module.exports = [
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		0,
		13,
		27,
		35,
		17,
		30,
		-1,
		86,
		38,
		28,
		28,
		54,
		52,
		64,
		75,
		-1,
		-1,
		-1,
		45,
		50,
		41,
		37,
		47,
		58,
		65,
		-1,
		116,
		-1,
		72,
		50,
		61,
		66,
		39,
		42,
		62,
		89,
		111,
		113,
		87,
		69,
		46,
		47,
		70,
		81,
		115,
		107,
		-1,
		53,
		50,
		72,
		85,
		100,
		103,
		-1,
		-1,
		54,
		64,
		70,
		85,
		104,
		107,
		-1,
		117,
		136,
		-1,
		-1,
		53,
		66,
		79,
		82,
		90,
		96,
		109,
		126,
		131,
		-1,
		-1,
		71,
		75,
		85,
		83,
		79,
		96,
		115,
		126,
		140,
		139,
		-1,
		65,
		83,
		92,
		90,
		88,
		72,
		76,
		94,
		125,
		131,
		134,
		-1,
		82,
		78,
		88,
		94,
		106,
		88,
		75,
		81,
		100,
		113,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		83,
		74,
		94,
		96,
		95,
		109,
		107,
		78,
		84,
		88,
		105,
		121,
		122,
		132,
		-1,
		-1,
		176,
		149,
		173,
		131,
		113,
		-1,
		79,
		81,
		87,
		91,
		96,
		104,
		109,
		94,
		-1,
		99,
		98,
		129,
		115,
		126,
		158,
		-1,
		-1,
		134,
		126,
		108,
		111,
		88,
		84,
		96,
		95,
		91,
		93,
		95,
		107,
		102,
		115,
		122,
		93,
		103,
		107,
		122,
		133,
		-1,
		-1,
		207,
		-1,
		-1,
		155,
		138,
		-1,
		103,
		110,
		94,
		100,
		86,
		107,
		106,
		100,
		107,
		110,
		98,
		115,
		112,
		129,
		115,
		90,
		115,
		119,
		125,
		143,
		144,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		110,
		107,
		100,
		124,
		123,
		-1,
		129,
		127,
		133,
		118,
		123,
		119,
		104,
		120,
		115,
		115,
		112,
		97,
		99,
		136,
		127,
		148,
		145,
		176,
		182,
		176,
		185,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		128,
		-1,
		131,
		144,
		141,
		129,
		132,
		119,
		127,
		126,
		110,
		126,
		113,
		110,
		109,
		105,
		114,
		124,
		123,
		141,
		154,
		169,
		173,
		179,
		-1,
		213,
		-1,
		155,
		139,
		141,
		117,
		145,
		-1,
		148,
		132,
		152,
		143,
		143,
		-1,
		135,
		132,
		142,
		125,
		110,
		125,
		113,
		108,
		108,
		112,
		127,
		118,
		136,
		143,
		151,
		155,
		175,
		187,
		173,
		163,
		-1,
		145,
		150,
		120,
		132,
		155,
		175,
		159,
		-1,
		154,
		-1,
		137,
		150,
		-1,
		131,
		127,
		116,
		121,
		110,
		117,
		115,
		109,
		106,
		124,
		127,
		144,
		148,
		164,
		-1,
		-1,
		158,
		162,
		170,
		121,
		140,
		164,
		201,
		168,
		161,
		160,
		-1,
		155,
		152,
		149,
		150,
		136,
		129,
		130,
		116,
		122,
		123,
		108,
		111,
		133,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		147,
		118,
		142,
		184,
		190,
		183,
		171,
		186,
		186,
		179,
		-1,
		167,
		146,
		143,
		133,
		123,
		139,
		129,
		132,
		112,
		114,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		121,
		155,
		173,
		219,
		205,
		210,
		185,
		178,
		172,
		161,
		163,
		151,
		140,
		132,
		121,
		130,
		140,
		134,
		114,
		123,
		124,
		148,
		155,
		161,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		146,
		153,
		185,
		210,
		223,
		-1,
		177,
		-1,
		166,
		161,
		145,
		140,
		137,
		134,
		128,
		137,
		142,
		128,
		119,
		134,
		153,
		153,
		145,
		170,
		173,
		-1,
		-1,
		-1,
		177,
		194,
		169,
		146,
		127,
		163,
		-1,
		193,
		194,
		-1,
		171,
		165,
		162,
		147,
		143,
		138,
		142,
		135,
		142,
		138,
		137,
		138,
		120,
		156,
		-1,
		153,
		147,
		175,
		178,
		168,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		134,
		186,
		-1,
		-1,
		178,
		171,
		-1,
		158,
		140,
		147,
		145,
		139,
		143,
		147,
		136,
		149,
		145,
		125,
		135,
		155,
		159,
		166,
		159,
		164,
		163,
		177,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		154,
		-1,
		187,
		179,
		169,
		163,
		157,
		153,
		151,
		167,
		151,
		154,
		154,
		150,
		158,
		143,
		142,
		128,
		132,
		150,
		177,
		172,
		167,
		166,
		173,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		169,
		-1,
		140,
		164,
		180,
		-1,
		195,
		174,
		189,
		167,
		163,
		159,
		174,
		175,
		153,
		158,
		157,
		167,
		164,
		153,
		140,
		144,
		159,
		169,
		161,
		162,
		171,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		143,
		156,
		167,
		-1,
		-1,
		231,
		-1,
		165,
		182,
		173,
		171,
		164,
		155,
		161,
		168,
		171,
		168,
		158,
		147,
		153,
		149,
		171,
		157,
		155,
		174,
		189,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		184,
		-1,
		209,
		199,
		183,
		168,
		201,
		-1,
		172,
		156,
		161,
		-1,
		193,
		-1,
		166,
		166,
		157,
		146,
		143,
		154,
		152,
		163,
		180,
		-1,
		196,
		181,
		174,
		164,
		178,
		149,
		-1,
		200,
		-1,
		-1,
		196,
		190,
		190,
		174,
		177,
		188,
		168,
		162,
		161,
		188,
		183,
		174,
		155,
		148,
		145,
		146,
		159,
		179,
		170,
		182,
		-1,
		-1,
		-1,
		201,
		181,
		187,
		145,
		166,
		-1,
		-1,
		258,
		213,
		199,
		-1,
		183,
		205,
		193,
		183,
		173,
		207,
		199,
		174,
		167,
		153,
		155,
		153,
		155,
		160,
		181,
		182,
		195,
		-1,
		-1,
		178,
		185,
		173,
		159,
		178,
		-1,
		-1,
		-1,
		205,
		221,
		213,
		184,
		194,
		-1,
		-1,
		185,
		183,
		191,
		170,
		157,
		177,
		180,
		170,
		154,
		169,
		181,
		189,
		194,
		-1,
		181,
		168,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		-1,
		-1,
		238,
		204,
		216,
		211,
		215,
		188,
		-1,
		187,
		181,
		161,
		175,
		182,
		172,
		167,
		161,
		164,
		182,
		199,
		-1,
		-1,
		195,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		195,
		209,
		204,
		197,
		201,
		-1,
		189,
		177,
		163,
		180,
		185,
		182,
		173,
		165,
		170,
		167,
		180,
		194,
		198,
		218,
		-1,
		201,
		-1,
		-1,
		-1,
		213,
		228,
		243,
		220,
		193,
		188,
		181,
		175,
		171,
		187,
		193,
		204,
		172,
		168,
		169,
		173,
		172,
		189,
		199,
		-1,
		-1,
		201,
		218,
		239,
		221,
		225,
		270,
		-1,
		-1,
		197,
		188,
		179,
		182,
		181,
		184,
		178,
		175,
		180,
		185,
		173,
		182,
		200,
		199,
		-1,
		-1,
		-1,
		221,
		-1,
		236,
		-1,
		-1,
		240,
		268,
		215,
		197,
		193,
		191,
		184,
		193,
		188,
		183,
		193,
		195,
		187,
		175,
		179,
		202,
		191,
		230,
		-1,
		-1,
		338,
		-1,
		-1,
		-1,
		250,
		225,
		240,
		279,
		260,
		267,
		230,
		227,
		-1,
		197,
		222,
		194,
		201,
		192,
		199,
		199,
		191,
		169,
		176,
		192,
		191,
		186,
		222,
		213,
		219,
		-1,
		-1,
		331,
		320,
		309,
		315,
		-1,
		256,
		242,
		265,
		255,
		258,
		-1,
		-1,
		246,
		243,
		219,
		202,
		200,
		193,
		188,
		198,
		178,
		165,
		169,
		173,
		179,
		184,
		189,
		195,
		210,
		225,
		-1,
		226,
		307,
		300,
		283,
		291,
		322,
		-1,
		259,
		261,
		249,
		247,
		249,
		-1,
		-1,
		219,
		216,
		221,
		209,
		206,
		208,
		203,
		194,
		179,
		185,
		172,
		171,
		189,
		193,
		202,
		209,
		199,
		212,
		216,
		-1,
		240,
		283,
		277,
		280,
		304,
		318,
		-1,
		266,
		-1,
		-1,
		257,
		250,
		234,
		224,
		218,
		268,
		223,
		218,
		202,
		200,
		191,
		182,
		189,
		180,
		180,
		183,
		198,
		203,
		195,
		209,
		209,
		210,
		-1,
		275,
		263,
		271,
		-1,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		273,
		-1,
		261,
		-1,
		236,
		240,
		231,
		234,
		216,
		203,
		195,
		187,
		203,
		178,
		188,
		184,
		185,
		194,
		205,
		217,
		216,
		217,
		337,
		293,
		271,
		262,
		309,
		324,
		328,
		-1,
		278,
		317,
		311,
		-1,
		282,
		-1,
		-1,
		-1,
		250,
		244,
		236,
		236,
		215,
		215,
		189,
		193,
		183,
		190,
		200,
		202,
		194,
		198,
		211,
		222,
		225,
		333,
		324,
		337,
		282,
		276,
		294,
		303,
		324,
		293,
		284,
		311,
		318,
		307,
		302,
		289,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		222,
		210,
		193,
		194,
		190,
		193,
		208,
		211,
		201,
		199,
		193,
		225,
		-1,
		326,
		325,
		314,
		311,
		287,
		278,
		273,
		295,
		-1,
		-1,
		295,
		312,
		306,
		310,
		326,
		351,
		-1,
		282,
		-1,
		-1,
		267,
		-1,
		-1,
		252,
		215,
		204,
		195,
		201,
		198,
		209,
		219,
		207,
		208,
		198,
		208,
		221,
		310,
		307,
		295,
		293,
		316,
		281,
		269,
		-1,
		282,
		280,
		286,
		293,
		310,
		340,
		-1,
		-1,
		298,
		278,
		-1,
		-1,
		250,
		248,
		237,
		-1,
		227,
		200,
		205,
		225,
		227,
		216,
		210,
		204,
		211,
		210,
		218,
		226,
		319,
		333,
		322,
		318,
		317,
		325,
		274,
		267,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		-1,
		288,
		284,
		-1,
		-1,
		245,
		238,
		226,
		214,
		204,
		214,
		218,
		222,
		214,
		207,
		202,
		213,
		205,
		209,
		226,
		-1,
		353,
		-1,
		305,
		281,
		295,
		310,
		318,
		-1,
		-1,
		-1,
		305,
		291,
		284,
		272,
		270,
		-1,
		279,
		263,
		244,
		-1,
		214,
		227,
		258,
		226,
		231,
		226,
		208,
		219,
		208,
		211,
		225,
		220,
		-1,
		-1,
		293,
		296,
		-1,
		-1,
		295,
		297,
		-1,
		296,
		285,
		270,
		262,
		-1,
		-1,
		251,
		247,
		-1,
		-1,
		215,
		240,
		229,
		237,
		232,
		212,
		218,
		221,
		210,
		214,
		226,
		-1,
		-1,
		300,
		301,
		302,
		-1,
		280,
		-1,
		298,
		-1,
		265,
		271,
		259,
		-1,
		-1,
		-1,
		253,
		216,
		237,
		247,
		241,
		239,
		230,
		216,
		223,
		221,
		217,
		228,
		-1,
		-1,
		-1,
		298,
		272,
		305,
		296,
		279,
		259,
		251,
		270,
		-1,
		240,
		-1,
		215,
		217,
		243,
		246,
		252,
		246,
		219,
		234,
		224,
		215,
		224,
		304,
		-1,
		274,
		307,
		271,
		265,
		241,
		245,
		261,
		-1,
		237,
		219,
		-1,
		247,
		237,
		268,
		253,
		234,
		221,
		228,
		228,
		221,
		-1,
		-1,
		-1,
		276,
		275,
		267,
		261,
		261,
		246,
		237,
		-1,
		249,
		231,
		210,
		227,
		227,
		218,
		226,
		258,
		254,
		241,
		241,
		233,
		-1,
		377,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		270,
		265,
		238,
		226,
		232,
		228,
		214,
		220,
		222,
		230,
		228,
		225,
		237,
		233,
		253,
		234,
		269,
		-1,
		372,
		-1,
		306,
		-1,
		-1,
		288,
		268,
		260,
		249,
		238,
		236,
		227,
		218,
		240,
		256,
		240,
		238,
		241,
		242,
		-1,
		361,
		360,
		-1,
		307,
		299,
		285,
		-1,
		278,
		-1,
		284,
		245,
		-1,
		247,
		227,
		-1,
		249,
		245,
		-1,
		-1,
		348,
		323,
		-1,
		-1,
		-1,
		308,
		288,
		279,
		263,
		-1,
		238,
		238,
		-1,
		-1,
		-1,
		333,
		332,
		-1,
		301,
		304,
		-1,
		294,
		285,
		293,
		240,
		244,
		-1,
		-1,
		-1,
		342,
		323,
		317,
		316,
		314,
		309,
		306,
		292,
		276,
		254,
		243,
		264,
		-1,
		-1,
		-1,
		314,
		306,
		299,
		-1,
		-1,
		301,
		284,
		265,
		263,
		-1,
		-1,
		-1,
		336,
		317,
		-1,
		-1,
		291,
		-1,
		-1,
		297,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		353,
		325,
		-1,
		-1,
		-1,
		287,
		283,
		284,
		-1,
		-1,
		-1,
		-1,
		347,
		348,
		371,
		335,
		-1,
		-1,
		-1,
		279,
		273,
		-1,
		-1,
		350,
		348,
		-1,
		-1,
		-1,
		307,
		291,
		-1,
		277,
		-1,
		-1,
		-1,
		298,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		312,
		-1,
		312,
		287,
		294,
		-1,
		-1,
		-1,
		-1,
		325,
		317,
		325,
		-1,
		297,
		299,
		-1,
		347,
		-1,
		-1,
		340,
		331,
		-1,
		-1,
		302,
		309,
		331,
		334,
		370,
		-1,
		321
	],
	[
		-1,
		11,
		0,
		16,
		36,
		4,
		17,
		-1,
		73,
		39,
		21,
		15,
		41,
		39,
		51,
		62,
		-1,
		-1,
		-1,
		44,
		43,
		28,
		24,
		34,
		45,
		52,
		-1,
		103,
		-1,
		65,
		44,
		55,
		60,
		26,
		29,
		49,
		76,
		98,
		100,
		80,
		56,
		33,
		34,
		57,
		68,
		102,
		94,
		-1,
		40,
		37,
		59,
		72,
		87,
		90,
		-1,
		-1,
		41,
		51,
		57,
		72,
		91,
		94,
		-1,
		104,
		123,
		-1,
		-1,
		40,
		53,
		66,
		69,
		77,
		83,
		96,
		113,
		118,
		-1,
		-1,
		58,
		62,
		72,
		70,
		66,
		83,
		102,
		113,
		127,
		126,
		-1,
		52,
		70,
		79,
		77,
		75,
		59,
		63,
		81,
		112,
		118,
		121,
		-1,
		69,
		65,
		75,
		81,
		93,
		75,
		62,
		68,
		87,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		70,
		61,
		81,
		83,
		82,
		96,
		94,
		65,
		71,
		75,
		92,
		108,
		109,
		119,
		-1,
		-1,
		163,
		136,
		160,
		118,
		100,
		-1,
		66,
		68,
		74,
		78,
		83,
		91,
		96,
		81,
		-1,
		86,
		85,
		116,
		102,
		113,
		145,
		-1,
		-1,
		121,
		113,
		95,
		98,
		75,
		71,
		83,
		82,
		78,
		80,
		82,
		94,
		89,
		102,
		109,
		80,
		90,
		94,
		109,
		120,
		-1,
		-1,
		194,
		-1,
		-1,
		142,
		125,
		-1,
		90,
		97,
		81,
		87,
		73,
		94,
		93,
		87,
		94,
		97,
		85,
		102,
		99,
		116,
		102,
		77,
		102,
		106,
		112,
		130,
		131,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		97,
		94,
		87,
		111,
		110,
		-1,
		116,
		114,
		120,
		105,
		110,
		106,
		91,
		107,
		102,
		102,
		99,
		84,
		86,
		123,
		114,
		135,
		132,
		163,
		169,
		163,
		172,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		115,
		-1,
		118,
		131,
		128,
		116,
		119,
		106,
		114,
		113,
		97,
		113,
		100,
		97,
		96,
		92,
		101,
		111,
		110,
		128,
		141,
		156,
		160,
		166,
		-1,
		200,
		-1,
		142,
		126,
		128,
		104,
		132,
		-1,
		135,
		119,
		139,
		130,
		130,
		-1,
		122,
		119,
		129,
		112,
		97,
		112,
		100,
		95,
		95,
		99,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		160,
		150,
		-1,
		132,
		137,
		107,
		119,
		142,
		162,
		146,
		-1,
		141,
		-1,
		124,
		137,
		-1,
		118,
		114,
		103,
		108,
		97,
		104,
		102,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		145,
		149,
		157,
		108,
		127,
		151,
		188,
		155,
		148,
		147,
		-1,
		142,
		139,
		136,
		137,
		123,
		116,
		117,
		103,
		109,
		110,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		134,
		105,
		129,
		171,
		177,
		170,
		158,
		173,
		173,
		166,
		-1,
		154,
		133,
		130,
		120,
		110,
		126,
		116,
		119,
		99,
		101,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		108,
		142,
		160,
		206,
		192,
		197,
		172,
		165,
		159,
		148,
		150,
		138,
		127,
		119,
		108,
		117,
		127,
		121,
		101,
		110,
		111,
		135,
		142,
		148,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		133,
		140,
		172,
		197,
		210,
		-1,
		164,
		-1,
		153,
		148,
		132,
		127,
		124,
		121,
		115,
		124,
		129,
		115,
		106,
		121,
		140,
		140,
		132,
		157,
		160,
		-1,
		-1,
		-1,
		164,
		181,
		156,
		133,
		114,
		150,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		134,
		130,
		125,
		129,
		122,
		129,
		125,
		124,
		125,
		107,
		143,
		-1,
		140,
		134,
		162,
		165,
		155,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		121,
		173,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		134,
		132,
		126,
		130,
		134,
		123,
		136,
		132,
		112,
		122,
		142,
		146,
		153,
		146,
		151,
		150,
		164,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		141,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		154,
		138,
		141,
		141,
		137,
		145,
		130,
		129,
		115,
		119,
		137,
		164,
		159,
		154,
		153,
		160,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		156,
		-1,
		127,
		151,
		167,
		-1,
		182,
		161,
		176,
		154,
		150,
		146,
		161,
		162,
		140,
		145,
		144,
		154,
		151,
		140,
		127,
		131,
		146,
		156,
		148,
		149,
		158,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		130,
		143,
		154,
		-1,
		-1,
		218,
		-1,
		152,
		169,
		160,
		158,
		151,
		142,
		148,
		155,
		158,
		155,
		145,
		134,
		140,
		136,
		158,
		144,
		142,
		161,
		176,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		196,
		186,
		170,
		155,
		188,
		-1,
		159,
		143,
		148,
		-1,
		180,
		-1,
		153,
		153,
		144,
		133,
		130,
		141,
		139,
		150,
		167,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		187,
		-1,
		-1,
		183,
		177,
		177,
		161,
		164,
		175,
		155,
		149,
		148,
		175,
		170,
		161,
		142,
		135,
		132,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		188,
		168,
		174,
		132,
		153,
		-1,
		-1,
		245,
		200,
		186,
		-1,
		170,
		192,
		180,
		170,
		160,
		194,
		186,
		161,
		154,
		140,
		142,
		140,
		142,
		147,
		168,
		169,
		182,
		-1,
		-1,
		165,
		172,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		192,
		208,
		200,
		171,
		181,
		-1,
		-1,
		172,
		170,
		178,
		157,
		144,
		164,
		167,
		157,
		141,
		156,
		168,
		176,
		181,
		-1,
		168,
		155,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		203,
		198,
		202,
		175,
		-1,
		174,
		168,
		148,
		162,
		169,
		159,
		154,
		148,
		151,
		169,
		186,
		-1,
		-1,
		182,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		182,
		196,
		191,
		184,
		188,
		-1,
		176,
		164,
		150,
		167,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		205,
		-1,
		188,
		-1,
		-1,
		-1,
		200,
		215,
		230,
		207,
		180,
		175,
		168,
		162,
		158,
		174,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		188,
		205,
		226,
		208,
		212,
		257,
		-1,
		-1,
		184,
		175,
		166,
		169,
		168,
		171,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		186,
		-1,
		-1,
		-1,
		208,
		-1,
		223,
		-1,
		-1,
		227,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		182,
		174,
		162,
		166,
		189,
		178,
		217,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		237,
		212,
		227,
		266,
		247,
		254,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		179,
		186,
		186,
		178,
		156,
		163,
		179,
		178,
		173,
		209,
		200,
		206,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		243,
		229,
		252,
		242,
		245,
		-1,
		-1,
		233,
		230,
		206,
		189,
		187,
		180,
		175,
		185,
		165,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		213,
		294,
		287,
		270,
		278,
		309,
		-1,
		246,
		248,
		236,
		234,
		236,
		-1,
		-1,
		206,
		203,
		208,
		196,
		193,
		195,
		190,
		181,
		166,
		172,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		227,
		270,
		264,
		267,
		291,
		305,
		-1,
		253,
		-1,
		-1,
		244,
		237,
		221,
		211,
		205,
		255,
		210,
		205,
		189,
		187,
		178,
		169,
		176,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		262,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		260,
		-1,
		248,
		-1,
		223,
		227,
		218,
		221,
		203,
		190,
		182,
		174,
		190,
		165,
		175,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		324,
		280,
		258,
		249,
		296,
		311,
		315,
		-1,
		265,
		304,
		298,
		-1,
		269,
		-1,
		-1,
		-1,
		237,
		231,
		223,
		223,
		202,
		202,
		176,
		180,
		170,
		177,
		187,
		189,
		181,
		185,
		198,
		209,
		212,
		320,
		311,
		324,
		269,
		263,
		281,
		290,
		311,
		280,
		271,
		298,
		305,
		294,
		289,
		276,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		209,
		197,
		180,
		181,
		177,
		180,
		195,
		198,
		188,
		186,
		180,
		212,
		-1,
		313,
		312,
		301,
		298,
		274,
		265,
		260,
		282,
		-1,
		-1,
		282,
		299,
		293,
		297,
		313,
		338,
		-1,
		269,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		202,
		191,
		182,
		188,
		185,
		196,
		206,
		194,
		195,
		185,
		195,
		208,
		297,
		294,
		282,
		280,
		303,
		268,
		256,
		-1,
		269,
		267,
		273,
		280,
		297,
		327,
		-1,
		-1,
		285,
		265,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		187,
		192,
		212,
		214,
		203,
		197,
		191,
		198,
		197,
		205,
		213,
		306,
		320,
		309,
		305,
		304,
		312,
		261,
		254,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		-1,
		275,
		271,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		205,
		209,
		201,
		194,
		189,
		200,
		192,
		196,
		213,
		-1,
		340,
		-1,
		292,
		268,
		282,
		297,
		305,
		-1,
		-1,
		-1,
		292,
		278,
		271,
		259,
		257,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		245,
		213,
		218,
		213,
		195,
		206,
		195,
		198,
		212,
		207,
		-1,
		-1,
		280,
		283,
		-1,
		-1,
		282,
		284,
		-1,
		283,
		272,
		257,
		249,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		202,
		227,
		216,
		224,
		219,
		199,
		205,
		208,
		197,
		201,
		213,
		-1,
		-1,
		287,
		288,
		289,
		-1,
		267,
		-1,
		285,
		-1,
		252,
		258,
		246,
		-1,
		-1,
		-1,
		240,
		203,
		224,
		234,
		228,
		226,
		217,
		203,
		210,
		208,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		259,
		292,
		283,
		266,
		246,
		238,
		257,
		-1,
		227,
		-1,
		202,
		204,
		230,
		233,
		239,
		233,
		206,
		221,
		211,
		202,
		211,
		291,
		-1,
		261,
		294,
		258,
		252,
		228,
		232,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		255,
		240,
		221,
		208,
		215,
		215,
		208,
		-1,
		-1,
		-1,
		263,
		262,
		254,
		248,
		248,
		233,
		224,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		245,
		241,
		228,
		228,
		220,
		-1,
		364,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		257,
		252,
		225,
		213,
		219,
		215,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		221,
		256,
		-1,
		359,
		-1,
		293,
		-1,
		-1,
		275,
		255,
		247,
		236,
		225,
		223,
		214,
		205,
		227,
		243,
		227,
		225,
		228,
		229,
		-1,
		348,
		347,
		-1,
		294,
		286,
		272,
		-1,
		265,
		-1,
		271,
		232,
		-1,
		234,
		214,
		-1,
		236,
		232,
		-1,
		-1,
		335,
		310,
		-1,
		-1,
		-1,
		295,
		275,
		266,
		250,
		-1,
		225,
		225,
		-1,
		-1,
		-1,
		320,
		319,
		-1,
		288,
		291,
		-1,
		281,
		272,
		280,
		227,
		231,
		-1,
		-1,
		-1,
		329,
		310,
		304,
		303,
		301,
		296,
		293,
		279,
		263,
		241,
		230,
		251,
		-1,
		-1,
		-1,
		301,
		293,
		286,
		-1,
		-1,
		288,
		271,
		252,
		250,
		-1,
		-1,
		-1,
		323,
		304,
		-1,
		-1,
		278,
		-1,
		-1,
		284,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		312,
		-1,
		-1,
		-1,
		274,
		270,
		271,
		-1,
		-1,
		-1,
		-1,
		334,
		335,
		358,
		322,
		-1,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		337,
		335,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		264,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		299,
		-1,
		299,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		312,
		-1,
		284,
		286,
		-1,
		334,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		289,
		296,
		318,
		321,
		357,
		-1,
		308
	],
	[
		-1,
		26,
		17,
		0,
		51,
		18,
		30,
		-1,
		87,
		54,
		35,
		29,
		55,
		53,
		65,
		76,
		-1,
		-1,
		-1,
		58,
		57,
		42,
		38,
		48,
		59,
		66,
		-1,
		117,
		-1,
		79,
		58,
		69,
		74,
		40,
		43,
		63,
		90,
		112,
		114,
		94,
		70,
		47,
		48,
		71,
		82,
		116,
		108,
		-1,
		54,
		51,
		73,
		86,
		101,
		104,
		-1,
		-1,
		55,
		65,
		71,
		86,
		105,
		108,
		-1,
		118,
		137,
		-1,
		-1,
		54,
		67,
		80,
		83,
		91,
		97,
		110,
		127,
		132,
		-1,
		-1,
		72,
		76,
		86,
		84,
		80,
		97,
		116,
		127,
		141,
		140,
		-1,
		66,
		84,
		93,
		91,
		89,
		73,
		77,
		95,
		126,
		132,
		135,
		-1,
		83,
		79,
		89,
		95,
		107,
		89,
		76,
		82,
		101,
		114,
		133,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		84,
		75,
		95,
		97,
		96,
		110,
		108,
		79,
		85,
		89,
		106,
		122,
		123,
		133,
		-1,
		-1,
		177,
		150,
		174,
		132,
		114,
		-1,
		80,
		82,
		88,
		92,
		97,
		105,
		110,
		95,
		-1,
		100,
		99,
		130,
		116,
		127,
		159,
		-1,
		-1,
		135,
		127,
		109,
		112,
		89,
		85,
		97,
		96,
		92,
		94,
		96,
		108,
		103,
		116,
		123,
		94,
		104,
		108,
		123,
		134,
		-1,
		-1,
		208,
		-1,
		-1,
		156,
		139,
		-1,
		104,
		111,
		95,
		101,
		87,
		108,
		107,
		101,
		108,
		111,
		99,
		116,
		113,
		130,
		116,
		91,
		116,
		120,
		126,
		144,
		145,
		-1,
		207,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		111,
		108,
		101,
		125,
		124,
		-1,
		130,
		128,
		134,
		119,
		124,
		120,
		105,
		121,
		116,
		116,
		113,
		98,
		100,
		137,
		128,
		149,
		146,
		177,
		183,
		177,
		186,
		-1,
		164,
		160,
		156,
		163,
		112,
		-1,
		-1,
		129,
		-1,
		132,
		145,
		142,
		130,
		133,
		120,
		128,
		127,
		111,
		127,
		114,
		111,
		110,
		106,
		115,
		125,
		124,
		142,
		155,
		170,
		174,
		180,
		-1,
		214,
		-1,
		156,
		140,
		142,
		118,
		146,
		-1,
		149,
		133,
		153,
		144,
		144,
		-1,
		136,
		133,
		143,
		126,
		111,
		126,
		114,
		109,
		109,
		113,
		128,
		119,
		137,
		144,
		152,
		156,
		176,
		188,
		174,
		164,
		-1,
		146,
		151,
		121,
		133,
		156,
		176,
		160,
		-1,
		155,
		-1,
		138,
		151,
		-1,
		132,
		128,
		117,
		122,
		111,
		118,
		116,
		110,
		107,
		125,
		128,
		145,
		149,
		165,
		-1,
		-1,
		159,
		163,
		171,
		122,
		141,
		165,
		202,
		169,
		162,
		161,
		-1,
		156,
		153,
		150,
		151,
		137,
		130,
		131,
		117,
		123,
		124,
		109,
		112,
		134,
		162,
		140,
		152,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		148,
		119,
		143,
		185,
		191,
		184,
		172,
		187,
		187,
		180,
		-1,
		168,
		147,
		144,
		134,
		124,
		140,
		130,
		133,
		113,
		115,
		131,
		143,
		134,
		154,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		122,
		156,
		174,
		220,
		206,
		211,
		186,
		179,
		173,
		162,
		164,
		152,
		141,
		133,
		122,
		131,
		141,
		135,
		115,
		124,
		125,
		149,
		156,
		162,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		147,
		154,
		186,
		211,
		224,
		-1,
		178,
		-1,
		167,
		162,
		146,
		141,
		138,
		135,
		129,
		138,
		143,
		129,
		120,
		135,
		154,
		154,
		146,
		171,
		174,
		-1,
		-1,
		-1,
		178,
		195,
		170,
		147,
		128,
		164,
		-1,
		194,
		195,
		-1,
		172,
		166,
		163,
		148,
		144,
		139,
		143,
		136,
		143,
		139,
		138,
		139,
		121,
		157,
		-1,
		154,
		148,
		176,
		179,
		169,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		135,
		187,
		-1,
		-1,
		179,
		172,
		-1,
		159,
		141,
		148,
		146,
		140,
		144,
		148,
		137,
		150,
		146,
		126,
		136,
		156,
		160,
		167,
		160,
		165,
		164,
		178,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		155,
		-1,
		188,
		180,
		170,
		164,
		158,
		154,
		152,
		168,
		152,
		155,
		155,
		151,
		159,
		144,
		143,
		129,
		133,
		151,
		178,
		173,
		168,
		167,
		174,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		170,
		-1,
		141,
		165,
		181,
		-1,
		196,
		175,
		190,
		168,
		164,
		160,
		175,
		176,
		154,
		159,
		158,
		168,
		165,
		154,
		141,
		145,
		160,
		170,
		162,
		163,
		172,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		144,
		157,
		168,
		-1,
		-1,
		232,
		-1,
		166,
		183,
		174,
		172,
		165,
		156,
		162,
		169,
		172,
		169,
		159,
		148,
		154,
		150,
		172,
		158,
		156,
		175,
		190,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		210,
		200,
		184,
		169,
		202,
		-1,
		173,
		157,
		162,
		-1,
		194,
		-1,
		167,
		167,
		158,
		147,
		144,
		155,
		153,
		164,
		181,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		201,
		-1,
		-1,
		197,
		191,
		191,
		175,
		178,
		189,
		169,
		163,
		162,
		189,
		184,
		175,
		156,
		149,
		146,
		147,
		160,
		180,
		171,
		183,
		-1,
		-1,
		-1,
		202,
		182,
		188,
		146,
		167,
		-1,
		-1,
		259,
		214,
		200,
		-1,
		184,
		206,
		194,
		184,
		174,
		208,
		200,
		175,
		168,
		154,
		156,
		154,
		156,
		161,
		182,
		183,
		196,
		-1,
		-1,
		179,
		186,
		174,
		160,
		179,
		-1,
		-1,
		-1,
		206,
		222,
		214,
		185,
		195,
		-1,
		-1,
		186,
		184,
		192,
		171,
		158,
		178,
		181,
		171,
		155,
		170,
		182,
		190,
		195,
		-1,
		182,
		169,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		-1,
		-1,
		239,
		205,
		217,
		212,
		216,
		189,
		-1,
		188,
		182,
		162,
		176,
		183,
		173,
		168,
		162,
		165,
		183,
		200,
		-1,
		-1,
		196,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		196,
		210,
		205,
		198,
		202,
		-1,
		190,
		178,
		164,
		181,
		186,
		183,
		174,
		166,
		171,
		168,
		181,
		195,
		199,
		219,
		-1,
		202,
		-1,
		-1,
		-1,
		214,
		229,
		244,
		221,
		194,
		189,
		182,
		176,
		172,
		188,
		194,
		205,
		173,
		169,
		170,
		174,
		173,
		190,
		200,
		-1,
		-1,
		202,
		219,
		240,
		222,
		226,
		271,
		-1,
		-1,
		198,
		189,
		180,
		183,
		182,
		185,
		179,
		176,
		181,
		186,
		174,
		183,
		201,
		200,
		-1,
		-1,
		-1,
		222,
		-1,
		237,
		-1,
		-1,
		241,
		269,
		216,
		198,
		194,
		192,
		185,
		194,
		189,
		184,
		194,
		196,
		188,
		176,
		180,
		203,
		192,
		231,
		-1,
		-1,
		339,
		-1,
		-1,
		-1,
		251,
		226,
		241,
		280,
		261,
		268,
		231,
		228,
		-1,
		198,
		223,
		195,
		202,
		193,
		200,
		200,
		192,
		170,
		177,
		193,
		192,
		187,
		223,
		214,
		220,
		-1,
		-1,
		332,
		321,
		310,
		316,
		-1,
		257,
		243,
		266,
		256,
		259,
		-1,
		-1,
		247,
		244,
		220,
		203,
		201,
		194,
		189,
		199,
		179,
		166,
		170,
		174,
		180,
		185,
		190,
		196,
		211,
		226,
		-1,
		227,
		308,
		301,
		284,
		292,
		323,
		-1,
		260,
		262,
		250,
		248,
		250,
		-1,
		-1,
		220,
		217,
		222,
		210,
		207,
		209,
		204,
		195,
		180,
		186,
		173,
		172,
		190,
		194,
		203,
		210,
		200,
		213,
		217,
		-1,
		241,
		284,
		278,
		281,
		305,
		319,
		-1,
		267,
		-1,
		-1,
		258,
		251,
		235,
		225,
		219,
		269,
		224,
		219,
		203,
		201,
		192,
		183,
		190,
		181,
		181,
		184,
		199,
		204,
		196,
		210,
		210,
		211,
		-1,
		276,
		264,
		272,
		-1,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		274,
		-1,
		262,
		-1,
		237,
		241,
		232,
		235,
		217,
		204,
		196,
		188,
		204,
		179,
		189,
		185,
		186,
		195,
		206,
		218,
		217,
		218,
		338,
		294,
		272,
		263,
		310,
		325,
		329,
		-1,
		279,
		318,
		312,
		-1,
		283,
		-1,
		-1,
		-1,
		251,
		245,
		237,
		237,
		216,
		216,
		190,
		194,
		184,
		191,
		201,
		203,
		195,
		199,
		212,
		223,
		226,
		334,
		325,
		338,
		283,
		277,
		295,
		304,
		325,
		294,
		285,
		312,
		319,
		308,
		303,
		290,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		223,
		211,
		194,
		195,
		191,
		194,
		209,
		212,
		202,
		200,
		194,
		226,
		-1,
		327,
		326,
		315,
		312,
		288,
		279,
		274,
		296,
		-1,
		-1,
		296,
		313,
		307,
		311,
		327,
		352,
		-1,
		283,
		-1,
		-1,
		268,
		-1,
		-1,
		253,
		216,
		205,
		196,
		202,
		199,
		210,
		220,
		208,
		209,
		199,
		209,
		222,
		311,
		308,
		296,
		294,
		317,
		282,
		270,
		-1,
		283,
		281,
		287,
		294,
		311,
		341,
		-1,
		-1,
		299,
		279,
		-1,
		-1,
		251,
		249,
		238,
		-1,
		228,
		201,
		206,
		226,
		228,
		217,
		211,
		205,
		212,
		211,
		219,
		227,
		320,
		334,
		323,
		319,
		318,
		326,
		275,
		268,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		-1,
		289,
		285,
		-1,
		-1,
		246,
		239,
		227,
		215,
		205,
		215,
		219,
		223,
		215,
		208,
		203,
		214,
		206,
		210,
		227,
		-1,
		354,
		-1,
		306,
		282,
		296,
		311,
		319,
		-1,
		-1,
		-1,
		306,
		292,
		285,
		273,
		271,
		-1,
		280,
		264,
		245,
		-1,
		215,
		228,
		259,
		227,
		232,
		227,
		209,
		220,
		209,
		212,
		226,
		221,
		-1,
		-1,
		294,
		297,
		-1,
		-1,
		296,
		298,
		-1,
		297,
		286,
		271,
		263,
		-1,
		-1,
		252,
		248,
		-1,
		-1,
		216,
		241,
		230,
		238,
		233,
		213,
		219,
		222,
		211,
		215,
		227,
		-1,
		-1,
		301,
		302,
		303,
		-1,
		281,
		-1,
		299,
		-1,
		266,
		272,
		260,
		-1,
		-1,
		-1,
		254,
		217,
		238,
		248,
		242,
		240,
		231,
		217,
		224,
		222,
		218,
		229,
		-1,
		-1,
		-1,
		299,
		273,
		306,
		297,
		280,
		260,
		252,
		271,
		-1,
		241,
		-1,
		216,
		218,
		244,
		247,
		253,
		247,
		220,
		235,
		225,
		216,
		225,
		305,
		-1,
		275,
		308,
		272,
		266,
		242,
		246,
		262,
		-1,
		238,
		220,
		-1,
		248,
		238,
		269,
		254,
		235,
		222,
		229,
		229,
		222,
		-1,
		-1,
		-1,
		277,
		276,
		268,
		262,
		262,
		247,
		238,
		-1,
		250,
		232,
		211,
		228,
		228,
		219,
		227,
		259,
		255,
		242,
		242,
		234,
		-1,
		378,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		271,
		266,
		239,
		227,
		233,
		229,
		215,
		221,
		223,
		231,
		229,
		226,
		238,
		234,
		254,
		235,
		270,
		-1,
		373,
		-1,
		307,
		-1,
		-1,
		289,
		269,
		261,
		250,
		239,
		237,
		228,
		219,
		241,
		257,
		241,
		239,
		242,
		243,
		-1,
		362,
		361,
		-1,
		308,
		300,
		286,
		-1,
		279,
		-1,
		285,
		246,
		-1,
		248,
		228,
		-1,
		250,
		246,
		-1,
		-1,
		349,
		324,
		-1,
		-1,
		-1,
		309,
		289,
		280,
		264,
		-1,
		239,
		239,
		-1,
		-1,
		-1,
		334,
		333,
		-1,
		302,
		305,
		-1,
		295,
		286,
		294,
		241,
		245,
		-1,
		-1,
		-1,
		343,
		324,
		318,
		317,
		315,
		310,
		307,
		293,
		277,
		255,
		244,
		265,
		-1,
		-1,
		-1,
		315,
		307,
		300,
		-1,
		-1,
		302,
		285,
		266,
		264,
		-1,
		-1,
		-1,
		337,
		318,
		-1,
		-1,
		292,
		-1,
		-1,
		298,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		354,
		326,
		-1,
		-1,
		-1,
		288,
		284,
		285,
		-1,
		-1,
		-1,
		-1,
		348,
		349,
		372,
		336,
		-1,
		-1,
		-1,
		280,
		274,
		-1,
		-1,
		351,
		349,
		-1,
		-1,
		-1,
		308,
		292,
		-1,
		278,
		-1,
		-1,
		-1,
		299,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		313,
		-1,
		313,
		288,
		295,
		-1,
		-1,
		-1,
		-1,
		326,
		318,
		326,
		-1,
		298,
		300,
		-1,
		348,
		-1,
		-1,
		341,
		332,
		-1,
		-1,
		303,
		310,
		332,
		335,
		371,
		-1,
		322
	],
	[
		-1,
		33,
		36,
		50,
		0,
		34,
		46,
		-1,
		95,
		9,
		31,
		37,
		66,
		61,
		73,
		84,
		-1,
		-1,
		-1,
		36,
		43,
		50,
		46,
		56,
		67,
		74,
		-1,
		125,
		-1,
		65,
		53,
		64,
		69,
		48,
		51,
		71,
		98,
		120,
		122,
		80,
		78,
		55,
		56,
		79,
		90,
		124,
		116,
		-1,
		62,
		59,
		81,
		94,
		109,
		112,
		-1,
		-1,
		63,
		73,
		79,
		94,
		113,
		116,
		-1,
		126,
		145,
		-1,
		-1,
		62,
		75,
		88,
		91,
		99,
		105,
		118,
		135,
		140,
		-1,
		-1,
		80,
		84,
		94,
		92,
		88,
		105,
		124,
		135,
		149,
		148,
		-1,
		74,
		92,
		101,
		99,
		97,
		81,
		85,
		103,
		134,
		140,
		143,
		-1,
		91,
		87,
		97,
		103,
		115,
		97,
		84,
		90,
		109,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		83,
		103,
		105,
		104,
		118,
		116,
		87,
		93,
		97,
		114,
		130,
		131,
		141,
		-1,
		-1,
		185,
		158,
		182,
		140,
		122,
		-1,
		88,
		90,
		96,
		100,
		105,
		113,
		118,
		103,
		-1,
		108,
		107,
		138,
		124,
		135,
		167,
		-1,
		-1,
		143,
		135,
		117,
		120,
		97,
		93,
		105,
		104,
		100,
		102,
		104,
		116,
		111,
		124,
		131,
		102,
		112,
		116,
		131,
		142,
		-1,
		-1,
		216,
		-1,
		-1,
		164,
		147,
		-1,
		112,
		119,
		103,
		109,
		95,
		116,
		115,
		109,
		116,
		119,
		107,
		124,
		121,
		138,
		124,
		99,
		124,
		128,
		134,
		152,
		153,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		119,
		116,
		109,
		133,
		132,
		-1,
		138,
		136,
		142,
		127,
		132,
		128,
		113,
		129,
		124,
		124,
		121,
		106,
		108,
		145,
		136,
		157,
		154,
		185,
		191,
		185,
		194,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		137,
		-1,
		140,
		153,
		150,
		138,
		141,
		128,
		136,
		135,
		119,
		135,
		122,
		119,
		118,
		114,
		123,
		133,
		132,
		150,
		163,
		178,
		182,
		188,
		-1,
		222,
		-1,
		164,
		148,
		150,
		126,
		154,
		-1,
		157,
		141,
		161,
		152,
		152,
		-1,
		144,
		141,
		151,
		134,
		119,
		134,
		122,
		117,
		117,
		121,
		136,
		127,
		145,
		152,
		160,
		164,
		184,
		196,
		182,
		172,
		-1,
		154,
		159,
		129,
		141,
		164,
		184,
		168,
		-1,
		163,
		-1,
		146,
		159,
		-1,
		140,
		136,
		125,
		130,
		119,
		126,
		124,
		118,
		115,
		133,
		136,
		153,
		157,
		173,
		-1,
		-1,
		167,
		171,
		179,
		130,
		149,
		173,
		210,
		177,
		170,
		169,
		-1,
		164,
		161,
		158,
		159,
		145,
		138,
		139,
		125,
		131,
		132,
		117,
		120,
		142,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		156,
		127,
		151,
		193,
		199,
		192,
		180,
		195,
		195,
		188,
		-1,
		176,
		155,
		152,
		142,
		132,
		148,
		138,
		141,
		121,
		123,
		139,
		151,
		142,
		162,
		-1,
		-1,
		-1,
		186,
		175,
		176,
		130,
		164,
		182,
		228,
		214,
		219,
		194,
		187,
		181,
		170,
		172,
		160,
		149,
		141,
		130,
		139,
		149,
		143,
		123,
		132,
		133,
		157,
		164,
		170,
		-1,
		-1,
		193,
		183,
		167,
		169,
		166,
		155,
		162,
		194,
		219,
		232,
		-1,
		186,
		-1,
		175,
		170,
		154,
		149,
		146,
		143,
		137,
		146,
		151,
		137,
		128,
		143,
		162,
		162,
		154,
		179,
		182,
		-1,
		-1,
		-1,
		186,
		203,
		178,
		155,
		136,
		172,
		-1,
		202,
		203,
		-1,
		180,
		174,
		171,
		156,
		152,
		147,
		151,
		144,
		151,
		147,
		146,
		147,
		129,
		165,
		-1,
		162,
		156,
		184,
		187,
		177,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		143,
		195,
		-1,
		-1,
		187,
		180,
		-1,
		167,
		149,
		156,
		154,
		148,
		152,
		156,
		145,
		158,
		154,
		134,
		144,
		164,
		168,
		175,
		168,
		173,
		172,
		186,
		-1,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		163,
		-1,
		196,
		188,
		178,
		172,
		166,
		162,
		160,
		176,
		160,
		163,
		163,
		159,
		167,
		152,
		151,
		137,
		141,
		159,
		186,
		181,
		176,
		175,
		182,
		-1,
		249,
		235,
		206,
		-1,
		-1,
		178,
		-1,
		149,
		173,
		189,
		-1,
		204,
		183,
		198,
		176,
		172,
		168,
		183,
		184,
		162,
		167,
		166,
		176,
		173,
		162,
		149,
		153,
		168,
		178,
		170,
		171,
		180,
		-1,
		255,
		242,
		200,
		196,
		185,
		205,
		152,
		165,
		176,
		-1,
		-1,
		240,
		-1,
		174,
		191,
		182,
		180,
		173,
		164,
		170,
		177,
		180,
		177,
		167,
		156,
		162,
		158,
		180,
		166,
		164,
		183,
		198,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		171,
		158,
		152,
		-1,
		193,
		-1,
		218,
		208,
		192,
		177,
		210,
		-1,
		181,
		165,
		170,
		-1,
		202,
		-1,
		175,
		175,
		166,
		155,
		152,
		163,
		161,
		172,
		189,
		-1,
		205,
		190,
		183,
		173,
		187,
		158,
		-1,
		209,
		-1,
		-1,
		205,
		199,
		199,
		183,
		186,
		197,
		177,
		171,
		170,
		197,
		192,
		183,
		164,
		157,
		154,
		155,
		168,
		188,
		179,
		191,
		-1,
		-1,
		-1,
		210,
		190,
		196,
		154,
		175,
		-1,
		-1,
		267,
		222,
		208,
		-1,
		192,
		214,
		202,
		192,
		182,
		216,
		208,
		183,
		176,
		162,
		164,
		162,
		164,
		169,
		190,
		191,
		204,
		-1,
		-1,
		187,
		194,
		182,
		168,
		187,
		-1,
		-1,
		-1,
		214,
		230,
		222,
		193,
		203,
		-1,
		-1,
		194,
		192,
		200,
		179,
		166,
		186,
		189,
		179,
		163,
		178,
		190,
		198,
		203,
		-1,
		190,
		177,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		213,
		225,
		220,
		224,
		197,
		-1,
		196,
		190,
		170,
		184,
		191,
		181,
		176,
		170,
		173,
		191,
		208,
		-1,
		-1,
		204,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		204,
		218,
		213,
		206,
		210,
		-1,
		198,
		186,
		172,
		189,
		194,
		191,
		182,
		174,
		179,
		176,
		189,
		203,
		207,
		227,
		-1,
		210,
		-1,
		-1,
		-1,
		222,
		237,
		252,
		229,
		202,
		197,
		190,
		184,
		180,
		196,
		202,
		213,
		181,
		177,
		178,
		182,
		181,
		198,
		208,
		-1,
		-1,
		210,
		227,
		248,
		230,
		234,
		279,
		-1,
		-1,
		206,
		197,
		188,
		191,
		190,
		193,
		187,
		184,
		189,
		194,
		182,
		191,
		209,
		208,
		-1,
		-1,
		-1,
		230,
		-1,
		245,
		-1,
		-1,
		249,
		277,
		224,
		206,
		202,
		200,
		193,
		202,
		197,
		192,
		202,
		204,
		196,
		184,
		188,
		211,
		200,
		239,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		259,
		234,
		249,
		288,
		269,
		276,
		239,
		236,
		-1,
		206,
		231,
		203,
		210,
		201,
		208,
		208,
		200,
		178,
		185,
		201,
		200,
		195,
		231,
		222,
		228,
		-1,
		-1,
		340,
		329,
		318,
		324,
		-1,
		265,
		251,
		274,
		264,
		267,
		-1,
		-1,
		255,
		252,
		228,
		211,
		209,
		202,
		197,
		207,
		187,
		174,
		178,
		182,
		188,
		193,
		198,
		204,
		219,
		234,
		-1,
		235,
		316,
		309,
		292,
		300,
		331,
		-1,
		268,
		270,
		258,
		256,
		258,
		-1,
		-1,
		228,
		225,
		230,
		218,
		215,
		217,
		212,
		203,
		188,
		194,
		181,
		180,
		198,
		202,
		211,
		218,
		208,
		221,
		225,
		-1,
		249,
		292,
		286,
		289,
		313,
		327,
		-1,
		275,
		-1,
		-1,
		266,
		259,
		243,
		233,
		227,
		277,
		232,
		227,
		211,
		209,
		200,
		191,
		198,
		189,
		189,
		192,
		207,
		212,
		204,
		218,
		218,
		219,
		-1,
		284,
		272,
		280,
		-1,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		282,
		-1,
		270,
		-1,
		245,
		249,
		240,
		243,
		225,
		212,
		204,
		196,
		212,
		187,
		197,
		193,
		194,
		203,
		214,
		226,
		225,
		226,
		346,
		302,
		280,
		271,
		318,
		333,
		337,
		-1,
		287,
		326,
		320,
		-1,
		291,
		-1,
		-1,
		-1,
		259,
		253,
		245,
		245,
		224,
		224,
		198,
		202,
		192,
		199,
		209,
		211,
		203,
		207,
		220,
		231,
		234,
		342,
		333,
		346,
		291,
		285,
		303,
		312,
		333,
		302,
		293,
		320,
		327,
		316,
		311,
		298,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		231,
		219,
		202,
		203,
		199,
		202,
		217,
		220,
		210,
		208,
		202,
		234,
		-1,
		335,
		334,
		323,
		320,
		296,
		287,
		282,
		304,
		-1,
		-1,
		304,
		321,
		315,
		319,
		335,
		360,
		-1,
		291,
		-1,
		-1,
		276,
		-1,
		-1,
		261,
		224,
		213,
		204,
		210,
		207,
		218,
		228,
		216,
		217,
		207,
		217,
		230,
		319,
		316,
		304,
		302,
		325,
		290,
		278,
		-1,
		291,
		289,
		295,
		302,
		319,
		349,
		-1,
		-1,
		307,
		287,
		-1,
		-1,
		259,
		257,
		246,
		-1,
		236,
		209,
		214,
		234,
		236,
		225,
		219,
		213,
		220,
		219,
		227,
		235,
		328,
		342,
		331,
		327,
		326,
		334,
		283,
		276,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		-1,
		297,
		293,
		-1,
		-1,
		254,
		247,
		235,
		223,
		213,
		223,
		227,
		231,
		223,
		216,
		211,
		222,
		214,
		218,
		235,
		-1,
		362,
		-1,
		314,
		290,
		304,
		319,
		327,
		-1,
		-1,
		-1,
		314,
		300,
		293,
		281,
		279,
		-1,
		288,
		272,
		253,
		-1,
		223,
		236,
		267,
		235,
		240,
		235,
		217,
		228,
		217,
		220,
		234,
		229,
		-1,
		-1,
		302,
		305,
		-1,
		-1,
		304,
		306,
		-1,
		305,
		294,
		279,
		271,
		-1,
		-1,
		260,
		256,
		-1,
		-1,
		224,
		249,
		238,
		246,
		241,
		221,
		227,
		230,
		219,
		223,
		235,
		-1,
		-1,
		309,
		310,
		311,
		-1,
		289,
		-1,
		307,
		-1,
		274,
		280,
		268,
		-1,
		-1,
		-1,
		262,
		225,
		246,
		256,
		250,
		248,
		239,
		225,
		232,
		230,
		226,
		237,
		-1,
		-1,
		-1,
		307,
		281,
		314,
		305,
		288,
		268,
		260,
		279,
		-1,
		249,
		-1,
		224,
		226,
		252,
		255,
		261,
		255,
		228,
		243,
		233,
		224,
		233,
		313,
		-1,
		283,
		316,
		280,
		274,
		250,
		254,
		270,
		-1,
		246,
		228,
		-1,
		256,
		246,
		277,
		262,
		243,
		230,
		237,
		237,
		230,
		-1,
		-1,
		-1,
		285,
		284,
		276,
		270,
		270,
		255,
		246,
		-1,
		258,
		240,
		219,
		236,
		236,
		227,
		235,
		267,
		263,
		250,
		250,
		242,
		-1,
		386,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		279,
		274,
		247,
		235,
		241,
		237,
		223,
		229,
		231,
		239,
		237,
		234,
		246,
		242,
		262,
		243,
		278,
		-1,
		381,
		-1,
		315,
		-1,
		-1,
		297,
		277,
		269,
		258,
		247,
		245,
		236,
		227,
		249,
		265,
		249,
		247,
		250,
		251,
		-1,
		370,
		369,
		-1,
		316,
		308,
		294,
		-1,
		287,
		-1,
		293,
		254,
		-1,
		256,
		236,
		-1,
		258,
		254,
		-1,
		-1,
		357,
		332,
		-1,
		-1,
		-1,
		317,
		297,
		288,
		272,
		-1,
		247,
		247,
		-1,
		-1,
		-1,
		342,
		341,
		-1,
		310,
		313,
		-1,
		303,
		294,
		302,
		249,
		253,
		-1,
		-1,
		-1,
		351,
		332,
		326,
		325,
		323,
		318,
		315,
		301,
		285,
		263,
		252,
		273,
		-1,
		-1,
		-1,
		323,
		315,
		308,
		-1,
		-1,
		310,
		293,
		274,
		272,
		-1,
		-1,
		-1,
		345,
		326,
		-1,
		-1,
		300,
		-1,
		-1,
		306,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		362,
		334,
		-1,
		-1,
		-1,
		296,
		292,
		293,
		-1,
		-1,
		-1,
		-1,
		356,
		357,
		380,
		344,
		-1,
		-1,
		-1,
		288,
		282,
		-1,
		-1,
		359,
		357,
		-1,
		-1,
		-1,
		316,
		300,
		-1,
		286,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		321,
		-1,
		321,
		296,
		303,
		-1,
		-1,
		-1,
		-1,
		334,
		326,
		334,
		-1,
		306,
		308,
		-1,
		356,
		-1,
		-1,
		349,
		340,
		-1,
		-1,
		311,
		318,
		340,
		343,
		379,
		-1,
		330
	],
	[
		-1,
		19,
		8,
		19,
		42,
		0,
		13,
		-1,
		69,
		45,
		17,
		11,
		37,
		35,
		47,
		58,
		-1,
		-1,
		-1,
		40,
		39,
		24,
		20,
		30,
		41,
		48,
		-1,
		99,
		-1,
		61,
		40,
		51,
		56,
		22,
		25,
		45,
		72,
		94,
		96,
		76,
		52,
		29,
		30,
		53,
		64,
		98,
		90,
		-1,
		36,
		33,
		55,
		68,
		83,
		86,
		-1,
		-1,
		37,
		47,
		53,
		68,
		87,
		90,
		-1,
		100,
		119,
		-1,
		-1,
		36,
		49,
		62,
		65,
		73,
		79,
		92,
		109,
		114,
		-1,
		-1,
		54,
		58,
		68,
		66,
		62,
		79,
		98,
		109,
		123,
		122,
		-1,
		48,
		66,
		75,
		73,
		71,
		55,
		59,
		77,
		108,
		114,
		117,
		-1,
		65,
		61,
		71,
		77,
		89,
		71,
		58,
		64,
		83,
		96,
		115,
		106,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		66,
		57,
		77,
		79,
		78,
		92,
		90,
		61,
		67,
		71,
		88,
		104,
		105,
		115,
		-1,
		-1,
		159,
		132,
		156,
		114,
		96,
		-1,
		62,
		64,
		70,
		74,
		79,
		87,
		92,
		77,
		-1,
		82,
		81,
		112,
		98,
		109,
		141,
		-1,
		-1,
		117,
		109,
		91,
		94,
		71,
		67,
		79,
		78,
		74,
		76,
		78,
		90,
		85,
		98,
		105,
		76,
		86,
		90,
		105,
		116,
		-1,
		-1,
		190,
		-1,
		-1,
		138,
		121,
		-1,
		86,
		93,
		77,
		83,
		69,
		90,
		89,
		83,
		90,
		93,
		81,
		98,
		95,
		112,
		98,
		73,
		98,
		102,
		108,
		126,
		127,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		93,
		90,
		83,
		107,
		106,
		-1,
		112,
		110,
		116,
		101,
		106,
		102,
		87,
		103,
		98,
		98,
		95,
		80,
		82,
		119,
		110,
		131,
		128,
		159,
		165,
		159,
		168,
		-1,
		146,
		142,
		138,
		145,
		94,
		-1,
		-1,
		111,
		-1,
		114,
		127,
		124,
		112,
		115,
		102,
		110,
		109,
		93,
		109,
		96,
		93,
		92,
		88,
		97,
		107,
		106,
		124,
		137,
		152,
		156,
		162,
		-1,
		196,
		-1,
		138,
		122,
		124,
		100,
		128,
		-1,
		131,
		115,
		135,
		126,
		126,
		-1,
		118,
		115,
		125,
		108,
		93,
		108,
		96,
		91,
		91,
		95,
		110,
		101,
		119,
		126,
		134,
		138,
		158,
		170,
		156,
		146,
		-1,
		128,
		133,
		103,
		115,
		138,
		158,
		142,
		-1,
		137,
		-1,
		120,
		133,
		-1,
		114,
		110,
		99,
		104,
		93,
		100,
		98,
		92,
		89,
		107,
		110,
		127,
		131,
		147,
		-1,
		-1,
		141,
		145,
		153,
		104,
		123,
		147,
		184,
		151,
		144,
		143,
		-1,
		138,
		135,
		132,
		133,
		119,
		112,
		113,
		99,
		105,
		106,
		91,
		94,
		116,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		130,
		101,
		125,
		167,
		173,
		166,
		154,
		169,
		169,
		162,
		-1,
		150,
		129,
		126,
		116,
		106,
		122,
		112,
		115,
		95,
		97,
		113,
		125,
		116,
		136,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		104,
		138,
		156,
		202,
		188,
		193,
		168,
		161,
		155,
		144,
		146,
		134,
		123,
		115,
		104,
		113,
		123,
		117,
		97,
		106,
		107,
		131,
		138,
		144,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		129,
		136,
		168,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		117,
		111,
		120,
		125,
		111,
		102,
		117,
		136,
		136,
		128,
		153,
		156,
		-1,
		-1,
		-1,
		160,
		177,
		152,
		129,
		110,
		146,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		121,
		125,
		118,
		125,
		121,
		120,
		121,
		103,
		139,
		-1,
		136,
		130,
		158,
		161,
		151,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		117,
		169,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		128,
		122,
		126,
		130,
		119,
		132,
		128,
		108,
		118,
		138,
		142,
		149,
		142,
		147,
		146,
		160,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		137,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		137,
		137,
		133,
		141,
		126,
		125,
		111,
		115,
		133,
		160,
		155,
		150,
		149,
		156,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		152,
		-1,
		123,
		147,
		163,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		136,
		141,
		140,
		150,
		147,
		136,
		123,
		127,
		142,
		152,
		144,
		145,
		154,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		126,
		139,
		150,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		138,
		144,
		151,
		154,
		151,
		141,
		130,
		136,
		132,
		154,
		140,
		138,
		157,
		172,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		167,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		155,
		139,
		144,
		-1,
		176,
		-1,
		149,
		149,
		140,
		129,
		126,
		137,
		135,
		146,
		163,
		-1,
		179,
		164,
		157,
		147,
		161,
		132,
		-1,
		183,
		-1,
		-1,
		179,
		173,
		173,
		157,
		160,
		171,
		151,
		145,
		144,
		171,
		166,
		157,
		138,
		131,
		128,
		129,
		142,
		162,
		153,
		165,
		-1,
		-1,
		-1,
		184,
		164,
		170,
		128,
		149,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		166,
		188,
		176,
		166,
		156,
		190,
		182,
		157,
		150,
		136,
		138,
		136,
		138,
		143,
		164,
		165,
		178,
		-1,
		-1,
		161,
		168,
		156,
		142,
		161,
		-1,
		-1,
		-1,
		188,
		204,
		196,
		167,
		177,
		-1,
		-1,
		168,
		166,
		174,
		153,
		140,
		160,
		163,
		153,
		137,
		152,
		164,
		172,
		177,
		-1,
		164,
		151,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		199,
		194,
		198,
		171,
		-1,
		170,
		164,
		144,
		158,
		165,
		155,
		150,
		144,
		147,
		165,
		182,
		-1,
		-1,
		178,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		178,
		192,
		187,
		180,
		184,
		-1,
		172,
		160,
		146,
		163,
		168,
		165,
		156,
		148,
		153,
		150,
		163,
		177,
		181,
		201,
		-1,
		184,
		-1,
		-1,
		-1,
		196,
		211,
		226,
		203,
		176,
		171,
		164,
		158,
		154,
		170,
		176,
		187,
		155,
		151,
		152,
		156,
		155,
		172,
		182,
		-1,
		-1,
		184,
		201,
		222,
		204,
		208,
		253,
		-1,
		-1,
		180,
		171,
		162,
		165,
		164,
		167,
		161,
		158,
		163,
		168,
		156,
		165,
		183,
		182,
		-1,
		-1,
		-1,
		204,
		-1,
		219,
		-1,
		-1,
		223,
		251,
		198,
		180,
		176,
		174,
		167,
		176,
		171,
		166,
		176,
		178,
		170,
		158,
		162,
		185,
		174,
		213,
		-1,
		-1,
		321,
		-1,
		-1,
		-1,
		233,
		208,
		223,
		262,
		243,
		250,
		213,
		210,
		-1,
		180,
		205,
		177,
		184,
		175,
		182,
		182,
		174,
		152,
		159,
		175,
		174,
		169,
		205,
		196,
		202,
		-1,
		-1,
		314,
		303,
		292,
		298,
		-1,
		239,
		225,
		248,
		238,
		241,
		-1,
		-1,
		229,
		226,
		202,
		185,
		183,
		176,
		171,
		181,
		161,
		148,
		152,
		156,
		162,
		167,
		172,
		178,
		193,
		208,
		-1,
		209,
		290,
		283,
		266,
		274,
		305,
		-1,
		242,
		244,
		232,
		230,
		232,
		-1,
		-1,
		202,
		199,
		204,
		192,
		189,
		191,
		186,
		177,
		162,
		168,
		155,
		154,
		172,
		176,
		185,
		192,
		182,
		195,
		199,
		-1,
		223,
		266,
		260,
		263,
		287,
		301,
		-1,
		249,
		-1,
		-1,
		240,
		233,
		217,
		207,
		201,
		251,
		206,
		201,
		185,
		183,
		174,
		165,
		172,
		163,
		163,
		166,
		181,
		186,
		178,
		192,
		192,
		193,
		-1,
		258,
		246,
		254,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		256,
		-1,
		244,
		-1,
		219,
		223,
		214,
		217,
		199,
		186,
		178,
		170,
		186,
		161,
		171,
		167,
		168,
		177,
		188,
		200,
		199,
		200,
		320,
		276,
		254,
		245,
		292,
		307,
		311,
		-1,
		261,
		300,
		294,
		-1,
		265,
		-1,
		-1,
		-1,
		233,
		227,
		219,
		219,
		198,
		198,
		172,
		176,
		166,
		173,
		183,
		185,
		177,
		181,
		194,
		205,
		208,
		316,
		307,
		320,
		265,
		259,
		277,
		286,
		307,
		276,
		267,
		294,
		301,
		290,
		285,
		272,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		205,
		193,
		176,
		177,
		173,
		176,
		191,
		194,
		184,
		182,
		176,
		208,
		-1,
		309,
		308,
		297,
		294,
		270,
		261,
		256,
		278,
		-1,
		-1,
		278,
		295,
		289,
		293,
		309,
		334,
		-1,
		265,
		-1,
		-1,
		250,
		-1,
		-1,
		235,
		198,
		187,
		178,
		184,
		181,
		192,
		202,
		190,
		191,
		181,
		191,
		204,
		293,
		290,
		278,
		276,
		299,
		264,
		252,
		-1,
		265,
		263,
		269,
		276,
		293,
		323,
		-1,
		-1,
		281,
		261,
		-1,
		-1,
		233,
		231,
		220,
		-1,
		210,
		183,
		188,
		208,
		210,
		199,
		193,
		187,
		194,
		193,
		201,
		209,
		302,
		316,
		305,
		301,
		300,
		308,
		257,
		250,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		-1,
		271,
		267,
		-1,
		-1,
		228,
		221,
		209,
		197,
		187,
		197,
		201,
		205,
		197,
		190,
		185,
		196,
		188,
		192,
		209,
		-1,
		336,
		-1,
		288,
		264,
		278,
		293,
		301,
		-1,
		-1,
		-1,
		288,
		274,
		267,
		255,
		253,
		-1,
		262,
		246,
		227,
		-1,
		197,
		210,
		241,
		209,
		214,
		209,
		191,
		202,
		191,
		194,
		208,
		203,
		-1,
		-1,
		276,
		279,
		-1,
		-1,
		278,
		280,
		-1,
		279,
		268,
		253,
		245,
		-1,
		-1,
		234,
		230,
		-1,
		-1,
		198,
		223,
		212,
		220,
		215,
		195,
		201,
		204,
		193,
		197,
		209,
		-1,
		-1,
		283,
		284,
		285,
		-1,
		263,
		-1,
		281,
		-1,
		248,
		254,
		242,
		-1,
		-1,
		-1,
		236,
		199,
		220,
		230,
		224,
		222,
		213,
		199,
		206,
		204,
		200,
		211,
		-1,
		-1,
		-1,
		281,
		255,
		288,
		279,
		262,
		242,
		234,
		253,
		-1,
		223,
		-1,
		198,
		200,
		226,
		229,
		235,
		229,
		202,
		217,
		207,
		198,
		207,
		287,
		-1,
		257,
		290,
		254,
		248,
		224,
		228,
		244,
		-1,
		220,
		202,
		-1,
		230,
		220,
		251,
		236,
		217,
		204,
		211,
		211,
		204,
		-1,
		-1,
		-1,
		259,
		258,
		250,
		244,
		244,
		229,
		220,
		-1,
		232,
		214,
		193,
		210,
		210,
		201,
		209,
		241,
		237,
		224,
		224,
		216,
		-1,
		360,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		253,
		248,
		221,
		209,
		215,
		211,
		197,
		203,
		205,
		213,
		211,
		208,
		220,
		216,
		236,
		217,
		252,
		-1,
		355,
		-1,
		289,
		-1,
		-1,
		271,
		251,
		243,
		232,
		221,
		219,
		210,
		201,
		223,
		239,
		223,
		221,
		224,
		225,
		-1,
		344,
		343,
		-1,
		290,
		282,
		268,
		-1,
		261,
		-1,
		267,
		228,
		-1,
		230,
		210,
		-1,
		232,
		228,
		-1,
		-1,
		331,
		306,
		-1,
		-1,
		-1,
		291,
		271,
		262,
		246,
		-1,
		221,
		221,
		-1,
		-1,
		-1,
		316,
		315,
		-1,
		284,
		287,
		-1,
		277,
		268,
		276,
		223,
		227,
		-1,
		-1,
		-1,
		325,
		306,
		300,
		299,
		297,
		292,
		289,
		275,
		259,
		237,
		226,
		247,
		-1,
		-1,
		-1,
		297,
		289,
		282,
		-1,
		-1,
		284,
		267,
		248,
		246,
		-1,
		-1,
		-1,
		319,
		300,
		-1,
		-1,
		274,
		-1,
		-1,
		280,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		336,
		308,
		-1,
		-1,
		-1,
		270,
		266,
		267,
		-1,
		-1,
		-1,
		-1,
		330,
		331,
		354,
		318,
		-1,
		-1,
		-1,
		262,
		256,
		-1,
		-1,
		333,
		331,
		-1,
		-1,
		-1,
		290,
		274,
		-1,
		260,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		295,
		-1,
		295,
		270,
		277,
		-1,
		-1,
		-1,
		-1,
		308,
		300,
		308,
		-1,
		280,
		282,
		-1,
		330,
		-1,
		-1,
		323,
		314,
		-1,
		-1,
		285,
		292,
		314,
		317,
		353,
		-1,
		304
	],
	[
		-1,
		29,
		20,
		31,
		52,
		12,
		0,
		-1,
		77,
		55,
		25,
		19,
		30,
		42,
		55,
		66,
		-1,
		-1,
		-1,
		41,
		42,
		32,
		28,
		38,
		49,
		56,
		-1,
		107,
		-1,
		64,
		40,
		51,
		56,
		30,
		33,
		53,
		80,
		102,
		104,
		79,
		60,
		37,
		38,
		61,
		72,
		106,
		98,
		-1,
		44,
		41,
		63,
		76,
		91,
		94,
		-1,
		-1,
		45,
		55,
		61,
		76,
		95,
		98,
		-1,
		108,
		127,
		-1,
		-1,
		44,
		57,
		70,
		73,
		81,
		87,
		100,
		117,
		122,
		-1,
		-1,
		62,
		66,
		76,
		74,
		70,
		87,
		106,
		117,
		131,
		130,
		-1,
		56,
		74,
		83,
		81,
		79,
		63,
		67,
		85,
		116,
		122,
		125,
		-1,
		73,
		69,
		79,
		85,
		97,
		79,
		66,
		72,
		91,
		104,
		123,
		114,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		74,
		65,
		85,
		87,
		86,
		100,
		98,
		69,
		75,
		79,
		96,
		112,
		113,
		123,
		-1,
		-1,
		167,
		140,
		164,
		122,
		104,
		-1,
		70,
		72,
		78,
		82,
		87,
		95,
		100,
		85,
		-1,
		90,
		89,
		120,
		106,
		117,
		149,
		-1,
		-1,
		125,
		117,
		99,
		102,
		79,
		75,
		87,
		86,
		82,
		84,
		86,
		98,
		93,
		106,
		113,
		84,
		94,
		98,
		113,
		124,
		-1,
		-1,
		198,
		-1,
		-1,
		146,
		129,
		-1,
		94,
		101,
		85,
		91,
		77,
		98,
		97,
		91,
		98,
		101,
		89,
		106,
		103,
		120,
		106,
		81,
		106,
		110,
		116,
		134,
		135,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		101,
		98,
		91,
		115,
		114,
		-1,
		120,
		118,
		124,
		109,
		114,
		110,
		95,
		111,
		106,
		106,
		103,
		88,
		90,
		127,
		118,
		139,
		136,
		167,
		173,
		167,
		176,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		119,
		-1,
		122,
		135,
		132,
		120,
		123,
		110,
		118,
		117,
		101,
		117,
		104,
		101,
		100,
		96,
		105,
		115,
		114,
		132,
		145,
		160,
		164,
		170,
		-1,
		204,
		-1,
		146,
		130,
		132,
		108,
		136,
		-1,
		139,
		123,
		143,
		134,
		134,
		-1,
		126,
		123,
		133,
		116,
		101,
		116,
		104,
		99,
		99,
		103,
		118,
		109,
		127,
		134,
		142,
		146,
		166,
		178,
		164,
		154,
		-1,
		136,
		141,
		111,
		123,
		146,
		166,
		150,
		-1,
		145,
		-1,
		128,
		141,
		-1,
		122,
		118,
		107,
		112,
		101,
		108,
		106,
		100,
		97,
		115,
		118,
		135,
		139,
		155,
		-1,
		-1,
		149,
		153,
		161,
		112,
		131,
		155,
		192,
		159,
		152,
		151,
		-1,
		146,
		143,
		140,
		141,
		127,
		120,
		121,
		107,
		113,
		114,
		99,
		102,
		124,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		138,
		109,
		133,
		175,
		181,
		174,
		162,
		177,
		177,
		170,
		-1,
		158,
		137,
		134,
		124,
		114,
		130,
		120,
		123,
		103,
		105,
		121,
		133,
		124,
		144,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		112,
		146,
		164,
		210,
		196,
		201,
		176,
		169,
		163,
		152,
		154,
		142,
		131,
		123,
		112,
		121,
		131,
		125,
		105,
		114,
		115,
		139,
		146,
		152,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		137,
		144,
		176,
		201,
		214,
		-1,
		168,
		-1,
		157,
		152,
		136,
		131,
		128,
		125,
		119,
		128,
		133,
		119,
		110,
		125,
		144,
		144,
		136,
		161,
		164,
		-1,
		-1,
		-1,
		168,
		185,
		160,
		137,
		118,
		154,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		138,
		134,
		129,
		133,
		126,
		133,
		129,
		128,
		129,
		111,
		147,
		-1,
		144,
		138,
		166,
		169,
		159,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		125,
		177,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		138,
		136,
		130,
		134,
		138,
		127,
		140,
		136,
		116,
		126,
		146,
		150,
		157,
		150,
		155,
		154,
		168,
		-1,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		145,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		158,
		142,
		145,
		145,
		141,
		149,
		134,
		133,
		119,
		123,
		141,
		168,
		163,
		158,
		157,
		164,
		-1,
		231,
		217,
		188,
		-1,
		-1,
		160,
		-1,
		131,
		155,
		171,
		-1,
		186,
		165,
		180,
		158,
		154,
		150,
		165,
		166,
		144,
		149,
		148,
		158,
		155,
		144,
		131,
		135,
		150,
		160,
		152,
		153,
		162,
		-1,
		237,
		224,
		182,
		178,
		167,
		187,
		134,
		147,
		158,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		164,
		162,
		155,
		146,
		152,
		159,
		162,
		159,
		149,
		138,
		144,
		140,
		162,
		148,
		146,
		165,
		180,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		153,
		140,
		134,
		-1,
		175,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		163,
		147,
		152,
		-1,
		184,
		-1,
		157,
		157,
		148,
		137,
		134,
		145,
		143,
		154,
		171,
		-1,
		187,
		172,
		165,
		155,
		169,
		140,
		-1,
		191,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		179,
		159,
		153,
		152,
		179,
		174,
		165,
		146,
		139,
		136,
		137,
		150,
		170,
		161,
		173,
		-1,
		-1,
		-1,
		192,
		172,
		178,
		136,
		157,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		174,
		196,
		184,
		174,
		164,
		198,
		190,
		165,
		158,
		144,
		146,
		144,
		146,
		151,
		172,
		173,
		186,
		-1,
		-1,
		169,
		176,
		164,
		150,
		169,
		-1,
		-1,
		-1,
		196,
		212,
		204,
		175,
		185,
		-1,
		-1,
		176,
		174,
		182,
		161,
		148,
		168,
		171,
		161,
		145,
		160,
		172,
		180,
		185,
		-1,
		172,
		159,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		-1,
		-1,
		229,
		195,
		207,
		202,
		206,
		179,
		-1,
		178,
		172,
		152,
		166,
		173,
		163,
		158,
		152,
		155,
		173,
		190,
		-1,
		-1,
		186,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		186,
		200,
		195,
		188,
		192,
		-1,
		180,
		168,
		154,
		171,
		176,
		173,
		164,
		156,
		161,
		158,
		171,
		185,
		189,
		209,
		-1,
		192,
		-1,
		-1,
		-1,
		204,
		219,
		234,
		211,
		184,
		179,
		172,
		166,
		162,
		178,
		184,
		195,
		163,
		159,
		160,
		164,
		163,
		180,
		190,
		-1,
		-1,
		192,
		209,
		230,
		212,
		216,
		261,
		-1,
		-1,
		188,
		179,
		170,
		173,
		172,
		175,
		169,
		166,
		171,
		176,
		164,
		173,
		191,
		190,
		-1,
		-1,
		-1,
		212,
		-1,
		227,
		-1,
		-1,
		231,
		259,
		206,
		188,
		184,
		182,
		175,
		184,
		179,
		174,
		184,
		186,
		178,
		166,
		170,
		193,
		182,
		221,
		-1,
		-1,
		329,
		-1,
		-1,
		-1,
		241,
		216,
		231,
		270,
		251,
		258,
		221,
		218,
		-1,
		188,
		213,
		185,
		192,
		183,
		190,
		190,
		182,
		160,
		167,
		183,
		182,
		177,
		213,
		204,
		210,
		-1,
		-1,
		322,
		311,
		300,
		306,
		-1,
		247,
		233,
		256,
		246,
		249,
		-1,
		-1,
		237,
		234,
		210,
		193,
		191,
		184,
		179,
		189,
		169,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		217,
		298,
		291,
		274,
		282,
		313,
		-1,
		250,
		252,
		240,
		238,
		240,
		-1,
		-1,
		210,
		207,
		212,
		200,
		197,
		199,
		194,
		185,
		170,
		176,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		231,
		274,
		268,
		271,
		295,
		309,
		-1,
		257,
		-1,
		-1,
		248,
		241,
		225,
		215,
		209,
		259,
		214,
		209,
		193,
		191,
		182,
		173,
		180,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		266,
		254,
		262,
		-1,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		264,
		-1,
		252,
		-1,
		227,
		231,
		222,
		225,
		207,
		194,
		186,
		178,
		194,
		169,
		179,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		328,
		284,
		262,
		253,
		300,
		315,
		319,
		-1,
		269,
		308,
		302,
		-1,
		273,
		-1,
		-1,
		-1,
		241,
		235,
		227,
		227,
		206,
		206,
		180,
		184,
		174,
		181,
		191,
		193,
		185,
		189,
		202,
		213,
		216,
		324,
		315,
		328,
		273,
		267,
		285,
		294,
		315,
		284,
		275,
		302,
		309,
		298,
		293,
		280,
		-1,
		-1,
		264,
		245,
		-1,
		-1,
		213,
		201,
		184,
		185,
		181,
		184,
		199,
		202,
		192,
		190,
		184,
		216,
		-1,
		317,
		316,
		305,
		302,
		278,
		269,
		264,
		286,
		-1,
		-1,
		286,
		303,
		297,
		301,
		317,
		342,
		-1,
		273,
		-1,
		-1,
		258,
		-1,
		-1,
		243,
		206,
		195,
		186,
		192,
		189,
		200,
		210,
		198,
		199,
		189,
		199,
		212,
		301,
		298,
		286,
		284,
		307,
		272,
		260,
		-1,
		273,
		271,
		277,
		284,
		301,
		331,
		-1,
		-1,
		289,
		269,
		-1,
		-1,
		241,
		239,
		228,
		-1,
		218,
		191,
		196,
		216,
		218,
		207,
		201,
		195,
		202,
		201,
		209,
		217,
		310,
		324,
		313,
		309,
		308,
		316,
		265,
		258,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		-1,
		279,
		275,
		-1,
		-1,
		236,
		229,
		217,
		205,
		195,
		205,
		209,
		213,
		205,
		198,
		193,
		204,
		196,
		200,
		217,
		-1,
		344,
		-1,
		296,
		272,
		286,
		301,
		309,
		-1,
		-1,
		-1,
		296,
		282,
		275,
		263,
		261,
		-1,
		270,
		254,
		235,
		-1,
		205,
		218,
		249,
		217,
		222,
		217,
		199,
		210,
		199,
		202,
		216,
		211,
		-1,
		-1,
		284,
		287,
		-1,
		-1,
		286,
		288,
		-1,
		287,
		276,
		261,
		253,
		-1,
		-1,
		242,
		238,
		-1,
		-1,
		206,
		231,
		220,
		228,
		223,
		203,
		209,
		212,
		201,
		205,
		217,
		-1,
		-1,
		291,
		292,
		293,
		-1,
		271,
		-1,
		289,
		-1,
		256,
		262,
		250,
		-1,
		-1,
		-1,
		244,
		207,
		228,
		238,
		232,
		230,
		221,
		207,
		214,
		212,
		208,
		219,
		-1,
		-1,
		-1,
		289,
		263,
		296,
		287,
		270,
		250,
		242,
		261,
		-1,
		231,
		-1,
		206,
		208,
		234,
		237,
		243,
		237,
		210,
		225,
		215,
		206,
		215,
		295,
		-1,
		265,
		298,
		262,
		256,
		232,
		236,
		252,
		-1,
		228,
		210,
		-1,
		238,
		228,
		259,
		244,
		225,
		212,
		219,
		219,
		212,
		-1,
		-1,
		-1,
		267,
		266,
		258,
		252,
		252,
		237,
		228,
		-1,
		240,
		222,
		201,
		218,
		218,
		209,
		217,
		249,
		245,
		232,
		232,
		224,
		-1,
		368,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		261,
		256,
		229,
		217,
		223,
		219,
		205,
		211,
		213,
		221,
		219,
		216,
		228,
		224,
		244,
		225,
		260,
		-1,
		363,
		-1,
		297,
		-1,
		-1,
		279,
		259,
		251,
		240,
		229,
		227,
		218,
		209,
		231,
		247,
		231,
		229,
		232,
		233,
		-1,
		352,
		351,
		-1,
		298,
		290,
		276,
		-1,
		269,
		-1,
		275,
		236,
		-1,
		238,
		218,
		-1,
		240,
		236,
		-1,
		-1,
		339,
		314,
		-1,
		-1,
		-1,
		299,
		279,
		270,
		254,
		-1,
		229,
		229,
		-1,
		-1,
		-1,
		324,
		323,
		-1,
		292,
		295,
		-1,
		285,
		276,
		284,
		231,
		235,
		-1,
		-1,
		-1,
		333,
		314,
		308,
		307,
		305,
		300,
		297,
		283,
		267,
		245,
		234,
		255,
		-1,
		-1,
		-1,
		305,
		297,
		290,
		-1,
		-1,
		292,
		275,
		256,
		254,
		-1,
		-1,
		-1,
		327,
		308,
		-1,
		-1,
		282,
		-1,
		-1,
		288,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		344,
		316,
		-1,
		-1,
		-1,
		278,
		274,
		275,
		-1,
		-1,
		-1,
		-1,
		338,
		339,
		362,
		326,
		-1,
		-1,
		-1,
		270,
		264,
		-1,
		-1,
		341,
		339,
		-1,
		-1,
		-1,
		298,
		282,
		-1,
		268,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		303,
		-1,
		303,
		278,
		285,
		-1,
		-1,
		-1,
		-1,
		316,
		308,
		316,
		-1,
		288,
		290,
		-1,
		338,
		-1,
		-1,
		331,
		322,
		-1,
		-1,
		293,
		300,
		322,
		325,
		361,
		-1,
		312
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		90,
		79,
		90,
		98,
		71,
		78,
		-1,
		0,
		101,
		67,
		61,
		98,
		67,
		73,
		10,
		-1,
		-1,
		-1,
		90,
		89,
		55,
		53,
		62,
		67,
		21,
		-1,
		125,
		-1,
		111,
		90,
		101,
		106,
		48,
		51,
		71,
		98,
		120,
		122,
		126,
		78,
		55,
		56,
		79,
		90,
		124,
		117,
		-1,
		62,
		59,
		81,
		95,
		110,
		114,
		-1,
		-1,
		63,
		73,
		80,
		95,
		114,
		120,
		-1,
		130,
		149,
		-1,
		-1,
		63,
		76,
		89,
		92,
		100,
		109,
		122,
		139,
		144,
		-1,
		-1,
		81,
		85,
		95,
		96,
		92,
		109,
		128,
		139,
		153,
		152,
		-1,
		83,
		101,
		110,
		103,
		101,
		85,
		89,
		107,
		138,
		144,
		147,
		-1,
		100,
		96,
		106,
		112,
		123,
		101,
		88,
		94,
		113,
		126,
		145,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		92,
		112,
		114,
		113,
		122,
		120,
		91,
		97,
		101,
		118,
		134,
		135,
		145,
		-1,
		-1,
		194,
		167,
		191,
		149,
		131,
		-1,
		97,
		99,
		105,
		109,
		114,
		122,
		122,
		107,
		-1,
		112,
		111,
		142,
		128,
		139,
		176,
		-1,
		-1,
		152,
		144,
		126,
		129,
		106,
		102,
		114,
		113,
		109,
		111,
		113,
		125,
		115,
		128,
		135,
		106,
		116,
		120,
		135,
		146,
		-1,
		-1,
		220,
		-1,
		-1,
		173,
		156,
		-1,
		121,
		128,
		112,
		118,
		104,
		125,
		124,
		118,
		125,
		128,
		116,
		128,
		125,
		142,
		128,
		103,
		128,
		132,
		138,
		156,
		157,
		-1,
		219,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		128,
		125,
		118,
		142,
		141,
		-1,
		147,
		145,
		151,
		136,
		141,
		137,
		122,
		133,
		128,
		128,
		125,
		110,
		112,
		149,
		140,
		161,
		158,
		189,
		195,
		189,
		198,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		146,
		-1,
		149,
		162,
		159,
		147,
		150,
		137,
		145,
		144,
		128,
		139,
		126,
		123,
		122,
		118,
		127,
		137,
		136,
		154,
		167,
		182,
		186,
		192,
		-1,
		231,
		-1,
		173,
		157,
		159,
		135,
		163,
		-1,
		166,
		150,
		170,
		161,
		161,
		-1,
		153,
		150,
		160,
		143,
		128,
		138,
		126,
		121,
		121,
		125,
		140,
		131,
		149,
		156,
		164,
		168,
		188,
		200,
		191,
		181,
		-1,
		163,
		168,
		138,
		150,
		173,
		193,
		177,
		-1,
		172,
		-1,
		155,
		168,
		-1,
		149,
		145,
		134,
		134,
		123,
		130,
		128,
		122,
		119,
		137,
		140,
		157,
		161,
		177,
		-1,
		-1,
		176,
		180,
		188,
		139,
		158,
		182,
		219,
		186,
		179,
		178,
		-1,
		173,
		170,
		167,
		168,
		154,
		147,
		146,
		129,
		135,
		136,
		121,
		124,
		146,
		174,
		152,
		164,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		165,
		136,
		160,
		202,
		208,
		201,
		189,
		199,
		199,
		193,
		-1,
		185,
		164,
		157,
		146,
		136,
		152,
		142,
		145,
		125,
		127,
		143,
		155,
		146,
		166,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		139,
		173,
		191,
		232,
		218,
		223,
		198,
		191,
		185,
		179,
		181,
		164,
		153,
		145,
		134,
		143,
		153,
		147,
		127,
		136,
		137,
		161,
		168,
		174,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		164,
		171,
		203,
		223,
		236,
		-1,
		190,
		-1,
		179,
		174,
		158,
		153,
		150,
		147,
		141,
		150,
		155,
		141,
		132,
		147,
		166,
		166,
		158,
		183,
		186,
		-1,
		-1,
		-1,
		195,
		212,
		187,
		164,
		145,
		181,
		-1,
		206,
		207,
		-1,
		184,
		178,
		175,
		160,
		156,
		151,
		155,
		148,
		155,
		151,
		150,
		151,
		133,
		169,
		-1,
		166,
		160,
		188,
		191,
		181,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		152,
		204,
		-1,
		-1,
		191,
		184,
		-1,
		171,
		153,
		160,
		158,
		152,
		156,
		160,
		149,
		162,
		158,
		138,
		148,
		168,
		172,
		179,
		172,
		177,
		176,
		190,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		172,
		-1,
		200,
		192,
		182,
		176,
		170,
		166,
		164,
		180,
		164,
		167,
		167,
		163,
		171,
		156,
		155,
		141,
		145,
		163,
		190,
		185,
		180,
		179,
		186,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		187,
		-1,
		158,
		182,
		198,
		-1,
		208,
		187,
		202,
		180,
		176,
		172,
		187,
		188,
		166,
		171,
		170,
		180,
		177,
		166,
		153,
		157,
		172,
		182,
		174,
		175,
		184,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		161,
		170,
		185,
		-1,
		-1,
		244,
		-1,
		178,
		195,
		186,
		184,
		177,
		168,
		174,
		181,
		184,
		181,
		171,
		160,
		166,
		162,
		184,
		170,
		168,
		187,
		202,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		222,
		212,
		196,
		181,
		214,
		-1,
		185,
		169,
		174,
		-1,
		206,
		-1,
		179,
		179,
		170,
		159,
		156,
		167,
		165,
		176,
		193,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		218,
		-1,
		-1,
		209,
		203,
		203,
		187,
		190,
		201,
		181,
		175,
		174,
		201,
		196,
		187,
		168,
		161,
		158,
		159,
		172,
		192,
		183,
		195,
		-1,
		-1,
		-1,
		219,
		199,
		205,
		163,
		184,
		-1,
		-1,
		271,
		226,
		212,
		-1,
		196,
		218,
		206,
		196,
		186,
		220,
		212,
		187,
		180,
		166,
		168,
		166,
		168,
		173,
		194,
		195,
		208,
		-1,
		-1,
		196,
		203,
		191,
		177,
		196,
		-1,
		-1,
		-1,
		218,
		234,
		226,
		197,
		207,
		-1,
		-1,
		198,
		196,
		204,
		183,
		170,
		190,
		193,
		183,
		167,
		182,
		194,
		202,
		207,
		-1,
		199,
		186,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		-1,
		-1,
		251,
		217,
		229,
		224,
		228,
		201,
		-1,
		200,
		194,
		174,
		188,
		195,
		185,
		180,
		174,
		177,
		195,
		212,
		-1,
		-1,
		213,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		208,
		222,
		217,
		210,
		214,
		-1,
		202,
		190,
		176,
		193,
		198,
		195,
		186,
		178,
		183,
		180,
		193,
		207,
		211,
		236,
		-1,
		219,
		-1,
		-1,
		-1,
		226,
		241,
		256,
		233,
		206,
		201,
		194,
		188,
		184,
		200,
		206,
		217,
		185,
		181,
		182,
		186,
		185,
		202,
		212,
		-1,
		-1,
		219,
		236,
		252,
		234,
		238,
		283,
		-1,
		-1,
		210,
		201,
		192,
		195,
		194,
		197,
		191,
		188,
		193,
		198,
		186,
		195,
		213,
		212,
		-1,
		-1,
		-1,
		239,
		-1,
		254,
		-1,
		-1,
		253,
		281,
		228,
		210,
		206,
		204,
		197,
		206,
		201,
		196,
		206,
		208,
		200,
		188,
		192,
		215,
		204,
		243,
		-1,
		-1,
		356,
		-1,
		-1,
		-1,
		268,
		243,
		258,
		292,
		273,
		280,
		243,
		240,
		-1,
		210,
		235,
		207,
		214,
		205,
		212,
		212,
		204,
		182,
		189,
		205,
		204,
		199,
		235,
		226,
		232,
		-1,
		-1,
		349,
		338,
		327,
		333,
		-1,
		274,
		260,
		278,
		268,
		271,
		-1,
		-1,
		259,
		256,
		232,
		215,
		213,
		206,
		201,
		211,
		191,
		178,
		182,
		186,
		192,
		197,
		202,
		208,
		223,
		238,
		-1,
		244,
		325,
		318,
		301,
		309,
		340,
		-1,
		277,
		274,
		267,
		260,
		262,
		-1,
		-1,
		232,
		229,
		234,
		222,
		219,
		221,
		216,
		207,
		192,
		198,
		185,
		184,
		202,
		206,
		215,
		222,
		212,
		225,
		229,
		-1,
		258,
		301,
		295,
		298,
		322,
		336,
		-1,
		279,
		-1,
		-1,
		275,
		263,
		247,
		237,
		231,
		281,
		236,
		231,
		215,
		213,
		204,
		195,
		202,
		193,
		193,
		196,
		211,
		216,
		208,
		222,
		222,
		223,
		-1,
		293,
		281,
		289,
		-1,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		291,
		-1,
		274,
		-1,
		249,
		253,
		244,
		247,
		229,
		216,
		208,
		200,
		216,
		191,
		201,
		197,
		198,
		207,
		218,
		230,
		229,
		230,
		350,
		306,
		289,
		280,
		327,
		342,
		346,
		-1,
		291,
		330,
		328,
		-1,
		300,
		-1,
		-1,
		-1,
		263,
		257,
		249,
		249,
		228,
		228,
		202,
		206,
		196,
		203,
		213,
		215,
		207,
		211,
		224,
		235,
		238,
		346,
		337,
		350,
		295,
		294,
		312,
		321,
		342,
		306,
		297,
		324,
		335,
		324,
		319,
		306,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		235,
		223,
		206,
		207,
		203,
		206,
		221,
		224,
		214,
		212,
		206,
		238,
		-1,
		339,
		338,
		327,
		324,
		300,
		291,
		286,
		313,
		-1,
		-1,
		308,
		325,
		319,
		323,
		339,
		364,
		-1,
		295,
		-1,
		-1,
		280,
		-1,
		-1,
		265,
		228,
		217,
		208,
		214,
		211,
		222,
		232,
		220,
		221,
		211,
		221,
		234,
		323,
		320,
		308,
		306,
		329,
		294,
		282,
		-1,
		295,
		293,
		299,
		306,
		323,
		353,
		-1,
		-1,
		311,
		291,
		-1,
		-1,
		263,
		261,
		250,
		-1,
		240,
		213,
		218,
		238,
		240,
		229,
		223,
		217,
		224,
		223,
		231,
		239,
		332,
		346,
		335,
		331,
		330,
		338,
		287,
		280,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		-1,
		301,
		297,
		-1,
		-1,
		258,
		251,
		239,
		227,
		217,
		227,
		231,
		235,
		227,
		220,
		215,
		226,
		218,
		222,
		239,
		-1,
		366,
		-1,
		318,
		294,
		308,
		323,
		331,
		-1,
		-1,
		-1,
		318,
		304,
		297,
		285,
		283,
		-1,
		292,
		276,
		257,
		-1,
		227,
		240,
		271,
		239,
		244,
		239,
		221,
		232,
		221,
		224,
		238,
		233,
		-1,
		-1,
		306,
		309,
		-1,
		-1,
		308,
		310,
		-1,
		309,
		298,
		283,
		275,
		-1,
		-1,
		264,
		260,
		-1,
		-1,
		228,
		253,
		242,
		250,
		245,
		225,
		231,
		234,
		223,
		227,
		239,
		-1,
		-1,
		313,
		314,
		315,
		-1,
		293,
		-1,
		311,
		-1,
		278,
		284,
		272,
		-1,
		-1,
		-1,
		266,
		229,
		250,
		260,
		254,
		252,
		243,
		229,
		236,
		234,
		230,
		241,
		-1,
		-1,
		-1,
		311,
		285,
		318,
		309,
		292,
		272,
		264,
		283,
		-1,
		253,
		-1,
		228,
		230,
		256,
		259,
		265,
		259,
		232,
		247,
		237,
		228,
		237,
		317,
		-1,
		287,
		320,
		284,
		278,
		254,
		258,
		274,
		-1,
		250,
		232,
		-1,
		260,
		250,
		281,
		266,
		247,
		234,
		241,
		241,
		234,
		-1,
		-1,
		-1,
		289,
		288,
		280,
		274,
		274,
		259,
		250,
		-1,
		262,
		244,
		223,
		240,
		240,
		231,
		239,
		271,
		267,
		254,
		254,
		246,
		-1,
		390,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		283,
		278,
		251,
		239,
		245,
		241,
		227,
		233,
		235,
		243,
		241,
		238,
		250,
		246,
		266,
		247,
		282,
		-1,
		385,
		-1,
		319,
		-1,
		-1,
		301,
		281,
		273,
		262,
		251,
		249,
		240,
		231,
		253,
		269,
		253,
		251,
		254,
		255,
		-1,
		374,
		373,
		-1,
		320,
		312,
		298,
		-1,
		291,
		-1,
		297,
		258,
		-1,
		260,
		240,
		-1,
		262,
		258,
		-1,
		-1,
		361,
		336,
		-1,
		-1,
		-1,
		321,
		301,
		292,
		276,
		-1,
		251,
		251,
		-1,
		-1,
		-1,
		346,
		345,
		-1,
		314,
		317,
		-1,
		307,
		298,
		306,
		253,
		257,
		-1,
		-1,
		-1,
		355,
		336,
		330,
		329,
		327,
		322,
		319,
		305,
		289,
		267,
		256,
		277,
		-1,
		-1,
		-1,
		327,
		319,
		312,
		-1,
		-1,
		314,
		297,
		278,
		276,
		-1,
		-1,
		-1,
		349,
		330,
		-1,
		-1,
		304,
		-1,
		-1,
		310,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		366,
		338,
		-1,
		-1,
		-1,
		300,
		296,
		297,
		-1,
		-1,
		-1,
		-1,
		360,
		361,
		384,
		348,
		-1,
		-1,
		-1,
		292,
		286,
		-1,
		-1,
		363,
		361,
		-1,
		-1,
		-1,
		320,
		304,
		-1,
		290,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		323,
		-1,
		-1,
		-1,
		325,
		-1,
		325,
		300,
		307,
		-1,
		-1,
		-1,
		-1,
		338,
		330,
		338,
		-1,
		310,
		312,
		-1,
		360,
		-1,
		-1,
		353,
		344,
		-1,
		-1,
		315,
		322,
		344,
		347,
		383,
		-1,
		334
	],
	[
		-1,
		38,
		41,
		55,
		5,
		39,
		51,
		-1,
		100,
		0,
		36,
		42,
		71,
		66,
		78,
		89,
		-1,
		-1,
		-1,
		41,
		48,
		55,
		51,
		61,
		72,
		79,
		-1,
		130,
		-1,
		70,
		58,
		69,
		74,
		53,
		56,
		76,
		103,
		125,
		127,
		85,
		83,
		60,
		61,
		84,
		95,
		129,
		121,
		-1,
		67,
		64,
		86,
		99,
		114,
		117,
		-1,
		-1,
		68,
		78,
		84,
		99,
		118,
		121,
		-1,
		131,
		150,
		-1,
		-1,
		67,
		80,
		93,
		96,
		104,
		110,
		123,
		140,
		145,
		-1,
		-1,
		85,
		89,
		99,
		97,
		93,
		110,
		129,
		140,
		154,
		153,
		-1,
		79,
		97,
		106,
		104,
		102,
		86,
		90,
		108,
		139,
		145,
		148,
		-1,
		96,
		92,
		102,
		108,
		120,
		102,
		89,
		95,
		114,
		127,
		146,
		137,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		97,
		88,
		108,
		110,
		109,
		123,
		121,
		92,
		98,
		102,
		119,
		135,
		136,
		146,
		-1,
		-1,
		190,
		163,
		187,
		145,
		127,
		-1,
		93,
		95,
		101,
		105,
		110,
		118,
		123,
		108,
		-1,
		113,
		112,
		143,
		129,
		140,
		172,
		-1,
		-1,
		148,
		140,
		122,
		125,
		102,
		98,
		110,
		109,
		105,
		107,
		109,
		121,
		116,
		129,
		136,
		107,
		117,
		121,
		136,
		147,
		-1,
		-1,
		221,
		-1,
		-1,
		169,
		152,
		-1,
		117,
		124,
		108,
		114,
		100,
		121,
		120,
		114,
		121,
		124,
		112,
		129,
		126,
		143,
		129,
		104,
		129,
		133,
		139,
		157,
		158,
		-1,
		220,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		124,
		121,
		114,
		138,
		137,
		-1,
		143,
		141,
		147,
		132,
		137,
		133,
		118,
		134,
		129,
		129,
		126,
		111,
		113,
		150,
		141,
		162,
		159,
		190,
		196,
		190,
		199,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		142,
		-1,
		145,
		158,
		155,
		143,
		146,
		133,
		141,
		140,
		124,
		140,
		127,
		124,
		123,
		119,
		128,
		138,
		137,
		155,
		168,
		183,
		187,
		193,
		-1,
		227,
		-1,
		169,
		153,
		155,
		131,
		159,
		-1,
		162,
		146,
		166,
		157,
		157,
		-1,
		149,
		146,
		156,
		139,
		124,
		139,
		127,
		122,
		122,
		126,
		141,
		132,
		150,
		157,
		165,
		169,
		189,
		201,
		187,
		177,
		-1,
		159,
		164,
		134,
		146,
		169,
		189,
		173,
		-1,
		168,
		-1,
		151,
		164,
		-1,
		145,
		141,
		130,
		135,
		124,
		131,
		129,
		123,
		120,
		138,
		141,
		158,
		162,
		178,
		-1,
		-1,
		172,
		176,
		184,
		135,
		154,
		178,
		215,
		182,
		175,
		174,
		-1,
		169,
		166,
		163,
		164,
		150,
		143,
		144,
		130,
		136,
		137,
		122,
		125,
		147,
		175,
		153,
		165,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		161,
		132,
		156,
		198,
		204,
		197,
		185,
		200,
		200,
		193,
		-1,
		181,
		160,
		157,
		147,
		137,
		153,
		143,
		146,
		126,
		128,
		144,
		156,
		147,
		167,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		135,
		169,
		187,
		233,
		219,
		224,
		199,
		192,
		186,
		175,
		177,
		165,
		154,
		146,
		135,
		144,
		154,
		148,
		128,
		137,
		138,
		162,
		169,
		175,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		160,
		167,
		199,
		224,
		237,
		-1,
		191,
		-1,
		180,
		175,
		159,
		154,
		151,
		148,
		142,
		151,
		156,
		142,
		133,
		148,
		167,
		167,
		159,
		184,
		187,
		-1,
		-1,
		-1,
		191,
		208,
		183,
		160,
		141,
		177,
		-1,
		207,
		208,
		-1,
		185,
		179,
		176,
		161,
		157,
		152,
		156,
		149,
		156,
		152,
		151,
		152,
		134,
		170,
		-1,
		167,
		161,
		189,
		192,
		182,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		148,
		200,
		-1,
		-1,
		192,
		185,
		-1,
		172,
		154,
		161,
		159,
		153,
		157,
		161,
		150,
		163,
		159,
		139,
		149,
		169,
		173,
		180,
		173,
		178,
		177,
		191,
		-1,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		168,
		-1,
		201,
		193,
		183,
		177,
		171,
		167,
		165,
		181,
		165,
		168,
		168,
		164,
		172,
		157,
		156,
		142,
		146,
		164,
		191,
		186,
		181,
		180,
		187,
		-1,
		254,
		240,
		211,
		-1,
		-1,
		183,
		-1,
		154,
		178,
		194,
		-1,
		209,
		188,
		203,
		181,
		177,
		173,
		188,
		189,
		167,
		172,
		171,
		181,
		178,
		167,
		154,
		158,
		173,
		183,
		175,
		176,
		185,
		-1,
		260,
		247,
		205,
		201,
		190,
		210,
		157,
		170,
		181,
		-1,
		-1,
		245,
		-1,
		179,
		196,
		187,
		185,
		178,
		169,
		175,
		182,
		185,
		182,
		172,
		161,
		167,
		163,
		185,
		171,
		169,
		188,
		203,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		176,
		163,
		157,
		-1,
		198,
		-1,
		223,
		213,
		197,
		182,
		215,
		-1,
		186,
		170,
		175,
		-1,
		207,
		-1,
		180,
		180,
		171,
		160,
		157,
		168,
		166,
		177,
		194,
		-1,
		210,
		195,
		188,
		178,
		192,
		163,
		-1,
		214,
		-1,
		-1,
		210,
		204,
		204,
		188,
		191,
		202,
		182,
		176,
		175,
		202,
		197,
		188,
		169,
		162,
		159,
		160,
		173,
		193,
		184,
		196,
		-1,
		-1,
		-1,
		215,
		195,
		201,
		159,
		180,
		-1,
		-1,
		272,
		227,
		213,
		-1,
		197,
		219,
		207,
		197,
		187,
		221,
		213,
		188,
		181,
		167,
		169,
		167,
		169,
		174,
		195,
		196,
		209,
		-1,
		-1,
		192,
		199,
		187,
		173,
		192,
		-1,
		-1,
		-1,
		219,
		235,
		227,
		198,
		208,
		-1,
		-1,
		199,
		197,
		205,
		184,
		171,
		191,
		194,
		184,
		168,
		183,
		195,
		203,
		208,
		-1,
		195,
		182,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		-1,
		-1,
		252,
		218,
		230,
		225,
		229,
		202,
		-1,
		201,
		195,
		175,
		189,
		196,
		186,
		181,
		175,
		178,
		196,
		213,
		-1,
		-1,
		209,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		209,
		223,
		218,
		211,
		215,
		-1,
		203,
		191,
		177,
		194,
		199,
		196,
		187,
		179,
		184,
		181,
		194,
		208,
		212,
		232,
		-1,
		215,
		-1,
		-1,
		-1,
		227,
		242,
		257,
		234,
		207,
		202,
		195,
		189,
		185,
		201,
		207,
		218,
		186,
		182,
		183,
		187,
		186,
		203,
		213,
		-1,
		-1,
		215,
		232,
		253,
		235,
		239,
		284,
		-1,
		-1,
		211,
		202,
		193,
		196,
		195,
		198,
		192,
		189,
		194,
		199,
		187,
		196,
		214,
		213,
		-1,
		-1,
		-1,
		235,
		-1,
		250,
		-1,
		-1,
		254,
		282,
		229,
		211,
		207,
		205,
		198,
		207,
		202,
		197,
		207,
		209,
		201,
		189,
		193,
		216,
		205,
		244,
		-1,
		-1,
		352,
		-1,
		-1,
		-1,
		264,
		239,
		254,
		293,
		274,
		281,
		244,
		241,
		-1,
		211,
		236,
		208,
		215,
		206,
		213,
		213,
		205,
		183,
		190,
		206,
		205,
		200,
		236,
		227,
		233,
		-1,
		-1,
		345,
		334,
		323,
		329,
		-1,
		270,
		256,
		279,
		269,
		272,
		-1,
		-1,
		260,
		257,
		233,
		216,
		214,
		207,
		202,
		212,
		192,
		179,
		183,
		187,
		193,
		198,
		203,
		209,
		224,
		239,
		-1,
		240,
		321,
		314,
		297,
		305,
		336,
		-1,
		273,
		275,
		263,
		261,
		263,
		-1,
		-1,
		233,
		230,
		235,
		223,
		220,
		222,
		217,
		208,
		193,
		199,
		186,
		185,
		203,
		207,
		216,
		223,
		213,
		226,
		230,
		-1,
		254,
		297,
		291,
		294,
		318,
		332,
		-1,
		280,
		-1,
		-1,
		271,
		264,
		248,
		238,
		232,
		282,
		237,
		232,
		216,
		214,
		205,
		196,
		203,
		194,
		194,
		197,
		212,
		217,
		209,
		223,
		223,
		224,
		-1,
		289,
		277,
		285,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		287,
		-1,
		275,
		-1,
		250,
		254,
		245,
		248,
		230,
		217,
		209,
		201,
		217,
		192,
		202,
		198,
		199,
		208,
		219,
		231,
		230,
		231,
		351,
		307,
		285,
		276,
		323,
		338,
		342,
		-1,
		292,
		331,
		325,
		-1,
		296,
		-1,
		-1,
		-1,
		264,
		258,
		250,
		250,
		229,
		229,
		203,
		207,
		197,
		204,
		214,
		216,
		208,
		212,
		225,
		236,
		239,
		347,
		338,
		351,
		296,
		290,
		308,
		317,
		338,
		307,
		298,
		325,
		332,
		321,
		316,
		303,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		236,
		224,
		207,
		208,
		204,
		207,
		222,
		225,
		215,
		213,
		207,
		239,
		-1,
		340,
		339,
		328,
		325,
		301,
		292,
		287,
		309,
		-1,
		-1,
		309,
		326,
		320,
		324,
		340,
		365,
		-1,
		296,
		-1,
		-1,
		281,
		-1,
		-1,
		266,
		229,
		218,
		209,
		215,
		212,
		223,
		233,
		221,
		222,
		212,
		222,
		235,
		324,
		321,
		309,
		307,
		330,
		295,
		283,
		-1,
		296,
		294,
		300,
		307,
		324,
		354,
		-1,
		-1,
		312,
		292,
		-1,
		-1,
		264,
		262,
		251,
		-1,
		241,
		214,
		219,
		239,
		241,
		230,
		224,
		218,
		225,
		224,
		232,
		240,
		333,
		347,
		336,
		332,
		331,
		339,
		288,
		281,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		317,
		-1,
		302,
		298,
		-1,
		-1,
		259,
		252,
		240,
		228,
		218,
		228,
		232,
		236,
		228,
		221,
		216,
		227,
		219,
		223,
		240,
		-1,
		367,
		-1,
		319,
		295,
		309,
		324,
		332,
		-1,
		-1,
		-1,
		319,
		305,
		298,
		286,
		284,
		-1,
		293,
		277,
		258,
		-1,
		228,
		241,
		272,
		240,
		245,
		240,
		222,
		233,
		222,
		225,
		239,
		234,
		-1,
		-1,
		307,
		310,
		-1,
		-1,
		309,
		311,
		-1,
		310,
		299,
		284,
		276,
		-1,
		-1,
		265,
		261,
		-1,
		-1,
		229,
		254,
		243,
		251,
		246,
		226,
		232,
		235,
		224,
		228,
		240,
		-1,
		-1,
		314,
		315,
		316,
		-1,
		294,
		-1,
		312,
		-1,
		279,
		285,
		273,
		-1,
		-1,
		-1,
		267,
		230,
		251,
		261,
		255,
		253,
		244,
		230,
		237,
		235,
		231,
		242,
		-1,
		-1,
		-1,
		312,
		286,
		319,
		310,
		293,
		273,
		265,
		284,
		-1,
		254,
		-1,
		229,
		231,
		257,
		260,
		266,
		260,
		233,
		248,
		238,
		229,
		238,
		318,
		-1,
		288,
		321,
		285,
		279,
		255,
		259,
		275,
		-1,
		251,
		233,
		-1,
		261,
		251,
		282,
		267,
		248,
		235,
		242,
		242,
		235,
		-1,
		-1,
		-1,
		290,
		289,
		281,
		275,
		275,
		260,
		251,
		-1,
		263,
		245,
		224,
		241,
		241,
		232,
		240,
		272,
		268,
		255,
		255,
		247,
		-1,
		391,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		284,
		279,
		252,
		240,
		246,
		242,
		228,
		234,
		236,
		244,
		242,
		239,
		251,
		247,
		267,
		248,
		283,
		-1,
		386,
		-1,
		320,
		-1,
		-1,
		302,
		282,
		274,
		263,
		252,
		250,
		241,
		232,
		254,
		270,
		254,
		252,
		255,
		256,
		-1,
		375,
		374,
		-1,
		321,
		313,
		299,
		-1,
		292,
		-1,
		298,
		259,
		-1,
		261,
		241,
		-1,
		263,
		259,
		-1,
		-1,
		362,
		337,
		-1,
		-1,
		-1,
		322,
		302,
		293,
		277,
		-1,
		252,
		252,
		-1,
		-1,
		-1,
		347,
		346,
		-1,
		315,
		318,
		-1,
		308,
		299,
		307,
		254,
		258,
		-1,
		-1,
		-1,
		356,
		337,
		331,
		330,
		328,
		323,
		320,
		306,
		290,
		268,
		257,
		278,
		-1,
		-1,
		-1,
		328,
		320,
		313,
		-1,
		-1,
		315,
		298,
		279,
		277,
		-1,
		-1,
		-1,
		350,
		331,
		-1,
		-1,
		305,
		-1,
		-1,
		311,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		367,
		339,
		-1,
		-1,
		-1,
		301,
		297,
		298,
		-1,
		-1,
		-1,
		-1,
		361,
		362,
		385,
		349,
		-1,
		-1,
		-1,
		293,
		287,
		-1,
		-1,
		364,
		362,
		-1,
		-1,
		-1,
		321,
		305,
		-1,
		291,
		-1,
		-1,
		-1,
		312,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		326,
		-1,
		326,
		301,
		308,
		-1,
		-1,
		-1,
		-1,
		339,
		331,
		339,
		-1,
		311,
		313,
		-1,
		361,
		-1,
		-1,
		354,
		345,
		-1,
		-1,
		316,
		323,
		345,
		348,
		384,
		-1,
		335
	],
	[
		-1,
		28,
		24,
		35,
		31,
		16,
		23,
		-1,
		64,
		34,
		0,
		6,
		45,
		30,
		42,
		53,
		-1,
		-1,
		-1,
		25,
		32,
		19,
		15,
		25,
		36,
		43,
		-1,
		94,
		-1,
		54,
		35,
		46,
		51,
		17,
		20,
		40,
		67,
		89,
		91,
		69,
		47,
		24,
		25,
		48,
		59,
		93,
		85,
		-1,
		31,
		28,
		50,
		63,
		78,
		81,
		-1,
		-1,
		32,
		42,
		48,
		63,
		82,
		85,
		-1,
		95,
		114,
		-1,
		-1,
		31,
		44,
		57,
		60,
		68,
		74,
		87,
		104,
		109,
		-1,
		-1,
		49,
		53,
		63,
		61,
		57,
		74,
		93,
		104,
		118,
		117,
		-1,
		43,
		61,
		70,
		68,
		66,
		50,
		54,
		72,
		103,
		109,
		112,
		-1,
		60,
		56,
		66,
		72,
		84,
		66,
		53,
		59,
		78,
		91,
		110,
		101,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		61,
		52,
		72,
		74,
		73,
		87,
		85,
		56,
		62,
		66,
		83,
		99,
		100,
		110,
		-1,
		-1,
		154,
		127,
		151,
		109,
		91,
		-1,
		57,
		59,
		65,
		69,
		74,
		82,
		87,
		72,
		-1,
		77,
		76,
		107,
		93,
		104,
		136,
		-1,
		-1,
		112,
		104,
		86,
		89,
		66,
		62,
		74,
		73,
		69,
		71,
		73,
		85,
		80,
		93,
		100,
		71,
		81,
		85,
		100,
		111,
		-1,
		-1,
		185,
		-1,
		-1,
		133,
		116,
		-1,
		81,
		88,
		72,
		78,
		64,
		85,
		84,
		78,
		85,
		88,
		76,
		93,
		90,
		107,
		93,
		68,
		93,
		97,
		103,
		121,
		122,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		88,
		85,
		78,
		102,
		101,
		-1,
		107,
		105,
		111,
		96,
		101,
		97,
		82,
		98,
		93,
		93,
		90,
		75,
		77,
		114,
		105,
		126,
		123,
		154,
		160,
		154,
		163,
		-1,
		141,
		137,
		133,
		140,
		89,
		-1,
		-1,
		106,
		-1,
		109,
		122,
		119,
		107,
		110,
		97,
		105,
		104,
		88,
		104,
		91,
		88,
		87,
		83,
		92,
		102,
		101,
		119,
		132,
		147,
		151,
		157,
		-1,
		191,
		-1,
		133,
		117,
		119,
		95,
		123,
		-1,
		126,
		110,
		130,
		121,
		121,
		-1,
		113,
		110,
		120,
		103,
		88,
		103,
		91,
		86,
		86,
		90,
		105,
		96,
		114,
		121,
		129,
		133,
		153,
		165,
		151,
		141,
		-1,
		123,
		128,
		98,
		110,
		133,
		153,
		137,
		-1,
		132,
		-1,
		115,
		128,
		-1,
		109,
		105,
		94,
		99,
		88,
		95,
		93,
		87,
		84,
		102,
		105,
		122,
		126,
		142,
		-1,
		-1,
		136,
		140,
		148,
		99,
		118,
		142,
		179,
		146,
		139,
		138,
		-1,
		133,
		130,
		127,
		128,
		114,
		107,
		108,
		94,
		100,
		101,
		86,
		89,
		111,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		125,
		96,
		120,
		162,
		168,
		161,
		149,
		164,
		164,
		157,
		-1,
		145,
		124,
		121,
		111,
		101,
		117,
		107,
		110,
		90,
		92,
		108,
		120,
		111,
		131,
		-1,
		-1,
		-1,
		155,
		144,
		145,
		99,
		133,
		151,
		197,
		183,
		188,
		163,
		156,
		150,
		139,
		141,
		129,
		118,
		110,
		99,
		108,
		118,
		112,
		92,
		101,
		102,
		126,
		133,
		139,
		-1,
		-1,
		162,
		152,
		136,
		138,
		135,
		124,
		131,
		163,
		188,
		201,
		-1,
		155,
		-1,
		144,
		139,
		123,
		118,
		115,
		112,
		106,
		115,
		120,
		106,
		97,
		112,
		131,
		131,
		123,
		148,
		151,
		-1,
		-1,
		-1,
		155,
		172,
		147,
		124,
		105,
		141,
		-1,
		171,
		172,
		-1,
		149,
		143,
		140,
		125,
		121,
		116,
		120,
		113,
		120,
		116,
		115,
		116,
		98,
		134,
		-1,
		131,
		125,
		153,
		156,
		146,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		112,
		164,
		-1,
		-1,
		156,
		149,
		-1,
		136,
		118,
		125,
		123,
		117,
		121,
		125,
		114,
		127,
		123,
		103,
		113,
		133,
		137,
		144,
		137,
		142,
		141,
		155,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		132,
		-1,
		165,
		157,
		147,
		141,
		135,
		131,
		129,
		145,
		129,
		132,
		132,
		128,
		136,
		121,
		120,
		106,
		110,
		128,
		155,
		150,
		145,
		144,
		151,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		147,
		-1,
		118,
		142,
		158,
		-1,
		173,
		152,
		167,
		145,
		141,
		137,
		152,
		153,
		131,
		136,
		135,
		145,
		142,
		131,
		118,
		122,
		137,
		147,
		139,
		140,
		149,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		121,
		134,
		145,
		-1,
		-1,
		209,
		-1,
		143,
		160,
		151,
		149,
		142,
		133,
		139,
		146,
		149,
		146,
		136,
		125,
		131,
		127,
		149,
		135,
		133,
		152,
		167,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		187,
		177,
		161,
		146,
		179,
		-1,
		150,
		134,
		139,
		-1,
		171,
		-1,
		144,
		144,
		135,
		124,
		121,
		132,
		130,
		141,
		158,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		178,
		-1,
		-1,
		174,
		168,
		168,
		152,
		155,
		166,
		146,
		140,
		139,
		166,
		161,
		152,
		133,
		126,
		123,
		124,
		137,
		157,
		148,
		160,
		-1,
		-1,
		-1,
		179,
		159,
		165,
		123,
		144,
		-1,
		-1,
		236,
		191,
		177,
		-1,
		161,
		183,
		171,
		161,
		151,
		185,
		177,
		152,
		145,
		131,
		133,
		131,
		133,
		138,
		159,
		160,
		173,
		-1,
		-1,
		156,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		183,
		199,
		191,
		162,
		172,
		-1,
		-1,
		163,
		161,
		169,
		148,
		135,
		155,
		158,
		148,
		132,
		147,
		159,
		167,
		172,
		-1,
		159,
		146,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		216,
		182,
		194,
		189,
		193,
		166,
		-1,
		165,
		159,
		139,
		153,
		160,
		150,
		145,
		139,
		142,
		160,
		177,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		173,
		187,
		182,
		175,
		179,
		-1,
		167,
		155,
		141,
		158,
		163,
		160,
		151,
		143,
		148,
		145,
		158,
		172,
		176,
		196,
		-1,
		179,
		-1,
		-1,
		-1,
		191,
		206,
		221,
		198,
		171,
		166,
		159,
		153,
		149,
		165,
		171,
		182,
		150,
		146,
		147,
		151,
		150,
		167,
		177,
		-1,
		-1,
		179,
		196,
		217,
		199,
		203,
		248,
		-1,
		-1,
		175,
		166,
		157,
		160,
		159,
		162,
		156,
		153,
		158,
		163,
		151,
		160,
		178,
		177,
		-1,
		-1,
		-1,
		199,
		-1,
		214,
		-1,
		-1,
		218,
		246,
		193,
		175,
		171,
		169,
		162,
		171,
		166,
		161,
		171,
		173,
		165,
		153,
		157,
		180,
		169,
		208,
		-1,
		-1,
		316,
		-1,
		-1,
		-1,
		228,
		203,
		218,
		257,
		238,
		245,
		208,
		205,
		-1,
		175,
		200,
		172,
		179,
		170,
		177,
		177,
		169,
		147,
		154,
		170,
		169,
		164,
		200,
		191,
		197,
		-1,
		-1,
		309,
		298,
		287,
		293,
		-1,
		234,
		220,
		243,
		233,
		236,
		-1,
		-1,
		224,
		221,
		197,
		180,
		178,
		171,
		166,
		176,
		156,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		204,
		285,
		278,
		261,
		269,
		300,
		-1,
		237,
		239,
		227,
		225,
		227,
		-1,
		-1,
		197,
		194,
		199,
		187,
		184,
		186,
		181,
		172,
		157,
		163,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		218,
		261,
		255,
		258,
		282,
		296,
		-1,
		244,
		-1,
		-1,
		235,
		228,
		212,
		202,
		196,
		246,
		201,
		196,
		180,
		178,
		169,
		160,
		167,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		253,
		241,
		249,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		-1,
		239,
		-1,
		214,
		218,
		209,
		212,
		194,
		181,
		173,
		165,
		181,
		156,
		166,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		315,
		271,
		249,
		240,
		287,
		302,
		306,
		-1,
		256,
		295,
		289,
		-1,
		260,
		-1,
		-1,
		-1,
		228,
		222,
		214,
		214,
		193,
		193,
		167,
		171,
		161,
		168,
		178,
		180,
		172,
		176,
		189,
		200,
		203,
		311,
		302,
		315,
		260,
		254,
		272,
		281,
		302,
		271,
		262,
		289,
		296,
		285,
		280,
		267,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		200,
		188,
		171,
		172,
		168,
		171,
		186,
		189,
		179,
		177,
		171,
		203,
		-1,
		304,
		303,
		292,
		289,
		265,
		256,
		251,
		273,
		-1,
		-1,
		273,
		290,
		284,
		288,
		304,
		329,
		-1,
		260,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		176,
		187,
		197,
		185,
		186,
		176,
		186,
		199,
		288,
		285,
		273,
		271,
		294,
		259,
		247,
		-1,
		260,
		258,
		264,
		271,
		288,
		318,
		-1,
		-1,
		276,
		256,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		178,
		183,
		203,
		205,
		194,
		188,
		182,
		189,
		188,
		196,
		204,
		297,
		311,
		300,
		296,
		295,
		303,
		252,
		245,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		266,
		262,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		196,
		200,
		192,
		185,
		180,
		191,
		183,
		187,
		204,
		-1,
		331,
		-1,
		283,
		259,
		273,
		288,
		296,
		-1,
		-1,
		-1,
		283,
		269,
		262,
		250,
		248,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		186,
		197,
		186,
		189,
		203,
		198,
		-1,
		-1,
		271,
		274,
		-1,
		-1,
		273,
		275,
		-1,
		274,
		263,
		248,
		240,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		190,
		196,
		199,
		188,
		192,
		204,
		-1,
		-1,
		278,
		279,
		280,
		-1,
		258,
		-1,
		276,
		-1,
		243,
		249,
		237,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		219,
		217,
		208,
		194,
		201,
		199,
		195,
		206,
		-1,
		-1,
		-1,
		276,
		250,
		283,
		274,
		257,
		237,
		229,
		248,
		-1,
		218,
		-1,
		193,
		195,
		221,
		224,
		230,
		224,
		197,
		212,
		202,
		193,
		202,
		282,
		-1,
		252,
		285,
		249,
		243,
		219,
		223,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		246,
		231,
		212,
		199,
		206,
		206,
		199,
		-1,
		-1,
		-1,
		254,
		253,
		245,
		239,
		239,
		224,
		215,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		236,
		232,
		219,
		219,
		211,
		-1,
		355,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		248,
		243,
		216,
		204,
		210,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		212,
		247,
		-1,
		350,
		-1,
		284,
		-1,
		-1,
		266,
		246,
		238,
		227,
		216,
		214,
		205,
		196,
		218,
		234,
		218,
		216,
		219,
		220,
		-1,
		339,
		338,
		-1,
		285,
		277,
		263,
		-1,
		256,
		-1,
		262,
		223,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		326,
		301,
		-1,
		-1,
		-1,
		286,
		266,
		257,
		241,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		311,
		310,
		-1,
		279,
		282,
		-1,
		272,
		263,
		271,
		218,
		222,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		294,
		292,
		287,
		284,
		270,
		254,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		292,
		284,
		277,
		-1,
		-1,
		279,
		262,
		243,
		241,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		303,
		-1,
		-1,
		-1,
		265,
		261,
		262,
		-1,
		-1,
		-1,
		-1,
		325,
		326,
		349,
		313,
		-1,
		-1,
		-1,
		257,
		251,
		-1,
		-1,
		328,
		326,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		255,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		290,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		280,
		287,
		309,
		312,
		348,
		-1,
		299
	],
	[
		-1,
		29,
		18,
		29,
		37,
		10,
		17,
		-1,
		58,
		40,
		6,
		0,
		39,
		24,
		36,
		47,
		-1,
		-1,
		-1,
		29,
		28,
		13,
		9,
		19,
		30,
		37,
		-1,
		88,
		-1,
		50,
		29,
		40,
		45,
		11,
		14,
		34,
		61,
		83,
		85,
		65,
		41,
		18,
		19,
		42,
		53,
		87,
		79,
		-1,
		25,
		22,
		44,
		57,
		72,
		75,
		-1,
		-1,
		26,
		36,
		42,
		57,
		76,
		79,
		-1,
		89,
		108,
		-1,
		-1,
		25,
		38,
		51,
		54,
		62,
		68,
		81,
		98,
		103,
		-1,
		-1,
		43,
		47,
		57,
		55,
		51,
		68,
		87,
		98,
		112,
		111,
		-1,
		37,
		55,
		64,
		62,
		60,
		44,
		48,
		66,
		97,
		103,
		106,
		-1,
		54,
		50,
		60,
		66,
		78,
		60,
		47,
		53,
		72,
		85,
		104,
		95,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		55,
		46,
		66,
		68,
		67,
		81,
		79,
		50,
		56,
		60,
		77,
		93,
		94,
		104,
		-1,
		-1,
		148,
		121,
		145,
		103,
		85,
		-1,
		51,
		53,
		59,
		63,
		68,
		76,
		81,
		66,
		-1,
		71,
		70,
		101,
		87,
		98,
		130,
		-1,
		-1,
		106,
		98,
		80,
		83,
		60,
		56,
		68,
		67,
		63,
		65,
		67,
		79,
		74,
		87,
		94,
		65,
		75,
		79,
		94,
		105,
		-1,
		-1,
		179,
		-1,
		-1,
		127,
		110,
		-1,
		75,
		82,
		66,
		72,
		58,
		79,
		78,
		72,
		79,
		82,
		70,
		87,
		84,
		101,
		87,
		62,
		87,
		91,
		97,
		115,
		116,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		82,
		79,
		72,
		96,
		95,
		-1,
		101,
		99,
		105,
		90,
		95,
		91,
		76,
		92,
		87,
		87,
		84,
		69,
		71,
		108,
		99,
		120,
		117,
		148,
		154,
		148,
		157,
		-1,
		135,
		131,
		127,
		134,
		83,
		-1,
		-1,
		100,
		-1,
		103,
		116,
		113,
		101,
		104,
		91,
		99,
		98,
		82,
		98,
		85,
		82,
		81,
		77,
		86,
		96,
		95,
		113,
		126,
		141,
		145,
		151,
		-1,
		185,
		-1,
		127,
		111,
		113,
		89,
		117,
		-1,
		120,
		104,
		124,
		115,
		115,
		-1,
		107,
		104,
		114,
		97,
		82,
		97,
		85,
		80,
		80,
		84,
		99,
		90,
		108,
		115,
		123,
		127,
		147,
		159,
		145,
		135,
		-1,
		117,
		122,
		92,
		104,
		127,
		147,
		131,
		-1,
		126,
		-1,
		109,
		122,
		-1,
		103,
		99,
		88,
		93,
		82,
		89,
		87,
		81,
		78,
		96,
		99,
		116,
		120,
		136,
		-1,
		-1,
		130,
		134,
		142,
		93,
		112,
		136,
		173,
		140,
		133,
		132,
		-1,
		127,
		124,
		121,
		122,
		108,
		101,
		102,
		88,
		94,
		95,
		80,
		83,
		105,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		119,
		90,
		114,
		156,
		162,
		155,
		143,
		158,
		158,
		151,
		-1,
		139,
		118,
		115,
		105,
		95,
		111,
		101,
		104,
		84,
		86,
		102,
		114,
		105,
		125,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		93,
		127,
		145,
		191,
		177,
		182,
		157,
		150,
		144,
		133,
		135,
		123,
		112,
		104,
		93,
		102,
		112,
		106,
		86,
		95,
		96,
		120,
		127,
		133,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		118,
		125,
		157,
		182,
		195,
		-1,
		149,
		-1,
		138,
		133,
		117,
		112,
		109,
		106,
		100,
		109,
		114,
		100,
		91,
		106,
		125,
		125,
		117,
		142,
		145,
		-1,
		-1,
		-1,
		149,
		166,
		141,
		118,
		99,
		135,
		-1,
		165,
		166,
		-1,
		143,
		137,
		134,
		119,
		115,
		110,
		114,
		107,
		114,
		110,
		109,
		110,
		92,
		128,
		-1,
		125,
		119,
		147,
		150,
		140,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		106,
		158,
		-1,
		-1,
		150,
		143,
		-1,
		130,
		112,
		119,
		117,
		111,
		115,
		119,
		108,
		121,
		117,
		97,
		107,
		127,
		131,
		138,
		131,
		136,
		135,
		149,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		126,
		-1,
		159,
		151,
		141,
		135,
		129,
		125,
		123,
		139,
		123,
		126,
		126,
		122,
		130,
		115,
		114,
		100,
		104,
		122,
		149,
		144,
		139,
		138,
		145,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		141,
		-1,
		112,
		136,
		152,
		-1,
		167,
		146,
		161,
		139,
		135,
		131,
		146,
		147,
		125,
		130,
		129,
		139,
		136,
		125,
		112,
		116,
		131,
		141,
		133,
		134,
		143,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		115,
		128,
		139,
		-1,
		-1,
		203,
		-1,
		137,
		154,
		145,
		143,
		136,
		127,
		133,
		140,
		143,
		140,
		130,
		119,
		125,
		121,
		143,
		129,
		127,
		146,
		161,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		181,
		171,
		155,
		140,
		173,
		-1,
		144,
		128,
		133,
		-1,
		165,
		-1,
		138,
		138,
		129,
		118,
		115,
		126,
		124,
		135,
		152,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		172,
		-1,
		-1,
		168,
		162,
		162,
		146,
		149,
		160,
		140,
		134,
		133,
		160,
		155,
		146,
		127,
		120,
		117,
		118,
		131,
		151,
		142,
		154,
		-1,
		-1,
		-1,
		173,
		153,
		159,
		117,
		138,
		-1,
		-1,
		230,
		185,
		171,
		-1,
		155,
		177,
		165,
		155,
		145,
		179,
		171,
		146,
		139,
		125,
		127,
		125,
		127,
		132,
		153,
		154,
		167,
		-1,
		-1,
		150,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		177,
		193,
		185,
		156,
		166,
		-1,
		-1,
		157,
		155,
		163,
		142,
		129,
		149,
		152,
		142,
		126,
		141,
		153,
		161,
		166,
		-1,
		153,
		140,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		188,
		183,
		187,
		160,
		-1,
		159,
		153,
		133,
		147,
		154,
		144,
		139,
		133,
		136,
		154,
		171,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		167,
		181,
		176,
		169,
		173,
		-1,
		161,
		149,
		135,
		152,
		157,
		154,
		145,
		137,
		142,
		139,
		152,
		166,
		170,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		185,
		200,
		215,
		192,
		165,
		160,
		153,
		147,
		143,
		159,
		165,
		176,
		144,
		140,
		141,
		145,
		144,
		161,
		171,
		-1,
		-1,
		173,
		190,
		211,
		193,
		197,
		242,
		-1,
		-1,
		169,
		160,
		151,
		154,
		153,
		156,
		150,
		147,
		152,
		157,
		145,
		154,
		172,
		171,
		-1,
		-1,
		-1,
		193,
		-1,
		208,
		-1,
		-1,
		212,
		240,
		187,
		169,
		165,
		163,
		156,
		165,
		160,
		155,
		165,
		167,
		159,
		147,
		151,
		174,
		163,
		202,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		222,
		197,
		212,
		251,
		232,
		239,
		202,
		199,
		-1,
		169,
		194,
		166,
		173,
		164,
		171,
		171,
		163,
		141,
		148,
		164,
		163,
		158,
		194,
		185,
		191,
		-1,
		-1,
		303,
		292,
		281,
		287,
		-1,
		228,
		214,
		237,
		227,
		230,
		-1,
		-1,
		218,
		215,
		191,
		174,
		172,
		165,
		160,
		170,
		150,
		137,
		141,
		145,
		151,
		156,
		161,
		167,
		182,
		197,
		-1,
		198,
		279,
		272,
		255,
		263,
		294,
		-1,
		231,
		233,
		221,
		219,
		221,
		-1,
		-1,
		191,
		188,
		193,
		181,
		178,
		180,
		175,
		166,
		151,
		157,
		144,
		143,
		161,
		165,
		174,
		181,
		171,
		184,
		188,
		-1,
		212,
		255,
		249,
		252,
		276,
		290,
		-1,
		238,
		-1,
		-1,
		229,
		222,
		206,
		196,
		190,
		240,
		195,
		190,
		174,
		172,
		163,
		154,
		161,
		152,
		152,
		155,
		170,
		175,
		167,
		181,
		181,
		182,
		-1,
		247,
		235,
		243,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		245,
		-1,
		233,
		-1,
		208,
		212,
		203,
		206,
		188,
		175,
		167,
		159,
		175,
		150,
		160,
		156,
		157,
		166,
		177,
		189,
		188,
		189,
		309,
		265,
		243,
		234,
		281,
		296,
		300,
		-1,
		250,
		289,
		283,
		-1,
		254,
		-1,
		-1,
		-1,
		222,
		216,
		208,
		208,
		187,
		187,
		161,
		165,
		155,
		162,
		172,
		174,
		166,
		170,
		183,
		194,
		197,
		305,
		296,
		309,
		254,
		248,
		266,
		275,
		296,
		265,
		256,
		283,
		290,
		279,
		274,
		261,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		194,
		182,
		165,
		166,
		162,
		165,
		180,
		183,
		173,
		171,
		165,
		197,
		-1,
		298,
		297,
		286,
		283,
		259,
		250,
		245,
		267,
		-1,
		-1,
		267,
		284,
		278,
		282,
		298,
		323,
		-1,
		254,
		-1,
		-1,
		239,
		-1,
		-1,
		224,
		187,
		176,
		167,
		173,
		170,
		181,
		191,
		179,
		180,
		170,
		180,
		193,
		282,
		279,
		267,
		265,
		288,
		253,
		241,
		-1,
		254,
		252,
		258,
		265,
		282,
		312,
		-1,
		-1,
		270,
		250,
		-1,
		-1,
		222,
		220,
		209,
		-1,
		199,
		172,
		177,
		197,
		199,
		188,
		182,
		176,
		183,
		182,
		190,
		198,
		291,
		305,
		294,
		290,
		289,
		297,
		246,
		239,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		-1,
		260,
		256,
		-1,
		-1,
		217,
		210,
		198,
		186,
		176,
		186,
		190,
		194,
		186,
		179,
		174,
		185,
		177,
		181,
		198,
		-1,
		325,
		-1,
		277,
		253,
		267,
		282,
		290,
		-1,
		-1,
		-1,
		277,
		263,
		256,
		244,
		242,
		-1,
		251,
		235,
		216,
		-1,
		186,
		199,
		230,
		198,
		203,
		198,
		180,
		191,
		180,
		183,
		197,
		192,
		-1,
		-1,
		265,
		268,
		-1,
		-1,
		267,
		269,
		-1,
		268,
		257,
		242,
		234,
		-1,
		-1,
		223,
		219,
		-1,
		-1,
		187,
		212,
		201,
		209,
		204,
		184,
		190,
		193,
		182,
		186,
		198,
		-1,
		-1,
		272,
		273,
		274,
		-1,
		252,
		-1,
		270,
		-1,
		237,
		243,
		231,
		-1,
		-1,
		-1,
		225,
		188,
		209,
		219,
		213,
		211,
		202,
		188,
		195,
		193,
		189,
		200,
		-1,
		-1,
		-1,
		270,
		244,
		277,
		268,
		251,
		231,
		223,
		242,
		-1,
		212,
		-1,
		187,
		189,
		215,
		218,
		224,
		218,
		191,
		206,
		196,
		187,
		196,
		276,
		-1,
		246,
		279,
		243,
		237,
		213,
		217,
		233,
		-1,
		209,
		191,
		-1,
		219,
		209,
		240,
		225,
		206,
		193,
		200,
		200,
		193,
		-1,
		-1,
		-1,
		248,
		247,
		239,
		233,
		233,
		218,
		209,
		-1,
		221,
		203,
		182,
		199,
		199,
		190,
		198,
		230,
		226,
		213,
		213,
		205,
		-1,
		349,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		242,
		237,
		210,
		198,
		204,
		200,
		186,
		192,
		194,
		202,
		200,
		197,
		209,
		205,
		225,
		206,
		241,
		-1,
		344,
		-1,
		278,
		-1,
		-1,
		260,
		240,
		232,
		221,
		210,
		208,
		199,
		190,
		212,
		228,
		212,
		210,
		213,
		214,
		-1,
		333,
		332,
		-1,
		279,
		271,
		257,
		-1,
		250,
		-1,
		256,
		217,
		-1,
		219,
		199,
		-1,
		221,
		217,
		-1,
		-1,
		320,
		295,
		-1,
		-1,
		-1,
		280,
		260,
		251,
		235,
		-1,
		210,
		210,
		-1,
		-1,
		-1,
		305,
		304,
		-1,
		273,
		276,
		-1,
		266,
		257,
		265,
		212,
		216,
		-1,
		-1,
		-1,
		314,
		295,
		289,
		288,
		286,
		281,
		278,
		264,
		248,
		226,
		215,
		236,
		-1,
		-1,
		-1,
		286,
		278,
		271,
		-1,
		-1,
		273,
		256,
		237,
		235,
		-1,
		-1,
		-1,
		308,
		289,
		-1,
		-1,
		263,
		-1,
		-1,
		269,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		325,
		297,
		-1,
		-1,
		-1,
		259,
		255,
		256,
		-1,
		-1,
		-1,
		-1,
		319,
		320,
		343,
		307,
		-1,
		-1,
		-1,
		251,
		245,
		-1,
		-1,
		322,
		320,
		-1,
		-1,
		-1,
		279,
		263,
		-1,
		249,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		284,
		-1,
		284,
		259,
		266,
		-1,
		-1,
		-1,
		-1,
		297,
		289,
		297,
		-1,
		269,
		271,
		-1,
		319,
		-1,
		-1,
		312,
		303,
		-1,
		-1,
		274,
		281,
		303,
		306,
		342,
		-1,
		293
	],
	[
		-1,
		54,
		47,
		58,
		71,
		39,
		36,
		-1,
		99,
		74,
		47,
		41,
		0,
		50,
		61,
		88,
		-1,
		-1,
		-1,
		57,
		56,
		42,
		46,
		56,
		71,
		78,
		-1,
		129,
		-1,
		78,
		57,
		68,
		73,
		52,
		55,
		75,
		102,
		124,
		126,
		93,
		82,
		59,
		60,
		83,
		94,
		128,
		120,
		-1,
		66,
		63,
		85,
		98,
		113,
		116,
		-1,
		-1,
		67,
		77,
		83,
		98,
		117,
		120,
		-1,
		130,
		149,
		-1,
		-1,
		66,
		79,
		92,
		95,
		103,
		109,
		122,
		139,
		144,
		-1,
		-1,
		84,
		88,
		98,
		96,
		92,
		109,
		128,
		139,
		153,
		152,
		-1,
		78,
		96,
		105,
		103,
		101,
		85,
		89,
		107,
		138,
		144,
		147,
		-1,
		95,
		91,
		101,
		107,
		119,
		101,
		88,
		94,
		113,
		126,
		145,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		96,
		87,
		107,
		109,
		108,
		122,
		120,
		91,
		97,
		101,
		118,
		134,
		135,
		145,
		-1,
		-1,
		189,
		162,
		186,
		144,
		126,
		-1,
		92,
		94,
		100,
		104,
		109,
		117,
		122,
		107,
		-1,
		112,
		111,
		142,
		128,
		139,
		171,
		-1,
		-1,
		147,
		139,
		121,
		124,
		101,
		97,
		109,
		108,
		104,
		106,
		108,
		120,
		115,
		128,
		135,
		106,
		116,
		120,
		135,
		146,
		-1,
		-1,
		220,
		-1,
		-1,
		168,
		151,
		-1,
		116,
		123,
		107,
		113,
		99,
		120,
		119,
		113,
		120,
		123,
		111,
		128,
		125,
		142,
		128,
		103,
		128,
		132,
		138,
		156,
		157,
		-1,
		219,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		123,
		120,
		113,
		137,
		136,
		-1,
		142,
		140,
		146,
		131,
		136,
		132,
		117,
		133,
		128,
		128,
		125,
		110,
		112,
		149,
		140,
		161,
		158,
		189,
		195,
		189,
		198,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		141,
		-1,
		144,
		157,
		154,
		142,
		145,
		132,
		140,
		139,
		123,
		139,
		126,
		123,
		122,
		118,
		127,
		137,
		136,
		154,
		167,
		182,
		186,
		192,
		-1,
		226,
		-1,
		168,
		152,
		154,
		130,
		158,
		-1,
		161,
		145,
		165,
		156,
		156,
		-1,
		148,
		145,
		155,
		138,
		123,
		138,
		126,
		121,
		121,
		125,
		140,
		131,
		149,
		156,
		164,
		168,
		188,
		200,
		186,
		176,
		-1,
		158,
		163,
		133,
		145,
		168,
		188,
		172,
		-1,
		167,
		-1,
		150,
		163,
		-1,
		144,
		140,
		129,
		134,
		123,
		130,
		128,
		122,
		119,
		137,
		140,
		157,
		161,
		177,
		-1,
		-1,
		171,
		175,
		183,
		134,
		153,
		177,
		214,
		181,
		174,
		173,
		-1,
		168,
		165,
		162,
		163,
		149,
		142,
		143,
		129,
		135,
		136,
		121,
		124,
		146,
		174,
		152,
		164,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		160,
		131,
		155,
		197,
		203,
		196,
		184,
		199,
		199,
		192,
		-1,
		180,
		159,
		156,
		146,
		136,
		152,
		142,
		145,
		125,
		127,
		143,
		155,
		146,
		166,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		134,
		168,
		186,
		232,
		218,
		223,
		198,
		191,
		185,
		174,
		176,
		164,
		153,
		145,
		134,
		143,
		153,
		147,
		127,
		136,
		137,
		161,
		168,
		174,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		159,
		166,
		198,
		223,
		236,
		-1,
		190,
		-1,
		179,
		174,
		158,
		153,
		150,
		147,
		141,
		150,
		155,
		141,
		132,
		147,
		166,
		166,
		158,
		183,
		186,
		-1,
		-1,
		-1,
		190,
		207,
		182,
		159,
		140,
		176,
		-1,
		206,
		207,
		-1,
		184,
		178,
		175,
		160,
		156,
		151,
		155,
		148,
		155,
		151,
		150,
		151,
		133,
		169,
		-1,
		166,
		160,
		188,
		191,
		181,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		147,
		199,
		-1,
		-1,
		191,
		184,
		-1,
		171,
		153,
		160,
		158,
		152,
		156,
		160,
		149,
		162,
		158,
		138,
		148,
		168,
		172,
		179,
		172,
		177,
		176,
		190,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		167,
		-1,
		200,
		192,
		182,
		176,
		170,
		166,
		164,
		180,
		164,
		167,
		167,
		163,
		171,
		156,
		155,
		141,
		145,
		163,
		190,
		185,
		180,
		179,
		186,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		182,
		-1,
		153,
		177,
		193,
		-1,
		208,
		187,
		202,
		180,
		176,
		172,
		187,
		188,
		166,
		171,
		170,
		180,
		177,
		166,
		153,
		157,
		172,
		182,
		174,
		175,
		184,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		156,
		169,
		180,
		-1,
		-1,
		244,
		-1,
		178,
		195,
		186,
		184,
		177,
		168,
		174,
		181,
		184,
		181,
		171,
		160,
		166,
		162,
		184,
		170,
		168,
		187,
		202,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		222,
		212,
		196,
		181,
		214,
		-1,
		185,
		169,
		174,
		-1,
		206,
		-1,
		179,
		179,
		170,
		159,
		156,
		167,
		165,
		176,
		193,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		213,
		-1,
		-1,
		209,
		203,
		203,
		187,
		190,
		201,
		181,
		175,
		174,
		201,
		196,
		187,
		168,
		161,
		158,
		159,
		172,
		192,
		183,
		195,
		-1,
		-1,
		-1,
		214,
		194,
		200,
		158,
		179,
		-1,
		-1,
		271,
		226,
		212,
		-1,
		196,
		218,
		206,
		196,
		186,
		220,
		212,
		187,
		180,
		166,
		168,
		166,
		168,
		173,
		194,
		195,
		208,
		-1,
		-1,
		191,
		198,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		218,
		234,
		226,
		197,
		207,
		-1,
		-1,
		198,
		196,
		204,
		183,
		170,
		190,
		193,
		183,
		167,
		182,
		194,
		202,
		207,
		-1,
		194,
		181,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		-1,
		-1,
		251,
		217,
		229,
		224,
		228,
		201,
		-1,
		200,
		194,
		174,
		188,
		195,
		185,
		180,
		174,
		177,
		195,
		212,
		-1,
		-1,
		208,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		208,
		222,
		217,
		210,
		214,
		-1,
		202,
		190,
		176,
		193,
		198,
		195,
		186,
		178,
		183,
		180,
		193,
		207,
		211,
		231,
		-1,
		214,
		-1,
		-1,
		-1,
		226,
		241,
		256,
		233,
		206,
		201,
		194,
		188,
		184,
		200,
		206,
		217,
		185,
		181,
		182,
		186,
		185,
		202,
		212,
		-1,
		-1,
		214,
		231,
		252,
		234,
		238,
		283,
		-1,
		-1,
		210,
		201,
		192,
		195,
		194,
		197,
		191,
		188,
		193,
		198,
		186,
		195,
		213,
		212,
		-1,
		-1,
		-1,
		234,
		-1,
		249,
		-1,
		-1,
		253,
		281,
		228,
		210,
		206,
		204,
		197,
		206,
		201,
		196,
		206,
		208,
		200,
		188,
		192,
		215,
		204,
		243,
		-1,
		-1,
		351,
		-1,
		-1,
		-1,
		263,
		238,
		253,
		292,
		273,
		280,
		243,
		240,
		-1,
		210,
		235,
		207,
		214,
		205,
		212,
		212,
		204,
		182,
		189,
		205,
		204,
		199,
		235,
		226,
		232,
		-1,
		-1,
		344,
		333,
		322,
		328,
		-1,
		269,
		255,
		278,
		268,
		271,
		-1,
		-1,
		259,
		256,
		232,
		215,
		213,
		206,
		201,
		211,
		191,
		178,
		182,
		186,
		192,
		197,
		202,
		208,
		223,
		238,
		-1,
		239,
		320,
		313,
		296,
		304,
		335,
		-1,
		272,
		274,
		262,
		260,
		262,
		-1,
		-1,
		232,
		229,
		234,
		222,
		219,
		221,
		216,
		207,
		192,
		198,
		185,
		184,
		202,
		206,
		215,
		222,
		212,
		225,
		229,
		-1,
		253,
		296,
		290,
		293,
		317,
		331,
		-1,
		279,
		-1,
		-1,
		270,
		263,
		247,
		237,
		231,
		281,
		236,
		231,
		215,
		213,
		204,
		195,
		202,
		193,
		193,
		196,
		211,
		216,
		208,
		222,
		222,
		223,
		-1,
		288,
		276,
		284,
		-1,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		286,
		-1,
		274,
		-1,
		249,
		253,
		244,
		247,
		229,
		216,
		208,
		200,
		216,
		191,
		201,
		197,
		198,
		207,
		218,
		230,
		229,
		230,
		350,
		306,
		284,
		275,
		322,
		337,
		341,
		-1,
		291,
		330,
		324,
		-1,
		295,
		-1,
		-1,
		-1,
		263,
		257,
		249,
		249,
		228,
		228,
		202,
		206,
		196,
		203,
		213,
		215,
		207,
		211,
		224,
		235,
		238,
		346,
		337,
		350,
		295,
		289,
		307,
		316,
		337,
		306,
		297,
		324,
		331,
		320,
		315,
		302,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		235,
		223,
		206,
		207,
		203,
		206,
		221,
		224,
		214,
		212,
		206,
		238,
		-1,
		339,
		338,
		327,
		324,
		300,
		291,
		286,
		308,
		-1,
		-1,
		308,
		325,
		319,
		323,
		339,
		364,
		-1,
		295,
		-1,
		-1,
		280,
		-1,
		-1,
		265,
		228,
		217,
		208,
		214,
		211,
		222,
		232,
		220,
		221,
		211,
		221,
		234,
		323,
		320,
		308,
		306,
		329,
		294,
		282,
		-1,
		295,
		293,
		299,
		306,
		323,
		353,
		-1,
		-1,
		311,
		291,
		-1,
		-1,
		263,
		261,
		250,
		-1,
		240,
		213,
		218,
		238,
		240,
		229,
		223,
		217,
		224,
		223,
		231,
		239,
		332,
		346,
		335,
		331,
		330,
		338,
		287,
		280,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		-1,
		301,
		297,
		-1,
		-1,
		258,
		251,
		239,
		227,
		217,
		227,
		231,
		235,
		227,
		220,
		215,
		226,
		218,
		222,
		239,
		-1,
		366,
		-1,
		318,
		294,
		308,
		323,
		331,
		-1,
		-1,
		-1,
		318,
		304,
		297,
		285,
		283,
		-1,
		292,
		276,
		257,
		-1,
		227,
		240,
		271,
		239,
		244,
		239,
		221,
		232,
		221,
		224,
		238,
		233,
		-1,
		-1,
		306,
		309,
		-1,
		-1,
		308,
		310,
		-1,
		309,
		298,
		283,
		275,
		-1,
		-1,
		264,
		260,
		-1,
		-1,
		228,
		253,
		242,
		250,
		245,
		225,
		231,
		234,
		223,
		227,
		239,
		-1,
		-1,
		313,
		314,
		315,
		-1,
		293,
		-1,
		311,
		-1,
		278,
		284,
		272,
		-1,
		-1,
		-1,
		266,
		229,
		250,
		260,
		254,
		252,
		243,
		229,
		236,
		234,
		230,
		241,
		-1,
		-1,
		-1,
		311,
		285,
		318,
		309,
		292,
		272,
		264,
		283,
		-1,
		253,
		-1,
		228,
		230,
		256,
		259,
		265,
		259,
		232,
		247,
		237,
		228,
		237,
		317,
		-1,
		287,
		320,
		284,
		278,
		254,
		258,
		274,
		-1,
		250,
		232,
		-1,
		260,
		250,
		281,
		266,
		247,
		234,
		241,
		241,
		234,
		-1,
		-1,
		-1,
		289,
		288,
		280,
		274,
		274,
		259,
		250,
		-1,
		262,
		244,
		223,
		240,
		240,
		231,
		239,
		271,
		267,
		254,
		254,
		246,
		-1,
		390,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		283,
		278,
		251,
		239,
		245,
		241,
		227,
		233,
		235,
		243,
		241,
		238,
		250,
		246,
		266,
		247,
		282,
		-1,
		385,
		-1,
		319,
		-1,
		-1,
		301,
		281,
		273,
		262,
		251,
		249,
		240,
		231,
		253,
		269,
		253,
		251,
		254,
		255,
		-1,
		374,
		373,
		-1,
		320,
		312,
		298,
		-1,
		291,
		-1,
		297,
		258,
		-1,
		260,
		240,
		-1,
		262,
		258,
		-1,
		-1,
		361,
		336,
		-1,
		-1,
		-1,
		321,
		301,
		292,
		276,
		-1,
		251,
		251,
		-1,
		-1,
		-1,
		346,
		345,
		-1,
		314,
		317,
		-1,
		307,
		298,
		306,
		253,
		257,
		-1,
		-1,
		-1,
		355,
		336,
		330,
		329,
		327,
		322,
		319,
		305,
		289,
		267,
		256,
		277,
		-1,
		-1,
		-1,
		327,
		319,
		312,
		-1,
		-1,
		314,
		297,
		278,
		276,
		-1,
		-1,
		-1,
		349,
		330,
		-1,
		-1,
		304,
		-1,
		-1,
		310,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		366,
		338,
		-1,
		-1,
		-1,
		300,
		296,
		297,
		-1,
		-1,
		-1,
		-1,
		360,
		361,
		384,
		348,
		-1,
		-1,
		-1,
		292,
		286,
		-1,
		-1,
		363,
		361,
		-1,
		-1,
		-1,
		320,
		304,
		-1,
		290,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		323,
		-1,
		-1,
		-1,
		325,
		-1,
		325,
		300,
		307,
		-1,
		-1,
		-1,
		-1,
		338,
		330,
		338,
		-1,
		310,
		312,
		-1,
		360,
		-1,
		-1,
		353,
		344,
		-1,
		-1,
		315,
		322,
		344,
		347,
		383,
		-1,
		334
	],
	[
		-1,
		50,
		39,
		50,
		58,
		31,
		38,
		-1,
		66,
		61,
		27,
		21,
		52,
		0,
		27,
		55,
		-1,
		-1,
		-1,
		50,
		49,
		14,
		13,
		20,
		38,
		45,
		-1,
		96,
		-1,
		71,
		50,
		61,
		66,
		19,
		22,
		42,
		69,
		91,
		93,
		86,
		49,
		26,
		27,
		50,
		61,
		95,
		88,
		-1,
		33,
		30,
		52,
		66,
		81,
		85,
		-1,
		-1,
		34,
		44,
		51,
		66,
		85,
		91,
		-1,
		101,
		120,
		-1,
		-1,
		34,
		47,
		60,
		63,
		71,
		80,
		93,
		110,
		115,
		-1,
		-1,
		52,
		56,
		66,
		67,
		63,
		80,
		99,
		110,
		124,
		123,
		-1,
		54,
		72,
		81,
		74,
		72,
		56,
		60,
		78,
		109,
		115,
		118,
		-1,
		71,
		67,
		77,
		83,
		94,
		72,
		59,
		65,
		84,
		97,
		116,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		72,
		63,
		83,
		85,
		84,
		93,
		91,
		62,
		68,
		72,
		89,
		105,
		106,
		116,
		-1,
		-1,
		165,
		138,
		162,
		120,
		102,
		-1,
		68,
		70,
		76,
		80,
		85,
		93,
		93,
		78,
		-1,
		83,
		82,
		113,
		99,
		110,
		147,
		-1,
		-1,
		123,
		115,
		97,
		100,
		77,
		73,
		85,
		84,
		80,
		82,
		84,
		96,
		86,
		99,
		106,
		77,
		87,
		91,
		106,
		117,
		-1,
		-1,
		191,
		-1,
		-1,
		144,
		127,
		-1,
		92,
		99,
		83,
		89,
		75,
		96,
		95,
		89,
		96,
		99,
		87,
		99,
		96,
		113,
		99,
		74,
		99,
		103,
		109,
		127,
		128,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		99,
		96,
		89,
		113,
		112,
		-1,
		118,
		116,
		122,
		107,
		112,
		108,
		93,
		104,
		99,
		99,
		96,
		81,
		83,
		120,
		111,
		132,
		129,
		160,
		166,
		160,
		169,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		117,
		-1,
		120,
		133,
		130,
		118,
		121,
		108,
		116,
		115,
		99,
		110,
		97,
		94,
		93,
		89,
		98,
		108,
		107,
		125,
		138,
		153,
		157,
		163,
		-1,
		202,
		-1,
		144,
		128,
		130,
		106,
		134,
		-1,
		137,
		121,
		141,
		132,
		132,
		-1,
		124,
		121,
		131,
		114,
		99,
		109,
		97,
		92,
		92,
		96,
		111,
		102,
		120,
		127,
		135,
		139,
		159,
		171,
		162,
		152,
		-1,
		134,
		139,
		109,
		121,
		144,
		164,
		148,
		-1,
		143,
		-1,
		126,
		139,
		-1,
		120,
		116,
		105,
		105,
		94,
		101,
		99,
		93,
		90,
		108,
		111,
		128,
		132,
		148,
		-1,
		-1,
		147,
		151,
		159,
		110,
		129,
		153,
		190,
		157,
		150,
		149,
		-1,
		144,
		141,
		138,
		139,
		125,
		118,
		117,
		100,
		106,
		107,
		92,
		95,
		117,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		136,
		107,
		131,
		173,
		179,
		172,
		160,
		170,
		170,
		164,
		-1,
		156,
		135,
		128,
		117,
		107,
		123,
		113,
		116,
		96,
		98,
		114,
		126,
		117,
		137,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		110,
		144,
		162,
		203,
		189,
		194,
		169,
		162,
		156,
		150,
		152,
		135,
		124,
		116,
		105,
		114,
		124,
		118,
		98,
		107,
		108,
		132,
		139,
		145,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		135,
		142,
		174,
		194,
		207,
		-1,
		161,
		-1,
		150,
		145,
		129,
		124,
		121,
		118,
		112,
		121,
		126,
		112,
		103,
		118,
		137,
		137,
		129,
		154,
		157,
		-1,
		-1,
		-1,
		166,
		183,
		158,
		135,
		116,
		152,
		-1,
		177,
		178,
		-1,
		155,
		149,
		146,
		131,
		127,
		122,
		126,
		119,
		126,
		122,
		121,
		122,
		104,
		140,
		-1,
		137,
		131,
		159,
		162,
		152,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		123,
		175,
		-1,
		-1,
		162,
		155,
		-1,
		142,
		124,
		131,
		129,
		123,
		127,
		131,
		120,
		133,
		129,
		109,
		119,
		139,
		143,
		150,
		143,
		148,
		147,
		161,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		143,
		-1,
		171,
		163,
		153,
		147,
		141,
		137,
		135,
		151,
		135,
		138,
		138,
		134,
		142,
		127,
		126,
		112,
		116,
		134,
		161,
		156,
		151,
		150,
		157,
		-1,
		229,
		215,
		186,
		-1,
		-1,
		158,
		-1,
		129,
		153,
		169,
		-1,
		179,
		158,
		173,
		151,
		147,
		143,
		158,
		159,
		137,
		142,
		141,
		151,
		148,
		137,
		124,
		128,
		143,
		153,
		145,
		146,
		155,
		-1,
		235,
		222,
		180,
		176,
		165,
		185,
		132,
		141,
		156,
		-1,
		-1,
		215,
		-1,
		149,
		166,
		157,
		155,
		148,
		139,
		145,
		152,
		155,
		152,
		142,
		131,
		137,
		133,
		155,
		141,
		139,
		158,
		173,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		151,
		138,
		132,
		-1,
		173,
		-1,
		193,
		183,
		167,
		152,
		185,
		-1,
		156,
		140,
		145,
		-1,
		177,
		-1,
		150,
		150,
		141,
		130,
		127,
		138,
		136,
		147,
		164,
		-1,
		185,
		170,
		163,
		153,
		167,
		138,
		-1,
		189,
		-1,
		-1,
		180,
		174,
		174,
		158,
		161,
		172,
		152,
		146,
		145,
		172,
		167,
		158,
		139,
		132,
		129,
		130,
		143,
		163,
		154,
		166,
		-1,
		-1,
		-1,
		190,
		170,
		176,
		134,
		155,
		-1,
		-1,
		242,
		197,
		183,
		-1,
		167,
		189,
		177,
		167,
		157,
		191,
		183,
		158,
		151,
		137,
		139,
		137,
		139,
		144,
		165,
		166,
		179,
		-1,
		-1,
		167,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		189,
		205,
		197,
		168,
		178,
		-1,
		-1,
		169,
		167,
		175,
		154,
		141,
		161,
		164,
		154,
		138,
		153,
		165,
		173,
		178,
		-1,
		170,
		157,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		222,
		188,
		200,
		195,
		199,
		172,
		-1,
		171,
		165,
		145,
		159,
		166,
		156,
		151,
		145,
		148,
		166,
		183,
		-1,
		-1,
		184,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		179,
		193,
		188,
		181,
		185,
		-1,
		173,
		161,
		147,
		164,
		169,
		166,
		157,
		149,
		154,
		151,
		164,
		178,
		182,
		207,
		-1,
		190,
		-1,
		-1,
		-1,
		197,
		212,
		227,
		204,
		177,
		172,
		165,
		159,
		155,
		171,
		177,
		188,
		156,
		152,
		153,
		157,
		156,
		173,
		183,
		-1,
		-1,
		190,
		207,
		223,
		205,
		209,
		254,
		-1,
		-1,
		181,
		172,
		163,
		166,
		165,
		168,
		162,
		159,
		164,
		169,
		157,
		166,
		184,
		183,
		-1,
		-1,
		-1,
		210,
		-1,
		225,
		-1,
		-1,
		224,
		252,
		199,
		181,
		177,
		175,
		168,
		177,
		172,
		167,
		177,
		179,
		171,
		159,
		163,
		186,
		175,
		214,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		239,
		214,
		229,
		263,
		244,
		251,
		214,
		211,
		-1,
		181,
		206,
		178,
		185,
		176,
		183,
		183,
		175,
		153,
		160,
		176,
		175,
		170,
		206,
		197,
		203,
		-1,
		-1,
		320,
		309,
		298,
		304,
		-1,
		245,
		231,
		249,
		239,
		242,
		-1,
		-1,
		230,
		227,
		203,
		186,
		184,
		177,
		172,
		182,
		162,
		149,
		153,
		157,
		163,
		168,
		173,
		179,
		194,
		209,
		-1,
		215,
		296,
		289,
		272,
		280,
		311,
		-1,
		248,
		245,
		238,
		231,
		233,
		-1,
		-1,
		203,
		200,
		205,
		193,
		190,
		192,
		187,
		178,
		163,
		169,
		156,
		155,
		173,
		177,
		186,
		193,
		183,
		196,
		200,
		-1,
		229,
		272,
		266,
		269,
		293,
		307,
		-1,
		250,
		-1,
		-1,
		246,
		234,
		218,
		208,
		202,
		252,
		207,
		202,
		186,
		184,
		175,
		166,
		173,
		164,
		164,
		167,
		182,
		187,
		179,
		193,
		193,
		194,
		-1,
		264,
		252,
		260,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		262,
		-1,
		245,
		-1,
		220,
		224,
		215,
		218,
		200,
		187,
		179,
		171,
		187,
		162,
		172,
		168,
		169,
		178,
		189,
		201,
		200,
		201,
		321,
		277,
		260,
		251,
		298,
		313,
		317,
		-1,
		262,
		301,
		299,
		-1,
		271,
		-1,
		-1,
		-1,
		234,
		228,
		220,
		220,
		199,
		199,
		173,
		177,
		167,
		174,
		184,
		186,
		178,
		182,
		195,
		206,
		209,
		317,
		308,
		321,
		266,
		265,
		283,
		292,
		313,
		277,
		268,
		295,
		306,
		295,
		290,
		277,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		206,
		194,
		177,
		178,
		174,
		177,
		192,
		195,
		185,
		183,
		177,
		209,
		-1,
		310,
		309,
		298,
		295,
		271,
		262,
		257,
		284,
		-1,
		-1,
		279,
		296,
		290,
		294,
		310,
		335,
		-1,
		266,
		-1,
		-1,
		251,
		-1,
		-1,
		236,
		199,
		188,
		179,
		185,
		182,
		193,
		203,
		191,
		192,
		182,
		192,
		205,
		294,
		291,
		279,
		277,
		300,
		265,
		253,
		-1,
		266,
		264,
		270,
		277,
		294,
		324,
		-1,
		-1,
		282,
		262,
		-1,
		-1,
		234,
		232,
		221,
		-1,
		211,
		184,
		189,
		209,
		211,
		200,
		194,
		188,
		195,
		194,
		202,
		210,
		303,
		317,
		306,
		302,
		301,
		309,
		258,
		251,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		-1,
		272,
		268,
		-1,
		-1,
		229,
		222,
		210,
		198,
		188,
		198,
		202,
		206,
		198,
		191,
		186,
		197,
		189,
		193,
		210,
		-1,
		337,
		-1,
		289,
		265,
		279,
		294,
		302,
		-1,
		-1,
		-1,
		289,
		275,
		268,
		256,
		254,
		-1,
		263,
		247,
		228,
		-1,
		198,
		211,
		242,
		210,
		215,
		210,
		192,
		203,
		192,
		195,
		209,
		204,
		-1,
		-1,
		277,
		280,
		-1,
		-1,
		279,
		281,
		-1,
		280,
		269,
		254,
		246,
		-1,
		-1,
		235,
		231,
		-1,
		-1,
		199,
		224,
		213,
		221,
		216,
		196,
		202,
		205,
		194,
		198,
		210,
		-1,
		-1,
		284,
		285,
		286,
		-1,
		264,
		-1,
		282,
		-1,
		249,
		255,
		243,
		-1,
		-1,
		-1,
		237,
		200,
		221,
		231,
		225,
		223,
		214,
		200,
		207,
		205,
		201,
		212,
		-1,
		-1,
		-1,
		282,
		256,
		289,
		280,
		263,
		243,
		235,
		254,
		-1,
		224,
		-1,
		199,
		201,
		227,
		230,
		236,
		230,
		203,
		218,
		208,
		199,
		208,
		288,
		-1,
		258,
		291,
		255,
		249,
		225,
		229,
		245,
		-1,
		221,
		203,
		-1,
		231,
		221,
		252,
		237,
		218,
		205,
		212,
		212,
		205,
		-1,
		-1,
		-1,
		260,
		259,
		251,
		245,
		245,
		230,
		221,
		-1,
		233,
		215,
		194,
		211,
		211,
		202,
		210,
		242,
		238,
		225,
		225,
		217,
		-1,
		361,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		254,
		249,
		222,
		210,
		216,
		212,
		198,
		204,
		206,
		214,
		212,
		209,
		221,
		217,
		237,
		218,
		253,
		-1,
		356,
		-1,
		290,
		-1,
		-1,
		272,
		252,
		244,
		233,
		222,
		220,
		211,
		202,
		224,
		240,
		224,
		222,
		225,
		226,
		-1,
		345,
		344,
		-1,
		291,
		283,
		269,
		-1,
		262,
		-1,
		268,
		229,
		-1,
		231,
		211,
		-1,
		233,
		229,
		-1,
		-1,
		332,
		307,
		-1,
		-1,
		-1,
		292,
		272,
		263,
		247,
		-1,
		222,
		222,
		-1,
		-1,
		-1,
		317,
		316,
		-1,
		285,
		288,
		-1,
		278,
		269,
		277,
		224,
		228,
		-1,
		-1,
		-1,
		326,
		307,
		301,
		300,
		298,
		293,
		290,
		276,
		260,
		238,
		227,
		248,
		-1,
		-1,
		-1,
		298,
		290,
		283,
		-1,
		-1,
		285,
		268,
		249,
		247,
		-1,
		-1,
		-1,
		320,
		301,
		-1,
		-1,
		275,
		-1,
		-1,
		281,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		337,
		309,
		-1,
		-1,
		-1,
		271,
		267,
		268,
		-1,
		-1,
		-1,
		-1,
		331,
		332,
		355,
		319,
		-1,
		-1,
		-1,
		263,
		257,
		-1,
		-1,
		334,
		332,
		-1,
		-1,
		-1,
		291,
		275,
		-1,
		261,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		296,
		-1,
		296,
		271,
		278,
		-1,
		-1,
		-1,
		-1,
		309,
		301,
		309,
		-1,
		281,
		283,
		-1,
		331,
		-1,
		-1,
		324,
		315,
		-1,
		-1,
		286,
		293,
		315,
		318,
		354,
		-1,
		305
	],
	[
		-1,
		64,
		53,
		64,
		72,
		45,
		52,
		-1,
		69,
		75,
		41,
		35,
		54,
		39,
		0,
		58,
		-1,
		-1,
		-1,
		64,
		63,
		29,
		27,
		30,
		35,
		48,
		-1,
		95,
		-1,
		85,
		64,
		75,
		80,
		22,
		25,
		41,
		68,
		90,
		92,
		100,
		49,
		29,
		30,
		53,
		64,
		94,
		91,
		-1,
		36,
		33,
		55,
		69,
		84,
		88,
		-1,
		-1,
		37,
		47,
		54,
		69,
		88,
		94,
		-1,
		104,
		123,
		-1,
		-1,
		37,
		50,
		63,
		66,
		74,
		83,
		96,
		113,
		118,
		-1,
		-1,
		55,
		59,
		69,
		70,
		66,
		83,
		102,
		113,
		127,
		126,
		-1,
		57,
		75,
		84,
		77,
		75,
		59,
		63,
		81,
		112,
		118,
		121,
		-1,
		74,
		70,
		80,
		86,
		97,
		75,
		62,
		68,
		87,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		66,
		86,
		88,
		87,
		96,
		94,
		65,
		71,
		75,
		92,
		108,
		109,
		119,
		-1,
		-1,
		168,
		141,
		165,
		123,
		105,
		-1,
		71,
		73,
		79,
		83,
		88,
		96,
		96,
		81,
		-1,
		86,
		85,
		116,
		102,
		113,
		150,
		-1,
		-1,
		126,
		118,
		100,
		103,
		80,
		76,
		88,
		87,
		83,
		85,
		87,
		99,
		89,
		102,
		109,
		80,
		90,
		94,
		109,
		120,
		-1,
		-1,
		194,
		-1,
		-1,
		147,
		130,
		-1,
		95,
		102,
		86,
		92,
		78,
		99,
		98,
		92,
		99,
		102,
		90,
		102,
		99,
		116,
		102,
		77,
		102,
		106,
		112,
		130,
		131,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		102,
		99,
		92,
		116,
		115,
		-1,
		121,
		119,
		125,
		110,
		115,
		111,
		96,
		107,
		102,
		102,
		99,
		84,
		86,
		123,
		114,
		135,
		132,
		163,
		169,
		163,
		172,
		-1,
		155,
		151,
		147,
		154,
		103,
		-1,
		-1,
		120,
		-1,
		123,
		136,
		133,
		121,
		124,
		111,
		119,
		118,
		102,
		113,
		100,
		97,
		96,
		92,
		101,
		111,
		110,
		128,
		141,
		156,
		160,
		166,
		-1,
		205,
		-1,
		147,
		131,
		133,
		109,
		137,
		-1,
		140,
		124,
		144,
		135,
		135,
		-1,
		127,
		124,
		134,
		117,
		102,
		112,
		100,
		95,
		95,
		99,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		165,
		155,
		-1,
		137,
		142,
		112,
		124,
		147,
		167,
		151,
		-1,
		146,
		-1,
		129,
		142,
		-1,
		123,
		119,
		108,
		108,
		97,
		104,
		102,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		150,
		154,
		162,
		113,
		132,
		156,
		193,
		160,
		153,
		152,
		-1,
		147,
		144,
		141,
		142,
		128,
		121,
		120,
		103,
		109,
		110,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		139,
		110,
		134,
		176,
		182,
		175,
		163,
		173,
		173,
		167,
		-1,
		159,
		138,
		131,
		120,
		110,
		126,
		116,
		119,
		99,
		101,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		113,
		147,
		165,
		206,
		192,
		197,
		172,
		165,
		159,
		153,
		155,
		138,
		127,
		119,
		108,
		117,
		127,
		121,
		101,
		110,
		111,
		135,
		142,
		148,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		138,
		145,
		177,
		197,
		210,
		-1,
		164,
		-1,
		153,
		148,
		132,
		127,
		124,
		121,
		115,
		124,
		129,
		115,
		106,
		121,
		140,
		140,
		132,
		157,
		160,
		-1,
		-1,
		-1,
		169,
		186,
		161,
		138,
		119,
		155,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		134,
		130,
		125,
		129,
		122,
		129,
		125,
		124,
		125,
		107,
		143,
		-1,
		140,
		134,
		162,
		165,
		155,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		126,
		178,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		134,
		132,
		126,
		130,
		134,
		123,
		136,
		132,
		112,
		122,
		142,
		146,
		153,
		146,
		151,
		150,
		164,
		-1,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		146,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		154,
		138,
		141,
		141,
		137,
		145,
		130,
		129,
		115,
		119,
		137,
		164,
		159,
		154,
		153,
		160,
		-1,
		232,
		218,
		189,
		-1,
		-1,
		161,
		-1,
		132,
		156,
		172,
		-1,
		182,
		161,
		176,
		154,
		150,
		146,
		161,
		162,
		140,
		145,
		144,
		154,
		151,
		140,
		127,
		131,
		146,
		156,
		148,
		149,
		158,
		-1,
		238,
		225,
		183,
		179,
		168,
		188,
		135,
		144,
		159,
		-1,
		-1,
		218,
		-1,
		152,
		169,
		160,
		158,
		151,
		142,
		148,
		155,
		158,
		155,
		145,
		134,
		140,
		136,
		158,
		144,
		142,
		161,
		176,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		154,
		141,
		135,
		-1,
		176,
		-1,
		196,
		186,
		170,
		155,
		188,
		-1,
		159,
		143,
		148,
		-1,
		180,
		-1,
		153,
		153,
		144,
		133,
		130,
		141,
		139,
		150,
		167,
		-1,
		188,
		173,
		166,
		156,
		170,
		141,
		-1,
		192,
		-1,
		-1,
		183,
		177,
		177,
		161,
		164,
		175,
		155,
		149,
		148,
		175,
		170,
		161,
		142,
		135,
		132,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		193,
		173,
		179,
		137,
		158,
		-1,
		-1,
		245,
		200,
		186,
		-1,
		170,
		192,
		180,
		170,
		160,
		194,
		186,
		161,
		154,
		140,
		142,
		140,
		142,
		147,
		168,
		169,
		182,
		-1,
		-1,
		170,
		177,
		165,
		151,
		170,
		-1,
		-1,
		-1,
		192,
		208,
		200,
		171,
		181,
		-1,
		-1,
		172,
		170,
		178,
		157,
		144,
		164,
		167,
		157,
		141,
		156,
		168,
		176,
		181,
		-1,
		173,
		160,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		203,
		198,
		202,
		175,
		-1,
		174,
		168,
		148,
		162,
		169,
		159,
		154,
		148,
		151,
		169,
		186,
		-1,
		-1,
		187,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		182,
		196,
		191,
		184,
		188,
		-1,
		176,
		164,
		150,
		167,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		210,
		-1,
		193,
		-1,
		-1,
		-1,
		200,
		215,
		230,
		207,
		180,
		175,
		168,
		162,
		158,
		174,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		193,
		210,
		226,
		208,
		212,
		257,
		-1,
		-1,
		184,
		175,
		166,
		169,
		168,
		171,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		186,
		-1,
		-1,
		-1,
		213,
		-1,
		228,
		-1,
		-1,
		227,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		182,
		174,
		162,
		166,
		189,
		178,
		217,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		242,
		217,
		232,
		266,
		247,
		254,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		179,
		186,
		186,
		178,
		156,
		163,
		179,
		178,
		173,
		209,
		200,
		206,
		-1,
		-1,
		323,
		312,
		301,
		307,
		-1,
		248,
		234,
		252,
		242,
		245,
		-1,
		-1,
		233,
		230,
		206,
		189,
		187,
		180,
		175,
		185,
		165,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		218,
		299,
		292,
		275,
		283,
		314,
		-1,
		251,
		248,
		241,
		234,
		236,
		-1,
		-1,
		206,
		203,
		208,
		196,
		193,
		195,
		190,
		181,
		166,
		172,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		232,
		275,
		269,
		272,
		296,
		310,
		-1,
		253,
		-1,
		-1,
		249,
		237,
		221,
		211,
		205,
		255,
		210,
		205,
		189,
		187,
		178,
		169,
		176,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		267,
		255,
		263,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		265,
		-1,
		248,
		-1,
		223,
		227,
		218,
		221,
		203,
		190,
		182,
		174,
		190,
		165,
		175,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		324,
		280,
		263,
		254,
		301,
		316,
		320,
		-1,
		265,
		304,
		302,
		-1,
		274,
		-1,
		-1,
		-1,
		237,
		231,
		223,
		223,
		202,
		202,
		176,
		180,
		170,
		177,
		187,
		189,
		181,
		185,
		198,
		209,
		212,
		320,
		311,
		324,
		269,
		268,
		286,
		295,
		316,
		280,
		271,
		298,
		309,
		298,
		293,
		280,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		209,
		197,
		180,
		181,
		177,
		180,
		195,
		198,
		188,
		186,
		180,
		212,
		-1,
		313,
		312,
		301,
		298,
		274,
		265,
		260,
		287,
		-1,
		-1,
		282,
		299,
		293,
		297,
		313,
		338,
		-1,
		269,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		202,
		191,
		182,
		188,
		185,
		196,
		206,
		194,
		195,
		185,
		195,
		208,
		297,
		294,
		282,
		280,
		303,
		268,
		256,
		-1,
		269,
		267,
		273,
		280,
		297,
		327,
		-1,
		-1,
		285,
		265,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		187,
		192,
		212,
		214,
		203,
		197,
		191,
		198,
		197,
		205,
		213,
		306,
		320,
		309,
		305,
		304,
		312,
		261,
		254,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		-1,
		275,
		271,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		205,
		209,
		201,
		194,
		189,
		200,
		192,
		196,
		213,
		-1,
		340,
		-1,
		292,
		268,
		282,
		297,
		305,
		-1,
		-1,
		-1,
		292,
		278,
		271,
		259,
		257,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		245,
		213,
		218,
		213,
		195,
		206,
		195,
		198,
		212,
		207,
		-1,
		-1,
		280,
		283,
		-1,
		-1,
		282,
		284,
		-1,
		283,
		272,
		257,
		249,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		202,
		227,
		216,
		224,
		219,
		199,
		205,
		208,
		197,
		201,
		213,
		-1,
		-1,
		287,
		288,
		289,
		-1,
		267,
		-1,
		285,
		-1,
		252,
		258,
		246,
		-1,
		-1,
		-1,
		240,
		203,
		224,
		234,
		228,
		226,
		217,
		203,
		210,
		208,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		259,
		292,
		283,
		266,
		246,
		238,
		257,
		-1,
		227,
		-1,
		202,
		204,
		230,
		233,
		239,
		233,
		206,
		221,
		211,
		202,
		211,
		291,
		-1,
		261,
		294,
		258,
		252,
		228,
		232,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		255,
		240,
		221,
		208,
		215,
		215,
		208,
		-1,
		-1,
		-1,
		263,
		262,
		254,
		248,
		248,
		233,
		224,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		245,
		241,
		228,
		228,
		220,
		-1,
		364,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		257,
		252,
		225,
		213,
		219,
		215,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		221,
		256,
		-1,
		359,
		-1,
		293,
		-1,
		-1,
		275,
		255,
		247,
		236,
		225,
		223,
		214,
		205,
		227,
		243,
		227,
		225,
		228,
		229,
		-1,
		348,
		347,
		-1,
		294,
		286,
		272,
		-1,
		265,
		-1,
		271,
		232,
		-1,
		234,
		214,
		-1,
		236,
		232,
		-1,
		-1,
		335,
		310,
		-1,
		-1,
		-1,
		295,
		275,
		266,
		250,
		-1,
		225,
		225,
		-1,
		-1,
		-1,
		320,
		319,
		-1,
		288,
		291,
		-1,
		281,
		272,
		280,
		227,
		231,
		-1,
		-1,
		-1,
		329,
		310,
		304,
		303,
		301,
		296,
		293,
		279,
		263,
		241,
		230,
		251,
		-1,
		-1,
		-1,
		301,
		293,
		286,
		-1,
		-1,
		288,
		271,
		252,
		250,
		-1,
		-1,
		-1,
		323,
		304,
		-1,
		-1,
		278,
		-1,
		-1,
		284,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		312,
		-1,
		-1,
		-1,
		274,
		270,
		271,
		-1,
		-1,
		-1,
		-1,
		334,
		335,
		358,
		322,
		-1,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		337,
		335,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		264,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		299,
		-1,
		299,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		312,
		-1,
		284,
		286,
		-1,
		334,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		289,
		296,
		318,
		321,
		357,
		-1,
		308
	],
	[
		-1,
		80,
		69,
		80,
		88,
		61,
		68,
		-1,
		11,
		91,
		57,
		51,
		88,
		57,
		63,
		0,
		-1,
		-1,
		-1,
		80,
		79,
		45,
		43,
		52,
		57,
		11,
		-1,
		115,
		-1,
		101,
		80,
		91,
		96,
		38,
		41,
		61,
		88,
		110,
		112,
		116,
		68,
		45,
		46,
		69,
		80,
		114,
		107,
		-1,
		52,
		49,
		71,
		85,
		100,
		104,
		-1,
		-1,
		53,
		63,
		70,
		85,
		104,
		110,
		-1,
		120,
		139,
		-1,
		-1,
		53,
		66,
		79,
		82,
		90,
		99,
		112,
		129,
		134,
		-1,
		-1,
		71,
		75,
		85,
		86,
		82,
		99,
		118,
		129,
		143,
		142,
		-1,
		73,
		91,
		100,
		93,
		91,
		75,
		79,
		97,
		128,
		134,
		137,
		-1,
		90,
		86,
		96,
		102,
		113,
		91,
		78,
		84,
		103,
		116,
		135,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		91,
		82,
		102,
		104,
		103,
		112,
		110,
		81,
		87,
		91,
		108,
		124,
		125,
		135,
		-1,
		-1,
		184,
		157,
		181,
		139,
		121,
		-1,
		87,
		89,
		95,
		99,
		104,
		112,
		112,
		97,
		-1,
		102,
		101,
		132,
		118,
		129,
		166,
		-1,
		-1,
		142,
		134,
		116,
		119,
		96,
		92,
		104,
		103,
		99,
		101,
		103,
		115,
		105,
		118,
		125,
		96,
		106,
		110,
		125,
		136,
		-1,
		-1,
		210,
		-1,
		-1,
		163,
		146,
		-1,
		111,
		118,
		102,
		108,
		94,
		115,
		114,
		108,
		115,
		118,
		106,
		118,
		115,
		132,
		118,
		93,
		118,
		122,
		128,
		146,
		147,
		-1,
		209,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		118,
		115,
		108,
		132,
		131,
		-1,
		137,
		135,
		141,
		126,
		131,
		127,
		112,
		123,
		118,
		118,
		115,
		100,
		102,
		139,
		130,
		151,
		148,
		179,
		185,
		179,
		188,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		136,
		-1,
		139,
		152,
		149,
		137,
		140,
		127,
		135,
		134,
		118,
		129,
		116,
		113,
		112,
		108,
		117,
		127,
		126,
		144,
		157,
		172,
		176,
		182,
		-1,
		221,
		-1,
		163,
		147,
		149,
		125,
		153,
		-1,
		156,
		140,
		160,
		151,
		151,
		-1,
		143,
		140,
		150,
		133,
		118,
		128,
		116,
		111,
		111,
		115,
		130,
		121,
		139,
		146,
		154,
		158,
		178,
		190,
		181,
		171,
		-1,
		153,
		158,
		128,
		140,
		163,
		183,
		167,
		-1,
		162,
		-1,
		145,
		158,
		-1,
		139,
		135,
		124,
		124,
		113,
		120,
		118,
		112,
		109,
		127,
		130,
		147,
		151,
		167,
		-1,
		-1,
		166,
		170,
		178,
		129,
		148,
		172,
		209,
		176,
		169,
		168,
		-1,
		163,
		160,
		157,
		158,
		144,
		137,
		136,
		119,
		125,
		126,
		111,
		114,
		136,
		164,
		142,
		154,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		155,
		126,
		150,
		192,
		198,
		191,
		179,
		189,
		189,
		183,
		-1,
		175,
		154,
		147,
		136,
		126,
		142,
		132,
		135,
		115,
		117,
		133,
		145,
		136,
		156,
		-1,
		-1,
		-1,
		185,
		174,
		175,
		129,
		163,
		181,
		222,
		208,
		213,
		188,
		181,
		175,
		169,
		171,
		154,
		143,
		135,
		124,
		133,
		143,
		137,
		117,
		126,
		127,
		151,
		158,
		164,
		-1,
		-1,
		192,
		182,
		166,
		168,
		165,
		154,
		161,
		193,
		213,
		226,
		-1,
		180,
		-1,
		169,
		164,
		148,
		143,
		140,
		137,
		131,
		140,
		145,
		131,
		122,
		137,
		156,
		156,
		148,
		173,
		176,
		-1,
		-1,
		-1,
		185,
		202,
		177,
		154,
		135,
		171,
		-1,
		196,
		197,
		-1,
		174,
		168,
		165,
		150,
		146,
		141,
		145,
		138,
		145,
		141,
		140,
		141,
		123,
		159,
		-1,
		156,
		150,
		178,
		181,
		171,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		142,
		194,
		-1,
		-1,
		181,
		174,
		-1,
		161,
		143,
		150,
		148,
		142,
		146,
		150,
		139,
		152,
		148,
		128,
		138,
		158,
		162,
		169,
		162,
		167,
		166,
		180,
		-1,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		162,
		-1,
		190,
		182,
		172,
		166,
		160,
		156,
		154,
		170,
		154,
		157,
		157,
		153,
		161,
		146,
		145,
		131,
		135,
		153,
		180,
		175,
		170,
		169,
		176,
		-1,
		248,
		234,
		205,
		-1,
		-1,
		177,
		-1,
		148,
		172,
		188,
		-1,
		198,
		177,
		192,
		170,
		166,
		162,
		177,
		178,
		156,
		161,
		160,
		170,
		167,
		156,
		143,
		147,
		162,
		172,
		164,
		165,
		174,
		-1,
		254,
		241,
		199,
		195,
		184,
		204,
		151,
		160,
		175,
		-1,
		-1,
		234,
		-1,
		168,
		185,
		176,
		174,
		167,
		158,
		164,
		171,
		174,
		171,
		161,
		150,
		156,
		152,
		174,
		160,
		158,
		177,
		192,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		170,
		157,
		151,
		-1,
		192,
		-1,
		212,
		202,
		186,
		171,
		204,
		-1,
		175,
		159,
		164,
		-1,
		196,
		-1,
		169,
		169,
		160,
		149,
		146,
		157,
		155,
		166,
		183,
		-1,
		204,
		189,
		182,
		172,
		186,
		157,
		-1,
		208,
		-1,
		-1,
		199,
		193,
		193,
		177,
		180,
		191,
		171,
		165,
		164,
		191,
		186,
		177,
		158,
		151,
		148,
		149,
		162,
		182,
		173,
		185,
		-1,
		-1,
		-1,
		209,
		189,
		195,
		153,
		174,
		-1,
		-1,
		261,
		216,
		202,
		-1,
		186,
		208,
		196,
		186,
		176,
		210,
		202,
		177,
		170,
		156,
		158,
		156,
		158,
		163,
		184,
		185,
		198,
		-1,
		-1,
		186,
		193,
		181,
		167,
		186,
		-1,
		-1,
		-1,
		208,
		224,
		216,
		187,
		197,
		-1,
		-1,
		188,
		186,
		194,
		173,
		160,
		180,
		183,
		173,
		157,
		172,
		184,
		192,
		197,
		-1,
		189,
		176,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		-1,
		-1,
		241,
		207,
		219,
		214,
		218,
		191,
		-1,
		190,
		184,
		164,
		178,
		185,
		175,
		170,
		164,
		167,
		185,
		202,
		-1,
		-1,
		203,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		198,
		212,
		207,
		200,
		204,
		-1,
		192,
		180,
		166,
		183,
		188,
		185,
		176,
		168,
		173,
		170,
		183,
		197,
		201,
		226,
		-1,
		209,
		-1,
		-1,
		-1,
		216,
		231,
		246,
		223,
		196,
		191,
		184,
		178,
		174,
		190,
		196,
		207,
		175,
		171,
		172,
		176,
		175,
		192,
		202,
		-1,
		-1,
		209,
		226,
		242,
		224,
		228,
		273,
		-1,
		-1,
		200,
		191,
		182,
		185,
		184,
		187,
		181,
		178,
		183,
		188,
		176,
		185,
		203,
		202,
		-1,
		-1,
		-1,
		229,
		-1,
		244,
		-1,
		-1,
		243,
		271,
		218,
		200,
		196,
		194,
		187,
		196,
		191,
		186,
		196,
		198,
		190,
		178,
		182,
		205,
		194,
		233,
		-1,
		-1,
		346,
		-1,
		-1,
		-1,
		258,
		233,
		248,
		282,
		263,
		270,
		233,
		230,
		-1,
		200,
		225,
		197,
		204,
		195,
		202,
		202,
		194,
		172,
		179,
		195,
		194,
		189,
		225,
		216,
		222,
		-1,
		-1,
		339,
		328,
		317,
		323,
		-1,
		264,
		250,
		268,
		258,
		261,
		-1,
		-1,
		249,
		246,
		222,
		205,
		203,
		196,
		191,
		201,
		181,
		168,
		172,
		176,
		182,
		187,
		192,
		198,
		213,
		228,
		-1,
		234,
		315,
		308,
		291,
		299,
		330,
		-1,
		267,
		264,
		257,
		250,
		252,
		-1,
		-1,
		222,
		219,
		224,
		212,
		209,
		211,
		206,
		197,
		182,
		188,
		175,
		174,
		192,
		196,
		205,
		212,
		202,
		215,
		219,
		-1,
		248,
		291,
		285,
		288,
		312,
		326,
		-1,
		269,
		-1,
		-1,
		265,
		253,
		237,
		227,
		221,
		271,
		226,
		221,
		205,
		203,
		194,
		185,
		192,
		183,
		183,
		186,
		201,
		206,
		198,
		212,
		212,
		213,
		-1,
		283,
		271,
		279,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		281,
		-1,
		264,
		-1,
		239,
		243,
		234,
		237,
		219,
		206,
		198,
		190,
		206,
		181,
		191,
		187,
		188,
		197,
		208,
		220,
		219,
		220,
		340,
		296,
		279,
		270,
		317,
		332,
		336,
		-1,
		281,
		320,
		318,
		-1,
		290,
		-1,
		-1,
		-1,
		253,
		247,
		239,
		239,
		218,
		218,
		192,
		196,
		186,
		193,
		203,
		205,
		197,
		201,
		214,
		225,
		228,
		336,
		327,
		340,
		285,
		284,
		302,
		311,
		332,
		296,
		287,
		314,
		325,
		314,
		309,
		296,
		-1,
		-1,
		276,
		257,
		-1,
		-1,
		225,
		213,
		196,
		197,
		193,
		196,
		211,
		214,
		204,
		202,
		196,
		228,
		-1,
		329,
		328,
		317,
		314,
		290,
		281,
		276,
		303,
		-1,
		-1,
		298,
		315,
		309,
		313,
		329,
		354,
		-1,
		285,
		-1,
		-1,
		270,
		-1,
		-1,
		255,
		218,
		207,
		198,
		204,
		201,
		212,
		222,
		210,
		211,
		201,
		211,
		224,
		313,
		310,
		298,
		296,
		319,
		284,
		272,
		-1,
		285,
		283,
		289,
		296,
		313,
		343,
		-1,
		-1,
		301,
		281,
		-1,
		-1,
		253,
		251,
		240,
		-1,
		230,
		203,
		208,
		228,
		230,
		219,
		213,
		207,
		214,
		213,
		221,
		229,
		322,
		336,
		325,
		321,
		320,
		328,
		277,
		270,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		-1,
		291,
		287,
		-1,
		-1,
		248,
		241,
		229,
		217,
		207,
		217,
		221,
		225,
		217,
		210,
		205,
		216,
		208,
		212,
		229,
		-1,
		356,
		-1,
		308,
		284,
		298,
		313,
		321,
		-1,
		-1,
		-1,
		308,
		294,
		287,
		275,
		273,
		-1,
		282,
		266,
		247,
		-1,
		217,
		230,
		261,
		229,
		234,
		229,
		211,
		222,
		211,
		214,
		228,
		223,
		-1,
		-1,
		296,
		299,
		-1,
		-1,
		298,
		300,
		-1,
		299,
		288,
		273,
		265,
		-1,
		-1,
		254,
		250,
		-1,
		-1,
		218,
		243,
		232,
		240,
		235,
		215,
		221,
		224,
		213,
		217,
		229,
		-1,
		-1,
		303,
		304,
		305,
		-1,
		283,
		-1,
		301,
		-1,
		268,
		274,
		262,
		-1,
		-1,
		-1,
		256,
		219,
		240,
		250,
		244,
		242,
		233,
		219,
		226,
		224,
		220,
		231,
		-1,
		-1,
		-1,
		301,
		275,
		308,
		299,
		282,
		262,
		254,
		273,
		-1,
		243,
		-1,
		218,
		220,
		246,
		249,
		255,
		249,
		222,
		237,
		227,
		218,
		227,
		307,
		-1,
		277,
		310,
		274,
		268,
		244,
		248,
		264,
		-1,
		240,
		222,
		-1,
		250,
		240,
		271,
		256,
		237,
		224,
		231,
		231,
		224,
		-1,
		-1,
		-1,
		279,
		278,
		270,
		264,
		264,
		249,
		240,
		-1,
		252,
		234,
		213,
		230,
		230,
		221,
		229,
		261,
		257,
		244,
		244,
		236,
		-1,
		380,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		273,
		268,
		241,
		229,
		235,
		231,
		217,
		223,
		225,
		233,
		231,
		228,
		240,
		236,
		256,
		237,
		272,
		-1,
		375,
		-1,
		309,
		-1,
		-1,
		291,
		271,
		263,
		252,
		241,
		239,
		230,
		221,
		243,
		259,
		243,
		241,
		244,
		245,
		-1,
		364,
		363,
		-1,
		310,
		302,
		288,
		-1,
		281,
		-1,
		287,
		248,
		-1,
		250,
		230,
		-1,
		252,
		248,
		-1,
		-1,
		351,
		326,
		-1,
		-1,
		-1,
		311,
		291,
		282,
		266,
		-1,
		241,
		241,
		-1,
		-1,
		-1,
		336,
		335,
		-1,
		304,
		307,
		-1,
		297,
		288,
		296,
		243,
		247,
		-1,
		-1,
		-1,
		345,
		326,
		320,
		319,
		317,
		312,
		309,
		295,
		279,
		257,
		246,
		267,
		-1,
		-1,
		-1,
		317,
		309,
		302,
		-1,
		-1,
		304,
		287,
		268,
		266,
		-1,
		-1,
		-1,
		339,
		320,
		-1,
		-1,
		294,
		-1,
		-1,
		300,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		356,
		328,
		-1,
		-1,
		-1,
		290,
		286,
		287,
		-1,
		-1,
		-1,
		-1,
		350,
		351,
		374,
		338,
		-1,
		-1,
		-1,
		282,
		276,
		-1,
		-1,
		353,
		351,
		-1,
		-1,
		-1,
		310,
		294,
		-1,
		280,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		315,
		-1,
		315,
		290,
		297,
		-1,
		-1,
		-1,
		-1,
		328,
		320,
		328,
		-1,
		300,
		302,
		-1,
		350,
		-1,
		-1,
		343,
		334,
		-1,
		-1,
		305,
		312,
		334,
		337,
		373,
		-1,
		324
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		41,
		44,
		58,
		35,
		40,
		42,
		-1,
		88,
		38,
		25,
		30,
		55,
		54,
		66,
		77,
		-1,
		-1,
		-1,
		0,
		13,
		43,
		39,
		49,
		60,
		67,
		-1,
		118,
		-1,
		31,
		31,
		43,
		48,
		41,
		44,
		64,
		91,
		113,
		115,
		47,
		71,
		48,
		49,
		72,
		83,
		117,
		109,
		-1,
		55,
		52,
		74,
		87,
		102,
		105,
		-1,
		-1,
		56,
		66,
		72,
		87,
		106,
		109,
		-1,
		119,
		138,
		-1,
		-1,
		55,
		68,
		81,
		84,
		92,
		98,
		111,
		128,
		133,
		-1,
		-1,
		73,
		77,
		87,
		85,
		81,
		98,
		117,
		128,
		142,
		141,
		-1,
		67,
		85,
		94,
		92,
		90,
		74,
		78,
		96,
		127,
		133,
		136,
		-1,
		84,
		80,
		90,
		96,
		108,
		90,
		77,
		83,
		102,
		115,
		134,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		85,
		76,
		96,
		98,
		97,
		111,
		109,
		80,
		86,
		90,
		107,
		123,
		124,
		134,
		-1,
		-1,
		178,
		151,
		175,
		133,
		115,
		-1,
		81,
		83,
		89,
		93,
		98,
		106,
		111,
		96,
		-1,
		101,
		100,
		131,
		117,
		128,
		160,
		-1,
		-1,
		136,
		128,
		110,
		113,
		90,
		86,
		98,
		97,
		93,
		95,
		97,
		109,
		104,
		117,
		124,
		95,
		105,
		109,
		124,
		135,
		-1,
		-1,
		209,
		-1,
		-1,
		157,
		140,
		-1,
		105,
		112,
		96,
		102,
		88,
		109,
		108,
		102,
		109,
		112,
		100,
		117,
		114,
		131,
		117,
		92,
		117,
		121,
		127,
		145,
		146,
		-1,
		208,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		112,
		109,
		102,
		126,
		125,
		-1,
		131,
		129,
		135,
		120,
		125,
		121,
		106,
		122,
		117,
		117,
		114,
		99,
		101,
		138,
		129,
		150,
		147,
		178,
		184,
		178,
		187,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		130,
		-1,
		133,
		146,
		143,
		131,
		134,
		121,
		129,
		128,
		112,
		128,
		115,
		112,
		111,
		107,
		116,
		126,
		125,
		143,
		156,
		171,
		175,
		181,
		-1,
		215,
		-1,
		157,
		141,
		143,
		119,
		147,
		-1,
		150,
		134,
		154,
		145,
		145,
		-1,
		137,
		134,
		144,
		127,
		112,
		127,
		115,
		110,
		110,
		114,
		129,
		120,
		138,
		145,
		153,
		157,
		177,
		189,
		175,
		165,
		-1,
		147,
		152,
		122,
		134,
		157,
		177,
		161,
		-1,
		156,
		-1,
		139,
		152,
		-1,
		133,
		129,
		118,
		123,
		112,
		119,
		117,
		111,
		108,
		126,
		129,
		146,
		150,
		166,
		-1,
		-1,
		160,
		164,
		172,
		123,
		142,
		166,
		203,
		170,
		163,
		162,
		-1,
		157,
		154,
		151,
		152,
		138,
		131,
		132,
		118,
		124,
		125,
		110,
		113,
		135,
		163,
		141,
		153,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		149,
		120,
		144,
		186,
		192,
		185,
		173,
		188,
		188,
		181,
		-1,
		169,
		148,
		145,
		135,
		125,
		141,
		131,
		134,
		114,
		116,
		132,
		144,
		135,
		155,
		-1,
		-1,
		-1,
		179,
		168,
		169,
		123,
		157,
		175,
		221,
		207,
		212,
		187,
		180,
		174,
		163,
		165,
		153,
		142,
		134,
		123,
		132,
		142,
		136,
		116,
		125,
		126,
		150,
		157,
		163,
		-1,
		-1,
		186,
		176,
		160,
		162,
		159,
		148,
		155,
		187,
		212,
		225,
		-1,
		179,
		-1,
		168,
		163,
		147,
		142,
		139,
		136,
		130,
		139,
		144,
		130,
		121,
		136,
		155,
		155,
		147,
		172,
		175,
		-1,
		-1,
		-1,
		179,
		196,
		171,
		148,
		129,
		165,
		-1,
		195,
		196,
		-1,
		173,
		167,
		164,
		149,
		145,
		140,
		144,
		137,
		144,
		140,
		139,
		140,
		122,
		158,
		-1,
		155,
		149,
		177,
		180,
		170,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		136,
		188,
		-1,
		-1,
		180,
		173,
		-1,
		160,
		142,
		149,
		147,
		141,
		145,
		149,
		138,
		151,
		147,
		127,
		137,
		157,
		161,
		168,
		161,
		166,
		165,
		179,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		156,
		-1,
		189,
		181,
		171,
		165,
		159,
		155,
		153,
		169,
		153,
		156,
		156,
		152,
		160,
		145,
		144,
		130,
		134,
		152,
		179,
		174,
		169,
		168,
		175,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		171,
		-1,
		142,
		166,
		182,
		-1,
		197,
		176,
		191,
		169,
		165,
		161,
		176,
		177,
		155,
		160,
		159,
		169,
		166,
		155,
		142,
		146,
		161,
		171,
		163,
		164,
		173,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		145,
		158,
		169,
		-1,
		-1,
		233,
		-1,
		167,
		184,
		175,
		173,
		166,
		157,
		163,
		170,
		173,
		170,
		160,
		149,
		155,
		151,
		173,
		159,
		157,
		176,
		191,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		211,
		201,
		185,
		170,
		203,
		-1,
		174,
		158,
		163,
		-1,
		195,
		-1,
		168,
		168,
		159,
		148,
		145,
		156,
		154,
		165,
		182,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		202,
		-1,
		-1,
		198,
		192,
		192,
		176,
		179,
		190,
		170,
		164,
		163,
		190,
		185,
		176,
		157,
		150,
		147,
		148,
		161,
		181,
		172,
		184,
		-1,
		-1,
		-1,
		203,
		183,
		189,
		147,
		168,
		-1,
		-1,
		260,
		215,
		201,
		-1,
		185,
		207,
		195,
		185,
		175,
		209,
		201,
		176,
		169,
		155,
		157,
		155,
		157,
		162,
		183,
		184,
		197,
		-1,
		-1,
		180,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		207,
		223,
		215,
		186,
		196,
		-1,
		-1,
		187,
		185,
		193,
		172,
		159,
		179,
		182,
		172,
		156,
		171,
		183,
		191,
		196,
		-1,
		183,
		170,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		240,
		206,
		218,
		213,
		217,
		190,
		-1,
		189,
		183,
		163,
		177,
		184,
		174,
		169,
		163,
		166,
		184,
		201,
		-1,
		-1,
		197,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		197,
		211,
		206,
		199,
		203,
		-1,
		191,
		179,
		165,
		182,
		187,
		184,
		175,
		167,
		172,
		169,
		182,
		196,
		200,
		220,
		-1,
		203,
		-1,
		-1,
		-1,
		215,
		230,
		245,
		222,
		195,
		190,
		183,
		177,
		173,
		189,
		195,
		206,
		174,
		170,
		171,
		175,
		174,
		191,
		201,
		-1,
		-1,
		203,
		220,
		241,
		223,
		227,
		272,
		-1,
		-1,
		199,
		190,
		181,
		184,
		183,
		186,
		180,
		177,
		182,
		187,
		175,
		184,
		202,
		201,
		-1,
		-1,
		-1,
		223,
		-1,
		238,
		-1,
		-1,
		242,
		270,
		217,
		199,
		195,
		193,
		186,
		195,
		190,
		185,
		195,
		197,
		189,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		340,
		-1,
		-1,
		-1,
		252,
		227,
		242,
		281,
		262,
		269,
		232,
		229,
		-1,
		199,
		224,
		196,
		203,
		194,
		201,
		201,
		193,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		333,
		322,
		311,
		317,
		-1,
		258,
		244,
		267,
		257,
		260,
		-1,
		-1,
		248,
		245,
		221,
		204,
		202,
		195,
		190,
		200,
		180,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		228,
		309,
		302,
		285,
		293,
		324,
		-1,
		261,
		263,
		251,
		249,
		251,
		-1,
		-1,
		221,
		218,
		223,
		211,
		208,
		210,
		205,
		196,
		181,
		187,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		242,
		285,
		279,
		282,
		306,
		320,
		-1,
		268,
		-1,
		-1,
		259,
		252,
		236,
		226,
		220,
		270,
		225,
		220,
		204,
		202,
		193,
		184,
		191,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		277,
		265,
		273,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		-1,
		263,
		-1,
		238,
		242,
		233,
		236,
		218,
		205,
		197,
		189,
		205,
		180,
		190,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		339,
		295,
		273,
		264,
		311,
		326,
		330,
		-1,
		280,
		319,
		313,
		-1,
		284,
		-1,
		-1,
		-1,
		252,
		246,
		238,
		238,
		217,
		217,
		191,
		195,
		185,
		192,
		202,
		204,
		196,
		200,
		213,
		224,
		227,
		335,
		326,
		339,
		284,
		278,
		296,
		305,
		326,
		295,
		286,
		313,
		320,
		309,
		304,
		291,
		-1,
		-1,
		275,
		256,
		-1,
		-1,
		224,
		212,
		195,
		196,
		192,
		195,
		210,
		213,
		203,
		201,
		195,
		227,
		-1,
		328,
		327,
		316,
		313,
		289,
		280,
		275,
		297,
		-1,
		-1,
		297,
		314,
		308,
		312,
		328,
		353,
		-1,
		284,
		-1,
		-1,
		269,
		-1,
		-1,
		254,
		217,
		206,
		197,
		203,
		200,
		211,
		221,
		209,
		210,
		200,
		210,
		223,
		312,
		309,
		297,
		295,
		318,
		283,
		271,
		-1,
		284,
		282,
		288,
		295,
		312,
		342,
		-1,
		-1,
		300,
		280,
		-1,
		-1,
		252,
		250,
		239,
		-1,
		229,
		202,
		207,
		227,
		229,
		218,
		212,
		206,
		213,
		212,
		220,
		228,
		321,
		335,
		324,
		320,
		319,
		327,
		276,
		269,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		-1,
		290,
		286,
		-1,
		-1,
		247,
		240,
		228,
		216,
		206,
		216,
		220,
		224,
		216,
		209,
		204,
		215,
		207,
		211,
		228,
		-1,
		355,
		-1,
		307,
		283,
		297,
		312,
		320,
		-1,
		-1,
		-1,
		307,
		293,
		286,
		274,
		272,
		-1,
		281,
		265,
		246,
		-1,
		216,
		229,
		260,
		228,
		233,
		228,
		210,
		221,
		210,
		213,
		227,
		222,
		-1,
		-1,
		295,
		298,
		-1,
		-1,
		297,
		299,
		-1,
		298,
		287,
		272,
		264,
		-1,
		-1,
		253,
		249,
		-1,
		-1,
		217,
		242,
		231,
		239,
		234,
		214,
		220,
		223,
		212,
		216,
		228,
		-1,
		-1,
		302,
		303,
		304,
		-1,
		282,
		-1,
		300,
		-1,
		267,
		273,
		261,
		-1,
		-1,
		-1,
		255,
		218,
		239,
		249,
		243,
		241,
		232,
		218,
		225,
		223,
		219,
		230,
		-1,
		-1,
		-1,
		300,
		274,
		307,
		298,
		281,
		261,
		253,
		272,
		-1,
		242,
		-1,
		217,
		219,
		245,
		248,
		254,
		248,
		221,
		236,
		226,
		217,
		226,
		306,
		-1,
		276,
		309,
		273,
		267,
		243,
		247,
		263,
		-1,
		239,
		221,
		-1,
		249,
		239,
		270,
		255,
		236,
		223,
		230,
		230,
		223,
		-1,
		-1,
		-1,
		278,
		277,
		269,
		263,
		263,
		248,
		239,
		-1,
		251,
		233,
		212,
		229,
		229,
		220,
		228,
		260,
		256,
		243,
		243,
		235,
		-1,
		379,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		272,
		267,
		240,
		228,
		234,
		230,
		216,
		222,
		224,
		232,
		230,
		227,
		239,
		235,
		255,
		236,
		271,
		-1,
		374,
		-1,
		308,
		-1,
		-1,
		290,
		270,
		262,
		251,
		240,
		238,
		229,
		220,
		242,
		258,
		242,
		240,
		243,
		244,
		-1,
		363,
		362,
		-1,
		309,
		301,
		287,
		-1,
		280,
		-1,
		286,
		247,
		-1,
		249,
		229,
		-1,
		251,
		247,
		-1,
		-1,
		350,
		325,
		-1,
		-1,
		-1,
		310,
		290,
		281,
		265,
		-1,
		240,
		240,
		-1,
		-1,
		-1,
		335,
		334,
		-1,
		303,
		306,
		-1,
		296,
		287,
		295,
		242,
		246,
		-1,
		-1,
		-1,
		344,
		325,
		319,
		318,
		316,
		311,
		308,
		294,
		278,
		256,
		245,
		266,
		-1,
		-1,
		-1,
		316,
		308,
		301,
		-1,
		-1,
		303,
		286,
		267,
		265,
		-1,
		-1,
		-1,
		338,
		319,
		-1,
		-1,
		293,
		-1,
		-1,
		299,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		355,
		327,
		-1,
		-1,
		-1,
		289,
		285,
		286,
		-1,
		-1,
		-1,
		-1,
		349,
		350,
		373,
		337,
		-1,
		-1,
		-1,
		281,
		275,
		-1,
		-1,
		352,
		350,
		-1,
		-1,
		-1,
		309,
		293,
		-1,
		279,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		314,
		-1,
		314,
		289,
		296,
		-1,
		-1,
		-1,
		-1,
		327,
		319,
		327,
		-1,
		299,
		301,
		-1,
		349,
		-1,
		-1,
		342,
		333,
		-1,
		-1,
		304,
		311,
		333,
		336,
		372,
		-1,
		323
	],
	[
		-1,
		50,
		47,
		58,
		44,
		39,
		43,
		-1,
		87,
		47,
		34,
		29,
		54,
		53,
		65,
		76,
		-1,
		-1,
		-1,
		16,
		0,
		42,
		38,
		48,
		59,
		66,
		-1,
		117,
		-1,
		23,
		23,
		35,
		44,
		40,
		43,
		63,
		90,
		112,
		114,
		38,
		70,
		47,
		48,
		71,
		82,
		116,
		108,
		-1,
		54,
		51,
		73,
		86,
		101,
		104,
		-1,
		-1,
		55,
		65,
		71,
		86,
		105,
		108,
		-1,
		118,
		137,
		-1,
		-1,
		54,
		67,
		80,
		83,
		91,
		97,
		110,
		127,
		132,
		-1,
		-1,
		72,
		76,
		86,
		84,
		80,
		97,
		116,
		127,
		141,
		140,
		-1,
		66,
		84,
		93,
		91,
		89,
		73,
		77,
		95,
		126,
		132,
		135,
		-1,
		83,
		79,
		89,
		95,
		107,
		89,
		76,
		82,
		101,
		114,
		133,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		84,
		75,
		95,
		97,
		96,
		110,
		108,
		79,
		85,
		89,
		106,
		122,
		123,
		133,
		-1,
		-1,
		177,
		150,
		174,
		132,
		114,
		-1,
		80,
		82,
		88,
		92,
		97,
		105,
		110,
		95,
		-1,
		100,
		99,
		130,
		116,
		127,
		159,
		-1,
		-1,
		135,
		127,
		109,
		112,
		89,
		85,
		97,
		96,
		92,
		94,
		96,
		108,
		103,
		116,
		123,
		94,
		104,
		108,
		123,
		134,
		-1,
		-1,
		208,
		-1,
		-1,
		156,
		139,
		-1,
		104,
		111,
		95,
		101,
		87,
		108,
		107,
		101,
		108,
		111,
		99,
		116,
		113,
		130,
		116,
		91,
		116,
		120,
		126,
		144,
		145,
		-1,
		207,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		111,
		108,
		101,
		125,
		124,
		-1,
		130,
		128,
		134,
		119,
		124,
		120,
		105,
		121,
		116,
		116,
		113,
		98,
		100,
		137,
		128,
		149,
		146,
		177,
		183,
		177,
		186,
		-1,
		164,
		160,
		156,
		163,
		112,
		-1,
		-1,
		129,
		-1,
		132,
		145,
		142,
		130,
		133,
		120,
		128,
		127,
		111,
		127,
		114,
		111,
		110,
		106,
		115,
		125,
		124,
		142,
		155,
		170,
		174,
		180,
		-1,
		214,
		-1,
		156,
		140,
		142,
		118,
		146,
		-1,
		149,
		133,
		153,
		144,
		144,
		-1,
		136,
		133,
		143,
		126,
		111,
		126,
		114,
		109,
		109,
		113,
		128,
		119,
		137,
		144,
		152,
		156,
		176,
		188,
		174,
		164,
		-1,
		146,
		151,
		121,
		133,
		156,
		176,
		160,
		-1,
		155,
		-1,
		138,
		151,
		-1,
		132,
		128,
		117,
		122,
		111,
		118,
		116,
		110,
		107,
		125,
		128,
		145,
		149,
		165,
		-1,
		-1,
		159,
		163,
		171,
		122,
		141,
		165,
		202,
		169,
		162,
		161,
		-1,
		156,
		153,
		150,
		151,
		137,
		130,
		131,
		117,
		123,
		124,
		109,
		112,
		134,
		162,
		140,
		152,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		148,
		119,
		143,
		185,
		191,
		184,
		172,
		187,
		187,
		180,
		-1,
		168,
		147,
		144,
		134,
		124,
		140,
		130,
		133,
		113,
		115,
		131,
		143,
		134,
		154,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		122,
		156,
		174,
		220,
		206,
		211,
		186,
		179,
		173,
		162,
		164,
		152,
		141,
		133,
		122,
		131,
		141,
		135,
		115,
		124,
		125,
		149,
		156,
		162,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		147,
		154,
		186,
		211,
		224,
		-1,
		178,
		-1,
		167,
		162,
		146,
		141,
		138,
		135,
		129,
		138,
		143,
		129,
		120,
		135,
		154,
		154,
		146,
		171,
		174,
		-1,
		-1,
		-1,
		178,
		195,
		170,
		147,
		128,
		164,
		-1,
		194,
		195,
		-1,
		172,
		166,
		163,
		148,
		144,
		139,
		143,
		136,
		143,
		139,
		138,
		139,
		121,
		157,
		-1,
		154,
		148,
		176,
		179,
		169,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		135,
		187,
		-1,
		-1,
		179,
		172,
		-1,
		159,
		141,
		148,
		146,
		140,
		144,
		148,
		137,
		150,
		146,
		126,
		136,
		156,
		160,
		167,
		160,
		165,
		164,
		178,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		155,
		-1,
		188,
		180,
		170,
		164,
		158,
		154,
		152,
		168,
		152,
		155,
		155,
		151,
		159,
		144,
		143,
		129,
		133,
		151,
		178,
		173,
		168,
		167,
		174,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		170,
		-1,
		141,
		165,
		181,
		-1,
		196,
		175,
		190,
		168,
		164,
		160,
		175,
		176,
		154,
		159,
		158,
		168,
		165,
		154,
		141,
		145,
		160,
		170,
		162,
		163,
		172,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		144,
		157,
		168,
		-1,
		-1,
		232,
		-1,
		166,
		183,
		174,
		172,
		165,
		156,
		162,
		169,
		172,
		169,
		159,
		148,
		154,
		150,
		172,
		158,
		156,
		175,
		190,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		210,
		200,
		184,
		169,
		202,
		-1,
		173,
		157,
		162,
		-1,
		194,
		-1,
		167,
		167,
		158,
		147,
		144,
		155,
		153,
		164,
		181,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		201,
		-1,
		-1,
		197,
		191,
		191,
		175,
		178,
		189,
		169,
		163,
		162,
		189,
		184,
		175,
		156,
		149,
		146,
		147,
		160,
		180,
		171,
		183,
		-1,
		-1,
		-1,
		202,
		182,
		188,
		146,
		167,
		-1,
		-1,
		259,
		214,
		200,
		-1,
		184,
		206,
		194,
		184,
		174,
		208,
		200,
		175,
		168,
		154,
		156,
		154,
		156,
		161,
		182,
		183,
		196,
		-1,
		-1,
		179,
		186,
		174,
		160,
		179,
		-1,
		-1,
		-1,
		206,
		222,
		214,
		185,
		195,
		-1,
		-1,
		186,
		184,
		192,
		171,
		158,
		178,
		181,
		171,
		155,
		170,
		182,
		190,
		195,
		-1,
		182,
		169,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		-1,
		-1,
		239,
		205,
		217,
		212,
		216,
		189,
		-1,
		188,
		182,
		162,
		176,
		183,
		173,
		168,
		162,
		165,
		183,
		200,
		-1,
		-1,
		196,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		196,
		210,
		205,
		198,
		202,
		-1,
		190,
		178,
		164,
		181,
		186,
		183,
		174,
		166,
		171,
		168,
		181,
		195,
		199,
		219,
		-1,
		202,
		-1,
		-1,
		-1,
		214,
		229,
		244,
		221,
		194,
		189,
		182,
		176,
		172,
		188,
		194,
		205,
		173,
		169,
		170,
		174,
		173,
		190,
		200,
		-1,
		-1,
		202,
		219,
		240,
		222,
		226,
		271,
		-1,
		-1,
		198,
		189,
		180,
		183,
		182,
		185,
		179,
		176,
		181,
		186,
		174,
		183,
		201,
		200,
		-1,
		-1,
		-1,
		222,
		-1,
		237,
		-1,
		-1,
		241,
		269,
		216,
		198,
		194,
		192,
		185,
		194,
		189,
		184,
		194,
		196,
		188,
		176,
		180,
		203,
		192,
		231,
		-1,
		-1,
		339,
		-1,
		-1,
		-1,
		251,
		226,
		241,
		280,
		261,
		268,
		231,
		228,
		-1,
		198,
		223,
		195,
		202,
		193,
		200,
		200,
		192,
		170,
		177,
		193,
		192,
		187,
		223,
		214,
		220,
		-1,
		-1,
		332,
		321,
		310,
		316,
		-1,
		257,
		243,
		266,
		256,
		259,
		-1,
		-1,
		247,
		244,
		220,
		203,
		201,
		194,
		189,
		199,
		179,
		166,
		170,
		174,
		180,
		185,
		190,
		196,
		211,
		226,
		-1,
		227,
		308,
		301,
		284,
		292,
		323,
		-1,
		260,
		262,
		250,
		248,
		250,
		-1,
		-1,
		220,
		217,
		222,
		210,
		207,
		209,
		204,
		195,
		180,
		186,
		173,
		172,
		190,
		194,
		203,
		210,
		200,
		213,
		217,
		-1,
		241,
		284,
		278,
		281,
		305,
		319,
		-1,
		267,
		-1,
		-1,
		258,
		251,
		235,
		225,
		219,
		269,
		224,
		219,
		203,
		201,
		192,
		183,
		190,
		181,
		181,
		184,
		199,
		204,
		196,
		210,
		210,
		211,
		-1,
		276,
		264,
		272,
		-1,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		274,
		-1,
		262,
		-1,
		237,
		241,
		232,
		235,
		217,
		204,
		196,
		188,
		204,
		179,
		189,
		185,
		186,
		195,
		206,
		218,
		217,
		218,
		338,
		294,
		272,
		263,
		310,
		325,
		329,
		-1,
		279,
		318,
		312,
		-1,
		283,
		-1,
		-1,
		-1,
		251,
		245,
		237,
		237,
		216,
		216,
		190,
		194,
		184,
		191,
		201,
		203,
		195,
		199,
		212,
		223,
		226,
		334,
		325,
		338,
		283,
		277,
		295,
		304,
		325,
		294,
		285,
		312,
		319,
		308,
		303,
		290,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		223,
		211,
		194,
		195,
		191,
		194,
		209,
		212,
		202,
		200,
		194,
		226,
		-1,
		327,
		326,
		315,
		312,
		288,
		279,
		274,
		296,
		-1,
		-1,
		296,
		313,
		307,
		311,
		327,
		352,
		-1,
		283,
		-1,
		-1,
		268,
		-1,
		-1,
		253,
		216,
		205,
		196,
		202,
		199,
		210,
		220,
		208,
		209,
		199,
		209,
		222,
		311,
		308,
		296,
		294,
		317,
		282,
		270,
		-1,
		283,
		281,
		287,
		294,
		311,
		341,
		-1,
		-1,
		299,
		279,
		-1,
		-1,
		251,
		249,
		238,
		-1,
		228,
		201,
		206,
		226,
		228,
		217,
		211,
		205,
		212,
		211,
		219,
		227,
		320,
		334,
		323,
		319,
		318,
		326,
		275,
		268,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		-1,
		289,
		285,
		-1,
		-1,
		246,
		239,
		227,
		215,
		205,
		215,
		219,
		223,
		215,
		208,
		203,
		214,
		206,
		210,
		227,
		-1,
		354,
		-1,
		306,
		282,
		296,
		311,
		319,
		-1,
		-1,
		-1,
		306,
		292,
		285,
		273,
		271,
		-1,
		280,
		264,
		245,
		-1,
		215,
		228,
		259,
		227,
		232,
		227,
		209,
		220,
		209,
		212,
		226,
		221,
		-1,
		-1,
		294,
		297,
		-1,
		-1,
		296,
		298,
		-1,
		297,
		286,
		271,
		263,
		-1,
		-1,
		252,
		248,
		-1,
		-1,
		216,
		241,
		230,
		238,
		233,
		213,
		219,
		222,
		211,
		215,
		227,
		-1,
		-1,
		301,
		302,
		303,
		-1,
		281,
		-1,
		299,
		-1,
		266,
		272,
		260,
		-1,
		-1,
		-1,
		254,
		217,
		238,
		248,
		242,
		240,
		231,
		217,
		224,
		222,
		218,
		229,
		-1,
		-1,
		-1,
		299,
		273,
		306,
		297,
		280,
		260,
		252,
		271,
		-1,
		241,
		-1,
		216,
		218,
		244,
		247,
		253,
		247,
		220,
		235,
		225,
		216,
		225,
		305,
		-1,
		275,
		308,
		272,
		266,
		242,
		246,
		262,
		-1,
		238,
		220,
		-1,
		248,
		238,
		269,
		254,
		235,
		222,
		229,
		229,
		222,
		-1,
		-1,
		-1,
		277,
		276,
		268,
		262,
		262,
		247,
		238,
		-1,
		250,
		232,
		211,
		228,
		228,
		219,
		227,
		259,
		255,
		242,
		242,
		234,
		-1,
		378,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		271,
		266,
		239,
		227,
		233,
		229,
		215,
		221,
		223,
		231,
		229,
		226,
		238,
		234,
		254,
		235,
		270,
		-1,
		373,
		-1,
		307,
		-1,
		-1,
		289,
		269,
		261,
		250,
		239,
		237,
		228,
		219,
		241,
		257,
		241,
		239,
		242,
		243,
		-1,
		362,
		361,
		-1,
		308,
		300,
		286,
		-1,
		279,
		-1,
		285,
		246,
		-1,
		248,
		228,
		-1,
		250,
		246,
		-1,
		-1,
		349,
		324,
		-1,
		-1,
		-1,
		309,
		289,
		280,
		264,
		-1,
		239,
		239,
		-1,
		-1,
		-1,
		334,
		333,
		-1,
		302,
		305,
		-1,
		295,
		286,
		294,
		241,
		245,
		-1,
		-1,
		-1,
		343,
		324,
		318,
		317,
		315,
		310,
		307,
		293,
		277,
		255,
		244,
		265,
		-1,
		-1,
		-1,
		315,
		307,
		300,
		-1,
		-1,
		302,
		285,
		266,
		264,
		-1,
		-1,
		-1,
		337,
		318,
		-1,
		-1,
		292,
		-1,
		-1,
		298,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		354,
		326,
		-1,
		-1,
		-1,
		288,
		284,
		285,
		-1,
		-1,
		-1,
		-1,
		348,
		349,
		372,
		336,
		-1,
		-1,
		-1,
		280,
		274,
		-1,
		-1,
		351,
		349,
		-1,
		-1,
		-1,
		308,
		292,
		-1,
		278,
		-1,
		-1,
		-1,
		299,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		313,
		-1,
		313,
		288,
		295,
		-1,
		-1,
		-1,
		-1,
		326,
		318,
		326,
		-1,
		298,
		300,
		-1,
		348,
		-1,
		-1,
		341,
		332,
		-1,
		-1,
		303,
		310,
		332,
		335,
		371,
		-1,
		322
	],
	[
		-1,
		41,
		30,
		41,
		49,
		22,
		29,
		-1,
		57,
		52,
		18,
		12,
		43,
		12,
		31,
		46,
		-1,
		-1,
		-1,
		41,
		40,
		0,
		4,
		14,
		29,
		36,
		-1,
		87,
		-1,
		62,
		41,
		52,
		57,
		10,
		13,
		33,
		60,
		82,
		84,
		77,
		40,
		17,
		18,
		41,
		52,
		86,
		79,
		-1,
		24,
		21,
		43,
		57,
		72,
		76,
		-1,
		-1,
		25,
		35,
		42,
		57,
		76,
		82,
		-1,
		92,
		111,
		-1,
		-1,
		25,
		38,
		51,
		54,
		62,
		71,
		84,
		101,
		106,
		-1,
		-1,
		43,
		47,
		57,
		58,
		54,
		71,
		90,
		101,
		115,
		114,
		-1,
		45,
		63,
		72,
		65,
		63,
		47,
		51,
		69,
		100,
		106,
		109,
		-1,
		62,
		58,
		68,
		74,
		85,
		63,
		50,
		56,
		75,
		88,
		107,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		63,
		54,
		74,
		76,
		75,
		84,
		82,
		53,
		59,
		63,
		80,
		96,
		97,
		107,
		-1,
		-1,
		156,
		129,
		153,
		111,
		93,
		-1,
		59,
		61,
		67,
		71,
		76,
		84,
		84,
		69,
		-1,
		74,
		73,
		104,
		90,
		101,
		138,
		-1,
		-1,
		114,
		106,
		88,
		91,
		68,
		64,
		76,
		75,
		71,
		73,
		75,
		87,
		77,
		90,
		97,
		68,
		78,
		82,
		97,
		108,
		-1,
		-1,
		182,
		-1,
		-1,
		135,
		118,
		-1,
		83,
		90,
		74,
		80,
		66,
		87,
		86,
		80,
		87,
		90,
		78,
		90,
		87,
		104,
		90,
		65,
		90,
		94,
		100,
		118,
		119,
		-1,
		181,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		90,
		87,
		80,
		104,
		103,
		-1,
		109,
		107,
		113,
		98,
		103,
		99,
		84,
		95,
		90,
		90,
		87,
		72,
		74,
		111,
		102,
		123,
		120,
		151,
		157,
		151,
		160,
		-1,
		143,
		139,
		135,
		142,
		91,
		-1,
		-1,
		108,
		-1,
		111,
		124,
		121,
		109,
		112,
		99,
		107,
		106,
		90,
		101,
		88,
		85,
		84,
		80,
		89,
		99,
		98,
		116,
		129,
		144,
		148,
		154,
		-1,
		193,
		-1,
		135,
		119,
		121,
		97,
		125,
		-1,
		128,
		112,
		132,
		123,
		123,
		-1,
		115,
		112,
		122,
		105,
		90,
		100,
		88,
		83,
		83,
		87,
		102,
		93,
		111,
		118,
		126,
		130,
		150,
		162,
		153,
		143,
		-1,
		125,
		130,
		100,
		112,
		135,
		155,
		139,
		-1,
		134,
		-1,
		117,
		130,
		-1,
		111,
		107,
		96,
		96,
		85,
		92,
		90,
		84,
		81,
		99,
		102,
		119,
		123,
		139,
		-1,
		-1,
		138,
		142,
		150,
		101,
		120,
		144,
		181,
		148,
		141,
		140,
		-1,
		135,
		132,
		129,
		130,
		116,
		109,
		108,
		91,
		97,
		98,
		83,
		86,
		108,
		136,
		114,
		126,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		127,
		98,
		122,
		164,
		170,
		163,
		151,
		161,
		161,
		155,
		-1,
		147,
		126,
		119,
		108,
		98,
		114,
		104,
		107,
		87,
		89,
		105,
		117,
		108,
		128,
		-1,
		-1,
		-1,
		157,
		146,
		147,
		101,
		135,
		153,
		194,
		180,
		185,
		160,
		153,
		147,
		141,
		143,
		126,
		115,
		107,
		96,
		105,
		115,
		109,
		89,
		98,
		99,
		123,
		130,
		136,
		-1,
		-1,
		164,
		154,
		138,
		140,
		137,
		126,
		133,
		165,
		185,
		198,
		-1,
		152,
		-1,
		141,
		136,
		120,
		115,
		112,
		109,
		103,
		112,
		117,
		103,
		94,
		109,
		128,
		128,
		120,
		145,
		148,
		-1,
		-1,
		-1,
		157,
		174,
		149,
		126,
		107,
		143,
		-1,
		168,
		169,
		-1,
		146,
		140,
		137,
		122,
		118,
		113,
		117,
		110,
		117,
		113,
		112,
		113,
		95,
		131,
		-1,
		128,
		122,
		150,
		153,
		143,
		-1,
		-1,
		-1,
		172,
		151,
		144,
		164,
		114,
		166,
		-1,
		-1,
		153,
		146,
		-1,
		133,
		115,
		122,
		120,
		114,
		118,
		122,
		111,
		124,
		120,
		100,
		110,
		130,
		134,
		141,
		134,
		139,
		138,
		152,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		134,
		-1,
		162,
		154,
		144,
		138,
		132,
		128,
		126,
		142,
		126,
		129,
		129,
		125,
		133,
		118,
		117,
		103,
		107,
		125,
		152,
		147,
		142,
		141,
		148,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		149,
		-1,
		120,
		144,
		160,
		-1,
		170,
		149,
		164,
		142,
		138,
		134,
		149,
		150,
		128,
		133,
		132,
		142,
		139,
		128,
		115,
		119,
		134,
		144,
		136,
		137,
		146,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		123,
		132,
		147,
		-1,
		-1,
		206,
		-1,
		140,
		157,
		148,
		146,
		139,
		130,
		136,
		143,
		146,
		143,
		133,
		122,
		128,
		124,
		146,
		132,
		130,
		149,
		164,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		184,
		174,
		158,
		143,
		176,
		-1,
		147,
		131,
		136,
		-1,
		168,
		-1,
		141,
		141,
		132,
		121,
		118,
		129,
		127,
		138,
		155,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		180,
		-1,
		-1,
		171,
		165,
		165,
		149,
		152,
		163,
		143,
		137,
		136,
		163,
		158,
		149,
		130,
		123,
		120,
		121,
		134,
		154,
		145,
		157,
		-1,
		-1,
		-1,
		181,
		161,
		167,
		125,
		146,
		-1,
		-1,
		233,
		188,
		174,
		-1,
		158,
		180,
		168,
		158,
		148,
		182,
		174,
		149,
		142,
		128,
		130,
		128,
		130,
		135,
		156,
		157,
		170,
		-1,
		-1,
		158,
		165,
		153,
		139,
		158,
		-1,
		-1,
		-1,
		180,
		196,
		188,
		159,
		169,
		-1,
		-1,
		160,
		158,
		166,
		145,
		132,
		152,
		155,
		145,
		129,
		144,
		156,
		164,
		169,
		-1,
		161,
		148,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		191,
		186,
		190,
		163,
		-1,
		162,
		156,
		136,
		150,
		157,
		147,
		142,
		136,
		139,
		157,
		174,
		-1,
		-1,
		175,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		170,
		184,
		179,
		172,
		176,
		-1,
		164,
		152,
		138,
		155,
		160,
		157,
		148,
		140,
		145,
		142,
		155,
		169,
		173,
		198,
		-1,
		181,
		-1,
		-1,
		-1,
		188,
		203,
		218,
		195,
		168,
		163,
		156,
		150,
		146,
		162,
		168,
		179,
		147,
		143,
		144,
		148,
		147,
		164,
		174,
		-1,
		-1,
		181,
		198,
		214,
		196,
		200,
		245,
		-1,
		-1,
		172,
		163,
		154,
		157,
		156,
		159,
		153,
		150,
		155,
		160,
		148,
		157,
		175,
		174,
		-1,
		-1,
		-1,
		201,
		-1,
		216,
		-1,
		-1,
		215,
		243,
		190,
		172,
		168,
		166,
		159,
		168,
		163,
		158,
		168,
		170,
		162,
		150,
		154,
		177,
		166,
		205,
		-1,
		-1,
		318,
		-1,
		-1,
		-1,
		230,
		205,
		220,
		254,
		235,
		242,
		205,
		202,
		-1,
		172,
		197,
		169,
		176,
		167,
		174,
		174,
		166,
		144,
		151,
		167,
		166,
		161,
		197,
		188,
		194,
		-1,
		-1,
		311,
		300,
		289,
		295,
		-1,
		236,
		222,
		240,
		230,
		233,
		-1,
		-1,
		221,
		218,
		194,
		177,
		175,
		168,
		163,
		173,
		153,
		140,
		144,
		148,
		154,
		159,
		164,
		170,
		185,
		200,
		-1,
		206,
		287,
		280,
		263,
		271,
		302,
		-1,
		239,
		236,
		229,
		222,
		224,
		-1,
		-1,
		194,
		191,
		196,
		184,
		181,
		183,
		178,
		169,
		154,
		160,
		147,
		146,
		164,
		168,
		177,
		184,
		174,
		187,
		191,
		-1,
		220,
		263,
		257,
		260,
		284,
		298,
		-1,
		241,
		-1,
		-1,
		237,
		225,
		209,
		199,
		193,
		243,
		198,
		193,
		177,
		175,
		166,
		157,
		164,
		155,
		155,
		158,
		173,
		178,
		170,
		184,
		184,
		185,
		-1,
		255,
		243,
		251,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		253,
		-1,
		236,
		-1,
		211,
		215,
		206,
		209,
		191,
		178,
		170,
		162,
		178,
		153,
		163,
		159,
		160,
		169,
		180,
		192,
		191,
		192,
		312,
		268,
		251,
		242,
		289,
		304,
		308,
		-1,
		253,
		292,
		290,
		-1,
		262,
		-1,
		-1,
		-1,
		225,
		219,
		211,
		211,
		190,
		190,
		164,
		168,
		158,
		165,
		175,
		177,
		169,
		173,
		186,
		197,
		200,
		308,
		299,
		312,
		257,
		256,
		274,
		283,
		304,
		268,
		259,
		286,
		297,
		286,
		281,
		268,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		197,
		185,
		168,
		169,
		165,
		168,
		183,
		186,
		176,
		174,
		168,
		200,
		-1,
		301,
		300,
		289,
		286,
		262,
		253,
		248,
		275,
		-1,
		-1,
		270,
		287,
		281,
		285,
		301,
		326,
		-1,
		257,
		-1,
		-1,
		242,
		-1,
		-1,
		227,
		190,
		179,
		170,
		176,
		173,
		184,
		194,
		182,
		183,
		173,
		183,
		196,
		285,
		282,
		270,
		268,
		291,
		256,
		244,
		-1,
		257,
		255,
		261,
		268,
		285,
		315,
		-1,
		-1,
		273,
		253,
		-1,
		-1,
		225,
		223,
		212,
		-1,
		202,
		175,
		180,
		200,
		202,
		191,
		185,
		179,
		186,
		185,
		193,
		201,
		294,
		308,
		297,
		293,
		292,
		300,
		249,
		242,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		-1,
		263,
		259,
		-1,
		-1,
		220,
		213,
		201,
		189,
		179,
		189,
		193,
		197,
		189,
		182,
		177,
		188,
		180,
		184,
		201,
		-1,
		328,
		-1,
		280,
		256,
		270,
		285,
		293,
		-1,
		-1,
		-1,
		280,
		266,
		259,
		247,
		245,
		-1,
		254,
		238,
		219,
		-1,
		189,
		202,
		233,
		201,
		206,
		201,
		183,
		194,
		183,
		186,
		200,
		195,
		-1,
		-1,
		268,
		271,
		-1,
		-1,
		270,
		272,
		-1,
		271,
		260,
		245,
		237,
		-1,
		-1,
		226,
		222,
		-1,
		-1,
		190,
		215,
		204,
		212,
		207,
		187,
		193,
		196,
		185,
		189,
		201,
		-1,
		-1,
		275,
		276,
		277,
		-1,
		255,
		-1,
		273,
		-1,
		240,
		246,
		234,
		-1,
		-1,
		-1,
		228,
		191,
		212,
		222,
		216,
		214,
		205,
		191,
		198,
		196,
		192,
		203,
		-1,
		-1,
		-1,
		273,
		247,
		280,
		271,
		254,
		234,
		226,
		245,
		-1,
		215,
		-1,
		190,
		192,
		218,
		221,
		227,
		221,
		194,
		209,
		199,
		190,
		199,
		279,
		-1,
		249,
		282,
		246,
		240,
		216,
		220,
		236,
		-1,
		212,
		194,
		-1,
		222,
		212,
		243,
		228,
		209,
		196,
		203,
		203,
		196,
		-1,
		-1,
		-1,
		251,
		250,
		242,
		236,
		236,
		221,
		212,
		-1,
		224,
		206,
		185,
		202,
		202,
		193,
		201,
		233,
		229,
		216,
		216,
		208,
		-1,
		352,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		245,
		240,
		213,
		201,
		207,
		203,
		189,
		195,
		197,
		205,
		203,
		200,
		212,
		208,
		228,
		209,
		244,
		-1,
		347,
		-1,
		281,
		-1,
		-1,
		263,
		243,
		235,
		224,
		213,
		211,
		202,
		193,
		215,
		231,
		215,
		213,
		216,
		217,
		-1,
		336,
		335,
		-1,
		282,
		274,
		260,
		-1,
		253,
		-1,
		259,
		220,
		-1,
		222,
		202,
		-1,
		224,
		220,
		-1,
		-1,
		323,
		298,
		-1,
		-1,
		-1,
		283,
		263,
		254,
		238,
		-1,
		213,
		213,
		-1,
		-1,
		-1,
		308,
		307,
		-1,
		276,
		279,
		-1,
		269,
		260,
		268,
		215,
		219,
		-1,
		-1,
		-1,
		317,
		298,
		292,
		291,
		289,
		284,
		281,
		267,
		251,
		229,
		218,
		239,
		-1,
		-1,
		-1,
		289,
		281,
		274,
		-1,
		-1,
		276,
		259,
		240,
		238,
		-1,
		-1,
		-1,
		311,
		292,
		-1,
		-1,
		266,
		-1,
		-1,
		272,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		328,
		300,
		-1,
		-1,
		-1,
		262,
		258,
		259,
		-1,
		-1,
		-1,
		-1,
		322,
		323,
		346,
		310,
		-1,
		-1,
		-1,
		254,
		248,
		-1,
		-1,
		325,
		323,
		-1,
		-1,
		-1,
		282,
		266,
		-1,
		252,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		287,
		-1,
		287,
		262,
		269,
		-1,
		-1,
		-1,
		-1,
		300,
		292,
		300,
		-1,
		272,
		274,
		-1,
		322,
		-1,
		-1,
		315,
		306,
		-1,
		-1,
		277,
		284,
		306,
		309,
		345,
		-1,
		296
	],
	[
		-1,
		37,
		26,
		37,
		45,
		18,
		25,
		-1,
		53,
		48,
		14,
		8,
		47,
		15,
		27,
		42,
		-1,
		-1,
		-1,
		37,
		36,
		4,
		0,
		10,
		25,
		32,
		-1,
		83,
		-1,
		58,
		37,
		48,
		53,
		6,
		9,
		29,
		56,
		78,
		80,
		73,
		36,
		13,
		14,
		37,
		48,
		82,
		75,
		-1,
		20,
		17,
		39,
		53,
		68,
		72,
		-1,
		-1,
		21,
		31,
		38,
		53,
		72,
		78,
		-1,
		88,
		107,
		-1,
		-1,
		21,
		34,
		47,
		50,
		58,
		67,
		80,
		97,
		102,
		-1,
		-1,
		39,
		43,
		53,
		54,
		50,
		67,
		86,
		97,
		111,
		110,
		-1,
		41,
		59,
		68,
		61,
		59,
		43,
		47,
		65,
		96,
		102,
		105,
		-1,
		58,
		54,
		64,
		70,
		81,
		59,
		46,
		52,
		71,
		84,
		103,
		94,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		59,
		50,
		70,
		72,
		71,
		80,
		78,
		49,
		55,
		59,
		76,
		92,
		93,
		103,
		-1,
		-1,
		152,
		125,
		149,
		107,
		89,
		-1,
		55,
		57,
		63,
		67,
		72,
		80,
		80,
		65,
		-1,
		70,
		69,
		100,
		86,
		97,
		134,
		-1,
		-1,
		110,
		102,
		84,
		87,
		64,
		60,
		72,
		71,
		67,
		69,
		71,
		83,
		73,
		86,
		93,
		64,
		74,
		78,
		93,
		104,
		-1,
		-1,
		178,
		-1,
		-1,
		131,
		114,
		-1,
		79,
		86,
		70,
		76,
		62,
		83,
		82,
		76,
		83,
		86,
		74,
		86,
		83,
		100,
		86,
		61,
		86,
		90,
		96,
		114,
		115,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		86,
		83,
		76,
		100,
		99,
		-1,
		105,
		103,
		109,
		94,
		99,
		95,
		80,
		91,
		86,
		86,
		83,
		68,
		70,
		107,
		98,
		119,
		116,
		147,
		153,
		147,
		156,
		-1,
		139,
		135,
		131,
		138,
		87,
		-1,
		-1,
		104,
		-1,
		107,
		120,
		117,
		105,
		108,
		95,
		103,
		102,
		86,
		97,
		84,
		81,
		80,
		76,
		85,
		95,
		94,
		112,
		125,
		140,
		144,
		150,
		-1,
		189,
		-1,
		131,
		115,
		117,
		93,
		121,
		-1,
		124,
		108,
		128,
		119,
		119,
		-1,
		111,
		108,
		118,
		101,
		86,
		96,
		84,
		79,
		79,
		83,
		98,
		89,
		107,
		114,
		122,
		126,
		146,
		158,
		149,
		139,
		-1,
		121,
		126,
		96,
		108,
		131,
		151,
		135,
		-1,
		130,
		-1,
		113,
		126,
		-1,
		107,
		103,
		92,
		92,
		81,
		88,
		86,
		80,
		77,
		95,
		98,
		115,
		119,
		135,
		-1,
		-1,
		134,
		138,
		146,
		97,
		116,
		140,
		177,
		144,
		137,
		136,
		-1,
		131,
		128,
		125,
		126,
		112,
		105,
		104,
		87,
		93,
		94,
		79,
		82,
		104,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		123,
		94,
		118,
		160,
		166,
		159,
		147,
		157,
		157,
		151,
		-1,
		143,
		122,
		115,
		104,
		94,
		110,
		100,
		103,
		83,
		85,
		101,
		113,
		104,
		124,
		-1,
		-1,
		-1,
		153,
		142,
		143,
		97,
		131,
		149,
		190,
		176,
		181,
		156,
		149,
		143,
		137,
		139,
		122,
		111,
		103,
		92,
		101,
		111,
		105,
		85,
		94,
		95,
		119,
		126,
		132,
		-1,
		-1,
		160,
		150,
		134,
		136,
		133,
		122,
		129,
		161,
		181,
		194,
		-1,
		148,
		-1,
		137,
		132,
		116,
		111,
		108,
		105,
		99,
		108,
		113,
		99,
		90,
		105,
		124,
		124,
		116,
		141,
		144,
		-1,
		-1,
		-1,
		153,
		170,
		145,
		122,
		103,
		139,
		-1,
		164,
		165,
		-1,
		142,
		136,
		133,
		118,
		114,
		109,
		113,
		106,
		113,
		109,
		108,
		109,
		91,
		127,
		-1,
		124,
		118,
		146,
		149,
		139,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		110,
		162,
		-1,
		-1,
		149,
		142,
		-1,
		129,
		111,
		118,
		116,
		110,
		114,
		118,
		107,
		120,
		116,
		96,
		106,
		126,
		130,
		137,
		130,
		135,
		134,
		148,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		130,
		-1,
		158,
		150,
		140,
		134,
		128,
		124,
		122,
		138,
		122,
		125,
		125,
		121,
		129,
		114,
		113,
		99,
		103,
		121,
		148,
		143,
		138,
		137,
		144,
		-1,
		216,
		202,
		173,
		-1,
		-1,
		145,
		-1,
		116,
		140,
		156,
		-1,
		166,
		145,
		160,
		138,
		134,
		130,
		145,
		146,
		124,
		129,
		128,
		138,
		135,
		124,
		111,
		115,
		130,
		140,
		132,
		133,
		142,
		-1,
		222,
		209,
		167,
		163,
		152,
		172,
		119,
		128,
		143,
		-1,
		-1,
		202,
		-1,
		136,
		153,
		144,
		142,
		135,
		126,
		132,
		139,
		142,
		139,
		129,
		118,
		124,
		120,
		142,
		128,
		126,
		145,
		160,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		138,
		125,
		119,
		-1,
		160,
		-1,
		180,
		170,
		154,
		139,
		172,
		-1,
		143,
		127,
		132,
		-1,
		164,
		-1,
		137,
		137,
		128,
		117,
		114,
		125,
		123,
		134,
		151,
		-1,
		172,
		157,
		150,
		140,
		154,
		125,
		-1,
		176,
		-1,
		-1,
		167,
		161,
		161,
		145,
		148,
		159,
		139,
		133,
		132,
		159,
		154,
		145,
		126,
		119,
		116,
		117,
		130,
		150,
		141,
		153,
		-1,
		-1,
		-1,
		177,
		157,
		163,
		121,
		142,
		-1,
		-1,
		229,
		184,
		170,
		-1,
		154,
		176,
		164,
		154,
		144,
		178,
		170,
		145,
		138,
		124,
		126,
		124,
		126,
		131,
		152,
		153,
		166,
		-1,
		-1,
		154,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		176,
		192,
		184,
		155,
		165,
		-1,
		-1,
		156,
		154,
		162,
		141,
		128,
		148,
		151,
		141,
		125,
		140,
		152,
		160,
		165,
		-1,
		157,
		144,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		187,
		182,
		186,
		159,
		-1,
		158,
		152,
		132,
		146,
		153,
		143,
		138,
		132,
		135,
		153,
		170,
		-1,
		-1,
		171,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		166,
		180,
		175,
		168,
		172,
		-1,
		160,
		148,
		134,
		151,
		156,
		153,
		144,
		136,
		141,
		138,
		151,
		165,
		169,
		194,
		-1,
		177,
		-1,
		-1,
		-1,
		184,
		199,
		214,
		191,
		164,
		159,
		152,
		146,
		142,
		158,
		164,
		175,
		143,
		139,
		140,
		144,
		143,
		160,
		170,
		-1,
		-1,
		177,
		194,
		210,
		192,
		196,
		241,
		-1,
		-1,
		168,
		159,
		150,
		153,
		152,
		155,
		149,
		146,
		151,
		156,
		144,
		153,
		171,
		170,
		-1,
		-1,
		-1,
		197,
		-1,
		212,
		-1,
		-1,
		211,
		239,
		186,
		168,
		164,
		162,
		155,
		164,
		159,
		154,
		164,
		166,
		158,
		146,
		150,
		173,
		162,
		201,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		226,
		201,
		216,
		250,
		231,
		238,
		201,
		198,
		-1,
		168,
		193,
		165,
		172,
		163,
		170,
		170,
		162,
		140,
		147,
		163,
		162,
		157,
		193,
		184,
		190,
		-1,
		-1,
		307,
		296,
		285,
		291,
		-1,
		232,
		218,
		236,
		226,
		229,
		-1,
		-1,
		217,
		214,
		190,
		173,
		171,
		164,
		159,
		169,
		149,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		202,
		283,
		276,
		259,
		267,
		298,
		-1,
		235,
		232,
		225,
		218,
		220,
		-1,
		-1,
		190,
		187,
		192,
		180,
		177,
		179,
		174,
		165,
		150,
		156,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		216,
		259,
		253,
		256,
		280,
		294,
		-1,
		237,
		-1,
		-1,
		233,
		221,
		205,
		195,
		189,
		239,
		194,
		189,
		173,
		171,
		162,
		153,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		251,
		239,
		247,
		-1,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		249,
		-1,
		232,
		-1,
		207,
		211,
		202,
		205,
		187,
		174,
		166,
		158,
		174,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		308,
		264,
		247,
		238,
		285,
		300,
		304,
		-1,
		249,
		288,
		286,
		-1,
		258,
		-1,
		-1,
		-1,
		221,
		215,
		207,
		207,
		186,
		186,
		160,
		164,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		304,
		295,
		308,
		253,
		252,
		270,
		279,
		300,
		264,
		255,
		282,
		293,
		282,
		277,
		264,
		-1,
		-1,
		244,
		225,
		-1,
		-1,
		193,
		181,
		164,
		165,
		161,
		164,
		179,
		182,
		172,
		170,
		164,
		196,
		-1,
		297,
		296,
		285,
		282,
		258,
		249,
		244,
		271,
		-1,
		-1,
		266,
		283,
		277,
		281,
		297,
		322,
		-1,
		253,
		-1,
		-1,
		238,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		169,
		180,
		190,
		178,
		179,
		169,
		179,
		192,
		281,
		278,
		266,
		264,
		287,
		252,
		240,
		-1,
		253,
		251,
		257,
		264,
		281,
		311,
		-1,
		-1,
		269,
		249,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		171,
		176,
		196,
		198,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		290,
		304,
		293,
		289,
		288,
		296,
		245,
		238,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		-1,
		259,
		255,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		189,
		193,
		185,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		324,
		-1,
		276,
		252,
		266,
		281,
		289,
		-1,
		-1,
		-1,
		276,
		262,
		255,
		243,
		241,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		264,
		267,
		-1,
		-1,
		266,
		268,
		-1,
		267,
		256,
		241,
		233,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		271,
		272,
		273,
		-1,
		251,
		-1,
		269,
		-1,
		236,
		242,
		230,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		212,
		210,
		201,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		269,
		243,
		276,
		267,
		250,
		230,
		222,
		241,
		-1,
		211,
		-1,
		186,
		188,
		214,
		217,
		223,
		217,
		190,
		205,
		195,
		186,
		195,
		275,
		-1,
		245,
		278,
		242,
		236,
		212,
		216,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		239,
		224,
		205,
		192,
		199,
		199,
		192,
		-1,
		-1,
		-1,
		247,
		246,
		238,
		232,
		232,
		217,
		208,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		229,
		225,
		212,
		212,
		204,
		-1,
		348,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		241,
		236,
		209,
		197,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		205,
		240,
		-1,
		343,
		-1,
		277,
		-1,
		-1,
		259,
		239,
		231,
		220,
		209,
		207,
		198,
		189,
		211,
		227,
		211,
		209,
		212,
		213,
		-1,
		332,
		331,
		-1,
		278,
		270,
		256,
		-1,
		249,
		-1,
		255,
		216,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		319,
		294,
		-1,
		-1,
		-1,
		279,
		259,
		250,
		234,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		304,
		303,
		-1,
		272,
		275,
		-1,
		265,
		256,
		264,
		211,
		215,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		287,
		285,
		280,
		277,
		263,
		247,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		285,
		277,
		270,
		-1,
		-1,
		272,
		255,
		236,
		234,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		262,
		-1,
		-1,
		268,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		296,
		-1,
		-1,
		-1,
		258,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		318,
		319,
		342,
		306,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		321,
		319,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		59,
		48,
		59,
		67,
		40,
		47,
		-1,
		64,
		70,
		36,
		30,
		64,
		35,
		24,
		53,
		-1,
		-1,
		-1,
		59,
		58,
		24,
		22,
		0,
		30,
		43,
		-1,
		90,
		-1,
		80,
		59,
		70,
		75,
		17,
		20,
		36,
		63,
		85,
		87,
		95,
		44,
		24,
		25,
		48,
		59,
		89,
		86,
		-1,
		31,
		28,
		50,
		64,
		79,
		83,
		-1,
		-1,
		32,
		42,
		49,
		64,
		83,
		89,
		-1,
		99,
		118,
		-1,
		-1,
		32,
		45,
		58,
		61,
		69,
		78,
		91,
		108,
		113,
		-1,
		-1,
		50,
		54,
		64,
		65,
		61,
		78,
		97,
		108,
		122,
		121,
		-1,
		52,
		70,
		79,
		72,
		70,
		54,
		58,
		76,
		107,
		113,
		116,
		-1,
		69,
		65,
		75,
		81,
		92,
		70,
		57,
		63,
		82,
		95,
		114,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		70,
		61,
		81,
		83,
		82,
		91,
		89,
		60,
		66,
		70,
		87,
		103,
		104,
		114,
		-1,
		-1,
		163,
		136,
		160,
		118,
		100,
		-1,
		66,
		68,
		74,
		78,
		83,
		91,
		91,
		76,
		-1,
		81,
		80,
		111,
		97,
		108,
		145,
		-1,
		-1,
		121,
		113,
		95,
		98,
		75,
		71,
		83,
		82,
		78,
		80,
		82,
		94,
		84,
		97,
		104,
		75,
		85,
		89,
		104,
		115,
		-1,
		-1,
		189,
		-1,
		-1,
		142,
		125,
		-1,
		90,
		97,
		81,
		87,
		73,
		94,
		93,
		87,
		94,
		97,
		85,
		97,
		94,
		111,
		97,
		72,
		97,
		101,
		107,
		125,
		126,
		-1,
		188,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		97,
		94,
		87,
		111,
		110,
		-1,
		116,
		114,
		120,
		105,
		110,
		106,
		91,
		102,
		97,
		97,
		94,
		79,
		81,
		118,
		109,
		130,
		127,
		158,
		164,
		158,
		167,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		115,
		-1,
		118,
		131,
		128,
		116,
		119,
		106,
		114,
		113,
		97,
		108,
		95,
		92,
		91,
		87,
		96,
		106,
		105,
		123,
		136,
		151,
		155,
		161,
		-1,
		200,
		-1,
		142,
		126,
		128,
		104,
		132,
		-1,
		135,
		119,
		139,
		130,
		130,
		-1,
		122,
		119,
		129,
		112,
		97,
		107,
		95,
		90,
		90,
		94,
		109,
		100,
		118,
		125,
		133,
		137,
		157,
		169,
		160,
		150,
		-1,
		132,
		137,
		107,
		119,
		142,
		162,
		146,
		-1,
		141,
		-1,
		124,
		137,
		-1,
		118,
		114,
		103,
		103,
		92,
		99,
		97,
		91,
		88,
		106,
		109,
		126,
		130,
		146,
		-1,
		-1,
		145,
		149,
		157,
		108,
		127,
		151,
		188,
		155,
		148,
		147,
		-1,
		142,
		139,
		136,
		137,
		123,
		116,
		115,
		98,
		104,
		105,
		90,
		93,
		115,
		143,
		121,
		133,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		134,
		105,
		129,
		171,
		177,
		170,
		158,
		168,
		168,
		162,
		-1,
		154,
		133,
		126,
		115,
		105,
		121,
		111,
		114,
		94,
		96,
		112,
		124,
		115,
		135,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		108,
		142,
		160,
		201,
		187,
		192,
		167,
		160,
		154,
		148,
		150,
		133,
		122,
		114,
		103,
		112,
		122,
		116,
		96,
		105,
		106,
		130,
		137,
		143,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		133,
		140,
		172,
		192,
		205,
		-1,
		159,
		-1,
		148,
		143,
		127,
		122,
		119,
		116,
		110,
		119,
		124,
		110,
		101,
		116,
		135,
		135,
		127,
		152,
		155,
		-1,
		-1,
		-1,
		164,
		181,
		156,
		133,
		114,
		150,
		-1,
		175,
		176,
		-1,
		153,
		147,
		144,
		129,
		125,
		120,
		124,
		117,
		124,
		120,
		119,
		120,
		102,
		138,
		-1,
		135,
		129,
		157,
		160,
		150,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		121,
		173,
		-1,
		-1,
		160,
		153,
		-1,
		140,
		122,
		129,
		127,
		121,
		125,
		129,
		118,
		131,
		127,
		107,
		117,
		137,
		141,
		148,
		141,
		146,
		145,
		159,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		141,
		-1,
		169,
		161,
		151,
		145,
		139,
		135,
		133,
		149,
		133,
		136,
		136,
		132,
		140,
		125,
		124,
		110,
		114,
		132,
		159,
		154,
		149,
		148,
		155,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		156,
		-1,
		127,
		151,
		167,
		-1,
		177,
		156,
		171,
		149,
		145,
		141,
		156,
		157,
		135,
		140,
		139,
		149,
		146,
		135,
		122,
		126,
		141,
		151,
		143,
		144,
		153,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		130,
		139,
		154,
		-1,
		-1,
		213,
		-1,
		147,
		164,
		155,
		153,
		146,
		137,
		143,
		150,
		153,
		150,
		140,
		129,
		135,
		131,
		153,
		139,
		137,
		156,
		171,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		191,
		181,
		165,
		150,
		183,
		-1,
		154,
		138,
		143,
		-1,
		175,
		-1,
		148,
		148,
		139,
		128,
		125,
		136,
		134,
		145,
		162,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		187,
		-1,
		-1,
		178,
		172,
		172,
		156,
		159,
		170,
		150,
		144,
		143,
		170,
		165,
		156,
		137,
		130,
		127,
		128,
		141,
		161,
		152,
		164,
		-1,
		-1,
		-1,
		188,
		168,
		174,
		132,
		153,
		-1,
		-1,
		240,
		195,
		181,
		-1,
		165,
		187,
		175,
		165,
		155,
		189,
		181,
		156,
		149,
		135,
		137,
		135,
		137,
		142,
		163,
		164,
		177,
		-1,
		-1,
		165,
		172,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		187,
		203,
		195,
		166,
		176,
		-1,
		-1,
		167,
		165,
		173,
		152,
		139,
		159,
		162,
		152,
		136,
		151,
		163,
		171,
		176,
		-1,
		168,
		155,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		220,
		186,
		198,
		193,
		197,
		170,
		-1,
		169,
		163,
		143,
		157,
		164,
		154,
		149,
		143,
		146,
		164,
		181,
		-1,
		-1,
		182,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		177,
		191,
		186,
		179,
		183,
		-1,
		171,
		159,
		145,
		162,
		167,
		164,
		155,
		147,
		152,
		149,
		162,
		176,
		180,
		205,
		-1,
		188,
		-1,
		-1,
		-1,
		195,
		210,
		225,
		202,
		175,
		170,
		163,
		157,
		153,
		169,
		175,
		186,
		154,
		150,
		151,
		155,
		154,
		171,
		181,
		-1,
		-1,
		188,
		205,
		221,
		203,
		207,
		252,
		-1,
		-1,
		179,
		170,
		161,
		164,
		163,
		166,
		160,
		157,
		162,
		167,
		155,
		164,
		182,
		181,
		-1,
		-1,
		-1,
		208,
		-1,
		223,
		-1,
		-1,
		222,
		250,
		197,
		179,
		175,
		173,
		166,
		175,
		170,
		165,
		175,
		177,
		169,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		237,
		212,
		227,
		261,
		242,
		249,
		212,
		209,
		-1,
		179,
		204,
		176,
		183,
		174,
		181,
		181,
		173,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		243,
		229,
		247,
		237,
		240,
		-1,
		-1,
		228,
		225,
		201,
		184,
		182,
		175,
		170,
		180,
		160,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		213,
		294,
		287,
		270,
		278,
		309,
		-1,
		246,
		243,
		236,
		229,
		231,
		-1,
		-1,
		201,
		198,
		203,
		191,
		188,
		190,
		185,
		176,
		161,
		167,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		227,
		270,
		264,
		267,
		291,
		305,
		-1,
		248,
		-1,
		-1,
		244,
		232,
		216,
		206,
		200,
		250,
		205,
		200,
		184,
		182,
		173,
		164,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		262,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		260,
		-1,
		243,
		-1,
		218,
		222,
		213,
		216,
		198,
		185,
		177,
		169,
		185,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		319,
		275,
		258,
		249,
		296,
		311,
		315,
		-1,
		260,
		299,
		297,
		-1,
		269,
		-1,
		-1,
		-1,
		232,
		226,
		218,
		218,
		197,
		197,
		171,
		175,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		315,
		306,
		319,
		264,
		263,
		281,
		290,
		311,
		275,
		266,
		293,
		304,
		293,
		288,
		275,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		204,
		192,
		175,
		176,
		172,
		175,
		190,
		193,
		183,
		181,
		175,
		207,
		-1,
		308,
		307,
		296,
		293,
		269,
		260,
		255,
		282,
		-1,
		-1,
		277,
		294,
		288,
		292,
		308,
		333,
		-1,
		264,
		-1,
		-1,
		249,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		180,
		191,
		201,
		189,
		190,
		180,
		190,
		203,
		292,
		289,
		277,
		275,
		298,
		263,
		251,
		-1,
		264,
		262,
		268,
		275,
		292,
		322,
		-1,
		-1,
		280,
		260,
		-1,
		-1,
		232,
		230,
		219,
		-1,
		209,
		182,
		187,
		207,
		209,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		301,
		315,
		304,
		300,
		299,
		307,
		256,
		249,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		-1,
		270,
		266,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		200,
		204,
		196,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		335,
		-1,
		287,
		263,
		277,
		292,
		300,
		-1,
		-1,
		-1,
		287,
		273,
		266,
		254,
		252,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		275,
		278,
		-1,
		-1,
		277,
		279,
		-1,
		278,
		267,
		252,
		244,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		282,
		283,
		284,
		-1,
		262,
		-1,
		280,
		-1,
		247,
		253,
		241,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		223,
		221,
		212,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		280,
		254,
		287,
		278,
		261,
		241,
		233,
		252,
		-1,
		222,
		-1,
		197,
		199,
		225,
		228,
		234,
		228,
		201,
		216,
		206,
		197,
		206,
		286,
		-1,
		256,
		289,
		253,
		247,
		223,
		227,
		243,
		-1,
		219,
		201,
		-1,
		229,
		219,
		250,
		235,
		216,
		203,
		210,
		210,
		203,
		-1,
		-1,
		-1,
		258,
		257,
		249,
		243,
		243,
		228,
		219,
		-1,
		231,
		213,
		192,
		209,
		209,
		200,
		208,
		240,
		236,
		223,
		223,
		215,
		-1,
		359,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		252,
		247,
		220,
		208,
		214,
		210,
		196,
		202,
		204,
		212,
		210,
		207,
		219,
		215,
		235,
		216,
		251,
		-1,
		354,
		-1,
		288,
		-1,
		-1,
		270,
		250,
		242,
		231,
		220,
		218,
		209,
		200,
		222,
		238,
		222,
		220,
		223,
		224,
		-1,
		343,
		342,
		-1,
		289,
		281,
		267,
		-1,
		260,
		-1,
		266,
		227,
		-1,
		229,
		209,
		-1,
		231,
		227,
		-1,
		-1,
		330,
		305,
		-1,
		-1,
		-1,
		290,
		270,
		261,
		245,
		-1,
		220,
		220,
		-1,
		-1,
		-1,
		315,
		314,
		-1,
		283,
		286,
		-1,
		276,
		267,
		275,
		222,
		226,
		-1,
		-1,
		-1,
		324,
		305,
		299,
		298,
		296,
		291,
		288,
		274,
		258,
		236,
		225,
		246,
		-1,
		-1,
		-1,
		296,
		288,
		281,
		-1,
		-1,
		283,
		266,
		247,
		245,
		-1,
		-1,
		-1,
		318,
		299,
		-1,
		-1,
		273,
		-1,
		-1,
		279,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		335,
		307,
		-1,
		-1,
		-1,
		269,
		265,
		266,
		-1,
		-1,
		-1,
		-1,
		329,
		330,
		353,
		317,
		-1,
		-1,
		-1,
		261,
		255,
		-1,
		-1,
		332,
		330,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		259,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		294,
		-1,
		294,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		307,
		-1,
		279,
		281,
		-1,
		329,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		284,
		291,
		313,
		316,
		352,
		-1,
		303
	],
	[
		-1,
		63,
		52,
		63,
		71,
		44,
		51,
		-1,
		68,
		74,
		40,
		34,
		71,
		40,
		40,
		57,
		-1,
		-1,
		-1,
		63,
		62,
		28,
		26,
		29,
		0,
		47,
		-1,
		94,
		-1,
		84,
		63,
		74,
		79,
		21,
		24,
		40,
		67,
		89,
		91,
		99,
		48,
		28,
		29,
		52,
		63,
		93,
		90,
		-1,
		35,
		32,
		54,
		68,
		83,
		87,
		-1,
		-1,
		36,
		46,
		53,
		68,
		87,
		93,
		-1,
		103,
		122,
		-1,
		-1,
		36,
		49,
		62,
		65,
		73,
		82,
		95,
		112,
		117,
		-1,
		-1,
		54,
		58,
		68,
		69,
		65,
		82,
		101,
		112,
		126,
		125,
		-1,
		56,
		74,
		83,
		76,
		74,
		58,
		62,
		80,
		111,
		117,
		120,
		-1,
		73,
		69,
		79,
		85,
		96,
		74,
		61,
		67,
		86,
		99,
		118,
		109,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		74,
		65,
		85,
		87,
		86,
		95,
		93,
		64,
		70,
		74,
		91,
		107,
		108,
		118,
		-1,
		-1,
		167,
		140,
		164,
		122,
		104,
		-1,
		70,
		72,
		78,
		82,
		87,
		95,
		95,
		80,
		-1,
		85,
		84,
		115,
		101,
		112,
		149,
		-1,
		-1,
		125,
		117,
		99,
		102,
		79,
		75,
		87,
		86,
		82,
		84,
		86,
		98,
		88,
		101,
		108,
		79,
		89,
		93,
		108,
		119,
		-1,
		-1,
		193,
		-1,
		-1,
		146,
		129,
		-1,
		94,
		101,
		85,
		91,
		77,
		98,
		97,
		91,
		98,
		101,
		89,
		101,
		98,
		115,
		101,
		76,
		101,
		105,
		111,
		129,
		130,
		-1,
		192,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		101,
		98,
		91,
		115,
		114,
		-1,
		120,
		118,
		124,
		109,
		114,
		110,
		95,
		106,
		101,
		101,
		98,
		83,
		85,
		122,
		113,
		134,
		131,
		162,
		168,
		162,
		171,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		119,
		-1,
		122,
		135,
		132,
		120,
		123,
		110,
		118,
		117,
		101,
		112,
		99,
		96,
		95,
		91,
		100,
		110,
		109,
		127,
		140,
		155,
		159,
		165,
		-1,
		204,
		-1,
		146,
		130,
		132,
		108,
		136,
		-1,
		139,
		123,
		143,
		134,
		134,
		-1,
		126,
		123,
		133,
		116,
		101,
		111,
		99,
		94,
		94,
		98,
		113,
		104,
		122,
		129,
		137,
		141,
		161,
		173,
		164,
		154,
		-1,
		136,
		141,
		111,
		123,
		146,
		166,
		150,
		-1,
		145,
		-1,
		128,
		141,
		-1,
		122,
		118,
		107,
		107,
		96,
		103,
		101,
		95,
		92,
		110,
		113,
		130,
		134,
		150,
		-1,
		-1,
		149,
		153,
		161,
		112,
		131,
		155,
		192,
		159,
		152,
		151,
		-1,
		146,
		143,
		140,
		141,
		127,
		120,
		119,
		102,
		108,
		109,
		94,
		97,
		119,
		147,
		125,
		137,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		138,
		109,
		133,
		175,
		181,
		174,
		162,
		172,
		172,
		166,
		-1,
		158,
		137,
		130,
		119,
		109,
		125,
		115,
		118,
		98,
		100,
		116,
		128,
		119,
		139,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		112,
		146,
		164,
		205,
		191,
		196,
		171,
		164,
		158,
		152,
		154,
		137,
		126,
		118,
		107,
		116,
		126,
		120,
		100,
		109,
		110,
		134,
		141,
		147,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		137,
		144,
		176,
		196,
		209,
		-1,
		163,
		-1,
		152,
		147,
		131,
		126,
		123,
		120,
		114,
		123,
		128,
		114,
		105,
		120,
		139,
		139,
		131,
		156,
		159,
		-1,
		-1,
		-1,
		168,
		185,
		160,
		137,
		118,
		154,
		-1,
		179,
		180,
		-1,
		157,
		151,
		148,
		133,
		129,
		124,
		128,
		121,
		128,
		124,
		123,
		124,
		106,
		142,
		-1,
		139,
		133,
		161,
		164,
		154,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		125,
		177,
		-1,
		-1,
		164,
		157,
		-1,
		144,
		126,
		133,
		131,
		125,
		129,
		133,
		122,
		135,
		131,
		111,
		121,
		141,
		145,
		152,
		145,
		150,
		149,
		163,
		-1,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		145,
		-1,
		173,
		165,
		155,
		149,
		143,
		139,
		137,
		153,
		137,
		140,
		140,
		136,
		144,
		129,
		128,
		114,
		118,
		136,
		163,
		158,
		153,
		152,
		159,
		-1,
		231,
		217,
		188,
		-1,
		-1,
		160,
		-1,
		131,
		155,
		171,
		-1,
		181,
		160,
		175,
		153,
		149,
		145,
		160,
		161,
		139,
		144,
		143,
		153,
		150,
		139,
		126,
		130,
		145,
		155,
		147,
		148,
		157,
		-1,
		237,
		224,
		182,
		178,
		167,
		187,
		134,
		143,
		158,
		-1,
		-1,
		217,
		-1,
		151,
		168,
		159,
		157,
		150,
		141,
		147,
		154,
		157,
		154,
		144,
		133,
		139,
		135,
		157,
		143,
		141,
		160,
		175,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		153,
		140,
		134,
		-1,
		175,
		-1,
		195,
		185,
		169,
		154,
		187,
		-1,
		158,
		142,
		147,
		-1,
		179,
		-1,
		152,
		152,
		143,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		187,
		172,
		165,
		155,
		169,
		140,
		-1,
		191,
		-1,
		-1,
		182,
		176,
		176,
		160,
		163,
		174,
		154,
		148,
		147,
		174,
		169,
		160,
		141,
		134,
		131,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		192,
		172,
		178,
		136,
		157,
		-1,
		-1,
		244,
		199,
		185,
		-1,
		169,
		191,
		179,
		169,
		159,
		193,
		185,
		160,
		153,
		139,
		141,
		139,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		169,
		176,
		164,
		150,
		169,
		-1,
		-1,
		-1,
		191,
		207,
		199,
		170,
		180,
		-1,
		-1,
		171,
		169,
		177,
		156,
		143,
		163,
		166,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		172,
		159,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		-1,
		-1,
		224,
		190,
		202,
		197,
		201,
		174,
		-1,
		173,
		167,
		147,
		161,
		168,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		186,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		181,
		195,
		190,
		183,
		187,
		-1,
		175,
		163,
		149,
		166,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		209,
		-1,
		192,
		-1,
		-1,
		-1,
		199,
		214,
		229,
		206,
		179,
		174,
		167,
		161,
		157,
		173,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		192,
		209,
		225,
		207,
		211,
		256,
		-1,
		-1,
		183,
		174,
		165,
		168,
		167,
		170,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		185,
		-1,
		-1,
		-1,
		212,
		-1,
		227,
		-1,
		-1,
		226,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		181,
		173,
		161,
		165,
		188,
		177,
		216,
		-1,
		-1,
		329,
		-1,
		-1,
		-1,
		241,
		216,
		231,
		265,
		246,
		253,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		178,
		185,
		185,
		177,
		155,
		162,
		178,
		177,
		172,
		208,
		199,
		205,
		-1,
		-1,
		322,
		311,
		300,
		306,
		-1,
		247,
		233,
		251,
		241,
		244,
		-1,
		-1,
		232,
		229,
		205,
		188,
		186,
		179,
		174,
		184,
		164,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		217,
		298,
		291,
		274,
		282,
		313,
		-1,
		250,
		247,
		240,
		233,
		235,
		-1,
		-1,
		205,
		202,
		207,
		195,
		192,
		194,
		189,
		180,
		165,
		171,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		231,
		274,
		268,
		271,
		295,
		309,
		-1,
		252,
		-1,
		-1,
		248,
		236,
		220,
		210,
		204,
		254,
		209,
		204,
		188,
		186,
		177,
		168,
		175,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		266,
		254,
		262,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		264,
		-1,
		247,
		-1,
		222,
		226,
		217,
		220,
		202,
		189,
		181,
		173,
		189,
		164,
		174,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		323,
		279,
		262,
		253,
		300,
		315,
		319,
		-1,
		264,
		303,
		301,
		-1,
		273,
		-1,
		-1,
		-1,
		236,
		230,
		222,
		222,
		201,
		201,
		175,
		179,
		169,
		176,
		186,
		188,
		180,
		184,
		197,
		208,
		211,
		319,
		310,
		323,
		268,
		267,
		285,
		294,
		315,
		279,
		270,
		297,
		308,
		297,
		292,
		279,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		208,
		196,
		179,
		180,
		176,
		179,
		194,
		197,
		187,
		185,
		179,
		211,
		-1,
		312,
		311,
		300,
		297,
		273,
		264,
		259,
		286,
		-1,
		-1,
		281,
		298,
		292,
		296,
		312,
		337,
		-1,
		268,
		-1,
		-1,
		253,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		184,
		195,
		205,
		193,
		194,
		184,
		194,
		207,
		296,
		293,
		281,
		279,
		302,
		267,
		255,
		-1,
		268,
		266,
		272,
		279,
		296,
		326,
		-1,
		-1,
		284,
		264,
		-1,
		-1,
		236,
		234,
		223,
		-1,
		213,
		186,
		191,
		211,
		213,
		202,
		196,
		190,
		197,
		196,
		204,
		212,
		305,
		319,
		308,
		304,
		303,
		311,
		260,
		253,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		-1,
		274,
		270,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		204,
		208,
		200,
		193,
		188,
		199,
		191,
		195,
		212,
		-1,
		339,
		-1,
		291,
		267,
		281,
		296,
		304,
		-1,
		-1,
		-1,
		291,
		277,
		270,
		258,
		256,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		194,
		205,
		194,
		197,
		211,
		206,
		-1,
		-1,
		279,
		282,
		-1,
		-1,
		281,
		283,
		-1,
		282,
		271,
		256,
		248,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		198,
		204,
		207,
		196,
		200,
		212,
		-1,
		-1,
		286,
		287,
		288,
		-1,
		266,
		-1,
		284,
		-1,
		251,
		257,
		245,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		227,
		225,
		216,
		202,
		209,
		207,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		258,
		291,
		282,
		265,
		245,
		237,
		256,
		-1,
		226,
		-1,
		201,
		203,
		229,
		232,
		238,
		232,
		205,
		220,
		210,
		201,
		210,
		290,
		-1,
		260,
		293,
		257,
		251,
		227,
		231,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		254,
		239,
		220,
		207,
		214,
		214,
		207,
		-1,
		-1,
		-1,
		262,
		261,
		253,
		247,
		247,
		232,
		223,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		244,
		240,
		227,
		227,
		219,
		-1,
		363,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		256,
		251,
		224,
		212,
		218,
		214,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		220,
		255,
		-1,
		358,
		-1,
		292,
		-1,
		-1,
		274,
		254,
		246,
		235,
		224,
		222,
		213,
		204,
		226,
		242,
		226,
		224,
		227,
		228,
		-1,
		347,
		346,
		-1,
		293,
		285,
		271,
		-1,
		264,
		-1,
		270,
		231,
		-1,
		233,
		213,
		-1,
		235,
		231,
		-1,
		-1,
		334,
		309,
		-1,
		-1,
		-1,
		294,
		274,
		265,
		249,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		319,
		318,
		-1,
		287,
		290,
		-1,
		280,
		271,
		279,
		226,
		230,
		-1,
		-1,
		-1,
		328,
		309,
		303,
		302,
		300,
		295,
		292,
		278,
		262,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		300,
		292,
		285,
		-1,
		-1,
		287,
		270,
		251,
		249,
		-1,
		-1,
		-1,
		322,
		303,
		-1,
		-1,
		277,
		-1,
		-1,
		283,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		311,
		-1,
		-1,
		-1,
		273,
		269,
		270,
		-1,
		-1,
		-1,
		-1,
		333,
		334,
		357,
		321,
		-1,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		336,
		334,
		-1,
		-1,
		-1,
		293,
		277,
		-1,
		263,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		298,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		311,
		303,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		326,
		317,
		-1,
		-1,
		288,
		295,
		317,
		320,
		356,
		-1,
		307
	],
	[
		-1,
		69,
		58,
		69,
		77,
		50,
		57,
		-1,
		21,
		80,
		46,
		40,
		77,
		46,
		52,
		10,
		-1,
		-1,
		-1,
		69,
		68,
		34,
		32,
		41,
		46,
		0,
		-1,
		104,
		-1,
		90,
		69,
		80,
		85,
		27,
		30,
		50,
		77,
		99,
		101,
		105,
		57,
		34,
		35,
		58,
		69,
		103,
		96,
		-1,
		41,
		38,
		60,
		74,
		89,
		93,
		-1,
		-1,
		42,
		52,
		59,
		74,
		93,
		99,
		-1,
		109,
		128,
		-1,
		-1,
		42,
		55,
		68,
		71,
		79,
		88,
		101,
		118,
		123,
		-1,
		-1,
		60,
		64,
		74,
		75,
		71,
		88,
		107,
		118,
		132,
		131,
		-1,
		62,
		80,
		89,
		82,
		80,
		64,
		68,
		86,
		117,
		123,
		126,
		-1,
		79,
		75,
		85,
		91,
		102,
		80,
		67,
		73,
		92,
		105,
		124,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		80,
		71,
		91,
		93,
		92,
		101,
		99,
		70,
		76,
		80,
		97,
		113,
		114,
		124,
		-1,
		-1,
		173,
		146,
		170,
		128,
		110,
		-1,
		76,
		78,
		84,
		88,
		93,
		101,
		101,
		86,
		-1,
		91,
		90,
		121,
		107,
		118,
		155,
		-1,
		-1,
		131,
		123,
		105,
		108,
		85,
		81,
		93,
		92,
		88,
		90,
		92,
		104,
		94,
		107,
		114,
		85,
		95,
		99,
		114,
		125,
		-1,
		-1,
		199,
		-1,
		-1,
		152,
		135,
		-1,
		100,
		107,
		91,
		97,
		83,
		104,
		103,
		97,
		104,
		107,
		95,
		107,
		104,
		121,
		107,
		82,
		107,
		111,
		117,
		135,
		136,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		107,
		104,
		97,
		121,
		120,
		-1,
		126,
		124,
		130,
		115,
		120,
		116,
		101,
		112,
		107,
		107,
		104,
		89,
		91,
		128,
		119,
		140,
		137,
		168,
		174,
		168,
		177,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		125,
		-1,
		128,
		141,
		138,
		126,
		129,
		116,
		124,
		123,
		107,
		118,
		105,
		102,
		101,
		97,
		106,
		116,
		115,
		133,
		146,
		161,
		165,
		171,
		-1,
		210,
		-1,
		152,
		136,
		138,
		114,
		142,
		-1,
		145,
		129,
		149,
		140,
		140,
		-1,
		132,
		129,
		139,
		122,
		107,
		117,
		105,
		100,
		100,
		104,
		119,
		110,
		128,
		135,
		143,
		147,
		167,
		179,
		170,
		160,
		-1,
		142,
		147,
		117,
		129,
		152,
		172,
		156,
		-1,
		151,
		-1,
		134,
		147,
		-1,
		128,
		124,
		113,
		113,
		102,
		109,
		107,
		101,
		98,
		116,
		119,
		136,
		140,
		156,
		-1,
		-1,
		155,
		159,
		167,
		118,
		137,
		161,
		198,
		165,
		158,
		157,
		-1,
		152,
		149,
		146,
		147,
		133,
		126,
		125,
		108,
		114,
		115,
		100,
		103,
		125,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		144,
		115,
		139,
		181,
		187,
		180,
		168,
		178,
		178,
		172,
		-1,
		164,
		143,
		136,
		125,
		115,
		131,
		121,
		124,
		104,
		106,
		122,
		134,
		125,
		145,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		118,
		152,
		170,
		211,
		197,
		202,
		177,
		170,
		164,
		158,
		160,
		143,
		132,
		124,
		113,
		122,
		132,
		126,
		106,
		115,
		116,
		140,
		147,
		153,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		143,
		150,
		182,
		202,
		215,
		-1,
		169,
		-1,
		158,
		153,
		137,
		132,
		129,
		126,
		120,
		129,
		134,
		120,
		111,
		126,
		145,
		145,
		137,
		162,
		165,
		-1,
		-1,
		-1,
		174,
		191,
		166,
		143,
		124,
		160,
		-1,
		185,
		186,
		-1,
		163,
		157,
		154,
		139,
		135,
		130,
		134,
		127,
		134,
		130,
		129,
		130,
		112,
		148,
		-1,
		145,
		139,
		167,
		170,
		160,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		131,
		183,
		-1,
		-1,
		170,
		163,
		-1,
		150,
		132,
		139,
		137,
		131,
		135,
		139,
		128,
		141,
		137,
		117,
		127,
		147,
		151,
		158,
		151,
		156,
		155,
		169,
		-1,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		151,
		-1,
		179,
		171,
		161,
		155,
		149,
		145,
		143,
		159,
		143,
		146,
		146,
		142,
		150,
		135,
		134,
		120,
		124,
		142,
		169,
		164,
		159,
		158,
		165,
		-1,
		237,
		223,
		194,
		-1,
		-1,
		166,
		-1,
		137,
		161,
		177,
		-1,
		187,
		166,
		181,
		159,
		155,
		151,
		166,
		167,
		145,
		150,
		149,
		159,
		156,
		145,
		132,
		136,
		151,
		161,
		153,
		154,
		163,
		-1,
		243,
		230,
		188,
		184,
		173,
		193,
		140,
		149,
		164,
		-1,
		-1,
		223,
		-1,
		157,
		174,
		165,
		163,
		156,
		147,
		153,
		160,
		163,
		160,
		150,
		139,
		145,
		141,
		163,
		149,
		147,
		166,
		181,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		159,
		146,
		140,
		-1,
		181,
		-1,
		201,
		191,
		175,
		160,
		193,
		-1,
		164,
		148,
		153,
		-1,
		185,
		-1,
		158,
		158,
		149,
		138,
		135,
		146,
		144,
		155,
		172,
		-1,
		193,
		178,
		171,
		161,
		175,
		146,
		-1,
		197,
		-1,
		-1,
		188,
		182,
		182,
		166,
		169,
		180,
		160,
		154,
		153,
		180,
		175,
		166,
		147,
		140,
		137,
		138,
		151,
		171,
		162,
		174,
		-1,
		-1,
		-1,
		198,
		178,
		184,
		142,
		163,
		-1,
		-1,
		250,
		205,
		191,
		-1,
		175,
		197,
		185,
		175,
		165,
		199,
		191,
		166,
		159,
		145,
		147,
		145,
		147,
		152,
		173,
		174,
		187,
		-1,
		-1,
		175,
		182,
		170,
		156,
		175,
		-1,
		-1,
		-1,
		197,
		213,
		205,
		176,
		186,
		-1,
		-1,
		177,
		175,
		183,
		162,
		149,
		169,
		172,
		162,
		146,
		161,
		173,
		181,
		186,
		-1,
		178,
		165,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		-1,
		-1,
		230,
		196,
		208,
		203,
		207,
		180,
		-1,
		179,
		173,
		153,
		167,
		174,
		164,
		159,
		153,
		156,
		174,
		191,
		-1,
		-1,
		192,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		187,
		201,
		196,
		189,
		193,
		-1,
		181,
		169,
		155,
		172,
		177,
		174,
		165,
		157,
		162,
		159,
		172,
		186,
		190,
		215,
		-1,
		198,
		-1,
		-1,
		-1,
		205,
		220,
		235,
		212,
		185,
		180,
		173,
		167,
		163,
		179,
		185,
		196,
		164,
		160,
		161,
		165,
		164,
		181,
		191,
		-1,
		-1,
		198,
		215,
		231,
		213,
		217,
		262,
		-1,
		-1,
		189,
		180,
		171,
		174,
		173,
		176,
		170,
		167,
		172,
		177,
		165,
		174,
		192,
		191,
		-1,
		-1,
		-1,
		218,
		-1,
		233,
		-1,
		-1,
		232,
		260,
		207,
		189,
		185,
		183,
		176,
		185,
		180,
		175,
		185,
		187,
		179,
		167,
		171,
		194,
		183,
		222,
		-1,
		-1,
		335,
		-1,
		-1,
		-1,
		247,
		222,
		237,
		271,
		252,
		259,
		222,
		219,
		-1,
		189,
		214,
		186,
		193,
		184,
		191,
		191,
		183,
		161,
		168,
		184,
		183,
		178,
		214,
		205,
		211,
		-1,
		-1,
		328,
		317,
		306,
		312,
		-1,
		253,
		239,
		257,
		247,
		250,
		-1,
		-1,
		238,
		235,
		211,
		194,
		192,
		185,
		180,
		190,
		170,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		223,
		304,
		297,
		280,
		288,
		319,
		-1,
		256,
		253,
		246,
		239,
		241,
		-1,
		-1,
		211,
		208,
		213,
		201,
		198,
		200,
		195,
		186,
		171,
		177,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		237,
		280,
		274,
		277,
		301,
		315,
		-1,
		258,
		-1,
		-1,
		254,
		242,
		226,
		216,
		210,
		260,
		215,
		210,
		194,
		192,
		183,
		174,
		181,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		272,
		260,
		268,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		270,
		-1,
		253,
		-1,
		228,
		232,
		223,
		226,
		208,
		195,
		187,
		179,
		195,
		170,
		180,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		329,
		285,
		268,
		259,
		306,
		321,
		325,
		-1,
		270,
		309,
		307,
		-1,
		279,
		-1,
		-1,
		-1,
		242,
		236,
		228,
		228,
		207,
		207,
		181,
		185,
		175,
		182,
		192,
		194,
		186,
		190,
		203,
		214,
		217,
		325,
		316,
		329,
		274,
		273,
		291,
		300,
		321,
		285,
		276,
		303,
		314,
		303,
		298,
		285,
		-1,
		-1,
		265,
		246,
		-1,
		-1,
		214,
		202,
		185,
		186,
		182,
		185,
		200,
		203,
		193,
		191,
		185,
		217,
		-1,
		318,
		317,
		306,
		303,
		279,
		270,
		265,
		292,
		-1,
		-1,
		287,
		304,
		298,
		302,
		318,
		343,
		-1,
		274,
		-1,
		-1,
		259,
		-1,
		-1,
		244,
		207,
		196,
		187,
		193,
		190,
		201,
		211,
		199,
		200,
		190,
		200,
		213,
		302,
		299,
		287,
		285,
		308,
		273,
		261,
		-1,
		274,
		272,
		278,
		285,
		302,
		332,
		-1,
		-1,
		290,
		270,
		-1,
		-1,
		242,
		240,
		229,
		-1,
		219,
		192,
		197,
		217,
		219,
		208,
		202,
		196,
		203,
		202,
		210,
		218,
		311,
		325,
		314,
		310,
		309,
		317,
		266,
		259,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		-1,
		280,
		276,
		-1,
		-1,
		237,
		230,
		218,
		206,
		196,
		206,
		210,
		214,
		206,
		199,
		194,
		205,
		197,
		201,
		218,
		-1,
		345,
		-1,
		297,
		273,
		287,
		302,
		310,
		-1,
		-1,
		-1,
		297,
		283,
		276,
		264,
		262,
		-1,
		271,
		255,
		236,
		-1,
		206,
		219,
		250,
		218,
		223,
		218,
		200,
		211,
		200,
		203,
		217,
		212,
		-1,
		-1,
		285,
		288,
		-1,
		-1,
		287,
		289,
		-1,
		288,
		277,
		262,
		254,
		-1,
		-1,
		243,
		239,
		-1,
		-1,
		207,
		232,
		221,
		229,
		224,
		204,
		210,
		213,
		202,
		206,
		218,
		-1,
		-1,
		292,
		293,
		294,
		-1,
		272,
		-1,
		290,
		-1,
		257,
		263,
		251,
		-1,
		-1,
		-1,
		245,
		208,
		229,
		239,
		233,
		231,
		222,
		208,
		215,
		213,
		209,
		220,
		-1,
		-1,
		-1,
		290,
		264,
		297,
		288,
		271,
		251,
		243,
		262,
		-1,
		232,
		-1,
		207,
		209,
		235,
		238,
		244,
		238,
		211,
		226,
		216,
		207,
		216,
		296,
		-1,
		266,
		299,
		263,
		257,
		233,
		237,
		253,
		-1,
		229,
		211,
		-1,
		239,
		229,
		260,
		245,
		226,
		213,
		220,
		220,
		213,
		-1,
		-1,
		-1,
		268,
		267,
		259,
		253,
		253,
		238,
		229,
		-1,
		241,
		223,
		202,
		219,
		219,
		210,
		218,
		250,
		246,
		233,
		233,
		225,
		-1,
		369,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		262,
		257,
		230,
		218,
		224,
		220,
		206,
		212,
		214,
		222,
		220,
		217,
		229,
		225,
		245,
		226,
		261,
		-1,
		364,
		-1,
		298,
		-1,
		-1,
		280,
		260,
		252,
		241,
		230,
		228,
		219,
		210,
		232,
		248,
		232,
		230,
		233,
		234,
		-1,
		353,
		352,
		-1,
		299,
		291,
		277,
		-1,
		270,
		-1,
		276,
		237,
		-1,
		239,
		219,
		-1,
		241,
		237,
		-1,
		-1,
		340,
		315,
		-1,
		-1,
		-1,
		300,
		280,
		271,
		255,
		-1,
		230,
		230,
		-1,
		-1,
		-1,
		325,
		324,
		-1,
		293,
		296,
		-1,
		286,
		277,
		285,
		232,
		236,
		-1,
		-1,
		-1,
		334,
		315,
		309,
		308,
		306,
		301,
		298,
		284,
		268,
		246,
		235,
		256,
		-1,
		-1,
		-1,
		306,
		298,
		291,
		-1,
		-1,
		293,
		276,
		257,
		255,
		-1,
		-1,
		-1,
		328,
		309,
		-1,
		-1,
		283,
		-1,
		-1,
		289,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		345,
		317,
		-1,
		-1,
		-1,
		279,
		275,
		276,
		-1,
		-1,
		-1,
		-1,
		339,
		340,
		363,
		327,
		-1,
		-1,
		-1,
		271,
		265,
		-1,
		-1,
		342,
		340,
		-1,
		-1,
		-1,
		299,
		283,
		-1,
		269,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		304,
		-1,
		304,
		279,
		286,
		-1,
		-1,
		-1,
		-1,
		317,
		309,
		317,
		-1,
		289,
		291,
		-1,
		339,
		-1,
		-1,
		332,
		323,
		-1,
		-1,
		294,
		301,
		323,
		326,
		362,
		-1,
		313
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		120,
		109,
		120,
		128,
		101,
		108,
		-1,
		125,
		131,
		97,
		91,
		128,
		97,
		103,
		114,
		-1,
		-1,
		-1,
		120,
		119,
		85,
		83,
		92,
		97,
		104,
		-1,
		0,
		-1,
		141,
		120,
		131,
		136,
		78,
		75,
		54,
		29,
		8,
		14,
		156,
		108,
		75,
		75,
		50,
		59,
		12,
		20,
		-1,
		79,
		76,
		62,
		48,
		29,
		40,
		-1,
		-1,
		72,
		73,
		59,
		42,
		57,
		52,
		-1,
		107,
		98,
		-1,
		-1,
		76,
		75,
		63,
		54,
		43,
		66,
		99,
		116,
		103,
		-1,
		-1,
		71,
		65,
		68,
		61,
		65,
		96,
		105,
		115,
		118,
		120,
		-1,
		80,
		98,
		97,
		76,
		70,
		72,
		76,
		94,
		120,
		129,
		129,
		-1,
		97,
		93,
		103,
		101,
		96,
		71,
		75,
		81,
		100,
		111,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		98,
		89,
		109,
		111,
		110,
		92,
		90,
		78,
		84,
		88,
		105,
		121,
		122,
		132,
		-1,
		-1,
		191,
		164,
		188,
		146,
		128,
		-1,
		94,
		96,
		102,
		106,
		109,
		117,
		92,
		94,
		-1,
		99,
		98,
		129,
		115,
		126,
		173,
		-1,
		-1,
		149,
		141,
		123,
		126,
		103,
		99,
		111,
		110,
		106,
		108,
		110,
		117,
		102,
		115,
		122,
		93,
		103,
		107,
		122,
		133,
		-1,
		-1,
		207,
		-1,
		-1,
		170,
		153,
		-1,
		118,
		125,
		109,
		115,
		101,
		122,
		121,
		115,
		122,
		125,
		113,
		115,
		112,
		129,
		115,
		90,
		115,
		119,
		125,
		143,
		144,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		125,
		122,
		115,
		139,
		138,
		-1,
		144,
		142,
		148,
		133,
		138,
		134,
		119,
		120,
		115,
		115,
		112,
		97,
		99,
		136,
		127,
		148,
		145,
		176,
		182,
		176,
		185,
		-1,
		178,
		174,
		170,
		177,
		126,
		-1,
		-1,
		143,
		-1,
		146,
		159,
		156,
		144,
		147,
		134,
		142,
		141,
		125,
		126,
		113,
		110,
		109,
		105,
		114,
		124,
		123,
		141,
		154,
		169,
		173,
		179,
		-1,
		228,
		-1,
		170,
		154,
		156,
		132,
		160,
		-1,
		163,
		147,
		167,
		158,
		158,
		-1,
		150,
		147,
		157,
		140,
		125,
		125,
		113,
		108,
		108,
		112,
		127,
		118,
		136,
		143,
		151,
		155,
		175,
		187,
		188,
		178,
		-1,
		160,
		165,
		135,
		147,
		170,
		190,
		174,
		-1,
		169,
		-1,
		152,
		165,
		-1,
		146,
		142,
		131,
		121,
		110,
		117,
		115,
		109,
		106,
		124,
		127,
		144,
		148,
		164,
		-1,
		-1,
		173,
		177,
		185,
		136,
		155,
		179,
		216,
		183,
		176,
		175,
		-1,
		170,
		167,
		164,
		163,
		150,
		135,
		133,
		116,
		122,
		123,
		108,
		111,
		133,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		162,
		133,
		157,
		199,
		205,
		198,
		186,
		186,
		186,
		180,
		-1,
		174,
		153,
		144,
		133,
		123,
		139,
		129,
		132,
		112,
		114,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		136,
		170,
		188,
		219,
		205,
		210,
		185,
		178,
		172,
		176,
		170,
		151,
		140,
		132,
		121,
		130,
		140,
		134,
		114,
		123,
		124,
		148,
		155,
		161,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		161,
		168,
		200,
		210,
		223,
		-1,
		177,
		-1,
		166,
		161,
		145,
		140,
		137,
		134,
		128,
		137,
		142,
		128,
		119,
		134,
		153,
		153,
		145,
		170,
		173,
		-1,
		-1,
		-1,
		192,
		209,
		184,
		161,
		142,
		178,
		-1,
		193,
		194,
		-1,
		171,
		165,
		162,
		147,
		143,
		138,
		142,
		135,
		142,
		138,
		137,
		138,
		120,
		156,
		-1,
		153,
		147,
		175,
		178,
		168,
		-1,
		-1,
		-1,
		207,
		186,
		179,
		199,
		149,
		201,
		-1,
		-1,
		178,
		171,
		-1,
		158,
		140,
		147,
		145,
		139,
		143,
		147,
		136,
		149,
		145,
		125,
		135,
		155,
		159,
		166,
		159,
		164,
		163,
		177,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		169,
		-1,
		187,
		179,
		169,
		163,
		157,
		153,
		151,
		167,
		151,
		154,
		154,
		150,
		158,
		143,
		142,
		128,
		132,
		150,
		177,
		172,
		167,
		166,
		173,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		184,
		-1,
		155,
		179,
		195,
		-1,
		195,
		174,
		189,
		167,
		163,
		159,
		174,
		175,
		153,
		158,
		157,
		167,
		164,
		153,
		140,
		144,
		159,
		169,
		161,
		162,
		171,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		158,
		157,
		182,
		-1,
		-1,
		231,
		-1,
		165,
		182,
		173,
		171,
		164,
		155,
		161,
		168,
		171,
		168,
		158,
		147,
		153,
		149,
		171,
		157,
		155,
		174,
		189,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		209,
		199,
		183,
		168,
		201,
		-1,
		172,
		156,
		161,
		-1,
		193,
		-1,
		166,
		166,
		157,
		146,
		143,
		154,
		152,
		163,
		180,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		215,
		-1,
		-1,
		196,
		190,
		190,
		174,
		177,
		188,
		168,
		162,
		161,
		188,
		183,
		174,
		155,
		148,
		145,
		146,
		159,
		179,
		170,
		182,
		-1,
		-1,
		-1,
		216,
		196,
		202,
		160,
		181,
		-1,
		-1,
		258,
		213,
		199,
		-1,
		183,
		205,
		193,
		183,
		173,
		207,
		199,
		174,
		167,
		153,
		155,
		153,
		155,
		160,
		181,
		182,
		195,
		-1,
		-1,
		193,
		200,
		188,
		174,
		193,
		-1,
		-1,
		-1,
		205,
		221,
		213,
		184,
		194,
		-1,
		-1,
		185,
		183,
		191,
		170,
		157,
		177,
		180,
		170,
		154,
		169,
		181,
		189,
		194,
		-1,
		196,
		183,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		-1,
		-1,
		238,
		204,
		216,
		211,
		215,
		188,
		-1,
		187,
		181,
		161,
		175,
		182,
		172,
		167,
		161,
		164,
		182,
		199,
		-1,
		-1,
		210,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		195,
		209,
		204,
		197,
		201,
		-1,
		189,
		177,
		163,
		180,
		185,
		182,
		173,
		165,
		170,
		167,
		180,
		194,
		198,
		233,
		-1,
		216,
		-1,
		-1,
		-1,
		213,
		228,
		243,
		220,
		193,
		188,
		181,
		175,
		171,
		187,
		193,
		204,
		172,
		168,
		169,
		173,
		172,
		189,
		199,
		-1,
		-1,
		216,
		233,
		239,
		221,
		225,
		270,
		-1,
		-1,
		197,
		188,
		179,
		182,
		181,
		184,
		178,
		175,
		180,
		185,
		173,
		182,
		200,
		199,
		-1,
		-1,
		-1,
		236,
		-1,
		251,
		-1,
		-1,
		240,
		268,
		215,
		197,
		193,
		191,
		184,
		193,
		188,
		183,
		193,
		195,
		187,
		175,
		179,
		202,
		191,
		230,
		-1,
		-1,
		353,
		-1,
		-1,
		-1,
		265,
		240,
		255,
		279,
		260,
		267,
		230,
		227,
		-1,
		197,
		222,
		194,
		201,
		192,
		199,
		199,
		191,
		169,
		176,
		192,
		191,
		186,
		222,
		213,
		219,
		-1,
		-1,
		346,
		335,
		324,
		330,
		-1,
		271,
		257,
		265,
		255,
		258,
		-1,
		-1,
		246,
		243,
		219,
		202,
		200,
		193,
		188,
		198,
		178,
		165,
		169,
		173,
		179,
		184,
		189,
		195,
		210,
		225,
		-1,
		241,
		322,
		315,
		298,
		306,
		337,
		-1,
		269,
		261,
		264,
		247,
		249,
		-1,
		-1,
		219,
		216,
		221,
		209,
		206,
		208,
		203,
		194,
		179,
		185,
		172,
		171,
		189,
		193,
		202,
		209,
		199,
		212,
		216,
		-1,
		255,
		298,
		292,
		295,
		319,
		333,
		-1,
		266,
		-1,
		-1,
		272,
		250,
		234,
		224,
		218,
		268,
		223,
		218,
		202,
		200,
		191,
		182,
		189,
		180,
		180,
		183,
		198,
		203,
		195,
		209,
		209,
		210,
		-1,
		290,
		278,
		286,
		-1,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		288,
		-1,
		261,
		-1,
		236,
		240,
		231,
		234,
		216,
		203,
		195,
		187,
		203,
		178,
		188,
		184,
		185,
		194,
		205,
		217,
		216,
		217,
		337,
		293,
		286,
		277,
		318,
		333,
		337,
		-1,
		278,
		317,
		315,
		-1,
		297,
		-1,
		-1,
		-1,
		250,
		244,
		236,
		236,
		215,
		215,
		189,
		193,
		183,
		190,
		200,
		202,
		194,
		198,
		211,
		222,
		225,
		333,
		324,
		337,
		282,
		282,
		303,
		312,
		333,
		293,
		284,
		311,
		322,
		311,
		306,
		293,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		222,
		210,
		193,
		194,
		190,
		193,
		208,
		211,
		201,
		199,
		193,
		225,
		-1,
		326,
		325,
		314,
		311,
		287,
		278,
		273,
		300,
		-1,
		-1,
		295,
		312,
		306,
		310,
		326,
		351,
		-1,
		282,
		-1,
		-1,
		267,
		-1,
		-1,
		252,
		215,
		204,
		195,
		201,
		198,
		209,
		219,
		207,
		208,
		198,
		208,
		221,
		310,
		307,
		295,
		293,
		316,
		281,
		269,
		-1,
		282,
		280,
		286,
		293,
		310,
		340,
		-1,
		-1,
		298,
		278,
		-1,
		-1,
		250,
		248,
		237,
		-1,
		227,
		200,
		205,
		225,
		227,
		216,
		210,
		204,
		211,
		210,
		218,
		226,
		319,
		333,
		322,
		318,
		317,
		325,
		274,
		267,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		-1,
		288,
		284,
		-1,
		-1,
		245,
		238,
		226,
		214,
		204,
		214,
		218,
		222,
		214,
		207,
		202,
		213,
		205,
		209,
		226,
		-1,
		353,
		-1,
		305,
		281,
		295,
		310,
		318,
		-1,
		-1,
		-1,
		305,
		291,
		284,
		272,
		270,
		-1,
		279,
		263,
		244,
		-1,
		214,
		227,
		258,
		226,
		231,
		226,
		208,
		219,
		208,
		211,
		225,
		220,
		-1,
		-1,
		293,
		296,
		-1,
		-1,
		295,
		297,
		-1,
		296,
		285,
		270,
		262,
		-1,
		-1,
		251,
		247,
		-1,
		-1,
		215,
		240,
		229,
		237,
		232,
		212,
		218,
		221,
		210,
		214,
		226,
		-1,
		-1,
		300,
		301,
		302,
		-1,
		280,
		-1,
		298,
		-1,
		265,
		271,
		259,
		-1,
		-1,
		-1,
		253,
		216,
		237,
		247,
		241,
		239,
		230,
		216,
		223,
		221,
		217,
		228,
		-1,
		-1,
		-1,
		298,
		272,
		305,
		296,
		279,
		259,
		251,
		270,
		-1,
		240,
		-1,
		215,
		217,
		243,
		246,
		252,
		246,
		219,
		234,
		224,
		215,
		224,
		304,
		-1,
		274,
		307,
		271,
		265,
		241,
		245,
		261,
		-1,
		237,
		219,
		-1,
		247,
		237,
		268,
		253,
		234,
		221,
		228,
		228,
		221,
		-1,
		-1,
		-1,
		276,
		275,
		267,
		261,
		261,
		246,
		237,
		-1,
		249,
		231,
		210,
		227,
		227,
		218,
		226,
		258,
		254,
		241,
		241,
		233,
		-1,
		377,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		270,
		265,
		238,
		226,
		232,
		228,
		214,
		220,
		222,
		230,
		228,
		225,
		237,
		233,
		253,
		234,
		269,
		-1,
		372,
		-1,
		306,
		-1,
		-1,
		288,
		268,
		260,
		249,
		238,
		236,
		227,
		218,
		240,
		256,
		240,
		238,
		241,
		242,
		-1,
		361,
		360,
		-1,
		307,
		299,
		285,
		-1,
		278,
		-1,
		284,
		245,
		-1,
		247,
		227,
		-1,
		249,
		245,
		-1,
		-1,
		348,
		323,
		-1,
		-1,
		-1,
		308,
		288,
		279,
		263,
		-1,
		238,
		238,
		-1,
		-1,
		-1,
		333,
		332,
		-1,
		301,
		304,
		-1,
		294,
		285,
		293,
		240,
		244,
		-1,
		-1,
		-1,
		342,
		323,
		317,
		316,
		314,
		309,
		306,
		292,
		276,
		254,
		243,
		264,
		-1,
		-1,
		-1,
		314,
		306,
		299,
		-1,
		-1,
		301,
		284,
		265,
		263,
		-1,
		-1,
		-1,
		336,
		317,
		-1,
		-1,
		291,
		-1,
		-1,
		297,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		353,
		325,
		-1,
		-1,
		-1,
		287,
		283,
		284,
		-1,
		-1,
		-1,
		-1,
		347,
		348,
		371,
		335,
		-1,
		-1,
		-1,
		279,
		273,
		-1,
		-1,
		350,
		348,
		-1,
		-1,
		-1,
		307,
		291,
		-1,
		277,
		-1,
		-1,
		-1,
		298,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		312,
		-1,
		312,
		287,
		294,
		-1,
		-1,
		-1,
		-1,
		325,
		317,
		325,
		-1,
		297,
		299,
		-1,
		347,
		-1,
		-1,
		340,
		331,
		-1,
		-1,
		302,
		309,
		331,
		334,
		370,
		-1,
		321
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		70,
		67,
		78,
		64,
		59,
		63,
		-1,
		107,
		67,
		54,
		49,
		74,
		73,
		85,
		96,
		-1,
		-1,
		-1,
		32,
		21,
		62,
		58,
		68,
		79,
		86,
		-1,
		137,
		-1,
		0,
		43,
		55,
		64,
		60,
		63,
		83,
		110,
		132,
		134,
		28,
		90,
		67,
		68,
		91,
		102,
		136,
		128,
		-1,
		74,
		71,
		93,
		106,
		121,
		124,
		-1,
		-1,
		75,
		85,
		91,
		106,
		125,
		128,
		-1,
		138,
		157,
		-1,
		-1,
		74,
		87,
		100,
		103,
		111,
		117,
		130,
		147,
		152,
		-1,
		-1,
		92,
		96,
		106,
		104,
		100,
		117,
		136,
		147,
		161,
		160,
		-1,
		86,
		104,
		113,
		111,
		109,
		93,
		97,
		115,
		146,
		152,
		155,
		-1,
		103,
		99,
		109,
		115,
		127,
		109,
		96,
		102,
		121,
		134,
		153,
		144,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		95,
		115,
		117,
		116,
		130,
		128,
		99,
		105,
		109,
		126,
		142,
		143,
		153,
		-1,
		-1,
		197,
		170,
		194,
		152,
		134,
		-1,
		100,
		102,
		108,
		112,
		117,
		125,
		130,
		115,
		-1,
		120,
		119,
		150,
		136,
		147,
		179,
		-1,
		-1,
		155,
		147,
		129,
		132,
		109,
		105,
		117,
		116,
		112,
		114,
		116,
		128,
		123,
		136,
		143,
		114,
		124,
		128,
		143,
		154,
		-1,
		-1,
		228,
		-1,
		-1,
		176,
		159,
		-1,
		124,
		131,
		115,
		121,
		107,
		128,
		127,
		121,
		128,
		131,
		119,
		136,
		133,
		150,
		136,
		111,
		136,
		140,
		146,
		164,
		165,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		131,
		128,
		121,
		145,
		144,
		-1,
		150,
		148,
		154,
		139,
		144,
		140,
		125,
		141,
		136,
		136,
		133,
		118,
		120,
		157,
		148,
		169,
		166,
		197,
		203,
		197,
		206,
		-1,
		184,
		180,
		176,
		183,
		132,
		-1,
		-1,
		149,
		-1,
		152,
		165,
		162,
		150,
		153,
		140,
		148,
		147,
		131,
		147,
		134,
		131,
		130,
		126,
		135,
		145,
		144,
		162,
		175,
		190,
		194,
		200,
		-1,
		234,
		-1,
		176,
		160,
		162,
		138,
		166,
		-1,
		169,
		153,
		173,
		164,
		164,
		-1,
		156,
		153,
		163,
		146,
		131,
		146,
		134,
		129,
		129,
		133,
		148,
		139,
		157,
		164,
		172,
		176,
		196,
		208,
		194,
		184,
		-1,
		166,
		171,
		141,
		153,
		176,
		196,
		180,
		-1,
		175,
		-1,
		158,
		171,
		-1,
		152,
		148,
		137,
		142,
		131,
		138,
		136,
		130,
		127,
		145,
		148,
		165,
		169,
		185,
		-1,
		-1,
		179,
		183,
		191,
		142,
		161,
		185,
		222,
		189,
		182,
		181,
		-1,
		176,
		173,
		170,
		171,
		157,
		150,
		151,
		137,
		143,
		144,
		129,
		132,
		154,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		168,
		139,
		163,
		205,
		211,
		204,
		192,
		207,
		207,
		200,
		-1,
		188,
		167,
		164,
		154,
		144,
		160,
		150,
		153,
		133,
		135,
		151,
		163,
		154,
		174,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		142,
		176,
		194,
		240,
		226,
		231,
		206,
		199,
		193,
		182,
		184,
		172,
		161,
		153,
		142,
		151,
		161,
		155,
		135,
		144,
		145,
		169,
		176,
		182,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		167,
		174,
		206,
		231,
		244,
		-1,
		198,
		-1,
		187,
		182,
		166,
		161,
		158,
		155,
		149,
		158,
		163,
		149,
		140,
		155,
		174,
		174,
		166,
		191,
		194,
		-1,
		-1,
		-1,
		198,
		215,
		190,
		167,
		148,
		184,
		-1,
		214,
		215,
		-1,
		192,
		186,
		183,
		168,
		164,
		159,
		163,
		156,
		163,
		159,
		158,
		159,
		141,
		177,
		-1,
		174,
		168,
		196,
		199,
		189,
		-1,
		-1,
		-1,
		213,
		192,
		185,
		205,
		155,
		207,
		-1,
		-1,
		199,
		192,
		-1,
		179,
		161,
		168,
		166,
		160,
		164,
		168,
		157,
		170,
		166,
		146,
		156,
		176,
		180,
		187,
		180,
		185,
		184,
		198,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		175,
		-1,
		208,
		200,
		190,
		184,
		178,
		174,
		172,
		188,
		172,
		175,
		175,
		171,
		179,
		164,
		163,
		149,
		153,
		171,
		198,
		193,
		188,
		187,
		194,
		-1,
		261,
		247,
		218,
		-1,
		-1,
		190,
		-1,
		161,
		185,
		201,
		-1,
		216,
		195,
		210,
		188,
		184,
		180,
		195,
		196,
		174,
		179,
		178,
		188,
		185,
		174,
		161,
		165,
		180,
		190,
		182,
		183,
		192,
		-1,
		267,
		254,
		212,
		208,
		197,
		217,
		164,
		177,
		188,
		-1,
		-1,
		252,
		-1,
		186,
		203,
		194,
		192,
		185,
		176,
		182,
		189,
		192,
		189,
		179,
		168,
		174,
		170,
		192,
		178,
		176,
		195,
		210,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		183,
		170,
		164,
		-1,
		205,
		-1,
		230,
		220,
		204,
		189,
		222,
		-1,
		193,
		177,
		182,
		-1,
		214,
		-1,
		187,
		187,
		178,
		167,
		164,
		175,
		173,
		184,
		201,
		-1,
		217,
		202,
		195,
		185,
		199,
		170,
		-1,
		221,
		-1,
		-1,
		217,
		211,
		211,
		195,
		198,
		209,
		189,
		183,
		182,
		209,
		204,
		195,
		176,
		169,
		166,
		167,
		180,
		200,
		191,
		203,
		-1,
		-1,
		-1,
		222,
		202,
		208,
		166,
		187,
		-1,
		-1,
		279,
		234,
		220,
		-1,
		204,
		226,
		214,
		204,
		194,
		228,
		220,
		195,
		188,
		174,
		176,
		174,
		176,
		181,
		202,
		203,
		216,
		-1,
		-1,
		199,
		206,
		194,
		180,
		199,
		-1,
		-1,
		-1,
		226,
		242,
		234,
		205,
		215,
		-1,
		-1,
		206,
		204,
		212,
		191,
		178,
		198,
		201,
		191,
		175,
		190,
		202,
		210,
		215,
		-1,
		202,
		189,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		225,
		237,
		232,
		236,
		209,
		-1,
		208,
		202,
		182,
		196,
		203,
		193,
		188,
		182,
		185,
		203,
		220,
		-1,
		-1,
		216,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		216,
		230,
		225,
		218,
		222,
		-1,
		210,
		198,
		184,
		201,
		206,
		203,
		194,
		186,
		191,
		188,
		201,
		215,
		219,
		239,
		-1,
		222,
		-1,
		-1,
		-1,
		234,
		249,
		264,
		241,
		214,
		209,
		202,
		196,
		192,
		208,
		214,
		225,
		193,
		189,
		190,
		194,
		193,
		210,
		220,
		-1,
		-1,
		222,
		239,
		260,
		242,
		246,
		291,
		-1,
		-1,
		218,
		209,
		200,
		203,
		202,
		205,
		199,
		196,
		201,
		206,
		194,
		203,
		221,
		220,
		-1,
		-1,
		-1,
		242,
		-1,
		257,
		-1,
		-1,
		261,
		289,
		236,
		218,
		214,
		212,
		205,
		214,
		209,
		204,
		214,
		216,
		208,
		196,
		200,
		223,
		212,
		251,
		-1,
		-1,
		359,
		-1,
		-1,
		-1,
		271,
		246,
		261,
		300,
		281,
		288,
		251,
		248,
		-1,
		218,
		243,
		215,
		222,
		213,
		220,
		220,
		212,
		190,
		197,
		213,
		212,
		207,
		243,
		234,
		240,
		-1,
		-1,
		352,
		341,
		330,
		336,
		-1,
		277,
		263,
		286,
		276,
		279,
		-1,
		-1,
		267,
		264,
		240,
		223,
		221,
		214,
		209,
		219,
		199,
		186,
		190,
		194,
		200,
		205,
		210,
		216,
		231,
		246,
		-1,
		247,
		328,
		321,
		304,
		312,
		343,
		-1,
		280,
		282,
		270,
		268,
		270,
		-1,
		-1,
		240,
		237,
		242,
		230,
		227,
		229,
		224,
		215,
		200,
		206,
		193,
		192,
		210,
		214,
		223,
		230,
		220,
		233,
		237,
		-1,
		261,
		304,
		298,
		301,
		325,
		339,
		-1,
		287,
		-1,
		-1,
		278,
		271,
		255,
		245,
		239,
		289,
		244,
		239,
		223,
		221,
		212,
		203,
		210,
		201,
		201,
		204,
		219,
		224,
		216,
		230,
		230,
		231,
		-1,
		296,
		284,
		292,
		-1,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		294,
		-1,
		282,
		-1,
		257,
		261,
		252,
		255,
		237,
		224,
		216,
		208,
		224,
		199,
		209,
		205,
		206,
		215,
		226,
		238,
		237,
		238,
		358,
		314,
		292,
		283,
		330,
		345,
		349,
		-1,
		299,
		338,
		332,
		-1,
		303,
		-1,
		-1,
		-1,
		271,
		265,
		257,
		257,
		236,
		236,
		210,
		214,
		204,
		211,
		221,
		223,
		215,
		219,
		232,
		243,
		246,
		354,
		345,
		358,
		303,
		297,
		315,
		324,
		345,
		314,
		305,
		332,
		339,
		328,
		323,
		310,
		-1,
		-1,
		294,
		275,
		-1,
		-1,
		243,
		231,
		214,
		215,
		211,
		214,
		229,
		232,
		222,
		220,
		214,
		246,
		-1,
		347,
		346,
		335,
		332,
		308,
		299,
		294,
		316,
		-1,
		-1,
		316,
		333,
		327,
		331,
		347,
		372,
		-1,
		303,
		-1,
		-1,
		288,
		-1,
		-1,
		273,
		236,
		225,
		216,
		222,
		219,
		230,
		240,
		228,
		229,
		219,
		229,
		242,
		331,
		328,
		316,
		314,
		337,
		302,
		290,
		-1,
		303,
		301,
		307,
		314,
		331,
		361,
		-1,
		-1,
		319,
		299,
		-1,
		-1,
		271,
		269,
		258,
		-1,
		248,
		221,
		226,
		246,
		248,
		237,
		231,
		225,
		232,
		231,
		239,
		247,
		340,
		354,
		343,
		339,
		338,
		346,
		295,
		288,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		-1,
		309,
		305,
		-1,
		-1,
		266,
		259,
		247,
		235,
		225,
		235,
		239,
		243,
		235,
		228,
		223,
		234,
		226,
		230,
		247,
		-1,
		374,
		-1,
		326,
		302,
		316,
		331,
		339,
		-1,
		-1,
		-1,
		326,
		312,
		305,
		293,
		291,
		-1,
		300,
		284,
		265,
		-1,
		235,
		248,
		279,
		247,
		252,
		247,
		229,
		240,
		229,
		232,
		246,
		241,
		-1,
		-1,
		314,
		317,
		-1,
		-1,
		316,
		318,
		-1,
		317,
		306,
		291,
		283,
		-1,
		-1,
		272,
		268,
		-1,
		-1,
		236,
		261,
		250,
		258,
		253,
		233,
		239,
		242,
		231,
		235,
		247,
		-1,
		-1,
		321,
		322,
		323,
		-1,
		301,
		-1,
		319,
		-1,
		286,
		292,
		280,
		-1,
		-1,
		-1,
		274,
		237,
		258,
		268,
		262,
		260,
		251,
		237,
		244,
		242,
		238,
		249,
		-1,
		-1,
		-1,
		319,
		293,
		326,
		317,
		300,
		280,
		272,
		291,
		-1,
		261,
		-1,
		236,
		238,
		264,
		267,
		273,
		267,
		240,
		255,
		245,
		236,
		245,
		325,
		-1,
		295,
		328,
		292,
		286,
		262,
		266,
		282,
		-1,
		258,
		240,
		-1,
		268,
		258,
		289,
		274,
		255,
		242,
		249,
		249,
		242,
		-1,
		-1,
		-1,
		297,
		296,
		288,
		282,
		282,
		267,
		258,
		-1,
		270,
		252,
		231,
		248,
		248,
		239,
		247,
		279,
		275,
		262,
		262,
		254,
		-1,
		398,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		291,
		286,
		259,
		247,
		253,
		249,
		235,
		241,
		243,
		251,
		249,
		246,
		258,
		254,
		274,
		255,
		290,
		-1,
		393,
		-1,
		327,
		-1,
		-1,
		309,
		289,
		281,
		270,
		259,
		257,
		248,
		239,
		261,
		277,
		261,
		259,
		262,
		263,
		-1,
		382,
		381,
		-1,
		328,
		320,
		306,
		-1,
		299,
		-1,
		305,
		266,
		-1,
		268,
		248,
		-1,
		270,
		266,
		-1,
		-1,
		369,
		344,
		-1,
		-1,
		-1,
		329,
		309,
		300,
		284,
		-1,
		259,
		259,
		-1,
		-1,
		-1,
		354,
		353,
		-1,
		322,
		325,
		-1,
		315,
		306,
		314,
		261,
		265,
		-1,
		-1,
		-1,
		363,
		344,
		338,
		337,
		335,
		330,
		327,
		313,
		297,
		275,
		264,
		285,
		-1,
		-1,
		-1,
		335,
		327,
		320,
		-1,
		-1,
		322,
		305,
		286,
		284,
		-1,
		-1,
		-1,
		357,
		338,
		-1,
		-1,
		312,
		-1,
		-1,
		318,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		374,
		346,
		-1,
		-1,
		-1,
		308,
		304,
		305,
		-1,
		-1,
		-1,
		-1,
		368,
		369,
		392,
		356,
		-1,
		-1,
		-1,
		300,
		294,
		-1,
		-1,
		371,
		369,
		-1,
		-1,
		-1,
		328,
		312,
		-1,
		298,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		331,
		-1,
		-1,
		-1,
		333,
		-1,
		333,
		308,
		315,
		-1,
		-1,
		-1,
		-1,
		346,
		338,
		346,
		-1,
		318,
		320,
		-1,
		368,
		-1,
		-1,
		361,
		352,
		-1,
		-1,
		323,
		330,
		352,
		355,
		391,
		-1,
		342
	],
	[
		-1,
		53,
		48,
		59,
		55,
		40,
		44,
		-1,
		88,
		58,
		36,
		30,
		55,
		54,
		66,
		77,
		-1,
		-1,
		-1,
		31,
		23,
		43,
		39,
		49,
		60,
		67,
		-1,
		118,
		-1,
		45,
		0,
		12,
		21,
		41,
		44,
		64,
		91,
		113,
		115,
		60,
		71,
		48,
		49,
		72,
		83,
		117,
		109,
		-1,
		55,
		52,
		74,
		87,
		102,
		105,
		-1,
		-1,
		56,
		66,
		72,
		87,
		106,
		109,
		-1,
		119,
		138,
		-1,
		-1,
		55,
		68,
		81,
		84,
		92,
		98,
		111,
		128,
		133,
		-1,
		-1,
		73,
		77,
		87,
		85,
		81,
		98,
		117,
		128,
		142,
		141,
		-1,
		67,
		85,
		94,
		92,
		90,
		74,
		78,
		96,
		127,
		133,
		136,
		-1,
		84,
		80,
		90,
		96,
		108,
		90,
		77,
		83,
		102,
		115,
		134,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		85,
		76,
		96,
		98,
		97,
		111,
		109,
		80,
		86,
		90,
		107,
		123,
		124,
		134,
		-1,
		-1,
		178,
		151,
		175,
		133,
		115,
		-1,
		81,
		83,
		89,
		93,
		98,
		106,
		111,
		96,
		-1,
		101,
		100,
		131,
		117,
		128,
		160,
		-1,
		-1,
		136,
		128,
		110,
		113,
		90,
		86,
		98,
		97,
		93,
		95,
		97,
		109,
		104,
		117,
		124,
		95,
		105,
		109,
		124,
		135,
		-1,
		-1,
		209,
		-1,
		-1,
		157,
		140,
		-1,
		105,
		112,
		96,
		102,
		88,
		109,
		108,
		102,
		109,
		112,
		100,
		117,
		114,
		131,
		117,
		92,
		117,
		121,
		127,
		145,
		146,
		-1,
		208,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		112,
		109,
		102,
		126,
		125,
		-1,
		131,
		129,
		135,
		120,
		125,
		121,
		106,
		122,
		117,
		117,
		114,
		99,
		101,
		138,
		129,
		150,
		147,
		178,
		184,
		178,
		187,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		130,
		-1,
		133,
		146,
		143,
		131,
		134,
		121,
		129,
		128,
		112,
		128,
		115,
		112,
		111,
		107,
		116,
		126,
		125,
		143,
		156,
		171,
		175,
		181,
		-1,
		215,
		-1,
		157,
		141,
		143,
		119,
		147,
		-1,
		150,
		134,
		154,
		145,
		145,
		-1,
		137,
		134,
		144,
		127,
		112,
		127,
		115,
		110,
		110,
		114,
		129,
		120,
		138,
		145,
		153,
		157,
		177,
		189,
		175,
		165,
		-1,
		147,
		152,
		122,
		134,
		157,
		177,
		161,
		-1,
		156,
		-1,
		139,
		152,
		-1,
		133,
		129,
		118,
		123,
		112,
		119,
		117,
		111,
		108,
		126,
		129,
		146,
		150,
		166,
		-1,
		-1,
		160,
		164,
		172,
		123,
		142,
		166,
		203,
		170,
		163,
		162,
		-1,
		157,
		154,
		151,
		152,
		138,
		131,
		132,
		118,
		124,
		125,
		110,
		113,
		135,
		163,
		141,
		153,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		149,
		120,
		144,
		186,
		192,
		185,
		173,
		188,
		188,
		181,
		-1,
		169,
		148,
		145,
		135,
		125,
		141,
		131,
		134,
		114,
		116,
		132,
		144,
		135,
		155,
		-1,
		-1,
		-1,
		179,
		168,
		169,
		123,
		157,
		175,
		221,
		207,
		212,
		187,
		180,
		174,
		163,
		165,
		153,
		142,
		134,
		123,
		132,
		142,
		136,
		116,
		125,
		126,
		150,
		157,
		163,
		-1,
		-1,
		186,
		176,
		160,
		162,
		159,
		148,
		155,
		187,
		212,
		225,
		-1,
		179,
		-1,
		168,
		163,
		147,
		142,
		139,
		136,
		130,
		139,
		144,
		130,
		121,
		136,
		155,
		155,
		147,
		172,
		175,
		-1,
		-1,
		-1,
		179,
		196,
		171,
		148,
		129,
		165,
		-1,
		195,
		196,
		-1,
		173,
		167,
		164,
		149,
		145,
		140,
		144,
		137,
		144,
		140,
		139,
		140,
		122,
		158,
		-1,
		155,
		149,
		177,
		180,
		170,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		136,
		188,
		-1,
		-1,
		180,
		173,
		-1,
		160,
		142,
		149,
		147,
		141,
		145,
		149,
		138,
		151,
		147,
		127,
		137,
		157,
		161,
		168,
		161,
		166,
		165,
		179,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		156,
		-1,
		189,
		181,
		171,
		165,
		159,
		155,
		153,
		169,
		153,
		156,
		156,
		152,
		160,
		145,
		144,
		130,
		134,
		152,
		179,
		174,
		169,
		168,
		175,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		171,
		-1,
		142,
		166,
		182,
		-1,
		197,
		176,
		191,
		169,
		165,
		161,
		176,
		177,
		155,
		160,
		159,
		169,
		166,
		155,
		142,
		146,
		161,
		171,
		163,
		164,
		173,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		145,
		158,
		169,
		-1,
		-1,
		233,
		-1,
		167,
		184,
		175,
		173,
		166,
		157,
		163,
		170,
		173,
		170,
		160,
		149,
		155,
		151,
		173,
		159,
		157,
		176,
		191,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		211,
		201,
		185,
		170,
		203,
		-1,
		174,
		158,
		163,
		-1,
		195,
		-1,
		168,
		168,
		159,
		148,
		145,
		156,
		154,
		165,
		182,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		202,
		-1,
		-1,
		198,
		192,
		192,
		176,
		179,
		190,
		170,
		164,
		163,
		190,
		185,
		176,
		157,
		150,
		147,
		148,
		161,
		181,
		172,
		184,
		-1,
		-1,
		-1,
		203,
		183,
		189,
		147,
		168,
		-1,
		-1,
		260,
		215,
		201,
		-1,
		185,
		207,
		195,
		185,
		175,
		209,
		201,
		176,
		169,
		155,
		157,
		155,
		157,
		162,
		183,
		184,
		197,
		-1,
		-1,
		180,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		207,
		223,
		215,
		186,
		196,
		-1,
		-1,
		187,
		185,
		193,
		172,
		159,
		179,
		182,
		172,
		156,
		171,
		183,
		191,
		196,
		-1,
		183,
		170,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		240,
		206,
		218,
		213,
		217,
		190,
		-1,
		189,
		183,
		163,
		177,
		184,
		174,
		169,
		163,
		166,
		184,
		201,
		-1,
		-1,
		197,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		197,
		211,
		206,
		199,
		203,
		-1,
		191,
		179,
		165,
		182,
		187,
		184,
		175,
		167,
		172,
		169,
		182,
		196,
		200,
		220,
		-1,
		203,
		-1,
		-1,
		-1,
		215,
		230,
		245,
		222,
		195,
		190,
		183,
		177,
		173,
		189,
		195,
		206,
		174,
		170,
		171,
		175,
		174,
		191,
		201,
		-1,
		-1,
		203,
		220,
		241,
		223,
		227,
		272,
		-1,
		-1,
		199,
		190,
		181,
		184,
		183,
		186,
		180,
		177,
		182,
		187,
		175,
		184,
		202,
		201,
		-1,
		-1,
		-1,
		223,
		-1,
		238,
		-1,
		-1,
		242,
		270,
		217,
		199,
		195,
		193,
		186,
		195,
		190,
		185,
		195,
		197,
		189,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		340,
		-1,
		-1,
		-1,
		252,
		227,
		242,
		281,
		262,
		269,
		232,
		229,
		-1,
		199,
		224,
		196,
		203,
		194,
		201,
		201,
		193,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		333,
		322,
		311,
		317,
		-1,
		258,
		244,
		267,
		257,
		260,
		-1,
		-1,
		248,
		245,
		221,
		204,
		202,
		195,
		190,
		200,
		180,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		228,
		309,
		302,
		285,
		293,
		324,
		-1,
		261,
		263,
		251,
		249,
		251,
		-1,
		-1,
		221,
		218,
		223,
		211,
		208,
		210,
		205,
		196,
		181,
		187,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		242,
		285,
		279,
		282,
		306,
		320,
		-1,
		268,
		-1,
		-1,
		259,
		252,
		236,
		226,
		220,
		270,
		225,
		220,
		204,
		202,
		193,
		184,
		191,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		277,
		265,
		273,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		-1,
		263,
		-1,
		238,
		242,
		233,
		236,
		218,
		205,
		197,
		189,
		205,
		180,
		190,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		339,
		295,
		273,
		264,
		311,
		326,
		330,
		-1,
		280,
		319,
		313,
		-1,
		284,
		-1,
		-1,
		-1,
		252,
		246,
		238,
		238,
		217,
		217,
		191,
		195,
		185,
		192,
		202,
		204,
		196,
		200,
		213,
		224,
		227,
		335,
		326,
		339,
		284,
		278,
		296,
		305,
		326,
		295,
		286,
		313,
		320,
		309,
		304,
		291,
		-1,
		-1,
		275,
		256,
		-1,
		-1,
		224,
		212,
		195,
		196,
		192,
		195,
		210,
		213,
		203,
		201,
		195,
		227,
		-1,
		328,
		327,
		316,
		313,
		289,
		280,
		275,
		297,
		-1,
		-1,
		297,
		314,
		308,
		312,
		328,
		353,
		-1,
		284,
		-1,
		-1,
		269,
		-1,
		-1,
		254,
		217,
		206,
		197,
		203,
		200,
		211,
		221,
		209,
		210,
		200,
		210,
		223,
		312,
		309,
		297,
		295,
		318,
		283,
		271,
		-1,
		284,
		282,
		288,
		295,
		312,
		342,
		-1,
		-1,
		300,
		280,
		-1,
		-1,
		252,
		250,
		239,
		-1,
		229,
		202,
		207,
		227,
		229,
		218,
		212,
		206,
		213,
		212,
		220,
		228,
		321,
		335,
		324,
		320,
		319,
		327,
		276,
		269,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		-1,
		290,
		286,
		-1,
		-1,
		247,
		240,
		228,
		216,
		206,
		216,
		220,
		224,
		216,
		209,
		204,
		215,
		207,
		211,
		228,
		-1,
		355,
		-1,
		307,
		283,
		297,
		312,
		320,
		-1,
		-1,
		-1,
		307,
		293,
		286,
		274,
		272,
		-1,
		281,
		265,
		246,
		-1,
		216,
		229,
		260,
		228,
		233,
		228,
		210,
		221,
		210,
		213,
		227,
		222,
		-1,
		-1,
		295,
		298,
		-1,
		-1,
		297,
		299,
		-1,
		298,
		287,
		272,
		264,
		-1,
		-1,
		253,
		249,
		-1,
		-1,
		217,
		242,
		231,
		239,
		234,
		214,
		220,
		223,
		212,
		216,
		228,
		-1,
		-1,
		302,
		303,
		304,
		-1,
		282,
		-1,
		300,
		-1,
		267,
		273,
		261,
		-1,
		-1,
		-1,
		255,
		218,
		239,
		249,
		243,
		241,
		232,
		218,
		225,
		223,
		219,
		230,
		-1,
		-1,
		-1,
		300,
		274,
		307,
		298,
		281,
		261,
		253,
		272,
		-1,
		242,
		-1,
		217,
		219,
		245,
		248,
		254,
		248,
		221,
		236,
		226,
		217,
		226,
		306,
		-1,
		276,
		309,
		273,
		267,
		243,
		247,
		263,
		-1,
		239,
		221,
		-1,
		249,
		239,
		270,
		255,
		236,
		223,
		230,
		230,
		223,
		-1,
		-1,
		-1,
		278,
		277,
		269,
		263,
		263,
		248,
		239,
		-1,
		251,
		233,
		212,
		229,
		229,
		220,
		228,
		260,
		256,
		243,
		243,
		235,
		-1,
		379,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		272,
		267,
		240,
		228,
		234,
		230,
		216,
		222,
		224,
		232,
		230,
		227,
		239,
		235,
		255,
		236,
		271,
		-1,
		374,
		-1,
		308,
		-1,
		-1,
		290,
		270,
		262,
		251,
		240,
		238,
		229,
		220,
		242,
		258,
		242,
		240,
		243,
		244,
		-1,
		363,
		362,
		-1,
		309,
		301,
		287,
		-1,
		280,
		-1,
		286,
		247,
		-1,
		249,
		229,
		-1,
		251,
		247,
		-1,
		-1,
		350,
		325,
		-1,
		-1,
		-1,
		310,
		290,
		281,
		265,
		-1,
		240,
		240,
		-1,
		-1,
		-1,
		335,
		334,
		-1,
		303,
		306,
		-1,
		296,
		287,
		295,
		242,
		246,
		-1,
		-1,
		-1,
		344,
		325,
		319,
		318,
		316,
		311,
		308,
		294,
		278,
		256,
		245,
		266,
		-1,
		-1,
		-1,
		316,
		308,
		301,
		-1,
		-1,
		303,
		286,
		267,
		265,
		-1,
		-1,
		-1,
		338,
		319,
		-1,
		-1,
		293,
		-1,
		-1,
		299,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		355,
		327,
		-1,
		-1,
		-1,
		289,
		285,
		286,
		-1,
		-1,
		-1,
		-1,
		349,
		350,
		373,
		337,
		-1,
		-1,
		-1,
		281,
		275,
		-1,
		-1,
		352,
		350,
		-1,
		-1,
		-1,
		309,
		293,
		-1,
		279,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		314,
		-1,
		314,
		289,
		296,
		-1,
		-1,
		-1,
		-1,
		327,
		319,
		327,
		-1,
		299,
		301,
		-1,
		349,
		-1,
		-1,
		342,
		333,
		-1,
		-1,
		304,
		311,
		333,
		336,
		372,
		-1,
		323
	],
	[
		-1,
		64,
		59,
		70,
		66,
		51,
		55,
		-1,
		99,
		69,
		47,
		41,
		66,
		65,
		77,
		88,
		-1,
		-1,
		-1,
		43,
		35,
		54,
		50,
		60,
		71,
		78,
		-1,
		129,
		-1,
		57,
		12,
		0,
		21,
		52,
		55,
		75,
		102,
		124,
		126,
		72,
		82,
		59,
		60,
		83,
		94,
		128,
		120,
		-1,
		66,
		63,
		85,
		98,
		113,
		116,
		-1,
		-1,
		67,
		77,
		83,
		98,
		117,
		120,
		-1,
		130,
		149,
		-1,
		-1,
		66,
		79,
		92,
		95,
		103,
		109,
		122,
		139,
		144,
		-1,
		-1,
		84,
		88,
		98,
		96,
		92,
		109,
		128,
		139,
		153,
		152,
		-1,
		78,
		96,
		105,
		103,
		101,
		85,
		89,
		107,
		138,
		144,
		147,
		-1,
		95,
		91,
		101,
		107,
		119,
		101,
		88,
		94,
		113,
		126,
		145,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		96,
		87,
		107,
		109,
		108,
		122,
		120,
		91,
		97,
		101,
		118,
		134,
		135,
		145,
		-1,
		-1,
		189,
		162,
		186,
		144,
		126,
		-1,
		92,
		94,
		100,
		104,
		109,
		117,
		122,
		107,
		-1,
		112,
		111,
		142,
		128,
		139,
		171,
		-1,
		-1,
		147,
		139,
		121,
		124,
		101,
		97,
		109,
		108,
		104,
		106,
		108,
		120,
		115,
		128,
		135,
		106,
		116,
		120,
		135,
		146,
		-1,
		-1,
		220,
		-1,
		-1,
		168,
		151,
		-1,
		116,
		123,
		107,
		113,
		99,
		120,
		119,
		113,
		120,
		123,
		111,
		128,
		125,
		142,
		128,
		103,
		128,
		132,
		138,
		156,
		157,
		-1,
		219,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		123,
		120,
		113,
		137,
		136,
		-1,
		142,
		140,
		146,
		131,
		136,
		132,
		117,
		133,
		128,
		128,
		125,
		110,
		112,
		149,
		140,
		161,
		158,
		189,
		195,
		189,
		198,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		141,
		-1,
		144,
		157,
		154,
		142,
		145,
		132,
		140,
		139,
		123,
		139,
		126,
		123,
		122,
		118,
		127,
		137,
		136,
		154,
		167,
		182,
		186,
		192,
		-1,
		226,
		-1,
		168,
		152,
		154,
		130,
		158,
		-1,
		161,
		145,
		165,
		156,
		156,
		-1,
		148,
		145,
		155,
		138,
		123,
		138,
		126,
		121,
		121,
		125,
		140,
		131,
		149,
		156,
		164,
		168,
		188,
		200,
		186,
		176,
		-1,
		158,
		163,
		133,
		145,
		168,
		188,
		172,
		-1,
		167,
		-1,
		150,
		163,
		-1,
		144,
		140,
		129,
		134,
		123,
		130,
		128,
		122,
		119,
		137,
		140,
		157,
		161,
		177,
		-1,
		-1,
		171,
		175,
		183,
		134,
		153,
		177,
		214,
		181,
		174,
		173,
		-1,
		168,
		165,
		162,
		163,
		149,
		142,
		143,
		129,
		135,
		136,
		121,
		124,
		146,
		174,
		152,
		164,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		160,
		131,
		155,
		197,
		203,
		196,
		184,
		199,
		199,
		192,
		-1,
		180,
		159,
		156,
		146,
		136,
		152,
		142,
		145,
		125,
		127,
		143,
		155,
		146,
		166,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		134,
		168,
		186,
		232,
		218,
		223,
		198,
		191,
		185,
		174,
		176,
		164,
		153,
		145,
		134,
		143,
		153,
		147,
		127,
		136,
		137,
		161,
		168,
		174,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		159,
		166,
		198,
		223,
		236,
		-1,
		190,
		-1,
		179,
		174,
		158,
		153,
		150,
		147,
		141,
		150,
		155,
		141,
		132,
		147,
		166,
		166,
		158,
		183,
		186,
		-1,
		-1,
		-1,
		190,
		207,
		182,
		159,
		140,
		176,
		-1,
		206,
		207,
		-1,
		184,
		178,
		175,
		160,
		156,
		151,
		155,
		148,
		155,
		151,
		150,
		151,
		133,
		169,
		-1,
		166,
		160,
		188,
		191,
		181,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		147,
		199,
		-1,
		-1,
		191,
		184,
		-1,
		171,
		153,
		160,
		158,
		152,
		156,
		160,
		149,
		162,
		158,
		138,
		148,
		168,
		172,
		179,
		172,
		177,
		176,
		190,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		167,
		-1,
		200,
		192,
		182,
		176,
		170,
		166,
		164,
		180,
		164,
		167,
		167,
		163,
		171,
		156,
		155,
		141,
		145,
		163,
		190,
		185,
		180,
		179,
		186,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		182,
		-1,
		153,
		177,
		193,
		-1,
		208,
		187,
		202,
		180,
		176,
		172,
		187,
		188,
		166,
		171,
		170,
		180,
		177,
		166,
		153,
		157,
		172,
		182,
		174,
		175,
		184,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		156,
		169,
		180,
		-1,
		-1,
		244,
		-1,
		178,
		195,
		186,
		184,
		177,
		168,
		174,
		181,
		184,
		181,
		171,
		160,
		166,
		162,
		184,
		170,
		168,
		187,
		202,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		222,
		212,
		196,
		181,
		214,
		-1,
		185,
		169,
		174,
		-1,
		206,
		-1,
		179,
		179,
		170,
		159,
		156,
		167,
		165,
		176,
		193,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		213,
		-1,
		-1,
		209,
		203,
		203,
		187,
		190,
		201,
		181,
		175,
		174,
		201,
		196,
		187,
		168,
		161,
		158,
		159,
		172,
		192,
		183,
		195,
		-1,
		-1,
		-1,
		214,
		194,
		200,
		158,
		179,
		-1,
		-1,
		271,
		226,
		212,
		-1,
		196,
		218,
		206,
		196,
		186,
		220,
		212,
		187,
		180,
		166,
		168,
		166,
		168,
		173,
		194,
		195,
		208,
		-1,
		-1,
		191,
		198,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		218,
		234,
		226,
		197,
		207,
		-1,
		-1,
		198,
		196,
		204,
		183,
		170,
		190,
		193,
		183,
		167,
		182,
		194,
		202,
		207,
		-1,
		194,
		181,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		-1,
		-1,
		251,
		217,
		229,
		224,
		228,
		201,
		-1,
		200,
		194,
		174,
		188,
		195,
		185,
		180,
		174,
		177,
		195,
		212,
		-1,
		-1,
		208,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		208,
		222,
		217,
		210,
		214,
		-1,
		202,
		190,
		176,
		193,
		198,
		195,
		186,
		178,
		183,
		180,
		193,
		207,
		211,
		231,
		-1,
		214,
		-1,
		-1,
		-1,
		226,
		241,
		256,
		233,
		206,
		201,
		194,
		188,
		184,
		200,
		206,
		217,
		185,
		181,
		182,
		186,
		185,
		202,
		212,
		-1,
		-1,
		214,
		231,
		252,
		234,
		238,
		283,
		-1,
		-1,
		210,
		201,
		192,
		195,
		194,
		197,
		191,
		188,
		193,
		198,
		186,
		195,
		213,
		212,
		-1,
		-1,
		-1,
		234,
		-1,
		249,
		-1,
		-1,
		253,
		281,
		228,
		210,
		206,
		204,
		197,
		206,
		201,
		196,
		206,
		208,
		200,
		188,
		192,
		215,
		204,
		243,
		-1,
		-1,
		351,
		-1,
		-1,
		-1,
		263,
		238,
		253,
		292,
		273,
		280,
		243,
		240,
		-1,
		210,
		235,
		207,
		214,
		205,
		212,
		212,
		204,
		182,
		189,
		205,
		204,
		199,
		235,
		226,
		232,
		-1,
		-1,
		344,
		333,
		322,
		328,
		-1,
		269,
		255,
		278,
		268,
		271,
		-1,
		-1,
		259,
		256,
		232,
		215,
		213,
		206,
		201,
		211,
		191,
		178,
		182,
		186,
		192,
		197,
		202,
		208,
		223,
		238,
		-1,
		239,
		320,
		313,
		296,
		304,
		335,
		-1,
		272,
		274,
		262,
		260,
		262,
		-1,
		-1,
		232,
		229,
		234,
		222,
		219,
		221,
		216,
		207,
		192,
		198,
		185,
		184,
		202,
		206,
		215,
		222,
		212,
		225,
		229,
		-1,
		253,
		296,
		290,
		293,
		317,
		331,
		-1,
		279,
		-1,
		-1,
		270,
		263,
		247,
		237,
		231,
		281,
		236,
		231,
		215,
		213,
		204,
		195,
		202,
		193,
		193,
		196,
		211,
		216,
		208,
		222,
		222,
		223,
		-1,
		288,
		276,
		284,
		-1,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		286,
		-1,
		274,
		-1,
		249,
		253,
		244,
		247,
		229,
		216,
		208,
		200,
		216,
		191,
		201,
		197,
		198,
		207,
		218,
		230,
		229,
		230,
		350,
		306,
		284,
		275,
		322,
		337,
		341,
		-1,
		291,
		330,
		324,
		-1,
		295,
		-1,
		-1,
		-1,
		263,
		257,
		249,
		249,
		228,
		228,
		202,
		206,
		196,
		203,
		213,
		215,
		207,
		211,
		224,
		235,
		238,
		346,
		337,
		350,
		295,
		289,
		307,
		316,
		337,
		306,
		297,
		324,
		331,
		320,
		315,
		302,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		235,
		223,
		206,
		207,
		203,
		206,
		221,
		224,
		214,
		212,
		206,
		238,
		-1,
		339,
		338,
		327,
		324,
		300,
		291,
		286,
		308,
		-1,
		-1,
		308,
		325,
		319,
		323,
		339,
		364,
		-1,
		295,
		-1,
		-1,
		280,
		-1,
		-1,
		265,
		228,
		217,
		208,
		214,
		211,
		222,
		232,
		220,
		221,
		211,
		221,
		234,
		323,
		320,
		308,
		306,
		329,
		294,
		282,
		-1,
		295,
		293,
		299,
		306,
		323,
		353,
		-1,
		-1,
		311,
		291,
		-1,
		-1,
		263,
		261,
		250,
		-1,
		240,
		213,
		218,
		238,
		240,
		229,
		223,
		217,
		224,
		223,
		231,
		239,
		332,
		346,
		335,
		331,
		330,
		338,
		287,
		280,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		-1,
		301,
		297,
		-1,
		-1,
		258,
		251,
		239,
		227,
		217,
		227,
		231,
		235,
		227,
		220,
		215,
		226,
		218,
		222,
		239,
		-1,
		366,
		-1,
		318,
		294,
		308,
		323,
		331,
		-1,
		-1,
		-1,
		318,
		304,
		297,
		285,
		283,
		-1,
		292,
		276,
		257,
		-1,
		227,
		240,
		271,
		239,
		244,
		239,
		221,
		232,
		221,
		224,
		238,
		233,
		-1,
		-1,
		306,
		309,
		-1,
		-1,
		308,
		310,
		-1,
		309,
		298,
		283,
		275,
		-1,
		-1,
		264,
		260,
		-1,
		-1,
		228,
		253,
		242,
		250,
		245,
		225,
		231,
		234,
		223,
		227,
		239,
		-1,
		-1,
		313,
		314,
		315,
		-1,
		293,
		-1,
		311,
		-1,
		278,
		284,
		272,
		-1,
		-1,
		-1,
		266,
		229,
		250,
		260,
		254,
		252,
		243,
		229,
		236,
		234,
		230,
		241,
		-1,
		-1,
		-1,
		311,
		285,
		318,
		309,
		292,
		272,
		264,
		283,
		-1,
		253,
		-1,
		228,
		230,
		256,
		259,
		265,
		259,
		232,
		247,
		237,
		228,
		237,
		317,
		-1,
		287,
		320,
		284,
		278,
		254,
		258,
		274,
		-1,
		250,
		232,
		-1,
		260,
		250,
		281,
		266,
		247,
		234,
		241,
		241,
		234,
		-1,
		-1,
		-1,
		289,
		288,
		280,
		274,
		274,
		259,
		250,
		-1,
		262,
		244,
		223,
		240,
		240,
		231,
		239,
		271,
		267,
		254,
		254,
		246,
		-1,
		390,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		283,
		278,
		251,
		239,
		245,
		241,
		227,
		233,
		235,
		243,
		241,
		238,
		250,
		246,
		266,
		247,
		282,
		-1,
		385,
		-1,
		319,
		-1,
		-1,
		301,
		281,
		273,
		262,
		251,
		249,
		240,
		231,
		253,
		269,
		253,
		251,
		254,
		255,
		-1,
		374,
		373,
		-1,
		320,
		312,
		298,
		-1,
		291,
		-1,
		297,
		258,
		-1,
		260,
		240,
		-1,
		262,
		258,
		-1,
		-1,
		361,
		336,
		-1,
		-1,
		-1,
		321,
		301,
		292,
		276,
		-1,
		251,
		251,
		-1,
		-1,
		-1,
		346,
		345,
		-1,
		314,
		317,
		-1,
		307,
		298,
		306,
		253,
		257,
		-1,
		-1,
		-1,
		355,
		336,
		330,
		329,
		327,
		322,
		319,
		305,
		289,
		267,
		256,
		277,
		-1,
		-1,
		-1,
		327,
		319,
		312,
		-1,
		-1,
		314,
		297,
		278,
		276,
		-1,
		-1,
		-1,
		349,
		330,
		-1,
		-1,
		304,
		-1,
		-1,
		310,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		366,
		338,
		-1,
		-1,
		-1,
		300,
		296,
		297,
		-1,
		-1,
		-1,
		-1,
		360,
		361,
		384,
		348,
		-1,
		-1,
		-1,
		292,
		286,
		-1,
		-1,
		363,
		361,
		-1,
		-1,
		-1,
		320,
		304,
		-1,
		290,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		323,
		-1,
		-1,
		-1,
		325,
		-1,
		325,
		300,
		307,
		-1,
		-1,
		-1,
		-1,
		338,
		330,
		338,
		-1,
		310,
		312,
		-1,
		360,
		-1,
		-1,
		353,
		344,
		-1,
		-1,
		315,
		322,
		344,
		347,
		383,
		-1,
		334
	],
	[
		-1,
		67,
		62,
		73,
		69,
		54,
		58,
		-1,
		102,
		72,
		50,
		44,
		69,
		68,
		80,
		91,
		-1,
		-1,
		-1,
		50,
		42,
		57,
		53,
		63,
		74,
		81,
		-1,
		132,
		-1,
		64,
		19,
		22,
		0,
		55,
		58,
		78,
		105,
		127,
		129,
		79,
		85,
		62,
		63,
		86,
		97,
		131,
		123,
		-1,
		69,
		66,
		88,
		101,
		116,
		119,
		-1,
		-1,
		70,
		80,
		86,
		101,
		120,
		123,
		-1,
		133,
		152,
		-1,
		-1,
		69,
		82,
		95,
		98,
		106,
		112,
		125,
		142,
		147,
		-1,
		-1,
		87,
		91,
		101,
		99,
		95,
		112,
		131,
		142,
		156,
		155,
		-1,
		81,
		99,
		108,
		106,
		104,
		88,
		92,
		110,
		141,
		147,
		150,
		-1,
		98,
		94,
		104,
		110,
		122,
		104,
		91,
		97,
		116,
		129,
		148,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		99,
		90,
		110,
		112,
		111,
		125,
		123,
		94,
		100,
		104,
		121,
		137,
		138,
		148,
		-1,
		-1,
		192,
		165,
		189,
		147,
		129,
		-1,
		95,
		97,
		103,
		107,
		112,
		120,
		125,
		110,
		-1,
		115,
		114,
		145,
		131,
		142,
		174,
		-1,
		-1,
		150,
		142,
		124,
		127,
		104,
		100,
		112,
		111,
		107,
		109,
		111,
		123,
		118,
		131,
		138,
		109,
		119,
		123,
		138,
		149,
		-1,
		-1,
		223,
		-1,
		-1,
		171,
		154,
		-1,
		119,
		126,
		110,
		116,
		102,
		123,
		122,
		116,
		123,
		126,
		114,
		131,
		128,
		145,
		131,
		106,
		131,
		135,
		141,
		159,
		160,
		-1,
		222,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		126,
		123,
		116,
		140,
		139,
		-1,
		145,
		143,
		149,
		134,
		139,
		135,
		120,
		136,
		131,
		131,
		128,
		113,
		115,
		152,
		143,
		164,
		161,
		192,
		198,
		192,
		201,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		144,
		-1,
		147,
		160,
		157,
		145,
		148,
		135,
		143,
		142,
		126,
		142,
		129,
		126,
		125,
		121,
		130,
		140,
		139,
		157,
		170,
		185,
		189,
		195,
		-1,
		229,
		-1,
		171,
		155,
		157,
		133,
		161,
		-1,
		164,
		148,
		168,
		159,
		159,
		-1,
		151,
		148,
		158,
		141,
		126,
		141,
		129,
		124,
		124,
		128,
		143,
		134,
		152,
		159,
		167,
		171,
		191,
		203,
		189,
		179,
		-1,
		161,
		166,
		136,
		148,
		171,
		191,
		175,
		-1,
		170,
		-1,
		153,
		166,
		-1,
		147,
		143,
		132,
		137,
		126,
		133,
		131,
		125,
		122,
		140,
		143,
		160,
		164,
		180,
		-1,
		-1,
		174,
		178,
		186,
		137,
		156,
		180,
		217,
		184,
		177,
		176,
		-1,
		171,
		168,
		165,
		166,
		152,
		145,
		146,
		132,
		138,
		139,
		124,
		127,
		149,
		177,
		155,
		167,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		163,
		134,
		158,
		200,
		206,
		199,
		187,
		202,
		202,
		195,
		-1,
		183,
		162,
		159,
		149,
		139,
		155,
		145,
		148,
		128,
		130,
		146,
		158,
		149,
		169,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		137,
		171,
		189,
		235,
		221,
		226,
		201,
		194,
		188,
		177,
		179,
		167,
		156,
		148,
		137,
		146,
		156,
		150,
		130,
		139,
		140,
		164,
		171,
		177,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		162,
		169,
		201,
		226,
		239,
		-1,
		193,
		-1,
		182,
		177,
		161,
		156,
		153,
		150,
		144,
		153,
		158,
		144,
		135,
		150,
		169,
		169,
		161,
		186,
		189,
		-1,
		-1,
		-1,
		193,
		210,
		185,
		162,
		143,
		179,
		-1,
		209,
		210,
		-1,
		187,
		181,
		178,
		163,
		159,
		154,
		158,
		151,
		158,
		154,
		153,
		154,
		136,
		172,
		-1,
		169,
		163,
		191,
		194,
		184,
		-1,
		-1,
		-1,
		208,
		187,
		180,
		200,
		150,
		202,
		-1,
		-1,
		194,
		187,
		-1,
		174,
		156,
		163,
		161,
		155,
		159,
		163,
		152,
		165,
		161,
		141,
		151,
		171,
		175,
		182,
		175,
		180,
		179,
		193,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		170,
		-1,
		203,
		195,
		185,
		179,
		173,
		169,
		167,
		183,
		167,
		170,
		170,
		166,
		174,
		159,
		158,
		144,
		148,
		166,
		193,
		188,
		183,
		182,
		189,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		185,
		-1,
		156,
		180,
		196,
		-1,
		211,
		190,
		205,
		183,
		179,
		175,
		190,
		191,
		169,
		174,
		173,
		183,
		180,
		169,
		156,
		160,
		175,
		185,
		177,
		178,
		187,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		159,
		172,
		183,
		-1,
		-1,
		247,
		-1,
		181,
		198,
		189,
		187,
		180,
		171,
		177,
		184,
		187,
		184,
		174,
		163,
		169,
		165,
		187,
		173,
		171,
		190,
		205,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		225,
		215,
		199,
		184,
		217,
		-1,
		188,
		172,
		177,
		-1,
		209,
		-1,
		182,
		182,
		173,
		162,
		159,
		170,
		168,
		179,
		196,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		216,
		-1,
		-1,
		212,
		206,
		206,
		190,
		193,
		204,
		184,
		178,
		177,
		204,
		199,
		190,
		171,
		164,
		161,
		162,
		175,
		195,
		186,
		198,
		-1,
		-1,
		-1,
		217,
		197,
		203,
		161,
		182,
		-1,
		-1,
		274,
		229,
		215,
		-1,
		199,
		221,
		209,
		199,
		189,
		223,
		215,
		190,
		183,
		169,
		171,
		169,
		171,
		176,
		197,
		198,
		211,
		-1,
		-1,
		194,
		201,
		189,
		175,
		194,
		-1,
		-1,
		-1,
		221,
		237,
		229,
		200,
		210,
		-1,
		-1,
		201,
		199,
		207,
		186,
		173,
		193,
		196,
		186,
		170,
		185,
		197,
		205,
		210,
		-1,
		197,
		184,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		-1,
		-1,
		254,
		220,
		232,
		227,
		231,
		204,
		-1,
		203,
		197,
		177,
		191,
		198,
		188,
		183,
		177,
		180,
		198,
		215,
		-1,
		-1,
		211,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		211,
		225,
		220,
		213,
		217,
		-1,
		205,
		193,
		179,
		196,
		201,
		198,
		189,
		181,
		186,
		183,
		196,
		210,
		214,
		234,
		-1,
		217,
		-1,
		-1,
		-1,
		229,
		244,
		259,
		236,
		209,
		204,
		197,
		191,
		187,
		203,
		209,
		220,
		188,
		184,
		185,
		189,
		188,
		205,
		215,
		-1,
		-1,
		217,
		234,
		255,
		237,
		241,
		286,
		-1,
		-1,
		213,
		204,
		195,
		198,
		197,
		200,
		194,
		191,
		196,
		201,
		189,
		198,
		216,
		215,
		-1,
		-1,
		-1,
		237,
		-1,
		252,
		-1,
		-1,
		256,
		284,
		231,
		213,
		209,
		207,
		200,
		209,
		204,
		199,
		209,
		211,
		203,
		191,
		195,
		218,
		207,
		246,
		-1,
		-1,
		354,
		-1,
		-1,
		-1,
		266,
		241,
		256,
		295,
		276,
		283,
		246,
		243,
		-1,
		213,
		238,
		210,
		217,
		208,
		215,
		215,
		207,
		185,
		192,
		208,
		207,
		202,
		238,
		229,
		235,
		-1,
		-1,
		347,
		336,
		325,
		331,
		-1,
		272,
		258,
		281,
		271,
		274,
		-1,
		-1,
		262,
		259,
		235,
		218,
		216,
		209,
		204,
		214,
		194,
		181,
		185,
		189,
		195,
		200,
		205,
		211,
		226,
		241,
		-1,
		242,
		323,
		316,
		299,
		307,
		338,
		-1,
		275,
		277,
		265,
		263,
		265,
		-1,
		-1,
		235,
		232,
		237,
		225,
		222,
		224,
		219,
		210,
		195,
		201,
		188,
		187,
		205,
		209,
		218,
		225,
		215,
		228,
		232,
		-1,
		256,
		299,
		293,
		296,
		320,
		334,
		-1,
		282,
		-1,
		-1,
		273,
		266,
		250,
		240,
		234,
		284,
		239,
		234,
		218,
		216,
		207,
		198,
		205,
		196,
		196,
		199,
		214,
		219,
		211,
		225,
		225,
		226,
		-1,
		291,
		279,
		287,
		-1,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		289,
		-1,
		277,
		-1,
		252,
		256,
		247,
		250,
		232,
		219,
		211,
		203,
		219,
		194,
		204,
		200,
		201,
		210,
		221,
		233,
		232,
		233,
		353,
		309,
		287,
		278,
		325,
		340,
		344,
		-1,
		294,
		333,
		327,
		-1,
		298,
		-1,
		-1,
		-1,
		266,
		260,
		252,
		252,
		231,
		231,
		205,
		209,
		199,
		206,
		216,
		218,
		210,
		214,
		227,
		238,
		241,
		349,
		340,
		353,
		298,
		292,
		310,
		319,
		340,
		309,
		300,
		327,
		334,
		323,
		318,
		305,
		-1,
		-1,
		289,
		270,
		-1,
		-1,
		238,
		226,
		209,
		210,
		206,
		209,
		224,
		227,
		217,
		215,
		209,
		241,
		-1,
		342,
		341,
		330,
		327,
		303,
		294,
		289,
		311,
		-1,
		-1,
		311,
		328,
		322,
		326,
		342,
		367,
		-1,
		298,
		-1,
		-1,
		283,
		-1,
		-1,
		268,
		231,
		220,
		211,
		217,
		214,
		225,
		235,
		223,
		224,
		214,
		224,
		237,
		326,
		323,
		311,
		309,
		332,
		297,
		285,
		-1,
		298,
		296,
		302,
		309,
		326,
		356,
		-1,
		-1,
		314,
		294,
		-1,
		-1,
		266,
		264,
		253,
		-1,
		243,
		216,
		221,
		241,
		243,
		232,
		226,
		220,
		227,
		226,
		234,
		242,
		335,
		349,
		338,
		334,
		333,
		341,
		290,
		283,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		-1,
		304,
		300,
		-1,
		-1,
		261,
		254,
		242,
		230,
		220,
		230,
		234,
		238,
		230,
		223,
		218,
		229,
		221,
		225,
		242,
		-1,
		369,
		-1,
		321,
		297,
		311,
		326,
		334,
		-1,
		-1,
		-1,
		321,
		307,
		300,
		288,
		286,
		-1,
		295,
		279,
		260,
		-1,
		230,
		243,
		274,
		242,
		247,
		242,
		224,
		235,
		224,
		227,
		241,
		236,
		-1,
		-1,
		309,
		312,
		-1,
		-1,
		311,
		313,
		-1,
		312,
		301,
		286,
		278,
		-1,
		-1,
		267,
		263,
		-1,
		-1,
		231,
		256,
		245,
		253,
		248,
		228,
		234,
		237,
		226,
		230,
		242,
		-1,
		-1,
		316,
		317,
		318,
		-1,
		296,
		-1,
		314,
		-1,
		281,
		287,
		275,
		-1,
		-1,
		-1,
		269,
		232,
		253,
		263,
		257,
		255,
		246,
		232,
		239,
		237,
		233,
		244,
		-1,
		-1,
		-1,
		314,
		288,
		321,
		312,
		295,
		275,
		267,
		286,
		-1,
		256,
		-1,
		231,
		233,
		259,
		262,
		268,
		262,
		235,
		250,
		240,
		231,
		240,
		320,
		-1,
		290,
		323,
		287,
		281,
		257,
		261,
		277,
		-1,
		253,
		235,
		-1,
		263,
		253,
		284,
		269,
		250,
		237,
		244,
		244,
		237,
		-1,
		-1,
		-1,
		292,
		291,
		283,
		277,
		277,
		262,
		253,
		-1,
		265,
		247,
		226,
		243,
		243,
		234,
		242,
		274,
		270,
		257,
		257,
		249,
		-1,
		393,
		-1,
		-1,
		315,
		-1,
		-1,
		-1,
		286,
		281,
		254,
		242,
		248,
		244,
		230,
		236,
		238,
		246,
		244,
		241,
		253,
		249,
		269,
		250,
		285,
		-1,
		388,
		-1,
		322,
		-1,
		-1,
		304,
		284,
		276,
		265,
		254,
		252,
		243,
		234,
		256,
		272,
		256,
		254,
		257,
		258,
		-1,
		377,
		376,
		-1,
		323,
		315,
		301,
		-1,
		294,
		-1,
		300,
		261,
		-1,
		263,
		243,
		-1,
		265,
		261,
		-1,
		-1,
		364,
		339,
		-1,
		-1,
		-1,
		324,
		304,
		295,
		279,
		-1,
		254,
		254,
		-1,
		-1,
		-1,
		349,
		348,
		-1,
		317,
		320,
		-1,
		310,
		301,
		309,
		256,
		260,
		-1,
		-1,
		-1,
		358,
		339,
		333,
		332,
		330,
		325,
		322,
		308,
		292,
		270,
		259,
		280,
		-1,
		-1,
		-1,
		330,
		322,
		315,
		-1,
		-1,
		317,
		300,
		281,
		279,
		-1,
		-1,
		-1,
		352,
		333,
		-1,
		-1,
		307,
		-1,
		-1,
		313,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		369,
		341,
		-1,
		-1,
		-1,
		303,
		299,
		300,
		-1,
		-1,
		-1,
		-1,
		363,
		364,
		387,
		351,
		-1,
		-1,
		-1,
		295,
		289,
		-1,
		-1,
		366,
		364,
		-1,
		-1,
		-1,
		323,
		307,
		-1,
		293,
		-1,
		-1,
		-1,
		314,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		328,
		-1,
		328,
		303,
		310,
		-1,
		-1,
		-1,
		-1,
		341,
		333,
		341,
		-1,
		313,
		315,
		-1,
		363,
		-1,
		-1,
		356,
		347,
		-1,
		-1,
		318,
		325,
		347,
		350,
		386,
		-1,
		337
	],
	[
		-1,
		42,
		31,
		42,
		50,
		23,
		30,
		-1,
		47,
		53,
		19,
		13,
		50,
		19,
		25,
		36,
		-1,
		-1,
		-1,
		42,
		41,
		7,
		5,
		14,
		19,
		26,
		-1,
		77,
		-1,
		63,
		42,
		53,
		58,
		0,
		3,
		23,
		50,
		72,
		74,
		78,
		30,
		7,
		8,
		31,
		42,
		76,
		69,
		-1,
		14,
		11,
		33,
		47,
		62,
		66,
		-1,
		-1,
		15,
		25,
		32,
		47,
		66,
		72,
		-1,
		82,
		101,
		-1,
		-1,
		15,
		28,
		41,
		44,
		52,
		61,
		74,
		91,
		96,
		-1,
		-1,
		33,
		37,
		47,
		48,
		44,
		61,
		80,
		91,
		105,
		104,
		-1,
		35,
		53,
		62,
		55,
		53,
		37,
		41,
		59,
		90,
		96,
		99,
		-1,
		52,
		48,
		58,
		64,
		75,
		53,
		40,
		46,
		65,
		78,
		97,
		88,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		53,
		44,
		64,
		66,
		65,
		74,
		72,
		43,
		49,
		53,
		70,
		86,
		87,
		97,
		-1,
		-1,
		146,
		119,
		143,
		101,
		83,
		-1,
		49,
		51,
		57,
		61,
		66,
		74,
		74,
		59,
		-1,
		64,
		63,
		94,
		80,
		91,
		128,
		-1,
		-1,
		104,
		96,
		78,
		81,
		58,
		54,
		66,
		65,
		61,
		63,
		65,
		77,
		67,
		80,
		87,
		58,
		68,
		72,
		87,
		98,
		-1,
		-1,
		172,
		-1,
		-1,
		125,
		108,
		-1,
		73,
		80,
		64,
		70,
		56,
		77,
		76,
		70,
		77,
		80,
		68,
		80,
		77,
		94,
		80,
		55,
		80,
		84,
		90,
		108,
		109,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		80,
		77,
		70,
		94,
		93,
		-1,
		99,
		97,
		103,
		88,
		93,
		89,
		74,
		85,
		80,
		80,
		77,
		62,
		64,
		101,
		92,
		113,
		110,
		141,
		147,
		141,
		150,
		-1,
		133,
		129,
		125,
		132,
		81,
		-1,
		-1,
		98,
		-1,
		101,
		114,
		111,
		99,
		102,
		89,
		97,
		96,
		80,
		91,
		78,
		75,
		74,
		70,
		79,
		89,
		88,
		106,
		119,
		134,
		138,
		144,
		-1,
		183,
		-1,
		125,
		109,
		111,
		87,
		115,
		-1,
		118,
		102,
		122,
		113,
		113,
		-1,
		105,
		102,
		112,
		95,
		80,
		90,
		78,
		73,
		73,
		77,
		92,
		83,
		101,
		108,
		116,
		120,
		140,
		152,
		143,
		133,
		-1,
		115,
		120,
		90,
		102,
		125,
		145,
		129,
		-1,
		124,
		-1,
		107,
		120,
		-1,
		101,
		97,
		86,
		86,
		75,
		82,
		80,
		74,
		71,
		89,
		92,
		109,
		113,
		129,
		-1,
		-1,
		128,
		132,
		140,
		91,
		110,
		134,
		171,
		138,
		131,
		130,
		-1,
		125,
		122,
		119,
		120,
		106,
		99,
		98,
		81,
		87,
		88,
		73,
		76,
		98,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		117,
		88,
		112,
		154,
		160,
		153,
		141,
		151,
		151,
		145,
		-1,
		137,
		116,
		109,
		98,
		88,
		104,
		94,
		97,
		77,
		79,
		95,
		107,
		98,
		118,
		-1,
		-1,
		-1,
		147,
		136,
		137,
		91,
		125,
		143,
		184,
		170,
		175,
		150,
		143,
		137,
		131,
		133,
		116,
		105,
		97,
		86,
		95,
		105,
		99,
		79,
		88,
		89,
		113,
		120,
		126,
		-1,
		-1,
		154,
		144,
		128,
		130,
		127,
		116,
		123,
		155,
		175,
		188,
		-1,
		142,
		-1,
		131,
		126,
		110,
		105,
		102,
		99,
		93,
		102,
		107,
		93,
		84,
		99,
		118,
		118,
		110,
		135,
		138,
		-1,
		-1,
		-1,
		147,
		164,
		139,
		116,
		97,
		133,
		-1,
		158,
		159,
		-1,
		136,
		130,
		127,
		112,
		108,
		103,
		107,
		100,
		107,
		103,
		102,
		103,
		85,
		121,
		-1,
		118,
		112,
		140,
		143,
		133,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		104,
		156,
		-1,
		-1,
		143,
		136,
		-1,
		123,
		105,
		112,
		110,
		104,
		108,
		112,
		101,
		114,
		110,
		90,
		100,
		120,
		124,
		131,
		124,
		129,
		128,
		142,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		124,
		-1,
		152,
		144,
		134,
		128,
		122,
		118,
		116,
		132,
		116,
		119,
		119,
		115,
		123,
		108,
		107,
		93,
		97,
		115,
		142,
		137,
		132,
		131,
		138,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		139,
		-1,
		110,
		134,
		150,
		-1,
		160,
		139,
		154,
		132,
		128,
		124,
		139,
		140,
		118,
		123,
		122,
		132,
		129,
		118,
		105,
		109,
		124,
		134,
		126,
		127,
		136,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		113,
		122,
		137,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		138,
		136,
		129,
		120,
		126,
		133,
		136,
		133,
		123,
		112,
		118,
		114,
		136,
		122,
		120,
		139,
		154,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		137,
		121,
		126,
		-1,
		158,
		-1,
		131,
		131,
		122,
		111,
		108,
		119,
		117,
		128,
		145,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		170,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		153,
		133,
		127,
		126,
		153,
		148,
		139,
		120,
		113,
		110,
		111,
		124,
		144,
		135,
		147,
		-1,
		-1,
		-1,
		171,
		151,
		157,
		115,
		136,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		148,
		170,
		158,
		148,
		138,
		172,
		164,
		139,
		132,
		118,
		120,
		118,
		120,
		125,
		146,
		147,
		160,
		-1,
		-1,
		148,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		170,
		186,
		178,
		149,
		159,
		-1,
		-1,
		150,
		148,
		156,
		135,
		122,
		142,
		145,
		135,
		119,
		134,
		146,
		154,
		159,
		-1,
		151,
		138,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		181,
		176,
		180,
		153,
		-1,
		152,
		146,
		126,
		140,
		147,
		137,
		132,
		126,
		129,
		147,
		164,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		160,
		174,
		169,
		162,
		166,
		-1,
		154,
		142,
		128,
		145,
		150,
		147,
		138,
		130,
		135,
		132,
		145,
		159,
		163,
		188,
		-1,
		171,
		-1,
		-1,
		-1,
		178,
		193,
		208,
		185,
		158,
		153,
		146,
		140,
		136,
		152,
		158,
		169,
		137,
		133,
		134,
		138,
		137,
		154,
		164,
		-1,
		-1,
		171,
		188,
		204,
		186,
		190,
		235,
		-1,
		-1,
		162,
		153,
		144,
		147,
		146,
		149,
		143,
		140,
		145,
		150,
		138,
		147,
		165,
		164,
		-1,
		-1,
		-1,
		191,
		-1,
		206,
		-1,
		-1,
		205,
		233,
		180,
		162,
		158,
		156,
		149,
		158,
		153,
		148,
		158,
		160,
		152,
		140,
		144,
		167,
		156,
		195,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		220,
		195,
		210,
		244,
		225,
		232,
		195,
		192,
		-1,
		162,
		187,
		159,
		166,
		157,
		164,
		164,
		156,
		134,
		141,
		157,
		156,
		151,
		187,
		178,
		184,
		-1,
		-1,
		301,
		290,
		279,
		285,
		-1,
		226,
		212,
		230,
		220,
		223,
		-1,
		-1,
		211,
		208,
		184,
		167,
		165,
		158,
		153,
		163,
		143,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		196,
		277,
		270,
		253,
		261,
		292,
		-1,
		229,
		226,
		219,
		212,
		214,
		-1,
		-1,
		184,
		181,
		186,
		174,
		171,
		173,
		168,
		159,
		144,
		150,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		210,
		253,
		247,
		250,
		274,
		288,
		-1,
		231,
		-1,
		-1,
		227,
		215,
		199,
		189,
		183,
		233,
		188,
		183,
		167,
		165,
		156,
		147,
		154,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		245,
		233,
		241,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		243,
		-1,
		226,
		-1,
		201,
		205,
		196,
		199,
		181,
		168,
		160,
		152,
		168,
		143,
		153,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		302,
		258,
		241,
		232,
		279,
		294,
		298,
		-1,
		243,
		282,
		280,
		-1,
		252,
		-1,
		-1,
		-1,
		215,
		209,
		201,
		201,
		180,
		180,
		154,
		158,
		148,
		155,
		165,
		167,
		159,
		163,
		176,
		187,
		190,
		298,
		289,
		302,
		247,
		246,
		264,
		273,
		294,
		258,
		249,
		276,
		287,
		276,
		271,
		258,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		187,
		175,
		158,
		159,
		155,
		158,
		173,
		176,
		166,
		164,
		158,
		190,
		-1,
		291,
		290,
		279,
		276,
		252,
		243,
		238,
		265,
		-1,
		-1,
		260,
		277,
		271,
		275,
		291,
		316,
		-1,
		247,
		-1,
		-1,
		232,
		-1,
		-1,
		217,
		180,
		169,
		160,
		166,
		163,
		174,
		184,
		172,
		173,
		163,
		173,
		186,
		275,
		272,
		260,
		258,
		281,
		246,
		234,
		-1,
		247,
		245,
		251,
		258,
		275,
		305,
		-1,
		-1,
		263,
		243,
		-1,
		-1,
		215,
		213,
		202,
		-1,
		192,
		165,
		170,
		190,
		192,
		181,
		175,
		169,
		176,
		175,
		183,
		191,
		284,
		298,
		287,
		283,
		282,
		290,
		239,
		232,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		-1,
		253,
		249,
		-1,
		-1,
		210,
		203,
		191,
		179,
		169,
		179,
		183,
		187,
		179,
		172,
		167,
		178,
		170,
		174,
		191,
		-1,
		318,
		-1,
		270,
		246,
		260,
		275,
		283,
		-1,
		-1,
		-1,
		270,
		256,
		249,
		237,
		235,
		-1,
		244,
		228,
		209,
		-1,
		179,
		192,
		223,
		191,
		196,
		191,
		173,
		184,
		173,
		176,
		190,
		185,
		-1,
		-1,
		258,
		261,
		-1,
		-1,
		260,
		262,
		-1,
		261,
		250,
		235,
		227,
		-1,
		-1,
		216,
		212,
		-1,
		-1,
		180,
		205,
		194,
		202,
		197,
		177,
		183,
		186,
		175,
		179,
		191,
		-1,
		-1,
		265,
		266,
		267,
		-1,
		245,
		-1,
		263,
		-1,
		230,
		236,
		224,
		-1,
		-1,
		-1,
		218,
		181,
		202,
		212,
		206,
		204,
		195,
		181,
		188,
		186,
		182,
		193,
		-1,
		-1,
		-1,
		263,
		237,
		270,
		261,
		244,
		224,
		216,
		235,
		-1,
		205,
		-1,
		180,
		182,
		208,
		211,
		217,
		211,
		184,
		199,
		189,
		180,
		189,
		269,
		-1,
		239,
		272,
		236,
		230,
		206,
		210,
		226,
		-1,
		202,
		184,
		-1,
		212,
		202,
		233,
		218,
		199,
		186,
		193,
		193,
		186,
		-1,
		-1,
		-1,
		241,
		240,
		232,
		226,
		226,
		211,
		202,
		-1,
		214,
		196,
		175,
		192,
		192,
		183,
		191,
		223,
		219,
		206,
		206,
		198,
		-1,
		342,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		235,
		230,
		203,
		191,
		197,
		193,
		179,
		185,
		187,
		195,
		193,
		190,
		202,
		198,
		218,
		199,
		234,
		-1,
		337,
		-1,
		271,
		-1,
		-1,
		253,
		233,
		225,
		214,
		203,
		201,
		192,
		183,
		205,
		221,
		205,
		203,
		206,
		207,
		-1,
		326,
		325,
		-1,
		272,
		264,
		250,
		-1,
		243,
		-1,
		249,
		210,
		-1,
		212,
		192,
		-1,
		214,
		210,
		-1,
		-1,
		313,
		288,
		-1,
		-1,
		-1,
		273,
		253,
		244,
		228,
		-1,
		203,
		203,
		-1,
		-1,
		-1,
		298,
		297,
		-1,
		266,
		269,
		-1,
		259,
		250,
		258,
		205,
		209,
		-1,
		-1,
		-1,
		307,
		288,
		282,
		281,
		279,
		274,
		271,
		257,
		241,
		219,
		208,
		229,
		-1,
		-1,
		-1,
		279,
		271,
		264,
		-1,
		-1,
		266,
		249,
		230,
		228,
		-1,
		-1,
		-1,
		301,
		282,
		-1,
		-1,
		256,
		-1,
		-1,
		262,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		318,
		290,
		-1,
		-1,
		-1,
		252,
		248,
		249,
		-1,
		-1,
		-1,
		-1,
		312,
		313,
		336,
		300,
		-1,
		-1,
		-1,
		244,
		238,
		-1,
		-1,
		315,
		313,
		-1,
		-1,
		-1,
		272,
		256,
		-1,
		242,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		277,
		-1,
		277,
		252,
		259,
		-1,
		-1,
		-1,
		-1,
		290,
		282,
		290,
		-1,
		262,
		264,
		-1,
		312,
		-1,
		-1,
		305,
		296,
		-1,
		-1,
		267,
		274,
		296,
		299,
		335,
		-1,
		286
	],
	[
		-1,
		45,
		34,
		45,
		53,
		26,
		33,
		-1,
		50,
		56,
		22,
		16,
		53,
		22,
		28,
		39,
		-1,
		-1,
		-1,
		45,
		44,
		10,
		8,
		17,
		22,
		29,
		-1,
		74,
		-1,
		66,
		45,
		56,
		61,
		3,
		0,
		20,
		47,
		69,
		71,
		81,
		33,
		4,
		5,
		28,
		39,
		73,
		66,
		-1,
		11,
		8,
		30,
		44,
		59,
		63,
		-1,
		-1,
		12,
		22,
		29,
		44,
		63,
		69,
		-1,
		79,
		98,
		-1,
		-1,
		12,
		25,
		38,
		41,
		49,
		58,
		71,
		88,
		93,
		-1,
		-1,
		30,
		34,
		44,
		45,
		41,
		58,
		77,
		88,
		102,
		101,
		-1,
		32,
		50,
		59,
		52,
		50,
		34,
		38,
		56,
		87,
		93,
		96,
		-1,
		49,
		45,
		55,
		61,
		72,
		50,
		37,
		43,
		62,
		75,
		94,
		85,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		50,
		41,
		61,
		63,
		62,
		71,
		69,
		40,
		46,
		50,
		67,
		83,
		84,
		94,
		-1,
		-1,
		143,
		116,
		140,
		98,
		80,
		-1,
		46,
		48,
		54,
		58,
		63,
		71,
		71,
		56,
		-1,
		61,
		60,
		91,
		77,
		88,
		125,
		-1,
		-1,
		101,
		93,
		75,
		78,
		55,
		51,
		63,
		62,
		58,
		60,
		62,
		74,
		64,
		77,
		84,
		55,
		65,
		69,
		84,
		95,
		-1,
		-1,
		169,
		-1,
		-1,
		122,
		105,
		-1,
		70,
		77,
		61,
		67,
		53,
		74,
		73,
		67,
		74,
		77,
		65,
		77,
		74,
		91,
		77,
		52,
		77,
		81,
		87,
		105,
		106,
		-1,
		168,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		77,
		74,
		67,
		91,
		90,
		-1,
		96,
		94,
		100,
		85,
		90,
		86,
		71,
		82,
		77,
		77,
		74,
		59,
		61,
		98,
		89,
		110,
		107,
		138,
		144,
		138,
		147,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		95,
		-1,
		98,
		111,
		108,
		96,
		99,
		86,
		94,
		93,
		77,
		88,
		75,
		72,
		71,
		67,
		76,
		86,
		85,
		103,
		116,
		131,
		135,
		141,
		-1,
		180,
		-1,
		122,
		106,
		108,
		84,
		112,
		-1,
		115,
		99,
		119,
		110,
		110,
		-1,
		102,
		99,
		109,
		92,
		77,
		87,
		75,
		70,
		70,
		74,
		89,
		80,
		98,
		105,
		113,
		117,
		137,
		149,
		140,
		130,
		-1,
		112,
		117,
		87,
		99,
		122,
		142,
		126,
		-1,
		121,
		-1,
		104,
		117,
		-1,
		98,
		94,
		83,
		83,
		72,
		79,
		77,
		71,
		68,
		86,
		89,
		106,
		110,
		126,
		-1,
		-1,
		125,
		129,
		137,
		88,
		107,
		131,
		168,
		135,
		128,
		127,
		-1,
		122,
		119,
		116,
		117,
		103,
		96,
		95,
		78,
		84,
		85,
		70,
		73,
		95,
		123,
		101,
		113,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		114,
		85,
		109,
		151,
		157,
		150,
		138,
		148,
		148,
		142,
		-1,
		134,
		113,
		106,
		95,
		85,
		101,
		91,
		94,
		74,
		76,
		92,
		104,
		95,
		115,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		88,
		122,
		140,
		181,
		167,
		172,
		147,
		140,
		134,
		128,
		130,
		113,
		102,
		94,
		83,
		92,
		102,
		96,
		76,
		85,
		86,
		110,
		117,
		123,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		113,
		120,
		152,
		172,
		185,
		-1,
		139,
		-1,
		128,
		123,
		107,
		102,
		99,
		96,
		90,
		99,
		104,
		90,
		81,
		96,
		115,
		115,
		107,
		132,
		135,
		-1,
		-1,
		-1,
		144,
		161,
		136,
		113,
		94,
		130,
		-1,
		155,
		156,
		-1,
		133,
		127,
		124,
		109,
		105,
		100,
		104,
		97,
		104,
		100,
		99,
		100,
		82,
		118,
		-1,
		115,
		109,
		137,
		140,
		130,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		101,
		153,
		-1,
		-1,
		140,
		133,
		-1,
		120,
		102,
		109,
		107,
		101,
		105,
		109,
		98,
		111,
		107,
		87,
		97,
		117,
		121,
		128,
		121,
		126,
		125,
		139,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		121,
		-1,
		149,
		141,
		131,
		125,
		119,
		115,
		113,
		129,
		113,
		116,
		116,
		112,
		120,
		105,
		104,
		90,
		94,
		112,
		139,
		134,
		129,
		128,
		135,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		136,
		-1,
		107,
		131,
		147,
		-1,
		157,
		136,
		151,
		129,
		125,
		121,
		136,
		137,
		115,
		120,
		119,
		129,
		126,
		115,
		102,
		106,
		121,
		131,
		123,
		124,
		133,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		110,
		119,
		134,
		-1,
		-1,
		193,
		-1,
		127,
		144,
		135,
		133,
		126,
		117,
		123,
		130,
		133,
		130,
		120,
		109,
		115,
		111,
		133,
		119,
		117,
		136,
		151,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		171,
		161,
		145,
		130,
		163,
		-1,
		134,
		118,
		123,
		-1,
		155,
		-1,
		128,
		128,
		119,
		108,
		105,
		116,
		114,
		125,
		142,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		167,
		-1,
		-1,
		158,
		152,
		152,
		136,
		139,
		150,
		130,
		124,
		123,
		150,
		145,
		136,
		117,
		110,
		107,
		108,
		121,
		141,
		132,
		144,
		-1,
		-1,
		-1,
		168,
		148,
		154,
		112,
		133,
		-1,
		-1,
		220,
		175,
		161,
		-1,
		145,
		167,
		155,
		145,
		135,
		169,
		161,
		136,
		129,
		115,
		117,
		115,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		145,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		167,
		183,
		175,
		146,
		156,
		-1,
		-1,
		147,
		145,
		153,
		132,
		119,
		139,
		142,
		132,
		116,
		131,
		143,
		151,
		156,
		-1,
		148,
		135,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		200,
		166,
		178,
		173,
		177,
		150,
		-1,
		149,
		143,
		123,
		137,
		144,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		157,
		171,
		166,
		159,
		163,
		-1,
		151,
		139,
		125,
		142,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		175,
		190,
		205,
		182,
		155,
		150,
		143,
		137,
		133,
		149,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		168,
		185,
		201,
		183,
		187,
		232,
		-1,
		-1,
		159,
		150,
		141,
		144,
		143,
		146,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		161,
		-1,
		-1,
		-1,
		188,
		-1,
		203,
		-1,
		-1,
		202,
		230,
		177,
		159,
		155,
		153,
		146,
		155,
		150,
		145,
		155,
		157,
		149,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		217,
		192,
		207,
		241,
		222,
		229,
		192,
		189,
		-1,
		159,
		184,
		156,
		163,
		154,
		161,
		161,
		153,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		223,
		209,
		227,
		217,
		220,
		-1,
		-1,
		208,
		205,
		181,
		164,
		162,
		155,
		150,
		160,
		140,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		226,
		223,
		216,
		209,
		211,
		-1,
		-1,
		181,
		178,
		183,
		171,
		168,
		170,
		165,
		156,
		141,
		147,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		228,
		-1,
		-1,
		224,
		212,
		196,
		186,
		180,
		230,
		185,
		180,
		164,
		162,
		153,
		144,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		240,
		-1,
		223,
		-1,
		198,
		202,
		193,
		196,
		178,
		165,
		157,
		149,
		165,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		299,
		255,
		238,
		229,
		276,
		291,
		295,
		-1,
		240,
		279,
		277,
		-1,
		249,
		-1,
		-1,
		-1,
		212,
		206,
		198,
		198,
		177,
		177,
		151,
		155,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		295,
		286,
		299,
		244,
		243,
		261,
		270,
		291,
		255,
		246,
		273,
		284,
		273,
		268,
		255,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		184,
		172,
		155,
		156,
		152,
		155,
		170,
		173,
		163,
		161,
		155,
		187,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		235,
		262,
		-1,
		-1,
		257,
		274,
		268,
		272,
		288,
		313,
		-1,
		244,
		-1,
		-1,
		229,
		-1,
		-1,
		214,
		177,
		166,
		157,
		163,
		160,
		171,
		181,
		169,
		170,
		160,
		170,
		183,
		272,
		269,
		257,
		255,
		278,
		243,
		231,
		-1,
		244,
		242,
		248,
		255,
		272,
		302,
		-1,
		-1,
		260,
		240,
		-1,
		-1,
		212,
		210,
		199,
		-1,
		189,
		162,
		167,
		187,
		189,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		229,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		250,
		246,
		-1,
		-1,
		207,
		200,
		188,
		176,
		166,
		176,
		180,
		184,
		176,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		315,
		-1,
		267,
		243,
		257,
		272,
		280,
		-1,
		-1,
		-1,
		267,
		253,
		246,
		234,
		232,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		220,
		188,
		193,
		188,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		255,
		258,
		-1,
		-1,
		257,
		259,
		-1,
		258,
		247,
		232,
		224,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		177,
		202,
		191,
		199,
		194,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		262,
		263,
		264,
		-1,
		242,
		-1,
		260,
		-1,
		227,
		233,
		221,
		-1,
		-1,
		-1,
		215,
		178,
		199,
		209,
		203,
		201,
		192,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		260,
		234,
		267,
		258,
		241,
		221,
		213,
		232,
		-1,
		202,
		-1,
		177,
		179,
		205,
		208,
		214,
		208,
		181,
		196,
		186,
		177,
		186,
		266,
		-1,
		236,
		269,
		233,
		227,
		203,
		207,
		223,
		-1,
		199,
		181,
		-1,
		209,
		199,
		230,
		215,
		196,
		183,
		190,
		190,
		183,
		-1,
		-1,
		-1,
		238,
		237,
		229,
		223,
		223,
		208,
		199,
		-1,
		211,
		193,
		172,
		189,
		189,
		180,
		188,
		220,
		216,
		203,
		203,
		195,
		-1,
		339,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		232,
		227,
		200,
		188,
		194,
		190,
		176,
		182,
		184,
		192,
		190,
		187,
		199,
		195,
		215,
		196,
		231,
		-1,
		334,
		-1,
		268,
		-1,
		-1,
		250,
		230,
		222,
		211,
		200,
		198,
		189,
		180,
		202,
		218,
		202,
		200,
		203,
		204,
		-1,
		323,
		322,
		-1,
		269,
		261,
		247,
		-1,
		240,
		-1,
		246,
		207,
		-1,
		209,
		189,
		-1,
		211,
		207,
		-1,
		-1,
		310,
		285,
		-1,
		-1,
		-1,
		270,
		250,
		241,
		225,
		-1,
		200,
		200,
		-1,
		-1,
		-1,
		295,
		294,
		-1,
		263,
		266,
		-1,
		256,
		247,
		255,
		202,
		206,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		278,
		276,
		271,
		268,
		254,
		238,
		216,
		205,
		226,
		-1,
		-1,
		-1,
		276,
		268,
		261,
		-1,
		-1,
		263,
		246,
		227,
		225,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		253,
		-1,
		-1,
		259,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		287,
		-1,
		-1,
		-1,
		249,
		245,
		246,
		-1,
		-1,
		-1,
		-1,
		309,
		310,
		333,
		297,
		-1,
		-1,
		-1,
		241,
		235,
		-1,
		-1,
		312,
		310,
		-1,
		-1,
		-1,
		269,
		253,
		-1,
		239,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		274,
		-1,
		274,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		287,
		279,
		287,
		-1,
		259,
		261,
		-1,
		309,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		264,
		271,
		293,
		296,
		332,
		-1,
		283
	],
	[
		-1,
		66,
		55,
		66,
		74,
		47,
		54,
		-1,
		71,
		77,
		43,
		37,
		74,
		43,
		49,
		60,
		-1,
		-1,
		-1,
		66,
		65,
		31,
		29,
		38,
		43,
		50,
		-1,
		54,
		-1,
		87,
		66,
		77,
		82,
		24,
		21,
		0,
		27,
		49,
		51,
		102,
		54,
		21,
		26,
		12,
		33,
		53,
		61,
		-1,
		32,
		29,
		24,
		43,
		64,
		78,
		-1,
		-1,
		33,
		43,
		40,
		49,
		76,
		90,
		-1,
		100,
		119,
		-1,
		-1,
		33,
		46,
		59,
		62,
		69,
		79,
		92,
		109,
		114,
		-1,
		-1,
		51,
		55,
		65,
		66,
		62,
		79,
		98,
		109,
		123,
		122,
		-1,
		53,
		71,
		80,
		73,
		71,
		55,
		59,
		77,
		108,
		114,
		117,
		-1,
		70,
		66,
		76,
		82,
		93,
		71,
		58,
		64,
		83,
		96,
		115,
		106,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		71,
		62,
		82,
		84,
		83,
		92,
		90,
		61,
		67,
		71,
		88,
		104,
		105,
		115,
		-1,
		-1,
		164,
		137,
		161,
		119,
		101,
		-1,
		67,
		69,
		75,
		79,
		84,
		92,
		92,
		77,
		-1,
		82,
		81,
		112,
		98,
		109,
		146,
		-1,
		-1,
		122,
		114,
		96,
		99,
		76,
		72,
		84,
		83,
		79,
		81,
		83,
		95,
		85,
		98,
		105,
		76,
		86,
		90,
		105,
		116,
		-1,
		-1,
		190,
		-1,
		-1,
		143,
		126,
		-1,
		91,
		98,
		82,
		88,
		74,
		95,
		94,
		88,
		95,
		98,
		86,
		98,
		95,
		112,
		98,
		73,
		98,
		102,
		108,
		126,
		127,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		98,
		95,
		88,
		112,
		111,
		-1,
		117,
		115,
		121,
		106,
		111,
		107,
		92,
		103,
		98,
		98,
		95,
		80,
		82,
		119,
		110,
		131,
		128,
		159,
		165,
		159,
		168,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		116,
		-1,
		119,
		132,
		129,
		117,
		120,
		107,
		115,
		114,
		98,
		109,
		96,
		93,
		92,
		88,
		97,
		107,
		106,
		124,
		137,
		152,
		156,
		162,
		-1,
		201,
		-1,
		143,
		127,
		129,
		105,
		133,
		-1,
		136,
		120,
		140,
		131,
		131,
		-1,
		123,
		120,
		130,
		113,
		98,
		108,
		96,
		91,
		91,
		95,
		110,
		101,
		119,
		126,
		134,
		138,
		158,
		170,
		161,
		151,
		-1,
		133,
		138,
		108,
		120,
		143,
		163,
		147,
		-1,
		142,
		-1,
		125,
		138,
		-1,
		119,
		115,
		104,
		104,
		93,
		100,
		98,
		92,
		89,
		107,
		110,
		127,
		131,
		147,
		-1,
		-1,
		146,
		150,
		158,
		109,
		128,
		152,
		189,
		156,
		149,
		148,
		-1,
		143,
		140,
		137,
		138,
		124,
		117,
		116,
		99,
		105,
		106,
		91,
		94,
		116,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		135,
		106,
		130,
		172,
		178,
		171,
		159,
		169,
		169,
		163,
		-1,
		155,
		134,
		127,
		116,
		106,
		122,
		112,
		115,
		95,
		97,
		113,
		125,
		116,
		136,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		109,
		143,
		161,
		202,
		188,
		193,
		168,
		161,
		155,
		149,
		151,
		134,
		123,
		115,
		104,
		113,
		123,
		117,
		97,
		106,
		107,
		131,
		138,
		144,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		134,
		141,
		173,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		117,
		111,
		120,
		125,
		111,
		102,
		117,
		136,
		136,
		128,
		153,
		156,
		-1,
		-1,
		-1,
		165,
		182,
		157,
		134,
		115,
		151,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		121,
		125,
		118,
		125,
		121,
		120,
		121,
		103,
		139,
		-1,
		136,
		130,
		158,
		161,
		151,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		122,
		174,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		128,
		122,
		126,
		130,
		119,
		132,
		128,
		108,
		118,
		138,
		142,
		149,
		142,
		147,
		146,
		160,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		142,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		137,
		137,
		133,
		141,
		126,
		125,
		111,
		115,
		133,
		160,
		155,
		150,
		149,
		156,
		-1,
		228,
		214,
		185,
		-1,
		-1,
		157,
		-1,
		128,
		152,
		168,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		136,
		141,
		140,
		150,
		147,
		136,
		123,
		127,
		142,
		152,
		144,
		145,
		154,
		-1,
		234,
		221,
		179,
		175,
		164,
		184,
		131,
		140,
		155,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		138,
		144,
		151,
		154,
		151,
		141,
		130,
		136,
		132,
		154,
		140,
		138,
		157,
		172,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		150,
		137,
		131,
		-1,
		172,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		155,
		139,
		144,
		-1,
		176,
		-1,
		149,
		149,
		140,
		129,
		126,
		137,
		135,
		146,
		163,
		-1,
		184,
		169,
		162,
		152,
		166,
		137,
		-1,
		188,
		-1,
		-1,
		179,
		173,
		173,
		157,
		160,
		171,
		151,
		145,
		144,
		171,
		166,
		157,
		138,
		131,
		128,
		129,
		142,
		162,
		153,
		165,
		-1,
		-1,
		-1,
		189,
		169,
		175,
		133,
		154,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		166,
		188,
		176,
		166,
		156,
		190,
		182,
		157,
		150,
		136,
		138,
		136,
		138,
		143,
		164,
		165,
		178,
		-1,
		-1,
		166,
		173,
		161,
		147,
		166,
		-1,
		-1,
		-1,
		188,
		204,
		196,
		167,
		177,
		-1,
		-1,
		168,
		166,
		174,
		153,
		140,
		160,
		163,
		153,
		137,
		152,
		164,
		172,
		177,
		-1,
		169,
		156,
		-1,
		-1,
		169,
		163,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		199,
		194,
		198,
		171,
		-1,
		170,
		164,
		144,
		158,
		165,
		155,
		150,
		144,
		147,
		165,
		182,
		-1,
		-1,
		183,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		178,
		192,
		187,
		180,
		184,
		-1,
		172,
		160,
		146,
		163,
		168,
		165,
		156,
		148,
		153,
		150,
		163,
		177,
		181,
		206,
		-1,
		189,
		-1,
		-1,
		-1,
		196,
		211,
		226,
		203,
		176,
		171,
		164,
		158,
		154,
		170,
		176,
		187,
		155,
		151,
		152,
		156,
		155,
		172,
		182,
		-1,
		-1,
		189,
		206,
		222,
		204,
		208,
		253,
		-1,
		-1,
		180,
		171,
		162,
		165,
		164,
		167,
		161,
		158,
		163,
		168,
		156,
		165,
		183,
		182,
		-1,
		-1,
		-1,
		209,
		-1,
		224,
		-1,
		-1,
		223,
		251,
		198,
		180,
		176,
		174,
		167,
		176,
		171,
		166,
		176,
		178,
		170,
		158,
		162,
		185,
		174,
		213,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		238,
		213,
		228,
		262,
		243,
		250,
		213,
		210,
		-1,
		180,
		205,
		177,
		184,
		175,
		182,
		182,
		174,
		152,
		159,
		175,
		174,
		169,
		205,
		196,
		202,
		-1,
		-1,
		319,
		308,
		297,
		303,
		-1,
		244,
		230,
		248,
		238,
		241,
		-1,
		-1,
		229,
		226,
		202,
		185,
		183,
		176,
		171,
		181,
		161,
		148,
		152,
		156,
		162,
		167,
		172,
		178,
		193,
		208,
		-1,
		214,
		295,
		288,
		271,
		279,
		310,
		-1,
		247,
		244,
		237,
		230,
		232,
		-1,
		-1,
		202,
		199,
		204,
		192,
		189,
		191,
		186,
		177,
		162,
		168,
		155,
		154,
		172,
		176,
		185,
		192,
		182,
		195,
		199,
		-1,
		228,
		271,
		265,
		268,
		292,
		306,
		-1,
		249,
		-1,
		-1,
		245,
		233,
		217,
		207,
		201,
		251,
		206,
		201,
		185,
		183,
		174,
		165,
		172,
		163,
		163,
		166,
		181,
		186,
		178,
		192,
		192,
		193,
		-1,
		263,
		251,
		259,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		261,
		-1,
		244,
		-1,
		219,
		223,
		214,
		217,
		199,
		186,
		178,
		170,
		186,
		161,
		171,
		167,
		168,
		177,
		188,
		200,
		199,
		200,
		320,
		276,
		259,
		250,
		297,
		312,
		316,
		-1,
		261,
		300,
		298,
		-1,
		270,
		-1,
		-1,
		-1,
		233,
		227,
		219,
		219,
		198,
		198,
		172,
		176,
		166,
		173,
		183,
		185,
		177,
		181,
		194,
		205,
		208,
		316,
		307,
		320,
		265,
		264,
		282,
		291,
		312,
		276,
		267,
		294,
		305,
		294,
		289,
		276,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		205,
		193,
		176,
		177,
		173,
		176,
		191,
		194,
		184,
		182,
		176,
		208,
		-1,
		309,
		308,
		297,
		294,
		270,
		261,
		256,
		283,
		-1,
		-1,
		278,
		295,
		289,
		293,
		309,
		334,
		-1,
		265,
		-1,
		-1,
		250,
		-1,
		-1,
		235,
		198,
		187,
		178,
		184,
		181,
		192,
		202,
		190,
		191,
		181,
		191,
		204,
		293,
		290,
		278,
		276,
		299,
		264,
		252,
		-1,
		265,
		263,
		269,
		276,
		293,
		323,
		-1,
		-1,
		281,
		261,
		-1,
		-1,
		233,
		231,
		220,
		-1,
		210,
		183,
		188,
		208,
		210,
		199,
		193,
		187,
		194,
		193,
		201,
		209,
		302,
		316,
		305,
		301,
		300,
		308,
		257,
		250,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		-1,
		271,
		267,
		-1,
		-1,
		228,
		221,
		209,
		197,
		187,
		197,
		201,
		205,
		197,
		190,
		185,
		196,
		188,
		192,
		209,
		-1,
		336,
		-1,
		288,
		264,
		278,
		293,
		301,
		-1,
		-1,
		-1,
		288,
		274,
		267,
		255,
		253,
		-1,
		262,
		246,
		227,
		-1,
		197,
		210,
		241,
		209,
		214,
		209,
		191,
		202,
		191,
		194,
		208,
		203,
		-1,
		-1,
		276,
		279,
		-1,
		-1,
		278,
		280,
		-1,
		279,
		268,
		253,
		245,
		-1,
		-1,
		234,
		230,
		-1,
		-1,
		198,
		223,
		212,
		220,
		215,
		195,
		201,
		204,
		193,
		197,
		209,
		-1,
		-1,
		283,
		284,
		285,
		-1,
		263,
		-1,
		281,
		-1,
		248,
		254,
		242,
		-1,
		-1,
		-1,
		236,
		199,
		220,
		230,
		224,
		222,
		213,
		199,
		206,
		204,
		200,
		211,
		-1,
		-1,
		-1,
		281,
		255,
		288,
		279,
		262,
		242,
		234,
		253,
		-1,
		223,
		-1,
		198,
		200,
		226,
		229,
		235,
		229,
		202,
		217,
		207,
		198,
		207,
		287,
		-1,
		257,
		290,
		254,
		248,
		224,
		228,
		244,
		-1,
		220,
		202,
		-1,
		230,
		220,
		251,
		236,
		217,
		204,
		211,
		211,
		204,
		-1,
		-1,
		-1,
		259,
		258,
		250,
		244,
		244,
		229,
		220,
		-1,
		232,
		214,
		193,
		210,
		210,
		201,
		209,
		241,
		237,
		224,
		224,
		216,
		-1,
		360,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		253,
		248,
		221,
		209,
		215,
		211,
		197,
		203,
		205,
		213,
		211,
		208,
		220,
		216,
		236,
		217,
		252,
		-1,
		355,
		-1,
		289,
		-1,
		-1,
		271,
		251,
		243,
		232,
		221,
		219,
		210,
		201,
		223,
		239,
		223,
		221,
		224,
		225,
		-1,
		344,
		343,
		-1,
		290,
		282,
		268,
		-1,
		261,
		-1,
		267,
		228,
		-1,
		230,
		210,
		-1,
		232,
		228,
		-1,
		-1,
		331,
		306,
		-1,
		-1,
		-1,
		291,
		271,
		262,
		246,
		-1,
		221,
		221,
		-1,
		-1,
		-1,
		316,
		315,
		-1,
		284,
		287,
		-1,
		277,
		268,
		276,
		223,
		227,
		-1,
		-1,
		-1,
		325,
		306,
		300,
		299,
		297,
		292,
		289,
		275,
		259,
		237,
		226,
		247,
		-1,
		-1,
		-1,
		297,
		289,
		282,
		-1,
		-1,
		284,
		267,
		248,
		246,
		-1,
		-1,
		-1,
		319,
		300,
		-1,
		-1,
		274,
		-1,
		-1,
		280,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		336,
		308,
		-1,
		-1,
		-1,
		270,
		266,
		267,
		-1,
		-1,
		-1,
		-1,
		330,
		331,
		354,
		318,
		-1,
		-1,
		-1,
		262,
		256,
		-1,
		-1,
		333,
		331,
		-1,
		-1,
		-1,
		290,
		274,
		-1,
		260,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		295,
		-1,
		295,
		270,
		277,
		-1,
		-1,
		-1,
		-1,
		308,
		300,
		308,
		-1,
		280,
		282,
		-1,
		330,
		-1,
		-1,
		323,
		314,
		-1,
		-1,
		285,
		292,
		314,
		317,
		353,
		-1,
		304
	],
	[
		-1,
		91,
		80,
		91,
		99,
		72,
		79,
		-1,
		96,
		102,
		68,
		62,
		99,
		68,
		74,
		85,
		-1,
		-1,
		-1,
		91,
		90,
		56,
		54,
		63,
		68,
		75,
		-1,
		27,
		-1,
		112,
		91,
		102,
		107,
		49,
		46,
		25,
		0,
		22,
		24,
		127,
		79,
		46,
		46,
		21,
		42,
		26,
		34,
		-1,
		50,
		47,
		33,
		52,
		43,
		51,
		-1,
		-1,
		51,
		54,
		49,
		56,
		68,
		63,
		-1,
		118,
		109,
		-1,
		-1,
		55,
		68,
		77,
		65,
		54,
		77,
		110,
		127,
		114,
		-1,
		-1,
		73,
		77,
		82,
		72,
		76,
		101,
		116,
		126,
		129,
		131,
		-1,
		75,
		93,
		102,
		87,
		81,
		77,
		81,
		99,
		130,
		136,
		139,
		-1,
		92,
		88,
		98,
		104,
		109,
		82,
		80,
		86,
		105,
		118,
		137,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		84,
		104,
		106,
		105,
		103,
		101,
		83,
		89,
		93,
		110,
		126,
		127,
		137,
		-1,
		-1,
		186,
		159,
		183,
		141,
		123,
		-1,
		89,
		91,
		97,
		101,
		106,
		114,
		103,
		99,
		-1,
		104,
		103,
		134,
		120,
		131,
		168,
		-1,
		-1,
		144,
		136,
		118,
		121,
		98,
		94,
		106,
		105,
		101,
		103,
		105,
		117,
		107,
		120,
		127,
		98,
		108,
		112,
		127,
		138,
		-1,
		-1,
		212,
		-1,
		-1,
		165,
		148,
		-1,
		113,
		120,
		104,
		110,
		96,
		117,
		116,
		110,
		117,
		120,
		108,
		120,
		117,
		134,
		120,
		95,
		120,
		124,
		130,
		148,
		149,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		120,
		117,
		110,
		134,
		133,
		-1,
		139,
		137,
		143,
		128,
		133,
		129,
		114,
		125,
		120,
		120,
		117,
		102,
		104,
		141,
		132,
		153,
		150,
		181,
		187,
		181,
		190,
		-1,
		173,
		169,
		165,
		172,
		121,
		-1,
		-1,
		138,
		-1,
		141,
		154,
		151,
		139,
		142,
		129,
		137,
		136,
		120,
		131,
		118,
		115,
		114,
		110,
		119,
		129,
		128,
		146,
		159,
		174,
		178,
		184,
		-1,
		223,
		-1,
		165,
		149,
		151,
		127,
		155,
		-1,
		158,
		142,
		162,
		153,
		153,
		-1,
		145,
		142,
		152,
		135,
		120,
		130,
		118,
		113,
		113,
		117,
		132,
		123,
		141,
		148,
		156,
		160,
		180,
		192,
		183,
		173,
		-1,
		155,
		160,
		130,
		142,
		165,
		185,
		169,
		-1,
		164,
		-1,
		147,
		160,
		-1,
		141,
		137,
		126,
		126,
		115,
		122,
		120,
		114,
		111,
		129,
		132,
		149,
		153,
		169,
		-1,
		-1,
		168,
		172,
		180,
		131,
		150,
		174,
		211,
		178,
		171,
		170,
		-1,
		165,
		162,
		159,
		160,
		146,
		139,
		138,
		121,
		127,
		128,
		113,
		116,
		138,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		157,
		128,
		152,
		194,
		200,
		193,
		181,
		191,
		191,
		185,
		-1,
		177,
		156,
		149,
		138,
		128,
		144,
		134,
		137,
		117,
		119,
		135,
		147,
		138,
		158,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		131,
		165,
		183,
		224,
		210,
		215,
		190,
		183,
		177,
		171,
		173,
		156,
		145,
		137,
		126,
		135,
		145,
		139,
		119,
		128,
		129,
		153,
		160,
		166,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		156,
		163,
		195,
		215,
		228,
		-1,
		182,
		-1,
		171,
		166,
		150,
		145,
		142,
		139,
		133,
		142,
		147,
		133,
		124,
		139,
		158,
		158,
		150,
		175,
		178,
		-1,
		-1,
		-1,
		187,
		204,
		179,
		156,
		137,
		173,
		-1,
		198,
		199,
		-1,
		176,
		170,
		167,
		152,
		148,
		143,
		147,
		140,
		147,
		143,
		142,
		143,
		125,
		161,
		-1,
		158,
		152,
		180,
		183,
		173,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		144,
		196,
		-1,
		-1,
		183,
		176,
		-1,
		163,
		145,
		152,
		150,
		144,
		148,
		152,
		141,
		154,
		150,
		130,
		140,
		160,
		164,
		171,
		164,
		169,
		168,
		182,
		-1,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		164,
		-1,
		192,
		184,
		174,
		168,
		162,
		158,
		156,
		172,
		156,
		159,
		159,
		155,
		163,
		148,
		147,
		133,
		137,
		155,
		182,
		177,
		172,
		171,
		178,
		-1,
		250,
		236,
		207,
		-1,
		-1,
		179,
		-1,
		150,
		174,
		190,
		-1,
		200,
		179,
		194,
		172,
		168,
		164,
		179,
		180,
		158,
		163,
		162,
		172,
		169,
		158,
		145,
		149,
		164,
		174,
		166,
		167,
		176,
		-1,
		256,
		243,
		201,
		197,
		186,
		206,
		153,
		162,
		177,
		-1,
		-1,
		236,
		-1,
		170,
		187,
		178,
		176,
		169,
		160,
		166,
		173,
		176,
		173,
		163,
		152,
		158,
		154,
		176,
		162,
		160,
		179,
		194,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		172,
		159,
		153,
		-1,
		194,
		-1,
		214,
		204,
		188,
		173,
		206,
		-1,
		177,
		161,
		166,
		-1,
		198,
		-1,
		171,
		171,
		162,
		151,
		148,
		159,
		157,
		168,
		185,
		-1,
		206,
		191,
		184,
		174,
		188,
		159,
		-1,
		210,
		-1,
		-1,
		201,
		195,
		195,
		179,
		182,
		193,
		173,
		167,
		166,
		193,
		188,
		179,
		160,
		153,
		150,
		151,
		164,
		184,
		175,
		187,
		-1,
		-1,
		-1,
		211,
		191,
		197,
		155,
		176,
		-1,
		-1,
		263,
		218,
		204,
		-1,
		188,
		210,
		198,
		188,
		178,
		212,
		204,
		179,
		172,
		158,
		160,
		158,
		160,
		165,
		186,
		187,
		200,
		-1,
		-1,
		188,
		195,
		183,
		169,
		188,
		-1,
		-1,
		-1,
		210,
		226,
		218,
		189,
		199,
		-1,
		-1,
		190,
		188,
		196,
		175,
		162,
		182,
		185,
		175,
		159,
		174,
		186,
		194,
		199,
		-1,
		191,
		178,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		-1,
		-1,
		243,
		209,
		221,
		216,
		220,
		193,
		-1,
		192,
		186,
		166,
		180,
		187,
		177,
		172,
		166,
		169,
		187,
		204,
		-1,
		-1,
		205,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		200,
		214,
		209,
		202,
		206,
		-1,
		194,
		182,
		168,
		185,
		190,
		187,
		178,
		170,
		175,
		172,
		185,
		199,
		203,
		228,
		-1,
		211,
		-1,
		-1,
		-1,
		218,
		233,
		248,
		225,
		198,
		193,
		186,
		180,
		176,
		192,
		198,
		209,
		177,
		173,
		174,
		178,
		177,
		194,
		204,
		-1,
		-1,
		211,
		228,
		244,
		226,
		230,
		275,
		-1,
		-1,
		202,
		193,
		184,
		187,
		186,
		189,
		183,
		180,
		185,
		190,
		178,
		187,
		205,
		204,
		-1,
		-1,
		-1,
		231,
		-1,
		246,
		-1,
		-1,
		245,
		273,
		220,
		202,
		198,
		196,
		189,
		198,
		193,
		188,
		198,
		200,
		192,
		180,
		184,
		207,
		196,
		235,
		-1,
		-1,
		348,
		-1,
		-1,
		-1,
		260,
		235,
		250,
		284,
		265,
		272,
		235,
		232,
		-1,
		202,
		227,
		199,
		206,
		197,
		204,
		204,
		196,
		174,
		181,
		197,
		196,
		191,
		227,
		218,
		224,
		-1,
		-1,
		341,
		330,
		319,
		325,
		-1,
		266,
		252,
		270,
		260,
		263,
		-1,
		-1,
		251,
		248,
		224,
		207,
		205,
		198,
		193,
		203,
		183,
		170,
		174,
		178,
		184,
		189,
		194,
		200,
		215,
		230,
		-1,
		236,
		317,
		310,
		293,
		301,
		332,
		-1,
		269,
		266,
		259,
		252,
		254,
		-1,
		-1,
		224,
		221,
		226,
		214,
		211,
		213,
		208,
		199,
		184,
		190,
		177,
		176,
		194,
		198,
		207,
		214,
		204,
		217,
		221,
		-1,
		250,
		293,
		287,
		290,
		314,
		328,
		-1,
		271,
		-1,
		-1,
		267,
		255,
		239,
		229,
		223,
		273,
		228,
		223,
		207,
		205,
		196,
		187,
		194,
		185,
		185,
		188,
		203,
		208,
		200,
		214,
		214,
		215,
		-1,
		285,
		273,
		281,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		283,
		-1,
		266,
		-1,
		241,
		245,
		236,
		239,
		221,
		208,
		200,
		192,
		208,
		183,
		193,
		189,
		190,
		199,
		210,
		222,
		221,
		222,
		342,
		298,
		281,
		272,
		319,
		334,
		338,
		-1,
		283,
		322,
		320,
		-1,
		292,
		-1,
		-1,
		-1,
		255,
		249,
		241,
		241,
		220,
		220,
		194,
		198,
		188,
		195,
		205,
		207,
		199,
		203,
		216,
		227,
		230,
		338,
		329,
		342,
		287,
		286,
		304,
		313,
		334,
		298,
		289,
		316,
		327,
		316,
		311,
		298,
		-1,
		-1,
		278,
		259,
		-1,
		-1,
		227,
		215,
		198,
		199,
		195,
		198,
		213,
		216,
		206,
		204,
		198,
		230,
		-1,
		331,
		330,
		319,
		316,
		292,
		283,
		278,
		305,
		-1,
		-1,
		300,
		317,
		311,
		315,
		331,
		356,
		-1,
		287,
		-1,
		-1,
		272,
		-1,
		-1,
		257,
		220,
		209,
		200,
		206,
		203,
		214,
		224,
		212,
		213,
		203,
		213,
		226,
		315,
		312,
		300,
		298,
		321,
		286,
		274,
		-1,
		287,
		285,
		291,
		298,
		315,
		345,
		-1,
		-1,
		303,
		283,
		-1,
		-1,
		255,
		253,
		242,
		-1,
		232,
		205,
		210,
		230,
		232,
		221,
		215,
		209,
		216,
		215,
		223,
		231,
		324,
		338,
		327,
		323,
		322,
		330,
		279,
		272,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		308,
		-1,
		293,
		289,
		-1,
		-1,
		250,
		243,
		231,
		219,
		209,
		219,
		223,
		227,
		219,
		212,
		207,
		218,
		210,
		214,
		231,
		-1,
		358,
		-1,
		310,
		286,
		300,
		315,
		323,
		-1,
		-1,
		-1,
		310,
		296,
		289,
		277,
		275,
		-1,
		284,
		268,
		249,
		-1,
		219,
		232,
		263,
		231,
		236,
		231,
		213,
		224,
		213,
		216,
		230,
		225,
		-1,
		-1,
		298,
		301,
		-1,
		-1,
		300,
		302,
		-1,
		301,
		290,
		275,
		267,
		-1,
		-1,
		256,
		252,
		-1,
		-1,
		220,
		245,
		234,
		242,
		237,
		217,
		223,
		226,
		215,
		219,
		231,
		-1,
		-1,
		305,
		306,
		307,
		-1,
		285,
		-1,
		303,
		-1,
		270,
		276,
		264,
		-1,
		-1,
		-1,
		258,
		221,
		242,
		252,
		246,
		244,
		235,
		221,
		228,
		226,
		222,
		233,
		-1,
		-1,
		-1,
		303,
		277,
		310,
		301,
		284,
		264,
		256,
		275,
		-1,
		245,
		-1,
		220,
		222,
		248,
		251,
		257,
		251,
		224,
		239,
		229,
		220,
		229,
		309,
		-1,
		279,
		312,
		276,
		270,
		246,
		250,
		266,
		-1,
		242,
		224,
		-1,
		252,
		242,
		273,
		258,
		239,
		226,
		233,
		233,
		226,
		-1,
		-1,
		-1,
		281,
		280,
		272,
		266,
		266,
		251,
		242,
		-1,
		254,
		236,
		215,
		232,
		232,
		223,
		231,
		263,
		259,
		246,
		246,
		238,
		-1,
		382,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		275,
		270,
		243,
		231,
		237,
		233,
		219,
		225,
		227,
		235,
		233,
		230,
		242,
		238,
		258,
		239,
		274,
		-1,
		377,
		-1,
		311,
		-1,
		-1,
		293,
		273,
		265,
		254,
		243,
		241,
		232,
		223,
		245,
		261,
		245,
		243,
		246,
		247,
		-1,
		366,
		365,
		-1,
		312,
		304,
		290,
		-1,
		283,
		-1,
		289,
		250,
		-1,
		252,
		232,
		-1,
		254,
		250,
		-1,
		-1,
		353,
		328,
		-1,
		-1,
		-1,
		313,
		293,
		284,
		268,
		-1,
		243,
		243,
		-1,
		-1,
		-1,
		338,
		337,
		-1,
		306,
		309,
		-1,
		299,
		290,
		298,
		245,
		249,
		-1,
		-1,
		-1,
		347,
		328,
		322,
		321,
		319,
		314,
		311,
		297,
		281,
		259,
		248,
		269,
		-1,
		-1,
		-1,
		319,
		311,
		304,
		-1,
		-1,
		306,
		289,
		270,
		268,
		-1,
		-1,
		-1,
		341,
		322,
		-1,
		-1,
		296,
		-1,
		-1,
		302,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		358,
		330,
		-1,
		-1,
		-1,
		292,
		288,
		289,
		-1,
		-1,
		-1,
		-1,
		352,
		353,
		376,
		340,
		-1,
		-1,
		-1,
		284,
		278,
		-1,
		-1,
		355,
		353,
		-1,
		-1,
		-1,
		312,
		296,
		-1,
		282,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		315,
		-1,
		-1,
		-1,
		317,
		-1,
		317,
		292,
		299,
		-1,
		-1,
		-1,
		-1,
		330,
		322,
		330,
		-1,
		302,
		304,
		-1,
		352,
		-1,
		-1,
		345,
		336,
		-1,
		-1,
		307,
		314,
		336,
		339,
		375,
		-1,
		326
	],
	[
		-1,
		115,
		104,
		115,
		123,
		96,
		103,
		-1,
		120,
		126,
		92,
		86,
		123,
		92,
		98,
		109,
		-1,
		-1,
		-1,
		115,
		114,
		80,
		78,
		87,
		92,
		99,
		-1,
		8,
		-1,
		136,
		115,
		126,
		131,
		73,
		70,
		49,
		24,
		0,
		9,
		151,
		103,
		70,
		70,
		45,
		52,
		5,
		13,
		-1,
		74,
		71,
		57,
		41,
		22,
		33,
		-1,
		-1,
		65,
		66,
		52,
		35,
		50,
		45,
		-1,
		100,
		91,
		-1,
		-1,
		69,
		68,
		56,
		47,
		36,
		59,
		92,
		109,
		96,
		-1,
		-1,
		64,
		58,
		61,
		54,
		58,
		89,
		98,
		108,
		111,
		113,
		-1,
		73,
		91,
		90,
		69,
		63,
		65,
		69,
		87,
		113,
		122,
		122,
		-1,
		90,
		86,
		96,
		94,
		89,
		64,
		68,
		74,
		93,
		104,
		125,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		91,
		82,
		102,
		104,
		103,
		85,
		83,
		71,
		77,
		81,
		98,
		114,
		115,
		125,
		-1,
		-1,
		184,
		157,
		181,
		139,
		121,
		-1,
		87,
		89,
		95,
		99,
		102,
		110,
		85,
		87,
		-1,
		92,
		91,
		122,
		108,
		119,
		166,
		-1,
		-1,
		142,
		134,
		116,
		119,
		96,
		92,
		104,
		103,
		99,
		101,
		103,
		110,
		95,
		108,
		115,
		86,
		96,
		100,
		115,
		126,
		-1,
		-1,
		200,
		-1,
		-1,
		163,
		146,
		-1,
		111,
		118,
		102,
		108,
		94,
		115,
		114,
		108,
		115,
		118,
		106,
		108,
		105,
		122,
		108,
		83,
		108,
		112,
		118,
		136,
		137,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		118,
		115,
		108,
		132,
		131,
		-1,
		137,
		135,
		141,
		126,
		131,
		127,
		112,
		113,
		108,
		108,
		105,
		90,
		92,
		129,
		120,
		141,
		138,
		169,
		175,
		169,
		178,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		136,
		-1,
		139,
		152,
		149,
		137,
		140,
		127,
		135,
		134,
		118,
		119,
		106,
		103,
		102,
		98,
		107,
		117,
		116,
		134,
		147,
		162,
		166,
		172,
		-1,
		221,
		-1,
		163,
		147,
		149,
		125,
		153,
		-1,
		156,
		140,
		160,
		151,
		151,
		-1,
		143,
		140,
		150,
		133,
		118,
		118,
		106,
		101,
		101,
		105,
		120,
		111,
		129,
		136,
		144,
		148,
		168,
		180,
		181,
		171,
		-1,
		153,
		158,
		128,
		140,
		163,
		183,
		167,
		-1,
		162,
		-1,
		145,
		158,
		-1,
		139,
		135,
		124,
		114,
		103,
		110,
		108,
		102,
		99,
		117,
		120,
		137,
		141,
		157,
		-1,
		-1,
		166,
		170,
		178,
		129,
		148,
		172,
		209,
		176,
		169,
		168,
		-1,
		163,
		160,
		157,
		156,
		143,
		128,
		126,
		109,
		115,
		116,
		101,
		104,
		126,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		155,
		126,
		150,
		192,
		198,
		191,
		179,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		116,
		132,
		122,
		125,
		105,
		107,
		123,
		135,
		126,
		146,
		-1,
		-1,
		-1,
		185,
		174,
		175,
		129,
		163,
		181,
		212,
		198,
		203,
		178,
		171,
		165,
		169,
		163,
		144,
		133,
		125,
		114,
		123,
		133,
		127,
		107,
		116,
		117,
		141,
		148,
		154,
		-1,
		-1,
		192,
		182,
		166,
		168,
		165,
		154,
		161,
		193,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		135,
		121,
		112,
		127,
		146,
		146,
		138,
		163,
		166,
		-1,
		-1,
		-1,
		185,
		202,
		177,
		154,
		135,
		171,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		131,
		130,
		131,
		113,
		149,
		-1,
		146,
		140,
		168,
		171,
		161,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		142,
		194,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		140,
		129,
		142,
		138,
		118,
		128,
		148,
		152,
		159,
		152,
		157,
		156,
		170,
		-1,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		162,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		147,
		143,
		151,
		136,
		135,
		121,
		125,
		143,
		170,
		165,
		160,
		159,
		166,
		-1,
		248,
		234,
		205,
		-1,
		-1,
		177,
		-1,
		148,
		172,
		188,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		146,
		151,
		150,
		160,
		157,
		146,
		133,
		137,
		152,
		162,
		154,
		155,
		164,
		-1,
		254,
		241,
		199,
		195,
		184,
		204,
		151,
		150,
		175,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		148,
		154,
		161,
		164,
		161,
		151,
		140,
		146,
		142,
		164,
		150,
		148,
		167,
		182,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		170,
		157,
		151,
		-1,
		192,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		165,
		149,
		154,
		-1,
		186,
		-1,
		159,
		159,
		150,
		139,
		136,
		147,
		145,
		156,
		173,
		-1,
		204,
		189,
		182,
		172,
		186,
		157,
		-1,
		208,
		-1,
		-1,
		189,
		183,
		183,
		167,
		170,
		181,
		161,
		155,
		154,
		181,
		176,
		167,
		148,
		141,
		138,
		139,
		152,
		172,
		163,
		175,
		-1,
		-1,
		-1,
		209,
		189,
		195,
		153,
		174,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		176,
		198,
		186,
		176,
		166,
		200,
		192,
		167,
		160,
		146,
		148,
		146,
		148,
		153,
		174,
		175,
		188,
		-1,
		-1,
		186,
		193,
		181,
		167,
		186,
		-1,
		-1,
		-1,
		198,
		214,
		206,
		177,
		187,
		-1,
		-1,
		178,
		176,
		184,
		163,
		150,
		170,
		173,
		163,
		147,
		162,
		174,
		182,
		187,
		-1,
		189,
		176,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		-1,
		-1,
		231,
		197,
		209,
		204,
		208,
		181,
		-1,
		180,
		174,
		154,
		168,
		175,
		165,
		160,
		154,
		157,
		175,
		192,
		-1,
		-1,
		203,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		188,
		202,
		197,
		190,
		194,
		-1,
		182,
		170,
		156,
		173,
		178,
		175,
		166,
		158,
		163,
		160,
		173,
		187,
		191,
		226,
		-1,
		209,
		-1,
		-1,
		-1,
		206,
		221,
		236,
		213,
		186,
		181,
		174,
		168,
		164,
		180,
		186,
		197,
		165,
		161,
		162,
		166,
		165,
		182,
		192,
		-1,
		-1,
		209,
		226,
		232,
		214,
		218,
		263,
		-1,
		-1,
		190,
		181,
		172,
		175,
		174,
		177,
		171,
		168,
		173,
		178,
		166,
		175,
		193,
		192,
		-1,
		-1,
		-1,
		229,
		-1,
		244,
		-1,
		-1,
		233,
		261,
		208,
		190,
		186,
		184,
		177,
		186,
		181,
		176,
		186,
		188,
		180,
		168,
		172,
		195,
		184,
		223,
		-1,
		-1,
		346,
		-1,
		-1,
		-1,
		258,
		233,
		248,
		272,
		253,
		260,
		223,
		220,
		-1,
		190,
		215,
		187,
		194,
		185,
		192,
		192,
		184,
		162,
		169,
		185,
		184,
		179,
		215,
		206,
		212,
		-1,
		-1,
		339,
		328,
		317,
		323,
		-1,
		264,
		250,
		258,
		248,
		251,
		-1,
		-1,
		239,
		236,
		212,
		195,
		193,
		186,
		181,
		191,
		171,
		158,
		162,
		166,
		172,
		177,
		182,
		188,
		203,
		218,
		-1,
		234,
		315,
		308,
		291,
		299,
		330,
		-1,
		262,
		254,
		257,
		240,
		242,
		-1,
		-1,
		212,
		209,
		214,
		202,
		199,
		201,
		196,
		187,
		172,
		178,
		165,
		164,
		182,
		186,
		195,
		202,
		192,
		205,
		209,
		-1,
		248,
		291,
		285,
		288,
		312,
		326,
		-1,
		259,
		-1,
		-1,
		265,
		243,
		227,
		217,
		211,
		261,
		216,
		211,
		195,
		193,
		184,
		175,
		182,
		173,
		173,
		176,
		191,
		196,
		188,
		202,
		202,
		203,
		-1,
		283,
		271,
		279,
		-1,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		281,
		-1,
		254,
		-1,
		229,
		233,
		224,
		227,
		209,
		196,
		188,
		180,
		196,
		171,
		181,
		177,
		178,
		187,
		198,
		210,
		209,
		210,
		330,
		286,
		279,
		270,
		311,
		326,
		330,
		-1,
		271,
		310,
		308,
		-1,
		290,
		-1,
		-1,
		-1,
		243,
		237,
		229,
		229,
		208,
		208,
		182,
		186,
		176,
		183,
		193,
		195,
		187,
		191,
		204,
		215,
		218,
		326,
		317,
		330,
		275,
		275,
		296,
		305,
		326,
		286,
		277,
		304,
		315,
		304,
		299,
		286,
		-1,
		-1,
		266,
		247,
		-1,
		-1,
		215,
		203,
		186,
		187,
		183,
		186,
		201,
		204,
		194,
		192,
		186,
		218,
		-1,
		319,
		318,
		307,
		304,
		280,
		271,
		266,
		293,
		-1,
		-1,
		288,
		305,
		299,
		303,
		319,
		344,
		-1,
		275,
		-1,
		-1,
		260,
		-1,
		-1,
		245,
		208,
		197,
		188,
		194,
		191,
		202,
		212,
		200,
		201,
		191,
		201,
		214,
		303,
		300,
		288,
		286,
		309,
		274,
		262,
		-1,
		275,
		273,
		279,
		286,
		303,
		333,
		-1,
		-1,
		291,
		271,
		-1,
		-1,
		243,
		241,
		230,
		-1,
		220,
		193,
		198,
		218,
		220,
		209,
		203,
		197,
		204,
		203,
		211,
		219,
		312,
		326,
		315,
		311,
		310,
		318,
		267,
		260,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		-1,
		281,
		277,
		-1,
		-1,
		238,
		231,
		219,
		207,
		197,
		207,
		211,
		215,
		207,
		200,
		195,
		206,
		198,
		202,
		219,
		-1,
		346,
		-1,
		298,
		274,
		288,
		303,
		311,
		-1,
		-1,
		-1,
		298,
		284,
		277,
		265,
		263,
		-1,
		272,
		256,
		237,
		-1,
		207,
		220,
		251,
		219,
		224,
		219,
		201,
		212,
		201,
		204,
		218,
		213,
		-1,
		-1,
		286,
		289,
		-1,
		-1,
		288,
		290,
		-1,
		289,
		278,
		263,
		255,
		-1,
		-1,
		244,
		240,
		-1,
		-1,
		208,
		233,
		222,
		230,
		225,
		205,
		211,
		214,
		203,
		207,
		219,
		-1,
		-1,
		293,
		294,
		295,
		-1,
		273,
		-1,
		291,
		-1,
		258,
		264,
		252,
		-1,
		-1,
		-1,
		246,
		209,
		230,
		240,
		234,
		232,
		223,
		209,
		216,
		214,
		210,
		221,
		-1,
		-1,
		-1,
		291,
		265,
		298,
		289,
		272,
		252,
		244,
		263,
		-1,
		233,
		-1,
		208,
		210,
		236,
		239,
		245,
		239,
		212,
		227,
		217,
		208,
		217,
		297,
		-1,
		267,
		300,
		264,
		258,
		234,
		238,
		254,
		-1,
		230,
		212,
		-1,
		240,
		230,
		261,
		246,
		227,
		214,
		221,
		221,
		214,
		-1,
		-1,
		-1,
		269,
		268,
		260,
		254,
		254,
		239,
		230,
		-1,
		242,
		224,
		203,
		220,
		220,
		211,
		219,
		251,
		247,
		234,
		234,
		226,
		-1,
		370,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		263,
		258,
		231,
		219,
		225,
		221,
		207,
		213,
		215,
		223,
		221,
		218,
		230,
		226,
		246,
		227,
		262,
		-1,
		365,
		-1,
		299,
		-1,
		-1,
		281,
		261,
		253,
		242,
		231,
		229,
		220,
		211,
		233,
		249,
		233,
		231,
		234,
		235,
		-1,
		354,
		353,
		-1,
		300,
		292,
		278,
		-1,
		271,
		-1,
		277,
		238,
		-1,
		240,
		220,
		-1,
		242,
		238,
		-1,
		-1,
		341,
		316,
		-1,
		-1,
		-1,
		301,
		281,
		272,
		256,
		-1,
		231,
		231,
		-1,
		-1,
		-1,
		326,
		325,
		-1,
		294,
		297,
		-1,
		287,
		278,
		286,
		233,
		237,
		-1,
		-1,
		-1,
		335,
		316,
		310,
		309,
		307,
		302,
		299,
		285,
		269,
		247,
		236,
		257,
		-1,
		-1,
		-1,
		307,
		299,
		292,
		-1,
		-1,
		294,
		277,
		258,
		256,
		-1,
		-1,
		-1,
		329,
		310,
		-1,
		-1,
		284,
		-1,
		-1,
		290,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		346,
		318,
		-1,
		-1,
		-1,
		280,
		276,
		277,
		-1,
		-1,
		-1,
		-1,
		340,
		341,
		364,
		328,
		-1,
		-1,
		-1,
		272,
		266,
		-1,
		-1,
		343,
		341,
		-1,
		-1,
		-1,
		300,
		284,
		-1,
		270,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		305,
		-1,
		305,
		280,
		287,
		-1,
		-1,
		-1,
		-1,
		318,
		310,
		318,
		-1,
		290,
		292,
		-1,
		340,
		-1,
		-1,
		333,
		324,
		-1,
		-1,
		295,
		302,
		324,
		327,
		363,
		-1,
		314
	],
	[
		-1,
		118,
		107,
		118,
		126,
		99,
		106,
		-1,
		123,
		129,
		95,
		89,
		126,
		95,
		101,
		112,
		-1,
		-1,
		-1,
		118,
		117,
		83,
		81,
		90,
		95,
		102,
		-1,
		15,
		-1,
		139,
		118,
		129,
		134,
		76,
		73,
		52,
		27,
		10,
		0,
		154,
		106,
		73,
		73,
		48,
		50,
		14,
		14,
		-1,
		77,
		73,
		60,
		39,
		20,
		27,
		-1,
		-1,
		63,
		64,
		50,
		33,
		44,
		39,
		-1,
		94,
		85,
		-1,
		-1,
		67,
		66,
		54,
		41,
		30,
		53,
		86,
		103,
		90,
		-1,
		-1,
		62,
		56,
		59,
		48,
		52,
		83,
		92,
		102,
		105,
		107,
		-1,
		67,
		85,
		88,
		63,
		57,
		59,
		63,
		81,
		107,
		116,
		116,
		-1,
		84,
		80,
		90,
		90,
		85,
		58,
		62,
		68,
		87,
		98,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		85,
		76,
		96,
		98,
		97,
		79,
		77,
		65,
		71,
		75,
		92,
		108,
		109,
		119,
		-1,
		-1,
		178,
		151,
		175,
		133,
		115,
		-1,
		81,
		83,
		89,
		93,
		96,
		104,
		79,
		81,
		-1,
		86,
		85,
		116,
		102,
		113,
		160,
		-1,
		-1,
		136,
		128,
		110,
		113,
		90,
		86,
		98,
		97,
		93,
		95,
		97,
		104,
		89,
		102,
		109,
		80,
		90,
		94,
		109,
		120,
		-1,
		-1,
		194,
		-1,
		-1,
		157,
		140,
		-1,
		105,
		112,
		96,
		102,
		88,
		109,
		108,
		102,
		109,
		112,
		100,
		102,
		99,
		116,
		102,
		77,
		102,
		106,
		112,
		130,
		131,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		112,
		109,
		102,
		126,
		125,
		-1,
		131,
		129,
		135,
		120,
		125,
		121,
		106,
		107,
		102,
		102,
		99,
		84,
		86,
		123,
		114,
		135,
		132,
		163,
		169,
		163,
		172,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		130,
		-1,
		133,
		146,
		143,
		131,
		134,
		121,
		129,
		128,
		112,
		113,
		100,
		97,
		96,
		92,
		101,
		111,
		110,
		128,
		141,
		156,
		160,
		166,
		-1,
		215,
		-1,
		157,
		141,
		143,
		119,
		147,
		-1,
		150,
		134,
		154,
		145,
		145,
		-1,
		137,
		134,
		144,
		127,
		112,
		112,
		100,
		95,
		95,
		99,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		175,
		165,
		-1,
		147,
		152,
		122,
		134,
		157,
		177,
		161,
		-1,
		156,
		-1,
		139,
		152,
		-1,
		133,
		129,
		118,
		108,
		97,
		104,
		102,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		160,
		164,
		172,
		123,
		142,
		166,
		203,
		170,
		163,
		162,
		-1,
		157,
		154,
		151,
		150,
		137,
		122,
		120,
		103,
		109,
		110,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		149,
		120,
		144,
		186,
		192,
		185,
		173,
		173,
		173,
		167,
		-1,
		161,
		140,
		131,
		120,
		110,
		126,
		116,
		119,
		99,
		101,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		179,
		168,
		169,
		123,
		157,
		175,
		206,
		192,
		197,
		172,
		165,
		159,
		163,
		157,
		138,
		127,
		119,
		108,
		117,
		127,
		121,
		101,
		110,
		111,
		135,
		142,
		148,
		-1,
		-1,
		186,
		176,
		160,
		162,
		159,
		148,
		155,
		187,
		197,
		210,
		-1,
		164,
		-1,
		153,
		148,
		132,
		127,
		124,
		121,
		115,
		124,
		129,
		115,
		106,
		121,
		140,
		140,
		132,
		157,
		160,
		-1,
		-1,
		-1,
		179,
		196,
		171,
		148,
		129,
		165,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		134,
		130,
		125,
		129,
		122,
		129,
		125,
		124,
		125,
		107,
		143,
		-1,
		140,
		134,
		162,
		165,
		155,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		136,
		188,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		134,
		132,
		126,
		130,
		134,
		123,
		136,
		132,
		112,
		122,
		142,
		146,
		153,
		146,
		151,
		150,
		164,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		156,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		154,
		138,
		141,
		141,
		137,
		145,
		130,
		129,
		115,
		119,
		137,
		164,
		159,
		154,
		153,
		160,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		171,
		-1,
		142,
		166,
		182,
		-1,
		182,
		161,
		176,
		154,
		150,
		146,
		161,
		162,
		140,
		145,
		144,
		154,
		151,
		140,
		127,
		131,
		146,
		156,
		148,
		149,
		158,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		145,
		144,
		169,
		-1,
		-1,
		218,
		-1,
		152,
		169,
		160,
		158,
		151,
		142,
		148,
		155,
		158,
		155,
		145,
		134,
		140,
		136,
		158,
		144,
		142,
		161,
		176,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		196,
		186,
		170,
		155,
		188,
		-1,
		159,
		143,
		148,
		-1,
		180,
		-1,
		153,
		153,
		144,
		133,
		130,
		141,
		139,
		150,
		167,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		202,
		-1,
		-1,
		183,
		177,
		177,
		161,
		164,
		175,
		155,
		149,
		148,
		175,
		170,
		161,
		142,
		135,
		132,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		203,
		183,
		189,
		147,
		168,
		-1,
		-1,
		245,
		200,
		186,
		-1,
		170,
		192,
		180,
		170,
		160,
		194,
		186,
		161,
		154,
		140,
		142,
		140,
		142,
		147,
		168,
		169,
		182,
		-1,
		-1,
		180,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		192,
		208,
		200,
		171,
		181,
		-1,
		-1,
		172,
		170,
		178,
		157,
		144,
		164,
		167,
		157,
		141,
		156,
		168,
		176,
		181,
		-1,
		183,
		170,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		203,
		198,
		202,
		175,
		-1,
		174,
		168,
		148,
		162,
		169,
		159,
		154,
		148,
		151,
		169,
		186,
		-1,
		-1,
		197,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		182,
		196,
		191,
		184,
		188,
		-1,
		176,
		164,
		150,
		167,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		220,
		-1,
		203,
		-1,
		-1,
		-1,
		200,
		215,
		230,
		207,
		180,
		175,
		168,
		162,
		158,
		174,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		203,
		220,
		226,
		208,
		212,
		257,
		-1,
		-1,
		184,
		175,
		166,
		169,
		168,
		171,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		186,
		-1,
		-1,
		-1,
		223,
		-1,
		238,
		-1,
		-1,
		227,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		182,
		174,
		162,
		166,
		189,
		178,
		217,
		-1,
		-1,
		340,
		-1,
		-1,
		-1,
		252,
		227,
		242,
		266,
		247,
		254,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		179,
		186,
		186,
		178,
		156,
		163,
		179,
		178,
		173,
		209,
		200,
		206,
		-1,
		-1,
		333,
		322,
		311,
		317,
		-1,
		258,
		244,
		252,
		242,
		245,
		-1,
		-1,
		233,
		230,
		206,
		189,
		187,
		180,
		175,
		185,
		165,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		228,
		309,
		302,
		285,
		293,
		324,
		-1,
		256,
		248,
		251,
		234,
		236,
		-1,
		-1,
		206,
		203,
		208,
		196,
		193,
		195,
		190,
		181,
		166,
		172,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		242,
		285,
		279,
		282,
		306,
		320,
		-1,
		253,
		-1,
		-1,
		259,
		237,
		221,
		211,
		205,
		255,
		210,
		205,
		189,
		187,
		178,
		169,
		176,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		277,
		265,
		273,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		275,
		-1,
		248,
		-1,
		223,
		227,
		218,
		221,
		203,
		190,
		182,
		174,
		190,
		165,
		175,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		324,
		280,
		273,
		264,
		305,
		320,
		324,
		-1,
		265,
		304,
		302,
		-1,
		284,
		-1,
		-1,
		-1,
		237,
		231,
		223,
		223,
		202,
		202,
		176,
		180,
		170,
		177,
		187,
		189,
		181,
		185,
		198,
		209,
		212,
		320,
		311,
		324,
		269,
		269,
		290,
		299,
		320,
		280,
		271,
		298,
		309,
		298,
		293,
		280,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		209,
		197,
		180,
		181,
		177,
		180,
		195,
		198,
		188,
		186,
		180,
		212,
		-1,
		313,
		312,
		301,
		298,
		274,
		265,
		260,
		287,
		-1,
		-1,
		282,
		299,
		293,
		297,
		313,
		338,
		-1,
		269,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		202,
		191,
		182,
		188,
		185,
		196,
		206,
		194,
		195,
		185,
		195,
		208,
		297,
		294,
		282,
		280,
		303,
		268,
		256,
		-1,
		269,
		267,
		273,
		280,
		297,
		327,
		-1,
		-1,
		285,
		265,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		187,
		192,
		212,
		214,
		203,
		197,
		191,
		198,
		197,
		205,
		213,
		306,
		320,
		309,
		305,
		304,
		312,
		261,
		254,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		-1,
		275,
		271,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		205,
		209,
		201,
		194,
		189,
		200,
		192,
		196,
		213,
		-1,
		340,
		-1,
		292,
		268,
		282,
		297,
		305,
		-1,
		-1,
		-1,
		292,
		278,
		271,
		259,
		257,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		245,
		213,
		218,
		213,
		195,
		206,
		195,
		198,
		212,
		207,
		-1,
		-1,
		280,
		283,
		-1,
		-1,
		282,
		284,
		-1,
		283,
		272,
		257,
		249,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		202,
		227,
		216,
		224,
		219,
		199,
		205,
		208,
		197,
		201,
		213,
		-1,
		-1,
		287,
		288,
		289,
		-1,
		267,
		-1,
		285,
		-1,
		252,
		258,
		246,
		-1,
		-1,
		-1,
		240,
		203,
		224,
		234,
		228,
		226,
		217,
		203,
		210,
		208,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		259,
		292,
		283,
		266,
		246,
		238,
		257,
		-1,
		227,
		-1,
		202,
		204,
		230,
		233,
		239,
		233,
		206,
		221,
		211,
		202,
		211,
		291,
		-1,
		261,
		294,
		258,
		252,
		228,
		232,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		255,
		240,
		221,
		208,
		215,
		215,
		208,
		-1,
		-1,
		-1,
		263,
		262,
		254,
		248,
		248,
		233,
		224,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		245,
		241,
		228,
		228,
		220,
		-1,
		364,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		257,
		252,
		225,
		213,
		219,
		215,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		221,
		256,
		-1,
		359,
		-1,
		293,
		-1,
		-1,
		275,
		255,
		247,
		236,
		225,
		223,
		214,
		205,
		227,
		243,
		227,
		225,
		228,
		229,
		-1,
		348,
		347,
		-1,
		294,
		286,
		272,
		-1,
		265,
		-1,
		271,
		232,
		-1,
		234,
		214,
		-1,
		236,
		232,
		-1,
		-1,
		335,
		310,
		-1,
		-1,
		-1,
		295,
		275,
		266,
		250,
		-1,
		225,
		225,
		-1,
		-1,
		-1,
		320,
		319,
		-1,
		288,
		291,
		-1,
		281,
		272,
		280,
		227,
		231,
		-1,
		-1,
		-1,
		329,
		310,
		304,
		303,
		301,
		296,
		293,
		279,
		263,
		241,
		230,
		251,
		-1,
		-1,
		-1,
		301,
		293,
		286,
		-1,
		-1,
		288,
		271,
		252,
		250,
		-1,
		-1,
		-1,
		323,
		304,
		-1,
		-1,
		278,
		-1,
		-1,
		284,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		312,
		-1,
		-1,
		-1,
		274,
		270,
		271,
		-1,
		-1,
		-1,
		-1,
		334,
		335,
		358,
		322,
		-1,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		337,
		335,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		264,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		299,
		-1,
		299,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		312,
		-1,
		284,
		286,
		-1,
		334,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		289,
		296,
		318,
		321,
		357,
		-1,
		308
	],
	[
		-1,
		85,
		82,
		93,
		79,
		74,
		78,
		-1,
		122,
		82,
		69,
		64,
		89,
		88,
		100,
		111,
		-1,
		-1,
		-1,
		47,
		36,
		77,
		73,
		83,
		94,
		101,
		-1,
		152,
		-1,
		29,
		58,
		70,
		79,
		75,
		78,
		98,
		125,
		147,
		149,
		0,
		105,
		82,
		83,
		106,
		117,
		151,
		143,
		-1,
		89,
		86,
		108,
		121,
		136,
		139,
		-1,
		-1,
		90,
		100,
		106,
		121,
		140,
		143,
		-1,
		153,
		172,
		-1,
		-1,
		89,
		102,
		115,
		118,
		126,
		132,
		145,
		162,
		167,
		-1,
		-1,
		107,
		111,
		121,
		119,
		115,
		132,
		151,
		162,
		176,
		175,
		-1,
		101,
		119,
		128,
		126,
		124,
		108,
		112,
		130,
		161,
		167,
		170,
		-1,
		118,
		114,
		124,
		130,
		142,
		124,
		111,
		117,
		136,
		149,
		168,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		110,
		130,
		132,
		131,
		145,
		143,
		114,
		120,
		124,
		141,
		157,
		158,
		168,
		-1,
		-1,
		212,
		185,
		209,
		167,
		149,
		-1,
		115,
		117,
		123,
		127,
		132,
		140,
		145,
		130,
		-1,
		135,
		134,
		165,
		151,
		162,
		194,
		-1,
		-1,
		170,
		162,
		144,
		147,
		124,
		120,
		132,
		131,
		127,
		129,
		131,
		143,
		138,
		151,
		158,
		129,
		139,
		143,
		158,
		169,
		-1,
		-1,
		243,
		-1,
		-1,
		191,
		174,
		-1,
		139,
		146,
		130,
		136,
		122,
		143,
		142,
		136,
		143,
		146,
		134,
		151,
		148,
		165,
		151,
		126,
		151,
		155,
		161,
		179,
		180,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		146,
		143,
		136,
		160,
		159,
		-1,
		165,
		163,
		169,
		154,
		159,
		155,
		140,
		156,
		151,
		151,
		148,
		133,
		135,
		172,
		163,
		184,
		181,
		212,
		218,
		212,
		221,
		-1,
		199,
		195,
		191,
		198,
		147,
		-1,
		-1,
		164,
		-1,
		167,
		180,
		177,
		165,
		168,
		155,
		163,
		162,
		146,
		162,
		149,
		146,
		145,
		141,
		150,
		160,
		159,
		177,
		190,
		205,
		209,
		215,
		-1,
		249,
		-1,
		191,
		175,
		177,
		153,
		181,
		-1,
		184,
		168,
		188,
		179,
		179,
		-1,
		171,
		168,
		178,
		161,
		146,
		161,
		149,
		144,
		144,
		148,
		163,
		154,
		172,
		179,
		187,
		191,
		211,
		223,
		209,
		199,
		-1,
		181,
		186,
		156,
		168,
		191,
		211,
		195,
		-1,
		190,
		-1,
		173,
		186,
		-1,
		167,
		163,
		152,
		157,
		146,
		153,
		151,
		145,
		142,
		160,
		163,
		180,
		184,
		200,
		-1,
		-1,
		194,
		198,
		206,
		157,
		176,
		200,
		237,
		204,
		197,
		196,
		-1,
		191,
		188,
		185,
		186,
		172,
		165,
		166,
		152,
		158,
		159,
		144,
		147,
		169,
		197,
		175,
		187,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		183,
		154,
		178,
		220,
		226,
		219,
		207,
		222,
		222,
		215,
		-1,
		203,
		182,
		179,
		169,
		159,
		175,
		165,
		168,
		148,
		150,
		166,
		178,
		169,
		189,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		157,
		191,
		209,
		255,
		241,
		246,
		221,
		214,
		208,
		197,
		199,
		187,
		176,
		168,
		157,
		166,
		176,
		170,
		150,
		159,
		160,
		184,
		191,
		197,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		182,
		189,
		221,
		246,
		259,
		-1,
		213,
		-1,
		202,
		197,
		181,
		176,
		173,
		170,
		164,
		173,
		178,
		164,
		155,
		170,
		189,
		189,
		181,
		206,
		209,
		-1,
		-1,
		-1,
		213,
		230,
		205,
		182,
		163,
		199,
		-1,
		229,
		230,
		-1,
		207,
		201,
		198,
		183,
		179,
		174,
		178,
		171,
		178,
		174,
		173,
		174,
		156,
		192,
		-1,
		189,
		183,
		211,
		214,
		204,
		-1,
		-1,
		-1,
		228,
		207,
		200,
		220,
		170,
		222,
		-1,
		-1,
		214,
		207,
		-1,
		194,
		176,
		183,
		181,
		175,
		179,
		183,
		172,
		185,
		181,
		161,
		171,
		191,
		195,
		202,
		195,
		200,
		199,
		213,
		-1,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		190,
		-1,
		223,
		215,
		205,
		199,
		193,
		189,
		187,
		203,
		187,
		190,
		190,
		186,
		194,
		179,
		178,
		164,
		168,
		186,
		213,
		208,
		203,
		202,
		209,
		-1,
		276,
		262,
		233,
		-1,
		-1,
		205,
		-1,
		176,
		200,
		216,
		-1,
		231,
		210,
		225,
		203,
		199,
		195,
		210,
		211,
		189,
		194,
		193,
		203,
		200,
		189,
		176,
		180,
		195,
		205,
		197,
		198,
		207,
		-1,
		282,
		269,
		227,
		223,
		212,
		232,
		179,
		192,
		203,
		-1,
		-1,
		267,
		-1,
		201,
		218,
		209,
		207,
		200,
		191,
		197,
		204,
		207,
		204,
		194,
		183,
		189,
		185,
		207,
		193,
		191,
		210,
		225,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		198,
		185,
		179,
		-1,
		220,
		-1,
		245,
		235,
		219,
		204,
		237,
		-1,
		208,
		192,
		197,
		-1,
		229,
		-1,
		202,
		202,
		193,
		182,
		179,
		190,
		188,
		199,
		216,
		-1,
		232,
		217,
		210,
		200,
		214,
		185,
		-1,
		236,
		-1,
		-1,
		232,
		226,
		226,
		210,
		213,
		224,
		204,
		198,
		197,
		224,
		219,
		210,
		191,
		184,
		181,
		182,
		195,
		215,
		206,
		218,
		-1,
		-1,
		-1,
		237,
		217,
		223,
		181,
		202,
		-1,
		-1,
		294,
		249,
		235,
		-1,
		219,
		241,
		229,
		219,
		209,
		243,
		235,
		210,
		203,
		189,
		191,
		189,
		191,
		196,
		217,
		218,
		231,
		-1,
		-1,
		214,
		221,
		209,
		195,
		214,
		-1,
		-1,
		-1,
		241,
		257,
		249,
		220,
		230,
		-1,
		-1,
		221,
		219,
		227,
		206,
		193,
		213,
		216,
		206,
		190,
		205,
		217,
		225,
		230,
		-1,
		217,
		204,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		-1,
		-1,
		274,
		240,
		252,
		247,
		251,
		224,
		-1,
		223,
		217,
		197,
		211,
		218,
		208,
		203,
		197,
		200,
		218,
		235,
		-1,
		-1,
		231,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		231,
		245,
		240,
		233,
		237,
		-1,
		225,
		213,
		199,
		216,
		221,
		218,
		209,
		201,
		206,
		203,
		216,
		230,
		234,
		254,
		-1,
		237,
		-1,
		-1,
		-1,
		249,
		264,
		279,
		256,
		229,
		224,
		217,
		211,
		207,
		223,
		229,
		240,
		208,
		204,
		205,
		209,
		208,
		225,
		235,
		-1,
		-1,
		237,
		254,
		275,
		257,
		261,
		306,
		-1,
		-1,
		233,
		224,
		215,
		218,
		217,
		220,
		214,
		211,
		216,
		221,
		209,
		218,
		236,
		235,
		-1,
		-1,
		-1,
		257,
		-1,
		272,
		-1,
		-1,
		276,
		304,
		251,
		233,
		229,
		227,
		220,
		229,
		224,
		219,
		229,
		231,
		223,
		211,
		215,
		238,
		227,
		266,
		-1,
		-1,
		374,
		-1,
		-1,
		-1,
		286,
		261,
		276,
		315,
		296,
		303,
		266,
		263,
		-1,
		233,
		258,
		230,
		237,
		228,
		235,
		235,
		227,
		205,
		212,
		228,
		227,
		222,
		258,
		249,
		255,
		-1,
		-1,
		367,
		356,
		345,
		351,
		-1,
		292,
		278,
		301,
		291,
		294,
		-1,
		-1,
		282,
		279,
		255,
		238,
		236,
		229,
		224,
		234,
		214,
		201,
		205,
		209,
		215,
		220,
		225,
		231,
		246,
		261,
		-1,
		262,
		343,
		336,
		319,
		327,
		358,
		-1,
		295,
		297,
		285,
		283,
		285,
		-1,
		-1,
		255,
		252,
		257,
		245,
		242,
		244,
		239,
		230,
		215,
		221,
		208,
		207,
		225,
		229,
		238,
		245,
		235,
		248,
		252,
		-1,
		276,
		319,
		313,
		316,
		340,
		354,
		-1,
		302,
		-1,
		-1,
		293,
		286,
		270,
		260,
		254,
		304,
		259,
		254,
		238,
		236,
		227,
		218,
		225,
		216,
		216,
		219,
		234,
		239,
		231,
		245,
		245,
		246,
		-1,
		311,
		299,
		307,
		-1,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		309,
		-1,
		297,
		-1,
		272,
		276,
		267,
		270,
		252,
		239,
		231,
		223,
		239,
		214,
		224,
		220,
		221,
		230,
		241,
		253,
		252,
		253,
		373,
		329,
		307,
		298,
		345,
		360,
		364,
		-1,
		314,
		353,
		347,
		-1,
		318,
		-1,
		-1,
		-1,
		286,
		280,
		272,
		272,
		251,
		251,
		225,
		229,
		219,
		226,
		236,
		238,
		230,
		234,
		247,
		258,
		261,
		369,
		360,
		373,
		318,
		312,
		330,
		339,
		360,
		329,
		320,
		347,
		354,
		343,
		338,
		325,
		-1,
		-1,
		309,
		290,
		-1,
		-1,
		258,
		246,
		229,
		230,
		226,
		229,
		244,
		247,
		237,
		235,
		229,
		261,
		-1,
		362,
		361,
		350,
		347,
		323,
		314,
		309,
		331,
		-1,
		-1,
		331,
		348,
		342,
		346,
		362,
		387,
		-1,
		318,
		-1,
		-1,
		303,
		-1,
		-1,
		288,
		251,
		240,
		231,
		237,
		234,
		245,
		255,
		243,
		244,
		234,
		244,
		257,
		346,
		343,
		331,
		329,
		352,
		317,
		305,
		-1,
		318,
		316,
		322,
		329,
		346,
		376,
		-1,
		-1,
		334,
		314,
		-1,
		-1,
		286,
		284,
		273,
		-1,
		263,
		236,
		241,
		261,
		263,
		252,
		246,
		240,
		247,
		246,
		254,
		262,
		355,
		369,
		358,
		354,
		353,
		361,
		310,
		303,
		315,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		-1,
		324,
		320,
		-1,
		-1,
		281,
		274,
		262,
		250,
		240,
		250,
		254,
		258,
		250,
		243,
		238,
		249,
		241,
		245,
		262,
		-1,
		389,
		-1,
		341,
		317,
		331,
		346,
		354,
		-1,
		-1,
		-1,
		341,
		327,
		320,
		308,
		306,
		-1,
		315,
		299,
		280,
		-1,
		250,
		263,
		294,
		262,
		267,
		262,
		244,
		255,
		244,
		247,
		261,
		256,
		-1,
		-1,
		329,
		332,
		-1,
		-1,
		331,
		333,
		-1,
		332,
		321,
		306,
		298,
		-1,
		-1,
		287,
		283,
		-1,
		-1,
		251,
		276,
		265,
		273,
		268,
		248,
		254,
		257,
		246,
		250,
		262,
		-1,
		-1,
		336,
		337,
		338,
		-1,
		316,
		-1,
		334,
		-1,
		301,
		307,
		295,
		-1,
		-1,
		-1,
		289,
		252,
		273,
		283,
		277,
		275,
		266,
		252,
		259,
		257,
		253,
		264,
		-1,
		-1,
		-1,
		334,
		308,
		341,
		332,
		315,
		295,
		287,
		306,
		-1,
		276,
		-1,
		251,
		253,
		279,
		282,
		288,
		282,
		255,
		270,
		260,
		251,
		260,
		340,
		-1,
		310,
		343,
		307,
		301,
		277,
		281,
		297,
		-1,
		273,
		255,
		-1,
		283,
		273,
		304,
		289,
		270,
		257,
		264,
		264,
		257,
		-1,
		-1,
		-1,
		312,
		311,
		303,
		297,
		297,
		282,
		273,
		-1,
		285,
		267,
		246,
		263,
		263,
		254,
		262,
		294,
		290,
		277,
		277,
		269,
		-1,
		413,
		-1,
		-1,
		335,
		-1,
		-1,
		-1,
		306,
		301,
		274,
		262,
		268,
		264,
		250,
		256,
		258,
		266,
		264,
		261,
		273,
		269,
		289,
		270,
		305,
		-1,
		408,
		-1,
		342,
		-1,
		-1,
		324,
		304,
		296,
		285,
		274,
		272,
		263,
		254,
		276,
		292,
		276,
		274,
		277,
		278,
		-1,
		397,
		396,
		-1,
		343,
		335,
		321,
		-1,
		314,
		-1,
		320,
		281,
		-1,
		283,
		263,
		-1,
		285,
		281,
		-1,
		-1,
		384,
		359,
		-1,
		-1,
		-1,
		344,
		324,
		315,
		299,
		-1,
		274,
		274,
		-1,
		-1,
		-1,
		369,
		368,
		-1,
		337,
		340,
		-1,
		330,
		321,
		329,
		276,
		280,
		-1,
		-1,
		-1,
		378,
		359,
		353,
		352,
		350,
		345,
		342,
		328,
		312,
		290,
		279,
		300,
		-1,
		-1,
		-1,
		350,
		342,
		335,
		-1,
		-1,
		337,
		320,
		301,
		299,
		-1,
		-1,
		-1,
		372,
		353,
		-1,
		-1,
		327,
		-1,
		-1,
		333,
		298,
		-1,
		-1,
		-1,
		-1,
		-1,
		389,
		361,
		-1,
		-1,
		-1,
		323,
		319,
		320,
		-1,
		-1,
		-1,
		-1,
		383,
		384,
		407,
		371,
		-1,
		-1,
		-1,
		315,
		309,
		-1,
		-1,
		386,
		384,
		-1,
		-1,
		-1,
		343,
		327,
		-1,
		313,
		-1,
		-1,
		-1,
		334,
		-1,
		-1,
		346,
		-1,
		-1,
		-1,
		348,
		-1,
		348,
		323,
		330,
		-1,
		-1,
		-1,
		-1,
		361,
		353,
		361,
		-1,
		333,
		335,
		-1,
		383,
		-1,
		-1,
		376,
		367,
		-1,
		-1,
		338,
		345,
		367,
		370,
		406,
		-1,
		357
	],
	[
		-1,
		72,
		61,
		72,
		80,
		53,
		60,
		-1,
		77,
		83,
		49,
		43,
		80,
		49,
		52,
		66,
		-1,
		-1,
		-1,
		72,
		71,
		37,
		35,
		41,
		46,
		56,
		-1,
		106,
		-1,
		93,
		72,
		83,
		88,
		30,
		33,
		52,
		79,
		101,
		103,
		108,
		0,
		37,
		38,
		61,
		72,
		105,
		99,
		-1,
		44,
		41,
		63,
		77,
		92,
		96,
		-1,
		-1,
		45,
		55,
		62,
		77,
		96,
		102,
		-1,
		112,
		131,
		-1,
		-1,
		45,
		58,
		71,
		74,
		82,
		91,
		104,
		121,
		126,
		-1,
		-1,
		63,
		67,
		77,
		78,
		74,
		91,
		110,
		121,
		135,
		134,
		-1,
		65,
		83,
		92,
		85,
		83,
		67,
		71,
		89,
		120,
		126,
		129,
		-1,
		82,
		78,
		88,
		94,
		105,
		83,
		70,
		76,
		95,
		108,
		127,
		118,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		83,
		74,
		94,
		96,
		95,
		104,
		102,
		73,
		79,
		83,
		100,
		116,
		117,
		127,
		-1,
		-1,
		176,
		149,
		173,
		131,
		113,
		-1,
		79,
		81,
		87,
		91,
		96,
		104,
		104,
		89,
		-1,
		94,
		93,
		124,
		110,
		121,
		158,
		-1,
		-1,
		134,
		126,
		108,
		111,
		88,
		84,
		96,
		95,
		91,
		93,
		95,
		107,
		97,
		110,
		117,
		88,
		98,
		102,
		117,
		128,
		-1,
		-1,
		202,
		-1,
		-1,
		155,
		138,
		-1,
		103,
		110,
		94,
		100,
		86,
		107,
		106,
		100,
		107,
		110,
		98,
		110,
		107,
		124,
		110,
		85,
		110,
		114,
		120,
		138,
		139,
		-1,
		201,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		110,
		107,
		100,
		124,
		123,
		-1,
		129,
		127,
		133,
		118,
		123,
		119,
		104,
		115,
		110,
		110,
		107,
		92,
		94,
		131,
		122,
		143,
		140,
		171,
		177,
		171,
		180,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		128,
		-1,
		131,
		144,
		141,
		129,
		132,
		119,
		127,
		126,
		110,
		121,
		108,
		105,
		104,
		100,
		109,
		119,
		118,
		136,
		149,
		164,
		168,
		174,
		-1,
		213,
		-1,
		155,
		139,
		141,
		117,
		145,
		-1,
		148,
		132,
		152,
		143,
		143,
		-1,
		135,
		132,
		142,
		125,
		110,
		120,
		108,
		103,
		103,
		107,
		122,
		113,
		131,
		138,
		146,
		150,
		170,
		182,
		173,
		163,
		-1,
		145,
		150,
		120,
		132,
		155,
		175,
		159,
		-1,
		154,
		-1,
		137,
		150,
		-1,
		131,
		127,
		116,
		116,
		105,
		112,
		110,
		104,
		101,
		119,
		122,
		139,
		143,
		159,
		-1,
		-1,
		158,
		162,
		170,
		121,
		140,
		164,
		201,
		168,
		161,
		160,
		-1,
		155,
		152,
		149,
		150,
		136,
		129,
		128,
		111,
		117,
		118,
		103,
		106,
		128,
		156,
		134,
		146,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		147,
		118,
		142,
		184,
		190,
		183,
		171,
		181,
		181,
		175,
		-1,
		167,
		146,
		139,
		128,
		118,
		134,
		124,
		127,
		107,
		109,
		125,
		137,
		128,
		148,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		121,
		155,
		173,
		214,
		200,
		205,
		180,
		173,
		167,
		161,
		163,
		146,
		135,
		127,
		116,
		125,
		135,
		129,
		109,
		118,
		119,
		143,
		150,
		156,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		146,
		153,
		185,
		205,
		218,
		-1,
		172,
		-1,
		161,
		156,
		140,
		135,
		132,
		129,
		123,
		132,
		137,
		123,
		114,
		129,
		148,
		148,
		140,
		165,
		168,
		-1,
		-1,
		-1,
		177,
		194,
		169,
		146,
		127,
		163,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		142,
		138,
		133,
		137,
		130,
		137,
		133,
		132,
		133,
		115,
		151,
		-1,
		148,
		142,
		170,
		173,
		163,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		134,
		186,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		142,
		140,
		134,
		138,
		142,
		131,
		144,
		140,
		120,
		130,
		150,
		154,
		161,
		154,
		159,
		158,
		172,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		154,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		162,
		146,
		149,
		149,
		145,
		153,
		138,
		137,
		123,
		127,
		145,
		172,
		167,
		162,
		161,
		168,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		169,
		-1,
		140,
		164,
		180,
		-1,
		190,
		169,
		184,
		162,
		158,
		154,
		169,
		170,
		148,
		153,
		152,
		162,
		159,
		148,
		135,
		139,
		154,
		164,
		156,
		157,
		166,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		143,
		152,
		167,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		168,
		166,
		159,
		150,
		156,
		163,
		166,
		163,
		153,
		142,
		148,
		144,
		166,
		152,
		150,
		169,
		184,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		184,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		167,
		151,
		156,
		-1,
		188,
		-1,
		161,
		161,
		152,
		141,
		138,
		149,
		147,
		158,
		175,
		-1,
		196,
		181,
		174,
		164,
		178,
		149,
		-1,
		200,
		-1,
		-1,
		191,
		185,
		185,
		169,
		172,
		183,
		163,
		157,
		156,
		183,
		178,
		169,
		150,
		143,
		140,
		141,
		154,
		174,
		165,
		177,
		-1,
		-1,
		-1,
		201,
		181,
		187,
		145,
		166,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		178,
		200,
		188,
		178,
		168,
		202,
		194,
		169,
		162,
		148,
		150,
		148,
		150,
		155,
		176,
		177,
		190,
		-1,
		-1,
		178,
		185,
		173,
		159,
		178,
		-1,
		-1,
		-1,
		200,
		216,
		208,
		179,
		189,
		-1,
		-1,
		180,
		178,
		186,
		165,
		152,
		172,
		175,
		165,
		149,
		164,
		176,
		184,
		189,
		-1,
		181,
		168,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		-1,
		-1,
		233,
		199,
		211,
		206,
		210,
		183,
		-1,
		182,
		176,
		156,
		170,
		177,
		167,
		162,
		156,
		159,
		177,
		194,
		-1,
		-1,
		195,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		190,
		204,
		199,
		192,
		196,
		-1,
		184,
		172,
		158,
		175,
		180,
		177,
		168,
		160,
		165,
		162,
		175,
		189,
		193,
		218,
		-1,
		201,
		-1,
		-1,
		-1,
		208,
		223,
		238,
		215,
		188,
		183,
		176,
		170,
		166,
		182,
		188,
		199,
		167,
		163,
		164,
		168,
		167,
		184,
		194,
		-1,
		-1,
		201,
		218,
		234,
		216,
		220,
		265,
		-1,
		-1,
		192,
		183,
		174,
		177,
		176,
		179,
		173,
		170,
		175,
		180,
		168,
		177,
		195,
		194,
		-1,
		-1,
		-1,
		221,
		-1,
		236,
		-1,
		-1,
		235,
		263,
		210,
		192,
		188,
		186,
		179,
		188,
		183,
		178,
		188,
		190,
		182,
		170,
		174,
		197,
		186,
		225,
		-1,
		-1,
		338,
		-1,
		-1,
		-1,
		250,
		225,
		240,
		274,
		255,
		262,
		225,
		222,
		-1,
		192,
		217,
		189,
		196,
		187,
		194,
		194,
		186,
		164,
		171,
		187,
		186,
		181,
		217,
		208,
		214,
		-1,
		-1,
		331,
		320,
		309,
		315,
		-1,
		256,
		242,
		260,
		250,
		253,
		-1,
		-1,
		241,
		238,
		214,
		197,
		195,
		188,
		183,
		193,
		173,
		160,
		164,
		168,
		174,
		179,
		184,
		190,
		205,
		220,
		-1,
		226,
		307,
		300,
		283,
		291,
		322,
		-1,
		259,
		256,
		249,
		242,
		244,
		-1,
		-1,
		214,
		211,
		216,
		204,
		201,
		203,
		198,
		189,
		174,
		180,
		167,
		166,
		184,
		188,
		197,
		204,
		194,
		207,
		211,
		-1,
		240,
		283,
		277,
		280,
		304,
		318,
		-1,
		261,
		-1,
		-1,
		257,
		245,
		229,
		219,
		213,
		263,
		218,
		213,
		197,
		195,
		186,
		177,
		184,
		175,
		175,
		178,
		193,
		198,
		190,
		204,
		204,
		205,
		-1,
		275,
		263,
		271,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		273,
		-1,
		256,
		-1,
		231,
		235,
		226,
		229,
		211,
		198,
		190,
		182,
		198,
		173,
		183,
		179,
		180,
		189,
		200,
		212,
		211,
		212,
		332,
		288,
		271,
		262,
		309,
		324,
		328,
		-1,
		273,
		312,
		310,
		-1,
		282,
		-1,
		-1,
		-1,
		245,
		239,
		231,
		231,
		210,
		210,
		184,
		188,
		178,
		185,
		195,
		197,
		189,
		193,
		206,
		217,
		220,
		328,
		319,
		332,
		277,
		276,
		294,
		303,
		324,
		288,
		279,
		306,
		317,
		306,
		301,
		288,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		217,
		205,
		188,
		189,
		185,
		188,
		203,
		206,
		196,
		194,
		188,
		220,
		-1,
		321,
		320,
		309,
		306,
		282,
		273,
		268,
		295,
		-1,
		-1,
		290,
		307,
		301,
		305,
		321,
		346,
		-1,
		277,
		-1,
		-1,
		262,
		-1,
		-1,
		247,
		210,
		199,
		190,
		196,
		193,
		204,
		214,
		202,
		203,
		193,
		203,
		216,
		305,
		302,
		290,
		288,
		311,
		276,
		264,
		-1,
		277,
		275,
		281,
		288,
		305,
		335,
		-1,
		-1,
		293,
		273,
		-1,
		-1,
		245,
		243,
		232,
		-1,
		222,
		195,
		200,
		220,
		222,
		211,
		205,
		199,
		206,
		205,
		213,
		221,
		314,
		328,
		317,
		313,
		312,
		320,
		269,
		262,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		298,
		-1,
		283,
		279,
		-1,
		-1,
		240,
		233,
		221,
		209,
		199,
		209,
		213,
		217,
		209,
		202,
		197,
		208,
		200,
		204,
		221,
		-1,
		348,
		-1,
		300,
		276,
		290,
		305,
		313,
		-1,
		-1,
		-1,
		300,
		286,
		279,
		267,
		265,
		-1,
		274,
		258,
		239,
		-1,
		209,
		222,
		253,
		221,
		226,
		221,
		203,
		214,
		203,
		206,
		220,
		215,
		-1,
		-1,
		288,
		291,
		-1,
		-1,
		290,
		292,
		-1,
		291,
		280,
		265,
		257,
		-1,
		-1,
		246,
		242,
		-1,
		-1,
		210,
		235,
		224,
		232,
		227,
		207,
		213,
		216,
		205,
		209,
		221,
		-1,
		-1,
		295,
		296,
		297,
		-1,
		275,
		-1,
		293,
		-1,
		260,
		266,
		254,
		-1,
		-1,
		-1,
		248,
		211,
		232,
		242,
		236,
		234,
		225,
		211,
		218,
		216,
		212,
		223,
		-1,
		-1,
		-1,
		293,
		267,
		300,
		291,
		274,
		254,
		246,
		265,
		-1,
		235,
		-1,
		210,
		212,
		238,
		241,
		247,
		241,
		214,
		229,
		219,
		210,
		219,
		299,
		-1,
		269,
		302,
		266,
		260,
		236,
		240,
		256,
		-1,
		232,
		214,
		-1,
		242,
		232,
		263,
		248,
		229,
		216,
		223,
		223,
		216,
		-1,
		-1,
		-1,
		271,
		270,
		262,
		256,
		256,
		241,
		232,
		-1,
		244,
		226,
		205,
		222,
		222,
		213,
		221,
		253,
		249,
		236,
		236,
		228,
		-1,
		372,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		265,
		260,
		233,
		221,
		227,
		223,
		209,
		215,
		217,
		225,
		223,
		220,
		232,
		228,
		248,
		229,
		264,
		-1,
		367,
		-1,
		301,
		-1,
		-1,
		283,
		263,
		255,
		244,
		233,
		231,
		222,
		213,
		235,
		251,
		235,
		233,
		236,
		237,
		-1,
		356,
		355,
		-1,
		302,
		294,
		280,
		-1,
		273,
		-1,
		279,
		240,
		-1,
		242,
		222,
		-1,
		244,
		240,
		-1,
		-1,
		343,
		318,
		-1,
		-1,
		-1,
		303,
		283,
		274,
		258,
		-1,
		233,
		233,
		-1,
		-1,
		-1,
		328,
		327,
		-1,
		296,
		299,
		-1,
		289,
		280,
		288,
		235,
		239,
		-1,
		-1,
		-1,
		337,
		318,
		312,
		311,
		309,
		304,
		301,
		287,
		271,
		249,
		238,
		259,
		-1,
		-1,
		-1,
		309,
		301,
		294,
		-1,
		-1,
		296,
		279,
		260,
		258,
		-1,
		-1,
		-1,
		331,
		312,
		-1,
		-1,
		286,
		-1,
		-1,
		292,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		348,
		320,
		-1,
		-1,
		-1,
		282,
		278,
		279,
		-1,
		-1,
		-1,
		-1,
		342,
		343,
		366,
		330,
		-1,
		-1,
		-1,
		274,
		268,
		-1,
		-1,
		345,
		343,
		-1,
		-1,
		-1,
		302,
		286,
		-1,
		272,
		-1,
		-1,
		-1,
		293,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		307,
		-1,
		307,
		282,
		289,
		-1,
		-1,
		-1,
		-1,
		320,
		312,
		320,
		-1,
		292,
		294,
		-1,
		342,
		-1,
		-1,
		335,
		326,
		-1,
		-1,
		297,
		304,
		326,
		329,
		365,
		-1,
		316
	],
	[
		-1,
		50,
		39,
		50,
		58,
		31,
		38,
		-1,
		55,
		61,
		27,
		21,
		58,
		27,
		33,
		44,
		-1,
		-1,
		-1,
		50,
		49,
		15,
		13,
		22,
		27,
		34,
		-1,
		75,
		-1,
		71,
		50,
		61,
		66,
		8,
		5,
		21,
		48,
		70,
		72,
		86,
		38,
		0,
		10,
		33,
		44,
		74,
		71,
		-1,
		16,
		13,
		35,
		49,
		64,
		68,
		-1,
		-1,
		17,
		27,
		34,
		49,
		68,
		74,
		-1,
		84,
		103,
		-1,
		-1,
		17,
		30,
		43,
		46,
		54,
		63,
		76,
		93,
		98,
		-1,
		-1,
		35,
		39,
		49,
		50,
		46,
		63,
		82,
		93,
		107,
		106,
		-1,
		37,
		55,
		64,
		57,
		55,
		39,
		43,
		61,
		92,
		98,
		101,
		-1,
		54,
		50,
		60,
		66,
		77,
		55,
		42,
		48,
		67,
		80,
		99,
		90,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		55,
		46,
		66,
		68,
		67,
		76,
		74,
		45,
		51,
		55,
		72,
		88,
		89,
		99,
		-1,
		-1,
		148,
		121,
		145,
		103,
		85,
		-1,
		51,
		53,
		59,
		63,
		68,
		76,
		76,
		61,
		-1,
		66,
		65,
		96,
		82,
		93,
		130,
		-1,
		-1,
		106,
		98,
		80,
		83,
		60,
		56,
		68,
		67,
		63,
		65,
		67,
		79,
		69,
		82,
		89,
		60,
		70,
		74,
		89,
		100,
		-1,
		-1,
		174,
		-1,
		-1,
		127,
		110,
		-1,
		75,
		82,
		66,
		72,
		58,
		79,
		78,
		72,
		79,
		82,
		70,
		82,
		79,
		96,
		82,
		57,
		82,
		86,
		92,
		110,
		111,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		82,
		79,
		72,
		96,
		95,
		-1,
		101,
		99,
		105,
		90,
		95,
		91,
		76,
		87,
		82,
		82,
		79,
		64,
		66,
		103,
		94,
		115,
		112,
		143,
		149,
		143,
		152,
		-1,
		135,
		131,
		127,
		134,
		83,
		-1,
		-1,
		100,
		-1,
		103,
		116,
		113,
		101,
		104,
		91,
		99,
		98,
		82,
		93,
		80,
		77,
		76,
		72,
		81,
		91,
		90,
		108,
		121,
		136,
		140,
		146,
		-1,
		185,
		-1,
		127,
		111,
		113,
		89,
		117,
		-1,
		120,
		104,
		124,
		115,
		115,
		-1,
		107,
		104,
		114,
		97,
		82,
		92,
		80,
		75,
		75,
		79,
		94,
		85,
		103,
		110,
		118,
		122,
		142,
		154,
		145,
		135,
		-1,
		117,
		122,
		92,
		104,
		127,
		147,
		131,
		-1,
		126,
		-1,
		109,
		122,
		-1,
		103,
		99,
		88,
		88,
		77,
		84,
		82,
		76,
		73,
		91,
		94,
		111,
		115,
		131,
		-1,
		-1,
		130,
		134,
		142,
		93,
		112,
		136,
		173,
		140,
		133,
		132,
		-1,
		127,
		124,
		121,
		122,
		108,
		101,
		100,
		83,
		89,
		90,
		75,
		78,
		100,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		119,
		90,
		114,
		156,
		162,
		155,
		143,
		153,
		153,
		147,
		-1,
		139,
		118,
		111,
		100,
		90,
		106,
		96,
		99,
		79,
		81,
		97,
		109,
		100,
		120,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		93,
		127,
		145,
		186,
		172,
		177,
		152,
		145,
		139,
		133,
		135,
		118,
		107,
		99,
		88,
		97,
		107,
		101,
		81,
		90,
		91,
		115,
		122,
		128,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		118,
		125,
		157,
		177,
		190,
		-1,
		144,
		-1,
		133,
		128,
		112,
		107,
		104,
		101,
		95,
		104,
		109,
		95,
		86,
		101,
		120,
		120,
		112,
		137,
		140,
		-1,
		-1,
		-1,
		149,
		166,
		141,
		118,
		99,
		135,
		-1,
		160,
		161,
		-1,
		138,
		132,
		129,
		114,
		110,
		105,
		109,
		102,
		109,
		105,
		104,
		105,
		87,
		123,
		-1,
		120,
		114,
		142,
		145,
		135,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		106,
		158,
		-1,
		-1,
		145,
		138,
		-1,
		125,
		107,
		114,
		112,
		106,
		110,
		114,
		103,
		116,
		112,
		92,
		102,
		122,
		126,
		133,
		126,
		131,
		130,
		144,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		126,
		-1,
		154,
		146,
		136,
		130,
		124,
		120,
		118,
		134,
		118,
		121,
		121,
		117,
		125,
		110,
		109,
		95,
		99,
		117,
		144,
		139,
		134,
		133,
		140,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		141,
		-1,
		112,
		136,
		152,
		-1,
		162,
		141,
		156,
		134,
		130,
		126,
		141,
		142,
		120,
		125,
		124,
		134,
		131,
		120,
		107,
		111,
		126,
		136,
		128,
		129,
		138,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		115,
		124,
		139,
		-1,
		-1,
		198,
		-1,
		132,
		149,
		140,
		138,
		131,
		122,
		128,
		135,
		138,
		135,
		125,
		114,
		120,
		116,
		138,
		124,
		122,
		141,
		156,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		176,
		166,
		150,
		135,
		168,
		-1,
		139,
		123,
		128,
		-1,
		160,
		-1,
		133,
		133,
		124,
		113,
		110,
		121,
		119,
		130,
		147,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		172,
		-1,
		-1,
		163,
		157,
		157,
		141,
		144,
		155,
		135,
		129,
		128,
		155,
		150,
		141,
		122,
		115,
		112,
		113,
		126,
		146,
		137,
		149,
		-1,
		-1,
		-1,
		173,
		153,
		159,
		117,
		138,
		-1,
		-1,
		225,
		180,
		166,
		-1,
		150,
		172,
		160,
		150,
		140,
		174,
		166,
		141,
		134,
		120,
		122,
		120,
		122,
		127,
		148,
		149,
		162,
		-1,
		-1,
		150,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		172,
		188,
		180,
		151,
		161,
		-1,
		-1,
		152,
		150,
		158,
		137,
		124,
		144,
		147,
		137,
		121,
		136,
		148,
		156,
		161,
		-1,
		153,
		140,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		183,
		178,
		182,
		155,
		-1,
		154,
		148,
		128,
		142,
		149,
		139,
		134,
		128,
		131,
		149,
		166,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		162,
		176,
		171,
		164,
		168,
		-1,
		156,
		144,
		130,
		147,
		152,
		149,
		140,
		132,
		137,
		134,
		147,
		161,
		165,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		180,
		195,
		210,
		187,
		160,
		155,
		148,
		142,
		138,
		154,
		160,
		171,
		139,
		135,
		136,
		140,
		139,
		156,
		166,
		-1,
		-1,
		173,
		190,
		206,
		188,
		192,
		237,
		-1,
		-1,
		164,
		155,
		146,
		149,
		148,
		151,
		145,
		142,
		147,
		152,
		140,
		149,
		167,
		166,
		-1,
		-1,
		-1,
		193,
		-1,
		208,
		-1,
		-1,
		207,
		235,
		182,
		164,
		160,
		158,
		151,
		160,
		155,
		150,
		160,
		162,
		154,
		142,
		146,
		169,
		158,
		197,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		222,
		197,
		212,
		246,
		227,
		234,
		197,
		194,
		-1,
		164,
		189,
		161,
		168,
		159,
		166,
		166,
		158,
		136,
		143,
		159,
		158,
		153,
		189,
		180,
		186,
		-1,
		-1,
		303,
		292,
		281,
		287,
		-1,
		228,
		214,
		232,
		222,
		225,
		-1,
		-1,
		213,
		210,
		186,
		169,
		167,
		160,
		155,
		165,
		145,
		132,
		136,
		140,
		146,
		151,
		156,
		162,
		177,
		192,
		-1,
		198,
		279,
		272,
		255,
		263,
		294,
		-1,
		231,
		228,
		221,
		214,
		216,
		-1,
		-1,
		186,
		183,
		188,
		176,
		173,
		175,
		170,
		161,
		146,
		152,
		139,
		138,
		156,
		160,
		169,
		176,
		166,
		179,
		183,
		-1,
		212,
		255,
		249,
		252,
		276,
		290,
		-1,
		233,
		-1,
		-1,
		229,
		217,
		201,
		191,
		185,
		235,
		190,
		185,
		169,
		167,
		158,
		149,
		156,
		147,
		147,
		150,
		165,
		170,
		162,
		176,
		176,
		177,
		-1,
		247,
		235,
		243,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		245,
		-1,
		228,
		-1,
		203,
		207,
		198,
		201,
		183,
		170,
		162,
		154,
		170,
		145,
		155,
		151,
		152,
		161,
		172,
		184,
		183,
		184,
		304,
		260,
		243,
		234,
		281,
		296,
		300,
		-1,
		245,
		284,
		282,
		-1,
		254,
		-1,
		-1,
		-1,
		217,
		211,
		203,
		203,
		182,
		182,
		156,
		160,
		150,
		157,
		167,
		169,
		161,
		165,
		178,
		189,
		192,
		300,
		291,
		304,
		249,
		248,
		266,
		275,
		296,
		260,
		251,
		278,
		289,
		278,
		273,
		260,
		-1,
		-1,
		240,
		221,
		-1,
		-1,
		189,
		177,
		160,
		161,
		157,
		160,
		175,
		178,
		168,
		166,
		160,
		192,
		-1,
		293,
		292,
		281,
		278,
		254,
		245,
		240,
		267,
		-1,
		-1,
		262,
		279,
		273,
		277,
		293,
		318,
		-1,
		249,
		-1,
		-1,
		234,
		-1,
		-1,
		219,
		182,
		171,
		162,
		168,
		165,
		176,
		186,
		174,
		175,
		165,
		175,
		188,
		277,
		274,
		262,
		260,
		283,
		248,
		236,
		-1,
		249,
		247,
		253,
		260,
		277,
		307,
		-1,
		-1,
		265,
		245,
		-1,
		-1,
		217,
		215,
		204,
		-1,
		194,
		167,
		172,
		192,
		194,
		183,
		177,
		171,
		178,
		177,
		185,
		193,
		286,
		300,
		289,
		285,
		284,
		292,
		241,
		234,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		255,
		251,
		-1,
		-1,
		212,
		205,
		193,
		181,
		171,
		181,
		185,
		189,
		181,
		174,
		169,
		180,
		172,
		176,
		193,
		-1,
		320,
		-1,
		272,
		248,
		262,
		277,
		285,
		-1,
		-1,
		-1,
		272,
		258,
		251,
		239,
		237,
		-1,
		246,
		230,
		211,
		-1,
		181,
		194,
		225,
		193,
		198,
		193,
		175,
		186,
		175,
		178,
		192,
		187,
		-1,
		-1,
		260,
		263,
		-1,
		-1,
		262,
		264,
		-1,
		263,
		252,
		237,
		229,
		-1,
		-1,
		218,
		214,
		-1,
		-1,
		182,
		207,
		196,
		204,
		199,
		179,
		185,
		188,
		177,
		181,
		193,
		-1,
		-1,
		267,
		268,
		269,
		-1,
		247,
		-1,
		265,
		-1,
		232,
		238,
		226,
		-1,
		-1,
		-1,
		220,
		183,
		204,
		214,
		208,
		206,
		197,
		183,
		190,
		188,
		184,
		195,
		-1,
		-1,
		-1,
		265,
		239,
		272,
		263,
		246,
		226,
		218,
		237,
		-1,
		207,
		-1,
		182,
		184,
		210,
		213,
		219,
		213,
		186,
		201,
		191,
		182,
		191,
		271,
		-1,
		241,
		274,
		238,
		232,
		208,
		212,
		228,
		-1,
		204,
		186,
		-1,
		214,
		204,
		235,
		220,
		201,
		188,
		195,
		195,
		188,
		-1,
		-1,
		-1,
		243,
		242,
		234,
		228,
		228,
		213,
		204,
		-1,
		216,
		198,
		177,
		194,
		194,
		185,
		193,
		225,
		221,
		208,
		208,
		200,
		-1,
		344,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		237,
		232,
		205,
		193,
		199,
		195,
		181,
		187,
		189,
		197,
		195,
		192,
		204,
		200,
		220,
		201,
		236,
		-1,
		339,
		-1,
		273,
		-1,
		-1,
		255,
		235,
		227,
		216,
		205,
		203,
		194,
		185,
		207,
		223,
		207,
		205,
		208,
		209,
		-1,
		328,
		327,
		-1,
		274,
		266,
		252,
		-1,
		245,
		-1,
		251,
		212,
		-1,
		214,
		194,
		-1,
		216,
		212,
		-1,
		-1,
		315,
		290,
		-1,
		-1,
		-1,
		275,
		255,
		246,
		230,
		-1,
		205,
		205,
		-1,
		-1,
		-1,
		300,
		299,
		-1,
		268,
		271,
		-1,
		261,
		252,
		260,
		207,
		211,
		-1,
		-1,
		-1,
		309,
		290,
		284,
		283,
		281,
		276,
		273,
		259,
		243,
		221,
		210,
		231,
		-1,
		-1,
		-1,
		281,
		273,
		266,
		-1,
		-1,
		268,
		251,
		232,
		230,
		-1,
		-1,
		-1,
		303,
		284,
		-1,
		-1,
		258,
		-1,
		-1,
		264,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		292,
		-1,
		-1,
		-1,
		254,
		250,
		251,
		-1,
		-1,
		-1,
		-1,
		314,
		315,
		338,
		302,
		-1,
		-1,
		-1,
		246,
		240,
		-1,
		-1,
		317,
		315,
		-1,
		-1,
		-1,
		274,
		258,
		-1,
		244,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		279,
		-1,
		279,
		254,
		261,
		-1,
		-1,
		-1,
		-1,
		292,
		284,
		292,
		-1,
		264,
		266,
		-1,
		314,
		-1,
		-1,
		307,
		298,
		-1,
		-1,
		269,
		276,
		298,
		301,
		337,
		-1,
		288
	],
	[
		-1,
		50,
		39,
		50,
		58,
		31,
		38,
		-1,
		55,
		61,
		27,
		21,
		58,
		27,
		33,
		44,
		-1,
		-1,
		-1,
		50,
		49,
		15,
		13,
		22,
		27,
		34,
		-1,
		73,
		-1,
		71,
		50,
		61,
		66,
		8,
		5,
		25,
		46,
		68,
		70,
		86,
		38,
		9,
		0,
		23,
		34,
		72,
		65,
		-1,
		6,
		3,
		25,
		43,
		58,
		62,
		-1,
		-1,
		7,
		17,
		28,
		43,
		62,
		68,
		-1,
		78,
		97,
		-1,
		-1,
		11,
		24,
		37,
		40,
		48,
		57,
		70,
		87,
		92,
		-1,
		-1,
		29,
		33,
		43,
		44,
		40,
		57,
		76,
		87,
		101,
		100,
		-1,
		31,
		49,
		58,
		51,
		49,
		33,
		37,
		55,
		86,
		92,
		95,
		-1,
		48,
		44,
		54,
		60,
		71,
		49,
		36,
		42,
		61,
		74,
		93,
		84,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		49,
		40,
		60,
		62,
		61,
		70,
		68,
		39,
		45,
		49,
		66,
		82,
		83,
		93,
		-1,
		-1,
		142,
		115,
		139,
		97,
		79,
		-1,
		45,
		47,
		53,
		57,
		62,
		70,
		70,
		55,
		-1,
		60,
		59,
		90,
		76,
		87,
		124,
		-1,
		-1,
		100,
		92,
		74,
		77,
		54,
		50,
		62,
		61,
		57,
		59,
		61,
		73,
		63,
		76,
		83,
		54,
		64,
		68,
		83,
		94,
		-1,
		-1,
		168,
		-1,
		-1,
		121,
		104,
		-1,
		69,
		76,
		60,
		66,
		52,
		73,
		72,
		66,
		73,
		76,
		64,
		76,
		73,
		90,
		76,
		51,
		76,
		80,
		86,
		104,
		105,
		-1,
		167,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		76,
		73,
		66,
		90,
		89,
		-1,
		95,
		93,
		99,
		84,
		89,
		85,
		70,
		81,
		76,
		76,
		73,
		58,
		60,
		97,
		88,
		109,
		106,
		137,
		143,
		137,
		146,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		94,
		-1,
		97,
		110,
		107,
		95,
		98,
		85,
		93,
		92,
		76,
		87,
		74,
		71,
		70,
		66,
		75,
		85,
		84,
		102,
		115,
		130,
		134,
		140,
		-1,
		179,
		-1,
		121,
		105,
		107,
		83,
		111,
		-1,
		114,
		98,
		118,
		109,
		109,
		-1,
		101,
		98,
		108,
		91,
		76,
		86,
		74,
		69,
		69,
		73,
		88,
		79,
		97,
		104,
		112,
		116,
		136,
		148,
		139,
		129,
		-1,
		111,
		116,
		86,
		98,
		121,
		141,
		125,
		-1,
		120,
		-1,
		103,
		116,
		-1,
		97,
		93,
		82,
		82,
		71,
		78,
		76,
		70,
		67,
		85,
		88,
		105,
		109,
		125,
		-1,
		-1,
		124,
		128,
		136,
		87,
		106,
		130,
		167,
		134,
		127,
		126,
		-1,
		121,
		118,
		115,
		116,
		102,
		95,
		94,
		77,
		83,
		84,
		69,
		72,
		94,
		122,
		100,
		112,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		113,
		84,
		108,
		150,
		156,
		149,
		137,
		147,
		147,
		141,
		-1,
		133,
		112,
		105,
		94,
		84,
		100,
		90,
		93,
		73,
		75,
		91,
		103,
		94,
		114,
		-1,
		-1,
		-1,
		143,
		132,
		133,
		87,
		121,
		139,
		180,
		166,
		171,
		146,
		139,
		133,
		127,
		129,
		112,
		101,
		93,
		82,
		91,
		101,
		95,
		75,
		84,
		85,
		109,
		116,
		122,
		-1,
		-1,
		150,
		140,
		124,
		126,
		123,
		112,
		119,
		151,
		171,
		184,
		-1,
		138,
		-1,
		127,
		122,
		106,
		101,
		98,
		95,
		89,
		98,
		103,
		89,
		80,
		95,
		114,
		114,
		106,
		131,
		134,
		-1,
		-1,
		-1,
		143,
		160,
		135,
		112,
		93,
		129,
		-1,
		154,
		155,
		-1,
		132,
		126,
		123,
		108,
		104,
		99,
		103,
		96,
		103,
		99,
		98,
		99,
		81,
		117,
		-1,
		114,
		108,
		136,
		139,
		129,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		100,
		152,
		-1,
		-1,
		139,
		132,
		-1,
		119,
		101,
		108,
		106,
		100,
		104,
		108,
		97,
		110,
		106,
		86,
		96,
		116,
		120,
		127,
		120,
		125,
		124,
		138,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		120,
		-1,
		148,
		140,
		130,
		124,
		118,
		114,
		112,
		128,
		112,
		115,
		115,
		111,
		119,
		104,
		103,
		89,
		93,
		111,
		138,
		133,
		128,
		127,
		134,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		135,
		-1,
		106,
		130,
		146,
		-1,
		156,
		135,
		150,
		128,
		124,
		120,
		135,
		136,
		114,
		119,
		118,
		128,
		125,
		114,
		101,
		105,
		120,
		130,
		122,
		123,
		132,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		109,
		118,
		133,
		-1,
		-1,
		192,
		-1,
		126,
		143,
		134,
		132,
		125,
		116,
		122,
		129,
		132,
		129,
		119,
		108,
		114,
		110,
		132,
		118,
		116,
		135,
		150,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		170,
		160,
		144,
		129,
		162,
		-1,
		133,
		117,
		122,
		-1,
		154,
		-1,
		127,
		127,
		118,
		107,
		104,
		115,
		113,
		124,
		141,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		166,
		-1,
		-1,
		157,
		151,
		151,
		135,
		138,
		149,
		129,
		123,
		122,
		149,
		144,
		135,
		116,
		109,
		106,
		107,
		120,
		140,
		131,
		143,
		-1,
		-1,
		-1,
		167,
		147,
		153,
		111,
		132,
		-1,
		-1,
		219,
		174,
		160,
		-1,
		144,
		166,
		154,
		144,
		134,
		168,
		160,
		135,
		128,
		114,
		116,
		114,
		116,
		121,
		142,
		143,
		156,
		-1,
		-1,
		144,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		166,
		182,
		174,
		145,
		155,
		-1,
		-1,
		146,
		144,
		152,
		131,
		118,
		138,
		141,
		131,
		115,
		130,
		142,
		150,
		155,
		-1,
		147,
		134,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		199,
		165,
		177,
		172,
		176,
		149,
		-1,
		148,
		142,
		122,
		136,
		143,
		133,
		128,
		122,
		125,
		143,
		160,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		156,
		170,
		165,
		158,
		162,
		-1,
		150,
		138,
		124,
		141,
		146,
		143,
		134,
		126,
		131,
		128,
		141,
		155,
		159,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		174,
		189,
		204,
		181,
		154,
		149,
		142,
		136,
		132,
		148,
		154,
		165,
		133,
		129,
		130,
		134,
		133,
		150,
		160,
		-1,
		-1,
		167,
		184,
		200,
		182,
		186,
		231,
		-1,
		-1,
		158,
		149,
		140,
		143,
		142,
		145,
		139,
		136,
		141,
		146,
		134,
		143,
		161,
		160,
		-1,
		-1,
		-1,
		187,
		-1,
		202,
		-1,
		-1,
		201,
		229,
		176,
		158,
		154,
		152,
		145,
		154,
		149,
		144,
		154,
		156,
		148,
		136,
		140,
		163,
		152,
		191,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		216,
		191,
		206,
		240,
		221,
		228,
		191,
		188,
		-1,
		158,
		183,
		155,
		162,
		153,
		160,
		160,
		152,
		130,
		137,
		153,
		152,
		147,
		183,
		174,
		180,
		-1,
		-1,
		297,
		286,
		275,
		281,
		-1,
		222,
		208,
		226,
		216,
		219,
		-1,
		-1,
		207,
		204,
		180,
		163,
		161,
		154,
		149,
		159,
		139,
		126,
		130,
		134,
		140,
		145,
		150,
		156,
		171,
		186,
		-1,
		192,
		273,
		266,
		249,
		257,
		288,
		-1,
		225,
		222,
		215,
		208,
		210,
		-1,
		-1,
		180,
		177,
		182,
		170,
		167,
		169,
		164,
		155,
		140,
		146,
		133,
		132,
		150,
		154,
		163,
		170,
		160,
		173,
		177,
		-1,
		206,
		249,
		243,
		246,
		270,
		284,
		-1,
		227,
		-1,
		-1,
		223,
		211,
		195,
		185,
		179,
		229,
		184,
		179,
		163,
		161,
		152,
		143,
		150,
		141,
		141,
		144,
		159,
		164,
		156,
		170,
		170,
		171,
		-1,
		241,
		229,
		237,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		239,
		-1,
		222,
		-1,
		197,
		201,
		192,
		195,
		177,
		164,
		156,
		148,
		164,
		139,
		149,
		145,
		146,
		155,
		166,
		178,
		177,
		178,
		298,
		254,
		237,
		228,
		275,
		290,
		294,
		-1,
		239,
		278,
		276,
		-1,
		248,
		-1,
		-1,
		-1,
		211,
		205,
		197,
		197,
		176,
		176,
		150,
		154,
		144,
		151,
		161,
		163,
		155,
		159,
		172,
		183,
		186,
		294,
		285,
		298,
		243,
		242,
		260,
		269,
		290,
		254,
		245,
		272,
		283,
		272,
		267,
		254,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		183,
		171,
		154,
		155,
		151,
		154,
		169,
		172,
		162,
		160,
		154,
		186,
		-1,
		287,
		286,
		275,
		272,
		248,
		239,
		234,
		261,
		-1,
		-1,
		256,
		273,
		267,
		271,
		287,
		312,
		-1,
		243,
		-1,
		-1,
		228,
		-1,
		-1,
		213,
		176,
		165,
		156,
		162,
		159,
		170,
		180,
		168,
		169,
		159,
		169,
		182,
		271,
		268,
		256,
		254,
		277,
		242,
		230,
		-1,
		243,
		241,
		247,
		254,
		271,
		301,
		-1,
		-1,
		259,
		239,
		-1,
		-1,
		211,
		209,
		198,
		-1,
		188,
		161,
		166,
		186,
		188,
		177,
		171,
		165,
		172,
		171,
		179,
		187,
		280,
		294,
		283,
		279,
		278,
		286,
		235,
		228,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		-1,
		249,
		245,
		-1,
		-1,
		206,
		199,
		187,
		175,
		165,
		175,
		179,
		183,
		175,
		168,
		163,
		174,
		166,
		170,
		187,
		-1,
		314,
		-1,
		266,
		242,
		256,
		271,
		279,
		-1,
		-1,
		-1,
		266,
		252,
		245,
		233,
		231,
		-1,
		240,
		224,
		205,
		-1,
		175,
		188,
		219,
		187,
		192,
		187,
		169,
		180,
		169,
		172,
		186,
		181,
		-1,
		-1,
		254,
		257,
		-1,
		-1,
		256,
		258,
		-1,
		257,
		246,
		231,
		223,
		-1,
		-1,
		212,
		208,
		-1,
		-1,
		176,
		201,
		190,
		198,
		193,
		173,
		179,
		182,
		171,
		175,
		187,
		-1,
		-1,
		261,
		262,
		263,
		-1,
		241,
		-1,
		259,
		-1,
		226,
		232,
		220,
		-1,
		-1,
		-1,
		214,
		177,
		198,
		208,
		202,
		200,
		191,
		177,
		184,
		182,
		178,
		189,
		-1,
		-1,
		-1,
		259,
		233,
		266,
		257,
		240,
		220,
		212,
		231,
		-1,
		201,
		-1,
		176,
		178,
		204,
		207,
		213,
		207,
		180,
		195,
		185,
		176,
		185,
		265,
		-1,
		235,
		268,
		232,
		226,
		202,
		206,
		222,
		-1,
		198,
		180,
		-1,
		208,
		198,
		229,
		214,
		195,
		182,
		189,
		189,
		182,
		-1,
		-1,
		-1,
		237,
		236,
		228,
		222,
		222,
		207,
		198,
		-1,
		210,
		192,
		171,
		188,
		188,
		179,
		187,
		219,
		215,
		202,
		202,
		194,
		-1,
		338,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		231,
		226,
		199,
		187,
		193,
		189,
		175,
		181,
		183,
		191,
		189,
		186,
		198,
		194,
		214,
		195,
		230,
		-1,
		333,
		-1,
		267,
		-1,
		-1,
		249,
		229,
		221,
		210,
		199,
		197,
		188,
		179,
		201,
		217,
		201,
		199,
		202,
		203,
		-1,
		322,
		321,
		-1,
		268,
		260,
		246,
		-1,
		239,
		-1,
		245,
		206,
		-1,
		208,
		188,
		-1,
		210,
		206,
		-1,
		-1,
		309,
		284,
		-1,
		-1,
		-1,
		269,
		249,
		240,
		224,
		-1,
		199,
		199,
		-1,
		-1,
		-1,
		294,
		293,
		-1,
		262,
		265,
		-1,
		255,
		246,
		254,
		201,
		205,
		-1,
		-1,
		-1,
		303,
		284,
		278,
		277,
		275,
		270,
		267,
		253,
		237,
		215,
		204,
		225,
		-1,
		-1,
		-1,
		275,
		267,
		260,
		-1,
		-1,
		262,
		245,
		226,
		224,
		-1,
		-1,
		-1,
		297,
		278,
		-1,
		-1,
		252,
		-1,
		-1,
		258,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		286,
		-1,
		-1,
		-1,
		248,
		244,
		245,
		-1,
		-1,
		-1,
		-1,
		308,
		309,
		332,
		296,
		-1,
		-1,
		-1,
		240,
		234,
		-1,
		-1,
		311,
		309,
		-1,
		-1,
		-1,
		268,
		252,
		-1,
		238,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		273,
		-1,
		273,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		286,
		278,
		286,
		-1,
		258,
		260,
		-1,
		308,
		-1,
		-1,
		301,
		292,
		-1,
		-1,
		263,
		270,
		292,
		295,
		331,
		-1,
		282
	],
	[
		-1,
		75,
		64,
		75,
		83,
		56,
		63,
		-1,
		80,
		86,
		52,
		46,
		83,
		52,
		58,
		69,
		-1,
		-1,
		-1,
		75,
		74,
		40,
		38,
		47,
		52,
		59,
		-1,
		50,
		-1,
		96,
		75,
		86,
		91,
		33,
		30,
		12,
		23,
		45,
		47,
		111,
		63,
		33,
		25,
		0,
		21,
		49,
		57,
		-1,
		29,
		26,
		12,
		31,
		52,
		71,
		-1,
		-1,
		30,
		33,
		28,
		37,
		64,
		83,
		-1,
		101,
		120,
		-1,
		-1,
		34,
		47,
		56,
		53,
		57,
		80,
		93,
		110,
		115,
		-1,
		-1,
		52,
		56,
		61,
		58,
		62,
		80,
		99,
		110,
		124,
		123,
		-1,
		54,
		72,
		81,
		73,
		72,
		56,
		60,
		78,
		109,
		115,
		118,
		-1,
		71,
		67,
		77,
		83,
		89,
		72,
		59,
		65,
		84,
		97,
		116,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		72,
		63,
		83,
		85,
		84,
		93,
		91,
		62,
		68,
		72,
		89,
		105,
		106,
		116,
		-1,
		-1,
		165,
		138,
		162,
		120,
		102,
		-1,
		68,
		70,
		76,
		80,
		85,
		93,
		93,
		78,
		-1,
		83,
		82,
		113,
		99,
		110,
		147,
		-1,
		-1,
		123,
		115,
		97,
		100,
		77,
		73,
		85,
		84,
		80,
		82,
		84,
		96,
		86,
		99,
		106,
		77,
		87,
		91,
		106,
		117,
		-1,
		-1,
		191,
		-1,
		-1,
		144,
		127,
		-1,
		92,
		99,
		83,
		89,
		75,
		96,
		95,
		89,
		96,
		99,
		87,
		99,
		96,
		113,
		99,
		74,
		99,
		103,
		109,
		127,
		128,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		99,
		96,
		89,
		113,
		112,
		-1,
		118,
		116,
		122,
		107,
		112,
		108,
		93,
		104,
		99,
		99,
		96,
		81,
		83,
		120,
		111,
		132,
		129,
		160,
		166,
		160,
		169,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		117,
		-1,
		120,
		133,
		130,
		118,
		121,
		108,
		116,
		115,
		99,
		110,
		97,
		94,
		93,
		89,
		98,
		108,
		107,
		125,
		138,
		153,
		157,
		163,
		-1,
		202,
		-1,
		144,
		128,
		130,
		106,
		134,
		-1,
		137,
		121,
		141,
		132,
		132,
		-1,
		124,
		121,
		131,
		114,
		99,
		109,
		97,
		92,
		92,
		96,
		111,
		102,
		120,
		127,
		135,
		139,
		159,
		171,
		162,
		152,
		-1,
		134,
		139,
		109,
		121,
		144,
		164,
		148,
		-1,
		143,
		-1,
		126,
		139,
		-1,
		120,
		116,
		105,
		105,
		94,
		101,
		99,
		93,
		90,
		108,
		111,
		128,
		132,
		148,
		-1,
		-1,
		147,
		151,
		159,
		110,
		129,
		153,
		190,
		157,
		150,
		149,
		-1,
		144,
		141,
		138,
		139,
		125,
		118,
		117,
		100,
		106,
		107,
		92,
		95,
		117,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		136,
		107,
		131,
		173,
		179,
		172,
		160,
		170,
		170,
		164,
		-1,
		156,
		135,
		128,
		117,
		107,
		123,
		113,
		116,
		96,
		98,
		114,
		126,
		117,
		137,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		110,
		144,
		162,
		203,
		189,
		194,
		169,
		162,
		156,
		150,
		152,
		135,
		124,
		116,
		105,
		114,
		124,
		118,
		98,
		107,
		108,
		132,
		139,
		145,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		135,
		142,
		174,
		194,
		207,
		-1,
		161,
		-1,
		150,
		145,
		129,
		124,
		121,
		118,
		112,
		121,
		126,
		112,
		103,
		118,
		137,
		137,
		129,
		154,
		157,
		-1,
		-1,
		-1,
		166,
		183,
		158,
		135,
		116,
		152,
		-1,
		177,
		178,
		-1,
		155,
		149,
		146,
		131,
		127,
		122,
		126,
		119,
		126,
		122,
		121,
		122,
		104,
		140,
		-1,
		137,
		131,
		159,
		162,
		152,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		123,
		175,
		-1,
		-1,
		162,
		155,
		-1,
		142,
		124,
		131,
		129,
		123,
		127,
		131,
		120,
		133,
		129,
		109,
		119,
		139,
		143,
		150,
		143,
		148,
		147,
		161,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		143,
		-1,
		171,
		163,
		153,
		147,
		141,
		137,
		135,
		151,
		135,
		138,
		138,
		134,
		142,
		127,
		126,
		112,
		116,
		134,
		161,
		156,
		151,
		150,
		157,
		-1,
		229,
		215,
		186,
		-1,
		-1,
		158,
		-1,
		129,
		153,
		169,
		-1,
		179,
		158,
		173,
		151,
		147,
		143,
		158,
		159,
		137,
		142,
		141,
		151,
		148,
		137,
		124,
		128,
		143,
		153,
		145,
		146,
		155,
		-1,
		235,
		222,
		180,
		176,
		165,
		185,
		132,
		141,
		156,
		-1,
		-1,
		215,
		-1,
		149,
		166,
		157,
		155,
		148,
		139,
		145,
		152,
		155,
		152,
		142,
		131,
		137,
		133,
		155,
		141,
		139,
		158,
		173,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		151,
		138,
		132,
		-1,
		173,
		-1,
		193,
		183,
		167,
		152,
		185,
		-1,
		156,
		140,
		145,
		-1,
		177,
		-1,
		150,
		150,
		141,
		130,
		127,
		138,
		136,
		147,
		164,
		-1,
		185,
		170,
		163,
		153,
		167,
		138,
		-1,
		189,
		-1,
		-1,
		180,
		174,
		174,
		158,
		161,
		172,
		152,
		146,
		145,
		172,
		167,
		158,
		139,
		132,
		129,
		130,
		143,
		163,
		154,
		166,
		-1,
		-1,
		-1,
		190,
		170,
		176,
		134,
		155,
		-1,
		-1,
		242,
		197,
		183,
		-1,
		167,
		189,
		177,
		167,
		157,
		191,
		183,
		158,
		151,
		137,
		139,
		137,
		139,
		144,
		165,
		166,
		179,
		-1,
		-1,
		167,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		189,
		205,
		197,
		168,
		178,
		-1,
		-1,
		169,
		167,
		175,
		154,
		141,
		161,
		164,
		154,
		138,
		153,
		165,
		173,
		178,
		-1,
		170,
		157,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		222,
		188,
		200,
		195,
		199,
		172,
		-1,
		171,
		165,
		145,
		159,
		166,
		156,
		151,
		145,
		148,
		166,
		183,
		-1,
		-1,
		184,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		179,
		193,
		188,
		181,
		185,
		-1,
		173,
		161,
		147,
		164,
		169,
		166,
		157,
		149,
		154,
		151,
		164,
		178,
		182,
		207,
		-1,
		190,
		-1,
		-1,
		-1,
		197,
		212,
		227,
		204,
		177,
		172,
		165,
		159,
		155,
		171,
		177,
		188,
		156,
		152,
		153,
		157,
		156,
		173,
		183,
		-1,
		-1,
		190,
		207,
		223,
		205,
		209,
		254,
		-1,
		-1,
		181,
		172,
		163,
		166,
		165,
		168,
		162,
		159,
		164,
		169,
		157,
		166,
		184,
		183,
		-1,
		-1,
		-1,
		210,
		-1,
		225,
		-1,
		-1,
		224,
		252,
		199,
		181,
		177,
		175,
		168,
		177,
		172,
		167,
		177,
		179,
		171,
		159,
		163,
		186,
		175,
		214,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		239,
		214,
		229,
		263,
		244,
		251,
		214,
		211,
		-1,
		181,
		206,
		178,
		185,
		176,
		183,
		183,
		175,
		153,
		160,
		176,
		175,
		170,
		206,
		197,
		203,
		-1,
		-1,
		320,
		309,
		298,
		304,
		-1,
		245,
		231,
		249,
		239,
		242,
		-1,
		-1,
		230,
		227,
		203,
		186,
		184,
		177,
		172,
		182,
		162,
		149,
		153,
		157,
		163,
		168,
		173,
		179,
		194,
		209,
		-1,
		215,
		296,
		289,
		272,
		280,
		311,
		-1,
		248,
		245,
		238,
		231,
		233,
		-1,
		-1,
		203,
		200,
		205,
		193,
		190,
		192,
		187,
		178,
		163,
		169,
		156,
		155,
		173,
		177,
		186,
		193,
		183,
		196,
		200,
		-1,
		229,
		272,
		266,
		269,
		293,
		307,
		-1,
		250,
		-1,
		-1,
		246,
		234,
		218,
		208,
		202,
		252,
		207,
		202,
		186,
		184,
		175,
		166,
		173,
		164,
		164,
		167,
		182,
		187,
		179,
		193,
		193,
		194,
		-1,
		264,
		252,
		260,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		262,
		-1,
		245,
		-1,
		220,
		224,
		215,
		218,
		200,
		187,
		179,
		171,
		187,
		162,
		172,
		168,
		169,
		178,
		189,
		201,
		200,
		201,
		321,
		277,
		260,
		251,
		298,
		313,
		317,
		-1,
		262,
		301,
		299,
		-1,
		271,
		-1,
		-1,
		-1,
		234,
		228,
		220,
		220,
		199,
		199,
		173,
		177,
		167,
		174,
		184,
		186,
		178,
		182,
		195,
		206,
		209,
		317,
		308,
		321,
		266,
		265,
		283,
		292,
		313,
		277,
		268,
		295,
		306,
		295,
		290,
		277,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		206,
		194,
		177,
		178,
		174,
		177,
		192,
		195,
		185,
		183,
		177,
		209,
		-1,
		310,
		309,
		298,
		295,
		271,
		262,
		257,
		284,
		-1,
		-1,
		279,
		296,
		290,
		294,
		310,
		335,
		-1,
		266,
		-1,
		-1,
		251,
		-1,
		-1,
		236,
		199,
		188,
		179,
		185,
		182,
		193,
		203,
		191,
		192,
		182,
		192,
		205,
		294,
		291,
		279,
		277,
		300,
		265,
		253,
		-1,
		266,
		264,
		270,
		277,
		294,
		324,
		-1,
		-1,
		282,
		262,
		-1,
		-1,
		234,
		232,
		221,
		-1,
		211,
		184,
		189,
		209,
		211,
		200,
		194,
		188,
		195,
		194,
		202,
		210,
		303,
		317,
		306,
		302,
		301,
		309,
		258,
		251,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		-1,
		272,
		268,
		-1,
		-1,
		229,
		222,
		210,
		198,
		188,
		198,
		202,
		206,
		198,
		191,
		186,
		197,
		189,
		193,
		210,
		-1,
		337,
		-1,
		289,
		265,
		279,
		294,
		302,
		-1,
		-1,
		-1,
		289,
		275,
		268,
		256,
		254,
		-1,
		263,
		247,
		228,
		-1,
		198,
		211,
		242,
		210,
		215,
		210,
		192,
		203,
		192,
		195,
		209,
		204,
		-1,
		-1,
		277,
		280,
		-1,
		-1,
		279,
		281,
		-1,
		280,
		269,
		254,
		246,
		-1,
		-1,
		235,
		231,
		-1,
		-1,
		199,
		224,
		213,
		221,
		216,
		196,
		202,
		205,
		194,
		198,
		210,
		-1,
		-1,
		284,
		285,
		286,
		-1,
		264,
		-1,
		282,
		-1,
		249,
		255,
		243,
		-1,
		-1,
		-1,
		237,
		200,
		221,
		231,
		225,
		223,
		214,
		200,
		207,
		205,
		201,
		212,
		-1,
		-1,
		-1,
		282,
		256,
		289,
		280,
		263,
		243,
		235,
		254,
		-1,
		224,
		-1,
		199,
		201,
		227,
		230,
		236,
		230,
		203,
		218,
		208,
		199,
		208,
		288,
		-1,
		258,
		291,
		255,
		249,
		225,
		229,
		245,
		-1,
		221,
		203,
		-1,
		231,
		221,
		252,
		237,
		218,
		205,
		212,
		212,
		205,
		-1,
		-1,
		-1,
		260,
		259,
		251,
		245,
		245,
		230,
		221,
		-1,
		233,
		215,
		194,
		211,
		211,
		202,
		210,
		242,
		238,
		225,
		225,
		217,
		-1,
		361,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		254,
		249,
		222,
		210,
		216,
		212,
		198,
		204,
		206,
		214,
		212,
		209,
		221,
		217,
		237,
		218,
		253,
		-1,
		356,
		-1,
		290,
		-1,
		-1,
		272,
		252,
		244,
		233,
		222,
		220,
		211,
		202,
		224,
		240,
		224,
		222,
		225,
		226,
		-1,
		345,
		344,
		-1,
		291,
		283,
		269,
		-1,
		262,
		-1,
		268,
		229,
		-1,
		231,
		211,
		-1,
		233,
		229,
		-1,
		-1,
		332,
		307,
		-1,
		-1,
		-1,
		292,
		272,
		263,
		247,
		-1,
		222,
		222,
		-1,
		-1,
		-1,
		317,
		316,
		-1,
		285,
		288,
		-1,
		278,
		269,
		277,
		224,
		228,
		-1,
		-1,
		-1,
		326,
		307,
		301,
		300,
		298,
		293,
		290,
		276,
		260,
		238,
		227,
		248,
		-1,
		-1,
		-1,
		298,
		290,
		283,
		-1,
		-1,
		285,
		268,
		249,
		247,
		-1,
		-1,
		-1,
		320,
		301,
		-1,
		-1,
		275,
		-1,
		-1,
		281,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		337,
		309,
		-1,
		-1,
		-1,
		271,
		267,
		268,
		-1,
		-1,
		-1,
		-1,
		331,
		332,
		355,
		319,
		-1,
		-1,
		-1,
		263,
		257,
		-1,
		-1,
		334,
		332,
		-1,
		-1,
		-1,
		291,
		275,
		-1,
		261,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		296,
		-1,
		296,
		271,
		278,
		-1,
		-1,
		-1,
		-1,
		309,
		301,
		309,
		-1,
		281,
		283,
		-1,
		331,
		-1,
		-1,
		324,
		315,
		-1,
		-1,
		286,
		293,
		315,
		318,
		354,
		-1,
		305
	],
	[
		-1,
		86,
		75,
		86,
		94,
		67,
		74,
		-1,
		91,
		97,
		63,
		57,
		94,
		63,
		69,
		80,
		-1,
		-1,
		-1,
		86,
		85,
		51,
		49,
		58,
		63,
		70,
		-1,
		60,
		-1,
		107,
		86,
		97,
		102,
		44,
		41,
		33,
		44,
		52,
		48,
		122,
		74,
		45,
		36,
		21,
		0,
		46,
		38,
		-1,
		40,
		35,
		11,
		10,
		31,
		50,
		-1,
		-1,
		31,
		32,
		18,
		16,
		43,
		62,
		-1,
		94,
		108,
		-1,
		-1,
		35,
		44,
		35,
		32,
		36,
		59,
		86,
		103,
		108,
		-1,
		-1,
		43,
		37,
		40,
		37,
		41,
		73,
		92,
		103,
		117,
		116,
		-1,
		55,
		72,
		69,
		52,
		63,
		49,
		53,
		71,
		102,
		108,
		111,
		-1,
		72,
		68,
		75,
		73,
		68,
		65,
		52,
		58,
		77,
		90,
		109,
		100,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		73,
		64,
		81,
		83,
		85,
		84,
		84,
		55,
		61,
		65,
		82,
		98,
		99,
		109,
		-1,
		-1,
		166,
		139,
		163,
		121,
		103,
		-1,
		69,
		71,
		77,
		81,
		86,
		94,
		86,
		71,
		-1,
		76,
		75,
		106,
		92,
		103,
		148,
		-1,
		-1,
		124,
		116,
		98,
		101,
		78,
		74,
		86,
		85,
		81,
		83,
		85,
		94,
		79,
		92,
		99,
		70,
		80,
		84,
		99,
		110,
		-1,
		-1,
		184,
		-1,
		-1,
		145,
		128,
		-1,
		93,
		100,
		84,
		90,
		76,
		97,
		96,
		90,
		97,
		100,
		88,
		92,
		89,
		106,
		92,
		67,
		92,
		96,
		102,
		120,
		121,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		100,
		97,
		90,
		114,
		113,
		-1,
		119,
		117,
		123,
		108,
		113,
		109,
		94,
		97,
		92,
		92,
		89,
		74,
		76,
		113,
		104,
		125,
		122,
		153,
		159,
		153,
		162,
		-1,
		153,
		149,
		145,
		152,
		101,
		-1,
		-1,
		118,
		-1,
		121,
		134,
		131,
		119,
		122,
		109,
		117,
		116,
		100,
		103,
		90,
		87,
		86,
		82,
		91,
		101,
		100,
		118,
		131,
		146,
		150,
		156,
		-1,
		203,
		-1,
		145,
		129,
		131,
		107,
		135,
		-1,
		138,
		122,
		142,
		133,
		133,
		-1,
		125,
		122,
		132,
		115,
		100,
		102,
		90,
		85,
		85,
		89,
		104,
		95,
		113,
		120,
		128,
		132,
		152,
		164,
		163,
		153,
		-1,
		135,
		140,
		110,
		122,
		145,
		165,
		149,
		-1,
		144,
		-1,
		127,
		140,
		-1,
		121,
		117,
		106,
		98,
		87,
		94,
		92,
		86,
		83,
		101,
		104,
		121,
		125,
		141,
		-1,
		-1,
		148,
		152,
		160,
		111,
		130,
		154,
		191,
		158,
		151,
		150,
		-1,
		145,
		142,
		139,
		140,
		126,
		112,
		110,
		93,
		99,
		100,
		85,
		88,
		110,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		137,
		108,
		132,
		174,
		180,
		173,
		161,
		163,
		163,
		157,
		-1,
		151,
		130,
		121,
		110,
		100,
		116,
		106,
		109,
		89,
		91,
		107,
		119,
		110,
		130,
		-1,
		-1,
		-1,
		167,
		156,
		157,
		111,
		145,
		163,
		196,
		182,
		187,
		162,
		155,
		149,
		151,
		147,
		128,
		117,
		109,
		98,
		107,
		117,
		111,
		91,
		100,
		101,
		125,
		132,
		138,
		-1,
		-1,
		174,
		164,
		148,
		150,
		147,
		136,
		143,
		175,
		187,
		200,
		-1,
		154,
		-1,
		143,
		138,
		122,
		117,
		114,
		111,
		105,
		114,
		119,
		105,
		96,
		111,
		130,
		130,
		122,
		147,
		150,
		-1,
		-1,
		-1,
		167,
		184,
		159,
		136,
		117,
		153,
		-1,
		170,
		171,
		-1,
		148,
		142,
		139,
		124,
		120,
		115,
		119,
		112,
		119,
		115,
		114,
		115,
		97,
		133,
		-1,
		130,
		124,
		152,
		155,
		145,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		124,
		176,
		-1,
		-1,
		155,
		148,
		-1,
		135,
		117,
		124,
		122,
		116,
		120,
		124,
		113,
		126,
		122,
		102,
		112,
		132,
		136,
		143,
		136,
		141,
		140,
		154,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		144,
		-1,
		164,
		156,
		146,
		140,
		134,
		130,
		128,
		144,
		128,
		131,
		131,
		127,
		135,
		120,
		119,
		105,
		109,
		127,
		154,
		149,
		144,
		143,
		150,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		159,
		-1,
		130,
		154,
		170,
		-1,
		172,
		151,
		166,
		144,
		140,
		136,
		151,
		152,
		130,
		135,
		134,
		144,
		141,
		130,
		117,
		121,
		136,
		146,
		138,
		139,
		148,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		133,
		134,
		157,
		-1,
		-1,
		208,
		-1,
		142,
		159,
		150,
		148,
		141,
		132,
		138,
		145,
		148,
		145,
		135,
		124,
		130,
		126,
		148,
		134,
		132,
		151,
		166,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		186,
		176,
		160,
		145,
		178,
		-1,
		149,
		133,
		138,
		-1,
		170,
		-1,
		143,
		143,
		134,
		123,
		120,
		131,
		129,
		140,
		157,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		190,
		-1,
		-1,
		173,
		167,
		167,
		151,
		154,
		165,
		145,
		139,
		138,
		165,
		160,
		151,
		132,
		125,
		122,
		123,
		136,
		156,
		147,
		159,
		-1,
		-1,
		-1,
		191,
		171,
		177,
		135,
		156,
		-1,
		-1,
		235,
		190,
		176,
		-1,
		160,
		182,
		170,
		160,
		150,
		184,
		176,
		151,
		144,
		130,
		132,
		130,
		132,
		137,
		158,
		159,
		172,
		-1,
		-1,
		168,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		182,
		198,
		190,
		161,
		171,
		-1,
		-1,
		162,
		160,
		168,
		147,
		134,
		154,
		157,
		147,
		131,
		146,
		158,
		166,
		171,
		-1,
		171,
		158,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		215,
		181,
		193,
		188,
		192,
		165,
		-1,
		164,
		158,
		138,
		152,
		159,
		149,
		144,
		138,
		141,
		159,
		176,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		172,
		186,
		181,
		174,
		178,
		-1,
		166,
		154,
		140,
		157,
		162,
		159,
		150,
		142,
		147,
		144,
		157,
		171,
		175,
		208,
		-1,
		191,
		-1,
		-1,
		-1,
		190,
		205,
		220,
		197,
		170,
		165,
		158,
		152,
		148,
		164,
		170,
		181,
		149,
		145,
		146,
		150,
		149,
		166,
		176,
		-1,
		-1,
		191,
		208,
		216,
		198,
		202,
		247,
		-1,
		-1,
		174,
		165,
		156,
		159,
		158,
		161,
		155,
		152,
		157,
		162,
		150,
		159,
		177,
		176,
		-1,
		-1,
		-1,
		211,
		-1,
		226,
		-1,
		-1,
		217,
		245,
		192,
		174,
		170,
		168,
		161,
		170,
		165,
		160,
		170,
		172,
		164,
		152,
		156,
		179,
		168,
		207,
		-1,
		-1,
		328,
		-1,
		-1,
		-1,
		240,
		215,
		230,
		256,
		237,
		244,
		207,
		204,
		-1,
		174,
		199,
		171,
		178,
		169,
		176,
		176,
		168,
		146,
		153,
		169,
		168,
		163,
		199,
		190,
		196,
		-1,
		-1,
		321,
		310,
		299,
		305,
		-1,
		246,
		232,
		242,
		232,
		235,
		-1,
		-1,
		223,
		220,
		196,
		179,
		177,
		170,
		165,
		175,
		155,
		142,
		146,
		150,
		156,
		161,
		166,
		172,
		187,
		202,
		-1,
		216,
		297,
		290,
		273,
		281,
		312,
		-1,
		246,
		238,
		239,
		224,
		226,
		-1,
		-1,
		196,
		193,
		198,
		186,
		183,
		185,
		180,
		171,
		156,
		162,
		149,
		148,
		166,
		170,
		179,
		186,
		176,
		189,
		193,
		-1,
		230,
		273,
		267,
		270,
		294,
		308,
		-1,
		243,
		-1,
		-1,
		247,
		227,
		211,
		201,
		195,
		245,
		200,
		195,
		179,
		177,
		168,
		159,
		166,
		157,
		157,
		160,
		175,
		180,
		172,
		186,
		186,
		187,
		-1,
		265,
		253,
		261,
		-1,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		263,
		-1,
		238,
		-1,
		213,
		217,
		208,
		211,
		193,
		180,
		172,
		164,
		180,
		155,
		165,
		161,
		162,
		171,
		182,
		194,
		193,
		194,
		314,
		270,
		261,
		252,
		295,
		310,
		314,
		-1,
		255,
		294,
		292,
		-1,
		272,
		-1,
		-1,
		-1,
		227,
		221,
		213,
		213,
		192,
		192,
		166,
		170,
		160,
		167,
		177,
		179,
		171,
		175,
		188,
		199,
		202,
		310,
		301,
		314,
		259,
		259,
		280,
		289,
		310,
		270,
		261,
		288,
		299,
		288,
		283,
		270,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		199,
		187,
		170,
		171,
		167,
		170,
		185,
		188,
		178,
		176,
		170,
		202,
		-1,
		303,
		302,
		291,
		288,
		264,
		255,
		250,
		277,
		-1,
		-1,
		272,
		289,
		283,
		287,
		303,
		328,
		-1,
		259,
		-1,
		-1,
		244,
		-1,
		-1,
		229,
		192,
		181,
		172,
		178,
		175,
		186,
		196,
		184,
		185,
		175,
		185,
		198,
		287,
		284,
		272,
		270,
		293,
		258,
		246,
		-1,
		259,
		257,
		263,
		270,
		287,
		317,
		-1,
		-1,
		275,
		255,
		-1,
		-1,
		227,
		225,
		214,
		-1,
		204,
		177,
		182,
		202,
		204,
		193,
		187,
		181,
		188,
		187,
		195,
		203,
		296,
		310,
		299,
		295,
		294,
		302,
		251,
		244,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		-1,
		265,
		261,
		-1,
		-1,
		222,
		215,
		203,
		191,
		181,
		191,
		195,
		199,
		191,
		184,
		179,
		190,
		182,
		186,
		203,
		-1,
		330,
		-1,
		282,
		258,
		272,
		287,
		295,
		-1,
		-1,
		-1,
		282,
		268,
		261,
		249,
		247,
		-1,
		256,
		240,
		221,
		-1,
		191,
		204,
		235,
		203,
		208,
		203,
		185,
		196,
		185,
		188,
		202,
		197,
		-1,
		-1,
		270,
		273,
		-1,
		-1,
		272,
		274,
		-1,
		273,
		262,
		247,
		239,
		-1,
		-1,
		228,
		224,
		-1,
		-1,
		192,
		217,
		206,
		214,
		209,
		189,
		195,
		198,
		187,
		191,
		203,
		-1,
		-1,
		277,
		278,
		279,
		-1,
		257,
		-1,
		275,
		-1,
		242,
		248,
		236,
		-1,
		-1,
		-1,
		230,
		193,
		214,
		224,
		218,
		216,
		207,
		193,
		200,
		198,
		194,
		205,
		-1,
		-1,
		-1,
		275,
		249,
		282,
		273,
		256,
		236,
		228,
		247,
		-1,
		217,
		-1,
		192,
		194,
		220,
		223,
		229,
		223,
		196,
		211,
		201,
		192,
		201,
		281,
		-1,
		251,
		284,
		248,
		242,
		218,
		222,
		238,
		-1,
		214,
		196,
		-1,
		224,
		214,
		245,
		230,
		211,
		198,
		205,
		205,
		198,
		-1,
		-1,
		-1,
		253,
		252,
		244,
		238,
		238,
		223,
		214,
		-1,
		226,
		208,
		187,
		204,
		204,
		195,
		203,
		235,
		231,
		218,
		218,
		210,
		-1,
		354,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		247,
		242,
		215,
		203,
		209,
		205,
		191,
		197,
		199,
		207,
		205,
		202,
		214,
		210,
		230,
		211,
		246,
		-1,
		349,
		-1,
		283,
		-1,
		-1,
		265,
		245,
		237,
		226,
		215,
		213,
		204,
		195,
		217,
		233,
		217,
		215,
		218,
		219,
		-1,
		338,
		337,
		-1,
		284,
		276,
		262,
		-1,
		255,
		-1,
		261,
		222,
		-1,
		224,
		204,
		-1,
		226,
		222,
		-1,
		-1,
		325,
		300,
		-1,
		-1,
		-1,
		285,
		265,
		256,
		240,
		-1,
		215,
		215,
		-1,
		-1,
		-1,
		310,
		309,
		-1,
		278,
		281,
		-1,
		271,
		262,
		270,
		217,
		221,
		-1,
		-1,
		-1,
		319,
		300,
		294,
		293,
		291,
		286,
		283,
		269,
		253,
		231,
		220,
		241,
		-1,
		-1,
		-1,
		291,
		283,
		276,
		-1,
		-1,
		278,
		261,
		242,
		240,
		-1,
		-1,
		-1,
		313,
		294,
		-1,
		-1,
		268,
		-1,
		-1,
		274,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		330,
		302,
		-1,
		-1,
		-1,
		264,
		260,
		261,
		-1,
		-1,
		-1,
		-1,
		324,
		325,
		348,
		312,
		-1,
		-1,
		-1,
		256,
		250,
		-1,
		-1,
		327,
		325,
		-1,
		-1,
		-1,
		284,
		268,
		-1,
		254,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		289,
		-1,
		289,
		264,
		271,
		-1,
		-1,
		-1,
		-1,
		302,
		294,
		302,
		-1,
		274,
		276,
		-1,
		324,
		-1,
		-1,
		317,
		308,
		-1,
		-1,
		279,
		286,
		308,
		311,
		347,
		-1,
		298
	],
	[
		-1,
		120,
		109,
		120,
		128,
		101,
		108,
		-1,
		126,
		131,
		97,
		91,
		129,
		98,
		104,
		115,
		-1,
		-1,
		-1,
		120,
		119,
		86,
		84,
		93,
		98,
		105,
		-1,
		14,
		-1,
		141,
		120,
		131,
		136,
		79,
		76,
		55,
		30,
		6,
		15,
		156,
		109,
		76,
		74,
		51,
		47,
		0,
		8,
		-1,
		80,
		70,
		58,
		36,
		17,
		28,
		-1,
		-1,
		60,
		61,
		47,
		30,
		45,
		40,
		-1,
		95,
		86,
		-1,
		-1,
		64,
		63,
		51,
		42,
		31,
		54,
		87,
		104,
		91,
		-1,
		-1,
		59,
		53,
		56,
		49,
		53,
		84,
		93,
		103,
		106,
		108,
		-1,
		68,
		86,
		85,
		64,
		58,
		60,
		64,
		82,
		108,
		117,
		117,
		-1,
		85,
		81,
		91,
		89,
		84,
		59,
		63,
		69,
		88,
		99,
		120,
		111,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		86,
		77,
		97,
		99,
		98,
		80,
		78,
		66,
		72,
		76,
		93,
		109,
		110,
		120,
		-1,
		-1,
		179,
		152,
		176,
		134,
		116,
		-1,
		82,
		84,
		90,
		94,
		97,
		105,
		80,
		82,
		-1,
		87,
		86,
		117,
		103,
		114,
		161,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		99,
		98,
		94,
		96,
		98,
		105,
		90,
		103,
		110,
		81,
		91,
		95,
		110,
		121,
		-1,
		-1,
		195,
		-1,
		-1,
		158,
		141,
		-1,
		106,
		113,
		97,
		103,
		89,
		110,
		109,
		103,
		110,
		113,
		101,
		103,
		100,
		117,
		103,
		78,
		103,
		107,
		113,
		131,
		132,
		-1,
		194,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		113,
		110,
		103,
		127,
		126,
		-1,
		132,
		130,
		136,
		121,
		126,
		122,
		107,
		108,
		103,
		103,
		100,
		85,
		87,
		124,
		115,
		136,
		133,
		164,
		170,
		164,
		173,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		131,
		-1,
		134,
		147,
		144,
		132,
		135,
		122,
		130,
		129,
		113,
		114,
		101,
		98,
		97,
		93,
		102,
		112,
		111,
		129,
		142,
		157,
		161,
		167,
		-1,
		216,
		-1,
		158,
		142,
		144,
		120,
		148,
		-1,
		151,
		135,
		155,
		146,
		146,
		-1,
		138,
		135,
		145,
		128,
		113,
		113,
		101,
		96,
		96,
		100,
		115,
		106,
		124,
		131,
		139,
		143,
		163,
		175,
		176,
		166,
		-1,
		148,
		153,
		123,
		135,
		158,
		178,
		162,
		-1,
		157,
		-1,
		140,
		153,
		-1,
		134,
		130,
		119,
		109,
		98,
		105,
		103,
		97,
		94,
		112,
		115,
		132,
		136,
		152,
		-1,
		-1,
		161,
		165,
		173,
		124,
		143,
		167,
		204,
		171,
		164,
		163,
		-1,
		158,
		155,
		152,
		151,
		138,
		123,
		121,
		104,
		110,
		111,
		96,
		99,
		121,
		149,
		127,
		139,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		150,
		121,
		145,
		187,
		193,
		186,
		174,
		174,
		174,
		168,
		-1,
		162,
		141,
		132,
		121,
		111,
		127,
		117,
		120,
		100,
		102,
		118,
		130,
		121,
		141,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		124,
		158,
		176,
		207,
		193,
		198,
		173,
		166,
		160,
		164,
		158,
		139,
		128,
		120,
		109,
		118,
		128,
		122,
		102,
		111,
		112,
		136,
		143,
		149,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		149,
		156,
		188,
		198,
		211,
		-1,
		165,
		-1,
		154,
		149,
		133,
		128,
		125,
		122,
		116,
		125,
		130,
		116,
		107,
		122,
		141,
		141,
		133,
		158,
		161,
		-1,
		-1,
		-1,
		180,
		197,
		172,
		149,
		130,
		166,
		-1,
		181,
		182,
		-1,
		159,
		153,
		150,
		135,
		131,
		126,
		130,
		123,
		130,
		126,
		125,
		126,
		108,
		144,
		-1,
		141,
		135,
		163,
		166,
		156,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		137,
		189,
		-1,
		-1,
		166,
		159,
		-1,
		146,
		128,
		135,
		133,
		127,
		131,
		135,
		124,
		137,
		133,
		113,
		123,
		143,
		147,
		154,
		147,
		152,
		151,
		165,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		157,
		-1,
		175,
		167,
		157,
		151,
		145,
		141,
		139,
		155,
		139,
		142,
		142,
		138,
		146,
		131,
		130,
		116,
		120,
		138,
		165,
		160,
		155,
		154,
		161,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		172,
		-1,
		143,
		167,
		183,
		-1,
		183,
		162,
		177,
		155,
		151,
		147,
		162,
		163,
		141,
		146,
		145,
		155,
		152,
		141,
		128,
		132,
		147,
		157,
		149,
		150,
		159,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		146,
		145,
		170,
		-1,
		-1,
		219,
		-1,
		153,
		170,
		161,
		159,
		152,
		143,
		149,
		156,
		159,
		156,
		146,
		135,
		141,
		137,
		159,
		145,
		143,
		162,
		177,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		197,
		187,
		171,
		156,
		189,
		-1,
		160,
		144,
		149,
		-1,
		181,
		-1,
		154,
		154,
		145,
		134,
		131,
		142,
		140,
		151,
		168,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		203,
		-1,
		-1,
		184,
		178,
		178,
		162,
		165,
		176,
		156,
		150,
		149,
		176,
		171,
		162,
		143,
		136,
		133,
		134,
		147,
		167,
		158,
		170,
		-1,
		-1,
		-1,
		204,
		184,
		190,
		148,
		169,
		-1,
		-1,
		246,
		201,
		187,
		-1,
		171,
		193,
		181,
		171,
		161,
		195,
		187,
		162,
		155,
		141,
		143,
		141,
		143,
		148,
		169,
		170,
		183,
		-1,
		-1,
		181,
		188,
		176,
		162,
		181,
		-1,
		-1,
		-1,
		193,
		209,
		201,
		172,
		182,
		-1,
		-1,
		173,
		171,
		179,
		158,
		145,
		165,
		168,
		158,
		142,
		157,
		169,
		177,
		182,
		-1,
		184,
		171,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		204,
		199,
		203,
		176,
		-1,
		175,
		169,
		149,
		163,
		170,
		160,
		155,
		149,
		152,
		170,
		187,
		-1,
		-1,
		198,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		183,
		197,
		192,
		185,
		189,
		-1,
		177,
		165,
		151,
		168,
		173,
		170,
		161,
		153,
		158,
		155,
		168,
		182,
		186,
		221,
		-1,
		204,
		-1,
		-1,
		-1,
		201,
		216,
		231,
		208,
		181,
		176,
		169,
		163,
		159,
		175,
		181,
		192,
		160,
		156,
		157,
		161,
		160,
		177,
		187,
		-1,
		-1,
		204,
		221,
		227,
		209,
		213,
		258,
		-1,
		-1,
		185,
		176,
		167,
		170,
		169,
		172,
		166,
		163,
		168,
		173,
		161,
		170,
		188,
		187,
		-1,
		-1,
		-1,
		224,
		-1,
		239,
		-1,
		-1,
		228,
		256,
		203,
		185,
		181,
		179,
		172,
		181,
		176,
		171,
		181,
		183,
		175,
		163,
		167,
		190,
		179,
		218,
		-1,
		-1,
		341,
		-1,
		-1,
		-1,
		253,
		228,
		243,
		267,
		248,
		255,
		218,
		215,
		-1,
		185,
		210,
		182,
		189,
		180,
		187,
		187,
		179,
		157,
		164,
		180,
		179,
		174,
		210,
		201,
		207,
		-1,
		-1,
		334,
		323,
		312,
		318,
		-1,
		259,
		245,
		253,
		243,
		246,
		-1,
		-1,
		234,
		231,
		207,
		190,
		188,
		181,
		176,
		186,
		166,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		229,
		310,
		303,
		286,
		294,
		325,
		-1,
		257,
		249,
		252,
		235,
		237,
		-1,
		-1,
		207,
		204,
		209,
		197,
		194,
		196,
		191,
		182,
		167,
		173,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		243,
		286,
		280,
		283,
		307,
		321,
		-1,
		254,
		-1,
		-1,
		260,
		238,
		222,
		212,
		206,
		256,
		211,
		206,
		190,
		188,
		179,
		170,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		278,
		266,
		274,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		276,
		-1,
		249,
		-1,
		224,
		228,
		219,
		222,
		204,
		191,
		183,
		175,
		191,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		325,
		281,
		274,
		265,
		306,
		321,
		325,
		-1,
		266,
		305,
		303,
		-1,
		285,
		-1,
		-1,
		-1,
		238,
		232,
		224,
		224,
		203,
		203,
		177,
		181,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		321,
		312,
		325,
		270,
		270,
		291,
		300,
		321,
		281,
		272,
		299,
		310,
		299,
		294,
		281,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		210,
		198,
		181,
		182,
		178,
		181,
		196,
		199,
		189,
		187,
		181,
		213,
		-1,
		314,
		313,
		302,
		299,
		275,
		266,
		261,
		288,
		-1,
		-1,
		283,
		300,
		294,
		298,
		314,
		339,
		-1,
		270,
		-1,
		-1,
		255,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		186,
		197,
		207,
		195,
		196,
		186,
		196,
		209,
		298,
		295,
		283,
		281,
		304,
		269,
		257,
		-1,
		270,
		268,
		274,
		281,
		298,
		328,
		-1,
		-1,
		286,
		266,
		-1,
		-1,
		238,
		236,
		225,
		-1,
		215,
		188,
		193,
		213,
		215,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		307,
		321,
		310,
		306,
		305,
		313,
		262,
		255,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		-1,
		276,
		272,
		-1,
		-1,
		233,
		226,
		214,
		202,
		192,
		202,
		206,
		210,
		202,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		341,
		-1,
		293,
		269,
		283,
		298,
		306,
		-1,
		-1,
		-1,
		293,
		279,
		272,
		260,
		258,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		281,
		284,
		-1,
		-1,
		283,
		285,
		-1,
		284,
		273,
		258,
		250,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		288,
		289,
		290,
		-1,
		268,
		-1,
		286,
		-1,
		253,
		259,
		247,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		229,
		227,
		218,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		286,
		260,
		293,
		284,
		267,
		247,
		239,
		258,
		-1,
		228,
		-1,
		203,
		205,
		231,
		234,
		240,
		234,
		207,
		222,
		212,
		203,
		212,
		292,
		-1,
		262,
		295,
		259,
		253,
		229,
		233,
		249,
		-1,
		225,
		207,
		-1,
		235,
		225,
		256,
		241,
		222,
		209,
		216,
		216,
		209,
		-1,
		-1,
		-1,
		264,
		263,
		255,
		249,
		249,
		234,
		225,
		-1,
		237,
		219,
		198,
		215,
		215,
		206,
		214,
		246,
		242,
		229,
		229,
		221,
		-1,
		365,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		258,
		253,
		226,
		214,
		220,
		216,
		202,
		208,
		210,
		218,
		216,
		213,
		225,
		221,
		241,
		222,
		257,
		-1,
		360,
		-1,
		294,
		-1,
		-1,
		276,
		256,
		248,
		237,
		226,
		224,
		215,
		206,
		228,
		244,
		228,
		226,
		229,
		230,
		-1,
		349,
		348,
		-1,
		295,
		287,
		273,
		-1,
		266,
		-1,
		272,
		233,
		-1,
		235,
		215,
		-1,
		237,
		233,
		-1,
		-1,
		336,
		311,
		-1,
		-1,
		-1,
		296,
		276,
		267,
		251,
		-1,
		226,
		226,
		-1,
		-1,
		-1,
		321,
		320,
		-1,
		289,
		292,
		-1,
		282,
		273,
		281,
		228,
		232,
		-1,
		-1,
		-1,
		330,
		311,
		305,
		304,
		302,
		297,
		294,
		280,
		264,
		242,
		231,
		252,
		-1,
		-1,
		-1,
		302,
		294,
		287,
		-1,
		-1,
		289,
		272,
		253,
		251,
		-1,
		-1,
		-1,
		324,
		305,
		-1,
		-1,
		279,
		-1,
		-1,
		285,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		341,
		313,
		-1,
		-1,
		-1,
		275,
		271,
		272,
		-1,
		-1,
		-1,
		-1,
		335,
		336,
		359,
		323,
		-1,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		338,
		336,
		-1,
		-1,
		-1,
		295,
		279,
		-1,
		265,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		300,
		-1,
		300,
		275,
		282,
		-1,
		-1,
		-1,
		-1,
		313,
		305,
		313,
		-1,
		285,
		287,
		-1,
		335,
		-1,
		-1,
		328,
		319,
		-1,
		-1,
		290,
		297,
		319,
		322,
		358,
		-1,
		309
	],
	[
		-1,
		112,
		101,
		112,
		120,
		93,
		100,
		-1,
		118,
		123,
		89,
		83,
		121,
		90,
		96,
		107,
		-1,
		-1,
		-1,
		112,
		111,
		78,
		76,
		85,
		90,
		97,
		-1,
		22,
		-1,
		133,
		112,
		123,
		128,
		71,
		68,
		63,
		38,
		14,
		13,
		148,
		101,
		72,
		66,
		59,
		39,
		8,
		0,
		-1,
		72,
		62,
		50,
		28,
		9,
		20,
		-1,
		-1,
		52,
		53,
		39,
		22,
		37,
		32,
		-1,
		87,
		78,
		-1,
		-1,
		56,
		55,
		43,
		34,
		23,
		46,
		79,
		96,
		83,
		-1,
		-1,
		51,
		45,
		48,
		41,
		45,
		76,
		85,
		95,
		98,
		100,
		-1,
		60,
		78,
		77,
		56,
		50,
		52,
		56,
		74,
		100,
		109,
		109,
		-1,
		77,
		73,
		83,
		81,
		76,
		51,
		55,
		61,
		80,
		91,
		112,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		78,
		69,
		89,
		91,
		90,
		72,
		70,
		58,
		64,
		68,
		85,
		101,
		102,
		112,
		-1,
		-1,
		171,
		144,
		168,
		126,
		108,
		-1,
		74,
		76,
		82,
		86,
		89,
		97,
		72,
		74,
		-1,
		79,
		78,
		109,
		95,
		106,
		153,
		-1,
		-1,
		129,
		121,
		103,
		106,
		83,
		79,
		91,
		90,
		86,
		88,
		90,
		97,
		82,
		95,
		102,
		73,
		83,
		87,
		102,
		113,
		-1,
		-1,
		187,
		-1,
		-1,
		150,
		133,
		-1,
		98,
		105,
		89,
		95,
		81,
		102,
		101,
		95,
		102,
		105,
		93,
		95,
		92,
		109,
		95,
		70,
		95,
		99,
		105,
		123,
		124,
		-1,
		186,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		105,
		102,
		95,
		119,
		118,
		-1,
		124,
		122,
		128,
		113,
		118,
		114,
		99,
		100,
		95,
		95,
		92,
		77,
		79,
		116,
		107,
		128,
		125,
		156,
		162,
		156,
		165,
		-1,
		158,
		154,
		150,
		157,
		106,
		-1,
		-1,
		123,
		-1,
		126,
		139,
		136,
		124,
		127,
		114,
		122,
		121,
		105,
		106,
		93,
		90,
		89,
		85,
		94,
		104,
		103,
		121,
		134,
		149,
		153,
		159,
		-1,
		208,
		-1,
		150,
		134,
		136,
		112,
		140,
		-1,
		143,
		127,
		147,
		138,
		138,
		-1,
		130,
		127,
		137,
		120,
		105,
		105,
		93,
		88,
		88,
		92,
		107,
		98,
		116,
		123,
		131,
		135,
		155,
		167,
		168,
		158,
		-1,
		140,
		145,
		115,
		127,
		150,
		170,
		154,
		-1,
		149,
		-1,
		132,
		145,
		-1,
		126,
		122,
		111,
		101,
		90,
		97,
		95,
		89,
		86,
		104,
		107,
		124,
		128,
		144,
		-1,
		-1,
		153,
		157,
		165,
		116,
		135,
		159,
		196,
		163,
		156,
		155,
		-1,
		150,
		147,
		144,
		143,
		130,
		115,
		113,
		96,
		102,
		103,
		88,
		91,
		113,
		141,
		119,
		131,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		142,
		113,
		137,
		179,
		185,
		178,
		166,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		103,
		119,
		109,
		112,
		92,
		94,
		110,
		122,
		113,
		133,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		116,
		150,
		168,
		199,
		185,
		190,
		165,
		158,
		152,
		156,
		150,
		131,
		120,
		112,
		101,
		110,
		120,
		114,
		94,
		103,
		104,
		128,
		135,
		141,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		141,
		148,
		180,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		122,
		108,
		99,
		114,
		133,
		133,
		125,
		150,
		153,
		-1,
		-1,
		-1,
		172,
		189,
		164,
		141,
		122,
		158,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		118,
		117,
		118,
		100,
		136,
		-1,
		133,
		127,
		155,
		158,
		148,
		-1,
		-1,
		-1,
		187,
		166,
		159,
		179,
		129,
		181,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		127,
		116,
		129,
		125,
		105,
		115,
		135,
		139,
		146,
		139,
		144,
		143,
		157,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		149,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		134,
		130,
		138,
		123,
		122,
		108,
		112,
		130,
		157,
		152,
		147,
		146,
		153,
		-1,
		235,
		221,
		192,
		-1,
		-1,
		164,
		-1,
		135,
		159,
		175,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		138,
		137,
		147,
		144,
		133,
		120,
		124,
		139,
		149,
		141,
		142,
		151,
		-1,
		241,
		228,
		186,
		182,
		171,
		191,
		138,
		137,
		162,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		148,
		151,
		148,
		138,
		127,
		133,
		129,
		151,
		137,
		135,
		154,
		169,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		157,
		144,
		138,
		-1,
		179,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		152,
		136,
		141,
		-1,
		173,
		-1,
		146,
		146,
		137,
		126,
		123,
		134,
		132,
		143,
		160,
		-1,
		191,
		176,
		169,
		159,
		173,
		144,
		-1,
		195,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		168,
		148,
		142,
		141,
		168,
		163,
		154,
		135,
		128,
		125,
		126,
		139,
		159,
		150,
		162,
		-1,
		-1,
		-1,
		196,
		176,
		182,
		140,
		161,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		185,
		173,
		163,
		153,
		187,
		179,
		154,
		147,
		133,
		135,
		133,
		135,
		140,
		161,
		162,
		175,
		-1,
		-1,
		173,
		180,
		168,
		154,
		173,
		-1,
		-1,
		-1,
		185,
		201,
		193,
		164,
		174,
		-1,
		-1,
		165,
		163,
		171,
		150,
		137,
		157,
		160,
		150,
		134,
		149,
		161,
		169,
		174,
		-1,
		176,
		163,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		-1,
		-1,
		218,
		184,
		196,
		191,
		195,
		168,
		-1,
		167,
		161,
		141,
		155,
		162,
		152,
		147,
		141,
		144,
		162,
		179,
		-1,
		-1,
		190,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		175,
		189,
		184,
		177,
		181,
		-1,
		169,
		157,
		143,
		160,
		165,
		162,
		153,
		145,
		150,
		147,
		160,
		174,
		178,
		213,
		-1,
		196,
		-1,
		-1,
		-1,
		193,
		208,
		223,
		200,
		173,
		168,
		161,
		155,
		151,
		167,
		173,
		184,
		152,
		148,
		149,
		153,
		152,
		169,
		179,
		-1,
		-1,
		196,
		213,
		219,
		201,
		205,
		250,
		-1,
		-1,
		177,
		168,
		159,
		162,
		161,
		164,
		158,
		155,
		160,
		165,
		153,
		162,
		180,
		179,
		-1,
		-1,
		-1,
		216,
		-1,
		231,
		-1,
		-1,
		220,
		248,
		195,
		177,
		173,
		171,
		164,
		173,
		168,
		163,
		173,
		175,
		167,
		155,
		159,
		182,
		171,
		210,
		-1,
		-1,
		333,
		-1,
		-1,
		-1,
		245,
		220,
		235,
		259,
		240,
		247,
		210,
		207,
		-1,
		177,
		202,
		174,
		181,
		172,
		179,
		179,
		171,
		149,
		156,
		172,
		171,
		166,
		202,
		193,
		199,
		-1,
		-1,
		326,
		315,
		304,
		310,
		-1,
		251,
		237,
		245,
		235,
		238,
		-1,
		-1,
		226,
		223,
		199,
		182,
		180,
		173,
		168,
		178,
		158,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		221,
		302,
		295,
		278,
		286,
		317,
		-1,
		249,
		241,
		244,
		227,
		229,
		-1,
		-1,
		199,
		196,
		201,
		189,
		186,
		188,
		183,
		174,
		159,
		165,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		235,
		278,
		272,
		275,
		299,
		313,
		-1,
		246,
		-1,
		-1,
		252,
		230,
		214,
		204,
		198,
		248,
		203,
		198,
		182,
		180,
		171,
		162,
		169,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		270,
		258,
		266,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		268,
		-1,
		241,
		-1,
		216,
		220,
		211,
		214,
		196,
		183,
		175,
		167,
		183,
		158,
		168,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		317,
		273,
		266,
		257,
		298,
		313,
		317,
		-1,
		258,
		297,
		295,
		-1,
		277,
		-1,
		-1,
		-1,
		230,
		224,
		216,
		216,
		195,
		195,
		169,
		173,
		163,
		170,
		180,
		182,
		174,
		178,
		191,
		202,
		205,
		313,
		304,
		317,
		262,
		262,
		283,
		292,
		313,
		273,
		264,
		291,
		302,
		291,
		286,
		273,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		202,
		190,
		173,
		174,
		170,
		173,
		188,
		191,
		181,
		179,
		173,
		205,
		-1,
		306,
		305,
		294,
		291,
		267,
		258,
		253,
		280,
		-1,
		-1,
		275,
		292,
		286,
		290,
		306,
		331,
		-1,
		262,
		-1,
		-1,
		247,
		-1,
		-1,
		232,
		195,
		184,
		175,
		181,
		178,
		189,
		199,
		187,
		188,
		178,
		188,
		201,
		290,
		287,
		275,
		273,
		296,
		261,
		249,
		-1,
		262,
		260,
		266,
		273,
		290,
		320,
		-1,
		-1,
		278,
		258,
		-1,
		-1,
		230,
		228,
		217,
		-1,
		207,
		180,
		185,
		205,
		207,
		196,
		190,
		184,
		191,
		190,
		198,
		206,
		299,
		313,
		302,
		298,
		297,
		305,
		254,
		247,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		-1,
		268,
		264,
		-1,
		-1,
		225,
		218,
		206,
		194,
		184,
		194,
		198,
		202,
		194,
		187,
		182,
		193,
		185,
		189,
		206,
		-1,
		333,
		-1,
		285,
		261,
		275,
		290,
		298,
		-1,
		-1,
		-1,
		285,
		271,
		264,
		252,
		250,
		-1,
		259,
		243,
		224,
		-1,
		194,
		207,
		238,
		206,
		211,
		206,
		188,
		199,
		188,
		191,
		205,
		200,
		-1,
		-1,
		273,
		276,
		-1,
		-1,
		275,
		277,
		-1,
		276,
		265,
		250,
		242,
		-1,
		-1,
		231,
		227,
		-1,
		-1,
		195,
		220,
		209,
		217,
		212,
		192,
		198,
		201,
		190,
		194,
		206,
		-1,
		-1,
		280,
		281,
		282,
		-1,
		260,
		-1,
		278,
		-1,
		245,
		251,
		239,
		-1,
		-1,
		-1,
		233,
		196,
		217,
		227,
		221,
		219,
		210,
		196,
		203,
		201,
		197,
		208,
		-1,
		-1,
		-1,
		278,
		252,
		285,
		276,
		259,
		239,
		231,
		250,
		-1,
		220,
		-1,
		195,
		197,
		223,
		226,
		232,
		226,
		199,
		214,
		204,
		195,
		204,
		284,
		-1,
		254,
		287,
		251,
		245,
		221,
		225,
		241,
		-1,
		217,
		199,
		-1,
		227,
		217,
		248,
		233,
		214,
		201,
		208,
		208,
		201,
		-1,
		-1,
		-1,
		256,
		255,
		247,
		241,
		241,
		226,
		217,
		-1,
		229,
		211,
		190,
		207,
		207,
		198,
		206,
		238,
		234,
		221,
		221,
		213,
		-1,
		357,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		250,
		245,
		218,
		206,
		212,
		208,
		194,
		200,
		202,
		210,
		208,
		205,
		217,
		213,
		233,
		214,
		249,
		-1,
		352,
		-1,
		286,
		-1,
		-1,
		268,
		248,
		240,
		229,
		218,
		216,
		207,
		198,
		220,
		236,
		220,
		218,
		221,
		222,
		-1,
		341,
		340,
		-1,
		287,
		279,
		265,
		-1,
		258,
		-1,
		264,
		225,
		-1,
		227,
		207,
		-1,
		229,
		225,
		-1,
		-1,
		328,
		303,
		-1,
		-1,
		-1,
		288,
		268,
		259,
		243,
		-1,
		218,
		218,
		-1,
		-1,
		-1,
		313,
		312,
		-1,
		281,
		284,
		-1,
		274,
		265,
		273,
		220,
		224,
		-1,
		-1,
		-1,
		322,
		303,
		297,
		296,
		294,
		289,
		286,
		272,
		256,
		234,
		223,
		244,
		-1,
		-1,
		-1,
		294,
		286,
		279,
		-1,
		-1,
		281,
		264,
		245,
		243,
		-1,
		-1,
		-1,
		316,
		297,
		-1,
		-1,
		271,
		-1,
		-1,
		277,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		333,
		305,
		-1,
		-1,
		-1,
		267,
		263,
		264,
		-1,
		-1,
		-1,
		-1,
		327,
		328,
		351,
		315,
		-1,
		-1,
		-1,
		259,
		253,
		-1,
		-1,
		330,
		328,
		-1,
		-1,
		-1,
		287,
		271,
		-1,
		257,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		292,
		-1,
		292,
		267,
		274,
		-1,
		-1,
		-1,
		-1,
		305,
		297,
		305,
		-1,
		277,
		279,
		-1,
		327,
		-1,
		-1,
		320,
		311,
		-1,
		-1,
		282,
		289,
		311,
		314,
		350,
		-1,
		301
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		58,
		47,
		58,
		66,
		39,
		46,
		-1,
		63,
		69,
		35,
		29,
		66,
		35,
		41,
		52,
		-1,
		-1,
		-1,
		58,
		57,
		23,
		21,
		30,
		35,
		42,
		-1,
		79,
		-1,
		79,
		58,
		69,
		74,
		16,
		13,
		33,
		52,
		74,
		76,
		94,
		46,
		17,
		8,
		29,
		40,
		78,
		73,
		-1,
		0,
		11,
		31,
		50,
		66,
		70,
		-1,
		-1,
		15,
		25,
		36,
		51,
		70,
		76,
		-1,
		86,
		105,
		-1,
		-1,
		19,
		32,
		45,
		48,
		56,
		65,
		78,
		95,
		100,
		-1,
		-1,
		37,
		41,
		51,
		52,
		48,
		65,
		84,
		95,
		109,
		108,
		-1,
		39,
		57,
		66,
		59,
		57,
		41,
		45,
		63,
		94,
		100,
		103,
		-1,
		56,
		52,
		62,
		68,
		79,
		57,
		44,
		50,
		69,
		82,
		101,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		57,
		48,
		68,
		70,
		69,
		78,
		76,
		47,
		53,
		57,
		74,
		90,
		91,
		101,
		-1,
		-1,
		150,
		123,
		147,
		105,
		87,
		-1,
		53,
		55,
		61,
		65,
		70,
		78,
		78,
		63,
		-1,
		68,
		67,
		98,
		84,
		95,
		132,
		-1,
		-1,
		108,
		100,
		82,
		85,
		62,
		58,
		70,
		69,
		65,
		67,
		69,
		81,
		71,
		84,
		91,
		62,
		72,
		76,
		91,
		102,
		-1,
		-1,
		176,
		-1,
		-1,
		129,
		112,
		-1,
		77,
		84,
		68,
		74,
		60,
		81,
		80,
		74,
		81,
		84,
		72,
		84,
		81,
		98,
		84,
		59,
		84,
		88,
		94,
		112,
		113,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		84,
		81,
		74,
		98,
		97,
		-1,
		103,
		101,
		107,
		92,
		97,
		93,
		78,
		89,
		84,
		84,
		81,
		66,
		68,
		105,
		96,
		117,
		114,
		145,
		151,
		145,
		154,
		-1,
		137,
		133,
		129,
		136,
		85,
		-1,
		-1,
		102,
		-1,
		105,
		118,
		115,
		103,
		106,
		93,
		101,
		100,
		84,
		95,
		82,
		79,
		78,
		74,
		83,
		93,
		92,
		110,
		123,
		138,
		142,
		148,
		-1,
		187,
		-1,
		129,
		113,
		115,
		91,
		119,
		-1,
		122,
		106,
		126,
		117,
		117,
		-1,
		109,
		106,
		116,
		99,
		84,
		94,
		82,
		77,
		77,
		81,
		96,
		87,
		105,
		112,
		120,
		124,
		144,
		156,
		147,
		137,
		-1,
		119,
		124,
		94,
		106,
		129,
		149,
		133,
		-1,
		128,
		-1,
		111,
		124,
		-1,
		105,
		101,
		90,
		90,
		79,
		86,
		84,
		78,
		75,
		93,
		96,
		113,
		117,
		133,
		-1,
		-1,
		132,
		136,
		144,
		95,
		114,
		138,
		175,
		142,
		135,
		134,
		-1,
		129,
		126,
		123,
		124,
		110,
		103,
		102,
		85,
		91,
		92,
		77,
		80,
		102,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		121,
		92,
		116,
		158,
		164,
		157,
		145,
		155,
		155,
		149,
		-1,
		141,
		120,
		113,
		102,
		92,
		108,
		98,
		101,
		81,
		83,
		99,
		111,
		102,
		122,
		-1,
		-1,
		-1,
		151,
		140,
		141,
		95,
		129,
		147,
		188,
		174,
		179,
		154,
		147,
		141,
		135,
		137,
		120,
		109,
		101,
		90,
		99,
		109,
		103,
		83,
		92,
		93,
		117,
		124,
		130,
		-1,
		-1,
		158,
		148,
		132,
		134,
		131,
		120,
		127,
		159,
		179,
		192,
		-1,
		146,
		-1,
		135,
		130,
		114,
		109,
		106,
		103,
		97,
		106,
		111,
		97,
		88,
		103,
		122,
		122,
		114,
		139,
		142,
		-1,
		-1,
		-1,
		151,
		168,
		143,
		120,
		101,
		137,
		-1,
		162,
		163,
		-1,
		140,
		134,
		131,
		116,
		112,
		107,
		111,
		104,
		111,
		107,
		106,
		107,
		89,
		125,
		-1,
		122,
		116,
		144,
		147,
		137,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		108,
		160,
		-1,
		-1,
		147,
		140,
		-1,
		127,
		109,
		116,
		114,
		108,
		112,
		116,
		105,
		118,
		114,
		94,
		104,
		124,
		128,
		135,
		128,
		133,
		132,
		146,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		128,
		-1,
		156,
		148,
		138,
		132,
		126,
		122,
		120,
		136,
		120,
		123,
		123,
		119,
		127,
		112,
		111,
		97,
		101,
		119,
		146,
		141,
		136,
		135,
		142,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		143,
		-1,
		114,
		138,
		154,
		-1,
		164,
		143,
		158,
		136,
		132,
		128,
		143,
		144,
		122,
		127,
		126,
		136,
		133,
		122,
		109,
		113,
		128,
		138,
		130,
		131,
		140,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		117,
		126,
		141,
		-1,
		-1,
		200,
		-1,
		134,
		151,
		142,
		140,
		133,
		124,
		130,
		137,
		140,
		137,
		127,
		116,
		122,
		118,
		140,
		126,
		124,
		143,
		158,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		178,
		168,
		152,
		137,
		170,
		-1,
		141,
		125,
		130,
		-1,
		162,
		-1,
		135,
		135,
		126,
		115,
		112,
		123,
		121,
		132,
		149,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		174,
		-1,
		-1,
		165,
		159,
		159,
		143,
		146,
		157,
		137,
		131,
		130,
		157,
		152,
		143,
		124,
		117,
		114,
		115,
		128,
		148,
		139,
		151,
		-1,
		-1,
		-1,
		175,
		155,
		161,
		119,
		140,
		-1,
		-1,
		227,
		182,
		168,
		-1,
		152,
		174,
		162,
		152,
		142,
		176,
		168,
		143,
		136,
		122,
		124,
		122,
		124,
		129,
		150,
		151,
		164,
		-1,
		-1,
		152,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		174,
		190,
		182,
		153,
		163,
		-1,
		-1,
		154,
		152,
		160,
		139,
		126,
		146,
		149,
		139,
		123,
		138,
		150,
		158,
		163,
		-1,
		155,
		142,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		185,
		180,
		184,
		157,
		-1,
		156,
		150,
		130,
		144,
		151,
		141,
		136,
		130,
		133,
		151,
		168,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		164,
		178,
		173,
		166,
		170,
		-1,
		158,
		146,
		132,
		149,
		154,
		151,
		142,
		134,
		139,
		136,
		149,
		163,
		167,
		192,
		-1,
		175,
		-1,
		-1,
		-1,
		182,
		197,
		212,
		189,
		162,
		157,
		150,
		144,
		140,
		156,
		162,
		173,
		141,
		137,
		138,
		142,
		141,
		158,
		168,
		-1,
		-1,
		175,
		192,
		208,
		190,
		194,
		239,
		-1,
		-1,
		166,
		157,
		148,
		151,
		150,
		153,
		147,
		144,
		149,
		154,
		142,
		151,
		169,
		168,
		-1,
		-1,
		-1,
		195,
		-1,
		210,
		-1,
		-1,
		209,
		237,
		184,
		166,
		162,
		160,
		153,
		162,
		157,
		152,
		162,
		164,
		156,
		144,
		148,
		171,
		160,
		199,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		224,
		199,
		214,
		248,
		229,
		236,
		199,
		196,
		-1,
		166,
		191,
		163,
		170,
		161,
		168,
		168,
		160,
		138,
		145,
		161,
		160,
		155,
		191,
		182,
		188,
		-1,
		-1,
		305,
		294,
		283,
		289,
		-1,
		230,
		216,
		234,
		224,
		227,
		-1,
		-1,
		215,
		212,
		188,
		171,
		169,
		162,
		157,
		167,
		147,
		134,
		138,
		142,
		148,
		153,
		158,
		164,
		179,
		194,
		-1,
		200,
		281,
		274,
		257,
		265,
		296,
		-1,
		233,
		230,
		223,
		216,
		218,
		-1,
		-1,
		188,
		185,
		190,
		178,
		175,
		177,
		172,
		163,
		148,
		154,
		141,
		140,
		158,
		162,
		171,
		178,
		168,
		181,
		185,
		-1,
		214,
		257,
		251,
		254,
		278,
		292,
		-1,
		235,
		-1,
		-1,
		231,
		219,
		203,
		193,
		187,
		237,
		192,
		187,
		171,
		169,
		160,
		151,
		158,
		149,
		149,
		152,
		167,
		172,
		164,
		178,
		178,
		179,
		-1,
		249,
		237,
		245,
		-1,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		247,
		-1,
		230,
		-1,
		205,
		209,
		200,
		203,
		185,
		172,
		164,
		156,
		172,
		147,
		157,
		153,
		154,
		163,
		174,
		186,
		185,
		186,
		306,
		262,
		245,
		236,
		283,
		298,
		302,
		-1,
		247,
		286,
		284,
		-1,
		256,
		-1,
		-1,
		-1,
		219,
		213,
		205,
		205,
		184,
		184,
		158,
		162,
		152,
		159,
		169,
		171,
		163,
		167,
		180,
		191,
		194,
		302,
		293,
		306,
		251,
		250,
		268,
		277,
		298,
		262,
		253,
		280,
		291,
		280,
		275,
		262,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		191,
		179,
		162,
		163,
		159,
		162,
		177,
		180,
		170,
		168,
		162,
		194,
		-1,
		295,
		294,
		283,
		280,
		256,
		247,
		242,
		269,
		-1,
		-1,
		264,
		281,
		275,
		279,
		295,
		320,
		-1,
		251,
		-1,
		-1,
		236,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		167,
		178,
		188,
		176,
		177,
		167,
		177,
		190,
		279,
		276,
		264,
		262,
		285,
		250,
		238,
		-1,
		251,
		249,
		255,
		262,
		279,
		309,
		-1,
		-1,
		267,
		247,
		-1,
		-1,
		219,
		217,
		206,
		-1,
		196,
		169,
		174,
		194,
		196,
		185,
		179,
		173,
		180,
		179,
		187,
		195,
		288,
		302,
		291,
		287,
		286,
		294,
		243,
		236,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		257,
		253,
		-1,
		-1,
		214,
		207,
		195,
		183,
		173,
		183,
		187,
		191,
		183,
		176,
		171,
		182,
		174,
		178,
		195,
		-1,
		322,
		-1,
		274,
		250,
		264,
		279,
		287,
		-1,
		-1,
		-1,
		274,
		260,
		253,
		241,
		239,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		177,
		188,
		177,
		180,
		194,
		189,
		-1,
		-1,
		262,
		265,
		-1,
		-1,
		264,
		266,
		-1,
		265,
		254,
		239,
		231,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		184,
		209,
		198,
		206,
		201,
		181,
		187,
		190,
		179,
		183,
		195,
		-1,
		-1,
		269,
		270,
		271,
		-1,
		249,
		-1,
		267,
		-1,
		234,
		240,
		228,
		-1,
		-1,
		-1,
		222,
		185,
		206,
		216,
		210,
		208,
		199,
		185,
		192,
		190,
		186,
		197,
		-1,
		-1,
		-1,
		267,
		241,
		274,
		265,
		248,
		228,
		220,
		239,
		-1,
		209,
		-1,
		184,
		186,
		212,
		215,
		221,
		215,
		188,
		203,
		193,
		184,
		193,
		273,
		-1,
		243,
		276,
		240,
		234,
		210,
		214,
		230,
		-1,
		206,
		188,
		-1,
		216,
		206,
		237,
		222,
		203,
		190,
		197,
		197,
		190,
		-1,
		-1,
		-1,
		245,
		244,
		236,
		230,
		230,
		215,
		206,
		-1,
		218,
		200,
		179,
		196,
		196,
		187,
		195,
		227,
		223,
		210,
		210,
		202,
		-1,
		346,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		239,
		234,
		207,
		195,
		201,
		197,
		183,
		189,
		191,
		199,
		197,
		194,
		206,
		202,
		222,
		203,
		238,
		-1,
		341,
		-1,
		275,
		-1,
		-1,
		257,
		237,
		229,
		218,
		207,
		205,
		196,
		187,
		209,
		225,
		209,
		207,
		210,
		211,
		-1,
		330,
		329,
		-1,
		276,
		268,
		254,
		-1,
		247,
		-1,
		253,
		214,
		-1,
		216,
		196,
		-1,
		218,
		214,
		-1,
		-1,
		317,
		292,
		-1,
		-1,
		-1,
		277,
		257,
		248,
		232,
		-1,
		207,
		207,
		-1,
		-1,
		-1,
		302,
		301,
		-1,
		270,
		273,
		-1,
		263,
		254,
		262,
		209,
		213,
		-1,
		-1,
		-1,
		311,
		292,
		286,
		285,
		283,
		278,
		275,
		261,
		245,
		223,
		212,
		233,
		-1,
		-1,
		-1,
		283,
		275,
		268,
		-1,
		-1,
		270,
		253,
		234,
		232,
		-1,
		-1,
		-1,
		305,
		286,
		-1,
		-1,
		260,
		-1,
		-1,
		266,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		322,
		294,
		-1,
		-1,
		-1,
		256,
		252,
		253,
		-1,
		-1,
		-1,
		-1,
		316,
		317,
		340,
		304,
		-1,
		-1,
		-1,
		248,
		242,
		-1,
		-1,
		319,
		317,
		-1,
		-1,
		-1,
		276,
		260,
		-1,
		246,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		281,
		-1,
		281,
		256,
		263,
		-1,
		-1,
		-1,
		-1,
		294,
		286,
		294,
		-1,
		266,
		268,
		-1,
		316,
		-1,
		-1,
		309,
		300,
		-1,
		-1,
		271,
		278,
		300,
		303,
		339,
		-1,
		290
	],
	[
		-1,
		54,
		43,
		54,
		62,
		35,
		42,
		-1,
		59,
		65,
		31,
		25,
		62,
		31,
		37,
		48,
		-1,
		-1,
		-1,
		54,
		53,
		19,
		17,
		26,
		31,
		38,
		-1,
		72,
		-1,
		75,
		54,
		65,
		70,
		12,
		9,
		29,
		45,
		67,
		69,
		90,
		42,
		13,
		4,
		22,
		31,
		70,
		62,
		-1,
		10,
		0,
		22,
		40,
		55,
		59,
		-1,
		-1,
		4,
		14,
		25,
		40,
		59,
		65,
		-1,
		75,
		94,
		-1,
		-1,
		8,
		21,
		34,
		37,
		45,
		54,
		67,
		84,
		89,
		-1,
		-1,
		26,
		30,
		40,
		41,
		37,
		54,
		73,
		84,
		98,
		97,
		-1,
		28,
		46,
		55,
		48,
		46,
		30,
		34,
		52,
		83,
		89,
		92,
		-1,
		45,
		41,
		51,
		57,
		68,
		46,
		33,
		39,
		58,
		71,
		90,
		81,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		46,
		37,
		57,
		59,
		58,
		67,
		65,
		36,
		42,
		46,
		63,
		79,
		80,
		90,
		-1,
		-1,
		139,
		112,
		136,
		94,
		76,
		-1,
		42,
		44,
		50,
		54,
		59,
		67,
		67,
		52,
		-1,
		57,
		56,
		87,
		73,
		84,
		121,
		-1,
		-1,
		97,
		89,
		71,
		74,
		51,
		47,
		59,
		58,
		54,
		56,
		58,
		70,
		60,
		73,
		80,
		51,
		61,
		65,
		80,
		91,
		-1,
		-1,
		165,
		-1,
		-1,
		118,
		101,
		-1,
		66,
		73,
		57,
		63,
		49,
		70,
		69,
		63,
		70,
		73,
		61,
		73,
		70,
		87,
		73,
		48,
		73,
		77,
		83,
		101,
		102,
		-1,
		164,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		73,
		70,
		63,
		87,
		86,
		-1,
		92,
		90,
		96,
		81,
		86,
		82,
		67,
		78,
		73,
		73,
		70,
		55,
		57,
		94,
		85,
		106,
		103,
		134,
		140,
		134,
		143,
		-1,
		126,
		122,
		118,
		125,
		74,
		-1,
		-1,
		91,
		-1,
		94,
		107,
		104,
		92,
		95,
		82,
		90,
		89,
		73,
		84,
		71,
		68,
		67,
		63,
		72,
		82,
		81,
		99,
		112,
		127,
		131,
		137,
		-1,
		176,
		-1,
		118,
		102,
		104,
		80,
		108,
		-1,
		111,
		95,
		115,
		106,
		106,
		-1,
		98,
		95,
		105,
		88,
		73,
		83,
		71,
		66,
		66,
		70,
		85,
		76,
		94,
		101,
		109,
		113,
		133,
		145,
		136,
		126,
		-1,
		108,
		113,
		83,
		95,
		118,
		138,
		122,
		-1,
		117,
		-1,
		100,
		113,
		-1,
		94,
		90,
		79,
		79,
		68,
		75,
		73,
		67,
		64,
		82,
		85,
		102,
		106,
		122,
		-1,
		-1,
		121,
		125,
		133,
		84,
		103,
		127,
		164,
		131,
		124,
		123,
		-1,
		118,
		115,
		112,
		113,
		99,
		92,
		91,
		74,
		80,
		81,
		66,
		69,
		91,
		119,
		97,
		109,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		110,
		81,
		105,
		147,
		153,
		146,
		134,
		144,
		144,
		138,
		-1,
		130,
		109,
		102,
		91,
		81,
		97,
		87,
		90,
		70,
		72,
		88,
		100,
		91,
		111,
		-1,
		-1,
		-1,
		140,
		129,
		130,
		84,
		118,
		136,
		177,
		163,
		168,
		143,
		136,
		130,
		124,
		126,
		109,
		98,
		90,
		79,
		88,
		98,
		92,
		72,
		81,
		82,
		106,
		113,
		119,
		-1,
		-1,
		147,
		137,
		121,
		123,
		120,
		109,
		116,
		148,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		92,
		86,
		95,
		100,
		86,
		77,
		92,
		111,
		111,
		103,
		128,
		131,
		-1,
		-1,
		-1,
		140,
		157,
		132,
		109,
		90,
		126,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		96,
		100,
		93,
		100,
		96,
		95,
		96,
		78,
		114,
		-1,
		111,
		105,
		133,
		136,
		126,
		-1,
		-1,
		-1,
		155,
		134,
		127,
		147,
		97,
		149,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		103,
		97,
		101,
		105,
		94,
		107,
		103,
		83,
		93,
		113,
		117,
		124,
		117,
		122,
		121,
		135,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		117,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		112,
		112,
		108,
		116,
		101,
		100,
		86,
		90,
		108,
		135,
		130,
		125,
		124,
		131,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		132,
		-1,
		103,
		127,
		143,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		116,
		115,
		125,
		122,
		111,
		98,
		102,
		117,
		127,
		119,
		120,
		129,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		106,
		115,
		130,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		126,
		129,
		126,
		116,
		105,
		111,
		107,
		129,
		115,
		113,
		132,
		147,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		130,
		114,
		119,
		-1,
		151,
		-1,
		124,
		124,
		115,
		104,
		101,
		112,
		110,
		121,
		138,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		163,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		146,
		126,
		120,
		119,
		146,
		141,
		132,
		113,
		106,
		103,
		104,
		117,
		137,
		128,
		140,
		-1,
		-1,
		-1,
		164,
		144,
		150,
		108,
		129,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		163,
		151,
		141,
		131,
		165,
		157,
		132,
		125,
		111,
		113,
		111,
		113,
		118,
		139,
		140,
		153,
		-1,
		-1,
		141,
		148,
		136,
		122,
		141,
		-1,
		-1,
		-1,
		163,
		179,
		171,
		142,
		152,
		-1,
		-1,
		143,
		141,
		149,
		128,
		115,
		135,
		138,
		128,
		112,
		127,
		139,
		147,
		152,
		-1,
		144,
		131,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		174,
		169,
		173,
		146,
		-1,
		145,
		139,
		119,
		133,
		140,
		130,
		125,
		119,
		122,
		140,
		157,
		-1,
		-1,
		158,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		153,
		167,
		162,
		155,
		159,
		-1,
		147,
		135,
		121,
		138,
		143,
		140,
		131,
		123,
		128,
		125,
		138,
		152,
		156,
		181,
		-1,
		164,
		-1,
		-1,
		-1,
		171,
		186,
		201,
		178,
		151,
		146,
		139,
		133,
		129,
		145,
		151,
		162,
		130,
		126,
		127,
		131,
		130,
		147,
		157,
		-1,
		-1,
		164,
		181,
		197,
		179,
		183,
		228,
		-1,
		-1,
		155,
		146,
		137,
		140,
		139,
		142,
		136,
		133,
		138,
		143,
		131,
		140,
		158,
		157,
		-1,
		-1,
		-1,
		184,
		-1,
		199,
		-1,
		-1,
		198,
		226,
		173,
		155,
		151,
		149,
		142,
		151,
		146,
		141,
		151,
		153,
		145,
		133,
		137,
		160,
		149,
		188,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		213,
		188,
		203,
		237,
		218,
		225,
		188,
		185,
		-1,
		155,
		180,
		152,
		159,
		150,
		157,
		157,
		149,
		127,
		134,
		150,
		149,
		144,
		180,
		171,
		177,
		-1,
		-1,
		294,
		283,
		272,
		278,
		-1,
		219,
		205,
		223,
		213,
		216,
		-1,
		-1,
		204,
		201,
		177,
		160,
		158,
		151,
		146,
		156,
		136,
		123,
		127,
		131,
		137,
		142,
		147,
		153,
		168,
		183,
		-1,
		189,
		270,
		263,
		246,
		254,
		285,
		-1,
		222,
		219,
		212,
		205,
		207,
		-1,
		-1,
		177,
		174,
		179,
		167,
		164,
		166,
		161,
		152,
		137,
		143,
		130,
		129,
		147,
		151,
		160,
		167,
		157,
		170,
		174,
		-1,
		203,
		246,
		240,
		243,
		267,
		281,
		-1,
		224,
		-1,
		-1,
		220,
		208,
		192,
		182,
		176,
		226,
		181,
		176,
		160,
		158,
		149,
		140,
		147,
		138,
		138,
		141,
		156,
		161,
		153,
		167,
		167,
		168,
		-1,
		238,
		226,
		234,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		236,
		-1,
		219,
		-1,
		194,
		198,
		189,
		192,
		174,
		161,
		153,
		145,
		161,
		136,
		146,
		142,
		143,
		152,
		163,
		175,
		174,
		175,
		295,
		251,
		234,
		225,
		272,
		287,
		291,
		-1,
		236,
		275,
		273,
		-1,
		245,
		-1,
		-1,
		-1,
		208,
		202,
		194,
		194,
		173,
		173,
		147,
		151,
		141,
		148,
		158,
		160,
		152,
		156,
		169,
		180,
		183,
		291,
		282,
		295,
		240,
		239,
		257,
		266,
		287,
		251,
		242,
		269,
		280,
		269,
		264,
		251,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		180,
		168,
		151,
		152,
		148,
		151,
		166,
		169,
		159,
		157,
		151,
		183,
		-1,
		284,
		283,
		272,
		269,
		245,
		236,
		231,
		258,
		-1,
		-1,
		253,
		270,
		264,
		268,
		284,
		309,
		-1,
		240,
		-1,
		-1,
		225,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		156,
		167,
		177,
		165,
		166,
		156,
		166,
		179,
		268,
		265,
		253,
		251,
		274,
		239,
		227,
		-1,
		240,
		238,
		244,
		251,
		268,
		298,
		-1,
		-1,
		256,
		236,
		-1,
		-1,
		208,
		206,
		195,
		-1,
		185,
		158,
		163,
		183,
		185,
		174,
		168,
		162,
		169,
		168,
		176,
		184,
		277,
		291,
		280,
		276,
		275,
		283,
		232,
		225,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		-1,
		246,
		242,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		176,
		180,
		172,
		165,
		160,
		171,
		163,
		167,
		184,
		-1,
		311,
		-1,
		263,
		239,
		253,
		268,
		276,
		-1,
		-1,
		-1,
		263,
		249,
		242,
		230,
		228,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		166,
		177,
		166,
		169,
		183,
		178,
		-1,
		-1,
		251,
		254,
		-1,
		-1,
		253,
		255,
		-1,
		254,
		243,
		228,
		220,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		170,
		176,
		179,
		168,
		172,
		184,
		-1,
		-1,
		258,
		259,
		260,
		-1,
		238,
		-1,
		256,
		-1,
		223,
		229,
		217,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		199,
		197,
		188,
		174,
		181,
		179,
		175,
		186,
		-1,
		-1,
		-1,
		256,
		230,
		263,
		254,
		237,
		217,
		209,
		228,
		-1,
		198,
		-1,
		173,
		175,
		201,
		204,
		210,
		204,
		177,
		192,
		182,
		173,
		182,
		262,
		-1,
		232,
		265,
		229,
		223,
		199,
		203,
		219,
		-1,
		195,
		177,
		-1,
		205,
		195,
		226,
		211,
		192,
		179,
		186,
		186,
		179,
		-1,
		-1,
		-1,
		234,
		233,
		225,
		219,
		219,
		204,
		195,
		-1,
		207,
		189,
		168,
		185,
		185,
		176,
		184,
		216,
		212,
		199,
		199,
		191,
		-1,
		335,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		228,
		223,
		196,
		184,
		190,
		186,
		172,
		178,
		180,
		188,
		186,
		183,
		195,
		191,
		211,
		192,
		227,
		-1,
		330,
		-1,
		264,
		-1,
		-1,
		246,
		226,
		218,
		207,
		196,
		194,
		185,
		176,
		198,
		214,
		198,
		196,
		199,
		200,
		-1,
		319,
		318,
		-1,
		265,
		257,
		243,
		-1,
		236,
		-1,
		242,
		203,
		-1,
		205,
		185,
		-1,
		207,
		203,
		-1,
		-1,
		306,
		281,
		-1,
		-1,
		-1,
		266,
		246,
		237,
		221,
		-1,
		196,
		196,
		-1,
		-1,
		-1,
		291,
		290,
		-1,
		259,
		262,
		-1,
		252,
		243,
		251,
		198,
		202,
		-1,
		-1,
		-1,
		300,
		281,
		275,
		274,
		272,
		267,
		264,
		250,
		234,
		212,
		201,
		222,
		-1,
		-1,
		-1,
		272,
		264,
		257,
		-1,
		-1,
		259,
		242,
		223,
		221,
		-1,
		-1,
		-1,
		294,
		275,
		-1,
		-1,
		249,
		-1,
		-1,
		255,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		283,
		-1,
		-1,
		-1,
		245,
		241,
		242,
		-1,
		-1,
		-1,
		-1,
		305,
		306,
		329,
		293,
		-1,
		-1,
		-1,
		237,
		231,
		-1,
		-1,
		308,
		306,
		-1,
		-1,
		-1,
		265,
		249,
		-1,
		235,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		270,
		-1,
		270,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		283,
		275,
		283,
		-1,
		255,
		257,
		-1,
		305,
		-1,
		-1,
		298,
		289,
		-1,
		-1,
		260,
		267,
		289,
		292,
		328,
		-1,
		279
	],
	[
		-1,
		75,
		64,
		75,
		83,
		56,
		63,
		-1,
		80,
		86,
		52,
		46,
		83,
		52,
		58,
		69,
		-1,
		-1,
		-1,
		75,
		74,
		40,
		38,
		47,
		52,
		59,
		-1,
		60,
		-1,
		96,
		75,
		86,
		91,
		33,
		30,
		22,
		33,
		55,
		57,
		111,
		63,
		34,
		25,
		10,
		9,
		55,
		47,
		-1,
		29,
		24,
		0,
		19,
		40,
		59,
		-1,
		-1,
		28,
		30,
		16,
		25,
		52,
		71,
		-1,
		99,
		117,
		-1,
		-1,
		32,
		42,
		44,
		41,
		45,
		68,
		91,
		108,
		113,
		-1,
		-1,
		50,
		46,
		49,
		46,
		50,
		78,
		97,
		108,
		122,
		121,
		-1,
		52,
		70,
		78,
		61,
		70,
		54,
		58,
		76,
		107,
		113,
		116,
		-1,
		69,
		65,
		75,
		81,
		77,
		70,
		57,
		63,
		82,
		95,
		114,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		70,
		61,
		81,
		83,
		82,
		91,
		89,
		60,
		66,
		70,
		87,
		103,
		104,
		114,
		-1,
		-1,
		163,
		136,
		160,
		118,
		100,
		-1,
		66,
		68,
		74,
		78,
		83,
		91,
		91,
		76,
		-1,
		81,
		80,
		111,
		97,
		108,
		145,
		-1,
		-1,
		121,
		113,
		95,
		98,
		75,
		71,
		83,
		82,
		78,
		80,
		82,
		94,
		84,
		97,
		104,
		75,
		85,
		89,
		104,
		115,
		-1,
		-1,
		189,
		-1,
		-1,
		142,
		125,
		-1,
		90,
		97,
		81,
		87,
		73,
		94,
		93,
		87,
		94,
		97,
		85,
		97,
		94,
		111,
		97,
		72,
		97,
		101,
		107,
		125,
		126,
		-1,
		188,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		97,
		94,
		87,
		111,
		110,
		-1,
		116,
		114,
		120,
		105,
		110,
		106,
		91,
		102,
		97,
		97,
		94,
		79,
		81,
		118,
		109,
		130,
		127,
		158,
		164,
		158,
		167,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		115,
		-1,
		118,
		131,
		128,
		116,
		119,
		106,
		114,
		113,
		97,
		108,
		95,
		92,
		91,
		87,
		96,
		106,
		105,
		123,
		136,
		151,
		155,
		161,
		-1,
		200,
		-1,
		142,
		126,
		128,
		104,
		132,
		-1,
		135,
		119,
		139,
		130,
		130,
		-1,
		122,
		119,
		129,
		112,
		97,
		107,
		95,
		90,
		90,
		94,
		109,
		100,
		118,
		125,
		133,
		137,
		157,
		169,
		160,
		150,
		-1,
		132,
		137,
		107,
		119,
		142,
		162,
		146,
		-1,
		141,
		-1,
		124,
		137,
		-1,
		118,
		114,
		103,
		103,
		92,
		99,
		97,
		91,
		88,
		106,
		109,
		126,
		130,
		146,
		-1,
		-1,
		145,
		149,
		157,
		108,
		127,
		151,
		188,
		155,
		148,
		147,
		-1,
		142,
		139,
		136,
		137,
		123,
		116,
		115,
		98,
		104,
		105,
		90,
		93,
		115,
		143,
		121,
		133,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		134,
		105,
		129,
		171,
		177,
		170,
		158,
		168,
		168,
		162,
		-1,
		154,
		133,
		126,
		115,
		105,
		121,
		111,
		114,
		94,
		96,
		112,
		124,
		115,
		135,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		108,
		142,
		160,
		201,
		187,
		192,
		167,
		160,
		154,
		148,
		150,
		133,
		122,
		114,
		103,
		112,
		122,
		116,
		96,
		105,
		106,
		130,
		137,
		143,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		133,
		140,
		172,
		192,
		205,
		-1,
		159,
		-1,
		148,
		143,
		127,
		122,
		119,
		116,
		110,
		119,
		124,
		110,
		101,
		116,
		135,
		135,
		127,
		152,
		155,
		-1,
		-1,
		-1,
		164,
		181,
		156,
		133,
		114,
		150,
		-1,
		175,
		176,
		-1,
		153,
		147,
		144,
		129,
		125,
		120,
		124,
		117,
		124,
		120,
		119,
		120,
		102,
		138,
		-1,
		135,
		129,
		157,
		160,
		150,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		121,
		173,
		-1,
		-1,
		160,
		153,
		-1,
		140,
		122,
		129,
		127,
		121,
		125,
		129,
		118,
		131,
		127,
		107,
		117,
		137,
		141,
		148,
		141,
		146,
		145,
		159,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		141,
		-1,
		169,
		161,
		151,
		145,
		139,
		135,
		133,
		149,
		133,
		136,
		136,
		132,
		140,
		125,
		124,
		110,
		114,
		132,
		159,
		154,
		149,
		148,
		155,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		156,
		-1,
		127,
		151,
		167,
		-1,
		177,
		156,
		171,
		149,
		145,
		141,
		156,
		157,
		135,
		140,
		139,
		149,
		146,
		135,
		122,
		126,
		141,
		151,
		143,
		144,
		153,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		130,
		139,
		154,
		-1,
		-1,
		213,
		-1,
		147,
		164,
		155,
		153,
		146,
		137,
		143,
		150,
		153,
		150,
		140,
		129,
		135,
		131,
		153,
		139,
		137,
		156,
		171,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		191,
		181,
		165,
		150,
		183,
		-1,
		154,
		138,
		143,
		-1,
		175,
		-1,
		148,
		148,
		139,
		128,
		125,
		136,
		134,
		145,
		162,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		187,
		-1,
		-1,
		178,
		172,
		172,
		156,
		159,
		170,
		150,
		144,
		143,
		170,
		165,
		156,
		137,
		130,
		127,
		128,
		141,
		161,
		152,
		164,
		-1,
		-1,
		-1,
		188,
		168,
		174,
		132,
		153,
		-1,
		-1,
		240,
		195,
		181,
		-1,
		165,
		187,
		175,
		165,
		155,
		189,
		181,
		156,
		149,
		135,
		137,
		135,
		137,
		142,
		163,
		164,
		177,
		-1,
		-1,
		165,
		172,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		187,
		203,
		195,
		166,
		176,
		-1,
		-1,
		167,
		165,
		173,
		152,
		139,
		159,
		162,
		152,
		136,
		151,
		163,
		171,
		176,
		-1,
		168,
		155,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		220,
		186,
		198,
		193,
		197,
		170,
		-1,
		169,
		163,
		143,
		157,
		164,
		154,
		149,
		143,
		146,
		164,
		181,
		-1,
		-1,
		182,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		177,
		191,
		186,
		179,
		183,
		-1,
		171,
		159,
		145,
		162,
		167,
		164,
		155,
		147,
		152,
		149,
		162,
		176,
		180,
		205,
		-1,
		188,
		-1,
		-1,
		-1,
		195,
		210,
		225,
		202,
		175,
		170,
		163,
		157,
		153,
		169,
		175,
		186,
		154,
		150,
		151,
		155,
		154,
		171,
		181,
		-1,
		-1,
		188,
		205,
		221,
		203,
		207,
		252,
		-1,
		-1,
		179,
		170,
		161,
		164,
		163,
		166,
		160,
		157,
		162,
		167,
		155,
		164,
		182,
		181,
		-1,
		-1,
		-1,
		208,
		-1,
		223,
		-1,
		-1,
		222,
		250,
		197,
		179,
		175,
		173,
		166,
		175,
		170,
		165,
		175,
		177,
		169,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		237,
		212,
		227,
		261,
		242,
		249,
		212,
		209,
		-1,
		179,
		204,
		176,
		183,
		174,
		181,
		181,
		173,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		243,
		229,
		247,
		237,
		240,
		-1,
		-1,
		228,
		225,
		201,
		184,
		182,
		175,
		170,
		180,
		160,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		213,
		294,
		287,
		270,
		278,
		309,
		-1,
		246,
		243,
		236,
		229,
		231,
		-1,
		-1,
		201,
		198,
		203,
		191,
		188,
		190,
		185,
		176,
		161,
		167,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		227,
		270,
		264,
		267,
		291,
		305,
		-1,
		248,
		-1,
		-1,
		244,
		232,
		216,
		206,
		200,
		250,
		205,
		200,
		184,
		182,
		173,
		164,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		262,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		260,
		-1,
		243,
		-1,
		218,
		222,
		213,
		216,
		198,
		185,
		177,
		169,
		185,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		319,
		275,
		258,
		249,
		296,
		311,
		315,
		-1,
		260,
		299,
		297,
		-1,
		269,
		-1,
		-1,
		-1,
		232,
		226,
		218,
		218,
		197,
		197,
		171,
		175,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		315,
		306,
		319,
		264,
		263,
		281,
		290,
		311,
		275,
		266,
		293,
		304,
		293,
		288,
		275,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		204,
		192,
		175,
		176,
		172,
		175,
		190,
		193,
		183,
		181,
		175,
		207,
		-1,
		308,
		307,
		296,
		293,
		269,
		260,
		255,
		282,
		-1,
		-1,
		277,
		294,
		288,
		292,
		308,
		333,
		-1,
		264,
		-1,
		-1,
		249,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		180,
		191,
		201,
		189,
		190,
		180,
		190,
		203,
		292,
		289,
		277,
		275,
		298,
		263,
		251,
		-1,
		264,
		262,
		268,
		275,
		292,
		322,
		-1,
		-1,
		280,
		260,
		-1,
		-1,
		232,
		230,
		219,
		-1,
		209,
		182,
		187,
		207,
		209,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		301,
		315,
		304,
		300,
		299,
		307,
		256,
		249,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		-1,
		270,
		266,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		200,
		204,
		196,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		335,
		-1,
		287,
		263,
		277,
		292,
		300,
		-1,
		-1,
		-1,
		287,
		273,
		266,
		254,
		252,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		275,
		278,
		-1,
		-1,
		277,
		279,
		-1,
		278,
		267,
		252,
		244,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		282,
		283,
		284,
		-1,
		262,
		-1,
		280,
		-1,
		247,
		253,
		241,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		223,
		221,
		212,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		280,
		254,
		287,
		278,
		261,
		241,
		233,
		252,
		-1,
		222,
		-1,
		197,
		199,
		225,
		228,
		234,
		228,
		201,
		216,
		206,
		197,
		206,
		286,
		-1,
		256,
		289,
		253,
		247,
		223,
		227,
		243,
		-1,
		219,
		201,
		-1,
		229,
		219,
		250,
		235,
		216,
		203,
		210,
		210,
		203,
		-1,
		-1,
		-1,
		258,
		257,
		249,
		243,
		243,
		228,
		219,
		-1,
		231,
		213,
		192,
		209,
		209,
		200,
		208,
		240,
		236,
		223,
		223,
		215,
		-1,
		359,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		252,
		247,
		220,
		208,
		214,
		210,
		196,
		202,
		204,
		212,
		210,
		207,
		219,
		215,
		235,
		216,
		251,
		-1,
		354,
		-1,
		288,
		-1,
		-1,
		270,
		250,
		242,
		231,
		220,
		218,
		209,
		200,
		222,
		238,
		222,
		220,
		223,
		224,
		-1,
		343,
		342,
		-1,
		289,
		281,
		267,
		-1,
		260,
		-1,
		266,
		227,
		-1,
		229,
		209,
		-1,
		231,
		227,
		-1,
		-1,
		330,
		305,
		-1,
		-1,
		-1,
		290,
		270,
		261,
		245,
		-1,
		220,
		220,
		-1,
		-1,
		-1,
		315,
		314,
		-1,
		283,
		286,
		-1,
		276,
		267,
		275,
		222,
		226,
		-1,
		-1,
		-1,
		324,
		305,
		299,
		298,
		296,
		291,
		288,
		274,
		258,
		236,
		225,
		246,
		-1,
		-1,
		-1,
		296,
		288,
		281,
		-1,
		-1,
		283,
		266,
		247,
		245,
		-1,
		-1,
		-1,
		318,
		299,
		-1,
		-1,
		273,
		-1,
		-1,
		279,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		335,
		307,
		-1,
		-1,
		-1,
		269,
		265,
		266,
		-1,
		-1,
		-1,
		-1,
		329,
		330,
		353,
		317,
		-1,
		-1,
		-1,
		261,
		255,
		-1,
		-1,
		332,
		330,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		259,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		294,
		-1,
		294,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		307,
		-1,
		279,
		281,
		-1,
		329,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		284,
		291,
		313,
		316,
		352,
		-1,
		303
	],
	[
		-1,
		91,
		80,
		91,
		99,
		72,
		79,
		-1,
		97,
		102,
		68,
		62,
		100,
		69,
		75,
		86,
		-1,
		-1,
		-1,
		91,
		90,
		57,
		55,
		64,
		69,
		76,
		-1,
		50,
		-1,
		112,
		91,
		102,
		107,
		50,
		47,
		44,
		55,
		42,
		38,
		127,
		80,
		51,
		45,
		32,
		11,
		36,
		28,
		-1,
		51,
		41,
		22,
		0,
		21,
		40,
		-1,
		-1,
		31,
		32,
		18,
		6,
		33,
		52,
		-1,
		84,
		98,
		-1,
		-1,
		35,
		37,
		25,
		22,
		26,
		49,
		76,
		93,
		98,
		-1,
		-1,
		33,
		27,
		30,
		27,
		31,
		63,
		82,
		93,
		107,
		106,
		-1,
		45,
		62,
		59,
		42,
		53,
		39,
		43,
		61,
		92,
		98,
		101,
		-1,
		62,
		58,
		65,
		63,
		58,
		55,
		42,
		48,
		67,
		80,
		99,
		90,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		63,
		54,
		71,
		73,
		75,
		74,
		74,
		45,
		51,
		55,
		72,
		88,
		89,
		99,
		-1,
		-1,
		156,
		129,
		153,
		111,
		93,
		-1,
		59,
		61,
		67,
		71,
		76,
		84,
		76,
		61,
		-1,
		66,
		65,
		96,
		82,
		93,
		138,
		-1,
		-1,
		114,
		106,
		88,
		91,
		68,
		64,
		76,
		75,
		71,
		73,
		75,
		84,
		69,
		82,
		89,
		60,
		70,
		74,
		89,
		100,
		-1,
		-1,
		174,
		-1,
		-1,
		135,
		118,
		-1,
		83,
		90,
		74,
		80,
		66,
		87,
		86,
		80,
		87,
		90,
		78,
		82,
		79,
		96,
		82,
		57,
		82,
		86,
		92,
		110,
		111,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		90,
		87,
		80,
		104,
		103,
		-1,
		109,
		107,
		113,
		98,
		103,
		99,
		84,
		87,
		82,
		82,
		79,
		64,
		66,
		103,
		94,
		115,
		112,
		143,
		149,
		143,
		152,
		-1,
		143,
		139,
		135,
		142,
		91,
		-1,
		-1,
		108,
		-1,
		111,
		124,
		121,
		109,
		112,
		99,
		107,
		106,
		90,
		93,
		80,
		77,
		76,
		72,
		81,
		91,
		90,
		108,
		121,
		136,
		140,
		146,
		-1,
		193,
		-1,
		135,
		119,
		121,
		97,
		125,
		-1,
		128,
		112,
		132,
		123,
		123,
		-1,
		115,
		112,
		122,
		105,
		90,
		92,
		80,
		75,
		75,
		79,
		94,
		85,
		103,
		110,
		118,
		122,
		142,
		154,
		153,
		143,
		-1,
		125,
		130,
		100,
		112,
		135,
		155,
		139,
		-1,
		134,
		-1,
		117,
		130,
		-1,
		111,
		107,
		96,
		88,
		77,
		84,
		82,
		76,
		73,
		91,
		94,
		111,
		115,
		131,
		-1,
		-1,
		138,
		142,
		150,
		101,
		120,
		144,
		181,
		148,
		141,
		140,
		-1,
		135,
		132,
		129,
		130,
		116,
		102,
		100,
		83,
		89,
		90,
		75,
		78,
		100,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		127,
		98,
		122,
		164,
		170,
		163,
		151,
		153,
		153,
		147,
		-1,
		141,
		120,
		111,
		100,
		90,
		106,
		96,
		99,
		79,
		81,
		97,
		109,
		100,
		120,
		-1,
		-1,
		-1,
		157,
		146,
		147,
		101,
		135,
		153,
		186,
		172,
		177,
		152,
		145,
		139,
		141,
		137,
		118,
		107,
		99,
		88,
		97,
		107,
		101,
		81,
		90,
		91,
		115,
		122,
		128,
		-1,
		-1,
		164,
		154,
		138,
		140,
		137,
		126,
		133,
		165,
		177,
		190,
		-1,
		144,
		-1,
		133,
		128,
		112,
		107,
		104,
		101,
		95,
		104,
		109,
		95,
		86,
		101,
		120,
		120,
		112,
		137,
		140,
		-1,
		-1,
		-1,
		157,
		174,
		149,
		126,
		107,
		143,
		-1,
		160,
		161,
		-1,
		138,
		132,
		129,
		114,
		110,
		105,
		109,
		102,
		109,
		105,
		104,
		105,
		87,
		123,
		-1,
		120,
		114,
		142,
		145,
		135,
		-1,
		-1,
		-1,
		172,
		151,
		144,
		164,
		114,
		166,
		-1,
		-1,
		145,
		138,
		-1,
		125,
		107,
		114,
		112,
		106,
		110,
		114,
		103,
		116,
		112,
		92,
		102,
		122,
		126,
		133,
		126,
		131,
		130,
		144,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		134,
		-1,
		154,
		146,
		136,
		130,
		124,
		120,
		118,
		134,
		118,
		121,
		121,
		117,
		125,
		110,
		109,
		95,
		99,
		117,
		144,
		139,
		134,
		133,
		140,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		149,
		-1,
		120,
		144,
		160,
		-1,
		162,
		141,
		156,
		134,
		130,
		126,
		141,
		142,
		120,
		125,
		124,
		134,
		131,
		120,
		107,
		111,
		126,
		136,
		128,
		129,
		138,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		123,
		124,
		147,
		-1,
		-1,
		198,
		-1,
		132,
		149,
		140,
		138,
		131,
		122,
		128,
		135,
		138,
		135,
		125,
		114,
		120,
		116,
		138,
		124,
		122,
		141,
		156,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		176,
		166,
		150,
		135,
		168,
		-1,
		139,
		123,
		128,
		-1,
		160,
		-1,
		133,
		133,
		124,
		113,
		110,
		121,
		119,
		130,
		147,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		180,
		-1,
		-1,
		163,
		157,
		157,
		141,
		144,
		155,
		135,
		129,
		128,
		155,
		150,
		141,
		122,
		115,
		112,
		113,
		126,
		146,
		137,
		149,
		-1,
		-1,
		-1,
		181,
		161,
		167,
		125,
		146,
		-1,
		-1,
		225,
		180,
		166,
		-1,
		150,
		172,
		160,
		150,
		140,
		174,
		166,
		141,
		134,
		120,
		122,
		120,
		122,
		127,
		148,
		149,
		162,
		-1,
		-1,
		158,
		165,
		153,
		139,
		158,
		-1,
		-1,
		-1,
		172,
		188,
		180,
		151,
		161,
		-1,
		-1,
		152,
		150,
		158,
		137,
		124,
		144,
		147,
		137,
		121,
		136,
		148,
		156,
		161,
		-1,
		161,
		148,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		183,
		178,
		182,
		155,
		-1,
		154,
		148,
		128,
		142,
		149,
		139,
		134,
		128,
		131,
		149,
		166,
		-1,
		-1,
		175,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		162,
		176,
		171,
		164,
		168,
		-1,
		156,
		144,
		130,
		147,
		152,
		149,
		140,
		132,
		137,
		134,
		147,
		161,
		165,
		198,
		-1,
		181,
		-1,
		-1,
		-1,
		180,
		195,
		210,
		187,
		160,
		155,
		148,
		142,
		138,
		154,
		160,
		171,
		139,
		135,
		136,
		140,
		139,
		156,
		166,
		-1,
		-1,
		181,
		198,
		206,
		188,
		192,
		237,
		-1,
		-1,
		164,
		155,
		146,
		149,
		148,
		151,
		145,
		142,
		147,
		152,
		140,
		149,
		167,
		166,
		-1,
		-1,
		-1,
		201,
		-1,
		216,
		-1,
		-1,
		207,
		235,
		182,
		164,
		160,
		158,
		151,
		160,
		155,
		150,
		160,
		162,
		154,
		142,
		146,
		169,
		158,
		197,
		-1,
		-1,
		318,
		-1,
		-1,
		-1,
		230,
		205,
		220,
		246,
		227,
		234,
		197,
		194,
		-1,
		164,
		189,
		161,
		168,
		159,
		166,
		166,
		158,
		136,
		143,
		159,
		158,
		153,
		189,
		180,
		186,
		-1,
		-1,
		311,
		300,
		289,
		295,
		-1,
		236,
		222,
		232,
		222,
		225,
		-1,
		-1,
		213,
		210,
		186,
		169,
		167,
		160,
		155,
		165,
		145,
		132,
		136,
		140,
		146,
		151,
		156,
		162,
		177,
		192,
		-1,
		206,
		287,
		280,
		263,
		271,
		302,
		-1,
		236,
		228,
		229,
		214,
		216,
		-1,
		-1,
		186,
		183,
		188,
		176,
		173,
		175,
		170,
		161,
		146,
		152,
		139,
		138,
		156,
		160,
		169,
		176,
		166,
		179,
		183,
		-1,
		220,
		263,
		257,
		260,
		284,
		298,
		-1,
		233,
		-1,
		-1,
		237,
		217,
		201,
		191,
		185,
		235,
		190,
		185,
		169,
		167,
		158,
		149,
		156,
		147,
		147,
		150,
		165,
		170,
		162,
		176,
		176,
		177,
		-1,
		255,
		243,
		251,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		253,
		-1,
		228,
		-1,
		203,
		207,
		198,
		201,
		183,
		170,
		162,
		154,
		170,
		145,
		155,
		151,
		152,
		161,
		172,
		184,
		183,
		184,
		304,
		260,
		251,
		242,
		285,
		300,
		304,
		-1,
		245,
		284,
		282,
		-1,
		262,
		-1,
		-1,
		-1,
		217,
		211,
		203,
		203,
		182,
		182,
		156,
		160,
		150,
		157,
		167,
		169,
		161,
		165,
		178,
		189,
		192,
		300,
		291,
		304,
		249,
		249,
		270,
		279,
		300,
		260,
		251,
		278,
		289,
		278,
		273,
		260,
		-1,
		-1,
		240,
		221,
		-1,
		-1,
		189,
		177,
		160,
		161,
		157,
		160,
		175,
		178,
		168,
		166,
		160,
		192,
		-1,
		293,
		292,
		281,
		278,
		254,
		245,
		240,
		267,
		-1,
		-1,
		262,
		279,
		273,
		277,
		293,
		318,
		-1,
		249,
		-1,
		-1,
		234,
		-1,
		-1,
		219,
		182,
		171,
		162,
		168,
		165,
		176,
		186,
		174,
		175,
		165,
		175,
		188,
		277,
		274,
		262,
		260,
		283,
		248,
		236,
		-1,
		249,
		247,
		253,
		260,
		277,
		307,
		-1,
		-1,
		265,
		245,
		-1,
		-1,
		217,
		215,
		204,
		-1,
		194,
		167,
		172,
		192,
		194,
		183,
		177,
		171,
		178,
		177,
		185,
		193,
		286,
		300,
		289,
		285,
		284,
		292,
		241,
		234,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		255,
		251,
		-1,
		-1,
		212,
		205,
		193,
		181,
		171,
		181,
		185,
		189,
		181,
		174,
		169,
		180,
		172,
		176,
		193,
		-1,
		320,
		-1,
		272,
		248,
		262,
		277,
		285,
		-1,
		-1,
		-1,
		272,
		258,
		251,
		239,
		237,
		-1,
		246,
		230,
		211,
		-1,
		181,
		194,
		225,
		193,
		198,
		193,
		175,
		186,
		175,
		178,
		192,
		187,
		-1,
		-1,
		260,
		263,
		-1,
		-1,
		262,
		264,
		-1,
		263,
		252,
		237,
		229,
		-1,
		-1,
		218,
		214,
		-1,
		-1,
		182,
		207,
		196,
		204,
		199,
		179,
		185,
		188,
		177,
		181,
		193,
		-1,
		-1,
		267,
		268,
		269,
		-1,
		247,
		-1,
		265,
		-1,
		232,
		238,
		226,
		-1,
		-1,
		-1,
		220,
		183,
		204,
		214,
		208,
		206,
		197,
		183,
		190,
		188,
		184,
		195,
		-1,
		-1,
		-1,
		265,
		239,
		272,
		263,
		246,
		226,
		218,
		237,
		-1,
		207,
		-1,
		182,
		184,
		210,
		213,
		219,
		213,
		186,
		201,
		191,
		182,
		191,
		271,
		-1,
		241,
		274,
		238,
		232,
		208,
		212,
		228,
		-1,
		204,
		186,
		-1,
		214,
		204,
		235,
		220,
		201,
		188,
		195,
		195,
		188,
		-1,
		-1,
		-1,
		243,
		242,
		234,
		228,
		228,
		213,
		204,
		-1,
		216,
		198,
		177,
		194,
		194,
		185,
		193,
		225,
		221,
		208,
		208,
		200,
		-1,
		344,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		237,
		232,
		205,
		193,
		199,
		195,
		181,
		187,
		189,
		197,
		195,
		192,
		204,
		200,
		220,
		201,
		236,
		-1,
		339,
		-1,
		273,
		-1,
		-1,
		255,
		235,
		227,
		216,
		205,
		203,
		194,
		185,
		207,
		223,
		207,
		205,
		208,
		209,
		-1,
		328,
		327,
		-1,
		274,
		266,
		252,
		-1,
		245,
		-1,
		251,
		212,
		-1,
		214,
		194,
		-1,
		216,
		212,
		-1,
		-1,
		315,
		290,
		-1,
		-1,
		-1,
		275,
		255,
		246,
		230,
		-1,
		205,
		205,
		-1,
		-1,
		-1,
		300,
		299,
		-1,
		268,
		271,
		-1,
		261,
		252,
		260,
		207,
		211,
		-1,
		-1,
		-1,
		309,
		290,
		284,
		283,
		281,
		276,
		273,
		259,
		243,
		221,
		210,
		231,
		-1,
		-1,
		-1,
		281,
		273,
		266,
		-1,
		-1,
		268,
		251,
		232,
		230,
		-1,
		-1,
		-1,
		303,
		284,
		-1,
		-1,
		258,
		-1,
		-1,
		264,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		292,
		-1,
		-1,
		-1,
		254,
		250,
		251,
		-1,
		-1,
		-1,
		-1,
		314,
		315,
		338,
		302,
		-1,
		-1,
		-1,
		246,
		240,
		-1,
		-1,
		317,
		315,
		-1,
		-1,
		-1,
		274,
		258,
		-1,
		244,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		279,
		-1,
		279,
		254,
		261,
		-1,
		-1,
		-1,
		-1,
		292,
		284,
		292,
		-1,
		264,
		266,
		-1,
		314,
		-1,
		-1,
		307,
		298,
		-1,
		-1,
		269,
		276,
		298,
		301,
		337,
		-1,
		288
	],
	[
		-1,
		103,
		92,
		103,
		111,
		84,
		91,
		-1,
		109,
		114,
		80,
		74,
		112,
		81,
		87,
		98,
		-1,
		-1,
		-1,
		103,
		102,
		69,
		67,
		76,
		81,
		88,
		-1,
		29,
		-1,
		124,
		103,
		114,
		119,
		62,
		59,
		63,
		44,
		21,
		17,
		139,
		92,
		63,
		57,
		51,
		30,
		15,
		7,
		-1,
		63,
		53,
		41,
		19,
		0,
		24,
		-1,
		-1,
		43,
		44,
		30,
		13,
		31,
		36,
		-1,
		88,
		82,
		-1,
		-1,
		47,
		46,
		34,
		31,
		24,
		47,
		80,
		97,
		87,
		-1,
		-1,
		42,
		36,
		39,
		36,
		40,
		72,
		86,
		99,
		102,
		104,
		-1,
		54,
		71,
		68,
		51,
		52,
		48,
		52,
		70,
		101,
		107,
		110,
		-1,
		71,
		67,
		74,
		72,
		67,
		53,
		51,
		57,
		76,
		89,
		108,
		99,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		72,
		63,
		80,
		82,
		84,
		74,
		72,
		54,
		60,
		64,
		81,
		97,
		98,
		108,
		-1,
		-1,
		165,
		138,
		162,
		120,
		102,
		-1,
		68,
		70,
		76,
		80,
		85,
		93,
		74,
		70,
		-1,
		75,
		74,
		105,
		91,
		102,
		147,
		-1,
		-1,
		123,
		115,
		97,
		100,
		77,
		73,
		85,
		84,
		80,
		82,
		84,
		93,
		78,
		91,
		98,
		69,
		79,
		83,
		98,
		109,
		-1,
		-1,
		183,
		-1,
		-1,
		144,
		127,
		-1,
		92,
		99,
		83,
		89,
		75,
		96,
		95,
		89,
		96,
		99,
		87,
		91,
		88,
		105,
		91,
		66,
		91,
		95,
		101,
		119,
		120,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		99,
		96,
		89,
		113,
		112,
		-1,
		118,
		116,
		122,
		107,
		112,
		108,
		93,
		96,
		91,
		91,
		88,
		73,
		75,
		112,
		103,
		124,
		121,
		152,
		158,
		152,
		161,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		117,
		-1,
		120,
		133,
		130,
		118,
		121,
		108,
		116,
		115,
		99,
		102,
		89,
		86,
		85,
		81,
		90,
		100,
		99,
		117,
		130,
		145,
		149,
		155,
		-1,
		202,
		-1,
		144,
		128,
		130,
		106,
		134,
		-1,
		137,
		121,
		141,
		132,
		132,
		-1,
		124,
		121,
		131,
		114,
		99,
		101,
		89,
		84,
		84,
		88,
		103,
		94,
		112,
		119,
		127,
		131,
		151,
		163,
		162,
		152,
		-1,
		134,
		139,
		109,
		121,
		144,
		164,
		148,
		-1,
		143,
		-1,
		126,
		139,
		-1,
		120,
		116,
		105,
		97,
		86,
		93,
		91,
		85,
		82,
		100,
		103,
		120,
		124,
		140,
		-1,
		-1,
		147,
		151,
		159,
		110,
		129,
		153,
		190,
		157,
		150,
		149,
		-1,
		144,
		141,
		138,
		139,
		125,
		111,
		109,
		92,
		98,
		99,
		84,
		87,
		109,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		136,
		107,
		131,
		173,
		179,
		172,
		160,
		162,
		162,
		156,
		-1,
		150,
		129,
		120,
		109,
		99,
		115,
		105,
		108,
		88,
		90,
		106,
		118,
		109,
		129,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		110,
		144,
		162,
		195,
		181,
		186,
		161,
		154,
		148,
		150,
		146,
		127,
		116,
		108,
		97,
		106,
		116,
		110,
		90,
		99,
		100,
		124,
		131,
		137,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		135,
		142,
		174,
		186,
		199,
		-1,
		153,
		-1,
		142,
		137,
		121,
		116,
		113,
		110,
		104,
		113,
		118,
		104,
		95,
		110,
		129,
		129,
		121,
		146,
		149,
		-1,
		-1,
		-1,
		166,
		183,
		158,
		135,
		116,
		152,
		-1,
		169,
		170,
		-1,
		147,
		141,
		138,
		123,
		119,
		114,
		118,
		111,
		118,
		114,
		113,
		114,
		96,
		132,
		-1,
		129,
		123,
		151,
		154,
		144,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		123,
		175,
		-1,
		-1,
		154,
		147,
		-1,
		134,
		116,
		123,
		121,
		115,
		119,
		123,
		112,
		125,
		121,
		101,
		111,
		131,
		135,
		142,
		135,
		140,
		139,
		153,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		143,
		-1,
		163,
		155,
		145,
		139,
		133,
		129,
		127,
		143,
		127,
		130,
		130,
		126,
		134,
		119,
		118,
		104,
		108,
		126,
		153,
		148,
		143,
		142,
		149,
		-1,
		229,
		215,
		186,
		-1,
		-1,
		158,
		-1,
		129,
		153,
		169,
		-1,
		171,
		150,
		165,
		143,
		139,
		135,
		150,
		151,
		129,
		134,
		133,
		143,
		140,
		129,
		116,
		120,
		135,
		145,
		137,
		138,
		147,
		-1,
		235,
		222,
		180,
		176,
		165,
		185,
		132,
		133,
		156,
		-1,
		-1,
		207,
		-1,
		141,
		158,
		149,
		147,
		140,
		131,
		137,
		144,
		147,
		144,
		134,
		123,
		129,
		125,
		147,
		133,
		131,
		150,
		165,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		151,
		138,
		132,
		-1,
		173,
		-1,
		185,
		175,
		159,
		144,
		177,
		-1,
		148,
		132,
		137,
		-1,
		169,
		-1,
		142,
		142,
		133,
		122,
		119,
		130,
		128,
		139,
		156,
		-1,
		185,
		170,
		163,
		153,
		167,
		138,
		-1,
		189,
		-1,
		-1,
		172,
		166,
		166,
		150,
		153,
		164,
		144,
		138,
		137,
		164,
		159,
		150,
		131,
		124,
		121,
		122,
		135,
		155,
		146,
		158,
		-1,
		-1,
		-1,
		190,
		170,
		176,
		134,
		155,
		-1,
		-1,
		234,
		189,
		175,
		-1,
		159,
		181,
		169,
		159,
		149,
		183,
		175,
		150,
		143,
		129,
		131,
		129,
		131,
		136,
		157,
		158,
		171,
		-1,
		-1,
		167,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		181,
		197,
		189,
		160,
		170,
		-1,
		-1,
		161,
		159,
		167,
		146,
		133,
		153,
		156,
		146,
		130,
		145,
		157,
		165,
		170,
		-1,
		170,
		157,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		214,
		180,
		192,
		187,
		191,
		164,
		-1,
		163,
		157,
		137,
		151,
		158,
		148,
		143,
		137,
		140,
		158,
		175,
		-1,
		-1,
		184,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		171,
		185,
		180,
		173,
		177,
		-1,
		165,
		153,
		139,
		156,
		161,
		158,
		149,
		141,
		146,
		143,
		156,
		170,
		174,
		207,
		-1,
		190,
		-1,
		-1,
		-1,
		189,
		204,
		219,
		196,
		169,
		164,
		157,
		151,
		147,
		163,
		169,
		180,
		148,
		144,
		145,
		149,
		148,
		165,
		175,
		-1,
		-1,
		190,
		207,
		215,
		197,
		201,
		246,
		-1,
		-1,
		173,
		164,
		155,
		158,
		157,
		160,
		154,
		151,
		156,
		161,
		149,
		158,
		176,
		175,
		-1,
		-1,
		-1,
		210,
		-1,
		225,
		-1,
		-1,
		216,
		244,
		191,
		173,
		169,
		167,
		160,
		169,
		164,
		159,
		169,
		171,
		163,
		151,
		155,
		178,
		167,
		206,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		239,
		214,
		229,
		255,
		236,
		243,
		206,
		203,
		-1,
		173,
		198,
		170,
		177,
		168,
		175,
		175,
		167,
		145,
		152,
		168,
		167,
		162,
		198,
		189,
		195,
		-1,
		-1,
		320,
		309,
		298,
		304,
		-1,
		245,
		231,
		241,
		231,
		234,
		-1,
		-1,
		222,
		219,
		195,
		178,
		176,
		169,
		164,
		174,
		154,
		141,
		145,
		149,
		155,
		160,
		165,
		171,
		186,
		201,
		-1,
		215,
		296,
		289,
		272,
		280,
		311,
		-1,
		245,
		237,
		238,
		223,
		225,
		-1,
		-1,
		195,
		192,
		197,
		185,
		182,
		184,
		179,
		170,
		155,
		161,
		148,
		147,
		165,
		169,
		178,
		185,
		175,
		188,
		192,
		-1,
		229,
		272,
		266,
		269,
		293,
		307,
		-1,
		242,
		-1,
		-1,
		246,
		226,
		210,
		200,
		194,
		244,
		199,
		194,
		178,
		176,
		167,
		158,
		165,
		156,
		156,
		159,
		174,
		179,
		171,
		185,
		185,
		186,
		-1,
		264,
		252,
		260,
		-1,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		262,
		-1,
		237,
		-1,
		212,
		216,
		207,
		210,
		192,
		179,
		171,
		163,
		179,
		154,
		164,
		160,
		161,
		170,
		181,
		193,
		192,
		193,
		313,
		269,
		260,
		251,
		294,
		309,
		313,
		-1,
		254,
		293,
		291,
		-1,
		271,
		-1,
		-1,
		-1,
		226,
		220,
		212,
		212,
		191,
		191,
		165,
		169,
		159,
		166,
		176,
		178,
		170,
		174,
		187,
		198,
		201,
		309,
		300,
		313,
		258,
		258,
		279,
		288,
		309,
		269,
		260,
		287,
		298,
		287,
		282,
		269,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		198,
		186,
		169,
		170,
		166,
		169,
		184,
		187,
		177,
		175,
		169,
		201,
		-1,
		302,
		301,
		290,
		287,
		263,
		254,
		249,
		276,
		-1,
		-1,
		271,
		288,
		282,
		286,
		302,
		327,
		-1,
		258,
		-1,
		-1,
		243,
		-1,
		-1,
		228,
		191,
		180,
		171,
		177,
		174,
		185,
		195,
		183,
		184,
		174,
		184,
		197,
		286,
		283,
		271,
		269,
		292,
		257,
		245,
		-1,
		258,
		256,
		262,
		269,
		286,
		316,
		-1,
		-1,
		274,
		254,
		-1,
		-1,
		226,
		224,
		213,
		-1,
		203,
		176,
		181,
		201,
		203,
		192,
		186,
		180,
		187,
		186,
		194,
		202,
		295,
		309,
		298,
		294,
		293,
		301,
		250,
		243,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		-1,
		264,
		260,
		-1,
		-1,
		221,
		214,
		202,
		190,
		180,
		190,
		194,
		198,
		190,
		183,
		178,
		189,
		181,
		185,
		202,
		-1,
		329,
		-1,
		281,
		257,
		271,
		286,
		294,
		-1,
		-1,
		-1,
		281,
		267,
		260,
		248,
		246,
		-1,
		255,
		239,
		220,
		-1,
		190,
		203,
		234,
		202,
		207,
		202,
		184,
		195,
		184,
		187,
		201,
		196,
		-1,
		-1,
		269,
		272,
		-1,
		-1,
		271,
		273,
		-1,
		272,
		261,
		246,
		238,
		-1,
		-1,
		227,
		223,
		-1,
		-1,
		191,
		216,
		205,
		213,
		208,
		188,
		194,
		197,
		186,
		190,
		202,
		-1,
		-1,
		276,
		277,
		278,
		-1,
		256,
		-1,
		274,
		-1,
		241,
		247,
		235,
		-1,
		-1,
		-1,
		229,
		192,
		213,
		223,
		217,
		215,
		206,
		192,
		199,
		197,
		193,
		204,
		-1,
		-1,
		-1,
		274,
		248,
		281,
		272,
		255,
		235,
		227,
		246,
		-1,
		216,
		-1,
		191,
		193,
		219,
		222,
		228,
		222,
		195,
		210,
		200,
		191,
		200,
		280,
		-1,
		250,
		283,
		247,
		241,
		217,
		221,
		237,
		-1,
		213,
		195,
		-1,
		223,
		213,
		244,
		229,
		210,
		197,
		204,
		204,
		197,
		-1,
		-1,
		-1,
		252,
		251,
		243,
		237,
		237,
		222,
		213,
		-1,
		225,
		207,
		186,
		203,
		203,
		194,
		202,
		234,
		230,
		217,
		217,
		209,
		-1,
		353,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		246,
		241,
		214,
		202,
		208,
		204,
		190,
		196,
		198,
		206,
		204,
		201,
		213,
		209,
		229,
		210,
		245,
		-1,
		348,
		-1,
		282,
		-1,
		-1,
		264,
		244,
		236,
		225,
		214,
		212,
		203,
		194,
		216,
		232,
		216,
		214,
		217,
		218,
		-1,
		337,
		336,
		-1,
		283,
		275,
		261,
		-1,
		254,
		-1,
		260,
		221,
		-1,
		223,
		203,
		-1,
		225,
		221,
		-1,
		-1,
		324,
		299,
		-1,
		-1,
		-1,
		284,
		264,
		255,
		239,
		-1,
		214,
		214,
		-1,
		-1,
		-1,
		309,
		308,
		-1,
		277,
		280,
		-1,
		270,
		261,
		269,
		216,
		220,
		-1,
		-1,
		-1,
		318,
		299,
		293,
		292,
		290,
		285,
		282,
		268,
		252,
		230,
		219,
		240,
		-1,
		-1,
		-1,
		290,
		282,
		275,
		-1,
		-1,
		277,
		260,
		241,
		239,
		-1,
		-1,
		-1,
		312,
		293,
		-1,
		-1,
		267,
		-1,
		-1,
		273,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		329,
		301,
		-1,
		-1,
		-1,
		263,
		259,
		260,
		-1,
		-1,
		-1,
		-1,
		323,
		324,
		347,
		311,
		-1,
		-1,
		-1,
		255,
		249,
		-1,
		-1,
		326,
		324,
		-1,
		-1,
		-1,
		283,
		267,
		-1,
		253,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		288,
		-1,
		288,
		263,
		270,
		-1,
		-1,
		-1,
		-1,
		301,
		293,
		301,
		-1,
		273,
		275,
		-1,
		323,
		-1,
		-1,
		316,
		307,
		-1,
		-1,
		278,
		285,
		307,
		310,
		346,
		-1,
		297
	],
	[
		-1,
		104,
		93,
		104,
		112,
		85,
		92,
		-1,
		113,
		115,
		81,
		75,
		114,
		85,
		91,
		102,
		-1,
		-1,
		-1,
		104,
		103,
		73,
		71,
		80,
		85,
		92,
		-1,
		39,
		-1,
		125,
		104,
		115,
		120,
		66,
		63,
		76,
		51,
		32,
		24,
		140,
		96,
		67,
		61,
		69,
		48,
		26,
		18,
		-1,
		67,
		57,
		59,
		37,
		24,
		0,
		-1,
		-1,
		61,
		62,
		48,
		31,
		24,
		12,
		-1,
		67,
		58,
		-1,
		-1,
		51,
		52,
		36,
		21,
		10,
		26,
		59,
		76,
		63,
		-1,
		-1,
		44,
		38,
		45,
		28,
		32,
		56,
		65,
		75,
		78,
		80,
		-1,
		40,
		58,
		67,
		43,
		30,
		32,
		36,
		54,
		80,
		89,
		89,
		-1,
		57,
		53,
		63,
		66,
		61,
		31,
		35,
		41,
		60,
		71,
		92,
		83,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		58,
		49,
		69,
		71,
		70,
		52,
		50,
		38,
		44,
		48,
		65,
		81,
		82,
		92,
		-1,
		-1,
		151,
		124,
		148,
		106,
		88,
		-1,
		54,
		56,
		62,
		66,
		69,
		77,
		52,
		54,
		-1,
		59,
		58,
		89,
		75,
		86,
		133,
		-1,
		-1,
		109,
		101,
		83,
		86,
		63,
		59,
		71,
		70,
		66,
		68,
		70,
		77,
		62,
		75,
		82,
		53,
		63,
		67,
		82,
		93,
		-1,
		-1,
		167,
		-1,
		-1,
		130,
		113,
		-1,
		78,
		85,
		69,
		75,
		61,
		82,
		81,
		75,
		82,
		85,
		73,
		75,
		72,
		89,
		75,
		50,
		75,
		79,
		85,
		103,
		104,
		-1,
		166,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		85,
		82,
		75,
		99,
		98,
		-1,
		104,
		102,
		108,
		93,
		98,
		94,
		79,
		80,
		75,
		75,
		72,
		57,
		59,
		96,
		87,
		108,
		105,
		136,
		142,
		136,
		145,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		103,
		-1,
		106,
		119,
		116,
		104,
		107,
		94,
		102,
		101,
		85,
		86,
		73,
		70,
		69,
		65,
		74,
		84,
		83,
		101,
		114,
		129,
		133,
		139,
		-1,
		188,
		-1,
		130,
		114,
		116,
		92,
		120,
		-1,
		123,
		107,
		127,
		118,
		118,
		-1,
		110,
		107,
		117,
		100,
		85,
		85,
		73,
		68,
		68,
		72,
		87,
		78,
		96,
		103,
		111,
		115,
		135,
		147,
		148,
		138,
		-1,
		120,
		125,
		95,
		107,
		130,
		150,
		134,
		-1,
		129,
		-1,
		112,
		125,
		-1,
		106,
		102,
		91,
		81,
		70,
		77,
		75,
		69,
		66,
		84,
		87,
		104,
		108,
		124,
		-1,
		-1,
		133,
		137,
		145,
		96,
		115,
		139,
		176,
		143,
		136,
		135,
		-1,
		130,
		127,
		124,
		123,
		110,
		95,
		93,
		76,
		82,
		83,
		68,
		71,
		93,
		121,
		99,
		111,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		122,
		93,
		117,
		159,
		165,
		158,
		146,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		83,
		99,
		89,
		92,
		72,
		74,
		90,
		102,
		93,
		113,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		96,
		130,
		148,
		179,
		165,
		170,
		145,
		138,
		132,
		136,
		130,
		111,
		100,
		92,
		81,
		90,
		100,
		94,
		74,
		83,
		84,
		108,
		115,
		121,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		121,
		128,
		160,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		88,
		97,
		102,
		88,
		79,
		94,
		113,
		113,
		105,
		130,
		133,
		-1,
		-1,
		-1,
		152,
		169,
		144,
		121,
		102,
		138,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		102,
		98,
		97,
		98,
		80,
		116,
		-1,
		113,
		107,
		135,
		138,
		128,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		109,
		161,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		107,
		96,
		109,
		105,
		85,
		95,
		115,
		119,
		126,
		119,
		124,
		123,
		137,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		129,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		114,
		110,
		118,
		103,
		102,
		88,
		92,
		110,
		137,
		132,
		127,
		126,
		133,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		144,
		-1,
		115,
		139,
		155,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		118,
		117,
		127,
		124,
		113,
		100,
		104,
		119,
		129,
		121,
		122,
		131,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		118,
		117,
		142,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		115,
		121,
		128,
		131,
		128,
		118,
		107,
		113,
		109,
		131,
		117,
		115,
		134,
		149,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		132,
		116,
		121,
		-1,
		153,
		-1,
		126,
		126,
		117,
		106,
		103,
		114,
		112,
		123,
		140,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		175,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		148,
		128,
		122,
		121,
		148,
		143,
		134,
		115,
		108,
		105,
		106,
		119,
		139,
		130,
		142,
		-1,
		-1,
		-1,
		176,
		156,
		162,
		120,
		141,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		165,
		153,
		143,
		133,
		167,
		159,
		134,
		127,
		113,
		115,
		113,
		115,
		120,
		141,
		142,
		155,
		-1,
		-1,
		153,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		154,
		-1,
		-1,
		145,
		143,
		151,
		130,
		117,
		137,
		140,
		130,
		114,
		129,
		141,
		149,
		154,
		-1,
		156,
		143,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		176,
		171,
		175,
		148,
		-1,
		147,
		141,
		121,
		135,
		142,
		132,
		127,
		121,
		124,
		142,
		159,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		155,
		169,
		164,
		157,
		161,
		-1,
		149,
		137,
		123,
		140,
		145,
		142,
		133,
		125,
		130,
		127,
		140,
		154,
		158,
		193,
		-1,
		176,
		-1,
		-1,
		-1,
		173,
		188,
		203,
		180,
		153,
		148,
		141,
		135,
		131,
		147,
		153,
		164,
		132,
		128,
		129,
		133,
		132,
		149,
		159,
		-1,
		-1,
		176,
		193,
		199,
		181,
		185,
		230,
		-1,
		-1,
		157,
		148,
		139,
		142,
		141,
		144,
		138,
		135,
		140,
		145,
		133,
		142,
		160,
		159,
		-1,
		-1,
		-1,
		196,
		-1,
		211,
		-1,
		-1,
		200,
		228,
		175,
		157,
		153,
		151,
		144,
		153,
		148,
		143,
		153,
		155,
		147,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		225,
		200,
		215,
		239,
		220,
		227,
		190,
		187,
		-1,
		157,
		182,
		154,
		161,
		152,
		159,
		159,
		151,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		231,
		217,
		225,
		215,
		218,
		-1,
		-1,
		206,
		203,
		179,
		162,
		160,
		153,
		148,
		158,
		138,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		201,
		282,
		275,
		258,
		266,
		297,
		-1,
		229,
		221,
		224,
		207,
		209,
		-1,
		-1,
		179,
		176,
		181,
		169,
		166,
		168,
		163,
		154,
		139,
		145,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		215,
		258,
		252,
		255,
		279,
		293,
		-1,
		226,
		-1,
		-1,
		232,
		210,
		194,
		184,
		178,
		228,
		183,
		178,
		162,
		160,
		151,
		142,
		149,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		250,
		238,
		246,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		248,
		-1,
		221,
		-1,
		196,
		200,
		191,
		194,
		176,
		163,
		155,
		147,
		163,
		138,
		148,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		297,
		253,
		246,
		237,
		278,
		293,
		297,
		-1,
		238,
		277,
		275,
		-1,
		257,
		-1,
		-1,
		-1,
		210,
		204,
		196,
		196,
		175,
		175,
		149,
		153,
		143,
		150,
		160,
		162,
		154,
		158,
		171,
		182,
		185,
		293,
		284,
		297,
		242,
		242,
		263,
		272,
		293,
		253,
		244,
		271,
		282,
		271,
		266,
		253,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		182,
		170,
		153,
		154,
		150,
		153,
		168,
		171,
		161,
		159,
		153,
		185,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		260,
		-1,
		-1,
		255,
		272,
		266,
		270,
		286,
		311,
		-1,
		242,
		-1,
		-1,
		227,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		158,
		169,
		179,
		167,
		168,
		158,
		168,
		181,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		242,
		240,
		246,
		253,
		270,
		300,
		-1,
		-1,
		258,
		238,
		-1,
		-1,
		210,
		208,
		197,
		-1,
		187,
		160,
		165,
		185,
		187,
		176,
		170,
		164,
		171,
		170,
		178,
		186,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		244,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		178,
		182,
		174,
		167,
		162,
		173,
		165,
		169,
		186,
		-1,
		313,
		-1,
		265,
		241,
		255,
		270,
		278,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		168,
		179,
		168,
		171,
		185,
		180,
		-1,
		-1,
		253,
		256,
		-1,
		-1,
		255,
		257,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		172,
		178,
		181,
		170,
		174,
		186,
		-1,
		-1,
		260,
		261,
		262,
		-1,
		240,
		-1,
		258,
		-1,
		225,
		231,
		219,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		201,
		199,
		190,
		176,
		183,
		181,
		177,
		188,
		-1,
		-1,
		-1,
		258,
		232,
		265,
		256,
		239,
		219,
		211,
		230,
		-1,
		200,
		-1,
		175,
		177,
		203,
		206,
		212,
		206,
		179,
		194,
		184,
		175,
		184,
		264,
		-1,
		234,
		267,
		231,
		225,
		201,
		205,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		228,
		213,
		194,
		181,
		188,
		188,
		181,
		-1,
		-1,
		-1,
		236,
		235,
		227,
		221,
		221,
		206,
		197,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		218,
		214,
		201,
		201,
		193,
		-1,
		337,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		230,
		225,
		198,
		186,
		192,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		194,
		229,
		-1,
		332,
		-1,
		266,
		-1,
		-1,
		248,
		228,
		220,
		209,
		198,
		196,
		187,
		178,
		200,
		216,
		200,
		198,
		201,
		202,
		-1,
		321,
		320,
		-1,
		267,
		259,
		245,
		-1,
		238,
		-1,
		244,
		205,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		308,
		283,
		-1,
		-1,
		-1,
		268,
		248,
		239,
		223,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		293,
		292,
		-1,
		261,
		264,
		-1,
		254,
		245,
		253,
		200,
		204,
		-1,
		-1,
		-1,
		302,
		283,
		277,
		276,
		274,
		269,
		266,
		252,
		236,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		274,
		266,
		259,
		-1,
		-1,
		261,
		244,
		225,
		223,
		-1,
		-1,
		-1,
		296,
		277,
		-1,
		-1,
		251,
		-1,
		-1,
		257,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		285,
		-1,
		-1,
		-1,
		247,
		243,
		244,
		-1,
		-1,
		-1,
		-1,
		307,
		308,
		331,
		295,
		-1,
		-1,
		-1,
		239,
		233,
		-1,
		-1,
		310,
		308,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		237,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		272,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		262,
		269,
		291,
		294,
		330,
		-1,
		281
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		60,
		49,
		60,
		68,
		41,
		48,
		-1,
		66,
		71,
		37,
		31,
		69,
		38,
		44,
		55,
		-1,
		-1,
		-1,
		60,
		59,
		26,
		24,
		33,
		38,
		45,
		-1,
		79,
		-1,
		81,
		60,
		71,
		76,
		19,
		16,
		36,
		52,
		72,
		68,
		96,
		49,
		20,
		14,
		29,
		37,
		66,
		58,
		-1,
		20,
		10,
		29,
		36,
		51,
		55,
		-1,
		-1,
		0,
		15,
		21,
		36,
		55,
		61,
		-1,
		71,
		90,
		-1,
		-1,
		4,
		17,
		30,
		33,
		41,
		50,
		63,
		80,
		85,
		-1,
		-1,
		22,
		26,
		36,
		37,
		33,
		50,
		69,
		80,
		94,
		93,
		-1,
		24,
		42,
		51,
		44,
		42,
		26,
		30,
		48,
		79,
		85,
		88,
		-1,
		41,
		37,
		47,
		53,
		64,
		42,
		29,
		35,
		54,
		67,
		86,
		77,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		76,
		42,
		33,
		53,
		55,
		54,
		63,
		61,
		32,
		38,
		42,
		59,
		75,
		76,
		86,
		-1,
		-1,
		135,
		108,
		132,
		90,
		72,
		-1,
		38,
		40,
		46,
		50,
		55,
		63,
		63,
		48,
		-1,
		53,
		52,
		83,
		69,
		80,
		117,
		-1,
		-1,
		93,
		85,
		67,
		70,
		47,
		43,
		55,
		54,
		50,
		52,
		54,
		66,
		56,
		69,
		76,
		47,
		57,
		61,
		76,
		87,
		-1,
		-1,
		161,
		-1,
		-1,
		114,
		97,
		-1,
		62,
		69,
		53,
		59,
		45,
		66,
		65,
		59,
		66,
		69,
		57,
		69,
		66,
		83,
		69,
		44,
		69,
		73,
		79,
		97,
		98,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		69,
		66,
		59,
		83,
		82,
		-1,
		88,
		86,
		92,
		77,
		82,
		78,
		63,
		74,
		69,
		69,
		66,
		51,
		53,
		90,
		81,
		102,
		99,
		130,
		136,
		130,
		139,
		-1,
		122,
		118,
		114,
		121,
		70,
		-1,
		-1,
		87,
		-1,
		90,
		103,
		100,
		88,
		91,
		78,
		86,
		85,
		69,
		80,
		67,
		64,
		63,
		59,
		68,
		78,
		77,
		95,
		108,
		123,
		127,
		133,
		-1,
		172,
		-1,
		114,
		98,
		100,
		76,
		104,
		-1,
		107,
		91,
		111,
		102,
		102,
		-1,
		94,
		91,
		101,
		84,
		69,
		79,
		67,
		62,
		62,
		66,
		81,
		72,
		90,
		97,
		105,
		109,
		129,
		141,
		132,
		122,
		-1,
		104,
		109,
		79,
		91,
		114,
		134,
		118,
		-1,
		113,
		-1,
		96,
		109,
		-1,
		90,
		86,
		75,
		75,
		64,
		71,
		69,
		63,
		60,
		78,
		81,
		98,
		102,
		118,
		-1,
		-1,
		117,
		121,
		129,
		80,
		99,
		123,
		160,
		127,
		120,
		119,
		-1,
		114,
		111,
		108,
		109,
		95,
		88,
		87,
		70,
		76,
		77,
		62,
		65,
		87,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		106,
		77,
		101,
		143,
		149,
		142,
		130,
		140,
		140,
		134,
		-1,
		126,
		105,
		98,
		87,
		77,
		93,
		83,
		86,
		66,
		68,
		84,
		96,
		87,
		107,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		80,
		114,
		132,
		173,
		159,
		164,
		139,
		132,
		126,
		120,
		122,
		105,
		94,
		86,
		75,
		84,
		94,
		88,
		68,
		77,
		78,
		102,
		109,
		115,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		105,
		112,
		144,
		164,
		177,
		-1,
		131,
		-1,
		120,
		115,
		99,
		94,
		91,
		88,
		82,
		91,
		96,
		82,
		73,
		88,
		107,
		107,
		99,
		124,
		127,
		-1,
		-1,
		-1,
		136,
		153,
		128,
		105,
		86,
		122,
		-1,
		147,
		148,
		-1,
		125,
		119,
		116,
		101,
		97,
		92,
		96,
		89,
		96,
		92,
		91,
		92,
		74,
		110,
		-1,
		107,
		101,
		129,
		132,
		122,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		93,
		145,
		-1,
		-1,
		132,
		125,
		-1,
		112,
		94,
		101,
		99,
		93,
		97,
		101,
		90,
		103,
		99,
		79,
		89,
		109,
		113,
		120,
		113,
		118,
		117,
		131,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		113,
		-1,
		141,
		133,
		123,
		117,
		111,
		107,
		105,
		121,
		105,
		108,
		108,
		104,
		112,
		97,
		96,
		82,
		86,
		104,
		131,
		126,
		121,
		120,
		127,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		128,
		-1,
		99,
		123,
		139,
		-1,
		149,
		128,
		143,
		121,
		117,
		113,
		128,
		129,
		107,
		112,
		111,
		121,
		118,
		107,
		94,
		98,
		113,
		123,
		115,
		116,
		125,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		102,
		111,
		126,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		127,
		125,
		118,
		109,
		115,
		122,
		125,
		122,
		112,
		101,
		107,
		103,
		125,
		111,
		109,
		128,
		143,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		126,
		110,
		115,
		-1,
		147,
		-1,
		120,
		120,
		111,
		100,
		97,
		108,
		106,
		117,
		134,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		159,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		142,
		122,
		116,
		115,
		142,
		137,
		128,
		109,
		102,
		99,
		100,
		113,
		133,
		124,
		136,
		-1,
		-1,
		-1,
		160,
		140,
		146,
		104,
		125,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		137,
		159,
		147,
		137,
		127,
		161,
		153,
		128,
		121,
		107,
		109,
		107,
		109,
		114,
		135,
		136,
		149,
		-1,
		-1,
		137,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		159,
		175,
		167,
		138,
		148,
		-1,
		-1,
		139,
		137,
		145,
		124,
		111,
		131,
		134,
		124,
		108,
		123,
		135,
		143,
		148,
		-1,
		140,
		127,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		170,
		165,
		169,
		142,
		-1,
		141,
		135,
		115,
		129,
		136,
		126,
		121,
		115,
		118,
		136,
		153,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		149,
		163,
		158,
		151,
		155,
		-1,
		143,
		131,
		117,
		134,
		139,
		136,
		127,
		119,
		124,
		121,
		134,
		148,
		152,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		167,
		182,
		197,
		174,
		147,
		142,
		135,
		129,
		125,
		141,
		147,
		158,
		126,
		122,
		123,
		127,
		126,
		143,
		153,
		-1,
		-1,
		160,
		177,
		193,
		175,
		179,
		224,
		-1,
		-1,
		151,
		142,
		133,
		136,
		135,
		138,
		132,
		129,
		134,
		139,
		127,
		136,
		154,
		153,
		-1,
		-1,
		-1,
		180,
		-1,
		195,
		-1,
		-1,
		194,
		222,
		169,
		151,
		147,
		145,
		138,
		147,
		142,
		137,
		147,
		149,
		141,
		129,
		133,
		156,
		145,
		184,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		209,
		184,
		199,
		233,
		214,
		221,
		184,
		181,
		-1,
		151,
		176,
		148,
		155,
		146,
		153,
		153,
		145,
		123,
		130,
		146,
		145,
		140,
		176,
		167,
		173,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		215,
		201,
		219,
		209,
		212,
		-1,
		-1,
		200,
		197,
		173,
		156,
		154,
		147,
		142,
		152,
		132,
		119,
		123,
		127,
		133,
		138,
		143,
		149,
		164,
		179,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		218,
		215,
		208,
		201,
		203,
		-1,
		-1,
		173,
		170,
		175,
		163,
		160,
		162,
		157,
		148,
		133,
		139,
		126,
		125,
		143,
		147,
		156,
		163,
		153,
		166,
		170,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		220,
		-1,
		-1,
		216,
		204,
		188,
		178,
		172,
		222,
		177,
		172,
		156,
		154,
		145,
		136,
		143,
		134,
		134,
		137,
		152,
		157,
		149,
		163,
		163,
		164,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		232,
		-1,
		215,
		-1,
		190,
		194,
		185,
		188,
		170,
		157,
		149,
		141,
		157,
		132,
		142,
		138,
		139,
		148,
		159,
		171,
		170,
		171,
		291,
		247,
		230,
		221,
		268,
		283,
		287,
		-1,
		232,
		271,
		269,
		-1,
		241,
		-1,
		-1,
		-1,
		204,
		198,
		190,
		190,
		169,
		169,
		143,
		147,
		137,
		144,
		154,
		156,
		148,
		152,
		165,
		176,
		179,
		287,
		278,
		291,
		236,
		235,
		253,
		262,
		283,
		247,
		238,
		265,
		276,
		265,
		260,
		247,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		176,
		164,
		147,
		148,
		144,
		147,
		162,
		165,
		155,
		153,
		147,
		179,
		-1,
		280,
		279,
		268,
		265,
		241,
		232,
		227,
		254,
		-1,
		-1,
		249,
		266,
		260,
		264,
		280,
		305,
		-1,
		236,
		-1,
		-1,
		221,
		-1,
		-1,
		206,
		169,
		158,
		149,
		155,
		152,
		163,
		173,
		161,
		162,
		152,
		162,
		175,
		264,
		261,
		249,
		247,
		270,
		235,
		223,
		-1,
		236,
		234,
		240,
		247,
		264,
		294,
		-1,
		-1,
		252,
		232,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		154,
		159,
		179,
		181,
		170,
		164,
		158,
		165,
		164,
		172,
		180,
		273,
		287,
		276,
		272,
		271,
		279,
		228,
		221,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		-1,
		242,
		238,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		172,
		176,
		168,
		161,
		156,
		167,
		159,
		163,
		180,
		-1,
		307,
		-1,
		259,
		235,
		249,
		264,
		272,
		-1,
		-1,
		-1,
		259,
		245,
		238,
		226,
		224,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		212,
		180,
		185,
		180,
		162,
		173,
		162,
		165,
		179,
		174,
		-1,
		-1,
		247,
		250,
		-1,
		-1,
		249,
		251,
		-1,
		250,
		239,
		224,
		216,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		169,
		194,
		183,
		191,
		186,
		166,
		172,
		175,
		164,
		168,
		180,
		-1,
		-1,
		254,
		255,
		256,
		-1,
		234,
		-1,
		252,
		-1,
		219,
		225,
		213,
		-1,
		-1,
		-1,
		207,
		170,
		191,
		201,
		195,
		193,
		184,
		170,
		177,
		175,
		171,
		182,
		-1,
		-1,
		-1,
		252,
		226,
		259,
		250,
		233,
		213,
		205,
		224,
		-1,
		194,
		-1,
		169,
		171,
		197,
		200,
		206,
		200,
		173,
		188,
		178,
		169,
		178,
		258,
		-1,
		228,
		261,
		225,
		219,
		195,
		199,
		215,
		-1,
		191,
		173,
		-1,
		201,
		191,
		222,
		207,
		188,
		175,
		182,
		182,
		175,
		-1,
		-1,
		-1,
		230,
		229,
		221,
		215,
		215,
		200,
		191,
		-1,
		203,
		185,
		164,
		181,
		181,
		172,
		180,
		212,
		208,
		195,
		195,
		187,
		-1,
		331,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		224,
		219,
		192,
		180,
		186,
		182,
		168,
		174,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		188,
		223,
		-1,
		326,
		-1,
		260,
		-1,
		-1,
		242,
		222,
		214,
		203,
		192,
		190,
		181,
		172,
		194,
		210,
		194,
		192,
		195,
		196,
		-1,
		315,
		314,
		-1,
		261,
		253,
		239,
		-1,
		232,
		-1,
		238,
		199,
		-1,
		201,
		181,
		-1,
		203,
		199,
		-1,
		-1,
		302,
		277,
		-1,
		-1,
		-1,
		262,
		242,
		233,
		217,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		287,
		286,
		-1,
		255,
		258,
		-1,
		248,
		239,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		296,
		277,
		271,
		270,
		268,
		263,
		260,
		246,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		268,
		260,
		253,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		290,
		271,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		279,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		301,
		302,
		325,
		289,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		304,
		302,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		68,
		57,
		68,
		76,
		49,
		56,
		-1,
		74,
		79,
		45,
		39,
		77,
		46,
		52,
		63,
		-1,
		-1,
		-1,
		68,
		67,
		34,
		32,
		41,
		46,
		53,
		-1,
		84,
		-1,
		89,
		68,
		79,
		84,
		27,
		24,
		44,
		57,
		76,
		72,
		104,
		57,
		28,
		22,
		34,
		41,
		70,
		62,
		-1,
		28,
		18,
		34,
		40,
		55,
		63,
		-1,
		-1,
		9,
		0,
		25,
		40,
		63,
		69,
		-1,
		79,
		98,
		-1,
		-1,
		12,
		19,
		33,
		41,
		49,
		58,
		71,
		88,
		93,
		-1,
		-1,
		30,
		34,
		38,
		45,
		41,
		58,
		77,
		88,
		102,
		101,
		-1,
		32,
		50,
		59,
		52,
		50,
		34,
		38,
		56,
		87,
		93,
		96,
		-1,
		49,
		45,
		55,
		61,
		66,
		50,
		37,
		43,
		62,
		75,
		94,
		85,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		50,
		41,
		61,
		63,
		62,
		71,
		69,
		40,
		46,
		50,
		67,
		83,
		84,
		94,
		-1,
		-1,
		143,
		116,
		140,
		98,
		80,
		-1,
		46,
		48,
		54,
		58,
		63,
		71,
		71,
		56,
		-1,
		61,
		60,
		91,
		77,
		88,
		125,
		-1,
		-1,
		101,
		93,
		75,
		78,
		55,
		51,
		63,
		62,
		58,
		60,
		62,
		74,
		64,
		77,
		84,
		55,
		65,
		69,
		84,
		95,
		-1,
		-1,
		169,
		-1,
		-1,
		122,
		105,
		-1,
		70,
		77,
		61,
		67,
		53,
		74,
		73,
		67,
		74,
		77,
		65,
		77,
		74,
		91,
		77,
		52,
		77,
		81,
		87,
		105,
		106,
		-1,
		168,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		77,
		74,
		67,
		91,
		90,
		-1,
		96,
		94,
		100,
		85,
		90,
		86,
		71,
		82,
		77,
		77,
		74,
		59,
		61,
		98,
		89,
		110,
		107,
		138,
		144,
		138,
		147,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		95,
		-1,
		98,
		111,
		108,
		96,
		99,
		86,
		94,
		93,
		77,
		88,
		75,
		72,
		71,
		67,
		76,
		86,
		85,
		103,
		116,
		131,
		135,
		141,
		-1,
		180,
		-1,
		122,
		106,
		108,
		84,
		112,
		-1,
		115,
		99,
		119,
		110,
		110,
		-1,
		102,
		99,
		109,
		92,
		77,
		87,
		75,
		70,
		70,
		74,
		89,
		80,
		98,
		105,
		113,
		117,
		137,
		149,
		140,
		130,
		-1,
		112,
		117,
		87,
		99,
		122,
		142,
		126,
		-1,
		121,
		-1,
		104,
		117,
		-1,
		98,
		94,
		83,
		83,
		72,
		79,
		77,
		71,
		68,
		86,
		89,
		106,
		110,
		126,
		-1,
		-1,
		125,
		129,
		137,
		88,
		107,
		131,
		168,
		135,
		128,
		127,
		-1,
		122,
		119,
		116,
		117,
		103,
		96,
		95,
		78,
		84,
		85,
		70,
		73,
		95,
		123,
		101,
		113,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		114,
		85,
		109,
		151,
		157,
		150,
		138,
		148,
		148,
		142,
		-1,
		134,
		113,
		106,
		95,
		85,
		101,
		91,
		94,
		74,
		76,
		92,
		104,
		95,
		115,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		88,
		122,
		140,
		181,
		167,
		172,
		147,
		140,
		134,
		128,
		130,
		113,
		102,
		94,
		83,
		92,
		102,
		96,
		76,
		85,
		86,
		110,
		117,
		123,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		113,
		120,
		152,
		172,
		185,
		-1,
		139,
		-1,
		128,
		123,
		107,
		102,
		99,
		96,
		90,
		99,
		104,
		90,
		81,
		96,
		115,
		115,
		107,
		132,
		135,
		-1,
		-1,
		-1,
		144,
		161,
		136,
		113,
		94,
		130,
		-1,
		155,
		156,
		-1,
		133,
		127,
		124,
		109,
		105,
		100,
		104,
		97,
		104,
		100,
		99,
		100,
		82,
		118,
		-1,
		115,
		109,
		137,
		140,
		130,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		101,
		153,
		-1,
		-1,
		140,
		133,
		-1,
		120,
		102,
		109,
		107,
		101,
		105,
		109,
		98,
		111,
		107,
		87,
		97,
		117,
		121,
		128,
		121,
		126,
		125,
		139,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		121,
		-1,
		149,
		141,
		131,
		125,
		119,
		115,
		113,
		129,
		113,
		116,
		116,
		112,
		120,
		105,
		104,
		90,
		94,
		112,
		139,
		134,
		129,
		128,
		135,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		136,
		-1,
		107,
		131,
		147,
		-1,
		157,
		136,
		151,
		129,
		125,
		121,
		136,
		137,
		115,
		120,
		119,
		129,
		126,
		115,
		102,
		106,
		121,
		131,
		123,
		124,
		133,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		110,
		119,
		134,
		-1,
		-1,
		193,
		-1,
		127,
		144,
		135,
		133,
		126,
		117,
		123,
		130,
		133,
		130,
		120,
		109,
		115,
		111,
		133,
		119,
		117,
		136,
		151,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		171,
		161,
		145,
		130,
		163,
		-1,
		134,
		118,
		123,
		-1,
		155,
		-1,
		128,
		128,
		119,
		108,
		105,
		116,
		114,
		125,
		142,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		167,
		-1,
		-1,
		158,
		152,
		152,
		136,
		139,
		150,
		130,
		124,
		123,
		150,
		145,
		136,
		117,
		110,
		107,
		108,
		121,
		141,
		132,
		144,
		-1,
		-1,
		-1,
		168,
		148,
		154,
		112,
		133,
		-1,
		-1,
		220,
		175,
		161,
		-1,
		145,
		167,
		155,
		145,
		135,
		169,
		161,
		136,
		129,
		115,
		117,
		115,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		145,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		167,
		183,
		175,
		146,
		156,
		-1,
		-1,
		147,
		145,
		153,
		132,
		119,
		139,
		142,
		132,
		116,
		131,
		143,
		151,
		156,
		-1,
		148,
		135,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		200,
		166,
		178,
		173,
		177,
		150,
		-1,
		149,
		143,
		123,
		137,
		144,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		157,
		171,
		166,
		159,
		163,
		-1,
		151,
		139,
		125,
		142,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		175,
		190,
		205,
		182,
		155,
		150,
		143,
		137,
		133,
		149,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		168,
		185,
		201,
		183,
		187,
		232,
		-1,
		-1,
		159,
		150,
		141,
		144,
		143,
		146,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		161,
		-1,
		-1,
		-1,
		188,
		-1,
		203,
		-1,
		-1,
		202,
		230,
		177,
		159,
		155,
		153,
		146,
		155,
		150,
		145,
		155,
		157,
		149,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		217,
		192,
		207,
		241,
		222,
		229,
		192,
		189,
		-1,
		159,
		184,
		156,
		163,
		154,
		161,
		161,
		153,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		223,
		209,
		227,
		217,
		220,
		-1,
		-1,
		208,
		205,
		181,
		164,
		162,
		155,
		150,
		160,
		140,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		226,
		223,
		216,
		209,
		211,
		-1,
		-1,
		181,
		178,
		183,
		171,
		168,
		170,
		165,
		156,
		141,
		147,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		228,
		-1,
		-1,
		224,
		212,
		196,
		186,
		180,
		230,
		185,
		180,
		164,
		162,
		153,
		144,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		240,
		-1,
		223,
		-1,
		198,
		202,
		193,
		196,
		178,
		165,
		157,
		149,
		165,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		299,
		255,
		238,
		229,
		276,
		291,
		295,
		-1,
		240,
		279,
		277,
		-1,
		249,
		-1,
		-1,
		-1,
		212,
		206,
		198,
		198,
		177,
		177,
		151,
		155,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		295,
		286,
		299,
		244,
		243,
		261,
		270,
		291,
		255,
		246,
		273,
		284,
		273,
		268,
		255,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		184,
		172,
		155,
		156,
		152,
		155,
		170,
		173,
		163,
		161,
		155,
		187,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		235,
		262,
		-1,
		-1,
		257,
		274,
		268,
		272,
		288,
		313,
		-1,
		244,
		-1,
		-1,
		229,
		-1,
		-1,
		214,
		177,
		166,
		157,
		163,
		160,
		171,
		181,
		169,
		170,
		160,
		170,
		183,
		272,
		269,
		257,
		255,
		278,
		243,
		231,
		-1,
		244,
		242,
		248,
		255,
		272,
		302,
		-1,
		-1,
		260,
		240,
		-1,
		-1,
		212,
		210,
		199,
		-1,
		189,
		162,
		167,
		187,
		189,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		229,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		250,
		246,
		-1,
		-1,
		207,
		200,
		188,
		176,
		166,
		176,
		180,
		184,
		176,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		315,
		-1,
		267,
		243,
		257,
		272,
		280,
		-1,
		-1,
		-1,
		267,
		253,
		246,
		234,
		232,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		220,
		188,
		193,
		188,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		255,
		258,
		-1,
		-1,
		257,
		259,
		-1,
		258,
		247,
		232,
		224,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		177,
		202,
		191,
		199,
		194,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		262,
		263,
		264,
		-1,
		242,
		-1,
		260,
		-1,
		227,
		233,
		221,
		-1,
		-1,
		-1,
		215,
		178,
		199,
		209,
		203,
		201,
		192,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		260,
		234,
		267,
		258,
		241,
		221,
		213,
		232,
		-1,
		202,
		-1,
		177,
		179,
		205,
		208,
		214,
		208,
		181,
		196,
		186,
		177,
		186,
		266,
		-1,
		236,
		269,
		233,
		227,
		203,
		207,
		223,
		-1,
		199,
		181,
		-1,
		209,
		199,
		230,
		215,
		196,
		183,
		190,
		190,
		183,
		-1,
		-1,
		-1,
		238,
		237,
		229,
		223,
		223,
		208,
		199,
		-1,
		211,
		193,
		172,
		189,
		189,
		180,
		188,
		220,
		216,
		203,
		203,
		195,
		-1,
		339,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		232,
		227,
		200,
		188,
		194,
		190,
		176,
		182,
		184,
		192,
		190,
		187,
		199,
		195,
		215,
		196,
		231,
		-1,
		334,
		-1,
		268,
		-1,
		-1,
		250,
		230,
		222,
		211,
		200,
		198,
		189,
		180,
		202,
		218,
		202,
		200,
		203,
		204,
		-1,
		323,
		322,
		-1,
		269,
		261,
		247,
		-1,
		240,
		-1,
		246,
		207,
		-1,
		209,
		189,
		-1,
		211,
		207,
		-1,
		-1,
		310,
		285,
		-1,
		-1,
		-1,
		270,
		250,
		241,
		225,
		-1,
		200,
		200,
		-1,
		-1,
		-1,
		295,
		294,
		-1,
		263,
		266,
		-1,
		256,
		247,
		255,
		202,
		206,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		278,
		276,
		271,
		268,
		254,
		238,
		216,
		205,
		226,
		-1,
		-1,
		-1,
		276,
		268,
		261,
		-1,
		-1,
		263,
		246,
		227,
		225,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		253,
		-1,
		-1,
		259,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		287,
		-1,
		-1,
		-1,
		249,
		245,
		246,
		-1,
		-1,
		-1,
		-1,
		309,
		310,
		333,
		297,
		-1,
		-1,
		-1,
		241,
		235,
		-1,
		-1,
		312,
		310,
		-1,
		-1,
		-1,
		269,
		253,
		-1,
		239,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		274,
		-1,
		274,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		287,
		279,
		287,
		-1,
		259,
		261,
		-1,
		309,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		264,
		271,
		293,
		296,
		332,
		-1,
		283
	],
	[
		-1,
		75,
		64,
		75,
		83,
		56,
		63,
		-1,
		81,
		86,
		52,
		46,
		84,
		53,
		59,
		70,
		-1,
		-1,
		-1,
		75,
		74,
		41,
		39,
		48,
		53,
		60,
		-1,
		61,
		-1,
		96,
		75,
		86,
		91,
		34,
		31,
		40,
		51,
		53,
		49,
		111,
		64,
		35,
		29,
		28,
		18,
		47,
		39,
		-1,
		35,
		25,
		18,
		17,
		32,
		51,
		-1,
		-1,
		15,
		16,
		0,
		17,
		44,
		63,
		-1,
		86,
		105,
		-1,
		-1,
		19,
		28,
		30,
		33,
		37,
		57,
		78,
		95,
		100,
		-1,
		-1,
		37,
		32,
		35,
		38,
		38,
		65,
		84,
		95,
		109,
		108,
		-1,
		39,
		57,
		64,
		49,
		57,
		41,
		45,
		63,
		94,
		100,
		103,
		-1,
		56,
		52,
		62,
		68,
		63,
		57,
		44,
		50,
		69,
		82,
		101,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		57,
		48,
		68,
		70,
		69,
		78,
		76,
		47,
		53,
		57,
		74,
		90,
		91,
		101,
		-1,
		-1,
		150,
		123,
		147,
		105,
		87,
		-1,
		53,
		55,
		61,
		65,
		70,
		78,
		78,
		63,
		-1,
		68,
		67,
		98,
		84,
		95,
		132,
		-1,
		-1,
		108,
		100,
		82,
		85,
		62,
		58,
		70,
		69,
		65,
		67,
		69,
		81,
		71,
		84,
		91,
		62,
		72,
		76,
		91,
		102,
		-1,
		-1,
		176,
		-1,
		-1,
		129,
		112,
		-1,
		77,
		84,
		68,
		74,
		60,
		81,
		80,
		74,
		81,
		84,
		72,
		84,
		81,
		98,
		84,
		59,
		84,
		88,
		94,
		112,
		113,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		84,
		81,
		74,
		98,
		97,
		-1,
		103,
		101,
		107,
		92,
		97,
		93,
		78,
		89,
		84,
		84,
		81,
		66,
		68,
		105,
		96,
		117,
		114,
		145,
		151,
		145,
		154,
		-1,
		137,
		133,
		129,
		136,
		85,
		-1,
		-1,
		102,
		-1,
		105,
		118,
		115,
		103,
		106,
		93,
		101,
		100,
		84,
		95,
		82,
		79,
		78,
		74,
		83,
		93,
		92,
		110,
		123,
		138,
		142,
		148,
		-1,
		187,
		-1,
		129,
		113,
		115,
		91,
		119,
		-1,
		122,
		106,
		126,
		117,
		117,
		-1,
		109,
		106,
		116,
		99,
		84,
		94,
		82,
		77,
		77,
		81,
		96,
		87,
		105,
		112,
		120,
		124,
		144,
		156,
		147,
		137,
		-1,
		119,
		124,
		94,
		106,
		129,
		149,
		133,
		-1,
		128,
		-1,
		111,
		124,
		-1,
		105,
		101,
		90,
		90,
		79,
		86,
		84,
		78,
		75,
		93,
		96,
		113,
		117,
		133,
		-1,
		-1,
		132,
		136,
		144,
		95,
		114,
		138,
		175,
		142,
		135,
		134,
		-1,
		129,
		126,
		123,
		124,
		110,
		103,
		102,
		85,
		91,
		92,
		77,
		80,
		102,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		121,
		92,
		116,
		158,
		164,
		157,
		145,
		155,
		155,
		149,
		-1,
		141,
		120,
		113,
		102,
		92,
		108,
		98,
		101,
		81,
		83,
		99,
		111,
		102,
		122,
		-1,
		-1,
		-1,
		151,
		140,
		141,
		95,
		129,
		147,
		188,
		174,
		179,
		154,
		147,
		141,
		135,
		137,
		120,
		109,
		101,
		90,
		99,
		109,
		103,
		83,
		92,
		93,
		117,
		124,
		130,
		-1,
		-1,
		158,
		148,
		132,
		134,
		131,
		120,
		127,
		159,
		179,
		192,
		-1,
		146,
		-1,
		135,
		130,
		114,
		109,
		106,
		103,
		97,
		106,
		111,
		97,
		88,
		103,
		122,
		122,
		114,
		139,
		142,
		-1,
		-1,
		-1,
		151,
		168,
		143,
		120,
		101,
		137,
		-1,
		162,
		163,
		-1,
		140,
		134,
		131,
		116,
		112,
		107,
		111,
		104,
		111,
		107,
		106,
		107,
		89,
		125,
		-1,
		122,
		116,
		144,
		147,
		137,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		108,
		160,
		-1,
		-1,
		147,
		140,
		-1,
		127,
		109,
		116,
		114,
		108,
		112,
		116,
		105,
		118,
		114,
		94,
		104,
		124,
		128,
		135,
		128,
		133,
		132,
		146,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		128,
		-1,
		156,
		148,
		138,
		132,
		126,
		122,
		120,
		136,
		120,
		123,
		123,
		119,
		127,
		112,
		111,
		97,
		101,
		119,
		146,
		141,
		136,
		135,
		142,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		143,
		-1,
		114,
		138,
		154,
		-1,
		164,
		143,
		158,
		136,
		132,
		128,
		143,
		144,
		122,
		127,
		126,
		136,
		133,
		122,
		109,
		113,
		128,
		138,
		130,
		131,
		140,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		117,
		126,
		141,
		-1,
		-1,
		200,
		-1,
		134,
		151,
		142,
		140,
		133,
		124,
		130,
		137,
		140,
		137,
		127,
		116,
		122,
		118,
		140,
		126,
		124,
		143,
		158,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		178,
		168,
		152,
		137,
		170,
		-1,
		141,
		125,
		130,
		-1,
		162,
		-1,
		135,
		135,
		126,
		115,
		112,
		123,
		121,
		132,
		149,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		174,
		-1,
		-1,
		165,
		159,
		159,
		143,
		146,
		157,
		137,
		131,
		130,
		157,
		152,
		143,
		124,
		117,
		114,
		115,
		128,
		148,
		139,
		151,
		-1,
		-1,
		-1,
		175,
		155,
		161,
		119,
		140,
		-1,
		-1,
		227,
		182,
		168,
		-1,
		152,
		174,
		162,
		152,
		142,
		176,
		168,
		143,
		136,
		122,
		124,
		122,
		124,
		129,
		150,
		151,
		164,
		-1,
		-1,
		152,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		174,
		190,
		182,
		153,
		163,
		-1,
		-1,
		154,
		152,
		160,
		139,
		126,
		146,
		149,
		139,
		123,
		138,
		150,
		158,
		163,
		-1,
		155,
		142,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		185,
		180,
		184,
		157,
		-1,
		156,
		150,
		130,
		144,
		151,
		141,
		136,
		130,
		133,
		151,
		168,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		164,
		178,
		173,
		166,
		170,
		-1,
		158,
		146,
		132,
		149,
		154,
		151,
		142,
		134,
		139,
		136,
		149,
		163,
		167,
		192,
		-1,
		175,
		-1,
		-1,
		-1,
		182,
		197,
		212,
		189,
		162,
		157,
		150,
		144,
		140,
		156,
		162,
		173,
		141,
		137,
		138,
		142,
		141,
		158,
		168,
		-1,
		-1,
		175,
		192,
		208,
		190,
		194,
		239,
		-1,
		-1,
		166,
		157,
		148,
		151,
		150,
		153,
		147,
		144,
		149,
		154,
		142,
		151,
		169,
		168,
		-1,
		-1,
		-1,
		195,
		-1,
		210,
		-1,
		-1,
		209,
		237,
		184,
		166,
		162,
		160,
		153,
		162,
		157,
		152,
		162,
		164,
		156,
		144,
		148,
		171,
		160,
		199,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		224,
		199,
		214,
		248,
		229,
		236,
		199,
		196,
		-1,
		166,
		191,
		163,
		170,
		161,
		168,
		168,
		160,
		138,
		145,
		161,
		160,
		155,
		191,
		182,
		188,
		-1,
		-1,
		305,
		294,
		283,
		289,
		-1,
		230,
		216,
		234,
		224,
		227,
		-1,
		-1,
		215,
		212,
		188,
		171,
		169,
		162,
		157,
		167,
		147,
		134,
		138,
		142,
		148,
		153,
		158,
		164,
		179,
		194,
		-1,
		200,
		281,
		274,
		257,
		265,
		296,
		-1,
		233,
		230,
		223,
		216,
		218,
		-1,
		-1,
		188,
		185,
		190,
		178,
		175,
		177,
		172,
		163,
		148,
		154,
		141,
		140,
		158,
		162,
		171,
		178,
		168,
		181,
		185,
		-1,
		214,
		257,
		251,
		254,
		278,
		292,
		-1,
		235,
		-1,
		-1,
		231,
		219,
		203,
		193,
		187,
		237,
		192,
		187,
		171,
		169,
		160,
		151,
		158,
		149,
		149,
		152,
		167,
		172,
		164,
		178,
		178,
		179,
		-1,
		249,
		237,
		245,
		-1,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		247,
		-1,
		230,
		-1,
		205,
		209,
		200,
		203,
		185,
		172,
		164,
		156,
		172,
		147,
		157,
		153,
		154,
		163,
		174,
		186,
		185,
		186,
		306,
		262,
		245,
		236,
		283,
		298,
		302,
		-1,
		247,
		286,
		284,
		-1,
		256,
		-1,
		-1,
		-1,
		219,
		213,
		205,
		205,
		184,
		184,
		158,
		162,
		152,
		159,
		169,
		171,
		163,
		167,
		180,
		191,
		194,
		302,
		293,
		306,
		251,
		250,
		268,
		277,
		298,
		262,
		253,
		280,
		291,
		280,
		275,
		262,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		191,
		179,
		162,
		163,
		159,
		162,
		177,
		180,
		170,
		168,
		162,
		194,
		-1,
		295,
		294,
		283,
		280,
		256,
		247,
		242,
		269,
		-1,
		-1,
		264,
		281,
		275,
		279,
		295,
		320,
		-1,
		251,
		-1,
		-1,
		236,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		167,
		178,
		188,
		176,
		177,
		167,
		177,
		190,
		279,
		276,
		264,
		262,
		285,
		250,
		238,
		-1,
		251,
		249,
		255,
		262,
		279,
		309,
		-1,
		-1,
		267,
		247,
		-1,
		-1,
		219,
		217,
		206,
		-1,
		196,
		169,
		174,
		194,
		196,
		185,
		179,
		173,
		180,
		179,
		187,
		195,
		288,
		302,
		291,
		287,
		286,
		294,
		243,
		236,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		257,
		253,
		-1,
		-1,
		214,
		207,
		195,
		183,
		173,
		183,
		187,
		191,
		183,
		176,
		171,
		182,
		174,
		178,
		195,
		-1,
		322,
		-1,
		274,
		250,
		264,
		279,
		287,
		-1,
		-1,
		-1,
		274,
		260,
		253,
		241,
		239,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		177,
		188,
		177,
		180,
		194,
		189,
		-1,
		-1,
		262,
		265,
		-1,
		-1,
		264,
		266,
		-1,
		265,
		254,
		239,
		231,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		184,
		209,
		198,
		206,
		201,
		181,
		187,
		190,
		179,
		183,
		195,
		-1,
		-1,
		269,
		270,
		271,
		-1,
		249,
		-1,
		267,
		-1,
		234,
		240,
		228,
		-1,
		-1,
		-1,
		222,
		185,
		206,
		216,
		210,
		208,
		199,
		185,
		192,
		190,
		186,
		197,
		-1,
		-1,
		-1,
		267,
		241,
		274,
		265,
		248,
		228,
		220,
		239,
		-1,
		209,
		-1,
		184,
		186,
		212,
		215,
		221,
		215,
		188,
		203,
		193,
		184,
		193,
		273,
		-1,
		243,
		276,
		240,
		234,
		210,
		214,
		230,
		-1,
		206,
		188,
		-1,
		216,
		206,
		237,
		222,
		203,
		190,
		197,
		197,
		190,
		-1,
		-1,
		-1,
		245,
		244,
		236,
		230,
		230,
		215,
		206,
		-1,
		218,
		200,
		179,
		196,
		196,
		187,
		195,
		227,
		223,
		210,
		210,
		202,
		-1,
		346,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		239,
		234,
		207,
		195,
		201,
		197,
		183,
		189,
		191,
		199,
		197,
		194,
		206,
		202,
		222,
		203,
		238,
		-1,
		341,
		-1,
		275,
		-1,
		-1,
		257,
		237,
		229,
		218,
		207,
		205,
		196,
		187,
		209,
		225,
		209,
		207,
		210,
		211,
		-1,
		330,
		329,
		-1,
		276,
		268,
		254,
		-1,
		247,
		-1,
		253,
		214,
		-1,
		216,
		196,
		-1,
		218,
		214,
		-1,
		-1,
		317,
		292,
		-1,
		-1,
		-1,
		277,
		257,
		248,
		232,
		-1,
		207,
		207,
		-1,
		-1,
		-1,
		302,
		301,
		-1,
		270,
		273,
		-1,
		263,
		254,
		262,
		209,
		213,
		-1,
		-1,
		-1,
		311,
		292,
		286,
		285,
		283,
		278,
		275,
		261,
		245,
		223,
		212,
		233,
		-1,
		-1,
		-1,
		283,
		275,
		268,
		-1,
		-1,
		270,
		253,
		234,
		232,
		-1,
		-1,
		-1,
		305,
		286,
		-1,
		-1,
		260,
		-1,
		-1,
		266,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		322,
		294,
		-1,
		-1,
		-1,
		256,
		252,
		253,
		-1,
		-1,
		-1,
		-1,
		316,
		317,
		340,
		304,
		-1,
		-1,
		-1,
		248,
		242,
		-1,
		-1,
		319,
		317,
		-1,
		-1,
		-1,
		276,
		260,
		-1,
		246,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		281,
		-1,
		281,
		256,
		263,
		-1,
		-1,
		-1,
		-1,
		294,
		286,
		294,
		-1,
		266,
		268,
		-1,
		316,
		-1,
		-1,
		309,
		300,
		-1,
		-1,
		271,
		278,
		300,
		303,
		339,
		-1,
		290
	],
	[
		-1,
		90,
		79,
		90,
		98,
		71,
		78,
		-1,
		96,
		101,
		67,
		61,
		99,
		68,
		74,
		85,
		-1,
		-1,
		-1,
		90,
		89,
		56,
		54,
		63,
		68,
		75,
		-1,
		44,
		-1,
		111,
		90,
		101,
		106,
		49,
		46,
		50,
		59,
		36,
		32,
		126,
		79,
		50,
		44,
		38,
		17,
		30,
		22,
		-1,
		50,
		40,
		28,
		6,
		15,
		34,
		-1,
		-1,
		30,
		31,
		17,
		0,
		27,
		46,
		-1,
		80,
		92,
		-1,
		-1,
		34,
		33,
		21,
		18,
		20,
		43,
		72,
		89,
		94,
		-1,
		-1,
		29,
		23,
		26,
		23,
		27,
		59,
		78,
		89,
		103,
		102,
		-1,
		41,
		58,
		55,
		38,
		48,
		35,
		39,
		57,
		88,
		94,
		97,
		-1,
		58,
		54,
		61,
		59,
		54,
		49,
		38,
		44,
		63,
		76,
		95,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		59,
		50,
		67,
		69,
		71,
		70,
		68,
		41,
		47,
		51,
		68,
		84,
		85,
		95,
		-1,
		-1,
		152,
		125,
		149,
		107,
		89,
		-1,
		55,
		57,
		63,
		67,
		72,
		80,
		70,
		57,
		-1,
		62,
		61,
		92,
		78,
		89,
		134,
		-1,
		-1,
		110,
		102,
		84,
		87,
		64,
		60,
		72,
		71,
		67,
		69,
		71,
		80,
		65,
		78,
		85,
		56,
		66,
		70,
		85,
		96,
		-1,
		-1,
		170,
		-1,
		-1,
		131,
		114,
		-1,
		79,
		86,
		70,
		76,
		62,
		83,
		82,
		76,
		83,
		86,
		74,
		78,
		75,
		92,
		78,
		53,
		78,
		82,
		88,
		106,
		107,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		86,
		83,
		76,
		100,
		99,
		-1,
		105,
		103,
		109,
		94,
		99,
		95,
		80,
		83,
		78,
		78,
		75,
		60,
		62,
		99,
		90,
		111,
		108,
		139,
		145,
		139,
		148,
		-1,
		139,
		135,
		131,
		138,
		87,
		-1,
		-1,
		104,
		-1,
		107,
		120,
		117,
		105,
		108,
		95,
		103,
		102,
		86,
		89,
		76,
		73,
		72,
		68,
		77,
		87,
		86,
		104,
		117,
		132,
		136,
		142,
		-1,
		189,
		-1,
		131,
		115,
		117,
		93,
		121,
		-1,
		124,
		108,
		128,
		119,
		119,
		-1,
		111,
		108,
		118,
		101,
		86,
		88,
		76,
		71,
		71,
		75,
		90,
		81,
		99,
		106,
		114,
		118,
		138,
		150,
		149,
		139,
		-1,
		121,
		126,
		96,
		108,
		131,
		151,
		135,
		-1,
		130,
		-1,
		113,
		126,
		-1,
		107,
		103,
		92,
		84,
		73,
		80,
		78,
		72,
		69,
		87,
		90,
		107,
		111,
		127,
		-1,
		-1,
		134,
		138,
		146,
		97,
		116,
		140,
		177,
		144,
		137,
		136,
		-1,
		131,
		128,
		125,
		126,
		112,
		98,
		96,
		79,
		85,
		86,
		71,
		74,
		96,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		123,
		94,
		118,
		160,
		166,
		159,
		147,
		149,
		149,
		143,
		-1,
		137,
		116,
		107,
		96,
		86,
		102,
		92,
		95,
		75,
		77,
		93,
		105,
		96,
		116,
		-1,
		-1,
		-1,
		153,
		142,
		143,
		97,
		131,
		149,
		182,
		168,
		173,
		148,
		141,
		135,
		137,
		133,
		114,
		103,
		95,
		84,
		93,
		103,
		97,
		77,
		86,
		87,
		111,
		118,
		124,
		-1,
		-1,
		160,
		150,
		134,
		136,
		133,
		122,
		129,
		161,
		173,
		186,
		-1,
		140,
		-1,
		129,
		124,
		108,
		103,
		100,
		97,
		91,
		100,
		105,
		91,
		82,
		97,
		116,
		116,
		108,
		133,
		136,
		-1,
		-1,
		-1,
		153,
		170,
		145,
		122,
		103,
		139,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		110,
		106,
		101,
		105,
		98,
		105,
		101,
		100,
		101,
		83,
		119,
		-1,
		116,
		110,
		138,
		141,
		131,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		110,
		162,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		110,
		108,
		102,
		106,
		110,
		99,
		112,
		108,
		88,
		98,
		118,
		122,
		129,
		122,
		127,
		126,
		140,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		130,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		130,
		114,
		117,
		117,
		113,
		121,
		106,
		105,
		91,
		95,
		113,
		140,
		135,
		130,
		129,
		136,
		-1,
		216,
		202,
		173,
		-1,
		-1,
		145,
		-1,
		116,
		140,
		156,
		-1,
		158,
		137,
		152,
		130,
		126,
		122,
		137,
		138,
		116,
		121,
		120,
		130,
		127,
		116,
		103,
		107,
		122,
		132,
		124,
		125,
		134,
		-1,
		222,
		209,
		167,
		163,
		152,
		172,
		119,
		120,
		143,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		136,
		134,
		127,
		118,
		124,
		131,
		134,
		131,
		121,
		110,
		116,
		112,
		134,
		120,
		118,
		137,
		152,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		138,
		125,
		119,
		-1,
		160,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		135,
		119,
		124,
		-1,
		156,
		-1,
		129,
		129,
		120,
		109,
		106,
		117,
		115,
		126,
		143,
		-1,
		172,
		157,
		150,
		140,
		154,
		125,
		-1,
		176,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		151,
		131,
		125,
		124,
		151,
		146,
		137,
		118,
		111,
		108,
		109,
		122,
		142,
		133,
		145,
		-1,
		-1,
		-1,
		177,
		157,
		163,
		121,
		142,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		146,
		168,
		156,
		146,
		136,
		170,
		162,
		137,
		130,
		116,
		118,
		116,
		118,
		123,
		144,
		145,
		158,
		-1,
		-1,
		154,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		168,
		184,
		176,
		147,
		157,
		-1,
		-1,
		148,
		146,
		154,
		133,
		120,
		140,
		143,
		133,
		117,
		132,
		144,
		152,
		157,
		-1,
		157,
		144,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		-1,
		-1,
		201,
		167,
		179,
		174,
		178,
		151,
		-1,
		150,
		144,
		124,
		138,
		145,
		135,
		130,
		124,
		127,
		145,
		162,
		-1,
		-1,
		171,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		158,
		172,
		167,
		160,
		164,
		-1,
		152,
		140,
		126,
		143,
		148,
		145,
		136,
		128,
		133,
		130,
		143,
		157,
		161,
		194,
		-1,
		177,
		-1,
		-1,
		-1,
		176,
		191,
		206,
		183,
		156,
		151,
		144,
		138,
		134,
		150,
		156,
		167,
		135,
		131,
		132,
		136,
		135,
		152,
		162,
		-1,
		-1,
		177,
		194,
		202,
		184,
		188,
		233,
		-1,
		-1,
		160,
		151,
		142,
		145,
		144,
		147,
		141,
		138,
		143,
		148,
		136,
		145,
		163,
		162,
		-1,
		-1,
		-1,
		197,
		-1,
		212,
		-1,
		-1,
		203,
		231,
		178,
		160,
		156,
		154,
		147,
		156,
		151,
		146,
		156,
		158,
		150,
		138,
		142,
		165,
		154,
		193,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		226,
		201,
		216,
		242,
		223,
		230,
		193,
		190,
		-1,
		160,
		185,
		157,
		164,
		155,
		162,
		162,
		154,
		132,
		139,
		155,
		154,
		149,
		185,
		176,
		182,
		-1,
		-1,
		307,
		296,
		285,
		291,
		-1,
		232,
		218,
		228,
		218,
		221,
		-1,
		-1,
		209,
		206,
		182,
		165,
		163,
		156,
		151,
		161,
		141,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		202,
		283,
		276,
		259,
		267,
		298,
		-1,
		232,
		224,
		225,
		210,
		212,
		-1,
		-1,
		182,
		179,
		184,
		172,
		169,
		171,
		166,
		157,
		142,
		148,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		216,
		259,
		253,
		256,
		280,
		294,
		-1,
		229,
		-1,
		-1,
		233,
		213,
		197,
		187,
		181,
		231,
		186,
		181,
		165,
		163,
		154,
		145,
		152,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		251,
		239,
		247,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		249,
		-1,
		224,
		-1,
		199,
		203,
		194,
		197,
		179,
		166,
		158,
		150,
		166,
		141,
		151,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		300,
		256,
		247,
		238,
		281,
		296,
		300,
		-1,
		241,
		280,
		278,
		-1,
		258,
		-1,
		-1,
		-1,
		213,
		207,
		199,
		199,
		178,
		178,
		152,
		156,
		146,
		153,
		163,
		165,
		157,
		161,
		174,
		185,
		188,
		296,
		287,
		300,
		245,
		245,
		266,
		275,
		296,
		256,
		247,
		274,
		285,
		274,
		269,
		256,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		185,
		173,
		156,
		157,
		153,
		156,
		171,
		174,
		164,
		162,
		156,
		188,
		-1,
		289,
		288,
		277,
		274,
		250,
		241,
		236,
		263,
		-1,
		-1,
		258,
		275,
		269,
		273,
		289,
		314,
		-1,
		245,
		-1,
		-1,
		230,
		-1,
		-1,
		215,
		178,
		167,
		158,
		164,
		161,
		172,
		182,
		170,
		171,
		161,
		171,
		184,
		273,
		270,
		258,
		256,
		279,
		244,
		232,
		-1,
		245,
		243,
		249,
		256,
		273,
		303,
		-1,
		-1,
		261,
		241,
		-1,
		-1,
		213,
		211,
		200,
		-1,
		190,
		163,
		168,
		188,
		190,
		179,
		173,
		167,
		174,
		173,
		181,
		189,
		282,
		296,
		285,
		281,
		280,
		288,
		237,
		230,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		247,
		-1,
		-1,
		208,
		201,
		189,
		177,
		167,
		177,
		181,
		185,
		177,
		170,
		165,
		176,
		168,
		172,
		189,
		-1,
		316,
		-1,
		268,
		244,
		258,
		273,
		281,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		242,
		226,
		207,
		-1,
		177,
		190,
		221,
		189,
		194,
		189,
		171,
		182,
		171,
		174,
		188,
		183,
		-1,
		-1,
		256,
		259,
		-1,
		-1,
		258,
		260,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		214,
		210,
		-1,
		-1,
		178,
		203,
		192,
		200,
		195,
		175,
		181,
		184,
		173,
		177,
		189,
		-1,
		-1,
		263,
		264,
		265,
		-1,
		243,
		-1,
		261,
		-1,
		228,
		234,
		222,
		-1,
		-1,
		-1,
		216,
		179,
		200,
		210,
		204,
		202,
		193,
		179,
		186,
		184,
		180,
		191,
		-1,
		-1,
		-1,
		261,
		235,
		268,
		259,
		242,
		222,
		214,
		233,
		-1,
		203,
		-1,
		178,
		180,
		206,
		209,
		215,
		209,
		182,
		197,
		187,
		178,
		187,
		267,
		-1,
		237,
		270,
		234,
		228,
		204,
		208,
		224,
		-1,
		200,
		182,
		-1,
		210,
		200,
		231,
		216,
		197,
		184,
		191,
		191,
		184,
		-1,
		-1,
		-1,
		239,
		238,
		230,
		224,
		224,
		209,
		200,
		-1,
		212,
		194,
		173,
		190,
		190,
		181,
		189,
		221,
		217,
		204,
		204,
		196,
		-1,
		340,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		233,
		228,
		201,
		189,
		195,
		191,
		177,
		183,
		185,
		193,
		191,
		188,
		200,
		196,
		216,
		197,
		232,
		-1,
		335,
		-1,
		269,
		-1,
		-1,
		251,
		231,
		223,
		212,
		201,
		199,
		190,
		181,
		203,
		219,
		203,
		201,
		204,
		205,
		-1,
		324,
		323,
		-1,
		270,
		262,
		248,
		-1,
		241,
		-1,
		247,
		208,
		-1,
		210,
		190,
		-1,
		212,
		208,
		-1,
		-1,
		311,
		286,
		-1,
		-1,
		-1,
		271,
		251,
		242,
		226,
		-1,
		201,
		201,
		-1,
		-1,
		-1,
		296,
		295,
		-1,
		264,
		267,
		-1,
		257,
		248,
		256,
		203,
		207,
		-1,
		-1,
		-1,
		305,
		286,
		280,
		279,
		277,
		272,
		269,
		255,
		239,
		217,
		206,
		227,
		-1,
		-1,
		-1,
		277,
		269,
		262,
		-1,
		-1,
		264,
		247,
		228,
		226,
		-1,
		-1,
		-1,
		299,
		280,
		-1,
		-1,
		254,
		-1,
		-1,
		260,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		288,
		-1,
		-1,
		-1,
		250,
		246,
		247,
		-1,
		-1,
		-1,
		-1,
		310,
		311,
		334,
		298,
		-1,
		-1,
		-1,
		242,
		236,
		-1,
		-1,
		313,
		311,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		240,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		275,
		-1,
		275,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		288,
		280,
		288,
		-1,
		260,
		262,
		-1,
		310,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		265,
		272,
		294,
		297,
		333,
		-1,
		284
	],
	[
		-1,
		120,
		109,
		120,
		128,
		101,
		108,
		-1,
		126,
		131,
		97,
		91,
		129,
		98,
		104,
		115,
		-1,
		-1,
		-1,
		120,
		119,
		86,
		84,
		93,
		98,
		105,
		-1,
		60,
		-1,
		141,
		120,
		131,
		136,
		79,
		76,
		80,
		72,
		53,
		45,
		156,
		109,
		80,
		74,
		68,
		47,
		47,
		39,
		-1,
		80,
		70,
		58,
		36,
		36,
		30,
		-1,
		-1,
		60,
		61,
		47,
		30,
		0,
		42,
		-1,
		80,
		88,
		-1,
		-1,
		64,
		58,
		42,
		27,
		16,
		39,
		72,
		89,
		93,
		-1,
		-1,
		50,
		44,
		51,
		34,
		38,
		67,
		78,
		100,
		108,
		110,
		-1,
		62,
		79,
		80,
		49,
		44,
		46,
		50,
		68,
		99,
		105,
		108,
		-1,
		79,
		75,
		82,
		76,
		71,
		45,
		49,
		55,
		74,
		87,
		106,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		80,
		71,
		88,
		90,
		85,
		66,
		64,
		52,
		58,
		62,
		79,
		95,
		96,
		106,
		-1,
		-1,
		173,
		146,
		170,
		128,
		110,
		-1,
		76,
		78,
		84,
		88,
		83,
		91,
		66,
		68,
		-1,
		73,
		72,
		103,
		89,
		100,
		155,
		-1,
		-1,
		131,
		123,
		105,
		108,
		85,
		81,
		93,
		92,
		88,
		90,
		92,
		91,
		76,
		89,
		96,
		67,
		77,
		81,
		96,
		107,
		-1,
		-1,
		181,
		-1,
		-1,
		152,
		135,
		-1,
		100,
		107,
		91,
		97,
		83,
		104,
		103,
		97,
		104,
		107,
		95,
		89,
		86,
		103,
		89,
		64,
		89,
		93,
		99,
		117,
		118,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		107,
		104,
		97,
		121,
		120,
		-1,
		126,
		124,
		130,
		115,
		120,
		116,
		101,
		94,
		89,
		89,
		86,
		71,
		73,
		110,
		101,
		122,
		119,
		150,
		156,
		150,
		159,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		125,
		-1,
		128,
		141,
		138,
		126,
		129,
		116,
		124,
		123,
		107,
		100,
		87,
		84,
		83,
		79,
		88,
		98,
		97,
		115,
		128,
		143,
		147,
		153,
		-1,
		210,
		-1,
		152,
		136,
		138,
		114,
		142,
		-1,
		145,
		129,
		149,
		140,
		140,
		-1,
		132,
		129,
		139,
		122,
		107,
		99,
		87,
		82,
		82,
		86,
		101,
		92,
		110,
		117,
		125,
		129,
		149,
		161,
		170,
		160,
		-1,
		142,
		147,
		117,
		129,
		152,
		172,
		156,
		-1,
		151,
		-1,
		134,
		147,
		-1,
		128,
		124,
		107,
		95,
		84,
		91,
		89,
		83,
		80,
		98,
		101,
		118,
		122,
		138,
		-1,
		-1,
		155,
		159,
		167,
		118,
		137,
		161,
		198,
		165,
		158,
		157,
		-1,
		152,
		143,
		140,
		137,
		124,
		109,
		107,
		90,
		96,
		97,
		82,
		85,
		107,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		144,
		115,
		139,
		181,
		187,
		180,
		168,
		160,
		160,
		154,
		-1,
		148,
		127,
		118,
		107,
		97,
		113,
		103,
		106,
		86,
		88,
		104,
		116,
		107,
		127,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		118,
		152,
		170,
		193,
		179,
		184,
		159,
		152,
		146,
		152,
		144,
		125,
		114,
		106,
		95,
		104,
		114,
		108,
		88,
		97,
		98,
		122,
		129,
		135,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		143,
		150,
		182,
		184,
		197,
		-1,
		151,
		-1,
		140,
		135,
		119,
		114,
		111,
		108,
		102,
		111,
		116,
		102,
		93,
		108,
		127,
		127,
		119,
		144,
		147,
		-1,
		-1,
		-1,
		174,
		191,
		166,
		143,
		124,
		160,
		-1,
		167,
		168,
		-1,
		145,
		139,
		136,
		121,
		117,
		112,
		116,
		109,
		116,
		112,
		111,
		112,
		94,
		130,
		-1,
		127,
		121,
		149,
		152,
		142,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		131,
		183,
		-1,
		-1,
		152,
		145,
		-1,
		132,
		114,
		121,
		119,
		113,
		117,
		121,
		110,
		123,
		119,
		99,
		109,
		129,
		133,
		140,
		133,
		138,
		137,
		151,
		-1,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		151,
		-1,
		161,
		153,
		143,
		137,
		131,
		127,
		125,
		141,
		125,
		128,
		128,
		124,
		132,
		117,
		116,
		102,
		106,
		124,
		151,
		146,
		141,
		140,
		147,
		-1,
		236,
		222,
		193,
		-1,
		-1,
		166,
		-1,
		137,
		160,
		176,
		-1,
		169,
		148,
		163,
		141,
		137,
		133,
		148,
		149,
		127,
		132,
		131,
		141,
		138,
		127,
		114,
		118,
		133,
		143,
		135,
		136,
		145,
		-1,
		242,
		229,
		187,
		183,
		172,
		192,
		140,
		131,
		163,
		-1,
		-1,
		205,
		-1,
		139,
		156,
		147,
		145,
		138,
		129,
		135,
		142,
		145,
		142,
		132,
		121,
		127,
		123,
		145,
		131,
		129,
		148,
		163,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		158,
		145,
		139,
		-1,
		180,
		-1,
		183,
		173,
		157,
		142,
		175,
		-1,
		146,
		130,
		135,
		-1,
		167,
		-1,
		140,
		140,
		131,
		120,
		117,
		128,
		126,
		137,
		154,
		-1,
		192,
		177,
		170,
		160,
		174,
		145,
		-1,
		197,
		-1,
		-1,
		170,
		164,
		164,
		148,
		151,
		162,
		142,
		136,
		135,
		162,
		157,
		148,
		129,
		122,
		119,
		120,
		133,
		153,
		144,
		156,
		-1,
		-1,
		-1,
		197,
		178,
		184,
		142,
		163,
		-1,
		-1,
		232,
		187,
		173,
		-1,
		157,
		179,
		167,
		157,
		147,
		181,
		173,
		148,
		141,
		127,
		129,
		127,
		129,
		134,
		155,
		156,
		169,
		-1,
		-1,
		175,
		182,
		170,
		156,
		175,
		-1,
		-1,
		-1,
		179,
		195,
		187,
		158,
		168,
		-1,
		-1,
		159,
		157,
		165,
		144,
		131,
		151,
		154,
		144,
		128,
		143,
		155,
		163,
		168,
		-1,
		178,
		165,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		-1,
		-1,
		212,
		178,
		190,
		185,
		189,
		162,
		-1,
		161,
		155,
		135,
		149,
		156,
		146,
		141,
		135,
		138,
		156,
		173,
		-1,
		-1,
		192,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		169,
		183,
		178,
		171,
		175,
		-1,
		163,
		151,
		137,
		154,
		159,
		156,
		147,
		139,
		144,
		141,
		154,
		168,
		172,
		215,
		-1,
		198,
		-1,
		-1,
		-1,
		187,
		202,
		217,
		194,
		167,
		162,
		155,
		149,
		145,
		161,
		167,
		178,
		146,
		142,
		143,
		147,
		146,
		163,
		173,
		-1,
		-1,
		198,
		215,
		213,
		195,
		199,
		244,
		-1,
		-1,
		171,
		162,
		153,
		156,
		155,
		158,
		152,
		149,
		154,
		159,
		147,
		156,
		174,
		173,
		-1,
		-1,
		-1,
		218,
		-1,
		233,
		-1,
		-1,
		214,
		242,
		189,
		171,
		167,
		165,
		158,
		167,
		162,
		157,
		167,
		169,
		161,
		149,
		153,
		176,
		165,
		204,
		-1,
		-1,
		335,
		-1,
		-1,
		-1,
		247,
		222,
		237,
		253,
		234,
		241,
		204,
		201,
		-1,
		171,
		196,
		168,
		175,
		166,
		173,
		173,
		165,
		143,
		150,
		166,
		165,
		160,
		196,
		187,
		193,
		-1,
		-1,
		328,
		317,
		306,
		312,
		-1,
		253,
		239,
		239,
		229,
		232,
		-1,
		-1,
		220,
		217,
		193,
		176,
		174,
		167,
		162,
		172,
		152,
		139,
		143,
		147,
		153,
		158,
		163,
		169,
		184,
		199,
		-1,
		223,
		304,
		297,
		280,
		288,
		319,
		-1,
		243,
		235,
		246,
		221,
		223,
		-1,
		-1,
		193,
		190,
		195,
		183,
		180,
		182,
		177,
		168,
		153,
		159,
		146,
		145,
		163,
		167,
		176,
		183,
		173,
		186,
		190,
		-1,
		237,
		280,
		274,
		277,
		301,
		315,
		-1,
		240,
		-1,
		-1,
		252,
		224,
		208,
		198,
		192,
		242,
		197,
		192,
		176,
		174,
		165,
		156,
		163,
		154,
		154,
		157,
		172,
		177,
		169,
		183,
		183,
		184,
		-1,
		272,
		260,
		268,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		268,
		-1,
		235,
		-1,
		210,
		214,
		205,
		208,
		190,
		177,
		169,
		161,
		177,
		152,
		162,
		158,
		159,
		168,
		179,
		191,
		190,
		191,
		311,
		267,
		268,
		259,
		292,
		307,
		311,
		-1,
		252,
		291,
		289,
		-1,
		273,
		-1,
		-1,
		-1,
		224,
		218,
		210,
		210,
		189,
		189,
		163,
		167,
		157,
		164,
		174,
		176,
		168,
		172,
		185,
		196,
		199,
		307,
		298,
		311,
		256,
		256,
		277,
		286,
		307,
		267,
		258,
		285,
		296,
		285,
		280,
		267,
		-1,
		-1,
		247,
		228,
		-1,
		-1,
		196,
		184,
		167,
		168,
		164,
		167,
		182,
		185,
		175,
		173,
		167,
		199,
		-1,
		300,
		299,
		288,
		285,
		261,
		252,
		247,
		274,
		-1,
		-1,
		269,
		286,
		280,
		284,
		300,
		325,
		-1,
		256,
		-1,
		-1,
		241,
		-1,
		-1,
		226,
		189,
		178,
		169,
		175,
		172,
		183,
		193,
		181,
		182,
		172,
		182,
		195,
		284,
		281,
		269,
		267,
		290,
		255,
		243,
		-1,
		256,
		254,
		260,
		267,
		284,
		314,
		-1,
		-1,
		272,
		252,
		-1,
		-1,
		224,
		222,
		211,
		-1,
		201,
		174,
		179,
		199,
		201,
		190,
		184,
		178,
		185,
		184,
		192,
		200,
		293,
		307,
		296,
		292,
		291,
		299,
		248,
		241,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		-1,
		262,
		258,
		-1,
		-1,
		219,
		212,
		200,
		188,
		178,
		188,
		192,
		196,
		188,
		181,
		176,
		187,
		179,
		183,
		200,
		-1,
		327,
		-1,
		279,
		255,
		269,
		284,
		292,
		-1,
		-1,
		-1,
		279,
		265,
		258,
		246,
		244,
		-1,
		253,
		237,
		218,
		-1,
		188,
		201,
		232,
		200,
		205,
		200,
		182,
		193,
		182,
		185,
		199,
		194,
		-1,
		-1,
		267,
		270,
		-1,
		-1,
		269,
		271,
		-1,
		270,
		259,
		244,
		236,
		-1,
		-1,
		225,
		221,
		-1,
		-1,
		189,
		214,
		203,
		211,
		206,
		186,
		192,
		195,
		184,
		188,
		200,
		-1,
		-1,
		274,
		275,
		276,
		-1,
		254,
		-1,
		272,
		-1,
		239,
		245,
		233,
		-1,
		-1,
		-1,
		227,
		190,
		211,
		221,
		215,
		213,
		204,
		190,
		197,
		195,
		191,
		202,
		-1,
		-1,
		-1,
		272,
		246,
		279,
		270,
		253,
		233,
		225,
		244,
		-1,
		214,
		-1,
		189,
		191,
		217,
		220,
		226,
		220,
		193,
		208,
		198,
		189,
		198,
		278,
		-1,
		248,
		281,
		245,
		239,
		215,
		219,
		235,
		-1,
		211,
		193,
		-1,
		221,
		211,
		242,
		227,
		208,
		195,
		202,
		202,
		195,
		-1,
		-1,
		-1,
		250,
		249,
		241,
		235,
		235,
		220,
		211,
		-1,
		223,
		205,
		184,
		201,
		201,
		192,
		200,
		232,
		228,
		215,
		215,
		207,
		-1,
		351,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		244,
		239,
		212,
		200,
		206,
		202,
		188,
		194,
		196,
		204,
		202,
		199,
		211,
		207,
		227,
		208,
		243,
		-1,
		346,
		-1,
		280,
		-1,
		-1,
		262,
		242,
		234,
		223,
		212,
		210,
		201,
		192,
		214,
		230,
		214,
		212,
		215,
		216,
		-1,
		335,
		334,
		-1,
		281,
		273,
		259,
		-1,
		252,
		-1,
		258,
		219,
		-1,
		221,
		201,
		-1,
		223,
		219,
		-1,
		-1,
		322,
		297,
		-1,
		-1,
		-1,
		282,
		262,
		253,
		237,
		-1,
		212,
		212,
		-1,
		-1,
		-1,
		307,
		306,
		-1,
		275,
		278,
		-1,
		268,
		259,
		267,
		214,
		218,
		-1,
		-1,
		-1,
		316,
		297,
		291,
		290,
		288,
		283,
		280,
		266,
		250,
		228,
		217,
		238,
		-1,
		-1,
		-1,
		288,
		280,
		273,
		-1,
		-1,
		275,
		258,
		239,
		237,
		-1,
		-1,
		-1,
		310,
		291,
		-1,
		-1,
		265,
		-1,
		-1,
		271,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		327,
		299,
		-1,
		-1,
		-1,
		261,
		257,
		258,
		-1,
		-1,
		-1,
		-1,
		321,
		322,
		345,
		309,
		-1,
		-1,
		-1,
		253,
		247,
		-1,
		-1,
		324,
		322,
		-1,
		-1,
		-1,
		281,
		265,
		-1,
		251,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		286,
		-1,
		286,
		261,
		268,
		-1,
		-1,
		-1,
		-1,
		299,
		291,
		299,
		-1,
		271,
		273,
		-1,
		321,
		-1,
		-1,
		314,
		305,
		-1,
		-1,
		276,
		283,
		305,
		308,
		344,
		-1,
		295
	],
	[
		-1,
		120,
		109,
		120,
		128,
		101,
		108,
		-1,
		127,
		131,
		97,
		91,
		130,
		99,
		105,
		116,
		-1,
		-1,
		-1,
		120,
		119,
		87,
		85,
		94,
		99,
		106,
		-1,
		59,
		-1,
		141,
		120,
		131,
		136,
		80,
		77,
		96,
		71,
		52,
		44,
		156,
		110,
		81,
		75,
		89,
		68,
		46,
		38,
		-1,
		81,
		71,
		79,
		57,
		44,
		20,
		-1,
		-1,
		71,
		72,
		68,
		51,
		44,
		0,
		-1,
		61,
		78,
		-1,
		-1,
		65,
		55,
		39,
		41,
		30,
		20,
		53,
		70,
		83,
		-1,
		-1,
		47,
		41,
		48,
		35,
		31,
		54,
		59,
		89,
		98,
		100,
		-1,
		59,
		76,
		74,
		42,
		33,
		35,
		39,
		57,
		88,
		94,
		97,
		-1,
		76,
		72,
		79,
		69,
		64,
		34,
		38,
		44,
		63,
		76,
		95,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		77,
		68,
		85,
		82,
		74,
		55,
		53,
		41,
		47,
		51,
		68,
		84,
		85,
		95,
		-1,
		-1,
		170,
		143,
		167,
		125,
		107,
		-1,
		73,
		75,
		81,
		78,
		72,
		80,
		55,
		57,
		-1,
		62,
		61,
		92,
		78,
		89,
		152,
		-1,
		-1,
		128,
		120,
		102,
		105,
		82,
		78,
		90,
		89,
		85,
		87,
		89,
		80,
		65,
		78,
		85,
		56,
		66,
		70,
		85,
		96,
		-1,
		-1,
		170,
		-1,
		-1,
		149,
		132,
		-1,
		97,
		104,
		88,
		94,
		80,
		101,
		100,
		94,
		101,
		104,
		92,
		78,
		75,
		92,
		78,
		53,
		78,
		82,
		88,
		106,
		107,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		104,
		101,
		94,
		118,
		117,
		-1,
		123,
		121,
		127,
		112,
		117,
		113,
		98,
		83,
		78,
		78,
		75,
		60,
		62,
		99,
		90,
		111,
		108,
		139,
		145,
		139,
		148,
		-1,
		157,
		153,
		149,
		156,
		105,
		-1,
		-1,
		122,
		-1,
		125,
		138,
		135,
		123,
		126,
		113,
		121,
		120,
		104,
		89,
		76,
		73,
		72,
		68,
		77,
		87,
		86,
		104,
		117,
		132,
		136,
		142,
		-1,
		207,
		-1,
		149,
		133,
		135,
		111,
		139,
		-1,
		142,
		126,
		146,
		137,
		137,
		-1,
		129,
		126,
		136,
		119,
		104,
		88,
		76,
		71,
		71,
		75,
		90,
		81,
		99,
		106,
		114,
		118,
		138,
		150,
		167,
		157,
		-1,
		139,
		144,
		114,
		126,
		149,
		169,
		153,
		-1,
		148,
		-1,
		131,
		144,
		-1,
		125,
		121,
		96,
		84,
		73,
		80,
		78,
		72,
		69,
		87,
		90,
		107,
		111,
		127,
		-1,
		-1,
		152,
		156,
		164,
		115,
		134,
		158,
		195,
		162,
		155,
		154,
		-1,
		149,
		132,
		129,
		126,
		113,
		98,
		96,
		79,
		85,
		86,
		71,
		74,
		96,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		141,
		112,
		136,
		178,
		184,
		177,
		165,
		149,
		149,
		143,
		-1,
		137,
		116,
		107,
		96,
		86,
		102,
		92,
		95,
		75,
		77,
		93,
		105,
		96,
		116,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		115,
		149,
		167,
		182,
		168,
		173,
		148,
		141,
		135,
		141,
		133,
		114,
		103,
		95,
		84,
		93,
		103,
		97,
		77,
		86,
		87,
		111,
		118,
		124,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		140,
		147,
		179,
		173,
		186,
		-1,
		140,
		-1,
		129,
		124,
		108,
		103,
		100,
		97,
		91,
		100,
		105,
		91,
		82,
		97,
		116,
		116,
		108,
		133,
		136,
		-1,
		-1,
		-1,
		171,
		188,
		163,
		140,
		121,
		157,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		110,
		106,
		101,
		105,
		98,
		105,
		101,
		100,
		101,
		83,
		119,
		-1,
		116,
		110,
		138,
		141,
		131,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		128,
		180,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		110,
		108,
		102,
		106,
		110,
		99,
		112,
		108,
		88,
		98,
		118,
		122,
		129,
		122,
		127,
		126,
		140,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		148,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		130,
		114,
		117,
		117,
		113,
		121,
		106,
		105,
		91,
		95,
		113,
		140,
		135,
		130,
		129,
		136,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		163,
		-1,
		134,
		149,
		165,
		-1,
		158,
		137,
		152,
		130,
		126,
		122,
		137,
		138,
		116,
		121,
		120,
		130,
		127,
		116,
		103,
		107,
		122,
		132,
		124,
		125,
		134,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		120,
		152,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		136,
		134,
		127,
		118,
		124,
		131,
		134,
		131,
		121,
		110,
		116,
		112,
		134,
		120,
		118,
		137,
		152,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		135,
		119,
		124,
		-1,
		156,
		-1,
		129,
		129,
		120,
		109,
		106,
		117,
		115,
		126,
		143,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		189,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		151,
		131,
		125,
		124,
		151,
		146,
		137,
		118,
		111,
		108,
		109,
		122,
		142,
		133,
		145,
		-1,
		-1,
		-1,
		186,
		172,
		176,
		136,
		155,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		146,
		168,
		156,
		146,
		136,
		170,
		162,
		137,
		130,
		116,
		118,
		116,
		118,
		123,
		144,
		145,
		158,
		-1,
		-1,
		169,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		168,
		184,
		176,
		147,
		157,
		-1,
		-1,
		148,
		146,
		154,
		133,
		120,
		140,
		143,
		133,
		117,
		132,
		144,
		152,
		157,
		-1,
		172,
		159,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		201,
		167,
		179,
		174,
		178,
		151,
		-1,
		150,
		144,
		124,
		138,
		145,
		135,
		130,
		124,
		127,
		145,
		162,
		-1,
		-1,
		184,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		158,
		172,
		167,
		160,
		164,
		-1,
		152,
		140,
		126,
		143,
		148,
		145,
		136,
		128,
		133,
		130,
		143,
		157,
		161,
		207,
		-1,
		190,
		-1,
		-1,
		-1,
		176,
		191,
		206,
		183,
		156,
		151,
		144,
		138,
		134,
		150,
		156,
		167,
		135,
		131,
		132,
		136,
		135,
		152,
		162,
		-1,
		-1,
		190,
		207,
		202,
		184,
		188,
		233,
		-1,
		-1,
		160,
		151,
		142,
		145,
		144,
		147,
		141,
		138,
		143,
		148,
		136,
		145,
		163,
		162,
		-1,
		-1,
		-1,
		210,
		-1,
		225,
		-1,
		-1,
		203,
		231,
		178,
		160,
		156,
		154,
		147,
		156,
		151,
		146,
		156,
		158,
		150,
		138,
		142,
		165,
		154,
		193,
		-1,
		-1,
		329,
		-1,
		-1,
		-1,
		239,
		214,
		229,
		242,
		223,
		230,
		193,
		190,
		-1,
		160,
		185,
		157,
		164,
		155,
		162,
		162,
		154,
		132,
		139,
		155,
		154,
		149,
		185,
		176,
		182,
		-1,
		-1,
		322,
		311,
		300,
		306,
		-1,
		242,
		231,
		228,
		218,
		221,
		-1,
		-1,
		209,
		206,
		182,
		165,
		163,
		156,
		151,
		161,
		141,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		217,
		298,
		291,
		274,
		282,
		313,
		-1,
		232,
		224,
		235,
		210,
		212,
		-1,
		-1,
		182,
		179,
		184,
		172,
		169,
		171,
		166,
		157,
		142,
		148,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		231,
		274,
		268,
		271,
		295,
		309,
		-1,
		229,
		-1,
		-1,
		241,
		213,
		197,
		187,
		181,
		231,
		186,
		181,
		165,
		163,
		154,
		145,
		152,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		266,
		254,
		262,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		257,
		-1,
		224,
		-1,
		199,
		203,
		194,
		197,
		179,
		166,
		158,
		150,
		166,
		141,
		151,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		300,
		256,
		259,
		253,
		281,
		296,
		300,
		-1,
		241,
		280,
		278,
		-1,
		262,
		-1,
		-1,
		-1,
		213,
		207,
		199,
		199,
		178,
		178,
		152,
		156,
		146,
		153,
		163,
		165,
		157,
		161,
		174,
		185,
		188,
		296,
		287,
		300,
		245,
		245,
		266,
		275,
		296,
		256,
		247,
		274,
		285,
		274,
		269,
		256,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		185,
		173,
		156,
		157,
		153,
		156,
		171,
		174,
		164,
		162,
		156,
		188,
		-1,
		289,
		288,
		277,
		274,
		250,
		241,
		236,
		263,
		-1,
		-1,
		258,
		275,
		269,
		273,
		289,
		314,
		-1,
		245,
		-1,
		-1,
		230,
		-1,
		-1,
		215,
		178,
		167,
		158,
		164,
		161,
		172,
		182,
		170,
		171,
		161,
		171,
		184,
		273,
		270,
		258,
		256,
		279,
		244,
		232,
		-1,
		245,
		243,
		249,
		256,
		273,
		303,
		-1,
		-1,
		261,
		241,
		-1,
		-1,
		213,
		211,
		200,
		-1,
		190,
		163,
		168,
		188,
		190,
		179,
		173,
		167,
		174,
		173,
		181,
		189,
		282,
		296,
		285,
		281,
		280,
		288,
		237,
		230,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		247,
		-1,
		-1,
		208,
		201,
		189,
		177,
		167,
		177,
		181,
		185,
		177,
		170,
		165,
		176,
		168,
		172,
		189,
		-1,
		316,
		-1,
		268,
		244,
		258,
		273,
		281,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		242,
		226,
		207,
		-1,
		177,
		190,
		221,
		189,
		194,
		189,
		171,
		182,
		171,
		174,
		188,
		183,
		-1,
		-1,
		256,
		259,
		-1,
		-1,
		258,
		260,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		214,
		210,
		-1,
		-1,
		178,
		203,
		192,
		200,
		195,
		175,
		181,
		184,
		173,
		177,
		189,
		-1,
		-1,
		263,
		264,
		265,
		-1,
		243,
		-1,
		261,
		-1,
		228,
		234,
		222,
		-1,
		-1,
		-1,
		216,
		179,
		200,
		210,
		204,
		202,
		193,
		179,
		186,
		184,
		180,
		191,
		-1,
		-1,
		-1,
		261,
		235,
		268,
		259,
		242,
		222,
		214,
		233,
		-1,
		203,
		-1,
		178,
		180,
		206,
		209,
		215,
		209,
		182,
		197,
		187,
		178,
		187,
		267,
		-1,
		237,
		270,
		234,
		228,
		204,
		208,
		224,
		-1,
		200,
		182,
		-1,
		210,
		200,
		231,
		216,
		197,
		184,
		191,
		191,
		184,
		-1,
		-1,
		-1,
		239,
		238,
		230,
		224,
		224,
		209,
		200,
		-1,
		212,
		194,
		173,
		190,
		190,
		181,
		189,
		221,
		217,
		204,
		204,
		196,
		-1,
		340,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		233,
		228,
		201,
		189,
		195,
		191,
		177,
		183,
		185,
		193,
		191,
		188,
		200,
		196,
		216,
		197,
		232,
		-1,
		335,
		-1,
		269,
		-1,
		-1,
		251,
		231,
		223,
		212,
		201,
		199,
		190,
		181,
		203,
		219,
		203,
		201,
		204,
		205,
		-1,
		324,
		323,
		-1,
		270,
		262,
		248,
		-1,
		241,
		-1,
		247,
		208,
		-1,
		210,
		190,
		-1,
		212,
		208,
		-1,
		-1,
		311,
		286,
		-1,
		-1,
		-1,
		271,
		251,
		242,
		226,
		-1,
		201,
		201,
		-1,
		-1,
		-1,
		296,
		295,
		-1,
		264,
		267,
		-1,
		257,
		248,
		256,
		203,
		207,
		-1,
		-1,
		-1,
		305,
		286,
		280,
		279,
		277,
		272,
		269,
		255,
		239,
		217,
		206,
		227,
		-1,
		-1,
		-1,
		277,
		269,
		262,
		-1,
		-1,
		264,
		247,
		228,
		226,
		-1,
		-1,
		-1,
		299,
		280,
		-1,
		-1,
		254,
		-1,
		-1,
		260,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		288,
		-1,
		-1,
		-1,
		250,
		246,
		247,
		-1,
		-1,
		-1,
		-1,
		310,
		311,
		334,
		298,
		-1,
		-1,
		-1,
		242,
		236,
		-1,
		-1,
		313,
		311,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		240,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		275,
		-1,
		275,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		288,
		280,
		288,
		-1,
		260,
		262,
		-1,
		310,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		265,
		272,
		294,
		297,
		333,
		-1,
		284
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		129,
		118,
		129,
		137,
		110,
		117,
		-1,
		136,
		140,
		106,
		100,
		139,
		108,
		114,
		125,
		-1,
		-1,
		-1,
		129,
		128,
		96,
		94,
		103,
		108,
		115,
		-1,
		105,
		-1,
		150,
		129,
		140,
		145,
		89,
		86,
		106,
		117,
		98,
		90,
		165,
		119,
		90,
		84,
		102,
		92,
		92,
		84,
		-1,
		90,
		80,
		102,
		81,
		86,
		70,
		-1,
		-1,
		84,
		85,
		91,
		77,
		73,
		59,
		-1,
		0,
		47,
		-1,
		-1,
		74,
		75,
		59,
		62,
		61,
		36,
		7,
		20,
		42,
		-1,
		-1,
		65,
		61,
		68,
		55,
		51,
		53,
		16,
		39,
		51,
		53,
		-1,
		77,
		94,
		94,
		62,
		60,
		44,
		48,
		40,
		41,
		50,
		58,
		-1,
		94,
		90,
		97,
		89,
		84,
		60,
		47,
		53,
		72,
		47,
		61,
		70,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		95,
		86,
		103,
		105,
		100,
		81,
		79,
		50,
		56,
		60,
		68,
		63,
		73,
		97,
		-1,
		-1,
		188,
		161,
		185,
		143,
		125,
		-1,
		91,
		93,
		99,
		103,
		98,
		92,
		81,
		66,
		-1,
		71,
		70,
		73,
		80,
		91,
		170,
		-1,
		-1,
		146,
		138,
		120,
		123,
		100,
		96,
		108,
		107,
		103,
		105,
		107,
		89,
		74,
		87,
		94,
		65,
		75,
		79,
		87,
		98,
		-1,
		-1,
		179,
		-1,
		-1,
		167,
		150,
		-1,
		115,
		122,
		106,
		112,
		98,
		119,
		118,
		112,
		119,
		120,
		110,
		87,
		84,
		101,
		87,
		62,
		87,
		91,
		90,
		108,
		109,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		122,
		119,
		112,
		136,
		135,
		-1,
		141,
		139,
		145,
		130,
		133,
		129,
		116,
		92,
		87,
		87,
		84,
		69,
		71,
		108,
		92,
		113,
		110,
		141,
		154,
		148,
		157,
		-1,
		175,
		171,
		167,
		174,
		123,
		-1,
		-1,
		140,
		-1,
		143,
		156,
		153,
		141,
		144,
		131,
		139,
		133,
		116,
		98,
		85,
		82,
		81,
		77,
		86,
		96,
		95,
		113,
		119,
		141,
		145,
		151,
		-1,
		225,
		-1,
		167,
		151,
		153,
		129,
		157,
		-1,
		160,
		144,
		164,
		155,
		155,
		-1,
		147,
		144,
		151,
		129,
		114,
		97,
		85,
		80,
		80,
		84,
		99,
		90,
		108,
		115,
		123,
		127,
		147,
		159,
		185,
		175,
		-1,
		157,
		162,
		132,
		144,
		167,
		187,
		171,
		-1,
		166,
		-1,
		149,
		162,
		-1,
		135,
		131,
		105,
		93,
		82,
		89,
		87,
		81,
		78,
		96,
		99,
		116,
		120,
		136,
		-1,
		-1,
		170,
		174,
		182,
		133,
		152,
		176,
		213,
		180,
		173,
		172,
		-1,
		167,
		141,
		138,
		135,
		122,
		107,
		105,
		88,
		94,
		95,
		80,
		83,
		105,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		159,
		130,
		154,
		196,
		202,
		195,
		183,
		158,
		158,
		152,
		-1,
		146,
		125,
		116,
		105,
		95,
		111,
		101,
		104,
		84,
		86,
		102,
		114,
		105,
		125,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		133,
		167,
		185,
		191,
		177,
		182,
		157,
		150,
		144,
		150,
		142,
		123,
		112,
		104,
		93,
		102,
		112,
		106,
		86,
		95,
		96,
		120,
		127,
		133,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		158,
		165,
		197,
		182,
		195,
		-1,
		149,
		-1,
		138,
		133,
		117,
		112,
		109,
		106,
		100,
		109,
		114,
		100,
		91,
		106,
		125,
		125,
		117,
		142,
		145,
		-1,
		-1,
		-1,
		189,
		206,
		181,
		158,
		139,
		175,
		-1,
		165,
		166,
		-1,
		143,
		137,
		134,
		119,
		115,
		110,
		114,
		107,
		114,
		110,
		109,
		110,
		92,
		128,
		-1,
		125,
		119,
		147,
		150,
		140,
		-1,
		-1,
		-1,
		204,
		183,
		176,
		196,
		146,
		198,
		-1,
		-1,
		150,
		143,
		-1,
		130,
		112,
		119,
		117,
		111,
		115,
		119,
		108,
		121,
		117,
		97,
		107,
		127,
		131,
		138,
		131,
		136,
		135,
		149,
		-1,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		166,
		-1,
		159,
		151,
		141,
		135,
		129,
		125,
		123,
		139,
		123,
		126,
		126,
		122,
		130,
		115,
		114,
		100,
		104,
		122,
		149,
		144,
		139,
		138,
		145,
		-1,
		234,
		220,
		191,
		-1,
		-1,
		180,
		-1,
		144,
		158,
		174,
		-1,
		167,
		146,
		161,
		139,
		135,
		131,
		146,
		147,
		125,
		130,
		129,
		139,
		136,
		125,
		112,
		116,
		131,
		141,
		133,
		134,
		143,
		-1,
		240,
		227,
		185,
		181,
		170,
		190,
		141,
		129,
		161,
		-1,
		-1,
		203,
		-1,
		137,
		154,
		145,
		143,
		136,
		127,
		133,
		140,
		143,
		140,
		130,
		119,
		125,
		121,
		143,
		129,
		127,
		146,
		161,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		156,
		143,
		137,
		-1,
		178,
		-1,
		181,
		171,
		155,
		140,
		173,
		-1,
		144,
		128,
		133,
		-1,
		165,
		-1,
		138,
		138,
		129,
		118,
		115,
		126,
		124,
		135,
		152,
		-1,
		190,
		175,
		168,
		158,
		172,
		143,
		-1,
		198,
		-1,
		-1,
		168,
		162,
		162,
		146,
		149,
		160,
		140,
		134,
		133,
		160,
		155,
		146,
		127,
		120,
		117,
		118,
		131,
		151,
		142,
		154,
		-1,
		-1,
		-1,
		195,
		181,
		185,
		145,
		164,
		-1,
		-1,
		230,
		185,
		171,
		-1,
		155,
		177,
		165,
		155,
		145,
		179,
		171,
		146,
		139,
		125,
		127,
		125,
		127,
		132,
		153,
		154,
		167,
		-1,
		-1,
		178,
		183,
		171,
		157,
		176,
		-1,
		-1,
		-1,
		177,
		193,
		185,
		156,
		166,
		-1,
		-1,
		157,
		155,
		163,
		142,
		129,
		149,
		152,
		142,
		126,
		141,
		153,
		161,
		166,
		-1,
		181,
		168,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		188,
		183,
		187,
		160,
		-1,
		159,
		153,
		133,
		147,
		154,
		144,
		139,
		133,
		136,
		154,
		171,
		-1,
		-1,
		193,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		167,
		181,
		176,
		169,
		173,
		-1,
		161,
		149,
		135,
		152,
		157,
		154,
		145,
		137,
		142,
		139,
		152,
		166,
		170,
		216,
		-1,
		199,
		-1,
		-1,
		-1,
		185,
		200,
		215,
		192,
		165,
		160,
		153,
		147,
		143,
		159,
		165,
		176,
		144,
		140,
		141,
		145,
		144,
		161,
		171,
		-1,
		-1,
		199,
		216,
		211,
		193,
		197,
		242,
		-1,
		-1,
		169,
		160,
		151,
		154,
		153,
		156,
		150,
		147,
		152,
		157,
		145,
		154,
		172,
		171,
		-1,
		-1,
		-1,
		219,
		-1,
		234,
		-1,
		-1,
		212,
		240,
		187,
		169,
		165,
		163,
		156,
		165,
		160,
		155,
		165,
		167,
		159,
		147,
		151,
		174,
		163,
		202,
		-1,
		-1,
		338,
		-1,
		-1,
		-1,
		248,
		223,
		238,
		251,
		232,
		239,
		202,
		199,
		-1,
		169,
		194,
		166,
		173,
		164,
		171,
		171,
		163,
		141,
		148,
		164,
		163,
		158,
		194,
		185,
		191,
		-1,
		-1,
		331,
		320,
		309,
		315,
		-1,
		251,
		240,
		237,
		227,
		230,
		-1,
		-1,
		218,
		215,
		191,
		174,
		172,
		165,
		160,
		170,
		150,
		137,
		141,
		145,
		151,
		156,
		161,
		167,
		182,
		197,
		-1,
		226,
		307,
		300,
		283,
		291,
		322,
		-1,
		241,
		233,
		244,
		219,
		221,
		-1,
		-1,
		191,
		188,
		193,
		181,
		178,
		180,
		175,
		166,
		151,
		157,
		144,
		143,
		161,
		165,
		174,
		181,
		171,
		184,
		188,
		-1,
		240,
		283,
		277,
		280,
		304,
		318,
		-1,
		238,
		-1,
		-1,
		250,
		222,
		206,
		196,
		190,
		240,
		195,
		190,
		174,
		172,
		163,
		154,
		161,
		152,
		152,
		155,
		170,
		175,
		167,
		181,
		181,
		182,
		-1,
		275,
		263,
		271,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		266,
		-1,
		233,
		-1,
		208,
		212,
		203,
		206,
		188,
		175,
		167,
		159,
		175,
		150,
		160,
		156,
		157,
		166,
		177,
		189,
		188,
		189,
		309,
		265,
		268,
		262,
		290,
		305,
		309,
		-1,
		250,
		289,
		287,
		-1,
		271,
		-1,
		-1,
		-1,
		222,
		216,
		208,
		208,
		187,
		187,
		161,
		165,
		155,
		162,
		172,
		174,
		166,
		170,
		183,
		194,
		197,
		305,
		296,
		309,
		254,
		254,
		275,
		284,
		305,
		265,
		256,
		283,
		294,
		283,
		278,
		265,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		194,
		182,
		165,
		166,
		162,
		165,
		180,
		183,
		173,
		171,
		165,
		197,
		-1,
		298,
		297,
		286,
		283,
		259,
		250,
		245,
		272,
		-1,
		-1,
		267,
		284,
		278,
		282,
		298,
		323,
		-1,
		254,
		-1,
		-1,
		239,
		-1,
		-1,
		224,
		187,
		176,
		167,
		173,
		170,
		181,
		191,
		179,
		180,
		170,
		180,
		193,
		282,
		279,
		267,
		265,
		288,
		253,
		241,
		-1,
		254,
		252,
		258,
		265,
		282,
		312,
		-1,
		-1,
		270,
		250,
		-1,
		-1,
		222,
		220,
		209,
		-1,
		199,
		172,
		177,
		197,
		199,
		188,
		182,
		176,
		183,
		182,
		190,
		198,
		291,
		305,
		294,
		290,
		289,
		297,
		246,
		239,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		-1,
		260,
		256,
		-1,
		-1,
		217,
		210,
		198,
		186,
		176,
		186,
		190,
		194,
		186,
		179,
		174,
		185,
		177,
		181,
		198,
		-1,
		325,
		-1,
		277,
		253,
		267,
		282,
		290,
		-1,
		-1,
		-1,
		277,
		263,
		256,
		244,
		242,
		-1,
		251,
		235,
		216,
		-1,
		186,
		199,
		230,
		198,
		203,
		198,
		180,
		191,
		180,
		183,
		197,
		192,
		-1,
		-1,
		265,
		268,
		-1,
		-1,
		267,
		269,
		-1,
		268,
		257,
		242,
		234,
		-1,
		-1,
		223,
		219,
		-1,
		-1,
		187,
		212,
		201,
		209,
		204,
		184,
		190,
		193,
		182,
		186,
		198,
		-1,
		-1,
		272,
		273,
		274,
		-1,
		252,
		-1,
		270,
		-1,
		237,
		243,
		231,
		-1,
		-1,
		-1,
		225,
		188,
		209,
		219,
		213,
		211,
		202,
		188,
		195,
		193,
		189,
		200,
		-1,
		-1,
		-1,
		270,
		244,
		277,
		268,
		251,
		231,
		223,
		242,
		-1,
		212,
		-1,
		187,
		189,
		215,
		218,
		224,
		218,
		191,
		206,
		196,
		187,
		196,
		276,
		-1,
		246,
		279,
		243,
		237,
		213,
		217,
		233,
		-1,
		209,
		191,
		-1,
		219,
		209,
		240,
		225,
		206,
		193,
		200,
		200,
		193,
		-1,
		-1,
		-1,
		248,
		247,
		239,
		233,
		233,
		218,
		209,
		-1,
		221,
		203,
		182,
		199,
		199,
		190,
		198,
		230,
		226,
		213,
		213,
		205,
		-1,
		349,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		242,
		237,
		210,
		198,
		204,
		200,
		186,
		192,
		194,
		202,
		200,
		197,
		209,
		205,
		225,
		206,
		241,
		-1,
		344,
		-1,
		278,
		-1,
		-1,
		260,
		240,
		232,
		221,
		210,
		208,
		199,
		190,
		212,
		228,
		212,
		210,
		213,
		214,
		-1,
		333,
		332,
		-1,
		279,
		271,
		257,
		-1,
		250,
		-1,
		256,
		217,
		-1,
		219,
		199,
		-1,
		221,
		217,
		-1,
		-1,
		320,
		295,
		-1,
		-1,
		-1,
		280,
		260,
		251,
		235,
		-1,
		210,
		210,
		-1,
		-1,
		-1,
		305,
		304,
		-1,
		273,
		276,
		-1,
		266,
		257,
		265,
		212,
		216,
		-1,
		-1,
		-1,
		314,
		295,
		289,
		288,
		286,
		281,
		278,
		264,
		248,
		226,
		215,
		236,
		-1,
		-1,
		-1,
		286,
		278,
		271,
		-1,
		-1,
		273,
		256,
		237,
		235,
		-1,
		-1,
		-1,
		308,
		289,
		-1,
		-1,
		263,
		-1,
		-1,
		269,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		325,
		297,
		-1,
		-1,
		-1,
		259,
		255,
		256,
		-1,
		-1,
		-1,
		-1,
		319,
		320,
		343,
		307,
		-1,
		-1,
		-1,
		251,
		245,
		-1,
		-1,
		322,
		320,
		-1,
		-1,
		-1,
		279,
		263,
		-1,
		249,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		284,
		-1,
		284,
		259,
		266,
		-1,
		-1,
		-1,
		-1,
		297,
		289,
		297,
		-1,
		269,
		271,
		-1,
		319,
		-1,
		-1,
		312,
		303,
		-1,
		-1,
		274,
		281,
		303,
		306,
		342,
		-1,
		293
	],
	[
		-1,
		156,
		145,
		156,
		164,
		137,
		144,
		-1,
		163,
		167,
		133,
		127,
		166,
		135,
		141,
		152,
		-1,
		-1,
		-1,
		156,
		155,
		123,
		121,
		130,
		135,
		142,
		-1,
		101,
		-1,
		177,
		156,
		167,
		172,
		116,
		113,
		133,
		113,
		94,
		86,
		192,
		146,
		117,
		111,
		129,
		110,
		88,
		80,
		-1,
		117,
		107,
		121,
		99,
		86,
		62,
		-1,
		-1,
		111,
		112,
		110,
		93,
		86,
		74,
		-1,
		47,
		0,
		-1,
		-1,
		101,
		102,
		86,
		83,
		72,
		72,
		43,
		29,
		5,
		-1,
		-1,
		92,
		88,
		95,
		82,
		78,
		89,
		52,
		17,
		20,
		22,
		-1,
		102,
		120,
		121,
		89,
		87,
		71,
		69,
		71,
		22,
		31,
		31,
		-1,
		119,
		115,
		118,
		116,
		111,
		87,
		74,
		74,
		84,
		32,
		34,
		43,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		120,
		111,
		130,
		114,
		104,
		108,
		106,
		77,
		74,
		72,
		53,
		44,
		46,
		70,
		-1,
		-1,
		213,
		186,
		210,
		168,
		150,
		-1,
		116,
		118,
		112,
		108,
		102,
		95,
		108,
		93,
		-1,
		63,
		57,
		54,
		53,
		64,
		195,
		-1,
		-1,
		171,
		163,
		145,
		148,
		125,
		121,
		133,
		132,
		125,
		118,
		114,
		92,
		95,
		95,
		101,
		57,
		63,
		60,
		60,
		71,
		-1,
		-1,
		171,
		-1,
		-1,
		192,
		175,
		-1,
		140,
		147,
		131,
		137,
		123,
		144,
		143,
		134,
		128,
		123,
		115,
		90,
		87,
		100,
		79,
		54,
		70,
		73,
		63,
		81,
		82,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		147,
		144,
		137,
		161,
		160,
		-1,
		163,
		151,
		152,
		137,
		136,
		130,
		118,
		95,
		79,
		79,
		76,
		61,
		63,
		97,
		65,
		86,
		83,
		114,
		146,
		140,
		149,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		165,
		-1,
		168,
		181,
		175,
		148,
		151,
		138,
		138,
		125,
		114,
		96,
		77,
		74,
		73,
		69,
		78,
		70,
		73,
		89,
		92,
		133,
		137,
		143,
		-1,
		250,
		-1,
		192,
		176,
		178,
		154,
		182,
		-1,
		185,
		169,
		189,
		177,
		177,
		-1,
		154,
		151,
		143,
		121,
		106,
		89,
		77,
		72,
		72,
		76,
		91,
		77,
		95,
		97,
		104,
		119,
		139,
		151,
		210,
		200,
		-1,
		182,
		187,
		157,
		169,
		191,
		212,
		193,
		-1,
		188,
		-1,
		156,
		169,
		-1,
		127,
		123,
		97,
		85,
		74,
		81,
		79,
		73,
		70,
		83,
		86,
		108,
		112,
		128,
		-1,
		-1,
		195,
		199,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		133,
		130,
		127,
		114,
		99,
		97,
		80,
		86,
		87,
		72,
		75,
		92,
		125,
		103,
		115,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		87,
		103,
		93,
		96,
		76,
		78,
		94,
		106,
		97,
		117,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		142,
		134,
		115,
		104,
		96,
		85,
		94,
		104,
		98,
		78,
		87,
		88,
		112,
		119,
		125,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		98,
		92,
		101,
		106,
		92,
		83,
		98,
		117,
		117,
		109,
		134,
		137,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		102,
		106,
		99,
		106,
		102,
		101,
		102,
		84,
		120,
		-1,
		117,
		111,
		139,
		142,
		132,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		111,
		109,
		103,
		107,
		111,
		100,
		113,
		109,
		89,
		99,
		119,
		123,
		130,
		123,
		128,
		127,
		141,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		118,
		118,
		114,
		122,
		107,
		106,
		92,
		96,
		114,
		141,
		136,
		131,
		130,
		137,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		122,
		121,
		131,
		128,
		117,
		104,
		108,
		123,
		133,
		125,
		126,
		135,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		132,
		135,
		132,
		122,
		111,
		117,
		113,
		135,
		121,
		119,
		138,
		153,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		136,
		120,
		125,
		-1,
		157,
		-1,
		130,
		130,
		121,
		110,
		107,
		118,
		116,
		127,
		144,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		152,
		132,
		126,
		125,
		152,
		147,
		138,
		119,
		112,
		109,
		110,
		123,
		143,
		134,
		146,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		169,
		157,
		147,
		137,
		171,
		163,
		138,
		131,
		117,
		119,
		117,
		119,
		124,
		145,
		146,
		159,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		158,
		-1,
		-1,
		149,
		147,
		155,
		134,
		121,
		141,
		144,
		134,
		118,
		133,
		145,
		153,
		158,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		202,
		168,
		180,
		175,
		179,
		152,
		-1,
		151,
		145,
		125,
		139,
		146,
		136,
		131,
		125,
		128,
		146,
		163,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		159,
		173,
		168,
		161,
		165,
		-1,
		153,
		141,
		127,
		144,
		149,
		146,
		137,
		129,
		134,
		131,
		144,
		158,
		162,
		208,
		-1,
		191,
		-1,
		-1,
		-1,
		177,
		192,
		207,
		184,
		157,
		152,
		145,
		139,
		135,
		151,
		157,
		168,
		136,
		132,
		133,
		137,
		136,
		153,
		163,
		-1,
		-1,
		191,
		208,
		203,
		185,
		189,
		234,
		-1,
		-1,
		161,
		152,
		143,
		146,
		145,
		148,
		142,
		139,
		144,
		149,
		137,
		146,
		164,
		163,
		-1,
		-1,
		-1,
		211,
		-1,
		226,
		-1,
		-1,
		204,
		232,
		179,
		161,
		157,
		155,
		148,
		157,
		152,
		147,
		157,
		159,
		151,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		240,
		215,
		230,
		243,
		224,
		231,
		194,
		191,
		-1,
		161,
		186,
		158,
		165,
		156,
		163,
		163,
		155,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		323,
		312,
		301,
		307,
		-1,
		243,
		232,
		229,
		219,
		222,
		-1,
		-1,
		210,
		207,
		183,
		166,
		164,
		157,
		152,
		162,
		142,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		218,
		299,
		292,
		275,
		283,
		314,
		-1,
		233,
		225,
		236,
		211,
		213,
		-1,
		-1,
		183,
		180,
		185,
		173,
		170,
		172,
		167,
		158,
		143,
		149,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		232,
		275,
		269,
		272,
		296,
		310,
		-1,
		230,
		-1,
		-1,
		242,
		214,
		198,
		188,
		182,
		232,
		187,
		182,
		166,
		164,
		155,
		146,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		267,
		255,
		263,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		258,
		-1,
		225,
		-1,
		200,
		204,
		195,
		198,
		180,
		167,
		159,
		151,
		167,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		301,
		257,
		260,
		254,
		282,
		297,
		301,
		-1,
		242,
		281,
		279,
		-1,
		263,
		-1,
		-1,
		-1,
		214,
		208,
		200,
		200,
		179,
		179,
		153,
		157,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		297,
		288,
		301,
		246,
		246,
		267,
		276,
		297,
		257,
		248,
		275,
		286,
		275,
		270,
		257,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		186,
		174,
		157,
		158,
		154,
		157,
		172,
		175,
		165,
		163,
		157,
		189,
		-1,
		290,
		289,
		278,
		275,
		251,
		242,
		237,
		264,
		-1,
		-1,
		259,
		276,
		270,
		274,
		290,
		315,
		-1,
		246,
		-1,
		-1,
		231,
		-1,
		-1,
		216,
		179,
		168,
		159,
		165,
		162,
		173,
		183,
		171,
		172,
		162,
		172,
		185,
		274,
		271,
		259,
		257,
		280,
		245,
		233,
		-1,
		246,
		244,
		250,
		257,
		274,
		304,
		-1,
		-1,
		262,
		242,
		-1,
		-1,
		214,
		212,
		201,
		-1,
		191,
		164,
		169,
		189,
		191,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		283,
		297,
		286,
		282,
		281,
		289,
		238,
		231,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		-1,
		252,
		248,
		-1,
		-1,
		209,
		202,
		190,
		178,
		168,
		178,
		182,
		186,
		178,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		317,
		-1,
		269,
		245,
		259,
		274,
		282,
		-1,
		-1,
		-1,
		269,
		255,
		248,
		236,
		234,
		-1,
		243,
		227,
		208,
		-1,
		178,
		191,
		222,
		190,
		195,
		190,
		172,
		183,
		172,
		175,
		189,
		184,
		-1,
		-1,
		257,
		260,
		-1,
		-1,
		259,
		261,
		-1,
		260,
		249,
		234,
		226,
		-1,
		-1,
		215,
		211,
		-1,
		-1,
		179,
		204,
		193,
		201,
		196,
		176,
		182,
		185,
		174,
		178,
		190,
		-1,
		-1,
		264,
		265,
		266,
		-1,
		244,
		-1,
		262,
		-1,
		229,
		235,
		223,
		-1,
		-1,
		-1,
		217,
		180,
		201,
		211,
		205,
		203,
		194,
		180,
		187,
		185,
		181,
		192,
		-1,
		-1,
		-1,
		262,
		236,
		269,
		260,
		243,
		223,
		215,
		234,
		-1,
		204,
		-1,
		179,
		181,
		207,
		210,
		216,
		210,
		183,
		198,
		188,
		179,
		188,
		268,
		-1,
		238,
		271,
		235,
		229,
		205,
		209,
		225,
		-1,
		201,
		183,
		-1,
		211,
		201,
		232,
		217,
		198,
		185,
		192,
		192,
		185,
		-1,
		-1,
		-1,
		240,
		239,
		231,
		225,
		225,
		210,
		201,
		-1,
		213,
		195,
		174,
		191,
		191,
		182,
		190,
		222,
		218,
		205,
		205,
		197,
		-1,
		341,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		234,
		229,
		202,
		190,
		196,
		192,
		178,
		184,
		186,
		194,
		192,
		189,
		201,
		197,
		217,
		198,
		233,
		-1,
		336,
		-1,
		270,
		-1,
		-1,
		252,
		232,
		224,
		213,
		202,
		200,
		191,
		182,
		204,
		220,
		204,
		202,
		205,
		206,
		-1,
		325,
		324,
		-1,
		271,
		263,
		249,
		-1,
		242,
		-1,
		248,
		209,
		-1,
		211,
		191,
		-1,
		213,
		209,
		-1,
		-1,
		312,
		287,
		-1,
		-1,
		-1,
		272,
		252,
		243,
		227,
		-1,
		202,
		202,
		-1,
		-1,
		-1,
		297,
		296,
		-1,
		265,
		268,
		-1,
		258,
		249,
		257,
		204,
		208,
		-1,
		-1,
		-1,
		306,
		287,
		281,
		280,
		278,
		273,
		270,
		256,
		240,
		218,
		207,
		228,
		-1,
		-1,
		-1,
		278,
		270,
		263,
		-1,
		-1,
		265,
		248,
		229,
		227,
		-1,
		-1,
		-1,
		300,
		281,
		-1,
		-1,
		255,
		-1,
		-1,
		261,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		317,
		289,
		-1,
		-1,
		-1,
		251,
		247,
		248,
		-1,
		-1,
		-1,
		-1,
		311,
		312,
		335,
		299,
		-1,
		-1,
		-1,
		243,
		237,
		-1,
		-1,
		314,
		312,
		-1,
		-1,
		-1,
		271,
		255,
		-1,
		241,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		276,
		-1,
		276,
		251,
		258,
		-1,
		-1,
		-1,
		-1,
		289,
		281,
		289,
		-1,
		261,
		263,
		-1,
		311,
		-1,
		-1,
		304,
		295,
		-1,
		-1,
		266,
		273,
		295,
		298,
		334,
		-1,
		285
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		56,
		45,
		56,
		64,
		37,
		44,
		-1,
		62,
		67,
		33,
		27,
		65,
		34,
		40,
		51,
		-1,
		-1,
		-1,
		56,
		55,
		22,
		20,
		29,
		34,
		41,
		-1,
		76,
		-1,
		77,
		56,
		67,
		72,
		15,
		12,
		32,
		51,
		68,
		64,
		92,
		45,
		16,
		10,
		28,
		33,
		62,
		54,
		-1,
		16,
		6,
		28,
		32,
		47,
		51,
		-1,
		-1,
		10,
		11,
		17,
		32,
		51,
		57,
		-1,
		67,
		86,
		-1,
		-1,
		0,
		13,
		26,
		29,
		37,
		46,
		59,
		76,
		81,
		-1,
		-1,
		18,
		22,
		32,
		33,
		29,
		46,
		65,
		76,
		90,
		89,
		-1,
		20,
		38,
		47,
		40,
		38,
		22,
		26,
		44,
		75,
		81,
		84,
		-1,
		37,
		33,
		43,
		49,
		60,
		38,
		25,
		31,
		50,
		63,
		82,
		73,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		38,
		29,
		49,
		51,
		50,
		59,
		57,
		28,
		34,
		38,
		55,
		71,
		72,
		82,
		-1,
		-1,
		131,
		104,
		128,
		86,
		68,
		-1,
		34,
		36,
		42,
		46,
		51,
		59,
		59,
		44,
		-1,
		49,
		48,
		79,
		65,
		76,
		113,
		-1,
		-1,
		89,
		81,
		63,
		66,
		43,
		39,
		51,
		50,
		46,
		48,
		50,
		62,
		52,
		65,
		72,
		43,
		53,
		57,
		72,
		83,
		-1,
		-1,
		157,
		-1,
		-1,
		110,
		93,
		-1,
		58,
		65,
		49,
		55,
		41,
		62,
		61,
		55,
		62,
		65,
		53,
		65,
		62,
		79,
		65,
		40,
		65,
		69,
		75,
		93,
		94,
		-1,
		156,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		65,
		62,
		55,
		79,
		78,
		-1,
		84,
		82,
		88,
		73,
		78,
		74,
		59,
		70,
		65,
		65,
		62,
		47,
		49,
		86,
		77,
		98,
		95,
		126,
		132,
		126,
		135,
		-1,
		118,
		114,
		110,
		117,
		66,
		-1,
		-1,
		83,
		-1,
		86,
		99,
		96,
		84,
		87,
		74,
		82,
		81,
		65,
		76,
		63,
		60,
		59,
		55,
		64,
		74,
		73,
		91,
		104,
		119,
		123,
		129,
		-1,
		168,
		-1,
		110,
		94,
		96,
		72,
		100,
		-1,
		103,
		87,
		107,
		98,
		98,
		-1,
		90,
		87,
		97,
		80,
		65,
		75,
		63,
		58,
		58,
		62,
		77,
		68,
		86,
		93,
		101,
		105,
		125,
		137,
		128,
		118,
		-1,
		100,
		105,
		75,
		87,
		110,
		130,
		114,
		-1,
		109,
		-1,
		92,
		105,
		-1,
		86,
		82,
		71,
		71,
		60,
		67,
		65,
		59,
		56,
		74,
		77,
		94,
		98,
		114,
		-1,
		-1,
		113,
		117,
		125,
		76,
		95,
		119,
		156,
		123,
		116,
		115,
		-1,
		110,
		107,
		104,
		105,
		91,
		84,
		83,
		66,
		72,
		73,
		58,
		61,
		83,
		111,
		89,
		101,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		102,
		73,
		97,
		139,
		145,
		138,
		126,
		136,
		136,
		130,
		-1,
		122,
		101,
		94,
		83,
		73,
		89,
		79,
		82,
		62,
		64,
		80,
		92,
		83,
		103,
		-1,
		-1,
		-1,
		132,
		121,
		122,
		76,
		110,
		128,
		169,
		155,
		160,
		135,
		128,
		122,
		116,
		118,
		101,
		90,
		82,
		71,
		80,
		90,
		84,
		64,
		73,
		74,
		98,
		105,
		111,
		-1,
		-1,
		139,
		129,
		113,
		115,
		112,
		101,
		108,
		140,
		160,
		173,
		-1,
		127,
		-1,
		116,
		111,
		95,
		90,
		87,
		84,
		78,
		87,
		92,
		78,
		69,
		84,
		103,
		103,
		95,
		120,
		123,
		-1,
		-1,
		-1,
		132,
		149,
		124,
		101,
		82,
		118,
		-1,
		143,
		144,
		-1,
		121,
		115,
		112,
		97,
		93,
		88,
		92,
		85,
		92,
		88,
		87,
		88,
		70,
		106,
		-1,
		103,
		97,
		125,
		128,
		118,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		89,
		141,
		-1,
		-1,
		128,
		121,
		-1,
		108,
		90,
		97,
		95,
		89,
		93,
		97,
		86,
		99,
		95,
		75,
		85,
		105,
		109,
		116,
		109,
		114,
		113,
		127,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		109,
		-1,
		137,
		129,
		119,
		113,
		107,
		103,
		101,
		117,
		101,
		104,
		104,
		100,
		108,
		93,
		92,
		78,
		82,
		100,
		127,
		122,
		117,
		116,
		123,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		124,
		-1,
		95,
		119,
		135,
		-1,
		145,
		124,
		139,
		117,
		113,
		109,
		124,
		125,
		103,
		108,
		107,
		117,
		114,
		103,
		90,
		94,
		109,
		119,
		111,
		112,
		121,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		98,
		107,
		122,
		-1,
		-1,
		181,
		-1,
		115,
		132,
		123,
		121,
		114,
		105,
		111,
		118,
		121,
		118,
		108,
		97,
		103,
		99,
		121,
		107,
		105,
		124,
		139,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		159,
		149,
		133,
		118,
		151,
		-1,
		122,
		106,
		111,
		-1,
		143,
		-1,
		116,
		116,
		107,
		96,
		93,
		104,
		102,
		113,
		130,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		155,
		-1,
		-1,
		146,
		140,
		140,
		124,
		127,
		138,
		118,
		112,
		111,
		138,
		133,
		124,
		105,
		98,
		95,
		96,
		109,
		129,
		120,
		132,
		-1,
		-1,
		-1,
		156,
		136,
		142,
		100,
		121,
		-1,
		-1,
		208,
		163,
		149,
		-1,
		133,
		155,
		143,
		133,
		123,
		157,
		149,
		124,
		117,
		103,
		105,
		103,
		105,
		110,
		131,
		132,
		145,
		-1,
		-1,
		133,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		155,
		171,
		163,
		134,
		144,
		-1,
		-1,
		135,
		133,
		141,
		120,
		107,
		127,
		130,
		120,
		104,
		119,
		131,
		139,
		144,
		-1,
		136,
		123,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		166,
		161,
		165,
		138,
		-1,
		137,
		131,
		111,
		125,
		132,
		122,
		117,
		111,
		114,
		132,
		149,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		145,
		159,
		154,
		147,
		151,
		-1,
		139,
		127,
		113,
		130,
		135,
		132,
		123,
		115,
		120,
		117,
		130,
		144,
		148,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		163,
		178,
		193,
		170,
		143,
		138,
		131,
		125,
		121,
		137,
		143,
		154,
		122,
		118,
		119,
		123,
		122,
		139,
		149,
		-1,
		-1,
		156,
		173,
		189,
		171,
		175,
		220,
		-1,
		-1,
		147,
		138,
		129,
		132,
		131,
		134,
		128,
		125,
		130,
		135,
		123,
		132,
		150,
		149,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		190,
		218,
		165,
		147,
		143,
		141,
		134,
		143,
		138,
		133,
		143,
		145,
		137,
		125,
		129,
		152,
		141,
		180,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		205,
		180,
		195,
		229,
		210,
		217,
		180,
		177,
		-1,
		147,
		172,
		144,
		151,
		142,
		149,
		149,
		141,
		119,
		126,
		142,
		141,
		136,
		172,
		163,
		169,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		211,
		197,
		215,
		205,
		208,
		-1,
		-1,
		196,
		193,
		169,
		152,
		150,
		143,
		138,
		148,
		128,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		214,
		211,
		204,
		197,
		199,
		-1,
		-1,
		169,
		166,
		171,
		159,
		156,
		158,
		153,
		144,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		216,
		-1,
		-1,
		212,
		200,
		184,
		174,
		168,
		218,
		173,
		168,
		152,
		150,
		141,
		132,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		228,
		-1,
		211,
		-1,
		186,
		190,
		181,
		184,
		166,
		153,
		145,
		137,
		153,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		287,
		243,
		226,
		217,
		264,
		279,
		283,
		-1,
		228,
		267,
		265,
		-1,
		237,
		-1,
		-1,
		-1,
		200,
		194,
		186,
		186,
		165,
		165,
		139,
		143,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		283,
		274,
		287,
		232,
		231,
		249,
		258,
		279,
		243,
		234,
		261,
		272,
		261,
		256,
		243,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		172,
		160,
		143,
		144,
		140,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		276,
		275,
		264,
		261,
		237,
		228,
		223,
		250,
		-1,
		-1,
		245,
		262,
		256,
		260,
		276,
		301,
		-1,
		232,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		165,
		154,
		145,
		151,
		148,
		159,
		169,
		157,
		158,
		148,
		158,
		171,
		260,
		257,
		245,
		243,
		266,
		231,
		219,
		-1,
		232,
		230,
		236,
		243,
		260,
		290,
		-1,
		-1,
		248,
		228,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		150,
		155,
		175,
		177,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		269,
		283,
		272,
		268,
		267,
		275,
		224,
		217,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		238,
		234,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		168,
		172,
		164,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		303,
		-1,
		255,
		231,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		255,
		241,
		234,
		222,
		220,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		208,
		176,
		181,
		176,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		245,
		247,
		-1,
		246,
		235,
		220,
		212,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		165,
		190,
		179,
		187,
		182,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		250,
		251,
		252,
		-1,
		230,
		-1,
		248,
		-1,
		215,
		221,
		209,
		-1,
		-1,
		-1,
		203,
		166,
		187,
		197,
		191,
		189,
		180,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		248,
		222,
		255,
		246,
		229,
		209,
		201,
		220,
		-1,
		190,
		-1,
		165,
		167,
		193,
		196,
		202,
		196,
		169,
		184,
		174,
		165,
		174,
		254,
		-1,
		224,
		257,
		221,
		215,
		191,
		195,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		218,
		203,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		226,
		225,
		217,
		211,
		211,
		196,
		187,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		208,
		204,
		191,
		191,
		183,
		-1,
		327,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		220,
		215,
		188,
		176,
		182,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		184,
		219,
		-1,
		322,
		-1,
		256,
		-1,
		-1,
		238,
		218,
		210,
		199,
		188,
		186,
		177,
		168,
		190,
		206,
		190,
		188,
		191,
		192,
		-1,
		311,
		310,
		-1,
		257,
		249,
		235,
		-1,
		228,
		-1,
		234,
		195,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		298,
		273,
		-1,
		-1,
		-1,
		258,
		238,
		229,
		213,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		283,
		282,
		-1,
		251,
		254,
		-1,
		244,
		235,
		243,
		190,
		194,
		-1,
		-1,
		-1,
		292,
		273,
		267,
		266,
		264,
		259,
		256,
		242,
		226,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		264,
		256,
		249,
		-1,
		-1,
		251,
		234,
		215,
		213,
		-1,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		241,
		-1,
		-1,
		247,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		275,
		-1,
		-1,
		-1,
		237,
		233,
		234,
		-1,
		-1,
		-1,
		-1,
		297,
		298,
		321,
		285,
		-1,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		300,
		298,
		-1,
		-1,
		-1,
		257,
		241,
		-1,
		227,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		262,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		275,
		267,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		290,
		281,
		-1,
		-1,
		252,
		259,
		281,
		284,
		320,
		-1,
		271
	],
	[
		-1,
		66,
		55,
		66,
		74,
		47,
		54,
		-1,
		72,
		77,
		43,
		37,
		75,
		44,
		50,
		61,
		-1,
		-1,
		-1,
		66,
		65,
		32,
		30,
		39,
		44,
		51,
		-1,
		77,
		-1,
		87,
		66,
		77,
		82,
		25,
		22,
		42,
		61,
		69,
		62,
		102,
		55,
		26,
		20,
		38,
		41,
		63,
		55,
		-1,
		26,
		16,
		38,
		37,
		48,
		47,
		-1,
		-1,
		16,
		17,
		25,
		33,
		47,
		58,
		-1,
		77,
		96,
		-1,
		-1,
		10,
		0,
		22,
		25,
		33,
		49,
		69,
		86,
		91,
		-1,
		-1,
		14,
		18,
		27,
		32,
		30,
		56,
		75,
		86,
		100,
		99,
		-1,
		26,
		36,
		45,
		41,
		48,
		32,
		36,
		54,
		85,
		91,
		94,
		-1,
		43,
		39,
		41,
		47,
		55,
		48,
		35,
		41,
		60,
		73,
		92,
		83,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		44,
		35,
		47,
		49,
		56,
		69,
		67,
		38,
		44,
		48,
		65,
		81,
		82,
		92,
		-1,
		-1,
		137,
		110,
		134,
		92,
		74,
		-1,
		40,
		42,
		48,
		52,
		57,
		65,
		69,
		54,
		-1,
		59,
		58,
		89,
		75,
		86,
		119,
		-1,
		-1,
		95,
		87,
		69,
		72,
		49,
		45,
		57,
		56,
		52,
		54,
		56,
		68,
		62,
		75,
		82,
		53,
		63,
		67,
		82,
		93,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		99,
		-1,
		64,
		71,
		55,
		61,
		47,
		68,
		67,
		61,
		68,
		71,
		59,
		75,
		72,
		89,
		75,
		50,
		75,
		79,
		85,
		103,
		104,
		-1,
		166,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		71,
		68,
		61,
		85,
		84,
		-1,
		90,
		88,
		94,
		79,
		84,
		80,
		65,
		80,
		75,
		75,
		72,
		57,
		59,
		96,
		87,
		108,
		105,
		136,
		142,
		136,
		145,
		-1,
		124,
		120,
		116,
		123,
		72,
		-1,
		-1,
		89,
		-1,
		92,
		105,
		102,
		90,
		93,
		80,
		88,
		87,
		71,
		86,
		73,
		70,
		69,
		65,
		74,
		84,
		83,
		101,
		114,
		129,
		133,
		139,
		-1,
		174,
		-1,
		116,
		100,
		102,
		78,
		106,
		-1,
		109,
		93,
		113,
		104,
		104,
		-1,
		96,
		93,
		103,
		86,
		71,
		85,
		73,
		68,
		68,
		72,
		87,
		78,
		96,
		103,
		111,
		115,
		135,
		147,
		134,
		124,
		-1,
		106,
		111,
		81,
		93,
		116,
		136,
		120,
		-1,
		115,
		-1,
		98,
		111,
		-1,
		92,
		88,
		77,
		81,
		70,
		77,
		75,
		69,
		66,
		84,
		87,
		104,
		108,
		124,
		-1,
		-1,
		119,
		123,
		131,
		82,
		101,
		125,
		162,
		129,
		122,
		121,
		-1,
		116,
		113,
		110,
		111,
		97,
		90,
		91,
		76,
		82,
		83,
		68,
		71,
		93,
		121,
		99,
		111,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		108,
		79,
		103,
		145,
		151,
		144,
		132,
		146,
		146,
		140,
		-1,
		128,
		107,
		104,
		93,
		83,
		99,
		89,
		92,
		72,
		74,
		90,
		102,
		93,
		113,
		-1,
		-1,
		-1,
		138,
		127,
		128,
		82,
		116,
		134,
		179,
		165,
		170,
		145,
		138,
		132,
		122,
		124,
		111,
		100,
		92,
		81,
		90,
		100,
		94,
		74,
		83,
		84,
		108,
		115,
		121,
		-1,
		-1,
		145,
		135,
		119,
		121,
		118,
		107,
		114,
		146,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		88,
		97,
		102,
		88,
		79,
		94,
		113,
		113,
		105,
		130,
		133,
		-1,
		-1,
		-1,
		138,
		155,
		130,
		107,
		88,
		124,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		102,
		98,
		97,
		98,
		80,
		116,
		-1,
		113,
		107,
		135,
		138,
		128,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		95,
		147,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		107,
		96,
		109,
		105,
		85,
		95,
		115,
		119,
		126,
		119,
		124,
		123,
		137,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		115,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		114,
		110,
		118,
		103,
		102,
		88,
		92,
		110,
		137,
		132,
		127,
		126,
		133,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		130,
		-1,
		101,
		125,
		141,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		118,
		117,
		127,
		124,
		113,
		100,
		104,
		119,
		129,
		121,
		122,
		131,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		104,
		117,
		128,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		115,
		121,
		128,
		131,
		128,
		118,
		107,
		113,
		109,
		131,
		117,
		115,
		134,
		149,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		132,
		116,
		121,
		-1,
		153,
		-1,
		126,
		126,
		117,
		106,
		103,
		114,
		112,
		123,
		140,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		161,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		148,
		128,
		122,
		121,
		148,
		143,
		134,
		115,
		108,
		105,
		106,
		119,
		139,
		130,
		142,
		-1,
		-1,
		-1,
		162,
		142,
		148,
		106,
		127,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		165,
		153,
		143,
		133,
		167,
		159,
		134,
		127,
		113,
		115,
		113,
		115,
		120,
		141,
		142,
		155,
		-1,
		-1,
		139,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		154,
		-1,
		-1,
		145,
		143,
		151,
		130,
		117,
		137,
		140,
		130,
		114,
		129,
		141,
		149,
		154,
		-1,
		142,
		129,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		176,
		171,
		175,
		148,
		-1,
		147,
		141,
		121,
		135,
		142,
		132,
		127,
		121,
		124,
		142,
		159,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		155,
		169,
		164,
		157,
		161,
		-1,
		149,
		137,
		123,
		140,
		145,
		142,
		133,
		125,
		130,
		127,
		140,
		154,
		158,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		173,
		188,
		203,
		180,
		153,
		148,
		141,
		135,
		131,
		147,
		153,
		164,
		132,
		128,
		129,
		133,
		132,
		149,
		159,
		-1,
		-1,
		162,
		179,
		199,
		181,
		185,
		230,
		-1,
		-1,
		157,
		148,
		139,
		142,
		141,
		144,
		138,
		135,
		140,
		145,
		133,
		142,
		160,
		159,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		200,
		228,
		175,
		157,
		153,
		151,
		144,
		153,
		148,
		143,
		153,
		155,
		147,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		211,
		186,
		201,
		239,
		220,
		227,
		190,
		187,
		-1,
		157,
		182,
		154,
		161,
		152,
		159,
		159,
		151,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		217,
		203,
		225,
		215,
		218,
		-1,
		-1,
		206,
		203,
		179,
		162,
		160,
		153,
		148,
		158,
		138,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		187,
		268,
		261,
		244,
		252,
		283,
		-1,
		220,
		221,
		210,
		207,
		209,
		-1,
		-1,
		179,
		176,
		181,
		169,
		166,
		168,
		163,
		154,
		139,
		145,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		201,
		244,
		238,
		241,
		265,
		279,
		-1,
		226,
		-1,
		-1,
		218,
		210,
		194,
		184,
		178,
		228,
		183,
		178,
		162,
		160,
		151,
		142,
		149,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		236,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		234,
		-1,
		221,
		-1,
		196,
		200,
		191,
		194,
		176,
		163,
		155,
		147,
		163,
		138,
		148,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		297,
		253,
		232,
		223,
		270,
		285,
		289,
		-1,
		238,
		277,
		272,
		-1,
		243,
		-1,
		-1,
		-1,
		210,
		204,
		196,
		196,
		175,
		175,
		149,
		153,
		143,
		150,
		160,
		162,
		154,
		158,
		171,
		182,
		185,
		293,
		284,
		297,
		242,
		237,
		255,
		264,
		285,
		253,
		244,
		271,
		279,
		268,
		263,
		250,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		182,
		170,
		153,
		154,
		150,
		153,
		168,
		171,
		161,
		159,
		153,
		185,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		256,
		-1,
		-1,
		255,
		272,
		266,
		270,
		286,
		311,
		-1,
		242,
		-1,
		-1,
		227,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		158,
		169,
		179,
		167,
		168,
		158,
		168,
		181,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		242,
		240,
		246,
		253,
		270,
		300,
		-1,
		-1,
		258,
		238,
		-1,
		-1,
		210,
		208,
		197,
		-1,
		187,
		160,
		165,
		185,
		187,
		176,
		170,
		164,
		171,
		170,
		178,
		186,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		244,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		178,
		182,
		174,
		167,
		162,
		173,
		165,
		169,
		186,
		-1,
		313,
		-1,
		265,
		241,
		255,
		270,
		278,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		168,
		179,
		168,
		171,
		185,
		180,
		-1,
		-1,
		253,
		256,
		-1,
		-1,
		255,
		257,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		172,
		178,
		181,
		170,
		174,
		186,
		-1,
		-1,
		260,
		261,
		262,
		-1,
		240,
		-1,
		258,
		-1,
		225,
		231,
		219,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		201,
		199,
		190,
		176,
		183,
		181,
		177,
		188,
		-1,
		-1,
		-1,
		258,
		232,
		265,
		256,
		239,
		219,
		211,
		230,
		-1,
		200,
		-1,
		175,
		177,
		203,
		206,
		212,
		206,
		179,
		194,
		184,
		175,
		184,
		264,
		-1,
		234,
		267,
		231,
		225,
		201,
		205,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		228,
		213,
		194,
		181,
		188,
		188,
		181,
		-1,
		-1,
		-1,
		236,
		235,
		227,
		221,
		221,
		206,
		197,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		218,
		214,
		201,
		201,
		193,
		-1,
		337,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		230,
		225,
		198,
		186,
		192,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		194,
		229,
		-1,
		332,
		-1,
		266,
		-1,
		-1,
		248,
		228,
		220,
		209,
		198,
		196,
		187,
		178,
		200,
		216,
		200,
		198,
		201,
		202,
		-1,
		321,
		320,
		-1,
		267,
		259,
		245,
		-1,
		238,
		-1,
		244,
		205,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		308,
		283,
		-1,
		-1,
		-1,
		268,
		248,
		239,
		223,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		293,
		292,
		-1,
		261,
		264,
		-1,
		254,
		245,
		253,
		200,
		204,
		-1,
		-1,
		-1,
		302,
		283,
		277,
		276,
		274,
		269,
		266,
		252,
		236,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		274,
		266,
		259,
		-1,
		-1,
		261,
		244,
		225,
		223,
		-1,
		-1,
		-1,
		296,
		277,
		-1,
		-1,
		251,
		-1,
		-1,
		257,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		285,
		-1,
		-1,
		-1,
		247,
		243,
		244,
		-1,
		-1,
		-1,
		-1,
		307,
		308,
		331,
		295,
		-1,
		-1,
		-1,
		239,
		233,
		-1,
		-1,
		310,
		308,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		237,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		272,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		262,
		269,
		291,
		294,
		330,
		-1,
		281
	],
	[
		-1,
		82,
		71,
		82,
		90,
		63,
		70,
		-1,
		88,
		93,
		59,
		53,
		91,
		60,
		66,
		77,
		-1,
		-1,
		-1,
		82,
		81,
		48,
		46,
		55,
		60,
		67,
		-1,
		64,
		-1,
		103,
		82,
		93,
		98,
		41,
		38,
		58,
		77,
		56,
		51,
		118,
		71,
		42,
		36,
		54,
		35,
		50,
		42,
		-1,
		42,
		32,
		46,
		24,
		35,
		36,
		-1,
		-1,
		32,
		33,
		35,
		20,
		36,
		36,
		-1,
		61,
		80,
		-1,
		-1,
		26,
		16,
		0,
		14,
		22,
		27,
		53,
		70,
		75,
		-1,
		-1,
		8,
		2,
		9,
		12,
		8,
		40,
		59,
		70,
		84,
		83,
		-1,
		20,
		37,
		38,
		19,
		30,
		16,
		20,
		38,
		69,
		75,
		78,
		-1,
		37,
		33,
		40,
		42,
		37,
		32,
		19,
		25,
		44,
		57,
		76,
		67,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		38,
		29,
		46,
		48,
		50,
		53,
		51,
		22,
		28,
		32,
		49,
		65,
		66,
		76,
		-1,
		-1,
		131,
		104,
		128,
		86,
		68,
		-1,
		34,
		36,
		42,
		46,
		51,
		59,
		53,
		38,
		-1,
		43,
		42,
		73,
		59,
		70,
		113,
		-1,
		-1,
		89,
		81,
		63,
		66,
		43,
		39,
		51,
		50,
		46,
		48,
		50,
		61,
		46,
		59,
		66,
		37,
		47,
		51,
		66,
		77,
		-1,
		-1,
		151,
		-1,
		-1,
		110,
		93,
		-1,
		58,
		65,
		49,
		55,
		41,
		62,
		61,
		55,
		62,
		65,
		53,
		59,
		56,
		73,
		59,
		34,
		59,
		63,
		69,
		87,
		88,
		-1,
		150,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		65,
		62,
		55,
		79,
		78,
		-1,
		84,
		82,
		88,
		73,
		78,
		74,
		59,
		64,
		59,
		59,
		56,
		41,
		43,
		80,
		71,
		92,
		89,
		120,
		126,
		120,
		129,
		-1,
		118,
		114,
		110,
		117,
		66,
		-1,
		-1,
		83,
		-1,
		86,
		99,
		96,
		84,
		87,
		74,
		82,
		81,
		65,
		70,
		57,
		54,
		53,
		49,
		58,
		68,
		67,
		85,
		98,
		113,
		117,
		123,
		-1,
		168,
		-1,
		110,
		94,
		96,
		72,
		100,
		-1,
		103,
		87,
		107,
		98,
		98,
		-1,
		90,
		87,
		97,
		80,
		65,
		69,
		57,
		52,
		52,
		56,
		71,
		62,
		80,
		87,
		95,
		99,
		119,
		131,
		128,
		118,
		-1,
		100,
		105,
		75,
		87,
		110,
		130,
		114,
		-1,
		109,
		-1,
		92,
		105,
		-1,
		86,
		82,
		71,
		65,
		54,
		61,
		59,
		53,
		50,
		68,
		71,
		88,
		92,
		108,
		-1,
		-1,
		113,
		117,
		125,
		76,
		95,
		119,
		156,
		123,
		116,
		115,
		-1,
		110,
		107,
		104,
		105,
		91,
		79,
		77,
		60,
		66,
		67,
		52,
		55,
		77,
		105,
		83,
		95,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		102,
		73,
		97,
		139,
		145,
		138,
		126,
		130,
		130,
		124,
		-1,
		118,
		97,
		88,
		77,
		67,
		83,
		73,
		76,
		56,
		58,
		74,
		86,
		77,
		97,
		-1,
		-1,
		-1,
		132,
		121,
		122,
		76,
		110,
		128,
		163,
		149,
		154,
		129,
		122,
		116,
		116,
		114,
		95,
		84,
		76,
		65,
		74,
		84,
		78,
		58,
		67,
		68,
		92,
		99,
		105,
		-1,
		-1,
		139,
		129,
		113,
		115,
		112,
		101,
		108,
		140,
		154,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		86,
		72,
		63,
		78,
		97,
		97,
		89,
		114,
		117,
		-1,
		-1,
		-1,
		132,
		149,
		124,
		101,
		82,
		118,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		82,
		81,
		82,
		64,
		100,
		-1,
		97,
		91,
		119,
		122,
		112,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		89,
		141,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		91,
		80,
		93,
		89,
		69,
		79,
		99,
		103,
		110,
		103,
		108,
		107,
		121,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		109,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		98,
		94,
		102,
		87,
		86,
		72,
		76,
		94,
		121,
		116,
		111,
		110,
		117,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		124,
		-1,
		95,
		119,
		135,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		102,
		101,
		111,
		108,
		97,
		84,
		88,
		103,
		113,
		105,
		106,
		115,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		98,
		101,
		122,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		112,
		115,
		112,
		102,
		91,
		97,
		93,
		115,
		101,
		99,
		118,
		133,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		116,
		100,
		105,
		-1,
		137,
		-1,
		110,
		110,
		101,
		90,
		87,
		98,
		96,
		107,
		124,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		155,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		132,
		112,
		106,
		105,
		132,
		127,
		118,
		99,
		92,
		89,
		90,
		103,
		123,
		114,
		126,
		-1,
		-1,
		-1,
		156,
		136,
		142,
		100,
		121,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		149,
		137,
		127,
		117,
		151,
		143,
		118,
		111,
		97,
		99,
		97,
		99,
		104,
		125,
		126,
		139,
		-1,
		-1,
		133,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		138,
		-1,
		-1,
		129,
		127,
		135,
		114,
		101,
		121,
		124,
		114,
		98,
		113,
		125,
		133,
		138,
		-1,
		136,
		123,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		160,
		155,
		159,
		132,
		-1,
		131,
		125,
		105,
		119,
		126,
		116,
		111,
		105,
		108,
		126,
		143,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		139,
		153,
		148,
		141,
		145,
		-1,
		133,
		121,
		107,
		124,
		129,
		126,
		117,
		109,
		114,
		111,
		124,
		138,
		142,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		157,
		172,
		187,
		164,
		137,
		132,
		125,
		119,
		115,
		131,
		137,
		148,
		116,
		112,
		113,
		117,
		116,
		133,
		143,
		-1,
		-1,
		156,
		173,
		183,
		165,
		169,
		214,
		-1,
		-1,
		141,
		132,
		123,
		126,
		125,
		128,
		122,
		119,
		124,
		129,
		117,
		126,
		144,
		143,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		184,
		212,
		159,
		141,
		137,
		135,
		128,
		137,
		132,
		127,
		137,
		139,
		131,
		119,
		123,
		146,
		135,
		174,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		205,
		180,
		195,
		223,
		204,
		211,
		174,
		171,
		-1,
		141,
		166,
		138,
		145,
		136,
		143,
		143,
		135,
		113,
		120,
		136,
		135,
		130,
		166,
		157,
		163,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		211,
		197,
		209,
		199,
		202,
		-1,
		-1,
		190,
		187,
		163,
		146,
		144,
		137,
		132,
		142,
		122,
		109,
		113,
		117,
		123,
		128,
		133,
		139,
		154,
		169,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		213,
		205,
		204,
		191,
		193,
		-1,
		-1,
		163,
		160,
		165,
		153,
		150,
		152,
		147,
		138,
		123,
		129,
		116,
		115,
		133,
		137,
		146,
		153,
		143,
		156,
		160,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		210,
		-1,
		-1,
		212,
		194,
		178,
		168,
		162,
		212,
		167,
		162,
		146,
		144,
		135,
		126,
		133,
		124,
		124,
		127,
		142,
		147,
		139,
		153,
		153,
		154,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		228,
		-1,
		205,
		-1,
		180,
		184,
		175,
		178,
		160,
		147,
		139,
		131,
		147,
		122,
		132,
		128,
		129,
		138,
		149,
		161,
		160,
		161,
		281,
		237,
		226,
		217,
		262,
		277,
		281,
		-1,
		222,
		261,
		259,
		-1,
		237,
		-1,
		-1,
		-1,
		194,
		188,
		180,
		180,
		159,
		159,
		133,
		137,
		127,
		134,
		144,
		146,
		138,
		142,
		155,
		166,
		169,
		277,
		268,
		281,
		226,
		226,
		247,
		256,
		277,
		237,
		228,
		255,
		266,
		255,
		250,
		237,
		-1,
		-1,
		217,
		198,
		-1,
		-1,
		166,
		154,
		137,
		138,
		134,
		137,
		152,
		155,
		145,
		143,
		137,
		169,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		217,
		244,
		-1,
		-1,
		239,
		256,
		250,
		254,
		270,
		295,
		-1,
		226,
		-1,
		-1,
		211,
		-1,
		-1,
		196,
		159,
		148,
		139,
		145,
		142,
		153,
		163,
		151,
		152,
		142,
		152,
		165,
		254,
		251,
		239,
		237,
		260,
		225,
		213,
		-1,
		226,
		224,
		230,
		237,
		254,
		284,
		-1,
		-1,
		242,
		222,
		-1,
		-1,
		194,
		192,
		181,
		-1,
		171,
		144,
		149,
		169,
		171,
		160,
		154,
		148,
		155,
		154,
		162,
		170,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		211,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		232,
		228,
		-1,
		-1,
		189,
		182,
		170,
		158,
		148,
		158,
		162,
		166,
		158,
		151,
		146,
		157,
		149,
		153,
		170,
		-1,
		297,
		-1,
		249,
		225,
		239,
		254,
		262,
		-1,
		-1,
		-1,
		249,
		235,
		228,
		216,
		214,
		-1,
		223,
		207,
		188,
		-1,
		158,
		171,
		202,
		170,
		175,
		170,
		152,
		163,
		152,
		155,
		169,
		164,
		-1,
		-1,
		237,
		240,
		-1,
		-1,
		239,
		241,
		-1,
		240,
		229,
		214,
		206,
		-1,
		-1,
		195,
		191,
		-1,
		-1,
		159,
		184,
		173,
		181,
		176,
		156,
		162,
		165,
		154,
		158,
		170,
		-1,
		-1,
		244,
		245,
		246,
		-1,
		224,
		-1,
		242,
		-1,
		209,
		215,
		203,
		-1,
		-1,
		-1,
		197,
		160,
		181,
		191,
		185,
		183,
		174,
		160,
		167,
		165,
		161,
		172,
		-1,
		-1,
		-1,
		242,
		216,
		249,
		240,
		223,
		203,
		195,
		214,
		-1,
		184,
		-1,
		159,
		161,
		187,
		190,
		196,
		190,
		163,
		178,
		168,
		159,
		168,
		248,
		-1,
		218,
		251,
		215,
		209,
		185,
		189,
		205,
		-1,
		181,
		163,
		-1,
		191,
		181,
		212,
		197,
		178,
		165,
		172,
		172,
		165,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		205,
		190,
		181,
		-1,
		193,
		175,
		154,
		171,
		171,
		162,
		170,
		202,
		198,
		185,
		185,
		177,
		-1,
		321,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		209,
		182,
		170,
		176,
		172,
		158,
		164,
		166,
		174,
		172,
		169,
		181,
		177,
		197,
		178,
		213,
		-1,
		316,
		-1,
		250,
		-1,
		-1,
		232,
		212,
		204,
		193,
		182,
		180,
		171,
		162,
		184,
		200,
		184,
		182,
		185,
		186,
		-1,
		305,
		304,
		-1,
		251,
		243,
		229,
		-1,
		222,
		-1,
		228,
		189,
		-1,
		191,
		171,
		-1,
		193,
		189,
		-1,
		-1,
		292,
		267,
		-1,
		-1,
		-1,
		252,
		232,
		223,
		207,
		-1,
		182,
		182,
		-1,
		-1,
		-1,
		277,
		276,
		-1,
		245,
		248,
		-1,
		238,
		229,
		237,
		184,
		188,
		-1,
		-1,
		-1,
		286,
		267,
		261,
		260,
		258,
		253,
		250,
		236,
		220,
		198,
		187,
		208,
		-1,
		-1,
		-1,
		258,
		250,
		243,
		-1,
		-1,
		245,
		228,
		209,
		207,
		-1,
		-1,
		-1,
		280,
		261,
		-1,
		-1,
		235,
		-1,
		-1,
		241,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		269,
		-1,
		-1,
		-1,
		231,
		227,
		228,
		-1,
		-1,
		-1,
		-1,
		291,
		292,
		315,
		279,
		-1,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		294,
		292,
		-1,
		-1,
		-1,
		251,
		235,
		-1,
		221,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		256,
		-1,
		256,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		269,
		261,
		269,
		-1,
		241,
		243,
		-1,
		291,
		-1,
		-1,
		284,
		275,
		-1,
		-1,
		246,
		253,
		275,
		278,
		314,
		-1,
		265
	],
	[
		-1,
		97,
		86,
		97,
		105,
		78,
		85,
		-1,
		103,
		108,
		74,
		68,
		106,
		75,
		81,
		92,
		-1,
		-1,
		-1,
		97,
		96,
		63,
		61,
		70,
		75,
		82,
		-1,
		52,
		-1,
		118,
		97,
		108,
		113,
		56,
		53,
		65,
		64,
		45,
		37,
		133,
		86,
		57,
		51,
		53,
		32,
		39,
		31,
		-1,
		57,
		47,
		43,
		21,
		32,
		22,
		-1,
		-1,
		45,
		46,
		32,
		17,
		22,
		34,
		-1,
		64,
		80,
		-1,
		-1,
		41,
		31,
		15,
		0,
		8,
		30,
		56,
		73,
		78,
		-1,
		-1,
		23,
		17,
		24,
		7,
		11,
		43,
		62,
		73,
		87,
		86,
		-1,
		35,
		52,
		53,
		22,
		33,
		19,
		23,
		41,
		72,
		78,
		81,
		-1,
		52,
		48,
		55,
		49,
		44,
		35,
		22,
		28,
		47,
		60,
		79,
		70,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		53,
		44,
		61,
		63,
		65,
		56,
		54,
		25,
		31,
		35,
		52,
		68,
		69,
		79,
		-1,
		-1,
		146,
		119,
		143,
		101,
		83,
		-1,
		49,
		51,
		57,
		61,
		66,
		67,
		56,
		41,
		-1,
		46,
		45,
		76,
		62,
		73,
		128,
		-1,
		-1,
		104,
		96,
		78,
		81,
		58,
		54,
		66,
		65,
		61,
		63,
		65,
		64,
		49,
		62,
		69,
		40,
		50,
		54,
		69,
		80,
		-1,
		-1,
		154,
		-1,
		-1,
		125,
		108,
		-1,
		73,
		80,
		64,
		70,
		56,
		77,
		76,
		70,
		77,
		80,
		68,
		62,
		59,
		76,
		62,
		37,
		62,
		66,
		72,
		90,
		91,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		80,
		77,
		70,
		94,
		93,
		-1,
		99,
		97,
		103,
		88,
		93,
		89,
		74,
		67,
		62,
		62,
		59,
		44,
		46,
		83,
		74,
		95,
		92,
		123,
		129,
		123,
		132,
		-1,
		133,
		129,
		125,
		132,
		81,
		-1,
		-1,
		98,
		-1,
		101,
		114,
		111,
		99,
		102,
		89,
		97,
		96,
		80,
		73,
		60,
		57,
		56,
		52,
		61,
		71,
		70,
		88,
		101,
		116,
		120,
		126,
		-1,
		183,
		-1,
		125,
		109,
		111,
		87,
		115,
		-1,
		118,
		102,
		122,
		113,
		113,
		-1,
		105,
		102,
		112,
		95,
		80,
		72,
		60,
		55,
		55,
		59,
		74,
		65,
		83,
		90,
		98,
		102,
		122,
		134,
		143,
		133,
		-1,
		115,
		120,
		90,
		102,
		125,
		145,
		129,
		-1,
		124,
		-1,
		107,
		120,
		-1,
		101,
		97,
		80,
		68,
		57,
		64,
		62,
		56,
		53,
		71,
		74,
		91,
		95,
		111,
		-1,
		-1,
		128,
		132,
		140,
		91,
		110,
		134,
		171,
		138,
		131,
		130,
		-1,
		125,
		116,
		113,
		110,
		97,
		82,
		80,
		63,
		69,
		70,
		55,
		58,
		80,
		108,
		86,
		98,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		117,
		88,
		112,
		154,
		160,
		153,
		141,
		133,
		133,
		127,
		-1,
		121,
		100,
		91,
		80,
		70,
		86,
		76,
		79,
		59,
		61,
		77,
		89,
		80,
		100,
		-1,
		-1,
		-1,
		147,
		136,
		137,
		91,
		125,
		143,
		166,
		152,
		157,
		132,
		125,
		119,
		125,
		117,
		98,
		87,
		79,
		68,
		77,
		87,
		81,
		61,
		70,
		71,
		95,
		102,
		108,
		-1,
		-1,
		154,
		144,
		128,
		130,
		127,
		116,
		123,
		155,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		81,
		75,
		84,
		89,
		75,
		66,
		81,
		100,
		100,
		92,
		117,
		120,
		-1,
		-1,
		-1,
		147,
		164,
		139,
		116,
		97,
		133,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		85,
		89,
		82,
		89,
		85,
		84,
		85,
		67,
		103,
		-1,
		100,
		94,
		122,
		125,
		115,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		104,
		156,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		94,
		92,
		86,
		90,
		94,
		83,
		96,
		92,
		72,
		82,
		102,
		106,
		113,
		106,
		111,
		110,
		124,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		124,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		101,
		101,
		97,
		105,
		90,
		89,
		75,
		79,
		97,
		124,
		119,
		114,
		113,
		120,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		139,
		-1,
		110,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		106,
		121,
		122,
		100,
		105,
		104,
		114,
		111,
		100,
		87,
		91,
		106,
		116,
		108,
		109,
		118,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		113,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		120,
		118,
		111,
		102,
		108,
		115,
		118,
		115,
		105,
		94,
		100,
		96,
		118,
		104,
		102,
		121,
		136,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		140,
		-1,
		113,
		113,
		104,
		93,
		90,
		101,
		99,
		110,
		127,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		170,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		135,
		130,
		121,
		102,
		95,
		92,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		170,
		151,
		157,
		115,
		136,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		152,
		140,
		130,
		120,
		154,
		146,
		121,
		114,
		100,
		102,
		100,
		102,
		107,
		128,
		129,
		142,
		-1,
		-1,
		148,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		141,
		-1,
		-1,
		132,
		130,
		138,
		117,
		104,
		124,
		127,
		117,
		101,
		116,
		128,
		136,
		141,
		-1,
		151,
		138,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		158,
		162,
		135,
		-1,
		134,
		128,
		108,
		122,
		129,
		119,
		114,
		108,
		111,
		129,
		146,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		151,
		144,
		148,
		-1,
		136,
		124,
		110,
		127,
		132,
		129,
		120,
		112,
		117,
		114,
		127,
		141,
		145,
		188,
		-1,
		171,
		-1,
		-1,
		-1,
		160,
		175,
		190,
		167,
		140,
		135,
		128,
		122,
		118,
		134,
		140,
		151,
		119,
		115,
		116,
		120,
		119,
		136,
		146,
		-1,
		-1,
		171,
		188,
		186,
		168,
		172,
		217,
		-1,
		-1,
		144,
		135,
		126,
		129,
		128,
		131,
		125,
		122,
		127,
		132,
		120,
		129,
		147,
		146,
		-1,
		-1,
		-1,
		191,
		-1,
		206,
		-1,
		-1,
		187,
		215,
		162,
		144,
		140,
		138,
		131,
		140,
		135,
		130,
		140,
		142,
		134,
		122,
		126,
		149,
		138,
		177,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		220,
		195,
		210,
		226,
		207,
		214,
		177,
		174,
		-1,
		144,
		169,
		141,
		148,
		139,
		146,
		146,
		138,
		116,
		123,
		139,
		138,
		133,
		169,
		160,
		166,
		-1,
		-1,
		301,
		290,
		279,
		285,
		-1,
		226,
		212,
		212,
		202,
		205,
		-1,
		-1,
		193,
		190,
		166,
		149,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		196,
		277,
		270,
		253,
		261,
		292,
		-1,
		216,
		208,
		219,
		194,
		196,
		-1,
		-1,
		166,
		163,
		168,
		156,
		153,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		210,
		253,
		247,
		250,
		274,
		288,
		-1,
		213,
		-1,
		-1,
		225,
		197,
		181,
		171,
		165,
		215,
		170,
		165,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		245,
		233,
		241,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		241,
		-1,
		208,
		-1,
		183,
		187,
		178,
		181,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		284,
		240,
		241,
		232,
		265,
		280,
		284,
		-1,
		225,
		264,
		262,
		-1,
		246,
		-1,
		-1,
		-1,
		197,
		191,
		183,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		280,
		271,
		284,
		229,
		229,
		250,
		259,
		280,
		240,
		231,
		258,
		269,
		258,
		253,
		240,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		220,
		247,
		-1,
		-1,
		242,
		259,
		253,
		257,
		273,
		298,
		-1,
		229,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		257,
		254,
		242,
		240,
		263,
		228,
		216,
		-1,
		229,
		227,
		233,
		240,
		257,
		287,
		-1,
		-1,
		245,
		225,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		214,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		231,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		300,
		-1,
		252,
		228,
		242,
		257,
		265,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		240,
		243,
		-1,
		-1,
		242,
		244,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		247,
		248,
		249,
		-1,
		227,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		212,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		324,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		108,
		97,
		108,
		116,
		89,
		96,
		-1,
		114,
		119,
		85,
		79,
		117,
		86,
		92,
		103,
		-1,
		-1,
		-1,
		108,
		107,
		74,
		72,
		81,
		86,
		93,
		-1,
		44,
		-1,
		129,
		108,
		119,
		124,
		67,
		64,
		71,
		56,
		37,
		29,
		144,
		97,
		68,
		62,
		59,
		38,
		31,
		23,
		-1,
		68,
		58,
		49,
		27,
		27,
		14,
		-1,
		-1,
		51,
		52,
		38,
		21,
		14,
		26,
		-1,
		66,
		72,
		-1,
		-1,
		52,
		42,
		26,
		11,
		0,
		25,
		58,
		75,
		77,
		-1,
		-1,
		34,
		28,
		35,
		18,
		22,
		53,
		64,
		84,
		92,
		94,
		-1,
		46,
		63,
		64,
		33,
		30,
		30,
		34,
		52,
		83,
		89,
		92,
		-1,
		63,
		59,
		66,
		60,
		55,
		31,
		33,
		39,
		58,
		71,
		90,
		81,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		64,
		55,
		72,
		74,
		71,
		52,
		50,
		36,
		42,
		46,
		63,
		79,
		80,
		90,
		-1,
		-1,
		157,
		130,
		154,
		112,
		94,
		-1,
		60,
		62,
		68,
		72,
		69,
		77,
		52,
		52,
		-1,
		57,
		56,
		87,
		73,
		84,
		139,
		-1,
		-1,
		115,
		107,
		89,
		92,
		69,
		65,
		77,
		76,
		72,
		74,
		76,
		75,
		60,
		73,
		80,
		51,
		61,
		65,
		80,
		91,
		-1,
		-1,
		165,
		-1,
		-1,
		136,
		119,
		-1,
		84,
		91,
		75,
		81,
		67,
		88,
		87,
		81,
		88,
		91,
		79,
		73,
		70,
		87,
		73,
		48,
		73,
		77,
		83,
		101,
		102,
		-1,
		164,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		91,
		88,
		81,
		105,
		104,
		-1,
		110,
		108,
		114,
		99,
		104,
		100,
		85,
		78,
		73,
		73,
		70,
		55,
		57,
		94,
		85,
		106,
		103,
		134,
		140,
		134,
		143,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		109,
		-1,
		112,
		125,
		122,
		110,
		113,
		100,
		108,
		107,
		91,
		84,
		71,
		68,
		67,
		63,
		72,
		82,
		81,
		99,
		112,
		127,
		131,
		137,
		-1,
		194,
		-1,
		136,
		120,
		122,
		98,
		126,
		-1,
		129,
		113,
		133,
		124,
		124,
		-1,
		116,
		113,
		123,
		106,
		91,
		83,
		71,
		66,
		66,
		70,
		85,
		76,
		94,
		101,
		109,
		113,
		133,
		145,
		154,
		144,
		-1,
		126,
		131,
		101,
		113,
		136,
		156,
		140,
		-1,
		135,
		-1,
		118,
		131,
		-1,
		112,
		108,
		91,
		79,
		68,
		75,
		73,
		67,
		64,
		82,
		85,
		102,
		106,
		122,
		-1,
		-1,
		139,
		143,
		151,
		102,
		121,
		145,
		182,
		149,
		142,
		141,
		-1,
		136,
		127,
		124,
		121,
		108,
		93,
		91,
		74,
		80,
		81,
		66,
		69,
		91,
		119,
		97,
		109,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		128,
		99,
		123,
		165,
		171,
		164,
		152,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		81,
		97,
		87,
		90,
		70,
		72,
		88,
		100,
		91,
		111,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		102,
		136,
		154,
		177,
		163,
		168,
		143,
		136,
		130,
		136,
		128,
		109,
		98,
		90,
		79,
		88,
		98,
		92,
		72,
		81,
		82,
		106,
		113,
		119,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		127,
		134,
		166,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		92,
		86,
		95,
		100,
		86,
		77,
		92,
		111,
		111,
		103,
		128,
		131,
		-1,
		-1,
		-1,
		158,
		175,
		150,
		127,
		108,
		144,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		96,
		100,
		93,
		100,
		96,
		95,
		96,
		78,
		114,
		-1,
		111,
		105,
		133,
		136,
		126,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		115,
		167,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		103,
		97,
		101,
		105,
		94,
		107,
		103,
		83,
		93,
		113,
		117,
		124,
		117,
		122,
		121,
		135,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		135,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		112,
		112,
		108,
		116,
		101,
		100,
		86,
		90,
		108,
		135,
		130,
		125,
		124,
		131,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		150,
		-1,
		121,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		116,
		115,
		125,
		122,
		111,
		98,
		102,
		117,
		127,
		119,
		120,
		129,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		124,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		126,
		129,
		126,
		116,
		105,
		111,
		107,
		129,
		115,
		113,
		132,
		147,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		130,
		114,
		119,
		-1,
		151,
		-1,
		124,
		124,
		115,
		104,
		101,
		112,
		110,
		121,
		138,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		181,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		146,
		126,
		120,
		119,
		146,
		141,
		132,
		113,
		106,
		103,
		104,
		117,
		137,
		128,
		140,
		-1,
		-1,
		-1,
		181,
		162,
		168,
		126,
		147,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		163,
		151,
		141,
		131,
		165,
		157,
		132,
		125,
		111,
		113,
		111,
		113,
		118,
		139,
		140,
		153,
		-1,
		-1,
		159,
		166,
		154,
		140,
		159,
		-1,
		-1,
		-1,
		163,
		179,
		171,
		142,
		152,
		-1,
		-1,
		143,
		141,
		149,
		128,
		115,
		135,
		138,
		128,
		112,
		127,
		139,
		147,
		152,
		-1,
		162,
		149,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		174,
		169,
		173,
		146,
		-1,
		145,
		139,
		119,
		133,
		140,
		130,
		125,
		119,
		122,
		140,
		157,
		-1,
		-1,
		176,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		153,
		167,
		162,
		155,
		159,
		-1,
		147,
		135,
		121,
		138,
		143,
		140,
		131,
		123,
		128,
		125,
		138,
		152,
		156,
		199,
		-1,
		182,
		-1,
		-1,
		-1,
		171,
		186,
		201,
		178,
		151,
		146,
		139,
		133,
		129,
		145,
		151,
		162,
		130,
		126,
		127,
		131,
		130,
		147,
		157,
		-1,
		-1,
		182,
		199,
		197,
		179,
		183,
		228,
		-1,
		-1,
		155,
		146,
		137,
		140,
		139,
		142,
		136,
		133,
		138,
		143,
		131,
		140,
		158,
		157,
		-1,
		-1,
		-1,
		202,
		-1,
		217,
		-1,
		-1,
		198,
		226,
		173,
		155,
		151,
		149,
		142,
		151,
		146,
		141,
		151,
		153,
		145,
		133,
		137,
		160,
		149,
		188,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		231,
		206,
		221,
		237,
		218,
		225,
		188,
		185,
		-1,
		155,
		180,
		152,
		159,
		150,
		157,
		157,
		149,
		127,
		134,
		150,
		149,
		144,
		180,
		171,
		177,
		-1,
		-1,
		312,
		301,
		290,
		296,
		-1,
		237,
		223,
		223,
		213,
		216,
		-1,
		-1,
		204,
		201,
		177,
		160,
		158,
		151,
		146,
		156,
		136,
		123,
		127,
		131,
		137,
		142,
		147,
		153,
		168,
		183,
		-1,
		207,
		288,
		281,
		264,
		272,
		303,
		-1,
		227,
		219,
		230,
		205,
		207,
		-1,
		-1,
		177,
		174,
		179,
		167,
		164,
		166,
		161,
		152,
		137,
		143,
		130,
		129,
		147,
		151,
		160,
		167,
		157,
		170,
		174,
		-1,
		221,
		264,
		258,
		261,
		285,
		299,
		-1,
		224,
		-1,
		-1,
		236,
		208,
		192,
		182,
		176,
		226,
		181,
		176,
		160,
		158,
		149,
		140,
		147,
		138,
		138,
		141,
		156,
		161,
		153,
		167,
		167,
		168,
		-1,
		256,
		244,
		252,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		252,
		-1,
		219,
		-1,
		194,
		198,
		189,
		192,
		174,
		161,
		153,
		145,
		161,
		136,
		146,
		142,
		143,
		152,
		163,
		175,
		174,
		175,
		295,
		251,
		252,
		243,
		276,
		291,
		295,
		-1,
		236,
		275,
		273,
		-1,
		257,
		-1,
		-1,
		-1,
		208,
		202,
		194,
		194,
		173,
		173,
		147,
		151,
		141,
		148,
		158,
		160,
		152,
		156,
		169,
		180,
		183,
		291,
		282,
		295,
		240,
		240,
		261,
		270,
		291,
		251,
		242,
		269,
		280,
		269,
		264,
		251,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		180,
		168,
		151,
		152,
		148,
		151,
		166,
		169,
		159,
		157,
		151,
		183,
		-1,
		284,
		283,
		272,
		269,
		245,
		236,
		231,
		258,
		-1,
		-1,
		253,
		270,
		264,
		268,
		284,
		309,
		-1,
		240,
		-1,
		-1,
		225,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		156,
		167,
		177,
		165,
		166,
		156,
		166,
		179,
		268,
		265,
		253,
		251,
		274,
		239,
		227,
		-1,
		240,
		238,
		244,
		251,
		268,
		298,
		-1,
		-1,
		256,
		236,
		-1,
		-1,
		208,
		206,
		195,
		-1,
		185,
		158,
		163,
		183,
		185,
		174,
		168,
		162,
		169,
		168,
		176,
		184,
		277,
		291,
		280,
		276,
		275,
		283,
		232,
		225,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		-1,
		246,
		242,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		176,
		180,
		172,
		165,
		160,
		171,
		163,
		167,
		184,
		-1,
		311,
		-1,
		263,
		239,
		253,
		268,
		276,
		-1,
		-1,
		-1,
		263,
		249,
		242,
		230,
		228,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		166,
		177,
		166,
		169,
		183,
		178,
		-1,
		-1,
		251,
		254,
		-1,
		-1,
		253,
		255,
		-1,
		254,
		243,
		228,
		220,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		170,
		176,
		179,
		168,
		172,
		184,
		-1,
		-1,
		258,
		259,
		260,
		-1,
		238,
		-1,
		256,
		-1,
		223,
		229,
		217,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		199,
		197,
		188,
		174,
		181,
		179,
		175,
		186,
		-1,
		-1,
		-1,
		256,
		230,
		263,
		254,
		237,
		217,
		209,
		228,
		-1,
		198,
		-1,
		173,
		175,
		201,
		204,
		210,
		204,
		177,
		192,
		182,
		173,
		182,
		262,
		-1,
		232,
		265,
		229,
		223,
		199,
		203,
		219,
		-1,
		195,
		177,
		-1,
		205,
		195,
		226,
		211,
		192,
		179,
		186,
		186,
		179,
		-1,
		-1,
		-1,
		234,
		233,
		225,
		219,
		219,
		204,
		195,
		-1,
		207,
		189,
		168,
		185,
		185,
		176,
		184,
		216,
		212,
		199,
		199,
		191,
		-1,
		335,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		228,
		223,
		196,
		184,
		190,
		186,
		172,
		178,
		180,
		188,
		186,
		183,
		195,
		191,
		211,
		192,
		227,
		-1,
		330,
		-1,
		264,
		-1,
		-1,
		246,
		226,
		218,
		207,
		196,
		194,
		185,
		176,
		198,
		214,
		198,
		196,
		199,
		200,
		-1,
		319,
		318,
		-1,
		265,
		257,
		243,
		-1,
		236,
		-1,
		242,
		203,
		-1,
		205,
		185,
		-1,
		207,
		203,
		-1,
		-1,
		306,
		281,
		-1,
		-1,
		-1,
		266,
		246,
		237,
		221,
		-1,
		196,
		196,
		-1,
		-1,
		-1,
		291,
		290,
		-1,
		259,
		262,
		-1,
		252,
		243,
		251,
		198,
		202,
		-1,
		-1,
		-1,
		300,
		281,
		275,
		274,
		272,
		267,
		264,
		250,
		234,
		212,
		201,
		222,
		-1,
		-1,
		-1,
		272,
		264,
		257,
		-1,
		-1,
		259,
		242,
		223,
		221,
		-1,
		-1,
		-1,
		294,
		275,
		-1,
		-1,
		249,
		-1,
		-1,
		255,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		283,
		-1,
		-1,
		-1,
		245,
		241,
		242,
		-1,
		-1,
		-1,
		-1,
		305,
		306,
		329,
		293,
		-1,
		-1,
		-1,
		237,
		231,
		-1,
		-1,
		308,
		306,
		-1,
		-1,
		-1,
		265,
		249,
		-1,
		235,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		270,
		-1,
		270,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		283,
		275,
		283,
		-1,
		255,
		257,
		-1,
		305,
		-1,
		-1,
		298,
		289,
		-1,
		-1,
		260,
		267,
		289,
		292,
		328,
		-1,
		279
	],
	[
		-1,
		113,
		102,
		113,
		121,
		94,
		101,
		-1,
		120,
		124,
		90,
		84,
		123,
		92,
		98,
		109,
		-1,
		-1,
		-1,
		113,
		112,
		80,
		78,
		87,
		92,
		99,
		-1,
		69,
		-1,
		134,
		113,
		124,
		129,
		73,
		70,
		90,
		81,
		62,
		54,
		149,
		103,
		74,
		68,
		82,
		61,
		56,
		48,
		-1,
		74,
		64,
		72,
		50,
		50,
		34,
		-1,
		-1,
		64,
		65,
		61,
		44,
		37,
		23,
		-1,
		41,
		77,
		-1,
		-1,
		58,
		48,
		32,
		35,
		25,
		0,
		33,
		50,
		72,
		-1,
		-1,
		40,
		34,
		41,
		28,
		24,
		37,
		39,
		69,
		81,
		83,
		-1,
		52,
		69,
		67,
		35,
		29,
		28,
		32,
		44,
		71,
		80,
		88,
		-1,
		69,
		65,
		72,
		62,
		57,
		30,
		31,
		37,
		56,
		69,
		88,
		79,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		70,
		61,
		78,
		78,
		70,
		51,
		49,
		34,
		40,
		44,
		61,
		77,
		78,
		88,
		-1,
		-1,
		163,
		136,
		160,
		118,
		100,
		-1,
		66,
		68,
		74,
		74,
		68,
		76,
		51,
		50,
		-1,
		55,
		54,
		85,
		71,
		82,
		145,
		-1,
		-1,
		121,
		113,
		95,
		98,
		75,
		71,
		83,
		82,
		78,
		80,
		82,
		73,
		58,
		71,
		78,
		49,
		59,
		63,
		78,
		89,
		-1,
		-1,
		163,
		-1,
		-1,
		142,
		125,
		-1,
		90,
		97,
		81,
		87,
		73,
		94,
		93,
		87,
		94,
		97,
		85,
		71,
		68,
		85,
		71,
		46,
		71,
		75,
		81,
		99,
		100,
		-1,
		162,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		97,
		94,
		87,
		111,
		110,
		-1,
		116,
		114,
		120,
		105,
		110,
		106,
		91,
		76,
		71,
		71,
		68,
		53,
		55,
		92,
		83,
		104,
		101,
		132,
		138,
		132,
		141,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		115,
		-1,
		118,
		131,
		128,
		116,
		119,
		106,
		114,
		113,
		97,
		82,
		69,
		66,
		65,
		61,
		70,
		80,
		79,
		97,
		110,
		125,
		129,
		135,
		-1,
		200,
		-1,
		142,
		126,
		128,
		104,
		132,
		-1,
		135,
		119,
		139,
		130,
		130,
		-1,
		122,
		119,
		129,
		112,
		97,
		81,
		69,
		64,
		64,
		68,
		83,
		74,
		92,
		99,
		107,
		111,
		131,
		143,
		160,
		150,
		-1,
		132,
		137,
		107,
		119,
		142,
		162,
		146,
		-1,
		141,
		-1,
		124,
		137,
		-1,
		118,
		114,
		89,
		77,
		66,
		73,
		71,
		65,
		62,
		80,
		83,
		100,
		104,
		120,
		-1,
		-1,
		145,
		149,
		157,
		108,
		127,
		151,
		188,
		155,
		148,
		147,
		-1,
		142,
		125,
		122,
		119,
		106,
		91,
		89,
		72,
		78,
		79,
		64,
		67,
		89,
		117,
		95,
		107,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		134,
		105,
		129,
		171,
		177,
		170,
		158,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		79,
		95,
		85,
		88,
		68,
		70,
		86,
		98,
		89,
		109,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		108,
		142,
		160,
		175,
		161,
		166,
		141,
		134,
		128,
		134,
		126,
		107,
		96,
		88,
		77,
		86,
		96,
		90,
		70,
		79,
		80,
		104,
		111,
		117,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		133,
		140,
		172,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		90,
		84,
		93,
		98,
		84,
		75,
		90,
		109,
		109,
		101,
		126,
		129,
		-1,
		-1,
		-1,
		164,
		181,
		156,
		133,
		114,
		150,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		94,
		98,
		91,
		98,
		94,
		93,
		94,
		76,
		112,
		-1,
		109,
		103,
		131,
		134,
		124,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		121,
		173,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		101,
		95,
		99,
		103,
		92,
		105,
		101,
		81,
		91,
		111,
		115,
		122,
		115,
		120,
		119,
		133,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		141,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		110,
		110,
		106,
		114,
		99,
		98,
		84,
		88,
		106,
		133,
		128,
		123,
		122,
		129,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		156,
		-1,
		127,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		130,
		131,
		109,
		114,
		113,
		123,
		120,
		109,
		96,
		100,
		115,
		125,
		117,
		118,
		127,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		129,
		127,
		120,
		111,
		117,
		124,
		127,
		124,
		114,
		103,
		109,
		105,
		127,
		113,
		111,
		130,
		145,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		128,
		112,
		117,
		-1,
		149,
		-1,
		122,
		122,
		113,
		102,
		99,
		110,
		108,
		119,
		136,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		144,
		124,
		118,
		117,
		144,
		139,
		130,
		111,
		104,
		101,
		102,
		115,
		135,
		126,
		138,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		161,
		149,
		139,
		129,
		163,
		155,
		130,
		123,
		109,
		111,
		109,
		111,
		116,
		137,
		138,
		151,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		177,
		169,
		140,
		150,
		-1,
		-1,
		141,
		139,
		147,
		126,
		113,
		133,
		136,
		126,
		110,
		125,
		137,
		145,
		150,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		172,
		167,
		171,
		144,
		-1,
		143,
		137,
		117,
		131,
		138,
		128,
		123,
		117,
		120,
		138,
		155,
		-1,
		-1,
		177,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		151,
		165,
		160,
		153,
		157,
		-1,
		145,
		133,
		119,
		136,
		141,
		138,
		129,
		121,
		126,
		123,
		136,
		150,
		154,
		200,
		-1,
		183,
		-1,
		-1,
		-1,
		169,
		184,
		199,
		176,
		149,
		144,
		137,
		131,
		127,
		143,
		149,
		160,
		128,
		124,
		125,
		129,
		128,
		145,
		155,
		-1,
		-1,
		183,
		200,
		195,
		177,
		181,
		226,
		-1,
		-1,
		153,
		144,
		135,
		138,
		137,
		140,
		134,
		131,
		136,
		141,
		129,
		138,
		156,
		155,
		-1,
		-1,
		-1,
		203,
		-1,
		218,
		-1,
		-1,
		196,
		224,
		171,
		153,
		149,
		147,
		140,
		149,
		144,
		139,
		149,
		151,
		143,
		131,
		135,
		158,
		147,
		186,
		-1,
		-1,
		322,
		-1,
		-1,
		-1,
		232,
		207,
		222,
		235,
		216,
		223,
		186,
		183,
		-1,
		153,
		178,
		150,
		157,
		148,
		155,
		155,
		147,
		125,
		132,
		148,
		147,
		142,
		178,
		169,
		175,
		-1,
		-1,
		315,
		304,
		293,
		299,
		-1,
		235,
		224,
		221,
		211,
		214,
		-1,
		-1,
		202,
		199,
		175,
		158,
		156,
		149,
		144,
		154,
		134,
		121,
		125,
		129,
		135,
		140,
		145,
		151,
		166,
		181,
		-1,
		210,
		291,
		284,
		267,
		275,
		306,
		-1,
		225,
		217,
		228,
		203,
		205,
		-1,
		-1,
		175,
		172,
		177,
		165,
		162,
		164,
		159,
		150,
		135,
		141,
		128,
		127,
		145,
		149,
		158,
		165,
		155,
		168,
		172,
		-1,
		224,
		267,
		261,
		264,
		288,
		302,
		-1,
		222,
		-1,
		-1,
		234,
		206,
		190,
		180,
		174,
		224,
		179,
		174,
		158,
		156,
		147,
		138,
		145,
		136,
		136,
		139,
		154,
		159,
		151,
		165,
		165,
		166,
		-1,
		259,
		247,
		255,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		250,
		-1,
		217,
		-1,
		192,
		196,
		187,
		190,
		172,
		159,
		151,
		143,
		159,
		134,
		144,
		140,
		141,
		150,
		161,
		173,
		172,
		173,
		293,
		249,
		252,
		246,
		274,
		289,
		293,
		-1,
		234,
		273,
		271,
		-1,
		255,
		-1,
		-1,
		-1,
		206,
		200,
		192,
		192,
		171,
		171,
		145,
		149,
		139,
		146,
		156,
		158,
		150,
		154,
		167,
		178,
		181,
		289,
		280,
		293,
		238,
		238,
		259,
		268,
		289,
		249,
		240,
		267,
		278,
		267,
		262,
		249,
		-1,
		-1,
		229,
		210,
		-1,
		-1,
		178,
		166,
		149,
		150,
		146,
		149,
		164,
		167,
		157,
		155,
		149,
		181,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		229,
		256,
		-1,
		-1,
		251,
		268,
		262,
		266,
		282,
		307,
		-1,
		238,
		-1,
		-1,
		223,
		-1,
		-1,
		208,
		171,
		160,
		151,
		157,
		154,
		165,
		175,
		163,
		164,
		154,
		164,
		177,
		266,
		263,
		251,
		249,
		272,
		237,
		225,
		-1,
		238,
		236,
		242,
		249,
		266,
		296,
		-1,
		-1,
		254,
		234,
		-1,
		-1,
		206,
		204,
		193,
		-1,
		183,
		156,
		161,
		181,
		183,
		172,
		166,
		160,
		167,
		166,
		174,
		182,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		223,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		240,
		-1,
		-1,
		201,
		194,
		182,
		170,
		160,
		170,
		174,
		178,
		170,
		163,
		158,
		169,
		161,
		165,
		182,
		-1,
		309,
		-1,
		261,
		237,
		251,
		266,
		274,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		235,
		219,
		200,
		-1,
		170,
		183,
		214,
		182,
		187,
		182,
		164,
		175,
		164,
		167,
		181,
		176,
		-1,
		-1,
		249,
		252,
		-1,
		-1,
		251,
		253,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		207,
		203,
		-1,
		-1,
		171,
		196,
		185,
		193,
		188,
		168,
		174,
		177,
		166,
		170,
		182,
		-1,
		-1,
		256,
		257,
		258,
		-1,
		236,
		-1,
		254,
		-1,
		221,
		227,
		215,
		-1,
		-1,
		-1,
		209,
		172,
		193,
		203,
		197,
		195,
		186,
		172,
		179,
		177,
		173,
		184,
		-1,
		-1,
		-1,
		254,
		228,
		261,
		252,
		235,
		215,
		207,
		226,
		-1,
		196,
		-1,
		171,
		173,
		199,
		202,
		208,
		202,
		175,
		190,
		180,
		171,
		180,
		260,
		-1,
		230,
		263,
		227,
		221,
		197,
		201,
		217,
		-1,
		193,
		175,
		-1,
		203,
		193,
		224,
		209,
		190,
		177,
		184,
		184,
		177,
		-1,
		-1,
		-1,
		232,
		231,
		223,
		217,
		217,
		202,
		193,
		-1,
		205,
		187,
		166,
		183,
		183,
		174,
		182,
		214,
		210,
		197,
		197,
		189,
		-1,
		333,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		226,
		221,
		194,
		182,
		188,
		184,
		170,
		176,
		178,
		186,
		184,
		181,
		193,
		189,
		209,
		190,
		225,
		-1,
		328,
		-1,
		262,
		-1,
		-1,
		244,
		224,
		216,
		205,
		194,
		192,
		183,
		174,
		196,
		212,
		196,
		194,
		197,
		198,
		-1,
		317,
		316,
		-1,
		263,
		255,
		241,
		-1,
		234,
		-1,
		240,
		201,
		-1,
		203,
		183,
		-1,
		205,
		201,
		-1,
		-1,
		304,
		279,
		-1,
		-1,
		-1,
		264,
		244,
		235,
		219,
		-1,
		194,
		194,
		-1,
		-1,
		-1,
		289,
		288,
		-1,
		257,
		260,
		-1,
		250,
		241,
		249,
		196,
		200,
		-1,
		-1,
		-1,
		298,
		279,
		273,
		272,
		270,
		265,
		262,
		248,
		232,
		210,
		199,
		220,
		-1,
		-1,
		-1,
		270,
		262,
		255,
		-1,
		-1,
		257,
		240,
		221,
		219,
		-1,
		-1,
		-1,
		292,
		273,
		-1,
		-1,
		247,
		-1,
		-1,
		253,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		281,
		-1,
		-1,
		-1,
		243,
		239,
		240,
		-1,
		-1,
		-1,
		-1,
		303,
		304,
		327,
		291,
		-1,
		-1,
		-1,
		235,
		229,
		-1,
		-1,
		306,
		304,
		-1,
		-1,
		-1,
		263,
		247,
		-1,
		233,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		268,
		-1,
		268,
		243,
		250,
		-1,
		-1,
		-1,
		-1,
		281,
		273,
		281,
		-1,
		253,
		255,
		-1,
		303,
		-1,
		-1,
		296,
		287,
		-1,
		-1,
		258,
		265,
		287,
		290,
		326,
		-1,
		277
	],
	[
		-1,
		122,
		111,
		122,
		130,
		103,
		110,
		-1,
		129,
		133,
		99,
		93,
		132,
		101,
		107,
		118,
		-1,
		-1,
		-1,
		122,
		121,
		89,
		87,
		96,
		101,
		108,
		-1,
		98,
		-1,
		143,
		122,
		133,
		138,
		82,
		79,
		99,
		110,
		91,
		83,
		158,
		112,
		83,
		77,
		95,
		85,
		85,
		77,
		-1,
		83,
		73,
		95,
		74,
		79,
		63,
		-1,
		-1,
		77,
		78,
		84,
		70,
		66,
		52,
		-1,
		8,
		44,
		-1,
		-1,
		67,
		68,
		52,
		55,
		54,
		29,
		0,
		17,
		39,
		-1,
		-1,
		58,
		54,
		61,
		48,
		44,
		46,
		9,
		36,
		48,
		50,
		-1,
		70,
		87,
		87,
		55,
		53,
		37,
		41,
		33,
		38,
		47,
		55,
		-1,
		87,
		83,
		90,
		82,
		77,
		53,
		40,
		46,
		65,
		44,
		58,
		67,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		88,
		79,
		96,
		98,
		93,
		74,
		72,
		43,
		49,
		53,
		65,
		60,
		70,
		94,
		-1,
		-1,
		181,
		154,
		178,
		136,
		118,
		-1,
		84,
		86,
		92,
		96,
		91,
		85,
		74,
		59,
		-1,
		64,
		63,
		70,
		77,
		88,
		163,
		-1,
		-1,
		139,
		131,
		113,
		116,
		93,
		89,
		101,
		100,
		96,
		98,
		100,
		82,
		67,
		80,
		87,
		58,
		68,
		72,
		84,
		95,
		-1,
		-1,
		172,
		-1,
		-1,
		160,
		143,
		-1,
		108,
		115,
		99,
		105,
		91,
		112,
		111,
		105,
		112,
		113,
		103,
		80,
		77,
		94,
		80,
		55,
		80,
		84,
		87,
		105,
		106,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		115,
		112,
		105,
		129,
		128,
		-1,
		134,
		132,
		138,
		123,
		126,
		122,
		109,
		85,
		80,
		80,
		77,
		62,
		64,
		101,
		89,
		110,
		107,
		138,
		147,
		141,
		150,
		-1,
		168,
		164,
		160,
		167,
		116,
		-1,
		-1,
		133,
		-1,
		136,
		149,
		146,
		134,
		137,
		124,
		132,
		126,
		109,
		91,
		78,
		75,
		74,
		70,
		79,
		89,
		88,
		106,
		116,
		134,
		138,
		144,
		-1,
		218,
		-1,
		160,
		144,
		146,
		122,
		150,
		-1,
		153,
		137,
		157,
		148,
		148,
		-1,
		140,
		137,
		144,
		122,
		107,
		90,
		78,
		73,
		73,
		77,
		92,
		83,
		101,
		108,
		116,
		120,
		140,
		152,
		178,
		168,
		-1,
		150,
		155,
		125,
		137,
		160,
		180,
		164,
		-1,
		159,
		-1,
		142,
		155,
		-1,
		128,
		124,
		98,
		86,
		75,
		82,
		80,
		74,
		71,
		89,
		92,
		109,
		113,
		129,
		-1,
		-1,
		163,
		167,
		175,
		126,
		145,
		169,
		206,
		173,
		166,
		165,
		-1,
		160,
		134,
		131,
		128,
		115,
		100,
		98,
		81,
		87,
		88,
		73,
		76,
		98,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		152,
		123,
		147,
		189,
		195,
		188,
		176,
		151,
		151,
		145,
		-1,
		139,
		118,
		109,
		98,
		88,
		104,
		94,
		97,
		77,
		79,
		95,
		107,
		98,
		118,
		-1,
		-1,
		-1,
		182,
		171,
		172,
		126,
		160,
		178,
		184,
		170,
		175,
		150,
		143,
		137,
		143,
		135,
		116,
		105,
		97,
		86,
		95,
		105,
		99,
		79,
		88,
		89,
		113,
		120,
		126,
		-1,
		-1,
		189,
		179,
		163,
		165,
		162,
		151,
		158,
		190,
		175,
		188,
		-1,
		142,
		-1,
		131,
		126,
		110,
		105,
		102,
		99,
		93,
		102,
		107,
		93,
		84,
		99,
		118,
		118,
		110,
		135,
		138,
		-1,
		-1,
		-1,
		182,
		199,
		174,
		151,
		132,
		168,
		-1,
		158,
		159,
		-1,
		136,
		130,
		127,
		112,
		108,
		103,
		107,
		100,
		107,
		103,
		102,
		103,
		85,
		121,
		-1,
		118,
		112,
		140,
		143,
		133,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		139,
		191,
		-1,
		-1,
		143,
		136,
		-1,
		123,
		105,
		112,
		110,
		104,
		108,
		112,
		101,
		114,
		110,
		90,
		100,
		120,
		124,
		131,
		124,
		129,
		128,
		142,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		159,
		-1,
		152,
		144,
		134,
		128,
		122,
		118,
		116,
		132,
		116,
		119,
		119,
		115,
		123,
		108,
		107,
		93,
		97,
		115,
		142,
		137,
		132,
		131,
		138,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		173,
		-1,
		137,
		151,
		167,
		-1,
		160,
		139,
		154,
		132,
		128,
		124,
		139,
		140,
		118,
		123,
		122,
		132,
		129,
		118,
		105,
		109,
		124,
		134,
		126,
		127,
		136,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		134,
		122,
		154,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		138,
		136,
		129,
		120,
		126,
		133,
		136,
		133,
		123,
		112,
		118,
		114,
		136,
		122,
		120,
		139,
		154,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		137,
		121,
		126,
		-1,
		158,
		-1,
		131,
		131,
		122,
		111,
		108,
		119,
		117,
		128,
		145,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		191,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		153,
		133,
		127,
		126,
		153,
		148,
		139,
		120,
		113,
		110,
		111,
		124,
		144,
		135,
		147,
		-1,
		-1,
		-1,
		188,
		174,
		178,
		138,
		157,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		148,
		170,
		158,
		148,
		138,
		172,
		164,
		139,
		132,
		118,
		120,
		118,
		120,
		125,
		146,
		147,
		160,
		-1,
		-1,
		171,
		176,
		164,
		150,
		169,
		-1,
		-1,
		-1,
		170,
		186,
		178,
		149,
		159,
		-1,
		-1,
		150,
		148,
		156,
		135,
		122,
		142,
		145,
		135,
		119,
		134,
		146,
		154,
		159,
		-1,
		174,
		161,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		181,
		176,
		180,
		153,
		-1,
		152,
		146,
		126,
		140,
		147,
		137,
		132,
		126,
		129,
		147,
		164,
		-1,
		-1,
		186,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		160,
		174,
		169,
		162,
		166,
		-1,
		154,
		142,
		128,
		145,
		150,
		147,
		138,
		130,
		135,
		132,
		145,
		159,
		163,
		209,
		-1,
		192,
		-1,
		-1,
		-1,
		178,
		193,
		208,
		185,
		158,
		153,
		146,
		140,
		136,
		152,
		158,
		169,
		137,
		133,
		134,
		138,
		137,
		154,
		164,
		-1,
		-1,
		192,
		209,
		204,
		186,
		190,
		235,
		-1,
		-1,
		162,
		153,
		144,
		147,
		146,
		149,
		143,
		140,
		145,
		150,
		138,
		147,
		165,
		164,
		-1,
		-1,
		-1,
		212,
		-1,
		227,
		-1,
		-1,
		205,
		233,
		180,
		162,
		158,
		156,
		149,
		158,
		153,
		148,
		158,
		160,
		152,
		140,
		144,
		167,
		156,
		195,
		-1,
		-1,
		331,
		-1,
		-1,
		-1,
		241,
		216,
		231,
		244,
		225,
		232,
		195,
		192,
		-1,
		162,
		187,
		159,
		166,
		157,
		164,
		164,
		156,
		134,
		141,
		157,
		156,
		151,
		187,
		178,
		184,
		-1,
		-1,
		324,
		313,
		302,
		308,
		-1,
		244,
		233,
		230,
		220,
		223,
		-1,
		-1,
		211,
		208,
		184,
		167,
		165,
		158,
		153,
		163,
		143,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		219,
		300,
		293,
		276,
		284,
		315,
		-1,
		234,
		226,
		237,
		212,
		214,
		-1,
		-1,
		184,
		181,
		186,
		174,
		171,
		173,
		168,
		159,
		144,
		150,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		233,
		276,
		270,
		273,
		297,
		311,
		-1,
		231,
		-1,
		-1,
		243,
		215,
		199,
		189,
		183,
		233,
		188,
		183,
		167,
		165,
		156,
		147,
		154,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		268,
		256,
		264,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		259,
		-1,
		226,
		-1,
		201,
		205,
		196,
		199,
		181,
		168,
		160,
		152,
		168,
		143,
		153,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		302,
		258,
		261,
		255,
		283,
		298,
		302,
		-1,
		243,
		282,
		280,
		-1,
		264,
		-1,
		-1,
		-1,
		215,
		209,
		201,
		201,
		180,
		180,
		154,
		158,
		148,
		155,
		165,
		167,
		159,
		163,
		176,
		187,
		190,
		298,
		289,
		302,
		247,
		247,
		268,
		277,
		298,
		258,
		249,
		276,
		287,
		276,
		271,
		258,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		187,
		175,
		158,
		159,
		155,
		158,
		173,
		176,
		166,
		164,
		158,
		190,
		-1,
		291,
		290,
		279,
		276,
		252,
		243,
		238,
		265,
		-1,
		-1,
		260,
		277,
		271,
		275,
		291,
		316,
		-1,
		247,
		-1,
		-1,
		232,
		-1,
		-1,
		217,
		180,
		169,
		160,
		166,
		163,
		174,
		184,
		172,
		173,
		163,
		173,
		186,
		275,
		272,
		260,
		258,
		281,
		246,
		234,
		-1,
		247,
		245,
		251,
		258,
		275,
		305,
		-1,
		-1,
		263,
		243,
		-1,
		-1,
		215,
		213,
		202,
		-1,
		192,
		165,
		170,
		190,
		192,
		181,
		175,
		169,
		176,
		175,
		183,
		191,
		284,
		298,
		287,
		283,
		282,
		290,
		239,
		232,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		-1,
		253,
		249,
		-1,
		-1,
		210,
		203,
		191,
		179,
		169,
		179,
		183,
		187,
		179,
		172,
		167,
		178,
		170,
		174,
		191,
		-1,
		318,
		-1,
		270,
		246,
		260,
		275,
		283,
		-1,
		-1,
		-1,
		270,
		256,
		249,
		237,
		235,
		-1,
		244,
		228,
		209,
		-1,
		179,
		192,
		223,
		191,
		196,
		191,
		173,
		184,
		173,
		176,
		190,
		185,
		-1,
		-1,
		258,
		261,
		-1,
		-1,
		260,
		262,
		-1,
		261,
		250,
		235,
		227,
		-1,
		-1,
		216,
		212,
		-1,
		-1,
		180,
		205,
		194,
		202,
		197,
		177,
		183,
		186,
		175,
		179,
		191,
		-1,
		-1,
		265,
		266,
		267,
		-1,
		245,
		-1,
		263,
		-1,
		230,
		236,
		224,
		-1,
		-1,
		-1,
		218,
		181,
		202,
		212,
		206,
		204,
		195,
		181,
		188,
		186,
		182,
		193,
		-1,
		-1,
		-1,
		263,
		237,
		270,
		261,
		244,
		224,
		216,
		235,
		-1,
		205,
		-1,
		180,
		182,
		208,
		211,
		217,
		211,
		184,
		199,
		189,
		180,
		189,
		269,
		-1,
		239,
		272,
		236,
		230,
		206,
		210,
		226,
		-1,
		202,
		184,
		-1,
		212,
		202,
		233,
		218,
		199,
		186,
		193,
		193,
		186,
		-1,
		-1,
		-1,
		241,
		240,
		232,
		226,
		226,
		211,
		202,
		-1,
		214,
		196,
		175,
		192,
		192,
		183,
		191,
		223,
		219,
		206,
		206,
		198,
		-1,
		342,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		235,
		230,
		203,
		191,
		197,
		193,
		179,
		185,
		187,
		195,
		193,
		190,
		202,
		198,
		218,
		199,
		234,
		-1,
		337,
		-1,
		271,
		-1,
		-1,
		253,
		233,
		225,
		214,
		203,
		201,
		192,
		183,
		205,
		221,
		205,
		203,
		206,
		207,
		-1,
		326,
		325,
		-1,
		272,
		264,
		250,
		-1,
		243,
		-1,
		249,
		210,
		-1,
		212,
		192,
		-1,
		214,
		210,
		-1,
		-1,
		313,
		288,
		-1,
		-1,
		-1,
		273,
		253,
		244,
		228,
		-1,
		203,
		203,
		-1,
		-1,
		-1,
		298,
		297,
		-1,
		266,
		269,
		-1,
		259,
		250,
		258,
		205,
		209,
		-1,
		-1,
		-1,
		307,
		288,
		282,
		281,
		279,
		274,
		271,
		257,
		241,
		219,
		208,
		229,
		-1,
		-1,
		-1,
		279,
		271,
		264,
		-1,
		-1,
		266,
		249,
		230,
		228,
		-1,
		-1,
		-1,
		301,
		282,
		-1,
		-1,
		256,
		-1,
		-1,
		262,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		318,
		290,
		-1,
		-1,
		-1,
		252,
		248,
		249,
		-1,
		-1,
		-1,
		-1,
		312,
		313,
		336,
		300,
		-1,
		-1,
		-1,
		244,
		238,
		-1,
		-1,
		315,
		313,
		-1,
		-1,
		-1,
		272,
		256,
		-1,
		242,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		277,
		-1,
		277,
		252,
		259,
		-1,
		-1,
		-1,
		-1,
		290,
		282,
		290,
		-1,
		262,
		264,
		-1,
		312,
		-1,
		-1,
		305,
		296,
		-1,
		-1,
		267,
		274,
		296,
		299,
		335,
		-1,
		286
	],
	[
		-1,
		136,
		125,
		136,
		144,
		117,
		124,
		-1,
		143,
		147,
		113,
		107,
		146,
		115,
		121,
		132,
		-1,
		-1,
		-1,
		136,
		135,
		103,
		101,
		110,
		115,
		122,
		-1,
		112,
		-1,
		157,
		136,
		147,
		152,
		96,
		93,
		113,
		124,
		105,
		97,
		172,
		126,
		97,
		91,
		109,
		99,
		99,
		91,
		-1,
		97,
		87,
		109,
		88,
		93,
		77,
		-1,
		-1,
		91,
		92,
		98,
		84,
		80,
		66,
		-1,
		18,
		27,
		-1,
		-1,
		81,
		82,
		66,
		69,
		68,
		43,
		14,
		0,
		22,
		-1,
		-1,
		72,
		68,
		75,
		62,
		58,
		60,
		23,
		19,
		31,
		33,
		-1,
		84,
		101,
		101,
		69,
		67,
		51,
		55,
		47,
		21,
		30,
		38,
		-1,
		101,
		97,
		104,
		96,
		91,
		67,
		54,
		60,
		79,
		27,
		41,
		50,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		93,
		110,
		109,
		99,
		88,
		86,
		57,
		63,
		67,
		48,
		43,
		53,
		77,
		-1,
		-1,
		195,
		168,
		192,
		150,
		132,
		-1,
		98,
		100,
		106,
		103,
		97,
		90,
		88,
		73,
		-1,
		58,
		52,
		53,
		60,
		71,
		177,
		-1,
		-1,
		153,
		145,
		127,
		130,
		107,
		103,
		115,
		114,
		110,
		112,
		109,
		87,
		81,
		90,
		96,
		52,
		62,
		66,
		67,
		78,
		-1,
		-1,
		166,
		-1,
		-1,
		174,
		157,
		-1,
		122,
		129,
		113,
		119,
		105,
		126,
		125,
		119,
		123,
		118,
		110,
		85,
		82,
		95,
		74,
		49,
		74,
		78,
		70,
		88,
		89,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		129,
		126,
		119,
		143,
		142,
		-1,
		148,
		146,
		147,
		132,
		131,
		125,
		113,
		90,
		74,
		74,
		71,
		56,
		58,
		95,
		72,
		93,
		90,
		121,
		141,
		135,
		144,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		147,
		-1,
		150,
		163,
		160,
		143,
		146,
		133,
		133,
		120,
		109,
		91,
		72,
		69,
		68,
		64,
		73,
		77,
		80,
		96,
		99,
		128,
		132,
		138,
		-1,
		232,
		-1,
		174,
		158,
		160,
		136,
		164,
		-1,
		167,
		151,
		171,
		162,
		162,
		-1,
		149,
		146,
		138,
		116,
		101,
		84,
		72,
		67,
		67,
		71,
		86,
		77,
		95,
		102,
		110,
		114,
		134,
		146,
		192,
		182,
		-1,
		164,
		169,
		139,
		151,
		174,
		194,
		178,
		-1,
		173,
		-1,
		151,
		164,
		-1,
		122,
		118,
		92,
		80,
		69,
		76,
		74,
		68,
		65,
		83,
		86,
		103,
		107,
		123,
		-1,
		-1,
		177,
		181,
		189,
		140,
		159,
		183,
		220,
		181,
		170,
		169,
		-1,
		160,
		128,
		125,
		122,
		109,
		94,
		92,
		75,
		81,
		82,
		67,
		70,
		92,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		166,
		137,
		161,
		203,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		82,
		98,
		88,
		91,
		71,
		73,
		89,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		140,
		167,
		192,
		178,
		164,
		169,
		144,
		137,
		131,
		137,
		129,
		110,
		99,
		91,
		80,
		89,
		99,
		93,
		73,
		82,
		83,
		107,
		114,
		120,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		101,
		87,
		78,
		93,
		112,
		112,
		104,
		129,
		132,
		-1,
		-1,
		-1,
		196,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		97,
		96,
		97,
		79,
		115,
		-1,
		112,
		106,
		134,
		137,
		127,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		106,
		104,
		98,
		102,
		106,
		95,
		108,
		104,
		84,
		94,
		114,
		118,
		125,
		118,
		123,
		122,
		136,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		113,
		113,
		109,
		117,
		102,
		101,
		87,
		91,
		109,
		136,
		131,
		126,
		125,
		132,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		118,
		133,
		134,
		112,
		117,
		116,
		126,
		123,
		112,
		99,
		103,
		118,
		128,
		120,
		121,
		130,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		132,
		130,
		123,
		114,
		120,
		127,
		130,
		127,
		117,
		106,
		112,
		108,
		130,
		116,
		114,
		133,
		148,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		131,
		115,
		120,
		-1,
		152,
		-1,
		125,
		125,
		116,
		105,
		102,
		113,
		111,
		122,
		139,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		147,
		127,
		121,
		120,
		147,
		142,
		133,
		114,
		107,
		104,
		105,
		118,
		138,
		129,
		141,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		164,
		152,
		142,
		132,
		166,
		158,
		133,
		126,
		112,
		114,
		112,
		114,
		119,
		140,
		141,
		154,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		153,
		-1,
		-1,
		144,
		142,
		150,
		129,
		116,
		136,
		139,
		129,
		113,
		128,
		140,
		148,
		153,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		175,
		170,
		174,
		147,
		-1,
		146,
		140,
		120,
		134,
		141,
		131,
		126,
		120,
		123,
		141,
		158,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		154,
		168,
		163,
		156,
		160,
		-1,
		148,
		136,
		122,
		139,
		144,
		141,
		132,
		124,
		129,
		126,
		139,
		153,
		157,
		203,
		-1,
		186,
		-1,
		-1,
		-1,
		172,
		187,
		202,
		179,
		152,
		147,
		140,
		134,
		130,
		146,
		152,
		163,
		131,
		127,
		128,
		132,
		131,
		148,
		158,
		-1,
		-1,
		186,
		203,
		198,
		180,
		184,
		229,
		-1,
		-1,
		156,
		147,
		138,
		141,
		140,
		143,
		137,
		134,
		139,
		144,
		132,
		141,
		159,
		158,
		-1,
		-1,
		-1,
		206,
		-1,
		221,
		-1,
		-1,
		199,
		227,
		174,
		156,
		152,
		150,
		143,
		152,
		147,
		142,
		152,
		154,
		146,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		235,
		210,
		225,
		238,
		219,
		226,
		189,
		186,
		-1,
		156,
		181,
		153,
		160,
		151,
		158,
		158,
		150,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		238,
		227,
		224,
		214,
		217,
		-1,
		-1,
		205,
		202,
		178,
		161,
		159,
		152,
		147,
		157,
		137,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		213,
		294,
		287,
		270,
		278,
		309,
		-1,
		228,
		220,
		231,
		206,
		208,
		-1,
		-1,
		178,
		175,
		180,
		168,
		165,
		167,
		162,
		153,
		138,
		144,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		227,
		270,
		264,
		267,
		291,
		305,
		-1,
		225,
		-1,
		-1,
		237,
		209,
		193,
		183,
		177,
		227,
		182,
		177,
		161,
		159,
		150,
		141,
		148,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		262,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		253,
		-1,
		220,
		-1,
		195,
		199,
		190,
		193,
		175,
		162,
		154,
		146,
		162,
		137,
		147,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		296,
		252,
		255,
		249,
		277,
		292,
		296,
		-1,
		237,
		276,
		274,
		-1,
		258,
		-1,
		-1,
		-1,
		209,
		203,
		195,
		195,
		174,
		174,
		148,
		152,
		142,
		149,
		159,
		161,
		153,
		157,
		170,
		181,
		184,
		292,
		283,
		296,
		241,
		241,
		262,
		271,
		292,
		252,
		243,
		270,
		281,
		270,
		265,
		252,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		181,
		169,
		152,
		153,
		149,
		152,
		167,
		170,
		160,
		158,
		152,
		184,
		-1,
		285,
		284,
		273,
		270,
		246,
		237,
		232,
		259,
		-1,
		-1,
		254,
		271,
		265,
		269,
		285,
		310,
		-1,
		241,
		-1,
		-1,
		226,
		-1,
		-1,
		211,
		174,
		163,
		154,
		160,
		157,
		168,
		178,
		166,
		167,
		157,
		167,
		180,
		269,
		266,
		254,
		252,
		275,
		240,
		228,
		-1,
		241,
		239,
		245,
		252,
		269,
		299,
		-1,
		-1,
		257,
		237,
		-1,
		-1,
		209,
		207,
		196,
		-1,
		186,
		159,
		164,
		184,
		186,
		175,
		169,
		163,
		170,
		169,
		177,
		185,
		278,
		292,
		281,
		277,
		276,
		284,
		233,
		226,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		243,
		-1,
		-1,
		204,
		197,
		185,
		173,
		163,
		173,
		177,
		181,
		173,
		166,
		161,
		172,
		164,
		168,
		185,
		-1,
		312,
		-1,
		264,
		240,
		254,
		269,
		277,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		238,
		222,
		203,
		-1,
		173,
		186,
		217,
		185,
		190,
		185,
		167,
		178,
		167,
		170,
		184,
		179,
		-1,
		-1,
		252,
		255,
		-1,
		-1,
		254,
		256,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		210,
		206,
		-1,
		-1,
		174,
		199,
		188,
		196,
		191,
		171,
		177,
		180,
		169,
		173,
		185,
		-1,
		-1,
		259,
		260,
		261,
		-1,
		239,
		-1,
		257,
		-1,
		224,
		230,
		218,
		-1,
		-1,
		-1,
		212,
		175,
		196,
		206,
		200,
		198,
		189,
		175,
		182,
		180,
		176,
		187,
		-1,
		-1,
		-1,
		257,
		231,
		264,
		255,
		238,
		218,
		210,
		229,
		-1,
		199,
		-1,
		174,
		176,
		202,
		205,
		211,
		205,
		178,
		193,
		183,
		174,
		183,
		263,
		-1,
		233,
		266,
		230,
		224,
		200,
		204,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		227,
		212,
		193,
		180,
		187,
		187,
		180,
		-1,
		-1,
		-1,
		235,
		234,
		226,
		220,
		220,
		205,
		196,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		217,
		213,
		200,
		200,
		192,
		-1,
		336,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		229,
		224,
		197,
		185,
		191,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		193,
		228,
		-1,
		331,
		-1,
		265,
		-1,
		-1,
		247,
		227,
		219,
		208,
		197,
		195,
		186,
		177,
		199,
		215,
		199,
		197,
		200,
		201,
		-1,
		320,
		319,
		-1,
		266,
		258,
		244,
		-1,
		237,
		-1,
		243,
		204,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		307,
		282,
		-1,
		-1,
		-1,
		267,
		247,
		238,
		222,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		292,
		291,
		-1,
		260,
		263,
		-1,
		253,
		244,
		252,
		199,
		203,
		-1,
		-1,
		-1,
		301,
		282,
		276,
		275,
		273,
		268,
		265,
		251,
		235,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		273,
		265,
		258,
		-1,
		-1,
		260,
		243,
		224,
		222,
		-1,
		-1,
		-1,
		295,
		276,
		-1,
		-1,
		250,
		-1,
		-1,
		256,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		284,
		-1,
		-1,
		-1,
		246,
		242,
		243,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		330,
		294,
		-1,
		-1,
		-1,
		238,
		232,
		-1,
		-1,
		309,
		307,
		-1,
		-1,
		-1,
		266,
		250,
		-1,
		236,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		271,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		284,
		276,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		299,
		290,
		-1,
		-1,
		261,
		268,
		290,
		293,
		329,
		-1,
		280
	],
	[
		-1,
		151,
		140,
		151,
		159,
		132,
		139,
		-1,
		158,
		162,
		128,
		122,
		161,
		130,
		136,
		147,
		-1,
		-1,
		-1,
		151,
		150,
		118,
		116,
		125,
		130,
		137,
		-1,
		106,
		-1,
		172,
		151,
		162,
		167,
		111,
		108,
		128,
		118,
		99,
		91,
		187,
		141,
		112,
		106,
		124,
		114,
		93,
		85,
		-1,
		112,
		102,
		124,
		103,
		91,
		67,
		-1,
		-1,
		106,
		107,
		113,
		98,
		91,
		79,
		-1,
		42,
		5,
		-1,
		-1,
		96,
		97,
		81,
		84,
		77,
		67,
		38,
		24,
		0,
		-1,
		-1,
		87,
		83,
		90,
		77,
		73,
		84,
		47,
		12,
		15,
		17,
		-1,
		99,
		116,
		116,
		84,
		82,
		66,
		64,
		66,
		17,
		26,
		26,
		-1,
		116,
		112,
		113,
		111,
		106,
		82,
		69,
		69,
		79,
		27,
		29,
		38,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		117,
		108,
		125,
		109,
		99,
		103,
		101,
		72,
		69,
		67,
		48,
		39,
		41,
		65,
		-1,
		-1,
		210,
		183,
		207,
		165,
		147,
		-1,
		113,
		113,
		107,
		103,
		97,
		90,
		103,
		88,
		-1,
		58,
		52,
		49,
		48,
		59,
		192,
		-1,
		-1,
		168,
		160,
		142,
		145,
		122,
		118,
		128,
		127,
		120,
		113,
		109,
		87,
		90,
		90,
		96,
		52,
		58,
		55,
		55,
		66,
		-1,
		-1,
		166,
		-1,
		-1,
		189,
		172,
		-1,
		137,
		144,
		128,
		134,
		120,
		141,
		138,
		129,
		123,
		118,
		110,
		85,
		82,
		95,
		74,
		49,
		65,
		68,
		58,
		76,
		77,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		144,
		141,
		134,
		158,
		157,
		-1,
		158,
		146,
		147,
		132,
		131,
		125,
		113,
		90,
		74,
		74,
		71,
		56,
		58,
		92,
		60,
		81,
		78,
		109,
		141,
		135,
		144,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		162,
		-1,
		165,
		178,
		170,
		143,
		146,
		133,
		133,
		120,
		109,
		91,
		72,
		69,
		68,
		64,
		73,
		65,
		68,
		84,
		87,
		128,
		132,
		138,
		-1,
		247,
		-1,
		189,
		173,
		175,
		151,
		179,
		-1,
		182,
		166,
		186,
		172,
		172,
		-1,
		149,
		146,
		138,
		116,
		101,
		84,
		72,
		67,
		67,
		71,
		86,
		72,
		90,
		92,
		99,
		114,
		134,
		146,
		207,
		197,
		-1,
		179,
		184,
		154,
		166,
		186,
		209,
		188,
		-1,
		183,
		-1,
		151,
		164,
		-1,
		122,
		118,
		92,
		80,
		69,
		76,
		74,
		68,
		65,
		78,
		81,
		103,
		107,
		123,
		-1,
		-1,
		192,
		196,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		128,
		125,
		122,
		109,
		94,
		92,
		75,
		81,
		82,
		67,
		70,
		87,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		82,
		98,
		88,
		91,
		71,
		73,
		89,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		137,
		129,
		110,
		99,
		91,
		80,
		89,
		99,
		93,
		73,
		82,
		83,
		107,
		114,
		120,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		101,
		87,
		78,
		93,
		112,
		112,
		104,
		129,
		132,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		97,
		96,
		97,
		79,
		115,
		-1,
		112,
		106,
		134,
		137,
		127,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		106,
		104,
		98,
		102,
		106,
		95,
		108,
		104,
		84,
		94,
		114,
		118,
		125,
		118,
		123,
		122,
		136,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		113,
		113,
		109,
		117,
		102,
		101,
		87,
		91,
		109,
		136,
		131,
		126,
		125,
		132,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		118,
		133,
		134,
		112,
		117,
		116,
		126,
		123,
		112,
		99,
		103,
		118,
		128,
		120,
		121,
		130,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		132,
		130,
		123,
		114,
		120,
		127,
		130,
		127,
		117,
		106,
		112,
		108,
		130,
		116,
		114,
		133,
		148,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		131,
		115,
		120,
		-1,
		152,
		-1,
		125,
		125,
		116,
		105,
		102,
		113,
		111,
		122,
		139,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		147,
		127,
		121,
		120,
		147,
		142,
		133,
		114,
		107,
		104,
		105,
		118,
		138,
		129,
		141,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		164,
		152,
		142,
		132,
		166,
		158,
		133,
		126,
		112,
		114,
		112,
		114,
		119,
		140,
		141,
		154,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		153,
		-1,
		-1,
		144,
		142,
		150,
		129,
		116,
		136,
		139,
		129,
		113,
		128,
		140,
		148,
		153,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		175,
		170,
		174,
		147,
		-1,
		146,
		140,
		120,
		134,
		141,
		131,
		126,
		120,
		123,
		141,
		158,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		154,
		168,
		163,
		156,
		160,
		-1,
		148,
		136,
		122,
		139,
		144,
		141,
		132,
		124,
		129,
		126,
		139,
		153,
		157,
		203,
		-1,
		186,
		-1,
		-1,
		-1,
		172,
		187,
		202,
		179,
		152,
		147,
		140,
		134,
		130,
		146,
		152,
		163,
		131,
		127,
		128,
		132,
		131,
		148,
		158,
		-1,
		-1,
		186,
		203,
		198,
		180,
		184,
		229,
		-1,
		-1,
		156,
		147,
		138,
		141,
		140,
		143,
		137,
		134,
		139,
		144,
		132,
		141,
		159,
		158,
		-1,
		-1,
		-1,
		206,
		-1,
		221,
		-1,
		-1,
		199,
		227,
		174,
		156,
		152,
		150,
		143,
		152,
		147,
		142,
		152,
		154,
		146,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		235,
		210,
		225,
		238,
		219,
		226,
		189,
		186,
		-1,
		156,
		181,
		153,
		160,
		151,
		158,
		158,
		150,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		238,
		227,
		224,
		214,
		217,
		-1,
		-1,
		205,
		202,
		178,
		161,
		159,
		152,
		147,
		157,
		137,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		213,
		294,
		287,
		270,
		278,
		309,
		-1,
		228,
		220,
		231,
		206,
		208,
		-1,
		-1,
		178,
		175,
		180,
		168,
		165,
		167,
		162,
		153,
		138,
		144,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		227,
		270,
		264,
		267,
		291,
		305,
		-1,
		225,
		-1,
		-1,
		237,
		209,
		193,
		183,
		177,
		227,
		182,
		177,
		161,
		159,
		150,
		141,
		148,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		262,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		253,
		-1,
		220,
		-1,
		195,
		199,
		190,
		193,
		175,
		162,
		154,
		146,
		162,
		137,
		147,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		296,
		252,
		255,
		249,
		277,
		292,
		296,
		-1,
		237,
		276,
		274,
		-1,
		258,
		-1,
		-1,
		-1,
		209,
		203,
		195,
		195,
		174,
		174,
		148,
		152,
		142,
		149,
		159,
		161,
		153,
		157,
		170,
		181,
		184,
		292,
		283,
		296,
		241,
		241,
		262,
		271,
		292,
		252,
		243,
		270,
		281,
		270,
		265,
		252,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		181,
		169,
		152,
		153,
		149,
		152,
		167,
		170,
		160,
		158,
		152,
		184,
		-1,
		285,
		284,
		273,
		270,
		246,
		237,
		232,
		259,
		-1,
		-1,
		254,
		271,
		265,
		269,
		285,
		310,
		-1,
		241,
		-1,
		-1,
		226,
		-1,
		-1,
		211,
		174,
		163,
		154,
		160,
		157,
		168,
		178,
		166,
		167,
		157,
		167,
		180,
		269,
		266,
		254,
		252,
		275,
		240,
		228,
		-1,
		241,
		239,
		245,
		252,
		269,
		299,
		-1,
		-1,
		257,
		237,
		-1,
		-1,
		209,
		207,
		196,
		-1,
		186,
		159,
		164,
		184,
		186,
		175,
		169,
		163,
		170,
		169,
		177,
		185,
		278,
		292,
		281,
		277,
		276,
		284,
		233,
		226,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		243,
		-1,
		-1,
		204,
		197,
		185,
		173,
		163,
		173,
		177,
		181,
		173,
		166,
		161,
		172,
		164,
		168,
		185,
		-1,
		312,
		-1,
		264,
		240,
		254,
		269,
		277,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		238,
		222,
		203,
		-1,
		173,
		186,
		217,
		185,
		190,
		185,
		167,
		178,
		167,
		170,
		184,
		179,
		-1,
		-1,
		252,
		255,
		-1,
		-1,
		254,
		256,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		210,
		206,
		-1,
		-1,
		174,
		199,
		188,
		196,
		191,
		171,
		177,
		180,
		169,
		173,
		185,
		-1,
		-1,
		259,
		260,
		261,
		-1,
		239,
		-1,
		257,
		-1,
		224,
		230,
		218,
		-1,
		-1,
		-1,
		212,
		175,
		196,
		206,
		200,
		198,
		189,
		175,
		182,
		180,
		176,
		187,
		-1,
		-1,
		-1,
		257,
		231,
		264,
		255,
		238,
		218,
		210,
		229,
		-1,
		199,
		-1,
		174,
		176,
		202,
		205,
		211,
		205,
		178,
		193,
		183,
		174,
		183,
		263,
		-1,
		233,
		266,
		230,
		224,
		200,
		204,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		227,
		212,
		193,
		180,
		187,
		187,
		180,
		-1,
		-1,
		-1,
		235,
		234,
		226,
		220,
		220,
		205,
		196,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		217,
		213,
		200,
		200,
		192,
		-1,
		336,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		229,
		224,
		197,
		185,
		191,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		193,
		228,
		-1,
		331,
		-1,
		265,
		-1,
		-1,
		247,
		227,
		219,
		208,
		197,
		195,
		186,
		177,
		199,
		215,
		199,
		197,
		200,
		201,
		-1,
		320,
		319,
		-1,
		266,
		258,
		244,
		-1,
		237,
		-1,
		243,
		204,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		307,
		282,
		-1,
		-1,
		-1,
		267,
		247,
		238,
		222,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		292,
		291,
		-1,
		260,
		263,
		-1,
		253,
		244,
		252,
		199,
		203,
		-1,
		-1,
		-1,
		301,
		282,
		276,
		275,
		273,
		268,
		265,
		251,
		235,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		273,
		265,
		258,
		-1,
		-1,
		260,
		243,
		224,
		222,
		-1,
		-1,
		-1,
		295,
		276,
		-1,
		-1,
		250,
		-1,
		-1,
		256,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		284,
		-1,
		-1,
		-1,
		246,
		242,
		243,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		330,
		294,
		-1,
		-1,
		-1,
		238,
		232,
		-1,
		-1,
		309,
		307,
		-1,
		-1,
		-1,
		266,
		250,
		-1,
		236,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		271,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		284,
		276,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		299,
		290,
		-1,
		-1,
		261,
		268,
		290,
		293,
		329,
		-1,
		280
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		74,
		63,
		74,
		82,
		55,
		62,
		-1,
		80,
		85,
		51,
		45,
		83,
		52,
		58,
		69,
		-1,
		-1,
		-1,
		74,
		73,
		40,
		38,
		47,
		52,
		59,
		-1,
		63,
		-1,
		95,
		74,
		85,
		90,
		33,
		30,
		50,
		69,
		56,
		48,
		110,
		63,
		34,
		28,
		46,
		43,
		50,
		42,
		-1,
		34,
		24,
		46,
		32,
		43,
		33,
		-1,
		-1,
		28,
		29,
		35,
		28,
		33,
		44,
		-1,
		64,
		83,
		-1,
		-1,
		18,
		17,
		8,
		11,
		19,
		35,
		56,
		73,
		78,
		-1,
		-1,
		0,
		4,
		17,
		18,
		16,
		43,
		62,
		73,
		87,
		86,
		-1,
		12,
		29,
		33,
		27,
		35,
		19,
		23,
		41,
		72,
		78,
		81,
		-1,
		29,
		25,
		32,
		38,
		42,
		35,
		22,
		28,
		47,
		60,
		79,
		70,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		30,
		21,
		38,
		40,
		42,
		56,
		54,
		25,
		31,
		35,
		52,
		68,
		69,
		79,
		-1,
		-1,
		123,
		96,
		120,
		78,
		60,
		-1,
		26,
		28,
		34,
		38,
		43,
		51,
		56,
		41,
		-1,
		46,
		45,
		76,
		62,
		73,
		105,
		-1,
		-1,
		81,
		73,
		55,
		58,
		35,
		31,
		43,
		42,
		38,
		40,
		42,
		54,
		49,
		62,
		69,
		40,
		50,
		54,
		69,
		80,
		-1,
		-1,
		154,
		-1,
		-1,
		102,
		85,
		-1,
		50,
		57,
		41,
		47,
		33,
		54,
		53,
		47,
		54,
		57,
		45,
		62,
		59,
		76,
		62,
		37,
		62,
		66,
		72,
		90,
		91,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		57,
		54,
		47,
		71,
		70,
		-1,
		76,
		74,
		80,
		65,
		70,
		66,
		51,
		67,
		62,
		62,
		59,
		44,
		46,
		83,
		74,
		95,
		92,
		123,
		129,
		123,
		132,
		-1,
		110,
		106,
		102,
		109,
		58,
		-1,
		-1,
		75,
		-1,
		78,
		91,
		88,
		76,
		79,
		66,
		74,
		73,
		57,
		73,
		60,
		57,
		56,
		52,
		61,
		71,
		70,
		88,
		101,
		116,
		120,
		126,
		-1,
		160,
		-1,
		102,
		86,
		88,
		64,
		92,
		-1,
		95,
		79,
		99,
		90,
		90,
		-1,
		82,
		79,
		89,
		72,
		57,
		72,
		60,
		55,
		55,
		59,
		74,
		65,
		83,
		90,
		98,
		102,
		122,
		134,
		120,
		110,
		-1,
		92,
		97,
		67,
		79,
		102,
		122,
		106,
		-1,
		101,
		-1,
		84,
		97,
		-1,
		78,
		74,
		63,
		68,
		57,
		64,
		62,
		56,
		53,
		71,
		74,
		91,
		95,
		111,
		-1,
		-1,
		105,
		109,
		117,
		68,
		87,
		111,
		148,
		115,
		108,
		107,
		-1,
		102,
		99,
		96,
		97,
		83,
		76,
		77,
		63,
		69,
		70,
		55,
		58,
		80,
		108,
		86,
		98,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		94,
		65,
		89,
		131,
		137,
		130,
		118,
		133,
		133,
		126,
		-1,
		114,
		93,
		90,
		80,
		70,
		86,
		76,
		79,
		59,
		61,
		77,
		89,
		80,
		100,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		68,
		102,
		120,
		166,
		152,
		157,
		132,
		125,
		119,
		108,
		110,
		98,
		87,
		79,
		68,
		77,
		87,
		81,
		61,
		70,
		71,
		95,
		102,
		108,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		93,
		100,
		132,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		81,
		75,
		84,
		89,
		75,
		66,
		81,
		100,
		100,
		92,
		117,
		120,
		-1,
		-1,
		-1,
		124,
		141,
		116,
		93,
		74,
		110,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		85,
		89,
		82,
		89,
		85,
		84,
		85,
		67,
		103,
		-1,
		100,
		94,
		122,
		125,
		115,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		81,
		133,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		94,
		92,
		86,
		90,
		94,
		83,
		96,
		92,
		72,
		82,
		102,
		106,
		113,
		106,
		111,
		110,
		124,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		101,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		101,
		101,
		97,
		105,
		90,
		89,
		75,
		79,
		97,
		124,
		119,
		114,
		113,
		120,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		116,
		-1,
		87,
		111,
		127,
		-1,
		142,
		121,
		136,
		114,
		110,
		106,
		121,
		122,
		100,
		105,
		104,
		114,
		111,
		100,
		87,
		91,
		106,
		116,
		108,
		109,
		118,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		90,
		103,
		114,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		120,
		118,
		111,
		102,
		108,
		115,
		118,
		115,
		105,
		94,
		100,
		96,
		118,
		104,
		102,
		121,
		136,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		140,
		-1,
		113,
		113,
		104,
		93,
		90,
		101,
		99,
		110,
		127,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		147,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		135,
		130,
		121,
		102,
		95,
		92,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		148,
		128,
		134,
		92,
		113,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		152,
		140,
		130,
		120,
		154,
		146,
		121,
		114,
		100,
		102,
		100,
		102,
		107,
		128,
		129,
		142,
		-1,
		-1,
		125,
		132,
		120,
		106,
		125,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		141,
		-1,
		-1,
		132,
		130,
		138,
		117,
		104,
		124,
		127,
		117,
		101,
		116,
		128,
		136,
		141,
		-1,
		128,
		115,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		158,
		162,
		135,
		-1,
		134,
		128,
		108,
		122,
		129,
		119,
		114,
		108,
		111,
		129,
		146,
		-1,
		-1,
		142,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		151,
		144,
		148,
		-1,
		136,
		124,
		110,
		127,
		132,
		129,
		120,
		112,
		117,
		114,
		127,
		141,
		145,
		165,
		-1,
		148,
		-1,
		-1,
		-1,
		160,
		175,
		190,
		167,
		140,
		135,
		128,
		122,
		118,
		134,
		140,
		151,
		119,
		115,
		116,
		120,
		119,
		136,
		146,
		-1,
		-1,
		148,
		165,
		186,
		168,
		172,
		217,
		-1,
		-1,
		144,
		135,
		126,
		129,
		128,
		131,
		125,
		122,
		127,
		132,
		120,
		129,
		147,
		146,
		-1,
		-1,
		-1,
		168,
		-1,
		183,
		-1,
		-1,
		187,
		215,
		162,
		144,
		140,
		138,
		131,
		140,
		135,
		130,
		140,
		142,
		134,
		122,
		126,
		149,
		138,
		177,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		197,
		172,
		187,
		226,
		207,
		214,
		177,
		174,
		-1,
		144,
		169,
		141,
		148,
		139,
		146,
		146,
		138,
		116,
		123,
		139,
		138,
		133,
		169,
		160,
		166,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		203,
		189,
		212,
		202,
		205,
		-1,
		-1,
		193,
		190,
		166,
		149,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		206,
		208,
		196,
		194,
		196,
		-1,
		-1,
		166,
		163,
		168,
		156,
		153,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		213,
		-1,
		-1,
		204,
		197,
		181,
		171,
		165,
		215,
		170,
		165,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		220,
		-1,
		208,
		-1,
		183,
		187,
		178,
		181,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		284,
		240,
		218,
		209,
		256,
		271,
		275,
		-1,
		225,
		264,
		258,
		-1,
		229,
		-1,
		-1,
		-1,
		197,
		191,
		183,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		280,
		271,
		284,
		229,
		223,
		241,
		250,
		271,
		240,
		231,
		258,
		265,
		254,
		249,
		236,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		220,
		242,
		-1,
		-1,
		242,
		259,
		253,
		257,
		273,
		298,
		-1,
		229,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		257,
		254,
		242,
		240,
		263,
		228,
		216,
		-1,
		229,
		227,
		233,
		240,
		257,
		287,
		-1,
		-1,
		245,
		225,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		214,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		231,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		300,
		-1,
		252,
		228,
		242,
		257,
		265,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		240,
		243,
		-1,
		-1,
		242,
		244,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		247,
		248,
		249,
		-1,
		227,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		212,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		324,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		80,
		69,
		80,
		88,
		61,
		68,
		-1,
		86,
		91,
		57,
		51,
		89,
		58,
		64,
		75,
		-1,
		-1,
		-1,
		80,
		79,
		46,
		44,
		53,
		58,
		65,
		-1,
		68,
		-1,
		101,
		80,
		91,
		96,
		39,
		36,
		56,
		75,
		60,
		54,
		116,
		69,
		40,
		34,
		52,
		39,
		54,
		46,
		-1,
		40,
		30,
		50,
		28,
		39,
		39,
		-1,
		-1,
		30,
		31,
		39,
		24,
		39,
		40,
		-1,
		65,
		84,
		-1,
		-1,
		24,
		14,
		4,
		17,
		25,
		31,
		57,
		74,
		79,
		-1,
		-1,
		6,
		0,
		13,
		16,
		12,
		44,
		63,
		74,
		88,
		87,
		-1,
		18,
		35,
		39,
		23,
		34,
		20,
		24,
		42,
		73,
		79,
		82,
		-1,
		35,
		31,
		38,
		44,
		41,
		36,
		23,
		29,
		48,
		61,
		80,
		71,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		36,
		27,
		44,
		46,
		48,
		57,
		55,
		26,
		32,
		36,
		53,
		69,
		70,
		80,
		-1,
		-1,
		129,
		102,
		126,
		84,
		66,
		-1,
		32,
		34,
		40,
		44,
		49,
		57,
		57,
		42,
		-1,
		47,
		46,
		77,
		63,
		74,
		111,
		-1,
		-1,
		87,
		79,
		61,
		64,
		41,
		37,
		49,
		48,
		44,
		46,
		48,
		60,
		50,
		63,
		70,
		41,
		51,
		55,
		70,
		81,
		-1,
		-1,
		155,
		-1,
		-1,
		108,
		91,
		-1,
		56,
		63,
		47,
		53,
		39,
		60,
		59,
		53,
		60,
		63,
		51,
		63,
		60,
		77,
		63,
		38,
		63,
		67,
		73,
		91,
		92,
		-1,
		154,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		63,
		60,
		53,
		77,
		76,
		-1,
		82,
		80,
		86,
		71,
		76,
		72,
		57,
		68,
		63,
		63,
		60,
		45,
		47,
		84,
		75,
		96,
		93,
		124,
		130,
		124,
		133,
		-1,
		116,
		112,
		108,
		115,
		64,
		-1,
		-1,
		81,
		-1,
		84,
		97,
		94,
		82,
		85,
		72,
		80,
		79,
		63,
		74,
		61,
		58,
		57,
		53,
		62,
		72,
		71,
		89,
		102,
		117,
		121,
		127,
		-1,
		166,
		-1,
		108,
		92,
		94,
		70,
		98,
		-1,
		101,
		85,
		105,
		96,
		96,
		-1,
		88,
		85,
		95,
		78,
		63,
		73,
		61,
		56,
		56,
		60,
		75,
		66,
		84,
		91,
		99,
		103,
		123,
		135,
		126,
		116,
		-1,
		98,
		103,
		73,
		85,
		108,
		128,
		112,
		-1,
		107,
		-1,
		90,
		103,
		-1,
		84,
		80,
		69,
		69,
		58,
		65,
		63,
		57,
		54,
		72,
		75,
		92,
		96,
		112,
		-1,
		-1,
		111,
		115,
		123,
		74,
		93,
		117,
		154,
		121,
		114,
		113,
		-1,
		108,
		105,
		102,
		103,
		89,
		82,
		81,
		64,
		70,
		71,
		56,
		59,
		81,
		109,
		87,
		99,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		100,
		71,
		95,
		137,
		143,
		136,
		124,
		134,
		134,
		128,
		-1,
		120,
		99,
		92,
		81,
		71,
		87,
		77,
		80,
		60,
		62,
		78,
		90,
		81,
		101,
		-1,
		-1,
		-1,
		130,
		119,
		120,
		74,
		108,
		126,
		167,
		153,
		158,
		133,
		126,
		120,
		114,
		116,
		99,
		88,
		80,
		69,
		78,
		88,
		82,
		62,
		71,
		72,
		96,
		103,
		109,
		-1,
		-1,
		137,
		127,
		111,
		113,
		110,
		99,
		106,
		138,
		158,
		171,
		-1,
		125,
		-1,
		114,
		109,
		93,
		88,
		85,
		82,
		76,
		85,
		90,
		76,
		67,
		82,
		101,
		101,
		93,
		118,
		121,
		-1,
		-1,
		-1,
		130,
		147,
		122,
		99,
		80,
		116,
		-1,
		141,
		142,
		-1,
		119,
		113,
		110,
		95,
		91,
		86,
		90,
		83,
		90,
		86,
		85,
		86,
		68,
		104,
		-1,
		101,
		95,
		123,
		126,
		116,
		-1,
		-1,
		-1,
		145,
		124,
		117,
		137,
		87,
		139,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		95,
		93,
		87,
		91,
		95,
		84,
		97,
		93,
		73,
		83,
		103,
		107,
		114,
		107,
		112,
		111,
		125,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		107,
		-1,
		135,
		127,
		117,
		111,
		105,
		101,
		99,
		115,
		99,
		102,
		102,
		98,
		106,
		91,
		90,
		76,
		80,
		98,
		125,
		120,
		115,
		114,
		121,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		122,
		-1,
		93,
		117,
		133,
		-1,
		143,
		122,
		137,
		115,
		111,
		107,
		122,
		123,
		101,
		106,
		105,
		115,
		112,
		101,
		88,
		92,
		107,
		117,
		109,
		110,
		119,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		96,
		105,
		120,
		-1,
		-1,
		179,
		-1,
		113,
		130,
		121,
		119,
		112,
		103,
		109,
		116,
		119,
		116,
		106,
		95,
		101,
		97,
		119,
		105,
		103,
		122,
		137,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		157,
		147,
		131,
		116,
		149,
		-1,
		120,
		104,
		109,
		-1,
		141,
		-1,
		114,
		114,
		105,
		94,
		91,
		102,
		100,
		111,
		128,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		153,
		-1,
		-1,
		144,
		138,
		138,
		122,
		125,
		136,
		116,
		110,
		109,
		136,
		131,
		122,
		103,
		96,
		93,
		94,
		107,
		127,
		118,
		130,
		-1,
		-1,
		-1,
		154,
		134,
		140,
		98,
		119,
		-1,
		-1,
		206,
		161,
		147,
		-1,
		131,
		153,
		141,
		131,
		121,
		155,
		147,
		122,
		115,
		101,
		103,
		101,
		103,
		108,
		129,
		130,
		143,
		-1,
		-1,
		131,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		153,
		169,
		161,
		132,
		142,
		-1,
		-1,
		133,
		131,
		139,
		118,
		105,
		125,
		128,
		118,
		102,
		117,
		129,
		137,
		142,
		-1,
		134,
		121,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		164,
		159,
		163,
		136,
		-1,
		135,
		129,
		109,
		123,
		130,
		120,
		115,
		109,
		112,
		130,
		147,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		143,
		157,
		152,
		145,
		149,
		-1,
		137,
		125,
		111,
		128,
		133,
		130,
		121,
		113,
		118,
		115,
		128,
		142,
		146,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		161,
		176,
		191,
		168,
		141,
		136,
		129,
		123,
		119,
		135,
		141,
		152,
		120,
		116,
		117,
		121,
		120,
		137,
		147,
		-1,
		-1,
		154,
		171,
		187,
		169,
		173,
		218,
		-1,
		-1,
		145,
		136,
		127,
		130,
		129,
		132,
		126,
		123,
		128,
		133,
		121,
		130,
		148,
		147,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		188,
		216,
		163,
		145,
		141,
		139,
		132,
		141,
		136,
		131,
		141,
		143,
		135,
		123,
		127,
		150,
		139,
		178,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		227,
		208,
		215,
		178,
		175,
		-1,
		145,
		170,
		142,
		149,
		140,
		147,
		147,
		139,
		117,
		124,
		140,
		139,
		134,
		170,
		161,
		167,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		209,
		195,
		213,
		203,
		206,
		-1,
		-1,
		194,
		191,
		167,
		150,
		148,
		141,
		136,
		146,
		126,
		113,
		117,
		121,
		127,
		132,
		137,
		143,
		158,
		173,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		212,
		209,
		202,
		195,
		197,
		-1,
		-1,
		167,
		164,
		169,
		157,
		154,
		156,
		151,
		142,
		127,
		133,
		120,
		119,
		137,
		141,
		150,
		157,
		147,
		160,
		164,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		214,
		-1,
		-1,
		210,
		198,
		182,
		172,
		166,
		216,
		171,
		166,
		150,
		148,
		139,
		130,
		137,
		128,
		128,
		131,
		146,
		151,
		143,
		157,
		157,
		158,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		226,
		-1,
		209,
		-1,
		184,
		188,
		179,
		182,
		164,
		151,
		143,
		135,
		151,
		126,
		136,
		132,
		133,
		142,
		153,
		165,
		164,
		165,
		285,
		241,
		224,
		215,
		262,
		277,
		281,
		-1,
		226,
		265,
		263,
		-1,
		235,
		-1,
		-1,
		-1,
		198,
		192,
		184,
		184,
		163,
		163,
		137,
		141,
		131,
		138,
		148,
		150,
		142,
		146,
		159,
		170,
		173,
		281,
		272,
		285,
		230,
		229,
		247,
		256,
		277,
		241,
		232,
		259,
		270,
		259,
		254,
		241,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		170,
		158,
		141,
		142,
		138,
		141,
		156,
		159,
		149,
		147,
		141,
		173,
		-1,
		274,
		273,
		262,
		259,
		235,
		226,
		221,
		248,
		-1,
		-1,
		243,
		260,
		254,
		258,
		274,
		299,
		-1,
		230,
		-1,
		-1,
		215,
		-1,
		-1,
		200,
		163,
		152,
		143,
		149,
		146,
		157,
		167,
		155,
		156,
		146,
		156,
		169,
		258,
		255,
		243,
		241,
		264,
		229,
		217,
		-1,
		230,
		228,
		234,
		241,
		258,
		288,
		-1,
		-1,
		246,
		226,
		-1,
		-1,
		198,
		196,
		185,
		-1,
		175,
		148,
		153,
		173,
		175,
		164,
		158,
		152,
		159,
		158,
		166,
		174,
		267,
		281,
		270,
		266,
		265,
		273,
		222,
		215,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		236,
		232,
		-1,
		-1,
		193,
		186,
		174,
		162,
		152,
		162,
		166,
		170,
		162,
		155,
		150,
		161,
		153,
		157,
		174,
		-1,
		301,
		-1,
		253,
		229,
		243,
		258,
		266,
		-1,
		-1,
		-1,
		253,
		239,
		232,
		220,
		218,
		-1,
		227,
		211,
		192,
		-1,
		162,
		175,
		206,
		174,
		179,
		174,
		156,
		167,
		156,
		159,
		173,
		168,
		-1,
		-1,
		241,
		244,
		-1,
		-1,
		243,
		245,
		-1,
		244,
		233,
		218,
		210,
		-1,
		-1,
		199,
		195,
		-1,
		-1,
		163,
		188,
		177,
		185,
		180,
		160,
		166,
		169,
		158,
		162,
		174,
		-1,
		-1,
		248,
		249,
		250,
		-1,
		228,
		-1,
		246,
		-1,
		213,
		219,
		207,
		-1,
		-1,
		-1,
		201,
		164,
		185,
		195,
		189,
		187,
		178,
		164,
		171,
		169,
		165,
		176,
		-1,
		-1,
		-1,
		246,
		220,
		253,
		244,
		227,
		207,
		199,
		218,
		-1,
		188,
		-1,
		163,
		165,
		191,
		194,
		200,
		194,
		167,
		182,
		172,
		163,
		172,
		252,
		-1,
		222,
		255,
		219,
		213,
		189,
		193,
		209,
		-1,
		185,
		167,
		-1,
		195,
		185,
		216,
		201,
		182,
		169,
		176,
		176,
		169,
		-1,
		-1,
		-1,
		224,
		223,
		215,
		209,
		209,
		194,
		185,
		-1,
		197,
		179,
		158,
		175,
		175,
		166,
		174,
		206,
		202,
		189,
		189,
		181,
		-1,
		325,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		218,
		213,
		186,
		174,
		180,
		176,
		162,
		168,
		170,
		178,
		176,
		173,
		185,
		181,
		201,
		182,
		217,
		-1,
		320,
		-1,
		254,
		-1,
		-1,
		236,
		216,
		208,
		197,
		186,
		184,
		175,
		166,
		188,
		204,
		188,
		186,
		189,
		190,
		-1,
		309,
		308,
		-1,
		255,
		247,
		233,
		-1,
		226,
		-1,
		232,
		193,
		-1,
		195,
		175,
		-1,
		197,
		193,
		-1,
		-1,
		296,
		271,
		-1,
		-1,
		-1,
		256,
		236,
		227,
		211,
		-1,
		186,
		186,
		-1,
		-1,
		-1,
		281,
		280,
		-1,
		249,
		252,
		-1,
		242,
		233,
		241,
		188,
		192,
		-1,
		-1,
		-1,
		290,
		271,
		265,
		264,
		262,
		257,
		254,
		240,
		224,
		202,
		191,
		212,
		-1,
		-1,
		-1,
		262,
		254,
		247,
		-1,
		-1,
		249,
		232,
		213,
		211,
		-1,
		-1,
		-1,
		284,
		265,
		-1,
		-1,
		239,
		-1,
		-1,
		245,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		273,
		-1,
		-1,
		-1,
		235,
		231,
		232,
		-1,
		-1,
		-1,
		-1,
		295,
		296,
		319,
		283,
		-1,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		298,
		296,
		-1,
		-1,
		-1,
		255,
		239,
		-1,
		225,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		260,
		-1,
		260,
		235,
		242,
		-1,
		-1,
		-1,
		-1,
		273,
		265,
		273,
		-1,
		245,
		247,
		-1,
		295,
		-1,
		-1,
		288,
		279,
		-1,
		-1,
		250,
		257,
		279,
		282,
		318,
		-1,
		269
	],
	[
		-1,
		90,
		79,
		90,
		98,
		71,
		78,
		-1,
		96,
		101,
		67,
		61,
		99,
		68,
		74,
		85,
		-1,
		-1,
		-1,
		90,
		89,
		56,
		54,
		63,
		68,
		75,
		-1,
		69,
		-1,
		111,
		90,
		101,
		106,
		49,
		46,
		66,
		84,
		61,
		57,
		126,
		79,
		50,
		44,
		61,
		40,
		55,
		47,
		-1,
		50,
		40,
		51,
		29,
		40,
		45,
		-1,
		-1,
		38,
		39,
		40,
		25,
		45,
		45,
		-1,
		70,
		89,
		-1,
		-1,
		34,
		25,
		9,
		23,
		31,
		36,
		62,
		79,
		84,
		-1,
		-1,
		17,
		11,
		0,
		21,
		17,
		49,
		68,
		79,
		93,
		92,
		-1,
		29,
		44,
		31,
		23,
		29,
		25,
		29,
		47,
		78,
		84,
		87,
		-1,
		46,
		42,
		43,
		33,
		28,
		41,
		28,
		34,
		53,
		66,
		85,
		76,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		47,
		38,
		55,
		51,
		59,
		44,
		54,
		31,
		37,
		41,
		58,
		74,
		75,
		85,
		-1,
		-1,
		140,
		113,
		137,
		95,
		77,
		-1,
		43,
		45,
		51,
		55,
		57,
		65,
		56,
		47,
		-1,
		52,
		51,
		82,
		68,
		79,
		122,
		-1,
		-1,
		98,
		90,
		72,
		75,
		52,
		48,
		60,
		59,
		55,
		57,
		59,
		68,
		55,
		68,
		75,
		46,
		56,
		60,
		75,
		86,
		-1,
		-1,
		160,
		-1,
		-1,
		119,
		102,
		-1,
		67,
		74,
		58,
		64,
		50,
		71,
		70,
		64,
		71,
		74,
		62,
		68,
		65,
		82,
		68,
		43,
		68,
		72,
		78,
		96,
		97,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		74,
		71,
		64,
		88,
		87,
		-1,
		93,
		91,
		97,
		82,
		87,
		83,
		68,
		73,
		68,
		68,
		65,
		50,
		52,
		89,
		80,
		101,
		98,
		129,
		135,
		129,
		138,
		-1,
		127,
		123,
		119,
		126,
		75,
		-1,
		-1,
		92,
		-1,
		95,
		108,
		105,
		93,
		96,
		83,
		91,
		90,
		74,
		79,
		66,
		63,
		62,
		58,
		67,
		77,
		76,
		94,
		107,
		122,
		126,
		132,
		-1,
		177,
		-1,
		119,
		103,
		105,
		81,
		109,
		-1,
		112,
		96,
		116,
		107,
		107,
		-1,
		99,
		96,
		106,
		89,
		74,
		78,
		66,
		61,
		61,
		65,
		80,
		71,
		89,
		96,
		104,
		108,
		128,
		140,
		137,
		127,
		-1,
		109,
		114,
		84,
		96,
		119,
		139,
		123,
		-1,
		118,
		-1,
		101,
		114,
		-1,
		95,
		91,
		80,
		74,
		63,
		70,
		68,
		62,
		59,
		77,
		80,
		97,
		101,
		117,
		-1,
		-1,
		122,
		126,
		134,
		85,
		104,
		128,
		165,
		132,
		125,
		124,
		-1,
		119,
		116,
		113,
		114,
		100,
		88,
		86,
		69,
		75,
		76,
		61,
		64,
		86,
		114,
		92,
		104,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		111,
		82,
		106,
		148,
		154,
		147,
		135,
		139,
		139,
		133,
		-1,
		127,
		106,
		97,
		86,
		76,
		92,
		82,
		85,
		65,
		67,
		83,
		95,
		86,
		106,
		-1,
		-1,
		-1,
		141,
		130,
		131,
		85,
		119,
		137,
		172,
		158,
		163,
		138,
		131,
		125,
		125,
		123,
		104,
		93,
		85,
		74,
		83,
		93,
		87,
		67,
		76,
		77,
		101,
		108,
		114,
		-1,
		-1,
		148,
		138,
		122,
		124,
		121,
		110,
		117,
		149,
		163,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		87,
		81,
		90,
		95,
		81,
		72,
		87,
		106,
		106,
		98,
		123,
		126,
		-1,
		-1,
		-1,
		141,
		158,
		133,
		110,
		91,
		127,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		91,
		95,
		88,
		95,
		91,
		90,
		91,
		73,
		109,
		-1,
		106,
		100,
		128,
		131,
		121,
		-1,
		-1,
		-1,
		156,
		135,
		128,
		148,
		98,
		150,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		100,
		98,
		92,
		96,
		100,
		89,
		102,
		98,
		78,
		88,
		108,
		112,
		119,
		112,
		117,
		116,
		130,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		118,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		120,
		104,
		107,
		107,
		103,
		111,
		96,
		95,
		81,
		85,
		103,
		130,
		125,
		120,
		119,
		126,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		133,
		-1,
		104,
		128,
		144,
		-1,
		148,
		127,
		142,
		120,
		116,
		112,
		127,
		128,
		106,
		111,
		110,
		120,
		117,
		106,
		93,
		97,
		112,
		122,
		114,
		115,
		124,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		107,
		110,
		131,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		126,
		124,
		117,
		108,
		114,
		121,
		124,
		121,
		111,
		100,
		106,
		102,
		124,
		110,
		108,
		127,
		142,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		125,
		109,
		114,
		-1,
		146,
		-1,
		119,
		119,
		110,
		99,
		96,
		107,
		105,
		116,
		133,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		164,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		141,
		121,
		115,
		114,
		141,
		136,
		127,
		108,
		101,
		98,
		99,
		112,
		132,
		123,
		135,
		-1,
		-1,
		-1,
		165,
		145,
		151,
		109,
		130,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		158,
		146,
		136,
		126,
		160,
		152,
		127,
		120,
		106,
		108,
		106,
		108,
		113,
		134,
		135,
		148,
		-1,
		-1,
		142,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		147,
		-1,
		-1,
		138,
		136,
		144,
		123,
		110,
		130,
		133,
		123,
		107,
		122,
		134,
		142,
		147,
		-1,
		145,
		132,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		169,
		164,
		168,
		141,
		-1,
		140,
		134,
		114,
		128,
		135,
		125,
		120,
		114,
		117,
		135,
		152,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		148,
		162,
		157,
		150,
		154,
		-1,
		142,
		130,
		116,
		133,
		138,
		135,
		126,
		118,
		123,
		120,
		133,
		147,
		151,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		166,
		181,
		196,
		173,
		146,
		141,
		134,
		128,
		124,
		140,
		146,
		157,
		125,
		121,
		122,
		126,
		125,
		142,
		152,
		-1,
		-1,
		165,
		182,
		192,
		174,
		178,
		223,
		-1,
		-1,
		150,
		141,
		132,
		135,
		134,
		137,
		131,
		128,
		133,
		138,
		126,
		135,
		153,
		152,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		193,
		221,
		168,
		150,
		146,
		144,
		137,
		146,
		141,
		136,
		146,
		148,
		140,
		128,
		132,
		155,
		144,
		183,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		214,
		189,
		204,
		232,
		213,
		220,
		183,
		180,
		-1,
		150,
		175,
		147,
		154,
		145,
		152,
		152,
		144,
		122,
		129,
		145,
		144,
		139,
		175,
		166,
		172,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		220,
		206,
		218,
		208,
		211,
		-1,
		-1,
		199,
		196,
		172,
		155,
		153,
		146,
		141,
		151,
		131,
		118,
		122,
		126,
		132,
		137,
		142,
		148,
		163,
		178,
		-1,
		190,
		271,
		264,
		247,
		255,
		286,
		-1,
		222,
		214,
		213,
		200,
		202,
		-1,
		-1,
		172,
		169,
		174,
		162,
		159,
		161,
		156,
		147,
		132,
		138,
		125,
		124,
		142,
		146,
		155,
		162,
		152,
		165,
		169,
		-1,
		204,
		247,
		241,
		244,
		268,
		282,
		-1,
		219,
		-1,
		-1,
		221,
		203,
		187,
		177,
		171,
		221,
		176,
		171,
		155,
		153,
		144,
		135,
		142,
		133,
		133,
		136,
		151,
		156,
		148,
		162,
		162,
		163,
		-1,
		239,
		227,
		235,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		237,
		-1,
		214,
		-1,
		189,
		193,
		184,
		187,
		169,
		156,
		148,
		140,
		156,
		131,
		141,
		137,
		138,
		147,
		158,
		170,
		169,
		170,
		290,
		246,
		235,
		226,
		271,
		286,
		290,
		-1,
		231,
		270,
		268,
		-1,
		246,
		-1,
		-1,
		-1,
		203,
		197,
		189,
		189,
		168,
		168,
		142,
		146,
		136,
		143,
		153,
		155,
		147,
		151,
		164,
		175,
		178,
		286,
		277,
		290,
		235,
		235,
		256,
		265,
		286,
		246,
		237,
		264,
		275,
		264,
		259,
		246,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		175,
		163,
		146,
		147,
		143,
		146,
		161,
		164,
		154,
		152,
		146,
		178,
		-1,
		279,
		278,
		267,
		264,
		240,
		231,
		226,
		253,
		-1,
		-1,
		248,
		265,
		259,
		263,
		279,
		304,
		-1,
		235,
		-1,
		-1,
		220,
		-1,
		-1,
		205,
		168,
		157,
		148,
		154,
		151,
		162,
		172,
		160,
		161,
		151,
		161,
		174,
		263,
		260,
		248,
		246,
		269,
		234,
		222,
		-1,
		235,
		233,
		239,
		246,
		263,
		293,
		-1,
		-1,
		251,
		231,
		-1,
		-1,
		203,
		201,
		190,
		-1,
		180,
		153,
		158,
		178,
		180,
		169,
		163,
		157,
		164,
		163,
		171,
		179,
		272,
		286,
		275,
		271,
		270,
		278,
		227,
		220,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		-1,
		241,
		237,
		-1,
		-1,
		198,
		191,
		179,
		167,
		157,
		167,
		171,
		175,
		167,
		160,
		155,
		166,
		158,
		162,
		179,
		-1,
		306,
		-1,
		258,
		234,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		258,
		244,
		237,
		225,
		223,
		-1,
		232,
		216,
		197,
		-1,
		167,
		180,
		211,
		179,
		184,
		179,
		161,
		172,
		161,
		164,
		178,
		173,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		248,
		250,
		-1,
		249,
		238,
		223,
		215,
		-1,
		-1,
		204,
		200,
		-1,
		-1,
		168,
		193,
		182,
		190,
		185,
		165,
		171,
		174,
		163,
		167,
		179,
		-1,
		-1,
		253,
		254,
		255,
		-1,
		233,
		-1,
		251,
		-1,
		218,
		224,
		212,
		-1,
		-1,
		-1,
		206,
		169,
		190,
		200,
		194,
		192,
		183,
		169,
		176,
		174,
		170,
		181,
		-1,
		-1,
		-1,
		251,
		225,
		258,
		249,
		232,
		212,
		204,
		223,
		-1,
		193,
		-1,
		168,
		170,
		196,
		199,
		205,
		199,
		172,
		187,
		177,
		168,
		177,
		257,
		-1,
		227,
		260,
		224,
		218,
		194,
		198,
		214,
		-1,
		190,
		172,
		-1,
		200,
		190,
		221,
		206,
		187,
		174,
		181,
		181,
		174,
		-1,
		-1,
		-1,
		229,
		228,
		220,
		214,
		214,
		199,
		190,
		-1,
		202,
		184,
		163,
		180,
		180,
		171,
		179,
		211,
		207,
		194,
		194,
		186,
		-1,
		330,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		223,
		218,
		191,
		179,
		185,
		181,
		167,
		173,
		175,
		183,
		181,
		178,
		190,
		186,
		206,
		187,
		222,
		-1,
		325,
		-1,
		259,
		-1,
		-1,
		241,
		221,
		213,
		202,
		191,
		189,
		180,
		171,
		193,
		209,
		193,
		191,
		194,
		195,
		-1,
		314,
		313,
		-1,
		260,
		252,
		238,
		-1,
		231,
		-1,
		237,
		198,
		-1,
		200,
		180,
		-1,
		202,
		198,
		-1,
		-1,
		301,
		276,
		-1,
		-1,
		-1,
		261,
		241,
		232,
		216,
		-1,
		191,
		191,
		-1,
		-1,
		-1,
		286,
		285,
		-1,
		254,
		257,
		-1,
		247,
		238,
		246,
		193,
		197,
		-1,
		-1,
		-1,
		295,
		276,
		270,
		269,
		267,
		262,
		259,
		245,
		229,
		207,
		196,
		217,
		-1,
		-1,
		-1,
		267,
		259,
		252,
		-1,
		-1,
		254,
		237,
		218,
		216,
		-1,
		-1,
		-1,
		289,
		270,
		-1,
		-1,
		244,
		-1,
		-1,
		250,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		278,
		-1,
		-1,
		-1,
		240,
		236,
		237,
		-1,
		-1,
		-1,
		-1,
		300,
		301,
		324,
		288,
		-1,
		-1,
		-1,
		232,
		226,
		-1,
		-1,
		303,
		301,
		-1,
		-1,
		-1,
		260,
		244,
		-1,
		230,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		265,
		-1,
		265,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		278,
		270,
		278,
		-1,
		250,
		252,
		-1,
		300,
		-1,
		-1,
		293,
		284,
		-1,
		-1,
		255,
		262,
		284,
		287,
		323,
		-1,
		274
	],
	[
		-1,
		94,
		83,
		94,
		102,
		75,
		82,
		-1,
		100,
		105,
		71,
		65,
		103,
		72,
		78,
		89,
		-1,
		-1,
		-1,
		94,
		93,
		60,
		58,
		67,
		72,
		79,
		-1,
		59,
		-1,
		115,
		94,
		105,
		110,
		53,
		50,
		70,
		71,
		52,
		44,
		130,
		83,
		54,
		48,
		58,
		37,
		46,
		38,
		-1,
		54,
		44,
		48,
		26,
		37,
		29,
		-1,
		-1,
		44,
		45,
		37,
		22,
		29,
		32,
		-1,
		57,
		76,
		-1,
		-1,
		38,
		28,
		12,
		7,
		15,
		23,
		49,
		66,
		71,
		-1,
		-1,
		20,
		14,
		21,
		0,
		4,
		36,
		55,
		66,
		80,
		79,
		-1,
		32,
		49,
		47,
		15,
		26,
		12,
		16,
		34,
		65,
		71,
		74,
		-1,
		49,
		45,
		52,
		42,
		37,
		28,
		15,
		21,
		40,
		53,
		72,
		63,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		50,
		41,
		58,
		60,
		62,
		49,
		47,
		18,
		24,
		28,
		45,
		61,
		62,
		72,
		-1,
		-1,
		143,
		116,
		140,
		98,
		80,
		-1,
		46,
		48,
		54,
		58,
		63,
		60,
		49,
		34,
		-1,
		39,
		38,
		69,
		55,
		66,
		125,
		-1,
		-1,
		101,
		93,
		75,
		78,
		55,
		51,
		63,
		62,
		58,
		60,
		62,
		57,
		42,
		55,
		62,
		33,
		43,
		47,
		62,
		73,
		-1,
		-1,
		147,
		-1,
		-1,
		122,
		105,
		-1,
		70,
		77,
		61,
		67,
		53,
		74,
		73,
		67,
		74,
		77,
		65,
		55,
		52,
		69,
		55,
		30,
		55,
		59,
		65,
		83,
		84,
		-1,
		146,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		77,
		74,
		67,
		91,
		90,
		-1,
		96,
		94,
		100,
		85,
		90,
		86,
		71,
		60,
		55,
		55,
		52,
		37,
		39,
		76,
		67,
		88,
		85,
		116,
		122,
		116,
		125,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		95,
		-1,
		98,
		111,
		108,
		96,
		99,
		86,
		94,
		93,
		77,
		66,
		53,
		50,
		49,
		45,
		54,
		64,
		63,
		81,
		94,
		109,
		113,
		119,
		-1,
		180,
		-1,
		122,
		106,
		108,
		84,
		112,
		-1,
		115,
		99,
		119,
		110,
		110,
		-1,
		102,
		99,
		109,
		92,
		77,
		65,
		53,
		48,
		48,
		52,
		67,
		58,
		76,
		83,
		91,
		95,
		115,
		127,
		140,
		130,
		-1,
		112,
		117,
		87,
		99,
		122,
		142,
		126,
		-1,
		121,
		-1,
		104,
		117,
		-1,
		98,
		94,
		73,
		61,
		50,
		57,
		55,
		49,
		46,
		64,
		67,
		84,
		88,
		104,
		-1,
		-1,
		125,
		129,
		137,
		88,
		107,
		131,
		168,
		135,
		128,
		127,
		-1,
		122,
		109,
		106,
		103,
		90,
		75,
		73,
		56,
		62,
		63,
		48,
		51,
		73,
		101,
		79,
		91,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		114,
		85,
		109,
		151,
		157,
		150,
		138,
		126,
		126,
		120,
		-1,
		114,
		93,
		84,
		73,
		63,
		79,
		69,
		72,
		52,
		54,
		70,
		82,
		73,
		93,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		88,
		122,
		140,
		159,
		145,
		150,
		125,
		118,
		112,
		118,
		110,
		91,
		80,
		72,
		61,
		70,
		80,
		74,
		54,
		63,
		64,
		88,
		95,
		101,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		113,
		120,
		152,
		150,
		163,
		-1,
		117,
		-1,
		106,
		101,
		85,
		80,
		77,
		74,
		68,
		77,
		82,
		68,
		59,
		74,
		93,
		93,
		85,
		110,
		113,
		-1,
		-1,
		-1,
		144,
		161,
		136,
		113,
		94,
		130,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		87,
		83,
		78,
		82,
		75,
		82,
		78,
		77,
		78,
		60,
		96,
		-1,
		93,
		87,
		115,
		118,
		108,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		101,
		153,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		87,
		85,
		79,
		83,
		87,
		76,
		89,
		85,
		65,
		75,
		95,
		99,
		106,
		99,
		104,
		103,
		117,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		121,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		107,
		91,
		94,
		94,
		90,
		98,
		83,
		82,
		68,
		72,
		90,
		117,
		112,
		107,
		106,
		113,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		136,
		-1,
		107,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		99,
		114,
		115,
		93,
		98,
		97,
		107,
		104,
		93,
		80,
		84,
		99,
		109,
		101,
		102,
		111,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		113,
		111,
		104,
		95,
		101,
		108,
		111,
		108,
		98,
		87,
		93,
		89,
		111,
		97,
		95,
		114,
		129,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		112,
		96,
		101,
		-1,
		133,
		-1,
		106,
		106,
		97,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		128,
		108,
		102,
		101,
		128,
		123,
		114,
		95,
		88,
		85,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		163,
		148,
		153,
		112,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		145,
		133,
		123,
		113,
		147,
		139,
		114,
		107,
		93,
		95,
		93,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		145,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		134,
		-1,
		-1,
		125,
		123,
		131,
		110,
		97,
		117,
		120,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		148,
		135,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		156,
		151,
		155,
		128,
		-1,
		127,
		121,
		101,
		115,
		122,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		135,
		149,
		144,
		137,
		141,
		-1,
		129,
		117,
		103,
		120,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		153,
		168,
		183,
		160,
		133,
		128,
		121,
		115,
		111,
		127,
		133,
		144,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		167,
		184,
		179,
		161,
		165,
		210,
		-1,
		-1,
		137,
		128,
		119,
		122,
		121,
		124,
		118,
		115,
		120,
		125,
		113,
		122,
		140,
		139,
		-1,
		-1,
		-1,
		187,
		-1,
		202,
		-1,
		-1,
		180,
		208,
		155,
		137,
		133,
		131,
		124,
		133,
		128,
		123,
		133,
		135,
		127,
		115,
		119,
		142,
		131,
		170,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		216,
		191,
		206,
		219,
		200,
		207,
		170,
		167,
		-1,
		137,
		162,
		134,
		141,
		132,
		139,
		139,
		131,
		109,
		116,
		132,
		131,
		126,
		162,
		153,
		159,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		219,
		208,
		205,
		195,
		198,
		-1,
		-1,
		186,
		183,
		159,
		142,
		140,
		133,
		128,
		138,
		118,
		105,
		109,
		113,
		119,
		124,
		129,
		135,
		150,
		165,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		209,
		201,
		212,
		187,
		189,
		-1,
		-1,
		159,
		156,
		161,
		149,
		146,
		148,
		143,
		134,
		119,
		125,
		112,
		111,
		129,
		133,
		142,
		149,
		139,
		152,
		156,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		206,
		-1,
		-1,
		218,
		190,
		174,
		164,
		158,
		208,
		163,
		158,
		142,
		140,
		131,
		122,
		129,
		120,
		120,
		123,
		138,
		143,
		135,
		149,
		149,
		150,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		234,
		-1,
		201,
		-1,
		176,
		180,
		171,
		174,
		156,
		143,
		135,
		127,
		143,
		118,
		128,
		124,
		125,
		134,
		145,
		157,
		156,
		157,
		277,
		233,
		236,
		229,
		258,
		273,
		277,
		-1,
		218,
		257,
		255,
		-1,
		239,
		-1,
		-1,
		-1,
		190,
		184,
		176,
		176,
		155,
		155,
		129,
		133,
		123,
		130,
		140,
		142,
		134,
		138,
		151,
		162,
		165,
		273,
		264,
		277,
		222,
		222,
		243,
		252,
		273,
		233,
		224,
		251,
		262,
		251,
		246,
		233,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		162,
		150,
		133,
		134,
		130,
		133,
		148,
		151,
		141,
		139,
		133,
		165,
		-1,
		266,
		265,
		254,
		251,
		227,
		218,
		213,
		240,
		-1,
		-1,
		235,
		252,
		246,
		250,
		266,
		291,
		-1,
		222,
		-1,
		-1,
		207,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		138,
		149,
		159,
		147,
		148,
		138,
		148,
		161,
		250,
		247,
		235,
		233,
		256,
		221,
		209,
		-1,
		222,
		220,
		226,
		233,
		250,
		280,
		-1,
		-1,
		238,
		218,
		-1,
		-1,
		190,
		188,
		177,
		-1,
		167,
		140,
		145,
		165,
		167,
		156,
		150,
		144,
		151,
		150,
		158,
		166,
		259,
		273,
		262,
		258,
		257,
		265,
		214,
		207,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		-1,
		228,
		224,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		158,
		162,
		154,
		147,
		142,
		153,
		145,
		149,
		166,
		-1,
		293,
		-1,
		245,
		221,
		235,
		250,
		258,
		-1,
		-1,
		-1,
		245,
		231,
		224,
		212,
		210,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		148,
		159,
		148,
		151,
		165,
		160,
		-1,
		-1,
		233,
		236,
		-1,
		-1,
		235,
		237,
		-1,
		236,
		225,
		210,
		202,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		152,
		158,
		161,
		150,
		154,
		166,
		-1,
		-1,
		240,
		241,
		242,
		-1,
		220,
		-1,
		238,
		-1,
		205,
		211,
		199,
		-1,
		-1,
		-1,
		193,
		156,
		177,
		187,
		181,
		179,
		170,
		156,
		163,
		161,
		157,
		168,
		-1,
		-1,
		-1,
		238,
		212,
		245,
		236,
		219,
		199,
		191,
		210,
		-1,
		180,
		-1,
		155,
		157,
		183,
		186,
		192,
		186,
		159,
		174,
		164,
		155,
		164,
		244,
		-1,
		214,
		247,
		211,
		205,
		181,
		185,
		201,
		-1,
		177,
		159,
		-1,
		187,
		177,
		208,
		193,
		174,
		161,
		168,
		168,
		161,
		-1,
		-1,
		-1,
		216,
		215,
		207,
		201,
		201,
		186,
		177,
		-1,
		189,
		171,
		150,
		167,
		167,
		158,
		166,
		198,
		194,
		181,
		181,
		173,
		-1,
		317,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		210,
		205,
		178,
		166,
		172,
		168,
		154,
		160,
		162,
		170,
		168,
		165,
		177,
		173,
		193,
		174,
		209,
		-1,
		312,
		-1,
		246,
		-1,
		-1,
		228,
		208,
		200,
		189,
		178,
		176,
		167,
		158,
		180,
		196,
		180,
		178,
		181,
		182,
		-1,
		301,
		300,
		-1,
		247,
		239,
		225,
		-1,
		218,
		-1,
		224,
		185,
		-1,
		187,
		167,
		-1,
		189,
		185,
		-1,
		-1,
		288,
		263,
		-1,
		-1,
		-1,
		248,
		228,
		219,
		203,
		-1,
		178,
		178,
		-1,
		-1,
		-1,
		273,
		272,
		-1,
		241,
		244,
		-1,
		234,
		225,
		233,
		180,
		184,
		-1,
		-1,
		-1,
		282,
		263,
		257,
		256,
		254,
		249,
		246,
		232,
		216,
		194,
		183,
		204,
		-1,
		-1,
		-1,
		254,
		246,
		239,
		-1,
		-1,
		241,
		224,
		205,
		203,
		-1,
		-1,
		-1,
		276,
		257,
		-1,
		-1,
		231,
		-1,
		-1,
		237,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		293,
		265,
		-1,
		-1,
		-1,
		227,
		223,
		224,
		-1,
		-1,
		-1,
		-1,
		287,
		288,
		311,
		275,
		-1,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		290,
		288,
		-1,
		-1,
		-1,
		247,
		231,
		-1,
		217,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		252,
		-1,
		252,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		265,
		257,
		265,
		-1,
		237,
		239,
		-1,
		287,
		-1,
		-1,
		280,
		271,
		-1,
		-1,
		242,
		249,
		271,
		274,
		310,
		-1,
		261
	],
	[
		-1,
		90,
		79,
		90,
		98,
		71,
		78,
		-1,
		96,
		101,
		67,
		61,
		99,
		68,
		74,
		85,
		-1,
		-1,
		-1,
		90,
		89,
		56,
		54,
		63,
		68,
		75,
		-1,
		63,
		-1,
		111,
		90,
		101,
		106,
		49,
		46,
		66,
		75,
		56,
		48,
		126,
		79,
		50,
		44,
		62,
		41,
		50,
		42,
		-1,
		50,
		40,
		52,
		30,
		41,
		33,
		-1,
		-1,
		40,
		41,
		41,
		26,
		32,
		28,
		-1,
		53,
		72,
		-1,
		-1,
		34,
		24,
		8,
		11,
		19,
		19,
		45,
		62,
		67,
		-1,
		-1,
		16,
		10,
		17,
		4,
		0,
		32,
		51,
		62,
		76,
		75,
		-1,
		28,
		45,
		43,
		11,
		22,
		8,
		12,
		30,
		61,
		67,
		70,
		-1,
		45,
		41,
		48,
		38,
		33,
		24,
		11,
		17,
		36,
		49,
		68,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		46,
		37,
		54,
		56,
		58,
		45,
		43,
		14,
		20,
		24,
		41,
		57,
		58,
		68,
		-1,
		-1,
		139,
		112,
		136,
		94,
		76,
		-1,
		42,
		44,
		50,
		54,
		59,
		56,
		45,
		30,
		-1,
		35,
		34,
		65,
		51,
		62,
		121,
		-1,
		-1,
		97,
		89,
		71,
		74,
		51,
		47,
		59,
		58,
		54,
		56,
		58,
		53,
		38,
		51,
		58,
		29,
		39,
		43,
		58,
		69,
		-1,
		-1,
		143,
		-1,
		-1,
		118,
		101,
		-1,
		66,
		73,
		57,
		63,
		49,
		70,
		69,
		63,
		70,
		73,
		61,
		51,
		48,
		65,
		51,
		26,
		51,
		55,
		61,
		79,
		80,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		73,
		70,
		63,
		87,
		86,
		-1,
		92,
		90,
		96,
		81,
		86,
		82,
		67,
		56,
		51,
		51,
		48,
		33,
		35,
		72,
		63,
		84,
		81,
		112,
		118,
		112,
		121,
		-1,
		126,
		122,
		118,
		125,
		74,
		-1,
		-1,
		91,
		-1,
		94,
		107,
		104,
		92,
		95,
		82,
		90,
		89,
		73,
		62,
		49,
		46,
		45,
		41,
		50,
		60,
		59,
		77,
		90,
		105,
		109,
		115,
		-1,
		176,
		-1,
		118,
		102,
		104,
		80,
		108,
		-1,
		111,
		95,
		115,
		106,
		106,
		-1,
		98,
		95,
		105,
		88,
		73,
		61,
		49,
		44,
		44,
		48,
		63,
		54,
		72,
		79,
		87,
		91,
		111,
		123,
		136,
		126,
		-1,
		108,
		113,
		83,
		95,
		118,
		138,
		122,
		-1,
		117,
		-1,
		100,
		113,
		-1,
		94,
		90,
		69,
		57,
		46,
		53,
		51,
		45,
		42,
		60,
		63,
		80,
		84,
		100,
		-1,
		-1,
		121,
		125,
		133,
		84,
		103,
		127,
		164,
		131,
		124,
		123,
		-1,
		118,
		105,
		102,
		99,
		86,
		71,
		69,
		52,
		58,
		59,
		44,
		47,
		69,
		97,
		75,
		87,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		110,
		81,
		105,
		147,
		153,
		146,
		134,
		122,
		122,
		116,
		-1,
		110,
		89,
		80,
		69,
		59,
		75,
		65,
		68,
		48,
		50,
		66,
		78,
		69,
		89,
		-1,
		-1,
		-1,
		140,
		129,
		130,
		84,
		118,
		136,
		155,
		141,
		146,
		121,
		114,
		108,
		114,
		106,
		87,
		76,
		68,
		57,
		66,
		76,
		70,
		50,
		59,
		60,
		84,
		91,
		97,
		-1,
		-1,
		147,
		137,
		121,
		123,
		120,
		109,
		116,
		148,
		146,
		159,
		-1,
		113,
		-1,
		102,
		97,
		81,
		76,
		73,
		70,
		64,
		73,
		78,
		64,
		55,
		70,
		89,
		89,
		81,
		106,
		109,
		-1,
		-1,
		-1,
		140,
		157,
		132,
		109,
		90,
		126,
		-1,
		129,
		130,
		-1,
		107,
		101,
		98,
		83,
		79,
		74,
		78,
		71,
		78,
		74,
		73,
		74,
		56,
		92,
		-1,
		89,
		83,
		111,
		114,
		104,
		-1,
		-1,
		-1,
		155,
		134,
		127,
		147,
		97,
		149,
		-1,
		-1,
		114,
		107,
		-1,
		94,
		76,
		83,
		81,
		75,
		79,
		83,
		72,
		85,
		81,
		61,
		71,
		91,
		95,
		102,
		95,
		100,
		99,
		113,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		117,
		-1,
		123,
		115,
		105,
		99,
		93,
		89,
		87,
		103,
		87,
		90,
		90,
		86,
		94,
		79,
		78,
		64,
		68,
		86,
		113,
		108,
		103,
		102,
		109,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		132,
		-1,
		103,
		122,
		138,
		-1,
		131,
		110,
		125,
		103,
		99,
		95,
		110,
		111,
		89,
		94,
		93,
		103,
		100,
		89,
		76,
		80,
		95,
		105,
		97,
		98,
		107,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		93,
		125,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		109,
		107,
		100,
		91,
		97,
		104,
		107,
		104,
		94,
		83,
		89,
		85,
		107,
		93,
		91,
		110,
		125,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		108,
		92,
		97,
		-1,
		129,
		-1,
		102,
		102,
		93,
		82,
		79,
		90,
		88,
		99,
		116,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		162,
		-1,
		-1,
		132,
		126,
		126,
		110,
		113,
		124,
		104,
		98,
		97,
		124,
		119,
		110,
		91,
		84,
		81,
		82,
		95,
		115,
		106,
		118,
		-1,
		-1,
		-1,
		159,
		144,
		149,
		108,
		128,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		119,
		141,
		129,
		119,
		109,
		143,
		135,
		110,
		103,
		89,
		91,
		89,
		91,
		96,
		117,
		118,
		131,
		-1,
		-1,
		141,
		147,
		135,
		121,
		140,
		-1,
		-1,
		-1,
		141,
		157,
		149,
		120,
		130,
		-1,
		-1,
		121,
		119,
		127,
		106,
		93,
		113,
		116,
		106,
		90,
		105,
		117,
		125,
		130,
		-1,
		144,
		131,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		152,
		147,
		151,
		124,
		-1,
		123,
		117,
		97,
		111,
		118,
		108,
		103,
		97,
		100,
		118,
		135,
		-1,
		-1,
		157,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		131,
		145,
		140,
		133,
		137,
		-1,
		125,
		113,
		99,
		116,
		121,
		118,
		109,
		101,
		106,
		103,
		116,
		130,
		134,
		180,
		-1,
		163,
		-1,
		-1,
		-1,
		149,
		164,
		179,
		156,
		129,
		124,
		117,
		111,
		107,
		123,
		129,
		140,
		108,
		104,
		105,
		109,
		108,
		125,
		135,
		-1,
		-1,
		163,
		180,
		175,
		157,
		161,
		206,
		-1,
		-1,
		133,
		124,
		115,
		118,
		117,
		120,
		114,
		111,
		116,
		121,
		109,
		118,
		136,
		135,
		-1,
		-1,
		-1,
		183,
		-1,
		198,
		-1,
		-1,
		176,
		204,
		151,
		133,
		129,
		127,
		120,
		129,
		124,
		119,
		129,
		131,
		123,
		111,
		115,
		138,
		127,
		166,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		212,
		187,
		202,
		215,
		196,
		203,
		166,
		163,
		-1,
		133,
		158,
		130,
		137,
		128,
		135,
		135,
		127,
		105,
		112,
		128,
		127,
		122,
		158,
		149,
		155,
		-1,
		-1,
		294,
		283,
		272,
		278,
		-1,
		215,
		204,
		201,
		191,
		194,
		-1,
		-1,
		182,
		179,
		155,
		138,
		136,
		129,
		124,
		134,
		114,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		189,
		270,
		263,
		246,
		254,
		285,
		-1,
		205,
		197,
		208,
		183,
		185,
		-1,
		-1,
		155,
		152,
		157,
		145,
		142,
		144,
		139,
		130,
		115,
		121,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		203,
		246,
		240,
		243,
		267,
		281,
		-1,
		202,
		-1,
		-1,
		214,
		186,
		170,
		160,
		154,
		204,
		159,
		154,
		138,
		136,
		127,
		118,
		125,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		238,
		226,
		234,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		230,
		-1,
		197,
		-1,
		172,
		176,
		167,
		170,
		152,
		139,
		131,
		123,
		139,
		114,
		124,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		273,
		229,
		232,
		225,
		254,
		269,
		273,
		-1,
		214,
		253,
		251,
		-1,
		235,
		-1,
		-1,
		-1,
		186,
		180,
		172,
		172,
		151,
		151,
		125,
		129,
		119,
		126,
		136,
		138,
		130,
		134,
		147,
		158,
		161,
		269,
		260,
		273,
		218,
		218,
		239,
		248,
		269,
		229,
		220,
		247,
		258,
		247,
		242,
		229,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		158,
		146,
		129,
		130,
		126,
		129,
		144,
		147,
		137,
		135,
		129,
		161,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		209,
		236,
		-1,
		-1,
		231,
		248,
		242,
		246,
		262,
		287,
		-1,
		218,
		-1,
		-1,
		203,
		-1,
		-1,
		188,
		151,
		140,
		131,
		137,
		134,
		145,
		155,
		143,
		144,
		134,
		144,
		157,
		246,
		243,
		231,
		229,
		252,
		217,
		205,
		-1,
		218,
		216,
		222,
		229,
		246,
		276,
		-1,
		-1,
		234,
		214,
		-1,
		-1,
		186,
		184,
		173,
		-1,
		163,
		136,
		141,
		161,
		163,
		152,
		146,
		140,
		147,
		146,
		154,
		162,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		203,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		224,
		220,
		-1,
		-1,
		181,
		174,
		162,
		150,
		140,
		150,
		154,
		158,
		150,
		143,
		138,
		149,
		141,
		145,
		162,
		-1,
		289,
		-1,
		241,
		217,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		241,
		227,
		220,
		208,
		206,
		-1,
		215,
		199,
		180,
		-1,
		150,
		163,
		194,
		162,
		167,
		162,
		144,
		155,
		144,
		147,
		161,
		156,
		-1,
		-1,
		229,
		232,
		-1,
		-1,
		231,
		233,
		-1,
		232,
		221,
		206,
		198,
		-1,
		-1,
		187,
		183,
		-1,
		-1,
		151,
		176,
		165,
		173,
		168,
		148,
		154,
		157,
		146,
		150,
		162,
		-1,
		-1,
		236,
		237,
		238,
		-1,
		216,
		-1,
		234,
		-1,
		201,
		207,
		195,
		-1,
		-1,
		-1,
		189,
		152,
		173,
		183,
		177,
		175,
		166,
		152,
		159,
		157,
		153,
		164,
		-1,
		-1,
		-1,
		234,
		208,
		241,
		232,
		215,
		195,
		187,
		206,
		-1,
		176,
		-1,
		151,
		153,
		179,
		182,
		188,
		182,
		155,
		170,
		160,
		151,
		160,
		240,
		-1,
		210,
		243,
		207,
		201,
		177,
		181,
		197,
		-1,
		173,
		155,
		-1,
		183,
		173,
		204,
		189,
		170,
		157,
		164,
		164,
		157,
		-1,
		-1,
		-1,
		212,
		211,
		203,
		197,
		197,
		182,
		173,
		-1,
		185,
		167,
		146,
		163,
		163,
		154,
		162,
		194,
		190,
		177,
		177,
		169,
		-1,
		313,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		206,
		201,
		174,
		162,
		168,
		164,
		150,
		156,
		158,
		166,
		164,
		161,
		173,
		169,
		189,
		170,
		205,
		-1,
		308,
		-1,
		242,
		-1,
		-1,
		224,
		204,
		196,
		185,
		174,
		172,
		163,
		154,
		176,
		192,
		176,
		174,
		177,
		178,
		-1,
		297,
		296,
		-1,
		243,
		235,
		221,
		-1,
		214,
		-1,
		220,
		181,
		-1,
		183,
		163,
		-1,
		185,
		181,
		-1,
		-1,
		284,
		259,
		-1,
		-1,
		-1,
		244,
		224,
		215,
		199,
		-1,
		174,
		174,
		-1,
		-1,
		-1,
		269,
		268,
		-1,
		237,
		240,
		-1,
		230,
		221,
		229,
		176,
		180,
		-1,
		-1,
		-1,
		278,
		259,
		253,
		252,
		250,
		245,
		242,
		228,
		212,
		190,
		179,
		200,
		-1,
		-1,
		-1,
		250,
		242,
		235,
		-1,
		-1,
		237,
		220,
		201,
		199,
		-1,
		-1,
		-1,
		272,
		253,
		-1,
		-1,
		227,
		-1,
		-1,
		233,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		261,
		-1,
		-1,
		-1,
		223,
		219,
		220,
		-1,
		-1,
		-1,
		-1,
		283,
		284,
		307,
		271,
		-1,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		286,
		284,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		213,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		248,
		-1,
		248,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		261,
		-1,
		233,
		235,
		-1,
		283,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		238,
		245,
		267,
		270,
		306,
		-1,
		257
	],
	[
		-1,
		109,
		98,
		109,
		117,
		90,
		97,
		-1,
		116,
		120,
		86,
		80,
		119,
		88,
		94,
		105,
		-1,
		-1,
		-1,
		109,
		108,
		76,
		74,
		83,
		88,
		95,
		-1,
		90,
		-1,
		130,
		109,
		120,
		125,
		69,
		66,
		86,
		102,
		83,
		75,
		145,
		99,
		70,
		64,
		82,
		72,
		77,
		69,
		-1,
		70,
		60,
		82,
		61,
		71,
		60,
		-1,
		-1,
		64,
		65,
		71,
		57,
		58,
		49,
		-1,
		54,
		88,
		-1,
		-1,
		54,
		55,
		39,
		42,
		46,
		33,
		46,
		63,
		83,
		-1,
		-1,
		45,
		41,
		48,
		35,
		31,
		0,
		52,
		78,
		92,
		91,
		-1,
		57,
		74,
		74,
		42,
		34,
		24,
		28,
		46,
		77,
		83,
		86,
		-1,
		74,
		70,
		77,
		69,
		64,
		34,
		27,
		33,
		52,
		65,
		84,
		75,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		66,
		83,
		82,
		74,
		55,
		53,
		30,
		36,
		40,
		57,
		73,
		74,
		84,
		-1,
		-1,
		168,
		141,
		165,
		123,
		105,
		-1,
		71,
		73,
		79,
		78,
		72,
		72,
		55,
		46,
		-1,
		51,
		50,
		81,
		67,
		78,
		150,
		-1,
		-1,
		126,
		118,
		100,
		103,
		80,
		76,
		88,
		87,
		83,
		85,
		87,
		69,
		54,
		67,
		74,
		45,
		55,
		59,
		74,
		85,
		-1,
		-1,
		159,
		-1,
		-1,
		147,
		130,
		-1,
		95,
		102,
		86,
		92,
		78,
		99,
		98,
		92,
		99,
		100,
		90,
		67,
		64,
		81,
		67,
		42,
		67,
		71,
		77,
		95,
		96,
		-1,
		158,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		102,
		99,
		92,
		116,
		115,
		-1,
		121,
		119,
		125,
		110,
		113,
		109,
		96,
		72,
		67,
		67,
		64,
		49,
		51,
		88,
		79,
		100,
		97,
		128,
		134,
		128,
		137,
		-1,
		155,
		151,
		147,
		154,
		103,
		-1,
		-1,
		120,
		-1,
		123,
		136,
		133,
		121,
		124,
		111,
		119,
		113,
		96,
		78,
		65,
		62,
		61,
		57,
		66,
		76,
		75,
		93,
		106,
		121,
		125,
		131,
		-1,
		205,
		-1,
		147,
		131,
		133,
		109,
		137,
		-1,
		140,
		124,
		144,
		135,
		135,
		-1,
		127,
		124,
		131,
		109,
		94,
		77,
		65,
		60,
		60,
		64,
		79,
		70,
		88,
		95,
		103,
		107,
		127,
		139,
		165,
		155,
		-1,
		137,
		142,
		112,
		124,
		147,
		167,
		151,
		-1,
		146,
		-1,
		129,
		142,
		-1,
		115,
		111,
		85,
		73,
		62,
		69,
		67,
		61,
		58,
		76,
		79,
		96,
		100,
		116,
		-1,
		-1,
		150,
		154,
		162,
		113,
		132,
		156,
		193,
		160,
		153,
		152,
		-1,
		147,
		121,
		118,
		115,
		102,
		87,
		85,
		68,
		74,
		75,
		60,
		63,
		85,
		113,
		91,
		103,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		139,
		110,
		134,
		176,
		182,
		175,
		163,
		138,
		138,
		132,
		-1,
		126,
		105,
		96,
		85,
		75,
		91,
		81,
		84,
		64,
		66,
		82,
		94,
		85,
		105,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		113,
		147,
		165,
		171,
		157,
		162,
		137,
		130,
		124,
		130,
		122,
		103,
		92,
		84,
		73,
		82,
		92,
		86,
		66,
		75,
		76,
		100,
		107,
		113,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		138,
		145,
		177,
		162,
		175,
		-1,
		129,
		-1,
		118,
		113,
		97,
		92,
		89,
		86,
		80,
		89,
		94,
		80,
		71,
		86,
		105,
		105,
		97,
		122,
		125,
		-1,
		-1,
		-1,
		169,
		186,
		161,
		138,
		119,
		155,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		99,
		95,
		90,
		94,
		87,
		94,
		90,
		89,
		90,
		72,
		108,
		-1,
		105,
		99,
		127,
		130,
		120,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		126,
		178,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		99,
		97,
		91,
		95,
		99,
		88,
		101,
		97,
		77,
		87,
		107,
		111,
		118,
		111,
		116,
		115,
		129,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		146,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		119,
		103,
		106,
		106,
		102,
		110,
		95,
		94,
		80,
		84,
		102,
		129,
		124,
		119,
		118,
		125,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		111,
		126,
		127,
		105,
		110,
		109,
		119,
		116,
		105,
		92,
		96,
		111,
		121,
		113,
		114,
		123,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		125,
		123,
		116,
		107,
		113,
		120,
		123,
		120,
		110,
		99,
		105,
		101,
		123,
		109,
		107,
		126,
		141,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		124,
		108,
		113,
		-1,
		145,
		-1,
		118,
		118,
		109,
		98,
		95,
		106,
		104,
		115,
		132,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		140,
		120,
		114,
		113,
		140,
		135,
		126,
		107,
		100,
		97,
		98,
		111,
		131,
		122,
		134,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		157,
		145,
		135,
		125,
		159,
		151,
		126,
		119,
		105,
		107,
		105,
		107,
		112,
		133,
		134,
		147,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		165,
		136,
		146,
		-1,
		-1,
		137,
		135,
		143,
		122,
		109,
		129,
		132,
		122,
		106,
		121,
		133,
		141,
		146,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		168,
		163,
		167,
		140,
		-1,
		139,
		133,
		113,
		127,
		134,
		124,
		119,
		113,
		116,
		134,
		151,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		147,
		161,
		156,
		149,
		153,
		-1,
		141,
		129,
		115,
		132,
		137,
		134,
		125,
		117,
		122,
		119,
		132,
		146,
		150,
		196,
		-1,
		179,
		-1,
		-1,
		-1,
		165,
		180,
		195,
		172,
		145,
		140,
		133,
		127,
		123,
		139,
		145,
		156,
		124,
		120,
		121,
		125,
		124,
		141,
		151,
		-1,
		-1,
		179,
		196,
		191,
		173,
		177,
		222,
		-1,
		-1,
		149,
		140,
		131,
		134,
		133,
		136,
		130,
		127,
		132,
		137,
		125,
		134,
		152,
		151,
		-1,
		-1,
		-1,
		199,
		-1,
		214,
		-1,
		-1,
		192,
		220,
		167,
		149,
		145,
		143,
		136,
		145,
		140,
		135,
		145,
		147,
		139,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		318,
		-1,
		-1,
		-1,
		228,
		203,
		218,
		231,
		212,
		219,
		182,
		179,
		-1,
		149,
		174,
		146,
		153,
		144,
		151,
		151,
		143,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		311,
		300,
		289,
		295,
		-1,
		231,
		220,
		217,
		207,
		210,
		-1,
		-1,
		198,
		195,
		171,
		154,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		206,
		287,
		280,
		263,
		271,
		302,
		-1,
		221,
		213,
		224,
		199,
		201,
		-1,
		-1,
		171,
		168,
		173,
		161,
		158,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		220,
		263,
		257,
		260,
		284,
		298,
		-1,
		218,
		-1,
		-1,
		230,
		202,
		186,
		176,
		170,
		220,
		175,
		170,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		255,
		243,
		251,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		246,
		-1,
		213,
		-1,
		188,
		192,
		183,
		186,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		289,
		245,
		248,
		242,
		270,
		285,
		289,
		-1,
		230,
		269,
		267,
		-1,
		251,
		-1,
		-1,
		-1,
		202,
		196,
		188,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		285,
		276,
		289,
		234,
		234,
		255,
		264,
		285,
		245,
		236,
		263,
		274,
		263,
		258,
		245,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		225,
		252,
		-1,
		-1,
		247,
		264,
		258,
		262,
		278,
		303,
		-1,
		234,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		262,
		259,
		247,
		245,
		268,
		233,
		221,
		-1,
		234,
		232,
		238,
		245,
		262,
		292,
		-1,
		-1,
		250,
		230,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		219,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		236,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		305,
		-1,
		257,
		233,
		247,
		262,
		270,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		245,
		248,
		-1,
		-1,
		247,
		249,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		252,
		253,
		254,
		-1,
		232,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		329,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		126,
		115,
		126,
		134,
		107,
		114,
		-1,
		133,
		137,
		103,
		97,
		136,
		105,
		111,
		122,
		-1,
		-1,
		-1,
		126,
		125,
		93,
		91,
		100,
		105,
		112,
		-1,
		102,
		-1,
		147,
		126,
		137,
		142,
		86,
		83,
		103,
		114,
		95,
		87,
		162,
		116,
		87,
		81,
		99,
		89,
		89,
		81,
		-1,
		87,
		77,
		99,
		78,
		83,
		67,
		-1,
		-1,
		81,
		82,
		88,
		74,
		70,
		56,
		-1,
		14,
		47,
		-1,
		-1,
		71,
		72,
		56,
		59,
		58,
		33,
		6,
		23,
		42,
		-1,
		-1,
		62,
		58,
		65,
		52,
		48,
		50,
		0,
		39,
		51,
		49,
		-1,
		74,
		91,
		91,
		59,
		57,
		41,
		39,
		24,
		38,
		41,
		49,
		-1,
		91,
		87,
		94,
		86,
		81,
		57,
		44,
		44,
		63,
		36,
		52,
		61,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		83,
		100,
		102,
		97,
		78,
		76,
		47,
		47,
		51,
		57,
		51,
		64,
		88,
		-1,
		-1,
		185,
		158,
		182,
		140,
		122,
		-1,
		88,
		90,
		96,
		100,
		95,
		89,
		78,
		63,
		-1,
		67,
		61,
		61,
		71,
		82,
		167,
		-1,
		-1,
		143,
		135,
		117,
		120,
		97,
		93,
		105,
		104,
		100,
		102,
		104,
		86,
		71,
		84,
		91,
		61,
		71,
		75,
		78,
		89,
		-1,
		-1,
		175,
		-1,
		-1,
		164,
		147,
		-1,
		112,
		119,
		103,
		109,
		95,
		116,
		115,
		109,
		116,
		117,
		107,
		84,
		81,
		98,
		83,
		58,
		83,
		87,
		81,
		99,
		100,
		-1,
		174,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		119,
		116,
		109,
		133,
		132,
		-1,
		138,
		136,
		142,
		127,
		130,
		126,
		113,
		89,
		83,
		83,
		80,
		65,
		67,
		104,
		83,
		104,
		101,
		132,
		150,
		144,
		153,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		137,
		-1,
		140,
		153,
		150,
		138,
		141,
		128,
		136,
		129,
		113,
		95,
		81,
		78,
		77,
		73,
		82,
		88,
		91,
		107,
		110,
		137,
		141,
		147,
		-1,
		222,
		-1,
		164,
		148,
		150,
		126,
		154,
		-1,
		157,
		141,
		161,
		152,
		152,
		-1,
		144,
		141,
		147,
		125,
		110,
		93,
		81,
		76,
		76,
		80,
		95,
		86,
		104,
		111,
		119,
		123,
		143,
		155,
		182,
		172,
		-1,
		154,
		159,
		129,
		141,
		164,
		184,
		168,
		-1,
		163,
		-1,
		146,
		159,
		-1,
		131,
		127,
		101,
		89,
		78,
		85,
		83,
		77,
		74,
		92,
		95,
		112,
		116,
		132,
		-1,
		-1,
		167,
		171,
		179,
		130,
		149,
		173,
		210,
		177,
		170,
		169,
		-1,
		164,
		137,
		134,
		131,
		118,
		103,
		101,
		84,
		90,
		91,
		76,
		79,
		101,
		129,
		107,
		119,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		156,
		127,
		151,
		193,
		199,
		192,
		180,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		91,
		107,
		97,
		100,
		80,
		82,
		98,
		110,
		101,
		121,
		-1,
		-1,
		-1,
		186,
		175,
		176,
		130,
		164,
		182,
		187,
		173,
		178,
		153,
		146,
		140,
		146,
		138,
		119,
		108,
		100,
		89,
		98,
		108,
		102,
		82,
		91,
		92,
		116,
		123,
		129,
		-1,
		-1,
		193,
		183,
		167,
		169,
		166,
		155,
		162,
		194,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		110,
		96,
		87,
		102,
		121,
		121,
		113,
		138,
		141,
		-1,
		-1,
		-1,
		186,
		203,
		178,
		155,
		136,
		172,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		106,
		105,
		106,
		88,
		124,
		-1,
		121,
		115,
		143,
		146,
		136,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		115,
		104,
		117,
		113,
		93,
		103,
		123,
		127,
		134,
		127,
		132,
		131,
		145,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		122,
		118,
		126,
		111,
		110,
		96,
		100,
		118,
		145,
		140,
		135,
		134,
		141,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		121,
		126,
		125,
		135,
		132,
		121,
		108,
		112,
		127,
		137,
		129,
		130,
		139,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		123,
		129,
		136,
		139,
		136,
		126,
		115,
		121,
		117,
		139,
		125,
		123,
		142,
		157,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		140,
		124,
		129,
		-1,
		161,
		-1,
		134,
		134,
		125,
		114,
		111,
		122,
		120,
		131,
		148,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		156,
		136,
		130,
		129,
		156,
		151,
		142,
		123,
		116,
		113,
		114,
		127,
		147,
		138,
		150,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		173,
		161,
		151,
		141,
		175,
		167,
		142,
		135,
		121,
		123,
		121,
		123,
		128,
		149,
		150,
		163,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		181,
		152,
		162,
		-1,
		-1,
		153,
		151,
		159,
		138,
		125,
		145,
		148,
		138,
		122,
		137,
		149,
		157,
		162,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		184,
		179,
		183,
		156,
		-1,
		155,
		149,
		129,
		143,
		150,
		140,
		135,
		129,
		132,
		150,
		167,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		163,
		177,
		172,
		165,
		169,
		-1,
		157,
		145,
		131,
		148,
		153,
		150,
		141,
		133,
		138,
		135,
		148,
		162,
		166,
		212,
		-1,
		195,
		-1,
		-1,
		-1,
		181,
		196,
		211,
		188,
		161,
		156,
		149,
		143,
		139,
		155,
		161,
		172,
		140,
		136,
		137,
		141,
		140,
		157,
		167,
		-1,
		-1,
		195,
		212,
		207,
		189,
		193,
		238,
		-1,
		-1,
		165,
		156,
		147,
		150,
		149,
		152,
		146,
		143,
		148,
		153,
		141,
		150,
		168,
		167,
		-1,
		-1,
		-1,
		215,
		-1,
		230,
		-1,
		-1,
		208,
		236,
		183,
		165,
		161,
		159,
		152,
		161,
		156,
		151,
		161,
		163,
		155,
		143,
		147,
		170,
		159,
		198,
		-1,
		-1,
		334,
		-1,
		-1,
		-1,
		244,
		219,
		234,
		247,
		228,
		235,
		198,
		195,
		-1,
		165,
		190,
		162,
		169,
		160,
		167,
		167,
		159,
		137,
		144,
		160,
		159,
		154,
		190,
		181,
		187,
		-1,
		-1,
		327,
		316,
		305,
		311,
		-1,
		247,
		236,
		233,
		223,
		226,
		-1,
		-1,
		214,
		211,
		187,
		170,
		168,
		161,
		156,
		166,
		146,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		222,
		303,
		296,
		279,
		287,
		318,
		-1,
		237,
		229,
		240,
		215,
		217,
		-1,
		-1,
		187,
		184,
		189,
		177,
		174,
		176,
		171,
		162,
		147,
		153,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		236,
		279,
		273,
		276,
		300,
		314,
		-1,
		234,
		-1,
		-1,
		246,
		218,
		202,
		192,
		186,
		236,
		191,
		186,
		170,
		168,
		159,
		150,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		271,
		259,
		267,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		262,
		-1,
		229,
		-1,
		204,
		208,
		199,
		202,
		184,
		171,
		163,
		155,
		171,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		305,
		261,
		264,
		258,
		286,
		301,
		305,
		-1,
		246,
		285,
		283,
		-1,
		267,
		-1,
		-1,
		-1,
		218,
		212,
		204,
		204,
		183,
		183,
		157,
		161,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		301,
		292,
		305,
		250,
		250,
		271,
		280,
		301,
		261,
		252,
		279,
		290,
		279,
		274,
		261,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		190,
		178,
		161,
		162,
		158,
		161,
		176,
		179,
		169,
		167,
		161,
		193,
		-1,
		294,
		293,
		282,
		279,
		255,
		246,
		241,
		268,
		-1,
		-1,
		263,
		280,
		274,
		278,
		294,
		319,
		-1,
		250,
		-1,
		-1,
		235,
		-1,
		-1,
		220,
		183,
		172,
		163,
		169,
		166,
		177,
		187,
		175,
		176,
		166,
		176,
		189,
		278,
		275,
		263,
		261,
		284,
		249,
		237,
		-1,
		250,
		248,
		254,
		261,
		278,
		308,
		-1,
		-1,
		266,
		246,
		-1,
		-1,
		218,
		216,
		205,
		-1,
		195,
		168,
		173,
		193,
		195,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		287,
		301,
		290,
		286,
		285,
		293,
		242,
		235,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		-1,
		256,
		252,
		-1,
		-1,
		213,
		206,
		194,
		182,
		172,
		182,
		186,
		190,
		182,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		321,
		-1,
		273,
		249,
		263,
		278,
		286,
		-1,
		-1,
		-1,
		273,
		259,
		252,
		240,
		238,
		-1,
		247,
		231,
		212,
		-1,
		182,
		195,
		226,
		194,
		199,
		194,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		261,
		264,
		-1,
		-1,
		263,
		265,
		-1,
		264,
		253,
		238,
		230,
		-1,
		-1,
		219,
		215,
		-1,
		-1,
		183,
		208,
		197,
		205,
		200,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		268,
		269,
		270,
		-1,
		248,
		-1,
		266,
		-1,
		233,
		239,
		227,
		-1,
		-1,
		-1,
		221,
		184,
		205,
		215,
		209,
		207,
		198,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		266,
		240,
		273,
		264,
		247,
		227,
		219,
		238,
		-1,
		208,
		-1,
		183,
		185,
		211,
		214,
		220,
		214,
		187,
		202,
		192,
		183,
		192,
		272,
		-1,
		242,
		275,
		239,
		233,
		209,
		213,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		236,
		221,
		202,
		189,
		196,
		196,
		189,
		-1,
		-1,
		-1,
		244,
		243,
		235,
		229,
		229,
		214,
		205,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		226,
		222,
		209,
		209,
		201,
		-1,
		345,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		238,
		233,
		206,
		194,
		200,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		202,
		237,
		-1,
		340,
		-1,
		274,
		-1,
		-1,
		256,
		236,
		228,
		217,
		206,
		204,
		195,
		186,
		208,
		224,
		208,
		206,
		209,
		210,
		-1,
		329,
		328,
		-1,
		275,
		267,
		253,
		-1,
		246,
		-1,
		252,
		213,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		316,
		291,
		-1,
		-1,
		-1,
		276,
		256,
		247,
		231,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		301,
		300,
		-1,
		269,
		272,
		-1,
		262,
		253,
		261,
		208,
		212,
		-1,
		-1,
		-1,
		310,
		291,
		285,
		284,
		282,
		277,
		274,
		260,
		244,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		282,
		274,
		267,
		-1,
		-1,
		269,
		252,
		233,
		231,
		-1,
		-1,
		-1,
		304,
		285,
		-1,
		-1,
		259,
		-1,
		-1,
		265,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		321,
		293,
		-1,
		-1,
		-1,
		255,
		251,
		252,
		-1,
		-1,
		-1,
		-1,
		315,
		316,
		339,
		303,
		-1,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		318,
		316,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		245,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		280,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		293,
		285,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		308,
		299,
		-1,
		-1,
		270,
		277,
		299,
		302,
		338,
		-1,
		289
	],
	[
		-1,
		139,
		128,
		139,
		147,
		120,
		127,
		-1,
		146,
		150,
		116,
		110,
		149,
		118,
		124,
		135,
		-1,
		-1,
		-1,
		139,
		138,
		106,
		104,
		113,
		118,
		125,
		-1,
		112,
		-1,
		160,
		139,
		150,
		155,
		99,
		96,
		116,
		124,
		105,
		97,
		175,
		129,
		100,
		94,
		112,
		102,
		99,
		91,
		-1,
		100,
		90,
		112,
		91,
		97,
		73,
		-1,
		-1,
		94,
		95,
		101,
		87,
		93,
		81,
		-1,
		33,
		11,
		-1,
		-1,
		84,
		85,
		69,
		72,
		80,
		58,
		29,
		15,
		6,
		-1,
		-1,
		75,
		71,
		78,
		65,
		61,
		75,
		38,
		0,
		15,
		17,
		-1,
		87,
		104,
		104,
		72,
		70,
		54,
		52,
		54,
		5,
		14,
		22,
		-1,
		104,
		100,
		101,
		99,
		94,
		70,
		57,
		57,
		67,
		15,
		25,
		34,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		105,
		96,
		113,
		97,
		87,
		91,
		89,
		60,
		57,
		55,
		36,
		29,
		37,
		61,
		-1,
		-1,
		198,
		171,
		195,
		153,
		135,
		-1,
		101,
		101,
		95,
		91,
		85,
		78,
		91,
		76,
		-1,
		46,
		40,
		39,
		44,
		55,
		180,
		-1,
		-1,
		156,
		148,
		130,
		133,
		110,
		106,
		116,
		115,
		108,
		101,
		97,
		75,
		78,
		78,
		84,
		40,
		50,
		51,
		51,
		62,
		-1,
		-1,
		154,
		-1,
		-1,
		177,
		160,
		-1,
		125,
		132,
		116,
		122,
		108,
		129,
		126,
		117,
		111,
		106,
		98,
		73,
		70,
		83,
		62,
		37,
		61,
		64,
		54,
		72,
		73,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		132,
		129,
		122,
		146,
		145,
		-1,
		146,
		134,
		135,
		120,
		119,
		113,
		101,
		78,
		62,
		62,
		59,
		44,
		46,
		83,
		56,
		77,
		74,
		105,
		129,
		123,
		132,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		150,
		-1,
		153,
		166,
		158,
		131,
		134,
		121,
		121,
		108,
		97,
		79,
		60,
		57,
		56,
		52,
		61,
		61,
		64,
		80,
		83,
		116,
		120,
		126,
		-1,
		235,
		-1,
		177,
		161,
		163,
		139,
		167,
		-1,
		170,
		154,
		174,
		160,
		160,
		-1,
		137,
		134,
		126,
		104,
		89,
		72,
		60,
		55,
		55,
		59,
		74,
		65,
		83,
		88,
		95,
		102,
		122,
		134,
		195,
		185,
		-1,
		167,
		172,
		142,
		154,
		174,
		197,
		176,
		-1,
		171,
		-1,
		139,
		152,
		-1,
		110,
		106,
		80,
		68,
		57,
		64,
		62,
		56,
		53,
		71,
		74,
		91,
		95,
		111,
		-1,
		-1,
		180,
		184,
		189,
		140,
		159,
		183,
		220,
		169,
		158,
		157,
		-1,
		148,
		116,
		113,
		110,
		97,
		82,
		80,
		63,
		69,
		70,
		55,
		58,
		80,
		108,
		86,
		98,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		166,
		137,
		161,
		203,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		121,
		100,
		91,
		80,
		70,
		86,
		76,
		79,
		59,
		61,
		77,
		89,
		80,
		100,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		166,
		152,
		157,
		132,
		125,
		119,
		125,
		117,
		98,
		87,
		79,
		68,
		77,
		87,
		81,
		61,
		70,
		71,
		95,
		102,
		108,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		81,
		75,
		84,
		89,
		75,
		66,
		81,
		100,
		100,
		92,
		117,
		120,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		85,
		89,
		82,
		89,
		85,
		84,
		85,
		67,
		103,
		-1,
		100,
		94,
		122,
		125,
		115,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		94,
		92,
		86,
		90,
		94,
		83,
		96,
		92,
		72,
		82,
		102,
		106,
		113,
		106,
		111,
		110,
		124,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		101,
		101,
		97,
		105,
		90,
		89,
		75,
		79,
		97,
		124,
		119,
		114,
		113,
		120,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		106,
		121,
		122,
		100,
		105,
		104,
		114,
		111,
		100,
		87,
		91,
		106,
		116,
		108,
		109,
		118,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		120,
		118,
		111,
		102,
		108,
		115,
		118,
		115,
		105,
		94,
		100,
		96,
		118,
		104,
		102,
		121,
		136,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		140,
		-1,
		113,
		113,
		104,
		93,
		90,
		101,
		99,
		110,
		127,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		135,
		130,
		121,
		102,
		95,
		92,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		152,
		140,
		130,
		120,
		154,
		146,
		121,
		114,
		100,
		102,
		100,
		102,
		107,
		128,
		129,
		142,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		141,
		-1,
		-1,
		132,
		130,
		138,
		117,
		104,
		124,
		127,
		117,
		101,
		116,
		128,
		136,
		141,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		158,
		162,
		135,
		-1,
		134,
		128,
		108,
		122,
		129,
		119,
		114,
		108,
		111,
		129,
		146,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		151,
		144,
		148,
		-1,
		136,
		124,
		110,
		127,
		132,
		129,
		120,
		112,
		117,
		114,
		127,
		141,
		145,
		191,
		-1,
		174,
		-1,
		-1,
		-1,
		160,
		175,
		190,
		167,
		140,
		135,
		128,
		122,
		118,
		134,
		140,
		151,
		119,
		115,
		116,
		120,
		119,
		136,
		146,
		-1,
		-1,
		174,
		191,
		186,
		168,
		172,
		217,
		-1,
		-1,
		144,
		135,
		126,
		129,
		128,
		131,
		125,
		122,
		127,
		132,
		120,
		129,
		147,
		146,
		-1,
		-1,
		-1,
		194,
		-1,
		209,
		-1,
		-1,
		187,
		215,
		162,
		144,
		140,
		138,
		131,
		140,
		135,
		130,
		140,
		142,
		134,
		122,
		126,
		149,
		138,
		177,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		223,
		198,
		213,
		226,
		207,
		214,
		177,
		174,
		-1,
		144,
		169,
		141,
		148,
		139,
		146,
		146,
		138,
		116,
		123,
		139,
		138,
		133,
		169,
		160,
		166,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		226,
		215,
		212,
		202,
		205,
		-1,
		-1,
		193,
		190,
		166,
		149,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		201,
		282,
		275,
		258,
		266,
		297,
		-1,
		216,
		208,
		219,
		194,
		196,
		-1,
		-1,
		166,
		163,
		168,
		156,
		153,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		215,
		258,
		252,
		255,
		279,
		293,
		-1,
		213,
		-1,
		-1,
		225,
		197,
		181,
		171,
		165,
		215,
		170,
		165,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		250,
		238,
		246,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		241,
		-1,
		208,
		-1,
		183,
		187,
		178,
		181,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		284,
		240,
		243,
		237,
		265,
		280,
		284,
		-1,
		225,
		264,
		262,
		-1,
		246,
		-1,
		-1,
		-1,
		197,
		191,
		183,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		280,
		271,
		284,
		229,
		229,
		250,
		259,
		280,
		240,
		231,
		258,
		269,
		258,
		253,
		240,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		220,
		247,
		-1,
		-1,
		242,
		259,
		253,
		257,
		273,
		298,
		-1,
		229,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		257,
		254,
		242,
		240,
		263,
		228,
		216,
		-1,
		229,
		227,
		233,
		240,
		257,
		287,
		-1,
		-1,
		245,
		225,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		214,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		231,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		300,
		-1,
		252,
		228,
		242,
		257,
		265,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		240,
		243,
		-1,
		-1,
		242,
		244,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		247,
		248,
		249,
		-1,
		227,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		212,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		324,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		154,
		143,
		154,
		162,
		135,
		142,
		-1,
		161,
		165,
		131,
		125,
		164,
		133,
		139,
		150,
		-1,
		-1,
		-1,
		154,
		153,
		121,
		119,
		128,
		133,
		140,
		-1,
		119,
		-1,
		175,
		154,
		165,
		170,
		114,
		111,
		131,
		131,
		112,
		104,
		190,
		144,
		115,
		109,
		127,
		117,
		106,
		98,
		-1,
		115,
		105,
		127,
		106,
		104,
		80,
		-1,
		-1,
		109,
		110,
		116,
		102,
		104,
		92,
		-1,
		47,
		18,
		-1,
		-1,
		99,
		100,
		84,
		87,
		90,
		72,
		43,
		29,
		13,
		-1,
		-1,
		90,
		86,
		93,
		80,
		76,
		89,
		52,
		17,
		0,
		2,
		-1,
		102,
		119,
		119,
		87,
		85,
		69,
		67,
		67,
		22,
		11,
		11,
		-1,
		119,
		115,
		116,
		114,
		109,
		85,
		72,
		72,
		78,
		30,
		14,
		23,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		120,
		111,
		128,
		112,
		102,
		106,
		104,
		75,
		68,
		66,
		51,
		24,
		26,
		50,
		-1,
		-1,
		213,
		186,
		210,
		168,
		150,
		-1,
		116,
		116,
		110,
		106,
		100,
		93,
		106,
		91,
		-1,
		45,
		52,
		34,
		33,
		44,
		195,
		-1,
		-1,
		171,
		163,
		145,
		148,
		125,
		121,
		131,
		130,
		123,
		116,
		112,
		90,
		93,
		93,
		99,
		55,
		43,
		40,
		40,
		51,
		-1,
		-1,
		157,
		-1,
		-1,
		192,
		175,
		-1,
		140,
		147,
		131,
		137,
		123,
		144,
		141,
		132,
		126,
		121,
		113,
		88,
		85,
		98,
		77,
		52,
		50,
		53,
		43,
		61,
		62,
		-1,
		156,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		147,
		144,
		137,
		161,
		160,
		-1,
		161,
		149,
		150,
		135,
		134,
		128,
		116,
		93,
		77,
		77,
		74,
		59,
		61,
		77,
		45,
		66,
		63,
		94,
		132,
		126,
		135,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		165,
		-1,
		168,
		181,
		173,
		146,
		149,
		136,
		136,
		123,
		112,
		94,
		75,
		72,
		71,
		67,
		76,
		50,
		53,
		69,
		72,
		119,
		123,
		129,
		-1,
		250,
		-1,
		192,
		176,
		178,
		154,
		182,
		-1,
		185,
		169,
		189,
		175,
		175,
		-1,
		152,
		149,
		141,
		119,
		104,
		87,
		75,
		70,
		70,
		74,
		82,
		57,
		75,
		77,
		84,
		105,
		127,
		137,
		210,
		200,
		-1,
		182,
		187,
		157,
		169,
		189,
		212,
		191,
		-1,
		186,
		-1,
		154,
		167,
		-1,
		125,
		121,
		95,
		83,
		72,
		79,
		77,
		71,
		68,
		63,
		66,
		95,
		95,
		121,
		-1,
		-1,
		195,
		199,
		204,
		155,
		174,
		198,
		235,
		184,
		173,
		172,
		-1,
		163,
		131,
		128,
		125,
		112,
		97,
		95,
		78,
		84,
		85,
		70,
		73,
		72,
		114,
		100,
		112,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		181,
		152,
		176,
		218,
		202,
		195,
		183,
		148,
		148,
		142,
		-1,
		136,
		115,
		106,
		95,
		85,
		101,
		91,
		94,
		74,
		76,
		78,
		103,
		94,
		114,
		-1,
		-1,
		-1,
		211,
		200,
		201,
		147,
		170,
		207,
		181,
		167,
		172,
		147,
		140,
		134,
		140,
		132,
		113,
		102,
		94,
		83,
		92,
		102,
		96,
		76,
		85,
		85,
		109,
		116,
		122,
		-1,
		-1,
		218,
		208,
		192,
		194,
		191,
		161,
		168,
		200,
		172,
		185,
		-1,
		139,
		-1,
		128,
		123,
		107,
		102,
		99,
		96,
		90,
		99,
		104,
		90,
		81,
		96,
		114,
		114,
		106,
		131,
		134,
		-1,
		-1,
		-1,
		211,
		206,
		181,
		158,
		142,
		178,
		-1,
		155,
		156,
		-1,
		133,
		127,
		124,
		109,
		105,
		100,
		104,
		97,
		104,
		100,
		99,
		100,
		82,
		118,
		-1,
		114,
		108,
		136,
		139,
		129,
		-1,
		-1,
		-1,
		204,
		183,
		176,
		196,
		137,
		189,
		-1,
		-1,
		140,
		133,
		-1,
		120,
		102,
		109,
		107,
		101,
		105,
		109,
		98,
		111,
		107,
		87,
		97,
		117,
		121,
		127,
		120,
		125,
		124,
		138,
		-1,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		157,
		-1,
		149,
		141,
		131,
		125,
		119,
		115,
		113,
		129,
		113,
		116,
		116,
		112,
		120,
		105,
		104,
		90,
		94,
		112,
		138,
		133,
		129,
		128,
		134,
		-1,
		224,
		210,
		181,
		-1,
		-1,
		170,
		-1,
		134,
		148,
		164,
		-1,
		157,
		136,
		151,
		129,
		125,
		121,
		136,
		137,
		115,
		120,
		119,
		129,
		126,
		115,
		102,
		106,
		121,
		131,
		123,
		124,
		133,
		-1,
		230,
		217,
		175,
		171,
		160,
		180,
		131,
		119,
		151,
		-1,
		-1,
		193,
		-1,
		127,
		144,
		135,
		133,
		126,
		117,
		123,
		130,
		133,
		130,
		120,
		109,
		115,
		111,
		133,
		119,
		117,
		135,
		150,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		146,
		133,
		127,
		-1,
		168,
		-1,
		171,
		161,
		145,
		130,
		163,
		-1,
		134,
		118,
		123,
		-1,
		155,
		-1,
		128,
		128,
		119,
		108,
		105,
		116,
		114,
		125,
		141,
		-1,
		180,
		165,
		158,
		148,
		162,
		133,
		-1,
		188,
		-1,
		-1,
		158,
		152,
		152,
		136,
		139,
		150,
		130,
		124,
		123,
		150,
		145,
		136,
		117,
		110,
		107,
		108,
		121,
		141,
		132,
		143,
		-1,
		-1,
		-1,
		185,
		171,
		175,
		135,
		154,
		-1,
		-1,
		220,
		175,
		161,
		-1,
		145,
		167,
		155,
		145,
		135,
		169,
		161,
		136,
		129,
		115,
		117,
		115,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		168,
		173,
		161,
		147,
		166,
		-1,
		-1,
		-1,
		167,
		183,
		175,
		146,
		156,
		-1,
		-1,
		147,
		145,
		153,
		132,
		119,
		139,
		142,
		132,
		116,
		131,
		143,
		150,
		156,
		-1,
		171,
		158,
		-1,
		-1,
		169,
		163,
		-1,
		-1,
		-1,
		-1,
		200,
		166,
		178,
		173,
		177,
		150,
		-1,
		149,
		143,
		123,
		137,
		144,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		183,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		157,
		171,
		166,
		159,
		163,
		-1,
		151,
		139,
		125,
		142,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		206,
		-1,
		189,
		-1,
		-1,
		-1,
		175,
		190,
		205,
		182,
		155,
		150,
		143,
		137,
		133,
		149,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		189,
		206,
		201,
		183,
		187,
		232,
		-1,
		-1,
		159,
		150,
		141,
		144,
		143,
		146,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		161,
		-1,
		-1,
		-1,
		209,
		-1,
		224,
		-1,
		-1,
		202,
		230,
		177,
		159,
		155,
		153,
		146,
		155,
		150,
		145,
		155,
		157,
		149,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		328,
		-1,
		-1,
		-1,
		238,
		213,
		228,
		241,
		222,
		229,
		192,
		189,
		-1,
		159,
		184,
		156,
		163,
		154,
		161,
		161,
		153,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		321,
		310,
		299,
		305,
		-1,
		241,
		230,
		227,
		217,
		220,
		-1,
		-1,
		208,
		205,
		181,
		164,
		162,
		155,
		150,
		160,
		140,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		216,
		297,
		290,
		273,
		281,
		312,
		-1,
		231,
		223,
		234,
		209,
		211,
		-1,
		-1,
		181,
		178,
		183,
		171,
		168,
		170,
		165,
		156,
		141,
		147,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		230,
		273,
		267,
		270,
		294,
		308,
		-1,
		228,
		-1,
		-1,
		240,
		212,
		196,
		186,
		180,
		230,
		185,
		180,
		164,
		162,
		153,
		144,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		265,
		253,
		261,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		256,
		-1,
		223,
		-1,
		198,
		202,
		193,
		196,
		178,
		165,
		157,
		149,
		165,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		299,
		255,
		258,
		252,
		280,
		295,
		299,
		-1,
		240,
		279,
		277,
		-1,
		261,
		-1,
		-1,
		-1,
		212,
		206,
		198,
		198,
		177,
		177,
		151,
		155,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		295,
		286,
		299,
		244,
		244,
		265,
		274,
		295,
		255,
		246,
		273,
		284,
		273,
		268,
		255,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		184,
		172,
		155,
		156,
		152,
		155,
		170,
		173,
		163,
		161,
		155,
		187,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		235,
		262,
		-1,
		-1,
		257,
		274,
		268,
		272,
		288,
		313,
		-1,
		244,
		-1,
		-1,
		229,
		-1,
		-1,
		214,
		177,
		166,
		157,
		163,
		160,
		171,
		181,
		169,
		170,
		160,
		170,
		183,
		272,
		269,
		257,
		255,
		278,
		243,
		231,
		-1,
		244,
		242,
		248,
		255,
		272,
		302,
		-1,
		-1,
		260,
		240,
		-1,
		-1,
		212,
		210,
		199,
		-1,
		189,
		162,
		167,
		187,
		189,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		229,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		250,
		246,
		-1,
		-1,
		207,
		200,
		188,
		176,
		166,
		176,
		180,
		184,
		176,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		315,
		-1,
		267,
		243,
		257,
		272,
		280,
		-1,
		-1,
		-1,
		267,
		253,
		246,
		234,
		232,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		220,
		188,
		193,
		188,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		255,
		258,
		-1,
		-1,
		257,
		259,
		-1,
		258,
		247,
		232,
		224,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		177,
		202,
		191,
		199,
		194,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		262,
		263,
		264,
		-1,
		242,
		-1,
		260,
		-1,
		227,
		233,
		221,
		-1,
		-1,
		-1,
		215,
		178,
		199,
		209,
		203,
		201,
		192,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		260,
		234,
		267,
		258,
		241,
		221,
		213,
		232,
		-1,
		202,
		-1,
		177,
		179,
		205,
		208,
		214,
		208,
		181,
		196,
		186,
		177,
		186,
		266,
		-1,
		236,
		269,
		233,
		227,
		203,
		207,
		223,
		-1,
		199,
		181,
		-1,
		209,
		199,
		230,
		215,
		196,
		183,
		190,
		190,
		183,
		-1,
		-1,
		-1,
		238,
		237,
		229,
		223,
		223,
		208,
		199,
		-1,
		211,
		193,
		172,
		189,
		189,
		180,
		188,
		220,
		216,
		203,
		203,
		195,
		-1,
		339,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		232,
		227,
		200,
		188,
		194,
		190,
		176,
		182,
		184,
		192,
		190,
		187,
		199,
		195,
		215,
		196,
		231,
		-1,
		334,
		-1,
		268,
		-1,
		-1,
		250,
		230,
		222,
		211,
		200,
		198,
		189,
		180,
		202,
		218,
		202,
		200,
		203,
		204,
		-1,
		323,
		322,
		-1,
		269,
		261,
		247,
		-1,
		240,
		-1,
		246,
		207,
		-1,
		209,
		189,
		-1,
		211,
		207,
		-1,
		-1,
		310,
		285,
		-1,
		-1,
		-1,
		270,
		250,
		241,
		225,
		-1,
		200,
		200,
		-1,
		-1,
		-1,
		295,
		294,
		-1,
		263,
		266,
		-1,
		256,
		247,
		255,
		202,
		206,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		278,
		276,
		271,
		268,
		254,
		238,
		216,
		205,
		226,
		-1,
		-1,
		-1,
		276,
		268,
		261,
		-1,
		-1,
		263,
		246,
		227,
		225,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		253,
		-1,
		-1,
		259,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		287,
		-1,
		-1,
		-1,
		249,
		245,
		246,
		-1,
		-1,
		-1,
		-1,
		309,
		310,
		333,
		297,
		-1,
		-1,
		-1,
		241,
		235,
		-1,
		-1,
		312,
		310,
		-1,
		-1,
		-1,
		269,
		253,
		-1,
		239,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		274,
		-1,
		274,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		287,
		279,
		287,
		-1,
		259,
		261,
		-1,
		309,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		264,
		271,
		293,
		296,
		332,
		-1,
		283
	],
	[
		-1,
		152,
		141,
		152,
		160,
		133,
		140,
		-1,
		159,
		163,
		129,
		123,
		162,
		131,
		137,
		148,
		-1,
		-1,
		-1,
		152,
		151,
		119,
		117,
		126,
		131,
		138,
		-1,
		121,
		-1,
		173,
		152,
		163,
		168,
		112,
		109,
		129,
		133,
		114,
		106,
		188,
		142,
		113,
		107,
		125,
		115,
		108,
		100,
		-1,
		113,
		103,
		125,
		104,
		106,
		82,
		-1,
		-1,
		107,
		108,
		114,
		100,
		106,
		94,
		-1,
		49,
		20,
		-1,
		-1,
		97,
		98,
		82,
		85,
		92,
		74,
		45,
		31,
		15,
		-1,
		-1,
		88,
		84,
		91,
		78,
		74,
		91,
		54,
		19,
		2,
		0,
		-1,
		100,
		117,
		117,
		85,
		83,
		67,
		65,
		65,
		24,
		9,
		9,
		-1,
		117,
		113,
		114,
		112,
		107,
		83,
		70,
		70,
		76,
		28,
		12,
		21,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		109,
		126,
		110,
		100,
		104,
		102,
		73,
		66,
		64,
		49,
		22,
		24,
		48,
		-1,
		-1,
		211,
		184,
		208,
		166,
		148,
		-1,
		114,
		114,
		108,
		104,
		98,
		91,
		104,
		89,
		-1,
		43,
		50,
		32,
		31,
		42,
		193,
		-1,
		-1,
		169,
		161,
		143,
		146,
		123,
		119,
		129,
		128,
		121,
		114,
		110,
		88,
		91,
		91,
		97,
		53,
		41,
		38,
		38,
		49,
		-1,
		-1,
		155,
		-1,
		-1,
		190,
		173,
		-1,
		138,
		145,
		129,
		135,
		121,
		142,
		139,
		130,
		124,
		119,
		111,
		86,
		83,
		96,
		75,
		50,
		48,
		51,
		41,
		59,
		60,
		-1,
		154,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		145,
		142,
		135,
		159,
		158,
		-1,
		159,
		147,
		148,
		133,
		132,
		126,
		114,
		91,
		75,
		75,
		72,
		57,
		59,
		75,
		43,
		64,
		61,
		92,
		130,
		124,
		133,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		163,
		-1,
		166,
		179,
		171,
		144,
		147,
		134,
		134,
		121,
		110,
		92,
		73,
		70,
		69,
		65,
		74,
		48,
		51,
		67,
		70,
		117,
		121,
		127,
		-1,
		248,
		-1,
		190,
		174,
		176,
		152,
		180,
		-1,
		183,
		167,
		187,
		173,
		173,
		-1,
		150,
		147,
		139,
		117,
		102,
		85,
		73,
		68,
		68,
		72,
		80,
		55,
		73,
		75,
		82,
		103,
		125,
		135,
		208,
		198,
		-1,
		180,
		185,
		155,
		167,
		187,
		210,
		189,
		-1,
		184,
		-1,
		152,
		165,
		-1,
		123,
		119,
		93,
		81,
		70,
		77,
		75,
		69,
		66,
		61,
		64,
		93,
		93,
		119,
		-1,
		-1,
		193,
		197,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		129,
		126,
		123,
		110,
		95,
		93,
		76,
		82,
		83,
		68,
		71,
		70,
		112,
		98,
		110,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		83,
		99,
		89,
		92,
		72,
		74,
		76,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		138,
		130,
		111,
		100,
		92,
		81,
		90,
		100,
		94,
		74,
		83,
		83,
		107,
		114,
		120,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		88,
		97,
		102,
		88,
		79,
		94,
		112,
		112,
		104,
		129,
		132,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		102,
		98,
		97,
		98,
		80,
		116,
		-1,
		112,
		106,
		134,
		137,
		127,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		107,
		96,
		109,
		105,
		85,
		95,
		115,
		119,
		125,
		118,
		123,
		122,
		136,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		114,
		110,
		118,
		103,
		102,
		88,
		92,
		110,
		136,
		131,
		127,
		126,
		132,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		118,
		117,
		127,
		124,
		113,
		100,
		104,
		119,
		129,
		121,
		122,
		131,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		115,
		121,
		128,
		131,
		128,
		118,
		107,
		113,
		109,
		131,
		117,
		115,
		133,
		148,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		132,
		116,
		121,
		-1,
		153,
		-1,
		126,
		126,
		117,
		106,
		103,
		114,
		112,
		123,
		139,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		148,
		128,
		122,
		121,
		148,
		143,
		134,
		115,
		108,
		105,
		106,
		119,
		139,
		130,
		141,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		165,
		153,
		143,
		133,
		167,
		159,
		134,
		127,
		113,
		115,
		113,
		115,
		120,
		141,
		142,
		155,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		154,
		-1,
		-1,
		145,
		143,
		151,
		130,
		117,
		137,
		140,
		130,
		114,
		129,
		141,
		148,
		154,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		176,
		171,
		175,
		148,
		-1,
		147,
		141,
		121,
		135,
		142,
		132,
		127,
		121,
		124,
		142,
		159,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		155,
		169,
		164,
		157,
		161,
		-1,
		149,
		137,
		123,
		140,
		145,
		142,
		133,
		125,
		130,
		127,
		140,
		154,
		158,
		204,
		-1,
		187,
		-1,
		-1,
		-1,
		173,
		188,
		203,
		180,
		153,
		148,
		141,
		135,
		131,
		147,
		153,
		164,
		132,
		128,
		129,
		133,
		132,
		149,
		159,
		-1,
		-1,
		187,
		204,
		199,
		181,
		185,
		230,
		-1,
		-1,
		157,
		148,
		139,
		142,
		141,
		144,
		138,
		135,
		140,
		145,
		133,
		142,
		160,
		159,
		-1,
		-1,
		-1,
		207,
		-1,
		222,
		-1,
		-1,
		200,
		228,
		175,
		157,
		153,
		151,
		144,
		153,
		148,
		143,
		153,
		155,
		147,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		236,
		211,
		226,
		239,
		220,
		227,
		190,
		187,
		-1,
		157,
		182,
		154,
		161,
		152,
		159,
		159,
		151,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		319,
		308,
		297,
		303,
		-1,
		239,
		228,
		225,
		215,
		218,
		-1,
		-1,
		206,
		203,
		179,
		162,
		160,
		153,
		148,
		158,
		138,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		214,
		295,
		288,
		271,
		279,
		310,
		-1,
		229,
		221,
		232,
		207,
		209,
		-1,
		-1,
		179,
		176,
		181,
		169,
		166,
		168,
		163,
		154,
		139,
		145,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		228,
		271,
		265,
		268,
		292,
		306,
		-1,
		226,
		-1,
		-1,
		238,
		210,
		194,
		184,
		178,
		228,
		183,
		178,
		162,
		160,
		151,
		142,
		149,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		263,
		251,
		259,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		254,
		-1,
		221,
		-1,
		196,
		200,
		191,
		194,
		176,
		163,
		155,
		147,
		163,
		138,
		148,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		297,
		253,
		256,
		250,
		278,
		293,
		297,
		-1,
		238,
		277,
		275,
		-1,
		259,
		-1,
		-1,
		-1,
		210,
		204,
		196,
		196,
		175,
		175,
		149,
		153,
		143,
		150,
		160,
		162,
		154,
		158,
		171,
		182,
		185,
		293,
		284,
		297,
		242,
		242,
		263,
		272,
		293,
		253,
		244,
		271,
		282,
		271,
		266,
		253,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		182,
		170,
		153,
		154,
		150,
		153,
		168,
		171,
		161,
		159,
		153,
		185,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		260,
		-1,
		-1,
		255,
		272,
		266,
		270,
		286,
		311,
		-1,
		242,
		-1,
		-1,
		227,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		158,
		169,
		179,
		167,
		168,
		158,
		168,
		181,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		242,
		240,
		246,
		253,
		270,
		300,
		-1,
		-1,
		258,
		238,
		-1,
		-1,
		210,
		208,
		197,
		-1,
		187,
		160,
		165,
		185,
		187,
		176,
		170,
		164,
		171,
		170,
		178,
		186,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		244,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		178,
		182,
		174,
		167,
		162,
		173,
		165,
		169,
		186,
		-1,
		313,
		-1,
		265,
		241,
		255,
		270,
		278,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		168,
		179,
		168,
		171,
		185,
		180,
		-1,
		-1,
		253,
		256,
		-1,
		-1,
		255,
		257,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		172,
		178,
		181,
		170,
		174,
		186,
		-1,
		-1,
		260,
		261,
		262,
		-1,
		240,
		-1,
		258,
		-1,
		225,
		231,
		219,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		201,
		199,
		190,
		176,
		183,
		181,
		177,
		188,
		-1,
		-1,
		-1,
		258,
		232,
		265,
		256,
		239,
		219,
		211,
		230,
		-1,
		200,
		-1,
		175,
		177,
		203,
		206,
		212,
		206,
		179,
		194,
		184,
		175,
		184,
		264,
		-1,
		234,
		267,
		231,
		225,
		201,
		205,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		228,
		213,
		194,
		181,
		188,
		188,
		181,
		-1,
		-1,
		-1,
		236,
		235,
		227,
		221,
		221,
		206,
		197,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		218,
		214,
		201,
		201,
		193,
		-1,
		337,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		230,
		225,
		198,
		186,
		192,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		194,
		229,
		-1,
		332,
		-1,
		266,
		-1,
		-1,
		248,
		228,
		220,
		209,
		198,
		196,
		187,
		178,
		200,
		216,
		200,
		198,
		201,
		202,
		-1,
		321,
		320,
		-1,
		267,
		259,
		245,
		-1,
		238,
		-1,
		244,
		205,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		308,
		283,
		-1,
		-1,
		-1,
		268,
		248,
		239,
		223,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		293,
		292,
		-1,
		261,
		264,
		-1,
		254,
		245,
		253,
		200,
		204,
		-1,
		-1,
		-1,
		302,
		283,
		277,
		276,
		274,
		269,
		266,
		252,
		236,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		274,
		266,
		259,
		-1,
		-1,
		261,
		244,
		225,
		223,
		-1,
		-1,
		-1,
		296,
		277,
		-1,
		-1,
		251,
		-1,
		-1,
		257,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		285,
		-1,
		-1,
		-1,
		247,
		243,
		244,
		-1,
		-1,
		-1,
		-1,
		307,
		308,
		331,
		295,
		-1,
		-1,
		-1,
		239,
		233,
		-1,
		-1,
		310,
		308,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		237,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		272,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		262,
		269,
		291,
		294,
		330,
		-1,
		281
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		64,
		53,
		64,
		72,
		45,
		52,
		-1,
		73,
		75,
		41,
		35,
		74,
		45,
		51,
		62,
		-1,
		-1,
		-1,
		64,
		63,
		33,
		31,
		40,
		45,
		52,
		-1,
		75,
		-1,
		85,
		64,
		75,
		80,
		26,
		23,
		43,
		62,
		68,
		60,
		100,
		56,
		27,
		21,
		39,
		44,
		62,
		54,
		-1,
		27,
		17,
		39,
		43,
		55,
		38,
		-1,
		-1,
		21,
		22,
		28,
		40,
		45,
		50,
		-1,
		76,
		95,
		-1,
		-1,
		11,
		24,
		20,
		23,
		31,
		47,
		68,
		85,
		90,
		-1,
		-1,
		12,
		16,
		29,
		30,
		28,
		55,
		74,
		85,
		99,
		98,
		-1,
		0,
		18,
		27,
		36,
		42,
		31,
		35,
		53,
		84,
		90,
		93,
		-1,
		17,
		13,
		23,
		29,
		41,
		47,
		34,
		40,
		59,
		72,
		91,
		82,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		52,
		18,
		9,
		29,
		31,
		30,
		48,
		63,
		37,
		43,
		47,
		64,
		80,
		81,
		91,
		-1,
		-1,
		111,
		84,
		108,
		66,
		48,
		-1,
		14,
		16,
		22,
		26,
		31,
		39,
		65,
		53,
		-1,
		58,
		57,
		88,
		74,
		85,
		93,
		-1,
		-1,
		69,
		61,
		43,
		46,
		23,
		19,
		31,
		30,
		26,
		28,
		30,
		42,
		57,
		57,
		67,
		52,
		62,
		66,
		81,
		92,
		-1,
		-1,
		166,
		-1,
		-1,
		90,
		73,
		-1,
		38,
		45,
		29,
		35,
		21,
		42,
		41,
		35,
		42,
		45,
		33,
		52,
		49,
		73,
		69,
		49,
		74,
		78,
		84,
		102,
		103,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		45,
		42,
		35,
		59,
		58,
		-1,
		64,
		62,
		68,
		53,
		58,
		54,
		39,
		57,
		55,
		70,
		71,
		56,
		58,
		95,
		86,
		107,
		104,
		135,
		141,
		135,
		144,
		-1,
		98,
		94,
		90,
		97,
		46,
		-1,
		-1,
		63,
		-1,
		66,
		79,
		76,
		64,
		67,
		54,
		62,
		61,
		45,
		63,
		58,
		61,
		68,
		64,
		73,
		83,
		82,
		100,
		113,
		128,
		132,
		138,
		-1,
		148,
		-1,
		90,
		74,
		76,
		52,
		80,
		-1,
		83,
		67,
		87,
		78,
		78,
		-1,
		70,
		67,
		77,
		60,
		45,
		62,
		65,
		67,
		67,
		71,
		86,
		77,
		95,
		102,
		110,
		114,
		134,
		146,
		108,
		98,
		-1,
		80,
		85,
		55,
		67,
		90,
		110,
		94,
		-1,
		89,
		-1,
		72,
		85,
		-1,
		66,
		62,
		51,
		67,
		69,
		76,
		74,
		68,
		65,
		83,
		86,
		103,
		107,
		123,
		-1,
		-1,
		93,
		97,
		105,
		56,
		75,
		99,
		136,
		103,
		96,
		95,
		-1,
		90,
		87,
		84,
		85,
		71,
		64,
		65,
		75,
		81,
		82,
		67,
		70,
		92,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		82,
		53,
		77,
		119,
		125,
		118,
		106,
		123,
		123,
		114,
		-1,
		102,
		81,
		78,
		69,
		77,
		91,
		88,
		91,
		71,
		73,
		89,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		112,
		101,
		102,
		56,
		90,
		108,
		156,
		142,
		147,
		122,
		116,
		119,
		96,
		98,
		93,
		87,
		79,
		68,
		84,
		92,
		93,
		73,
		82,
		83,
		107,
		114,
		120,
		-1,
		-1,
		119,
		109,
		93,
		95,
		92,
		81,
		88,
		120,
		147,
		163,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		81,
		75,
		84,
		98,
		87,
		78,
		93,
		112,
		112,
		104,
		129,
		132,
		-1,
		-1,
		-1,
		112,
		129,
		104,
		81,
		62,
		98,
		-1,
		133,
		134,
		-1,
		118,
		112,
		109,
		94,
		90,
		85,
		89,
		82,
		89,
		85,
		96,
		97,
		79,
		115,
		-1,
		112,
		106,
		134,
		137,
		127,
		-1,
		-1,
		-1,
		127,
		106,
		99,
		119,
		69,
		121,
		-1,
		-1,
		118,
		111,
		-1,
		105,
		87,
		94,
		92,
		86,
		90,
		94,
		83,
		96,
		101,
		84,
		94,
		114,
		118,
		125,
		118,
		123,
		122,
		136,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		89,
		-1,
		126,
		118,
		109,
		103,
		104,
		100,
		98,
		114,
		98,
		101,
		101,
		97,
		105,
		90,
		93,
		87,
		91,
		109,
		135,
		127,
		121,
		120,
		132,
		-1,
		175,
		161,
		132,
		-1,
		-1,
		104,
		-1,
		75,
		99,
		115,
		-1,
		142,
		121,
		136,
		114,
		110,
		106,
		121,
		122,
		100,
		105,
		104,
		114,
		115,
		104,
		99,
		103,
		118,
		128,
		115,
		116,
		125,
		-1,
		181,
		168,
		126,
		122,
		111,
		131,
		78,
		91,
		102,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		120,
		118,
		111,
		102,
		108,
		115,
		118,
		119,
		109,
		98,
		104,
		103,
		125,
		111,
		109,
		128,
		144,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		97,
		84,
		78,
		-1,
		119,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		144,
		-1,
		117,
		119,
		111,
		100,
		97,
		108,
		106,
		117,
		134,
		-1,
		131,
		116,
		109,
		99,
		113,
		84,
		-1,
		135,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		139,
		137,
		125,
		109,
		102,
		99,
		100,
		113,
		133,
		124,
		136,
		-1,
		-1,
		-1,
		136,
		116,
		122,
		80,
		101,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		152,
		140,
		130,
		120,
		154,
		153,
		128,
		121,
		107,
		109,
		107,
		109,
		114,
		135,
		136,
		149,
		-1,
		-1,
		113,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		141,
		-1,
		-1,
		132,
		130,
		140,
		124,
		111,
		131,
		134,
		124,
		108,
		123,
		135,
		143,
		148,
		-1,
		116,
		103,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		165,
		169,
		135,
		-1,
		140,
		135,
		115,
		129,
		136,
		126,
		121,
		115,
		118,
		136,
		153,
		-1,
		-1,
		130,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		158,
		151,
		155,
		-1,
		143,
		131,
		117,
		134,
		139,
		136,
		127,
		119,
		124,
		121,
		134,
		148,
		152,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		160,
		175,
		197,
		174,
		147,
		142,
		135,
		129,
		125,
		141,
		147,
		158,
		126,
		122,
		123,
		127,
		126,
		143,
		153,
		-1,
		-1,
		136,
		153,
		186,
		168,
		172,
		224,
		-1,
		-1,
		151,
		142,
		133,
		136,
		135,
		138,
		132,
		129,
		134,
		139,
		127,
		136,
		154,
		153,
		-1,
		-1,
		-1,
		156,
		-1,
		171,
		-1,
		-1,
		187,
		222,
		169,
		151,
		147,
		145,
		138,
		147,
		142,
		137,
		147,
		149,
		141,
		129,
		133,
		156,
		145,
		184,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		185,
		160,
		175,
		221,
		207,
		214,
		184,
		181,
		-1,
		151,
		176,
		148,
		155,
		146,
		153,
		153,
		145,
		123,
		130,
		146,
		145,
		140,
		176,
		167,
		173,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		191,
		177,
		207,
		197,
		203,
		-1,
		-1,
		200,
		197,
		173,
		156,
		154,
		147,
		142,
		152,
		132,
		119,
		123,
		127,
		133,
		138,
		143,
		149,
		164,
		179,
		-1,
		161,
		242,
		235,
		218,
		226,
		257,
		-1,
		194,
		203,
		184,
		189,
		197,
		-1,
		-1,
		173,
		170,
		175,
		163,
		160,
		162,
		157,
		148,
		133,
		139,
		126,
		125,
		143,
		147,
		156,
		163,
		153,
		166,
		170,
		-1,
		175,
		218,
		212,
		215,
		239,
		253,
		-1,
		207,
		-1,
		-1,
		192,
		204,
		188,
		178,
		172,
		222,
		177,
		172,
		156,
		154,
		145,
		136,
		143,
		134,
		134,
		137,
		152,
		157,
		149,
		163,
		163,
		164,
		-1,
		210,
		198,
		206,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		208,
		-1,
		215,
		-1,
		190,
		194,
		185,
		188,
		170,
		157,
		149,
		141,
		157,
		132,
		142,
		138,
		139,
		148,
		159,
		171,
		170,
		171,
		284,
		239,
		206,
		197,
		244,
		259,
		263,
		-1,
		220,
		259,
		246,
		-1,
		217,
		-1,
		-1,
		-1,
		204,
		198,
		190,
		190,
		169,
		169,
		143,
		147,
		137,
		144,
		154,
		156,
		148,
		152,
		165,
		176,
		179,
		280,
		278,
		283,
		228,
		211,
		229,
		238,
		259,
		235,
		226,
		253,
		253,
		242,
		237,
		224,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		176,
		164,
		147,
		148,
		144,
		147,
		162,
		165,
		155,
		153,
		147,
		179,
		-1,
		280,
		279,
		268,
		265,
		241,
		232,
		219,
		230,
		-1,
		-1,
		238,
		254,
		260,
		264,
		280,
		305,
		-1,
		227,
		-1,
		-1,
		221,
		-1,
		-1,
		206,
		169,
		158,
		149,
		155,
		152,
		163,
		173,
		161,
		162,
		152,
		162,
		175,
		264,
		261,
		249,
		247,
		270,
		227,
		223,
		-1,
		236,
		234,
		240,
		247,
		264,
		294,
		-1,
		-1,
		243,
		232,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		154,
		159,
		179,
		181,
		170,
		164,
		158,
		165,
		164,
		172,
		180,
		273,
		287,
		276,
		272,
		271,
		279,
		228,
		221,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		-1,
		242,
		238,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		172,
		176,
		168,
		161,
		156,
		167,
		159,
		163,
		180,
		-1,
		307,
		-1,
		259,
		235,
		249,
		264,
		272,
		-1,
		-1,
		-1,
		259,
		245,
		238,
		226,
		224,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		212,
		180,
		185,
		180,
		162,
		173,
		162,
		165,
		179,
		174,
		-1,
		-1,
		247,
		250,
		-1,
		-1,
		249,
		251,
		-1,
		250,
		239,
		224,
		216,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		169,
		194,
		183,
		191,
		186,
		166,
		172,
		175,
		164,
		168,
		180,
		-1,
		-1,
		254,
		255,
		256,
		-1,
		234,
		-1,
		252,
		-1,
		219,
		225,
		213,
		-1,
		-1,
		-1,
		207,
		170,
		191,
		201,
		195,
		193,
		184,
		170,
		177,
		175,
		171,
		182,
		-1,
		-1,
		-1,
		252,
		226,
		259,
		250,
		233,
		213,
		205,
		224,
		-1,
		194,
		-1,
		169,
		171,
		197,
		200,
		206,
		200,
		173,
		188,
		178,
		169,
		178,
		258,
		-1,
		228,
		261,
		225,
		219,
		195,
		199,
		215,
		-1,
		191,
		173,
		-1,
		201,
		191,
		222,
		207,
		188,
		175,
		182,
		182,
		175,
		-1,
		-1,
		-1,
		230,
		229,
		221,
		215,
		215,
		200,
		191,
		-1,
		203,
		185,
		164,
		181,
		181,
		172,
		180,
		212,
		208,
		195,
		195,
		187,
		-1,
		331,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		224,
		219,
		192,
		180,
		186,
		182,
		168,
		174,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		188,
		223,
		-1,
		326,
		-1,
		260,
		-1,
		-1,
		242,
		222,
		214,
		203,
		192,
		190,
		181,
		172,
		194,
		210,
		194,
		192,
		195,
		196,
		-1,
		315,
		314,
		-1,
		261,
		253,
		239,
		-1,
		232,
		-1,
		238,
		199,
		-1,
		201,
		181,
		-1,
		203,
		199,
		-1,
		-1,
		302,
		277,
		-1,
		-1,
		-1,
		262,
		242,
		233,
		217,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		287,
		286,
		-1,
		255,
		258,
		-1,
		248,
		239,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		296,
		277,
		271,
		270,
		268,
		263,
		260,
		246,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		268,
		260,
		253,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		290,
		271,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		279,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		301,
		302,
		325,
		289,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		304,
		302,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		81,
		70,
		81,
		89,
		62,
		69,
		-1,
		90,
		92,
		58,
		52,
		91,
		62,
		68,
		79,
		-1,
		-1,
		-1,
		81,
		80,
		50,
		48,
		57,
		62,
		69,
		-1,
		92,
		-1,
		102,
		81,
		92,
		97,
		43,
		40,
		60,
		79,
		85,
		77,
		117,
		73,
		44,
		38,
		56,
		61,
		79,
		71,
		-1,
		44,
		34,
		56,
		60,
		72,
		55,
		-1,
		-1,
		38,
		39,
		45,
		57,
		62,
		67,
		-1,
		93,
		112,
		-1,
		-1,
		28,
		36,
		37,
		40,
		48,
		64,
		85,
		102,
		107,
		-1,
		-1,
		29,
		33,
		39,
		47,
		45,
		72,
		91,
		102,
		116,
		115,
		-1,
		17,
		0,
		16,
		41,
		47,
		48,
		52,
		70,
		101,
		107,
		110,
		-1,
		32,
		28,
		25,
		31,
		37,
		63,
		51,
		57,
		76,
		89,
		108,
		99,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		35,
		26,
		31,
		33,
		47,
		53,
		68,
		54,
		60,
		64,
		81,
		97,
		98,
		108,
		-1,
		-1,
		128,
		101,
		125,
		83,
		65,
		-1,
		31,
		33,
		39,
		43,
		45,
		53,
		70,
		70,
		-1,
		75,
		74,
		105,
		91,
		102,
		110,
		-1,
		-1,
		86,
		78,
		60,
		63,
		40,
		36,
		48,
		47,
		43,
		45,
		47,
		56,
		71,
		71,
		81,
		69,
		79,
		83,
		98,
		109,
		-1,
		-1,
		183,
		-1,
		-1,
		107,
		90,
		-1,
		55,
		62,
		46,
		52,
		38,
		59,
		58,
		52,
		59,
		62,
		50,
		66,
		63,
		87,
		83,
		66,
		91,
		95,
		101,
		119,
		120,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		62,
		59,
		52,
		76,
		75,
		-1,
		81,
		79,
		85,
		70,
		75,
		71,
		56,
		71,
		69,
		84,
		86,
		73,
		75,
		112,
		103,
		124,
		121,
		152,
		158,
		152,
		161,
		-1,
		115,
		111,
		107,
		114,
		63,
		-1,
		-1,
		80,
		-1,
		83,
		96,
		93,
		81,
		84,
		71,
		79,
		78,
		62,
		77,
		72,
		75,
		85,
		81,
		90,
		100,
		99,
		117,
		130,
		145,
		149,
		155,
		-1,
		165,
		-1,
		107,
		91,
		93,
		69,
		97,
		-1,
		100,
		84,
		104,
		95,
		95,
		-1,
		87,
		84,
		94,
		77,
		62,
		79,
		79,
		83,
		84,
		88,
		103,
		94,
		112,
		119,
		127,
		131,
		151,
		163,
		125,
		115,
		-1,
		97,
		102,
		72,
		84,
		107,
		127,
		111,
		-1,
		106,
		-1,
		89,
		102,
		-1,
		83,
		79,
		68,
		84,
		86,
		93,
		91,
		85,
		82,
		100,
		103,
		120,
		124,
		140,
		-1,
		-1,
		110,
		114,
		122,
		73,
		92,
		116,
		153,
		120,
		113,
		112,
		-1,
		107,
		104,
		101,
		102,
		88,
		81,
		82,
		92,
		98,
		99,
		84,
		87,
		109,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		99,
		70,
		94,
		136,
		142,
		135,
		123,
		140,
		140,
		131,
		-1,
		119,
		98,
		95,
		86,
		94,
		108,
		105,
		108,
		88,
		90,
		106,
		118,
		109,
		129,
		-1,
		-1,
		-1,
		129,
		118,
		119,
		73,
		107,
		125,
		173,
		159,
		164,
		139,
		133,
		136,
		113,
		115,
		110,
		104,
		96,
		85,
		101,
		109,
		110,
		90,
		99,
		100,
		124,
		131,
		137,
		-1,
		-1,
		136,
		126,
		110,
		112,
		109,
		98,
		105,
		137,
		164,
		180,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		98,
		92,
		101,
		115,
		104,
		95,
		110,
		129,
		129,
		121,
		146,
		149,
		-1,
		-1,
		-1,
		129,
		146,
		121,
		98,
		79,
		115,
		-1,
		150,
		151,
		-1,
		135,
		129,
		126,
		111,
		107,
		102,
		106,
		99,
		106,
		102,
		113,
		114,
		96,
		132,
		-1,
		129,
		123,
		151,
		154,
		144,
		-1,
		-1,
		-1,
		144,
		123,
		116,
		136,
		86,
		138,
		-1,
		-1,
		135,
		128,
		-1,
		122,
		104,
		111,
		109,
		103,
		107,
		111,
		100,
		113,
		118,
		101,
		111,
		131,
		135,
		142,
		135,
		140,
		139,
		153,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		106,
		-1,
		143,
		135,
		126,
		120,
		121,
		117,
		115,
		131,
		115,
		118,
		118,
		114,
		122,
		107,
		110,
		104,
		108,
		126,
		152,
		144,
		138,
		137,
		149,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		121,
		-1,
		92,
		116,
		132,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		122,
		121,
		131,
		132,
		121,
		116,
		120,
		135,
		145,
		132,
		133,
		142,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		95,
		108,
		119,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		132,
		135,
		136,
		126,
		115,
		121,
		120,
		142,
		128,
		126,
		145,
		161,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		136,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		136,
		120,
		125,
		-1,
		161,
		-1,
		134,
		136,
		128,
		117,
		114,
		125,
		123,
		134,
		151,
		-1,
		148,
		133,
		126,
		116,
		130,
		101,
		-1,
		152,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		152,
		132,
		126,
		125,
		156,
		154,
		142,
		126,
		119,
		116,
		117,
		130,
		150,
		141,
		153,
		-1,
		-1,
		-1,
		153,
		133,
		139,
		97,
		118,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		169,
		157,
		147,
		137,
		171,
		170,
		145,
		138,
		124,
		126,
		124,
		126,
		131,
		152,
		153,
		166,
		-1,
		-1,
		130,
		137,
		125,
		111,
		130,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		158,
		-1,
		-1,
		149,
		147,
		157,
		141,
		128,
		148,
		151,
		141,
		125,
		140,
		152,
		160,
		165,
		-1,
		133,
		120,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		-1,
		-1,
		202,
		168,
		180,
		182,
		186,
		152,
		-1,
		157,
		152,
		132,
		146,
		153,
		143,
		138,
		132,
		135,
		153,
		170,
		-1,
		-1,
		147,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		159,
		173,
		175,
		168,
		172,
		-1,
		160,
		148,
		134,
		151,
		156,
		153,
		144,
		136,
		141,
		138,
		151,
		165,
		169,
		170,
		-1,
		153,
		-1,
		-1,
		-1,
		177,
		192,
		214,
		191,
		164,
		159,
		152,
		146,
		142,
		158,
		164,
		175,
		143,
		139,
		140,
		144,
		143,
		160,
		170,
		-1,
		-1,
		153,
		170,
		203,
		185,
		189,
		241,
		-1,
		-1,
		168,
		159,
		150,
		153,
		152,
		155,
		149,
		146,
		151,
		156,
		144,
		153,
		171,
		170,
		-1,
		-1,
		-1,
		173,
		-1,
		188,
		-1,
		-1,
		204,
		239,
		186,
		168,
		164,
		162,
		155,
		164,
		159,
		154,
		164,
		166,
		158,
		146,
		150,
		173,
		162,
		201,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		202,
		177,
		192,
		238,
		224,
		231,
		201,
		198,
		-1,
		168,
		193,
		165,
		172,
		163,
		170,
		170,
		162,
		140,
		147,
		163,
		162,
		157,
		193,
		184,
		190,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		208,
		194,
		224,
		214,
		220,
		-1,
		-1,
		217,
		214,
		190,
		173,
		171,
		164,
		159,
		169,
		149,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		178,
		259,
		252,
		235,
		243,
		274,
		-1,
		211,
		220,
		201,
		206,
		214,
		-1,
		-1,
		190,
		187,
		192,
		180,
		177,
		179,
		174,
		165,
		150,
		156,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		192,
		235,
		229,
		232,
		256,
		270,
		-1,
		224,
		-1,
		-1,
		209,
		221,
		205,
		195,
		189,
		239,
		194,
		189,
		173,
		171,
		162,
		153,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		227,
		215,
		223,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		225,
		-1,
		232,
		-1,
		207,
		211,
		202,
		205,
		187,
		174,
		166,
		158,
		174,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		301,
		256,
		223,
		214,
		261,
		276,
		280,
		-1,
		237,
		276,
		263,
		-1,
		234,
		-1,
		-1,
		-1,
		221,
		215,
		207,
		207,
		186,
		186,
		160,
		164,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		297,
		295,
		300,
		245,
		228,
		246,
		255,
		276,
		252,
		243,
		270,
		270,
		259,
		254,
		241,
		-1,
		-1,
		244,
		225,
		-1,
		-1,
		193,
		181,
		164,
		165,
		161,
		164,
		179,
		182,
		172,
		170,
		164,
		196,
		-1,
		297,
		296,
		285,
		282,
		258,
		249,
		236,
		247,
		-1,
		-1,
		255,
		271,
		277,
		281,
		297,
		322,
		-1,
		244,
		-1,
		-1,
		238,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		169,
		180,
		190,
		178,
		179,
		169,
		179,
		192,
		281,
		278,
		266,
		264,
		287,
		244,
		240,
		-1,
		253,
		251,
		257,
		264,
		281,
		311,
		-1,
		-1,
		260,
		249,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		171,
		176,
		196,
		198,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		290,
		304,
		293,
		289,
		288,
		296,
		245,
		238,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		-1,
		259,
		255,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		189,
		193,
		185,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		324,
		-1,
		276,
		252,
		266,
		281,
		289,
		-1,
		-1,
		-1,
		276,
		262,
		255,
		243,
		241,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		264,
		267,
		-1,
		-1,
		266,
		268,
		-1,
		267,
		256,
		241,
		233,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		271,
		272,
		273,
		-1,
		251,
		-1,
		269,
		-1,
		236,
		242,
		230,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		212,
		210,
		201,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		269,
		243,
		276,
		267,
		250,
		230,
		222,
		241,
		-1,
		211,
		-1,
		186,
		188,
		214,
		217,
		223,
		217,
		190,
		205,
		195,
		186,
		195,
		275,
		-1,
		245,
		278,
		242,
		236,
		212,
		216,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		239,
		224,
		205,
		192,
		199,
		199,
		192,
		-1,
		-1,
		-1,
		247,
		246,
		238,
		232,
		232,
		217,
		208,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		229,
		225,
		212,
		212,
		204,
		-1,
		348,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		241,
		236,
		209,
		197,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		205,
		240,
		-1,
		343,
		-1,
		277,
		-1,
		-1,
		259,
		239,
		231,
		220,
		209,
		207,
		198,
		189,
		211,
		227,
		211,
		209,
		212,
		213,
		-1,
		332,
		331,
		-1,
		278,
		270,
		256,
		-1,
		249,
		-1,
		255,
		216,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		319,
		294,
		-1,
		-1,
		-1,
		279,
		259,
		250,
		234,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		304,
		303,
		-1,
		272,
		275,
		-1,
		265,
		256,
		264,
		211,
		215,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		287,
		285,
		280,
		277,
		263,
		247,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		285,
		277,
		270,
		-1,
		-1,
		272,
		255,
		236,
		234,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		262,
		-1,
		-1,
		268,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		296,
		-1,
		-1,
		-1,
		258,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		318,
		319,
		342,
		306,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		321,
		319,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		88,
		77,
		88,
		96,
		69,
		76,
		-1,
		97,
		99,
		65,
		59,
		98,
		69,
		75,
		86,
		-1,
		-1,
		-1,
		88,
		87,
		57,
		55,
		64,
		69,
		76,
		-1,
		96,
		-1,
		109,
		88,
		99,
		104,
		50,
		47,
		67,
		86,
		89,
		81,
		124,
		80,
		51,
		45,
		63,
		68,
		83,
		75,
		-1,
		51,
		41,
		63,
		59,
		70,
		62,
		-1,
		-1,
		45,
		46,
		52,
		55,
		66,
		74,
		-1,
		97,
		116,
		-1,
		-1,
		35,
		43,
		39,
		44,
		52,
		66,
		89,
		106,
		111,
		-1,
		-1,
		33,
		37,
		30,
		51,
		47,
		76,
		95,
		106,
		120,
		119,
		-1,
		24,
		14,
		0,
		29,
		35,
		52,
		56,
		74,
		105,
		111,
		114,
		-1,
		39,
		35,
		29,
		19,
		21,
		52,
		55,
		61,
		80,
		93,
		112,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		76,
		42,
		33,
		38,
		37,
		45,
		37,
		59,
		58,
		64,
		68,
		85,
		101,
		102,
		112,
		-1,
		-1,
		135,
		108,
		132,
		90,
		72,
		-1,
		38,
		40,
		46,
		49,
		43,
		51,
		56,
		74,
		-1,
		79,
		78,
		109,
		95,
		106,
		117,
		-1,
		-1,
		93,
		85,
		67,
		70,
		47,
		43,
		55,
		54,
		50,
		52,
		54,
		54,
		69,
		69,
		79,
		73,
		83,
		87,
		102,
		113,
		-1,
		-1,
		187,
		-1,
		-1,
		114,
		97,
		-1,
		62,
		69,
		53,
		59,
		45,
		66,
		65,
		59,
		66,
		69,
		57,
		64,
		61,
		85,
		81,
		70,
		95,
		99,
		105,
		123,
		124,
		-1,
		186,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		69,
		66,
		59,
		83,
		82,
		-1,
		88,
		86,
		92,
		77,
		82,
		78,
		63,
		69,
		67,
		82,
		84,
		77,
		79,
		116,
		107,
		128,
		125,
		156,
		162,
		156,
		165,
		-1,
		122,
		118,
		114,
		121,
		70,
		-1,
		-1,
		87,
		-1,
		90,
		103,
		100,
		88,
		91,
		78,
		86,
		85,
		69,
		75,
		70,
		73,
		89,
		85,
		94,
		104,
		103,
		121,
		134,
		149,
		153,
		159,
		-1,
		172,
		-1,
		114,
		98,
		100,
		76,
		104,
		-1,
		107,
		91,
		111,
		102,
		102,
		-1,
		94,
		91,
		101,
		84,
		69,
		86,
		77,
		81,
		88,
		92,
		107,
		98,
		116,
		123,
		131,
		135,
		155,
		167,
		132,
		122,
		-1,
		104,
		109,
		79,
		91,
		114,
		134,
		118,
		-1,
		113,
		-1,
		96,
		109,
		-1,
		90,
		86,
		75,
		91,
		88,
		95,
		95,
		89,
		86,
		104,
		107,
		124,
		128,
		144,
		-1,
		-1,
		117,
		121,
		129,
		80,
		99,
		123,
		160,
		127,
		120,
		119,
		-1,
		114,
		111,
		108,
		109,
		95,
		88,
		89,
		94,
		100,
		103,
		88,
		91,
		113,
		141,
		119,
		131,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		106,
		77,
		101,
		143,
		149,
		142,
		130,
		147,
		147,
		138,
		-1,
		126,
		105,
		102,
		93,
		101,
		115,
		109,
		112,
		92,
		94,
		110,
		122,
		113,
		133,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		80,
		114,
		132,
		180,
		166,
		171,
		146,
		140,
		143,
		120,
		122,
		117,
		111,
		103,
		92,
		108,
		116,
		114,
		94,
		103,
		104,
		128,
		135,
		141,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		105,
		112,
		144,
		171,
		187,
		-1,
		148,
		-1,
		137,
		132,
		116,
		111,
		108,
		105,
		99,
		108,
		122,
		108,
		99,
		114,
		133,
		133,
		125,
		150,
		153,
		-1,
		-1,
		-1,
		136,
		153,
		128,
		105,
		86,
		122,
		-1,
		157,
		158,
		-1,
		142,
		136,
		133,
		118,
		114,
		109,
		113,
		106,
		113,
		109,
		117,
		118,
		100,
		136,
		-1,
		133,
		127,
		155,
		158,
		148,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		93,
		145,
		-1,
		-1,
		142,
		135,
		-1,
		129,
		111,
		118,
		116,
		110,
		114,
		118,
		107,
		120,
		125,
		105,
		115,
		135,
		139,
		146,
		139,
		144,
		143,
		157,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		113,
		-1,
		150,
		142,
		133,
		127,
		128,
		124,
		122,
		138,
		122,
		125,
		125,
		121,
		129,
		114,
		117,
		108,
		112,
		130,
		157,
		151,
		145,
		144,
		153,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		128,
		-1,
		99,
		123,
		139,
		-1,
		166,
		145,
		160,
		138,
		134,
		130,
		145,
		146,
		124,
		129,
		128,
		138,
		139,
		128,
		120,
		124,
		139,
		149,
		139,
		140,
		149,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		102,
		115,
		126,
		-1,
		-1,
		202,
		-1,
		136,
		153,
		144,
		142,
		135,
		126,
		132,
		139,
		142,
		143,
		133,
		122,
		128,
		127,
		149,
		135,
		133,
		152,
		168,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		180,
		170,
		154,
		139,
		172,
		-1,
		143,
		127,
		132,
		-1,
		168,
		-1,
		141,
		143,
		135,
		124,
		121,
		132,
		130,
		141,
		158,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		159,
		-1,
		-1,
		167,
		161,
		161,
		145,
		148,
		159,
		139,
		133,
		132,
		163,
		161,
		149,
		133,
		126,
		123,
		124,
		137,
		157,
		148,
		160,
		-1,
		-1,
		-1,
		160,
		140,
		146,
		104,
		125,
		-1,
		-1,
		229,
		184,
		170,
		-1,
		154,
		176,
		164,
		154,
		144,
		178,
		177,
		152,
		145,
		131,
		133,
		131,
		133,
		138,
		159,
		160,
		173,
		-1,
		-1,
		137,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		176,
		192,
		184,
		155,
		165,
		-1,
		-1,
		156,
		154,
		164,
		148,
		135,
		155,
		158,
		148,
		132,
		147,
		159,
		167,
		172,
		-1,
		140,
		127,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		187,
		189,
		193,
		159,
		-1,
		164,
		159,
		139,
		153,
		160,
		150,
		145,
		139,
		142,
		160,
		177,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		166,
		180,
		182,
		175,
		179,
		-1,
		167,
		155,
		141,
		158,
		163,
		160,
		151,
		143,
		148,
		145,
		158,
		172,
		176,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		184,
		199,
		221,
		198,
		171,
		166,
		159,
		153,
		149,
		165,
		171,
		182,
		150,
		146,
		147,
		151,
		150,
		167,
		177,
		-1,
		-1,
		160,
		177,
		210,
		192,
		196,
		248,
		-1,
		-1,
		175,
		166,
		157,
		160,
		159,
		162,
		156,
		153,
		158,
		163,
		151,
		160,
		178,
		177,
		-1,
		-1,
		-1,
		180,
		-1,
		195,
		-1,
		-1,
		211,
		246,
		193,
		175,
		171,
		169,
		162,
		171,
		166,
		161,
		171,
		173,
		165,
		153,
		157,
		180,
		169,
		208,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		209,
		184,
		199,
		245,
		231,
		238,
		208,
		205,
		-1,
		175,
		200,
		172,
		179,
		170,
		177,
		177,
		169,
		147,
		154,
		170,
		169,
		164,
		200,
		191,
		197,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		215,
		201,
		231,
		221,
		227,
		-1,
		-1,
		224,
		221,
		197,
		180,
		178,
		171,
		166,
		176,
		156,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		218,
		227,
		208,
		213,
		221,
		-1,
		-1,
		197,
		194,
		199,
		187,
		184,
		186,
		181,
		172,
		157,
		163,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		231,
		-1,
		-1,
		216,
		228,
		212,
		202,
		196,
		246,
		201,
		196,
		180,
		178,
		169,
		160,
		167,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		232,
		-1,
		239,
		-1,
		214,
		218,
		209,
		212,
		194,
		181,
		173,
		165,
		181,
		156,
		166,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		308,
		263,
		230,
		221,
		268,
		283,
		287,
		-1,
		244,
		283,
		270,
		-1,
		241,
		-1,
		-1,
		-1,
		228,
		222,
		214,
		214,
		193,
		193,
		167,
		171,
		161,
		168,
		178,
		180,
		172,
		176,
		189,
		200,
		203,
		304,
		302,
		307,
		252,
		235,
		253,
		262,
		283,
		259,
		250,
		277,
		277,
		266,
		261,
		248,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		200,
		188,
		171,
		172,
		168,
		171,
		186,
		189,
		179,
		177,
		171,
		203,
		-1,
		304,
		303,
		292,
		289,
		265,
		256,
		243,
		254,
		-1,
		-1,
		262,
		278,
		284,
		288,
		304,
		329,
		-1,
		251,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		176,
		187,
		197,
		185,
		186,
		176,
		186,
		199,
		288,
		285,
		273,
		271,
		294,
		251,
		247,
		-1,
		260,
		258,
		264,
		271,
		288,
		318,
		-1,
		-1,
		267,
		256,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		178,
		183,
		203,
		205,
		194,
		188,
		182,
		189,
		188,
		196,
		204,
		297,
		311,
		300,
		296,
		295,
		303,
		252,
		245,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		266,
		262,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		196,
		200,
		192,
		185,
		180,
		191,
		183,
		187,
		204,
		-1,
		331,
		-1,
		283,
		259,
		273,
		288,
		296,
		-1,
		-1,
		-1,
		283,
		269,
		262,
		250,
		248,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		186,
		197,
		186,
		189,
		203,
		198,
		-1,
		-1,
		271,
		274,
		-1,
		-1,
		273,
		275,
		-1,
		274,
		263,
		248,
		240,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		190,
		196,
		199,
		188,
		192,
		204,
		-1,
		-1,
		278,
		279,
		280,
		-1,
		258,
		-1,
		276,
		-1,
		243,
		249,
		237,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		219,
		217,
		208,
		194,
		201,
		199,
		195,
		206,
		-1,
		-1,
		-1,
		276,
		250,
		283,
		274,
		257,
		237,
		229,
		248,
		-1,
		218,
		-1,
		193,
		195,
		221,
		224,
		230,
		224,
		197,
		212,
		202,
		193,
		202,
		282,
		-1,
		252,
		285,
		249,
		243,
		219,
		223,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		246,
		231,
		212,
		199,
		206,
		206,
		199,
		-1,
		-1,
		-1,
		254,
		253,
		245,
		239,
		239,
		224,
		215,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		236,
		232,
		219,
		219,
		211,
		-1,
		355,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		248,
		243,
		216,
		204,
		210,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		212,
		247,
		-1,
		350,
		-1,
		284,
		-1,
		-1,
		266,
		246,
		238,
		227,
		216,
		214,
		205,
		196,
		218,
		234,
		218,
		216,
		219,
		220,
		-1,
		339,
		338,
		-1,
		285,
		277,
		263,
		-1,
		256,
		-1,
		262,
		223,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		326,
		301,
		-1,
		-1,
		-1,
		286,
		266,
		257,
		241,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		311,
		310,
		-1,
		279,
		282,
		-1,
		272,
		263,
		271,
		218,
		222,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		294,
		292,
		287,
		284,
		270,
		254,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		292,
		284,
		277,
		-1,
		-1,
		279,
		262,
		243,
		241,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		303,
		-1,
		-1,
		-1,
		265,
		261,
		262,
		-1,
		-1,
		-1,
		-1,
		325,
		326,
		349,
		313,
		-1,
		-1,
		-1,
		257,
		251,
		-1,
		-1,
		328,
		326,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		255,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		290,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		280,
		287,
		309,
		312,
		348,
		-1,
		299
	],
	[
		-1,
		104,
		93,
		104,
		112,
		85,
		92,
		-1,
		113,
		115,
		81,
		75,
		114,
		85,
		91,
		102,
		-1,
		-1,
		-1,
		104,
		103,
		73,
		71,
		80,
		85,
		92,
		-1,
		82,
		-1,
		125,
		104,
		115,
		120,
		66,
		63,
		83,
		94,
		75,
		67,
		140,
		96,
		67,
		61,
		79,
		60,
		69,
		61,
		-1,
		67,
		57,
		71,
		49,
		60,
		52,
		-1,
		-1,
		59,
		60,
		60,
		45,
		51,
		47,
		-1,
		72,
		91,
		-1,
		-1,
		51,
		43,
		27,
		30,
		38,
		38,
		64,
		81,
		86,
		-1,
		-1,
		35,
		29,
		24,
		23,
		19,
		51,
		70,
		81,
		95,
		94,
		-1,
		40,
		46,
		32,
		0,
		11,
		27,
		31,
		49,
		80,
		86,
		89,
		-1,
		56,
		52,
		37,
		27,
		22,
		28,
		30,
		36,
		55,
		68,
		87,
		78,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		58,
		49,
		57,
		45,
		53,
		38,
		47,
		33,
		39,
		43,
		60,
		76,
		77,
		87,
		-1,
		-1,
		151,
		124,
		148,
		106,
		88,
		-1,
		54,
		56,
		61,
		57,
		51,
		59,
		49,
		49,
		-1,
		54,
		53,
		84,
		70,
		81,
		133,
		-1,
		-1,
		109,
		101,
		83,
		86,
		63,
		59,
		71,
		70,
		66,
		68,
		70,
		62,
		57,
		70,
		77,
		48,
		58,
		62,
		77,
		88,
		-1,
		-1,
		162,
		-1,
		-1,
		130,
		113,
		-1,
		78,
		85,
		69,
		75,
		61,
		82,
		81,
		75,
		82,
		85,
		73,
		70,
		67,
		84,
		70,
		45,
		70,
		74,
		80,
		98,
		99,
		-1,
		161,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		85,
		82,
		75,
		99,
		98,
		-1,
		104,
		102,
		108,
		93,
		98,
		94,
		79,
		75,
		70,
		70,
		67,
		52,
		54,
		91,
		82,
		103,
		100,
		131,
		137,
		131,
		140,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		103,
		-1,
		106,
		119,
		116,
		104,
		107,
		94,
		102,
		101,
		85,
		81,
		68,
		65,
		64,
		60,
		69,
		79,
		78,
		96,
		109,
		124,
		128,
		134,
		-1,
		188,
		-1,
		130,
		114,
		116,
		92,
		120,
		-1,
		123,
		107,
		127,
		118,
		118,
		-1,
		110,
		107,
		117,
		100,
		85,
		80,
		68,
		63,
		63,
		67,
		82,
		73,
		91,
		98,
		106,
		110,
		130,
		142,
		148,
		138,
		-1,
		120,
		125,
		95,
		107,
		130,
		150,
		134,
		-1,
		129,
		-1,
		112,
		125,
		-1,
		106,
		102,
		88,
		76,
		65,
		72,
		70,
		64,
		61,
		79,
		82,
		99,
		103,
		119,
		-1,
		-1,
		133,
		137,
		145,
		96,
		115,
		139,
		176,
		143,
		136,
		135,
		-1,
		130,
		124,
		121,
		118,
		105,
		90,
		88,
		71,
		77,
		78,
		63,
		66,
		88,
		116,
		94,
		106,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		122,
		93,
		117,
		159,
		165,
		158,
		146,
		141,
		141,
		135,
		-1,
		129,
		108,
		99,
		88,
		78,
		94,
		84,
		87,
		67,
		69,
		85,
		97,
		88,
		108,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		96,
		130,
		148,
		174,
		160,
		165,
		140,
		133,
		127,
		133,
		125,
		106,
		95,
		87,
		76,
		85,
		95,
		89,
		69,
		78,
		79,
		103,
		110,
		116,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		121,
		128,
		160,
		165,
		178,
		-1,
		132,
		-1,
		121,
		116,
		100,
		95,
		92,
		89,
		83,
		92,
		97,
		83,
		74,
		89,
		108,
		108,
		100,
		125,
		128,
		-1,
		-1,
		-1,
		152,
		169,
		144,
		121,
		102,
		138,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		102,
		98,
		93,
		97,
		90,
		97,
		93,
		92,
		93,
		75,
		111,
		-1,
		108,
		102,
		130,
		133,
		123,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		109,
		161,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		102,
		100,
		94,
		98,
		102,
		91,
		104,
		100,
		80,
		90,
		110,
		114,
		121,
		114,
		119,
		118,
		132,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		129,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		122,
		106,
		109,
		109,
		105,
		113,
		98,
		97,
		83,
		87,
		105,
		132,
		127,
		122,
		121,
		128,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		144,
		-1,
		115,
		139,
		155,
		-1,
		150,
		129,
		144,
		122,
		118,
		114,
		129,
		130,
		108,
		113,
		112,
		122,
		119,
		108,
		95,
		99,
		114,
		124,
		116,
		117,
		126,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		118,
		112,
		142,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		128,
		126,
		119,
		110,
		116,
		123,
		126,
		123,
		113,
		102,
		108,
		104,
		126,
		112,
		110,
		129,
		144,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		127,
		111,
		116,
		-1,
		148,
		-1,
		121,
		121,
		112,
		101,
		98,
		109,
		107,
		118,
		135,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		175,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		143,
		123,
		117,
		116,
		143,
		138,
		129,
		110,
		103,
		100,
		101,
		114,
		134,
		125,
		137,
		-1,
		-1,
		-1,
		176,
		156,
		162,
		120,
		141,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		160,
		148,
		138,
		128,
		162,
		154,
		129,
		122,
		108,
		110,
		108,
		110,
		115,
		136,
		137,
		150,
		-1,
		-1,
		153,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		160,
		176,
		168,
		139,
		149,
		-1,
		-1,
		140,
		138,
		146,
		125,
		112,
		132,
		135,
		125,
		109,
		124,
		136,
		144,
		149,
		-1,
		156,
		143,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		171,
		166,
		170,
		143,
		-1,
		142,
		136,
		116,
		130,
		137,
		127,
		122,
		116,
		119,
		137,
		154,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		150,
		164,
		159,
		152,
		156,
		-1,
		144,
		132,
		118,
		135,
		140,
		137,
		128,
		120,
		125,
		122,
		135,
		149,
		153,
		193,
		-1,
		176,
		-1,
		-1,
		-1,
		168,
		183,
		198,
		175,
		148,
		143,
		136,
		130,
		126,
		142,
		148,
		159,
		127,
		123,
		124,
		128,
		127,
		144,
		154,
		-1,
		-1,
		176,
		193,
		194,
		176,
		180,
		225,
		-1,
		-1,
		152,
		143,
		134,
		137,
		136,
		139,
		133,
		130,
		135,
		140,
		128,
		137,
		155,
		154,
		-1,
		-1,
		-1,
		196,
		-1,
		211,
		-1,
		-1,
		195,
		223,
		170,
		152,
		148,
		146,
		139,
		148,
		143,
		138,
		148,
		150,
		142,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		225,
		200,
		215,
		234,
		215,
		222,
		185,
		182,
		-1,
		152,
		177,
		149,
		156,
		147,
		154,
		154,
		146,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		231,
		217,
		220,
		210,
		213,
		-1,
		-1,
		201,
		198,
		174,
		157,
		155,
		148,
		143,
		153,
		133,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		201,
		282,
		275,
		258,
		266,
		297,
		-1,
		224,
		216,
		224,
		202,
		204,
		-1,
		-1,
		174,
		171,
		176,
		164,
		161,
		163,
		158,
		149,
		134,
		140,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		215,
		258,
		252,
		255,
		279,
		293,
		-1,
		221,
		-1,
		-1,
		232,
		205,
		189,
		179,
		173,
		223,
		178,
		173,
		157,
		155,
		146,
		137,
		144,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		250,
		238,
		246,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		248,
		-1,
		216,
		-1,
		191,
		195,
		186,
		189,
		171,
		158,
		150,
		142,
		158,
		133,
		143,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		292,
		248,
		246,
		237,
		273,
		288,
		292,
		-1,
		233,
		272,
		270,
		-1,
		254,
		-1,
		-1,
		-1,
		205,
		199,
		191,
		191,
		170,
		170,
		144,
		148,
		138,
		145,
		155,
		157,
		149,
		153,
		166,
		177,
		180,
		288,
		279,
		292,
		237,
		237,
		258,
		267,
		288,
		248,
		239,
		266,
		277,
		266,
		261,
		248,
		-1,
		-1,
		228,
		209,
		-1,
		-1,
		177,
		165,
		148,
		149,
		145,
		148,
		163,
		166,
		156,
		154,
		148,
		180,
		-1,
		281,
		280,
		269,
		266,
		242,
		233,
		228,
		255,
		-1,
		-1,
		250,
		267,
		261,
		265,
		281,
		306,
		-1,
		237,
		-1,
		-1,
		222,
		-1,
		-1,
		207,
		170,
		159,
		150,
		156,
		153,
		164,
		174,
		162,
		163,
		153,
		163,
		176,
		265,
		262,
		250,
		248,
		271,
		236,
		224,
		-1,
		237,
		235,
		241,
		248,
		265,
		295,
		-1,
		-1,
		253,
		233,
		-1,
		-1,
		205,
		203,
		192,
		-1,
		182,
		155,
		160,
		180,
		182,
		171,
		165,
		159,
		166,
		165,
		173,
		181,
		274,
		288,
		277,
		273,
		272,
		280,
		229,
		222,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		-1,
		243,
		239,
		-1,
		-1,
		200,
		193,
		181,
		169,
		159,
		169,
		173,
		177,
		169,
		162,
		157,
		168,
		160,
		164,
		181,
		-1,
		308,
		-1,
		260,
		236,
		250,
		265,
		273,
		-1,
		-1,
		-1,
		260,
		246,
		239,
		227,
		225,
		-1,
		234,
		218,
		199,
		-1,
		169,
		182,
		213,
		181,
		186,
		181,
		163,
		174,
		163,
		166,
		180,
		175,
		-1,
		-1,
		248,
		251,
		-1,
		-1,
		250,
		252,
		-1,
		251,
		240,
		225,
		217,
		-1,
		-1,
		206,
		202,
		-1,
		-1,
		170,
		195,
		184,
		192,
		187,
		167,
		173,
		176,
		165,
		169,
		181,
		-1,
		-1,
		255,
		256,
		257,
		-1,
		235,
		-1,
		253,
		-1,
		220,
		226,
		214,
		-1,
		-1,
		-1,
		208,
		171,
		192,
		202,
		196,
		194,
		185,
		171,
		178,
		176,
		172,
		183,
		-1,
		-1,
		-1,
		253,
		227,
		260,
		251,
		234,
		214,
		206,
		225,
		-1,
		195,
		-1,
		170,
		172,
		198,
		201,
		207,
		201,
		174,
		189,
		179,
		170,
		179,
		259,
		-1,
		229,
		262,
		226,
		220,
		196,
		200,
		216,
		-1,
		192,
		174,
		-1,
		202,
		192,
		223,
		208,
		189,
		176,
		183,
		183,
		176,
		-1,
		-1,
		-1,
		231,
		230,
		222,
		216,
		216,
		201,
		192,
		-1,
		204,
		186,
		165,
		182,
		182,
		173,
		181,
		213,
		209,
		196,
		196,
		188,
		-1,
		332,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		225,
		220,
		193,
		181,
		187,
		183,
		169,
		175,
		177,
		185,
		183,
		180,
		192,
		188,
		208,
		189,
		224,
		-1,
		327,
		-1,
		261,
		-1,
		-1,
		243,
		223,
		215,
		204,
		193,
		191,
		182,
		173,
		195,
		211,
		195,
		193,
		196,
		197,
		-1,
		316,
		315,
		-1,
		262,
		254,
		240,
		-1,
		233,
		-1,
		239,
		200,
		-1,
		202,
		182,
		-1,
		204,
		200,
		-1,
		-1,
		303,
		278,
		-1,
		-1,
		-1,
		263,
		243,
		234,
		218,
		-1,
		193,
		193,
		-1,
		-1,
		-1,
		288,
		287,
		-1,
		256,
		259,
		-1,
		249,
		240,
		248,
		195,
		199,
		-1,
		-1,
		-1,
		297,
		278,
		272,
		271,
		269,
		264,
		261,
		247,
		231,
		209,
		198,
		219,
		-1,
		-1,
		-1,
		269,
		261,
		254,
		-1,
		-1,
		256,
		239,
		220,
		218,
		-1,
		-1,
		-1,
		291,
		272,
		-1,
		-1,
		246,
		-1,
		-1,
		252,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		308,
		280,
		-1,
		-1,
		-1,
		242,
		238,
		239,
		-1,
		-1,
		-1,
		-1,
		302,
		303,
		326,
		290,
		-1,
		-1,
		-1,
		234,
		228,
		-1,
		-1,
		305,
		303,
		-1,
		-1,
		-1,
		262,
		246,
		-1,
		232,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		267,
		-1,
		267,
		242,
		249,
		-1,
		-1,
		-1,
		-1,
		280,
		272,
		280,
		-1,
		252,
		254,
		-1,
		302,
		-1,
		-1,
		295,
		286,
		-1,
		-1,
		257,
		264,
		286,
		289,
		325,
		-1,
		276
	],
	[
		-1,
		103,
		92,
		103,
		111,
		84,
		91,
		-1,
		110,
		114,
		80,
		74,
		113,
		82,
		88,
		99,
		-1,
		-1,
		-1,
		103,
		102,
		70,
		68,
		77,
		82,
		89,
		-1,
		79,
		-1,
		124,
		103,
		114,
		119,
		63,
		60,
		80,
		91,
		72,
		64,
		139,
		93,
		64,
		58,
		76,
		66,
		66,
		58,
		-1,
		64,
		54,
		76,
		55,
		60,
		42,
		-1,
		-1,
		58,
		59,
		65,
		51,
		47,
		39,
		-1,
		63,
		82,
		-1,
		-1,
		48,
		49,
		33,
		36,
		35,
		34,
		55,
		72,
		77,
		-1,
		-1,
		39,
		35,
		33,
		29,
		25,
		42,
		61,
		72,
		86,
		85,
		-1,
		49,
		55,
		41,
		14,
		0,
		18,
		22,
		40,
		71,
		77,
		80,
		-1,
		65,
		61,
		46,
		36,
		31,
		17,
		21,
		27,
		46,
		59,
		78,
		69,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		67,
		58,
		66,
		54,
		57,
		38,
		36,
		24,
		30,
		34,
		51,
		67,
		68,
		78,
		-1,
		-1,
		160,
		133,
		157,
		115,
		97,
		-1,
		63,
		65,
		65,
		61,
		55,
		63,
		38,
		40,
		-1,
		45,
		44,
		75,
		61,
		72,
		142,
		-1,
		-1,
		118,
		110,
		92,
		95,
		72,
		68,
		80,
		79,
		75,
		77,
		79,
		63,
		48,
		61,
		68,
		39,
		49,
		53,
		68,
		79,
		-1,
		-1,
		153,
		-1,
		-1,
		139,
		122,
		-1,
		87,
		94,
		78,
		84,
		70,
		91,
		90,
		84,
		91,
		94,
		82,
		61,
		58,
		75,
		61,
		36,
		61,
		65,
		71,
		89,
		90,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		94,
		91,
		84,
		108,
		107,
		-1,
		113,
		111,
		117,
		102,
		102,
		103,
		88,
		66,
		61,
		61,
		58,
		43,
		45,
		82,
		73,
		94,
		91,
		122,
		128,
		122,
		131,
		-1,
		147,
		143,
		139,
		146,
		95,
		-1,
		-1,
		112,
		-1,
		115,
		128,
		125,
		113,
		116,
		103,
		111,
		107,
		90,
		72,
		59,
		56,
		55,
		51,
		60,
		70,
		69,
		87,
		100,
		115,
		119,
		125,
		-1,
		197,
		-1,
		139,
		123,
		125,
		101,
		129,
		-1,
		132,
		116,
		136,
		127,
		127,
		-1,
		119,
		116,
		125,
		103,
		88,
		71,
		59,
		54,
		54,
		58,
		73,
		64,
		82,
		89,
		97,
		101,
		121,
		133,
		157,
		147,
		-1,
		129,
		134,
		104,
		116,
		139,
		159,
		143,
		-1,
		138,
		-1,
		121,
		134,
		-1,
		109,
		105,
		79,
		67,
		56,
		63,
		61,
		55,
		52,
		70,
		73,
		90,
		94,
		110,
		-1,
		-1,
		142,
		146,
		154,
		105,
		124,
		148,
		185,
		152,
		145,
		144,
		-1,
		139,
		115,
		112,
		109,
		96,
		81,
		79,
		62,
		68,
		69,
		54,
		57,
		79,
		107,
		85,
		97,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		131,
		102,
		126,
		168,
		174,
		167,
		155,
		132,
		132,
		126,
		-1,
		120,
		99,
		90,
		79,
		69,
		85,
		75,
		78,
		58,
		60,
		76,
		88,
		79,
		99,
		-1,
		-1,
		-1,
		161,
		150,
		151,
		105,
		139,
		157,
		165,
		151,
		156,
		131,
		124,
		118,
		124,
		116,
		97,
		86,
		78,
		67,
		76,
		86,
		80,
		60,
		69,
		70,
		94,
		101,
		107,
		-1,
		-1,
		168,
		158,
		142,
		144,
		141,
		130,
		137,
		169,
		156,
		169,
		-1,
		123,
		-1,
		112,
		107,
		91,
		86,
		83,
		80,
		74,
		83,
		88,
		74,
		65,
		80,
		99,
		99,
		91,
		116,
		119,
		-1,
		-1,
		-1,
		161,
		178,
		153,
		130,
		111,
		147,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		93,
		89,
		84,
		88,
		81,
		88,
		84,
		83,
		84,
		66,
		102,
		-1,
		99,
		93,
		121,
		124,
		114,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		118,
		170,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		93,
		91,
		85,
		89,
		93,
		82,
		95,
		91,
		71,
		81,
		101,
		105,
		112,
		105,
		110,
		109,
		123,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		138,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		113,
		97,
		100,
		100,
		96,
		104,
		89,
		88,
		74,
		78,
		96,
		123,
		118,
		113,
		112,
		119,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		153,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		105,
		120,
		121,
		99,
		104,
		103,
		113,
		110,
		99,
		86,
		90,
		105,
		115,
		107,
		108,
		117,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		119,
		117,
		110,
		101,
		107,
		114,
		117,
		114,
		104,
		93,
		99,
		95,
		117,
		103,
		101,
		120,
		135,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		118,
		102,
		107,
		-1,
		139,
		-1,
		112,
		112,
		103,
		92,
		89,
		100,
		98,
		109,
		126,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		134,
		114,
		108,
		107,
		134,
		129,
		120,
		101,
		94,
		91,
		92,
		105,
		125,
		116,
		128,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		151,
		139,
		129,
		119,
		153,
		145,
		120,
		113,
		99,
		101,
		99,
		101,
		106,
		127,
		128,
		141,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		140,
		-1,
		-1,
		131,
		129,
		137,
		116,
		103,
		123,
		126,
		116,
		100,
		115,
		127,
		135,
		140,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		162,
		157,
		161,
		134,
		-1,
		133,
		127,
		107,
		121,
		128,
		118,
		113,
		107,
		110,
		128,
		145,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		141,
		155,
		150,
		143,
		147,
		-1,
		135,
		123,
		109,
		126,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		140,
		144,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		159,
		174,
		189,
		166,
		139,
		134,
		127,
		121,
		117,
		133,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		135,
		145,
		-1,
		-1,
		173,
		190,
		185,
		167,
		171,
		216,
		-1,
		-1,
		143,
		134,
		125,
		128,
		127,
		130,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		145,
		-1,
		-1,
		-1,
		193,
		-1,
		208,
		-1,
		-1,
		186,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		141,
		133,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		222,
		197,
		212,
		225,
		206,
		213,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		138,
		145,
		145,
		137,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		305,
		294,
		283,
		289,
		-1,
		225,
		214,
		211,
		201,
		204,
		-1,
		-1,
		192,
		189,
		165,
		148,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		200,
		281,
		274,
		257,
		265,
		296,
		-1,
		215,
		207,
		218,
		193,
		195,
		-1,
		-1,
		165,
		162,
		167,
		155,
		152,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		214,
		257,
		251,
		254,
		278,
		292,
		-1,
		212,
		-1,
		-1,
		224,
		196,
		180,
		170,
		164,
		214,
		169,
		164,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		249,
		237,
		245,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		240,
		-1,
		207,
		-1,
		182,
		186,
		177,
		180,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		283,
		239,
		242,
		236,
		264,
		279,
		283,
		-1,
		224,
		263,
		261,
		-1,
		245,
		-1,
		-1,
		-1,
		196,
		190,
		182,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		279,
		270,
		283,
		228,
		228,
		249,
		258,
		279,
		239,
		230,
		257,
		268,
		257,
		252,
		239,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		272,
		271,
		260,
		257,
		233,
		224,
		219,
		246,
		-1,
		-1,
		241,
		258,
		252,
		256,
		272,
		297,
		-1,
		228,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		256,
		253,
		241,
		239,
		262,
		227,
		215,
		-1,
		228,
		226,
		232,
		239,
		256,
		286,
		-1,
		-1,
		244,
		224,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		265,
		279,
		268,
		264,
		263,
		271,
		220,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		230,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		299,
		-1,
		251,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		246,
		247,
		248,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		85,
		74,
		85,
		93,
		66,
		73,
		-1,
		92,
		96,
		62,
		56,
		95,
		64,
		70,
		81,
		-1,
		-1,
		-1,
		85,
		84,
		52,
		50,
		59,
		64,
		71,
		-1,
		70,
		-1,
		106,
		85,
		96,
		101,
		45,
		42,
		62,
		81,
		63,
		55,
		121,
		75,
		46,
		40,
		58,
		48,
		57,
		49,
		-1,
		46,
		36,
		58,
		37,
		48,
		40,
		-1,
		-1,
		40,
		41,
		47,
		33,
		39,
		35,
		-1,
		45,
		64,
		-1,
		-1,
		30,
		31,
		15,
		18,
		26,
		24,
		37,
		54,
		59,
		-1,
		-1,
		21,
		17,
		24,
		11,
		7,
		24,
		43,
		54,
		68,
		67,
		-1,
		33,
		50,
		50,
		18,
		16,
		0,
		4,
		22,
		53,
		59,
		62,
		-1,
		50,
		46,
		53,
		45,
		40,
		16,
		3,
		9,
		28,
		41,
		60,
		51,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		51,
		42,
		59,
		61,
		56,
		37,
		35,
		6,
		12,
		16,
		33,
		49,
		50,
		60,
		-1,
		-1,
		144,
		117,
		141,
		99,
		81,
		-1,
		47,
		49,
		55,
		59,
		54,
		48,
		37,
		22,
		-1,
		27,
		26,
		57,
		43,
		54,
		126,
		-1,
		-1,
		102,
		94,
		76,
		79,
		56,
		52,
		64,
		63,
		59,
		61,
		63,
		45,
		30,
		43,
		50,
		21,
		31,
		35,
		50,
		61,
		-1,
		-1,
		135,
		-1,
		-1,
		123,
		106,
		-1,
		71,
		78,
		62,
		68,
		54,
		75,
		74,
		68,
		75,
		76,
		66,
		43,
		40,
		57,
		43,
		18,
		43,
		47,
		53,
		71,
		72,
		-1,
		134,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		78,
		75,
		68,
		92,
		91,
		-1,
		97,
		95,
		101,
		86,
		89,
		85,
		72,
		48,
		43,
		43,
		40,
		25,
		27,
		64,
		55,
		76,
		73,
		104,
		110,
		104,
		113,
		-1,
		131,
		127,
		123,
		130,
		79,
		-1,
		-1,
		96,
		-1,
		99,
		112,
		109,
		97,
		100,
		87,
		95,
		89,
		72,
		54,
		41,
		38,
		37,
		33,
		42,
		52,
		51,
		69,
		82,
		97,
		101,
		107,
		-1,
		181,
		-1,
		123,
		107,
		109,
		85,
		113,
		-1,
		116,
		100,
		120,
		111,
		111,
		-1,
		103,
		100,
		107,
		85,
		70,
		53,
		41,
		36,
		36,
		40,
		55,
		46,
		64,
		71,
		79,
		83,
		103,
		115,
		141,
		131,
		-1,
		113,
		118,
		88,
		100,
		123,
		143,
		127,
		-1,
		122,
		-1,
		105,
		118,
		-1,
		91,
		87,
		61,
		49,
		38,
		45,
		43,
		37,
		34,
		52,
		55,
		72,
		76,
		92,
		-1,
		-1,
		126,
		130,
		138,
		89,
		108,
		132,
		169,
		136,
		129,
		128,
		-1,
		123,
		97,
		94,
		91,
		78,
		63,
		61,
		44,
		50,
		51,
		36,
		39,
		61,
		89,
		67,
		79,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		115,
		86,
		110,
		152,
		158,
		151,
		139,
		114,
		114,
		108,
		-1,
		102,
		81,
		72,
		61,
		51,
		67,
		57,
		60,
		40,
		42,
		58,
		70,
		61,
		81,
		-1,
		-1,
		-1,
		145,
		134,
		135,
		89,
		123,
		141,
		147,
		133,
		138,
		113,
		106,
		100,
		106,
		98,
		79,
		68,
		60,
		49,
		58,
		68,
		62,
		42,
		51,
		52,
		76,
		83,
		89,
		-1,
		-1,
		152,
		142,
		126,
		128,
		125,
		114,
		121,
		153,
		138,
		151,
		-1,
		105,
		-1,
		94,
		89,
		73,
		68,
		65,
		62,
		56,
		65,
		70,
		56,
		47,
		62,
		81,
		81,
		73,
		98,
		101,
		-1,
		-1,
		-1,
		145,
		162,
		137,
		114,
		95,
		131,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		75,
		71,
		66,
		70,
		63,
		70,
		66,
		65,
		66,
		48,
		84,
		-1,
		81,
		75,
		103,
		106,
		96,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		102,
		154,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		75,
		73,
		67,
		71,
		75,
		64,
		77,
		73,
		53,
		63,
		83,
		87,
		94,
		87,
		92,
		91,
		105,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		122,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		95,
		79,
		82,
		82,
		78,
		86,
		71,
		70,
		56,
		60,
		78,
		105,
		100,
		95,
		94,
		101,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		87,
		102,
		103,
		81,
		86,
		85,
		95,
		92,
		81,
		68,
		72,
		87,
		97,
		89,
		90,
		99,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		101,
		99,
		92,
		83,
		89,
		96,
		99,
		96,
		86,
		75,
		81,
		77,
		99,
		85,
		83,
		102,
		117,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		100,
		84,
		89,
		-1,
		121,
		-1,
		94,
		94,
		85,
		74,
		71,
		82,
		80,
		91,
		108,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		116,
		96,
		90,
		89,
		116,
		111,
		102,
		83,
		76,
		73,
		74,
		87,
		107,
		98,
		110,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		133,
		121,
		111,
		101,
		135,
		127,
		102,
		95,
		81,
		83,
		81,
		83,
		88,
		109,
		110,
		123,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		122,
		-1,
		-1,
		113,
		111,
		119,
		98,
		85,
		105,
		108,
		98,
		82,
		97,
		109,
		117,
		122,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		144,
		139,
		143,
		116,
		-1,
		115,
		109,
		89,
		103,
		110,
		100,
		95,
		89,
		92,
		110,
		127,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		123,
		137,
		132,
		125,
		129,
		-1,
		117,
		105,
		91,
		108,
		113,
		110,
		101,
		93,
		98,
		95,
		108,
		122,
		126,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		141,
		156,
		171,
		148,
		121,
		116,
		109,
		103,
		99,
		115,
		121,
		132,
		100,
		96,
		97,
		101,
		100,
		117,
		127,
		-1,
		-1,
		155,
		172,
		167,
		149,
		153,
		198,
		-1,
		-1,
		125,
		116,
		107,
		110,
		109,
		112,
		106,
		103,
		108,
		113,
		101,
		110,
		128,
		127,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		168,
		196,
		143,
		125,
		121,
		119,
		112,
		121,
		116,
		111,
		121,
		123,
		115,
		103,
		107,
		130,
		119,
		158,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		204,
		179,
		194,
		207,
		188,
		195,
		158,
		155,
		-1,
		125,
		150,
		122,
		129,
		120,
		127,
		127,
		119,
		97,
		104,
		120,
		119,
		114,
		150,
		141,
		147,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		207,
		196,
		193,
		183,
		186,
		-1,
		-1,
		174,
		171,
		147,
		130,
		128,
		121,
		116,
		126,
		106,
		93,
		97,
		101,
		107,
		112,
		117,
		123,
		138,
		153,
		-1,
		182,
		263,
		256,
		239,
		247,
		278,
		-1,
		197,
		189,
		200,
		175,
		177,
		-1,
		-1,
		147,
		144,
		149,
		137,
		134,
		136,
		131,
		122,
		107,
		113,
		100,
		99,
		117,
		121,
		130,
		137,
		127,
		140,
		144,
		-1,
		196,
		239,
		233,
		236,
		260,
		274,
		-1,
		194,
		-1,
		-1,
		206,
		178,
		162,
		152,
		146,
		196,
		151,
		146,
		130,
		128,
		119,
		110,
		117,
		108,
		108,
		111,
		126,
		131,
		123,
		137,
		137,
		138,
		-1,
		231,
		219,
		227,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		222,
		-1,
		189,
		-1,
		164,
		168,
		159,
		162,
		144,
		131,
		123,
		115,
		131,
		106,
		116,
		112,
		113,
		122,
		133,
		145,
		144,
		145,
		265,
		221,
		224,
		218,
		246,
		261,
		265,
		-1,
		206,
		245,
		243,
		-1,
		227,
		-1,
		-1,
		-1,
		178,
		172,
		164,
		164,
		143,
		143,
		117,
		121,
		111,
		118,
		128,
		130,
		122,
		126,
		139,
		150,
		153,
		261,
		252,
		265,
		210,
		210,
		231,
		240,
		261,
		221,
		212,
		239,
		250,
		239,
		234,
		221,
		-1,
		-1,
		201,
		182,
		-1,
		-1,
		150,
		138,
		121,
		122,
		118,
		121,
		136,
		139,
		129,
		127,
		121,
		153,
		-1,
		254,
		253,
		242,
		239,
		215,
		206,
		201,
		228,
		-1,
		-1,
		223,
		240,
		234,
		238,
		254,
		279,
		-1,
		210,
		-1,
		-1,
		195,
		-1,
		-1,
		180,
		143,
		132,
		123,
		129,
		126,
		137,
		147,
		135,
		136,
		126,
		136,
		149,
		238,
		235,
		223,
		221,
		244,
		209,
		197,
		-1,
		210,
		208,
		214,
		221,
		238,
		268,
		-1,
		-1,
		226,
		206,
		-1,
		-1,
		178,
		176,
		165,
		-1,
		155,
		128,
		133,
		153,
		155,
		144,
		138,
		132,
		139,
		138,
		146,
		154,
		247,
		261,
		250,
		246,
		245,
		253,
		202,
		195,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		216,
		212,
		-1,
		-1,
		173,
		166,
		154,
		142,
		132,
		142,
		146,
		150,
		142,
		135,
		130,
		141,
		133,
		137,
		154,
		-1,
		281,
		-1,
		233,
		209,
		223,
		238,
		246,
		-1,
		-1,
		-1,
		233,
		219,
		212,
		200,
		198,
		-1,
		207,
		191,
		172,
		-1,
		142,
		155,
		186,
		154,
		159,
		154,
		136,
		147,
		136,
		139,
		153,
		148,
		-1,
		-1,
		221,
		224,
		-1,
		-1,
		223,
		225,
		-1,
		224,
		213,
		198,
		190,
		-1,
		-1,
		179,
		175,
		-1,
		-1,
		143,
		168,
		157,
		165,
		160,
		140,
		146,
		149,
		138,
		142,
		154,
		-1,
		-1,
		228,
		229,
		230,
		-1,
		208,
		-1,
		226,
		-1,
		193,
		199,
		187,
		-1,
		-1,
		-1,
		181,
		144,
		165,
		175,
		169,
		167,
		158,
		144,
		151,
		149,
		145,
		156,
		-1,
		-1,
		-1,
		226,
		200,
		233,
		224,
		207,
		187,
		179,
		198,
		-1,
		168,
		-1,
		143,
		145,
		171,
		174,
		180,
		174,
		147,
		162,
		152,
		143,
		152,
		232,
		-1,
		202,
		235,
		199,
		193,
		169,
		173,
		189,
		-1,
		165,
		147,
		-1,
		175,
		165,
		196,
		181,
		162,
		149,
		156,
		156,
		149,
		-1,
		-1,
		-1,
		204,
		203,
		195,
		189,
		189,
		174,
		165,
		-1,
		177,
		159,
		138,
		155,
		155,
		146,
		154,
		186,
		182,
		169,
		169,
		161,
		-1,
		305,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		198,
		193,
		166,
		154,
		160,
		156,
		142,
		148,
		150,
		158,
		156,
		153,
		165,
		161,
		181,
		162,
		197,
		-1,
		300,
		-1,
		234,
		-1,
		-1,
		216,
		196,
		188,
		177,
		166,
		164,
		155,
		146,
		168,
		184,
		168,
		166,
		169,
		170,
		-1,
		289,
		288,
		-1,
		235,
		227,
		213,
		-1,
		206,
		-1,
		212,
		173,
		-1,
		175,
		155,
		-1,
		177,
		173,
		-1,
		-1,
		276,
		251,
		-1,
		-1,
		-1,
		236,
		216,
		207,
		191,
		-1,
		166,
		166,
		-1,
		-1,
		-1,
		261,
		260,
		-1,
		229,
		232,
		-1,
		222,
		213,
		221,
		168,
		172,
		-1,
		-1,
		-1,
		270,
		251,
		245,
		244,
		242,
		237,
		234,
		220,
		204,
		182,
		171,
		192,
		-1,
		-1,
		-1,
		242,
		234,
		227,
		-1,
		-1,
		229,
		212,
		193,
		191,
		-1,
		-1,
		-1,
		264,
		245,
		-1,
		-1,
		219,
		-1,
		-1,
		225,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		253,
		-1,
		-1,
		-1,
		215,
		211,
		212,
		-1,
		-1,
		-1,
		-1,
		275,
		276,
		299,
		263,
		-1,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		278,
		276,
		-1,
		-1,
		-1,
		235,
		219,
		-1,
		205,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		240,
		-1,
		240,
		215,
		222,
		-1,
		-1,
		-1,
		-1,
		253,
		245,
		253,
		-1,
		225,
		227,
		-1,
		275,
		-1,
		-1,
		268,
		259,
		-1,
		-1,
		230,
		237,
		259,
		262,
		298,
		-1,
		249
	],
	[
		-1,
		88,
		77,
		88,
		96,
		69,
		76,
		-1,
		95,
		99,
		65,
		59,
		98,
		67,
		73,
		84,
		-1,
		-1,
		-1,
		88,
		87,
		55,
		53,
		62,
		67,
		74,
		-1,
		73,
		-1,
		109,
		88,
		99,
		104,
		48,
		45,
		65,
		84,
		66,
		58,
		124,
		78,
		49,
		43,
		61,
		51,
		60,
		52,
		-1,
		49,
		39,
		61,
		40,
		51,
		43,
		-1,
		-1,
		43,
		44,
		50,
		36,
		42,
		38,
		-1,
		48,
		66,
		-1,
		-1,
		33,
		34,
		18,
		21,
		29,
		27,
		40,
		57,
		61,
		-1,
		-1,
		24,
		20,
		27,
		14,
		10,
		27,
		39,
		56,
		70,
		69,
		-1,
		36,
		53,
		53,
		21,
		19,
		3,
		0,
		18,
		55,
		61,
		65,
		-1,
		53,
		49,
		56,
		48,
		43,
		19,
		6,
		5,
		24,
		43,
		63,
		54,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		54,
		45,
		62,
		64,
		59,
		40,
		38,
		9,
		8,
		12,
		34,
		52,
		53,
		63,
		-1,
		-1,
		147,
		120,
		144,
		102,
		84,
		-1,
		50,
		52,
		58,
		62,
		57,
		51,
		40,
		25,
		-1,
		30,
		27,
		60,
		46,
		57,
		129,
		-1,
		-1,
		105,
		97,
		79,
		82,
		59,
		55,
		67,
		66,
		62,
		64,
		66,
		48,
		33,
		46,
		53,
		24,
		34,
		38,
		53,
		64,
		-1,
		-1,
		138,
		-1,
		-1,
		126,
		109,
		-1,
		74,
		81,
		65,
		71,
		57,
		78,
		77,
		71,
		78,
		79,
		69,
		46,
		43,
		60,
		46,
		21,
		46,
		50,
		56,
		74,
		75,
		-1,
		137,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		81,
		78,
		71,
		95,
		94,
		-1,
		100,
		98,
		104,
		89,
		92,
		88,
		75,
		51,
		46,
		46,
		43,
		28,
		30,
		67,
		58,
		79,
		76,
		107,
		113,
		107,
		116,
		-1,
		134,
		130,
		126,
		133,
		82,
		-1,
		-1,
		99,
		-1,
		102,
		115,
		112,
		100,
		103,
		90,
		98,
		92,
		75,
		57,
		44,
		41,
		40,
		36,
		45,
		55,
		54,
		72,
		85,
		100,
		104,
		110,
		-1,
		184,
		-1,
		126,
		110,
		112,
		88,
		116,
		-1,
		119,
		103,
		123,
		114,
		114,
		-1,
		106,
		103,
		110,
		88,
		73,
		56,
		44,
		39,
		39,
		43,
		58,
		49,
		67,
		74,
		82,
		86,
		106,
		118,
		144,
		134,
		-1,
		116,
		121,
		91,
		103,
		126,
		146,
		130,
		-1,
		125,
		-1,
		108,
		121,
		-1,
		94,
		90,
		64,
		52,
		41,
		48,
		46,
		40,
		37,
		55,
		58,
		75,
		79,
		95,
		-1,
		-1,
		129,
		133,
		141,
		92,
		111,
		135,
		172,
		139,
		132,
		131,
		-1,
		126,
		100,
		97,
		94,
		81,
		66,
		64,
		47,
		53,
		54,
		39,
		42,
		64,
		92,
		70,
		82,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		118,
		89,
		113,
		155,
		161,
		154,
		142,
		117,
		117,
		111,
		-1,
		105,
		84,
		75,
		64,
		54,
		70,
		60,
		63,
		43,
		45,
		61,
		73,
		64,
		84,
		-1,
		-1,
		-1,
		148,
		137,
		138,
		92,
		126,
		144,
		150,
		136,
		141,
		116,
		109,
		103,
		109,
		101,
		82,
		71,
		63,
		52,
		61,
		71,
		65,
		45,
		54,
		55,
		79,
		86,
		92,
		-1,
		-1,
		155,
		145,
		129,
		131,
		128,
		117,
		124,
		156,
		141,
		154,
		-1,
		108,
		-1,
		97,
		92,
		76,
		71,
		68,
		65,
		59,
		68,
		73,
		59,
		50,
		65,
		84,
		84,
		76,
		101,
		104,
		-1,
		-1,
		-1,
		148,
		165,
		140,
		117,
		98,
		134,
		-1,
		124,
		125,
		-1,
		102,
		96,
		93,
		78,
		74,
		69,
		73,
		66,
		73,
		69,
		68,
		69,
		51,
		87,
		-1,
		84,
		78,
		106,
		109,
		99,
		-1,
		-1,
		-1,
		163,
		142,
		135,
		155,
		105,
		157,
		-1,
		-1,
		109,
		102,
		-1,
		89,
		71,
		78,
		76,
		70,
		74,
		78,
		67,
		80,
		76,
		56,
		66,
		86,
		90,
		97,
		90,
		95,
		94,
		108,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		125,
		-1,
		118,
		110,
		100,
		94,
		88,
		84,
		82,
		98,
		82,
		85,
		85,
		81,
		89,
		74,
		73,
		59,
		63,
		81,
		108,
		103,
		98,
		97,
		104,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		94,
		90,
		105,
		106,
		84,
		89,
		88,
		98,
		95,
		84,
		71,
		75,
		90,
		100,
		92,
		93,
		102,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		104,
		102,
		95,
		86,
		92,
		99,
		102,
		99,
		89,
		78,
		84,
		80,
		102,
		88,
		86,
		105,
		120,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		103,
		87,
		92,
		-1,
		124,
		-1,
		97,
		97,
		88,
		77,
		74,
		85,
		83,
		94,
		111,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		119,
		99,
		93,
		92,
		119,
		114,
		105,
		86,
		79,
		76,
		77,
		90,
		110,
		101,
		113,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		136,
		124,
		114,
		104,
		138,
		130,
		105,
		98,
		84,
		86,
		84,
		86,
		91,
		112,
		113,
		126,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		125,
		-1,
		-1,
		116,
		114,
		122,
		101,
		88,
		108,
		111,
		101,
		85,
		100,
		112,
		120,
		125,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		169,
		135,
		147,
		142,
		146,
		119,
		-1,
		118,
		112,
		92,
		106,
		113,
		103,
		98,
		92,
		95,
		113,
		130,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		126,
		140,
		135,
		128,
		132,
		-1,
		120,
		108,
		94,
		111,
		116,
		113,
		104,
		96,
		101,
		98,
		111,
		125,
		129,
		175,
		-1,
		158,
		-1,
		-1,
		-1,
		144,
		159,
		174,
		151,
		124,
		119,
		112,
		106,
		102,
		118,
		124,
		135,
		103,
		99,
		100,
		104,
		103,
		120,
		130,
		-1,
		-1,
		158,
		175,
		170,
		152,
		156,
		201,
		-1,
		-1,
		128,
		119,
		110,
		113,
		112,
		115,
		109,
		106,
		111,
		116,
		104,
		113,
		131,
		130,
		-1,
		-1,
		-1,
		178,
		-1,
		193,
		-1,
		-1,
		171,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		126,
		118,
		106,
		110,
		133,
		122,
		161,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		207,
		182,
		197,
		210,
		191,
		198,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		123,
		130,
		130,
		122,
		100,
		107,
		123,
		122,
		117,
		153,
		144,
		150,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		210,
		199,
		196,
		186,
		189,
		-1,
		-1,
		177,
		174,
		150,
		133,
		131,
		124,
		119,
		129,
		109,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		200,
		192,
		203,
		178,
		180,
		-1,
		-1,
		150,
		147,
		152,
		140,
		137,
		139,
		134,
		125,
		110,
		116,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		197,
		-1,
		-1,
		209,
		181,
		165,
		155,
		149,
		199,
		154,
		149,
		133,
		131,
		122,
		113,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		225,
		-1,
		192,
		-1,
		167,
		171,
		162,
		165,
		147,
		134,
		126,
		118,
		134,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		268,
		224,
		227,
		221,
		249,
		264,
		268,
		-1,
		209,
		248,
		246,
		-1,
		230,
		-1,
		-1,
		-1,
		181,
		175,
		167,
		167,
		146,
		146,
		120,
		124,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		264,
		255,
		268,
		213,
		213,
		234,
		243,
		264,
		224,
		215,
		242,
		253,
		242,
		237,
		224,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		153,
		141,
		124,
		125,
		121,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		204,
		231,
		-1,
		-1,
		226,
		243,
		237,
		241,
		257,
		282,
		-1,
		213,
		-1,
		-1,
		198,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		129,
		140,
		150,
		138,
		139,
		129,
		139,
		152,
		241,
		238,
		226,
		224,
		247,
		212,
		200,
		-1,
		213,
		211,
		217,
		224,
		241,
		271,
		-1,
		-1,
		229,
		209,
		-1,
		-1,
		181,
		179,
		168,
		-1,
		158,
		131,
		136,
		156,
		158,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		198,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		215,
		-1,
		-1,
		176,
		169,
		157,
		145,
		135,
		145,
		149,
		153,
		145,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		284,
		-1,
		236,
		212,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		226,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		231,
		232,
		233,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		172,
		170,
		161,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		148,
		174,
		177,
		183,
		177,
		150,
		165,
		155,
		146,
		155,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		199,
		184,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		189,
		185,
		172,
		172,
		164,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		165,
		200,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		172,
		173,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		103,
		92,
		103,
		111,
		84,
		91,
		-1,
		110,
		114,
		80,
		74,
		113,
		82,
		88,
		99,
		-1,
		-1,
		-1,
		103,
		102,
		70,
		68,
		77,
		82,
		89,
		-1,
		88,
		-1,
		124,
		103,
		114,
		119,
		63,
		60,
		80,
		99,
		81,
		73,
		139,
		93,
		64,
		58,
		76,
		66,
		75,
		67,
		-1,
		64,
		54,
		76,
		55,
		66,
		58,
		-1,
		-1,
		58,
		59,
		65,
		51,
		57,
		53,
		-1,
		35,
		54,
		-1,
		-1,
		48,
		49,
		33,
		36,
		44,
		39,
		27,
		44,
		49,
		-1,
		-1,
		39,
		35,
		42,
		29,
		25,
		42,
		21,
		46,
		58,
		56,
		-1,
		51,
		68,
		68,
		36,
		34,
		18,
		15,
		0,
		45,
		48,
		56,
		-1,
		68,
		64,
		71,
		63,
		58,
		34,
		21,
		20,
		39,
		43,
		59,
		68,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		69,
		60,
		77,
		79,
		74,
		55,
		53,
		24,
		23,
		27,
		49,
		58,
		68,
		78,
		-1,
		-1,
		162,
		135,
		159,
		117,
		99,
		-1,
		65,
		67,
		73,
		77,
		72,
		66,
		55,
		40,
		-1,
		45,
		42,
		68,
		61,
		72,
		144,
		-1,
		-1,
		120,
		112,
		94,
		97,
		74,
		70,
		82,
		81,
		77,
		79,
		81,
		63,
		48,
		61,
		68,
		39,
		49,
		53,
		68,
		79,
		-1,
		-1,
		153,
		-1,
		-1,
		141,
		124,
		-1,
		89,
		96,
		80,
		86,
		72,
		93,
		92,
		86,
		93,
		94,
		84,
		61,
		58,
		75,
		61,
		36,
		61,
		65,
		71,
		89,
		90,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		96,
		93,
		86,
		110,
		109,
		-1,
		115,
		113,
		119,
		104,
		107,
		103,
		90,
		66,
		61,
		61,
		58,
		43,
		45,
		82,
		73,
		94,
		91,
		122,
		128,
		122,
		131,
		-1,
		149,
		145,
		141,
		148,
		97,
		-1,
		-1,
		114,
		-1,
		117,
		130,
		127,
		115,
		118,
		105,
		113,
		107,
		90,
		72,
		59,
		56,
		55,
		51,
		60,
		70,
		69,
		87,
		100,
		115,
		119,
		125,
		-1,
		199,
		-1,
		141,
		125,
		127,
		103,
		131,
		-1,
		134,
		118,
		138,
		129,
		129,
		-1,
		121,
		118,
		125,
		103,
		88,
		71,
		59,
		54,
		54,
		58,
		73,
		64,
		82,
		89,
		97,
		101,
		121,
		133,
		159,
		149,
		-1,
		131,
		136,
		106,
		118,
		141,
		161,
		145,
		-1,
		140,
		-1,
		123,
		136,
		-1,
		109,
		105,
		79,
		67,
		56,
		63,
		61,
		55,
		52,
		70,
		73,
		90,
		94,
		110,
		-1,
		-1,
		144,
		148,
		156,
		107,
		126,
		150,
		187,
		154,
		147,
		146,
		-1,
		141,
		115,
		112,
		109,
		96,
		81,
		79,
		62,
		68,
		69,
		54,
		57,
		79,
		107,
		85,
		97,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		133,
		104,
		128,
		170,
		176,
		169,
		157,
		132,
		132,
		126,
		-1,
		120,
		99,
		90,
		79,
		69,
		85,
		75,
		78,
		58,
		60,
		76,
		88,
		79,
		99,
		-1,
		-1,
		-1,
		163,
		152,
		153,
		107,
		141,
		159,
		165,
		151,
		156,
		131,
		124,
		118,
		124,
		116,
		97,
		86,
		78,
		67,
		76,
		86,
		80,
		60,
		69,
		70,
		94,
		101,
		107,
		-1,
		-1,
		170,
		160,
		144,
		146,
		143,
		132,
		139,
		171,
		156,
		169,
		-1,
		123,
		-1,
		112,
		107,
		91,
		86,
		83,
		80,
		74,
		83,
		88,
		74,
		65,
		80,
		99,
		99,
		91,
		116,
		119,
		-1,
		-1,
		-1,
		163,
		180,
		155,
		132,
		113,
		149,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		93,
		89,
		84,
		88,
		81,
		88,
		84,
		83,
		84,
		66,
		102,
		-1,
		99,
		93,
		121,
		124,
		114,
		-1,
		-1,
		-1,
		178,
		157,
		150,
		170,
		120,
		172,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		93,
		91,
		85,
		89,
		93,
		82,
		95,
		91,
		71,
		81,
		101,
		105,
		112,
		105,
		110,
		109,
		123,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		140,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		113,
		97,
		100,
		100,
		96,
		104,
		89,
		88,
		74,
		78,
		96,
		123,
		118,
		113,
		112,
		119,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		105,
		120,
		121,
		99,
		104,
		103,
		113,
		110,
		99,
		86,
		90,
		105,
		115,
		107,
		108,
		117,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		119,
		117,
		110,
		101,
		107,
		114,
		117,
		114,
		104,
		93,
		99,
		95,
		117,
		103,
		101,
		120,
		135,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		118,
		102,
		107,
		-1,
		139,
		-1,
		112,
		112,
		103,
		92,
		89,
		100,
		98,
		109,
		126,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		134,
		114,
		108,
		107,
		134,
		129,
		120,
		101,
		94,
		91,
		92,
		105,
		125,
		116,
		128,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		151,
		139,
		129,
		119,
		153,
		145,
		120,
		113,
		99,
		101,
		99,
		101,
		106,
		127,
		128,
		141,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		140,
		-1,
		-1,
		131,
		129,
		137,
		116,
		103,
		123,
		126,
		116,
		100,
		115,
		127,
		135,
		140,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		162,
		157,
		161,
		134,
		-1,
		133,
		127,
		107,
		121,
		128,
		118,
		113,
		107,
		110,
		128,
		145,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		141,
		155,
		150,
		143,
		147,
		-1,
		135,
		123,
		109,
		126,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		140,
		144,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		159,
		174,
		189,
		166,
		139,
		134,
		127,
		121,
		117,
		133,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		135,
		145,
		-1,
		-1,
		173,
		190,
		185,
		167,
		171,
		216,
		-1,
		-1,
		143,
		134,
		125,
		128,
		127,
		130,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		145,
		-1,
		-1,
		-1,
		193,
		-1,
		208,
		-1,
		-1,
		186,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		141,
		133,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		222,
		197,
		212,
		225,
		206,
		213,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		138,
		145,
		145,
		137,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		305,
		294,
		283,
		289,
		-1,
		225,
		214,
		211,
		201,
		204,
		-1,
		-1,
		192,
		189,
		165,
		148,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		200,
		281,
		274,
		257,
		265,
		296,
		-1,
		215,
		207,
		218,
		193,
		195,
		-1,
		-1,
		165,
		162,
		167,
		155,
		152,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		214,
		257,
		251,
		254,
		278,
		292,
		-1,
		212,
		-1,
		-1,
		224,
		196,
		180,
		170,
		164,
		214,
		169,
		164,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		249,
		237,
		245,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		240,
		-1,
		207,
		-1,
		182,
		186,
		177,
		180,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		283,
		239,
		242,
		236,
		264,
		279,
		283,
		-1,
		224,
		263,
		261,
		-1,
		245,
		-1,
		-1,
		-1,
		196,
		190,
		182,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		279,
		270,
		283,
		228,
		228,
		249,
		258,
		279,
		239,
		230,
		257,
		268,
		257,
		252,
		239,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		272,
		271,
		260,
		257,
		233,
		224,
		219,
		246,
		-1,
		-1,
		241,
		258,
		252,
		256,
		272,
		297,
		-1,
		228,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		256,
		253,
		241,
		239,
		262,
		227,
		215,
		-1,
		228,
		226,
		232,
		239,
		256,
		286,
		-1,
		-1,
		244,
		224,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		265,
		279,
		268,
		264,
		263,
		271,
		220,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		230,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		299,
		-1,
		251,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		246,
		247,
		248,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		136,
		125,
		136,
		144,
		117,
		124,
		-1,
		143,
		147,
		113,
		107,
		146,
		115,
		121,
		132,
		-1,
		-1,
		-1,
		136,
		135,
		103,
		101,
		110,
		115,
		122,
		-1,
		119,
		-1,
		157,
		136,
		147,
		152,
		96,
		93,
		113,
		131,
		112,
		104,
		172,
		126,
		97,
		91,
		109,
		99,
		106,
		98,
		-1,
		97,
		87,
		109,
		88,
		99,
		80,
		-1,
		-1,
		91,
		92,
		98,
		84,
		90,
		86,
		-1,
		39,
		18,
		-1,
		-1,
		81,
		82,
		66,
		69,
		77,
		64,
		35,
		21,
		13,
		-1,
		-1,
		72,
		68,
		75,
		62,
		58,
		75,
		39,
		7,
		22,
		24,
		-1,
		84,
		101,
		101,
		69,
		67,
		51,
		49,
		49,
		0,
		18,
		26,
		-1,
		101,
		97,
		98,
		96,
		91,
		67,
		54,
		54,
		64,
		12,
		29,
		37,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		93,
		110,
		94,
		84,
		88,
		86,
		57,
		54,
		52,
		33,
		24,
		40,
		64,
		-1,
		-1,
		195,
		168,
		192,
		150,
		132,
		-1,
		98,
		98,
		92,
		88,
		82,
		75,
		88,
		73,
		-1,
		41,
		37,
		34,
		47,
		58,
		177,
		-1,
		-1,
		153,
		145,
		127,
		130,
		107,
		103,
		113,
		112,
		105,
		98,
		94,
		72,
		75,
		75,
		81,
		37,
		45,
		49,
		54,
		65,
		-1,
		-1,
		151,
		-1,
		-1,
		174,
		157,
		-1,
		122,
		129,
		113,
		119,
		105,
		126,
		123,
		114,
		108,
		103,
		95,
		70,
		67,
		80,
		59,
		34,
		56,
		60,
		57,
		75,
		76,
		-1,
		150,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		129,
		126,
		119,
		143,
		142,
		-1,
		143,
		131,
		132,
		117,
		116,
		110,
		98,
		75,
		59,
		59,
		56,
		41,
		43,
		80,
		59,
		80,
		77,
		108,
		126,
		120,
		129,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		147,
		-1,
		150,
		163,
		155,
		128,
		131,
		118,
		118,
		105,
		94,
		76,
		57,
		54,
		53,
		49,
		58,
		64,
		67,
		83,
		86,
		113,
		117,
		123,
		-1,
		232,
		-1,
		174,
		158,
		160,
		136,
		164,
		-1,
		167,
		151,
		171,
		157,
		157,
		-1,
		134,
		131,
		123,
		101,
		86,
		69,
		57,
		52,
		52,
		56,
		71,
		62,
		80,
		87,
		95,
		99,
		119,
		131,
		192,
		182,
		-1,
		164,
		169,
		139,
		151,
		171,
		194,
		173,
		-1,
		168,
		-1,
		136,
		149,
		-1,
		107,
		103,
		77,
		65,
		54,
		61,
		59,
		53,
		50,
		68,
		71,
		88,
		92,
		108,
		-1,
		-1,
		177,
		181,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		113,
		110,
		107,
		94,
		79,
		77,
		60,
		66,
		67,
		52,
		55,
		77,
		105,
		83,
		95,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		118,
		97,
		88,
		77,
		67,
		83,
		73,
		76,
		56,
		58,
		74,
		86,
		77,
		97,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		122,
		114,
		95,
		84,
		76,
		65,
		74,
		84,
		78,
		58,
		67,
		68,
		92,
		99,
		105,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		86,
		72,
		63,
		78,
		97,
		97,
		89,
		114,
		117,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		82,
		81,
		82,
		64,
		100,
		-1,
		97,
		91,
		119,
		122,
		112,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		91,
		80,
		93,
		89,
		69,
		79,
		99,
		103,
		110,
		103,
		108,
		107,
		121,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		98,
		94,
		102,
		87,
		86,
		72,
		76,
		94,
		121,
		116,
		111,
		110,
		117,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		102,
		101,
		111,
		108,
		97,
		84,
		88,
		103,
		113,
		105,
		106,
		115,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		112,
		115,
		112,
		102,
		91,
		97,
		93,
		115,
		101,
		99,
		118,
		133,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		116,
		100,
		105,
		-1,
		137,
		-1,
		110,
		110,
		101,
		90,
		87,
		98,
		96,
		107,
		124,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		132,
		112,
		106,
		105,
		132,
		127,
		118,
		99,
		92,
		89,
		90,
		103,
		123,
		114,
		126,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		149,
		137,
		127,
		117,
		151,
		143,
		118,
		111,
		97,
		99,
		97,
		99,
		104,
		125,
		126,
		139,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		138,
		-1,
		-1,
		129,
		127,
		135,
		114,
		101,
		121,
		124,
		114,
		98,
		113,
		125,
		133,
		138,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		160,
		155,
		159,
		132,
		-1,
		131,
		125,
		105,
		119,
		126,
		116,
		111,
		105,
		108,
		126,
		143,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		139,
		153,
		148,
		141,
		145,
		-1,
		133,
		121,
		107,
		124,
		129,
		126,
		117,
		109,
		114,
		111,
		124,
		138,
		142,
		188,
		-1,
		171,
		-1,
		-1,
		-1,
		157,
		172,
		187,
		164,
		137,
		132,
		125,
		119,
		115,
		131,
		137,
		148,
		116,
		112,
		113,
		117,
		116,
		133,
		143,
		-1,
		-1,
		171,
		188,
		183,
		165,
		169,
		214,
		-1,
		-1,
		141,
		132,
		123,
		126,
		125,
		128,
		122,
		119,
		124,
		129,
		117,
		126,
		144,
		143,
		-1,
		-1,
		-1,
		191,
		-1,
		206,
		-1,
		-1,
		184,
		212,
		159,
		141,
		137,
		135,
		128,
		137,
		132,
		127,
		137,
		139,
		131,
		119,
		123,
		146,
		135,
		174,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		220,
		195,
		210,
		223,
		204,
		211,
		174,
		171,
		-1,
		141,
		166,
		138,
		145,
		136,
		143,
		143,
		135,
		113,
		120,
		136,
		135,
		130,
		166,
		157,
		163,
		-1,
		-1,
		303,
		292,
		281,
		287,
		-1,
		223,
		212,
		209,
		199,
		202,
		-1,
		-1,
		190,
		187,
		163,
		146,
		144,
		137,
		132,
		142,
		122,
		109,
		113,
		117,
		123,
		128,
		133,
		139,
		154,
		169,
		-1,
		198,
		279,
		272,
		255,
		263,
		294,
		-1,
		213,
		205,
		216,
		191,
		193,
		-1,
		-1,
		163,
		160,
		165,
		153,
		150,
		152,
		147,
		138,
		123,
		129,
		116,
		115,
		133,
		137,
		146,
		153,
		143,
		156,
		160,
		-1,
		212,
		255,
		249,
		252,
		276,
		290,
		-1,
		210,
		-1,
		-1,
		222,
		194,
		178,
		168,
		162,
		212,
		167,
		162,
		146,
		144,
		135,
		126,
		133,
		124,
		124,
		127,
		142,
		147,
		139,
		153,
		153,
		154,
		-1,
		247,
		235,
		243,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		238,
		-1,
		205,
		-1,
		180,
		184,
		175,
		178,
		160,
		147,
		139,
		131,
		147,
		122,
		132,
		128,
		129,
		138,
		149,
		161,
		160,
		161,
		281,
		237,
		240,
		234,
		262,
		277,
		281,
		-1,
		222,
		261,
		259,
		-1,
		243,
		-1,
		-1,
		-1,
		194,
		188,
		180,
		180,
		159,
		159,
		133,
		137,
		127,
		134,
		144,
		146,
		138,
		142,
		155,
		166,
		169,
		277,
		268,
		281,
		226,
		226,
		247,
		256,
		277,
		237,
		228,
		255,
		266,
		255,
		250,
		237,
		-1,
		-1,
		217,
		198,
		-1,
		-1,
		166,
		154,
		137,
		138,
		134,
		137,
		152,
		155,
		145,
		143,
		137,
		169,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		217,
		244,
		-1,
		-1,
		239,
		256,
		250,
		254,
		270,
		295,
		-1,
		226,
		-1,
		-1,
		211,
		-1,
		-1,
		196,
		159,
		148,
		139,
		145,
		142,
		153,
		163,
		151,
		152,
		142,
		152,
		165,
		254,
		251,
		239,
		237,
		260,
		225,
		213,
		-1,
		226,
		224,
		230,
		237,
		254,
		284,
		-1,
		-1,
		242,
		222,
		-1,
		-1,
		194,
		192,
		181,
		-1,
		171,
		144,
		149,
		169,
		171,
		160,
		154,
		148,
		155,
		154,
		162,
		170,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		211,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		232,
		228,
		-1,
		-1,
		189,
		182,
		170,
		158,
		148,
		158,
		162,
		166,
		158,
		151,
		146,
		157,
		149,
		153,
		170,
		-1,
		297,
		-1,
		249,
		225,
		239,
		254,
		262,
		-1,
		-1,
		-1,
		249,
		235,
		228,
		216,
		214,
		-1,
		223,
		207,
		188,
		-1,
		158,
		171,
		202,
		170,
		175,
		170,
		152,
		163,
		152,
		155,
		169,
		164,
		-1,
		-1,
		237,
		240,
		-1,
		-1,
		239,
		241,
		-1,
		240,
		229,
		214,
		206,
		-1,
		-1,
		195,
		191,
		-1,
		-1,
		159,
		184,
		173,
		181,
		176,
		156,
		162,
		165,
		154,
		158,
		170,
		-1,
		-1,
		244,
		245,
		246,
		-1,
		224,
		-1,
		242,
		-1,
		209,
		215,
		203,
		-1,
		-1,
		-1,
		197,
		160,
		181,
		191,
		185,
		183,
		174,
		160,
		167,
		165,
		161,
		172,
		-1,
		-1,
		-1,
		242,
		216,
		249,
		240,
		223,
		203,
		195,
		214,
		-1,
		184,
		-1,
		159,
		161,
		187,
		190,
		196,
		190,
		163,
		178,
		168,
		159,
		168,
		248,
		-1,
		218,
		251,
		215,
		209,
		185,
		189,
		205,
		-1,
		181,
		163,
		-1,
		191,
		181,
		212,
		197,
		178,
		165,
		172,
		172,
		165,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		205,
		190,
		181,
		-1,
		193,
		175,
		154,
		171,
		171,
		162,
		170,
		202,
		198,
		185,
		185,
		177,
		-1,
		321,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		209,
		182,
		170,
		176,
		172,
		158,
		164,
		166,
		174,
		172,
		169,
		181,
		177,
		197,
		178,
		213,
		-1,
		316,
		-1,
		250,
		-1,
		-1,
		232,
		212,
		204,
		193,
		182,
		180,
		171,
		162,
		184,
		200,
		184,
		182,
		185,
		186,
		-1,
		305,
		304,
		-1,
		251,
		243,
		229,
		-1,
		222,
		-1,
		228,
		189,
		-1,
		191,
		171,
		-1,
		193,
		189,
		-1,
		-1,
		292,
		267,
		-1,
		-1,
		-1,
		252,
		232,
		223,
		207,
		-1,
		182,
		182,
		-1,
		-1,
		-1,
		277,
		276,
		-1,
		245,
		248,
		-1,
		238,
		229,
		237,
		184,
		188,
		-1,
		-1,
		-1,
		286,
		267,
		261,
		260,
		258,
		253,
		250,
		236,
		220,
		198,
		187,
		208,
		-1,
		-1,
		-1,
		258,
		250,
		243,
		-1,
		-1,
		245,
		228,
		209,
		207,
		-1,
		-1,
		-1,
		280,
		261,
		-1,
		-1,
		235,
		-1,
		-1,
		241,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		269,
		-1,
		-1,
		-1,
		231,
		227,
		228,
		-1,
		-1,
		-1,
		-1,
		291,
		292,
		315,
		279,
		-1,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		294,
		292,
		-1,
		-1,
		-1,
		251,
		235,
		-1,
		221,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		256,
		-1,
		256,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		269,
		261,
		269,
		-1,
		241,
		243,
		-1,
		291,
		-1,
		-1,
		284,
		275,
		-1,
		-1,
		246,
		253,
		275,
		278,
		314,
		-1,
		265
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		150,
		154,
		120,
		114,
		153,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		143,
		142,
		110,
		108,
		117,
		122,
		129,
		-1,
		126,
		-1,
		164,
		143,
		154,
		159,
		103,
		100,
		120,
		138,
		119,
		111,
		179,
		133,
		104,
		98,
		116,
		106,
		113,
		105,
		-1,
		104,
		94,
		116,
		95,
		106,
		87,
		-1,
		-1,
		98,
		99,
		105,
		91,
		97,
		93,
		-1,
		47,
		26,
		-1,
		-1,
		88,
		89,
		73,
		76,
		84,
		72,
		43,
		29,
		21,
		-1,
		-1,
		79,
		75,
		82,
		69,
		65,
		82,
		46,
		15,
		10,
		8,
		-1,
		91,
		108,
		108,
		76,
		74,
		58,
		56,
		56,
		17,
		0,
		8,
		-1,
		108,
		104,
		105,
		103,
		98,
		74,
		61,
		61,
		71,
		19,
		11,
		20,
		70,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		100,
		117,
		101,
		91,
		95,
		93,
		64,
		61,
		59,
		40,
		21,
		23,
		47,
		-1,
		-1,
		202,
		175,
		199,
		157,
		139,
		-1,
		105,
		105,
		99,
		95,
		89,
		82,
		95,
		80,
		-1,
		42,
		44,
		31,
		30,
		41,
		184,
		-1,
		-1,
		160,
		152,
		134,
		137,
		114,
		110,
		120,
		119,
		112,
		105,
		101,
		79,
		82,
		82,
		88,
		44,
		40,
		37,
		37,
		48,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		164,
		-1,
		129,
		136,
		120,
		126,
		112,
		133,
		130,
		121,
		115,
		110,
		102,
		77,
		74,
		87,
		66,
		41,
		47,
		50,
		40,
		58,
		59,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		136,
		133,
		126,
		150,
		149,
		-1,
		150,
		138,
		139,
		124,
		123,
		117,
		105,
		82,
		66,
		66,
		63,
		48,
		50,
		74,
		42,
		63,
		60,
		91,
		129,
		123,
		132,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		154,
		-1,
		157,
		170,
		162,
		135,
		138,
		125,
		125,
		112,
		101,
		83,
		64,
		61,
		60,
		56,
		65,
		47,
		50,
		66,
		69,
		116,
		120,
		126,
		-1,
		239,
		-1,
		181,
		165,
		167,
		143,
		171,
		-1,
		174,
		158,
		178,
		164,
		164,
		-1,
		141,
		138,
		130,
		108,
		93,
		76,
		64,
		59,
		59,
		63,
		78,
		54,
		72,
		74,
		81,
		102,
		124,
		134,
		199,
		189,
		-1,
		171,
		176,
		146,
		158,
		178,
		201,
		180,
		-1,
		175,
		-1,
		143,
		156,
		-1,
		114,
		110,
		84,
		72,
		61,
		68,
		66,
		60,
		57,
		60,
		63,
		92,
		92,
		115,
		-1,
		-1,
		184,
		188,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		120,
		117,
		114,
		101,
		86,
		84,
		67,
		73,
		74,
		59,
		62,
		69,
		111,
		90,
		102,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		125,
		104,
		95,
		84,
		74,
		90,
		80,
		83,
		63,
		65,
		75,
		93,
		84,
		104,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		129,
		121,
		102,
		91,
		83,
		72,
		81,
		91,
		85,
		65,
		74,
		75,
		99,
		106,
		112,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		112,
		96,
		91,
		88,
		85,
		79,
		88,
		93,
		79,
		70,
		85,
		104,
		104,
		96,
		121,
		124,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		98,
		94,
		89,
		93,
		86,
		93,
		89,
		88,
		89,
		71,
		107,
		-1,
		104,
		98,
		126,
		129,
		119,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		98,
		96,
		90,
		94,
		98,
		87,
		100,
		96,
		76,
		86,
		106,
		110,
		117,
		110,
		115,
		114,
		128,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		118,
		102,
		105,
		105,
		101,
		109,
		94,
		93,
		79,
		83,
		101,
		128,
		123,
		118,
		117,
		124,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		110,
		125,
		126,
		104,
		109,
		108,
		118,
		115,
		104,
		91,
		95,
		110,
		120,
		112,
		113,
		122,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		124,
		122,
		115,
		106,
		112,
		119,
		122,
		119,
		109,
		98,
		104,
		100,
		122,
		108,
		106,
		125,
		140,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		123,
		107,
		112,
		-1,
		144,
		-1,
		117,
		117,
		108,
		97,
		94,
		105,
		103,
		114,
		131,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		139,
		119,
		113,
		112,
		139,
		134,
		125,
		106,
		99,
		96,
		97,
		110,
		130,
		121,
		133,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		156,
		144,
		134,
		124,
		158,
		150,
		125,
		118,
		104,
		106,
		104,
		106,
		111,
		132,
		133,
		146,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		164,
		135,
		145,
		-1,
		-1,
		136,
		134,
		142,
		121,
		108,
		128,
		131,
		121,
		105,
		120,
		132,
		140,
		145,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		167,
		162,
		166,
		139,
		-1,
		138,
		132,
		112,
		126,
		133,
		123,
		118,
		112,
		115,
		133,
		150,
		-1,
		-1,
		172,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		146,
		160,
		155,
		148,
		152,
		-1,
		140,
		128,
		114,
		131,
		136,
		133,
		124,
		116,
		121,
		118,
		131,
		145,
		149,
		195,
		-1,
		178,
		-1,
		-1,
		-1,
		164,
		179,
		194,
		171,
		144,
		139,
		132,
		126,
		122,
		138,
		144,
		155,
		123,
		119,
		120,
		124,
		123,
		140,
		150,
		-1,
		-1,
		178,
		195,
		190,
		172,
		176,
		221,
		-1,
		-1,
		148,
		139,
		130,
		133,
		132,
		135,
		129,
		126,
		131,
		136,
		124,
		133,
		151,
		150,
		-1,
		-1,
		-1,
		198,
		-1,
		213,
		-1,
		-1,
		191,
		219,
		166,
		148,
		144,
		142,
		135,
		144,
		139,
		134,
		144,
		146,
		138,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		227,
		202,
		217,
		230,
		211,
		218,
		181,
		178,
		-1,
		148,
		173,
		145,
		152,
		143,
		150,
		150,
		142,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		310,
		299,
		288,
		294,
		-1,
		230,
		219,
		216,
		206,
		209,
		-1,
		-1,
		197,
		194,
		170,
		153,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		205,
		286,
		279,
		262,
		270,
		301,
		-1,
		220,
		212,
		223,
		198,
		200,
		-1,
		-1,
		170,
		167,
		172,
		160,
		157,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		219,
		262,
		256,
		259,
		283,
		297,
		-1,
		217,
		-1,
		-1,
		229,
		201,
		185,
		175,
		169,
		219,
		174,
		169,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		254,
		242,
		250,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		245,
		-1,
		212,
		-1,
		187,
		191,
		182,
		185,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		288,
		244,
		247,
		241,
		269,
		284,
		288,
		-1,
		229,
		268,
		266,
		-1,
		250,
		-1,
		-1,
		-1,
		201,
		195,
		187,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		284,
		275,
		288,
		233,
		233,
		254,
		263,
		284,
		244,
		235,
		262,
		273,
		262,
		257,
		244,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		224,
		251,
		-1,
		-1,
		246,
		263,
		257,
		261,
		277,
		302,
		-1,
		233,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		261,
		258,
		246,
		244,
		267,
		232,
		220,
		-1,
		233,
		231,
		237,
		244,
		261,
		291,
		-1,
		-1,
		249,
		229,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		218,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		235,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		304,
		-1,
		256,
		232,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		251,
		252,
		253,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		148,
		137,
		148,
		156,
		129,
		136,
		-1,
		155,
		159,
		125,
		119,
		158,
		127,
		133,
		144,
		-1,
		-1,
		-1,
		148,
		147,
		115,
		113,
		122,
		127,
		134,
		-1,
		129,
		-1,
		169,
		148,
		159,
		164,
		108,
		105,
		125,
		141,
		122,
		114,
		184,
		138,
		109,
		103,
		121,
		111,
		116,
		108,
		-1,
		109,
		99,
		121,
		100,
		111,
		90,
		-1,
		-1,
		103,
		104,
		110,
		96,
		102,
		98,
		-1,
		55,
		28,
		-1,
		-1,
		93,
		94,
		78,
		81,
		89,
		80,
		51,
		37,
		23,
		-1,
		-1,
		84,
		80,
		87,
		74,
		70,
		87,
		54,
		23,
		10,
		8,
		-1,
		96,
		113,
		113,
		81,
		79,
		63,
		61,
		64,
		25,
		8,
		0,
		-1,
		113,
		109,
		110,
		108,
		103,
		79,
		66,
		66,
		72,
		27,
		11,
		12,
		62,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		105,
		122,
		106,
		96,
		100,
		98,
		69,
		62,
		60,
		48,
		18,
		15,
		39,
		-1,
		-1,
		207,
		180,
		204,
		162,
		144,
		-1,
		110,
		110,
		104,
		100,
		94,
		87,
		100,
		85,
		-1,
		37,
		46,
		28,
		22,
		33,
		189,
		-1,
		-1,
		165,
		157,
		139,
		142,
		119,
		115,
		125,
		124,
		117,
		110,
		106,
		84,
		87,
		87,
		93,
		49,
		32,
		29,
		29,
		40,
		-1,
		-1,
		146,
		-1,
		-1,
		186,
		169,
		-1,
		134,
		141,
		125,
		131,
		117,
		138,
		135,
		126,
		120,
		115,
		107,
		82,
		79,
		92,
		71,
		46,
		39,
		42,
		32,
		50,
		51,
		-1,
		145,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		141,
		138,
		131,
		155,
		154,
		-1,
		155,
		143,
		144,
		129,
		128,
		122,
		110,
		87,
		71,
		71,
		68,
		53,
		55,
		66,
		34,
		55,
		52,
		83,
		121,
		115,
		124,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		159,
		-1,
		162,
		175,
		167,
		140,
		143,
		130,
		130,
		117,
		106,
		88,
		69,
		66,
		65,
		61,
		70,
		39,
		42,
		58,
		61,
		108,
		112,
		118,
		-1,
		244,
		-1,
		186,
		170,
		172,
		148,
		176,
		-1,
		179,
		163,
		183,
		169,
		169,
		-1,
		146,
		143,
		135,
		113,
		98,
		81,
		69,
		64,
		64,
		66,
		71,
		46,
		64,
		66,
		73,
		94,
		116,
		126,
		204,
		194,
		-1,
		176,
		181,
		151,
		163,
		183,
		206,
		185,
		-1,
		180,
		-1,
		148,
		161,
		-1,
		119,
		115,
		89,
		77,
		66,
		73,
		71,
		62,
		59,
		52,
		55,
		84,
		84,
		110,
		-1,
		-1,
		189,
		193,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		125,
		122,
		119,
		106,
		91,
		89,
		72,
		78,
		76,
		61,
		64,
		61,
		103,
		89,
		101,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		79,
		95,
		82,
		85,
		65,
		67,
		67,
		92,
		83,
		103,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		134,
		126,
		107,
		96,
		88,
		77,
		83,
		93,
		87,
		67,
		76,
		74,
		98,
		105,
		111,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		90,
		84,
		93,
		95,
		81,
		72,
		87,
		103,
		103,
		95,
		120,
		123,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		94,
		98,
		91,
		98,
		94,
		90,
		91,
		73,
		108,
		-1,
		103,
		97,
		125,
		128,
		118,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		101,
		95,
		99,
		103,
		92,
		105,
		98,
		78,
		88,
		108,
		112,
		116,
		109,
		114,
		113,
		127,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		110,
		110,
		106,
		114,
		99,
		95,
		81,
		85,
		103,
		127,
		122,
		120,
		119,
		123,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		130,
		131,
		109,
		114,
		113,
		123,
		117,
		106,
		93,
		97,
		112,
		122,
		114,
		115,
		124,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		129,
		127,
		120,
		111,
		117,
		124,
		126,
		121,
		111,
		100,
		106,
		102,
		124,
		110,
		108,
		124,
		139,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		128,
		112,
		117,
		-1,
		146,
		-1,
		119,
		119,
		110,
		99,
		96,
		107,
		105,
		116,
		130,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		144,
		124,
		118,
		117,
		141,
		136,
		127,
		108,
		101,
		98,
		99,
		112,
		132,
		123,
		132,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		161,
		149,
		139,
		129,
		162,
		152,
		127,
		120,
		106,
		108,
		106,
		108,
		113,
		134,
		135,
		147,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		177,
		169,
		140,
		150,
		-1,
		-1,
		141,
		139,
		144,
		123,
		110,
		130,
		133,
		123,
		107,
		122,
		134,
		139,
		147,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		169,
		164,
		168,
		144,
		-1,
		140,
		134,
		114,
		128,
		135,
		125,
		120,
		114,
		117,
		135,
		150,
		-1,
		-1,
		177,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		151,
		165,
		157,
		150,
		154,
		-1,
		142,
		130,
		116,
		133,
		138,
		135,
		126,
		118,
		123,
		120,
		133,
		147,
		151,
		200,
		-1,
		183,
		-1,
		-1,
		-1,
		169,
		184,
		196,
		173,
		146,
		141,
		134,
		128,
		124,
		140,
		146,
		157,
		125,
		121,
		122,
		126,
		125,
		142,
		152,
		-1,
		-1,
		183,
		200,
		195,
		177,
		181,
		223,
		-1,
		-1,
		150,
		141,
		132,
		135,
		134,
		137,
		131,
		128,
		133,
		138,
		126,
		135,
		153,
		152,
		-1,
		-1,
		-1,
		203,
		-1,
		218,
		-1,
		-1,
		196,
		221,
		168,
		150,
		146,
		144,
		137,
		146,
		141,
		136,
		146,
		148,
		140,
		128,
		132,
		155,
		144,
		183,
		-1,
		-1,
		322,
		-1,
		-1,
		-1,
		232,
		207,
		222,
		232,
		216,
		223,
		183,
		180,
		-1,
		150,
		175,
		147,
		154,
		145,
		152,
		152,
		144,
		122,
		129,
		145,
		144,
		139,
		175,
		166,
		172,
		-1,
		-1,
		315,
		304,
		293,
		299,
		-1,
		232,
		224,
		218,
		208,
		211,
		-1,
		-1,
		199,
		196,
		172,
		155,
		153,
		146,
		141,
		151,
		131,
		118,
		122,
		126,
		132,
		137,
		142,
		148,
		163,
		178,
		-1,
		210,
		291,
		284,
		267,
		275,
		306,
		-1,
		222,
		214,
		225,
		200,
		202,
		-1,
		-1,
		172,
		169,
		174,
		162,
		159,
		161,
		156,
		147,
		132,
		138,
		125,
		124,
		142,
		146,
		155,
		162,
		152,
		165,
		169,
		-1,
		224,
		267,
		261,
		264,
		288,
		302,
		-1,
		219,
		-1,
		-1,
		231,
		203,
		187,
		177,
		171,
		221,
		176,
		171,
		155,
		153,
		144,
		135,
		142,
		133,
		133,
		136,
		151,
		156,
		148,
		162,
		162,
		163,
		-1,
		259,
		247,
		255,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		247,
		-1,
		214,
		-1,
		189,
		193,
		184,
		187,
		169,
		156,
		148,
		140,
		156,
		131,
		141,
		137,
		138,
		147,
		158,
		170,
		169,
		170,
		290,
		246,
		249,
		246,
		271,
		286,
		290,
		-1,
		231,
		270,
		268,
		-1,
		252,
		-1,
		-1,
		-1,
		203,
		197,
		189,
		189,
		168,
		168,
		142,
		146,
		136,
		143,
		153,
		155,
		147,
		151,
		164,
		175,
		178,
		286,
		277,
		290,
		235,
		235,
		256,
		265,
		286,
		246,
		237,
		264,
		275,
		264,
		259,
		246,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		175,
		163,
		146,
		147,
		143,
		146,
		161,
		164,
		154,
		152,
		146,
		178,
		-1,
		279,
		278,
		267,
		264,
		240,
		231,
		226,
		253,
		-1,
		-1,
		248,
		265,
		259,
		263,
		279,
		304,
		-1,
		235,
		-1,
		-1,
		220,
		-1,
		-1,
		205,
		168,
		157,
		148,
		154,
		151,
		162,
		172,
		160,
		161,
		151,
		161,
		174,
		263,
		260,
		248,
		246,
		269,
		234,
		222,
		-1,
		235,
		233,
		239,
		246,
		263,
		293,
		-1,
		-1,
		251,
		231,
		-1,
		-1,
		203,
		201,
		190,
		-1,
		180,
		153,
		158,
		178,
		180,
		169,
		163,
		157,
		164,
		163,
		171,
		179,
		272,
		286,
		275,
		271,
		270,
		278,
		227,
		220,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		-1,
		241,
		237,
		-1,
		-1,
		198,
		191,
		179,
		167,
		157,
		167,
		171,
		175,
		167,
		160,
		155,
		166,
		158,
		162,
		179,
		-1,
		306,
		-1,
		258,
		234,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		258,
		244,
		237,
		225,
		223,
		-1,
		232,
		216,
		197,
		-1,
		167,
		180,
		211,
		179,
		184,
		179,
		161,
		172,
		161,
		164,
		178,
		173,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		248,
		250,
		-1,
		249,
		238,
		223,
		215,
		-1,
		-1,
		204,
		200,
		-1,
		-1,
		168,
		193,
		182,
		190,
		185,
		165,
		171,
		174,
		163,
		167,
		179,
		-1,
		-1,
		253,
		254,
		255,
		-1,
		233,
		-1,
		251,
		-1,
		218,
		224,
		212,
		-1,
		-1,
		-1,
		206,
		169,
		190,
		200,
		194,
		192,
		183,
		169,
		176,
		174,
		170,
		181,
		-1,
		-1,
		-1,
		251,
		225,
		258,
		249,
		232,
		212,
		204,
		223,
		-1,
		193,
		-1,
		168,
		170,
		196,
		199,
		205,
		199,
		172,
		187,
		177,
		168,
		177,
		257,
		-1,
		227,
		260,
		224,
		218,
		194,
		198,
		214,
		-1,
		190,
		172,
		-1,
		200,
		190,
		221,
		206,
		187,
		174,
		181,
		181,
		174,
		-1,
		-1,
		-1,
		229,
		228,
		220,
		214,
		214,
		199,
		190,
		-1,
		202,
		184,
		163,
		180,
		180,
		171,
		179,
		211,
		207,
		194,
		194,
		186,
		-1,
		330,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		223,
		218,
		191,
		179,
		185,
		181,
		167,
		173,
		175,
		183,
		181,
		178,
		190,
		186,
		206,
		187,
		222,
		-1,
		325,
		-1,
		259,
		-1,
		-1,
		241,
		221,
		213,
		202,
		191,
		189,
		180,
		171,
		193,
		209,
		193,
		191,
		194,
		195,
		-1,
		314,
		313,
		-1,
		260,
		252,
		238,
		-1,
		231,
		-1,
		237,
		198,
		-1,
		200,
		180,
		-1,
		202,
		198,
		-1,
		-1,
		301,
		276,
		-1,
		-1,
		-1,
		261,
		241,
		232,
		216,
		-1,
		191,
		191,
		-1,
		-1,
		-1,
		286,
		285,
		-1,
		254,
		257,
		-1,
		247,
		238,
		246,
		193,
		197,
		-1,
		-1,
		-1,
		295,
		276,
		270,
		269,
		267,
		262,
		259,
		245,
		229,
		207,
		196,
		217,
		-1,
		-1,
		-1,
		267,
		259,
		252,
		-1,
		-1,
		254,
		237,
		218,
		216,
		-1,
		-1,
		-1,
		289,
		270,
		-1,
		-1,
		244,
		-1,
		-1,
		250,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		278,
		-1,
		-1,
		-1,
		240,
		236,
		237,
		-1,
		-1,
		-1,
		-1,
		300,
		301,
		324,
		288,
		-1,
		-1,
		-1,
		232,
		226,
		-1,
		-1,
		303,
		301,
		-1,
		-1,
		-1,
		260,
		244,
		-1,
		230,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		265,
		-1,
		265,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		278,
		270,
		278,
		-1,
		250,
		252,
		-1,
		300,
		-1,
		-1,
		293,
		284,
		-1,
		-1,
		255,
		262,
		284,
		287,
		323,
		-1,
		274
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		72,
		61,
		72,
		80,
		53,
		60,
		-1,
		81,
		83,
		49,
		43,
		82,
		53,
		59,
		70,
		-1,
		-1,
		-1,
		72,
		71,
		41,
		39,
		48,
		53,
		60,
		-1,
		83,
		-1,
		93,
		72,
		83,
		88,
		34,
		31,
		51,
		70,
		76,
		68,
		108,
		64,
		35,
		29,
		47,
		52,
		70,
		62,
		-1,
		35,
		25,
		47,
		51,
		63,
		46,
		-1,
		-1,
		29,
		30,
		36,
		48,
		53,
		58,
		-1,
		84,
		103,
		-1,
		-1,
		19,
		32,
		28,
		31,
		39,
		55,
		76,
		93,
		98,
		-1,
		-1,
		20,
		24,
		37,
		38,
		36,
		63,
		82,
		93,
		107,
		106,
		-1,
		8,
		26,
		35,
		44,
		50,
		39,
		43,
		61,
		92,
		98,
		101,
		-1,
		0,
		2,
		31,
		37,
		49,
		55,
		42,
		48,
		67,
		80,
		99,
		90,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		6,
		16,
		31,
		30,
		37,
		55,
		71,
		45,
		51,
		55,
		72,
		88,
		89,
		99,
		-1,
		-1,
		105,
		78,
		102,
		60,
		41,
		-1,
		7,
		23,
		29,
		33,
		38,
		46,
		73,
		61,
		-1,
		66,
		65,
		96,
		82,
		93,
		87,
		-1,
		-1,
		63,
		55,
		37,
		40,
		17,
		13,
		32,
		31,
		33,
		35,
		37,
		49,
		64,
		64,
		74,
		60,
		70,
		74,
		89,
		100,
		-1,
		-1,
		174,
		-1,
		-1,
		84,
		67,
		-1,
		32,
		39,
		23,
		29,
		15,
		36,
		40,
		42,
		49,
		52,
		40,
		59,
		56,
		80,
		76,
		57,
		82,
		86,
		92,
		110,
		111,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		39,
		36,
		29,
		53,
		52,
		-1,
		58,
		56,
		75,
		60,
		65,
		61,
		46,
		64,
		62,
		77,
		79,
		64,
		66,
		103,
		94,
		115,
		112,
		143,
		149,
		143,
		152,
		-1,
		92,
		88,
		84,
		91,
		40,
		-1,
		-1,
		57,
		-1,
		60,
		73,
		70,
		60,
		63,
		61,
		69,
		68,
		52,
		70,
		65,
		68,
		76,
		72,
		81,
		91,
		90,
		108,
		121,
		136,
		140,
		146,
		-1,
		142,
		-1,
		84,
		68,
		70,
		46,
		74,
		-1,
		77,
		61,
		81,
		72,
		72,
		-1,
		77,
		74,
		84,
		68,
		53,
		70,
		72,
		75,
		75,
		79,
		94,
		85,
		103,
		110,
		118,
		122,
		142,
		154,
		102,
		92,
		-1,
		74,
		79,
		49,
		61,
		84,
		104,
		88,
		-1,
		83,
		-1,
		79,
		92,
		-1,
		74,
		70,
		59,
		75,
		77,
		84,
		82,
		76,
		73,
		91,
		94,
		111,
		115,
		131,
		-1,
		-1,
		87,
		91,
		99,
		50,
		69,
		93,
		130,
		97,
		90,
		89,
		-1,
		97,
		95,
		92,
		93,
		79,
		72,
		73,
		83,
		89,
		90,
		75,
		78,
		100,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		76,
		47,
		71,
		113,
		119,
		112,
		100,
		117,
		117,
		121,
		-1,
		110,
		89,
		86,
		77,
		85,
		99,
		96,
		99,
		79,
		81,
		97,
		109,
		100,
		120,
		-1,
		-1,
		-1,
		106,
		95,
		96,
		50,
		84,
		102,
		150,
		136,
		141,
		116,
		122,
		122,
		104,
		106,
		101,
		95,
		87,
		76,
		92,
		100,
		101,
		81,
		90,
		91,
		115,
		122,
		128,
		-1,
		-1,
		113,
		103,
		87,
		89,
		86,
		75,
		82,
		114,
		141,
		157,
		-1,
		127,
		-1,
		116,
		116,
		100,
		95,
		92,
		89,
		83,
		92,
		106,
		95,
		86,
		101,
		120,
		120,
		112,
		137,
		140,
		-1,
		-1,
		-1,
		106,
		123,
		98,
		75,
		56,
		92,
		-1,
		127,
		128,
		-1,
		121,
		115,
		117,
		102,
		98,
		93,
		97,
		90,
		97,
		93,
		104,
		105,
		87,
		123,
		-1,
		120,
		114,
		142,
		145,
		135,
		-1,
		-1,
		-1,
		121,
		100,
		93,
		113,
		63,
		115,
		-1,
		-1,
		112,
		105,
		-1,
		108,
		95,
		102,
		100,
		94,
		98,
		102,
		91,
		104,
		109,
		92,
		102,
		122,
		126,
		133,
		126,
		131,
		130,
		144,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		83,
		-1,
		120,
		112,
		103,
		97,
		103,
		108,
		106,
		122,
		106,
		109,
		109,
		105,
		113,
		98,
		101,
		95,
		99,
		117,
		143,
		135,
		129,
		128,
		140,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		98,
		-1,
		69,
		93,
		109,
		-1,
		137,
		116,
		139,
		117,
		118,
		114,
		129,
		130,
		108,
		113,
		112,
		122,
		123,
		112,
		107,
		111,
		126,
		136,
		123,
		124,
		133,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		72,
		85,
		96,
		-1,
		-1,
		181,
		-1,
		115,
		132,
		128,
		126,
		119,
		110,
		116,
		123,
		126,
		127,
		117,
		106,
		112,
		111,
		133,
		119,
		117,
		136,
		152,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		159,
		149,
		133,
		118,
		151,
		-1,
		127,
		111,
		116,
		-1,
		152,
		-1,
		125,
		127,
		119,
		108,
		105,
		116,
		114,
		125,
		142,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		129,
		-1,
		-1,
		146,
		140,
		140,
		124,
		127,
		143,
		123,
		117,
		116,
		147,
		145,
		133,
		117,
		110,
		107,
		108,
		121,
		141,
		132,
		144,
		-1,
		-1,
		-1,
		130,
		110,
		116,
		74,
		95,
		-1,
		-1,
		208,
		163,
		149,
		-1,
		133,
		160,
		148,
		138,
		128,
		162,
		161,
		136,
		129,
		115,
		117,
		115,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		107,
		114,
		102,
		88,
		107,
		-1,
		-1,
		-1,
		155,
		171,
		163,
		134,
		149,
		-1,
		-1,
		140,
		138,
		148,
		132,
		119,
		139,
		142,
		132,
		116,
		131,
		143,
		151,
		156,
		-1,
		110,
		97,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		166,
		173,
		177,
		143,
		-1,
		148,
		143,
		123,
		137,
		144,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		124,
		-1,
		119,
		-1,
		-1,
		-1,
		-1,
		145,
		159,
		166,
		159,
		163,
		-1,
		151,
		139,
		125,
		142,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		147,
		-1,
		130,
		-1,
		-1,
		-1,
		163,
		178,
		205,
		182,
		155,
		150,
		143,
		137,
		133,
		149,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		130,
		147,
		182,
		171,
		175,
		232,
		-1,
		-1,
		159,
		150,
		141,
		144,
		143,
		146,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		161,
		-1,
		-1,
		-1,
		150,
		-1,
		165,
		-1,
		-1,
		190,
		230,
		177,
		159,
		155,
		153,
		146,
		155,
		150,
		145,
		155,
		157,
		149,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		179,
		154,
		169,
		215,
		210,
		211,
		192,
		189,
		-1,
		159,
		184,
		156,
		163,
		154,
		161,
		161,
		153,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		185,
		171,
		201,
		191,
		197,
		-1,
		-1,
		208,
		205,
		181,
		164,
		162,
		155,
		150,
		160,
		140,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		155,
		236,
		229,
		212,
		220,
		251,
		-1,
		188,
		197,
		178,
		183,
		191,
		-1,
		-1,
		181,
		178,
		183,
		171,
		168,
		170,
		165,
		156,
		141,
		147,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		169,
		212,
		206,
		209,
		233,
		247,
		-1,
		201,
		-1,
		-1,
		186,
		204,
		196,
		186,
		180,
		230,
		185,
		180,
		164,
		162,
		153,
		144,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		204,
		192,
		200,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		202,
		-1,
		223,
		-1,
		198,
		202,
		193,
		196,
		178,
		165,
		157,
		149,
		165,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		278,
		233,
		200,
		191,
		238,
		253,
		257,
		-1,
		214,
		253,
		240,
		-1,
		211,
		-1,
		-1,
		-1,
		212,
		206,
		198,
		198,
		177,
		177,
		151,
		155,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		274,
		272,
		277,
		222,
		205,
		223,
		232,
		253,
		229,
		220,
		247,
		247,
		236,
		231,
		218,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		184,
		172,
		155,
		156,
		152,
		155,
		170,
		173,
		163,
		161,
		155,
		187,
		-1,
		274,
		273,
		262,
		259,
		235,
		226,
		213,
		224,
		-1,
		-1,
		232,
		248,
		261,
		265,
		278,
		303,
		-1,
		221,
		-1,
		-1,
		229,
		-1,
		-1,
		214,
		177,
		166,
		157,
		163,
		160,
		171,
		181,
		169,
		170,
		160,
		170,
		183,
		258,
		255,
		243,
		241,
		264,
		221,
		217,
		-1,
		244,
		235,
		241,
		248,
		265,
		292,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		212,
		210,
		199,
		-1,
		189,
		162,
		167,
		187,
		189,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		267,
		281,
		270,
		266,
		265,
		273,
		222,
		229,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		250,
		246,
		-1,
		-1,
		207,
		200,
		188,
		176,
		166,
		176,
		180,
		184,
		176,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		301,
		-1,
		253,
		243,
		257,
		272,
		280,
		-1,
		-1,
		-1,
		267,
		253,
		246,
		234,
		232,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		220,
		188,
		193,
		188,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		255,
		258,
		-1,
		-1,
		257,
		259,
		-1,
		258,
		247,
		232,
		224,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		177,
		202,
		191,
		199,
		194,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		262,
		263,
		264,
		-1,
		242,
		-1,
		260,
		-1,
		227,
		233,
		221,
		-1,
		-1,
		-1,
		215,
		178,
		199,
		209,
		203,
		201,
		192,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		260,
		234,
		267,
		258,
		241,
		221,
		213,
		232,
		-1,
		202,
		-1,
		177,
		179,
		205,
		208,
		214,
		208,
		181,
		196,
		186,
		177,
		186,
		266,
		-1,
		236,
		269,
		233,
		227,
		203,
		207,
		223,
		-1,
		199,
		181,
		-1,
		209,
		199,
		230,
		215,
		196,
		183,
		190,
		190,
		183,
		-1,
		-1,
		-1,
		238,
		237,
		229,
		223,
		223,
		208,
		199,
		-1,
		211,
		193,
		172,
		189,
		189,
		180,
		188,
		220,
		216,
		203,
		203,
		195,
		-1,
		339,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		232,
		227,
		200,
		188,
		194,
		190,
		176,
		182,
		184,
		192,
		190,
		187,
		199,
		195,
		215,
		196,
		231,
		-1,
		334,
		-1,
		268,
		-1,
		-1,
		250,
		230,
		222,
		211,
		200,
		198,
		189,
		180,
		202,
		218,
		202,
		200,
		203,
		204,
		-1,
		323,
		322,
		-1,
		269,
		261,
		247,
		-1,
		240,
		-1,
		246,
		207,
		-1,
		209,
		189,
		-1,
		211,
		207,
		-1,
		-1,
		310,
		285,
		-1,
		-1,
		-1,
		270,
		250,
		241,
		225,
		-1,
		200,
		200,
		-1,
		-1,
		-1,
		295,
		294,
		-1,
		263,
		266,
		-1,
		256,
		247,
		255,
		202,
		206,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		278,
		276,
		271,
		268,
		254,
		238,
		216,
		205,
		226,
		-1,
		-1,
		-1,
		276,
		268,
		261,
		-1,
		-1,
		263,
		246,
		227,
		225,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		253,
		-1,
		-1,
		259,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		287,
		-1,
		-1,
		-1,
		249,
		245,
		246,
		-1,
		-1,
		-1,
		-1,
		309,
		310,
		333,
		297,
		-1,
		-1,
		-1,
		241,
		235,
		-1,
		-1,
		312,
		310,
		-1,
		-1,
		-1,
		269,
		253,
		-1,
		239,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		274,
		-1,
		274,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		287,
		279,
		287,
		-1,
		259,
		261,
		-1,
		309,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		264,
		271,
		293,
		296,
		332,
		-1,
		283
	],
	[
		-1,
		76,
		65,
		76,
		84,
		57,
		64,
		-1,
		85,
		87,
		53,
		47,
		86,
		57,
		63,
		74,
		-1,
		-1,
		-1,
		76,
		75,
		45,
		43,
		52,
		57,
		64,
		-1,
		87,
		-1,
		97,
		76,
		87,
		92,
		38,
		35,
		55,
		74,
		80,
		72,
		112,
		68,
		39,
		33,
		51,
		56,
		74,
		66,
		-1,
		39,
		29,
		51,
		55,
		67,
		50,
		-1,
		-1,
		33,
		34,
		40,
		52,
		57,
		62,
		-1,
		88,
		107,
		-1,
		-1,
		23,
		36,
		32,
		35,
		43,
		59,
		80,
		97,
		102,
		-1,
		-1,
		24,
		28,
		41,
		42,
		40,
		67,
		86,
		97,
		111,
		110,
		-1,
		12,
		30,
		39,
		48,
		54,
		43,
		47,
		65,
		96,
		102,
		105,
		-1,
		4,
		0,
		35,
		41,
		53,
		59,
		46,
		52,
		71,
		84,
		103,
		94,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		49,
		10,
		20,
		35,
		34,
		41,
		59,
		75,
		49,
		55,
		59,
		76,
		92,
		93,
		103,
		-1,
		-1,
		109,
		82,
		106,
		64,
		45,
		-1,
		11,
		27,
		33,
		37,
		42,
		50,
		77,
		65,
		-1,
		70,
		69,
		100,
		86,
		97,
		91,
		-1,
		-1,
		67,
		59,
		41,
		44,
		21,
		17,
		36,
		35,
		37,
		39,
		41,
		53,
		68,
		68,
		78,
		64,
		74,
		78,
		93,
		104,
		-1,
		-1,
		178,
		-1,
		-1,
		88,
		71,
		-1,
		36,
		43,
		27,
		33,
		19,
		40,
		44,
		46,
		53,
		56,
		44,
		63,
		60,
		84,
		80,
		61,
		86,
		90,
		96,
		114,
		115,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		43,
		40,
		33,
		57,
		56,
		-1,
		62,
		60,
		79,
		64,
		69,
		65,
		50,
		68,
		66,
		81,
		83,
		68,
		70,
		107,
		98,
		119,
		116,
		147,
		153,
		147,
		156,
		-1,
		96,
		92,
		88,
		95,
		44,
		-1,
		-1,
		61,
		-1,
		64,
		77,
		74,
		64,
		67,
		65,
		73,
		72,
		56,
		74,
		69,
		72,
		80,
		76,
		85,
		95,
		94,
		112,
		125,
		140,
		144,
		150,
		-1,
		146,
		-1,
		88,
		72,
		74,
		50,
		78,
		-1,
		81,
		65,
		85,
		76,
		76,
		-1,
		81,
		78,
		88,
		72,
		57,
		74,
		76,
		79,
		79,
		83,
		98,
		89,
		107,
		114,
		122,
		126,
		146,
		158,
		106,
		96,
		-1,
		78,
		83,
		53,
		65,
		88,
		108,
		92,
		-1,
		87,
		-1,
		83,
		96,
		-1,
		78,
		74,
		63,
		79,
		81,
		88,
		86,
		80,
		77,
		95,
		98,
		115,
		119,
		135,
		-1,
		-1,
		91,
		95,
		103,
		54,
		73,
		97,
		134,
		101,
		94,
		93,
		-1,
		101,
		99,
		96,
		97,
		83,
		76,
		77,
		87,
		93,
		94,
		79,
		82,
		104,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		80,
		51,
		75,
		117,
		123,
		116,
		104,
		121,
		121,
		125,
		-1,
		114,
		93,
		90,
		81,
		89,
		103,
		100,
		103,
		83,
		85,
		101,
		113,
		104,
		124,
		-1,
		-1,
		-1,
		110,
		99,
		100,
		54,
		88,
		106,
		154,
		140,
		145,
		120,
		126,
		126,
		108,
		110,
		105,
		99,
		91,
		80,
		96,
		104,
		105,
		85,
		94,
		95,
		119,
		126,
		132,
		-1,
		-1,
		117,
		107,
		91,
		93,
		90,
		79,
		86,
		118,
		145,
		161,
		-1,
		131,
		-1,
		120,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		110,
		99,
		90,
		105,
		124,
		124,
		116,
		141,
		144,
		-1,
		-1,
		-1,
		110,
		127,
		102,
		79,
		60,
		96,
		-1,
		131,
		132,
		-1,
		125,
		119,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		97,
		108,
		109,
		91,
		127,
		-1,
		124,
		118,
		146,
		149,
		139,
		-1,
		-1,
		-1,
		125,
		104,
		97,
		117,
		67,
		119,
		-1,
		-1,
		116,
		109,
		-1,
		112,
		99,
		106,
		104,
		98,
		102,
		106,
		95,
		108,
		113,
		96,
		106,
		126,
		130,
		137,
		130,
		135,
		134,
		148,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		87,
		-1,
		124,
		116,
		107,
		101,
		107,
		112,
		110,
		126,
		110,
		113,
		113,
		109,
		117,
		102,
		105,
		99,
		103,
		121,
		147,
		139,
		133,
		132,
		144,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		102,
		-1,
		73,
		97,
		113,
		-1,
		141,
		120,
		143,
		121,
		122,
		118,
		133,
		134,
		112,
		117,
		116,
		126,
		127,
		116,
		111,
		115,
		130,
		140,
		127,
		128,
		137,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		76,
		89,
		100,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		132,
		130,
		123,
		114,
		120,
		127,
		130,
		131,
		121,
		110,
		116,
		115,
		137,
		123,
		121,
		140,
		156,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		117,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		131,
		115,
		120,
		-1,
		156,
		-1,
		129,
		131,
		123,
		112,
		109,
		120,
		118,
		129,
		146,
		-1,
		129,
		114,
		107,
		97,
		111,
		82,
		-1,
		133,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		147,
		127,
		121,
		120,
		151,
		149,
		137,
		121,
		114,
		111,
		112,
		125,
		145,
		136,
		148,
		-1,
		-1,
		-1,
		134,
		114,
		120,
		78,
		99,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		137,
		164,
		152,
		142,
		132,
		166,
		165,
		140,
		133,
		119,
		121,
		119,
		121,
		126,
		147,
		148,
		161,
		-1,
		-1,
		111,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		159,
		175,
		167,
		138,
		153,
		-1,
		-1,
		144,
		142,
		152,
		136,
		123,
		143,
		146,
		136,
		120,
		135,
		147,
		155,
		160,
		-1,
		114,
		101,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		170,
		177,
		181,
		147,
		-1,
		152,
		147,
		127,
		141,
		148,
		138,
		133,
		127,
		130,
		148,
		165,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		149,
		163,
		170,
		163,
		167,
		-1,
		155,
		143,
		129,
		146,
		151,
		148,
		139,
		131,
		136,
		133,
		146,
		160,
		164,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		167,
		182,
		209,
		186,
		159,
		154,
		147,
		141,
		137,
		153,
		159,
		170,
		138,
		134,
		135,
		139,
		138,
		155,
		165,
		-1,
		-1,
		134,
		151,
		186,
		175,
		179,
		236,
		-1,
		-1,
		163,
		154,
		145,
		148,
		147,
		150,
		144,
		141,
		146,
		151,
		139,
		148,
		166,
		165,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		194,
		234,
		181,
		163,
		159,
		157,
		150,
		159,
		154,
		149,
		159,
		161,
		153,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		183,
		158,
		173,
		219,
		214,
		215,
		196,
		193,
		-1,
		163,
		188,
		160,
		167,
		158,
		165,
		165,
		157,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		189,
		175,
		205,
		195,
		201,
		-1,
		-1,
		212,
		209,
		185,
		168,
		166,
		159,
		154,
		164,
		144,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		192,
		201,
		182,
		187,
		195,
		-1,
		-1,
		185,
		182,
		187,
		175,
		172,
		174,
		169,
		160,
		145,
		151,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		205,
		-1,
		-1,
		190,
		208,
		200,
		190,
		184,
		234,
		189,
		184,
		168,
		166,
		157,
		148,
		155,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		206,
		-1,
		227,
		-1,
		202,
		206,
		197,
		200,
		182,
		169,
		161,
		153,
		169,
		144,
		154,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		282,
		237,
		204,
		195,
		242,
		257,
		261,
		-1,
		218,
		257,
		244,
		-1,
		215,
		-1,
		-1,
		-1,
		216,
		210,
		202,
		202,
		181,
		181,
		155,
		159,
		149,
		156,
		166,
		168,
		160,
		164,
		177,
		188,
		191,
		278,
		276,
		281,
		226,
		209,
		227,
		236,
		257,
		233,
		224,
		251,
		251,
		240,
		235,
		222,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		188,
		176,
		159,
		160,
		156,
		159,
		174,
		177,
		167,
		165,
		159,
		191,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		217,
		228,
		-1,
		-1,
		236,
		252,
		265,
		269,
		282,
		307,
		-1,
		225,
		-1,
		-1,
		233,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		164,
		175,
		185,
		173,
		174,
		164,
		174,
		187,
		262,
		259,
		247,
		245,
		268,
		225,
		221,
		-1,
		248,
		239,
		245,
		252,
		269,
		296,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		216,
		214,
		203,
		-1,
		193,
		166,
		171,
		191,
		193,
		182,
		176,
		170,
		177,
		176,
		184,
		192,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		233,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		254,
		250,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		184,
		188,
		180,
		173,
		168,
		179,
		171,
		175,
		192,
		-1,
		305,
		-1,
		257,
		247,
		261,
		276,
		284,
		-1,
		-1,
		-1,
		271,
		257,
		250,
		238,
		236,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		174,
		185,
		174,
		177,
		191,
		186,
		-1,
		-1,
		259,
		262,
		-1,
		-1,
		261,
		263,
		-1,
		262,
		251,
		236,
		228,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		178,
		184,
		187,
		176,
		180,
		192,
		-1,
		-1,
		266,
		267,
		268,
		-1,
		246,
		-1,
		264,
		-1,
		231,
		237,
		225,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		207,
		205,
		196,
		182,
		189,
		187,
		183,
		194,
		-1,
		-1,
		-1,
		264,
		238,
		271,
		262,
		245,
		225,
		217,
		236,
		-1,
		206,
		-1,
		181,
		183,
		209,
		212,
		218,
		212,
		185,
		200,
		190,
		181,
		190,
		270,
		-1,
		240,
		273,
		237,
		231,
		207,
		211,
		227,
		-1,
		203,
		185,
		-1,
		213,
		203,
		234,
		219,
		200,
		187,
		194,
		194,
		187,
		-1,
		-1,
		-1,
		242,
		241,
		233,
		227,
		227,
		212,
		203,
		-1,
		215,
		197,
		176,
		193,
		193,
		184,
		192,
		224,
		220,
		207,
		207,
		199,
		-1,
		343,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		236,
		231,
		204,
		192,
		198,
		194,
		180,
		186,
		188,
		196,
		194,
		191,
		203,
		199,
		219,
		200,
		235,
		-1,
		338,
		-1,
		272,
		-1,
		-1,
		254,
		234,
		226,
		215,
		204,
		202,
		193,
		184,
		206,
		222,
		206,
		204,
		207,
		208,
		-1,
		327,
		326,
		-1,
		273,
		265,
		251,
		-1,
		244,
		-1,
		250,
		211,
		-1,
		213,
		193,
		-1,
		215,
		211,
		-1,
		-1,
		314,
		289,
		-1,
		-1,
		-1,
		274,
		254,
		245,
		229,
		-1,
		204,
		204,
		-1,
		-1,
		-1,
		299,
		298,
		-1,
		267,
		270,
		-1,
		260,
		251,
		259,
		206,
		210,
		-1,
		-1,
		-1,
		308,
		289,
		283,
		282,
		280,
		275,
		272,
		258,
		242,
		220,
		209,
		230,
		-1,
		-1,
		-1,
		280,
		272,
		265,
		-1,
		-1,
		267,
		250,
		231,
		229,
		-1,
		-1,
		-1,
		302,
		283,
		-1,
		-1,
		257,
		-1,
		-1,
		263,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		291,
		-1,
		-1,
		-1,
		253,
		249,
		250,
		-1,
		-1,
		-1,
		-1,
		313,
		314,
		337,
		301,
		-1,
		-1,
		-1,
		245,
		239,
		-1,
		-1,
		316,
		314,
		-1,
		-1,
		-1,
		273,
		257,
		-1,
		243,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		278,
		-1,
		278,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		291,
		283,
		291,
		-1,
		263,
		265,
		-1,
		313,
		-1,
		-1,
		306,
		297,
		-1,
		-1,
		268,
		275,
		297,
		300,
		336,
		-1,
		287
	],
	[
		-1,
		90,
		79,
		90,
		98,
		71,
		78,
		-1,
		99,
		101,
		67,
		61,
		100,
		71,
		77,
		88,
		-1,
		-1,
		-1,
		90,
		89,
		59,
		57,
		66,
		71,
		78,
		-1,
		101,
		-1,
		111,
		90,
		101,
		106,
		52,
		49,
		69,
		88,
		94,
		86,
		126,
		82,
		53,
		47,
		65,
		70,
		88,
		80,
		-1,
		53,
		43,
		65,
		69,
		80,
		64,
		-1,
		-1,
		47,
		48,
		54,
		65,
		71,
		76,
		-1,
		102,
		116,
		-1,
		-1,
		37,
		45,
		46,
		49,
		57,
		71,
		94,
		111,
		111,
		-1,
		-1,
		38,
		42,
		40,
		56,
		52,
		81,
		100,
		106,
		120,
		119,
		-1,
		26,
		29,
		28,
		33,
		39,
		57,
		61,
		79,
		105,
		111,
		114,
		-1,
		40,
		36,
		0,
		9,
		23,
		53,
		60,
		66,
		85,
		93,
		112,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		44,
		35,
		26,
		8,
		22,
		34,
		56,
		63,
		69,
		73,
		85,
		101,
		102,
		112,
		-1,
		-1,
		137,
		110,
		134,
		92,
		74,
		-1,
		40,
		34,
		25,
		26,
		20,
		28,
		53,
		56,
		-1,
		79,
		78,
		109,
		95,
		106,
		119,
		-1,
		-1,
		95,
		87,
		69,
		72,
		49,
		45,
		49,
		48,
		34,
		38,
		45,
		31,
		46,
		46,
		56,
		73,
		83,
		87,
		102,
		113,
		-1,
		-1,
		187,
		-1,
		-1,
		116,
		99,
		-1,
		64,
		71,
		55,
		61,
		47,
		68,
		59,
		43,
		50,
		59,
		48,
		41,
		38,
		62,
		58,
		70,
		95,
		99,
		105,
		123,
		124,
		-1,
		186,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		71,
		68,
		61,
		85,
		84,
		-1,
		90,
		80,
		81,
		66,
		67,
		68,
		54,
		46,
		44,
		59,
		61,
		77,
		79,
		112,
		107,
		128,
		125,
		156,
		162,
		156,
		165,
		-1,
		124,
		120,
		116,
		123,
		72,
		-1,
		-1,
		89,
		-1,
		92,
		105,
		102,
		77,
		80,
		67,
		75,
		75,
		60,
		52,
		47,
		50,
		70,
		83,
		90,
		104,
		103,
		121,
		134,
		149,
		153,
		159,
		-1,
		174,
		-1,
		116,
		100,
		102,
		78,
		106,
		-1,
		109,
		93,
		113,
		104,
		104,
		-1,
		83,
		80,
		90,
		77,
		62,
		65,
		54,
		58,
		69,
		90,
		107,
		98,
		116,
		123,
		131,
		135,
		155,
		167,
		134,
		124,
		-1,
		106,
		111,
		81,
		93,
		116,
		136,
		120,
		-1,
		115,
		-1,
		85,
		98,
		-1,
		83,
		79,
		68,
		76,
		65,
		72,
		76,
		89,
		86,
		104,
		107,
		124,
		128,
		144,
		-1,
		-1,
		119,
		123,
		131,
		82,
		101,
		125,
		162,
		129,
		122,
		121,
		-1,
		103,
		104,
		101,
		102,
		88,
		81,
		82,
		71,
		77,
		86,
		88,
		91,
		113,
		141,
		119,
		131,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		108,
		79,
		103,
		145,
		151,
		144,
		132,
		141,
		140,
		127,
		-1,
		119,
		98,
		95,
		86,
		78,
		94,
		89,
		105,
		92,
		94,
		110,
		122,
		113,
		133,
		-1,
		-1,
		-1,
		138,
		127,
		128,
		82,
		116,
		134,
		174,
		160,
		165,
		140,
		129,
		127,
		113,
		115,
		106,
		95,
		87,
		76,
		92,
		99,
		94,
		94,
		103,
		104,
		128,
		135,
		141,
		-1,
		-1,
		145,
		135,
		119,
		121,
		118,
		107,
		114,
		146,
		165,
		178,
		-1,
		132,
		-1,
		121,
		116,
		100,
		95,
		92,
		89,
		83,
		92,
		100,
		108,
		99,
		114,
		133,
		133,
		125,
		150,
		153,
		-1,
		-1,
		-1,
		138,
		155,
		130,
		107,
		88,
		124,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		102,
		98,
		93,
		97,
		90,
		97,
		93,
		107,
		118,
		100,
		136,
		-1,
		133,
		127,
		155,
		147,
		135,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		95,
		147,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		102,
		100,
		94,
		98,
		102,
		91,
		104,
		109,
		105,
		115,
		135,
		139,
		146,
		137,
		133,
		130,
		144,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		115,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		122,
		106,
		109,
		109,
		105,
		113,
		98,
		101,
		108,
		112,
		130,
		143,
		135,
		129,
		128,
		140,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		130,
		-1,
		101,
		125,
		141,
		-1,
		150,
		129,
		144,
		122,
		118,
		114,
		129,
		130,
		108,
		113,
		112,
		122,
		123,
		112,
		120,
		117,
		139,
		139,
		123,
		124,
		133,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		104,
		112,
		128,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		128,
		126,
		119,
		110,
		116,
		123,
		126,
		127,
		117,
		106,
		112,
		111,
		133,
		119,
		117,
		136,
		152,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		127,
		111,
		116,
		-1,
		152,
		-1,
		125,
		127,
		119,
		108,
		105,
		116,
		114,
		125,
		142,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		161,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		143,
		123,
		117,
		116,
		147,
		145,
		133,
		117,
		110,
		107,
		108,
		121,
		141,
		132,
		144,
		-1,
		-1,
		-1,
		162,
		142,
		148,
		106,
		127,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		160,
		148,
		138,
		128,
		162,
		161,
		136,
		129,
		115,
		117,
		115,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		139,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		160,
		176,
		168,
		139,
		149,
		-1,
		-1,
		140,
		138,
		148,
		132,
		119,
		139,
		142,
		132,
		116,
		131,
		143,
		151,
		156,
		-1,
		142,
		129,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		171,
		173,
		177,
		143,
		-1,
		148,
		143,
		123,
		137,
		144,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		150,
		164,
		166,
		159,
		163,
		-1,
		151,
		139,
		125,
		142,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		168,
		183,
		205,
		182,
		155,
		150,
		143,
		137,
		133,
		149,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		162,
		179,
		194,
		176,
		180,
		232,
		-1,
		-1,
		159,
		150,
		141,
		144,
		143,
		146,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		161,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		195,
		230,
		177,
		159,
		155,
		153,
		146,
		155,
		150,
		145,
		155,
		157,
		149,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		211,
		186,
		201,
		241,
		215,
		222,
		192,
		189,
		-1,
		159,
		184,
		156,
		163,
		154,
		161,
		161,
		153,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		217,
		203,
		227,
		217,
		220,
		-1,
		-1,
		208,
		205,
		181,
		164,
		162,
		155,
		150,
		160,
		140,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		187,
		268,
		261,
		244,
		252,
		283,
		-1,
		220,
		223,
		210,
		209,
		211,
		-1,
		-1,
		181,
		178,
		183,
		171,
		168,
		170,
		165,
		156,
		141,
		147,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		201,
		244,
		238,
		241,
		265,
		279,
		-1,
		228,
		-1,
		-1,
		218,
		212,
		196,
		186,
		180,
		230,
		185,
		180,
		164,
		162,
		153,
		144,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		236,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		234,
		-1,
		223,
		-1,
		198,
		202,
		193,
		196,
		178,
		165,
		157,
		149,
		165,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		299,
		255,
		232,
		223,
		270,
		285,
		289,
		-1,
		240,
		279,
		272,
		-1,
		243,
		-1,
		-1,
		-1,
		212,
		206,
		198,
		198,
		177,
		177,
		151,
		155,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		295,
		286,
		299,
		244,
		237,
		255,
		264,
		285,
		255,
		246,
		273,
		279,
		268,
		263,
		250,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		184,
		172,
		155,
		156,
		152,
		155,
		170,
		173,
		163,
		161,
		155,
		187,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		235,
		256,
		-1,
		-1,
		257,
		274,
		268,
		272,
		288,
		313,
		-1,
		244,
		-1,
		-1,
		229,
		-1,
		-1,
		214,
		177,
		166,
		157,
		163,
		160,
		171,
		181,
		169,
		170,
		160,
		170,
		183,
		272,
		269,
		257,
		255,
		278,
		243,
		231,
		-1,
		244,
		242,
		248,
		255,
		272,
		302,
		-1,
		-1,
		260,
		240,
		-1,
		-1,
		212,
		210,
		199,
		-1,
		189,
		162,
		167,
		187,
		189,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		229,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		250,
		246,
		-1,
		-1,
		207,
		200,
		188,
		176,
		166,
		176,
		180,
		184,
		176,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		315,
		-1,
		267,
		243,
		257,
		272,
		280,
		-1,
		-1,
		-1,
		267,
		253,
		246,
		234,
		232,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		220,
		188,
		193,
		188,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		255,
		258,
		-1,
		-1,
		257,
		259,
		-1,
		258,
		247,
		232,
		224,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		177,
		202,
		191,
		199,
		194,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		262,
		263,
		264,
		-1,
		242,
		-1,
		260,
		-1,
		227,
		233,
		221,
		-1,
		-1,
		-1,
		215,
		178,
		199,
		209,
		203,
		201,
		192,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		260,
		234,
		267,
		258,
		241,
		221,
		213,
		232,
		-1,
		202,
		-1,
		177,
		179,
		205,
		208,
		214,
		208,
		181,
		196,
		186,
		177,
		186,
		266,
		-1,
		236,
		269,
		233,
		227,
		203,
		207,
		223,
		-1,
		199,
		181,
		-1,
		209,
		199,
		230,
		215,
		196,
		183,
		190,
		190,
		183,
		-1,
		-1,
		-1,
		238,
		237,
		229,
		223,
		223,
		208,
		199,
		-1,
		211,
		193,
		172,
		189,
		189,
		180,
		188,
		220,
		216,
		203,
		203,
		195,
		-1,
		339,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		232,
		227,
		200,
		188,
		194,
		190,
		176,
		182,
		184,
		192,
		190,
		187,
		199,
		195,
		215,
		196,
		231,
		-1,
		334,
		-1,
		268,
		-1,
		-1,
		250,
		230,
		222,
		211,
		200,
		198,
		189,
		180,
		202,
		218,
		202,
		200,
		203,
		204,
		-1,
		323,
		322,
		-1,
		269,
		261,
		247,
		-1,
		240,
		-1,
		246,
		207,
		-1,
		209,
		189,
		-1,
		211,
		207,
		-1,
		-1,
		310,
		285,
		-1,
		-1,
		-1,
		270,
		250,
		241,
		225,
		-1,
		200,
		200,
		-1,
		-1,
		-1,
		295,
		294,
		-1,
		263,
		266,
		-1,
		256,
		247,
		255,
		202,
		206,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		278,
		276,
		271,
		268,
		254,
		238,
		216,
		205,
		226,
		-1,
		-1,
		-1,
		276,
		268,
		261,
		-1,
		-1,
		263,
		246,
		227,
		225,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		253,
		-1,
		-1,
		259,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		287,
		-1,
		-1,
		-1,
		249,
		245,
		246,
		-1,
		-1,
		-1,
		-1,
		309,
		310,
		333,
		297,
		-1,
		-1,
		-1,
		241,
		235,
		-1,
		-1,
		312,
		310,
		-1,
		-1,
		-1,
		269,
		253,
		-1,
		239,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		274,
		-1,
		274,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		287,
		279,
		287,
		-1,
		259,
		261,
		-1,
		309,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		264,
		271,
		293,
		296,
		332,
		-1,
		283
	],
	[
		-1,
		97,
		86,
		97,
		105,
		78,
		85,
		-1,
		106,
		108,
		74,
		68,
		107,
		78,
		84,
		95,
		-1,
		-1,
		-1,
		97,
		96,
		66,
		64,
		73,
		78,
		85,
		-1,
		100,
		-1,
		118,
		97,
		108,
		113,
		59,
		56,
		76,
		95,
		92,
		88,
		133,
		89,
		60,
		54,
		72,
		71,
		86,
		78,
		-1,
		60,
		50,
		72,
		60,
		71,
		71,
		-1,
		-1,
		54,
		55,
		61,
		56,
		75,
		69,
		-1,
		93,
		112,
		-1,
		-1,
		44,
		52,
		40,
		54,
		62,
		62,
		85,
		102,
		107,
		-1,
		-1,
		45,
		42,
		31,
		47,
		43,
		72,
		91,
		102,
		116,
		115,
		-1,
		33,
		33,
		19,
		24,
		30,
		48,
		52,
		70,
		101,
		107,
		110,
		-1,
		47,
		43,
		10,
		0,
		14,
		44,
		51,
		57,
		76,
		89,
		108,
		99,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		51,
		42,
		36,
		18,
		28,
		25,
		47,
		54,
		60,
		64,
		81,
		97,
		98,
		108,
		-1,
		-1,
		144,
		117,
		141,
		99,
		81,
		-1,
		47,
		42,
		35,
		32,
		26,
		34,
		44,
		62,
		-1,
		75,
		74,
		105,
		91,
		102,
		126,
		-1,
		-1,
		102,
		94,
		76,
		79,
		56,
		52,
		57,
		56,
		44,
		48,
		51,
		37,
		52,
		52,
		62,
		69,
		79,
		83,
		98,
		109,
		-1,
		-1,
		183,
		-1,
		-1,
		123,
		106,
		-1,
		71,
		78,
		62,
		68,
		54,
		75,
		67,
		53,
		60,
		65,
		54,
		47,
		44,
		68,
		64,
		66,
		91,
		95,
		101,
		119,
		120,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		78,
		75,
		68,
		92,
		91,
		-1,
		97,
		88,
		89,
		74,
		73,
		74,
		60,
		52,
		50,
		65,
		67,
		73,
		75,
		112,
		103,
		124,
		121,
		152,
		158,
		152,
		161,
		-1,
		131,
		127,
		123,
		130,
		79,
		-1,
		-1,
		96,
		-1,
		99,
		112,
		109,
		85,
		88,
		75,
		83,
		81,
		66,
		58,
		53,
		56,
		76,
		81,
		90,
		100,
		99,
		117,
		130,
		145,
		149,
		155,
		-1,
		181,
		-1,
		123,
		107,
		109,
		85,
		113,
		-1,
		116,
		100,
		120,
		111,
		111,
		-1,
		91,
		88,
		98,
		83,
		68,
		71,
		60,
		64,
		75,
		88,
		103,
		94,
		112,
		119,
		127,
		131,
		151,
		163,
		141,
		131,
		-1,
		113,
		118,
		88,
		100,
		123,
		143,
		127,
		-1,
		122,
		-1,
		93,
		106,
		-1,
		89,
		85,
		74,
		82,
		71,
		78,
		82,
		85,
		82,
		100,
		103,
		120,
		124,
		140,
		-1,
		-1,
		126,
		130,
		138,
		89,
		108,
		132,
		169,
		136,
		129,
		128,
		-1,
		111,
		110,
		107,
		108,
		94,
		87,
		88,
		77,
		83,
		92,
		84,
		87,
		109,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		115,
		86,
		110,
		152,
		158,
		151,
		139,
		147,
		147,
		135,
		-1,
		125,
		104,
		101,
		92,
		84,
		100,
		95,
		108,
		88,
		90,
		106,
		118,
		109,
		129,
		-1,
		-1,
		-1,
		145,
		134,
		135,
		89,
		123,
		141,
		180,
		166,
		171,
		146,
		137,
		133,
		119,
		121,
		112,
		101,
		93,
		82,
		98,
		105,
		100,
		90,
		99,
		100,
		124,
		131,
		137,
		-1,
		-1,
		152,
		142,
		126,
		128,
		125,
		114,
		121,
		153,
		171,
		184,
		-1,
		138,
		-1,
		127,
		122,
		106,
		101,
		98,
		95,
		89,
		98,
		106,
		104,
		95,
		110,
		129,
		129,
		121,
		146,
		149,
		-1,
		-1,
		-1,
		145,
		162,
		137,
		114,
		95,
		131,
		-1,
		154,
		155,
		-1,
		132,
		126,
		123,
		108,
		104,
		99,
		103,
		96,
		103,
		99,
		113,
		114,
		96,
		132,
		-1,
		129,
		123,
		151,
		153,
		141,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		102,
		154,
		-1,
		-1,
		139,
		132,
		-1,
		119,
		101,
		108,
		106,
		100,
		104,
		108,
		97,
		110,
		115,
		101,
		111,
		131,
		135,
		142,
		135,
		139,
		136,
		150,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		122,
		-1,
		148,
		140,
		130,
		124,
		118,
		114,
		112,
		128,
		112,
		115,
		115,
		111,
		119,
		104,
		107,
		104,
		108,
		126,
		149,
		141,
		135,
		134,
		146,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		137,
		-1,
		108,
		132,
		148,
		-1,
		156,
		135,
		150,
		128,
		124,
		120,
		135,
		136,
		114,
		119,
		118,
		128,
		129,
		118,
		116,
		120,
		135,
		145,
		129,
		130,
		139,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		111,
		118,
		135,
		-1,
		-1,
		192,
		-1,
		126,
		143,
		134,
		132,
		125,
		116,
		122,
		129,
		132,
		133,
		123,
		112,
		118,
		117,
		139,
		125,
		123,
		142,
		158,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		170,
		160,
		144,
		129,
		162,
		-1,
		133,
		117,
		122,
		-1,
		158,
		-1,
		131,
		133,
		125,
		114,
		111,
		122,
		120,
		131,
		148,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		168,
		-1,
		-1,
		157,
		151,
		151,
		135,
		138,
		149,
		129,
		123,
		122,
		153,
		151,
		139,
		123,
		116,
		113,
		114,
		127,
		147,
		138,
		150,
		-1,
		-1,
		-1,
		169,
		149,
		155,
		113,
		134,
		-1,
		-1,
		219,
		174,
		160,
		-1,
		144,
		166,
		154,
		144,
		134,
		168,
		167,
		142,
		135,
		121,
		123,
		121,
		123,
		128,
		149,
		150,
		163,
		-1,
		-1,
		146,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		166,
		182,
		174,
		145,
		155,
		-1,
		-1,
		146,
		144,
		154,
		138,
		125,
		145,
		148,
		138,
		122,
		137,
		149,
		157,
		162,
		-1,
		149,
		136,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		199,
		165,
		177,
		179,
		183,
		149,
		-1,
		154,
		149,
		129,
		143,
		150,
		140,
		135,
		129,
		132,
		150,
		167,
		-1,
		-1,
		163,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		156,
		170,
		172,
		165,
		169,
		-1,
		157,
		145,
		131,
		148,
		153,
		150,
		141,
		133,
		138,
		135,
		148,
		162,
		166,
		186,
		-1,
		169,
		-1,
		-1,
		-1,
		174,
		189,
		211,
		188,
		161,
		156,
		149,
		143,
		139,
		155,
		161,
		172,
		140,
		136,
		137,
		141,
		140,
		157,
		167,
		-1,
		-1,
		169,
		186,
		200,
		182,
		186,
		238,
		-1,
		-1,
		165,
		156,
		147,
		150,
		149,
		152,
		146,
		143,
		148,
		153,
		141,
		150,
		168,
		167,
		-1,
		-1,
		-1,
		189,
		-1,
		204,
		-1,
		-1,
		201,
		236,
		183,
		165,
		161,
		159,
		152,
		161,
		156,
		151,
		161,
		163,
		155,
		143,
		147,
		170,
		159,
		198,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		218,
		193,
		208,
		247,
		221,
		228,
		198,
		195,
		-1,
		165,
		190,
		162,
		169,
		160,
		167,
		167,
		159,
		137,
		144,
		160,
		159,
		154,
		190,
		181,
		187,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		224,
		210,
		233,
		223,
		226,
		-1,
		-1,
		214,
		211,
		187,
		170,
		168,
		161,
		156,
		166,
		146,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		194,
		275,
		268,
		251,
		259,
		290,
		-1,
		227,
		229,
		217,
		215,
		217,
		-1,
		-1,
		187,
		184,
		189,
		177,
		174,
		176,
		171,
		162,
		147,
		153,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		208,
		251,
		245,
		248,
		272,
		286,
		-1,
		234,
		-1,
		-1,
		225,
		218,
		202,
		192,
		186,
		236,
		191,
		186,
		170,
		168,
		159,
		150,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		243,
		231,
		239,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		241,
		-1,
		229,
		-1,
		204,
		208,
		199,
		202,
		184,
		171,
		163,
		155,
		171,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		305,
		261,
		239,
		230,
		277,
		292,
		296,
		-1,
		246,
		285,
		279,
		-1,
		250,
		-1,
		-1,
		-1,
		218,
		212,
		204,
		204,
		183,
		183,
		157,
		161,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		301,
		292,
		305,
		250,
		244,
		262,
		271,
		292,
		261,
		252,
		279,
		286,
		275,
		270,
		257,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		190,
		178,
		161,
		162,
		158,
		161,
		176,
		179,
		169,
		167,
		161,
		193,
		-1,
		294,
		293,
		282,
		279,
		255,
		246,
		241,
		263,
		-1,
		-1,
		263,
		280,
		274,
		278,
		294,
		319,
		-1,
		250,
		-1,
		-1,
		235,
		-1,
		-1,
		220,
		183,
		172,
		163,
		169,
		166,
		177,
		187,
		175,
		176,
		166,
		176,
		189,
		278,
		275,
		263,
		261,
		284,
		249,
		237,
		-1,
		250,
		248,
		254,
		261,
		278,
		308,
		-1,
		-1,
		266,
		246,
		-1,
		-1,
		218,
		216,
		205,
		-1,
		195,
		168,
		173,
		193,
		195,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		287,
		301,
		290,
		286,
		285,
		293,
		242,
		235,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		-1,
		256,
		252,
		-1,
		-1,
		213,
		206,
		194,
		182,
		172,
		182,
		186,
		190,
		182,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		321,
		-1,
		273,
		249,
		263,
		278,
		286,
		-1,
		-1,
		-1,
		273,
		259,
		252,
		240,
		238,
		-1,
		247,
		231,
		212,
		-1,
		182,
		195,
		226,
		194,
		199,
		194,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		261,
		264,
		-1,
		-1,
		263,
		265,
		-1,
		264,
		253,
		238,
		230,
		-1,
		-1,
		219,
		215,
		-1,
		-1,
		183,
		208,
		197,
		205,
		200,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		268,
		269,
		270,
		-1,
		248,
		-1,
		266,
		-1,
		233,
		239,
		227,
		-1,
		-1,
		-1,
		221,
		184,
		205,
		215,
		209,
		207,
		198,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		266,
		240,
		273,
		264,
		247,
		227,
		219,
		238,
		-1,
		208,
		-1,
		183,
		185,
		211,
		214,
		220,
		214,
		187,
		202,
		192,
		183,
		192,
		272,
		-1,
		242,
		275,
		239,
		233,
		209,
		213,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		236,
		221,
		202,
		189,
		196,
		196,
		189,
		-1,
		-1,
		-1,
		244,
		243,
		235,
		229,
		229,
		214,
		205,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		226,
		222,
		209,
		209,
		201,
		-1,
		345,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		238,
		233,
		206,
		194,
		200,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		202,
		237,
		-1,
		340,
		-1,
		274,
		-1,
		-1,
		256,
		236,
		228,
		217,
		206,
		204,
		195,
		186,
		208,
		224,
		208,
		206,
		209,
		210,
		-1,
		329,
		328,
		-1,
		275,
		267,
		253,
		-1,
		246,
		-1,
		252,
		213,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		316,
		291,
		-1,
		-1,
		-1,
		276,
		256,
		247,
		231,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		301,
		300,
		-1,
		269,
		272,
		-1,
		262,
		253,
		261,
		208,
		212,
		-1,
		-1,
		-1,
		310,
		291,
		285,
		284,
		282,
		277,
		274,
		260,
		244,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		282,
		274,
		267,
		-1,
		-1,
		269,
		252,
		233,
		231,
		-1,
		-1,
		-1,
		304,
		285,
		-1,
		-1,
		259,
		-1,
		-1,
		265,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		321,
		293,
		-1,
		-1,
		-1,
		255,
		251,
		252,
		-1,
		-1,
		-1,
		-1,
		315,
		316,
		339,
		303,
		-1,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		318,
		316,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		245,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		280,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		293,
		285,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		308,
		299,
		-1,
		-1,
		270,
		277,
		299,
		302,
		338,
		-1,
		289
	],
	[
		-1,
		112,
		101,
		112,
		120,
		93,
		100,
		-1,
		121,
		123,
		89,
		83,
		122,
		93,
		99,
		110,
		-1,
		-1,
		-1,
		112,
		111,
		81,
		79,
		88,
		93,
		100,
		-1,
		101,
		-1,
		133,
		112,
		123,
		128,
		74,
		71,
		91,
		110,
		93,
		89,
		148,
		104,
		75,
		69,
		87,
		72,
		87,
		79,
		-1,
		75,
		65,
		83,
		61,
		72,
		73,
		-1,
		-1,
		69,
		70,
		72,
		57,
		76,
		70,
		-1,
		94,
		113,
		-1,
		-1,
		59,
		57,
		41,
		55,
		63,
		63,
		86,
		103,
		108,
		-1,
		-1,
		46,
		43,
		32,
		48,
		44,
		73,
		92,
		103,
		117,
		116,
		-1,
		48,
		41,
		27,
		25,
		31,
		49,
		53,
		71,
		102,
		108,
		111,
		-1,
		64,
		60,
		28,
		18,
		0,
		35,
		52,
		58,
		77,
		90,
		109,
		100,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		66,
		56,
		54,
		36,
		35,
		16,
		38,
		55,
		61,
		65,
		82,
		98,
		99,
		109,
		-1,
		-1,
		159,
		132,
		156,
		114,
		96,
		-1,
		62,
		49,
		43,
		39,
		33,
		41,
		35,
		55,
		-1,
		76,
		75,
		106,
		92,
		103,
		141,
		-1,
		-1,
		117,
		109,
		91,
		94,
		71,
		67,
		64,
		63,
		56,
		60,
		58,
		44,
		51,
		59,
		69,
		70,
		80,
		84,
		99,
		110,
		-1,
		-1,
		184,
		-1,
		-1,
		138,
		121,
		-1,
		86,
		93,
		77,
		83,
		69,
		90,
		74,
		65,
		72,
		72,
		61,
		54,
		51,
		75,
		71,
		67,
		92,
		96,
		102,
		120,
		121,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		93,
		90,
		83,
		107,
		106,
		-1,
		107,
		95,
		96,
		81,
		80,
		81,
		67,
		59,
		57,
		72,
		74,
		74,
		76,
		113,
		104,
		125,
		122,
		153,
		159,
		153,
		162,
		-1,
		146,
		142,
		138,
		145,
		94,
		-1,
		-1,
		111,
		-1,
		114,
		127,
		119,
		92,
		95,
		82,
		90,
		88,
		73,
		65,
		60,
		63,
		83,
		82,
		91,
		101,
		100,
		118,
		131,
		146,
		150,
		156,
		-1,
		196,
		-1,
		138,
		122,
		124,
		100,
		128,
		-1,
		131,
		115,
		135,
		121,
		121,
		-1,
		98,
		95,
		105,
		90,
		75,
		78,
		67,
		71,
		82,
		89,
		104,
		95,
		113,
		120,
		128,
		132,
		152,
		164,
		156,
		146,
		-1,
		128,
		133,
		103,
		115,
		138,
		158,
		142,
		-1,
		132,
		-1,
		100,
		113,
		-1,
		96,
		92,
		81,
		89,
		78,
		85,
		89,
		86,
		83,
		101,
		104,
		121,
		125,
		141,
		-1,
		-1,
		141,
		145,
		153,
		104,
		123,
		147,
		184,
		150,
		139,
		138,
		-1,
		118,
		117,
		114,
		115,
		101,
		94,
		95,
		84,
		90,
		99,
		85,
		88,
		110,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		130,
		101,
		125,
		167,
		168,
		161,
		149,
		154,
		154,
		142,
		-1,
		132,
		111,
		108,
		99,
		91,
		107,
		102,
		109,
		89,
		91,
		107,
		119,
		110,
		130,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		104,
		138,
		156,
		187,
		173,
		178,
		153,
		144,
		140,
		126,
		128,
		119,
		108,
		100,
		89,
		105,
		112,
		107,
		91,
		100,
		101,
		125,
		132,
		138,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		129,
		136,
		168,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		113,
		105,
		96,
		111,
		130,
		130,
		122,
		147,
		150,
		-1,
		-1,
		-1,
		160,
		177,
		152,
		129,
		110,
		146,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		106,
		114,
		115,
		97,
		133,
		-1,
		130,
		124,
		152,
		155,
		145,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		117,
		169,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		115,
		104,
		117,
		122,
		102,
		112,
		132,
		136,
		143,
		136,
		141,
		140,
		154,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		137,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		122,
		118,
		126,
		111,
		114,
		105,
		109,
		127,
		154,
		148,
		142,
		141,
		150,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		152,
		-1,
		123,
		147,
		163,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		121,
		126,
		125,
		135,
		136,
		125,
		117,
		121,
		136,
		146,
		136,
		137,
		146,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		126,
		125,
		150,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		123,
		129,
		136,
		139,
		140,
		130,
		119,
		125,
		124,
		146,
		132,
		130,
		149,
		165,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		167,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		140,
		124,
		129,
		-1,
		165,
		-1,
		138,
		140,
		132,
		121,
		118,
		129,
		127,
		138,
		155,
		-1,
		179,
		164,
		157,
		147,
		161,
		132,
		-1,
		183,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		156,
		136,
		130,
		129,
		160,
		158,
		146,
		130,
		123,
		120,
		121,
		134,
		154,
		145,
		157,
		-1,
		-1,
		-1,
		184,
		164,
		170,
		128,
		149,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		173,
		161,
		151,
		141,
		175,
		174,
		149,
		142,
		128,
		130,
		128,
		130,
		135,
		156,
		157,
		170,
		-1,
		-1,
		161,
		168,
		156,
		142,
		161,
		-1,
		-1,
		-1,
		173,
		189,
		181,
		152,
		162,
		-1,
		-1,
		153,
		151,
		161,
		145,
		132,
		152,
		155,
		145,
		129,
		144,
		156,
		164,
		169,
		-1,
		164,
		151,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		184,
		186,
		190,
		156,
		-1,
		161,
		156,
		136,
		150,
		157,
		147,
		142,
		136,
		139,
		157,
		174,
		-1,
		-1,
		178,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		163,
		177,
		179,
		172,
		176,
		-1,
		164,
		152,
		138,
		155,
		160,
		157,
		148,
		140,
		145,
		142,
		155,
		169,
		173,
		201,
		-1,
		184,
		-1,
		-1,
		-1,
		181,
		196,
		218,
		195,
		168,
		163,
		156,
		150,
		146,
		162,
		168,
		179,
		147,
		143,
		144,
		148,
		147,
		164,
		174,
		-1,
		-1,
		184,
		201,
		207,
		189,
		193,
		245,
		-1,
		-1,
		172,
		163,
		154,
		157,
		156,
		159,
		153,
		150,
		155,
		160,
		148,
		157,
		175,
		174,
		-1,
		-1,
		-1,
		204,
		-1,
		219,
		-1,
		-1,
		208,
		243,
		190,
		172,
		168,
		166,
		159,
		168,
		163,
		158,
		168,
		170,
		162,
		150,
		154,
		177,
		166,
		205,
		-1,
		-1,
		321,
		-1,
		-1,
		-1,
		233,
		208,
		223,
		254,
		228,
		235,
		205,
		202,
		-1,
		172,
		197,
		169,
		176,
		167,
		174,
		174,
		166,
		144,
		151,
		167,
		166,
		161,
		197,
		188,
		194,
		-1,
		-1,
		314,
		303,
		292,
		298,
		-1,
		239,
		225,
		240,
		230,
		233,
		-1,
		-1,
		221,
		218,
		194,
		177,
		175,
		168,
		163,
		173,
		153,
		140,
		144,
		148,
		154,
		159,
		164,
		170,
		185,
		200,
		-1,
		209,
		290,
		283,
		266,
		274,
		305,
		-1,
		242,
		236,
		232,
		222,
		224,
		-1,
		-1,
		194,
		191,
		196,
		184,
		181,
		183,
		178,
		169,
		154,
		160,
		147,
		146,
		164,
		168,
		177,
		184,
		174,
		187,
		191,
		-1,
		223,
		266,
		260,
		263,
		287,
		301,
		-1,
		241,
		-1,
		-1,
		240,
		225,
		209,
		199,
		193,
		243,
		198,
		193,
		177,
		175,
		166,
		157,
		164,
		155,
		155,
		158,
		173,
		178,
		170,
		184,
		184,
		185,
		-1,
		258,
		246,
		254,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		256,
		-1,
		236,
		-1,
		211,
		215,
		206,
		209,
		191,
		178,
		170,
		162,
		178,
		153,
		163,
		159,
		160,
		169,
		180,
		192,
		191,
		192,
		312,
		268,
		254,
		245,
		292,
		307,
		311,
		-1,
		253,
		292,
		290,
		-1,
		265,
		-1,
		-1,
		-1,
		225,
		219,
		211,
		211,
		190,
		190,
		164,
		168,
		158,
		165,
		175,
		177,
		169,
		173,
		186,
		197,
		200,
		308,
		299,
		312,
		257,
		257,
		277,
		286,
		307,
		268,
		259,
		286,
		297,
		286,
		281,
		268,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		197,
		185,
		168,
		169,
		165,
		168,
		183,
		186,
		176,
		174,
		168,
		200,
		-1,
		301,
		300,
		289,
		286,
		262,
		253,
		248,
		275,
		-1,
		-1,
		270,
		287,
		281,
		285,
		301,
		326,
		-1,
		257,
		-1,
		-1,
		242,
		-1,
		-1,
		227,
		190,
		179,
		170,
		176,
		173,
		184,
		194,
		182,
		183,
		173,
		183,
		196,
		285,
		282,
		270,
		268,
		291,
		256,
		244,
		-1,
		257,
		255,
		261,
		268,
		285,
		315,
		-1,
		-1,
		273,
		253,
		-1,
		-1,
		225,
		223,
		212,
		-1,
		202,
		175,
		180,
		200,
		202,
		191,
		185,
		179,
		186,
		185,
		193,
		201,
		294,
		308,
		297,
		293,
		292,
		300,
		249,
		242,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		-1,
		263,
		259,
		-1,
		-1,
		220,
		213,
		201,
		189,
		179,
		189,
		193,
		197,
		189,
		182,
		177,
		188,
		180,
		184,
		201,
		-1,
		328,
		-1,
		280,
		256,
		270,
		285,
		293,
		-1,
		-1,
		-1,
		280,
		266,
		259,
		247,
		245,
		-1,
		254,
		238,
		219,
		-1,
		189,
		202,
		233,
		201,
		206,
		201,
		183,
		194,
		183,
		186,
		200,
		195,
		-1,
		-1,
		268,
		271,
		-1,
		-1,
		270,
		272,
		-1,
		271,
		260,
		245,
		237,
		-1,
		-1,
		226,
		222,
		-1,
		-1,
		190,
		215,
		204,
		212,
		207,
		187,
		193,
		196,
		185,
		189,
		201,
		-1,
		-1,
		275,
		276,
		277,
		-1,
		255,
		-1,
		273,
		-1,
		240,
		246,
		234,
		-1,
		-1,
		-1,
		228,
		191,
		212,
		222,
		216,
		214,
		205,
		191,
		198,
		196,
		192,
		203,
		-1,
		-1,
		-1,
		273,
		247,
		280,
		271,
		254,
		234,
		226,
		245,
		-1,
		215,
		-1,
		190,
		192,
		218,
		221,
		227,
		221,
		194,
		209,
		199,
		190,
		199,
		279,
		-1,
		249,
		282,
		246,
		240,
		216,
		220,
		236,
		-1,
		212,
		194,
		-1,
		222,
		212,
		243,
		228,
		209,
		196,
		203,
		203,
		196,
		-1,
		-1,
		-1,
		251,
		250,
		242,
		236,
		236,
		221,
		212,
		-1,
		224,
		206,
		185,
		202,
		202,
		193,
		201,
		233,
		229,
		216,
		216,
		208,
		-1,
		352,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		245,
		240,
		213,
		201,
		207,
		203,
		189,
		195,
		197,
		205,
		203,
		200,
		212,
		208,
		228,
		209,
		244,
		-1,
		347,
		-1,
		281,
		-1,
		-1,
		263,
		243,
		235,
		224,
		213,
		211,
		202,
		193,
		215,
		231,
		215,
		213,
		216,
		217,
		-1,
		336,
		335,
		-1,
		282,
		274,
		260,
		-1,
		253,
		-1,
		259,
		220,
		-1,
		222,
		202,
		-1,
		224,
		220,
		-1,
		-1,
		323,
		298,
		-1,
		-1,
		-1,
		283,
		263,
		254,
		238,
		-1,
		213,
		213,
		-1,
		-1,
		-1,
		308,
		307,
		-1,
		276,
		279,
		-1,
		269,
		260,
		268,
		215,
		219,
		-1,
		-1,
		-1,
		317,
		298,
		292,
		291,
		289,
		284,
		281,
		267,
		251,
		229,
		218,
		239,
		-1,
		-1,
		-1,
		289,
		281,
		274,
		-1,
		-1,
		276,
		259,
		240,
		238,
		-1,
		-1,
		-1,
		311,
		292,
		-1,
		-1,
		266,
		-1,
		-1,
		272,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		328,
		300,
		-1,
		-1,
		-1,
		262,
		258,
		259,
		-1,
		-1,
		-1,
		-1,
		322,
		323,
		346,
		310,
		-1,
		-1,
		-1,
		254,
		248,
		-1,
		-1,
		325,
		323,
		-1,
		-1,
		-1,
		282,
		266,
		-1,
		252,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		287,
		-1,
		287,
		262,
		269,
		-1,
		-1,
		-1,
		-1,
		300,
		292,
		300,
		-1,
		272,
		274,
		-1,
		322,
		-1,
		-1,
		315,
		306,
		-1,
		-1,
		277,
		284,
		306,
		309,
		345,
		-1,
		296
	],
	[
		-1,
		103,
		92,
		103,
		111,
		84,
		91,
		-1,
		110,
		114,
		80,
		74,
		113,
		82,
		88,
		99,
		-1,
		-1,
		-1,
		103,
		102,
		70,
		68,
		77,
		82,
		89,
		-1,
		82,
		-1,
		124,
		103,
		114,
		119,
		63,
		60,
		80,
		94,
		75,
		67,
		139,
		93,
		64,
		58,
		76,
		66,
		69,
		61,
		-1,
		64,
		54,
		76,
		55,
		63,
		45,
		-1,
		-1,
		58,
		59,
		65,
		51,
		50,
		42,
		-1,
		63,
		82,
		-1,
		-1,
		48,
		49,
		33,
		36,
		38,
		37,
		55,
		72,
		77,
		-1,
		-1,
		39,
		35,
		42,
		29,
		25,
		42,
		61,
		72,
		86,
		85,
		-1,
		51,
		64,
		53,
		32,
		19,
		18,
		22,
		40,
		71,
		77,
		80,
		-1,
		68,
		64,
		51,
		41,
		33,
		0,
		21,
		27,
		46,
		59,
		78,
		69,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		69,
		60,
		66,
		48,
		40,
		21,
		19,
		24,
		30,
		34,
		51,
		67,
		68,
		78,
		-1,
		-1,
		162,
		135,
		159,
		117,
		99,
		-1,
		65,
		54,
		48,
		44,
		38,
		46,
		21,
		40,
		-1,
		45,
		44,
		75,
		61,
		72,
		144,
		-1,
		-1,
		120,
		112,
		94,
		97,
		74,
		70,
		69,
		68,
		61,
		65,
		63,
		49,
		46,
		55,
		62,
		39,
		49,
		53,
		68,
		79,
		-1,
		-1,
		153,
		-1,
		-1,
		141,
		124,
		-1,
		89,
		96,
		80,
		86,
		72,
		93,
		79,
		70,
		77,
		77,
		66,
		52,
		51,
		69,
		61,
		36,
		61,
		65,
		71,
		89,
		90,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		96,
		93,
		86,
		110,
		109,
		-1,
		112,
		100,
		101,
		86,
		85,
		86,
		72,
		59,
		57,
		61,
		58,
		43,
		45,
		82,
		73,
		94,
		91,
		122,
		128,
		122,
		131,
		-1,
		149,
		145,
		141,
		148,
		97,
		-1,
		-1,
		114,
		-1,
		117,
		130,
		124,
		97,
		100,
		87,
		95,
		93,
		78,
		65,
		59,
		56,
		55,
		51,
		60,
		70,
		69,
		87,
		100,
		115,
		119,
		125,
		-1,
		199,
		-1,
		141,
		125,
		127,
		103,
		131,
		-1,
		134,
		118,
		138,
		126,
		126,
		-1,
		103,
		100,
		110,
		95,
		80,
		71,
		59,
		54,
		54,
		58,
		73,
		64,
		82,
		89,
		97,
		101,
		121,
		133,
		159,
		149,
		-1,
		131,
		136,
		106,
		118,
		141,
		161,
		145,
		-1,
		137,
		-1,
		105,
		118,
		-1,
		101,
		97,
		79,
		67,
		56,
		63,
		61,
		55,
		52,
		70,
		73,
		90,
		94,
		110,
		-1,
		-1,
		144,
		148,
		156,
		107,
		126,
		150,
		187,
		154,
		144,
		143,
		-1,
		123,
		115,
		112,
		109,
		96,
		81,
		79,
		62,
		68,
		69,
		54,
		57,
		79,
		107,
		85,
		97,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		133,
		104,
		128,
		170,
		173,
		166,
		154,
		132,
		132,
		126,
		-1,
		120,
		99,
		90,
		79,
		69,
		85,
		75,
		78,
		58,
		60,
		76,
		88,
		79,
		99,
		-1,
		-1,
		-1,
		163,
		152,
		153,
		107,
		141,
		159,
		165,
		151,
		156,
		131,
		124,
		118,
		124,
		116,
		97,
		86,
		78,
		67,
		76,
		86,
		80,
		60,
		69,
		70,
		94,
		101,
		107,
		-1,
		-1,
		170,
		160,
		144,
		146,
		143,
		132,
		139,
		171,
		156,
		169,
		-1,
		123,
		-1,
		112,
		107,
		91,
		86,
		83,
		80,
		74,
		83,
		88,
		74,
		65,
		80,
		99,
		99,
		91,
		116,
		119,
		-1,
		-1,
		-1,
		163,
		180,
		155,
		132,
		113,
		149,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		93,
		89,
		84,
		88,
		81,
		88,
		84,
		83,
		84,
		66,
		102,
		-1,
		99,
		93,
		121,
		124,
		114,
		-1,
		-1,
		-1,
		178,
		157,
		150,
		170,
		120,
		172,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		93,
		91,
		85,
		89,
		93,
		82,
		95,
		91,
		71,
		81,
		101,
		105,
		112,
		105,
		110,
		109,
		123,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		140,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		113,
		97,
		100,
		100,
		96,
		104,
		89,
		88,
		74,
		78,
		96,
		123,
		118,
		113,
		112,
		119,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		105,
		120,
		121,
		99,
		104,
		103,
		113,
		110,
		99,
		86,
		90,
		105,
		115,
		107,
		108,
		117,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		119,
		117,
		110,
		101,
		107,
		114,
		117,
		114,
		104,
		93,
		99,
		95,
		117,
		103,
		101,
		120,
		135,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		118,
		102,
		107,
		-1,
		139,
		-1,
		112,
		112,
		103,
		92,
		89,
		100,
		98,
		109,
		126,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		134,
		114,
		108,
		107,
		134,
		129,
		120,
		101,
		94,
		91,
		92,
		105,
		125,
		116,
		128,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		151,
		139,
		129,
		119,
		153,
		145,
		120,
		113,
		99,
		101,
		99,
		101,
		106,
		127,
		128,
		141,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		140,
		-1,
		-1,
		131,
		129,
		137,
		116,
		103,
		123,
		126,
		116,
		100,
		115,
		127,
		135,
		140,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		162,
		157,
		161,
		134,
		-1,
		133,
		127,
		107,
		121,
		128,
		118,
		113,
		107,
		110,
		128,
		145,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		141,
		155,
		150,
		143,
		147,
		-1,
		135,
		123,
		109,
		126,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		140,
		144,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		159,
		174,
		189,
		166,
		139,
		134,
		127,
		121,
		117,
		133,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		135,
		145,
		-1,
		-1,
		173,
		190,
		185,
		167,
		171,
		216,
		-1,
		-1,
		143,
		134,
		125,
		128,
		127,
		130,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		145,
		-1,
		-1,
		-1,
		193,
		-1,
		208,
		-1,
		-1,
		186,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		141,
		133,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		222,
		197,
		212,
		225,
		206,
		213,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		138,
		145,
		145,
		137,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		305,
		294,
		283,
		289,
		-1,
		225,
		214,
		211,
		201,
		204,
		-1,
		-1,
		192,
		189,
		165,
		148,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		200,
		281,
		274,
		257,
		265,
		296,
		-1,
		215,
		207,
		218,
		193,
		195,
		-1,
		-1,
		165,
		162,
		167,
		155,
		152,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		214,
		257,
		251,
		254,
		278,
		292,
		-1,
		212,
		-1,
		-1,
		224,
		196,
		180,
		170,
		164,
		214,
		169,
		164,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		249,
		237,
		245,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		240,
		-1,
		207,
		-1,
		182,
		186,
		177,
		180,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		283,
		239,
		242,
		236,
		264,
		279,
		283,
		-1,
		224,
		263,
		261,
		-1,
		245,
		-1,
		-1,
		-1,
		196,
		190,
		182,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		279,
		270,
		283,
		228,
		228,
		249,
		258,
		279,
		239,
		230,
		257,
		268,
		257,
		252,
		239,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		272,
		271,
		260,
		257,
		233,
		224,
		219,
		246,
		-1,
		-1,
		241,
		258,
		252,
		256,
		272,
		297,
		-1,
		228,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		256,
		253,
		241,
		239,
		262,
		227,
		215,
		-1,
		228,
		226,
		232,
		239,
		256,
		286,
		-1,
		-1,
		244,
		224,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		265,
		279,
		268,
		264,
		263,
		271,
		220,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		230,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		299,
		-1,
		251,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		246,
		247,
		248,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		89,
		78,
		89,
		97,
		70,
		77,
		-1,
		96,
		100,
		66,
		60,
		99,
		68,
		74,
		85,
		-1,
		-1,
		-1,
		89,
		88,
		56,
		54,
		63,
		68,
		75,
		-1,
		74,
		-1,
		110,
		89,
		100,
		105,
		49,
		46,
		66,
		85,
		67,
		59,
		125,
		79,
		50,
		44,
		62,
		52,
		61,
		53,
		-1,
		50,
		40,
		62,
		41,
		52,
		44,
		-1,
		-1,
		44,
		45,
		51,
		37,
		43,
		39,
		-1,
		49,
		68,
		-1,
		-1,
		34,
		35,
		19,
		22,
		30,
		28,
		41,
		58,
		63,
		-1,
		-1,
		25,
		21,
		28,
		15,
		11,
		28,
		47,
		58,
		72,
		71,
		-1,
		37,
		54,
		54,
		22,
		20,
		4,
		8,
		26,
		57,
		63,
		66,
		-1,
		54,
		50,
		57,
		49,
		44,
		20,
		0,
		13,
		32,
		45,
		64,
		55,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		55,
		46,
		63,
		65,
		60,
		41,
		39,
		9,
		16,
		20,
		37,
		53,
		54,
		64,
		-1,
		-1,
		148,
		121,
		145,
		103,
		85,
		-1,
		51,
		53,
		59,
		63,
		58,
		51,
		41,
		25,
		-1,
		31,
		30,
		61,
		47,
		58,
		130,
		-1,
		-1,
		106,
		98,
		80,
		83,
		60,
		56,
		68,
		67,
		63,
		65,
		67,
		48,
		33,
		46,
		53,
		25,
		35,
		39,
		54,
		65,
		-1,
		-1,
		139,
		-1,
		-1,
		127,
		110,
		-1,
		75,
		82,
		66,
		72,
		58,
		79,
		78,
		72,
		79,
		79,
		70,
		46,
		43,
		60,
		47,
		22,
		47,
		51,
		57,
		75,
		76,
		-1,
		138,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		82,
		79,
		72,
		96,
		95,
		-1,
		101,
		99,
		105,
		90,
		92,
		88,
		76,
		51,
		47,
		47,
		44,
		29,
		31,
		68,
		59,
		80,
		77,
		108,
		114,
		108,
		117,
		-1,
		135,
		131,
		127,
		134,
		83,
		-1,
		-1,
		100,
		-1,
		103,
		116,
		113,
		101,
		104,
		91,
		99,
		93,
		75,
		57,
		45,
		42,
		41,
		37,
		46,
		56,
		55,
		73,
		86,
		101,
		105,
		111,
		-1,
		185,
		-1,
		127,
		111,
		113,
		89,
		117,
		-1,
		120,
		104,
		124,
		115,
		115,
		-1,
		107,
		104,
		111,
		89,
		74,
		57,
		45,
		40,
		40,
		44,
		59,
		50,
		68,
		75,
		83,
		87,
		107,
		119,
		145,
		135,
		-1,
		117,
		122,
		92,
		104,
		127,
		147,
		131,
		-1,
		126,
		-1,
		109,
		122,
		-1,
		95,
		91,
		65,
		53,
		42,
		49,
		47,
		41,
		38,
		56,
		59,
		76,
		80,
		96,
		-1,
		-1,
		130,
		134,
		142,
		93,
		112,
		136,
		173,
		140,
		133,
		132,
		-1,
		127,
		101,
		98,
		95,
		82,
		67,
		65,
		48,
		54,
		55,
		40,
		43,
		65,
		93,
		71,
		83,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		119,
		90,
		114,
		156,
		162,
		155,
		143,
		118,
		118,
		112,
		-1,
		106,
		85,
		76,
		65,
		55,
		71,
		61,
		64,
		44,
		46,
		62,
		74,
		65,
		85,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		93,
		127,
		145,
		151,
		137,
		142,
		117,
		110,
		104,
		110,
		102,
		83,
		72,
		64,
		53,
		62,
		72,
		66,
		46,
		55,
		56,
		80,
		87,
		93,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		118,
		125,
		157,
		142,
		155,
		-1,
		109,
		-1,
		98,
		93,
		77,
		72,
		69,
		66,
		60,
		69,
		74,
		60,
		51,
		66,
		85,
		85,
		77,
		102,
		105,
		-1,
		-1,
		-1,
		149,
		166,
		141,
		118,
		99,
		135,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		79,
		75,
		70,
		74,
		67,
		74,
		70,
		69,
		70,
		52,
		88,
		-1,
		85,
		79,
		107,
		110,
		100,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		106,
		158,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		79,
		77,
		71,
		75,
		79,
		68,
		81,
		77,
		57,
		67,
		87,
		91,
		98,
		91,
		96,
		95,
		109,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		126,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		99,
		83,
		86,
		86,
		82,
		90,
		75,
		74,
		60,
		64,
		82,
		109,
		104,
		99,
		98,
		105,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		95,
		91,
		106,
		107,
		85,
		90,
		89,
		99,
		96,
		85,
		72,
		76,
		91,
		101,
		93,
		94,
		103,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		105,
		103,
		96,
		87,
		93,
		100,
		103,
		100,
		90,
		79,
		85,
		81,
		103,
		89,
		87,
		106,
		121,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		104,
		88,
		93,
		-1,
		125,
		-1,
		98,
		98,
		89,
		78,
		75,
		86,
		84,
		95,
		112,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		120,
		100,
		94,
		93,
		120,
		115,
		106,
		87,
		80,
		77,
		78,
		91,
		111,
		102,
		114,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		137,
		125,
		115,
		105,
		139,
		131,
		106,
		99,
		85,
		87,
		85,
		87,
		92,
		113,
		114,
		127,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		126,
		-1,
		-1,
		117,
		115,
		123,
		102,
		89,
		109,
		112,
		102,
		86,
		101,
		113,
		121,
		126,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		148,
		143,
		147,
		120,
		-1,
		119,
		113,
		93,
		107,
		114,
		104,
		99,
		93,
		96,
		114,
		131,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		136,
		129,
		133,
		-1,
		121,
		109,
		95,
		112,
		117,
		114,
		105,
		97,
		102,
		99,
		112,
		126,
		130,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		145,
		160,
		175,
		152,
		125,
		120,
		113,
		107,
		103,
		119,
		125,
		136,
		104,
		100,
		101,
		105,
		104,
		121,
		131,
		-1,
		-1,
		159,
		176,
		171,
		153,
		157,
		202,
		-1,
		-1,
		129,
		120,
		111,
		114,
		113,
		116,
		110,
		107,
		112,
		117,
		105,
		114,
		132,
		131,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		172,
		200,
		147,
		129,
		125,
		123,
		116,
		125,
		120,
		115,
		125,
		127,
		119,
		107,
		111,
		134,
		123,
		162,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		211,
		192,
		199,
		162,
		159,
		-1,
		129,
		154,
		126,
		133,
		124,
		131,
		131,
		123,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		291,
		280,
		269,
		275,
		-1,
		211,
		200,
		197,
		187,
		190,
		-1,
		-1,
		178,
		175,
		151,
		134,
		132,
		125,
		120,
		130,
		110,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		186,
		267,
		260,
		243,
		251,
		282,
		-1,
		201,
		193,
		204,
		179,
		181,
		-1,
		-1,
		151,
		148,
		153,
		141,
		138,
		140,
		135,
		126,
		111,
		117,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		200,
		243,
		237,
		240,
		264,
		278,
		-1,
		198,
		-1,
		-1,
		210,
		182,
		166,
		156,
		150,
		200,
		155,
		150,
		134,
		132,
		123,
		114,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		235,
		223,
		231,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		226,
		-1,
		193,
		-1,
		168,
		172,
		163,
		166,
		148,
		135,
		127,
		119,
		135,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		269,
		225,
		228,
		222,
		250,
		265,
		269,
		-1,
		210,
		249,
		247,
		-1,
		231,
		-1,
		-1,
		-1,
		182,
		176,
		168,
		168,
		147,
		147,
		121,
		125,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		265,
		256,
		269,
		214,
		214,
		235,
		244,
		265,
		225,
		216,
		243,
		254,
		243,
		238,
		225,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		154,
		142,
		125,
		126,
		122,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		205,
		232,
		-1,
		-1,
		227,
		244,
		238,
		242,
		258,
		283,
		-1,
		214,
		-1,
		-1,
		199,
		-1,
		-1,
		184,
		147,
		136,
		127,
		133,
		130,
		141,
		151,
		139,
		140,
		130,
		140,
		153,
		242,
		239,
		227,
		225,
		248,
		213,
		201,
		-1,
		214,
		212,
		218,
		225,
		242,
		272,
		-1,
		-1,
		230,
		210,
		-1,
		-1,
		182,
		180,
		169,
		-1,
		159,
		132,
		137,
		157,
		159,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		199,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		216,
		-1,
		-1,
		177,
		170,
		158,
		146,
		136,
		146,
		150,
		154,
		146,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		285,
		-1,
		237,
		213,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		211,
		195,
		176,
		-1,
		146,
		159,
		190,
		158,
		163,
		158,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		225,
		228,
		-1,
		-1,
		227,
		229,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		183,
		179,
		-1,
		-1,
		147,
		172,
		161,
		169,
		164,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		232,
		233,
		234,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		185,
		148,
		169,
		179,
		173,
		171,
		162,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		149,
		175,
		178,
		184,
		178,
		151,
		166,
		156,
		147,
		156,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		200,
		185,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		190,
		186,
		173,
		173,
		165,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		166,
		201,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		173,
		174,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		92,
		81,
		92,
		100,
		73,
		80,
		-1,
		99,
		103,
		69,
		63,
		102,
		71,
		77,
		88,
		-1,
		-1,
		-1,
		92,
		91,
		59,
		57,
		66,
		71,
		78,
		-1,
		77,
		-1,
		113,
		92,
		103,
		108,
		52,
		49,
		69,
		88,
		70,
		62,
		128,
		82,
		53,
		47,
		65,
		55,
		64,
		56,
		-1,
		53,
		43,
		65,
		44,
		55,
		47,
		-1,
		-1,
		47,
		48,
		54,
		40,
		46,
		42,
		-1,
		52,
		61,
		-1,
		-1,
		37,
		38,
		22,
		25,
		33,
		31,
		44,
		61,
		56,
		-1,
		-1,
		28,
		24,
		31,
		18,
		14,
		31,
		43,
		51,
		65,
		64,
		-1,
		40,
		57,
		57,
		25,
		23,
		7,
		4,
		22,
		50,
		56,
		63,
		-1,
		57,
		53,
		60,
		52,
		47,
		23,
		10,
		0,
		19,
		38,
		59,
		54,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		58,
		49,
		66,
		68,
		63,
		44,
		42,
		13,
		3,
		7,
		29,
		48,
		53,
		63,
		-1,
		-1,
		151,
		124,
		148,
		106,
		88,
		-1,
		54,
		56,
		62,
		66,
		61,
		55,
		44,
		29,
		-1,
		30,
		22,
		58,
		46,
		57,
		133,
		-1,
		-1,
		109,
		101,
		83,
		86,
		63,
		59,
		71,
		70,
		66,
		68,
		70,
		52,
		37,
		50,
		57,
		21,
		34,
		38,
		53,
		64,
		-1,
		-1,
		142,
		-1,
		-1,
		130,
		113,
		-1,
		78,
		85,
		69,
		75,
		61,
		82,
		81,
		75,
		82,
		83,
		73,
		50,
		47,
		64,
		50,
		25,
		45,
		49,
		56,
		74,
		75,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		85,
		82,
		75,
		99,
		98,
		-1,
		104,
		102,
		108,
		93,
		96,
		92,
		79,
		55,
		50,
		50,
		47,
		32,
		34,
		71,
		58,
		79,
		76,
		107,
		117,
		111,
		120,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		103,
		-1,
		106,
		119,
		116,
		104,
		107,
		94,
		102,
		96,
		79,
		61,
		48,
		45,
		44,
		40,
		49,
		59,
		58,
		76,
		85,
		104,
		108,
		114,
		-1,
		188,
		-1,
		130,
		114,
		116,
		92,
		120,
		-1,
		123,
		107,
		127,
		118,
		118,
		-1,
		110,
		107,
		114,
		92,
		77,
		60,
		48,
		43,
		43,
		47,
		62,
		53,
		71,
		78,
		86,
		90,
		110,
		122,
		148,
		138,
		-1,
		120,
		125,
		95,
		107,
		130,
		150,
		134,
		-1,
		129,
		-1,
		112,
		125,
		-1,
		98,
		94,
		68,
		56,
		45,
		52,
		50,
		44,
		41,
		59,
		62,
		79,
		83,
		99,
		-1,
		-1,
		133,
		137,
		145,
		96,
		115,
		139,
		176,
		143,
		136,
		135,
		-1,
		130,
		104,
		101,
		98,
		85,
		70,
		68,
		51,
		57,
		58,
		43,
		46,
		68,
		96,
		74,
		86,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		122,
		93,
		117,
		159,
		165,
		158,
		146,
		121,
		121,
		115,
		-1,
		109,
		88,
		79,
		68,
		58,
		74,
		64,
		67,
		47,
		49,
		65,
		77,
		68,
		88,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		96,
		130,
		148,
		154,
		140,
		145,
		120,
		113,
		107,
		113,
		105,
		86,
		75,
		67,
		56,
		65,
		75,
		69,
		49,
		58,
		59,
		83,
		90,
		96,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		121,
		128,
		160,
		145,
		158,
		-1,
		112,
		-1,
		101,
		96,
		80,
		75,
		72,
		69,
		63,
		72,
		77,
		63,
		54,
		69,
		88,
		88,
		80,
		105,
		108,
		-1,
		-1,
		-1,
		152,
		169,
		144,
		121,
		102,
		138,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		82,
		78,
		73,
		77,
		70,
		77,
		73,
		72,
		73,
		55,
		91,
		-1,
		88,
		82,
		110,
		113,
		103,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		109,
		161,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		82,
		80,
		74,
		78,
		82,
		71,
		84,
		80,
		60,
		70,
		90,
		94,
		101,
		94,
		99,
		98,
		112,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		129,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		102,
		86,
		89,
		89,
		85,
		93,
		78,
		77,
		63,
		67,
		85,
		112,
		107,
		102,
		101,
		108,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		94,
		109,
		110,
		88,
		93,
		92,
		102,
		99,
		88,
		75,
		79,
		94,
		104,
		96,
		97,
		106,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		108,
		106,
		99,
		90,
		96,
		103,
		106,
		103,
		93,
		82,
		88,
		84,
		106,
		92,
		90,
		109,
		124,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		107,
		91,
		96,
		-1,
		128,
		-1,
		101,
		101,
		92,
		81,
		78,
		89,
		87,
		98,
		115,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		123,
		103,
		97,
		96,
		123,
		118,
		109,
		90,
		83,
		80,
		81,
		94,
		114,
		105,
		117,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		140,
		128,
		118,
		108,
		142,
		134,
		109,
		102,
		88,
		90,
		88,
		90,
		95,
		116,
		117,
		130,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		129,
		-1,
		-1,
		120,
		118,
		126,
		105,
		92,
		112,
		115,
		105,
		89,
		104,
		116,
		124,
		129,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		151,
		146,
		150,
		123,
		-1,
		122,
		116,
		96,
		110,
		117,
		107,
		102,
		96,
		99,
		117,
		134,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		130,
		144,
		139,
		132,
		136,
		-1,
		124,
		112,
		98,
		115,
		120,
		117,
		108,
		100,
		105,
		102,
		115,
		129,
		133,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		148,
		163,
		178,
		155,
		128,
		123,
		116,
		110,
		106,
		122,
		128,
		139,
		107,
		103,
		104,
		108,
		107,
		124,
		134,
		-1,
		-1,
		162,
		179,
		174,
		156,
		160,
		205,
		-1,
		-1,
		132,
		123,
		114,
		117,
		116,
		119,
		113,
		110,
		115,
		120,
		108,
		117,
		135,
		134,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		175,
		203,
		150,
		132,
		128,
		126,
		119,
		128,
		123,
		118,
		128,
		130,
		122,
		110,
		114,
		137,
		126,
		165,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		211,
		186,
		201,
		214,
		195,
		202,
		165,
		162,
		-1,
		132,
		157,
		129,
		136,
		127,
		134,
		134,
		126,
		104,
		111,
		127,
		126,
		121,
		157,
		148,
		154,
		-1,
		-1,
		294,
		283,
		272,
		278,
		-1,
		214,
		203,
		200,
		190,
		193,
		-1,
		-1,
		181,
		178,
		154,
		137,
		135,
		128,
		123,
		133,
		113,
		100,
		104,
		108,
		114,
		119,
		124,
		130,
		145,
		160,
		-1,
		189,
		270,
		263,
		246,
		254,
		285,
		-1,
		204,
		196,
		207,
		182,
		184,
		-1,
		-1,
		154,
		151,
		156,
		144,
		141,
		143,
		138,
		129,
		114,
		120,
		107,
		106,
		124,
		128,
		137,
		144,
		134,
		147,
		151,
		-1,
		203,
		246,
		240,
		243,
		267,
		281,
		-1,
		201,
		-1,
		-1,
		213,
		185,
		169,
		159,
		153,
		203,
		158,
		153,
		137,
		135,
		126,
		117,
		124,
		115,
		115,
		118,
		133,
		138,
		130,
		144,
		144,
		145,
		-1,
		238,
		226,
		234,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		229,
		-1,
		196,
		-1,
		171,
		175,
		166,
		169,
		151,
		138,
		130,
		122,
		138,
		113,
		123,
		119,
		120,
		129,
		140,
		152,
		151,
		152,
		272,
		228,
		231,
		225,
		253,
		268,
		272,
		-1,
		213,
		252,
		250,
		-1,
		234,
		-1,
		-1,
		-1,
		185,
		179,
		171,
		171,
		150,
		150,
		124,
		128,
		118,
		125,
		135,
		137,
		129,
		133,
		146,
		157,
		160,
		268,
		259,
		272,
		217,
		217,
		238,
		247,
		268,
		228,
		219,
		246,
		257,
		246,
		241,
		228,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		157,
		145,
		128,
		129,
		125,
		128,
		143,
		146,
		136,
		134,
		128,
		160,
		-1,
		261,
		260,
		249,
		246,
		222,
		213,
		208,
		235,
		-1,
		-1,
		230,
		247,
		241,
		245,
		261,
		286,
		-1,
		217,
		-1,
		-1,
		202,
		-1,
		-1,
		187,
		150,
		139,
		130,
		136,
		133,
		144,
		154,
		142,
		143,
		133,
		143,
		156,
		245,
		242,
		230,
		228,
		251,
		216,
		204,
		-1,
		217,
		215,
		221,
		228,
		245,
		275,
		-1,
		-1,
		233,
		213,
		-1,
		-1,
		185,
		183,
		172,
		-1,
		162,
		135,
		140,
		160,
		162,
		151,
		145,
		139,
		146,
		145,
		153,
		161,
		254,
		268,
		257,
		253,
		252,
		260,
		209,
		202,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		-1,
		223,
		219,
		-1,
		-1,
		180,
		173,
		161,
		149,
		139,
		149,
		153,
		157,
		149,
		142,
		137,
		148,
		140,
		144,
		161,
		-1,
		288,
		-1,
		240,
		216,
		230,
		245,
		253,
		-1,
		-1,
		-1,
		240,
		226,
		219,
		207,
		205,
		-1,
		214,
		198,
		179,
		-1,
		149,
		162,
		193,
		161,
		166,
		161,
		143,
		154,
		143,
		146,
		160,
		155,
		-1,
		-1,
		228,
		231,
		-1,
		-1,
		230,
		232,
		-1,
		231,
		220,
		205,
		197,
		-1,
		-1,
		186,
		182,
		-1,
		-1,
		150,
		175,
		164,
		172,
		167,
		147,
		153,
		156,
		145,
		149,
		161,
		-1,
		-1,
		235,
		236,
		237,
		-1,
		215,
		-1,
		233,
		-1,
		200,
		206,
		194,
		-1,
		-1,
		-1,
		188,
		151,
		172,
		182,
		176,
		174,
		165,
		151,
		158,
		156,
		152,
		163,
		-1,
		-1,
		-1,
		233,
		207,
		240,
		231,
		214,
		194,
		186,
		205,
		-1,
		175,
		-1,
		150,
		152,
		178,
		181,
		187,
		181,
		154,
		169,
		159,
		150,
		159,
		239,
		-1,
		209,
		242,
		206,
		200,
		176,
		180,
		196,
		-1,
		172,
		154,
		-1,
		182,
		172,
		203,
		188,
		169,
		156,
		163,
		163,
		156,
		-1,
		-1,
		-1,
		211,
		210,
		202,
		196,
		196,
		181,
		172,
		-1,
		184,
		166,
		145,
		162,
		162,
		153,
		161,
		193,
		189,
		176,
		176,
		168,
		-1,
		312,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		205,
		200,
		173,
		161,
		167,
		163,
		149,
		155,
		157,
		165,
		163,
		160,
		172,
		168,
		188,
		169,
		204,
		-1,
		307,
		-1,
		241,
		-1,
		-1,
		223,
		203,
		195,
		184,
		173,
		171,
		162,
		153,
		175,
		191,
		175,
		173,
		176,
		177,
		-1,
		296,
		295,
		-1,
		242,
		234,
		220,
		-1,
		213,
		-1,
		219,
		180,
		-1,
		182,
		162,
		-1,
		184,
		180,
		-1,
		-1,
		283,
		258,
		-1,
		-1,
		-1,
		243,
		223,
		214,
		198,
		-1,
		173,
		173,
		-1,
		-1,
		-1,
		268,
		267,
		-1,
		236,
		239,
		-1,
		229,
		220,
		228,
		175,
		179,
		-1,
		-1,
		-1,
		277,
		258,
		252,
		251,
		249,
		244,
		241,
		227,
		211,
		189,
		178,
		199,
		-1,
		-1,
		-1,
		249,
		241,
		234,
		-1,
		-1,
		236,
		219,
		200,
		198,
		-1,
		-1,
		-1,
		271,
		252,
		-1,
		-1,
		226,
		-1,
		-1,
		232,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		260,
		-1,
		-1,
		-1,
		222,
		218,
		219,
		-1,
		-1,
		-1,
		-1,
		282,
		283,
		306,
		270,
		-1,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		285,
		283,
		-1,
		-1,
		-1,
		242,
		226,
		-1,
		212,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		247,
		-1,
		247,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		260,
		252,
		260,
		-1,
		232,
		234,
		-1,
		282,
		-1,
		-1,
		275,
		266,
		-1,
		-1,
		237,
		244,
		266,
		269,
		305,
		-1,
		256
	],
	[
		-1,
		113,
		102,
		113,
		121,
		94,
		101,
		-1,
		120,
		124,
		90,
		84,
		123,
		92,
		98,
		109,
		-1,
		-1,
		-1,
		113,
		112,
		80,
		78,
		87,
		92,
		99,
		-1,
		98,
		-1,
		134,
		113,
		124,
		129,
		73,
		70,
		90,
		109,
		91,
		83,
		149,
		103,
		74,
		68,
		86,
		76,
		85,
		77,
		-1,
		74,
		64,
		86,
		65,
		76,
		68,
		-1,
		-1,
		68,
		69,
		75,
		61,
		67,
		63,
		-1,
		73,
		66,
		-1,
		-1,
		58,
		59,
		43,
		46,
		54,
		52,
		65,
		66,
		61,
		-1,
		-1,
		49,
		45,
		52,
		39,
		35,
		52,
		63,
		56,
		70,
		69,
		-1,
		61,
		78,
		78,
		46,
		44,
		28,
		25,
		42,
		55,
		61,
		68,
		-1,
		78,
		74,
		81,
		73,
		68,
		44,
		31,
		21,
		0,
		43,
		64,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		70,
		87,
		89,
		80,
		65,
		63,
		34,
		14,
		12,
		34,
		53,
		58,
		68,
		-1,
		-1,
		172,
		145,
		169,
		127,
		109,
		-1,
		75,
		77,
		83,
		84,
		78,
		71,
		65,
		50,
		-1,
		35,
		27,
		63,
		51,
		62,
		154,
		-1,
		-1,
		130,
		122,
		104,
		107,
		84,
		80,
		92,
		91,
		87,
		89,
		90,
		68,
		58,
		71,
		77,
		26,
		39,
		43,
		58,
		69,
		-1,
		-1,
		147,
		-1,
		-1,
		151,
		134,
		-1,
		99,
		106,
		90,
		96,
		82,
		103,
		102,
		96,
		103,
		99,
		91,
		66,
		63,
		76,
		55,
		30,
		50,
		54,
		61,
		79,
		80,
		-1,
		146,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		106,
		103,
		96,
		120,
		119,
		-1,
		125,
		123,
		128,
		113,
		112,
		106,
		94,
		71,
		55,
		55,
		52,
		37,
		39,
		76,
		63,
		84,
		81,
		112,
		122,
		116,
		125,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		124,
		-1,
		127,
		140,
		137,
		124,
		127,
		114,
		114,
		101,
		90,
		72,
		53,
		50,
		49,
		45,
		54,
		64,
		63,
		81,
		90,
		109,
		113,
		119,
		-1,
		209,
		-1,
		151,
		135,
		137,
		113,
		141,
		-1,
		144,
		128,
		148,
		139,
		139,
		-1,
		130,
		127,
		119,
		97,
		82,
		65,
		53,
		48,
		48,
		52,
		67,
		58,
		76,
		83,
		91,
		95,
		115,
		127,
		169,
		159,
		-1,
		141,
		146,
		116,
		128,
		151,
		171,
		155,
		-1,
		150,
		-1,
		132,
		145,
		-1,
		103,
		99,
		73,
		61,
		50,
		57,
		55,
		49,
		46,
		64,
		67,
		84,
		88,
		104,
		-1,
		-1,
		154,
		158,
		166,
		117,
		136,
		160,
		197,
		162,
		151,
		150,
		-1,
		141,
		109,
		106,
		103,
		90,
		75,
		73,
		56,
		62,
		63,
		48,
		51,
		73,
		101,
		79,
		91,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		143,
		114,
		138,
		180,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		114,
		93,
		84,
		73,
		63,
		79,
		69,
		72,
		52,
		54,
		70,
		82,
		73,
		93,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		117,
		148,
		169,
		159,
		145,
		150,
		125,
		118,
		112,
		118,
		110,
		91,
		80,
		72,
		61,
		70,
		80,
		74,
		54,
		63,
		64,
		88,
		95,
		101,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		101,
		85,
		80,
		77,
		74,
		68,
		77,
		82,
		68,
		59,
		74,
		93,
		93,
		85,
		110,
		113,
		-1,
		-1,
		-1,
		173,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		87,
		83,
		78,
		82,
		75,
		82,
		78,
		77,
		78,
		60,
		96,
		-1,
		93,
		87,
		115,
		118,
		108,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		87,
		85,
		79,
		83,
		87,
		76,
		89,
		85,
		65,
		75,
		95,
		99,
		106,
		99,
		104,
		103,
		117,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		107,
		91,
		94,
		94,
		90,
		98,
		83,
		82,
		68,
		72,
		90,
		117,
		112,
		107,
		106,
		113,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		99,
		114,
		115,
		93,
		98,
		97,
		107,
		104,
		93,
		80,
		84,
		99,
		109,
		101,
		102,
		111,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		113,
		111,
		104,
		95,
		101,
		108,
		111,
		108,
		98,
		87,
		93,
		89,
		111,
		97,
		95,
		114,
		129,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		112,
		96,
		101,
		-1,
		133,
		-1,
		106,
		106,
		97,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		128,
		108,
		102,
		101,
		128,
		123,
		114,
		95,
		88,
		85,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		145,
		133,
		123,
		113,
		147,
		139,
		114,
		107,
		93,
		95,
		93,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		134,
		-1,
		-1,
		125,
		123,
		131,
		110,
		97,
		117,
		120,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		156,
		151,
		155,
		128,
		-1,
		127,
		121,
		101,
		115,
		122,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		135,
		149,
		144,
		137,
		141,
		-1,
		129,
		117,
		103,
		120,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		153,
		168,
		183,
		160,
		133,
		128,
		121,
		115,
		111,
		127,
		133,
		144,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		167,
		184,
		179,
		161,
		165,
		210,
		-1,
		-1,
		137,
		128,
		119,
		122,
		121,
		124,
		118,
		115,
		120,
		125,
		113,
		122,
		140,
		139,
		-1,
		-1,
		-1,
		187,
		-1,
		202,
		-1,
		-1,
		180,
		208,
		155,
		137,
		133,
		131,
		124,
		133,
		128,
		123,
		133,
		135,
		127,
		115,
		119,
		142,
		131,
		170,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		216,
		191,
		206,
		219,
		200,
		207,
		170,
		167,
		-1,
		137,
		162,
		134,
		141,
		132,
		139,
		139,
		131,
		109,
		116,
		132,
		131,
		126,
		162,
		153,
		159,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		219,
		208,
		205,
		195,
		198,
		-1,
		-1,
		186,
		183,
		159,
		142,
		140,
		133,
		128,
		138,
		118,
		105,
		109,
		113,
		119,
		124,
		129,
		135,
		150,
		165,
		-1,
		194,
		275,
		268,
		251,
		259,
		290,
		-1,
		209,
		201,
		212,
		187,
		189,
		-1,
		-1,
		159,
		156,
		161,
		149,
		146,
		148,
		143,
		134,
		119,
		125,
		112,
		111,
		129,
		133,
		142,
		149,
		139,
		152,
		156,
		-1,
		208,
		251,
		245,
		248,
		272,
		286,
		-1,
		206,
		-1,
		-1,
		218,
		190,
		174,
		164,
		158,
		208,
		163,
		158,
		142,
		140,
		131,
		122,
		129,
		120,
		120,
		123,
		138,
		143,
		135,
		149,
		149,
		150,
		-1,
		243,
		231,
		239,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		234,
		-1,
		201,
		-1,
		176,
		180,
		171,
		174,
		156,
		143,
		135,
		127,
		143,
		118,
		128,
		124,
		125,
		134,
		145,
		157,
		156,
		157,
		277,
		233,
		236,
		230,
		258,
		273,
		277,
		-1,
		218,
		257,
		255,
		-1,
		239,
		-1,
		-1,
		-1,
		190,
		184,
		176,
		176,
		155,
		155,
		129,
		133,
		123,
		130,
		140,
		142,
		134,
		138,
		151,
		162,
		165,
		273,
		264,
		277,
		222,
		222,
		243,
		252,
		273,
		233,
		224,
		251,
		262,
		251,
		246,
		233,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		162,
		150,
		133,
		134,
		130,
		133,
		148,
		151,
		141,
		139,
		133,
		165,
		-1,
		266,
		265,
		254,
		251,
		227,
		218,
		213,
		240,
		-1,
		-1,
		235,
		252,
		246,
		250,
		266,
		291,
		-1,
		222,
		-1,
		-1,
		207,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		138,
		149,
		159,
		147,
		148,
		138,
		148,
		161,
		250,
		247,
		235,
		233,
		256,
		221,
		209,
		-1,
		222,
		220,
		226,
		233,
		250,
		280,
		-1,
		-1,
		238,
		218,
		-1,
		-1,
		190,
		188,
		177,
		-1,
		167,
		140,
		145,
		165,
		167,
		156,
		150,
		144,
		151,
		150,
		158,
		166,
		259,
		273,
		262,
		258,
		257,
		265,
		214,
		207,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		-1,
		228,
		224,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		158,
		162,
		154,
		147,
		142,
		153,
		145,
		149,
		166,
		-1,
		293,
		-1,
		245,
		221,
		235,
		250,
		258,
		-1,
		-1,
		-1,
		245,
		231,
		224,
		212,
		210,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		148,
		159,
		148,
		151,
		165,
		160,
		-1,
		-1,
		233,
		236,
		-1,
		-1,
		235,
		237,
		-1,
		236,
		225,
		210,
		202,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		152,
		158,
		161,
		150,
		154,
		166,
		-1,
		-1,
		240,
		241,
		242,
		-1,
		220,
		-1,
		238,
		-1,
		205,
		211,
		199,
		-1,
		-1,
		-1,
		193,
		156,
		177,
		187,
		181,
		179,
		170,
		156,
		163,
		161,
		157,
		168,
		-1,
		-1,
		-1,
		238,
		212,
		245,
		236,
		219,
		199,
		191,
		210,
		-1,
		180,
		-1,
		155,
		157,
		183,
		186,
		192,
		186,
		159,
		174,
		164,
		155,
		164,
		244,
		-1,
		214,
		247,
		211,
		205,
		181,
		185,
		201,
		-1,
		177,
		159,
		-1,
		187,
		177,
		208,
		193,
		174,
		161,
		168,
		168,
		161,
		-1,
		-1,
		-1,
		216,
		215,
		207,
		201,
		201,
		186,
		177,
		-1,
		189,
		171,
		150,
		167,
		167,
		158,
		166,
		198,
		194,
		181,
		181,
		173,
		-1,
		317,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		210,
		205,
		178,
		166,
		172,
		168,
		154,
		160,
		162,
		170,
		168,
		165,
		177,
		173,
		193,
		174,
		209,
		-1,
		312,
		-1,
		246,
		-1,
		-1,
		228,
		208,
		200,
		189,
		178,
		176,
		167,
		158,
		180,
		196,
		180,
		178,
		181,
		182,
		-1,
		301,
		300,
		-1,
		247,
		239,
		225,
		-1,
		218,
		-1,
		224,
		185,
		-1,
		187,
		167,
		-1,
		189,
		185,
		-1,
		-1,
		288,
		263,
		-1,
		-1,
		-1,
		248,
		228,
		219,
		203,
		-1,
		178,
		178,
		-1,
		-1,
		-1,
		273,
		272,
		-1,
		241,
		244,
		-1,
		234,
		225,
		233,
		180,
		184,
		-1,
		-1,
		-1,
		282,
		263,
		257,
		256,
		254,
		249,
		246,
		232,
		216,
		194,
		183,
		204,
		-1,
		-1,
		-1,
		254,
		246,
		239,
		-1,
		-1,
		241,
		224,
		205,
		203,
		-1,
		-1,
		-1,
		276,
		257,
		-1,
		-1,
		231,
		-1,
		-1,
		237,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		293,
		265,
		-1,
		-1,
		-1,
		227,
		223,
		224,
		-1,
		-1,
		-1,
		-1,
		287,
		288,
		311,
		275,
		-1,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		290,
		288,
		-1,
		-1,
		-1,
		247,
		231,
		-1,
		217,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		252,
		-1,
		252,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		265,
		257,
		265,
		-1,
		237,
		239,
		-1,
		287,
		-1,
		-1,
		280,
		271,
		-1,
		-1,
		242,
		249,
		271,
		274,
		310,
		-1,
		261
	],
	[
		-1,
		124,
		113,
		124,
		132,
		105,
		112,
		-1,
		131,
		135,
		101,
		95,
		134,
		103,
		109,
		120,
		-1,
		-1,
		-1,
		124,
		123,
		91,
		89,
		98,
		103,
		110,
		-1,
		107,
		-1,
		145,
		124,
		135,
		140,
		84,
		81,
		101,
		119,
		100,
		92,
		160,
		114,
		85,
		79,
		97,
		87,
		94,
		86,
		-1,
		85,
		75,
		97,
		76,
		87,
		68,
		-1,
		-1,
		79,
		80,
		86,
		72,
		78,
		74,
		-1,
		41,
		23,
		-1,
		-1,
		69,
		70,
		54,
		57,
		65,
		63,
		37,
		23,
		18,
		-1,
		-1,
		60,
		56,
		63,
		50,
		46,
		63,
		38,
		13,
		27,
		26,
		-1,
		72,
		89,
		89,
		57,
		55,
		39,
		37,
		48,
		12,
		18,
		26,
		-1,
		89,
		85,
		86,
		84,
		79,
		55,
		42,
		42,
		52,
		0,
		27,
		29,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		90,
		81,
		98,
		82,
		72,
		76,
		74,
		45,
		42,
		40,
		21,
		16,
		32,
		56,
		-1,
		-1,
		183,
		156,
		180,
		138,
		120,
		-1,
		86,
		86,
		80,
		76,
		70,
		63,
		76,
		61,
		-1,
		31,
		25,
		26,
		39,
		50,
		165,
		-1,
		-1,
		141,
		133,
		115,
		118,
		95,
		91,
		101,
		100,
		93,
		86,
		82,
		60,
		63,
		63,
		69,
		25,
		35,
		39,
		46,
		57,
		-1,
		-1,
		139,
		-1,
		-1,
		162,
		145,
		-1,
		110,
		117,
		101,
		107,
		93,
		114,
		111,
		102,
		96,
		91,
		83,
		58,
		55,
		68,
		47,
		22,
		47,
		51,
		49,
		67,
		68,
		-1,
		138,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		117,
		114,
		107,
		131,
		130,
		-1,
		131,
		119,
		120,
		105,
		104,
		98,
		86,
		63,
		47,
		47,
		44,
		29,
		31,
		68,
		51,
		72,
		69,
		100,
		114,
		108,
		117,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		135,
		-1,
		138,
		151,
		143,
		116,
		119,
		106,
		106,
		93,
		82,
		64,
		45,
		42,
		41,
		37,
		46,
		56,
		55,
		73,
		78,
		101,
		105,
		111,
		-1,
		220,
		-1,
		162,
		146,
		148,
		124,
		152,
		-1,
		155,
		139,
		159,
		145,
		145,
		-1,
		122,
		119,
		111,
		89,
		74,
		57,
		45,
		40,
		40,
		44,
		59,
		50,
		68,
		75,
		83,
		87,
		107,
		119,
		180,
		170,
		-1,
		152,
		157,
		127,
		139,
		159,
		182,
		161,
		-1,
		156,
		-1,
		124,
		137,
		-1,
		95,
		91,
		65,
		53,
		42,
		49,
		47,
		41,
		38,
		56,
		59,
		76,
		80,
		96,
		-1,
		-1,
		165,
		169,
		174,
		125,
		144,
		168,
		205,
		154,
		143,
		142,
		-1,
		133,
		101,
		98,
		95,
		82,
		67,
		65,
		48,
		54,
		55,
		40,
		43,
		65,
		93,
		71,
		83,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		151,
		122,
		146,
		188,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		106,
		85,
		76,
		65,
		55,
		71,
		61,
		64,
		44,
		46,
		62,
		74,
		65,
		85,
		-1,
		-1,
		-1,
		181,
		170,
		171,
		117,
		140,
		177,
		151,
		137,
		142,
		117,
		110,
		104,
		110,
		102,
		83,
		72,
		64,
		53,
		62,
		72,
		66,
		46,
		55,
		56,
		80,
		87,
		93,
		-1,
		-1,
		188,
		178,
		162,
		164,
		161,
		131,
		138,
		170,
		142,
		155,
		-1,
		109,
		-1,
		98,
		93,
		77,
		72,
		69,
		66,
		60,
		69,
		74,
		60,
		51,
		66,
		85,
		85,
		77,
		102,
		105,
		-1,
		-1,
		-1,
		181,
		176,
		151,
		128,
		112,
		148,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		79,
		75,
		70,
		74,
		67,
		74,
		70,
		69,
		70,
		52,
		88,
		-1,
		85,
		79,
		107,
		110,
		100,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		79,
		77,
		71,
		75,
		79,
		68,
		81,
		77,
		57,
		67,
		87,
		91,
		98,
		91,
		96,
		95,
		109,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		99,
		83,
		86,
		86,
		82,
		90,
		75,
		74,
		60,
		64,
		82,
		109,
		104,
		99,
		98,
		105,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		95,
		91,
		106,
		107,
		85,
		90,
		89,
		99,
		96,
		85,
		72,
		76,
		91,
		101,
		93,
		94,
		103,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		105,
		103,
		96,
		87,
		93,
		100,
		103,
		100,
		90,
		79,
		85,
		81,
		103,
		89,
		87,
		106,
		121,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		104,
		88,
		93,
		-1,
		125,
		-1,
		98,
		98,
		89,
		78,
		75,
		86,
		84,
		95,
		112,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		120,
		100,
		94,
		93,
		120,
		115,
		106,
		87,
		80,
		77,
		78,
		91,
		111,
		102,
		114,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		137,
		125,
		115,
		105,
		139,
		131,
		106,
		99,
		85,
		87,
		85,
		87,
		92,
		113,
		114,
		127,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		126,
		-1,
		-1,
		117,
		115,
		123,
		102,
		89,
		109,
		112,
		102,
		86,
		101,
		113,
		121,
		126,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		148,
		143,
		147,
		120,
		-1,
		119,
		113,
		93,
		107,
		114,
		104,
		99,
		93,
		96,
		114,
		131,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		136,
		129,
		133,
		-1,
		121,
		109,
		95,
		112,
		117,
		114,
		105,
		97,
		102,
		99,
		112,
		126,
		130,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		145,
		160,
		175,
		152,
		125,
		120,
		113,
		107,
		103,
		119,
		125,
		136,
		104,
		100,
		101,
		105,
		104,
		121,
		131,
		-1,
		-1,
		159,
		176,
		171,
		153,
		157,
		202,
		-1,
		-1,
		129,
		120,
		111,
		114,
		113,
		116,
		110,
		107,
		112,
		117,
		105,
		114,
		132,
		131,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		172,
		200,
		147,
		129,
		125,
		123,
		116,
		125,
		120,
		115,
		125,
		127,
		119,
		107,
		111,
		134,
		123,
		162,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		211,
		192,
		199,
		162,
		159,
		-1,
		129,
		154,
		126,
		133,
		124,
		131,
		131,
		123,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		291,
		280,
		269,
		275,
		-1,
		211,
		200,
		197,
		187,
		190,
		-1,
		-1,
		178,
		175,
		151,
		134,
		132,
		125,
		120,
		130,
		110,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		186,
		267,
		260,
		243,
		251,
		282,
		-1,
		201,
		193,
		204,
		179,
		181,
		-1,
		-1,
		151,
		148,
		153,
		141,
		138,
		140,
		135,
		126,
		111,
		117,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		200,
		243,
		237,
		240,
		264,
		278,
		-1,
		198,
		-1,
		-1,
		210,
		182,
		166,
		156,
		150,
		200,
		155,
		150,
		134,
		132,
		123,
		114,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		235,
		223,
		231,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		226,
		-1,
		193,
		-1,
		168,
		172,
		163,
		166,
		148,
		135,
		127,
		119,
		135,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		269,
		225,
		228,
		222,
		250,
		265,
		269,
		-1,
		210,
		249,
		247,
		-1,
		231,
		-1,
		-1,
		-1,
		182,
		176,
		168,
		168,
		147,
		147,
		121,
		125,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		265,
		256,
		269,
		214,
		214,
		235,
		244,
		265,
		225,
		216,
		243,
		254,
		243,
		238,
		225,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		154,
		142,
		125,
		126,
		122,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		205,
		232,
		-1,
		-1,
		227,
		244,
		238,
		242,
		258,
		283,
		-1,
		214,
		-1,
		-1,
		199,
		-1,
		-1,
		184,
		147,
		136,
		127,
		133,
		130,
		141,
		151,
		139,
		140,
		130,
		140,
		153,
		242,
		239,
		227,
		225,
		248,
		213,
		201,
		-1,
		214,
		212,
		218,
		225,
		242,
		272,
		-1,
		-1,
		230,
		210,
		-1,
		-1,
		182,
		180,
		169,
		-1,
		159,
		132,
		137,
		157,
		159,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		199,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		216,
		-1,
		-1,
		177,
		170,
		158,
		146,
		136,
		146,
		150,
		154,
		146,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		285,
		-1,
		237,
		213,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		211,
		195,
		176,
		-1,
		146,
		159,
		190,
		158,
		163,
		158,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		225,
		228,
		-1,
		-1,
		227,
		229,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		183,
		179,
		-1,
		-1,
		147,
		172,
		161,
		169,
		164,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		232,
		233,
		234,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		185,
		148,
		169,
		179,
		173,
		171,
		162,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		149,
		175,
		178,
		184,
		178,
		151,
		166,
		156,
		147,
		156,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		200,
		185,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		190,
		186,
		173,
		173,
		165,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		166,
		201,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		173,
		174,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		150,
		154,
		120,
		114,
		153,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		143,
		142,
		110,
		108,
		117,
		122,
		129,
		-1,
		128,
		-1,
		164,
		143,
		154,
		159,
		103,
		100,
		120,
		139,
		121,
		113,
		179,
		133,
		104,
		98,
		116,
		106,
		115,
		107,
		-1,
		104,
		94,
		116,
		95,
		106,
		92,
		-1,
		-1,
		98,
		99,
		105,
		91,
		97,
		93,
		-1,
		57,
		30,
		-1,
		-1,
		88,
		89,
		73,
		76,
		84,
		82,
		53,
		39,
		25,
		-1,
		-1,
		79,
		75,
		82,
		69,
		65,
		82,
		56,
		25,
		12,
		10,
		-1,
		91,
		108,
		108,
		76,
		74,
		58,
		56,
		66,
		27,
		10,
		10,
		-1,
		108,
		104,
		105,
		103,
		98,
		74,
		61,
		61,
		65,
		25,
		0,
		10,
		60,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		100,
		117,
		101,
		91,
		95,
		93,
		64,
		55,
		53,
		46,
		11,
		13,
		37,
		-1,
		-1,
		202,
		175,
		199,
		157,
		139,
		-1,
		105,
		105,
		99,
		95,
		89,
		82,
		95,
		80,
		-1,
		32,
		39,
		21,
		20,
		31,
		184,
		-1,
		-1,
		160,
		152,
		134,
		137,
		114,
		110,
		120,
		119,
		112,
		105,
		101,
		79,
		82,
		82,
		88,
		42,
		30,
		27,
		27,
		38,
		-1,
		-1,
		144,
		-1,
		-1,
		181,
		164,
		-1,
		129,
		136,
		120,
		126,
		112,
		133,
		130,
		121,
		115,
		110,
		102,
		77,
		74,
		87,
		66,
		41,
		37,
		40,
		30,
		48,
		49,
		-1,
		143,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		136,
		133,
		126,
		150,
		149,
		-1,
		150,
		138,
		139,
		124,
		123,
		117,
		105,
		82,
		66,
		66,
		63,
		48,
		50,
		64,
		32,
		53,
		50,
		81,
		119,
		113,
		122,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		154,
		-1,
		157,
		170,
		162,
		135,
		138,
		125,
		125,
		112,
		101,
		83,
		64,
		61,
		60,
		56,
		65,
		37,
		40,
		56,
		59,
		106,
		110,
		116,
		-1,
		239,
		-1,
		181,
		165,
		167,
		143,
		171,
		-1,
		174,
		158,
		178,
		164,
		164,
		-1,
		141,
		138,
		130,
		108,
		93,
		76,
		64,
		59,
		59,
		63,
		69,
		44,
		62,
		64,
		71,
		92,
		114,
		124,
		199,
		189,
		-1,
		171,
		176,
		146,
		158,
		178,
		201,
		180,
		-1,
		175,
		-1,
		143,
		156,
		-1,
		114,
		110,
		84,
		72,
		61,
		68,
		66,
		60,
		57,
		50,
		53,
		82,
		82,
		108,
		-1,
		-1,
		184,
		188,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		120,
		117,
		114,
		101,
		86,
		84,
		67,
		73,
		74,
		59,
		62,
		59,
		101,
		87,
		99,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		125,
		104,
		95,
		84,
		74,
		90,
		80,
		83,
		63,
		65,
		65,
		90,
		81,
		101,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		129,
		121,
		102,
		91,
		83,
		72,
		81,
		91,
		85,
		65,
		74,
		72,
		96,
		103,
		109,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		112,
		96,
		91,
		88,
		85,
		79,
		88,
		93,
		79,
		70,
		85,
		101,
		101,
		93,
		118,
		121,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		98,
		94,
		89,
		93,
		86,
		93,
		89,
		88,
		89,
		71,
		106,
		-1,
		101,
		95,
		123,
		126,
		116,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		98,
		96,
		90,
		94,
		98,
		87,
		100,
		96,
		76,
		86,
		106,
		110,
		114,
		107,
		112,
		111,
		125,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		118,
		102,
		105,
		105,
		101,
		109,
		94,
		93,
		79,
		83,
		101,
		125,
		120,
		118,
		117,
		121,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		110,
		125,
		126,
		104,
		109,
		108,
		118,
		115,
		104,
		91,
		95,
		110,
		120,
		112,
		113,
		122,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		124,
		122,
		115,
		106,
		112,
		119,
		122,
		119,
		109,
		98,
		104,
		100,
		122,
		108,
		106,
		122,
		137,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		123,
		107,
		112,
		-1,
		144,
		-1,
		117,
		117,
		108,
		97,
		94,
		105,
		103,
		114,
		128,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		139,
		119,
		113,
		112,
		139,
		134,
		125,
		106,
		99,
		96,
		97,
		110,
		130,
		121,
		130,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		156,
		144,
		134,
		124,
		158,
		150,
		125,
		118,
		104,
		106,
		104,
		106,
		111,
		132,
		133,
		145,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		164,
		135,
		145,
		-1,
		-1,
		136,
		134,
		142,
		121,
		108,
		128,
		131,
		121,
		105,
		120,
		132,
		137,
		145,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		167,
		162,
		166,
		139,
		-1,
		138,
		132,
		112,
		126,
		133,
		123,
		118,
		112,
		115,
		133,
		148,
		-1,
		-1,
		172,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		146,
		160,
		155,
		148,
		152,
		-1,
		140,
		128,
		114,
		131,
		136,
		133,
		124,
		116,
		121,
		118,
		131,
		145,
		149,
		195,
		-1,
		178,
		-1,
		-1,
		-1,
		164,
		179,
		194,
		171,
		144,
		139,
		132,
		126,
		122,
		138,
		144,
		155,
		123,
		119,
		120,
		124,
		123,
		140,
		150,
		-1,
		-1,
		178,
		195,
		190,
		172,
		176,
		221,
		-1,
		-1,
		148,
		139,
		130,
		133,
		132,
		135,
		129,
		126,
		131,
		136,
		124,
		133,
		151,
		150,
		-1,
		-1,
		-1,
		198,
		-1,
		213,
		-1,
		-1,
		191,
		219,
		166,
		148,
		144,
		142,
		135,
		144,
		139,
		134,
		144,
		146,
		138,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		227,
		202,
		217,
		230,
		211,
		218,
		181,
		178,
		-1,
		148,
		173,
		145,
		152,
		143,
		150,
		150,
		142,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		310,
		299,
		288,
		294,
		-1,
		230,
		219,
		216,
		206,
		209,
		-1,
		-1,
		197,
		194,
		170,
		153,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		205,
		286,
		279,
		262,
		270,
		301,
		-1,
		220,
		212,
		223,
		198,
		200,
		-1,
		-1,
		170,
		167,
		172,
		160,
		157,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		219,
		262,
		256,
		259,
		283,
		297,
		-1,
		217,
		-1,
		-1,
		229,
		201,
		185,
		175,
		169,
		219,
		174,
		169,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		254,
		242,
		250,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		245,
		-1,
		212,
		-1,
		187,
		191,
		182,
		185,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		288,
		244,
		247,
		241,
		269,
		284,
		288,
		-1,
		229,
		268,
		266,
		-1,
		250,
		-1,
		-1,
		-1,
		201,
		195,
		187,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		284,
		275,
		288,
		233,
		233,
		254,
		263,
		284,
		244,
		235,
		262,
		273,
		262,
		257,
		244,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		224,
		251,
		-1,
		-1,
		246,
		263,
		257,
		261,
		277,
		302,
		-1,
		233,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		261,
		258,
		246,
		244,
		267,
		232,
		220,
		-1,
		233,
		231,
		237,
		244,
		261,
		291,
		-1,
		-1,
		249,
		229,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		218,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		235,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		304,
		-1,
		256,
		232,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		251,
		252,
		253,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		136,
		125,
		136,
		144,
		117,
		124,
		-1,
		143,
		147,
		113,
		107,
		146,
		115,
		121,
		132,
		-1,
		-1,
		-1,
		136,
		135,
		103,
		101,
		110,
		115,
		122,
		-1,
		121,
		-1,
		157,
		136,
		147,
		152,
		96,
		93,
		113,
		132,
		114,
		106,
		172,
		126,
		97,
		91,
		109,
		99,
		108,
		100,
		-1,
		97,
		87,
		109,
		88,
		99,
		91,
		-1,
		-1,
		91,
		92,
		98,
		84,
		90,
		86,
		-1,
		66,
		39,
		-1,
		-1,
		81,
		82,
		66,
		69,
		77,
		75,
		62,
		48,
		34,
		-1,
		-1,
		72,
		68,
		75,
		62,
		58,
		75,
		65,
		34,
		21,
		19,
		-1,
		84,
		101,
		101,
		69,
		67,
		51,
		49,
		67,
		36,
		19,
		11,
		-1,
		101,
		97,
		98,
		96,
		91,
		67,
		54,
		54,
		64,
		30,
		13,
		0,
		50,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		93,
		110,
		94,
		84,
		88,
		86,
		57,
		54,
		52,
		41,
		16,
		3,
		27,
		-1,
		-1,
		195,
		168,
		192,
		150,
		132,
		-1,
		98,
		98,
		92,
		88,
		82,
		75,
		88,
		73,
		-1,
		25,
		34,
		24,
		10,
		21,
		177,
		-1,
		-1,
		153,
		145,
		127,
		130,
		107,
		103,
		113,
		112,
		105,
		98,
		94,
		72,
		75,
		75,
		81,
		37,
		20,
		17,
		17,
		28,
		-1,
		-1,
		134,
		-1,
		-1,
		174,
		157,
		-1,
		122,
		129,
		113,
		119,
		105,
		126,
		123,
		114,
		108,
		103,
		95,
		70,
		67,
		80,
		59,
		34,
		27,
		30,
		20,
		38,
		39,
		-1,
		133,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		129,
		126,
		119,
		143,
		142,
		-1,
		143,
		131,
		132,
		117,
		116,
		110,
		98,
		75,
		59,
		59,
		56,
		41,
		43,
		54,
		22,
		43,
		40,
		71,
		109,
		103,
		112,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		147,
		-1,
		150,
		163,
		155,
		128,
		131,
		118,
		118,
		105,
		94,
		76,
		57,
		54,
		53,
		49,
		58,
		27,
		30,
		46,
		49,
		96,
		100,
		106,
		-1,
		232,
		-1,
		174,
		158,
		160,
		136,
		164,
		-1,
		167,
		151,
		171,
		157,
		157,
		-1,
		134,
		131,
		123,
		101,
		86,
		69,
		57,
		52,
		52,
		54,
		59,
		34,
		52,
		54,
		61,
		82,
		104,
		114,
		192,
		182,
		-1,
		164,
		169,
		139,
		151,
		171,
		194,
		173,
		-1,
		168,
		-1,
		136,
		149,
		-1,
		107,
		103,
		77,
		65,
		54,
		61,
		59,
		50,
		47,
		40,
		43,
		72,
		72,
		98,
		-1,
		-1,
		177,
		181,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		113,
		110,
		107,
		94,
		79,
		77,
		60,
		66,
		64,
		49,
		52,
		49,
		91,
		77,
		89,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		118,
		97,
		88,
		77,
		67,
		83,
		70,
		73,
		53,
		55,
		55,
		80,
		71,
		91,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		122,
		114,
		95,
		84,
		76,
		65,
		71,
		81,
		75,
		55,
		64,
		62,
		86,
		93,
		99,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		83,
		69,
		60,
		75,
		91,
		91,
		83,
		108,
		111,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		82,
		78,
		79,
		61,
		96,
		-1,
		91,
		85,
		113,
		116,
		106,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		91,
		80,
		93,
		86,
		66,
		76,
		96,
		100,
		104,
		97,
		102,
		101,
		115,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		98,
		94,
		102,
		87,
		83,
		69,
		73,
		91,
		115,
		110,
		108,
		107,
		111,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		102,
		101,
		111,
		105,
		94,
		81,
		85,
		100,
		110,
		102,
		103,
		112,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		112,
		114,
		109,
		99,
		88,
		94,
		90,
		112,
		98,
		96,
		112,
		127,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		116,
		100,
		105,
		-1,
		134,
		-1,
		107,
		107,
		98,
		87,
		84,
		95,
		93,
		104,
		118,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		132,
		112,
		106,
		105,
		129,
		124,
		115,
		96,
		89,
		86,
		87,
		100,
		120,
		111,
		120,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		149,
		137,
		127,
		117,
		150,
		140,
		115,
		108,
		94,
		96,
		94,
		96,
		101,
		122,
		123,
		135,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		138,
		-1,
		-1,
		129,
		127,
		132,
		111,
		98,
		118,
		121,
		111,
		95,
		110,
		122,
		127,
		135,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		157,
		152,
		156,
		132,
		-1,
		128,
		122,
		102,
		116,
		123,
		113,
		108,
		102,
		105,
		123,
		138,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		139,
		153,
		145,
		138,
		142,
		-1,
		130,
		118,
		104,
		121,
		126,
		123,
		114,
		106,
		111,
		108,
		121,
		135,
		139,
		188,
		-1,
		171,
		-1,
		-1,
		-1,
		157,
		172,
		184,
		161,
		134,
		129,
		122,
		116,
		112,
		128,
		134,
		145,
		113,
		109,
		110,
		114,
		113,
		130,
		140,
		-1,
		-1,
		171,
		188,
		183,
		165,
		169,
		211,
		-1,
		-1,
		138,
		129,
		120,
		123,
		122,
		125,
		119,
		116,
		121,
		126,
		114,
		123,
		141,
		140,
		-1,
		-1,
		-1,
		191,
		-1,
		206,
		-1,
		-1,
		184,
		209,
		156,
		138,
		134,
		132,
		125,
		134,
		129,
		124,
		134,
		136,
		128,
		116,
		120,
		143,
		132,
		171,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		220,
		195,
		210,
		220,
		204,
		211,
		171,
		168,
		-1,
		138,
		163,
		135,
		142,
		133,
		140,
		140,
		132,
		110,
		117,
		133,
		132,
		127,
		163,
		154,
		160,
		-1,
		-1,
		303,
		292,
		281,
		287,
		-1,
		220,
		212,
		206,
		196,
		199,
		-1,
		-1,
		187,
		184,
		160,
		143,
		141,
		134,
		129,
		139,
		119,
		106,
		110,
		114,
		120,
		125,
		130,
		136,
		151,
		166,
		-1,
		198,
		279,
		272,
		255,
		263,
		294,
		-1,
		210,
		202,
		213,
		188,
		190,
		-1,
		-1,
		160,
		157,
		162,
		150,
		147,
		149,
		144,
		135,
		120,
		126,
		113,
		112,
		130,
		134,
		143,
		150,
		140,
		153,
		157,
		-1,
		212,
		255,
		249,
		252,
		276,
		290,
		-1,
		207,
		-1,
		-1,
		219,
		191,
		175,
		165,
		159,
		209,
		164,
		159,
		143,
		141,
		132,
		123,
		130,
		121,
		121,
		124,
		139,
		144,
		136,
		150,
		150,
		151,
		-1,
		247,
		235,
		243,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		235,
		-1,
		202,
		-1,
		177,
		181,
		172,
		175,
		157,
		144,
		136,
		128,
		144,
		119,
		129,
		125,
		126,
		135,
		146,
		158,
		157,
		158,
		278,
		234,
		237,
		234,
		259,
		274,
		278,
		-1,
		219,
		258,
		256,
		-1,
		240,
		-1,
		-1,
		-1,
		191,
		185,
		177,
		177,
		156,
		156,
		130,
		134,
		124,
		131,
		141,
		143,
		135,
		139,
		152,
		163,
		166,
		274,
		265,
		278,
		223,
		223,
		244,
		253,
		274,
		234,
		225,
		252,
		263,
		252,
		247,
		234,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		163,
		151,
		134,
		135,
		131,
		134,
		149,
		152,
		142,
		140,
		134,
		166,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		214,
		241,
		-1,
		-1,
		236,
		253,
		247,
		251,
		267,
		292,
		-1,
		223,
		-1,
		-1,
		208,
		-1,
		-1,
		193,
		156,
		145,
		136,
		142,
		139,
		150,
		160,
		148,
		149,
		139,
		149,
		162,
		251,
		248,
		236,
		234,
		257,
		222,
		210,
		-1,
		223,
		221,
		227,
		234,
		251,
		281,
		-1,
		-1,
		239,
		219,
		-1,
		-1,
		191,
		189,
		178,
		-1,
		168,
		141,
		146,
		166,
		168,
		157,
		151,
		145,
		152,
		151,
		159,
		167,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		208,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		-1,
		229,
		225,
		-1,
		-1,
		186,
		179,
		167,
		155,
		145,
		155,
		159,
		163,
		155,
		148,
		143,
		154,
		146,
		150,
		167,
		-1,
		294,
		-1,
		246,
		222,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		246,
		232,
		225,
		213,
		211,
		-1,
		220,
		204,
		185,
		-1,
		155,
		168,
		199,
		167,
		172,
		167,
		149,
		160,
		149,
		152,
		166,
		161,
		-1,
		-1,
		234,
		237,
		-1,
		-1,
		236,
		238,
		-1,
		237,
		226,
		211,
		203,
		-1,
		-1,
		192,
		188,
		-1,
		-1,
		156,
		181,
		170,
		178,
		173,
		153,
		159,
		162,
		151,
		155,
		167,
		-1,
		-1,
		241,
		242,
		243,
		-1,
		221,
		-1,
		239,
		-1,
		206,
		212,
		200,
		-1,
		-1,
		-1,
		194,
		157,
		178,
		188,
		182,
		180,
		171,
		157,
		164,
		162,
		158,
		169,
		-1,
		-1,
		-1,
		239,
		213,
		246,
		237,
		220,
		200,
		192,
		211,
		-1,
		181,
		-1,
		156,
		158,
		184,
		187,
		193,
		187,
		160,
		175,
		165,
		156,
		165,
		245,
		-1,
		215,
		248,
		212,
		206,
		182,
		186,
		202,
		-1,
		178,
		160,
		-1,
		188,
		178,
		209,
		194,
		175,
		162,
		169,
		169,
		162,
		-1,
		-1,
		-1,
		217,
		216,
		208,
		202,
		202,
		187,
		178,
		-1,
		190,
		172,
		151,
		168,
		168,
		159,
		167,
		199,
		195,
		182,
		182,
		174,
		-1,
		318,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		211,
		206,
		179,
		167,
		173,
		169,
		155,
		161,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		175,
		210,
		-1,
		313,
		-1,
		247,
		-1,
		-1,
		229,
		209,
		201,
		190,
		179,
		177,
		168,
		159,
		181,
		197,
		181,
		179,
		182,
		183,
		-1,
		302,
		301,
		-1,
		248,
		240,
		226,
		-1,
		219,
		-1,
		225,
		186,
		-1,
		188,
		168,
		-1,
		190,
		186,
		-1,
		-1,
		289,
		264,
		-1,
		-1,
		-1,
		249,
		229,
		220,
		204,
		-1,
		179,
		179,
		-1,
		-1,
		-1,
		274,
		273,
		-1,
		242,
		245,
		-1,
		235,
		226,
		234,
		181,
		185,
		-1,
		-1,
		-1,
		283,
		264,
		258,
		257,
		255,
		250,
		247,
		233,
		217,
		195,
		184,
		205,
		-1,
		-1,
		-1,
		255,
		247,
		240,
		-1,
		-1,
		242,
		225,
		206,
		204,
		-1,
		-1,
		-1,
		277,
		258,
		-1,
		-1,
		232,
		-1,
		-1,
		238,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		266,
		-1,
		-1,
		-1,
		228,
		224,
		225,
		-1,
		-1,
		-1,
		-1,
		288,
		289,
		312,
		276,
		-1,
		-1,
		-1,
		220,
		214,
		-1,
		-1,
		291,
		289,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		218,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		253,
		-1,
		253,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		266,
		258,
		266,
		-1,
		238,
		240,
		-1,
		288,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		243,
		250,
		272,
		275,
		311,
		-1,
		262
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		189,
		193,
		159,
		153,
		192,
		161,
		167,
		178,
		-1,
		-1,
		-1,
		182,
		181,
		149,
		147,
		156,
		161,
		168,
		-1,
		167,
		-1,
		203,
		182,
		193,
		198,
		142,
		139,
		159,
		178,
		160,
		152,
		218,
		172,
		143,
		137,
		155,
		145,
		154,
		146,
		-1,
		143,
		133,
		155,
		134,
		145,
		137,
		-1,
		-1,
		137,
		138,
		144,
		130,
		136,
		132,
		-1,
		117,
		90,
		-1,
		-1,
		127,
		128,
		112,
		115,
		123,
		121,
		113,
		99,
		85,
		-1,
		-1,
		118,
		114,
		121,
		108,
		104,
		121,
		116,
		85,
		72,
		70,
		-1,
		130,
		147,
		147,
		115,
		113,
		97,
		95,
		113,
		87,
		70,
		62,
		-1,
		147,
		143,
		144,
		142,
		137,
		113,
		100,
		100,
		110,
		80,
		64,
		52,
		0,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		139,
		156,
		140,
		130,
		134,
		132,
		103,
		100,
		98,
		87,
		66,
		49,
		73,
		-1,
		-1,
		241,
		214,
		238,
		196,
		178,
		-1,
		144,
		144,
		138,
		134,
		128,
		121,
		134,
		119,
		-1,
		71,
		80,
		70,
		56,
		67,
		223,
		-1,
		-1,
		199,
		191,
		173,
		176,
		153,
		149,
		159,
		158,
		151,
		144,
		140,
		118,
		121,
		121,
		127,
		83,
		66,
		63,
		63,
		74,
		-1,
		-1,
		180,
		-1,
		-1,
		220,
		203,
		-1,
		168,
		175,
		159,
		165,
		151,
		172,
		169,
		160,
		154,
		149,
		141,
		116,
		113,
		126,
		105,
		80,
		73,
		76,
		66,
		84,
		85,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		175,
		172,
		165,
		189,
		188,
		-1,
		189,
		177,
		178,
		163,
		162,
		156,
		144,
		121,
		105,
		105,
		102,
		87,
		89,
		100,
		68,
		89,
		86,
		117,
		155,
		149,
		158,
		-1,
		228,
		224,
		220,
		227,
		176,
		-1,
		-1,
		193,
		-1,
		196,
		209,
		201,
		174,
		177,
		164,
		164,
		151,
		140,
		122,
		103,
		100,
		99,
		95,
		104,
		73,
		76,
		92,
		95,
		142,
		146,
		152,
		-1,
		278,
		-1,
		220,
		204,
		206,
		182,
		210,
		-1,
		213,
		197,
		217,
		203,
		203,
		-1,
		180,
		177,
		169,
		147,
		132,
		115,
		103,
		98,
		98,
		100,
		105,
		80,
		98,
		100,
		107,
		128,
		150,
		160,
		238,
		228,
		-1,
		210,
		215,
		185,
		197,
		217,
		240,
		219,
		-1,
		214,
		-1,
		182,
		195,
		-1,
		153,
		149,
		123,
		111,
		100,
		107,
		105,
		96,
		93,
		86,
		89,
		118,
		118,
		144,
		-1,
		-1,
		223,
		227,
		232,
		183,
		202,
		226,
		263,
		212,
		201,
		200,
		-1,
		191,
		159,
		156,
		153,
		140,
		125,
		123,
		106,
		112,
		110,
		95,
		98,
		95,
		137,
		123,
		135,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		209,
		180,
		204,
		246,
		230,
		223,
		211,
		176,
		176,
		170,
		-1,
		164,
		143,
		134,
		123,
		113,
		129,
		116,
		119,
		99,
		101,
		101,
		126,
		117,
		137,
		-1,
		-1,
		-1,
		239,
		228,
		229,
		175,
		198,
		235,
		209,
		195,
		200,
		175,
		168,
		162,
		168,
		160,
		141,
		130,
		122,
		111,
		117,
		127,
		121,
		101,
		110,
		108,
		132,
		139,
		145,
		-1,
		-1,
		246,
		236,
		220,
		222,
		219,
		189,
		196,
		228,
		200,
		213,
		-1,
		167,
		-1,
		156,
		151,
		135,
		130,
		127,
		124,
		118,
		127,
		129,
		115,
		106,
		121,
		137,
		137,
		129,
		154,
		157,
		-1,
		-1,
		-1,
		239,
		234,
		209,
		186,
		170,
		206,
		-1,
		183,
		184,
		-1,
		161,
		155,
		152,
		137,
		133,
		128,
		132,
		125,
		132,
		128,
		124,
		125,
		107,
		142,
		-1,
		137,
		131,
		159,
		162,
		152,
		-1,
		-1,
		-1,
		232,
		211,
		204,
		224,
		165,
		217,
		-1,
		-1,
		168,
		161,
		-1,
		148,
		130,
		137,
		135,
		129,
		133,
		137,
		126,
		139,
		132,
		112,
		122,
		142,
		146,
		150,
		143,
		148,
		147,
		161,
		-1,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		185,
		-1,
		177,
		169,
		159,
		153,
		147,
		143,
		141,
		157,
		141,
		144,
		144,
		140,
		148,
		133,
		129,
		115,
		119,
		137,
		161,
		156,
		154,
		153,
		157,
		-1,
		252,
		238,
		209,
		-1,
		-1,
		198,
		-1,
		162,
		176,
		192,
		-1,
		185,
		164,
		179,
		157,
		153,
		149,
		164,
		165,
		143,
		148,
		147,
		157,
		151,
		140,
		127,
		131,
		146,
		156,
		148,
		149,
		158,
		-1,
		258,
		245,
		203,
		199,
		188,
		208,
		159,
		147,
		179,
		-1,
		-1,
		221,
		-1,
		155,
		172,
		163,
		161,
		154,
		145,
		151,
		158,
		160,
		155,
		145,
		134,
		140,
		136,
		158,
		144,
		142,
		158,
		173,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		174,
		161,
		155,
		-1,
		196,
		-1,
		199,
		189,
		173,
		158,
		191,
		-1,
		162,
		146,
		151,
		-1,
		180,
		-1,
		153,
		153,
		144,
		133,
		130,
		141,
		139,
		150,
		164,
		-1,
		208,
		193,
		186,
		176,
		190,
		161,
		-1,
		216,
		-1,
		-1,
		186,
		180,
		180,
		164,
		167,
		178,
		158,
		152,
		151,
		175,
		170,
		161,
		142,
		135,
		132,
		133,
		146,
		166,
		157,
		166,
		-1,
		-1,
		-1,
		213,
		199,
		203,
		163,
		182,
		-1,
		-1,
		248,
		203,
		189,
		-1,
		173,
		195,
		183,
		173,
		163,
		196,
		186,
		161,
		154,
		140,
		142,
		140,
		142,
		147,
		168,
		169,
		181,
		-1,
		-1,
		196,
		201,
		189,
		175,
		194,
		-1,
		-1,
		-1,
		195,
		211,
		203,
		174,
		184,
		-1,
		-1,
		175,
		173,
		178,
		157,
		144,
		164,
		167,
		157,
		141,
		156,
		168,
		173,
		181,
		-1,
		199,
		186,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		-1,
		-1,
		228,
		194,
		203,
		198,
		202,
		178,
		-1,
		174,
		168,
		148,
		162,
		169,
		159,
		154,
		148,
		151,
		169,
		184,
		-1,
		-1,
		211,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		185,
		199,
		191,
		184,
		188,
		-1,
		176,
		164,
		150,
		167,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		234,
		-1,
		217,
		-1,
		-1,
		-1,
		203,
		218,
		230,
		207,
		180,
		175,
		168,
		162,
		158,
		174,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		217,
		234,
		229,
		211,
		215,
		257,
		-1,
		-1,
		184,
		175,
		166,
		169,
		168,
		171,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		186,
		-1,
		-1,
		-1,
		237,
		-1,
		252,
		-1,
		-1,
		230,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		182,
		174,
		162,
		166,
		189,
		178,
		217,
		-1,
		-1,
		356,
		-1,
		-1,
		-1,
		266,
		241,
		256,
		266,
		250,
		257,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		179,
		186,
		186,
		178,
		156,
		163,
		179,
		178,
		173,
		209,
		200,
		206,
		-1,
		-1,
		349,
		338,
		327,
		333,
		-1,
		266,
		258,
		252,
		242,
		245,
		-1,
		-1,
		233,
		230,
		206,
		189,
		187,
		180,
		175,
		185,
		165,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		244,
		325,
		318,
		301,
		309,
		340,
		-1,
		256,
		248,
		259,
		234,
		236,
		-1,
		-1,
		206,
		203,
		208,
		196,
		193,
		195,
		190,
		181,
		166,
		172,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		258,
		301,
		295,
		298,
		322,
		336,
		-1,
		253,
		-1,
		-1,
		265,
		237,
		221,
		211,
		205,
		255,
		210,
		205,
		189,
		187,
		178,
		169,
		176,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		293,
		281,
		289,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		281,
		-1,
		248,
		-1,
		223,
		227,
		218,
		221,
		203,
		190,
		182,
		174,
		190,
		165,
		175,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		324,
		280,
		283,
		280,
		305,
		320,
		324,
		-1,
		265,
		304,
		302,
		-1,
		286,
		-1,
		-1,
		-1,
		237,
		231,
		223,
		223,
		202,
		202,
		176,
		180,
		170,
		177,
		187,
		189,
		181,
		185,
		198,
		209,
		212,
		320,
		311,
		324,
		269,
		269,
		290,
		299,
		320,
		280,
		271,
		298,
		309,
		298,
		293,
		280,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		209,
		197,
		180,
		181,
		177,
		180,
		195,
		198,
		188,
		186,
		180,
		212,
		-1,
		313,
		312,
		301,
		298,
		274,
		265,
		260,
		287,
		-1,
		-1,
		282,
		299,
		293,
		297,
		313,
		338,
		-1,
		269,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		202,
		191,
		182,
		188,
		185,
		196,
		206,
		194,
		195,
		185,
		195,
		208,
		297,
		294,
		282,
		280,
		303,
		268,
		256,
		-1,
		269,
		267,
		273,
		280,
		297,
		327,
		-1,
		-1,
		285,
		265,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		187,
		192,
		212,
		214,
		203,
		197,
		191,
		198,
		197,
		205,
		213,
		306,
		320,
		309,
		305,
		304,
		312,
		261,
		254,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		-1,
		275,
		271,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		205,
		209,
		201,
		194,
		189,
		200,
		192,
		196,
		213,
		-1,
		340,
		-1,
		292,
		268,
		282,
		297,
		305,
		-1,
		-1,
		-1,
		292,
		278,
		271,
		259,
		257,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		245,
		213,
		218,
		213,
		195,
		206,
		195,
		198,
		212,
		207,
		-1,
		-1,
		280,
		283,
		-1,
		-1,
		282,
		284,
		-1,
		283,
		272,
		257,
		249,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		202,
		227,
		216,
		224,
		219,
		199,
		205,
		208,
		197,
		201,
		213,
		-1,
		-1,
		287,
		288,
		289,
		-1,
		267,
		-1,
		285,
		-1,
		252,
		258,
		246,
		-1,
		-1,
		-1,
		240,
		203,
		224,
		234,
		228,
		226,
		217,
		203,
		210,
		208,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		259,
		292,
		283,
		266,
		246,
		238,
		257,
		-1,
		227,
		-1,
		202,
		204,
		230,
		233,
		239,
		233,
		206,
		221,
		211,
		202,
		211,
		291,
		-1,
		261,
		294,
		258,
		252,
		228,
		232,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		255,
		240,
		221,
		208,
		215,
		215,
		208,
		-1,
		-1,
		-1,
		263,
		262,
		254,
		248,
		248,
		233,
		224,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		245,
		241,
		228,
		228,
		220,
		-1,
		364,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		257,
		252,
		225,
		213,
		219,
		215,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		221,
		256,
		-1,
		359,
		-1,
		293,
		-1,
		-1,
		275,
		255,
		247,
		236,
		225,
		223,
		214,
		205,
		227,
		243,
		227,
		225,
		228,
		229,
		-1,
		348,
		347,
		-1,
		294,
		286,
		272,
		-1,
		265,
		-1,
		271,
		232,
		-1,
		234,
		214,
		-1,
		236,
		232,
		-1,
		-1,
		335,
		310,
		-1,
		-1,
		-1,
		295,
		275,
		266,
		250,
		-1,
		225,
		225,
		-1,
		-1,
		-1,
		320,
		319,
		-1,
		288,
		291,
		-1,
		281,
		272,
		280,
		227,
		231,
		-1,
		-1,
		-1,
		329,
		310,
		304,
		303,
		301,
		296,
		293,
		279,
		263,
		241,
		230,
		251,
		-1,
		-1,
		-1,
		301,
		293,
		286,
		-1,
		-1,
		288,
		271,
		252,
		250,
		-1,
		-1,
		-1,
		323,
		304,
		-1,
		-1,
		278,
		-1,
		-1,
		284,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		312,
		-1,
		-1,
		-1,
		274,
		270,
		271,
		-1,
		-1,
		-1,
		-1,
		334,
		335,
		358,
		322,
		-1,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		337,
		335,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		264,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		299,
		-1,
		299,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		312,
		-1,
		284,
		286,
		-1,
		334,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		289,
		296,
		318,
		321,
		357,
		-1,
		308
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		116,
		105,
		116,
		124,
		97,
		104,
		-1,
		125,
		127,
		93,
		87,
		126,
		97,
		103,
		114,
		-1,
		-1,
		-1,
		116,
		115,
		85,
		83,
		92,
		97,
		104,
		-1,
		127,
		-1,
		137,
		116,
		127,
		132,
		78,
		75,
		95,
		114,
		120,
		112,
		152,
		108,
		79,
		73,
		91,
		96,
		114,
		106,
		-1,
		79,
		69,
		91,
		95,
		107,
		90,
		-1,
		-1,
		73,
		74,
		80,
		92,
		97,
		102,
		-1,
		128,
		147,
		-1,
		-1,
		63,
		76,
		72,
		75,
		83,
		99,
		120,
		137,
		142,
		-1,
		-1,
		64,
		68,
		81,
		82,
		80,
		107,
		126,
		137,
		151,
		150,
		-1,
		52,
		70,
		79,
		88,
		94,
		83,
		87,
		105,
		136,
		142,
		145,
		-1,
		44,
		46,
		75,
		81,
		93,
		99,
		86,
		92,
		111,
		124,
		143,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		0,
		41,
		49,
		75,
		74,
		70,
		88,
		110,
		89,
		95,
		99,
		116,
		132,
		133,
		143,
		-1,
		-1,
		86,
		59,
		82,
		33,
		5,
		-1,
		37,
		56,
		62,
		66,
		71,
		79,
		107,
		105,
		-1,
		110,
		109,
		140,
		126,
		137,
		83,
		-1,
		-1,
		44,
		36,
		13,
		10,
		31,
		36,
		58,
		57,
		66,
		68,
		70,
		82,
		97,
		97,
		107,
		104,
		114,
		118,
		133,
		144,
		-1,
		-1,
		218,
		-1,
		-1,
		80,
		63,
		-1,
		26,
		20,
		26,
		43,
		34,
		59,
		66,
		70,
		82,
		85,
		73,
		92,
		89,
		113,
		109,
		101,
		126,
		130,
		136,
		154,
		155,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		33,
		30,
		32,
		56,
		55,
		-1,
		81,
		79,
		103,
		91,
		98,
		94,
		79,
		97,
		95,
		110,
		112,
		108,
		110,
		147,
		138,
		159,
		156,
		187,
		193,
		187,
		196,
		-1,
		88,
		84,
		80,
		87,
		36,
		-1,
		-1,
		60,
		-1,
		63,
		76,
		93,
		83,
		86,
		92,
		100,
		101,
		85,
		103,
		98,
		101,
		120,
		116,
		125,
		135,
		134,
		152,
		165,
		180,
		184,
		190,
		-1,
		138,
		-1,
		80,
		64,
		66,
		42,
		70,
		-1,
		80,
		64,
		84,
		95,
		95,
		-1,
		108,
		105,
		115,
		101,
		86,
		103,
		105,
		109,
		119,
		123,
		138,
		129,
		147,
		154,
		162,
		166,
		186,
		198,
		98,
		88,
		-1,
		70,
		75,
		45,
		57,
		93,
		107,
		91,
		-1,
		106,
		-1,
		110,
		123,
		-1,
		107,
		103,
		92,
		108,
		116,
		123,
		126,
		120,
		117,
		135,
		138,
		155,
		159,
		175,
		-1,
		-1,
		83,
		87,
		108,
		51,
		78,
		102,
		139,
		100,
		109,
		111,
		-1,
		128,
		128,
		125,
		126,
		112,
		105,
		106,
		122,
		128,
		124,
		119,
		122,
		144,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		85,
		56,
		80,
		122,
		139,
		132,
		120,
		140,
		140,
		139,
		-1,
		143,
		122,
		119,
		110,
		118,
		132,
		129,
		143,
		123,
		125,
		141,
		153,
		144,
		164,
		-1,
		-1,
		-1,
		115,
		104,
		105,
		59,
		93,
		111,
		173,
		159,
		164,
		139,
		137,
		131,
		137,
		139,
		134,
		128,
		120,
		109,
		125,
		133,
		135,
		125,
		134,
		135,
		159,
		166,
		172,
		-1,
		-1,
		122,
		112,
		96,
		98,
		95,
		84,
		91,
		123,
		164,
		166,
		-1,
		136,
		-1,
		125,
		133,
		132,
		128,
		125,
		122,
		116,
		125,
		139,
		139,
		130,
		145,
		164,
		164,
		156,
		181,
		184,
		-1,
		-1,
		-1,
		115,
		132,
		107,
		84,
		65,
		101,
		-1,
		136,
		137,
		-1,
		130,
		124,
		130,
		129,
		131,
		126,
		130,
		123,
		130,
		126,
		140,
		149,
		131,
		167,
		-1,
		164,
		158,
		186,
		180,
		168,
		-1,
		-1,
		-1,
		130,
		109,
		102,
		122,
		72,
		124,
		-1,
		-1,
		121,
		114,
		-1,
		117,
		117,
		124,
		133,
		127,
		131,
		135,
		124,
		137,
		142,
		136,
		146,
		166,
		170,
		177,
		170,
		166,
		163,
		177,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		92,
		-1,
		129,
		121,
		112,
		106,
		112,
		130,
		128,
		148,
		139,
		142,
		142,
		138,
		146,
		131,
		134,
		139,
		143,
		161,
		176,
		168,
		162,
		161,
		173,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		107,
		-1,
		78,
		102,
		118,
		-1,
		146,
		125,
		148,
		126,
		140,
		136,
		162,
		163,
		141,
		146,
		145,
		155,
		156,
		145,
		151,
		150,
		170,
		172,
		156,
		157,
		166,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		81,
		94,
		105,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		150,
		148,
		152,
		143,
		149,
		156,
		159,
		160,
		150,
		139,
		145,
		144,
		166,
		152,
		150,
		169,
		185,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		160,
		144,
		149,
		-1,
		185,
		-1,
		158,
		160,
		152,
		141,
		138,
		149,
		147,
		158,
		175,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		138,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		176,
		156,
		150,
		149,
		180,
		178,
		166,
		150,
		143,
		140,
		141,
		154,
		174,
		165,
		177,
		-1,
		-1,
		-1,
		139,
		119,
		125,
		83,
		104,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		193,
		181,
		171,
		161,
		195,
		194,
		169,
		162,
		148,
		150,
		148,
		150,
		155,
		176,
		177,
		190,
		-1,
		-1,
		116,
		123,
		111,
		97,
		116,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		182,
		-1,
		-1,
		173,
		171,
		181,
		165,
		152,
		172,
		175,
		165,
		149,
		164,
		176,
		184,
		189,
		-1,
		119,
		106,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		175,
		196,
		210,
		176,
		-1,
		181,
		176,
		156,
		170,
		177,
		167,
		162,
		156,
		159,
		177,
		194,
		-1,
		-1,
		133,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		154,
		168,
		189,
		192,
		196,
		-1,
		184,
		172,
		158,
		175,
		180,
		177,
		168,
		160,
		165,
		162,
		175,
		189,
		193,
		156,
		-1,
		139,
		-1,
		-1,
		-1,
		172,
		187,
		238,
		215,
		188,
		183,
		176,
		170,
		166,
		182,
		188,
		199,
		167,
		163,
		164,
		168,
		167,
		184,
		194,
		-1,
		-1,
		139,
		156,
		191,
		180,
		184,
		265,
		-1,
		-1,
		192,
		183,
		174,
		177,
		176,
		179,
		173,
		170,
		175,
		180,
		168,
		177,
		195,
		194,
		-1,
		-1,
		-1,
		159,
		-1,
		174,
		-1,
		-1,
		199,
		263,
		210,
		192,
		188,
		186,
		179,
		188,
		183,
		178,
		188,
		190,
		182,
		170,
		174,
		197,
		186,
		225,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		188,
		163,
		178,
		224,
		219,
		220,
		225,
		222,
		-1,
		192,
		217,
		189,
		196,
		187,
		194,
		194,
		186,
		164,
		171,
		187,
		186,
		181,
		217,
		208,
		214,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		194,
		180,
		210,
		200,
		206,
		-1,
		-1,
		241,
		238,
		214,
		197,
		195,
		188,
		183,
		193,
		173,
		160,
		164,
		168,
		174,
		179,
		184,
		190,
		205,
		220,
		-1,
		164,
		245,
		238,
		221,
		229,
		260,
		-1,
		197,
		206,
		187,
		192,
		200,
		-1,
		-1,
		214,
		211,
		216,
		204,
		201,
		203,
		198,
		189,
		174,
		180,
		167,
		166,
		184,
		188,
		197,
		204,
		194,
		207,
		211,
		-1,
		178,
		221,
		215,
		218,
		242,
		256,
		-1,
		210,
		-1,
		-1,
		195,
		213,
		221,
		217,
		213,
		263,
		218,
		213,
		197,
		195,
		186,
		177,
		184,
		175,
		175,
		178,
		193,
		198,
		190,
		204,
		204,
		205,
		-1,
		213,
		201,
		209,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		211,
		-1,
		247,
		-1,
		231,
		235,
		226,
		229,
		211,
		198,
		190,
		182,
		198,
		173,
		183,
		179,
		180,
		189,
		200,
		212,
		211,
		212,
		287,
		242,
		209,
		200,
		247,
		262,
		266,
		-1,
		223,
		262,
		249,
		-1,
		220,
		-1,
		-1,
		-1,
		245,
		239,
		231,
		231,
		210,
		210,
		184,
		188,
		178,
		185,
		195,
		197,
		189,
		193,
		206,
		217,
		220,
		283,
		281,
		286,
		231,
		214,
		232,
		241,
		262,
		238,
		229,
		256,
		256,
		245,
		240,
		227,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		217,
		205,
		188,
		189,
		185,
		188,
		203,
		206,
		196,
		194,
		188,
		220,
		-1,
		283,
		282,
		271,
		268,
		244,
		235,
		222,
		233,
		-1,
		-1,
		241,
		257,
		270,
		274,
		287,
		312,
		-1,
		230,
		-1,
		-1,
		262,
		-1,
		-1,
		247,
		210,
		199,
		190,
		196,
		193,
		204,
		214,
		202,
		203,
		193,
		203,
		216,
		267,
		264,
		252,
		250,
		273,
		230,
		226,
		-1,
		256,
		244,
		250,
		257,
		274,
		301,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		245,
		243,
		232,
		-1,
		222,
		195,
		200,
		220,
		222,
		211,
		205,
		199,
		206,
		205,
		213,
		221,
		276,
		290,
		279,
		275,
		274,
		282,
		231,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		-1,
		281,
		256,
		-1,
		-1,
		240,
		233,
		221,
		209,
		199,
		209,
		213,
		217,
		209,
		202,
		197,
		208,
		200,
		204,
		221,
		-1,
		310,
		-1,
		262,
		255,
		270,
		285,
		293,
		-1,
		-1,
		-1,
		298,
		284,
		277,
		265,
		263,
		-1,
		274,
		258,
		239,
		-1,
		209,
		222,
		253,
		221,
		226,
		221,
		203,
		214,
		203,
		206,
		220,
		215,
		-1,
		-1,
		268,
		271,
		-1,
		-1,
		290,
		292,
		-1,
		289,
		278,
		263,
		255,
		-1,
		-1,
		246,
		242,
		-1,
		-1,
		210,
		235,
		224,
		232,
		227,
		207,
		213,
		216,
		205,
		209,
		221,
		-1,
		-1,
		275,
		276,
		281,
		-1,
		275,
		-1,
		293,
		-1,
		258,
		266,
		254,
		-1,
		-1,
		-1,
		248,
		211,
		232,
		242,
		236,
		234,
		225,
		211,
		218,
		216,
		212,
		223,
		-1,
		-1,
		-1,
		293,
		267,
		300,
		291,
		274,
		254,
		246,
		265,
		-1,
		235,
		-1,
		210,
		212,
		238,
		241,
		247,
		241,
		214,
		229,
		219,
		210,
		219,
		299,
		-1,
		269,
		302,
		266,
		260,
		236,
		240,
		256,
		-1,
		232,
		214,
		-1,
		242,
		232,
		263,
		248,
		229,
		216,
		223,
		223,
		216,
		-1,
		-1,
		-1,
		271,
		270,
		262,
		256,
		256,
		241,
		232,
		-1,
		244,
		226,
		205,
		222,
		222,
		213,
		221,
		253,
		249,
		236,
		236,
		228,
		-1,
		372,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		265,
		260,
		233,
		221,
		227,
		223,
		209,
		215,
		217,
		225,
		223,
		220,
		232,
		228,
		248,
		229,
		264,
		-1,
		367,
		-1,
		301,
		-1,
		-1,
		283,
		263,
		255,
		244,
		233,
		231,
		222,
		213,
		235,
		251,
		235,
		233,
		236,
		237,
		-1,
		356,
		355,
		-1,
		302,
		294,
		280,
		-1,
		273,
		-1,
		279,
		240,
		-1,
		242,
		222,
		-1,
		244,
		240,
		-1,
		-1,
		343,
		318,
		-1,
		-1,
		-1,
		303,
		283,
		274,
		258,
		-1,
		233,
		233,
		-1,
		-1,
		-1,
		328,
		327,
		-1,
		296,
		299,
		-1,
		289,
		280,
		288,
		235,
		239,
		-1,
		-1,
		-1,
		337,
		318,
		312,
		311,
		309,
		304,
		301,
		287,
		271,
		249,
		238,
		259,
		-1,
		-1,
		-1,
		309,
		301,
		294,
		-1,
		-1,
		296,
		279,
		260,
		258,
		-1,
		-1,
		-1,
		331,
		312,
		-1,
		-1,
		286,
		-1,
		-1,
		292,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		348,
		320,
		-1,
		-1,
		-1,
		282,
		278,
		279,
		-1,
		-1,
		-1,
		-1,
		342,
		343,
		366,
		330,
		-1,
		-1,
		-1,
		274,
		268,
		-1,
		-1,
		345,
		343,
		-1,
		-1,
		-1,
		302,
		286,
		-1,
		272,
		-1,
		-1,
		-1,
		293,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		307,
		-1,
		307,
		282,
		289,
		-1,
		-1,
		-1,
		-1,
		320,
		312,
		320,
		-1,
		292,
		294,
		-1,
		342,
		-1,
		-1,
		335,
		326,
		-1,
		-1,
		297,
		304,
		326,
		329,
		365,
		-1,
		316
	],
	[
		-1,
		77,
		66,
		77,
		85,
		58,
		65,
		-1,
		86,
		88,
		54,
		48,
		87,
		58,
		64,
		75,
		-1,
		-1,
		-1,
		77,
		76,
		46,
		44,
		53,
		58,
		65,
		-1,
		88,
		-1,
		98,
		77,
		88,
		93,
		39,
		36,
		56,
		75,
		81,
		73,
		113,
		69,
		40,
		34,
		52,
		57,
		75,
		67,
		-1,
		40,
		30,
		52,
		56,
		68,
		51,
		-1,
		-1,
		34,
		35,
		41,
		53,
		58,
		63,
		-1,
		89,
		108,
		-1,
		-1,
		24,
		37,
		33,
		36,
		44,
		60,
		81,
		98,
		103,
		-1,
		-1,
		25,
		29,
		42,
		43,
		41,
		68,
		87,
		98,
		112,
		111,
		-1,
		13,
		31,
		40,
		49,
		55,
		44,
		48,
		66,
		97,
		103,
		106,
		-1,
		5,
		7,
		36,
		42,
		54,
		60,
		47,
		53,
		72,
		85,
		104,
		95,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		0,
		20,
		36,
		35,
		41,
		59,
		76,
		50,
		56,
		60,
		77,
		93,
		94,
		104,
		-1,
		-1,
		106,
		79,
		103,
		61,
		41,
		-1,
		8,
		27,
		33,
		37,
		42,
		50,
		78,
		66,
		-1,
		71,
		70,
		101,
		87,
		98,
		88,
		-1,
		-1,
		64,
		56,
		38,
		41,
		18,
		14,
		33,
		32,
		37,
		39,
		41,
		53,
		68,
		68,
		78,
		65,
		75,
		79,
		94,
		105,
		-1,
		-1,
		179,
		-1,
		-1,
		85,
		68,
		-1,
		33,
		40,
		24,
		30,
		16,
		37,
		41,
		45,
		53,
		56,
		44,
		63,
		60,
		84,
		80,
		62,
		87,
		91,
		97,
		115,
		116,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		40,
		37,
		30,
		54,
		53,
		-1,
		59,
		57,
		79,
		64,
		69,
		65,
		50,
		68,
		66,
		81,
		83,
		69,
		71,
		108,
		99,
		120,
		117,
		148,
		154,
		148,
		157,
		-1,
		93,
		89,
		85,
		92,
		41,
		-1,
		-1,
		58,
		-1,
		61,
		74,
		71,
		61,
		64,
		65,
		73,
		72,
		56,
		74,
		69,
		72,
		81,
		77,
		86,
		96,
		95,
		113,
		126,
		141,
		145,
		151,
		-1,
		143,
		-1,
		85,
		69,
		71,
		47,
		75,
		-1,
		78,
		62,
		82,
		73,
		73,
		-1,
		81,
		78,
		88,
		72,
		57,
		74,
		76,
		80,
		80,
		84,
		99,
		90,
		108,
		115,
		123,
		127,
		147,
		159,
		103,
		93,
		-1,
		75,
		80,
		50,
		62,
		85,
		105,
		89,
		-1,
		84,
		-1,
		83,
		96,
		-1,
		78,
		74,
		63,
		79,
		82,
		89,
		87,
		81,
		78,
		96,
		99,
		116,
		120,
		136,
		-1,
		-1,
		88,
		92,
		100,
		51,
		70,
		94,
		131,
		98,
		91,
		90,
		-1,
		101,
		99,
		96,
		97,
		83,
		76,
		77,
		88,
		94,
		95,
		80,
		83,
		105,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		77,
		48,
		72,
		114,
		120,
		113,
		101,
		118,
		118,
		125,
		-1,
		114,
		93,
		90,
		81,
		89,
		103,
		100,
		104,
		84,
		86,
		102,
		114,
		105,
		125,
		-1,
		-1,
		-1,
		107,
		96,
		97,
		51,
		85,
		103,
		151,
		137,
		142,
		117,
		123,
		123,
		108,
		110,
		105,
		99,
		91,
		80,
		96,
		104,
		106,
		86,
		95,
		96,
		120,
		127,
		133,
		-1,
		-1,
		114,
		104,
		88,
		90,
		87,
		76,
		83,
		115,
		142,
		158,
		-1,
		128,
		-1,
		117,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		110,
		100,
		91,
		106,
		125,
		125,
		117,
		142,
		145,
		-1,
		-1,
		-1,
		107,
		124,
		99,
		76,
		57,
		93,
		-1,
		128,
		129,
		-1,
		122,
		116,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		97,
		109,
		110,
		92,
		128,
		-1,
		125,
		119,
		147,
		150,
		139,
		-1,
		-1,
		-1,
		122,
		101,
		94,
		114,
		64,
		116,
		-1,
		-1,
		113,
		106,
		-1,
		109,
		99,
		106,
		104,
		98,
		102,
		106,
		95,
		108,
		113,
		97,
		107,
		127,
		131,
		138,
		131,
		136,
		134,
		148,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		84,
		-1,
		121,
		113,
		104,
		98,
		104,
		112,
		110,
		126,
		110,
		113,
		113,
		109,
		117,
		102,
		105,
		100,
		104,
		122,
		147,
		139,
		133,
		132,
		144,
		-1,
		170,
		156,
		127,
		-1,
		-1,
		99,
		-1,
		70,
		94,
		110,
		-1,
		138,
		117,
		140,
		118,
		122,
		118,
		133,
		134,
		112,
		117,
		116,
		126,
		127,
		116,
		112,
		116,
		131,
		141,
		127,
		128,
		137,
		-1,
		176,
		163,
		121,
		117,
		106,
		126,
		73,
		86,
		97,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		132,
		130,
		123,
		114,
		120,
		127,
		130,
		131,
		121,
		110,
		116,
		115,
		137,
		123,
		121,
		140,
		156,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		92,
		79,
		73,
		-1,
		114,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		131,
		115,
		120,
		-1,
		156,
		-1,
		129,
		131,
		123,
		112,
		109,
		120,
		118,
		129,
		146,
		-1,
		126,
		111,
		104,
		94,
		108,
		79,
		-1,
		130,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		147,
		127,
		121,
		120,
		151,
		149,
		137,
		121,
		114,
		111,
		112,
		125,
		145,
		136,
		148,
		-1,
		-1,
		-1,
		131,
		111,
		117,
		75,
		96,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		164,
		152,
		142,
		132,
		166,
		165,
		140,
		133,
		119,
		121,
		119,
		121,
		126,
		147,
		148,
		161,
		-1,
		-1,
		108,
		115,
		103,
		89,
		108,
		-1,
		-1,
		-1,
		156,
		172,
		164,
		135,
		153,
		-1,
		-1,
		144,
		142,
		152,
		136,
		123,
		143,
		146,
		136,
		120,
		135,
		147,
		155,
		160,
		-1,
		111,
		98,
		-1,
		-1,
		111,
		105,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		167,
		177,
		181,
		147,
		-1,
		152,
		147,
		127,
		141,
		148,
		138,
		133,
		127,
		130,
		148,
		165,
		-1,
		-1,
		125,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		146,
		160,
		170,
		163,
		167,
		-1,
		155,
		143,
		129,
		146,
		151,
		148,
		139,
		131,
		136,
		133,
		146,
		160,
		164,
		148,
		-1,
		131,
		-1,
		-1,
		-1,
		164,
		179,
		209,
		186,
		159,
		154,
		147,
		141,
		137,
		153,
		159,
		170,
		138,
		134,
		135,
		139,
		138,
		155,
		165,
		-1,
		-1,
		131,
		148,
		183,
		172,
		176,
		236,
		-1,
		-1,
		163,
		154,
		145,
		148,
		147,
		150,
		144,
		141,
		146,
		151,
		139,
		148,
		166,
		165,
		-1,
		-1,
		-1,
		151,
		-1,
		166,
		-1,
		-1,
		191,
		234,
		181,
		163,
		159,
		157,
		150,
		159,
		154,
		149,
		159,
		161,
		153,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		180,
		155,
		170,
		216,
		211,
		212,
		196,
		193,
		-1,
		163,
		188,
		160,
		167,
		158,
		165,
		165,
		157,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		186,
		172,
		202,
		192,
		198,
		-1,
		-1,
		212,
		209,
		185,
		168,
		166,
		159,
		154,
		164,
		144,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		156,
		237,
		230,
		213,
		221,
		252,
		-1,
		189,
		198,
		179,
		184,
		192,
		-1,
		-1,
		185,
		182,
		187,
		175,
		172,
		174,
		169,
		160,
		145,
		151,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		170,
		213,
		207,
		210,
		234,
		248,
		-1,
		202,
		-1,
		-1,
		187,
		205,
		200,
		190,
		184,
		234,
		189,
		184,
		168,
		166,
		157,
		148,
		155,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		205,
		193,
		201,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		203,
		-1,
		227,
		-1,
		202,
		206,
		197,
		200,
		182,
		169,
		161,
		153,
		169,
		144,
		154,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		279,
		234,
		201,
		192,
		239,
		254,
		258,
		-1,
		215,
		254,
		241,
		-1,
		212,
		-1,
		-1,
		-1,
		216,
		210,
		202,
		202,
		181,
		181,
		155,
		159,
		149,
		156,
		166,
		168,
		160,
		164,
		177,
		188,
		191,
		275,
		273,
		278,
		223,
		206,
		224,
		233,
		254,
		230,
		221,
		248,
		248,
		237,
		232,
		219,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		188,
		176,
		159,
		160,
		156,
		159,
		174,
		177,
		167,
		165,
		159,
		191,
		-1,
		275,
		274,
		263,
		260,
		236,
		227,
		214,
		225,
		-1,
		-1,
		233,
		249,
		262,
		266,
		279,
		304,
		-1,
		222,
		-1,
		-1,
		233,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		164,
		175,
		185,
		173,
		174,
		164,
		174,
		187,
		259,
		256,
		244,
		242,
		265,
		222,
		218,
		-1,
		248,
		236,
		242,
		249,
		266,
		293,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		216,
		214,
		203,
		-1,
		193,
		166,
		171,
		191,
		193,
		182,
		176,
		170,
		177,
		176,
		184,
		192,
		268,
		282,
		271,
		267,
		266,
		274,
		223,
		233,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		254,
		248,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		184,
		188,
		180,
		173,
		168,
		179,
		171,
		175,
		192,
		-1,
		302,
		-1,
		254,
		247,
		261,
		276,
		284,
		-1,
		-1,
		-1,
		271,
		257,
		250,
		238,
		236,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		174,
		185,
		174,
		177,
		191,
		186,
		-1,
		-1,
		259,
		262,
		-1,
		-1,
		261,
		263,
		-1,
		262,
		251,
		236,
		228,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		178,
		184,
		187,
		176,
		180,
		192,
		-1,
		-1,
		266,
		267,
		268,
		-1,
		246,
		-1,
		264,
		-1,
		231,
		237,
		225,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		207,
		205,
		196,
		182,
		189,
		187,
		183,
		194,
		-1,
		-1,
		-1,
		264,
		238,
		271,
		262,
		245,
		225,
		217,
		236,
		-1,
		206,
		-1,
		181,
		183,
		209,
		212,
		218,
		212,
		185,
		200,
		190,
		181,
		190,
		270,
		-1,
		240,
		273,
		237,
		231,
		207,
		211,
		227,
		-1,
		203,
		185,
		-1,
		213,
		203,
		234,
		219,
		200,
		187,
		194,
		194,
		187,
		-1,
		-1,
		-1,
		242,
		241,
		233,
		227,
		227,
		212,
		203,
		-1,
		215,
		197,
		176,
		193,
		193,
		184,
		192,
		224,
		220,
		207,
		207,
		199,
		-1,
		343,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		236,
		231,
		204,
		192,
		198,
		194,
		180,
		186,
		188,
		196,
		194,
		191,
		203,
		199,
		219,
		200,
		235,
		-1,
		338,
		-1,
		272,
		-1,
		-1,
		254,
		234,
		226,
		215,
		204,
		202,
		193,
		184,
		206,
		222,
		206,
		204,
		207,
		208,
		-1,
		327,
		326,
		-1,
		273,
		265,
		251,
		-1,
		244,
		-1,
		250,
		211,
		-1,
		213,
		193,
		-1,
		215,
		211,
		-1,
		-1,
		314,
		289,
		-1,
		-1,
		-1,
		274,
		254,
		245,
		229,
		-1,
		204,
		204,
		-1,
		-1,
		-1,
		299,
		298,
		-1,
		267,
		270,
		-1,
		260,
		251,
		259,
		206,
		210,
		-1,
		-1,
		-1,
		308,
		289,
		283,
		282,
		280,
		275,
		272,
		258,
		242,
		220,
		209,
		230,
		-1,
		-1,
		-1,
		280,
		272,
		265,
		-1,
		-1,
		267,
		250,
		231,
		229,
		-1,
		-1,
		-1,
		302,
		283,
		-1,
		-1,
		257,
		-1,
		-1,
		263,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		291,
		-1,
		-1,
		-1,
		253,
		249,
		250,
		-1,
		-1,
		-1,
		-1,
		313,
		314,
		337,
		301,
		-1,
		-1,
		-1,
		245,
		239,
		-1,
		-1,
		316,
		314,
		-1,
		-1,
		-1,
		273,
		257,
		-1,
		243,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		278,
		-1,
		278,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		291,
		283,
		291,
		-1,
		263,
		265,
		-1,
		313,
		-1,
		-1,
		306,
		297,
		-1,
		-1,
		268,
		275,
		297,
		300,
		336,
		-1,
		287
	],
	[
		-1,
		75,
		64,
		75,
		83,
		56,
		63,
		-1,
		84,
		86,
		52,
		46,
		85,
		56,
		62,
		73,
		-1,
		-1,
		-1,
		75,
		74,
		44,
		42,
		51,
		56,
		63,
		-1,
		86,
		-1,
		96,
		75,
		86,
		91,
		37,
		34,
		54,
		73,
		79,
		71,
		111,
		67,
		38,
		32,
		50,
		55,
		73,
		65,
		-1,
		38,
		28,
		50,
		54,
		66,
		49,
		-1,
		-1,
		32,
		33,
		39,
		51,
		56,
		61,
		-1,
		87,
		106,
		-1,
		-1,
		22,
		35,
		31,
		34,
		42,
		58,
		79,
		96,
		101,
		-1,
		-1,
		23,
		27,
		40,
		41,
		39,
		66,
		85,
		96,
		110,
		109,
		-1,
		11,
		29,
		38,
		47,
		53,
		42,
		46,
		64,
		95,
		101,
		104,
		-1,
		17,
		18,
		34,
		40,
		51,
		58,
		45,
		51,
		70,
		83,
		102,
		93,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		51,
		17,
		0,
		29,
		28,
		21,
		39,
		61,
		48,
		54,
		58,
		75,
		91,
		92,
		102,
		-1,
		-1,
		111,
		84,
		108,
		66,
		47,
		-1,
		13,
		7,
		13,
		17,
		22,
		30,
		58,
		58,
		-1,
		69,
		68,
		99,
		85,
		96,
		93,
		-1,
		-1,
		69,
		61,
		43,
		46,
		23,
		19,
		22,
		21,
		17,
		19,
		21,
		33,
		48,
		48,
		58,
		63,
		73,
		77,
		92,
		103,
		-1,
		-1,
		177,
		-1,
		-1,
		90,
		73,
		-1,
		38,
		45,
		29,
		35,
		21,
		42,
		32,
		26,
		33,
		36,
		24,
		43,
		40,
		64,
		60,
		60,
		85,
		89,
		95,
		113,
		114,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		45,
		42,
		35,
		59,
		58,
		-1,
		64,
		58,
		59,
		44,
		49,
		45,
		30,
		48,
		46,
		61,
		63,
		67,
		69,
		106,
		97,
		118,
		115,
		146,
		152,
		146,
		155,
		-1,
		98,
		94,
		90,
		97,
		46,
		-1,
		-1,
		63,
		-1,
		66,
		79,
		76,
		55,
		58,
		45,
		53,
		52,
		36,
		54,
		49,
		52,
		72,
		75,
		84,
		94,
		93,
		111,
		124,
		139,
		143,
		149,
		-1,
		148,
		-1,
		90,
		74,
		76,
		52,
		80,
		-1,
		83,
		67,
		87,
		78,
		78,
		-1,
		61,
		58,
		68,
		52,
		37,
		54,
		56,
		60,
		71,
		82,
		97,
		88,
		106,
		113,
		121,
		125,
		145,
		157,
		108,
		98,
		-1,
		80,
		85,
		55,
		67,
		90,
		110,
		94,
		-1,
		89,
		-1,
		63,
		76,
		-1,
		58,
		54,
		43,
		59,
		67,
		74,
		78,
		79,
		76,
		94,
		97,
		114,
		118,
		134,
		-1,
		-1,
		93,
		97,
		105,
		56,
		75,
		99,
		136,
		103,
		96,
		95,
		-1,
		81,
		79,
		76,
		77,
		63,
		56,
		57,
		73,
		79,
		75,
		78,
		81,
		103,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		82,
		53,
		77,
		119,
		125,
		118,
		106,
		120,
		118,
		105,
		-1,
		94,
		73,
		70,
		61,
		69,
		83,
		80,
		94,
		82,
		84,
		100,
		112,
		103,
		123,
		-1,
		-1,
		-1,
		112,
		101,
		102,
		56,
		90,
		108,
		153,
		139,
		144,
		119,
		107,
		111,
		88,
		90,
		85,
		79,
		71,
		60,
		76,
		84,
		86,
		84,
		93,
		94,
		118,
		125,
		131,
		-1,
		-1,
		119,
		109,
		93,
		95,
		92,
		81,
		88,
		120,
		144,
		162,
		-1,
		116,
		-1,
		105,
		100,
		84,
		79,
		76,
		73,
		67,
		76,
		90,
		98,
		89,
		104,
		123,
		123,
		115,
		140,
		143,
		-1,
		-1,
		-1,
		112,
		129,
		104,
		81,
		62,
		98,
		-1,
		132,
		133,
		-1,
		110,
		104,
		101,
		86,
		82,
		77,
		81,
		74,
		81,
		77,
		91,
		102,
		89,
		125,
		-1,
		123,
		117,
		141,
		131,
		119,
		-1,
		-1,
		-1,
		127,
		106,
		99,
		119,
		69,
		121,
		-1,
		-1,
		117,
		110,
		-1,
		97,
		79,
		86,
		84,
		78,
		82,
		86,
		75,
		88,
		93,
		94,
		104,
		124,
		128,
		132,
		121,
		117,
		114,
		128,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		89,
		-1,
		126,
		118,
		108,
		102,
		96,
		92,
		90,
		106,
		90,
		93,
		93,
		89,
		97,
		82,
		85,
		97,
		101,
		119,
		127,
		119,
		113,
		112,
		124,
		-1,
		175,
		161,
		132,
		-1,
		-1,
		104,
		-1,
		75,
		99,
		115,
		-1,
		134,
		113,
		128,
		106,
		102,
		98,
		113,
		114,
		92,
		97,
		96,
		106,
		107,
		96,
		109,
		101,
		123,
		123,
		107,
		108,
		117,
		-1,
		181,
		168,
		126,
		122,
		111,
		131,
		78,
		91,
		102,
		-1,
		-1,
		170,
		-1,
		104,
		121,
		112,
		110,
		103,
		94,
		100,
		107,
		110,
		111,
		101,
		90,
		96,
		95,
		117,
		103,
		101,
		120,
		136,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		97,
		84,
		78,
		-1,
		119,
		-1,
		148,
		138,
		122,
		107,
		140,
		-1,
		111,
		95,
		100,
		-1,
		136,
		-1,
		109,
		111,
		103,
		92,
		89,
		100,
		98,
		109,
		126,
		-1,
		131,
		116,
		109,
		99,
		113,
		84,
		-1,
		135,
		-1,
		-1,
		135,
		129,
		129,
		113,
		116,
		127,
		107,
		101,
		100,
		131,
		129,
		117,
		101,
		94,
		91,
		92,
		105,
		125,
		116,
		128,
		-1,
		-1,
		-1,
		136,
		116,
		122,
		80,
		101,
		-1,
		-1,
		197,
		152,
		138,
		-1,
		122,
		144,
		132,
		122,
		112,
		146,
		145,
		120,
		113,
		99,
		101,
		99,
		101,
		106,
		127,
		128,
		141,
		-1,
		-1,
		113,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		144,
		160,
		152,
		123,
		133,
		-1,
		-1,
		124,
		122,
		132,
		116,
		103,
		123,
		126,
		116,
		100,
		115,
		127,
		135,
		140,
		-1,
		116,
		103,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		155,
		157,
		161,
		127,
		-1,
		132,
		127,
		107,
		121,
		128,
		118,
		113,
		107,
		110,
		128,
		145,
		-1,
		-1,
		130,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		134,
		148,
		150,
		143,
		147,
		-1,
		135,
		123,
		109,
		126,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		140,
		144,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		152,
		167,
		189,
		166,
		139,
		134,
		127,
		121,
		117,
		133,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		135,
		145,
		-1,
		-1,
		136,
		153,
		178,
		160,
		164,
		216,
		-1,
		-1,
		143,
		134,
		125,
		128,
		127,
		130,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		145,
		-1,
		-1,
		-1,
		156,
		-1,
		171,
		-1,
		-1,
		179,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		141,
		133,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		185,
		160,
		175,
		221,
		199,
		206,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		138,
		145,
		145,
		137,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		191,
		177,
		207,
		197,
		203,
		-1,
		-1,
		192,
		189,
		165,
		148,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		161,
		242,
		235,
		218,
		226,
		257,
		-1,
		194,
		203,
		184,
		189,
		195,
		-1,
		-1,
		165,
		162,
		167,
		155,
		152,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		175,
		218,
		212,
		215,
		239,
		253,
		-1,
		207,
		-1,
		-1,
		192,
		196,
		180,
		170,
		164,
		214,
		169,
		164,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		210,
		198,
		206,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		208,
		-1,
		207,
		-1,
		182,
		186,
		177,
		180,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		283,
		239,
		206,
		197,
		244,
		259,
		263,
		-1,
		220,
		259,
		246,
		-1,
		217,
		-1,
		-1,
		-1,
		196,
		190,
		182,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		279,
		270,
		283,
		228,
		211,
		229,
		238,
		259,
		235,
		226,
		253,
		253,
		242,
		237,
		224,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		272,
		271,
		260,
		257,
		233,
		224,
		219,
		230,
		-1,
		-1,
		238,
		254,
		252,
		256,
		272,
		297,
		-1,
		227,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		256,
		253,
		241,
		239,
		262,
		227,
		215,
		-1,
		228,
		226,
		232,
		239,
		256,
		286,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		265,
		279,
		268,
		264,
		263,
		271,
		220,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		230,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		299,
		-1,
		251,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		246,
		247,
		248,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		93,
		82,
		93,
		101,
		74,
		81,
		-1,
		102,
		104,
		70,
		64,
		103,
		74,
		80,
		91,
		-1,
		-1,
		-1,
		93,
		92,
		62,
		60,
		69,
		74,
		81,
		-1,
		104,
		-1,
		114,
		93,
		104,
		109,
		55,
		52,
		72,
		91,
		97,
		89,
		129,
		85,
		56,
		50,
		68,
		73,
		91,
		83,
		-1,
		56,
		46,
		68,
		72,
		84,
		67,
		-1,
		-1,
		50,
		51,
		57,
		69,
		74,
		79,
		-1,
		105,
		124,
		-1,
		-1,
		40,
		48,
		49,
		52,
		60,
		76,
		97,
		114,
		119,
		-1,
		-1,
		41,
		45,
		51,
		59,
		57,
		84,
		103,
		114,
		128,
		127,
		-1,
		29,
		32,
		41,
		53,
		59,
		60,
		64,
		82,
		113,
		119,
		122,
		-1,
		32,
		31,
		27,
		34,
		48,
		68,
		63,
		69,
		88,
		101,
		120,
		111,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		38,
		29,
		0,
		16,
		32,
		49,
		71,
		66,
		72,
		76,
		93,
		109,
		110,
		120,
		-1,
		-1,
		137,
		110,
		134,
		92,
		73,
		-1,
		39,
		23,
		24,
		28,
		34,
		42,
		68,
		70,
		-1,
		87,
		86,
		117,
		103,
		114,
		119,
		-1,
		-1,
		95,
		87,
		69,
		72,
		49,
		45,
		38,
		37,
		33,
		35,
		37,
		45,
		60,
		60,
		70,
		81,
		91,
		95,
		110,
		121,
		-1,
		-1,
		195,
		-1,
		-1,
		116,
		99,
		-1,
		64,
		71,
		55,
		61,
		47,
		68,
		48,
		42,
		49,
		52,
		40,
		55,
		52,
		76,
		72,
		78,
		103,
		107,
		113,
		131,
		132,
		-1,
		194,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		71,
		68,
		61,
		85,
		84,
		-1,
		86,
		74,
		75,
		60,
		65,
		61,
		46,
		60,
		58,
		73,
		75,
		85,
		87,
		124,
		115,
		136,
		133,
		164,
		170,
		164,
		173,
		-1,
		124,
		120,
		116,
		123,
		72,
		-1,
		-1,
		89,
		-1,
		92,
		105,
		98,
		71,
		74,
		61,
		69,
		68,
		52,
		66,
		61,
		64,
		84,
		93,
		102,
		112,
		111,
		129,
		142,
		157,
		161,
		167,
		-1,
		174,
		-1,
		116,
		100,
		102,
		78,
		106,
		-1,
		109,
		93,
		113,
		100,
		100,
		-1,
		77,
		74,
		84,
		68,
		53,
		70,
		68,
		72,
		83,
		100,
		115,
		106,
		124,
		131,
		139,
		143,
		163,
		175,
		134,
		124,
		-1,
		106,
		111,
		81,
		93,
		116,
		136,
		120,
		-1,
		111,
		-1,
		79,
		92,
		-1,
		74,
		70,
		59,
		75,
		79,
		86,
		90,
		97,
		94,
		112,
		115,
		132,
		136,
		152,
		-1,
		-1,
		119,
		123,
		131,
		82,
		101,
		125,
		162,
		129,
		118,
		117,
		-1,
		97,
		95,
		92,
		93,
		79,
		72,
		73,
		85,
		91,
		91,
		96,
		99,
		121,
		149,
		127,
		139,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		108,
		79,
		103,
		145,
		147,
		140,
		128,
		136,
		134,
		121,
		-1,
		110,
		89,
		86,
		77,
		85,
		99,
		96,
		110,
		100,
		102,
		118,
		130,
		121,
		141,
		-1,
		-1,
		-1,
		138,
		127,
		128,
		82,
		116,
		134,
		169,
		155,
		160,
		135,
		123,
		127,
		104,
		106,
		101,
		95,
		87,
		76,
		92,
		100,
		102,
		102,
		111,
		112,
		136,
		143,
		149,
		-1,
		-1,
		145,
		135,
		119,
		121,
		118,
		107,
		114,
		146,
		160,
		178,
		-1,
		132,
		-1,
		121,
		116,
		100,
		95,
		92,
		89,
		83,
		92,
		106,
		116,
		107,
		120,
		141,
		141,
		133,
		158,
		161,
		-1,
		-1,
		-1,
		138,
		155,
		130,
		107,
		88,
		124,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		102,
		98,
		93,
		97,
		90,
		97,
		93,
		107,
		118,
		105,
		141,
		-1,
		141,
		135,
		157,
		147,
		135,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		95,
		147,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		102,
		100,
		94,
		98,
		102,
		91,
		104,
		109,
		110,
		120,
		140,
		144,
		148,
		137,
		133,
		130,
		144,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		115,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		122,
		106,
		109,
		109,
		105,
		113,
		98,
		101,
		113,
		117,
		135,
		143,
		135,
		129,
		128,
		140,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		130,
		-1,
		101,
		125,
		141,
		-1,
		150,
		129,
		144,
		122,
		118,
		114,
		129,
		130,
		108,
		113,
		112,
		122,
		123,
		112,
		125,
		117,
		139,
		139,
		123,
		124,
		133,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		104,
		112,
		128,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		128,
		126,
		119,
		110,
		116,
		123,
		126,
		127,
		117,
		106,
		112,
		111,
		133,
		119,
		117,
		136,
		152,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		127,
		111,
		116,
		-1,
		152,
		-1,
		125,
		127,
		119,
		108,
		105,
		116,
		114,
		125,
		142,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		161,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		143,
		123,
		117,
		116,
		147,
		145,
		133,
		117,
		110,
		107,
		108,
		121,
		141,
		132,
		144,
		-1,
		-1,
		-1,
		162,
		142,
		148,
		106,
		127,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		160,
		148,
		138,
		128,
		162,
		161,
		136,
		129,
		115,
		117,
		115,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		139,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		160,
		176,
		168,
		139,
		149,
		-1,
		-1,
		140,
		138,
		148,
		132,
		119,
		139,
		142,
		132,
		116,
		131,
		143,
		151,
		156,
		-1,
		142,
		129,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		171,
		173,
		177,
		143,
		-1,
		148,
		143,
		123,
		137,
		144,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		150,
		164,
		166,
		159,
		163,
		-1,
		151,
		139,
		125,
		142,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		168,
		183,
		205,
		182,
		155,
		150,
		143,
		137,
		133,
		149,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		162,
		179,
		194,
		176,
		180,
		232,
		-1,
		-1,
		159,
		150,
		141,
		144,
		143,
		146,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		161,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		195,
		230,
		177,
		159,
		155,
		153,
		146,
		155,
		150,
		145,
		155,
		157,
		149,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		211,
		186,
		201,
		241,
		215,
		222,
		192,
		189,
		-1,
		159,
		184,
		156,
		163,
		154,
		161,
		161,
		153,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		217,
		203,
		227,
		217,
		220,
		-1,
		-1,
		208,
		205,
		181,
		164,
		162,
		155,
		150,
		160,
		140,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		187,
		268,
		261,
		244,
		252,
		283,
		-1,
		220,
		223,
		210,
		209,
		211,
		-1,
		-1,
		181,
		178,
		183,
		171,
		168,
		170,
		165,
		156,
		141,
		147,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		201,
		244,
		238,
		241,
		265,
		279,
		-1,
		228,
		-1,
		-1,
		218,
		212,
		196,
		186,
		180,
		230,
		185,
		180,
		164,
		162,
		153,
		144,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		236,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		234,
		-1,
		223,
		-1,
		198,
		202,
		193,
		196,
		178,
		165,
		157,
		149,
		165,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		299,
		255,
		232,
		223,
		270,
		285,
		289,
		-1,
		240,
		279,
		272,
		-1,
		243,
		-1,
		-1,
		-1,
		212,
		206,
		198,
		198,
		177,
		177,
		151,
		155,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		295,
		286,
		299,
		244,
		237,
		255,
		264,
		285,
		255,
		246,
		273,
		279,
		268,
		263,
		250,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		184,
		172,
		155,
		156,
		152,
		155,
		170,
		173,
		163,
		161,
		155,
		187,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		235,
		256,
		-1,
		-1,
		257,
		274,
		268,
		272,
		288,
		313,
		-1,
		244,
		-1,
		-1,
		229,
		-1,
		-1,
		214,
		177,
		166,
		157,
		163,
		160,
		171,
		181,
		169,
		170,
		160,
		170,
		183,
		272,
		269,
		257,
		255,
		278,
		243,
		231,
		-1,
		244,
		242,
		248,
		255,
		272,
		302,
		-1,
		-1,
		260,
		240,
		-1,
		-1,
		212,
		210,
		199,
		-1,
		189,
		162,
		167,
		187,
		189,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		229,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		250,
		246,
		-1,
		-1,
		207,
		200,
		188,
		176,
		166,
		176,
		180,
		184,
		176,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		315,
		-1,
		267,
		243,
		257,
		272,
		280,
		-1,
		-1,
		-1,
		267,
		253,
		246,
		234,
		232,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		220,
		188,
		193,
		188,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		255,
		258,
		-1,
		-1,
		257,
		259,
		-1,
		258,
		247,
		232,
		224,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		177,
		202,
		191,
		199,
		194,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		262,
		263,
		264,
		-1,
		242,
		-1,
		260,
		-1,
		227,
		233,
		221,
		-1,
		-1,
		-1,
		215,
		178,
		199,
		209,
		203,
		201,
		192,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		260,
		234,
		267,
		258,
		241,
		221,
		213,
		232,
		-1,
		202,
		-1,
		177,
		179,
		205,
		208,
		214,
		208,
		181,
		196,
		186,
		177,
		186,
		266,
		-1,
		236,
		269,
		233,
		227,
		203,
		207,
		223,
		-1,
		199,
		181,
		-1,
		209,
		199,
		230,
		215,
		196,
		183,
		190,
		190,
		183,
		-1,
		-1,
		-1,
		238,
		237,
		229,
		223,
		223,
		208,
		199,
		-1,
		211,
		193,
		172,
		189,
		189,
		180,
		188,
		220,
		216,
		203,
		203,
		195,
		-1,
		339,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		232,
		227,
		200,
		188,
		194,
		190,
		176,
		182,
		184,
		192,
		190,
		187,
		199,
		195,
		215,
		196,
		231,
		-1,
		334,
		-1,
		268,
		-1,
		-1,
		250,
		230,
		222,
		211,
		200,
		198,
		189,
		180,
		202,
		218,
		202,
		200,
		203,
		204,
		-1,
		323,
		322,
		-1,
		269,
		261,
		247,
		-1,
		240,
		-1,
		246,
		207,
		-1,
		209,
		189,
		-1,
		211,
		207,
		-1,
		-1,
		310,
		285,
		-1,
		-1,
		-1,
		270,
		250,
		241,
		225,
		-1,
		200,
		200,
		-1,
		-1,
		-1,
		295,
		294,
		-1,
		263,
		266,
		-1,
		256,
		247,
		255,
		202,
		206,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		278,
		276,
		271,
		268,
		254,
		238,
		216,
		205,
		226,
		-1,
		-1,
		-1,
		276,
		268,
		261,
		-1,
		-1,
		263,
		246,
		227,
		225,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		253,
		-1,
		-1,
		259,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		287,
		-1,
		-1,
		-1,
		249,
		245,
		246,
		-1,
		-1,
		-1,
		-1,
		309,
		310,
		333,
		297,
		-1,
		-1,
		-1,
		241,
		235,
		-1,
		-1,
		312,
		310,
		-1,
		-1,
		-1,
		269,
		253,
		-1,
		239,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		274,
		-1,
		274,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		287,
		279,
		287,
		-1,
		259,
		261,
		-1,
		309,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		264,
		271,
		293,
		296,
		332,
		-1,
		283
	],
	[
		-1,
		101,
		90,
		101,
		109,
		82,
		89,
		-1,
		110,
		112,
		78,
		72,
		111,
		82,
		88,
		99,
		-1,
		-1,
		-1,
		101,
		100,
		70,
		68,
		77,
		82,
		89,
		-1,
		112,
		-1,
		122,
		101,
		112,
		117,
		63,
		60,
		80,
		99,
		105,
		97,
		137,
		93,
		64,
		58,
		76,
		81,
		99,
		91,
		-1,
		64,
		54,
		76,
		80,
		91,
		75,
		-1,
		-1,
		58,
		59,
		65,
		76,
		82,
		87,
		-1,
		113,
		114,
		-1,
		-1,
		48,
		56,
		57,
		60,
		68,
		82,
		105,
		114,
		109,
		-1,
		-1,
		49,
		53,
		51,
		67,
		63,
		92,
		111,
		104,
		118,
		117,
		-1,
		37,
		40,
		39,
		44,
		50,
		68,
		72,
		90,
		103,
		109,
		112,
		-1,
		35,
		34,
		11,
		20,
		34,
		52,
		71,
		77,
		96,
		91,
		110,
		101,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		41,
		32,
		18,
		0,
		20,
		33,
		55,
		67,
		80,
		84,
		83,
		99,
		100,
		110,
		-1,
		-1,
		140,
		113,
		137,
		95,
		76,
		-1,
		42,
		26,
		17,
		21,
		18,
		26,
		52,
		54,
		-1,
		77,
		76,
		107,
		93,
		104,
		122,
		-1,
		-1,
		98,
		90,
		72,
		75,
		52,
		48,
		41,
		40,
		26,
		30,
		37,
		29,
		44,
		44,
		54,
		71,
		81,
		85,
		100,
		111,
		-1,
		-1,
		185,
		-1,
		-1,
		119,
		102,
		-1,
		67,
		74,
		58,
		64,
		50,
		71,
		51,
		35,
		42,
		52,
		40,
		39,
		36,
		60,
		56,
		68,
		93,
		97,
		103,
		121,
		122,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		74,
		71,
		64,
		88,
		87,
		-1,
		84,
		72,
		73,
		58,
		62,
		61,
		46,
		44,
		42,
		57,
		59,
		75,
		77,
		110,
		105,
		126,
		123,
		154,
		160,
		154,
		163,
		-1,
		127,
		123,
		119,
		126,
		75,
		-1,
		-1,
		92,
		-1,
		95,
		108,
		96,
		69,
		72,
		59,
		67,
		68,
		52,
		50,
		45,
		48,
		68,
		81,
		88,
		102,
		101,
		119,
		132,
		147,
		151,
		157,
		-1,
		177,
		-1,
		119,
		103,
		105,
		81,
		109,
		-1,
		112,
		96,
		113,
		98,
		98,
		-1,
		75,
		72,
		82,
		69,
		54,
		63,
		52,
		56,
		67,
		88,
		105,
		96,
		114,
		121,
		129,
		133,
		153,
		165,
		137,
		127,
		-1,
		109,
		114,
		84,
		96,
		119,
		139,
		123,
		-1,
		109,
		-1,
		77,
		90,
		-1,
		75,
		71,
		60,
		74,
		63,
		70,
		74,
		87,
		84,
		102,
		105,
		122,
		126,
		142,
		-1,
		-1,
		122,
		126,
		134,
		85,
		104,
		128,
		165,
		127,
		116,
		115,
		-1,
		95,
		96,
		93,
		94,
		80,
		73,
		74,
		69,
		75,
		84,
		86,
		89,
		111,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		111,
		82,
		106,
		148,
		145,
		138,
		126,
		134,
		132,
		119,
		-1,
		111,
		90,
		87,
		78,
		76,
		92,
		87,
		103,
		90,
		92,
		108,
		120,
		111,
		131,
		-1,
		-1,
		-1,
		141,
		130,
		131,
		85,
		119,
		137,
		167,
		153,
		158,
		133,
		121,
		125,
		105,
		107,
		102,
		93,
		85,
		74,
		90,
		97,
		92,
		92,
		101,
		102,
		126,
		133,
		139,
		-1,
		-1,
		148,
		138,
		122,
		124,
		121,
		110,
		117,
		149,
		158,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		87,
		81,
		90,
		98,
		106,
		97,
		112,
		131,
		131,
		123,
		148,
		151,
		-1,
		-1,
		-1,
		141,
		158,
		133,
		110,
		91,
		127,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		91,
		95,
		88,
		95,
		91,
		105,
		116,
		98,
		134,
		-1,
		131,
		125,
		153,
		145,
		133,
		-1,
		-1,
		-1,
		156,
		135,
		128,
		148,
		98,
		150,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		100,
		98,
		92,
		96,
		100,
		89,
		102,
		107,
		103,
		113,
		133,
		137,
		144,
		135,
		131,
		128,
		142,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		118,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		120,
		104,
		107,
		107,
		103,
		111,
		96,
		99,
		106,
		110,
		128,
		141,
		133,
		127,
		126,
		138,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		133,
		-1,
		104,
		128,
		144,
		-1,
		148,
		127,
		142,
		120,
		116,
		112,
		127,
		128,
		106,
		111,
		110,
		120,
		121,
		110,
		118,
		115,
		137,
		137,
		121,
		122,
		131,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		107,
		110,
		131,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		126,
		124,
		117,
		108,
		114,
		121,
		124,
		125,
		115,
		104,
		110,
		109,
		131,
		117,
		115,
		134,
		150,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		125,
		109,
		114,
		-1,
		150,
		-1,
		123,
		125,
		117,
		106,
		103,
		114,
		112,
		123,
		140,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		164,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		141,
		121,
		115,
		114,
		145,
		143,
		131,
		115,
		108,
		105,
		106,
		119,
		139,
		130,
		142,
		-1,
		-1,
		-1,
		165,
		145,
		151,
		109,
		130,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		158,
		146,
		136,
		126,
		160,
		159,
		134,
		127,
		113,
		115,
		113,
		115,
		120,
		141,
		142,
		155,
		-1,
		-1,
		142,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		147,
		-1,
		-1,
		138,
		136,
		146,
		130,
		117,
		137,
		140,
		130,
		114,
		129,
		141,
		149,
		154,
		-1,
		145,
		132,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		169,
		171,
		175,
		141,
		-1,
		146,
		141,
		121,
		135,
		142,
		132,
		127,
		121,
		124,
		142,
		159,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		148,
		162,
		164,
		157,
		161,
		-1,
		149,
		137,
		123,
		140,
		145,
		142,
		133,
		125,
		130,
		127,
		140,
		154,
		158,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		166,
		181,
		203,
		180,
		153,
		148,
		141,
		135,
		131,
		147,
		153,
		164,
		132,
		128,
		129,
		133,
		132,
		149,
		159,
		-1,
		-1,
		165,
		182,
		192,
		174,
		178,
		230,
		-1,
		-1,
		157,
		148,
		139,
		142,
		141,
		144,
		138,
		135,
		140,
		145,
		133,
		142,
		160,
		159,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		193,
		228,
		175,
		157,
		153,
		151,
		144,
		153,
		148,
		143,
		153,
		155,
		147,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		214,
		189,
		204,
		239,
		213,
		220,
		190,
		187,
		-1,
		157,
		182,
		154,
		161,
		152,
		159,
		159,
		151,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		220,
		206,
		225,
		215,
		218,
		-1,
		-1,
		206,
		203,
		179,
		162,
		160,
		153,
		148,
		158,
		138,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		190,
		271,
		264,
		247,
		255,
		286,
		-1,
		223,
		221,
		213,
		207,
		209,
		-1,
		-1,
		179,
		176,
		181,
		169,
		166,
		168,
		163,
		154,
		139,
		145,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		204,
		247,
		241,
		244,
		268,
		282,
		-1,
		226,
		-1,
		-1,
		221,
		210,
		194,
		184,
		178,
		228,
		183,
		178,
		162,
		160,
		151,
		142,
		149,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		239,
		227,
		235,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		237,
		-1,
		221,
		-1,
		196,
		200,
		191,
		194,
		176,
		163,
		155,
		147,
		163,
		138,
		148,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		297,
		253,
		235,
		226,
		273,
		288,
		292,
		-1,
		238,
		277,
		275,
		-1,
		246,
		-1,
		-1,
		-1,
		210,
		204,
		196,
		196,
		175,
		175,
		149,
		153,
		143,
		150,
		160,
		162,
		154,
		158,
		171,
		182,
		185,
		293,
		284,
		297,
		242,
		240,
		258,
		267,
		288,
		253,
		244,
		271,
		282,
		271,
		266,
		253,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		182,
		170,
		153,
		154,
		150,
		153,
		168,
		171,
		161,
		159,
		153,
		185,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		259,
		-1,
		-1,
		255,
		272,
		266,
		270,
		286,
		311,
		-1,
		242,
		-1,
		-1,
		227,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		158,
		169,
		179,
		167,
		168,
		158,
		168,
		181,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		242,
		240,
		246,
		253,
		270,
		300,
		-1,
		-1,
		258,
		238,
		-1,
		-1,
		210,
		208,
		197,
		-1,
		187,
		160,
		165,
		185,
		187,
		176,
		170,
		164,
		171,
		170,
		178,
		186,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		244,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		178,
		182,
		174,
		167,
		162,
		173,
		165,
		169,
		186,
		-1,
		313,
		-1,
		265,
		241,
		255,
		270,
		278,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		168,
		179,
		168,
		171,
		185,
		180,
		-1,
		-1,
		253,
		256,
		-1,
		-1,
		255,
		257,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		172,
		178,
		181,
		170,
		174,
		186,
		-1,
		-1,
		260,
		261,
		262,
		-1,
		240,
		-1,
		258,
		-1,
		225,
		231,
		219,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		201,
		199,
		190,
		176,
		183,
		181,
		177,
		188,
		-1,
		-1,
		-1,
		258,
		232,
		265,
		256,
		239,
		219,
		211,
		230,
		-1,
		200,
		-1,
		175,
		177,
		203,
		206,
		212,
		206,
		179,
		194,
		184,
		175,
		184,
		264,
		-1,
		234,
		267,
		231,
		225,
		201,
		205,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		228,
		213,
		194,
		181,
		188,
		188,
		181,
		-1,
		-1,
		-1,
		236,
		235,
		227,
		221,
		221,
		206,
		197,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		218,
		214,
		201,
		201,
		193,
		-1,
		337,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		230,
		225,
		198,
		186,
		192,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		194,
		229,
		-1,
		332,
		-1,
		266,
		-1,
		-1,
		248,
		228,
		220,
		209,
		198,
		196,
		187,
		178,
		200,
		216,
		200,
		198,
		201,
		202,
		-1,
		321,
		320,
		-1,
		267,
		259,
		245,
		-1,
		238,
		-1,
		244,
		205,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		308,
		283,
		-1,
		-1,
		-1,
		268,
		248,
		239,
		223,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		293,
		292,
		-1,
		261,
		264,
		-1,
		254,
		245,
		253,
		200,
		204,
		-1,
		-1,
		-1,
		302,
		283,
		277,
		276,
		274,
		269,
		266,
		252,
		236,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		274,
		266,
		259,
		-1,
		-1,
		261,
		244,
		225,
		223,
		-1,
		-1,
		-1,
		296,
		277,
		-1,
		-1,
		251,
		-1,
		-1,
		257,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		285,
		-1,
		-1,
		-1,
		247,
		243,
		244,
		-1,
		-1,
		-1,
		-1,
		307,
		308,
		331,
		295,
		-1,
		-1,
		-1,
		239,
		233,
		-1,
		-1,
		310,
		308,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		237,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		272,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		262,
		269,
		291,
		294,
		330,
		-1,
		281
	],
	[
		-1,
		96,
		85,
		96,
		104,
		77,
		84,
		-1,
		105,
		107,
		73,
		67,
		106,
		77,
		83,
		94,
		-1,
		-1,
		-1,
		96,
		95,
		65,
		63,
		72,
		77,
		84,
		-1,
		107,
		-1,
		117,
		96,
		107,
		112,
		58,
		55,
		75,
		94,
		100,
		92,
		132,
		88,
		59,
		53,
		71,
		76,
		94,
		86,
		-1,
		59,
		49,
		71,
		75,
		87,
		70,
		-1,
		-1,
		53,
		54,
		60,
		72,
		77,
		82,
		-1,
		104,
		101,
		-1,
		-1,
		43,
		56,
		52,
		55,
		63,
		78,
		96,
		101,
		96,
		-1,
		-1,
		44,
		48,
		58,
		62,
		60,
		83,
		102,
		91,
		105,
		104,
		-1,
		32,
		50,
		46,
		51,
		57,
		59,
		63,
		81,
		90,
		96,
		99,
		-1,
		41,
		42,
		21,
		29,
		34,
		41,
		58,
		68,
		85,
		78,
		97,
		88,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		41,
		24,
		34,
		17,
		0,
		22,
		44,
		54,
		71,
		73,
		70,
		86,
		87,
		97,
		-1,
		-1,
		135,
		108,
		132,
		90,
		71,
		-1,
		37,
		17,
		8,
		4,
		5,
		13,
		41,
		41,
		-1,
		64,
		63,
		94,
		80,
		91,
		117,
		-1,
		-1,
		93,
		85,
		67,
		70,
		47,
		43,
		32,
		31,
		21,
		25,
		31,
		16,
		31,
		31,
		41,
		58,
		68,
		72,
		87,
		98,
		-1,
		-1,
		172,
		-1,
		-1,
		114,
		97,
		-1,
		62,
		69,
		53,
		59,
		45,
		66,
		42,
		30,
		37,
		46,
		34,
		26,
		23,
		47,
		43,
		55,
		80,
		84,
		90,
		108,
		109,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		69,
		66,
		59,
		83,
		82,
		-1,
		79,
		67,
		68,
		53,
		54,
		55,
		40,
		31,
		29,
		44,
		46,
		62,
		64,
		97,
		92,
		113,
		110,
		141,
		147,
		141,
		150,
		-1,
		122,
		118,
		114,
		121,
		70,
		-1,
		-1,
		87,
		-1,
		90,
		103,
		91,
		64,
		67,
		54,
		62,
		62,
		46,
		37,
		32,
		35,
		55,
		68,
		75,
		89,
		88,
		106,
		119,
		134,
		138,
		144,
		-1,
		172,
		-1,
		114,
		98,
		100,
		76,
		104,
		-1,
		107,
		91,
		108,
		93,
		93,
		-1,
		70,
		67,
		77,
		62,
		47,
		50,
		39,
		43,
		54,
		75,
		92,
		83,
		101,
		108,
		116,
		120,
		140,
		152,
		132,
		122,
		-1,
		104,
		109,
		79,
		91,
		114,
		134,
		118,
		-1,
		104,
		-1,
		72,
		85,
		-1,
		68,
		64,
		53,
		61,
		50,
		57,
		61,
		74,
		71,
		89,
		92,
		109,
		113,
		129,
		-1,
		-1,
		117,
		121,
		129,
		80,
		99,
		123,
		160,
		122,
		111,
		110,
		-1,
		90,
		89,
		86,
		87,
		73,
		66,
		67,
		56,
		62,
		71,
		73,
		76,
		98,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		106,
		77,
		101,
		143,
		140,
		133,
		121,
		126,
		126,
		114,
		-1,
		104,
		83,
		80,
		71,
		63,
		79,
		74,
		90,
		77,
		79,
		95,
		107,
		98,
		118,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		80,
		114,
		132,
		159,
		145,
		150,
		125,
		116,
		112,
		98,
		100,
		91,
		80,
		72,
		61,
		77,
		84,
		79,
		79,
		88,
		89,
		113,
		120,
		126,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		105,
		112,
		144,
		150,
		163,
		-1,
		117,
		-1,
		106,
		101,
		85,
		80,
		77,
		74,
		68,
		77,
		85,
		93,
		84,
		99,
		118,
		118,
		110,
		135,
		138,
		-1,
		-1,
		-1,
		136,
		153,
		128,
		105,
		86,
		122,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		87,
		83,
		78,
		82,
		75,
		82,
		78,
		92,
		103,
		85,
		121,
		-1,
		118,
		112,
		140,
		132,
		120,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		93,
		145,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		87,
		85,
		79,
		83,
		87,
		76,
		89,
		94,
		90,
		100,
		120,
		124,
		131,
		122,
		118,
		115,
		129,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		113,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		107,
		91,
		94,
		94,
		90,
		98,
		83,
		86,
		93,
		97,
		115,
		128,
		120,
		114,
		113,
		125,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		128,
		-1,
		99,
		123,
		139,
		-1,
		135,
		114,
		129,
		107,
		103,
		99,
		114,
		115,
		93,
		98,
		97,
		107,
		108,
		97,
		105,
		102,
		124,
		124,
		108,
		109,
		118,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		102,
		97,
		126,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		113,
		111,
		104,
		95,
		101,
		108,
		111,
		112,
		102,
		91,
		97,
		96,
		118,
		104,
		102,
		121,
		137,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		112,
		96,
		101,
		-1,
		137,
		-1,
		110,
		112,
		104,
		93,
		90,
		101,
		99,
		110,
		127,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		159,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		128,
		108,
		102,
		101,
		132,
		130,
		118,
		102,
		95,
		92,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		160,
		140,
		146,
		104,
		125,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		145,
		133,
		123,
		113,
		147,
		146,
		121,
		114,
		100,
		102,
		100,
		102,
		107,
		128,
		129,
		142,
		-1,
		-1,
		137,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		134,
		-1,
		-1,
		125,
		123,
		133,
		117,
		104,
		124,
		127,
		117,
		101,
		116,
		128,
		136,
		141,
		-1,
		140,
		127,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		156,
		158,
		162,
		128,
		-1,
		133,
		128,
		108,
		122,
		129,
		119,
		114,
		108,
		111,
		129,
		146,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		135,
		149,
		151,
		144,
		148,
		-1,
		136,
		124,
		110,
		127,
		132,
		129,
		120,
		112,
		117,
		114,
		127,
		141,
		145,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		153,
		168,
		190,
		167,
		140,
		135,
		128,
		122,
		118,
		134,
		140,
		151,
		119,
		115,
		116,
		120,
		119,
		136,
		146,
		-1,
		-1,
		160,
		177,
		179,
		161,
		165,
		217,
		-1,
		-1,
		144,
		135,
		126,
		129,
		128,
		131,
		125,
		122,
		127,
		132,
		120,
		129,
		147,
		146,
		-1,
		-1,
		-1,
		180,
		-1,
		195,
		-1,
		-1,
		180,
		215,
		162,
		144,
		140,
		138,
		131,
		140,
		135,
		130,
		140,
		142,
		134,
		122,
		126,
		149,
		138,
		177,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		209,
		184,
		199,
		226,
		200,
		207,
		177,
		174,
		-1,
		144,
		169,
		141,
		148,
		139,
		146,
		146,
		138,
		116,
		123,
		139,
		138,
		133,
		169,
		160,
		166,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		215,
		201,
		212,
		202,
		205,
		-1,
		-1,
		193,
		190,
		166,
		149,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		216,
		208,
		208,
		194,
		196,
		-1,
		-1,
		166,
		163,
		168,
		156,
		153,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		213,
		-1,
		-1,
		216,
		197,
		181,
		171,
		165,
		215,
		170,
		165,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		232,
		-1,
		208,
		-1,
		183,
		187,
		178,
		181,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		284,
		240,
		230,
		221,
		265,
		280,
		284,
		-1,
		225,
		264,
		262,
		-1,
		241,
		-1,
		-1,
		-1,
		197,
		191,
		183,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		280,
		271,
		284,
		229,
		229,
		250,
		259,
		280,
		240,
		231,
		258,
		269,
		258,
		253,
		240,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		220,
		247,
		-1,
		-1,
		242,
		259,
		253,
		257,
		273,
		298,
		-1,
		229,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		257,
		254,
		242,
		240,
		263,
		228,
		216,
		-1,
		229,
		227,
		233,
		240,
		257,
		287,
		-1,
		-1,
		245,
		225,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		214,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		231,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		300,
		-1,
		252,
		228,
		242,
		257,
		265,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		240,
		243,
		-1,
		-1,
		242,
		244,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		247,
		248,
		249,
		-1,
		227,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		212,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		324,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		116,
		105,
		116,
		124,
		97,
		104,
		-1,
		125,
		127,
		93,
		87,
		126,
		97,
		103,
		114,
		-1,
		-1,
		-1,
		116,
		115,
		85,
		83,
		92,
		97,
		104,
		-1,
		102,
		-1,
		137,
		116,
		127,
		132,
		78,
		75,
		95,
		114,
		95,
		87,
		152,
		108,
		79,
		73,
		91,
		83,
		89,
		81,
		-1,
		79,
		69,
		91,
		72,
		83,
		65,
		-1,
		-1,
		73,
		74,
		80,
		68,
		70,
		62,
		-1,
		83,
		102,
		-1,
		-1,
		63,
		68,
		52,
		56,
		58,
		57,
		75,
		92,
		97,
		-1,
		-1,
		54,
		54,
		43,
		49,
		45,
		62,
		81,
		92,
		106,
		105,
		-1,
		52,
		52,
		38,
		36,
		39,
		38,
		42,
		60,
		91,
		97,
		100,
		-1,
		61,
		62,
		34,
		24,
		16,
		20,
		41,
		47,
		66,
		79,
		98,
		89,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		61,
		44,
		49,
		31,
		23,
		0,
		22,
		39,
		50,
		54,
		71,
		87,
		88,
		98,
		-1,
		-1,
		155,
		128,
		152,
		110,
		91,
		-1,
		57,
		37,
		31,
		27,
		21,
		29,
		19,
		39,
		-1,
		65,
		64,
		95,
		81,
		92,
		137,
		-1,
		-1,
		113,
		105,
		87,
		90,
		67,
		63,
		52,
		51,
		44,
		48,
		46,
		32,
		35,
		46,
		56,
		59,
		69,
		73,
		88,
		99,
		-1,
		-1,
		173,
		-1,
		-1,
		134,
		117,
		-1,
		82,
		89,
		73,
		79,
		65,
		86,
		62,
		53,
		60,
		60,
		49,
		41,
		39,
		63,
		59,
		56,
		81,
		85,
		91,
		109,
		110,
		-1,
		172,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		89,
		86,
		79,
		103,
		102,
		-1,
		95,
		83,
		84,
		69,
		68,
		69,
		55,
		47,
		45,
		60,
		62,
		63,
		65,
		102,
		93,
		114,
		111,
		142,
		148,
		142,
		151,
		-1,
		142,
		138,
		134,
		141,
		90,
		-1,
		-1,
		107,
		-1,
		110,
		123,
		107,
		80,
		83,
		70,
		78,
		76,
		61,
		53,
		48,
		51,
		71,
		71,
		80,
		90,
		89,
		107,
		120,
		135,
		139,
		145,
		-1,
		192,
		-1,
		134,
		118,
		120,
		96,
		124,
		-1,
		127,
		111,
		124,
		109,
		109,
		-1,
		86,
		83,
		93,
		78,
		63,
		66,
		55,
		59,
		70,
		78,
		93,
		84,
		102,
		109,
		117,
		121,
		141,
		153,
		152,
		142,
		-1,
		124,
		129,
		99,
		111,
		134,
		154,
		138,
		-1,
		120,
		-1,
		88,
		101,
		-1,
		84,
		80,
		69,
		77,
		66,
		73,
		77,
		75,
		72,
		90,
		93,
		110,
		114,
		130,
		-1,
		-1,
		137,
		141,
		149,
		100,
		119,
		143,
		180,
		138,
		127,
		126,
		-1,
		106,
		105,
		102,
		103,
		89,
		82,
		83,
		72,
		78,
		87,
		74,
		77,
		99,
		127,
		105,
		117,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		126,
		97,
		121,
		163,
		156,
		149,
		137,
		142,
		142,
		130,
		-1,
		120,
		99,
		96,
		87,
		79,
		95,
		90,
		98,
		78,
		80,
		96,
		108,
		99,
		119,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		100,
		134,
		152,
		175,
		161,
		166,
		141,
		132,
		128,
		114,
		116,
		107,
		96,
		88,
		77,
		93,
		100,
		95,
		80,
		89,
		90,
		114,
		121,
		127,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		125,
		132,
		164,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		90,
		84,
		93,
		101,
		94,
		85,
		100,
		119,
		119,
		111,
		136,
		139,
		-1,
		-1,
		-1,
		156,
		173,
		148,
		125,
		106,
		142,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		94,
		98,
		91,
		98,
		94,
		103,
		104,
		86,
		122,
		-1,
		119,
		113,
		141,
		144,
		134,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		113,
		165,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		101,
		95,
		99,
		103,
		92,
		105,
		110,
		91,
		101,
		121,
		125,
		132,
		125,
		130,
		129,
		143,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		133,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		110,
		110,
		106,
		114,
		99,
		102,
		94,
		98,
		116,
		143,
		136,
		130,
		129,
		139,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		148,
		-1,
		119,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		130,
		131,
		109,
		114,
		113,
		123,
		124,
		113,
		106,
		110,
		125,
		135,
		124,
		125,
		134,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		122,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		129,
		127,
		120,
		111,
		117,
		124,
		127,
		128,
		118,
		107,
		113,
		112,
		134,
		120,
		118,
		137,
		153,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		128,
		112,
		117,
		-1,
		153,
		-1,
		126,
		128,
		120,
		109,
		106,
		117,
		115,
		126,
		143,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		179,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		144,
		124,
		118,
		117,
		148,
		146,
		134,
		118,
		111,
		108,
		109,
		122,
		142,
		133,
		145,
		-1,
		-1,
		-1,
		179,
		160,
		166,
		124,
		145,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		161,
		149,
		139,
		129,
		163,
		162,
		137,
		130,
		116,
		118,
		116,
		118,
		123,
		144,
		145,
		158,
		-1,
		-1,
		157,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		161,
		177,
		169,
		140,
		150,
		-1,
		-1,
		141,
		139,
		149,
		133,
		120,
		140,
		143,
		133,
		117,
		132,
		144,
		152,
		157,
		-1,
		160,
		147,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		172,
		174,
		178,
		144,
		-1,
		149,
		144,
		124,
		138,
		145,
		135,
		130,
		124,
		127,
		145,
		162,
		-1,
		-1,
		174,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		151,
		165,
		167,
		160,
		164,
		-1,
		152,
		140,
		126,
		143,
		148,
		145,
		136,
		128,
		133,
		130,
		143,
		157,
		161,
		197,
		-1,
		180,
		-1,
		-1,
		-1,
		169,
		184,
		206,
		183,
		156,
		151,
		144,
		138,
		134,
		150,
		156,
		167,
		135,
		131,
		132,
		136,
		135,
		152,
		162,
		-1,
		-1,
		180,
		197,
		195,
		177,
		181,
		233,
		-1,
		-1,
		160,
		151,
		142,
		145,
		144,
		147,
		141,
		138,
		143,
		148,
		136,
		145,
		163,
		162,
		-1,
		-1,
		-1,
		200,
		-1,
		215,
		-1,
		-1,
		196,
		231,
		178,
		160,
		156,
		154,
		147,
		156,
		151,
		146,
		156,
		158,
		150,
		138,
		142,
		165,
		154,
		193,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		229,
		204,
		219,
		242,
		216,
		223,
		193,
		190,
		-1,
		160,
		185,
		157,
		164,
		155,
		162,
		162,
		154,
		132,
		139,
		155,
		154,
		149,
		185,
		176,
		182,
		-1,
		-1,
		310,
		299,
		288,
		294,
		-1,
		235,
		221,
		228,
		218,
		221,
		-1,
		-1,
		209,
		206,
		182,
		165,
		163,
		156,
		151,
		161,
		141,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		205,
		286,
		279,
		262,
		270,
		301,
		-1,
		232,
		224,
		228,
		210,
		212,
		-1,
		-1,
		182,
		179,
		184,
		172,
		169,
		171,
		166,
		157,
		142,
		148,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		219,
		262,
		256,
		259,
		283,
		297,
		-1,
		229,
		-1,
		-1,
		236,
		213,
		197,
		187,
		181,
		231,
		186,
		181,
		165,
		163,
		154,
		145,
		152,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		254,
		242,
		250,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		252,
		-1,
		224,
		-1,
		199,
		203,
		194,
		197,
		179,
		166,
		158,
		150,
		166,
		141,
		151,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		300,
		256,
		250,
		241,
		281,
		296,
		300,
		-1,
		241,
		280,
		278,
		-1,
		261,
		-1,
		-1,
		-1,
		213,
		207,
		199,
		199,
		178,
		178,
		152,
		156,
		146,
		153,
		163,
		165,
		157,
		161,
		174,
		185,
		188,
		296,
		287,
		300,
		245,
		245,
		266,
		275,
		296,
		256,
		247,
		274,
		285,
		274,
		269,
		256,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		185,
		173,
		156,
		157,
		153,
		156,
		171,
		174,
		164,
		162,
		156,
		188,
		-1,
		289,
		288,
		277,
		274,
		250,
		241,
		236,
		263,
		-1,
		-1,
		258,
		275,
		269,
		273,
		289,
		314,
		-1,
		245,
		-1,
		-1,
		230,
		-1,
		-1,
		215,
		178,
		167,
		158,
		164,
		161,
		172,
		182,
		170,
		171,
		161,
		171,
		184,
		273,
		270,
		258,
		256,
		279,
		244,
		232,
		-1,
		245,
		243,
		249,
		256,
		273,
		303,
		-1,
		-1,
		261,
		241,
		-1,
		-1,
		213,
		211,
		200,
		-1,
		190,
		163,
		168,
		188,
		190,
		179,
		173,
		167,
		174,
		173,
		181,
		189,
		282,
		296,
		285,
		281,
		280,
		288,
		237,
		230,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		247,
		-1,
		-1,
		208,
		201,
		189,
		177,
		167,
		177,
		181,
		185,
		177,
		170,
		165,
		176,
		168,
		172,
		189,
		-1,
		316,
		-1,
		268,
		244,
		258,
		273,
		281,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		242,
		226,
		207,
		-1,
		177,
		190,
		221,
		189,
		194,
		189,
		171,
		182,
		171,
		174,
		188,
		183,
		-1,
		-1,
		256,
		259,
		-1,
		-1,
		258,
		260,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		214,
		210,
		-1,
		-1,
		178,
		203,
		192,
		200,
		195,
		175,
		181,
		184,
		173,
		177,
		189,
		-1,
		-1,
		263,
		264,
		265,
		-1,
		243,
		-1,
		261,
		-1,
		228,
		234,
		222,
		-1,
		-1,
		-1,
		216,
		179,
		200,
		210,
		204,
		202,
		193,
		179,
		186,
		184,
		180,
		191,
		-1,
		-1,
		-1,
		261,
		235,
		268,
		259,
		242,
		222,
		214,
		233,
		-1,
		203,
		-1,
		178,
		180,
		206,
		209,
		215,
		209,
		182,
		197,
		187,
		178,
		187,
		267,
		-1,
		237,
		270,
		234,
		228,
		204,
		208,
		224,
		-1,
		200,
		182,
		-1,
		210,
		200,
		231,
		216,
		197,
		184,
		191,
		191,
		184,
		-1,
		-1,
		-1,
		239,
		238,
		230,
		224,
		224,
		209,
		200,
		-1,
		212,
		194,
		173,
		190,
		190,
		181,
		189,
		221,
		217,
		204,
		204,
		196,
		-1,
		340,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		233,
		228,
		201,
		189,
		195,
		191,
		177,
		183,
		185,
		193,
		191,
		188,
		200,
		196,
		216,
		197,
		232,
		-1,
		335,
		-1,
		269,
		-1,
		-1,
		251,
		231,
		223,
		212,
		201,
		199,
		190,
		181,
		203,
		219,
		203,
		201,
		204,
		205,
		-1,
		324,
		323,
		-1,
		270,
		262,
		248,
		-1,
		241,
		-1,
		247,
		208,
		-1,
		210,
		190,
		-1,
		212,
		208,
		-1,
		-1,
		311,
		286,
		-1,
		-1,
		-1,
		271,
		251,
		242,
		226,
		-1,
		201,
		201,
		-1,
		-1,
		-1,
		296,
		295,
		-1,
		264,
		267,
		-1,
		257,
		248,
		256,
		203,
		207,
		-1,
		-1,
		-1,
		305,
		286,
		280,
		279,
		277,
		272,
		269,
		255,
		239,
		217,
		206,
		227,
		-1,
		-1,
		-1,
		277,
		269,
		262,
		-1,
		-1,
		264,
		247,
		228,
		226,
		-1,
		-1,
		-1,
		299,
		280,
		-1,
		-1,
		254,
		-1,
		-1,
		260,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		288,
		-1,
		-1,
		-1,
		250,
		246,
		247,
		-1,
		-1,
		-1,
		-1,
		310,
		311,
		334,
		298,
		-1,
		-1,
		-1,
		242,
		236,
		-1,
		-1,
		313,
		311,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		240,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		275,
		-1,
		275,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		288,
		280,
		288,
		-1,
		260,
		262,
		-1,
		310,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		265,
		272,
		294,
		297,
		333,
		-1,
		284
	],
	[
		-1,
		124,
		113,
		124,
		132,
		105,
		112,
		-1,
		131,
		135,
		101,
		95,
		134,
		103,
		109,
		120,
		-1,
		-1,
		-1,
		124,
		123,
		91,
		89,
		98,
		103,
		110,
		-1,
		105,
		-1,
		145,
		124,
		135,
		140,
		84,
		81,
		101,
		117,
		98,
		90,
		160,
		114,
		85,
		79,
		97,
		87,
		92,
		84,
		-1,
		85,
		75,
		97,
		76,
		86,
		68,
		-1,
		-1,
		79,
		80,
		86,
		72,
		73,
		65,
		-1,
		84,
		103,
		-1,
		-1,
		69,
		70,
		54,
		57,
		61,
		60,
		76,
		93,
		98,
		-1,
		-1,
		60,
		56,
		55,
		50,
		46,
		63,
		82,
		93,
		107,
		106,
		-1,
		67,
		67,
		53,
		48,
		42,
		39,
		43,
		61,
		92,
		98,
		101,
		-1,
		76,
		77,
		49,
		39,
		31,
		23,
		35,
		48,
		67,
		80,
		99,
		90,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		76,
		59,
		64,
		46,
		38,
		19,
		0,
		31,
		51,
		55,
		72,
		88,
		89,
		99,
		-1,
		-1,
		170,
		143,
		167,
		125,
		106,
		-1,
		72,
		52,
		46,
		42,
		36,
		41,
		3,
		23,
		-1,
		66,
		65,
		96,
		82,
		93,
		152,
		-1,
		-1,
		128,
		120,
		102,
		105,
		82,
		78,
		67,
		66,
		59,
		62,
		58,
		38,
		28,
		37,
		44,
		60,
		70,
		74,
		89,
		100,
		-1,
		-1,
		174,
		-1,
		-1,
		149,
		132,
		-1,
		97,
		104,
		88,
		94,
		80,
		101,
		77,
		68,
		72,
		67,
		59,
		34,
		33,
		51,
		53,
		57,
		82,
		86,
		92,
		110,
		111,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		104,
		101,
		94,
		118,
		117,
		-1,
		107,
		95,
		96,
		81,
		80,
		76,
		65,
		41,
		39,
		54,
		56,
		64,
		66,
		103,
		94,
		115,
		112,
		143,
		149,
		143,
		152,
		-1,
		157,
		153,
		149,
		156,
		105,
		-1,
		-1,
		122,
		-1,
		125,
		138,
		119,
		92,
		95,
		82,
		90,
		83,
		63,
		47,
		42,
		45,
		65,
		72,
		81,
		91,
		90,
		108,
		121,
		136,
		140,
		146,
		-1,
		207,
		-1,
		149,
		133,
		135,
		111,
		139,
		-1,
		142,
		126,
		136,
		121,
		121,
		-1,
		98,
		95,
		101,
		79,
		64,
		60,
		49,
		53,
		64,
		79,
		94,
		85,
		103,
		110,
		118,
		122,
		142,
		154,
		167,
		157,
		-1,
		139,
		144,
		114,
		126,
		149,
		169,
		153,
		-1,
		132,
		-1,
		100,
		113,
		-1,
		85,
		81,
		70,
		71,
		60,
		67,
		71,
		76,
		73,
		91,
		94,
		111,
		115,
		131,
		-1,
		-1,
		152,
		156,
		164,
		115,
		134,
		158,
		195,
		150,
		139,
		138,
		-1,
		118,
		104,
		101,
		102,
		89,
		83,
		83,
		66,
		72,
		81,
		75,
		78,
		100,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		141,
		112,
		136,
		178,
		168,
		161,
		149,
		136,
		136,
		130,
		-1,
		120,
		99,
		94,
		83,
		73,
		89,
		84,
		99,
		79,
		81,
		97,
		109,
		100,
		120,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		115,
		149,
		167,
		169,
		155,
		160,
		135,
		128,
		122,
		113,
		116,
		101,
		90,
		82,
		71,
		87,
		94,
		89,
		81,
		90,
		91,
		115,
		122,
		128,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		140,
		147,
		179,
		160,
		173,
		-1,
		127,
		-1,
		116,
		111,
		95,
		90,
		87,
		84,
		78,
		87,
		95,
		95,
		86,
		101,
		120,
		120,
		112,
		137,
		140,
		-1,
		-1,
		-1,
		171,
		188,
		163,
		140,
		121,
		157,
		-1,
		143,
		144,
		-1,
		121,
		115,
		112,
		97,
		93,
		88,
		92,
		85,
		92,
		88,
		102,
		105,
		87,
		123,
		-1,
		120,
		114,
		142,
		142,
		130,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		125,
		177,
		-1,
		-1,
		128,
		121,
		-1,
		108,
		90,
		97,
		95,
		89,
		93,
		97,
		86,
		99,
		104,
		92,
		102,
		122,
		126,
		133,
		126,
		128,
		125,
		139,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		145,
		-1,
		137,
		129,
		119,
		113,
		107,
		103,
		101,
		117,
		101,
		104,
		104,
		100,
		108,
		93,
		96,
		95,
		99,
		117,
		138,
		130,
		124,
		123,
		135,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		158,
		-1,
		122,
		136,
		152,
		-1,
		145,
		124,
		139,
		117,
		113,
		109,
		124,
		125,
		103,
		108,
		107,
		117,
		118,
		107,
		107,
		111,
		126,
		134,
		118,
		119,
		128,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		119,
		107,
		139,
		-1,
		-1,
		181,
		-1,
		115,
		132,
		123,
		121,
		114,
		105,
		111,
		118,
		121,
		122,
		112,
		101,
		107,
		106,
		128,
		114,
		112,
		131,
		147,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		159,
		149,
		133,
		118,
		151,
		-1,
		122,
		106,
		111,
		-1,
		147,
		-1,
		120,
		122,
		114,
		103,
		100,
		111,
		109,
		120,
		137,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		176,
		-1,
		-1,
		146,
		140,
		140,
		124,
		127,
		138,
		118,
		112,
		111,
		142,
		140,
		128,
		112,
		105,
		102,
		103,
		116,
		136,
		127,
		139,
		-1,
		-1,
		-1,
		173,
		159,
		163,
		123,
		142,
		-1,
		-1,
		208,
		163,
		149,
		-1,
		133,
		155,
		143,
		133,
		123,
		157,
		156,
		131,
		124,
		110,
		112,
		110,
		112,
		117,
		138,
		139,
		152,
		-1,
		-1,
		156,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		155,
		171,
		163,
		134,
		144,
		-1,
		-1,
		135,
		133,
		143,
		127,
		114,
		134,
		137,
		127,
		111,
		126,
		138,
		146,
		151,
		-1,
		159,
		146,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		166,
		168,
		172,
		138,
		-1,
		143,
		138,
		118,
		132,
		139,
		129,
		124,
		118,
		121,
		139,
		156,
		-1,
		-1,
		171,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		145,
		159,
		161,
		154,
		158,
		-1,
		146,
		134,
		120,
		137,
		142,
		139,
		130,
		122,
		127,
		124,
		137,
		151,
		155,
		194,
		-1,
		177,
		-1,
		-1,
		-1,
		163,
		178,
		200,
		177,
		150,
		145,
		138,
		132,
		128,
		144,
		150,
		161,
		129,
		125,
		126,
		130,
		129,
		146,
		156,
		-1,
		-1,
		177,
		194,
		189,
		171,
		175,
		227,
		-1,
		-1,
		154,
		145,
		136,
		139,
		138,
		141,
		135,
		132,
		137,
		142,
		130,
		139,
		157,
		156,
		-1,
		-1,
		-1,
		197,
		-1,
		212,
		-1,
		-1,
		190,
		225,
		172,
		154,
		150,
		148,
		141,
		150,
		145,
		140,
		150,
		152,
		144,
		132,
		136,
		159,
		148,
		187,
		-1,
		-1,
		316,
		-1,
		-1,
		-1,
		226,
		201,
		216,
		236,
		210,
		217,
		187,
		184,
		-1,
		154,
		179,
		151,
		158,
		149,
		156,
		156,
		148,
		126,
		133,
		149,
		148,
		143,
		179,
		170,
		176,
		-1,
		-1,
		309,
		298,
		287,
		293,
		-1,
		232,
		218,
		222,
		212,
		215,
		-1,
		-1,
		203,
		200,
		176,
		159,
		157,
		150,
		145,
		155,
		135,
		122,
		126,
		130,
		136,
		141,
		146,
		152,
		167,
		182,
		-1,
		204,
		285,
		278,
		261,
		269,
		300,
		-1,
		226,
		218,
		225,
		204,
		206,
		-1,
		-1,
		176,
		173,
		178,
		166,
		163,
		165,
		160,
		151,
		136,
		142,
		129,
		128,
		146,
		150,
		159,
		166,
		156,
		169,
		173,
		-1,
		218,
		261,
		255,
		258,
		282,
		296,
		-1,
		223,
		-1,
		-1,
		233,
		207,
		191,
		181,
		175,
		225,
		180,
		175,
		159,
		157,
		148,
		139,
		146,
		137,
		137,
		140,
		155,
		160,
		152,
		166,
		166,
		167,
		-1,
		253,
		241,
		249,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		249,
		-1,
		218,
		-1,
		193,
		197,
		188,
		191,
		173,
		160,
		152,
		144,
		160,
		135,
		145,
		141,
		142,
		151,
		162,
		174,
		173,
		174,
		294,
		250,
		249,
		240,
		275,
		290,
		294,
		-1,
		235,
		274,
		272,
		-1,
		256,
		-1,
		-1,
		-1,
		207,
		201,
		193,
		193,
		172,
		172,
		146,
		150,
		140,
		147,
		157,
		159,
		151,
		155,
		168,
		179,
		182,
		290,
		281,
		294,
		239,
		239,
		260,
		269,
		290,
		250,
		241,
		268,
		279,
		268,
		263,
		250,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		179,
		167,
		150,
		151,
		147,
		150,
		165,
		168,
		158,
		156,
		150,
		182,
		-1,
		283,
		282,
		271,
		268,
		244,
		235,
		230,
		257,
		-1,
		-1,
		252,
		269,
		263,
		267,
		283,
		308,
		-1,
		239,
		-1,
		-1,
		224,
		-1,
		-1,
		209,
		172,
		161,
		152,
		158,
		155,
		166,
		176,
		164,
		165,
		155,
		165,
		178,
		267,
		264,
		252,
		250,
		273,
		238,
		226,
		-1,
		239,
		237,
		243,
		250,
		267,
		297,
		-1,
		-1,
		255,
		235,
		-1,
		-1,
		207,
		205,
		194,
		-1,
		184,
		157,
		162,
		182,
		184,
		173,
		167,
		161,
		168,
		167,
		175,
		183,
		276,
		290,
		279,
		275,
		274,
		282,
		231,
		224,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		-1,
		245,
		241,
		-1,
		-1,
		202,
		195,
		183,
		171,
		161,
		171,
		175,
		179,
		171,
		164,
		159,
		170,
		162,
		166,
		183,
		-1,
		310,
		-1,
		262,
		238,
		252,
		267,
		275,
		-1,
		-1,
		-1,
		262,
		248,
		241,
		229,
		227,
		-1,
		236,
		220,
		201,
		-1,
		171,
		184,
		215,
		183,
		188,
		183,
		165,
		176,
		165,
		168,
		182,
		177,
		-1,
		-1,
		250,
		253,
		-1,
		-1,
		252,
		254,
		-1,
		253,
		242,
		227,
		219,
		-1,
		-1,
		208,
		204,
		-1,
		-1,
		172,
		197,
		186,
		194,
		189,
		169,
		175,
		178,
		167,
		171,
		183,
		-1,
		-1,
		257,
		258,
		259,
		-1,
		237,
		-1,
		255,
		-1,
		222,
		228,
		216,
		-1,
		-1,
		-1,
		210,
		173,
		194,
		204,
		198,
		196,
		187,
		173,
		180,
		178,
		174,
		185,
		-1,
		-1,
		-1,
		255,
		229,
		262,
		253,
		236,
		216,
		208,
		227,
		-1,
		197,
		-1,
		172,
		174,
		200,
		203,
		209,
		203,
		176,
		191,
		181,
		172,
		181,
		261,
		-1,
		231,
		264,
		228,
		222,
		198,
		202,
		218,
		-1,
		194,
		176,
		-1,
		204,
		194,
		225,
		210,
		191,
		178,
		185,
		185,
		178,
		-1,
		-1,
		-1,
		233,
		232,
		224,
		218,
		218,
		203,
		194,
		-1,
		206,
		188,
		167,
		184,
		184,
		175,
		183,
		215,
		211,
		198,
		198,
		190,
		-1,
		334,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		227,
		222,
		195,
		183,
		189,
		185,
		171,
		177,
		179,
		187,
		185,
		182,
		194,
		190,
		210,
		191,
		226,
		-1,
		329,
		-1,
		263,
		-1,
		-1,
		245,
		225,
		217,
		206,
		195,
		193,
		184,
		175,
		197,
		213,
		197,
		195,
		198,
		199,
		-1,
		318,
		317,
		-1,
		264,
		256,
		242,
		-1,
		235,
		-1,
		241,
		202,
		-1,
		204,
		184,
		-1,
		206,
		202,
		-1,
		-1,
		305,
		280,
		-1,
		-1,
		-1,
		265,
		245,
		236,
		220,
		-1,
		195,
		195,
		-1,
		-1,
		-1,
		290,
		289,
		-1,
		258,
		261,
		-1,
		251,
		242,
		250,
		197,
		201,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		273,
		271,
		266,
		263,
		249,
		233,
		211,
		200,
		221,
		-1,
		-1,
		-1,
		271,
		263,
		256,
		-1,
		-1,
		258,
		241,
		222,
		220,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		248,
		-1,
		-1,
		254,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		282,
		-1,
		-1,
		-1,
		244,
		240,
		241,
		-1,
		-1,
		-1,
		-1,
		304,
		305,
		328,
		292,
		-1,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		307,
		305,
		-1,
		-1,
		-1,
		264,
		248,
		-1,
		234,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		269,
		-1,
		269,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		282,
		274,
		282,
		-1,
		254,
		256,
		-1,
		304,
		-1,
		-1,
		297,
		288,
		-1,
		-1,
		259,
		266,
		288,
		291,
		327,
		-1,
		278
	],
	[
		-1,
		93,
		82,
		93,
		101,
		74,
		81,
		-1,
		100,
		104,
		70,
		64,
		103,
		72,
		78,
		89,
		-1,
		-1,
		-1,
		93,
		92,
		60,
		58,
		67,
		72,
		79,
		-1,
		78,
		-1,
		114,
		93,
		104,
		109,
		53,
		50,
		70,
		89,
		71,
		63,
		129,
		83,
		54,
		48,
		66,
		56,
		65,
		57,
		-1,
		54,
		44,
		66,
		45,
		56,
		48,
		-1,
		-1,
		48,
		49,
		55,
		41,
		47,
		43,
		-1,
		53,
		72,
		-1,
		-1,
		38,
		39,
		23,
		26,
		34,
		32,
		45,
		62,
		67,
		-1,
		-1,
		29,
		25,
		32,
		19,
		15,
		32,
		51,
		62,
		76,
		75,
		-1,
		41,
		58,
		58,
		26,
		24,
		8,
		12,
		30,
		61,
		67,
		70,
		-1,
		58,
		54,
		61,
		53,
		48,
		23,
		4,
		17,
		36,
		49,
		68,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		59,
		50,
		67,
		61,
		51,
		40,
		30,
		0,
		20,
		24,
		41,
		57,
		58,
		68,
		-1,
		-1,
		152,
		125,
		149,
		107,
		89,
		-1,
		55,
		57,
		59,
		55,
		49,
		42,
		32,
		16,
		-1,
		35,
		34,
		65,
		51,
		62,
		134,
		-1,
		-1,
		110,
		102,
		84,
		87,
		64,
		60,
		72,
		71,
		67,
		65,
		61,
		39,
		24,
		37,
		44,
		29,
		39,
		43,
		58,
		69,
		-1,
		-1,
		143,
		-1,
		-1,
		131,
		114,
		-1,
		79,
		86,
		70,
		76,
		62,
		83,
		82,
		76,
		75,
		70,
		62,
		37,
		34,
		51,
		51,
		26,
		51,
		55,
		61,
		79,
		80,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		86,
		83,
		76,
		100,
		99,
		-1,
		105,
		98,
		99,
		84,
		83,
		79,
		68,
		42,
		40,
		51,
		48,
		33,
		35,
		72,
		63,
		84,
		81,
		112,
		118,
		112,
		121,
		-1,
		139,
		135,
		131,
		138,
		87,
		-1,
		-1,
		104,
		-1,
		107,
		120,
		117,
		95,
		98,
		85,
		93,
		84,
		66,
		48,
		43,
		46,
		45,
		41,
		50,
		60,
		59,
		77,
		90,
		105,
		109,
		115,
		-1,
		189,
		-1,
		131,
		115,
		117,
		93,
		121,
		-1,
		124,
		108,
		128,
		119,
		119,
		-1,
		101,
		98,
		102,
		80,
		65,
		61,
		49,
		44,
		44,
		48,
		63,
		54,
		72,
		79,
		87,
		91,
		111,
		123,
		149,
		139,
		-1,
		121,
		126,
		96,
		108,
		131,
		151,
		135,
		-1,
		130,
		-1,
		103,
		116,
		-1,
		86,
		82,
		69,
		57,
		46,
		53,
		51,
		45,
		42,
		60,
		63,
		80,
		84,
		100,
		-1,
		-1,
		134,
		138,
		146,
		97,
		116,
		140,
		177,
		144,
		137,
		136,
		-1,
		121,
		105,
		102,
		99,
		86,
		71,
		69,
		52,
		58,
		59,
		44,
		47,
		69,
		97,
		75,
		87,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		123,
		94,
		118,
		160,
		166,
		159,
		147,
		122,
		122,
		116,
		-1,
		110,
		89,
		80,
		69,
		59,
		75,
		65,
		68,
		48,
		50,
		66,
		78,
		69,
		89,
		-1,
		-1,
		-1,
		153,
		142,
		143,
		97,
		131,
		149,
		155,
		141,
		146,
		121,
		114,
		108,
		114,
		106,
		87,
		76,
		68,
		57,
		66,
		76,
		70,
		50,
		59,
		60,
		84,
		91,
		97,
		-1,
		-1,
		160,
		150,
		134,
		136,
		133,
		122,
		129,
		161,
		146,
		159,
		-1,
		113,
		-1,
		102,
		97,
		81,
		76,
		73,
		70,
		64,
		73,
		78,
		64,
		55,
		70,
		89,
		89,
		81,
		106,
		109,
		-1,
		-1,
		-1,
		153,
		170,
		145,
		122,
		103,
		139,
		-1,
		129,
		130,
		-1,
		107,
		101,
		98,
		83,
		79,
		74,
		78,
		71,
		78,
		74,
		73,
		74,
		56,
		92,
		-1,
		89,
		83,
		111,
		114,
		104,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		110,
		162,
		-1,
		-1,
		114,
		107,
		-1,
		94,
		76,
		83,
		81,
		75,
		79,
		83,
		72,
		85,
		81,
		61,
		71,
		91,
		95,
		102,
		95,
		100,
		99,
		113,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		130,
		-1,
		123,
		115,
		105,
		99,
		93,
		89,
		87,
		103,
		87,
		90,
		90,
		86,
		94,
		79,
		78,
		64,
		68,
		86,
		113,
		108,
		103,
		102,
		109,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		144,
		-1,
		108,
		122,
		138,
		-1,
		131,
		110,
		125,
		103,
		99,
		95,
		110,
		111,
		89,
		94,
		93,
		103,
		100,
		89,
		76,
		80,
		95,
		105,
		97,
		98,
		107,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		93,
		125,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		109,
		107,
		100,
		91,
		97,
		104,
		107,
		104,
		94,
		83,
		89,
		85,
		107,
		93,
		91,
		110,
		125,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		108,
		92,
		97,
		-1,
		129,
		-1,
		102,
		102,
		93,
		82,
		79,
		90,
		88,
		99,
		116,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		162,
		-1,
		-1,
		132,
		126,
		126,
		110,
		113,
		124,
		104,
		98,
		97,
		124,
		119,
		110,
		91,
		84,
		81,
		82,
		95,
		115,
		106,
		118,
		-1,
		-1,
		-1,
		159,
		145,
		149,
		109,
		128,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		119,
		141,
		129,
		119,
		109,
		143,
		135,
		110,
		103,
		89,
		91,
		89,
		91,
		96,
		117,
		118,
		131,
		-1,
		-1,
		142,
		147,
		135,
		121,
		140,
		-1,
		-1,
		-1,
		141,
		157,
		149,
		120,
		130,
		-1,
		-1,
		121,
		119,
		127,
		106,
		93,
		113,
		116,
		106,
		90,
		105,
		117,
		125,
		130,
		-1,
		145,
		132,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		152,
		147,
		151,
		124,
		-1,
		123,
		117,
		97,
		111,
		118,
		108,
		103,
		97,
		100,
		118,
		135,
		-1,
		-1,
		157,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		131,
		145,
		140,
		133,
		137,
		-1,
		125,
		113,
		99,
		116,
		121,
		118,
		109,
		101,
		106,
		103,
		116,
		130,
		134,
		180,
		-1,
		163,
		-1,
		-1,
		-1,
		149,
		164,
		179,
		156,
		129,
		124,
		117,
		111,
		107,
		123,
		129,
		140,
		108,
		104,
		105,
		109,
		108,
		125,
		135,
		-1,
		-1,
		163,
		180,
		175,
		157,
		161,
		206,
		-1,
		-1,
		133,
		124,
		115,
		118,
		117,
		120,
		114,
		111,
		116,
		121,
		109,
		118,
		136,
		135,
		-1,
		-1,
		-1,
		183,
		-1,
		198,
		-1,
		-1,
		176,
		204,
		151,
		133,
		129,
		127,
		120,
		129,
		124,
		119,
		129,
		131,
		123,
		111,
		115,
		138,
		127,
		166,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		212,
		187,
		202,
		215,
		196,
		203,
		166,
		163,
		-1,
		133,
		158,
		130,
		137,
		128,
		135,
		135,
		127,
		105,
		112,
		128,
		127,
		122,
		158,
		149,
		155,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		215,
		204,
		201,
		191,
		194,
		-1,
		-1,
		182,
		179,
		155,
		138,
		136,
		129,
		124,
		134,
		114,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		190,
		271,
		264,
		247,
		255,
		286,
		-1,
		205,
		197,
		208,
		183,
		185,
		-1,
		-1,
		155,
		152,
		157,
		145,
		142,
		144,
		139,
		130,
		115,
		121,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		204,
		247,
		241,
		244,
		268,
		282,
		-1,
		202,
		-1,
		-1,
		214,
		186,
		170,
		160,
		154,
		204,
		159,
		154,
		138,
		136,
		127,
		118,
		125,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		239,
		227,
		235,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		230,
		-1,
		197,
		-1,
		172,
		176,
		167,
		170,
		152,
		139,
		131,
		123,
		139,
		114,
		124,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		273,
		229,
		232,
		226,
		254,
		269,
		273,
		-1,
		214,
		253,
		251,
		-1,
		235,
		-1,
		-1,
		-1,
		186,
		180,
		172,
		172,
		151,
		151,
		125,
		129,
		119,
		126,
		136,
		138,
		130,
		134,
		147,
		158,
		161,
		269,
		260,
		273,
		218,
		218,
		239,
		248,
		269,
		229,
		220,
		247,
		258,
		247,
		242,
		229,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		158,
		146,
		129,
		130,
		126,
		129,
		144,
		147,
		137,
		135,
		129,
		161,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		209,
		236,
		-1,
		-1,
		231,
		248,
		242,
		246,
		262,
		287,
		-1,
		218,
		-1,
		-1,
		203,
		-1,
		-1,
		188,
		151,
		140,
		131,
		137,
		134,
		145,
		155,
		143,
		144,
		134,
		144,
		157,
		246,
		243,
		231,
		229,
		252,
		217,
		205,
		-1,
		218,
		216,
		222,
		229,
		246,
		276,
		-1,
		-1,
		234,
		214,
		-1,
		-1,
		186,
		184,
		173,
		-1,
		163,
		136,
		141,
		161,
		163,
		152,
		146,
		140,
		147,
		146,
		154,
		162,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		203,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		224,
		220,
		-1,
		-1,
		181,
		174,
		162,
		150,
		140,
		150,
		154,
		158,
		150,
		143,
		138,
		149,
		141,
		145,
		162,
		-1,
		289,
		-1,
		241,
		217,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		241,
		227,
		220,
		208,
		206,
		-1,
		215,
		199,
		180,
		-1,
		150,
		163,
		194,
		162,
		167,
		162,
		144,
		155,
		144,
		147,
		161,
		156,
		-1,
		-1,
		229,
		232,
		-1,
		-1,
		231,
		233,
		-1,
		232,
		221,
		206,
		198,
		-1,
		-1,
		187,
		183,
		-1,
		-1,
		151,
		176,
		165,
		173,
		168,
		148,
		154,
		157,
		146,
		150,
		162,
		-1,
		-1,
		236,
		237,
		238,
		-1,
		216,
		-1,
		234,
		-1,
		201,
		207,
		195,
		-1,
		-1,
		-1,
		189,
		152,
		173,
		183,
		177,
		175,
		166,
		152,
		159,
		157,
		153,
		164,
		-1,
		-1,
		-1,
		234,
		208,
		241,
		232,
		215,
		195,
		187,
		206,
		-1,
		176,
		-1,
		151,
		153,
		179,
		182,
		188,
		182,
		155,
		170,
		160,
		151,
		160,
		240,
		-1,
		210,
		243,
		207,
		201,
		177,
		181,
		197,
		-1,
		173,
		155,
		-1,
		183,
		173,
		204,
		189,
		170,
		157,
		164,
		164,
		157,
		-1,
		-1,
		-1,
		212,
		211,
		203,
		197,
		197,
		182,
		173,
		-1,
		185,
		167,
		146,
		163,
		163,
		154,
		162,
		194,
		190,
		177,
		177,
		169,
		-1,
		313,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		206,
		201,
		174,
		162,
		168,
		164,
		150,
		156,
		158,
		166,
		164,
		161,
		173,
		169,
		189,
		170,
		205,
		-1,
		308,
		-1,
		242,
		-1,
		-1,
		224,
		204,
		196,
		185,
		174,
		172,
		163,
		154,
		176,
		192,
		176,
		174,
		177,
		178,
		-1,
		297,
		296,
		-1,
		243,
		235,
		221,
		-1,
		214,
		-1,
		220,
		181,
		-1,
		183,
		163,
		-1,
		185,
		181,
		-1,
		-1,
		284,
		259,
		-1,
		-1,
		-1,
		244,
		224,
		215,
		199,
		-1,
		174,
		174,
		-1,
		-1,
		-1,
		269,
		268,
		-1,
		237,
		240,
		-1,
		230,
		221,
		229,
		176,
		180,
		-1,
		-1,
		-1,
		278,
		259,
		253,
		252,
		250,
		245,
		242,
		228,
		212,
		190,
		179,
		200,
		-1,
		-1,
		-1,
		250,
		242,
		235,
		-1,
		-1,
		237,
		220,
		201,
		199,
		-1,
		-1,
		-1,
		272,
		253,
		-1,
		-1,
		227,
		-1,
		-1,
		233,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		261,
		-1,
		-1,
		-1,
		223,
		219,
		220,
		-1,
		-1,
		-1,
		-1,
		283,
		284,
		307,
		271,
		-1,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		286,
		284,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		213,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		248,
		-1,
		248,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		261,
		-1,
		233,
		235,
		-1,
		283,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		238,
		245,
		267,
		270,
		306,
		-1,
		257
	],
	[
		-1,
		99,
		88,
		99,
		107,
		80,
		87,
		-1,
		106,
		110,
		76,
		70,
		109,
		78,
		84,
		95,
		-1,
		-1,
		-1,
		99,
		98,
		66,
		64,
		73,
		78,
		85,
		-1,
		84,
		-1,
		120,
		99,
		110,
		115,
		59,
		56,
		76,
		95,
		77,
		69,
		135,
		89,
		60,
		54,
		72,
		62,
		71,
		63,
		-1,
		60,
		50,
		72,
		51,
		62,
		54,
		-1,
		-1,
		54,
		55,
		61,
		47,
		53,
		49,
		-1,
		59,
		58,
		-1,
		-1,
		44,
		45,
		29,
		32,
		40,
		38,
		51,
		58,
		53,
		-1,
		-1,
		35,
		31,
		38,
		25,
		21,
		38,
		50,
		48,
		62,
		61,
		-1,
		47,
		64,
		64,
		32,
		30,
		14,
		11,
		29,
		47,
		53,
		60,
		-1,
		64,
		60,
		67,
		59,
		54,
		30,
		17,
		7,
		16,
		35,
		56,
		51,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		65,
		56,
		73,
		75,
		70,
		51,
		49,
		20,
		0,
		4,
		26,
		45,
		50,
		60,
		-1,
		-1,
		158,
		131,
		155,
		113,
		95,
		-1,
		61,
		63,
		69,
		73,
		68,
		62,
		51,
		36,
		-1,
		27,
		19,
		55,
		43,
		54,
		140,
		-1,
		-1,
		116,
		108,
		90,
		93,
		70,
		66,
		78,
		77,
		73,
		75,
		77,
		59,
		44,
		57,
		64,
		18,
		31,
		35,
		50,
		61,
		-1,
		-1,
		139,
		-1,
		-1,
		137,
		120,
		-1,
		85,
		92,
		76,
		82,
		68,
		89,
		88,
		82,
		89,
		90,
		80,
		57,
		54,
		68,
		47,
		22,
		42,
		46,
		53,
		71,
		72,
		-1,
		138,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		92,
		89,
		82,
		106,
		105,
		-1,
		111,
		109,
		115,
		100,
		103,
		98,
		86,
		62,
		47,
		47,
		44,
		29,
		31,
		68,
		55,
		76,
		73,
		104,
		114,
		108,
		117,
		-1,
		145,
		141,
		137,
		144,
		93,
		-1,
		-1,
		110,
		-1,
		113,
		126,
		123,
		111,
		114,
		101,
		106,
		93,
		82,
		64,
		45,
		42,
		41,
		37,
		46,
		56,
		55,
		73,
		82,
		101,
		105,
		111,
		-1,
		195,
		-1,
		137,
		121,
		123,
		99,
		127,
		-1,
		130,
		114,
		134,
		125,
		125,
		-1,
		117,
		114,
		111,
		89,
		74,
		57,
		45,
		40,
		40,
		44,
		59,
		50,
		68,
		75,
		83,
		87,
		107,
		119,
		155,
		145,
		-1,
		127,
		132,
		102,
		114,
		137,
		157,
		141,
		-1,
		136,
		-1,
		119,
		132,
		-1,
		95,
		91,
		65,
		53,
		42,
		49,
		47,
		41,
		38,
		56,
		59,
		76,
		80,
		96,
		-1,
		-1,
		140,
		144,
		152,
		103,
		122,
		146,
		183,
		150,
		143,
		142,
		-1,
		133,
		101,
		98,
		95,
		82,
		67,
		65,
		48,
		54,
		55,
		40,
		43,
		65,
		93,
		71,
		83,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		129,
		100,
		124,
		166,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		106,
		85,
		76,
		65,
		55,
		71,
		61,
		64,
		44,
		46,
		62,
		74,
		65,
		85,
		-1,
		-1,
		-1,
		159,
		148,
		149,
		103,
		137,
		155,
		151,
		137,
		142,
		117,
		110,
		104,
		110,
		102,
		83,
		72,
		64,
		53,
		62,
		72,
		66,
		46,
		55,
		56,
		80,
		87,
		93,
		-1,
		-1,
		166,
		156,
		140,
		142,
		139,
		128,
		135,
		167,
		142,
		155,
		-1,
		109,
		-1,
		98,
		93,
		77,
		72,
		69,
		66,
		60,
		69,
		74,
		60,
		51,
		66,
		85,
		85,
		77,
		102,
		105,
		-1,
		-1,
		-1,
		159,
		176,
		151,
		128,
		109,
		145,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		79,
		75,
		70,
		74,
		67,
		74,
		70,
		69,
		70,
		52,
		88,
		-1,
		85,
		79,
		107,
		110,
		100,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		79,
		77,
		71,
		75,
		79,
		68,
		81,
		77,
		57,
		67,
		87,
		91,
		98,
		91,
		96,
		95,
		109,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		99,
		83,
		86,
		86,
		82,
		90,
		75,
		74,
		60,
		64,
		82,
		109,
		104,
		99,
		98,
		105,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		95,
		91,
		106,
		107,
		85,
		90,
		89,
		99,
		96,
		85,
		72,
		76,
		91,
		101,
		93,
		94,
		103,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		105,
		103,
		96,
		87,
		93,
		100,
		103,
		100,
		90,
		79,
		85,
		81,
		103,
		89,
		87,
		106,
		121,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		104,
		88,
		93,
		-1,
		125,
		-1,
		98,
		98,
		89,
		78,
		75,
		86,
		84,
		95,
		112,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		120,
		100,
		94,
		93,
		120,
		115,
		106,
		87,
		80,
		77,
		78,
		91,
		111,
		102,
		114,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		137,
		125,
		115,
		105,
		139,
		131,
		106,
		99,
		85,
		87,
		85,
		87,
		92,
		113,
		114,
		127,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		126,
		-1,
		-1,
		117,
		115,
		123,
		102,
		89,
		109,
		112,
		102,
		86,
		101,
		113,
		121,
		126,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		148,
		143,
		147,
		120,
		-1,
		119,
		113,
		93,
		107,
		114,
		104,
		99,
		93,
		96,
		114,
		131,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		136,
		129,
		133,
		-1,
		121,
		109,
		95,
		112,
		117,
		114,
		105,
		97,
		102,
		99,
		112,
		126,
		130,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		145,
		160,
		175,
		152,
		125,
		120,
		113,
		107,
		103,
		119,
		125,
		136,
		104,
		100,
		101,
		105,
		104,
		121,
		131,
		-1,
		-1,
		159,
		176,
		171,
		153,
		157,
		202,
		-1,
		-1,
		129,
		120,
		111,
		114,
		113,
		116,
		110,
		107,
		112,
		117,
		105,
		114,
		132,
		131,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		172,
		200,
		147,
		129,
		125,
		123,
		116,
		125,
		120,
		115,
		125,
		127,
		119,
		107,
		111,
		134,
		123,
		162,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		211,
		192,
		199,
		162,
		159,
		-1,
		129,
		154,
		126,
		133,
		124,
		131,
		131,
		123,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		291,
		280,
		269,
		275,
		-1,
		211,
		200,
		197,
		187,
		190,
		-1,
		-1,
		178,
		175,
		151,
		134,
		132,
		125,
		120,
		130,
		110,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		186,
		267,
		260,
		243,
		251,
		282,
		-1,
		201,
		193,
		204,
		179,
		181,
		-1,
		-1,
		151,
		148,
		153,
		141,
		138,
		140,
		135,
		126,
		111,
		117,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		200,
		243,
		237,
		240,
		264,
		278,
		-1,
		198,
		-1,
		-1,
		210,
		182,
		166,
		156,
		150,
		200,
		155,
		150,
		134,
		132,
		123,
		114,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		235,
		223,
		231,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		226,
		-1,
		193,
		-1,
		168,
		172,
		163,
		166,
		148,
		135,
		127,
		119,
		135,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		269,
		225,
		228,
		222,
		250,
		265,
		269,
		-1,
		210,
		249,
		247,
		-1,
		231,
		-1,
		-1,
		-1,
		182,
		176,
		168,
		168,
		147,
		147,
		121,
		125,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		265,
		256,
		269,
		214,
		214,
		235,
		244,
		265,
		225,
		216,
		243,
		254,
		243,
		238,
		225,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		154,
		142,
		125,
		126,
		122,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		205,
		232,
		-1,
		-1,
		227,
		244,
		238,
		242,
		258,
		283,
		-1,
		214,
		-1,
		-1,
		199,
		-1,
		-1,
		184,
		147,
		136,
		127,
		133,
		130,
		141,
		151,
		139,
		140,
		130,
		140,
		153,
		242,
		239,
		227,
		225,
		248,
		213,
		201,
		-1,
		214,
		212,
		218,
		225,
		242,
		272,
		-1,
		-1,
		230,
		210,
		-1,
		-1,
		182,
		180,
		169,
		-1,
		159,
		132,
		137,
		157,
		159,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		199,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		216,
		-1,
		-1,
		177,
		170,
		158,
		146,
		136,
		146,
		150,
		154,
		146,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		285,
		-1,
		237,
		213,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		211,
		195,
		176,
		-1,
		146,
		159,
		190,
		158,
		163,
		158,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		225,
		228,
		-1,
		-1,
		227,
		229,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		183,
		179,
		-1,
		-1,
		147,
		172,
		161,
		169,
		164,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		232,
		233,
		234,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		185,
		148,
		169,
		179,
		173,
		171,
		162,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		149,
		175,
		178,
		184,
		178,
		151,
		166,
		156,
		147,
		156,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		200,
		185,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		190,
		186,
		173,
		173,
		165,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		166,
		201,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		173,
		174,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		101,
		90,
		101,
		109,
		82,
		89,
		-1,
		108,
		112,
		78,
		72,
		111,
		80,
		86,
		97,
		-1,
		-1,
		-1,
		101,
		100,
		68,
		66,
		75,
		80,
		87,
		-1,
		86,
		-1,
		122,
		101,
		112,
		117,
		61,
		58,
		78,
		97,
		79,
		71,
		137,
		91,
		62,
		56,
		74,
		64,
		73,
		65,
		-1,
		62,
		52,
		74,
		53,
		64,
		56,
		-1,
		-1,
		56,
		57,
		63,
		49,
		55,
		51,
		-1,
		61,
		54,
		-1,
		-1,
		46,
		47,
		31,
		34,
		42,
		40,
		53,
		54,
		49,
		-1,
		-1,
		37,
		33,
		40,
		27,
		23,
		40,
		52,
		44,
		58,
		57,
		-1,
		49,
		66,
		66,
		34,
		32,
		16,
		13,
		31,
		43,
		49,
		56,
		-1,
		66,
		62,
		69,
		61,
		56,
		32,
		19,
		9,
		12,
		31,
		52,
		47,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		67,
		58,
		75,
		77,
		68,
		53,
		51,
		22,
		2,
		0,
		22,
		41,
		46,
		56,
		-1,
		-1,
		160,
		133,
		157,
		115,
		97,
		-1,
		63,
		65,
		71,
		72,
		66,
		59,
		53,
		38,
		-1,
		23,
		15,
		51,
		39,
		50,
		142,
		-1,
		-1,
		118,
		110,
		92,
		95,
		72,
		68,
		80,
		79,
		75,
		77,
		78,
		56,
		46,
		59,
		65,
		14,
		27,
		31,
		46,
		57,
		-1,
		-1,
		135,
		-1,
		-1,
		139,
		122,
		-1,
		87,
		94,
		78,
		84,
		70,
		91,
		90,
		84,
		91,
		87,
		79,
		54,
		51,
		64,
		43,
		18,
		38,
		42,
		49,
		67,
		68,
		-1,
		134,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		94,
		91,
		84,
		108,
		107,
		-1,
		113,
		111,
		116,
		101,
		100,
		94,
		82,
		59,
		43,
		43,
		40,
		25,
		27,
		64,
		51,
		72,
		69,
		100,
		110,
		104,
		113,
		-1,
		147,
		143,
		139,
		146,
		95,
		-1,
		-1,
		112,
		-1,
		115,
		128,
		125,
		112,
		115,
		102,
		102,
		89,
		78,
		60,
		41,
		38,
		37,
		33,
		42,
		52,
		51,
		69,
		78,
		97,
		101,
		107,
		-1,
		197,
		-1,
		139,
		123,
		125,
		101,
		129,
		-1,
		132,
		116,
		136,
		127,
		127,
		-1,
		118,
		115,
		107,
		85,
		70,
		53,
		41,
		36,
		36,
		40,
		55,
		46,
		64,
		71,
		79,
		83,
		103,
		115,
		157,
		147,
		-1,
		129,
		134,
		104,
		116,
		139,
		159,
		143,
		-1,
		138,
		-1,
		120,
		133,
		-1,
		91,
		87,
		61,
		49,
		38,
		45,
		43,
		37,
		34,
		52,
		55,
		72,
		76,
		92,
		-1,
		-1,
		142,
		146,
		154,
		105,
		124,
		148,
		185,
		150,
		139,
		138,
		-1,
		129,
		97,
		94,
		91,
		78,
		63,
		61,
		44,
		50,
		51,
		36,
		39,
		61,
		89,
		67,
		79,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		131,
		102,
		126,
		168,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		102,
		81,
		72,
		61,
		51,
		67,
		57,
		60,
		40,
		42,
		58,
		70,
		61,
		81,
		-1,
		-1,
		-1,
		161,
		150,
		151,
		105,
		136,
		157,
		147,
		133,
		138,
		113,
		106,
		100,
		106,
		98,
		79,
		68,
		60,
		49,
		58,
		68,
		62,
		42,
		51,
		52,
		76,
		83,
		89,
		-1,
		-1,
		168,
		158,
		142,
		144,
		141,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		89,
		73,
		68,
		65,
		62,
		56,
		65,
		70,
		56,
		47,
		62,
		81,
		81,
		73,
		98,
		101,
		-1,
		-1,
		-1,
		161,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		75,
		71,
		66,
		70,
		63,
		70,
		66,
		65,
		66,
		48,
		84,
		-1,
		81,
		75,
		103,
		106,
		96,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		75,
		73,
		67,
		71,
		75,
		64,
		77,
		73,
		53,
		63,
		83,
		87,
		94,
		87,
		92,
		91,
		105,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		95,
		79,
		82,
		82,
		78,
		86,
		71,
		70,
		56,
		60,
		78,
		105,
		100,
		95,
		94,
		101,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		87,
		102,
		103,
		81,
		86,
		85,
		95,
		92,
		81,
		68,
		72,
		87,
		97,
		89,
		90,
		99,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		101,
		99,
		92,
		83,
		89,
		96,
		99,
		96,
		86,
		75,
		81,
		77,
		99,
		85,
		83,
		102,
		117,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		100,
		84,
		89,
		-1,
		121,
		-1,
		94,
		94,
		85,
		74,
		71,
		82,
		80,
		91,
		108,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		116,
		96,
		90,
		89,
		116,
		111,
		102,
		83,
		76,
		73,
		74,
		87,
		107,
		98,
		110,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		133,
		121,
		111,
		101,
		135,
		127,
		102,
		95,
		81,
		83,
		81,
		83,
		88,
		109,
		110,
		123,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		122,
		-1,
		-1,
		113,
		111,
		119,
		98,
		85,
		105,
		108,
		98,
		82,
		97,
		109,
		117,
		122,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		144,
		139,
		143,
		116,
		-1,
		115,
		109,
		89,
		103,
		110,
		100,
		95,
		89,
		92,
		110,
		127,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		123,
		137,
		132,
		125,
		129,
		-1,
		117,
		105,
		91,
		108,
		113,
		110,
		101,
		93,
		98,
		95,
		108,
		122,
		126,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		141,
		156,
		171,
		148,
		121,
		116,
		109,
		103,
		99,
		115,
		121,
		132,
		100,
		96,
		97,
		101,
		100,
		117,
		127,
		-1,
		-1,
		155,
		172,
		167,
		149,
		153,
		198,
		-1,
		-1,
		125,
		116,
		107,
		110,
		109,
		112,
		106,
		103,
		108,
		113,
		101,
		110,
		128,
		127,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		168,
		196,
		143,
		125,
		121,
		119,
		112,
		121,
		116,
		111,
		121,
		123,
		115,
		103,
		107,
		130,
		119,
		158,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		204,
		179,
		194,
		207,
		188,
		195,
		158,
		155,
		-1,
		125,
		150,
		122,
		129,
		120,
		127,
		127,
		119,
		97,
		104,
		120,
		119,
		114,
		150,
		141,
		147,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		207,
		196,
		193,
		183,
		186,
		-1,
		-1,
		174,
		171,
		147,
		130,
		128,
		121,
		116,
		126,
		106,
		93,
		97,
		101,
		107,
		112,
		117,
		123,
		138,
		153,
		-1,
		182,
		263,
		256,
		239,
		247,
		278,
		-1,
		197,
		189,
		200,
		175,
		177,
		-1,
		-1,
		147,
		144,
		149,
		137,
		134,
		136,
		131,
		122,
		107,
		113,
		100,
		99,
		117,
		121,
		130,
		137,
		127,
		140,
		144,
		-1,
		196,
		239,
		233,
		236,
		260,
		274,
		-1,
		194,
		-1,
		-1,
		206,
		178,
		162,
		152,
		146,
		196,
		151,
		146,
		130,
		128,
		119,
		110,
		117,
		108,
		108,
		111,
		126,
		131,
		123,
		137,
		137,
		138,
		-1,
		231,
		219,
		227,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		222,
		-1,
		189,
		-1,
		164,
		168,
		159,
		162,
		144,
		131,
		123,
		115,
		131,
		106,
		116,
		112,
		113,
		122,
		133,
		145,
		144,
		145,
		265,
		221,
		224,
		218,
		246,
		261,
		265,
		-1,
		206,
		245,
		243,
		-1,
		227,
		-1,
		-1,
		-1,
		178,
		172,
		164,
		164,
		143,
		143,
		117,
		121,
		111,
		118,
		128,
		130,
		122,
		126,
		139,
		150,
		153,
		261,
		252,
		265,
		210,
		210,
		231,
		240,
		261,
		221,
		212,
		239,
		250,
		239,
		234,
		221,
		-1,
		-1,
		201,
		182,
		-1,
		-1,
		150,
		138,
		121,
		122,
		118,
		121,
		136,
		139,
		129,
		127,
		121,
		153,
		-1,
		254,
		253,
		242,
		239,
		215,
		206,
		201,
		228,
		-1,
		-1,
		223,
		240,
		234,
		238,
		254,
		279,
		-1,
		210,
		-1,
		-1,
		195,
		-1,
		-1,
		180,
		143,
		132,
		123,
		129,
		126,
		137,
		147,
		135,
		136,
		126,
		136,
		149,
		238,
		235,
		223,
		221,
		244,
		209,
		197,
		-1,
		210,
		208,
		214,
		221,
		238,
		268,
		-1,
		-1,
		226,
		206,
		-1,
		-1,
		178,
		176,
		165,
		-1,
		155,
		128,
		133,
		153,
		155,
		144,
		138,
		132,
		139,
		138,
		146,
		154,
		247,
		261,
		250,
		246,
		245,
		253,
		202,
		195,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		216,
		212,
		-1,
		-1,
		173,
		166,
		154,
		142,
		132,
		142,
		146,
		150,
		142,
		135,
		130,
		141,
		133,
		137,
		154,
		-1,
		281,
		-1,
		233,
		209,
		223,
		238,
		246,
		-1,
		-1,
		-1,
		233,
		219,
		212,
		200,
		198,
		-1,
		207,
		191,
		172,
		-1,
		142,
		155,
		186,
		154,
		159,
		154,
		136,
		147,
		136,
		139,
		153,
		148,
		-1,
		-1,
		221,
		224,
		-1,
		-1,
		223,
		225,
		-1,
		224,
		213,
		198,
		190,
		-1,
		-1,
		179,
		175,
		-1,
		-1,
		143,
		168,
		157,
		165,
		160,
		140,
		146,
		149,
		138,
		142,
		154,
		-1,
		-1,
		228,
		229,
		230,
		-1,
		208,
		-1,
		226,
		-1,
		193,
		199,
		187,
		-1,
		-1,
		-1,
		181,
		144,
		165,
		175,
		169,
		167,
		158,
		144,
		151,
		149,
		145,
		156,
		-1,
		-1,
		-1,
		226,
		200,
		233,
		224,
		207,
		187,
		179,
		198,
		-1,
		168,
		-1,
		143,
		145,
		171,
		174,
		180,
		174,
		147,
		162,
		152,
		143,
		152,
		232,
		-1,
		202,
		235,
		199,
		193,
		169,
		173,
		189,
		-1,
		165,
		147,
		-1,
		175,
		165,
		196,
		181,
		162,
		149,
		156,
		156,
		149,
		-1,
		-1,
		-1,
		204,
		203,
		195,
		189,
		189,
		174,
		165,
		-1,
		177,
		159,
		138,
		155,
		155,
		146,
		154,
		186,
		182,
		169,
		169,
		161,
		-1,
		305,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		198,
		193,
		166,
		154,
		160,
		156,
		142,
		148,
		150,
		158,
		156,
		153,
		165,
		161,
		181,
		162,
		197,
		-1,
		300,
		-1,
		234,
		-1,
		-1,
		216,
		196,
		188,
		177,
		166,
		164,
		155,
		146,
		168,
		184,
		168,
		166,
		169,
		170,
		-1,
		289,
		288,
		-1,
		235,
		227,
		213,
		-1,
		206,
		-1,
		212,
		173,
		-1,
		175,
		155,
		-1,
		177,
		173,
		-1,
		-1,
		276,
		251,
		-1,
		-1,
		-1,
		236,
		216,
		207,
		191,
		-1,
		166,
		166,
		-1,
		-1,
		-1,
		261,
		260,
		-1,
		229,
		232,
		-1,
		222,
		213,
		221,
		168,
		172,
		-1,
		-1,
		-1,
		270,
		251,
		245,
		244,
		242,
		237,
		234,
		220,
		204,
		182,
		171,
		192,
		-1,
		-1,
		-1,
		242,
		234,
		227,
		-1,
		-1,
		229,
		212,
		193,
		191,
		-1,
		-1,
		-1,
		264,
		245,
		-1,
		-1,
		219,
		-1,
		-1,
		225,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		253,
		-1,
		-1,
		-1,
		215,
		211,
		212,
		-1,
		-1,
		-1,
		-1,
		275,
		276,
		299,
		263,
		-1,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		278,
		276,
		-1,
		-1,
		-1,
		235,
		219,
		-1,
		205,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		240,
		-1,
		240,
		215,
		222,
		-1,
		-1,
		-1,
		-1,
		253,
		245,
		253,
		-1,
		225,
		227,
		-1,
		275,
		-1,
		-1,
		268,
		259,
		-1,
		-1,
		230,
		237,
		259,
		262,
		298,
		-1,
		249
	],
	[
		-1,
		117,
		106,
		117,
		125,
		98,
		105,
		-1,
		124,
		128,
		94,
		88,
		127,
		96,
		102,
		113,
		-1,
		-1,
		-1,
		117,
		116,
		84,
		82,
		91,
		96,
		103,
		-1,
		102,
		-1,
		138,
		117,
		128,
		133,
		77,
		74,
		94,
		113,
		95,
		87,
		153,
		107,
		78,
		72,
		90,
		80,
		89,
		81,
		-1,
		78,
		68,
		90,
		69,
		80,
		72,
		-1,
		-1,
		72,
		73,
		79,
		65,
		71,
		67,
		-1,
		50,
		32,
		-1,
		-1,
		62,
		63,
		47,
		50,
		58,
		56,
		46,
		32,
		27,
		-1,
		-1,
		53,
		49,
		56,
		43,
		39,
		56,
		47,
		22,
		36,
		35,
		-1,
		65,
		82,
		82,
		50,
		48,
		32,
		30,
		48,
		21,
		27,
		35,
		-1,
		82,
		78,
		79,
		77,
		72,
		48,
		35,
		31,
		34,
		9,
		36,
		36,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		83,
		74,
		91,
		75,
		65,
		69,
		67,
		38,
		24,
		22,
		0,
		25,
		35,
		45,
		-1,
		-1,
		176,
		149,
		173,
		131,
		113,
		-1,
		79,
		79,
		73,
		69,
		63,
		56,
		69,
		54,
		-1,
		12,
		4,
		35,
		28,
		39,
		158,
		-1,
		-1,
		134,
		126,
		108,
		111,
		88,
		84,
		94,
		93,
		86,
		79,
		75,
		53,
		56,
		56,
		62,
		11,
		16,
		20,
		35,
		46,
		-1,
		-1,
		132,
		-1,
		-1,
		155,
		138,
		-1,
		103,
		110,
		94,
		100,
		86,
		107,
		104,
		95,
		89,
		84,
		76,
		51,
		48,
		61,
		40,
		15,
		30,
		33,
		38,
		56,
		57,
		-1,
		131,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		110,
		107,
		100,
		124,
		123,
		-1,
		124,
		112,
		113,
		98,
		97,
		91,
		79,
		56,
		40,
		40,
		37,
		22,
		24,
		61,
		40,
		61,
		58,
		89,
		107,
		101,
		110,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		128,
		-1,
		131,
		144,
		136,
		109,
		112,
		99,
		99,
		86,
		75,
		57,
		38,
		35,
		34,
		30,
		39,
		45,
		48,
		64,
		67,
		94,
		98,
		104,
		-1,
		213,
		-1,
		155,
		139,
		141,
		117,
		145,
		-1,
		148,
		132,
		152,
		138,
		138,
		-1,
		115,
		112,
		104,
		82,
		67,
		50,
		38,
		33,
		33,
		37,
		52,
		43,
		61,
		68,
		76,
		80,
		100,
		112,
		173,
		163,
		-1,
		145,
		150,
		120,
		132,
		152,
		175,
		154,
		-1,
		149,
		-1,
		117,
		130,
		-1,
		88,
		84,
		58,
		46,
		35,
		42,
		40,
		34,
		31,
		49,
		52,
		69,
		73,
		89,
		-1,
		-1,
		158,
		162,
		167,
		118,
		137,
		161,
		198,
		147,
		136,
		135,
		-1,
		126,
		94,
		91,
		88,
		75,
		60,
		58,
		41,
		47,
		48,
		33,
		36,
		58,
		86,
		64,
		76,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		144,
		115,
		139,
		181,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		99,
		78,
		69,
		58,
		48,
		64,
		54,
		57,
		37,
		39,
		55,
		67,
		58,
		78,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		144,
		130,
		135,
		110,
		103,
		97,
		103,
		95,
		76,
		65,
		57,
		46,
		55,
		65,
		59,
		39,
		48,
		49,
		73,
		80,
		86,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		135,
		148,
		-1,
		102,
		-1,
		91,
		86,
		70,
		65,
		62,
		59,
		53,
		62,
		67,
		53,
		44,
		59,
		78,
		78,
		70,
		95,
		98,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		118,
		119,
		-1,
		96,
		90,
		87,
		72,
		68,
		63,
		67,
		60,
		67,
		63,
		62,
		63,
		45,
		81,
		-1,
		78,
		72,
		100,
		103,
		93,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		83,
		65,
		72,
		70,
		64,
		68,
		72,
		61,
		74,
		70,
		50,
		60,
		80,
		84,
		91,
		84,
		89,
		88,
		102,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		78,
		76,
		92,
		76,
		79,
		79,
		75,
		83,
		68,
		67,
		53,
		57,
		75,
		102,
		97,
		92,
		91,
		98,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		88,
		84,
		99,
		100,
		78,
		83,
		82,
		92,
		89,
		78,
		65,
		69,
		84,
		94,
		86,
		87,
		96,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		98,
		96,
		89,
		80,
		86,
		93,
		96,
		93,
		83,
		72,
		78,
		74,
		96,
		82,
		80,
		99,
		114,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		97,
		81,
		86,
		-1,
		118,
		-1,
		91,
		91,
		82,
		71,
		68,
		79,
		77,
		88,
		105,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		113,
		93,
		87,
		86,
		113,
		108,
		99,
		80,
		73,
		70,
		71,
		84,
		104,
		95,
		107,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		130,
		118,
		108,
		98,
		132,
		124,
		99,
		92,
		78,
		80,
		78,
		80,
		85,
		106,
		107,
		120,
		-1,
		-1,
		131,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		119,
		-1,
		-1,
		110,
		108,
		116,
		95,
		82,
		102,
		105,
		95,
		79,
		94,
		106,
		114,
		119,
		-1,
		134,
		121,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		136,
		140,
		113,
		-1,
		112,
		106,
		86,
		100,
		107,
		97,
		92,
		86,
		89,
		107,
		124,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		129,
		122,
		126,
		-1,
		114,
		102,
		88,
		105,
		110,
		107,
		98,
		90,
		95,
		92,
		105,
		119,
		123,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		138,
		153,
		168,
		145,
		118,
		113,
		106,
		100,
		96,
		112,
		118,
		129,
		97,
		93,
		94,
		98,
		97,
		114,
		124,
		-1,
		-1,
		152,
		169,
		164,
		146,
		150,
		195,
		-1,
		-1,
		122,
		113,
		104,
		107,
		106,
		109,
		103,
		100,
		105,
		110,
		98,
		107,
		125,
		124,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		165,
		193,
		140,
		122,
		118,
		116,
		109,
		118,
		113,
		108,
		118,
		120,
		112,
		100,
		104,
		127,
		116,
		155,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		201,
		176,
		191,
		204,
		185,
		192,
		155,
		152,
		-1,
		122,
		147,
		119,
		126,
		117,
		124,
		124,
		116,
		94,
		101,
		117,
		116,
		111,
		147,
		138,
		144,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		204,
		193,
		190,
		180,
		183,
		-1,
		-1,
		171,
		168,
		144,
		127,
		125,
		118,
		113,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		135,
		150,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		194,
		186,
		197,
		172,
		174,
		-1,
		-1,
		144,
		141,
		146,
		134,
		131,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		134,
		124,
		137,
		141,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		191,
		-1,
		-1,
		203,
		175,
		159,
		149,
		143,
		193,
		148,
		143,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		134,
		134,
		135,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		219,
		-1,
		186,
		-1,
		161,
		165,
		156,
		159,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		141,
		142,
		262,
		218,
		221,
		215,
		243,
		258,
		262,
		-1,
		203,
		242,
		240,
		-1,
		224,
		-1,
		-1,
		-1,
		175,
		169,
		161,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		150,
		258,
		249,
		262,
		207,
		207,
		228,
		237,
		258,
		218,
		209,
		236,
		247,
		236,
		231,
		218,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		251,
		250,
		239,
		236,
		212,
		203,
		198,
		225,
		-1,
		-1,
		220,
		237,
		231,
		235,
		251,
		276,
		-1,
		207,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		235,
		232,
		220,
		218,
		241,
		206,
		194,
		-1,
		207,
		205,
		211,
		218,
		235,
		265,
		-1,
		-1,
		223,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		244,
		258,
		247,
		243,
		242,
		250,
		199,
		192,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		278,
		-1,
		230,
		206,
		220,
		235,
		243,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		218,
		221,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		225,
		226,
		227,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		132,
		121,
		132,
		140,
		113,
		120,
		-1,
		139,
		143,
		109,
		103,
		142,
		111,
		117,
		128,
		-1,
		-1,
		-1,
		132,
		131,
		99,
		97,
		106,
		111,
		118,
		-1,
		117,
		-1,
		153,
		132,
		143,
		148,
		92,
		89,
		109,
		128,
		110,
		102,
		168,
		122,
		93,
		87,
		105,
		95,
		104,
		96,
		-1,
		93,
		83,
		105,
		84,
		95,
		82,
		-1,
		-1,
		87,
		88,
		94,
		80,
		86,
		82,
		-1,
		55,
		33,
		-1,
		-1,
		77,
		78,
		62,
		65,
		73,
		71,
		51,
		37,
		28,
		-1,
		-1,
		68,
		64,
		71,
		58,
		54,
		71,
		50,
		25,
		23,
		21,
		-1,
		80,
		97,
		97,
		65,
		63,
		47,
		45,
		60,
		22,
		21,
		15,
		-1,
		97,
		93,
		94,
		92,
		87,
		63,
		50,
		50,
		54,
		14,
		11,
		13,
		63,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		98,
		89,
		106,
		90,
		80,
		84,
		82,
		53,
		44,
		42,
		35,
		0,
		16,
		40,
		-1,
		-1,
		191,
		164,
		188,
		146,
		128,
		-1,
		94,
		94,
		88,
		84,
		78,
		71,
		84,
		69,
		-1,
		21,
		28,
		10,
		23,
		34,
		173,
		-1,
		-1,
		149,
		141,
		123,
		126,
		103,
		99,
		109,
		108,
		101,
		94,
		90,
		68,
		71,
		71,
		77,
		31,
		25,
		29,
		30,
		41,
		-1,
		-1,
		147,
		-1,
		-1,
		170,
		153,
		-1,
		118,
		125,
		109,
		115,
		101,
		122,
		119,
		110,
		104,
		99,
		91,
		66,
		63,
		76,
		55,
		30,
		36,
		40,
		33,
		51,
		52,
		-1,
		146,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		125,
		122,
		115,
		139,
		138,
		-1,
		139,
		127,
		128,
		113,
		112,
		106,
		94,
		71,
		55,
		55,
		52,
		37,
		39,
		67,
		35,
		56,
		53,
		84,
		122,
		116,
		125,
		-1,
		178,
		174,
		170,
		177,
		126,
		-1,
		-1,
		143,
		-1,
		146,
		159,
		151,
		124,
		127,
		114,
		114,
		101,
		90,
		72,
		53,
		50,
		49,
		45,
		54,
		40,
		43,
		59,
		62,
		109,
		113,
		119,
		-1,
		228,
		-1,
		170,
		154,
		156,
		132,
		160,
		-1,
		163,
		147,
		167,
		153,
		153,
		-1,
		130,
		127,
		119,
		97,
		82,
		65,
		53,
		48,
		48,
		52,
		67,
		47,
		65,
		67,
		74,
		95,
		115,
		127,
		188,
		178,
		-1,
		160,
		165,
		135,
		147,
		167,
		190,
		169,
		-1,
		164,
		-1,
		132,
		145,
		-1,
		103,
		99,
		73,
		61,
		50,
		57,
		55,
		49,
		46,
		53,
		56,
		84,
		85,
		104,
		-1,
		-1,
		173,
		177,
		182,
		133,
		152,
		176,
		213,
		162,
		151,
		150,
		-1,
		141,
		109,
		106,
		103,
		90,
		75,
		73,
		56,
		62,
		63,
		48,
		51,
		62,
		101,
		79,
		91,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		159,
		130,
		154,
		196,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		114,
		93,
		84,
		73,
		63,
		79,
		69,
		72,
		52,
		54,
		68,
		82,
		73,
		93,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		125,
		148,
		185,
		159,
		145,
		150,
		125,
		118,
		112,
		118,
		110,
		91,
		80,
		72,
		61,
		70,
		80,
		74,
		54,
		63,
		64,
		88,
		95,
		101,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		101,
		85,
		80,
		77,
		74,
		68,
		77,
		82,
		68,
		59,
		74,
		93,
		93,
		85,
		110,
		113,
		-1,
		-1,
		-1,
		189,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		87,
		83,
		78,
		82,
		75,
		82,
		78,
		77,
		78,
		60,
		96,
		-1,
		93,
		87,
		115,
		118,
		108,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		87,
		85,
		79,
		83,
		87,
		76,
		89,
		85,
		65,
		75,
		95,
		99,
		106,
		99,
		104,
		103,
		117,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		107,
		91,
		94,
		94,
		90,
		98,
		83,
		82,
		68,
		72,
		90,
		117,
		112,
		107,
		106,
		113,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		99,
		114,
		115,
		93,
		98,
		97,
		107,
		104,
		93,
		80,
		84,
		99,
		109,
		101,
		102,
		111,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		113,
		111,
		104,
		95,
		101,
		108,
		111,
		108,
		98,
		87,
		93,
		89,
		111,
		97,
		95,
		114,
		129,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		112,
		96,
		101,
		-1,
		133,
		-1,
		106,
		106,
		97,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		128,
		108,
		102,
		101,
		128,
		123,
		114,
		95,
		88,
		85,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		145,
		133,
		123,
		113,
		147,
		139,
		114,
		107,
		93,
		95,
		93,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		134,
		-1,
		-1,
		125,
		123,
		131,
		110,
		97,
		117,
		120,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		156,
		151,
		155,
		128,
		-1,
		127,
		121,
		101,
		115,
		122,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		135,
		149,
		144,
		137,
		141,
		-1,
		129,
		117,
		103,
		120,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		153,
		168,
		183,
		160,
		133,
		128,
		121,
		115,
		111,
		127,
		133,
		144,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		167,
		184,
		179,
		161,
		165,
		210,
		-1,
		-1,
		137,
		128,
		119,
		122,
		121,
		124,
		118,
		115,
		120,
		125,
		113,
		122,
		140,
		139,
		-1,
		-1,
		-1,
		187,
		-1,
		202,
		-1,
		-1,
		180,
		208,
		155,
		137,
		133,
		131,
		124,
		133,
		128,
		123,
		133,
		135,
		127,
		115,
		119,
		142,
		131,
		170,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		216,
		191,
		206,
		219,
		200,
		207,
		170,
		167,
		-1,
		137,
		162,
		134,
		141,
		132,
		139,
		139,
		131,
		109,
		116,
		132,
		131,
		126,
		162,
		153,
		159,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		219,
		208,
		205,
		195,
		198,
		-1,
		-1,
		186,
		183,
		159,
		142,
		140,
		133,
		128,
		138,
		118,
		105,
		109,
		113,
		119,
		124,
		129,
		135,
		150,
		165,
		-1,
		194,
		275,
		268,
		251,
		259,
		290,
		-1,
		209,
		201,
		212,
		187,
		189,
		-1,
		-1,
		159,
		156,
		161,
		149,
		146,
		148,
		143,
		134,
		119,
		125,
		112,
		111,
		129,
		133,
		142,
		149,
		139,
		152,
		156,
		-1,
		208,
		251,
		245,
		248,
		272,
		286,
		-1,
		206,
		-1,
		-1,
		218,
		190,
		174,
		164,
		158,
		208,
		163,
		158,
		142,
		140,
		131,
		122,
		129,
		120,
		120,
		123,
		138,
		143,
		135,
		149,
		149,
		150,
		-1,
		243,
		231,
		239,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		234,
		-1,
		201,
		-1,
		176,
		180,
		171,
		174,
		156,
		143,
		135,
		127,
		143,
		118,
		128,
		124,
		125,
		134,
		145,
		157,
		156,
		157,
		277,
		233,
		236,
		230,
		258,
		273,
		277,
		-1,
		218,
		257,
		255,
		-1,
		239,
		-1,
		-1,
		-1,
		190,
		184,
		176,
		176,
		155,
		155,
		129,
		133,
		123,
		130,
		140,
		142,
		134,
		138,
		151,
		162,
		165,
		273,
		264,
		277,
		222,
		222,
		243,
		252,
		273,
		233,
		224,
		251,
		262,
		251,
		246,
		233,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		162,
		150,
		133,
		134,
		130,
		133,
		148,
		151,
		141,
		139,
		133,
		165,
		-1,
		266,
		265,
		254,
		251,
		227,
		218,
		213,
		240,
		-1,
		-1,
		235,
		252,
		246,
		250,
		266,
		291,
		-1,
		222,
		-1,
		-1,
		207,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		138,
		149,
		159,
		147,
		148,
		138,
		148,
		161,
		250,
		247,
		235,
		233,
		256,
		221,
		209,
		-1,
		222,
		220,
		226,
		233,
		250,
		280,
		-1,
		-1,
		238,
		218,
		-1,
		-1,
		190,
		188,
		177,
		-1,
		167,
		140,
		145,
		165,
		167,
		156,
		150,
		144,
		151,
		150,
		158,
		166,
		259,
		273,
		262,
		258,
		257,
		265,
		214,
		207,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		-1,
		228,
		224,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		158,
		162,
		154,
		147,
		142,
		153,
		145,
		149,
		166,
		-1,
		293,
		-1,
		245,
		221,
		235,
		250,
		258,
		-1,
		-1,
		-1,
		245,
		231,
		224,
		212,
		210,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		148,
		159,
		148,
		151,
		165,
		160,
		-1,
		-1,
		233,
		236,
		-1,
		-1,
		235,
		237,
		-1,
		236,
		225,
		210,
		202,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		152,
		158,
		161,
		150,
		154,
		166,
		-1,
		-1,
		240,
		241,
		242,
		-1,
		220,
		-1,
		238,
		-1,
		205,
		211,
		199,
		-1,
		-1,
		-1,
		193,
		156,
		177,
		187,
		181,
		179,
		170,
		156,
		163,
		161,
		157,
		168,
		-1,
		-1,
		-1,
		238,
		212,
		245,
		236,
		219,
		199,
		191,
		210,
		-1,
		180,
		-1,
		155,
		157,
		183,
		186,
		192,
		186,
		159,
		174,
		164,
		155,
		164,
		244,
		-1,
		214,
		247,
		211,
		205,
		181,
		185,
		201,
		-1,
		177,
		159,
		-1,
		187,
		177,
		208,
		193,
		174,
		161,
		168,
		168,
		161,
		-1,
		-1,
		-1,
		216,
		215,
		207,
		201,
		201,
		186,
		177,
		-1,
		189,
		171,
		150,
		167,
		167,
		158,
		166,
		198,
		194,
		181,
		181,
		173,
		-1,
		317,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		210,
		205,
		178,
		166,
		172,
		168,
		154,
		160,
		162,
		170,
		168,
		165,
		177,
		173,
		193,
		174,
		209,
		-1,
		312,
		-1,
		246,
		-1,
		-1,
		228,
		208,
		200,
		189,
		178,
		176,
		167,
		158,
		180,
		196,
		180,
		178,
		181,
		182,
		-1,
		301,
		300,
		-1,
		247,
		239,
		225,
		-1,
		218,
		-1,
		224,
		185,
		-1,
		187,
		167,
		-1,
		189,
		185,
		-1,
		-1,
		288,
		263,
		-1,
		-1,
		-1,
		248,
		228,
		219,
		203,
		-1,
		178,
		178,
		-1,
		-1,
		-1,
		273,
		272,
		-1,
		241,
		244,
		-1,
		234,
		225,
		233,
		180,
		184,
		-1,
		-1,
		-1,
		282,
		263,
		257,
		256,
		254,
		249,
		246,
		232,
		216,
		194,
		183,
		204,
		-1,
		-1,
		-1,
		254,
		246,
		239,
		-1,
		-1,
		241,
		224,
		205,
		203,
		-1,
		-1,
		-1,
		276,
		257,
		-1,
		-1,
		231,
		-1,
		-1,
		237,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		293,
		265,
		-1,
		-1,
		-1,
		227,
		223,
		224,
		-1,
		-1,
		-1,
		-1,
		287,
		288,
		311,
		275,
		-1,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		290,
		288,
		-1,
		-1,
		-1,
		247,
		231,
		-1,
		217,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		252,
		-1,
		252,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		265,
		257,
		265,
		-1,
		237,
		239,
		-1,
		287,
		-1,
		-1,
		280,
		271,
		-1,
		-1,
		242,
		249,
		271,
		274,
		310,
		-1,
		261
	],
	[
		-1,
		133,
		122,
		133,
		141,
		114,
		121,
		-1,
		140,
		144,
		110,
		104,
		143,
		112,
		118,
		129,
		-1,
		-1,
		-1,
		133,
		132,
		100,
		98,
		107,
		112,
		119,
		-1,
		118,
		-1,
		154,
		133,
		144,
		149,
		93,
		90,
		110,
		129,
		111,
		103,
		169,
		123,
		94,
		88,
		106,
		96,
		105,
		97,
		-1,
		94,
		84,
		106,
		85,
		96,
		88,
		-1,
		-1,
		88,
		89,
		95,
		81,
		87,
		83,
		-1,
		69,
		42,
		-1,
		-1,
		78,
		79,
		63,
		66,
		74,
		72,
		65,
		51,
		37,
		-1,
		-1,
		69,
		65,
		72,
		59,
		55,
		72,
		68,
		37,
		24,
		22,
		-1,
		81,
		98,
		98,
		66,
		64,
		48,
		46,
		64,
		39,
		22,
		14,
		-1,
		98,
		94,
		95,
		93,
		88,
		64,
		51,
		51,
		61,
		33,
		16,
		3,
		47,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		99,
		90,
		107,
		91,
		81,
		85,
		83,
		54,
		51,
		49,
		38,
		19,
		0,
		24,
		-1,
		-1,
		192,
		165,
		189,
		147,
		129,
		-1,
		95,
		95,
		89,
		85,
		79,
		72,
		85,
		70,
		-1,
		22,
		31,
		21,
		7,
		18,
		174,
		-1,
		-1,
		150,
		142,
		124,
		127,
		104,
		100,
		110,
		109,
		102,
		95,
		91,
		69,
		72,
		72,
		78,
		34,
		17,
		14,
		14,
		25,
		-1,
		-1,
		131,
		-1,
		-1,
		171,
		154,
		-1,
		119,
		126,
		110,
		116,
		102,
		123,
		120,
		111,
		105,
		100,
		92,
		67,
		64,
		77,
		56,
		31,
		24,
		27,
		17,
		35,
		36,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		126,
		123,
		116,
		140,
		139,
		-1,
		140,
		128,
		129,
		114,
		113,
		107,
		95,
		72,
		56,
		56,
		53,
		38,
		40,
		51,
		19,
		40,
		37,
		68,
		106,
		100,
		109,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		144,
		-1,
		147,
		160,
		152,
		125,
		128,
		115,
		115,
		102,
		91,
		73,
		54,
		51,
		50,
		46,
		55,
		24,
		27,
		43,
		46,
		93,
		97,
		103,
		-1,
		229,
		-1,
		171,
		155,
		157,
		133,
		161,
		-1,
		164,
		148,
		168,
		154,
		154,
		-1,
		131,
		128,
		120,
		98,
		83,
		66,
		54,
		49,
		49,
		51,
		56,
		31,
		49,
		51,
		58,
		79,
		101,
		111,
		189,
		179,
		-1,
		161,
		166,
		136,
		148,
		168,
		191,
		170,
		-1,
		165,
		-1,
		133,
		146,
		-1,
		104,
		100,
		74,
		62,
		51,
		58,
		56,
		47,
		44,
		37,
		40,
		69,
		69,
		95,
		-1,
		-1,
		174,
		178,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		110,
		107,
		104,
		91,
		76,
		74,
		57,
		63,
		61,
		46,
		49,
		46,
		88,
		74,
		86,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		64,
		80,
		67,
		70,
		50,
		52,
		52,
		77,
		68,
		88,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		119,
		111,
		92,
		81,
		73,
		62,
		68,
		78,
		72,
		52,
		61,
		59,
		83,
		90,
		96,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		75,
		69,
		78,
		80,
		66,
		57,
		72,
		88,
		88,
		80,
		105,
		108,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		79,
		83,
		76,
		83,
		79,
		75,
		76,
		58,
		93,
		-1,
		88,
		82,
		110,
		113,
		103,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		88,
		86,
		80,
		84,
		88,
		77,
		90,
		83,
		63,
		73,
		93,
		97,
		101,
		94,
		99,
		98,
		112,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		108,
		92,
		95,
		95,
		91,
		99,
		84,
		80,
		66,
		70,
		88,
		112,
		107,
		105,
		104,
		108,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		100,
		115,
		116,
		94,
		99,
		98,
		108,
		102,
		91,
		78,
		82,
		97,
		107,
		99,
		100,
		109,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		114,
		112,
		105,
		96,
		102,
		109,
		111,
		106,
		96,
		85,
		91,
		87,
		109,
		95,
		93,
		109,
		124,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		113,
		97,
		102,
		-1,
		131,
		-1,
		104,
		104,
		95,
		84,
		81,
		92,
		90,
		101,
		115,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		129,
		109,
		103,
		102,
		126,
		121,
		112,
		93,
		86,
		83,
		84,
		97,
		117,
		108,
		117,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		146,
		134,
		124,
		114,
		147,
		137,
		112,
		105,
		91,
		93,
		91,
		93,
		98,
		119,
		120,
		132,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		135,
		-1,
		-1,
		126,
		124,
		129,
		108,
		95,
		115,
		118,
		108,
		92,
		107,
		119,
		124,
		132,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		154,
		149,
		153,
		129,
		-1,
		125,
		119,
		99,
		113,
		120,
		110,
		105,
		99,
		102,
		120,
		135,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		136,
		150,
		142,
		135,
		139,
		-1,
		127,
		115,
		101,
		118,
		123,
		120,
		111,
		103,
		108,
		105,
		118,
		132,
		136,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		154,
		169,
		181,
		158,
		131,
		126,
		119,
		113,
		109,
		125,
		131,
		142,
		110,
		106,
		107,
		111,
		110,
		127,
		137,
		-1,
		-1,
		168,
		185,
		180,
		162,
		166,
		208,
		-1,
		-1,
		135,
		126,
		117,
		120,
		119,
		122,
		116,
		113,
		118,
		123,
		111,
		120,
		138,
		137,
		-1,
		-1,
		-1,
		188,
		-1,
		203,
		-1,
		-1,
		181,
		206,
		153,
		135,
		131,
		129,
		122,
		131,
		126,
		121,
		131,
		133,
		125,
		113,
		117,
		140,
		129,
		168,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		217,
		192,
		207,
		217,
		201,
		208,
		168,
		165,
		-1,
		135,
		160,
		132,
		139,
		130,
		137,
		137,
		129,
		107,
		114,
		130,
		129,
		124,
		160,
		151,
		157,
		-1,
		-1,
		300,
		289,
		278,
		284,
		-1,
		217,
		209,
		203,
		193,
		196,
		-1,
		-1,
		184,
		181,
		157,
		140,
		138,
		131,
		126,
		136,
		116,
		103,
		107,
		111,
		117,
		122,
		127,
		133,
		148,
		163,
		-1,
		195,
		276,
		269,
		252,
		260,
		291,
		-1,
		207,
		199,
		210,
		185,
		187,
		-1,
		-1,
		157,
		154,
		159,
		147,
		144,
		146,
		141,
		132,
		117,
		123,
		110,
		109,
		127,
		131,
		140,
		147,
		137,
		150,
		154,
		-1,
		209,
		252,
		246,
		249,
		273,
		287,
		-1,
		204,
		-1,
		-1,
		216,
		188,
		172,
		162,
		156,
		206,
		161,
		156,
		140,
		138,
		129,
		120,
		127,
		118,
		118,
		121,
		136,
		141,
		133,
		147,
		147,
		148,
		-1,
		244,
		232,
		240,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		232,
		-1,
		199,
		-1,
		174,
		178,
		169,
		172,
		154,
		141,
		133,
		125,
		141,
		116,
		126,
		122,
		123,
		132,
		143,
		155,
		154,
		155,
		275,
		231,
		234,
		231,
		256,
		271,
		275,
		-1,
		216,
		255,
		253,
		-1,
		237,
		-1,
		-1,
		-1,
		188,
		182,
		174,
		174,
		153,
		153,
		127,
		131,
		121,
		128,
		138,
		140,
		132,
		136,
		149,
		160,
		163,
		271,
		262,
		275,
		220,
		220,
		241,
		250,
		271,
		231,
		222,
		249,
		260,
		249,
		244,
		231,
		-1,
		-1,
		211,
		192,
		-1,
		-1,
		160,
		148,
		131,
		132,
		128,
		131,
		146,
		149,
		139,
		137,
		131,
		163,
		-1,
		264,
		263,
		252,
		249,
		225,
		216,
		211,
		238,
		-1,
		-1,
		233,
		250,
		244,
		248,
		264,
		289,
		-1,
		220,
		-1,
		-1,
		205,
		-1,
		-1,
		190,
		153,
		142,
		133,
		139,
		136,
		147,
		157,
		145,
		146,
		136,
		146,
		159,
		248,
		245,
		233,
		231,
		254,
		219,
		207,
		-1,
		220,
		218,
		224,
		231,
		248,
		278,
		-1,
		-1,
		236,
		216,
		-1,
		-1,
		188,
		186,
		175,
		-1,
		165,
		138,
		143,
		163,
		165,
		154,
		148,
		142,
		149,
		148,
		156,
		164,
		257,
		271,
		260,
		256,
		255,
		263,
		212,
		205,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		226,
		222,
		-1,
		-1,
		183,
		176,
		164,
		152,
		142,
		152,
		156,
		160,
		152,
		145,
		140,
		151,
		143,
		147,
		164,
		-1,
		291,
		-1,
		243,
		219,
		233,
		248,
		256,
		-1,
		-1,
		-1,
		243,
		229,
		222,
		210,
		208,
		-1,
		217,
		201,
		182,
		-1,
		152,
		165,
		196,
		164,
		169,
		164,
		146,
		157,
		146,
		149,
		163,
		158,
		-1,
		-1,
		231,
		234,
		-1,
		-1,
		233,
		235,
		-1,
		234,
		223,
		208,
		200,
		-1,
		-1,
		189,
		185,
		-1,
		-1,
		153,
		178,
		167,
		175,
		170,
		150,
		156,
		159,
		148,
		152,
		164,
		-1,
		-1,
		238,
		239,
		240,
		-1,
		218,
		-1,
		236,
		-1,
		203,
		209,
		197,
		-1,
		-1,
		-1,
		191,
		154,
		175,
		185,
		179,
		177,
		168,
		154,
		161,
		159,
		155,
		166,
		-1,
		-1,
		-1,
		236,
		210,
		243,
		234,
		217,
		197,
		189,
		208,
		-1,
		178,
		-1,
		153,
		155,
		181,
		184,
		190,
		184,
		157,
		172,
		162,
		153,
		162,
		242,
		-1,
		212,
		245,
		209,
		203,
		179,
		183,
		199,
		-1,
		175,
		157,
		-1,
		185,
		175,
		206,
		191,
		172,
		159,
		166,
		166,
		159,
		-1,
		-1,
		-1,
		214,
		213,
		205,
		199,
		199,
		184,
		175,
		-1,
		187,
		169,
		148,
		165,
		165,
		156,
		164,
		196,
		192,
		179,
		179,
		171,
		-1,
		315,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		208,
		203,
		176,
		164,
		170,
		166,
		152,
		158,
		160,
		168,
		166,
		163,
		175,
		171,
		191,
		172,
		207,
		-1,
		310,
		-1,
		244,
		-1,
		-1,
		226,
		206,
		198,
		187,
		176,
		174,
		165,
		156,
		178,
		194,
		178,
		176,
		179,
		180,
		-1,
		299,
		298,
		-1,
		245,
		237,
		223,
		-1,
		216,
		-1,
		222,
		183,
		-1,
		185,
		165,
		-1,
		187,
		183,
		-1,
		-1,
		286,
		261,
		-1,
		-1,
		-1,
		246,
		226,
		217,
		201,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		271,
		270,
		-1,
		239,
		242,
		-1,
		232,
		223,
		231,
		178,
		182,
		-1,
		-1,
		-1,
		280,
		261,
		255,
		254,
		252,
		247,
		244,
		230,
		214,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		252,
		244,
		237,
		-1,
		-1,
		239,
		222,
		203,
		201,
		-1,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		229,
		-1,
		-1,
		235,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		263,
		-1,
		-1,
		-1,
		225,
		221,
		222,
		-1,
		-1,
		-1,
		-1,
		285,
		286,
		309,
		273,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		288,
		286,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		145,
		134,
		145,
		153,
		126,
		133,
		-1,
		152,
		156,
		122,
		116,
		155,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		145,
		144,
		112,
		110,
		119,
		124,
		131,
		-1,
		130,
		-1,
		166,
		145,
		156,
		161,
		105,
		102,
		122,
		141,
		123,
		115,
		181,
		135,
		106,
		100,
		118,
		108,
		117,
		109,
		-1,
		106,
		96,
		118,
		97,
		108,
		100,
		-1,
		-1,
		100,
		101,
		107,
		93,
		99,
		95,
		-1,
		93,
		66,
		-1,
		-1,
		90,
		91,
		75,
		78,
		86,
		84,
		89,
		75,
		61,
		-1,
		-1,
		81,
		77,
		84,
		71,
		67,
		84,
		92,
		61,
		48,
		46,
		-1,
		93,
		110,
		110,
		78,
		76,
		60,
		58,
		76,
		63,
		46,
		38,
		-1,
		110,
		106,
		107,
		105,
		100,
		76,
		63,
		63,
		73,
		57,
		40,
		27,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		102,
		119,
		103,
		93,
		97,
		95,
		66,
		63,
		61,
		50,
		43,
		26,
		0,
		-1,
		-1,
		204,
		177,
		201,
		159,
		141,
		-1,
		107,
		107,
		101,
		97,
		91,
		84,
		97,
		82,
		-1,
		34,
		43,
		33,
		19,
		6,
		186,
		-1,
		-1,
		162,
		154,
		136,
		139,
		116,
		112,
		122,
		121,
		114,
		107,
		103,
		81,
		84,
		84,
		90,
		46,
		29,
		26,
		26,
		31,
		-1,
		-1,
		139,
		-1,
		-1,
		183,
		166,
		-1,
		131,
		138,
		122,
		128,
		114,
		135,
		132,
		123,
		117,
		112,
		104,
		79,
		76,
		89,
		68,
		43,
		30,
		33,
		29,
		41,
		42,
		-1,
		138,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		138,
		135,
		128,
		152,
		151,
		-1,
		152,
		140,
		141,
		126,
		125,
		119,
		107,
		84,
		68,
		68,
		65,
		50,
		52,
		63,
		31,
		46,
		43,
		74,
		114,
		108,
		117,
		-1,
		191,
		187,
		183,
		190,
		139,
		-1,
		-1,
		156,
		-1,
		159,
		172,
		164,
		137,
		140,
		127,
		127,
		114,
		103,
		85,
		66,
		63,
		62,
		58,
		67,
		36,
		39,
		55,
		52,
		101,
		105,
		111,
		-1,
		241,
		-1,
		183,
		167,
		169,
		145,
		173,
		-1,
		176,
		160,
		180,
		166,
		166,
		-1,
		143,
		140,
		132,
		110,
		95,
		78,
		66,
		61,
		61,
		63,
		68,
		43,
		61,
		63,
		64,
		87,
		109,
		119,
		201,
		191,
		-1,
		173,
		178,
		148,
		160,
		180,
		203,
		182,
		-1,
		177,
		-1,
		145,
		158,
		-1,
		116,
		112,
		86,
		74,
		63,
		70,
		68,
		59,
		56,
		49,
		52,
		77,
		75,
		103,
		-1,
		-1,
		186,
		190,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		122,
		119,
		116,
		103,
		88,
		86,
		69,
		75,
		73,
		58,
		61,
		58,
		96,
		80,
		98,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		127,
		106,
		97,
		86,
		76,
		92,
		79,
		82,
		62,
		64,
		64,
		89,
		80,
		100,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		131,
		123,
		104,
		93,
		85,
		74,
		80,
		90,
		84,
		64,
		73,
		71,
		95,
		102,
		108,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		87,
		81,
		90,
		92,
		78,
		69,
		84,
		100,
		100,
		92,
		117,
		120,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		91,
		95,
		88,
		95,
		91,
		87,
		88,
		70,
		105,
		-1,
		100,
		94,
		122,
		125,
		115,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		100,
		98,
		92,
		96,
		100,
		89,
		102,
		95,
		75,
		85,
		105,
		109,
		113,
		106,
		111,
		110,
		124,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		120,
		104,
		107,
		107,
		103,
		111,
		96,
		92,
		78,
		82,
		100,
		124,
		119,
		117,
		116,
		120,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		112,
		127,
		128,
		106,
		111,
		110,
		120,
		114,
		103,
		90,
		94,
		109,
		119,
		111,
		112,
		121,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		126,
		124,
		117,
		108,
		114,
		121,
		123,
		118,
		108,
		97,
		103,
		99,
		121,
		107,
		105,
		121,
		136,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		125,
		109,
		114,
		-1,
		143,
		-1,
		116,
		116,
		107,
		96,
		93,
		104,
		102,
		113,
		127,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		141,
		121,
		115,
		114,
		138,
		133,
		124,
		105,
		98,
		95,
		96,
		109,
		129,
		120,
		129,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		158,
		146,
		136,
		126,
		159,
		149,
		124,
		117,
		103,
		105,
		103,
		105,
		110,
		131,
		132,
		144,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		147,
		-1,
		-1,
		138,
		136,
		141,
		120,
		107,
		127,
		130,
		120,
		104,
		119,
		131,
		136,
		144,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		166,
		161,
		165,
		141,
		-1,
		137,
		131,
		111,
		125,
		132,
		122,
		117,
		111,
		114,
		132,
		147,
		-1,
		-1,
		174,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		148,
		162,
		154,
		147,
		151,
		-1,
		139,
		127,
		113,
		130,
		135,
		132,
		123,
		115,
		120,
		117,
		130,
		144,
		148,
		197,
		-1,
		180,
		-1,
		-1,
		-1,
		166,
		181,
		193,
		170,
		143,
		138,
		131,
		125,
		121,
		137,
		143,
		154,
		122,
		118,
		119,
		123,
		122,
		139,
		149,
		-1,
		-1,
		180,
		197,
		192,
		174,
		178,
		220,
		-1,
		-1,
		147,
		138,
		129,
		132,
		131,
		134,
		128,
		125,
		130,
		135,
		123,
		132,
		150,
		149,
		-1,
		-1,
		-1,
		200,
		-1,
		215,
		-1,
		-1,
		193,
		218,
		165,
		147,
		143,
		141,
		134,
		143,
		138,
		133,
		143,
		145,
		137,
		125,
		129,
		152,
		141,
		180,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		229,
		204,
		219,
		229,
		213,
		220,
		180,
		177,
		-1,
		147,
		172,
		144,
		151,
		142,
		149,
		149,
		141,
		119,
		126,
		142,
		141,
		136,
		172,
		163,
		169,
		-1,
		-1,
		312,
		301,
		290,
		296,
		-1,
		229,
		221,
		215,
		205,
		208,
		-1,
		-1,
		196,
		193,
		169,
		152,
		150,
		143,
		138,
		148,
		128,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		207,
		288,
		281,
		264,
		272,
		303,
		-1,
		219,
		211,
		222,
		197,
		199,
		-1,
		-1,
		169,
		166,
		171,
		159,
		156,
		158,
		153,
		144,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		221,
		264,
		258,
		261,
		285,
		299,
		-1,
		216,
		-1,
		-1,
		228,
		200,
		184,
		174,
		168,
		218,
		173,
		168,
		152,
		150,
		141,
		132,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		256,
		244,
		252,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		244,
		-1,
		211,
		-1,
		186,
		190,
		181,
		184,
		166,
		153,
		145,
		137,
		153,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		287,
		243,
		246,
		243,
		268,
		283,
		287,
		-1,
		228,
		267,
		265,
		-1,
		249,
		-1,
		-1,
		-1,
		200,
		194,
		186,
		186,
		165,
		165,
		139,
		143,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		283,
		274,
		287,
		232,
		232,
		253,
		262,
		283,
		243,
		234,
		261,
		272,
		261,
		256,
		243,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		172,
		160,
		143,
		144,
		140,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		276,
		275,
		264,
		261,
		237,
		228,
		223,
		250,
		-1,
		-1,
		245,
		262,
		256,
		260,
		276,
		301,
		-1,
		232,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		165,
		154,
		145,
		151,
		148,
		159,
		169,
		157,
		158,
		148,
		158,
		171,
		260,
		257,
		245,
		243,
		266,
		231,
		219,
		-1,
		232,
		230,
		236,
		243,
		260,
		290,
		-1,
		-1,
		248,
		228,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		150,
		155,
		175,
		177,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		269,
		283,
		272,
		268,
		267,
		275,
		224,
		217,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		238,
		234,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		168,
		172,
		164,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		303,
		-1,
		255,
		231,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		255,
		241,
		234,
		222,
		220,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		208,
		176,
		181,
		176,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		245,
		247,
		-1,
		246,
		235,
		220,
		212,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		165,
		190,
		179,
		187,
		182,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		250,
		251,
		252,
		-1,
		230,
		-1,
		248,
		-1,
		215,
		221,
		209,
		-1,
		-1,
		-1,
		203,
		166,
		187,
		197,
		191,
		189,
		180,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		248,
		222,
		255,
		246,
		229,
		209,
		201,
		220,
		-1,
		190,
		-1,
		165,
		167,
		193,
		196,
		202,
		196,
		169,
		184,
		174,
		165,
		174,
		254,
		-1,
		224,
		257,
		221,
		215,
		191,
		195,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		218,
		203,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		226,
		225,
		217,
		211,
		211,
		196,
		187,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		208,
		204,
		191,
		191,
		183,
		-1,
		327,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		220,
		215,
		188,
		176,
		182,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		184,
		219,
		-1,
		322,
		-1,
		256,
		-1,
		-1,
		238,
		218,
		210,
		199,
		188,
		186,
		177,
		168,
		190,
		206,
		190,
		188,
		191,
		192,
		-1,
		311,
		310,
		-1,
		257,
		249,
		235,
		-1,
		228,
		-1,
		234,
		195,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		298,
		273,
		-1,
		-1,
		-1,
		258,
		238,
		229,
		213,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		283,
		282,
		-1,
		251,
		254,
		-1,
		244,
		235,
		243,
		190,
		194,
		-1,
		-1,
		-1,
		292,
		273,
		267,
		266,
		264,
		259,
		256,
		242,
		226,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		264,
		256,
		249,
		-1,
		-1,
		251,
		234,
		215,
		213,
		-1,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		241,
		-1,
		-1,
		247,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		275,
		-1,
		-1,
		-1,
		237,
		233,
		234,
		-1,
		-1,
		-1,
		-1,
		297,
		298,
		321,
		285,
		-1,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		300,
		298,
		-1,
		-1,
		-1,
		257,
		241,
		-1,
		227,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		262,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		275,
		267,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		290,
		281,
		-1,
		-1,
		252,
		259,
		281,
		284,
		320,
		-1,
		271
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		177,
		166,
		177,
		185,
		158,
		165,
		-1,
		186,
		188,
		154,
		148,
		187,
		158,
		164,
		175,
		-1,
		-1,
		-1,
		177,
		176,
		146,
		144,
		153,
		158,
		165,
		-1,
		188,
		-1,
		198,
		177,
		188,
		193,
		139,
		136,
		156,
		175,
		181,
		173,
		213,
		169,
		140,
		134,
		152,
		157,
		175,
		167,
		-1,
		140,
		130,
		152,
		156,
		168,
		151,
		-1,
		-1,
		134,
		135,
		141,
		153,
		158,
		163,
		-1,
		189,
		208,
		-1,
		-1,
		124,
		137,
		133,
		136,
		144,
		160,
		181,
		198,
		203,
		-1,
		-1,
		125,
		129,
		142,
		143,
		141,
		168,
		187,
		198,
		212,
		211,
		-1,
		113,
		131,
		140,
		149,
		155,
		144,
		148,
		166,
		197,
		203,
		206,
		-1,
		105,
		107,
		136,
		142,
		154,
		160,
		147,
		153,
		172,
		185,
		204,
		195,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		102,
		110,
		136,
		135,
		131,
		149,
		171,
		150,
		156,
		160,
		177,
		193,
		194,
		204,
		-1,
		-1,
		0,
		78,
		143,
		100,
		85,
		-1,
		98,
		117,
		123,
		127,
		132,
		140,
		168,
		166,
		-1,
		171,
		170,
		201,
		187,
		198,
		132,
		-1,
		-1,
		42,
		49,
		74,
		77,
		88,
		93,
		123,
		122,
		127,
		129,
		131,
		143,
		158,
		158,
		168,
		165,
		175,
		179,
		194,
		205,
		-1,
		-1,
		279,
		-1,
		-1,
		129,
		112,
		-1,
		75,
		69,
		83,
		100,
		91,
		116,
		131,
		135,
		143,
		146,
		134,
		153,
		150,
		174,
		170,
		162,
		187,
		191,
		197,
		215,
		216,
		-1,
		278,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		82,
		79,
		81,
		105,
		112,
		-1,
		138,
		136,
		160,
		154,
		159,
		155,
		140,
		158,
		156,
		171,
		173,
		169,
		171,
		208,
		199,
		220,
		217,
		248,
		254,
		248,
		257,
		-1,
		137,
		133,
		129,
		136,
		85,
		-1,
		-1,
		109,
		-1,
		120,
		133,
		150,
		140,
		143,
		155,
		163,
		162,
		146,
		164,
		159,
		162,
		181,
		177,
		186,
		196,
		195,
		213,
		226,
		241,
		245,
		251,
		-1,
		187,
		-1,
		129,
		113,
		115,
		91,
		119,
		-1,
		129,
		121,
		141,
		152,
		152,
		-1,
		168,
		165,
		178,
		162,
		147,
		164,
		166,
		170,
		180,
		184,
		199,
		190,
		208,
		215,
		223,
		227,
		247,
		259,
		147,
		137,
		-1,
		119,
		124,
		94,
		106,
		142,
		164,
		148,
		-1,
		163,
		-1,
		170,
		183,
		-1,
		168,
		164,
		153,
		169,
		177,
		184,
		187,
		181,
		178,
		196,
		199,
		216,
		220,
		236,
		-1,
		-1,
		132,
		136,
		157,
		100,
		127,
		151,
		188,
		157,
		166,
		168,
		-1,
		188,
		189,
		186,
		187,
		173,
		166,
		167,
		183,
		189,
		185,
		180,
		183,
		205,
		233,
		211,
		223,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		134,
		105,
		129,
		171,
		196,
		189,
		177,
		194,
		194,
		188,
		-1,
		204,
		183,
		180,
		171,
		179,
		193,
		190,
		204,
		184,
		186,
		202,
		214,
		205,
		225,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		108,
		142,
		160,
		227,
		213,
		218,
		193,
		186,
		180,
		198,
		200,
		195,
		189,
		181,
		170,
		186,
		194,
		196,
		186,
		195,
		196,
		220,
		227,
		233,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		133,
		140,
		172,
		218,
		215,
		-1,
		185,
		-1,
		174,
		182,
		181,
		187,
		186,
		183,
		177,
		186,
		200,
		200,
		191,
		206,
		225,
		225,
		217,
		242,
		245,
		-1,
		-1,
		-1,
		164,
		181,
		156,
		133,
		114,
		150,
		-1,
		185,
		186,
		-1,
		179,
		173,
		179,
		178,
		185,
		182,
		182,
		184,
		191,
		187,
		201,
		210,
		192,
		228,
		-1,
		225,
		219,
		247,
		241,
		229,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		121,
		173,
		-1,
		-1,
		170,
		163,
		-1,
		166,
		166,
		173,
		182,
		187,
		192,
		196,
		185,
		198,
		203,
		197,
		207,
		227,
		231,
		238,
		231,
		227,
		224,
		238,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		141,
		-1,
		178,
		170,
		161,
		155,
		161,
		179,
		177,
		197,
		189,
		203,
		203,
		199,
		207,
		192,
		195,
		200,
		204,
		222,
		237,
		229,
		223,
		222,
		234,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		156,
		-1,
		127,
		151,
		167,
		-1,
		195,
		174,
		197,
		175,
		189,
		185,
		223,
		224,
		202,
		207,
		206,
		216,
		217,
		206,
		212,
		211,
		231,
		233,
		217,
		218,
		227,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		130,
		143,
		154,
		-1,
		-1,
		239,
		-1,
		173,
		190,
		199,
		197,
		213,
		204,
		210,
		217,
		220,
		221,
		211,
		200,
		206,
		205,
		227,
		213,
		211,
		230,
		246,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		217,
		207,
		191,
		176,
		209,
		-1,
		221,
		205,
		210,
		-1,
		246,
		-1,
		219,
		221,
		213,
		202,
		199,
		210,
		208,
		219,
		236,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		187,
		-1,
		-1,
		204,
		198,
		198,
		182,
		185,
		237,
		217,
		211,
		210,
		241,
		239,
		227,
		211,
		204,
		201,
		202,
		215,
		235,
		226,
		238,
		-1,
		-1,
		-1,
		188,
		168,
		174,
		132,
		153,
		-1,
		-1,
		266,
		221,
		207,
		-1,
		191,
		254,
		242,
		232,
		222,
		256,
		255,
		230,
		223,
		209,
		211,
		209,
		211,
		216,
		237,
		238,
		251,
		-1,
		-1,
		165,
		172,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		213,
		229,
		221,
		192,
		243,
		-1,
		-1,
		234,
		232,
		242,
		226,
		213,
		233,
		236,
		226,
		210,
		225,
		237,
		245,
		250,
		-1,
		168,
		155,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		246,
		212,
		224,
		245,
		270,
		237,
		-1,
		242,
		237,
		217,
		231,
		238,
		228,
		223,
		217,
		220,
		238,
		255,
		-1,
		-1,
		182,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		203,
		217,
		238,
		244,
		256,
		-1,
		245,
		233,
		219,
		236,
		241,
		238,
		229,
		221,
		226,
		223,
		236,
		250,
		254,
		205,
		-1,
		188,
		-1,
		-1,
		-1,
		221,
		236,
		298,
		275,
		248,
		244,
		237,
		231,
		227,
		243,
		249,
		260,
		228,
		224,
		225,
		229,
		228,
		245,
		255,
		-1,
		-1,
		188,
		205,
		240,
		229,
		233,
		325,
		-1,
		-1,
		253,
		244,
		235,
		238,
		237,
		240,
		234,
		231,
		236,
		241,
		229,
		238,
		256,
		255,
		-1,
		-1,
		-1,
		208,
		-1,
		223,
		-1,
		-1,
		248,
		324,
		271,
		253,
		249,
		247,
		240,
		249,
		244,
		239,
		249,
		251,
		243,
		231,
		235,
		258,
		247,
		286,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		237,
		212,
		227,
		273,
		268,
		269,
		286,
		283,
		-1,
		253,
		278,
		250,
		257,
		248,
		255,
		255,
		247,
		225,
		232,
		248,
		247,
		242,
		278,
		269,
		275,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		243,
		229,
		259,
		249,
		255,
		-1,
		-1,
		302,
		299,
		275,
		258,
		256,
		249,
		244,
		254,
		234,
		221,
		225,
		229,
		235,
		240,
		245,
		251,
		266,
		281,
		-1,
		213,
		294,
		287,
		270,
		278,
		309,
		-1,
		246,
		255,
		236,
		241,
		249,
		-1,
		-1,
		275,
		271,
		276,
		265,
		262,
		264,
		259,
		250,
		235,
		241,
		228,
		227,
		245,
		249,
		258,
		265,
		255,
		268,
		272,
		-1,
		227,
		270,
		264,
		267,
		291,
		305,
		-1,
		259,
		-1,
		-1,
		244,
		262,
		270,
		266,
		270,
		323,
		279,
		274,
		258,
		256,
		247,
		238,
		245,
		236,
		236,
		239,
		254,
		259,
		251,
		265,
		265,
		266,
		-1,
		262,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		260,
		-1,
		296,
		-1,
		289,
		293,
		287,
		290,
		272,
		259,
		251,
		243,
		259,
		234,
		244,
		240,
		241,
		250,
		261,
		273,
		272,
		273,
		336,
		291,
		258,
		249,
		296,
		311,
		315,
		-1,
		272,
		311,
		298,
		-1,
		269,
		-1,
		-1,
		-1,
		303,
		300,
		292,
		292,
		271,
		271,
		245,
		249,
		239,
		246,
		256,
		258,
		250,
		254,
		267,
		278,
		281,
		332,
		330,
		335,
		280,
		263,
		281,
		290,
		311,
		287,
		278,
		305,
		305,
		294,
		289,
		276,
		-1,
		-1,
		326,
		310,
		-1,
		-1,
		278,
		266,
		249,
		250,
		246,
		249,
		264,
		267,
		257,
		255,
		249,
		281,
		-1,
		332,
		331,
		320,
		317,
		293,
		284,
		271,
		282,
		-1,
		-1,
		290,
		306,
		319,
		323,
		336,
		361,
		-1,
		279,
		-1,
		-1,
		323,
		-1,
		-1,
		308,
		271,
		260,
		251,
		257,
		254,
		265,
		275,
		263,
		264,
		254,
		264,
		277,
		316,
		313,
		301,
		299,
		322,
		279,
		275,
		-1,
		305,
		293,
		299,
		306,
		323,
		350,
		-1,
		-1,
		295,
		286,
		-1,
		-1,
		306,
		304,
		293,
		-1,
		283,
		256,
		261,
		281,
		283,
		272,
		266,
		260,
		267,
		266,
		274,
		282,
		325,
		339,
		328,
		324,
		323,
		331,
		280,
		297,
		304,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		345,
		-1,
		330,
		305,
		-1,
		-1,
		301,
		294,
		282,
		270,
		260,
		270,
		274,
		278,
		270,
		263,
		258,
		269,
		261,
		265,
		282,
		-1,
		359,
		-1,
		311,
		304,
		319,
		334,
		342,
		-1,
		-1,
		-1,
		347,
		333,
		326,
		314,
		312,
		-1,
		335,
		319,
		300,
		-1,
		270,
		283,
		314,
		282,
		287,
		282,
		264,
		275,
		264,
		267,
		281,
		276,
		-1,
		-1,
		317,
		320,
		-1,
		-1,
		342,
		353,
		-1,
		338,
		327,
		312,
		304,
		-1,
		-1,
		307,
		303,
		-1,
		-1,
		271,
		296,
		285,
		293,
		288,
		268,
		274,
		277,
		266,
		270,
		282,
		-1,
		-1,
		324,
		325,
		330,
		-1,
		336,
		-1,
		354,
		-1,
		307,
		323,
		315,
		-1,
		-1,
		-1,
		309,
		272,
		293,
		303,
		297,
		295,
		286,
		272,
		279,
		277,
		273,
		284,
		-1,
		-1,
		-1,
		354,
		328,
		361,
		352,
		335,
		315,
		307,
		326,
		-1,
		296,
		-1,
		271,
		273,
		299,
		302,
		308,
		302,
		275,
		290,
		280,
		271,
		280,
		360,
		-1,
		330,
		363,
		327,
		321,
		297,
		301,
		317,
		-1,
		293,
		275,
		-1,
		303,
		293,
		324,
		309,
		290,
		277,
		284,
		284,
		277,
		-1,
		-1,
		-1,
		332,
		331,
		323,
		317,
		317,
		302,
		293,
		-1,
		305,
		287,
		266,
		283,
		283,
		274,
		282,
		314,
		310,
		297,
		297,
		289,
		-1,
		431,
		-1,
		-1,
		355,
		-1,
		-1,
		-1,
		326,
		321,
		294,
		282,
		288,
		284,
		270,
		276,
		278,
		286,
		284,
		281,
		293,
		289,
		309,
		290,
		325,
		-1,
		428,
		-1,
		362,
		-1,
		-1,
		344,
		324,
		316,
		305,
		294,
		292,
		283,
		274,
		296,
		312,
		296,
		294,
		297,
		298,
		-1,
		417,
		416,
		-1,
		363,
		355,
		341,
		-1,
		334,
		-1,
		340,
		301,
		-1,
		303,
		283,
		-1,
		305,
		301,
		-1,
		-1,
		404,
		379,
		-1,
		-1,
		-1,
		364,
		344,
		335,
		319,
		-1,
		294,
		294,
		-1,
		-1,
		-1,
		389,
		388,
		-1,
		357,
		360,
		-1,
		350,
		341,
		349,
		296,
		300,
		-1,
		-1,
		-1,
		398,
		379,
		373,
		372,
		370,
		365,
		362,
		348,
		332,
		310,
		299,
		320,
		-1,
		-1,
		-1,
		370,
		362,
		355,
		-1,
		-1,
		357,
		340,
		321,
		319,
		-1,
		-1,
		-1,
		392,
		373,
		-1,
		-1,
		347,
		-1,
		-1,
		353,
		318,
		-1,
		-1,
		-1,
		-1,
		-1,
		409,
		381,
		-1,
		-1,
		-1,
		343,
		339,
		340,
		-1,
		-1,
		-1,
		-1,
		403,
		404,
		427,
		391,
		-1,
		-1,
		-1,
		335,
		329,
		-1,
		-1,
		406,
		404,
		-1,
		-1,
		-1,
		363,
		347,
		-1,
		333,
		-1,
		-1,
		-1,
		354,
		-1,
		-1,
		366,
		-1,
		-1,
		-1,
		368,
		-1,
		368,
		343,
		350,
		-1,
		-1,
		-1,
		-1,
		381,
		373,
		381,
		-1,
		353,
		355,
		-1,
		403,
		-1,
		-1,
		396,
		387,
		-1,
		-1,
		358,
		365,
		387,
		390,
		426,
		-1,
		377
	],
	[
		-1,
		138,
		127,
		138,
		146,
		119,
		126,
		-1,
		147,
		149,
		115,
		109,
		148,
		119,
		125,
		136,
		-1,
		-1,
		-1,
		138,
		137,
		107,
		105,
		114,
		119,
		126,
		-1,
		149,
		-1,
		159,
		138,
		149,
		154,
		100,
		97,
		117,
		136,
		142,
		134,
		174,
		130,
		101,
		95,
		113,
		118,
		136,
		128,
		-1,
		101,
		91,
		113,
		117,
		129,
		112,
		-1,
		-1,
		95,
		96,
		102,
		114,
		119,
		124,
		-1,
		150,
		169,
		-1,
		-1,
		85,
		98,
		94,
		97,
		105,
		121,
		142,
		159,
		164,
		-1,
		-1,
		86,
		90,
		103,
		104,
		102,
		129,
		148,
		159,
		173,
		172,
		-1,
		74,
		92,
		101,
		110,
		116,
		105,
		109,
		127,
		158,
		164,
		167,
		-1,
		66,
		68,
		97,
		103,
		115,
		121,
		108,
		114,
		133,
		146,
		165,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		49,
		63,
		71,
		97,
		96,
		92,
		110,
		132,
		111,
		117,
		121,
		138,
		154,
		155,
		165,
		-1,
		-1,
		76,
		0,
		103,
		60,
		45,
		-1,
		59,
		78,
		84,
		88,
		93,
		101,
		129,
		127,
		-1,
		132,
		131,
		162,
		148,
		159,
		92,
		-1,
		-1,
		34,
		26,
		34,
		37,
		49,
		54,
		84,
		83,
		88,
		90,
		92,
		104,
		119,
		119,
		129,
		126,
		136,
		140,
		155,
		166,
		-1,
		-1,
		240,
		-1,
		-1,
		89,
		72,
		-1,
		35,
		29,
		44,
		61,
		52,
		77,
		92,
		96,
		104,
		107,
		95,
		114,
		111,
		135,
		131,
		123,
		148,
		152,
		158,
		176,
		177,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		42,
		39,
		41,
		65,
		73,
		-1,
		99,
		97,
		121,
		115,
		120,
		116,
		101,
		119,
		117,
		132,
		134,
		130,
		132,
		169,
		160,
		181,
		178,
		209,
		215,
		209,
		218,
		-1,
		97,
		93,
		89,
		96,
		45,
		-1,
		-1,
		69,
		-1,
		81,
		94,
		111,
		101,
		104,
		116,
		124,
		123,
		107,
		125,
		120,
		123,
		142,
		138,
		147,
		157,
		156,
		174,
		187,
		202,
		206,
		212,
		-1,
		147,
		-1,
		89,
		73,
		75,
		51,
		79,
		-1,
		89,
		82,
		102,
		113,
		113,
		-1,
		129,
		126,
		139,
		123,
		108,
		125,
		127,
		131,
		141,
		145,
		160,
		151,
		169,
		176,
		184,
		188,
		208,
		220,
		107,
		97,
		-1,
		79,
		84,
		54,
		66,
		102,
		125,
		109,
		-1,
		124,
		-1,
		131,
		144,
		-1,
		129,
		125,
		114,
		130,
		138,
		145,
		148,
		142,
		139,
		157,
		160,
		177,
		181,
		197,
		-1,
		-1,
		92,
		96,
		117,
		60,
		87,
		111,
		148,
		118,
		127,
		129,
		-1,
		149,
		150,
		147,
		148,
		134,
		127,
		128,
		144,
		150,
		146,
		141,
		144,
		166,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		94,
		65,
		89,
		131,
		157,
		150,
		138,
		154,
		154,
		148,
		-1,
		165,
		144,
		141,
		132,
		140,
		154,
		151,
		165,
		145,
		147,
		163,
		175,
		166,
		186,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		68,
		102,
		120,
		187,
		173,
		178,
		153,
		146,
		140,
		159,
		161,
		156,
		150,
		142,
		131,
		147,
		155,
		157,
		147,
		156,
		157,
		181,
		188,
		194,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		93,
		100,
		132,
		178,
		175,
		-1,
		145,
		-1,
		134,
		142,
		141,
		147,
		147,
		144,
		138,
		147,
		161,
		161,
		152,
		167,
		186,
		186,
		178,
		203,
		206,
		-1,
		-1,
		-1,
		124,
		141,
		116,
		93,
		74,
		110,
		-1,
		145,
		146,
		-1,
		139,
		133,
		139,
		138,
		145,
		142,
		142,
		145,
		152,
		148,
		162,
		171,
		153,
		189,
		-1,
		186,
		180,
		208,
		202,
		190,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		81,
		133,
		-1,
		-1,
		130,
		123,
		-1,
		126,
		126,
		133,
		142,
		147,
		152,
		157,
		146,
		159,
		164,
		158,
		168,
		188,
		192,
		199,
		192,
		188,
		185,
		199,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		101,
		-1,
		138,
		130,
		121,
		115,
		121,
		139,
		137,
		157,
		149,
		163,
		163,
		160,
		168,
		153,
		156,
		161,
		165,
		183,
		198,
		190,
		184,
		183,
		195,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		116,
		-1,
		87,
		111,
		127,
		-1,
		155,
		134,
		157,
		135,
		149,
		145,
		183,
		184,
		162,
		167,
		167,
		177,
		178,
		167,
		173,
		172,
		192,
		194,
		178,
		179,
		188,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		90,
		103,
		114,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		159,
		157,
		173,
		164,
		170,
		178,
		181,
		182,
		172,
		161,
		167,
		166,
		188,
		174,
		172,
		191,
		207,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		181,
		165,
		170,
		-1,
		207,
		-1,
		180,
		182,
		174,
		163,
		160,
		171,
		169,
		180,
		197,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		147,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		197,
		177,
		171,
		170,
		202,
		200,
		188,
		172,
		165,
		162,
		163,
		176,
		196,
		187,
		199,
		-1,
		-1,
		-1,
		148,
		128,
		134,
		92,
		113,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		214,
		202,
		192,
		182,
		216,
		216,
		191,
		184,
		170,
		172,
		170,
		172,
		177,
		198,
		199,
		212,
		-1,
		-1,
		125,
		132,
		120,
		106,
		125,
		-1,
		-1,
		-1,
		173,
		189,
		181,
		152,
		203,
		-1,
		-1,
		194,
		192,
		202,
		187,
		174,
		194,
		197,
		187,
		171,
		186,
		198,
		206,
		211,
		-1,
		128,
		115,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		184,
		205,
		230,
		197,
		-1,
		202,
		198,
		178,
		192,
		199,
		189,
		184,
		178,
		181,
		199,
		216,
		-1,
		-1,
		142,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		163,
		177,
		198,
		204,
		216,
		-1,
		206,
		194,
		180,
		197,
		202,
		199,
		190,
		182,
		187,
		184,
		197,
		211,
		215,
		165,
		-1,
		148,
		-1,
		-1,
		-1,
		181,
		196,
		258,
		235,
		208,
		205,
		198,
		192,
		188,
		204,
		210,
		221,
		189,
		185,
		186,
		190,
		189,
		206,
		216,
		-1,
		-1,
		148,
		165,
		200,
		189,
		193,
		285,
		-1,
		-1,
		214,
		205,
		196,
		199,
		198,
		201,
		195,
		192,
		197,
		202,
		190,
		199,
		217,
		216,
		-1,
		-1,
		-1,
		168,
		-1,
		183,
		-1,
		-1,
		208,
		285,
		232,
		214,
		210,
		208,
		201,
		210,
		205,
		200,
		210,
		212,
		204,
		192,
		196,
		219,
		208,
		247,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		197,
		172,
		187,
		233,
		228,
		229,
		247,
		244,
		-1,
		214,
		239,
		211,
		218,
		209,
		216,
		216,
		208,
		186,
		193,
		209,
		208,
		203,
		239,
		230,
		236,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		203,
		189,
		219,
		209,
		215,
		-1,
		-1,
		262,
		259,
		236,
		219,
		217,
		210,
		205,
		215,
		195,
		182,
		186,
		190,
		196,
		201,
		206,
		212,
		227,
		242,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		206,
		215,
		196,
		201,
		209,
		-1,
		-1,
		235,
		231,
		236,
		226,
		223,
		225,
		220,
		211,
		196,
		202,
		189,
		188,
		206,
		210,
		219,
		226,
		216,
		229,
		233,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		219,
		-1,
		-1,
		204,
		222,
		230,
		226,
		230,
		283,
		240,
		235,
		219,
		217,
		208,
		199,
		206,
		197,
		197,
		200,
		215,
		220,
		212,
		226,
		226,
		227,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		220,
		-1,
		256,
		-1,
		249,
		253,
		248,
		251,
		233,
		220,
		212,
		204,
		220,
		195,
		205,
		201,
		202,
		211,
		222,
		234,
		233,
		234,
		296,
		251,
		218,
		209,
		256,
		271,
		275,
		-1,
		232,
		271,
		258,
		-1,
		229,
		-1,
		-1,
		-1,
		263,
		261,
		253,
		253,
		232,
		232,
		206,
		210,
		200,
		207,
		217,
		219,
		211,
		215,
		228,
		239,
		242,
		292,
		290,
		295,
		240,
		223,
		241,
		250,
		271,
		247,
		238,
		265,
		265,
		254,
		249,
		236,
		-1,
		-1,
		286,
		271,
		-1,
		-1,
		239,
		227,
		210,
		211,
		207,
		210,
		225,
		228,
		218,
		216,
		210,
		242,
		-1,
		292,
		291,
		280,
		277,
		253,
		244,
		231,
		242,
		-1,
		-1,
		250,
		266,
		279,
		283,
		296,
		321,
		-1,
		239,
		-1,
		-1,
		284,
		-1,
		-1,
		269,
		232,
		221,
		212,
		218,
		215,
		226,
		236,
		224,
		225,
		215,
		225,
		238,
		276,
		273,
		261,
		259,
		282,
		239,
		235,
		-1,
		265,
		253,
		259,
		266,
		283,
		310,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		267,
		265,
		254,
		-1,
		244,
		217,
		222,
		242,
		244,
		233,
		227,
		221,
		228,
		227,
		235,
		243,
		285,
		299,
		288,
		284,
		283,
		291,
		240,
		257,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		-1,
		290,
		265,
		-1,
		-1,
		262,
		255,
		243,
		231,
		221,
		231,
		235,
		239,
		231,
		224,
		219,
		230,
		222,
		226,
		243,
		-1,
		319,
		-1,
		271,
		264,
		279,
		294,
		302,
		-1,
		-1,
		-1,
		307,
		293,
		286,
		274,
		272,
		-1,
		296,
		280,
		261,
		-1,
		231,
		244,
		275,
		243,
		248,
		243,
		225,
		236,
		225,
		228,
		242,
		237,
		-1,
		-1,
		277,
		280,
		-1,
		-1,
		302,
		314,
		-1,
		298,
		287,
		272,
		264,
		-1,
		-1,
		268,
		264,
		-1,
		-1,
		232,
		257,
		246,
		254,
		249,
		229,
		235,
		238,
		227,
		231,
		243,
		-1,
		-1,
		284,
		285,
		290,
		-1,
		297,
		-1,
		315,
		-1,
		267,
		283,
		276,
		-1,
		-1,
		-1,
		270,
		233,
		254,
		264,
		258,
		256,
		247,
		233,
		240,
		238,
		234,
		245,
		-1,
		-1,
		-1,
		315,
		289,
		322,
		313,
		296,
		276,
		268,
		287,
		-1,
		257,
		-1,
		232,
		234,
		260,
		263,
		269,
		263,
		236,
		251,
		241,
		232,
		241,
		321,
		-1,
		291,
		324,
		288,
		282,
		258,
		262,
		278,
		-1,
		254,
		236,
		-1,
		264,
		254,
		285,
		270,
		251,
		238,
		245,
		245,
		238,
		-1,
		-1,
		-1,
		293,
		292,
		284,
		278,
		278,
		263,
		254,
		-1,
		266,
		248,
		227,
		244,
		244,
		235,
		243,
		275,
		271,
		258,
		258,
		250,
		-1,
		391,
		-1,
		-1,
		316,
		-1,
		-1,
		-1,
		287,
		282,
		255,
		243,
		249,
		245,
		231,
		237,
		239,
		247,
		245,
		242,
		254,
		250,
		270,
		251,
		286,
		-1,
		389,
		-1,
		323,
		-1,
		-1,
		305,
		285,
		277,
		266,
		255,
		253,
		244,
		235,
		257,
		273,
		257,
		255,
		258,
		259,
		-1,
		378,
		377,
		-1,
		324,
		316,
		302,
		-1,
		295,
		-1,
		301,
		262,
		-1,
		264,
		244,
		-1,
		266,
		262,
		-1,
		-1,
		365,
		340,
		-1,
		-1,
		-1,
		325,
		305,
		296,
		280,
		-1,
		255,
		255,
		-1,
		-1,
		-1,
		350,
		349,
		-1,
		318,
		321,
		-1,
		311,
		302,
		310,
		257,
		261,
		-1,
		-1,
		-1,
		359,
		340,
		334,
		333,
		331,
		326,
		323,
		309,
		293,
		271,
		260,
		281,
		-1,
		-1,
		-1,
		331,
		323,
		316,
		-1,
		-1,
		318,
		301,
		282,
		280,
		-1,
		-1,
		-1,
		353,
		334,
		-1,
		-1,
		308,
		-1,
		-1,
		314,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		370,
		342,
		-1,
		-1,
		-1,
		304,
		300,
		301,
		-1,
		-1,
		-1,
		-1,
		364,
		365,
		388,
		352,
		-1,
		-1,
		-1,
		296,
		290,
		-1,
		-1,
		367,
		365,
		-1,
		-1,
		-1,
		324,
		308,
		-1,
		294,
		-1,
		-1,
		-1,
		315,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		329,
		-1,
		329,
		304,
		311,
		-1,
		-1,
		-1,
		-1,
		342,
		334,
		342,
		-1,
		314,
		316,
		-1,
		364,
		-1,
		-1,
		357,
		348,
		-1,
		-1,
		319,
		326,
		348,
		351,
		387,
		-1,
		338
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		183,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		176,
		168,
		208,
		164,
		135,
		129,
		147,
		152,
		170,
		162,
		-1,
		135,
		125,
		147,
		151,
		163,
		146,
		-1,
		-1,
		129,
		130,
		136,
		148,
		153,
		158,
		-1,
		184,
		203,
		-1,
		-1,
		119,
		132,
		128,
		131,
		139,
		155,
		176,
		193,
		198,
		-1,
		-1,
		120,
		124,
		137,
		138,
		136,
		163,
		182,
		193,
		207,
		206,
		-1,
		108,
		126,
		135,
		144,
		150,
		139,
		143,
		161,
		192,
		198,
		201,
		-1,
		100,
		102,
		131,
		137,
		149,
		155,
		142,
		148,
		167,
		180,
		199,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		97,
		105,
		131,
		130,
		126,
		144,
		166,
		145,
		151,
		155,
		172,
		188,
		189,
		199,
		-1,
		-1,
		143,
		116,
		0,
		89,
		80,
		-1,
		93,
		112,
		118,
		122,
		127,
		135,
		163,
		161,
		-1,
		166,
		165,
		196,
		182,
		193,
		140,
		-1,
		-1,
		101,
		93,
		69,
		72,
		83,
		88,
		118,
		117,
		122,
		124,
		126,
		138,
		153,
		153,
		163,
		160,
		170,
		174,
		189,
		200,
		-1,
		-1,
		274,
		-1,
		-1,
		137,
		120,
		-1,
		83,
		77,
		78,
		95,
		86,
		111,
		126,
		130,
		138,
		141,
		129,
		148,
		145,
		169,
		165,
		157,
		182,
		186,
		192,
		210,
		211,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		90,
		87,
		84,
		108,
		107,
		-1,
		133,
		131,
		155,
		149,
		154,
		150,
		135,
		153,
		151,
		166,
		168,
		164,
		166,
		203,
		194,
		215,
		212,
		243,
		249,
		243,
		252,
		-1,
		145,
		141,
		137,
		144,
		93,
		-1,
		-1,
		112,
		-1,
		115,
		128,
		145,
		135,
		138,
		150,
		158,
		157,
		141,
		159,
		154,
		157,
		176,
		172,
		181,
		191,
		190,
		208,
		221,
		236,
		240,
		246,
		-1,
		195,
		-1,
		137,
		121,
		123,
		99,
		127,
		-1,
		132,
		116,
		136,
		147,
		147,
		-1,
		163,
		160,
		173,
		157,
		142,
		159,
		161,
		165,
		175,
		179,
		194,
		185,
		203,
		210,
		218,
		222,
		242,
		254,
		155,
		145,
		-1,
		127,
		132,
		102,
		114,
		150,
		159,
		143,
		-1,
		158,
		-1,
		165,
		178,
		-1,
		163,
		159,
		148,
		164,
		172,
		179,
		182,
		176,
		173,
		191,
		194,
		211,
		215,
		231,
		-1,
		-1,
		140,
		144,
		165,
		108,
		135,
		159,
		196,
		152,
		161,
		163,
		-1,
		183,
		184,
		181,
		182,
		168,
		161,
		162,
		178,
		184,
		180,
		175,
		178,
		200,
		228,
		206,
		218,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		142,
		113,
		137,
		179,
		191,
		184,
		172,
		192,
		192,
		196,
		-1,
		199,
		178,
		175,
		166,
		174,
		188,
		185,
		199,
		179,
		181,
		197,
		209,
		200,
		220,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		116,
		150,
		168,
		225,
		211,
		216,
		191,
		194,
		188,
		193,
		195,
		190,
		184,
		176,
		165,
		181,
		189,
		191,
		181,
		190,
		191,
		215,
		222,
		228,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		141,
		148,
		180,
		216,
		223,
		-1,
		193,
		-1,
		182,
		190,
		189,
		184,
		181,
		178,
		172,
		181,
		195,
		195,
		186,
		201,
		220,
		220,
		212,
		237,
		240,
		-1,
		-1,
		-1,
		172,
		189,
		164,
		141,
		122,
		158,
		-1,
		193,
		194,
		-1,
		187,
		181,
		187,
		186,
		187,
		182,
		186,
		179,
		186,
		182,
		196,
		205,
		187,
		223,
		-1,
		220,
		214,
		242,
		236,
		224,
		-1,
		-1,
		-1,
		187,
		166,
		159,
		179,
		129,
		181,
		-1,
		-1,
		178,
		171,
		-1,
		174,
		174,
		181,
		189,
		183,
		187,
		191,
		180,
		193,
		198,
		192,
		202,
		222,
		226,
		233,
		226,
		222,
		219,
		233,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		149,
		-1,
		186,
		178,
		169,
		163,
		169,
		187,
		185,
		205,
		195,
		198,
		198,
		194,
		202,
		187,
		190,
		195,
		199,
		217,
		232,
		224,
		218,
		217,
		229,
		-1,
		235,
		221,
		192,
		-1,
		-1,
		164,
		-1,
		135,
		159,
		175,
		-1,
		203,
		182,
		205,
		183,
		197,
		193,
		218,
		219,
		197,
		202,
		201,
		211,
		212,
		201,
		207,
		206,
		226,
		228,
		212,
		213,
		222,
		-1,
		241,
		228,
		186,
		182,
		171,
		191,
		138,
		151,
		162,
		-1,
		-1,
		247,
		-1,
		181,
		198,
		207,
		205,
		208,
		199,
		205,
		212,
		215,
		216,
		206,
		195,
		201,
		200,
		222,
		208,
		206,
		225,
		241,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		157,
		144,
		138,
		-1,
		179,
		-1,
		225,
		215,
		199,
		184,
		217,
		-1,
		216,
		200,
		205,
		-1,
		241,
		-1,
		214,
		216,
		208,
		197,
		194,
		205,
		203,
		214,
		231,
		-1,
		191,
		176,
		169,
		159,
		173,
		144,
		-1,
		195,
		-1,
		-1,
		212,
		206,
		206,
		190,
		193,
		232,
		212,
		206,
		205,
		236,
		234,
		222,
		206,
		199,
		196,
		197,
		210,
		230,
		221,
		233,
		-1,
		-1,
		-1,
		196,
		176,
		182,
		140,
		161,
		-1,
		-1,
		274,
		229,
		215,
		-1,
		199,
		249,
		237,
		227,
		217,
		251,
		250,
		225,
		218,
		204,
		206,
		204,
		206,
		211,
		232,
		233,
		246,
		-1,
		-1,
		173,
		180,
		168,
		154,
		173,
		-1,
		-1,
		-1,
		221,
		237,
		229,
		200,
		238,
		-1,
		-1,
		229,
		227,
		237,
		221,
		208,
		228,
		231,
		221,
		205,
		220,
		232,
		240,
		245,
		-1,
		176,
		163,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		-1,
		-1,
		254,
		220,
		232,
		253,
		266,
		232,
		-1,
		237,
		232,
		212,
		226,
		233,
		223,
		218,
		212,
		215,
		233,
		250,
		-1,
		-1,
		190,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		211,
		225,
		246,
		248,
		252,
		-1,
		240,
		228,
		214,
		231,
		236,
		233,
		224,
		216,
		221,
		218,
		231,
		245,
		249,
		213,
		-1,
		196,
		-1,
		-1,
		-1,
		229,
		244,
		294,
		271,
		244,
		239,
		232,
		226,
		222,
		238,
		244,
		255,
		223,
		219,
		220,
		224,
		223,
		240,
		250,
		-1,
		-1,
		196,
		213,
		248,
		237,
		241,
		321,
		-1,
		-1,
		248,
		239,
		230,
		233,
		232,
		235,
		229,
		226,
		231,
		236,
		224,
		233,
		251,
		250,
		-1,
		-1,
		-1,
		216,
		-1,
		231,
		-1,
		-1,
		256,
		319,
		266,
		248,
		244,
		242,
		235,
		244,
		239,
		234,
		244,
		246,
		238,
		226,
		230,
		253,
		242,
		281,
		-1,
		-1,
		333,
		-1,
		-1,
		-1,
		245,
		220,
		235,
		281,
		276,
		277,
		281,
		278,
		-1,
		248,
		273,
		245,
		252,
		243,
		250,
		250,
		242,
		220,
		227,
		243,
		242,
		237,
		273,
		264,
		270,
		-1,
		-1,
		326,
		315,
		304,
		310,
		-1,
		251,
		237,
		267,
		257,
		263,
		-1,
		-1,
		297,
		294,
		270,
		253,
		251,
		244,
		239,
		249,
		229,
		216,
		220,
		224,
		230,
		235,
		240,
		246,
		261,
		276,
		-1,
		221,
		302,
		295,
		278,
		286,
		317,
		-1,
		254,
		263,
		244,
		249,
		257,
		-1,
		-1,
		270,
		267,
		272,
		260,
		257,
		259,
		254,
		245,
		230,
		236,
		223,
		222,
		240,
		244,
		253,
		260,
		250,
		263,
		267,
		-1,
		235,
		278,
		272,
		275,
		299,
		313,
		-1,
		267,
		-1,
		-1,
		252,
		270,
		278,
		274,
		269,
		319,
		274,
		269,
		253,
		251,
		242,
		233,
		240,
		231,
		231,
		234,
		249,
		254,
		246,
		260,
		260,
		261,
		-1,
		270,
		258,
		266,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		268,
		-1,
		304,
		-1,
		287,
		291,
		282,
		285,
		267,
		254,
		246,
		238,
		254,
		229,
		239,
		235,
		236,
		245,
		256,
		268,
		267,
		268,
		344,
		299,
		266,
		257,
		304,
		319,
		323,
		-1,
		280,
		319,
		306,
		-1,
		277,
		-1,
		-1,
		-1,
		301,
		295,
		287,
		287,
		266,
		266,
		240,
		244,
		234,
		241,
		251,
		253,
		245,
		249,
		262,
		273,
		276,
		340,
		338,
		343,
		288,
		271,
		289,
		298,
		319,
		295,
		286,
		313,
		313,
		302,
		297,
		284,
		-1,
		-1,
		324,
		305,
		-1,
		-1,
		273,
		261,
		244,
		245,
		241,
		244,
		259,
		262,
		252,
		250,
		244,
		276,
		-1,
		340,
		339,
		328,
		325,
		301,
		292,
		279,
		290,
		-1,
		-1,
		298,
		314,
		327,
		331,
		344,
		369,
		-1,
		287,
		-1,
		-1,
		318,
		-1,
		-1,
		303,
		266,
		255,
		246,
		252,
		249,
		260,
		270,
		258,
		259,
		249,
		259,
		272,
		324,
		321,
		309,
		307,
		330,
		287,
		283,
		-1,
		313,
		301,
		307,
		314,
		331,
		358,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		301,
		299,
		288,
		-1,
		278,
		251,
		256,
		276,
		278,
		267,
		261,
		255,
		262,
		261,
		269,
		277,
		333,
		347,
		336,
		332,
		331,
		339,
		288,
		305,
		312,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		353,
		-1,
		338,
		313,
		-1,
		-1,
		296,
		289,
		277,
		265,
		255,
		265,
		269,
		273,
		265,
		258,
		253,
		264,
		256,
		260,
		277,
		-1,
		367,
		-1,
		319,
		312,
		327,
		342,
		350,
		-1,
		-1,
		-1,
		355,
		341,
		334,
		322,
		320,
		-1,
		330,
		314,
		295,
		-1,
		265,
		278,
		309,
		277,
		282,
		277,
		259,
		270,
		259,
		262,
		276,
		271,
		-1,
		-1,
		325,
		328,
		-1,
		-1,
		346,
		348,
		-1,
		346,
		335,
		320,
		312,
		-1,
		-1,
		302,
		298,
		-1,
		-1,
		266,
		291,
		280,
		288,
		283,
		263,
		269,
		272,
		261,
		265,
		277,
		-1,
		-1,
		332,
		333,
		338,
		-1,
		331,
		-1,
		349,
		-1,
		315,
		322,
		310,
		-1,
		-1,
		-1,
		304,
		267,
		288,
		298,
		292,
		290,
		281,
		267,
		274,
		272,
		268,
		279,
		-1,
		-1,
		-1,
		349,
		323,
		356,
		347,
		330,
		310,
		302,
		321,
		-1,
		291,
		-1,
		266,
		268,
		294,
		297,
		303,
		297,
		270,
		285,
		275,
		266,
		275,
		355,
		-1,
		325,
		358,
		322,
		316,
		292,
		296,
		312,
		-1,
		288,
		270,
		-1,
		298,
		288,
		319,
		304,
		285,
		272,
		279,
		279,
		272,
		-1,
		-1,
		-1,
		327,
		326,
		318,
		312,
		312,
		297,
		288,
		-1,
		300,
		282,
		261,
		278,
		278,
		269,
		277,
		309,
		305,
		292,
		292,
		284,
		-1,
		428,
		-1,
		-1,
		350,
		-1,
		-1,
		-1,
		321,
		316,
		289,
		277,
		283,
		279,
		265,
		271,
		273,
		281,
		279,
		276,
		288,
		284,
		304,
		285,
		320,
		-1,
		423,
		-1,
		357,
		-1,
		-1,
		339,
		319,
		311,
		300,
		289,
		287,
		278,
		269,
		291,
		307,
		291,
		289,
		292,
		293,
		-1,
		412,
		411,
		-1,
		358,
		350,
		336,
		-1,
		329,
		-1,
		335,
		296,
		-1,
		298,
		278,
		-1,
		300,
		296,
		-1,
		-1,
		399,
		374,
		-1,
		-1,
		-1,
		359,
		339,
		330,
		314,
		-1,
		289,
		289,
		-1,
		-1,
		-1,
		384,
		383,
		-1,
		352,
		355,
		-1,
		345,
		336,
		344,
		291,
		295,
		-1,
		-1,
		-1,
		393,
		374,
		368,
		367,
		365,
		360,
		357,
		343,
		327,
		305,
		294,
		315,
		-1,
		-1,
		-1,
		365,
		357,
		350,
		-1,
		-1,
		352,
		335,
		316,
		314,
		-1,
		-1,
		-1,
		387,
		368,
		-1,
		-1,
		342,
		-1,
		-1,
		348,
		313,
		-1,
		-1,
		-1,
		-1,
		-1,
		404,
		376,
		-1,
		-1,
		-1,
		338,
		334,
		335,
		-1,
		-1,
		-1,
		-1,
		398,
		399,
		422,
		386,
		-1,
		-1,
		-1,
		330,
		324,
		-1,
		-1,
		401,
		399,
		-1,
		-1,
		-1,
		358,
		342,
		-1,
		328,
		-1,
		-1,
		-1,
		349,
		-1,
		-1,
		361,
		-1,
		-1,
		-1,
		363,
		-1,
		363,
		338,
		345,
		-1,
		-1,
		-1,
		-1,
		376,
		368,
		376,
		-1,
		348,
		350,
		-1,
		398,
		-1,
		-1,
		391,
		382,
		-1,
		-1,
		353,
		360,
		382,
		385,
		421,
		-1,
		372
	],
	[
		-1,
		130,
		119,
		130,
		138,
		111,
		118,
		-1,
		139,
		141,
		107,
		101,
		140,
		111,
		117,
		128,
		-1,
		-1,
		-1,
		130,
		129,
		99,
		97,
		106,
		111,
		118,
		-1,
		141,
		-1,
		151,
		130,
		141,
		146,
		92,
		89,
		109,
		128,
		134,
		126,
		166,
		122,
		93,
		87,
		105,
		110,
		128,
		120,
		-1,
		93,
		83,
		105,
		109,
		121,
		104,
		-1,
		-1,
		87,
		88,
		94,
		106,
		111,
		116,
		-1,
		142,
		161,
		-1,
		-1,
		77,
		90,
		86,
		89,
		97,
		113,
		134,
		151,
		156,
		-1,
		-1,
		78,
		82,
		95,
		96,
		94,
		121,
		140,
		151,
		165,
		164,
		-1,
		66,
		84,
		93,
		102,
		108,
		97,
		101,
		119,
		150,
		156,
		159,
		-1,
		58,
		60,
		89,
		95,
		107,
		113,
		100,
		106,
		125,
		138,
		157,
		148,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		35,
		55,
		63,
		89,
		88,
		84,
		102,
		124,
		103,
		109,
		113,
		130,
		146,
		147,
		157,
		-1,
		-1,
		99,
		72,
		88,
		0,
		31,
		-1,
		51,
		70,
		76,
		80,
		85,
		93,
		121,
		119,
		-1,
		124,
		123,
		154,
		140,
		151,
		96,
		-1,
		-1,
		57,
		49,
		26,
		23,
		41,
		46,
		76,
		75,
		80,
		82,
		84,
		96,
		111,
		111,
		121,
		118,
		128,
		132,
		147,
		158,
		-1,
		-1,
		232,
		-1,
		-1,
		93,
		76,
		-1,
		39,
		33,
		36,
		51,
		44,
		69,
		84,
		88,
		96,
		99,
		87,
		106,
		103,
		127,
		123,
		115,
		140,
		144,
		150,
		168,
		169,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		46,
		43,
		42,
		66,
		65,
		-1,
		91,
		89,
		113,
		107,
		112,
		108,
		93,
		111,
		109,
		124,
		126,
		122,
		124,
		161,
		152,
		173,
		170,
		201,
		207,
		201,
		210,
		-1,
		101,
		97,
		93,
		100,
		49,
		-1,
		-1,
		70,
		-1,
		73,
		86,
		103,
		93,
		96,
		108,
		116,
		115,
		99,
		117,
		112,
		115,
		134,
		130,
		139,
		149,
		148,
		166,
		179,
		194,
		198,
		204,
		-1,
		151,
		-1,
		93,
		77,
		79,
		55,
		83,
		-1,
		90,
		74,
		94,
		105,
		105,
		-1,
		121,
		118,
		131,
		115,
		100,
		117,
		119,
		123,
		133,
		137,
		152,
		143,
		161,
		168,
		176,
		180,
		200,
		212,
		111,
		101,
		-1,
		83,
		88,
		58,
		70,
		106,
		117,
		101,
		-1,
		116,
		-1,
		123,
		136,
		-1,
		121,
		117,
		106,
		122,
		130,
		137,
		140,
		134,
		131,
		149,
		152,
		169,
		173,
		189,
		-1,
		-1,
		96,
		100,
		121,
		64,
		91,
		115,
		152,
		110,
		119,
		121,
		-1,
		141,
		142,
		139,
		140,
		126,
		119,
		120,
		136,
		142,
		138,
		133,
		136,
		158,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		98,
		69,
		93,
		135,
		149,
		142,
		130,
		150,
		150,
		152,
		-1,
		157,
		136,
		133,
		124,
		132,
		146,
		143,
		157,
		137,
		139,
		155,
		167,
		158,
		178,
		-1,
		-1,
		-1,
		128,
		117,
		118,
		72,
		106,
		124,
		183,
		169,
		174,
		149,
		150,
		144,
		151,
		153,
		148,
		142,
		134,
		123,
		139,
		147,
		149,
		139,
		148,
		149,
		173,
		180,
		186,
		-1,
		-1,
		135,
		125,
		109,
		111,
		108,
		97,
		104,
		136,
		174,
		179,
		-1,
		149,
		-1,
		138,
		146,
		145,
		142,
		139,
		136,
		130,
		139,
		153,
		153,
		144,
		159,
		178,
		178,
		170,
		195,
		198,
		-1,
		-1,
		-1,
		128,
		145,
		120,
		97,
		78,
		114,
		-1,
		149,
		150,
		-1,
		143,
		137,
		143,
		142,
		145,
		140,
		144,
		137,
		144,
		140,
		154,
		163,
		145,
		181,
		-1,
		178,
		172,
		200,
		194,
		182,
		-1,
		-1,
		-1,
		143,
		122,
		115,
		135,
		85,
		137,
		-1,
		-1,
		134,
		127,
		-1,
		130,
		130,
		137,
		146,
		141,
		145,
		149,
		138,
		151,
		156,
		150,
		160,
		180,
		184,
		191,
		184,
		180,
		177,
		191,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		105,
		-1,
		142,
		134,
		125,
		119,
		125,
		143,
		141,
		161,
		153,
		156,
		156,
		152,
		160,
		145,
		148,
		153,
		157,
		175,
		190,
		182,
		176,
		175,
		187,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		120,
		-1,
		91,
		115,
		131,
		-1,
		159,
		138,
		161,
		139,
		153,
		149,
		176,
		177,
		155,
		160,
		159,
		169,
		170,
		159,
		165,
		164,
		184,
		186,
		170,
		171,
		180,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		94,
		107,
		118,
		-1,
		-1,
		203,
		-1,
		137,
		154,
		163,
		161,
		166,
		157,
		163,
		170,
		173,
		174,
		164,
		153,
		159,
		158,
		180,
		166,
		164,
		183,
		199,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		181,
		171,
		155,
		140,
		173,
		-1,
		174,
		158,
		163,
		-1,
		199,
		-1,
		172,
		174,
		166,
		155,
		152,
		163,
		161,
		172,
		189,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		151,
		-1,
		-1,
		168,
		162,
		162,
		146,
		149,
		190,
		170,
		164,
		163,
		194,
		192,
		180,
		164,
		157,
		154,
		155,
		168,
		188,
		179,
		191,
		-1,
		-1,
		-1,
		152,
		132,
		138,
		96,
		117,
		-1,
		-1,
		230,
		185,
		171,
		-1,
		155,
		207,
		195,
		185,
		175,
		209,
		208,
		183,
		176,
		162,
		164,
		162,
		164,
		169,
		190,
		191,
		204,
		-1,
		-1,
		129,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		177,
		193,
		185,
		156,
		196,
		-1,
		-1,
		187,
		185,
		195,
		179,
		166,
		186,
		189,
		179,
		163,
		178,
		190,
		198,
		203,
		-1,
		132,
		119,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		188,
		209,
		224,
		190,
		-1,
		195,
		190,
		170,
		184,
		191,
		181,
		176,
		170,
		173,
		191,
		208,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		167,
		181,
		202,
		206,
		210,
		-1,
		198,
		186,
		172,
		189,
		194,
		191,
		182,
		174,
		179,
		176,
		189,
		203,
		207,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		185,
		200,
		252,
		229,
		202,
		197,
		190,
		184,
		180,
		196,
		202,
		213,
		181,
		177,
		178,
		182,
		181,
		198,
		208,
		-1,
		-1,
		152,
		169,
		204,
		193,
		197,
		279,
		-1,
		-1,
		206,
		197,
		188,
		191,
		190,
		193,
		187,
		184,
		189,
		194,
		182,
		191,
		209,
		208,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		212,
		277,
		224,
		206,
		202,
		200,
		193,
		202,
		197,
		192,
		202,
		204,
		196,
		184,
		188,
		211,
		200,
		239,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		201,
		176,
		191,
		237,
		232,
		233,
		239,
		236,
		-1,
		206,
		231,
		203,
		210,
		201,
		208,
		208,
		200,
		178,
		185,
		201,
		200,
		195,
		231,
		222,
		228,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		207,
		193,
		223,
		213,
		219,
		-1,
		-1,
		255,
		252,
		228,
		211,
		209,
		202,
		197,
		207,
		187,
		174,
		178,
		182,
		188,
		193,
		198,
		204,
		219,
		234,
		-1,
		177,
		258,
		251,
		234,
		242,
		273,
		-1,
		210,
		219,
		200,
		205,
		213,
		-1,
		-1,
		228,
		225,
		230,
		218,
		215,
		217,
		212,
		203,
		188,
		194,
		181,
		180,
		198,
		202,
		211,
		218,
		208,
		221,
		225,
		-1,
		191,
		234,
		228,
		231,
		255,
		269,
		-1,
		223,
		-1,
		-1,
		208,
		226,
		234,
		230,
		227,
		277,
		232,
		227,
		211,
		209,
		200,
		191,
		198,
		189,
		189,
		192,
		207,
		212,
		204,
		218,
		218,
		219,
		-1,
		226,
		214,
		222,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		224,
		-1,
		260,
		-1,
		245,
		249,
		240,
		243,
		225,
		212,
		204,
		196,
		212,
		187,
		197,
		193,
		194,
		203,
		214,
		226,
		225,
		226,
		300,
		255,
		222,
		213,
		260,
		275,
		279,
		-1,
		236,
		275,
		262,
		-1,
		233,
		-1,
		-1,
		-1,
		259,
		253,
		245,
		245,
		224,
		224,
		198,
		202,
		192,
		199,
		209,
		211,
		203,
		207,
		220,
		231,
		234,
		296,
		294,
		299,
		244,
		227,
		245,
		254,
		275,
		251,
		242,
		269,
		269,
		258,
		253,
		240,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		231,
		219,
		202,
		203,
		199,
		202,
		217,
		220,
		210,
		208,
		202,
		234,
		-1,
		296,
		295,
		284,
		281,
		257,
		248,
		235,
		246,
		-1,
		-1,
		254,
		270,
		283,
		287,
		300,
		325,
		-1,
		243,
		-1,
		-1,
		276,
		-1,
		-1,
		261,
		224,
		213,
		204,
		210,
		207,
		218,
		228,
		216,
		217,
		207,
		217,
		230,
		280,
		277,
		265,
		263,
		286,
		243,
		239,
		-1,
		269,
		257,
		263,
		270,
		287,
		314,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		259,
		257,
		246,
		-1,
		236,
		209,
		214,
		234,
		236,
		225,
		219,
		213,
		220,
		219,
		227,
		235,
		289,
		303,
		292,
		288,
		287,
		295,
		244,
		261,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		-1,
		294,
		269,
		-1,
		-1,
		254,
		247,
		235,
		223,
		213,
		223,
		227,
		231,
		223,
		216,
		211,
		222,
		214,
		218,
		235,
		-1,
		323,
		-1,
		275,
		268,
		283,
		298,
		306,
		-1,
		-1,
		-1,
		311,
		297,
		290,
		278,
		276,
		-1,
		288,
		272,
		253,
		-1,
		223,
		236,
		267,
		235,
		240,
		235,
		217,
		228,
		217,
		220,
		234,
		229,
		-1,
		-1,
		281,
		284,
		-1,
		-1,
		304,
		306,
		-1,
		302,
		291,
		276,
		268,
		-1,
		-1,
		260,
		256,
		-1,
		-1,
		224,
		249,
		238,
		246,
		241,
		221,
		227,
		230,
		219,
		223,
		235,
		-1,
		-1,
		288,
		289,
		294,
		-1,
		289,
		-1,
		307,
		-1,
		271,
		280,
		268,
		-1,
		-1,
		-1,
		262,
		225,
		246,
		256,
		250,
		248,
		239,
		225,
		232,
		230,
		226,
		237,
		-1,
		-1,
		-1,
		307,
		281,
		314,
		305,
		288,
		268,
		260,
		279,
		-1,
		249,
		-1,
		224,
		226,
		252,
		255,
		261,
		255,
		228,
		243,
		233,
		224,
		233,
		313,
		-1,
		283,
		316,
		280,
		274,
		250,
		254,
		270,
		-1,
		246,
		228,
		-1,
		256,
		246,
		277,
		262,
		243,
		230,
		237,
		237,
		230,
		-1,
		-1,
		-1,
		285,
		284,
		276,
		270,
		270,
		255,
		246,
		-1,
		258,
		240,
		219,
		236,
		236,
		227,
		235,
		267,
		263,
		250,
		250,
		242,
		-1,
		386,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		279,
		274,
		247,
		235,
		241,
		237,
		223,
		229,
		231,
		239,
		237,
		234,
		246,
		242,
		262,
		243,
		278,
		-1,
		381,
		-1,
		315,
		-1,
		-1,
		297,
		277,
		269,
		258,
		247,
		245,
		236,
		227,
		249,
		265,
		249,
		247,
		250,
		251,
		-1,
		370,
		369,
		-1,
		316,
		308,
		294,
		-1,
		287,
		-1,
		293,
		254,
		-1,
		256,
		236,
		-1,
		258,
		254,
		-1,
		-1,
		357,
		332,
		-1,
		-1,
		-1,
		317,
		297,
		288,
		272,
		-1,
		247,
		247,
		-1,
		-1,
		-1,
		342,
		341,
		-1,
		310,
		313,
		-1,
		303,
		294,
		302,
		249,
		253,
		-1,
		-1,
		-1,
		351,
		332,
		326,
		325,
		323,
		318,
		315,
		301,
		285,
		263,
		252,
		273,
		-1,
		-1,
		-1,
		323,
		315,
		308,
		-1,
		-1,
		310,
		293,
		274,
		272,
		-1,
		-1,
		-1,
		345,
		326,
		-1,
		-1,
		300,
		-1,
		-1,
		306,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		362,
		334,
		-1,
		-1,
		-1,
		296,
		292,
		293,
		-1,
		-1,
		-1,
		-1,
		356,
		357,
		380,
		344,
		-1,
		-1,
		-1,
		288,
		282,
		-1,
		-1,
		359,
		357,
		-1,
		-1,
		-1,
		316,
		300,
		-1,
		286,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		321,
		-1,
		321,
		296,
		303,
		-1,
		-1,
		-1,
		-1,
		334,
		326,
		334,
		-1,
		306,
		308,
		-1,
		356,
		-1,
		-1,
		349,
		340,
		-1,
		-1,
		311,
		318,
		340,
		343,
		379,
		-1,
		330
	],
	[
		-1,
		115,
		104,
		115,
		123,
		96,
		103,
		-1,
		124,
		126,
		92,
		86,
		125,
		96,
		102,
		113,
		-1,
		-1,
		-1,
		115,
		114,
		84,
		82,
		91,
		96,
		103,
		-1,
		126,
		-1,
		136,
		115,
		126,
		131,
		77,
		74,
		94,
		113,
		119,
		111,
		151,
		107,
		78,
		72,
		90,
		95,
		113,
		105,
		-1,
		78,
		68,
		90,
		94,
		106,
		89,
		-1,
		-1,
		72,
		73,
		79,
		91,
		96,
		101,
		-1,
		127,
		146,
		-1,
		-1,
		62,
		75,
		71,
		74,
		82,
		98,
		119,
		136,
		141,
		-1,
		-1,
		63,
		67,
		80,
		81,
		79,
		106,
		125,
		136,
		150,
		149,
		-1,
		51,
		69,
		78,
		87,
		93,
		82,
		86,
		104,
		135,
		141,
		144,
		-1,
		43,
		45,
		74,
		80,
		92,
		98,
		85,
		91,
		110,
		123,
		142,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		4,
		40,
		48,
		74,
		73,
		69,
		87,
		109,
		88,
		94,
		98,
		115,
		131,
		132,
		142,
		-1,
		-1,
		81,
		54,
		77,
		28,
		0,
		-1,
		36,
		55,
		61,
		65,
		70,
		78,
		106,
		104,
		-1,
		109,
		108,
		139,
		125,
		136,
		78,
		-1,
		-1,
		39,
		31,
		8,
		5,
		26,
		31,
		61,
		60,
		65,
		67,
		69,
		81,
		96,
		96,
		106,
		103,
		113,
		117,
		132,
		143,
		-1,
		-1,
		217,
		-1,
		-1,
		75,
		58,
		-1,
		21,
		15,
		21,
		38,
		29,
		54,
		69,
		73,
		81,
		84,
		72,
		91,
		88,
		112,
		108,
		100,
		125,
		129,
		135,
		153,
		154,
		-1,
		216,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		28,
		25,
		27,
		51,
		50,
		-1,
		76,
		74,
		98,
		92,
		97,
		93,
		78,
		96,
		94,
		109,
		111,
		107,
		109,
		146,
		137,
		158,
		155,
		186,
		192,
		186,
		195,
		-1,
		83,
		79,
		75,
		82,
		31,
		-1,
		-1,
		55,
		-1,
		58,
		71,
		88,
		78,
		81,
		93,
		101,
		100,
		84,
		102,
		97,
		100,
		119,
		115,
		124,
		134,
		133,
		151,
		164,
		179,
		183,
		189,
		-1,
		133,
		-1,
		75,
		59,
		61,
		37,
		65,
		-1,
		75,
		59,
		79,
		90,
		90,
		-1,
		106,
		103,
		116,
		100,
		85,
		102,
		104,
		108,
		118,
		122,
		137,
		128,
		146,
		153,
		161,
		165,
		185,
		197,
		93,
		83,
		-1,
		65,
		70,
		40,
		52,
		88,
		102,
		86,
		-1,
		101,
		-1,
		108,
		121,
		-1,
		106,
		102,
		91,
		107,
		115,
		122,
		125,
		119,
		116,
		134,
		137,
		154,
		158,
		174,
		-1,
		-1,
		78,
		82,
		103,
		46,
		73,
		97,
		134,
		95,
		104,
		106,
		-1,
		126,
		127,
		124,
		125,
		111,
		104,
		105,
		121,
		127,
		123,
		118,
		121,
		143,
		171,
		149,
		161,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		80,
		51,
		75,
		117,
		134,
		127,
		115,
		135,
		135,
		134,
		-1,
		142,
		121,
		118,
		109,
		117,
		131,
		128,
		142,
		122,
		124,
		140,
		152,
		143,
		163,
		-1,
		-1,
		-1,
		110,
		99,
		100,
		54,
		88,
		106,
		168,
		154,
		159,
		134,
		132,
		126,
		136,
		138,
		133,
		127,
		119,
		108,
		124,
		132,
		134,
		124,
		133,
		134,
		158,
		165,
		171,
		-1,
		-1,
		117,
		107,
		91,
		93,
		90,
		79,
		86,
		118,
		159,
		161,
		-1,
		131,
		-1,
		120,
		128,
		127,
		127,
		124,
		121,
		115,
		124,
		138,
		138,
		129,
		144,
		163,
		163,
		155,
		180,
		183,
		-1,
		-1,
		-1,
		110,
		127,
		102,
		79,
		60,
		96,
		-1,
		131,
		132,
		-1,
		125,
		119,
		125,
		124,
		130,
		125,
		128,
		122,
		129,
		125,
		139,
		148,
		130,
		166,
		-1,
		163,
		157,
		185,
		179,
		167,
		-1,
		-1,
		-1,
		125,
		104,
		97,
		117,
		67,
		119,
		-1,
		-1,
		116,
		109,
		-1,
		112,
		112,
		119,
		128,
		126,
		130,
		134,
		123,
		136,
		141,
		135,
		145,
		165,
		169,
		176,
		169,
		165,
		162,
		176,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		87,
		-1,
		124,
		116,
		107,
		101,
		107,
		125,
		123,
		143,
		135,
		141,
		141,
		137,
		145,
		130,
		133,
		138,
		142,
		160,
		175,
		167,
		161,
		160,
		172,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		102,
		-1,
		73,
		97,
		113,
		-1,
		141,
		120,
		143,
		121,
		135,
		131,
		161,
		162,
		140,
		145,
		144,
		154,
		155,
		144,
		150,
		149,
		169,
		171,
		155,
		156,
		165,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		76,
		89,
		100,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		145,
		143,
		151,
		142,
		148,
		155,
		158,
		159,
		149,
		138,
		144,
		143,
		165,
		151,
		149,
		168,
		184,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		117,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		159,
		143,
		148,
		-1,
		184,
		-1,
		157,
		159,
		151,
		140,
		137,
		148,
		146,
		157,
		174,
		-1,
		129,
		114,
		107,
		97,
		111,
		82,
		-1,
		133,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		175,
		155,
		149,
		148,
		179,
		177,
		165,
		149,
		142,
		139,
		140,
		153,
		173,
		164,
		176,
		-1,
		-1,
		-1,
		134,
		114,
		120,
		78,
		99,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		137,
		192,
		180,
		170,
		160,
		194,
		193,
		168,
		161,
		147,
		149,
		147,
		149,
		154,
		175,
		176,
		189,
		-1,
		-1,
		111,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		159,
		175,
		167,
		138,
		181,
		-1,
		-1,
		172,
		170,
		180,
		164,
		151,
		171,
		174,
		164,
		148,
		163,
		175,
		183,
		188,
		-1,
		114,
		101,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		170,
		191,
		209,
		175,
		-1,
		180,
		175,
		155,
		169,
		176,
		166,
		161,
		155,
		158,
		176,
		193,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		149,
		163,
		184,
		190,
		195,
		-1,
		183,
		171,
		157,
		174,
		179,
		176,
		167,
		159,
		164,
		161,
		174,
		188,
		192,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		167,
		182,
		237,
		214,
		187,
		182,
		175,
		169,
		165,
		181,
		187,
		198,
		166,
		162,
		163,
		167,
		166,
		183,
		193,
		-1,
		-1,
		134,
		151,
		186,
		175,
		179,
		264,
		-1,
		-1,
		191,
		182,
		173,
		176,
		175,
		178,
		172,
		169,
		174,
		179,
		167,
		176,
		194,
		193,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		194,
		262,
		209,
		191,
		187,
		185,
		178,
		187,
		182,
		177,
		187,
		189,
		181,
		169,
		173,
		196,
		185,
		224,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		183,
		158,
		173,
		219,
		214,
		215,
		224,
		221,
		-1,
		191,
		216,
		188,
		195,
		186,
		193,
		193,
		185,
		163,
		170,
		186,
		185,
		180,
		216,
		207,
		213,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		189,
		175,
		205,
		195,
		201,
		-1,
		-1,
		240,
		237,
		213,
		196,
		194,
		187,
		182,
		192,
		172,
		159,
		163,
		167,
		173,
		178,
		183,
		189,
		204,
		219,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		192,
		201,
		182,
		187,
		195,
		-1,
		-1,
		213,
		210,
		215,
		203,
		200,
		202,
		197,
		188,
		173,
		179,
		166,
		165,
		183,
		187,
		196,
		203,
		193,
		206,
		210,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		205,
		-1,
		-1,
		190,
		208,
		216,
		212,
		212,
		262,
		217,
		212,
		196,
		194,
		185,
		176,
		183,
		174,
		174,
		177,
		192,
		197,
		189,
		203,
		203,
		204,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		206,
		-1,
		242,
		-1,
		230,
		234,
		225,
		228,
		210,
		197,
		189,
		181,
		197,
		172,
		182,
		178,
		179,
		188,
		199,
		211,
		210,
		211,
		282,
		237,
		204,
		195,
		242,
		257,
		261,
		-1,
		218,
		257,
		244,
		-1,
		215,
		-1,
		-1,
		-1,
		244,
		238,
		230,
		230,
		209,
		209,
		183,
		187,
		177,
		184,
		194,
		196,
		188,
		192,
		205,
		216,
		219,
		278,
		276,
		281,
		226,
		209,
		227,
		236,
		257,
		233,
		224,
		251,
		251,
		240,
		235,
		222,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		216,
		204,
		187,
		188,
		184,
		187,
		202,
		205,
		195,
		193,
		187,
		219,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		217,
		228,
		-1,
		-1,
		236,
		252,
		265,
		269,
		282,
		307,
		-1,
		225,
		-1,
		-1,
		261,
		-1,
		-1,
		246,
		209,
		198,
		189,
		195,
		192,
		203,
		213,
		201,
		202,
		192,
		202,
		215,
		262,
		259,
		247,
		245,
		268,
		225,
		221,
		-1,
		251,
		239,
		245,
		252,
		269,
		296,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		244,
		242,
		231,
		-1,
		221,
		194,
		199,
		219,
		221,
		210,
		204,
		198,
		205,
		204,
		212,
		220,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		243,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		-1,
		276,
		251,
		-1,
		-1,
		239,
		232,
		220,
		208,
		198,
		208,
		212,
		216,
		208,
		201,
		196,
		207,
		199,
		203,
		220,
		-1,
		305,
		-1,
		257,
		250,
		265,
		280,
		288,
		-1,
		-1,
		-1,
		293,
		279,
		272,
		260,
		258,
		-1,
		273,
		257,
		238,
		-1,
		208,
		221,
		252,
		220,
		225,
		220,
		202,
		213,
		202,
		205,
		219,
		214,
		-1,
		-1,
		263,
		266,
		-1,
		-1,
		288,
		291,
		-1,
		284,
		273,
		258,
		250,
		-1,
		-1,
		245,
		241,
		-1,
		-1,
		209,
		234,
		223,
		231,
		226,
		206,
		212,
		215,
		204,
		208,
		220,
		-1,
		-1,
		270,
		271,
		276,
		-1,
		274,
		-1,
		292,
		-1,
		253,
		265,
		253,
		-1,
		-1,
		-1,
		247,
		210,
		231,
		241,
		235,
		233,
		224,
		210,
		217,
		215,
		211,
		222,
		-1,
		-1,
		-1,
		292,
		266,
		299,
		290,
		273,
		253,
		245,
		264,
		-1,
		234,
		-1,
		209,
		211,
		237,
		240,
		246,
		240,
		213,
		228,
		218,
		209,
		218,
		298,
		-1,
		268,
		301,
		265,
		259,
		235,
		239,
		255,
		-1,
		231,
		213,
		-1,
		241,
		231,
		262,
		247,
		228,
		215,
		222,
		222,
		215,
		-1,
		-1,
		-1,
		270,
		269,
		261,
		255,
		255,
		240,
		231,
		-1,
		243,
		225,
		204,
		221,
		221,
		212,
		220,
		252,
		248,
		235,
		235,
		227,
		-1,
		371,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		264,
		259,
		232,
		220,
		226,
		222,
		208,
		214,
		216,
		224,
		222,
		219,
		231,
		227,
		247,
		228,
		263,
		-1,
		366,
		-1,
		300,
		-1,
		-1,
		282,
		262,
		254,
		243,
		232,
		230,
		221,
		212,
		234,
		250,
		234,
		232,
		235,
		236,
		-1,
		355,
		354,
		-1,
		301,
		293,
		279,
		-1,
		272,
		-1,
		278,
		239,
		-1,
		241,
		221,
		-1,
		243,
		239,
		-1,
		-1,
		342,
		317,
		-1,
		-1,
		-1,
		302,
		282,
		273,
		257,
		-1,
		232,
		232,
		-1,
		-1,
		-1,
		327,
		326,
		-1,
		295,
		298,
		-1,
		288,
		279,
		287,
		234,
		238,
		-1,
		-1,
		-1,
		336,
		317,
		311,
		310,
		308,
		303,
		300,
		286,
		270,
		248,
		237,
		258,
		-1,
		-1,
		-1,
		308,
		300,
		293,
		-1,
		-1,
		295,
		278,
		259,
		257,
		-1,
		-1,
		-1,
		330,
		311,
		-1,
		-1,
		285,
		-1,
		-1,
		291,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		347,
		319,
		-1,
		-1,
		-1,
		281,
		277,
		278,
		-1,
		-1,
		-1,
		-1,
		341,
		342,
		365,
		329,
		-1,
		-1,
		-1,
		273,
		267,
		-1,
		-1,
		344,
		342,
		-1,
		-1,
		-1,
		301,
		285,
		-1,
		271,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		306,
		-1,
		306,
		281,
		288,
		-1,
		-1,
		-1,
		-1,
		319,
		311,
		319,
		-1,
		291,
		293,
		-1,
		341,
		-1,
		-1,
		334,
		325,
		-1,
		-1,
		296,
		303,
		325,
		328,
		364,
		-1,
		315
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		79,
		68,
		79,
		87,
		60,
		67,
		-1,
		88,
		90,
		56,
		50,
		89,
		60,
		66,
		77,
		-1,
		-1,
		-1,
		79,
		78,
		48,
		46,
		55,
		60,
		67,
		-1,
		90,
		-1,
		100,
		79,
		90,
		95,
		41,
		38,
		58,
		77,
		83,
		75,
		115,
		71,
		42,
		36,
		54,
		59,
		77,
		69,
		-1,
		42,
		32,
		54,
		58,
		70,
		53,
		-1,
		-1,
		36,
		37,
		43,
		55,
		60,
		65,
		-1,
		91,
		110,
		-1,
		-1,
		26,
		39,
		35,
		38,
		46,
		62,
		83,
		100,
		105,
		-1,
		-1,
		27,
		31,
		44,
		45,
		43,
		70,
		89,
		100,
		114,
		113,
		-1,
		15,
		33,
		42,
		51,
		57,
		46,
		50,
		68,
		99,
		105,
		108,
		-1,
		7,
		9,
		38,
		44,
		56,
		62,
		49,
		55,
		74,
		87,
		106,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		38,
		4,
		12,
		38,
		37,
		33,
		51,
		73,
		52,
		58,
		62,
		79,
		95,
		96,
		106,
		-1,
		-1,
		98,
		71,
		95,
		53,
		34,
		-1,
		0,
		19,
		25,
		29,
		34,
		42,
		70,
		68,
		-1,
		73,
		72,
		103,
		89,
		100,
		80,
		-1,
		-1,
		56,
		48,
		30,
		33,
		10,
		6,
		25,
		24,
		29,
		31,
		33,
		45,
		60,
		60,
		70,
		67,
		77,
		81,
		96,
		107,
		-1,
		-1,
		181,
		-1,
		-1,
		77,
		60,
		-1,
		25,
		32,
		16,
		22,
		8,
		29,
		33,
		37,
		45,
		48,
		36,
		55,
		52,
		76,
		72,
		64,
		89,
		93,
		99,
		117,
		118,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		55,
		32,
		29,
		22,
		46,
		45,
		-1,
		51,
		49,
		71,
		56,
		61,
		57,
		42,
		60,
		58,
		73,
		75,
		71,
		73,
		110,
		101,
		122,
		119,
		150,
		156,
		150,
		159,
		-1,
		85,
		81,
		77,
		84,
		33,
		-1,
		-1,
		50,
		-1,
		53,
		66,
		63,
		53,
		56,
		57,
		65,
		64,
		48,
		66,
		61,
		64,
		83,
		79,
		88,
		98,
		97,
		115,
		128,
		143,
		147,
		153,
		-1,
		135,
		-1,
		77,
		61,
		63,
		39,
		67,
		-1,
		70,
		54,
		74,
		65,
		65,
		-1,
		73,
		70,
		80,
		64,
		49,
		66,
		68,
		72,
		82,
		86,
		101,
		92,
		110,
		117,
		125,
		129,
		149,
		161,
		95,
		85,
		-1,
		67,
		72,
		42,
		54,
		77,
		97,
		81,
		-1,
		76,
		-1,
		75,
		88,
		-1,
		70,
		66,
		55,
		71,
		79,
		86,
		89,
		83,
		80,
		98,
		101,
		118,
		122,
		138,
		-1,
		-1,
		80,
		84,
		92,
		43,
		62,
		86,
		123,
		90,
		83,
		82,
		-1,
		93,
		91,
		88,
		89,
		75,
		68,
		69,
		85,
		91,
		87,
		82,
		85,
		107,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		69,
		40,
		64,
		106,
		112,
		105,
		93,
		110,
		110,
		117,
		-1,
		106,
		85,
		82,
		73,
		81,
		95,
		92,
		106,
		86,
		88,
		104,
		116,
		107,
		127,
		-1,
		-1,
		-1,
		99,
		88,
		89,
		43,
		77,
		95,
		143,
		129,
		134,
		109,
		115,
		115,
		100,
		102,
		97,
		91,
		83,
		72,
		88,
		96,
		98,
		88,
		97,
		98,
		122,
		129,
		135,
		-1,
		-1,
		106,
		96,
		80,
		82,
		79,
		68,
		75,
		107,
		134,
		150,
		-1,
		120,
		-1,
		109,
		112,
		96,
		91,
		88,
		85,
		79,
		88,
		102,
		102,
		93,
		108,
		127,
		127,
		119,
		144,
		147,
		-1,
		-1,
		-1,
		99,
		116,
		91,
		68,
		49,
		85,
		-1,
		120,
		121,
		-1,
		114,
		108,
		113,
		98,
		94,
		89,
		93,
		86,
		93,
		89,
		103,
		112,
		94,
		130,
		-1,
		127,
		121,
		149,
		143,
		131,
		-1,
		-1,
		-1,
		114,
		93,
		86,
		106,
		56,
		108,
		-1,
		-1,
		105,
		98,
		-1,
		101,
		91,
		98,
		96,
		90,
		94,
		98,
		87,
		100,
		105,
		99,
		109,
		129,
		133,
		140,
		133,
		129,
		126,
		140,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		76,
		-1,
		113,
		105,
		96,
		90,
		96,
		104,
		102,
		118,
		102,
		105,
		105,
		101,
		109,
		94,
		97,
		102,
		106,
		124,
		139,
		131,
		125,
		124,
		136,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		91,
		-1,
		62,
		86,
		102,
		-1,
		130,
		109,
		132,
		110,
		114,
		110,
		125,
		126,
		104,
		109,
		108,
		118,
		119,
		108,
		114,
		113,
		133,
		135,
		119,
		120,
		129,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		65,
		78,
		89,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		124,
		122,
		115,
		106,
		112,
		119,
		122,
		123,
		113,
		102,
		108,
		107,
		129,
		115,
		113,
		132,
		148,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		123,
		107,
		112,
		-1,
		148,
		-1,
		121,
		123,
		115,
		104,
		101,
		112,
		110,
		121,
		138,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		122,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		139,
		119,
		113,
		112,
		143,
		141,
		129,
		113,
		106,
		103,
		104,
		117,
		137,
		128,
		140,
		-1,
		-1,
		-1,
		123,
		103,
		109,
		67,
		88,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		156,
		144,
		134,
		124,
		158,
		157,
		132,
		125,
		111,
		113,
		111,
		113,
		118,
		139,
		140,
		153,
		-1,
		-1,
		100,
		107,
		95,
		81,
		100,
		-1,
		-1,
		-1,
		148,
		164,
		156,
		127,
		145,
		-1,
		-1,
		136,
		134,
		144,
		128,
		115,
		135,
		138,
		128,
		112,
		127,
		139,
		147,
		152,
		-1,
		103,
		90,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		159,
		169,
		173,
		139,
		-1,
		144,
		139,
		119,
		133,
		140,
		130,
		125,
		119,
		122,
		140,
		157,
		-1,
		-1,
		117,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		138,
		152,
		162,
		155,
		159,
		-1,
		147,
		135,
		121,
		138,
		143,
		140,
		131,
		123,
		128,
		125,
		138,
		152,
		156,
		140,
		-1,
		123,
		-1,
		-1,
		-1,
		156,
		171,
		201,
		178,
		151,
		146,
		139,
		133,
		129,
		145,
		151,
		162,
		130,
		126,
		127,
		131,
		130,
		147,
		157,
		-1,
		-1,
		123,
		140,
		175,
		164,
		168,
		228,
		-1,
		-1,
		155,
		146,
		137,
		140,
		139,
		142,
		136,
		133,
		138,
		143,
		131,
		140,
		158,
		157,
		-1,
		-1,
		-1,
		143,
		-1,
		158,
		-1,
		-1,
		183,
		226,
		173,
		155,
		151,
		149,
		142,
		151,
		146,
		141,
		151,
		153,
		145,
		133,
		137,
		160,
		149,
		188,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		172,
		147,
		162,
		208,
		203,
		204,
		188,
		185,
		-1,
		155,
		180,
		152,
		159,
		150,
		157,
		157,
		149,
		127,
		134,
		150,
		149,
		144,
		180,
		171,
		177,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		178,
		164,
		194,
		184,
		190,
		-1,
		-1,
		204,
		201,
		177,
		160,
		158,
		151,
		146,
		156,
		136,
		123,
		127,
		131,
		137,
		142,
		147,
		153,
		168,
		183,
		-1,
		148,
		229,
		222,
		205,
		213,
		244,
		-1,
		181,
		190,
		171,
		176,
		184,
		-1,
		-1,
		177,
		174,
		179,
		167,
		164,
		166,
		161,
		152,
		137,
		143,
		130,
		129,
		147,
		151,
		160,
		167,
		157,
		170,
		174,
		-1,
		162,
		205,
		199,
		202,
		226,
		240,
		-1,
		194,
		-1,
		-1,
		179,
		197,
		192,
		182,
		176,
		226,
		181,
		176,
		160,
		158,
		149,
		140,
		147,
		138,
		138,
		141,
		156,
		161,
		153,
		167,
		167,
		168,
		-1,
		197,
		185,
		193,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		195,
		-1,
		219,
		-1,
		194,
		198,
		189,
		192,
		174,
		161,
		153,
		145,
		161,
		136,
		146,
		142,
		143,
		152,
		163,
		175,
		174,
		175,
		271,
		226,
		193,
		184,
		231,
		246,
		250,
		-1,
		207,
		246,
		233,
		-1,
		204,
		-1,
		-1,
		-1,
		208,
		202,
		194,
		194,
		173,
		173,
		147,
		151,
		141,
		148,
		158,
		160,
		152,
		156,
		169,
		180,
		183,
		267,
		265,
		270,
		215,
		198,
		216,
		225,
		246,
		222,
		213,
		240,
		240,
		229,
		224,
		211,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		180,
		168,
		151,
		152,
		148,
		151,
		166,
		169,
		159,
		157,
		151,
		183,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		206,
		217,
		-1,
		-1,
		225,
		241,
		254,
		258,
		271,
		296,
		-1,
		214,
		-1,
		-1,
		225,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		156,
		167,
		177,
		165,
		166,
		156,
		166,
		179,
		251,
		248,
		236,
		234,
		257,
		214,
		210,
		-1,
		240,
		228,
		234,
		241,
		258,
		285,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		208,
		206,
		195,
		-1,
		185,
		158,
		163,
		183,
		185,
		174,
		168,
		162,
		169,
		168,
		176,
		184,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		225,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		-1,
		246,
		240,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		176,
		180,
		172,
		165,
		160,
		171,
		163,
		167,
		184,
		-1,
		294,
		-1,
		246,
		239,
		253,
		268,
		276,
		-1,
		-1,
		-1,
		263,
		249,
		242,
		230,
		228,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		166,
		177,
		166,
		169,
		183,
		178,
		-1,
		-1,
		251,
		254,
		-1,
		-1,
		253,
		255,
		-1,
		254,
		243,
		228,
		220,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		170,
		176,
		179,
		168,
		172,
		184,
		-1,
		-1,
		258,
		259,
		260,
		-1,
		238,
		-1,
		256,
		-1,
		223,
		229,
		217,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		199,
		197,
		188,
		174,
		181,
		179,
		175,
		186,
		-1,
		-1,
		-1,
		256,
		230,
		263,
		254,
		237,
		217,
		209,
		228,
		-1,
		198,
		-1,
		173,
		175,
		201,
		204,
		210,
		204,
		177,
		192,
		182,
		173,
		182,
		262,
		-1,
		232,
		265,
		229,
		223,
		199,
		203,
		219,
		-1,
		195,
		177,
		-1,
		205,
		195,
		226,
		211,
		192,
		179,
		186,
		186,
		179,
		-1,
		-1,
		-1,
		234,
		233,
		225,
		219,
		219,
		204,
		195,
		-1,
		207,
		189,
		168,
		185,
		185,
		176,
		184,
		216,
		212,
		199,
		199,
		191,
		-1,
		335,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		228,
		223,
		196,
		184,
		190,
		186,
		172,
		178,
		180,
		188,
		186,
		183,
		195,
		191,
		211,
		192,
		227,
		-1,
		330,
		-1,
		264,
		-1,
		-1,
		246,
		226,
		218,
		207,
		196,
		194,
		185,
		176,
		198,
		214,
		198,
		196,
		199,
		200,
		-1,
		319,
		318,
		-1,
		265,
		257,
		243,
		-1,
		236,
		-1,
		242,
		203,
		-1,
		205,
		185,
		-1,
		207,
		203,
		-1,
		-1,
		306,
		281,
		-1,
		-1,
		-1,
		266,
		246,
		237,
		221,
		-1,
		196,
		196,
		-1,
		-1,
		-1,
		291,
		290,
		-1,
		259,
		262,
		-1,
		252,
		243,
		251,
		198,
		202,
		-1,
		-1,
		-1,
		300,
		281,
		275,
		274,
		272,
		267,
		264,
		250,
		234,
		212,
		201,
		222,
		-1,
		-1,
		-1,
		272,
		264,
		257,
		-1,
		-1,
		259,
		242,
		223,
		221,
		-1,
		-1,
		-1,
		294,
		275,
		-1,
		-1,
		249,
		-1,
		-1,
		255,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		283,
		-1,
		-1,
		-1,
		245,
		241,
		242,
		-1,
		-1,
		-1,
		-1,
		305,
		306,
		329,
		293,
		-1,
		-1,
		-1,
		237,
		231,
		-1,
		-1,
		308,
		306,
		-1,
		-1,
		-1,
		265,
		249,
		-1,
		235,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		270,
		-1,
		270,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		283,
		275,
		283,
		-1,
		255,
		257,
		-1,
		305,
		-1,
		-1,
		298,
		289,
		-1,
		-1,
		260,
		267,
		289,
		292,
		328,
		-1,
		279
	],
	[
		-1,
		79,
		68,
		79,
		87,
		60,
		67,
		-1,
		88,
		90,
		56,
		50,
		89,
		60,
		66,
		77,
		-1,
		-1,
		-1,
		79,
		78,
		48,
		46,
		55,
		60,
		67,
		-1,
		90,
		-1,
		100,
		79,
		90,
		95,
		41,
		38,
		58,
		77,
		83,
		75,
		115,
		71,
		42,
		36,
		54,
		59,
		77,
		69,
		-1,
		42,
		32,
		54,
		58,
		70,
		53,
		-1,
		-1,
		36,
		37,
		43,
		55,
		60,
		65,
		-1,
		91,
		110,
		-1,
		-1,
		26,
		39,
		35,
		38,
		46,
		62,
		83,
		100,
		105,
		-1,
		-1,
		27,
		31,
		44,
		45,
		43,
		70,
		89,
		100,
		114,
		113,
		-1,
		15,
		33,
		42,
		51,
		57,
		46,
		50,
		68,
		99,
		105,
		108,
		-1,
		24,
		25,
		31,
		39,
		44,
		51,
		49,
		55,
		74,
		87,
		106,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		24,
		7,
		24,
		21,
		14,
		32,
		54,
		52,
		58,
		62,
		79,
		95,
		96,
		106,
		-1,
		-1,
		118,
		91,
		115,
		73,
		54,
		-1,
		20,
		0,
		6,
		10,
		15,
		23,
		51,
		51,
		-1,
		73,
		72,
		103,
		89,
		100,
		100,
		-1,
		-1,
		76,
		68,
		50,
		53,
		30,
		26,
		15,
		14,
		10,
		12,
		14,
		26,
		41,
		41,
		51,
		67,
		77,
		81,
		96,
		107,
		-1,
		-1,
		181,
		-1,
		-1,
		97,
		80,
		-1,
		45,
		52,
		36,
		42,
		28,
		49,
		25,
		19,
		26,
		29,
		17,
		36,
		33,
		57,
		53,
		64,
		89,
		93,
		99,
		117,
		118,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		52,
		49,
		42,
		66,
		65,
		-1,
		63,
		51,
		52,
		37,
		42,
		38,
		23,
		41,
		39,
		54,
		56,
		71,
		73,
		107,
		101,
		122,
		119,
		150,
		156,
		150,
		159,
		-1,
		105,
		101,
		97,
		104,
		53,
		-1,
		-1,
		70,
		-1,
		73,
		86,
		75,
		48,
		51,
		38,
		46,
		45,
		29,
		47,
		42,
		45,
		65,
		78,
		85,
		98,
		97,
		115,
		128,
		143,
		147,
		153,
		-1,
		155,
		-1,
		97,
		81,
		83,
		59,
		87,
		-1,
		90,
		74,
		92,
		77,
		77,
		-1,
		54,
		51,
		61,
		45,
		30,
		47,
		49,
		53,
		64,
		85,
		101,
		92,
		110,
		117,
		125,
		129,
		149,
		161,
		115,
		105,
		-1,
		87,
		92,
		62,
		74,
		97,
		117,
		101,
		-1,
		88,
		-1,
		56,
		69,
		-1,
		51,
		47,
		36,
		52,
		60,
		67,
		71,
		83,
		80,
		98,
		101,
		118,
		122,
		138,
		-1,
		-1,
		100,
		104,
		112,
		63,
		82,
		106,
		143,
		106,
		95,
		94,
		-1,
		74,
		72,
		69,
		70,
		56,
		49,
		50,
		66,
		72,
		68,
		82,
		85,
		107,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		89,
		60,
		84,
		126,
		124,
		117,
		105,
		113,
		111,
		98,
		-1,
		87,
		66,
		63,
		54,
		62,
		76,
		73,
		87,
		86,
		88,
		104,
		116,
		107,
		127,
		-1,
		-1,
		-1,
		119,
		108,
		109,
		63,
		97,
		115,
		146,
		132,
		137,
		112,
		100,
		104,
		81,
		83,
		78,
		72,
		64,
		53,
		69,
		77,
		79,
		88,
		97,
		98,
		122,
		129,
		135,
		-1,
		-1,
		126,
		116,
		100,
		102,
		99,
		88,
		95,
		127,
		137,
		155,
		-1,
		109,
		-1,
		98,
		93,
		77,
		72,
		69,
		66,
		60,
		69,
		83,
		94,
		90,
		97,
		127,
		127,
		119,
		144,
		147,
		-1,
		-1,
		-1,
		119,
		136,
		111,
		88,
		69,
		105,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		79,
		75,
		70,
		74,
		67,
		74,
		70,
		84,
		95,
		82,
		118,
		-1,
		127,
		121,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		134,
		113,
		106,
		126,
		76,
		128,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		79,
		77,
		71,
		75,
		79,
		68,
		81,
		86,
		87,
		97,
		117,
		121,
		125,
		114,
		110,
		107,
		121,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		79,
		96,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		99,
		83,
		86,
		86,
		82,
		90,
		75,
		78,
		90,
		94,
		112,
		120,
		112,
		106,
		105,
		117,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		111,
		-1,
		82,
		106,
		122,
		-1,
		127,
		106,
		121,
		99,
		95,
		91,
		106,
		107,
		85,
		90,
		89,
		99,
		100,
		89,
		102,
		94,
		116,
		116,
		100,
		101,
		110,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		85,
		89,
		109,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		105,
		103,
		96,
		87,
		93,
		100,
		103,
		104,
		94,
		83,
		89,
		88,
		110,
		96,
		94,
		113,
		129,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		104,
		88,
		93,
		-1,
		129,
		-1,
		102,
		104,
		96,
		85,
		82,
		93,
		91,
		102,
		119,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		142,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		120,
		100,
		94,
		93,
		124,
		122,
		110,
		94,
		87,
		84,
		85,
		98,
		118,
		109,
		121,
		-1,
		-1,
		-1,
		143,
		123,
		129,
		87,
		108,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		137,
		125,
		115,
		105,
		139,
		138,
		113,
		106,
		92,
		94,
		92,
		94,
		99,
		120,
		121,
		134,
		-1,
		-1,
		120,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		126,
		-1,
		-1,
		117,
		115,
		125,
		109,
		96,
		116,
		119,
		109,
		93,
		108,
		120,
		128,
		133,
		-1,
		123,
		110,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		148,
		150,
		154,
		120,
		-1,
		125,
		120,
		100,
		114,
		121,
		111,
		106,
		100,
		103,
		121,
		138,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		143,
		136,
		140,
		-1,
		128,
		116,
		102,
		119,
		124,
		121,
		112,
		104,
		109,
		106,
		119,
		133,
		137,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		145,
		160,
		182,
		159,
		132,
		127,
		120,
		114,
		110,
		126,
		132,
		143,
		111,
		107,
		108,
		112,
		111,
		128,
		138,
		-1,
		-1,
		143,
		160,
		171,
		153,
		157,
		209,
		-1,
		-1,
		136,
		127,
		118,
		121,
		120,
		123,
		117,
		114,
		119,
		124,
		112,
		121,
		139,
		138,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		172,
		207,
		154,
		136,
		132,
		130,
		123,
		132,
		127,
		122,
		132,
		134,
		126,
		114,
		118,
		141,
		130,
		169,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		192,
		167,
		182,
		218,
		192,
		199,
		169,
		166,
		-1,
		136,
		161,
		133,
		140,
		131,
		138,
		138,
		130,
		108,
		115,
		131,
		130,
		125,
		161,
		152,
		158,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		198,
		184,
		204,
		194,
		197,
		-1,
		-1,
		185,
		182,
		158,
		141,
		139,
		132,
		127,
		137,
		117,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		168,
		249,
		242,
		225,
		233,
		264,
		-1,
		201,
		200,
		191,
		186,
		188,
		-1,
		-1,
		158,
		155,
		160,
		148,
		145,
		147,
		142,
		133,
		118,
		124,
		111,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		182,
		225,
		219,
		222,
		246,
		260,
		-1,
		205,
		-1,
		-1,
		199,
		189,
		173,
		163,
		157,
		207,
		162,
		157,
		141,
		139,
		130,
		121,
		128,
		119,
		119,
		122,
		137,
		142,
		134,
		148,
		148,
		149,
		-1,
		217,
		205,
		213,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		215,
		-1,
		200,
		-1,
		175,
		179,
		170,
		173,
		155,
		142,
		134,
		126,
		142,
		117,
		127,
		123,
		124,
		133,
		144,
		156,
		155,
		156,
		276,
		232,
		213,
		204,
		251,
		266,
		270,
		-1,
		217,
		256,
		253,
		-1,
		224,
		-1,
		-1,
		-1,
		189,
		183,
		175,
		175,
		154,
		154,
		128,
		132,
		122,
		129,
		139,
		141,
		133,
		137,
		150,
		161,
		164,
		272,
		263,
		276,
		221,
		218,
		236,
		245,
		266,
		232,
		223,
		250,
		260,
		249,
		244,
		231,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		161,
		149,
		132,
		133,
		129,
		132,
		147,
		150,
		140,
		138,
		132,
		164,
		-1,
		265,
		264,
		253,
		250,
		226,
		217,
		212,
		237,
		-1,
		-1,
		234,
		251,
		245,
		249,
		265,
		290,
		-1,
		221,
		-1,
		-1,
		206,
		-1,
		-1,
		191,
		154,
		143,
		134,
		140,
		137,
		148,
		158,
		146,
		147,
		137,
		147,
		160,
		249,
		246,
		234,
		232,
		255,
		220,
		208,
		-1,
		221,
		219,
		225,
		232,
		249,
		279,
		-1,
		-1,
		237,
		217,
		-1,
		-1,
		189,
		187,
		176,
		-1,
		166,
		139,
		144,
		164,
		166,
		155,
		149,
		143,
		150,
		149,
		157,
		165,
		258,
		272,
		261,
		257,
		256,
		264,
		213,
		206,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		227,
		223,
		-1,
		-1,
		184,
		177,
		165,
		153,
		143,
		153,
		157,
		161,
		153,
		146,
		141,
		152,
		144,
		148,
		165,
		-1,
		292,
		-1,
		244,
		220,
		234,
		249,
		257,
		-1,
		-1,
		-1,
		244,
		230,
		223,
		211,
		209,
		-1,
		218,
		202,
		183,
		-1,
		153,
		166,
		197,
		165,
		170,
		165,
		147,
		158,
		147,
		150,
		164,
		159,
		-1,
		-1,
		232,
		235,
		-1,
		-1,
		234,
		236,
		-1,
		235,
		224,
		209,
		201,
		-1,
		-1,
		190,
		186,
		-1,
		-1,
		154,
		179,
		168,
		176,
		171,
		151,
		157,
		160,
		149,
		153,
		165,
		-1,
		-1,
		239,
		240,
		241,
		-1,
		219,
		-1,
		237,
		-1,
		204,
		210,
		198,
		-1,
		-1,
		-1,
		192,
		155,
		176,
		186,
		180,
		178,
		169,
		155,
		162,
		160,
		156,
		167,
		-1,
		-1,
		-1,
		237,
		211,
		244,
		235,
		218,
		198,
		190,
		209,
		-1,
		179,
		-1,
		154,
		156,
		182,
		185,
		191,
		185,
		158,
		173,
		163,
		154,
		163,
		243,
		-1,
		213,
		246,
		210,
		204,
		180,
		184,
		200,
		-1,
		176,
		158,
		-1,
		186,
		176,
		207,
		192,
		173,
		160,
		167,
		167,
		160,
		-1,
		-1,
		-1,
		215,
		214,
		206,
		200,
		200,
		185,
		176,
		-1,
		188,
		170,
		149,
		166,
		166,
		157,
		165,
		197,
		193,
		180,
		180,
		172,
		-1,
		316,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		209,
		204,
		177,
		165,
		171,
		167,
		153,
		159,
		161,
		169,
		167,
		164,
		176,
		172,
		192,
		173,
		208,
		-1,
		311,
		-1,
		245,
		-1,
		-1,
		227,
		207,
		199,
		188,
		177,
		175,
		166,
		157,
		179,
		195,
		179,
		177,
		180,
		181,
		-1,
		300,
		299,
		-1,
		246,
		238,
		224,
		-1,
		217,
		-1,
		223,
		184,
		-1,
		186,
		166,
		-1,
		188,
		184,
		-1,
		-1,
		287,
		262,
		-1,
		-1,
		-1,
		247,
		227,
		218,
		202,
		-1,
		177,
		177,
		-1,
		-1,
		-1,
		272,
		271,
		-1,
		240,
		243,
		-1,
		233,
		224,
		232,
		179,
		183,
		-1,
		-1,
		-1,
		281,
		262,
		256,
		255,
		253,
		248,
		245,
		231,
		215,
		193,
		182,
		203,
		-1,
		-1,
		-1,
		253,
		245,
		238,
		-1,
		-1,
		240,
		223,
		204,
		202,
		-1,
		-1,
		-1,
		275,
		256,
		-1,
		-1,
		230,
		-1,
		-1,
		236,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		264,
		-1,
		-1,
		-1,
		226,
		222,
		223,
		-1,
		-1,
		-1,
		-1,
		286,
		287,
		310,
		274,
		-1,
		-1,
		-1,
		218,
		212,
		-1,
		-1,
		289,
		287,
		-1,
		-1,
		-1,
		246,
		230,
		-1,
		216,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		251,
		-1,
		251,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		264,
		256,
		264,
		-1,
		236,
		238,
		-1,
		286,
		-1,
		-1,
		279,
		270,
		-1,
		-1,
		241,
		248,
		270,
		273,
		309,
		-1,
		260
	],
	[
		-1,
		88,
		77,
		88,
		96,
		69,
		76,
		-1,
		97,
		99,
		65,
		59,
		98,
		69,
		75,
		86,
		-1,
		-1,
		-1,
		88,
		87,
		57,
		55,
		64,
		69,
		76,
		-1,
		99,
		-1,
		109,
		88,
		99,
		104,
		50,
		47,
		67,
		86,
		92,
		84,
		124,
		80,
		51,
		45,
		63,
		68,
		86,
		78,
		-1,
		51,
		41,
		63,
		67,
		79,
		62,
		-1,
		-1,
		45,
		46,
		52,
		64,
		69,
		74,
		-1,
		100,
		109,
		-1,
		-1,
		35,
		48,
		44,
		47,
		55,
		71,
		92,
		109,
		104,
		-1,
		-1,
		36,
		40,
		53,
		54,
		52,
		79,
		98,
		99,
		113,
		112,
		-1,
		24,
		42,
		51,
		59,
		65,
		55,
		59,
		77,
		98,
		104,
		107,
		-1,
		33,
		34,
		26,
		35,
		42,
		49,
		58,
		64,
		83,
		86,
		105,
		96,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		33,
		16,
		26,
		15,
		8,
		30,
		52,
		61,
		67,
		71,
		78,
		94,
		95,
		105,
		-1,
		-1,
		127,
		100,
		124,
		82,
		63,
		-1,
		29,
		9,
		0,
		4,
		13,
		21,
		49,
		49,
		-1,
		72,
		71,
		102,
		88,
		99,
		109,
		-1,
		-1,
		85,
		77,
		59,
		62,
		39,
		35,
		24,
		23,
		13,
		17,
		23,
		24,
		39,
		39,
		49,
		66,
		76,
		80,
		95,
		106,
		-1,
		-1,
		180,
		-1,
		-1,
		106,
		89,
		-1,
		54,
		61,
		45,
		51,
		37,
		58,
		34,
		22,
		29,
		38,
		26,
		34,
		31,
		55,
		51,
		63,
		88,
		92,
		98,
		116,
		117,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		61,
		58,
		51,
		75,
		74,
		-1,
		71,
		59,
		60,
		45,
		49,
		47,
		32,
		39,
		37,
		52,
		54,
		70,
		72,
		105,
		100,
		121,
		118,
		149,
		155,
		149,
		158,
		-1,
		114,
		110,
		106,
		113,
		62,
		-1,
		-1,
		79,
		-1,
		82,
		95,
		83,
		56,
		59,
		46,
		54,
		54,
		38,
		45,
		40,
		43,
		63,
		76,
		83,
		97,
		96,
		114,
		127,
		142,
		146,
		152,
		-1,
		164,
		-1,
		106,
		90,
		92,
		68,
		96,
		-1,
		99,
		83,
		100,
		85,
		85,
		-1,
		62,
		59,
		69,
		54,
		39,
		56,
		47,
		51,
		62,
		83,
		100,
		91,
		109,
		116,
		124,
		128,
		148,
		160,
		124,
		114,
		-1,
		96,
		101,
		71,
		83,
		106,
		126,
		110,
		-1,
		96,
		-1,
		64,
		77,
		-1,
		60,
		56,
		45,
		61,
		58,
		65,
		69,
		82,
		79,
		97,
		100,
		117,
		121,
		137,
		-1,
		-1,
		109,
		113,
		121,
		72,
		91,
		115,
		152,
		114,
		103,
		102,
		-1,
		82,
		81,
		78,
		79,
		65,
		58,
		59,
		64,
		70,
		77,
		81,
		84,
		106,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		98,
		69,
		93,
		135,
		132,
		125,
		113,
		121,
		119,
		106,
		-1,
		96,
		75,
		72,
		63,
		71,
		85,
		82,
		96,
		85,
		87,
		103,
		115,
		106,
		126,
		-1,
		-1,
		-1,
		128,
		117,
		118,
		72,
		106,
		124,
		154,
		140,
		145,
		120,
		108,
		113,
		90,
		92,
		87,
		81,
		73,
		62,
		78,
		86,
		87,
		87,
		96,
		97,
		121,
		128,
		134,
		-1,
		-1,
		135,
		125,
		109,
		111,
		108,
		97,
		104,
		136,
		145,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		75,
		69,
		78,
		92,
		101,
		92,
		106,
		126,
		126,
		118,
		143,
		146,
		-1,
		-1,
		-1,
		128,
		145,
		120,
		97,
		78,
		114,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		79,
		83,
		76,
		83,
		79,
		93,
		104,
		91,
		127,
		-1,
		126,
		120,
		143,
		133,
		121,
		-1,
		-1,
		-1,
		143,
		122,
		115,
		135,
		85,
		137,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		88,
		86,
		80,
		84,
		88,
		77,
		90,
		95,
		96,
		106,
		126,
		130,
		134,
		123,
		119,
		116,
		130,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		105,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		108,
		92,
		95,
		95,
		91,
		99,
		84,
		87,
		99,
		103,
		121,
		129,
		121,
		115,
		114,
		126,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		120,
		-1,
		91,
		115,
		131,
		-1,
		136,
		115,
		130,
		108,
		104,
		100,
		115,
		116,
		94,
		99,
		98,
		108,
		109,
		98,
		111,
		103,
		125,
		125,
		109,
		110,
		119,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		94,
		98,
		118,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		114,
		112,
		105,
		96,
		102,
		109,
		112,
		113,
		103,
		92,
		98,
		97,
		119,
		105,
		103,
		122,
		138,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		113,
		97,
		102,
		-1,
		138,
		-1,
		111,
		113,
		105,
		94,
		91,
		102,
		100,
		111,
		128,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		151,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		129,
		109,
		103,
		102,
		133,
		131,
		119,
		103,
		96,
		93,
		94,
		107,
		127,
		118,
		130,
		-1,
		-1,
		-1,
		152,
		132,
		138,
		96,
		117,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		146,
		134,
		124,
		114,
		148,
		147,
		122,
		115,
		101,
		103,
		101,
		103,
		108,
		129,
		130,
		143,
		-1,
		-1,
		129,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		135,
		-1,
		-1,
		126,
		124,
		134,
		118,
		105,
		125,
		128,
		118,
		102,
		117,
		129,
		137,
		142,
		-1,
		132,
		119,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		157,
		159,
		163,
		129,
		-1,
		134,
		129,
		109,
		123,
		130,
		120,
		115,
		109,
		112,
		130,
		147,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		136,
		150,
		152,
		145,
		149,
		-1,
		137,
		125,
		111,
		128,
		133,
		130,
		121,
		113,
		118,
		115,
		128,
		142,
		146,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		154,
		169,
		191,
		168,
		141,
		136,
		129,
		123,
		119,
		135,
		141,
		152,
		120,
		116,
		117,
		121,
		120,
		137,
		147,
		-1,
		-1,
		152,
		169,
		180,
		162,
		166,
		218,
		-1,
		-1,
		145,
		136,
		127,
		130,
		129,
		132,
		126,
		123,
		128,
		133,
		121,
		130,
		148,
		147,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		181,
		216,
		163,
		145,
		141,
		139,
		132,
		141,
		136,
		131,
		141,
		143,
		135,
		123,
		127,
		150,
		139,
		178,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		201,
		176,
		191,
		227,
		201,
		208,
		178,
		175,
		-1,
		145,
		170,
		142,
		149,
		140,
		147,
		147,
		139,
		117,
		124,
		140,
		139,
		134,
		170,
		161,
		167,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		207,
		193,
		213,
		203,
		206,
		-1,
		-1,
		194,
		191,
		167,
		150,
		148,
		141,
		136,
		146,
		126,
		113,
		117,
		121,
		127,
		132,
		137,
		143,
		158,
		173,
		-1,
		177,
		258,
		251,
		234,
		242,
		273,
		-1,
		210,
		209,
		200,
		195,
		197,
		-1,
		-1,
		167,
		164,
		169,
		157,
		154,
		156,
		151,
		142,
		127,
		133,
		120,
		119,
		137,
		141,
		150,
		157,
		147,
		160,
		164,
		-1,
		191,
		234,
		228,
		231,
		255,
		269,
		-1,
		214,
		-1,
		-1,
		208,
		198,
		182,
		172,
		166,
		216,
		171,
		166,
		150,
		148,
		139,
		130,
		137,
		128,
		128,
		131,
		146,
		151,
		143,
		157,
		157,
		158,
		-1,
		226,
		214,
		222,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		224,
		-1,
		209,
		-1,
		184,
		188,
		179,
		182,
		164,
		151,
		143,
		135,
		151,
		126,
		136,
		132,
		133,
		142,
		153,
		165,
		164,
		165,
		285,
		241,
		222,
		213,
		260,
		275,
		279,
		-1,
		226,
		265,
		262,
		-1,
		233,
		-1,
		-1,
		-1,
		198,
		192,
		184,
		184,
		163,
		163,
		137,
		141,
		131,
		138,
		148,
		150,
		142,
		146,
		159,
		170,
		173,
		281,
		272,
		285,
		230,
		227,
		245,
		254,
		275,
		241,
		232,
		259,
		269,
		258,
		253,
		240,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		170,
		158,
		141,
		142,
		138,
		141,
		156,
		159,
		149,
		147,
		141,
		173,
		-1,
		274,
		273,
		262,
		259,
		235,
		226,
		221,
		246,
		-1,
		-1,
		243,
		260,
		254,
		258,
		274,
		299,
		-1,
		230,
		-1,
		-1,
		215,
		-1,
		-1,
		200,
		163,
		152,
		143,
		149,
		146,
		157,
		167,
		155,
		156,
		146,
		156,
		169,
		258,
		255,
		243,
		241,
		264,
		229,
		217,
		-1,
		230,
		228,
		234,
		241,
		258,
		288,
		-1,
		-1,
		246,
		226,
		-1,
		-1,
		198,
		196,
		185,
		-1,
		175,
		148,
		153,
		173,
		175,
		164,
		158,
		152,
		159,
		158,
		166,
		174,
		267,
		281,
		270,
		266,
		265,
		273,
		222,
		215,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		236,
		232,
		-1,
		-1,
		193,
		186,
		174,
		162,
		152,
		162,
		166,
		170,
		162,
		155,
		150,
		161,
		153,
		157,
		174,
		-1,
		301,
		-1,
		253,
		229,
		243,
		258,
		266,
		-1,
		-1,
		-1,
		253,
		239,
		232,
		220,
		218,
		-1,
		227,
		211,
		192,
		-1,
		162,
		175,
		206,
		174,
		179,
		174,
		156,
		167,
		156,
		159,
		173,
		168,
		-1,
		-1,
		241,
		244,
		-1,
		-1,
		243,
		245,
		-1,
		244,
		233,
		218,
		210,
		-1,
		-1,
		199,
		195,
		-1,
		-1,
		163,
		188,
		177,
		185,
		180,
		160,
		166,
		169,
		158,
		162,
		174,
		-1,
		-1,
		248,
		249,
		250,
		-1,
		228,
		-1,
		246,
		-1,
		213,
		219,
		207,
		-1,
		-1,
		-1,
		201,
		164,
		185,
		195,
		189,
		187,
		178,
		164,
		171,
		169,
		165,
		176,
		-1,
		-1,
		-1,
		246,
		220,
		253,
		244,
		227,
		207,
		199,
		218,
		-1,
		188,
		-1,
		163,
		165,
		191,
		194,
		200,
		194,
		167,
		182,
		172,
		163,
		172,
		252,
		-1,
		222,
		255,
		219,
		213,
		189,
		193,
		209,
		-1,
		185,
		167,
		-1,
		195,
		185,
		216,
		201,
		182,
		169,
		176,
		176,
		169,
		-1,
		-1,
		-1,
		224,
		223,
		215,
		209,
		209,
		194,
		185,
		-1,
		197,
		179,
		158,
		175,
		175,
		166,
		174,
		206,
		202,
		189,
		189,
		181,
		-1,
		325,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		218,
		213,
		186,
		174,
		180,
		176,
		162,
		168,
		170,
		178,
		176,
		173,
		185,
		181,
		201,
		182,
		217,
		-1,
		320,
		-1,
		254,
		-1,
		-1,
		236,
		216,
		208,
		197,
		186,
		184,
		175,
		166,
		188,
		204,
		188,
		186,
		189,
		190,
		-1,
		309,
		308,
		-1,
		255,
		247,
		233,
		-1,
		226,
		-1,
		232,
		193,
		-1,
		195,
		175,
		-1,
		197,
		193,
		-1,
		-1,
		296,
		271,
		-1,
		-1,
		-1,
		256,
		236,
		227,
		211,
		-1,
		186,
		186,
		-1,
		-1,
		-1,
		281,
		280,
		-1,
		249,
		252,
		-1,
		242,
		233,
		241,
		188,
		192,
		-1,
		-1,
		-1,
		290,
		271,
		265,
		264,
		262,
		257,
		254,
		240,
		224,
		202,
		191,
		212,
		-1,
		-1,
		-1,
		262,
		254,
		247,
		-1,
		-1,
		249,
		232,
		213,
		211,
		-1,
		-1,
		-1,
		284,
		265,
		-1,
		-1,
		239,
		-1,
		-1,
		245,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		273,
		-1,
		-1,
		-1,
		235,
		231,
		232,
		-1,
		-1,
		-1,
		-1,
		295,
		296,
		319,
		283,
		-1,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		298,
		296,
		-1,
		-1,
		-1,
		255,
		239,
		-1,
		225,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		260,
		-1,
		260,
		235,
		242,
		-1,
		-1,
		-1,
		-1,
		273,
		265,
		273,
		-1,
		245,
		247,
		-1,
		295,
		-1,
		-1,
		288,
		279,
		-1,
		-1,
		250,
		257,
		279,
		282,
		318,
		-1,
		269
	],
	[
		-1,
		92,
		81,
		92,
		100,
		73,
		80,
		-1,
		101,
		103,
		69,
		63,
		102,
		73,
		79,
		90,
		-1,
		-1,
		-1,
		92,
		91,
		61,
		59,
		68,
		73,
		80,
		-1,
		103,
		-1,
		113,
		92,
		103,
		108,
		54,
		51,
		71,
		90,
		96,
		88,
		128,
		84,
		55,
		49,
		67,
		72,
		90,
		82,
		-1,
		55,
		45,
		67,
		71,
		83,
		66,
		-1,
		-1,
		49,
		50,
		56,
		68,
		73,
		78,
		-1,
		104,
		105,
		-1,
		-1,
		39,
		52,
		48,
		51,
		59,
		75,
		96,
		105,
		100,
		-1,
		-1,
		40,
		44,
		57,
		58,
		56,
		83,
		102,
		95,
		109,
		108,
		-1,
		28,
		46,
		50,
		55,
		61,
		59,
		63,
		81,
		94,
		100,
		103,
		-1,
		37,
		38,
		25,
		33,
		38,
		45,
		62,
		68,
		87,
		82,
		101,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		37,
		20,
		30,
		19,
		4,
		26,
		48,
		58,
		71,
		75,
		74,
		90,
		91,
		101,
		-1,
		-1,
		131,
		104,
		128,
		86,
		67,
		-1,
		33,
		13,
		4,
		0,
		9,
		17,
		45,
		45,
		-1,
		68,
		67,
		98,
		84,
		95,
		113,
		-1,
		-1,
		89,
		81,
		63,
		66,
		43,
		39,
		28,
		27,
		17,
		21,
		27,
		20,
		35,
		35,
		45,
		62,
		72,
		76,
		91,
		102,
		-1,
		-1,
		176,
		-1,
		-1,
		110,
		93,
		-1,
		58,
		65,
		49,
		55,
		41,
		62,
		38,
		26,
		33,
		42,
		30,
		30,
		27,
		51,
		47,
		59,
		84,
		88,
		94,
		112,
		113,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		65,
		62,
		55,
		79,
		78,
		-1,
		75,
		63,
		64,
		49,
		53,
		51,
		36,
		35,
		33,
		48,
		50,
		66,
		68,
		101,
		96,
		117,
		114,
		145,
		151,
		145,
		154,
		-1,
		118,
		114,
		110,
		117,
		66,
		-1,
		-1,
		83,
		-1,
		86,
		99,
		87,
		60,
		63,
		50,
		58,
		58,
		42,
		41,
		36,
		39,
		59,
		72,
		79,
		93,
		92,
		110,
		123,
		138,
		142,
		148,
		-1,
		168,
		-1,
		110,
		94,
		96,
		72,
		100,
		-1,
		103,
		87,
		104,
		89,
		89,
		-1,
		66,
		63,
		73,
		58,
		43,
		54,
		43,
		47,
		58,
		79,
		96,
		87,
		105,
		112,
		120,
		124,
		144,
		156,
		128,
		118,
		-1,
		100,
		105,
		75,
		87,
		110,
		130,
		114,
		-1,
		100,
		-1,
		68,
		81,
		-1,
		64,
		60,
		49,
		65,
		54,
		61,
		65,
		78,
		75,
		93,
		96,
		113,
		117,
		133,
		-1,
		-1,
		113,
		117,
		125,
		76,
		95,
		119,
		156,
		118,
		107,
		106,
		-1,
		86,
		85,
		82,
		83,
		69,
		62,
		63,
		60,
		66,
		75,
		77,
		80,
		102,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		102,
		73,
		97,
		139,
		136,
		129,
		117,
		125,
		123,
		110,
		-1,
		100,
		79,
		76,
		67,
		67,
		83,
		78,
		94,
		81,
		83,
		99,
		111,
		102,
		122,
		-1,
		-1,
		-1,
		132,
		121,
		122,
		76,
		110,
		128,
		158,
		144,
		149,
		124,
		112,
		116,
		94,
		96,
		91,
		84,
		76,
		65,
		81,
		88,
		83,
		83,
		92,
		93,
		117,
		124,
		130,
		-1,
		-1,
		139,
		129,
		113,
		115,
		112,
		101,
		108,
		140,
		149,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		89,
		97,
		88,
		103,
		122,
		122,
		114,
		139,
		142,
		-1,
		-1,
		-1,
		132,
		149,
		124,
		101,
		82,
		118,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		82,
		96,
		107,
		89,
		125,
		-1,
		122,
		116,
		144,
		136,
		124,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		89,
		141,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		91,
		80,
		93,
		98,
		94,
		104,
		124,
		128,
		135,
		126,
		122,
		119,
		133,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		109,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		98,
		94,
		102,
		87,
		90,
		97,
		101,
		119,
		132,
		124,
		118,
		117,
		129,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		124,
		-1,
		95,
		119,
		135,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		102,
		101,
		111,
		112,
		101,
		109,
		106,
		128,
		128,
		112,
		113,
		122,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		98,
		101,
		122,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		112,
		115,
		116,
		106,
		95,
		101,
		100,
		122,
		108,
		106,
		125,
		141,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		116,
		100,
		105,
		-1,
		141,
		-1,
		114,
		116,
		108,
		97,
		94,
		105,
		103,
		114,
		131,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		155,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		132,
		112,
		106,
		105,
		136,
		134,
		122,
		106,
		99,
		96,
		97,
		110,
		130,
		121,
		133,
		-1,
		-1,
		-1,
		156,
		136,
		142,
		100,
		121,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		149,
		137,
		127,
		117,
		151,
		150,
		125,
		118,
		104,
		106,
		104,
		106,
		111,
		132,
		133,
		146,
		-1,
		-1,
		133,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		138,
		-1,
		-1,
		129,
		127,
		137,
		121,
		108,
		128,
		131,
		121,
		105,
		120,
		132,
		140,
		145,
		-1,
		136,
		123,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		160,
		162,
		166,
		132,
		-1,
		137,
		132,
		112,
		126,
		133,
		123,
		118,
		112,
		115,
		133,
		150,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		139,
		153,
		155,
		148,
		152,
		-1,
		140,
		128,
		114,
		131,
		136,
		133,
		124,
		116,
		121,
		118,
		131,
		145,
		149,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		157,
		172,
		194,
		171,
		144,
		139,
		132,
		126,
		122,
		138,
		144,
		155,
		123,
		119,
		120,
		124,
		123,
		140,
		150,
		-1,
		-1,
		156,
		173,
		183,
		165,
		169,
		221,
		-1,
		-1,
		148,
		139,
		130,
		133,
		132,
		135,
		129,
		126,
		131,
		136,
		124,
		133,
		151,
		150,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		184,
		219,
		166,
		148,
		144,
		142,
		135,
		144,
		139,
		134,
		144,
		146,
		138,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		205,
		180,
		195,
		230,
		204,
		211,
		181,
		178,
		-1,
		148,
		173,
		145,
		152,
		143,
		150,
		150,
		142,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		211,
		197,
		216,
		206,
		209,
		-1,
		-1,
		197,
		194,
		170,
		153,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		214,
		212,
		204,
		198,
		200,
		-1,
		-1,
		170,
		167,
		172,
		160,
		157,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		217,
		-1,
		-1,
		212,
		201,
		185,
		175,
		169,
		219,
		174,
		169,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		228,
		-1,
		212,
		-1,
		187,
		191,
		182,
		185,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		288,
		244,
		226,
		217,
		264,
		279,
		283,
		-1,
		229,
		268,
		266,
		-1,
		237,
		-1,
		-1,
		-1,
		201,
		195,
		187,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		284,
		275,
		288,
		233,
		231,
		249,
		258,
		279,
		244,
		235,
		262,
		273,
		262,
		257,
		244,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		224,
		250,
		-1,
		-1,
		246,
		263,
		257,
		261,
		277,
		302,
		-1,
		233,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		261,
		258,
		246,
		244,
		267,
		232,
		220,
		-1,
		233,
		231,
		237,
		244,
		261,
		291,
		-1,
		-1,
		249,
		229,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		218,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		235,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		304,
		-1,
		256,
		232,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		251,
		252,
		253,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		95,
		84,
		95,
		103,
		76,
		83,
		-1,
		104,
		106,
		72,
		66,
		105,
		76,
		82,
		93,
		-1,
		-1,
		-1,
		95,
		94,
		64,
		62,
		71,
		76,
		83,
		-1,
		106,
		-1,
		116,
		95,
		106,
		111,
		57,
		54,
		74,
		93,
		99,
		91,
		131,
		87,
		58,
		52,
		70,
		75,
		93,
		85,
		-1,
		58,
		48,
		70,
		74,
		86,
		69,
		-1,
		-1,
		52,
		53,
		59,
		71,
		76,
		78,
		-1,
		99,
		96,
		-1,
		-1,
		42,
		55,
		51,
		54,
		62,
		73,
		91,
		96,
		91,
		-1,
		-1,
		43,
		47,
		53,
		61,
		59,
		78,
		97,
		86,
		100,
		99,
		-1,
		31,
		45,
		41,
		46,
		52,
		54,
		58,
		76,
		85,
		91,
		94,
		-1,
		40,
		41,
		16,
		24,
		29,
		36,
		53,
		63,
		80,
		73,
		92,
		83,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		40,
		23,
		30,
		12,
		2,
		17,
		39,
		49,
		66,
		68,
		65,
		81,
		82,
		92,
		-1,
		-1,
		134,
		107,
		131,
		89,
		70,
		-1,
		36,
		16,
		10,
		6,
		0,
		8,
		36,
		36,
		-1,
		59,
		58,
		89,
		75,
		86,
		116,
		-1,
		-1,
		92,
		84,
		66,
		69,
		46,
		42,
		31,
		30,
		23,
		27,
		27,
		11,
		26,
		26,
		36,
		53,
		63,
		67,
		82,
		93,
		-1,
		-1,
		167,
		-1,
		-1,
		113,
		96,
		-1,
		61,
		68,
		52,
		58,
		44,
		65,
		41,
		32,
		39,
		41,
		30,
		21,
		18,
		42,
		38,
		50,
		75,
		79,
		85,
		103,
		104,
		-1,
		166,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		68,
		65,
		58,
		82,
		81,
		-1,
		76,
		64,
		65,
		50,
		49,
		50,
		36,
		26,
		24,
		39,
		41,
		57,
		59,
		92,
		87,
		108,
		105,
		136,
		142,
		136,
		145,
		-1,
		121,
		117,
		113,
		120,
		69,
		-1,
		-1,
		86,
		-1,
		89,
		102,
		88,
		61,
		64,
		51,
		59,
		57,
		42,
		32,
		27,
		30,
		50,
		63,
		70,
		84,
		83,
		101,
		114,
		129,
		133,
		139,
		-1,
		171,
		-1,
		113,
		97,
		99,
		75,
		103,
		-1,
		106,
		90,
		105,
		90,
		90,
		-1,
		67,
		64,
		74,
		59,
		44,
		45,
		34,
		38,
		49,
		70,
		87,
		78,
		96,
		103,
		111,
		115,
		135,
		147,
		131,
		121,
		-1,
		103,
		108,
		78,
		90,
		113,
		133,
		117,
		-1,
		101,
		-1,
		69,
		82,
		-1,
		65,
		61,
		50,
		56,
		45,
		52,
		56,
		69,
		66,
		84,
		87,
		104,
		108,
		124,
		-1,
		-1,
		116,
		120,
		128,
		79,
		98,
		122,
		159,
		119,
		108,
		107,
		-1,
		87,
		86,
		83,
		84,
		70,
		63,
		64,
		51,
		57,
		66,
		68,
		71,
		93,
		121,
		99,
		111,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		105,
		76,
		100,
		142,
		137,
		130,
		118,
		121,
		121,
		111,
		-1,
		101,
		80,
		77,
		68,
		58,
		74,
		69,
		85,
		72,
		74,
		90,
		102,
		93,
		113,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		79,
		113,
		131,
		154,
		140,
		145,
		120,
		113,
		107,
		95,
		97,
		86,
		75,
		67,
		56,
		72,
		79,
		74,
		74,
		83,
		84,
		108,
		115,
		121,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		104,
		111,
		143,
		145,
		158,
		-1,
		112,
		-1,
		101,
		96,
		80,
		75,
		72,
		69,
		63,
		72,
		80,
		88,
		79,
		94,
		113,
		113,
		105,
		130,
		133,
		-1,
		-1,
		-1,
		135,
		152,
		127,
		104,
		85,
		121,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		82,
		78,
		73,
		77,
		70,
		77,
		73,
		87,
		98,
		80,
		116,
		-1,
		113,
		107,
		135,
		127,
		115,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		92,
		144,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		82,
		80,
		74,
		78,
		82,
		71,
		84,
		89,
		85,
		95,
		115,
		119,
		126,
		117,
		113,
		110,
		124,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		112,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		102,
		86,
		89,
		89,
		85,
		93,
		78,
		81,
		88,
		92,
		110,
		123,
		115,
		109,
		108,
		120,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		127,
		-1,
		98,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		94,
		109,
		110,
		88,
		93,
		92,
		102,
		103,
		92,
		100,
		97,
		119,
		119,
		103,
		104,
		113,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		101,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		108,
		106,
		99,
		90,
		96,
		103,
		106,
		107,
		97,
		86,
		92,
		91,
		113,
		99,
		97,
		116,
		132,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		107,
		91,
		96,
		-1,
		132,
		-1,
		105,
		107,
		99,
		88,
		85,
		96,
		94,
		105,
		122,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		158,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		123,
		103,
		97,
		96,
		127,
		125,
		113,
		97,
		90,
		87,
		88,
		101,
		121,
		112,
		124,
		-1,
		-1,
		-1,
		158,
		139,
		145,
		103,
		124,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		140,
		128,
		118,
		108,
		142,
		141,
		116,
		109,
		95,
		97,
		95,
		97,
		102,
		123,
		124,
		137,
		-1,
		-1,
		136,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		129,
		-1,
		-1,
		120,
		118,
		128,
		112,
		99,
		119,
		122,
		112,
		96,
		111,
		123,
		131,
		136,
		-1,
		139,
		126,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		151,
		153,
		157,
		123,
		-1,
		128,
		123,
		103,
		117,
		124,
		114,
		109,
		103,
		106,
		124,
		141,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		130,
		144,
		146,
		139,
		143,
		-1,
		131,
		119,
		105,
		122,
		127,
		124,
		115,
		107,
		112,
		109,
		122,
		136,
		140,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		148,
		163,
		185,
		162,
		135,
		130,
		123,
		117,
		113,
		129,
		135,
		146,
		114,
		110,
		111,
		115,
		114,
		131,
		141,
		-1,
		-1,
		159,
		176,
		174,
		156,
		160,
		212,
		-1,
		-1,
		139,
		130,
		121,
		124,
		123,
		126,
		120,
		117,
		122,
		127,
		115,
		124,
		142,
		141,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		175,
		210,
		157,
		139,
		135,
		133,
		126,
		135,
		130,
		125,
		135,
		137,
		129,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		221,
		195,
		202,
		172,
		169,
		-1,
		139,
		164,
		136,
		143,
		134,
		141,
		141,
		133,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		214,
		200,
		207,
		197,
		200,
		-1,
		-1,
		188,
		185,
		161,
		144,
		142,
		135,
		130,
		140,
		120,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		211,
		203,
		207,
		189,
		191,
		-1,
		-1,
		161,
		158,
		163,
		151,
		148,
		150,
		145,
		136,
		121,
		127,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		208,
		-1,
		-1,
		215,
		192,
		176,
		166,
		160,
		210,
		165,
		160,
		144,
		142,
		133,
		124,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		231,
		-1,
		203,
		-1,
		178,
		182,
		173,
		176,
		158,
		145,
		137,
		129,
		145,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		279,
		235,
		229,
		220,
		260,
		275,
		279,
		-1,
		220,
		259,
		257,
		-1,
		240,
		-1,
		-1,
		-1,
		192,
		186,
		178,
		178,
		157,
		157,
		131,
		135,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		275,
		266,
		279,
		224,
		224,
		245,
		254,
		275,
		235,
		226,
		253,
		264,
		253,
		248,
		235,
		-1,
		-1,
		215,
		196,
		-1,
		-1,
		164,
		152,
		135,
		136,
		132,
		135,
		150,
		153,
		143,
		141,
		135,
		167,
		-1,
		268,
		267,
		256,
		253,
		229,
		220,
		215,
		242,
		-1,
		-1,
		237,
		254,
		248,
		252,
		268,
		293,
		-1,
		224,
		-1,
		-1,
		209,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		140,
		151,
		161,
		149,
		150,
		140,
		150,
		163,
		252,
		249,
		237,
		235,
		258,
		223,
		211,
		-1,
		224,
		222,
		228,
		235,
		252,
		282,
		-1,
		-1,
		240,
		220,
		-1,
		-1,
		192,
		190,
		179,
		-1,
		169,
		142,
		147,
		167,
		169,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		261,
		275,
		264,
		260,
		259,
		267,
		216,
		209,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		226,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		160,
		164,
		156,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		295,
		-1,
		247,
		223,
		237,
		252,
		260,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		235,
		238,
		-1,
		-1,
		237,
		239,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		242,
		243,
		244,
		-1,
		222,
		-1,
		240,
		-1,
		207,
		213,
		201,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		183,
		181,
		172,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		240,
		214,
		247,
		238,
		221,
		201,
		193,
		212,
		-1,
		182,
		-1,
		157,
		159,
		185,
		188,
		194,
		188,
		161,
		176,
		166,
		157,
		166,
		246,
		-1,
		216,
		249,
		213,
		207,
		183,
		187,
		203,
		-1,
		179,
		161,
		-1,
		189,
		179,
		210,
		195,
		176,
		163,
		170,
		170,
		163,
		-1,
		-1,
		-1,
		218,
		217,
		209,
		203,
		203,
		188,
		179,
		-1,
		191,
		173,
		152,
		169,
		169,
		160,
		168,
		200,
		196,
		183,
		183,
		175,
		-1,
		319,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		212,
		207,
		180,
		168,
		174,
		170,
		156,
		162,
		164,
		172,
		170,
		167,
		179,
		175,
		195,
		176,
		211,
		-1,
		314,
		-1,
		248,
		-1,
		-1,
		230,
		210,
		202,
		191,
		180,
		178,
		169,
		160,
		182,
		198,
		182,
		180,
		183,
		184,
		-1,
		303,
		302,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		226,
		187,
		-1,
		189,
		169,
		-1,
		191,
		187,
		-1,
		-1,
		290,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		221,
		205,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		275,
		274,
		-1,
		243,
		246,
		-1,
		236,
		227,
		235,
		182,
		186,
		-1,
		-1,
		-1,
		284,
		265,
		259,
		258,
		256,
		251,
		248,
		234,
		218,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		256,
		248,
		241,
		-1,
		-1,
		243,
		226,
		207,
		205,
		-1,
		-1,
		-1,
		278,
		259,
		-1,
		-1,
		233,
		-1,
		-1,
		239,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		267,
		-1,
		-1,
		-1,
		229,
		225,
		226,
		-1,
		-1,
		-1,
		-1,
		289,
		290,
		313,
		277,
		-1,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		292,
		290,
		-1,
		-1,
		-1,
		249,
		233,
		-1,
		219,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		254,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		267,
		259,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		282,
		273,
		-1,
		-1,
		244,
		251,
		273,
		276,
		312,
		-1,
		263
	],
	[
		-1,
		104,
		93,
		104,
		112,
		85,
		92,
		-1,
		113,
		115,
		81,
		75,
		114,
		85,
		91,
		102,
		-1,
		-1,
		-1,
		104,
		103,
		73,
		71,
		80,
		85,
		92,
		-1,
		115,
		-1,
		125,
		104,
		115,
		120,
		66,
		63,
		83,
		102,
		108,
		100,
		140,
		96,
		67,
		61,
		79,
		84,
		102,
		94,
		-1,
		67,
		57,
		79,
		83,
		95,
		78,
		-1,
		-1,
		61,
		62,
		68,
		80,
		85,
		85,
		-1,
		95,
		89,
		-1,
		-1,
		51,
		64,
		60,
		63,
		71,
		74,
		87,
		89,
		84,
		-1,
		-1,
		52,
		56,
		62,
		61,
		57,
		74,
		93,
		79,
		93,
		92,
		-1,
		40,
		54,
		50,
		55,
		61,
		50,
		54,
		72,
		78,
		84,
		87,
		-1,
		49,
		50,
		25,
		33,
		38,
		45,
		46,
		59,
		73,
		66,
		85,
		76,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		49,
		32,
		39,
		21,
		11,
		26,
		36,
		42,
		62,
		61,
		58,
		74,
		75,
		85,
		-1,
		-1,
		143,
		116,
		140,
		98,
		79,
		-1,
		45,
		25,
		19,
		15,
		9,
		0,
		33,
		29,
		-1,
		52,
		51,
		82,
		68,
		79,
		125,
		-1,
		-1,
		101,
		93,
		75,
		78,
		55,
		51,
		40,
		39,
		32,
		36,
		32,
		3,
		19,
		19,
		29,
		46,
		56,
		60,
		75,
		86,
		-1,
		-1,
		160,
		-1,
		-1,
		122,
		105,
		-1,
		70,
		77,
		61,
		67,
		53,
		74,
		50,
		41,
		46,
		46,
		35,
		14,
		11,
		35,
		31,
		43,
		68,
		72,
		78,
		96,
		97,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		77,
		74,
		67,
		91,
		90,
		-1,
		81,
		69,
		70,
		55,
		54,
		55,
		41,
		19,
		17,
		32,
		34,
		50,
		52,
		85,
		80,
		101,
		98,
		129,
		135,
		129,
		138,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		95,
		-1,
		98,
		111,
		93,
		66,
		69,
		56,
		64,
		61,
		43,
		25,
		20,
		23,
		43,
		56,
		63,
		77,
		76,
		94,
		107,
		122,
		126,
		132,
		-1,
		180,
		-1,
		122,
		106,
		108,
		84,
		112,
		-1,
		115,
		99,
		110,
		95,
		95,
		-1,
		72,
		69,
		79,
		57,
		42,
		38,
		27,
		31,
		42,
		63,
		80,
		71,
		89,
		96,
		104,
		108,
		128,
		140,
		140,
		130,
		-1,
		112,
		117,
		87,
		99,
		122,
		142,
		126,
		-1,
		106,
		-1,
		74,
		87,
		-1,
		63,
		59,
		48,
		49,
		38,
		45,
		49,
		62,
		59,
		77,
		80,
		97,
		101,
		117,
		-1,
		-1,
		125,
		129,
		137,
		88,
		107,
		131,
		168,
		124,
		113,
		112,
		-1,
		92,
		82,
		79,
		80,
		67,
		61,
		61,
		44,
		50,
		59,
		61,
		64,
		86,
		114,
		92,
		104,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		114,
		85,
		109,
		151,
		142,
		135,
		123,
		114,
		114,
		108,
		-1,
		98,
		77,
		72,
		61,
		51,
		67,
		62,
		78,
		65,
		67,
		83,
		95,
		86,
		106,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		88,
		122,
		140,
		147,
		133,
		138,
		113,
		106,
		100,
		91,
		94,
		79,
		68,
		60,
		49,
		65,
		72,
		67,
		67,
		76,
		77,
		101,
		108,
		114,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		113,
		120,
		152,
		138,
		151,
		-1,
		105,
		-1,
		94,
		89,
		73,
		68,
		65,
		62,
		56,
		65,
		73,
		81,
		72,
		87,
		106,
		106,
		98,
		123,
		126,
		-1,
		-1,
		-1,
		144,
		161,
		136,
		113,
		94,
		130,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		75,
		71,
		66,
		70,
		63,
		70,
		66,
		80,
		91,
		73,
		109,
		-1,
		106,
		100,
		128,
		120,
		108,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		101,
		153,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		75,
		73,
		67,
		71,
		75,
		64,
		77,
		82,
		78,
		88,
		108,
		112,
		119,
		110,
		106,
		103,
		117,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		121,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		95,
		79,
		82,
		82,
		78,
		86,
		71,
		74,
		81,
		85,
		103,
		116,
		108,
		102,
		101,
		113,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		87,
		102,
		103,
		81,
		86,
		85,
		95,
		96,
		85,
		93,
		90,
		112,
		112,
		96,
		97,
		106,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		101,
		99,
		92,
		83,
		89,
		96,
		99,
		100,
		90,
		79,
		85,
		84,
		106,
		92,
		90,
		109,
		125,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		100,
		84,
		89,
		-1,
		125,
		-1,
		98,
		100,
		92,
		81,
		78,
		89,
		87,
		98,
		115,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		116,
		96,
		90,
		89,
		120,
		118,
		106,
		90,
		83,
		80,
		81,
		94,
		114,
		105,
		117,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		133,
		121,
		111,
		101,
		135,
		134,
		109,
		102,
		88,
		90,
		88,
		90,
		95,
		116,
		117,
		130,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		122,
		-1,
		-1,
		113,
		111,
		121,
		105,
		92,
		112,
		115,
		105,
		89,
		104,
		116,
		124,
		129,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		144,
		146,
		150,
		116,
		-1,
		121,
		116,
		96,
		110,
		117,
		107,
		102,
		96,
		99,
		117,
		134,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		123,
		137,
		139,
		132,
		136,
		-1,
		124,
		112,
		98,
		115,
		120,
		117,
		108,
		100,
		105,
		102,
		115,
		129,
		133,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		141,
		156,
		178,
		155,
		128,
		123,
		116,
		110,
		106,
		122,
		128,
		139,
		107,
		103,
		104,
		108,
		107,
		124,
		134,
		-1,
		-1,
		155,
		172,
		167,
		149,
		153,
		205,
		-1,
		-1,
		132,
		123,
		114,
		117,
		116,
		119,
		113,
		110,
		115,
		120,
		108,
		117,
		135,
		134,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		168,
		203,
		150,
		132,
		128,
		126,
		119,
		128,
		123,
		118,
		128,
		130,
		122,
		110,
		114,
		137,
		126,
		165,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		204,
		179,
		194,
		214,
		188,
		195,
		165,
		162,
		-1,
		132,
		157,
		129,
		136,
		127,
		134,
		134,
		126,
		104,
		111,
		127,
		126,
		121,
		157,
		148,
		154,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		210,
		196,
		200,
		190,
		193,
		-1,
		-1,
		181,
		178,
		154,
		137,
		135,
		128,
		123,
		133,
		113,
		100,
		104,
		108,
		114,
		119,
		124,
		130,
		145,
		160,
		-1,
		182,
		263,
		256,
		239,
		247,
		278,
		-1,
		204,
		196,
		203,
		182,
		184,
		-1,
		-1,
		154,
		151,
		156,
		144,
		141,
		143,
		138,
		129,
		114,
		120,
		107,
		106,
		124,
		128,
		137,
		144,
		134,
		147,
		151,
		-1,
		196,
		239,
		233,
		236,
		260,
		274,
		-1,
		201,
		-1,
		-1,
		211,
		185,
		169,
		159,
		153,
		203,
		158,
		153,
		137,
		135,
		126,
		117,
		124,
		115,
		115,
		118,
		133,
		138,
		130,
		144,
		144,
		145,
		-1,
		231,
		219,
		227,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		227,
		-1,
		196,
		-1,
		171,
		175,
		166,
		169,
		151,
		138,
		130,
		122,
		138,
		113,
		123,
		119,
		120,
		129,
		140,
		152,
		151,
		152,
		272,
		228,
		227,
		218,
		253,
		268,
		272,
		-1,
		213,
		252,
		250,
		-1,
		234,
		-1,
		-1,
		-1,
		185,
		179,
		171,
		171,
		150,
		150,
		124,
		128,
		118,
		125,
		135,
		137,
		129,
		133,
		146,
		157,
		160,
		268,
		259,
		272,
		217,
		217,
		238,
		247,
		268,
		228,
		219,
		246,
		257,
		246,
		241,
		228,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		157,
		145,
		128,
		129,
		125,
		128,
		143,
		146,
		136,
		134,
		128,
		160,
		-1,
		261,
		260,
		249,
		246,
		222,
		213,
		208,
		235,
		-1,
		-1,
		230,
		247,
		241,
		245,
		261,
		286,
		-1,
		217,
		-1,
		-1,
		202,
		-1,
		-1,
		187,
		150,
		139,
		130,
		136,
		133,
		144,
		154,
		142,
		143,
		133,
		143,
		156,
		245,
		242,
		230,
		228,
		251,
		216,
		204,
		-1,
		217,
		215,
		221,
		228,
		245,
		275,
		-1,
		-1,
		233,
		213,
		-1,
		-1,
		185,
		183,
		172,
		-1,
		162,
		135,
		140,
		160,
		162,
		151,
		145,
		139,
		146,
		145,
		153,
		161,
		254,
		268,
		257,
		253,
		252,
		260,
		209,
		202,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		-1,
		223,
		219,
		-1,
		-1,
		180,
		173,
		161,
		149,
		139,
		149,
		153,
		157,
		149,
		142,
		137,
		148,
		140,
		144,
		161,
		-1,
		288,
		-1,
		240,
		216,
		230,
		245,
		253,
		-1,
		-1,
		-1,
		240,
		226,
		219,
		207,
		205,
		-1,
		214,
		198,
		179,
		-1,
		149,
		162,
		193,
		161,
		166,
		161,
		143,
		154,
		143,
		146,
		160,
		155,
		-1,
		-1,
		228,
		231,
		-1,
		-1,
		230,
		232,
		-1,
		231,
		220,
		205,
		197,
		-1,
		-1,
		186,
		182,
		-1,
		-1,
		150,
		175,
		164,
		172,
		167,
		147,
		153,
		156,
		145,
		149,
		161,
		-1,
		-1,
		235,
		236,
		237,
		-1,
		215,
		-1,
		233,
		-1,
		200,
		206,
		194,
		-1,
		-1,
		-1,
		188,
		151,
		172,
		182,
		176,
		174,
		165,
		151,
		158,
		156,
		152,
		163,
		-1,
		-1,
		-1,
		233,
		207,
		240,
		231,
		214,
		194,
		186,
		205,
		-1,
		175,
		-1,
		150,
		152,
		178,
		181,
		187,
		181,
		154,
		169,
		159,
		150,
		159,
		239,
		-1,
		209,
		242,
		206,
		200,
		176,
		180,
		196,
		-1,
		172,
		154,
		-1,
		182,
		172,
		203,
		188,
		169,
		156,
		163,
		163,
		156,
		-1,
		-1,
		-1,
		211,
		210,
		202,
		196,
		196,
		181,
		172,
		-1,
		184,
		166,
		145,
		162,
		162,
		153,
		161,
		193,
		189,
		176,
		176,
		168,
		-1,
		312,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		205,
		200,
		173,
		161,
		167,
		163,
		149,
		155,
		157,
		165,
		163,
		160,
		172,
		168,
		188,
		169,
		204,
		-1,
		307,
		-1,
		241,
		-1,
		-1,
		223,
		203,
		195,
		184,
		173,
		171,
		162,
		153,
		175,
		191,
		175,
		173,
		176,
		177,
		-1,
		296,
		295,
		-1,
		242,
		234,
		220,
		-1,
		213,
		-1,
		219,
		180,
		-1,
		182,
		162,
		-1,
		184,
		180,
		-1,
		-1,
		283,
		258,
		-1,
		-1,
		-1,
		243,
		223,
		214,
		198,
		-1,
		173,
		173,
		-1,
		-1,
		-1,
		268,
		267,
		-1,
		236,
		239,
		-1,
		229,
		220,
		228,
		175,
		179,
		-1,
		-1,
		-1,
		277,
		258,
		252,
		251,
		249,
		244,
		241,
		227,
		211,
		189,
		178,
		199,
		-1,
		-1,
		-1,
		249,
		241,
		234,
		-1,
		-1,
		236,
		219,
		200,
		198,
		-1,
		-1,
		-1,
		271,
		252,
		-1,
		-1,
		226,
		-1,
		-1,
		232,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		260,
		-1,
		-1,
		-1,
		222,
		218,
		219,
		-1,
		-1,
		-1,
		-1,
		282,
		283,
		306,
		270,
		-1,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		285,
		283,
		-1,
		-1,
		-1,
		242,
		226,
		-1,
		212,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		247,
		-1,
		247,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		260,
		252,
		260,
		-1,
		232,
		234,
		-1,
		282,
		-1,
		-1,
		275,
		266,
		-1,
		-1,
		237,
		244,
		266,
		269,
		305,
		-1,
		256
	],
	[
		-1,
		126,
		115,
		126,
		134,
		107,
		114,
		-1,
		133,
		137,
		103,
		97,
		136,
		105,
		111,
		122,
		-1,
		-1,
		-1,
		126,
		125,
		93,
		91,
		100,
		105,
		112,
		-1,
		107,
		-1,
		147,
		126,
		137,
		142,
		86,
		83,
		103,
		119,
		100,
		92,
		162,
		116,
		87,
		81,
		99,
		89,
		94,
		86,
		-1,
		87,
		77,
		99,
		78,
		88,
		70,
		-1,
		-1,
		81,
		82,
		88,
		74,
		75,
		67,
		-1,
		86,
		105,
		-1,
		-1,
		71,
		72,
		56,
		59,
		63,
		62,
		78,
		95,
		100,
		-1,
		-1,
		62,
		58,
		57,
		52,
		48,
		65,
		84,
		95,
		109,
		108,
		-1,
		69,
		69,
		55,
		50,
		44,
		41,
		45,
		63,
		94,
		100,
		103,
		-1,
		78,
		79,
		51,
		41,
		33,
		25,
		37,
		50,
		69,
		82,
		101,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		78,
		61,
		66,
		48,
		40,
		21,
		3,
		33,
		53,
		57,
		74,
		90,
		91,
		101,
		-1,
		-1,
		172,
		145,
		169,
		127,
		108,
		-1,
		74,
		54,
		48,
		44,
		38,
		38,
		0,
		23,
		-1,
		68,
		67,
		98,
		84,
		95,
		154,
		-1,
		-1,
		130,
		122,
		104,
		107,
		84,
		80,
		69,
		68,
		61,
		59,
		55,
		35,
		25,
		36,
		44,
		62,
		72,
		76,
		91,
		102,
		-1,
		-1,
		176,
		-1,
		-1,
		151,
		134,
		-1,
		99,
		106,
		90,
		96,
		82,
		103,
		79,
		70,
		69,
		64,
		56,
		31,
		30,
		51,
		50,
		59,
		84,
		88,
		94,
		112,
		113,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		106,
		103,
		96,
		120,
		119,
		-1,
		104,
		92,
		93,
		78,
		77,
		73,
		62,
		38,
		36,
		51,
		53,
		66,
		68,
		104,
		96,
		117,
		114,
		145,
		151,
		145,
		154,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		124,
		-1,
		127,
		140,
		116,
		89,
		92,
		79,
		87,
		80,
		60,
		44,
		39,
		42,
		62,
		74,
		82,
		93,
		92,
		110,
		123,
		138,
		142,
		148,
		-1,
		209,
		-1,
		151,
		135,
		137,
		113,
		141,
		-1,
		144,
		128,
		133,
		118,
		118,
		-1,
		95,
		92,
		98,
		76,
		61,
		57,
		46,
		50,
		61,
		81,
		96,
		87,
		105,
		112,
		120,
		124,
		144,
		156,
		169,
		159,
		-1,
		141,
		146,
		116,
		128,
		151,
		171,
		154,
		-1,
		129,
		-1,
		97,
		110,
		-1,
		82,
		78,
		67,
		68,
		57,
		64,
		68,
		78,
		75,
		93,
		96,
		113,
		117,
		133,
		-1,
		-1,
		154,
		158,
		166,
		117,
		136,
		160,
		197,
		147,
		136,
		135,
		-1,
		115,
		101,
		98,
		99,
		86,
		80,
		80,
		63,
		69,
		78,
		77,
		80,
		102,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		143,
		114,
		138,
		180,
		165,
		158,
		146,
		133,
		133,
		127,
		-1,
		117,
		96,
		91,
		80,
		70,
		86,
		81,
		97,
		81,
		83,
		99,
		111,
		102,
		122,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		117,
		151,
		169,
		166,
		152,
		157,
		132,
		125,
		119,
		110,
		113,
		98,
		87,
		79,
		68,
		84,
		91,
		86,
		83,
		92,
		93,
		117,
		124,
		130,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		142,
		149,
		181,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		81,
		75,
		84,
		92,
		97,
		88,
		103,
		122,
		122,
		114,
		139,
		142,
		-1,
		-1,
		-1,
		173,
		190,
		165,
		142,
		123,
		159,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		85,
		89,
		82,
		89,
		85,
		99,
		107,
		89,
		125,
		-1,
		122,
		116,
		144,
		139,
		127,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		94,
		92,
		86,
		90,
		94,
		83,
		96,
		101,
		94,
		104,
		124,
		128,
		135,
		128,
		125,
		122,
		136,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		101,
		101,
		97,
		105,
		90,
		93,
		97,
		101,
		119,
		135,
		127,
		121,
		120,
		132,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		106,
		121,
		122,
		100,
		105,
		104,
		114,
		115,
		104,
		109,
		109,
		128,
		131,
		115,
		116,
		125,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		120,
		118,
		111,
		102,
		108,
		115,
		118,
		119,
		109,
		98,
		104,
		103,
		125,
		111,
		109,
		128,
		144,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		144,
		-1,
		117,
		119,
		111,
		100,
		97,
		108,
		106,
		117,
		134,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		139,
		137,
		125,
		109,
		102,
		99,
		100,
		113,
		133,
		124,
		136,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		152,
		140,
		130,
		120,
		154,
		153,
		128,
		121,
		107,
		109,
		107,
		109,
		114,
		135,
		136,
		149,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		141,
		-1,
		-1,
		132,
		130,
		140,
		124,
		111,
		131,
		134,
		124,
		108,
		123,
		135,
		143,
		148,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		165,
		169,
		135,
		-1,
		140,
		135,
		115,
		129,
		136,
		126,
		121,
		115,
		118,
		136,
		153,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		158,
		151,
		155,
		-1,
		143,
		131,
		117,
		134,
		139,
		136,
		127,
		119,
		124,
		121,
		134,
		148,
		152,
		191,
		-1,
		174,
		-1,
		-1,
		-1,
		160,
		175,
		197,
		174,
		147,
		142,
		135,
		129,
		125,
		141,
		147,
		158,
		126,
		122,
		123,
		127,
		126,
		143,
		153,
		-1,
		-1,
		174,
		191,
		186,
		168,
		172,
		224,
		-1,
		-1,
		151,
		142,
		133,
		136,
		135,
		138,
		132,
		129,
		134,
		139,
		127,
		136,
		154,
		153,
		-1,
		-1,
		-1,
		194,
		-1,
		209,
		-1,
		-1,
		187,
		222,
		169,
		151,
		147,
		145,
		138,
		147,
		142,
		137,
		147,
		149,
		141,
		129,
		133,
		156,
		145,
		184,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		223,
		198,
		213,
		233,
		207,
		214,
		184,
		181,
		-1,
		151,
		176,
		148,
		155,
		146,
		153,
		153,
		145,
		123,
		130,
		146,
		145,
		140,
		176,
		167,
		173,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		229,
		215,
		219,
		209,
		212,
		-1,
		-1,
		200,
		197,
		173,
		156,
		154,
		147,
		142,
		152,
		132,
		119,
		123,
		127,
		133,
		138,
		143,
		149,
		164,
		179,
		-1,
		201,
		282,
		275,
		258,
		266,
		297,
		-1,
		223,
		215,
		222,
		201,
		203,
		-1,
		-1,
		173,
		170,
		175,
		163,
		160,
		162,
		157,
		148,
		133,
		139,
		126,
		125,
		143,
		147,
		156,
		163,
		153,
		166,
		170,
		-1,
		215,
		258,
		252,
		255,
		279,
		293,
		-1,
		220,
		-1,
		-1,
		230,
		204,
		188,
		178,
		172,
		222,
		177,
		172,
		156,
		154,
		145,
		136,
		143,
		134,
		134,
		137,
		152,
		157,
		149,
		163,
		163,
		164,
		-1,
		250,
		238,
		246,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		246,
		-1,
		215,
		-1,
		190,
		194,
		185,
		188,
		170,
		157,
		149,
		141,
		157,
		132,
		142,
		138,
		139,
		148,
		159,
		171,
		170,
		171,
		291,
		247,
		246,
		237,
		272,
		287,
		291,
		-1,
		232,
		271,
		269,
		-1,
		253,
		-1,
		-1,
		-1,
		204,
		198,
		190,
		190,
		169,
		169,
		143,
		147,
		137,
		144,
		154,
		156,
		148,
		152,
		165,
		176,
		179,
		287,
		278,
		291,
		236,
		236,
		257,
		266,
		287,
		247,
		238,
		265,
		276,
		265,
		260,
		247,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		176,
		164,
		147,
		148,
		144,
		147,
		162,
		165,
		155,
		153,
		147,
		179,
		-1,
		280,
		279,
		268,
		265,
		241,
		232,
		227,
		254,
		-1,
		-1,
		249,
		266,
		260,
		264,
		280,
		305,
		-1,
		236,
		-1,
		-1,
		221,
		-1,
		-1,
		206,
		169,
		158,
		149,
		155,
		152,
		163,
		173,
		161,
		162,
		152,
		162,
		175,
		264,
		261,
		249,
		247,
		270,
		235,
		223,
		-1,
		236,
		234,
		240,
		247,
		264,
		294,
		-1,
		-1,
		252,
		232,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		154,
		159,
		179,
		181,
		170,
		164,
		158,
		165,
		164,
		172,
		180,
		273,
		287,
		276,
		272,
		271,
		279,
		228,
		221,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		-1,
		242,
		238,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		172,
		176,
		168,
		161,
		156,
		167,
		159,
		163,
		180,
		-1,
		307,
		-1,
		259,
		235,
		249,
		264,
		272,
		-1,
		-1,
		-1,
		259,
		245,
		238,
		226,
		224,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		212,
		180,
		185,
		180,
		162,
		173,
		162,
		165,
		179,
		174,
		-1,
		-1,
		247,
		250,
		-1,
		-1,
		249,
		251,
		-1,
		250,
		239,
		224,
		216,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		169,
		194,
		183,
		191,
		186,
		166,
		172,
		175,
		164,
		168,
		180,
		-1,
		-1,
		254,
		255,
		256,
		-1,
		234,
		-1,
		252,
		-1,
		219,
		225,
		213,
		-1,
		-1,
		-1,
		207,
		170,
		191,
		201,
		195,
		193,
		184,
		170,
		177,
		175,
		171,
		182,
		-1,
		-1,
		-1,
		252,
		226,
		259,
		250,
		233,
		213,
		205,
		224,
		-1,
		194,
		-1,
		169,
		171,
		197,
		200,
		206,
		200,
		173,
		188,
		178,
		169,
		178,
		258,
		-1,
		228,
		261,
		225,
		219,
		195,
		199,
		215,
		-1,
		191,
		173,
		-1,
		201,
		191,
		222,
		207,
		188,
		175,
		182,
		182,
		175,
		-1,
		-1,
		-1,
		230,
		229,
		221,
		215,
		215,
		200,
		191,
		-1,
		203,
		185,
		164,
		181,
		181,
		172,
		180,
		212,
		208,
		195,
		195,
		187,
		-1,
		331,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		224,
		219,
		192,
		180,
		186,
		182,
		168,
		174,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		188,
		223,
		-1,
		326,
		-1,
		260,
		-1,
		-1,
		242,
		222,
		214,
		203,
		192,
		190,
		181,
		172,
		194,
		210,
		194,
		192,
		195,
		196,
		-1,
		315,
		314,
		-1,
		261,
		253,
		239,
		-1,
		232,
		-1,
		238,
		199,
		-1,
		201,
		181,
		-1,
		203,
		199,
		-1,
		-1,
		302,
		277,
		-1,
		-1,
		-1,
		262,
		242,
		233,
		217,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		287,
		286,
		-1,
		255,
		258,
		-1,
		248,
		239,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		296,
		277,
		271,
		270,
		268,
		263,
		260,
		246,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		268,
		260,
		253,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		290,
		271,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		279,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		301,
		302,
		325,
		289,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		304,
		302,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		106,
		95,
		106,
		114,
		87,
		94,
		-1,
		113,
		117,
		83,
		77,
		116,
		85,
		91,
		102,
		-1,
		-1,
		-1,
		106,
		105,
		73,
		71,
		80,
		85,
		92,
		-1,
		91,
		-1,
		127,
		106,
		117,
		122,
		66,
		63,
		83,
		102,
		84,
		76,
		142,
		96,
		67,
		61,
		79,
		69,
		78,
		70,
		-1,
		67,
		57,
		79,
		58,
		69,
		61,
		-1,
		-1,
		61,
		62,
		68,
		54,
		60,
		56,
		-1,
		66,
		85,
		-1,
		-1,
		51,
		52,
		36,
		39,
		47,
		45,
		58,
		75,
		80,
		-1,
		-1,
		42,
		38,
		45,
		32,
		28,
		45,
		64,
		75,
		89,
		88,
		-1,
		54,
		71,
		70,
		39,
		37,
		21,
		25,
		43,
		74,
		80,
		83,
		-1,
		71,
		67,
		49,
		56,
		48,
		36,
		17,
		30,
		49,
		62,
		81,
		72,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		72,
		56,
		63,
		45,
		35,
		36,
		18,
		13,
		33,
		37,
		54,
		70,
		71,
		81,
		-1,
		-1,
		165,
		138,
		162,
		120,
		102,
		-1,
		68,
		49,
		43,
		39,
		33,
		26,
		18,
		0,
		-1,
		48,
		47,
		78,
		64,
		75,
		147,
		-1,
		-1,
		123,
		115,
		97,
		100,
		77,
		73,
		64,
		63,
		56,
		49,
		45,
		23,
		8,
		21,
		28,
		42,
		52,
		56,
		71,
		82,
		-1,
		-1,
		156,
		-1,
		-1,
		144,
		127,
		-1,
		92,
		99,
		83,
		89,
		75,
		96,
		74,
		65,
		59,
		54,
		46,
		21,
		18,
		35,
		38,
		39,
		64,
		68,
		74,
		92,
		93,
		-1,
		155,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		99,
		96,
		89,
		113,
		112,
		-1,
		94,
		82,
		83,
		68,
		67,
		63,
		52,
		26,
		24,
		39,
		41,
		46,
		48,
		85,
		76,
		97,
		94,
		125,
		131,
		125,
		134,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		117,
		-1,
		120,
		131,
		106,
		79,
		82,
		69,
		77,
		68,
		50,
		32,
		27,
		30,
		50,
		54,
		63,
		73,
		72,
		90,
		103,
		118,
		122,
		128,
		-1,
		202,
		-1,
		144,
		128,
		130,
		106,
		134,
		-1,
		137,
		121,
		123,
		108,
		108,
		-1,
		85,
		82,
		86,
		64,
		49,
		45,
		34,
		38,
		49,
		61,
		76,
		67,
		85,
		92,
		100,
		104,
		124,
		136,
		162,
		152,
		-1,
		134,
		139,
		109,
		121,
		144,
		164,
		144,
		-1,
		119,
		-1,
		87,
		100,
		-1,
		70,
		66,
		55,
		56,
		45,
		52,
		56,
		58,
		55,
		73,
		76,
		93,
		97,
		113,
		-1,
		-1,
		147,
		151,
		159,
		110,
		129,
		153,
		190,
		137,
		126,
		125,
		-1,
		105,
		89,
		86,
		87,
		74,
		68,
		68,
		51,
		57,
		66,
		57,
		60,
		82,
		110,
		88,
		100,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		136,
		107,
		131,
		173,
		155,
		148,
		136,
		121,
		121,
		115,
		-1,
		105,
		84,
		79,
		68,
		58,
		74,
		69,
		81,
		61,
		63,
		79,
		91,
		82,
		102,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		110,
		143,
		162,
		154,
		140,
		145,
		120,
		113,
		107,
		98,
		101,
		86,
		75,
		67,
		56,
		72,
		79,
		74,
		63,
		72,
		73,
		97,
		104,
		110,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		96,
		80,
		75,
		72,
		69,
		63,
		72,
		80,
		77,
		68,
		83,
		102,
		102,
		94,
		119,
		122,
		-1,
		-1,
		-1,
		166,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		82,
		78,
		73,
		77,
		70,
		77,
		73,
		86,
		87,
		69,
		105,
		-1,
		102,
		96,
		124,
		127,
		115,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		82,
		80,
		74,
		78,
		82,
		71,
		84,
		89,
		74,
		84,
		104,
		108,
		115,
		108,
		113,
		110,
		124,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		102,
		86,
		89,
		89,
		85,
		93,
		78,
		81,
		77,
		81,
		99,
		123,
		115,
		109,
		108,
		120,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		94,
		109,
		110,
		88,
		93,
		92,
		102,
		103,
		92,
		89,
		93,
		108,
		118,
		103,
		104,
		113,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		108,
		106,
		99,
		90,
		96,
		103,
		106,
		107,
		97,
		86,
		92,
		91,
		113,
		99,
		97,
		116,
		132,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		107,
		91,
		96,
		-1,
		132,
		-1,
		105,
		107,
		99,
		88,
		85,
		96,
		94,
		105,
		122,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		123,
		103,
		97,
		96,
		127,
		125,
		113,
		97,
		90,
		87,
		88,
		101,
		121,
		112,
		124,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		140,
		128,
		118,
		108,
		142,
		141,
		116,
		109,
		95,
		97,
		95,
		97,
		102,
		123,
		124,
		137,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		129,
		-1,
		-1,
		120,
		118,
		128,
		112,
		99,
		119,
		122,
		112,
		96,
		111,
		123,
		131,
		136,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		151,
		153,
		157,
		123,
		-1,
		128,
		123,
		103,
		117,
		124,
		114,
		109,
		103,
		106,
		124,
		141,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		130,
		144,
		146,
		139,
		143,
		-1,
		131,
		119,
		105,
		122,
		127,
		124,
		115,
		107,
		112,
		109,
		122,
		136,
		140,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		148,
		163,
		185,
		162,
		135,
		130,
		123,
		117,
		113,
		129,
		135,
		146,
		114,
		110,
		111,
		115,
		114,
		131,
		141,
		-1,
		-1,
		162,
		179,
		174,
		156,
		160,
		212,
		-1,
		-1,
		139,
		130,
		121,
		124,
		123,
		126,
		120,
		117,
		122,
		127,
		115,
		124,
		142,
		141,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		175,
		210,
		157,
		139,
		135,
		133,
		126,
		135,
		130,
		125,
		135,
		137,
		129,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		211,
		186,
		201,
		221,
		195,
		202,
		172,
		169,
		-1,
		139,
		164,
		136,
		143,
		134,
		141,
		141,
		133,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		294,
		283,
		272,
		278,
		-1,
		217,
		203,
		207,
		197,
		200,
		-1,
		-1,
		188,
		185,
		161,
		144,
		142,
		135,
		130,
		140,
		120,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		189,
		270,
		263,
		246,
		254,
		285,
		-1,
		211,
		203,
		210,
		189,
		191,
		-1,
		-1,
		161,
		158,
		163,
		151,
		148,
		150,
		145,
		136,
		121,
		127,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		203,
		246,
		240,
		243,
		267,
		281,
		-1,
		208,
		-1,
		-1,
		218,
		192,
		176,
		166,
		160,
		210,
		165,
		160,
		144,
		142,
		133,
		124,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		238,
		226,
		234,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		234,
		-1,
		203,
		-1,
		178,
		182,
		173,
		176,
		158,
		145,
		137,
		129,
		145,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		279,
		235,
		234,
		225,
		260,
		275,
		279,
		-1,
		220,
		259,
		257,
		-1,
		241,
		-1,
		-1,
		-1,
		192,
		186,
		178,
		178,
		157,
		157,
		131,
		135,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		275,
		266,
		279,
		224,
		224,
		245,
		254,
		275,
		235,
		226,
		253,
		264,
		253,
		248,
		235,
		-1,
		-1,
		215,
		196,
		-1,
		-1,
		164,
		152,
		135,
		136,
		132,
		135,
		150,
		153,
		143,
		141,
		135,
		167,
		-1,
		268,
		267,
		256,
		253,
		229,
		220,
		215,
		242,
		-1,
		-1,
		237,
		254,
		248,
		252,
		268,
		293,
		-1,
		224,
		-1,
		-1,
		209,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		140,
		151,
		161,
		149,
		150,
		140,
		150,
		163,
		252,
		249,
		237,
		235,
		258,
		223,
		211,
		-1,
		224,
		222,
		228,
		235,
		252,
		282,
		-1,
		-1,
		240,
		220,
		-1,
		-1,
		192,
		190,
		179,
		-1,
		169,
		142,
		147,
		167,
		169,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		261,
		275,
		264,
		260,
		259,
		267,
		216,
		209,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		226,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		160,
		164,
		156,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		295,
		-1,
		247,
		223,
		237,
		252,
		260,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		235,
		238,
		-1,
		-1,
		237,
		239,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		242,
		243,
		244,
		-1,
		222,
		-1,
		240,
		-1,
		207,
		213,
		201,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		183,
		181,
		172,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		240,
		214,
		247,
		238,
		221,
		201,
		193,
		212,
		-1,
		182,
		-1,
		157,
		159,
		185,
		188,
		194,
		188,
		161,
		176,
		166,
		157,
		166,
		246,
		-1,
		216,
		249,
		213,
		207,
		183,
		187,
		203,
		-1,
		179,
		161,
		-1,
		189,
		179,
		210,
		195,
		176,
		163,
		170,
		170,
		163,
		-1,
		-1,
		-1,
		218,
		217,
		209,
		203,
		203,
		188,
		179,
		-1,
		191,
		173,
		152,
		169,
		169,
		160,
		168,
		200,
		196,
		183,
		183,
		175,
		-1,
		319,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		212,
		207,
		180,
		168,
		174,
		170,
		156,
		162,
		164,
		172,
		170,
		167,
		179,
		175,
		195,
		176,
		211,
		-1,
		314,
		-1,
		248,
		-1,
		-1,
		230,
		210,
		202,
		191,
		180,
		178,
		169,
		160,
		182,
		198,
		182,
		180,
		183,
		184,
		-1,
		303,
		302,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		226,
		187,
		-1,
		189,
		169,
		-1,
		191,
		187,
		-1,
		-1,
		290,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		221,
		205,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		275,
		274,
		-1,
		243,
		246,
		-1,
		236,
		227,
		235,
		182,
		186,
		-1,
		-1,
		-1,
		284,
		265,
		259,
		258,
		256,
		251,
		248,
		234,
		218,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		256,
		248,
		241,
		-1,
		-1,
		243,
		226,
		207,
		205,
		-1,
		-1,
		-1,
		278,
		259,
		-1,
		-1,
		233,
		-1,
		-1,
		239,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		267,
		-1,
		-1,
		-1,
		229,
		225,
		226,
		-1,
		-1,
		-1,
		-1,
		289,
		290,
		313,
		277,
		-1,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		292,
		290,
		-1,
		-1,
		-1,
		249,
		233,
		-1,
		219,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		254,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		267,
		259,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		282,
		273,
		-1,
		-1,
		244,
		251,
		273,
		276,
		312,
		-1,
		263
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		111,
		100,
		111,
		119,
		92,
		99,
		-1,
		118,
		122,
		88,
		82,
		121,
		90,
		96,
		107,
		-1,
		-1,
		-1,
		111,
		110,
		78,
		76,
		85,
		90,
		97,
		-1,
		96,
		-1,
		132,
		111,
		122,
		127,
		71,
		68,
		88,
		107,
		89,
		81,
		147,
		101,
		72,
		66,
		84,
		74,
		83,
		75,
		-1,
		72,
		62,
		84,
		63,
		74,
		66,
		-1,
		-1,
		66,
		67,
		73,
		59,
		65,
		61,
		-1,
		66,
		48,
		-1,
		-1,
		56,
		57,
		41,
		44,
		52,
		50,
		62,
		48,
		43,
		-1,
		-1,
		47,
		43,
		50,
		37,
		33,
		50,
		63,
		38,
		45,
		43,
		-1,
		59,
		76,
		76,
		44,
		42,
		26,
		24,
		42,
		37,
		43,
		35,
		-1,
		76,
		72,
		73,
		71,
		66,
		42,
		29,
		29,
		39,
		25,
		33,
		24,
		70,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		77,
		68,
		85,
		69,
		59,
		63,
		61,
		32,
		29,
		27,
		16,
		22,
		23,
		33,
		-1,
		-1,
		170,
		143,
		167,
		125,
		107,
		-1,
		73,
		73,
		67,
		63,
		57,
		50,
		63,
		48,
		-1,
		0,
		9,
		30,
		16,
		27,
		152,
		-1,
		-1,
		128,
		120,
		102,
		105,
		82,
		78,
		88,
		87,
		80,
		73,
		69,
		47,
		50,
		50,
		56,
		12,
		4,
		8,
		23,
		34,
		-1,
		-1,
		126,
		-1,
		-1,
		149,
		132,
		-1,
		97,
		104,
		88,
		94,
		80,
		101,
		98,
		89,
		83,
		78,
		70,
		45,
		42,
		55,
		34,
		9,
		18,
		21,
		26,
		44,
		45,
		-1,
		125,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		104,
		101,
		94,
		118,
		117,
		-1,
		118,
		106,
		107,
		92,
		91,
		85,
		73,
		50,
		34,
		34,
		31,
		16,
		18,
		55,
		28,
		49,
		46,
		77,
		101,
		95,
		104,
		-1,
		157,
		153,
		149,
		156,
		105,
		-1,
		-1,
		122,
		-1,
		125,
		138,
		130,
		103,
		106,
		93,
		93,
		80,
		69,
		51,
		32,
		29,
		28,
		24,
		33,
		33,
		36,
		52,
		55,
		88,
		92,
		98,
		-1,
		207,
		-1,
		149,
		133,
		135,
		111,
		139,
		-1,
		142,
		126,
		146,
		132,
		132,
		-1,
		109,
		106,
		98,
		76,
		61,
		44,
		32,
		27,
		27,
		31,
		46,
		37,
		55,
		60,
		67,
		74,
		94,
		106,
		167,
		157,
		-1,
		139,
		144,
		114,
		126,
		146,
		169,
		148,
		-1,
		143,
		-1,
		111,
		124,
		-1,
		82,
		78,
		52,
		40,
		29,
		36,
		34,
		28,
		25,
		43,
		46,
		63,
		67,
		83,
		-1,
		-1,
		152,
		156,
		161,
		112,
		131,
		155,
		192,
		141,
		130,
		129,
		-1,
		120,
		88,
		85,
		82,
		69,
		54,
		52,
		35,
		41,
		42,
		27,
		30,
		52,
		80,
		58,
		70,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		138,
		109,
		133,
		175,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		93,
		72,
		63,
		52,
		42,
		58,
		48,
		51,
		31,
		33,
		49,
		61,
		52,
		72,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		138,
		124,
		129,
		104,
		97,
		91,
		97,
		89,
		70,
		59,
		51,
		40,
		49,
		59,
		53,
		33,
		42,
		43,
		67,
		74,
		80,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		80,
		64,
		59,
		56,
		53,
		47,
		56,
		61,
		47,
		38,
		53,
		72,
		72,
		64,
		89,
		92,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		81,
		66,
		62,
		57,
		61,
		54,
		61,
		57,
		56,
		57,
		39,
		75,
		-1,
		72,
		66,
		94,
		97,
		87,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		66,
		64,
		58,
		62,
		66,
		55,
		68,
		64,
		44,
		54,
		74,
		78,
		85,
		78,
		83,
		82,
		96,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		72,
		70,
		86,
		70,
		73,
		73,
		69,
		77,
		62,
		61,
		47,
		51,
		69,
		96,
		91,
		86,
		85,
		92,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		82,
		78,
		93,
		94,
		72,
		77,
		76,
		86,
		83,
		72,
		59,
		63,
		78,
		88,
		80,
		81,
		90,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		92,
		90,
		83,
		74,
		80,
		87,
		90,
		87,
		77,
		66,
		72,
		68,
		90,
		76,
		74,
		93,
		108,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		91,
		75,
		80,
		-1,
		112,
		-1,
		85,
		85,
		76,
		65,
		62,
		73,
		71,
		82,
		99,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		107,
		87,
		81,
		80,
		107,
		102,
		93,
		74,
		67,
		64,
		65,
		78,
		98,
		89,
		101,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		124,
		112,
		102,
		92,
		126,
		118,
		93,
		86,
		72,
		74,
		72,
		74,
		79,
		100,
		101,
		114,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		113,
		-1,
		-1,
		104,
		102,
		110,
		89,
		76,
		96,
		99,
		89,
		73,
		88,
		100,
		108,
		113,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		135,
		130,
		134,
		107,
		-1,
		106,
		100,
		80,
		94,
		101,
		91,
		86,
		80,
		83,
		101,
		118,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		123,
		116,
		120,
		-1,
		108,
		96,
		82,
		99,
		104,
		101,
		92,
		84,
		89,
		86,
		99,
		113,
		117,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		162,
		139,
		112,
		107,
		100,
		94,
		90,
		106,
		112,
		123,
		91,
		87,
		88,
		92,
		91,
		108,
		118,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		189,
		-1,
		-1,
		116,
		107,
		98,
		101,
		100,
		103,
		97,
		94,
		99,
		104,
		92,
		101,
		119,
		118,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		187,
		134,
		116,
		112,
		110,
		103,
		112,
		107,
		102,
		112,
		114,
		106,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		195,
		170,
		185,
		198,
		179,
		186,
		149,
		146,
		-1,
		116,
		141,
		113,
		120,
		111,
		118,
		118,
		110,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		198,
		187,
		184,
		174,
		177,
		-1,
		-1,
		165,
		162,
		138,
		121,
		119,
		112,
		107,
		117,
		97,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		188,
		180,
		191,
		166,
		168,
		-1,
		-1,
		138,
		135,
		140,
		128,
		125,
		127,
		122,
		113,
		98,
		104,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		185,
		-1,
		-1,
		197,
		169,
		153,
		143,
		137,
		187,
		142,
		137,
		121,
		119,
		110,
		101,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		213,
		-1,
		180,
		-1,
		155,
		159,
		150,
		153,
		135,
		122,
		114,
		106,
		122,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		256,
		212,
		215,
		209,
		237,
		252,
		256,
		-1,
		197,
		236,
		234,
		-1,
		218,
		-1,
		-1,
		-1,
		169,
		163,
		155,
		155,
		134,
		134,
		108,
		112,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		252,
		243,
		256,
		201,
		201,
		222,
		231,
		252,
		212,
		203,
		230,
		241,
		230,
		225,
		212,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		141,
		129,
		112,
		113,
		109,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		245,
		244,
		233,
		230,
		206,
		197,
		192,
		219,
		-1,
		-1,
		214,
		231,
		225,
		229,
		245,
		270,
		-1,
		201,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		117,
		128,
		138,
		126,
		127,
		117,
		127,
		140,
		229,
		226,
		214,
		212,
		235,
		200,
		188,
		-1,
		201,
		199,
		205,
		212,
		229,
		259,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		144,
		146,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		238,
		252,
		241,
		237,
		236,
		244,
		193,
		186,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		137,
		141,
		133,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		272,
		-1,
		224,
		200,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		214,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		219,
		220,
		221,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		160,
		158,
		149,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		136,
		162,
		165,
		171,
		165,
		138,
		153,
		143,
		134,
		143,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		187,
		172,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		177,
		173,
		160,
		160,
		152,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		153,
		188,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		160,
		161,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		113,
		102,
		113,
		121,
		94,
		101,
		-1,
		120,
		124,
		90,
		84,
		123,
		92,
		98,
		109,
		-1,
		-1,
		-1,
		113,
		112,
		80,
		78,
		87,
		92,
		99,
		-1,
		98,
		-1,
		134,
		113,
		124,
		129,
		73,
		70,
		90,
		109,
		91,
		83,
		149,
		103,
		74,
		68,
		86,
		76,
		85,
		77,
		-1,
		74,
		64,
		86,
		65,
		76,
		68,
		-1,
		-1,
		68,
		69,
		75,
		61,
		67,
		63,
		-1,
		57,
		39,
		-1,
		-1,
		58,
		59,
		43,
		46,
		54,
		52,
		53,
		39,
		34,
		-1,
		-1,
		49,
		45,
		52,
		39,
		35,
		52,
		54,
		29,
		43,
		42,
		-1,
		61,
		78,
		78,
		46,
		44,
		28,
		26,
		44,
		28,
		34,
		42,
		-1,
		78,
		74,
		75,
		73,
		68,
		44,
		31,
		27,
		30,
		16,
		39,
		32,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		70,
		87,
		71,
		61,
		65,
		63,
		34,
		20,
		18,
		7,
		28,
		31,
		41,
		-1,
		-1,
		172,
		145,
		169,
		127,
		109,
		-1,
		75,
		75,
		69,
		65,
		59,
		52,
		65,
		50,
		-1,
		8,
		0,
		38,
		24,
		35,
		154,
		-1,
		-1,
		130,
		122,
		104,
		107,
		84,
		80,
		90,
		89,
		82,
		75,
		71,
		49,
		52,
		52,
		58,
		7,
		12,
		16,
		31,
		42,
		-1,
		-1,
		128,
		-1,
		-1,
		151,
		134,
		-1,
		99,
		106,
		90,
		96,
		82,
		103,
		100,
		91,
		85,
		80,
		72,
		47,
		44,
		57,
		36,
		11,
		26,
		29,
		34,
		52,
		53,
		-1,
		127,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		106,
		103,
		96,
		120,
		119,
		-1,
		120,
		108,
		109,
		94,
		93,
		87,
		75,
		52,
		36,
		36,
		33,
		18,
		20,
		57,
		36,
		57,
		54,
		85,
		103,
		97,
		106,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		124,
		-1,
		127,
		140,
		132,
		105,
		108,
		95,
		95,
		82,
		71,
		53,
		34,
		31,
		30,
		26,
		35,
		41,
		44,
		60,
		63,
		90,
		94,
		100,
		-1,
		209,
		-1,
		151,
		135,
		137,
		113,
		141,
		-1,
		144,
		128,
		148,
		134,
		134,
		-1,
		111,
		108,
		100,
		78,
		63,
		46,
		34,
		29,
		29,
		33,
		48,
		39,
		57,
		64,
		72,
		76,
		96,
		108,
		169,
		159,
		-1,
		141,
		146,
		116,
		128,
		148,
		171,
		150,
		-1,
		145,
		-1,
		113,
		126,
		-1,
		84,
		80,
		54,
		42,
		31,
		38,
		36,
		30,
		27,
		45,
		48,
		65,
		69,
		85,
		-1,
		-1,
		154,
		158,
		163,
		114,
		133,
		157,
		194,
		143,
		132,
		131,
		-1,
		122,
		90,
		87,
		84,
		71,
		56,
		54,
		37,
		43,
		44,
		29,
		32,
		54,
		82,
		60,
		72,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		140,
		111,
		135,
		177,
		161,
		154,
		142,
		107,
		107,
		101,
		-1,
		95,
		74,
		65,
		54,
		44,
		60,
		50,
		53,
		33,
		35,
		51,
		63,
		54,
		74,
		-1,
		-1,
		-1,
		170,
		159,
		160,
		106,
		129,
		166,
		140,
		126,
		131,
		106,
		99,
		93,
		99,
		91,
		72,
		61,
		53,
		42,
		51,
		61,
		55,
		35,
		44,
		45,
		69,
		76,
		82,
		-1,
		-1,
		177,
		167,
		151,
		153,
		150,
		120,
		127,
		159,
		131,
		144,
		-1,
		98,
		-1,
		87,
		82,
		66,
		61,
		58,
		55,
		49,
		58,
		63,
		49,
		40,
		55,
		74,
		74,
		66,
		91,
		94,
		-1,
		-1,
		-1,
		170,
		165,
		140,
		117,
		101,
		137,
		-1,
		114,
		115,
		-1,
		92,
		86,
		83,
		68,
		64,
		59,
		63,
		56,
		63,
		59,
		58,
		59,
		41,
		77,
		-1,
		74,
		68,
		96,
		99,
		89,
		-1,
		-1,
		-1,
		163,
		142,
		135,
		155,
		96,
		148,
		-1,
		-1,
		99,
		92,
		-1,
		79,
		61,
		68,
		66,
		60,
		64,
		68,
		57,
		70,
		66,
		46,
		56,
		76,
		80,
		87,
		80,
		85,
		84,
		98,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		116,
		-1,
		108,
		100,
		90,
		84,
		78,
		74,
		72,
		88,
		72,
		75,
		75,
		71,
		79,
		64,
		63,
		49,
		53,
		71,
		98,
		93,
		88,
		87,
		94,
		-1,
		183,
		169,
		140,
		-1,
		-1,
		129,
		-1,
		93,
		107,
		123,
		-1,
		116,
		95,
		110,
		88,
		84,
		80,
		95,
		96,
		74,
		79,
		78,
		88,
		85,
		74,
		61,
		65,
		80,
		90,
		82,
		83,
		92,
		-1,
		189,
		176,
		134,
		130,
		119,
		139,
		90,
		78,
		110,
		-1,
		-1,
		152,
		-1,
		86,
		103,
		94,
		92,
		85,
		76,
		82,
		89,
		92,
		89,
		79,
		68,
		74,
		70,
		92,
		78,
		76,
		95,
		110,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		105,
		92,
		86,
		-1,
		127,
		-1,
		130,
		120,
		104,
		89,
		122,
		-1,
		93,
		77,
		82,
		-1,
		114,
		-1,
		87,
		87,
		78,
		67,
		64,
		75,
		73,
		84,
		101,
		-1,
		139,
		124,
		117,
		107,
		121,
		92,
		-1,
		147,
		-1,
		-1,
		117,
		111,
		111,
		95,
		98,
		109,
		89,
		83,
		82,
		109,
		104,
		95,
		76,
		69,
		66,
		67,
		80,
		100,
		91,
		103,
		-1,
		-1,
		-1,
		144,
		130,
		134,
		94,
		113,
		-1,
		-1,
		179,
		134,
		120,
		-1,
		104,
		126,
		114,
		104,
		94,
		128,
		120,
		95,
		88,
		74,
		76,
		74,
		76,
		81,
		102,
		103,
		116,
		-1,
		-1,
		127,
		132,
		120,
		106,
		125,
		-1,
		-1,
		-1,
		126,
		142,
		134,
		105,
		115,
		-1,
		-1,
		106,
		104,
		112,
		91,
		78,
		98,
		101,
		91,
		75,
		90,
		102,
		110,
		115,
		-1,
		130,
		117,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		137,
		132,
		136,
		109,
		-1,
		108,
		102,
		82,
		96,
		103,
		93,
		88,
		82,
		85,
		103,
		120,
		-1,
		-1,
		142,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		116,
		130,
		125,
		118,
		122,
		-1,
		110,
		98,
		84,
		101,
		106,
		103,
		94,
		86,
		91,
		88,
		101,
		115,
		119,
		165,
		-1,
		148,
		-1,
		-1,
		-1,
		134,
		149,
		164,
		141,
		114,
		109,
		102,
		96,
		92,
		108,
		114,
		125,
		93,
		89,
		90,
		94,
		93,
		110,
		120,
		-1,
		-1,
		148,
		165,
		160,
		142,
		146,
		191,
		-1,
		-1,
		118,
		109,
		100,
		103,
		102,
		105,
		99,
		96,
		101,
		106,
		94,
		103,
		121,
		120,
		-1,
		-1,
		-1,
		168,
		-1,
		183,
		-1,
		-1,
		161,
		189,
		136,
		118,
		114,
		112,
		105,
		114,
		109,
		104,
		114,
		116,
		108,
		96,
		100,
		123,
		112,
		151,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		197,
		172,
		187,
		200,
		181,
		188,
		151,
		148,
		-1,
		118,
		143,
		115,
		122,
		113,
		120,
		120,
		112,
		90,
		97,
		113,
		112,
		107,
		143,
		134,
		140,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		200,
		189,
		186,
		176,
		179,
		-1,
		-1,
		167,
		164,
		140,
		123,
		121,
		114,
		109,
		119,
		99,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		175,
		256,
		249,
		232,
		240,
		271,
		-1,
		190,
		182,
		193,
		168,
		170,
		-1,
		-1,
		140,
		137,
		142,
		130,
		127,
		129,
		124,
		115,
		100,
		106,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		189,
		232,
		226,
		229,
		253,
		267,
		-1,
		187,
		-1,
		-1,
		199,
		171,
		155,
		145,
		139,
		189,
		144,
		139,
		123,
		121,
		112,
		103,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		224,
		212,
		220,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		215,
		-1,
		182,
		-1,
		157,
		161,
		152,
		155,
		137,
		124,
		116,
		108,
		124,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		258,
		214,
		217,
		211,
		239,
		254,
		258,
		-1,
		199,
		238,
		236,
		-1,
		220,
		-1,
		-1,
		-1,
		171,
		165,
		157,
		157,
		136,
		136,
		110,
		114,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		254,
		245,
		258,
		203,
		203,
		224,
		233,
		254,
		214,
		205,
		232,
		243,
		232,
		227,
		214,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		143,
		131,
		114,
		115,
		111,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		247,
		246,
		235,
		232,
		208,
		199,
		194,
		221,
		-1,
		-1,
		216,
		233,
		227,
		231,
		247,
		272,
		-1,
		203,
		-1,
		-1,
		188,
		-1,
		-1,
		173,
		136,
		125,
		116,
		122,
		119,
		130,
		140,
		128,
		129,
		119,
		129,
		142,
		231,
		228,
		216,
		214,
		237,
		202,
		190,
		-1,
		203,
		201,
		207,
		214,
		231,
		261,
		-1,
		-1,
		219,
		199,
		-1,
		-1,
		171,
		169,
		158,
		-1,
		148,
		121,
		126,
		146,
		148,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		240,
		254,
		243,
		239,
		238,
		246,
		195,
		188,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		205,
		-1,
		-1,
		166,
		159,
		147,
		135,
		125,
		135,
		139,
		143,
		135,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		274,
		-1,
		226,
		202,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		200,
		184,
		165,
		-1,
		135,
		148,
		179,
		147,
		152,
		147,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		214,
		217,
		-1,
		-1,
		216,
		218,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		172,
		168,
		-1,
		-1,
		136,
		161,
		150,
		158,
		153,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		221,
		222,
		223,
		-1,
		201,
		-1,
		219,
		-1,
		186,
		192,
		180,
		-1,
		-1,
		-1,
		174,
		137,
		158,
		168,
		162,
		160,
		151,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		219,
		193,
		226,
		217,
		200,
		180,
		172,
		191,
		-1,
		161,
		-1,
		136,
		138,
		164,
		167,
		173,
		167,
		140,
		155,
		145,
		136,
		145,
		225,
		-1,
		195,
		228,
		192,
		186,
		162,
		166,
		182,
		-1,
		158,
		140,
		-1,
		168,
		158,
		189,
		174,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		182,
		167,
		158,
		-1,
		170,
		152,
		131,
		148,
		148,
		139,
		147,
		179,
		175,
		162,
		162,
		154,
		-1,
		298,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		186,
		159,
		147,
		153,
		149,
		135,
		141,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		155,
		190,
		-1,
		293,
		-1,
		227,
		-1,
		-1,
		209,
		189,
		181,
		170,
		159,
		157,
		148,
		139,
		161,
		177,
		161,
		159,
		162,
		163,
		-1,
		282,
		281,
		-1,
		228,
		220,
		206,
		-1,
		199,
		-1,
		205,
		166,
		-1,
		168,
		148,
		-1,
		170,
		166,
		-1,
		-1,
		269,
		244,
		-1,
		-1,
		-1,
		229,
		209,
		200,
		184,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		254,
		253,
		-1,
		222,
		225,
		-1,
		215,
		206,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		263,
		244,
		238,
		237,
		235,
		230,
		227,
		213,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		235,
		227,
		220,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		246,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		292,
		256,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		140,
		129,
		140,
		148,
		121,
		128,
		-1,
		147,
		151,
		117,
		111,
		150,
		119,
		125,
		136,
		-1,
		-1,
		-1,
		140,
		139,
		107,
		105,
		114,
		119,
		126,
		-1,
		125,
		-1,
		161,
		140,
		151,
		156,
		100,
		97,
		117,
		136,
		118,
		110,
		176,
		130,
		101,
		95,
		113,
		103,
		112,
		104,
		-1,
		101,
		91,
		113,
		92,
		103,
		92,
		-1,
		-1,
		95,
		96,
		102,
		88,
		94,
		90,
		-1,
		65,
		43,
		-1,
		-1,
		85,
		86,
		70,
		73,
		81,
		79,
		61,
		47,
		38,
		-1,
		-1,
		76,
		72,
		79,
		66,
		62,
		79,
		60,
		35,
		33,
		31,
		-1,
		88,
		105,
		105,
		73,
		71,
		55,
		53,
		70,
		32,
		31,
		25,
		-1,
		105,
		101,
		102,
		100,
		95,
		71,
		58,
		58,
		64,
		24,
		21,
		22,
		68,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		97,
		114,
		98,
		88,
		92,
		90,
		61,
		54,
		52,
		45,
		10,
		21,
		31,
		-1,
		-1,
		199,
		172,
		196,
		154,
		136,
		-1,
		102,
		102,
		96,
		92,
		86,
		79,
		92,
		77,
		-1,
		29,
		38,
		0,
		14,
		25,
		181,
		-1,
		-1,
		157,
		149,
		131,
		134,
		111,
		107,
		117,
		116,
		109,
		102,
		98,
		76,
		79,
		79,
		85,
		41,
		24,
		21,
		21,
		32,
		-1,
		-1,
		138,
		-1,
		-1,
		178,
		161,
		-1,
		126,
		133,
		117,
		123,
		109,
		130,
		127,
		118,
		112,
		107,
		99,
		74,
		71,
		84,
		63,
		38,
		31,
		34,
		24,
		42,
		43,
		-1,
		137,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		133,
		130,
		123,
		147,
		146,
		-1,
		147,
		135,
		136,
		121,
		120,
		114,
		102,
		79,
		63,
		63,
		60,
		45,
		47,
		58,
		26,
		47,
		44,
		75,
		113,
		107,
		116,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		151,
		-1,
		154,
		167,
		159,
		132,
		135,
		122,
		122,
		109,
		98,
		80,
		61,
		58,
		57,
		53,
		62,
		31,
		34,
		50,
		53,
		100,
		104,
		110,
		-1,
		236,
		-1,
		178,
		162,
		164,
		140,
		168,
		-1,
		171,
		155,
		175,
		161,
		161,
		-1,
		138,
		135,
		127,
		105,
		90,
		73,
		61,
		56,
		56,
		58,
		63,
		38,
		56,
		58,
		65,
		86,
		108,
		118,
		196,
		186,
		-1,
		168,
		173,
		143,
		155,
		175,
		198,
		177,
		-1,
		172,
		-1,
		140,
		153,
		-1,
		111,
		107,
		81,
		69,
		58,
		65,
		63,
		54,
		51,
		44,
		47,
		76,
		76,
		102,
		-1,
		-1,
		181,
		185,
		190,
		141,
		160,
		184,
		221,
		170,
		159,
		158,
		-1,
		149,
		117,
		114,
		111,
		98,
		83,
		81,
		64,
		70,
		68,
		53,
		56,
		53,
		95,
		81,
		93,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		167,
		138,
		162,
		204,
		188,
		181,
		169,
		134,
		134,
		128,
		-1,
		122,
		101,
		92,
		81,
		71,
		87,
		74,
		77,
		57,
		59,
		59,
		84,
		75,
		95,
		-1,
		-1,
		-1,
		197,
		186,
		187,
		133,
		156,
		193,
		167,
		153,
		158,
		133,
		126,
		120,
		126,
		118,
		99,
		88,
		80,
		69,
		75,
		85,
		79,
		59,
		68,
		66,
		90,
		97,
		103,
		-1,
		-1,
		204,
		194,
		178,
		180,
		177,
		147,
		154,
		186,
		158,
		171,
		-1,
		125,
		-1,
		114,
		109,
		93,
		88,
		85,
		82,
		76,
		85,
		87,
		73,
		64,
		79,
		95,
		95,
		87,
		112,
		115,
		-1,
		-1,
		-1,
		197,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		119,
		113,
		110,
		95,
		91,
		86,
		90,
		83,
		90,
		86,
		82,
		83,
		65,
		100,
		-1,
		95,
		89,
		117,
		120,
		110,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		95,
		93,
		87,
		91,
		95,
		84,
		97,
		90,
		70,
		80,
		100,
		104,
		108,
		101,
		106,
		105,
		119,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		101,
		99,
		115,
		99,
		102,
		102,
		98,
		106,
		91,
		87,
		73,
		77,
		95,
		119,
		114,
		112,
		111,
		115,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		111,
		107,
		122,
		123,
		101,
		106,
		105,
		115,
		109,
		98,
		85,
		89,
		104,
		114,
		106,
		107,
		116,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		179,
		-1,
		113,
		130,
		121,
		119,
		112,
		103,
		109,
		116,
		118,
		113,
		103,
		92,
		98,
		94,
		116,
		102,
		100,
		116,
		131,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		157,
		147,
		131,
		116,
		149,
		-1,
		120,
		104,
		109,
		-1,
		138,
		-1,
		111,
		111,
		102,
		91,
		88,
		99,
		97,
		108,
		122,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		144,
		138,
		138,
		122,
		125,
		136,
		116,
		110,
		109,
		133,
		128,
		119,
		100,
		93,
		90,
		91,
		104,
		124,
		115,
		124,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		206,
		161,
		147,
		-1,
		131,
		153,
		141,
		131,
		121,
		154,
		144,
		119,
		112,
		98,
		100,
		98,
		100,
		105,
		126,
		127,
		139,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		153,
		169,
		161,
		132,
		142,
		-1,
		-1,
		133,
		131,
		136,
		115,
		102,
		122,
		125,
		115,
		99,
		114,
		126,
		131,
		139,
		-1,
		157,
		144,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		161,
		156,
		160,
		136,
		-1,
		132,
		126,
		106,
		120,
		127,
		117,
		112,
		106,
		109,
		127,
		142,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		143,
		157,
		149,
		142,
		146,
		-1,
		134,
		122,
		108,
		125,
		130,
		127,
		118,
		110,
		115,
		112,
		125,
		139,
		143,
		192,
		-1,
		175,
		-1,
		-1,
		-1,
		161,
		176,
		188,
		165,
		138,
		133,
		126,
		120,
		116,
		132,
		138,
		149,
		117,
		113,
		114,
		118,
		117,
		134,
		144,
		-1,
		-1,
		175,
		192,
		187,
		169,
		173,
		215,
		-1,
		-1,
		142,
		133,
		124,
		127,
		126,
		129,
		123,
		120,
		125,
		130,
		118,
		127,
		145,
		144,
		-1,
		-1,
		-1,
		195,
		-1,
		210,
		-1,
		-1,
		188,
		213,
		160,
		142,
		138,
		136,
		129,
		138,
		133,
		128,
		138,
		140,
		132,
		120,
		124,
		147,
		136,
		175,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		224,
		199,
		214,
		224,
		208,
		215,
		175,
		172,
		-1,
		142,
		167,
		139,
		146,
		137,
		144,
		144,
		136,
		114,
		121,
		137,
		136,
		131,
		167,
		158,
		164,
		-1,
		-1,
		307,
		296,
		285,
		291,
		-1,
		224,
		216,
		210,
		200,
		203,
		-1,
		-1,
		191,
		188,
		164,
		147,
		145,
		138,
		133,
		143,
		123,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		202,
		283,
		276,
		259,
		267,
		298,
		-1,
		214,
		206,
		217,
		192,
		194,
		-1,
		-1,
		164,
		161,
		166,
		154,
		151,
		153,
		148,
		139,
		124,
		130,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		216,
		259,
		253,
		256,
		280,
		294,
		-1,
		211,
		-1,
		-1,
		223,
		195,
		179,
		169,
		163,
		213,
		168,
		163,
		147,
		145,
		136,
		127,
		134,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		251,
		239,
		247,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		239,
		-1,
		206,
		-1,
		181,
		185,
		176,
		179,
		161,
		148,
		140,
		132,
		148,
		123,
		133,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		282,
		238,
		241,
		238,
		263,
		278,
		282,
		-1,
		223,
		262,
		260,
		-1,
		244,
		-1,
		-1,
		-1,
		195,
		189,
		181,
		181,
		160,
		160,
		134,
		138,
		128,
		135,
		145,
		147,
		139,
		143,
		156,
		167,
		170,
		278,
		269,
		282,
		227,
		227,
		248,
		257,
		278,
		238,
		229,
		256,
		267,
		256,
		251,
		238,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		167,
		155,
		138,
		139,
		135,
		138,
		153,
		156,
		146,
		144,
		138,
		170,
		-1,
		271,
		270,
		259,
		256,
		232,
		223,
		218,
		245,
		-1,
		-1,
		240,
		257,
		251,
		255,
		271,
		296,
		-1,
		227,
		-1,
		-1,
		212,
		-1,
		-1,
		197,
		160,
		149,
		140,
		146,
		143,
		154,
		164,
		152,
		153,
		143,
		153,
		166,
		255,
		252,
		240,
		238,
		261,
		226,
		214,
		-1,
		227,
		225,
		231,
		238,
		255,
		285,
		-1,
		-1,
		243,
		223,
		-1,
		-1,
		195,
		193,
		182,
		-1,
		172,
		145,
		150,
		170,
		172,
		161,
		155,
		149,
		156,
		155,
		163,
		171,
		264,
		278,
		267,
		263,
		262,
		270,
		219,
		212,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		-1,
		233,
		229,
		-1,
		-1,
		190,
		183,
		171,
		159,
		149,
		159,
		163,
		167,
		159,
		152,
		147,
		158,
		150,
		154,
		171,
		-1,
		298,
		-1,
		250,
		226,
		240,
		255,
		263,
		-1,
		-1,
		-1,
		250,
		236,
		229,
		217,
		215,
		-1,
		224,
		208,
		189,
		-1,
		159,
		172,
		203,
		171,
		176,
		171,
		153,
		164,
		153,
		156,
		170,
		165,
		-1,
		-1,
		238,
		241,
		-1,
		-1,
		240,
		242,
		-1,
		241,
		230,
		215,
		207,
		-1,
		-1,
		196,
		192,
		-1,
		-1,
		160,
		185,
		174,
		182,
		177,
		157,
		163,
		166,
		155,
		159,
		171,
		-1,
		-1,
		245,
		246,
		247,
		-1,
		225,
		-1,
		243,
		-1,
		210,
		216,
		204,
		-1,
		-1,
		-1,
		198,
		161,
		182,
		192,
		186,
		184,
		175,
		161,
		168,
		166,
		162,
		173,
		-1,
		-1,
		-1,
		243,
		217,
		250,
		241,
		224,
		204,
		196,
		215,
		-1,
		185,
		-1,
		160,
		162,
		188,
		191,
		197,
		191,
		164,
		179,
		169,
		160,
		169,
		249,
		-1,
		219,
		252,
		216,
		210,
		186,
		190,
		206,
		-1,
		182,
		164,
		-1,
		192,
		182,
		213,
		198,
		179,
		166,
		173,
		173,
		166,
		-1,
		-1,
		-1,
		221,
		220,
		212,
		206,
		206,
		191,
		182,
		-1,
		194,
		176,
		155,
		172,
		172,
		163,
		171,
		203,
		199,
		186,
		186,
		178,
		-1,
		322,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		215,
		210,
		183,
		171,
		177,
		173,
		159,
		165,
		167,
		175,
		173,
		170,
		182,
		178,
		198,
		179,
		214,
		-1,
		317,
		-1,
		251,
		-1,
		-1,
		233,
		213,
		205,
		194,
		183,
		181,
		172,
		163,
		185,
		201,
		185,
		183,
		186,
		187,
		-1,
		306,
		305,
		-1,
		252,
		244,
		230,
		-1,
		223,
		-1,
		229,
		190,
		-1,
		192,
		172,
		-1,
		194,
		190,
		-1,
		-1,
		293,
		268,
		-1,
		-1,
		-1,
		253,
		233,
		224,
		208,
		-1,
		183,
		183,
		-1,
		-1,
		-1,
		278,
		277,
		-1,
		246,
		249,
		-1,
		239,
		230,
		238,
		185,
		189,
		-1,
		-1,
		-1,
		287,
		268,
		262,
		261,
		259,
		254,
		251,
		237,
		221,
		199,
		188,
		209,
		-1,
		-1,
		-1,
		259,
		251,
		244,
		-1,
		-1,
		246,
		229,
		210,
		208,
		-1,
		-1,
		-1,
		281,
		262,
		-1,
		-1,
		236,
		-1,
		-1,
		242,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		298,
		270,
		-1,
		-1,
		-1,
		232,
		228,
		229,
		-1,
		-1,
		-1,
		-1,
		292,
		293,
		316,
		280,
		-1,
		-1,
		-1,
		224,
		218,
		-1,
		-1,
		295,
		293,
		-1,
		-1,
		-1,
		252,
		236,
		-1,
		222,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		257,
		-1,
		257,
		232,
		239,
		-1,
		-1,
		-1,
		-1,
		270,
		262,
		270,
		-1,
		242,
		244,
		-1,
		292,
		-1,
		-1,
		285,
		276,
		-1,
		-1,
		247,
		254,
		276,
		279,
		315,
		-1,
		266
	],
	[
		-1,
		126,
		115,
		126,
		134,
		107,
		114,
		-1,
		133,
		137,
		103,
		97,
		136,
		105,
		111,
		122,
		-1,
		-1,
		-1,
		126,
		125,
		93,
		91,
		100,
		105,
		112,
		-1,
		111,
		-1,
		147,
		126,
		137,
		142,
		86,
		83,
		103,
		122,
		104,
		96,
		162,
		116,
		87,
		81,
		99,
		89,
		98,
		90,
		-1,
		87,
		77,
		99,
		78,
		89,
		81,
		-1,
		-1,
		81,
		82,
		88,
		74,
		80,
		76,
		-1,
		74,
		47,
		-1,
		-1,
		71,
		72,
		56,
		59,
		67,
		65,
		70,
		56,
		42,
		-1,
		-1,
		62,
		58,
		65,
		52,
		48,
		65,
		73,
		42,
		29,
		27,
		-1,
		74,
		91,
		91,
		59,
		57,
		41,
		39,
		57,
		44,
		27,
		19,
		-1,
		91,
		87,
		88,
		86,
		81,
		57,
		44,
		44,
		54,
		38,
		21,
		8,
		54,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		83,
		100,
		84,
		74,
		78,
		76,
		47,
		44,
		42,
		31,
		24,
		7,
		17,
		-1,
		-1,
		185,
		158,
		182,
		140,
		122,
		-1,
		88,
		88,
		82,
		78,
		72,
		65,
		78,
		63,
		-1,
		15,
		24,
		14,
		0,
		11,
		167,
		-1,
		-1,
		143,
		135,
		117,
		120,
		97,
		93,
		103,
		102,
		95,
		88,
		84,
		62,
		65,
		65,
		71,
		27,
		10,
		7,
		7,
		18,
		-1,
		-1,
		124,
		-1,
		-1,
		164,
		147,
		-1,
		112,
		119,
		103,
		109,
		95,
		116,
		113,
		104,
		98,
		93,
		85,
		60,
		57,
		70,
		49,
		24,
		17,
		20,
		10,
		28,
		29,
		-1,
		123,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		119,
		116,
		109,
		133,
		132,
		-1,
		133,
		121,
		122,
		107,
		106,
		100,
		88,
		65,
		49,
		49,
		46,
		31,
		33,
		44,
		12,
		33,
		30,
		61,
		99,
		93,
		102,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		137,
		-1,
		140,
		153,
		145,
		118,
		121,
		108,
		108,
		95,
		84,
		66,
		47,
		44,
		43,
		39,
		48,
		17,
		20,
		36,
		39,
		86,
		90,
		96,
		-1,
		222,
		-1,
		164,
		148,
		150,
		126,
		154,
		-1,
		157,
		141,
		161,
		147,
		147,
		-1,
		124,
		121,
		113,
		91,
		76,
		59,
		47,
		42,
		42,
		44,
		49,
		24,
		42,
		44,
		51,
		72,
		94,
		104,
		182,
		172,
		-1,
		154,
		159,
		129,
		141,
		161,
		184,
		163,
		-1,
		158,
		-1,
		126,
		139,
		-1,
		97,
		93,
		67,
		55,
		44,
		51,
		49,
		40,
		37,
		30,
		33,
		62,
		62,
		88,
		-1,
		-1,
		167,
		171,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		103,
		100,
		97,
		84,
		69,
		67,
		50,
		56,
		54,
		39,
		42,
		39,
		81,
		67,
		79,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		57,
		73,
		60,
		63,
		43,
		45,
		45,
		70,
		61,
		81,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		112,
		104,
		85,
		74,
		66,
		55,
		61,
		71,
		65,
		45,
		54,
		52,
		76,
		83,
		89,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		68,
		62,
		71,
		73,
		59,
		50,
		65,
		81,
		81,
		73,
		98,
		101,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		72,
		76,
		69,
		76,
		72,
		68,
		69,
		51,
		86,
		-1,
		81,
		75,
		103,
		106,
		96,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		81,
		79,
		73,
		77,
		81,
		70,
		83,
		76,
		56,
		66,
		86,
		90,
		94,
		87,
		92,
		91,
		105,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		88,
		88,
		84,
		92,
		77,
		73,
		59,
		63,
		81,
		105,
		100,
		98,
		97,
		101,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		93,
		108,
		109,
		87,
		92,
		91,
		101,
		95,
		84,
		71,
		75,
		90,
		100,
		92,
		93,
		102,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		107,
		105,
		98,
		89,
		95,
		102,
		104,
		99,
		89,
		78,
		84,
		80,
		102,
		88,
		86,
		102,
		117,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		106,
		90,
		95,
		-1,
		124,
		-1,
		97,
		97,
		88,
		77,
		74,
		85,
		83,
		94,
		108,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		122,
		102,
		96,
		95,
		119,
		114,
		105,
		86,
		79,
		76,
		77,
		90,
		110,
		101,
		110,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		139,
		127,
		117,
		107,
		140,
		130,
		105,
		98,
		84,
		86,
		84,
		86,
		91,
		112,
		113,
		125,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		128,
		-1,
		-1,
		119,
		117,
		122,
		101,
		88,
		108,
		111,
		101,
		85,
		100,
		112,
		117,
		125,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		147,
		142,
		146,
		122,
		-1,
		118,
		112,
		92,
		106,
		113,
		103,
		98,
		92,
		95,
		113,
		128,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		129,
		143,
		135,
		128,
		132,
		-1,
		120,
		108,
		94,
		111,
		116,
		113,
		104,
		96,
		101,
		98,
		111,
		125,
		129,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		147,
		162,
		174,
		151,
		124,
		119,
		112,
		106,
		102,
		118,
		124,
		135,
		103,
		99,
		100,
		104,
		103,
		120,
		130,
		-1,
		-1,
		161,
		178,
		173,
		155,
		159,
		201,
		-1,
		-1,
		128,
		119,
		110,
		113,
		112,
		115,
		109,
		106,
		111,
		116,
		104,
		113,
		131,
		130,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		174,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		126,
		118,
		106,
		110,
		133,
		122,
		161,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		210,
		185,
		200,
		210,
		194,
		201,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		123,
		130,
		130,
		122,
		100,
		107,
		123,
		122,
		117,
		153,
		144,
		150,
		-1,
		-1,
		293,
		282,
		271,
		277,
		-1,
		210,
		202,
		196,
		186,
		189,
		-1,
		-1,
		177,
		174,
		150,
		133,
		131,
		124,
		119,
		129,
		109,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		188,
		269,
		262,
		245,
		253,
		284,
		-1,
		200,
		192,
		203,
		178,
		180,
		-1,
		-1,
		150,
		147,
		152,
		140,
		137,
		139,
		134,
		125,
		110,
		116,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		202,
		245,
		239,
		242,
		266,
		280,
		-1,
		197,
		-1,
		-1,
		209,
		181,
		165,
		155,
		149,
		199,
		154,
		149,
		133,
		131,
		122,
		113,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		237,
		225,
		233,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		225,
		-1,
		192,
		-1,
		167,
		171,
		162,
		165,
		147,
		134,
		126,
		118,
		134,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		268,
		224,
		227,
		224,
		249,
		264,
		268,
		-1,
		209,
		248,
		246,
		-1,
		230,
		-1,
		-1,
		-1,
		181,
		175,
		167,
		167,
		146,
		146,
		120,
		124,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		264,
		255,
		268,
		213,
		213,
		234,
		243,
		264,
		224,
		215,
		242,
		253,
		242,
		237,
		224,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		153,
		141,
		124,
		125,
		121,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		204,
		231,
		-1,
		-1,
		226,
		243,
		237,
		241,
		257,
		282,
		-1,
		213,
		-1,
		-1,
		198,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		129,
		140,
		150,
		138,
		139,
		129,
		139,
		152,
		241,
		238,
		226,
		224,
		247,
		212,
		200,
		-1,
		213,
		211,
		217,
		224,
		241,
		271,
		-1,
		-1,
		229,
		209,
		-1,
		-1,
		181,
		179,
		168,
		-1,
		158,
		131,
		136,
		156,
		158,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		198,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		215,
		-1,
		-1,
		176,
		169,
		157,
		145,
		135,
		145,
		149,
		153,
		145,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		284,
		-1,
		236,
		212,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		226,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		231,
		232,
		233,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		172,
		170,
		161,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		148,
		174,
		177,
		183,
		177,
		150,
		165,
		155,
		146,
		155,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		199,
		184,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		189,
		185,
		172,
		172,
		164,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		165,
		200,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		172,
		173,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		139,
		128,
		139,
		147,
		120,
		127,
		-1,
		146,
		150,
		116,
		110,
		149,
		118,
		124,
		135,
		-1,
		-1,
		-1,
		139,
		138,
		106,
		104,
		113,
		118,
		125,
		-1,
		124,
		-1,
		160,
		139,
		150,
		155,
		99,
		96,
		116,
		135,
		117,
		109,
		175,
		129,
		100,
		94,
		112,
		102,
		111,
		103,
		-1,
		100,
		90,
		112,
		91,
		102,
		94,
		-1,
		-1,
		94,
		95,
		101,
		87,
		93,
		89,
		-1,
		87,
		60,
		-1,
		-1,
		84,
		85,
		69,
		72,
		80,
		78,
		83,
		69,
		55,
		-1,
		-1,
		75,
		71,
		78,
		65,
		61,
		78,
		86,
		55,
		42,
		40,
		-1,
		87,
		104,
		104,
		72,
		70,
		54,
		52,
		70,
		57,
		40,
		32,
		-1,
		104,
		100,
		101,
		99,
		94,
		70,
		57,
		57,
		67,
		51,
		34,
		21,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		105,
		96,
		113,
		97,
		87,
		91,
		89,
		60,
		57,
		55,
		44,
		37,
		20,
		6,
		-1,
		-1,
		198,
		171,
		195,
		153,
		135,
		-1,
		101,
		101,
		95,
		91,
		85,
		78,
		91,
		76,
		-1,
		28,
		37,
		27,
		13,
		0,
		180,
		-1,
		-1,
		156,
		148,
		130,
		133,
		110,
		106,
		116,
		115,
		108,
		101,
		97,
		75,
		78,
		78,
		84,
		40,
		23,
		20,
		20,
		25,
		-1,
		-1,
		133,
		-1,
		-1,
		177,
		160,
		-1,
		125,
		132,
		116,
		122,
		108,
		129,
		126,
		117,
		111,
		106,
		98,
		73,
		70,
		83,
		62,
		37,
		24,
		27,
		23,
		35,
		36,
		-1,
		132,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		132,
		129,
		122,
		146,
		145,
		-1,
		146,
		134,
		135,
		120,
		119,
		113,
		101,
		78,
		62,
		62,
		59,
		44,
		46,
		57,
		25,
		40,
		37,
		68,
		108,
		102,
		111,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		150,
		-1,
		153,
		166,
		158,
		131,
		134,
		121,
		121,
		108,
		97,
		79,
		60,
		57,
		56,
		52,
		61,
		30,
		33,
		49,
		46,
		95,
		99,
		105,
		-1,
		235,
		-1,
		177,
		161,
		163,
		139,
		167,
		-1,
		170,
		154,
		174,
		160,
		160,
		-1,
		137,
		134,
		126,
		104,
		89,
		72,
		60,
		55,
		55,
		57,
		62,
		37,
		55,
		57,
		58,
		81,
		103,
		113,
		195,
		185,
		-1,
		167,
		172,
		142,
		154,
		174,
		197,
		176,
		-1,
		171,
		-1,
		139,
		152,
		-1,
		110,
		106,
		80,
		68,
		57,
		64,
		62,
		53,
		50,
		43,
		46,
		71,
		69,
		97,
		-1,
		-1,
		180,
		184,
		189,
		140,
		159,
		183,
		220,
		169,
		158,
		157,
		-1,
		148,
		116,
		113,
		110,
		97,
		82,
		80,
		63,
		69,
		67,
		52,
		55,
		52,
		90,
		74,
		92,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		166,
		137,
		161,
		203,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		121,
		100,
		91,
		80,
		70,
		86,
		73,
		76,
		56,
		58,
		58,
		83,
		74,
		94,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		166,
		152,
		157,
		132,
		125,
		119,
		125,
		117,
		98,
		87,
		79,
		68,
		74,
		84,
		78,
		58,
		67,
		65,
		89,
		96,
		102,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		81,
		75,
		84,
		86,
		72,
		63,
		78,
		94,
		94,
		86,
		111,
		114,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		85,
		89,
		82,
		89,
		85,
		81,
		82,
		64,
		99,
		-1,
		94,
		88,
		116,
		119,
		109,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		94,
		92,
		86,
		90,
		94,
		83,
		96,
		89,
		69,
		79,
		99,
		103,
		107,
		100,
		105,
		104,
		118,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		101,
		101,
		97,
		105,
		90,
		86,
		72,
		76,
		94,
		118,
		113,
		111,
		110,
		114,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		106,
		121,
		122,
		100,
		105,
		104,
		114,
		108,
		97,
		84,
		88,
		103,
		113,
		105,
		106,
		115,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		120,
		118,
		111,
		102,
		108,
		115,
		117,
		112,
		102,
		91,
		97,
		93,
		115,
		101,
		99,
		115,
		130,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		137,
		-1,
		110,
		110,
		101,
		90,
		87,
		98,
		96,
		107,
		121,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		132,
		127,
		118,
		99,
		92,
		89,
		90,
		103,
		123,
		114,
		123,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		152,
		140,
		130,
		120,
		153,
		143,
		118,
		111,
		97,
		99,
		97,
		99,
		104,
		125,
		126,
		138,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		141,
		-1,
		-1,
		132,
		130,
		135,
		114,
		101,
		121,
		124,
		114,
		98,
		113,
		125,
		130,
		138,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		160,
		155,
		159,
		135,
		-1,
		131,
		125,
		105,
		119,
		126,
		116,
		111,
		105,
		108,
		126,
		141,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		148,
		141,
		145,
		-1,
		133,
		121,
		107,
		124,
		129,
		126,
		117,
		109,
		114,
		111,
		124,
		138,
		142,
		191,
		-1,
		174,
		-1,
		-1,
		-1,
		160,
		175,
		187,
		164,
		137,
		132,
		125,
		119,
		115,
		131,
		137,
		148,
		116,
		112,
		113,
		117,
		116,
		133,
		143,
		-1,
		-1,
		174,
		191,
		186,
		168,
		172,
		214,
		-1,
		-1,
		141,
		132,
		123,
		126,
		125,
		128,
		122,
		119,
		124,
		129,
		117,
		126,
		144,
		143,
		-1,
		-1,
		-1,
		194,
		-1,
		209,
		-1,
		-1,
		187,
		212,
		159,
		141,
		137,
		135,
		128,
		137,
		132,
		127,
		137,
		139,
		131,
		119,
		123,
		146,
		135,
		174,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		223,
		198,
		213,
		223,
		207,
		214,
		174,
		171,
		-1,
		141,
		166,
		138,
		145,
		136,
		143,
		143,
		135,
		113,
		120,
		136,
		135,
		130,
		166,
		157,
		163,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		223,
		215,
		209,
		199,
		202,
		-1,
		-1,
		190,
		187,
		163,
		146,
		144,
		137,
		132,
		142,
		122,
		109,
		113,
		117,
		123,
		128,
		133,
		139,
		154,
		169,
		-1,
		201,
		282,
		275,
		258,
		266,
		297,
		-1,
		213,
		205,
		216,
		191,
		193,
		-1,
		-1,
		163,
		160,
		165,
		153,
		150,
		152,
		147,
		138,
		123,
		129,
		116,
		115,
		133,
		137,
		146,
		153,
		143,
		156,
		160,
		-1,
		215,
		258,
		252,
		255,
		279,
		293,
		-1,
		210,
		-1,
		-1,
		222,
		194,
		178,
		168,
		162,
		212,
		167,
		162,
		146,
		144,
		135,
		126,
		133,
		124,
		124,
		127,
		142,
		147,
		139,
		153,
		153,
		154,
		-1,
		250,
		238,
		246,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		238,
		-1,
		205,
		-1,
		180,
		184,
		175,
		178,
		160,
		147,
		139,
		131,
		147,
		122,
		132,
		128,
		129,
		138,
		149,
		161,
		160,
		161,
		281,
		237,
		240,
		237,
		262,
		277,
		281,
		-1,
		222,
		261,
		259,
		-1,
		243,
		-1,
		-1,
		-1,
		194,
		188,
		180,
		180,
		159,
		159,
		133,
		137,
		127,
		134,
		144,
		146,
		138,
		142,
		155,
		166,
		169,
		277,
		268,
		281,
		226,
		226,
		247,
		256,
		277,
		237,
		228,
		255,
		266,
		255,
		250,
		237,
		-1,
		-1,
		217,
		198,
		-1,
		-1,
		166,
		154,
		137,
		138,
		134,
		137,
		152,
		155,
		145,
		143,
		137,
		169,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		217,
		244,
		-1,
		-1,
		239,
		256,
		250,
		254,
		270,
		295,
		-1,
		226,
		-1,
		-1,
		211,
		-1,
		-1,
		196,
		159,
		148,
		139,
		145,
		142,
		153,
		163,
		151,
		152,
		142,
		152,
		165,
		254,
		251,
		239,
		237,
		260,
		225,
		213,
		-1,
		226,
		224,
		230,
		237,
		254,
		284,
		-1,
		-1,
		242,
		222,
		-1,
		-1,
		194,
		192,
		181,
		-1,
		171,
		144,
		149,
		169,
		171,
		160,
		154,
		148,
		155,
		154,
		162,
		170,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		211,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		232,
		228,
		-1,
		-1,
		189,
		182,
		170,
		158,
		148,
		158,
		162,
		166,
		158,
		151,
		146,
		157,
		149,
		153,
		170,
		-1,
		297,
		-1,
		249,
		225,
		239,
		254,
		262,
		-1,
		-1,
		-1,
		249,
		235,
		228,
		216,
		214,
		-1,
		223,
		207,
		188,
		-1,
		158,
		171,
		202,
		170,
		175,
		170,
		152,
		163,
		152,
		155,
		169,
		164,
		-1,
		-1,
		237,
		240,
		-1,
		-1,
		239,
		241,
		-1,
		240,
		229,
		214,
		206,
		-1,
		-1,
		195,
		191,
		-1,
		-1,
		159,
		184,
		173,
		181,
		176,
		156,
		162,
		165,
		154,
		158,
		170,
		-1,
		-1,
		244,
		245,
		246,
		-1,
		224,
		-1,
		242,
		-1,
		209,
		215,
		203,
		-1,
		-1,
		-1,
		197,
		160,
		181,
		191,
		185,
		183,
		174,
		160,
		167,
		165,
		161,
		172,
		-1,
		-1,
		-1,
		242,
		216,
		249,
		240,
		223,
		203,
		195,
		214,
		-1,
		184,
		-1,
		159,
		161,
		187,
		190,
		196,
		190,
		163,
		178,
		168,
		159,
		168,
		248,
		-1,
		218,
		251,
		215,
		209,
		185,
		189,
		205,
		-1,
		181,
		163,
		-1,
		191,
		181,
		212,
		197,
		178,
		165,
		172,
		172,
		165,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		205,
		190,
		181,
		-1,
		193,
		175,
		154,
		171,
		171,
		162,
		170,
		202,
		198,
		185,
		185,
		177,
		-1,
		321,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		209,
		182,
		170,
		176,
		172,
		158,
		164,
		166,
		174,
		172,
		169,
		181,
		177,
		197,
		178,
		213,
		-1,
		316,
		-1,
		250,
		-1,
		-1,
		232,
		212,
		204,
		193,
		182,
		180,
		171,
		162,
		184,
		200,
		184,
		182,
		185,
		186,
		-1,
		305,
		304,
		-1,
		251,
		243,
		229,
		-1,
		222,
		-1,
		228,
		189,
		-1,
		191,
		171,
		-1,
		193,
		189,
		-1,
		-1,
		292,
		267,
		-1,
		-1,
		-1,
		252,
		232,
		223,
		207,
		-1,
		182,
		182,
		-1,
		-1,
		-1,
		277,
		276,
		-1,
		245,
		248,
		-1,
		238,
		229,
		237,
		184,
		188,
		-1,
		-1,
		-1,
		286,
		267,
		261,
		260,
		258,
		253,
		250,
		236,
		220,
		198,
		187,
		208,
		-1,
		-1,
		-1,
		258,
		250,
		243,
		-1,
		-1,
		245,
		228,
		209,
		207,
		-1,
		-1,
		-1,
		280,
		261,
		-1,
		-1,
		235,
		-1,
		-1,
		241,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		269,
		-1,
		-1,
		-1,
		231,
		227,
		228,
		-1,
		-1,
		-1,
		-1,
		291,
		292,
		315,
		279,
		-1,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		294,
		292,
		-1,
		-1,
		-1,
		251,
		235,
		-1,
		221,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		256,
		-1,
		256,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		269,
		261,
		269,
		-1,
		241,
		243,
		-1,
		291,
		-1,
		-1,
		284,
		275,
		-1,
		-1,
		246,
		253,
		275,
		278,
		314,
		-1,
		265
	],
	[
		-1,
		163,
		152,
		163,
		171,
		144,
		151,
		-1,
		172,
		174,
		140,
		134,
		173,
		144,
		150,
		161,
		-1,
		-1,
		-1,
		163,
		162,
		132,
		130,
		139,
		144,
		151,
		-1,
		174,
		-1,
		184,
		163,
		174,
		179,
		125,
		122,
		142,
		161,
		167,
		159,
		199,
		155,
		126,
		120,
		138,
		143,
		161,
		153,
		-1,
		126,
		116,
		138,
		142,
		154,
		137,
		-1,
		-1,
		120,
		121,
		127,
		139,
		144,
		149,
		-1,
		175,
		194,
		-1,
		-1,
		110,
		123,
		119,
		122,
		130,
		146,
		167,
		184,
		189,
		-1,
		-1,
		111,
		115,
		128,
		129,
		127,
		154,
		173,
		184,
		198,
		197,
		-1,
		99,
		117,
		126,
		135,
		141,
		130,
		134,
		152,
		183,
		189,
		192,
		-1,
		91,
		93,
		122,
		128,
		140,
		146,
		133,
		139,
		158,
		171,
		190,
		181,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		88,
		96,
		122,
		121,
		117,
		135,
		157,
		136,
		142,
		146,
		163,
		179,
		180,
		190,
		-1,
		-1,
		139,
		108,
		143,
		100,
		85,
		-1,
		84,
		103,
		109,
		113,
		118,
		126,
		154,
		152,
		-1,
		157,
		156,
		187,
		173,
		184,
		0,
		-1,
		-1,
		97,
		89,
		74,
		77,
		74,
		79,
		109,
		108,
		113,
		115,
		117,
		129,
		144,
		144,
		154,
		151,
		161,
		165,
		180,
		191,
		-1,
		-1,
		265,
		-1,
		-1,
		17,
		37,
		-1,
		62,
		69,
		69,
		86,
		77,
		102,
		117,
		121,
		129,
		132,
		120,
		139,
		136,
		160,
		156,
		148,
		173,
		177,
		183,
		201,
		202,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		32,
		55,
		58,
		64,
		88,
		98,
		-1,
		124,
		122,
		146,
		140,
		145,
		141,
		126,
		144,
		142,
		157,
		159,
		155,
		157,
		194,
		185,
		206,
		203,
		234,
		240,
		234,
		243,
		-1,
		104,
		100,
		96,
		103,
		52,
		-1,
		-1,
		92,
		-1,
		106,
		119,
		136,
		126,
		129,
		141,
		149,
		148,
		132,
		150,
		145,
		148,
		167,
		163,
		172,
		182,
		181,
		199,
		212,
		227,
		231,
		237,
		-1,
		154,
		-1,
		96,
		80,
		82,
		58,
		86,
		-1,
		112,
		107,
		127,
		138,
		138,
		-1,
		154,
		151,
		164,
		148,
		133,
		150,
		152,
		156,
		166,
		170,
		185,
		176,
		194,
		201,
		209,
		213,
		233,
		245,
		114,
		104,
		-1,
		86,
		91,
		61,
		73,
		109,
		150,
		134,
		-1,
		149,
		-1,
		156,
		169,
		-1,
		154,
		150,
		139,
		155,
		163,
		170,
		173,
		167,
		164,
		182,
		185,
		202,
		206,
		222,
		-1,
		-1,
		99,
		103,
		124,
		67,
		94,
		118,
		155,
		143,
		152,
		154,
		-1,
		174,
		175,
		172,
		173,
		159,
		152,
		153,
		169,
		175,
		167,
		166,
		169,
		191,
		219,
		197,
		209,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		101,
		72,
		96,
		138,
		182,
		175,
		163,
		161,
		161,
		155,
		-1,
		190,
		169,
		166,
		157,
		162,
		175,
		170,
		186,
		170,
		172,
		188,
		200,
		191,
		211,
		-1,
		-1,
		-1,
		131,
		120,
		121,
		75,
		109,
		127,
		194,
		180,
		185,
		160,
		153,
		147,
		184,
		186,
		163,
		171,
		163,
		152,
		166,
		174,
		178,
		172,
		181,
		182,
		206,
		213,
		219,
		-1,
		-1,
		138,
		128,
		112,
		114,
		111,
		100,
		107,
		139,
		185,
		182,
		-1,
		152,
		-1,
		141,
		149,
		148,
		154,
		166,
		152,
		157,
		168,
		180,
		186,
		177,
		192,
		211,
		211,
		203,
		228,
		231,
		-1,
		-1,
		-1,
		131,
		148,
		123,
		100,
		81,
		117,
		-1,
		152,
		153,
		-1,
		146,
		140,
		146,
		145,
		152,
		149,
		149,
		163,
		171,
		167,
		183,
		189,
		178,
		214,
		-1,
		211,
		205,
		226,
		216,
		204,
		-1,
		-1,
		-1,
		146,
		125,
		118,
		138,
		88,
		140,
		-1,
		-1,
		137,
		130,
		-1,
		133,
		133,
		140,
		149,
		154,
		159,
		167,
		162,
		175,
		180,
		183,
		191,
		209,
		213,
		217,
		206,
		202,
		199,
		213,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		108,
		-1,
		145,
		137,
		128,
		122,
		128,
		146,
		144,
		164,
		156,
		170,
		170,
		176,
		184,
		169,
		172,
		186,
		186,
		204,
		212,
		204,
		198,
		197,
		209,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		123,
		-1,
		94,
		118,
		134,
		-1,
		162,
		141,
		164,
		142,
		156,
		152,
		190,
		191,
		169,
		174,
		182,
		192,
		194,
		183,
		194,
		186,
		208,
		208,
		192,
		193,
		202,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		97,
		110,
		121,
		-1,
		-1,
		206,
		-1,
		140,
		157,
		166,
		164,
		180,
		171,
		177,
		193,
		196,
		198,
		188,
		177,
		183,
		180,
		202,
		188,
		186,
		205,
		221,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		184,
		174,
		158,
		143,
		176,
		-1,
		188,
		172,
		177,
		-1,
		223,
		-1,
		196,
		198,
		192,
		177,
		174,
		185,
		183,
		194,
		211,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		154,
		-1,
		-1,
		171,
		165,
		165,
		149,
		152,
		204,
		184,
		178,
		177,
		218,
		218,
		204,
		190,
		183,
		180,
		177,
		190,
		210,
		201,
		213,
		-1,
		-1,
		-1,
		155,
		135,
		141,
		99,
		120,
		-1,
		-1,
		233,
		188,
		174,
		-1,
		158,
		221,
		209,
		199,
		189,
		223,
		224,
		209,
		202,
		188,
		190,
		188,
		186,
		191,
		212,
		213,
		226,
		-1,
		-1,
		132,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		180,
		196,
		188,
		159,
		210,
		-1,
		-1,
		201,
		199,
		209,
		205,
		192,
		212,
		215,
		201,
		185,
		200,
		212,
		220,
		225,
		-1,
		135,
		122,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		191,
		212,
		237,
		204,
		-1,
		209,
		210,
		196,
		210,
		217,
		203,
		198,
		192,
		195,
		213,
		230,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		170,
		184,
		205,
		211,
		223,
		-1,
		218,
		212,
		198,
		215,
		216,
		213,
		204,
		196,
		201,
		198,
		211,
		225,
		229,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		188,
		203,
		265,
		242,
		215,
		219,
		212,
		206,
		206,
		222,
		224,
		235,
		203,
		199,
		200,
		204,
		203,
		220,
		230,
		-1,
		-1,
		155,
		172,
		207,
		196,
		200,
		292,
		-1,
		-1,
		228,
		219,
		210,
		213,
		216,
		219,
		209,
		206,
		211,
		216,
		204,
		213,
		231,
		235,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		215,
		299,
		246,
		228,
		224,
		222,
		215,
		224,
		219,
		214,
		224,
		233,
		225,
		206,
		217,
		240,
		229,
		267,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		204,
		179,
		194,
		240,
		235,
		236,
		261,
		258,
		-1,
		228,
		253,
		225,
		232,
		224,
		232,
		232,
		229,
		207,
		214,
		230,
		229,
		224,
		259,
		251,
		257,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		210,
		196,
		226,
		216,
		222,
		-1,
		-1,
		269,
		266,
		250,
		234,
		238,
		231,
		226,
		236,
		216,
		203,
		207,
		211,
		217,
		222,
		227,
		233,
		248,
		263,
		-1,
		180,
		261,
		254,
		237,
		245,
		276,
		-1,
		213,
		222,
		203,
		208,
		216,
		-1,
		-1,
		242,
		238,
		243,
		241,
		238,
		246,
		241,
		232,
		217,
		223,
		210,
		209,
		227,
		231,
		240,
		247,
		237,
		250,
		254,
		-1,
		194,
		237,
		231,
		234,
		258,
		272,
		-1,
		226,
		-1,
		-1,
		211,
		229,
		237,
		233,
		237,
		290,
		255,
		250,
		240,
		238,
		229,
		220,
		227,
		218,
		218,
		221,
		236,
		241,
		233,
		247,
		247,
		248,
		-1,
		229,
		217,
		225,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		227,
		-1,
		263,
		-1,
		256,
		260,
		263,
		266,
		254,
		241,
		233,
		225,
		241,
		216,
		226,
		222,
		223,
		232,
		243,
		255,
		254,
		255,
		303,
		258,
		225,
		216,
		263,
		278,
		282,
		-1,
		239,
		278,
		265,
		-1,
		236,
		-1,
		-1,
		-1,
		270,
		276,
		268,
		274,
		253,
		253,
		227,
		231,
		221,
		228,
		238,
		240,
		232,
		236,
		249,
		260,
		263,
		299,
		297,
		302,
		247,
		230,
		248,
		257,
		278,
		254,
		245,
		272,
		272,
		261,
		256,
		243,
		-1,
		-1,
		293,
		286,
		-1,
		-1,
		260,
		248,
		231,
		232,
		228,
		231,
		246,
		249,
		239,
		237,
		231,
		263,
		-1,
		299,
		298,
		287,
		284,
		260,
		251,
		238,
		249,
		-1,
		-1,
		257,
		273,
		286,
		290,
		303,
		328,
		-1,
		246,
		-1,
		-1,
		305,
		-1,
		-1,
		290,
		253,
		242,
		233,
		239,
		236,
		247,
		257,
		245,
		246,
		236,
		246,
		259,
		283,
		280,
		268,
		266,
		289,
		246,
		242,
		-1,
		272,
		260,
		266,
		273,
		290,
		317,
		-1,
		-1,
		262,
		253,
		-1,
		-1,
		288,
		286,
		275,
		-1,
		265,
		238,
		243,
		263,
		265,
		254,
		248,
		242,
		249,
		248,
		256,
		264,
		292,
		306,
		295,
		291,
		290,
		298,
		247,
		264,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		-1,
		297,
		272,
		-1,
		-1,
		283,
		276,
		264,
		252,
		242,
		252,
		256,
		260,
		252,
		245,
		240,
		251,
		243,
		247,
		264,
		-1,
		326,
		-1,
		278,
		271,
		286,
		301,
		309,
		-1,
		-1,
		-1,
		314,
		300,
		293,
		281,
		279,
		-1,
		317,
		301,
		282,
		-1,
		252,
		265,
		296,
		264,
		269,
		264,
		246,
		257,
		246,
		249,
		263,
		258,
		-1,
		-1,
		284,
		287,
		-1,
		-1,
		309,
		328,
		-1,
		305,
		294,
		279,
		271,
		-1,
		-1,
		289,
		285,
		-1,
		-1,
		253,
		278,
		267,
		275,
		270,
		250,
		256,
		259,
		248,
		252,
		264,
		-1,
		-1,
		291,
		292,
		297,
		-1,
		318,
		-1,
		329,
		-1,
		274,
		290,
		292,
		-1,
		-1,
		-1,
		291,
		254,
		275,
		285,
		279,
		277,
		268,
		254,
		261,
		259,
		255,
		266,
		-1,
		-1,
		-1,
		336,
		310,
		336,
		327,
		310,
		290,
		282,
		307,
		-1,
		278,
		-1,
		253,
		255,
		281,
		284,
		290,
		284,
		257,
		272,
		262,
		253,
		262,
		342,
		-1,
		312,
		345,
		309,
		296,
		279,
		283,
		299,
		-1,
		275,
		257,
		-1,
		285,
		275,
		306,
		291,
		272,
		259,
		266,
		266,
		259,
		-1,
		-1,
		-1,
		314,
		313,
		305,
		299,
		299,
		284,
		275,
		-1,
		287,
		269,
		248,
		265,
		265,
		256,
		264,
		296,
		292,
		279,
		279,
		271,
		-1,
		398,
		-1,
		-1,
		337,
		-1,
		-1,
		-1,
		308,
		303,
		276,
		264,
		270,
		266,
		252,
		258,
		260,
		268,
		266,
		263,
		275,
		271,
		291,
		272,
		307,
		-1,
		405,
		-1,
		344,
		-1,
		-1,
		326,
		306,
		298,
		287,
		276,
		274,
		265,
		256,
		278,
		294,
		278,
		276,
		279,
		280,
		-1,
		399,
		398,
		-1,
		345,
		337,
		323,
		-1,
		316,
		-1,
		322,
		283,
		-1,
		285,
		265,
		-1,
		287,
		283,
		-1,
		-1,
		386,
		361,
		-1,
		-1,
		-1,
		346,
		326,
		317,
		301,
		-1,
		276,
		276,
		-1,
		-1,
		-1,
		371,
		370,
		-1,
		339,
		342,
		-1,
		332,
		323,
		331,
		278,
		282,
		-1,
		-1,
		-1,
		380,
		361,
		355,
		354,
		352,
		347,
		344,
		330,
		314,
		292,
		281,
		302,
		-1,
		-1,
		-1,
		352,
		344,
		337,
		-1,
		-1,
		339,
		322,
		303,
		301,
		-1,
		-1,
		-1,
		374,
		355,
		-1,
		-1,
		329,
		-1,
		-1,
		335,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		391,
		363,
		-1,
		-1,
		-1,
		325,
		321,
		322,
		-1,
		-1,
		-1,
		-1,
		385,
		386,
		409,
		373,
		-1,
		-1,
		-1,
		317,
		311,
		-1,
		-1,
		388,
		386,
		-1,
		-1,
		-1,
		345,
		329,
		-1,
		315,
		-1,
		-1,
		-1,
		336,
		-1,
		-1,
		348,
		-1,
		-1,
		-1,
		350,
		-1,
		350,
		325,
		332,
		-1,
		-1,
		-1,
		-1,
		363,
		355,
		363,
		-1,
		335,
		337,
		-1,
		385,
		-1,
		-1,
		378,
		369,
		-1,
		-1,
		340,
		347,
		369,
		372,
		408,
		-1,
		359
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		135,
		124,
		135,
		143,
		116,
		123,
		-1,
		144,
		146,
		112,
		106,
		145,
		116,
		122,
		133,
		-1,
		-1,
		-1,
		135,
		134,
		104,
		102,
		111,
		116,
		123,
		-1,
		146,
		-1,
		156,
		135,
		146,
		151,
		97,
		94,
		114,
		133,
		139,
		131,
		171,
		127,
		98,
		92,
		110,
		115,
		133,
		125,
		-1,
		98,
		88,
		110,
		114,
		126,
		109,
		-1,
		-1,
		92,
		93,
		99,
		111,
		116,
		121,
		-1,
		147,
		166,
		-1,
		-1,
		82,
		95,
		91,
		94,
		102,
		118,
		139,
		156,
		161,
		-1,
		-1,
		83,
		87,
		100,
		101,
		99,
		126,
		145,
		156,
		170,
		169,
		-1,
		71,
		89,
		98,
		107,
		113,
		102,
		106,
		124,
		155,
		161,
		164,
		-1,
		63,
		65,
		94,
		100,
		112,
		118,
		105,
		111,
		130,
		143,
		162,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		47,
		60,
		68,
		94,
		93,
		89,
		107,
		129,
		108,
		114,
		118,
		135,
		151,
		152,
		162,
		-1,
		-1,
		42,
		36,
		101,
		58,
		43,
		-1,
		56,
		75,
		81,
		85,
		90,
		98,
		126,
		124,
		-1,
		129,
		128,
		159,
		145,
		156,
		90,
		-1,
		-1,
		0,
		7,
		32,
		35,
		46,
		51,
		81,
		80,
		85,
		87,
		89,
		101,
		116,
		116,
		126,
		123,
		133,
		137,
		152,
		163,
		-1,
		-1,
		237,
		-1,
		-1,
		87,
		70,
		-1,
		33,
		27,
		41,
		58,
		49,
		74,
		89,
		93,
		101,
		104,
		92,
		111,
		108,
		132,
		128,
		120,
		145,
		149,
		155,
		173,
		174,
		-1,
		236,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		40,
		37,
		39,
		63,
		70,
		-1,
		96,
		94,
		118,
		112,
		117,
		113,
		98,
		116,
		114,
		129,
		131,
		127,
		129,
		166,
		157,
		178,
		175,
		206,
		212,
		206,
		215,
		-1,
		95,
		91,
		87,
		94,
		43,
		-1,
		-1,
		67,
		-1,
		78,
		91,
		108,
		98,
		101,
		113,
		121,
		120,
		104,
		122,
		117,
		120,
		139,
		135,
		144,
		154,
		153,
		171,
		184,
		199,
		203,
		209,
		-1,
		145,
		-1,
		87,
		71,
		73,
		49,
		77,
		-1,
		87,
		79,
		99,
		110,
		110,
		-1,
		126,
		123,
		136,
		120,
		105,
		122,
		124,
		128,
		138,
		142,
		157,
		148,
		166,
		173,
		181,
		185,
		205,
		217,
		105,
		95,
		-1,
		77,
		82,
		52,
		64,
		100,
		122,
		106,
		-1,
		121,
		-1,
		128,
		141,
		-1,
		126,
		122,
		111,
		127,
		135,
		142,
		145,
		139,
		136,
		154,
		157,
		174,
		178,
		194,
		-1,
		-1,
		90,
		94,
		115,
		58,
		85,
		109,
		146,
		115,
		124,
		126,
		-1,
		146,
		147,
		144,
		145,
		131,
		124,
		125,
		141,
		147,
		143,
		138,
		141,
		163,
		191,
		169,
		181,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		92,
		63,
		87,
		129,
		154,
		147,
		135,
		152,
		152,
		146,
		-1,
		162,
		141,
		138,
		129,
		137,
		151,
		148,
		162,
		142,
		144,
		160,
		172,
		163,
		183,
		-1,
		-1,
		-1,
		122,
		111,
		112,
		66,
		100,
		118,
		185,
		171,
		176,
		151,
		144,
		138,
		156,
		158,
		153,
		147,
		139,
		128,
		144,
		152,
		154,
		144,
		153,
		154,
		178,
		185,
		191,
		-1,
		-1,
		129,
		119,
		103,
		105,
		102,
		91,
		98,
		130,
		176,
		173,
		-1,
		143,
		-1,
		132,
		140,
		139,
		145,
		144,
		141,
		135,
		144,
		158,
		158,
		149,
		164,
		183,
		183,
		175,
		200,
		203,
		-1,
		-1,
		-1,
		122,
		139,
		114,
		91,
		72,
		108,
		-1,
		143,
		144,
		-1,
		137,
		131,
		137,
		136,
		143,
		140,
		140,
		142,
		149,
		145,
		159,
		168,
		150,
		186,
		-1,
		183,
		177,
		205,
		199,
		187,
		-1,
		-1,
		-1,
		137,
		116,
		109,
		129,
		79,
		131,
		-1,
		-1,
		128,
		121,
		-1,
		124,
		124,
		131,
		140,
		145,
		150,
		154,
		143,
		156,
		161,
		155,
		165,
		185,
		189,
		196,
		189,
		185,
		182,
		196,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		99,
		-1,
		136,
		128,
		119,
		113,
		119,
		137,
		135,
		155,
		147,
		161,
		161,
		157,
		165,
		150,
		153,
		158,
		162,
		180,
		195,
		187,
		181,
		180,
		192,
		-1,
		185,
		171,
		142,
		-1,
		-1,
		114,
		-1,
		85,
		109,
		125,
		-1,
		153,
		132,
		155,
		133,
		147,
		143,
		181,
		182,
		160,
		165,
		164,
		174,
		175,
		164,
		170,
		169,
		189,
		191,
		175,
		176,
		185,
		-1,
		191,
		178,
		136,
		132,
		121,
		141,
		88,
		101,
		112,
		-1,
		-1,
		197,
		-1,
		131,
		148,
		157,
		155,
		171,
		162,
		168,
		175,
		178,
		179,
		169,
		158,
		164,
		163,
		185,
		171,
		169,
		188,
		204,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		107,
		94,
		88,
		-1,
		129,
		-1,
		175,
		165,
		149,
		134,
		167,
		-1,
		179,
		163,
		168,
		-1,
		204,
		-1,
		177,
		179,
		171,
		160,
		157,
		168,
		166,
		177,
		194,
		-1,
		141,
		126,
		119,
		109,
		123,
		94,
		-1,
		145,
		-1,
		-1,
		162,
		156,
		156,
		140,
		143,
		195,
		175,
		169,
		168,
		199,
		197,
		185,
		169,
		162,
		159,
		160,
		173,
		193,
		184,
		196,
		-1,
		-1,
		-1,
		146,
		126,
		132,
		90,
		111,
		-1,
		-1,
		224,
		179,
		165,
		-1,
		149,
		212,
		200,
		190,
		180,
		214,
		213,
		188,
		181,
		167,
		169,
		167,
		169,
		174,
		195,
		196,
		209,
		-1,
		-1,
		123,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		171,
		187,
		179,
		150,
		201,
		-1,
		-1,
		192,
		190,
		200,
		184,
		171,
		191,
		194,
		184,
		168,
		183,
		195,
		203,
		208,
		-1,
		126,
		113,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		204,
		170,
		182,
		203,
		228,
		195,
		-1,
		200,
		195,
		175,
		189,
		196,
		186,
		181,
		175,
		178,
		196,
		213,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		161,
		175,
		196,
		202,
		214,
		-1,
		203,
		191,
		177,
		194,
		199,
		196,
		187,
		179,
		184,
		181,
		194,
		208,
		212,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		179,
		194,
		256,
		233,
		206,
		202,
		195,
		189,
		185,
		201,
		207,
		218,
		186,
		182,
		183,
		187,
		186,
		203,
		213,
		-1,
		-1,
		146,
		163,
		198,
		187,
		191,
		283,
		-1,
		-1,
		211,
		202,
		193,
		196,
		195,
		198,
		192,
		189,
		194,
		199,
		187,
		196,
		214,
		213,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		206,
		282,
		229,
		211,
		207,
		205,
		198,
		207,
		202,
		197,
		207,
		209,
		201,
		189,
		193,
		216,
		205,
		244,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		195,
		170,
		185,
		231,
		226,
		227,
		244,
		241,
		-1,
		211,
		236,
		208,
		215,
		206,
		213,
		213,
		205,
		183,
		190,
		206,
		205,
		200,
		236,
		227,
		233,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		201,
		187,
		217,
		207,
		213,
		-1,
		-1,
		260,
		257,
		233,
		216,
		214,
		207,
		202,
		212,
		192,
		179,
		183,
		187,
		193,
		198,
		203,
		209,
		224,
		239,
		-1,
		171,
		252,
		245,
		228,
		236,
		267,
		-1,
		204,
		213,
		194,
		199,
		207,
		-1,
		-1,
		233,
		229,
		234,
		223,
		220,
		222,
		217,
		208,
		193,
		199,
		186,
		185,
		203,
		207,
		216,
		223,
		213,
		226,
		230,
		-1,
		185,
		228,
		222,
		225,
		249,
		263,
		-1,
		217,
		-1,
		-1,
		202,
		220,
		228,
		224,
		228,
		281,
		237,
		232,
		216,
		214,
		205,
		196,
		203,
		194,
		194,
		197,
		212,
		217,
		209,
		223,
		223,
		224,
		-1,
		220,
		208,
		216,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		218,
		-1,
		254,
		-1,
		247,
		251,
		245,
		248,
		230,
		217,
		209,
		201,
		217,
		192,
		202,
		198,
		199,
		208,
		219,
		231,
		230,
		231,
		294,
		249,
		216,
		207,
		254,
		269,
		273,
		-1,
		230,
		269,
		256,
		-1,
		227,
		-1,
		-1,
		-1,
		261,
		258,
		250,
		250,
		229,
		229,
		203,
		207,
		197,
		204,
		214,
		216,
		208,
		212,
		225,
		236,
		239,
		290,
		288,
		293,
		238,
		221,
		239,
		248,
		269,
		245,
		236,
		263,
		263,
		252,
		247,
		234,
		-1,
		-1,
		284,
		268,
		-1,
		-1,
		236,
		224,
		207,
		208,
		204,
		207,
		222,
		225,
		215,
		213,
		207,
		239,
		-1,
		290,
		289,
		278,
		275,
		251,
		242,
		229,
		240,
		-1,
		-1,
		248,
		264,
		277,
		281,
		294,
		319,
		-1,
		237,
		-1,
		-1,
		281,
		-1,
		-1,
		266,
		229,
		218,
		209,
		215,
		212,
		223,
		233,
		221,
		222,
		212,
		222,
		235,
		274,
		271,
		259,
		257,
		280,
		237,
		233,
		-1,
		263,
		251,
		257,
		264,
		281,
		308,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		264,
		262,
		251,
		-1,
		241,
		214,
		219,
		239,
		241,
		230,
		224,
		218,
		225,
		224,
		232,
		240,
		283,
		297,
		286,
		282,
		281,
		289,
		238,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		-1,
		288,
		263,
		-1,
		-1,
		259,
		252,
		240,
		228,
		218,
		228,
		232,
		236,
		228,
		221,
		216,
		227,
		219,
		223,
		240,
		-1,
		317,
		-1,
		269,
		262,
		277,
		292,
		300,
		-1,
		-1,
		-1,
		305,
		291,
		284,
		272,
		270,
		-1,
		293,
		277,
		258,
		-1,
		228,
		241,
		272,
		240,
		245,
		240,
		222,
		233,
		222,
		225,
		239,
		234,
		-1,
		-1,
		275,
		278,
		-1,
		-1,
		300,
		311,
		-1,
		296,
		285,
		270,
		262,
		-1,
		-1,
		265,
		261,
		-1,
		-1,
		229,
		254,
		243,
		251,
		246,
		226,
		232,
		235,
		224,
		228,
		240,
		-1,
		-1,
		282,
		283,
		288,
		-1,
		294,
		-1,
		312,
		-1,
		265,
		281,
		273,
		-1,
		-1,
		-1,
		267,
		230,
		251,
		261,
		255,
		253,
		244,
		230,
		237,
		235,
		231,
		242,
		-1,
		-1,
		-1,
		312,
		286,
		319,
		310,
		293,
		273,
		265,
		284,
		-1,
		254,
		-1,
		229,
		231,
		257,
		260,
		266,
		260,
		233,
		248,
		238,
		229,
		238,
		318,
		-1,
		288,
		321,
		285,
		279,
		255,
		259,
		275,
		-1,
		251,
		233,
		-1,
		261,
		251,
		282,
		267,
		248,
		235,
		242,
		242,
		235,
		-1,
		-1,
		-1,
		290,
		289,
		281,
		275,
		275,
		260,
		251,
		-1,
		263,
		245,
		224,
		241,
		241,
		232,
		240,
		272,
		268,
		255,
		255,
		247,
		-1,
		389,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		284,
		279,
		252,
		240,
		246,
		242,
		228,
		234,
		236,
		244,
		242,
		239,
		251,
		247,
		267,
		248,
		283,
		-1,
		386,
		-1,
		320,
		-1,
		-1,
		302,
		282,
		274,
		263,
		252,
		250,
		241,
		232,
		254,
		270,
		254,
		252,
		255,
		256,
		-1,
		375,
		374,
		-1,
		321,
		313,
		299,
		-1,
		292,
		-1,
		298,
		259,
		-1,
		261,
		241,
		-1,
		263,
		259,
		-1,
		-1,
		362,
		337,
		-1,
		-1,
		-1,
		322,
		302,
		293,
		277,
		-1,
		252,
		252,
		-1,
		-1,
		-1,
		347,
		346,
		-1,
		315,
		318,
		-1,
		308,
		299,
		307,
		254,
		258,
		-1,
		-1,
		-1,
		356,
		337,
		331,
		330,
		328,
		323,
		320,
		306,
		290,
		268,
		257,
		278,
		-1,
		-1,
		-1,
		328,
		320,
		313,
		-1,
		-1,
		315,
		298,
		279,
		277,
		-1,
		-1,
		-1,
		350,
		331,
		-1,
		-1,
		305,
		-1,
		-1,
		311,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		367,
		339,
		-1,
		-1,
		-1,
		301,
		297,
		298,
		-1,
		-1,
		-1,
		-1,
		361,
		362,
		385,
		349,
		-1,
		-1,
		-1,
		293,
		287,
		-1,
		-1,
		364,
		362,
		-1,
		-1,
		-1,
		321,
		305,
		-1,
		291,
		-1,
		-1,
		-1,
		312,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		326,
		-1,
		326,
		301,
		308,
		-1,
		-1,
		-1,
		-1,
		339,
		331,
		339,
		-1,
		311,
		313,
		-1,
		361,
		-1,
		-1,
		354,
		345,
		-1,
		-1,
		316,
		323,
		345,
		348,
		384,
		-1,
		335
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		137,
		139,
		105,
		99,
		138,
		109,
		115,
		126,
		-1,
		-1,
		-1,
		128,
		127,
		97,
		95,
		104,
		109,
		116,
		-1,
		139,
		-1,
		149,
		128,
		139,
		144,
		90,
		87,
		107,
		126,
		132,
		124,
		164,
		120,
		91,
		85,
		103,
		108,
		126,
		118,
		-1,
		91,
		81,
		103,
		107,
		119,
		102,
		-1,
		-1,
		85,
		86,
		92,
		104,
		109,
		114,
		-1,
		140,
		159,
		-1,
		-1,
		75,
		88,
		84,
		87,
		95,
		111,
		132,
		149,
		154,
		-1,
		-1,
		76,
		80,
		93,
		94,
		92,
		119,
		138,
		149,
		163,
		162,
		-1,
		64,
		82,
		91,
		100,
		106,
		95,
		99,
		117,
		148,
		154,
		157,
		-1,
		56,
		58,
		87,
		93,
		105,
		111,
		98,
		104,
		123,
		136,
		155,
		146,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		40,
		53,
		61,
		87,
		86,
		82,
		100,
		122,
		101,
		107,
		111,
		128,
		144,
		145,
		155,
		-1,
		-1,
		50,
		29,
		94,
		51,
		36,
		-1,
		49,
		68,
		74,
		78,
		83,
		91,
		119,
		117,
		-1,
		122,
		121,
		152,
		138,
		149,
		83,
		-1,
		-1,
		8,
		0,
		25,
		28,
		39,
		44,
		74,
		73,
		78,
		80,
		82,
		94,
		109,
		109,
		119,
		116,
		126,
		130,
		145,
		156,
		-1,
		-1,
		230,
		-1,
		-1,
		80,
		63,
		-1,
		26,
		20,
		34,
		51,
		42,
		67,
		82,
		86,
		94,
		97,
		85,
		104,
		101,
		125,
		121,
		113,
		138,
		142,
		148,
		166,
		167,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		33,
		30,
		32,
		56,
		63,
		-1,
		89,
		87,
		111,
		105,
		110,
		106,
		91,
		109,
		107,
		122,
		124,
		120,
		122,
		159,
		150,
		171,
		168,
		199,
		205,
		199,
		208,
		-1,
		88,
		84,
		80,
		87,
		36,
		-1,
		-1,
		60,
		-1,
		71,
		84,
		101,
		91,
		94,
		106,
		114,
		113,
		97,
		115,
		110,
		113,
		132,
		128,
		137,
		147,
		146,
		164,
		177,
		192,
		196,
		202,
		-1,
		138,
		-1,
		80,
		64,
		66,
		42,
		70,
		-1,
		80,
		72,
		92,
		103,
		103,
		-1,
		119,
		116,
		129,
		113,
		98,
		115,
		117,
		121,
		131,
		135,
		150,
		141,
		159,
		166,
		174,
		178,
		198,
		210,
		98,
		88,
		-1,
		70,
		75,
		45,
		57,
		93,
		115,
		99,
		-1,
		114,
		-1,
		121,
		134,
		-1,
		119,
		115,
		104,
		120,
		128,
		135,
		138,
		132,
		129,
		147,
		150,
		167,
		171,
		187,
		-1,
		-1,
		83,
		87,
		108,
		51,
		78,
		102,
		139,
		108,
		117,
		119,
		-1,
		139,
		140,
		137,
		138,
		124,
		117,
		118,
		134,
		140,
		136,
		131,
		134,
		156,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		85,
		56,
		80,
		122,
		147,
		140,
		128,
		145,
		145,
		139,
		-1,
		155,
		134,
		131,
		122,
		130,
		144,
		141,
		155,
		135,
		137,
		153,
		165,
		156,
		176,
		-1,
		-1,
		-1,
		115,
		104,
		105,
		59,
		93,
		111,
		178,
		164,
		169,
		144,
		137,
		131,
		149,
		151,
		146,
		140,
		132,
		121,
		137,
		145,
		147,
		137,
		146,
		147,
		171,
		178,
		184,
		-1,
		-1,
		122,
		112,
		96,
		98,
		95,
		84,
		91,
		123,
		169,
		166,
		-1,
		136,
		-1,
		125,
		133,
		132,
		138,
		137,
		134,
		128,
		137,
		151,
		151,
		142,
		157,
		176,
		176,
		168,
		193,
		196,
		-1,
		-1,
		-1,
		115,
		132,
		107,
		84,
		65,
		101,
		-1,
		136,
		137,
		-1,
		130,
		124,
		130,
		129,
		136,
		133,
		133,
		135,
		142,
		138,
		152,
		161,
		143,
		179,
		-1,
		176,
		170,
		198,
		192,
		180,
		-1,
		-1,
		-1,
		130,
		109,
		102,
		122,
		72,
		124,
		-1,
		-1,
		121,
		114,
		-1,
		117,
		117,
		124,
		133,
		138,
		143,
		147,
		136,
		149,
		154,
		148,
		158,
		178,
		182,
		189,
		182,
		178,
		175,
		189,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		92,
		-1,
		129,
		121,
		112,
		106,
		112,
		130,
		128,
		148,
		140,
		154,
		154,
		150,
		158,
		143,
		146,
		151,
		155,
		173,
		188,
		180,
		174,
		173,
		185,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		107,
		-1,
		78,
		102,
		118,
		-1,
		146,
		125,
		148,
		126,
		140,
		136,
		174,
		175,
		153,
		158,
		157,
		167,
		168,
		157,
		163,
		162,
		182,
		184,
		168,
		169,
		178,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		81,
		94,
		105,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		150,
		148,
		164,
		155,
		161,
		168,
		171,
		172,
		162,
		151,
		157,
		156,
		178,
		164,
		162,
		181,
		197,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		172,
		156,
		161,
		-1,
		197,
		-1,
		170,
		172,
		164,
		153,
		150,
		161,
		159,
		170,
		187,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		138,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		188,
		168,
		162,
		161,
		192,
		190,
		178,
		162,
		155,
		152,
		153,
		166,
		186,
		177,
		189,
		-1,
		-1,
		-1,
		139,
		119,
		125,
		83,
		104,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		205,
		193,
		183,
		173,
		207,
		206,
		181,
		174,
		160,
		162,
		160,
		162,
		167,
		188,
		189,
		202,
		-1,
		-1,
		116,
		123,
		111,
		97,
		116,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		194,
		-1,
		-1,
		185,
		183,
		193,
		177,
		164,
		184,
		187,
		177,
		161,
		176,
		188,
		196,
		201,
		-1,
		119,
		106,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		175,
		196,
		221,
		188,
		-1,
		193,
		188,
		168,
		182,
		189,
		179,
		174,
		168,
		171,
		189,
		206,
		-1,
		-1,
		133,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		154,
		168,
		189,
		195,
		207,
		-1,
		196,
		184,
		170,
		187,
		192,
		189,
		180,
		172,
		177,
		174,
		187,
		201,
		205,
		156,
		-1,
		139,
		-1,
		-1,
		-1,
		172,
		187,
		249,
		226,
		199,
		195,
		188,
		182,
		178,
		194,
		200,
		211,
		179,
		175,
		176,
		180,
		179,
		196,
		206,
		-1,
		-1,
		139,
		156,
		191,
		180,
		184,
		276,
		-1,
		-1,
		204,
		195,
		186,
		189,
		188,
		191,
		185,
		182,
		187,
		192,
		180,
		189,
		207,
		206,
		-1,
		-1,
		-1,
		159,
		-1,
		174,
		-1,
		-1,
		199,
		275,
		222,
		204,
		200,
		198,
		191,
		200,
		195,
		190,
		200,
		202,
		194,
		182,
		186,
		209,
		198,
		237,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		188,
		163,
		178,
		224,
		219,
		220,
		237,
		234,
		-1,
		204,
		229,
		201,
		208,
		199,
		206,
		206,
		198,
		176,
		183,
		199,
		198,
		193,
		229,
		220,
		226,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		194,
		180,
		210,
		200,
		206,
		-1,
		-1,
		253,
		250,
		226,
		209,
		207,
		200,
		195,
		205,
		185,
		172,
		176,
		180,
		186,
		191,
		196,
		202,
		217,
		232,
		-1,
		164,
		245,
		238,
		221,
		229,
		260,
		-1,
		197,
		206,
		187,
		192,
		200,
		-1,
		-1,
		226,
		222,
		227,
		216,
		213,
		215,
		210,
		201,
		186,
		192,
		179,
		178,
		196,
		200,
		209,
		216,
		206,
		219,
		223,
		-1,
		178,
		221,
		215,
		218,
		242,
		256,
		-1,
		210,
		-1,
		-1,
		195,
		213,
		221,
		217,
		221,
		274,
		230,
		225,
		209,
		207,
		198,
		189,
		196,
		187,
		187,
		190,
		205,
		210,
		202,
		216,
		216,
		217,
		-1,
		213,
		201,
		209,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		211,
		-1,
		247,
		-1,
		240,
		244,
		238,
		241,
		223,
		210,
		202,
		194,
		210,
		185,
		195,
		191,
		192,
		201,
		212,
		224,
		223,
		224,
		287,
		242,
		209,
		200,
		247,
		262,
		266,
		-1,
		223,
		262,
		249,
		-1,
		220,
		-1,
		-1,
		-1,
		254,
		251,
		243,
		243,
		222,
		222,
		196,
		200,
		190,
		197,
		207,
		209,
		201,
		205,
		218,
		229,
		232,
		283,
		281,
		286,
		231,
		214,
		232,
		241,
		262,
		238,
		229,
		256,
		256,
		245,
		240,
		227,
		-1,
		-1,
		277,
		261,
		-1,
		-1,
		229,
		217,
		200,
		201,
		197,
		200,
		215,
		218,
		208,
		206,
		200,
		232,
		-1,
		283,
		282,
		271,
		268,
		244,
		235,
		222,
		233,
		-1,
		-1,
		241,
		257,
		270,
		274,
		287,
		312,
		-1,
		230,
		-1,
		-1,
		274,
		-1,
		-1,
		259,
		222,
		211,
		202,
		208,
		205,
		216,
		226,
		214,
		215,
		205,
		215,
		228,
		267,
		264,
		252,
		250,
		273,
		230,
		226,
		-1,
		256,
		244,
		250,
		257,
		274,
		301,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		257,
		255,
		244,
		-1,
		234,
		207,
		212,
		232,
		234,
		223,
		217,
		211,
		218,
		217,
		225,
		233,
		276,
		290,
		279,
		275,
		274,
		282,
		231,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		-1,
		281,
		256,
		-1,
		-1,
		252,
		245,
		233,
		221,
		211,
		221,
		225,
		229,
		221,
		214,
		209,
		220,
		212,
		216,
		233,
		-1,
		310,
		-1,
		262,
		255,
		270,
		285,
		293,
		-1,
		-1,
		-1,
		298,
		284,
		277,
		265,
		263,
		-1,
		286,
		270,
		251,
		-1,
		221,
		234,
		265,
		233,
		238,
		233,
		215,
		226,
		215,
		218,
		232,
		227,
		-1,
		-1,
		268,
		271,
		-1,
		-1,
		293,
		304,
		-1,
		289,
		278,
		263,
		255,
		-1,
		-1,
		258,
		254,
		-1,
		-1,
		222,
		247,
		236,
		244,
		239,
		219,
		225,
		228,
		217,
		221,
		233,
		-1,
		-1,
		275,
		276,
		281,
		-1,
		287,
		-1,
		305,
		-1,
		258,
		274,
		266,
		-1,
		-1,
		-1,
		260,
		223,
		244,
		254,
		248,
		246,
		237,
		223,
		230,
		228,
		224,
		235,
		-1,
		-1,
		-1,
		305,
		279,
		312,
		303,
		286,
		266,
		258,
		277,
		-1,
		247,
		-1,
		222,
		224,
		250,
		253,
		259,
		253,
		226,
		241,
		231,
		222,
		231,
		311,
		-1,
		281,
		314,
		278,
		272,
		248,
		252,
		268,
		-1,
		244,
		226,
		-1,
		254,
		244,
		275,
		260,
		241,
		228,
		235,
		235,
		228,
		-1,
		-1,
		-1,
		283,
		282,
		274,
		268,
		268,
		253,
		244,
		-1,
		256,
		238,
		217,
		234,
		234,
		225,
		233,
		265,
		261,
		248,
		248,
		240,
		-1,
		382,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		277,
		272,
		245,
		233,
		239,
		235,
		221,
		227,
		229,
		237,
		235,
		232,
		244,
		240,
		260,
		241,
		276,
		-1,
		379,
		-1,
		313,
		-1,
		-1,
		295,
		275,
		267,
		256,
		245,
		243,
		234,
		225,
		247,
		263,
		247,
		245,
		248,
		249,
		-1,
		368,
		367,
		-1,
		314,
		306,
		292,
		-1,
		285,
		-1,
		291,
		252,
		-1,
		254,
		234,
		-1,
		256,
		252,
		-1,
		-1,
		355,
		330,
		-1,
		-1,
		-1,
		315,
		295,
		286,
		270,
		-1,
		245,
		245,
		-1,
		-1,
		-1,
		340,
		339,
		-1,
		308,
		311,
		-1,
		301,
		292,
		300,
		247,
		251,
		-1,
		-1,
		-1,
		349,
		330,
		324,
		323,
		321,
		316,
		313,
		299,
		283,
		261,
		250,
		271,
		-1,
		-1,
		-1,
		321,
		313,
		306,
		-1,
		-1,
		308,
		291,
		272,
		270,
		-1,
		-1,
		-1,
		343,
		324,
		-1,
		-1,
		298,
		-1,
		-1,
		304,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		360,
		332,
		-1,
		-1,
		-1,
		294,
		290,
		291,
		-1,
		-1,
		-1,
		-1,
		354,
		355,
		378,
		342,
		-1,
		-1,
		-1,
		286,
		280,
		-1,
		-1,
		357,
		355,
		-1,
		-1,
		-1,
		314,
		298,
		-1,
		284,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		319,
		-1,
		319,
		294,
		301,
		-1,
		-1,
		-1,
		-1,
		332,
		324,
		332,
		-1,
		304,
		306,
		-1,
		354,
		-1,
		-1,
		347,
		338,
		-1,
		-1,
		309,
		316,
		338,
		341,
		377,
		-1,
		328
	],
	[
		-1,
		107,
		96,
		107,
		115,
		88,
		95,
		-1,
		116,
		118,
		84,
		78,
		117,
		88,
		94,
		105,
		-1,
		-1,
		-1,
		107,
		106,
		76,
		74,
		83,
		88,
		95,
		-1,
		118,
		-1,
		128,
		107,
		118,
		123,
		69,
		66,
		86,
		105,
		111,
		103,
		143,
		99,
		70,
		64,
		82,
		87,
		105,
		97,
		-1,
		70,
		60,
		82,
		86,
		98,
		81,
		-1,
		-1,
		64,
		65,
		71,
		83,
		88,
		93,
		-1,
		119,
		138,
		-1,
		-1,
		54,
		67,
		63,
		66,
		74,
		90,
		111,
		128,
		133,
		-1,
		-1,
		55,
		59,
		72,
		73,
		71,
		98,
		117,
		128,
		142,
		141,
		-1,
		43,
		61,
		70,
		79,
		85,
		74,
		78,
		96,
		127,
		133,
		136,
		-1,
		35,
		37,
		66,
		72,
		84,
		90,
		77,
		83,
		102,
		115,
		134,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		15,
		32,
		40,
		66,
		65,
		61,
		79,
		101,
		80,
		86,
		90,
		107,
		123,
		124,
		134,
		-1,
		-1,
		74,
		47,
		69,
		26,
		11,
		-1,
		28,
		47,
		53,
		57,
		62,
		70,
		98,
		96,
		-1,
		101,
		100,
		131,
		117,
		128,
		71,
		-1,
		-1,
		32,
		24,
		0,
		3,
		18,
		23,
		53,
		52,
		57,
		59,
		61,
		73,
		88,
		88,
		98,
		95,
		105,
		109,
		124,
		135,
		-1,
		-1,
		209,
		-1,
		-1,
		68,
		51,
		-1,
		14,
		8,
		13,
		30,
		21,
		46,
		61,
		65,
		73,
		76,
		64,
		83,
		80,
		104,
		100,
		92,
		117,
		121,
		127,
		145,
		146,
		-1,
		208,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		46,
		21,
		18,
		19,
		43,
		42,
		-1,
		68,
		66,
		90,
		84,
		89,
		85,
		70,
		88,
		86,
		101,
		103,
		99,
		101,
		138,
		129,
		150,
		147,
		178,
		184,
		178,
		187,
		-1,
		76,
		72,
		68,
		75,
		24,
		-1,
		-1,
		47,
		-1,
		50,
		63,
		80,
		70,
		73,
		85,
		93,
		92,
		76,
		94,
		89,
		92,
		111,
		107,
		116,
		126,
		125,
		143,
		156,
		171,
		175,
		181,
		-1,
		126,
		-1,
		68,
		52,
		54,
		30,
		58,
		-1,
		67,
		51,
		71,
		82,
		82,
		-1,
		98,
		95,
		108,
		92,
		77,
		94,
		96,
		100,
		110,
		114,
		129,
		120,
		138,
		145,
		153,
		157,
		177,
		189,
		86,
		76,
		-1,
		58,
		63,
		33,
		45,
		81,
		94,
		78,
		-1,
		93,
		-1,
		100,
		113,
		-1,
		98,
		94,
		83,
		99,
		107,
		114,
		117,
		111,
		108,
		126,
		129,
		146,
		150,
		166,
		-1,
		-1,
		71,
		75,
		96,
		39,
		66,
		90,
		127,
		87,
		96,
		98,
		-1,
		118,
		119,
		116,
		117,
		103,
		96,
		97,
		113,
		119,
		115,
		110,
		113,
		135,
		163,
		141,
		153,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		73,
		44,
		68,
		110,
		126,
		119,
		107,
		127,
		127,
		127,
		-1,
		134,
		113,
		110,
		101,
		109,
		123,
		120,
		134,
		114,
		116,
		132,
		144,
		135,
		155,
		-1,
		-1,
		-1,
		103,
		92,
		93,
		47,
		81,
		99,
		160,
		146,
		151,
		126,
		125,
		119,
		128,
		130,
		125,
		119,
		111,
		100,
		116,
		124,
		126,
		116,
		125,
		126,
		150,
		157,
		163,
		-1,
		-1,
		110,
		100,
		84,
		86,
		83,
		72,
		79,
		111,
		151,
		154,
		-1,
		124,
		-1,
		113,
		121,
		120,
		119,
		116,
		113,
		107,
		116,
		130,
		130,
		121,
		136,
		155,
		155,
		147,
		172,
		175,
		-1,
		-1,
		-1,
		103,
		120,
		95,
		72,
		53,
		89,
		-1,
		124,
		125,
		-1,
		118,
		112,
		118,
		117,
		122,
		117,
		121,
		114,
		121,
		117,
		131,
		140,
		122,
		158,
		-1,
		155,
		149,
		177,
		171,
		159,
		-1,
		-1,
		-1,
		118,
		97,
		90,
		110,
		60,
		112,
		-1,
		-1,
		109,
		102,
		-1,
		105,
		105,
		112,
		121,
		118,
		122,
		126,
		115,
		128,
		133,
		127,
		137,
		157,
		161,
		168,
		161,
		157,
		154,
		168,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		80,
		-1,
		117,
		109,
		100,
		94,
		100,
		118,
		116,
		136,
		128,
		133,
		133,
		129,
		137,
		122,
		125,
		130,
		134,
		152,
		167,
		159,
		153,
		152,
		164,
		-1,
		166,
		152,
		123,
		-1,
		-1,
		95,
		-1,
		66,
		90,
		106,
		-1,
		134,
		113,
		136,
		114,
		128,
		124,
		153,
		154,
		132,
		137,
		136,
		146,
		147,
		136,
		142,
		141,
		161,
		163,
		147,
		148,
		157,
		-1,
		172,
		159,
		117,
		113,
		102,
		122,
		69,
		82,
		93,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		138,
		136,
		143,
		134,
		140,
		147,
		150,
		151,
		141,
		130,
		136,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		88,
		75,
		69,
		-1,
		110,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		151,
		135,
		140,
		-1,
		176,
		-1,
		149,
		151,
		143,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		122,
		107,
		100,
		90,
		104,
		75,
		-1,
		126,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		167,
		147,
		141,
		140,
		171,
		169,
		157,
		141,
		134,
		131,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		127,
		107,
		113,
		71,
		92,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		184,
		172,
		162,
		152,
		186,
		185,
		160,
		153,
		139,
		141,
		139,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		104,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		173,
		-1,
		-1,
		164,
		162,
		172,
		156,
		143,
		163,
		166,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		107,
		94,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		184,
		201,
		167,
		-1,
		172,
		167,
		147,
		161,
		168,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		177,
		183,
		187,
		-1,
		175,
		163,
		149,
		166,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		160,
		175,
		229,
		206,
		179,
		174,
		167,
		161,
		157,
		173,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		127,
		144,
		179,
		168,
		172,
		256,
		-1,
		-1,
		183,
		174,
		165,
		168,
		167,
		170,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		185,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		187,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		181,
		173,
		161,
		165,
		188,
		177,
		216,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		212,
		207,
		208,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		178,
		185,
		185,
		177,
		155,
		162,
		178,
		177,
		172,
		208,
		199,
		205,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		182,
		168,
		198,
		188,
		194,
		-1,
		-1,
		232,
		229,
		205,
		188,
		186,
		179,
		174,
		184,
		164,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		152,
		233,
		226,
		209,
		217,
		248,
		-1,
		185,
		194,
		175,
		180,
		188,
		-1,
		-1,
		205,
		202,
		207,
		195,
		192,
		194,
		189,
		180,
		165,
		171,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		166,
		209,
		203,
		206,
		230,
		244,
		-1,
		198,
		-1,
		-1,
		183,
		201,
		209,
		205,
		204,
		254,
		209,
		204,
		188,
		186,
		177,
		168,
		175,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		201,
		189,
		197,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		199,
		-1,
		235,
		-1,
		222,
		226,
		217,
		220,
		202,
		189,
		181,
		173,
		189,
		164,
		174,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		275,
		230,
		197,
		188,
		235,
		250,
		254,
		-1,
		211,
		250,
		237,
		-1,
		208,
		-1,
		-1,
		-1,
		236,
		230,
		222,
		222,
		201,
		201,
		175,
		179,
		169,
		176,
		186,
		188,
		180,
		184,
		197,
		208,
		211,
		271,
		269,
		274,
		219,
		202,
		220,
		229,
		250,
		226,
		217,
		244,
		244,
		233,
		228,
		215,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		208,
		196,
		179,
		180,
		176,
		179,
		194,
		197,
		187,
		185,
		179,
		211,
		-1,
		271,
		270,
		259,
		256,
		232,
		223,
		210,
		221,
		-1,
		-1,
		229,
		245,
		258,
		262,
		275,
		300,
		-1,
		218,
		-1,
		-1,
		253,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		184,
		195,
		205,
		193,
		194,
		184,
		194,
		207,
		255,
		252,
		240,
		238,
		261,
		218,
		214,
		-1,
		244,
		232,
		238,
		245,
		262,
		289,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		236,
		234,
		223,
		-1,
		213,
		186,
		191,
		211,
		213,
		202,
		196,
		190,
		197,
		196,
		204,
		212,
		264,
		278,
		267,
		263,
		262,
		270,
		219,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		-1,
		269,
		244,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		204,
		208,
		200,
		193,
		188,
		199,
		191,
		195,
		212,
		-1,
		298,
		-1,
		250,
		243,
		258,
		273,
		281,
		-1,
		-1,
		-1,
		286,
		272,
		265,
		253,
		251,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		194,
		205,
		194,
		197,
		211,
		206,
		-1,
		-1,
		256,
		259,
		-1,
		-1,
		281,
		283,
		-1,
		277,
		266,
		251,
		243,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		198,
		204,
		207,
		196,
		200,
		212,
		-1,
		-1,
		263,
		264,
		269,
		-1,
		266,
		-1,
		284,
		-1,
		246,
		257,
		245,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		227,
		225,
		216,
		202,
		209,
		207,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		258,
		291,
		282,
		265,
		245,
		237,
		256,
		-1,
		226,
		-1,
		201,
		203,
		229,
		232,
		238,
		232,
		205,
		220,
		210,
		201,
		210,
		290,
		-1,
		260,
		293,
		257,
		251,
		227,
		231,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		254,
		239,
		220,
		207,
		214,
		214,
		207,
		-1,
		-1,
		-1,
		262,
		261,
		253,
		247,
		247,
		232,
		223,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		244,
		240,
		227,
		227,
		219,
		-1,
		363,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		256,
		251,
		224,
		212,
		218,
		214,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		220,
		255,
		-1,
		358,
		-1,
		292,
		-1,
		-1,
		274,
		254,
		246,
		235,
		224,
		222,
		213,
		204,
		226,
		242,
		226,
		224,
		227,
		228,
		-1,
		347,
		346,
		-1,
		293,
		285,
		271,
		-1,
		264,
		-1,
		270,
		231,
		-1,
		233,
		213,
		-1,
		235,
		231,
		-1,
		-1,
		334,
		309,
		-1,
		-1,
		-1,
		294,
		274,
		265,
		249,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		319,
		318,
		-1,
		287,
		290,
		-1,
		280,
		271,
		279,
		226,
		230,
		-1,
		-1,
		-1,
		328,
		309,
		303,
		302,
		300,
		295,
		292,
		278,
		262,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		300,
		292,
		285,
		-1,
		-1,
		287,
		270,
		251,
		249,
		-1,
		-1,
		-1,
		322,
		303,
		-1,
		-1,
		277,
		-1,
		-1,
		283,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		311,
		-1,
		-1,
		-1,
		273,
		269,
		270,
		-1,
		-1,
		-1,
		-1,
		333,
		334,
		357,
		321,
		-1,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		336,
		334,
		-1,
		-1,
		-1,
		293,
		277,
		-1,
		263,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		298,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		311,
		303,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		326,
		317,
		-1,
		-1,
		288,
		295,
		317,
		320,
		356,
		-1,
		307
	],
	[
		-1,
		110,
		99,
		110,
		118,
		91,
		98,
		-1,
		119,
		121,
		87,
		81,
		120,
		91,
		97,
		108,
		-1,
		-1,
		-1,
		110,
		109,
		79,
		77,
		86,
		91,
		98,
		-1,
		121,
		-1,
		131,
		110,
		121,
		126,
		72,
		69,
		89,
		108,
		114,
		106,
		146,
		102,
		73,
		67,
		85,
		90,
		108,
		100,
		-1,
		73,
		63,
		85,
		89,
		101,
		84,
		-1,
		-1,
		67,
		68,
		74,
		86,
		91,
		96,
		-1,
		122,
		141,
		-1,
		-1,
		57,
		70,
		66,
		69,
		77,
		93,
		114,
		131,
		136,
		-1,
		-1,
		58,
		62,
		75,
		76,
		74,
		101,
		120,
		131,
		145,
		144,
		-1,
		46,
		64,
		73,
		82,
		88,
		77,
		81,
		99,
		130,
		136,
		139,
		-1,
		38,
		40,
		69,
		75,
		87,
		93,
		80,
		86,
		105,
		118,
		137,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		12,
		35,
		43,
		69,
		68,
		64,
		82,
		104,
		83,
		89,
		93,
		110,
		126,
		127,
		137,
		-1,
		-1,
		76,
		49,
		72,
		23,
		8,
		-1,
		31,
		50,
		56,
		60,
		65,
		73,
		101,
		99,
		-1,
		104,
		103,
		134,
		120,
		131,
		73,
		-1,
		-1,
		34,
		26,
		3,
		0,
		21,
		26,
		56,
		55,
		60,
		62,
		64,
		76,
		91,
		91,
		101,
		98,
		108,
		112,
		127,
		138,
		-1,
		-1,
		212,
		-1,
		-1,
		70,
		53,
		-1,
		16,
		10,
		16,
		33,
		24,
		49,
		64,
		68,
		76,
		79,
		67,
		86,
		83,
		107,
		103,
		95,
		120,
		124,
		130,
		148,
		149,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		48,
		23,
		20,
		22,
		46,
		45,
		-1,
		71,
		69,
		93,
		87,
		92,
		88,
		73,
		91,
		89,
		104,
		106,
		102,
		104,
		141,
		132,
		153,
		150,
		181,
		187,
		181,
		190,
		-1,
		78,
		74,
		70,
		77,
		26,
		-1,
		-1,
		50,
		-1,
		53,
		66,
		83,
		73,
		76,
		88,
		96,
		95,
		79,
		97,
		92,
		95,
		114,
		110,
		119,
		129,
		128,
		146,
		159,
		174,
		178,
		184,
		-1,
		128,
		-1,
		70,
		54,
		56,
		32,
		60,
		-1,
		70,
		54,
		74,
		85,
		85,
		-1,
		101,
		98,
		111,
		95,
		80,
		97,
		99,
		103,
		113,
		117,
		132,
		123,
		141,
		148,
		156,
		160,
		180,
		192,
		88,
		78,
		-1,
		60,
		65,
		35,
		47,
		83,
		97,
		81,
		-1,
		96,
		-1,
		103,
		116,
		-1,
		101,
		97,
		86,
		102,
		110,
		117,
		120,
		114,
		111,
		129,
		132,
		149,
		153,
		169,
		-1,
		-1,
		73,
		77,
		98,
		41,
		68,
		92,
		129,
		90,
		99,
		101,
		-1,
		121,
		122,
		119,
		120,
		106,
		99,
		100,
		116,
		122,
		118,
		113,
		116,
		138,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		98,
		-1,
		-1,
		75,
		46,
		70,
		112,
		129,
		122,
		110,
		130,
		130,
		129,
		-1,
		137,
		116,
		113,
		104,
		112,
		126,
		123,
		137,
		117,
		119,
		135,
		147,
		138,
		158,
		-1,
		-1,
		-1,
		105,
		94,
		95,
		49,
		83,
		101,
		163,
		149,
		154,
		129,
		127,
		121,
		131,
		133,
		128,
		122,
		114,
		103,
		119,
		127,
		129,
		119,
		128,
		129,
		153,
		160,
		166,
		-1,
		-1,
		112,
		102,
		86,
		88,
		85,
		74,
		81,
		113,
		154,
		156,
		-1,
		126,
		-1,
		115,
		123,
		122,
		122,
		119,
		116,
		110,
		119,
		133,
		133,
		124,
		139,
		158,
		158,
		150,
		175,
		178,
		-1,
		-1,
		-1,
		105,
		122,
		97,
		74,
		55,
		91,
		-1,
		126,
		127,
		-1,
		120,
		114,
		120,
		119,
		125,
		120,
		123,
		117,
		124,
		120,
		134,
		143,
		125,
		161,
		-1,
		158,
		152,
		180,
		174,
		162,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		62,
		114,
		-1,
		-1,
		111,
		104,
		-1,
		107,
		107,
		114,
		123,
		121,
		125,
		129,
		118,
		131,
		136,
		130,
		140,
		160,
		164,
		171,
		164,
		160,
		157,
		171,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		82,
		-1,
		119,
		111,
		102,
		96,
		102,
		120,
		118,
		138,
		130,
		136,
		136,
		132,
		140,
		125,
		128,
		133,
		137,
		155,
		170,
		162,
		156,
		155,
		167,
		-1,
		168,
		154,
		125,
		-1,
		-1,
		97,
		-1,
		68,
		92,
		108,
		-1,
		136,
		115,
		138,
		116,
		130,
		126,
		156,
		157,
		135,
		140,
		139,
		149,
		150,
		139,
		145,
		144,
		164,
		166,
		150,
		151,
		160,
		-1,
		174,
		161,
		119,
		115,
		104,
		124,
		71,
		84,
		95,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		140,
		138,
		146,
		137,
		143,
		150,
		153,
		154,
		144,
		133,
		139,
		138,
		160,
		146,
		144,
		163,
		179,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		90,
		77,
		71,
		-1,
		112,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		154,
		138,
		143,
		-1,
		179,
		-1,
		152,
		154,
		146,
		135,
		132,
		143,
		141,
		152,
		169,
		-1,
		124,
		109,
		102,
		92,
		106,
		77,
		-1,
		128,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		170,
		150,
		144,
		143,
		174,
		172,
		160,
		144,
		137,
		134,
		135,
		148,
		168,
		159,
		171,
		-1,
		-1,
		-1,
		129,
		109,
		115,
		73,
		94,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		187,
		175,
		165,
		155,
		189,
		188,
		163,
		156,
		142,
		144,
		142,
		144,
		149,
		170,
		171,
		184,
		-1,
		-1,
		106,
		113,
		101,
		87,
		106,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		176,
		-1,
		-1,
		167,
		165,
		175,
		159,
		146,
		166,
		169,
		159,
		143,
		158,
		170,
		178,
		183,
		-1,
		109,
		96,
		-1,
		-1,
		109,
		103,
		-1,
		-1,
		-1,
		-1,
		187,
		153,
		165,
		186,
		204,
		170,
		-1,
		175,
		170,
		150,
		164,
		171,
		161,
		156,
		150,
		153,
		171,
		188,
		-1,
		-1,
		123,
		-1,
		118,
		-1,
		-1,
		-1,
		-1,
		144,
		158,
		179,
		185,
		190,
		-1,
		178,
		166,
		152,
		169,
		174,
		171,
		162,
		154,
		159,
		156,
		169,
		183,
		187,
		146,
		-1,
		129,
		-1,
		-1,
		-1,
		162,
		177,
		232,
		209,
		182,
		177,
		170,
		164,
		160,
		176,
		182,
		193,
		161,
		157,
		158,
		162,
		161,
		178,
		188,
		-1,
		-1,
		129,
		146,
		181,
		170,
		174,
		259,
		-1,
		-1,
		186,
		177,
		168,
		171,
		170,
		173,
		167,
		164,
		169,
		174,
		162,
		171,
		189,
		188,
		-1,
		-1,
		-1,
		149,
		-1,
		164,
		-1,
		-1,
		189,
		257,
		204,
		186,
		182,
		180,
		173,
		182,
		177,
		172,
		182,
		184,
		176,
		164,
		168,
		191,
		180,
		219,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		178,
		153,
		168,
		214,
		209,
		210,
		219,
		216,
		-1,
		186,
		211,
		183,
		190,
		181,
		188,
		188,
		180,
		158,
		165,
		181,
		180,
		175,
		211,
		202,
		208,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		184,
		170,
		200,
		190,
		196,
		-1,
		-1,
		235,
		232,
		208,
		191,
		189,
		182,
		177,
		187,
		167,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		187,
		196,
		177,
		182,
		190,
		-1,
		-1,
		208,
		205,
		210,
		198,
		195,
		197,
		192,
		183,
		168,
		174,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		200,
		-1,
		-1,
		185,
		203,
		211,
		207,
		207,
		257,
		212,
		207,
		191,
		189,
		180,
		171,
		178,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		203,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		201,
		-1,
		237,
		-1,
		225,
		229,
		220,
		223,
		205,
		192,
		184,
		176,
		192,
		167,
		177,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		277,
		232,
		199,
		190,
		237,
		252,
		256,
		-1,
		213,
		252,
		239,
		-1,
		210,
		-1,
		-1,
		-1,
		239,
		233,
		225,
		225,
		204,
		204,
		178,
		182,
		172,
		179,
		189,
		191,
		183,
		187,
		200,
		211,
		214,
		273,
		271,
		276,
		221,
		204,
		222,
		231,
		252,
		228,
		219,
		246,
		246,
		235,
		230,
		217,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		211,
		199,
		182,
		183,
		179,
		182,
		197,
		200,
		190,
		188,
		182,
		214,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		212,
		223,
		-1,
		-1,
		231,
		247,
		260,
		264,
		277,
		302,
		-1,
		220,
		-1,
		-1,
		256,
		-1,
		-1,
		241,
		204,
		193,
		184,
		190,
		187,
		198,
		208,
		196,
		197,
		187,
		197,
		210,
		257,
		254,
		242,
		240,
		263,
		220,
		216,
		-1,
		246,
		234,
		240,
		247,
		264,
		291,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		239,
		237,
		226,
		-1,
		216,
		189,
		194,
		214,
		216,
		205,
		199,
		193,
		200,
		199,
		207,
		215,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		-1,
		271,
		246,
		-1,
		-1,
		234,
		227,
		215,
		203,
		193,
		203,
		207,
		211,
		203,
		196,
		191,
		202,
		194,
		198,
		215,
		-1,
		300,
		-1,
		252,
		245,
		260,
		275,
		283,
		-1,
		-1,
		-1,
		288,
		274,
		267,
		255,
		253,
		-1,
		268,
		252,
		233,
		-1,
		203,
		216,
		247,
		215,
		220,
		215,
		197,
		208,
		197,
		200,
		214,
		209,
		-1,
		-1,
		258,
		261,
		-1,
		-1,
		283,
		286,
		-1,
		279,
		268,
		253,
		245,
		-1,
		-1,
		240,
		236,
		-1,
		-1,
		204,
		229,
		218,
		226,
		221,
		201,
		207,
		210,
		199,
		203,
		215,
		-1,
		-1,
		265,
		266,
		271,
		-1,
		269,
		-1,
		287,
		-1,
		248,
		260,
		248,
		-1,
		-1,
		-1,
		242,
		205,
		226,
		236,
		230,
		228,
		219,
		205,
		212,
		210,
		206,
		217,
		-1,
		-1,
		-1,
		287,
		261,
		294,
		285,
		268,
		248,
		240,
		259,
		-1,
		229,
		-1,
		204,
		206,
		232,
		235,
		241,
		235,
		208,
		223,
		213,
		204,
		213,
		293,
		-1,
		263,
		296,
		260,
		254,
		230,
		234,
		250,
		-1,
		226,
		208,
		-1,
		236,
		226,
		257,
		242,
		223,
		210,
		217,
		217,
		210,
		-1,
		-1,
		-1,
		265,
		264,
		256,
		250,
		250,
		235,
		226,
		-1,
		238,
		220,
		199,
		216,
		216,
		207,
		215,
		247,
		243,
		230,
		230,
		222,
		-1,
		366,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		259,
		254,
		227,
		215,
		221,
		217,
		203,
		209,
		211,
		219,
		217,
		214,
		226,
		222,
		242,
		223,
		258,
		-1,
		361,
		-1,
		295,
		-1,
		-1,
		277,
		257,
		249,
		238,
		227,
		225,
		216,
		207,
		229,
		245,
		229,
		227,
		230,
		231,
		-1,
		350,
		349,
		-1,
		296,
		288,
		274,
		-1,
		267,
		-1,
		273,
		234,
		-1,
		236,
		216,
		-1,
		238,
		234,
		-1,
		-1,
		337,
		312,
		-1,
		-1,
		-1,
		297,
		277,
		268,
		252,
		-1,
		227,
		227,
		-1,
		-1,
		-1,
		322,
		321,
		-1,
		290,
		293,
		-1,
		283,
		274,
		282,
		229,
		233,
		-1,
		-1,
		-1,
		331,
		312,
		306,
		305,
		303,
		298,
		295,
		281,
		265,
		243,
		232,
		253,
		-1,
		-1,
		-1,
		303,
		295,
		288,
		-1,
		-1,
		290,
		273,
		254,
		252,
		-1,
		-1,
		-1,
		325,
		306,
		-1,
		-1,
		280,
		-1,
		-1,
		286,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		342,
		314,
		-1,
		-1,
		-1,
		276,
		272,
		273,
		-1,
		-1,
		-1,
		-1,
		336,
		337,
		360,
		324,
		-1,
		-1,
		-1,
		268,
		262,
		-1,
		-1,
		339,
		337,
		-1,
		-1,
		-1,
		296,
		280,
		-1,
		266,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		301,
		-1,
		301,
		276,
		283,
		-1,
		-1,
		-1,
		-1,
		314,
		306,
		314,
		-1,
		286,
		288,
		-1,
		336,
		-1,
		-1,
		329,
		320,
		-1,
		-1,
		291,
		298,
		320,
		323,
		359,
		-1,
		310
	],
	[
		-1,
		89,
		78,
		89,
		97,
		70,
		77,
		-1,
		98,
		100,
		66,
		60,
		99,
		70,
		76,
		87,
		-1,
		-1,
		-1,
		89,
		88,
		58,
		56,
		65,
		70,
		77,
		-1,
		100,
		-1,
		110,
		89,
		100,
		105,
		51,
		48,
		68,
		87,
		93,
		85,
		125,
		81,
		52,
		46,
		64,
		69,
		87,
		79,
		-1,
		52,
		42,
		64,
		68,
		80,
		63,
		-1,
		-1,
		46,
		47,
		53,
		65,
		70,
		75,
		-1,
		101,
		120,
		-1,
		-1,
		36,
		49,
		45,
		48,
		56,
		72,
		93,
		110,
		115,
		-1,
		-1,
		37,
		41,
		54,
		55,
		53,
		80,
		99,
		110,
		124,
		123,
		-1,
		25,
		43,
		52,
		61,
		67,
		56,
		60,
		78,
		109,
		115,
		118,
		-1,
		17,
		19,
		48,
		54,
		66,
		72,
		59,
		65,
		84,
		97,
		116,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		35,
		14,
		22,
		48,
		47,
		43,
		61,
		83,
		62,
		68,
		72,
		89,
		105,
		106,
		116,
		-1,
		-1,
		88,
		61,
		85,
		43,
		31,
		-1,
		10,
		29,
		35,
		39,
		44,
		52,
		80,
		78,
		-1,
		83,
		82,
		113,
		99,
		110,
		70,
		-1,
		-1,
		46,
		38,
		20,
		23,
		0,
		5,
		35,
		34,
		39,
		41,
		43,
		55,
		70,
		70,
		80,
		77,
		87,
		91,
		106,
		117,
		-1,
		-1,
		191,
		-1,
		-1,
		67,
		50,
		-1,
		15,
		22,
		6,
		12,
		3,
		28,
		43,
		47,
		55,
		58,
		46,
		65,
		62,
		86,
		82,
		74,
		99,
		103,
		109,
		127,
		128,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		22,
		19,
		12,
		36,
		35,
		-1,
		50,
		48,
		72,
		66,
		71,
		67,
		52,
		70,
		68,
		83,
		85,
		81,
		83,
		120,
		111,
		132,
		129,
		160,
		166,
		160,
		169,
		-1,
		75,
		71,
		67,
		74,
		23,
		-1,
		-1,
		40,
		-1,
		43,
		56,
		62,
		52,
		55,
		67,
		75,
		74,
		58,
		76,
		71,
		74,
		93,
		89,
		98,
		108,
		107,
		125,
		138,
		153,
		157,
		163,
		-1,
		125,
		-1,
		67,
		51,
		53,
		29,
		57,
		-1,
		60,
		44,
		64,
		64,
		64,
		-1,
		80,
		77,
		90,
		74,
		59,
		76,
		78,
		82,
		92,
		96,
		111,
		102,
		120,
		127,
		135,
		139,
		159,
		171,
		85,
		75,
		-1,
		57,
		62,
		32,
		44,
		76,
		87,
		71,
		-1,
		75,
		-1,
		82,
		95,
		-1,
		80,
		76,
		65,
		81,
		89,
		96,
		99,
		93,
		90,
		108,
		111,
		128,
		132,
		148,
		-1,
		-1,
		70,
		74,
		91,
		38,
		61,
		85,
		122,
		80,
		82,
		81,
		-1,
		100,
		101,
		98,
		99,
		85,
		78,
		79,
		95,
		101,
		97,
		92,
		95,
		117,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		68,
		39,
		63,
		105,
		111,
		104,
		92,
		109,
		109,
		116,
		-1,
		116,
		95,
		92,
		83,
		91,
		105,
		102,
		116,
		96,
		98,
		114,
		126,
		117,
		137,
		-1,
		-1,
		-1,
		98,
		87,
		88,
		42,
		76,
		94,
		142,
		128,
		133,
		108,
		114,
		114,
		110,
		112,
		107,
		101,
		93,
		82,
		98,
		106,
		108,
		98,
		107,
		108,
		132,
		139,
		145,
		-1,
		-1,
		105,
		95,
		79,
		81,
		78,
		67,
		74,
		106,
		133,
		149,
		-1,
		119,
		-1,
		108,
		116,
		106,
		101,
		98,
		95,
		89,
		98,
		112,
		112,
		103,
		118,
		137,
		137,
		129,
		154,
		157,
		-1,
		-1,
		-1,
		98,
		115,
		90,
		67,
		48,
		84,
		-1,
		119,
		120,
		-1,
		113,
		107,
		113,
		108,
		104,
		99,
		103,
		96,
		103,
		99,
		113,
		122,
		104,
		140,
		-1,
		137,
		131,
		159,
		153,
		141,
		-1,
		-1,
		-1,
		113,
		92,
		85,
		105,
		55,
		107,
		-1,
		-1,
		104,
		97,
		-1,
		100,
		100,
		107,
		106,
		100,
		104,
		108,
		97,
		110,
		115,
		109,
		119,
		139,
		143,
		150,
		143,
		139,
		136,
		150,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		75,
		-1,
		112,
		104,
		95,
		89,
		95,
		113,
		111,
		128,
		112,
		115,
		115,
		111,
		119,
		104,
		107,
		112,
		116,
		134,
		149,
		141,
		135,
		134,
		146,
		-1,
		161,
		147,
		118,
		-1,
		-1,
		90,
		-1,
		61,
		85,
		101,
		-1,
		129,
		108,
		131,
		109,
		123,
		119,
		135,
		136,
		114,
		119,
		118,
		128,
		129,
		118,
		124,
		123,
		143,
		145,
		129,
		130,
		139,
		-1,
		167,
		154,
		112,
		108,
		97,
		117,
		64,
		77,
		88,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		133,
		131,
		125,
		116,
		122,
		129,
		132,
		133,
		123,
		112,
		118,
		117,
		139,
		125,
		123,
		142,
		158,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		83,
		70,
		64,
		-1,
		105,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		133,
		117,
		122,
		-1,
		158,
		-1,
		131,
		133,
		125,
		114,
		111,
		122,
		120,
		131,
		148,
		-1,
		117,
		102,
		95,
		85,
		99,
		70,
		-1,
		121,
		-1,
		-1,
		138,
		132,
		132,
		116,
		119,
		149,
		129,
		123,
		122,
		153,
		151,
		139,
		123,
		116,
		113,
		114,
		127,
		147,
		138,
		150,
		-1,
		-1,
		-1,
		122,
		102,
		108,
		66,
		87,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		125,
		166,
		154,
		144,
		134,
		168,
		167,
		142,
		135,
		121,
		123,
		121,
		123,
		128,
		149,
		150,
		163,
		-1,
		-1,
		99,
		106,
		94,
		80,
		99,
		-1,
		-1,
		-1,
		147,
		163,
		155,
		126,
		155,
		-1,
		-1,
		146,
		144,
		154,
		138,
		125,
		145,
		148,
		138,
		122,
		137,
		149,
		157,
		162,
		-1,
		102,
		89,
		-1,
		-1,
		102,
		96,
		-1,
		-1,
		-1,
		-1,
		180,
		146,
		158,
		179,
		183,
		149,
		-1,
		154,
		149,
		129,
		143,
		150,
		140,
		135,
		129,
		132,
		150,
		167,
		-1,
		-1,
		116,
		-1,
		111,
		-1,
		-1,
		-1,
		-1,
		137,
		151,
		172,
		165,
		169,
		-1,
		157,
		145,
		131,
		148,
		153,
		150,
		141,
		133,
		138,
		135,
		148,
		162,
		166,
		139,
		-1,
		122,
		-1,
		-1,
		-1,
		155,
		170,
		211,
		188,
		161,
		156,
		149,
		143,
		139,
		155,
		161,
		172,
		140,
		136,
		137,
		141,
		140,
		157,
		167,
		-1,
		-1,
		122,
		139,
		174,
		163,
		167,
		238,
		-1,
		-1,
		165,
		156,
		147,
		150,
		149,
		152,
		146,
		143,
		148,
		153,
		141,
		150,
		168,
		167,
		-1,
		-1,
		-1,
		142,
		-1,
		157,
		-1,
		-1,
		182,
		236,
		183,
		165,
		161,
		159,
		152,
		161,
		156,
		151,
		161,
		163,
		155,
		143,
		147,
		170,
		159,
		198,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		171,
		146,
		161,
		207,
		202,
		203,
		198,
		195,
		-1,
		165,
		190,
		162,
		169,
		160,
		167,
		167,
		159,
		137,
		144,
		160,
		159,
		154,
		190,
		181,
		187,
		-1,
		-1,
		252,
		241,
		230,
		236,
		-1,
		177,
		163,
		193,
		183,
		189,
		-1,
		-1,
		214,
		211,
		187,
		170,
		168,
		161,
		156,
		166,
		146,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		147,
		228,
		221,
		204,
		212,
		243,
		-1,
		180,
		189,
		170,
		175,
		183,
		-1,
		-1,
		187,
		184,
		189,
		177,
		174,
		176,
		171,
		162,
		147,
		153,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		161,
		204,
		198,
		201,
		225,
		239,
		-1,
		193,
		-1,
		-1,
		178,
		196,
		202,
		192,
		186,
		236,
		191,
		186,
		170,
		168,
		159,
		150,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		196,
		184,
		192,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		194,
		-1,
		229,
		-1,
		204,
		208,
		199,
		202,
		184,
		171,
		163,
		155,
		171,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		270,
		225,
		192,
		183,
		230,
		245,
		249,
		-1,
		206,
		245,
		232,
		-1,
		203,
		-1,
		-1,
		-1,
		218,
		212,
		204,
		204,
		183,
		183,
		157,
		161,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		266,
		264,
		269,
		214,
		197,
		215,
		224,
		245,
		221,
		212,
		239,
		239,
		228,
		223,
		210,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		190,
		178,
		161,
		162,
		158,
		161,
		176,
		179,
		169,
		167,
		161,
		193,
		-1,
		266,
		265,
		254,
		251,
		227,
		218,
		205,
		216,
		-1,
		-1,
		224,
		240,
		253,
		257,
		270,
		295,
		-1,
		213,
		-1,
		-1,
		235,
		-1,
		-1,
		220,
		183,
		172,
		163,
		169,
		166,
		177,
		187,
		175,
		176,
		166,
		176,
		189,
		250,
		247,
		235,
		233,
		256,
		213,
		209,
		-1,
		239,
		227,
		233,
		240,
		257,
		284,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		218,
		216,
		205,
		-1,
		195,
		168,
		173,
		193,
		195,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		259,
		273,
		262,
		258,
		257,
		265,
		214,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		-1,
		256,
		239,
		-1,
		-1,
		213,
		206,
		194,
		182,
		172,
		182,
		186,
		190,
		182,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		293,
		-1,
		245,
		238,
		253,
		268,
		276,
		-1,
		-1,
		-1,
		273,
		259,
		252,
		240,
		238,
		-1,
		247,
		231,
		212,
		-1,
		182,
		195,
		226,
		194,
		199,
		194,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		251,
		254,
		-1,
		-1,
		263,
		265,
		-1,
		264,
		253,
		238,
		230,
		-1,
		-1,
		219,
		215,
		-1,
		-1,
		183,
		208,
		197,
		205,
		200,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		258,
		259,
		264,
		-1,
		248,
		-1,
		266,
		-1,
		233,
		239,
		227,
		-1,
		-1,
		-1,
		221,
		184,
		205,
		215,
		209,
		207,
		198,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		266,
		240,
		273,
		264,
		247,
		227,
		219,
		238,
		-1,
		208,
		-1,
		183,
		185,
		211,
		214,
		220,
		214,
		187,
		202,
		192,
		183,
		192,
		272,
		-1,
		242,
		275,
		239,
		233,
		209,
		213,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		236,
		221,
		202,
		189,
		196,
		196,
		189,
		-1,
		-1,
		-1,
		244,
		243,
		235,
		229,
		229,
		214,
		205,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		226,
		222,
		209,
		209,
		201,
		-1,
		345,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		238,
		233,
		206,
		194,
		200,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		202,
		237,
		-1,
		340,
		-1,
		274,
		-1,
		-1,
		256,
		236,
		228,
		217,
		206,
		204,
		195,
		186,
		208,
		224,
		208,
		206,
		209,
		210,
		-1,
		329,
		328,
		-1,
		275,
		267,
		253,
		-1,
		246,
		-1,
		252,
		213,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		316,
		291,
		-1,
		-1,
		-1,
		276,
		256,
		247,
		231,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		301,
		300,
		-1,
		269,
		272,
		-1,
		262,
		253,
		261,
		208,
		212,
		-1,
		-1,
		-1,
		310,
		291,
		285,
		284,
		282,
		277,
		274,
		260,
		244,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		282,
		274,
		267,
		-1,
		-1,
		269,
		252,
		233,
		231,
		-1,
		-1,
		-1,
		304,
		285,
		-1,
		-1,
		259,
		-1,
		-1,
		265,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		321,
		293,
		-1,
		-1,
		-1,
		255,
		251,
		252,
		-1,
		-1,
		-1,
		-1,
		315,
		316,
		339,
		303,
		-1,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		318,
		316,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		245,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		280,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		293,
		285,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		308,
		299,
		-1,
		-1,
		270,
		277,
		299,
		302,
		338,
		-1,
		289
	],
	[
		-1,
		84,
		73,
		84,
		92,
		65,
		72,
		-1,
		93,
		95,
		61,
		55,
		94,
		65,
		71,
		82,
		-1,
		-1,
		-1,
		84,
		83,
		53,
		51,
		60,
		65,
		72,
		-1,
		95,
		-1,
		105,
		84,
		95,
		100,
		46,
		43,
		63,
		82,
		88,
		80,
		120,
		76,
		47,
		41,
		59,
		64,
		82,
		74,
		-1,
		47,
		37,
		59,
		63,
		75,
		58,
		-1,
		-1,
		41,
		42,
		48,
		60,
		65,
		70,
		-1,
		96,
		115,
		-1,
		-1,
		31,
		44,
		40,
		43,
		51,
		67,
		88,
		105,
		110,
		-1,
		-1,
		32,
		36,
		49,
		50,
		48,
		75,
		94,
		105,
		119,
		118,
		-1,
		20,
		38,
		47,
		56,
		62,
		51,
		55,
		73,
		104,
		110,
		113,
		-1,
		12,
		14,
		43,
		49,
		61,
		67,
		54,
		60,
		79,
		92,
		111,
		102,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		39,
		9,
		17,
		43,
		42,
		38,
		56,
		78,
		57,
		63,
		67,
		84,
		100,
		101,
		111,
		-1,
		-1,
		92,
		65,
		89,
		47,
		35,
		-1,
		5,
		24,
		30,
		34,
		39,
		47,
		75,
		73,
		-1,
		78,
		77,
		108,
		94,
		105,
		74,
		-1,
		-1,
		50,
		42,
		24,
		27,
		4,
		0,
		30,
		29,
		34,
		36,
		38,
		50,
		65,
		65,
		75,
		72,
		82,
		86,
		101,
		112,
		-1,
		-1,
		186,
		-1,
		-1,
		71,
		54,
		-1,
		19,
		26,
		10,
		16,
		2,
		23,
		38,
		42,
		50,
		53,
		41,
		60,
		57,
		81,
		77,
		69,
		94,
		98,
		104,
		122,
		123,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		49,
		26,
		23,
		16,
		40,
		39,
		-1,
		45,
		43,
		67,
		61,
		66,
		62,
		47,
		65,
		63,
		78,
		80,
		76,
		78,
		115,
		106,
		127,
		124,
		155,
		161,
		155,
		164,
		-1,
		79,
		75,
		71,
		78,
		27,
		-1,
		-1,
		44,
		-1,
		47,
		60,
		57,
		47,
		50,
		62,
		70,
		69,
		53,
		71,
		66,
		69,
		88,
		84,
		93,
		103,
		102,
		120,
		133,
		148,
		152,
		158,
		-1,
		129,
		-1,
		71,
		55,
		57,
		33,
		61,
		-1,
		64,
		48,
		68,
		59,
		59,
		-1,
		75,
		72,
		85,
		69,
		54,
		71,
		73,
		77,
		87,
		91,
		106,
		97,
		115,
		122,
		130,
		134,
		154,
		166,
		89,
		79,
		-1,
		61,
		66,
		36,
		48,
		71,
		91,
		75,
		-1,
		70,
		-1,
		77,
		90,
		-1,
		75,
		71,
		60,
		76,
		84,
		91,
		94,
		88,
		85,
		103,
		106,
		123,
		127,
		143,
		-1,
		-1,
		74,
		78,
		86,
		37,
		56,
		80,
		117,
		84,
		77,
		76,
		-1,
		95,
		96,
		93,
		94,
		80,
		73,
		74,
		90,
		96,
		92,
		87,
		90,
		112,
		140,
		118,
		130,
		-1,
		-1,
		-1,
		99,
		-1,
		-1,
		63,
		34,
		58,
		100,
		106,
		99,
		87,
		104,
		104,
		111,
		-1,
		111,
		90,
		87,
		78,
		86,
		100,
		97,
		111,
		91,
		93,
		109,
		121,
		112,
		132,
		-1,
		-1,
		-1,
		93,
		82,
		83,
		37,
		71,
		89,
		137,
		123,
		128,
		103,
		109,
		109,
		105,
		107,
		102,
		96,
		88,
		77,
		93,
		101,
		103,
		93,
		102,
		103,
		127,
		134,
		140,
		-1,
		-1,
		100,
		90,
		74,
		76,
		73,
		62,
		69,
		101,
		128,
		144,
		-1,
		114,
		-1,
		103,
		111,
		101,
		96,
		93,
		90,
		84,
		93,
		107,
		107,
		98,
		113,
		132,
		132,
		124,
		149,
		152,
		-1,
		-1,
		-1,
		93,
		110,
		85,
		62,
		43,
		79,
		-1,
		114,
		115,
		-1,
		108,
		102,
		108,
		103,
		99,
		94,
		98,
		91,
		98,
		94,
		108,
		117,
		99,
		135,
		-1,
		132,
		126,
		154,
		148,
		136,
		-1,
		-1,
		-1,
		108,
		87,
		80,
		100,
		50,
		102,
		-1,
		-1,
		99,
		92,
		-1,
		95,
		95,
		102,
		101,
		95,
		99,
		103,
		92,
		105,
		110,
		104,
		114,
		134,
		138,
		145,
		138,
		134,
		131,
		145,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		70,
		-1,
		107,
		99,
		90,
		84,
		90,
		108,
		106,
		123,
		107,
		110,
		110,
		106,
		114,
		99,
		102,
		107,
		111,
		129,
		144,
		136,
		130,
		129,
		141,
		-1,
		156,
		142,
		113,
		-1,
		-1,
		85,
		-1,
		56,
		80,
		96,
		-1,
		124,
		103,
		126,
		104,
		118,
		114,
		130,
		131,
		109,
		114,
		113,
		123,
		124,
		113,
		119,
		118,
		138,
		140,
		124,
		125,
		134,
		-1,
		162,
		149,
		107,
		103,
		92,
		112,
		59,
		72,
		83,
		-1,
		-1,
		168,
		-1,
		102,
		119,
		128,
		126,
		120,
		111,
		117,
		124,
		127,
		128,
		118,
		107,
		113,
		112,
		134,
		120,
		118,
		137,
		153,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		78,
		65,
		59,
		-1,
		100,
		-1,
		146,
		136,
		120,
		105,
		138,
		-1,
		128,
		112,
		117,
		-1,
		153,
		-1,
		126,
		128,
		120,
		109,
		106,
		117,
		115,
		126,
		143,
		-1,
		112,
		97,
		90,
		80,
		94,
		65,
		-1,
		116,
		-1,
		-1,
		133,
		127,
		127,
		111,
		114,
		144,
		124,
		118,
		117,
		148,
		146,
		134,
		118,
		111,
		108,
		109,
		122,
		142,
		133,
		145,
		-1,
		-1,
		-1,
		117,
		97,
		103,
		61,
		82,
		-1,
		-1,
		195,
		150,
		136,
		-1,
		120,
		161,
		149,
		139,
		129,
		163,
		162,
		137,
		130,
		116,
		118,
		116,
		118,
		123,
		144,
		145,
		158,
		-1,
		-1,
		94,
		101,
		89,
		75,
		94,
		-1,
		-1,
		-1,
		142,
		158,
		150,
		121,
		150,
		-1,
		-1,
		141,
		139,
		149,
		133,
		120,
		140,
		143,
		133,
		117,
		132,
		144,
		152,
		157,
		-1,
		97,
		84,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		153,
		174,
		178,
		144,
		-1,
		149,
		144,
		124,
		138,
		145,
		135,
		130,
		124,
		127,
		145,
		162,
		-1,
		-1,
		111,
		-1,
		106,
		-1,
		-1,
		-1,
		-1,
		132,
		146,
		167,
		160,
		164,
		-1,
		152,
		140,
		126,
		143,
		148,
		145,
		136,
		128,
		133,
		130,
		143,
		157,
		161,
		134,
		-1,
		117,
		-1,
		-1,
		-1,
		150,
		165,
		206,
		183,
		156,
		151,
		144,
		138,
		134,
		150,
		156,
		167,
		135,
		131,
		132,
		136,
		135,
		152,
		162,
		-1,
		-1,
		117,
		134,
		169,
		158,
		162,
		233,
		-1,
		-1,
		160,
		151,
		142,
		145,
		144,
		147,
		141,
		138,
		143,
		148,
		136,
		145,
		163,
		162,
		-1,
		-1,
		-1,
		137,
		-1,
		152,
		-1,
		-1,
		177,
		231,
		178,
		160,
		156,
		154,
		147,
		156,
		151,
		146,
		156,
		158,
		150,
		138,
		142,
		165,
		154,
		193,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		166,
		141,
		156,
		202,
		197,
		198,
		193,
		190,
		-1,
		160,
		185,
		157,
		164,
		155,
		162,
		162,
		154,
		132,
		139,
		155,
		154,
		149,
		185,
		176,
		182,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		172,
		158,
		188,
		178,
		184,
		-1,
		-1,
		209,
		206,
		182,
		165,
		163,
		156,
		151,
		161,
		141,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		142,
		223,
		216,
		199,
		207,
		238,
		-1,
		175,
		184,
		165,
		170,
		178,
		-1,
		-1,
		182,
		179,
		184,
		172,
		169,
		171,
		166,
		157,
		142,
		148,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		156,
		199,
		193,
		196,
		220,
		234,
		-1,
		188,
		-1,
		-1,
		173,
		191,
		197,
		187,
		181,
		231,
		186,
		181,
		165,
		163,
		154,
		145,
		152,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		191,
		179,
		187,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		189,
		-1,
		224,
		-1,
		199,
		203,
		194,
		197,
		179,
		166,
		158,
		150,
		166,
		141,
		151,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		265,
		220,
		187,
		178,
		225,
		240,
		244,
		-1,
		201,
		240,
		227,
		-1,
		198,
		-1,
		-1,
		-1,
		213,
		207,
		199,
		199,
		178,
		178,
		152,
		156,
		146,
		153,
		163,
		165,
		157,
		161,
		174,
		185,
		188,
		261,
		259,
		264,
		209,
		192,
		210,
		219,
		240,
		216,
		207,
		234,
		234,
		223,
		218,
		205,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		185,
		173,
		156,
		157,
		153,
		156,
		171,
		174,
		164,
		162,
		156,
		188,
		-1,
		261,
		260,
		249,
		246,
		222,
		213,
		200,
		211,
		-1,
		-1,
		219,
		235,
		248,
		252,
		265,
		290,
		-1,
		208,
		-1,
		-1,
		230,
		-1,
		-1,
		215,
		178,
		167,
		158,
		164,
		161,
		172,
		182,
		170,
		171,
		161,
		171,
		184,
		245,
		242,
		230,
		228,
		251,
		208,
		204,
		-1,
		234,
		222,
		228,
		235,
		252,
		279,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		213,
		211,
		200,
		-1,
		190,
		163,
		168,
		188,
		190,
		179,
		173,
		167,
		174,
		173,
		181,
		189,
		254,
		268,
		257,
		253,
		252,
		260,
		209,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		234,
		-1,
		-1,
		208,
		201,
		189,
		177,
		167,
		177,
		181,
		185,
		177,
		170,
		165,
		176,
		168,
		172,
		189,
		-1,
		288,
		-1,
		240,
		233,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		242,
		226,
		207,
		-1,
		177,
		190,
		221,
		189,
		194,
		189,
		171,
		182,
		171,
		174,
		188,
		183,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		258,
		260,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		214,
		210,
		-1,
		-1,
		178,
		203,
		192,
		200,
		195,
		175,
		181,
		184,
		173,
		177,
		189,
		-1,
		-1,
		253,
		254,
		259,
		-1,
		243,
		-1,
		261,
		-1,
		228,
		234,
		222,
		-1,
		-1,
		-1,
		216,
		179,
		200,
		210,
		204,
		202,
		193,
		179,
		186,
		184,
		180,
		191,
		-1,
		-1,
		-1,
		261,
		235,
		268,
		259,
		242,
		222,
		214,
		233,
		-1,
		203,
		-1,
		178,
		180,
		206,
		209,
		215,
		209,
		182,
		197,
		187,
		178,
		187,
		267,
		-1,
		237,
		270,
		234,
		228,
		204,
		208,
		224,
		-1,
		200,
		182,
		-1,
		210,
		200,
		231,
		216,
		197,
		184,
		191,
		191,
		184,
		-1,
		-1,
		-1,
		239,
		238,
		230,
		224,
		224,
		209,
		200,
		-1,
		212,
		194,
		173,
		190,
		190,
		181,
		189,
		221,
		217,
		204,
		204,
		196,
		-1,
		340,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		233,
		228,
		201,
		189,
		195,
		191,
		177,
		183,
		185,
		193,
		191,
		188,
		200,
		196,
		216,
		197,
		232,
		-1,
		335,
		-1,
		269,
		-1,
		-1,
		251,
		231,
		223,
		212,
		201,
		199,
		190,
		181,
		203,
		219,
		203,
		201,
		204,
		205,
		-1,
		324,
		323,
		-1,
		270,
		262,
		248,
		-1,
		241,
		-1,
		247,
		208,
		-1,
		210,
		190,
		-1,
		212,
		208,
		-1,
		-1,
		311,
		286,
		-1,
		-1,
		-1,
		271,
		251,
		242,
		226,
		-1,
		201,
		201,
		-1,
		-1,
		-1,
		296,
		295,
		-1,
		264,
		267,
		-1,
		257,
		248,
		256,
		203,
		207,
		-1,
		-1,
		-1,
		305,
		286,
		280,
		279,
		277,
		272,
		269,
		255,
		239,
		217,
		206,
		227,
		-1,
		-1,
		-1,
		277,
		269,
		262,
		-1,
		-1,
		264,
		247,
		228,
		226,
		-1,
		-1,
		-1,
		299,
		280,
		-1,
		-1,
		254,
		-1,
		-1,
		260,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		288,
		-1,
		-1,
		-1,
		250,
		246,
		247,
		-1,
		-1,
		-1,
		-1,
		310,
		311,
		334,
		298,
		-1,
		-1,
		-1,
		242,
		236,
		-1,
		-1,
		313,
		311,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		240,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		275,
		-1,
		275,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		288,
		280,
		288,
		-1,
		260,
		262,
		-1,
		310,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		265,
		272,
		294,
		297,
		333,
		-1,
		284
	],
	[
		-1,
		91,
		80,
		91,
		99,
		72,
		79,
		-1,
		100,
		102,
		68,
		62,
		101,
		72,
		78,
		89,
		-1,
		-1,
		-1,
		91,
		90,
		60,
		58,
		67,
		72,
		79,
		-1,
		102,
		-1,
		112,
		91,
		102,
		107,
		53,
		50,
		70,
		89,
		95,
		87,
		127,
		83,
		54,
		48,
		66,
		71,
		89,
		81,
		-1,
		54,
		44,
		66,
		70,
		82,
		65,
		-1,
		-1,
		48,
		49,
		55,
		67,
		72,
		77,
		-1,
		103,
		122,
		-1,
		-1,
		38,
		51,
		47,
		50,
		58,
		74,
		95,
		112,
		117,
		-1,
		-1,
		39,
		43,
		56,
		57,
		55,
		82,
		101,
		112,
		126,
		125,
		-1,
		27,
		45,
		54,
		63,
		69,
		58,
		62,
		80,
		111,
		117,
		120,
		-1,
		36,
		37,
		43,
		51,
		56,
		63,
		61,
		67,
		86,
		99,
		118,
		109,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		36,
		19,
		36,
		33,
		26,
		44,
		66,
		64,
		70,
		74,
		91,
		107,
		108,
		118,
		-1,
		-1,
		130,
		103,
		127,
		85,
		63,
		-1,
		32,
		12,
		18,
		22,
		27,
		35,
		63,
		63,
		-1,
		85,
		84,
		115,
		101,
		112,
		112,
		-1,
		-1,
		88,
		80,
		62,
		65,
		42,
		38,
		0,
		13,
		22,
		24,
		26,
		38,
		53,
		53,
		63,
		79,
		89,
		93,
		108,
		119,
		-1,
		-1,
		193,
		-1,
		-1,
		109,
		92,
		-1,
		57,
		64,
		48,
		54,
		40,
		61,
		24,
		25,
		38,
		41,
		29,
		48,
		45,
		69,
		65,
		76,
		101,
		105,
		111,
		129,
		130,
		-1,
		192,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		64,
		61,
		54,
		78,
		77,
		-1,
		72,
		60,
		61,
		46,
		54,
		50,
		35,
		53,
		51,
		66,
		68,
		83,
		85,
		119,
		113,
		134,
		131,
		162,
		168,
		162,
		171,
		-1,
		117,
		113,
		109,
		116,
		65,
		-1,
		-1,
		82,
		-1,
		85,
		98,
		84,
		57,
		60,
		47,
		55,
		57,
		41,
		59,
		54,
		57,
		77,
		90,
		97,
		110,
		109,
		127,
		140,
		155,
		159,
		165,
		-1,
		167,
		-1,
		109,
		93,
		95,
		71,
		99,
		-1,
		102,
		86,
		101,
		86,
		86,
		-1,
		63,
		60,
		70,
		57,
		42,
		59,
		61,
		65,
		76,
		97,
		113,
		104,
		122,
		129,
		137,
		141,
		161,
		173,
		127,
		117,
		-1,
		99,
		104,
		74,
		86,
		109,
		129,
		113,
		-1,
		97,
		-1,
		65,
		78,
		-1,
		63,
		59,
		48,
		64,
		72,
		79,
		83,
		95,
		92,
		110,
		113,
		130,
		134,
		150,
		-1,
		-1,
		112,
		116,
		124,
		75,
		94,
		118,
		155,
		115,
		104,
		103,
		-1,
		83,
		84,
		81,
		82,
		68,
		61,
		62,
		78,
		84,
		80,
		94,
		97,
		119,
		147,
		125,
		137,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		101,
		72,
		96,
		138,
		133,
		126,
		114,
		122,
		120,
		107,
		-1,
		99,
		78,
		75,
		66,
		74,
		88,
		85,
		99,
		98,
		100,
		116,
		128,
		119,
		139,
		-1,
		-1,
		-1,
		131,
		120,
		121,
		75,
		109,
		127,
		155,
		141,
		146,
		121,
		109,
		116,
		93,
		95,
		90,
		84,
		76,
		65,
		81,
		89,
		91,
		100,
		109,
		110,
		134,
		141,
		147,
		-1,
		-1,
		138,
		128,
		112,
		114,
		111,
		100,
		107,
		139,
		146,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		95,
		106,
		102,
		109,
		139,
		139,
		131,
		156,
		159,
		-1,
		-1,
		-1,
		131,
		148,
		123,
		100,
		81,
		117,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		82,
		96,
		107,
		94,
		130,
		-1,
		139,
		133,
		146,
		136,
		124,
		-1,
		-1,
		-1,
		146,
		125,
		118,
		138,
		88,
		140,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		91,
		80,
		93,
		98,
		99,
		109,
		129,
		133,
		137,
		126,
		122,
		119,
		133,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		108,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		98,
		94,
		102,
		87,
		90,
		102,
		106,
		124,
		132,
		124,
		118,
		117,
		129,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		123,
		-1,
		94,
		118,
		134,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		102,
		101,
		111,
		112,
		101,
		114,
		106,
		128,
		128,
		112,
		113,
		122,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		97,
		101,
		121,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		112,
		115,
		116,
		106,
		95,
		101,
		100,
		122,
		108,
		106,
		125,
		141,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		116,
		100,
		105,
		-1,
		141,
		-1,
		114,
		116,
		108,
		97,
		94,
		105,
		103,
		114,
		131,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		154,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		132,
		112,
		106,
		105,
		136,
		134,
		122,
		106,
		99,
		96,
		97,
		110,
		130,
		121,
		133,
		-1,
		-1,
		-1,
		155,
		135,
		141,
		99,
		120,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		149,
		137,
		127,
		117,
		151,
		150,
		125,
		118,
		104,
		106,
		104,
		106,
		111,
		132,
		133,
		146,
		-1,
		-1,
		132,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		138,
		-1,
		-1,
		129,
		127,
		137,
		121,
		108,
		128,
		131,
		121,
		105,
		120,
		132,
		140,
		145,
		-1,
		135,
		122,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		160,
		162,
		166,
		132,
		-1,
		137,
		132,
		112,
		126,
		133,
		123,
		118,
		112,
		115,
		133,
		150,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		139,
		153,
		155,
		148,
		152,
		-1,
		140,
		128,
		114,
		131,
		136,
		133,
		124,
		116,
		121,
		118,
		131,
		145,
		149,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		172,
		194,
		171,
		144,
		139,
		132,
		126,
		122,
		138,
		144,
		155,
		123,
		119,
		120,
		124,
		123,
		140,
		150,
		-1,
		-1,
		155,
		172,
		183,
		165,
		169,
		221,
		-1,
		-1,
		148,
		139,
		130,
		133,
		132,
		135,
		129,
		126,
		131,
		136,
		124,
		133,
		151,
		150,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		184,
		219,
		166,
		148,
		144,
		142,
		135,
		144,
		139,
		134,
		144,
		146,
		138,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		204,
		179,
		194,
		230,
		204,
		211,
		181,
		178,
		-1,
		148,
		173,
		145,
		152,
		143,
		150,
		150,
		142,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		210,
		196,
		216,
		206,
		209,
		-1,
		-1,
		197,
		194,
		170,
		153,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		180,
		261,
		254,
		237,
		245,
		276,
		-1,
		213,
		212,
		203,
		198,
		200,
		-1,
		-1,
		170,
		167,
		172,
		160,
		157,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		194,
		237,
		231,
		234,
		258,
		272,
		-1,
		217,
		-1,
		-1,
		211,
		201,
		185,
		175,
		169,
		219,
		174,
		169,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		229,
		217,
		225,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		227,
		-1,
		212,
		-1,
		187,
		191,
		182,
		185,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		288,
		244,
		225,
		216,
		263,
		278,
		282,
		-1,
		229,
		268,
		265,
		-1,
		236,
		-1,
		-1,
		-1,
		201,
		195,
		187,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		284,
		275,
		288,
		233,
		230,
		248,
		257,
		278,
		244,
		235,
		262,
		272,
		261,
		256,
		243,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		224,
		249,
		-1,
		-1,
		246,
		263,
		257,
		261,
		277,
		302,
		-1,
		233,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		261,
		258,
		246,
		244,
		267,
		232,
		220,
		-1,
		233,
		231,
		237,
		244,
		261,
		291,
		-1,
		-1,
		249,
		229,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		218,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		235,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		304,
		-1,
		256,
		232,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		251,
		252,
		253,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		92,
		81,
		92,
		100,
		73,
		80,
		-1,
		101,
		103,
		69,
		63,
		102,
		73,
		79,
		90,
		-1,
		-1,
		-1,
		92,
		91,
		61,
		59,
		68,
		73,
		80,
		-1,
		103,
		-1,
		113,
		92,
		103,
		108,
		54,
		51,
		71,
		90,
		96,
		88,
		128,
		84,
		55,
		49,
		67,
		72,
		90,
		82,
		-1,
		55,
		45,
		67,
		71,
		83,
		66,
		-1,
		-1,
		49,
		50,
		56,
		68,
		73,
		78,
		-1,
		104,
		123,
		-1,
		-1,
		39,
		52,
		48,
		51,
		59,
		75,
		96,
		113,
		118,
		-1,
		-1,
		40,
		44,
		57,
		58,
		56,
		83,
		102,
		113,
		127,
		126,
		-1,
		28,
		46,
		55,
		64,
		70,
		59,
		63,
		81,
		112,
		118,
		121,
		-1,
		37,
		38,
		44,
		52,
		57,
		64,
		62,
		68,
		87,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		37,
		20,
		37,
		34,
		27,
		45,
		67,
		65,
		71,
		75,
		92,
		108,
		109,
		119,
		-1,
		-1,
		131,
		104,
		128,
		86,
		64,
		-1,
		33,
		13,
		19,
		23,
		28,
		36,
		64,
		64,
		-1,
		86,
		85,
		116,
		102,
		113,
		113,
		-1,
		-1,
		89,
		81,
		63,
		66,
		43,
		39,
		1,
		0,
		23,
		25,
		27,
		39,
		54,
		54,
		64,
		80,
		90,
		94,
		109,
		120,
		-1,
		-1,
		194,
		-1,
		-1,
		110,
		93,
		-1,
		58,
		65,
		49,
		55,
		41,
		62,
		25,
		26,
		39,
		42,
		30,
		49,
		46,
		70,
		66,
		77,
		102,
		106,
		112,
		130,
		131,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		65,
		62,
		55,
		79,
		78,
		-1,
		73,
		61,
		62,
		47,
		55,
		51,
		36,
		54,
		52,
		67,
		69,
		84,
		86,
		120,
		114,
		135,
		132,
		163,
		169,
		163,
		172,
		-1,
		118,
		114,
		110,
		117,
		66,
		-1,
		-1,
		83,
		-1,
		86,
		99,
		85,
		58,
		61,
		48,
		56,
		58,
		42,
		60,
		55,
		58,
		78,
		91,
		98,
		111,
		110,
		128,
		141,
		156,
		160,
		166,
		-1,
		168,
		-1,
		110,
		94,
		96,
		72,
		100,
		-1,
		103,
		87,
		102,
		87,
		87,
		-1,
		64,
		61,
		71,
		58,
		43,
		60,
		62,
		66,
		77,
		98,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		128,
		118,
		-1,
		100,
		105,
		75,
		87,
		110,
		130,
		114,
		-1,
		98,
		-1,
		66,
		79,
		-1,
		64,
		60,
		49,
		65,
		73,
		80,
		84,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		113,
		117,
		125,
		76,
		95,
		119,
		156,
		116,
		105,
		104,
		-1,
		84,
		85,
		82,
		83,
		69,
		62,
		63,
		79,
		85,
		81,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		102,
		73,
		97,
		139,
		134,
		127,
		115,
		123,
		121,
		108,
		-1,
		100,
		79,
		76,
		67,
		75,
		89,
		86,
		100,
		99,
		101,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		132,
		121,
		122,
		76,
		110,
		128,
		156,
		142,
		147,
		122,
		110,
		117,
		94,
		96,
		91,
		85,
		77,
		66,
		82,
		90,
		92,
		101,
		110,
		111,
		135,
		142,
		148,
		-1,
		-1,
		139,
		129,
		113,
		115,
		112,
		101,
		108,
		140,
		147,
		168,
		-1,
		122,
		-1,
		111,
		106,
		90,
		85,
		82,
		79,
		73,
		82,
		96,
		107,
		103,
		110,
		140,
		140,
		132,
		157,
		160,
		-1,
		-1,
		-1,
		132,
		149,
		124,
		101,
		82,
		118,
		-1,
		138,
		139,
		-1,
		116,
		110,
		107,
		92,
		88,
		83,
		87,
		80,
		87,
		83,
		97,
		108,
		95,
		131,
		-1,
		140,
		134,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		89,
		141,
		-1,
		-1,
		123,
		116,
		-1,
		103,
		85,
		92,
		90,
		84,
		88,
		92,
		81,
		94,
		99,
		100,
		110,
		130,
		134,
		138,
		127,
		123,
		120,
		134,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		109,
		-1,
		132,
		124,
		114,
		108,
		102,
		98,
		96,
		112,
		96,
		99,
		99,
		95,
		103,
		88,
		91,
		103,
		107,
		125,
		133,
		125,
		119,
		118,
		130,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		124,
		-1,
		95,
		119,
		135,
		-1,
		140,
		119,
		134,
		112,
		108,
		104,
		119,
		120,
		98,
		103,
		102,
		112,
		113,
		102,
		115,
		107,
		129,
		129,
		113,
		114,
		123,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		98,
		102,
		122,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		118,
		116,
		109,
		100,
		106,
		113,
		116,
		117,
		107,
		96,
		102,
		101,
		123,
		109,
		107,
		126,
		142,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		117,
		101,
		106,
		-1,
		142,
		-1,
		115,
		117,
		109,
		98,
		95,
		106,
		104,
		115,
		132,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		155,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		133,
		113,
		107,
		106,
		137,
		135,
		123,
		107,
		100,
		97,
		98,
		111,
		131,
		122,
		134,
		-1,
		-1,
		-1,
		156,
		136,
		142,
		100,
		121,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		150,
		138,
		128,
		118,
		152,
		151,
		126,
		119,
		105,
		107,
		105,
		107,
		112,
		133,
		134,
		147,
		-1,
		-1,
		133,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		139,
		-1,
		-1,
		130,
		128,
		138,
		122,
		109,
		129,
		132,
		122,
		106,
		121,
		133,
		141,
		146,
		-1,
		136,
		123,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		161,
		163,
		167,
		133,
		-1,
		138,
		133,
		113,
		127,
		134,
		124,
		119,
		113,
		116,
		134,
		151,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		140,
		154,
		156,
		149,
		153,
		-1,
		141,
		129,
		115,
		132,
		137,
		134,
		125,
		117,
		122,
		119,
		132,
		146,
		150,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		158,
		173,
		195,
		172,
		145,
		140,
		133,
		127,
		123,
		139,
		145,
		156,
		124,
		120,
		121,
		125,
		124,
		141,
		151,
		-1,
		-1,
		156,
		173,
		184,
		166,
		170,
		222,
		-1,
		-1,
		149,
		140,
		131,
		134,
		133,
		136,
		130,
		127,
		132,
		137,
		125,
		134,
		152,
		151,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		185,
		220,
		167,
		149,
		145,
		143,
		136,
		145,
		140,
		135,
		145,
		147,
		139,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		205,
		180,
		195,
		231,
		205,
		212,
		182,
		179,
		-1,
		149,
		174,
		146,
		153,
		144,
		151,
		151,
		143,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		211,
		197,
		217,
		207,
		210,
		-1,
		-1,
		198,
		195,
		171,
		154,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		214,
		213,
		204,
		199,
		201,
		-1,
		-1,
		171,
		168,
		173,
		161,
		158,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		218,
		-1,
		-1,
		212,
		202,
		186,
		176,
		170,
		220,
		175,
		170,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		228,
		-1,
		213,
		-1,
		188,
		192,
		183,
		186,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		289,
		245,
		226,
		217,
		264,
		279,
		283,
		-1,
		230,
		269,
		266,
		-1,
		237,
		-1,
		-1,
		-1,
		202,
		196,
		188,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		285,
		276,
		289,
		234,
		231,
		249,
		258,
		279,
		245,
		236,
		263,
		273,
		262,
		257,
		244,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		225,
		250,
		-1,
		-1,
		247,
		264,
		258,
		262,
		278,
		303,
		-1,
		234,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		262,
		259,
		247,
		245,
		268,
		233,
		221,
		-1,
		234,
		232,
		238,
		245,
		262,
		292,
		-1,
		-1,
		250,
		230,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		219,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		236,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		305,
		-1,
		257,
		233,
		247,
		262,
		270,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		245,
		248,
		-1,
		-1,
		247,
		249,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		252,
		253,
		254,
		-1,
		232,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		329,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		96,
		85,
		96,
		104,
		77,
		84,
		-1,
		105,
		107,
		73,
		67,
		106,
		77,
		83,
		94,
		-1,
		-1,
		-1,
		96,
		95,
		65,
		63,
		72,
		77,
		84,
		-1,
		107,
		-1,
		117,
		96,
		107,
		112,
		58,
		55,
		75,
		94,
		100,
		92,
		132,
		88,
		59,
		53,
		71,
		76,
		94,
		86,
		-1,
		59,
		49,
		71,
		75,
		87,
		70,
		-1,
		-1,
		53,
		54,
		60,
		72,
		77,
		82,
		-1,
		108,
		127,
		-1,
		-1,
		43,
		56,
		52,
		55,
		63,
		79,
		100,
		117,
		122,
		-1,
		-1,
		44,
		48,
		61,
		62,
		60,
		87,
		106,
		117,
		131,
		130,
		-1,
		32,
		50,
		59,
		68,
		74,
		63,
		67,
		85,
		116,
		122,
		125,
		-1,
		41,
		42,
		41,
		50,
		61,
		68,
		66,
		72,
		91,
		104,
		123,
		114,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		41,
		24,
		41,
		30,
		27,
		49,
		71,
		69,
		75,
		79,
		96,
		112,
		113,
		123,
		-1,
		-1,
		135,
		108,
		132,
		90,
		71,
		-1,
		37,
		17,
		19,
		23,
		32,
		40,
		68,
		68,
		-1,
		90,
		89,
		120,
		106,
		117,
		117,
		-1,
		-1,
		93,
		85,
		67,
		70,
		47,
		43,
		32,
		31,
		0,
		20,
		27,
		43,
		58,
		58,
		68,
		84,
		94,
		98,
		113,
		124,
		-1,
		-1,
		198,
		-1,
		-1,
		114,
		97,
		-1,
		62,
		69,
		53,
		59,
		45,
		66,
		42,
		24,
		16,
		41,
		30,
		44,
		50,
		74,
		70,
		81,
		106,
		110,
		116,
		134,
		135,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		69,
		66,
		59,
		83,
		82,
		-1,
		64,
		52,
		50,
		35,
		36,
		50,
		36,
		58,
		56,
		71,
		73,
		88,
		90,
		124,
		118,
		139,
		136,
		167,
		173,
		167,
		176,
		-1,
		122,
		118,
		114,
		121,
		70,
		-1,
		-1,
		87,
		-1,
		90,
		101,
		76,
		49,
		52,
		36,
		44,
		57,
		42,
		60,
		59,
		62,
		82,
		95,
		102,
		115,
		114,
		132,
		145,
		160,
		164,
		170,
		-1,
		172,
		-1,
		114,
		98,
		100,
		76,
		104,
		-1,
		107,
		91,
		93,
		78,
		78,
		-1,
		51,
		48,
		59,
		59,
		44,
		61,
		66,
		70,
		81,
		102,
		118,
		109,
		127,
		134,
		142,
		146,
		166,
		178,
		132,
		122,
		-1,
		104,
		109,
		79,
		91,
		114,
		134,
		114,
		-1,
		89,
		-1,
		53,
		66,
		-1,
		65,
		61,
		50,
		66,
		77,
		84,
		88,
		100,
		97,
		115,
		118,
		135,
		139,
		155,
		-1,
		-1,
		117,
		121,
		129,
		80,
		99,
		123,
		160,
		107,
		96,
		95,
		-1,
		71,
		86,
		83,
		84,
		70,
		63,
		64,
		83,
		89,
		82,
		99,
		102,
		124,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		106,
		77,
		101,
		143,
		125,
		118,
		106,
		110,
		108,
		95,
		-1,
		101,
		80,
		77,
		68,
		76,
		90,
		87,
		101,
		103,
		104,
		121,
		133,
		124,
		144,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		80,
		114,
		132,
		143,
		129,
		134,
		109,
		97,
		105,
		95,
		97,
		92,
		86,
		78,
		67,
		83,
		91,
		93,
		102,
		111,
		115,
		139,
		146,
		152,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		105,
		112,
		144,
		134,
		169,
		-1,
		123,
		-1,
		111,
		107,
		91,
		86,
		83,
		80,
		74,
		83,
		97,
		108,
		104,
		111,
		144,
		144,
		136,
		158,
		161,
		-1,
		-1,
		-1,
		136,
		153,
		128,
		105,
		86,
		122,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		93,
		89,
		84,
		88,
		81,
		88,
		84,
		98,
		109,
		96,
		132,
		-1,
		144,
		138,
		148,
		138,
		126,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		93,
		145,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		93,
		91,
		85,
		89,
		93,
		82,
		95,
		100,
		101,
		111,
		131,
		135,
		139,
		128,
		124,
		121,
		135,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		113,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		113,
		97,
		100,
		100,
		96,
		104,
		89,
		92,
		104,
		108,
		126,
		134,
		126,
		120,
		119,
		131,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		128,
		-1,
		99,
		123,
		139,
		-1,
		141,
		120,
		135,
		113,
		109,
		105,
		120,
		121,
		99,
		104,
		103,
		113,
		114,
		103,
		116,
		108,
		130,
		130,
		114,
		115,
		124,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		102,
		103,
		126,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		119,
		117,
		110,
		101,
		107,
		114,
		117,
		118,
		108,
		97,
		103,
		102,
		124,
		110,
		108,
		127,
		143,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		118,
		102,
		107,
		-1,
		143,
		-1,
		116,
		118,
		110,
		99,
		96,
		107,
		105,
		116,
		133,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		159,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		134,
		114,
		108,
		107,
		138,
		136,
		124,
		108,
		101,
		98,
		99,
		112,
		132,
		123,
		135,
		-1,
		-1,
		-1,
		160,
		140,
		146,
		104,
		125,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		151,
		139,
		129,
		119,
		153,
		152,
		127,
		120,
		106,
		108,
		106,
		108,
		113,
		134,
		135,
		148,
		-1,
		-1,
		137,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		140,
		-1,
		-1,
		131,
		129,
		139,
		123,
		110,
		130,
		133,
		123,
		107,
		122,
		134,
		142,
		147,
		-1,
		140,
		127,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		162,
		164,
		168,
		134,
		-1,
		139,
		134,
		114,
		128,
		135,
		125,
		120,
		114,
		117,
		135,
		152,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		141,
		155,
		157,
		150,
		154,
		-1,
		142,
		130,
		116,
		133,
		138,
		135,
		126,
		118,
		123,
		120,
		133,
		147,
		151,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		159,
		174,
		196,
		173,
		146,
		141,
		134,
		128,
		124,
		140,
		146,
		157,
		125,
		121,
		122,
		126,
		125,
		142,
		152,
		-1,
		-1,
		160,
		177,
		185,
		167,
		171,
		223,
		-1,
		-1,
		150,
		141,
		132,
		135,
		134,
		137,
		131,
		128,
		133,
		138,
		126,
		135,
		153,
		152,
		-1,
		-1,
		-1,
		180,
		-1,
		195,
		-1,
		-1,
		186,
		221,
		168,
		150,
		146,
		144,
		137,
		146,
		141,
		136,
		146,
		148,
		140,
		128,
		132,
		155,
		144,
		183,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		209,
		184,
		199,
		232,
		206,
		213,
		183,
		180,
		-1,
		150,
		175,
		147,
		154,
		145,
		152,
		152,
		144,
		122,
		129,
		145,
		144,
		139,
		175,
		166,
		172,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		215,
		201,
		218,
		208,
		211,
		-1,
		-1,
		199,
		196,
		172,
		155,
		153,
		146,
		141,
		151,
		131,
		118,
		122,
		126,
		132,
		137,
		142,
		148,
		163,
		178,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		218,
		214,
		208,
		200,
		202,
		-1,
		-1,
		172,
		169,
		174,
		162,
		159,
		161,
		156,
		147,
		132,
		138,
		125,
		124,
		142,
		146,
		155,
		162,
		152,
		165,
		169,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		219,
		-1,
		-1,
		216,
		203,
		187,
		177,
		171,
		221,
		176,
		171,
		155,
		153,
		144,
		135,
		142,
		133,
		133,
		136,
		151,
		156,
		148,
		162,
		162,
		163,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		232,
		-1,
		214,
		-1,
		189,
		193,
		184,
		187,
		169,
		156,
		148,
		140,
		156,
		131,
		141,
		137,
		138,
		147,
		158,
		170,
		169,
		170,
		290,
		246,
		230,
		221,
		268,
		283,
		287,
		-1,
		231,
		270,
		268,
		-1,
		241,
		-1,
		-1,
		-1,
		203,
		197,
		189,
		189,
		168,
		168,
		142,
		146,
		136,
		143,
		153,
		155,
		147,
		151,
		164,
		175,
		178,
		286,
		277,
		290,
		235,
		235,
		253,
		262,
		283,
		246,
		237,
		264,
		275,
		264,
		259,
		246,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		175,
		163,
		146,
		147,
		143,
		146,
		161,
		164,
		154,
		152,
		146,
		178,
		-1,
		279,
		278,
		267,
		264,
		240,
		231,
		226,
		253,
		-1,
		-1,
		248,
		265,
		259,
		263,
		279,
		304,
		-1,
		235,
		-1,
		-1,
		220,
		-1,
		-1,
		205,
		168,
		157,
		148,
		154,
		151,
		162,
		172,
		160,
		161,
		151,
		161,
		174,
		263,
		260,
		248,
		246,
		269,
		234,
		222,
		-1,
		235,
		233,
		239,
		246,
		263,
		293,
		-1,
		-1,
		251,
		231,
		-1,
		-1,
		203,
		201,
		190,
		-1,
		180,
		153,
		158,
		178,
		180,
		169,
		163,
		157,
		164,
		163,
		171,
		179,
		272,
		286,
		275,
		271,
		270,
		278,
		227,
		220,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		-1,
		241,
		237,
		-1,
		-1,
		198,
		191,
		179,
		167,
		157,
		167,
		171,
		175,
		167,
		160,
		155,
		166,
		158,
		162,
		179,
		-1,
		306,
		-1,
		258,
		234,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		258,
		244,
		237,
		225,
		223,
		-1,
		232,
		216,
		197,
		-1,
		167,
		180,
		211,
		179,
		184,
		179,
		161,
		172,
		161,
		164,
		178,
		173,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		248,
		250,
		-1,
		249,
		238,
		223,
		215,
		-1,
		-1,
		204,
		200,
		-1,
		-1,
		168,
		193,
		182,
		190,
		185,
		165,
		171,
		174,
		163,
		167,
		179,
		-1,
		-1,
		253,
		254,
		255,
		-1,
		233,
		-1,
		251,
		-1,
		218,
		224,
		212,
		-1,
		-1,
		-1,
		206,
		169,
		190,
		200,
		194,
		192,
		183,
		169,
		176,
		174,
		170,
		181,
		-1,
		-1,
		-1,
		251,
		225,
		258,
		249,
		232,
		212,
		204,
		223,
		-1,
		193,
		-1,
		168,
		170,
		196,
		199,
		205,
		199,
		172,
		187,
		177,
		168,
		177,
		257,
		-1,
		227,
		260,
		224,
		218,
		194,
		198,
		214,
		-1,
		190,
		172,
		-1,
		200,
		190,
		221,
		206,
		187,
		174,
		181,
		181,
		174,
		-1,
		-1,
		-1,
		229,
		228,
		220,
		214,
		214,
		199,
		190,
		-1,
		202,
		184,
		163,
		180,
		180,
		171,
		179,
		211,
		207,
		194,
		194,
		186,
		-1,
		330,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		223,
		218,
		191,
		179,
		185,
		181,
		167,
		173,
		175,
		183,
		181,
		178,
		190,
		186,
		206,
		187,
		222,
		-1,
		325,
		-1,
		259,
		-1,
		-1,
		241,
		221,
		213,
		202,
		191,
		189,
		180,
		171,
		193,
		209,
		193,
		191,
		194,
		195,
		-1,
		314,
		313,
		-1,
		260,
		252,
		238,
		-1,
		231,
		-1,
		237,
		198,
		-1,
		200,
		180,
		-1,
		202,
		198,
		-1,
		-1,
		301,
		276,
		-1,
		-1,
		-1,
		261,
		241,
		232,
		216,
		-1,
		191,
		191,
		-1,
		-1,
		-1,
		286,
		285,
		-1,
		254,
		257,
		-1,
		247,
		238,
		246,
		193,
		197,
		-1,
		-1,
		-1,
		295,
		276,
		270,
		269,
		267,
		262,
		259,
		245,
		229,
		207,
		196,
		217,
		-1,
		-1,
		-1,
		267,
		259,
		252,
		-1,
		-1,
		254,
		237,
		218,
		216,
		-1,
		-1,
		-1,
		289,
		270,
		-1,
		-1,
		244,
		-1,
		-1,
		250,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		278,
		-1,
		-1,
		-1,
		240,
		236,
		237,
		-1,
		-1,
		-1,
		-1,
		300,
		301,
		324,
		288,
		-1,
		-1,
		-1,
		232,
		226,
		-1,
		-1,
		303,
		301,
		-1,
		-1,
		-1,
		260,
		244,
		-1,
		230,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		265,
		-1,
		265,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		278,
		270,
		278,
		-1,
		250,
		252,
		-1,
		300,
		-1,
		-1,
		293,
		284,
		-1,
		-1,
		255,
		262,
		284,
		287,
		323,
		-1,
		274
	],
	[
		-1,
		93,
		82,
		93,
		101,
		74,
		81,
		-1,
		102,
		104,
		70,
		64,
		103,
		74,
		80,
		91,
		-1,
		-1,
		-1,
		93,
		92,
		62,
		60,
		69,
		74,
		81,
		-1,
		104,
		-1,
		114,
		93,
		104,
		109,
		55,
		52,
		72,
		91,
		97,
		89,
		129,
		85,
		56,
		50,
		68,
		73,
		91,
		83,
		-1,
		56,
		46,
		68,
		72,
		84,
		67,
		-1,
		-1,
		50,
		51,
		57,
		69,
		74,
		79,
		-1,
		105,
		118,
		-1,
		-1,
		40,
		53,
		49,
		52,
		60,
		76,
		97,
		114,
		113,
		-1,
		-1,
		41,
		45,
		58,
		59,
		57,
		84,
		103,
		108,
		122,
		121,
		-1,
		29,
		47,
		56,
		65,
		71,
		60,
		64,
		82,
		107,
		113,
		116,
		-1,
		38,
		39,
		40,
		49,
		58,
		65,
		63,
		69,
		88,
		95,
		114,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		38,
		21,
		38,
		29,
		26,
		46,
		63,
		66,
		72,
		76,
		87,
		103,
		104,
		114,
		-1,
		-1,
		132,
		105,
		129,
		87,
		68,
		-1,
		34,
		14,
		18,
		22,
		29,
		33,
		60,
		58,
		-1,
		81,
		80,
		111,
		97,
		108,
		114,
		-1,
		-1,
		90,
		82,
		64,
		67,
		44,
		40,
		29,
		28,
		15,
		0,
		7,
		36,
		48,
		46,
		56,
		75,
		85,
		89,
		104,
		115,
		-1,
		-1,
		180,
		-1,
		-1,
		111,
		94,
		-1,
		59,
		66,
		50,
		56,
		42,
		63,
		39,
		24,
		27,
		22,
		10,
		30,
		40,
		63,
		60,
		72,
		97,
		101,
		105,
		125,
		121,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		66,
		63,
		56,
		80,
		79,
		-1,
		56,
		44,
		45,
		30,
		35,
		31,
		16,
		46,
		46,
		61,
		63,
		79,
		81,
		114,
		102,
		124,
		121,
		150,
		155,
		149,
		158,
		-1,
		119,
		115,
		111,
		118,
		67,
		-1,
		-1,
		84,
		-1,
		87,
		93,
		68,
		41,
		44,
		31,
		39,
		38,
		22,
		40,
		49,
		52,
		72,
		85,
		92,
		97,
		96,
		114,
		129,
		142,
		146,
		152,
		-1,
		169,
		-1,
		111,
		95,
		97,
		73,
		101,
		-1,
		104,
		88,
		85,
		70,
		70,
		-1,
		47,
		44,
		54,
		39,
		24,
		41,
		56,
		60,
		71,
		86,
		100,
		91,
		109,
		116,
		124,
		128,
		148,
		160,
		129,
		119,
		-1,
		101,
		106,
		76,
		88,
		111,
		131,
		106,
		-1,
		81,
		-1,
		49,
		62,
		-1,
		45,
		41,
		30,
		46,
		60,
		73,
		78,
		82,
		79,
		97,
		100,
		117,
		121,
		137,
		-1,
		-1,
		114,
		118,
		126,
		77,
		96,
		120,
		152,
		99,
		88,
		87,
		-1,
		67,
		66,
		63,
		64,
		50,
		43,
		44,
		66,
		79,
		62,
		81,
		84,
		106,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		103,
		74,
		98,
		140,
		117,
		110,
		98,
		106,
		104,
		91,
		-1,
		81,
		60,
		57,
		48,
		56,
		70,
		67,
		81,
		85,
		84,
		103,
		115,
		106,
		126,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		77,
		111,
		129,
		139,
		125,
		130,
		105,
		93,
		98,
		75,
		77,
		72,
		66,
		58,
		47,
		63,
		71,
		73,
		82,
		91,
		97,
		121,
		128,
		134,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		102,
		109,
		141,
		130,
		149,
		-1,
		103,
		-1,
		92,
		87,
		71,
		66,
		63,
		60,
		54,
		63,
		77,
		88,
		84,
		91,
		126,
		126,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		133,
		150,
		125,
		102,
		83,
		119,
		-1,
		119,
		120,
		-1,
		97,
		91,
		88,
		73,
		69,
		64,
		68,
		61,
		68,
		64,
		78,
		89,
		76,
		112,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		148,
		127,
		120,
		140,
		90,
		142,
		-1,
		-1,
		104,
		97,
		-1,
		84,
		66,
		73,
		71,
		65,
		69,
		73,
		62,
		75,
		80,
		81,
		91,
		111,
		115,
		119,
		108,
		104,
		101,
		115,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		110,
		-1,
		113,
		105,
		95,
		89,
		83,
		79,
		77,
		93,
		77,
		80,
		80,
		76,
		84,
		69,
		72,
		84,
		88,
		106,
		114,
		106,
		100,
		99,
		111,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		125,
		-1,
		96,
		112,
		128,
		-1,
		121,
		100,
		115,
		93,
		89,
		85,
		100,
		101,
		79,
		84,
		83,
		93,
		94,
		83,
		96,
		88,
		110,
		110,
		94,
		95,
		104,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		95,
		83,
		115,
		-1,
		-1,
		157,
		-1,
		91,
		108,
		99,
		97,
		90,
		81,
		87,
		94,
		97,
		98,
		88,
		77,
		83,
		82,
		104,
		90,
		88,
		107,
		123,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		135,
		125,
		109,
		94,
		127,
		-1,
		98,
		82,
		87,
		-1,
		123,
		-1,
		96,
		98,
		90,
		79,
		76,
		87,
		85,
		96,
		113,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		152,
		-1,
		-1,
		122,
		116,
		116,
		100,
		103,
		114,
		94,
		88,
		87,
		118,
		116,
		104,
		88,
		81,
		78,
		79,
		92,
		112,
		103,
		115,
		-1,
		-1,
		-1,
		149,
		135,
		139,
		99,
		118,
		-1,
		-1,
		184,
		139,
		125,
		-1,
		109,
		131,
		119,
		109,
		99,
		133,
		132,
		107,
		100,
		86,
		88,
		86,
		88,
		93,
		114,
		115,
		128,
		-1,
		-1,
		132,
		137,
		125,
		111,
		130,
		-1,
		-1,
		-1,
		131,
		147,
		139,
		110,
		120,
		-1,
		-1,
		111,
		109,
		119,
		103,
		90,
		110,
		113,
		103,
		87,
		102,
		114,
		122,
		127,
		-1,
		135,
		122,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		142,
		144,
		148,
		114,
		-1,
		119,
		114,
		94,
		108,
		115,
		105,
		100,
		94,
		97,
		115,
		132,
		-1,
		-1,
		147,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		121,
		135,
		137,
		130,
		134,
		-1,
		122,
		110,
		96,
		113,
		118,
		115,
		106,
		98,
		103,
		100,
		113,
		127,
		131,
		170,
		-1,
		153,
		-1,
		-1,
		-1,
		139,
		154,
		176,
		153,
		126,
		121,
		114,
		108,
		104,
		120,
		126,
		137,
		105,
		101,
		102,
		106,
		105,
		122,
		132,
		-1,
		-1,
		153,
		170,
		165,
		147,
		151,
		203,
		-1,
		-1,
		130,
		121,
		112,
		115,
		114,
		117,
		111,
		108,
		113,
		118,
		106,
		115,
		133,
		132,
		-1,
		-1,
		-1,
		173,
		-1,
		188,
		-1,
		-1,
		166,
		201,
		148,
		130,
		126,
		124,
		117,
		126,
		121,
		116,
		126,
		128,
		120,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		202,
		177,
		192,
		212,
		186,
		193,
		163,
		160,
		-1,
		130,
		155,
		127,
		134,
		125,
		132,
		132,
		124,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		208,
		194,
		198,
		188,
		191,
		-1,
		-1,
		179,
		176,
		152,
		135,
		133,
		126,
		121,
		131,
		111,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		180,
		261,
		254,
		237,
		245,
		276,
		-1,
		202,
		194,
		201,
		180,
		182,
		-1,
		-1,
		152,
		149,
		154,
		142,
		139,
		141,
		136,
		127,
		112,
		118,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		194,
		237,
		231,
		234,
		258,
		272,
		-1,
		199,
		-1,
		-1,
		209,
		183,
		167,
		157,
		151,
		201,
		156,
		151,
		135,
		133,
		124,
		115,
		122,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		229,
		217,
		225,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		225,
		-1,
		194,
		-1,
		169,
		173,
		164,
		167,
		149,
		136,
		128,
		120,
		136,
		111,
		121,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		270,
		226,
		225,
		216,
		251,
		266,
		270,
		-1,
		211,
		250,
		248,
		-1,
		232,
		-1,
		-1,
		-1,
		183,
		177,
		169,
		169,
		148,
		148,
		122,
		126,
		116,
		123,
		133,
		135,
		127,
		131,
		144,
		155,
		158,
		266,
		257,
		270,
		215,
		215,
		236,
		245,
		266,
		226,
		217,
		244,
		255,
		244,
		239,
		226,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		155,
		143,
		126,
		127,
		123,
		126,
		141,
		144,
		134,
		132,
		126,
		158,
		-1,
		259,
		258,
		247,
		244,
		220,
		211,
		206,
		233,
		-1,
		-1,
		228,
		245,
		239,
		243,
		259,
		284,
		-1,
		215,
		-1,
		-1,
		200,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		131,
		142,
		152,
		140,
		141,
		131,
		141,
		154,
		243,
		240,
		228,
		226,
		249,
		214,
		202,
		-1,
		215,
		213,
		219,
		226,
		243,
		273,
		-1,
		-1,
		231,
		211,
		-1,
		-1,
		183,
		181,
		170,
		-1,
		160,
		133,
		138,
		158,
		160,
		149,
		143,
		137,
		144,
		143,
		151,
		159,
		252,
		266,
		255,
		251,
		250,
		258,
		207,
		200,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		-1,
		221,
		217,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		151,
		155,
		147,
		140,
		135,
		146,
		138,
		142,
		159,
		-1,
		286,
		-1,
		238,
		214,
		228,
		243,
		251,
		-1,
		-1,
		-1,
		238,
		224,
		217,
		205,
		203,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		141,
		152,
		141,
		144,
		158,
		153,
		-1,
		-1,
		226,
		229,
		-1,
		-1,
		228,
		230,
		-1,
		229,
		218,
		203,
		195,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		145,
		151,
		154,
		143,
		147,
		159,
		-1,
		-1,
		233,
		234,
		235,
		-1,
		213,
		-1,
		231,
		-1,
		198,
		204,
		192,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		174,
		172,
		163,
		149,
		156,
		154,
		150,
		161,
		-1,
		-1,
		-1,
		231,
		205,
		238,
		229,
		212,
		192,
		184,
		203,
		-1,
		173,
		-1,
		148,
		150,
		176,
		179,
		185,
		179,
		152,
		167,
		157,
		148,
		157,
		237,
		-1,
		207,
		240,
		204,
		198,
		174,
		178,
		194,
		-1,
		170,
		152,
		-1,
		180,
		170,
		201,
		186,
		167,
		154,
		161,
		161,
		154,
		-1,
		-1,
		-1,
		209,
		208,
		200,
		194,
		194,
		179,
		170,
		-1,
		182,
		164,
		143,
		160,
		160,
		151,
		159,
		191,
		187,
		174,
		174,
		166,
		-1,
		310,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		203,
		198,
		171,
		159,
		165,
		161,
		147,
		153,
		155,
		163,
		161,
		158,
		170,
		166,
		186,
		167,
		202,
		-1,
		305,
		-1,
		239,
		-1,
		-1,
		221,
		201,
		193,
		182,
		171,
		169,
		160,
		151,
		173,
		189,
		173,
		171,
		174,
		175,
		-1,
		294,
		293,
		-1,
		240,
		232,
		218,
		-1,
		211,
		-1,
		217,
		178,
		-1,
		180,
		160,
		-1,
		182,
		178,
		-1,
		-1,
		281,
		256,
		-1,
		-1,
		-1,
		241,
		221,
		212,
		196,
		-1,
		171,
		171,
		-1,
		-1,
		-1,
		266,
		265,
		-1,
		234,
		237,
		-1,
		227,
		218,
		226,
		173,
		177,
		-1,
		-1,
		-1,
		275,
		256,
		250,
		249,
		247,
		242,
		239,
		225,
		209,
		187,
		176,
		197,
		-1,
		-1,
		-1,
		247,
		239,
		232,
		-1,
		-1,
		234,
		217,
		198,
		196,
		-1,
		-1,
		-1,
		269,
		250,
		-1,
		-1,
		224,
		-1,
		-1,
		230,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		258,
		-1,
		-1,
		-1,
		220,
		216,
		217,
		-1,
		-1,
		-1,
		-1,
		280,
		281,
		304,
		268,
		-1,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		283,
		281,
		-1,
		-1,
		-1,
		240,
		224,
		-1,
		210,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		245,
		-1,
		245,
		220,
		227,
		-1,
		-1,
		-1,
		-1,
		258,
		250,
		258,
		-1,
		230,
		232,
		-1,
		280,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		235,
		242,
		264,
		267,
		303,
		-1,
		254
	],
	[
		-1,
		93,
		82,
		93,
		101,
		74,
		81,
		-1,
		102,
		104,
		70,
		64,
		103,
		74,
		80,
		91,
		-1,
		-1,
		-1,
		93,
		92,
		62,
		60,
		69,
		74,
		81,
		-1,
		104,
		-1,
		114,
		93,
		104,
		109,
		55,
		52,
		72,
		91,
		97,
		89,
		129,
		85,
		56,
		50,
		68,
		73,
		91,
		83,
		-1,
		56,
		46,
		68,
		72,
		84,
		67,
		-1,
		-1,
		50,
		51,
		57,
		69,
		74,
		79,
		-1,
		105,
		111,
		-1,
		-1,
		40,
		53,
		49,
		52,
		60,
		76,
		97,
		111,
		106,
		-1,
		-1,
		41,
		45,
		58,
		59,
		57,
		84,
		103,
		101,
		115,
		114,
		-1,
		29,
		47,
		56,
		65,
		71,
		60,
		64,
		82,
		100,
		106,
		109,
		-1,
		38,
		39,
		38,
		46,
		51,
		58,
		63,
		69,
		88,
		88,
		107,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		38,
		21,
		38,
		33,
		26,
		39,
		56,
		64,
		72,
		76,
		80,
		96,
		97,
		107,
		-1,
		-1,
		132,
		105,
		129,
		87,
		68,
		-1,
		34,
		14,
		20,
		24,
		24,
		26,
		53,
		51,
		-1,
		74,
		73,
		104,
		90,
		101,
		114,
		-1,
		-1,
		90,
		82,
		64,
		67,
		44,
		40,
		29,
		28,
		18,
		4,
		0,
		29,
		41,
		39,
		49,
		68,
		78,
		82,
		97,
		108,
		-1,
		-1,
		173,
		-1,
		-1,
		111,
		94,
		-1,
		59,
		66,
		50,
		56,
		42,
		63,
		39,
		28,
		20,
		15,
		3,
		23,
		33,
		56,
		53,
		65,
		90,
		94,
		98,
		118,
		114,
		-1,
		172,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		66,
		63,
		56,
		80,
		79,
		-1,
		49,
		37,
		38,
		23,
		28,
		24,
		9,
		39,
		39,
		54,
		56,
		72,
		74,
		107,
		95,
		117,
		114,
		143,
		148,
		142,
		151,
		-1,
		119,
		115,
		111,
		118,
		67,
		-1,
		-1,
		84,
		-1,
		87,
		86,
		61,
		34,
		37,
		24,
		32,
		31,
		15,
		33,
		42,
		45,
		65,
		78,
		85,
		90,
		89,
		107,
		122,
		135,
		139,
		145,
		-1,
		169,
		-1,
		111,
		95,
		97,
		73,
		101,
		-1,
		104,
		88,
		78,
		63,
		63,
		-1,
		40,
		37,
		47,
		32,
		17,
		34,
		49,
		53,
		64,
		79,
		93,
		84,
		102,
		109,
		117,
		121,
		141,
		153,
		129,
		119,
		-1,
		101,
		106,
		76,
		88,
		111,
		131,
		99,
		-1,
		74,
		-1,
		42,
		55,
		-1,
		38,
		34,
		23,
		39,
		53,
		66,
		71,
		75,
		72,
		90,
		93,
		110,
		114,
		130,
		-1,
		-1,
		114,
		118,
		126,
		77,
		96,
		120,
		145,
		92,
		81,
		80,
		-1,
		60,
		59,
		56,
		57,
		43,
		36,
		37,
		59,
		72,
		55,
		74,
		77,
		99,
		127,
		105,
		117,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		103,
		74,
		98,
		140,
		110,
		103,
		91,
		99,
		97,
		84,
		-1,
		74,
		53,
		50,
		41,
		49,
		63,
		60,
		74,
		78,
		77,
		96,
		108,
		99,
		119,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		77,
		111,
		129,
		132,
		118,
		123,
		98,
		86,
		91,
		68,
		70,
		65,
		59,
		51,
		40,
		56,
		64,
		66,
		75,
		84,
		90,
		114,
		121,
		127,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		102,
		109,
		141,
		123,
		142,
		-1,
		96,
		-1,
		85,
		80,
		64,
		59,
		56,
		53,
		47,
		56,
		70,
		81,
		77,
		84,
		119,
		119,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		133,
		150,
		125,
		102,
		83,
		119,
		-1,
		112,
		113,
		-1,
		90,
		84,
		81,
		66,
		62,
		57,
		61,
		54,
		61,
		57,
		71,
		82,
		69,
		105,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		148,
		127,
		120,
		140,
		90,
		142,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		66,
		64,
		58,
		62,
		66,
		55,
		68,
		73,
		74,
		84,
		104,
		108,
		112,
		101,
		97,
		94,
		108,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		110,
		-1,
		106,
		98,
		88,
		82,
		76,
		72,
		70,
		86,
		70,
		73,
		73,
		69,
		77,
		62,
		65,
		77,
		81,
		99,
		107,
		99,
		93,
		92,
		104,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		125,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		82,
		78,
		93,
		94,
		72,
		77,
		76,
		86,
		87,
		76,
		89,
		81,
		103,
		103,
		87,
		88,
		97,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		92,
		90,
		83,
		74,
		80,
		87,
		90,
		91,
		81,
		70,
		76,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		91,
		75,
		80,
		-1,
		116,
		-1,
		89,
		91,
		83,
		72,
		69,
		80,
		78,
		89,
		106,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		107,
		87,
		81,
		80,
		111,
		109,
		97,
		81,
		74,
		71,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		124,
		112,
		102,
		92,
		126,
		125,
		100,
		93,
		79,
		81,
		79,
		81,
		86,
		107,
		108,
		121,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		113,
		-1,
		-1,
		104,
		102,
		112,
		96,
		83,
		103,
		106,
		96,
		80,
		95,
		107,
		115,
		120,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		135,
		137,
		141,
		107,
		-1,
		112,
		107,
		87,
		101,
		108,
		98,
		93,
		87,
		90,
		108,
		125,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		130,
		123,
		127,
		-1,
		115,
		103,
		89,
		106,
		111,
		108,
		99,
		91,
		96,
		93,
		106,
		120,
		124,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		169,
		146,
		119,
		114,
		107,
		101,
		97,
		113,
		119,
		130,
		98,
		94,
		95,
		99,
		98,
		115,
		125,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		196,
		-1,
		-1,
		123,
		114,
		105,
		108,
		107,
		110,
		104,
		101,
		106,
		111,
		99,
		108,
		126,
		125,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		194,
		141,
		123,
		119,
		117,
		110,
		119,
		114,
		109,
		119,
		121,
		113,
		101,
		105,
		128,
		117,
		156,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		195,
		170,
		185,
		205,
		179,
		186,
		156,
		153,
		-1,
		123,
		148,
		120,
		127,
		118,
		125,
		125,
		117,
		95,
		102,
		118,
		117,
		112,
		148,
		139,
		145,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		201,
		187,
		191,
		181,
		184,
		-1,
		-1,
		172,
		169,
		145,
		128,
		126,
		119,
		114,
		124,
		104,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		195,
		187,
		194,
		173,
		175,
		-1,
		-1,
		145,
		142,
		147,
		135,
		132,
		134,
		129,
		120,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		192,
		-1,
		-1,
		202,
		176,
		160,
		150,
		144,
		194,
		149,
		144,
		128,
		126,
		117,
		108,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		218,
		-1,
		187,
		-1,
		162,
		166,
		157,
		160,
		142,
		129,
		121,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		263,
		219,
		218,
		209,
		244,
		259,
		263,
		-1,
		204,
		243,
		241,
		-1,
		225,
		-1,
		-1,
		-1,
		176,
		170,
		162,
		162,
		141,
		141,
		115,
		119,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		259,
		250,
		263,
		208,
		208,
		229,
		238,
		259,
		219,
		210,
		237,
		248,
		237,
		232,
		219,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		148,
		136,
		119,
		120,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		199,
		226,
		-1,
		-1,
		221,
		238,
		232,
		236,
		252,
		277,
		-1,
		208,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		236,
		233,
		221,
		219,
		242,
		207,
		195,
		-1,
		208,
		206,
		212,
		219,
		236,
		266,
		-1,
		-1,
		224,
		204,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		151,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		193,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		214,
		210,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		144,
		148,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		279,
		-1,
		231,
		207,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		231,
		217,
		210,
		198,
		196,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		221,
		223,
		-1,
		222,
		211,
		196,
		188,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		226,
		227,
		228,
		-1,
		206,
		-1,
		224,
		-1,
		191,
		197,
		185,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		224,
		198,
		231,
		222,
		205,
		185,
		177,
		196,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		230,
		-1,
		200,
		233,
		197,
		191,
		167,
		171,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		194,
		179,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		202,
		201,
		193,
		187,
		187,
		172,
		163,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		184,
		180,
		167,
		167,
		159,
		-1,
		303,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		196,
		191,
		164,
		152,
		158,
		154,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		160,
		195,
		-1,
		298,
		-1,
		232,
		-1,
		-1,
		214,
		194,
		186,
		175,
		164,
		162,
		153,
		144,
		166,
		182,
		166,
		164,
		167,
		168,
		-1,
		287,
		286,
		-1,
		233,
		225,
		211,
		-1,
		204,
		-1,
		210,
		171,
		-1,
		173,
		153,
		-1,
		175,
		171,
		-1,
		-1,
		274,
		249,
		-1,
		-1,
		-1,
		234,
		214,
		205,
		189,
		-1,
		164,
		164,
		-1,
		-1,
		-1,
		259,
		258,
		-1,
		227,
		230,
		-1,
		220,
		211,
		219,
		166,
		170,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		242,
		240,
		235,
		232,
		218,
		202,
		180,
		169,
		190,
		-1,
		-1,
		-1,
		240,
		232,
		225,
		-1,
		-1,
		227,
		210,
		191,
		189,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		217,
		-1,
		-1,
		223,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		251,
		-1,
		-1,
		-1,
		213,
		209,
		210,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		297,
		261,
		-1,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		233,
		217,
		-1,
		203,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		238,
		-1,
		238,
		213,
		220,
		-1,
		-1,
		-1,
		-1,
		251,
		243,
		251,
		-1,
		223,
		225,
		-1,
		273,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		228,
		235,
		257,
		260,
		296,
		-1,
		247
	],
	[
		-1,
		107,
		96,
		107,
		115,
		88,
		95,
		-1,
		116,
		118,
		84,
		78,
		117,
		88,
		94,
		105,
		-1,
		-1,
		-1,
		107,
		106,
		76,
		74,
		83,
		88,
		95,
		-1,
		117,
		-1,
		128,
		107,
		118,
		123,
		69,
		66,
		86,
		105,
		110,
		102,
		143,
		99,
		70,
		64,
		82,
		87,
		104,
		96,
		-1,
		70,
		60,
		82,
		84,
		95,
		81,
		-1,
		-1,
		64,
		65,
		71,
		80,
		86,
		82,
		-1,
		92,
		86,
		-1,
		-1,
		54,
		67,
		62,
		65,
		73,
		71,
		84,
		86,
		81,
		-1,
		-1,
		55,
		59,
		65,
		58,
		54,
		71,
		90,
		76,
		90,
		89,
		-1,
		43,
		57,
		53,
		58,
		63,
		47,
		51,
		69,
		75,
		81,
		84,
		-1,
		52,
		53,
		28,
		36,
		41,
		48,
		43,
		56,
		70,
		63,
		82,
		73,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		52,
		35,
		42,
		24,
		14,
		29,
		33,
		39,
		59,
		58,
		55,
		71,
		72,
		82,
		-1,
		-1,
		146,
		119,
		143,
		101,
		82,
		-1,
		48,
		28,
		22,
		18,
		12,
		3,
		30,
		26,
		-1,
		49,
		48,
		79,
		65,
		76,
		128,
		-1,
		-1,
		104,
		96,
		78,
		81,
		58,
		54,
		43,
		42,
		35,
		39,
		35,
		0,
		16,
		16,
		26,
		43,
		53,
		57,
		72,
		83,
		-1,
		-1,
		157,
		-1,
		-1,
		125,
		108,
		-1,
		73,
		80,
		64,
		70,
		56,
		77,
		53,
		44,
		49,
		44,
		36,
		11,
		8,
		32,
		28,
		40,
		65,
		69,
		75,
		93,
		94,
		-1,
		156,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		80,
		77,
		70,
		94,
		93,
		-1,
		84,
		72,
		73,
		58,
		57,
		53,
		42,
		16,
		14,
		29,
		31,
		47,
		49,
		82,
		77,
		98,
		95,
		126,
		132,
		126,
		135,
		-1,
		133,
		129,
		125,
		132,
		81,
		-1,
		-1,
		98,
		-1,
		101,
		114,
		96,
		69,
		72,
		59,
		67,
		58,
		40,
		22,
		17,
		20,
		40,
		53,
		60,
		74,
		73,
		91,
		104,
		119,
		123,
		129,
		-1,
		183,
		-1,
		125,
		109,
		111,
		87,
		115,
		-1,
		118,
		102,
		113,
		98,
		98,
		-1,
		75,
		72,
		76,
		54,
		39,
		35,
		24,
		28,
		39,
		60,
		77,
		68,
		86,
		93,
		101,
		105,
		125,
		137,
		143,
		133,
		-1,
		115,
		120,
		90,
		102,
		125,
		145,
		129,
		-1,
		109,
		-1,
		77,
		90,
		-1,
		60,
		56,
		45,
		46,
		35,
		42,
		46,
		59,
		56,
		74,
		77,
		94,
		98,
		114,
		-1,
		-1,
		128,
		132,
		140,
		91,
		110,
		134,
		171,
		127,
		116,
		115,
		-1,
		95,
		79,
		76,
		77,
		64,
		58,
		58,
		41,
		47,
		56,
		58,
		61,
		83,
		111,
		89,
		101,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		117,
		88,
		112,
		154,
		145,
		138,
		126,
		111,
		111,
		105,
		-1,
		95,
		74,
		69,
		58,
		48,
		64,
		59,
		75,
		62,
		64,
		80,
		92,
		83,
		103,
		-1,
		-1,
		-1,
		147,
		136,
		137,
		91,
		125,
		143,
		144,
		130,
		135,
		110,
		103,
		97,
		88,
		91,
		76,
		65,
		57,
		46,
		62,
		69,
		64,
		64,
		73,
		74,
		98,
		105,
		111,
		-1,
		-1,
		154,
		144,
		128,
		130,
		127,
		116,
		123,
		155,
		135,
		148,
		-1,
		102,
		-1,
		91,
		86,
		70,
		65,
		62,
		59,
		53,
		62,
		70,
		78,
		69,
		84,
		103,
		103,
		95,
		120,
		123,
		-1,
		-1,
		-1,
		147,
		164,
		139,
		116,
		97,
		133,
		-1,
		118,
		119,
		-1,
		96,
		90,
		87,
		72,
		68,
		63,
		67,
		60,
		67,
		63,
		77,
		88,
		70,
		106,
		-1,
		103,
		97,
		125,
		117,
		105,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		83,
		65,
		72,
		70,
		64,
		68,
		72,
		61,
		74,
		79,
		75,
		85,
		105,
		109,
		116,
		107,
		103,
		100,
		114,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		78,
		76,
		92,
		76,
		79,
		79,
		75,
		83,
		68,
		71,
		78,
		82,
		100,
		113,
		105,
		99,
		98,
		110,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		88,
		84,
		99,
		100,
		78,
		83,
		82,
		92,
		93,
		82,
		90,
		87,
		109,
		109,
		93,
		94,
		103,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		98,
		96,
		89,
		80,
		86,
		93,
		96,
		97,
		87,
		76,
		82,
		81,
		103,
		89,
		87,
		106,
		122,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		97,
		81,
		86,
		-1,
		122,
		-1,
		95,
		97,
		89,
		78,
		75,
		86,
		84,
		95,
		112,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		113,
		93,
		87,
		86,
		117,
		115,
		103,
		87,
		80,
		77,
		78,
		91,
		111,
		102,
		114,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		130,
		118,
		108,
		98,
		132,
		131,
		106,
		99,
		85,
		87,
		85,
		87,
		92,
		113,
		114,
		127,
		-1,
		-1,
		131,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		119,
		-1,
		-1,
		110,
		108,
		118,
		102,
		89,
		109,
		112,
		102,
		86,
		101,
		113,
		121,
		126,
		-1,
		134,
		121,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		143,
		147,
		113,
		-1,
		118,
		113,
		93,
		107,
		114,
		104,
		99,
		93,
		96,
		114,
		131,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		136,
		129,
		133,
		-1,
		121,
		109,
		95,
		112,
		117,
		114,
		105,
		97,
		102,
		99,
		112,
		126,
		130,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		138,
		153,
		175,
		152,
		125,
		120,
		113,
		107,
		103,
		119,
		125,
		136,
		104,
		100,
		101,
		105,
		104,
		121,
		131,
		-1,
		-1,
		152,
		169,
		164,
		146,
		150,
		202,
		-1,
		-1,
		129,
		120,
		111,
		114,
		113,
		116,
		110,
		107,
		112,
		117,
		105,
		114,
		132,
		131,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		165,
		200,
		147,
		129,
		125,
		123,
		116,
		125,
		120,
		115,
		125,
		127,
		119,
		107,
		111,
		134,
		123,
		162,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		201,
		176,
		191,
		211,
		185,
		192,
		162,
		159,
		-1,
		129,
		154,
		126,
		133,
		124,
		131,
		131,
		123,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		207,
		193,
		197,
		187,
		190,
		-1,
		-1,
		178,
		175,
		151,
		134,
		132,
		125,
		120,
		130,
		110,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		201,
		193,
		200,
		179,
		181,
		-1,
		-1,
		151,
		148,
		153,
		141,
		138,
		140,
		135,
		126,
		111,
		117,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		198,
		-1,
		-1,
		208,
		182,
		166,
		156,
		150,
		200,
		155,
		150,
		134,
		132,
		123,
		114,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		224,
		-1,
		193,
		-1,
		168,
		172,
		163,
		166,
		148,
		135,
		127,
		119,
		135,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		269,
		225,
		224,
		215,
		250,
		265,
		269,
		-1,
		210,
		249,
		247,
		-1,
		231,
		-1,
		-1,
		-1,
		182,
		176,
		168,
		168,
		147,
		147,
		121,
		125,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		265,
		256,
		269,
		214,
		214,
		235,
		244,
		265,
		225,
		216,
		243,
		254,
		243,
		238,
		225,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		154,
		142,
		125,
		126,
		122,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		205,
		232,
		-1,
		-1,
		227,
		244,
		238,
		242,
		258,
		283,
		-1,
		214,
		-1,
		-1,
		199,
		-1,
		-1,
		184,
		147,
		136,
		127,
		133,
		130,
		141,
		151,
		139,
		140,
		130,
		140,
		153,
		242,
		239,
		227,
		225,
		248,
		213,
		201,
		-1,
		214,
		212,
		218,
		225,
		242,
		272,
		-1,
		-1,
		230,
		210,
		-1,
		-1,
		182,
		180,
		169,
		-1,
		159,
		132,
		137,
		157,
		159,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		199,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		216,
		-1,
		-1,
		177,
		170,
		158,
		146,
		136,
		146,
		150,
		154,
		146,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		285,
		-1,
		237,
		213,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		211,
		195,
		176,
		-1,
		146,
		159,
		190,
		158,
		163,
		158,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		225,
		228,
		-1,
		-1,
		227,
		229,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		183,
		179,
		-1,
		-1,
		147,
		172,
		161,
		169,
		164,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		232,
		233,
		234,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		185,
		148,
		169,
		179,
		173,
		171,
		162,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		149,
		175,
		178,
		184,
		178,
		151,
		166,
		156,
		147,
		156,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		200,
		185,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		190,
		186,
		173,
		173,
		165,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		166,
		201,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		173,
		174,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		116,
		105,
		116,
		124,
		97,
		104,
		-1,
		123,
		127,
		93,
		87,
		126,
		95,
		101,
		112,
		-1,
		-1,
		-1,
		116,
		115,
		83,
		81,
		90,
		95,
		102,
		-1,
		101,
		-1,
		137,
		116,
		127,
		132,
		76,
		73,
		93,
		112,
		94,
		86,
		152,
		106,
		77,
		71,
		89,
		79,
		88,
		80,
		-1,
		77,
		67,
		89,
		68,
		79,
		71,
		-1,
		-1,
		71,
		72,
		78,
		64,
		70,
		66,
		-1,
		76,
		88,
		-1,
		-1,
		61,
		62,
		46,
		49,
		57,
		55,
		68,
		85,
		83,
		-1,
		-1,
		52,
		48,
		55,
		42,
		38,
		55,
		74,
		78,
		92,
		91,
		-1,
		56,
		70,
		66,
		49,
		47,
		31,
		35,
		53,
		77,
		83,
		86,
		-1,
		65,
		66,
		41,
		49,
		53,
		46,
		27,
		40,
		59,
		65,
		84,
		75,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		65,
		48,
		55,
		37,
		27,
		37,
		24,
		23,
		43,
		47,
		57,
		73,
		74,
		84,
		-1,
		-1,
		159,
		132,
		156,
		114,
		95,
		-1,
		61,
		41,
		35,
		31,
		25,
		18,
		21,
		10,
		-1,
		51,
		50,
		81,
		67,
		78,
		141,
		-1,
		-1,
		117,
		109,
		91,
		94,
		71,
		67,
		56,
		55,
		48,
		41,
		37,
		15,
		0,
		18,
		28,
		45,
		55,
		59,
		74,
		85,
		-1,
		-1,
		159,
		-1,
		-1,
		138,
		121,
		-1,
		86,
		93,
		77,
		83,
		69,
		90,
		66,
		57,
		51,
		46,
		38,
		13,
		10,
		34,
		30,
		42,
		67,
		71,
		77,
		95,
		96,
		-1,
		158,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		93,
		90,
		83,
		107,
		106,
		-1,
		86,
		74,
		75,
		60,
		59,
		55,
		44,
		18,
		16,
		31,
		33,
		49,
		51,
		84,
		79,
		100,
		97,
		128,
		134,
		128,
		137,
		-1,
		146,
		142,
		138,
		145,
		94,
		-1,
		-1,
		111,
		-1,
		114,
		123,
		98,
		71,
		74,
		61,
		69,
		60,
		42,
		24,
		19,
		22,
		42,
		55,
		62,
		76,
		75,
		93,
		106,
		121,
		125,
		131,
		-1,
		196,
		-1,
		138,
		122,
		124,
		100,
		128,
		-1,
		131,
		115,
		115,
		100,
		100,
		-1,
		77,
		74,
		78,
		56,
		41,
		37,
		26,
		30,
		41,
		62,
		79,
		70,
		88,
		95,
		103,
		107,
		127,
		139,
		156,
		146,
		-1,
		128,
		133,
		103,
		115,
		138,
		158,
		136,
		-1,
		111,
		-1,
		79,
		92,
		-1,
		62,
		58,
		47,
		48,
		37,
		44,
		48,
		61,
		58,
		76,
		79,
		96,
		100,
		116,
		-1,
		-1,
		141,
		145,
		153,
		104,
		123,
		147,
		182,
		129,
		118,
		117,
		-1,
		97,
		81,
		78,
		79,
		66,
		60,
		60,
		43,
		49,
		58,
		60,
		63,
		85,
		113,
		91,
		103,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		130,
		101,
		125,
		167,
		147,
		140,
		128,
		113,
		113,
		107,
		-1,
		97,
		76,
		71,
		60,
		50,
		66,
		61,
		77,
		64,
		66,
		82,
		94,
		85,
		105,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		104,
		135,
		156,
		146,
		132,
		137,
		112,
		105,
		99,
		90,
		93,
		78,
		67,
		59,
		48,
		64,
		71,
		66,
		66,
		75,
		76,
		100,
		107,
		113,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		88,
		72,
		67,
		64,
		61,
		55,
		64,
		72,
		80,
		71,
		86,
		105,
		105,
		97,
		122,
		125,
		-1,
		-1,
		-1,
		160,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		89,
		74,
		70,
		65,
		69,
		62,
		69,
		65,
		79,
		90,
		72,
		108,
		-1,
		105,
		99,
		127,
		119,
		107,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		74,
		72,
		66,
		70,
		74,
		63,
		76,
		81,
		77,
		87,
		107,
		111,
		118,
		109,
		105,
		102,
		116,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		80,
		78,
		94,
		78,
		81,
		81,
		77,
		85,
		70,
		73,
		80,
		84,
		102,
		115,
		107,
		101,
		100,
		112,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		90,
		86,
		101,
		102,
		80,
		85,
		84,
		94,
		95,
		84,
		92,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		100,
		98,
		91,
		82,
		88,
		95,
		98,
		99,
		89,
		78,
		84,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		99,
		83,
		88,
		-1,
		124,
		-1,
		97,
		99,
		91,
		80,
		77,
		88,
		86,
		97,
		114,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		115,
		95,
		89,
		88,
		119,
		117,
		105,
		89,
		82,
		79,
		80,
		93,
		113,
		104,
		116,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		132,
		120,
		110,
		100,
		134,
		133,
		108,
		101,
		87,
		89,
		87,
		89,
		94,
		115,
		116,
		129,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		140,
		111,
		121,
		-1,
		-1,
		112,
		110,
		120,
		104,
		91,
		111,
		114,
		104,
		88,
		103,
		115,
		123,
		128,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		143,
		145,
		149,
		115,
		-1,
		120,
		115,
		95,
		109,
		116,
		106,
		101,
		95,
		98,
		116,
		133,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		122,
		136,
		138,
		131,
		135,
		-1,
		123,
		111,
		97,
		114,
		119,
		116,
		107,
		99,
		104,
		101,
		114,
		128,
		132,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		140,
		155,
		177,
		154,
		127,
		122,
		115,
		109,
		105,
		121,
		127,
		138,
		106,
		102,
		103,
		107,
		106,
		123,
		133,
		-1,
		-1,
		154,
		171,
		166,
		148,
		152,
		204,
		-1,
		-1,
		131,
		122,
		113,
		116,
		115,
		118,
		112,
		109,
		114,
		119,
		107,
		116,
		134,
		133,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		167,
		202,
		149,
		131,
		127,
		125,
		118,
		127,
		122,
		117,
		127,
		129,
		121,
		109,
		113,
		136,
		125,
		164,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		213,
		187,
		194,
		164,
		161,
		-1,
		131,
		156,
		128,
		135,
		126,
		133,
		133,
		125,
		103,
		110,
		126,
		125,
		120,
		156,
		147,
		153,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		209,
		195,
		199,
		189,
		192,
		-1,
		-1,
		180,
		177,
		153,
		136,
		134,
		127,
		122,
		132,
		112,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		203,
		195,
		202,
		181,
		183,
		-1,
		-1,
		153,
		150,
		155,
		143,
		140,
		142,
		137,
		128,
		113,
		119,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		200,
		-1,
		-1,
		210,
		184,
		168,
		158,
		152,
		202,
		157,
		152,
		136,
		134,
		125,
		116,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		226,
		-1,
		195,
		-1,
		170,
		174,
		165,
		168,
		150,
		137,
		129,
		121,
		137,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		271,
		227,
		226,
		217,
		252,
		267,
		271,
		-1,
		212,
		251,
		249,
		-1,
		233,
		-1,
		-1,
		-1,
		184,
		178,
		170,
		170,
		149,
		149,
		123,
		127,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		267,
		258,
		271,
		216,
		216,
		237,
		246,
		267,
		227,
		218,
		245,
		256,
		245,
		240,
		227,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		156,
		144,
		127,
		128,
		124,
		127,
		142,
		145,
		135,
		133,
		127,
		159,
		-1,
		260,
		259,
		248,
		245,
		221,
		212,
		207,
		234,
		-1,
		-1,
		229,
		246,
		240,
		244,
		260,
		285,
		-1,
		216,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		132,
		143,
		153,
		141,
		142,
		132,
		142,
		155,
		244,
		241,
		229,
		227,
		250,
		215,
		203,
		-1,
		216,
		214,
		220,
		227,
		244,
		274,
		-1,
		-1,
		232,
		212,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		134,
		139,
		159,
		161,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		253,
		267,
		256,
		252,
		251,
		259,
		208,
		201,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		222,
		218,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		152,
		156,
		148,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		287,
		-1,
		239,
		215,
		229,
		244,
		252,
		-1,
		-1,
		-1,
		239,
		225,
		218,
		206,
		204,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		227,
		230,
		-1,
		-1,
		229,
		231,
		-1,
		230,
		219,
		204,
		196,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		234,
		235,
		236,
		-1,
		214,
		-1,
		232,
		-1,
		199,
		205,
		193,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		175,
		173,
		164,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		232,
		206,
		239,
		230,
		213,
		193,
		185,
		204,
		-1,
		174,
		-1,
		149,
		151,
		177,
		180,
		186,
		180,
		153,
		168,
		158,
		149,
		158,
		238,
		-1,
		208,
		241,
		205,
		199,
		175,
		179,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		202,
		187,
		168,
		155,
		162,
		162,
		155,
		-1,
		-1,
		-1,
		210,
		209,
		201,
		195,
		195,
		180,
		171,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		192,
		188,
		175,
		175,
		167,
		-1,
		311,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		204,
		199,
		172,
		160,
		166,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		168,
		203,
		-1,
		306,
		-1,
		240,
		-1,
		-1,
		222,
		202,
		194,
		183,
		172,
		170,
		161,
		152,
		174,
		190,
		174,
		172,
		175,
		176,
		-1,
		295,
		294,
		-1,
		241,
		233,
		219,
		-1,
		212,
		-1,
		218,
		179,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		282,
		257,
		-1,
		-1,
		-1,
		242,
		222,
		213,
		197,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		267,
		266,
		-1,
		235,
		238,
		-1,
		228,
		219,
		227,
		174,
		178,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		250,
		248,
		243,
		240,
		226,
		210,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		248,
		240,
		233,
		-1,
		-1,
		235,
		218,
		199,
		197,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		225,
		-1,
		-1,
		231,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		259,
		-1,
		-1,
		-1,
		221,
		217,
		218,
		-1,
		-1,
		-1,
		-1,
		281,
		282,
		305,
		269,
		-1,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		284,
		282,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		211,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		246,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		236,
		243,
		265,
		268,
		304,
		-1,
		255
	],
	[
		-1,
		123,
		112,
		123,
		131,
		104,
		111,
		-1,
		132,
		134,
		100,
		94,
		133,
		104,
		110,
		121,
		-1,
		-1,
		-1,
		123,
		122,
		92,
		90,
		99,
		104,
		111,
		-1,
		112,
		-1,
		144,
		123,
		134,
		139,
		85,
		82,
		102,
		121,
		105,
		97,
		159,
		115,
		86,
		80,
		98,
		90,
		99,
		91,
		-1,
		86,
		76,
		98,
		79,
		90,
		82,
		-1,
		-1,
		80,
		81,
		87,
		75,
		81,
		77,
		-1,
		87,
		90,
		-1,
		-1,
		70,
		73,
		57,
		60,
		68,
		66,
		79,
		90,
		85,
		-1,
		-1,
		63,
		59,
		66,
		53,
		49,
		66,
		85,
		80,
		94,
		93,
		-1,
		59,
		73,
		69,
		60,
		58,
		42,
		46,
		64,
		79,
		85,
		88,
		-1,
		68,
		69,
		44,
		52,
		57,
		55,
		38,
		51,
		70,
		67,
		86,
		77,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		68,
		51,
		58,
		40,
		30,
		45,
		33,
		34,
		54,
		58,
		59,
		75,
		76,
		86,
		-1,
		-1,
		162,
		135,
		159,
		117,
		98,
		-1,
		64,
		44,
		38,
		34,
		28,
		21,
		33,
		21,
		-1,
		53,
		52,
		83,
		69,
		80,
		144,
		-1,
		-1,
		120,
		112,
		94,
		97,
		74,
		70,
		59,
		58,
		50,
		42,
		38,
		18,
		21,
		0,
		10,
		47,
		57,
		61,
		76,
		87,
		-1,
		-1,
		161,
		-1,
		-1,
		141,
		124,
		-1,
		89,
		96,
		80,
		86,
		72,
		93,
		69,
		60,
		52,
		47,
		39,
		14,
		13,
		17,
		30,
		44,
		69,
		73,
		79,
		97,
		98,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		96,
		93,
		86,
		110,
		109,
		-1,
		87,
		75,
		76,
		61,
		60,
		56,
		45,
		21,
		18,
		31,
		33,
		51,
		53,
		86,
		81,
		102,
		99,
		130,
		136,
		130,
		139,
		-1,
		149,
		145,
		141,
		148,
		97,
		-1,
		-1,
		114,
		-1,
		117,
		124,
		99,
		72,
		75,
		62,
		70,
		58,
		43,
		27,
		21,
		24,
		44,
		57,
		64,
		78,
		77,
		95,
		108,
		123,
		127,
		133,
		-1,
		199,
		-1,
		141,
		125,
		127,
		103,
		131,
		-1,
		134,
		118,
		116,
		101,
		101,
		-1,
		78,
		75,
		76,
		54,
		44,
		39,
		28,
		32,
		43,
		64,
		81,
		72,
		90,
		97,
		105,
		109,
		129,
		141,
		159,
		149,
		-1,
		131,
		136,
		106,
		118,
		141,
		161,
		137,
		-1,
		112,
		-1,
		80,
		93,
		-1,
		60,
		56,
		48,
		50,
		39,
		46,
		50,
		63,
		60,
		78,
		81,
		98,
		102,
		118,
		-1,
		-1,
		144,
		148,
		156,
		107,
		126,
		150,
		183,
		130,
		119,
		118,
		-1,
		98,
		79,
		76,
		77,
		64,
		62,
		62,
		45,
		51,
		60,
		62,
		65,
		87,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		133,
		104,
		128,
		170,
		148,
		141,
		129,
		115,
		115,
		109,
		-1,
		95,
		74,
		73,
		62,
		52,
		68,
		63,
		79,
		66,
		68,
		84,
		96,
		87,
		107,
		-1,
		-1,
		-1,
		163,
		152,
		153,
		107,
		137,
		159,
		148,
		134,
		139,
		114,
		107,
		101,
		88,
		91,
		80,
		69,
		61,
		50,
		66,
		73,
		68,
		68,
		77,
		78,
		102,
		109,
		115,
		-1,
		-1,
		170,
		160,
		144,
		146,
		143,
		128,
		135,
		167,
		139,
		152,
		-1,
		106,
		-1,
		95,
		90,
		74,
		69,
		66,
		63,
		57,
		66,
		74,
		82,
		73,
		88,
		107,
		107,
		99,
		124,
		127,
		-1,
		-1,
		-1,
		163,
		173,
		148,
		125,
		109,
		145,
		-1,
		122,
		123,
		-1,
		100,
		94,
		91,
		76,
		72,
		67,
		71,
		64,
		71,
		67,
		81,
		92,
		74,
		110,
		-1,
		107,
		101,
		129,
		121,
		109,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		104,
		156,
		-1,
		-1,
		107,
		100,
		-1,
		87,
		69,
		76,
		74,
		68,
		72,
		76,
		65,
		78,
		83,
		79,
		89,
		109,
		113,
		120,
		111,
		107,
		104,
		118,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		124,
		-1,
		116,
		108,
		98,
		92,
		86,
		82,
		80,
		96,
		80,
		83,
		83,
		79,
		87,
		72,
		75,
		82,
		86,
		104,
		117,
		109,
		103,
		102,
		114,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		137,
		-1,
		101,
		115,
		131,
		-1,
		124,
		103,
		118,
		96,
		92,
		88,
		103,
		104,
		82,
		87,
		86,
		96,
		97,
		86,
		94,
		91,
		113,
		113,
		97,
		98,
		107,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		98,
		86,
		118,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		102,
		100,
		93,
		84,
		90,
		97,
		100,
		101,
		91,
		80,
		86,
		85,
		107,
		93,
		91,
		110,
		126,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		101,
		85,
		90,
		-1,
		126,
		-1,
		99,
		101,
		93,
		82,
		79,
		90,
		88,
		99,
		116,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		155,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		117,
		97,
		91,
		90,
		121,
		119,
		107,
		91,
		84,
		81,
		82,
		95,
		115,
		106,
		118,
		-1,
		-1,
		-1,
		152,
		138,
		142,
		102,
		121,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		134,
		122,
		112,
		102,
		136,
		135,
		110,
		103,
		89,
		91,
		89,
		91,
		96,
		117,
		118,
		131,
		-1,
		-1,
		135,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		123,
		-1,
		-1,
		114,
		112,
		122,
		106,
		93,
		113,
		116,
		106,
		90,
		105,
		117,
		125,
		130,
		-1,
		138,
		125,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		145,
		147,
		151,
		117,
		-1,
		122,
		117,
		97,
		111,
		118,
		108,
		103,
		97,
		100,
		118,
		135,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		140,
		133,
		137,
		-1,
		125,
		113,
		99,
		116,
		121,
		118,
		109,
		101,
		106,
		103,
		116,
		130,
		134,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		142,
		157,
		179,
		156,
		129,
		124,
		117,
		111,
		107,
		123,
		129,
		140,
		108,
		104,
		105,
		109,
		108,
		125,
		135,
		-1,
		-1,
		156,
		173,
		168,
		150,
		154,
		206,
		-1,
		-1,
		133,
		124,
		115,
		118,
		117,
		120,
		114,
		111,
		116,
		121,
		109,
		118,
		136,
		135,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		169,
		204,
		151,
		133,
		129,
		127,
		120,
		129,
		124,
		119,
		129,
		131,
		123,
		111,
		115,
		138,
		127,
		166,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		205,
		180,
		195,
		215,
		189,
		196,
		166,
		163,
		-1,
		133,
		158,
		130,
		137,
		128,
		135,
		135,
		127,
		105,
		112,
		128,
		127,
		122,
		158,
		149,
		155,
		-1,
		-1,
		288,
		277,
		266,
		272,
		-1,
		211,
		197,
		201,
		191,
		194,
		-1,
		-1,
		182,
		179,
		155,
		138,
		136,
		129,
		124,
		134,
		114,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		183,
		264,
		257,
		240,
		248,
		279,
		-1,
		205,
		197,
		204,
		183,
		185,
		-1,
		-1,
		155,
		152,
		157,
		145,
		142,
		144,
		139,
		130,
		115,
		121,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		197,
		240,
		234,
		237,
		261,
		275,
		-1,
		202,
		-1,
		-1,
		212,
		186,
		170,
		160,
		154,
		204,
		159,
		154,
		138,
		136,
		127,
		118,
		125,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		232,
		220,
		228,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		228,
		-1,
		197,
		-1,
		172,
		176,
		167,
		170,
		152,
		139,
		131,
		123,
		139,
		114,
		124,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		273,
		229,
		228,
		219,
		254,
		269,
		273,
		-1,
		214,
		253,
		251,
		-1,
		235,
		-1,
		-1,
		-1,
		186,
		180,
		172,
		172,
		151,
		151,
		125,
		129,
		119,
		126,
		136,
		138,
		130,
		134,
		147,
		158,
		161,
		269,
		260,
		273,
		218,
		218,
		239,
		248,
		269,
		229,
		220,
		247,
		258,
		247,
		242,
		229,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		158,
		146,
		129,
		130,
		126,
		129,
		144,
		147,
		137,
		135,
		129,
		161,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		209,
		236,
		-1,
		-1,
		231,
		248,
		242,
		246,
		262,
		287,
		-1,
		218,
		-1,
		-1,
		203,
		-1,
		-1,
		188,
		151,
		140,
		131,
		137,
		134,
		145,
		155,
		143,
		144,
		134,
		144,
		157,
		246,
		243,
		231,
		229,
		252,
		217,
		205,
		-1,
		218,
		216,
		222,
		229,
		246,
		276,
		-1,
		-1,
		234,
		214,
		-1,
		-1,
		186,
		184,
		173,
		-1,
		163,
		136,
		141,
		161,
		163,
		152,
		146,
		140,
		147,
		146,
		154,
		162,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		203,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		224,
		220,
		-1,
		-1,
		181,
		174,
		162,
		150,
		140,
		150,
		154,
		158,
		150,
		143,
		138,
		149,
		141,
		145,
		162,
		-1,
		289,
		-1,
		241,
		217,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		241,
		227,
		220,
		208,
		206,
		-1,
		215,
		199,
		180,
		-1,
		150,
		163,
		194,
		162,
		167,
		162,
		144,
		155,
		144,
		147,
		161,
		156,
		-1,
		-1,
		229,
		232,
		-1,
		-1,
		231,
		233,
		-1,
		232,
		221,
		206,
		198,
		-1,
		-1,
		187,
		183,
		-1,
		-1,
		151,
		176,
		165,
		173,
		168,
		148,
		154,
		157,
		146,
		150,
		162,
		-1,
		-1,
		236,
		237,
		238,
		-1,
		216,
		-1,
		234,
		-1,
		201,
		207,
		195,
		-1,
		-1,
		-1,
		189,
		152,
		173,
		183,
		177,
		175,
		166,
		152,
		159,
		157,
		153,
		164,
		-1,
		-1,
		-1,
		234,
		208,
		241,
		232,
		215,
		195,
		187,
		206,
		-1,
		176,
		-1,
		151,
		153,
		179,
		182,
		188,
		182,
		155,
		170,
		160,
		151,
		160,
		240,
		-1,
		210,
		243,
		207,
		201,
		177,
		181,
		197,
		-1,
		173,
		155,
		-1,
		183,
		173,
		204,
		189,
		170,
		157,
		164,
		164,
		157,
		-1,
		-1,
		-1,
		212,
		211,
		203,
		197,
		197,
		182,
		173,
		-1,
		185,
		167,
		146,
		163,
		163,
		154,
		162,
		194,
		190,
		177,
		177,
		169,
		-1,
		313,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		206,
		201,
		174,
		162,
		168,
		164,
		150,
		156,
		158,
		166,
		164,
		161,
		173,
		169,
		189,
		170,
		205,
		-1,
		308,
		-1,
		242,
		-1,
		-1,
		224,
		204,
		196,
		185,
		174,
		172,
		163,
		154,
		176,
		192,
		176,
		174,
		177,
		178,
		-1,
		297,
		296,
		-1,
		243,
		235,
		221,
		-1,
		214,
		-1,
		220,
		181,
		-1,
		183,
		163,
		-1,
		185,
		181,
		-1,
		-1,
		284,
		259,
		-1,
		-1,
		-1,
		244,
		224,
		215,
		199,
		-1,
		174,
		174,
		-1,
		-1,
		-1,
		269,
		268,
		-1,
		237,
		240,
		-1,
		230,
		221,
		229,
		176,
		180,
		-1,
		-1,
		-1,
		278,
		259,
		253,
		252,
		250,
		245,
		242,
		228,
		212,
		190,
		179,
		200,
		-1,
		-1,
		-1,
		250,
		242,
		235,
		-1,
		-1,
		237,
		220,
		201,
		199,
		-1,
		-1,
		-1,
		272,
		253,
		-1,
		-1,
		227,
		-1,
		-1,
		233,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		261,
		-1,
		-1,
		-1,
		223,
		219,
		220,
		-1,
		-1,
		-1,
		-1,
		283,
		284,
		307,
		271,
		-1,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		286,
		284,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		213,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		248,
		-1,
		248,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		261,
		-1,
		233,
		235,
		-1,
		283,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		238,
		245,
		267,
		270,
		306,
		-1,
		257
	],
	[
		-1,
		136,
		125,
		136,
		144,
		117,
		124,
		-1,
		145,
		147,
		113,
		107,
		146,
		117,
		123,
		134,
		-1,
		-1,
		-1,
		136,
		135,
		105,
		103,
		112,
		117,
		124,
		-1,
		125,
		-1,
		157,
		136,
		147,
		152,
		98,
		95,
		115,
		134,
		118,
		110,
		172,
		128,
		99,
		93,
		111,
		103,
		112,
		104,
		-1,
		99,
		89,
		111,
		92,
		103,
		95,
		-1,
		-1,
		93,
		94,
		100,
		88,
		94,
		90,
		-1,
		100,
		94,
		-1,
		-1,
		83,
		86,
		70,
		73,
		81,
		79,
		92,
		94,
		89,
		-1,
		-1,
		76,
		72,
		79,
		66,
		62,
		79,
		98,
		84,
		98,
		97,
		-1,
		72,
		86,
		82,
		73,
		71,
		55,
		59,
		77,
		83,
		89,
		92,
		-1,
		81,
		82,
		57,
		65,
		70,
		68,
		51,
		64,
		78,
		71,
		90,
		81,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		81,
		64,
		71,
		53,
		43,
		58,
		46,
		47,
		67,
		66,
		63,
		79,
		80,
		90,
		-1,
		-1,
		175,
		148,
		172,
		130,
		111,
		-1,
		77,
		57,
		51,
		47,
		41,
		34,
		46,
		34,
		-1,
		57,
		56,
		87,
		73,
		84,
		157,
		-1,
		-1,
		133,
		125,
		107,
		110,
		87,
		83,
		72,
		71,
		64,
		57,
		53,
		31,
		34,
		17,
		0,
		51,
		61,
		65,
		80,
		91,
		-1,
		-1,
		165,
		-1,
		-1,
		154,
		137,
		-1,
		102,
		109,
		93,
		99,
		85,
		106,
		82,
		73,
		67,
		62,
		54,
		29,
		26,
		21,
		34,
		48,
		70,
		74,
		83,
		101,
		102,
		-1,
		164,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		109,
		106,
		99,
		123,
		122,
		-1,
		102,
		90,
		91,
		76,
		75,
		67,
		56,
		34,
		22,
		35,
		37,
		55,
		57,
		90,
		85,
		106,
		103,
		134,
		140,
		134,
		143,
		-1,
		162,
		158,
		154,
		161,
		110,
		-1,
		-1,
		127,
		-1,
		130,
		139,
		114,
		87,
		90,
		77,
		75,
		62,
		52,
		33,
		25,
		28,
		48,
		61,
		68,
		82,
		81,
		99,
		112,
		127,
		131,
		137,
		-1,
		212,
		-1,
		154,
		138,
		140,
		116,
		144,
		-1,
		147,
		131,
		131,
		116,
		116,
		-1,
		93,
		90,
		80,
		58,
		49,
		43,
		32,
		36,
		47,
		68,
		85,
		76,
		94,
		101,
		109,
		113,
		133,
		145,
		172,
		162,
		-1,
		144,
		149,
		119,
		131,
		154,
		174,
		152,
		-1,
		127,
		-1,
		95,
		108,
		-1,
		64,
		60,
		52,
		54,
		43,
		50,
		54,
		67,
		64,
		82,
		85,
		102,
		106,
		122,
		-1,
		-1,
		157,
		161,
		169,
		120,
		139,
		163,
		198,
		145,
		134,
		133,
		-1,
		113,
		83,
		80,
		81,
		68,
		66,
		66,
		49,
		55,
		64,
		66,
		69,
		91,
		119,
		97,
		109,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		146,
		117,
		141,
		183,
		163,
		156,
		144,
		119,
		119,
		113,
		-1,
		99,
		78,
		77,
		66,
		56,
		72,
		67,
		83,
		70,
		72,
		88,
		100,
		91,
		111,
		-1,
		-1,
		-1,
		176,
		165,
		166,
		118,
		141,
		172,
		152,
		138,
		143,
		118,
		111,
		105,
		92,
		95,
		84,
		73,
		65,
		54,
		70,
		77,
		72,
		72,
		81,
		82,
		106,
		113,
		119,
		-1,
		-1,
		183,
		173,
		157,
		159,
		156,
		132,
		139,
		171,
		143,
		156,
		-1,
		110,
		-1,
		99,
		94,
		78,
		73,
		70,
		67,
		61,
		70,
		78,
		86,
		77,
		92,
		111,
		111,
		103,
		128,
		131,
		-1,
		-1,
		-1,
		176,
		177,
		152,
		129,
		113,
		149,
		-1,
		126,
		127,
		-1,
		104,
		98,
		95,
		80,
		76,
		71,
		75,
		68,
		75,
		71,
		85,
		96,
		78,
		114,
		-1,
		111,
		105,
		133,
		125,
		113,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		108,
		160,
		-1,
		-1,
		111,
		104,
		-1,
		91,
		73,
		80,
		78,
		72,
		76,
		80,
		69,
		82,
		87,
		83,
		93,
		113,
		117,
		124,
		115,
		111,
		108,
		122,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		128,
		-1,
		120,
		112,
		102,
		96,
		90,
		86,
		84,
		100,
		84,
		87,
		87,
		83,
		91,
		76,
		79,
		86,
		90,
		108,
		121,
		113,
		107,
		106,
		118,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		141,
		-1,
		105,
		119,
		135,
		-1,
		128,
		107,
		122,
		100,
		96,
		92,
		107,
		108,
		86,
		91,
		90,
		100,
		101,
		90,
		98,
		95,
		117,
		117,
		101,
		102,
		111,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		102,
		90,
		122,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		106,
		104,
		97,
		88,
		94,
		101,
		104,
		105,
		95,
		84,
		90,
		89,
		111,
		97,
		95,
		114,
		130,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		105,
		89,
		94,
		-1,
		130,
		-1,
		103,
		105,
		97,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		159,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		121,
		101,
		95,
		94,
		125,
		123,
		111,
		95,
		88,
		85,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		156,
		142,
		146,
		106,
		125,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		138,
		126,
		116,
		106,
		140,
		139,
		114,
		107,
		93,
		95,
		93,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		139,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		138,
		154,
		146,
		117,
		127,
		-1,
		-1,
		118,
		116,
		126,
		110,
		97,
		117,
		120,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		142,
		129,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		149,
		151,
		155,
		121,
		-1,
		126,
		121,
		101,
		115,
		122,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		128,
		142,
		144,
		137,
		141,
		-1,
		129,
		117,
		103,
		120,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		146,
		161,
		183,
		160,
		133,
		128,
		121,
		115,
		111,
		127,
		133,
		144,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		160,
		177,
		172,
		154,
		158,
		210,
		-1,
		-1,
		137,
		128,
		119,
		122,
		121,
		124,
		118,
		115,
		120,
		125,
		113,
		122,
		140,
		139,
		-1,
		-1,
		-1,
		180,
		-1,
		195,
		-1,
		-1,
		173,
		208,
		155,
		137,
		133,
		131,
		124,
		133,
		128,
		123,
		133,
		135,
		127,
		115,
		119,
		142,
		131,
		170,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		209,
		184,
		199,
		219,
		193,
		200,
		170,
		167,
		-1,
		137,
		162,
		134,
		141,
		132,
		139,
		139,
		131,
		109,
		116,
		132,
		131,
		126,
		162,
		153,
		159,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		215,
		201,
		205,
		195,
		198,
		-1,
		-1,
		186,
		183,
		159,
		142,
		140,
		133,
		128,
		138,
		118,
		105,
		109,
		113,
		119,
		124,
		129,
		135,
		150,
		165,
		-1,
		187,
		268,
		261,
		244,
		252,
		283,
		-1,
		209,
		201,
		208,
		187,
		189,
		-1,
		-1,
		159,
		156,
		161,
		149,
		146,
		148,
		143,
		134,
		119,
		125,
		112,
		111,
		129,
		133,
		142,
		149,
		139,
		152,
		156,
		-1,
		201,
		244,
		238,
		241,
		265,
		279,
		-1,
		206,
		-1,
		-1,
		216,
		190,
		174,
		164,
		158,
		208,
		163,
		158,
		142,
		140,
		131,
		122,
		129,
		120,
		120,
		123,
		138,
		143,
		135,
		149,
		149,
		150,
		-1,
		236,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		232,
		-1,
		201,
		-1,
		176,
		180,
		171,
		174,
		156,
		143,
		135,
		127,
		143,
		118,
		128,
		124,
		125,
		134,
		145,
		157,
		156,
		157,
		277,
		233,
		232,
		223,
		258,
		273,
		277,
		-1,
		218,
		257,
		255,
		-1,
		239,
		-1,
		-1,
		-1,
		190,
		184,
		176,
		176,
		155,
		155,
		129,
		133,
		123,
		130,
		140,
		142,
		134,
		138,
		151,
		162,
		165,
		273,
		264,
		277,
		222,
		222,
		243,
		252,
		273,
		233,
		224,
		251,
		262,
		251,
		246,
		233,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		162,
		150,
		133,
		134,
		130,
		133,
		148,
		151,
		141,
		139,
		133,
		165,
		-1,
		266,
		265,
		254,
		251,
		227,
		218,
		213,
		240,
		-1,
		-1,
		235,
		252,
		246,
		250,
		266,
		291,
		-1,
		222,
		-1,
		-1,
		207,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		138,
		149,
		159,
		147,
		148,
		138,
		148,
		161,
		250,
		247,
		235,
		233,
		256,
		221,
		209,
		-1,
		222,
		220,
		226,
		233,
		250,
		280,
		-1,
		-1,
		238,
		218,
		-1,
		-1,
		190,
		188,
		177,
		-1,
		167,
		140,
		145,
		165,
		167,
		156,
		150,
		144,
		151,
		150,
		158,
		166,
		259,
		273,
		262,
		258,
		257,
		265,
		214,
		207,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		-1,
		228,
		224,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		158,
		162,
		154,
		147,
		142,
		153,
		145,
		149,
		166,
		-1,
		293,
		-1,
		245,
		221,
		235,
		250,
		258,
		-1,
		-1,
		-1,
		245,
		231,
		224,
		212,
		210,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		148,
		159,
		148,
		151,
		165,
		160,
		-1,
		-1,
		233,
		236,
		-1,
		-1,
		235,
		237,
		-1,
		236,
		225,
		210,
		202,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		152,
		158,
		161,
		150,
		154,
		166,
		-1,
		-1,
		240,
		241,
		242,
		-1,
		220,
		-1,
		238,
		-1,
		205,
		211,
		199,
		-1,
		-1,
		-1,
		193,
		156,
		177,
		187,
		181,
		179,
		170,
		156,
		163,
		161,
		157,
		168,
		-1,
		-1,
		-1,
		238,
		212,
		245,
		236,
		219,
		199,
		191,
		210,
		-1,
		180,
		-1,
		155,
		157,
		183,
		186,
		192,
		186,
		159,
		174,
		164,
		155,
		164,
		244,
		-1,
		214,
		247,
		211,
		205,
		181,
		185,
		201,
		-1,
		177,
		159,
		-1,
		187,
		177,
		208,
		193,
		174,
		161,
		168,
		168,
		161,
		-1,
		-1,
		-1,
		216,
		215,
		207,
		201,
		201,
		186,
		177,
		-1,
		189,
		171,
		150,
		167,
		167,
		158,
		166,
		198,
		194,
		181,
		181,
		173,
		-1,
		317,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		210,
		205,
		178,
		166,
		172,
		168,
		154,
		160,
		162,
		170,
		168,
		165,
		177,
		173,
		193,
		174,
		209,
		-1,
		312,
		-1,
		246,
		-1,
		-1,
		228,
		208,
		200,
		189,
		178,
		176,
		167,
		158,
		180,
		196,
		180,
		178,
		181,
		182,
		-1,
		301,
		300,
		-1,
		247,
		239,
		225,
		-1,
		218,
		-1,
		224,
		185,
		-1,
		187,
		167,
		-1,
		189,
		185,
		-1,
		-1,
		288,
		263,
		-1,
		-1,
		-1,
		248,
		228,
		219,
		203,
		-1,
		178,
		178,
		-1,
		-1,
		-1,
		273,
		272,
		-1,
		241,
		244,
		-1,
		234,
		225,
		233,
		180,
		184,
		-1,
		-1,
		-1,
		282,
		263,
		257,
		256,
		254,
		249,
		246,
		232,
		216,
		194,
		183,
		204,
		-1,
		-1,
		-1,
		254,
		246,
		239,
		-1,
		-1,
		241,
		224,
		205,
		203,
		-1,
		-1,
		-1,
		276,
		257,
		-1,
		-1,
		231,
		-1,
		-1,
		237,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		293,
		265,
		-1,
		-1,
		-1,
		227,
		223,
		224,
		-1,
		-1,
		-1,
		-1,
		287,
		288,
		311,
		275,
		-1,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		290,
		288,
		-1,
		-1,
		-1,
		247,
		231,
		-1,
		217,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		252,
		-1,
		252,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		265,
		257,
		265,
		-1,
		237,
		239,
		-1,
		287,
		-1,
		-1,
		280,
		271,
		-1,
		-1,
		242,
		249,
		271,
		274,
		310,
		-1,
		261
	],
	[
		-1,
		106,
		95,
		106,
		114,
		87,
		94,
		-1,
		113,
		117,
		83,
		77,
		116,
		85,
		91,
		102,
		-1,
		-1,
		-1,
		106,
		105,
		73,
		71,
		80,
		85,
		92,
		-1,
		91,
		-1,
		127,
		106,
		117,
		122,
		66,
		63,
		83,
		102,
		84,
		76,
		142,
		96,
		67,
		61,
		79,
		69,
		78,
		70,
		-1,
		67,
		57,
		79,
		58,
		69,
		61,
		-1,
		-1,
		61,
		62,
		68,
		54,
		60,
		56,
		-1,
		62,
		44,
		-1,
		-1,
		51,
		52,
		36,
		39,
		47,
		45,
		58,
		44,
		39,
		-1,
		-1,
		42,
		38,
		45,
		32,
		28,
		45,
		58,
		34,
		48,
		47,
		-1,
		54,
		71,
		71,
		39,
		37,
		21,
		19,
		37,
		33,
		39,
		46,
		-1,
		71,
		67,
		68,
		66,
		61,
		37,
		24,
		24,
		27,
		21,
		42,
		37,
		83,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		72,
		63,
		80,
		64,
		54,
		58,
		56,
		27,
		17,
		15,
		12,
		31,
		36,
		46,
		-1,
		-1,
		165,
		138,
		162,
		120,
		102,
		-1,
		68,
		68,
		62,
		58,
		52,
		45,
		58,
		43,
		-1,
		13,
		5,
		41,
		29,
		40,
		147,
		-1,
		-1,
		123,
		115,
		97,
		100,
		77,
		73,
		83,
		82,
		75,
		68,
		64,
		42,
		45,
		45,
		51,
		0,
		17,
		21,
		36,
		47,
		-1,
		-1,
		121,
		-1,
		-1,
		144,
		127,
		-1,
		92,
		99,
		83,
		89,
		75,
		96,
		93,
		84,
		78,
		73,
		65,
		40,
		37,
		50,
		29,
		4,
		28,
		32,
		39,
		57,
		58,
		-1,
		120,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		99,
		96,
		89,
		113,
		112,
		-1,
		113,
		101,
		102,
		87,
		86,
		80,
		68,
		45,
		29,
		29,
		26,
		11,
		13,
		50,
		41,
		62,
		59,
		90,
		96,
		90,
		99,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		117,
		-1,
		120,
		133,
		125,
		98,
		101,
		88,
		88,
		75,
		64,
		46,
		27,
		24,
		23,
		19,
		28,
		38,
		37,
		55,
		68,
		83,
		87,
		93,
		-1,
		202,
		-1,
		144,
		128,
		130,
		106,
		134,
		-1,
		137,
		121,
		141,
		127,
		127,
		-1,
		104,
		101,
		93,
		71,
		56,
		39,
		27,
		22,
		22,
		26,
		41,
		32,
		50,
		57,
		65,
		69,
		89,
		101,
		162,
		152,
		-1,
		134,
		139,
		109,
		121,
		141,
		164,
		143,
		-1,
		138,
		-1,
		106,
		119,
		-1,
		77,
		73,
		47,
		35,
		24,
		31,
		29,
		23,
		20,
		38,
		41,
		58,
		62,
		78,
		-1,
		-1,
		147,
		151,
		156,
		107,
		126,
		150,
		187,
		136,
		125,
		124,
		-1,
		115,
		83,
		80,
		77,
		64,
		49,
		47,
		30,
		36,
		37,
		22,
		25,
		47,
		75,
		53,
		65,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		133,
		104,
		128,
		170,
		154,
		147,
		135,
		100,
		100,
		94,
		-1,
		88,
		67,
		58,
		47,
		37,
		53,
		43,
		46,
		26,
		28,
		44,
		56,
		47,
		67,
		-1,
		-1,
		-1,
		163,
		152,
		153,
		99,
		122,
		159,
		133,
		119,
		124,
		99,
		92,
		86,
		92,
		84,
		65,
		54,
		46,
		35,
		44,
		54,
		48,
		28,
		37,
		38,
		62,
		69,
		75,
		-1,
		-1,
		170,
		160,
		144,
		146,
		143,
		113,
		120,
		152,
		124,
		137,
		-1,
		91,
		-1,
		80,
		75,
		59,
		54,
		51,
		48,
		42,
		51,
		56,
		42,
		33,
		48,
		67,
		67,
		59,
		84,
		87,
		-1,
		-1,
		-1,
		163,
		158,
		133,
		110,
		94,
		130,
		-1,
		107,
		108,
		-1,
		85,
		79,
		76,
		61,
		57,
		52,
		56,
		49,
		56,
		52,
		51,
		52,
		34,
		70,
		-1,
		67,
		61,
		89,
		92,
		82,
		-1,
		-1,
		-1,
		156,
		135,
		128,
		148,
		89,
		141,
		-1,
		-1,
		92,
		85,
		-1,
		72,
		54,
		61,
		59,
		53,
		57,
		61,
		50,
		63,
		59,
		39,
		49,
		69,
		73,
		80,
		73,
		78,
		77,
		91,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		109,
		-1,
		101,
		93,
		83,
		77,
		71,
		67,
		65,
		81,
		65,
		68,
		68,
		64,
		72,
		57,
		56,
		42,
		46,
		64,
		91,
		86,
		81,
		80,
		87,
		-1,
		176,
		162,
		133,
		-1,
		-1,
		122,
		-1,
		86,
		100,
		116,
		-1,
		109,
		88,
		103,
		81,
		77,
		73,
		88,
		89,
		67,
		72,
		71,
		81,
		78,
		67,
		54,
		58,
		73,
		83,
		75,
		76,
		85,
		-1,
		182,
		169,
		127,
		123,
		112,
		132,
		83,
		71,
		103,
		-1,
		-1,
		145,
		-1,
		79,
		96,
		87,
		85,
		78,
		69,
		75,
		82,
		85,
		82,
		72,
		61,
		67,
		63,
		85,
		71,
		69,
		88,
		103,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		98,
		85,
		79,
		-1,
		120,
		-1,
		123,
		113,
		97,
		82,
		115,
		-1,
		86,
		70,
		75,
		-1,
		107,
		-1,
		80,
		80,
		71,
		60,
		57,
		68,
		66,
		77,
		94,
		-1,
		132,
		117,
		110,
		100,
		114,
		85,
		-1,
		140,
		-1,
		-1,
		110,
		104,
		104,
		88,
		91,
		102,
		82,
		76,
		75,
		102,
		97,
		88,
		69,
		62,
		59,
		60,
		73,
		93,
		84,
		96,
		-1,
		-1,
		-1,
		137,
		123,
		127,
		87,
		106,
		-1,
		-1,
		172,
		127,
		113,
		-1,
		97,
		119,
		107,
		97,
		87,
		121,
		113,
		88,
		81,
		67,
		69,
		67,
		69,
		74,
		95,
		96,
		109,
		-1,
		-1,
		120,
		125,
		113,
		99,
		118,
		-1,
		-1,
		-1,
		119,
		135,
		127,
		98,
		108,
		-1,
		-1,
		99,
		97,
		105,
		84,
		71,
		91,
		94,
		84,
		68,
		83,
		95,
		103,
		108,
		-1,
		123,
		110,
		-1,
		-1,
		121,
		115,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		130,
		125,
		129,
		102,
		-1,
		101,
		95,
		75,
		89,
		96,
		86,
		81,
		75,
		78,
		96,
		113,
		-1,
		-1,
		135,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		109,
		123,
		118,
		111,
		115,
		-1,
		103,
		91,
		77,
		94,
		99,
		96,
		87,
		79,
		84,
		81,
		94,
		108,
		112,
		158,
		-1,
		141,
		-1,
		-1,
		-1,
		127,
		142,
		157,
		134,
		107,
		102,
		95,
		89,
		85,
		101,
		107,
		118,
		86,
		82,
		83,
		87,
		86,
		103,
		113,
		-1,
		-1,
		141,
		158,
		153,
		135,
		139,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		95,
		98,
		92,
		89,
		94,
		99,
		87,
		96,
		114,
		113,
		-1,
		-1,
		-1,
		161,
		-1,
		176,
		-1,
		-1,
		154,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		97,
		107,
		109,
		101,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		190,
		165,
		180,
		193,
		174,
		181,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		106,
		113,
		113,
		105,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		193,
		182,
		179,
		169,
		172,
		-1,
		-1,
		160,
		157,
		133,
		116,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		168,
		249,
		242,
		225,
		233,
		264,
		-1,
		183,
		175,
		186,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		123,
		120,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		182,
		225,
		219,
		222,
		246,
		260,
		-1,
		180,
		-1,
		-1,
		192,
		164,
		148,
		138,
		132,
		182,
		137,
		132,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		217,
		205,
		213,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		208,
		-1,
		175,
		-1,
		150,
		154,
		145,
		148,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		251,
		207,
		210,
		204,
		232,
		247,
		251,
		-1,
		192,
		231,
		229,
		-1,
		213,
		-1,
		-1,
		-1,
		164,
		158,
		150,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		207,
		198,
		225,
		236,
		225,
		220,
		207,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		226,
		220,
		224,
		240,
		265,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		214,
		215,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		116,
		105,
		116,
		124,
		97,
		104,
		-1,
		123,
		127,
		93,
		87,
		126,
		95,
		101,
		112,
		-1,
		-1,
		-1,
		116,
		115,
		83,
		81,
		90,
		95,
		102,
		-1,
		101,
		-1,
		137,
		116,
		127,
		132,
		76,
		73,
		93,
		112,
		94,
		86,
		152,
		106,
		77,
		71,
		89,
		79,
		88,
		80,
		-1,
		77,
		67,
		89,
		68,
		79,
		71,
		-1,
		-1,
		71,
		72,
		78,
		64,
		70,
		66,
		-1,
		71,
		52,
		-1,
		-1,
		61,
		62,
		46,
		49,
		57,
		55,
		67,
		53,
		47,
		-1,
		-1,
		52,
		48,
		55,
		42,
		38,
		55,
		68,
		43,
		41,
		39,
		-1,
		64,
		81,
		81,
		49,
		47,
		31,
		29,
		47,
		41,
		39,
		31,
		-1,
		81,
		77,
		78,
		76,
		71,
		47,
		34,
		34,
		44,
		30,
		33,
		20,
		66,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		82,
		73,
		90,
		74,
		64,
		68,
		66,
		37,
		34,
		32,
		21,
		23,
		19,
		29,
		-1,
		-1,
		175,
		148,
		172,
		130,
		112,
		-1,
		78,
		78,
		72,
		68,
		62,
		55,
		68,
		53,
		-1,
		5,
		14,
		26,
		12,
		23,
		157,
		-1,
		-1,
		133,
		125,
		107,
		110,
		87,
		83,
		93,
		92,
		85,
		78,
		74,
		52,
		55,
		55,
		61,
		17,
		0,
		4,
		19,
		30,
		-1,
		-1,
		131,
		-1,
		-1,
		154,
		137,
		-1,
		102,
		109,
		93,
		99,
		85,
		106,
		103,
		94,
		88,
		83,
		75,
		50,
		47,
		60,
		39,
		14,
		14,
		17,
		22,
		40,
		41,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		109,
		106,
		99,
		123,
		122,
		-1,
		123,
		111,
		112,
		97,
		96,
		90,
		78,
		55,
		39,
		39,
		36,
		21,
		23,
		56,
		24,
		45,
		42,
		73,
		106,
		100,
		109,
		-1,
		162,
		158,
		154,
		161,
		110,
		-1,
		-1,
		127,
		-1,
		130,
		143,
		135,
		108,
		111,
		98,
		98,
		85,
		74,
		56,
		37,
		34,
		33,
		29,
		38,
		29,
		32,
		48,
		51,
		93,
		97,
		103,
		-1,
		212,
		-1,
		154,
		138,
		140,
		116,
		144,
		-1,
		147,
		131,
		151,
		137,
		137,
		-1,
		114,
		111,
		103,
		81,
		66,
		49,
		37,
		32,
		32,
		36,
		51,
		36,
		54,
		56,
		63,
		79,
		99,
		111,
		172,
		162,
		-1,
		144,
		149,
		119,
		131,
		151,
		174,
		153,
		-1,
		148,
		-1,
		116,
		129,
		-1,
		87,
		83,
		57,
		45,
		34,
		41,
		39,
		33,
		30,
		42,
		45,
		68,
		72,
		88,
		-1,
		-1,
		157,
		161,
		166,
		117,
		136,
		160,
		197,
		146,
		135,
		134,
		-1,
		125,
		93,
		90,
		87,
		74,
		59,
		57,
		40,
		46,
		47,
		32,
		35,
		51,
		85,
		63,
		75,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		143,
		114,
		138,
		180,
		164,
		157,
		145,
		110,
		110,
		104,
		-1,
		98,
		77,
		68,
		57,
		47,
		63,
		53,
		56,
		36,
		38,
		54,
		66,
		57,
		77,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		109,
		132,
		169,
		143,
		129,
		134,
		109,
		102,
		96,
		102,
		94,
		75,
		64,
		56,
		45,
		54,
		64,
		58,
		38,
		47,
		48,
		72,
		79,
		85,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		123,
		130,
		162,
		134,
		147,
		-1,
		101,
		-1,
		90,
		85,
		69,
		64,
		61,
		58,
		52,
		61,
		66,
		52,
		43,
		58,
		77,
		77,
		69,
		94,
		97,
		-1,
		-1,
		-1,
		173,
		168,
		143,
		120,
		104,
		140,
		-1,
		117,
		118,
		-1,
		95,
		89,
		86,
		71,
		67,
		62,
		66,
		59,
		66,
		62,
		61,
		62,
		44,
		80,
		-1,
		77,
		71,
		99,
		102,
		92,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		99,
		151,
		-1,
		-1,
		102,
		95,
		-1,
		82,
		64,
		71,
		69,
		63,
		67,
		71,
		60,
		73,
		69,
		49,
		59,
		79,
		83,
		90,
		83,
		88,
		87,
		101,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		119,
		-1,
		111,
		103,
		93,
		87,
		81,
		77,
		75,
		91,
		75,
		78,
		78,
		74,
		82,
		67,
		66,
		52,
		56,
		74,
		101,
		96,
		91,
		90,
		97,
		-1,
		186,
		172,
		143,
		-1,
		-1,
		132,
		-1,
		96,
		110,
		126,
		-1,
		119,
		98,
		113,
		91,
		87,
		83,
		98,
		99,
		77,
		82,
		81,
		91,
		88,
		77,
		64,
		68,
		83,
		93,
		85,
		86,
		95,
		-1,
		192,
		179,
		137,
		133,
		122,
		142,
		93,
		81,
		113,
		-1,
		-1,
		155,
		-1,
		89,
		106,
		97,
		95,
		88,
		79,
		85,
		92,
		95,
		92,
		82,
		71,
		77,
		73,
		95,
		81,
		79,
		98,
		113,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		108,
		95,
		89,
		-1,
		130,
		-1,
		133,
		123,
		107,
		92,
		125,
		-1,
		96,
		80,
		85,
		-1,
		117,
		-1,
		90,
		90,
		81,
		70,
		67,
		78,
		76,
		87,
		104,
		-1,
		142,
		127,
		120,
		110,
		124,
		95,
		-1,
		150,
		-1,
		-1,
		120,
		114,
		114,
		98,
		101,
		112,
		92,
		86,
		85,
		112,
		107,
		98,
		79,
		72,
		69,
		70,
		83,
		103,
		94,
		106,
		-1,
		-1,
		-1,
		147,
		133,
		137,
		97,
		116,
		-1,
		-1,
		182,
		137,
		123,
		-1,
		107,
		129,
		117,
		107,
		97,
		131,
		123,
		98,
		91,
		77,
		79,
		77,
		79,
		84,
		105,
		106,
		119,
		-1,
		-1,
		130,
		135,
		123,
		109,
		128,
		-1,
		-1,
		-1,
		129,
		145,
		137,
		108,
		118,
		-1,
		-1,
		109,
		107,
		115,
		94,
		81,
		101,
		104,
		94,
		78,
		93,
		105,
		113,
		118,
		-1,
		133,
		120,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		140,
		135,
		139,
		112,
		-1,
		111,
		105,
		85,
		99,
		106,
		96,
		91,
		85,
		88,
		106,
		123,
		-1,
		-1,
		145,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		119,
		133,
		128,
		121,
		125,
		-1,
		113,
		101,
		87,
		104,
		109,
		106,
		97,
		89,
		94,
		91,
		104,
		118,
		122,
		168,
		-1,
		151,
		-1,
		-1,
		-1,
		137,
		152,
		167,
		144,
		117,
		112,
		105,
		99,
		95,
		111,
		117,
		128,
		96,
		92,
		93,
		97,
		96,
		113,
		123,
		-1,
		-1,
		151,
		168,
		163,
		145,
		149,
		194,
		-1,
		-1,
		121,
		112,
		103,
		106,
		105,
		108,
		102,
		99,
		104,
		109,
		97,
		106,
		124,
		123,
		-1,
		-1,
		-1,
		171,
		-1,
		186,
		-1,
		-1,
		164,
		192,
		139,
		121,
		117,
		115,
		108,
		117,
		112,
		107,
		117,
		119,
		111,
		99,
		103,
		126,
		115,
		154,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		200,
		175,
		190,
		203,
		184,
		191,
		154,
		151,
		-1,
		121,
		146,
		118,
		125,
		116,
		123,
		123,
		115,
		93,
		100,
		116,
		115,
		110,
		146,
		137,
		143,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		203,
		192,
		189,
		179,
		182,
		-1,
		-1,
		170,
		167,
		143,
		126,
		124,
		117,
		112,
		122,
		102,
		89,
		93,
		97,
		103,
		108,
		113,
		119,
		134,
		149,
		-1,
		178,
		259,
		252,
		235,
		243,
		274,
		-1,
		193,
		185,
		196,
		171,
		173,
		-1,
		-1,
		143,
		140,
		145,
		133,
		130,
		132,
		127,
		118,
		103,
		109,
		96,
		95,
		113,
		117,
		126,
		133,
		123,
		136,
		140,
		-1,
		192,
		235,
		229,
		232,
		256,
		270,
		-1,
		190,
		-1,
		-1,
		202,
		174,
		158,
		148,
		142,
		192,
		147,
		142,
		126,
		124,
		115,
		106,
		113,
		104,
		104,
		107,
		122,
		127,
		119,
		133,
		133,
		134,
		-1,
		227,
		215,
		223,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		218,
		-1,
		185,
		-1,
		160,
		164,
		155,
		158,
		140,
		127,
		119,
		111,
		127,
		102,
		112,
		108,
		109,
		118,
		129,
		141,
		140,
		141,
		261,
		217,
		220,
		214,
		242,
		257,
		261,
		-1,
		202,
		241,
		239,
		-1,
		223,
		-1,
		-1,
		-1,
		174,
		168,
		160,
		160,
		139,
		139,
		113,
		117,
		107,
		114,
		124,
		126,
		118,
		122,
		135,
		146,
		149,
		257,
		248,
		261,
		206,
		206,
		227,
		236,
		257,
		217,
		208,
		235,
		246,
		235,
		230,
		217,
		-1,
		-1,
		197,
		178,
		-1,
		-1,
		146,
		134,
		117,
		118,
		114,
		117,
		132,
		135,
		125,
		123,
		117,
		149,
		-1,
		250,
		249,
		238,
		235,
		211,
		202,
		197,
		224,
		-1,
		-1,
		219,
		236,
		230,
		234,
		250,
		275,
		-1,
		206,
		-1,
		-1,
		191,
		-1,
		-1,
		176,
		139,
		128,
		119,
		125,
		122,
		133,
		143,
		131,
		132,
		122,
		132,
		145,
		234,
		231,
		219,
		217,
		240,
		205,
		193,
		-1,
		206,
		204,
		210,
		217,
		234,
		264,
		-1,
		-1,
		222,
		202,
		-1,
		-1,
		174,
		172,
		161,
		-1,
		151,
		124,
		129,
		149,
		151,
		140,
		134,
		128,
		135,
		134,
		142,
		150,
		243,
		257,
		246,
		242,
		241,
		249,
		198,
		191,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		212,
		208,
		-1,
		-1,
		169,
		162,
		150,
		138,
		128,
		138,
		142,
		146,
		138,
		131,
		126,
		137,
		129,
		133,
		150,
		-1,
		277,
		-1,
		229,
		205,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		229,
		215,
		208,
		196,
		194,
		-1,
		203,
		187,
		168,
		-1,
		138,
		151,
		182,
		150,
		155,
		150,
		132,
		143,
		132,
		135,
		149,
		144,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		219,
		221,
		-1,
		220,
		209,
		194,
		186,
		-1,
		-1,
		175,
		171,
		-1,
		-1,
		139,
		164,
		153,
		161,
		156,
		136,
		142,
		145,
		134,
		138,
		150,
		-1,
		-1,
		224,
		225,
		226,
		-1,
		204,
		-1,
		222,
		-1,
		189,
		195,
		183,
		-1,
		-1,
		-1,
		177,
		140,
		161,
		171,
		165,
		163,
		154,
		140,
		147,
		145,
		141,
		152,
		-1,
		-1,
		-1,
		222,
		196,
		229,
		220,
		203,
		183,
		175,
		194,
		-1,
		164,
		-1,
		139,
		141,
		167,
		170,
		176,
		170,
		143,
		158,
		148,
		139,
		148,
		228,
		-1,
		198,
		231,
		195,
		189,
		165,
		169,
		185,
		-1,
		161,
		143,
		-1,
		171,
		161,
		192,
		177,
		158,
		145,
		152,
		152,
		145,
		-1,
		-1,
		-1,
		200,
		199,
		191,
		185,
		185,
		170,
		161,
		-1,
		173,
		155,
		134,
		151,
		151,
		142,
		150,
		182,
		178,
		165,
		165,
		157,
		-1,
		301,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		194,
		189,
		162,
		150,
		156,
		152,
		138,
		144,
		146,
		154,
		152,
		149,
		161,
		157,
		177,
		158,
		193,
		-1,
		296,
		-1,
		230,
		-1,
		-1,
		212,
		192,
		184,
		173,
		162,
		160,
		151,
		142,
		164,
		180,
		164,
		162,
		165,
		166,
		-1,
		285,
		284,
		-1,
		231,
		223,
		209,
		-1,
		202,
		-1,
		208,
		169,
		-1,
		171,
		151,
		-1,
		173,
		169,
		-1,
		-1,
		272,
		247,
		-1,
		-1,
		-1,
		232,
		212,
		203,
		187,
		-1,
		162,
		162,
		-1,
		-1,
		-1,
		257,
		256,
		-1,
		225,
		228,
		-1,
		218,
		209,
		217,
		164,
		168,
		-1,
		-1,
		-1,
		266,
		247,
		241,
		240,
		238,
		233,
		230,
		216,
		200,
		178,
		167,
		188,
		-1,
		-1,
		-1,
		238,
		230,
		223,
		-1,
		-1,
		225,
		208,
		189,
		187,
		-1,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		215,
		-1,
		-1,
		221,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		249,
		-1,
		-1,
		-1,
		211,
		207,
		208,
		-1,
		-1,
		-1,
		-1,
		271,
		272,
		295,
		259,
		-1,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		274,
		272,
		-1,
		-1,
		-1,
		231,
		215,
		-1,
		201,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		236,
		-1,
		236,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		249,
		241,
		249,
		-1,
		221,
		223,
		-1,
		271,
		-1,
		-1,
		264,
		255,
		-1,
		-1,
		226,
		233,
		255,
		258,
		294,
		-1,
		245
	],
	[
		-1,
		119,
		108,
		119,
		127,
		100,
		107,
		-1,
		126,
		130,
		96,
		90,
		129,
		98,
		104,
		115,
		-1,
		-1,
		-1,
		119,
		118,
		86,
		84,
		93,
		98,
		105,
		-1,
		104,
		-1,
		140,
		119,
		130,
		135,
		79,
		76,
		96,
		115,
		97,
		89,
		155,
		109,
		80,
		74,
		92,
		82,
		91,
		83,
		-1,
		80,
		70,
		92,
		71,
		82,
		74,
		-1,
		-1,
		74,
		75,
		81,
		67,
		73,
		69,
		-1,
		74,
		55,
		-1,
		-1,
		64,
		65,
		49,
		52,
		60,
		58,
		70,
		56,
		50,
		-1,
		-1,
		55,
		51,
		58,
		45,
		41,
		58,
		71,
		46,
		37,
		35,
		-1,
		67,
		84,
		84,
		52,
		50,
		34,
		32,
		50,
		44,
		35,
		27,
		-1,
		84,
		80,
		81,
		79,
		74,
		50,
		37,
		37,
		47,
		33,
		29,
		16,
		62,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		85,
		76,
		93,
		77,
		67,
		71,
		69,
		40,
		37,
		35,
		24,
		26,
		15,
		25,
		-1,
		-1,
		178,
		151,
		175,
		133,
		115,
		-1,
		81,
		81,
		75,
		71,
		65,
		58,
		71,
		56,
		-1,
		8,
		17,
		22,
		8,
		19,
		160,
		-1,
		-1,
		136,
		128,
		110,
		113,
		90,
		86,
		96,
		95,
		88,
		81,
		77,
		55,
		58,
		58,
		64,
		20,
		3,
		0,
		15,
		26,
		-1,
		-1,
		132,
		-1,
		-1,
		157,
		140,
		-1,
		105,
		112,
		96,
		102,
		88,
		109,
		106,
		97,
		91,
		86,
		78,
		53,
		50,
		63,
		42,
		17,
		10,
		13,
		18,
		36,
		37,
		-1,
		131,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		112,
		109,
		102,
		126,
		125,
		-1,
		126,
		114,
		115,
		100,
		99,
		93,
		81,
		58,
		42,
		42,
		39,
		24,
		26,
		52,
		20,
		41,
		38,
		69,
		107,
		101,
		110,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		130,
		-1,
		133,
		146,
		138,
		111,
		114,
		101,
		101,
		88,
		77,
		59,
		40,
		37,
		36,
		32,
		41,
		25,
		28,
		44,
		47,
		94,
		98,
		104,
		-1,
		215,
		-1,
		157,
		141,
		143,
		119,
		147,
		-1,
		150,
		134,
		154,
		140,
		140,
		-1,
		117,
		114,
		106,
		84,
		69,
		52,
		40,
		35,
		35,
		39,
		54,
		32,
		50,
		52,
		59,
		80,
		102,
		112,
		175,
		165,
		-1,
		147,
		152,
		122,
		134,
		154,
		177,
		156,
		-1,
		151,
		-1,
		119,
		132,
		-1,
		90,
		86,
		60,
		48,
		37,
		44,
		42,
		36,
		33,
		38,
		41,
		70,
		70,
		91,
		-1,
		-1,
		160,
		164,
		169,
		120,
		139,
		163,
		200,
		149,
		138,
		137,
		-1,
		128,
		96,
		93,
		90,
		77,
		62,
		60,
		43,
		49,
		50,
		35,
		38,
		47,
		88,
		66,
		78,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		146,
		117,
		141,
		183,
		167,
		160,
		148,
		113,
		113,
		107,
		-1,
		101,
		80,
		71,
		60,
		50,
		66,
		56,
		59,
		39,
		41,
		53,
		69,
		60,
		80,
		-1,
		-1,
		-1,
		176,
		165,
		166,
		112,
		135,
		172,
		146,
		132,
		137,
		112,
		105,
		99,
		105,
		97,
		78,
		67,
		59,
		48,
		57,
		67,
		61,
		41,
		50,
		51,
		75,
		82,
		88,
		-1,
		-1,
		183,
		173,
		157,
		159,
		156,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		88,
		72,
		67,
		64,
		61,
		55,
		64,
		69,
		55,
		46,
		61,
		80,
		80,
		72,
		97,
		100,
		-1,
		-1,
		-1,
		176,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		89,
		74,
		70,
		65,
		69,
		62,
		69,
		65,
		64,
		65,
		47,
		83,
		-1,
		80,
		74,
		102,
		105,
		95,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		74,
		72,
		66,
		70,
		74,
		63,
		76,
		72,
		52,
		62,
		82,
		86,
		93,
		86,
		91,
		90,
		104,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		80,
		78,
		94,
		78,
		81,
		81,
		77,
		85,
		70,
		69,
		55,
		59,
		77,
		104,
		99,
		94,
		93,
		100,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		90,
		86,
		101,
		102,
		80,
		85,
		84,
		94,
		91,
		80,
		67,
		71,
		86,
		96,
		88,
		89,
		98,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		100,
		98,
		91,
		82,
		88,
		95,
		98,
		95,
		85,
		74,
		80,
		76,
		98,
		84,
		82,
		101,
		116,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		99,
		83,
		88,
		-1,
		120,
		-1,
		93,
		93,
		84,
		73,
		70,
		81,
		79,
		90,
		107,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		115,
		95,
		89,
		88,
		115,
		110,
		101,
		82,
		75,
		72,
		73,
		86,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		132,
		120,
		110,
		100,
		134,
		126,
		101,
		94,
		80,
		82,
		80,
		82,
		87,
		108,
		109,
		122,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		140,
		111,
		121,
		-1,
		-1,
		112,
		110,
		118,
		97,
		84,
		104,
		107,
		97,
		81,
		96,
		108,
		116,
		121,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		143,
		138,
		142,
		115,
		-1,
		114,
		108,
		88,
		102,
		109,
		99,
		94,
		88,
		91,
		109,
		126,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		122,
		136,
		131,
		124,
		128,
		-1,
		116,
		104,
		90,
		107,
		112,
		109,
		100,
		92,
		97,
		94,
		107,
		121,
		125,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		140,
		155,
		170,
		147,
		120,
		115,
		108,
		102,
		98,
		114,
		120,
		131,
		99,
		95,
		96,
		100,
		99,
		116,
		126,
		-1,
		-1,
		154,
		171,
		166,
		148,
		152,
		197,
		-1,
		-1,
		124,
		115,
		106,
		109,
		108,
		111,
		105,
		102,
		107,
		112,
		100,
		109,
		127,
		126,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		167,
		195,
		142,
		124,
		120,
		118,
		111,
		120,
		115,
		110,
		120,
		122,
		114,
		102,
		106,
		129,
		118,
		157,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		206,
		187,
		194,
		157,
		154,
		-1,
		124,
		149,
		121,
		128,
		119,
		126,
		126,
		118,
		96,
		103,
		119,
		118,
		113,
		149,
		140,
		146,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		206,
		195,
		192,
		182,
		185,
		-1,
		-1,
		173,
		170,
		146,
		129,
		127,
		120,
		115,
		125,
		105,
		92,
		96,
		100,
		106,
		111,
		116,
		122,
		137,
		152,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		196,
		188,
		199,
		174,
		176,
		-1,
		-1,
		146,
		143,
		148,
		136,
		133,
		135,
		130,
		121,
		106,
		112,
		99,
		98,
		116,
		120,
		129,
		136,
		126,
		139,
		143,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		193,
		-1,
		-1,
		205,
		177,
		161,
		151,
		145,
		195,
		150,
		145,
		129,
		127,
		118,
		109,
		116,
		107,
		107,
		110,
		125,
		130,
		122,
		136,
		136,
		137,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		221,
		-1,
		188,
		-1,
		163,
		167,
		158,
		161,
		143,
		130,
		122,
		114,
		130,
		105,
		115,
		111,
		112,
		121,
		132,
		144,
		143,
		144,
		264,
		220,
		223,
		217,
		245,
		260,
		264,
		-1,
		205,
		244,
		242,
		-1,
		226,
		-1,
		-1,
		-1,
		177,
		171,
		163,
		163,
		142,
		142,
		116,
		120,
		110,
		117,
		127,
		129,
		121,
		125,
		138,
		149,
		152,
		260,
		251,
		264,
		209,
		209,
		230,
		239,
		260,
		220,
		211,
		238,
		249,
		238,
		233,
		220,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		149,
		137,
		120,
		121,
		117,
		120,
		135,
		138,
		128,
		126,
		120,
		152,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		200,
		227,
		-1,
		-1,
		222,
		239,
		233,
		237,
		253,
		278,
		-1,
		209,
		-1,
		-1,
		194,
		-1,
		-1,
		179,
		142,
		131,
		122,
		128,
		125,
		136,
		146,
		134,
		135,
		125,
		135,
		148,
		237,
		234,
		222,
		220,
		243,
		208,
		196,
		-1,
		209,
		207,
		213,
		220,
		237,
		267,
		-1,
		-1,
		225,
		205,
		-1,
		-1,
		177,
		175,
		164,
		-1,
		154,
		127,
		132,
		152,
		154,
		143,
		137,
		131,
		138,
		137,
		145,
		153,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		194,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		215,
		211,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		145,
		149,
		141,
		134,
		129,
		140,
		132,
		136,
		153,
		-1,
		280,
		-1,
		232,
		208,
		222,
		237,
		245,
		-1,
		-1,
		-1,
		232,
		218,
		211,
		199,
		197,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		185,
		153,
		158,
		153,
		135,
		146,
		135,
		138,
		152,
		147,
		-1,
		-1,
		220,
		223,
		-1,
		-1,
		222,
		224,
		-1,
		223,
		212,
		197,
		189,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		142,
		167,
		156,
		164,
		159,
		139,
		145,
		148,
		137,
		141,
		153,
		-1,
		-1,
		227,
		228,
		229,
		-1,
		207,
		-1,
		225,
		-1,
		192,
		198,
		186,
		-1,
		-1,
		-1,
		180,
		143,
		164,
		174,
		168,
		166,
		157,
		143,
		150,
		148,
		144,
		155,
		-1,
		-1,
		-1,
		225,
		199,
		232,
		223,
		206,
		186,
		178,
		197,
		-1,
		167,
		-1,
		142,
		144,
		170,
		173,
		179,
		173,
		146,
		161,
		151,
		142,
		151,
		231,
		-1,
		201,
		234,
		198,
		192,
		168,
		172,
		188,
		-1,
		164,
		146,
		-1,
		174,
		164,
		195,
		180,
		161,
		148,
		155,
		155,
		148,
		-1,
		-1,
		-1,
		203,
		202,
		194,
		188,
		188,
		173,
		164,
		-1,
		176,
		158,
		137,
		154,
		154,
		145,
		153,
		185,
		181,
		168,
		168,
		160,
		-1,
		304,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		197,
		192,
		165,
		153,
		159,
		155,
		141,
		147,
		149,
		157,
		155,
		152,
		164,
		160,
		180,
		161,
		196,
		-1,
		299,
		-1,
		233,
		-1,
		-1,
		215,
		195,
		187,
		176,
		165,
		163,
		154,
		145,
		167,
		183,
		167,
		165,
		168,
		169,
		-1,
		288,
		287,
		-1,
		234,
		226,
		212,
		-1,
		205,
		-1,
		211,
		172,
		-1,
		174,
		154,
		-1,
		176,
		172,
		-1,
		-1,
		275,
		250,
		-1,
		-1,
		-1,
		235,
		215,
		206,
		190,
		-1,
		165,
		165,
		-1,
		-1,
		-1,
		260,
		259,
		-1,
		228,
		231,
		-1,
		221,
		212,
		220,
		167,
		171,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		243,
		241,
		236,
		233,
		219,
		203,
		181,
		170,
		191,
		-1,
		-1,
		-1,
		241,
		233,
		226,
		-1,
		-1,
		228,
		211,
		192,
		190,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		218,
		-1,
		-1,
		224,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		252,
		-1,
		-1,
		-1,
		214,
		210,
		211,
		-1,
		-1,
		-1,
		-1,
		274,
		275,
		298,
		262,
		-1,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		277,
		275,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		204,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		239,
		-1,
		239,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		252,
		244,
		252,
		-1,
		224,
		226,
		-1,
		274,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		229,
		236,
		258,
		261,
		297,
		-1,
		248
	],
	[
		-1,
		135,
		124,
		135,
		143,
		116,
		123,
		-1,
		142,
		146,
		112,
		106,
		145,
		114,
		120,
		131,
		-1,
		-1,
		-1,
		135,
		134,
		102,
		100,
		109,
		114,
		121,
		-1,
		120,
		-1,
		156,
		135,
		146,
		151,
		95,
		92,
		112,
		131,
		113,
		105,
		171,
		125,
		96,
		90,
		108,
		98,
		107,
		99,
		-1,
		96,
		86,
		108,
		87,
		98,
		90,
		-1,
		-1,
		90,
		91,
		97,
		83,
		89,
		85,
		-1,
		83,
		56,
		-1,
		-1,
		80,
		81,
		65,
		68,
		76,
		74,
		79,
		65,
		51,
		-1,
		-1,
		71,
		67,
		74,
		61,
		57,
		74,
		82,
		51,
		38,
		36,
		-1,
		83,
		100,
		100,
		68,
		66,
		50,
		48,
		66,
		53,
		36,
		28,
		-1,
		100,
		96,
		97,
		95,
		90,
		66,
		53,
		53,
		63,
		47,
		30,
		17,
		63,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		92,
		109,
		93,
		83,
		87,
		85,
		56,
		53,
		51,
		40,
		33,
		16,
		26,
		-1,
		-1,
		194,
		167,
		191,
		149,
		131,
		-1,
		97,
		97,
		91,
		87,
		81,
		74,
		87,
		72,
		-1,
		24,
		33,
		23,
		9,
		20,
		176,
		-1,
		-1,
		152,
		144,
		126,
		129,
		106,
		102,
		112,
		111,
		104,
		97,
		93,
		71,
		74,
		74,
		80,
		36,
		19,
		16,
		0,
		27,
		-1,
		-1,
		119,
		-1,
		-1,
		173,
		156,
		-1,
		121,
		128,
		112,
		118,
		104,
		125,
		122,
		113,
		107,
		102,
		94,
		69,
		66,
		79,
		58,
		33,
		26,
		29,
		3,
		34,
		35,
		-1,
		118,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		128,
		125,
		118,
		142,
		141,
		-1,
		142,
		130,
		131,
		116,
		115,
		109,
		97,
		74,
		58,
		58,
		55,
		40,
		42,
		39,
		7,
		32,
		36,
		67,
		94,
		88,
		97,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		146,
		-1,
		149,
		162,
		154,
		127,
		130,
		117,
		117,
		104,
		93,
		75,
		56,
		53,
		52,
		44,
		57,
		12,
		15,
		31,
		45,
		81,
		85,
		91,
		-1,
		231,
		-1,
		173,
		157,
		159,
		135,
		163,
		-1,
		166,
		150,
		170,
		156,
		156,
		-1,
		133,
		130,
		122,
		100,
		85,
		68,
		56,
		51,
		51,
		39,
		44,
		19,
		37,
		39,
		53,
		67,
		89,
		99,
		191,
		181,
		-1,
		163,
		168,
		138,
		150,
		170,
		193,
		172,
		-1,
		167,
		-1,
		135,
		148,
		-1,
		106,
		102,
		76,
		64,
		53,
		60,
		50,
		35,
		32,
		25,
		28,
		57,
		58,
		83,
		-1,
		-1,
		176,
		180,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		112,
		109,
		106,
		93,
		78,
		76,
		59,
		65,
		49,
		34,
		37,
		34,
		76,
		62,
		74,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		117,
		96,
		87,
		76,
		66,
		82,
		55,
		58,
		38,
		40,
		40,
		65,
		56,
		76,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		121,
		113,
		94,
		83,
		75,
		64,
		56,
		66,
		60,
		40,
		49,
		47,
		71,
		78,
		84,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		104,
		88,
		83,
		80,
		74,
		61,
		71,
		68,
		54,
		45,
		60,
		76,
		76,
		68,
		93,
		96,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		90,
		86,
		78,
		82,
		76,
		75,
		71,
		63,
		64,
		46,
		81,
		-1,
		76,
		70,
		98,
		101,
		91,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		90,
		85,
		82,
		83,
		82,
		71,
		79,
		71,
		51,
		61,
		81,
		85,
		89,
		82,
		87,
		86,
		100,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		110,
		94,
		95,
		94,
		85,
		93,
		75,
		68,
		54,
		58,
		76,
		100,
		95,
		93,
		92,
		96,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		102,
		117,
		118,
		96,
		94,
		92,
		102,
		90,
		79,
		66,
		70,
		85,
		95,
		87,
		88,
		97,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		116,
		114,
		107,
		98,
		104,
		103,
		99,
		94,
		84,
		73,
		79,
		75,
		97,
		83,
		81,
		97,
		112,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		115,
		99,
		104,
		-1,
		119,
		-1,
		92,
		92,
		83,
		72,
		69,
		80,
		78,
		89,
		103,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		131,
		111,
		105,
		104,
		114,
		109,
		100,
		81,
		74,
		71,
		72,
		85,
		105,
		96,
		105,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		148,
		136,
		126,
		116,
		135,
		125,
		100,
		93,
		79,
		81,
		79,
		81,
		86,
		107,
		108,
		120,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		156,
		127,
		137,
		-1,
		-1,
		128,
		126,
		117,
		96,
		83,
		103,
		106,
		96,
		80,
		95,
		107,
		112,
		120,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		142,
		137,
		141,
		131,
		-1,
		113,
		107,
		87,
		101,
		108,
		98,
		93,
		87,
		90,
		108,
		123,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		138,
		152,
		130,
		123,
		127,
		-1,
		115,
		103,
		89,
		106,
		111,
		108,
		99,
		91,
		96,
		93,
		106,
		120,
		124,
		187,
		-1,
		170,
		-1,
		-1,
		-1,
		156,
		171,
		169,
		146,
		119,
		114,
		107,
		101,
		97,
		113,
		119,
		130,
		98,
		94,
		95,
		99,
		98,
		115,
		125,
		-1,
		-1,
		170,
		187,
		182,
		164,
		168,
		196,
		-1,
		-1,
		123,
		114,
		105,
		108,
		107,
		110,
		104,
		101,
		106,
		111,
		99,
		108,
		126,
		125,
		-1,
		-1,
		-1,
		190,
		-1,
		205,
		-1,
		-1,
		183,
		194,
		141,
		123,
		119,
		117,
		110,
		119,
		114,
		109,
		119,
		121,
		113,
		101,
		105,
		128,
		117,
		156,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		212,
		194,
		199,
		205,
		203,
		198,
		156,
		153,
		-1,
		123,
		148,
		120,
		127,
		118,
		125,
		125,
		117,
		95,
		102,
		118,
		117,
		112,
		148,
		139,
		145,
		-1,
		-1,
		302,
		291,
		280,
		286,
		-1,
		205,
		201,
		191,
		181,
		184,
		-1,
		-1,
		172,
		169,
		145,
		128,
		126,
		119,
		114,
		124,
		104,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		197,
		278,
		271,
		254,
		262,
		293,
		-1,
		195,
		187,
		198,
		173,
		175,
		-1,
		-1,
		145,
		142,
		147,
		135,
		132,
		134,
		129,
		120,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		211,
		254,
		248,
		251,
		275,
		289,
		-1,
		192,
		-1,
		-1,
		204,
		176,
		160,
		150,
		144,
		194,
		149,
		144,
		128,
		126,
		117,
		108,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		238,
		234,
		242,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		220,
		-1,
		187,
		-1,
		162,
		166,
		157,
		160,
		142,
		129,
		121,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		263,
		219,
		222,
		233,
		244,
		259,
		263,
		-1,
		204,
		243,
		241,
		-1,
		225,
		-1,
		-1,
		-1,
		176,
		170,
		162,
		162,
		141,
		141,
		115,
		119,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		259,
		250,
		263,
		208,
		208,
		229,
		238,
		259,
		219,
		210,
		237,
		248,
		237,
		232,
		219,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		148,
		136,
		119,
		120,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		199,
		226,
		-1,
		-1,
		221,
		238,
		232,
		236,
		252,
		277,
		-1,
		208,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		236,
		233,
		221,
		219,
		242,
		207,
		195,
		-1,
		208,
		206,
		212,
		219,
		236,
		266,
		-1,
		-1,
		224,
		204,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		151,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		193,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		214,
		210,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		144,
		148,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		279,
		-1,
		231,
		207,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		231,
		217,
		210,
		198,
		196,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		221,
		223,
		-1,
		222,
		211,
		196,
		188,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		226,
		227,
		228,
		-1,
		206,
		-1,
		224,
		-1,
		191,
		197,
		185,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		224,
		198,
		231,
		222,
		205,
		185,
		177,
		196,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		230,
		-1,
		200,
		233,
		197,
		191,
		167,
		171,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		194,
		179,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		202,
		201,
		193,
		187,
		187,
		172,
		163,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		184,
		180,
		167,
		167,
		159,
		-1,
		303,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		196,
		191,
		164,
		152,
		158,
		154,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		160,
		195,
		-1,
		298,
		-1,
		232,
		-1,
		-1,
		214,
		194,
		186,
		175,
		164,
		162,
		153,
		144,
		166,
		182,
		166,
		164,
		167,
		168,
		-1,
		287,
		286,
		-1,
		233,
		225,
		211,
		-1,
		204,
		-1,
		210,
		171,
		-1,
		173,
		153,
		-1,
		175,
		171,
		-1,
		-1,
		274,
		249,
		-1,
		-1,
		-1,
		234,
		214,
		205,
		189,
		-1,
		164,
		164,
		-1,
		-1,
		-1,
		259,
		258,
		-1,
		227,
		230,
		-1,
		220,
		211,
		219,
		166,
		170,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		242,
		240,
		235,
		232,
		218,
		202,
		180,
		169,
		190,
		-1,
		-1,
		-1,
		240,
		232,
		225,
		-1,
		-1,
		227,
		210,
		191,
		189,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		217,
		-1,
		-1,
		223,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		251,
		-1,
		-1,
		-1,
		213,
		209,
		210,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		297,
		261,
		-1,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		233,
		217,
		-1,
		203,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		238,
		-1,
		238,
		213,
		220,
		-1,
		-1,
		-1,
		-1,
		251,
		243,
		251,
		-1,
		223,
		225,
		-1,
		273,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		228,
		235,
		257,
		260,
		296,
		-1,
		247
	],
	[
		-1,
		149,
		138,
		149,
		157,
		130,
		137,
		-1,
		156,
		160,
		126,
		120,
		159,
		128,
		134,
		145,
		-1,
		-1,
		-1,
		149,
		148,
		116,
		114,
		123,
		128,
		135,
		-1,
		134,
		-1,
		170,
		149,
		160,
		165,
		109,
		106,
		126,
		145,
		127,
		119,
		185,
		139,
		110,
		104,
		122,
		112,
		121,
		113,
		-1,
		110,
		100,
		122,
		101,
		112,
		104,
		-1,
		-1,
		104,
		105,
		111,
		97,
		103,
		99,
		-1,
		97,
		70,
		-1,
		-1,
		94,
		95,
		79,
		82,
		90,
		88,
		93,
		79,
		65,
		-1,
		-1,
		85,
		81,
		88,
		75,
		71,
		88,
		96,
		65,
		52,
		50,
		-1,
		97,
		114,
		114,
		82,
		80,
		64,
		62,
		80,
		67,
		50,
		42,
		-1,
		114,
		110,
		111,
		109,
		104,
		80,
		67,
		67,
		77,
		61,
		44,
		31,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		115,
		106,
		123,
		107,
		97,
		101,
		99,
		70,
		67,
		65,
		54,
		47,
		30,
		34,
		-1,
		-1,
		208,
		181,
		205,
		163,
		145,
		-1,
		111,
		111,
		105,
		101,
		95,
		88,
		101,
		86,
		-1,
		38,
		47,
		37,
		23,
		28,
		190,
		-1,
		-1,
		166,
		158,
		140,
		143,
		120,
		116,
		126,
		125,
		118,
		111,
		107,
		85,
		88,
		88,
		94,
		50,
		33,
		30,
		30,
		0,
		-1,
		-1,
		108,
		-1,
		-1,
		187,
		170,
		-1,
		135,
		142,
		126,
		132,
		118,
		139,
		136,
		127,
		121,
		116,
		108,
		83,
		80,
		93,
		72,
		47,
		38,
		41,
		33,
		10,
		11,
		-1,
		107,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		142,
		139,
		132,
		156,
		155,
		-1,
		156,
		144,
		145,
		130,
		129,
		123,
		111,
		88,
		72,
		72,
		69,
		54,
		56,
		67,
		35,
		15,
		12,
		43,
		83,
		77,
		86,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		160,
		-1,
		163,
		176,
		168,
		141,
		144,
		131,
		131,
		118,
		107,
		89,
		70,
		67,
		66,
		62,
		71,
		40,
		43,
		27,
		21,
		70,
		74,
		80,
		-1,
		245,
		-1,
		187,
		171,
		173,
		149,
		177,
		-1,
		180,
		164,
		184,
		170,
		170,
		-1,
		147,
		144,
		136,
		114,
		99,
		82,
		70,
		65,
		65,
		64,
		69,
		44,
		38,
		35,
		33,
		56,
		78,
		88,
		205,
		195,
		-1,
		177,
		182,
		152,
		164,
		184,
		207,
		186,
		-1,
		181,
		-1,
		149,
		162,
		-1,
		120,
		116,
		90,
		78,
		67,
		74,
		72,
		60,
		57,
		36,
		39,
		46,
		44,
		72,
		-1,
		-1,
		190,
		194,
		199,
		150,
		169,
		193,
		230,
		179,
		168,
		167,
		-1,
		158,
		126,
		123,
		120,
		107,
		92,
		90,
		73,
		79,
		74,
		59,
		62,
		45,
		65,
		49,
		74,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		176,
		147,
		171,
		213,
		197,
		190,
		178,
		143,
		143,
		137,
		-1,
		131,
		110,
		101,
		90,
		80,
		96,
		80,
		83,
		63,
		65,
		51,
		63,
		56,
		76,
		-1,
		-1,
		-1,
		206,
		195,
		196,
		142,
		165,
		202,
		176,
		162,
		167,
		142,
		135,
		129,
		135,
		127,
		108,
		97,
		89,
		78,
		81,
		91,
		85,
		65,
		74,
		58,
		71,
		78,
		84,
		-1,
		-1,
		213,
		203,
		187,
		189,
		186,
		156,
		163,
		195,
		167,
		180,
		-1,
		134,
		-1,
		123,
		118,
		102,
		97,
		94,
		91,
		85,
		94,
		93,
		79,
		70,
		85,
		76,
		76,
		68,
		93,
		96,
		-1,
		-1,
		-1,
		206,
		201,
		176,
		153,
		137,
		173,
		-1,
		150,
		151,
		-1,
		128,
		122,
		119,
		104,
		100,
		95,
		99,
		92,
		99,
		95,
		88,
		89,
		71,
		92,
		-1,
		76,
		70,
		98,
		101,
		91,
		-1,
		-1,
		-1,
		199,
		178,
		171,
		191,
		132,
		184,
		-1,
		-1,
		135,
		128,
		-1,
		115,
		97,
		104,
		102,
		96,
		100,
		104,
		93,
		104,
		96,
		76,
		86,
		106,
		91,
		89,
		82,
		87,
		86,
		100,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		152,
		-1,
		144,
		136,
		126,
		120,
		114,
		110,
		108,
		124,
		108,
		111,
		111,
		107,
		115,
		100,
		93,
		79,
		83,
		101,
		100,
		95,
		101,
		93,
		96,
		-1,
		219,
		205,
		176,
		-1,
		-1,
		165,
		-1,
		129,
		143,
		159,
		-1,
		152,
		131,
		146,
		124,
		120,
		116,
		131,
		132,
		110,
		115,
		114,
		124,
		115,
		104,
		91,
		95,
		110,
		110,
		96,
		96,
		98,
		-1,
		225,
		212,
		170,
		166,
		155,
		175,
		126,
		114,
		146,
		-1,
		-1,
		188,
		-1,
		122,
		139,
		130,
		128,
		121,
		112,
		118,
		125,
		124,
		119,
		109,
		98,
		104,
		100,
		118,
		104,
		102,
		97,
		112,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		141,
		128,
		122,
		-1,
		163,
		-1,
		166,
		156,
		140,
		125,
		158,
		-1,
		129,
		113,
		118,
		-1,
		144,
		-1,
		117,
		117,
		108,
		97,
		94,
		105,
		103,
		114,
		103,
		-1,
		175,
		160,
		153,
		143,
		157,
		128,
		-1,
		183,
		-1,
		-1,
		153,
		147,
		147,
		131,
		134,
		145,
		125,
		119,
		118,
		139,
		134,
		125,
		106,
		99,
		96,
		97,
		110,
		130,
		117,
		105,
		-1,
		-1,
		-1,
		180,
		166,
		170,
		130,
		149,
		-1,
		-1,
		215,
		170,
		156,
		-1,
		140,
		162,
		150,
		140,
		130,
		160,
		150,
		125,
		118,
		104,
		106,
		104,
		106,
		111,
		118,
		110,
		120,
		-1,
		-1,
		163,
		168,
		156,
		142,
		161,
		-1,
		-1,
		-1,
		162,
		178,
		170,
		141,
		151,
		-1,
		-1,
		142,
		140,
		142,
		121,
		108,
		128,
		131,
		121,
		105,
		120,
		124,
		112,
		121,
		-1,
		166,
		153,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		-1,
		-1,
		195,
		161,
		167,
		162,
		166,
		145,
		-1,
		138,
		132,
		112,
		126,
		133,
		123,
		118,
		112,
		115,
		129,
		123,
		-1,
		-1,
		178,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		152,
		166,
		155,
		148,
		152,
		-1,
		140,
		128,
		114,
		131,
		136,
		133,
		124,
		116,
		121,
		118,
		131,
		135,
		125,
		201,
		-1,
		184,
		-1,
		-1,
		-1,
		170,
		185,
		194,
		171,
		144,
		139,
		132,
		126,
		122,
		138,
		144,
		155,
		123,
		119,
		120,
		124,
		123,
		139,
		140,
		-1,
		-1,
		184,
		201,
		196,
		178,
		182,
		221,
		-1,
		-1,
		148,
		139,
		130,
		133,
		132,
		135,
		129,
		126,
		131,
		136,
		124,
		133,
		151,
		143,
		-1,
		-1,
		-1,
		204,
		-1,
		219,
		-1,
		-1,
		197,
		219,
		166,
		148,
		144,
		142,
		135,
		144,
		139,
		134,
		144,
		146,
		138,
		126,
		130,
		153,
		142,
		172,
		-1,
		-1,
		323,
		-1,
		-1,
		-1,
		233,
		208,
		223,
		230,
		217,
		223,
		181,
		178,
		-1,
		148,
		173,
		145,
		152,
		143,
		150,
		150,
		142,
		120,
		127,
		143,
		142,
		137,
		164,
		159,
		168,
		-1,
		-1,
		316,
		305,
		294,
		300,
		-1,
		230,
		225,
		216,
		206,
		209,
		-1,
		-1,
		197,
		194,
		170,
		153,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		174,
		-1,
		211,
		292,
		285,
		268,
		276,
		307,
		-1,
		220,
		212,
		223,
		198,
		200,
		-1,
		-1,
		170,
		167,
		172,
		160,
		157,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		225,
		268,
		262,
		265,
		289,
		303,
		-1,
		217,
		-1,
		-1,
		229,
		201,
		185,
		175,
		169,
		219,
		174,
		169,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		260,
		248,
		256,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		245,
		-1,
		212,
		-1,
		187,
		191,
		182,
		185,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		288,
		244,
		247,
		247,
		269,
		284,
		288,
		-1,
		229,
		268,
		266,
		-1,
		250,
		-1,
		-1,
		-1,
		201,
		195,
		187,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		284,
		275,
		288,
		233,
		233,
		254,
		263,
		284,
		244,
		235,
		262,
		273,
		262,
		257,
		244,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		224,
		251,
		-1,
		-1,
		246,
		263,
		257,
		261,
		277,
		302,
		-1,
		233,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		261,
		258,
		246,
		244,
		267,
		232,
		220,
		-1,
		233,
		231,
		237,
		244,
		261,
		291,
		-1,
		-1,
		249,
		229,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		218,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		235,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		304,
		-1,
		256,
		232,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		251,
		252,
		253,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		219,
		208,
		219,
		227,
		200,
		207,
		-1,
		226,
		230,
		196,
		190,
		229,
		198,
		204,
		215,
		-1,
		-1,
		-1,
		219,
		218,
		186,
		184,
		193,
		198,
		205,
		-1,
		204,
		-1,
		240,
		219,
		230,
		235,
		179,
		176,
		196,
		215,
		197,
		189,
		255,
		209,
		180,
		174,
		192,
		182,
		191,
		183,
		-1,
		180,
		170,
		192,
		171,
		182,
		174,
		-1,
		-1,
		174,
		175,
		181,
		167,
		173,
		169,
		-1,
		179,
		163,
		-1,
		-1,
		164,
		165,
		149,
		152,
		160,
		158,
		171,
		163,
		158,
		-1,
		-1,
		155,
		151,
		158,
		145,
		141,
		158,
		171,
		153,
		145,
		143,
		-1,
		167,
		184,
		184,
		152,
		150,
		134,
		132,
		150,
		152,
		143,
		135,
		-1,
		184,
		180,
		181,
		179,
		174,
		150,
		137,
		137,
		147,
		140,
		137,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		185,
		176,
		193,
		177,
		167,
		171,
		169,
		140,
		137,
		135,
		132,
		140,
		123,
		133,
		-1,
		-1,
		278,
		251,
		275,
		233,
		215,
		-1,
		181,
		181,
		175,
		171,
		165,
		158,
		171,
		156,
		-1,
		126,
		125,
		130,
		116,
		127,
		260,
		-1,
		-1,
		236,
		228,
		210,
		213,
		190,
		186,
		196,
		195,
		188,
		176,
		172,
		155,
		158,
		158,
		164,
		120,
		126,
		123,
		109,
		107,
		-1,
		-1,
		0,
		-1,
		-1,
		257,
		240,
		-1,
		205,
		212,
		196,
		202,
		188,
		209,
		206,
		197,
		191,
		186,
		174,
		153,
		150,
		163,
		142,
		117,
		133,
		136,
		104,
		97,
		92,
		-1,
		4,
		25,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		212,
		209,
		202,
		226,
		225,
		-1,
		221,
		209,
		210,
		195,
		192,
		179,
		167,
		158,
		142,
		142,
		139,
		121,
		119,
		129,
		101,
		96,
		86,
		74,
		38,
		41,
		50,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		230,
		-1,
		233,
		246,
		233,
		206,
		209,
		196,
		187,
		174,
		163,
		159,
		140,
		137,
		133,
		113,
		128,
		106,
		107,
		75,
		75,
		66,
		38,
		44,
		-1,
		315,
		-1,
		257,
		241,
		243,
		216,
		237,
		-1,
		250,
		234,
		250,
		235,
		235,
		-1,
		205,
		202,
		192,
		170,
		155,
		152,
		140,
		135,
		126,
		108,
		122,
		102,
		88,
		79,
		65,
		52,
		42,
		52,
		275,
		265,
		-1,
		247,
		252,
		212,
		220,
		239,
		277,
		241,
		-1,
		236,
		-1,
		207,
		220,
		-1,
		176,
		172,
		154,
		148,
		137,
		144,
		119,
		104,
		101,
		94,
		97,
		61,
		62,
		53,
		-1,
		-1,
		260,
		264,
		254,
		205,
		224,
		248,
		285,
		234,
		223,
		222,
		-1,
		213,
		190,
		187,
		175,
		162,
		147,
		148,
		143,
		139,
		118,
		103,
		105,
		95,
		80,
		67,
		92,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		231,
		202,
		226,
		268,
		252,
		245,
		233,
		198,
		198,
		192,
		-1,
		186,
		165,
		156,
		145,
		143,
		151,
		124,
		119,
		103,
		101,
		90,
		78,
		74,
		94,
		-1,
		-1,
		-1,
		261,
		250,
		251,
		197,
		220,
		257,
		231,
		217,
		222,
		197,
		190,
		184,
		199,
		182,
		163,
		152,
		144,
		133,
		125,
		131,
		123,
		99,
		104,
		84,
		89,
		96,
		102,
		-1,
		-1,
		268,
		258,
		242,
		244,
		241,
		211,
		218,
		250,
		222,
		235,
		-1,
		189,
		-1,
		178,
		173,
		157,
		152,
		149,
		143,
		130,
		130,
		128,
		109,
		104,
		116,
		94,
		94,
		86,
		111,
		114,
		-1,
		-1,
		-1,
		261,
		256,
		231,
		208,
		192,
		228,
		-1,
		205,
		206,
		-1,
		183,
		177,
		174,
		159,
		155,
		147,
		151,
		145,
		140,
		130,
		122,
		123,
		105,
		118,
		-1,
		94,
		88,
		116,
		119,
		109,
		-1,
		-1,
		-1,
		254,
		233,
		226,
		246,
		187,
		239,
		-1,
		-1,
		190,
		183,
		-1,
		170,
		152,
		159,
		154,
		151,
		152,
		143,
		132,
		138,
		130,
		110,
		120,
		132,
		109,
		107,
		100,
		105,
		104,
		118,
		-1,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		207,
		-1,
		199,
		191,
		181,
		175,
		169,
		165,
		163,
		179,
		163,
		164,
		155,
		146,
		154,
		134,
		127,
		113,
		117,
		127,
		118,
		113,
		119,
		111,
		114,
		-1,
		274,
		260,
		231,
		-1,
		-1,
		220,
		-1,
		184,
		198,
		214,
		-1,
		207,
		186,
		201,
		179,
		175,
		171,
		186,
		187,
		165,
		155,
		153,
		161,
		149,
		138,
		125,
		129,
		131,
		128,
		114,
		114,
		116,
		-1,
		280,
		267,
		225,
		221,
		210,
		230,
		181,
		169,
		201,
		-1,
		-1,
		243,
		-1,
		177,
		194,
		185,
		183,
		176,
		167,
		173,
		164,
		158,
		153,
		143,
		132,
		138,
		134,
		136,
		122,
		120,
		115,
		130,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		196,
		183,
		177,
		-1,
		218,
		-1,
		221,
		211,
		195,
		180,
		213,
		-1,
		184,
		168,
		173,
		-1,
		178,
		-1,
		151,
		151,
		142,
		131,
		128,
		132,
		123,
		136,
		121,
		-1,
		230,
		215,
		208,
		198,
		212,
		183,
		-1,
		238,
		-1,
		-1,
		208,
		202,
		202,
		186,
		189,
		200,
		180,
		174,
		173,
		173,
		168,
		159,
		140,
		133,
		130,
		131,
		144,
		156,
		135,
		123,
		-1,
		-1,
		-1,
		235,
		221,
		225,
		185,
		204,
		-1,
		-1,
		270,
		225,
		211,
		-1,
		195,
		217,
		205,
		195,
		185,
		194,
		184,
		159,
		152,
		138,
		140,
		138,
		140,
		145,
		136,
		128,
		138,
		-1,
		-1,
		218,
		223,
		211,
		197,
		216,
		-1,
		-1,
		-1,
		217,
		233,
		225,
		196,
		206,
		-1,
		-1,
		195,
		186,
		176,
		155,
		142,
		162,
		165,
		155,
		139,
		152,
		142,
		130,
		139,
		-1,
		221,
		208,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		-1,
		-1,
		250,
		212,
		201,
		196,
		200,
		194,
		-1,
		172,
		166,
		146,
		160,
		167,
		157,
		152,
		146,
		147,
		147,
		141,
		-1,
		-1,
		233,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		207,
		218,
		189,
		182,
		186,
		-1,
		174,
		162,
		148,
		165,
		170,
		167,
		158,
		150,
		155,
		144,
		157,
		153,
		143,
		256,
		-1,
		239,
		-1,
		-1,
		-1,
		225,
		240,
		228,
		205,
		178,
		173,
		166,
		160,
		156,
		172,
		178,
		189,
		157,
		153,
		154,
		150,
		149,
		157,
		158,
		-1,
		-1,
		239,
		256,
		251,
		233,
		237,
		255,
		-1,
		-1,
		182,
		173,
		164,
		167,
		166,
		169,
		163,
		160,
		165,
		167,
		158,
		159,
		176,
		161,
		-1,
		-1,
		-1,
		259,
		-1,
		274,
		-1,
		-1,
		252,
		253,
		200,
		182,
		178,
		176,
		169,
		178,
		173,
		168,
		178,
		180,
		172,
		157,
		164,
		187,
		169,
		190,
		-1,
		-1,
		368,
		-1,
		-1,
		-1,
		271,
		263,
		258,
		264,
		266,
		257,
		215,
		212,
		-1,
		182,
		207,
		179,
		186,
		177,
		184,
		184,
		176,
		154,
		161,
		177,
		176,
		171,
		182,
		177,
		186,
		-1,
		-1,
		361,
		350,
		339,
		345,
		-1,
		264,
		260,
		250,
		240,
		243,
		-1,
		-1,
		231,
		228,
		204,
		187,
		185,
		178,
		173,
		183,
		163,
		150,
		154,
		158,
		164,
		169,
		174,
		180,
		184,
		192,
		-1,
		266,
		347,
		340,
		313,
		321,
		352,
		-1,
		254,
		246,
		257,
		232,
		234,
		-1,
		-1,
		204,
		201,
		206,
		194,
		191,
		193,
		188,
		179,
		164,
		170,
		157,
		156,
		174,
		178,
		187,
		194,
		184,
		197,
		201,
		-1,
		280,
		323,
		307,
		310,
		334,
		348,
		-1,
		251,
		-1,
		-1,
		263,
		235,
		219,
		209,
		203,
		253,
		208,
		203,
		187,
		185,
		176,
		167,
		174,
		165,
		165,
		168,
		183,
		188,
		180,
		194,
		194,
		195,
		-1,
		297,
		303,
		301,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		279,
		-1,
		246,
		-1,
		221,
		225,
		216,
		219,
		201,
		188,
		180,
		172,
		188,
		163,
		173,
		169,
		170,
		179,
		190,
		202,
		201,
		202,
		322,
		278,
		281,
		292,
		303,
		318,
		322,
		-1,
		263,
		302,
		300,
		-1,
		284,
		-1,
		-1,
		-1,
		235,
		229,
		221,
		221,
		200,
		200,
		174,
		178,
		168,
		175,
		185,
		187,
		179,
		183,
		196,
		207,
		210,
		318,
		309,
		322,
		267,
		267,
		288,
		297,
		318,
		278,
		269,
		296,
		307,
		296,
		291,
		278,
		-1,
		-1,
		258,
		239,
		-1,
		-1,
		207,
		195,
		178,
		179,
		175,
		178,
		193,
		196,
		186,
		184,
		178,
		210,
		-1,
		311,
		310,
		299,
		296,
		272,
		263,
		258,
		285,
		-1,
		-1,
		280,
		297,
		291,
		295,
		311,
		336,
		-1,
		267,
		-1,
		-1,
		252,
		-1,
		-1,
		237,
		200,
		189,
		180,
		186,
		183,
		194,
		204,
		192,
		193,
		183,
		193,
		206,
		295,
		292,
		280,
		278,
		301,
		266,
		254,
		-1,
		267,
		265,
		271,
		278,
		295,
		325,
		-1,
		-1,
		283,
		263,
		-1,
		-1,
		235,
		233,
		222,
		-1,
		212,
		185,
		190,
		210,
		212,
		201,
		195,
		189,
		196,
		195,
		203,
		211,
		304,
		318,
		307,
		303,
		302,
		310,
		259,
		252,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		-1,
		273,
		269,
		-1,
		-1,
		230,
		223,
		211,
		199,
		189,
		199,
		203,
		207,
		199,
		192,
		187,
		198,
		190,
		194,
		211,
		-1,
		338,
		-1,
		290,
		266,
		280,
		295,
		303,
		-1,
		-1,
		-1,
		290,
		276,
		269,
		257,
		255,
		-1,
		264,
		248,
		229,
		-1,
		199,
		212,
		243,
		211,
		216,
		211,
		193,
		204,
		193,
		196,
		210,
		205,
		-1,
		-1,
		278,
		281,
		-1,
		-1,
		280,
		282,
		-1,
		281,
		270,
		255,
		247,
		-1,
		-1,
		236,
		232,
		-1,
		-1,
		200,
		225,
		214,
		222,
		217,
		197,
		203,
		206,
		195,
		199,
		211,
		-1,
		-1,
		285,
		286,
		287,
		-1,
		265,
		-1,
		283,
		-1,
		250,
		256,
		244,
		-1,
		-1,
		-1,
		238,
		201,
		222,
		232,
		226,
		224,
		215,
		201,
		208,
		206,
		202,
		213,
		-1,
		-1,
		-1,
		283,
		257,
		290,
		281,
		264,
		244,
		236,
		255,
		-1,
		225,
		-1,
		200,
		202,
		228,
		231,
		237,
		231,
		204,
		219,
		209,
		200,
		209,
		289,
		-1,
		259,
		292,
		256,
		250,
		226,
		230,
		246,
		-1,
		222,
		204,
		-1,
		232,
		222,
		253,
		238,
		219,
		206,
		213,
		213,
		206,
		-1,
		-1,
		-1,
		261,
		260,
		252,
		246,
		246,
		231,
		222,
		-1,
		234,
		216,
		195,
		212,
		212,
		203,
		211,
		243,
		239,
		226,
		226,
		218,
		-1,
		362,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		255,
		250,
		223,
		211,
		217,
		213,
		199,
		205,
		207,
		215,
		213,
		210,
		222,
		218,
		238,
		219,
		254,
		-1,
		357,
		-1,
		291,
		-1,
		-1,
		273,
		253,
		245,
		234,
		223,
		221,
		212,
		203,
		225,
		241,
		225,
		223,
		226,
		227,
		-1,
		346,
		345,
		-1,
		292,
		284,
		270,
		-1,
		263,
		-1,
		269,
		230,
		-1,
		232,
		212,
		-1,
		234,
		230,
		-1,
		-1,
		333,
		308,
		-1,
		-1,
		-1,
		293,
		273,
		264,
		248,
		-1,
		223,
		223,
		-1,
		-1,
		-1,
		318,
		317,
		-1,
		286,
		289,
		-1,
		279,
		270,
		278,
		225,
		229,
		-1,
		-1,
		-1,
		327,
		308,
		302,
		301,
		299,
		294,
		291,
		277,
		261,
		239,
		228,
		249,
		-1,
		-1,
		-1,
		299,
		291,
		284,
		-1,
		-1,
		286,
		269,
		250,
		248,
		-1,
		-1,
		-1,
		321,
		302,
		-1,
		-1,
		276,
		-1,
		-1,
		282,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		338,
		310,
		-1,
		-1,
		-1,
		272,
		268,
		269,
		-1,
		-1,
		-1,
		-1,
		332,
		333,
		356,
		320,
		-1,
		-1,
		-1,
		264,
		258,
		-1,
		-1,
		335,
		333,
		-1,
		-1,
		-1,
		292,
		276,
		-1,
		262,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		297,
		-1,
		297,
		272,
		279,
		-1,
		-1,
		-1,
		-1,
		310,
		302,
		310,
		-1,
		282,
		284,
		-1,
		332,
		-1,
		-1,
		325,
		316,
		-1,
		-1,
		287,
		294,
		316,
		319,
		355,
		-1,
		306
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		156,
		145,
		156,
		164,
		137,
		144,
		-1,
		165,
		167,
		133,
		127,
		166,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		156,
		155,
		125,
		123,
		132,
		137,
		144,
		-1,
		167,
		-1,
		177,
		156,
		167,
		172,
		118,
		115,
		135,
		154,
		160,
		152,
		192,
		148,
		119,
		113,
		131,
		136,
		154,
		146,
		-1,
		119,
		109,
		131,
		135,
		147,
		130,
		-1,
		-1,
		113,
		114,
		120,
		132,
		137,
		142,
		-1,
		168,
		187,
		-1,
		-1,
		103,
		116,
		112,
		115,
		123,
		139,
		160,
		177,
		182,
		-1,
		-1,
		104,
		108,
		121,
		122,
		120,
		147,
		166,
		177,
		191,
		190,
		-1,
		92,
		110,
		119,
		128,
		134,
		123,
		127,
		145,
		176,
		182,
		185,
		-1,
		84,
		86,
		115,
		121,
		133,
		139,
		126,
		132,
		151,
		164,
		183,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		81,
		89,
		115,
		114,
		110,
		128,
		150,
		129,
		135,
		139,
		156,
		172,
		173,
		183,
		-1,
		-1,
		132,
		101,
		136,
		93,
		78,
		-1,
		77,
		96,
		102,
		106,
		111,
		119,
		147,
		145,
		-1,
		150,
		149,
		180,
		166,
		177,
		20,
		-1,
		-1,
		90,
		82,
		67,
		70,
		67,
		72,
		102,
		101,
		106,
		108,
		110,
		122,
		137,
		137,
		147,
		144,
		154,
		158,
		173,
		184,
		-1,
		-1,
		258,
		-1,
		-1,
		0,
		41,
		-1,
		55,
		62,
		62,
		79,
		70,
		95,
		110,
		114,
		122,
		125,
		113,
		132,
		129,
		153,
		149,
		141,
		166,
		170,
		176,
		194,
		195,
		-1,
		257,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		36,
		48,
		51,
		57,
		81,
		91,
		-1,
		117,
		115,
		139,
		133,
		138,
		134,
		119,
		137,
		135,
		150,
		152,
		148,
		150,
		187,
		178,
		199,
		196,
		227,
		233,
		227,
		236,
		-1,
		92,
		88,
		84,
		91,
		45,
		-1,
		-1,
		85,
		-1,
		99,
		112,
		129,
		119,
		122,
		134,
		142,
		141,
		125,
		143,
		138,
		141,
		160,
		156,
		165,
		175,
		174,
		192,
		205,
		220,
		224,
		230,
		-1,
		142,
		-1,
		84,
		68,
		69,
		51,
		79,
		-1,
		105,
		100,
		120,
		131,
		131,
		-1,
		147,
		144,
		157,
		141,
		126,
		143,
		145,
		149,
		159,
		163,
		178,
		169,
		187,
		194,
		202,
		206,
		226,
		238,
		102,
		92,
		-1,
		76,
		81,
		54,
		66,
		102,
		143,
		127,
		-1,
		142,
		-1,
		149,
		162,
		-1,
		147,
		143,
		132,
		148,
		156,
		163,
		166,
		160,
		157,
		175,
		178,
		195,
		199,
		215,
		-1,
		-1,
		89,
		93,
		117,
		60,
		87,
		111,
		148,
		136,
		145,
		147,
		-1,
		167,
		168,
		165,
		166,
		152,
		145,
		146,
		162,
		168,
		160,
		159,
		162,
		184,
		212,
		190,
		202,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		94,
		65,
		89,
		131,
		175,
		168,
		156,
		154,
		154,
		148,
		-1,
		183,
		162,
		159,
		150,
		155,
		168,
		163,
		179,
		163,
		165,
		181,
		193,
		184,
		204,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		68,
		102,
		120,
		187,
		173,
		178,
		153,
		146,
		140,
		177,
		179,
		156,
		164,
		156,
		145,
		159,
		167,
		171,
		165,
		174,
		175,
		199,
		206,
		212,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		93,
		100,
		132,
		178,
		175,
		-1,
		145,
		-1,
		134,
		142,
		141,
		147,
		159,
		145,
		150,
		161,
		173,
		179,
		170,
		185,
		204,
		204,
		196,
		221,
		224,
		-1,
		-1,
		-1,
		124,
		141,
		116,
		93,
		74,
		110,
		-1,
		145,
		146,
		-1,
		139,
		133,
		139,
		138,
		145,
		142,
		142,
		156,
		164,
		160,
		176,
		182,
		171,
		207,
		-1,
		204,
		198,
		219,
		209,
		197,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		81,
		133,
		-1,
		-1,
		130,
		123,
		-1,
		126,
		126,
		133,
		142,
		147,
		152,
		160,
		155,
		168,
		173,
		176,
		184,
		202,
		206,
		210,
		199,
		195,
		192,
		206,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		101,
		-1,
		138,
		130,
		121,
		115,
		121,
		139,
		137,
		157,
		149,
		163,
		163,
		169,
		177,
		162,
		165,
		179,
		179,
		197,
		205,
		197,
		191,
		190,
		202,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		116,
		-1,
		87,
		111,
		127,
		-1,
		155,
		134,
		157,
		135,
		149,
		145,
		183,
		184,
		162,
		167,
		175,
		185,
		187,
		176,
		187,
		179,
		201,
		201,
		185,
		186,
		195,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		90,
		103,
		114,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		159,
		157,
		173,
		164,
		170,
		186,
		189,
		191,
		181,
		170,
		176,
		173,
		195,
		181,
		179,
		198,
		214,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		181,
		165,
		170,
		-1,
		216,
		-1,
		189,
		191,
		185,
		170,
		167,
		178,
		176,
		187,
		204,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		147,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		197,
		177,
		171,
		170,
		211,
		211,
		197,
		183,
		176,
		173,
		170,
		183,
		203,
		194,
		206,
		-1,
		-1,
		-1,
		148,
		128,
		134,
		92,
		113,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		214,
		202,
		192,
		182,
		216,
		217,
		202,
		195,
		181,
		183,
		181,
		179,
		184,
		205,
		206,
		219,
		-1,
		-1,
		125,
		132,
		120,
		106,
		125,
		-1,
		-1,
		-1,
		173,
		189,
		181,
		152,
		203,
		-1,
		-1,
		194,
		192,
		202,
		198,
		185,
		205,
		208,
		194,
		178,
		193,
		205,
		213,
		218,
		-1,
		128,
		115,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		184,
		205,
		230,
		197,
		-1,
		202,
		203,
		189,
		203,
		210,
		196,
		191,
		185,
		188,
		206,
		223,
		-1,
		-1,
		142,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		163,
		177,
		198,
		204,
		216,
		-1,
		211,
		205,
		191,
		208,
		209,
		206,
		197,
		189,
		194,
		191,
		204,
		218,
		222,
		165,
		-1,
		148,
		-1,
		-1,
		-1,
		181,
		196,
		258,
		235,
		208,
		212,
		205,
		199,
		199,
		215,
		217,
		228,
		196,
		192,
		193,
		197,
		196,
		213,
		223,
		-1,
		-1,
		148,
		165,
		200,
		189,
		193,
		285,
		-1,
		-1,
		221,
		212,
		203,
		206,
		209,
		212,
		202,
		199,
		204,
		209,
		197,
		206,
		224,
		228,
		-1,
		-1,
		-1,
		168,
		-1,
		183,
		-1,
		-1,
		208,
		292,
		239,
		221,
		217,
		215,
		208,
		217,
		212,
		207,
		217,
		226,
		218,
		199,
		210,
		233,
		222,
		260,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		197,
		172,
		187,
		233,
		228,
		229,
		254,
		251,
		-1,
		221,
		246,
		218,
		225,
		217,
		225,
		225,
		222,
		200,
		207,
		223,
		222,
		217,
		252,
		244,
		250,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		203,
		189,
		219,
		209,
		215,
		-1,
		-1,
		262,
		259,
		243,
		227,
		231,
		224,
		219,
		229,
		209,
		196,
		200,
		204,
		210,
		215,
		220,
		226,
		241,
		256,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		206,
		215,
		196,
		201,
		209,
		-1,
		-1,
		235,
		231,
		236,
		234,
		231,
		239,
		234,
		225,
		210,
		216,
		203,
		202,
		220,
		224,
		233,
		240,
		230,
		243,
		247,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		219,
		-1,
		-1,
		204,
		222,
		230,
		226,
		230,
		283,
		248,
		243,
		233,
		231,
		222,
		213,
		220,
		211,
		211,
		214,
		229,
		234,
		226,
		240,
		240,
		241,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		220,
		-1,
		256,
		-1,
		249,
		253,
		256,
		259,
		247,
		234,
		226,
		218,
		234,
		209,
		219,
		215,
		216,
		225,
		236,
		248,
		247,
		248,
		296,
		251,
		218,
		209,
		256,
		271,
		275,
		-1,
		232,
		271,
		258,
		-1,
		229,
		-1,
		-1,
		-1,
		263,
		269,
		261,
		267,
		246,
		246,
		220,
		224,
		214,
		221,
		231,
		233,
		225,
		229,
		242,
		253,
		256,
		292,
		290,
		295,
		240,
		223,
		241,
		250,
		271,
		247,
		238,
		265,
		265,
		254,
		249,
		236,
		-1,
		-1,
		286,
		279,
		-1,
		-1,
		253,
		241,
		224,
		225,
		221,
		224,
		239,
		242,
		232,
		230,
		224,
		256,
		-1,
		292,
		291,
		280,
		277,
		253,
		244,
		231,
		242,
		-1,
		-1,
		250,
		266,
		279,
		283,
		296,
		321,
		-1,
		239,
		-1,
		-1,
		298,
		-1,
		-1,
		283,
		246,
		235,
		226,
		232,
		229,
		240,
		250,
		238,
		239,
		229,
		239,
		252,
		276,
		273,
		261,
		259,
		282,
		239,
		235,
		-1,
		265,
		253,
		259,
		266,
		283,
		310,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		281,
		279,
		268,
		-1,
		258,
		231,
		236,
		256,
		258,
		247,
		241,
		235,
		242,
		241,
		249,
		257,
		285,
		299,
		288,
		284,
		283,
		291,
		240,
		257,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		-1,
		290,
		265,
		-1,
		-1,
		276,
		269,
		257,
		245,
		235,
		245,
		249,
		253,
		245,
		238,
		233,
		244,
		236,
		240,
		257,
		-1,
		319,
		-1,
		271,
		264,
		279,
		294,
		302,
		-1,
		-1,
		-1,
		307,
		293,
		286,
		274,
		272,
		-1,
		310,
		294,
		275,
		-1,
		245,
		258,
		289,
		257,
		262,
		257,
		239,
		250,
		239,
		242,
		256,
		251,
		-1,
		-1,
		277,
		280,
		-1,
		-1,
		302,
		321,
		-1,
		298,
		287,
		272,
		264,
		-1,
		-1,
		282,
		278,
		-1,
		-1,
		246,
		271,
		260,
		268,
		263,
		243,
		249,
		252,
		241,
		245,
		257,
		-1,
		-1,
		284,
		285,
		290,
		-1,
		311,
		-1,
		322,
		-1,
		267,
		283,
		285,
		-1,
		-1,
		-1,
		284,
		247,
		268,
		278,
		272,
		270,
		261,
		247,
		254,
		252,
		248,
		259,
		-1,
		-1,
		-1,
		329,
		303,
		329,
		320,
		303,
		283,
		275,
		300,
		-1,
		271,
		-1,
		246,
		248,
		274,
		277,
		283,
		277,
		250,
		265,
		255,
		246,
		255,
		335,
		-1,
		305,
		338,
		302,
		289,
		272,
		276,
		292,
		-1,
		268,
		250,
		-1,
		278,
		268,
		299,
		284,
		265,
		252,
		259,
		259,
		252,
		-1,
		-1,
		-1,
		307,
		306,
		298,
		292,
		292,
		277,
		268,
		-1,
		280,
		262,
		241,
		258,
		258,
		249,
		257,
		289,
		285,
		272,
		272,
		264,
		-1,
		391,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		301,
		296,
		269,
		257,
		263,
		259,
		245,
		251,
		253,
		261,
		259,
		256,
		268,
		264,
		284,
		265,
		300,
		-1,
		398,
		-1,
		337,
		-1,
		-1,
		319,
		299,
		291,
		280,
		269,
		267,
		258,
		249,
		271,
		287,
		271,
		269,
		272,
		273,
		-1,
		392,
		391,
		-1,
		338,
		330,
		316,
		-1,
		309,
		-1,
		315,
		276,
		-1,
		278,
		258,
		-1,
		280,
		276,
		-1,
		-1,
		379,
		354,
		-1,
		-1,
		-1,
		339,
		319,
		310,
		294,
		-1,
		269,
		269,
		-1,
		-1,
		-1,
		364,
		363,
		-1,
		332,
		335,
		-1,
		325,
		316,
		324,
		271,
		275,
		-1,
		-1,
		-1,
		373,
		354,
		348,
		347,
		345,
		340,
		337,
		323,
		307,
		285,
		274,
		295,
		-1,
		-1,
		-1,
		345,
		337,
		330,
		-1,
		-1,
		332,
		315,
		296,
		294,
		-1,
		-1,
		-1,
		367,
		348,
		-1,
		-1,
		322,
		-1,
		-1,
		328,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		384,
		356,
		-1,
		-1,
		-1,
		318,
		314,
		315,
		-1,
		-1,
		-1,
		-1,
		378,
		379,
		402,
		366,
		-1,
		-1,
		-1,
		310,
		304,
		-1,
		-1,
		381,
		379,
		-1,
		-1,
		-1,
		338,
		322,
		-1,
		308,
		-1,
		-1,
		-1,
		329,
		-1,
		-1,
		341,
		-1,
		-1,
		-1,
		343,
		-1,
		343,
		318,
		325,
		-1,
		-1,
		-1,
		-1,
		356,
		348,
		356,
		-1,
		328,
		330,
		-1,
		378,
		-1,
		-1,
		371,
		362,
		-1,
		-1,
		333,
		340,
		362,
		365,
		401,
		-1,
		352
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		152,
		154,
		120,
		114,
		153,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		143,
		142,
		112,
		110,
		119,
		124,
		131,
		-1,
		154,
		-1,
		164,
		143,
		154,
		159,
		105,
		102,
		122,
		141,
		147,
		139,
		179,
		135,
		106,
		100,
		118,
		123,
		141,
		133,
		-1,
		106,
		96,
		118,
		122,
		134,
		117,
		-1,
		-1,
		100,
		101,
		107,
		119,
		124,
		129,
		-1,
		155,
		174,
		-1,
		-1,
		90,
		103,
		99,
		102,
		110,
		126,
		147,
		164,
		169,
		-1,
		-1,
		91,
		95,
		108,
		109,
		107,
		134,
		153,
		164,
		178,
		177,
		-1,
		79,
		97,
		106,
		115,
		121,
		110,
		114,
		132,
		163,
		169,
		172,
		-1,
		71,
		73,
		102,
		108,
		120,
		126,
		113,
		119,
		138,
		151,
		170,
		161,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		68,
		76,
		102,
		101,
		97,
		115,
		137,
		116,
		122,
		126,
		143,
		159,
		160,
		170,
		-1,
		-1,
		119,
		88,
		123,
		80,
		65,
		-1,
		64,
		83,
		89,
		93,
		98,
		106,
		134,
		132,
		-1,
		137,
		136,
		167,
		153,
		164,
		37,
		-1,
		-1,
		77,
		69,
		54,
		57,
		54,
		59,
		89,
		88,
		93,
		95,
		97,
		109,
		124,
		124,
		134,
		131,
		141,
		145,
		160,
		171,
		-1,
		-1,
		245,
		-1,
		-1,
		38,
		0,
		-1,
		42,
		49,
		49,
		66,
		57,
		82,
		97,
		101,
		109,
		112,
		100,
		119,
		116,
		140,
		136,
		128,
		153,
		157,
		163,
		181,
		182,
		-1,
		244,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		4,
		35,
		38,
		44,
		68,
		78,
		-1,
		104,
		102,
		126,
		120,
		125,
		121,
		106,
		124,
		122,
		137,
		139,
		135,
		137,
		174,
		165,
		186,
		183,
		214,
		220,
		214,
		223,
		-1,
		84,
		80,
		76,
		83,
		32,
		-1,
		-1,
		72,
		-1,
		86,
		99,
		116,
		106,
		109,
		121,
		129,
		128,
		112,
		130,
		125,
		128,
		147,
		143,
		152,
		162,
		161,
		179,
		192,
		207,
		211,
		217,
		-1,
		134,
		-1,
		76,
		60,
		62,
		38,
		66,
		-1,
		92,
		87,
		107,
		118,
		118,
		-1,
		134,
		131,
		144,
		128,
		113,
		130,
		132,
		136,
		146,
		150,
		165,
		156,
		174,
		181,
		189,
		193,
		213,
		225,
		94,
		84,
		-1,
		66,
		71,
		41,
		53,
		89,
		130,
		114,
		-1,
		129,
		-1,
		136,
		149,
		-1,
		134,
		130,
		119,
		135,
		143,
		150,
		153,
		147,
		144,
		162,
		165,
		182,
		186,
		202,
		-1,
		-1,
		79,
		83,
		104,
		47,
		74,
		98,
		135,
		123,
		132,
		134,
		-1,
		154,
		155,
		152,
		153,
		139,
		132,
		133,
		149,
		155,
		147,
		146,
		149,
		171,
		199,
		177,
		189,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		81,
		52,
		76,
		118,
		162,
		155,
		143,
		141,
		141,
		135,
		-1,
		170,
		149,
		146,
		137,
		142,
		155,
		150,
		166,
		150,
		152,
		168,
		180,
		171,
		191,
		-1,
		-1,
		-1,
		111,
		100,
		101,
		55,
		89,
		107,
		174,
		160,
		165,
		140,
		133,
		127,
		164,
		166,
		143,
		151,
		143,
		132,
		146,
		154,
		158,
		152,
		161,
		162,
		186,
		193,
		199,
		-1,
		-1,
		118,
		108,
		92,
		94,
		91,
		80,
		87,
		119,
		165,
		162,
		-1,
		132,
		-1,
		121,
		129,
		128,
		134,
		146,
		132,
		137,
		148,
		160,
		166,
		157,
		172,
		191,
		191,
		183,
		208,
		211,
		-1,
		-1,
		-1,
		111,
		128,
		103,
		80,
		61,
		97,
		-1,
		132,
		133,
		-1,
		126,
		120,
		126,
		125,
		132,
		129,
		129,
		143,
		151,
		147,
		163,
		169,
		158,
		194,
		-1,
		191,
		185,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		68,
		120,
		-1,
		-1,
		117,
		110,
		-1,
		113,
		113,
		120,
		129,
		134,
		139,
		147,
		142,
		155,
		160,
		163,
		171,
		189,
		193,
		197,
		186,
		182,
		179,
		193,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		88,
		-1,
		125,
		117,
		108,
		102,
		108,
		126,
		124,
		144,
		136,
		150,
		150,
		156,
		164,
		149,
		152,
		166,
		166,
		184,
		192,
		184,
		178,
		177,
		189,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		103,
		-1,
		74,
		98,
		114,
		-1,
		142,
		121,
		144,
		122,
		136,
		132,
		170,
		171,
		149,
		154,
		162,
		172,
		174,
		163,
		174,
		166,
		188,
		188,
		172,
		173,
		182,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		77,
		90,
		101,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		146,
		144,
		160,
		151,
		157,
		173,
		176,
		178,
		168,
		157,
		163,
		160,
		182,
		168,
		166,
		185,
		201,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		168,
		152,
		157,
		-1,
		203,
		-1,
		176,
		178,
		172,
		157,
		154,
		165,
		163,
		174,
		191,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		134,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		184,
		164,
		158,
		157,
		198,
		198,
		184,
		170,
		163,
		160,
		157,
		170,
		190,
		181,
		193,
		-1,
		-1,
		-1,
		135,
		115,
		121,
		79,
		100,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		201,
		189,
		179,
		169,
		203,
		204,
		189,
		182,
		168,
		170,
		168,
		166,
		171,
		192,
		193,
		206,
		-1,
		-1,
		112,
		119,
		107,
		93,
		112,
		-1,
		-1,
		-1,
		160,
		176,
		168,
		139,
		190,
		-1,
		-1,
		181,
		179,
		189,
		185,
		172,
		192,
		195,
		181,
		165,
		180,
		192,
		200,
		205,
		-1,
		115,
		102,
		-1,
		-1,
		115,
		109,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		171,
		192,
		217,
		184,
		-1,
		189,
		190,
		176,
		190,
		197,
		183,
		178,
		172,
		175,
		193,
		210,
		-1,
		-1,
		129,
		-1,
		124,
		-1,
		-1,
		-1,
		-1,
		150,
		164,
		185,
		191,
		203,
		-1,
		198,
		192,
		178,
		195,
		196,
		193,
		184,
		176,
		181,
		178,
		191,
		205,
		209,
		152,
		-1,
		135,
		-1,
		-1,
		-1,
		168,
		183,
		245,
		222,
		195,
		199,
		192,
		186,
		186,
		202,
		204,
		215,
		183,
		179,
		180,
		184,
		183,
		200,
		210,
		-1,
		-1,
		135,
		152,
		187,
		176,
		180,
		272,
		-1,
		-1,
		208,
		199,
		190,
		193,
		196,
		199,
		189,
		186,
		191,
		196,
		184,
		193,
		211,
		215,
		-1,
		-1,
		-1,
		155,
		-1,
		170,
		-1,
		-1,
		195,
		279,
		226,
		208,
		204,
		202,
		195,
		204,
		199,
		194,
		204,
		213,
		205,
		186,
		197,
		220,
		209,
		247,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		184,
		159,
		174,
		220,
		215,
		216,
		241,
		238,
		-1,
		208,
		233,
		205,
		212,
		204,
		212,
		212,
		209,
		187,
		194,
		210,
		209,
		204,
		239,
		231,
		237,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		190,
		176,
		206,
		196,
		202,
		-1,
		-1,
		249,
		246,
		230,
		214,
		218,
		211,
		206,
		216,
		196,
		183,
		187,
		191,
		197,
		202,
		207,
		213,
		228,
		243,
		-1,
		160,
		241,
		234,
		217,
		225,
		256,
		-1,
		193,
		202,
		183,
		188,
		196,
		-1,
		-1,
		222,
		218,
		223,
		221,
		218,
		226,
		221,
		212,
		197,
		203,
		190,
		189,
		207,
		211,
		220,
		227,
		217,
		230,
		234,
		-1,
		174,
		217,
		211,
		214,
		238,
		252,
		-1,
		206,
		-1,
		-1,
		191,
		209,
		217,
		213,
		217,
		270,
		235,
		230,
		220,
		218,
		209,
		200,
		207,
		198,
		198,
		201,
		216,
		221,
		213,
		227,
		227,
		228,
		-1,
		209,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		207,
		-1,
		243,
		-1,
		236,
		240,
		243,
		246,
		234,
		221,
		213,
		205,
		221,
		196,
		206,
		202,
		203,
		212,
		223,
		235,
		234,
		235,
		283,
		238,
		205,
		196,
		243,
		258,
		262,
		-1,
		219,
		258,
		245,
		-1,
		216,
		-1,
		-1,
		-1,
		250,
		256,
		248,
		254,
		233,
		233,
		207,
		211,
		201,
		208,
		218,
		220,
		212,
		216,
		229,
		240,
		243,
		279,
		277,
		282,
		227,
		210,
		228,
		237,
		258,
		234,
		225,
		252,
		252,
		241,
		236,
		223,
		-1,
		-1,
		273,
		266,
		-1,
		-1,
		240,
		228,
		211,
		212,
		208,
		211,
		226,
		229,
		219,
		217,
		211,
		243,
		-1,
		279,
		278,
		267,
		264,
		240,
		231,
		218,
		229,
		-1,
		-1,
		237,
		253,
		266,
		270,
		283,
		308,
		-1,
		226,
		-1,
		-1,
		285,
		-1,
		-1,
		270,
		233,
		222,
		213,
		219,
		216,
		227,
		237,
		225,
		226,
		216,
		226,
		239,
		263,
		260,
		248,
		246,
		269,
		226,
		222,
		-1,
		252,
		240,
		246,
		253,
		270,
		297,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		268,
		266,
		255,
		-1,
		245,
		218,
		223,
		243,
		245,
		234,
		228,
		222,
		229,
		228,
		236,
		244,
		272,
		286,
		275,
		271,
		270,
		278,
		227,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		-1,
		277,
		252,
		-1,
		-1,
		263,
		256,
		244,
		232,
		222,
		232,
		236,
		240,
		232,
		225,
		220,
		231,
		223,
		227,
		244,
		-1,
		306,
		-1,
		258,
		251,
		266,
		281,
		289,
		-1,
		-1,
		-1,
		294,
		280,
		273,
		261,
		259,
		-1,
		297,
		281,
		262,
		-1,
		232,
		245,
		276,
		244,
		249,
		244,
		226,
		237,
		226,
		229,
		243,
		238,
		-1,
		-1,
		264,
		267,
		-1,
		-1,
		289,
		308,
		-1,
		285,
		274,
		259,
		251,
		-1,
		-1,
		269,
		265,
		-1,
		-1,
		233,
		258,
		247,
		255,
		250,
		230,
		236,
		239,
		228,
		232,
		244,
		-1,
		-1,
		271,
		272,
		277,
		-1,
		298,
		-1,
		309,
		-1,
		254,
		270,
		272,
		-1,
		-1,
		-1,
		271,
		234,
		255,
		265,
		259,
		257,
		248,
		234,
		241,
		239,
		235,
		246,
		-1,
		-1,
		-1,
		316,
		290,
		316,
		307,
		290,
		270,
		262,
		287,
		-1,
		258,
		-1,
		233,
		235,
		261,
		264,
		270,
		264,
		237,
		252,
		242,
		233,
		242,
		322,
		-1,
		292,
		325,
		289,
		276,
		259,
		263,
		279,
		-1,
		255,
		237,
		-1,
		265,
		255,
		286,
		271,
		252,
		239,
		246,
		246,
		239,
		-1,
		-1,
		-1,
		294,
		293,
		285,
		279,
		279,
		264,
		255,
		-1,
		267,
		249,
		228,
		245,
		245,
		236,
		244,
		276,
		272,
		259,
		259,
		251,
		-1,
		378,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		288,
		283,
		256,
		244,
		250,
		246,
		232,
		238,
		240,
		248,
		246,
		243,
		255,
		251,
		271,
		252,
		287,
		-1,
		385,
		-1,
		324,
		-1,
		-1,
		306,
		286,
		278,
		267,
		256,
		254,
		245,
		236,
		258,
		274,
		258,
		256,
		259,
		260,
		-1,
		379,
		378,
		-1,
		325,
		317,
		303,
		-1,
		296,
		-1,
		302,
		263,
		-1,
		265,
		245,
		-1,
		267,
		263,
		-1,
		-1,
		366,
		341,
		-1,
		-1,
		-1,
		326,
		306,
		297,
		281,
		-1,
		256,
		256,
		-1,
		-1,
		-1,
		351,
		350,
		-1,
		319,
		322,
		-1,
		312,
		303,
		311,
		258,
		262,
		-1,
		-1,
		-1,
		360,
		341,
		335,
		334,
		332,
		327,
		324,
		310,
		294,
		272,
		261,
		282,
		-1,
		-1,
		-1,
		332,
		324,
		317,
		-1,
		-1,
		319,
		302,
		283,
		281,
		-1,
		-1,
		-1,
		354,
		335,
		-1,
		-1,
		309,
		-1,
		-1,
		315,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		371,
		343,
		-1,
		-1,
		-1,
		305,
		301,
		302,
		-1,
		-1,
		-1,
		-1,
		365,
		366,
		389,
		353,
		-1,
		-1,
		-1,
		297,
		291,
		-1,
		-1,
		368,
		366,
		-1,
		-1,
		-1,
		325,
		309,
		-1,
		295,
		-1,
		-1,
		-1,
		316,
		-1,
		-1,
		328,
		-1,
		-1,
		-1,
		330,
		-1,
		330,
		305,
		312,
		-1,
		-1,
		-1,
		-1,
		343,
		335,
		343,
		-1,
		315,
		317,
		-1,
		365,
		-1,
		-1,
		358,
		349,
		-1,
		-1,
		320,
		327,
		349,
		352,
		388,
		-1,
		339
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		103,
		92,
		103,
		111,
		84,
		91,
		-1,
		112,
		114,
		80,
		74,
		113,
		84,
		90,
		101,
		-1,
		-1,
		-1,
		103,
		102,
		72,
		70,
		79,
		84,
		91,
		-1,
		114,
		-1,
		124,
		103,
		114,
		119,
		65,
		62,
		82,
		101,
		107,
		99,
		139,
		95,
		66,
		60,
		78,
		83,
		101,
		93,
		-1,
		66,
		56,
		78,
		82,
		94,
		77,
		-1,
		-1,
		60,
		61,
		67,
		79,
		84,
		89,
		-1,
		115,
		134,
		-1,
		-1,
		50,
		63,
		59,
		62,
		70,
		86,
		107,
		124,
		129,
		-1,
		-1,
		51,
		55,
		68,
		69,
		67,
		94,
		113,
		124,
		138,
		137,
		-1,
		39,
		57,
		66,
		75,
		81,
		70,
		74,
		92,
		123,
		129,
		132,
		-1,
		31,
		33,
		62,
		68,
		80,
		86,
		73,
		79,
		98,
		111,
		130,
		121,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		27,
		28,
		36,
		62,
		61,
		57,
		75,
		97,
		76,
		82,
		86,
		103,
		119,
		120,
		130,
		-1,
		-1,
		77,
		46,
		81,
		38,
		23,
		-1,
		24,
		43,
		49,
		53,
		58,
		66,
		94,
		92,
		-1,
		97,
		96,
		127,
		113,
		124,
		57,
		-1,
		-1,
		35,
		27,
		12,
		15,
		14,
		19,
		49,
		48,
		53,
		55,
		57,
		69,
		84,
		84,
		94,
		91,
		101,
		105,
		120,
		131,
		-1,
		-1,
		205,
		-1,
		-1,
		54,
		37,
		-1,
		0,
		7,
		9,
		26,
		17,
		42,
		57,
		61,
		69,
		72,
		60,
		79,
		76,
		100,
		96,
		88,
		113,
		117,
		123,
		141,
		142,
		-1,
		204,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		32,
		7,
		4,
		6,
		30,
		38,
		-1,
		64,
		62,
		86,
		80,
		85,
		81,
		66,
		84,
		82,
		97,
		99,
		95,
		97,
		134,
		125,
		146,
		143,
		174,
		180,
		174,
		183,
		-1,
		62,
		58,
		54,
		61,
		10,
		-1,
		-1,
		34,
		-1,
		46,
		59,
		76,
		66,
		69,
		81,
		89,
		88,
		72,
		90,
		85,
		88,
		107,
		103,
		112,
		122,
		121,
		139,
		152,
		167,
		171,
		177,
		-1,
		112,
		-1,
		54,
		38,
		40,
		16,
		44,
		-1,
		54,
		47,
		67,
		78,
		78,
		-1,
		94,
		91,
		104,
		88,
		73,
		90,
		92,
		96,
		106,
		110,
		125,
		116,
		134,
		141,
		149,
		153,
		173,
		185,
		72,
		62,
		-1,
		44,
		49,
		19,
		31,
		67,
		90,
		74,
		-1,
		89,
		-1,
		96,
		109,
		-1,
		94,
		90,
		79,
		95,
		103,
		110,
		113,
		107,
		104,
		122,
		125,
		142,
		146,
		162,
		-1,
		-1,
		57,
		61,
		82,
		25,
		52,
		76,
		113,
		83,
		92,
		94,
		-1,
		114,
		115,
		112,
		113,
		99,
		92,
		93,
		109,
		115,
		111,
		106,
		109,
		131,
		159,
		137,
		149,
		-1,
		-1,
		-1,
		82,
		-1,
		-1,
		59,
		30,
		54,
		96,
		122,
		115,
		103,
		119,
		119,
		113,
		-1,
		130,
		109,
		106,
		97,
		105,
		119,
		116,
		130,
		110,
		112,
		128,
		140,
		131,
		151,
		-1,
		-1,
		-1,
		89,
		78,
		79,
		33,
		67,
		85,
		152,
		138,
		143,
		118,
		111,
		105,
		124,
		126,
		121,
		115,
		107,
		96,
		112,
		120,
		122,
		112,
		121,
		122,
		146,
		153,
		159,
		-1,
		-1,
		96,
		86,
		70,
		72,
		69,
		58,
		65,
		97,
		143,
		140,
		-1,
		110,
		-1,
		99,
		107,
		106,
		112,
		112,
		109,
		103,
		112,
		126,
		126,
		117,
		132,
		151,
		151,
		143,
		168,
		171,
		-1,
		-1,
		-1,
		89,
		106,
		81,
		58,
		39,
		75,
		-1,
		110,
		111,
		-1,
		104,
		98,
		104,
		103,
		110,
		107,
		107,
		110,
		117,
		113,
		127,
		136,
		118,
		154,
		-1,
		151,
		145,
		173,
		167,
		155,
		-1,
		-1,
		-1,
		104,
		83,
		76,
		96,
		46,
		98,
		-1,
		-1,
		95,
		88,
		-1,
		91,
		91,
		98,
		107,
		112,
		117,
		122,
		111,
		124,
		129,
		123,
		133,
		153,
		157,
		164,
		157,
		153,
		150,
		164,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		49,
		66,
		-1,
		103,
		95,
		86,
		80,
		86,
		104,
		102,
		122,
		114,
		128,
		128,
		125,
		133,
		118,
		121,
		126,
		130,
		148,
		163,
		155,
		149,
		148,
		160,
		-1,
		152,
		138,
		109,
		-1,
		-1,
		81,
		-1,
		52,
		76,
		92,
		-1,
		120,
		99,
		122,
		100,
		114,
		110,
		148,
		149,
		127,
		132,
		132,
		142,
		143,
		132,
		138,
		137,
		157,
		159,
		143,
		144,
		153,
		-1,
		158,
		145,
		103,
		99,
		88,
		108,
		55,
		68,
		79,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		124,
		122,
		138,
		129,
		135,
		143,
		146,
		147,
		137,
		126,
		132,
		131,
		153,
		139,
		137,
		156,
		172,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		74,
		61,
		55,
		-1,
		96,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		146,
		130,
		135,
		-1,
		172,
		-1,
		145,
		147,
		139,
		128,
		125,
		136,
		134,
		145,
		162,
		-1,
		108,
		93,
		86,
		76,
		90,
		61,
		-1,
		112,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		162,
		142,
		136,
		135,
		167,
		165,
		153,
		137,
		130,
		127,
		128,
		141,
		161,
		152,
		164,
		-1,
		-1,
		-1,
		113,
		93,
		99,
		57,
		78,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		179,
		167,
		157,
		147,
		181,
		181,
		156,
		149,
		135,
		137,
		135,
		137,
		142,
		163,
		164,
		177,
		-1,
		-1,
		90,
		97,
		85,
		71,
		90,
		-1,
		-1,
		-1,
		138,
		154,
		146,
		117,
		168,
		-1,
		-1,
		159,
		157,
		167,
		152,
		139,
		159,
		162,
		152,
		136,
		151,
		163,
		171,
		176,
		-1,
		93,
		80,
		-1,
		-1,
		93,
		87,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		149,
		170,
		195,
		162,
		-1,
		167,
		163,
		143,
		157,
		164,
		154,
		149,
		143,
		146,
		164,
		181,
		-1,
		-1,
		107,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		128,
		142,
		163,
		169,
		181,
		-1,
		171,
		159,
		145,
		162,
		167,
		164,
		155,
		147,
		152,
		149,
		162,
		176,
		180,
		130,
		-1,
		113,
		-1,
		-1,
		-1,
		146,
		161,
		223,
		200,
		173,
		170,
		163,
		157,
		153,
		169,
		175,
		186,
		154,
		150,
		151,
		155,
		154,
		171,
		181,
		-1,
		-1,
		113,
		130,
		165,
		154,
		158,
		250,
		-1,
		-1,
		179,
		170,
		161,
		164,
		163,
		166,
		160,
		157,
		162,
		167,
		155,
		164,
		182,
		181,
		-1,
		-1,
		-1,
		133,
		-1,
		148,
		-1,
		-1,
		173,
		250,
		197,
		179,
		175,
		173,
		166,
		175,
		170,
		165,
		175,
		177,
		169,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		162,
		137,
		152,
		198,
		193,
		194,
		212,
		209,
		-1,
		179,
		204,
		176,
		183,
		174,
		181,
		181,
		173,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		168,
		154,
		184,
		174,
		180,
		-1,
		-1,
		227,
		224,
		201,
		184,
		182,
		175,
		170,
		180,
		160,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		138,
		219,
		212,
		195,
		203,
		234,
		-1,
		171,
		180,
		161,
		166,
		174,
		-1,
		-1,
		200,
		196,
		201,
		191,
		188,
		190,
		185,
		176,
		161,
		167,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		152,
		195,
		189,
		192,
		216,
		230,
		-1,
		184,
		-1,
		-1,
		169,
		187,
		195,
		191,
		195,
		248,
		205,
		200,
		184,
		182,
		173,
		164,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		187,
		175,
		183,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		185,
		-1,
		221,
		-1,
		214,
		218,
		213,
		216,
		198,
		185,
		177,
		169,
		185,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		261,
		216,
		183,
		174,
		221,
		236,
		240,
		-1,
		197,
		236,
		223,
		-1,
		194,
		-1,
		-1,
		-1,
		228,
		226,
		218,
		218,
		197,
		197,
		171,
		175,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		257,
		255,
		260,
		205,
		188,
		206,
		215,
		236,
		212,
		203,
		230,
		230,
		219,
		214,
		201,
		-1,
		-1,
		251,
		236,
		-1,
		-1,
		204,
		192,
		175,
		176,
		172,
		175,
		190,
		193,
		183,
		181,
		175,
		207,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		196,
		207,
		-1,
		-1,
		215,
		231,
		244,
		248,
		261,
		286,
		-1,
		204,
		-1,
		-1,
		249,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		180,
		191,
		201,
		189,
		190,
		180,
		190,
		203,
		241,
		238,
		226,
		224,
		247,
		204,
		200,
		-1,
		230,
		218,
		224,
		231,
		248,
		275,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		232,
		230,
		219,
		-1,
		209,
		182,
		187,
		207,
		209,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		255,
		230,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		200,
		204,
		196,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		284,
		-1,
		236,
		229,
		244,
		259,
		267,
		-1,
		-1,
		-1,
		272,
		258,
		251,
		239,
		237,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		242,
		245,
		-1,
		-1,
		267,
		279,
		-1,
		263,
		252,
		237,
		229,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		249,
		250,
		255,
		-1,
		262,
		-1,
		280,
		-1,
		232,
		248,
		241,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		223,
		221,
		212,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		280,
		254,
		287,
		278,
		261,
		241,
		233,
		252,
		-1,
		222,
		-1,
		197,
		199,
		225,
		228,
		234,
		228,
		201,
		216,
		206,
		197,
		206,
		286,
		-1,
		256,
		289,
		253,
		247,
		223,
		227,
		243,
		-1,
		219,
		201,
		-1,
		229,
		219,
		250,
		235,
		216,
		203,
		210,
		210,
		203,
		-1,
		-1,
		-1,
		258,
		257,
		249,
		243,
		243,
		228,
		219,
		-1,
		231,
		213,
		192,
		209,
		209,
		200,
		208,
		240,
		236,
		223,
		223,
		215,
		-1,
		356,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		252,
		247,
		220,
		208,
		214,
		210,
		196,
		202,
		204,
		212,
		210,
		207,
		219,
		215,
		235,
		216,
		251,
		-1,
		354,
		-1,
		288,
		-1,
		-1,
		270,
		250,
		242,
		231,
		220,
		218,
		209,
		200,
		222,
		238,
		222,
		220,
		223,
		224,
		-1,
		343,
		342,
		-1,
		289,
		281,
		267,
		-1,
		260,
		-1,
		266,
		227,
		-1,
		229,
		209,
		-1,
		231,
		227,
		-1,
		-1,
		330,
		305,
		-1,
		-1,
		-1,
		290,
		270,
		261,
		245,
		-1,
		220,
		220,
		-1,
		-1,
		-1,
		315,
		314,
		-1,
		283,
		286,
		-1,
		276,
		267,
		275,
		222,
		226,
		-1,
		-1,
		-1,
		324,
		305,
		299,
		298,
		296,
		291,
		288,
		274,
		258,
		236,
		225,
		246,
		-1,
		-1,
		-1,
		296,
		288,
		281,
		-1,
		-1,
		283,
		266,
		247,
		245,
		-1,
		-1,
		-1,
		318,
		299,
		-1,
		-1,
		273,
		-1,
		-1,
		279,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		335,
		307,
		-1,
		-1,
		-1,
		269,
		265,
		266,
		-1,
		-1,
		-1,
		-1,
		329,
		330,
		353,
		317,
		-1,
		-1,
		-1,
		261,
		255,
		-1,
		-1,
		332,
		330,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		259,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		294,
		-1,
		294,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		307,
		-1,
		279,
		281,
		-1,
		329,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		284,
		291,
		313,
		316,
		352,
		-1,
		303
	],
	[
		-1,
		109,
		98,
		109,
		117,
		90,
		97,
		-1,
		118,
		120,
		86,
		80,
		119,
		90,
		96,
		107,
		-1,
		-1,
		-1,
		109,
		108,
		78,
		76,
		85,
		90,
		97,
		-1,
		120,
		-1,
		130,
		109,
		120,
		125,
		71,
		68,
		88,
		107,
		113,
		105,
		145,
		101,
		72,
		66,
		84,
		89,
		107,
		99,
		-1,
		72,
		62,
		84,
		88,
		100,
		83,
		-1,
		-1,
		66,
		67,
		73,
		85,
		90,
		95,
		-1,
		121,
		140,
		-1,
		-1,
		56,
		69,
		65,
		68,
		76,
		92,
		113,
		130,
		135,
		-1,
		-1,
		57,
		61,
		74,
		75,
		73,
		100,
		119,
		130,
		144,
		143,
		-1,
		45,
		63,
		72,
		81,
		87,
		76,
		80,
		98,
		129,
		135,
		138,
		-1,
		37,
		39,
		68,
		74,
		86,
		92,
		79,
		85,
		104,
		117,
		136,
		127,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		20,
		34,
		42,
		68,
		67,
		63,
		81,
		103,
		82,
		88,
		92,
		109,
		125,
		126,
		136,
		-1,
		-1,
		70,
		39,
		74,
		31,
		16,
		-1,
		30,
		49,
		55,
		59,
		64,
		72,
		100,
		98,
		-1,
		103,
		102,
		133,
		119,
		130,
		63,
		-1,
		-1,
		28,
		20,
		5,
		8,
		20,
		25,
		55,
		54,
		59,
		61,
		63,
		75,
		90,
		90,
		100,
		97,
		107,
		111,
		126,
		137,
		-1,
		-1,
		211,
		-1,
		-1,
		60,
		43,
		-1,
		6,
		0,
		15,
		32,
		23,
		48,
		63,
		67,
		75,
		78,
		66,
		85,
		82,
		106,
		102,
		94,
		119,
		123,
		129,
		147,
		148,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		38,
		13,
		10,
		12,
		36,
		44,
		-1,
		70,
		68,
		92,
		86,
		91,
		87,
		72,
		90,
		88,
		103,
		105,
		101,
		103,
		140,
		131,
		152,
		149,
		180,
		186,
		180,
		189,
		-1,
		68,
		64,
		60,
		67,
		16,
		-1,
		-1,
		40,
		-1,
		52,
		65,
		82,
		72,
		75,
		87,
		95,
		94,
		78,
		96,
		91,
		94,
		113,
		109,
		118,
		128,
		127,
		145,
		158,
		173,
		177,
		183,
		-1,
		118,
		-1,
		60,
		44,
		46,
		22,
		50,
		-1,
		60,
		53,
		73,
		84,
		84,
		-1,
		100,
		97,
		110,
		94,
		79,
		96,
		98,
		102,
		112,
		116,
		131,
		122,
		140,
		147,
		155,
		159,
		179,
		191,
		78,
		68,
		-1,
		50,
		55,
		25,
		37,
		73,
		96,
		80,
		-1,
		95,
		-1,
		102,
		115,
		-1,
		100,
		96,
		85,
		101,
		109,
		116,
		119,
		113,
		110,
		128,
		131,
		148,
		152,
		168,
		-1,
		-1,
		63,
		67,
		88,
		31,
		58,
		82,
		119,
		89,
		98,
		100,
		-1,
		120,
		121,
		118,
		119,
		105,
		98,
		99,
		115,
		121,
		117,
		112,
		115,
		137,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		65,
		36,
		60,
		102,
		128,
		121,
		109,
		125,
		125,
		119,
		-1,
		136,
		115,
		112,
		103,
		111,
		125,
		122,
		136,
		116,
		118,
		134,
		146,
		137,
		157,
		-1,
		-1,
		-1,
		95,
		84,
		85,
		39,
		73,
		91,
		158,
		144,
		149,
		124,
		117,
		111,
		130,
		132,
		127,
		121,
		113,
		102,
		118,
		126,
		128,
		118,
		127,
		128,
		152,
		159,
		165,
		-1,
		-1,
		102,
		92,
		76,
		78,
		75,
		64,
		71,
		103,
		149,
		146,
		-1,
		116,
		-1,
		105,
		113,
		112,
		118,
		118,
		115,
		109,
		118,
		132,
		132,
		123,
		138,
		157,
		157,
		149,
		174,
		177,
		-1,
		-1,
		-1,
		95,
		112,
		87,
		64,
		45,
		81,
		-1,
		116,
		117,
		-1,
		110,
		104,
		110,
		109,
		116,
		113,
		113,
		116,
		123,
		119,
		133,
		142,
		124,
		160,
		-1,
		157,
		151,
		179,
		173,
		161,
		-1,
		-1,
		-1,
		110,
		89,
		82,
		102,
		52,
		104,
		-1,
		-1,
		101,
		94,
		-1,
		97,
		97,
		104,
		113,
		118,
		123,
		128,
		117,
		130,
		135,
		129,
		139,
		159,
		163,
		170,
		163,
		159,
		156,
		170,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		55,
		72,
		-1,
		109,
		101,
		92,
		86,
		92,
		110,
		108,
		128,
		120,
		134,
		134,
		131,
		139,
		124,
		127,
		132,
		136,
		154,
		169,
		161,
		155,
		154,
		166,
		-1,
		158,
		144,
		115,
		-1,
		-1,
		87,
		-1,
		58,
		82,
		98,
		-1,
		126,
		105,
		128,
		106,
		120,
		116,
		154,
		155,
		133,
		138,
		138,
		148,
		149,
		138,
		144,
		143,
		163,
		165,
		149,
		150,
		159,
		-1,
		164,
		151,
		109,
		105,
		94,
		114,
		61,
		74,
		85,
		-1,
		-1,
		170,
		-1,
		104,
		121,
		130,
		128,
		144,
		135,
		141,
		149,
		152,
		153,
		143,
		132,
		138,
		137,
		159,
		145,
		143,
		162,
		178,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		80,
		67,
		61,
		-1,
		102,
		-1,
		148,
		138,
		122,
		107,
		140,
		-1,
		152,
		136,
		141,
		-1,
		178,
		-1,
		151,
		153,
		145,
		134,
		131,
		142,
		140,
		151,
		168,
		-1,
		114,
		99,
		92,
		82,
		96,
		67,
		-1,
		118,
		-1,
		-1,
		135,
		129,
		129,
		113,
		116,
		168,
		148,
		142,
		141,
		173,
		171,
		159,
		143,
		136,
		133,
		134,
		147,
		167,
		158,
		170,
		-1,
		-1,
		-1,
		119,
		99,
		105,
		63,
		84,
		-1,
		-1,
		197,
		152,
		138,
		-1,
		122,
		185,
		173,
		163,
		153,
		187,
		187,
		162,
		155,
		141,
		143,
		141,
		143,
		148,
		169,
		170,
		183,
		-1,
		-1,
		96,
		103,
		91,
		77,
		96,
		-1,
		-1,
		-1,
		144,
		160,
		152,
		123,
		174,
		-1,
		-1,
		165,
		163,
		173,
		158,
		145,
		165,
		168,
		158,
		142,
		157,
		169,
		177,
		182,
		-1,
		99,
		86,
		-1,
		-1,
		99,
		93,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		155,
		176,
		201,
		168,
		-1,
		173,
		169,
		149,
		163,
		170,
		160,
		155,
		149,
		152,
		170,
		187,
		-1,
		-1,
		113,
		-1,
		108,
		-1,
		-1,
		-1,
		-1,
		134,
		148,
		169,
		175,
		187,
		-1,
		177,
		165,
		151,
		168,
		173,
		170,
		161,
		153,
		158,
		155,
		168,
		182,
		186,
		136,
		-1,
		119,
		-1,
		-1,
		-1,
		152,
		167,
		229,
		206,
		179,
		176,
		169,
		163,
		159,
		175,
		181,
		192,
		160,
		156,
		157,
		161,
		160,
		177,
		187,
		-1,
		-1,
		119,
		136,
		171,
		160,
		164,
		256,
		-1,
		-1,
		185,
		176,
		167,
		170,
		169,
		172,
		166,
		163,
		168,
		173,
		161,
		170,
		188,
		187,
		-1,
		-1,
		-1,
		139,
		-1,
		154,
		-1,
		-1,
		179,
		256,
		203,
		185,
		181,
		179,
		172,
		181,
		176,
		171,
		181,
		183,
		175,
		163,
		167,
		190,
		179,
		218,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		168,
		143,
		158,
		204,
		199,
		200,
		218,
		215,
		-1,
		185,
		210,
		182,
		189,
		180,
		187,
		187,
		179,
		157,
		164,
		180,
		179,
		174,
		210,
		201,
		207,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		174,
		160,
		190,
		180,
		186,
		-1,
		-1,
		233,
		230,
		207,
		190,
		188,
		181,
		176,
		186,
		166,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		144,
		225,
		218,
		201,
		209,
		240,
		-1,
		177,
		186,
		167,
		172,
		180,
		-1,
		-1,
		206,
		202,
		207,
		197,
		194,
		196,
		191,
		182,
		167,
		173,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		158,
		201,
		195,
		198,
		222,
		236,
		-1,
		190,
		-1,
		-1,
		175,
		193,
		201,
		197,
		201,
		254,
		211,
		206,
		190,
		188,
		179,
		170,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		193,
		181,
		189,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		191,
		-1,
		227,
		-1,
		220,
		224,
		219,
		222,
		204,
		191,
		183,
		175,
		191,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		267,
		222,
		189,
		180,
		227,
		242,
		246,
		-1,
		203,
		242,
		229,
		-1,
		200,
		-1,
		-1,
		-1,
		234,
		232,
		224,
		224,
		203,
		203,
		177,
		181,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		263,
		261,
		266,
		211,
		194,
		212,
		221,
		242,
		218,
		209,
		236,
		236,
		225,
		220,
		207,
		-1,
		-1,
		257,
		242,
		-1,
		-1,
		210,
		198,
		181,
		182,
		178,
		181,
		196,
		199,
		189,
		187,
		181,
		213,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		202,
		213,
		-1,
		-1,
		221,
		237,
		250,
		254,
		267,
		292,
		-1,
		210,
		-1,
		-1,
		255,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		186,
		197,
		207,
		195,
		196,
		186,
		196,
		209,
		247,
		244,
		232,
		230,
		253,
		210,
		206,
		-1,
		236,
		224,
		230,
		237,
		254,
		281,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		238,
		236,
		225,
		-1,
		215,
		188,
		193,
		213,
		215,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		-1,
		261,
		236,
		-1,
		-1,
		233,
		226,
		214,
		202,
		192,
		202,
		206,
		210,
		202,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		290,
		-1,
		242,
		235,
		250,
		265,
		273,
		-1,
		-1,
		-1,
		278,
		264,
		257,
		245,
		243,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		248,
		251,
		-1,
		-1,
		273,
		285,
		-1,
		269,
		258,
		243,
		235,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		255,
		256,
		261,
		-1,
		268,
		-1,
		286,
		-1,
		238,
		254,
		247,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		229,
		227,
		218,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		286,
		260,
		293,
		284,
		267,
		247,
		239,
		258,
		-1,
		228,
		-1,
		203,
		205,
		231,
		234,
		240,
		234,
		207,
		222,
		212,
		203,
		212,
		292,
		-1,
		262,
		295,
		259,
		253,
		229,
		233,
		249,
		-1,
		225,
		207,
		-1,
		235,
		225,
		256,
		241,
		222,
		209,
		216,
		216,
		209,
		-1,
		-1,
		-1,
		264,
		263,
		255,
		249,
		249,
		234,
		225,
		-1,
		237,
		219,
		198,
		215,
		215,
		206,
		214,
		246,
		242,
		229,
		229,
		221,
		-1,
		362,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		258,
		253,
		226,
		214,
		220,
		216,
		202,
		208,
		210,
		218,
		216,
		213,
		225,
		221,
		241,
		222,
		257,
		-1,
		360,
		-1,
		294,
		-1,
		-1,
		276,
		256,
		248,
		237,
		226,
		224,
		215,
		206,
		228,
		244,
		228,
		226,
		229,
		230,
		-1,
		349,
		348,
		-1,
		295,
		287,
		273,
		-1,
		266,
		-1,
		272,
		233,
		-1,
		235,
		215,
		-1,
		237,
		233,
		-1,
		-1,
		336,
		311,
		-1,
		-1,
		-1,
		296,
		276,
		267,
		251,
		-1,
		226,
		226,
		-1,
		-1,
		-1,
		321,
		320,
		-1,
		289,
		292,
		-1,
		282,
		273,
		281,
		228,
		232,
		-1,
		-1,
		-1,
		330,
		311,
		305,
		304,
		302,
		297,
		294,
		280,
		264,
		242,
		231,
		252,
		-1,
		-1,
		-1,
		302,
		294,
		287,
		-1,
		-1,
		289,
		272,
		253,
		251,
		-1,
		-1,
		-1,
		324,
		305,
		-1,
		-1,
		279,
		-1,
		-1,
		285,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		341,
		313,
		-1,
		-1,
		-1,
		275,
		271,
		272,
		-1,
		-1,
		-1,
		-1,
		335,
		336,
		359,
		323,
		-1,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		338,
		336,
		-1,
		-1,
		-1,
		295,
		279,
		-1,
		265,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		300,
		-1,
		300,
		275,
		282,
		-1,
		-1,
		-1,
		-1,
		313,
		305,
		313,
		-1,
		285,
		287,
		-1,
		335,
		-1,
		-1,
		328,
		319,
		-1,
		-1,
		290,
		297,
		319,
		322,
		358,
		-1,
		309
	],
	[
		-1,
		94,
		83,
		94,
		102,
		75,
		82,
		-1,
		103,
		105,
		71,
		65,
		104,
		75,
		81,
		92,
		-1,
		-1,
		-1,
		94,
		93,
		63,
		61,
		70,
		75,
		82,
		-1,
		105,
		-1,
		115,
		94,
		105,
		110,
		56,
		53,
		73,
		92,
		98,
		90,
		130,
		86,
		57,
		51,
		69,
		74,
		92,
		84,
		-1,
		57,
		47,
		69,
		73,
		85,
		68,
		-1,
		-1,
		51,
		52,
		58,
		70,
		75,
		80,
		-1,
		106,
		125,
		-1,
		-1,
		41,
		54,
		50,
		53,
		61,
		77,
		98,
		115,
		120,
		-1,
		-1,
		42,
		46,
		59,
		60,
		58,
		85,
		104,
		115,
		129,
		128,
		-1,
		30,
		48,
		57,
		66,
		72,
		61,
		65,
		83,
		114,
		120,
		123,
		-1,
		22,
		24,
		53,
		59,
		71,
		77,
		64,
		70,
		89,
		102,
		121,
		112,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		29,
		19,
		27,
		53,
		52,
		48,
		66,
		88,
		67,
		73,
		77,
		94,
		110,
		111,
		121,
		-1,
		-1,
		82,
		55,
		79,
		38,
		25,
		-1,
		15,
		34,
		40,
		44,
		49,
		57,
		85,
		83,
		-1,
		88,
		87,
		118,
		104,
		115,
		64,
		-1,
		-1,
		40,
		32,
		14,
		17,
		5,
		10,
		40,
		39,
		44,
		46,
		48,
		60,
		75,
		75,
		85,
		82,
		92,
		96,
		111,
		122,
		-1,
		-1,
		196,
		-1,
		-1,
		61,
		44,
		-1,
		9,
		16,
		0,
		17,
		8,
		33,
		48,
		52,
		60,
		63,
		51,
		70,
		67,
		91,
		87,
		79,
		104,
		108,
		114,
		132,
		133,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		39,
		16,
		13,
		6,
		30,
		29,
		-1,
		55,
		53,
		77,
		71,
		76,
		72,
		57,
		75,
		73,
		88,
		90,
		86,
		88,
		125,
		116,
		137,
		134,
		165,
		171,
		165,
		174,
		-1,
		69,
		65,
		61,
		68,
		17,
		-1,
		-1,
		34,
		-1,
		37,
		50,
		67,
		57,
		60,
		72,
		80,
		79,
		63,
		81,
		76,
		79,
		98,
		94,
		103,
		113,
		112,
		130,
		143,
		158,
		162,
		168,
		-1,
		119,
		-1,
		61,
		45,
		47,
		23,
		51,
		-1,
		54,
		38,
		58,
		69,
		69,
		-1,
		85,
		82,
		95,
		79,
		64,
		81,
		83,
		87,
		97,
		101,
		116,
		107,
		125,
		132,
		140,
		144,
		164,
		176,
		79,
		69,
		-1,
		51,
		56,
		26,
		38,
		74,
		81,
		65,
		-1,
		80,
		-1,
		87,
		100,
		-1,
		85,
		81,
		70,
		86,
		94,
		101,
		104,
		98,
		95,
		113,
		116,
		133,
		137,
		153,
		-1,
		-1,
		64,
		68,
		89,
		32,
		59,
		83,
		120,
		74,
		83,
		85,
		-1,
		105,
		106,
		103,
		104,
		90,
		83,
		84,
		100,
		106,
		102,
		97,
		100,
		122,
		150,
		128,
		140,
		-1,
		-1,
		-1,
		89,
		-1,
		-1,
		66,
		37,
		61,
		103,
		113,
		106,
		94,
		114,
		114,
		120,
		-1,
		121,
		100,
		97,
		88,
		96,
		110,
		107,
		121,
		101,
		103,
		119,
		131,
		122,
		142,
		-1,
		-1,
		-1,
		96,
		85,
		86,
		40,
		74,
		92,
		147,
		133,
		138,
		113,
		118,
		112,
		115,
		117,
		112,
		106,
		98,
		87,
		103,
		111,
		113,
		103,
		112,
		113,
		137,
		144,
		150,
		-1,
		-1,
		103,
		93,
		77,
		79,
		76,
		65,
		72,
		104,
		138,
		147,
		-1,
		117,
		-1,
		106,
		114,
		111,
		106,
		103,
		100,
		94,
		103,
		117,
		117,
		108,
		123,
		142,
		142,
		134,
		159,
		162,
		-1,
		-1,
		-1,
		96,
		113,
		88,
		65,
		46,
		82,
		-1,
		117,
		118,
		-1,
		111,
		105,
		111,
		110,
		109,
		104,
		108,
		101,
		108,
		104,
		118,
		127,
		109,
		145,
		-1,
		142,
		136,
		164,
		158,
		146,
		-1,
		-1,
		-1,
		111,
		90,
		83,
		103,
		53,
		105,
		-1,
		-1,
		102,
		95,
		-1,
		98,
		98,
		105,
		111,
		105,
		109,
		113,
		102,
		115,
		120,
		114,
		124,
		144,
		148,
		155,
		148,
		144,
		141,
		155,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		56,
		73,
		-1,
		110,
		102,
		93,
		87,
		93,
		111,
		109,
		129,
		117,
		120,
		120,
		116,
		124,
		109,
		112,
		117,
		121,
		139,
		154,
		146,
		140,
		139,
		151,
		-1,
		159,
		145,
		116,
		-1,
		-1,
		88,
		-1,
		59,
		83,
		99,
		-1,
		127,
		106,
		129,
		107,
		121,
		117,
		140,
		141,
		119,
		124,
		123,
		133,
		134,
		123,
		129,
		128,
		148,
		150,
		134,
		135,
		144,
		-1,
		165,
		152,
		110,
		106,
		95,
		115,
		62,
		75,
		86,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		131,
		129,
		130,
		121,
		127,
		134,
		137,
		138,
		128,
		117,
		123,
		122,
		144,
		130,
		128,
		147,
		163,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		68,
		62,
		-1,
		103,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		138,
		122,
		127,
		-1,
		163,
		-1,
		136,
		138,
		130,
		119,
		116,
		127,
		125,
		136,
		153,
		-1,
		115,
		100,
		93,
		83,
		97,
		68,
		-1,
		119,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		154,
		134,
		128,
		127,
		158,
		156,
		144,
		128,
		121,
		118,
		119,
		132,
		152,
		143,
		155,
		-1,
		-1,
		-1,
		120,
		100,
		106,
		64,
		85,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		171,
		159,
		149,
		139,
		173,
		172,
		147,
		140,
		126,
		128,
		126,
		128,
		133,
		154,
		155,
		168,
		-1,
		-1,
		97,
		104,
		92,
		78,
		97,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		160,
		-1,
		-1,
		151,
		149,
		159,
		143,
		130,
		150,
		153,
		143,
		127,
		142,
		154,
		162,
		167,
		-1,
		100,
		87,
		-1,
		-1,
		100,
		94,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		156,
		177,
		188,
		154,
		-1,
		159,
		154,
		134,
		148,
		155,
		145,
		140,
		134,
		137,
		155,
		172,
		-1,
		-1,
		114,
		-1,
		109,
		-1,
		-1,
		-1,
		-1,
		135,
		149,
		170,
		170,
		174,
		-1,
		162,
		150,
		136,
		153,
		158,
		155,
		146,
		138,
		143,
		140,
		153,
		167,
		171,
		137,
		-1,
		120,
		-1,
		-1,
		-1,
		153,
		168,
		216,
		193,
		166,
		161,
		154,
		148,
		144,
		160,
		166,
		177,
		145,
		141,
		142,
		146,
		145,
		162,
		172,
		-1,
		-1,
		120,
		137,
		172,
		161,
		165,
		243,
		-1,
		-1,
		170,
		161,
		152,
		155,
		154,
		157,
		151,
		148,
		153,
		158,
		146,
		155,
		173,
		172,
		-1,
		-1,
		-1,
		140,
		-1,
		155,
		-1,
		-1,
		180,
		241,
		188,
		170,
		166,
		164,
		157,
		166,
		161,
		156,
		166,
		168,
		160,
		148,
		152,
		175,
		164,
		203,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		169,
		144,
		159,
		205,
		200,
		201,
		203,
		200,
		-1,
		170,
		195,
		167,
		174,
		165,
		172,
		172,
		164,
		142,
		149,
		165,
		164,
		159,
		195,
		186,
		192,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		175,
		161,
		191,
		181,
		187,
		-1,
		-1,
		219,
		216,
		192,
		175,
		173,
		166,
		161,
		171,
		151,
		138,
		142,
		146,
		152,
		157,
		162,
		168,
		183,
		198,
		-1,
		145,
		226,
		219,
		202,
		210,
		241,
		-1,
		178,
		187,
		168,
		173,
		181,
		-1,
		-1,
		192,
		189,
		194,
		182,
		179,
		181,
		176,
		167,
		152,
		158,
		145,
		144,
		162,
		166,
		175,
		182,
		172,
		185,
		189,
		-1,
		159,
		202,
		196,
		199,
		223,
		237,
		-1,
		191,
		-1,
		-1,
		176,
		194,
		202,
		197,
		191,
		241,
		196,
		191,
		175,
		173,
		164,
		155,
		162,
		153,
		153,
		156,
		171,
		176,
		168,
		182,
		182,
		183,
		-1,
		194,
		182,
		190,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		192,
		-1,
		228,
		-1,
		209,
		213,
		204,
		207,
		189,
		176,
		168,
		160,
		176,
		151,
		161,
		157,
		158,
		167,
		178,
		190,
		189,
		190,
		268,
		223,
		190,
		181,
		228,
		243,
		247,
		-1,
		204,
		243,
		230,
		-1,
		201,
		-1,
		-1,
		-1,
		223,
		217,
		209,
		209,
		188,
		188,
		162,
		166,
		156,
		163,
		173,
		175,
		167,
		171,
		184,
		195,
		198,
		264,
		262,
		267,
		212,
		195,
		213,
		222,
		243,
		219,
		210,
		237,
		237,
		226,
		221,
		208,
		-1,
		-1,
		246,
		227,
		-1,
		-1,
		195,
		183,
		166,
		167,
		163,
		166,
		181,
		184,
		174,
		172,
		166,
		198,
		-1,
		264,
		263,
		252,
		249,
		225,
		216,
		203,
		214,
		-1,
		-1,
		222,
		238,
		251,
		255,
		268,
		293,
		-1,
		211,
		-1,
		-1,
		240,
		-1,
		-1,
		225,
		188,
		177,
		168,
		174,
		171,
		182,
		192,
		180,
		181,
		171,
		181,
		194,
		248,
		245,
		233,
		231,
		254,
		211,
		207,
		-1,
		237,
		225,
		231,
		238,
		255,
		282,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		223,
		221,
		210,
		-1,
		200,
		173,
		178,
		198,
		200,
		189,
		183,
		177,
		184,
		183,
		191,
		199,
		257,
		271,
		260,
		256,
		255,
		263,
		212,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		-1,
		261,
		237,
		-1,
		-1,
		218,
		211,
		199,
		187,
		177,
		187,
		191,
		195,
		187,
		180,
		175,
		186,
		178,
		182,
		199,
		-1,
		291,
		-1,
		243,
		236,
		251,
		266,
		274,
		-1,
		-1,
		-1,
		278,
		264,
		257,
		245,
		243,
		-1,
		252,
		236,
		217,
		-1,
		187,
		200,
		231,
		199,
		204,
		199,
		181,
		192,
		181,
		184,
		198,
		193,
		-1,
		-1,
		249,
		252,
		-1,
		-1,
		268,
		270,
		-1,
		269,
		258,
		243,
		235,
		-1,
		-1,
		224,
		220,
		-1,
		-1,
		188,
		213,
		202,
		210,
		205,
		185,
		191,
		194,
		183,
		187,
		199,
		-1,
		-1,
		256,
		257,
		262,
		-1,
		253,
		-1,
		271,
		-1,
		238,
		244,
		232,
		-1,
		-1,
		-1,
		226,
		189,
		210,
		220,
		214,
		212,
		203,
		189,
		196,
		194,
		190,
		201,
		-1,
		-1,
		-1,
		271,
		245,
		278,
		269,
		252,
		232,
		224,
		243,
		-1,
		213,
		-1,
		188,
		190,
		216,
		219,
		225,
		219,
		192,
		207,
		197,
		188,
		197,
		277,
		-1,
		247,
		280,
		244,
		238,
		214,
		218,
		234,
		-1,
		210,
		192,
		-1,
		220,
		210,
		241,
		226,
		207,
		194,
		201,
		201,
		194,
		-1,
		-1,
		-1,
		249,
		248,
		240,
		234,
		234,
		219,
		210,
		-1,
		222,
		204,
		183,
		200,
		200,
		191,
		199,
		231,
		227,
		214,
		214,
		206,
		-1,
		350,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		243,
		238,
		211,
		199,
		205,
		201,
		187,
		193,
		195,
		203,
		201,
		198,
		210,
		206,
		226,
		207,
		242,
		-1,
		345,
		-1,
		279,
		-1,
		-1,
		261,
		241,
		233,
		222,
		211,
		209,
		200,
		191,
		213,
		229,
		213,
		211,
		214,
		215,
		-1,
		334,
		333,
		-1,
		280,
		272,
		258,
		-1,
		251,
		-1,
		257,
		218,
		-1,
		220,
		200,
		-1,
		222,
		218,
		-1,
		-1,
		321,
		296,
		-1,
		-1,
		-1,
		281,
		261,
		252,
		236,
		-1,
		211,
		211,
		-1,
		-1,
		-1,
		306,
		305,
		-1,
		274,
		277,
		-1,
		267,
		258,
		266,
		213,
		217,
		-1,
		-1,
		-1,
		315,
		296,
		290,
		289,
		287,
		282,
		279,
		265,
		249,
		227,
		216,
		237,
		-1,
		-1,
		-1,
		287,
		279,
		272,
		-1,
		-1,
		274,
		257,
		238,
		236,
		-1,
		-1,
		-1,
		309,
		290,
		-1,
		-1,
		264,
		-1,
		-1,
		270,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		326,
		298,
		-1,
		-1,
		-1,
		260,
		256,
		257,
		-1,
		-1,
		-1,
		-1,
		320,
		321,
		344,
		308,
		-1,
		-1,
		-1,
		252,
		246,
		-1,
		-1,
		323,
		321,
		-1,
		-1,
		-1,
		280,
		264,
		-1,
		250,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		285,
		-1,
		285,
		260,
		267,
		-1,
		-1,
		-1,
		-1,
		298,
		290,
		298,
		-1,
		270,
		272,
		-1,
		320,
		-1,
		-1,
		313,
		304,
		-1,
		-1,
		275,
		282,
		304,
		307,
		343,
		-1,
		294
	],
	[
		-1,
		99,
		88,
		99,
		107,
		80,
		87,
		-1,
		108,
		110,
		76,
		70,
		109,
		80,
		86,
		97,
		-1,
		-1,
		-1,
		99,
		98,
		68,
		66,
		75,
		80,
		87,
		-1,
		110,
		-1,
		120,
		99,
		110,
		115,
		61,
		58,
		78,
		97,
		103,
		95,
		135,
		91,
		62,
		56,
		74,
		79,
		97,
		89,
		-1,
		62,
		52,
		74,
		78,
		90,
		73,
		-1,
		-1,
		56,
		57,
		63,
		75,
		80,
		85,
		-1,
		111,
		130,
		-1,
		-1,
		46,
		59,
		55,
		58,
		66,
		82,
		103,
		120,
		125,
		-1,
		-1,
		47,
		51,
		64,
		65,
		63,
		90,
		109,
		120,
		134,
		133,
		-1,
		35,
		53,
		62,
		71,
		77,
		66,
		70,
		88,
		119,
		125,
		128,
		-1,
		27,
		29,
		58,
		64,
		76,
		82,
		69,
		75,
		94,
		107,
		126,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		24,
		32,
		58,
		57,
		53,
		71,
		93,
		72,
		78,
		82,
		99,
		115,
		116,
		126,
		-1,
		-1,
		98,
		71,
		95,
		49,
		39,
		-1,
		20,
		39,
		45,
		49,
		54,
		62,
		90,
		88,
		-1,
		93,
		92,
		123,
		109,
		120,
		80,
		-1,
		-1,
		56,
		48,
		30,
		33,
		10,
		15,
		45,
		44,
		49,
		51,
		53,
		65,
		80,
		80,
		90,
		87,
		97,
		101,
		116,
		127,
		-1,
		-1,
		201,
		-1,
		-1,
		77,
		60,
		-1,
		25,
		32,
		16,
		0,
		13,
		38,
		53,
		57,
		65,
		68,
		56,
		75,
		72,
		96,
		92,
		84,
		109,
		113,
		119,
		137,
		138,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		55,
		32,
		29,
		22,
		46,
		45,
		-1,
		60,
		58,
		82,
		76,
		81,
		77,
		62,
		80,
		78,
		93,
		95,
		91,
		93,
		130,
		121,
		142,
		139,
		170,
		176,
		170,
		179,
		-1,
		85,
		81,
		77,
		84,
		33,
		-1,
		-1,
		50,
		-1,
		53,
		66,
		72,
		62,
		65,
		77,
		85,
		84,
		68,
		86,
		81,
		84,
		103,
		99,
		108,
		118,
		117,
		135,
		148,
		163,
		167,
		173,
		-1,
		135,
		-1,
		77,
		61,
		63,
		39,
		67,
		-1,
		70,
		54,
		74,
		74,
		74,
		-1,
		90,
		87,
		100,
		84,
		69,
		86,
		88,
		92,
		102,
		106,
		121,
		112,
		130,
		137,
		145,
		149,
		169,
		181,
		95,
		85,
		-1,
		67,
		72,
		42,
		54,
		86,
		97,
		81,
		-1,
		85,
		-1,
		92,
		105,
		-1,
		90,
		86,
		75,
		91,
		99,
		106,
		109,
		103,
		100,
		118,
		121,
		138,
		142,
		158,
		-1,
		-1,
		80,
		84,
		101,
		48,
		71,
		95,
		132,
		90,
		92,
		91,
		-1,
		110,
		111,
		108,
		109,
		95,
		88,
		89,
		105,
		111,
		107,
		102,
		105,
		127,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		78,
		49,
		73,
		115,
		121,
		114,
		102,
		119,
		119,
		126,
		-1,
		126,
		105,
		102,
		93,
		101,
		115,
		112,
		126,
		106,
		108,
		124,
		136,
		127,
		147,
		-1,
		-1,
		-1,
		108,
		97,
		98,
		52,
		86,
		104,
		152,
		138,
		143,
		118,
		124,
		124,
		120,
		122,
		117,
		111,
		103,
		92,
		108,
		116,
		118,
		108,
		117,
		118,
		142,
		149,
		155,
		-1,
		-1,
		115,
		105,
		89,
		91,
		88,
		77,
		84,
		116,
		143,
		159,
		-1,
		129,
		-1,
		118,
		126,
		116,
		111,
		108,
		105,
		99,
		108,
		122,
		122,
		113,
		128,
		147,
		147,
		139,
		164,
		167,
		-1,
		-1,
		-1,
		108,
		125,
		100,
		77,
		58,
		94,
		-1,
		129,
		130,
		-1,
		123,
		117,
		123,
		118,
		114,
		109,
		113,
		106,
		113,
		109,
		123,
		132,
		114,
		150,
		-1,
		147,
		141,
		169,
		163,
		151,
		-1,
		-1,
		-1,
		123,
		102,
		95,
		115,
		65,
		117,
		-1,
		-1,
		114,
		107,
		-1,
		110,
		110,
		117,
		116,
		110,
		114,
		118,
		107,
		120,
		125,
		119,
		129,
		149,
		153,
		160,
		153,
		149,
		146,
		160,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		85,
		-1,
		122,
		114,
		105,
		99,
		105,
		123,
		121,
		138,
		122,
		125,
		125,
		121,
		129,
		114,
		117,
		122,
		126,
		144,
		159,
		151,
		145,
		144,
		156,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		100,
		-1,
		71,
		95,
		111,
		-1,
		139,
		118,
		141,
		119,
		133,
		129,
		145,
		146,
		124,
		129,
		128,
		138,
		139,
		128,
		134,
		133,
		153,
		155,
		139,
		140,
		149,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		74,
		87,
		98,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		143,
		141,
		135,
		126,
		132,
		139,
		142,
		143,
		133,
		122,
		128,
		127,
		149,
		135,
		133,
		152,
		168,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		115,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		143,
		127,
		132,
		-1,
		168,
		-1,
		141,
		143,
		135,
		124,
		121,
		132,
		130,
		141,
		158,
		-1,
		127,
		112,
		105,
		95,
		109,
		80,
		-1,
		131,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		159,
		139,
		133,
		132,
		163,
		161,
		149,
		133,
		126,
		123,
		124,
		137,
		157,
		148,
		160,
		-1,
		-1,
		-1,
		132,
		112,
		118,
		76,
		97,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		176,
		164,
		154,
		144,
		178,
		177,
		152,
		145,
		131,
		133,
		131,
		133,
		138,
		159,
		160,
		173,
		-1,
		-1,
		109,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		157,
		173,
		165,
		136,
		165,
		-1,
		-1,
		156,
		154,
		164,
		148,
		135,
		155,
		158,
		148,
		132,
		147,
		159,
		167,
		172,
		-1,
		112,
		99,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		168,
		189,
		193,
		159,
		-1,
		164,
		159,
		139,
		153,
		160,
		150,
		145,
		139,
		142,
		160,
		177,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		147,
		161,
		182,
		175,
		179,
		-1,
		167,
		155,
		141,
		158,
		163,
		160,
		151,
		143,
		148,
		145,
		158,
		172,
		176,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		165,
		180,
		221,
		198,
		171,
		166,
		159,
		153,
		149,
		165,
		171,
		182,
		150,
		146,
		147,
		151,
		150,
		167,
		177,
		-1,
		-1,
		132,
		149,
		184,
		173,
		177,
		248,
		-1,
		-1,
		175,
		166,
		157,
		160,
		159,
		162,
		156,
		153,
		158,
		163,
		151,
		160,
		178,
		177,
		-1,
		-1,
		-1,
		152,
		-1,
		167,
		-1,
		-1,
		192,
		246,
		193,
		175,
		171,
		169,
		162,
		171,
		166,
		161,
		171,
		173,
		165,
		153,
		157,
		180,
		169,
		208,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		217,
		212,
		213,
		208,
		205,
		-1,
		175,
		200,
		172,
		179,
		170,
		177,
		177,
		169,
		147,
		154,
		170,
		169,
		164,
		200,
		191,
		197,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		187,
		173,
		203,
		193,
		199,
		-1,
		-1,
		224,
		221,
		197,
		180,
		178,
		171,
		166,
		176,
		156,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		157,
		238,
		231,
		214,
		222,
		253,
		-1,
		190,
		199,
		180,
		185,
		193,
		-1,
		-1,
		197,
		194,
		199,
		187,
		184,
		186,
		181,
		172,
		157,
		163,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		171,
		214,
		208,
		211,
		235,
		249,
		-1,
		203,
		-1,
		-1,
		188,
		206,
		212,
		202,
		196,
		246,
		201,
		196,
		180,
		178,
		169,
		160,
		167,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		206,
		194,
		202,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		204,
		-1,
		239,
		-1,
		214,
		218,
		209,
		212,
		194,
		181,
		173,
		165,
		181,
		156,
		166,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		280,
		235,
		202,
		193,
		240,
		255,
		259,
		-1,
		216,
		255,
		242,
		-1,
		213,
		-1,
		-1,
		-1,
		228,
		222,
		214,
		214,
		193,
		193,
		167,
		171,
		161,
		168,
		178,
		180,
		172,
		176,
		189,
		200,
		203,
		276,
		274,
		279,
		224,
		207,
		225,
		234,
		255,
		231,
		222,
		249,
		249,
		238,
		233,
		220,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		200,
		188,
		171,
		172,
		168,
		171,
		186,
		189,
		179,
		177,
		171,
		203,
		-1,
		276,
		275,
		264,
		261,
		237,
		228,
		215,
		226,
		-1,
		-1,
		234,
		250,
		263,
		267,
		280,
		305,
		-1,
		223,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		176,
		187,
		197,
		185,
		186,
		176,
		186,
		199,
		260,
		257,
		245,
		243,
		266,
		223,
		219,
		-1,
		249,
		237,
		243,
		250,
		267,
		294,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		178,
		183,
		203,
		205,
		194,
		188,
		182,
		189,
		188,
		196,
		204,
		269,
		283,
		272,
		268,
		267,
		275,
		224,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		266,
		249,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		196,
		200,
		192,
		185,
		180,
		191,
		183,
		187,
		204,
		-1,
		303,
		-1,
		255,
		248,
		263,
		278,
		286,
		-1,
		-1,
		-1,
		283,
		269,
		262,
		250,
		248,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		186,
		197,
		186,
		189,
		203,
		198,
		-1,
		-1,
		261,
		264,
		-1,
		-1,
		273,
		275,
		-1,
		274,
		263,
		248,
		240,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		190,
		196,
		199,
		188,
		192,
		204,
		-1,
		-1,
		268,
		269,
		274,
		-1,
		258,
		-1,
		276,
		-1,
		243,
		249,
		237,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		219,
		217,
		208,
		194,
		201,
		199,
		195,
		206,
		-1,
		-1,
		-1,
		276,
		250,
		283,
		274,
		257,
		237,
		229,
		248,
		-1,
		218,
		-1,
		193,
		195,
		221,
		224,
		230,
		224,
		197,
		212,
		202,
		193,
		202,
		282,
		-1,
		252,
		285,
		249,
		243,
		219,
		223,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		246,
		231,
		212,
		199,
		206,
		206,
		199,
		-1,
		-1,
		-1,
		254,
		253,
		245,
		239,
		239,
		224,
		215,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		236,
		232,
		219,
		219,
		211,
		-1,
		355,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		248,
		243,
		216,
		204,
		210,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		212,
		247,
		-1,
		350,
		-1,
		284,
		-1,
		-1,
		266,
		246,
		238,
		227,
		216,
		214,
		205,
		196,
		218,
		234,
		218,
		216,
		219,
		220,
		-1,
		339,
		338,
		-1,
		285,
		277,
		263,
		-1,
		256,
		-1,
		262,
		223,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		326,
		301,
		-1,
		-1,
		-1,
		286,
		266,
		257,
		241,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		311,
		310,
		-1,
		279,
		282,
		-1,
		272,
		263,
		271,
		218,
		222,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		294,
		292,
		287,
		284,
		270,
		254,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		292,
		284,
		277,
		-1,
		-1,
		279,
		262,
		243,
		241,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		303,
		-1,
		-1,
		-1,
		265,
		261,
		262,
		-1,
		-1,
		-1,
		-1,
		325,
		326,
		349,
		313,
		-1,
		-1,
		-1,
		257,
		251,
		-1,
		-1,
		328,
		326,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		255,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		290,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		280,
		287,
		309,
		312,
		348,
		-1,
		299
	],
	[
		-1,
		90,
		79,
		90,
		98,
		71,
		78,
		-1,
		99,
		101,
		67,
		61,
		100,
		71,
		77,
		88,
		-1,
		-1,
		-1,
		90,
		89,
		59,
		57,
		66,
		71,
		78,
		-1,
		101,
		-1,
		111,
		90,
		101,
		106,
		52,
		49,
		69,
		88,
		94,
		86,
		126,
		82,
		53,
		47,
		65,
		70,
		88,
		80,
		-1,
		53,
		43,
		65,
		69,
		81,
		64,
		-1,
		-1,
		47,
		48,
		54,
		66,
		71,
		76,
		-1,
		102,
		121,
		-1,
		-1,
		37,
		50,
		46,
		49,
		57,
		73,
		94,
		111,
		116,
		-1,
		-1,
		38,
		42,
		55,
		56,
		54,
		81,
		100,
		111,
		125,
		124,
		-1,
		26,
		44,
		53,
		62,
		68,
		57,
		61,
		79,
		110,
		116,
		119,
		-1,
		18,
		20,
		49,
		55,
		67,
		73,
		60,
		66,
		85,
		98,
		117,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		40,
		15,
		23,
		49,
		48,
		44,
		62,
		84,
		63,
		69,
		73,
		90,
		106,
		107,
		117,
		-1,
		-1,
		93,
		66,
		90,
		48,
		36,
		-1,
		11,
		30,
		36,
		40,
		45,
		53,
		81,
		79,
		-1,
		84,
		83,
		114,
		100,
		111,
		75,
		-1,
		-1,
		51,
		43,
		25,
		28,
		5,
		6,
		36,
		35,
		40,
		42,
		44,
		56,
		71,
		71,
		81,
		78,
		88,
		92,
		107,
		118,
		-1,
		-1,
		192,
		-1,
		-1,
		72,
		55,
		-1,
		20,
		27,
		11,
		17,
		0,
		29,
		44,
		48,
		56,
		59,
		47,
		66,
		63,
		87,
		83,
		75,
		100,
		104,
		110,
		128,
		129,
		-1,
		191,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		27,
		24,
		17,
		41,
		40,
		-1,
		51,
		49,
		73,
		67,
		72,
		68,
		53,
		71,
		69,
		84,
		86,
		82,
		84,
		121,
		112,
		133,
		130,
		161,
		167,
		161,
		170,
		-1,
		80,
		76,
		72,
		79,
		28,
		-1,
		-1,
		45,
		-1,
		48,
		61,
		63,
		53,
		56,
		68,
		76,
		75,
		59,
		77,
		72,
		75,
		94,
		90,
		99,
		109,
		108,
		126,
		139,
		154,
		158,
		164,
		-1,
		130,
		-1,
		72,
		56,
		58,
		34,
		62,
		-1,
		65,
		49,
		69,
		65,
		65,
		-1,
		81,
		78,
		91,
		75,
		60,
		77,
		79,
		83,
		93,
		97,
		112,
		103,
		121,
		128,
		136,
		140,
		160,
		172,
		90,
		80,
		-1,
		62,
		67,
		37,
		49,
		77,
		92,
		76,
		-1,
		76,
		-1,
		83,
		96,
		-1,
		81,
		77,
		66,
		82,
		90,
		97,
		100,
		94,
		91,
		109,
		112,
		129,
		133,
		149,
		-1,
		-1,
		75,
		79,
		92,
		43,
		62,
		86,
		123,
		85,
		83,
		82,
		-1,
		101,
		102,
		99,
		100,
		86,
		79,
		80,
		96,
		102,
		98,
		93,
		96,
		118,
		146,
		124,
		136,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		69,
		40,
		64,
		106,
		112,
		105,
		93,
		110,
		110,
		117,
		-1,
		117,
		96,
		93,
		84,
		92,
		106,
		103,
		117,
		97,
		99,
		115,
		127,
		118,
		138,
		-1,
		-1,
		-1,
		99,
		88,
		89,
		43,
		77,
		95,
		143,
		129,
		134,
		109,
		115,
		115,
		111,
		113,
		108,
		102,
		94,
		83,
		99,
		107,
		109,
		99,
		108,
		109,
		133,
		140,
		146,
		-1,
		-1,
		106,
		96,
		80,
		82,
		79,
		68,
		75,
		107,
		134,
		150,
		-1,
		120,
		-1,
		109,
		117,
		107,
		102,
		99,
		96,
		90,
		99,
		113,
		113,
		104,
		119,
		138,
		138,
		130,
		155,
		158,
		-1,
		-1,
		-1,
		99,
		116,
		91,
		68,
		49,
		85,
		-1,
		120,
		121,
		-1,
		114,
		108,
		114,
		109,
		105,
		100,
		104,
		97,
		104,
		100,
		114,
		123,
		105,
		141,
		-1,
		138,
		132,
		160,
		154,
		142,
		-1,
		-1,
		-1,
		114,
		93,
		86,
		106,
		56,
		108,
		-1,
		-1,
		105,
		98,
		-1,
		101,
		101,
		108,
		107,
		101,
		105,
		109,
		98,
		111,
		116,
		110,
		120,
		140,
		144,
		151,
		144,
		140,
		137,
		151,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		76,
		-1,
		113,
		105,
		96,
		90,
		96,
		114,
		112,
		129,
		113,
		116,
		116,
		112,
		120,
		105,
		108,
		113,
		117,
		135,
		150,
		142,
		136,
		135,
		147,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		91,
		-1,
		62,
		86,
		102,
		-1,
		130,
		109,
		132,
		110,
		124,
		120,
		136,
		137,
		115,
		120,
		119,
		129,
		130,
		119,
		125,
		124,
		144,
		146,
		130,
		131,
		140,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		65,
		78,
		89,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		134,
		132,
		126,
		117,
		123,
		130,
		133,
		134,
		124,
		113,
		119,
		118,
		140,
		126,
		124,
		143,
		159,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		134,
		118,
		123,
		-1,
		159,
		-1,
		132,
		134,
		126,
		115,
		112,
		123,
		121,
		132,
		149,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		122,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		150,
		130,
		124,
		123,
		154,
		152,
		140,
		124,
		117,
		114,
		115,
		128,
		148,
		139,
		151,
		-1,
		-1,
		-1,
		123,
		103,
		109,
		67,
		88,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		167,
		155,
		145,
		135,
		169,
		168,
		143,
		136,
		122,
		124,
		122,
		124,
		129,
		150,
		151,
		164,
		-1,
		-1,
		100,
		107,
		95,
		81,
		100,
		-1,
		-1,
		-1,
		148,
		164,
		156,
		127,
		156,
		-1,
		-1,
		147,
		145,
		155,
		139,
		126,
		146,
		149,
		139,
		123,
		138,
		150,
		158,
		163,
		-1,
		103,
		90,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		159,
		180,
		184,
		150,
		-1,
		155,
		150,
		130,
		144,
		151,
		141,
		136,
		130,
		133,
		151,
		168,
		-1,
		-1,
		117,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		138,
		152,
		173,
		166,
		170,
		-1,
		158,
		146,
		132,
		149,
		154,
		151,
		142,
		134,
		139,
		136,
		149,
		163,
		167,
		140,
		-1,
		123,
		-1,
		-1,
		-1,
		156,
		171,
		212,
		189,
		162,
		157,
		150,
		144,
		140,
		156,
		162,
		173,
		141,
		137,
		138,
		142,
		141,
		158,
		168,
		-1,
		-1,
		123,
		140,
		175,
		164,
		168,
		239,
		-1,
		-1,
		166,
		157,
		148,
		151,
		150,
		153,
		147,
		144,
		149,
		154,
		142,
		151,
		169,
		168,
		-1,
		-1,
		-1,
		143,
		-1,
		158,
		-1,
		-1,
		183,
		237,
		184,
		166,
		162,
		160,
		153,
		162,
		157,
		152,
		162,
		164,
		156,
		144,
		148,
		171,
		160,
		199,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		172,
		147,
		162,
		208,
		203,
		204,
		199,
		196,
		-1,
		166,
		191,
		163,
		170,
		161,
		168,
		168,
		160,
		138,
		145,
		161,
		160,
		155,
		191,
		182,
		188,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		178,
		164,
		194,
		184,
		190,
		-1,
		-1,
		215,
		212,
		188,
		171,
		169,
		162,
		157,
		167,
		147,
		134,
		138,
		142,
		148,
		153,
		158,
		164,
		179,
		194,
		-1,
		148,
		229,
		222,
		205,
		213,
		244,
		-1,
		181,
		190,
		171,
		176,
		184,
		-1,
		-1,
		188,
		185,
		190,
		178,
		175,
		177,
		172,
		163,
		148,
		154,
		141,
		140,
		158,
		162,
		171,
		178,
		168,
		181,
		185,
		-1,
		162,
		205,
		199,
		202,
		226,
		240,
		-1,
		194,
		-1,
		-1,
		179,
		197,
		203,
		193,
		187,
		237,
		192,
		187,
		171,
		169,
		160,
		151,
		158,
		149,
		149,
		152,
		167,
		172,
		164,
		178,
		178,
		179,
		-1,
		197,
		185,
		193,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		195,
		-1,
		230,
		-1,
		205,
		209,
		200,
		203,
		185,
		172,
		164,
		156,
		172,
		147,
		157,
		153,
		154,
		163,
		174,
		186,
		185,
		186,
		271,
		226,
		193,
		184,
		231,
		246,
		250,
		-1,
		207,
		246,
		233,
		-1,
		204,
		-1,
		-1,
		-1,
		219,
		213,
		205,
		205,
		184,
		184,
		158,
		162,
		152,
		159,
		169,
		171,
		163,
		167,
		180,
		191,
		194,
		267,
		265,
		270,
		215,
		198,
		216,
		225,
		246,
		222,
		213,
		240,
		240,
		229,
		224,
		211,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		191,
		179,
		162,
		163,
		159,
		162,
		177,
		180,
		170,
		168,
		162,
		194,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		206,
		217,
		-1,
		-1,
		225,
		241,
		254,
		258,
		271,
		296,
		-1,
		214,
		-1,
		-1,
		236,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		167,
		178,
		188,
		176,
		177,
		167,
		177,
		190,
		251,
		248,
		236,
		234,
		257,
		214,
		210,
		-1,
		240,
		228,
		234,
		241,
		258,
		285,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		219,
		217,
		206,
		-1,
		196,
		169,
		174,
		194,
		196,
		185,
		179,
		173,
		180,
		179,
		187,
		195,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		232,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		257,
		240,
		-1,
		-1,
		214,
		207,
		195,
		183,
		173,
		183,
		187,
		191,
		183,
		176,
		171,
		182,
		174,
		178,
		195,
		-1,
		294,
		-1,
		246,
		239,
		254,
		269,
		277,
		-1,
		-1,
		-1,
		274,
		260,
		253,
		241,
		239,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		177,
		188,
		177,
		180,
		194,
		189,
		-1,
		-1,
		252,
		255,
		-1,
		-1,
		264,
		266,
		-1,
		265,
		254,
		239,
		231,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		184,
		209,
		198,
		206,
		201,
		181,
		187,
		190,
		179,
		183,
		195,
		-1,
		-1,
		259,
		260,
		265,
		-1,
		249,
		-1,
		267,
		-1,
		234,
		240,
		228,
		-1,
		-1,
		-1,
		222,
		185,
		206,
		216,
		210,
		208,
		199,
		185,
		192,
		190,
		186,
		197,
		-1,
		-1,
		-1,
		267,
		241,
		274,
		265,
		248,
		228,
		220,
		239,
		-1,
		209,
		-1,
		184,
		186,
		212,
		215,
		221,
		215,
		188,
		203,
		193,
		184,
		193,
		273,
		-1,
		243,
		276,
		240,
		234,
		210,
		214,
		230,
		-1,
		206,
		188,
		-1,
		216,
		206,
		237,
		222,
		203,
		190,
		197,
		197,
		190,
		-1,
		-1,
		-1,
		245,
		244,
		236,
		230,
		230,
		215,
		206,
		-1,
		218,
		200,
		179,
		196,
		196,
		187,
		195,
		227,
		223,
		210,
		210,
		202,
		-1,
		346,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		239,
		234,
		207,
		195,
		201,
		197,
		183,
		189,
		191,
		199,
		197,
		194,
		206,
		202,
		222,
		203,
		238,
		-1,
		341,
		-1,
		275,
		-1,
		-1,
		257,
		237,
		229,
		218,
		207,
		205,
		196,
		187,
		209,
		225,
		209,
		207,
		210,
		211,
		-1,
		330,
		329,
		-1,
		276,
		268,
		254,
		-1,
		247,
		-1,
		253,
		214,
		-1,
		216,
		196,
		-1,
		218,
		214,
		-1,
		-1,
		317,
		292,
		-1,
		-1,
		-1,
		277,
		257,
		248,
		232,
		-1,
		207,
		207,
		-1,
		-1,
		-1,
		302,
		301,
		-1,
		270,
		273,
		-1,
		263,
		254,
		262,
		209,
		213,
		-1,
		-1,
		-1,
		311,
		292,
		286,
		285,
		283,
		278,
		275,
		261,
		245,
		223,
		212,
		233,
		-1,
		-1,
		-1,
		283,
		275,
		268,
		-1,
		-1,
		270,
		253,
		234,
		232,
		-1,
		-1,
		-1,
		305,
		286,
		-1,
		-1,
		260,
		-1,
		-1,
		266,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		322,
		294,
		-1,
		-1,
		-1,
		256,
		252,
		253,
		-1,
		-1,
		-1,
		-1,
		316,
		317,
		340,
		304,
		-1,
		-1,
		-1,
		248,
		242,
		-1,
		-1,
		319,
		317,
		-1,
		-1,
		-1,
		276,
		260,
		-1,
		246,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		281,
		-1,
		281,
		256,
		263,
		-1,
		-1,
		-1,
		-1,
		294,
		286,
		294,
		-1,
		266,
		268,
		-1,
		316,
		-1,
		-1,
		309,
		300,
		-1,
		-1,
		271,
		278,
		300,
		303,
		339,
		-1,
		290
	],
	[
		-1,
		108,
		97,
		108,
		116,
		89,
		96,
		-1,
		117,
		119,
		85,
		79,
		118,
		89,
		95,
		106,
		-1,
		-1,
		-1,
		108,
		107,
		77,
		75,
		84,
		89,
		96,
		-1,
		119,
		-1,
		129,
		108,
		119,
		124,
		70,
		67,
		87,
		106,
		112,
		104,
		144,
		100,
		71,
		65,
		83,
		88,
		106,
		98,
		-1,
		71,
		61,
		83,
		87,
		99,
		82,
		-1,
		-1,
		65,
		66,
		72,
		84,
		89,
		94,
		-1,
		120,
		139,
		-1,
		-1,
		55,
		68,
		64,
		67,
		75,
		91,
		112,
		129,
		134,
		-1,
		-1,
		56,
		60,
		73,
		74,
		72,
		99,
		118,
		129,
		143,
		142,
		-1,
		44,
		62,
		71,
		80,
		86,
		75,
		79,
		97,
		128,
		134,
		137,
		-1,
		36,
		38,
		67,
		73,
		85,
		91,
		78,
		84,
		103,
		116,
		135,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		33,
		41,
		67,
		66,
		62,
		80,
		102,
		81,
		87,
		91,
		108,
		124,
		125,
		135,
		-1,
		-1,
		116,
		89,
		113,
		71,
		59,
		-1,
		29,
		48,
		54,
		58,
		63,
		71,
		99,
		97,
		-1,
		102,
		101,
		132,
		118,
		129,
		98,
		-1,
		-1,
		74,
		66,
		48,
		51,
		28,
		24,
		54,
		53,
		58,
		60,
		62,
		74,
		89,
		89,
		99,
		96,
		106,
		110,
		125,
		136,
		-1,
		-1,
		210,
		-1,
		-1,
		95,
		78,
		-1,
		43,
		50,
		34,
		40,
		26,
		0,
		62,
		66,
		73,
		77,
		65,
		84,
		81,
		105,
		101,
		93,
		118,
		122,
		128,
		146,
		147,
		-1,
		209,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		50,
		47,
		40,
		64,
		63,
		-1,
		41,
		39,
		63,
		66,
		78,
		86,
		71,
		89,
		87,
		102,
		104,
		100,
		102,
		139,
		130,
		151,
		148,
		179,
		185,
		179,
		188,
		-1,
		103,
		99,
		95,
		102,
		51,
		-1,
		-1,
		68,
		-1,
		71,
		78,
		53,
		43,
		46,
		67,
		67,
		93,
		77,
		95,
		90,
		93,
		112,
		108,
		117,
		127,
		126,
		144,
		157,
		172,
		176,
		182,
		-1,
		153,
		-1,
		95,
		79,
		81,
		57,
		85,
		-1,
		88,
		72,
		70,
		55,
		55,
		-1,
		71,
		68,
		82,
		89,
		78,
		95,
		97,
		101,
		111,
		115,
		130,
		121,
		139,
		146,
		154,
		158,
		178,
		190,
		113,
		103,
		-1,
		85,
		90,
		60,
		72,
		95,
		115,
		91,
		-1,
		66,
		-1,
		73,
		86,
		-1,
		88,
		92,
		84,
		100,
		108,
		115,
		118,
		112,
		109,
		127,
		130,
		147,
		151,
		167,
		-1,
		-1,
		98,
		102,
		110,
		61,
		80,
		104,
		137,
		84,
		73,
		72,
		-1,
		91,
		119,
		116,
		117,
		104,
		97,
		98,
		114,
		120,
		116,
		111,
		114,
		136,
		164,
		142,
		154,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		87,
		58,
		82,
		124,
		102,
		95,
		83,
		100,
		100,
		107,
		-1,
		135,
		114,
		111,
		102,
		110,
		124,
		121,
		135,
		115,
		117,
		133,
		145,
		136,
		156,
		-1,
		-1,
		-1,
		117,
		106,
		107,
		61,
		95,
		113,
		133,
		119,
		124,
		99,
		105,
		110,
		128,
		131,
		126,
		120,
		112,
		101,
		117,
		125,
		127,
		117,
		126,
		127,
		151,
		158,
		164,
		-1,
		-1,
		124,
		114,
		98,
		100,
		97,
		86,
		93,
		125,
		124,
		168,
		-1,
		138,
		-1,
		116,
		135,
		125,
		120,
		117,
		114,
		108,
		117,
		131,
		131,
		122,
		137,
		156,
		156,
		148,
		173,
		176,
		-1,
		-1,
		-1,
		117,
		134,
		109,
		86,
		67,
		103,
		-1,
		138,
		139,
		-1,
		132,
		126,
		132,
		127,
		123,
		118,
		122,
		115,
		122,
		118,
		132,
		141,
		123,
		159,
		-1,
		156,
		150,
		178,
		172,
		160,
		-1,
		-1,
		-1,
		132,
		111,
		104,
		124,
		74,
		126,
		-1,
		-1,
		123,
		116,
		-1,
		119,
		119,
		126,
		125,
		119,
		123,
		127,
		116,
		129,
		134,
		128,
		138,
		158,
		162,
		169,
		162,
		158,
		155,
		169,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		94,
		-1,
		131,
		123,
		114,
		108,
		114,
		132,
		130,
		147,
		131,
		134,
		134,
		130,
		138,
		123,
		126,
		131,
		135,
		153,
		168,
		160,
		154,
		153,
		165,
		-1,
		180,
		166,
		137,
		-1,
		-1,
		109,
		-1,
		80,
		104,
		120,
		-1,
		148,
		127,
		150,
		128,
		142,
		138,
		154,
		155,
		133,
		138,
		137,
		147,
		148,
		137,
		143,
		142,
		162,
		164,
		148,
		149,
		158,
		-1,
		186,
		173,
		131,
		127,
		116,
		136,
		83,
		96,
		107,
		-1,
		-1,
		192,
		-1,
		126,
		143,
		152,
		150,
		144,
		135,
		141,
		148,
		151,
		152,
		142,
		131,
		137,
		136,
		158,
		144,
		142,
		161,
		177,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		102,
		89,
		83,
		-1,
		124,
		-1,
		170,
		160,
		144,
		129,
		162,
		-1,
		152,
		136,
		141,
		-1,
		177,
		-1,
		150,
		152,
		144,
		133,
		130,
		141,
		139,
		150,
		167,
		-1,
		136,
		121,
		114,
		104,
		118,
		89,
		-1,
		140,
		-1,
		-1,
		157,
		151,
		151,
		135,
		138,
		168,
		148,
		142,
		141,
		172,
		170,
		158,
		142,
		135,
		132,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		141,
		121,
		127,
		85,
		106,
		-1,
		-1,
		219,
		174,
		160,
		-1,
		144,
		185,
		173,
		163,
		153,
		187,
		186,
		161,
		154,
		140,
		142,
		140,
		142,
		147,
		168,
		169,
		182,
		-1,
		-1,
		118,
		125,
		113,
		99,
		118,
		-1,
		-1,
		-1,
		166,
		182,
		174,
		145,
		174,
		-1,
		-1,
		165,
		163,
		173,
		157,
		144,
		164,
		167,
		157,
		141,
		156,
		168,
		176,
		181,
		-1,
		121,
		108,
		-1,
		-1,
		121,
		115,
		-1,
		-1,
		-1,
		-1,
		199,
		165,
		177,
		198,
		202,
		168,
		-1,
		173,
		168,
		148,
		162,
		169,
		159,
		154,
		148,
		151,
		169,
		186,
		-1,
		-1,
		135,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		156,
		170,
		191,
		184,
		188,
		-1,
		176,
		164,
		150,
		167,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		158,
		-1,
		141,
		-1,
		-1,
		-1,
		174,
		189,
		230,
		207,
		180,
		175,
		168,
		162,
		158,
		174,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		141,
		158,
		193,
		182,
		186,
		257,
		-1,
		-1,
		184,
		175,
		166,
		169,
		168,
		171,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		186,
		-1,
		-1,
		-1,
		161,
		-1,
		176,
		-1,
		-1,
		201,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		182,
		174,
		162,
		166,
		189,
		178,
		217,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		190,
		165,
		180,
		226,
		221,
		222,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		179,
		186,
		186,
		178,
		156,
		163,
		179,
		178,
		173,
		209,
		200,
		206,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		196,
		182,
		212,
		202,
		208,
		-1,
		-1,
		233,
		230,
		206,
		189,
		187,
		180,
		175,
		185,
		165,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		166,
		247,
		240,
		223,
		231,
		262,
		-1,
		199,
		208,
		189,
		194,
		202,
		-1,
		-1,
		206,
		203,
		208,
		196,
		193,
		195,
		190,
		181,
		166,
		172,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		180,
		223,
		217,
		220,
		244,
		258,
		-1,
		212,
		-1,
		-1,
		197,
		215,
		221,
		211,
		205,
		255,
		210,
		205,
		189,
		187,
		178,
		169,
		176,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		215,
		203,
		211,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		213,
		-1,
		248,
		-1,
		223,
		227,
		218,
		221,
		203,
		190,
		182,
		174,
		190,
		165,
		175,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		289,
		244,
		211,
		202,
		249,
		264,
		268,
		-1,
		225,
		264,
		251,
		-1,
		222,
		-1,
		-1,
		-1,
		237,
		231,
		223,
		223,
		202,
		202,
		176,
		180,
		170,
		177,
		187,
		189,
		181,
		185,
		198,
		209,
		212,
		285,
		283,
		288,
		233,
		216,
		234,
		243,
		264,
		240,
		231,
		258,
		258,
		247,
		242,
		229,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		209,
		197,
		180,
		181,
		177,
		180,
		195,
		198,
		188,
		186,
		180,
		212,
		-1,
		285,
		284,
		273,
		270,
		246,
		237,
		224,
		235,
		-1,
		-1,
		243,
		259,
		272,
		276,
		289,
		314,
		-1,
		232,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		202,
		191,
		182,
		188,
		185,
		196,
		206,
		194,
		195,
		185,
		195,
		208,
		269,
		266,
		254,
		252,
		275,
		232,
		228,
		-1,
		258,
		246,
		252,
		259,
		276,
		303,
		-1,
		-1,
		248,
		239,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		187,
		192,
		212,
		214,
		203,
		197,
		191,
		198,
		197,
		205,
		213,
		278,
		292,
		281,
		277,
		276,
		284,
		233,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		-1,
		275,
		258,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		205,
		209,
		201,
		194,
		189,
		200,
		192,
		196,
		213,
		-1,
		312,
		-1,
		264,
		257,
		272,
		287,
		295,
		-1,
		-1,
		-1,
		292,
		278,
		271,
		259,
		257,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		245,
		213,
		218,
		213,
		195,
		206,
		195,
		198,
		212,
		207,
		-1,
		-1,
		270,
		273,
		-1,
		-1,
		282,
		284,
		-1,
		283,
		272,
		257,
		249,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		202,
		227,
		216,
		224,
		219,
		199,
		205,
		208,
		197,
		201,
		213,
		-1,
		-1,
		277,
		278,
		283,
		-1,
		267,
		-1,
		285,
		-1,
		252,
		258,
		246,
		-1,
		-1,
		-1,
		240,
		203,
		224,
		234,
		228,
		226,
		217,
		203,
		210,
		208,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		259,
		292,
		283,
		266,
		246,
		238,
		257,
		-1,
		227,
		-1,
		202,
		204,
		230,
		233,
		239,
		233,
		206,
		221,
		211,
		202,
		211,
		291,
		-1,
		261,
		294,
		258,
		252,
		228,
		232,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		255,
		240,
		221,
		208,
		215,
		215,
		208,
		-1,
		-1,
		-1,
		263,
		262,
		254,
		248,
		248,
		233,
		224,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		245,
		241,
		228,
		228,
		220,
		-1,
		364,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		257,
		252,
		225,
		213,
		219,
		215,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		221,
		256,
		-1,
		359,
		-1,
		293,
		-1,
		-1,
		275,
		255,
		247,
		236,
		225,
		223,
		214,
		205,
		227,
		243,
		227,
		225,
		228,
		229,
		-1,
		348,
		347,
		-1,
		294,
		286,
		272,
		-1,
		265,
		-1,
		271,
		232,
		-1,
		234,
		214,
		-1,
		236,
		232,
		-1,
		-1,
		335,
		310,
		-1,
		-1,
		-1,
		295,
		275,
		266,
		250,
		-1,
		225,
		225,
		-1,
		-1,
		-1,
		320,
		319,
		-1,
		288,
		291,
		-1,
		281,
		272,
		280,
		227,
		231,
		-1,
		-1,
		-1,
		329,
		310,
		304,
		303,
		301,
		296,
		293,
		279,
		263,
		241,
		230,
		251,
		-1,
		-1,
		-1,
		301,
		293,
		286,
		-1,
		-1,
		288,
		271,
		252,
		250,
		-1,
		-1,
		-1,
		323,
		304,
		-1,
		-1,
		278,
		-1,
		-1,
		284,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		312,
		-1,
		-1,
		-1,
		274,
		270,
		271,
		-1,
		-1,
		-1,
		-1,
		334,
		335,
		358,
		322,
		-1,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		337,
		335,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		264,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		299,
		-1,
		299,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		312,
		-1,
		284,
		286,
		-1,
		334,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		289,
		296,
		318,
		321,
		357,
		-1,
		308
	],
	[
		-1,
		105,
		94,
		105,
		113,
		86,
		93,
		-1,
		114,
		116,
		82,
		76,
		115,
		86,
		92,
		103,
		-1,
		-1,
		-1,
		105,
		104,
		74,
		72,
		81,
		86,
		93,
		-1,
		116,
		-1,
		126,
		105,
		116,
		121,
		67,
		64,
		84,
		103,
		109,
		101,
		141,
		97,
		68,
		62,
		80,
		85,
		103,
		95,
		-1,
		68,
		58,
		80,
		84,
		96,
		79,
		-1,
		-1,
		62,
		63,
		69,
		81,
		86,
		91,
		-1,
		117,
		136,
		-1,
		-1,
		52,
		65,
		61,
		64,
		72,
		88,
		109,
		126,
		131,
		-1,
		-1,
		53,
		57,
		70,
		71,
		69,
		96,
		115,
		126,
		140,
		139,
		-1,
		41,
		59,
		68,
		77,
		83,
		72,
		76,
		94,
		125,
		131,
		134,
		-1,
		43,
		45,
		57,
		65,
		70,
		77,
		75,
		81,
		100,
		113,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		40,
		33,
		50,
		47,
		40,
		58,
		80,
		78,
		84,
		88,
		105,
		121,
		122,
		132,
		-1,
		-1,
		134,
		107,
		131,
		89,
		65,
		-1,
		36,
		26,
		32,
		36,
		41,
		49,
		77,
		77,
		-1,
		99,
		98,
		129,
		115,
		126,
		116,
		-1,
		-1,
		92,
		84,
		66,
		69,
		46,
		42,
		16,
		15,
		36,
		38,
		40,
		52,
		67,
		67,
		77,
		93,
		103,
		107,
		122,
		133,
		-1,
		-1,
		207,
		-1,
		-1,
		113,
		96,
		-1,
		61,
		68,
		52,
		58,
		44,
		64,
		0,
		28,
		46,
		55,
		43,
		62,
		59,
		83,
		79,
		90,
		115,
		119,
		125,
		143,
		144,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		68,
		65,
		58,
		82,
		81,
		-1,
		75,
		63,
		64,
		49,
		61,
		64,
		49,
		67,
		65,
		80,
		82,
		97,
		99,
		133,
		127,
		148,
		145,
		176,
		182,
		176,
		185,
		-1,
		121,
		117,
		113,
		120,
		69,
		-1,
		-1,
		86,
		-1,
		89,
		102,
		87,
		60,
		63,
		50,
		58,
		71,
		55,
		73,
		68,
		71,
		91,
		104,
		111,
		124,
		123,
		141,
		154,
		169,
		173,
		179,
		-1,
		171,
		-1,
		113,
		97,
		99,
		75,
		103,
		-1,
		106,
		90,
		104,
		89,
		89,
		-1,
		66,
		63,
		73,
		71,
		56,
		73,
		75,
		79,
		90,
		111,
		127,
		118,
		136,
		143,
		151,
		155,
		175,
		187,
		131,
		121,
		-1,
		103,
		108,
		78,
		90,
		113,
		133,
		117,
		-1,
		100,
		-1,
		68,
		81,
		-1,
		77,
		73,
		62,
		78,
		86,
		93,
		97,
		109,
		106,
		124,
		127,
		144,
		148,
		164,
		-1,
		-1,
		116,
		120,
		128,
		79,
		98,
		122,
		159,
		118,
		107,
		106,
		-1,
		86,
		98,
		95,
		96,
		82,
		75,
		76,
		92,
		98,
		94,
		108,
		111,
		133,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		105,
		76,
		100,
		142,
		136,
		129,
		117,
		125,
		123,
		110,
		-1,
		113,
		92,
		89,
		80,
		88,
		102,
		99,
		113,
		112,
		114,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		79,
		113,
		131,
		158,
		144,
		149,
		124,
		112,
		120,
		107,
		109,
		104,
		98,
		90,
		79,
		95,
		103,
		105,
		114,
		123,
		124,
		148,
		155,
		161,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		104,
		111,
		143,
		149,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		92,
		86,
		95,
		109,
		120,
		116,
		123,
		153,
		153,
		145,
		170,
		173,
		-1,
		-1,
		-1,
		135,
		152,
		127,
		104,
		85,
		121,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		96,
		100,
		93,
		100,
		96,
		110,
		121,
		108,
		144,
		-1,
		153,
		147,
		160,
		150,
		138,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		92,
		144,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		103,
		97,
		101,
		105,
		94,
		107,
		112,
		113,
		123,
		143,
		147,
		151,
		140,
		136,
		133,
		147,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		112,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		112,
		112,
		108,
		116,
		101,
		104,
		116,
		120,
		138,
		146,
		138,
		132,
		131,
		143,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		127,
		-1,
		98,
		122,
		138,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		116,
		115,
		125,
		126,
		115,
		128,
		120,
		142,
		142,
		126,
		127,
		136,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		101,
		114,
		125,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		126,
		129,
		130,
		120,
		109,
		115,
		114,
		136,
		122,
		120,
		139,
		155,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		130,
		114,
		119,
		-1,
		155,
		-1,
		128,
		130,
		122,
		111,
		108,
		119,
		117,
		128,
		145,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		158,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		146,
		126,
		120,
		119,
		150,
		148,
		136,
		120,
		113,
		110,
		111,
		124,
		144,
		135,
		147,
		-1,
		-1,
		-1,
		159,
		139,
		145,
		103,
		124,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		163,
		151,
		141,
		131,
		165,
		164,
		139,
		132,
		118,
		120,
		118,
		120,
		125,
		146,
		147,
		160,
		-1,
		-1,
		136,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		163,
		179,
		171,
		142,
		152,
		-1,
		-1,
		143,
		141,
		151,
		135,
		122,
		142,
		145,
		135,
		119,
		134,
		146,
		154,
		159,
		-1,
		139,
		126,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		174,
		176,
		180,
		146,
		-1,
		151,
		146,
		126,
		140,
		147,
		137,
		132,
		126,
		129,
		147,
		164,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		153,
		167,
		169,
		162,
		166,
		-1,
		154,
		142,
		128,
		145,
		150,
		147,
		138,
		130,
		135,
		132,
		145,
		159,
		163,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		171,
		186,
		208,
		185,
		158,
		153,
		146,
		140,
		136,
		152,
		158,
		169,
		137,
		133,
		134,
		138,
		137,
		154,
		164,
		-1,
		-1,
		159,
		176,
		197,
		179,
		183,
		235,
		-1,
		-1,
		162,
		153,
		144,
		147,
		146,
		149,
		143,
		140,
		145,
		150,
		138,
		147,
		165,
		164,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		198,
		233,
		180,
		162,
		158,
		156,
		149,
		158,
		153,
		148,
		158,
		160,
		152,
		140,
		144,
		167,
		156,
		195,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		244,
		218,
		225,
		195,
		192,
		-1,
		162,
		187,
		159,
		166,
		157,
		164,
		164,
		156,
		134,
		141,
		157,
		156,
		151,
		187,
		178,
		184,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		214,
		200,
		230,
		220,
		223,
		-1,
		-1,
		211,
		208,
		184,
		167,
		165,
		158,
		153,
		163,
		143,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		217,
		226,
		207,
		212,
		214,
		-1,
		-1,
		184,
		181,
		186,
		174,
		171,
		173,
		168,
		159,
		144,
		150,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		230,
		-1,
		-1,
		215,
		215,
		199,
		189,
		183,
		233,
		188,
		183,
		167,
		165,
		156,
		147,
		154,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		231,
		-1,
		226,
		-1,
		201,
		205,
		196,
		199,
		181,
		168,
		160,
		152,
		168,
		143,
		153,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		302,
		258,
		229,
		220,
		267,
		282,
		286,
		-1,
		243,
		282,
		269,
		-1,
		240,
		-1,
		-1,
		-1,
		215,
		209,
		201,
		201,
		180,
		180,
		154,
		158,
		148,
		155,
		165,
		167,
		159,
		163,
		176,
		187,
		190,
		298,
		289,
		302,
		247,
		234,
		252,
		261,
		282,
		258,
		249,
		276,
		276,
		265,
		260,
		247,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		187,
		175,
		158,
		159,
		155,
		158,
		173,
		176,
		166,
		164,
		158,
		190,
		-1,
		291,
		290,
		279,
		276,
		252,
		243,
		238,
		253,
		-1,
		-1,
		260,
		277,
		271,
		275,
		291,
		316,
		-1,
		247,
		-1,
		-1,
		232,
		-1,
		-1,
		217,
		180,
		169,
		160,
		166,
		163,
		174,
		184,
		172,
		173,
		163,
		173,
		186,
		275,
		272,
		260,
		258,
		281,
		246,
		234,
		-1,
		247,
		245,
		251,
		258,
		275,
		305,
		-1,
		-1,
		263,
		243,
		-1,
		-1,
		215,
		213,
		202,
		-1,
		192,
		165,
		170,
		190,
		192,
		181,
		175,
		169,
		176,
		175,
		183,
		191,
		284,
		298,
		287,
		283,
		282,
		290,
		239,
		232,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		-1,
		253,
		249,
		-1,
		-1,
		210,
		203,
		191,
		179,
		169,
		179,
		183,
		187,
		179,
		172,
		167,
		178,
		170,
		174,
		191,
		-1,
		318,
		-1,
		270,
		246,
		260,
		275,
		283,
		-1,
		-1,
		-1,
		270,
		256,
		249,
		237,
		235,
		-1,
		244,
		228,
		209,
		-1,
		179,
		192,
		223,
		191,
		196,
		191,
		173,
		184,
		173,
		176,
		190,
		185,
		-1,
		-1,
		258,
		261,
		-1,
		-1,
		260,
		262,
		-1,
		261,
		250,
		235,
		227,
		-1,
		-1,
		216,
		212,
		-1,
		-1,
		180,
		205,
		194,
		202,
		197,
		177,
		183,
		186,
		175,
		179,
		191,
		-1,
		-1,
		265,
		266,
		267,
		-1,
		245,
		-1,
		263,
		-1,
		230,
		236,
		224,
		-1,
		-1,
		-1,
		218,
		181,
		202,
		212,
		206,
		204,
		195,
		181,
		188,
		186,
		182,
		193,
		-1,
		-1,
		-1,
		263,
		237,
		270,
		261,
		244,
		224,
		216,
		235,
		-1,
		205,
		-1,
		180,
		182,
		208,
		211,
		217,
		211,
		184,
		199,
		189,
		180,
		189,
		269,
		-1,
		239,
		272,
		236,
		230,
		206,
		210,
		226,
		-1,
		202,
		184,
		-1,
		212,
		202,
		233,
		218,
		199,
		186,
		193,
		193,
		186,
		-1,
		-1,
		-1,
		241,
		240,
		232,
		226,
		226,
		211,
		202,
		-1,
		214,
		196,
		175,
		192,
		192,
		183,
		191,
		223,
		219,
		206,
		206,
		198,
		-1,
		342,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		235,
		230,
		203,
		191,
		197,
		193,
		179,
		185,
		187,
		195,
		193,
		190,
		202,
		198,
		218,
		199,
		234,
		-1,
		337,
		-1,
		271,
		-1,
		-1,
		253,
		233,
		225,
		214,
		203,
		201,
		192,
		183,
		205,
		221,
		205,
		203,
		206,
		207,
		-1,
		326,
		325,
		-1,
		272,
		264,
		250,
		-1,
		243,
		-1,
		249,
		210,
		-1,
		212,
		192,
		-1,
		214,
		210,
		-1,
		-1,
		313,
		288,
		-1,
		-1,
		-1,
		273,
		253,
		244,
		228,
		-1,
		203,
		203,
		-1,
		-1,
		-1,
		298,
		297,
		-1,
		266,
		269,
		-1,
		259,
		250,
		258,
		205,
		209,
		-1,
		-1,
		-1,
		307,
		288,
		282,
		281,
		279,
		274,
		271,
		257,
		241,
		219,
		208,
		229,
		-1,
		-1,
		-1,
		279,
		271,
		264,
		-1,
		-1,
		266,
		249,
		230,
		228,
		-1,
		-1,
		-1,
		301,
		282,
		-1,
		-1,
		256,
		-1,
		-1,
		262,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		318,
		290,
		-1,
		-1,
		-1,
		252,
		248,
		249,
		-1,
		-1,
		-1,
		-1,
		312,
		313,
		336,
		300,
		-1,
		-1,
		-1,
		244,
		238,
		-1,
		-1,
		315,
		313,
		-1,
		-1,
		-1,
		272,
		256,
		-1,
		242,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		277,
		-1,
		277,
		252,
		259,
		-1,
		-1,
		-1,
		-1,
		290,
		282,
		290,
		-1,
		262,
		264,
		-1,
		312,
		-1,
		-1,
		305,
		296,
		-1,
		-1,
		267,
		274,
		296,
		299,
		335,
		-1,
		286
	],
	[
		-1,
		99,
		88,
		99,
		107,
		80,
		87,
		-1,
		108,
		110,
		76,
		70,
		109,
		80,
		86,
		97,
		-1,
		-1,
		-1,
		99,
		98,
		68,
		66,
		75,
		80,
		87,
		-1,
		110,
		-1,
		120,
		99,
		110,
		115,
		61,
		58,
		78,
		97,
		103,
		95,
		135,
		91,
		62,
		56,
		74,
		79,
		97,
		89,
		-1,
		62,
		52,
		74,
		78,
		90,
		73,
		-1,
		-1,
		56,
		57,
		63,
		75,
		80,
		85,
		-1,
		111,
		130,
		-1,
		-1,
		46,
		59,
		55,
		58,
		66,
		82,
		103,
		120,
		125,
		-1,
		-1,
		47,
		51,
		64,
		65,
		63,
		90,
		109,
		120,
		134,
		133,
		-1,
		35,
		53,
		62,
		71,
		77,
		66,
		70,
		88,
		119,
		125,
		128,
		-1,
		44,
		45,
		44,
		53,
		64,
		71,
		69,
		75,
		94,
		107,
		126,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		42,
		27,
		44,
		33,
		30,
		52,
		74,
		72,
		78,
		82,
		99,
		115,
		116,
		126,
		-1,
		-1,
		136,
		109,
		133,
		91,
		67,
		-1,
		38,
		20,
		22,
		26,
		35,
		43,
		71,
		71,
		-1,
		93,
		92,
		123,
		109,
		120,
		118,
		-1,
		-1,
		94,
		86,
		68,
		71,
		48,
		44,
		16,
		15,
		18,
		23,
		30,
		46,
		61,
		61,
		71,
		87,
		97,
		101,
		116,
		127,
		-1,
		-1,
		201,
		-1,
		-1,
		115,
		98,
		-1,
		63,
		70,
		54,
		60,
		46,
		66,
		26,
		0,
		20,
		45,
		33,
		53,
		53,
		77,
		73,
		84,
		109,
		113,
		119,
		137,
		138,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		70,
		67,
		60,
		84,
		83,
		-1,
		49,
		37,
		38,
		23,
		35,
		48,
		39,
		61,
		59,
		74,
		76,
		91,
		93,
		127,
		121,
		142,
		139,
		170,
		176,
		170,
		179,
		-1,
		123,
		119,
		115,
		122,
		71,
		-1,
		-1,
		88,
		-1,
		91,
		86,
		61,
		34,
		37,
		24,
		32,
		55,
		45,
		63,
		62,
		65,
		85,
		98,
		105,
		118,
		117,
		135,
		148,
		163,
		167,
		173,
		-1,
		173,
		-1,
		115,
		99,
		101,
		77,
		105,
		-1,
		108,
		92,
		78,
		63,
		63,
		-1,
		40,
		37,
		47,
		54,
		47,
		64,
		69,
		73,
		84,
		105,
		121,
		112,
		130,
		137,
		145,
		149,
		169,
		181,
		133,
		123,
		-1,
		105,
		110,
		80,
		92,
		115,
		135,
		99,
		-1,
		74,
		-1,
		42,
		55,
		-1,
		53,
		57,
		53,
		69,
		80,
		87,
		91,
		103,
		100,
		118,
		121,
		138,
		142,
		158,
		-1,
		-1,
		118,
		122,
		130,
		81,
		100,
		124,
		145,
		92,
		81,
		80,
		-1,
		60,
		84,
		81,
		82,
		73,
		66,
		67,
		86,
		92,
		85,
		102,
		105,
		127,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		107,
		78,
		102,
		144,
		110,
		103,
		91,
		99,
		97,
		84,
		-1,
		104,
		83,
		80,
		71,
		79,
		93,
		90,
		104,
		106,
		107,
		124,
		136,
		127,
		147,
		-1,
		-1,
		-1,
		137,
		126,
		127,
		81,
		115,
		133,
		132,
		118,
		123,
		98,
		86,
		94,
		93,
		100,
		95,
		89,
		81,
		70,
		86,
		94,
		96,
		105,
		114,
		118,
		142,
		149,
		155,
		-1,
		-1,
		144,
		134,
		118,
		120,
		117,
		106,
		113,
		145,
		123,
		172,
		-1,
		126,
		-1,
		100,
		110,
		94,
		89,
		86,
		83,
		77,
		86,
		100,
		111,
		107,
		114,
		147,
		147,
		139,
		161,
		164,
		-1,
		-1,
		-1,
		137,
		154,
		129,
		106,
		87,
		123,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		96,
		92,
		87,
		91,
		84,
		91,
		87,
		101,
		112,
		99,
		135,
		-1,
		147,
		141,
		151,
		141,
		129,
		-1,
		-1,
		-1,
		152,
		131,
		124,
		144,
		94,
		146,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		96,
		94,
		88,
		92,
		96,
		85,
		98,
		103,
		104,
		114,
		134,
		138,
		142,
		131,
		127,
		124,
		138,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		114,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		116,
		100,
		103,
		103,
		99,
		107,
		92,
		95,
		107,
		111,
		129,
		137,
		129,
		123,
		122,
		134,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		129,
		-1,
		100,
		124,
		140,
		-1,
		144,
		123,
		138,
		116,
		112,
		108,
		123,
		124,
		102,
		107,
		106,
		116,
		117,
		106,
		119,
		111,
		133,
		133,
		117,
		118,
		127,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		103,
		106,
		127,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		122,
		120,
		113,
		104,
		110,
		117,
		120,
		121,
		111,
		100,
		106,
		105,
		127,
		113,
		111,
		130,
		146,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		121,
		105,
		110,
		-1,
		146,
		-1,
		119,
		121,
		113,
		102,
		99,
		110,
		108,
		119,
		136,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		160,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		137,
		117,
		111,
		110,
		141,
		139,
		127,
		111,
		104,
		101,
		102,
		115,
		135,
		126,
		138,
		-1,
		-1,
		-1,
		161,
		141,
		147,
		105,
		126,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		154,
		142,
		132,
		122,
		156,
		155,
		130,
		123,
		109,
		111,
		109,
		111,
		116,
		137,
		138,
		151,
		-1,
		-1,
		138,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		143,
		-1,
		-1,
		134,
		132,
		142,
		126,
		113,
		133,
		136,
		126,
		110,
		125,
		137,
		145,
		150,
		-1,
		141,
		128,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		187,
		153,
		165,
		167,
		171,
		137,
		-1,
		142,
		137,
		117,
		131,
		138,
		128,
		123,
		117,
		120,
		138,
		155,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		144,
		158,
		160,
		153,
		157,
		-1,
		145,
		133,
		119,
		136,
		141,
		138,
		129,
		121,
		126,
		123,
		136,
		150,
		154,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		162,
		177,
		199,
		176,
		149,
		144,
		137,
		131,
		127,
		143,
		149,
		160,
		128,
		124,
		125,
		129,
		128,
		145,
		155,
		-1,
		-1,
		161,
		178,
		188,
		170,
		174,
		226,
		-1,
		-1,
		153,
		144,
		135,
		138,
		137,
		140,
		134,
		131,
		136,
		141,
		129,
		138,
		156,
		155,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		189,
		224,
		171,
		153,
		149,
		147,
		140,
		149,
		144,
		139,
		149,
		151,
		143,
		131,
		135,
		158,
		147,
		186,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		210,
		185,
		200,
		235,
		209,
		216,
		186,
		183,
		-1,
		153,
		178,
		150,
		157,
		148,
		155,
		155,
		147,
		125,
		132,
		148,
		147,
		142,
		178,
		169,
		175,
		-1,
		-1,
		291,
		280,
		269,
		275,
		-1,
		216,
		202,
		221,
		211,
		214,
		-1,
		-1,
		202,
		199,
		175,
		158,
		156,
		149,
		144,
		154,
		134,
		121,
		125,
		129,
		135,
		140,
		145,
		151,
		166,
		181,
		-1,
		186,
		267,
		260,
		243,
		251,
		282,
		-1,
		219,
		217,
		209,
		203,
		205,
		-1,
		-1,
		175,
		172,
		177,
		165,
		162,
		164,
		159,
		150,
		135,
		141,
		128,
		127,
		145,
		149,
		158,
		165,
		155,
		168,
		172,
		-1,
		200,
		243,
		237,
		240,
		264,
		278,
		-1,
		222,
		-1,
		-1,
		217,
		206,
		190,
		180,
		174,
		224,
		179,
		174,
		158,
		156,
		147,
		138,
		145,
		136,
		136,
		139,
		154,
		159,
		151,
		165,
		165,
		166,
		-1,
		235,
		223,
		231,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		233,
		-1,
		217,
		-1,
		192,
		196,
		187,
		190,
		172,
		159,
		151,
		143,
		159,
		134,
		144,
		140,
		141,
		150,
		161,
		173,
		172,
		173,
		293,
		249,
		231,
		222,
		269,
		284,
		288,
		-1,
		234,
		273,
		271,
		-1,
		242,
		-1,
		-1,
		-1,
		206,
		200,
		192,
		192,
		171,
		171,
		145,
		149,
		139,
		146,
		156,
		158,
		150,
		154,
		167,
		178,
		181,
		289,
		280,
		293,
		238,
		236,
		254,
		263,
		284,
		249,
		240,
		267,
		278,
		267,
		262,
		249,
		-1,
		-1,
		229,
		210,
		-1,
		-1,
		178,
		166,
		149,
		150,
		146,
		149,
		164,
		167,
		157,
		155,
		149,
		181,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		229,
		255,
		-1,
		-1,
		251,
		268,
		262,
		266,
		282,
		307,
		-1,
		238,
		-1,
		-1,
		223,
		-1,
		-1,
		208,
		171,
		160,
		151,
		157,
		154,
		165,
		175,
		163,
		164,
		154,
		164,
		177,
		266,
		263,
		251,
		249,
		272,
		237,
		225,
		-1,
		238,
		236,
		242,
		249,
		266,
		296,
		-1,
		-1,
		254,
		234,
		-1,
		-1,
		206,
		204,
		193,
		-1,
		183,
		156,
		161,
		181,
		183,
		172,
		166,
		160,
		167,
		166,
		174,
		182,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		223,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		240,
		-1,
		-1,
		201,
		194,
		182,
		170,
		160,
		170,
		174,
		178,
		170,
		163,
		158,
		169,
		161,
		165,
		182,
		-1,
		309,
		-1,
		261,
		237,
		251,
		266,
		274,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		235,
		219,
		200,
		-1,
		170,
		183,
		214,
		182,
		187,
		182,
		164,
		175,
		164,
		167,
		181,
		176,
		-1,
		-1,
		249,
		252,
		-1,
		-1,
		251,
		253,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		207,
		203,
		-1,
		-1,
		171,
		196,
		185,
		193,
		188,
		168,
		174,
		177,
		166,
		170,
		182,
		-1,
		-1,
		256,
		257,
		258,
		-1,
		236,
		-1,
		254,
		-1,
		221,
		227,
		215,
		-1,
		-1,
		-1,
		209,
		172,
		193,
		203,
		197,
		195,
		186,
		172,
		179,
		177,
		173,
		184,
		-1,
		-1,
		-1,
		254,
		228,
		261,
		252,
		235,
		215,
		207,
		226,
		-1,
		196,
		-1,
		171,
		173,
		199,
		202,
		208,
		202,
		175,
		190,
		180,
		171,
		180,
		260,
		-1,
		230,
		263,
		227,
		221,
		197,
		201,
		217,
		-1,
		193,
		175,
		-1,
		203,
		193,
		224,
		209,
		190,
		177,
		184,
		184,
		177,
		-1,
		-1,
		-1,
		232,
		231,
		223,
		217,
		217,
		202,
		193,
		-1,
		205,
		187,
		166,
		183,
		183,
		174,
		182,
		214,
		210,
		197,
		197,
		189,
		-1,
		333,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		226,
		221,
		194,
		182,
		188,
		184,
		170,
		176,
		178,
		186,
		184,
		181,
		193,
		189,
		209,
		190,
		225,
		-1,
		328,
		-1,
		262,
		-1,
		-1,
		244,
		224,
		216,
		205,
		194,
		192,
		183,
		174,
		196,
		212,
		196,
		194,
		197,
		198,
		-1,
		317,
		316,
		-1,
		263,
		255,
		241,
		-1,
		234,
		-1,
		240,
		201,
		-1,
		203,
		183,
		-1,
		205,
		201,
		-1,
		-1,
		304,
		279,
		-1,
		-1,
		-1,
		264,
		244,
		235,
		219,
		-1,
		194,
		194,
		-1,
		-1,
		-1,
		289,
		288,
		-1,
		257,
		260,
		-1,
		250,
		241,
		249,
		196,
		200,
		-1,
		-1,
		-1,
		298,
		279,
		273,
		272,
		270,
		265,
		262,
		248,
		232,
		210,
		199,
		220,
		-1,
		-1,
		-1,
		270,
		262,
		255,
		-1,
		-1,
		257,
		240,
		221,
		219,
		-1,
		-1,
		-1,
		292,
		273,
		-1,
		-1,
		247,
		-1,
		-1,
		253,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		281,
		-1,
		-1,
		-1,
		243,
		239,
		240,
		-1,
		-1,
		-1,
		-1,
		303,
		304,
		327,
		291,
		-1,
		-1,
		-1,
		235,
		229,
		-1,
		-1,
		306,
		304,
		-1,
		-1,
		-1,
		263,
		247,
		-1,
		233,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		268,
		-1,
		268,
		243,
		250,
		-1,
		-1,
		-1,
		-1,
		281,
		273,
		281,
		-1,
		253,
		255,
		-1,
		303,
		-1,
		-1,
		296,
		287,
		-1,
		-1,
		258,
		265,
		287,
		290,
		326,
		-1,
		277
	],
	[
		-1,
		108,
		97,
		108,
		116,
		89,
		96,
		-1,
		117,
		119,
		85,
		79,
		118,
		89,
		95,
		106,
		-1,
		-1,
		-1,
		108,
		107,
		77,
		75,
		84,
		89,
		96,
		-1,
		119,
		-1,
		129,
		108,
		119,
		124,
		70,
		67,
		87,
		106,
		112,
		104,
		144,
		100,
		71,
		65,
		83,
		88,
		106,
		98,
		-1,
		71,
		61,
		83,
		87,
		99,
		82,
		-1,
		-1,
		65,
		66,
		72,
		84,
		89,
		94,
		-1,
		120,
		130,
		-1,
		-1,
		55,
		68,
		64,
		67,
		75,
		91,
		112,
		129,
		125,
		-1,
		-1,
		56,
		60,
		73,
		74,
		72,
		99,
		118,
		120,
		134,
		133,
		-1,
		44,
		62,
		71,
		80,
		86,
		75,
		79,
		97,
		119,
		125,
		128,
		-1,
		53,
		54,
		53,
		62,
		70,
		77,
		78,
		84,
		103,
		107,
		126,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		53,
		36,
		53,
		42,
		39,
		58,
		75,
		81,
		87,
		91,
		99,
		115,
		116,
		126,
		-1,
		-1,
		147,
		120,
		144,
		102,
		83,
		-1,
		49,
		29,
		31,
		35,
		43,
		45,
		72,
		70,
		-1,
		93,
		92,
		123,
		109,
		120,
		129,
		-1,
		-1,
		105,
		97,
		79,
		82,
		59,
		55,
		34,
		33,
		12,
		29,
		25,
		48,
		60,
		58,
		68,
		87,
		97,
		101,
		116,
		127,
		-1,
		-1,
		198,
		-1,
		-1,
		126,
		109,
		-1,
		74,
		81,
		65,
		71,
		57,
		78,
		44,
		20,
		0,
		39,
		28,
		42,
		52,
		75,
		72,
		84,
		109,
		113,
		119,
		137,
		138,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		81,
		78,
		71,
		95,
		94,
		-1,
		48,
		36,
		34,
		19,
		31,
		44,
		34,
		60,
		58,
		73,
		75,
		91,
		93,
		126,
		120,
		142,
		139,
		168,
		173,
		167,
		176,
		-1,
		134,
		130,
		126,
		133,
		82,
		-1,
		-1,
		99,
		-1,
		102,
		85,
		60,
		33,
		36,
		20,
		28,
		51,
		40,
		58,
		61,
		64,
		84,
		97,
		104,
		115,
		114,
		132,
		147,
		160,
		164,
		170,
		-1,
		184,
		-1,
		126,
		110,
		112,
		88,
		116,
		-1,
		119,
		103,
		77,
		62,
		62,
		-1,
		35,
		32,
		43,
		50,
		42,
		59,
		68,
		72,
		83,
		104,
		118,
		109,
		127,
		134,
		142,
		146,
		166,
		178,
		144,
		134,
		-1,
		116,
		121,
		91,
		103,
		126,
		134,
		98,
		-1,
		73,
		-1,
		37,
		50,
		-1,
		49,
		53,
		48,
		64,
		78,
		86,
		90,
		100,
		97,
		115,
		118,
		135,
		139,
		155,
		-1,
		-1,
		129,
		133,
		141,
		92,
		111,
		135,
		144,
		91,
		80,
		79,
		-1,
		55,
		80,
		77,
		78,
		68,
		61,
		62,
		84,
		91,
		80,
		99,
		102,
		124,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		118,
		89,
		113,
		155,
		109,
		102,
		90,
		94,
		92,
		79,
		-1,
		99,
		78,
		75,
		66,
		74,
		88,
		85,
		99,
		103,
		102,
		121,
		133,
		124,
		144,
		-1,
		-1,
		-1,
		148,
		137,
		138,
		92,
		126,
		144,
		127,
		113,
		118,
		93,
		81,
		89,
		89,
		95,
		90,
		84,
		76,
		65,
		81,
		89,
		91,
		100,
		109,
		115,
		139,
		146,
		152,
		-1,
		-1,
		155,
		145,
		129,
		131,
		128,
		117,
		124,
		156,
		118,
		167,
		-1,
		121,
		-1,
		95,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		95,
		106,
		102,
		109,
		144,
		144,
		136,
		156,
		159,
		-1,
		-1,
		-1,
		148,
		165,
		140,
		117,
		98,
		134,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		82,
		96,
		107,
		94,
		130,
		-1,
		144,
		138,
		146,
		136,
		124,
		-1,
		-1,
		-1,
		163,
		142,
		135,
		155,
		105,
		157,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		91,
		80,
		93,
		98,
		99,
		109,
		129,
		133,
		137,
		126,
		122,
		119,
		133,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		125,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		98,
		94,
		102,
		87,
		90,
		102,
		106,
		124,
		132,
		124,
		118,
		117,
		129,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		140,
		-1,
		111,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		102,
		101,
		111,
		112,
		101,
		114,
		106,
		128,
		128,
		112,
		113,
		122,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		112,
		115,
		116,
		106,
		95,
		101,
		100,
		122,
		108,
		106,
		125,
		141,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		116,
		100,
		105,
		-1,
		141,
		-1,
		114,
		116,
		108,
		97,
		94,
		105,
		103,
		114,
		131,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		132,
		112,
		106,
		105,
		136,
		134,
		122,
		106,
		99,
		96,
		97,
		110,
		130,
		121,
		133,
		-1,
		-1,
		-1,
		167,
		152,
		157,
		116,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		149,
		137,
		127,
		117,
		151,
		150,
		125,
		118,
		104,
		106,
		104,
		106,
		111,
		132,
		133,
		146,
		-1,
		-1,
		149,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		138,
		-1,
		-1,
		129,
		127,
		137,
		121,
		108,
		128,
		131,
		121,
		105,
		120,
		132,
		140,
		145,
		-1,
		152,
		139,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		160,
		162,
		166,
		132,
		-1,
		137,
		132,
		112,
		126,
		133,
		123,
		118,
		112,
		115,
		133,
		150,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		139,
		153,
		155,
		148,
		152,
		-1,
		140,
		128,
		114,
		131,
		136,
		133,
		124,
		116,
		121,
		118,
		131,
		145,
		149,
		188,
		-1,
		171,
		-1,
		-1,
		-1,
		157,
		172,
		194,
		171,
		144,
		139,
		132,
		126,
		122,
		138,
		144,
		155,
		123,
		119,
		120,
		124,
		123,
		140,
		150,
		-1,
		-1,
		171,
		188,
		183,
		165,
		169,
		221,
		-1,
		-1,
		148,
		139,
		130,
		133,
		132,
		135,
		129,
		126,
		131,
		136,
		124,
		133,
		151,
		150,
		-1,
		-1,
		-1,
		191,
		-1,
		206,
		-1,
		-1,
		184,
		219,
		166,
		148,
		144,
		142,
		135,
		144,
		139,
		134,
		144,
		146,
		138,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		220,
		195,
		210,
		230,
		204,
		211,
		181,
		178,
		-1,
		148,
		173,
		145,
		152,
		143,
		150,
		150,
		142,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		302,
		291,
		280,
		286,
		-1,
		226,
		212,
		216,
		206,
		209,
		-1,
		-1,
		197,
		194,
		170,
		153,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		197,
		278,
		271,
		254,
		262,
		293,
		-1,
		220,
		212,
		219,
		198,
		200,
		-1,
		-1,
		170,
		167,
		172,
		160,
		157,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		211,
		254,
		248,
		251,
		275,
		289,
		-1,
		217,
		-1,
		-1,
		227,
		201,
		185,
		175,
		169,
		219,
		174,
		169,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		246,
		234,
		242,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		243,
		-1,
		212,
		-1,
		187,
		191,
		182,
		185,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		288,
		244,
		242,
		233,
		269,
		284,
		288,
		-1,
		229,
		268,
		266,
		-1,
		250,
		-1,
		-1,
		-1,
		201,
		195,
		187,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		284,
		275,
		288,
		233,
		233,
		254,
		263,
		284,
		244,
		235,
		262,
		273,
		262,
		257,
		244,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		224,
		251,
		-1,
		-1,
		246,
		263,
		257,
		261,
		277,
		302,
		-1,
		233,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		261,
		258,
		246,
		244,
		267,
		232,
		220,
		-1,
		233,
		231,
		237,
		244,
		261,
		291,
		-1,
		-1,
		249,
		229,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		218,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		235,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		304,
		-1,
		256,
		232,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		251,
		252,
		253,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		111,
		100,
		111,
		119,
		92,
		99,
		-1,
		120,
		122,
		88,
		82,
		121,
		92,
		98,
		109,
		-1,
		-1,
		-1,
		111,
		110,
		80,
		78,
		87,
		92,
		99,
		-1,
		122,
		-1,
		132,
		111,
		122,
		127,
		73,
		70,
		90,
		109,
		115,
		107,
		147,
		103,
		74,
		68,
		86,
		91,
		109,
		101,
		-1,
		74,
		64,
		86,
		90,
		102,
		85,
		-1,
		-1,
		68,
		69,
		75,
		87,
		92,
		97,
		-1,
		123,
		121,
		-1,
		-1,
		58,
		71,
		67,
		70,
		78,
		94,
		115,
		121,
		116,
		-1,
		-1,
		59,
		63,
		76,
		77,
		75,
		102,
		121,
		111,
		125,
		124,
		-1,
		47,
		65,
		74,
		83,
		89,
		78,
		82,
		100,
		110,
		116,
		119,
		-1,
		56,
		57,
		53,
		61,
		66,
		73,
		78,
		87,
		105,
		98,
		117,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		56,
		39,
		56,
		49,
		41,
		54,
		66,
		74,
		90,
		93,
		90,
		106,
		107,
		117,
		-1,
		-1,
		150,
		123,
		147,
		105,
		86,
		-1,
		52,
		32,
		38,
		42,
		39,
		41,
		63,
		61,
		-1,
		84,
		83,
		114,
		100,
		111,
		132,
		-1,
		-1,
		108,
		100,
		82,
		85,
		62,
		58,
		47,
		46,
		33,
		22,
		18,
		44,
		51,
		49,
		59,
		78,
		88,
		92,
		107,
		118,
		-1,
		-1,
		190,
		-1,
		-1,
		129,
		112,
		-1,
		77,
		84,
		68,
		74,
		60,
		81,
		57,
		46,
		35,
		0,
		12,
		33,
		43,
		66,
		63,
		75,
		100,
		104,
		110,
		128,
		129,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		84,
		81,
		74,
		98,
		97,
		-1,
		67,
		55,
		56,
		41,
		34,
		29,
		18,
		48,
		49,
		64,
		66,
		82,
		84,
		117,
		112,
		133,
		130,
		160,
		165,
		159,
		168,
		-1,
		137,
		133,
		129,
		136,
		85,
		-1,
		-1,
		102,
		-1,
		105,
		104,
		79,
		52,
		55,
		42,
		47,
		36,
		24,
		42,
		52,
		55,
		75,
		88,
		95,
		107,
		106,
		124,
		139,
		152,
		156,
		162,
		-1,
		187,
		-1,
		129,
		113,
		115,
		91,
		119,
		-1,
		122,
		106,
		96,
		81,
		81,
		-1,
		58,
		55,
		62,
		49,
		34,
		51,
		59,
		63,
		74,
		95,
		110,
		101,
		119,
		126,
		134,
		138,
		158,
		170,
		147,
		137,
		-1,
		119,
		124,
		94,
		106,
		129,
		149,
		117,
		-1,
		92,
		-1,
		60,
		73,
		-1,
		55,
		51,
		40,
		56,
		70,
		77,
		81,
		92,
		89,
		107,
		110,
		127,
		131,
		147,
		-1,
		-1,
		132,
		136,
		144,
		95,
		114,
		138,
		163,
		110,
		99,
		98,
		-1,
		78,
		76,
		73,
		74,
		60,
		53,
		54,
		76,
		82,
		72,
		91,
		94,
		116,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		121,
		92,
		116,
		158,
		128,
		121,
		109,
		117,
		115,
		102,
		-1,
		91,
		70,
		67,
		58,
		66,
		80,
		77,
		91,
		95,
		94,
		113,
		125,
		116,
		136,
		-1,
		-1,
		-1,
		151,
		140,
		141,
		95,
		129,
		147,
		150,
		136,
		141,
		116,
		104,
		108,
		85,
		87,
		82,
		76,
		68,
		57,
		73,
		81,
		83,
		92,
		101,
		107,
		131,
		138,
		144,
		-1,
		-1,
		158,
		148,
		132,
		134,
		131,
		120,
		127,
		159,
		141,
		159,
		-1,
		113,
		-1,
		102,
		97,
		81,
		76,
		73,
		70,
		64,
		73,
		87,
		98,
		94,
		101,
		136,
		136,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		151,
		168,
		143,
		120,
		101,
		137,
		-1,
		129,
		130,
		-1,
		107,
		101,
		98,
		83,
		79,
		74,
		78,
		71,
		78,
		74,
		88,
		99,
		86,
		122,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		108,
		160,
		-1,
		-1,
		114,
		107,
		-1,
		94,
		76,
		83,
		81,
		75,
		79,
		83,
		72,
		85,
		90,
		91,
		101,
		121,
		125,
		129,
		118,
		114,
		111,
		125,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		128,
		-1,
		123,
		115,
		105,
		99,
		93,
		89,
		87,
		103,
		87,
		90,
		90,
		86,
		94,
		79,
		82,
		94,
		98,
		116,
		124,
		116,
		110,
		109,
		121,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		143,
		-1,
		108,
		122,
		138,
		-1,
		131,
		110,
		125,
		103,
		99,
		95,
		110,
		111,
		89,
		94,
		93,
		103,
		104,
		93,
		106,
		98,
		120,
		120,
		104,
		105,
		114,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		93,
		125,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		109,
		107,
		100,
		91,
		97,
		104,
		107,
		108,
		98,
		87,
		93,
		92,
		114,
		100,
		98,
		117,
		133,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		108,
		92,
		97,
		-1,
		133,
		-1,
		106,
		108,
		100,
		89,
		86,
		97,
		95,
		106,
		123,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		162,
		-1,
		-1,
		132,
		126,
		126,
		110,
		113,
		124,
		104,
		98,
		97,
		128,
		126,
		114,
		98,
		91,
		88,
		89,
		102,
		122,
		113,
		125,
		-1,
		-1,
		-1,
		159,
		145,
		149,
		109,
		128,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		119,
		141,
		129,
		119,
		109,
		143,
		142,
		117,
		110,
		96,
		98,
		96,
		98,
		103,
		124,
		125,
		138,
		-1,
		-1,
		142,
		147,
		135,
		121,
		140,
		-1,
		-1,
		-1,
		141,
		157,
		149,
		120,
		130,
		-1,
		-1,
		121,
		119,
		129,
		113,
		100,
		120,
		123,
		113,
		97,
		112,
		124,
		132,
		137,
		-1,
		145,
		132,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		152,
		154,
		158,
		124,
		-1,
		129,
		124,
		104,
		118,
		125,
		115,
		110,
		104,
		107,
		125,
		142,
		-1,
		-1,
		157,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		131,
		145,
		147,
		140,
		144,
		-1,
		132,
		120,
		106,
		123,
		128,
		125,
		116,
		108,
		113,
		110,
		123,
		137,
		141,
		180,
		-1,
		163,
		-1,
		-1,
		-1,
		149,
		164,
		186,
		163,
		136,
		131,
		124,
		118,
		114,
		130,
		136,
		147,
		115,
		111,
		112,
		116,
		115,
		132,
		142,
		-1,
		-1,
		163,
		180,
		175,
		157,
		161,
		213,
		-1,
		-1,
		140,
		131,
		122,
		125,
		124,
		127,
		121,
		118,
		123,
		128,
		116,
		125,
		143,
		142,
		-1,
		-1,
		-1,
		183,
		-1,
		198,
		-1,
		-1,
		176,
		211,
		158,
		140,
		136,
		134,
		127,
		136,
		131,
		126,
		136,
		138,
		130,
		118,
		122,
		145,
		134,
		173,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		212,
		187,
		202,
		222,
		196,
		203,
		173,
		170,
		-1,
		140,
		165,
		137,
		144,
		135,
		142,
		142,
		134,
		112,
		119,
		135,
		134,
		129,
		165,
		156,
		162,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		218,
		204,
		208,
		198,
		201,
		-1,
		-1,
		189,
		186,
		162,
		145,
		143,
		136,
		131,
		141,
		121,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		153,
		168,
		-1,
		190,
		271,
		264,
		247,
		255,
		286,
		-1,
		212,
		204,
		211,
		190,
		192,
		-1,
		-1,
		162,
		159,
		164,
		152,
		149,
		151,
		146,
		137,
		122,
		128,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		204,
		247,
		241,
		244,
		268,
		282,
		-1,
		209,
		-1,
		-1,
		219,
		193,
		177,
		167,
		161,
		211,
		166,
		161,
		145,
		143,
		134,
		125,
		132,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		239,
		227,
		235,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		235,
		-1,
		204,
		-1,
		179,
		183,
		174,
		177,
		159,
		146,
		138,
		130,
		146,
		121,
		131,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		280,
		236,
		235,
		226,
		261,
		276,
		280,
		-1,
		221,
		260,
		258,
		-1,
		242,
		-1,
		-1,
		-1,
		193,
		187,
		179,
		179,
		158,
		158,
		132,
		136,
		126,
		133,
		143,
		145,
		137,
		141,
		154,
		165,
		168,
		276,
		267,
		280,
		225,
		225,
		246,
		255,
		276,
		236,
		227,
		254,
		265,
		254,
		249,
		236,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		165,
		153,
		136,
		137,
		133,
		136,
		151,
		154,
		144,
		142,
		136,
		168,
		-1,
		269,
		268,
		257,
		254,
		230,
		221,
		216,
		243,
		-1,
		-1,
		238,
		255,
		249,
		253,
		269,
		294,
		-1,
		225,
		-1,
		-1,
		210,
		-1,
		-1,
		195,
		158,
		147,
		138,
		144,
		141,
		152,
		162,
		150,
		151,
		141,
		151,
		164,
		253,
		250,
		238,
		236,
		259,
		224,
		212,
		-1,
		225,
		223,
		229,
		236,
		253,
		283,
		-1,
		-1,
		241,
		221,
		-1,
		-1,
		193,
		191,
		180,
		-1,
		170,
		143,
		148,
		168,
		170,
		159,
		153,
		147,
		154,
		153,
		161,
		169,
		262,
		276,
		265,
		261,
		260,
		268,
		217,
		210,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		227,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		161,
		165,
		157,
		150,
		145,
		156,
		148,
		152,
		169,
		-1,
		296,
		-1,
		248,
		224,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		201,
		169,
		174,
		169,
		151,
		162,
		151,
		154,
		168,
		163,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		238,
		240,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		158,
		183,
		172,
		180,
		175,
		155,
		161,
		164,
		153,
		157,
		169,
		-1,
		-1,
		243,
		244,
		245,
		-1,
		223,
		-1,
		241,
		-1,
		208,
		214,
		202,
		-1,
		-1,
		-1,
		196,
		159,
		180,
		190,
		184,
		182,
		173,
		159,
		166,
		164,
		160,
		171,
		-1,
		-1,
		-1,
		241,
		215,
		248,
		239,
		222,
		202,
		194,
		213,
		-1,
		183,
		-1,
		158,
		160,
		186,
		189,
		195,
		189,
		162,
		177,
		167,
		158,
		167,
		247,
		-1,
		217,
		250,
		214,
		208,
		184,
		188,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		211,
		196,
		177,
		164,
		171,
		171,
		164,
		-1,
		-1,
		-1,
		219,
		218,
		210,
		204,
		204,
		189,
		180,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		201,
		197,
		184,
		184,
		176,
		-1,
		320,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		213,
		208,
		181,
		169,
		175,
		171,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		177,
		212,
		-1,
		315,
		-1,
		249,
		-1,
		-1,
		231,
		211,
		203,
		192,
		181,
		179,
		170,
		161,
		183,
		199,
		183,
		181,
		184,
		185,
		-1,
		304,
		303,
		-1,
		250,
		242,
		228,
		-1,
		221,
		-1,
		227,
		188,
		-1,
		190,
		170,
		-1,
		192,
		188,
		-1,
		-1,
		291,
		266,
		-1,
		-1,
		-1,
		251,
		231,
		222,
		206,
		-1,
		181,
		181,
		-1,
		-1,
		-1,
		276,
		275,
		-1,
		244,
		247,
		-1,
		237,
		228,
		236,
		183,
		187,
		-1,
		-1,
		-1,
		285,
		266,
		260,
		259,
		257,
		252,
		249,
		235,
		219,
		197,
		186,
		207,
		-1,
		-1,
		-1,
		257,
		249,
		242,
		-1,
		-1,
		244,
		227,
		208,
		206,
		-1,
		-1,
		-1,
		279,
		260,
		-1,
		-1,
		234,
		-1,
		-1,
		240,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		268,
		-1,
		-1,
		-1,
		230,
		226,
		227,
		-1,
		-1,
		-1,
		-1,
		290,
		291,
		314,
		278,
		-1,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		293,
		291,
		-1,
		-1,
		-1,
		250,
		234,
		-1,
		220,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		255,
		-1,
		255,
		230,
		237,
		-1,
		-1,
		-1,
		-1,
		268,
		260,
		268,
		-1,
		240,
		242,
		-1,
		290,
		-1,
		-1,
		283,
		274,
		-1,
		-1,
		245,
		252,
		274,
		277,
		313,
		-1,
		264
	],
	[
		-1,
		99,
		88,
		99,
		107,
		80,
		87,
		-1,
		108,
		110,
		76,
		70,
		109,
		80,
		86,
		97,
		-1,
		-1,
		-1,
		99,
		98,
		68,
		66,
		75,
		80,
		87,
		-1,
		110,
		-1,
		120,
		99,
		110,
		115,
		61,
		58,
		78,
		97,
		103,
		95,
		135,
		91,
		62,
		56,
		74,
		79,
		97,
		89,
		-1,
		62,
		52,
		74,
		78,
		90,
		73,
		-1,
		-1,
		56,
		57,
		63,
		75,
		80,
		85,
		-1,
		111,
		113,
		-1,
		-1,
		46,
		59,
		55,
		58,
		66,
		82,
		103,
		113,
		108,
		-1,
		-1,
		47,
		51,
		64,
		65,
		63,
		90,
		109,
		103,
		117,
		116,
		-1,
		35,
		53,
		62,
		71,
		77,
		66,
		70,
		88,
		102,
		108,
		111,
		-1,
		44,
		45,
		44,
		52,
		57,
		64,
		69,
		75,
		94,
		90,
		109,
		100,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		44,
		27,
		44,
		39,
		32,
		45,
		58,
		66,
		78,
		82,
		82,
		98,
		99,
		109,
		-1,
		-1,
		138,
		111,
		135,
		93,
		74,
		-1,
		40,
		20,
		26,
		30,
		30,
		32,
		55,
		53,
		-1,
		76,
		75,
		106,
		92,
		103,
		120,
		-1,
		-1,
		96,
		88,
		70,
		73,
		50,
		46,
		35,
		34,
		24,
		10,
		6,
		35,
		43,
		41,
		51,
		70,
		80,
		84,
		99,
		110,
		-1,
		-1,
		178,
		-1,
		-1,
		117,
		100,
		-1,
		65,
		72,
		56,
		62,
		48,
		69,
		45,
		34,
		26,
		12,
		0,
		25,
		35,
		58,
		55,
		67,
		92,
		96,
		102,
		120,
		119,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		72,
		69,
		62,
		86,
		85,
		-1,
		55,
		43,
		44,
		29,
		26,
		21,
		6,
		36,
		41,
		56,
		58,
		74,
		76,
		109,
		100,
		122,
		119,
		148,
		153,
		147,
		156,
		-1,
		125,
		121,
		117,
		124,
		73,
		-1,
		-1,
		90,
		-1,
		93,
		92,
		67,
		40,
		43,
		30,
		38,
		28,
		12,
		30,
		44,
		47,
		67,
		80,
		87,
		95,
		94,
		112,
		127,
		140,
		144,
		150,
		-1,
		175,
		-1,
		117,
		101,
		103,
		79,
		107,
		-1,
		110,
		94,
		84,
		69,
		69,
		-1,
		46,
		43,
		53,
		37,
		22,
		39,
		51,
		55,
		66,
		84,
		98,
		89,
		107,
		114,
		122,
		126,
		146,
		158,
		135,
		125,
		-1,
		107,
		112,
		82,
		94,
		117,
		137,
		105,
		-1,
		80,
		-1,
		48,
		61,
		-1,
		43,
		39,
		28,
		44,
		58,
		69,
		73,
		80,
		77,
		95,
		98,
		115,
		119,
		135,
		-1,
		-1,
		120,
		124,
		132,
		83,
		102,
		126,
		151,
		98,
		87,
		86,
		-1,
		66,
		64,
		61,
		62,
		48,
		41,
		42,
		64,
		74,
		60,
		79,
		82,
		104,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		109,
		80,
		104,
		146,
		116,
		109,
		97,
		105,
		103,
		90,
		-1,
		79,
		58,
		55,
		46,
		54,
		68,
		65,
		79,
		83,
		82,
		101,
		113,
		104,
		124,
		-1,
		-1,
		-1,
		139,
		128,
		129,
		83,
		117,
		135,
		138,
		124,
		129,
		104,
		92,
		96,
		73,
		75,
		70,
		64,
		56,
		45,
		61,
		69,
		71,
		80,
		89,
		95,
		119,
		126,
		132,
		-1,
		-1,
		146,
		136,
		120,
		122,
		119,
		108,
		115,
		147,
		129,
		147,
		-1,
		101,
		-1,
		90,
		85,
		69,
		64,
		61,
		58,
		52,
		61,
		75,
		86,
		82,
		89,
		124,
		124,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		139,
		156,
		131,
		108,
		89,
		125,
		-1,
		117,
		118,
		-1,
		95,
		89,
		86,
		71,
		67,
		62,
		66,
		59,
		66,
		62,
		76,
		87,
		74,
		110,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		154,
		133,
		126,
		146,
		96,
		148,
		-1,
		-1,
		102,
		95,
		-1,
		82,
		64,
		71,
		69,
		63,
		67,
		71,
		60,
		73,
		78,
		79,
		89,
		109,
		113,
		117,
		106,
		102,
		99,
		113,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		116,
		-1,
		111,
		103,
		93,
		87,
		81,
		77,
		75,
		91,
		75,
		78,
		78,
		74,
		82,
		67,
		70,
		82,
		86,
		104,
		112,
		104,
		98,
		97,
		109,
		-1,
		186,
		172,
		143,
		-1,
		-1,
		131,
		-1,
		96,
		110,
		126,
		-1,
		119,
		98,
		113,
		91,
		87,
		83,
		98,
		99,
		77,
		82,
		81,
		91,
		92,
		81,
		94,
		86,
		108,
		108,
		92,
		93,
		102,
		-1,
		192,
		179,
		137,
		133,
		122,
		142,
		93,
		81,
		113,
		-1,
		-1,
		155,
		-1,
		89,
		106,
		97,
		95,
		88,
		79,
		85,
		92,
		95,
		96,
		86,
		75,
		81,
		80,
		102,
		88,
		86,
		105,
		121,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		108,
		95,
		89,
		-1,
		130,
		-1,
		133,
		123,
		107,
		92,
		125,
		-1,
		96,
		80,
		85,
		-1,
		121,
		-1,
		94,
		96,
		88,
		77,
		74,
		85,
		83,
		94,
		111,
		-1,
		142,
		127,
		120,
		110,
		124,
		95,
		-1,
		150,
		-1,
		-1,
		120,
		114,
		114,
		98,
		101,
		112,
		92,
		86,
		85,
		116,
		114,
		102,
		86,
		79,
		76,
		77,
		90,
		110,
		101,
		113,
		-1,
		-1,
		-1,
		147,
		133,
		137,
		97,
		116,
		-1,
		-1,
		182,
		137,
		123,
		-1,
		107,
		129,
		117,
		107,
		97,
		131,
		130,
		105,
		98,
		84,
		86,
		84,
		86,
		91,
		112,
		113,
		126,
		-1,
		-1,
		130,
		135,
		123,
		109,
		128,
		-1,
		-1,
		-1,
		129,
		145,
		137,
		108,
		118,
		-1,
		-1,
		109,
		107,
		117,
		101,
		88,
		108,
		111,
		101,
		85,
		100,
		112,
		120,
		125,
		-1,
		133,
		120,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		140,
		142,
		146,
		112,
		-1,
		117,
		112,
		92,
		106,
		113,
		103,
		98,
		92,
		95,
		113,
		130,
		-1,
		-1,
		145,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		119,
		133,
		135,
		128,
		132,
		-1,
		120,
		108,
		94,
		111,
		116,
		113,
		104,
		96,
		101,
		98,
		111,
		125,
		129,
		168,
		-1,
		151,
		-1,
		-1,
		-1,
		137,
		152,
		174,
		151,
		124,
		119,
		112,
		106,
		102,
		118,
		124,
		135,
		103,
		99,
		100,
		104,
		103,
		120,
		130,
		-1,
		-1,
		151,
		168,
		163,
		145,
		149,
		201,
		-1,
		-1,
		128,
		119,
		110,
		113,
		112,
		115,
		109,
		106,
		111,
		116,
		104,
		113,
		131,
		130,
		-1,
		-1,
		-1,
		171,
		-1,
		186,
		-1,
		-1,
		164,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		126,
		118,
		106,
		110,
		133,
		122,
		161,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		200,
		175,
		190,
		210,
		184,
		191,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		123,
		130,
		130,
		122,
		100,
		107,
		123,
		122,
		117,
		153,
		144,
		150,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		206,
		192,
		196,
		186,
		189,
		-1,
		-1,
		177,
		174,
		150,
		133,
		131,
		124,
		119,
		129,
		109,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		178,
		259,
		252,
		235,
		243,
		274,
		-1,
		200,
		192,
		199,
		178,
		180,
		-1,
		-1,
		150,
		147,
		152,
		140,
		137,
		139,
		134,
		125,
		110,
		116,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		192,
		235,
		229,
		232,
		256,
		270,
		-1,
		197,
		-1,
		-1,
		207,
		181,
		165,
		155,
		149,
		199,
		154,
		149,
		133,
		131,
		122,
		113,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		227,
		215,
		223,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		223,
		-1,
		192,
		-1,
		167,
		171,
		162,
		165,
		147,
		134,
		126,
		118,
		134,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		268,
		224,
		223,
		214,
		249,
		264,
		268,
		-1,
		209,
		248,
		246,
		-1,
		230,
		-1,
		-1,
		-1,
		181,
		175,
		167,
		167,
		146,
		146,
		120,
		124,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		264,
		255,
		268,
		213,
		213,
		234,
		243,
		264,
		224,
		215,
		242,
		253,
		242,
		237,
		224,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		153,
		141,
		124,
		125,
		121,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		204,
		231,
		-1,
		-1,
		226,
		243,
		237,
		241,
		257,
		282,
		-1,
		213,
		-1,
		-1,
		198,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		129,
		140,
		150,
		138,
		139,
		129,
		139,
		152,
		241,
		238,
		226,
		224,
		247,
		212,
		200,
		-1,
		213,
		211,
		217,
		224,
		241,
		271,
		-1,
		-1,
		229,
		209,
		-1,
		-1,
		181,
		179,
		168,
		-1,
		158,
		131,
		136,
		156,
		158,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		198,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		215,
		-1,
		-1,
		176,
		169,
		157,
		145,
		135,
		145,
		149,
		153,
		145,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		284,
		-1,
		236,
		212,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		226,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		231,
		232,
		233,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		172,
		170,
		161,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		148,
		174,
		177,
		183,
		177,
		150,
		165,
		155,
		146,
		155,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		199,
		184,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		189,
		185,
		172,
		172,
		164,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		165,
		200,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		172,
		173,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		117,
		106,
		117,
		125,
		98,
		105,
		-1,
		126,
		128,
		94,
		88,
		127,
		98,
		104,
		115,
		-1,
		-1,
		-1,
		117,
		116,
		86,
		84,
		93,
		98,
		105,
		-1,
		119,
		-1,
		138,
		117,
		128,
		133,
		79,
		76,
		96,
		115,
		112,
		104,
		153,
		109,
		80,
		74,
		92,
		97,
		106,
		98,
		-1,
		80,
		70,
		92,
		86,
		97,
		89,
		-1,
		-1,
		74,
		75,
		81,
		82,
		88,
		84,
		-1,
		94,
		88,
		-1,
		-1,
		64,
		77,
		64,
		67,
		75,
		73,
		86,
		88,
		83,
		-1,
		-1,
		65,
		66,
		73,
		60,
		56,
		73,
		92,
		78,
		92,
		91,
		-1,
		53,
		70,
		66,
		67,
		65,
		49,
		53,
		71,
		77,
		83,
		86,
		-1,
		62,
		63,
		41,
		49,
		54,
		55,
		45,
		58,
		72,
		65,
		84,
		75,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		62,
		45,
		55,
		37,
		27,
		42,
		33,
		41,
		61,
		60,
		57,
		73,
		74,
		84,
		-1,
		-1,
		156,
		129,
		153,
		111,
		92,
		-1,
		58,
		38,
		35,
		31,
		25,
		18,
		30,
		28,
		-1,
		51,
		50,
		81,
		67,
		78,
		138,
		-1,
		-1,
		114,
		106,
		88,
		91,
		68,
		64,
		53,
		52,
		36,
		28,
		24,
		15,
		18,
		16,
		26,
		45,
		55,
		59,
		74,
		85,
		-1,
		-1,
		159,
		-1,
		-1,
		135,
		118,
		-1,
		83,
		90,
		74,
		80,
		66,
		87,
		63,
		52,
		38,
		33,
		25,
		0,
		10,
		33,
		30,
		42,
		67,
		71,
		77,
		95,
		96,
		-1,
		158,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		90,
		87,
		80,
		104,
		103,
		-1,
		73,
		61,
		62,
		47,
		46,
		42,
		31,
		18,
		16,
		31,
		33,
		49,
		51,
		84,
		79,
		100,
		97,
		128,
		134,
		128,
		137,
		-1,
		143,
		139,
		135,
		142,
		91,
		-1,
		-1,
		108,
		-1,
		111,
		110,
		85,
		58,
		61,
		48,
		56,
		49,
		29,
		24,
		19,
		22,
		42,
		55,
		62,
		76,
		75,
		93,
		106,
		121,
		125,
		131,
		-1,
		193,
		-1,
		135,
		119,
		121,
		97,
		125,
		-1,
		128,
		112,
		102,
		87,
		87,
		-1,
		64,
		61,
		71,
		53,
		39,
		37,
		26,
		30,
		41,
		62,
		79,
		70,
		88,
		95,
		103,
		107,
		127,
		139,
		153,
		143,
		-1,
		125,
		130,
		100,
		112,
		135,
		155,
		123,
		-1,
		98,
		-1,
		66,
		79,
		-1,
		59,
		55,
		45,
		48,
		37,
		44,
		48,
		61,
		58,
		76,
		79,
		96,
		100,
		116,
		-1,
		-1,
		138,
		142,
		150,
		101,
		120,
		144,
		169,
		116,
		105,
		104,
		-1,
		84,
		81,
		78,
		79,
		65,
		58,
		59,
		43,
		49,
		58,
		60,
		63,
		85,
		113,
		91,
		103,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		127,
		98,
		122,
		164,
		134,
		127,
		115,
		113,
		113,
		107,
		-1,
		96,
		75,
		71,
		60,
		50,
		66,
		61,
		77,
		64,
		66,
		82,
		94,
		85,
		105,
		-1,
		-1,
		-1,
		157,
		146,
		147,
		101,
		135,
		153,
		146,
		132,
		137,
		112,
		105,
		99,
		90,
		92,
		78,
		67,
		59,
		48,
		64,
		71,
		66,
		66,
		75,
		76,
		100,
		107,
		113,
		-1,
		-1,
		164,
		154,
		138,
		140,
		137,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		88,
		72,
		67,
		64,
		61,
		55,
		64,
		72,
		80,
		71,
		86,
		105,
		105,
		97,
		122,
		125,
		-1,
		-1,
		-1,
		157,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		89,
		74,
		70,
		65,
		69,
		62,
		69,
		65,
		79,
		90,
		72,
		108,
		-1,
		105,
		99,
		127,
		119,
		107,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		74,
		72,
		66,
		70,
		74,
		63,
		76,
		81,
		77,
		87,
		107,
		111,
		118,
		109,
		105,
		102,
		116,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		80,
		78,
		94,
		78,
		81,
		81,
		77,
		85,
		70,
		73,
		80,
		84,
		102,
		115,
		107,
		101,
		100,
		112,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		90,
		86,
		101,
		102,
		80,
		85,
		84,
		94,
		95,
		84,
		92,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		100,
		98,
		91,
		82,
		88,
		95,
		98,
		99,
		89,
		78,
		84,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		99,
		83,
		88,
		-1,
		124,
		-1,
		97,
		99,
		91,
		80,
		77,
		88,
		86,
		97,
		114,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		115,
		95,
		89,
		88,
		119,
		117,
		105,
		89,
		82,
		79,
		80,
		93,
		113,
		104,
		116,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		132,
		120,
		110,
		100,
		134,
		133,
		108,
		101,
		87,
		89,
		87,
		89,
		94,
		115,
		116,
		129,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		140,
		111,
		121,
		-1,
		-1,
		112,
		110,
		120,
		104,
		91,
		111,
		114,
		104,
		88,
		103,
		115,
		123,
		128,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		143,
		145,
		149,
		115,
		-1,
		120,
		115,
		95,
		109,
		116,
		106,
		101,
		95,
		98,
		116,
		133,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		122,
		136,
		138,
		131,
		135,
		-1,
		123,
		111,
		97,
		114,
		119,
		116,
		107,
		99,
		104,
		101,
		114,
		128,
		132,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		140,
		155,
		177,
		154,
		127,
		122,
		115,
		109,
		105,
		121,
		127,
		138,
		106,
		102,
		103,
		107,
		106,
		123,
		133,
		-1,
		-1,
		154,
		171,
		166,
		148,
		152,
		204,
		-1,
		-1,
		131,
		122,
		113,
		116,
		115,
		118,
		112,
		109,
		114,
		119,
		107,
		116,
		134,
		133,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		167,
		202,
		149,
		131,
		127,
		125,
		118,
		127,
		122,
		117,
		127,
		129,
		121,
		109,
		113,
		136,
		125,
		164,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		213,
		187,
		194,
		164,
		161,
		-1,
		131,
		156,
		128,
		135,
		126,
		133,
		133,
		125,
		103,
		110,
		126,
		125,
		120,
		156,
		147,
		153,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		209,
		195,
		199,
		189,
		192,
		-1,
		-1,
		180,
		177,
		153,
		136,
		134,
		127,
		122,
		132,
		112,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		203,
		195,
		202,
		181,
		183,
		-1,
		-1,
		153,
		150,
		155,
		143,
		140,
		142,
		137,
		128,
		113,
		119,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		200,
		-1,
		-1,
		210,
		184,
		168,
		158,
		152,
		202,
		157,
		152,
		136,
		134,
		125,
		116,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		226,
		-1,
		195,
		-1,
		170,
		174,
		165,
		168,
		150,
		137,
		129,
		121,
		137,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		271,
		227,
		226,
		217,
		252,
		267,
		271,
		-1,
		212,
		251,
		249,
		-1,
		233,
		-1,
		-1,
		-1,
		184,
		178,
		170,
		170,
		149,
		149,
		123,
		127,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		267,
		258,
		271,
		216,
		216,
		237,
		246,
		267,
		227,
		218,
		245,
		256,
		245,
		240,
		227,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		156,
		144,
		127,
		128,
		124,
		127,
		142,
		145,
		135,
		133,
		127,
		159,
		-1,
		260,
		259,
		248,
		245,
		221,
		212,
		207,
		234,
		-1,
		-1,
		229,
		246,
		240,
		244,
		260,
		285,
		-1,
		216,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		132,
		143,
		153,
		141,
		142,
		132,
		142,
		155,
		244,
		241,
		229,
		227,
		250,
		215,
		203,
		-1,
		216,
		214,
		220,
		227,
		244,
		274,
		-1,
		-1,
		232,
		212,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		134,
		139,
		159,
		161,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		253,
		267,
		256,
		252,
		251,
		259,
		208,
		201,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		222,
		218,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		152,
		156,
		148,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		287,
		-1,
		239,
		215,
		229,
		244,
		252,
		-1,
		-1,
		-1,
		239,
		225,
		218,
		206,
		204,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		227,
		230,
		-1,
		-1,
		229,
		231,
		-1,
		230,
		219,
		204,
		196,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		234,
		235,
		236,
		-1,
		214,
		-1,
		232,
		-1,
		199,
		205,
		193,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		175,
		173,
		164,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		232,
		206,
		239,
		230,
		213,
		193,
		185,
		204,
		-1,
		174,
		-1,
		149,
		151,
		177,
		180,
		186,
		180,
		153,
		168,
		158,
		149,
		158,
		238,
		-1,
		208,
		241,
		205,
		199,
		175,
		179,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		202,
		187,
		168,
		155,
		162,
		162,
		155,
		-1,
		-1,
		-1,
		210,
		209,
		201,
		195,
		195,
		180,
		171,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		192,
		188,
		175,
		175,
		167,
		-1,
		311,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		204,
		199,
		172,
		160,
		166,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		168,
		203,
		-1,
		306,
		-1,
		240,
		-1,
		-1,
		222,
		202,
		194,
		183,
		172,
		170,
		161,
		152,
		174,
		190,
		174,
		172,
		175,
		176,
		-1,
		295,
		294,
		-1,
		241,
		233,
		219,
		-1,
		212,
		-1,
		218,
		179,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		282,
		257,
		-1,
		-1,
		-1,
		242,
		222,
		213,
		197,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		267,
		266,
		-1,
		235,
		238,
		-1,
		228,
		219,
		227,
		174,
		178,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		250,
		248,
		243,
		240,
		226,
		210,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		248,
		240,
		233,
		-1,
		-1,
		235,
		218,
		199,
		197,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		225,
		-1,
		-1,
		231,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		259,
		-1,
		-1,
		-1,
		221,
		217,
		218,
		-1,
		-1,
		-1,
		-1,
		281,
		282,
		305,
		269,
		-1,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		284,
		282,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		211,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		246,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		236,
		243,
		265,
		268,
		304,
		-1,
		255
	],
	[
		-1,
		110,
		99,
		110,
		118,
		91,
		98,
		-1,
		119,
		121,
		87,
		81,
		120,
		91,
		97,
		108,
		-1,
		-1,
		-1,
		110,
		109,
		79,
		77,
		86,
		91,
		98,
		-1,
		109,
		-1,
		131,
		110,
		121,
		126,
		72,
		69,
		89,
		108,
		102,
		94,
		146,
		102,
		73,
		67,
		85,
		87,
		96,
		88,
		-1,
		73,
		63,
		85,
		76,
		87,
		79,
		-1,
		-1,
		67,
		68,
		74,
		72,
		78,
		74,
		-1,
		84,
		78,
		-1,
		-1,
		57,
		70,
		54,
		57,
		65,
		63,
		76,
		78,
		73,
		-1,
		-1,
		58,
		56,
		63,
		50,
		46,
		63,
		82,
		68,
		82,
		81,
		-1,
		46,
		60,
		56,
		57,
		55,
		39,
		43,
		61,
		67,
		73,
		76,
		-1,
		55,
		56,
		31,
		39,
		44,
		47,
		35,
		48,
		62,
		55,
		74,
		65,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		55,
		38,
		45,
		27,
		17,
		32,
		25,
		31,
		51,
		50,
		47,
		63,
		64,
		74,
		-1,
		-1,
		149,
		122,
		146,
		104,
		85,
		-1,
		51,
		31,
		25,
		21,
		15,
		8,
		22,
		18,
		-1,
		41,
		40,
		71,
		57,
		68,
		131,
		-1,
		-1,
		107,
		99,
		81,
		84,
		61,
		57,
		46,
		45,
		38,
		31,
		27,
		5,
		8,
		8,
		18,
		35,
		45,
		49,
		64,
		75,
		-1,
		-1,
		149,
		-1,
		-1,
		128,
		111,
		-1,
		76,
		83,
		67,
		73,
		59,
		80,
		56,
		47,
		41,
		36,
		28,
		3,
		0,
		24,
		20,
		32,
		57,
		61,
		67,
		85,
		86,
		-1,
		148,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		83,
		80,
		73,
		97,
		96,
		-1,
		76,
		64,
		65,
		50,
		49,
		45,
		34,
		8,
		6,
		21,
		23,
		39,
		41,
		74,
		69,
		90,
		87,
		118,
		124,
		118,
		127,
		-1,
		136,
		132,
		128,
		135,
		84,
		-1,
		-1,
		101,
		-1,
		104,
		113,
		88,
		61,
		64,
		51,
		59,
		50,
		32,
		14,
		9,
		12,
		32,
		45,
		52,
		66,
		65,
		83,
		96,
		111,
		115,
		121,
		-1,
		186,
		-1,
		128,
		112,
		114,
		90,
		118,
		-1,
		121,
		105,
		105,
		90,
		90,
		-1,
		67,
		64,
		68,
		46,
		31,
		27,
		16,
		20,
		31,
		52,
		69,
		60,
		78,
		85,
		93,
		97,
		117,
		129,
		146,
		136,
		-1,
		118,
		123,
		93,
		105,
		128,
		148,
		126,
		-1,
		101,
		-1,
		69,
		82,
		-1,
		52,
		48,
		37,
		38,
		27,
		34,
		38,
		51,
		48,
		66,
		69,
		86,
		90,
		106,
		-1,
		-1,
		131,
		135,
		143,
		94,
		113,
		137,
		172,
		119,
		108,
		107,
		-1,
		87,
		71,
		68,
		69,
		56,
		50,
		50,
		33,
		39,
		48,
		50,
		53,
		75,
		103,
		81,
		93,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		120,
		91,
		115,
		157,
		137,
		130,
		118,
		103,
		103,
		97,
		-1,
		87,
		66,
		61,
		50,
		40,
		56,
		51,
		67,
		54,
		56,
		72,
		84,
		75,
		95,
		-1,
		-1,
		-1,
		150,
		139,
		140,
		94,
		125,
		146,
		136,
		122,
		127,
		102,
		95,
		89,
		80,
		83,
		68,
		57,
		49,
		38,
		54,
		61,
		56,
		56,
		65,
		66,
		90,
		97,
		103,
		-1,
		-1,
		157,
		147,
		131,
		133,
		130,
		116,
		123,
		155,
		127,
		140,
		-1,
		94,
		-1,
		83,
		78,
		62,
		57,
		54,
		51,
		45,
		54,
		62,
		70,
		61,
		76,
		95,
		95,
		87,
		112,
		115,
		-1,
		-1,
		-1,
		150,
		161,
		136,
		113,
		97,
		133,
		-1,
		110,
		111,
		-1,
		88,
		82,
		79,
		64,
		60,
		55,
		59,
		52,
		59,
		55,
		69,
		80,
		62,
		98,
		-1,
		95,
		89,
		117,
		109,
		97,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		92,
		144,
		-1,
		-1,
		95,
		88,
		-1,
		75,
		57,
		64,
		62,
		56,
		60,
		64,
		53,
		66,
		71,
		67,
		77,
		97,
		101,
		108,
		99,
		95,
		92,
		106,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		112,
		-1,
		104,
		96,
		86,
		80,
		74,
		70,
		68,
		84,
		68,
		71,
		71,
		67,
		75,
		60,
		63,
		70,
		74,
		92,
		105,
		97,
		91,
		90,
		102,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		125,
		-1,
		89,
		103,
		119,
		-1,
		112,
		91,
		106,
		84,
		80,
		76,
		91,
		92,
		70,
		75,
		74,
		84,
		85,
		74,
		82,
		79,
		101,
		101,
		85,
		86,
		95,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		86,
		74,
		106,
		-1,
		-1,
		148,
		-1,
		82,
		99,
		90,
		88,
		81,
		72,
		78,
		85,
		88,
		89,
		79,
		68,
		74,
		73,
		95,
		81,
		79,
		98,
		114,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		123,
		-1,
		126,
		116,
		100,
		85,
		118,
		-1,
		89,
		73,
		78,
		-1,
		114,
		-1,
		87,
		89,
		81,
		70,
		67,
		78,
		76,
		87,
		104,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		113,
		107,
		107,
		91,
		94,
		105,
		85,
		79,
		78,
		109,
		107,
		95,
		79,
		72,
		69,
		70,
		83,
		103,
		94,
		106,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		175,
		130,
		116,
		-1,
		100,
		122,
		110,
		100,
		90,
		124,
		123,
		98,
		91,
		77,
		79,
		77,
		79,
		84,
		105,
		106,
		119,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		122,
		138,
		130,
		101,
		111,
		-1,
		-1,
		102,
		100,
		110,
		94,
		81,
		101,
		104,
		94,
		78,
		93,
		105,
		113,
		118,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		155,
		121,
		133,
		135,
		139,
		105,
		-1,
		110,
		105,
		85,
		99,
		106,
		96,
		91,
		85,
		88,
		106,
		123,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		112,
		126,
		128,
		121,
		125,
		-1,
		113,
		101,
		87,
		104,
		109,
		106,
		97,
		89,
		94,
		91,
		104,
		118,
		122,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		130,
		145,
		167,
		144,
		117,
		112,
		105,
		99,
		95,
		111,
		117,
		128,
		96,
		92,
		93,
		97,
		96,
		113,
		123,
		-1,
		-1,
		144,
		161,
		156,
		138,
		142,
		194,
		-1,
		-1,
		121,
		112,
		103,
		106,
		105,
		108,
		102,
		99,
		104,
		109,
		97,
		106,
		124,
		123,
		-1,
		-1,
		-1,
		164,
		-1,
		179,
		-1,
		-1,
		157,
		192,
		139,
		121,
		117,
		115,
		108,
		117,
		112,
		107,
		117,
		119,
		111,
		99,
		103,
		126,
		115,
		154,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		193,
		168,
		183,
		203,
		177,
		184,
		154,
		151,
		-1,
		121,
		146,
		118,
		125,
		116,
		123,
		123,
		115,
		93,
		100,
		116,
		115,
		110,
		146,
		137,
		143,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		199,
		185,
		189,
		179,
		182,
		-1,
		-1,
		170,
		167,
		143,
		126,
		124,
		117,
		112,
		122,
		102,
		89,
		93,
		97,
		103,
		108,
		113,
		119,
		134,
		149,
		-1,
		171,
		252,
		245,
		228,
		236,
		267,
		-1,
		193,
		185,
		192,
		171,
		173,
		-1,
		-1,
		143,
		140,
		145,
		133,
		130,
		132,
		127,
		118,
		103,
		109,
		96,
		95,
		113,
		117,
		126,
		133,
		123,
		136,
		140,
		-1,
		185,
		228,
		222,
		225,
		249,
		263,
		-1,
		190,
		-1,
		-1,
		200,
		174,
		158,
		148,
		142,
		192,
		147,
		142,
		126,
		124,
		115,
		106,
		113,
		104,
		104,
		107,
		122,
		127,
		119,
		133,
		133,
		134,
		-1,
		220,
		208,
		216,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		216,
		-1,
		185,
		-1,
		160,
		164,
		155,
		158,
		140,
		127,
		119,
		111,
		127,
		102,
		112,
		108,
		109,
		118,
		129,
		141,
		140,
		141,
		261,
		217,
		216,
		207,
		242,
		257,
		261,
		-1,
		202,
		241,
		239,
		-1,
		223,
		-1,
		-1,
		-1,
		174,
		168,
		160,
		160,
		139,
		139,
		113,
		117,
		107,
		114,
		124,
		126,
		118,
		122,
		135,
		146,
		149,
		257,
		248,
		261,
		206,
		206,
		227,
		236,
		257,
		217,
		208,
		235,
		246,
		235,
		230,
		217,
		-1,
		-1,
		197,
		178,
		-1,
		-1,
		146,
		134,
		117,
		118,
		114,
		117,
		132,
		135,
		125,
		123,
		117,
		149,
		-1,
		250,
		249,
		238,
		235,
		211,
		202,
		197,
		224,
		-1,
		-1,
		219,
		236,
		230,
		234,
		250,
		275,
		-1,
		206,
		-1,
		-1,
		191,
		-1,
		-1,
		176,
		139,
		128,
		119,
		125,
		122,
		133,
		143,
		131,
		132,
		122,
		132,
		145,
		234,
		231,
		219,
		217,
		240,
		205,
		193,
		-1,
		206,
		204,
		210,
		217,
		234,
		264,
		-1,
		-1,
		222,
		202,
		-1,
		-1,
		174,
		172,
		161,
		-1,
		151,
		124,
		129,
		149,
		151,
		140,
		134,
		128,
		135,
		134,
		142,
		150,
		243,
		257,
		246,
		242,
		241,
		249,
		198,
		191,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		212,
		208,
		-1,
		-1,
		169,
		162,
		150,
		138,
		128,
		138,
		142,
		146,
		138,
		131,
		126,
		137,
		129,
		133,
		150,
		-1,
		277,
		-1,
		229,
		205,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		229,
		215,
		208,
		196,
		194,
		-1,
		203,
		187,
		168,
		-1,
		138,
		151,
		182,
		150,
		155,
		150,
		132,
		143,
		132,
		135,
		149,
		144,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		219,
		221,
		-1,
		220,
		209,
		194,
		186,
		-1,
		-1,
		175,
		171,
		-1,
		-1,
		139,
		164,
		153,
		161,
		156,
		136,
		142,
		145,
		134,
		138,
		150,
		-1,
		-1,
		224,
		225,
		226,
		-1,
		204,
		-1,
		222,
		-1,
		189,
		195,
		183,
		-1,
		-1,
		-1,
		177,
		140,
		161,
		171,
		165,
		163,
		154,
		140,
		147,
		145,
		141,
		152,
		-1,
		-1,
		-1,
		222,
		196,
		229,
		220,
		203,
		183,
		175,
		194,
		-1,
		164,
		-1,
		139,
		141,
		167,
		170,
		176,
		170,
		143,
		158,
		148,
		139,
		148,
		228,
		-1,
		198,
		231,
		195,
		189,
		165,
		169,
		185,
		-1,
		161,
		143,
		-1,
		171,
		161,
		192,
		177,
		158,
		145,
		152,
		152,
		145,
		-1,
		-1,
		-1,
		200,
		199,
		191,
		185,
		185,
		170,
		161,
		-1,
		173,
		155,
		134,
		151,
		151,
		142,
		150,
		182,
		178,
		165,
		165,
		157,
		-1,
		301,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		194,
		189,
		162,
		150,
		156,
		152,
		138,
		144,
		146,
		154,
		152,
		149,
		161,
		157,
		177,
		158,
		193,
		-1,
		296,
		-1,
		230,
		-1,
		-1,
		212,
		192,
		184,
		173,
		162,
		160,
		151,
		142,
		164,
		180,
		164,
		162,
		165,
		166,
		-1,
		285,
		284,
		-1,
		231,
		223,
		209,
		-1,
		202,
		-1,
		208,
		169,
		-1,
		171,
		151,
		-1,
		173,
		169,
		-1,
		-1,
		272,
		247,
		-1,
		-1,
		-1,
		232,
		212,
		203,
		187,
		-1,
		162,
		162,
		-1,
		-1,
		-1,
		257,
		256,
		-1,
		225,
		228,
		-1,
		218,
		209,
		217,
		164,
		168,
		-1,
		-1,
		-1,
		266,
		247,
		241,
		240,
		238,
		233,
		230,
		216,
		200,
		178,
		167,
		188,
		-1,
		-1,
		-1,
		238,
		230,
		223,
		-1,
		-1,
		225,
		208,
		189,
		187,
		-1,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		215,
		-1,
		-1,
		221,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		249,
		-1,
		-1,
		-1,
		211,
		207,
		208,
		-1,
		-1,
		-1,
		-1,
		271,
		272,
		295,
		259,
		-1,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		274,
		272,
		-1,
		-1,
		-1,
		231,
		215,
		-1,
		201,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		236,
		-1,
		236,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		249,
		241,
		249,
		-1,
		221,
		223,
		-1,
		271,
		-1,
		-1,
		264,
		255,
		-1,
		-1,
		226,
		233,
		255,
		258,
		294,
		-1,
		245
	],
	[
		-1,
		130,
		119,
		130,
		138,
		111,
		118,
		-1,
		139,
		141,
		107,
		101,
		140,
		111,
		117,
		128,
		-1,
		-1,
		-1,
		130,
		129,
		99,
		97,
		106,
		111,
		118,
		-1,
		127,
		-1,
		151,
		130,
		141,
		146,
		92,
		89,
		109,
		128,
		120,
		112,
		166,
		122,
		93,
		87,
		105,
		105,
		114,
		106,
		-1,
		93,
		83,
		105,
		94,
		105,
		97,
		-1,
		-1,
		87,
		88,
		94,
		90,
		96,
		92,
		-1,
		102,
		88,
		-1,
		-1,
		77,
		88,
		72,
		75,
		83,
		81,
		94,
		88,
		83,
		-1,
		-1,
		78,
		74,
		81,
		68,
		64,
		81,
		96,
		78,
		92,
		91,
		-1,
		66,
		80,
		76,
		75,
		73,
		57,
		57,
		75,
		77,
		83,
		86,
		-1,
		75,
		76,
		51,
		59,
		64,
		67,
		53,
		62,
		72,
		65,
		84,
		75,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		58,
		65,
		47,
		37,
		52,
		45,
		49,
		62,
		60,
		57,
		73,
		74,
		84,
		-1,
		-1,
		169,
		142,
		166,
		124,
		105,
		-1,
		71,
		51,
		45,
		41,
		35,
		28,
		42,
		36,
		-1,
		51,
		50,
		81,
		67,
		78,
		151,
		-1,
		-1,
		127,
		119,
		101,
		104,
		81,
		77,
		66,
		65,
		58,
		51,
		47,
		25,
		28,
		19,
		16,
		45,
		55,
		59,
		74,
		85,
		-1,
		-1,
		159,
		-1,
		-1,
		148,
		131,
		-1,
		96,
		103,
		87,
		93,
		79,
		100,
		76,
		67,
		61,
		56,
		48,
		23,
		20,
		0,
		28,
		42,
		67,
		71,
		77,
		95,
		96,
		-1,
		158,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		103,
		100,
		93,
		117,
		116,
		-1,
		96,
		84,
		85,
		70,
		69,
		61,
		50,
		28,
		16,
		29,
		31,
		49,
		51,
		84,
		79,
		100,
		97,
		128,
		134,
		128,
		137,
		-1,
		156,
		152,
		148,
		155,
		104,
		-1,
		-1,
		121,
		-1,
		124,
		133,
		108,
		81,
		84,
		71,
		69,
		56,
		46,
		27,
		19,
		22,
		42,
		55,
		62,
		76,
		75,
		93,
		106,
		121,
		125,
		131,
		-1,
		206,
		-1,
		148,
		132,
		134,
		110,
		138,
		-1,
		141,
		125,
		125,
		110,
		110,
		-1,
		87,
		84,
		74,
		52,
		43,
		37,
		26,
		30,
		41,
		62,
		79,
		70,
		88,
		95,
		103,
		107,
		127,
		139,
		166,
		156,
		-1,
		138,
		143,
		113,
		125,
		148,
		168,
		146,
		-1,
		121,
		-1,
		89,
		102,
		-1,
		58,
		54,
		46,
		48,
		37,
		44,
		48,
		61,
		58,
		76,
		79,
		96,
		100,
		116,
		-1,
		-1,
		151,
		155,
		163,
		114,
		133,
		157,
		192,
		139,
		128,
		127,
		-1,
		107,
		77,
		74,
		75,
		62,
		60,
		60,
		43,
		49,
		58,
		60,
		63,
		85,
		113,
		91,
		103,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		140,
		111,
		135,
		177,
		157,
		150,
		138,
		113,
		113,
		107,
		-1,
		93,
		72,
		71,
		60,
		50,
		66,
		61,
		77,
		64,
		66,
		82,
		94,
		85,
		105,
		-1,
		-1,
		-1,
		170,
		159,
		160,
		112,
		135,
		166,
		146,
		132,
		137,
		112,
		105,
		99,
		86,
		89,
		78,
		67,
		59,
		48,
		64,
		71,
		66,
		66,
		75,
		76,
		100,
		107,
		113,
		-1,
		-1,
		177,
		167,
		151,
		153,
		150,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		88,
		72,
		67,
		64,
		61,
		55,
		64,
		72,
		80,
		71,
		86,
		105,
		105,
		97,
		122,
		125,
		-1,
		-1,
		-1,
		170,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		89,
		74,
		70,
		65,
		69,
		62,
		69,
		65,
		79,
		90,
		72,
		108,
		-1,
		105,
		99,
		127,
		119,
		107,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		74,
		72,
		66,
		70,
		74,
		63,
		76,
		81,
		77,
		87,
		107,
		111,
		118,
		109,
		105,
		102,
		116,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		80,
		78,
		94,
		78,
		81,
		81,
		77,
		85,
		70,
		73,
		80,
		84,
		102,
		115,
		107,
		101,
		100,
		112,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		90,
		86,
		101,
		102,
		80,
		85,
		84,
		94,
		95,
		84,
		92,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		100,
		98,
		91,
		82,
		88,
		95,
		98,
		99,
		89,
		78,
		84,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		99,
		83,
		88,
		-1,
		124,
		-1,
		97,
		99,
		91,
		80,
		77,
		88,
		86,
		97,
		114,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		115,
		95,
		89,
		88,
		119,
		117,
		105,
		89,
		82,
		79,
		80,
		93,
		113,
		104,
		116,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		132,
		120,
		110,
		100,
		134,
		133,
		108,
		101,
		87,
		89,
		87,
		89,
		94,
		115,
		116,
		129,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		140,
		111,
		121,
		-1,
		-1,
		112,
		110,
		120,
		104,
		91,
		111,
		114,
		104,
		88,
		103,
		115,
		123,
		128,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		143,
		145,
		149,
		115,
		-1,
		120,
		115,
		95,
		109,
		116,
		106,
		101,
		95,
		98,
		116,
		133,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		122,
		136,
		138,
		131,
		135,
		-1,
		123,
		111,
		97,
		114,
		119,
		116,
		107,
		99,
		104,
		101,
		114,
		128,
		132,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		140,
		155,
		177,
		154,
		127,
		122,
		115,
		109,
		105,
		121,
		127,
		138,
		106,
		102,
		103,
		107,
		106,
		123,
		133,
		-1,
		-1,
		154,
		171,
		166,
		148,
		152,
		204,
		-1,
		-1,
		131,
		122,
		113,
		116,
		115,
		118,
		112,
		109,
		114,
		119,
		107,
		116,
		134,
		133,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		167,
		202,
		149,
		131,
		127,
		125,
		118,
		127,
		122,
		117,
		127,
		129,
		121,
		109,
		113,
		136,
		125,
		164,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		213,
		187,
		194,
		164,
		161,
		-1,
		131,
		156,
		128,
		135,
		126,
		133,
		133,
		125,
		103,
		110,
		126,
		125,
		120,
		156,
		147,
		153,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		209,
		195,
		199,
		189,
		192,
		-1,
		-1,
		180,
		177,
		153,
		136,
		134,
		127,
		122,
		132,
		112,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		203,
		195,
		202,
		181,
		183,
		-1,
		-1,
		153,
		150,
		155,
		143,
		140,
		142,
		137,
		128,
		113,
		119,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		200,
		-1,
		-1,
		210,
		184,
		168,
		158,
		152,
		202,
		157,
		152,
		136,
		134,
		125,
		116,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		226,
		-1,
		195,
		-1,
		170,
		174,
		165,
		168,
		150,
		137,
		129,
		121,
		137,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		271,
		227,
		226,
		217,
		252,
		267,
		271,
		-1,
		212,
		251,
		249,
		-1,
		233,
		-1,
		-1,
		-1,
		184,
		178,
		170,
		170,
		149,
		149,
		123,
		127,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		267,
		258,
		271,
		216,
		216,
		237,
		246,
		267,
		227,
		218,
		245,
		256,
		245,
		240,
		227,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		156,
		144,
		127,
		128,
		124,
		127,
		142,
		145,
		135,
		133,
		127,
		159,
		-1,
		260,
		259,
		248,
		245,
		221,
		212,
		207,
		234,
		-1,
		-1,
		229,
		246,
		240,
		244,
		260,
		285,
		-1,
		216,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		132,
		143,
		153,
		141,
		142,
		132,
		142,
		155,
		244,
		241,
		229,
		227,
		250,
		215,
		203,
		-1,
		216,
		214,
		220,
		227,
		244,
		274,
		-1,
		-1,
		232,
		212,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		134,
		139,
		159,
		161,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		253,
		267,
		256,
		252,
		251,
		259,
		208,
		201,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		222,
		218,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		152,
		156,
		148,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		287,
		-1,
		239,
		215,
		229,
		244,
		252,
		-1,
		-1,
		-1,
		239,
		225,
		218,
		206,
		204,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		227,
		230,
		-1,
		-1,
		229,
		231,
		-1,
		230,
		219,
		204,
		196,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		234,
		235,
		236,
		-1,
		214,
		-1,
		232,
		-1,
		199,
		205,
		193,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		175,
		173,
		164,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		232,
		206,
		239,
		230,
		213,
		193,
		185,
		204,
		-1,
		174,
		-1,
		149,
		151,
		177,
		180,
		186,
		180,
		153,
		168,
		158,
		149,
		158,
		238,
		-1,
		208,
		241,
		205,
		199,
		175,
		179,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		202,
		187,
		168,
		155,
		162,
		162,
		155,
		-1,
		-1,
		-1,
		210,
		209,
		201,
		195,
		195,
		180,
		171,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		192,
		188,
		175,
		175,
		167,
		-1,
		311,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		204,
		199,
		172,
		160,
		166,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		168,
		203,
		-1,
		306,
		-1,
		240,
		-1,
		-1,
		222,
		202,
		194,
		183,
		172,
		170,
		161,
		152,
		174,
		190,
		174,
		172,
		175,
		176,
		-1,
		295,
		294,
		-1,
		241,
		233,
		219,
		-1,
		212,
		-1,
		218,
		179,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		282,
		257,
		-1,
		-1,
		-1,
		242,
		222,
		213,
		197,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		267,
		266,
		-1,
		235,
		238,
		-1,
		228,
		219,
		227,
		174,
		178,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		250,
		248,
		243,
		240,
		226,
		210,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		248,
		240,
		233,
		-1,
		-1,
		235,
		218,
		199,
		197,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		225,
		-1,
		-1,
		231,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		259,
		-1,
		-1,
		-1,
		221,
		217,
		218,
		-1,
		-1,
		-1,
		-1,
		281,
		282,
		305,
		269,
		-1,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		284,
		282,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		211,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		246,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		236,
		243,
		265,
		268,
		304,
		-1,
		255
	],
	[
		-1,
		134,
		123,
		134,
		142,
		115,
		122,
		-1,
		141,
		145,
		111,
		105,
		144,
		113,
		119,
		130,
		-1,
		-1,
		-1,
		134,
		133,
		101,
		99,
		108,
		113,
		120,
		-1,
		119,
		-1,
		155,
		134,
		145,
		150,
		94,
		91,
		111,
		130,
		112,
		104,
		170,
		124,
		95,
		89,
		107,
		97,
		106,
		98,
		-1,
		95,
		85,
		107,
		86,
		97,
		89,
		-1,
		-1,
		89,
		90,
		96,
		82,
		88,
		84,
		-1,
		94,
		78,
		-1,
		-1,
		79,
		80,
		64,
		67,
		75,
		73,
		86,
		78,
		73,
		-1,
		-1,
		70,
		66,
		73,
		60,
		56,
		73,
		86,
		68,
		82,
		81,
		-1,
		72,
		86,
		82,
		67,
		65,
		49,
		47,
		65,
		67,
		73,
		76,
		-1,
		81,
		82,
		57,
		65,
		70,
		65,
		52,
		52,
		62,
		55,
		74,
		65,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		81,
		64,
		71,
		53,
		43,
		58,
		51,
		55,
		52,
		50,
		47,
		63,
		64,
		74,
		-1,
		-1,
		175,
		148,
		172,
		130,
		111,
		-1,
		77,
		57,
		51,
		47,
		41,
		34,
		48,
		44,
		-1,
		41,
		40,
		71,
		57,
		68,
		157,
		-1,
		-1,
		133,
		125,
		107,
		110,
		87,
		83,
		72,
		71,
		64,
		57,
		53,
		31,
		34,
		34,
		37,
		35,
		45,
		49,
		64,
		75,
		-1,
		-1,
		149,
		-1,
		-1,
		154,
		137,
		-1,
		102,
		109,
		93,
		99,
		85,
		106,
		82,
		73,
		67,
		62,
		54,
		29,
		26,
		36,
		0,
		32,
		57,
		61,
		67,
		85,
		86,
		-1,
		148,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		109,
		106,
		99,
		123,
		122,
		-1,
		102,
		90,
		91,
		76,
		75,
		65,
		54,
		34,
		18,
		15,
		3,
		39,
		39,
		68,
		69,
		90,
		87,
		118,
		124,
		118,
		127,
		-1,
		162,
		158,
		154,
		161,
		110,
		-1,
		-1,
		127,
		-1,
		130,
		139,
		114,
		87,
		90,
		77,
		73,
		60,
		50,
		31,
		21,
		24,
		26,
		39,
		46,
		66,
		65,
		83,
		96,
		111,
		115,
		121,
		-1,
		212,
		-1,
		154,
		138,
		140,
		116,
		144,
		-1,
		147,
		131,
		131,
		116,
		116,
		-1,
		91,
		88,
		78,
		56,
		47,
		39,
		28,
		31,
		31,
		46,
		69,
		60,
		78,
		85,
		93,
		97,
		117,
		129,
		172,
		162,
		-1,
		144,
		149,
		119,
		131,
		150,
		174,
		152,
		-1,
		127,
		-1,
		93,
		106,
		-1,
		62,
		58,
		50,
		44,
		33,
		40,
		38,
		49,
		48,
		66,
		69,
		86,
		90,
		106,
		-1,
		-1,
		157,
		161,
		165,
		116,
		135,
		159,
		196,
		145,
		134,
		133,
		-1,
		111,
		81,
		78,
		79,
		66,
		58,
		56,
		39,
		45,
		54,
		50,
		53,
		75,
		103,
		81,
		93,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		142,
		113,
		137,
		179,
		163,
		156,
		144,
		109,
		109,
		103,
		-1,
		97,
		76,
		67,
		56,
		46,
		62,
		57,
		73,
		54,
		56,
		72,
		84,
		75,
		95,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		108,
		131,
		168,
		142,
		128,
		133,
		108,
		101,
		95,
		90,
		93,
		74,
		63,
		55,
		44,
		60,
		67,
		62,
		56,
		65,
		66,
		90,
		97,
		103,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		122,
		129,
		161,
		133,
		146,
		-1,
		100,
		-1,
		89,
		84,
		68,
		63,
		60,
		57,
		51,
		60,
		68,
		70,
		61,
		76,
		95,
		95,
		87,
		112,
		115,
		-1,
		-1,
		-1,
		172,
		167,
		142,
		119,
		103,
		139,
		-1,
		116,
		117,
		-1,
		94,
		88,
		85,
		70,
		66,
		61,
		65,
		58,
		65,
		61,
		75,
		80,
		62,
		98,
		-1,
		95,
		89,
		117,
		115,
		103,
		-1,
		-1,
		-1,
		165,
		144,
		137,
		157,
		98,
		150,
		-1,
		-1,
		101,
		94,
		-1,
		81,
		63,
		70,
		68,
		62,
		66,
		70,
		59,
		72,
		77,
		67,
		77,
		97,
		101,
		108,
		101,
		101,
		98,
		112,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		118,
		-1,
		110,
		102,
		92,
		86,
		80,
		76,
		74,
		90,
		74,
		77,
		77,
		73,
		81,
		66,
		69,
		70,
		74,
		92,
		111,
		103,
		97,
		96,
		108,
		-1,
		185,
		171,
		142,
		-1,
		-1,
		131,
		-1,
		95,
		109,
		125,
		-1,
		118,
		97,
		112,
		90,
		86,
		82,
		97,
		98,
		76,
		81,
		80,
		90,
		91,
		80,
		82,
		85,
		101,
		107,
		91,
		92,
		101,
		-1,
		191,
		178,
		136,
		132,
		121,
		141,
		92,
		80,
		112,
		-1,
		-1,
		154,
		-1,
		88,
		105,
		96,
		94,
		87,
		78,
		84,
		91,
		94,
		95,
		85,
		74,
		80,
		79,
		101,
		87,
		85,
		104,
		120,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		107,
		94,
		88,
		-1,
		129,
		-1,
		132,
		122,
		106,
		91,
		124,
		-1,
		95,
		79,
		84,
		-1,
		120,
		-1,
		93,
		95,
		87,
		76,
		73,
		84,
		82,
		93,
		110,
		-1,
		141,
		126,
		119,
		109,
		123,
		94,
		-1,
		149,
		-1,
		-1,
		119,
		113,
		113,
		97,
		100,
		111,
		91,
		85,
		84,
		115,
		113,
		101,
		85,
		78,
		75,
		76,
		89,
		109,
		100,
		112,
		-1,
		-1,
		-1,
		146,
		132,
		136,
		96,
		115,
		-1,
		-1,
		181,
		136,
		122,
		-1,
		106,
		128,
		116,
		106,
		96,
		130,
		129,
		104,
		97,
		83,
		85,
		83,
		85,
		90,
		111,
		112,
		125,
		-1,
		-1,
		129,
		134,
		122,
		108,
		127,
		-1,
		-1,
		-1,
		128,
		144,
		136,
		107,
		117,
		-1,
		-1,
		108,
		106,
		116,
		100,
		87,
		107,
		110,
		100,
		84,
		99,
		111,
		119,
		124,
		-1,
		132,
		119,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		-1,
		-1,
		161,
		127,
		139,
		141,
		145,
		111,
		-1,
		116,
		111,
		91,
		105,
		112,
		102,
		97,
		91,
		94,
		112,
		129,
		-1,
		-1,
		144,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		118,
		132,
		134,
		127,
		131,
		-1,
		119,
		107,
		93,
		110,
		115,
		112,
		103,
		95,
		100,
		97,
		110,
		124,
		128,
		167,
		-1,
		150,
		-1,
		-1,
		-1,
		136,
		151,
		173,
		150,
		123,
		118,
		111,
		105,
		101,
		117,
		123,
		134,
		102,
		98,
		99,
		103,
		102,
		119,
		129,
		-1,
		-1,
		150,
		167,
		162,
		144,
		148,
		200,
		-1,
		-1,
		127,
		118,
		109,
		112,
		111,
		114,
		108,
		105,
		110,
		115,
		103,
		112,
		130,
		129,
		-1,
		-1,
		-1,
		170,
		-1,
		185,
		-1,
		-1,
		163,
		198,
		145,
		127,
		123,
		121,
		114,
		123,
		118,
		113,
		123,
		125,
		117,
		105,
		109,
		132,
		121,
		160,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		199,
		174,
		189,
		209,
		183,
		190,
		160,
		157,
		-1,
		127,
		152,
		124,
		131,
		122,
		129,
		129,
		121,
		99,
		106,
		122,
		121,
		116,
		152,
		143,
		149,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		205,
		191,
		195,
		185,
		188,
		-1,
		-1,
		176,
		173,
		149,
		132,
		130,
		123,
		118,
		128,
		108,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		140,
		155,
		-1,
		177,
		258,
		251,
		234,
		242,
		273,
		-1,
		199,
		191,
		198,
		177,
		179,
		-1,
		-1,
		149,
		146,
		151,
		139,
		136,
		138,
		133,
		124,
		109,
		115,
		102,
		101,
		119,
		123,
		132,
		139,
		129,
		142,
		146,
		-1,
		191,
		234,
		228,
		231,
		255,
		269,
		-1,
		196,
		-1,
		-1,
		206,
		180,
		164,
		154,
		148,
		198,
		153,
		148,
		132,
		130,
		121,
		112,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		139,
		139,
		140,
		-1,
		226,
		214,
		222,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		222,
		-1,
		191,
		-1,
		166,
		170,
		161,
		164,
		146,
		133,
		125,
		117,
		133,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		146,
		147,
		267,
		223,
		222,
		213,
		248,
		263,
		267,
		-1,
		208,
		247,
		245,
		-1,
		229,
		-1,
		-1,
		-1,
		180,
		174,
		166,
		166,
		145,
		145,
		119,
		123,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		155,
		263,
		254,
		267,
		212,
		212,
		233,
		242,
		263,
		223,
		214,
		241,
		252,
		241,
		236,
		223,
		-1,
		-1,
		203,
		184,
		-1,
		-1,
		152,
		140,
		123,
		124,
		120,
		123,
		138,
		141,
		131,
		129,
		123,
		155,
		-1,
		256,
		255,
		244,
		241,
		217,
		208,
		203,
		230,
		-1,
		-1,
		225,
		242,
		236,
		240,
		256,
		281,
		-1,
		212,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		128,
		139,
		149,
		137,
		138,
		128,
		138,
		151,
		240,
		237,
		225,
		223,
		246,
		211,
		199,
		-1,
		212,
		210,
		216,
		223,
		240,
		270,
		-1,
		-1,
		228,
		208,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		130,
		135,
		155,
		157,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		249,
		263,
		252,
		248,
		247,
		255,
		204,
		197,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		218,
		214,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		148,
		152,
		144,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		283,
		-1,
		235,
		211,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		235,
		221,
		214,
		202,
		200,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		223,
		226,
		-1,
		-1,
		225,
		227,
		-1,
		226,
		215,
		200,
		192,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		230,
		231,
		232,
		-1,
		210,
		-1,
		228,
		-1,
		195,
		201,
		189,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		171,
		169,
		160,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		228,
		202,
		235,
		226,
		209,
		189,
		181,
		200,
		-1,
		170,
		-1,
		145,
		147,
		173,
		176,
		182,
		176,
		149,
		164,
		154,
		145,
		154,
		234,
		-1,
		204,
		237,
		201,
		195,
		171,
		175,
		191,
		-1,
		167,
		149,
		-1,
		177,
		167,
		198,
		183,
		164,
		151,
		158,
		158,
		151,
		-1,
		-1,
		-1,
		206,
		205,
		197,
		191,
		191,
		176,
		167,
		-1,
		179,
		161,
		140,
		157,
		157,
		148,
		156,
		188,
		184,
		171,
		171,
		163,
		-1,
		307,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		200,
		195,
		168,
		156,
		162,
		158,
		144,
		150,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		164,
		199,
		-1,
		302,
		-1,
		236,
		-1,
		-1,
		218,
		198,
		190,
		179,
		168,
		166,
		157,
		148,
		170,
		186,
		170,
		168,
		171,
		172,
		-1,
		291,
		290,
		-1,
		237,
		229,
		215,
		-1,
		208,
		-1,
		214,
		175,
		-1,
		177,
		157,
		-1,
		179,
		175,
		-1,
		-1,
		278,
		253,
		-1,
		-1,
		-1,
		238,
		218,
		209,
		193,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		263,
		262,
		-1,
		231,
		234,
		-1,
		224,
		215,
		223,
		170,
		174,
		-1,
		-1,
		-1,
		272,
		253,
		247,
		246,
		244,
		239,
		236,
		222,
		206,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		244,
		236,
		229,
		-1,
		-1,
		231,
		214,
		195,
		193,
		-1,
		-1,
		-1,
		266,
		247,
		-1,
		-1,
		221,
		-1,
		-1,
		227,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		255,
		-1,
		-1,
		-1,
		217,
		213,
		214,
		-1,
		-1,
		-1,
		-1,
		277,
		278,
		301,
		265,
		-1,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		280,
		278,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		207,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		242,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		255,
		247,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		270,
		261,
		-1,
		-1,
		232,
		239,
		261,
		264,
		300,
		-1,
		251
	],
	[
		-1,
		102,
		91,
		102,
		110,
		83,
		90,
		-1,
		109,
		113,
		79,
		73,
		112,
		81,
		87,
		98,
		-1,
		-1,
		-1,
		102,
		101,
		69,
		67,
		76,
		81,
		88,
		-1,
		87,
		-1,
		123,
		102,
		113,
		118,
		62,
		59,
		79,
		98,
		80,
		72,
		138,
		92,
		63,
		57,
		75,
		65,
		74,
		66,
		-1,
		63,
		53,
		75,
		54,
		65,
		57,
		-1,
		-1,
		57,
		58,
		64,
		50,
		56,
		52,
		-1,
		62,
		46,
		-1,
		-1,
		47,
		48,
		32,
		35,
		43,
		41,
		54,
		46,
		41,
		-1,
		-1,
		38,
		34,
		41,
		28,
		24,
		41,
		54,
		36,
		50,
		49,
		-1,
		50,
		67,
		67,
		35,
		33,
		17,
		15,
		33,
		35,
		41,
		44,
		-1,
		67,
		63,
		64,
		62,
		57,
		33,
		20,
		20,
		30,
		23,
		42,
		33,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		68,
		59,
		76,
		60,
		50,
		54,
		52,
		23,
		20,
		18,
		15,
		31,
		32,
		42,
		-1,
		-1,
		161,
		134,
		158,
		116,
		98,
		-1,
		64,
		64,
		58,
		54,
		48,
		41,
		54,
		39,
		-1,
		9,
		8,
		39,
		25,
		36,
		143,
		-1,
		-1,
		119,
		111,
		93,
		96,
		73,
		69,
		79,
		78,
		71,
		64,
		60,
		38,
		41,
		41,
		47,
		3,
		13,
		17,
		32,
		43,
		-1,
		-1,
		117,
		-1,
		-1,
		140,
		123,
		-1,
		88,
		95,
		79,
		85,
		71,
		92,
		89,
		80,
		74,
		69,
		61,
		36,
		33,
		46,
		25,
		0,
		25,
		29,
		35,
		53,
		54,
		-1,
		116,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		95,
		92,
		85,
		109,
		108,
		-1,
		109,
		97,
		98,
		83,
		82,
		76,
		64,
		41,
		25,
		25,
		22,
		7,
		9,
		46,
		37,
		58,
		55,
		86,
		92,
		86,
		95,
		-1,
		148,
		144,
		140,
		147,
		96,
		-1,
		-1,
		113,
		-1,
		116,
		129,
		121,
		94,
		97,
		84,
		84,
		71,
		60,
		42,
		23,
		20,
		19,
		15,
		24,
		34,
		33,
		51,
		64,
		79,
		83,
		89,
		-1,
		198,
		-1,
		140,
		124,
		126,
		102,
		130,
		-1,
		133,
		117,
		137,
		123,
		123,
		-1,
		100,
		97,
		89,
		67,
		52,
		35,
		23,
		18,
		18,
		22,
		37,
		28,
		46,
		53,
		61,
		65,
		85,
		97,
		158,
		148,
		-1,
		130,
		135,
		105,
		117,
		137,
		160,
		139,
		-1,
		134,
		-1,
		102,
		115,
		-1,
		73,
		69,
		43,
		31,
		20,
		27,
		25,
		19,
		16,
		34,
		37,
		54,
		58,
		74,
		-1,
		-1,
		143,
		147,
		152,
		103,
		122,
		146,
		183,
		132,
		121,
		120,
		-1,
		111,
		79,
		76,
		73,
		60,
		45,
		43,
		26,
		32,
		33,
		18,
		21,
		43,
		71,
		49,
		61,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		129,
		100,
		124,
		166,
		150,
		143,
		131,
		96,
		96,
		90,
		-1,
		84,
		63,
		54,
		43,
		33,
		49,
		39,
		42,
		22,
		24,
		40,
		52,
		43,
		63,
		-1,
		-1,
		-1,
		159,
		148,
		149,
		95,
		118,
		155,
		129,
		115,
		120,
		95,
		88,
		82,
		88,
		80,
		61,
		50,
		42,
		31,
		40,
		50,
		44,
		24,
		33,
		34,
		58,
		65,
		71,
		-1,
		-1,
		166,
		156,
		140,
		142,
		139,
		109,
		116,
		148,
		120,
		133,
		-1,
		87,
		-1,
		76,
		71,
		55,
		50,
		47,
		44,
		38,
		47,
		52,
		38,
		29,
		44,
		63,
		63,
		55,
		80,
		83,
		-1,
		-1,
		-1,
		159,
		154,
		129,
		106,
		90,
		126,
		-1,
		103,
		104,
		-1,
		81,
		75,
		72,
		57,
		53,
		48,
		52,
		45,
		52,
		48,
		47,
		48,
		30,
		66,
		-1,
		63,
		57,
		85,
		88,
		78,
		-1,
		-1,
		-1,
		152,
		131,
		124,
		144,
		85,
		137,
		-1,
		-1,
		88,
		81,
		-1,
		68,
		50,
		57,
		55,
		49,
		53,
		57,
		46,
		59,
		55,
		35,
		45,
		65,
		69,
		76,
		69,
		74,
		73,
		87,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		105,
		-1,
		97,
		89,
		79,
		73,
		67,
		63,
		61,
		77,
		61,
		64,
		64,
		60,
		68,
		53,
		52,
		38,
		42,
		60,
		87,
		82,
		77,
		76,
		83,
		-1,
		172,
		158,
		129,
		-1,
		-1,
		118,
		-1,
		82,
		96,
		112,
		-1,
		105,
		84,
		99,
		77,
		73,
		69,
		84,
		85,
		63,
		68,
		67,
		77,
		74,
		63,
		50,
		54,
		69,
		79,
		71,
		72,
		81,
		-1,
		178,
		165,
		123,
		119,
		108,
		128,
		79,
		67,
		99,
		-1,
		-1,
		141,
		-1,
		75,
		92,
		83,
		81,
		74,
		65,
		71,
		78,
		81,
		78,
		68,
		57,
		63,
		59,
		81,
		67,
		65,
		84,
		99,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		94,
		81,
		75,
		-1,
		116,
		-1,
		119,
		109,
		93,
		78,
		111,
		-1,
		82,
		66,
		71,
		-1,
		103,
		-1,
		76,
		76,
		67,
		56,
		53,
		64,
		62,
		73,
		90,
		-1,
		128,
		113,
		106,
		96,
		110,
		81,
		-1,
		136,
		-1,
		-1,
		106,
		100,
		100,
		84,
		87,
		98,
		78,
		72,
		71,
		98,
		93,
		84,
		65,
		58,
		55,
		56,
		69,
		89,
		80,
		92,
		-1,
		-1,
		-1,
		133,
		119,
		123,
		83,
		102,
		-1,
		-1,
		168,
		123,
		109,
		-1,
		93,
		115,
		103,
		93,
		83,
		117,
		109,
		84,
		77,
		63,
		65,
		63,
		65,
		70,
		91,
		92,
		105,
		-1,
		-1,
		116,
		121,
		109,
		95,
		114,
		-1,
		-1,
		-1,
		115,
		131,
		123,
		94,
		104,
		-1,
		-1,
		95,
		93,
		101,
		80,
		67,
		87,
		90,
		80,
		64,
		79,
		91,
		99,
		104,
		-1,
		119,
		106,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		126,
		121,
		125,
		98,
		-1,
		97,
		91,
		71,
		85,
		92,
		82,
		77,
		71,
		74,
		92,
		109,
		-1,
		-1,
		131,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		105,
		119,
		114,
		107,
		111,
		-1,
		99,
		87,
		73,
		90,
		95,
		92,
		83,
		75,
		80,
		77,
		90,
		104,
		108,
		154,
		-1,
		137,
		-1,
		-1,
		-1,
		123,
		138,
		153,
		130,
		103,
		98,
		91,
		85,
		81,
		97,
		103,
		114,
		82,
		78,
		79,
		83,
		82,
		99,
		109,
		-1,
		-1,
		137,
		154,
		149,
		131,
		135,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		91,
		94,
		88,
		85,
		90,
		95,
		83,
		92,
		110,
		109,
		-1,
		-1,
		-1,
		157,
		-1,
		172,
		-1,
		-1,
		150,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		105,
		97,
		85,
		89,
		112,
		101,
		140,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		186,
		161,
		176,
		189,
		170,
		177,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		102,
		109,
		109,
		101,
		79,
		86,
		102,
		101,
		96,
		132,
		123,
		129,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		189,
		178,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		112,
		110,
		103,
		98,
		108,
		88,
		75,
		79,
		83,
		89,
		94,
		99,
		105,
		120,
		135,
		-1,
		164,
		245,
		238,
		221,
		229,
		260,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		119,
		116,
		118,
		113,
		104,
		89,
		95,
		82,
		81,
		99,
		103,
		112,
		119,
		109,
		122,
		126,
		-1,
		178,
		221,
		215,
		218,
		242,
		256,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		128,
		178,
		133,
		128,
		112,
		110,
		101,
		92,
		99,
		90,
		90,
		93,
		108,
		113,
		105,
		119,
		119,
		120,
		-1,
		213,
		201,
		209,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		146,
		150,
		141,
		144,
		126,
		113,
		105,
		97,
		113,
		88,
		98,
		94,
		95,
		104,
		115,
		127,
		126,
		127,
		247,
		203,
		206,
		200,
		228,
		243,
		247,
		-1,
		188,
		227,
		225,
		-1,
		209,
		-1,
		-1,
		-1,
		160,
		154,
		146,
		146,
		125,
		125,
		99,
		103,
		93,
		100,
		110,
		112,
		104,
		108,
		121,
		132,
		135,
		243,
		234,
		247,
		192,
		192,
		213,
		222,
		243,
		203,
		194,
		221,
		232,
		221,
		216,
		203,
		-1,
		-1,
		183,
		164,
		-1,
		-1,
		132,
		120,
		103,
		104,
		100,
		103,
		118,
		121,
		111,
		109,
		103,
		135,
		-1,
		236,
		235,
		224,
		221,
		197,
		188,
		183,
		210,
		-1,
		-1,
		205,
		222,
		216,
		220,
		236,
		261,
		-1,
		192,
		-1,
		-1,
		177,
		-1,
		-1,
		162,
		125,
		114,
		105,
		111,
		108,
		119,
		129,
		117,
		118,
		108,
		118,
		131,
		220,
		217,
		205,
		203,
		226,
		191,
		179,
		-1,
		192,
		190,
		196,
		203,
		220,
		250,
		-1,
		-1,
		208,
		188,
		-1,
		-1,
		160,
		158,
		147,
		-1,
		137,
		110,
		115,
		135,
		137,
		126,
		120,
		114,
		121,
		120,
		128,
		136,
		229,
		243,
		232,
		228,
		227,
		235,
		184,
		177,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		194,
		-1,
		-1,
		155,
		148,
		136,
		124,
		114,
		124,
		128,
		132,
		124,
		117,
		112,
		123,
		115,
		119,
		136,
		-1,
		263,
		-1,
		215,
		191,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		189,
		173,
		154,
		-1,
		124,
		137,
		168,
		136,
		141,
		136,
		118,
		129,
		118,
		121,
		135,
		130,
		-1,
		-1,
		203,
		206,
		-1,
		-1,
		205,
		207,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		161,
		157,
		-1,
		-1,
		125,
		150,
		139,
		147,
		142,
		122,
		128,
		131,
		120,
		124,
		136,
		-1,
		-1,
		210,
		211,
		212,
		-1,
		190,
		-1,
		208,
		-1,
		175,
		181,
		169,
		-1,
		-1,
		-1,
		163,
		126,
		147,
		157,
		151,
		149,
		140,
		126,
		133,
		131,
		127,
		138,
		-1,
		-1,
		-1,
		208,
		182,
		215,
		206,
		189,
		169,
		161,
		180,
		-1,
		150,
		-1,
		125,
		127,
		153,
		156,
		162,
		156,
		129,
		144,
		134,
		125,
		134,
		214,
		-1,
		184,
		217,
		181,
		175,
		151,
		155,
		171,
		-1,
		147,
		129,
		-1,
		157,
		147,
		178,
		163,
		144,
		131,
		138,
		138,
		131,
		-1,
		-1,
		-1,
		186,
		185,
		177,
		171,
		171,
		156,
		147,
		-1,
		159,
		141,
		120,
		137,
		137,
		128,
		136,
		168,
		164,
		151,
		151,
		143,
		-1,
		287,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		180,
		175,
		148,
		136,
		142,
		138,
		124,
		130,
		132,
		140,
		138,
		135,
		147,
		143,
		163,
		144,
		179,
		-1,
		282,
		-1,
		216,
		-1,
		-1,
		198,
		178,
		170,
		159,
		148,
		146,
		137,
		128,
		150,
		166,
		150,
		148,
		151,
		152,
		-1,
		271,
		270,
		-1,
		217,
		209,
		195,
		-1,
		188,
		-1,
		194,
		155,
		-1,
		157,
		137,
		-1,
		159,
		155,
		-1,
		-1,
		258,
		233,
		-1,
		-1,
		-1,
		218,
		198,
		189,
		173,
		-1,
		148,
		148,
		-1,
		-1,
		-1,
		243,
		242,
		-1,
		211,
		214,
		-1,
		204,
		195,
		203,
		150,
		154,
		-1,
		-1,
		-1,
		252,
		233,
		227,
		226,
		224,
		219,
		216,
		202,
		186,
		164,
		153,
		174,
		-1,
		-1,
		-1,
		224,
		216,
		209,
		-1,
		-1,
		211,
		194,
		175,
		173,
		-1,
		-1,
		-1,
		246,
		227,
		-1,
		-1,
		201,
		-1,
		-1,
		207,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		235,
		-1,
		-1,
		-1,
		197,
		193,
		194,
		-1,
		-1,
		-1,
		-1,
		257,
		258,
		281,
		245,
		-1,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		260,
		258,
		-1,
		-1,
		-1,
		217,
		201,
		-1,
		187,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		222,
		-1,
		222,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		235,
		227,
		235,
		-1,
		207,
		209,
		-1,
		257,
		-1,
		-1,
		250,
		241,
		-1,
		-1,
		212,
		219,
		241,
		244,
		280,
		-1,
		231
	],
	[
		-1,
		129,
		118,
		129,
		137,
		110,
		117,
		-1,
		136,
		140,
		106,
		100,
		139,
		108,
		114,
		125,
		-1,
		-1,
		-1,
		129,
		128,
		96,
		94,
		103,
		108,
		115,
		-1,
		114,
		-1,
		150,
		129,
		140,
		145,
		89,
		86,
		106,
		125,
		107,
		99,
		165,
		119,
		90,
		84,
		102,
		92,
		101,
		93,
		-1,
		90,
		80,
		102,
		81,
		92,
		84,
		-1,
		-1,
		84,
		85,
		91,
		77,
		83,
		79,
		-1,
		86,
		65,
		-1,
		-1,
		74,
		75,
		59,
		62,
		70,
		68,
		81,
		68,
		60,
		-1,
		-1,
		65,
		61,
		68,
		55,
		51,
		68,
		81,
		57,
		49,
		47,
		-1,
		77,
		94,
		94,
		62,
		60,
		44,
		42,
		60,
		54,
		47,
		39,
		-1,
		94,
		90,
		91,
		89,
		84,
		60,
		47,
		47,
		55,
		45,
		41,
		28,
		74,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		95,
		86,
		103,
		87,
		77,
		81,
		79,
		50,
		45,
		43,
		36,
		36,
		27,
		37,
		-1,
		-1,
		188,
		161,
		185,
		143,
		125,
		-1,
		91,
		91,
		85,
		81,
		75,
		68,
		81,
		66,
		-1,
		20,
		29,
		34,
		20,
		31,
		170,
		-1,
		-1,
		146,
		138,
		120,
		123,
		100,
		96,
		106,
		105,
		98,
		91,
		87,
		65,
		68,
		68,
		74,
		30,
		15,
		12,
		27,
		38,
		-1,
		-1,
		144,
		-1,
		-1,
		167,
		150,
		-1,
		115,
		122,
		106,
		112,
		98,
		119,
		116,
		107,
		101,
		96,
		88,
		63,
		60,
		72,
		52,
		27,
		0,
		13,
		30,
		48,
		49,
		-1,
		143,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		122,
		119,
		112,
		136,
		135,
		-1,
		136,
		124,
		125,
		110,
		109,
		103,
		91,
		68,
		52,
		52,
		49,
		34,
		36,
		64,
		32,
		53,
		50,
		81,
		119,
		113,
		122,
		-1,
		175,
		171,
		167,
		174,
		123,
		-1,
		-1,
		140,
		-1,
		143,
		156,
		148,
		121,
		124,
		111,
		111,
		98,
		87,
		69,
		50,
		47,
		46,
		42,
		51,
		37,
		40,
		56,
		59,
		106,
		110,
		116,
		-1,
		225,
		-1,
		167,
		151,
		153,
		129,
		157,
		-1,
		160,
		144,
		164,
		150,
		150,
		-1,
		127,
		124,
		116,
		94,
		79,
		62,
		50,
		45,
		45,
		49,
		64,
		44,
		62,
		64,
		71,
		92,
		112,
		124,
		185,
		175,
		-1,
		157,
		162,
		132,
		144,
		164,
		187,
		166,
		-1,
		161,
		-1,
		129,
		142,
		-1,
		100,
		96,
		70,
		58,
		47,
		54,
		52,
		46,
		43,
		50,
		53,
		81,
		82,
		101,
		-1,
		-1,
		170,
		174,
		179,
		130,
		149,
		173,
		210,
		159,
		148,
		147,
		-1,
		138,
		106,
		103,
		100,
		87,
		72,
		70,
		53,
		59,
		60,
		45,
		48,
		59,
		98,
		76,
		88,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		156,
		127,
		151,
		193,
		177,
		170,
		158,
		123,
		123,
		117,
		-1,
		111,
		90,
		81,
		70,
		60,
		76,
		66,
		69,
		49,
		51,
		65,
		79,
		70,
		90,
		-1,
		-1,
		-1,
		186,
		175,
		176,
		122,
		145,
		182,
		156,
		142,
		147,
		122,
		115,
		109,
		115,
		107,
		88,
		77,
		69,
		58,
		67,
		77,
		71,
		51,
		60,
		61,
		85,
		92,
		98,
		-1,
		-1,
		193,
		183,
		167,
		169,
		166,
		136,
		143,
		175,
		147,
		160,
		-1,
		114,
		-1,
		103,
		98,
		82,
		77,
		74,
		71,
		65,
		74,
		79,
		65,
		56,
		71,
		90,
		90,
		82,
		107,
		110,
		-1,
		-1,
		-1,
		186,
		181,
		156,
		133,
		117,
		153,
		-1,
		130,
		131,
		-1,
		108,
		102,
		99,
		84,
		80,
		75,
		79,
		72,
		79,
		75,
		74,
		75,
		57,
		93,
		-1,
		90,
		84,
		112,
		115,
		105,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		112,
		164,
		-1,
		-1,
		115,
		108,
		-1,
		95,
		77,
		84,
		82,
		76,
		80,
		84,
		73,
		86,
		82,
		62,
		72,
		92,
		96,
		103,
		96,
		101,
		100,
		114,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		132,
		-1,
		124,
		116,
		106,
		100,
		94,
		90,
		88,
		104,
		88,
		91,
		91,
		87,
		95,
		80,
		79,
		65,
		69,
		87,
		114,
		109,
		104,
		103,
		110,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		145,
		-1,
		109,
		123,
		139,
		-1,
		132,
		111,
		126,
		104,
		100,
		96,
		111,
		112,
		90,
		95,
		94,
		104,
		101,
		90,
		77,
		81,
		96,
		106,
		98,
		99,
		108,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		106,
		94,
		126,
		-1,
		-1,
		168,
		-1,
		102,
		119,
		110,
		108,
		101,
		92,
		98,
		105,
		108,
		105,
		95,
		84,
		90,
		86,
		108,
		94,
		92,
		111,
		126,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		146,
		136,
		120,
		105,
		138,
		-1,
		109,
		93,
		98,
		-1,
		130,
		-1,
		103,
		103,
		94,
		83,
		80,
		91,
		89,
		100,
		117,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		163,
		-1,
		-1,
		133,
		127,
		127,
		111,
		114,
		125,
		105,
		99,
		98,
		125,
		120,
		111,
		92,
		85,
		82,
		83,
		96,
		116,
		107,
		119,
		-1,
		-1,
		-1,
		160,
		146,
		150,
		110,
		129,
		-1,
		-1,
		195,
		150,
		136,
		-1,
		120,
		142,
		130,
		120,
		110,
		144,
		136,
		111,
		104,
		90,
		92,
		90,
		92,
		97,
		118,
		119,
		132,
		-1,
		-1,
		143,
		148,
		136,
		122,
		141,
		-1,
		-1,
		-1,
		142,
		158,
		150,
		121,
		131,
		-1,
		-1,
		122,
		120,
		128,
		107,
		94,
		114,
		117,
		107,
		91,
		106,
		118,
		126,
		131,
		-1,
		146,
		133,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		153,
		148,
		152,
		125,
		-1,
		124,
		118,
		98,
		112,
		119,
		109,
		104,
		98,
		101,
		119,
		136,
		-1,
		-1,
		158,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		132,
		146,
		141,
		134,
		138,
		-1,
		126,
		114,
		100,
		117,
		122,
		119,
		110,
		102,
		107,
		104,
		117,
		131,
		135,
		181,
		-1,
		164,
		-1,
		-1,
		-1,
		150,
		165,
		180,
		157,
		130,
		125,
		118,
		112,
		108,
		124,
		130,
		141,
		109,
		105,
		106,
		110,
		109,
		126,
		136,
		-1,
		-1,
		164,
		181,
		176,
		158,
		162,
		207,
		-1,
		-1,
		134,
		125,
		116,
		119,
		118,
		121,
		115,
		112,
		117,
		122,
		110,
		119,
		137,
		136,
		-1,
		-1,
		-1,
		184,
		-1,
		199,
		-1,
		-1,
		177,
		205,
		152,
		134,
		130,
		128,
		121,
		130,
		125,
		120,
		130,
		132,
		124,
		112,
		116,
		139,
		128,
		167,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		213,
		188,
		203,
		216,
		197,
		204,
		167,
		164,
		-1,
		134,
		159,
		131,
		138,
		129,
		136,
		136,
		128,
		106,
		113,
		129,
		128,
		123,
		159,
		150,
		156,
		-1,
		-1,
		296,
		285,
		274,
		280,
		-1,
		216,
		205,
		202,
		192,
		195,
		-1,
		-1,
		183,
		180,
		156,
		139,
		137,
		130,
		125,
		135,
		115,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		147,
		162,
		-1,
		191,
		272,
		265,
		248,
		256,
		287,
		-1,
		206,
		198,
		209,
		184,
		186,
		-1,
		-1,
		156,
		153,
		158,
		146,
		143,
		145,
		140,
		131,
		116,
		122,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		205,
		248,
		242,
		245,
		269,
		283,
		-1,
		203,
		-1,
		-1,
		215,
		187,
		171,
		161,
		155,
		205,
		160,
		155,
		139,
		137,
		128,
		119,
		126,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		240,
		228,
		236,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		231,
		-1,
		198,
		-1,
		173,
		177,
		168,
		171,
		153,
		140,
		132,
		124,
		140,
		115,
		125,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		274,
		230,
		233,
		227,
		255,
		270,
		274,
		-1,
		215,
		254,
		252,
		-1,
		236,
		-1,
		-1,
		-1,
		187,
		181,
		173,
		173,
		152,
		152,
		126,
		130,
		120,
		127,
		137,
		139,
		131,
		135,
		148,
		159,
		162,
		270,
		261,
		274,
		219,
		219,
		240,
		249,
		270,
		230,
		221,
		248,
		259,
		248,
		243,
		230,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		159,
		147,
		130,
		131,
		127,
		130,
		145,
		148,
		138,
		136,
		130,
		162,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		210,
		237,
		-1,
		-1,
		232,
		249,
		243,
		247,
		263,
		288,
		-1,
		219,
		-1,
		-1,
		204,
		-1,
		-1,
		189,
		152,
		141,
		132,
		138,
		135,
		146,
		156,
		144,
		145,
		135,
		145,
		158,
		247,
		244,
		232,
		230,
		253,
		218,
		206,
		-1,
		219,
		217,
		223,
		230,
		247,
		277,
		-1,
		-1,
		235,
		215,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		137,
		142,
		162,
		164,
		153,
		147,
		141,
		148,
		147,
		155,
		163,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		204,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		225,
		221,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		155,
		159,
		151,
		144,
		139,
		150,
		142,
		146,
		163,
		-1,
		290,
		-1,
		242,
		218,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		242,
		228,
		221,
		209,
		207,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		195,
		163,
		168,
		163,
		145,
		156,
		145,
		148,
		162,
		157,
		-1,
		-1,
		230,
		233,
		-1,
		-1,
		232,
		234,
		-1,
		233,
		222,
		207,
		199,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		152,
		177,
		166,
		174,
		169,
		149,
		155,
		158,
		147,
		151,
		163,
		-1,
		-1,
		237,
		238,
		239,
		-1,
		217,
		-1,
		235,
		-1,
		202,
		208,
		196,
		-1,
		-1,
		-1,
		190,
		153,
		174,
		184,
		178,
		176,
		167,
		153,
		160,
		158,
		154,
		165,
		-1,
		-1,
		-1,
		235,
		209,
		242,
		233,
		216,
		196,
		188,
		207,
		-1,
		177,
		-1,
		152,
		154,
		180,
		183,
		189,
		183,
		156,
		171,
		161,
		152,
		161,
		241,
		-1,
		211,
		244,
		208,
		202,
		178,
		182,
		198,
		-1,
		174,
		156,
		-1,
		184,
		174,
		205,
		190,
		171,
		158,
		165,
		165,
		158,
		-1,
		-1,
		-1,
		213,
		212,
		204,
		198,
		198,
		183,
		174,
		-1,
		186,
		168,
		147,
		164,
		164,
		155,
		163,
		195,
		191,
		178,
		178,
		170,
		-1,
		314,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		207,
		202,
		175,
		163,
		169,
		165,
		151,
		157,
		159,
		167,
		165,
		162,
		174,
		170,
		190,
		171,
		206,
		-1,
		309,
		-1,
		243,
		-1,
		-1,
		225,
		205,
		197,
		186,
		175,
		173,
		164,
		155,
		177,
		193,
		177,
		175,
		178,
		179,
		-1,
		298,
		297,
		-1,
		244,
		236,
		222,
		-1,
		215,
		-1,
		221,
		182,
		-1,
		184,
		164,
		-1,
		186,
		182,
		-1,
		-1,
		285,
		260,
		-1,
		-1,
		-1,
		245,
		225,
		216,
		200,
		-1,
		175,
		175,
		-1,
		-1,
		-1,
		270,
		269,
		-1,
		238,
		241,
		-1,
		231,
		222,
		230,
		177,
		181,
		-1,
		-1,
		-1,
		279,
		260,
		254,
		253,
		251,
		246,
		243,
		229,
		213,
		191,
		180,
		201,
		-1,
		-1,
		-1,
		251,
		243,
		236,
		-1,
		-1,
		238,
		221,
		202,
		200,
		-1,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		228,
		-1,
		-1,
		234,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		262,
		-1,
		-1,
		-1,
		224,
		220,
		221,
		-1,
		-1,
		-1,
		-1,
		284,
		285,
		308,
		272,
		-1,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		287,
		285,
		-1,
		-1,
		-1,
		244,
		228,
		-1,
		214,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		249,
		-1,
		249,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		262,
		254,
		262,
		-1,
		234,
		236,
		-1,
		284,
		-1,
		-1,
		277,
		268,
		-1,
		-1,
		239,
		246,
		268,
		271,
		307,
		-1,
		258
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		138,
		142,
		108,
		102,
		141,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		131,
		130,
		98,
		96,
		105,
		110,
		117,
		-1,
		116,
		-1,
		152,
		131,
		142,
		147,
		91,
		88,
		108,
		127,
		109,
		101,
		167,
		121,
		92,
		86,
		104,
		94,
		103,
		95,
		-1,
		92,
		82,
		104,
		83,
		94,
		86,
		-1,
		-1,
		86,
		87,
		93,
		79,
		85,
		81,
		-1,
		90,
		70,
		-1,
		-1,
		76,
		77,
		61,
		64,
		72,
		70,
		83,
		72,
		65,
		-1,
		-1,
		67,
		63,
		70,
		57,
		53,
		70,
		83,
		62,
		53,
		51,
		-1,
		79,
		96,
		96,
		64,
		62,
		46,
		44,
		62,
		59,
		51,
		43,
		-1,
		96,
		92,
		93,
		91,
		86,
		62,
		49,
		49,
		59,
		49,
		45,
		32,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		97,
		88,
		105,
		89,
		79,
		83,
		81,
		52,
		49,
		47,
		40,
		41,
		31,
		41,
		-1,
		-1,
		190,
		163,
		187,
		145,
		127,
		-1,
		93,
		93,
		87,
		83,
		77,
		70,
		83,
		68,
		-1,
		24,
		33,
		38,
		24,
		35,
		172,
		-1,
		-1,
		148,
		140,
		122,
		125,
		102,
		98,
		108,
		107,
		100,
		93,
		89,
		67,
		70,
		70,
		76,
		32,
		19,
		16,
		31,
		42,
		-1,
		-1,
		146,
		-1,
		-1,
		169,
		152,
		-1,
		117,
		124,
		108,
		114,
		100,
		121,
		118,
		109,
		103,
		98,
		90,
		65,
		62,
		75,
		54,
		29,
		14,
		0,
		34,
		52,
		53,
		-1,
		145,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		124,
		121,
		114,
		138,
		137,
		-1,
		138,
		126,
		127,
		112,
		111,
		105,
		93,
		70,
		54,
		54,
		51,
		36,
		38,
		68,
		36,
		57,
		54,
		85,
		121,
		115,
		124,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		142,
		-1,
		145,
		158,
		150,
		123,
		126,
		113,
		113,
		100,
		89,
		71,
		52,
		49,
		48,
		44,
		53,
		41,
		44,
		60,
		63,
		108,
		112,
		118,
		-1,
		227,
		-1,
		169,
		153,
		155,
		131,
		159,
		-1,
		162,
		146,
		166,
		152,
		152,
		-1,
		129,
		126,
		118,
		96,
		81,
		64,
		52,
		47,
		47,
		51,
		66,
		48,
		66,
		68,
		75,
		94,
		114,
		126,
		187,
		177,
		-1,
		159,
		164,
		134,
		146,
		166,
		189,
		168,
		-1,
		163,
		-1,
		131,
		144,
		-1,
		102,
		98,
		72,
		60,
		49,
		56,
		54,
		48,
		45,
		54,
		57,
		83,
		86,
		103,
		-1,
		-1,
		172,
		176,
		181,
		132,
		151,
		175,
		212,
		161,
		150,
		149,
		-1,
		140,
		108,
		105,
		102,
		89,
		74,
		72,
		55,
		61,
		62,
		47,
		50,
		63,
		100,
		78,
		90,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		158,
		129,
		153,
		195,
		179,
		172,
		160,
		125,
		125,
		119,
		-1,
		113,
		92,
		83,
		72,
		62,
		78,
		68,
		71,
		51,
		53,
		69,
		81,
		72,
		92,
		-1,
		-1,
		-1,
		188,
		177,
		178,
		124,
		147,
		184,
		158,
		144,
		149,
		124,
		117,
		111,
		117,
		109,
		90,
		79,
		71,
		60,
		69,
		79,
		73,
		53,
		62,
		63,
		87,
		94,
		100,
		-1,
		-1,
		195,
		185,
		169,
		171,
		168,
		138,
		145,
		177,
		149,
		162,
		-1,
		116,
		-1,
		105,
		100,
		84,
		79,
		76,
		73,
		67,
		76,
		81,
		67,
		58,
		73,
		92,
		92,
		84,
		109,
		112,
		-1,
		-1,
		-1,
		188,
		183,
		158,
		135,
		119,
		155,
		-1,
		132,
		133,
		-1,
		110,
		104,
		101,
		86,
		82,
		77,
		81,
		74,
		81,
		77,
		76,
		77,
		59,
		95,
		-1,
		92,
		86,
		114,
		117,
		107,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		114,
		166,
		-1,
		-1,
		117,
		110,
		-1,
		97,
		79,
		86,
		84,
		78,
		82,
		86,
		75,
		88,
		84,
		64,
		74,
		94,
		98,
		105,
		98,
		103,
		102,
		116,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		134,
		-1,
		126,
		118,
		108,
		102,
		96,
		92,
		90,
		106,
		90,
		93,
		93,
		89,
		97,
		82,
		81,
		67,
		71,
		89,
		116,
		111,
		106,
		105,
		112,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		147,
		-1,
		111,
		125,
		141,
		-1,
		134,
		113,
		128,
		106,
		102,
		98,
		113,
		114,
		92,
		97,
		96,
		106,
		103,
		92,
		79,
		83,
		98,
		108,
		100,
		101,
		110,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		108,
		96,
		128,
		-1,
		-1,
		170,
		-1,
		104,
		121,
		112,
		110,
		103,
		94,
		100,
		107,
		110,
		107,
		97,
		86,
		92,
		88,
		110,
		96,
		94,
		113,
		128,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		148,
		138,
		122,
		107,
		140,
		-1,
		111,
		95,
		100,
		-1,
		132,
		-1,
		105,
		105,
		96,
		85,
		82,
		93,
		91,
		102,
		119,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		165,
		-1,
		-1,
		135,
		129,
		129,
		113,
		116,
		127,
		107,
		101,
		100,
		127,
		122,
		113,
		94,
		87,
		84,
		85,
		98,
		118,
		109,
		121,
		-1,
		-1,
		-1,
		162,
		148,
		152,
		112,
		131,
		-1,
		-1,
		197,
		152,
		138,
		-1,
		122,
		144,
		132,
		122,
		112,
		146,
		138,
		113,
		106,
		92,
		94,
		92,
		94,
		99,
		120,
		121,
		134,
		-1,
		-1,
		145,
		150,
		138,
		124,
		143,
		-1,
		-1,
		-1,
		144,
		160,
		152,
		123,
		133,
		-1,
		-1,
		124,
		122,
		130,
		109,
		96,
		116,
		119,
		109,
		93,
		108,
		120,
		128,
		133,
		-1,
		148,
		135,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		155,
		150,
		154,
		127,
		-1,
		126,
		120,
		100,
		114,
		121,
		111,
		106,
		100,
		103,
		121,
		138,
		-1,
		-1,
		160,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		134,
		148,
		143,
		136,
		140,
		-1,
		128,
		116,
		102,
		119,
		124,
		121,
		112,
		104,
		109,
		106,
		119,
		133,
		137,
		183,
		-1,
		166,
		-1,
		-1,
		-1,
		152,
		167,
		182,
		159,
		132,
		127,
		120,
		114,
		110,
		126,
		132,
		143,
		111,
		107,
		108,
		112,
		111,
		128,
		138,
		-1,
		-1,
		166,
		183,
		178,
		160,
		164,
		209,
		-1,
		-1,
		136,
		127,
		118,
		121,
		120,
		123,
		117,
		114,
		119,
		124,
		112,
		121,
		139,
		138,
		-1,
		-1,
		-1,
		186,
		-1,
		201,
		-1,
		-1,
		179,
		207,
		154,
		136,
		132,
		130,
		123,
		132,
		127,
		122,
		132,
		134,
		126,
		114,
		118,
		141,
		130,
		169,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		215,
		190,
		205,
		218,
		199,
		206,
		169,
		166,
		-1,
		136,
		161,
		133,
		140,
		131,
		138,
		138,
		130,
		108,
		115,
		131,
		130,
		125,
		161,
		152,
		158,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		218,
		207,
		204,
		194,
		197,
		-1,
		-1,
		185,
		182,
		158,
		141,
		139,
		132,
		127,
		137,
		117,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		208,
		200,
		211,
		186,
		188,
		-1,
		-1,
		158,
		155,
		160,
		148,
		145,
		147,
		142,
		133,
		118,
		124,
		111,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		205,
		-1,
		-1,
		217,
		189,
		173,
		163,
		157,
		207,
		162,
		157,
		141,
		139,
		130,
		121,
		128,
		119,
		119,
		122,
		137,
		142,
		134,
		148,
		148,
		149,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		233,
		-1,
		200,
		-1,
		175,
		179,
		170,
		173,
		155,
		142,
		134,
		126,
		142,
		117,
		127,
		123,
		124,
		133,
		144,
		156,
		155,
		156,
		276,
		232,
		235,
		229,
		257,
		272,
		276,
		-1,
		217,
		256,
		254,
		-1,
		238,
		-1,
		-1,
		-1,
		189,
		183,
		175,
		175,
		154,
		154,
		128,
		132,
		122,
		129,
		139,
		141,
		133,
		137,
		150,
		161,
		164,
		272,
		263,
		276,
		221,
		221,
		242,
		251,
		272,
		232,
		223,
		250,
		261,
		250,
		245,
		232,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		161,
		149,
		132,
		133,
		129,
		132,
		147,
		150,
		140,
		138,
		132,
		164,
		-1,
		265,
		264,
		253,
		250,
		226,
		217,
		212,
		239,
		-1,
		-1,
		234,
		251,
		245,
		249,
		265,
		290,
		-1,
		221,
		-1,
		-1,
		206,
		-1,
		-1,
		191,
		154,
		143,
		134,
		140,
		137,
		148,
		158,
		146,
		147,
		137,
		147,
		160,
		249,
		246,
		234,
		232,
		255,
		220,
		208,
		-1,
		221,
		219,
		225,
		232,
		249,
		279,
		-1,
		-1,
		237,
		217,
		-1,
		-1,
		189,
		187,
		176,
		-1,
		166,
		139,
		144,
		164,
		166,
		155,
		149,
		143,
		150,
		149,
		157,
		165,
		258,
		272,
		261,
		257,
		256,
		264,
		213,
		206,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		227,
		223,
		-1,
		-1,
		184,
		177,
		165,
		153,
		143,
		153,
		157,
		161,
		153,
		146,
		141,
		152,
		144,
		148,
		165,
		-1,
		292,
		-1,
		244,
		220,
		234,
		249,
		257,
		-1,
		-1,
		-1,
		244,
		230,
		223,
		211,
		209,
		-1,
		218,
		202,
		183,
		-1,
		153,
		166,
		197,
		165,
		170,
		165,
		147,
		158,
		147,
		150,
		164,
		159,
		-1,
		-1,
		232,
		235,
		-1,
		-1,
		234,
		236,
		-1,
		235,
		224,
		209,
		201,
		-1,
		-1,
		190,
		186,
		-1,
		-1,
		154,
		179,
		168,
		176,
		171,
		151,
		157,
		160,
		149,
		153,
		165,
		-1,
		-1,
		239,
		240,
		241,
		-1,
		219,
		-1,
		237,
		-1,
		204,
		210,
		198,
		-1,
		-1,
		-1,
		192,
		155,
		176,
		186,
		180,
		178,
		169,
		155,
		162,
		160,
		156,
		167,
		-1,
		-1,
		-1,
		237,
		211,
		244,
		235,
		218,
		198,
		190,
		209,
		-1,
		179,
		-1,
		154,
		156,
		182,
		185,
		191,
		185,
		158,
		173,
		163,
		154,
		163,
		243,
		-1,
		213,
		246,
		210,
		204,
		180,
		184,
		200,
		-1,
		176,
		158,
		-1,
		186,
		176,
		207,
		192,
		173,
		160,
		167,
		167,
		160,
		-1,
		-1,
		-1,
		215,
		214,
		206,
		200,
		200,
		185,
		176,
		-1,
		188,
		170,
		149,
		166,
		166,
		157,
		165,
		197,
		193,
		180,
		180,
		172,
		-1,
		316,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		209,
		204,
		177,
		165,
		171,
		167,
		153,
		159,
		161,
		169,
		167,
		164,
		176,
		172,
		192,
		173,
		208,
		-1,
		311,
		-1,
		245,
		-1,
		-1,
		227,
		207,
		199,
		188,
		177,
		175,
		166,
		157,
		179,
		195,
		179,
		177,
		180,
		181,
		-1,
		300,
		299,
		-1,
		246,
		238,
		224,
		-1,
		217,
		-1,
		223,
		184,
		-1,
		186,
		166,
		-1,
		188,
		184,
		-1,
		-1,
		287,
		262,
		-1,
		-1,
		-1,
		247,
		227,
		218,
		202,
		-1,
		177,
		177,
		-1,
		-1,
		-1,
		272,
		271,
		-1,
		240,
		243,
		-1,
		233,
		224,
		232,
		179,
		183,
		-1,
		-1,
		-1,
		281,
		262,
		256,
		255,
		253,
		248,
		245,
		231,
		215,
		193,
		182,
		203,
		-1,
		-1,
		-1,
		253,
		245,
		238,
		-1,
		-1,
		240,
		223,
		204,
		202,
		-1,
		-1,
		-1,
		275,
		256,
		-1,
		-1,
		230,
		-1,
		-1,
		236,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		264,
		-1,
		-1,
		-1,
		226,
		222,
		223,
		-1,
		-1,
		-1,
		-1,
		286,
		287,
		310,
		274,
		-1,
		-1,
		-1,
		218,
		212,
		-1,
		-1,
		289,
		287,
		-1,
		-1,
		-1,
		246,
		230,
		-1,
		216,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		251,
		-1,
		251,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		264,
		256,
		264,
		-1,
		236,
		238,
		-1,
		286,
		-1,
		-1,
		279,
		270,
		-1,
		-1,
		241,
		248,
		270,
		273,
		309,
		-1,
		260
	],
	[
		-1,
		140,
		129,
		140,
		148,
		121,
		128,
		-1,
		147,
		151,
		117,
		111,
		150,
		119,
		125,
		136,
		-1,
		-1,
		-1,
		140,
		139,
		107,
		105,
		114,
		119,
		126,
		-1,
		125,
		-1,
		161,
		140,
		151,
		156,
		100,
		97,
		117,
		136,
		118,
		110,
		176,
		130,
		101,
		95,
		113,
		103,
		112,
		104,
		-1,
		101,
		91,
		113,
		92,
		103,
		95,
		-1,
		-1,
		95,
		96,
		102,
		88,
		94,
		90,
		-1,
		88,
		61,
		-1,
		-1,
		85,
		86,
		70,
		73,
		81,
		79,
		84,
		70,
		56,
		-1,
		-1,
		76,
		72,
		79,
		66,
		62,
		79,
		87,
		56,
		43,
		41,
		-1,
		88,
		105,
		105,
		73,
		71,
		55,
		53,
		71,
		58,
		41,
		33,
		-1,
		105,
		101,
		102,
		100,
		95,
		71,
		58,
		58,
		68,
		52,
		35,
		22,
		68,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		97,
		114,
		98,
		88,
		92,
		90,
		61,
		58,
		56,
		45,
		38,
		21,
		31,
		-1,
		-1,
		199,
		172,
		196,
		154,
		136,
		-1,
		102,
		102,
		96,
		92,
		86,
		79,
		92,
		77,
		-1,
		29,
		38,
		28,
		14,
		25,
		181,
		-1,
		-1,
		157,
		149,
		131,
		134,
		111,
		107,
		117,
		116,
		109,
		102,
		98,
		76,
		79,
		79,
		85,
		41,
		24,
		21,
		5,
		32,
		-1,
		-1,
		116,
		-1,
		-1,
		178,
		161,
		-1,
		126,
		133,
		117,
		123,
		109,
		130,
		127,
		118,
		112,
		107,
		99,
		74,
		71,
		84,
		63,
		38,
		31,
		34,
		0,
		31,
		32,
		-1,
		115,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		133,
		130,
		123,
		147,
		146,
		-1,
		147,
		135,
		136,
		121,
		120,
		108,
		96,
		79,
		63,
		63,
		60,
		45,
		47,
		36,
		4,
		29,
		33,
		64,
		91,
		85,
		94,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		151,
		-1,
		154,
		167,
		159,
		132,
		135,
		122,
		116,
		103,
		92,
		80,
		61,
		58,
		57,
		41,
		56,
		9,
		12,
		28,
		42,
		78,
		82,
		88,
		-1,
		236,
		-1,
		178,
		162,
		164,
		140,
		166,
		-1,
		171,
		155,
		175,
		161,
		161,
		-1,
		134,
		131,
		121,
		99,
		84,
		73,
		61,
		56,
		54,
		36,
		41,
		16,
		34,
		36,
		50,
		64,
		86,
		96,
		196,
		186,
		-1,
		168,
		173,
		141,
		149,
		168,
		198,
		170,
		-1,
		165,
		-1,
		136,
		149,
		-1,
		105,
		101,
		81,
		69,
		58,
		65,
		47,
		32,
		29,
		22,
		25,
		54,
		55,
		80,
		-1,
		-1,
		181,
		185,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		117,
		114,
		104,
		91,
		76,
		77,
		64,
		67,
		46,
		31,
		34,
		31,
		73,
		59,
		71,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		71,
		79,
		52,
		55,
		35,
		37,
		37,
		62,
		53,
		73,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		126,
		111,
		92,
		81,
		73,
		62,
		53,
		63,
		57,
		37,
		46,
		44,
		68,
		75,
		81,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		71,
		58,
		68,
		65,
		51,
		42,
		57,
		73,
		73,
		65,
		90,
		93,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		75,
		79,
		73,
		72,
		68,
		60,
		61,
		43,
		78,
		-1,
		73,
		67,
		95,
		98,
		88,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		87,
		82,
		80,
		80,
		79,
		68,
		76,
		68,
		48,
		58,
		78,
		82,
		86,
		79,
		84,
		83,
		97,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		108,
		92,
		92,
		91,
		82,
		90,
		72,
		65,
		51,
		55,
		73,
		97,
		92,
		90,
		89,
		93,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		99,
		115,
		116,
		94,
		91,
		89,
		99,
		87,
		76,
		63,
		67,
		82,
		92,
		84,
		85,
		94,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		113,
		111,
		105,
		96,
		102,
		100,
		96,
		91,
		81,
		70,
		76,
		72,
		94,
		80,
		78,
		94,
		109,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		113,
		97,
		102,
		-1,
		116,
		-1,
		89,
		89,
		80,
		69,
		66,
		77,
		75,
		86,
		100,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		129,
		109,
		103,
		102,
		111,
		106,
		97,
		78,
		71,
		68,
		69,
		82,
		102,
		93,
		102,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		146,
		134,
		124,
		114,
		132,
		122,
		97,
		90,
		76,
		78,
		76,
		78,
		83,
		104,
		105,
		117,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		135,
		-1,
		-1,
		126,
		124,
		114,
		93,
		80,
		100,
		103,
		93,
		77,
		92,
		104,
		109,
		117,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		139,
		134,
		138,
		129,
		-1,
		110,
		104,
		84,
		98,
		105,
		95,
		90,
		84,
		87,
		105,
		120,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		136,
		150,
		127,
		120,
		124,
		-1,
		112,
		100,
		86,
		103,
		108,
		105,
		96,
		88,
		93,
		90,
		103,
		117,
		121,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		154,
		169,
		166,
		143,
		116,
		111,
		104,
		98,
		94,
		110,
		116,
		127,
		95,
		91,
		92,
		96,
		95,
		112,
		122,
		-1,
		-1,
		168,
		185,
		180,
		162,
		166,
		193,
		-1,
		-1,
		120,
		111,
		102,
		105,
		104,
		107,
		101,
		98,
		103,
		108,
		96,
		105,
		123,
		122,
		-1,
		-1,
		-1,
		188,
		-1,
		203,
		-1,
		-1,
		181,
		191,
		138,
		120,
		116,
		114,
		107,
		116,
		111,
		106,
		116,
		118,
		110,
		98,
		102,
		125,
		114,
		153,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		209,
		192,
		196,
		202,
		201,
		195,
		153,
		150,
		-1,
		120,
		145,
		117,
		124,
		115,
		122,
		122,
		114,
		92,
		99,
		115,
		114,
		109,
		145,
		136,
		142,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		202,
		198,
		188,
		178,
		181,
		-1,
		-1,
		169,
		166,
		142,
		125,
		123,
		116,
		111,
		121,
		101,
		88,
		92,
		96,
		102,
		107,
		112,
		118,
		133,
		148,
		-1,
		195,
		276,
		269,
		251,
		259,
		290,
		-1,
		192,
		184,
		195,
		170,
		172,
		-1,
		-1,
		142,
		139,
		144,
		132,
		129,
		131,
		126,
		117,
		102,
		108,
		95,
		94,
		112,
		116,
		125,
		132,
		122,
		135,
		139,
		-1,
		209,
		252,
		245,
		248,
		272,
		286,
		-1,
		189,
		-1,
		-1,
		201,
		173,
		157,
		147,
		141,
		191,
		146,
		141,
		125,
		123,
		114,
		105,
		112,
		103,
		103,
		106,
		121,
		126,
		118,
		132,
		132,
		133,
		-1,
		235,
		232,
		239,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		217,
		-1,
		184,
		-1,
		159,
		163,
		154,
		157,
		139,
		126,
		118,
		110,
		126,
		101,
		111,
		107,
		108,
		117,
		128,
		140,
		139,
		140,
		260,
		216,
		219,
		230,
		241,
		256,
		260,
		-1,
		201,
		240,
		238,
		-1,
		222,
		-1,
		-1,
		-1,
		173,
		167,
		159,
		159,
		138,
		138,
		112,
		116,
		106,
		113,
		123,
		125,
		117,
		121,
		134,
		145,
		148,
		256,
		247,
		260,
		205,
		205,
		226,
		235,
		256,
		216,
		207,
		234,
		245,
		234,
		229,
		216,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		145,
		133,
		116,
		117,
		113,
		116,
		131,
		134,
		124,
		122,
		116,
		148,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		196,
		223,
		-1,
		-1,
		218,
		235,
		229,
		233,
		249,
		274,
		-1,
		205,
		-1,
		-1,
		190,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		121,
		132,
		142,
		130,
		131,
		121,
		131,
		144,
		233,
		230,
		218,
		216,
		239,
		204,
		192,
		-1,
		205,
		203,
		209,
		216,
		233,
		263,
		-1,
		-1,
		221,
		201,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		123,
		128,
		148,
		150,
		139,
		133,
		127,
		134,
		133,
		141,
		149,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		190,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		211,
		207,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		141,
		145,
		137,
		130,
		125,
		136,
		128,
		132,
		149,
		-1,
		276,
		-1,
		228,
		204,
		218,
		233,
		241,
		-1,
		-1,
		-1,
		228,
		214,
		207,
		195,
		193,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		131,
		142,
		131,
		134,
		148,
		143,
		-1,
		-1,
		216,
		219,
		-1,
		-1,
		218,
		220,
		-1,
		219,
		208,
		193,
		185,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		135,
		141,
		144,
		133,
		137,
		149,
		-1,
		-1,
		223,
		224,
		225,
		-1,
		203,
		-1,
		221,
		-1,
		188,
		194,
		182,
		-1,
		-1,
		-1,
		176,
		139,
		160,
		170,
		164,
		162,
		153,
		139,
		146,
		144,
		140,
		151,
		-1,
		-1,
		-1,
		221,
		195,
		228,
		219,
		202,
		182,
		174,
		193,
		-1,
		163,
		-1,
		138,
		140,
		166,
		169,
		175,
		169,
		142,
		157,
		147,
		138,
		147,
		227,
		-1,
		197,
		230,
		194,
		188,
		164,
		168,
		184,
		-1,
		160,
		142,
		-1,
		170,
		160,
		191,
		176,
		157,
		144,
		151,
		151,
		144,
		-1,
		-1,
		-1,
		199,
		198,
		190,
		184,
		184,
		169,
		160,
		-1,
		172,
		154,
		133,
		150,
		150,
		141,
		149,
		181,
		177,
		164,
		164,
		156,
		-1,
		300,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		193,
		188,
		161,
		149,
		155,
		151,
		137,
		143,
		145,
		153,
		151,
		148,
		160,
		156,
		176,
		157,
		192,
		-1,
		295,
		-1,
		229,
		-1,
		-1,
		211,
		191,
		183,
		172,
		161,
		159,
		150,
		141,
		163,
		179,
		163,
		161,
		164,
		165,
		-1,
		284,
		283,
		-1,
		230,
		222,
		208,
		-1,
		201,
		-1,
		207,
		168,
		-1,
		170,
		150,
		-1,
		172,
		168,
		-1,
		-1,
		271,
		246,
		-1,
		-1,
		-1,
		231,
		211,
		202,
		186,
		-1,
		161,
		161,
		-1,
		-1,
		-1,
		256,
		255,
		-1,
		224,
		227,
		-1,
		217,
		208,
		216,
		163,
		167,
		-1,
		-1,
		-1,
		265,
		246,
		240,
		239,
		237,
		232,
		229,
		215,
		199,
		177,
		166,
		187,
		-1,
		-1,
		-1,
		237,
		229,
		222,
		-1,
		-1,
		224,
		207,
		188,
		186,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		214,
		-1,
		-1,
		220,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		248,
		-1,
		-1,
		-1,
		210,
		206,
		207,
		-1,
		-1,
		-1,
		-1,
		270,
		271,
		294,
		258,
		-1,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		273,
		271,
		-1,
		-1,
		-1,
		230,
		214,
		-1,
		200,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		235,
		-1,
		235,
		210,
		217,
		-1,
		-1,
		-1,
		-1,
		248,
		240,
		248,
		-1,
		220,
		222,
		-1,
		270,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		225,
		232,
		254,
		257,
		293,
		-1,
		244
	],
	[
		-1,
		159,
		148,
		159,
		167,
		140,
		147,
		-1,
		166,
		170,
		136,
		130,
		169,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		159,
		158,
		126,
		124,
		133,
		138,
		145,
		-1,
		144,
		-1,
		180,
		159,
		170,
		175,
		119,
		116,
		136,
		155,
		137,
		129,
		195,
		149,
		120,
		114,
		132,
		122,
		131,
		123,
		-1,
		120,
		110,
		132,
		111,
		122,
		114,
		-1,
		-1,
		114,
		115,
		121,
		107,
		113,
		109,
		-1,
		107,
		80,
		-1,
		-1,
		104,
		105,
		89,
		92,
		100,
		98,
		103,
		89,
		75,
		-1,
		-1,
		95,
		91,
		98,
		85,
		81,
		98,
		106,
		75,
		62,
		60,
		-1,
		107,
		124,
		124,
		92,
		90,
		74,
		72,
		90,
		77,
		60,
		52,
		-1,
		124,
		120,
		121,
		119,
		114,
		90,
		77,
		77,
		87,
		71,
		54,
		41,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		116,
		133,
		117,
		107,
		111,
		109,
		80,
		77,
		75,
		64,
		57,
		40,
		44,
		-1,
		-1,
		218,
		191,
		215,
		173,
		155,
		-1,
		121,
		121,
		115,
		111,
		105,
		98,
		111,
		96,
		-1,
		48,
		57,
		47,
		33,
		38,
		200,
		-1,
		-1,
		176,
		168,
		150,
		153,
		130,
		126,
		136,
		135,
		128,
		121,
		117,
		95,
		98,
		98,
		104,
		60,
		43,
		40,
		37,
		10,
		-1,
		-1,
		98,
		-1,
		-1,
		197,
		180,
		-1,
		145,
		152,
		136,
		142,
		128,
		149,
		146,
		137,
		131,
		126,
		118,
		93,
		90,
		103,
		82,
		57,
		48,
		51,
		32,
		0,
		1,
		-1,
		97,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		152,
		149,
		142,
		166,
		165,
		-1,
		166,
		154,
		155,
		140,
		139,
		126,
		114,
		98,
		82,
		82,
		79,
		64,
		65,
		57,
		29,
		5,
		2,
		33,
		73,
		67,
		76,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		170,
		-1,
		173,
		186,
		178,
		151,
		154,
		141,
		134,
		121,
		110,
		99,
		80,
		77,
		76,
		59,
		74,
		34,
		37,
		17,
		11,
		60,
		64,
		70,
		-1,
		255,
		-1,
		197,
		181,
		183,
		159,
		184,
		-1,
		190,
		174,
		194,
		180,
		180,
		-1,
		152,
		149,
		139,
		117,
		102,
		92,
		80,
		75,
		72,
		54,
		59,
		34,
		28,
		25,
		23,
		46,
		68,
		78,
		215,
		205,
		-1,
		187,
		192,
		159,
		167,
		186,
		217,
		188,
		-1,
		183,
		-1,
		154,
		167,
		-1,
		123,
		119,
		100,
		88,
		77,
		84,
		65,
		50,
		47,
		26,
		29,
		36,
		34,
		62,
		-1,
		-1,
		200,
		204,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		136,
		133,
		122,
		109,
		94,
		95,
		83,
		85,
		64,
		49,
		52,
		35,
		55,
		39,
		64,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		90,
		97,
		70,
		73,
		53,
		55,
		41,
		53,
		46,
		66,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		145,
		129,
		110,
		99,
		91,
		80,
		71,
		81,
		75,
		55,
		64,
		48,
		61,
		68,
		74,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		89,
		76,
		86,
		83,
		69,
		60,
		75,
		66,
		66,
		58,
		83,
		86,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		93,
		97,
		91,
		90,
		86,
		78,
		79,
		61,
		82,
		-1,
		66,
		60,
		88,
		91,
		81,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		105,
		100,
		98,
		98,
		97,
		86,
		94,
		86,
		66,
		76,
		96,
		81,
		79,
		72,
		77,
		76,
		90,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		110,
		109,
		100,
		108,
		90,
		83,
		69,
		73,
		91,
		90,
		85,
		91,
		83,
		86,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		117,
		133,
		134,
		112,
		109,
		107,
		117,
		105,
		94,
		81,
		85,
		100,
		100,
		86,
		86,
		88,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		131,
		129,
		123,
		114,
		120,
		118,
		114,
		109,
		99,
		88,
		94,
		90,
		108,
		94,
		92,
		87,
		102,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		131,
		115,
		120,
		-1,
		134,
		-1,
		107,
		107,
		98,
		87,
		84,
		95,
		93,
		104,
		93,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		147,
		127,
		121,
		120,
		129,
		124,
		115,
		96,
		89,
		86,
		87,
		100,
		120,
		107,
		95,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		164,
		152,
		142,
		132,
		150,
		140,
		115,
		108,
		94,
		96,
		94,
		96,
		101,
		108,
		100,
		110,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		153,
		-1,
		-1,
		144,
		142,
		132,
		111,
		98,
		118,
		121,
		111,
		95,
		110,
		114,
		102,
		111,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		157,
		152,
		156,
		147,
		-1,
		128,
		122,
		102,
		116,
		123,
		113,
		108,
		102,
		105,
		119,
		113,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		154,
		168,
		145,
		138,
		142,
		-1,
		130,
		118,
		104,
		121,
		126,
		123,
		114,
		106,
		111,
		108,
		121,
		125,
		115,
		203,
		-1,
		186,
		-1,
		-1,
		-1,
		172,
		187,
		184,
		161,
		134,
		129,
		122,
		116,
		112,
		128,
		134,
		145,
		113,
		109,
		110,
		114,
		113,
		129,
		130,
		-1,
		-1,
		186,
		203,
		198,
		180,
		184,
		211,
		-1,
		-1,
		138,
		129,
		120,
		123,
		122,
		125,
		119,
		116,
		121,
		126,
		114,
		123,
		141,
		133,
		-1,
		-1,
		-1,
		206,
		-1,
		221,
		-1,
		-1,
		199,
		209,
		156,
		138,
		134,
		132,
		125,
		134,
		129,
		124,
		134,
		136,
		128,
		116,
		120,
		143,
		132,
		162,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		227,
		210,
		214,
		220,
		219,
		213,
		171,
		168,
		-1,
		138,
		163,
		135,
		142,
		133,
		140,
		140,
		132,
		110,
		117,
		133,
		132,
		127,
		154,
		149,
		158,
		-1,
		-1,
		317,
		306,
		295,
		301,
		-1,
		220,
		216,
		206,
		196,
		199,
		-1,
		-1,
		187,
		184,
		160,
		143,
		141,
		134,
		129,
		139,
		119,
		106,
		110,
		114,
		120,
		125,
		130,
		136,
		151,
		164,
		-1,
		213,
		294,
		287,
		269,
		277,
		308,
		-1,
		210,
		202,
		213,
		188,
		190,
		-1,
		-1,
		160,
		157,
		162,
		150,
		147,
		149,
		144,
		135,
		120,
		126,
		113,
		112,
		130,
		134,
		143,
		150,
		140,
		153,
		157,
		-1,
		227,
		270,
		263,
		266,
		290,
		304,
		-1,
		207,
		-1,
		-1,
		219,
		191,
		175,
		165,
		159,
		209,
		164,
		159,
		143,
		141,
		132,
		123,
		130,
		121,
		121,
		124,
		139,
		144,
		136,
		150,
		150,
		151,
		-1,
		253,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		235,
		-1,
		202,
		-1,
		177,
		181,
		172,
		175,
		157,
		144,
		136,
		128,
		144,
		119,
		129,
		125,
		126,
		135,
		146,
		158,
		157,
		158,
		278,
		234,
		237,
		248,
		259,
		274,
		278,
		-1,
		219,
		258,
		256,
		-1,
		240,
		-1,
		-1,
		-1,
		191,
		185,
		177,
		177,
		156,
		156,
		130,
		134,
		124,
		131,
		141,
		143,
		135,
		139,
		152,
		163,
		166,
		274,
		265,
		278,
		223,
		223,
		244,
		253,
		274,
		234,
		225,
		252,
		263,
		252,
		247,
		234,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		163,
		151,
		134,
		135,
		131,
		134,
		149,
		152,
		142,
		140,
		134,
		166,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		214,
		241,
		-1,
		-1,
		236,
		253,
		247,
		251,
		267,
		292,
		-1,
		223,
		-1,
		-1,
		208,
		-1,
		-1,
		193,
		156,
		145,
		136,
		142,
		139,
		150,
		160,
		148,
		149,
		139,
		149,
		162,
		251,
		248,
		236,
		234,
		257,
		222,
		210,
		-1,
		223,
		221,
		227,
		234,
		251,
		281,
		-1,
		-1,
		239,
		219,
		-1,
		-1,
		191,
		189,
		178,
		-1,
		168,
		141,
		146,
		166,
		168,
		157,
		151,
		145,
		152,
		151,
		159,
		167,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		208,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		-1,
		229,
		225,
		-1,
		-1,
		186,
		179,
		167,
		155,
		145,
		155,
		159,
		163,
		155,
		148,
		143,
		154,
		146,
		150,
		167,
		-1,
		294,
		-1,
		246,
		222,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		246,
		232,
		225,
		213,
		211,
		-1,
		220,
		204,
		185,
		-1,
		155,
		168,
		199,
		167,
		172,
		167,
		149,
		160,
		149,
		152,
		166,
		161,
		-1,
		-1,
		234,
		237,
		-1,
		-1,
		236,
		238,
		-1,
		237,
		226,
		211,
		203,
		-1,
		-1,
		192,
		188,
		-1,
		-1,
		156,
		181,
		170,
		178,
		173,
		153,
		159,
		162,
		151,
		155,
		167,
		-1,
		-1,
		241,
		242,
		243,
		-1,
		221,
		-1,
		239,
		-1,
		206,
		212,
		200,
		-1,
		-1,
		-1,
		194,
		157,
		178,
		188,
		182,
		180,
		171,
		157,
		164,
		162,
		158,
		169,
		-1,
		-1,
		-1,
		239,
		213,
		246,
		237,
		220,
		200,
		192,
		211,
		-1,
		181,
		-1,
		156,
		158,
		184,
		187,
		193,
		187,
		160,
		175,
		165,
		156,
		165,
		245,
		-1,
		215,
		248,
		212,
		206,
		182,
		186,
		202,
		-1,
		178,
		160,
		-1,
		188,
		178,
		209,
		194,
		175,
		162,
		169,
		169,
		162,
		-1,
		-1,
		-1,
		217,
		216,
		208,
		202,
		202,
		187,
		178,
		-1,
		190,
		172,
		151,
		168,
		168,
		159,
		167,
		199,
		195,
		182,
		182,
		174,
		-1,
		318,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		211,
		206,
		179,
		167,
		173,
		169,
		155,
		161,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		175,
		210,
		-1,
		313,
		-1,
		247,
		-1,
		-1,
		229,
		209,
		201,
		190,
		179,
		177,
		168,
		159,
		181,
		197,
		181,
		179,
		182,
		183,
		-1,
		302,
		301,
		-1,
		248,
		240,
		226,
		-1,
		219,
		-1,
		225,
		186,
		-1,
		188,
		168,
		-1,
		190,
		186,
		-1,
		-1,
		289,
		264,
		-1,
		-1,
		-1,
		249,
		229,
		220,
		204,
		-1,
		179,
		179,
		-1,
		-1,
		-1,
		274,
		273,
		-1,
		242,
		245,
		-1,
		235,
		226,
		234,
		181,
		185,
		-1,
		-1,
		-1,
		283,
		264,
		258,
		257,
		255,
		250,
		247,
		233,
		217,
		195,
		184,
		205,
		-1,
		-1,
		-1,
		255,
		247,
		240,
		-1,
		-1,
		242,
		225,
		206,
		204,
		-1,
		-1,
		-1,
		277,
		258,
		-1,
		-1,
		232,
		-1,
		-1,
		238,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		266,
		-1,
		-1,
		-1,
		228,
		224,
		225,
		-1,
		-1,
		-1,
		-1,
		288,
		289,
		312,
		276,
		-1,
		-1,
		-1,
		220,
		214,
		-1,
		-1,
		291,
		289,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		218,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		253,
		-1,
		253,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		266,
		258,
		266,
		-1,
		238,
		240,
		-1,
		288,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		243,
		250,
		272,
		275,
		311,
		-1,
		262
	],
	[
		-1,
		164,
		153,
		164,
		172,
		145,
		152,
		-1,
		171,
		175,
		141,
		135,
		174,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		164,
		163,
		131,
		129,
		138,
		143,
		150,
		-1,
		149,
		-1,
		185,
		164,
		175,
		180,
		124,
		121,
		141,
		160,
		142,
		134,
		200,
		154,
		125,
		119,
		137,
		127,
		136,
		128,
		-1,
		125,
		115,
		137,
		116,
		127,
		119,
		-1,
		-1,
		119,
		120,
		126,
		112,
		118,
		114,
		-1,
		112,
		85,
		-1,
		-1,
		109,
		110,
		94,
		97,
		105,
		103,
		108,
		94,
		80,
		-1,
		-1,
		100,
		96,
		103,
		90,
		86,
		103,
		111,
		80,
		67,
		65,
		-1,
		112,
		129,
		129,
		97,
		95,
		79,
		77,
		95,
		82,
		65,
		57,
		-1,
		129,
		125,
		126,
		124,
		119,
		95,
		82,
		82,
		92,
		76,
		59,
		46,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		121,
		138,
		122,
		112,
		116,
		114,
		85,
		82,
		80,
		69,
		62,
		45,
		49,
		-1,
		-1,
		223,
		196,
		220,
		178,
		160,
		-1,
		126,
		126,
		120,
		116,
		110,
		103,
		116,
		101,
		-1,
		53,
		62,
		52,
		38,
		43,
		205,
		-1,
		-1,
		181,
		173,
		155,
		158,
		135,
		131,
		141,
		140,
		133,
		126,
		122,
		100,
		103,
		103,
		109,
		65,
		48,
		45,
		42,
		15,
		-1,
		-1,
		103,
		-1,
		-1,
		202,
		185,
		-1,
		150,
		157,
		141,
		147,
		133,
		154,
		151,
		142,
		136,
		131,
		123,
		98,
		95,
		108,
		87,
		62,
		53,
		56,
		37,
		5,
		0,
		-1,
		102,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		157,
		154,
		147,
		171,
		170,
		-1,
		171,
		159,
		160,
		145,
		144,
		131,
		119,
		103,
		87,
		87,
		84,
		69,
		70,
		62,
		34,
		10,
		7,
		38,
		78,
		72,
		81,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		175,
		-1,
		178,
		191,
		183,
		156,
		159,
		146,
		139,
		126,
		115,
		104,
		85,
		82,
		81,
		64,
		79,
		39,
		42,
		22,
		16,
		65,
		69,
		75,
		-1,
		260,
		-1,
		202,
		186,
		188,
		164,
		189,
		-1,
		195,
		179,
		199,
		185,
		185,
		-1,
		157,
		154,
		144,
		122,
		107,
		97,
		85,
		80,
		77,
		59,
		64,
		39,
		33,
		30,
		28,
		51,
		73,
		83,
		220,
		210,
		-1,
		192,
		197,
		164,
		172,
		191,
		222,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		105,
		93,
		82,
		89,
		70,
		55,
		52,
		31,
		34,
		41,
		39,
		67,
		-1,
		-1,
		205,
		209,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		141,
		138,
		127,
		114,
		99,
		100,
		88,
		90,
		69,
		54,
		57,
		40,
		60,
		44,
		69,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		102,
		75,
		78,
		58,
		60,
		46,
		58,
		51,
		71,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		150,
		134,
		115,
		104,
		96,
		85,
		76,
		86,
		80,
		60,
		69,
		53,
		66,
		73,
		79,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		94,
		81,
		91,
		88,
		74,
		65,
		80,
		71,
		71,
		63,
		88,
		91,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		98,
		102,
		96,
		95,
		91,
		83,
		84,
		66,
		87,
		-1,
		71,
		65,
		93,
		96,
		86,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		110,
		105,
		103,
		103,
		102,
		91,
		99,
		91,
		71,
		81,
		101,
		86,
		84,
		77,
		82,
		81,
		95,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		115,
		114,
		105,
		113,
		95,
		88,
		74,
		78,
		96,
		95,
		90,
		96,
		88,
		91,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		122,
		138,
		139,
		117,
		114,
		112,
		122,
		110,
		99,
		86,
		90,
		105,
		105,
		91,
		91,
		93,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		136,
		134,
		128,
		119,
		125,
		123,
		119,
		114,
		104,
		93,
		99,
		95,
		113,
		99,
		97,
		92,
		107,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		136,
		120,
		125,
		-1,
		139,
		-1,
		112,
		112,
		103,
		92,
		89,
		100,
		98,
		109,
		98,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		152,
		132,
		126,
		125,
		134,
		129,
		120,
		101,
		94,
		91,
		92,
		105,
		125,
		112,
		100,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		169,
		157,
		147,
		137,
		155,
		145,
		120,
		113,
		99,
		101,
		99,
		101,
		106,
		113,
		105,
		115,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		158,
		-1,
		-1,
		149,
		147,
		137,
		116,
		103,
		123,
		126,
		116,
		100,
		115,
		119,
		107,
		116,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		202,
		168,
		162,
		157,
		161,
		152,
		-1,
		133,
		127,
		107,
		121,
		128,
		118,
		113,
		107,
		110,
		124,
		118,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		159,
		173,
		150,
		143,
		147,
		-1,
		135,
		123,
		109,
		126,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		130,
		120,
		208,
		-1,
		191,
		-1,
		-1,
		-1,
		177,
		192,
		189,
		166,
		139,
		134,
		127,
		121,
		117,
		133,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		134,
		135,
		-1,
		-1,
		191,
		208,
		203,
		185,
		189,
		216,
		-1,
		-1,
		143,
		134,
		125,
		128,
		127,
		130,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		138,
		-1,
		-1,
		-1,
		211,
		-1,
		226,
		-1,
		-1,
		204,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		141,
		133,
		121,
		125,
		148,
		137,
		167,
		-1,
		-1,
		329,
		-1,
		-1,
		-1,
		232,
		215,
		219,
		225,
		224,
		218,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		138,
		145,
		145,
		137,
		115,
		122,
		138,
		137,
		132,
		159,
		154,
		163,
		-1,
		-1,
		322,
		311,
		300,
		306,
		-1,
		225,
		221,
		211,
		201,
		204,
		-1,
		-1,
		192,
		189,
		165,
		148,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		169,
		-1,
		218,
		299,
		292,
		274,
		282,
		313,
		-1,
		215,
		207,
		218,
		193,
		195,
		-1,
		-1,
		165,
		162,
		167,
		155,
		152,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		232,
		275,
		268,
		271,
		295,
		309,
		-1,
		212,
		-1,
		-1,
		224,
		196,
		180,
		170,
		164,
		214,
		169,
		164,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		258,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		240,
		-1,
		207,
		-1,
		182,
		186,
		177,
		180,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		283,
		239,
		242,
		253,
		264,
		279,
		283,
		-1,
		224,
		263,
		261,
		-1,
		245,
		-1,
		-1,
		-1,
		196,
		190,
		182,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		279,
		270,
		283,
		228,
		228,
		249,
		258,
		279,
		239,
		230,
		257,
		268,
		257,
		252,
		239,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		272,
		271,
		260,
		257,
		233,
		224,
		219,
		246,
		-1,
		-1,
		241,
		258,
		252,
		256,
		272,
		297,
		-1,
		228,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		256,
		253,
		241,
		239,
		262,
		227,
		215,
		-1,
		228,
		226,
		232,
		239,
		256,
		286,
		-1,
		-1,
		244,
		224,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		265,
		279,
		268,
		264,
		263,
		271,
		220,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		230,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		299,
		-1,
		251,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		246,
		247,
		248,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		221,
		210,
		221,
		229,
		202,
		209,
		-1,
		228,
		232,
		198,
		192,
		231,
		200,
		206,
		217,
		-1,
		-1,
		-1,
		221,
		220,
		188,
		186,
		195,
		200,
		207,
		-1,
		206,
		-1,
		242,
		221,
		232,
		237,
		181,
		178,
		198,
		217,
		199,
		191,
		257,
		211,
		182,
		176,
		194,
		184,
		193,
		185,
		-1,
		182,
		172,
		194,
		173,
		184,
		176,
		-1,
		-1,
		176,
		177,
		183,
		169,
		175,
		171,
		-1,
		181,
		165,
		-1,
		-1,
		166,
		167,
		151,
		154,
		162,
		160,
		173,
		165,
		160,
		-1,
		-1,
		157,
		153,
		160,
		147,
		143,
		160,
		173,
		155,
		147,
		145,
		-1,
		169,
		186,
		186,
		154,
		152,
		136,
		134,
		152,
		154,
		145,
		137,
		-1,
		186,
		182,
		183,
		181,
		176,
		152,
		139,
		139,
		149,
		142,
		139,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		178,
		195,
		179,
		169,
		173,
		171,
		142,
		139,
		137,
		134,
		142,
		125,
		135,
		-1,
		-1,
		280,
		253,
		277,
		235,
		217,
		-1,
		183,
		183,
		177,
		173,
		167,
		160,
		173,
		158,
		-1,
		128,
		127,
		132,
		118,
		129,
		262,
		-1,
		-1,
		238,
		230,
		212,
		215,
		192,
		188,
		198,
		197,
		190,
		178,
		174,
		157,
		160,
		160,
		166,
		122,
		128,
		125,
		111,
		109,
		-1,
		-1,
		9,
		-1,
		-1,
		259,
		242,
		-1,
		207,
		214,
		198,
		204,
		190,
		211,
		208,
		199,
		193,
		188,
		176,
		155,
		152,
		165,
		144,
		119,
		135,
		138,
		106,
		99,
		94,
		-1,
		0,
		27,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		214,
		211,
		204,
		228,
		227,
		-1,
		223,
		211,
		212,
		197,
		194,
		181,
		169,
		160,
		144,
		144,
		141,
		123,
		121,
		131,
		103,
		98,
		88,
		76,
		40,
		43,
		52,
		-1,
		267,
		263,
		259,
		266,
		215,
		-1,
		-1,
		232,
		-1,
		235,
		248,
		235,
		208,
		211,
		198,
		189,
		176,
		165,
		161,
		142,
		139,
		135,
		115,
		130,
		108,
		109,
		77,
		77,
		68,
		40,
		46,
		-1,
		317,
		-1,
		259,
		243,
		245,
		218,
		239,
		-1,
		252,
		236,
		252,
		237,
		237,
		-1,
		207,
		204,
		194,
		172,
		157,
		154,
		142,
		137,
		128,
		110,
		124,
		104,
		90,
		81,
		67,
		54,
		44,
		54,
		277,
		267,
		-1,
		249,
		254,
		214,
		222,
		241,
		279,
		243,
		-1,
		238,
		-1,
		209,
		222,
		-1,
		178,
		174,
		156,
		150,
		139,
		146,
		121,
		106,
		103,
		96,
		99,
		63,
		64,
		55,
		-1,
		-1,
		262,
		266,
		256,
		207,
		226,
		250,
		287,
		236,
		225,
		224,
		-1,
		215,
		192,
		189,
		177,
		164,
		149,
		150,
		145,
		141,
		120,
		105,
		107,
		97,
		82,
		69,
		94,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		233,
		204,
		228,
		270,
		254,
		247,
		235,
		200,
		200,
		194,
		-1,
		188,
		167,
		158,
		147,
		145,
		153,
		126,
		121,
		105,
		103,
		92,
		80,
		76,
		96,
		-1,
		-1,
		-1,
		263,
		252,
		253,
		199,
		222,
		259,
		233,
		219,
		224,
		199,
		192,
		186,
		201,
		184,
		165,
		154,
		146,
		135,
		127,
		133,
		125,
		101,
		106,
		86,
		91,
		98,
		104,
		-1,
		-1,
		270,
		260,
		244,
		246,
		243,
		213,
		220,
		252,
		224,
		237,
		-1,
		191,
		-1,
		180,
		175,
		159,
		154,
		151,
		145,
		132,
		132,
		130,
		111,
		106,
		118,
		96,
		96,
		88,
		113,
		116,
		-1,
		-1,
		-1,
		263,
		258,
		233,
		210,
		194,
		230,
		-1,
		207,
		208,
		-1,
		185,
		179,
		176,
		161,
		157,
		149,
		153,
		147,
		142,
		132,
		124,
		125,
		107,
		120,
		-1,
		96,
		90,
		118,
		121,
		111,
		-1,
		-1,
		-1,
		256,
		235,
		228,
		248,
		189,
		241,
		-1,
		-1,
		192,
		185,
		-1,
		172,
		154,
		161,
		156,
		153,
		154,
		145,
		134,
		140,
		132,
		112,
		122,
		134,
		111,
		109,
		102,
		107,
		106,
		120,
		-1,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		209,
		-1,
		201,
		193,
		183,
		177,
		171,
		167,
		165,
		181,
		165,
		166,
		157,
		148,
		156,
		136,
		129,
		115,
		119,
		129,
		120,
		115,
		121,
		113,
		116,
		-1,
		276,
		262,
		233,
		-1,
		-1,
		222,
		-1,
		186,
		200,
		216,
		-1,
		209,
		188,
		203,
		181,
		177,
		173,
		188,
		189,
		167,
		157,
		155,
		163,
		151,
		140,
		127,
		131,
		133,
		130,
		116,
		116,
		118,
		-1,
		282,
		269,
		227,
		223,
		212,
		232,
		183,
		171,
		203,
		-1,
		-1,
		245,
		-1,
		179,
		196,
		187,
		185,
		178,
		169,
		175,
		166,
		160,
		155,
		145,
		134,
		140,
		136,
		138,
		124,
		122,
		117,
		132,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		198,
		185,
		179,
		-1,
		220,
		-1,
		223,
		213,
		197,
		182,
		215,
		-1,
		186,
		170,
		175,
		-1,
		180,
		-1,
		153,
		153,
		144,
		133,
		130,
		134,
		125,
		138,
		123,
		-1,
		232,
		217,
		210,
		200,
		214,
		185,
		-1,
		240,
		-1,
		-1,
		210,
		204,
		204,
		188,
		191,
		202,
		182,
		176,
		175,
		175,
		170,
		161,
		142,
		135,
		132,
		133,
		146,
		158,
		137,
		125,
		-1,
		-1,
		-1,
		237,
		223,
		227,
		187,
		206,
		-1,
		-1,
		272,
		227,
		213,
		-1,
		197,
		219,
		207,
		197,
		187,
		196,
		186,
		161,
		154,
		140,
		142,
		140,
		142,
		147,
		138,
		130,
		140,
		-1,
		-1,
		220,
		225,
		213,
		199,
		218,
		-1,
		-1,
		-1,
		219,
		235,
		227,
		198,
		208,
		-1,
		-1,
		197,
		188,
		178,
		157,
		144,
		164,
		167,
		157,
		141,
		154,
		144,
		132,
		141,
		-1,
		223,
		210,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		-1,
		-1,
		252,
		214,
		203,
		198,
		202,
		196,
		-1,
		174,
		168,
		148,
		162,
		169,
		159,
		154,
		148,
		149,
		149,
		143,
		-1,
		-1,
		235,
		-1,
		230,
		-1,
		-1,
		-1,
		-1,
		209,
		220,
		191,
		184,
		188,
		-1,
		176,
		164,
		150,
		167,
		172,
		169,
		160,
		152,
		157,
		146,
		159,
		155,
		145,
		258,
		-1,
		241,
		-1,
		-1,
		-1,
		227,
		242,
		230,
		207,
		180,
		175,
		168,
		162,
		158,
		174,
		180,
		191,
		159,
		155,
		156,
		152,
		151,
		159,
		160,
		-1,
		-1,
		241,
		258,
		253,
		235,
		239,
		257,
		-1,
		-1,
		184,
		175,
		166,
		169,
		168,
		171,
		165,
		162,
		167,
		169,
		160,
		161,
		178,
		163,
		-1,
		-1,
		-1,
		261,
		-1,
		276,
		-1,
		-1,
		254,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		182,
		174,
		159,
		166,
		189,
		171,
		192,
		-1,
		-1,
		370,
		-1,
		-1,
		-1,
		273,
		265,
		260,
		266,
		268,
		259,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		179,
		186,
		186,
		178,
		156,
		163,
		179,
		178,
		173,
		184,
		179,
		188,
		-1,
		-1,
		363,
		352,
		341,
		347,
		-1,
		266,
		262,
		252,
		242,
		245,
		-1,
		-1,
		233,
		230,
		206,
		189,
		187,
		180,
		175,
		185,
		165,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		186,
		194,
		-1,
		268,
		349,
		342,
		315,
		323,
		354,
		-1,
		256,
		248,
		259,
		234,
		236,
		-1,
		-1,
		206,
		203,
		208,
		196,
		193,
		195,
		190,
		181,
		166,
		172,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		282,
		325,
		309,
		312,
		336,
		350,
		-1,
		253,
		-1,
		-1,
		265,
		237,
		221,
		211,
		205,
		255,
		210,
		205,
		189,
		187,
		178,
		169,
		176,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		299,
		305,
		303,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		281,
		-1,
		248,
		-1,
		223,
		227,
		218,
		221,
		203,
		190,
		182,
		174,
		190,
		165,
		175,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		324,
		280,
		283,
		294,
		305,
		320,
		324,
		-1,
		265,
		304,
		302,
		-1,
		286,
		-1,
		-1,
		-1,
		237,
		231,
		223,
		223,
		202,
		202,
		176,
		180,
		170,
		177,
		187,
		189,
		181,
		185,
		198,
		209,
		212,
		320,
		311,
		324,
		269,
		269,
		290,
		299,
		320,
		280,
		271,
		298,
		309,
		298,
		293,
		280,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		209,
		197,
		180,
		181,
		177,
		180,
		195,
		198,
		188,
		186,
		180,
		212,
		-1,
		313,
		312,
		301,
		298,
		274,
		265,
		260,
		287,
		-1,
		-1,
		282,
		299,
		293,
		297,
		313,
		338,
		-1,
		269,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		202,
		191,
		182,
		188,
		185,
		196,
		206,
		194,
		195,
		185,
		195,
		208,
		297,
		294,
		282,
		280,
		303,
		268,
		256,
		-1,
		269,
		267,
		273,
		280,
		297,
		327,
		-1,
		-1,
		285,
		265,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		187,
		192,
		212,
		214,
		203,
		197,
		191,
		198,
		197,
		205,
		213,
		306,
		320,
		309,
		305,
		304,
		312,
		261,
		254,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		-1,
		275,
		271,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		205,
		209,
		201,
		194,
		189,
		200,
		192,
		196,
		213,
		-1,
		340,
		-1,
		292,
		268,
		282,
		297,
		305,
		-1,
		-1,
		-1,
		292,
		278,
		271,
		259,
		257,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		245,
		213,
		218,
		213,
		195,
		206,
		195,
		198,
		212,
		207,
		-1,
		-1,
		280,
		283,
		-1,
		-1,
		282,
		284,
		-1,
		283,
		272,
		257,
		249,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		202,
		227,
		216,
		224,
		219,
		199,
		205,
		208,
		197,
		201,
		213,
		-1,
		-1,
		287,
		288,
		289,
		-1,
		267,
		-1,
		285,
		-1,
		252,
		258,
		246,
		-1,
		-1,
		-1,
		240,
		203,
		224,
		234,
		228,
		226,
		217,
		203,
		210,
		208,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		259,
		292,
		283,
		266,
		246,
		238,
		257,
		-1,
		227,
		-1,
		202,
		204,
		230,
		233,
		239,
		233,
		206,
		221,
		211,
		202,
		211,
		291,
		-1,
		261,
		294,
		258,
		252,
		228,
		232,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		255,
		240,
		221,
		208,
		215,
		215,
		208,
		-1,
		-1,
		-1,
		263,
		262,
		254,
		248,
		248,
		233,
		224,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		245,
		241,
		228,
		228,
		220,
		-1,
		364,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		257,
		252,
		225,
		213,
		219,
		215,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		221,
		256,
		-1,
		359,
		-1,
		293,
		-1,
		-1,
		275,
		255,
		247,
		236,
		225,
		223,
		214,
		205,
		227,
		243,
		227,
		225,
		228,
		229,
		-1,
		348,
		347,
		-1,
		294,
		286,
		272,
		-1,
		265,
		-1,
		271,
		232,
		-1,
		234,
		214,
		-1,
		236,
		232,
		-1,
		-1,
		335,
		310,
		-1,
		-1,
		-1,
		295,
		275,
		266,
		250,
		-1,
		225,
		225,
		-1,
		-1,
		-1,
		320,
		319,
		-1,
		288,
		291,
		-1,
		281,
		272,
		280,
		227,
		231,
		-1,
		-1,
		-1,
		329,
		310,
		304,
		303,
		301,
		296,
		293,
		279,
		263,
		241,
		230,
		251,
		-1,
		-1,
		-1,
		301,
		293,
		286,
		-1,
		-1,
		288,
		271,
		252,
		250,
		-1,
		-1,
		-1,
		323,
		304,
		-1,
		-1,
		278,
		-1,
		-1,
		284,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		312,
		-1,
		-1,
		-1,
		274,
		270,
		271,
		-1,
		-1,
		-1,
		-1,
		334,
		335,
		358,
		322,
		-1,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		337,
		335,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		264,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		299,
		-1,
		299,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		312,
		-1,
		284,
		286,
		-1,
		334,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		289,
		296,
		318,
		321,
		357,
		-1,
		308
	],
	[
		-1,
		202,
		191,
		202,
		210,
		183,
		190,
		-1,
		209,
		213,
		179,
		173,
		212,
		181,
		187,
		198,
		-1,
		-1,
		-1,
		202,
		201,
		169,
		167,
		176,
		181,
		188,
		-1,
		187,
		-1,
		223,
		202,
		213,
		218,
		162,
		159,
		179,
		198,
		180,
		172,
		238,
		192,
		163,
		157,
		175,
		165,
		174,
		166,
		-1,
		163,
		153,
		175,
		154,
		165,
		157,
		-1,
		-1,
		157,
		158,
		164,
		150,
		156,
		152,
		-1,
		162,
		146,
		-1,
		-1,
		147,
		148,
		132,
		135,
		143,
		141,
		154,
		146,
		141,
		-1,
		-1,
		138,
		134,
		141,
		128,
		124,
		141,
		154,
		136,
		128,
		126,
		-1,
		150,
		167,
		167,
		135,
		133,
		117,
		115,
		133,
		135,
		126,
		118,
		-1,
		167,
		163,
		164,
		162,
		157,
		133,
		120,
		120,
		130,
		123,
		120,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		168,
		159,
		176,
		160,
		150,
		154,
		152,
		123,
		120,
		118,
		115,
		123,
		106,
		116,
		-1,
		-1,
		261,
		234,
		258,
		216,
		198,
		-1,
		164,
		164,
		158,
		154,
		148,
		141,
		154,
		139,
		-1,
		109,
		108,
		113,
		99,
		110,
		243,
		-1,
		-1,
		219,
		211,
		193,
		196,
		173,
		169,
		179,
		178,
		171,
		159,
		155,
		138,
		141,
		141,
		147,
		103,
		109,
		106,
		92,
		90,
		-1,
		-1,
		25,
		-1,
		-1,
		240,
		223,
		-1,
		188,
		195,
		179,
		185,
		171,
		192,
		189,
		180,
		174,
		169,
		157,
		136,
		133,
		146,
		125,
		100,
		116,
		119,
		87,
		80,
		75,
		-1,
		24,
		0,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		195,
		192,
		185,
		209,
		208,
		-1,
		204,
		192,
		193,
		178,
		175,
		162,
		150,
		141,
		125,
		125,
		122,
		104,
		102,
		112,
		84,
		79,
		69,
		57,
		21,
		24,
		33,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		213,
		-1,
		216,
		229,
		216,
		189,
		192,
		179,
		170,
		157,
		146,
		142,
		123,
		120,
		116,
		96,
		111,
		89,
		90,
		58,
		58,
		49,
		21,
		27,
		-1,
		298,
		-1,
		240,
		224,
		226,
		199,
		220,
		-1,
		233,
		217,
		233,
		218,
		218,
		-1,
		188,
		185,
		175,
		153,
		138,
		135,
		123,
		118,
		109,
		91,
		105,
		85,
		71,
		62,
		48,
		35,
		25,
		35,
		258,
		248,
		-1,
		230,
		235,
		195,
		203,
		222,
		260,
		224,
		-1,
		219,
		-1,
		190,
		203,
		-1,
		159,
		155,
		137,
		131,
		120,
		127,
		102,
		87,
		84,
		77,
		80,
		44,
		45,
		36,
		-1,
		-1,
		243,
		247,
		237,
		188,
		207,
		231,
		268,
		217,
		206,
		205,
		-1,
		196,
		173,
		170,
		158,
		145,
		130,
		131,
		126,
		122,
		101,
		86,
		88,
		78,
		63,
		50,
		75,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		214,
		185,
		209,
		251,
		235,
		228,
		216,
		181,
		181,
		175,
		-1,
		169,
		148,
		139,
		128,
		126,
		134,
		107,
		102,
		86,
		84,
		73,
		61,
		57,
		77,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		180,
		203,
		240,
		214,
		200,
		205,
		180,
		173,
		167,
		182,
		165,
		146,
		135,
		127,
		116,
		108,
		114,
		106,
		82,
		87,
		67,
		72,
		79,
		85,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		194,
		201,
		233,
		205,
		218,
		-1,
		172,
		-1,
		161,
		156,
		140,
		135,
		132,
		126,
		113,
		113,
		111,
		92,
		87,
		99,
		77,
		77,
		69,
		94,
		97,
		-1,
		-1,
		-1,
		244,
		239,
		214,
		191,
		175,
		211,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		142,
		138,
		130,
		134,
		128,
		123,
		113,
		105,
		106,
		88,
		101,
		-1,
		77,
		71,
		99,
		102,
		92,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		142,
		137,
		134,
		135,
		126,
		115,
		121,
		113,
		93,
		103,
		115,
		92,
		90,
		83,
		88,
		87,
		101,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		162,
		146,
		147,
		138,
		129,
		137,
		117,
		110,
		96,
		100,
		110,
		101,
		96,
		102,
		94,
		97,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		190,
		169,
		184,
		162,
		158,
		154,
		169,
		170,
		148,
		138,
		136,
		144,
		132,
		121,
		108,
		112,
		114,
		111,
		97,
		97,
		99,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		152,
		184,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		168,
		166,
		159,
		150,
		156,
		147,
		141,
		136,
		126,
		115,
		121,
		117,
		119,
		105,
		103,
		98,
		113,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		167,
		151,
		156,
		-1,
		161,
		-1,
		134,
		134,
		125,
		114,
		111,
		115,
		106,
		119,
		104,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		221,
		-1,
		-1,
		191,
		185,
		185,
		169,
		172,
		183,
		163,
		157,
		156,
		156,
		151,
		142,
		123,
		116,
		113,
		114,
		127,
		139,
		118,
		106,
		-1,
		-1,
		-1,
		218,
		204,
		208,
		168,
		187,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		178,
		200,
		188,
		178,
		168,
		177,
		167,
		142,
		135,
		121,
		123,
		121,
		123,
		128,
		119,
		111,
		121,
		-1,
		-1,
		201,
		206,
		194,
		180,
		199,
		-1,
		-1,
		-1,
		200,
		216,
		208,
		179,
		189,
		-1,
		-1,
		178,
		169,
		159,
		138,
		125,
		145,
		148,
		138,
		122,
		135,
		125,
		113,
		122,
		-1,
		204,
		191,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		233,
		195,
		184,
		179,
		183,
		177,
		-1,
		155,
		149,
		129,
		143,
		150,
		140,
		135,
		129,
		130,
		130,
		124,
		-1,
		-1,
		216,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		190,
		201,
		172,
		165,
		169,
		-1,
		157,
		145,
		131,
		148,
		153,
		150,
		141,
		133,
		138,
		127,
		140,
		136,
		126,
		239,
		-1,
		222,
		-1,
		-1,
		-1,
		208,
		223,
		211,
		188,
		161,
		156,
		149,
		143,
		139,
		155,
		161,
		172,
		140,
		136,
		137,
		133,
		132,
		140,
		141,
		-1,
		-1,
		222,
		239,
		234,
		216,
		220,
		238,
		-1,
		-1,
		165,
		156,
		147,
		150,
		149,
		152,
		146,
		143,
		148,
		150,
		141,
		142,
		159,
		144,
		-1,
		-1,
		-1,
		242,
		-1,
		257,
		-1,
		-1,
		235,
		236,
		183,
		165,
		161,
		159,
		152,
		161,
		156,
		151,
		161,
		163,
		155,
		140,
		147,
		170,
		152,
		173,
		-1,
		-1,
		351,
		-1,
		-1,
		-1,
		254,
		246,
		241,
		247,
		249,
		240,
		198,
		195,
		-1,
		165,
		190,
		162,
		169,
		160,
		167,
		167,
		159,
		137,
		144,
		160,
		159,
		154,
		165,
		160,
		169,
		-1,
		-1,
		344,
		333,
		322,
		328,
		-1,
		247,
		243,
		233,
		223,
		226,
		-1,
		-1,
		214,
		211,
		187,
		170,
		168,
		161,
		156,
		166,
		146,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		167,
		175,
		-1,
		249,
		330,
		323,
		296,
		304,
		335,
		-1,
		237,
		229,
		240,
		215,
		217,
		-1,
		-1,
		187,
		184,
		189,
		177,
		174,
		176,
		171,
		162,
		147,
		153,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		263,
		306,
		290,
		293,
		317,
		331,
		-1,
		234,
		-1,
		-1,
		246,
		218,
		202,
		192,
		186,
		236,
		191,
		186,
		170,
		168,
		159,
		150,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		280,
		286,
		284,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		262,
		-1,
		229,
		-1,
		204,
		208,
		199,
		202,
		184,
		171,
		163,
		155,
		171,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		305,
		261,
		264,
		275,
		286,
		301,
		305,
		-1,
		246,
		285,
		283,
		-1,
		267,
		-1,
		-1,
		-1,
		218,
		212,
		204,
		204,
		183,
		183,
		157,
		161,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		301,
		292,
		305,
		250,
		250,
		271,
		280,
		301,
		261,
		252,
		279,
		290,
		279,
		274,
		261,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		190,
		178,
		161,
		162,
		158,
		161,
		176,
		179,
		169,
		167,
		161,
		193,
		-1,
		294,
		293,
		282,
		279,
		255,
		246,
		241,
		268,
		-1,
		-1,
		263,
		280,
		274,
		278,
		294,
		319,
		-1,
		250,
		-1,
		-1,
		235,
		-1,
		-1,
		220,
		183,
		172,
		163,
		169,
		166,
		177,
		187,
		175,
		176,
		166,
		176,
		189,
		278,
		275,
		263,
		261,
		284,
		249,
		237,
		-1,
		250,
		248,
		254,
		261,
		278,
		308,
		-1,
		-1,
		266,
		246,
		-1,
		-1,
		218,
		216,
		205,
		-1,
		195,
		168,
		173,
		193,
		195,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		287,
		301,
		290,
		286,
		285,
		293,
		242,
		235,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		-1,
		256,
		252,
		-1,
		-1,
		213,
		206,
		194,
		182,
		172,
		182,
		186,
		190,
		182,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		321,
		-1,
		273,
		249,
		263,
		278,
		286,
		-1,
		-1,
		-1,
		273,
		259,
		252,
		240,
		238,
		-1,
		247,
		231,
		212,
		-1,
		182,
		195,
		226,
		194,
		199,
		194,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		261,
		264,
		-1,
		-1,
		263,
		265,
		-1,
		264,
		253,
		238,
		230,
		-1,
		-1,
		219,
		215,
		-1,
		-1,
		183,
		208,
		197,
		205,
		200,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		268,
		269,
		270,
		-1,
		248,
		-1,
		266,
		-1,
		233,
		239,
		227,
		-1,
		-1,
		-1,
		221,
		184,
		205,
		215,
		209,
		207,
		198,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		266,
		240,
		273,
		264,
		247,
		227,
		219,
		238,
		-1,
		208,
		-1,
		183,
		185,
		211,
		214,
		220,
		214,
		187,
		202,
		192,
		183,
		192,
		272,
		-1,
		242,
		275,
		239,
		233,
		209,
		213,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		236,
		221,
		202,
		189,
		196,
		196,
		189,
		-1,
		-1,
		-1,
		244,
		243,
		235,
		229,
		229,
		214,
		205,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		226,
		222,
		209,
		209,
		201,
		-1,
		345,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		238,
		233,
		206,
		194,
		200,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		202,
		237,
		-1,
		340,
		-1,
		274,
		-1,
		-1,
		256,
		236,
		228,
		217,
		206,
		204,
		195,
		186,
		208,
		224,
		208,
		206,
		209,
		210,
		-1,
		329,
		328,
		-1,
		275,
		267,
		253,
		-1,
		246,
		-1,
		252,
		213,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		316,
		291,
		-1,
		-1,
		-1,
		276,
		256,
		247,
		231,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		301,
		300,
		-1,
		269,
		272,
		-1,
		262,
		253,
		261,
		208,
		212,
		-1,
		-1,
		-1,
		310,
		291,
		285,
		284,
		282,
		277,
		274,
		260,
		244,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		282,
		274,
		267,
		-1,
		-1,
		269,
		252,
		233,
		231,
		-1,
		-1,
		-1,
		304,
		285,
		-1,
		-1,
		259,
		-1,
		-1,
		265,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		321,
		293,
		-1,
		-1,
		-1,
		255,
		251,
		252,
		-1,
		-1,
		-1,
		-1,
		315,
		316,
		339,
		303,
		-1,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		318,
		316,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		245,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		280,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		293,
		285,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		308,
		299,
		-1,
		-1,
		270,
		277,
		299,
		302,
		338,
		-1,
		289
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		139,
		128,
		139,
		147,
		120,
		127,
		-1,
		148,
		150,
		116,
		110,
		149,
		120,
		126,
		137,
		-1,
		-1,
		-1,
		139,
		138,
		108,
		106,
		115,
		120,
		127,
		-1,
		150,
		-1,
		160,
		139,
		150,
		155,
		101,
		98,
		118,
		137,
		143,
		135,
		175,
		131,
		102,
		96,
		114,
		119,
		137,
		129,
		-1,
		102,
		92,
		114,
		118,
		130,
		113,
		-1,
		-1,
		96,
		97,
		103,
		115,
		120,
		125,
		-1,
		151,
		170,
		-1,
		-1,
		86,
		99,
		95,
		98,
		106,
		122,
		143,
		160,
		165,
		-1,
		-1,
		87,
		91,
		104,
		105,
		103,
		130,
		149,
		160,
		174,
		173,
		-1,
		75,
		93,
		102,
		111,
		117,
		106,
		110,
		128,
		159,
		165,
		168,
		-1,
		67,
		69,
		98,
		104,
		116,
		122,
		109,
		115,
		134,
		147,
		166,
		157,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		64,
		72,
		98,
		97,
		93,
		111,
		133,
		112,
		118,
		122,
		139,
		155,
		156,
		166,
		-1,
		-1,
		115,
		84,
		119,
		76,
		61,
		-1,
		60,
		79,
		85,
		89,
		94,
		102,
		130,
		128,
		-1,
		133,
		132,
		163,
		149,
		160,
		33,
		-1,
		-1,
		73,
		65,
		50,
		53,
		50,
		55,
		85,
		84,
		89,
		91,
		93,
		105,
		120,
		120,
		130,
		127,
		137,
		141,
		156,
		167,
		-1,
		-1,
		241,
		-1,
		-1,
		34,
		5,
		-1,
		38,
		45,
		45,
		62,
		53,
		78,
		93,
		97,
		105,
		108,
		96,
		115,
		112,
		136,
		132,
		124,
		149,
		153,
		159,
		177,
		178,
		-1,
		240,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		0,
		31,
		34,
		40,
		64,
		74,
		-1,
		100,
		98,
		122,
		116,
		121,
		117,
		102,
		120,
		118,
		133,
		135,
		131,
		133,
		170,
		161,
		182,
		179,
		210,
		216,
		210,
		219,
		-1,
		80,
		76,
		72,
		79,
		28,
		-1,
		-1,
		68,
		-1,
		82,
		95,
		112,
		102,
		105,
		117,
		125,
		124,
		108,
		126,
		121,
		124,
		143,
		139,
		148,
		158,
		157,
		175,
		188,
		203,
		207,
		213,
		-1,
		130,
		-1,
		72,
		56,
		58,
		34,
		62,
		-1,
		88,
		83,
		103,
		114,
		114,
		-1,
		130,
		127,
		140,
		124,
		109,
		126,
		128,
		132,
		142,
		146,
		161,
		152,
		170,
		177,
		185,
		189,
		209,
		221,
		90,
		80,
		-1,
		62,
		67,
		37,
		49,
		85,
		126,
		110,
		-1,
		125,
		-1,
		132,
		145,
		-1,
		130,
		126,
		115,
		131,
		139,
		146,
		149,
		143,
		140,
		158,
		161,
		178,
		182,
		198,
		-1,
		-1,
		75,
		79,
		100,
		43,
		70,
		94,
		131,
		119,
		128,
		130,
		-1,
		150,
		151,
		148,
		149,
		135,
		128,
		129,
		145,
		151,
		143,
		142,
		145,
		167,
		195,
		173,
		185,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		77,
		48,
		72,
		114,
		158,
		151,
		139,
		137,
		137,
		131,
		-1,
		166,
		145,
		142,
		133,
		138,
		151,
		146,
		162,
		146,
		148,
		164,
		176,
		167,
		187,
		-1,
		-1,
		-1,
		107,
		96,
		97,
		51,
		85,
		103,
		170,
		156,
		161,
		136,
		129,
		123,
		160,
		162,
		139,
		147,
		139,
		128,
		142,
		150,
		154,
		148,
		157,
		158,
		182,
		189,
		195,
		-1,
		-1,
		114,
		104,
		88,
		90,
		87,
		76,
		83,
		115,
		161,
		158,
		-1,
		128,
		-1,
		117,
		125,
		124,
		130,
		142,
		128,
		133,
		144,
		156,
		162,
		153,
		168,
		187,
		187,
		179,
		204,
		207,
		-1,
		-1,
		-1,
		107,
		124,
		99,
		76,
		57,
		93,
		-1,
		128,
		129,
		-1,
		122,
		116,
		122,
		121,
		128,
		125,
		125,
		139,
		147,
		143,
		159,
		165,
		154,
		190,
		-1,
		187,
		181,
		202,
		192,
		180,
		-1,
		-1,
		-1,
		122,
		101,
		94,
		114,
		64,
		116,
		-1,
		-1,
		113,
		106,
		-1,
		109,
		109,
		116,
		125,
		130,
		135,
		143,
		138,
		151,
		156,
		159,
		167,
		185,
		189,
		193,
		182,
		178,
		175,
		189,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		84,
		-1,
		121,
		113,
		104,
		98,
		104,
		122,
		120,
		140,
		132,
		146,
		146,
		152,
		160,
		145,
		148,
		162,
		162,
		180,
		188,
		180,
		174,
		173,
		185,
		-1,
		170,
		156,
		127,
		-1,
		-1,
		99,
		-1,
		70,
		94,
		110,
		-1,
		138,
		117,
		140,
		118,
		132,
		128,
		166,
		167,
		145,
		150,
		158,
		168,
		170,
		159,
		170,
		162,
		184,
		184,
		168,
		169,
		178,
		-1,
		176,
		163,
		121,
		117,
		106,
		126,
		73,
		86,
		97,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		142,
		140,
		156,
		147,
		153,
		169,
		172,
		174,
		164,
		153,
		159,
		156,
		178,
		164,
		162,
		181,
		197,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		92,
		79,
		73,
		-1,
		114,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		164,
		148,
		153,
		-1,
		199,
		-1,
		172,
		174,
		168,
		153,
		150,
		161,
		159,
		170,
		187,
		-1,
		126,
		111,
		104,
		94,
		108,
		79,
		-1,
		130,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		180,
		160,
		154,
		153,
		194,
		194,
		180,
		166,
		159,
		156,
		153,
		166,
		186,
		177,
		189,
		-1,
		-1,
		-1,
		131,
		111,
		117,
		75,
		96,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		197,
		185,
		175,
		165,
		199,
		200,
		185,
		178,
		164,
		166,
		164,
		162,
		167,
		188,
		189,
		202,
		-1,
		-1,
		108,
		115,
		103,
		89,
		108,
		-1,
		-1,
		-1,
		156,
		172,
		164,
		135,
		186,
		-1,
		-1,
		177,
		175,
		185,
		181,
		168,
		188,
		191,
		177,
		161,
		176,
		188,
		196,
		201,
		-1,
		111,
		98,
		-1,
		-1,
		111,
		105,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		167,
		188,
		213,
		180,
		-1,
		185,
		186,
		172,
		186,
		193,
		179,
		174,
		168,
		171,
		189,
		206,
		-1,
		-1,
		125,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		146,
		160,
		181,
		187,
		199,
		-1,
		194,
		188,
		174,
		191,
		192,
		189,
		180,
		172,
		177,
		174,
		187,
		201,
		205,
		148,
		-1,
		131,
		-1,
		-1,
		-1,
		164,
		179,
		241,
		218,
		191,
		195,
		188,
		182,
		182,
		198,
		200,
		211,
		179,
		175,
		176,
		180,
		179,
		196,
		206,
		-1,
		-1,
		131,
		148,
		183,
		172,
		176,
		268,
		-1,
		-1,
		204,
		195,
		186,
		189,
		192,
		195,
		185,
		182,
		187,
		192,
		180,
		189,
		207,
		211,
		-1,
		-1,
		-1,
		151,
		-1,
		166,
		-1,
		-1,
		191,
		275,
		222,
		204,
		200,
		198,
		191,
		200,
		195,
		190,
		200,
		209,
		201,
		182,
		193,
		216,
		205,
		243,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		180,
		155,
		170,
		216,
		211,
		212,
		237,
		234,
		-1,
		204,
		229,
		201,
		208,
		200,
		208,
		208,
		205,
		183,
		190,
		206,
		205,
		200,
		235,
		227,
		233,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		186,
		172,
		202,
		192,
		198,
		-1,
		-1,
		245,
		242,
		226,
		210,
		214,
		207,
		202,
		212,
		192,
		179,
		183,
		187,
		193,
		198,
		203,
		209,
		224,
		239,
		-1,
		156,
		237,
		230,
		213,
		221,
		252,
		-1,
		189,
		198,
		179,
		184,
		192,
		-1,
		-1,
		218,
		214,
		219,
		217,
		214,
		222,
		217,
		208,
		193,
		199,
		186,
		185,
		203,
		207,
		216,
		223,
		213,
		226,
		230,
		-1,
		170,
		213,
		207,
		210,
		234,
		248,
		-1,
		202,
		-1,
		-1,
		187,
		205,
		213,
		209,
		213,
		266,
		231,
		226,
		216,
		214,
		205,
		196,
		203,
		194,
		194,
		197,
		212,
		217,
		209,
		223,
		223,
		224,
		-1,
		205,
		193,
		201,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		203,
		-1,
		239,
		-1,
		232,
		236,
		239,
		242,
		230,
		217,
		209,
		201,
		217,
		192,
		202,
		198,
		199,
		208,
		219,
		231,
		230,
		231,
		279,
		234,
		201,
		192,
		239,
		254,
		258,
		-1,
		215,
		254,
		241,
		-1,
		212,
		-1,
		-1,
		-1,
		246,
		252,
		244,
		250,
		229,
		229,
		203,
		207,
		197,
		204,
		214,
		216,
		208,
		212,
		225,
		236,
		239,
		275,
		273,
		278,
		223,
		206,
		224,
		233,
		254,
		230,
		221,
		248,
		248,
		237,
		232,
		219,
		-1,
		-1,
		269,
		262,
		-1,
		-1,
		236,
		224,
		207,
		208,
		204,
		207,
		222,
		225,
		215,
		213,
		207,
		239,
		-1,
		275,
		274,
		263,
		260,
		236,
		227,
		214,
		225,
		-1,
		-1,
		233,
		249,
		262,
		266,
		279,
		304,
		-1,
		222,
		-1,
		-1,
		281,
		-1,
		-1,
		266,
		229,
		218,
		209,
		215,
		212,
		223,
		233,
		221,
		222,
		212,
		222,
		235,
		259,
		256,
		244,
		242,
		265,
		222,
		218,
		-1,
		248,
		236,
		242,
		249,
		266,
		293,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		264,
		262,
		251,
		-1,
		241,
		214,
		219,
		239,
		241,
		230,
		224,
		218,
		225,
		224,
		232,
		240,
		268,
		282,
		271,
		267,
		266,
		274,
		223,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		-1,
		273,
		248,
		-1,
		-1,
		259,
		252,
		240,
		228,
		218,
		228,
		232,
		236,
		228,
		221,
		216,
		227,
		219,
		223,
		240,
		-1,
		302,
		-1,
		254,
		247,
		262,
		277,
		285,
		-1,
		-1,
		-1,
		290,
		276,
		269,
		257,
		255,
		-1,
		293,
		277,
		258,
		-1,
		228,
		241,
		272,
		240,
		245,
		240,
		222,
		233,
		222,
		225,
		239,
		234,
		-1,
		-1,
		260,
		263,
		-1,
		-1,
		285,
		304,
		-1,
		281,
		270,
		255,
		247,
		-1,
		-1,
		265,
		261,
		-1,
		-1,
		229,
		254,
		243,
		251,
		246,
		226,
		232,
		235,
		224,
		228,
		240,
		-1,
		-1,
		267,
		268,
		273,
		-1,
		294,
		-1,
		305,
		-1,
		250,
		266,
		268,
		-1,
		-1,
		-1,
		267,
		230,
		251,
		261,
		255,
		253,
		244,
		230,
		237,
		235,
		231,
		242,
		-1,
		-1,
		-1,
		312,
		286,
		312,
		303,
		286,
		266,
		258,
		283,
		-1,
		254,
		-1,
		229,
		231,
		257,
		260,
		266,
		260,
		233,
		248,
		238,
		229,
		238,
		318,
		-1,
		288,
		321,
		285,
		272,
		255,
		259,
		275,
		-1,
		251,
		233,
		-1,
		261,
		251,
		282,
		267,
		248,
		235,
		242,
		242,
		235,
		-1,
		-1,
		-1,
		290,
		289,
		281,
		275,
		275,
		260,
		251,
		-1,
		263,
		245,
		224,
		241,
		241,
		232,
		240,
		272,
		268,
		255,
		255,
		247,
		-1,
		374,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		284,
		279,
		252,
		240,
		246,
		242,
		228,
		234,
		236,
		244,
		242,
		239,
		251,
		247,
		267,
		248,
		283,
		-1,
		381,
		-1,
		320,
		-1,
		-1,
		302,
		282,
		274,
		263,
		252,
		250,
		241,
		232,
		254,
		270,
		254,
		252,
		255,
		256,
		-1,
		375,
		374,
		-1,
		321,
		313,
		299,
		-1,
		292,
		-1,
		298,
		259,
		-1,
		261,
		241,
		-1,
		263,
		259,
		-1,
		-1,
		362,
		337,
		-1,
		-1,
		-1,
		322,
		302,
		293,
		277,
		-1,
		252,
		252,
		-1,
		-1,
		-1,
		347,
		346,
		-1,
		315,
		318,
		-1,
		308,
		299,
		307,
		254,
		258,
		-1,
		-1,
		-1,
		356,
		337,
		331,
		330,
		328,
		323,
		320,
		306,
		290,
		268,
		257,
		278,
		-1,
		-1,
		-1,
		328,
		320,
		313,
		-1,
		-1,
		315,
		298,
		279,
		277,
		-1,
		-1,
		-1,
		350,
		331,
		-1,
		-1,
		305,
		-1,
		-1,
		311,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		367,
		339,
		-1,
		-1,
		-1,
		301,
		297,
		298,
		-1,
		-1,
		-1,
		-1,
		361,
		362,
		385,
		349,
		-1,
		-1,
		-1,
		293,
		287,
		-1,
		-1,
		364,
		362,
		-1,
		-1,
		-1,
		321,
		305,
		-1,
		291,
		-1,
		-1,
		-1,
		312,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		326,
		-1,
		326,
		301,
		308,
		-1,
		-1,
		-1,
		-1,
		339,
		331,
		339,
		-1,
		311,
		313,
		-1,
		361,
		-1,
		-1,
		354,
		345,
		-1,
		-1,
		316,
		323,
		345,
		348,
		384,
		-1,
		335
	],
	[
		-1,
		114,
		103,
		114,
		122,
		95,
		102,
		-1,
		123,
		125,
		91,
		85,
		124,
		95,
		101,
		112,
		-1,
		-1,
		-1,
		114,
		113,
		83,
		81,
		90,
		95,
		102,
		-1,
		125,
		-1,
		135,
		114,
		125,
		130,
		76,
		73,
		93,
		112,
		118,
		110,
		150,
		106,
		77,
		71,
		89,
		94,
		112,
		104,
		-1,
		77,
		67,
		89,
		93,
		105,
		88,
		-1,
		-1,
		71,
		72,
		78,
		90,
		95,
		100,
		-1,
		126,
		145,
		-1,
		-1,
		61,
		74,
		70,
		73,
		81,
		97,
		118,
		135,
		140,
		-1,
		-1,
		62,
		66,
		79,
		80,
		78,
		105,
		124,
		135,
		149,
		148,
		-1,
		50,
		68,
		77,
		86,
		92,
		81,
		85,
		103,
		134,
		140,
		143,
		-1,
		42,
		44,
		73,
		79,
		91,
		97,
		84,
		90,
		109,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		38,
		39,
		47,
		73,
		72,
		68,
		86,
		108,
		87,
		93,
		97,
		114,
		130,
		131,
		141,
		-1,
		-1,
		88,
		57,
		92,
		49,
		34,
		-1,
		35,
		54,
		60,
		64,
		69,
		77,
		105,
		103,
		-1,
		108,
		107,
		138,
		124,
		135,
		53,
		-1,
		-1,
		46,
		38,
		23,
		26,
		25,
		30,
		60,
		59,
		64,
		66,
		68,
		80,
		95,
		95,
		105,
		102,
		112,
		116,
		131,
		142,
		-1,
		-1,
		216,
		-1,
		-1,
		50,
		33,
		-1,
		11,
		18,
		20,
		37,
		28,
		53,
		68,
		72,
		80,
		83,
		71,
		90,
		87,
		111,
		107,
		99,
		124,
		128,
		134,
		152,
		153,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		28,
		0,
		3,
		17,
		41,
		49,
		-1,
		75,
		73,
		97,
		91,
		96,
		92,
		77,
		95,
		93,
		108,
		110,
		106,
		108,
		145,
		136,
		157,
		154,
		185,
		191,
		185,
		194,
		-1,
		58,
		54,
		50,
		57,
		6,
		-1,
		-1,
		45,
		-1,
		57,
		70,
		87,
		77,
		80,
		92,
		100,
		99,
		83,
		101,
		96,
		99,
		118,
		114,
		123,
		133,
		132,
		150,
		163,
		178,
		182,
		188,
		-1,
		108,
		-1,
		50,
		34,
		36,
		12,
		40,
		-1,
		65,
		58,
		78,
		89,
		89,
		-1,
		105,
		102,
		115,
		99,
		84,
		101,
		103,
		107,
		117,
		121,
		136,
		127,
		145,
		152,
		160,
		164,
		184,
		196,
		68,
		58,
		-1,
		40,
		45,
		15,
		27,
		63,
		101,
		85,
		-1,
		100,
		-1,
		107,
		120,
		-1,
		105,
		101,
		90,
		106,
		114,
		121,
		124,
		118,
		115,
		133,
		136,
		153,
		157,
		173,
		-1,
		-1,
		53,
		57,
		78,
		21,
		48,
		72,
		109,
		94,
		103,
		105,
		-1,
		125,
		126,
		123,
		124,
		110,
		103,
		104,
		120,
		126,
		121,
		117,
		120,
		142,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		55,
		26,
		50,
		92,
		133,
		126,
		114,
		115,
		115,
		109,
		-1,
		141,
		120,
		117,
		108,
		116,
		129,
		124,
		140,
		121,
		123,
		139,
		151,
		142,
		162,
		-1,
		-1,
		-1,
		85,
		74,
		75,
		29,
		63,
		81,
		148,
		134,
		139,
		114,
		107,
		101,
		135,
		137,
		117,
		125,
		117,
		106,
		120,
		128,
		132,
		123,
		132,
		133,
		157,
		164,
		170,
		-1,
		-1,
		92,
		82,
		66,
		68,
		65,
		54,
		61,
		93,
		139,
		136,
		-1,
		106,
		-1,
		95,
		103,
		102,
		108,
		120,
		106,
		111,
		122,
		134,
		137,
		128,
		143,
		162,
		162,
		154,
		179,
		182,
		-1,
		-1,
		-1,
		85,
		102,
		77,
		54,
		35,
		71,
		-1,
		106,
		107,
		-1,
		100,
		94,
		100,
		99,
		106,
		103,
		103,
		117,
		125,
		121,
		137,
		143,
		129,
		165,
		-1,
		162,
		156,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		100,
		79,
		72,
		92,
		42,
		94,
		-1,
		-1,
		91,
		84,
		-1,
		87,
		87,
		94,
		103,
		108,
		113,
		121,
		116,
		129,
		134,
		134,
		144,
		163,
		167,
		171,
		160,
		156,
		153,
		167,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		62,
		-1,
		99,
		91,
		82,
		76,
		82,
		100,
		98,
		118,
		110,
		124,
		124,
		130,
		138,
		123,
		126,
		137,
		140,
		158,
		166,
		158,
		152,
		151,
		163,
		-1,
		148,
		134,
		105,
		-1,
		-1,
		77,
		-1,
		48,
		72,
		88,
		-1,
		116,
		95,
		118,
		96,
		110,
		106,
		144,
		145,
		123,
		128,
		136,
		146,
		148,
		137,
		148,
		140,
		162,
		162,
		146,
		147,
		156,
		-1,
		154,
		141,
		99,
		95,
		84,
		104,
		51,
		64,
		75,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		120,
		118,
		134,
		125,
		131,
		147,
		150,
		152,
		142,
		131,
		137,
		134,
		156,
		142,
		140,
		159,
		175,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		70,
		57,
		51,
		-1,
		92,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		142,
		126,
		131,
		-1,
		177,
		-1,
		150,
		152,
		146,
		131,
		128,
		139,
		137,
		148,
		165,
		-1,
		104,
		89,
		82,
		72,
		86,
		57,
		-1,
		108,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		158,
		138,
		132,
		131,
		172,
		172,
		158,
		144,
		137,
		134,
		131,
		144,
		164,
		155,
		167,
		-1,
		-1,
		-1,
		109,
		89,
		95,
		53,
		74,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		175,
		163,
		153,
		143,
		177,
		178,
		163,
		156,
		142,
		144,
		142,
		140,
		145,
		166,
		167,
		180,
		-1,
		-1,
		86,
		93,
		81,
		67,
		86,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		164,
		-1,
		-1,
		155,
		153,
		163,
		159,
		146,
		166,
		169,
		155,
		139,
		154,
		166,
		174,
		179,
		-1,
		89,
		76,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		145,
		166,
		191,
		158,
		-1,
		163,
		164,
		150,
		164,
		171,
		157,
		152,
		146,
		149,
		167,
		184,
		-1,
		-1,
		103,
		-1,
		98,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		159,
		165,
		177,
		-1,
		172,
		166,
		152,
		169,
		170,
		167,
		158,
		150,
		155,
		152,
		165,
		179,
		183,
		126,
		-1,
		109,
		-1,
		-1,
		-1,
		142,
		157,
		219,
		196,
		169,
		173,
		166,
		160,
		160,
		176,
		178,
		189,
		157,
		153,
		154,
		158,
		157,
		174,
		184,
		-1,
		-1,
		109,
		126,
		161,
		150,
		154,
		246,
		-1,
		-1,
		182,
		173,
		164,
		167,
		170,
		173,
		163,
		160,
		165,
		170,
		158,
		167,
		185,
		189,
		-1,
		-1,
		-1,
		129,
		-1,
		144,
		-1,
		-1,
		169,
		253,
		200,
		182,
		178,
		176,
		169,
		178,
		173,
		168,
		178,
		187,
		179,
		160,
		171,
		194,
		183,
		221,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		158,
		133,
		148,
		194,
		189,
		190,
		215,
		212,
		-1,
		182,
		207,
		179,
		186,
		178,
		186,
		186,
		183,
		161,
		168,
		184,
		183,
		178,
		213,
		205,
		211,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		164,
		150,
		180,
		170,
		176,
		-1,
		-1,
		223,
		220,
		204,
		188,
		192,
		185,
		180,
		190,
		170,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		134,
		215,
		208,
		191,
		199,
		230,
		-1,
		167,
		176,
		157,
		162,
		170,
		-1,
		-1,
		196,
		192,
		197,
		195,
		192,
		200,
		195,
		186,
		171,
		177,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		148,
		191,
		185,
		188,
		212,
		226,
		-1,
		180,
		-1,
		-1,
		165,
		183,
		191,
		187,
		191,
		244,
		209,
		204,
		194,
		192,
		183,
		174,
		181,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		183,
		171,
		179,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		181,
		-1,
		217,
		-1,
		210,
		214,
		217,
		220,
		208,
		195,
		187,
		179,
		195,
		170,
		180,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		257,
		212,
		179,
		170,
		217,
		232,
		236,
		-1,
		193,
		232,
		219,
		-1,
		190,
		-1,
		-1,
		-1,
		224,
		230,
		222,
		228,
		207,
		207,
		181,
		185,
		175,
		182,
		192,
		194,
		186,
		190,
		203,
		214,
		217,
		253,
		251,
		256,
		201,
		184,
		202,
		211,
		232,
		208,
		199,
		226,
		226,
		215,
		210,
		197,
		-1,
		-1,
		247,
		240,
		-1,
		-1,
		214,
		202,
		185,
		186,
		182,
		185,
		200,
		203,
		193,
		191,
		185,
		217,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		192,
		203,
		-1,
		-1,
		211,
		227,
		240,
		244,
		257,
		282,
		-1,
		200,
		-1,
		-1,
		259,
		-1,
		-1,
		244,
		207,
		196,
		187,
		193,
		190,
		201,
		211,
		199,
		200,
		190,
		200,
		213,
		237,
		234,
		222,
		220,
		243,
		200,
		196,
		-1,
		226,
		214,
		220,
		227,
		244,
		271,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		242,
		240,
		229,
		-1,
		219,
		192,
		197,
		217,
		219,
		208,
		202,
		196,
		203,
		202,
		210,
		218,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		226,
		-1,
		-1,
		237,
		230,
		218,
		206,
		196,
		206,
		210,
		214,
		206,
		199,
		194,
		205,
		197,
		201,
		218,
		-1,
		280,
		-1,
		232,
		225,
		240,
		255,
		263,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		271,
		255,
		236,
		-1,
		206,
		219,
		250,
		218,
		223,
		218,
		200,
		211,
		200,
		203,
		217,
		212,
		-1,
		-1,
		238,
		241,
		-1,
		-1,
		263,
		282,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		243,
		239,
		-1,
		-1,
		207,
		232,
		221,
		229,
		224,
		204,
		210,
		213,
		202,
		206,
		218,
		-1,
		-1,
		245,
		246,
		251,
		-1,
		272,
		-1,
		283,
		-1,
		228,
		244,
		246,
		-1,
		-1,
		-1,
		245,
		208,
		229,
		239,
		233,
		231,
		222,
		208,
		215,
		213,
		209,
		220,
		-1,
		-1,
		-1,
		290,
		264,
		290,
		281,
		264,
		244,
		236,
		261,
		-1,
		232,
		-1,
		207,
		209,
		235,
		238,
		244,
		238,
		211,
		226,
		216,
		207,
		216,
		296,
		-1,
		266,
		299,
		263,
		250,
		233,
		237,
		253,
		-1,
		229,
		211,
		-1,
		239,
		229,
		260,
		245,
		226,
		213,
		220,
		220,
		213,
		-1,
		-1,
		-1,
		268,
		267,
		259,
		253,
		253,
		238,
		229,
		-1,
		241,
		223,
		202,
		219,
		219,
		210,
		218,
		250,
		246,
		233,
		233,
		225,
		-1,
		352,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		262,
		257,
		230,
		218,
		224,
		220,
		206,
		212,
		214,
		222,
		220,
		217,
		229,
		225,
		245,
		226,
		261,
		-1,
		359,
		-1,
		298,
		-1,
		-1,
		280,
		260,
		252,
		241,
		230,
		228,
		219,
		210,
		232,
		248,
		232,
		230,
		233,
		234,
		-1,
		353,
		352,
		-1,
		299,
		291,
		277,
		-1,
		270,
		-1,
		276,
		237,
		-1,
		239,
		219,
		-1,
		241,
		237,
		-1,
		-1,
		340,
		315,
		-1,
		-1,
		-1,
		300,
		280,
		271,
		255,
		-1,
		230,
		230,
		-1,
		-1,
		-1,
		325,
		324,
		-1,
		293,
		296,
		-1,
		286,
		277,
		285,
		232,
		236,
		-1,
		-1,
		-1,
		334,
		315,
		309,
		308,
		306,
		301,
		298,
		284,
		268,
		246,
		235,
		256,
		-1,
		-1,
		-1,
		306,
		298,
		291,
		-1,
		-1,
		293,
		276,
		257,
		255,
		-1,
		-1,
		-1,
		328,
		309,
		-1,
		-1,
		283,
		-1,
		-1,
		289,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		345,
		317,
		-1,
		-1,
		-1,
		279,
		275,
		276,
		-1,
		-1,
		-1,
		-1,
		339,
		340,
		363,
		327,
		-1,
		-1,
		-1,
		271,
		265,
		-1,
		-1,
		342,
		340,
		-1,
		-1,
		-1,
		299,
		283,
		-1,
		269,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		304,
		-1,
		304,
		279,
		286,
		-1,
		-1,
		-1,
		-1,
		317,
		309,
		317,
		-1,
		289,
		291,
		-1,
		339,
		-1,
		-1,
		332,
		323,
		-1,
		-1,
		294,
		301,
		323,
		326,
		362,
		-1,
		313
	],
	[
		-1,
		111,
		100,
		111,
		119,
		92,
		99,
		-1,
		120,
		122,
		88,
		82,
		121,
		92,
		98,
		109,
		-1,
		-1,
		-1,
		111,
		110,
		80,
		78,
		87,
		92,
		99,
		-1,
		122,
		-1,
		132,
		111,
		122,
		127,
		73,
		70,
		90,
		109,
		115,
		107,
		147,
		103,
		74,
		68,
		86,
		91,
		109,
		101,
		-1,
		74,
		64,
		86,
		90,
		102,
		85,
		-1,
		-1,
		68,
		69,
		75,
		87,
		92,
		97,
		-1,
		123,
		142,
		-1,
		-1,
		58,
		71,
		67,
		70,
		78,
		94,
		115,
		132,
		137,
		-1,
		-1,
		59,
		63,
		76,
		77,
		75,
		102,
		121,
		132,
		146,
		145,
		-1,
		47,
		65,
		74,
		83,
		89,
		78,
		82,
		100,
		131,
		137,
		140,
		-1,
		39,
		41,
		70,
		76,
		88,
		94,
		81,
		87,
		106,
		119,
		138,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		35,
		36,
		44,
		70,
		69,
		65,
		83,
		105,
		84,
		90,
		94,
		111,
		127,
		128,
		138,
		-1,
		-1,
		85,
		54,
		89,
		46,
		31,
		-1,
		32,
		51,
		57,
		61,
		66,
		74,
		102,
		100,
		-1,
		105,
		104,
		135,
		121,
		132,
		56,
		-1,
		-1,
		43,
		35,
		20,
		23,
		22,
		27,
		57,
		56,
		61,
		63,
		65,
		77,
		92,
		92,
		102,
		99,
		109,
		113,
		128,
		139,
		-1,
		-1,
		213,
		-1,
		-1,
		53,
		36,
		-1,
		8,
		15,
		17,
		34,
		25,
		50,
		65,
		69,
		77,
		80,
		68,
		87,
		84,
		108,
		104,
		96,
		121,
		125,
		131,
		149,
		150,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		31,
		3,
		0,
		14,
		38,
		46,
		-1,
		72,
		70,
		94,
		88,
		93,
		89,
		74,
		92,
		90,
		105,
		107,
		103,
		105,
		142,
		133,
		154,
		151,
		182,
		188,
		182,
		191,
		-1,
		61,
		57,
		53,
		60,
		9,
		-1,
		-1,
		42,
		-1,
		54,
		67,
		84,
		74,
		77,
		89,
		97,
		96,
		80,
		98,
		93,
		96,
		115,
		111,
		120,
		130,
		129,
		147,
		160,
		175,
		179,
		185,
		-1,
		111,
		-1,
		53,
		37,
		39,
		15,
		43,
		-1,
		62,
		55,
		75,
		86,
		86,
		-1,
		102,
		99,
		112,
		96,
		81,
		98,
		100,
		104,
		114,
		118,
		133,
		124,
		142,
		149,
		157,
		161,
		181,
		193,
		71,
		61,
		-1,
		43,
		48,
		18,
		30,
		66,
		98,
		82,
		-1,
		97,
		-1,
		104,
		117,
		-1,
		102,
		98,
		87,
		103,
		111,
		118,
		121,
		115,
		112,
		130,
		133,
		150,
		154,
		170,
		-1,
		-1,
		56,
		60,
		81,
		24,
		51,
		75,
		112,
		91,
		100,
		102,
		-1,
		122,
		123,
		120,
		121,
		107,
		100,
		101,
		117,
		123,
		119,
		114,
		117,
		139,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		81,
		-1,
		-1,
		58,
		29,
		53,
		95,
		130,
		123,
		111,
		118,
		118,
		112,
		-1,
		138,
		117,
		114,
		105,
		113,
		127,
		124,
		138,
		118,
		120,
		136,
		148,
		139,
		159,
		-1,
		-1,
		-1,
		88,
		77,
		78,
		32,
		66,
		84,
		151,
		137,
		142,
		117,
		110,
		104,
		132,
		134,
		120,
		123,
		115,
		104,
		120,
		128,
		130,
		120,
		129,
		130,
		154,
		161,
		167,
		-1,
		-1,
		95,
		85,
		69,
		71,
		68,
		57,
		64,
		96,
		142,
		139,
		-1,
		109,
		-1,
		98,
		106,
		105,
		111,
		120,
		109,
		111,
		120,
		134,
		134,
		125,
		140,
		159,
		159,
		151,
		176,
		179,
		-1,
		-1,
		-1,
		88,
		105,
		80,
		57,
		38,
		74,
		-1,
		109,
		110,
		-1,
		103,
		97,
		103,
		102,
		109,
		106,
		106,
		118,
		125,
		121,
		135,
		144,
		126,
		162,
		-1,
		159,
		153,
		181,
		173,
		161,
		-1,
		-1,
		-1,
		103,
		82,
		75,
		95,
		45,
		97,
		-1,
		-1,
		94,
		87,
		-1,
		90,
		90,
		97,
		106,
		111,
		116,
		124,
		119,
		132,
		137,
		131,
		141,
		161,
		165,
		172,
		163,
		159,
		156,
		170,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		48,
		65,
		-1,
		102,
		94,
		85,
		79,
		85,
		103,
		101,
		121,
		113,
		127,
		127,
		133,
		141,
		126,
		129,
		134,
		138,
		156,
		169,
		161,
		155,
		154,
		166,
		-1,
		151,
		137,
		108,
		-1,
		-1,
		80,
		-1,
		51,
		75,
		91,
		-1,
		119,
		98,
		121,
		99,
		113,
		109,
		147,
		148,
		126,
		131,
		139,
		149,
		151,
		140,
		146,
		143,
		165,
		165,
		149,
		150,
		159,
		-1,
		157,
		144,
		102,
		98,
		87,
		107,
		54,
		67,
		78,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		123,
		121,
		137,
		128,
		134,
		150,
		153,
		155,
		145,
		134,
		140,
		137,
		159,
		145,
		143,
		162,
		178,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		73,
		60,
		54,
		-1,
		95,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		145,
		129,
		134,
		-1,
		180,
		-1,
		153,
		155,
		147,
		134,
		131,
		142,
		140,
		151,
		168,
		-1,
		107,
		92,
		85,
		75,
		89,
		60,
		-1,
		111,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		161,
		141,
		135,
		134,
		175,
		173,
		161,
		145,
		138,
		135,
		134,
		147,
		167,
		158,
		170,
		-1,
		-1,
		-1,
		112,
		92,
		98,
		56,
		77,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		178,
		166,
		156,
		146,
		180,
		181,
		164,
		157,
		143,
		145,
		143,
		143,
		148,
		169,
		170,
		183,
		-1,
		-1,
		89,
		96,
		84,
		70,
		89,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		167,
		-1,
		-1,
		158,
		156,
		166,
		160,
		147,
		167,
		170,
		158,
		142,
		157,
		169,
		177,
		182,
		-1,
		92,
		79,
		-1,
		-1,
		92,
		86,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		148,
		169,
		194,
		161,
		-1,
		166,
		167,
		151,
		165,
		172,
		160,
		155,
		149,
		152,
		170,
		187,
		-1,
		-1,
		106,
		-1,
		101,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		162,
		168,
		180,
		-1,
		175,
		167,
		153,
		170,
		173,
		170,
		161,
		153,
		158,
		155,
		168,
		182,
		186,
		129,
		-1,
		112,
		-1,
		-1,
		-1,
		145,
		160,
		222,
		199,
		172,
		176,
		169,
		163,
		161,
		177,
		181,
		192,
		160,
		156,
		157,
		161,
		160,
		177,
		187,
		-1,
		-1,
		112,
		129,
		164,
		153,
		157,
		249,
		-1,
		-1,
		185,
		176,
		167,
		170,
		171,
		174,
		166,
		163,
		168,
		173,
		161,
		170,
		188,
		189,
		-1,
		-1,
		-1,
		132,
		-1,
		147,
		-1,
		-1,
		172,
		256,
		203,
		185,
		181,
		179,
		172,
		181,
		176,
		171,
		181,
		185,
		177,
		163,
		169,
		192,
		181,
		220,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		161,
		136,
		151,
		197,
		192,
		193,
		218,
		215,
		-1,
		185,
		210,
		182,
		189,
		181,
		189,
		189,
		181,
		159,
		166,
		182,
		181,
		176,
		212,
		203,
		209,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		167,
		153,
		183,
		173,
		179,
		-1,
		-1,
		226,
		223,
		207,
		191,
		190,
		183,
		178,
		188,
		168,
		155,
		159,
		163,
		169,
		174,
		179,
		185,
		200,
		215,
		-1,
		137,
		218,
		211,
		194,
		202,
		233,
		-1,
		170,
		179,
		160,
		165,
		173,
		-1,
		-1,
		199,
		195,
		200,
		198,
		195,
		198,
		193,
		184,
		169,
		175,
		162,
		161,
		179,
		183,
		192,
		199,
		189,
		202,
		206,
		-1,
		151,
		194,
		188,
		191,
		215,
		229,
		-1,
		183,
		-1,
		-1,
		168,
		186,
		194,
		190,
		194,
		247,
		212,
		207,
		192,
		190,
		181,
		172,
		179,
		170,
		170,
		173,
		188,
		193,
		185,
		199,
		199,
		200,
		-1,
		186,
		174,
		182,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		184,
		-1,
		220,
		-1,
		213,
		217,
		220,
		223,
		206,
		193,
		185,
		177,
		193,
		168,
		178,
		174,
		175,
		184,
		195,
		207,
		206,
		207,
		260,
		215,
		182,
		173,
		220,
		235,
		239,
		-1,
		196,
		235,
		222,
		-1,
		193,
		-1,
		-1,
		-1,
		227,
		233,
		225,
		226,
		205,
		205,
		179,
		183,
		173,
		180,
		190,
		192,
		184,
		188,
		201,
		212,
		215,
		256,
		254,
		259,
		204,
		187,
		205,
		214,
		235,
		211,
		202,
		229,
		229,
		218,
		213,
		200,
		-1,
		-1,
		250,
		243,
		-1,
		-1,
		212,
		200,
		183,
		184,
		180,
		183,
		198,
		201,
		191,
		189,
		183,
		215,
		-1,
		256,
		255,
		244,
		241,
		217,
		208,
		195,
		206,
		-1,
		-1,
		214,
		230,
		243,
		247,
		260,
		285,
		-1,
		203,
		-1,
		-1,
		257,
		-1,
		-1,
		242,
		205,
		194,
		185,
		191,
		188,
		199,
		209,
		197,
		198,
		188,
		198,
		211,
		240,
		237,
		225,
		223,
		246,
		203,
		199,
		-1,
		229,
		217,
		223,
		230,
		247,
		274,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		240,
		238,
		227,
		-1,
		217,
		190,
		195,
		215,
		217,
		206,
		200,
		194,
		201,
		200,
		208,
		216,
		249,
		263,
		252,
		248,
		247,
		255,
		204,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		254,
		229,
		-1,
		-1,
		235,
		228,
		216,
		204,
		194,
		204,
		208,
		212,
		204,
		197,
		192,
		203,
		195,
		199,
		216,
		-1,
		283,
		-1,
		235,
		228,
		243,
		258,
		266,
		-1,
		-1,
		-1,
		271,
		257,
		250,
		238,
		236,
		-1,
		269,
		253,
		234,
		-1,
		204,
		217,
		248,
		216,
		221,
		216,
		198,
		209,
		198,
		201,
		215,
		210,
		-1,
		-1,
		241,
		244,
		-1,
		-1,
		266,
		285,
		-1,
		262,
		251,
		236,
		228,
		-1,
		-1,
		241,
		237,
		-1,
		-1,
		205,
		230,
		219,
		227,
		222,
		202,
		208,
		211,
		200,
		204,
		216,
		-1,
		-1,
		248,
		249,
		254,
		-1,
		270,
		-1,
		286,
		-1,
		231,
		247,
		249,
		-1,
		-1,
		-1,
		243,
		206,
		227,
		237,
		231,
		229,
		220,
		206,
		213,
		211,
		207,
		218,
		-1,
		-1,
		-1,
		288,
		262,
		293,
		284,
		267,
		247,
		239,
		260,
		-1,
		230,
		-1,
		205,
		207,
		233,
		236,
		242,
		236,
		209,
		224,
		214,
		205,
		214,
		294,
		-1,
		264,
		297,
		261,
		253,
		231,
		235,
		251,
		-1,
		227,
		209,
		-1,
		237,
		227,
		258,
		243,
		224,
		211,
		218,
		218,
		211,
		-1,
		-1,
		-1,
		266,
		265,
		257,
		251,
		251,
		236,
		227,
		-1,
		239,
		221,
		200,
		217,
		217,
		208,
		216,
		248,
		244,
		231,
		231,
		223,
		-1,
		355,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		260,
		255,
		228,
		216,
		222,
		218,
		204,
		210,
		212,
		220,
		218,
		215,
		227,
		223,
		243,
		224,
		259,
		-1,
		362,
		-1,
		296,
		-1,
		-1,
		278,
		258,
		250,
		239,
		228,
		226,
		217,
		208,
		230,
		246,
		230,
		228,
		231,
		232,
		-1,
		351,
		350,
		-1,
		297,
		289,
		275,
		-1,
		268,
		-1,
		274,
		235,
		-1,
		237,
		217,
		-1,
		239,
		235,
		-1,
		-1,
		338,
		313,
		-1,
		-1,
		-1,
		298,
		278,
		269,
		253,
		-1,
		228,
		228,
		-1,
		-1,
		-1,
		323,
		322,
		-1,
		291,
		294,
		-1,
		284,
		275,
		283,
		230,
		234,
		-1,
		-1,
		-1,
		332,
		313,
		307,
		306,
		304,
		299,
		296,
		282,
		266,
		244,
		233,
		254,
		-1,
		-1,
		-1,
		304,
		296,
		289,
		-1,
		-1,
		291,
		274,
		255,
		253,
		-1,
		-1,
		-1,
		326,
		307,
		-1,
		-1,
		281,
		-1,
		-1,
		287,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		343,
		315,
		-1,
		-1,
		-1,
		277,
		273,
		274,
		-1,
		-1,
		-1,
		-1,
		337,
		338,
		361,
		325,
		-1,
		-1,
		-1,
		269,
		263,
		-1,
		-1,
		340,
		338,
		-1,
		-1,
		-1,
		297,
		281,
		-1,
		267,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		302,
		-1,
		302,
		277,
		284,
		-1,
		-1,
		-1,
		-1,
		315,
		307,
		315,
		-1,
		287,
		289,
		-1,
		337,
		-1,
		-1,
		330,
		321,
		-1,
		-1,
		292,
		299,
		321,
		324,
		360,
		-1,
		311
	],
	[
		-1,
		99,
		88,
		99,
		107,
		80,
		87,
		-1,
		108,
		110,
		76,
		70,
		109,
		80,
		86,
		97,
		-1,
		-1,
		-1,
		99,
		98,
		68,
		66,
		75,
		80,
		87,
		-1,
		110,
		-1,
		120,
		99,
		110,
		115,
		61,
		58,
		78,
		97,
		103,
		95,
		135,
		91,
		62,
		56,
		74,
		79,
		97,
		89,
		-1,
		62,
		52,
		74,
		78,
		90,
		73,
		-1,
		-1,
		56,
		57,
		63,
		75,
		80,
		85,
		-1,
		111,
		130,
		-1,
		-1,
		46,
		59,
		55,
		58,
		66,
		82,
		103,
		120,
		125,
		-1,
		-1,
		47,
		51,
		64,
		65,
		63,
		90,
		109,
		120,
		134,
		133,
		-1,
		35,
		53,
		62,
		71,
		77,
		66,
		70,
		88,
		119,
		125,
		128,
		-1,
		27,
		29,
		58,
		64,
		76,
		82,
		69,
		75,
		94,
		107,
		126,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		32,
		24,
		32,
		58,
		57,
		53,
		71,
		93,
		72,
		78,
		82,
		99,
		115,
		116,
		126,
		-1,
		-1,
		81,
		50,
		84,
		43,
		28,
		-1,
		20,
		39,
		45,
		49,
		54,
		62,
		90,
		88,
		-1,
		93,
		92,
		123,
		109,
		120,
		59,
		-1,
		-1,
		39,
		31,
		17,
		20,
		10,
		15,
		45,
		44,
		49,
		51,
		53,
		65,
		80,
		80,
		90,
		87,
		97,
		101,
		116,
		127,
		-1,
		-1,
		201,
		-1,
		-1,
		56,
		39,
		-1,
		5,
		12,
		5,
		22,
		13,
		38,
		53,
		57,
		65,
		68,
		56,
		75,
		72,
		96,
		92,
		84,
		109,
		113,
		119,
		137,
		138,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		34,
		12,
		9,
		0,
		24,
		34,
		-1,
		60,
		58,
		82,
		76,
		81,
		77,
		62,
		80,
		78,
		93,
		95,
		91,
		93,
		130,
		121,
		142,
		139,
		170,
		176,
		170,
		179,
		-1,
		64,
		60,
		56,
		63,
		12,
		-1,
		-1,
		28,
		-1,
		42,
		55,
		72,
		62,
		65,
		77,
		85,
		84,
		68,
		86,
		81,
		84,
		103,
		99,
		108,
		118,
		117,
		135,
		148,
		163,
		167,
		173,
		-1,
		114,
		-1,
		56,
		40,
		42,
		18,
		46,
		-1,
		48,
		43,
		63,
		74,
		74,
		-1,
		90,
		87,
		100,
		84,
		69,
		86,
		88,
		92,
		102,
		106,
		121,
		112,
		130,
		137,
		145,
		149,
		169,
		181,
		74,
		64,
		-1,
		46,
		51,
		21,
		33,
		69,
		86,
		70,
		-1,
		85,
		-1,
		92,
		105,
		-1,
		90,
		86,
		75,
		91,
		99,
		106,
		109,
		103,
		100,
		118,
		121,
		138,
		142,
		158,
		-1,
		-1,
		59,
		63,
		84,
		27,
		54,
		78,
		115,
		79,
		88,
		90,
		-1,
		110,
		111,
		108,
		109,
		95,
		88,
		89,
		105,
		111,
		107,
		102,
		105,
		127,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		84,
		-1,
		-1,
		61,
		32,
		56,
		98,
		118,
		111,
		99,
		119,
		119,
		115,
		-1,
		126,
		105,
		102,
		93,
		101,
		115,
		112,
		126,
		106,
		108,
		124,
		136,
		127,
		147,
		-1,
		-1,
		-1,
		91,
		80,
		81,
		35,
		69,
		87,
		152,
		138,
		143,
		118,
		113,
		107,
		120,
		122,
		117,
		111,
		103,
		92,
		108,
		116,
		118,
		108,
		117,
		118,
		142,
		149,
		155,
		-1,
		-1,
		98,
		88,
		72,
		74,
		71,
		60,
		67,
		99,
		143,
		142,
		-1,
		112,
		-1,
		101,
		109,
		108,
		111,
		108,
		105,
		99,
		108,
		122,
		122,
		113,
		128,
		147,
		147,
		139,
		164,
		167,
		-1,
		-1,
		-1,
		91,
		108,
		83,
		60,
		41,
		77,
		-1,
		112,
		113,
		-1,
		106,
		100,
		106,
		105,
		112,
		109,
		109,
		106,
		113,
		109,
		123,
		132,
		114,
		150,
		-1,
		147,
		141,
		169,
		163,
		151,
		-1,
		-1,
		-1,
		106,
		85,
		78,
		98,
		48,
		100,
		-1,
		-1,
		97,
		90,
		-1,
		93,
		93,
		100,
		109,
		110,
		114,
		118,
		107,
		120,
		125,
		119,
		129,
		149,
		153,
		160,
		153,
		149,
		146,
		160,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		51,
		68,
		-1,
		105,
		97,
		88,
		82,
		88,
		106,
		104,
		124,
		116,
		125,
		125,
		121,
		129,
		114,
		117,
		122,
		126,
		144,
		159,
		151,
		145,
		144,
		156,
		-1,
		154,
		140,
		111,
		-1,
		-1,
		83,
		-1,
		54,
		78,
		94,
		-1,
		122,
		101,
		124,
		102,
		116,
		112,
		145,
		146,
		124,
		129,
		128,
		138,
		139,
		128,
		134,
		133,
		153,
		155,
		139,
		140,
		149,
		-1,
		160,
		147,
		105,
		101,
		90,
		110,
		57,
		70,
		81,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		126,
		124,
		135,
		126,
		132,
		139,
		142,
		143,
		133,
		122,
		128,
		127,
		149,
		135,
		133,
		152,
		168,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		76,
		63,
		57,
		-1,
		98,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		143,
		127,
		132,
		-1,
		168,
		-1,
		141,
		143,
		135,
		124,
		121,
		132,
		130,
		141,
		158,
		-1,
		110,
		95,
		88,
		78,
		92,
		63,
		-1,
		114,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		159,
		139,
		133,
		132,
		163,
		161,
		149,
		133,
		126,
		123,
		124,
		137,
		157,
		148,
		160,
		-1,
		-1,
		-1,
		115,
		95,
		101,
		59,
		80,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		176,
		164,
		154,
		144,
		178,
		177,
		152,
		145,
		131,
		133,
		131,
		133,
		138,
		159,
		160,
		173,
		-1,
		-1,
		92,
		99,
		87,
		73,
		92,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		165,
		-1,
		-1,
		156,
		154,
		164,
		148,
		135,
		155,
		158,
		148,
		132,
		147,
		159,
		167,
		172,
		-1,
		95,
		82,
		-1,
		-1,
		95,
		89,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		151,
		172,
		193,
		159,
		-1,
		164,
		159,
		139,
		153,
		160,
		150,
		145,
		139,
		142,
		160,
		177,
		-1,
		-1,
		109,
		-1,
		104,
		-1,
		-1,
		-1,
		-1,
		130,
		144,
		165,
		171,
		179,
		-1,
		167,
		155,
		141,
		158,
		163,
		160,
		151,
		143,
		148,
		145,
		158,
		172,
		176,
		132,
		-1,
		115,
		-1,
		-1,
		-1,
		148,
		163,
		221,
		198,
		171,
		166,
		159,
		153,
		149,
		165,
		171,
		182,
		150,
		146,
		147,
		151,
		150,
		167,
		177,
		-1,
		-1,
		115,
		132,
		167,
		156,
		160,
		248,
		-1,
		-1,
		175,
		166,
		157,
		160,
		159,
		162,
		156,
		153,
		158,
		163,
		151,
		160,
		178,
		177,
		-1,
		-1,
		-1,
		135,
		-1,
		150,
		-1,
		-1,
		175,
		246,
		193,
		175,
		171,
		169,
		162,
		171,
		166,
		161,
		171,
		173,
		165,
		153,
		157,
		180,
		169,
		208,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		164,
		139,
		154,
		200,
		195,
		196,
		208,
		205,
		-1,
		175,
		200,
		172,
		179,
		170,
		177,
		177,
		169,
		147,
		154,
		170,
		169,
		164,
		200,
		191,
		197,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		170,
		156,
		186,
		176,
		182,
		-1,
		-1,
		224,
		221,
		197,
		180,
		178,
		171,
		166,
		176,
		156,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		140,
		221,
		214,
		197,
		205,
		236,
		-1,
		173,
		182,
		163,
		168,
		176,
		-1,
		-1,
		197,
		194,
		199,
		187,
		184,
		186,
		181,
		172,
		157,
		163,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		154,
		197,
		191,
		194,
		218,
		232,
		-1,
		186,
		-1,
		-1,
		171,
		189,
		197,
		193,
		196,
		246,
		201,
		196,
		180,
		178,
		169,
		160,
		167,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		189,
		177,
		185,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		187,
		-1,
		223,
		-1,
		214,
		218,
		209,
		212,
		194,
		181,
		173,
		165,
		181,
		156,
		166,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		263,
		218,
		185,
		176,
		223,
		238,
		242,
		-1,
		199,
		238,
		225,
		-1,
		196,
		-1,
		-1,
		-1,
		228,
		222,
		214,
		214,
		193,
		193,
		167,
		171,
		161,
		168,
		178,
		180,
		172,
		176,
		189,
		200,
		203,
		259,
		257,
		262,
		207,
		190,
		208,
		217,
		238,
		214,
		205,
		232,
		232,
		221,
		216,
		203,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		200,
		188,
		171,
		172,
		168,
		171,
		186,
		189,
		179,
		177,
		171,
		203,
		-1,
		259,
		258,
		247,
		244,
		220,
		211,
		198,
		209,
		-1,
		-1,
		217,
		233,
		246,
		250,
		263,
		288,
		-1,
		206,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		176,
		187,
		197,
		185,
		186,
		176,
		186,
		199,
		243,
		240,
		228,
		226,
		249,
		206,
		202,
		-1,
		232,
		220,
		226,
		233,
		250,
		277,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		178,
		183,
		203,
		205,
		194,
		188,
		182,
		189,
		188,
		196,
		204,
		252,
		266,
		255,
		251,
		250,
		258,
		207,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		257,
		232,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		196,
		200,
		192,
		185,
		180,
		191,
		183,
		187,
		204,
		-1,
		286,
		-1,
		238,
		231,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		274,
		260,
		253,
		241,
		239,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		186,
		197,
		186,
		189,
		203,
		198,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		269,
		275,
		-1,
		265,
		254,
		239,
		231,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		190,
		196,
		199,
		188,
		192,
		204,
		-1,
		-1,
		251,
		252,
		257,
		-1,
		258,
		-1,
		276,
		-1,
		234,
		249,
		237,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		219,
		217,
		208,
		194,
		201,
		199,
		195,
		206,
		-1,
		-1,
		-1,
		276,
		250,
		283,
		274,
		257,
		237,
		229,
		248,
		-1,
		218,
		-1,
		193,
		195,
		221,
		224,
		230,
		224,
		197,
		212,
		202,
		193,
		202,
		282,
		-1,
		252,
		285,
		249,
		243,
		219,
		223,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		246,
		231,
		212,
		199,
		206,
		206,
		199,
		-1,
		-1,
		-1,
		254,
		253,
		245,
		239,
		239,
		224,
		215,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		236,
		232,
		219,
		219,
		211,
		-1,
		355,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		248,
		243,
		216,
		204,
		210,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		212,
		247,
		-1,
		350,
		-1,
		284,
		-1,
		-1,
		266,
		246,
		238,
		227,
		216,
		214,
		205,
		196,
		218,
		234,
		218,
		216,
		219,
		220,
		-1,
		339,
		338,
		-1,
		285,
		277,
		263,
		-1,
		256,
		-1,
		262,
		223,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		326,
		301,
		-1,
		-1,
		-1,
		286,
		266,
		257,
		241,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		311,
		310,
		-1,
		279,
		282,
		-1,
		272,
		263,
		271,
		218,
		222,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		294,
		292,
		287,
		284,
		270,
		254,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		292,
		284,
		277,
		-1,
		-1,
		279,
		262,
		243,
		241,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		303,
		-1,
		-1,
		-1,
		265,
		261,
		262,
		-1,
		-1,
		-1,
		-1,
		325,
		326,
		349,
		313,
		-1,
		-1,
		-1,
		257,
		251,
		-1,
		-1,
		328,
		326,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		255,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		290,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		280,
		287,
		309,
		312,
		348,
		-1,
		299
	],
	[
		-1,
		129,
		118,
		129,
		137,
		110,
		117,
		-1,
		138,
		140,
		106,
		100,
		139,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		129,
		128,
		98,
		96,
		105,
		110,
		117,
		-1,
		140,
		-1,
		150,
		129,
		140,
		145,
		91,
		88,
		108,
		127,
		133,
		125,
		165,
		121,
		92,
		86,
		104,
		109,
		127,
		119,
		-1,
		92,
		82,
		104,
		108,
		120,
		103,
		-1,
		-1,
		86,
		87,
		93,
		105,
		110,
		115,
		-1,
		141,
		160,
		-1,
		-1,
		76,
		89,
		85,
		88,
		96,
		112,
		133,
		150,
		155,
		-1,
		-1,
		77,
		81,
		94,
		95,
		93,
		120,
		139,
		150,
		164,
		163,
		-1,
		65,
		83,
		92,
		101,
		107,
		96,
		100,
		118,
		149,
		155,
		158,
		-1,
		57,
		59,
		88,
		94,
		106,
		112,
		99,
		105,
		124,
		137,
		156,
		147,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		54,
		62,
		88,
		87,
		83,
		101,
		123,
		102,
		108,
		112,
		129,
		145,
		146,
		156,
		-1,
		-1,
		111,
		80,
		114,
		73,
		58,
		-1,
		50,
		69,
		75,
		79,
		84,
		92,
		120,
		118,
		-1,
		123,
		122,
		153,
		139,
		150,
		89,
		-1,
		-1,
		69,
		61,
		47,
		50,
		40,
		45,
		75,
		74,
		79,
		81,
		83,
		95,
		110,
		110,
		120,
		117,
		127,
		131,
		146,
		157,
		-1,
		-1,
		231,
		-1,
		-1,
		86,
		69,
		-1,
		35,
		42,
		35,
		52,
		43,
		68,
		83,
		87,
		95,
		98,
		86,
		105,
		102,
		126,
		122,
		114,
		139,
		143,
		149,
		167,
		168,
		-1,
		230,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		42,
		39,
		30,
		0,
		64,
		-1,
		90,
		88,
		112,
		106,
		111,
		107,
		92,
		110,
		108,
		123,
		125,
		121,
		123,
		160,
		151,
		172,
		169,
		200,
		206,
		200,
		209,
		-1,
		94,
		90,
		86,
		93,
		42,
		-1,
		-1,
		4,
		-1,
		56,
		85,
		102,
		92,
		95,
		107,
		115,
		114,
		98,
		116,
		111,
		114,
		133,
		129,
		138,
		148,
		147,
		165,
		178,
		193,
		197,
		203,
		-1,
		144,
		-1,
		86,
		70,
		72,
		48,
		76,
		-1,
		24,
		55,
		93,
		104,
		104,
		-1,
		120,
		117,
		130,
		114,
		99,
		116,
		118,
		122,
		132,
		136,
		151,
		142,
		160,
		167,
		175,
		179,
		199,
		211,
		104,
		94,
		-1,
		76,
		81,
		51,
		63,
		99,
		87,
		71,
		-1,
		110,
		-1,
		122,
		135,
		-1,
		120,
		116,
		105,
		121,
		129,
		136,
		139,
		133,
		130,
		148,
		151,
		168,
		172,
		188,
		-1,
		-1,
		89,
		93,
		114,
		57,
		84,
		108,
		126,
		80,
		89,
		91,
		-1,
		140,
		141,
		138,
		139,
		125,
		118,
		119,
		135,
		141,
		137,
		132,
		135,
		157,
		185,
		163,
		175,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		91,
		62,
		86,
		128,
		119,
		112,
		100,
		125,
		125,
		132,
		-1,
		156,
		135,
		132,
		123,
		131,
		145,
		142,
		156,
		136,
		138,
		154,
		166,
		157,
		177,
		-1,
		-1,
		-1,
		121,
		110,
		111,
		65,
		99,
		117,
		158,
		144,
		149,
		124,
		130,
		135,
		150,
		152,
		147,
		141,
		133,
		122,
		138,
		146,
		148,
		138,
		147,
		148,
		172,
		179,
		185,
		-1,
		-1,
		128,
		118,
		102,
		104,
		101,
		90,
		97,
		129,
		149,
		172,
		-1,
		142,
		-1,
		131,
		139,
		138,
		141,
		138,
		135,
		129,
		138,
		152,
		152,
		143,
		158,
		177,
		177,
		169,
		194,
		197,
		-1,
		-1,
		-1,
		121,
		138,
		113,
		90,
		71,
		107,
		-1,
		142,
		143,
		-1,
		136,
		130,
		136,
		135,
		142,
		139,
		139,
		136,
		143,
		139,
		153,
		162,
		144,
		180,
		-1,
		177,
		171,
		199,
		193,
		181,
		-1,
		-1,
		-1,
		136,
		115,
		108,
		128,
		78,
		130,
		-1,
		-1,
		127,
		120,
		-1,
		123,
		123,
		130,
		139,
		140,
		144,
		148,
		137,
		150,
		155,
		149,
		159,
		179,
		183,
		190,
		183,
		179,
		176,
		190,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		98,
		-1,
		135,
		127,
		118,
		112,
		118,
		136,
		134,
		154,
		146,
		155,
		155,
		151,
		159,
		144,
		147,
		152,
		156,
		174,
		189,
		181,
		175,
		174,
		186,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		113,
		-1,
		84,
		108,
		124,
		-1,
		152,
		131,
		154,
		132,
		146,
		142,
		175,
		176,
		154,
		159,
		158,
		168,
		169,
		158,
		164,
		163,
		183,
		185,
		169,
		170,
		179,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		87,
		100,
		111,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		156,
		154,
		165,
		156,
		162,
		169,
		172,
		173,
		163,
		152,
		158,
		157,
		179,
		165,
		163,
		182,
		198,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		173,
		157,
		162,
		-1,
		198,
		-1,
		171,
		173,
		165,
		154,
		151,
		162,
		160,
		171,
		188,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		144,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		189,
		169,
		163,
		162,
		193,
		191,
		179,
		163,
		156,
		153,
		154,
		167,
		187,
		178,
		190,
		-1,
		-1,
		-1,
		145,
		125,
		131,
		89,
		110,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		148,
		206,
		194,
		184,
		174,
		208,
		207,
		182,
		175,
		161,
		163,
		161,
		163,
		168,
		189,
		190,
		203,
		-1,
		-1,
		122,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		170,
		186,
		178,
		149,
		195,
		-1,
		-1,
		186,
		184,
		194,
		178,
		165,
		185,
		188,
		178,
		162,
		177,
		189,
		197,
		202,
		-1,
		125,
		112,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		181,
		202,
		223,
		189,
		-1,
		194,
		189,
		169,
		183,
		190,
		180,
		175,
		169,
		172,
		190,
		207,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		160,
		174,
		195,
		201,
		209,
		-1,
		197,
		185,
		171,
		188,
		193,
		190,
		181,
		173,
		178,
		175,
		188,
		202,
		206,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		178,
		193,
		251,
		228,
		201,
		196,
		189,
		183,
		179,
		195,
		201,
		212,
		180,
		176,
		177,
		181,
		180,
		197,
		207,
		-1,
		-1,
		145,
		162,
		197,
		186,
		190,
		278,
		-1,
		-1,
		205,
		196,
		187,
		190,
		189,
		192,
		186,
		183,
		188,
		193,
		181,
		190,
		208,
		207,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		205,
		276,
		223,
		205,
		201,
		199,
		192,
		201,
		196,
		191,
		201,
		203,
		195,
		183,
		187,
		210,
		199,
		238,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		194,
		169,
		184,
		230,
		225,
		226,
		238,
		235,
		-1,
		205,
		230,
		202,
		209,
		200,
		207,
		207,
		199,
		177,
		184,
		200,
		199,
		194,
		230,
		221,
		227,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		200,
		186,
		216,
		206,
		212,
		-1,
		-1,
		254,
		251,
		227,
		210,
		208,
		201,
		196,
		206,
		186,
		173,
		177,
		181,
		187,
		192,
		197,
		203,
		218,
		233,
		-1,
		170,
		251,
		244,
		227,
		235,
		266,
		-1,
		203,
		212,
		193,
		198,
		206,
		-1,
		-1,
		227,
		224,
		229,
		217,
		214,
		216,
		211,
		202,
		187,
		193,
		180,
		179,
		197,
		201,
		210,
		217,
		207,
		220,
		224,
		-1,
		184,
		227,
		221,
		224,
		248,
		262,
		-1,
		216,
		-1,
		-1,
		201,
		219,
		227,
		223,
		226,
		276,
		231,
		226,
		210,
		208,
		199,
		190,
		197,
		188,
		188,
		191,
		206,
		211,
		203,
		217,
		217,
		218,
		-1,
		219,
		207,
		215,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		217,
		-1,
		253,
		-1,
		244,
		248,
		239,
		242,
		224,
		211,
		203,
		195,
		211,
		186,
		196,
		192,
		193,
		202,
		213,
		225,
		224,
		225,
		293,
		248,
		215,
		206,
		253,
		268,
		272,
		-1,
		229,
		268,
		255,
		-1,
		226,
		-1,
		-1,
		-1,
		258,
		252,
		244,
		244,
		223,
		223,
		197,
		201,
		191,
		198,
		208,
		210,
		202,
		206,
		219,
		230,
		233,
		289,
		287,
		292,
		237,
		220,
		238,
		247,
		268,
		244,
		235,
		262,
		262,
		251,
		246,
		233,
		-1,
		-1,
		281,
		262,
		-1,
		-1,
		230,
		218,
		201,
		202,
		198,
		201,
		216,
		219,
		209,
		207,
		201,
		233,
		-1,
		289,
		288,
		277,
		274,
		250,
		241,
		228,
		239,
		-1,
		-1,
		247,
		263,
		276,
		280,
		293,
		318,
		-1,
		236,
		-1,
		-1,
		275,
		-1,
		-1,
		260,
		223,
		212,
		203,
		209,
		206,
		217,
		227,
		215,
		216,
		206,
		216,
		229,
		273,
		270,
		258,
		256,
		279,
		236,
		232,
		-1,
		262,
		250,
		256,
		263,
		280,
		307,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		258,
		256,
		245,
		-1,
		235,
		208,
		213,
		233,
		235,
		224,
		218,
		212,
		219,
		218,
		226,
		234,
		282,
		296,
		285,
		281,
		280,
		288,
		237,
		254,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		-1,
		287,
		262,
		-1,
		-1,
		253,
		246,
		234,
		222,
		212,
		222,
		226,
		230,
		222,
		215,
		210,
		221,
		213,
		217,
		234,
		-1,
		316,
		-1,
		268,
		261,
		276,
		291,
		299,
		-1,
		-1,
		-1,
		304,
		290,
		283,
		271,
		269,
		-1,
		287,
		271,
		252,
		-1,
		222,
		235,
		266,
		234,
		239,
		234,
		216,
		227,
		216,
		219,
		233,
		228,
		-1,
		-1,
		274,
		277,
		-1,
		-1,
		299,
		305,
		-1,
		295,
		284,
		269,
		261,
		-1,
		-1,
		259,
		255,
		-1,
		-1,
		223,
		248,
		237,
		245,
		240,
		220,
		226,
		229,
		218,
		222,
		234,
		-1,
		-1,
		281,
		282,
		287,
		-1,
		288,
		-1,
		306,
		-1,
		264,
		279,
		267,
		-1,
		-1,
		-1,
		261,
		224,
		245,
		255,
		249,
		247,
		238,
		224,
		231,
		229,
		225,
		236,
		-1,
		-1,
		-1,
		306,
		280,
		313,
		304,
		287,
		267,
		259,
		278,
		-1,
		248,
		-1,
		223,
		225,
		251,
		254,
		260,
		254,
		227,
		242,
		232,
		223,
		232,
		312,
		-1,
		282,
		315,
		279,
		273,
		249,
		253,
		269,
		-1,
		245,
		227,
		-1,
		255,
		245,
		276,
		261,
		242,
		229,
		236,
		236,
		229,
		-1,
		-1,
		-1,
		284,
		283,
		275,
		269,
		269,
		254,
		245,
		-1,
		257,
		239,
		218,
		235,
		235,
		226,
		234,
		266,
		262,
		249,
		249,
		241,
		-1,
		385,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		278,
		273,
		246,
		234,
		240,
		236,
		222,
		228,
		230,
		238,
		236,
		233,
		245,
		241,
		261,
		242,
		277,
		-1,
		380,
		-1,
		314,
		-1,
		-1,
		296,
		276,
		268,
		257,
		246,
		244,
		235,
		226,
		248,
		264,
		248,
		246,
		249,
		250,
		-1,
		369,
		368,
		-1,
		315,
		307,
		293,
		-1,
		286,
		-1,
		292,
		253,
		-1,
		255,
		235,
		-1,
		257,
		253,
		-1,
		-1,
		356,
		331,
		-1,
		-1,
		-1,
		316,
		296,
		287,
		271,
		-1,
		246,
		246,
		-1,
		-1,
		-1,
		341,
		340,
		-1,
		309,
		312,
		-1,
		302,
		293,
		301,
		248,
		252,
		-1,
		-1,
		-1,
		350,
		331,
		325,
		324,
		322,
		317,
		314,
		300,
		284,
		262,
		251,
		272,
		-1,
		-1,
		-1,
		322,
		314,
		307,
		-1,
		-1,
		309,
		292,
		273,
		271,
		-1,
		-1,
		-1,
		344,
		325,
		-1,
		-1,
		299,
		-1,
		-1,
		305,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		361,
		333,
		-1,
		-1,
		-1,
		295,
		291,
		292,
		-1,
		-1,
		-1,
		-1,
		355,
		356,
		379,
		343,
		-1,
		-1,
		-1,
		287,
		281,
		-1,
		-1,
		358,
		356,
		-1,
		-1,
		-1,
		315,
		299,
		-1,
		285,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		318,
		-1,
		-1,
		-1,
		320,
		-1,
		320,
		295,
		302,
		-1,
		-1,
		-1,
		-1,
		333,
		325,
		333,
		-1,
		305,
		307,
		-1,
		355,
		-1,
		-1,
		348,
		339,
		-1,
		-1,
		310,
		317,
		339,
		342,
		378,
		-1,
		329
	],
	[
		-1,
		133,
		122,
		133,
		141,
		114,
		121,
		-1,
		142,
		144,
		110,
		104,
		143,
		114,
		120,
		131,
		-1,
		-1,
		-1,
		133,
		132,
		102,
		100,
		109,
		114,
		121,
		-1,
		144,
		-1,
		154,
		133,
		144,
		149,
		95,
		92,
		112,
		131,
		137,
		129,
		169,
		125,
		96,
		90,
		108,
		113,
		131,
		123,
		-1,
		96,
		86,
		108,
		112,
		124,
		107,
		-1,
		-1,
		90,
		91,
		97,
		109,
		114,
		119,
		-1,
		145,
		164,
		-1,
		-1,
		80,
		93,
		89,
		92,
		100,
		116,
		137,
		154,
		159,
		-1,
		-1,
		81,
		85,
		98,
		99,
		97,
		124,
		143,
		154,
		168,
		167,
		-1,
		69,
		87,
		96,
		105,
		111,
		100,
		104,
		122,
		153,
		159,
		162,
		-1,
		61,
		63,
		92,
		98,
		110,
		116,
		103,
		109,
		128,
		141,
		160,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		58,
		66,
		92,
		91,
		87,
		105,
		127,
		106,
		112,
		116,
		133,
		149,
		150,
		160,
		-1,
		-1,
		121,
		94,
		118,
		77,
		64,
		-1,
		54,
		73,
		79,
		83,
		88,
		96,
		124,
		122,
		-1,
		127,
		126,
		157,
		143,
		154,
		103,
		-1,
		-1,
		79,
		71,
		53,
		56,
		44,
		49,
		79,
		78,
		83,
		85,
		87,
		99,
		114,
		114,
		124,
		121,
		131,
		135,
		150,
		161,
		-1,
		-1,
		235,
		-1,
		-1,
		100,
		83,
		-1,
		48,
		55,
		39,
		56,
		47,
		72,
		87,
		91,
		99,
		102,
		90,
		109,
		106,
		130,
		126,
		118,
		143,
		147,
		153,
		171,
		172,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		55,
		52,
		45,
		69,
		0,
		-1,
		71,
		77,
		101,
		104,
		115,
		111,
		96,
		114,
		112,
		127,
		129,
		125,
		127,
		164,
		155,
		176,
		173,
		204,
		210,
		204,
		213,
		-1,
		108,
		104,
		100,
		107,
		56,
		-1,
		-1,
		73,
		-1,
		32,
		39,
		61,
		81,
		84,
		105,
		105,
		118,
		102,
		120,
		115,
		118,
		137,
		133,
		142,
		152,
		151,
		169,
		182,
		197,
		201,
		207,
		-1,
		158,
		-1,
		100,
		84,
		86,
		62,
		90,
		-1,
		93,
		33,
		47,
		65,
		65,
		-1,
		109,
		106,
		120,
		118,
		103,
		120,
		122,
		126,
		136,
		140,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		118,
		108,
		-1,
		90,
		95,
		65,
		77,
		113,
		76,
		60,
		-1,
		76,
		-1,
		111,
		124,
		-1,
		124,
		120,
		109,
		125,
		133,
		140,
		143,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		103,
		107,
		128,
		71,
		98,
		122,
		115,
		69,
		78,
		80,
		-1,
		129,
		145,
		142,
		143,
		129,
		122,
		123,
		139,
		145,
		141,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		105,
		76,
		100,
		129,
		108,
		101,
		89,
		110,
		110,
		117,
		-1,
		160,
		139,
		136,
		127,
		135,
		149,
		146,
		160,
		140,
		142,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		79,
		113,
		131,
		143,
		129,
		134,
		109,
		115,
		120,
		154,
		156,
		151,
		145,
		137,
		126,
		142,
		150,
		152,
		142,
		151,
		152,
		176,
		183,
		189,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		104,
		111,
		143,
		134,
		186,
		-1,
		153,
		-1,
		126,
		153,
		150,
		145,
		142,
		139,
		133,
		142,
		156,
		156,
		147,
		162,
		181,
		181,
		173,
		198,
		201,
		-1,
		-1,
		-1,
		135,
		152,
		127,
		104,
		85,
		121,
		-1,
		156,
		157,
		-1,
		147,
		141,
		150,
		149,
		148,
		143,
		147,
		140,
		147,
		143,
		157,
		166,
		148,
		184,
		-1,
		181,
		175,
		203,
		197,
		185,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		92,
		144,
		-1,
		-1,
		141,
		134,
		-1,
		137,
		137,
		144,
		150,
		144,
		148,
		152,
		141,
		154,
		159,
		153,
		163,
		183,
		187,
		194,
		187,
		183,
		180,
		194,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		112,
		-1,
		149,
		141,
		132,
		126,
		132,
		150,
		148,
		168,
		156,
		159,
		159,
		155,
		163,
		148,
		151,
		156,
		160,
		178,
		193,
		185,
		179,
		178,
		190,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		127,
		-1,
		98,
		122,
		138,
		-1,
		166,
		145,
		168,
		146,
		160,
		156,
		179,
		180,
		158,
		163,
		162,
		172,
		173,
		162,
		168,
		167,
		187,
		189,
		173,
		174,
		183,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		101,
		114,
		125,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		170,
		168,
		169,
		160,
		166,
		173,
		176,
		177,
		167,
		156,
		162,
		161,
		183,
		169,
		167,
		186,
		202,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		177,
		161,
		166,
		-1,
		202,
		-1,
		175,
		177,
		169,
		158,
		155,
		166,
		164,
		175,
		192,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		158,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		193,
		173,
		167,
		166,
		197,
		195,
		183,
		167,
		160,
		157,
		158,
		171,
		191,
		182,
		194,
		-1,
		-1,
		-1,
		159,
		139,
		145,
		103,
		124,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		162,
		210,
		198,
		188,
		178,
		212,
		211,
		186,
		179,
		165,
		167,
		165,
		167,
		172,
		193,
		194,
		207,
		-1,
		-1,
		136,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		184,
		200,
		192,
		163,
		199,
		-1,
		-1,
		190,
		188,
		198,
		182,
		169,
		189,
		192,
		182,
		166,
		181,
		193,
		201,
		206,
		-1,
		139,
		126,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		217,
		183,
		195,
		216,
		227,
		193,
		-1,
		198,
		193,
		173,
		187,
		194,
		184,
		179,
		173,
		176,
		194,
		211,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		174,
		188,
		209,
		209,
		213,
		-1,
		201,
		189,
		175,
		192,
		197,
		194,
		185,
		177,
		182,
		179,
		192,
		206,
		210,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		192,
		207,
		255,
		232,
		205,
		200,
		193,
		187,
		183,
		199,
		205,
		216,
		184,
		180,
		181,
		185,
		184,
		201,
		211,
		-1,
		-1,
		159,
		176,
		211,
		200,
		204,
		282,
		-1,
		-1,
		209,
		200,
		191,
		194,
		193,
		196,
		190,
		187,
		192,
		197,
		185,
		194,
		212,
		211,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		219,
		280,
		227,
		209,
		205,
		203,
		196,
		205,
		200,
		195,
		205,
		207,
		199,
		187,
		191,
		214,
		203,
		242,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		244,
		239,
		240,
		242,
		239,
		-1,
		209,
		234,
		206,
		213,
		204,
		211,
		211,
		203,
		181,
		188,
		204,
		203,
		198,
		234,
		225,
		231,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		214,
		200,
		230,
		220,
		226,
		-1,
		-1,
		258,
		255,
		231,
		214,
		212,
		205,
		200,
		210,
		190,
		177,
		181,
		185,
		191,
		196,
		201,
		207,
		222,
		237,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		217,
		226,
		207,
		212,
		220,
		-1,
		-1,
		231,
		228,
		233,
		221,
		218,
		220,
		215,
		206,
		191,
		197,
		184,
		183,
		201,
		205,
		214,
		221,
		211,
		224,
		228,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		230,
		-1,
		-1,
		215,
		233,
		241,
		236,
		230,
		280,
		235,
		230,
		214,
		212,
		203,
		194,
		201,
		192,
		192,
		195,
		210,
		215,
		207,
		221,
		221,
		222,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		231,
		-1,
		267,
		-1,
		248,
		252,
		243,
		246,
		228,
		215,
		207,
		199,
		215,
		190,
		200,
		196,
		197,
		206,
		217,
		229,
		228,
		229,
		307,
		262,
		229,
		220,
		267,
		282,
		286,
		-1,
		243,
		282,
		269,
		-1,
		240,
		-1,
		-1,
		-1,
		262,
		256,
		248,
		248,
		227,
		227,
		201,
		205,
		195,
		202,
		212,
		214,
		206,
		210,
		223,
		234,
		237,
		303,
		301,
		306,
		251,
		234,
		252,
		261,
		282,
		258,
		249,
		276,
		276,
		265,
		260,
		247,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		234,
		222,
		205,
		206,
		202,
		205,
		220,
		223,
		213,
		211,
		205,
		237,
		-1,
		303,
		302,
		291,
		288,
		264,
		255,
		242,
		253,
		-1,
		-1,
		261,
		277,
		290,
		294,
		307,
		332,
		-1,
		250,
		-1,
		-1,
		279,
		-1,
		-1,
		264,
		227,
		216,
		207,
		213,
		210,
		221,
		231,
		219,
		220,
		210,
		220,
		233,
		287,
		284,
		272,
		270,
		293,
		250,
		246,
		-1,
		276,
		264,
		270,
		277,
		294,
		321,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		262,
		260,
		249,
		-1,
		239,
		212,
		217,
		237,
		239,
		228,
		222,
		216,
		223,
		222,
		230,
		238,
		296,
		310,
		299,
		295,
		294,
		302,
		251,
		268,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		-1,
		300,
		276,
		-1,
		-1,
		257,
		250,
		238,
		226,
		216,
		226,
		230,
		234,
		226,
		219,
		214,
		225,
		217,
		221,
		238,
		-1,
		330,
		-1,
		282,
		275,
		290,
		305,
		313,
		-1,
		-1,
		-1,
		317,
		303,
		296,
		284,
		282,
		-1,
		291,
		275,
		256,
		-1,
		226,
		239,
		270,
		238,
		243,
		238,
		220,
		231,
		220,
		223,
		237,
		232,
		-1,
		-1,
		288,
		291,
		-1,
		-1,
		307,
		309,
		-1,
		308,
		297,
		282,
		274,
		-1,
		-1,
		263,
		259,
		-1,
		-1,
		227,
		252,
		241,
		249,
		244,
		224,
		230,
		233,
		222,
		226,
		238,
		-1,
		-1,
		295,
		296,
		301,
		-1,
		292,
		-1,
		310,
		-1,
		277,
		283,
		271,
		-1,
		-1,
		-1,
		265,
		228,
		249,
		259,
		253,
		251,
		242,
		228,
		235,
		233,
		229,
		240,
		-1,
		-1,
		-1,
		310,
		284,
		317,
		308,
		291,
		271,
		263,
		282,
		-1,
		252,
		-1,
		227,
		229,
		255,
		258,
		264,
		258,
		231,
		246,
		236,
		227,
		236,
		316,
		-1,
		286,
		319,
		283,
		277,
		253,
		257,
		273,
		-1,
		249,
		231,
		-1,
		259,
		249,
		280,
		265,
		246,
		233,
		240,
		240,
		233,
		-1,
		-1,
		-1,
		288,
		287,
		279,
		273,
		273,
		258,
		249,
		-1,
		261,
		243,
		222,
		239,
		239,
		230,
		238,
		270,
		266,
		253,
		253,
		245,
		-1,
		389,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		282,
		277,
		250,
		238,
		244,
		240,
		226,
		232,
		234,
		242,
		240,
		237,
		249,
		245,
		265,
		246,
		281,
		-1,
		384,
		-1,
		318,
		-1,
		-1,
		300,
		280,
		272,
		261,
		250,
		248,
		239,
		230,
		252,
		268,
		252,
		250,
		253,
		254,
		-1,
		373,
		372,
		-1,
		319,
		311,
		297,
		-1,
		290,
		-1,
		296,
		257,
		-1,
		259,
		239,
		-1,
		261,
		257,
		-1,
		-1,
		360,
		335,
		-1,
		-1,
		-1,
		320,
		300,
		291,
		275,
		-1,
		250,
		250,
		-1,
		-1,
		-1,
		345,
		344,
		-1,
		313,
		316,
		-1,
		306,
		297,
		305,
		252,
		256,
		-1,
		-1,
		-1,
		354,
		335,
		329,
		328,
		326,
		321,
		318,
		304,
		288,
		266,
		255,
		276,
		-1,
		-1,
		-1,
		326,
		318,
		311,
		-1,
		-1,
		313,
		296,
		277,
		275,
		-1,
		-1,
		-1,
		348,
		329,
		-1,
		-1,
		303,
		-1,
		-1,
		309,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		365,
		337,
		-1,
		-1,
		-1,
		299,
		295,
		296,
		-1,
		-1,
		-1,
		-1,
		359,
		360,
		383,
		347,
		-1,
		-1,
		-1,
		291,
		285,
		-1,
		-1,
		362,
		360,
		-1,
		-1,
		-1,
		319,
		303,
		-1,
		289,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		322,
		-1,
		-1,
		-1,
		324,
		-1,
		324,
		299,
		306,
		-1,
		-1,
		-1,
		-1,
		337,
		329,
		337,
		-1,
		309,
		311,
		-1,
		359,
		-1,
		-1,
		352,
		343,
		-1,
		-1,
		314,
		321,
		343,
		346,
		382,
		-1,
		333
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		137,
		139,
		105,
		99,
		138,
		109,
		115,
		126,
		-1,
		-1,
		-1,
		128,
		127,
		97,
		95,
		104,
		109,
		116,
		-1,
		139,
		-1,
		149,
		128,
		139,
		144,
		90,
		87,
		107,
		126,
		132,
		124,
		164,
		120,
		91,
		85,
		103,
		108,
		126,
		118,
		-1,
		91,
		81,
		103,
		107,
		119,
		102,
		-1,
		-1,
		85,
		86,
		92,
		104,
		109,
		114,
		-1,
		140,
		156,
		-1,
		-1,
		75,
		88,
		84,
		87,
		95,
		111,
		132,
		149,
		151,
		-1,
		-1,
		76,
		80,
		93,
		94,
		92,
		119,
		138,
		146,
		160,
		159,
		-1,
		64,
		82,
		91,
		100,
		106,
		95,
		99,
		117,
		145,
		151,
		154,
		-1,
		56,
		58,
		83,
		91,
		96,
		103,
		98,
		104,
		123,
		133,
		152,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		53,
		61,
		83,
		75,
		71,
		84,
		101,
		101,
		107,
		111,
		125,
		141,
		142,
		152,
		-1,
		-1,
		136,
		109,
		133,
		91,
		79,
		-1,
		49,
		59,
		64,
		68,
		69,
		71,
		98,
		96,
		-1,
		119,
		118,
		149,
		135,
		146,
		118,
		-1,
		-1,
		94,
		86,
		68,
		71,
		48,
		44,
		56,
		55,
		53,
		49,
		45,
		74,
		86,
		84,
		94,
		113,
		123,
		127,
		142,
		153,
		-1,
		-1,
		218,
		-1,
		-1,
		115,
		98,
		-1,
		63,
		70,
		54,
		60,
		46,
		39,
		66,
		42,
		41,
		60,
		48,
		68,
		78,
		101,
		98,
		110,
		135,
		139,
		143,
		163,
		159,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		70,
		67,
		60,
		84,
		76,
		-1,
		0,
		7,
		31,
		34,
		46,
		59,
		54,
		84,
		84,
		99,
		101,
		117,
		119,
		152,
		140,
		162,
		159,
		188,
		193,
		187,
		196,
		-1,
		123,
		119,
		115,
		122,
		71,
		-1,
		-1,
		88,
		-1,
		70,
		38,
		13,
		11,
		14,
		35,
		35,
		66,
		60,
		78,
		87,
		90,
		110,
		123,
		130,
		135,
		134,
		152,
		167,
		180,
		184,
		190,
		-1,
		173,
		-1,
		115,
		99,
		101,
		77,
		105,
		-1,
		108,
		71,
		30,
		15,
		15,
		-1,
		39,
		36,
		50,
		57,
		62,
		79,
		94,
		98,
		109,
		124,
		138,
		129,
		147,
		154,
		162,
		166,
		186,
		198,
		133,
		123,
		-1,
		105,
		110,
		80,
		92,
		115,
		87,
		51,
		-1,
		26,
		-1,
		41,
		54,
		-1,
		56,
		60,
		68,
		84,
		98,
		111,
		116,
		120,
		117,
		135,
		138,
		155,
		159,
		175,
		-1,
		-1,
		118,
		122,
		130,
		81,
		100,
		124,
		97,
		44,
		33,
		32,
		-1,
		59,
		87,
		84,
		85,
		88,
		81,
		82,
		104,
		117,
		100,
		119,
		122,
		144,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		107,
		78,
		102,
		111,
		62,
		55,
		43,
		60,
		60,
		67,
		-1,
		109,
		93,
		95,
		86,
		94,
		108,
		105,
		119,
		123,
		122,
		141,
		153,
		144,
		164,
		-1,
		-1,
		-1,
		137,
		126,
		127,
		81,
		115,
		133,
		93,
		79,
		84,
		59,
		65,
		70,
		96,
		105,
		110,
		104,
		96,
		85,
		101,
		109,
		111,
		120,
		129,
		135,
		159,
		166,
		172,
		-1,
		-1,
		144,
		134,
		118,
		120,
		117,
		106,
		113,
		145,
		84,
		168,
		-1,
		103,
		-1,
		76,
		110,
		109,
		104,
		101,
		98,
		92,
		101,
		115,
		126,
		122,
		129,
		164,
		164,
		156,
		176,
		179,
		-1,
		-1,
		-1,
		137,
		154,
		129,
		106,
		87,
		123,
		-1,
		138,
		139,
		-1,
		97,
		91,
		107,
		111,
		107,
		102,
		106,
		99,
		106,
		102,
		116,
		127,
		114,
		150,
		-1,
		164,
		158,
		166,
		156,
		144,
		-1,
		-1,
		-1,
		152,
		131,
		124,
		144,
		94,
		146,
		-1,
		-1,
		123,
		116,
		-1,
		94,
		103,
		110,
		109,
		103,
		107,
		111,
		100,
		113,
		118,
		119,
		129,
		149,
		153,
		157,
		146,
		142,
		139,
		153,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		114,
		-1,
		132,
		124,
		114,
		108,
		102,
		116,
		114,
		131,
		115,
		118,
		118,
		114,
		122,
		107,
		110,
		122,
		126,
		144,
		152,
		144,
		138,
		137,
		149,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		129,
		-1,
		100,
		124,
		140,
		-1,
		140,
		119,
		134,
		112,
		126,
		122,
		138,
		139,
		117,
		122,
		121,
		131,
		132,
		121,
		134,
		126,
		148,
		148,
		132,
		133,
		142,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		103,
		102,
		127,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		136,
		134,
		128,
		119,
		125,
		132,
		135,
		136,
		126,
		115,
		121,
		120,
		142,
		128,
		126,
		145,
		161,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		136,
		120,
		125,
		-1,
		161,
		-1,
		134,
		136,
		128,
		117,
		114,
		125,
		123,
		134,
		151,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		160,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		152,
		132,
		126,
		125,
		156,
		154,
		142,
		126,
		119,
		116,
		117,
		130,
		150,
		141,
		153,
		-1,
		-1,
		-1,
		161,
		141,
		147,
		105,
		126,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		169,
		157,
		147,
		137,
		171,
		170,
		145,
		138,
		124,
		126,
		124,
		126,
		131,
		152,
		153,
		166,
		-1,
		-1,
		138,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		158,
		-1,
		-1,
		149,
		147,
		157,
		141,
		128,
		148,
		151,
		141,
		125,
		140,
		152,
		160,
		165,
		-1,
		141,
		128,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		161,
		182,
		186,
		152,
		-1,
		157,
		152,
		132,
		146,
		153,
		143,
		138,
		132,
		135,
		153,
		170,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		140,
		154,
		175,
		168,
		172,
		-1,
		160,
		148,
		134,
		151,
		156,
		153,
		144,
		136,
		141,
		138,
		151,
		165,
		169,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		158,
		173,
		214,
		191,
		164,
		159,
		152,
		146,
		142,
		158,
		164,
		175,
		143,
		139,
		140,
		144,
		143,
		160,
		170,
		-1,
		-1,
		161,
		178,
		184,
		166,
		170,
		241,
		-1,
		-1,
		168,
		159,
		150,
		153,
		152,
		155,
		149,
		146,
		151,
		156,
		144,
		153,
		171,
		170,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		185,
		239,
		186,
		168,
		164,
		162,
		155,
		164,
		159,
		154,
		164,
		166,
		158,
		146,
		150,
		173,
		162,
		201,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		210,
		185,
		200,
		246,
		205,
		212,
		201,
		198,
		-1,
		168,
		193,
		165,
		172,
		163,
		170,
		170,
		162,
		140,
		147,
		163,
		162,
		157,
		193,
		184,
		190,
		-1,
		-1,
		291,
		280,
		269,
		275,
		-1,
		216,
		202,
		232,
		222,
		222,
		-1,
		-1,
		217,
		214,
		190,
		173,
		171,
		164,
		159,
		169,
		149,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		186,
		267,
		260,
		243,
		251,
		282,
		-1,
		219,
		228,
		209,
		214,
		220,
		-1,
		-1,
		190,
		187,
		192,
		180,
		177,
		179,
		174,
		165,
		150,
		156,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		200,
		243,
		237,
		240,
		264,
		278,
		-1,
		232,
		-1,
		-1,
		217,
		221,
		205,
		195,
		189,
		239,
		194,
		189,
		173,
		171,
		162,
		153,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		235,
		223,
		231,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		233,
		-1,
		232,
		-1,
		207,
		211,
		202,
		205,
		187,
		174,
		166,
		158,
		174,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		308,
		264,
		231,
		222,
		269,
		284,
		288,
		-1,
		245,
		284,
		271,
		-1,
		242,
		-1,
		-1,
		-1,
		221,
		215,
		207,
		207,
		186,
		186,
		160,
		164,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		304,
		295,
		308,
		253,
		236,
		254,
		263,
		284,
		260,
		251,
		278,
		278,
		267,
		262,
		249,
		-1,
		-1,
		244,
		225,
		-1,
		-1,
		193,
		181,
		164,
		165,
		161,
		164,
		179,
		182,
		172,
		170,
		164,
		196,
		-1,
		297,
		296,
		285,
		282,
		258,
		249,
		244,
		255,
		-1,
		-1,
		263,
		279,
		277,
		281,
		297,
		322,
		-1,
		252,
		-1,
		-1,
		238,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		169,
		180,
		190,
		178,
		179,
		169,
		179,
		192,
		281,
		278,
		266,
		264,
		287,
		252,
		240,
		-1,
		253,
		251,
		257,
		264,
		281,
		311,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		171,
		176,
		196,
		198,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		290,
		304,
		293,
		289,
		288,
		296,
		245,
		238,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		-1,
		259,
		255,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		189,
		193,
		185,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		324,
		-1,
		276,
		252,
		266,
		281,
		289,
		-1,
		-1,
		-1,
		276,
		262,
		255,
		243,
		241,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		264,
		267,
		-1,
		-1,
		266,
		268,
		-1,
		267,
		256,
		241,
		233,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		271,
		272,
		273,
		-1,
		251,
		-1,
		269,
		-1,
		236,
		242,
		230,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		212,
		210,
		201,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		269,
		243,
		276,
		267,
		250,
		230,
		222,
		241,
		-1,
		211,
		-1,
		186,
		188,
		214,
		217,
		223,
		217,
		190,
		205,
		195,
		186,
		195,
		275,
		-1,
		245,
		278,
		242,
		236,
		212,
		216,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		239,
		224,
		205,
		192,
		199,
		199,
		192,
		-1,
		-1,
		-1,
		247,
		246,
		238,
		232,
		232,
		217,
		208,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		229,
		225,
		212,
		212,
		204,
		-1,
		348,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		241,
		236,
		209,
		197,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		205,
		240,
		-1,
		343,
		-1,
		277,
		-1,
		-1,
		259,
		239,
		231,
		220,
		209,
		207,
		198,
		189,
		211,
		227,
		211,
		209,
		212,
		213,
		-1,
		332,
		331,
		-1,
		278,
		270,
		256,
		-1,
		249,
		-1,
		255,
		216,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		319,
		294,
		-1,
		-1,
		-1,
		279,
		259,
		250,
		234,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		304,
		303,
		-1,
		272,
		275,
		-1,
		265,
		256,
		264,
		211,
		215,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		287,
		285,
		280,
		277,
		263,
		247,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		285,
		277,
		270,
		-1,
		-1,
		272,
		255,
		236,
		234,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		262,
		-1,
		-1,
		268,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		296,
		-1,
		-1,
		-1,
		258,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		318,
		319,
		342,
		306,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		321,
		319,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		140,
		142,
		108,
		102,
		141,
		112,
		118,
		129,
		-1,
		-1,
		-1,
		131,
		130,
		100,
		98,
		107,
		112,
		119,
		-1,
		142,
		-1,
		152,
		131,
		142,
		147,
		93,
		90,
		110,
		129,
		135,
		127,
		167,
		123,
		94,
		88,
		106,
		111,
		129,
		121,
		-1,
		94,
		84,
		106,
		110,
		122,
		105,
		-1,
		-1,
		88,
		89,
		95,
		107,
		112,
		117,
		-1,
		143,
		149,
		-1,
		-1,
		78,
		91,
		87,
		90,
		98,
		114,
		135,
		149,
		144,
		-1,
		-1,
		79,
		83,
		96,
		97,
		95,
		122,
		141,
		139,
		153,
		152,
		-1,
		67,
		85,
		94,
		103,
		109,
		98,
		102,
		120,
		138,
		144,
		147,
		-1,
		59,
		61,
		76,
		84,
		89,
		96,
		101,
		107,
		126,
		126,
		145,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		56,
		59,
		76,
		68,
		64,
		77,
		94,
		102,
		110,
		114,
		118,
		134,
		135,
		145,
		-1,
		-1,
		139,
		112,
		136,
		94,
		82,
		-1,
		52,
		52,
		57,
		61,
		62,
		64,
		91,
		89,
		-1,
		112,
		111,
		142,
		128,
		139,
		121,
		-1,
		-1,
		97,
		89,
		71,
		74,
		51,
		47,
		49,
		48,
		46,
		42,
		38,
		67,
		79,
		77,
		87,
		106,
		116,
		120,
		135,
		146,
		-1,
		-1,
		211,
		-1,
		-1,
		118,
		101,
		-1,
		66,
		73,
		57,
		63,
		49,
		42,
		59,
		35,
		34,
		53,
		41,
		61,
		71,
		94,
		91,
		103,
		128,
		132,
		136,
		156,
		152,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		73,
		70,
		63,
		87,
		86,
		-1,
		12,
		0,
		24,
		27,
		39,
		52,
		47,
		77,
		77,
		92,
		94,
		110,
		112,
		145,
		133,
		155,
		152,
		181,
		186,
		180,
		189,
		-1,
		126,
		122,
		118,
		125,
		74,
		-1,
		-1,
		91,
		-1,
		81,
		49,
		24,
		4,
		7,
		28,
		28,
		59,
		53,
		71,
		80,
		83,
		103,
		116,
		123,
		128,
		127,
		145,
		160,
		173,
		177,
		183,
		-1,
		176,
		-1,
		118,
		102,
		104,
		80,
		108,
		-1,
		111,
		82,
		41,
		26,
		26,
		-1,
		32,
		29,
		43,
		50,
		55,
		72,
		87,
		91,
		102,
		117,
		131,
		122,
		140,
		147,
		155,
		159,
		179,
		191,
		136,
		126,
		-1,
		108,
		113,
		83,
		95,
		118,
		98,
		62,
		-1,
		37,
		-1,
		34,
		47,
		-1,
		49,
		53,
		61,
		77,
		91,
		104,
		109,
		113,
		110,
		128,
		131,
		148,
		152,
		168,
		-1,
		-1,
		121,
		125,
		133,
		84,
		103,
		127,
		108,
		55,
		44,
		43,
		-1,
		52,
		80,
		77,
		78,
		81,
		74,
		75,
		97,
		110,
		93,
		112,
		115,
		137,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		110,
		81,
		105,
		122,
		73,
		66,
		54,
		71,
		71,
		76,
		-1,
		102,
		86,
		88,
		79,
		87,
		101,
		98,
		112,
		116,
		115,
		134,
		146,
		137,
		157,
		-1,
		-1,
		-1,
		140,
		129,
		130,
		84,
		118,
		136,
		104,
		90,
		95,
		70,
		76,
		81,
		89,
		98,
		103,
		97,
		89,
		78,
		94,
		102,
		104,
		113,
		122,
		128,
		152,
		159,
		165,
		-1,
		-1,
		147,
		137,
		121,
		123,
		120,
		109,
		116,
		148,
		95,
		179,
		-1,
		114,
		-1,
		87,
		118,
		102,
		97,
		94,
		91,
		85,
		94,
		108,
		119,
		115,
		122,
		157,
		157,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		140,
		157,
		132,
		109,
		90,
		126,
		-1,
		149,
		150,
		-1,
		108,
		102,
		118,
		104,
		100,
		95,
		99,
		92,
		99,
		95,
		109,
		120,
		107,
		143,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		155,
		134,
		127,
		147,
		97,
		149,
		-1,
		-1,
		134,
		127,
		-1,
		105,
		97,
		104,
		102,
		96,
		100,
		104,
		93,
		106,
		111,
		112,
		122,
		142,
		146,
		150,
		139,
		135,
		132,
		146,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		117,
		-1,
		143,
		135,
		125,
		119,
		113,
		110,
		108,
		124,
		108,
		111,
		111,
		107,
		115,
		100,
		103,
		115,
		119,
		137,
		145,
		137,
		131,
		130,
		142,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		132,
		-1,
		103,
		127,
		143,
		-1,
		151,
		130,
		145,
		123,
		120,
		116,
		131,
		132,
		110,
		115,
		114,
		124,
		125,
		114,
		127,
		119,
		141,
		141,
		125,
		126,
		135,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		106,
		113,
		130,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		130,
		128,
		121,
		112,
		118,
		125,
		128,
		129,
		119,
		108,
		114,
		113,
		135,
		121,
		119,
		138,
		154,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		129,
		113,
		118,
		-1,
		154,
		-1,
		127,
		129,
		121,
		110,
		107,
		118,
		116,
		127,
		144,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		163,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		145,
		125,
		119,
		118,
		149,
		147,
		135,
		119,
		112,
		109,
		110,
		123,
		143,
		134,
		146,
		-1,
		-1,
		-1,
		164,
		144,
		150,
		108,
		129,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		162,
		150,
		140,
		130,
		164,
		163,
		138,
		131,
		117,
		119,
		117,
		119,
		124,
		145,
		146,
		159,
		-1,
		-1,
		141,
		148,
		136,
		122,
		141,
		-1,
		-1,
		-1,
		161,
		177,
		169,
		140,
		151,
		-1,
		-1,
		142,
		140,
		150,
		134,
		121,
		141,
		144,
		134,
		118,
		133,
		145,
		153,
		158,
		-1,
		144,
		131,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		172,
		175,
		179,
		145,
		-1,
		150,
		145,
		125,
		139,
		146,
		136,
		131,
		125,
		128,
		146,
		163,
		-1,
		-1,
		158,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		151,
		165,
		168,
		161,
		165,
		-1,
		153,
		141,
		127,
		144,
		149,
		146,
		137,
		129,
		134,
		131,
		144,
		158,
		162,
		181,
		-1,
		164,
		-1,
		-1,
		-1,
		169,
		184,
		207,
		184,
		157,
		152,
		145,
		139,
		135,
		151,
		157,
		168,
		136,
		132,
		133,
		137,
		136,
		153,
		163,
		-1,
		-1,
		164,
		181,
		195,
		177,
		181,
		234,
		-1,
		-1,
		161,
		152,
		143,
		146,
		145,
		148,
		142,
		139,
		144,
		149,
		137,
		146,
		164,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		199,
		-1,
		-1,
		196,
		232,
		179,
		161,
		157,
		155,
		148,
		157,
		152,
		147,
		157,
		159,
		151,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		213,
		188,
		203,
		243,
		216,
		223,
		194,
		191,
		-1,
		161,
		186,
		158,
		165,
		156,
		163,
		163,
		155,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		294,
		283,
		272,
		278,
		-1,
		219,
		205,
		229,
		219,
		222,
		-1,
		-1,
		210,
		207,
		183,
		166,
		164,
		157,
		152,
		162,
		142,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		189,
		270,
		263,
		246,
		254,
		285,
		-1,
		222,
		225,
		212,
		211,
		213,
		-1,
		-1,
		183,
		180,
		185,
		173,
		170,
		172,
		167,
		158,
		143,
		149,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		203,
		246,
		240,
		243,
		267,
		281,
		-1,
		230,
		-1,
		-1,
		220,
		214,
		198,
		188,
		182,
		232,
		187,
		182,
		166,
		164,
		155,
		146,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		238,
		226,
		234,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		236,
		-1,
		225,
		-1,
		200,
		204,
		195,
		198,
		180,
		167,
		159,
		151,
		167,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		301,
		257,
		234,
		225,
		272,
		287,
		291,
		-1,
		242,
		281,
		274,
		-1,
		245,
		-1,
		-1,
		-1,
		214,
		208,
		200,
		200,
		179,
		179,
		153,
		157,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		297,
		288,
		301,
		246,
		239,
		257,
		266,
		287,
		257,
		248,
		275,
		281,
		270,
		265,
		252,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		186,
		174,
		157,
		158,
		154,
		157,
		172,
		175,
		165,
		163,
		157,
		189,
		-1,
		290,
		289,
		278,
		275,
		251,
		242,
		237,
		258,
		-1,
		-1,
		259,
		276,
		270,
		274,
		290,
		315,
		-1,
		246,
		-1,
		-1,
		231,
		-1,
		-1,
		216,
		179,
		168,
		159,
		165,
		162,
		173,
		183,
		171,
		172,
		162,
		172,
		185,
		274,
		271,
		259,
		257,
		280,
		245,
		233,
		-1,
		246,
		244,
		250,
		257,
		274,
		304,
		-1,
		-1,
		262,
		242,
		-1,
		-1,
		214,
		212,
		201,
		-1,
		191,
		164,
		169,
		189,
		191,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		283,
		297,
		286,
		282,
		281,
		289,
		238,
		231,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		-1,
		252,
		248,
		-1,
		-1,
		209,
		202,
		190,
		178,
		168,
		178,
		182,
		186,
		178,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		317,
		-1,
		269,
		245,
		259,
		274,
		282,
		-1,
		-1,
		-1,
		269,
		255,
		248,
		236,
		234,
		-1,
		243,
		227,
		208,
		-1,
		178,
		191,
		222,
		190,
		195,
		190,
		172,
		183,
		172,
		175,
		189,
		184,
		-1,
		-1,
		257,
		260,
		-1,
		-1,
		259,
		261,
		-1,
		260,
		249,
		234,
		226,
		-1,
		-1,
		215,
		211,
		-1,
		-1,
		179,
		204,
		193,
		201,
		196,
		176,
		182,
		185,
		174,
		178,
		190,
		-1,
		-1,
		264,
		265,
		266,
		-1,
		244,
		-1,
		262,
		-1,
		229,
		235,
		223,
		-1,
		-1,
		-1,
		217,
		180,
		201,
		211,
		205,
		203,
		194,
		180,
		187,
		185,
		181,
		192,
		-1,
		-1,
		-1,
		262,
		236,
		269,
		260,
		243,
		223,
		215,
		234,
		-1,
		204,
		-1,
		179,
		181,
		207,
		210,
		216,
		210,
		183,
		198,
		188,
		179,
		188,
		268,
		-1,
		238,
		271,
		235,
		229,
		205,
		209,
		225,
		-1,
		201,
		183,
		-1,
		211,
		201,
		232,
		217,
		198,
		185,
		192,
		192,
		185,
		-1,
		-1,
		-1,
		240,
		239,
		231,
		225,
		225,
		210,
		201,
		-1,
		213,
		195,
		174,
		191,
		191,
		182,
		190,
		222,
		218,
		205,
		205,
		197,
		-1,
		341,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		234,
		229,
		202,
		190,
		196,
		192,
		178,
		184,
		186,
		194,
		192,
		189,
		201,
		197,
		217,
		198,
		233,
		-1,
		336,
		-1,
		270,
		-1,
		-1,
		252,
		232,
		224,
		213,
		202,
		200,
		191,
		182,
		204,
		220,
		204,
		202,
		205,
		206,
		-1,
		325,
		324,
		-1,
		271,
		263,
		249,
		-1,
		242,
		-1,
		248,
		209,
		-1,
		211,
		191,
		-1,
		213,
		209,
		-1,
		-1,
		312,
		287,
		-1,
		-1,
		-1,
		272,
		252,
		243,
		227,
		-1,
		202,
		202,
		-1,
		-1,
		-1,
		297,
		296,
		-1,
		265,
		268,
		-1,
		258,
		249,
		257,
		204,
		208,
		-1,
		-1,
		-1,
		306,
		287,
		281,
		280,
		278,
		273,
		270,
		256,
		240,
		218,
		207,
		228,
		-1,
		-1,
		-1,
		278,
		270,
		263,
		-1,
		-1,
		265,
		248,
		229,
		227,
		-1,
		-1,
		-1,
		300,
		281,
		-1,
		-1,
		255,
		-1,
		-1,
		261,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		317,
		289,
		-1,
		-1,
		-1,
		251,
		247,
		248,
		-1,
		-1,
		-1,
		-1,
		311,
		312,
		335,
		299,
		-1,
		-1,
		-1,
		243,
		237,
		-1,
		-1,
		314,
		312,
		-1,
		-1,
		-1,
		271,
		255,
		-1,
		241,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		276,
		-1,
		276,
		251,
		258,
		-1,
		-1,
		-1,
		-1,
		289,
		281,
		289,
		-1,
		261,
		263,
		-1,
		311,
		-1,
		-1,
		304,
		295,
		-1,
		-1,
		266,
		273,
		295,
		298,
		334,
		-1,
		285
	],
	[
		-1,
		133,
		122,
		133,
		141,
		114,
		121,
		-1,
		142,
		144,
		110,
		104,
		143,
		114,
		120,
		131,
		-1,
		-1,
		-1,
		133,
		132,
		102,
		100,
		109,
		114,
		121,
		-1,
		144,
		-1,
		154,
		133,
		144,
		149,
		95,
		92,
		112,
		131,
		137,
		129,
		169,
		125,
		96,
		90,
		108,
		113,
		131,
		123,
		-1,
		96,
		86,
		108,
		112,
		124,
		107,
		-1,
		-1,
		90,
		91,
		97,
		109,
		114,
		119,
		-1,
		145,
		151,
		-1,
		-1,
		80,
		93,
		89,
		92,
		100,
		116,
		137,
		151,
		146,
		-1,
		-1,
		81,
		85,
		98,
		99,
		97,
		124,
		143,
		141,
		155,
		154,
		-1,
		69,
		87,
		96,
		105,
		111,
		100,
		104,
		122,
		140,
		146,
		149,
		-1,
		78,
		79,
		78,
		86,
		91,
		98,
		103,
		109,
		128,
		128,
		147,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		77,
		61,
		78,
		70,
		66,
		79,
		96,
		104,
		112,
		116,
		120,
		136,
		137,
		147,
		-1,
		-1,
		167,
		140,
		164,
		122,
		102,
		-1,
		73,
		54,
		59,
		63,
		64,
		66,
		93,
		91,
		-1,
		114,
		113,
		144,
		130,
		141,
		149,
		-1,
		-1,
		125,
		117,
		99,
		102,
		79,
		75,
		51,
		50,
		48,
		44,
		40,
		69,
		81,
		79,
		89,
		108,
		118,
		122,
		137,
		148,
		-1,
		-1,
		213,
		-1,
		-1,
		146,
		129,
		-1,
		94,
		101,
		85,
		91,
		77,
		70,
		61,
		37,
		36,
		55,
		43,
		63,
		73,
		96,
		93,
		105,
		130,
		134,
		138,
		158,
		154,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		101,
		98,
		91,
		115,
		114,
		-1,
		40,
		28,
		0,
		28,
		40,
		53,
		49,
		79,
		79,
		94,
		96,
		112,
		114,
		147,
		135,
		157,
		154,
		183,
		188,
		182,
		191,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		119,
		-1,
		109,
		77,
		52,
		25,
		28,
		29,
		29,
		60,
		55,
		73,
		82,
		85,
		105,
		118,
		125,
		130,
		129,
		147,
		162,
		175,
		179,
		185,
		-1,
		204,
		-1,
		146,
		130,
		132,
		108,
		136,
		-1,
		139,
		110,
		69,
		54,
		54,
		-1,
		33,
		30,
		44,
		51,
		57,
		74,
		89,
		93,
		104,
		119,
		133,
		124,
		142,
		149,
		157,
		161,
		181,
		193,
		164,
		154,
		-1,
		136,
		141,
		111,
		123,
		146,
		126,
		90,
		-1,
		65,
		-1,
		35,
		48,
		-1,
		50,
		54,
		63,
		79,
		93,
		106,
		111,
		115,
		112,
		130,
		133,
		150,
		154,
		170,
		-1,
		-1,
		149,
		153,
		161,
		112,
		131,
		155,
		136,
		83,
		72,
		71,
		-1,
		53,
		81,
		78,
		79,
		83,
		76,
		77,
		99,
		112,
		95,
		114,
		117,
		139,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		138,
		109,
		133,
		150,
		101,
		94,
		82,
		92,
		90,
		77,
		-1,
		103,
		87,
		90,
		81,
		89,
		103,
		100,
		114,
		118,
		117,
		136,
		148,
		139,
		159,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		112,
		146,
		164,
		125,
		111,
		116,
		91,
		79,
		87,
		90,
		99,
		105,
		99,
		91,
		80,
		96,
		104,
		106,
		115,
		124,
		130,
		154,
		161,
		167,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		137,
		144,
		176,
		116,
		182,
		-1,
		120,
		-1,
		93,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		110,
		121,
		117,
		124,
		159,
		159,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		168,
		185,
		160,
		137,
		118,
		154,
		-1,
		152,
		153,
		-1,
		114,
		108,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		97,
		111,
		122,
		109,
		145,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		125,
		177,
		-1,
		-1,
		137,
		130,
		-1,
		111,
		99,
		106,
		104,
		98,
		102,
		106,
		95,
		108,
		113,
		114,
		124,
		144,
		148,
		152,
		141,
		137,
		134,
		148,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		145,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		113,
		113,
		109,
		117,
		102,
		105,
		117,
		121,
		139,
		147,
		139,
		133,
		132,
		144,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		160,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		118,
		133,
		134,
		112,
		117,
		116,
		126,
		127,
		116,
		129,
		121,
		143,
		143,
		127,
		128,
		137,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		132,
		130,
		123,
		114,
		120,
		127,
		130,
		131,
		121,
		110,
		116,
		115,
		137,
		123,
		121,
		140,
		156,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		131,
		115,
		120,
		-1,
		156,
		-1,
		129,
		131,
		123,
		112,
		109,
		120,
		118,
		129,
		146,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		147,
		127,
		121,
		120,
		151,
		149,
		137,
		121,
		114,
		111,
		112,
		125,
		145,
		136,
		148,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		164,
		152,
		142,
		132,
		166,
		165,
		140,
		133,
		119,
		121,
		119,
		121,
		126,
		147,
		148,
		161,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		153,
		-1,
		-1,
		144,
		142,
		152,
		136,
		123,
		143,
		146,
		136,
		120,
		135,
		147,
		155,
		160,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		175,
		177,
		181,
		147,
		-1,
		152,
		147,
		127,
		141,
		148,
		138,
		133,
		127,
		130,
		148,
		165,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		154,
		168,
		170,
		163,
		167,
		-1,
		155,
		143,
		129,
		146,
		151,
		148,
		139,
		131,
		136,
		133,
		146,
		160,
		164,
		203,
		-1,
		186,
		-1,
		-1,
		-1,
		172,
		187,
		209,
		186,
		159,
		154,
		147,
		141,
		137,
		153,
		159,
		170,
		138,
		134,
		135,
		139,
		138,
		155,
		165,
		-1,
		-1,
		186,
		203,
		198,
		180,
		184,
		236,
		-1,
		-1,
		163,
		154,
		145,
		148,
		147,
		150,
		144,
		141,
		146,
		151,
		139,
		148,
		166,
		165,
		-1,
		-1,
		-1,
		206,
		-1,
		221,
		-1,
		-1,
		199,
		234,
		181,
		163,
		159,
		157,
		150,
		159,
		154,
		149,
		159,
		161,
		153,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		235,
		210,
		225,
		245,
		219,
		226,
		196,
		193,
		-1,
		163,
		188,
		160,
		167,
		158,
		165,
		165,
		157,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		241,
		227,
		231,
		221,
		224,
		-1,
		-1,
		212,
		209,
		185,
		168,
		166,
		159,
		154,
		164,
		144,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		213,
		294,
		287,
		270,
		278,
		309,
		-1,
		235,
		227,
		234,
		213,
		215,
		-1,
		-1,
		185,
		182,
		187,
		175,
		172,
		174,
		169,
		160,
		145,
		151,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		227,
		270,
		264,
		267,
		291,
		305,
		-1,
		232,
		-1,
		-1,
		242,
		216,
		200,
		190,
		184,
		234,
		189,
		184,
		168,
		166,
		157,
		148,
		155,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		262,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		258,
		-1,
		227,
		-1,
		202,
		206,
		197,
		200,
		182,
		169,
		161,
		153,
		169,
		144,
		154,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		303,
		259,
		258,
		249,
		284,
		299,
		303,
		-1,
		244,
		283,
		281,
		-1,
		265,
		-1,
		-1,
		-1,
		216,
		210,
		202,
		202,
		181,
		181,
		155,
		159,
		149,
		156,
		166,
		168,
		160,
		164,
		177,
		188,
		191,
		299,
		290,
		303,
		248,
		248,
		269,
		278,
		299,
		259,
		250,
		277,
		288,
		277,
		272,
		259,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		188,
		176,
		159,
		160,
		156,
		159,
		174,
		177,
		167,
		165,
		159,
		191,
		-1,
		292,
		291,
		280,
		277,
		253,
		244,
		239,
		266,
		-1,
		-1,
		261,
		278,
		272,
		276,
		292,
		317,
		-1,
		248,
		-1,
		-1,
		233,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		164,
		175,
		185,
		173,
		174,
		164,
		174,
		187,
		276,
		273,
		261,
		259,
		282,
		247,
		235,
		-1,
		248,
		246,
		252,
		259,
		276,
		306,
		-1,
		-1,
		264,
		244,
		-1,
		-1,
		216,
		214,
		203,
		-1,
		193,
		166,
		171,
		191,
		193,
		182,
		176,
		170,
		177,
		176,
		184,
		192,
		285,
		299,
		288,
		284,
		283,
		291,
		240,
		233,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		254,
		250,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		184,
		188,
		180,
		173,
		168,
		179,
		171,
		175,
		192,
		-1,
		319,
		-1,
		271,
		247,
		261,
		276,
		284,
		-1,
		-1,
		-1,
		271,
		257,
		250,
		238,
		236,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		174,
		185,
		174,
		177,
		191,
		186,
		-1,
		-1,
		259,
		262,
		-1,
		-1,
		261,
		263,
		-1,
		262,
		251,
		236,
		228,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		178,
		184,
		187,
		176,
		180,
		192,
		-1,
		-1,
		266,
		267,
		268,
		-1,
		246,
		-1,
		264,
		-1,
		231,
		237,
		225,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		207,
		205,
		196,
		182,
		189,
		187,
		183,
		194,
		-1,
		-1,
		-1,
		264,
		238,
		271,
		262,
		245,
		225,
		217,
		236,
		-1,
		206,
		-1,
		181,
		183,
		209,
		212,
		218,
		212,
		185,
		200,
		190,
		181,
		190,
		270,
		-1,
		240,
		273,
		237,
		231,
		207,
		211,
		227,
		-1,
		203,
		185,
		-1,
		213,
		203,
		234,
		219,
		200,
		187,
		194,
		194,
		187,
		-1,
		-1,
		-1,
		242,
		241,
		233,
		227,
		227,
		212,
		203,
		-1,
		215,
		197,
		176,
		193,
		193,
		184,
		192,
		224,
		220,
		207,
		207,
		199,
		-1,
		343,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		236,
		231,
		204,
		192,
		198,
		194,
		180,
		186,
		188,
		196,
		194,
		191,
		203,
		199,
		219,
		200,
		235,
		-1,
		338,
		-1,
		272,
		-1,
		-1,
		254,
		234,
		226,
		215,
		204,
		202,
		193,
		184,
		206,
		222,
		206,
		204,
		207,
		208,
		-1,
		327,
		326,
		-1,
		273,
		265,
		251,
		-1,
		244,
		-1,
		250,
		211,
		-1,
		213,
		193,
		-1,
		215,
		211,
		-1,
		-1,
		314,
		289,
		-1,
		-1,
		-1,
		274,
		254,
		245,
		229,
		-1,
		204,
		204,
		-1,
		-1,
		-1,
		299,
		298,
		-1,
		267,
		270,
		-1,
		260,
		251,
		259,
		206,
		210,
		-1,
		-1,
		-1,
		308,
		289,
		283,
		282,
		280,
		275,
		272,
		258,
		242,
		220,
		209,
		230,
		-1,
		-1,
		-1,
		280,
		272,
		265,
		-1,
		-1,
		267,
		250,
		231,
		229,
		-1,
		-1,
		-1,
		302,
		283,
		-1,
		-1,
		257,
		-1,
		-1,
		263,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		291,
		-1,
		-1,
		-1,
		253,
		249,
		250,
		-1,
		-1,
		-1,
		-1,
		313,
		314,
		337,
		301,
		-1,
		-1,
		-1,
		245,
		239,
		-1,
		-1,
		316,
		314,
		-1,
		-1,
		-1,
		273,
		257,
		-1,
		243,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		278,
		-1,
		278,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		291,
		283,
		291,
		-1,
		263,
		265,
		-1,
		313,
		-1,
		-1,
		306,
		297,
		-1,
		-1,
		268,
		275,
		297,
		300,
		336,
		-1,
		287
	],
	[
		-1,
		119,
		108,
		119,
		127,
		100,
		107,
		-1,
		128,
		130,
		96,
		90,
		129,
		100,
		106,
		117,
		-1,
		-1,
		-1,
		119,
		118,
		88,
		86,
		95,
		100,
		107,
		-1,
		130,
		-1,
		140,
		119,
		130,
		135,
		81,
		78,
		98,
		117,
		123,
		115,
		155,
		111,
		82,
		76,
		94,
		99,
		117,
		109,
		-1,
		82,
		72,
		94,
		98,
		110,
		93,
		-1,
		-1,
		76,
		77,
		83,
		95,
		100,
		105,
		-1,
		131,
		137,
		-1,
		-1,
		66,
		79,
		75,
		78,
		86,
		102,
		123,
		137,
		132,
		-1,
		-1,
		67,
		71,
		84,
		85,
		83,
		110,
		129,
		127,
		141,
		140,
		-1,
		55,
		73,
		82,
		91,
		97,
		86,
		90,
		108,
		126,
		132,
		135,
		-1,
		64,
		65,
		64,
		72,
		77,
		84,
		89,
		95,
		114,
		114,
		133,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		63,
		47,
		64,
		56,
		52,
		65,
		82,
		90,
		98,
		102,
		106,
		122,
		123,
		133,
		-1,
		-1,
		157,
		130,
		154,
		112,
		88,
		-1,
		59,
		40,
		45,
		49,
		50,
		52,
		79,
		77,
		-1,
		100,
		99,
		130,
		116,
		127,
		139,
		-1,
		-1,
		115,
		107,
		89,
		92,
		69,
		65,
		37,
		36,
		31,
		30,
		26,
		55,
		67,
		65,
		75,
		94,
		104,
		108,
		123,
		134,
		-1,
		-1,
		199,
		-1,
		-1,
		136,
		119,
		-1,
		84,
		91,
		75,
		81,
		67,
		71,
		47,
		23,
		19,
		41,
		29,
		49,
		59,
		82,
		79,
		91,
		116,
		120,
		124,
		144,
		140,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		91,
		88,
		81,
		105,
		104,
		-1,
		41,
		29,
		27,
		0,
		21,
		34,
		35,
		65,
		65,
		80,
		82,
		98,
		100,
		133,
		121,
		143,
		140,
		169,
		174,
		168,
		177,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		109,
		-1,
		110,
		78,
		53,
		26,
		29,
		10,
		18,
		41,
		41,
		59,
		68,
		71,
		91,
		104,
		111,
		116,
		115,
		133,
		148,
		161,
		165,
		171,
		-1,
		194,
		-1,
		136,
		120,
		122,
		98,
		126,
		-1,
		129,
		111,
		70,
		55,
		55,
		-1,
		28,
		25,
		33,
		40,
		43,
		60,
		75,
		79,
		90,
		105,
		119,
		110,
		128,
		135,
		143,
		147,
		167,
		179,
		154,
		144,
		-1,
		126,
		131,
		101,
		113,
		136,
		127,
		91,
		-1,
		66,
		-1,
		30,
		43,
		-1,
		39,
		43,
		49,
		65,
		79,
		92,
		97,
		101,
		98,
		116,
		119,
		136,
		140,
		156,
		-1,
		-1,
		139,
		143,
		151,
		102,
		121,
		145,
		137,
		84,
		73,
		72,
		-1,
		48,
		70,
		67,
		68,
		69,
		62,
		63,
		85,
		98,
		81,
		100,
		103,
		125,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		128,
		99,
		123,
		151,
		102,
		95,
		83,
		87,
		85,
		72,
		-1,
		92,
		76,
		76,
		67,
		75,
		89,
		86,
		100,
		104,
		103,
		122,
		134,
		125,
		145,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		102,
		136,
		154,
		120,
		106,
		111,
		86,
		74,
		82,
		79,
		88,
		91,
		85,
		77,
		66,
		82,
		90,
		92,
		101,
		110,
		116,
		140,
		147,
		153,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		127,
		134,
		166,
		111,
		168,
		-1,
		115,
		-1,
		88,
		106,
		90,
		85,
		82,
		79,
		73,
		82,
		96,
		107,
		103,
		110,
		145,
		145,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		158,
		175,
		150,
		127,
		108,
		144,
		-1,
		138,
		139,
		-1,
		109,
		103,
		107,
		92,
		88,
		83,
		87,
		80,
		87,
		83,
		97,
		108,
		95,
		131,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		115,
		167,
		-1,
		-1,
		123,
		116,
		-1,
		103,
		85,
		92,
		90,
		84,
		88,
		92,
		81,
		94,
		99,
		100,
		110,
		130,
		134,
		138,
		127,
		123,
		120,
		134,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		135,
		-1,
		132,
		124,
		114,
		108,
		102,
		98,
		96,
		112,
		96,
		99,
		99,
		95,
		103,
		88,
		91,
		103,
		107,
		125,
		133,
		125,
		119,
		118,
		130,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		150,
		-1,
		117,
		131,
		147,
		-1,
		140,
		119,
		134,
		112,
		108,
		104,
		119,
		120,
		98,
		103,
		102,
		112,
		113,
		102,
		115,
		107,
		129,
		129,
		113,
		114,
		123,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		114,
		102,
		134,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		118,
		116,
		109,
		100,
		106,
		113,
		116,
		117,
		107,
		96,
		102,
		101,
		123,
		109,
		107,
		126,
		142,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		117,
		101,
		106,
		-1,
		142,
		-1,
		115,
		117,
		109,
		98,
		95,
		106,
		104,
		115,
		132,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		171,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		133,
		113,
		107,
		106,
		137,
		135,
		123,
		107,
		100,
		97,
		98,
		111,
		131,
		122,
		134,
		-1,
		-1,
		-1,
		168,
		154,
		158,
		118,
		137,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		150,
		138,
		128,
		118,
		152,
		151,
		126,
		119,
		105,
		107,
		105,
		107,
		112,
		133,
		134,
		147,
		-1,
		-1,
		151,
		156,
		144,
		130,
		149,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		139,
		-1,
		-1,
		130,
		128,
		138,
		122,
		109,
		129,
		132,
		122,
		106,
		121,
		133,
		141,
		146,
		-1,
		154,
		141,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		161,
		163,
		167,
		133,
		-1,
		138,
		133,
		113,
		127,
		134,
		124,
		119,
		113,
		116,
		134,
		151,
		-1,
		-1,
		166,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		140,
		154,
		156,
		149,
		153,
		-1,
		141,
		129,
		115,
		132,
		137,
		134,
		125,
		117,
		122,
		119,
		132,
		146,
		150,
		189,
		-1,
		172,
		-1,
		-1,
		-1,
		158,
		173,
		195,
		172,
		145,
		140,
		133,
		127,
		123,
		139,
		145,
		156,
		124,
		120,
		121,
		125,
		124,
		141,
		151,
		-1,
		-1,
		172,
		189,
		184,
		166,
		170,
		222,
		-1,
		-1,
		149,
		140,
		131,
		134,
		133,
		136,
		130,
		127,
		132,
		137,
		125,
		134,
		152,
		151,
		-1,
		-1,
		-1,
		192,
		-1,
		207,
		-1,
		-1,
		185,
		220,
		167,
		149,
		145,
		143,
		136,
		145,
		140,
		135,
		145,
		147,
		139,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		221,
		196,
		211,
		231,
		205,
		212,
		182,
		179,
		-1,
		149,
		174,
		146,
		153,
		144,
		151,
		151,
		143,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		304,
		293,
		282,
		288,
		-1,
		227,
		213,
		217,
		207,
		210,
		-1,
		-1,
		198,
		195,
		171,
		154,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		199,
		280,
		273,
		256,
		264,
		295,
		-1,
		221,
		213,
		220,
		199,
		201,
		-1,
		-1,
		171,
		168,
		173,
		161,
		158,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		213,
		256,
		250,
		253,
		277,
		291,
		-1,
		218,
		-1,
		-1,
		228,
		202,
		186,
		176,
		170,
		220,
		175,
		170,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		248,
		236,
		244,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		244,
		-1,
		213,
		-1,
		188,
		192,
		183,
		186,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		289,
		245,
		244,
		235,
		270,
		285,
		289,
		-1,
		230,
		269,
		267,
		-1,
		251,
		-1,
		-1,
		-1,
		202,
		196,
		188,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		285,
		276,
		289,
		234,
		234,
		255,
		264,
		285,
		245,
		236,
		263,
		274,
		263,
		258,
		245,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		225,
		252,
		-1,
		-1,
		247,
		264,
		258,
		262,
		278,
		303,
		-1,
		234,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		262,
		259,
		247,
		245,
		268,
		233,
		221,
		-1,
		234,
		232,
		238,
		245,
		262,
		292,
		-1,
		-1,
		250,
		230,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		219,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		236,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		305,
		-1,
		257,
		233,
		247,
		262,
		270,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		245,
		248,
		-1,
		-1,
		247,
		249,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		252,
		253,
		254,
		-1,
		232,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		329,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		124,
		113,
		124,
		132,
		105,
		112,
		-1,
		133,
		135,
		101,
		95,
		134,
		105,
		111,
		122,
		-1,
		-1,
		-1,
		124,
		123,
		93,
		91,
		100,
		105,
		112,
		-1,
		135,
		-1,
		145,
		124,
		135,
		140,
		86,
		83,
		103,
		122,
		128,
		120,
		160,
		116,
		87,
		81,
		99,
		104,
		122,
		114,
		-1,
		87,
		77,
		99,
		103,
		115,
		98,
		-1,
		-1,
		81,
		82,
		88,
		100,
		105,
		110,
		-1,
		136,
		136,
		-1,
		-1,
		71,
		84,
		80,
		83,
		91,
		107,
		128,
		136,
		131,
		-1,
		-1,
		72,
		76,
		89,
		90,
		88,
		115,
		134,
		126,
		140,
		139,
		-1,
		60,
		78,
		87,
		93,
		99,
		91,
		95,
		113,
		125,
		131,
		134,
		-1,
		69,
		70,
		63,
		71,
		76,
		83,
		93,
		100,
		119,
		113,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		69,
		52,
		69,
		59,
		51,
		64,
		81,
		89,
		103,
		107,
		105,
		121,
		122,
		132,
		-1,
		-1,
		163,
		136,
		160,
		118,
		99,
		-1,
		65,
		45,
		49,
		53,
		49,
		51,
		78,
		76,
		-1,
		99,
		98,
		129,
		115,
		126,
		145,
		-1,
		-1,
		121,
		113,
		95,
		98,
		75,
		71,
		49,
		48,
		30,
		35,
		31,
		54,
		66,
		64,
		74,
		93,
		103,
		107,
		122,
		133,
		-1,
		-1,
		197,
		-1,
		-1,
		142,
		125,
		-1,
		90,
		97,
		81,
		87,
		73,
		83,
		59,
		35,
		31,
		38,
		30,
		48,
		58,
		81,
		78,
		90,
		115,
		119,
		122,
		143,
		138,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		97,
		94,
		87,
		111,
		110,
		-1,
		53,
		41,
		39,
		21,
		0,
		19,
		36,
		62,
		64,
		79,
		81,
		97,
		99,
		132,
		119,
		141,
		138,
		167,
		172,
		166,
		175,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		115,
		-1,
		118,
		90,
		65,
		38,
		41,
		17,
		19,
		26,
		42,
		56,
		67,
		70,
		90,
		103,
		110,
		114,
		113,
		131,
		146,
		159,
		163,
		169,
		-1,
		200,
		-1,
		142,
		126,
		128,
		104,
		132,
		-1,
		135,
		119,
		82,
		67,
		67,
		-1,
		37,
		34,
		34,
		41,
		41,
		58,
		74,
		78,
		89,
		103,
		117,
		108,
		126,
		133,
		141,
		145,
		165,
		177,
		160,
		150,
		-1,
		132,
		137,
		107,
		119,
		142,
		139,
		103,
		-1,
		78,
		-1,
		39,
		52,
		-1,
		40,
		44,
		47,
		63,
		77,
		90,
		96,
		99,
		96,
		114,
		117,
		134,
		138,
		154,
		-1,
		-1,
		145,
		149,
		157,
		108,
		127,
		151,
		149,
		96,
		85,
		84,
		-1,
		57,
		71,
		68,
		69,
		65,
		60,
		61,
		83,
		97,
		79,
		98,
		101,
		123,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		134,
		105,
		129,
		163,
		114,
		107,
		95,
		96,
		94,
		81,
		-1,
		93,
		75,
		74,
		65,
		73,
		86,
		84,
		98,
		102,
		101,
		120,
		132,
		123,
		143,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		108,
		142,
		160,
		129,
		115,
		120,
		95,
		83,
		91,
		80,
		89,
		87,
		83,
		75,
		64,
		80,
		88,
		90,
		99,
		108,
		114,
		138,
		145,
		151,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		133,
		140,
		172,
		120,
		166,
		-1,
		120,
		-1,
		97,
		104,
		88,
		83,
		80,
		77,
		71,
		80,
		94,
		105,
		101,
		108,
		143,
		143,
		135,
		155,
		158,
		-1,
		-1,
		-1,
		164,
		181,
		156,
		133,
		114,
		150,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		90,
		86,
		81,
		85,
		78,
		85,
		81,
		95,
		106,
		93,
		129,
		-1,
		143,
		137,
		145,
		135,
		123,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		90,
		88,
		82,
		86,
		90,
		79,
		92,
		97,
		98,
		108,
		128,
		132,
		136,
		125,
		121,
		118,
		132,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		110,
		94,
		97,
		97,
		93,
		101,
		86,
		89,
		101,
		105,
		123,
		131,
		123,
		117,
		116,
		128,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		102,
		117,
		118,
		96,
		101,
		100,
		110,
		111,
		100,
		113,
		105,
		127,
		127,
		111,
		112,
		121,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		116,
		114,
		107,
		98,
		104,
		111,
		114,
		115,
		105,
		94,
		100,
		99,
		121,
		107,
		105,
		124,
		140,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		115,
		99,
		104,
		-1,
		140,
		-1,
		113,
		115,
		107,
		96,
		93,
		104,
		102,
		113,
		130,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		131,
		111,
		105,
		104,
		135,
		133,
		121,
		105,
		98,
		95,
		96,
		109,
		129,
		120,
		132,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		148,
		136,
		126,
		116,
		150,
		149,
		124,
		117,
		103,
		105,
		103,
		105,
		110,
		131,
		132,
		145,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		156,
		127,
		137,
		-1,
		-1,
		128,
		126,
		136,
		120,
		107,
		127,
		130,
		120,
		104,
		119,
		131,
		139,
		144,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		159,
		161,
		165,
		131,
		-1,
		136,
		131,
		111,
		125,
		132,
		122,
		117,
		111,
		114,
		132,
		149,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		138,
		152,
		154,
		147,
		151,
		-1,
		139,
		127,
		113,
		130,
		135,
		132,
		123,
		115,
		120,
		117,
		130,
		144,
		148,
		187,
		-1,
		170,
		-1,
		-1,
		-1,
		156,
		171,
		193,
		170,
		143,
		138,
		131,
		125,
		121,
		137,
		143,
		154,
		122,
		118,
		119,
		123,
		122,
		139,
		149,
		-1,
		-1,
		170,
		187,
		182,
		164,
		168,
		220,
		-1,
		-1,
		147,
		138,
		129,
		132,
		131,
		134,
		128,
		125,
		130,
		135,
		123,
		132,
		150,
		149,
		-1,
		-1,
		-1,
		190,
		-1,
		205,
		-1,
		-1,
		183,
		218,
		165,
		147,
		143,
		141,
		134,
		143,
		138,
		133,
		143,
		145,
		137,
		125,
		129,
		152,
		141,
		180,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		219,
		194,
		209,
		229,
		203,
		210,
		180,
		177,
		-1,
		147,
		172,
		144,
		151,
		142,
		149,
		149,
		141,
		119,
		126,
		142,
		141,
		136,
		172,
		163,
		169,
		-1,
		-1,
		302,
		291,
		280,
		286,
		-1,
		225,
		211,
		215,
		205,
		208,
		-1,
		-1,
		196,
		193,
		169,
		152,
		150,
		143,
		138,
		148,
		128,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		197,
		278,
		271,
		254,
		262,
		293,
		-1,
		219,
		211,
		218,
		197,
		199,
		-1,
		-1,
		169,
		166,
		171,
		159,
		156,
		158,
		153,
		144,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		211,
		254,
		248,
		251,
		275,
		289,
		-1,
		216,
		-1,
		-1,
		226,
		200,
		184,
		174,
		168,
		218,
		173,
		168,
		152,
		150,
		141,
		132,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		246,
		234,
		242,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		242,
		-1,
		211,
		-1,
		186,
		190,
		181,
		184,
		166,
		153,
		145,
		137,
		153,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		287,
		243,
		242,
		233,
		268,
		283,
		287,
		-1,
		228,
		267,
		265,
		-1,
		249,
		-1,
		-1,
		-1,
		200,
		194,
		186,
		186,
		165,
		165,
		139,
		143,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		283,
		274,
		287,
		232,
		232,
		253,
		262,
		283,
		243,
		234,
		261,
		272,
		261,
		256,
		243,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		172,
		160,
		143,
		144,
		140,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		276,
		275,
		264,
		261,
		237,
		228,
		223,
		250,
		-1,
		-1,
		245,
		262,
		256,
		260,
		276,
		301,
		-1,
		232,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		165,
		154,
		145,
		151,
		148,
		159,
		169,
		157,
		158,
		148,
		158,
		171,
		260,
		257,
		245,
		243,
		266,
		231,
		219,
		-1,
		232,
		230,
		236,
		243,
		260,
		290,
		-1,
		-1,
		248,
		228,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		150,
		155,
		175,
		177,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		269,
		283,
		272,
		268,
		267,
		275,
		224,
		217,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		238,
		234,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		168,
		172,
		164,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		303,
		-1,
		255,
		231,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		255,
		241,
		234,
		222,
		220,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		208,
		176,
		181,
		176,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		245,
		247,
		-1,
		246,
		235,
		220,
		212,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		165,
		190,
		179,
		187,
		182,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		250,
		251,
		252,
		-1,
		230,
		-1,
		248,
		-1,
		215,
		221,
		209,
		-1,
		-1,
		-1,
		203,
		166,
		187,
		197,
		191,
		189,
		180,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		248,
		222,
		255,
		246,
		229,
		209,
		201,
		220,
		-1,
		190,
		-1,
		165,
		167,
		193,
		196,
		202,
		196,
		169,
		184,
		174,
		165,
		174,
		254,
		-1,
		224,
		257,
		221,
		215,
		191,
		195,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		218,
		203,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		226,
		225,
		217,
		211,
		211,
		196,
		187,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		208,
		204,
		191,
		191,
		183,
		-1,
		327,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		220,
		215,
		188,
		176,
		182,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		184,
		219,
		-1,
		322,
		-1,
		256,
		-1,
		-1,
		238,
		218,
		210,
		199,
		188,
		186,
		177,
		168,
		190,
		206,
		190,
		188,
		191,
		192,
		-1,
		311,
		310,
		-1,
		257,
		249,
		235,
		-1,
		228,
		-1,
		234,
		195,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		298,
		273,
		-1,
		-1,
		-1,
		258,
		238,
		229,
		213,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		283,
		282,
		-1,
		251,
		254,
		-1,
		244,
		235,
		243,
		190,
		194,
		-1,
		-1,
		-1,
		292,
		273,
		267,
		266,
		264,
		259,
		256,
		242,
		226,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		264,
		256,
		249,
		-1,
		-1,
		251,
		234,
		215,
		213,
		-1,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		241,
		-1,
		-1,
		247,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		275,
		-1,
		-1,
		-1,
		237,
		233,
		234,
		-1,
		-1,
		-1,
		-1,
		297,
		298,
		321,
		285,
		-1,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		300,
		298,
		-1,
		-1,
		-1,
		257,
		241,
		-1,
		227,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		262,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		275,
		267,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		290,
		281,
		-1,
		-1,
		252,
		259,
		281,
		284,
		320,
		-1,
		271
	],
	[
		-1,
		124,
		113,
		124,
		132,
		105,
		112,
		-1,
		133,
		135,
		101,
		95,
		134,
		105,
		111,
		122,
		-1,
		-1,
		-1,
		124,
		123,
		93,
		91,
		100,
		105,
		112,
		-1,
		135,
		-1,
		145,
		124,
		135,
		140,
		86,
		83,
		103,
		122,
		128,
		120,
		160,
		116,
		87,
		81,
		99,
		104,
		122,
		114,
		-1,
		87,
		77,
		99,
		103,
		115,
		98,
		-1,
		-1,
		81,
		82,
		88,
		100,
		105,
		110,
		-1,
		136,
		123,
		-1,
		-1,
		71,
		84,
		80,
		83,
		91,
		107,
		128,
		123,
		118,
		-1,
		-1,
		72,
		76,
		89,
		90,
		88,
		115,
		131,
		113,
		127,
		126,
		-1,
		60,
		78,
		87,
		96,
		102,
		91,
		92,
		110,
		112,
		118,
		121,
		-1,
		69,
		70,
		66,
		74,
		79,
		86,
		91,
		97,
		107,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		69,
		52,
		69,
		62,
		54,
		67,
		79,
		87,
		97,
		95,
		92,
		108,
		109,
		119,
		-1,
		-1,
		163,
		136,
		160,
		118,
		99,
		-1,
		65,
		45,
		51,
		55,
		52,
		54,
		76,
		74,
		-1,
		86,
		85,
		116,
		102,
		113,
		145,
		-1,
		-1,
		121,
		113,
		95,
		98,
		75,
		71,
		60,
		59,
		46,
		35,
		31,
		57,
		64,
		62,
		72,
		80,
		90,
		94,
		109,
		120,
		-1,
		-1,
		184,
		-1,
		-1,
		142,
		125,
		-1,
		90,
		97,
		81,
		87,
		73,
		94,
		70,
		48,
		44,
		33,
		25,
		46,
		56,
		74,
		65,
		77,
		102,
		106,
		109,
		130,
		125,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		97,
		94,
		87,
		111,
		110,
		-1,
		66,
		54,
		52,
		34,
		19,
		0,
		31,
		49,
		53,
		66,
		68,
		84,
		86,
		119,
		106,
		128,
		125,
		154,
		159,
		153,
		162,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		115,
		-1,
		118,
		103,
		78,
		51,
		54,
		30,
		32,
		7,
		36,
		43,
		56,
		57,
		77,
		90,
		97,
		101,
		100,
		118,
		133,
		146,
		150,
		156,
		-1,
		200,
		-1,
		142,
		126,
		128,
		104,
		132,
		-1,
		135,
		119,
		95,
		80,
		80,
		-1,
		50,
		47,
		47,
		38,
		28,
		45,
		61,
		65,
		76,
		90,
		104,
		95,
		113,
		120,
		128,
		132,
		152,
		164,
		160,
		150,
		-1,
		132,
		137,
		107,
		119,
		142,
		152,
		116,
		-1,
		91,
		-1,
		52,
		65,
		-1,
		44,
		40,
		34,
		50,
		64,
		77,
		83,
		86,
		83,
		101,
		104,
		121,
		125,
		141,
		-1,
		-1,
		145,
		149,
		157,
		108,
		127,
		151,
		162,
		109,
		98,
		97,
		-1,
		70,
		67,
		64,
		65,
		52,
		47,
		48,
		70,
		84,
		66,
		85,
		88,
		110,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		134,
		105,
		129,
		171,
		127,
		120,
		108,
		109,
		107,
		94,
		-1,
		83,
		62,
		61,
		52,
		60,
		73,
		71,
		85,
		89,
		88,
		107,
		119,
		110,
		130,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		108,
		138,
		160,
		142,
		128,
		133,
		108,
		96,
		102,
		76,
		79,
		74,
		70,
		62,
		51,
		67,
		75,
		77,
		86,
		95,
		101,
		125,
		132,
		138,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		129,
		136,
		168,
		133,
		153,
		-1,
		107,
		-1,
		96,
		91,
		75,
		70,
		67,
		64,
		58,
		67,
		81,
		92,
		88,
		95,
		130,
		130,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		164,
		174,
		149,
		126,
		110,
		146,
		-1,
		123,
		124,
		-1,
		101,
		95,
		92,
		77,
		73,
		68,
		72,
		65,
		72,
		68,
		82,
		93,
		80,
		116,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		172,
		151,
		144,
		164,
		105,
		157,
		-1,
		-1,
		108,
		101,
		-1,
		88,
		70,
		77,
		75,
		69,
		73,
		77,
		66,
		79,
		84,
		85,
		95,
		115,
		119,
		123,
		112,
		108,
		105,
		119,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		125,
		-1,
		117,
		109,
		99,
		93,
		87,
		83,
		81,
		97,
		81,
		84,
		84,
		80,
		88,
		73,
		76,
		88,
		92,
		110,
		118,
		110,
		104,
		103,
		115,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		138,
		-1,
		102,
		116,
		132,
		-1,
		125,
		104,
		119,
		97,
		93,
		89,
		104,
		105,
		83,
		88,
		87,
		97,
		98,
		87,
		100,
		92,
		114,
		114,
		98,
		99,
		108,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		99,
		87,
		119,
		-1,
		-1,
		161,
		-1,
		95,
		112,
		103,
		101,
		94,
		85,
		91,
		98,
		101,
		102,
		92,
		81,
		87,
		86,
		108,
		94,
		92,
		111,
		127,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		136,
		-1,
		139,
		129,
		113,
		98,
		131,
		-1,
		102,
		86,
		91,
		-1,
		127,
		-1,
		100,
		102,
		94,
		83,
		80,
		91,
		89,
		100,
		117,
		-1,
		148,
		133,
		126,
		116,
		130,
		101,
		-1,
		156,
		-1,
		-1,
		126,
		120,
		120,
		104,
		107,
		118,
		98,
		92,
		91,
		122,
		120,
		108,
		92,
		85,
		82,
		83,
		96,
		116,
		107,
		119,
		-1,
		-1,
		-1,
		153,
		139,
		143,
		103,
		122,
		-1,
		-1,
		188,
		143,
		129,
		-1,
		113,
		135,
		123,
		113,
		103,
		137,
		136,
		111,
		104,
		90,
		92,
		90,
		92,
		97,
		118,
		119,
		132,
		-1,
		-1,
		136,
		141,
		129,
		115,
		134,
		-1,
		-1,
		-1,
		135,
		151,
		143,
		114,
		124,
		-1,
		-1,
		115,
		113,
		123,
		107,
		94,
		114,
		117,
		107,
		91,
		106,
		118,
		126,
		131,
		-1,
		139,
		126,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		146,
		148,
		152,
		118,
		-1,
		123,
		118,
		98,
		112,
		119,
		109,
		104,
		98,
		101,
		119,
		136,
		-1,
		-1,
		151,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		125,
		139,
		141,
		134,
		138,
		-1,
		126,
		114,
		100,
		117,
		122,
		119,
		110,
		102,
		107,
		104,
		117,
		131,
		135,
		174,
		-1,
		157,
		-1,
		-1,
		-1,
		143,
		158,
		180,
		157,
		130,
		125,
		118,
		112,
		108,
		124,
		130,
		141,
		109,
		105,
		106,
		110,
		109,
		126,
		136,
		-1,
		-1,
		157,
		174,
		169,
		151,
		155,
		207,
		-1,
		-1,
		134,
		125,
		116,
		119,
		118,
		121,
		115,
		112,
		117,
		122,
		110,
		119,
		137,
		136,
		-1,
		-1,
		-1,
		177,
		-1,
		192,
		-1,
		-1,
		170,
		205,
		152,
		134,
		130,
		128,
		121,
		130,
		125,
		120,
		130,
		132,
		124,
		112,
		116,
		139,
		128,
		167,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		206,
		181,
		196,
		216,
		190,
		197,
		167,
		164,
		-1,
		134,
		159,
		131,
		138,
		129,
		136,
		136,
		128,
		106,
		113,
		129,
		128,
		123,
		159,
		150,
		156,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		212,
		198,
		202,
		192,
		195,
		-1,
		-1,
		183,
		180,
		156,
		139,
		137,
		130,
		125,
		135,
		115,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		147,
		162,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		206,
		198,
		205,
		184,
		186,
		-1,
		-1,
		156,
		153,
		158,
		146,
		143,
		145,
		140,
		131,
		116,
		122,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		203,
		-1,
		-1,
		213,
		187,
		171,
		161,
		155,
		205,
		160,
		155,
		139,
		137,
		128,
		119,
		126,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		229,
		-1,
		198,
		-1,
		173,
		177,
		168,
		171,
		153,
		140,
		132,
		124,
		140,
		115,
		125,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		274,
		230,
		229,
		220,
		255,
		270,
		274,
		-1,
		215,
		254,
		252,
		-1,
		236,
		-1,
		-1,
		-1,
		187,
		181,
		173,
		173,
		152,
		152,
		126,
		130,
		120,
		127,
		137,
		139,
		131,
		135,
		148,
		159,
		162,
		270,
		261,
		274,
		219,
		219,
		240,
		249,
		270,
		230,
		221,
		248,
		259,
		248,
		243,
		230,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		159,
		147,
		130,
		131,
		127,
		130,
		145,
		148,
		138,
		136,
		130,
		162,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		210,
		237,
		-1,
		-1,
		232,
		249,
		243,
		247,
		263,
		288,
		-1,
		219,
		-1,
		-1,
		204,
		-1,
		-1,
		189,
		152,
		141,
		132,
		138,
		135,
		146,
		156,
		144,
		145,
		135,
		145,
		158,
		247,
		244,
		232,
		230,
		253,
		218,
		206,
		-1,
		219,
		217,
		223,
		230,
		247,
		277,
		-1,
		-1,
		235,
		215,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		137,
		142,
		162,
		164,
		153,
		147,
		141,
		148,
		147,
		155,
		163,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		204,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		225,
		221,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		155,
		159,
		151,
		144,
		139,
		150,
		142,
		146,
		163,
		-1,
		290,
		-1,
		242,
		218,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		242,
		228,
		221,
		209,
		207,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		195,
		163,
		168,
		163,
		145,
		156,
		145,
		148,
		162,
		157,
		-1,
		-1,
		230,
		233,
		-1,
		-1,
		232,
		234,
		-1,
		233,
		222,
		207,
		199,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		152,
		177,
		166,
		174,
		169,
		149,
		155,
		158,
		147,
		151,
		163,
		-1,
		-1,
		237,
		238,
		239,
		-1,
		217,
		-1,
		235,
		-1,
		202,
		208,
		196,
		-1,
		-1,
		-1,
		190,
		153,
		174,
		184,
		178,
		176,
		167,
		153,
		160,
		158,
		154,
		165,
		-1,
		-1,
		-1,
		235,
		209,
		242,
		233,
		216,
		196,
		188,
		207,
		-1,
		177,
		-1,
		152,
		154,
		180,
		183,
		189,
		183,
		156,
		171,
		161,
		152,
		161,
		241,
		-1,
		211,
		244,
		208,
		202,
		178,
		182,
		198,
		-1,
		174,
		156,
		-1,
		184,
		174,
		205,
		190,
		171,
		158,
		165,
		165,
		158,
		-1,
		-1,
		-1,
		213,
		212,
		204,
		198,
		198,
		183,
		174,
		-1,
		186,
		168,
		147,
		164,
		164,
		155,
		163,
		195,
		191,
		178,
		178,
		170,
		-1,
		314,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		207,
		202,
		175,
		163,
		169,
		165,
		151,
		157,
		159,
		167,
		165,
		162,
		174,
		170,
		190,
		171,
		206,
		-1,
		309,
		-1,
		243,
		-1,
		-1,
		225,
		205,
		197,
		186,
		175,
		173,
		164,
		155,
		177,
		193,
		177,
		175,
		178,
		179,
		-1,
		298,
		297,
		-1,
		244,
		236,
		222,
		-1,
		215,
		-1,
		221,
		182,
		-1,
		184,
		164,
		-1,
		186,
		182,
		-1,
		-1,
		285,
		260,
		-1,
		-1,
		-1,
		245,
		225,
		216,
		200,
		-1,
		175,
		175,
		-1,
		-1,
		-1,
		270,
		269,
		-1,
		238,
		241,
		-1,
		231,
		222,
		230,
		177,
		181,
		-1,
		-1,
		-1,
		279,
		260,
		254,
		253,
		251,
		246,
		243,
		229,
		213,
		191,
		180,
		201,
		-1,
		-1,
		-1,
		251,
		243,
		236,
		-1,
		-1,
		238,
		221,
		202,
		200,
		-1,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		228,
		-1,
		-1,
		234,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		262,
		-1,
		-1,
		-1,
		224,
		220,
		221,
		-1,
		-1,
		-1,
		-1,
		284,
		285,
		308,
		272,
		-1,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		287,
		285,
		-1,
		-1,
		-1,
		244,
		228,
		-1,
		214,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		249,
		-1,
		249,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		262,
		254,
		262,
		-1,
		234,
		236,
		-1,
		284,
		-1,
		-1,
		277,
		268,
		-1,
		-1,
		239,
		246,
		268,
		271,
		307,
		-1,
		258
	],
	[
		-1,
		106,
		95,
		106,
		114,
		87,
		94,
		-1,
		115,
		117,
		83,
		77,
		116,
		87,
		93,
		104,
		-1,
		-1,
		-1,
		106,
		105,
		75,
		73,
		82,
		87,
		94,
		-1,
		117,
		-1,
		127,
		106,
		117,
		122,
		68,
		65,
		85,
		104,
		110,
		102,
		142,
		98,
		69,
		63,
		81,
		86,
		104,
		96,
		-1,
		69,
		59,
		81,
		85,
		97,
		80,
		-1,
		-1,
		63,
		64,
		70,
		82,
		87,
		92,
		-1,
		118,
		109,
		-1,
		-1,
		53,
		66,
		62,
		65,
		73,
		89,
		110,
		109,
		104,
		-1,
		-1,
		54,
		58,
		71,
		72,
		70,
		97,
		116,
		99,
		113,
		112,
		-1,
		42,
		60,
		69,
		78,
		84,
		73,
		77,
		95,
		98,
		104,
		107,
		-1,
		51,
		52,
		51,
		59,
		64,
		71,
		72,
		82,
		93,
		86,
		105,
		96,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		51,
		34,
		51,
		46,
		39,
		52,
		60,
		68,
		83,
		81,
		78,
		94,
		95,
		105,
		-1,
		-1,
		145,
		118,
		142,
		100,
		81,
		-1,
		47,
		27,
		33,
		37,
		37,
		39,
		57,
		55,
		-1,
		72,
		71,
		102,
		88,
		99,
		127,
		-1,
		-1,
		103,
		95,
		77,
		80,
		57,
		53,
		42,
		41,
		31,
		17,
		13,
		42,
		45,
		43,
		53,
		66,
		76,
		80,
		95,
		106,
		-1,
		-1,
		172,
		-1,
		-1,
		124,
		107,
		-1,
		72,
		79,
		63,
		69,
		55,
		76,
		52,
		41,
		33,
		19,
		7,
		27,
		37,
		58,
		49,
		63,
		88,
		92,
		97,
		116,
		113,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		79,
		76,
		69,
		93,
		92,
		-1,
		62,
		50,
		51,
		36,
		33,
		28,
		0,
		30,
		37,
		50,
		52,
		70,
		72,
		105,
		94,
		116,
		113,
		142,
		147,
		141,
		150,
		-1,
		132,
		128,
		124,
		131,
		80,
		-1,
		-1,
		97,
		-1,
		100,
		99,
		74,
		47,
		50,
		37,
		45,
		28,
		6,
		24,
		40,
		43,
		63,
		76,
		83,
		89,
		88,
		106,
		121,
		134,
		138,
		144,
		-1,
		182,
		-1,
		124,
		108,
		110,
		86,
		114,
		-1,
		117,
		101,
		91,
		76,
		76,
		-1,
		53,
		50,
		53,
		31,
		16,
		33,
		47,
		51,
		62,
		78,
		92,
		83,
		101,
		108,
		116,
		120,
		140,
		152,
		142,
		132,
		-1,
		114,
		119,
		89,
		101,
		124,
		144,
		112,
		-1,
		87,
		-1,
		55,
		68,
		-1,
		37,
		33,
		22,
		38,
		52,
		65,
		69,
		74,
		71,
		89,
		92,
		109,
		113,
		129,
		-1,
		-1,
		127,
		131,
		139,
		90,
		109,
		133,
		158,
		105,
		94,
		93,
		-1,
		73,
		58,
		55,
		56,
		42,
		35,
		36,
		58,
		70,
		54,
		73,
		76,
		98,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		116,
		87,
		111,
		153,
		123,
		116,
		104,
		104,
		104,
		97,
		-1,
		73,
		52,
		49,
		40,
		48,
		62,
		59,
		73,
		77,
		76,
		95,
		107,
		98,
		118,
		-1,
		-1,
		-1,
		146,
		135,
		136,
		90,
		124,
		142,
		137,
		123,
		128,
		103,
		96,
		90,
		67,
		69,
		64,
		58,
		50,
		39,
		55,
		63,
		65,
		74,
		83,
		89,
		113,
		120,
		126,
		-1,
		-1,
		153,
		143,
		127,
		129,
		126,
		115,
		122,
		154,
		128,
		141,
		-1,
		95,
		-1,
		84,
		79,
		63,
		58,
		55,
		52,
		46,
		55,
		69,
		80,
		76,
		83,
		118,
		118,
		110,
		130,
		133,
		-1,
		-1,
		-1,
		146,
		162,
		137,
		114,
		96,
		132,
		-1,
		111,
		112,
		-1,
		89,
		83,
		80,
		65,
		61,
		56,
		60,
		53,
		60,
		56,
		70,
		81,
		68,
		104,
		-1,
		118,
		112,
		120,
		110,
		98,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		93,
		145,
		-1,
		-1,
		96,
		89,
		-1,
		76,
		58,
		65,
		63,
		57,
		61,
		65,
		54,
		67,
		72,
		73,
		83,
		103,
		107,
		111,
		100,
		96,
		93,
		107,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		113,
		-1,
		105,
		97,
		87,
		81,
		75,
		71,
		69,
		85,
		69,
		72,
		72,
		68,
		76,
		61,
		64,
		76,
		80,
		98,
		106,
		98,
		92,
		91,
		103,
		-1,
		180,
		166,
		137,
		-1,
		-1,
		126,
		-1,
		90,
		104,
		120,
		-1,
		113,
		92,
		107,
		85,
		81,
		77,
		92,
		93,
		71,
		76,
		75,
		85,
		86,
		75,
		88,
		80,
		102,
		102,
		86,
		87,
		96,
		-1,
		186,
		173,
		131,
		127,
		116,
		136,
		87,
		75,
		107,
		-1,
		-1,
		149,
		-1,
		83,
		100,
		91,
		89,
		82,
		73,
		79,
		86,
		89,
		90,
		80,
		69,
		75,
		74,
		96,
		82,
		80,
		99,
		115,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		102,
		89,
		83,
		-1,
		124,
		-1,
		127,
		117,
		101,
		86,
		119,
		-1,
		90,
		74,
		79,
		-1,
		115,
		-1,
		88,
		90,
		82,
		71,
		68,
		79,
		77,
		88,
		105,
		-1,
		136,
		121,
		114,
		104,
		118,
		89,
		-1,
		144,
		-1,
		-1,
		114,
		108,
		108,
		92,
		95,
		106,
		86,
		80,
		79,
		110,
		108,
		96,
		80,
		73,
		70,
		71,
		84,
		104,
		95,
		107,
		-1,
		-1,
		-1,
		141,
		127,
		131,
		91,
		110,
		-1,
		-1,
		176,
		131,
		117,
		-1,
		101,
		123,
		111,
		101,
		91,
		125,
		124,
		99,
		92,
		78,
		80,
		78,
		80,
		85,
		106,
		107,
		120,
		-1,
		-1,
		124,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		123,
		139,
		131,
		102,
		112,
		-1,
		-1,
		103,
		101,
		111,
		95,
		82,
		102,
		105,
		95,
		79,
		94,
		106,
		114,
		119,
		-1,
		127,
		114,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		156,
		122,
		134,
		136,
		140,
		106,
		-1,
		111,
		106,
		86,
		100,
		107,
		97,
		92,
		86,
		89,
		107,
		124,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		113,
		127,
		129,
		122,
		126,
		-1,
		114,
		102,
		88,
		105,
		110,
		107,
		98,
		90,
		95,
		92,
		105,
		119,
		123,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		131,
		146,
		168,
		145,
		118,
		113,
		106,
		100,
		96,
		112,
		118,
		129,
		97,
		93,
		94,
		98,
		97,
		114,
		124,
		-1,
		-1,
		145,
		162,
		157,
		139,
		143,
		195,
		-1,
		-1,
		122,
		113,
		104,
		107,
		106,
		109,
		103,
		100,
		105,
		110,
		98,
		107,
		125,
		124,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		158,
		193,
		140,
		122,
		118,
		116,
		109,
		118,
		113,
		108,
		118,
		120,
		112,
		100,
		104,
		127,
		116,
		155,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		194,
		169,
		184,
		204,
		178,
		185,
		155,
		152,
		-1,
		122,
		147,
		119,
		126,
		117,
		124,
		124,
		116,
		94,
		101,
		117,
		116,
		111,
		147,
		138,
		144,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		200,
		186,
		190,
		180,
		183,
		-1,
		-1,
		171,
		168,
		144,
		127,
		125,
		118,
		113,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		135,
		150,
		-1,
		172,
		253,
		246,
		229,
		237,
		268,
		-1,
		194,
		186,
		193,
		172,
		174,
		-1,
		-1,
		144,
		141,
		146,
		134,
		131,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		134,
		124,
		137,
		141,
		-1,
		186,
		229,
		223,
		226,
		250,
		264,
		-1,
		191,
		-1,
		-1,
		201,
		175,
		159,
		149,
		143,
		193,
		148,
		143,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		134,
		134,
		135,
		-1,
		221,
		209,
		217,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		217,
		-1,
		186,
		-1,
		161,
		165,
		156,
		159,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		141,
		142,
		262,
		218,
		217,
		208,
		243,
		258,
		262,
		-1,
		203,
		242,
		240,
		-1,
		224,
		-1,
		-1,
		-1,
		175,
		169,
		161,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		150,
		258,
		249,
		262,
		207,
		207,
		228,
		237,
		258,
		218,
		209,
		236,
		247,
		236,
		231,
		218,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		251,
		250,
		239,
		236,
		212,
		203,
		198,
		225,
		-1,
		-1,
		220,
		237,
		231,
		235,
		251,
		276,
		-1,
		207,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		235,
		232,
		220,
		218,
		241,
		206,
		194,
		-1,
		207,
		205,
		211,
		218,
		235,
		265,
		-1,
		-1,
		223,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		244,
		258,
		247,
		243,
		242,
		250,
		199,
		192,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		278,
		-1,
		230,
		206,
		220,
		235,
		243,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		218,
		221,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		225,
		226,
		227,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		125,
		114,
		125,
		133,
		106,
		113,
		-1,
		134,
		136,
		102,
		96,
		135,
		106,
		112,
		123,
		-1,
		-1,
		-1,
		125,
		124,
		94,
		92,
		101,
		106,
		113,
		-1,
		124,
		-1,
		146,
		125,
		136,
		141,
		87,
		84,
		104,
		123,
		117,
		109,
		161,
		117,
		88,
		82,
		100,
		102,
		111,
		103,
		-1,
		88,
		78,
		100,
		91,
		102,
		94,
		-1,
		-1,
		82,
		83,
		89,
		87,
		93,
		89,
		-1,
		99,
		93,
		-1,
		-1,
		72,
		85,
		69,
		72,
		80,
		78,
		91,
		93,
		88,
		-1,
		-1,
		73,
		71,
		78,
		65,
		61,
		78,
		97,
		83,
		97,
		96,
		-1,
		61,
		75,
		71,
		72,
		70,
		54,
		58,
		76,
		82,
		88,
		91,
		-1,
		70,
		71,
		46,
		54,
		59,
		62,
		50,
		63,
		77,
		70,
		89,
		80,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		70,
		53,
		60,
		42,
		32,
		47,
		40,
		46,
		66,
		65,
		62,
		78,
		79,
		89,
		-1,
		-1,
		164,
		137,
		161,
		119,
		100,
		-1,
		66,
		46,
		40,
		36,
		30,
		23,
		37,
		33,
		-1,
		56,
		55,
		86,
		72,
		83,
		146,
		-1,
		-1,
		122,
		114,
		96,
		99,
		76,
		72,
		61,
		60,
		53,
		44,
		40,
		20,
		23,
		23,
		33,
		50,
		60,
		64,
		79,
		90,
		-1,
		-1,
		164,
		-1,
		-1,
		143,
		126,
		-1,
		91,
		98,
		82,
		88,
		74,
		95,
		71,
		62,
		56,
		51,
		40,
		18,
		15,
		39,
		35,
		47,
		72,
		76,
		82,
		100,
		101,
		-1,
		163,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		98,
		95,
		88,
		112,
		111,
		-1,
		89,
		77,
		78,
		63,
		60,
		47,
		33,
		0,
		21,
		36,
		38,
		54,
		56,
		89,
		84,
		105,
		102,
		133,
		139,
		133,
		142,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		116,
		-1,
		119,
		126,
		101,
		74,
		77,
		64,
		55,
		42,
		29,
		6,
		24,
		27,
		47,
		60,
		67,
		81,
		80,
		98,
		111,
		126,
		130,
		136,
		-1,
		201,
		-1,
		143,
		127,
		129,
		105,
		133,
		-1,
		136,
		120,
		118,
		103,
		103,
		-1,
		73,
		70,
		60,
		38,
		23,
		31,
		31,
		35,
		46,
		67,
		84,
		75,
		93,
		100,
		108,
		112,
		132,
		144,
		161,
		151,
		-1,
		133,
		138,
		108,
		120,
		143,
		163,
		139,
		-1,
		114,
		-1,
		75,
		88,
		-1,
		44,
		40,
		29,
		45,
		42,
		49,
		53,
		66,
		63,
		81,
		84,
		101,
		105,
		121,
		-1,
		-1,
		146,
		150,
		158,
		109,
		128,
		152,
		185,
		132,
		121,
		120,
		-1,
		93,
		63,
		60,
		61,
		48,
		42,
		43,
		48,
		54,
		61,
		65,
		68,
		90,
		118,
		96,
		108,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		135,
		106,
		130,
		172,
		150,
		143,
		131,
		111,
		111,
		105,
		-1,
		79,
		58,
		56,
		47,
		55,
		69,
		66,
		80,
		69,
		71,
		87,
		99,
		90,
		110,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		109,
		133,
		161,
		144,
		130,
		135,
		110,
		103,
		97,
		72,
		75,
		70,
		65,
		57,
		46,
		62,
		70,
		71,
		71,
		80,
		81,
		105,
		112,
		118,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		124,
		131,
		163,
		135,
		148,
		-1,
		102,
		-1,
		91,
		86,
		70,
		65,
		62,
		59,
		53,
		62,
		76,
		85,
		76,
		90,
		110,
		110,
		102,
		127,
		130,
		-1,
		-1,
		-1,
		165,
		169,
		144,
		121,
		105,
		141,
		-1,
		118,
		119,
		-1,
		96,
		90,
		87,
		72,
		68,
		63,
		67,
		60,
		67,
		63,
		77,
		88,
		75,
		111,
		-1,
		110,
		104,
		127,
		117,
		105,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		83,
		65,
		72,
		70,
		64,
		68,
		72,
		61,
		74,
		79,
		80,
		90,
		110,
		114,
		118,
		107,
		103,
		100,
		114,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		78,
		76,
		92,
		76,
		79,
		79,
		75,
		83,
		68,
		71,
		83,
		87,
		105,
		113,
		105,
		99,
		98,
		110,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		88,
		84,
		99,
		100,
		78,
		83,
		82,
		92,
		93,
		82,
		95,
		87,
		109,
		109,
		93,
		94,
		103,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		98,
		96,
		89,
		80,
		86,
		93,
		96,
		97,
		87,
		76,
		82,
		81,
		103,
		89,
		87,
		106,
		122,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		97,
		81,
		86,
		-1,
		122,
		-1,
		95,
		97,
		89,
		78,
		75,
		86,
		84,
		95,
		112,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		113,
		93,
		87,
		86,
		117,
		115,
		103,
		87,
		80,
		77,
		78,
		91,
		111,
		102,
		114,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		130,
		118,
		108,
		98,
		132,
		131,
		106,
		99,
		85,
		87,
		85,
		87,
		92,
		113,
		114,
		127,
		-1,
		-1,
		131,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		119,
		-1,
		-1,
		110,
		108,
		118,
		102,
		89,
		109,
		112,
		102,
		86,
		101,
		113,
		121,
		126,
		-1,
		134,
		121,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		143,
		147,
		113,
		-1,
		118,
		113,
		93,
		107,
		114,
		104,
		99,
		93,
		96,
		114,
		131,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		136,
		129,
		133,
		-1,
		121,
		109,
		95,
		112,
		117,
		114,
		105,
		97,
		102,
		99,
		112,
		126,
		130,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		138,
		153,
		175,
		152,
		125,
		120,
		113,
		107,
		103,
		119,
		125,
		136,
		104,
		100,
		101,
		105,
		104,
		121,
		131,
		-1,
		-1,
		152,
		169,
		164,
		146,
		150,
		202,
		-1,
		-1,
		129,
		120,
		111,
		114,
		113,
		116,
		110,
		107,
		112,
		117,
		105,
		114,
		132,
		131,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		165,
		200,
		147,
		129,
		125,
		123,
		116,
		125,
		120,
		115,
		125,
		127,
		119,
		107,
		111,
		134,
		123,
		162,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		201,
		176,
		191,
		211,
		185,
		192,
		162,
		159,
		-1,
		129,
		154,
		126,
		133,
		124,
		131,
		131,
		123,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		207,
		193,
		197,
		187,
		190,
		-1,
		-1,
		178,
		175,
		151,
		134,
		132,
		125,
		120,
		130,
		110,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		201,
		193,
		200,
		179,
		181,
		-1,
		-1,
		151,
		148,
		153,
		141,
		138,
		140,
		135,
		126,
		111,
		117,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		198,
		-1,
		-1,
		208,
		182,
		166,
		156,
		150,
		200,
		155,
		150,
		134,
		132,
		123,
		114,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		224,
		-1,
		193,
		-1,
		168,
		172,
		163,
		166,
		148,
		135,
		127,
		119,
		135,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		269,
		225,
		224,
		215,
		250,
		265,
		269,
		-1,
		210,
		249,
		247,
		-1,
		231,
		-1,
		-1,
		-1,
		182,
		176,
		168,
		168,
		147,
		147,
		121,
		125,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		265,
		256,
		269,
		214,
		214,
		235,
		244,
		265,
		225,
		216,
		243,
		254,
		243,
		238,
		225,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		154,
		142,
		125,
		126,
		122,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		205,
		232,
		-1,
		-1,
		227,
		244,
		238,
		242,
		258,
		283,
		-1,
		214,
		-1,
		-1,
		199,
		-1,
		-1,
		184,
		147,
		136,
		127,
		133,
		130,
		141,
		151,
		139,
		140,
		130,
		140,
		153,
		242,
		239,
		227,
		225,
		248,
		213,
		201,
		-1,
		214,
		212,
		218,
		225,
		242,
		272,
		-1,
		-1,
		230,
		210,
		-1,
		-1,
		182,
		180,
		169,
		-1,
		159,
		132,
		137,
		157,
		159,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		199,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		216,
		-1,
		-1,
		177,
		170,
		158,
		146,
		136,
		146,
		150,
		154,
		146,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		285,
		-1,
		237,
		213,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		211,
		195,
		176,
		-1,
		146,
		159,
		190,
		158,
		163,
		158,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		225,
		228,
		-1,
		-1,
		227,
		229,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		183,
		179,
		-1,
		-1,
		147,
		172,
		161,
		169,
		164,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		232,
		233,
		234,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		185,
		148,
		169,
		179,
		173,
		171,
		162,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		149,
		175,
		178,
		184,
		178,
		151,
		166,
		156,
		147,
		156,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		200,
		185,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		190,
		186,
		173,
		173,
		165,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		166,
		201,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		173,
		174,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		118,
		107,
		118,
		126,
		99,
		106,
		-1,
		127,
		129,
		95,
		89,
		128,
		99,
		105,
		116,
		-1,
		-1,
		-1,
		118,
		117,
		87,
		85,
		94,
		99,
		106,
		-1,
		113,
		-1,
		139,
		118,
		129,
		134,
		80,
		77,
		97,
		116,
		106,
		98,
		154,
		110,
		81,
		75,
		93,
		91,
		100,
		92,
		-1,
		81,
		71,
		93,
		80,
		91,
		83,
		-1,
		-1,
		75,
		76,
		82,
		76,
		82,
		78,
		-1,
		88,
		72,
		-1,
		-1,
		65,
		74,
		58,
		61,
		69,
		67,
		80,
		72,
		67,
		-1,
		-1,
		64,
		60,
		67,
		54,
		50,
		67,
		80,
		62,
		76,
		75,
		-1,
		54,
		68,
		64,
		61,
		59,
		43,
		41,
		59,
		61,
		67,
		70,
		-1,
		63,
		64,
		39,
		47,
		52,
		55,
		43,
		46,
		56,
		49,
		68,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		63,
		46,
		53,
		35,
		25,
		40,
		33,
		39,
		46,
		44,
		41,
		57,
		58,
		68,
		-1,
		-1,
		157,
		130,
		154,
		112,
		93,
		-1,
		59,
		39,
		33,
		29,
		23,
		16,
		30,
		26,
		-1,
		35,
		34,
		65,
		51,
		62,
		139,
		-1,
		-1,
		115,
		107,
		89,
		92,
		69,
		65,
		54,
		53,
		46,
		39,
		35,
		13,
		16,
		16,
		22,
		29,
		39,
		43,
		58,
		69,
		-1,
		-1,
		143,
		-1,
		-1,
		136,
		119,
		-1,
		84,
		91,
		75,
		81,
		67,
		88,
		64,
		55,
		49,
		44,
		36,
		11,
		8,
		21,
		14,
		26,
		51,
		55,
		61,
		79,
		80,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		91,
		88,
		81,
		105,
		104,
		-1,
		84,
		72,
		73,
		58,
		57,
		51,
		40,
		16,
		0,
		15,
		17,
		33,
		35,
		68,
		63,
		84,
		81,
		112,
		118,
		112,
		121,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		109,
		-1,
		112,
		121,
		96,
		69,
		72,
		59,
		59,
		46,
		36,
		17,
		3,
		6,
		26,
		39,
		46,
		60,
		59,
		77,
		90,
		105,
		109,
		115,
		-1,
		194,
		-1,
		136,
		120,
		122,
		98,
		126,
		-1,
		129,
		113,
		113,
		98,
		98,
		-1,
		75,
		72,
		64,
		42,
		33,
		21,
		10,
		14,
		25,
		46,
		63,
		54,
		72,
		79,
		87,
		91,
		111,
		123,
		154,
		144,
		-1,
		126,
		131,
		101,
		113,
		136,
		156,
		134,
		-1,
		109,
		-1,
		77,
		90,
		-1,
		48,
		44,
		34,
		32,
		21,
		28,
		32,
		45,
		42,
		60,
		63,
		80,
		84,
		100,
		-1,
		-1,
		139,
		143,
		151,
		102,
		121,
		145,
		180,
		127,
		116,
		115,
		-1,
		95,
		67,
		64,
		65,
		52,
		46,
		44,
		27,
		33,
		42,
		44,
		47,
		69,
		97,
		75,
		87,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		128,
		99,
		123,
		165,
		145,
		138,
		126,
		97,
		97,
		91,
		-1,
		83,
		62,
		55,
		44,
		34,
		50,
		45,
		61,
		48,
		50,
		66,
		78,
		69,
		89,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		96,
		119,
		154,
		130,
		116,
		121,
		96,
		89,
		83,
		76,
		79,
		62,
		51,
		43,
		32,
		48,
		55,
		50,
		50,
		59,
		60,
		84,
		91,
		97,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		110,
		117,
		149,
		121,
		134,
		-1,
		88,
		-1,
		77,
		72,
		56,
		51,
		48,
		45,
		39,
		48,
		56,
		64,
		55,
		70,
		89,
		89,
		81,
		106,
		109,
		-1,
		-1,
		-1,
		158,
		155,
		130,
		107,
		91,
		127,
		-1,
		104,
		105,
		-1,
		82,
		76,
		73,
		58,
		54,
		49,
		53,
		46,
		53,
		49,
		63,
		74,
		56,
		92,
		-1,
		89,
		83,
		111,
		103,
		91,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		86,
		138,
		-1,
		-1,
		89,
		82,
		-1,
		69,
		51,
		58,
		56,
		50,
		54,
		58,
		47,
		60,
		65,
		61,
		71,
		91,
		95,
		102,
		93,
		89,
		86,
		100,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		106,
		-1,
		98,
		90,
		80,
		74,
		68,
		64,
		62,
		78,
		62,
		65,
		65,
		61,
		69,
		54,
		57,
		64,
		68,
		86,
		99,
		91,
		85,
		84,
		96,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		119,
		-1,
		83,
		97,
		113,
		-1,
		106,
		85,
		100,
		78,
		74,
		70,
		85,
		86,
		64,
		69,
		68,
		78,
		79,
		68,
		76,
		73,
		95,
		95,
		79,
		80,
		89,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		80,
		68,
		100,
		-1,
		-1,
		142,
		-1,
		76,
		93,
		84,
		82,
		75,
		66,
		72,
		79,
		82,
		83,
		73,
		62,
		68,
		67,
		89,
		75,
		73,
		92,
		108,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		117,
		-1,
		120,
		110,
		94,
		79,
		112,
		-1,
		83,
		67,
		72,
		-1,
		108,
		-1,
		81,
		83,
		75,
		64,
		61,
		72,
		70,
		81,
		98,
		-1,
		129,
		114,
		107,
		97,
		111,
		82,
		-1,
		137,
		-1,
		-1,
		107,
		101,
		101,
		85,
		88,
		99,
		79,
		73,
		72,
		103,
		101,
		89,
		73,
		66,
		63,
		64,
		77,
		97,
		88,
		100,
		-1,
		-1,
		-1,
		134,
		120,
		124,
		84,
		103,
		-1,
		-1,
		169,
		124,
		110,
		-1,
		94,
		116,
		104,
		94,
		84,
		118,
		117,
		92,
		85,
		71,
		73,
		71,
		73,
		78,
		99,
		100,
		113,
		-1,
		-1,
		117,
		122,
		110,
		96,
		115,
		-1,
		-1,
		-1,
		116,
		132,
		124,
		95,
		105,
		-1,
		-1,
		96,
		94,
		104,
		88,
		75,
		95,
		98,
		88,
		72,
		87,
		99,
		107,
		112,
		-1,
		120,
		107,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		-1,
		-1,
		149,
		115,
		127,
		129,
		133,
		99,
		-1,
		104,
		99,
		79,
		93,
		100,
		90,
		85,
		79,
		82,
		100,
		117,
		-1,
		-1,
		132,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		106,
		120,
		122,
		115,
		119,
		-1,
		107,
		95,
		81,
		98,
		103,
		100,
		91,
		83,
		88,
		85,
		98,
		112,
		116,
		155,
		-1,
		138,
		-1,
		-1,
		-1,
		124,
		139,
		161,
		138,
		111,
		106,
		99,
		93,
		89,
		105,
		111,
		122,
		90,
		86,
		87,
		91,
		90,
		107,
		117,
		-1,
		-1,
		138,
		155,
		150,
		132,
		136,
		188,
		-1,
		-1,
		115,
		106,
		97,
		100,
		99,
		102,
		96,
		93,
		98,
		103,
		91,
		100,
		118,
		117,
		-1,
		-1,
		-1,
		158,
		-1,
		173,
		-1,
		-1,
		151,
		186,
		133,
		115,
		111,
		109,
		102,
		111,
		106,
		101,
		111,
		113,
		105,
		93,
		97,
		120,
		109,
		148,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		187,
		162,
		177,
		197,
		171,
		178,
		148,
		145,
		-1,
		115,
		140,
		112,
		119,
		110,
		117,
		117,
		109,
		87,
		94,
		110,
		109,
		104,
		140,
		131,
		137,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		193,
		179,
		183,
		173,
		176,
		-1,
		-1,
		164,
		161,
		137,
		120,
		118,
		111,
		106,
		116,
		96,
		83,
		87,
		91,
		97,
		102,
		107,
		113,
		128,
		143,
		-1,
		165,
		246,
		239,
		222,
		230,
		261,
		-1,
		187,
		179,
		186,
		165,
		167,
		-1,
		-1,
		137,
		134,
		139,
		127,
		124,
		126,
		121,
		112,
		97,
		103,
		90,
		89,
		107,
		111,
		120,
		127,
		117,
		130,
		134,
		-1,
		179,
		222,
		216,
		219,
		243,
		257,
		-1,
		184,
		-1,
		-1,
		194,
		168,
		152,
		142,
		136,
		186,
		141,
		136,
		120,
		118,
		109,
		100,
		107,
		98,
		98,
		101,
		116,
		121,
		113,
		127,
		127,
		128,
		-1,
		214,
		202,
		210,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		210,
		-1,
		179,
		-1,
		154,
		158,
		149,
		152,
		134,
		121,
		113,
		105,
		121,
		96,
		106,
		102,
		103,
		112,
		123,
		135,
		134,
		135,
		255,
		211,
		210,
		201,
		236,
		251,
		255,
		-1,
		196,
		235,
		233,
		-1,
		217,
		-1,
		-1,
		-1,
		168,
		162,
		154,
		154,
		133,
		133,
		107,
		111,
		101,
		108,
		118,
		120,
		112,
		116,
		129,
		140,
		143,
		251,
		242,
		255,
		200,
		200,
		221,
		230,
		251,
		211,
		202,
		229,
		240,
		229,
		224,
		211,
		-1,
		-1,
		191,
		172,
		-1,
		-1,
		140,
		128,
		111,
		112,
		108,
		111,
		126,
		129,
		119,
		117,
		111,
		143,
		-1,
		244,
		243,
		232,
		229,
		205,
		196,
		191,
		218,
		-1,
		-1,
		213,
		230,
		224,
		228,
		244,
		269,
		-1,
		200,
		-1,
		-1,
		185,
		-1,
		-1,
		170,
		133,
		122,
		113,
		119,
		116,
		127,
		137,
		125,
		126,
		116,
		126,
		139,
		228,
		225,
		213,
		211,
		234,
		199,
		187,
		-1,
		200,
		198,
		204,
		211,
		228,
		258,
		-1,
		-1,
		216,
		196,
		-1,
		-1,
		168,
		166,
		155,
		-1,
		145,
		118,
		123,
		143,
		145,
		134,
		128,
		122,
		129,
		128,
		136,
		144,
		237,
		251,
		240,
		236,
		235,
		243,
		192,
		185,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		202,
		-1,
		-1,
		163,
		156,
		144,
		132,
		122,
		132,
		136,
		140,
		132,
		125,
		120,
		131,
		123,
		127,
		144,
		-1,
		271,
		-1,
		223,
		199,
		213,
		228,
		236,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		197,
		181,
		162,
		-1,
		132,
		145,
		176,
		144,
		149,
		144,
		126,
		137,
		126,
		129,
		143,
		138,
		-1,
		-1,
		211,
		214,
		-1,
		-1,
		213,
		215,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		169,
		165,
		-1,
		-1,
		133,
		158,
		147,
		155,
		150,
		130,
		136,
		139,
		128,
		132,
		144,
		-1,
		-1,
		218,
		219,
		220,
		-1,
		198,
		-1,
		216,
		-1,
		183,
		189,
		177,
		-1,
		-1,
		-1,
		171,
		134,
		155,
		165,
		159,
		157,
		148,
		134,
		141,
		139,
		135,
		146,
		-1,
		-1,
		-1,
		216,
		190,
		223,
		214,
		197,
		177,
		169,
		188,
		-1,
		158,
		-1,
		133,
		135,
		161,
		164,
		170,
		164,
		137,
		152,
		142,
		133,
		142,
		222,
		-1,
		192,
		225,
		189,
		183,
		159,
		163,
		179,
		-1,
		155,
		137,
		-1,
		165,
		155,
		186,
		171,
		152,
		139,
		146,
		146,
		139,
		-1,
		-1,
		-1,
		194,
		193,
		185,
		179,
		179,
		164,
		155,
		-1,
		167,
		149,
		128,
		145,
		145,
		136,
		144,
		176,
		172,
		159,
		159,
		151,
		-1,
		295,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		188,
		183,
		156,
		144,
		150,
		146,
		132,
		138,
		140,
		148,
		146,
		143,
		155,
		151,
		171,
		152,
		187,
		-1,
		290,
		-1,
		224,
		-1,
		-1,
		206,
		186,
		178,
		167,
		156,
		154,
		145,
		136,
		158,
		174,
		158,
		156,
		159,
		160,
		-1,
		279,
		278,
		-1,
		225,
		217,
		203,
		-1,
		196,
		-1,
		202,
		163,
		-1,
		165,
		145,
		-1,
		167,
		163,
		-1,
		-1,
		266,
		241,
		-1,
		-1,
		-1,
		226,
		206,
		197,
		181,
		-1,
		156,
		156,
		-1,
		-1,
		-1,
		251,
		250,
		-1,
		219,
		222,
		-1,
		212,
		203,
		211,
		158,
		162,
		-1,
		-1,
		-1,
		260,
		241,
		235,
		234,
		232,
		227,
		224,
		210,
		194,
		172,
		161,
		182,
		-1,
		-1,
		-1,
		232,
		224,
		217,
		-1,
		-1,
		219,
		202,
		183,
		181,
		-1,
		-1,
		-1,
		254,
		235,
		-1,
		-1,
		209,
		-1,
		-1,
		215,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		243,
		-1,
		-1,
		-1,
		205,
		201,
		202,
		-1,
		-1,
		-1,
		-1,
		265,
		266,
		289,
		253,
		-1,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		268,
		266,
		-1,
		-1,
		-1,
		225,
		209,
		-1,
		195,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		230,
		-1,
		230,
		205,
		212,
		-1,
		-1,
		-1,
		-1,
		243,
		235,
		243,
		-1,
		215,
		217,
		-1,
		265,
		-1,
		-1,
		258,
		249,
		-1,
		-1,
		220,
		227,
		249,
		252,
		288,
		-1,
		239
	],
	[
		-1,
		130,
		119,
		130,
		138,
		111,
		118,
		-1,
		137,
		141,
		107,
		101,
		140,
		109,
		115,
		126,
		-1,
		-1,
		-1,
		130,
		129,
		97,
		95,
		104,
		109,
		116,
		-1,
		115,
		-1,
		151,
		130,
		141,
		146,
		90,
		87,
		107,
		126,
		108,
		100,
		166,
		120,
		91,
		85,
		103,
		93,
		102,
		94,
		-1,
		91,
		81,
		103,
		82,
		93,
		85,
		-1,
		-1,
		85,
		86,
		92,
		78,
		84,
		80,
		-1,
		90,
		74,
		-1,
		-1,
		75,
		76,
		60,
		63,
		71,
		69,
		82,
		74,
		69,
		-1,
		-1,
		66,
		62,
		69,
		56,
		52,
		69,
		82,
		64,
		78,
		77,
		-1,
		69,
		83,
		79,
		63,
		61,
		45,
		43,
		61,
		63,
		69,
		72,
		-1,
		78,
		79,
		54,
		62,
		67,
		61,
		48,
		48,
		58,
		51,
		70,
		61,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		78,
		61,
		68,
		50,
		40,
		55,
		48,
		51,
		48,
		46,
		43,
		59,
		60,
		70,
		-1,
		-1,
		172,
		145,
		169,
		127,
		108,
		-1,
		74,
		54,
		48,
		44,
		38,
		31,
		45,
		41,
		-1,
		37,
		36,
		67,
		53,
		64,
		154,
		-1,
		-1,
		130,
		122,
		104,
		107,
		84,
		80,
		69,
		68,
		61,
		54,
		50,
		28,
		31,
		31,
		37,
		31,
		41,
		45,
		60,
		71,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		134,
		-1,
		99,
		106,
		90,
		96,
		82,
		103,
		79,
		70,
		64,
		59,
		51,
		26,
		23,
		36,
		15,
		28,
		53,
		57,
		63,
		81,
		82,
		-1,
		144,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		106,
		103,
		96,
		120,
		119,
		-1,
		99,
		87,
		88,
		73,
		72,
		64,
		53,
		31,
		15,
		0,
		12,
		35,
		37,
		70,
		65,
		86,
		83,
		114,
		120,
		114,
		123,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		124,
		-1,
		127,
		136,
		111,
		84,
		87,
		74,
		72,
		59,
		49,
		30,
		18,
		21,
		28,
		41,
		48,
		62,
		61,
		79,
		92,
		107,
		111,
		117,
		-1,
		209,
		-1,
		151,
		135,
		137,
		113,
		141,
		-1,
		144,
		128,
		128,
		113,
		113,
		-1,
		90,
		87,
		77,
		55,
		46,
		36,
		22,
		17,
		27,
		48,
		65,
		56,
		74,
		81,
		89,
		93,
		113,
		125,
		169,
		159,
		-1,
		141,
		146,
		116,
		127,
		146,
		171,
		148,
		-1,
		124,
		-1,
		92,
		105,
		-1,
		61,
		57,
		42,
		40,
		29,
		32,
		34,
		47,
		44,
		62,
		65,
		82,
		86,
		102,
		-1,
		-1,
		154,
		158,
		161,
		112,
		131,
		155,
		192,
		141,
		130,
		129,
		-1,
		110,
		78,
		75,
		76,
		62,
		54,
		52,
		35,
		41,
		50,
		46,
		49,
		71,
		99,
		77,
		89,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		138,
		109,
		133,
		175,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		93,
		72,
		63,
		52,
		42,
		58,
		53,
		69,
		50,
		52,
		68,
		80,
		71,
		91,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		138,
		124,
		129,
		104,
		97,
		91,
		87,
		89,
		70,
		59,
		51,
		40,
		56,
		63,
		58,
		52,
		61,
		62,
		86,
		93,
		99,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		80,
		64,
		59,
		56,
		53,
		47,
		56,
		64,
		66,
		57,
		72,
		91,
		91,
		83,
		108,
		111,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		81,
		66,
		62,
		57,
		61,
		54,
		61,
		57,
		71,
		76,
		58,
		94,
		-1,
		91,
		85,
		113,
		111,
		99,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		66,
		64,
		58,
		62,
		66,
		55,
		68,
		73,
		63,
		73,
		93,
		97,
		104,
		97,
		97,
		94,
		108,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		72,
		70,
		86,
		70,
		73,
		73,
		69,
		77,
		62,
		65,
		66,
		70,
		88,
		107,
		99,
		93,
		92,
		104,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		82,
		78,
		93,
		94,
		72,
		77,
		76,
		86,
		87,
		76,
		78,
		81,
		97,
		103,
		87,
		88,
		97,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		92,
		90,
		83,
		74,
		80,
		87,
		90,
		91,
		81,
		70,
		76,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		91,
		75,
		80,
		-1,
		116,
		-1,
		89,
		91,
		83,
		72,
		69,
		80,
		78,
		89,
		106,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		107,
		87,
		81,
		80,
		111,
		109,
		97,
		81,
		74,
		71,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		124,
		112,
		102,
		92,
		126,
		125,
		100,
		93,
		79,
		81,
		79,
		81,
		86,
		107,
		108,
		121,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		113,
		-1,
		-1,
		104,
		102,
		112,
		96,
		83,
		103,
		106,
		96,
		80,
		95,
		107,
		115,
		120,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		135,
		137,
		141,
		107,
		-1,
		112,
		107,
		87,
		101,
		108,
		98,
		93,
		87,
		90,
		108,
		125,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		130,
		123,
		127,
		-1,
		115,
		103,
		89,
		106,
		111,
		108,
		99,
		91,
		96,
		93,
		106,
		120,
		124,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		169,
		146,
		119,
		114,
		107,
		101,
		97,
		113,
		119,
		130,
		98,
		94,
		95,
		99,
		98,
		115,
		125,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		196,
		-1,
		-1,
		123,
		114,
		105,
		108,
		107,
		110,
		104,
		101,
		106,
		111,
		99,
		108,
		126,
		125,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		194,
		141,
		123,
		119,
		117,
		110,
		119,
		114,
		109,
		119,
		121,
		113,
		101,
		105,
		128,
		117,
		156,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		195,
		170,
		185,
		205,
		179,
		186,
		156,
		153,
		-1,
		123,
		148,
		120,
		127,
		118,
		125,
		125,
		117,
		95,
		102,
		118,
		117,
		112,
		148,
		139,
		145,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		201,
		187,
		191,
		181,
		184,
		-1,
		-1,
		172,
		169,
		145,
		128,
		126,
		119,
		114,
		124,
		104,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		195,
		187,
		194,
		173,
		175,
		-1,
		-1,
		145,
		142,
		147,
		135,
		132,
		134,
		129,
		120,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		192,
		-1,
		-1,
		202,
		176,
		160,
		150,
		144,
		194,
		149,
		144,
		128,
		126,
		117,
		108,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		218,
		-1,
		187,
		-1,
		162,
		166,
		157,
		160,
		142,
		129,
		121,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		263,
		219,
		218,
		209,
		244,
		259,
		263,
		-1,
		204,
		243,
		241,
		-1,
		225,
		-1,
		-1,
		-1,
		176,
		170,
		162,
		162,
		141,
		141,
		115,
		119,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		259,
		250,
		263,
		208,
		208,
		229,
		238,
		259,
		219,
		210,
		237,
		248,
		237,
		232,
		219,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		148,
		136,
		119,
		120,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		199,
		226,
		-1,
		-1,
		221,
		238,
		232,
		236,
		252,
		277,
		-1,
		208,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		236,
		233,
		221,
		219,
		242,
		207,
		195,
		-1,
		208,
		206,
		212,
		219,
		236,
		266,
		-1,
		-1,
		224,
		204,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		151,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		193,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		214,
		210,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		144,
		148,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		279,
		-1,
		231,
		207,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		231,
		217,
		210,
		198,
		196,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		221,
		223,
		-1,
		222,
		211,
		196,
		188,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		226,
		227,
		228,
		-1,
		206,
		-1,
		224,
		-1,
		191,
		197,
		185,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		224,
		198,
		231,
		222,
		205,
		185,
		177,
		196,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		230,
		-1,
		200,
		233,
		197,
		191,
		167,
		171,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		194,
		179,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		202,
		201,
		193,
		187,
		187,
		172,
		163,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		184,
		180,
		167,
		167,
		159,
		-1,
		303,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		196,
		191,
		164,
		152,
		158,
		154,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		160,
		195,
		-1,
		298,
		-1,
		232,
		-1,
		-1,
		214,
		194,
		186,
		175,
		164,
		162,
		153,
		144,
		166,
		182,
		166,
		164,
		167,
		168,
		-1,
		287,
		286,
		-1,
		233,
		225,
		211,
		-1,
		204,
		-1,
		210,
		171,
		-1,
		173,
		153,
		-1,
		175,
		171,
		-1,
		-1,
		274,
		249,
		-1,
		-1,
		-1,
		234,
		214,
		205,
		189,
		-1,
		164,
		164,
		-1,
		-1,
		-1,
		259,
		258,
		-1,
		227,
		230,
		-1,
		220,
		211,
		219,
		166,
		170,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		242,
		240,
		235,
		232,
		218,
		202,
		180,
		169,
		190,
		-1,
		-1,
		-1,
		240,
		232,
		225,
		-1,
		-1,
		227,
		210,
		191,
		189,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		217,
		-1,
		-1,
		223,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		251,
		-1,
		-1,
		-1,
		213,
		209,
		210,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		297,
		261,
		-1,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		233,
		217,
		-1,
		203,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		238,
		-1,
		238,
		213,
		220,
		-1,
		-1,
		-1,
		-1,
		251,
		243,
		251,
		-1,
		223,
		225,
		-1,
		273,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		228,
		235,
		257,
		260,
		296,
		-1,
		247
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		138,
		142,
		108,
		102,
		141,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		131,
		130,
		98,
		96,
		105,
		110,
		117,
		-1,
		116,
		-1,
		152,
		131,
		142,
		147,
		91,
		88,
		108,
		127,
		109,
		101,
		167,
		121,
		92,
		86,
		104,
		94,
		103,
		95,
		-1,
		92,
		82,
		104,
		83,
		94,
		86,
		-1,
		-1,
		86,
		87,
		93,
		79,
		85,
		81,
		-1,
		91,
		75,
		-1,
		-1,
		76,
		77,
		61,
		64,
		72,
		70,
		83,
		75,
		70,
		-1,
		-1,
		67,
		63,
		70,
		57,
		53,
		70,
		83,
		65,
		79,
		78,
		-1,
		75,
		89,
		85,
		64,
		62,
		46,
		44,
		62,
		64,
		70,
		73,
		-1,
		84,
		85,
		60,
		68,
		73,
		62,
		49,
		49,
		59,
		52,
		71,
		62,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		84,
		67,
		74,
		56,
		46,
		61,
		54,
		52,
		49,
		47,
		44,
		60,
		61,
		71,
		-1,
		-1,
		178,
		151,
		175,
		133,
		114,
		-1,
		80,
		60,
		54,
		50,
		44,
		37,
		51,
		47,
		-1,
		38,
		37,
		68,
		54,
		65,
		160,
		-1,
		-1,
		136,
		128,
		110,
		113,
		90,
		86,
		75,
		74,
		67,
		60,
		56,
		34,
		37,
		37,
		40,
		32,
		42,
		46,
		61,
		72,
		-1,
		-1,
		146,
		-1,
		-1,
		157,
		140,
		-1,
		105,
		112,
		96,
		102,
		88,
		109,
		85,
		76,
		70,
		65,
		57,
		32,
		29,
		39,
		3,
		29,
		54,
		58,
		64,
		82,
		83,
		-1,
		145,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		112,
		109,
		102,
		126,
		125,
		-1,
		105,
		93,
		94,
		79,
		78,
		68,
		57,
		37,
		21,
		12,
		0,
		36,
		36,
		65,
		66,
		87,
		84,
		115,
		121,
		115,
		124,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		130,
		-1,
		133,
		142,
		117,
		90,
		93,
		80,
		76,
		63,
		53,
		34,
		24,
		27,
		23,
		36,
		43,
		63,
		62,
		80,
		93,
		108,
		112,
		118,
		-1,
		215,
		-1,
		157,
		141,
		143,
		119,
		145,
		-1,
		150,
		134,
		134,
		119,
		119,
		-1,
		94,
		91,
		81,
		59,
		50,
		42,
		31,
		28,
		28,
		43,
		66,
		57,
		75,
		82,
		90,
		94,
		114,
		126,
		175,
		165,
		-1,
		147,
		152,
		120,
		128,
		147,
		177,
		149,
		-1,
		130,
		-1,
		96,
		109,
		-1,
		65,
		61,
		53,
		41,
		30,
		37,
		35,
		46,
		45,
		63,
		66,
		83,
		87,
		103,
		-1,
		-1,
		160,
		164,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		114,
		84,
		81,
		82,
		69,
		55,
		53,
		36,
		42,
		51,
		47,
		50,
		72,
		100,
		78,
		90,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		94,
		73,
		64,
		53,
		43,
		59,
		54,
		70,
		51,
		53,
		69,
		81,
		72,
		92,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		93,
		90,
		71,
		60,
		52,
		41,
		57,
		64,
		59,
		53,
		62,
		63,
		87,
		94,
		100,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		81,
		65,
		60,
		57,
		54,
		48,
		57,
		65,
		67,
		58,
		73,
		92,
		92,
		84,
		109,
		112,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		67,
		63,
		58,
		62,
		55,
		62,
		58,
		72,
		77,
		59,
		95,
		-1,
		92,
		86,
		114,
		112,
		100,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		67,
		65,
		59,
		63,
		67,
		56,
		69,
		74,
		64,
		74,
		94,
		98,
		105,
		98,
		98,
		95,
		109,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		87,
		71,
		74,
		74,
		70,
		78,
		63,
		66,
		67,
		71,
		89,
		108,
		100,
		94,
		93,
		105,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		79,
		94,
		95,
		73,
		78,
		77,
		87,
		88,
		77,
		79,
		82,
		98,
		104,
		88,
		89,
		98,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		93,
		91,
		84,
		75,
		81,
		88,
		91,
		92,
		82,
		71,
		77,
		76,
		98,
		84,
		82,
		101,
		117,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		92,
		76,
		81,
		-1,
		117,
		-1,
		90,
		92,
		84,
		73,
		70,
		81,
		79,
		90,
		107,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		108,
		88,
		82,
		81,
		112,
		110,
		98,
		82,
		75,
		72,
		73,
		86,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		125,
		113,
		103,
		93,
		127,
		126,
		101,
		94,
		80,
		82,
		80,
		82,
		87,
		108,
		109,
		122,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		114,
		-1,
		-1,
		105,
		103,
		113,
		97,
		84,
		104,
		107,
		97,
		81,
		96,
		108,
		116,
		121,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		136,
		138,
		142,
		108,
		-1,
		113,
		108,
		88,
		102,
		109,
		99,
		94,
		88,
		91,
		109,
		126,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		129,
		131,
		124,
		128,
		-1,
		116,
		104,
		90,
		107,
		112,
		109,
		100,
		92,
		97,
		94,
		107,
		121,
		125,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		170,
		147,
		120,
		115,
		108,
		102,
		98,
		114,
		120,
		131,
		99,
		95,
		96,
		100,
		99,
		116,
		126,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		197,
		-1,
		-1,
		124,
		115,
		106,
		109,
		108,
		111,
		105,
		102,
		107,
		112,
		100,
		109,
		127,
		126,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		195,
		142,
		124,
		120,
		118,
		111,
		120,
		115,
		110,
		120,
		122,
		114,
		102,
		106,
		129,
		118,
		157,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		196,
		171,
		186,
		206,
		180,
		187,
		157,
		154,
		-1,
		124,
		149,
		121,
		128,
		119,
		126,
		126,
		118,
		96,
		103,
		119,
		118,
		113,
		149,
		140,
		146,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		202,
		188,
		192,
		182,
		185,
		-1,
		-1,
		173,
		170,
		146,
		129,
		127,
		120,
		115,
		125,
		105,
		92,
		96,
		100,
		106,
		111,
		116,
		122,
		137,
		152,
		-1,
		174,
		255,
		248,
		231,
		239,
		270,
		-1,
		196,
		188,
		195,
		174,
		176,
		-1,
		-1,
		146,
		143,
		148,
		136,
		133,
		135,
		130,
		121,
		106,
		112,
		99,
		98,
		116,
		120,
		129,
		136,
		126,
		139,
		143,
		-1,
		188,
		231,
		225,
		228,
		252,
		266,
		-1,
		193,
		-1,
		-1,
		203,
		177,
		161,
		151,
		145,
		195,
		150,
		145,
		129,
		127,
		118,
		109,
		116,
		107,
		107,
		110,
		125,
		130,
		122,
		136,
		136,
		137,
		-1,
		223,
		211,
		219,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		219,
		-1,
		188,
		-1,
		163,
		167,
		158,
		161,
		143,
		130,
		122,
		114,
		130,
		105,
		115,
		111,
		112,
		121,
		132,
		144,
		143,
		144,
		264,
		220,
		219,
		210,
		245,
		260,
		264,
		-1,
		205,
		244,
		242,
		-1,
		226,
		-1,
		-1,
		-1,
		177,
		171,
		163,
		163,
		142,
		142,
		116,
		120,
		110,
		117,
		127,
		129,
		121,
		125,
		138,
		149,
		152,
		260,
		251,
		264,
		209,
		209,
		230,
		239,
		260,
		220,
		211,
		238,
		249,
		238,
		233,
		220,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		149,
		137,
		120,
		121,
		117,
		120,
		135,
		138,
		128,
		126,
		120,
		152,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		200,
		227,
		-1,
		-1,
		222,
		239,
		233,
		237,
		253,
		278,
		-1,
		209,
		-1,
		-1,
		194,
		-1,
		-1,
		179,
		142,
		131,
		122,
		128,
		125,
		136,
		146,
		134,
		135,
		125,
		135,
		148,
		237,
		234,
		222,
		220,
		243,
		208,
		196,
		-1,
		209,
		207,
		213,
		220,
		237,
		267,
		-1,
		-1,
		225,
		205,
		-1,
		-1,
		177,
		175,
		164,
		-1,
		154,
		127,
		132,
		152,
		154,
		143,
		137,
		131,
		138,
		137,
		145,
		153,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		194,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		215,
		211,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		145,
		149,
		141,
		134,
		129,
		140,
		132,
		136,
		153,
		-1,
		280,
		-1,
		232,
		208,
		222,
		237,
		245,
		-1,
		-1,
		-1,
		232,
		218,
		211,
		199,
		197,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		185,
		153,
		158,
		153,
		135,
		146,
		135,
		138,
		152,
		147,
		-1,
		-1,
		220,
		223,
		-1,
		-1,
		222,
		224,
		-1,
		223,
		212,
		197,
		189,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		142,
		167,
		156,
		164,
		159,
		139,
		145,
		148,
		137,
		141,
		153,
		-1,
		-1,
		227,
		228,
		229,
		-1,
		207,
		-1,
		225,
		-1,
		192,
		198,
		186,
		-1,
		-1,
		-1,
		180,
		143,
		164,
		174,
		168,
		166,
		157,
		143,
		150,
		148,
		144,
		155,
		-1,
		-1,
		-1,
		225,
		199,
		232,
		223,
		206,
		186,
		178,
		197,
		-1,
		167,
		-1,
		142,
		144,
		170,
		173,
		179,
		173,
		146,
		161,
		151,
		142,
		151,
		231,
		-1,
		201,
		234,
		198,
		192,
		168,
		172,
		188,
		-1,
		164,
		146,
		-1,
		174,
		164,
		195,
		180,
		161,
		148,
		155,
		155,
		148,
		-1,
		-1,
		-1,
		203,
		202,
		194,
		188,
		188,
		173,
		164,
		-1,
		176,
		158,
		137,
		154,
		154,
		145,
		153,
		185,
		181,
		168,
		168,
		160,
		-1,
		304,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		197,
		192,
		165,
		153,
		159,
		155,
		141,
		147,
		149,
		157,
		155,
		152,
		164,
		160,
		180,
		161,
		196,
		-1,
		299,
		-1,
		233,
		-1,
		-1,
		215,
		195,
		187,
		176,
		165,
		163,
		154,
		145,
		167,
		183,
		167,
		165,
		168,
		169,
		-1,
		288,
		287,
		-1,
		234,
		226,
		212,
		-1,
		205,
		-1,
		211,
		172,
		-1,
		174,
		154,
		-1,
		176,
		172,
		-1,
		-1,
		275,
		250,
		-1,
		-1,
		-1,
		235,
		215,
		206,
		190,
		-1,
		165,
		165,
		-1,
		-1,
		-1,
		260,
		259,
		-1,
		228,
		231,
		-1,
		221,
		212,
		220,
		167,
		171,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		243,
		241,
		236,
		233,
		219,
		203,
		181,
		170,
		191,
		-1,
		-1,
		-1,
		241,
		233,
		226,
		-1,
		-1,
		228,
		211,
		192,
		190,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		218,
		-1,
		-1,
		224,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		252,
		-1,
		-1,
		-1,
		214,
		210,
		211,
		-1,
		-1,
		-1,
		-1,
		274,
		275,
		298,
		262,
		-1,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		277,
		275,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		204,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		239,
		-1,
		239,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		252,
		244,
		252,
		-1,
		224,
		226,
		-1,
		274,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		229,
		236,
		258,
		261,
		297,
		-1,
		248
	],
	[
		-1,
		112,
		101,
		112,
		120,
		93,
		100,
		-1,
		119,
		123,
		89,
		83,
		122,
		91,
		97,
		108,
		-1,
		-1,
		-1,
		112,
		111,
		79,
		77,
		86,
		91,
		98,
		-1,
		97,
		-1,
		133,
		112,
		123,
		128,
		72,
		69,
		89,
		108,
		90,
		82,
		148,
		102,
		73,
		67,
		85,
		75,
		84,
		76,
		-1,
		73,
		63,
		85,
		64,
		75,
		67,
		-1,
		-1,
		67,
		68,
		74,
		60,
		66,
		62,
		-1,
		72,
		56,
		-1,
		-1,
		57,
		58,
		42,
		45,
		53,
		51,
		64,
		56,
		51,
		-1,
		-1,
		48,
		44,
		51,
		38,
		34,
		51,
		64,
		46,
		60,
		59,
		-1,
		60,
		77,
		77,
		45,
		43,
		27,
		25,
		43,
		45,
		51,
		54,
		-1,
		77,
		73,
		74,
		72,
		67,
		43,
		30,
		30,
		40,
		33,
		52,
		43,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		78,
		69,
		86,
		70,
		60,
		64,
		62,
		33,
		30,
		28,
		25,
		41,
		42,
		52,
		-1,
		-1,
		171,
		144,
		168,
		126,
		108,
		-1,
		74,
		74,
		68,
		64,
		58,
		51,
		64,
		49,
		-1,
		19,
		18,
		49,
		35,
		46,
		153,
		-1,
		-1,
		129,
		121,
		103,
		106,
		83,
		79,
		89,
		88,
		81,
		74,
		70,
		48,
		51,
		51,
		57,
		13,
		23,
		27,
		42,
		53,
		-1,
		-1,
		123,
		-1,
		-1,
		150,
		133,
		-1,
		98,
		105,
		89,
		95,
		81,
		102,
		99,
		90,
		84,
		79,
		71,
		46,
		43,
		56,
		35,
		10,
		35,
		39,
		45,
		63,
		64,
		-1,
		122,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		105,
		102,
		95,
		119,
		118,
		-1,
		119,
		107,
		108,
		93,
		92,
		86,
		74,
		51,
		35,
		35,
		32,
		0,
		2,
		39,
		45,
		67,
		64,
		93,
		98,
		92,
		101,
		-1,
		158,
		154,
		150,
		157,
		106,
		-1,
		-1,
		123,
		-1,
		126,
		139,
		131,
		104,
		107,
		94,
		94,
		81,
		70,
		52,
		33,
		30,
		22,
		8,
		17,
		40,
		39,
		57,
		72,
		85,
		89,
		95,
		-1,
		208,
		-1,
		150,
		134,
		136,
		112,
		140,
		-1,
		143,
		127,
		147,
		133,
		133,
		-1,
		110,
		107,
		99,
		77,
		62,
		45,
		33,
		28,
		27,
		15,
		43,
		34,
		52,
		59,
		67,
		71,
		91,
		103,
		168,
		158,
		-1,
		140,
		145,
		115,
		127,
		147,
		170,
		149,
		-1,
		144,
		-1,
		112,
		125,
		-1,
		83,
		79,
		53,
		41,
		30,
		37,
		30,
		18,
		22,
		40,
		43,
		60,
		64,
		80,
		-1,
		-1,
		153,
		157,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		89,
		86,
		83,
		70,
		55,
		53,
		36,
		42,
		39,
		24,
		27,
		49,
		77,
		55,
		67,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		94,
		73,
		64,
		53,
		43,
		59,
		45,
		48,
		28,
		30,
		46,
		58,
		49,
		69,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		98,
		90,
		71,
		60,
		52,
		41,
		46,
		56,
		50,
		30,
		39,
		40,
		64,
		71,
		77,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		81,
		65,
		60,
		57,
		54,
		48,
		57,
		58,
		44,
		35,
		50,
		69,
		69,
		61,
		86,
		89,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		67,
		63,
		58,
		62,
		55,
		62,
		58,
		53,
		54,
		36,
		72,
		-1,
		69,
		63,
		91,
		94,
		84,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		67,
		65,
		59,
		63,
		67,
		56,
		69,
		61,
		41,
		51,
		71,
		75,
		82,
		75,
		80,
		79,
		93,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		87,
		71,
		74,
		74,
		70,
		78,
		63,
		58,
		44,
		48,
		66,
		93,
		88,
		83,
		82,
		89,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		79,
		94,
		95,
		73,
		78,
		77,
		87,
		80,
		69,
		56,
		60,
		75,
		85,
		77,
		78,
		87,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		93,
		91,
		84,
		75,
		81,
		88,
		89,
		84,
		74,
		63,
		69,
		65,
		87,
		73,
		71,
		90,
		105,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		92,
		76,
		81,
		-1,
		109,
		-1,
		82,
		82,
		73,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		108,
		88,
		82,
		81,
		104,
		99,
		90,
		71,
		64,
		61,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		125,
		113,
		103,
		93,
		125,
		115,
		90,
		83,
		69,
		71,
		69,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		114,
		-1,
		-1,
		105,
		103,
		107,
		86,
		73,
		93,
		96,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		132,
		127,
		131,
		108,
		-1,
		103,
		97,
		77,
		91,
		98,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		129,
		120,
		113,
		117,
		-1,
		105,
		93,
		79,
		96,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		159,
		136,
		109,
		104,
		97,
		91,
		87,
		103,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		97,
		100,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		115,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		111,
		103,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		196,
		171,
		186,
		195,
		180,
		187,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		108,
		115,
		115,
		107,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		195,
		188,
		181,
		171,
		174,
		-1,
		-1,
		162,
		159,
		135,
		118,
		116,
		109,
		104,
		114,
		94,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		174,
		255,
		248,
		231,
		239,
		270,
		-1,
		185,
		177,
		188,
		163,
		165,
		-1,
		-1,
		135,
		132,
		137,
		125,
		122,
		124,
		119,
		110,
		95,
		101,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		188,
		231,
		225,
		228,
		252,
		266,
		-1,
		182,
		-1,
		-1,
		194,
		166,
		150,
		140,
		134,
		184,
		139,
		134,
		118,
		116,
		107,
		98,
		105,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		126,
		-1,
		223,
		211,
		219,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		210,
		-1,
		177,
		-1,
		152,
		156,
		147,
		150,
		132,
		119,
		111,
		103,
		119,
		94,
		104,
		100,
		101,
		110,
		121,
		133,
		132,
		133,
		253,
		209,
		212,
		210,
		234,
		249,
		253,
		-1,
		194,
		233,
		231,
		-1,
		215,
		-1,
		-1,
		-1,
		166,
		160,
		152,
		152,
		131,
		131,
		105,
		109,
		99,
		106,
		116,
		118,
		110,
		114,
		127,
		138,
		141,
		249,
		240,
		253,
		198,
		198,
		219,
		228,
		249,
		209,
		200,
		227,
		238,
		227,
		222,
		209,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		138,
		126,
		109,
		110,
		106,
		109,
		124,
		127,
		117,
		115,
		109,
		141,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		216,
		-1,
		-1,
		211,
		228,
		222,
		226,
		242,
		267,
		-1,
		198,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		131,
		120,
		111,
		117,
		114,
		125,
		135,
		123,
		124,
		114,
		124,
		137,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		198,
		196,
		202,
		209,
		226,
		256,
		-1,
		-1,
		214,
		194,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		116,
		121,
		141,
		143,
		132,
		126,
		120,
		127,
		126,
		134,
		142,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		134,
		138,
		130,
		123,
		118,
		129,
		121,
		125,
		142,
		-1,
		269,
		-1,
		221,
		197,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		174,
		142,
		147,
		142,
		124,
		135,
		124,
		127,
		141,
		136,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		211,
		213,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		131,
		156,
		145,
		153,
		148,
		128,
		134,
		137,
		126,
		130,
		142,
		-1,
		-1,
		216,
		217,
		218,
		-1,
		196,
		-1,
		214,
		-1,
		181,
		187,
		175,
		-1,
		-1,
		-1,
		169,
		132,
		153,
		163,
		157,
		155,
		146,
		132,
		139,
		137,
		133,
		144,
		-1,
		-1,
		-1,
		214,
		188,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		131,
		133,
		159,
		162,
		168,
		162,
		135,
		150,
		140,
		131,
		140,
		220,
		-1,
		190,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		135,
		-1,
		163,
		153,
		184,
		169,
		150,
		137,
		144,
		144,
		137,
		-1,
		-1,
		-1,
		192,
		191,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		174,
		170,
		157,
		157,
		149,
		-1,
		293,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		150,
		185,
		-1,
		288,
		-1,
		222,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		157,
		158,
		-1,
		277,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		114,
		103,
		114,
		122,
		95,
		102,
		-1,
		121,
		125,
		91,
		85,
		124,
		93,
		99,
		110,
		-1,
		-1,
		-1,
		114,
		113,
		81,
		79,
		88,
		93,
		100,
		-1,
		99,
		-1,
		135,
		114,
		125,
		130,
		74,
		71,
		91,
		110,
		92,
		84,
		150,
		104,
		75,
		69,
		87,
		77,
		86,
		78,
		-1,
		75,
		65,
		87,
		66,
		77,
		69,
		-1,
		-1,
		69,
		70,
		76,
		62,
		68,
		64,
		-1,
		74,
		58,
		-1,
		-1,
		59,
		60,
		44,
		47,
		55,
		53,
		66,
		58,
		53,
		-1,
		-1,
		50,
		46,
		53,
		40,
		36,
		53,
		66,
		48,
		62,
		61,
		-1,
		62,
		79,
		79,
		47,
		45,
		29,
		27,
		45,
		47,
		53,
		56,
		-1,
		79,
		75,
		76,
		74,
		69,
		45,
		32,
		32,
		42,
		35,
		54,
		45,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		80,
		71,
		88,
		72,
		62,
		66,
		64,
		35,
		32,
		30,
		27,
		43,
		44,
		54,
		-1,
		-1,
		173,
		146,
		170,
		128,
		110,
		-1,
		76,
		76,
		70,
		66,
		60,
		53,
		66,
		51,
		-1,
		21,
		20,
		51,
		37,
		48,
		155,
		-1,
		-1,
		131,
		123,
		105,
		108,
		85,
		81,
		91,
		90,
		83,
		76,
		72,
		50,
		53,
		53,
		59,
		15,
		25,
		29,
		44,
		55,
		-1,
		-1,
		121,
		-1,
		-1,
		152,
		135,
		-1,
		100,
		107,
		91,
		97,
		83,
		104,
		101,
		92,
		86,
		81,
		73,
		48,
		45,
		58,
		36,
		12,
		37,
		41,
		46,
		65,
		62,
		-1,
		120,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		107,
		104,
		97,
		121,
		120,
		-1,
		121,
		109,
		110,
		95,
		94,
		88,
		76,
		53,
		37,
		37,
		33,
		2,
		0,
		37,
		43,
		65,
		62,
		91,
		96,
		90,
		99,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		125,
		-1,
		128,
		141,
		133,
		106,
		109,
		96,
		96,
		83,
		72,
		54,
		35,
		32,
		20,
		6,
		15,
		38,
		37,
		55,
		70,
		83,
		87,
		93,
		-1,
		210,
		-1,
		152,
		136,
		138,
		114,
		142,
		-1,
		145,
		129,
		149,
		135,
		135,
		-1,
		112,
		109,
		101,
		79,
		64,
		47,
		35,
		30,
		25,
		13,
		41,
		32,
		50,
		57,
		65,
		69,
		89,
		101,
		170,
		160,
		-1,
		142,
		147,
		117,
		129,
		149,
		172,
		151,
		-1,
		146,
		-1,
		114,
		127,
		-1,
		85,
		81,
		55,
		43,
		32,
		39,
		28,
		16,
		20,
		38,
		41,
		58,
		62,
		78,
		-1,
		-1,
		155,
		159,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		91,
		88,
		85,
		72,
		57,
		55,
		38,
		44,
		37,
		22,
		25,
		47,
		75,
		53,
		65,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		96,
		75,
		66,
		55,
		45,
		61,
		43,
		46,
		26,
		28,
		44,
		56,
		47,
		67,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		100,
		92,
		73,
		62,
		54,
		43,
		44,
		54,
		48,
		28,
		37,
		38,
		62,
		69,
		75,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		83,
		67,
		62,
		59,
		56,
		49,
		59,
		56,
		42,
		33,
		48,
		67,
		67,
		59,
		84,
		87,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		69,
		65,
		60,
		64,
		57,
		63,
		59,
		51,
		52,
		34,
		70,
		-1,
		67,
		61,
		89,
		92,
		82,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		69,
		67,
		61,
		65,
		69,
		58,
		67,
		59,
		39,
		49,
		69,
		73,
		80,
		73,
		78,
		77,
		91,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		89,
		73,
		76,
		76,
		72,
		80,
		63,
		56,
		42,
		46,
		64,
		91,
		86,
		81,
		80,
		87,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		81,
		96,
		97,
		75,
		80,
		79,
		89,
		78,
		67,
		54,
		58,
		73,
		83,
		75,
		76,
		85,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		95,
		93,
		86,
		77,
		83,
		90,
		87,
		82,
		72,
		61,
		67,
		63,
		85,
		71,
		69,
		88,
		103,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		94,
		78,
		83,
		-1,
		107,
		-1,
		80,
		80,
		71,
		60,
		57,
		68,
		66,
		77,
		94,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		110,
		90,
		84,
		83,
		102,
		97,
		88,
		69,
		62,
		59,
		60,
		73,
		93,
		84,
		96,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		127,
		115,
		105,
		95,
		123,
		113,
		88,
		81,
		67,
		69,
		67,
		69,
		74,
		95,
		96,
		109,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		116,
		-1,
		-1,
		107,
		105,
		105,
		84,
		71,
		91,
		94,
		84,
		68,
		83,
		95,
		103,
		108,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		130,
		125,
		129,
		110,
		-1,
		101,
		95,
		75,
		89,
		96,
		86,
		81,
		75,
		78,
		96,
		113,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		117,
		131,
		118,
		111,
		115,
		-1,
		103,
		91,
		77,
		94,
		99,
		96,
		87,
		79,
		84,
		81,
		94,
		108,
		112,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		135,
		150,
		157,
		134,
		107,
		102,
		95,
		89,
		85,
		101,
		107,
		118,
		86,
		82,
		83,
		87,
		86,
		103,
		113,
		-1,
		-1,
		149,
		166,
		161,
		143,
		147,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		95,
		98,
		92,
		89,
		94,
		99,
		87,
		96,
		114,
		113,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		162,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		97,
		107,
		109,
		101,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		198,
		173,
		187,
		193,
		182,
		186,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		106,
		113,
		113,
		105,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		281,
		270,
		259,
		265,
		-1,
		193,
		189,
		179,
		169,
		172,
		-1,
		-1,
		160,
		157,
		133,
		116,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		176,
		257,
		250,
		233,
		241,
		272,
		-1,
		183,
		175,
		186,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		123,
		120,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		190,
		233,
		227,
		230,
		254,
		268,
		-1,
		180,
		-1,
		-1,
		192,
		164,
		148,
		138,
		132,
		182,
		137,
		132,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		225,
		213,
		221,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		208,
		-1,
		175,
		-1,
		150,
		154,
		145,
		148,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		251,
		207,
		210,
		212,
		232,
		247,
		251,
		-1,
		192,
		231,
		229,
		-1,
		213,
		-1,
		-1,
		-1,
		164,
		158,
		150,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		207,
		198,
		225,
		236,
		225,
		220,
		207,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		226,
		220,
		224,
		240,
		265,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		214,
		215,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		154,
		143,
		154,
		162,
		135,
		142,
		-1,
		161,
		165,
		131,
		125,
		164,
		133,
		139,
		150,
		-1,
		-1,
		-1,
		154,
		153,
		121,
		119,
		128,
		133,
		140,
		-1,
		139,
		-1,
		175,
		154,
		165,
		170,
		114,
		111,
		131,
		150,
		132,
		124,
		190,
		144,
		115,
		109,
		127,
		117,
		126,
		118,
		-1,
		115,
		105,
		127,
		106,
		117,
		109,
		-1,
		-1,
		109,
		110,
		116,
		102,
		108,
		104,
		-1,
		114,
		93,
		-1,
		-1,
		99,
		100,
		84,
		87,
		95,
		93,
		106,
		98,
		88,
		-1,
		-1,
		90,
		86,
		93,
		80,
		76,
		93,
		106,
		88,
		75,
		73,
		-1,
		102,
		119,
		119,
		87,
		85,
		69,
		67,
		85,
		87,
		73,
		65,
		-1,
		119,
		115,
		114,
		114,
		109,
		85,
		72,
		72,
		82,
		75,
		67,
		54,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		120,
		111,
		128,
		110,
		100,
		106,
		104,
		75,
		72,
		70,
		67,
		70,
		53,
		63,
		-1,
		-1,
		213,
		186,
		210,
		168,
		150,
		-1,
		116,
		114,
		108,
		104,
		98,
		91,
		105,
		91,
		-1,
		61,
		60,
		60,
		46,
		57,
		195,
		-1,
		-1,
		171,
		163,
		145,
		148,
		125,
		121,
		129,
		128,
		121,
		114,
		110,
		88,
		91,
		91,
		97,
		55,
		56,
		53,
		39,
		64,
		-1,
		-1,
		139,
		-1,
		-1,
		192,
		175,
		-1,
		140,
		147,
		131,
		137,
		123,
		144,
		139,
		130,
		124,
		119,
		111,
		86,
		83,
		96,
		69,
		52,
		63,
		66,
		34,
		54,
		55,
		-1,
		138,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		147,
		144,
		137,
		161,
		160,
		-1,
		159,
		147,
		148,
		133,
		132,
		126,
		114,
		91,
		75,
		75,
		66,
		43,
		41,
		0,
		31,
		52,
		56,
		87,
		114,
		108,
		117,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		165,
		-1,
		168,
		181,
		171,
		144,
		147,
		134,
		134,
		121,
		110,
		92,
		73,
		70,
		53,
		41,
		26,
		36,
		39,
		51,
		65,
		101,
		105,
		111,
		-1,
		250,
		-1,
		192,
		176,
		178,
		154,
		182,
		-1,
		185,
		169,
		188,
		173,
		173,
		-1,
		150,
		147,
		139,
		117,
		102,
		85,
		73,
		68,
		58,
		45,
		68,
		43,
		61,
		59,
		73,
		87,
		109,
		119,
		210,
		200,
		-1,
		182,
		187,
		157,
		168,
		187,
		212,
		189,
		-1,
		184,
		-1,
		152,
		165,
		-1,
		123,
		119,
		93,
		81,
		70,
		77,
		61,
		48,
		52,
		49,
		52,
		77,
		78,
		103,
		-1,
		-1,
		195,
		199,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		129,
		126,
		123,
		110,
		95,
		93,
		76,
		82,
		69,
		54,
		57,
		58,
		96,
		83,
		97,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		83,
		99,
		75,
		78,
		58,
		60,
		64,
		88,
		79,
		99,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		138,
		130,
		111,
		100,
		92,
		81,
		76,
		86,
		80,
		60,
		69,
		70,
		94,
		101,
		107,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		81,
		91,
		88,
		74,
		65,
		80,
		99,
		99,
		91,
		116,
		119,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		95,
		91,
		83,
		84,
		66,
		102,
		-1,
		99,
		93,
		121,
		124,
		114,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		102,
		91,
		99,
		91,
		71,
		81,
		101,
		105,
		112,
		105,
		110,
		109,
		123,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		114,
		105,
		113,
		95,
		88,
		74,
		78,
		96,
		123,
		118,
		113,
		112,
		119,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		114,
		112,
		122,
		110,
		99,
		86,
		90,
		105,
		115,
		107,
		108,
		117,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		115,
		121,
		123,
		119,
		114,
		104,
		93,
		99,
		95,
		117,
		103,
		101,
		120,
		135,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		132,
		116,
		121,
		-1,
		139,
		-1,
		112,
		112,
		103,
		92,
		89,
		100,
		98,
		109,
		126,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		148,
		128,
		122,
		121,
		134,
		129,
		120,
		101,
		94,
		91,
		92,
		105,
		125,
		116,
		128,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		165,
		153,
		143,
		133,
		155,
		145,
		120,
		113,
		99,
		101,
		99,
		101,
		106,
		127,
		128,
		141,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		154,
		-1,
		-1,
		145,
		143,
		137,
		116,
		103,
		123,
		126,
		116,
		100,
		115,
		127,
		135,
		140,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		162,
		157,
		161,
		148,
		-1,
		133,
		127,
		107,
		121,
		128,
		118,
		113,
		107,
		110,
		128,
		145,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		155,
		169,
		150,
		143,
		147,
		-1,
		135,
		123,
		109,
		126,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		140,
		144,
		204,
		-1,
		187,
		-1,
		-1,
		-1,
		173,
		188,
		189,
		166,
		139,
		134,
		127,
		121,
		117,
		133,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		135,
		145,
		-1,
		-1,
		187,
		204,
		199,
		181,
		185,
		216,
		-1,
		-1,
		143,
		134,
		125,
		128,
		127,
		130,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		145,
		-1,
		-1,
		-1,
		207,
		-1,
		222,
		-1,
		-1,
		200,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		141,
		133,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		232,
		211,
		219,
		225,
		220,
		218,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		138,
		145,
		145,
		137,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		319,
		308,
		297,
		303,
		-1,
		225,
		221,
		211,
		201,
		204,
		-1,
		-1,
		192,
		189,
		165,
		148,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		214,
		295,
		288,
		271,
		279,
		310,
		-1,
		215,
		207,
		218,
		193,
		195,
		-1,
		-1,
		165,
		162,
		167,
		155,
		152,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		228,
		271,
		265,
		268,
		292,
		306,
		-1,
		212,
		-1,
		-1,
		224,
		196,
		180,
		170,
		164,
		214,
		169,
		164,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		258,
		251,
		259,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		240,
		-1,
		207,
		-1,
		182,
		186,
		177,
		180,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		283,
		239,
		242,
		250,
		264,
		279,
		283,
		-1,
		224,
		263,
		261,
		-1,
		245,
		-1,
		-1,
		-1,
		196,
		190,
		182,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		279,
		270,
		283,
		228,
		228,
		249,
		258,
		279,
		239,
		230,
		257,
		268,
		257,
		252,
		239,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		272,
		271,
		260,
		257,
		233,
		224,
		219,
		246,
		-1,
		-1,
		241,
		258,
		252,
		256,
		272,
		297,
		-1,
		228,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		256,
		253,
		241,
		239,
		262,
		227,
		215,
		-1,
		228,
		226,
		232,
		239,
		256,
		286,
		-1,
		-1,
		244,
		224,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		265,
		279,
		268,
		264,
		263,
		271,
		220,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		230,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		299,
		-1,
		251,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		246,
		247,
		248,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		141,
		130,
		141,
		149,
		122,
		129,
		-1,
		148,
		152,
		118,
		112,
		151,
		120,
		126,
		137,
		-1,
		-1,
		-1,
		141,
		140,
		108,
		106,
		115,
		120,
		127,
		-1,
		126,
		-1,
		162,
		141,
		152,
		157,
		101,
		98,
		118,
		137,
		119,
		111,
		177,
		131,
		102,
		96,
		114,
		104,
		113,
		105,
		-1,
		102,
		92,
		114,
		93,
		104,
		96,
		-1,
		-1,
		96,
		97,
		103,
		89,
		95,
		91,
		-1,
		89,
		62,
		-1,
		-1,
		86,
		87,
		71,
		74,
		82,
		80,
		85,
		71,
		57,
		-1,
		-1,
		77,
		73,
		80,
		67,
		63,
		80,
		88,
		57,
		44,
		42,
		-1,
		89,
		106,
		106,
		74,
		72,
		56,
		54,
		72,
		59,
		42,
		34,
		-1,
		106,
		102,
		103,
		101,
		96,
		72,
		59,
		59,
		69,
		53,
		36,
		23,
		69,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		107,
		98,
		115,
		99,
		89,
		93,
		91,
		62,
		59,
		57,
		46,
		39,
		22,
		32,
		-1,
		-1,
		200,
		173,
		197,
		155,
		137,
		-1,
		103,
		103,
		97,
		93,
		87,
		80,
		93,
		78,
		-1,
		30,
		39,
		29,
		15,
		26,
		182,
		-1,
		-1,
		158,
		150,
		132,
		135,
		112,
		108,
		118,
		117,
		110,
		101,
		97,
		77,
		80,
		80,
		86,
		42,
		25,
		22,
		8,
		33,
		-1,
		-1,
		112,
		-1,
		-1,
		179,
		162,
		-1,
		127,
		134,
		118,
		124,
		110,
		131,
		128,
		119,
		113,
		108,
		99,
		75,
		72,
		85,
		64,
		39,
		32,
		35,
		3,
		27,
		28,
		-1,
		111,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		134,
		131,
		124,
		148,
		147,
		-1,
		146,
		134,
		135,
		120,
		117,
		104,
		92,
		80,
		64,
		64,
		61,
		45,
		43,
		32,
		0,
		25,
		29,
		60,
		87,
		81,
		90,
		-1,
		187,
		183,
		179,
		186,
		135,
		-1,
		-1,
		152,
		-1,
		155,
		168,
		158,
		131,
		134,
		121,
		112,
		99,
		88,
		81,
		62,
		59,
		57,
		37,
		52,
		5,
		8,
		24,
		38,
		74,
		78,
		84,
		-1,
		237,
		-1,
		179,
		163,
		165,
		141,
		162,
		-1,
		172,
		156,
		175,
		160,
		160,
		-1,
		130,
		127,
		117,
		95,
		80,
		74,
		62,
		57,
		50,
		32,
		37,
		12,
		30,
		32,
		46,
		60,
		82,
		92,
		197,
		187,
		-1,
		169,
		174,
		137,
		145,
		164,
		199,
		166,
		-1,
		161,
		-1,
		132,
		145,
		-1,
		101,
		97,
		79,
		70,
		59,
		66,
		43,
		28,
		25,
		18,
		21,
		50,
		51,
		76,
		-1,
		-1,
		182,
		186,
		179,
		130,
		149,
		173,
		210,
		159,
		148,
		147,
		-1,
		138,
		115,
		112,
		100,
		87,
		72,
		73,
		65,
		63,
		42,
		27,
		30,
		27,
		69,
		55,
		67,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		156,
		127,
		151,
		193,
		177,
		170,
		158,
		123,
		123,
		117,
		-1,
		111,
		90,
		81,
		70,
		68,
		75,
		48,
		51,
		31,
		33,
		33,
		58,
		49,
		69,
		-1,
		-1,
		-1,
		186,
		175,
		176,
		122,
		145,
		182,
		156,
		142,
		147,
		122,
		115,
		109,
		124,
		107,
		88,
		77,
		69,
		58,
		49,
		59,
		53,
		33,
		42,
		40,
		64,
		71,
		77,
		-1,
		-1,
		193,
		183,
		167,
		169,
		166,
		136,
		143,
		175,
		147,
		160,
		-1,
		114,
		-1,
		103,
		98,
		82,
		77,
		74,
		67,
		54,
		64,
		61,
		47,
		38,
		53,
		69,
		69,
		61,
		86,
		89,
		-1,
		-1,
		-1,
		186,
		181,
		156,
		133,
		117,
		153,
		-1,
		130,
		131,
		-1,
		108,
		102,
		99,
		84,
		80,
		71,
		75,
		69,
		68,
		64,
		56,
		57,
		39,
		74,
		-1,
		69,
		63,
		91,
		94,
		84,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		112,
		164,
		-1,
		-1,
		115,
		108,
		-1,
		95,
		77,
		83,
		78,
		76,
		76,
		75,
		64,
		72,
		64,
		44,
		54,
		74,
		78,
		82,
		75,
		80,
		79,
		93,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		132,
		-1,
		124,
		116,
		106,
		100,
		94,
		90,
		88,
		104,
		88,
		88,
		87,
		78,
		86,
		68,
		61,
		47,
		51,
		69,
		93,
		88,
		86,
		85,
		89,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		145,
		-1,
		109,
		123,
		139,
		-1,
		132,
		111,
		126,
		104,
		100,
		95,
		111,
		112,
		90,
		87,
		85,
		95,
		83,
		72,
		59,
		63,
		78,
		88,
		80,
		81,
		90,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		106,
		94,
		126,
		-1,
		-1,
		168,
		-1,
		102,
		119,
		109,
		107,
		101,
		92,
		98,
		96,
		92,
		87,
		77,
		66,
		72,
		68,
		90,
		76,
		74,
		90,
		105,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		146,
		136,
		120,
		105,
		138,
		-1,
		109,
		93,
		98,
		-1,
		112,
		-1,
		85,
		85,
		76,
		65,
		62,
		73,
		71,
		82,
		96,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		163,
		-1,
		-1,
		133,
		127,
		127,
		111,
		114,
		125,
		105,
		99,
		98,
		107,
		102,
		93,
		74,
		67,
		64,
		65,
		78,
		98,
		89,
		98,
		-1,
		-1,
		-1,
		160,
		146,
		150,
		110,
		129,
		-1,
		-1,
		195,
		150,
		136,
		-1,
		120,
		142,
		130,
		120,
		110,
		128,
		118,
		93,
		86,
		72,
		74,
		72,
		74,
		79,
		100,
		101,
		113,
		-1,
		-1,
		143,
		148,
		136,
		122,
		141,
		-1,
		-1,
		-1,
		142,
		158,
		150,
		121,
		131,
		-1,
		-1,
		122,
		120,
		110,
		89,
		76,
		96,
		99,
		89,
		73,
		88,
		100,
		105,
		113,
		-1,
		146,
		133,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		135,
		130,
		134,
		125,
		-1,
		106,
		100,
		80,
		94,
		101,
		91,
		86,
		80,
		83,
		101,
		116,
		-1,
		-1,
		158,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		132,
		146,
		123,
		116,
		120,
		-1,
		108,
		96,
		82,
		99,
		104,
		101,
		92,
		84,
		89,
		86,
		99,
		113,
		117,
		181,
		-1,
		164,
		-1,
		-1,
		-1,
		150,
		165,
		162,
		139,
		112,
		107,
		100,
		94,
		90,
		106,
		112,
		123,
		91,
		87,
		88,
		92,
		91,
		108,
		118,
		-1,
		-1,
		164,
		181,
		176,
		158,
		162,
		189,
		-1,
		-1,
		116,
		107,
		98,
		101,
		100,
		103,
		97,
		94,
		99,
		104,
		92,
		101,
		119,
		118,
		-1,
		-1,
		-1,
		184,
		-1,
		199,
		-1,
		-1,
		177,
		187,
		134,
		116,
		112,
		110,
		103,
		112,
		107,
		102,
		112,
		114,
		106,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		205,
		188,
		192,
		198,
		197,
		191,
		149,
		146,
		-1,
		116,
		141,
		113,
		120,
		111,
		118,
		118,
		110,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		198,
		194,
		184,
		174,
		177,
		-1,
		-1,
		165,
		162,
		138,
		121,
		119,
		112,
		107,
		117,
		97,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		191,
		272,
		265,
		247,
		255,
		286,
		-1,
		188,
		180,
		191,
		166,
		168,
		-1,
		-1,
		138,
		135,
		140,
		128,
		125,
		127,
		122,
		113,
		98,
		104,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		205,
		248,
		241,
		244,
		268,
		282,
		-1,
		185,
		-1,
		-1,
		197,
		169,
		153,
		143,
		137,
		187,
		142,
		137,
		121,
		119,
		110,
		101,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		231,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		213,
		-1,
		180,
		-1,
		155,
		159,
		150,
		153,
		135,
		122,
		114,
		106,
		122,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		256,
		212,
		215,
		226,
		237,
		252,
		256,
		-1,
		197,
		236,
		234,
		-1,
		218,
		-1,
		-1,
		-1,
		169,
		163,
		155,
		155,
		134,
		134,
		108,
		112,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		252,
		243,
		256,
		201,
		201,
		222,
		231,
		252,
		212,
		203,
		230,
		241,
		230,
		225,
		212,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		141,
		129,
		112,
		113,
		109,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		245,
		244,
		233,
		230,
		206,
		197,
		192,
		219,
		-1,
		-1,
		214,
		231,
		225,
		229,
		245,
		270,
		-1,
		201,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		117,
		128,
		138,
		126,
		127,
		117,
		127,
		140,
		229,
		226,
		214,
		212,
		235,
		200,
		188,
		-1,
		201,
		199,
		205,
		212,
		229,
		259,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		144,
		146,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		238,
		252,
		241,
		237,
		236,
		244,
		193,
		186,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		137,
		141,
		133,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		272,
		-1,
		224,
		200,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		214,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		219,
		220,
		221,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		160,
		158,
		149,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		136,
		162,
		165,
		171,
		165,
		138,
		153,
		143,
		134,
		143,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		187,
		172,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		177,
		173,
		160,
		160,
		152,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		153,
		188,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		160,
		161,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		165,
		154,
		165,
		173,
		146,
		153,
		-1,
		172,
		176,
		142,
		136,
		175,
		144,
		150,
		161,
		-1,
		-1,
		-1,
		165,
		164,
		132,
		130,
		139,
		144,
		151,
		-1,
		150,
		-1,
		186,
		165,
		176,
		181,
		125,
		122,
		142,
		161,
		143,
		135,
		201,
		155,
		126,
		120,
		138,
		128,
		137,
		129,
		-1,
		126,
		116,
		138,
		117,
		128,
		120,
		-1,
		-1,
		120,
		121,
		127,
		113,
		119,
		115,
		-1,
		113,
		86,
		-1,
		-1,
		110,
		111,
		95,
		98,
		106,
		104,
		109,
		95,
		81,
		-1,
		-1,
		101,
		97,
		104,
		91,
		87,
		104,
		112,
		81,
		68,
		66,
		-1,
		113,
		130,
		130,
		98,
		96,
		80,
		78,
		96,
		83,
		66,
		58,
		-1,
		130,
		126,
		127,
		125,
		120,
		96,
		83,
		83,
		93,
		77,
		60,
		47,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		122,
		139,
		123,
		113,
		117,
		115,
		86,
		83,
		81,
		70,
		63,
		46,
		55,
		-1,
		-1,
		224,
		197,
		221,
		179,
		161,
		-1,
		127,
		127,
		121,
		117,
		111,
		104,
		117,
		102,
		-1,
		54,
		63,
		53,
		39,
		49,
		206,
		-1,
		-1,
		182,
		174,
		156,
		159,
		136,
		132,
		142,
		141,
		134,
		125,
		121,
		101,
		104,
		104,
		110,
		66,
		49,
		46,
		32,
		21,
		-1,
		-1,
		103,
		-1,
		-1,
		203,
		186,
		-1,
		151,
		158,
		142,
		148,
		134,
		155,
		152,
		143,
		137,
		132,
		123,
		99,
		96,
		109,
		88,
		63,
		56,
		59,
		27,
		11,
		6,
		-1,
		102,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		158,
		155,
		148,
		172,
		171,
		-1,
		170,
		158,
		159,
		144,
		141,
		128,
		116,
		104,
		88,
		88,
		85,
		69,
		67,
		52,
		24,
		0,
		7,
		38,
		78,
		72,
		81,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		176,
		-1,
		179,
		192,
		182,
		155,
		158,
		145,
		136,
		123,
		112,
		105,
		86,
		83,
		81,
		61,
		76,
		29,
		32,
		21,
		16,
		65,
		69,
		75,
		-1,
		261,
		-1,
		203,
		187,
		189,
		165,
		186,
		-1,
		196,
		180,
		199,
		184,
		184,
		-1,
		154,
		151,
		141,
		119,
		104,
		98,
		86,
		81,
		74,
		56,
		61,
		36,
		32,
		29,
		28,
		51,
		73,
		83,
		221,
		211,
		-1,
		193,
		198,
		161,
		169,
		188,
		223,
		190,
		-1,
		185,
		-1,
		156,
		169,
		-1,
		125,
		121,
		103,
		94,
		83,
		90,
		67,
		52,
		49,
		30,
		33,
		41,
		39,
		67,
		-1,
		-1,
		206,
		210,
		203,
		154,
		173,
		197,
		234,
		183,
		172,
		171,
		-1,
		162,
		139,
		136,
		124,
		111,
		96,
		97,
		89,
		87,
		66,
		51,
		54,
		39,
		60,
		44,
		69,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		151,
		175,
		217,
		201,
		194,
		182,
		147,
		147,
		141,
		-1,
		135,
		114,
		105,
		94,
		92,
		99,
		72,
		75,
		55,
		57,
		45,
		58,
		51,
		71,
		-1,
		-1,
		-1,
		210,
		199,
		200,
		146,
		169,
		206,
		180,
		166,
		171,
		146,
		139,
		133,
		148,
		131,
		112,
		101,
		93,
		82,
		73,
		83,
		77,
		57,
		66,
		52,
		66,
		73,
		79,
		-1,
		-1,
		217,
		207,
		191,
		193,
		190,
		160,
		167,
		199,
		171,
		184,
		-1,
		138,
		-1,
		127,
		122,
		106,
		101,
		98,
		91,
		78,
		88,
		85,
		71,
		62,
		77,
		71,
		71,
		63,
		88,
		91,
		-1,
		-1,
		-1,
		210,
		205,
		180,
		157,
		141,
		177,
		-1,
		154,
		155,
		-1,
		132,
		126,
		123,
		108,
		104,
		95,
		99,
		93,
		92,
		88,
		80,
		81,
		63,
		86,
		-1,
		71,
		65,
		93,
		96,
		86,
		-1,
		-1,
		-1,
		203,
		182,
		175,
		195,
		136,
		188,
		-1,
		-1,
		139,
		132,
		-1,
		119,
		101,
		107,
		102,
		100,
		100,
		99,
		88,
		96,
		88,
		68,
		78,
		98,
		86,
		84,
		77,
		82,
		81,
		95,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		156,
		-1,
		148,
		140,
		130,
		124,
		118,
		114,
		112,
		128,
		112,
		112,
		111,
		102,
		110,
		92,
		85,
		71,
		75,
		93,
		95,
		90,
		96,
		88,
		91,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		169,
		-1,
		133,
		147,
		163,
		-1,
		156,
		135,
		150,
		128,
		124,
		119,
		135,
		136,
		114,
		111,
		109,
		119,
		107,
		96,
		83,
		87,
		102,
		105,
		91,
		91,
		93,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		130,
		118,
		150,
		-1,
		-1,
		192,
		-1,
		126,
		143,
		133,
		131,
		125,
		116,
		122,
		120,
		116,
		111,
		101,
		90,
		96,
		92,
		113,
		99,
		97,
		92,
		107,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		167,
		-1,
		170,
		160,
		144,
		129,
		162,
		-1,
		133,
		117,
		122,
		-1,
		136,
		-1,
		109,
		109,
		100,
		89,
		86,
		97,
		95,
		106,
		98,
		-1,
		179,
		164,
		157,
		147,
		161,
		132,
		-1,
		187,
		-1,
		-1,
		157,
		151,
		151,
		135,
		138,
		149,
		129,
		123,
		122,
		131,
		126,
		117,
		98,
		91,
		88,
		89,
		102,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		184,
		170,
		174,
		134,
		153,
		-1,
		-1,
		219,
		174,
		160,
		-1,
		144,
		166,
		154,
		144,
		134,
		152,
		142,
		117,
		110,
		96,
		98,
		96,
		98,
		103,
		113,
		105,
		115,
		-1,
		-1,
		167,
		172,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		166,
		182,
		174,
		145,
		155,
		-1,
		-1,
		146,
		144,
		134,
		113,
		100,
		120,
		123,
		113,
		97,
		112,
		119,
		107,
		116,
		-1,
		170,
		157,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		199,
		165,
		159,
		154,
		158,
		149,
		-1,
		130,
		124,
		104,
		118,
		125,
		115,
		110,
		104,
		107,
		124,
		118,
		-1,
		-1,
		182,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		156,
		170,
		147,
		140,
		144,
		-1,
		132,
		120,
		106,
		123,
		128,
		125,
		116,
		108,
		113,
		110,
		123,
		130,
		120,
		205,
		-1,
		188,
		-1,
		-1,
		-1,
		174,
		189,
		186,
		163,
		136,
		131,
		124,
		118,
		114,
		130,
		136,
		147,
		115,
		111,
		112,
		116,
		115,
		132,
		135,
		-1,
		-1,
		188,
		205,
		200,
		182,
		186,
		213,
		-1,
		-1,
		140,
		131,
		122,
		125,
		124,
		127,
		121,
		118,
		123,
		128,
		116,
		125,
		143,
		138,
		-1,
		-1,
		-1,
		208,
		-1,
		223,
		-1,
		-1,
		201,
		211,
		158,
		140,
		136,
		134,
		127,
		136,
		131,
		126,
		136,
		138,
		130,
		118,
		122,
		145,
		134,
		167,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		229,
		212,
		216,
		222,
		221,
		215,
		173,
		170,
		-1,
		140,
		165,
		137,
		144,
		135,
		142,
		142,
		134,
		112,
		119,
		135,
		134,
		129,
		159,
		154,
		162,
		-1,
		-1,
		319,
		308,
		297,
		303,
		-1,
		222,
		218,
		208,
		198,
		201,
		-1,
		-1,
		189,
		186,
		162,
		145,
		143,
		136,
		131,
		141,
		121,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		153,
		168,
		-1,
		215,
		296,
		289,
		271,
		279,
		310,
		-1,
		212,
		204,
		215,
		190,
		192,
		-1,
		-1,
		162,
		159,
		164,
		152,
		149,
		151,
		146,
		137,
		122,
		128,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		229,
		272,
		265,
		268,
		292,
		306,
		-1,
		209,
		-1,
		-1,
		221,
		193,
		177,
		167,
		161,
		211,
		166,
		161,
		145,
		143,
		134,
		125,
		132,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		255,
		252,
		259,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		237,
		-1,
		204,
		-1,
		179,
		183,
		174,
		177,
		159,
		146,
		138,
		130,
		146,
		121,
		131,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		280,
		236,
		239,
		250,
		261,
		276,
		280,
		-1,
		221,
		260,
		258,
		-1,
		242,
		-1,
		-1,
		-1,
		193,
		187,
		179,
		179,
		158,
		158,
		132,
		136,
		126,
		133,
		143,
		145,
		137,
		141,
		154,
		165,
		168,
		276,
		267,
		280,
		225,
		225,
		246,
		255,
		276,
		236,
		227,
		254,
		265,
		254,
		249,
		236,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		165,
		153,
		136,
		137,
		133,
		136,
		151,
		154,
		144,
		142,
		136,
		168,
		-1,
		269,
		268,
		257,
		254,
		230,
		221,
		216,
		243,
		-1,
		-1,
		238,
		255,
		249,
		253,
		269,
		294,
		-1,
		225,
		-1,
		-1,
		210,
		-1,
		-1,
		195,
		158,
		147,
		138,
		144,
		141,
		152,
		162,
		150,
		151,
		141,
		151,
		164,
		253,
		250,
		238,
		236,
		259,
		224,
		212,
		-1,
		225,
		223,
		229,
		236,
		253,
		283,
		-1,
		-1,
		241,
		221,
		-1,
		-1,
		193,
		191,
		180,
		-1,
		170,
		143,
		148,
		168,
		170,
		159,
		153,
		147,
		154,
		153,
		161,
		169,
		262,
		276,
		265,
		261,
		260,
		268,
		217,
		210,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		227,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		161,
		165,
		157,
		150,
		145,
		156,
		148,
		152,
		169,
		-1,
		296,
		-1,
		248,
		224,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		201,
		169,
		174,
		169,
		151,
		162,
		151,
		154,
		168,
		163,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		238,
		240,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		158,
		183,
		172,
		180,
		175,
		155,
		161,
		164,
		153,
		157,
		169,
		-1,
		-1,
		243,
		244,
		245,
		-1,
		223,
		-1,
		241,
		-1,
		208,
		214,
		202,
		-1,
		-1,
		-1,
		196,
		159,
		180,
		190,
		184,
		182,
		173,
		159,
		166,
		164,
		160,
		171,
		-1,
		-1,
		-1,
		241,
		215,
		248,
		239,
		222,
		202,
		194,
		213,
		-1,
		183,
		-1,
		158,
		160,
		186,
		189,
		195,
		189,
		162,
		177,
		167,
		158,
		167,
		247,
		-1,
		217,
		250,
		214,
		208,
		184,
		188,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		211,
		196,
		177,
		164,
		171,
		171,
		164,
		-1,
		-1,
		-1,
		219,
		218,
		210,
		204,
		204,
		189,
		180,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		201,
		197,
		184,
		184,
		176,
		-1,
		320,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		213,
		208,
		181,
		169,
		175,
		171,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		177,
		212,
		-1,
		315,
		-1,
		249,
		-1,
		-1,
		231,
		211,
		203,
		192,
		181,
		179,
		170,
		161,
		183,
		199,
		183,
		181,
		184,
		185,
		-1,
		304,
		303,
		-1,
		250,
		242,
		228,
		-1,
		221,
		-1,
		227,
		188,
		-1,
		190,
		170,
		-1,
		192,
		188,
		-1,
		-1,
		291,
		266,
		-1,
		-1,
		-1,
		251,
		231,
		222,
		206,
		-1,
		181,
		181,
		-1,
		-1,
		-1,
		276,
		275,
		-1,
		244,
		247,
		-1,
		237,
		228,
		236,
		183,
		187,
		-1,
		-1,
		-1,
		285,
		266,
		260,
		259,
		257,
		252,
		249,
		235,
		219,
		197,
		186,
		207,
		-1,
		-1,
		-1,
		257,
		249,
		242,
		-1,
		-1,
		244,
		227,
		208,
		206,
		-1,
		-1,
		-1,
		279,
		260,
		-1,
		-1,
		234,
		-1,
		-1,
		240,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		268,
		-1,
		-1,
		-1,
		230,
		226,
		227,
		-1,
		-1,
		-1,
		-1,
		290,
		291,
		314,
		278,
		-1,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		293,
		291,
		-1,
		-1,
		-1,
		250,
		234,
		-1,
		220,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		255,
		-1,
		255,
		230,
		237,
		-1,
		-1,
		-1,
		-1,
		268,
		260,
		268,
		-1,
		240,
		242,
		-1,
		290,
		-1,
		-1,
		283,
		274,
		-1,
		-1,
		245,
		252,
		274,
		277,
		313,
		-1,
		264
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		173,
		177,
		143,
		137,
		176,
		145,
		151,
		162,
		-1,
		-1,
		-1,
		166,
		165,
		133,
		131,
		140,
		145,
		152,
		-1,
		151,
		-1,
		187,
		166,
		177,
		182,
		126,
		123,
		143,
		162,
		144,
		136,
		202,
		156,
		127,
		121,
		139,
		129,
		138,
		130,
		-1,
		127,
		117,
		139,
		118,
		129,
		121,
		-1,
		-1,
		121,
		122,
		128,
		114,
		120,
		116,
		-1,
		117,
		90,
		-1,
		-1,
		111,
		112,
		96,
		99,
		107,
		105,
		113,
		99,
		85,
		-1,
		-1,
		102,
		98,
		105,
		92,
		88,
		105,
		116,
		85,
		72,
		70,
		-1,
		114,
		131,
		131,
		99,
		97,
		81,
		79,
		97,
		87,
		70,
		62,
		-1,
		131,
		127,
		128,
		126,
		121,
		97,
		84,
		84,
		94,
		81,
		64,
		51,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		123,
		140,
		124,
		114,
		118,
		116,
		87,
		84,
		82,
		74,
		67,
		50,
		55,
		-1,
		-1,
		225,
		198,
		222,
		180,
		162,
		-1,
		128,
		128,
		122,
		118,
		112,
		105,
		118,
		103,
		-1,
		58,
		67,
		57,
		43,
		49,
		207,
		-1,
		-1,
		183,
		175,
		157,
		160,
		137,
		133,
		143,
		142,
		135,
		124,
		120,
		102,
		105,
		105,
		111,
		67,
		53,
		50,
		40,
		21,
		-1,
		-1,
		97,
		-1,
		-1,
		204,
		187,
		-1,
		152,
		159,
		143,
		149,
		135,
		156,
		153,
		144,
		138,
		133,
		122,
		100,
		97,
		110,
		89,
		64,
		59,
		62,
		35,
		11,
		6,
		-1,
		96,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		159,
		156,
		149,
		173,
		172,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		105,
		89,
		89,
		86,
		68,
		66,
		60,
		32,
		10,
		0,
		32,
		72,
		66,
		75,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		177,
		-1,
		180,
		193,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		106,
		87,
		84,
		80,
		60,
		75,
		37,
		40,
		18,
		10,
		59,
		63,
		69,
		-1,
		262,
		-1,
		204,
		188,
		190,
		164,
		185,
		-1,
		197,
		181,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		99,
		87,
		82,
		73,
		55,
		60,
		35,
		29,
		26,
		22,
		45,
		67,
		77,
		222,
		212,
		-1,
		194,
		199,
		160,
		168,
		187,
		224,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		95,
		84,
		91,
		66,
		51,
		48,
		27,
		30,
		35,
		36,
		61,
		-1,
		-1,
		207,
		211,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		90,
		86,
		65,
		50,
		53,
		36,
		54,
		41,
		66,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		98,
		71,
		74,
		54,
		56,
		42,
		52,
		48,
		68,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		72,
		82,
		76,
		56,
		65,
		49,
		63,
		70,
		76,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		90,
		77,
		87,
		84,
		70,
		61,
		76,
		68,
		68,
		60,
		85,
		88,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		94,
		98,
		92,
		91,
		87,
		79,
		80,
		62,
		83,
		-1,
		68,
		62,
		90,
		93,
		83,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		106,
		101,
		99,
		99,
		98,
		87,
		95,
		87,
		67,
		77,
		97,
		83,
		81,
		74,
		79,
		78,
		92,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		111,
		110,
		101,
		109,
		91,
		84,
		70,
		74,
		92,
		92,
		87,
		93,
		85,
		88,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		118,
		134,
		135,
		113,
		110,
		108,
		118,
		106,
		95,
		82,
		86,
		101,
		102,
		88,
		88,
		90,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		132,
		130,
		124,
		115,
		121,
		119,
		115,
		110,
		100,
		89,
		95,
		91,
		110,
		96,
		94,
		89,
		104,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		132,
		116,
		121,
		-1,
		135,
		-1,
		108,
		108,
		99,
		88,
		85,
		96,
		94,
		105,
		95,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		148,
		128,
		122,
		121,
		130,
		125,
		116,
		97,
		90,
		87,
		88,
		101,
		121,
		109,
		97,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		165,
		153,
		143,
		133,
		151,
		141,
		116,
		109,
		95,
		97,
		95,
		97,
		102,
		110,
		102,
		112,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		154,
		-1,
		-1,
		145,
		143,
		133,
		112,
		99,
		119,
		122,
		112,
		96,
		111,
		116,
		104,
		113,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		158,
		153,
		157,
		148,
		-1,
		129,
		123,
		103,
		117,
		124,
		114,
		109,
		103,
		106,
		121,
		115,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		155,
		169,
		146,
		139,
		143,
		-1,
		131,
		119,
		105,
		122,
		127,
		124,
		115,
		107,
		112,
		109,
		122,
		127,
		117,
		204,
		-1,
		187,
		-1,
		-1,
		-1,
		173,
		188,
		185,
		162,
		135,
		130,
		123,
		117,
		113,
		129,
		135,
		146,
		114,
		110,
		111,
		115,
		114,
		131,
		132,
		-1,
		-1,
		187,
		204,
		199,
		181,
		185,
		212,
		-1,
		-1,
		139,
		130,
		121,
		124,
		123,
		126,
		120,
		117,
		122,
		127,
		115,
		124,
		142,
		135,
		-1,
		-1,
		-1,
		207,
		-1,
		222,
		-1,
		-1,
		200,
		210,
		157,
		139,
		135,
		133,
		126,
		135,
		130,
		125,
		135,
		137,
		129,
		117,
		121,
		144,
		133,
		164,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		228,
		211,
		215,
		221,
		220,
		214,
		172,
		169,
		-1,
		139,
		164,
		136,
		143,
		134,
		141,
		141,
		133,
		111,
		118,
		134,
		133,
		128,
		156,
		151,
		160,
		-1,
		-1,
		318,
		307,
		296,
		302,
		-1,
		221,
		217,
		207,
		197,
		200,
		-1,
		-1,
		188,
		185,
		161,
		144,
		142,
		135,
		130,
		140,
		120,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		166,
		-1,
		214,
		295,
		288,
		270,
		278,
		309,
		-1,
		211,
		203,
		214,
		189,
		191,
		-1,
		-1,
		161,
		158,
		163,
		151,
		148,
		150,
		145,
		136,
		121,
		127,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		228,
		271,
		264,
		267,
		291,
		305,
		-1,
		208,
		-1,
		-1,
		220,
		192,
		176,
		166,
		160,
		210,
		165,
		160,
		144,
		142,
		133,
		124,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		254,
		251,
		258,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		236,
		-1,
		203,
		-1,
		178,
		182,
		173,
		176,
		158,
		145,
		137,
		129,
		145,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		279,
		235,
		238,
		249,
		260,
		275,
		279,
		-1,
		220,
		259,
		257,
		-1,
		241,
		-1,
		-1,
		-1,
		192,
		186,
		178,
		178,
		157,
		157,
		131,
		135,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		275,
		266,
		279,
		224,
		224,
		245,
		254,
		275,
		235,
		226,
		253,
		264,
		253,
		248,
		235,
		-1,
		-1,
		215,
		196,
		-1,
		-1,
		164,
		152,
		135,
		136,
		132,
		135,
		150,
		153,
		143,
		141,
		135,
		167,
		-1,
		268,
		267,
		256,
		253,
		229,
		220,
		215,
		242,
		-1,
		-1,
		237,
		254,
		248,
		252,
		268,
		293,
		-1,
		224,
		-1,
		-1,
		209,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		140,
		151,
		161,
		149,
		150,
		140,
		150,
		163,
		252,
		249,
		237,
		235,
		258,
		223,
		211,
		-1,
		224,
		222,
		228,
		235,
		252,
		282,
		-1,
		-1,
		240,
		220,
		-1,
		-1,
		192,
		190,
		179,
		-1,
		169,
		142,
		147,
		167,
		169,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		261,
		275,
		264,
		260,
		259,
		267,
		216,
		209,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		226,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		160,
		164,
		156,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		295,
		-1,
		247,
		223,
		237,
		252,
		260,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		235,
		238,
		-1,
		-1,
		237,
		239,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		242,
		243,
		244,
		-1,
		222,
		-1,
		240,
		-1,
		207,
		213,
		201,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		183,
		181,
		172,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		240,
		214,
		247,
		238,
		221,
		201,
		193,
		212,
		-1,
		182,
		-1,
		157,
		159,
		185,
		188,
		194,
		188,
		161,
		176,
		166,
		157,
		166,
		246,
		-1,
		216,
		249,
		213,
		207,
		183,
		187,
		203,
		-1,
		179,
		161,
		-1,
		189,
		179,
		210,
		195,
		176,
		163,
		170,
		170,
		163,
		-1,
		-1,
		-1,
		218,
		217,
		209,
		203,
		203,
		188,
		179,
		-1,
		191,
		173,
		152,
		169,
		169,
		160,
		168,
		200,
		196,
		183,
		183,
		175,
		-1,
		319,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		212,
		207,
		180,
		168,
		174,
		170,
		156,
		162,
		164,
		172,
		170,
		167,
		179,
		175,
		195,
		176,
		211,
		-1,
		314,
		-1,
		248,
		-1,
		-1,
		230,
		210,
		202,
		191,
		180,
		178,
		169,
		160,
		182,
		198,
		182,
		180,
		183,
		184,
		-1,
		303,
		302,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		226,
		187,
		-1,
		189,
		169,
		-1,
		191,
		187,
		-1,
		-1,
		290,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		221,
		205,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		275,
		274,
		-1,
		243,
		246,
		-1,
		236,
		227,
		235,
		182,
		186,
		-1,
		-1,
		-1,
		284,
		265,
		259,
		258,
		256,
		251,
		248,
		234,
		218,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		256,
		248,
		241,
		-1,
		-1,
		243,
		226,
		207,
		205,
		-1,
		-1,
		-1,
		278,
		259,
		-1,
		-1,
		233,
		-1,
		-1,
		239,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		267,
		-1,
		-1,
		-1,
		229,
		225,
		226,
		-1,
		-1,
		-1,
		-1,
		289,
		290,
		313,
		277,
		-1,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		292,
		290,
		-1,
		-1,
		-1,
		249,
		233,
		-1,
		219,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		254,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		267,
		259,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		282,
		273,
		-1,
		-1,
		244,
		251,
		273,
		276,
		312,
		-1,
		263
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		197,
		201,
		167,
		161,
		200,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		190,
		189,
		157,
		155,
		164,
		169,
		176,
		-1,
		175,
		-1,
		211,
		190,
		201,
		206,
		150,
		147,
		167,
		186,
		168,
		160,
		226,
		180,
		151,
		145,
		163,
		153,
		162,
		154,
		-1,
		151,
		141,
		163,
		142,
		153,
		145,
		-1,
		-1,
		145,
		146,
		152,
		138,
		144,
		140,
		-1,
		146,
		119,
		-1,
		-1,
		135,
		136,
		120,
		123,
		131,
		129,
		142,
		128,
		114,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		114,
		101,
		99,
		-1,
		138,
		155,
		155,
		123,
		121,
		105,
		103,
		121,
		116,
		99,
		91,
		-1,
		155,
		151,
		152,
		150,
		145,
		121,
		108,
		108,
		118,
		110,
		93,
		80,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		147,
		164,
		148,
		138,
		142,
		140,
		111,
		108,
		106,
		103,
		96,
		79,
		84,
		-1,
		-1,
		249,
		222,
		246,
		204,
		186,
		-1,
		152,
		152,
		146,
		142,
		136,
		129,
		142,
		127,
		-1,
		87,
		96,
		86,
		72,
		78,
		231,
		-1,
		-1,
		207,
		199,
		181,
		184,
		161,
		157,
		167,
		166,
		159,
		147,
		143,
		126,
		129,
		129,
		135,
		91,
		82,
		79,
		69,
		50,
		-1,
		-1,
		75,
		-1,
		-1,
		228,
		211,
		-1,
		176,
		183,
		167,
		173,
		159,
		180,
		177,
		168,
		162,
		157,
		145,
		124,
		121,
		134,
		113,
		88,
		88,
		91,
		64,
		40,
		35,
		-1,
		74,
		58,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		183,
		180,
		173,
		197,
		196,
		-1,
		192,
		180,
		181,
		166,
		163,
		150,
		138,
		129,
		113,
		113,
		110,
		92,
		90,
		89,
		61,
		39,
		29,
		0,
		50,
		44,
		53,
		-1,
		236,
		232,
		228,
		235,
		184,
		-1,
		-1,
		201,
		-1,
		204,
		217,
		204,
		177,
		180,
		167,
		158,
		145,
		134,
		130,
		111,
		108,
		104,
		84,
		99,
		66,
		69,
		46,
		27,
		37,
		41,
		47,
		-1,
		286,
		-1,
		228,
		212,
		214,
		187,
		208,
		-1,
		221,
		205,
		221,
		206,
		206,
		-1,
		176,
		173,
		163,
		141,
		126,
		123,
		111,
		106,
		97,
		79,
		89,
		64,
		58,
		50,
		36,
		26,
		45,
		55,
		246,
		236,
		-1,
		218,
		223,
		183,
		191,
		210,
		248,
		212,
		-1,
		207,
		-1,
		178,
		191,
		-1,
		147,
		143,
		125,
		119,
		108,
		115,
		90,
		75,
		72,
		56,
		59,
		32,
		33,
		39,
		-1,
		-1,
		231,
		235,
		225,
		176,
		195,
		219,
		256,
		205,
		194,
		193,
		-1,
		184,
		161,
		158,
		146,
		133,
		118,
		119,
		114,
		110,
		89,
		74,
		76,
		65,
		51,
		38,
		63,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		202,
		173,
		197,
		239,
		223,
		216,
		204,
		169,
		169,
		163,
		-1,
		157,
		136,
		127,
		116,
		114,
		122,
		95,
		90,
		74,
		72,
		61,
		49,
		45,
		65,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		168,
		191,
		228,
		202,
		188,
		193,
		168,
		161,
		155,
		170,
		153,
		134,
		123,
		115,
		104,
		96,
		102,
		94,
		70,
		75,
		55,
		60,
		67,
		73,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		182,
		189,
		221,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		114,
		101,
		101,
		99,
		80,
		75,
		87,
		65,
		65,
		57,
		82,
		85,
		-1,
		-1,
		-1,
		232,
		227,
		202,
		179,
		163,
		199,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		118,
		122,
		116,
		111,
		101,
		93,
		94,
		76,
		89,
		-1,
		65,
		59,
		87,
		90,
		80,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		125,
		122,
		123,
		114,
		103,
		109,
		101,
		81,
		91,
		103,
		80,
		78,
		71,
		76,
		75,
		89,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		135,
		126,
		117,
		125,
		105,
		98,
		84,
		88,
		98,
		89,
		84,
		90,
		82,
		85,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		136,
		126,
		124,
		132,
		120,
		109,
		96,
		100,
		102,
		99,
		85,
		85,
		87,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		140,
		172,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		138,
		144,
		135,
		129,
		124,
		114,
		103,
		109,
		105,
		107,
		93,
		91,
		86,
		101,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		155,
		139,
		144,
		-1,
		149,
		-1,
		122,
		122,
		113,
		102,
		99,
		103,
		94,
		107,
		92,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		209,
		-1,
		-1,
		179,
		173,
		173,
		157,
		160,
		171,
		151,
		145,
		144,
		144,
		139,
		130,
		111,
		104,
		101,
		102,
		115,
		127,
		106,
		94,
		-1,
		-1,
		-1,
		206,
		192,
		196,
		156,
		175,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		166,
		188,
		176,
		166,
		156,
		165,
		155,
		130,
		123,
		109,
		111,
		109,
		111,
		116,
		107,
		99,
		109,
		-1,
		-1,
		189,
		194,
		182,
		168,
		187,
		-1,
		-1,
		-1,
		188,
		204,
		196,
		167,
		177,
		-1,
		-1,
		166,
		157,
		147,
		126,
		113,
		133,
		136,
		126,
		110,
		123,
		113,
		101,
		110,
		-1,
		192,
		179,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		-1,
		-1,
		221,
		183,
		172,
		167,
		171,
		165,
		-1,
		143,
		137,
		117,
		131,
		138,
		128,
		123,
		117,
		118,
		118,
		112,
		-1,
		-1,
		204,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		178,
		189,
		160,
		153,
		157,
		-1,
		145,
		133,
		119,
		136,
		141,
		138,
		129,
		121,
		126,
		115,
		128,
		124,
		114,
		227,
		-1,
		210,
		-1,
		-1,
		-1,
		196,
		211,
		199,
		176,
		149,
		144,
		137,
		131,
		127,
		143,
		149,
		160,
		128,
		124,
		125,
		121,
		120,
		128,
		129,
		-1,
		-1,
		210,
		227,
		222,
		204,
		208,
		226,
		-1,
		-1,
		153,
		144,
		135,
		138,
		137,
		140,
		134,
		131,
		136,
		138,
		129,
		130,
		147,
		132,
		-1,
		-1,
		-1,
		230,
		-1,
		245,
		-1,
		-1,
		223,
		224,
		171,
		153,
		149,
		147,
		140,
		149,
		144,
		139,
		149,
		151,
		143,
		128,
		135,
		158,
		140,
		161,
		-1,
		-1,
		339,
		-1,
		-1,
		-1,
		242,
		234,
		229,
		235,
		237,
		228,
		186,
		183,
		-1,
		153,
		178,
		150,
		157,
		148,
		155,
		155,
		147,
		125,
		132,
		148,
		147,
		142,
		153,
		148,
		157,
		-1,
		-1,
		332,
		321,
		310,
		316,
		-1,
		235,
		231,
		221,
		211,
		214,
		-1,
		-1,
		202,
		199,
		175,
		158,
		156,
		149,
		144,
		154,
		134,
		121,
		125,
		129,
		135,
		140,
		145,
		151,
		155,
		163,
		-1,
		237,
		318,
		311,
		284,
		292,
		323,
		-1,
		225,
		217,
		228,
		203,
		205,
		-1,
		-1,
		175,
		172,
		177,
		165,
		162,
		164,
		159,
		150,
		135,
		141,
		128,
		127,
		145,
		149,
		158,
		165,
		155,
		168,
		172,
		-1,
		251,
		294,
		278,
		281,
		305,
		319,
		-1,
		222,
		-1,
		-1,
		234,
		206,
		190,
		180,
		174,
		224,
		179,
		174,
		158,
		156,
		147,
		138,
		145,
		136,
		136,
		139,
		154,
		159,
		151,
		165,
		165,
		166,
		-1,
		268,
		274,
		272,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		250,
		-1,
		217,
		-1,
		192,
		196,
		187,
		190,
		172,
		159,
		151,
		143,
		159,
		134,
		144,
		140,
		141,
		150,
		161,
		173,
		172,
		173,
		293,
		249,
		252,
		263,
		274,
		289,
		293,
		-1,
		234,
		273,
		271,
		-1,
		255,
		-1,
		-1,
		-1,
		206,
		200,
		192,
		192,
		171,
		171,
		145,
		149,
		139,
		146,
		156,
		158,
		150,
		154,
		167,
		178,
		181,
		289,
		280,
		293,
		238,
		238,
		259,
		268,
		289,
		249,
		240,
		267,
		278,
		267,
		262,
		249,
		-1,
		-1,
		229,
		210,
		-1,
		-1,
		178,
		166,
		149,
		150,
		146,
		149,
		164,
		167,
		157,
		155,
		149,
		181,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		229,
		256,
		-1,
		-1,
		251,
		268,
		262,
		266,
		282,
		307,
		-1,
		238,
		-1,
		-1,
		223,
		-1,
		-1,
		208,
		171,
		160,
		151,
		157,
		154,
		165,
		175,
		163,
		164,
		154,
		164,
		177,
		266,
		263,
		251,
		249,
		272,
		237,
		225,
		-1,
		238,
		236,
		242,
		249,
		266,
		296,
		-1,
		-1,
		254,
		234,
		-1,
		-1,
		206,
		204,
		193,
		-1,
		183,
		156,
		161,
		181,
		183,
		172,
		166,
		160,
		167,
		166,
		174,
		182,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		223,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		240,
		-1,
		-1,
		201,
		194,
		182,
		170,
		160,
		170,
		174,
		178,
		170,
		163,
		158,
		169,
		161,
		165,
		182,
		-1,
		309,
		-1,
		261,
		237,
		251,
		266,
		274,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		235,
		219,
		200,
		-1,
		170,
		183,
		214,
		182,
		187,
		182,
		164,
		175,
		164,
		167,
		181,
		176,
		-1,
		-1,
		249,
		252,
		-1,
		-1,
		251,
		253,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		207,
		203,
		-1,
		-1,
		171,
		196,
		185,
		193,
		188,
		168,
		174,
		177,
		166,
		170,
		182,
		-1,
		-1,
		256,
		257,
		258,
		-1,
		236,
		-1,
		254,
		-1,
		221,
		227,
		215,
		-1,
		-1,
		-1,
		209,
		172,
		193,
		203,
		197,
		195,
		186,
		172,
		179,
		177,
		173,
		184,
		-1,
		-1,
		-1,
		254,
		228,
		261,
		252,
		235,
		215,
		207,
		226,
		-1,
		196,
		-1,
		171,
		173,
		199,
		202,
		208,
		202,
		175,
		190,
		180,
		171,
		180,
		260,
		-1,
		230,
		263,
		227,
		221,
		197,
		201,
		217,
		-1,
		193,
		175,
		-1,
		203,
		193,
		224,
		209,
		190,
		177,
		184,
		184,
		177,
		-1,
		-1,
		-1,
		232,
		231,
		223,
		217,
		217,
		202,
		193,
		-1,
		205,
		187,
		166,
		183,
		183,
		174,
		182,
		214,
		210,
		197,
		197,
		189,
		-1,
		333,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		226,
		221,
		194,
		182,
		188,
		184,
		170,
		176,
		178,
		186,
		184,
		181,
		193,
		189,
		209,
		190,
		225,
		-1,
		328,
		-1,
		262,
		-1,
		-1,
		244,
		224,
		216,
		205,
		194,
		192,
		183,
		174,
		196,
		212,
		196,
		194,
		197,
		198,
		-1,
		317,
		316,
		-1,
		263,
		255,
		241,
		-1,
		234,
		-1,
		240,
		201,
		-1,
		203,
		183,
		-1,
		205,
		201,
		-1,
		-1,
		304,
		279,
		-1,
		-1,
		-1,
		264,
		244,
		235,
		219,
		-1,
		194,
		194,
		-1,
		-1,
		-1,
		289,
		288,
		-1,
		257,
		260,
		-1,
		250,
		241,
		249,
		196,
		200,
		-1,
		-1,
		-1,
		298,
		279,
		273,
		272,
		270,
		265,
		262,
		248,
		232,
		210,
		199,
		220,
		-1,
		-1,
		-1,
		270,
		262,
		255,
		-1,
		-1,
		257,
		240,
		221,
		219,
		-1,
		-1,
		-1,
		292,
		273,
		-1,
		-1,
		247,
		-1,
		-1,
		253,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		281,
		-1,
		-1,
		-1,
		243,
		239,
		240,
		-1,
		-1,
		-1,
		-1,
		303,
		304,
		327,
		291,
		-1,
		-1,
		-1,
		235,
		229,
		-1,
		-1,
		306,
		304,
		-1,
		-1,
		-1,
		263,
		247,
		-1,
		233,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		268,
		-1,
		268,
		243,
		250,
		-1,
		-1,
		-1,
		-1,
		281,
		273,
		281,
		-1,
		253,
		255,
		-1,
		303,
		-1,
		-1,
		296,
		287,
		-1,
		-1,
		258,
		265,
		287,
		290,
		326,
		-1,
		277
	],
	[
		-1,
		195,
		184,
		195,
		203,
		176,
		183,
		-1,
		202,
		206,
		172,
		166,
		205,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		195,
		194,
		162,
		160,
		169,
		174,
		181,
		-1,
		180,
		-1,
		216,
		195,
		206,
		211,
		155,
		152,
		172,
		191,
		173,
		165,
		231,
		185,
		156,
		150,
		168,
		158,
		167,
		159,
		-1,
		156,
		146,
		168,
		147,
		158,
		150,
		-1,
		-1,
		150,
		151,
		157,
		143,
		149,
		145,
		-1,
		155,
		139,
		-1,
		-1,
		140,
		141,
		125,
		128,
		136,
		134,
		147,
		139,
		134,
		-1,
		-1,
		131,
		127,
		134,
		121,
		117,
		134,
		147,
		129,
		121,
		119,
		-1,
		143,
		160,
		160,
		128,
		126,
		110,
		108,
		126,
		128,
		119,
		111,
		-1,
		160,
		156,
		157,
		155,
		150,
		126,
		113,
		113,
		123,
		116,
		113,
		100,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		161,
		152,
		169,
		153,
		143,
		147,
		145,
		116,
		113,
		111,
		108,
		116,
		99,
		109,
		-1,
		-1,
		254,
		227,
		251,
		209,
		191,
		-1,
		157,
		157,
		151,
		147,
		141,
		134,
		147,
		132,
		-1,
		102,
		101,
		106,
		92,
		103,
		236,
		-1,
		-1,
		212,
		204,
		186,
		189,
		166,
		162,
		172,
		171,
		164,
		152,
		148,
		131,
		134,
		134,
		140,
		96,
		102,
		99,
		85,
		83,
		-1,
		-1,
		39,
		-1,
		-1,
		233,
		216,
		-1,
		181,
		188,
		172,
		178,
		164,
		185,
		182,
		173,
		167,
		162,
		150,
		129,
		126,
		139,
		118,
		93,
		109,
		112,
		80,
		73,
		68,
		-1,
		38,
		22,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		188,
		185,
		178,
		202,
		201,
		-1,
		197,
		185,
		186,
		171,
		168,
		155,
		143,
		134,
		118,
		118,
		115,
		97,
		95,
		105,
		77,
		72,
		62,
		50,
		0,
		17,
		26,
		-1,
		241,
		237,
		233,
		240,
		189,
		-1,
		-1,
		206,
		-1,
		209,
		222,
		209,
		182,
		185,
		172,
		163,
		150,
		139,
		135,
		116,
		113,
		109,
		89,
		104,
		82,
		83,
		51,
		51,
		42,
		14,
		20,
		-1,
		291,
		-1,
		233,
		217,
		219,
		192,
		213,
		-1,
		226,
		210,
		226,
		211,
		211,
		-1,
		181,
		178,
		168,
		146,
		131,
		128,
		116,
		111,
		102,
		84,
		98,
		78,
		64,
		55,
		41,
		28,
		18,
		28,
		251,
		241,
		-1,
		223,
		228,
		188,
		196,
		215,
		253,
		217,
		-1,
		212,
		-1,
		183,
		196,
		-1,
		152,
		148,
		130,
		124,
		113,
		120,
		95,
		80,
		77,
		70,
		73,
		37,
		38,
		29,
		-1,
		-1,
		236,
		240,
		230,
		181,
		200,
		224,
		261,
		210,
		199,
		198,
		-1,
		189,
		166,
		163,
		151,
		138,
		123,
		124,
		119,
		115,
		94,
		79,
		81,
		71,
		56,
		43,
		68,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		207,
		178,
		202,
		244,
		228,
		221,
		209,
		174,
		174,
		168,
		-1,
		162,
		141,
		132,
		121,
		119,
		127,
		100,
		95,
		79,
		77,
		66,
		54,
		50,
		70,
		-1,
		-1,
		-1,
		237,
		226,
		227,
		173,
		196,
		233,
		207,
		193,
		198,
		173,
		166,
		160,
		175,
		158,
		139,
		128,
		120,
		109,
		101,
		107,
		99,
		75,
		80,
		60,
		65,
		72,
		78,
		-1,
		-1,
		244,
		234,
		218,
		220,
		217,
		187,
		194,
		226,
		198,
		211,
		-1,
		165,
		-1,
		154,
		149,
		133,
		128,
		125,
		119,
		106,
		106,
		104,
		85,
		80,
		92,
		70,
		70,
		62,
		87,
		90,
		-1,
		-1,
		-1,
		237,
		232,
		207,
		184,
		168,
		204,
		-1,
		181,
		182,
		-1,
		159,
		153,
		150,
		135,
		131,
		123,
		127,
		121,
		116,
		106,
		98,
		99,
		81,
		94,
		-1,
		70,
		64,
		92,
		95,
		85,
		-1,
		-1,
		-1,
		230,
		209,
		202,
		222,
		163,
		215,
		-1,
		-1,
		166,
		159,
		-1,
		146,
		128,
		135,
		130,
		127,
		128,
		119,
		108,
		114,
		106,
		86,
		96,
		108,
		85,
		83,
		76,
		81,
		80,
		94,
		-1,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		183,
		-1,
		175,
		167,
		157,
		151,
		145,
		141,
		139,
		155,
		139,
		140,
		131,
		122,
		130,
		110,
		103,
		89,
		93,
		103,
		94,
		89,
		95,
		87,
		90,
		-1,
		250,
		236,
		207,
		-1,
		-1,
		196,
		-1,
		160,
		174,
		190,
		-1,
		183,
		162,
		177,
		155,
		151,
		147,
		162,
		163,
		141,
		131,
		129,
		137,
		125,
		114,
		101,
		105,
		107,
		104,
		90,
		90,
		92,
		-1,
		256,
		243,
		201,
		197,
		186,
		206,
		157,
		145,
		177,
		-1,
		-1,
		219,
		-1,
		153,
		170,
		161,
		159,
		152,
		143,
		149,
		140,
		134,
		129,
		119,
		108,
		114,
		110,
		112,
		98,
		96,
		91,
		106,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		172,
		159,
		153,
		-1,
		194,
		-1,
		197,
		187,
		171,
		156,
		189,
		-1,
		160,
		144,
		149,
		-1,
		154,
		-1,
		127,
		127,
		118,
		107,
		104,
		108,
		99,
		112,
		97,
		-1,
		206,
		191,
		184,
		174,
		188,
		159,
		-1,
		214,
		-1,
		-1,
		184,
		178,
		178,
		162,
		165,
		176,
		156,
		150,
		149,
		149,
		144,
		135,
		116,
		109,
		106,
		107,
		120,
		132,
		111,
		99,
		-1,
		-1,
		-1,
		211,
		197,
		201,
		161,
		180,
		-1,
		-1,
		246,
		201,
		187,
		-1,
		171,
		193,
		181,
		171,
		161,
		170,
		160,
		135,
		128,
		114,
		116,
		114,
		116,
		121,
		112,
		104,
		114,
		-1,
		-1,
		194,
		199,
		187,
		173,
		192,
		-1,
		-1,
		-1,
		193,
		209,
		201,
		172,
		182,
		-1,
		-1,
		171,
		162,
		152,
		131,
		118,
		138,
		141,
		131,
		115,
		128,
		118,
		106,
		115,
		-1,
		197,
		184,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		-1,
		-1,
		226,
		188,
		177,
		172,
		176,
		170,
		-1,
		148,
		142,
		122,
		136,
		143,
		133,
		128,
		122,
		123,
		123,
		117,
		-1,
		-1,
		209,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		183,
		194,
		165,
		158,
		162,
		-1,
		150,
		138,
		124,
		141,
		146,
		143,
		134,
		126,
		131,
		120,
		133,
		129,
		119,
		232,
		-1,
		215,
		-1,
		-1,
		-1,
		201,
		216,
		204,
		181,
		154,
		149,
		142,
		136,
		132,
		148,
		154,
		165,
		133,
		129,
		130,
		126,
		125,
		133,
		134,
		-1,
		-1,
		215,
		232,
		227,
		209,
		213,
		231,
		-1,
		-1,
		158,
		149,
		140,
		143,
		142,
		145,
		139,
		136,
		141,
		143,
		134,
		135,
		152,
		137,
		-1,
		-1,
		-1,
		235,
		-1,
		250,
		-1,
		-1,
		228,
		229,
		176,
		158,
		154,
		152,
		145,
		154,
		149,
		144,
		154,
		156,
		148,
		133,
		140,
		163,
		145,
		166,
		-1,
		-1,
		344,
		-1,
		-1,
		-1,
		247,
		239,
		234,
		240,
		242,
		233,
		191,
		188,
		-1,
		158,
		183,
		155,
		162,
		153,
		160,
		160,
		152,
		130,
		137,
		153,
		152,
		147,
		158,
		153,
		162,
		-1,
		-1,
		337,
		326,
		315,
		321,
		-1,
		240,
		236,
		226,
		216,
		219,
		-1,
		-1,
		207,
		204,
		180,
		163,
		161,
		154,
		149,
		159,
		139,
		126,
		130,
		134,
		140,
		145,
		150,
		156,
		160,
		168,
		-1,
		242,
		323,
		316,
		289,
		297,
		328,
		-1,
		230,
		222,
		233,
		208,
		210,
		-1,
		-1,
		180,
		177,
		182,
		170,
		167,
		169,
		164,
		155,
		140,
		146,
		133,
		132,
		150,
		154,
		163,
		170,
		160,
		173,
		177,
		-1,
		256,
		299,
		283,
		286,
		310,
		324,
		-1,
		227,
		-1,
		-1,
		239,
		211,
		195,
		185,
		179,
		229,
		184,
		179,
		163,
		161,
		152,
		143,
		150,
		141,
		141,
		144,
		159,
		164,
		156,
		170,
		170,
		171,
		-1,
		273,
		279,
		277,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		255,
		-1,
		222,
		-1,
		197,
		201,
		192,
		195,
		177,
		164,
		156,
		148,
		164,
		139,
		149,
		145,
		146,
		155,
		166,
		178,
		177,
		178,
		298,
		254,
		257,
		268,
		279,
		294,
		298,
		-1,
		239,
		278,
		276,
		-1,
		260,
		-1,
		-1,
		-1,
		211,
		205,
		197,
		197,
		176,
		176,
		150,
		154,
		144,
		151,
		161,
		163,
		155,
		159,
		172,
		183,
		186,
		294,
		285,
		298,
		243,
		243,
		264,
		273,
		294,
		254,
		245,
		272,
		283,
		272,
		267,
		254,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		183,
		171,
		154,
		155,
		151,
		154,
		169,
		172,
		162,
		160,
		154,
		186,
		-1,
		287,
		286,
		275,
		272,
		248,
		239,
		234,
		261,
		-1,
		-1,
		256,
		273,
		267,
		271,
		287,
		312,
		-1,
		243,
		-1,
		-1,
		228,
		-1,
		-1,
		213,
		176,
		165,
		156,
		162,
		159,
		170,
		180,
		168,
		169,
		159,
		169,
		182,
		271,
		268,
		256,
		254,
		277,
		242,
		230,
		-1,
		243,
		241,
		247,
		254,
		271,
		301,
		-1,
		-1,
		259,
		239,
		-1,
		-1,
		211,
		209,
		198,
		-1,
		188,
		161,
		166,
		186,
		188,
		177,
		171,
		165,
		172,
		171,
		179,
		187,
		280,
		294,
		283,
		279,
		278,
		286,
		235,
		228,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		-1,
		249,
		245,
		-1,
		-1,
		206,
		199,
		187,
		175,
		165,
		175,
		179,
		183,
		175,
		168,
		163,
		174,
		166,
		170,
		187,
		-1,
		314,
		-1,
		266,
		242,
		256,
		271,
		279,
		-1,
		-1,
		-1,
		266,
		252,
		245,
		233,
		231,
		-1,
		240,
		224,
		205,
		-1,
		175,
		188,
		219,
		187,
		192,
		187,
		169,
		180,
		169,
		172,
		186,
		181,
		-1,
		-1,
		254,
		257,
		-1,
		-1,
		256,
		258,
		-1,
		257,
		246,
		231,
		223,
		-1,
		-1,
		212,
		208,
		-1,
		-1,
		176,
		201,
		190,
		198,
		193,
		173,
		179,
		182,
		171,
		175,
		187,
		-1,
		-1,
		261,
		262,
		263,
		-1,
		241,
		-1,
		259,
		-1,
		226,
		232,
		220,
		-1,
		-1,
		-1,
		214,
		177,
		198,
		208,
		202,
		200,
		191,
		177,
		184,
		182,
		178,
		189,
		-1,
		-1,
		-1,
		259,
		233,
		266,
		257,
		240,
		220,
		212,
		231,
		-1,
		201,
		-1,
		176,
		178,
		204,
		207,
		213,
		207,
		180,
		195,
		185,
		176,
		185,
		265,
		-1,
		235,
		268,
		232,
		226,
		202,
		206,
		222,
		-1,
		198,
		180,
		-1,
		208,
		198,
		229,
		214,
		195,
		182,
		189,
		189,
		182,
		-1,
		-1,
		-1,
		237,
		236,
		228,
		222,
		222,
		207,
		198,
		-1,
		210,
		192,
		171,
		188,
		188,
		179,
		187,
		219,
		215,
		202,
		202,
		194,
		-1,
		338,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		231,
		226,
		199,
		187,
		193,
		189,
		175,
		181,
		183,
		191,
		189,
		186,
		198,
		194,
		214,
		195,
		230,
		-1,
		333,
		-1,
		267,
		-1,
		-1,
		249,
		229,
		221,
		210,
		199,
		197,
		188,
		179,
		201,
		217,
		201,
		199,
		202,
		203,
		-1,
		322,
		321,
		-1,
		268,
		260,
		246,
		-1,
		239,
		-1,
		245,
		206,
		-1,
		208,
		188,
		-1,
		210,
		206,
		-1,
		-1,
		309,
		284,
		-1,
		-1,
		-1,
		269,
		249,
		240,
		224,
		-1,
		199,
		199,
		-1,
		-1,
		-1,
		294,
		293,
		-1,
		262,
		265,
		-1,
		255,
		246,
		254,
		201,
		205,
		-1,
		-1,
		-1,
		303,
		284,
		278,
		277,
		275,
		270,
		267,
		253,
		237,
		215,
		204,
		225,
		-1,
		-1,
		-1,
		275,
		267,
		260,
		-1,
		-1,
		262,
		245,
		226,
		224,
		-1,
		-1,
		-1,
		297,
		278,
		-1,
		-1,
		252,
		-1,
		-1,
		258,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		286,
		-1,
		-1,
		-1,
		248,
		244,
		245,
		-1,
		-1,
		-1,
		-1,
		308,
		309,
		332,
		296,
		-1,
		-1,
		-1,
		240,
		234,
		-1,
		-1,
		311,
		309,
		-1,
		-1,
		-1,
		268,
		252,
		-1,
		238,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		273,
		-1,
		273,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		286,
		278,
		286,
		-1,
		258,
		260,
		-1,
		308,
		-1,
		-1,
		301,
		292,
		-1,
		-1,
		263,
		270,
		292,
		295,
		331,
		-1,
		282
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		198,
		202,
		168,
		162,
		201,
		170,
		176,
		187,
		-1,
		-1,
		-1,
		191,
		190,
		158,
		156,
		165,
		170,
		177,
		-1,
		176,
		-1,
		212,
		191,
		202,
		207,
		151,
		148,
		168,
		187,
		169,
		161,
		227,
		181,
		152,
		146,
		164,
		154,
		163,
		155,
		-1,
		152,
		142,
		164,
		143,
		154,
		146,
		-1,
		-1,
		146,
		147,
		153,
		139,
		145,
		141,
		-1,
		151,
		135,
		-1,
		-1,
		136,
		137,
		121,
		124,
		132,
		130,
		143,
		135,
		130,
		-1,
		-1,
		127,
		123,
		130,
		117,
		113,
		130,
		143,
		125,
		117,
		115,
		-1,
		139,
		156,
		156,
		124,
		122,
		106,
		104,
		122,
		124,
		115,
		107,
		-1,
		156,
		152,
		153,
		151,
		146,
		122,
		109,
		109,
		119,
		112,
		109,
		96,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		148,
		165,
		149,
		139,
		143,
		141,
		112,
		109,
		107,
		104,
		112,
		95,
		105,
		-1,
		-1,
		250,
		223,
		247,
		205,
		187,
		-1,
		153,
		153,
		147,
		143,
		137,
		130,
		143,
		128,
		-1,
		98,
		97,
		102,
		88,
		99,
		232,
		-1,
		-1,
		208,
		200,
		182,
		185,
		162,
		158,
		168,
		167,
		160,
		148,
		144,
		127,
		130,
		130,
		136,
		92,
		98,
		95,
		81,
		79,
		-1,
		-1,
		44,
		-1,
		-1,
		229,
		212,
		-1,
		177,
		184,
		168,
		174,
		160,
		181,
		178,
		169,
		163,
		158,
		146,
		125,
		122,
		135,
		114,
		89,
		105,
		108,
		76,
		69,
		64,
		-1,
		43,
		27,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		184,
		181,
		174,
		198,
		197,
		-1,
		193,
		181,
		182,
		167,
		164,
		151,
		139,
		130,
		114,
		114,
		111,
		93,
		91,
		101,
		73,
		68,
		58,
		46,
		19,
		0,
		9,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		202,
		-1,
		205,
		218,
		205,
		178,
		181,
		168,
		159,
		146,
		135,
		131,
		112,
		109,
		105,
		85,
		100,
		78,
		79,
		47,
		47,
		38,
		6,
		3,
		-1,
		287,
		-1,
		229,
		213,
		215,
		188,
		209,
		-1,
		222,
		206,
		222,
		207,
		207,
		-1,
		177,
		174,
		164,
		142,
		127,
		124,
		112,
		107,
		98,
		80,
		94,
		74,
		60,
		51,
		37,
		24,
		13,
		24,
		247,
		237,
		-1,
		219,
		224,
		184,
		192,
		211,
		249,
		213,
		-1,
		208,
		-1,
		179,
		192,
		-1,
		148,
		144,
		126,
		120,
		109,
		116,
		91,
		76,
		73,
		66,
		69,
		33,
		34,
		22,
		-1,
		-1,
		232,
		236,
		226,
		177,
		196,
		220,
		257,
		206,
		195,
		194,
		-1,
		185,
		162,
		159,
		147,
		134,
		119,
		120,
		115,
		111,
		90,
		75,
		77,
		67,
		52,
		39,
		64,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		203,
		174,
		198,
		240,
		224,
		217,
		205,
		170,
		170,
		164,
		-1,
		158,
		137,
		128,
		117,
		115,
		123,
		96,
		91,
		75,
		73,
		62,
		50,
		46,
		66,
		-1,
		-1,
		-1,
		233,
		222,
		223,
		169,
		192,
		229,
		203,
		189,
		194,
		169,
		162,
		156,
		171,
		154,
		135,
		124,
		116,
		105,
		97,
		103,
		95,
		71,
		76,
		56,
		61,
		68,
		74,
		-1,
		-1,
		240,
		230,
		214,
		216,
		213,
		183,
		190,
		222,
		194,
		207,
		-1,
		161,
		-1,
		150,
		145,
		129,
		124,
		121,
		115,
		102,
		102,
		100,
		81,
		76,
		88,
		66,
		66,
		58,
		83,
		86,
		-1,
		-1,
		-1,
		233,
		228,
		203,
		180,
		164,
		200,
		-1,
		177,
		178,
		-1,
		155,
		149,
		146,
		131,
		127,
		119,
		123,
		117,
		112,
		102,
		94,
		95,
		77,
		90,
		-1,
		66,
		60,
		88,
		91,
		81,
		-1,
		-1,
		-1,
		226,
		205,
		198,
		218,
		159,
		211,
		-1,
		-1,
		162,
		155,
		-1,
		142,
		124,
		131,
		126,
		123,
		124,
		115,
		104,
		110,
		102,
		82,
		92,
		104,
		81,
		79,
		72,
		77,
		76,
		90,
		-1,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		179,
		-1,
		171,
		163,
		153,
		147,
		141,
		137,
		135,
		151,
		135,
		136,
		127,
		118,
		126,
		106,
		99,
		85,
		89,
		99,
		90,
		85,
		91,
		83,
		86,
		-1,
		246,
		232,
		203,
		-1,
		-1,
		192,
		-1,
		156,
		170,
		186,
		-1,
		179,
		158,
		173,
		151,
		147,
		143,
		158,
		159,
		137,
		127,
		125,
		133,
		121,
		110,
		97,
		101,
		103,
		100,
		86,
		86,
		88,
		-1,
		252,
		239,
		197,
		193,
		182,
		202,
		153,
		141,
		173,
		-1,
		-1,
		215,
		-1,
		149,
		166,
		157,
		155,
		148,
		139,
		145,
		136,
		130,
		125,
		115,
		104,
		110,
		106,
		108,
		94,
		92,
		87,
		102,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		168,
		155,
		149,
		-1,
		190,
		-1,
		193,
		183,
		167,
		152,
		185,
		-1,
		156,
		140,
		145,
		-1,
		150,
		-1,
		123,
		123,
		114,
		103,
		100,
		104,
		95,
		108,
		93,
		-1,
		202,
		187,
		180,
		170,
		184,
		155,
		-1,
		210,
		-1,
		-1,
		180,
		174,
		174,
		158,
		161,
		172,
		152,
		146,
		145,
		145,
		140,
		131,
		112,
		105,
		102,
		103,
		116,
		128,
		107,
		95,
		-1,
		-1,
		-1,
		207,
		193,
		197,
		157,
		176,
		-1,
		-1,
		242,
		197,
		183,
		-1,
		167,
		189,
		177,
		167,
		157,
		166,
		156,
		131,
		124,
		110,
		112,
		110,
		112,
		117,
		108,
		100,
		110,
		-1,
		-1,
		190,
		195,
		183,
		169,
		188,
		-1,
		-1,
		-1,
		189,
		205,
		197,
		168,
		178,
		-1,
		-1,
		167,
		158,
		148,
		127,
		114,
		134,
		137,
		127,
		111,
		124,
		114,
		102,
		111,
		-1,
		193,
		180,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		-1,
		-1,
		222,
		184,
		173,
		168,
		172,
		166,
		-1,
		144,
		138,
		118,
		132,
		139,
		129,
		124,
		118,
		119,
		119,
		113,
		-1,
		-1,
		205,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		179,
		190,
		161,
		154,
		158,
		-1,
		146,
		134,
		120,
		137,
		142,
		139,
		130,
		122,
		127,
		116,
		129,
		125,
		115,
		228,
		-1,
		211,
		-1,
		-1,
		-1,
		197,
		212,
		200,
		177,
		150,
		145,
		138,
		132,
		128,
		144,
		150,
		161,
		129,
		125,
		126,
		122,
		121,
		129,
		130,
		-1,
		-1,
		211,
		228,
		223,
		205,
		209,
		227,
		-1,
		-1,
		154,
		145,
		136,
		139,
		138,
		141,
		135,
		132,
		137,
		139,
		130,
		131,
		148,
		133,
		-1,
		-1,
		-1,
		231,
		-1,
		246,
		-1,
		-1,
		224,
		225,
		172,
		154,
		150,
		148,
		141,
		150,
		145,
		140,
		150,
		152,
		144,
		129,
		136,
		159,
		141,
		162,
		-1,
		-1,
		340,
		-1,
		-1,
		-1,
		243,
		235,
		230,
		236,
		238,
		229,
		187,
		184,
		-1,
		154,
		179,
		151,
		158,
		149,
		156,
		156,
		148,
		126,
		133,
		149,
		148,
		143,
		154,
		149,
		158,
		-1,
		-1,
		333,
		322,
		311,
		317,
		-1,
		236,
		232,
		222,
		212,
		215,
		-1,
		-1,
		203,
		200,
		176,
		159,
		157,
		150,
		145,
		155,
		135,
		122,
		126,
		130,
		136,
		141,
		146,
		152,
		156,
		164,
		-1,
		238,
		319,
		312,
		285,
		293,
		324,
		-1,
		226,
		218,
		229,
		204,
		206,
		-1,
		-1,
		176,
		173,
		178,
		166,
		163,
		165,
		160,
		151,
		136,
		142,
		129,
		128,
		146,
		150,
		159,
		166,
		156,
		169,
		173,
		-1,
		252,
		295,
		279,
		282,
		306,
		320,
		-1,
		223,
		-1,
		-1,
		235,
		207,
		191,
		181,
		175,
		225,
		180,
		175,
		159,
		157,
		148,
		139,
		146,
		137,
		137,
		140,
		155,
		160,
		152,
		166,
		166,
		167,
		-1,
		269,
		275,
		273,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		251,
		-1,
		218,
		-1,
		193,
		197,
		188,
		191,
		173,
		160,
		152,
		144,
		160,
		135,
		145,
		141,
		142,
		151,
		162,
		174,
		173,
		174,
		294,
		250,
		253,
		264,
		275,
		290,
		294,
		-1,
		235,
		274,
		272,
		-1,
		256,
		-1,
		-1,
		-1,
		207,
		201,
		193,
		193,
		172,
		172,
		146,
		150,
		140,
		147,
		157,
		159,
		151,
		155,
		168,
		179,
		182,
		290,
		281,
		294,
		239,
		239,
		260,
		269,
		290,
		250,
		241,
		268,
		279,
		268,
		263,
		250,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		179,
		167,
		150,
		151,
		147,
		150,
		165,
		168,
		158,
		156,
		150,
		182,
		-1,
		283,
		282,
		271,
		268,
		244,
		235,
		230,
		257,
		-1,
		-1,
		252,
		269,
		263,
		267,
		283,
		308,
		-1,
		239,
		-1,
		-1,
		224,
		-1,
		-1,
		209,
		172,
		161,
		152,
		158,
		155,
		166,
		176,
		164,
		165,
		155,
		165,
		178,
		267,
		264,
		252,
		250,
		273,
		238,
		226,
		-1,
		239,
		237,
		243,
		250,
		267,
		297,
		-1,
		-1,
		255,
		235,
		-1,
		-1,
		207,
		205,
		194,
		-1,
		184,
		157,
		162,
		182,
		184,
		173,
		167,
		161,
		168,
		167,
		175,
		183,
		276,
		290,
		279,
		275,
		274,
		282,
		231,
		224,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		-1,
		245,
		241,
		-1,
		-1,
		202,
		195,
		183,
		171,
		161,
		171,
		175,
		179,
		171,
		164,
		159,
		170,
		162,
		166,
		183,
		-1,
		310,
		-1,
		262,
		238,
		252,
		267,
		275,
		-1,
		-1,
		-1,
		262,
		248,
		241,
		229,
		227,
		-1,
		236,
		220,
		201,
		-1,
		171,
		184,
		215,
		183,
		188,
		183,
		165,
		176,
		165,
		168,
		182,
		177,
		-1,
		-1,
		250,
		253,
		-1,
		-1,
		252,
		254,
		-1,
		253,
		242,
		227,
		219,
		-1,
		-1,
		208,
		204,
		-1,
		-1,
		172,
		197,
		186,
		194,
		189,
		169,
		175,
		178,
		167,
		171,
		183,
		-1,
		-1,
		257,
		258,
		259,
		-1,
		237,
		-1,
		255,
		-1,
		222,
		228,
		216,
		-1,
		-1,
		-1,
		210,
		173,
		194,
		204,
		198,
		196,
		187,
		173,
		180,
		178,
		174,
		185,
		-1,
		-1,
		-1,
		255,
		229,
		262,
		253,
		236,
		216,
		208,
		227,
		-1,
		197,
		-1,
		172,
		174,
		200,
		203,
		209,
		203,
		176,
		191,
		181,
		172,
		181,
		261,
		-1,
		231,
		264,
		228,
		222,
		198,
		202,
		218,
		-1,
		194,
		176,
		-1,
		204,
		194,
		225,
		210,
		191,
		178,
		185,
		185,
		178,
		-1,
		-1,
		-1,
		233,
		232,
		224,
		218,
		218,
		203,
		194,
		-1,
		206,
		188,
		167,
		184,
		184,
		175,
		183,
		215,
		211,
		198,
		198,
		190,
		-1,
		334,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		227,
		222,
		195,
		183,
		189,
		185,
		171,
		177,
		179,
		187,
		185,
		182,
		194,
		190,
		210,
		191,
		226,
		-1,
		329,
		-1,
		263,
		-1,
		-1,
		245,
		225,
		217,
		206,
		195,
		193,
		184,
		175,
		197,
		213,
		197,
		195,
		198,
		199,
		-1,
		318,
		317,
		-1,
		264,
		256,
		242,
		-1,
		235,
		-1,
		241,
		202,
		-1,
		204,
		184,
		-1,
		206,
		202,
		-1,
		-1,
		305,
		280,
		-1,
		-1,
		-1,
		265,
		245,
		236,
		220,
		-1,
		195,
		195,
		-1,
		-1,
		-1,
		290,
		289,
		-1,
		258,
		261,
		-1,
		251,
		242,
		250,
		197,
		201,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		273,
		271,
		266,
		263,
		249,
		233,
		211,
		200,
		221,
		-1,
		-1,
		-1,
		271,
		263,
		256,
		-1,
		-1,
		258,
		241,
		222,
		220,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		248,
		-1,
		-1,
		254,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		282,
		-1,
		-1,
		-1,
		244,
		240,
		241,
		-1,
		-1,
		-1,
		-1,
		304,
		305,
		328,
		292,
		-1,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		307,
		305,
		-1,
		-1,
		-1,
		264,
		248,
		-1,
		234,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		269,
		-1,
		269,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		282,
		274,
		282,
		-1,
		254,
		256,
		-1,
		304,
		-1,
		-1,
		297,
		288,
		-1,
		-1,
		259,
		266,
		288,
		291,
		327,
		-1,
		278
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		124,
		122,
		-1,
		146,
		163,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		122,
		114,
		-1,
		163,
		159,
		160,
		158,
		153,
		129,
		116,
		116,
		126,
		119,
		116,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		155,
		172,
		156,
		146,
		150,
		148,
		119,
		116,
		114,
		111,
		119,
		102,
		112,
		-1,
		-1,
		257,
		230,
		254,
		212,
		194,
		-1,
		160,
		160,
		154,
		150,
		144,
		137,
		150,
		135,
		-1,
		105,
		104,
		109,
		95,
		106,
		239,
		-1,
		-1,
		215,
		207,
		189,
		192,
		169,
		165,
		175,
		174,
		167,
		155,
		151,
		134,
		137,
		137,
		143,
		99,
		105,
		102,
		88,
		86,
		-1,
		-1,
		51,
		-1,
		-1,
		236,
		219,
		-1,
		184,
		191,
		175,
		181,
		167,
		188,
		185,
		176,
		170,
		165,
		153,
		132,
		129,
		142,
		121,
		96,
		112,
		115,
		83,
		76,
		71,
		-1,
		50,
		34,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		191,
		188,
		181,
		205,
		204,
		-1,
		200,
		188,
		189,
		174,
		171,
		158,
		146,
		137,
		121,
		121,
		118,
		100,
		98,
		108,
		80,
		75,
		65,
		53,
		26,
		10,
		0,
		-1,
		244,
		240,
		236,
		243,
		192,
		-1,
		-1,
		209,
		-1,
		212,
		225,
		212,
		185,
		188,
		175,
		166,
		153,
		142,
		138,
		119,
		116,
		112,
		92,
		107,
		85,
		86,
		54,
		54,
		45,
		13,
		8,
		-1,
		294,
		-1,
		236,
		220,
		222,
		195,
		216,
		-1,
		229,
		213,
		229,
		214,
		214,
		-1,
		184,
		181,
		171,
		149,
		134,
		131,
		119,
		114,
		105,
		87,
		101,
		81,
		67,
		58,
		44,
		31,
		20,
		31,
		254,
		244,
		-1,
		226,
		231,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		186,
		199,
		-1,
		155,
		151,
		133,
		127,
		116,
		123,
		98,
		83,
		80,
		73,
		76,
		40,
		41,
		29,
		-1,
		-1,
		239,
		243,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		169,
		166,
		154,
		141,
		126,
		127,
		122,
		118,
		97,
		82,
		84,
		74,
		59,
		46,
		71,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		165,
		144,
		135,
		124,
		122,
		130,
		103,
		98,
		82,
		80,
		69,
		57,
		53,
		73,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		178,
		161,
		142,
		131,
		123,
		112,
		104,
		110,
		102,
		78,
		83,
		63,
		68,
		75,
		81,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		152,
		136,
		131,
		128,
		122,
		109,
		109,
		107,
		88,
		83,
		95,
		73,
		73,
		65,
		90,
		93,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		138,
		134,
		126,
		130,
		124,
		119,
		109,
		101,
		102,
		84,
		97,
		-1,
		73,
		67,
		95,
		98,
		88,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		138,
		133,
		130,
		131,
		122,
		111,
		117,
		109,
		89,
		99,
		111,
		88,
		86,
		79,
		84,
		83,
		97,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		158,
		142,
		143,
		134,
		125,
		133,
		113,
		106,
		92,
		96,
		106,
		97,
		92,
		98,
		90,
		93,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		150,
		165,
		166,
		144,
		134,
		132,
		140,
		128,
		117,
		104,
		108,
		110,
		107,
		93,
		93,
		95,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		164,
		162,
		155,
		146,
		152,
		143,
		137,
		132,
		122,
		111,
		117,
		113,
		115,
		101,
		99,
		94,
		109,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		163,
		147,
		152,
		-1,
		157,
		-1,
		130,
		130,
		121,
		110,
		107,
		111,
		102,
		115,
		100,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		179,
		159,
		153,
		152,
		152,
		147,
		138,
		119,
		112,
		109,
		110,
		123,
		135,
		114,
		102,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		174,
		196,
		184,
		174,
		164,
		173,
		163,
		138,
		131,
		117,
		119,
		117,
		119,
		124,
		115,
		107,
		117,
		-1,
		-1,
		197,
		202,
		190,
		176,
		195,
		-1,
		-1,
		-1,
		196,
		212,
		204,
		175,
		185,
		-1,
		-1,
		174,
		165,
		155,
		134,
		121,
		141,
		144,
		134,
		118,
		131,
		121,
		109,
		118,
		-1,
		200,
		187,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		-1,
		-1,
		229,
		191,
		180,
		175,
		179,
		173,
		-1,
		151,
		145,
		125,
		139,
		146,
		136,
		131,
		125,
		126,
		126,
		120,
		-1,
		-1,
		212,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		186,
		197,
		168,
		161,
		165,
		-1,
		153,
		141,
		127,
		144,
		149,
		146,
		137,
		129,
		134,
		123,
		136,
		132,
		122,
		235,
		-1,
		218,
		-1,
		-1,
		-1,
		204,
		219,
		207,
		184,
		157,
		152,
		145,
		139,
		135,
		151,
		157,
		168,
		136,
		132,
		133,
		129,
		128,
		136,
		137,
		-1,
		-1,
		218,
		235,
		230,
		212,
		216,
		234,
		-1,
		-1,
		161,
		152,
		143,
		146,
		145,
		148,
		142,
		139,
		144,
		146,
		137,
		138,
		155,
		140,
		-1,
		-1,
		-1,
		238,
		-1,
		253,
		-1,
		-1,
		231,
		232,
		179,
		161,
		157,
		155,
		148,
		157,
		152,
		147,
		157,
		159,
		151,
		136,
		143,
		166,
		148,
		169,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		250,
		242,
		237,
		243,
		245,
		236,
		194,
		191,
		-1,
		161,
		186,
		158,
		165,
		156,
		163,
		163,
		155,
		133,
		140,
		156,
		155,
		150,
		161,
		156,
		165,
		-1,
		-1,
		340,
		329,
		318,
		324,
		-1,
		243,
		239,
		229,
		219,
		222,
		-1,
		-1,
		210,
		207,
		183,
		166,
		164,
		157,
		152,
		162,
		142,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		163,
		171,
		-1,
		245,
		326,
		319,
		292,
		300,
		331,
		-1,
		233,
		225,
		236,
		211,
		213,
		-1,
		-1,
		183,
		180,
		185,
		173,
		170,
		172,
		167,
		158,
		143,
		149,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		259,
		302,
		286,
		289,
		313,
		327,
		-1,
		230,
		-1,
		-1,
		242,
		214,
		198,
		188,
		182,
		232,
		187,
		182,
		166,
		164,
		155,
		146,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		276,
		282,
		280,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		258,
		-1,
		225,
		-1,
		200,
		204,
		195,
		198,
		180,
		167,
		159,
		151,
		167,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		301,
		257,
		260,
		271,
		282,
		297,
		301,
		-1,
		242,
		281,
		279,
		-1,
		263,
		-1,
		-1,
		-1,
		214,
		208,
		200,
		200,
		179,
		179,
		153,
		157,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		297,
		288,
		301,
		246,
		246,
		267,
		276,
		297,
		257,
		248,
		275,
		286,
		275,
		270,
		257,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		186,
		174,
		157,
		158,
		154,
		157,
		172,
		175,
		165,
		163,
		157,
		189,
		-1,
		290,
		289,
		278,
		275,
		251,
		242,
		237,
		264,
		-1,
		-1,
		259,
		276,
		270,
		274,
		290,
		315,
		-1,
		246,
		-1,
		-1,
		231,
		-1,
		-1,
		216,
		179,
		168,
		159,
		165,
		162,
		173,
		183,
		171,
		172,
		162,
		172,
		185,
		274,
		271,
		259,
		257,
		280,
		245,
		233,
		-1,
		246,
		244,
		250,
		257,
		274,
		304,
		-1,
		-1,
		262,
		242,
		-1,
		-1,
		214,
		212,
		201,
		-1,
		191,
		164,
		169,
		189,
		191,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		283,
		297,
		286,
		282,
		281,
		289,
		238,
		231,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		-1,
		252,
		248,
		-1,
		-1,
		209,
		202,
		190,
		178,
		168,
		178,
		182,
		186,
		178,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		317,
		-1,
		269,
		245,
		259,
		274,
		282,
		-1,
		-1,
		-1,
		269,
		255,
		248,
		236,
		234,
		-1,
		243,
		227,
		208,
		-1,
		178,
		191,
		222,
		190,
		195,
		190,
		172,
		183,
		172,
		175,
		189,
		184,
		-1,
		-1,
		257,
		260,
		-1,
		-1,
		259,
		261,
		-1,
		260,
		249,
		234,
		226,
		-1,
		-1,
		215,
		211,
		-1,
		-1,
		179,
		204,
		193,
		201,
		196,
		176,
		182,
		185,
		174,
		178,
		190,
		-1,
		-1,
		264,
		265,
		266,
		-1,
		244,
		-1,
		262,
		-1,
		229,
		235,
		223,
		-1,
		-1,
		-1,
		217,
		180,
		201,
		211,
		205,
		203,
		194,
		180,
		187,
		185,
		181,
		192,
		-1,
		-1,
		-1,
		262,
		236,
		269,
		260,
		243,
		223,
		215,
		234,
		-1,
		204,
		-1,
		179,
		181,
		207,
		210,
		216,
		210,
		183,
		198,
		188,
		179,
		188,
		268,
		-1,
		238,
		271,
		235,
		229,
		205,
		209,
		225,
		-1,
		201,
		183,
		-1,
		211,
		201,
		232,
		217,
		198,
		185,
		192,
		192,
		185,
		-1,
		-1,
		-1,
		240,
		239,
		231,
		225,
		225,
		210,
		201,
		-1,
		213,
		195,
		174,
		191,
		191,
		182,
		190,
		222,
		218,
		205,
		205,
		197,
		-1,
		341,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		234,
		229,
		202,
		190,
		196,
		192,
		178,
		184,
		186,
		194,
		192,
		189,
		201,
		197,
		217,
		198,
		233,
		-1,
		336,
		-1,
		270,
		-1,
		-1,
		252,
		232,
		224,
		213,
		202,
		200,
		191,
		182,
		204,
		220,
		204,
		202,
		205,
		206,
		-1,
		325,
		324,
		-1,
		271,
		263,
		249,
		-1,
		242,
		-1,
		248,
		209,
		-1,
		211,
		191,
		-1,
		213,
		209,
		-1,
		-1,
		312,
		287,
		-1,
		-1,
		-1,
		272,
		252,
		243,
		227,
		-1,
		202,
		202,
		-1,
		-1,
		-1,
		297,
		296,
		-1,
		265,
		268,
		-1,
		258,
		249,
		257,
		204,
		208,
		-1,
		-1,
		-1,
		306,
		287,
		281,
		280,
		278,
		273,
		270,
		256,
		240,
		218,
		207,
		228,
		-1,
		-1,
		-1,
		278,
		270,
		263,
		-1,
		-1,
		265,
		248,
		229,
		227,
		-1,
		-1,
		-1,
		300,
		281,
		-1,
		-1,
		255,
		-1,
		-1,
		261,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		317,
		289,
		-1,
		-1,
		-1,
		251,
		247,
		248,
		-1,
		-1,
		-1,
		-1,
		311,
		312,
		335,
		299,
		-1,
		-1,
		-1,
		243,
		237,
		-1,
		-1,
		314,
		312,
		-1,
		-1,
		-1,
		271,
		255,
		-1,
		241,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		276,
		-1,
		276,
		251,
		258,
		-1,
		-1,
		-1,
		-1,
		289,
		281,
		289,
		-1,
		261,
		263,
		-1,
		311,
		-1,
		-1,
		304,
		295,
		-1,
		-1,
		266,
		273,
		295,
		298,
		334,
		-1,
		285
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		175,
		177,
		143,
		137,
		176,
		147,
		153,
		164,
		-1,
		-1,
		-1,
		166,
		165,
		135,
		133,
		142,
		147,
		154,
		-1,
		177,
		-1,
		187,
		166,
		177,
		182,
		128,
		125,
		145,
		164,
		170,
		162,
		202,
		158,
		129,
		123,
		141,
		146,
		164,
		156,
		-1,
		129,
		119,
		141,
		145,
		157,
		140,
		-1,
		-1,
		123,
		124,
		130,
		142,
		147,
		152,
		-1,
		178,
		197,
		-1,
		-1,
		113,
		126,
		122,
		125,
		133,
		149,
		170,
		187,
		192,
		-1,
		-1,
		114,
		118,
		131,
		132,
		130,
		157,
		176,
		187,
		201,
		200,
		-1,
		102,
		120,
		129,
		138,
		144,
		133,
		137,
		155,
		186,
		192,
		195,
		-1,
		94,
		96,
		125,
		131,
		143,
		149,
		136,
		142,
		161,
		174,
		193,
		184,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		91,
		99,
		125,
		124,
		120,
		138,
		160,
		139,
		145,
		149,
		166,
		182,
		183,
		193,
		-1,
		-1,
		142,
		111,
		146,
		103,
		88,
		-1,
		87,
		106,
		112,
		116,
		121,
		129,
		157,
		155,
		-1,
		160,
		159,
		190,
		176,
		187,
		102,
		-1,
		-1,
		100,
		92,
		77,
		80,
		77,
		82,
		112,
		111,
		116,
		118,
		120,
		132,
		147,
		147,
		157,
		154,
		164,
		168,
		183,
		194,
		-1,
		-1,
		268,
		-1,
		-1,
		94,
		82,
		-1,
		65,
		72,
		72,
		89,
		80,
		105,
		120,
		124,
		132,
		135,
		123,
		142,
		139,
		163,
		159,
		151,
		176,
		180,
		186,
		204,
		205,
		-1,
		267,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		58,
		61,
		67,
		91,
		101,
		-1,
		127,
		125,
		149,
		143,
		148,
		144,
		129,
		147,
		145,
		160,
		162,
		158,
		160,
		197,
		188,
		209,
		206,
		237,
		243,
		237,
		246,
		-1,
		0,
		5,
		39,
		46,
		55,
		-1,
		-1,
		95,
		-1,
		109,
		122,
		139,
		129,
		132,
		144,
		152,
		151,
		135,
		153,
		148,
		151,
		170,
		166,
		175,
		185,
		184,
		202,
		215,
		230,
		234,
		240,
		-1,
		103,
		-1,
		45,
		29,
		50,
		61,
		89,
		-1,
		115,
		110,
		130,
		141,
		141,
		-1,
		157,
		154,
		167,
		151,
		136,
		153,
		155,
		159,
		169,
		173,
		188,
		179,
		197,
		204,
		212,
		216,
		236,
		248,
		63,
		53,
		-1,
		55,
		60,
		64,
		76,
		112,
		153,
		137,
		-1,
		152,
		-1,
		159,
		172,
		-1,
		157,
		153,
		142,
		158,
		166,
		173,
		176,
		170,
		167,
		185,
		188,
		205,
		209,
		225,
		-1,
		-1,
		68,
		72,
		104,
		70,
		97,
		121,
		158,
		146,
		155,
		157,
		-1,
		177,
		178,
		175,
		176,
		162,
		155,
		156,
		172,
		178,
		170,
		169,
		172,
		194,
		222,
		200,
		212,
		-1,
		-1,
		-1,
		93,
		-1,
		-1,
		104,
		75,
		99,
		141,
		185,
		178,
		166,
		164,
		164,
		158,
		-1,
		193,
		172,
		169,
		160,
		165,
		178,
		173,
		189,
		173,
		175,
		191,
		203,
		194,
		214,
		-1,
		-1,
		-1,
		134,
		123,
		124,
		78,
		112,
		130,
		197,
		183,
		188,
		163,
		156,
		150,
		187,
		189,
		166,
		174,
		166,
		155,
		169,
		177,
		181,
		175,
		184,
		185,
		209,
		216,
		222,
		-1,
		-1,
		141,
		131,
		115,
		117,
		114,
		103,
		110,
		142,
		188,
		185,
		-1,
		155,
		-1,
		144,
		152,
		151,
		157,
		169,
		155,
		160,
		171,
		183,
		189,
		180,
		195,
		214,
		214,
		206,
		231,
		234,
		-1,
		-1,
		-1,
		134,
		151,
		126,
		103,
		84,
		120,
		-1,
		155,
		156,
		-1,
		149,
		143,
		149,
		148,
		155,
		152,
		152,
		166,
		174,
		170,
		186,
		192,
		181,
		217,
		-1,
		214,
		208,
		229,
		219,
		207,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		91,
		143,
		-1,
		-1,
		140,
		133,
		-1,
		136,
		136,
		143,
		152,
		157,
		162,
		170,
		165,
		178,
		183,
		186,
		194,
		212,
		216,
		220,
		209,
		205,
		202,
		216,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		111,
		-1,
		148,
		140,
		131,
		125,
		131,
		149,
		147,
		167,
		159,
		173,
		173,
		179,
		187,
		172,
		175,
		189,
		189,
		207,
		215,
		207,
		201,
		200,
		212,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		126,
		-1,
		97,
		121,
		137,
		-1,
		165,
		144,
		167,
		145,
		159,
		155,
		193,
		194,
		172,
		177,
		185,
		195,
		197,
		186,
		197,
		189,
		211,
		211,
		195,
		196,
		205,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		100,
		113,
		124,
		-1,
		-1,
		209,
		-1,
		143,
		160,
		169,
		167,
		183,
		174,
		180,
		196,
		199,
		201,
		191,
		180,
		186,
		183,
		205,
		191,
		189,
		208,
		224,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		187,
		177,
		161,
		146,
		179,
		-1,
		191,
		175,
		180,
		-1,
		226,
		-1,
		199,
		201,
		195,
		180,
		177,
		188,
		186,
		197,
		214,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		157,
		-1,
		-1,
		174,
		168,
		168,
		152,
		155,
		207,
		187,
		181,
		180,
		221,
		221,
		207,
		193,
		186,
		183,
		180,
		193,
		213,
		204,
		216,
		-1,
		-1,
		-1,
		158,
		138,
		144,
		102,
		123,
		-1,
		-1,
		236,
		191,
		177,
		-1,
		161,
		224,
		212,
		202,
		192,
		226,
		227,
		212,
		205,
		191,
		193,
		191,
		189,
		194,
		215,
		216,
		229,
		-1,
		-1,
		135,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		183,
		199,
		191,
		162,
		213,
		-1,
		-1,
		204,
		202,
		212,
		208,
		195,
		215,
		218,
		204,
		188,
		203,
		215,
		223,
		228,
		-1,
		138,
		125,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		216,
		182,
		194,
		215,
		240,
		207,
		-1,
		212,
		213,
		199,
		213,
		220,
		206,
		201,
		195,
		198,
		216,
		233,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		173,
		187,
		208,
		214,
		226,
		-1,
		221,
		215,
		201,
		218,
		219,
		216,
		207,
		199,
		204,
		201,
		214,
		228,
		232,
		175,
		-1,
		158,
		-1,
		-1,
		-1,
		191,
		206,
		268,
		245,
		218,
		222,
		215,
		209,
		209,
		225,
		227,
		238,
		206,
		202,
		203,
		207,
		206,
		223,
		233,
		-1,
		-1,
		158,
		175,
		210,
		199,
		203,
		295,
		-1,
		-1,
		231,
		222,
		213,
		216,
		219,
		222,
		212,
		209,
		214,
		219,
		207,
		216,
		234,
		238,
		-1,
		-1,
		-1,
		178,
		-1,
		193,
		-1,
		-1,
		218,
		302,
		249,
		231,
		227,
		225,
		218,
		227,
		222,
		217,
		227,
		236,
		228,
		209,
		220,
		243,
		232,
		270,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		207,
		182,
		197,
		243,
		238,
		239,
		264,
		261,
		-1,
		231,
		256,
		228,
		235,
		227,
		235,
		235,
		232,
		210,
		217,
		233,
		232,
		227,
		262,
		254,
		260,
		-1,
		-1,
		288,
		277,
		266,
		272,
		-1,
		213,
		199,
		229,
		219,
		225,
		-1,
		-1,
		272,
		269,
		253,
		237,
		241,
		234,
		229,
		239,
		219,
		206,
		210,
		214,
		220,
		225,
		230,
		236,
		251,
		266,
		-1,
		183,
		264,
		257,
		240,
		248,
		279,
		-1,
		216,
		225,
		206,
		211,
		219,
		-1,
		-1,
		245,
		241,
		246,
		244,
		241,
		249,
		244,
		235,
		220,
		226,
		213,
		212,
		230,
		234,
		243,
		250,
		240,
		253,
		257,
		-1,
		197,
		240,
		234,
		237,
		261,
		275,
		-1,
		229,
		-1,
		-1,
		214,
		232,
		240,
		236,
		240,
		293,
		258,
		253,
		243,
		241,
		232,
		223,
		230,
		221,
		221,
		224,
		239,
		244,
		236,
		250,
		250,
		251,
		-1,
		232,
		220,
		228,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		230,
		-1,
		266,
		-1,
		259,
		263,
		266,
		269,
		257,
		244,
		236,
		228,
		244,
		219,
		229,
		225,
		226,
		235,
		246,
		258,
		257,
		258,
		306,
		261,
		228,
		219,
		266,
		281,
		285,
		-1,
		242,
		281,
		268,
		-1,
		239,
		-1,
		-1,
		-1,
		273,
		279,
		271,
		277,
		256,
		256,
		230,
		234,
		224,
		231,
		241,
		243,
		235,
		239,
		252,
		263,
		266,
		302,
		300,
		305,
		250,
		233,
		251,
		260,
		281,
		257,
		248,
		275,
		275,
		264,
		259,
		246,
		-1,
		-1,
		296,
		289,
		-1,
		-1,
		263,
		251,
		234,
		235,
		231,
		234,
		249,
		252,
		242,
		240,
		234,
		266,
		-1,
		302,
		301,
		290,
		287,
		263,
		254,
		241,
		252,
		-1,
		-1,
		260,
		276,
		289,
		293,
		306,
		331,
		-1,
		249,
		-1,
		-1,
		308,
		-1,
		-1,
		293,
		256,
		245,
		236,
		242,
		239,
		250,
		260,
		248,
		249,
		239,
		249,
		262,
		286,
		283,
		271,
		269,
		292,
		249,
		245,
		-1,
		275,
		263,
		269,
		276,
		293,
		320,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		291,
		289,
		278,
		-1,
		268,
		241,
		246,
		266,
		268,
		257,
		251,
		245,
		252,
		251,
		259,
		267,
		295,
		309,
		298,
		294,
		293,
		301,
		250,
		267,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		-1,
		300,
		275,
		-1,
		-1,
		286,
		279,
		267,
		255,
		245,
		255,
		259,
		263,
		255,
		248,
		243,
		254,
		246,
		250,
		267,
		-1,
		329,
		-1,
		281,
		274,
		289,
		304,
		312,
		-1,
		-1,
		-1,
		317,
		303,
		296,
		284,
		282,
		-1,
		320,
		304,
		285,
		-1,
		255,
		268,
		299,
		267,
		272,
		267,
		249,
		260,
		249,
		252,
		266,
		261,
		-1,
		-1,
		287,
		290,
		-1,
		-1,
		312,
		331,
		-1,
		308,
		297,
		282,
		274,
		-1,
		-1,
		292,
		288,
		-1,
		-1,
		256,
		281,
		270,
		278,
		273,
		253,
		259,
		262,
		251,
		255,
		267,
		-1,
		-1,
		294,
		295,
		300,
		-1,
		321,
		-1,
		332,
		-1,
		277,
		293,
		295,
		-1,
		-1,
		-1,
		294,
		257,
		278,
		288,
		282,
		280,
		271,
		257,
		264,
		262,
		258,
		269,
		-1,
		-1,
		-1,
		339,
		313,
		339,
		330,
		313,
		293,
		285,
		310,
		-1,
		281,
		-1,
		256,
		258,
		284,
		287,
		293,
		287,
		260,
		275,
		265,
		256,
		265,
		345,
		-1,
		315,
		348,
		312,
		299,
		282,
		286,
		302,
		-1,
		278,
		260,
		-1,
		288,
		278,
		309,
		294,
		275,
		262,
		269,
		269,
		262,
		-1,
		-1,
		-1,
		317,
		316,
		308,
		302,
		302,
		287,
		278,
		-1,
		290,
		272,
		251,
		268,
		268,
		259,
		267,
		299,
		295,
		282,
		282,
		274,
		-1,
		401,
		-1,
		-1,
		340,
		-1,
		-1,
		-1,
		311,
		306,
		279,
		267,
		273,
		269,
		255,
		261,
		263,
		271,
		269,
		266,
		278,
		274,
		294,
		275,
		310,
		-1,
		408,
		-1,
		347,
		-1,
		-1,
		329,
		309,
		301,
		290,
		279,
		277,
		268,
		259,
		281,
		297,
		281,
		279,
		282,
		283,
		-1,
		402,
		401,
		-1,
		348,
		340,
		326,
		-1,
		319,
		-1,
		325,
		286,
		-1,
		288,
		268,
		-1,
		290,
		286,
		-1,
		-1,
		389,
		364,
		-1,
		-1,
		-1,
		349,
		329,
		320,
		304,
		-1,
		279,
		279,
		-1,
		-1,
		-1,
		374,
		373,
		-1,
		342,
		345,
		-1,
		335,
		326,
		334,
		281,
		285,
		-1,
		-1,
		-1,
		383,
		364,
		358,
		357,
		355,
		350,
		347,
		333,
		317,
		295,
		284,
		305,
		-1,
		-1,
		-1,
		355,
		347,
		340,
		-1,
		-1,
		342,
		325,
		306,
		304,
		-1,
		-1,
		-1,
		377,
		358,
		-1,
		-1,
		332,
		-1,
		-1,
		338,
		303,
		-1,
		-1,
		-1,
		-1,
		-1,
		394,
		366,
		-1,
		-1,
		-1,
		328,
		324,
		325,
		-1,
		-1,
		-1,
		-1,
		388,
		389,
		412,
		376,
		-1,
		-1,
		-1,
		320,
		314,
		-1,
		-1,
		391,
		389,
		-1,
		-1,
		-1,
		348,
		332,
		-1,
		318,
		-1,
		-1,
		-1,
		339,
		-1,
		-1,
		351,
		-1,
		-1,
		-1,
		353,
		-1,
		353,
		328,
		335,
		-1,
		-1,
		-1,
		-1,
		366,
		358,
		366,
		-1,
		338,
		340,
		-1,
		388,
		-1,
		-1,
		381,
		372,
		-1,
		-1,
		343,
		350,
		372,
		375,
		411,
		-1,
		362
	],
	[
		-1,
		161,
		150,
		161,
		169,
		142,
		149,
		-1,
		170,
		172,
		138,
		132,
		171,
		142,
		148,
		159,
		-1,
		-1,
		-1,
		161,
		160,
		130,
		128,
		137,
		142,
		149,
		-1,
		172,
		-1,
		182,
		161,
		172,
		177,
		123,
		120,
		140,
		159,
		165,
		157,
		197,
		153,
		124,
		118,
		136,
		141,
		159,
		151,
		-1,
		124,
		114,
		136,
		140,
		152,
		135,
		-1,
		-1,
		118,
		119,
		125,
		137,
		142,
		147,
		-1,
		173,
		192,
		-1,
		-1,
		108,
		121,
		117,
		120,
		128,
		144,
		165,
		182,
		187,
		-1,
		-1,
		109,
		113,
		126,
		127,
		125,
		152,
		171,
		182,
		196,
		195,
		-1,
		97,
		115,
		124,
		133,
		139,
		128,
		132,
		150,
		181,
		187,
		190,
		-1,
		89,
		91,
		120,
		126,
		138,
		144,
		131,
		137,
		156,
		169,
		188,
		179,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		86,
		94,
		120,
		119,
		115,
		133,
		155,
		134,
		140,
		144,
		161,
		177,
		178,
		188,
		-1,
		-1,
		137,
		106,
		141,
		98,
		83,
		-1,
		82,
		101,
		107,
		111,
		116,
		124,
		152,
		150,
		-1,
		155,
		154,
		185,
		171,
		182,
		97,
		-1,
		-1,
		95,
		87,
		72,
		75,
		72,
		77,
		107,
		106,
		111,
		113,
		115,
		127,
		142,
		142,
		152,
		149,
		159,
		163,
		178,
		189,
		-1,
		-1,
		263,
		-1,
		-1,
		89,
		77,
		-1,
		60,
		67,
		67,
		84,
		75,
		100,
		115,
		119,
		127,
		130,
		118,
		137,
		134,
		158,
		154,
		146,
		171,
		175,
		181,
		199,
		200,
		-1,
		262,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		53,
		56,
		62,
		86,
		96,
		-1,
		122,
		120,
		144,
		138,
		143,
		139,
		124,
		142,
		140,
		155,
		157,
		153,
		155,
		192,
		183,
		204,
		201,
		232,
		238,
		232,
		241,
		-1,
		4,
		0,
		34,
		41,
		50,
		-1,
		-1,
		90,
		-1,
		104,
		117,
		134,
		124,
		127,
		139,
		147,
		146,
		130,
		148,
		143,
		146,
		165,
		161,
		170,
		180,
		179,
		197,
		210,
		225,
		229,
		235,
		-1,
		98,
		-1,
		40,
		24,
		45,
		56,
		84,
		-1,
		110,
		105,
		125,
		136,
		136,
		-1,
		152,
		149,
		162,
		146,
		131,
		148,
		150,
		154,
		164,
		168,
		183,
		174,
		192,
		199,
		207,
		211,
		231,
		243,
		58,
		48,
		-1,
		50,
		55,
		59,
		71,
		107,
		148,
		132,
		-1,
		147,
		-1,
		154,
		167,
		-1,
		152,
		148,
		137,
		153,
		161,
		168,
		171,
		165,
		162,
		180,
		183,
		200,
		204,
		220,
		-1,
		-1,
		63,
		67,
		99,
		65,
		92,
		116,
		153,
		141,
		150,
		152,
		-1,
		172,
		173,
		170,
		171,
		157,
		150,
		151,
		167,
		173,
		165,
		164,
		167,
		189,
		217,
		195,
		207,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		99,
		70,
		94,
		136,
		180,
		173,
		161,
		159,
		159,
		153,
		-1,
		188,
		167,
		164,
		155,
		160,
		173,
		168,
		184,
		168,
		170,
		186,
		198,
		189,
		209,
		-1,
		-1,
		-1,
		129,
		118,
		119,
		73,
		107,
		125,
		192,
		178,
		183,
		158,
		151,
		145,
		182,
		184,
		161,
		169,
		161,
		150,
		164,
		172,
		176,
		170,
		179,
		180,
		204,
		211,
		217,
		-1,
		-1,
		136,
		126,
		110,
		112,
		109,
		98,
		105,
		137,
		183,
		180,
		-1,
		150,
		-1,
		139,
		147,
		146,
		152,
		164,
		150,
		155,
		166,
		178,
		184,
		175,
		190,
		209,
		209,
		201,
		226,
		229,
		-1,
		-1,
		-1,
		129,
		146,
		121,
		98,
		79,
		115,
		-1,
		150,
		151,
		-1,
		144,
		138,
		144,
		143,
		150,
		147,
		147,
		161,
		169,
		165,
		181,
		187,
		176,
		212,
		-1,
		209,
		203,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		144,
		123,
		116,
		136,
		86,
		138,
		-1,
		-1,
		135,
		128,
		-1,
		131,
		131,
		138,
		147,
		152,
		157,
		165,
		160,
		173,
		178,
		181,
		189,
		207,
		211,
		215,
		204,
		200,
		197,
		211,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		106,
		-1,
		143,
		135,
		126,
		120,
		126,
		144,
		142,
		162,
		154,
		168,
		168,
		174,
		182,
		167,
		170,
		184,
		184,
		202,
		210,
		202,
		196,
		195,
		207,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		121,
		-1,
		92,
		116,
		132,
		-1,
		160,
		139,
		162,
		140,
		154,
		150,
		188,
		189,
		167,
		172,
		180,
		190,
		192,
		181,
		192,
		184,
		206,
		206,
		190,
		191,
		200,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		95,
		108,
		119,
		-1,
		-1,
		204,
		-1,
		138,
		155,
		164,
		162,
		178,
		169,
		175,
		191,
		194,
		196,
		186,
		175,
		181,
		178,
		200,
		186,
		184,
		203,
		219,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		136,
		-1,
		182,
		172,
		156,
		141,
		174,
		-1,
		186,
		170,
		175,
		-1,
		221,
		-1,
		194,
		196,
		190,
		175,
		172,
		183,
		181,
		192,
		209,
		-1,
		148,
		133,
		126,
		116,
		130,
		101,
		-1,
		152,
		-1,
		-1,
		169,
		163,
		163,
		147,
		150,
		202,
		182,
		176,
		175,
		216,
		216,
		202,
		188,
		181,
		178,
		175,
		188,
		208,
		199,
		211,
		-1,
		-1,
		-1,
		153,
		133,
		139,
		97,
		118,
		-1,
		-1,
		231,
		186,
		172,
		-1,
		156,
		219,
		207,
		197,
		187,
		221,
		222,
		207,
		200,
		186,
		188,
		186,
		184,
		189,
		210,
		211,
		224,
		-1,
		-1,
		130,
		137,
		125,
		111,
		130,
		-1,
		-1,
		-1,
		178,
		194,
		186,
		157,
		208,
		-1,
		-1,
		199,
		197,
		207,
		203,
		190,
		210,
		213,
		199,
		183,
		198,
		210,
		218,
		223,
		-1,
		133,
		120,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		189,
		210,
		235,
		202,
		-1,
		207,
		208,
		194,
		208,
		215,
		201,
		196,
		190,
		193,
		211,
		228,
		-1,
		-1,
		147,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		168,
		182,
		203,
		209,
		221,
		-1,
		216,
		210,
		196,
		213,
		214,
		211,
		202,
		194,
		199,
		196,
		209,
		223,
		227,
		170,
		-1,
		153,
		-1,
		-1,
		-1,
		186,
		201,
		263,
		240,
		213,
		217,
		210,
		204,
		204,
		220,
		222,
		233,
		201,
		197,
		198,
		202,
		201,
		218,
		228,
		-1,
		-1,
		153,
		170,
		205,
		194,
		198,
		290,
		-1,
		-1,
		226,
		217,
		208,
		211,
		214,
		217,
		207,
		204,
		209,
		214,
		202,
		211,
		229,
		233,
		-1,
		-1,
		-1,
		173,
		-1,
		188,
		-1,
		-1,
		213,
		297,
		244,
		226,
		222,
		220,
		213,
		222,
		217,
		212,
		222,
		231,
		223,
		204,
		215,
		238,
		227,
		265,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		202,
		177,
		192,
		238,
		233,
		234,
		259,
		256,
		-1,
		226,
		251,
		223,
		230,
		222,
		230,
		230,
		227,
		205,
		212,
		228,
		227,
		222,
		257,
		249,
		255,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		208,
		194,
		224,
		214,
		220,
		-1,
		-1,
		267,
		264,
		248,
		232,
		236,
		229,
		224,
		234,
		214,
		201,
		205,
		209,
		215,
		220,
		225,
		231,
		246,
		261,
		-1,
		178,
		259,
		252,
		235,
		243,
		274,
		-1,
		211,
		220,
		201,
		206,
		214,
		-1,
		-1,
		240,
		236,
		241,
		239,
		236,
		244,
		239,
		230,
		215,
		221,
		208,
		207,
		225,
		229,
		238,
		245,
		235,
		248,
		252,
		-1,
		192,
		235,
		229,
		232,
		256,
		270,
		-1,
		224,
		-1,
		-1,
		209,
		227,
		235,
		231,
		235,
		288,
		253,
		248,
		238,
		236,
		227,
		218,
		225,
		216,
		216,
		219,
		234,
		239,
		231,
		245,
		245,
		246,
		-1,
		227,
		215,
		223,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		225,
		-1,
		261,
		-1,
		254,
		258,
		261,
		264,
		252,
		239,
		231,
		223,
		239,
		214,
		224,
		220,
		221,
		230,
		241,
		253,
		252,
		253,
		301,
		256,
		223,
		214,
		261,
		276,
		280,
		-1,
		237,
		276,
		263,
		-1,
		234,
		-1,
		-1,
		-1,
		268,
		274,
		266,
		272,
		251,
		251,
		225,
		229,
		219,
		226,
		236,
		238,
		230,
		234,
		247,
		258,
		261,
		297,
		295,
		300,
		245,
		228,
		246,
		255,
		276,
		252,
		243,
		270,
		270,
		259,
		254,
		241,
		-1,
		-1,
		291,
		284,
		-1,
		-1,
		258,
		246,
		229,
		230,
		226,
		229,
		244,
		247,
		237,
		235,
		229,
		261,
		-1,
		297,
		296,
		285,
		282,
		258,
		249,
		236,
		247,
		-1,
		-1,
		255,
		271,
		284,
		288,
		301,
		326,
		-1,
		244,
		-1,
		-1,
		303,
		-1,
		-1,
		288,
		251,
		240,
		231,
		237,
		234,
		245,
		255,
		243,
		244,
		234,
		244,
		257,
		281,
		278,
		266,
		264,
		287,
		244,
		240,
		-1,
		270,
		258,
		264,
		271,
		288,
		315,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		286,
		284,
		273,
		-1,
		263,
		236,
		241,
		261,
		263,
		252,
		246,
		240,
		247,
		246,
		254,
		262,
		290,
		304,
		293,
		289,
		288,
		296,
		245,
		262,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		-1,
		295,
		270,
		-1,
		-1,
		281,
		274,
		262,
		250,
		240,
		250,
		254,
		258,
		250,
		243,
		238,
		249,
		241,
		245,
		262,
		-1,
		324,
		-1,
		276,
		269,
		284,
		299,
		307,
		-1,
		-1,
		-1,
		312,
		298,
		291,
		279,
		277,
		-1,
		315,
		299,
		280,
		-1,
		250,
		263,
		294,
		262,
		267,
		262,
		244,
		255,
		244,
		247,
		261,
		256,
		-1,
		-1,
		282,
		285,
		-1,
		-1,
		307,
		326,
		-1,
		303,
		292,
		277,
		269,
		-1,
		-1,
		287,
		283,
		-1,
		-1,
		251,
		276,
		265,
		273,
		268,
		248,
		254,
		257,
		246,
		250,
		262,
		-1,
		-1,
		289,
		290,
		295,
		-1,
		316,
		-1,
		327,
		-1,
		272,
		288,
		290,
		-1,
		-1,
		-1,
		289,
		252,
		273,
		283,
		277,
		275,
		266,
		252,
		259,
		257,
		253,
		264,
		-1,
		-1,
		-1,
		334,
		308,
		334,
		325,
		308,
		288,
		280,
		305,
		-1,
		276,
		-1,
		251,
		253,
		279,
		282,
		288,
		282,
		255,
		270,
		260,
		251,
		260,
		340,
		-1,
		310,
		343,
		307,
		294,
		277,
		281,
		297,
		-1,
		273,
		255,
		-1,
		283,
		273,
		304,
		289,
		270,
		257,
		264,
		264,
		257,
		-1,
		-1,
		-1,
		312,
		311,
		303,
		297,
		297,
		282,
		273,
		-1,
		285,
		267,
		246,
		263,
		263,
		254,
		262,
		294,
		290,
		277,
		277,
		269,
		-1,
		396,
		-1,
		-1,
		335,
		-1,
		-1,
		-1,
		306,
		301,
		274,
		262,
		268,
		264,
		250,
		256,
		258,
		266,
		264,
		261,
		273,
		269,
		289,
		270,
		305,
		-1,
		403,
		-1,
		342,
		-1,
		-1,
		324,
		304,
		296,
		285,
		274,
		272,
		263,
		254,
		276,
		292,
		276,
		274,
		277,
		278,
		-1,
		397,
		396,
		-1,
		343,
		335,
		321,
		-1,
		314,
		-1,
		320,
		281,
		-1,
		283,
		263,
		-1,
		285,
		281,
		-1,
		-1,
		384,
		359,
		-1,
		-1,
		-1,
		344,
		324,
		315,
		299,
		-1,
		274,
		274,
		-1,
		-1,
		-1,
		369,
		368,
		-1,
		337,
		340,
		-1,
		330,
		321,
		329,
		276,
		280,
		-1,
		-1,
		-1,
		378,
		359,
		353,
		352,
		350,
		345,
		342,
		328,
		312,
		290,
		279,
		300,
		-1,
		-1,
		-1,
		350,
		342,
		335,
		-1,
		-1,
		337,
		320,
		301,
		299,
		-1,
		-1,
		-1,
		372,
		353,
		-1,
		-1,
		327,
		-1,
		-1,
		333,
		298,
		-1,
		-1,
		-1,
		-1,
		-1,
		389,
		361,
		-1,
		-1,
		-1,
		323,
		319,
		320,
		-1,
		-1,
		-1,
		-1,
		383,
		384,
		407,
		371,
		-1,
		-1,
		-1,
		315,
		309,
		-1,
		-1,
		386,
		384,
		-1,
		-1,
		-1,
		343,
		327,
		-1,
		313,
		-1,
		-1,
		-1,
		334,
		-1,
		-1,
		346,
		-1,
		-1,
		-1,
		348,
		-1,
		348,
		323,
		330,
		-1,
		-1,
		-1,
		-1,
		361,
		353,
		361,
		-1,
		333,
		335,
		-1,
		383,
		-1,
		-1,
		376,
		367,
		-1,
		-1,
		338,
		345,
		367,
		370,
		406,
		-1,
		357
	],
	[
		-1,
		153,
		142,
		153,
		161,
		134,
		141,
		-1,
		162,
		164,
		130,
		124,
		163,
		134,
		140,
		151,
		-1,
		-1,
		-1,
		153,
		152,
		122,
		120,
		129,
		134,
		141,
		-1,
		164,
		-1,
		174,
		153,
		164,
		169,
		115,
		112,
		132,
		151,
		157,
		149,
		189,
		145,
		116,
		110,
		128,
		133,
		151,
		143,
		-1,
		116,
		106,
		128,
		132,
		144,
		127,
		-1,
		-1,
		110,
		111,
		117,
		129,
		134,
		139,
		-1,
		165,
		184,
		-1,
		-1,
		100,
		113,
		109,
		112,
		120,
		136,
		157,
		174,
		179,
		-1,
		-1,
		101,
		105,
		118,
		119,
		117,
		144,
		163,
		174,
		188,
		187,
		-1,
		89,
		107,
		116,
		125,
		131,
		120,
		124,
		142,
		173,
		179,
		182,
		-1,
		81,
		83,
		112,
		118,
		130,
		136,
		123,
		129,
		148,
		161,
		180,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		79,
		78,
		86,
		112,
		111,
		107,
		125,
		147,
		126,
		132,
		136,
		153,
		169,
		170,
		180,
		-1,
		-1,
		129,
		98,
		133,
		90,
		75,
		-1,
		74,
		93,
		99,
		103,
		108,
		116,
		144,
		142,
		-1,
		147,
		146,
		177,
		163,
		174,
		89,
		-1,
		-1,
		87,
		79,
		64,
		67,
		64,
		69,
		99,
		98,
		103,
		105,
		107,
		119,
		134,
		134,
		144,
		141,
		151,
		155,
		170,
		181,
		-1,
		-1,
		255,
		-1,
		-1,
		81,
		69,
		-1,
		52,
		59,
		59,
		76,
		67,
		92,
		107,
		111,
		119,
		122,
		110,
		129,
		126,
		150,
		146,
		138,
		163,
		167,
		173,
		191,
		192,
		-1,
		254,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		45,
		48,
		54,
		78,
		88,
		-1,
		114,
		112,
		136,
		130,
		135,
		131,
		116,
		134,
		132,
		147,
		149,
		145,
		147,
		184,
		175,
		196,
		193,
		224,
		230,
		224,
		233,
		-1,
		34,
		30,
		0,
		7,
		42,
		-1,
		-1,
		82,
		-1,
		96,
		109,
		126,
		116,
		119,
		131,
		139,
		138,
		122,
		140,
		135,
		138,
		157,
		153,
		162,
		172,
		171,
		189,
		202,
		217,
		221,
		227,
		-1,
		90,
		-1,
		32,
		16,
		37,
		48,
		76,
		-1,
		102,
		97,
		117,
		128,
		128,
		-1,
		144,
		141,
		154,
		138,
		123,
		140,
		142,
		146,
		156,
		160,
		175,
		166,
		184,
		191,
		199,
		203,
		223,
		235,
		50,
		40,
		-1,
		42,
		47,
		51,
		63,
		99,
		140,
		124,
		-1,
		139,
		-1,
		146,
		159,
		-1,
		144,
		140,
		129,
		145,
		153,
		160,
		163,
		157,
		154,
		172,
		175,
		192,
		196,
		212,
		-1,
		-1,
		55,
		59,
		91,
		57,
		84,
		108,
		145,
		133,
		142,
		144,
		-1,
		164,
		165,
		162,
		163,
		149,
		142,
		143,
		159,
		165,
		157,
		156,
		159,
		181,
		209,
		187,
		199,
		-1,
		-1,
		-1,
		80,
		-1,
		-1,
		91,
		62,
		86,
		128,
		172,
		165,
		153,
		151,
		151,
		145,
		-1,
		180,
		159,
		156,
		147,
		152,
		165,
		160,
		176,
		160,
		162,
		178,
		190,
		181,
		201,
		-1,
		-1,
		-1,
		121,
		110,
		111,
		65,
		99,
		117,
		184,
		170,
		175,
		150,
		143,
		137,
		174,
		176,
		153,
		161,
		153,
		142,
		156,
		164,
		168,
		162,
		171,
		172,
		196,
		203,
		209,
		-1,
		-1,
		128,
		118,
		102,
		104,
		101,
		90,
		97,
		129,
		175,
		172,
		-1,
		142,
		-1,
		131,
		139,
		138,
		144,
		156,
		142,
		147,
		158,
		170,
		176,
		167,
		182,
		201,
		201,
		193,
		218,
		221,
		-1,
		-1,
		-1,
		121,
		138,
		113,
		90,
		71,
		107,
		-1,
		142,
		143,
		-1,
		136,
		130,
		136,
		135,
		142,
		139,
		139,
		153,
		161,
		157,
		173,
		179,
		168,
		204,
		-1,
		201,
		195,
		216,
		206,
		194,
		-1,
		-1,
		-1,
		136,
		115,
		108,
		128,
		78,
		130,
		-1,
		-1,
		127,
		120,
		-1,
		123,
		123,
		130,
		139,
		144,
		149,
		157,
		152,
		165,
		170,
		173,
		181,
		199,
		203,
		207,
		196,
		192,
		189,
		203,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		98,
		-1,
		135,
		127,
		118,
		112,
		118,
		136,
		134,
		154,
		146,
		160,
		160,
		166,
		174,
		159,
		162,
		176,
		176,
		194,
		202,
		194,
		188,
		187,
		199,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		113,
		-1,
		84,
		108,
		124,
		-1,
		152,
		131,
		154,
		132,
		146,
		142,
		180,
		181,
		159,
		164,
		172,
		182,
		184,
		173,
		184,
		176,
		198,
		198,
		182,
		183,
		192,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		87,
		100,
		111,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		156,
		154,
		170,
		161,
		167,
		183,
		186,
		188,
		178,
		167,
		173,
		170,
		192,
		178,
		176,
		195,
		211,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		178,
		162,
		167,
		-1,
		213,
		-1,
		186,
		188,
		182,
		167,
		164,
		175,
		173,
		184,
		201,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		144,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		194,
		174,
		168,
		167,
		208,
		208,
		194,
		180,
		173,
		170,
		167,
		180,
		200,
		191,
		203,
		-1,
		-1,
		-1,
		145,
		125,
		131,
		89,
		110,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		148,
		211,
		199,
		189,
		179,
		213,
		214,
		199,
		192,
		178,
		180,
		178,
		176,
		181,
		202,
		203,
		216,
		-1,
		-1,
		122,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		170,
		186,
		178,
		149,
		200,
		-1,
		-1,
		191,
		189,
		199,
		195,
		182,
		202,
		205,
		191,
		175,
		190,
		202,
		210,
		215,
		-1,
		125,
		112,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		181,
		202,
		227,
		194,
		-1,
		199,
		200,
		186,
		200,
		207,
		193,
		188,
		182,
		185,
		203,
		220,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		160,
		174,
		195,
		201,
		213,
		-1,
		208,
		202,
		188,
		205,
		206,
		203,
		194,
		186,
		191,
		188,
		201,
		215,
		219,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		178,
		193,
		255,
		232,
		205,
		209,
		202,
		196,
		196,
		212,
		214,
		225,
		193,
		189,
		190,
		194,
		193,
		210,
		220,
		-1,
		-1,
		145,
		162,
		197,
		186,
		190,
		282,
		-1,
		-1,
		218,
		209,
		200,
		203,
		206,
		209,
		199,
		196,
		201,
		206,
		194,
		203,
		221,
		225,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		205,
		289,
		236,
		218,
		214,
		212,
		205,
		214,
		209,
		204,
		214,
		223,
		215,
		196,
		207,
		230,
		219,
		257,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		194,
		169,
		184,
		230,
		225,
		226,
		251,
		248,
		-1,
		218,
		243,
		215,
		222,
		214,
		222,
		222,
		219,
		197,
		204,
		220,
		219,
		214,
		249,
		241,
		247,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		200,
		186,
		216,
		206,
		212,
		-1,
		-1,
		259,
		256,
		240,
		224,
		228,
		221,
		216,
		226,
		206,
		193,
		197,
		201,
		207,
		212,
		217,
		223,
		238,
		253,
		-1,
		170,
		251,
		244,
		227,
		235,
		266,
		-1,
		203,
		212,
		193,
		198,
		206,
		-1,
		-1,
		232,
		228,
		233,
		231,
		228,
		236,
		231,
		222,
		207,
		213,
		200,
		199,
		217,
		221,
		230,
		237,
		227,
		240,
		244,
		-1,
		184,
		227,
		221,
		224,
		248,
		262,
		-1,
		216,
		-1,
		-1,
		201,
		219,
		227,
		223,
		227,
		280,
		245,
		240,
		230,
		228,
		219,
		210,
		217,
		208,
		208,
		211,
		226,
		231,
		223,
		237,
		237,
		238,
		-1,
		219,
		207,
		215,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		217,
		-1,
		253,
		-1,
		246,
		250,
		253,
		256,
		244,
		231,
		223,
		215,
		231,
		206,
		216,
		212,
		213,
		222,
		233,
		245,
		244,
		245,
		293,
		248,
		215,
		206,
		253,
		268,
		272,
		-1,
		229,
		268,
		255,
		-1,
		226,
		-1,
		-1,
		-1,
		260,
		266,
		258,
		264,
		243,
		243,
		217,
		221,
		211,
		218,
		228,
		230,
		222,
		226,
		239,
		250,
		253,
		289,
		287,
		292,
		237,
		220,
		238,
		247,
		268,
		244,
		235,
		262,
		262,
		251,
		246,
		233,
		-1,
		-1,
		283,
		276,
		-1,
		-1,
		250,
		238,
		221,
		222,
		218,
		221,
		236,
		239,
		229,
		227,
		221,
		253,
		-1,
		289,
		288,
		277,
		274,
		250,
		241,
		228,
		239,
		-1,
		-1,
		247,
		263,
		276,
		280,
		293,
		318,
		-1,
		236,
		-1,
		-1,
		295,
		-1,
		-1,
		280,
		243,
		232,
		223,
		229,
		226,
		237,
		247,
		235,
		236,
		226,
		236,
		249,
		273,
		270,
		258,
		256,
		279,
		236,
		232,
		-1,
		262,
		250,
		256,
		263,
		280,
		307,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		278,
		276,
		265,
		-1,
		255,
		228,
		233,
		253,
		255,
		244,
		238,
		232,
		239,
		238,
		246,
		254,
		282,
		296,
		285,
		281,
		280,
		288,
		237,
		254,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		-1,
		287,
		262,
		-1,
		-1,
		273,
		266,
		254,
		242,
		232,
		242,
		246,
		250,
		242,
		235,
		230,
		241,
		233,
		237,
		254,
		-1,
		316,
		-1,
		268,
		261,
		276,
		291,
		299,
		-1,
		-1,
		-1,
		304,
		290,
		283,
		271,
		269,
		-1,
		307,
		291,
		272,
		-1,
		242,
		255,
		286,
		254,
		259,
		254,
		236,
		247,
		236,
		239,
		253,
		248,
		-1,
		-1,
		274,
		277,
		-1,
		-1,
		299,
		318,
		-1,
		295,
		284,
		269,
		261,
		-1,
		-1,
		279,
		275,
		-1,
		-1,
		243,
		268,
		257,
		265,
		260,
		240,
		246,
		249,
		238,
		242,
		254,
		-1,
		-1,
		281,
		282,
		287,
		-1,
		308,
		-1,
		319,
		-1,
		264,
		280,
		282,
		-1,
		-1,
		-1,
		281,
		244,
		265,
		275,
		269,
		267,
		258,
		244,
		251,
		249,
		245,
		256,
		-1,
		-1,
		-1,
		326,
		300,
		326,
		317,
		300,
		280,
		272,
		297,
		-1,
		268,
		-1,
		243,
		245,
		271,
		274,
		280,
		274,
		247,
		262,
		252,
		243,
		252,
		332,
		-1,
		302,
		335,
		299,
		286,
		269,
		273,
		289,
		-1,
		265,
		247,
		-1,
		275,
		265,
		296,
		281,
		262,
		249,
		256,
		256,
		249,
		-1,
		-1,
		-1,
		304,
		303,
		295,
		289,
		289,
		274,
		265,
		-1,
		277,
		259,
		238,
		255,
		255,
		246,
		254,
		286,
		282,
		269,
		269,
		261,
		-1,
		388,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		298,
		293,
		266,
		254,
		260,
		256,
		242,
		248,
		250,
		258,
		256,
		253,
		265,
		261,
		281,
		262,
		297,
		-1,
		395,
		-1,
		334,
		-1,
		-1,
		316,
		296,
		288,
		277,
		266,
		264,
		255,
		246,
		268,
		284,
		268,
		266,
		269,
		270,
		-1,
		389,
		388,
		-1,
		335,
		327,
		313,
		-1,
		306,
		-1,
		312,
		273,
		-1,
		275,
		255,
		-1,
		277,
		273,
		-1,
		-1,
		376,
		351,
		-1,
		-1,
		-1,
		336,
		316,
		307,
		291,
		-1,
		266,
		266,
		-1,
		-1,
		-1,
		361,
		360,
		-1,
		329,
		332,
		-1,
		322,
		313,
		321,
		268,
		272,
		-1,
		-1,
		-1,
		370,
		351,
		345,
		344,
		342,
		337,
		334,
		320,
		304,
		282,
		271,
		292,
		-1,
		-1,
		-1,
		342,
		334,
		327,
		-1,
		-1,
		329,
		312,
		293,
		291,
		-1,
		-1,
		-1,
		364,
		345,
		-1,
		-1,
		319,
		-1,
		-1,
		325,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		381,
		353,
		-1,
		-1,
		-1,
		315,
		311,
		312,
		-1,
		-1,
		-1,
		-1,
		375,
		376,
		399,
		363,
		-1,
		-1,
		-1,
		307,
		301,
		-1,
		-1,
		378,
		376,
		-1,
		-1,
		-1,
		335,
		319,
		-1,
		305,
		-1,
		-1,
		-1,
		326,
		-1,
		-1,
		338,
		-1,
		-1,
		-1,
		340,
		-1,
		340,
		315,
		322,
		-1,
		-1,
		-1,
		-1,
		353,
		345,
		353,
		-1,
		325,
		327,
		-1,
		375,
		-1,
		-1,
		368,
		359,
		-1,
		-1,
		330,
		337,
		359,
		362,
		398,
		-1,
		349
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		173,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		166,
		158,
		198,
		154,
		125,
		119,
		137,
		142,
		160,
		152,
		-1,
		125,
		115,
		137,
		141,
		153,
		136,
		-1,
		-1,
		119,
		120,
		126,
		138,
		143,
		148,
		-1,
		174,
		193,
		-1,
		-1,
		109,
		122,
		118,
		121,
		129,
		145,
		166,
		183,
		188,
		-1,
		-1,
		110,
		114,
		127,
		128,
		126,
		153,
		172,
		183,
		197,
		196,
		-1,
		98,
		116,
		125,
		134,
		140,
		129,
		133,
		151,
		182,
		188,
		191,
		-1,
		90,
		92,
		121,
		127,
		139,
		145,
		132,
		138,
		157,
		170,
		189,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		87,
		95,
		121,
		120,
		116,
		134,
		156,
		135,
		141,
		145,
		162,
		178,
		179,
		189,
		-1,
		-1,
		138,
		107,
		142,
		99,
		84,
		-1,
		83,
		102,
		108,
		112,
		117,
		125,
		153,
		151,
		-1,
		156,
		155,
		186,
		172,
		183,
		98,
		-1,
		-1,
		96,
		88,
		73,
		76,
		73,
		78,
		108,
		107,
		112,
		114,
		116,
		128,
		143,
		143,
		153,
		150,
		160,
		164,
		179,
		190,
		-1,
		-1,
		264,
		-1,
		-1,
		90,
		78,
		-1,
		61,
		68,
		68,
		85,
		76,
		101,
		116,
		120,
		128,
		131,
		119,
		138,
		135,
		159,
		155,
		147,
		172,
		176,
		182,
		200,
		201,
		-1,
		263,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		54,
		57,
		63,
		87,
		97,
		-1,
		123,
		121,
		145,
		139,
		144,
		140,
		125,
		143,
		141,
		156,
		158,
		154,
		156,
		193,
		184,
		205,
		202,
		233,
		239,
		233,
		242,
		-1,
		43,
		39,
		9,
		0,
		51,
		-1,
		-1,
		91,
		-1,
		105,
		118,
		135,
		125,
		128,
		140,
		148,
		147,
		131,
		149,
		144,
		147,
		166,
		162,
		171,
		181,
		180,
		198,
		211,
		226,
		230,
		236,
		-1,
		99,
		-1,
		41,
		25,
		46,
		57,
		85,
		-1,
		111,
		106,
		126,
		137,
		137,
		-1,
		153,
		150,
		163,
		147,
		132,
		149,
		151,
		155,
		165,
		169,
		184,
		175,
		193,
		200,
		208,
		212,
		232,
		244,
		59,
		49,
		-1,
		51,
		56,
		60,
		72,
		108,
		149,
		133,
		-1,
		148,
		-1,
		155,
		168,
		-1,
		153,
		149,
		138,
		154,
		162,
		169,
		172,
		166,
		163,
		181,
		184,
		201,
		205,
		221,
		-1,
		-1,
		64,
		68,
		100,
		66,
		93,
		117,
		154,
		142,
		151,
		153,
		-1,
		173,
		174,
		171,
		172,
		158,
		151,
		152,
		168,
		174,
		166,
		165,
		168,
		190,
		218,
		196,
		208,
		-1,
		-1,
		-1,
		89,
		-1,
		-1,
		100,
		71,
		95,
		137,
		181,
		174,
		162,
		160,
		160,
		154,
		-1,
		189,
		168,
		165,
		156,
		161,
		174,
		169,
		185,
		169,
		171,
		187,
		199,
		190,
		210,
		-1,
		-1,
		-1,
		130,
		119,
		120,
		74,
		108,
		126,
		193,
		179,
		184,
		159,
		152,
		146,
		183,
		185,
		162,
		170,
		162,
		151,
		165,
		173,
		177,
		171,
		180,
		181,
		205,
		212,
		218,
		-1,
		-1,
		137,
		127,
		111,
		113,
		110,
		99,
		106,
		138,
		184,
		181,
		-1,
		151,
		-1,
		140,
		148,
		147,
		153,
		165,
		151,
		156,
		167,
		179,
		185,
		176,
		191,
		210,
		210,
		202,
		227,
		230,
		-1,
		-1,
		-1,
		130,
		147,
		122,
		99,
		80,
		116,
		-1,
		151,
		152,
		-1,
		145,
		139,
		145,
		144,
		151,
		148,
		148,
		162,
		170,
		166,
		182,
		188,
		177,
		213,
		-1,
		210,
		204,
		225,
		215,
		203,
		-1,
		-1,
		-1,
		145,
		124,
		117,
		137,
		87,
		139,
		-1,
		-1,
		136,
		129,
		-1,
		132,
		132,
		139,
		148,
		153,
		158,
		166,
		161,
		174,
		179,
		182,
		190,
		208,
		212,
		216,
		205,
		201,
		198,
		212,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		107,
		-1,
		144,
		136,
		127,
		121,
		127,
		145,
		143,
		163,
		155,
		169,
		169,
		175,
		183,
		168,
		171,
		185,
		185,
		203,
		211,
		203,
		197,
		196,
		208,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		122,
		-1,
		93,
		117,
		133,
		-1,
		161,
		140,
		163,
		141,
		155,
		151,
		189,
		190,
		168,
		173,
		181,
		191,
		193,
		182,
		193,
		185,
		207,
		207,
		191,
		192,
		201,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		96,
		109,
		120,
		-1,
		-1,
		205,
		-1,
		139,
		156,
		165,
		163,
		179,
		170,
		176,
		192,
		195,
		197,
		187,
		176,
		182,
		179,
		201,
		187,
		185,
		204,
		220,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		183,
		173,
		157,
		142,
		175,
		-1,
		187,
		171,
		176,
		-1,
		222,
		-1,
		195,
		197,
		191,
		176,
		173,
		184,
		182,
		193,
		210,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		153,
		-1,
		-1,
		170,
		164,
		164,
		148,
		151,
		203,
		183,
		177,
		176,
		217,
		217,
		203,
		189,
		182,
		179,
		176,
		189,
		209,
		200,
		212,
		-1,
		-1,
		-1,
		154,
		134,
		140,
		98,
		119,
		-1,
		-1,
		232,
		187,
		173,
		-1,
		157,
		220,
		208,
		198,
		188,
		222,
		223,
		208,
		201,
		187,
		189,
		187,
		185,
		190,
		211,
		212,
		225,
		-1,
		-1,
		131,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		179,
		195,
		187,
		158,
		209,
		-1,
		-1,
		200,
		198,
		208,
		204,
		191,
		211,
		214,
		200,
		184,
		199,
		211,
		219,
		224,
		-1,
		134,
		121,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		212,
		178,
		190,
		211,
		236,
		203,
		-1,
		208,
		209,
		195,
		209,
		216,
		202,
		197,
		191,
		194,
		212,
		229,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		169,
		183,
		204,
		210,
		222,
		-1,
		217,
		211,
		197,
		214,
		215,
		212,
		203,
		195,
		200,
		197,
		210,
		224,
		228,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		187,
		202,
		264,
		241,
		214,
		218,
		211,
		205,
		205,
		221,
		223,
		234,
		202,
		198,
		199,
		203,
		202,
		219,
		229,
		-1,
		-1,
		154,
		171,
		206,
		195,
		199,
		291,
		-1,
		-1,
		227,
		218,
		209,
		212,
		215,
		218,
		208,
		205,
		210,
		215,
		203,
		212,
		230,
		234,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		214,
		298,
		245,
		227,
		223,
		221,
		214,
		223,
		218,
		213,
		223,
		232,
		224,
		205,
		216,
		239,
		228,
		266,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		239,
		234,
		235,
		260,
		257,
		-1,
		227,
		252,
		224,
		231,
		223,
		231,
		231,
		228,
		206,
		213,
		229,
		228,
		223,
		258,
		250,
		256,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		209,
		195,
		225,
		215,
		221,
		-1,
		-1,
		268,
		265,
		249,
		233,
		237,
		230,
		225,
		235,
		215,
		202,
		206,
		210,
		216,
		221,
		226,
		232,
		247,
		262,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		212,
		221,
		202,
		207,
		215,
		-1,
		-1,
		241,
		237,
		242,
		240,
		237,
		245,
		240,
		231,
		216,
		222,
		209,
		208,
		226,
		230,
		239,
		246,
		236,
		249,
		253,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		225,
		-1,
		-1,
		210,
		228,
		236,
		232,
		236,
		289,
		254,
		249,
		239,
		237,
		228,
		219,
		226,
		217,
		217,
		220,
		235,
		240,
		232,
		246,
		246,
		247,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		226,
		-1,
		262,
		-1,
		255,
		259,
		262,
		265,
		253,
		240,
		232,
		224,
		240,
		215,
		225,
		221,
		222,
		231,
		242,
		254,
		253,
		254,
		302,
		257,
		224,
		215,
		262,
		277,
		281,
		-1,
		238,
		277,
		264,
		-1,
		235,
		-1,
		-1,
		-1,
		269,
		275,
		267,
		273,
		252,
		252,
		226,
		230,
		220,
		227,
		237,
		239,
		231,
		235,
		248,
		259,
		262,
		298,
		296,
		301,
		246,
		229,
		247,
		256,
		277,
		253,
		244,
		271,
		271,
		260,
		255,
		242,
		-1,
		-1,
		292,
		285,
		-1,
		-1,
		259,
		247,
		230,
		231,
		227,
		230,
		245,
		248,
		238,
		236,
		230,
		262,
		-1,
		298,
		297,
		286,
		283,
		259,
		250,
		237,
		248,
		-1,
		-1,
		256,
		272,
		285,
		289,
		302,
		327,
		-1,
		245,
		-1,
		-1,
		304,
		-1,
		-1,
		289,
		252,
		241,
		232,
		238,
		235,
		246,
		256,
		244,
		245,
		235,
		245,
		258,
		282,
		279,
		267,
		265,
		288,
		245,
		241,
		-1,
		271,
		259,
		265,
		272,
		289,
		316,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		287,
		285,
		274,
		-1,
		264,
		237,
		242,
		262,
		264,
		253,
		247,
		241,
		248,
		247,
		255,
		263,
		291,
		305,
		294,
		290,
		289,
		297,
		246,
		263,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		-1,
		296,
		271,
		-1,
		-1,
		282,
		275,
		263,
		251,
		241,
		251,
		255,
		259,
		251,
		244,
		239,
		250,
		242,
		246,
		263,
		-1,
		325,
		-1,
		277,
		270,
		285,
		300,
		308,
		-1,
		-1,
		-1,
		313,
		299,
		292,
		280,
		278,
		-1,
		316,
		300,
		281,
		-1,
		251,
		264,
		295,
		263,
		268,
		263,
		245,
		256,
		245,
		248,
		262,
		257,
		-1,
		-1,
		283,
		286,
		-1,
		-1,
		308,
		327,
		-1,
		304,
		293,
		278,
		270,
		-1,
		-1,
		288,
		284,
		-1,
		-1,
		252,
		277,
		266,
		274,
		269,
		249,
		255,
		258,
		247,
		251,
		263,
		-1,
		-1,
		290,
		291,
		296,
		-1,
		317,
		-1,
		328,
		-1,
		273,
		289,
		291,
		-1,
		-1,
		-1,
		290,
		253,
		274,
		284,
		278,
		276,
		267,
		253,
		260,
		258,
		254,
		265,
		-1,
		-1,
		-1,
		335,
		309,
		335,
		326,
		309,
		289,
		281,
		306,
		-1,
		277,
		-1,
		252,
		254,
		280,
		283,
		289,
		283,
		256,
		271,
		261,
		252,
		261,
		341,
		-1,
		311,
		344,
		308,
		295,
		278,
		282,
		298,
		-1,
		274,
		256,
		-1,
		284,
		274,
		305,
		290,
		271,
		258,
		265,
		265,
		258,
		-1,
		-1,
		-1,
		313,
		312,
		304,
		298,
		298,
		283,
		274,
		-1,
		286,
		268,
		247,
		264,
		264,
		255,
		263,
		295,
		291,
		278,
		278,
		270,
		-1,
		397,
		-1,
		-1,
		336,
		-1,
		-1,
		-1,
		307,
		302,
		275,
		263,
		269,
		265,
		251,
		257,
		259,
		267,
		265,
		262,
		274,
		270,
		290,
		271,
		306,
		-1,
		404,
		-1,
		343,
		-1,
		-1,
		325,
		305,
		297,
		286,
		275,
		273,
		264,
		255,
		277,
		293,
		277,
		275,
		278,
		279,
		-1,
		398,
		397,
		-1,
		344,
		336,
		322,
		-1,
		315,
		-1,
		321,
		282,
		-1,
		284,
		264,
		-1,
		286,
		282,
		-1,
		-1,
		385,
		360,
		-1,
		-1,
		-1,
		345,
		325,
		316,
		300,
		-1,
		275,
		275,
		-1,
		-1,
		-1,
		370,
		369,
		-1,
		338,
		341,
		-1,
		331,
		322,
		330,
		277,
		281,
		-1,
		-1,
		-1,
		379,
		360,
		354,
		353,
		351,
		346,
		343,
		329,
		313,
		291,
		280,
		301,
		-1,
		-1,
		-1,
		351,
		343,
		336,
		-1,
		-1,
		338,
		321,
		302,
		300,
		-1,
		-1,
		-1,
		373,
		354,
		-1,
		-1,
		328,
		-1,
		-1,
		334,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		390,
		362,
		-1,
		-1,
		-1,
		324,
		320,
		321,
		-1,
		-1,
		-1,
		-1,
		384,
		385,
		408,
		372,
		-1,
		-1,
		-1,
		316,
		310,
		-1,
		-1,
		387,
		385,
		-1,
		-1,
		-1,
		344,
		328,
		-1,
		314,
		-1,
		-1,
		-1,
		335,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		349,
		-1,
		349,
		324,
		331,
		-1,
		-1,
		-1,
		-1,
		362,
		354,
		362,
		-1,
		334,
		336,
		-1,
		384,
		-1,
		-1,
		377,
		368,
		-1,
		-1,
		339,
		346,
		368,
		371,
		407,
		-1,
		358
	],
	[
		-1,
		111,
		100,
		111,
		119,
		92,
		99,
		-1,
		120,
		122,
		88,
		82,
		121,
		92,
		98,
		109,
		-1,
		-1,
		-1,
		111,
		110,
		80,
		78,
		87,
		92,
		99,
		-1,
		122,
		-1,
		132,
		111,
		122,
		127,
		73,
		70,
		90,
		109,
		115,
		107,
		147,
		103,
		74,
		68,
		86,
		91,
		109,
		101,
		-1,
		74,
		64,
		86,
		90,
		102,
		85,
		-1,
		-1,
		68,
		69,
		75,
		87,
		92,
		97,
		-1,
		123,
		142,
		-1,
		-1,
		58,
		71,
		67,
		70,
		78,
		94,
		115,
		132,
		137,
		-1,
		-1,
		59,
		63,
		76,
		77,
		75,
		102,
		121,
		132,
		146,
		145,
		-1,
		47,
		65,
		74,
		83,
		89,
		78,
		82,
		100,
		131,
		137,
		140,
		-1,
		39,
		41,
		70,
		76,
		88,
		94,
		81,
		87,
		106,
		119,
		138,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		37,
		36,
		44,
		70,
		69,
		65,
		83,
		105,
		84,
		90,
		94,
		111,
		127,
		128,
		138,
		-1,
		-1,
		87,
		56,
		91,
		48,
		33,
		-1,
		32,
		51,
		57,
		61,
		66,
		74,
		102,
		100,
		-1,
		105,
		104,
		135,
		121,
		132,
		47,
		-1,
		-1,
		45,
		37,
		22,
		25,
		22,
		27,
		57,
		56,
		61,
		63,
		65,
		77,
		92,
		92,
		102,
		99,
		109,
		113,
		128,
		139,
		-1,
		-1,
		213,
		-1,
		-1,
		44,
		27,
		-1,
		10,
		17,
		17,
		34,
		25,
		50,
		65,
		69,
		77,
		80,
		68,
		87,
		84,
		108,
		104,
		96,
		121,
		125,
		131,
		149,
		150,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		22,
		3,
		6,
		12,
		36,
		46,
		-1,
		72,
		70,
		94,
		88,
		93,
		89,
		74,
		92,
		90,
		105,
		107,
		103,
		105,
		142,
		133,
		154,
		151,
		182,
		188,
		182,
		191,
		-1,
		52,
		48,
		44,
		51,
		0,
		-1,
		-1,
		40,
		-1,
		54,
		67,
		84,
		74,
		77,
		89,
		97,
		96,
		80,
		98,
		93,
		96,
		115,
		111,
		120,
		130,
		129,
		147,
		160,
		175,
		179,
		185,
		-1,
		102,
		-1,
		44,
		28,
		30,
		6,
		34,
		-1,
		60,
		55,
		75,
		86,
		86,
		-1,
		102,
		99,
		112,
		96,
		81,
		98,
		100,
		104,
		114,
		118,
		133,
		124,
		142,
		149,
		157,
		161,
		181,
		193,
		62,
		52,
		-1,
		34,
		39,
		9,
		21,
		57,
		98,
		82,
		-1,
		97,
		-1,
		104,
		117,
		-1,
		102,
		98,
		87,
		103,
		111,
		118,
		121,
		115,
		112,
		130,
		133,
		150,
		154,
		170,
		-1,
		-1,
		47,
		51,
		72,
		15,
		42,
		66,
		103,
		91,
		100,
		102,
		-1,
		122,
		123,
		120,
		121,
		107,
		100,
		101,
		117,
		123,
		115,
		114,
		117,
		139,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		72,
		-1,
		-1,
		49,
		20,
		44,
		86,
		130,
		123,
		111,
		109,
		109,
		103,
		-1,
		138,
		117,
		114,
		105,
		110,
		123,
		118,
		134,
		118,
		120,
		136,
		148,
		139,
		159,
		-1,
		-1,
		-1,
		79,
		68,
		69,
		23,
		57,
		75,
		142,
		128,
		133,
		108,
		101,
		95,
		132,
		134,
		111,
		119,
		111,
		100,
		114,
		122,
		126,
		120,
		129,
		130,
		154,
		161,
		167,
		-1,
		-1,
		86,
		76,
		60,
		62,
		59,
		48,
		55,
		87,
		133,
		130,
		-1,
		100,
		-1,
		89,
		97,
		96,
		102,
		114,
		100,
		105,
		116,
		128,
		134,
		125,
		140,
		159,
		159,
		151,
		176,
		179,
		-1,
		-1,
		-1,
		79,
		96,
		71,
		48,
		29,
		65,
		-1,
		100,
		101,
		-1,
		94,
		88,
		94,
		93,
		100,
		97,
		97,
		111,
		119,
		115,
		131,
		137,
		126,
		162,
		-1,
		159,
		153,
		174,
		164,
		152,
		-1,
		-1,
		-1,
		94,
		73,
		66,
		86,
		36,
		88,
		-1,
		-1,
		85,
		78,
		-1,
		81,
		81,
		88,
		97,
		102,
		107,
		115,
		110,
		123,
		128,
		131,
		139,
		157,
		161,
		165,
		154,
		150,
		147,
		161,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		39,
		56,
		-1,
		93,
		85,
		76,
		70,
		76,
		94,
		92,
		112,
		104,
		118,
		118,
		124,
		132,
		117,
		120,
		134,
		134,
		152,
		160,
		152,
		146,
		145,
		157,
		-1,
		142,
		128,
		99,
		-1,
		-1,
		71,
		-1,
		42,
		66,
		82,
		-1,
		110,
		89,
		112,
		90,
		104,
		100,
		138,
		139,
		117,
		122,
		130,
		140,
		142,
		131,
		142,
		134,
		156,
		156,
		140,
		141,
		150,
		-1,
		148,
		135,
		93,
		89,
		78,
		98,
		45,
		58,
		69,
		-1,
		-1,
		154,
		-1,
		88,
		105,
		114,
		112,
		128,
		119,
		125,
		141,
		144,
		146,
		136,
		125,
		131,
		128,
		150,
		136,
		134,
		153,
		169,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		64,
		51,
		45,
		-1,
		86,
		-1,
		132,
		122,
		106,
		91,
		124,
		-1,
		136,
		120,
		125,
		-1,
		171,
		-1,
		144,
		146,
		140,
		125,
		122,
		133,
		131,
		142,
		159,
		-1,
		98,
		83,
		76,
		66,
		80,
		51,
		-1,
		102,
		-1,
		-1,
		119,
		113,
		113,
		97,
		100,
		152,
		132,
		126,
		125,
		166,
		166,
		152,
		138,
		131,
		128,
		125,
		138,
		158,
		149,
		161,
		-1,
		-1,
		-1,
		103,
		83,
		89,
		47,
		68,
		-1,
		-1,
		181,
		136,
		122,
		-1,
		106,
		169,
		157,
		147,
		137,
		171,
		172,
		157,
		150,
		136,
		138,
		136,
		134,
		139,
		160,
		161,
		174,
		-1,
		-1,
		80,
		87,
		75,
		61,
		80,
		-1,
		-1,
		-1,
		128,
		144,
		136,
		107,
		158,
		-1,
		-1,
		149,
		147,
		157,
		153,
		140,
		160,
		163,
		149,
		133,
		148,
		160,
		168,
		173,
		-1,
		83,
		70,
		-1,
		-1,
		83,
		77,
		-1,
		-1,
		-1,
		-1,
		161,
		127,
		139,
		160,
		185,
		152,
		-1,
		157,
		158,
		144,
		158,
		165,
		151,
		146,
		140,
		143,
		161,
		178,
		-1,
		-1,
		97,
		-1,
		92,
		-1,
		-1,
		-1,
		-1,
		118,
		132,
		153,
		159,
		171,
		-1,
		166,
		160,
		146,
		163,
		164,
		161,
		152,
		144,
		149,
		146,
		159,
		173,
		177,
		120,
		-1,
		103,
		-1,
		-1,
		-1,
		136,
		151,
		213,
		190,
		163,
		167,
		160,
		154,
		154,
		170,
		172,
		183,
		151,
		147,
		148,
		152,
		151,
		168,
		178,
		-1,
		-1,
		103,
		120,
		155,
		144,
		148,
		240,
		-1,
		-1,
		176,
		167,
		158,
		161,
		164,
		167,
		157,
		154,
		159,
		164,
		152,
		161,
		179,
		183,
		-1,
		-1,
		-1,
		123,
		-1,
		138,
		-1,
		-1,
		163,
		247,
		194,
		176,
		172,
		170,
		163,
		172,
		167,
		162,
		172,
		181,
		173,
		154,
		165,
		188,
		177,
		215,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		152,
		127,
		142,
		188,
		183,
		184,
		209,
		206,
		-1,
		176,
		201,
		173,
		180,
		172,
		180,
		180,
		177,
		155,
		162,
		178,
		177,
		172,
		207,
		199,
		205,
		-1,
		-1,
		233,
		222,
		211,
		217,
		-1,
		158,
		144,
		174,
		164,
		170,
		-1,
		-1,
		217,
		214,
		198,
		182,
		186,
		179,
		174,
		184,
		164,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		128,
		209,
		202,
		185,
		193,
		224,
		-1,
		161,
		170,
		151,
		156,
		164,
		-1,
		-1,
		190,
		186,
		191,
		189,
		186,
		194,
		189,
		180,
		165,
		171,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		142,
		185,
		179,
		182,
		206,
		220,
		-1,
		174,
		-1,
		-1,
		159,
		177,
		185,
		181,
		185,
		238,
		203,
		198,
		188,
		186,
		177,
		168,
		175,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		177,
		165,
		173,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		175,
		-1,
		211,
		-1,
		204,
		208,
		211,
		214,
		202,
		189,
		181,
		173,
		189,
		164,
		174,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		251,
		206,
		173,
		164,
		211,
		226,
		230,
		-1,
		187,
		226,
		213,
		-1,
		184,
		-1,
		-1,
		-1,
		218,
		224,
		216,
		222,
		201,
		201,
		175,
		179,
		169,
		176,
		186,
		188,
		180,
		184,
		197,
		208,
		211,
		247,
		245,
		250,
		195,
		178,
		196,
		205,
		226,
		202,
		193,
		220,
		220,
		209,
		204,
		191,
		-1,
		-1,
		241,
		234,
		-1,
		-1,
		208,
		196,
		179,
		180,
		176,
		179,
		194,
		197,
		187,
		185,
		179,
		211,
		-1,
		247,
		246,
		235,
		232,
		208,
		199,
		186,
		197,
		-1,
		-1,
		205,
		221,
		234,
		238,
		251,
		276,
		-1,
		194,
		-1,
		-1,
		253,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		184,
		195,
		205,
		193,
		194,
		184,
		194,
		207,
		231,
		228,
		216,
		214,
		237,
		194,
		190,
		-1,
		220,
		208,
		214,
		221,
		238,
		265,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		236,
		234,
		223,
		-1,
		213,
		186,
		191,
		211,
		213,
		202,
		196,
		190,
		197,
		196,
		204,
		212,
		240,
		254,
		243,
		239,
		238,
		246,
		195,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		-1,
		245,
		220,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		204,
		208,
		200,
		193,
		188,
		199,
		191,
		195,
		212,
		-1,
		274,
		-1,
		226,
		219,
		234,
		249,
		257,
		-1,
		-1,
		-1,
		262,
		248,
		241,
		229,
		227,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		194,
		205,
		194,
		197,
		211,
		206,
		-1,
		-1,
		232,
		235,
		-1,
		-1,
		257,
		276,
		-1,
		253,
		242,
		227,
		219,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		198,
		204,
		207,
		196,
		200,
		212,
		-1,
		-1,
		239,
		240,
		245,
		-1,
		266,
		-1,
		277,
		-1,
		222,
		238,
		240,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		227,
		225,
		216,
		202,
		209,
		207,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		258,
		284,
		275,
		258,
		238,
		230,
		255,
		-1,
		226,
		-1,
		201,
		203,
		229,
		232,
		238,
		232,
		205,
		220,
		210,
		201,
		210,
		290,
		-1,
		260,
		293,
		257,
		244,
		227,
		231,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		254,
		239,
		220,
		207,
		214,
		214,
		207,
		-1,
		-1,
		-1,
		262,
		261,
		253,
		247,
		247,
		232,
		223,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		244,
		240,
		227,
		227,
		219,
		-1,
		346,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		256,
		251,
		224,
		212,
		218,
		214,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		220,
		255,
		-1,
		353,
		-1,
		292,
		-1,
		-1,
		274,
		254,
		246,
		235,
		224,
		222,
		213,
		204,
		226,
		242,
		226,
		224,
		227,
		228,
		-1,
		347,
		346,
		-1,
		293,
		285,
		271,
		-1,
		264,
		-1,
		270,
		231,
		-1,
		233,
		213,
		-1,
		235,
		231,
		-1,
		-1,
		334,
		309,
		-1,
		-1,
		-1,
		294,
		274,
		265,
		249,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		319,
		318,
		-1,
		287,
		290,
		-1,
		280,
		271,
		279,
		226,
		230,
		-1,
		-1,
		-1,
		328,
		309,
		303,
		302,
		300,
		295,
		292,
		278,
		262,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		300,
		292,
		285,
		-1,
		-1,
		287,
		270,
		251,
		249,
		-1,
		-1,
		-1,
		322,
		303,
		-1,
		-1,
		277,
		-1,
		-1,
		283,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		311,
		-1,
		-1,
		-1,
		273,
		269,
		270,
		-1,
		-1,
		-1,
		-1,
		333,
		334,
		357,
		321,
		-1,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		336,
		334,
		-1,
		-1,
		-1,
		293,
		277,
		-1,
		263,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		298,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		311,
		303,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		326,
		317,
		-1,
		-1,
		288,
		295,
		317,
		320,
		356,
		-1,
		307
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		133,
		122,
		133,
		141,
		114,
		121,
		-1,
		142,
		144,
		110,
		104,
		143,
		114,
		120,
		131,
		-1,
		-1,
		-1,
		133,
		132,
		102,
		100,
		109,
		114,
		121,
		-1,
		144,
		-1,
		154,
		133,
		144,
		149,
		95,
		92,
		112,
		131,
		137,
		129,
		169,
		125,
		96,
		90,
		108,
		113,
		131,
		123,
		-1,
		96,
		86,
		108,
		112,
		124,
		107,
		-1,
		-1,
		90,
		91,
		97,
		109,
		114,
		119,
		-1,
		145,
		164,
		-1,
		-1,
		80,
		93,
		89,
		92,
		100,
		116,
		137,
		154,
		159,
		-1,
		-1,
		81,
		85,
		98,
		99,
		97,
		124,
		143,
		154,
		168,
		167,
		-1,
		69,
		87,
		96,
		105,
		111,
		100,
		104,
		122,
		153,
		159,
		162,
		-1,
		61,
		63,
		92,
		98,
		110,
		116,
		103,
		109,
		128,
		141,
		160,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		58,
		66,
		92,
		91,
		87,
		105,
		127,
		106,
		112,
		116,
		133,
		149,
		150,
		160,
		-1,
		-1,
		115,
		84,
		118,
		77,
		62,
		-1,
		54,
		73,
		79,
		83,
		88,
		96,
		124,
		122,
		-1,
		127,
		126,
		157,
		143,
		154,
		93,
		-1,
		-1,
		73,
		65,
		51,
		54,
		44,
		49,
		79,
		78,
		83,
		85,
		87,
		99,
		114,
		114,
		124,
		121,
		131,
		135,
		150,
		161,
		-1,
		-1,
		235,
		-1,
		-1,
		90,
		73,
		-1,
		39,
		46,
		39,
		56,
		47,
		72,
		87,
		91,
		99,
		102,
		90,
		109,
		106,
		130,
		126,
		118,
		143,
		147,
		153,
		171,
		172,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		46,
		43,
		34,
		4,
		68,
		-1,
		94,
		92,
		116,
		110,
		115,
		111,
		96,
		114,
		112,
		127,
		129,
		125,
		127,
		164,
		155,
		176,
		173,
		204,
		210,
		204,
		213,
		-1,
		98,
		94,
		90,
		97,
		46,
		-1,
		-1,
		0,
		-1,
		52,
		87,
		106,
		96,
		99,
		111,
		119,
		118,
		102,
		120,
		115,
		118,
		137,
		133,
		142,
		152,
		151,
		169,
		182,
		197,
		201,
		207,
		-1,
		148,
		-1,
		90,
		74,
		76,
		52,
		80,
		-1,
		20,
		51,
		95,
		108,
		105,
		-1,
		124,
		121,
		134,
		118,
		103,
		120,
		122,
		126,
		136,
		140,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		108,
		98,
		-1,
		80,
		85,
		55,
		67,
		103,
		83,
		67,
		-1,
		106,
		-1,
		126,
		139,
		-1,
		124,
		120,
		109,
		125,
		133,
		140,
		143,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		93,
		97,
		118,
		61,
		88,
		112,
		122,
		76,
		85,
		87,
		-1,
		144,
		145,
		142,
		143,
		129,
		122,
		123,
		139,
		145,
		141,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		95,
		66,
		90,
		132,
		115,
		108,
		96,
		121,
		121,
		128,
		-1,
		160,
		139,
		136,
		127,
		135,
		149,
		146,
		160,
		140,
		142,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		125,
		114,
		115,
		69,
		103,
		121,
		154,
		140,
		145,
		120,
		126,
		131,
		154,
		156,
		151,
		145,
		137,
		126,
		142,
		150,
		152,
		142,
		151,
		152,
		176,
		183,
		189,
		-1,
		-1,
		132,
		122,
		106,
		108,
		105,
		94,
		101,
		133,
		145,
		176,
		-1,
		146,
		-1,
		135,
		143,
		142,
		145,
		142,
		139,
		133,
		142,
		156,
		156,
		147,
		162,
		181,
		181,
		173,
		198,
		201,
		-1,
		-1,
		-1,
		125,
		142,
		117,
		94,
		75,
		111,
		-1,
		146,
		147,
		-1,
		140,
		134,
		140,
		139,
		146,
		143,
		143,
		140,
		147,
		143,
		157,
		166,
		148,
		184,
		-1,
		181,
		175,
		203,
		197,
		185,
		-1,
		-1,
		-1,
		140,
		119,
		112,
		132,
		82,
		134,
		-1,
		-1,
		131,
		124,
		-1,
		127,
		127,
		134,
		143,
		144,
		148,
		152,
		141,
		154,
		159,
		153,
		163,
		183,
		187,
		194,
		187,
		183,
		180,
		194,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		102,
		-1,
		139,
		131,
		122,
		116,
		122,
		140,
		138,
		158,
		150,
		159,
		159,
		155,
		163,
		148,
		151,
		156,
		160,
		178,
		193,
		185,
		179,
		178,
		190,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		117,
		-1,
		88,
		112,
		128,
		-1,
		156,
		135,
		158,
		136,
		150,
		146,
		179,
		180,
		158,
		163,
		162,
		172,
		173,
		162,
		168,
		167,
		187,
		189,
		173,
		174,
		183,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		91,
		104,
		115,
		-1,
		-1,
		200,
		-1,
		134,
		151,
		160,
		158,
		169,
		160,
		166,
		173,
		176,
		177,
		167,
		156,
		162,
		161,
		183,
		169,
		167,
		186,
		202,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		178,
		168,
		152,
		137,
		170,
		-1,
		177,
		161,
		166,
		-1,
		202,
		-1,
		175,
		177,
		169,
		158,
		155,
		166,
		164,
		175,
		192,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		148,
		-1,
		-1,
		165,
		159,
		159,
		143,
		146,
		193,
		173,
		167,
		166,
		197,
		195,
		183,
		167,
		160,
		157,
		158,
		171,
		191,
		182,
		194,
		-1,
		-1,
		-1,
		149,
		129,
		135,
		93,
		114,
		-1,
		-1,
		227,
		182,
		168,
		-1,
		152,
		210,
		198,
		188,
		178,
		212,
		211,
		186,
		179,
		165,
		167,
		165,
		167,
		172,
		193,
		194,
		207,
		-1,
		-1,
		126,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		174,
		190,
		182,
		153,
		199,
		-1,
		-1,
		190,
		188,
		198,
		182,
		169,
		189,
		192,
		182,
		166,
		181,
		193,
		201,
		206,
		-1,
		129,
		116,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		185,
		206,
		227,
		193,
		-1,
		198,
		193,
		173,
		187,
		194,
		184,
		179,
		173,
		176,
		194,
		211,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		164,
		178,
		199,
		205,
		213,
		-1,
		201,
		189,
		175,
		192,
		197,
		194,
		185,
		177,
		182,
		179,
		192,
		206,
		210,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		182,
		197,
		255,
		232,
		205,
		200,
		193,
		187,
		183,
		199,
		205,
		216,
		184,
		180,
		181,
		185,
		184,
		201,
		211,
		-1,
		-1,
		149,
		166,
		201,
		190,
		194,
		282,
		-1,
		-1,
		209,
		200,
		191,
		194,
		193,
		196,
		190,
		187,
		192,
		197,
		185,
		194,
		212,
		211,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		209,
		280,
		227,
		209,
		205,
		203,
		196,
		205,
		200,
		195,
		205,
		207,
		199,
		187,
		191,
		214,
		203,
		242,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		198,
		173,
		188,
		234,
		229,
		230,
		242,
		239,
		-1,
		209,
		234,
		206,
		213,
		204,
		211,
		211,
		203,
		181,
		188,
		204,
		203,
		198,
		234,
		225,
		231,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		204,
		190,
		220,
		210,
		216,
		-1,
		-1,
		258,
		255,
		231,
		214,
		212,
		205,
		200,
		210,
		190,
		177,
		181,
		185,
		191,
		196,
		201,
		207,
		222,
		237,
		-1,
		174,
		255,
		248,
		231,
		239,
		270,
		-1,
		207,
		216,
		197,
		202,
		210,
		-1,
		-1,
		231,
		228,
		233,
		221,
		218,
		220,
		215,
		206,
		191,
		197,
		184,
		183,
		201,
		205,
		214,
		221,
		211,
		224,
		228,
		-1,
		188,
		231,
		225,
		228,
		252,
		266,
		-1,
		220,
		-1,
		-1,
		205,
		223,
		231,
		227,
		230,
		280,
		235,
		230,
		214,
		212,
		203,
		194,
		201,
		192,
		192,
		195,
		210,
		215,
		207,
		221,
		221,
		222,
		-1,
		223,
		211,
		219,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		221,
		-1,
		257,
		-1,
		248,
		252,
		243,
		246,
		228,
		215,
		207,
		199,
		215,
		190,
		200,
		196,
		197,
		206,
		217,
		229,
		228,
		229,
		297,
		252,
		219,
		210,
		257,
		272,
		276,
		-1,
		233,
		272,
		259,
		-1,
		230,
		-1,
		-1,
		-1,
		262,
		256,
		248,
		248,
		227,
		227,
		201,
		205,
		195,
		202,
		212,
		214,
		206,
		210,
		223,
		234,
		237,
		293,
		291,
		296,
		241,
		224,
		242,
		251,
		272,
		248,
		239,
		266,
		266,
		255,
		250,
		237,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		234,
		222,
		205,
		206,
		202,
		205,
		220,
		223,
		213,
		211,
		205,
		237,
		-1,
		293,
		292,
		281,
		278,
		254,
		245,
		232,
		243,
		-1,
		-1,
		251,
		267,
		280,
		284,
		297,
		322,
		-1,
		240,
		-1,
		-1,
		279,
		-1,
		-1,
		264,
		227,
		216,
		207,
		213,
		210,
		221,
		231,
		219,
		220,
		210,
		220,
		233,
		277,
		274,
		262,
		260,
		283,
		240,
		236,
		-1,
		266,
		254,
		260,
		267,
		284,
		311,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		262,
		260,
		249,
		-1,
		239,
		212,
		217,
		237,
		239,
		228,
		222,
		216,
		223,
		222,
		230,
		238,
		286,
		300,
		289,
		285,
		284,
		292,
		241,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		-1,
		291,
		266,
		-1,
		-1,
		257,
		250,
		238,
		226,
		216,
		226,
		230,
		234,
		226,
		219,
		214,
		225,
		217,
		221,
		238,
		-1,
		320,
		-1,
		272,
		265,
		280,
		295,
		303,
		-1,
		-1,
		-1,
		308,
		294,
		287,
		275,
		273,
		-1,
		291,
		275,
		256,
		-1,
		226,
		239,
		270,
		238,
		243,
		238,
		220,
		231,
		220,
		223,
		237,
		232,
		-1,
		-1,
		278,
		281,
		-1,
		-1,
		303,
		309,
		-1,
		299,
		288,
		273,
		265,
		-1,
		-1,
		263,
		259,
		-1,
		-1,
		227,
		252,
		241,
		249,
		244,
		224,
		230,
		233,
		222,
		226,
		238,
		-1,
		-1,
		285,
		286,
		291,
		-1,
		292,
		-1,
		310,
		-1,
		268,
		283,
		271,
		-1,
		-1,
		-1,
		265,
		228,
		249,
		259,
		253,
		251,
		242,
		228,
		235,
		233,
		229,
		240,
		-1,
		-1,
		-1,
		310,
		284,
		317,
		308,
		291,
		271,
		263,
		282,
		-1,
		252,
		-1,
		227,
		229,
		255,
		258,
		264,
		258,
		231,
		246,
		236,
		227,
		236,
		316,
		-1,
		286,
		319,
		283,
		277,
		253,
		257,
		273,
		-1,
		249,
		231,
		-1,
		259,
		249,
		280,
		265,
		246,
		233,
		240,
		240,
		233,
		-1,
		-1,
		-1,
		288,
		287,
		279,
		273,
		273,
		258,
		249,
		-1,
		261,
		243,
		222,
		239,
		239,
		230,
		238,
		270,
		266,
		253,
		253,
		245,
		-1,
		389,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		282,
		277,
		250,
		238,
		244,
		240,
		226,
		232,
		234,
		242,
		240,
		237,
		249,
		245,
		265,
		246,
		281,
		-1,
		384,
		-1,
		318,
		-1,
		-1,
		300,
		280,
		272,
		261,
		250,
		248,
		239,
		230,
		252,
		268,
		252,
		250,
		253,
		254,
		-1,
		373,
		372,
		-1,
		319,
		311,
		297,
		-1,
		290,
		-1,
		296,
		257,
		-1,
		259,
		239,
		-1,
		261,
		257,
		-1,
		-1,
		360,
		335,
		-1,
		-1,
		-1,
		320,
		300,
		291,
		275,
		-1,
		250,
		250,
		-1,
		-1,
		-1,
		345,
		344,
		-1,
		313,
		316,
		-1,
		306,
		297,
		305,
		252,
		256,
		-1,
		-1,
		-1,
		354,
		335,
		329,
		328,
		326,
		321,
		318,
		304,
		288,
		266,
		255,
		276,
		-1,
		-1,
		-1,
		326,
		318,
		311,
		-1,
		-1,
		313,
		296,
		277,
		275,
		-1,
		-1,
		-1,
		348,
		329,
		-1,
		-1,
		303,
		-1,
		-1,
		309,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		365,
		337,
		-1,
		-1,
		-1,
		299,
		295,
		296,
		-1,
		-1,
		-1,
		-1,
		359,
		360,
		383,
		347,
		-1,
		-1,
		-1,
		291,
		285,
		-1,
		-1,
		362,
		360,
		-1,
		-1,
		-1,
		319,
		303,
		-1,
		289,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		322,
		-1,
		-1,
		-1,
		324,
		-1,
		324,
		299,
		306,
		-1,
		-1,
		-1,
		-1,
		337,
		329,
		337,
		-1,
		309,
		311,
		-1,
		359,
		-1,
		-1,
		352,
		343,
		-1,
		-1,
		314,
		321,
		343,
		346,
		382,
		-1,
		333
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		0,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		133,
		122,
		133,
		141,
		114,
		121,
		-1,
		142,
		144,
		110,
		104,
		143,
		114,
		120,
		131,
		-1,
		-1,
		-1,
		133,
		132,
		102,
		100,
		109,
		114,
		121,
		-1,
		144,
		-1,
		154,
		133,
		144,
		149,
		95,
		92,
		112,
		131,
		137,
		129,
		169,
		125,
		96,
		90,
		108,
		113,
		131,
		123,
		-1,
		96,
		86,
		108,
		112,
		124,
		107,
		-1,
		-1,
		90,
		91,
		97,
		109,
		114,
		119,
		-1,
		145,
		164,
		-1,
		-1,
		80,
		93,
		89,
		92,
		100,
		116,
		137,
		154,
		159,
		-1,
		-1,
		81,
		85,
		98,
		99,
		97,
		124,
		143,
		154,
		168,
		167,
		-1,
		69,
		87,
		96,
		105,
		111,
		100,
		104,
		122,
		153,
		159,
		162,
		-1,
		61,
		63,
		92,
		98,
		110,
		116,
		103,
		109,
		128,
		141,
		160,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		58,
		66,
		92,
		91,
		87,
		105,
		127,
		106,
		112,
		116,
		133,
		149,
		150,
		160,
		-1,
		-1,
		121,
		94,
		118,
		77,
		64,
		-1,
		54,
		73,
		79,
		83,
		88,
		96,
		124,
		122,
		-1,
		127,
		126,
		157,
		143,
		154,
		103,
		-1,
		-1,
		79,
		71,
		53,
		56,
		44,
		49,
		79,
		78,
		83,
		85,
		87,
		99,
		114,
		114,
		124,
		121,
		131,
		135,
		150,
		161,
		-1,
		-1,
		235,
		-1,
		-1,
		100,
		83,
		-1,
		48,
		55,
		39,
		56,
		47,
		72,
		87,
		91,
		99,
		102,
		90,
		109,
		106,
		130,
		126,
		118,
		143,
		147,
		153,
		171,
		172,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		55,
		52,
		45,
		59,
		34,
		-1,
		67,
		73,
		97,
		100,
		112,
		111,
		96,
		114,
		112,
		127,
		129,
		125,
		127,
		164,
		155,
		176,
		173,
		204,
		210,
		204,
		213,
		-1,
		108,
		104,
		100,
		107,
		56,
		-1,
		-1,
		55,
		-1,
		0,
		35,
		57,
		77,
		80,
		101,
		101,
		118,
		102,
		120,
		115,
		118,
		137,
		133,
		142,
		152,
		151,
		169,
		182,
		197,
		201,
		207,
		-1,
		158,
		-1,
		100,
		84,
		86,
		62,
		90,
		-1,
		67,
		1,
		43,
		61,
		61,
		-1,
		105,
		102,
		116,
		118,
		103,
		120,
		122,
		126,
		136,
		140,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		118,
		108,
		-1,
		90,
		95,
		65,
		77,
		113,
		44,
		28,
		-1,
		67,
		-1,
		107,
		120,
		-1,
		122,
		120,
		109,
		125,
		133,
		140,
		143,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		103,
		107,
		128,
		71,
		98,
		115,
		83,
		37,
		46,
		48,
		-1,
		114,
		145,
		142,
		143,
		129,
		122,
		123,
		139,
		145,
		141,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		105,
		76,
		100,
		97,
		76,
		69,
		57,
		82,
		82,
		89,
		-1,
		160,
		139,
		136,
		127,
		135,
		149,
		146,
		160,
		140,
		142,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		79,
		113,
		131,
		115,
		101,
		106,
		81,
		87,
		92,
		154,
		156,
		151,
		145,
		137,
		126,
		142,
		150,
		152,
		142,
		151,
		152,
		176,
		183,
		189,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		104,
		111,
		143,
		106,
		186,
		-1,
		125,
		-1,
		98,
		132,
		140,
		145,
		142,
		139,
		133,
		142,
		156,
		156,
		147,
		162,
		181,
		181,
		173,
		198,
		201,
		-1,
		-1,
		-1,
		135,
		152,
		127,
		104,
		85,
		121,
		-1,
		156,
		157,
		-1,
		119,
		113,
		129,
		137,
		144,
		141,
		141,
		140,
		147,
		143,
		157,
		166,
		148,
		184,
		-1,
		181,
		175,
		203,
		197,
		185,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		92,
		144,
		-1,
		-1,
		141,
		134,
		-1,
		116,
		125,
		132,
		141,
		144,
		148,
		152,
		141,
		154,
		159,
		153,
		163,
		183,
		187,
		194,
		187,
		183,
		180,
		194,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		112,
		-1,
		149,
		141,
		132,
		126,
		124,
		138,
		136,
		156,
		148,
		159,
		159,
		155,
		163,
		148,
		151,
		156,
		160,
		178,
		193,
		185,
		179,
		178,
		190,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		127,
		-1,
		98,
		122,
		138,
		-1,
		162,
		141,
		156,
		134,
		148,
		144,
		179,
		180,
		158,
		163,
		162,
		172,
		173,
		162,
		168,
		167,
		187,
		189,
		173,
		174,
		183,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		101,
		114,
		125,
		-1,
		-1,
		198,
		-1,
		132,
		149,
		158,
		156,
		169,
		160,
		166,
		173,
		176,
		177,
		167,
		156,
		162,
		161,
		183,
		169,
		167,
		186,
		202,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		176,
		166,
		150,
		135,
		168,
		-1,
		177,
		161,
		166,
		-1,
		202,
		-1,
		175,
		177,
		169,
		158,
		155,
		166,
		164,
		175,
		192,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		158,
		-1,
		-1,
		163,
		157,
		157,
		141,
		144,
		193,
		173,
		167,
		166,
		197,
		195,
		183,
		167,
		160,
		157,
		158,
		171,
		191,
		182,
		194,
		-1,
		-1,
		-1,
		159,
		139,
		145,
		103,
		124,
		-1,
		-1,
		225,
		180,
		166,
		-1,
		150,
		210,
		198,
		188,
		178,
		212,
		211,
		186,
		179,
		165,
		167,
		165,
		167,
		172,
		193,
		194,
		207,
		-1,
		-1,
		136,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		172,
		188,
		180,
		151,
		199,
		-1,
		-1,
		190,
		188,
		198,
		182,
		169,
		189,
		192,
		182,
		166,
		181,
		193,
		201,
		206,
		-1,
		139,
		126,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		183,
		204,
		227,
		193,
		-1,
		198,
		193,
		173,
		187,
		194,
		184,
		179,
		173,
		176,
		194,
		211,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		162,
		176,
		197,
		203,
		213,
		-1,
		201,
		189,
		175,
		192,
		197,
		194,
		185,
		177,
		182,
		179,
		192,
		206,
		210,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		195,
		255,
		232,
		205,
		200,
		193,
		187,
		183,
		199,
		205,
		216,
		184,
		180,
		181,
		185,
		184,
		201,
		211,
		-1,
		-1,
		159,
		176,
		206,
		188,
		192,
		282,
		-1,
		-1,
		209,
		200,
		191,
		194,
		193,
		196,
		190,
		187,
		192,
		197,
		185,
		194,
		212,
		211,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		207,
		280,
		227,
		209,
		205,
		203,
		196,
		205,
		200,
		195,
		205,
		207,
		199,
		187,
		191,
		214,
		203,
		242,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		244,
		227,
		234,
		242,
		239,
		-1,
		209,
		234,
		206,
		213,
		204,
		211,
		211,
		203,
		181,
		188,
		204,
		203,
		198,
		234,
		225,
		231,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		214,
		200,
		230,
		220,
		226,
		-1,
		-1,
		258,
		255,
		231,
		214,
		212,
		205,
		200,
		210,
		190,
		177,
		181,
		185,
		191,
		196,
		201,
		207,
		222,
		237,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		217,
		226,
		207,
		212,
		220,
		-1,
		-1,
		231,
		228,
		233,
		221,
		218,
		220,
		215,
		206,
		191,
		197,
		184,
		183,
		201,
		205,
		214,
		221,
		211,
		224,
		228,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		230,
		-1,
		-1,
		215,
		233,
		241,
		236,
		230,
		280,
		235,
		230,
		214,
		212,
		203,
		194,
		201,
		192,
		192,
		195,
		210,
		215,
		207,
		221,
		221,
		222,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		231,
		-1,
		267,
		-1,
		248,
		252,
		243,
		246,
		228,
		215,
		207,
		199,
		215,
		190,
		200,
		196,
		197,
		206,
		217,
		229,
		228,
		229,
		307,
		262,
		229,
		220,
		267,
		282,
		286,
		-1,
		243,
		282,
		269,
		-1,
		240,
		-1,
		-1,
		-1,
		262,
		256,
		248,
		248,
		227,
		227,
		201,
		205,
		195,
		202,
		212,
		214,
		206,
		210,
		223,
		234,
		237,
		303,
		301,
		306,
		251,
		234,
		252,
		261,
		282,
		258,
		249,
		276,
		276,
		265,
		260,
		247,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		234,
		222,
		205,
		206,
		202,
		205,
		220,
		223,
		213,
		211,
		205,
		237,
		-1,
		303,
		302,
		291,
		288,
		264,
		255,
		242,
		253,
		-1,
		-1,
		261,
		277,
		290,
		294,
		307,
		332,
		-1,
		250,
		-1,
		-1,
		279,
		-1,
		-1,
		264,
		227,
		216,
		207,
		213,
		210,
		221,
		231,
		219,
		220,
		210,
		220,
		233,
		287,
		284,
		272,
		270,
		293,
		250,
		246,
		-1,
		276,
		264,
		270,
		277,
		294,
		321,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		262,
		260,
		249,
		-1,
		239,
		212,
		217,
		237,
		239,
		228,
		222,
		216,
		223,
		222,
		230,
		238,
		296,
		310,
		299,
		295,
		294,
		302,
		251,
		268,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		-1,
		300,
		276,
		-1,
		-1,
		257,
		250,
		238,
		226,
		216,
		226,
		230,
		234,
		226,
		219,
		214,
		225,
		217,
		221,
		238,
		-1,
		330,
		-1,
		282,
		275,
		290,
		305,
		313,
		-1,
		-1,
		-1,
		317,
		303,
		296,
		284,
		282,
		-1,
		291,
		275,
		256,
		-1,
		226,
		239,
		270,
		238,
		243,
		238,
		220,
		231,
		220,
		223,
		237,
		232,
		-1,
		-1,
		288,
		291,
		-1,
		-1,
		307,
		309,
		-1,
		308,
		297,
		282,
		274,
		-1,
		-1,
		263,
		259,
		-1,
		-1,
		227,
		252,
		241,
		249,
		244,
		224,
		230,
		233,
		222,
		226,
		238,
		-1,
		-1,
		295,
		296,
		301,
		-1,
		292,
		-1,
		310,
		-1,
		277,
		283,
		271,
		-1,
		-1,
		-1,
		265,
		228,
		249,
		259,
		253,
		251,
		242,
		228,
		235,
		233,
		229,
		240,
		-1,
		-1,
		-1,
		310,
		284,
		317,
		308,
		291,
		271,
		263,
		282,
		-1,
		252,
		-1,
		227,
		229,
		255,
		258,
		264,
		258,
		231,
		246,
		236,
		227,
		236,
		316,
		-1,
		286,
		319,
		283,
		277,
		253,
		257,
		273,
		-1,
		249,
		231,
		-1,
		259,
		249,
		280,
		265,
		246,
		233,
		240,
		240,
		233,
		-1,
		-1,
		-1,
		288,
		287,
		279,
		273,
		273,
		258,
		249,
		-1,
		261,
		243,
		222,
		239,
		239,
		230,
		238,
		270,
		266,
		253,
		253,
		245,
		-1,
		389,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		282,
		277,
		250,
		238,
		244,
		240,
		226,
		232,
		234,
		242,
		240,
		237,
		249,
		245,
		265,
		246,
		281,
		-1,
		384,
		-1,
		318,
		-1,
		-1,
		300,
		280,
		272,
		261,
		250,
		248,
		239,
		230,
		252,
		268,
		252,
		250,
		253,
		254,
		-1,
		373,
		372,
		-1,
		319,
		311,
		297,
		-1,
		290,
		-1,
		296,
		257,
		-1,
		259,
		239,
		-1,
		261,
		257,
		-1,
		-1,
		360,
		335,
		-1,
		-1,
		-1,
		320,
		300,
		291,
		275,
		-1,
		250,
		250,
		-1,
		-1,
		-1,
		345,
		344,
		-1,
		313,
		316,
		-1,
		306,
		297,
		305,
		252,
		256,
		-1,
		-1,
		-1,
		354,
		335,
		329,
		328,
		326,
		321,
		318,
		304,
		288,
		266,
		255,
		276,
		-1,
		-1,
		-1,
		326,
		318,
		311,
		-1,
		-1,
		313,
		296,
		277,
		275,
		-1,
		-1,
		-1,
		348,
		329,
		-1,
		-1,
		303,
		-1,
		-1,
		309,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		365,
		337,
		-1,
		-1,
		-1,
		299,
		295,
		296,
		-1,
		-1,
		-1,
		-1,
		359,
		360,
		383,
		347,
		-1,
		-1,
		-1,
		291,
		285,
		-1,
		-1,
		362,
		360,
		-1,
		-1,
		-1,
		319,
		303,
		-1,
		289,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		322,
		-1,
		-1,
		-1,
		324,
		-1,
		324,
		299,
		306,
		-1,
		-1,
		-1,
		-1,
		337,
		329,
		337,
		-1,
		309,
		311,
		-1,
		359,
		-1,
		-1,
		352,
		343,
		-1,
		-1,
		314,
		321,
		343,
		346,
		382,
		-1,
		333
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		152,
		154,
		120,
		114,
		153,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		143,
		142,
		112,
		110,
		119,
		124,
		131,
		-1,
		154,
		-1,
		164,
		143,
		154,
		159,
		105,
		102,
		122,
		141,
		147,
		139,
		179,
		135,
		106,
		100,
		118,
		123,
		141,
		133,
		-1,
		106,
		96,
		118,
		122,
		134,
		117,
		-1,
		-1,
		100,
		101,
		107,
		119,
		124,
		129,
		-1,
		155,
		174,
		-1,
		-1,
		90,
		103,
		99,
		102,
		110,
		126,
		147,
		164,
		169,
		-1,
		-1,
		91,
		95,
		108,
		109,
		107,
		134,
		153,
		164,
		178,
		177,
		-1,
		79,
		97,
		106,
		115,
		121,
		110,
		114,
		132,
		163,
		169,
		172,
		-1,
		71,
		73,
		102,
		108,
		120,
		126,
		113,
		119,
		138,
		151,
		170,
		161,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		68,
		76,
		102,
		101,
		97,
		115,
		132,
		116,
		122,
		126,
		143,
		159,
		160,
		170,
		-1,
		-1,
		131,
		104,
		128,
		87,
		74,
		-1,
		64,
		83,
		89,
		93,
		98,
		102,
		129,
		127,
		-1,
		137,
		136,
		167,
		153,
		164,
		113,
		-1,
		-1,
		89,
		81,
		63,
		66,
		54,
		59,
		87,
		86,
		84,
		80,
		76,
		105,
		117,
		115,
		125,
		131,
		141,
		145,
		160,
		171,
		-1,
		-1,
		245,
		-1,
		-1,
		110,
		93,
		-1,
		58,
		65,
		49,
		66,
		57,
		70,
		97,
		73,
		72,
		91,
		79,
		99,
		109,
		132,
		129,
		128,
		153,
		157,
		163,
		181,
		182,
		-1,
		244,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		65,
		62,
		55,
		79,
		38,
		-1,
		32,
		38,
		62,
		65,
		77,
		90,
		85,
		115,
		115,
		130,
		132,
		135,
		137,
		174,
		165,
		186,
		183,
		214,
		220,
		214,
		223,
		-1,
		118,
		114,
		110,
		117,
		66,
		-1,
		-1,
		83,
		-1,
		32,
		0,
		22,
		42,
		45,
		66,
		66,
		97,
		91,
		109,
		118,
		121,
		141,
		143,
		152,
		162,
		161,
		179,
		192,
		207,
		211,
		217,
		-1,
		168,
		-1,
		110,
		94,
		96,
		72,
		100,
		-1,
		99,
		33,
		8,
		26,
		26,
		-1,
		70,
		67,
		81,
		88,
		93,
		110,
		125,
		129,
		140,
		150,
		165,
		156,
		174,
		181,
		189,
		193,
		213,
		225,
		128,
		118,
		-1,
		100,
		105,
		75,
		87,
		123,
		76,
		60,
		-1,
		37,
		-1,
		72,
		85,
		-1,
		87,
		91,
		99,
		115,
		129,
		142,
		147,
		147,
		144,
		162,
		165,
		182,
		186,
		202,
		-1,
		-1,
		113,
		117,
		138,
		81,
		108,
		132,
		108,
		55,
		44,
		43,
		-1,
		90,
		118,
		115,
		116,
		119,
		112,
		113,
		135,
		148,
		131,
		146,
		149,
		171,
		199,
		177,
		189,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		115,
		86,
		110,
		122,
		73,
		66,
		54,
		71,
		71,
		78,
		-1,
		140,
		124,
		126,
		117,
		125,
		139,
		136,
		150,
		150,
		152,
		168,
		180,
		171,
		191,
		-1,
		-1,
		-1,
		145,
		134,
		135,
		89,
		123,
		141,
		104,
		90,
		95,
		70,
		76,
		81,
		127,
		136,
		141,
		135,
		127,
		116,
		132,
		140,
		142,
		151,
		160,
		162,
		186,
		193,
		199,
		-1,
		-1,
		152,
		142,
		126,
		128,
		125,
		114,
		121,
		153,
		95,
		179,
		-1,
		114,
		-1,
		87,
		121,
		129,
		135,
		132,
		129,
		123,
		132,
		146,
		157,
		153,
		160,
		191,
		191,
		183,
		207,
		210,
		-1,
		-1,
		-1,
		145,
		162,
		137,
		114,
		95,
		131,
		-1,
		149,
		150,
		-1,
		108,
		102,
		118,
		126,
		133,
		130,
		130,
		130,
		137,
		133,
		147,
		158,
		145,
		181,
		-1,
		191,
		185,
		197,
		187,
		175,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		102,
		154,
		-1,
		-1,
		134,
		127,
		-1,
		105,
		114,
		121,
		130,
		134,
		138,
		142,
		131,
		144,
		149,
		150,
		160,
		180,
		184,
		188,
		177,
		173,
		170,
		184,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		122,
		-1,
		143,
		135,
		125,
		119,
		113,
		127,
		125,
		145,
		137,
		149,
		149,
		145,
		153,
		138,
		141,
		153,
		157,
		175,
		183,
		175,
		169,
		168,
		180,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		137,
		-1,
		108,
		132,
		148,
		-1,
		151,
		130,
		145,
		123,
		137,
		133,
		169,
		170,
		148,
		153,
		152,
		162,
		163,
		152,
		165,
		157,
		179,
		179,
		163,
		164,
		173,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		111,
		113,
		135,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		147,
		145,
		159,
		150,
		156,
		163,
		166,
		167,
		157,
		146,
		152,
		151,
		173,
		159,
		157,
		176,
		192,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		167,
		151,
		156,
		-1,
		192,
		-1,
		165,
		167,
		159,
		148,
		145,
		156,
		154,
		165,
		182,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		168,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		183,
		163,
		157,
		156,
		187,
		185,
		173,
		157,
		150,
		147,
		148,
		161,
		181,
		172,
		184,
		-1,
		-1,
		-1,
		169,
		149,
		155,
		113,
		134,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		200,
		188,
		178,
		168,
		202,
		201,
		176,
		169,
		155,
		157,
		155,
		157,
		162,
		183,
		184,
		197,
		-1,
		-1,
		146,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		161,
		177,
		169,
		140,
		189,
		-1,
		-1,
		180,
		178,
		188,
		172,
		159,
		179,
		182,
		172,
		156,
		171,
		183,
		191,
		196,
		-1,
		149,
		136,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		172,
		193,
		217,
		183,
		-1,
		188,
		183,
		163,
		177,
		184,
		174,
		169,
		163,
		166,
		184,
		201,
		-1,
		-1,
		163,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		151,
		165,
		186,
		192,
		203,
		-1,
		191,
		179,
		165,
		182,
		187,
		184,
		175,
		167,
		172,
		169,
		182,
		196,
		200,
		186,
		-1,
		169,
		-1,
		-1,
		-1,
		169,
		184,
		245,
		222,
		195,
		190,
		183,
		177,
		173,
		189,
		195,
		206,
		174,
		170,
		171,
		175,
		174,
		191,
		201,
		-1,
		-1,
		169,
		186,
		195,
		177,
		181,
		272,
		-1,
		-1,
		199,
		190,
		181,
		184,
		183,
		186,
		180,
		177,
		182,
		187,
		175,
		184,
		202,
		201,
		-1,
		-1,
		-1,
		189,
		-1,
		204,
		-1,
		-1,
		196,
		270,
		217,
		199,
		195,
		193,
		186,
		195,
		190,
		185,
		195,
		197,
		189,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		218,
		193,
		208,
		254,
		216,
		223,
		232,
		229,
		-1,
		199,
		224,
		196,
		203,
		194,
		201,
		201,
		193,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		224,
		210,
		240,
		230,
		233,
		-1,
		-1,
		248,
		245,
		221,
		204,
		202,
		195,
		190,
		200,
		180,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		194,
		275,
		268,
		251,
		259,
		290,
		-1,
		227,
		236,
		217,
		222,
		230,
		-1,
		-1,
		221,
		218,
		223,
		211,
		208,
		210,
		205,
		196,
		181,
		187,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		208,
		251,
		245,
		248,
		272,
		286,
		-1,
		240,
		-1,
		-1,
		225,
		243,
		236,
		226,
		220,
		270,
		225,
		220,
		204,
		202,
		193,
		184,
		191,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		243,
		231,
		239,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		241,
		-1,
		263,
		-1,
		238,
		242,
		233,
		236,
		218,
		205,
		197,
		189,
		205,
		180,
		190,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		317,
		272,
		239,
		230,
		277,
		292,
		296,
		-1,
		253,
		292,
		279,
		-1,
		250,
		-1,
		-1,
		-1,
		252,
		246,
		238,
		238,
		217,
		217,
		191,
		195,
		185,
		192,
		202,
		204,
		196,
		200,
		213,
		224,
		227,
		313,
		311,
		316,
		261,
		244,
		262,
		271,
		292,
		268,
		259,
		286,
		286,
		275,
		270,
		257,
		-1,
		-1,
		275,
		256,
		-1,
		-1,
		224,
		212,
		195,
		196,
		192,
		195,
		210,
		213,
		203,
		201,
		195,
		227,
		-1,
		313,
		312,
		301,
		298,
		274,
		265,
		252,
		263,
		-1,
		-1,
		271,
		287,
		300,
		304,
		317,
		342,
		-1,
		260,
		-1,
		-1,
		269,
		-1,
		-1,
		254,
		217,
		206,
		197,
		203,
		200,
		211,
		221,
		209,
		210,
		200,
		210,
		223,
		297,
		294,
		282,
		280,
		303,
		260,
		256,
		-1,
		284,
		274,
		280,
		287,
		304,
		331,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		252,
		250,
		239,
		-1,
		229,
		202,
		207,
		227,
		229,
		218,
		212,
		206,
		213,
		212,
		220,
		228,
		306,
		320,
		309,
		305,
		304,
		312,
		261,
		269,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		-1,
		290,
		286,
		-1,
		-1,
		247,
		240,
		228,
		216,
		206,
		216,
		220,
		224,
		216,
		209,
		204,
		215,
		207,
		211,
		228,
		-1,
		340,
		-1,
		292,
		283,
		297,
		312,
		320,
		-1,
		-1,
		-1,
		307,
		293,
		286,
		274,
		272,
		-1,
		281,
		265,
		246,
		-1,
		216,
		229,
		260,
		228,
		233,
		228,
		210,
		221,
		210,
		213,
		227,
		222,
		-1,
		-1,
		295,
		298,
		-1,
		-1,
		297,
		299,
		-1,
		298,
		287,
		272,
		264,
		-1,
		-1,
		253,
		249,
		-1,
		-1,
		217,
		242,
		231,
		239,
		234,
		214,
		220,
		223,
		212,
		216,
		228,
		-1,
		-1,
		302,
		303,
		304,
		-1,
		282,
		-1,
		300,
		-1,
		267,
		273,
		261,
		-1,
		-1,
		-1,
		255,
		218,
		239,
		249,
		243,
		241,
		232,
		218,
		225,
		223,
		219,
		230,
		-1,
		-1,
		-1,
		300,
		274,
		307,
		298,
		281,
		261,
		253,
		272,
		-1,
		242,
		-1,
		217,
		219,
		245,
		248,
		254,
		248,
		221,
		236,
		226,
		217,
		226,
		306,
		-1,
		276,
		309,
		273,
		267,
		243,
		247,
		263,
		-1,
		239,
		221,
		-1,
		249,
		239,
		270,
		255,
		236,
		223,
		230,
		230,
		223,
		-1,
		-1,
		-1,
		278,
		277,
		269,
		263,
		263,
		248,
		239,
		-1,
		251,
		233,
		212,
		229,
		229,
		220,
		228,
		260,
		256,
		243,
		243,
		235,
		-1,
		379,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		272,
		267,
		240,
		228,
		234,
		230,
		216,
		222,
		224,
		232,
		230,
		227,
		239,
		235,
		255,
		236,
		271,
		-1,
		374,
		-1,
		308,
		-1,
		-1,
		290,
		270,
		262,
		251,
		240,
		238,
		229,
		220,
		242,
		258,
		242,
		240,
		243,
		244,
		-1,
		363,
		362,
		-1,
		309,
		301,
		287,
		-1,
		280,
		-1,
		286,
		247,
		-1,
		249,
		229,
		-1,
		251,
		247,
		-1,
		-1,
		350,
		325,
		-1,
		-1,
		-1,
		310,
		290,
		281,
		265,
		-1,
		240,
		240,
		-1,
		-1,
		-1,
		335,
		334,
		-1,
		303,
		306,
		-1,
		296,
		287,
		295,
		242,
		246,
		-1,
		-1,
		-1,
		344,
		325,
		319,
		318,
		316,
		311,
		308,
		294,
		278,
		256,
		245,
		266,
		-1,
		-1,
		-1,
		316,
		308,
		301,
		-1,
		-1,
		303,
		286,
		267,
		265,
		-1,
		-1,
		-1,
		338,
		319,
		-1,
		-1,
		293,
		-1,
		-1,
		299,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		355,
		327,
		-1,
		-1,
		-1,
		289,
		285,
		286,
		-1,
		-1,
		-1,
		-1,
		349,
		350,
		373,
		337,
		-1,
		-1,
		-1,
		281,
		275,
		-1,
		-1,
		352,
		350,
		-1,
		-1,
		-1,
		309,
		293,
		-1,
		279,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		314,
		-1,
		314,
		289,
		296,
		-1,
		-1,
		-1,
		-1,
		327,
		319,
		327,
		-1,
		299,
		301,
		-1,
		349,
		-1,
		-1,
		342,
		333,
		-1,
		-1,
		304,
		311,
		333,
		336,
		372,
		-1,
		323
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		152,
		154,
		120,
		114,
		153,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		143,
		142,
		112,
		110,
		119,
		124,
		131,
		-1,
		154,
		-1,
		164,
		143,
		154,
		159,
		105,
		102,
		122,
		141,
		147,
		139,
		179,
		135,
		106,
		100,
		118,
		123,
		141,
		133,
		-1,
		106,
		96,
		118,
		122,
		134,
		117,
		-1,
		-1,
		100,
		101,
		107,
		119,
		124,
		129,
		-1,
		155,
		171,
		-1,
		-1,
		90,
		103,
		99,
		102,
		110,
		126,
		147,
		164,
		166,
		-1,
		-1,
		91,
		95,
		108,
		109,
		107,
		134,
		153,
		161,
		175,
		174,
		-1,
		79,
		97,
		106,
		115,
		121,
		110,
		114,
		132,
		160,
		166,
		169,
		-1,
		71,
		73,
		98,
		106,
		111,
		118,
		113,
		119,
		138,
		148,
		167,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		68,
		76,
		98,
		90,
		86,
		99,
		116,
		116,
		122,
		126,
		140,
		156,
		157,
		167,
		-1,
		-1,
		151,
		124,
		148,
		106,
		94,
		-1,
		64,
		74,
		79,
		83,
		84,
		86,
		113,
		111,
		-1,
		134,
		133,
		164,
		150,
		161,
		133,
		-1,
		-1,
		109,
		101,
		83,
		86,
		63,
		59,
		71,
		70,
		68,
		64,
		60,
		89,
		101,
		99,
		109,
		128,
		138,
		142,
		157,
		168,
		-1,
		-1,
		233,
		-1,
		-1,
		130,
		113,
		-1,
		78,
		85,
		69,
		75,
		61,
		54,
		81,
		57,
		56,
		75,
		63,
		83,
		93,
		116,
		113,
		125,
		150,
		154,
		158,
		178,
		174,
		-1,
		232,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		85,
		82,
		75,
		99,
		63,
		-1,
		16,
		22,
		46,
		49,
		61,
		74,
		69,
		99,
		99,
		114,
		116,
		132,
		134,
		167,
		155,
		177,
		174,
		203,
		208,
		202,
		211,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		103,
		-1,
		57,
		25,
		0,
		26,
		29,
		50,
		50,
		81,
		75,
		93,
		102,
		105,
		125,
		138,
		145,
		150,
		149,
		167,
		182,
		195,
		199,
		205,
		-1,
		188,
		-1,
		130,
		114,
		116,
		92,
		120,
		-1,
		123,
		58,
		17,
		10,
		10,
		-1,
		54,
		51,
		65,
		72,
		77,
		94,
		109,
		113,
		124,
		139,
		153,
		144,
		162,
		169,
		177,
		181,
		201,
		213,
		148,
		138,
		-1,
		120,
		125,
		95,
		107,
		130,
		82,
		46,
		-1,
		21,
		-1,
		56,
		69,
		-1,
		71,
		75,
		83,
		99,
		113,
		126,
		131,
		135,
		132,
		150,
		153,
		170,
		174,
		190,
		-1,
		-1,
		133,
		137,
		145,
		96,
		115,
		124,
		92,
		39,
		28,
		27,
		-1,
		74,
		102,
		99,
		100,
		103,
		96,
		97,
		119,
		132,
		115,
		134,
		137,
		159,
		187,
		165,
		177,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		122,
		93,
		117,
		106,
		57,
		50,
		38,
		55,
		55,
		62,
		-1,
		124,
		108,
		110,
		101,
		109,
		123,
		120,
		134,
		138,
		137,
		156,
		168,
		159,
		179,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		96,
		130,
		148,
		88,
		74,
		79,
		54,
		60,
		65,
		111,
		120,
		125,
		119,
		111,
		100,
		116,
		124,
		126,
		135,
		144,
		150,
		174,
		181,
		187,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		121,
		128,
		160,
		79,
		163,
		-1,
		98,
		-1,
		71,
		105,
		113,
		119,
		116,
		113,
		107,
		116,
		130,
		141,
		137,
		144,
		179,
		179,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		152,
		169,
		144,
		121,
		102,
		138,
		-1,
		133,
		134,
		-1,
		92,
		86,
		102,
		110,
		117,
		114,
		114,
		114,
		121,
		117,
		131,
		142,
		129,
		165,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		109,
		161,
		-1,
		-1,
		118,
		111,
		-1,
		89,
		98,
		105,
		114,
		118,
		122,
		126,
		115,
		128,
		133,
		134,
		144,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		129,
		-1,
		127,
		119,
		109,
		103,
		97,
		111,
		109,
		129,
		121,
		133,
		133,
		129,
		137,
		122,
		125,
		137,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		144,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		121,
		117,
		153,
		154,
		132,
		137,
		136,
		146,
		147,
		136,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		131,
		129,
		143,
		134,
		140,
		147,
		150,
		151,
		141,
		130,
		136,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		151,
		135,
		140,
		-1,
		176,
		-1,
		149,
		151,
		143,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		167,
		147,
		141,
		140,
		171,
		169,
		157,
		141,
		134,
		131,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		184,
		172,
		162,
		152,
		186,
		185,
		160,
		153,
		139,
		141,
		139,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		173,
		-1,
		-1,
		164,
		162,
		172,
		156,
		143,
		163,
		166,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		156,
		177,
		201,
		167,
		-1,
		172,
		167,
		147,
		161,
		168,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		135,
		149,
		170,
		176,
		187,
		-1,
		175,
		163,
		149,
		166,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		153,
		168,
		229,
		206,
		179,
		174,
		167,
		161,
		157,
		173,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		167,
		184,
		179,
		161,
		165,
		256,
		-1,
		-1,
		183,
		174,
		165,
		168,
		167,
		170,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		185,
		-1,
		-1,
		-1,
		187,
		-1,
		202,
		-1,
		-1,
		180,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		181,
		173,
		161,
		165,
		188,
		177,
		216,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		216,
		191,
		206,
		252,
		200,
		207,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		178,
		185,
		185,
		177,
		155,
		162,
		178,
		177,
		172,
		208,
		199,
		205,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		222,
		208,
		238,
		228,
		217,
		-1,
		-1,
		232,
		229,
		205,
		188,
		186,
		179,
		174,
		184,
		164,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		194,
		275,
		268,
		251,
		259,
		290,
		-1,
		225,
		234,
		215,
		220,
		228,
		-1,
		-1,
		205,
		202,
		207,
		195,
		192,
		194,
		189,
		180,
		165,
		171,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		208,
		251,
		245,
		248,
		272,
		286,
		-1,
		238,
		-1,
		-1,
		223,
		236,
		220,
		210,
		204,
		254,
		209,
		204,
		188,
		186,
		177,
		168,
		175,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		243,
		231,
		239,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		239,
		-1,
		247,
		-1,
		222,
		226,
		217,
		220,
		202,
		189,
		181,
		173,
		189,
		164,
		174,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		317,
		272,
		239,
		230,
		277,
		292,
		296,
		-1,
		251,
		290,
		277,
		-1,
		248,
		-1,
		-1,
		-1,
		236,
		230,
		222,
		222,
		201,
		201,
		175,
		179,
		169,
		176,
		186,
		188,
		180,
		184,
		197,
		208,
		211,
		313,
		310,
		316,
		261,
		244,
		262,
		271,
		292,
		266,
		257,
		284,
		284,
		273,
		268,
		255,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		208,
		196,
		179,
		180,
		176,
		179,
		194,
		197,
		187,
		185,
		179,
		211,
		-1,
		312,
		311,
		300,
		297,
		273,
		264,
		252,
		263,
		-1,
		-1,
		269,
		285,
		292,
		296,
		312,
		337,
		-1,
		258,
		-1,
		-1,
		253,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		184,
		195,
		205,
		193,
		194,
		184,
		194,
		207,
		296,
		293,
		281,
		279,
		302,
		260,
		255,
		-1,
		268,
		266,
		272,
		279,
		296,
		326,
		-1,
		-1,
		274,
		264,
		-1,
		-1,
		236,
		234,
		223,
		-1,
		213,
		186,
		191,
		211,
		213,
		202,
		196,
		190,
		197,
		196,
		204,
		212,
		305,
		319,
		308,
		304,
		303,
		311,
		260,
		253,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		-1,
		274,
		270,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		204,
		208,
		200,
		193,
		188,
		199,
		191,
		195,
		212,
		-1,
		339,
		-1,
		291,
		267,
		281,
		296,
		304,
		-1,
		-1,
		-1,
		291,
		277,
		270,
		258,
		256,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		194,
		205,
		194,
		197,
		211,
		206,
		-1,
		-1,
		279,
		282,
		-1,
		-1,
		281,
		283,
		-1,
		282,
		271,
		256,
		248,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		198,
		204,
		207,
		196,
		200,
		212,
		-1,
		-1,
		286,
		287,
		288,
		-1,
		266,
		-1,
		284,
		-1,
		251,
		257,
		245,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		227,
		225,
		216,
		202,
		209,
		207,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		258,
		291,
		282,
		265,
		245,
		237,
		256,
		-1,
		226,
		-1,
		201,
		203,
		229,
		232,
		238,
		232,
		205,
		220,
		210,
		201,
		210,
		290,
		-1,
		260,
		293,
		257,
		251,
		227,
		231,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		254,
		239,
		220,
		207,
		214,
		214,
		207,
		-1,
		-1,
		-1,
		262,
		261,
		253,
		247,
		247,
		232,
		223,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		244,
		240,
		227,
		227,
		219,
		-1,
		363,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		256,
		251,
		224,
		212,
		218,
		214,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		220,
		255,
		-1,
		358,
		-1,
		292,
		-1,
		-1,
		274,
		254,
		246,
		235,
		224,
		222,
		213,
		204,
		226,
		242,
		226,
		224,
		227,
		228,
		-1,
		347,
		346,
		-1,
		293,
		285,
		271,
		-1,
		264,
		-1,
		270,
		231,
		-1,
		233,
		213,
		-1,
		235,
		231,
		-1,
		-1,
		334,
		309,
		-1,
		-1,
		-1,
		294,
		274,
		265,
		249,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		319,
		318,
		-1,
		287,
		290,
		-1,
		280,
		271,
		279,
		226,
		230,
		-1,
		-1,
		-1,
		328,
		309,
		303,
		302,
		300,
		295,
		292,
		278,
		262,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		300,
		292,
		285,
		-1,
		-1,
		287,
		270,
		251,
		249,
		-1,
		-1,
		-1,
		322,
		303,
		-1,
		-1,
		277,
		-1,
		-1,
		283,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		311,
		-1,
		-1,
		-1,
		273,
		269,
		270,
		-1,
		-1,
		-1,
		-1,
		333,
		334,
		357,
		321,
		-1,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		336,
		334,
		-1,
		-1,
		-1,
		293,
		277,
		-1,
		263,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		298,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		311,
		303,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		326,
		317,
		-1,
		-1,
		288,
		295,
		317,
		320,
		356,
		-1,
		307
	],
	[
		-1,
		127,
		116,
		127,
		135,
		108,
		115,
		-1,
		136,
		138,
		104,
		98,
		137,
		108,
		114,
		125,
		-1,
		-1,
		-1,
		127,
		126,
		96,
		94,
		103,
		108,
		115,
		-1,
		138,
		-1,
		148,
		127,
		138,
		143,
		89,
		86,
		106,
		125,
		131,
		123,
		163,
		119,
		90,
		84,
		102,
		107,
		125,
		117,
		-1,
		90,
		80,
		102,
		106,
		118,
		101,
		-1,
		-1,
		84,
		85,
		91,
		103,
		108,
		113,
		-1,
		139,
		145,
		-1,
		-1,
		74,
		87,
		83,
		86,
		94,
		110,
		131,
		145,
		140,
		-1,
		-1,
		75,
		79,
		92,
		93,
		91,
		118,
		137,
		135,
		149,
		148,
		-1,
		63,
		81,
		90,
		99,
		105,
		94,
		98,
		116,
		134,
		140,
		143,
		-1,
		63,
		65,
		72,
		80,
		85,
		92,
		97,
		103,
		122,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		60,
		55,
		72,
		64,
		60,
		73,
		90,
		98,
		106,
		110,
		114,
		130,
		131,
		141,
		-1,
		-1,
		143,
		116,
		140,
		98,
		86,
		-1,
		56,
		48,
		53,
		57,
		58,
		60,
		87,
		85,
		-1,
		108,
		107,
		138,
		124,
		135,
		125,
		-1,
		-1,
		101,
		93,
		75,
		78,
		55,
		51,
		45,
		44,
		42,
		38,
		34,
		63,
		75,
		73,
		83,
		102,
		112,
		116,
		131,
		142,
		-1,
		-1,
		207,
		-1,
		-1,
		122,
		105,
		-1,
		70,
		77,
		61,
		67,
		53,
		46,
		55,
		31,
		30,
		49,
		37,
		57,
		67,
		90,
		87,
		99,
		124,
		128,
		132,
		152,
		148,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		77,
		74,
		67,
		91,
		90,
		-1,
		16,
		4,
		20,
		23,
		35,
		48,
		43,
		73,
		73,
		88,
		90,
		106,
		108,
		141,
		129,
		151,
		148,
		177,
		182,
		176,
		185,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		95,
		-1,
		85,
		53,
		28,
		0,
		3,
		24,
		24,
		55,
		49,
		67,
		76,
		79,
		99,
		112,
		119,
		124,
		123,
		141,
		156,
		169,
		173,
		179,
		-1,
		180,
		-1,
		122,
		106,
		108,
		84,
		112,
		-1,
		115,
		86,
		45,
		30,
		30,
		-1,
		28,
		25,
		39,
		46,
		51,
		68,
		83,
		87,
		98,
		113,
		127,
		118,
		136,
		143,
		151,
		155,
		175,
		187,
		140,
		130,
		-1,
		112,
		117,
		87,
		99,
		122,
		102,
		66,
		-1,
		41,
		-1,
		30,
		43,
		-1,
		45,
		49,
		57,
		73,
		87,
		100,
		105,
		109,
		106,
		124,
		127,
		144,
		148,
		164,
		-1,
		-1,
		125,
		129,
		137,
		88,
		107,
		131,
		112,
		59,
		48,
		47,
		-1,
		48,
		76,
		73,
		74,
		77,
		70,
		71,
		93,
		106,
		89,
		108,
		111,
		133,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		114,
		85,
		109,
		126,
		77,
		70,
		58,
		75,
		75,
		72,
		-1,
		98,
		82,
		84,
		75,
		83,
		97,
		94,
		108,
		112,
		111,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		88,
		122,
		140,
		108,
		94,
		99,
		74,
		74,
		82,
		85,
		94,
		99,
		93,
		85,
		74,
		90,
		98,
		100,
		109,
		118,
		124,
		148,
		155,
		161,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		113,
		120,
		152,
		99,
		176,
		-1,
		115,
		-1,
		88,
		114,
		98,
		93,
		90,
		87,
		81,
		90,
		104,
		115,
		111,
		118,
		153,
		153,
		145,
		165,
		168,
		-1,
		-1,
		-1,
		144,
		161,
		136,
		113,
		94,
		130,
		-1,
		146,
		147,
		-1,
		109,
		103,
		115,
		100,
		96,
		91,
		95,
		88,
		95,
		91,
		105,
		116,
		103,
		139,
		-1,
		153,
		147,
		155,
		145,
		133,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		101,
		153,
		-1,
		-1,
		131,
		124,
		-1,
		106,
		93,
		100,
		98,
		92,
		96,
		100,
		89,
		102,
		107,
		108,
		118,
		138,
		142,
		146,
		135,
		131,
		128,
		142,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		121,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		120,
		104,
		107,
		107,
		103,
		111,
		96,
		99,
		111,
		115,
		133,
		141,
		133,
		127,
		126,
		138,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		136,
		-1,
		107,
		131,
		147,
		-1,
		148,
		127,
		142,
		120,
		116,
		112,
		127,
		128,
		106,
		111,
		110,
		120,
		121,
		110,
		123,
		115,
		137,
		137,
		121,
		122,
		131,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		110,
		110,
		134,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		126,
		124,
		117,
		108,
		114,
		121,
		124,
		125,
		115,
		104,
		110,
		109,
		131,
		117,
		115,
		134,
		150,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		125,
		109,
		114,
		-1,
		150,
		-1,
		123,
		125,
		117,
		106,
		103,
		114,
		112,
		123,
		140,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		167,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		141,
		121,
		115,
		114,
		145,
		143,
		131,
		115,
		108,
		105,
		106,
		119,
		139,
		130,
		142,
		-1,
		-1,
		-1,
		168,
		148,
		154,
		112,
		133,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		158,
		146,
		136,
		126,
		160,
		159,
		134,
		127,
		113,
		115,
		113,
		115,
		120,
		141,
		142,
		155,
		-1,
		-1,
		145,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		147,
		-1,
		-1,
		138,
		136,
		146,
		130,
		117,
		137,
		140,
		130,
		114,
		129,
		141,
		149,
		154,
		-1,
		148,
		135,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		169,
		171,
		175,
		141,
		-1,
		146,
		141,
		121,
		135,
		142,
		132,
		127,
		121,
		124,
		142,
		159,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		148,
		162,
		164,
		157,
		161,
		-1,
		149,
		137,
		123,
		140,
		145,
		142,
		133,
		125,
		130,
		127,
		140,
		154,
		158,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		166,
		181,
		203,
		180,
		153,
		148,
		141,
		135,
		131,
		147,
		153,
		164,
		132,
		128,
		129,
		133,
		132,
		149,
		159,
		-1,
		-1,
		168,
		185,
		192,
		174,
		178,
		230,
		-1,
		-1,
		157,
		148,
		139,
		142,
		141,
		144,
		138,
		135,
		140,
		145,
		133,
		142,
		160,
		159,
		-1,
		-1,
		-1,
		188,
		-1,
		203,
		-1,
		-1,
		193,
		228,
		175,
		157,
		153,
		151,
		144,
		153,
		148,
		143,
		153,
		155,
		147,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		217,
		192,
		207,
		239,
		213,
		220,
		190,
		187,
		-1,
		157,
		182,
		154,
		161,
		152,
		159,
		159,
		151,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		223,
		209,
		225,
		215,
		218,
		-1,
		-1,
		206,
		203,
		179,
		162,
		160,
		153,
		148,
		158,
		138,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		226,
		221,
		216,
		207,
		209,
		-1,
		-1,
		179,
		176,
		181,
		169,
		166,
		168,
		163,
		154,
		139,
		145,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		226,
		-1,
		-1,
		224,
		210,
		194,
		184,
		178,
		228,
		183,
		178,
		162,
		160,
		151,
		142,
		149,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		240,
		-1,
		221,
		-1,
		196,
		200,
		191,
		194,
		176,
		163,
		155,
		147,
		163,
		138,
		148,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		297,
		253,
		238,
		229,
		276,
		291,
		295,
		-1,
		238,
		277,
		275,
		-1,
		249,
		-1,
		-1,
		-1,
		210,
		204,
		196,
		196,
		175,
		175,
		149,
		153,
		143,
		150,
		160,
		162,
		154,
		158,
		171,
		182,
		185,
		293,
		284,
		297,
		242,
		242,
		261,
		270,
		291,
		253,
		244,
		271,
		282,
		271,
		266,
		253,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		182,
		170,
		153,
		154,
		150,
		153,
		168,
		171,
		161,
		159,
		153,
		185,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		260,
		-1,
		-1,
		255,
		272,
		266,
		270,
		286,
		311,
		-1,
		242,
		-1,
		-1,
		227,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		158,
		169,
		179,
		167,
		168,
		158,
		168,
		181,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		242,
		240,
		246,
		253,
		270,
		300,
		-1,
		-1,
		258,
		238,
		-1,
		-1,
		210,
		208,
		197,
		-1,
		187,
		160,
		165,
		185,
		187,
		176,
		170,
		164,
		171,
		170,
		178,
		186,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		244,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		178,
		182,
		174,
		167,
		162,
		173,
		165,
		169,
		186,
		-1,
		313,
		-1,
		265,
		241,
		255,
		270,
		278,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		168,
		179,
		168,
		171,
		185,
		180,
		-1,
		-1,
		253,
		256,
		-1,
		-1,
		255,
		257,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		172,
		178,
		181,
		170,
		174,
		186,
		-1,
		-1,
		260,
		261,
		262,
		-1,
		240,
		-1,
		258,
		-1,
		225,
		231,
		219,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		201,
		199,
		190,
		176,
		183,
		181,
		177,
		188,
		-1,
		-1,
		-1,
		258,
		232,
		265,
		256,
		239,
		219,
		211,
		230,
		-1,
		200,
		-1,
		175,
		177,
		203,
		206,
		212,
		206,
		179,
		194,
		184,
		175,
		184,
		264,
		-1,
		234,
		267,
		231,
		225,
		201,
		205,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		228,
		213,
		194,
		181,
		188,
		188,
		181,
		-1,
		-1,
		-1,
		236,
		235,
		227,
		221,
		221,
		206,
		197,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		218,
		214,
		201,
		201,
		193,
		-1,
		337,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		230,
		225,
		198,
		186,
		192,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		194,
		229,
		-1,
		332,
		-1,
		266,
		-1,
		-1,
		248,
		228,
		220,
		209,
		198,
		196,
		187,
		178,
		200,
		216,
		200,
		198,
		201,
		202,
		-1,
		321,
		320,
		-1,
		267,
		259,
		245,
		-1,
		238,
		-1,
		244,
		205,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		308,
		283,
		-1,
		-1,
		-1,
		268,
		248,
		239,
		223,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		293,
		292,
		-1,
		261,
		264,
		-1,
		254,
		245,
		253,
		200,
		204,
		-1,
		-1,
		-1,
		302,
		283,
		277,
		276,
		274,
		269,
		266,
		252,
		236,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		274,
		266,
		259,
		-1,
		-1,
		261,
		244,
		225,
		223,
		-1,
		-1,
		-1,
		296,
		277,
		-1,
		-1,
		251,
		-1,
		-1,
		257,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		285,
		-1,
		-1,
		-1,
		247,
		243,
		244,
		-1,
		-1,
		-1,
		-1,
		307,
		308,
		331,
		295,
		-1,
		-1,
		-1,
		239,
		233,
		-1,
		-1,
		310,
		308,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		237,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		272,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		262,
		269,
		291,
		294,
		330,
		-1,
		281
	],
	[
		-1,
		125,
		114,
		125,
		133,
		106,
		113,
		-1,
		134,
		136,
		102,
		96,
		135,
		106,
		112,
		123,
		-1,
		-1,
		-1,
		125,
		124,
		94,
		92,
		101,
		106,
		113,
		-1,
		136,
		-1,
		146,
		125,
		136,
		141,
		87,
		84,
		104,
		123,
		129,
		121,
		161,
		117,
		88,
		82,
		100,
		105,
		123,
		115,
		-1,
		88,
		78,
		100,
		104,
		116,
		99,
		-1,
		-1,
		82,
		83,
		89,
		101,
		106,
		111,
		-1,
		137,
		143,
		-1,
		-1,
		72,
		85,
		81,
		84,
		92,
		108,
		129,
		143,
		138,
		-1,
		-1,
		73,
		77,
		90,
		91,
		89,
		116,
		135,
		133,
		147,
		146,
		-1,
		61,
		79,
		88,
		97,
		103,
		92,
		96,
		114,
		132,
		138,
		141,
		-1,
		70,
		71,
		70,
		78,
		83,
		90,
		95,
		101,
		120,
		120,
		139,
		130,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		69,
		53,
		70,
		62,
		58,
		71,
		88,
		96,
		104,
		108,
		112,
		128,
		129,
		139,
		-1,
		-1,
		159,
		132,
		156,
		114,
		94,
		-1,
		65,
		46,
		51,
		55,
		56,
		58,
		85,
		83,
		-1,
		106,
		105,
		136,
		122,
		133,
		141,
		-1,
		-1,
		117,
		109,
		91,
		94,
		71,
		67,
		43,
		42,
		40,
		36,
		32,
		61,
		73,
		71,
		81,
		100,
		110,
		114,
		129,
		140,
		-1,
		-1,
		205,
		-1,
		-1,
		138,
		121,
		-1,
		86,
		93,
		77,
		83,
		69,
		62,
		53,
		29,
		28,
		47,
		35,
		55,
		65,
		88,
		85,
		97,
		122,
		126,
		130,
		150,
		146,
		-1,
		204,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		93,
		90,
		83,
		107,
		106,
		-1,
		32,
		20,
		17,
		20,
		32,
		45,
		41,
		71,
		71,
		86,
		88,
		104,
		106,
		139,
		127,
		149,
		146,
		175,
		180,
		174,
		183,
		-1,
		146,
		142,
		138,
		145,
		94,
		-1,
		-1,
		111,
		-1,
		101,
		69,
		44,
		17,
		0,
		21,
		21,
		52,
		47,
		65,
		74,
		77,
		97,
		110,
		117,
		122,
		121,
		139,
		154,
		167,
		171,
		177,
		-1,
		196,
		-1,
		138,
		122,
		124,
		100,
		128,
		-1,
		131,
		102,
		61,
		46,
		46,
		-1,
		25,
		22,
		36,
		43,
		49,
		66,
		81,
		85,
		96,
		111,
		125,
		116,
		134,
		141,
		149,
		153,
		173,
		185,
		156,
		146,
		-1,
		128,
		133,
		103,
		115,
		138,
		118,
		82,
		-1,
		57,
		-1,
		27,
		40,
		-1,
		42,
		46,
		55,
		71,
		85,
		98,
		103,
		107,
		104,
		122,
		125,
		142,
		146,
		162,
		-1,
		-1,
		141,
		145,
		153,
		104,
		123,
		147,
		128,
		75,
		64,
		63,
		-1,
		45,
		73,
		70,
		71,
		75,
		68,
		69,
		91,
		104,
		87,
		106,
		109,
		131,
		159,
		137,
		149,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		130,
		101,
		125,
		142,
		93,
		86,
		74,
		84,
		82,
		69,
		-1,
		95,
		79,
		82,
		73,
		81,
		95,
		92,
		106,
		110,
		109,
		128,
		140,
		131,
		151,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		104,
		138,
		156,
		117,
		103,
		108,
		83,
		71,
		79,
		82,
		91,
		97,
		91,
		83,
		72,
		88,
		96,
		98,
		107,
		116,
		122,
		146,
		153,
		159,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		129,
		136,
		168,
		108,
		174,
		-1,
		112,
		-1,
		85,
		112,
		96,
		91,
		88,
		85,
		79,
		88,
		102,
		113,
		109,
		116,
		151,
		151,
		143,
		163,
		166,
		-1,
		-1,
		-1,
		160,
		177,
		152,
		129,
		110,
		146,
		-1,
		144,
		145,
		-1,
		106,
		100,
		113,
		98,
		94,
		89,
		93,
		86,
		93,
		89,
		103,
		114,
		101,
		137,
		-1,
		151,
		145,
		153,
		143,
		131,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		117,
		169,
		-1,
		-1,
		129,
		122,
		-1,
		103,
		91,
		98,
		96,
		90,
		94,
		98,
		87,
		100,
		105,
		106,
		116,
		136,
		140,
		144,
		133,
		129,
		126,
		140,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		137,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		118,
		102,
		105,
		105,
		101,
		109,
		94,
		97,
		109,
		113,
		131,
		139,
		131,
		125,
		124,
		136,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		152,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		110,
		125,
		126,
		104,
		109,
		108,
		118,
		119,
		108,
		121,
		113,
		135,
		135,
		119,
		120,
		129,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		124,
		122,
		115,
		106,
		112,
		119,
		122,
		123,
		113,
		102,
		108,
		107,
		129,
		115,
		113,
		132,
		148,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		123,
		107,
		112,
		-1,
		148,
		-1,
		121,
		123,
		115,
		104,
		101,
		112,
		110,
		121,
		138,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		139,
		119,
		113,
		112,
		143,
		141,
		129,
		113,
		106,
		103,
		104,
		117,
		137,
		128,
		140,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		156,
		144,
		134,
		124,
		158,
		157,
		132,
		125,
		111,
		113,
		111,
		113,
		118,
		139,
		140,
		153,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		164,
		135,
		145,
		-1,
		-1,
		136,
		134,
		144,
		128,
		115,
		135,
		138,
		128,
		112,
		127,
		139,
		147,
		152,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		167,
		169,
		173,
		139,
		-1,
		144,
		139,
		119,
		133,
		140,
		130,
		125,
		119,
		122,
		140,
		157,
		-1,
		-1,
		172,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		146,
		160,
		162,
		155,
		159,
		-1,
		147,
		135,
		121,
		138,
		143,
		140,
		131,
		123,
		128,
		125,
		138,
		152,
		156,
		195,
		-1,
		178,
		-1,
		-1,
		-1,
		164,
		179,
		201,
		178,
		151,
		146,
		139,
		133,
		129,
		145,
		151,
		162,
		130,
		126,
		127,
		131,
		130,
		147,
		157,
		-1,
		-1,
		178,
		195,
		190,
		172,
		176,
		228,
		-1,
		-1,
		155,
		146,
		137,
		140,
		139,
		142,
		136,
		133,
		138,
		143,
		131,
		140,
		158,
		157,
		-1,
		-1,
		-1,
		198,
		-1,
		213,
		-1,
		-1,
		191,
		226,
		173,
		155,
		151,
		149,
		142,
		151,
		146,
		141,
		151,
		153,
		145,
		133,
		137,
		160,
		149,
		188,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		227,
		202,
		217,
		237,
		211,
		218,
		188,
		185,
		-1,
		155,
		180,
		152,
		159,
		150,
		157,
		157,
		149,
		127,
		134,
		150,
		149,
		144,
		180,
		171,
		177,
		-1,
		-1,
		310,
		299,
		288,
		294,
		-1,
		233,
		219,
		223,
		213,
		216,
		-1,
		-1,
		204,
		201,
		177,
		160,
		158,
		151,
		146,
		156,
		136,
		123,
		127,
		131,
		137,
		142,
		147,
		153,
		168,
		183,
		-1,
		205,
		286,
		279,
		262,
		270,
		301,
		-1,
		227,
		219,
		226,
		205,
		207,
		-1,
		-1,
		177,
		174,
		179,
		167,
		164,
		166,
		161,
		152,
		137,
		143,
		130,
		129,
		147,
		151,
		160,
		167,
		157,
		170,
		174,
		-1,
		219,
		262,
		256,
		259,
		283,
		297,
		-1,
		224,
		-1,
		-1,
		234,
		208,
		192,
		182,
		176,
		226,
		181,
		176,
		160,
		158,
		149,
		140,
		147,
		138,
		138,
		141,
		156,
		161,
		153,
		167,
		167,
		168,
		-1,
		254,
		242,
		250,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		250,
		-1,
		219,
		-1,
		194,
		198,
		189,
		192,
		174,
		161,
		153,
		145,
		161,
		136,
		146,
		142,
		143,
		152,
		163,
		175,
		174,
		175,
		295,
		251,
		250,
		241,
		276,
		291,
		295,
		-1,
		236,
		275,
		273,
		-1,
		257,
		-1,
		-1,
		-1,
		208,
		202,
		194,
		194,
		173,
		173,
		147,
		151,
		141,
		148,
		158,
		160,
		152,
		156,
		169,
		180,
		183,
		291,
		282,
		295,
		240,
		240,
		261,
		270,
		291,
		251,
		242,
		269,
		280,
		269,
		264,
		251,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		180,
		168,
		151,
		152,
		148,
		151,
		166,
		169,
		159,
		157,
		151,
		183,
		-1,
		284,
		283,
		272,
		269,
		245,
		236,
		231,
		258,
		-1,
		-1,
		253,
		270,
		264,
		268,
		284,
		309,
		-1,
		240,
		-1,
		-1,
		225,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		156,
		167,
		177,
		165,
		166,
		156,
		166,
		179,
		268,
		265,
		253,
		251,
		274,
		239,
		227,
		-1,
		240,
		238,
		244,
		251,
		268,
		298,
		-1,
		-1,
		256,
		236,
		-1,
		-1,
		208,
		206,
		195,
		-1,
		185,
		158,
		163,
		183,
		185,
		174,
		168,
		162,
		169,
		168,
		176,
		184,
		277,
		291,
		280,
		276,
		275,
		283,
		232,
		225,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		-1,
		246,
		242,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		176,
		180,
		172,
		165,
		160,
		171,
		163,
		167,
		184,
		-1,
		311,
		-1,
		263,
		239,
		253,
		268,
		276,
		-1,
		-1,
		-1,
		263,
		249,
		242,
		230,
		228,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		166,
		177,
		166,
		169,
		183,
		178,
		-1,
		-1,
		251,
		254,
		-1,
		-1,
		253,
		255,
		-1,
		254,
		243,
		228,
		220,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		170,
		176,
		179,
		168,
		172,
		184,
		-1,
		-1,
		258,
		259,
		260,
		-1,
		238,
		-1,
		256,
		-1,
		223,
		229,
		217,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		199,
		197,
		188,
		174,
		181,
		179,
		175,
		186,
		-1,
		-1,
		-1,
		256,
		230,
		263,
		254,
		237,
		217,
		209,
		228,
		-1,
		198,
		-1,
		173,
		175,
		201,
		204,
		210,
		204,
		177,
		192,
		182,
		173,
		182,
		262,
		-1,
		232,
		265,
		229,
		223,
		199,
		203,
		219,
		-1,
		195,
		177,
		-1,
		205,
		195,
		226,
		211,
		192,
		179,
		186,
		186,
		179,
		-1,
		-1,
		-1,
		234,
		233,
		225,
		219,
		219,
		204,
		195,
		-1,
		207,
		189,
		168,
		185,
		185,
		176,
		184,
		216,
		212,
		199,
		199,
		191,
		-1,
		335,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		228,
		223,
		196,
		184,
		190,
		186,
		172,
		178,
		180,
		188,
		186,
		183,
		195,
		191,
		211,
		192,
		227,
		-1,
		330,
		-1,
		264,
		-1,
		-1,
		246,
		226,
		218,
		207,
		196,
		194,
		185,
		176,
		198,
		214,
		198,
		196,
		199,
		200,
		-1,
		319,
		318,
		-1,
		265,
		257,
		243,
		-1,
		236,
		-1,
		242,
		203,
		-1,
		205,
		185,
		-1,
		207,
		203,
		-1,
		-1,
		306,
		281,
		-1,
		-1,
		-1,
		266,
		246,
		237,
		221,
		-1,
		196,
		196,
		-1,
		-1,
		-1,
		291,
		290,
		-1,
		259,
		262,
		-1,
		252,
		243,
		251,
		198,
		202,
		-1,
		-1,
		-1,
		300,
		281,
		275,
		274,
		272,
		267,
		264,
		250,
		234,
		212,
		201,
		222,
		-1,
		-1,
		-1,
		272,
		264,
		257,
		-1,
		-1,
		259,
		242,
		223,
		221,
		-1,
		-1,
		-1,
		294,
		275,
		-1,
		-1,
		249,
		-1,
		-1,
		255,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		283,
		-1,
		-1,
		-1,
		245,
		241,
		242,
		-1,
		-1,
		-1,
		-1,
		305,
		306,
		329,
		293,
		-1,
		-1,
		-1,
		237,
		231,
		-1,
		-1,
		308,
		306,
		-1,
		-1,
		-1,
		265,
		249,
		-1,
		235,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		270,
		-1,
		270,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		283,
		275,
		283,
		-1,
		255,
		257,
		-1,
		305,
		-1,
		-1,
		298,
		289,
		-1,
		-1,
		260,
		267,
		289,
		292,
		328,
		-1,
		279
	],
	[
		-1,
		119,
		108,
		119,
		127,
		100,
		107,
		-1,
		128,
		130,
		96,
		90,
		129,
		100,
		106,
		117,
		-1,
		-1,
		-1,
		119,
		118,
		88,
		86,
		95,
		100,
		107,
		-1,
		130,
		-1,
		140,
		119,
		130,
		135,
		81,
		78,
		98,
		117,
		123,
		115,
		155,
		111,
		82,
		76,
		94,
		99,
		117,
		109,
		-1,
		82,
		72,
		94,
		98,
		110,
		93,
		-1,
		-1,
		76,
		77,
		83,
		95,
		100,
		105,
		-1,
		131,
		137,
		-1,
		-1,
		66,
		79,
		75,
		78,
		86,
		102,
		123,
		137,
		132,
		-1,
		-1,
		67,
		71,
		84,
		85,
		83,
		110,
		129,
		127,
		141,
		140,
		-1,
		55,
		73,
		82,
		91,
		97,
		86,
		90,
		108,
		126,
		132,
		135,
		-1,
		64,
		65,
		64,
		72,
		77,
		84,
		89,
		95,
		114,
		114,
		133,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		63,
		47,
		64,
		56,
		52,
		65,
		82,
		90,
		98,
		102,
		106,
		122,
		123,
		133,
		-1,
		-1,
		157,
		130,
		154,
		112,
		88,
		-1,
		59,
		40,
		45,
		49,
		50,
		52,
		79,
		77,
		-1,
		100,
		99,
		130,
		116,
		127,
		139,
		-1,
		-1,
		115,
		107,
		89,
		92,
		69,
		65,
		37,
		36,
		31,
		30,
		26,
		55,
		67,
		65,
		75,
		94,
		104,
		108,
		123,
		134,
		-1,
		-1,
		199,
		-1,
		-1,
		136,
		119,
		-1,
		84,
		91,
		75,
		81,
		67,
		71,
		47,
		23,
		19,
		41,
		29,
		49,
		59,
		82,
		79,
		91,
		116,
		120,
		124,
		144,
		140,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		91,
		88,
		81,
		105,
		104,
		-1,
		41,
		29,
		27,
		9,
		16,
		29,
		35,
		65,
		65,
		80,
		82,
		98,
		100,
		133,
		121,
		143,
		140,
		169,
		174,
		168,
		177,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		109,
		-1,
		110,
		78,
		53,
		26,
		29,
		0,
		13,
		36,
		41,
		59,
		68,
		71,
		91,
		104,
		111,
		116,
		115,
		133,
		148,
		161,
		165,
		171,
		-1,
		194,
		-1,
		136,
		120,
		122,
		98,
		126,
		-1,
		129,
		111,
		70,
		55,
		55,
		-1,
		28,
		25,
		28,
		35,
		43,
		60,
		75,
		79,
		90,
		105,
		119,
		110,
		128,
		135,
		143,
		147,
		167,
		179,
		154,
		144,
		-1,
		126,
		131,
		101,
		113,
		136,
		127,
		91,
		-1,
		66,
		-1,
		30,
		43,
		-1,
		34,
		38,
		49,
		65,
		79,
		92,
		97,
		101,
		98,
		116,
		119,
		136,
		140,
		156,
		-1,
		-1,
		139,
		143,
		151,
		102,
		121,
		145,
		137,
		84,
		73,
		72,
		-1,
		48,
		65,
		62,
		63,
		69,
		62,
		63,
		85,
		98,
		81,
		100,
		103,
		125,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		128,
		99,
		123,
		151,
		102,
		95,
		83,
		87,
		85,
		72,
		-1,
		87,
		71,
		76,
		67,
		75,
		89,
		86,
		100,
		104,
		103,
		122,
		134,
		125,
		145,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		102,
		136,
		154,
		120,
		106,
		111,
		86,
		74,
		82,
		74,
		83,
		91,
		85,
		77,
		66,
		82,
		90,
		92,
		101,
		110,
		116,
		140,
		147,
		153,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		127,
		134,
		166,
		111,
		168,
		-1,
		115,
		-1,
		88,
		106,
		90,
		85,
		82,
		79,
		73,
		82,
		96,
		107,
		103,
		110,
		145,
		145,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		158,
		175,
		150,
		127,
		108,
		144,
		-1,
		138,
		139,
		-1,
		109,
		103,
		107,
		92,
		88,
		83,
		87,
		80,
		87,
		83,
		97,
		108,
		95,
		131,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		115,
		167,
		-1,
		-1,
		123,
		116,
		-1,
		103,
		85,
		92,
		90,
		84,
		88,
		92,
		81,
		94,
		99,
		100,
		110,
		130,
		134,
		138,
		127,
		123,
		120,
		134,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		135,
		-1,
		132,
		124,
		114,
		108,
		102,
		98,
		96,
		112,
		96,
		99,
		99,
		95,
		103,
		88,
		91,
		103,
		107,
		125,
		133,
		125,
		119,
		118,
		130,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		150,
		-1,
		117,
		131,
		147,
		-1,
		140,
		119,
		134,
		112,
		108,
		104,
		119,
		120,
		98,
		103,
		102,
		112,
		113,
		102,
		115,
		107,
		129,
		129,
		113,
		114,
		123,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		114,
		102,
		134,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		118,
		116,
		109,
		100,
		106,
		113,
		116,
		117,
		107,
		96,
		102,
		101,
		123,
		109,
		107,
		126,
		142,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		117,
		101,
		106,
		-1,
		142,
		-1,
		115,
		117,
		109,
		98,
		95,
		106,
		104,
		115,
		132,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		171,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		133,
		113,
		107,
		106,
		137,
		135,
		123,
		107,
		100,
		97,
		98,
		111,
		131,
		122,
		134,
		-1,
		-1,
		-1,
		168,
		154,
		158,
		118,
		137,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		150,
		138,
		128,
		118,
		152,
		151,
		126,
		119,
		105,
		107,
		105,
		107,
		112,
		133,
		134,
		147,
		-1,
		-1,
		151,
		156,
		144,
		130,
		149,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		139,
		-1,
		-1,
		130,
		128,
		138,
		122,
		109,
		129,
		132,
		122,
		106,
		121,
		133,
		141,
		146,
		-1,
		154,
		141,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		161,
		163,
		167,
		133,
		-1,
		138,
		133,
		113,
		127,
		134,
		124,
		119,
		113,
		116,
		134,
		151,
		-1,
		-1,
		166,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		140,
		154,
		156,
		149,
		153,
		-1,
		141,
		129,
		115,
		132,
		137,
		134,
		125,
		117,
		122,
		119,
		132,
		146,
		150,
		189,
		-1,
		172,
		-1,
		-1,
		-1,
		158,
		173,
		195,
		172,
		145,
		140,
		133,
		127,
		123,
		139,
		145,
		156,
		124,
		120,
		121,
		125,
		124,
		141,
		151,
		-1,
		-1,
		172,
		189,
		184,
		166,
		170,
		222,
		-1,
		-1,
		149,
		140,
		131,
		134,
		133,
		136,
		130,
		127,
		132,
		137,
		125,
		134,
		152,
		151,
		-1,
		-1,
		-1,
		192,
		-1,
		207,
		-1,
		-1,
		185,
		220,
		167,
		149,
		145,
		143,
		136,
		145,
		140,
		135,
		145,
		147,
		139,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		221,
		196,
		211,
		231,
		205,
		212,
		182,
		179,
		-1,
		149,
		174,
		146,
		153,
		144,
		151,
		151,
		143,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		304,
		293,
		282,
		288,
		-1,
		227,
		213,
		217,
		207,
		210,
		-1,
		-1,
		198,
		195,
		171,
		154,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		199,
		280,
		273,
		256,
		264,
		295,
		-1,
		221,
		213,
		220,
		199,
		201,
		-1,
		-1,
		171,
		168,
		173,
		161,
		158,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		213,
		256,
		250,
		253,
		277,
		291,
		-1,
		218,
		-1,
		-1,
		228,
		202,
		186,
		176,
		170,
		220,
		175,
		170,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		248,
		236,
		244,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		244,
		-1,
		213,
		-1,
		188,
		192,
		183,
		186,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		289,
		245,
		244,
		235,
		270,
		285,
		289,
		-1,
		230,
		269,
		267,
		-1,
		251,
		-1,
		-1,
		-1,
		202,
		196,
		188,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		285,
		276,
		289,
		234,
		234,
		255,
		264,
		285,
		245,
		236,
		263,
		274,
		263,
		258,
		245,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		225,
		252,
		-1,
		-1,
		247,
		264,
		258,
		262,
		278,
		303,
		-1,
		234,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		262,
		259,
		247,
		245,
		268,
		233,
		221,
		-1,
		234,
		232,
		238,
		245,
		262,
		292,
		-1,
		-1,
		250,
		230,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		219,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		236,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		305,
		-1,
		257,
		233,
		247,
		262,
		270,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		245,
		248,
		-1,
		-1,
		247,
		249,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		252,
		253,
		254,
		-1,
		232,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		329,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		127,
		116,
		127,
		135,
		108,
		115,
		-1,
		136,
		138,
		104,
		98,
		137,
		108,
		114,
		125,
		-1,
		-1,
		-1,
		127,
		126,
		96,
		94,
		103,
		108,
		115,
		-1,
		138,
		-1,
		148,
		127,
		138,
		143,
		89,
		86,
		106,
		125,
		131,
		123,
		163,
		119,
		90,
		84,
		102,
		107,
		125,
		117,
		-1,
		90,
		80,
		102,
		106,
		118,
		101,
		-1,
		-1,
		84,
		85,
		91,
		103,
		108,
		113,
		-1,
		139,
		128,
		-1,
		-1,
		74,
		87,
		83,
		86,
		94,
		110,
		131,
		128,
		123,
		-1,
		-1,
		75,
		79,
		92,
		93,
		91,
		118,
		136,
		118,
		132,
		131,
		-1,
		63,
		81,
		90,
		99,
		105,
		94,
		97,
		115,
		117,
		123,
		126,
		-1,
		72,
		73,
		72,
		80,
		85,
		92,
		97,
		102,
		112,
		105,
		124,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		71,
		55,
		72,
		64,
		60,
		73,
		90,
		97,
		102,
		100,
		97,
		113,
		114,
		124,
		-1,
		-1,
		165,
		138,
		162,
		120,
		96,
		-1,
		67,
		48,
		53,
		57,
		58,
		60,
		87,
		84,
		-1,
		91,
		90,
		121,
		107,
		118,
		147,
		-1,
		-1,
		123,
		115,
		97,
		100,
		77,
		73,
		45,
		44,
		39,
		38,
		34,
		63,
		74,
		73,
		80,
		85,
		95,
		99,
		114,
		125,
		-1,
		-1,
		189,
		-1,
		-1,
		144,
		127,
		-1,
		92,
		99,
		83,
		89,
		75,
		73,
		55,
		31,
		27,
		49,
		37,
		57,
		66,
		79,
		70,
		82,
		107,
		111,
		114,
		135,
		130,
		-1,
		188,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		99,
		96,
		89,
		113,
		112,
		-1,
		43,
		31,
		28,
		17,
		18,
		31,
		43,
		54,
		58,
		71,
		73,
		89,
		91,
		124,
		111,
		133,
		130,
		159,
		164,
		158,
		167,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		117,
		-1,
		112,
		80,
		55,
		28,
		31,
		13,
		0,
		38,
		41,
		48,
		61,
		62,
		82,
		95,
		102,
		106,
		105,
		123,
		138,
		151,
		155,
		161,
		-1,
		202,
		-1,
		144,
		128,
		130,
		106,
		134,
		-1,
		137,
		113,
		72,
		57,
		57,
		-1,
		18,
		15,
		15,
		22,
		33,
		50,
		66,
		70,
		81,
		95,
		109,
		100,
		118,
		125,
		133,
		137,
		157,
		169,
		162,
		152,
		-1,
		134,
		139,
		109,
		121,
		144,
		129,
		93,
		-1,
		68,
		-1,
		20,
		33,
		-1,
		21,
		25,
		39,
		55,
		69,
		82,
		88,
		91,
		88,
		106,
		109,
		126,
		130,
		146,
		-1,
		-1,
		147,
		151,
		159,
		110,
		129,
		153,
		139,
		86,
		75,
		74,
		-1,
		38,
		52,
		49,
		50,
		57,
		52,
		53,
		75,
		89,
		71,
		90,
		93,
		115,
		143,
		121,
		133,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		136,
		107,
		131,
		153,
		104,
		97,
		85,
		77,
		75,
		62,
		-1,
		74,
		58,
		66,
		57,
		65,
		78,
		76,
		90,
		94,
		93,
		112,
		124,
		115,
		135,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		110,
		143,
		162,
		110,
		96,
		101,
		76,
		64,
		72,
		61,
		70,
		79,
		75,
		67,
		56,
		72,
		80,
		82,
		91,
		100,
		106,
		130,
		137,
		143,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		134,
		141,
		173,
		101,
		158,
		-1,
		105,
		-1,
		78,
		96,
		80,
		75,
		72,
		69,
		63,
		72,
		86,
		97,
		93,
		100,
		135,
		135,
		127,
		147,
		150,
		-1,
		-1,
		-1,
		166,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		99,
		93,
		97,
		82,
		78,
		73,
		77,
		70,
		77,
		73,
		87,
		98,
		85,
		121,
		-1,
		135,
		129,
		137,
		127,
		115,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		82,
		80,
		74,
		78,
		82,
		71,
		84,
		89,
		90,
		100,
		120,
		124,
		128,
		117,
		113,
		110,
		124,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		102,
		86,
		89,
		89,
		85,
		93,
		78,
		81,
		93,
		97,
		115,
		123,
		115,
		109,
		108,
		120,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		94,
		109,
		110,
		88,
		93,
		92,
		102,
		103,
		92,
		105,
		97,
		119,
		119,
		103,
		104,
		113,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		108,
		106,
		99,
		90,
		96,
		103,
		106,
		107,
		97,
		86,
		92,
		91,
		113,
		99,
		97,
		116,
		132,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		107,
		91,
		96,
		-1,
		132,
		-1,
		105,
		107,
		99,
		88,
		85,
		96,
		94,
		105,
		122,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		123,
		103,
		97,
		96,
		127,
		125,
		113,
		97,
		90,
		87,
		88,
		101,
		121,
		112,
		124,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		140,
		128,
		118,
		108,
		142,
		141,
		116,
		109,
		95,
		97,
		95,
		97,
		102,
		123,
		124,
		137,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		129,
		-1,
		-1,
		120,
		118,
		128,
		112,
		99,
		119,
		122,
		112,
		96,
		111,
		123,
		131,
		136,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		151,
		153,
		157,
		123,
		-1,
		128,
		123,
		103,
		117,
		124,
		114,
		109,
		103,
		106,
		124,
		141,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		130,
		144,
		146,
		139,
		143,
		-1,
		131,
		119,
		105,
		122,
		127,
		124,
		115,
		107,
		112,
		109,
		122,
		136,
		140,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		148,
		163,
		185,
		162,
		135,
		130,
		123,
		117,
		113,
		129,
		135,
		146,
		114,
		110,
		111,
		115,
		114,
		131,
		141,
		-1,
		-1,
		162,
		179,
		174,
		156,
		160,
		212,
		-1,
		-1,
		139,
		130,
		121,
		124,
		123,
		126,
		120,
		117,
		122,
		127,
		115,
		124,
		142,
		141,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		175,
		210,
		157,
		139,
		135,
		133,
		126,
		135,
		130,
		125,
		135,
		137,
		129,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		211,
		186,
		201,
		221,
		195,
		202,
		172,
		169,
		-1,
		139,
		164,
		136,
		143,
		134,
		141,
		141,
		133,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		294,
		283,
		272,
		278,
		-1,
		217,
		203,
		207,
		197,
		200,
		-1,
		-1,
		188,
		185,
		161,
		144,
		142,
		135,
		130,
		140,
		120,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		189,
		270,
		263,
		246,
		254,
		285,
		-1,
		211,
		203,
		210,
		189,
		191,
		-1,
		-1,
		161,
		158,
		163,
		151,
		148,
		150,
		145,
		136,
		121,
		127,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		203,
		246,
		240,
		243,
		267,
		281,
		-1,
		208,
		-1,
		-1,
		218,
		192,
		176,
		166,
		160,
		210,
		165,
		160,
		144,
		142,
		133,
		124,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		238,
		226,
		234,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		234,
		-1,
		203,
		-1,
		178,
		182,
		173,
		176,
		158,
		145,
		137,
		129,
		145,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		279,
		235,
		234,
		225,
		260,
		275,
		279,
		-1,
		220,
		259,
		257,
		-1,
		241,
		-1,
		-1,
		-1,
		192,
		186,
		178,
		178,
		157,
		157,
		131,
		135,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		275,
		266,
		279,
		224,
		224,
		245,
		254,
		275,
		235,
		226,
		253,
		264,
		253,
		248,
		235,
		-1,
		-1,
		215,
		196,
		-1,
		-1,
		164,
		152,
		135,
		136,
		132,
		135,
		150,
		153,
		143,
		141,
		135,
		167,
		-1,
		268,
		267,
		256,
		253,
		229,
		220,
		215,
		242,
		-1,
		-1,
		237,
		254,
		248,
		252,
		268,
		293,
		-1,
		224,
		-1,
		-1,
		209,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		140,
		151,
		161,
		149,
		150,
		140,
		150,
		163,
		252,
		249,
		237,
		235,
		258,
		223,
		211,
		-1,
		224,
		222,
		228,
		235,
		252,
		282,
		-1,
		-1,
		240,
		220,
		-1,
		-1,
		192,
		190,
		179,
		-1,
		169,
		142,
		147,
		167,
		169,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		261,
		275,
		264,
		260,
		259,
		267,
		216,
		209,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		226,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		160,
		164,
		156,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		295,
		-1,
		247,
		223,
		237,
		252,
		260,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		235,
		238,
		-1,
		-1,
		237,
		239,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		242,
		243,
		244,
		-1,
		222,
		-1,
		240,
		-1,
		207,
		213,
		201,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		183,
		181,
		172,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		240,
		214,
		247,
		238,
		221,
		201,
		193,
		212,
		-1,
		182,
		-1,
		157,
		159,
		185,
		188,
		194,
		188,
		161,
		176,
		166,
		157,
		166,
		246,
		-1,
		216,
		249,
		213,
		207,
		183,
		187,
		203,
		-1,
		179,
		161,
		-1,
		189,
		179,
		210,
		195,
		176,
		163,
		170,
		170,
		163,
		-1,
		-1,
		-1,
		218,
		217,
		209,
		203,
		203,
		188,
		179,
		-1,
		191,
		173,
		152,
		169,
		169,
		160,
		168,
		200,
		196,
		183,
		183,
		175,
		-1,
		319,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		212,
		207,
		180,
		168,
		174,
		170,
		156,
		162,
		164,
		172,
		170,
		167,
		179,
		175,
		195,
		176,
		211,
		-1,
		314,
		-1,
		248,
		-1,
		-1,
		230,
		210,
		202,
		191,
		180,
		178,
		169,
		160,
		182,
		198,
		182,
		180,
		183,
		184,
		-1,
		303,
		302,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		226,
		187,
		-1,
		189,
		169,
		-1,
		191,
		187,
		-1,
		-1,
		290,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		221,
		205,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		275,
		274,
		-1,
		243,
		246,
		-1,
		236,
		227,
		235,
		182,
		186,
		-1,
		-1,
		-1,
		284,
		265,
		259,
		258,
		256,
		251,
		248,
		234,
		218,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		256,
		248,
		241,
		-1,
		-1,
		243,
		226,
		207,
		205,
		-1,
		-1,
		-1,
		278,
		259,
		-1,
		-1,
		233,
		-1,
		-1,
		239,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		267,
		-1,
		-1,
		-1,
		229,
		225,
		226,
		-1,
		-1,
		-1,
		-1,
		289,
		290,
		313,
		277,
		-1,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		292,
		290,
		-1,
		-1,
		-1,
		249,
		233,
		-1,
		219,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		254,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		267,
		259,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		282,
		273,
		-1,
		-1,
		244,
		251,
		273,
		276,
		312,
		-1,
		263
	],
	[
		-1,
		129,
		118,
		129,
		137,
		110,
		117,
		-1,
		138,
		140,
		106,
		100,
		139,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		129,
		128,
		98,
		96,
		105,
		110,
		117,
		-1,
		140,
		-1,
		150,
		129,
		140,
		145,
		91,
		88,
		108,
		127,
		133,
		125,
		165,
		121,
		92,
		86,
		104,
		109,
		127,
		119,
		-1,
		92,
		82,
		104,
		108,
		120,
		103,
		-1,
		-1,
		86,
		87,
		93,
		105,
		110,
		115,
		-1,
		132,
		116,
		-1,
		-1,
		76,
		89,
		85,
		88,
		96,
		111,
		124,
		116,
		111,
		-1,
		-1,
		77,
		81,
		94,
		95,
		93,
		111,
		124,
		106,
		120,
		119,
		-1,
		65,
		83,
		92,
		101,
		103,
		87,
		85,
		103,
		105,
		111,
		114,
		-1,
		74,
		75,
		71,
		79,
		84,
		91,
		89,
		90,
		100,
		93,
		112,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		74,
		57,
		74,
		67,
		59,
		72,
		79,
		85,
		90,
		88,
		85,
		101,
		102,
		112,
		-1,
		-1,
		168,
		141,
		165,
		123,
		104,
		-1,
		70,
		50,
		56,
		60,
		57,
		59,
		76,
		72,
		-1,
		79,
		78,
		109,
		95,
		106,
		150,
		-1,
		-1,
		126,
		118,
		100,
		103,
		80,
		76,
		65,
		64,
		51,
		40,
		36,
		59,
		62,
		62,
		68,
		73,
		83,
		87,
		102,
		113,
		-1,
		-1,
		177,
		-1,
		-1,
		147,
		130,
		-1,
		95,
		102,
		86,
		92,
		78,
		99,
		75,
		53,
		49,
		38,
		30,
		51,
		54,
		67,
		58,
		70,
		95,
		99,
		102,
		123,
		118,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		102,
		99,
		92,
		116,
		115,
		-1,
		71,
		59,
		57,
		39,
		24,
		7,
		33,
		42,
		46,
		59,
		61,
		77,
		79,
		112,
		99,
		121,
		118,
		147,
		152,
		146,
		155,
		-1,
		155,
		151,
		147,
		154,
		103,
		-1,
		-1,
		120,
		-1,
		123,
		108,
		83,
		56,
		59,
		35,
		37,
		0,
		29,
		36,
		49,
		50,
		70,
		83,
		90,
		94,
		93,
		111,
		126,
		139,
		143,
		149,
		-1,
		205,
		-1,
		147,
		131,
		133,
		109,
		137,
		-1,
		140,
		124,
		100,
		85,
		85,
		-1,
		55,
		52,
		52,
		31,
		21,
		38,
		54,
		58,
		69,
		83,
		97,
		88,
		106,
		113,
		121,
		125,
		145,
		157,
		165,
		155,
		-1,
		137,
		142,
		112,
		124,
		147,
		157,
		121,
		-1,
		96,
		-1,
		57,
		70,
		-1,
		37,
		33,
		27,
		43,
		57,
		70,
		76,
		79,
		76,
		94,
		97,
		114,
		118,
		134,
		-1,
		-1,
		150,
		154,
		162,
		113,
		132,
		156,
		167,
		114,
		103,
		102,
		-1,
		75,
		60,
		57,
		58,
		45,
		40,
		41,
		63,
		77,
		59,
		78,
		81,
		103,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		139,
		110,
		134,
		176,
		132,
		125,
		113,
		109,
		109,
		99,
		-1,
		76,
		55,
		54,
		45,
		53,
		66,
		64,
		78,
		82,
		81,
		100,
		112,
		103,
		123,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		108,
		131,
		165,
		142,
		128,
		133,
		108,
		101,
		95,
		69,
		72,
		67,
		63,
		55,
		44,
		60,
		68,
		70,
		79,
		88,
		94,
		118,
		125,
		131,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		122,
		129,
		161,
		133,
		146,
		-1,
		100,
		-1,
		89,
		84,
		68,
		63,
		60,
		57,
		51,
		60,
		74,
		85,
		81,
		88,
		123,
		123,
		115,
		135,
		138,
		-1,
		-1,
		-1,
		169,
		167,
		142,
		119,
		103,
		139,
		-1,
		116,
		117,
		-1,
		94,
		88,
		85,
		70,
		66,
		61,
		65,
		58,
		65,
		61,
		75,
		86,
		73,
		109,
		-1,
		123,
		117,
		125,
		115,
		103,
		-1,
		-1,
		-1,
		165,
		144,
		137,
		157,
		98,
		150,
		-1,
		-1,
		101,
		94,
		-1,
		81,
		63,
		70,
		68,
		62,
		66,
		70,
		59,
		72,
		77,
		78,
		88,
		108,
		112,
		116,
		105,
		101,
		98,
		112,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		118,
		-1,
		110,
		102,
		92,
		86,
		80,
		76,
		74,
		90,
		74,
		77,
		77,
		73,
		81,
		66,
		69,
		81,
		85,
		103,
		111,
		103,
		97,
		96,
		108,
		-1,
		185,
		171,
		142,
		-1,
		-1,
		131,
		-1,
		95,
		109,
		125,
		-1,
		118,
		97,
		112,
		90,
		86,
		82,
		97,
		98,
		76,
		81,
		80,
		90,
		91,
		80,
		93,
		85,
		107,
		107,
		91,
		92,
		101,
		-1,
		191,
		178,
		136,
		132,
		121,
		141,
		92,
		80,
		112,
		-1,
		-1,
		154,
		-1,
		88,
		105,
		96,
		94,
		87,
		78,
		84,
		91,
		94,
		95,
		85,
		74,
		80,
		79,
		101,
		87,
		85,
		104,
		120,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		107,
		94,
		88,
		-1,
		129,
		-1,
		132,
		122,
		106,
		91,
		124,
		-1,
		95,
		79,
		84,
		-1,
		120,
		-1,
		93,
		95,
		87,
		76,
		73,
		84,
		82,
		93,
		110,
		-1,
		141,
		126,
		119,
		109,
		123,
		94,
		-1,
		149,
		-1,
		-1,
		119,
		113,
		113,
		97,
		100,
		111,
		91,
		85,
		84,
		115,
		113,
		101,
		85,
		78,
		75,
		76,
		89,
		109,
		100,
		112,
		-1,
		-1,
		-1,
		146,
		132,
		136,
		96,
		115,
		-1,
		-1,
		181,
		136,
		122,
		-1,
		106,
		128,
		116,
		106,
		96,
		130,
		129,
		104,
		97,
		83,
		85,
		83,
		85,
		90,
		111,
		112,
		125,
		-1,
		-1,
		129,
		134,
		122,
		108,
		127,
		-1,
		-1,
		-1,
		128,
		144,
		136,
		107,
		117,
		-1,
		-1,
		108,
		106,
		116,
		100,
		87,
		107,
		110,
		100,
		84,
		99,
		111,
		119,
		124,
		-1,
		132,
		119,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		-1,
		-1,
		161,
		127,
		139,
		141,
		145,
		111,
		-1,
		116,
		111,
		91,
		105,
		112,
		102,
		97,
		91,
		94,
		112,
		129,
		-1,
		-1,
		144,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		118,
		132,
		134,
		127,
		131,
		-1,
		119,
		107,
		93,
		110,
		115,
		112,
		103,
		95,
		100,
		97,
		110,
		124,
		128,
		167,
		-1,
		150,
		-1,
		-1,
		-1,
		136,
		151,
		173,
		150,
		123,
		118,
		111,
		105,
		101,
		117,
		123,
		134,
		102,
		98,
		99,
		103,
		102,
		119,
		129,
		-1,
		-1,
		150,
		167,
		162,
		144,
		148,
		200,
		-1,
		-1,
		127,
		118,
		109,
		112,
		111,
		114,
		108,
		105,
		110,
		115,
		103,
		112,
		130,
		129,
		-1,
		-1,
		-1,
		170,
		-1,
		185,
		-1,
		-1,
		163,
		198,
		145,
		127,
		123,
		121,
		114,
		123,
		118,
		113,
		123,
		125,
		117,
		105,
		109,
		132,
		121,
		160,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		199,
		174,
		189,
		209,
		183,
		190,
		160,
		157,
		-1,
		127,
		152,
		124,
		131,
		122,
		129,
		129,
		121,
		99,
		106,
		122,
		121,
		116,
		152,
		143,
		149,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		205,
		191,
		195,
		185,
		188,
		-1,
		-1,
		176,
		173,
		149,
		132,
		130,
		123,
		118,
		128,
		108,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		140,
		155,
		-1,
		177,
		258,
		251,
		234,
		242,
		273,
		-1,
		199,
		191,
		198,
		177,
		179,
		-1,
		-1,
		149,
		146,
		151,
		139,
		136,
		138,
		133,
		124,
		109,
		115,
		102,
		101,
		119,
		123,
		132,
		139,
		129,
		142,
		146,
		-1,
		191,
		234,
		228,
		231,
		255,
		269,
		-1,
		196,
		-1,
		-1,
		206,
		180,
		164,
		154,
		148,
		198,
		153,
		148,
		132,
		130,
		121,
		112,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		139,
		139,
		140,
		-1,
		226,
		214,
		222,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		222,
		-1,
		191,
		-1,
		166,
		170,
		161,
		164,
		146,
		133,
		125,
		117,
		133,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		146,
		147,
		267,
		223,
		222,
		213,
		248,
		263,
		267,
		-1,
		208,
		247,
		245,
		-1,
		229,
		-1,
		-1,
		-1,
		180,
		174,
		166,
		166,
		145,
		145,
		119,
		123,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		155,
		263,
		254,
		267,
		212,
		212,
		233,
		242,
		263,
		223,
		214,
		241,
		252,
		241,
		236,
		223,
		-1,
		-1,
		203,
		184,
		-1,
		-1,
		152,
		140,
		123,
		124,
		120,
		123,
		138,
		141,
		131,
		129,
		123,
		155,
		-1,
		256,
		255,
		244,
		241,
		217,
		208,
		203,
		230,
		-1,
		-1,
		225,
		242,
		236,
		240,
		256,
		281,
		-1,
		212,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		128,
		139,
		149,
		137,
		138,
		128,
		138,
		151,
		240,
		237,
		225,
		223,
		246,
		211,
		199,
		-1,
		212,
		210,
		216,
		223,
		240,
		270,
		-1,
		-1,
		228,
		208,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		130,
		135,
		155,
		157,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		249,
		263,
		252,
		248,
		247,
		255,
		204,
		197,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		218,
		214,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		148,
		152,
		144,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		283,
		-1,
		235,
		211,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		235,
		221,
		214,
		202,
		200,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		223,
		226,
		-1,
		-1,
		225,
		227,
		-1,
		226,
		215,
		200,
		192,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		230,
		231,
		232,
		-1,
		210,
		-1,
		228,
		-1,
		195,
		201,
		189,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		171,
		169,
		160,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		228,
		202,
		235,
		226,
		209,
		189,
		181,
		200,
		-1,
		170,
		-1,
		145,
		147,
		173,
		176,
		182,
		176,
		149,
		164,
		154,
		145,
		154,
		234,
		-1,
		204,
		237,
		201,
		195,
		171,
		175,
		191,
		-1,
		167,
		149,
		-1,
		177,
		167,
		198,
		183,
		164,
		151,
		158,
		158,
		151,
		-1,
		-1,
		-1,
		206,
		205,
		197,
		191,
		191,
		176,
		167,
		-1,
		179,
		161,
		140,
		157,
		157,
		148,
		156,
		188,
		184,
		171,
		171,
		163,
		-1,
		307,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		200,
		195,
		168,
		156,
		162,
		158,
		144,
		150,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		164,
		199,
		-1,
		302,
		-1,
		236,
		-1,
		-1,
		218,
		198,
		190,
		179,
		168,
		166,
		157,
		148,
		170,
		186,
		170,
		168,
		171,
		172,
		-1,
		291,
		290,
		-1,
		237,
		229,
		215,
		-1,
		208,
		-1,
		214,
		175,
		-1,
		177,
		157,
		-1,
		179,
		175,
		-1,
		-1,
		278,
		253,
		-1,
		-1,
		-1,
		238,
		218,
		209,
		193,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		263,
		262,
		-1,
		231,
		234,
		-1,
		224,
		215,
		223,
		170,
		174,
		-1,
		-1,
		-1,
		272,
		253,
		247,
		246,
		244,
		239,
		236,
		222,
		206,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		244,
		236,
		229,
		-1,
		-1,
		231,
		214,
		195,
		193,
		-1,
		-1,
		-1,
		266,
		247,
		-1,
		-1,
		221,
		-1,
		-1,
		227,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		255,
		-1,
		-1,
		-1,
		217,
		213,
		214,
		-1,
		-1,
		-1,
		-1,
		277,
		278,
		301,
		265,
		-1,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		280,
		278,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		207,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		242,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		255,
		247,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		270,
		261,
		-1,
		-1,
		232,
		239,
		261,
		264,
		300,
		-1,
		251
	],
	[
		-1,
		110,
		99,
		110,
		118,
		91,
		98,
		-1,
		119,
		121,
		87,
		81,
		120,
		91,
		97,
		108,
		-1,
		-1,
		-1,
		110,
		109,
		79,
		77,
		86,
		91,
		98,
		-1,
		121,
		-1,
		131,
		110,
		121,
		126,
		72,
		69,
		89,
		108,
		114,
		106,
		146,
		102,
		73,
		67,
		85,
		90,
		108,
		100,
		-1,
		73,
		63,
		85,
		89,
		101,
		84,
		-1,
		-1,
		67,
		68,
		74,
		86,
		91,
		96,
		-1,
		118,
		103,
		-1,
		-1,
		57,
		70,
		66,
		69,
		77,
		93,
		110,
		103,
		98,
		-1,
		-1,
		58,
		62,
		75,
		76,
		74,
		97,
		111,
		93,
		107,
		106,
		-1,
		46,
		64,
		73,
		82,
		88,
		73,
		72,
		90,
		92,
		98,
		101,
		-1,
		55,
		56,
		55,
		63,
		68,
		75,
		69,
		77,
		87,
		80,
		99,
		90,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		55,
		38,
		55,
		50,
		43,
		56,
		57,
		65,
		77,
		75,
		72,
		88,
		89,
		99,
		-1,
		-1,
		149,
		122,
		146,
		104,
		85,
		-1,
		51,
		31,
		37,
		41,
		41,
		42,
		54,
		52,
		-1,
		66,
		65,
		96,
		82,
		93,
		131,
		-1,
		-1,
		107,
		99,
		81,
		84,
		61,
		57,
		46,
		45,
		35,
		21,
		17,
		39,
		42,
		40,
		50,
		60,
		70,
		74,
		89,
		100,
		-1,
		-1,
		166,
		-1,
		-1,
		128,
		111,
		-1,
		76,
		83,
		67,
		73,
		59,
		80,
		56,
		45,
		37,
		23,
		11,
		24,
		34,
		52,
		43,
		57,
		82,
		86,
		91,
		110,
		107,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		83,
		80,
		73,
		97,
		96,
		-1,
		66,
		54,
		55,
		40,
		37,
		27,
		4,
		24,
		31,
		44,
		46,
		64,
		66,
		99,
		88,
		110,
		107,
		136,
		141,
		135,
		144,
		-1,
		136,
		132,
		128,
		135,
		84,
		-1,
		-1,
		101,
		-1,
		104,
		103,
		78,
		51,
		54,
		41,
		42,
		22,
		0,
		18,
		34,
		37,
		57,
		70,
		77,
		83,
		82,
		100,
		115,
		128,
		132,
		138,
		-1,
		186,
		-1,
		128,
		112,
		114,
		90,
		118,
		-1,
		121,
		105,
		95,
		80,
		80,
		-1,
		57,
		54,
		47,
		25,
		10,
		27,
		41,
		45,
		56,
		72,
		86,
		77,
		95,
		102,
		110,
		114,
		134,
		146,
		146,
		136,
		-1,
		118,
		123,
		93,
		105,
		128,
		148,
		116,
		-1,
		91,
		-1,
		59,
		72,
		-1,
		31,
		27,
		16,
		32,
		46,
		59,
		63,
		68,
		65,
		83,
		86,
		103,
		107,
		123,
		-1,
		-1,
		131,
		135,
		143,
		94,
		113,
		137,
		162,
		109,
		98,
		97,
		-1,
		77,
		52,
		49,
		50,
		36,
		29,
		30,
		52,
		64,
		48,
		67,
		70,
		92,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		120,
		91,
		115,
		157,
		127,
		120,
		108,
		98,
		98,
		92,
		-1,
		67,
		46,
		43,
		34,
		42,
		56,
		53,
		67,
		71,
		70,
		89,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		150,
		139,
		140,
		94,
		120,
		146,
		131,
		117,
		122,
		97,
		90,
		84,
		61,
		63,
		58,
		52,
		44,
		33,
		49,
		57,
		59,
		68,
		77,
		83,
		107,
		114,
		120,
		-1,
		-1,
		157,
		147,
		131,
		133,
		130,
		111,
		118,
		150,
		122,
		135,
		-1,
		89,
		-1,
		78,
		73,
		57,
		52,
		49,
		46,
		40,
		49,
		63,
		74,
		70,
		77,
		112,
		112,
		104,
		124,
		127,
		-1,
		-1,
		-1,
		150,
		156,
		131,
		108,
		92,
		128,
		-1,
		105,
		106,
		-1,
		83,
		77,
		74,
		59,
		55,
		50,
		54,
		47,
		54,
		50,
		64,
		75,
		62,
		98,
		-1,
		112,
		106,
		114,
		104,
		92,
		-1,
		-1,
		-1,
		154,
		133,
		126,
		146,
		87,
		139,
		-1,
		-1,
		90,
		83,
		-1,
		70,
		52,
		59,
		57,
		51,
		55,
		59,
		48,
		61,
		66,
		67,
		77,
		97,
		101,
		105,
		94,
		90,
		87,
		101,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		107,
		-1,
		99,
		91,
		81,
		75,
		69,
		65,
		63,
		79,
		63,
		66,
		66,
		62,
		70,
		55,
		58,
		70,
		74,
		92,
		100,
		92,
		86,
		85,
		97,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		120,
		-1,
		84,
		98,
		114,
		-1,
		107,
		86,
		101,
		79,
		75,
		71,
		86,
		87,
		65,
		70,
		69,
		79,
		80,
		69,
		82,
		74,
		96,
		96,
		80,
		81,
		90,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		81,
		69,
		101,
		-1,
		-1,
		143,
		-1,
		77,
		94,
		85,
		83,
		76,
		67,
		73,
		80,
		83,
		84,
		74,
		63,
		69,
		68,
		90,
		76,
		74,
		93,
		109,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		121,
		111,
		95,
		80,
		113,
		-1,
		84,
		68,
		73,
		-1,
		109,
		-1,
		82,
		84,
		76,
		65,
		62,
		73,
		71,
		82,
		99,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		138,
		-1,
		-1,
		108,
		102,
		102,
		86,
		89,
		100,
		80,
		74,
		73,
		104,
		102,
		90,
		74,
		67,
		64,
		65,
		78,
		98,
		89,
		101,
		-1,
		-1,
		-1,
		135,
		121,
		125,
		85,
		104,
		-1,
		-1,
		170,
		125,
		111,
		-1,
		95,
		117,
		105,
		95,
		85,
		119,
		118,
		93,
		86,
		72,
		74,
		72,
		74,
		79,
		100,
		101,
		114,
		-1,
		-1,
		118,
		123,
		111,
		97,
		116,
		-1,
		-1,
		-1,
		117,
		133,
		125,
		96,
		106,
		-1,
		-1,
		97,
		95,
		105,
		89,
		76,
		96,
		99,
		89,
		73,
		88,
		100,
		108,
		113,
		-1,
		121,
		108,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		128,
		130,
		134,
		100,
		-1,
		105,
		100,
		80,
		94,
		101,
		91,
		86,
		80,
		83,
		101,
		118,
		-1,
		-1,
		133,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		107,
		121,
		123,
		116,
		120,
		-1,
		108,
		96,
		82,
		99,
		104,
		101,
		92,
		84,
		89,
		86,
		99,
		113,
		117,
		156,
		-1,
		139,
		-1,
		-1,
		-1,
		125,
		140,
		162,
		139,
		112,
		107,
		100,
		94,
		90,
		106,
		112,
		123,
		91,
		87,
		88,
		92,
		91,
		108,
		118,
		-1,
		-1,
		139,
		156,
		151,
		133,
		137,
		189,
		-1,
		-1,
		116,
		107,
		98,
		101,
		100,
		103,
		97,
		94,
		99,
		104,
		92,
		101,
		119,
		118,
		-1,
		-1,
		-1,
		159,
		-1,
		174,
		-1,
		-1,
		152,
		187,
		134,
		116,
		112,
		110,
		103,
		112,
		107,
		102,
		112,
		114,
		106,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		188,
		163,
		178,
		198,
		172,
		179,
		149,
		146,
		-1,
		116,
		141,
		113,
		120,
		111,
		118,
		118,
		110,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		194,
		180,
		184,
		174,
		177,
		-1,
		-1,
		165,
		162,
		138,
		121,
		119,
		112,
		107,
		117,
		97,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		166,
		247,
		240,
		223,
		231,
		262,
		-1,
		188,
		180,
		187,
		166,
		168,
		-1,
		-1,
		138,
		135,
		140,
		128,
		125,
		127,
		122,
		113,
		98,
		104,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		180,
		223,
		217,
		220,
		244,
		258,
		-1,
		185,
		-1,
		-1,
		195,
		169,
		153,
		143,
		137,
		187,
		142,
		137,
		121,
		119,
		110,
		101,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		215,
		203,
		211,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		211,
		-1,
		180,
		-1,
		155,
		159,
		150,
		153,
		135,
		122,
		114,
		106,
		122,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		256,
		212,
		211,
		202,
		237,
		252,
		256,
		-1,
		197,
		236,
		234,
		-1,
		218,
		-1,
		-1,
		-1,
		169,
		163,
		155,
		155,
		134,
		134,
		108,
		112,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		252,
		243,
		256,
		201,
		201,
		222,
		231,
		252,
		212,
		203,
		230,
		241,
		230,
		225,
		212,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		141,
		129,
		112,
		113,
		109,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		245,
		244,
		233,
		230,
		206,
		197,
		192,
		219,
		-1,
		-1,
		214,
		231,
		225,
		229,
		245,
		270,
		-1,
		201,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		117,
		128,
		138,
		126,
		127,
		117,
		127,
		140,
		229,
		226,
		214,
		212,
		235,
		200,
		188,
		-1,
		201,
		199,
		205,
		212,
		229,
		259,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		144,
		146,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		238,
		252,
		241,
		237,
		236,
		244,
		193,
		186,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		137,
		141,
		133,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		272,
		-1,
		224,
		200,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		214,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		219,
		220,
		221,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		160,
		158,
		149,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		136,
		162,
		165,
		171,
		165,
		138,
		153,
		143,
		134,
		143,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		187,
		172,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		177,
		173,
		160,
		160,
		152,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		153,
		188,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		160,
		161,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		125,
		114,
		125,
		133,
		106,
		113,
		-1,
		134,
		136,
		102,
		96,
		135,
		106,
		112,
		123,
		-1,
		-1,
		-1,
		125,
		124,
		94,
		92,
		101,
		106,
		113,
		-1,
		130,
		-1,
		146,
		125,
		136,
		141,
		87,
		84,
		104,
		123,
		123,
		115,
		161,
		117,
		88,
		82,
		100,
		105,
		117,
		109,
		-1,
		88,
		78,
		100,
		97,
		108,
		99,
		-1,
		-1,
		82,
		83,
		89,
		93,
		99,
		95,
		-1,
		105,
		89,
		-1,
		-1,
		72,
		85,
		75,
		78,
		86,
		84,
		97,
		89,
		84,
		-1,
		-1,
		73,
		77,
		84,
		71,
		67,
		84,
		97,
		79,
		93,
		92,
		-1,
		61,
		79,
		77,
		78,
		76,
		60,
		58,
		76,
		78,
		84,
		87,
		-1,
		70,
		71,
		52,
		60,
		65,
		68,
		56,
		63,
		73,
		66,
		85,
		76,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		70,
		53,
		66,
		48,
		38,
		53,
		46,
		52,
		63,
		61,
		58,
		74,
		75,
		85,
		-1,
		-1,
		164,
		137,
		161,
		119,
		100,
		-1,
		66,
		46,
		46,
		42,
		36,
		29,
		43,
		39,
		-1,
		52,
		51,
		82,
		68,
		79,
		146,
		-1,
		-1,
		122,
		114,
		96,
		99,
		76,
		72,
		61,
		60,
		52,
		38,
		34,
		26,
		29,
		29,
		39,
		46,
		56,
		60,
		75,
		86,
		-1,
		-1,
		160,
		-1,
		-1,
		143,
		126,
		-1,
		91,
		98,
		82,
		88,
		74,
		95,
		71,
		62,
		54,
		46,
		34,
		24,
		21,
		38,
		29,
		43,
		68,
		72,
		78,
		96,
		97,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		98,
		95,
		88,
		112,
		111,
		-1,
		83,
		71,
		72,
		57,
		54,
		41,
		27,
		6,
		17,
		30,
		32,
		50,
		52,
		85,
		80,
		101,
		98,
		129,
		135,
		129,
		138,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		116,
		-1,
		119,
		120,
		95,
		68,
		71,
		58,
		49,
		36,
		23,
		0,
		20,
		23,
		43,
		56,
		63,
		77,
		76,
		94,
		107,
		122,
		126,
		132,
		-1,
		201,
		-1,
		143,
		127,
		129,
		105,
		133,
		-1,
		136,
		120,
		112,
		97,
		97,
		-1,
		67,
		64,
		54,
		32,
		17,
		25,
		27,
		31,
		42,
		63,
		80,
		71,
		89,
		96,
		104,
		108,
		128,
		140,
		161,
		151,
		-1,
		133,
		138,
		108,
		120,
		143,
		163,
		133,
		-1,
		108,
		-1,
		69,
		82,
		-1,
		38,
		34,
		23,
		39,
		38,
		45,
		49,
		62,
		59,
		77,
		80,
		97,
		101,
		117,
		-1,
		-1,
		146,
		150,
		158,
		109,
		128,
		152,
		179,
		126,
		115,
		114,
		-1,
		87,
		57,
		54,
		55,
		42,
		36,
		37,
		44,
		50,
		55,
		61,
		64,
		86,
		114,
		92,
		104,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		135,
		106,
		130,
		172,
		144,
		137,
		125,
		105,
		105,
		99,
		-1,
		73,
		52,
		50,
		41,
		49,
		63,
		60,
		74,
		65,
		67,
		83,
		95,
		86,
		106,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		104,
		127,
		161,
		138,
		124,
		129,
		104,
		97,
		91,
		66,
		69,
		64,
		59,
		51,
		40,
		56,
		64,
		66,
		67,
		76,
		77,
		101,
		108,
		114,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		80,
		64,
		59,
		56,
		53,
		47,
		56,
		70,
		81,
		72,
		84,
		106,
		106,
		98,
		123,
		126,
		-1,
		-1,
		-1,
		165,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		81,
		66,
		62,
		57,
		61,
		54,
		61,
		57,
		71,
		82,
		69,
		105,
		-1,
		106,
		100,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		66,
		64,
		58,
		62,
		66,
		55,
		68,
		73,
		74,
		84,
		104,
		108,
		112,
		101,
		97,
		94,
		108,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		72,
		70,
		86,
		70,
		73,
		73,
		69,
		77,
		62,
		65,
		77,
		81,
		99,
		107,
		99,
		93,
		92,
		104,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		82,
		78,
		93,
		94,
		72,
		77,
		76,
		86,
		87,
		76,
		89,
		81,
		103,
		103,
		87,
		88,
		97,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		92,
		90,
		83,
		74,
		80,
		87,
		90,
		91,
		81,
		70,
		76,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		91,
		75,
		80,
		-1,
		116,
		-1,
		89,
		91,
		83,
		72,
		69,
		80,
		78,
		89,
		106,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		107,
		87,
		81,
		80,
		111,
		109,
		97,
		81,
		74,
		71,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		124,
		112,
		102,
		92,
		126,
		125,
		100,
		93,
		79,
		81,
		79,
		81,
		86,
		107,
		108,
		121,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		113,
		-1,
		-1,
		104,
		102,
		112,
		96,
		83,
		103,
		106,
		96,
		80,
		95,
		107,
		115,
		120,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		135,
		137,
		141,
		107,
		-1,
		112,
		107,
		87,
		101,
		108,
		98,
		93,
		87,
		90,
		108,
		125,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		130,
		123,
		127,
		-1,
		115,
		103,
		89,
		106,
		111,
		108,
		99,
		91,
		96,
		93,
		106,
		120,
		124,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		169,
		146,
		119,
		114,
		107,
		101,
		97,
		113,
		119,
		130,
		98,
		94,
		95,
		99,
		98,
		115,
		125,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		196,
		-1,
		-1,
		123,
		114,
		105,
		108,
		107,
		110,
		104,
		101,
		106,
		111,
		99,
		108,
		126,
		125,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		194,
		141,
		123,
		119,
		117,
		110,
		119,
		114,
		109,
		119,
		121,
		113,
		101,
		105,
		128,
		117,
		156,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		195,
		170,
		185,
		205,
		179,
		186,
		156,
		153,
		-1,
		123,
		148,
		120,
		127,
		118,
		125,
		125,
		117,
		95,
		102,
		118,
		117,
		112,
		148,
		139,
		145,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		201,
		187,
		191,
		181,
		184,
		-1,
		-1,
		172,
		169,
		145,
		128,
		126,
		119,
		114,
		124,
		104,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		195,
		187,
		194,
		173,
		175,
		-1,
		-1,
		145,
		142,
		147,
		135,
		132,
		134,
		129,
		120,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		192,
		-1,
		-1,
		202,
		176,
		160,
		150,
		144,
		194,
		149,
		144,
		128,
		126,
		117,
		108,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		218,
		-1,
		187,
		-1,
		162,
		166,
		157,
		160,
		142,
		129,
		121,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		263,
		219,
		218,
		209,
		244,
		259,
		263,
		-1,
		204,
		243,
		241,
		-1,
		225,
		-1,
		-1,
		-1,
		176,
		170,
		162,
		162,
		141,
		141,
		115,
		119,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		259,
		250,
		263,
		208,
		208,
		229,
		238,
		259,
		219,
		210,
		237,
		248,
		237,
		232,
		219,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		148,
		136,
		119,
		120,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		199,
		226,
		-1,
		-1,
		221,
		238,
		232,
		236,
		252,
		277,
		-1,
		208,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		236,
		233,
		221,
		219,
		242,
		207,
		195,
		-1,
		208,
		206,
		212,
		219,
		236,
		266,
		-1,
		-1,
		224,
		204,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		151,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		193,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		214,
		210,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		144,
		148,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		279,
		-1,
		231,
		207,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		231,
		217,
		210,
		198,
		196,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		221,
		223,
		-1,
		222,
		211,
		196,
		188,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		226,
		227,
		228,
		-1,
		206,
		-1,
		224,
		-1,
		191,
		197,
		185,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		224,
		198,
		231,
		222,
		205,
		185,
		177,
		196,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		230,
		-1,
		200,
		233,
		197,
		191,
		167,
		171,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		194,
		179,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		202,
		201,
		193,
		187,
		187,
		172,
		163,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		184,
		180,
		167,
		167,
		159,
		-1,
		303,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		196,
		191,
		164,
		152,
		158,
		154,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		160,
		195,
		-1,
		298,
		-1,
		232,
		-1,
		-1,
		214,
		194,
		186,
		175,
		164,
		162,
		153,
		144,
		166,
		182,
		166,
		164,
		167,
		168,
		-1,
		287,
		286,
		-1,
		233,
		225,
		211,
		-1,
		204,
		-1,
		210,
		171,
		-1,
		173,
		153,
		-1,
		175,
		171,
		-1,
		-1,
		274,
		249,
		-1,
		-1,
		-1,
		234,
		214,
		205,
		189,
		-1,
		164,
		164,
		-1,
		-1,
		-1,
		259,
		258,
		-1,
		227,
		230,
		-1,
		220,
		211,
		219,
		166,
		170,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		242,
		240,
		235,
		232,
		218,
		202,
		180,
		169,
		190,
		-1,
		-1,
		-1,
		240,
		232,
		225,
		-1,
		-1,
		227,
		210,
		191,
		189,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		217,
		-1,
		-1,
		223,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		251,
		-1,
		-1,
		-1,
		213,
		209,
		210,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		297,
		261,
		-1,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		233,
		217,
		-1,
		203,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		238,
		-1,
		238,
		213,
		220,
		-1,
		-1,
		-1,
		-1,
		251,
		243,
		251,
		-1,
		223,
		225,
		-1,
		273,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		228,
		235,
		257,
		260,
		296,
		-1,
		247
	],
	[
		-1,
		121,
		110,
		121,
		129,
		102,
		109,
		-1,
		130,
		132,
		98,
		92,
		131,
		102,
		108,
		119,
		-1,
		-1,
		-1,
		121,
		120,
		90,
		88,
		97,
		102,
		109,
		-1,
		111,
		-1,
		142,
		121,
		132,
		137,
		83,
		80,
		100,
		119,
		104,
		96,
		157,
		113,
		84,
		78,
		96,
		89,
		98,
		90,
		-1,
		84,
		74,
		96,
		78,
		89,
		81,
		-1,
		-1,
		78,
		79,
		85,
		74,
		80,
		76,
		-1,
		86,
		70,
		-1,
		-1,
		68,
		72,
		56,
		59,
		67,
		65,
		78,
		70,
		65,
		-1,
		-1,
		62,
		58,
		65,
		52,
		48,
		65,
		78,
		60,
		74,
		73,
		-1,
		57,
		71,
		67,
		59,
		57,
		41,
		39,
		57,
		59,
		65,
		68,
		-1,
		66,
		67,
		42,
		50,
		55,
		57,
		44,
		44,
		54,
		47,
		66,
		57,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		66,
		49,
		56,
		38,
		28,
		43,
		36,
		42,
		44,
		42,
		39,
		55,
		56,
		66,
		-1,
		-1,
		160,
		133,
		157,
		115,
		96,
		-1,
		62,
		42,
		36,
		32,
		26,
		19,
		33,
		29,
		-1,
		33,
		32,
		63,
		49,
		60,
		142,
		-1,
		-1,
		118,
		110,
		92,
		95,
		72,
		68,
		57,
		56,
		49,
		42,
		38,
		16,
		19,
		19,
		25,
		27,
		37,
		41,
		56,
		67,
		-1,
		-1,
		141,
		-1,
		-1,
		139,
		122,
		-1,
		87,
		94,
		78,
		84,
		70,
		91,
		67,
		58,
		52,
		47,
		39,
		14,
		11,
		24,
		17,
		24,
		49,
		53,
		59,
		77,
		78,
		-1,
		140,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		94,
		91,
		84,
		108,
		107,
		-1,
		87,
		75,
		76,
		61,
		60,
		54,
		43,
		19,
		3,
		18,
		20,
		31,
		33,
		66,
		61,
		82,
		79,
		110,
		116,
		110,
		119,
		-1,
		147,
		143,
		139,
		146,
		95,
		-1,
		-1,
		112,
		-1,
		115,
		124,
		99,
		72,
		75,
		62,
		62,
		49,
		39,
		20,
		0,
		4,
		24,
		37,
		44,
		58,
		57,
		75,
		88,
		103,
		107,
		113,
		-1,
		197,
		-1,
		139,
		123,
		125,
		101,
		129,
		-1,
		132,
		116,
		116,
		101,
		101,
		-1,
		78,
		75,
		67,
		45,
		36,
		19,
		8,
		12,
		23,
		44,
		61,
		52,
		70,
		77,
		85,
		89,
		109,
		121,
		157,
		147,
		-1,
		129,
		134,
		104,
		116,
		136,
		159,
		137,
		-1,
		112,
		-1,
		80,
		93,
		-1,
		51,
		47,
		32,
		30,
		19,
		26,
		30,
		43,
		40,
		58,
		61,
		78,
		82,
		98,
		-1,
		-1,
		142,
		146,
		151,
		102,
		121,
		145,
		182,
		130,
		119,
		118,
		-1,
		98,
		68,
		65,
		66,
		52,
		44,
		42,
		25,
		31,
		40,
		42,
		45,
		67,
		95,
		73,
		85,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		128,
		99,
		123,
		165,
		148,
		141,
		129,
		95,
		95,
		89,
		-1,
		83,
		62,
		53,
		42,
		32,
		48,
		43,
		59,
		46,
		48,
		64,
		76,
		67,
		87,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		94,
		117,
		154,
		128,
		114,
		119,
		94,
		87,
		81,
		77,
		79,
		60,
		49,
		41,
		30,
		46,
		53,
		48,
		48,
		57,
		58,
		82,
		89,
		95,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		108,
		115,
		147,
		119,
		132,
		-1,
		86,
		-1,
		75,
		70,
		54,
		49,
		46,
		43,
		37,
		46,
		54,
		62,
		53,
		68,
		87,
		87,
		79,
		104,
		107,
		-1,
		-1,
		-1,
		158,
		153,
		128,
		105,
		89,
		125,
		-1,
		102,
		103,
		-1,
		80,
		74,
		71,
		56,
		52,
		47,
		51,
		44,
		51,
		47,
		61,
		72,
		54,
		90,
		-1,
		87,
		81,
		109,
		101,
		89,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		84,
		136,
		-1,
		-1,
		87,
		80,
		-1,
		67,
		49,
		56,
		54,
		48,
		52,
		56,
		45,
		58,
		63,
		59,
		69,
		89,
		93,
		100,
		91,
		87,
		84,
		98,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		104,
		-1,
		96,
		88,
		78,
		72,
		66,
		62,
		60,
		76,
		60,
		63,
		63,
		59,
		67,
		52,
		55,
		62,
		66,
		84,
		97,
		89,
		83,
		82,
		94,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		117,
		-1,
		81,
		95,
		111,
		-1,
		104,
		83,
		98,
		76,
		72,
		68,
		83,
		84,
		62,
		67,
		66,
		76,
		77,
		66,
		74,
		71,
		93,
		93,
		77,
		78,
		87,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		78,
		66,
		98,
		-1,
		-1,
		140,
		-1,
		74,
		91,
		82,
		80,
		73,
		64,
		70,
		77,
		80,
		81,
		71,
		60,
		66,
		65,
		87,
		73,
		71,
		90,
		106,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		115,
		-1,
		118,
		108,
		92,
		77,
		110,
		-1,
		81,
		65,
		70,
		-1,
		106,
		-1,
		79,
		81,
		73,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		127,
		112,
		105,
		95,
		109,
		80,
		-1,
		135,
		-1,
		-1,
		105,
		99,
		99,
		83,
		86,
		97,
		77,
		71,
		70,
		101,
		99,
		87,
		71,
		64,
		61,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		132,
		118,
		122,
		82,
		101,
		-1,
		-1,
		167,
		122,
		108,
		-1,
		92,
		114,
		102,
		92,
		82,
		116,
		115,
		90,
		83,
		69,
		71,
		69,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		115,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		114,
		130,
		122,
		93,
		103,
		-1,
		-1,
		94,
		92,
		102,
		86,
		73,
		93,
		96,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		118,
		105,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		147,
		113,
		125,
		127,
		131,
		97,
		-1,
		102,
		97,
		77,
		91,
		98,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		130,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		104,
		118,
		120,
		113,
		117,
		-1,
		105,
		93,
		79,
		96,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		122,
		137,
		159,
		136,
		109,
		104,
		97,
		91,
		87,
		103,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		136,
		153,
		148,
		130,
		134,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		97,
		100,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		115,
		-1,
		-1,
		-1,
		156,
		-1,
		171,
		-1,
		-1,
		149,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		111,
		103,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		185,
		160,
		175,
		195,
		169,
		176,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		108,
		115,
		115,
		107,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		191,
		177,
		181,
		171,
		174,
		-1,
		-1,
		162,
		159,
		135,
		118,
		116,
		109,
		104,
		114,
		94,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		163,
		244,
		237,
		220,
		228,
		259,
		-1,
		185,
		177,
		184,
		163,
		165,
		-1,
		-1,
		135,
		132,
		137,
		125,
		122,
		124,
		119,
		110,
		95,
		101,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		177,
		220,
		214,
		217,
		241,
		255,
		-1,
		182,
		-1,
		-1,
		192,
		166,
		150,
		140,
		134,
		184,
		139,
		134,
		118,
		116,
		107,
		98,
		105,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		126,
		-1,
		212,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		208,
		-1,
		177,
		-1,
		152,
		156,
		147,
		150,
		132,
		119,
		111,
		103,
		119,
		94,
		104,
		100,
		101,
		110,
		121,
		133,
		132,
		133,
		253,
		209,
		208,
		199,
		234,
		249,
		253,
		-1,
		194,
		233,
		231,
		-1,
		215,
		-1,
		-1,
		-1,
		166,
		160,
		152,
		152,
		131,
		131,
		105,
		109,
		99,
		106,
		116,
		118,
		110,
		114,
		127,
		138,
		141,
		249,
		240,
		253,
		198,
		198,
		219,
		228,
		249,
		209,
		200,
		227,
		238,
		227,
		222,
		209,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		138,
		126,
		109,
		110,
		106,
		109,
		124,
		127,
		117,
		115,
		109,
		141,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		216,
		-1,
		-1,
		211,
		228,
		222,
		226,
		242,
		267,
		-1,
		198,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		131,
		120,
		111,
		117,
		114,
		125,
		135,
		123,
		124,
		114,
		124,
		137,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		198,
		196,
		202,
		209,
		226,
		256,
		-1,
		-1,
		214,
		194,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		116,
		121,
		141,
		143,
		132,
		126,
		120,
		127,
		126,
		134,
		142,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		134,
		138,
		130,
		123,
		118,
		129,
		121,
		125,
		142,
		-1,
		269,
		-1,
		221,
		197,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		174,
		142,
		147,
		142,
		124,
		135,
		124,
		127,
		141,
		136,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		211,
		213,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		131,
		156,
		145,
		153,
		148,
		128,
		134,
		137,
		126,
		130,
		142,
		-1,
		-1,
		216,
		217,
		218,
		-1,
		196,
		-1,
		214,
		-1,
		181,
		187,
		175,
		-1,
		-1,
		-1,
		169,
		132,
		153,
		163,
		157,
		155,
		146,
		132,
		139,
		137,
		133,
		144,
		-1,
		-1,
		-1,
		214,
		188,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		131,
		133,
		159,
		162,
		168,
		162,
		135,
		150,
		140,
		131,
		140,
		220,
		-1,
		190,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		135,
		-1,
		163,
		153,
		184,
		169,
		150,
		137,
		144,
		144,
		137,
		-1,
		-1,
		-1,
		192,
		191,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		174,
		170,
		157,
		157,
		149,
		-1,
		293,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		150,
		185,
		-1,
		288,
		-1,
		222,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		157,
		158,
		-1,
		277,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		122,
		111,
		122,
		130,
		103,
		110,
		-1,
		129,
		133,
		99,
		93,
		132,
		101,
		107,
		118,
		-1,
		-1,
		-1,
		122,
		121,
		89,
		87,
		96,
		101,
		108,
		-1,
		107,
		-1,
		143,
		122,
		133,
		138,
		82,
		79,
		99,
		118,
		100,
		92,
		158,
		112,
		83,
		77,
		95,
		85,
		94,
		86,
		-1,
		83,
		73,
		95,
		74,
		85,
		77,
		-1,
		-1,
		77,
		78,
		84,
		70,
		76,
		72,
		-1,
		82,
		66,
		-1,
		-1,
		67,
		68,
		52,
		55,
		63,
		61,
		74,
		66,
		61,
		-1,
		-1,
		58,
		54,
		61,
		48,
		44,
		61,
		74,
		56,
		70,
		69,
		-1,
		59,
		73,
		69,
		55,
		53,
		37,
		35,
		53,
		55,
		61,
		64,
		-1,
		68,
		69,
		44,
		52,
		57,
		53,
		40,
		40,
		50,
		43,
		62,
		53,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		68,
		51,
		58,
		40,
		30,
		45,
		38,
		43,
		40,
		38,
		35,
		51,
		52,
		62,
		-1,
		-1,
		162,
		135,
		159,
		117,
		98,
		-1,
		64,
		44,
		38,
		34,
		28,
		21,
		35,
		31,
		-1,
		29,
		28,
		59,
		45,
		56,
		144,
		-1,
		-1,
		120,
		112,
		94,
		97,
		74,
		70,
		59,
		58,
		51,
		44,
		40,
		18,
		21,
		21,
		27,
		23,
		33,
		37,
		52,
		63,
		-1,
		-1,
		137,
		-1,
		-1,
		141,
		124,
		-1,
		89,
		96,
		80,
		86,
		72,
		93,
		69,
		60,
		54,
		49,
		41,
		16,
		13,
		26,
		19,
		20,
		45,
		49,
		55,
		73,
		74,
		-1,
		136,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		96,
		93,
		86,
		110,
		109,
		-1,
		89,
		77,
		78,
		63,
		62,
		56,
		44,
		21,
		5,
		18,
		22,
		27,
		29,
		62,
		57,
		78,
		75,
		106,
		112,
		106,
		115,
		-1,
		149,
		145,
		141,
		148,
		97,
		-1,
		-1,
		114,
		-1,
		117,
		126,
		101,
		74,
		77,
		64,
		64,
		51,
		40,
		22,
		3,
		0,
		20,
		33,
		40,
		54,
		53,
		71,
		84,
		99,
		103,
		109,
		-1,
		199,
		-1,
		141,
		125,
		127,
		103,
		130,
		-1,
		134,
		118,
		118,
		103,
		103,
		-1,
		80,
		77,
		69,
		47,
		32,
		15,
		4,
		8,
		19,
		40,
		57,
		48,
		66,
		73,
		81,
		85,
		105,
		117,
		159,
		149,
		-1,
		131,
		136,
		105,
		113,
		132,
		161,
		134,
		-1,
		114,
		-1,
		82,
		95,
		-1,
		53,
		49,
		28,
		26,
		15,
		22,
		26,
		39,
		36,
		54,
		57,
		74,
		78,
		94,
		-1,
		-1,
		144,
		148,
		147,
		98,
		117,
		141,
		178,
		127,
		116,
		115,
		-1,
		100,
		64,
		61,
		62,
		48,
		40,
		38,
		21,
		27,
		36,
		38,
		41,
		63,
		91,
		69,
		81,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		124,
		95,
		119,
		161,
		145,
		138,
		126,
		91,
		91,
		85,
		-1,
		79,
		58,
		49,
		38,
		28,
		44,
		39,
		55,
		42,
		44,
		60,
		72,
		63,
		83,
		-1,
		-1,
		-1,
		154,
		143,
		144,
		90,
		113,
		150,
		124,
		110,
		115,
		90,
		83,
		77,
		73,
		75,
		56,
		45,
		37,
		26,
		42,
		49,
		44,
		44,
		53,
		54,
		78,
		85,
		91,
		-1,
		-1,
		161,
		151,
		135,
		137,
		134,
		104,
		111,
		143,
		115,
		128,
		-1,
		82,
		-1,
		71,
		66,
		50,
		45,
		42,
		39,
		33,
		42,
		50,
		58,
		49,
		64,
		83,
		83,
		75,
		100,
		103,
		-1,
		-1,
		-1,
		154,
		149,
		124,
		101,
		85,
		121,
		-1,
		98,
		99,
		-1,
		76,
		70,
		67,
		52,
		48,
		43,
		47,
		40,
		47,
		43,
		57,
		68,
		50,
		86,
		-1,
		83,
		77,
		105,
		97,
		85,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		80,
		132,
		-1,
		-1,
		83,
		76,
		-1,
		63,
		45,
		52,
		50,
		44,
		48,
		52,
		41,
		54,
		59,
		55,
		65,
		85,
		89,
		96,
		87,
		83,
		80,
		94,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		100,
		-1,
		92,
		84,
		74,
		68,
		62,
		58,
		56,
		72,
		56,
		59,
		59,
		55,
		63,
		48,
		51,
		58,
		62,
		80,
		93,
		85,
		79,
		78,
		90,
		-1,
		167,
		153,
		124,
		-1,
		-1,
		113,
		-1,
		77,
		91,
		107,
		-1,
		100,
		79,
		94,
		72,
		68,
		64,
		79,
		80,
		58,
		63,
		62,
		72,
		73,
		62,
		70,
		67,
		89,
		89,
		73,
		74,
		83,
		-1,
		173,
		160,
		118,
		114,
		103,
		123,
		74,
		62,
		94,
		-1,
		-1,
		136,
		-1,
		70,
		87,
		78,
		76,
		69,
		60,
		66,
		73,
		76,
		77,
		67,
		56,
		62,
		61,
		83,
		69,
		67,
		86,
		102,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		89,
		76,
		70,
		-1,
		111,
		-1,
		114,
		104,
		88,
		73,
		106,
		-1,
		77,
		61,
		66,
		-1,
		102,
		-1,
		75,
		77,
		69,
		58,
		55,
		66,
		64,
		75,
		92,
		-1,
		123,
		108,
		101,
		91,
		105,
		76,
		-1,
		131,
		-1,
		-1,
		101,
		95,
		95,
		79,
		82,
		93,
		73,
		67,
		66,
		97,
		95,
		83,
		67,
		60,
		57,
		58,
		71,
		91,
		82,
		94,
		-1,
		-1,
		-1,
		128,
		114,
		118,
		78,
		97,
		-1,
		-1,
		163,
		118,
		104,
		-1,
		88,
		110,
		98,
		88,
		78,
		112,
		111,
		86,
		79,
		65,
		67,
		65,
		67,
		72,
		93,
		94,
		107,
		-1,
		-1,
		111,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		110,
		126,
		118,
		89,
		99,
		-1,
		-1,
		90,
		88,
		98,
		82,
		69,
		89,
		92,
		82,
		66,
		81,
		93,
		101,
		106,
		-1,
		114,
		101,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		121,
		123,
		127,
		93,
		-1,
		98,
		93,
		73,
		87,
		94,
		84,
		79,
		73,
		76,
		94,
		111,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		100,
		114,
		116,
		109,
		113,
		-1,
		101,
		89,
		75,
		92,
		97,
		94,
		85,
		77,
		82,
		79,
		92,
		106,
		110,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		118,
		133,
		155,
		132,
		105,
		100,
		93,
		87,
		83,
		99,
		105,
		116,
		84,
		80,
		81,
		85,
		84,
		101,
		111,
		-1,
		-1,
		132,
		149,
		144,
		126,
		130,
		182,
		-1,
		-1,
		109,
		100,
		91,
		94,
		93,
		96,
		90,
		87,
		92,
		97,
		85,
		94,
		112,
		111,
		-1,
		-1,
		-1,
		152,
		-1,
		167,
		-1,
		-1,
		145,
		180,
		127,
		109,
		105,
		103,
		96,
		105,
		100,
		95,
		105,
		107,
		99,
		87,
		91,
		114,
		103,
		142,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		191,
		165,
		172,
		142,
		139,
		-1,
		109,
		134,
		106,
		113,
		104,
		111,
		111,
		103,
		81,
		88,
		104,
		103,
		98,
		134,
		125,
		131,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		187,
		173,
		177,
		167,
		170,
		-1,
		-1,
		158,
		155,
		131,
		114,
		112,
		105,
		100,
		110,
		90,
		77,
		81,
		85,
		91,
		96,
		101,
		107,
		122,
		137,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		181,
		173,
		180,
		159,
		161,
		-1,
		-1,
		131,
		128,
		133,
		121,
		118,
		120,
		115,
		106,
		91,
		97,
		84,
		83,
		101,
		105,
		114,
		121,
		111,
		124,
		128,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		178,
		-1,
		-1,
		188,
		162,
		146,
		136,
		130,
		180,
		135,
		130,
		114,
		112,
		103,
		94,
		101,
		92,
		92,
		95,
		110,
		115,
		107,
		121,
		121,
		122,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		204,
		-1,
		173,
		-1,
		148,
		152,
		143,
		146,
		128,
		115,
		107,
		99,
		115,
		90,
		100,
		96,
		97,
		106,
		117,
		129,
		128,
		129,
		249,
		205,
		204,
		195,
		230,
		245,
		249,
		-1,
		190,
		229,
		227,
		-1,
		211,
		-1,
		-1,
		-1,
		162,
		156,
		148,
		148,
		127,
		127,
		101,
		105,
		95,
		102,
		112,
		114,
		106,
		110,
		123,
		134,
		137,
		245,
		236,
		249,
		194,
		194,
		215,
		224,
		245,
		205,
		196,
		223,
		234,
		223,
		218,
		205,
		-1,
		-1,
		185,
		166,
		-1,
		-1,
		134,
		122,
		105,
		106,
		102,
		105,
		120,
		123,
		113,
		111,
		105,
		137,
		-1,
		238,
		237,
		226,
		223,
		199,
		190,
		185,
		212,
		-1,
		-1,
		207,
		224,
		218,
		222,
		238,
		263,
		-1,
		194,
		-1,
		-1,
		179,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		110,
		121,
		131,
		119,
		120,
		110,
		120,
		133,
		222,
		219,
		207,
		205,
		228,
		193,
		181,
		-1,
		194,
		192,
		198,
		205,
		222,
		252,
		-1,
		-1,
		210,
		190,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		112,
		117,
		137,
		139,
		128,
		122,
		116,
		123,
		122,
		130,
		138,
		231,
		245,
		234,
		230,
		229,
		237,
		186,
		179,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		200,
		196,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		130,
		134,
		126,
		119,
		114,
		125,
		117,
		121,
		138,
		-1,
		265,
		-1,
		217,
		193,
		207,
		222,
		230,
		-1,
		-1,
		-1,
		217,
		203,
		196,
		184,
		182,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		120,
		131,
		120,
		123,
		137,
		132,
		-1,
		-1,
		205,
		208,
		-1,
		-1,
		207,
		209,
		-1,
		208,
		197,
		182,
		174,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		124,
		130,
		133,
		122,
		126,
		138,
		-1,
		-1,
		212,
		213,
		214,
		-1,
		192,
		-1,
		210,
		-1,
		177,
		183,
		171,
		-1,
		-1,
		-1,
		165,
		128,
		149,
		159,
		153,
		151,
		142,
		128,
		135,
		133,
		129,
		140,
		-1,
		-1,
		-1,
		210,
		184,
		217,
		208,
		191,
		171,
		163,
		182,
		-1,
		152,
		-1,
		127,
		129,
		155,
		158,
		164,
		158,
		131,
		146,
		136,
		127,
		136,
		216,
		-1,
		186,
		219,
		183,
		177,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		180,
		165,
		146,
		133,
		140,
		140,
		133,
		-1,
		-1,
		-1,
		188,
		187,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		170,
		166,
		153,
		153,
		145,
		-1,
		289,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		146,
		181,
		-1,
		284,
		-1,
		218,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		153,
		154,
		-1,
		273,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		121,
		110,
		121,
		129,
		102,
		109,
		-1,
		128,
		132,
		98,
		92,
		131,
		100,
		106,
		117,
		-1,
		-1,
		-1,
		121,
		120,
		88,
		86,
		95,
		100,
		107,
		-1,
		106,
		-1,
		142,
		121,
		132,
		137,
		81,
		78,
		98,
		117,
		99,
		91,
		157,
		111,
		82,
		76,
		94,
		84,
		93,
		85,
		-1,
		82,
		72,
		94,
		73,
		84,
		76,
		-1,
		-1,
		76,
		77,
		83,
		69,
		75,
		71,
		-1,
		81,
		65,
		-1,
		-1,
		66,
		67,
		51,
		54,
		62,
		60,
		73,
		65,
		60,
		-1,
		-1,
		57,
		53,
		60,
		47,
		43,
		60,
		73,
		55,
		69,
		68,
		-1,
		69,
		86,
		86,
		54,
		52,
		36,
		34,
		52,
		54,
		60,
		63,
		-1,
		86,
		82,
		64,
		72,
		76,
		52,
		39,
		39,
		49,
		42,
		61,
		52,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		87,
		71,
		78,
		60,
		50,
		65,
		58,
		42,
		39,
		37,
		34,
		50,
		51,
		61,
		-1,
		-1,
		180,
		153,
		177,
		135,
		117,
		-1,
		83,
		64,
		58,
		54,
		48,
		41,
		55,
		51,
		-1,
		28,
		27,
		58,
		44,
		55,
		159,
		-1,
		-1,
		138,
		130,
		112,
		115,
		92,
		88,
		79,
		78,
		71,
		64,
		60,
		38,
		41,
		41,
		47,
		22,
		32,
		36,
		51,
		62,
		-1,
		-1,
		132,
		-1,
		-1,
		156,
		139,
		-1,
		107,
		114,
		98,
		104,
		90,
		111,
		89,
		80,
		74,
		69,
		61,
		36,
		33,
		46,
		19,
		19,
		44,
		48,
		54,
		72,
		73,
		-1,
		131,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		114,
		111,
		104,
		128,
		127,
		-1,
		109,
		97,
		98,
		83,
		82,
		76,
		64,
		41,
		25,
		25,
		16,
		19,
		17,
		46,
		54,
		76,
		73,
		102,
		107,
		101,
		110,
		-1,
		164,
		160,
		156,
		163,
		112,
		-1,
		-1,
		132,
		-1,
		135,
		146,
		121,
		94,
		97,
		84,
		84,
		71,
		60,
		42,
		23,
		20,
		0,
		17,
		24,
		49,
		48,
		66,
		81,
		94,
		98,
		104,
		-1,
		214,
		-1,
		156,
		140,
		142,
		114,
		135,
		-1,
		152,
		136,
		138,
		123,
		123,
		-1,
		100,
		97,
		89,
		67,
		52,
		35,
		23,
		18,
		17,
		24,
		52,
		43,
		61,
		68,
		76,
		80,
		100,
		112,
		174,
		164,
		-1,
		146,
		151,
		110,
		118,
		137,
		175,
		139,
		-1,
		134,
		-1,
		102,
		115,
		-1,
		73,
		69,
		43,
		31,
		20,
		27,
		20,
		27,
		31,
		49,
		52,
		69,
		73,
		89,
		-1,
		-1,
		159,
		163,
		152,
		103,
		122,
		146,
		183,
		132,
		121,
		120,
		-1,
		111,
		79,
		76,
		73,
		60,
		45,
		43,
		26,
		32,
		41,
		33,
		36,
		58,
		86,
		64,
		76,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		129,
		100,
		124,
		166,
		150,
		143,
		131,
		96,
		96,
		90,
		-1,
		84,
		63,
		54,
		43,
		33,
		49,
		44,
		57,
		37,
		39,
		55,
		67,
		58,
		78,
		-1,
		-1,
		-1,
		159,
		148,
		149,
		95,
		118,
		155,
		129,
		115,
		120,
		95,
		88,
		82,
		88,
		80,
		61,
		50,
		42,
		31,
		47,
		54,
		49,
		39,
		48,
		49,
		73,
		80,
		86,
		-1,
		-1,
		166,
		156,
		140,
		142,
		139,
		109,
		116,
		148,
		120,
		133,
		-1,
		87,
		-1,
		76,
		71,
		55,
		50,
		47,
		44,
		38,
		47,
		55,
		53,
		44,
		59,
		78,
		78,
		70,
		95,
		98,
		-1,
		-1,
		-1,
		159,
		154,
		129,
		106,
		90,
		126,
		-1,
		103,
		104,
		-1,
		81,
		75,
		72,
		57,
		53,
		48,
		52,
		45,
		52,
		48,
		62,
		63,
		45,
		81,
		-1,
		78,
		72,
		100,
		102,
		90,
		-1,
		-1,
		-1,
		152,
		131,
		124,
		144,
		85,
		137,
		-1,
		-1,
		88,
		81,
		-1,
		68,
		50,
		57,
		55,
		49,
		53,
		57,
		46,
		59,
		64,
		50,
		60,
		80,
		84,
		91,
		84,
		88,
		85,
		99,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		105,
		-1,
		97,
		89,
		79,
		73,
		67,
		63,
		61,
		77,
		61,
		64,
		64,
		60,
		68,
		53,
		56,
		53,
		57,
		75,
		98,
		90,
		84,
		83,
		95,
		-1,
		172,
		158,
		129,
		-1,
		-1,
		118,
		-1,
		82,
		96,
		112,
		-1,
		105,
		84,
		99,
		77,
		73,
		69,
		84,
		85,
		63,
		68,
		67,
		77,
		78,
		67,
		65,
		69,
		84,
		94,
		78,
		79,
		88,
		-1,
		178,
		165,
		123,
		119,
		108,
		128,
		79,
		67,
		99,
		-1,
		-1,
		141,
		-1,
		75,
		92,
		83,
		81,
		74,
		65,
		71,
		78,
		81,
		82,
		72,
		61,
		67,
		66,
		88,
		74,
		72,
		91,
		107,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		94,
		81,
		75,
		-1,
		116,
		-1,
		119,
		109,
		93,
		78,
		111,
		-1,
		82,
		66,
		71,
		-1,
		107,
		-1,
		80,
		82,
		74,
		63,
		60,
		71,
		69,
		80,
		97,
		-1,
		128,
		113,
		106,
		96,
		110,
		81,
		-1,
		136,
		-1,
		-1,
		106,
		100,
		100,
		84,
		87,
		98,
		78,
		72,
		71,
		102,
		100,
		88,
		72,
		65,
		62,
		63,
		76,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		133,
		119,
		123,
		83,
		102,
		-1,
		-1,
		168,
		123,
		109,
		-1,
		93,
		115,
		103,
		93,
		83,
		117,
		116,
		91,
		84,
		70,
		72,
		70,
		72,
		77,
		98,
		99,
		112,
		-1,
		-1,
		116,
		121,
		109,
		95,
		114,
		-1,
		-1,
		-1,
		115,
		131,
		123,
		94,
		104,
		-1,
		-1,
		95,
		93,
		103,
		87,
		74,
		94,
		97,
		87,
		71,
		86,
		98,
		106,
		111,
		-1,
		119,
		106,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		126,
		128,
		132,
		98,
		-1,
		103,
		98,
		78,
		92,
		99,
		89,
		84,
		78,
		81,
		99,
		116,
		-1,
		-1,
		131,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		105,
		119,
		121,
		114,
		118,
		-1,
		106,
		94,
		80,
		97,
		102,
		99,
		90,
		82,
		87,
		84,
		97,
		111,
		115,
		154,
		-1,
		137,
		-1,
		-1,
		-1,
		123,
		138,
		160,
		137,
		110,
		105,
		98,
		92,
		88,
		104,
		110,
		121,
		89,
		85,
		86,
		90,
		89,
		106,
		116,
		-1,
		-1,
		137,
		154,
		149,
		131,
		135,
		187,
		-1,
		-1,
		114,
		105,
		96,
		99,
		98,
		101,
		95,
		92,
		97,
		102,
		90,
		99,
		117,
		116,
		-1,
		-1,
		-1,
		157,
		-1,
		172,
		-1,
		-1,
		150,
		185,
		132,
		114,
		110,
		108,
		101,
		110,
		105,
		100,
		110,
		112,
		104,
		92,
		96,
		119,
		108,
		147,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		186,
		161,
		176,
		196,
		170,
		177,
		147,
		144,
		-1,
		114,
		139,
		111,
		118,
		109,
		116,
		116,
		108,
		86,
		93,
		109,
		108,
		103,
		139,
		130,
		136,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		192,
		178,
		182,
		172,
		175,
		-1,
		-1,
		163,
		160,
		136,
		119,
		117,
		110,
		105,
		115,
		95,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		164,
		245,
		238,
		221,
		229,
		260,
		-1,
		186,
		178,
		185,
		164,
		166,
		-1,
		-1,
		136,
		133,
		138,
		126,
		123,
		125,
		120,
		111,
		96,
		102,
		89,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		178,
		221,
		215,
		218,
		242,
		256,
		-1,
		183,
		-1,
		-1,
		193,
		167,
		151,
		141,
		135,
		185,
		140,
		135,
		119,
		117,
		108,
		99,
		106,
		97,
		97,
		100,
		115,
		120,
		112,
		126,
		126,
		127,
		-1,
		213,
		201,
		209,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		209,
		-1,
		178,
		-1,
		153,
		157,
		148,
		151,
		133,
		120,
		112,
		104,
		120,
		95,
		105,
		101,
		102,
		111,
		122,
		134,
		133,
		134,
		254,
		210,
		209,
		200,
		235,
		250,
		254,
		-1,
		195,
		234,
		232,
		-1,
		216,
		-1,
		-1,
		-1,
		167,
		161,
		153,
		153,
		132,
		132,
		106,
		110,
		100,
		107,
		117,
		119,
		111,
		115,
		128,
		139,
		142,
		250,
		241,
		254,
		199,
		199,
		220,
		229,
		250,
		210,
		201,
		228,
		239,
		228,
		223,
		210,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		139,
		127,
		110,
		111,
		107,
		110,
		125,
		128,
		118,
		116,
		110,
		142,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		217,
		-1,
		-1,
		212,
		229,
		223,
		227,
		243,
		268,
		-1,
		199,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		115,
		126,
		136,
		124,
		125,
		115,
		125,
		138,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		199,
		197,
		203,
		210,
		227,
		257,
		-1,
		-1,
		215,
		195,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		117,
		122,
		142,
		144,
		133,
		127,
		121,
		128,
		127,
		135,
		143,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		205,
		201,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		135,
		139,
		131,
		124,
		119,
		130,
		122,
		126,
		143,
		-1,
		270,
		-1,
		222,
		198,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		222,
		208,
		201,
		189,
		187,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		125,
		136,
		125,
		128,
		142,
		137,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		212,
		214,
		-1,
		213,
		202,
		187,
		179,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		129,
		135,
		138,
		127,
		131,
		143,
		-1,
		-1,
		217,
		218,
		219,
		-1,
		197,
		-1,
		215,
		-1,
		182,
		188,
		176,
		-1,
		-1,
		-1,
		170,
		133,
		154,
		164,
		158,
		156,
		147,
		133,
		140,
		138,
		134,
		145,
		-1,
		-1,
		-1,
		215,
		189,
		222,
		213,
		196,
		176,
		168,
		187,
		-1,
		157,
		-1,
		132,
		134,
		160,
		163,
		169,
		163,
		136,
		151,
		141,
		132,
		141,
		221,
		-1,
		191,
		224,
		188,
		182,
		158,
		162,
		178,
		-1,
		154,
		136,
		-1,
		164,
		154,
		185,
		170,
		151,
		138,
		145,
		145,
		138,
		-1,
		-1,
		-1,
		193,
		192,
		184,
		178,
		178,
		163,
		154,
		-1,
		166,
		148,
		127,
		144,
		144,
		135,
		143,
		175,
		171,
		158,
		158,
		150,
		-1,
		294,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		187,
		182,
		155,
		143,
		149,
		145,
		131,
		137,
		139,
		147,
		145,
		142,
		154,
		150,
		170,
		151,
		186,
		-1,
		289,
		-1,
		223,
		-1,
		-1,
		205,
		185,
		177,
		166,
		155,
		153,
		144,
		135,
		157,
		173,
		157,
		155,
		158,
		159,
		-1,
		278,
		277,
		-1,
		224,
		216,
		202,
		-1,
		195,
		-1,
		201,
		162,
		-1,
		164,
		144,
		-1,
		166,
		162,
		-1,
		-1,
		265,
		240,
		-1,
		-1,
		-1,
		225,
		205,
		196,
		180,
		-1,
		155,
		155,
		-1,
		-1,
		-1,
		250,
		249,
		-1,
		218,
		221,
		-1,
		211,
		202,
		210,
		157,
		161,
		-1,
		-1,
		-1,
		259,
		240,
		234,
		233,
		231,
		226,
		223,
		209,
		193,
		171,
		160,
		181,
		-1,
		-1,
		-1,
		231,
		223,
		216,
		-1,
		-1,
		218,
		201,
		182,
		180,
		-1,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		208,
		-1,
		-1,
		214,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		242,
		-1,
		-1,
		-1,
		204,
		200,
		201,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		288,
		252,
		-1,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		267,
		265,
		-1,
		-1,
		-1,
		224,
		208,
		-1,
		194,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		229,
		-1,
		229,
		204,
		211,
		-1,
		-1,
		-1,
		-1,
		242,
		234,
		242,
		-1,
		214,
		216,
		-1,
		264,
		-1,
		-1,
		257,
		248,
		-1,
		-1,
		219,
		226,
		248,
		251,
		287,
		-1,
		238
	],
	[
		-1,
		120,
		109,
		120,
		128,
		101,
		108,
		-1,
		127,
		131,
		97,
		91,
		130,
		99,
		105,
		116,
		-1,
		-1,
		-1,
		120,
		119,
		87,
		85,
		94,
		99,
		106,
		-1,
		105,
		-1,
		141,
		120,
		131,
		136,
		80,
		77,
		97,
		116,
		98,
		90,
		156,
		110,
		81,
		75,
		93,
		83,
		92,
		84,
		-1,
		81,
		71,
		93,
		72,
		83,
		75,
		-1,
		-1,
		75,
		76,
		82,
		68,
		74,
		70,
		-1,
		80,
		64,
		-1,
		-1,
		65,
		66,
		50,
		53,
		61,
		59,
		72,
		64,
		59,
		-1,
		-1,
		56,
		52,
		59,
		46,
		42,
		59,
		72,
		54,
		68,
		67,
		-1,
		68,
		85,
		85,
		53,
		51,
		35,
		33,
		51,
		53,
		59,
		62,
		-1,
		85,
		81,
		81,
		80,
		75,
		51,
		38,
		38,
		48,
		41,
		60,
		51,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		86,
		77,
		94,
		77,
		67,
		72,
		70,
		41,
		38,
		36,
		33,
		49,
		50,
		60,
		-1,
		-1,
		179,
		152,
		176,
		134,
		116,
		-1,
		82,
		81,
		75,
		71,
		65,
		58,
		72,
		57,
		-1,
		27,
		26,
		57,
		43,
		54,
		161,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		96,
		95,
		88,
		81,
		77,
		55,
		58,
		58,
		64,
		21,
		31,
		35,
		45,
		61,
		-1,
		-1,
		115,
		-1,
		-1,
		158,
		141,
		-1,
		106,
		113,
		97,
		103,
		89,
		110,
		106,
		97,
		91,
		86,
		78,
		53,
		50,
		63,
		36,
		18,
		43,
		47,
		40,
		61,
		56,
		-1,
		114,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		113,
		110,
		103,
		127,
		126,
		-1,
		126,
		114,
		115,
		100,
		99,
		93,
		81,
		58,
		42,
		42,
		33,
		8,
		6,
		37,
		37,
		59,
		56,
		85,
		90,
		84,
		93,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		131,
		-1,
		134,
		147,
		138,
		111,
		114,
		101,
		101,
		88,
		77,
		59,
		40,
		37,
		20,
		0,
		15,
		32,
		31,
		49,
		64,
		77,
		81,
		87,
		-1,
		216,
		-1,
		158,
		142,
		144,
		120,
		148,
		-1,
		151,
		135,
		155,
		140,
		140,
		-1,
		117,
		114,
		106,
		84,
		69,
		52,
		40,
		35,
		25,
		7,
		35,
		26,
		44,
		51,
		59,
		63,
		83,
		95,
		176,
		166,
		-1,
		148,
		153,
		123,
		134,
		153,
		178,
		155,
		-1,
		150,
		-1,
		119,
		132,
		-1,
		90,
		86,
		60,
		48,
		37,
		44,
		28,
		10,
		14,
		32,
		35,
		52,
		56,
		72,
		-1,
		-1,
		161,
		165,
		168,
		119,
		138,
		162,
		199,
		148,
		137,
		136,
		-1,
		127,
		96,
		93,
		89,
		76,
		61,
		60,
		43,
		49,
		31,
		16,
		19,
		41,
		69,
		47,
		59,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		145,
		116,
		140,
		182,
		166,
		159,
		147,
		112,
		112,
		106,
		-1,
		100,
		79,
		70,
		59,
		50,
		64,
		37,
		40,
		20,
		22,
		38,
		50,
		41,
		61,
		-1,
		-1,
		-1,
		175,
		164,
		165,
		111,
		134,
		171,
		145,
		131,
		136,
		111,
		104,
		98,
		105,
		96,
		77,
		66,
		58,
		47,
		38,
		48,
		42,
		22,
		31,
		32,
		56,
		63,
		69,
		-1,
		-1,
		182,
		172,
		156,
		158,
		155,
		125,
		132,
		164,
		136,
		149,
		-1,
		103,
		-1,
		92,
		87,
		71,
		66,
		63,
		56,
		43,
		53,
		50,
		36,
		27,
		42,
		61,
		61,
		53,
		78,
		81,
		-1,
		-1,
		-1,
		175,
		170,
		145,
		122,
		106,
		142,
		-1,
		119,
		120,
		-1,
		97,
		91,
		88,
		73,
		69,
		60,
		64,
		58,
		57,
		53,
		45,
		46,
		28,
		64,
		-1,
		61,
		55,
		83,
		86,
		76,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		101,
		153,
		-1,
		-1,
		104,
		97,
		-1,
		84,
		66,
		72,
		67,
		65,
		65,
		64,
		53,
		61,
		53,
		33,
		43,
		63,
		67,
		74,
		67,
		72,
		71,
		85,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		121,
		-1,
		113,
		105,
		95,
		89,
		83,
		79,
		77,
		93,
		77,
		77,
		76,
		67,
		75,
		57,
		50,
		36,
		40,
		58,
		85,
		80,
		75,
		74,
		81,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		134,
		-1,
		98,
		112,
		128,
		-1,
		121,
		100,
		115,
		93,
		89,
		84,
		100,
		101,
		79,
		76,
		74,
		84,
		72,
		61,
		48,
		52,
		67,
		77,
		69,
		70,
		79,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		95,
		83,
		115,
		-1,
		-1,
		157,
		-1,
		91,
		108,
		98,
		96,
		90,
		81,
		87,
		85,
		81,
		76,
		66,
		55,
		61,
		57,
		79,
		65,
		63,
		82,
		97,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		135,
		125,
		109,
		94,
		127,
		-1,
		98,
		82,
		87,
		-1,
		101,
		-1,
		74,
		74,
		65,
		54,
		51,
		62,
		60,
		71,
		88,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		152,
		-1,
		-1,
		122,
		116,
		116,
		100,
		103,
		114,
		94,
		88,
		87,
		96,
		91,
		82,
		63,
		56,
		53,
		54,
		67,
		87,
		78,
		90,
		-1,
		-1,
		-1,
		149,
		135,
		139,
		99,
		118,
		-1,
		-1,
		184,
		139,
		125,
		-1,
		109,
		131,
		119,
		109,
		99,
		117,
		107,
		82,
		75,
		61,
		63,
		61,
		63,
		68,
		89,
		90,
		103,
		-1,
		-1,
		132,
		137,
		125,
		111,
		130,
		-1,
		-1,
		-1,
		131,
		147,
		139,
		110,
		120,
		-1,
		-1,
		111,
		109,
		99,
		78,
		65,
		85,
		88,
		78,
		62,
		77,
		89,
		97,
		102,
		-1,
		135,
		122,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		124,
		119,
		123,
		114,
		-1,
		95,
		89,
		69,
		83,
		90,
		80,
		75,
		69,
		72,
		90,
		107,
		-1,
		-1,
		147,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		121,
		135,
		112,
		105,
		109,
		-1,
		97,
		85,
		71,
		88,
		93,
		90,
		81,
		73,
		78,
		75,
		88,
		102,
		106,
		170,
		-1,
		153,
		-1,
		-1,
		-1,
		139,
		154,
		151,
		128,
		101,
		96,
		89,
		83,
		79,
		95,
		101,
		112,
		80,
		76,
		77,
		81,
		80,
		97,
		107,
		-1,
		-1,
		153,
		170,
		165,
		147,
		151,
		178,
		-1,
		-1,
		105,
		96,
		87,
		90,
		89,
		92,
		86,
		83,
		88,
		93,
		81,
		90,
		108,
		107,
		-1,
		-1,
		-1,
		173,
		-1,
		188,
		-1,
		-1,
		166,
		176,
		123,
		105,
		101,
		99,
		92,
		101,
		96,
		91,
		101,
		103,
		95,
		83,
		87,
		110,
		99,
		138,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		194,
		177,
		181,
		187,
		186,
		180,
		138,
		135,
		-1,
		105,
		130,
		102,
		109,
		100,
		107,
		107,
		99,
		77,
		84,
		100,
		99,
		94,
		130,
		121,
		127,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		187,
		183,
		173,
		163,
		166,
		-1,
		-1,
		154,
		151,
		127,
		110,
		108,
		101,
		96,
		106,
		86,
		73,
		77,
		81,
		87,
		92,
		97,
		103,
		118,
		133,
		-1,
		180,
		261,
		254,
		236,
		244,
		275,
		-1,
		177,
		169,
		180,
		155,
		157,
		-1,
		-1,
		127,
		124,
		129,
		117,
		114,
		116,
		111,
		102,
		87,
		93,
		80,
		79,
		97,
		101,
		110,
		117,
		107,
		120,
		124,
		-1,
		194,
		237,
		230,
		233,
		257,
		271,
		-1,
		174,
		-1,
		-1,
		186,
		158,
		142,
		132,
		126,
		176,
		131,
		126,
		110,
		108,
		99,
		90,
		97,
		88,
		88,
		91,
		106,
		111,
		103,
		117,
		117,
		118,
		-1,
		220,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		202,
		-1,
		169,
		-1,
		144,
		148,
		139,
		142,
		124,
		111,
		103,
		95,
		111,
		86,
		96,
		92,
		93,
		102,
		113,
		125,
		124,
		125,
		245,
		201,
		204,
		215,
		226,
		241,
		245,
		-1,
		186,
		225,
		223,
		-1,
		207,
		-1,
		-1,
		-1,
		158,
		152,
		144,
		144,
		123,
		123,
		97,
		101,
		91,
		98,
		108,
		110,
		102,
		106,
		119,
		130,
		133,
		241,
		232,
		245,
		190,
		190,
		211,
		220,
		241,
		201,
		192,
		219,
		230,
		219,
		214,
		201,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		130,
		118,
		101,
		102,
		98,
		101,
		116,
		119,
		109,
		107,
		101,
		133,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		181,
		208,
		-1,
		-1,
		203,
		220,
		214,
		218,
		234,
		259,
		-1,
		190,
		-1,
		-1,
		175,
		-1,
		-1,
		160,
		123,
		112,
		103,
		109,
		106,
		117,
		127,
		115,
		116,
		106,
		116,
		129,
		218,
		215,
		203,
		201,
		224,
		189,
		177,
		-1,
		190,
		188,
		194,
		201,
		218,
		248,
		-1,
		-1,
		206,
		186,
		-1,
		-1,
		158,
		156,
		145,
		-1,
		135,
		108,
		113,
		133,
		135,
		124,
		118,
		112,
		119,
		118,
		126,
		134,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		175,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		196,
		192,
		-1,
		-1,
		153,
		146,
		134,
		122,
		112,
		122,
		126,
		130,
		122,
		115,
		110,
		121,
		113,
		117,
		134,
		-1,
		261,
		-1,
		213,
		189,
		203,
		218,
		226,
		-1,
		-1,
		-1,
		213,
		199,
		192,
		180,
		178,
		-1,
		187,
		171,
		152,
		-1,
		122,
		135,
		166,
		134,
		139,
		134,
		116,
		127,
		116,
		119,
		133,
		128,
		-1,
		-1,
		201,
		204,
		-1,
		-1,
		203,
		205,
		-1,
		204,
		193,
		178,
		170,
		-1,
		-1,
		159,
		155,
		-1,
		-1,
		123,
		148,
		137,
		145,
		140,
		120,
		126,
		129,
		118,
		122,
		134,
		-1,
		-1,
		208,
		209,
		210,
		-1,
		188,
		-1,
		206,
		-1,
		173,
		179,
		167,
		-1,
		-1,
		-1,
		161,
		124,
		145,
		155,
		149,
		147,
		138,
		124,
		131,
		129,
		125,
		136,
		-1,
		-1,
		-1,
		206,
		180,
		213,
		204,
		187,
		167,
		159,
		178,
		-1,
		148,
		-1,
		123,
		125,
		151,
		154,
		160,
		154,
		127,
		142,
		132,
		123,
		132,
		212,
		-1,
		182,
		215,
		179,
		173,
		149,
		153,
		169,
		-1,
		145,
		127,
		-1,
		155,
		145,
		176,
		161,
		142,
		129,
		136,
		136,
		129,
		-1,
		-1,
		-1,
		184,
		183,
		175,
		169,
		169,
		154,
		145,
		-1,
		157,
		139,
		118,
		135,
		135,
		126,
		134,
		166,
		162,
		149,
		149,
		141,
		-1,
		285,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		178,
		173,
		146,
		134,
		140,
		136,
		122,
		128,
		130,
		138,
		136,
		133,
		145,
		141,
		161,
		142,
		177,
		-1,
		280,
		-1,
		214,
		-1,
		-1,
		196,
		176,
		168,
		157,
		146,
		144,
		135,
		126,
		148,
		164,
		148,
		146,
		149,
		150,
		-1,
		269,
		268,
		-1,
		215,
		207,
		193,
		-1,
		186,
		-1,
		192,
		153,
		-1,
		155,
		135,
		-1,
		157,
		153,
		-1,
		-1,
		256,
		231,
		-1,
		-1,
		-1,
		216,
		196,
		187,
		171,
		-1,
		146,
		146,
		-1,
		-1,
		-1,
		241,
		240,
		-1,
		209,
		212,
		-1,
		202,
		193,
		201,
		148,
		152,
		-1,
		-1,
		-1,
		250,
		231,
		225,
		224,
		222,
		217,
		214,
		200,
		184,
		162,
		151,
		172,
		-1,
		-1,
		-1,
		222,
		214,
		207,
		-1,
		-1,
		209,
		192,
		173,
		171,
		-1,
		-1,
		-1,
		244,
		225,
		-1,
		-1,
		199,
		-1,
		-1,
		205,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		233,
		-1,
		-1,
		-1,
		195,
		191,
		192,
		-1,
		-1,
		-1,
		-1,
		255,
		256,
		279,
		243,
		-1,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		258,
		256,
		-1,
		-1,
		-1,
		215,
		199,
		-1,
		185,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		220,
		-1,
		220,
		195,
		202,
		-1,
		-1,
		-1,
		-1,
		233,
		225,
		233,
		-1,
		205,
		207,
		-1,
		255,
		-1,
		-1,
		248,
		239,
		-1,
		-1,
		210,
		217,
		239,
		242,
		278,
		-1,
		229
	],
	[
		-1,
		129,
		118,
		129,
		137,
		110,
		117,
		-1,
		136,
		140,
		106,
		100,
		139,
		108,
		114,
		125,
		-1,
		-1,
		-1,
		129,
		128,
		96,
		94,
		103,
		108,
		115,
		-1,
		114,
		-1,
		150,
		129,
		140,
		145,
		89,
		86,
		106,
		125,
		107,
		99,
		165,
		119,
		90,
		84,
		102,
		92,
		101,
		93,
		-1,
		90,
		80,
		102,
		81,
		92,
		84,
		-1,
		-1,
		84,
		85,
		91,
		77,
		83,
		79,
		-1,
		89,
		73,
		-1,
		-1,
		74,
		75,
		59,
		62,
		70,
		68,
		81,
		73,
		68,
		-1,
		-1,
		65,
		61,
		68,
		55,
		51,
		68,
		81,
		63,
		77,
		76,
		-1,
		77,
		94,
		94,
		62,
		60,
		44,
		42,
		60,
		62,
		68,
		71,
		-1,
		94,
		90,
		88,
		89,
		84,
		60,
		47,
		47,
		57,
		50,
		69,
		60,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		95,
		86,
		102,
		84,
		74,
		81,
		79,
		50,
		47,
		45,
		42,
		58,
		59,
		69,
		-1,
		-1,
		188,
		161,
		185,
		143,
		125,
		-1,
		91,
		88,
		82,
		78,
		72,
		65,
		79,
		66,
		-1,
		36,
		35,
		66,
		52,
		63,
		170,
		-1,
		-1,
		146,
		138,
		120,
		123,
		100,
		96,
		103,
		102,
		95,
		88,
		84,
		62,
		65,
		65,
		71,
		30,
		40,
		44,
		59,
		70,
		-1,
		-1,
		130,
		-1,
		-1,
		167,
		150,
		-1,
		115,
		122,
		106,
		112,
		98,
		119,
		113,
		104,
		98,
		93,
		85,
		60,
		57,
		70,
		43,
		27,
		52,
		56,
		55,
		76,
		71,
		-1,
		129,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		122,
		119,
		112,
		136,
		135,
		-1,
		133,
		121,
		122,
		107,
		106,
		100,
		88,
		65,
		49,
		49,
		40,
		17,
		15,
		22,
		52,
		74,
		71,
		100,
		105,
		99,
		108,
		-1,
		175,
		171,
		167,
		174,
		123,
		-1,
		-1,
		140,
		-1,
		143,
		156,
		145,
		118,
		121,
		108,
		108,
		95,
		84,
		66,
		47,
		44,
		27,
		15,
		0,
		47,
		46,
		64,
		79,
		92,
		96,
		102,
		-1,
		225,
		-1,
		167,
		151,
		153,
		129,
		157,
		-1,
		160,
		144,
		162,
		147,
		147,
		-1,
		124,
		121,
		113,
		91,
		76,
		59,
		47,
		42,
		32,
		22,
		50,
		41,
		59,
		66,
		74,
		78,
		98,
		110,
		185,
		175,
		-1,
		157,
		162,
		132,
		142,
		161,
		187,
		163,
		-1,
		158,
		-1,
		126,
		139,
		-1,
		97,
		93,
		67,
		55,
		44,
		51,
		35,
		25,
		29,
		47,
		50,
		67,
		71,
		87,
		-1,
		-1,
		170,
		174,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		103,
		100,
		97,
		84,
		69,
		67,
		50,
		56,
		46,
		31,
		34,
		56,
		84,
		62,
		74,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		57,
		73,
		52,
		55,
		35,
		37,
		53,
		65,
		56,
		76,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		112,
		104,
		85,
		74,
		66,
		55,
		53,
		63,
		57,
		37,
		46,
		47,
		71,
		78,
		84,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		68,
		58,
		68,
		65,
		51,
		42,
		57,
		76,
		76,
		68,
		93,
		96,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		72,
		76,
		69,
		72,
		68,
		60,
		61,
		43,
		79,
		-1,
		76,
		70,
		98,
		101,
		91,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		81,
		79,
		73,
		77,
		79,
		68,
		76,
		68,
		48,
		58,
		78,
		82,
		89,
		82,
		87,
		86,
		100,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		88,
		88,
		82,
		90,
		72,
		65,
		51,
		55,
		73,
		100,
		95,
		90,
		89,
		96,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		93,
		108,
		109,
		87,
		91,
		89,
		99,
		87,
		76,
		63,
		67,
		82,
		92,
		84,
		85,
		94,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		107,
		105,
		98,
		89,
		95,
		100,
		96,
		91,
		81,
		70,
		76,
		72,
		94,
		80,
		78,
		97,
		112,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		106,
		90,
		95,
		-1,
		116,
		-1,
		89,
		89,
		80,
		69,
		66,
		77,
		75,
		86,
		103,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		122,
		102,
		96,
		95,
		111,
		106,
		97,
		78,
		71,
		68,
		69,
		82,
		102,
		93,
		105,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		139,
		127,
		117,
		107,
		132,
		122,
		97,
		90,
		76,
		78,
		76,
		78,
		83,
		104,
		105,
		118,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		128,
		-1,
		-1,
		119,
		117,
		114,
		93,
		80,
		100,
		103,
		93,
		77,
		92,
		104,
		112,
		117,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		139,
		134,
		138,
		122,
		-1,
		110,
		104,
		84,
		98,
		105,
		95,
		90,
		84,
		87,
		105,
		122,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		129,
		143,
		127,
		120,
		124,
		-1,
		112,
		100,
		86,
		103,
		108,
		105,
		96,
		88,
		93,
		90,
		103,
		117,
		121,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		147,
		162,
		166,
		143,
		116,
		111,
		104,
		98,
		94,
		110,
		116,
		127,
		95,
		91,
		92,
		96,
		95,
		112,
		122,
		-1,
		-1,
		161,
		178,
		173,
		155,
		159,
		193,
		-1,
		-1,
		120,
		111,
		102,
		105,
		104,
		107,
		101,
		98,
		103,
		108,
		96,
		105,
		123,
		122,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		174,
		191,
		138,
		120,
		116,
		114,
		107,
		116,
		111,
		106,
		116,
		118,
		110,
		98,
		102,
		125,
		114,
		153,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		209,
		185,
		196,
		202,
		194,
		195,
		153,
		150,
		-1,
		120,
		145,
		117,
		124,
		115,
		122,
		122,
		114,
		92,
		99,
		115,
		114,
		109,
		145,
		136,
		142,
		-1,
		-1,
		293,
		282,
		271,
		277,
		-1,
		202,
		198,
		188,
		178,
		181,
		-1,
		-1,
		169,
		166,
		142,
		125,
		123,
		116,
		111,
		121,
		101,
		88,
		92,
		96,
		102,
		107,
		112,
		118,
		133,
		148,
		-1,
		188,
		269,
		262,
		245,
		253,
		284,
		-1,
		192,
		184,
		195,
		170,
		172,
		-1,
		-1,
		142,
		139,
		144,
		132,
		129,
		131,
		126,
		117,
		102,
		108,
		95,
		94,
		112,
		116,
		125,
		132,
		122,
		135,
		139,
		-1,
		202,
		245,
		239,
		242,
		266,
		280,
		-1,
		189,
		-1,
		-1,
		201,
		173,
		157,
		147,
		141,
		191,
		146,
		141,
		125,
		123,
		114,
		105,
		112,
		103,
		103,
		106,
		121,
		126,
		118,
		132,
		132,
		133,
		-1,
		235,
		225,
		233,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		217,
		-1,
		184,
		-1,
		159,
		163,
		154,
		157,
		139,
		126,
		118,
		110,
		126,
		101,
		111,
		107,
		108,
		117,
		128,
		140,
		139,
		140,
		260,
		216,
		219,
		224,
		241,
		256,
		260,
		-1,
		201,
		240,
		238,
		-1,
		222,
		-1,
		-1,
		-1,
		173,
		167,
		159,
		159,
		138,
		138,
		112,
		116,
		106,
		113,
		123,
		125,
		117,
		121,
		134,
		145,
		148,
		256,
		247,
		260,
		205,
		205,
		226,
		235,
		256,
		216,
		207,
		234,
		245,
		234,
		229,
		216,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		145,
		133,
		116,
		117,
		113,
		116,
		131,
		134,
		124,
		122,
		116,
		148,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		196,
		223,
		-1,
		-1,
		218,
		235,
		229,
		233,
		249,
		274,
		-1,
		205,
		-1,
		-1,
		190,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		121,
		132,
		142,
		130,
		131,
		121,
		131,
		144,
		233,
		230,
		218,
		216,
		239,
		204,
		192,
		-1,
		205,
		203,
		209,
		216,
		233,
		263,
		-1,
		-1,
		221,
		201,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		123,
		128,
		148,
		150,
		139,
		133,
		127,
		134,
		133,
		141,
		149,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		190,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		211,
		207,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		141,
		145,
		137,
		130,
		125,
		136,
		128,
		132,
		149,
		-1,
		276,
		-1,
		228,
		204,
		218,
		233,
		241,
		-1,
		-1,
		-1,
		228,
		214,
		207,
		195,
		193,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		131,
		142,
		131,
		134,
		148,
		143,
		-1,
		-1,
		216,
		219,
		-1,
		-1,
		218,
		220,
		-1,
		219,
		208,
		193,
		185,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		135,
		141,
		144,
		133,
		137,
		149,
		-1,
		-1,
		223,
		224,
		225,
		-1,
		203,
		-1,
		221,
		-1,
		188,
		194,
		182,
		-1,
		-1,
		-1,
		176,
		139,
		160,
		170,
		164,
		162,
		153,
		139,
		146,
		144,
		140,
		151,
		-1,
		-1,
		-1,
		221,
		195,
		228,
		219,
		202,
		182,
		174,
		193,
		-1,
		163,
		-1,
		138,
		140,
		166,
		169,
		175,
		169,
		142,
		157,
		147,
		138,
		147,
		227,
		-1,
		197,
		230,
		194,
		188,
		164,
		168,
		184,
		-1,
		160,
		142,
		-1,
		170,
		160,
		191,
		176,
		157,
		144,
		151,
		151,
		144,
		-1,
		-1,
		-1,
		199,
		198,
		190,
		184,
		184,
		169,
		160,
		-1,
		172,
		154,
		133,
		150,
		150,
		141,
		149,
		181,
		177,
		164,
		164,
		156,
		-1,
		300,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		193,
		188,
		161,
		149,
		155,
		151,
		137,
		143,
		145,
		153,
		151,
		148,
		160,
		156,
		176,
		157,
		192,
		-1,
		295,
		-1,
		229,
		-1,
		-1,
		211,
		191,
		183,
		172,
		161,
		159,
		150,
		141,
		163,
		179,
		163,
		161,
		164,
		165,
		-1,
		284,
		283,
		-1,
		230,
		222,
		208,
		-1,
		201,
		-1,
		207,
		168,
		-1,
		170,
		150,
		-1,
		172,
		168,
		-1,
		-1,
		271,
		246,
		-1,
		-1,
		-1,
		231,
		211,
		202,
		186,
		-1,
		161,
		161,
		-1,
		-1,
		-1,
		256,
		255,
		-1,
		224,
		227,
		-1,
		217,
		208,
		216,
		163,
		167,
		-1,
		-1,
		-1,
		265,
		246,
		240,
		239,
		237,
		232,
		229,
		215,
		199,
		177,
		166,
		187,
		-1,
		-1,
		-1,
		237,
		229,
		222,
		-1,
		-1,
		224,
		207,
		188,
		186,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		214,
		-1,
		-1,
		220,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		248,
		-1,
		-1,
		-1,
		210,
		206,
		207,
		-1,
		-1,
		-1,
		-1,
		270,
		271,
		294,
		258,
		-1,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		273,
		271,
		-1,
		-1,
		-1,
		230,
		214,
		-1,
		200,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		235,
		-1,
		235,
		210,
		217,
		-1,
		-1,
		-1,
		-1,
		248,
		240,
		248,
		-1,
		220,
		222,
		-1,
		270,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		225,
		232,
		254,
		257,
		293,
		-1,
		244
	],
	[
		-1,
		138,
		127,
		138,
		146,
		119,
		126,
		-1,
		145,
		149,
		115,
		109,
		148,
		117,
		123,
		134,
		-1,
		-1,
		-1,
		138,
		137,
		105,
		103,
		112,
		117,
		124,
		-1,
		123,
		-1,
		159,
		138,
		149,
		154,
		98,
		95,
		115,
		134,
		116,
		108,
		174,
		128,
		99,
		93,
		111,
		101,
		110,
		102,
		-1,
		99,
		89,
		111,
		90,
		101,
		93,
		-1,
		-1,
		93,
		94,
		100,
		86,
		92,
		88,
		-1,
		94,
		67,
		-1,
		-1,
		83,
		84,
		68,
		71,
		79,
		77,
		90,
		76,
		62,
		-1,
		-1,
		74,
		70,
		77,
		64,
		60,
		77,
		90,
		62,
		49,
		47,
		-1,
		86,
		103,
		103,
		71,
		69,
		53,
		51,
		69,
		64,
		47,
		39,
		-1,
		103,
		99,
		100,
		98,
		93,
		69,
		56,
		56,
		66,
		58,
		41,
		28,
		74,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		95,
		112,
		96,
		86,
		90,
		88,
		59,
		56,
		54,
		51,
		44,
		27,
		37,
		-1,
		-1,
		197,
		170,
		194,
		152,
		134,
		-1,
		100,
		100,
		94,
		90,
		84,
		77,
		90,
		75,
		-1,
		35,
		44,
		34,
		20,
		31,
		179,
		-1,
		-1,
		155,
		147,
		129,
		132,
		109,
		105,
		115,
		114,
		107,
		96,
		92,
		74,
		77,
		77,
		83,
		39,
		30,
		27,
		13,
		38,
		-1,
		-1,
		117,
		-1,
		-1,
		176,
		159,
		-1,
		124,
		131,
		115,
		121,
		107,
		128,
		125,
		116,
		110,
		105,
		94,
		72,
		69,
		82,
		61,
		36,
		37,
		40,
		8,
		32,
		33,
		-1,
		116,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		131,
		128,
		121,
		145,
		144,
		-1,
		141,
		129,
		130,
		115,
		112,
		99,
		87,
		77,
		61,
		61,
		58,
		40,
		38,
		37,
		5,
		30,
		34,
		65,
		92,
		86,
		95,
		-1,
		184,
		180,
		176,
		183,
		132,
		-1,
		-1,
		149,
		-1,
		152,
		165,
		153,
		126,
		129,
		116,
		107,
		94,
		83,
		78,
		59,
		56,
		52,
		32,
		47,
		0,
		3,
		29,
		43,
		79,
		83,
		89,
		-1,
		234,
		-1,
		176,
		160,
		162,
		136,
		157,
		-1,
		169,
		153,
		170,
		155,
		155,
		-1,
		125,
		122,
		112,
		90,
		75,
		71,
		59,
		54,
		45,
		27,
		32,
		7,
		25,
		32,
		51,
		65,
		86,
		97,
		194,
		184,
		-1,
		166,
		171,
		132,
		140,
		159,
		196,
		161,
		-1,
		156,
		-1,
		127,
		140,
		-1,
		96,
		92,
		74,
		67,
		56,
		63,
		38,
		23,
		20,
		13,
		16,
		55,
		56,
		75,
		-1,
		-1,
		179,
		183,
		174,
		125,
		144,
		168,
		205,
		154,
		143,
		142,
		-1,
		133,
		110,
		107,
		95,
		82,
		67,
		68,
		62,
		58,
		37,
		22,
		25,
		22,
		72,
		50,
		62,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		151,
		122,
		146,
		188,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		106,
		85,
		76,
		65,
		63,
		70,
		43,
		46,
		26,
		28,
		28,
		53,
		44,
		64,
		-1,
		-1,
		-1,
		181,
		170,
		171,
		117,
		140,
		177,
		151,
		137,
		142,
		117,
		110,
		104,
		119,
		102,
		83,
		72,
		64,
		53,
		44,
		54,
		48,
		28,
		37,
		35,
		59,
		66,
		72,
		-1,
		-1,
		188,
		178,
		162,
		164,
		161,
		131,
		138,
		170,
		142,
		155,
		-1,
		109,
		-1,
		98,
		93,
		77,
		72,
		69,
		62,
		49,
		59,
		56,
		42,
		33,
		48,
		64,
		64,
		56,
		81,
		84,
		-1,
		-1,
		-1,
		181,
		176,
		151,
		128,
		112,
		148,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		79,
		75,
		66,
		70,
		64,
		63,
		59,
		51,
		52,
		34,
		69,
		-1,
		64,
		58,
		86,
		89,
		79,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		78,
		73,
		71,
		71,
		70,
		59,
		67,
		59,
		39,
		49,
		69,
		73,
		77,
		70,
		75,
		74,
		88,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		99,
		83,
		83,
		82,
		73,
		81,
		63,
		56,
		42,
		46,
		64,
		88,
		83,
		81,
		80,
		84,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		95,
		90,
		106,
		107,
		85,
		82,
		80,
		90,
		78,
		67,
		54,
		58,
		73,
		83,
		75,
		76,
		85,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		104,
		102,
		96,
		87,
		93,
		91,
		87,
		82,
		72,
		61,
		67,
		63,
		85,
		71,
		69,
		85,
		100,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		104,
		88,
		93,
		-1,
		107,
		-1,
		80,
		80,
		71,
		60,
		57,
		68,
		66,
		77,
		91,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		120,
		100,
		94,
		93,
		102,
		97,
		88,
		69,
		62,
		59,
		60,
		73,
		93,
		84,
		93,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		137,
		125,
		115,
		105,
		123,
		113,
		88,
		81,
		67,
		69,
		67,
		69,
		74,
		95,
		96,
		108,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		126,
		-1,
		-1,
		117,
		115,
		105,
		84,
		71,
		91,
		94,
		84,
		68,
		83,
		95,
		100,
		108,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		130,
		125,
		129,
		120,
		-1,
		101,
		95,
		75,
		89,
		96,
		86,
		81,
		75,
		78,
		96,
		111,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		118,
		111,
		115,
		-1,
		103,
		91,
		77,
		94,
		99,
		96,
		87,
		79,
		84,
		81,
		94,
		108,
		112,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		145,
		160,
		157,
		134,
		107,
		102,
		95,
		89,
		85,
		101,
		107,
		118,
		86,
		82,
		83,
		87,
		86,
		103,
		113,
		-1,
		-1,
		159,
		176,
		171,
		153,
		157,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		95,
		98,
		92,
		89,
		94,
		99,
		87,
		96,
		114,
		113,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		172,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		97,
		107,
		109,
		101,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		200,
		183,
		187,
		193,
		192,
		186,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		106,
		113,
		113,
		105,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		193,
		189,
		179,
		169,
		172,
		-1,
		-1,
		160,
		157,
		133,
		116,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		186,
		267,
		260,
		242,
		250,
		281,
		-1,
		183,
		175,
		186,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		123,
		120,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		200,
		243,
		236,
		239,
		263,
		277,
		-1,
		180,
		-1,
		-1,
		192,
		164,
		148,
		138,
		132,
		182,
		137,
		132,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		226,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		208,
		-1,
		175,
		-1,
		150,
		154,
		145,
		148,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		251,
		207,
		210,
		221,
		232,
		247,
		251,
		-1,
		192,
		231,
		229,
		-1,
		213,
		-1,
		-1,
		-1,
		164,
		158,
		150,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		207,
		198,
		225,
		236,
		225,
		220,
		207,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		226,
		220,
		224,
		240,
		265,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		214,
		215,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		140,
		129,
		140,
		148,
		121,
		128,
		-1,
		147,
		151,
		117,
		111,
		150,
		119,
		125,
		136,
		-1,
		-1,
		-1,
		140,
		139,
		107,
		105,
		114,
		119,
		126,
		-1,
		125,
		-1,
		161,
		140,
		151,
		156,
		100,
		97,
		117,
		136,
		118,
		110,
		176,
		130,
		101,
		95,
		113,
		103,
		112,
		104,
		-1,
		101,
		91,
		113,
		92,
		103,
		95,
		-1,
		-1,
		95,
		96,
		102,
		88,
		94,
		90,
		-1,
		98,
		71,
		-1,
		-1,
		85,
		86,
		70,
		73,
		81,
		79,
		92,
		80,
		66,
		-1,
		-1,
		76,
		72,
		79,
		66,
		62,
		79,
		92,
		66,
		53,
		51,
		-1,
		88,
		105,
		105,
		73,
		71,
		55,
		53,
		71,
		68,
		51,
		43,
		-1,
		105,
		101,
		102,
		100,
		95,
		71,
		58,
		58,
		68,
		61,
		45,
		32,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		97,
		114,
		98,
		88,
		92,
		90,
		61,
		58,
		56,
		53,
		48,
		31,
		41,
		-1,
		-1,
		199,
		172,
		196,
		154,
		136,
		-1,
		102,
		102,
		96,
		92,
		86,
		79,
		92,
		77,
		-1,
		39,
		46,
		38,
		24,
		35,
		181,
		-1,
		-1,
		157,
		149,
		131,
		134,
		111,
		107,
		117,
		116,
		109,
		98,
		94,
		76,
		79,
		79,
		85,
		41,
		34,
		31,
		17,
		42,
		-1,
		-1,
		120,
		-1,
		-1,
		178,
		161,
		-1,
		126,
		133,
		117,
		123,
		109,
		130,
		127,
		118,
		112,
		107,
		96,
		74,
		71,
		84,
		63,
		38,
		41,
		44,
		12,
		36,
		37,
		-1,
		119,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		133,
		130,
		123,
		147,
		146,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		79,
		63,
		63,
		60,
		42,
		40,
		41,
		9,
		34,
		38,
		69,
		95,
		89,
		98,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		151,
		-1,
		154,
		167,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		80,
		61,
		58,
		54,
		34,
		49,
		4,
		0,
		32,
		47,
		82,
		86,
		92,
		-1,
		236,
		-1,
		178,
		162,
		164,
		138,
		159,
		-1,
		171,
		155,
		172,
		157,
		157,
		-1,
		127,
		124,
		114,
		92,
		77,
		73,
		61,
		56,
		47,
		29,
		34,
		9,
		27,
		34,
		54,
		68,
		88,
		100,
		196,
		186,
		-1,
		168,
		173,
		134,
		142,
		161,
		198,
		163,
		-1,
		158,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		69,
		58,
		65,
		40,
		25,
		22,
		15,
		18,
		57,
		59,
		77,
		-1,
		-1,
		181,
		185,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		112,
		109,
		97,
		84,
		69,
		70,
		64,
		60,
		39,
		24,
		27,
		24,
		74,
		52,
		64,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		65,
		72,
		45,
		48,
		28,
		30,
		30,
		55,
		46,
		66,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		121,
		104,
		85,
		74,
		66,
		55,
		46,
		56,
		50,
		30,
		39,
		37,
		61,
		68,
		74,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		64,
		51,
		61,
		58,
		44,
		35,
		50,
		66,
		66,
		58,
		83,
		86,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		68,
		72,
		66,
		65,
		61,
		53,
		54,
		36,
		71,
		-1,
		66,
		60,
		88,
		91,
		81,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		80,
		75,
		73,
		73,
		72,
		61,
		69,
		61,
		41,
		51,
		71,
		75,
		79,
		72,
		77,
		76,
		90,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		85,
		84,
		75,
		83,
		65,
		58,
		44,
		48,
		66,
		90,
		85,
		83,
		82,
		86,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		92,
		108,
		109,
		87,
		84,
		82,
		92,
		80,
		69,
		56,
		60,
		75,
		85,
		77,
		78,
		87,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		106,
		104,
		98,
		89,
		95,
		93,
		89,
		84,
		74,
		63,
		69,
		65,
		87,
		73,
		71,
		87,
		102,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		106,
		90,
		95,
		-1,
		109,
		-1,
		82,
		82,
		73,
		62,
		59,
		70,
		68,
		79,
		93,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		122,
		102,
		96,
		95,
		104,
		99,
		90,
		71,
		64,
		61,
		62,
		75,
		95,
		86,
		95,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		139,
		127,
		117,
		107,
		125,
		115,
		90,
		83,
		69,
		71,
		69,
		71,
		76,
		97,
		98,
		110,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		128,
		-1,
		-1,
		119,
		117,
		107,
		86,
		73,
		93,
		96,
		86,
		70,
		85,
		97,
		102,
		110,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		132,
		127,
		131,
		122,
		-1,
		103,
		97,
		77,
		91,
		98,
		88,
		83,
		77,
		80,
		98,
		113,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		129,
		143,
		120,
		113,
		117,
		-1,
		105,
		93,
		79,
		96,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		147,
		162,
		159,
		136,
		109,
		104,
		97,
		91,
		87,
		103,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		161,
		178,
		173,
		155,
		159,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		97,
		100,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		115,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		174,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		111,
		103,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		202,
		185,
		189,
		195,
		194,
		188,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		108,
		115,
		115,
		107,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		195,
		191,
		181,
		171,
		174,
		-1,
		-1,
		162,
		159,
		135,
		118,
		116,
		109,
		104,
		114,
		94,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		188,
		269,
		262,
		244,
		252,
		283,
		-1,
		185,
		177,
		188,
		163,
		165,
		-1,
		-1,
		135,
		132,
		137,
		125,
		122,
		124,
		119,
		110,
		95,
		101,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		202,
		245,
		238,
		241,
		265,
		279,
		-1,
		182,
		-1,
		-1,
		194,
		166,
		150,
		140,
		134,
		184,
		139,
		134,
		118,
		116,
		107,
		98,
		105,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		126,
		-1,
		228,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		210,
		-1,
		177,
		-1,
		152,
		156,
		147,
		150,
		132,
		119,
		111,
		103,
		119,
		94,
		104,
		100,
		101,
		110,
		121,
		133,
		132,
		133,
		253,
		209,
		212,
		223,
		234,
		249,
		253,
		-1,
		194,
		233,
		231,
		-1,
		215,
		-1,
		-1,
		-1,
		166,
		160,
		152,
		152,
		131,
		131,
		105,
		109,
		99,
		106,
		116,
		118,
		110,
		114,
		127,
		138,
		141,
		249,
		240,
		253,
		198,
		198,
		219,
		228,
		249,
		209,
		200,
		227,
		238,
		227,
		222,
		209,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		138,
		126,
		109,
		110,
		106,
		109,
		124,
		127,
		117,
		115,
		109,
		141,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		216,
		-1,
		-1,
		211,
		228,
		222,
		226,
		242,
		267,
		-1,
		198,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		131,
		120,
		111,
		117,
		114,
		125,
		135,
		123,
		124,
		114,
		124,
		137,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		198,
		196,
		202,
		209,
		226,
		256,
		-1,
		-1,
		214,
		194,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		116,
		121,
		141,
		143,
		132,
		126,
		120,
		127,
		126,
		134,
		142,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		134,
		138,
		130,
		123,
		118,
		129,
		121,
		125,
		142,
		-1,
		269,
		-1,
		221,
		197,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		174,
		142,
		147,
		142,
		124,
		135,
		124,
		127,
		141,
		136,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		211,
		213,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		131,
		156,
		145,
		153,
		148,
		128,
		134,
		137,
		126,
		130,
		142,
		-1,
		-1,
		216,
		217,
		218,
		-1,
		196,
		-1,
		214,
		-1,
		181,
		187,
		175,
		-1,
		-1,
		-1,
		169,
		132,
		153,
		163,
		157,
		155,
		146,
		132,
		139,
		137,
		133,
		144,
		-1,
		-1,
		-1,
		214,
		188,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		131,
		133,
		159,
		162,
		168,
		162,
		135,
		150,
		140,
		131,
		140,
		220,
		-1,
		190,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		135,
		-1,
		163,
		153,
		184,
		169,
		150,
		137,
		144,
		144,
		137,
		-1,
		-1,
		-1,
		192,
		191,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		174,
		170,
		157,
		157,
		149,
		-1,
		293,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		150,
		185,
		-1,
		288,
		-1,
		222,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		157,
		158,
		-1,
		277,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		167,
		171,
		137,
		131,
		170,
		139,
		145,
		156,
		-1,
		-1,
		-1,
		160,
		159,
		127,
		125,
		134,
		139,
		146,
		-1,
		145,
		-1,
		181,
		160,
		171,
		176,
		120,
		117,
		137,
		156,
		138,
		130,
		196,
		150,
		121,
		115,
		133,
		123,
		132,
		124,
		-1,
		121,
		111,
		133,
		112,
		123,
		115,
		-1,
		-1,
		115,
		116,
		122,
		108,
		114,
		110,
		-1,
		115,
		88,
		-1,
		-1,
		105,
		106,
		90,
		93,
		101,
		99,
		111,
		97,
		83,
		-1,
		-1,
		96,
		92,
		99,
		86,
		82,
		99,
		112,
		83,
		70,
		68,
		-1,
		108,
		125,
		125,
		93,
		91,
		75,
		73,
		91,
		85,
		68,
		60,
		-1,
		125,
		121,
		122,
		120,
		115,
		91,
		78,
		78,
		88,
		79,
		62,
		49,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		117,
		134,
		118,
		108,
		112,
		110,
		81,
		78,
		76,
		72,
		65,
		48,
		58,
		-1,
		-1,
		219,
		192,
		216,
		174,
		156,
		-1,
		122,
		122,
		116,
		112,
		106,
		99,
		112,
		97,
		-1,
		56,
		65,
		55,
		41,
		52,
		201,
		-1,
		-1,
		177,
		169,
		151,
		154,
		131,
		127,
		137,
		136,
		129,
		118,
		114,
		96,
		99,
		99,
		105,
		61,
		51,
		48,
		34,
		34,
		-1,
		-1,
		88,
		-1,
		-1,
		198,
		181,
		-1,
		146,
		153,
		137,
		143,
		129,
		150,
		147,
		138,
		132,
		127,
		116,
		94,
		91,
		104,
		83,
		58,
		58,
		61,
		29,
		24,
		19,
		-1,
		87,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		153,
		150,
		143,
		167,
		166,
		-1,
		163,
		151,
		152,
		137,
		134,
		121,
		109,
		99,
		83,
		83,
		80,
		62,
		60,
		54,
		26,
		22,
		19,
		49,
		63,
		57,
		66,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		171,
		-1,
		174,
		187,
		175,
		148,
		151,
		138,
		129,
		116,
		105,
		100,
		81,
		78,
		74,
		54,
		69,
		31,
		34,
		0,
		27,
		50,
		54,
		60,
		-1,
		256,
		-1,
		198,
		182,
		184,
		158,
		179,
		-1,
		191,
		175,
		192,
		177,
		177,
		-1,
		147,
		144,
		134,
		112,
		97,
		93,
		81,
		76,
		67,
		49,
		54,
		29,
		15,
		12,
		22,
		36,
		58,
		68,
		216,
		206,
		-1,
		188,
		193,
		154,
		162,
		181,
		218,
		183,
		-1,
		178,
		-1,
		149,
		162,
		-1,
		118,
		114,
		96,
		89,
		78,
		85,
		60,
		45,
		42,
		21,
		24,
		26,
		27,
		52,
		-1,
		-1,
		201,
		205,
		196,
		147,
		166,
		190,
		227,
		176,
		165,
		164,
		-1,
		155,
		132,
		129,
		117,
		104,
		89,
		90,
		84,
		80,
		59,
		44,
		47,
		30,
		45,
		32,
		57,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		173,
		144,
		168,
		210,
		194,
		187,
		175,
		140,
		140,
		134,
		-1,
		128,
		107,
		98,
		87,
		85,
		92,
		65,
		68,
		48,
		50,
		36,
		43,
		39,
		59,
		-1,
		-1,
		-1,
		203,
		192,
		193,
		139,
		162,
		199,
		173,
		159,
		164,
		139,
		132,
		126,
		141,
		124,
		105,
		94,
		86,
		75,
		66,
		76,
		70,
		50,
		59,
		43,
		54,
		61,
		67,
		-1,
		-1,
		210,
		200,
		184,
		186,
		183,
		153,
		160,
		192,
		164,
		177,
		-1,
		131,
		-1,
		120,
		115,
		99,
		94,
		91,
		84,
		71,
		81,
		78,
		64,
		55,
		70,
		59,
		59,
		51,
		76,
		79,
		-1,
		-1,
		-1,
		203,
		198,
		173,
		150,
		134,
		170,
		-1,
		147,
		148,
		-1,
		125,
		119,
		116,
		101,
		97,
		88,
		92,
		86,
		85,
		81,
		73,
		74,
		56,
		77,
		-1,
		59,
		53,
		81,
		84,
		74,
		-1,
		-1,
		-1,
		196,
		175,
		168,
		188,
		129,
		181,
		-1,
		-1,
		132,
		125,
		-1,
		112,
		94,
		100,
		95,
		93,
		93,
		92,
		81,
		89,
		81,
		61,
		71,
		91,
		74,
		72,
		65,
		70,
		69,
		83,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		149,
		-1,
		141,
		133,
		123,
		117,
		111,
		107,
		105,
		121,
		105,
		105,
		104,
		95,
		103,
		85,
		78,
		64,
		68,
		86,
		83,
		78,
		84,
		76,
		79,
		-1,
		216,
		202,
		173,
		-1,
		-1,
		162,
		-1,
		126,
		140,
		156,
		-1,
		149,
		128,
		143,
		121,
		117,
		112,
		128,
		129,
		107,
		104,
		102,
		112,
		100,
		89,
		76,
		80,
		95,
		93,
		79,
		79,
		81,
		-1,
		222,
		209,
		167,
		163,
		152,
		172,
		123,
		111,
		143,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		126,
		124,
		118,
		109,
		115,
		113,
		109,
		104,
		94,
		83,
		89,
		85,
		101,
		87,
		85,
		80,
		95,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		138,
		125,
		119,
		-1,
		160,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		126,
		110,
		115,
		-1,
		129,
		-1,
		102,
		102,
		93,
		82,
		79,
		90,
		88,
		99,
		86,
		-1,
		172,
		157,
		150,
		140,
		154,
		125,
		-1,
		180,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		142,
		122,
		116,
		115,
		124,
		119,
		110,
		91,
		84,
		81,
		82,
		95,
		115,
		100,
		88,
		-1,
		-1,
		-1,
		177,
		163,
		167,
		127,
		146,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		137,
		159,
		147,
		137,
		127,
		145,
		135,
		110,
		103,
		89,
		91,
		89,
		91,
		96,
		101,
		93,
		103,
		-1,
		-1,
		160,
		165,
		153,
		139,
		158,
		-1,
		-1,
		-1,
		159,
		175,
		167,
		138,
		148,
		-1,
		-1,
		139,
		137,
		127,
		106,
		93,
		113,
		116,
		106,
		90,
		105,
		107,
		95,
		104,
		-1,
		163,
		150,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		152,
		147,
		151,
		142,
		-1,
		123,
		117,
		97,
		111,
		118,
		108,
		103,
		97,
		100,
		112,
		106,
		-1,
		-1,
		175,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		149,
		163,
		140,
		133,
		137,
		-1,
		125,
		113,
		99,
		116,
		121,
		118,
		109,
		101,
		106,
		103,
		116,
		118,
		108,
		198,
		-1,
		181,
		-1,
		-1,
		-1,
		167,
		182,
		179,
		156,
		129,
		124,
		117,
		111,
		107,
		123,
		129,
		140,
		108,
		104,
		105,
		109,
		108,
		122,
		123,
		-1,
		-1,
		181,
		198,
		193,
		175,
		179,
		206,
		-1,
		-1,
		133,
		124,
		115,
		118,
		117,
		120,
		114,
		111,
		116,
		121,
		109,
		118,
		136,
		126,
		-1,
		-1,
		-1,
		201,
		-1,
		216,
		-1,
		-1,
		194,
		204,
		151,
		133,
		129,
		127,
		120,
		129,
		124,
		119,
		129,
		131,
		123,
		111,
		115,
		138,
		127,
		155,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		222,
		205,
		209,
		215,
		214,
		208,
		166,
		163,
		-1,
		133,
		158,
		130,
		137,
		128,
		135,
		135,
		127,
		105,
		112,
		128,
		127,
		122,
		147,
		142,
		151,
		-1,
		-1,
		312,
		301,
		290,
		296,
		-1,
		215,
		211,
		201,
		191,
		194,
		-1,
		-1,
		182,
		179,
		155,
		138,
		136,
		129,
		124,
		134,
		114,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		157,
		-1,
		208,
		289,
		282,
		264,
		272,
		303,
		-1,
		205,
		197,
		208,
		183,
		185,
		-1,
		-1,
		155,
		152,
		157,
		145,
		142,
		144,
		139,
		130,
		115,
		121,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		222,
		265,
		258,
		261,
		285,
		299,
		-1,
		202,
		-1,
		-1,
		214,
		186,
		170,
		160,
		154,
		204,
		159,
		154,
		138,
		136,
		127,
		118,
		125,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		248,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		230,
		-1,
		197,
		-1,
		172,
		176,
		167,
		170,
		152,
		139,
		131,
		123,
		139,
		114,
		124,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		273,
		229,
		232,
		243,
		254,
		269,
		273,
		-1,
		214,
		253,
		251,
		-1,
		235,
		-1,
		-1,
		-1,
		186,
		180,
		172,
		172,
		151,
		151,
		125,
		129,
		119,
		126,
		136,
		138,
		130,
		134,
		147,
		158,
		161,
		269,
		260,
		273,
		218,
		218,
		239,
		248,
		269,
		229,
		220,
		247,
		258,
		247,
		242,
		229,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		158,
		146,
		129,
		130,
		126,
		129,
		144,
		147,
		137,
		135,
		129,
		161,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		209,
		236,
		-1,
		-1,
		231,
		248,
		242,
		246,
		262,
		287,
		-1,
		218,
		-1,
		-1,
		203,
		-1,
		-1,
		188,
		151,
		140,
		131,
		137,
		134,
		145,
		155,
		143,
		144,
		134,
		144,
		157,
		246,
		243,
		231,
		229,
		252,
		217,
		205,
		-1,
		218,
		216,
		222,
		229,
		246,
		276,
		-1,
		-1,
		234,
		214,
		-1,
		-1,
		186,
		184,
		173,
		-1,
		163,
		136,
		141,
		161,
		163,
		152,
		146,
		140,
		147,
		146,
		154,
		162,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		203,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		224,
		220,
		-1,
		-1,
		181,
		174,
		162,
		150,
		140,
		150,
		154,
		158,
		150,
		143,
		138,
		149,
		141,
		145,
		162,
		-1,
		289,
		-1,
		241,
		217,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		241,
		227,
		220,
		208,
		206,
		-1,
		215,
		199,
		180,
		-1,
		150,
		163,
		194,
		162,
		167,
		162,
		144,
		155,
		144,
		147,
		161,
		156,
		-1,
		-1,
		229,
		232,
		-1,
		-1,
		231,
		233,
		-1,
		232,
		221,
		206,
		198,
		-1,
		-1,
		187,
		183,
		-1,
		-1,
		151,
		176,
		165,
		173,
		168,
		148,
		154,
		157,
		146,
		150,
		162,
		-1,
		-1,
		236,
		237,
		238,
		-1,
		216,
		-1,
		234,
		-1,
		201,
		207,
		195,
		-1,
		-1,
		-1,
		189,
		152,
		173,
		183,
		177,
		175,
		166,
		152,
		159,
		157,
		153,
		164,
		-1,
		-1,
		-1,
		234,
		208,
		241,
		232,
		215,
		195,
		187,
		206,
		-1,
		176,
		-1,
		151,
		153,
		179,
		182,
		188,
		182,
		155,
		170,
		160,
		151,
		160,
		240,
		-1,
		210,
		243,
		207,
		201,
		177,
		181,
		197,
		-1,
		173,
		155,
		-1,
		183,
		173,
		204,
		189,
		170,
		157,
		164,
		164,
		157,
		-1,
		-1,
		-1,
		212,
		211,
		203,
		197,
		197,
		182,
		173,
		-1,
		185,
		167,
		146,
		163,
		163,
		154,
		162,
		194,
		190,
		177,
		177,
		169,
		-1,
		313,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		206,
		201,
		174,
		162,
		168,
		164,
		150,
		156,
		158,
		166,
		164,
		161,
		173,
		169,
		189,
		170,
		205,
		-1,
		308,
		-1,
		242,
		-1,
		-1,
		224,
		204,
		196,
		185,
		174,
		172,
		163,
		154,
		176,
		192,
		176,
		174,
		177,
		178,
		-1,
		297,
		296,
		-1,
		243,
		235,
		221,
		-1,
		214,
		-1,
		220,
		181,
		-1,
		183,
		163,
		-1,
		185,
		181,
		-1,
		-1,
		284,
		259,
		-1,
		-1,
		-1,
		244,
		224,
		215,
		199,
		-1,
		174,
		174,
		-1,
		-1,
		-1,
		269,
		268,
		-1,
		237,
		240,
		-1,
		230,
		221,
		229,
		176,
		180,
		-1,
		-1,
		-1,
		278,
		259,
		253,
		252,
		250,
		245,
		242,
		228,
		212,
		190,
		179,
		200,
		-1,
		-1,
		-1,
		250,
		242,
		235,
		-1,
		-1,
		237,
		220,
		201,
		199,
		-1,
		-1,
		-1,
		272,
		253,
		-1,
		-1,
		227,
		-1,
		-1,
		233,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		261,
		-1,
		-1,
		-1,
		223,
		219,
		220,
		-1,
		-1,
		-1,
		-1,
		283,
		284,
		307,
		271,
		-1,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		286,
		284,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		213,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		248,
		-1,
		248,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		261,
		-1,
		233,
		235,
		-1,
		283,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		238,
		245,
		267,
		270,
		306,
		-1,
		257
	],
	[
		-1,
		177,
		166,
		177,
		185,
		158,
		165,
		-1,
		184,
		188,
		154,
		148,
		187,
		156,
		162,
		173,
		-1,
		-1,
		-1,
		177,
		176,
		144,
		142,
		151,
		156,
		163,
		-1,
		162,
		-1,
		198,
		177,
		188,
		193,
		137,
		134,
		154,
		173,
		155,
		147,
		213,
		167,
		138,
		132,
		150,
		140,
		149,
		141,
		-1,
		138,
		128,
		150,
		129,
		140,
		132,
		-1,
		-1,
		132,
		133,
		139,
		125,
		131,
		127,
		-1,
		128,
		101,
		-1,
		-1,
		122,
		123,
		107,
		110,
		118,
		116,
		124,
		110,
		96,
		-1,
		-1,
		113,
		109,
		116,
		103,
		99,
		116,
		127,
		96,
		83,
		81,
		-1,
		125,
		142,
		142,
		110,
		108,
		92,
		90,
		108,
		98,
		81,
		73,
		-1,
		142,
		138,
		139,
		137,
		132,
		108,
		95,
		95,
		105,
		92,
		75,
		62,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		134,
		151,
		135,
		125,
		129,
		127,
		98,
		95,
		93,
		85,
		78,
		61,
		66,
		-1,
		-1,
		236,
		209,
		233,
		191,
		173,
		-1,
		139,
		139,
		133,
		129,
		123,
		116,
		129,
		114,
		-1,
		69,
		78,
		68,
		54,
		60,
		218,
		-1,
		-1,
		194,
		186,
		168,
		171,
		148,
		144,
		154,
		153,
		146,
		135,
		131,
		113,
		116,
		116,
		122,
		78,
		64,
		61,
		51,
		32,
		-1,
		-1,
		87,
		-1,
		-1,
		215,
		198,
		-1,
		163,
		170,
		154,
		160,
		146,
		167,
		164,
		155,
		149,
		144,
		133,
		111,
		108,
		121,
		100,
		75,
		70,
		73,
		46,
		22,
		17,
		-1,
		86,
		70,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		170,
		167,
		160,
		184,
		183,
		-1,
		180,
		168,
		169,
		154,
		151,
		138,
		126,
		116,
		100,
		100,
		97,
		79,
		77,
		71,
		43,
		21,
		11,
		31,
		62,
		56,
		65,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		188,
		-1,
		191,
		204,
		192,
		165,
		168,
		155,
		146,
		133,
		122,
		117,
		98,
		95,
		91,
		71,
		86,
		48,
		51,
		29,
		0,
		49,
		53,
		59,
		-1,
		273,
		-1,
		215,
		199,
		201,
		175,
		196,
		-1,
		208,
		192,
		209,
		194,
		194,
		-1,
		164,
		161,
		151,
		129,
		114,
		110,
		98,
		93,
		84,
		66,
		71,
		46,
		40,
		35,
		12,
		35,
		57,
		67,
		233,
		223,
		-1,
		205,
		210,
		171,
		179,
		198,
		235,
		200,
		-1,
		195,
		-1,
		166,
		179,
		-1,
		135,
		131,
		113,
		106,
		95,
		102,
		77,
		62,
		59,
		38,
		41,
		25,
		26,
		51,
		-1,
		-1,
		218,
		222,
		213,
		164,
		183,
		207,
		244,
		193,
		182,
		181,
		-1,
		172,
		149,
		146,
		134,
		121,
		106,
		107,
		101,
		97,
		76,
		61,
		64,
		47,
		44,
		31,
		56,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		190,
		161,
		185,
		227,
		211,
		204,
		192,
		157,
		157,
		151,
		-1,
		145,
		124,
		115,
		104,
		102,
		109,
		82,
		83,
		65,
		65,
		53,
		42,
		38,
		58,
		-1,
		-1,
		-1,
		220,
		209,
		210,
		156,
		179,
		216,
		190,
		176,
		181,
		156,
		149,
		143,
		158,
		141,
		122,
		111,
		103,
		92,
		83,
		93,
		87,
		63,
		68,
		48,
		53,
		60,
		66,
		-1,
		-1,
		227,
		217,
		201,
		203,
		200,
		170,
		177,
		209,
		181,
		194,
		-1,
		148,
		-1,
		137,
		132,
		116,
		111,
		108,
		101,
		88,
		94,
		92,
		73,
		68,
		80,
		58,
		58,
		50,
		75,
		78,
		-1,
		-1,
		-1,
		220,
		215,
		190,
		167,
		151,
		187,
		-1,
		164,
		165,
		-1,
		142,
		136,
		133,
		118,
		114,
		105,
		109,
		103,
		102,
		94,
		86,
		87,
		69,
		82,
		-1,
		58,
		52,
		80,
		83,
		73,
		-1,
		-1,
		-1,
		213,
		192,
		185,
		205,
		146,
		198,
		-1,
		-1,
		149,
		142,
		-1,
		129,
		111,
		117,
		112,
		110,
		110,
		107,
		96,
		102,
		94,
		74,
		84,
		96,
		73,
		71,
		64,
		69,
		68,
		82,
		-1,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		166,
		-1,
		158,
		150,
		140,
		134,
		128,
		124,
		122,
		138,
		122,
		122,
		119,
		110,
		118,
		98,
		91,
		77,
		81,
		91,
		82,
		77,
		83,
		75,
		78,
		-1,
		233,
		219,
		190,
		-1,
		-1,
		179,
		-1,
		143,
		157,
		173,
		-1,
		166,
		145,
		160,
		138,
		134,
		129,
		145,
		146,
		124,
		119,
		117,
		125,
		113,
		102,
		89,
		93,
		95,
		92,
		78,
		78,
		80,
		-1,
		239,
		226,
		184,
		180,
		169,
		189,
		140,
		128,
		160,
		-1,
		-1,
		202,
		-1,
		136,
		153,
		143,
		141,
		135,
		126,
		132,
		128,
		122,
		117,
		107,
		96,
		102,
		98,
		100,
		86,
		84,
		79,
		94,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		155,
		142,
		136,
		-1,
		177,
		-1,
		180,
		170,
		154,
		139,
		172,
		-1,
		143,
		127,
		132,
		-1,
		142,
		-1,
		115,
		115,
		106,
		95,
		92,
		96,
		87,
		100,
		85,
		-1,
		189,
		174,
		167,
		157,
		171,
		142,
		-1,
		197,
		-1,
		-1,
		167,
		161,
		161,
		145,
		148,
		159,
		139,
		133,
		132,
		137,
		132,
		123,
		104,
		97,
		94,
		95,
		108,
		120,
		99,
		87,
		-1,
		-1,
		-1,
		194,
		180,
		184,
		144,
		163,
		-1,
		-1,
		229,
		184,
		170,
		-1,
		154,
		176,
		164,
		154,
		144,
		158,
		148,
		123,
		116,
		102,
		104,
		102,
		104,
		109,
		100,
		92,
		102,
		-1,
		-1,
		177,
		182,
		170,
		156,
		175,
		-1,
		-1,
		-1,
		176,
		192,
		184,
		155,
		165,
		-1,
		-1,
		156,
		150,
		140,
		119,
		106,
		126,
		129,
		119,
		103,
		116,
		106,
		94,
		103,
		-1,
		180,
		167,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		165,
		160,
		164,
		158,
		-1,
		136,
		130,
		110,
		124,
		131,
		121,
		116,
		110,
		111,
		111,
		105,
		-1,
		-1,
		192,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		166,
		180,
		153,
		146,
		150,
		-1,
		138,
		126,
		112,
		129,
		134,
		131,
		122,
		114,
		119,
		108,
		121,
		117,
		107,
		215,
		-1,
		198,
		-1,
		-1,
		-1,
		184,
		199,
		192,
		169,
		142,
		137,
		130,
		124,
		120,
		136,
		142,
		153,
		121,
		117,
		118,
		114,
		113,
		121,
		122,
		-1,
		-1,
		198,
		215,
		210,
		192,
		196,
		219,
		-1,
		-1,
		146,
		137,
		128,
		131,
		130,
		133,
		127,
		124,
		129,
		131,
		122,
		123,
		140,
		125,
		-1,
		-1,
		-1,
		218,
		-1,
		233,
		-1,
		-1,
		211,
		217,
		164,
		146,
		142,
		140,
		133,
		142,
		137,
		132,
		142,
		144,
		136,
		121,
		128,
		151,
		133,
		154,
		-1,
		-1,
		332,
		-1,
		-1,
		-1,
		235,
		222,
		222,
		228,
		230,
		221,
		179,
		176,
		-1,
		146,
		171,
		143,
		150,
		141,
		148,
		148,
		140,
		118,
		125,
		141,
		140,
		135,
		146,
		141,
		150,
		-1,
		-1,
		325,
		314,
		303,
		309,
		-1,
		228,
		224,
		214,
		204,
		207,
		-1,
		-1,
		195,
		192,
		168,
		151,
		149,
		142,
		137,
		147,
		127,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		148,
		156,
		-1,
		225,
		306,
		299,
		277,
		285,
		316,
		-1,
		218,
		210,
		221,
		196,
		198,
		-1,
		-1,
		168,
		165,
		170,
		158,
		155,
		157,
		152,
		143,
		128,
		134,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		239,
		282,
		271,
		274,
		298,
		312,
		-1,
		215,
		-1,
		-1,
		227,
		199,
		183,
		173,
		167,
		217,
		172,
		167,
		151,
		149,
		140,
		131,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		261,
		262,
		265,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		243,
		-1,
		210,
		-1,
		185,
		189,
		180,
		183,
		165,
		152,
		144,
		136,
		152,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		286,
		242,
		245,
		256,
		267,
		282,
		286,
		-1,
		227,
		266,
		264,
		-1,
		248,
		-1,
		-1,
		-1,
		199,
		193,
		185,
		185,
		164,
		164,
		138,
		142,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		282,
		273,
		286,
		231,
		231,
		252,
		261,
		282,
		242,
		233,
		260,
		271,
		260,
		255,
		242,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		171,
		159,
		142,
		143,
		139,
		142,
		157,
		160,
		150,
		148,
		142,
		174,
		-1,
		275,
		274,
		263,
		260,
		236,
		227,
		222,
		249,
		-1,
		-1,
		244,
		261,
		255,
		259,
		275,
		300,
		-1,
		231,
		-1,
		-1,
		216,
		-1,
		-1,
		201,
		164,
		153,
		144,
		150,
		147,
		158,
		168,
		156,
		157,
		147,
		157,
		170,
		259,
		256,
		244,
		242,
		265,
		230,
		218,
		-1,
		231,
		229,
		235,
		242,
		259,
		289,
		-1,
		-1,
		247,
		227,
		-1,
		-1,
		199,
		197,
		186,
		-1,
		176,
		149,
		154,
		174,
		176,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		268,
		282,
		271,
		267,
		266,
		274,
		223,
		216,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		237,
		233,
		-1,
		-1,
		194,
		187,
		175,
		163,
		153,
		163,
		167,
		171,
		163,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		302,
		-1,
		254,
		230,
		244,
		259,
		267,
		-1,
		-1,
		-1,
		254,
		240,
		233,
		221,
		219,
		-1,
		228,
		212,
		193,
		-1,
		163,
		176,
		207,
		175,
		180,
		175,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		242,
		245,
		-1,
		-1,
		244,
		246,
		-1,
		245,
		234,
		219,
		211,
		-1,
		-1,
		200,
		196,
		-1,
		-1,
		164,
		189,
		178,
		186,
		181,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		249,
		250,
		251,
		-1,
		229,
		-1,
		247,
		-1,
		214,
		220,
		208,
		-1,
		-1,
		-1,
		202,
		165,
		186,
		196,
		190,
		188,
		179,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		247,
		221,
		254,
		245,
		228,
		208,
		200,
		219,
		-1,
		189,
		-1,
		164,
		166,
		192,
		195,
		201,
		195,
		168,
		183,
		173,
		164,
		173,
		253,
		-1,
		223,
		256,
		220,
		214,
		190,
		194,
		210,
		-1,
		186,
		168,
		-1,
		196,
		186,
		217,
		202,
		183,
		170,
		177,
		177,
		170,
		-1,
		-1,
		-1,
		225,
		224,
		216,
		210,
		210,
		195,
		186,
		-1,
		198,
		180,
		159,
		176,
		176,
		167,
		175,
		207,
		203,
		190,
		190,
		182,
		-1,
		326,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		219,
		214,
		187,
		175,
		181,
		177,
		163,
		169,
		171,
		179,
		177,
		174,
		186,
		182,
		202,
		183,
		218,
		-1,
		321,
		-1,
		255,
		-1,
		-1,
		237,
		217,
		209,
		198,
		187,
		185,
		176,
		167,
		189,
		205,
		189,
		187,
		190,
		191,
		-1,
		310,
		309,
		-1,
		256,
		248,
		234,
		-1,
		227,
		-1,
		233,
		194,
		-1,
		196,
		176,
		-1,
		198,
		194,
		-1,
		-1,
		297,
		272,
		-1,
		-1,
		-1,
		257,
		237,
		228,
		212,
		-1,
		187,
		187,
		-1,
		-1,
		-1,
		282,
		281,
		-1,
		250,
		253,
		-1,
		243,
		234,
		242,
		189,
		193,
		-1,
		-1,
		-1,
		291,
		272,
		266,
		265,
		263,
		258,
		255,
		241,
		225,
		203,
		192,
		213,
		-1,
		-1,
		-1,
		263,
		255,
		248,
		-1,
		-1,
		250,
		233,
		214,
		212,
		-1,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		240,
		-1,
		-1,
		246,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		274,
		-1,
		-1,
		-1,
		236,
		232,
		233,
		-1,
		-1,
		-1,
		-1,
		296,
		297,
		320,
		284,
		-1,
		-1,
		-1,
		228,
		222,
		-1,
		-1,
		299,
		297,
		-1,
		-1,
		-1,
		256,
		240,
		-1,
		226,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		261,
		-1,
		261,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		274,
		266,
		274,
		-1,
		246,
		248,
		-1,
		296,
		-1,
		-1,
		289,
		280,
		-1,
		-1,
		251,
		258,
		280,
		283,
		319,
		-1,
		270
	],
	[
		-1,
		184,
		173,
		184,
		192,
		165,
		172,
		-1,
		191,
		195,
		161,
		155,
		194,
		163,
		169,
		180,
		-1,
		-1,
		-1,
		184,
		183,
		151,
		149,
		158,
		163,
		170,
		-1,
		169,
		-1,
		205,
		184,
		195,
		200,
		144,
		141,
		161,
		180,
		162,
		154,
		220,
		174,
		145,
		139,
		157,
		147,
		156,
		148,
		-1,
		145,
		135,
		157,
		136,
		147,
		139,
		-1,
		-1,
		139,
		140,
		146,
		132,
		138,
		134,
		-1,
		144,
		128,
		-1,
		-1,
		129,
		130,
		114,
		117,
		125,
		123,
		136,
		128,
		123,
		-1,
		-1,
		120,
		116,
		123,
		110,
		106,
		123,
		136,
		118,
		110,
		108,
		-1,
		132,
		149,
		149,
		117,
		115,
		99,
		97,
		115,
		117,
		108,
		100,
		-1,
		149,
		145,
		146,
		144,
		139,
		115,
		102,
		102,
		112,
		105,
		102,
		89,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		141,
		158,
		142,
		132,
		136,
		134,
		105,
		102,
		100,
		97,
		105,
		88,
		98,
		-1,
		-1,
		243,
		216,
		240,
		198,
		180,
		-1,
		146,
		146,
		140,
		136,
		130,
		123,
		136,
		121,
		-1,
		91,
		90,
		95,
		81,
		92,
		225,
		-1,
		-1,
		201,
		193,
		175,
		178,
		155,
		151,
		161,
		160,
		153,
		141,
		137,
		120,
		123,
		123,
		129,
		85,
		91,
		88,
		74,
		72,
		-1,
		-1,
		69,
		-1,
		-1,
		222,
		205,
		-1,
		170,
		177,
		161,
		167,
		153,
		174,
		171,
		162,
		156,
		151,
		139,
		118,
		115,
		128,
		107,
		82,
		98,
		101,
		69,
		62,
		57,
		-1,
		68,
		52,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		177,
		174,
		167,
		191,
		190,
		-1,
		186,
		174,
		175,
		160,
		157,
		144,
		132,
		123,
		107,
		107,
		104,
		86,
		84,
		94,
		66,
		61,
		51,
		39,
		44,
		38,
		47,
		-1,
		230,
		226,
		222,
		229,
		178,
		-1,
		-1,
		195,
		-1,
		198,
		211,
		198,
		171,
		174,
		161,
		152,
		139,
		128,
		124,
		105,
		102,
		98,
		78,
		93,
		71,
		72,
		40,
		40,
		0,
		35,
		41,
		-1,
		280,
		-1,
		222,
		206,
		208,
		181,
		202,
		-1,
		215,
		199,
		215,
		200,
		200,
		-1,
		170,
		167,
		157,
		135,
		120,
		117,
		105,
		100,
		91,
		73,
		87,
		67,
		53,
		44,
		30,
		20,
		39,
		49,
		240,
		230,
		-1,
		212,
		217,
		177,
		185,
		204,
		242,
		206,
		-1,
		201,
		-1,
		172,
		185,
		-1,
		141,
		137,
		119,
		113,
		102,
		109,
		84,
		69,
		66,
		59,
		62,
		26,
		27,
		33,
		-1,
		-1,
		225,
		229,
		219,
		170,
		189,
		213,
		250,
		199,
		188,
		187,
		-1,
		178,
		155,
		152,
		140,
		127,
		112,
		113,
		108,
		104,
		83,
		68,
		70,
		60,
		45,
		32,
		57,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		196,
		167,
		191,
		233,
		217,
		210,
		198,
		163,
		163,
		157,
		-1,
		151,
		130,
		121,
		110,
		108,
		116,
		89,
		84,
		68,
		66,
		55,
		43,
		39,
		59,
		-1,
		-1,
		-1,
		226,
		215,
		216,
		162,
		185,
		222,
		196,
		182,
		187,
		162,
		155,
		149,
		164,
		147,
		128,
		117,
		109,
		98,
		90,
		96,
		88,
		64,
		69,
		49,
		54,
		61,
		67,
		-1,
		-1,
		233,
		223,
		207,
		209,
		206,
		176,
		183,
		215,
		187,
		200,
		-1,
		154,
		-1,
		143,
		138,
		122,
		117,
		114,
		108,
		95,
		95,
		93,
		74,
		69,
		81,
		59,
		59,
		51,
		76,
		79,
		-1,
		-1,
		-1,
		226,
		221,
		196,
		173,
		157,
		193,
		-1,
		170,
		171,
		-1,
		148,
		142,
		139,
		124,
		120,
		112,
		116,
		110,
		105,
		95,
		87,
		88,
		70,
		83,
		-1,
		59,
		53,
		81,
		84,
		74,
		-1,
		-1,
		-1,
		219,
		198,
		191,
		211,
		152,
		204,
		-1,
		-1,
		155,
		148,
		-1,
		135,
		117,
		124,
		119,
		116,
		117,
		108,
		97,
		103,
		95,
		75,
		85,
		97,
		74,
		72,
		65,
		70,
		69,
		83,
		-1,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		172,
		-1,
		164,
		156,
		146,
		140,
		134,
		130,
		128,
		144,
		128,
		129,
		120,
		111,
		119,
		99,
		92,
		78,
		82,
		92,
		83,
		78,
		84,
		76,
		79,
		-1,
		239,
		225,
		196,
		-1,
		-1,
		185,
		-1,
		149,
		163,
		179,
		-1,
		172,
		151,
		166,
		144,
		140,
		136,
		151,
		152,
		130,
		120,
		118,
		126,
		114,
		103,
		90,
		94,
		96,
		93,
		79,
		79,
		81,
		-1,
		245,
		232,
		190,
		186,
		175,
		195,
		146,
		134,
		166,
		-1,
		-1,
		208,
		-1,
		142,
		159,
		150,
		148,
		141,
		132,
		138,
		129,
		123,
		118,
		108,
		97,
		103,
		99,
		101,
		87,
		85,
		80,
		95,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		161,
		148,
		142,
		-1,
		183,
		-1,
		186,
		176,
		160,
		145,
		178,
		-1,
		149,
		133,
		138,
		-1,
		143,
		-1,
		116,
		116,
		107,
		96,
		93,
		97,
		88,
		101,
		86,
		-1,
		195,
		180,
		173,
		163,
		177,
		148,
		-1,
		203,
		-1,
		-1,
		173,
		167,
		167,
		151,
		154,
		165,
		145,
		139,
		138,
		138,
		133,
		124,
		105,
		98,
		95,
		96,
		109,
		121,
		100,
		88,
		-1,
		-1,
		-1,
		200,
		186,
		190,
		150,
		169,
		-1,
		-1,
		235,
		190,
		176,
		-1,
		160,
		182,
		170,
		160,
		150,
		159,
		149,
		124,
		117,
		103,
		105,
		103,
		105,
		110,
		101,
		93,
		103,
		-1,
		-1,
		183,
		188,
		176,
		162,
		181,
		-1,
		-1,
		-1,
		182,
		198,
		190,
		161,
		171,
		-1,
		-1,
		160,
		151,
		141,
		120,
		107,
		127,
		130,
		120,
		104,
		117,
		107,
		95,
		104,
		-1,
		186,
		173,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		-1,
		-1,
		215,
		177,
		166,
		161,
		165,
		159,
		-1,
		137,
		131,
		111,
		125,
		132,
		122,
		117,
		111,
		112,
		112,
		106,
		-1,
		-1,
		198,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		172,
		183,
		154,
		147,
		151,
		-1,
		139,
		127,
		113,
		130,
		135,
		132,
		123,
		115,
		120,
		109,
		122,
		118,
		108,
		221,
		-1,
		204,
		-1,
		-1,
		-1,
		190,
		205,
		193,
		170,
		143,
		138,
		131,
		125,
		121,
		137,
		143,
		154,
		122,
		118,
		119,
		115,
		114,
		122,
		123,
		-1,
		-1,
		204,
		221,
		216,
		198,
		202,
		220,
		-1,
		-1,
		147,
		138,
		129,
		132,
		131,
		134,
		128,
		125,
		130,
		132,
		123,
		124,
		141,
		126,
		-1,
		-1,
		-1,
		224,
		-1,
		239,
		-1,
		-1,
		217,
		218,
		165,
		147,
		143,
		141,
		134,
		143,
		138,
		133,
		143,
		145,
		137,
		122,
		129,
		152,
		134,
		155,
		-1,
		-1,
		333,
		-1,
		-1,
		-1,
		236,
		228,
		223,
		229,
		231,
		222,
		180,
		177,
		-1,
		147,
		172,
		144,
		151,
		142,
		149,
		149,
		141,
		119,
		126,
		142,
		141,
		136,
		147,
		142,
		151,
		-1,
		-1,
		326,
		315,
		304,
		310,
		-1,
		229,
		225,
		215,
		205,
		208,
		-1,
		-1,
		196,
		193,
		169,
		152,
		150,
		143,
		138,
		148,
		128,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		149,
		157,
		-1,
		231,
		312,
		305,
		278,
		286,
		317,
		-1,
		219,
		211,
		222,
		197,
		199,
		-1,
		-1,
		169,
		166,
		171,
		159,
		156,
		158,
		153,
		144,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		245,
		288,
		272,
		275,
		299,
		313,
		-1,
		216,
		-1,
		-1,
		228,
		200,
		184,
		174,
		168,
		218,
		173,
		168,
		152,
		150,
		141,
		132,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		262,
		268,
		266,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		244,
		-1,
		211,
		-1,
		186,
		190,
		181,
		184,
		166,
		153,
		145,
		137,
		153,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		287,
		243,
		246,
		257,
		268,
		283,
		287,
		-1,
		228,
		267,
		265,
		-1,
		249,
		-1,
		-1,
		-1,
		200,
		194,
		186,
		186,
		165,
		165,
		139,
		143,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		283,
		274,
		287,
		232,
		232,
		253,
		262,
		283,
		243,
		234,
		261,
		272,
		261,
		256,
		243,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		172,
		160,
		143,
		144,
		140,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		276,
		275,
		264,
		261,
		237,
		228,
		223,
		250,
		-1,
		-1,
		245,
		262,
		256,
		260,
		276,
		301,
		-1,
		232,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		165,
		154,
		145,
		151,
		148,
		159,
		169,
		157,
		158,
		148,
		158,
		171,
		260,
		257,
		245,
		243,
		266,
		231,
		219,
		-1,
		232,
		230,
		236,
		243,
		260,
		290,
		-1,
		-1,
		248,
		228,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		150,
		155,
		175,
		177,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		269,
		283,
		272,
		268,
		267,
		275,
		224,
		217,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		238,
		234,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		168,
		172,
		164,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		303,
		-1,
		255,
		231,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		255,
		241,
		234,
		222,
		220,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		208,
		176,
		181,
		176,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		245,
		247,
		-1,
		246,
		235,
		220,
		212,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		165,
		190,
		179,
		187,
		182,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		250,
		251,
		252,
		-1,
		230,
		-1,
		248,
		-1,
		215,
		221,
		209,
		-1,
		-1,
		-1,
		203,
		166,
		187,
		197,
		191,
		189,
		180,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		248,
		222,
		255,
		246,
		229,
		209,
		201,
		220,
		-1,
		190,
		-1,
		165,
		167,
		193,
		196,
		202,
		196,
		169,
		184,
		174,
		165,
		174,
		254,
		-1,
		224,
		257,
		221,
		215,
		191,
		195,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		218,
		203,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		226,
		225,
		217,
		211,
		211,
		196,
		187,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		208,
		204,
		191,
		191,
		183,
		-1,
		327,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		220,
		215,
		188,
		176,
		182,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		184,
		219,
		-1,
		322,
		-1,
		256,
		-1,
		-1,
		238,
		218,
		210,
		199,
		188,
		186,
		177,
		168,
		190,
		206,
		190,
		188,
		191,
		192,
		-1,
		311,
		310,
		-1,
		257,
		249,
		235,
		-1,
		228,
		-1,
		234,
		195,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		298,
		273,
		-1,
		-1,
		-1,
		258,
		238,
		229,
		213,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		283,
		282,
		-1,
		251,
		254,
		-1,
		244,
		235,
		243,
		190,
		194,
		-1,
		-1,
		-1,
		292,
		273,
		267,
		266,
		264,
		259,
		256,
		242,
		226,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		264,
		256,
		249,
		-1,
		-1,
		251,
		234,
		215,
		213,
		-1,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		241,
		-1,
		-1,
		247,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		275,
		-1,
		-1,
		-1,
		237,
		233,
		234,
		-1,
		-1,
		-1,
		-1,
		297,
		298,
		321,
		285,
		-1,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		300,
		298,
		-1,
		-1,
		-1,
		257,
		241,
		-1,
		227,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		262,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		275,
		267,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		290,
		281,
		-1,
		-1,
		252,
		259,
		281,
		284,
		320,
		-1,
		271
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		192,
		196,
		162,
		156,
		195,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		185,
		184,
		152,
		150,
		159,
		164,
		171,
		-1,
		170,
		-1,
		206,
		185,
		196,
		201,
		145,
		142,
		162,
		181,
		163,
		155,
		221,
		175,
		146,
		140,
		158,
		148,
		157,
		149,
		-1,
		146,
		136,
		158,
		137,
		148,
		140,
		-1,
		-1,
		140,
		141,
		147,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		130,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		111,
		109,
		-1,
		133,
		150,
		150,
		118,
		116,
		100,
		98,
		116,
		118,
		109,
		101,
		-1,
		150,
		146,
		147,
		145,
		140,
		116,
		103,
		103,
		113,
		106,
		103,
		90,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		142,
		159,
		143,
		133,
		137,
		135,
		106,
		103,
		101,
		98,
		106,
		89,
		99,
		-1,
		-1,
		244,
		217,
		241,
		199,
		181,
		-1,
		147,
		147,
		141,
		137,
		131,
		124,
		137,
		122,
		-1,
		92,
		91,
		96,
		82,
		93,
		226,
		-1,
		-1,
		202,
		194,
		176,
		179,
		156,
		152,
		162,
		161,
		154,
		142,
		138,
		121,
		124,
		124,
		130,
		86,
		92,
		89,
		75,
		73,
		-1,
		-1,
		38,
		-1,
		-1,
		223,
		206,
		-1,
		171,
		178,
		162,
		168,
		154,
		175,
		172,
		163,
		157,
		152,
		140,
		119,
		116,
		129,
		108,
		83,
		99,
		102,
		70,
		63,
		58,
		-1,
		37,
		21,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		178,
		175,
		168,
		192,
		191,
		-1,
		187,
		175,
		176,
		161,
		158,
		145,
		133,
		124,
		108,
		108,
		105,
		87,
		85,
		95,
		67,
		62,
		52,
		40,
		13,
		3,
		12,
		-1,
		231,
		227,
		223,
		230,
		179,
		-1,
		-1,
		196,
		-1,
		199,
		212,
		199,
		172,
		175,
		162,
		153,
		140,
		129,
		125,
		106,
		103,
		99,
		79,
		94,
		72,
		73,
		41,
		41,
		32,
		0,
		6,
		-1,
		281,
		-1,
		223,
		207,
		209,
		182,
		203,
		-1,
		216,
		200,
		216,
		201,
		201,
		-1,
		171,
		168,
		158,
		136,
		121,
		118,
		106,
		101,
		92,
		74,
		88,
		68,
		54,
		45,
		31,
		18,
		7,
		18,
		241,
		231,
		-1,
		213,
		218,
		178,
		186,
		205,
		243,
		207,
		-1,
		202,
		-1,
		173,
		186,
		-1,
		142,
		138,
		120,
		114,
		103,
		110,
		85,
		70,
		67,
		60,
		63,
		27,
		28,
		16,
		-1,
		-1,
		226,
		230,
		220,
		171,
		190,
		214,
		251,
		200,
		189,
		188,
		-1,
		179,
		156,
		153,
		141,
		128,
		113,
		114,
		109,
		105,
		84,
		69,
		71,
		61,
		46,
		33,
		58,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		197,
		168,
		192,
		234,
		218,
		211,
		199,
		164,
		164,
		158,
		-1,
		152,
		131,
		122,
		111,
		109,
		117,
		90,
		85,
		69,
		67,
		56,
		44,
		40,
		60,
		-1,
		-1,
		-1,
		227,
		216,
		217,
		163,
		186,
		223,
		197,
		183,
		188,
		163,
		156,
		150,
		165,
		148,
		129,
		118,
		110,
		99,
		91,
		97,
		89,
		65,
		70,
		50,
		55,
		62,
		68,
		-1,
		-1,
		234,
		224,
		208,
		210,
		207,
		177,
		184,
		216,
		188,
		201,
		-1,
		155,
		-1,
		144,
		139,
		123,
		118,
		115,
		109,
		96,
		96,
		94,
		75,
		70,
		82,
		60,
		60,
		52,
		77,
		80,
		-1,
		-1,
		-1,
		227,
		222,
		197,
		174,
		158,
		194,
		-1,
		171,
		172,
		-1,
		149,
		143,
		140,
		125,
		121,
		113,
		117,
		111,
		106,
		96,
		88,
		89,
		71,
		84,
		-1,
		60,
		54,
		82,
		85,
		75,
		-1,
		-1,
		-1,
		220,
		199,
		192,
		212,
		153,
		205,
		-1,
		-1,
		156,
		149,
		-1,
		136,
		118,
		125,
		120,
		117,
		118,
		109,
		98,
		104,
		96,
		76,
		86,
		98,
		75,
		73,
		66,
		71,
		70,
		84,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		173,
		-1,
		165,
		157,
		147,
		141,
		135,
		131,
		129,
		145,
		129,
		130,
		121,
		112,
		120,
		100,
		93,
		79,
		83,
		93,
		84,
		79,
		85,
		77,
		80,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		186,
		-1,
		150,
		164,
		180,
		-1,
		173,
		152,
		167,
		145,
		141,
		137,
		152,
		153,
		131,
		121,
		119,
		127,
		115,
		104,
		91,
		95,
		97,
		94,
		80,
		80,
		82,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		147,
		135,
		167,
		-1,
		-1,
		209,
		-1,
		143,
		160,
		151,
		149,
		142,
		133,
		139,
		130,
		124,
		119,
		109,
		98,
		104,
		100,
		102,
		88,
		86,
		81,
		96,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		184,
		-1,
		187,
		177,
		161,
		146,
		179,
		-1,
		150,
		134,
		139,
		-1,
		144,
		-1,
		117,
		117,
		108,
		97,
		94,
		98,
		89,
		102,
		87,
		-1,
		196,
		181,
		174,
		164,
		178,
		149,
		-1,
		204,
		-1,
		-1,
		174,
		168,
		168,
		152,
		155,
		166,
		146,
		140,
		139,
		139,
		134,
		125,
		106,
		99,
		96,
		97,
		110,
		122,
		101,
		89,
		-1,
		-1,
		-1,
		201,
		187,
		191,
		151,
		170,
		-1,
		-1,
		236,
		191,
		177,
		-1,
		161,
		183,
		171,
		161,
		151,
		160,
		150,
		125,
		118,
		104,
		106,
		104,
		106,
		111,
		102,
		94,
		104,
		-1,
		-1,
		184,
		189,
		177,
		163,
		182,
		-1,
		-1,
		-1,
		183,
		199,
		191,
		162,
		172,
		-1,
		-1,
		161,
		152,
		142,
		121,
		108,
		128,
		131,
		121,
		105,
		118,
		108,
		96,
		105,
		-1,
		187,
		174,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		-1,
		-1,
		216,
		178,
		167,
		162,
		166,
		160,
		-1,
		138,
		132,
		112,
		126,
		133,
		123,
		118,
		112,
		113,
		113,
		107,
		-1,
		-1,
		199,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		173,
		184,
		155,
		148,
		152,
		-1,
		140,
		128,
		114,
		131,
		136,
		133,
		124,
		116,
		121,
		110,
		123,
		119,
		109,
		222,
		-1,
		205,
		-1,
		-1,
		-1,
		191,
		206,
		194,
		171,
		144,
		139,
		132,
		126,
		122,
		138,
		144,
		155,
		123,
		119,
		120,
		116,
		115,
		123,
		124,
		-1,
		-1,
		205,
		222,
		217,
		199,
		203,
		221,
		-1,
		-1,
		148,
		139,
		130,
		133,
		132,
		135,
		129,
		126,
		131,
		133,
		124,
		125,
		142,
		127,
		-1,
		-1,
		-1,
		225,
		-1,
		240,
		-1,
		-1,
		218,
		219,
		166,
		148,
		144,
		142,
		135,
		144,
		139,
		134,
		144,
		146,
		138,
		123,
		130,
		153,
		135,
		156,
		-1,
		-1,
		334,
		-1,
		-1,
		-1,
		237,
		229,
		224,
		230,
		232,
		223,
		181,
		178,
		-1,
		148,
		173,
		145,
		152,
		143,
		150,
		150,
		142,
		120,
		127,
		143,
		142,
		137,
		148,
		143,
		152,
		-1,
		-1,
		327,
		316,
		305,
		311,
		-1,
		230,
		226,
		216,
		206,
		209,
		-1,
		-1,
		197,
		194,
		170,
		153,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		150,
		158,
		-1,
		232,
		313,
		306,
		279,
		287,
		318,
		-1,
		220,
		212,
		223,
		198,
		200,
		-1,
		-1,
		170,
		167,
		172,
		160,
		157,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		246,
		289,
		273,
		276,
		300,
		314,
		-1,
		217,
		-1,
		-1,
		229,
		201,
		185,
		175,
		169,
		219,
		174,
		169,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		263,
		269,
		267,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		245,
		-1,
		212,
		-1,
		187,
		191,
		182,
		185,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		288,
		244,
		247,
		258,
		269,
		284,
		288,
		-1,
		229,
		268,
		266,
		-1,
		250,
		-1,
		-1,
		-1,
		201,
		195,
		187,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		284,
		275,
		288,
		233,
		233,
		254,
		263,
		284,
		244,
		235,
		262,
		273,
		262,
		257,
		244,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		224,
		251,
		-1,
		-1,
		246,
		263,
		257,
		261,
		277,
		302,
		-1,
		233,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		261,
		258,
		246,
		244,
		267,
		232,
		220,
		-1,
		233,
		231,
		237,
		244,
		261,
		291,
		-1,
		-1,
		249,
		229,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		218,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		235,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		304,
		-1,
		256,
		232,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		251,
		252,
		253,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		200,
		204,
		170,
		164,
		203,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		193,
		192,
		160,
		158,
		167,
		172,
		179,
		-1,
		178,
		-1,
		214,
		193,
		204,
		209,
		153,
		150,
		170,
		189,
		171,
		163,
		229,
		183,
		154,
		148,
		166,
		156,
		165,
		157,
		-1,
		154,
		144,
		166,
		145,
		156,
		148,
		-1,
		-1,
		148,
		149,
		155,
		141,
		147,
		143,
		-1,
		153,
		137,
		-1,
		-1,
		138,
		139,
		123,
		126,
		134,
		132,
		145,
		137,
		132,
		-1,
		-1,
		129,
		125,
		132,
		119,
		115,
		132,
		145,
		127,
		119,
		117,
		-1,
		141,
		158,
		158,
		126,
		124,
		108,
		106,
		124,
		126,
		117,
		109,
		-1,
		158,
		154,
		155,
		153,
		148,
		124,
		111,
		111,
		121,
		114,
		111,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		150,
		167,
		151,
		141,
		145,
		143,
		114,
		111,
		109,
		106,
		114,
		97,
		107,
		-1,
		-1,
		252,
		225,
		249,
		207,
		189,
		-1,
		155,
		155,
		149,
		145,
		139,
		132,
		145,
		130,
		-1,
		100,
		99,
		104,
		90,
		101,
		234,
		-1,
		-1,
		210,
		202,
		184,
		187,
		164,
		160,
		170,
		169,
		162,
		150,
		146,
		129,
		132,
		132,
		138,
		94,
		100,
		97,
		83,
		81,
		-1,
		-1,
		46,
		-1,
		-1,
		231,
		214,
		-1,
		179,
		186,
		170,
		176,
		162,
		183,
		180,
		171,
		165,
		160,
		148,
		127,
		124,
		137,
		116,
		91,
		107,
		110,
		78,
		71,
		66,
		-1,
		45,
		29,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		186,
		183,
		176,
		200,
		199,
		-1,
		195,
		183,
		184,
		169,
		166,
		153,
		141,
		132,
		116,
		116,
		113,
		95,
		93,
		103,
		75,
		70,
		60,
		48,
		21,
		2,
		6,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		204,
		-1,
		207,
		220,
		207,
		180,
		183,
		170,
		161,
		148,
		137,
		133,
		114,
		111,
		107,
		87,
		102,
		80,
		81,
		49,
		49,
		40,
		8,
		0,
		-1,
		289,
		-1,
		231,
		215,
		217,
		190,
		211,
		-1,
		224,
		208,
		224,
		209,
		209,
		-1,
		179,
		176,
		166,
		144,
		129,
		126,
		114,
		109,
		100,
		82,
		96,
		76,
		62,
		53,
		39,
		26,
		15,
		26,
		249,
		239,
		-1,
		221,
		226,
		186,
		194,
		213,
		251,
		215,
		-1,
		210,
		-1,
		181,
		194,
		-1,
		150,
		146,
		128,
		122,
		111,
		118,
		93,
		78,
		75,
		68,
		71,
		35,
		36,
		24,
		-1,
		-1,
		234,
		238,
		228,
		179,
		198,
		222,
		259,
		208,
		197,
		196,
		-1,
		187,
		164,
		161,
		149,
		136,
		121,
		122,
		117,
		113,
		92,
		77,
		79,
		69,
		54,
		41,
		66,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		205,
		176,
		200,
		242,
		226,
		219,
		207,
		172,
		172,
		166,
		-1,
		160,
		139,
		130,
		119,
		117,
		125,
		98,
		93,
		77,
		75,
		64,
		52,
		48,
		68,
		-1,
		-1,
		-1,
		235,
		224,
		225,
		171,
		194,
		231,
		205,
		191,
		196,
		171,
		164,
		158,
		173,
		156,
		137,
		126,
		118,
		107,
		99,
		105,
		97,
		73,
		78,
		58,
		63,
		70,
		76,
		-1,
		-1,
		242,
		232,
		216,
		218,
		215,
		185,
		192,
		224,
		196,
		209,
		-1,
		163,
		-1,
		152,
		147,
		131,
		126,
		123,
		117,
		104,
		104,
		102,
		83,
		78,
		90,
		68,
		68,
		60,
		85,
		88,
		-1,
		-1,
		-1,
		235,
		230,
		205,
		182,
		166,
		202,
		-1,
		179,
		180,
		-1,
		157,
		151,
		148,
		133,
		129,
		121,
		125,
		119,
		114,
		104,
		96,
		97,
		79,
		92,
		-1,
		68,
		62,
		90,
		93,
		83,
		-1,
		-1,
		-1,
		228,
		207,
		200,
		220,
		161,
		213,
		-1,
		-1,
		164,
		157,
		-1,
		144,
		126,
		133,
		128,
		125,
		126,
		117,
		106,
		112,
		104,
		84,
		94,
		106,
		83,
		81,
		74,
		79,
		78,
		92,
		-1,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		181,
		-1,
		173,
		165,
		155,
		149,
		143,
		139,
		137,
		153,
		137,
		138,
		129,
		120,
		128,
		108,
		101,
		87,
		91,
		101,
		92,
		87,
		93,
		85,
		88,
		-1,
		248,
		234,
		205,
		-1,
		-1,
		194,
		-1,
		158,
		172,
		188,
		-1,
		181,
		160,
		175,
		153,
		149,
		145,
		160,
		161,
		139,
		129,
		127,
		135,
		123,
		112,
		99,
		103,
		105,
		102,
		88,
		88,
		90,
		-1,
		254,
		241,
		199,
		195,
		184,
		204,
		155,
		143,
		175,
		-1,
		-1,
		217,
		-1,
		151,
		168,
		159,
		157,
		150,
		141,
		147,
		138,
		132,
		127,
		117,
		106,
		112,
		108,
		110,
		96,
		94,
		89,
		104,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		170,
		157,
		151,
		-1,
		192,
		-1,
		195,
		185,
		169,
		154,
		187,
		-1,
		158,
		142,
		147,
		-1,
		152,
		-1,
		125,
		125,
		116,
		105,
		102,
		106,
		97,
		110,
		95,
		-1,
		204,
		189,
		182,
		172,
		186,
		157,
		-1,
		212,
		-1,
		-1,
		182,
		176,
		176,
		160,
		163,
		174,
		154,
		148,
		147,
		147,
		142,
		133,
		114,
		107,
		104,
		105,
		118,
		130,
		109,
		97,
		-1,
		-1,
		-1,
		209,
		195,
		199,
		159,
		178,
		-1,
		-1,
		244,
		199,
		185,
		-1,
		169,
		191,
		179,
		169,
		159,
		168,
		158,
		133,
		126,
		112,
		114,
		112,
		114,
		119,
		110,
		102,
		112,
		-1,
		-1,
		192,
		197,
		185,
		171,
		190,
		-1,
		-1,
		-1,
		191,
		207,
		199,
		170,
		180,
		-1,
		-1,
		169,
		160,
		150,
		129,
		116,
		136,
		139,
		129,
		113,
		126,
		116,
		104,
		113,
		-1,
		195,
		182,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		-1,
		-1,
		224,
		186,
		175,
		170,
		174,
		168,
		-1,
		146,
		140,
		120,
		134,
		141,
		131,
		126,
		120,
		121,
		121,
		115,
		-1,
		-1,
		207,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		181,
		192,
		163,
		156,
		160,
		-1,
		148,
		136,
		122,
		139,
		144,
		141,
		132,
		124,
		129,
		118,
		131,
		127,
		117,
		230,
		-1,
		213,
		-1,
		-1,
		-1,
		199,
		214,
		202,
		179,
		152,
		147,
		140,
		134,
		130,
		146,
		152,
		163,
		131,
		127,
		128,
		124,
		123,
		131,
		132,
		-1,
		-1,
		213,
		230,
		225,
		207,
		211,
		229,
		-1,
		-1,
		156,
		147,
		138,
		141,
		140,
		143,
		137,
		134,
		139,
		141,
		132,
		133,
		150,
		135,
		-1,
		-1,
		-1,
		233,
		-1,
		248,
		-1,
		-1,
		226,
		227,
		174,
		156,
		152,
		150,
		143,
		152,
		147,
		142,
		152,
		154,
		146,
		131,
		138,
		161,
		143,
		164,
		-1,
		-1,
		342,
		-1,
		-1,
		-1,
		245,
		237,
		232,
		238,
		240,
		231,
		189,
		186,
		-1,
		156,
		181,
		153,
		160,
		151,
		158,
		158,
		150,
		128,
		135,
		151,
		150,
		145,
		156,
		151,
		160,
		-1,
		-1,
		335,
		324,
		313,
		319,
		-1,
		238,
		234,
		224,
		214,
		217,
		-1,
		-1,
		205,
		202,
		178,
		161,
		159,
		152,
		147,
		157,
		137,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		158,
		166,
		-1,
		240,
		321,
		314,
		287,
		295,
		326,
		-1,
		228,
		220,
		231,
		206,
		208,
		-1,
		-1,
		178,
		175,
		180,
		168,
		165,
		167,
		162,
		153,
		138,
		144,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		254,
		297,
		281,
		284,
		308,
		322,
		-1,
		225,
		-1,
		-1,
		237,
		209,
		193,
		183,
		177,
		227,
		182,
		177,
		161,
		159,
		150,
		141,
		148,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		271,
		277,
		275,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		253,
		-1,
		220,
		-1,
		195,
		199,
		190,
		193,
		175,
		162,
		154,
		146,
		162,
		137,
		147,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		296,
		252,
		255,
		266,
		277,
		292,
		296,
		-1,
		237,
		276,
		274,
		-1,
		258,
		-1,
		-1,
		-1,
		209,
		203,
		195,
		195,
		174,
		174,
		148,
		152,
		142,
		149,
		159,
		161,
		153,
		157,
		170,
		181,
		184,
		292,
		283,
		296,
		241,
		241,
		262,
		271,
		292,
		252,
		243,
		270,
		281,
		270,
		265,
		252,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		181,
		169,
		152,
		153,
		149,
		152,
		167,
		170,
		160,
		158,
		152,
		184,
		-1,
		285,
		284,
		273,
		270,
		246,
		237,
		232,
		259,
		-1,
		-1,
		254,
		271,
		265,
		269,
		285,
		310,
		-1,
		241,
		-1,
		-1,
		226,
		-1,
		-1,
		211,
		174,
		163,
		154,
		160,
		157,
		168,
		178,
		166,
		167,
		157,
		167,
		180,
		269,
		266,
		254,
		252,
		275,
		240,
		228,
		-1,
		241,
		239,
		245,
		252,
		269,
		299,
		-1,
		-1,
		257,
		237,
		-1,
		-1,
		209,
		207,
		196,
		-1,
		186,
		159,
		164,
		184,
		186,
		175,
		169,
		163,
		170,
		169,
		177,
		185,
		278,
		292,
		281,
		277,
		276,
		284,
		233,
		226,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		243,
		-1,
		-1,
		204,
		197,
		185,
		173,
		163,
		173,
		177,
		181,
		173,
		166,
		161,
		172,
		164,
		168,
		185,
		-1,
		312,
		-1,
		264,
		240,
		254,
		269,
		277,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		238,
		222,
		203,
		-1,
		173,
		186,
		217,
		185,
		190,
		185,
		167,
		178,
		167,
		170,
		184,
		179,
		-1,
		-1,
		252,
		255,
		-1,
		-1,
		254,
		256,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		210,
		206,
		-1,
		-1,
		174,
		199,
		188,
		196,
		191,
		171,
		177,
		180,
		169,
		173,
		185,
		-1,
		-1,
		259,
		260,
		261,
		-1,
		239,
		-1,
		257,
		-1,
		224,
		230,
		218,
		-1,
		-1,
		-1,
		212,
		175,
		196,
		206,
		200,
		198,
		189,
		175,
		182,
		180,
		176,
		187,
		-1,
		-1,
		-1,
		257,
		231,
		264,
		255,
		238,
		218,
		210,
		229,
		-1,
		199,
		-1,
		174,
		176,
		202,
		205,
		211,
		205,
		178,
		193,
		183,
		174,
		183,
		263,
		-1,
		233,
		266,
		230,
		224,
		200,
		204,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		227,
		212,
		193,
		180,
		187,
		187,
		180,
		-1,
		-1,
		-1,
		235,
		234,
		226,
		220,
		220,
		205,
		196,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		217,
		213,
		200,
		200,
		192,
		-1,
		336,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		229,
		224,
		197,
		185,
		191,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		193,
		228,
		-1,
		331,
		-1,
		265,
		-1,
		-1,
		247,
		227,
		219,
		208,
		197,
		195,
		186,
		177,
		199,
		215,
		199,
		197,
		200,
		201,
		-1,
		320,
		319,
		-1,
		266,
		258,
		244,
		-1,
		237,
		-1,
		243,
		204,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		307,
		282,
		-1,
		-1,
		-1,
		267,
		247,
		238,
		222,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		292,
		291,
		-1,
		260,
		263,
		-1,
		253,
		244,
		252,
		199,
		203,
		-1,
		-1,
		-1,
		301,
		282,
		276,
		275,
		273,
		268,
		265,
		251,
		235,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		273,
		265,
		258,
		-1,
		-1,
		260,
		243,
		224,
		222,
		-1,
		-1,
		-1,
		295,
		276,
		-1,
		-1,
		250,
		-1,
		-1,
		256,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		284,
		-1,
		-1,
		-1,
		246,
		242,
		243,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		330,
		294,
		-1,
		-1,
		-1,
		238,
		232,
		-1,
		-1,
		309,
		307,
		-1,
		-1,
		-1,
		266,
		250,
		-1,
		236,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		271,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		284,
		276,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		299,
		290,
		-1,
		-1,
		261,
		268,
		290,
		293,
		329,
		-1,
		280
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		222,
		224,
		190,
		184,
		223,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		213,
		212,
		182,
		180,
		189,
		194,
		201,
		-1,
		224,
		-1,
		234,
		213,
		224,
		229,
		175,
		172,
		192,
		211,
		217,
		209,
		249,
		205,
		176,
		170,
		188,
		193,
		211,
		203,
		-1,
		176,
		166,
		188,
		192,
		204,
		187,
		-1,
		-1,
		170,
		171,
		177,
		189,
		194,
		199,
		-1,
		225,
		244,
		-1,
		-1,
		160,
		173,
		169,
		172,
		180,
		196,
		217,
		234,
		239,
		-1,
		-1,
		161,
		165,
		178,
		179,
		177,
		204,
		223,
		234,
		248,
		247,
		-1,
		149,
		167,
		176,
		185,
		191,
		180,
		184,
		202,
		233,
		239,
		242,
		-1,
		141,
		143,
		172,
		178,
		190,
		196,
		183,
		189,
		208,
		221,
		240,
		231,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		138,
		146,
		172,
		171,
		167,
		185,
		207,
		186,
		192,
		196,
		213,
		229,
		230,
		240,
		-1,
		-1,
		189,
		158,
		193,
		150,
		135,
		-1,
		134,
		153,
		159,
		163,
		168,
		176,
		204,
		202,
		-1,
		207,
		206,
		237,
		223,
		234,
		149,
		-1,
		-1,
		147,
		139,
		124,
		127,
		124,
		129,
		159,
		158,
		163,
		165,
		167,
		179,
		194,
		194,
		204,
		201,
		211,
		215,
		230,
		241,
		-1,
		-1,
		315,
		-1,
		-1,
		141,
		129,
		-1,
		112,
		119,
		119,
		136,
		127,
		152,
		167,
		171,
		179,
		182,
		170,
		189,
		186,
		210,
		206,
		198,
		223,
		227,
		233,
		251,
		252,
		-1,
		314,
		298,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		105,
		108,
		114,
		138,
		148,
		-1,
		174,
		172,
		196,
		190,
		195,
		191,
		176,
		194,
		192,
		207,
		209,
		205,
		207,
		244,
		235,
		256,
		253,
		284,
		290,
		284,
		293,
		-1,
		100,
		96,
		92,
		99,
		102,
		-1,
		-1,
		142,
		-1,
		156,
		169,
		186,
		176,
		179,
		191,
		199,
		198,
		182,
		200,
		195,
		198,
		217,
		213,
		222,
		232,
		231,
		249,
		262,
		277,
		281,
		287,
		-1,
		0,
		-1,
		56,
		70,
		97,
		108,
		136,
		-1,
		162,
		157,
		177,
		188,
		188,
		-1,
		204,
		201,
		214,
		198,
		183,
		200,
		202,
		206,
		216,
		220,
		235,
		226,
		244,
		251,
		259,
		263,
		283,
		295,
		40,
		50,
		-1,
		102,
		107,
		111,
		123,
		159,
		200,
		184,
		-1,
		199,
		-1,
		206,
		219,
		-1,
		204,
		200,
		189,
		205,
		213,
		220,
		223,
		217,
		214,
		232,
		235,
		252,
		256,
		272,
		-1,
		-1,
		115,
		119,
		151,
		117,
		144,
		168,
		205,
		193,
		202,
		204,
		-1,
		224,
		225,
		222,
		223,
		209,
		202,
		203,
		219,
		225,
		217,
		216,
		219,
		241,
		269,
		247,
		259,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		151,
		122,
		146,
		188,
		232,
		225,
		213,
		211,
		211,
		205,
		-1,
		240,
		219,
		216,
		207,
		212,
		225,
		220,
		236,
		220,
		222,
		238,
		250,
		241,
		261,
		-1,
		-1,
		-1,
		181,
		170,
		171,
		125,
		159,
		177,
		244,
		230,
		235,
		210,
		203,
		197,
		234,
		236,
		213,
		221,
		213,
		202,
		216,
		224,
		228,
		222,
		231,
		232,
		256,
		263,
		269,
		-1,
		-1,
		188,
		178,
		162,
		164,
		161,
		150,
		157,
		189,
		235,
		232,
		-1,
		202,
		-1,
		191,
		199,
		198,
		204,
		216,
		202,
		207,
		218,
		230,
		236,
		227,
		242,
		261,
		261,
		253,
		278,
		281,
		-1,
		-1,
		-1,
		181,
		198,
		173,
		150,
		131,
		167,
		-1,
		202,
		203,
		-1,
		196,
		190,
		196,
		195,
		202,
		199,
		199,
		213,
		221,
		217,
		233,
		239,
		228,
		264,
		-1,
		261,
		255,
		276,
		266,
		254,
		-1,
		-1,
		-1,
		196,
		175,
		168,
		188,
		138,
		190,
		-1,
		-1,
		187,
		180,
		-1,
		183,
		183,
		190,
		199,
		204,
		209,
		217,
		212,
		225,
		230,
		233,
		241,
		259,
		263,
		267,
		256,
		252,
		249,
		263,
		-1,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		158,
		-1,
		195,
		187,
		178,
		172,
		178,
		196,
		194,
		214,
		206,
		220,
		220,
		226,
		234,
		219,
		222,
		236,
		236,
		254,
		262,
		254,
		248,
		247,
		259,
		-1,
		244,
		230,
		201,
		-1,
		-1,
		173,
		-1,
		144,
		168,
		184,
		-1,
		212,
		191,
		214,
		192,
		206,
		202,
		240,
		241,
		219,
		224,
		232,
		242,
		244,
		233,
		244,
		236,
		258,
		258,
		242,
		243,
		252,
		-1,
		250,
		237,
		195,
		191,
		180,
		200,
		147,
		160,
		171,
		-1,
		-1,
		256,
		-1,
		190,
		207,
		216,
		214,
		230,
		221,
		227,
		243,
		246,
		248,
		238,
		227,
		233,
		230,
		252,
		238,
		236,
		255,
		271,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		166,
		153,
		147,
		-1,
		188,
		-1,
		234,
		224,
		208,
		193,
		226,
		-1,
		238,
		222,
		227,
		-1,
		273,
		-1,
		246,
		248,
		242,
		227,
		224,
		235,
		233,
		244,
		261,
		-1,
		200,
		185,
		178,
		168,
		182,
		153,
		-1,
		204,
		-1,
		-1,
		221,
		215,
		215,
		199,
		202,
		254,
		234,
		228,
		227,
		268,
		268,
		254,
		240,
		233,
		230,
		227,
		240,
		260,
		251,
		263,
		-1,
		-1,
		-1,
		205,
		185,
		191,
		149,
		170,
		-1,
		-1,
		283,
		238,
		224,
		-1,
		208,
		271,
		259,
		249,
		239,
		273,
		274,
		259,
		252,
		238,
		240,
		238,
		236,
		241,
		262,
		263,
		276,
		-1,
		-1,
		182,
		189,
		177,
		163,
		182,
		-1,
		-1,
		-1,
		230,
		246,
		238,
		209,
		260,
		-1,
		-1,
		251,
		249,
		259,
		255,
		242,
		262,
		265,
		251,
		235,
		250,
		262,
		270,
		275,
		-1,
		185,
		172,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		-1,
		-1,
		263,
		229,
		241,
		262,
		287,
		254,
		-1,
		259,
		260,
		246,
		260,
		267,
		253,
		248,
		242,
		245,
		263,
		280,
		-1,
		-1,
		199,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		220,
		234,
		255,
		261,
		273,
		-1,
		268,
		262,
		248,
		265,
		266,
		263,
		254,
		246,
		251,
		248,
		261,
		275,
		279,
		222,
		-1,
		205,
		-1,
		-1,
		-1,
		238,
		253,
		315,
		292,
		265,
		269,
		262,
		256,
		256,
		272,
		274,
		285,
		253,
		249,
		250,
		254,
		253,
		270,
		280,
		-1,
		-1,
		205,
		222,
		257,
		246,
		250,
		342,
		-1,
		-1,
		278,
		269,
		260,
		263,
		266,
		269,
		259,
		256,
		261,
		266,
		254,
		263,
		281,
		285,
		-1,
		-1,
		-1,
		225,
		-1,
		240,
		-1,
		-1,
		265,
		349,
		296,
		278,
		274,
		272,
		265,
		274,
		269,
		264,
		274,
		283,
		275,
		256,
		267,
		290,
		279,
		317,
		-1,
		-1,
		342,
		-1,
		-1,
		-1,
		254,
		229,
		244,
		290,
		285,
		286,
		311,
		308,
		-1,
		278,
		303,
		275,
		282,
		274,
		282,
		282,
		279,
		257,
		264,
		280,
		279,
		274,
		309,
		301,
		307,
		-1,
		-1,
		335,
		324,
		313,
		319,
		-1,
		260,
		246,
		276,
		266,
		272,
		-1,
		-1,
		319,
		316,
		300,
		284,
		288,
		281,
		276,
		286,
		266,
		253,
		257,
		261,
		267,
		272,
		277,
		283,
		298,
		313,
		-1,
		230,
		311,
		304,
		287,
		295,
		326,
		-1,
		263,
		272,
		253,
		258,
		266,
		-1,
		-1,
		292,
		288,
		293,
		291,
		288,
		296,
		291,
		282,
		267,
		273,
		260,
		259,
		277,
		281,
		290,
		297,
		287,
		300,
		304,
		-1,
		244,
		287,
		281,
		284,
		308,
		322,
		-1,
		276,
		-1,
		-1,
		261,
		279,
		287,
		283,
		287,
		340,
		305,
		300,
		290,
		288,
		279,
		270,
		277,
		268,
		268,
		271,
		286,
		291,
		283,
		297,
		297,
		298,
		-1,
		279,
		267,
		275,
		-1,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		277,
		-1,
		313,
		-1,
		306,
		310,
		313,
		316,
		304,
		291,
		283,
		275,
		291,
		266,
		276,
		272,
		273,
		282,
		293,
		305,
		304,
		305,
		353,
		308,
		275,
		266,
		313,
		328,
		332,
		-1,
		289,
		328,
		315,
		-1,
		286,
		-1,
		-1,
		-1,
		320,
		326,
		318,
		324,
		303,
		303,
		277,
		281,
		271,
		278,
		288,
		290,
		282,
		286,
		299,
		310,
		313,
		349,
		347,
		352,
		297,
		280,
		298,
		307,
		328,
		304,
		295,
		322,
		322,
		311,
		306,
		293,
		-1,
		-1,
		343,
		336,
		-1,
		-1,
		310,
		298,
		281,
		282,
		278,
		281,
		296,
		299,
		289,
		287,
		281,
		313,
		-1,
		349,
		348,
		337,
		334,
		310,
		301,
		288,
		299,
		-1,
		-1,
		307,
		323,
		336,
		340,
		353,
		378,
		-1,
		296,
		-1,
		-1,
		355,
		-1,
		-1,
		340,
		303,
		292,
		283,
		289,
		286,
		297,
		307,
		295,
		296,
		286,
		296,
		309,
		333,
		330,
		318,
		316,
		339,
		296,
		292,
		-1,
		322,
		310,
		316,
		323,
		340,
		367,
		-1,
		-1,
		312,
		303,
		-1,
		-1,
		338,
		336,
		325,
		-1,
		315,
		288,
		293,
		313,
		315,
		304,
		298,
		292,
		299,
		298,
		306,
		314,
		342,
		356,
		345,
		341,
		340,
		348,
		297,
		314,
		321,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		362,
		-1,
		347,
		322,
		-1,
		-1,
		333,
		326,
		314,
		302,
		292,
		302,
		306,
		310,
		302,
		295,
		290,
		301,
		293,
		297,
		314,
		-1,
		376,
		-1,
		328,
		321,
		336,
		351,
		359,
		-1,
		-1,
		-1,
		364,
		350,
		343,
		331,
		329,
		-1,
		367,
		351,
		332,
		-1,
		302,
		315,
		346,
		314,
		319,
		314,
		296,
		307,
		296,
		299,
		313,
		308,
		-1,
		-1,
		334,
		337,
		-1,
		-1,
		359,
		378,
		-1,
		355,
		344,
		329,
		321,
		-1,
		-1,
		339,
		335,
		-1,
		-1,
		303,
		328,
		317,
		325,
		320,
		300,
		306,
		309,
		298,
		302,
		314,
		-1,
		-1,
		341,
		342,
		347,
		-1,
		368,
		-1,
		379,
		-1,
		324,
		340,
		342,
		-1,
		-1,
		-1,
		341,
		304,
		325,
		335,
		329,
		327,
		318,
		304,
		311,
		309,
		305,
		316,
		-1,
		-1,
		-1,
		386,
		360,
		386,
		377,
		360,
		340,
		332,
		357,
		-1,
		328,
		-1,
		303,
		305,
		331,
		334,
		340,
		334,
		307,
		322,
		312,
		303,
		312,
		392,
		-1,
		362,
		395,
		359,
		346,
		329,
		333,
		349,
		-1,
		325,
		307,
		-1,
		335,
		325,
		356,
		341,
		322,
		309,
		316,
		316,
		309,
		-1,
		-1,
		-1,
		364,
		363,
		355,
		349,
		349,
		334,
		325,
		-1,
		337,
		319,
		298,
		315,
		315,
		306,
		314,
		346,
		342,
		329,
		329,
		321,
		-1,
		448,
		-1,
		-1,
		387,
		-1,
		-1,
		-1,
		358,
		353,
		326,
		314,
		320,
		316,
		302,
		308,
		310,
		318,
		316,
		313,
		325,
		321,
		341,
		322,
		357,
		-1,
		455,
		-1,
		394,
		-1,
		-1,
		376,
		356,
		348,
		337,
		326,
		324,
		315,
		306,
		328,
		344,
		328,
		326,
		329,
		330,
		-1,
		449,
		448,
		-1,
		395,
		387,
		373,
		-1,
		366,
		-1,
		372,
		333,
		-1,
		335,
		315,
		-1,
		337,
		333,
		-1,
		-1,
		436,
		411,
		-1,
		-1,
		-1,
		396,
		376,
		367,
		351,
		-1,
		326,
		326,
		-1,
		-1,
		-1,
		421,
		420,
		-1,
		389,
		392,
		-1,
		382,
		373,
		381,
		328,
		332,
		-1,
		-1,
		-1,
		430,
		411,
		405,
		404,
		402,
		397,
		394,
		380,
		364,
		342,
		331,
		352,
		-1,
		-1,
		-1,
		402,
		394,
		387,
		-1,
		-1,
		389,
		372,
		353,
		351,
		-1,
		-1,
		-1,
		424,
		405,
		-1,
		-1,
		379,
		-1,
		-1,
		385,
		350,
		-1,
		-1,
		-1,
		-1,
		-1,
		441,
		413,
		-1,
		-1,
		-1,
		375,
		371,
		372,
		-1,
		-1,
		-1,
		-1,
		435,
		436,
		459,
		423,
		-1,
		-1,
		-1,
		367,
		361,
		-1,
		-1,
		438,
		436,
		-1,
		-1,
		-1,
		395,
		379,
		-1,
		365,
		-1,
		-1,
		-1,
		386,
		-1,
		-1,
		398,
		-1,
		-1,
		-1,
		400,
		-1,
		400,
		375,
		382,
		-1,
		-1,
		-1,
		-1,
		413,
		405,
		413,
		-1,
		385,
		387,
		-1,
		435,
		-1,
		-1,
		428,
		419,
		-1,
		-1,
		390,
		397,
		419,
		422,
		458,
		-1,
		409
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		157,
		146,
		157,
		165,
		138,
		145,
		-1,
		166,
		168,
		134,
		128,
		167,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		157,
		156,
		126,
		124,
		133,
		138,
		145,
		-1,
		168,
		-1,
		178,
		157,
		168,
		173,
		119,
		116,
		136,
		155,
		161,
		153,
		193,
		149,
		120,
		114,
		132,
		137,
		155,
		147,
		-1,
		120,
		110,
		132,
		136,
		148,
		131,
		-1,
		-1,
		114,
		115,
		121,
		133,
		138,
		143,
		-1,
		169,
		188,
		-1,
		-1,
		104,
		117,
		113,
		116,
		124,
		140,
		161,
		178,
		183,
		-1,
		-1,
		105,
		109,
		122,
		123,
		121,
		148,
		167,
		178,
		192,
		191,
		-1,
		93,
		111,
		120,
		129,
		135,
		124,
		128,
		146,
		177,
		183,
		186,
		-1,
		85,
		87,
		116,
		122,
		134,
		140,
		127,
		133,
		152,
		165,
		184,
		175,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		82,
		90,
		116,
		115,
		111,
		129,
		151,
		130,
		136,
		140,
		157,
		173,
		174,
		184,
		-1,
		-1,
		133,
		102,
		137,
		94,
		79,
		-1,
		78,
		97,
		103,
		107,
		112,
		120,
		148,
		146,
		-1,
		151,
		150,
		181,
		167,
		178,
		93,
		-1,
		-1,
		91,
		83,
		68,
		71,
		68,
		73,
		103,
		102,
		107,
		109,
		111,
		123,
		138,
		138,
		148,
		145,
		155,
		159,
		174,
		185,
		-1,
		-1,
		259,
		-1,
		-1,
		85,
		73,
		-1,
		56,
		63,
		63,
		80,
		71,
		96,
		111,
		115,
		123,
		126,
		114,
		133,
		130,
		154,
		150,
		142,
		167,
		171,
		177,
		195,
		196,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		49,
		52,
		58,
		82,
		92,
		-1,
		118,
		116,
		140,
		134,
		139,
		135,
		120,
		138,
		136,
		151,
		153,
		149,
		151,
		188,
		179,
		200,
		197,
		228,
		234,
		228,
		237,
		-1,
		44,
		40,
		36,
		43,
		46,
		-1,
		-1,
		86,
		-1,
		100,
		113,
		130,
		120,
		123,
		135,
		143,
		142,
		126,
		144,
		139,
		142,
		161,
		157,
		166,
		176,
		175,
		193,
		206,
		221,
		225,
		231,
		-1,
		58,
		-1,
		0,
		14,
		41,
		52,
		80,
		-1,
		106,
		101,
		121,
		132,
		132,
		-1,
		148,
		145,
		158,
		142,
		127,
		144,
		146,
		150,
		160,
		164,
		179,
		170,
		188,
		195,
		203,
		207,
		227,
		239,
		18,
		8,
		-1,
		46,
		51,
		55,
		67,
		103,
		144,
		128,
		-1,
		143,
		-1,
		150,
		163,
		-1,
		148,
		144,
		133,
		149,
		157,
		164,
		167,
		161,
		158,
		176,
		179,
		196,
		200,
		216,
		-1,
		-1,
		59,
		63,
		95,
		61,
		88,
		112,
		149,
		137,
		146,
		148,
		-1,
		168,
		169,
		166,
		167,
		153,
		146,
		147,
		163,
		169,
		161,
		160,
		163,
		185,
		213,
		191,
		203,
		-1,
		-1,
		-1,
		84,
		-1,
		-1,
		95,
		66,
		90,
		132,
		176,
		169,
		157,
		155,
		155,
		149,
		-1,
		184,
		163,
		160,
		151,
		156,
		169,
		164,
		180,
		164,
		166,
		182,
		194,
		185,
		205,
		-1,
		-1,
		-1,
		125,
		114,
		115,
		69,
		103,
		121,
		188,
		174,
		179,
		154,
		147,
		141,
		178,
		180,
		157,
		165,
		157,
		146,
		160,
		168,
		172,
		166,
		175,
		176,
		200,
		207,
		213,
		-1,
		-1,
		132,
		122,
		106,
		108,
		105,
		94,
		101,
		133,
		179,
		176,
		-1,
		146,
		-1,
		135,
		143,
		142,
		148,
		160,
		146,
		151,
		162,
		174,
		180,
		171,
		186,
		205,
		205,
		197,
		222,
		225,
		-1,
		-1,
		-1,
		125,
		142,
		117,
		94,
		75,
		111,
		-1,
		146,
		147,
		-1,
		140,
		134,
		140,
		139,
		146,
		143,
		143,
		157,
		165,
		161,
		177,
		183,
		172,
		208,
		-1,
		205,
		199,
		220,
		210,
		198,
		-1,
		-1,
		-1,
		140,
		119,
		112,
		132,
		82,
		134,
		-1,
		-1,
		131,
		124,
		-1,
		127,
		127,
		134,
		143,
		148,
		153,
		161,
		156,
		169,
		174,
		177,
		185,
		203,
		207,
		211,
		200,
		196,
		193,
		207,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		102,
		-1,
		139,
		131,
		122,
		116,
		122,
		140,
		138,
		158,
		150,
		164,
		164,
		170,
		178,
		163,
		166,
		180,
		180,
		198,
		206,
		198,
		192,
		191,
		203,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		117,
		-1,
		88,
		112,
		128,
		-1,
		156,
		135,
		158,
		136,
		150,
		146,
		184,
		185,
		163,
		168,
		176,
		186,
		188,
		177,
		188,
		180,
		202,
		202,
		186,
		187,
		196,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		91,
		104,
		115,
		-1,
		-1,
		200,
		-1,
		134,
		151,
		160,
		158,
		174,
		165,
		171,
		187,
		190,
		192,
		182,
		171,
		177,
		174,
		196,
		182,
		180,
		199,
		215,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		178,
		168,
		152,
		137,
		170,
		-1,
		182,
		166,
		171,
		-1,
		217,
		-1,
		190,
		192,
		186,
		171,
		168,
		179,
		177,
		188,
		205,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		148,
		-1,
		-1,
		165,
		159,
		159,
		143,
		146,
		198,
		178,
		172,
		171,
		212,
		212,
		198,
		184,
		177,
		174,
		171,
		184,
		204,
		195,
		207,
		-1,
		-1,
		-1,
		149,
		129,
		135,
		93,
		114,
		-1,
		-1,
		227,
		182,
		168,
		-1,
		152,
		215,
		203,
		193,
		183,
		217,
		218,
		203,
		196,
		182,
		184,
		182,
		180,
		185,
		206,
		207,
		220,
		-1,
		-1,
		126,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		174,
		190,
		182,
		153,
		204,
		-1,
		-1,
		195,
		193,
		203,
		199,
		186,
		206,
		209,
		195,
		179,
		194,
		206,
		214,
		219,
		-1,
		129,
		116,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		185,
		206,
		231,
		198,
		-1,
		203,
		204,
		190,
		204,
		211,
		197,
		192,
		186,
		189,
		207,
		224,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		164,
		178,
		199,
		205,
		217,
		-1,
		212,
		206,
		192,
		209,
		210,
		207,
		198,
		190,
		195,
		192,
		205,
		219,
		223,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		182,
		197,
		259,
		236,
		209,
		213,
		206,
		200,
		200,
		216,
		218,
		229,
		197,
		193,
		194,
		198,
		197,
		214,
		224,
		-1,
		-1,
		149,
		166,
		201,
		190,
		194,
		286,
		-1,
		-1,
		222,
		213,
		204,
		207,
		210,
		213,
		203,
		200,
		205,
		210,
		198,
		207,
		225,
		229,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		209,
		293,
		240,
		222,
		218,
		216,
		209,
		218,
		213,
		208,
		218,
		227,
		219,
		200,
		211,
		234,
		223,
		261,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		198,
		173,
		188,
		234,
		229,
		230,
		255,
		252,
		-1,
		222,
		247,
		219,
		226,
		218,
		226,
		226,
		223,
		201,
		208,
		224,
		223,
		218,
		253,
		245,
		251,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		204,
		190,
		220,
		210,
		216,
		-1,
		-1,
		263,
		260,
		244,
		228,
		232,
		225,
		220,
		230,
		210,
		197,
		201,
		205,
		211,
		216,
		221,
		227,
		242,
		257,
		-1,
		174,
		255,
		248,
		231,
		239,
		270,
		-1,
		207,
		216,
		197,
		202,
		210,
		-1,
		-1,
		236,
		232,
		237,
		235,
		232,
		240,
		235,
		226,
		211,
		217,
		204,
		203,
		221,
		225,
		234,
		241,
		231,
		244,
		248,
		-1,
		188,
		231,
		225,
		228,
		252,
		266,
		-1,
		220,
		-1,
		-1,
		205,
		223,
		231,
		227,
		231,
		284,
		249,
		244,
		234,
		232,
		223,
		214,
		221,
		212,
		212,
		215,
		230,
		235,
		227,
		241,
		241,
		242,
		-1,
		223,
		211,
		219,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		221,
		-1,
		257,
		-1,
		250,
		254,
		257,
		260,
		248,
		235,
		227,
		219,
		235,
		210,
		220,
		216,
		217,
		226,
		237,
		249,
		248,
		249,
		297,
		252,
		219,
		210,
		257,
		272,
		276,
		-1,
		233,
		272,
		259,
		-1,
		230,
		-1,
		-1,
		-1,
		264,
		270,
		262,
		268,
		247,
		247,
		221,
		225,
		215,
		222,
		232,
		234,
		226,
		230,
		243,
		254,
		257,
		293,
		291,
		296,
		241,
		224,
		242,
		251,
		272,
		248,
		239,
		266,
		266,
		255,
		250,
		237,
		-1,
		-1,
		287,
		280,
		-1,
		-1,
		254,
		242,
		225,
		226,
		222,
		225,
		240,
		243,
		233,
		231,
		225,
		257,
		-1,
		293,
		292,
		281,
		278,
		254,
		245,
		232,
		243,
		-1,
		-1,
		251,
		267,
		280,
		284,
		297,
		322,
		-1,
		240,
		-1,
		-1,
		299,
		-1,
		-1,
		284,
		247,
		236,
		227,
		233,
		230,
		241,
		251,
		239,
		240,
		230,
		240,
		253,
		277,
		274,
		262,
		260,
		283,
		240,
		236,
		-1,
		266,
		254,
		260,
		267,
		284,
		311,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		282,
		280,
		269,
		-1,
		259,
		232,
		237,
		257,
		259,
		248,
		242,
		236,
		243,
		242,
		250,
		258,
		286,
		300,
		289,
		285,
		284,
		292,
		241,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		-1,
		291,
		266,
		-1,
		-1,
		277,
		270,
		258,
		246,
		236,
		246,
		250,
		254,
		246,
		239,
		234,
		245,
		237,
		241,
		258,
		-1,
		320,
		-1,
		272,
		265,
		280,
		295,
		303,
		-1,
		-1,
		-1,
		308,
		294,
		287,
		275,
		273,
		-1,
		311,
		295,
		276,
		-1,
		246,
		259,
		290,
		258,
		263,
		258,
		240,
		251,
		240,
		243,
		257,
		252,
		-1,
		-1,
		278,
		281,
		-1,
		-1,
		303,
		322,
		-1,
		299,
		288,
		273,
		265,
		-1,
		-1,
		283,
		279,
		-1,
		-1,
		247,
		272,
		261,
		269,
		264,
		244,
		250,
		253,
		242,
		246,
		258,
		-1,
		-1,
		285,
		286,
		291,
		-1,
		312,
		-1,
		323,
		-1,
		268,
		284,
		286,
		-1,
		-1,
		-1,
		285,
		248,
		269,
		279,
		273,
		271,
		262,
		248,
		255,
		253,
		249,
		260,
		-1,
		-1,
		-1,
		330,
		304,
		330,
		321,
		304,
		284,
		276,
		301,
		-1,
		272,
		-1,
		247,
		249,
		275,
		278,
		284,
		278,
		251,
		266,
		256,
		247,
		256,
		336,
		-1,
		306,
		339,
		303,
		290,
		273,
		277,
		293,
		-1,
		269,
		251,
		-1,
		279,
		269,
		300,
		285,
		266,
		253,
		260,
		260,
		253,
		-1,
		-1,
		-1,
		308,
		307,
		299,
		293,
		293,
		278,
		269,
		-1,
		281,
		263,
		242,
		259,
		259,
		250,
		258,
		290,
		286,
		273,
		273,
		265,
		-1,
		392,
		-1,
		-1,
		331,
		-1,
		-1,
		-1,
		302,
		297,
		270,
		258,
		264,
		260,
		246,
		252,
		254,
		262,
		260,
		257,
		269,
		265,
		285,
		266,
		301,
		-1,
		399,
		-1,
		338,
		-1,
		-1,
		320,
		300,
		292,
		281,
		270,
		268,
		259,
		250,
		272,
		288,
		272,
		270,
		273,
		274,
		-1,
		393,
		392,
		-1,
		339,
		331,
		317,
		-1,
		310,
		-1,
		316,
		277,
		-1,
		279,
		259,
		-1,
		281,
		277,
		-1,
		-1,
		380,
		355,
		-1,
		-1,
		-1,
		340,
		320,
		311,
		295,
		-1,
		270,
		270,
		-1,
		-1,
		-1,
		365,
		364,
		-1,
		333,
		336,
		-1,
		326,
		317,
		325,
		272,
		276,
		-1,
		-1,
		-1,
		374,
		355,
		349,
		348,
		346,
		341,
		338,
		324,
		308,
		286,
		275,
		296,
		-1,
		-1,
		-1,
		346,
		338,
		331,
		-1,
		-1,
		333,
		316,
		297,
		295,
		-1,
		-1,
		-1,
		368,
		349,
		-1,
		-1,
		323,
		-1,
		-1,
		329,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		385,
		357,
		-1,
		-1,
		-1,
		319,
		315,
		316,
		-1,
		-1,
		-1,
		-1,
		379,
		380,
		403,
		367,
		-1,
		-1,
		-1,
		311,
		305,
		-1,
		-1,
		382,
		380,
		-1,
		-1,
		-1,
		339,
		323,
		-1,
		309,
		-1,
		-1,
		-1,
		330,
		-1,
		-1,
		342,
		-1,
		-1,
		-1,
		344,
		-1,
		344,
		319,
		326,
		-1,
		-1,
		-1,
		-1,
		357,
		349,
		357,
		-1,
		329,
		331,
		-1,
		379,
		-1,
		-1,
		372,
		363,
		-1,
		-1,
		334,
		341,
		363,
		366,
		402,
		-1,
		353
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		152,
		154,
		120,
		114,
		153,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		143,
		142,
		112,
		110,
		119,
		124,
		131,
		-1,
		154,
		-1,
		164,
		143,
		154,
		159,
		105,
		102,
		122,
		141,
		147,
		139,
		179,
		135,
		106,
		100,
		118,
		123,
		141,
		133,
		-1,
		106,
		96,
		118,
		122,
		134,
		117,
		-1,
		-1,
		100,
		101,
		107,
		119,
		124,
		129,
		-1,
		155,
		174,
		-1,
		-1,
		90,
		103,
		99,
		102,
		110,
		126,
		147,
		164,
		169,
		-1,
		-1,
		91,
		95,
		108,
		109,
		107,
		134,
		153,
		164,
		178,
		177,
		-1,
		79,
		97,
		106,
		115,
		121,
		110,
		114,
		132,
		163,
		169,
		172,
		-1,
		71,
		73,
		102,
		108,
		120,
		126,
		113,
		119,
		138,
		151,
		170,
		161,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		68,
		76,
		102,
		101,
		97,
		115,
		137,
		116,
		122,
		126,
		143,
		159,
		160,
		170,
		-1,
		-1,
		119,
		88,
		123,
		80,
		65,
		-1,
		64,
		83,
		89,
		93,
		98,
		106,
		134,
		132,
		-1,
		137,
		136,
		167,
		153,
		164,
		79,
		-1,
		-1,
		77,
		69,
		54,
		57,
		54,
		59,
		89,
		88,
		93,
		95,
		97,
		109,
		124,
		124,
		134,
		131,
		141,
		145,
		160,
		171,
		-1,
		-1,
		245,
		-1,
		-1,
		71,
		59,
		-1,
		42,
		49,
		49,
		66,
		57,
		82,
		97,
		101,
		109,
		112,
		100,
		119,
		116,
		140,
		136,
		128,
		153,
		157,
		163,
		181,
		182,
		-1,
		244,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		54,
		35,
		38,
		44,
		68,
		78,
		-1,
		104,
		102,
		126,
		120,
		125,
		121,
		106,
		124,
		122,
		137,
		139,
		135,
		137,
		174,
		165,
		186,
		183,
		214,
		220,
		214,
		223,
		-1,
		30,
		26,
		22,
		29,
		32,
		-1,
		-1,
		72,
		-1,
		86,
		99,
		116,
		106,
		109,
		121,
		129,
		128,
		112,
		130,
		125,
		128,
		147,
		143,
		152,
		162,
		161,
		179,
		192,
		207,
		211,
		217,
		-1,
		74,
		-1,
		16,
		0,
		27,
		38,
		66,
		-1,
		92,
		87,
		107,
		118,
		118,
		-1,
		134,
		131,
		144,
		128,
		113,
		130,
		132,
		136,
		146,
		150,
		165,
		156,
		174,
		181,
		189,
		193,
		213,
		225,
		34,
		24,
		-1,
		32,
		37,
		41,
		53,
		89,
		130,
		114,
		-1,
		129,
		-1,
		136,
		149,
		-1,
		134,
		130,
		119,
		135,
		143,
		150,
		153,
		147,
		144,
		162,
		165,
		182,
		186,
		202,
		-1,
		-1,
		45,
		49,
		81,
		47,
		74,
		98,
		135,
		123,
		132,
		134,
		-1,
		154,
		155,
		152,
		153,
		139,
		132,
		133,
		149,
		155,
		147,
		146,
		149,
		171,
		199,
		177,
		189,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		81,
		52,
		76,
		118,
		162,
		155,
		143,
		141,
		141,
		135,
		-1,
		170,
		149,
		146,
		137,
		142,
		155,
		150,
		166,
		150,
		152,
		168,
		180,
		171,
		191,
		-1,
		-1,
		-1,
		111,
		100,
		101,
		55,
		89,
		107,
		174,
		160,
		165,
		140,
		133,
		127,
		164,
		166,
		143,
		151,
		143,
		132,
		146,
		154,
		158,
		152,
		161,
		162,
		186,
		193,
		199,
		-1,
		-1,
		118,
		108,
		92,
		94,
		91,
		80,
		87,
		119,
		165,
		162,
		-1,
		132,
		-1,
		121,
		129,
		128,
		134,
		146,
		132,
		137,
		148,
		160,
		166,
		157,
		172,
		191,
		191,
		183,
		208,
		211,
		-1,
		-1,
		-1,
		111,
		128,
		103,
		80,
		61,
		97,
		-1,
		132,
		133,
		-1,
		126,
		120,
		126,
		125,
		132,
		129,
		129,
		143,
		151,
		147,
		163,
		169,
		158,
		194,
		-1,
		191,
		185,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		68,
		120,
		-1,
		-1,
		117,
		110,
		-1,
		113,
		113,
		120,
		129,
		134,
		139,
		147,
		142,
		155,
		160,
		163,
		171,
		189,
		193,
		197,
		186,
		182,
		179,
		193,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		88,
		-1,
		125,
		117,
		108,
		102,
		108,
		126,
		124,
		144,
		136,
		150,
		150,
		156,
		164,
		149,
		152,
		166,
		166,
		184,
		192,
		184,
		178,
		177,
		189,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		103,
		-1,
		74,
		98,
		114,
		-1,
		142,
		121,
		144,
		122,
		136,
		132,
		170,
		171,
		149,
		154,
		162,
		172,
		174,
		163,
		174,
		166,
		188,
		188,
		172,
		173,
		182,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		77,
		90,
		101,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		146,
		144,
		160,
		151,
		157,
		173,
		176,
		178,
		168,
		157,
		163,
		160,
		182,
		168,
		166,
		185,
		201,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		168,
		152,
		157,
		-1,
		203,
		-1,
		176,
		178,
		172,
		157,
		154,
		165,
		163,
		174,
		191,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		134,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		184,
		164,
		158,
		157,
		198,
		198,
		184,
		170,
		163,
		160,
		157,
		170,
		190,
		181,
		193,
		-1,
		-1,
		-1,
		135,
		115,
		121,
		79,
		100,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		201,
		189,
		179,
		169,
		203,
		204,
		189,
		182,
		168,
		170,
		168,
		166,
		171,
		192,
		193,
		206,
		-1,
		-1,
		112,
		119,
		107,
		93,
		112,
		-1,
		-1,
		-1,
		160,
		176,
		168,
		139,
		190,
		-1,
		-1,
		181,
		179,
		189,
		185,
		172,
		192,
		195,
		181,
		165,
		180,
		192,
		200,
		205,
		-1,
		115,
		102,
		-1,
		-1,
		115,
		109,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		171,
		192,
		217,
		184,
		-1,
		189,
		190,
		176,
		190,
		197,
		183,
		178,
		172,
		175,
		193,
		210,
		-1,
		-1,
		129,
		-1,
		124,
		-1,
		-1,
		-1,
		-1,
		150,
		164,
		185,
		191,
		203,
		-1,
		198,
		192,
		178,
		195,
		196,
		193,
		184,
		176,
		181,
		178,
		191,
		205,
		209,
		152,
		-1,
		135,
		-1,
		-1,
		-1,
		168,
		183,
		245,
		222,
		195,
		199,
		192,
		186,
		186,
		202,
		204,
		215,
		183,
		179,
		180,
		184,
		183,
		200,
		210,
		-1,
		-1,
		135,
		152,
		187,
		176,
		180,
		272,
		-1,
		-1,
		208,
		199,
		190,
		193,
		196,
		199,
		189,
		186,
		191,
		196,
		184,
		193,
		211,
		215,
		-1,
		-1,
		-1,
		155,
		-1,
		170,
		-1,
		-1,
		195,
		279,
		226,
		208,
		204,
		202,
		195,
		204,
		199,
		194,
		204,
		213,
		205,
		186,
		197,
		220,
		209,
		247,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		184,
		159,
		174,
		220,
		215,
		216,
		241,
		238,
		-1,
		208,
		233,
		205,
		212,
		204,
		212,
		212,
		209,
		187,
		194,
		210,
		209,
		204,
		239,
		231,
		237,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		190,
		176,
		206,
		196,
		202,
		-1,
		-1,
		249,
		246,
		230,
		214,
		218,
		211,
		206,
		216,
		196,
		183,
		187,
		191,
		197,
		202,
		207,
		213,
		228,
		243,
		-1,
		160,
		241,
		234,
		217,
		225,
		256,
		-1,
		193,
		202,
		183,
		188,
		196,
		-1,
		-1,
		222,
		218,
		223,
		221,
		218,
		226,
		221,
		212,
		197,
		203,
		190,
		189,
		207,
		211,
		220,
		227,
		217,
		230,
		234,
		-1,
		174,
		217,
		211,
		214,
		238,
		252,
		-1,
		206,
		-1,
		-1,
		191,
		209,
		217,
		213,
		217,
		270,
		235,
		230,
		220,
		218,
		209,
		200,
		207,
		198,
		198,
		201,
		216,
		221,
		213,
		227,
		227,
		228,
		-1,
		209,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		207,
		-1,
		243,
		-1,
		236,
		240,
		243,
		246,
		234,
		221,
		213,
		205,
		221,
		196,
		206,
		202,
		203,
		212,
		223,
		235,
		234,
		235,
		283,
		238,
		205,
		196,
		243,
		258,
		262,
		-1,
		219,
		258,
		245,
		-1,
		216,
		-1,
		-1,
		-1,
		250,
		256,
		248,
		254,
		233,
		233,
		207,
		211,
		201,
		208,
		218,
		220,
		212,
		216,
		229,
		240,
		243,
		279,
		277,
		282,
		227,
		210,
		228,
		237,
		258,
		234,
		225,
		252,
		252,
		241,
		236,
		223,
		-1,
		-1,
		273,
		266,
		-1,
		-1,
		240,
		228,
		211,
		212,
		208,
		211,
		226,
		229,
		219,
		217,
		211,
		243,
		-1,
		279,
		278,
		267,
		264,
		240,
		231,
		218,
		229,
		-1,
		-1,
		237,
		253,
		266,
		270,
		283,
		308,
		-1,
		226,
		-1,
		-1,
		285,
		-1,
		-1,
		270,
		233,
		222,
		213,
		219,
		216,
		227,
		237,
		225,
		226,
		216,
		226,
		239,
		263,
		260,
		248,
		246,
		269,
		226,
		222,
		-1,
		252,
		240,
		246,
		253,
		270,
		297,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		268,
		266,
		255,
		-1,
		245,
		218,
		223,
		243,
		245,
		234,
		228,
		222,
		229,
		228,
		236,
		244,
		272,
		286,
		275,
		271,
		270,
		278,
		227,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		-1,
		277,
		252,
		-1,
		-1,
		263,
		256,
		244,
		232,
		222,
		232,
		236,
		240,
		232,
		225,
		220,
		231,
		223,
		227,
		244,
		-1,
		306,
		-1,
		258,
		251,
		266,
		281,
		289,
		-1,
		-1,
		-1,
		294,
		280,
		273,
		261,
		259,
		-1,
		297,
		281,
		262,
		-1,
		232,
		245,
		276,
		244,
		249,
		244,
		226,
		237,
		226,
		229,
		243,
		238,
		-1,
		-1,
		264,
		267,
		-1,
		-1,
		289,
		308,
		-1,
		285,
		274,
		259,
		251,
		-1,
		-1,
		269,
		265,
		-1,
		-1,
		233,
		258,
		247,
		255,
		250,
		230,
		236,
		239,
		228,
		232,
		244,
		-1,
		-1,
		271,
		272,
		277,
		-1,
		298,
		-1,
		309,
		-1,
		254,
		270,
		272,
		-1,
		-1,
		-1,
		271,
		234,
		255,
		265,
		259,
		257,
		248,
		234,
		241,
		239,
		235,
		246,
		-1,
		-1,
		-1,
		316,
		290,
		316,
		307,
		290,
		270,
		262,
		287,
		-1,
		258,
		-1,
		233,
		235,
		261,
		264,
		270,
		264,
		237,
		252,
		242,
		233,
		242,
		322,
		-1,
		292,
		325,
		289,
		276,
		259,
		263,
		279,
		-1,
		255,
		237,
		-1,
		265,
		255,
		286,
		271,
		252,
		239,
		246,
		246,
		239,
		-1,
		-1,
		-1,
		294,
		293,
		285,
		279,
		279,
		264,
		255,
		-1,
		267,
		249,
		228,
		245,
		245,
		236,
		244,
		276,
		272,
		259,
		259,
		251,
		-1,
		378,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		288,
		283,
		256,
		244,
		250,
		246,
		232,
		238,
		240,
		248,
		246,
		243,
		255,
		251,
		271,
		252,
		287,
		-1,
		385,
		-1,
		324,
		-1,
		-1,
		306,
		286,
		278,
		267,
		256,
		254,
		245,
		236,
		258,
		274,
		258,
		256,
		259,
		260,
		-1,
		379,
		378,
		-1,
		325,
		317,
		303,
		-1,
		296,
		-1,
		302,
		263,
		-1,
		265,
		245,
		-1,
		267,
		263,
		-1,
		-1,
		366,
		341,
		-1,
		-1,
		-1,
		326,
		306,
		297,
		281,
		-1,
		256,
		256,
		-1,
		-1,
		-1,
		351,
		350,
		-1,
		319,
		322,
		-1,
		312,
		303,
		311,
		258,
		262,
		-1,
		-1,
		-1,
		360,
		341,
		335,
		334,
		332,
		327,
		324,
		310,
		294,
		272,
		261,
		282,
		-1,
		-1,
		-1,
		332,
		324,
		317,
		-1,
		-1,
		319,
		302,
		283,
		281,
		-1,
		-1,
		-1,
		354,
		335,
		-1,
		-1,
		309,
		-1,
		-1,
		315,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		371,
		343,
		-1,
		-1,
		-1,
		305,
		301,
		302,
		-1,
		-1,
		-1,
		-1,
		365,
		366,
		389,
		353,
		-1,
		-1,
		-1,
		297,
		291,
		-1,
		-1,
		368,
		366,
		-1,
		-1,
		-1,
		325,
		309,
		-1,
		295,
		-1,
		-1,
		-1,
		316,
		-1,
		-1,
		328,
		-1,
		-1,
		-1,
		330,
		-1,
		330,
		305,
		312,
		-1,
		-1,
		-1,
		-1,
		343,
		335,
		343,
		-1,
		315,
		317,
		-1,
		365,
		-1,
		-1,
		358,
		349,
		-1,
		-1,
		320,
		327,
		349,
		352,
		388,
		-1,
		339
	],
	[
		-1,
		141,
		130,
		141,
		149,
		122,
		129,
		-1,
		150,
		152,
		118,
		112,
		151,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		141,
		140,
		110,
		108,
		117,
		122,
		129,
		-1,
		152,
		-1,
		162,
		141,
		152,
		157,
		103,
		100,
		120,
		139,
		145,
		137,
		177,
		133,
		104,
		98,
		116,
		121,
		139,
		131,
		-1,
		104,
		94,
		116,
		120,
		132,
		115,
		-1,
		-1,
		98,
		99,
		105,
		117,
		122,
		127,
		-1,
		153,
		172,
		-1,
		-1,
		88,
		101,
		97,
		100,
		108,
		124,
		145,
		162,
		167,
		-1,
		-1,
		89,
		93,
		106,
		107,
		105,
		132,
		151,
		162,
		176,
		175,
		-1,
		77,
		95,
		104,
		113,
		119,
		108,
		112,
		130,
		161,
		167,
		170,
		-1,
		69,
		71,
		100,
		106,
		118,
		124,
		111,
		117,
		136,
		149,
		168,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		66,
		74,
		100,
		99,
		95,
		113,
		135,
		114,
		120,
		124,
		141,
		157,
		158,
		168,
		-1,
		-1,
		117,
		86,
		121,
		78,
		63,
		-1,
		62,
		81,
		87,
		91,
		96,
		104,
		132,
		130,
		-1,
		135,
		134,
		165,
		151,
		162,
		77,
		-1,
		-1,
		75,
		67,
		52,
		55,
		52,
		57,
		87,
		86,
		91,
		93,
		95,
		107,
		122,
		122,
		132,
		129,
		139,
		143,
		158,
		169,
		-1,
		-1,
		243,
		-1,
		-1,
		68,
		57,
		-1,
		40,
		47,
		47,
		64,
		55,
		80,
		95,
		99,
		107,
		110,
		98,
		117,
		114,
		138,
		134,
		126,
		151,
		155,
		161,
		179,
		180,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		52,
		33,
		36,
		42,
		66,
		76,
		-1,
		102,
		100,
		124,
		118,
		123,
		119,
		104,
		122,
		120,
		135,
		137,
		133,
		135,
		172,
		163,
		184,
		181,
		212,
		218,
		212,
		221,
		-1,
		47,
		43,
		39,
		46,
		30,
		-1,
		-1,
		70,
		-1,
		84,
		97,
		114,
		104,
		107,
		119,
		127,
		126,
		110,
		128,
		123,
		126,
		145,
		141,
		150,
		160,
		159,
		177,
		190,
		205,
		209,
		215,
		-1,
		97,
		-1,
		39,
		23,
		0,
		36,
		64,
		-1,
		90,
		85,
		105,
		116,
		116,
		-1,
		132,
		129,
		142,
		126,
		111,
		128,
		130,
		134,
		144,
		148,
		163,
		154,
		172,
		179,
		187,
		191,
		211,
		223,
		57,
		47,
		-1,
		31,
		36,
		39,
		51,
		87,
		128,
		112,
		-1,
		127,
		-1,
		134,
		147,
		-1,
		132,
		128,
		117,
		133,
		141,
		148,
		151,
		145,
		142,
		160,
		163,
		180,
		184,
		200,
		-1,
		-1,
		44,
		48,
		80,
		45,
		72,
		96,
		133,
		121,
		130,
		132,
		-1,
		152,
		153,
		150,
		151,
		137,
		130,
		131,
		147,
		153,
		145,
		144,
		147,
		169,
		197,
		175,
		187,
		-1,
		-1,
		-1,
		69,
		-1,
		-1,
		79,
		50,
		74,
		116,
		160,
		153,
		141,
		139,
		139,
		133,
		-1,
		168,
		147,
		144,
		135,
		140,
		153,
		148,
		164,
		148,
		150,
		166,
		178,
		169,
		189,
		-1,
		-1,
		-1,
		109,
		98,
		99,
		53,
		87,
		105,
		172,
		158,
		163,
		138,
		131,
		125,
		162,
		164,
		141,
		149,
		141,
		130,
		144,
		152,
		156,
		150,
		159,
		160,
		184,
		191,
		197,
		-1,
		-1,
		116,
		106,
		90,
		92,
		89,
		78,
		85,
		117,
		163,
		160,
		-1,
		130,
		-1,
		119,
		127,
		126,
		132,
		144,
		130,
		135,
		146,
		158,
		164,
		155,
		170,
		189,
		189,
		181,
		206,
		209,
		-1,
		-1,
		-1,
		109,
		126,
		101,
		78,
		59,
		95,
		-1,
		130,
		131,
		-1,
		124,
		118,
		124,
		123,
		130,
		127,
		127,
		141,
		149,
		145,
		161,
		167,
		156,
		192,
		-1,
		189,
		183,
		204,
		194,
		182,
		-1,
		-1,
		-1,
		124,
		103,
		96,
		116,
		66,
		118,
		-1,
		-1,
		115,
		108,
		-1,
		111,
		111,
		118,
		127,
		132,
		137,
		145,
		140,
		153,
		158,
		161,
		169,
		187,
		191,
		195,
		184,
		180,
		177,
		191,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		86,
		-1,
		123,
		115,
		106,
		100,
		106,
		124,
		122,
		142,
		134,
		148,
		148,
		154,
		162,
		147,
		150,
		164,
		164,
		182,
		190,
		182,
		176,
		175,
		187,
		-1,
		172,
		158,
		129,
		-1,
		-1,
		101,
		-1,
		72,
		96,
		112,
		-1,
		140,
		119,
		142,
		120,
		134,
		130,
		168,
		169,
		147,
		152,
		160,
		170,
		172,
		161,
		172,
		164,
		186,
		186,
		170,
		171,
		180,
		-1,
		178,
		165,
		123,
		119,
		108,
		128,
		75,
		88,
		99,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		144,
		142,
		158,
		149,
		155,
		171,
		174,
		176,
		166,
		155,
		161,
		158,
		180,
		166,
		164,
		183,
		199,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		94,
		81,
		75,
		-1,
		116,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		166,
		150,
		155,
		-1,
		201,
		-1,
		174,
		176,
		170,
		155,
		152,
		163,
		161,
		172,
		189,
		-1,
		128,
		113,
		106,
		96,
		110,
		81,
		-1,
		132,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		182,
		162,
		156,
		155,
		196,
		196,
		182,
		168,
		161,
		158,
		155,
		168,
		188,
		179,
		191,
		-1,
		-1,
		-1,
		133,
		113,
		119,
		77,
		98,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		199,
		187,
		177,
		167,
		201,
		202,
		187,
		180,
		166,
		168,
		166,
		164,
		169,
		190,
		191,
		204,
		-1,
		-1,
		110,
		117,
		105,
		91,
		110,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		188,
		-1,
		-1,
		179,
		177,
		187,
		183,
		170,
		190,
		193,
		179,
		163,
		178,
		190,
		198,
		203,
		-1,
		113,
		100,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		169,
		190,
		215,
		182,
		-1,
		187,
		188,
		174,
		188,
		195,
		181,
		176,
		170,
		173,
		191,
		208,
		-1,
		-1,
		127,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		148,
		162,
		183,
		189,
		201,
		-1,
		196,
		190,
		176,
		193,
		194,
		191,
		182,
		174,
		179,
		176,
		189,
		203,
		207,
		150,
		-1,
		133,
		-1,
		-1,
		-1,
		166,
		181,
		243,
		220,
		193,
		197,
		190,
		184,
		184,
		200,
		202,
		213,
		181,
		177,
		178,
		182,
		181,
		198,
		208,
		-1,
		-1,
		133,
		150,
		185,
		174,
		178,
		270,
		-1,
		-1,
		206,
		197,
		188,
		191,
		194,
		197,
		187,
		184,
		189,
		194,
		182,
		191,
		209,
		213,
		-1,
		-1,
		-1,
		153,
		-1,
		168,
		-1,
		-1,
		193,
		277,
		224,
		206,
		202,
		200,
		193,
		202,
		197,
		192,
		202,
		211,
		203,
		184,
		195,
		218,
		207,
		245,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		182,
		157,
		172,
		218,
		213,
		214,
		239,
		236,
		-1,
		206,
		231,
		203,
		210,
		202,
		210,
		210,
		207,
		185,
		192,
		208,
		207,
		202,
		237,
		229,
		235,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		188,
		174,
		204,
		194,
		200,
		-1,
		-1,
		247,
		244,
		228,
		212,
		216,
		209,
		204,
		214,
		194,
		181,
		185,
		189,
		195,
		200,
		205,
		211,
		226,
		241,
		-1,
		158,
		239,
		232,
		215,
		223,
		254,
		-1,
		191,
		200,
		181,
		186,
		194,
		-1,
		-1,
		220,
		216,
		221,
		219,
		216,
		224,
		219,
		210,
		195,
		201,
		188,
		187,
		205,
		209,
		218,
		225,
		215,
		228,
		232,
		-1,
		172,
		215,
		209,
		212,
		236,
		250,
		-1,
		204,
		-1,
		-1,
		189,
		207,
		215,
		211,
		215,
		268,
		233,
		228,
		218,
		216,
		207,
		198,
		205,
		196,
		196,
		199,
		214,
		219,
		211,
		225,
		225,
		226,
		-1,
		207,
		195,
		203,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		205,
		-1,
		241,
		-1,
		234,
		238,
		241,
		244,
		232,
		219,
		211,
		203,
		219,
		194,
		204,
		200,
		201,
		210,
		221,
		233,
		232,
		233,
		281,
		236,
		203,
		194,
		241,
		256,
		260,
		-1,
		217,
		256,
		243,
		-1,
		214,
		-1,
		-1,
		-1,
		248,
		254,
		246,
		252,
		231,
		231,
		205,
		209,
		199,
		206,
		216,
		218,
		210,
		214,
		227,
		238,
		241,
		277,
		275,
		280,
		225,
		208,
		226,
		235,
		256,
		232,
		223,
		250,
		250,
		239,
		234,
		221,
		-1,
		-1,
		271,
		264,
		-1,
		-1,
		238,
		226,
		209,
		210,
		206,
		209,
		224,
		227,
		217,
		215,
		209,
		241,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		216,
		227,
		-1,
		-1,
		235,
		251,
		264,
		268,
		281,
		306,
		-1,
		224,
		-1,
		-1,
		283,
		-1,
		-1,
		268,
		231,
		220,
		211,
		217,
		214,
		225,
		235,
		223,
		224,
		214,
		224,
		237,
		261,
		258,
		246,
		244,
		267,
		224,
		220,
		-1,
		250,
		238,
		244,
		251,
		268,
		295,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		266,
		264,
		253,
		-1,
		243,
		216,
		221,
		241,
		243,
		232,
		226,
		220,
		227,
		226,
		234,
		242,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		242,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		-1,
		275,
		250,
		-1,
		-1,
		261,
		254,
		242,
		230,
		220,
		230,
		234,
		238,
		230,
		223,
		218,
		229,
		221,
		225,
		242,
		-1,
		304,
		-1,
		256,
		249,
		264,
		279,
		287,
		-1,
		-1,
		-1,
		292,
		278,
		271,
		259,
		257,
		-1,
		295,
		279,
		260,
		-1,
		230,
		243,
		274,
		242,
		247,
		242,
		224,
		235,
		224,
		227,
		241,
		236,
		-1,
		-1,
		262,
		265,
		-1,
		-1,
		287,
		306,
		-1,
		283,
		272,
		257,
		249,
		-1,
		-1,
		267,
		263,
		-1,
		-1,
		231,
		256,
		245,
		253,
		248,
		228,
		234,
		237,
		226,
		230,
		242,
		-1,
		-1,
		269,
		270,
		275,
		-1,
		296,
		-1,
		307,
		-1,
		252,
		268,
		270,
		-1,
		-1,
		-1,
		269,
		232,
		253,
		263,
		257,
		255,
		246,
		232,
		239,
		237,
		233,
		244,
		-1,
		-1,
		-1,
		314,
		288,
		314,
		305,
		288,
		268,
		260,
		285,
		-1,
		256,
		-1,
		231,
		233,
		259,
		262,
		268,
		262,
		235,
		250,
		240,
		231,
		240,
		320,
		-1,
		290,
		323,
		287,
		274,
		257,
		261,
		277,
		-1,
		253,
		235,
		-1,
		263,
		253,
		284,
		269,
		250,
		237,
		244,
		244,
		237,
		-1,
		-1,
		-1,
		292,
		291,
		283,
		277,
		277,
		262,
		253,
		-1,
		265,
		247,
		226,
		243,
		243,
		234,
		242,
		274,
		270,
		257,
		257,
		249,
		-1,
		376,
		-1,
		-1,
		315,
		-1,
		-1,
		-1,
		286,
		281,
		254,
		242,
		248,
		244,
		230,
		236,
		238,
		246,
		244,
		241,
		253,
		249,
		269,
		250,
		285,
		-1,
		383,
		-1,
		322,
		-1,
		-1,
		304,
		284,
		276,
		265,
		254,
		252,
		243,
		234,
		256,
		272,
		256,
		254,
		257,
		258,
		-1,
		377,
		376,
		-1,
		323,
		315,
		301,
		-1,
		294,
		-1,
		300,
		261,
		-1,
		263,
		243,
		-1,
		265,
		261,
		-1,
		-1,
		364,
		339,
		-1,
		-1,
		-1,
		324,
		304,
		295,
		279,
		-1,
		254,
		254,
		-1,
		-1,
		-1,
		349,
		348,
		-1,
		317,
		320,
		-1,
		310,
		301,
		309,
		256,
		260,
		-1,
		-1,
		-1,
		358,
		339,
		333,
		332,
		330,
		325,
		322,
		308,
		292,
		270,
		259,
		280,
		-1,
		-1,
		-1,
		330,
		322,
		315,
		-1,
		-1,
		317,
		300,
		281,
		279,
		-1,
		-1,
		-1,
		352,
		333,
		-1,
		-1,
		307,
		-1,
		-1,
		313,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		369,
		341,
		-1,
		-1,
		-1,
		303,
		299,
		300,
		-1,
		-1,
		-1,
		-1,
		363,
		364,
		387,
		351,
		-1,
		-1,
		-1,
		295,
		289,
		-1,
		-1,
		366,
		364,
		-1,
		-1,
		-1,
		323,
		307,
		-1,
		293,
		-1,
		-1,
		-1,
		314,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		328,
		-1,
		328,
		303,
		310,
		-1,
		-1,
		-1,
		-1,
		341,
		333,
		341,
		-1,
		313,
		315,
		-1,
		363,
		-1,
		-1,
		356,
		347,
		-1,
		-1,
		318,
		325,
		347,
		350,
		386,
		-1,
		337
	],
	[
		-1,
		117,
		106,
		117,
		125,
		98,
		105,
		-1,
		126,
		128,
		94,
		88,
		127,
		98,
		104,
		115,
		-1,
		-1,
		-1,
		117,
		116,
		86,
		84,
		93,
		98,
		105,
		-1,
		128,
		-1,
		138,
		117,
		128,
		133,
		79,
		76,
		96,
		115,
		121,
		113,
		153,
		109,
		80,
		74,
		92,
		97,
		115,
		107,
		-1,
		80,
		70,
		92,
		96,
		108,
		91,
		-1,
		-1,
		74,
		75,
		81,
		93,
		98,
		103,
		-1,
		129,
		148,
		-1,
		-1,
		64,
		77,
		73,
		76,
		84,
		100,
		121,
		138,
		143,
		-1,
		-1,
		65,
		69,
		82,
		83,
		81,
		108,
		127,
		138,
		152,
		151,
		-1,
		53,
		71,
		80,
		89,
		95,
		84,
		88,
		106,
		137,
		143,
		146,
		-1,
		45,
		47,
		76,
		82,
		94,
		100,
		87,
		93,
		112,
		125,
		144,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		42,
		50,
		76,
		75,
		71,
		89,
		111,
		90,
		96,
		100,
		117,
		133,
		134,
		144,
		-1,
		-1,
		93,
		62,
		97,
		54,
		39,
		-1,
		38,
		57,
		63,
		67,
		72,
		80,
		108,
		106,
		-1,
		111,
		110,
		141,
		127,
		138,
		53,
		-1,
		-1,
		51,
		43,
		28,
		31,
		28,
		33,
		63,
		62,
		67,
		69,
		71,
		83,
		98,
		98,
		108,
		105,
		115,
		119,
		134,
		145,
		-1,
		-1,
		219,
		-1,
		-1,
		50,
		33,
		-1,
		16,
		23,
		23,
		40,
		31,
		56,
		71,
		75,
		83,
		86,
		74,
		93,
		90,
		114,
		110,
		102,
		127,
		131,
		137,
		155,
		156,
		-1,
		218,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		28,
		9,
		12,
		18,
		42,
		52,
		-1,
		78,
		76,
		100,
		94,
		99,
		95,
		80,
		98,
		96,
		111,
		113,
		109,
		111,
		148,
		139,
		160,
		157,
		188,
		194,
		188,
		197,
		-1,
		58,
		54,
		50,
		57,
		6,
		-1,
		-1,
		46,
		-1,
		60,
		73,
		90,
		80,
		83,
		95,
		103,
		102,
		86,
		104,
		99,
		102,
		121,
		117,
		126,
		136,
		135,
		153,
		166,
		181,
		185,
		191,
		-1,
		108,
		-1,
		50,
		34,
		36,
		0,
		28,
		-1,
		66,
		61,
		81,
		92,
		92,
		-1,
		108,
		105,
		118,
		102,
		87,
		104,
		106,
		110,
		120,
		124,
		139,
		130,
		148,
		155,
		163,
		167,
		187,
		199,
		68,
		58,
		-1,
		40,
		45,
		3,
		15,
		51,
		104,
		88,
		-1,
		103,
		-1,
		110,
		123,
		-1,
		108,
		104,
		93,
		109,
		111,
		124,
		127,
		121,
		118,
		136,
		139,
		156,
		160,
		176,
		-1,
		-1,
		53,
		57,
		66,
		9,
		36,
		60,
		97,
		97,
		106,
		108,
		-1,
		118,
		129,
		126,
		127,
		113,
		106,
		107,
		117,
		129,
		109,
		120,
		123,
		145,
		173,
		151,
		163,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		43,
		14,
		38,
		80,
		136,
		129,
		117,
		103,
		103,
		97,
		-1,
		138,
		121,
		117,
		106,
		104,
		117,
		112,
		128,
		124,
		126,
		142,
		154,
		145,
		165,
		-1,
		-1,
		-1,
		73,
		62,
		63,
		17,
		51,
		69,
		136,
		122,
		127,
		102,
		95,
		89,
		138,
		138,
		105,
		113,
		105,
		94,
		108,
		116,
		120,
		126,
		135,
		136,
		160,
		167,
		173,
		-1,
		-1,
		80,
		70,
		54,
		56,
		53,
		42,
		49,
		81,
		127,
		124,
		-1,
		94,
		-1,
		83,
		91,
		90,
		96,
		108,
		94,
		99,
		110,
		122,
		135,
		131,
		138,
		165,
		165,
		157,
		178,
		181,
		-1,
		-1,
		-1,
		73,
		90,
		65,
		42,
		23,
		59,
		-1,
		94,
		95,
		-1,
		88,
		82,
		88,
		87,
		94,
		91,
		91,
		105,
		113,
		109,
		125,
		131,
		123,
		159,
		-1,
		165,
		159,
		168,
		158,
		146,
		-1,
		-1,
		-1,
		88,
		67,
		60,
		80,
		30,
		82,
		-1,
		-1,
		79,
		72,
		-1,
		75,
		75,
		82,
		91,
		96,
		101,
		109,
		104,
		117,
		122,
		128,
		133,
		151,
		155,
		159,
		148,
		144,
		141,
		155,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		33,
		50,
		-1,
		87,
		79,
		70,
		64,
		70,
		88,
		86,
		106,
		98,
		112,
		112,
		118,
		126,
		111,
		114,
		130,
		128,
		146,
		154,
		146,
		140,
		139,
		151,
		-1,
		136,
		122,
		93,
		-1,
		-1,
		65,
		-1,
		36,
		60,
		76,
		-1,
		104,
		83,
		106,
		84,
		98,
		94,
		132,
		133,
		111,
		116,
		124,
		134,
		136,
		125,
		136,
		128,
		150,
		150,
		134,
		135,
		144,
		-1,
		142,
		129,
		87,
		83,
		72,
		92,
		39,
		52,
		63,
		-1,
		-1,
		148,
		-1,
		82,
		99,
		108,
		106,
		122,
		113,
		119,
		135,
		138,
		140,
		130,
		119,
		125,
		122,
		144,
		130,
		128,
		147,
		163,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		58,
		45,
		39,
		-1,
		80,
		-1,
		126,
		116,
		100,
		85,
		118,
		-1,
		130,
		114,
		119,
		-1,
		165,
		-1,
		138,
		140,
		134,
		119,
		116,
		127,
		125,
		136,
		153,
		-1,
		92,
		77,
		70,
		60,
		74,
		45,
		-1,
		96,
		-1,
		-1,
		113,
		107,
		107,
		91,
		94,
		146,
		126,
		120,
		119,
		160,
		160,
		146,
		132,
		125,
		122,
		119,
		132,
		152,
		143,
		155,
		-1,
		-1,
		-1,
		97,
		77,
		83,
		41,
		62,
		-1,
		-1,
		175,
		130,
		116,
		-1,
		100,
		163,
		151,
		141,
		131,
		165,
		166,
		151,
		144,
		130,
		132,
		130,
		128,
		133,
		154,
		155,
		168,
		-1,
		-1,
		74,
		81,
		69,
		55,
		74,
		-1,
		-1,
		-1,
		122,
		138,
		130,
		101,
		152,
		-1,
		-1,
		143,
		141,
		151,
		147,
		134,
		154,
		157,
		143,
		127,
		142,
		154,
		162,
		167,
		-1,
		77,
		64,
		-1,
		-1,
		77,
		71,
		-1,
		-1,
		-1,
		-1,
		155,
		121,
		133,
		154,
		179,
		146,
		-1,
		151,
		152,
		138,
		152,
		159,
		145,
		140,
		134,
		137,
		155,
		172,
		-1,
		-1,
		91,
		-1,
		86,
		-1,
		-1,
		-1,
		-1,
		112,
		126,
		147,
		153,
		165,
		-1,
		160,
		154,
		140,
		157,
		158,
		155,
		146,
		138,
		143,
		140,
		153,
		167,
		171,
		114,
		-1,
		97,
		-1,
		-1,
		-1,
		130,
		145,
		207,
		184,
		157,
		161,
		154,
		148,
		148,
		164,
		166,
		177,
		145,
		141,
		142,
		146,
		145,
		162,
		172,
		-1,
		-1,
		97,
		114,
		149,
		138,
		142,
		234,
		-1,
		-1,
		170,
		161,
		152,
		155,
		158,
		161,
		151,
		148,
		153,
		158,
		146,
		155,
		173,
		177,
		-1,
		-1,
		-1,
		117,
		-1,
		132,
		-1,
		-1,
		157,
		241,
		188,
		170,
		166,
		164,
		157,
		166,
		161,
		156,
		166,
		175,
		167,
		148,
		159,
		182,
		171,
		209,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		146,
		121,
		136,
		182,
		177,
		178,
		203,
		200,
		-1,
		170,
		195,
		167,
		174,
		166,
		174,
		174,
		171,
		149,
		156,
		172,
		171,
		166,
		201,
		193,
		199,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		152,
		138,
		168,
		158,
		164,
		-1,
		-1,
		211,
		208,
		192,
		176,
		180,
		173,
		168,
		178,
		158,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		122,
		203,
		196,
		179,
		187,
		218,
		-1,
		155,
		164,
		145,
		150,
		158,
		-1,
		-1,
		184,
		180,
		185,
		183,
		180,
		188,
		183,
		174,
		159,
		165,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		136,
		179,
		173,
		176,
		200,
		214,
		-1,
		168,
		-1,
		-1,
		153,
		171,
		179,
		175,
		179,
		232,
		197,
		192,
		182,
		180,
		171,
		162,
		169,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		171,
		159,
		167,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		169,
		-1,
		205,
		-1,
		198,
		202,
		205,
		208,
		196,
		183,
		175,
		167,
		183,
		158,
		168,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		245,
		200,
		167,
		158,
		205,
		220,
		224,
		-1,
		181,
		220,
		207,
		-1,
		178,
		-1,
		-1,
		-1,
		212,
		218,
		210,
		216,
		195,
		195,
		169,
		173,
		163,
		170,
		180,
		182,
		174,
		178,
		191,
		202,
		205,
		241,
		239,
		244,
		189,
		172,
		190,
		199,
		220,
		196,
		187,
		214,
		214,
		203,
		198,
		185,
		-1,
		-1,
		235,
		228,
		-1,
		-1,
		202,
		190,
		173,
		174,
		170,
		173,
		188,
		191,
		181,
		179,
		173,
		205,
		-1,
		241,
		240,
		229,
		226,
		202,
		193,
		180,
		191,
		-1,
		-1,
		199,
		215,
		228,
		232,
		245,
		270,
		-1,
		188,
		-1,
		-1,
		247,
		-1,
		-1,
		232,
		195,
		184,
		175,
		181,
		178,
		189,
		199,
		187,
		188,
		178,
		188,
		201,
		225,
		222,
		210,
		208,
		231,
		188,
		184,
		-1,
		214,
		202,
		208,
		215,
		232,
		259,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		230,
		228,
		217,
		-1,
		207,
		180,
		185,
		205,
		207,
		196,
		190,
		184,
		191,
		190,
		198,
		206,
		234,
		248,
		237,
		233,
		232,
		240,
		189,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		214,
		-1,
		-1,
		225,
		218,
		206,
		194,
		184,
		194,
		198,
		202,
		194,
		187,
		182,
		193,
		185,
		189,
		206,
		-1,
		268,
		-1,
		220,
		213,
		228,
		243,
		251,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		259,
		243,
		224,
		-1,
		194,
		207,
		238,
		206,
		211,
		206,
		188,
		199,
		188,
		191,
		205,
		200,
		-1,
		-1,
		226,
		229,
		-1,
		-1,
		251,
		270,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		231,
		227,
		-1,
		-1,
		195,
		220,
		209,
		217,
		212,
		192,
		198,
		201,
		190,
		194,
		206,
		-1,
		-1,
		233,
		234,
		239,
		-1,
		260,
		-1,
		271,
		-1,
		216,
		232,
		234,
		-1,
		-1,
		-1,
		233,
		196,
		217,
		227,
		221,
		219,
		210,
		196,
		203,
		201,
		197,
		208,
		-1,
		-1,
		-1,
		278,
		252,
		278,
		269,
		252,
		232,
		224,
		249,
		-1,
		220,
		-1,
		195,
		197,
		223,
		226,
		232,
		226,
		199,
		214,
		204,
		195,
		204,
		284,
		-1,
		254,
		287,
		251,
		238,
		221,
		225,
		241,
		-1,
		217,
		199,
		-1,
		227,
		217,
		248,
		233,
		214,
		201,
		208,
		208,
		201,
		-1,
		-1,
		-1,
		256,
		255,
		247,
		241,
		241,
		226,
		217,
		-1,
		229,
		211,
		190,
		207,
		207,
		198,
		206,
		238,
		234,
		221,
		221,
		213,
		-1,
		340,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		250,
		245,
		218,
		206,
		212,
		208,
		194,
		200,
		202,
		210,
		208,
		205,
		217,
		213,
		233,
		214,
		249,
		-1,
		347,
		-1,
		286,
		-1,
		-1,
		268,
		248,
		240,
		229,
		218,
		216,
		207,
		198,
		220,
		236,
		220,
		218,
		221,
		222,
		-1,
		341,
		340,
		-1,
		287,
		279,
		265,
		-1,
		258,
		-1,
		264,
		225,
		-1,
		227,
		207,
		-1,
		229,
		225,
		-1,
		-1,
		328,
		303,
		-1,
		-1,
		-1,
		288,
		268,
		259,
		243,
		-1,
		218,
		218,
		-1,
		-1,
		-1,
		313,
		312,
		-1,
		281,
		284,
		-1,
		274,
		265,
		273,
		220,
		224,
		-1,
		-1,
		-1,
		322,
		303,
		297,
		296,
		294,
		289,
		286,
		272,
		256,
		234,
		223,
		244,
		-1,
		-1,
		-1,
		294,
		286,
		279,
		-1,
		-1,
		281,
		264,
		245,
		243,
		-1,
		-1,
		-1,
		316,
		297,
		-1,
		-1,
		271,
		-1,
		-1,
		277,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		333,
		305,
		-1,
		-1,
		-1,
		267,
		263,
		264,
		-1,
		-1,
		-1,
		-1,
		327,
		328,
		351,
		315,
		-1,
		-1,
		-1,
		259,
		253,
		-1,
		-1,
		330,
		328,
		-1,
		-1,
		-1,
		287,
		271,
		-1,
		257,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		292,
		-1,
		292,
		267,
		274,
		-1,
		-1,
		-1,
		-1,
		305,
		297,
		305,
		-1,
		277,
		279,
		-1,
		327,
		-1,
		-1,
		320,
		311,
		-1,
		-1,
		282,
		289,
		311,
		314,
		350,
		-1,
		301
	],
	[
		-1,
		141,
		130,
		141,
		149,
		122,
		129,
		-1,
		150,
		152,
		118,
		112,
		151,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		141,
		140,
		110,
		108,
		117,
		122,
		129,
		-1,
		152,
		-1,
		162,
		141,
		152,
		157,
		103,
		100,
		120,
		139,
		145,
		137,
		177,
		133,
		104,
		98,
		116,
		121,
		139,
		131,
		-1,
		104,
		94,
		116,
		120,
		132,
		115,
		-1,
		-1,
		98,
		99,
		105,
		117,
		122,
		127,
		-1,
		153,
		172,
		-1,
		-1,
		88,
		101,
		97,
		100,
		108,
		124,
		145,
		162,
		167,
		-1,
		-1,
		89,
		93,
		106,
		107,
		105,
		132,
		151,
		162,
		176,
		175,
		-1,
		77,
		95,
		104,
		113,
		119,
		108,
		112,
		130,
		161,
		167,
		170,
		-1,
		69,
		71,
		100,
		106,
		118,
		124,
		111,
		117,
		136,
		149,
		168,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		66,
		74,
		100,
		99,
		95,
		113,
		135,
		114,
		120,
		124,
		141,
		157,
		158,
		168,
		-1,
		-1,
		117,
		86,
		121,
		78,
		63,
		-1,
		62,
		81,
		87,
		91,
		96,
		104,
		132,
		130,
		-1,
		135,
		134,
		165,
		151,
		162,
		77,
		-1,
		-1,
		75,
		67,
		52,
		55,
		52,
		57,
		87,
		86,
		91,
		93,
		95,
		107,
		122,
		122,
		132,
		129,
		139,
		143,
		158,
		169,
		-1,
		-1,
		243,
		-1,
		-1,
		74,
		57,
		-1,
		40,
		47,
		47,
		64,
		55,
		80,
		95,
		99,
		107,
		110,
		98,
		117,
		114,
		138,
		134,
		126,
		151,
		155,
		161,
		179,
		180,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		52,
		33,
		36,
		42,
		66,
		76,
		-1,
		102,
		100,
		124,
		118,
		123,
		119,
		104,
		122,
		120,
		135,
		137,
		133,
		135,
		172,
		163,
		184,
		181,
		212,
		218,
		212,
		221,
		-1,
		82,
		78,
		74,
		81,
		30,
		-1,
		-1,
		70,
		-1,
		84,
		97,
		114,
		104,
		107,
		119,
		127,
		126,
		110,
		128,
		123,
		126,
		145,
		141,
		150,
		160,
		159,
		177,
		190,
		205,
		209,
		215,
		-1,
		132,
		-1,
		74,
		58,
		60,
		24,
		0,
		-1,
		90,
		85,
		105,
		116,
		116,
		-1,
		132,
		129,
		142,
		126,
		111,
		128,
		130,
		134,
		144,
		148,
		163,
		154,
		172,
		179,
		187,
		191,
		211,
		223,
		92,
		82,
		-1,
		64,
		69,
		20,
		21,
		57,
		128,
		112,
		-1,
		127,
		-1,
		134,
		147,
		-1,
		132,
		128,
		117,
		133,
		128,
		143,
		149,
		145,
		142,
		160,
		163,
		180,
		184,
		200,
		-1,
		-1,
		77,
		81,
		83,
		26,
		53,
		77,
		114,
		121,
		130,
		132,
		-1,
		135,
		153,
		150,
		148,
		135,
		125,
		126,
		134,
		147,
		126,
		144,
		147,
		169,
		197,
		175,
		187,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		60,
		31,
		55,
		97,
		160,
		153,
		141,
		120,
		120,
		114,
		-1,
		155,
		138,
		134,
		123,
		121,
		134,
		129,
		145,
		148,
		148,
		166,
		178,
		169,
		189,
		-1,
		-1,
		-1,
		90,
		79,
		80,
		34,
		68,
		86,
		153,
		139,
		144,
		119,
		112,
		106,
		158,
		155,
		122,
		130,
		122,
		111,
		125,
		133,
		137,
		146,
		155,
		160,
		184,
		185,
		191,
		-1,
		-1,
		97,
		87,
		71,
		73,
		70,
		59,
		66,
		98,
		144,
		141,
		-1,
		111,
		-1,
		100,
		108,
		107,
		113,
		125,
		111,
		116,
		127,
		139,
		152,
		148,
		155,
		189,
		189,
		175,
		195,
		198,
		-1,
		-1,
		-1,
		90,
		107,
		82,
		59,
		40,
		76,
		-1,
		111,
		112,
		-1,
		105,
		99,
		105,
		104,
		111,
		108,
		108,
		122,
		130,
		126,
		142,
		148,
		140,
		176,
		-1,
		183,
		177,
		185,
		175,
		163,
		-1,
		-1,
		-1,
		105,
		84,
		77,
		97,
		47,
		99,
		-1,
		-1,
		96,
		89,
		-1,
		92,
		92,
		99,
		108,
		113,
		118,
		126,
		121,
		134,
		139,
		145,
		150,
		168,
		172,
		176,
		165,
		161,
		158,
		172,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		67,
		-1,
		104,
		96,
		87,
		81,
		87,
		105,
		103,
		123,
		115,
		129,
		129,
		135,
		143,
		128,
		131,
		147,
		145,
		163,
		171,
		163,
		157,
		156,
		168,
		-1,
		153,
		139,
		110,
		-1,
		-1,
		82,
		-1,
		53,
		77,
		93,
		-1,
		121,
		100,
		123,
		101,
		115,
		111,
		149,
		150,
		128,
		133,
		141,
		151,
		153,
		142,
		153,
		145,
		167,
		167,
		151,
		152,
		161,
		-1,
		159,
		146,
		104,
		100,
		89,
		109,
		56,
		69,
		80,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		125,
		123,
		139,
		130,
		136,
		152,
		155,
		157,
		147,
		136,
		142,
		139,
		161,
		147,
		145,
		164,
		180,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		75,
		62,
		56,
		-1,
		97,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		147,
		131,
		136,
		-1,
		182,
		-1,
		155,
		157,
		151,
		136,
		133,
		144,
		142,
		153,
		170,
		-1,
		109,
		94,
		87,
		77,
		91,
		62,
		-1,
		113,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		163,
		143,
		137,
		136,
		177,
		177,
		163,
		149,
		142,
		139,
		136,
		149,
		169,
		160,
		172,
		-1,
		-1,
		-1,
		114,
		94,
		100,
		58,
		79,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		180,
		168,
		158,
		148,
		182,
		183,
		168,
		161,
		147,
		149,
		147,
		145,
		150,
		171,
		172,
		185,
		-1,
		-1,
		91,
		98,
		86,
		72,
		91,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		169,
		-1,
		-1,
		160,
		158,
		168,
		164,
		151,
		171,
		174,
		160,
		144,
		159,
		171,
		179,
		184,
		-1,
		94,
		81,
		-1,
		-1,
		94,
		88,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		150,
		171,
		196,
		163,
		-1,
		168,
		169,
		155,
		169,
		176,
		162,
		157,
		151,
		154,
		172,
		189,
		-1,
		-1,
		108,
		-1,
		103,
		-1,
		-1,
		-1,
		-1,
		129,
		143,
		164,
		170,
		182,
		-1,
		177,
		171,
		157,
		174,
		175,
		172,
		163,
		155,
		160,
		157,
		170,
		184,
		188,
		131,
		-1,
		114,
		-1,
		-1,
		-1,
		147,
		162,
		224,
		201,
		174,
		178,
		171,
		165,
		165,
		181,
		183,
		194,
		162,
		158,
		159,
		163,
		162,
		179,
		189,
		-1,
		-1,
		114,
		131,
		166,
		155,
		159,
		251,
		-1,
		-1,
		187,
		178,
		169,
		172,
		175,
		178,
		168,
		165,
		170,
		175,
		163,
		172,
		190,
		194,
		-1,
		-1,
		-1,
		134,
		-1,
		149,
		-1,
		-1,
		174,
		258,
		205,
		187,
		183,
		181,
		174,
		183,
		178,
		173,
		183,
		192,
		184,
		165,
		176,
		199,
		188,
		226,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		163,
		138,
		153,
		199,
		194,
		195,
		220,
		217,
		-1,
		187,
		212,
		184,
		191,
		183,
		191,
		191,
		188,
		166,
		173,
		189,
		188,
		183,
		218,
		210,
		216,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		169,
		155,
		185,
		175,
		181,
		-1,
		-1,
		228,
		225,
		209,
		193,
		197,
		190,
		185,
		195,
		175,
		162,
		166,
		170,
		176,
		181,
		186,
		192,
		207,
		222,
		-1,
		139,
		220,
		213,
		196,
		204,
		235,
		-1,
		172,
		181,
		162,
		167,
		175,
		-1,
		-1,
		201,
		197,
		202,
		200,
		197,
		205,
		200,
		191,
		176,
		182,
		169,
		168,
		186,
		190,
		199,
		206,
		196,
		209,
		213,
		-1,
		153,
		196,
		190,
		193,
		217,
		231,
		-1,
		185,
		-1,
		-1,
		170,
		188,
		196,
		192,
		196,
		249,
		214,
		209,
		199,
		197,
		188,
		179,
		186,
		177,
		177,
		180,
		195,
		200,
		192,
		206,
		206,
		207,
		-1,
		188,
		176,
		184,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		186,
		-1,
		222,
		-1,
		215,
		219,
		222,
		225,
		213,
		200,
		192,
		184,
		200,
		175,
		185,
		181,
		182,
		191,
		202,
		214,
		213,
		214,
		262,
		217,
		184,
		175,
		222,
		237,
		241,
		-1,
		198,
		237,
		224,
		-1,
		195,
		-1,
		-1,
		-1,
		229,
		235,
		227,
		233,
		212,
		212,
		186,
		190,
		180,
		187,
		197,
		199,
		191,
		195,
		208,
		219,
		222,
		258,
		256,
		261,
		206,
		189,
		207,
		216,
		237,
		213,
		204,
		231,
		231,
		220,
		215,
		202,
		-1,
		-1,
		252,
		245,
		-1,
		-1,
		219,
		207,
		190,
		191,
		187,
		190,
		205,
		208,
		198,
		196,
		190,
		222,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		197,
		208,
		-1,
		-1,
		216,
		232,
		245,
		249,
		262,
		287,
		-1,
		205,
		-1,
		-1,
		264,
		-1,
		-1,
		249,
		212,
		201,
		192,
		198,
		195,
		206,
		216,
		204,
		205,
		195,
		205,
		218,
		242,
		239,
		227,
		225,
		248,
		205,
		201,
		-1,
		231,
		219,
		225,
		232,
		249,
		276,
		-1,
		-1,
		221,
		212,
		-1,
		-1,
		247,
		245,
		234,
		-1,
		224,
		197,
		202,
		222,
		224,
		213,
		207,
		201,
		208,
		207,
		215,
		223,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		-1,
		256,
		231,
		-1,
		-1,
		242,
		235,
		223,
		211,
		201,
		211,
		215,
		219,
		211,
		204,
		199,
		210,
		202,
		206,
		223,
		-1,
		285,
		-1,
		237,
		230,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		273,
		259,
		252,
		240,
		238,
		-1,
		276,
		260,
		241,
		-1,
		211,
		224,
		255,
		223,
		228,
		223,
		205,
		216,
		205,
		208,
		222,
		217,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		268,
		287,
		-1,
		264,
		253,
		238,
		230,
		-1,
		-1,
		248,
		244,
		-1,
		-1,
		212,
		237,
		226,
		234,
		229,
		209,
		215,
		218,
		207,
		211,
		223,
		-1,
		-1,
		250,
		251,
		256,
		-1,
		277,
		-1,
		288,
		-1,
		233,
		249,
		251,
		-1,
		-1,
		-1,
		250,
		213,
		234,
		244,
		238,
		236,
		227,
		213,
		220,
		218,
		214,
		225,
		-1,
		-1,
		-1,
		295,
		269,
		295,
		286,
		269,
		249,
		241,
		266,
		-1,
		237,
		-1,
		212,
		214,
		240,
		243,
		249,
		243,
		216,
		231,
		221,
		212,
		221,
		301,
		-1,
		271,
		304,
		268,
		255,
		238,
		242,
		258,
		-1,
		234,
		216,
		-1,
		244,
		234,
		265,
		250,
		231,
		218,
		225,
		225,
		218,
		-1,
		-1,
		-1,
		273,
		272,
		264,
		258,
		258,
		243,
		234,
		-1,
		246,
		228,
		207,
		224,
		224,
		215,
		223,
		255,
		251,
		238,
		238,
		230,
		-1,
		357,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		267,
		262,
		235,
		223,
		229,
		225,
		211,
		217,
		219,
		227,
		225,
		222,
		234,
		230,
		250,
		231,
		266,
		-1,
		364,
		-1,
		303,
		-1,
		-1,
		285,
		265,
		257,
		246,
		235,
		233,
		224,
		215,
		237,
		253,
		237,
		235,
		238,
		239,
		-1,
		358,
		357,
		-1,
		304,
		296,
		282,
		-1,
		275,
		-1,
		281,
		242,
		-1,
		244,
		224,
		-1,
		246,
		242,
		-1,
		-1,
		345,
		320,
		-1,
		-1,
		-1,
		305,
		285,
		276,
		260,
		-1,
		235,
		235,
		-1,
		-1,
		-1,
		330,
		329,
		-1,
		298,
		301,
		-1,
		291,
		282,
		290,
		237,
		241,
		-1,
		-1,
		-1,
		339,
		320,
		314,
		313,
		311,
		306,
		303,
		289,
		273,
		251,
		240,
		261,
		-1,
		-1,
		-1,
		311,
		303,
		296,
		-1,
		-1,
		298,
		281,
		262,
		260,
		-1,
		-1,
		-1,
		333,
		314,
		-1,
		-1,
		288,
		-1,
		-1,
		294,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		350,
		322,
		-1,
		-1,
		-1,
		284,
		280,
		281,
		-1,
		-1,
		-1,
		-1,
		344,
		345,
		368,
		332,
		-1,
		-1,
		-1,
		276,
		270,
		-1,
		-1,
		347,
		345,
		-1,
		-1,
		-1,
		304,
		288,
		-1,
		274,
		-1,
		-1,
		-1,
		295,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		309,
		-1,
		309,
		284,
		291,
		-1,
		-1,
		-1,
		-1,
		322,
		314,
		322,
		-1,
		294,
		296,
		-1,
		344,
		-1,
		-1,
		337,
		328,
		-1,
		-1,
		299,
		306,
		328,
		331,
		367,
		-1,
		318
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		149,
		138,
		149,
		157,
		130,
		137,
		-1,
		158,
		160,
		126,
		120,
		159,
		130,
		136,
		147,
		-1,
		-1,
		-1,
		149,
		148,
		118,
		116,
		125,
		130,
		137,
		-1,
		160,
		-1,
		170,
		149,
		160,
		165,
		111,
		108,
		128,
		147,
		153,
		145,
		185,
		141,
		112,
		106,
		124,
		129,
		147,
		139,
		-1,
		112,
		102,
		124,
		128,
		140,
		123,
		-1,
		-1,
		106,
		107,
		113,
		125,
		130,
		135,
		-1,
		161,
		180,
		-1,
		-1,
		96,
		109,
		105,
		108,
		116,
		132,
		153,
		170,
		175,
		-1,
		-1,
		97,
		101,
		114,
		115,
		113,
		140,
		159,
		170,
		184,
		183,
		-1,
		85,
		103,
		112,
		121,
		127,
		116,
		120,
		138,
		169,
		175,
		178,
		-1,
		77,
		79,
		108,
		114,
		126,
		132,
		119,
		125,
		144,
		157,
		176,
		167,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		74,
		82,
		108,
		107,
		103,
		121,
		143,
		122,
		128,
		132,
		149,
		165,
		166,
		176,
		-1,
		-1,
		125,
		98,
		132,
		91,
		76,
		-1,
		70,
		89,
		95,
		99,
		104,
		112,
		140,
		138,
		-1,
		143,
		142,
		173,
		159,
		170,
		112,
		-1,
		-1,
		83,
		75,
		65,
		68,
		60,
		65,
		95,
		94,
		99,
		101,
		103,
		115,
		130,
		130,
		140,
		137,
		147,
		151,
		166,
		177,
		-1,
		-1,
		251,
		-1,
		-1,
		109,
		92,
		-1,
		58,
		65,
		55,
		72,
		63,
		88,
		103,
		107,
		115,
		118,
		106,
		125,
		122,
		146,
		142,
		134,
		159,
		163,
		169,
		187,
		188,
		-1,
		250,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		65,
		62,
		53,
		23,
		84,
		-1,
		110,
		108,
		132,
		126,
		131,
		127,
		112,
		130,
		128,
		143,
		145,
		141,
		143,
		180,
		171,
		192,
		189,
		220,
		226,
		220,
		229,
		-1,
		117,
		113,
		109,
		116,
		65,
		-1,
		-1,
		19,
		-1,
		62,
		97,
		119,
		112,
		115,
		127,
		135,
		134,
		118,
		136,
		131,
		134,
		153,
		149,
		158,
		168,
		167,
		185,
		198,
		213,
		217,
		223,
		-1,
		167,
		-1,
		109,
		93,
		95,
		71,
		99,
		-1,
		0,
		61,
		105,
		123,
		115,
		-1,
		140,
		137,
		150,
		134,
		119,
		136,
		138,
		142,
		152,
		156,
		171,
		162,
		180,
		187,
		195,
		199,
		219,
		231,
		127,
		117,
		-1,
		99,
		104,
		74,
		86,
		122,
		93,
		77,
		-1,
		116,
		-1,
		142,
		155,
		-1,
		140,
		136,
		125,
		141,
		149,
		156,
		159,
		153,
		150,
		168,
		171,
		188,
		192,
		208,
		-1,
		-1,
		112,
		116,
		137,
		80,
		107,
		131,
		132,
		86,
		95,
		97,
		-1,
		160,
		161,
		158,
		159,
		145,
		138,
		139,
		155,
		161,
		157,
		152,
		155,
		177,
		205,
		183,
		195,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		114,
		85,
		109,
		146,
		125,
		118,
		106,
		131,
		131,
		138,
		-1,
		176,
		155,
		152,
		143,
		151,
		165,
		162,
		176,
		156,
		158,
		174,
		186,
		177,
		197,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		88,
		122,
		140,
		164,
		150,
		155,
		130,
		136,
		141,
		170,
		172,
		167,
		161,
		153,
		142,
		158,
		166,
		168,
		158,
		167,
		168,
		192,
		199,
		205,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		113,
		120,
		152,
		155,
		195,
		-1,
		165,
		-1,
		147,
		162,
		161,
		161,
		158,
		155,
		149,
		158,
		172,
		172,
		163,
		178,
		197,
		197,
		189,
		214,
		217,
		-1,
		-1,
		-1,
		144,
		161,
		136,
		113,
		94,
		130,
		-1,
		165,
		166,
		-1,
		159,
		153,
		159,
		158,
		164,
		159,
		162,
		156,
		163,
		159,
		173,
		182,
		164,
		200,
		-1,
		197,
		191,
		219,
		213,
		201,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		101,
		153,
		-1,
		-1,
		150,
		143,
		-1,
		146,
		146,
		153,
		162,
		160,
		164,
		168,
		157,
		170,
		175,
		169,
		179,
		199,
		203,
		210,
		203,
		199,
		196,
		210,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		121,
		-1,
		158,
		150,
		141,
		135,
		141,
		159,
		157,
		177,
		169,
		175,
		175,
		171,
		179,
		164,
		167,
		172,
		176,
		194,
		209,
		201,
		195,
		194,
		206,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		136,
		-1,
		107,
		131,
		147,
		-1,
		175,
		154,
		177,
		155,
		169,
		165,
		195,
		196,
		174,
		179,
		178,
		188,
		189,
		178,
		184,
		183,
		203,
		205,
		189,
		190,
		199,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		110,
		123,
		134,
		-1,
		-1,
		219,
		-1,
		153,
		170,
		179,
		177,
		185,
		176,
		182,
		189,
		192,
		193,
		183,
		172,
		178,
		177,
		199,
		185,
		183,
		202,
		218,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		197,
		187,
		171,
		156,
		189,
		-1,
		193,
		177,
		182,
		-1,
		218,
		-1,
		191,
		193,
		185,
		174,
		171,
		182,
		180,
		191,
		208,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		167,
		-1,
		-1,
		184,
		178,
		178,
		162,
		165,
		209,
		189,
		183,
		182,
		213,
		211,
		199,
		183,
		176,
		173,
		174,
		187,
		207,
		198,
		210,
		-1,
		-1,
		-1,
		168,
		148,
		154,
		112,
		133,
		-1,
		-1,
		246,
		201,
		187,
		-1,
		171,
		226,
		214,
		204,
		194,
		228,
		227,
		202,
		195,
		181,
		183,
		181,
		183,
		188,
		209,
		210,
		223,
		-1,
		-1,
		145,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		193,
		209,
		201,
		172,
		215,
		-1,
		-1,
		206,
		204,
		214,
		198,
		185,
		205,
		208,
		198,
		182,
		197,
		209,
		217,
		222,
		-1,
		148,
		135,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		204,
		225,
		243,
		209,
		-1,
		214,
		209,
		189,
		203,
		210,
		200,
		195,
		189,
		192,
		210,
		227,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		183,
		197,
		218,
		224,
		229,
		-1,
		217,
		205,
		191,
		208,
		213,
		210,
		201,
		193,
		198,
		195,
		208,
		222,
		226,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		201,
		216,
		271,
		248,
		221,
		216,
		209,
		203,
		199,
		215,
		221,
		232,
		200,
		196,
		197,
		201,
		200,
		217,
		227,
		-1,
		-1,
		168,
		185,
		220,
		209,
		213,
		298,
		-1,
		-1,
		225,
		216,
		207,
		210,
		209,
		212,
		206,
		203,
		208,
		213,
		201,
		210,
		228,
		227,
		-1,
		-1,
		-1,
		188,
		-1,
		203,
		-1,
		-1,
		228,
		296,
		243,
		225,
		221,
		219,
		212,
		221,
		216,
		211,
		221,
		223,
		215,
		203,
		207,
		230,
		219,
		258,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		217,
		192,
		207,
		253,
		248,
		249,
		258,
		255,
		-1,
		225,
		250,
		222,
		229,
		220,
		227,
		227,
		219,
		197,
		204,
		220,
		219,
		214,
		250,
		241,
		247,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		223,
		209,
		239,
		229,
		235,
		-1,
		-1,
		274,
		271,
		247,
		230,
		228,
		221,
		216,
		226,
		206,
		193,
		197,
		201,
		207,
		212,
		217,
		223,
		238,
		253,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		226,
		235,
		216,
		221,
		229,
		-1,
		-1,
		247,
		244,
		249,
		237,
		234,
		236,
		231,
		222,
		207,
		213,
		200,
		199,
		217,
		221,
		230,
		237,
		227,
		240,
		244,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		239,
		-1,
		-1,
		224,
		242,
		250,
		246,
		246,
		296,
		251,
		246,
		230,
		228,
		219,
		210,
		217,
		208,
		208,
		211,
		226,
		231,
		223,
		237,
		237,
		238,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		240,
		-1,
		276,
		-1,
		264,
		268,
		259,
		262,
		244,
		231,
		223,
		215,
		231,
		206,
		216,
		212,
		213,
		222,
		233,
		245,
		244,
		245,
		316,
		271,
		238,
		229,
		276,
		291,
		295,
		-1,
		252,
		291,
		278,
		-1,
		249,
		-1,
		-1,
		-1,
		278,
		272,
		264,
		264,
		243,
		243,
		217,
		221,
		211,
		218,
		228,
		230,
		222,
		226,
		239,
		250,
		253,
		312,
		310,
		315,
		260,
		243,
		261,
		270,
		291,
		267,
		258,
		285,
		285,
		274,
		269,
		256,
		-1,
		-1,
		301,
		282,
		-1,
		-1,
		250,
		238,
		221,
		222,
		218,
		221,
		236,
		239,
		229,
		227,
		221,
		253,
		-1,
		312,
		311,
		300,
		297,
		273,
		264,
		251,
		262,
		-1,
		-1,
		270,
		286,
		299,
		303,
		316,
		341,
		-1,
		259,
		-1,
		-1,
		295,
		-1,
		-1,
		280,
		243,
		232,
		223,
		229,
		226,
		237,
		247,
		235,
		236,
		226,
		236,
		249,
		296,
		293,
		281,
		279,
		302,
		259,
		255,
		-1,
		285,
		273,
		279,
		286,
		303,
		330,
		-1,
		-1,
		275,
		266,
		-1,
		-1,
		278,
		276,
		265,
		-1,
		255,
		228,
		233,
		253,
		255,
		244,
		238,
		232,
		239,
		238,
		246,
		254,
		305,
		319,
		308,
		304,
		303,
		311,
		260,
		277,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		325,
		-1,
		310,
		285,
		-1,
		-1,
		273,
		266,
		254,
		242,
		232,
		242,
		246,
		250,
		242,
		235,
		230,
		241,
		233,
		237,
		254,
		-1,
		339,
		-1,
		291,
		284,
		299,
		314,
		322,
		-1,
		-1,
		-1,
		327,
		313,
		306,
		294,
		292,
		-1,
		307,
		291,
		272,
		-1,
		242,
		255,
		286,
		254,
		259,
		254,
		236,
		247,
		236,
		239,
		253,
		248,
		-1,
		-1,
		297,
		300,
		-1,
		-1,
		322,
		325,
		-1,
		318,
		307,
		292,
		284,
		-1,
		-1,
		279,
		275,
		-1,
		-1,
		243,
		268,
		257,
		265,
		260,
		240,
		246,
		249,
		238,
		242,
		254,
		-1,
		-1,
		304,
		305,
		310,
		-1,
		308,
		-1,
		326,
		-1,
		287,
		299,
		287,
		-1,
		-1,
		-1,
		281,
		244,
		265,
		275,
		269,
		267,
		258,
		244,
		251,
		249,
		245,
		256,
		-1,
		-1,
		-1,
		326,
		300,
		333,
		324,
		307,
		287,
		279,
		298,
		-1,
		268,
		-1,
		243,
		245,
		271,
		274,
		280,
		274,
		247,
		262,
		252,
		243,
		252,
		332,
		-1,
		302,
		335,
		299,
		293,
		269,
		273,
		289,
		-1,
		265,
		247,
		-1,
		275,
		265,
		296,
		281,
		262,
		249,
		256,
		256,
		249,
		-1,
		-1,
		-1,
		304,
		303,
		295,
		289,
		289,
		274,
		265,
		-1,
		277,
		259,
		238,
		255,
		255,
		246,
		254,
		286,
		282,
		269,
		269,
		261,
		-1,
		405,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		298,
		293,
		266,
		254,
		260,
		256,
		242,
		248,
		250,
		258,
		256,
		253,
		265,
		261,
		281,
		262,
		297,
		-1,
		400,
		-1,
		334,
		-1,
		-1,
		316,
		296,
		288,
		277,
		266,
		264,
		255,
		246,
		268,
		284,
		268,
		266,
		269,
		270,
		-1,
		389,
		388,
		-1,
		335,
		327,
		313,
		-1,
		306,
		-1,
		312,
		273,
		-1,
		275,
		255,
		-1,
		277,
		273,
		-1,
		-1,
		376,
		351,
		-1,
		-1,
		-1,
		336,
		316,
		307,
		291,
		-1,
		266,
		266,
		-1,
		-1,
		-1,
		361,
		360,
		-1,
		329,
		332,
		-1,
		322,
		313,
		321,
		268,
		272,
		-1,
		-1,
		-1,
		370,
		351,
		345,
		344,
		342,
		337,
		334,
		320,
		304,
		282,
		271,
		292,
		-1,
		-1,
		-1,
		342,
		334,
		327,
		-1,
		-1,
		329,
		312,
		293,
		291,
		-1,
		-1,
		-1,
		364,
		345,
		-1,
		-1,
		319,
		-1,
		-1,
		325,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		381,
		353,
		-1,
		-1,
		-1,
		315,
		311,
		312,
		-1,
		-1,
		-1,
		-1,
		375,
		376,
		399,
		363,
		-1,
		-1,
		-1,
		307,
		301,
		-1,
		-1,
		378,
		376,
		-1,
		-1,
		-1,
		335,
		319,
		-1,
		305,
		-1,
		-1,
		-1,
		326,
		-1,
		-1,
		338,
		-1,
		-1,
		-1,
		340,
		-1,
		340,
		315,
		322,
		-1,
		-1,
		-1,
		-1,
		353,
		345,
		353,
		-1,
		325,
		327,
		-1,
		375,
		-1,
		-1,
		368,
		359,
		-1,
		-1,
		330,
		337,
		359,
		362,
		398,
		-1,
		349
	],
	[
		-1,
		134,
		123,
		134,
		142,
		115,
		122,
		-1,
		143,
		145,
		111,
		105,
		144,
		115,
		121,
		132,
		-1,
		-1,
		-1,
		134,
		133,
		103,
		101,
		110,
		115,
		122,
		-1,
		145,
		-1,
		155,
		134,
		145,
		150,
		96,
		93,
		113,
		132,
		138,
		130,
		170,
		126,
		97,
		91,
		109,
		114,
		132,
		124,
		-1,
		97,
		87,
		109,
		113,
		125,
		108,
		-1,
		-1,
		91,
		92,
		98,
		110,
		115,
		120,
		-1,
		146,
		165,
		-1,
		-1,
		81,
		94,
		90,
		93,
		101,
		117,
		138,
		155,
		160,
		-1,
		-1,
		82,
		86,
		99,
		100,
		98,
		125,
		144,
		155,
		169,
		168,
		-1,
		70,
		88,
		97,
		106,
		112,
		101,
		105,
		123,
		154,
		160,
		163,
		-1,
		62,
		64,
		93,
		99,
		111,
		117,
		104,
		110,
		129,
		142,
		161,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		59,
		67,
		93,
		92,
		88,
		106,
		128,
		107,
		113,
		117,
		134,
		150,
		151,
		161,
		-1,
		-1,
		122,
		95,
		119,
		78,
		65,
		-1,
		55,
		74,
		80,
		84,
		89,
		97,
		125,
		123,
		-1,
		128,
		127,
		158,
		144,
		155,
		104,
		-1,
		-1,
		80,
		72,
		54,
		57,
		45,
		50,
		80,
		79,
		84,
		86,
		88,
		100,
		115,
		115,
		125,
		122,
		132,
		136,
		151,
		162,
		-1,
		-1,
		236,
		-1,
		-1,
		101,
		84,
		-1,
		49,
		56,
		40,
		57,
		48,
		73,
		88,
		92,
		100,
		103,
		91,
		110,
		107,
		131,
		127,
		119,
		144,
		148,
		154,
		172,
		173,
		-1,
		235,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		79,
		56,
		53,
		46,
		58,
		35,
		-1,
		68,
		74,
		98,
		101,
		113,
		112,
		97,
		115,
		113,
		128,
		130,
		126,
		128,
		165,
		156,
		177,
		174,
		205,
		211,
		205,
		214,
		-1,
		109,
		105,
		101,
		108,
		57,
		-1,
		-1,
		54,
		-1,
		1,
		36,
		58,
		78,
		81,
		102,
		102,
		119,
		103,
		121,
		116,
		119,
		138,
		134,
		143,
		153,
		152,
		170,
		183,
		198,
		202,
		208,
		-1,
		159,
		-1,
		101,
		85,
		87,
		63,
		91,
		-1,
		66,
		0,
		44,
		62,
		62,
		-1,
		106,
		103,
		117,
		119,
		104,
		121,
		123,
		127,
		137,
		141,
		156,
		147,
		165,
		172,
		180,
		184,
		204,
		216,
		119,
		109,
		-1,
		91,
		96,
		66,
		78,
		114,
		43,
		27,
		-1,
		66,
		-1,
		108,
		121,
		-1,
		123,
		121,
		110,
		126,
		134,
		141,
		144,
		138,
		135,
		153,
		156,
		173,
		177,
		193,
		-1,
		-1,
		104,
		108,
		129,
		72,
		99,
		114,
		82,
		36,
		45,
		47,
		-1,
		113,
		146,
		143,
		144,
		130,
		123,
		124,
		140,
		146,
		142,
		137,
		140,
		162,
		190,
		168,
		180,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		106,
		77,
		101,
		96,
		75,
		68,
		56,
		81,
		81,
		88,
		-1,
		161,
		140,
		137,
		128,
		136,
		150,
		147,
		161,
		141,
		143,
		159,
		171,
		162,
		182,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		80,
		114,
		132,
		114,
		100,
		105,
		80,
		86,
		91,
		155,
		157,
		152,
		146,
		138,
		127,
		143,
		151,
		153,
		143,
		152,
		153,
		177,
		184,
		190,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		105,
		112,
		144,
		105,
		187,
		-1,
		124,
		-1,
		97,
		131,
		139,
		145,
		143,
		140,
		134,
		143,
		157,
		157,
		148,
		163,
		182,
		182,
		174,
		199,
		202,
		-1,
		-1,
		-1,
		136,
		153,
		128,
		105,
		86,
		122,
		-1,
		157,
		158,
		-1,
		118,
		112,
		128,
		136,
		143,
		140,
		140,
		141,
		148,
		144,
		158,
		167,
		149,
		185,
		-1,
		182,
		176,
		204,
		198,
		186,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		93,
		145,
		-1,
		-1,
		142,
		135,
		-1,
		115,
		124,
		131,
		140,
		145,
		149,
		153,
		142,
		155,
		160,
		154,
		164,
		184,
		188,
		195,
		188,
		184,
		181,
		195,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		113,
		-1,
		150,
		142,
		133,
		127,
		123,
		137,
		135,
		155,
		147,
		160,
		160,
		156,
		164,
		149,
		152,
		157,
		161,
		179,
		194,
		186,
		180,
		179,
		191,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		128,
		-1,
		99,
		123,
		139,
		-1,
		161,
		140,
		155,
		133,
		147,
		143,
		180,
		181,
		159,
		164,
		163,
		173,
		174,
		163,
		169,
		168,
		188,
		190,
		174,
		175,
		184,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		102,
		115,
		126,
		-1,
		-1,
		197,
		-1,
		131,
		148,
		157,
		155,
		170,
		161,
		167,
		174,
		177,
		178,
		168,
		157,
		163,
		162,
		184,
		170,
		168,
		187,
		203,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		175,
		165,
		149,
		134,
		167,
		-1,
		178,
		162,
		167,
		-1,
		203,
		-1,
		176,
		178,
		170,
		159,
		156,
		167,
		165,
		176,
		193,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		159,
		-1,
		-1,
		162,
		156,
		156,
		140,
		143,
		194,
		174,
		168,
		167,
		198,
		196,
		184,
		168,
		161,
		158,
		159,
		172,
		192,
		183,
		195,
		-1,
		-1,
		-1,
		160,
		140,
		146,
		104,
		125,
		-1,
		-1,
		224,
		179,
		165,
		-1,
		149,
		211,
		199,
		189,
		179,
		213,
		212,
		187,
		180,
		166,
		168,
		166,
		168,
		173,
		194,
		195,
		208,
		-1,
		-1,
		137,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		171,
		187,
		179,
		150,
		200,
		-1,
		-1,
		191,
		189,
		199,
		183,
		170,
		190,
		193,
		183,
		167,
		182,
		194,
		202,
		207,
		-1,
		140,
		127,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		204,
		170,
		182,
		203,
		228,
		194,
		-1,
		199,
		194,
		174,
		188,
		195,
		185,
		180,
		174,
		177,
		195,
		212,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		161,
		175,
		196,
		202,
		214,
		-1,
		202,
		190,
		176,
		193,
		198,
		195,
		186,
		178,
		183,
		180,
		193,
		207,
		211,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		179,
		194,
		256,
		233,
		206,
		201,
		194,
		188,
		184,
		200,
		206,
		217,
		185,
		181,
		182,
		186,
		185,
		202,
		212,
		-1,
		-1,
		160,
		177,
		205,
		187,
		191,
		283,
		-1,
		-1,
		210,
		201,
		192,
		195,
		194,
		197,
		191,
		188,
		193,
		198,
		186,
		195,
		213,
		212,
		-1,
		-1,
		-1,
		180,
		-1,
		195,
		-1,
		-1,
		206,
		281,
		228,
		210,
		206,
		204,
		197,
		206,
		201,
		196,
		206,
		208,
		200,
		188,
		192,
		215,
		204,
		243,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		209,
		184,
		199,
		245,
		226,
		233,
		243,
		240,
		-1,
		210,
		235,
		207,
		214,
		205,
		212,
		212,
		204,
		182,
		189,
		205,
		204,
		199,
		235,
		226,
		232,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		215,
		201,
		231,
		221,
		227,
		-1,
		-1,
		259,
		256,
		232,
		215,
		213,
		206,
		201,
		211,
		191,
		178,
		182,
		186,
		192,
		197,
		202,
		208,
		223,
		238,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		218,
		227,
		208,
		213,
		221,
		-1,
		-1,
		232,
		229,
		234,
		222,
		219,
		221,
		216,
		207,
		192,
		198,
		185,
		184,
		202,
		206,
		215,
		222,
		212,
		225,
		229,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		231,
		-1,
		-1,
		216,
		234,
		242,
		237,
		231,
		281,
		236,
		231,
		215,
		213,
		204,
		195,
		202,
		193,
		193,
		196,
		211,
		216,
		208,
		222,
		222,
		223,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		232,
		-1,
		268,
		-1,
		249,
		253,
		244,
		247,
		229,
		216,
		208,
		200,
		216,
		191,
		201,
		197,
		198,
		207,
		218,
		230,
		229,
		230,
		308,
		263,
		230,
		221,
		268,
		283,
		287,
		-1,
		244,
		283,
		270,
		-1,
		241,
		-1,
		-1,
		-1,
		263,
		257,
		249,
		249,
		228,
		228,
		202,
		206,
		196,
		203,
		213,
		215,
		207,
		211,
		224,
		235,
		238,
		304,
		302,
		307,
		252,
		235,
		253,
		262,
		283,
		259,
		250,
		277,
		277,
		266,
		261,
		248,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		235,
		223,
		206,
		207,
		203,
		206,
		221,
		224,
		214,
		212,
		206,
		238,
		-1,
		304,
		303,
		292,
		289,
		265,
		256,
		243,
		254,
		-1,
		-1,
		262,
		278,
		291,
		295,
		308,
		333,
		-1,
		251,
		-1,
		-1,
		280,
		-1,
		-1,
		265,
		228,
		217,
		208,
		214,
		211,
		222,
		232,
		220,
		221,
		211,
		221,
		234,
		288,
		285,
		273,
		271,
		294,
		251,
		247,
		-1,
		277,
		265,
		271,
		278,
		295,
		322,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		263,
		261,
		250,
		-1,
		240,
		213,
		218,
		238,
		240,
		229,
		223,
		217,
		224,
		223,
		231,
		239,
		297,
		311,
		300,
		296,
		295,
		303,
		252,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		-1,
		301,
		277,
		-1,
		-1,
		258,
		251,
		239,
		227,
		217,
		227,
		231,
		235,
		227,
		220,
		215,
		226,
		218,
		222,
		239,
		-1,
		331,
		-1,
		283,
		276,
		291,
		306,
		314,
		-1,
		-1,
		-1,
		318,
		304,
		297,
		285,
		283,
		-1,
		292,
		276,
		257,
		-1,
		227,
		240,
		271,
		239,
		244,
		239,
		221,
		232,
		221,
		224,
		238,
		233,
		-1,
		-1,
		289,
		292,
		-1,
		-1,
		308,
		310,
		-1,
		309,
		298,
		283,
		275,
		-1,
		-1,
		264,
		260,
		-1,
		-1,
		228,
		253,
		242,
		250,
		245,
		225,
		231,
		234,
		223,
		227,
		239,
		-1,
		-1,
		296,
		297,
		302,
		-1,
		293,
		-1,
		311,
		-1,
		278,
		284,
		272,
		-1,
		-1,
		-1,
		266,
		229,
		250,
		260,
		254,
		252,
		243,
		229,
		236,
		234,
		230,
		241,
		-1,
		-1,
		-1,
		311,
		285,
		318,
		309,
		292,
		272,
		264,
		283,
		-1,
		253,
		-1,
		228,
		230,
		256,
		259,
		265,
		259,
		232,
		247,
		237,
		228,
		237,
		317,
		-1,
		287,
		320,
		284,
		278,
		254,
		258,
		274,
		-1,
		250,
		232,
		-1,
		260,
		250,
		281,
		266,
		247,
		234,
		241,
		241,
		234,
		-1,
		-1,
		-1,
		289,
		288,
		280,
		274,
		274,
		259,
		250,
		-1,
		262,
		244,
		223,
		240,
		240,
		231,
		239,
		271,
		267,
		254,
		254,
		246,
		-1,
		390,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		283,
		278,
		251,
		239,
		245,
		241,
		227,
		233,
		235,
		243,
		241,
		238,
		250,
		246,
		266,
		247,
		282,
		-1,
		385,
		-1,
		319,
		-1,
		-1,
		301,
		281,
		273,
		262,
		251,
		249,
		240,
		231,
		253,
		269,
		253,
		251,
		254,
		255,
		-1,
		374,
		373,
		-1,
		320,
		312,
		298,
		-1,
		291,
		-1,
		297,
		258,
		-1,
		260,
		240,
		-1,
		262,
		258,
		-1,
		-1,
		361,
		336,
		-1,
		-1,
		-1,
		321,
		301,
		292,
		276,
		-1,
		251,
		251,
		-1,
		-1,
		-1,
		346,
		345,
		-1,
		314,
		317,
		-1,
		307,
		298,
		306,
		253,
		257,
		-1,
		-1,
		-1,
		355,
		336,
		330,
		329,
		327,
		322,
		319,
		305,
		289,
		267,
		256,
		277,
		-1,
		-1,
		-1,
		327,
		319,
		312,
		-1,
		-1,
		314,
		297,
		278,
		276,
		-1,
		-1,
		-1,
		349,
		330,
		-1,
		-1,
		304,
		-1,
		-1,
		310,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		366,
		338,
		-1,
		-1,
		-1,
		300,
		296,
		297,
		-1,
		-1,
		-1,
		-1,
		360,
		361,
		384,
		348,
		-1,
		-1,
		-1,
		292,
		286,
		-1,
		-1,
		363,
		361,
		-1,
		-1,
		-1,
		320,
		304,
		-1,
		290,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		323,
		-1,
		-1,
		-1,
		325,
		-1,
		325,
		300,
		307,
		-1,
		-1,
		-1,
		-1,
		338,
		330,
		338,
		-1,
		310,
		312,
		-1,
		360,
		-1,
		-1,
		353,
		344,
		-1,
		-1,
		315,
		322,
		344,
		347,
		383,
		-1,
		334
	],
	[
		-1,
		151,
		140,
		151,
		159,
		132,
		139,
		-1,
		160,
		162,
		128,
		122,
		161,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		151,
		150,
		120,
		118,
		127,
		132,
		139,
		-1,
		162,
		-1,
		172,
		151,
		162,
		167,
		113,
		110,
		130,
		149,
		155,
		147,
		187,
		143,
		114,
		108,
		126,
		131,
		149,
		141,
		-1,
		114,
		104,
		126,
		130,
		142,
		125,
		-1,
		-1,
		108,
		109,
		115,
		127,
		132,
		137,
		-1,
		163,
		179,
		-1,
		-1,
		98,
		111,
		107,
		110,
		118,
		134,
		155,
		172,
		174,
		-1,
		-1,
		99,
		103,
		116,
		117,
		115,
		142,
		161,
		169,
		183,
		182,
		-1,
		87,
		105,
		114,
		123,
		129,
		118,
		122,
		140,
		168,
		174,
		177,
		-1,
		79,
		81,
		106,
		114,
		119,
		126,
		121,
		127,
		146,
		156,
		175,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		76,
		84,
		106,
		98,
		94,
		107,
		124,
		124,
		130,
		134,
		148,
		164,
		165,
		175,
		-1,
		-1,
		139,
		112,
		136,
		95,
		82,
		-1,
		72,
		82,
		87,
		91,
		92,
		94,
		121,
		119,
		-1,
		142,
		141,
		172,
		158,
		169,
		121,
		-1,
		-1,
		97,
		89,
		71,
		74,
		62,
		67,
		79,
		78,
		76,
		72,
		68,
		97,
		109,
		107,
		117,
		136,
		146,
		150,
		165,
		176,
		-1,
		-1,
		241,
		-1,
		-1,
		118,
		101,
		-1,
		66,
		73,
		57,
		74,
		65,
		62,
		89,
		65,
		64,
		83,
		71,
		91,
		101,
		124,
		121,
		133,
		158,
		162,
		166,
		186,
		182,
		-1,
		240,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		73,
		70,
		63,
		87,
		46,
		-1,
		24,
		30,
		54,
		57,
		69,
		82,
		77,
		107,
		107,
		122,
		124,
		140,
		142,
		175,
		163,
		185,
		182,
		211,
		216,
		210,
		219,
		-1,
		126,
		122,
		118,
		125,
		74,
		-1,
		-1,
		91,
		-1,
		40,
		8,
		14,
		34,
		37,
		58,
		58,
		89,
		83,
		101,
		110,
		113,
		133,
		146,
		153,
		158,
		157,
		175,
		190,
		203,
		207,
		213,
		-1,
		176,
		-1,
		118,
		102,
		104,
		80,
		108,
		-1,
		107,
		41,
		0,
		18,
		18,
		-1,
		62,
		59,
		73,
		80,
		85,
		102,
		117,
		121,
		132,
		147,
		161,
		152,
		170,
		177,
		185,
		189,
		209,
		221,
		136,
		126,
		-1,
		108,
		113,
		83,
		95,
		131,
		84,
		54,
		-1,
		29,
		-1,
		64,
		77,
		-1,
		79,
		83,
		91,
		107,
		121,
		134,
		139,
		143,
		140,
		158,
		161,
		178,
		182,
		198,
		-1,
		-1,
		121,
		125,
		146,
		89,
		116,
		132,
		100,
		47,
		36,
		35,
		-1,
		82,
		110,
		107,
		108,
		111,
		104,
		105,
		127,
		140,
		123,
		142,
		145,
		167,
		195,
		173,
		185,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		123,
		94,
		118,
		114,
		65,
		58,
		46,
		63,
		63,
		70,
		-1,
		132,
		116,
		118,
		109,
		117,
		131,
		128,
		142,
		146,
		145,
		164,
		176,
		167,
		187,
		-1,
		-1,
		-1,
		153,
		142,
		143,
		97,
		131,
		149,
		96,
		82,
		87,
		62,
		68,
		73,
		119,
		128,
		133,
		127,
		119,
		108,
		124,
		132,
		134,
		143,
		152,
		158,
		182,
		189,
		195,
		-1,
		-1,
		160,
		150,
		134,
		136,
		133,
		122,
		129,
		161,
		87,
		171,
		-1,
		106,
		-1,
		79,
		113,
		121,
		127,
		124,
		121,
		115,
		124,
		138,
		149,
		145,
		152,
		187,
		187,
		179,
		199,
		202,
		-1,
		-1,
		-1,
		153,
		170,
		145,
		122,
		103,
		139,
		-1,
		141,
		142,
		-1,
		100,
		94,
		110,
		118,
		125,
		122,
		122,
		122,
		129,
		125,
		139,
		150,
		137,
		173,
		-1,
		187,
		181,
		189,
		179,
		167,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		110,
		162,
		-1,
		-1,
		126,
		119,
		-1,
		97,
		106,
		113,
		122,
		126,
		130,
		134,
		123,
		136,
		141,
		142,
		152,
		172,
		176,
		180,
		169,
		165,
		162,
		176,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		130,
		-1,
		135,
		127,
		117,
		111,
		105,
		119,
		117,
		137,
		129,
		141,
		141,
		137,
		145,
		130,
		133,
		145,
		149,
		167,
		175,
		167,
		161,
		160,
		172,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		145,
		-1,
		116,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		129,
		125,
		161,
		162,
		140,
		145,
		144,
		154,
		155,
		144,
		157,
		149,
		171,
		171,
		155,
		156,
		165,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		179,
		-1,
		113,
		130,
		139,
		137,
		151,
		142,
		148,
		155,
		158,
		159,
		149,
		138,
		144,
		143,
		165,
		151,
		149,
		168,
		184,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		157,
		147,
		131,
		116,
		149,
		-1,
		159,
		143,
		148,
		-1,
		184,
		-1,
		157,
		159,
		151,
		140,
		137,
		148,
		146,
		157,
		174,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		144,
		138,
		138,
		122,
		125,
		175,
		155,
		149,
		148,
		179,
		177,
		165,
		149,
		142,
		139,
		140,
		153,
		173,
		164,
		176,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		206,
		161,
		147,
		-1,
		131,
		192,
		180,
		170,
		160,
		194,
		193,
		168,
		161,
		147,
		149,
		147,
		149,
		154,
		175,
		176,
		189,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		153,
		169,
		161,
		132,
		181,
		-1,
		-1,
		172,
		170,
		180,
		164,
		151,
		171,
		174,
		164,
		148,
		163,
		175,
		183,
		188,
		-1,
		157,
		144,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		164,
		185,
		209,
		175,
		-1,
		180,
		175,
		155,
		169,
		176,
		166,
		161,
		155,
		158,
		176,
		193,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		143,
		157,
		178,
		184,
		195,
		-1,
		183,
		171,
		157,
		174,
		179,
		176,
		167,
		159,
		164,
		161,
		174,
		188,
		192,
		192,
		-1,
		175,
		-1,
		-1,
		-1,
		161,
		176,
		237,
		214,
		187,
		182,
		175,
		169,
		165,
		181,
		187,
		198,
		166,
		162,
		163,
		167,
		166,
		183,
		193,
		-1,
		-1,
		175,
		192,
		187,
		169,
		173,
		264,
		-1,
		-1,
		191,
		182,
		173,
		176,
		175,
		178,
		172,
		169,
		174,
		179,
		167,
		176,
		194,
		193,
		-1,
		-1,
		-1,
		195,
		-1,
		210,
		-1,
		-1,
		188,
		262,
		209,
		191,
		187,
		185,
		178,
		187,
		182,
		177,
		187,
		189,
		181,
		169,
		173,
		196,
		185,
		224,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		224,
		199,
		214,
		260,
		208,
		215,
		224,
		221,
		-1,
		191,
		216,
		188,
		195,
		186,
		193,
		193,
		185,
		163,
		170,
		186,
		185,
		180,
		216,
		207,
		213,
		-1,
		-1,
		307,
		296,
		285,
		291,
		-1,
		230,
		216,
		246,
		236,
		225,
		-1,
		-1,
		240,
		237,
		213,
		196,
		194,
		187,
		182,
		192,
		172,
		159,
		163,
		167,
		173,
		178,
		183,
		189,
		204,
		219,
		-1,
		202,
		283,
		276,
		259,
		267,
		298,
		-1,
		233,
		242,
		223,
		228,
		236,
		-1,
		-1,
		213,
		210,
		215,
		203,
		200,
		202,
		197,
		188,
		173,
		179,
		166,
		165,
		183,
		187,
		196,
		203,
		193,
		206,
		210,
		-1,
		216,
		259,
		253,
		256,
		280,
		294,
		-1,
		246,
		-1,
		-1,
		231,
		244,
		228,
		218,
		212,
		262,
		217,
		212,
		196,
		194,
		185,
		176,
		183,
		174,
		174,
		177,
		192,
		197,
		189,
		203,
		203,
		204,
		-1,
		251,
		239,
		247,
		-1,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		247,
		-1,
		255,
		-1,
		230,
		234,
		225,
		228,
		210,
		197,
		189,
		181,
		197,
		172,
		182,
		178,
		179,
		188,
		199,
		211,
		210,
		211,
		325,
		280,
		247,
		238,
		285,
		300,
		304,
		-1,
		259,
		298,
		285,
		-1,
		256,
		-1,
		-1,
		-1,
		244,
		238,
		230,
		230,
		209,
		209,
		183,
		187,
		177,
		184,
		194,
		196,
		188,
		192,
		205,
		216,
		219,
		321,
		318,
		324,
		269,
		252,
		270,
		279,
		300,
		274,
		265,
		292,
		292,
		281,
		276,
		263,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		216,
		204,
		187,
		188,
		184,
		187,
		202,
		205,
		195,
		193,
		187,
		219,
		-1,
		320,
		319,
		308,
		305,
		281,
		272,
		260,
		271,
		-1,
		-1,
		277,
		293,
		300,
		304,
		320,
		345,
		-1,
		266,
		-1,
		-1,
		261,
		-1,
		-1,
		246,
		209,
		198,
		189,
		195,
		192,
		203,
		213,
		201,
		202,
		192,
		202,
		215,
		304,
		301,
		289,
		287,
		310,
		268,
		263,
		-1,
		276,
		274,
		280,
		287,
		304,
		334,
		-1,
		-1,
		282,
		272,
		-1,
		-1,
		244,
		242,
		231,
		-1,
		221,
		194,
		199,
		219,
		221,
		210,
		204,
		198,
		205,
		204,
		212,
		220,
		313,
		327,
		316,
		312,
		311,
		319,
		268,
		261,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		-1,
		282,
		278,
		-1,
		-1,
		239,
		232,
		220,
		208,
		198,
		208,
		212,
		216,
		208,
		201,
		196,
		207,
		199,
		203,
		220,
		-1,
		347,
		-1,
		299,
		275,
		289,
		304,
		312,
		-1,
		-1,
		-1,
		299,
		285,
		278,
		266,
		264,
		-1,
		273,
		257,
		238,
		-1,
		208,
		221,
		252,
		220,
		225,
		220,
		202,
		213,
		202,
		205,
		219,
		214,
		-1,
		-1,
		287,
		290,
		-1,
		-1,
		289,
		291,
		-1,
		290,
		279,
		264,
		256,
		-1,
		-1,
		245,
		241,
		-1,
		-1,
		209,
		234,
		223,
		231,
		226,
		206,
		212,
		215,
		204,
		208,
		220,
		-1,
		-1,
		294,
		295,
		296,
		-1,
		274,
		-1,
		292,
		-1,
		259,
		265,
		253,
		-1,
		-1,
		-1,
		247,
		210,
		231,
		241,
		235,
		233,
		224,
		210,
		217,
		215,
		211,
		222,
		-1,
		-1,
		-1,
		292,
		266,
		299,
		290,
		273,
		253,
		245,
		264,
		-1,
		234,
		-1,
		209,
		211,
		237,
		240,
		246,
		240,
		213,
		228,
		218,
		209,
		218,
		298,
		-1,
		268,
		301,
		265,
		259,
		235,
		239,
		255,
		-1,
		231,
		213,
		-1,
		241,
		231,
		262,
		247,
		228,
		215,
		222,
		222,
		215,
		-1,
		-1,
		-1,
		270,
		269,
		261,
		255,
		255,
		240,
		231,
		-1,
		243,
		225,
		204,
		221,
		221,
		212,
		220,
		252,
		248,
		235,
		235,
		227,
		-1,
		371,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		264,
		259,
		232,
		220,
		226,
		222,
		208,
		214,
		216,
		224,
		222,
		219,
		231,
		227,
		247,
		228,
		263,
		-1,
		366,
		-1,
		300,
		-1,
		-1,
		282,
		262,
		254,
		243,
		232,
		230,
		221,
		212,
		234,
		250,
		234,
		232,
		235,
		236,
		-1,
		355,
		354,
		-1,
		301,
		293,
		279,
		-1,
		272,
		-1,
		278,
		239,
		-1,
		241,
		221,
		-1,
		243,
		239,
		-1,
		-1,
		342,
		317,
		-1,
		-1,
		-1,
		302,
		282,
		273,
		257,
		-1,
		232,
		232,
		-1,
		-1,
		-1,
		327,
		326,
		-1,
		295,
		298,
		-1,
		288,
		279,
		287,
		234,
		238,
		-1,
		-1,
		-1,
		336,
		317,
		311,
		310,
		308,
		303,
		300,
		286,
		270,
		248,
		237,
		258,
		-1,
		-1,
		-1,
		308,
		300,
		293,
		-1,
		-1,
		295,
		278,
		259,
		257,
		-1,
		-1,
		-1,
		330,
		311,
		-1,
		-1,
		285,
		-1,
		-1,
		291,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		347,
		319,
		-1,
		-1,
		-1,
		281,
		277,
		278,
		-1,
		-1,
		-1,
		-1,
		341,
		342,
		365,
		329,
		-1,
		-1,
		-1,
		273,
		267,
		-1,
		-1,
		344,
		342,
		-1,
		-1,
		-1,
		301,
		285,
		-1,
		271,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		306,
		-1,
		306,
		281,
		288,
		-1,
		-1,
		-1,
		-1,
		319,
		311,
		319,
		-1,
		291,
		293,
		-1,
		341,
		-1,
		-1,
		334,
		325,
		-1,
		-1,
		296,
		303,
		325,
		328,
		364,
		-1,
		315
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		152,
		154,
		120,
		114,
		153,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		143,
		142,
		112,
		110,
		119,
		124,
		131,
		-1,
		154,
		-1,
		164,
		143,
		154,
		159,
		105,
		102,
		122,
		141,
		147,
		139,
		179,
		135,
		106,
		100,
		118,
		123,
		141,
		133,
		-1,
		106,
		96,
		118,
		122,
		134,
		117,
		-1,
		-1,
		100,
		101,
		107,
		119,
		124,
		129,
		-1,
		155,
		171,
		-1,
		-1,
		90,
		103,
		99,
		102,
		110,
		126,
		147,
		164,
		166,
		-1,
		-1,
		91,
		95,
		108,
		109,
		107,
		134,
		153,
		161,
		175,
		174,
		-1,
		79,
		97,
		106,
		115,
		121,
		110,
		114,
		132,
		160,
		166,
		169,
		-1,
		71,
		73,
		98,
		106,
		111,
		118,
		113,
		119,
		138,
		148,
		167,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		68,
		76,
		98,
		90,
		86,
		99,
		116,
		116,
		122,
		126,
		140,
		156,
		157,
		167,
		-1,
		-1,
		151,
		124,
		148,
		106,
		94,
		-1,
		64,
		74,
		79,
		83,
		84,
		86,
		113,
		111,
		-1,
		134,
		133,
		164,
		150,
		161,
		133,
		-1,
		-1,
		109,
		101,
		83,
		86,
		63,
		59,
		71,
		70,
		68,
		64,
		60,
		89,
		101,
		99,
		109,
		128,
		138,
		142,
		157,
		168,
		-1,
		-1,
		233,
		-1,
		-1,
		130,
		113,
		-1,
		78,
		85,
		69,
		75,
		61,
		54,
		81,
		57,
		56,
		75,
		63,
		83,
		93,
		116,
		113,
		125,
		150,
		154,
		158,
		178,
		174,
		-1,
		232,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		85,
		82,
		75,
		99,
		71,
		-1,
		16,
		22,
		46,
		49,
		61,
		74,
		69,
		99,
		99,
		114,
		116,
		132,
		134,
		167,
		155,
		177,
		174,
		203,
		208,
		202,
		211,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		103,
		-1,
		65,
		33,
		8,
		26,
		29,
		50,
		50,
		81,
		75,
		93,
		102,
		105,
		125,
		138,
		145,
		150,
		149,
		167,
		182,
		195,
		199,
		205,
		-1,
		188,
		-1,
		130,
		114,
		116,
		92,
		120,
		-1,
		123,
		66,
		25,
		0,
		10,
		-1,
		54,
		51,
		65,
		72,
		77,
		94,
		109,
		113,
		124,
		139,
		153,
		144,
		162,
		169,
		177,
		181,
		201,
		213,
		148,
		138,
		-1,
		120,
		125,
		95,
		107,
		130,
		82,
		46,
		-1,
		21,
		-1,
		56,
		69,
		-1,
		71,
		75,
		83,
		99,
		113,
		126,
		131,
		135,
		132,
		150,
		153,
		170,
		174,
		190,
		-1,
		-1,
		133,
		137,
		145,
		96,
		115,
		124,
		92,
		39,
		28,
		27,
		-1,
		74,
		102,
		99,
		100,
		103,
		96,
		97,
		119,
		132,
		115,
		134,
		137,
		159,
		187,
		165,
		177,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		122,
		93,
		117,
		106,
		57,
		50,
		38,
		55,
		55,
		62,
		-1,
		124,
		108,
		110,
		101,
		109,
		123,
		120,
		134,
		138,
		137,
		156,
		168,
		159,
		179,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		96,
		130,
		148,
		88,
		74,
		79,
		54,
		60,
		65,
		111,
		120,
		125,
		119,
		111,
		100,
		116,
		124,
		126,
		135,
		144,
		150,
		174,
		181,
		187,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		121,
		128,
		160,
		79,
		163,
		-1,
		98,
		-1,
		71,
		105,
		113,
		119,
		116,
		113,
		107,
		116,
		130,
		141,
		137,
		144,
		179,
		179,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		152,
		169,
		144,
		121,
		102,
		138,
		-1,
		133,
		134,
		-1,
		92,
		86,
		102,
		110,
		117,
		114,
		114,
		114,
		121,
		117,
		131,
		142,
		129,
		165,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		109,
		161,
		-1,
		-1,
		118,
		111,
		-1,
		89,
		98,
		105,
		114,
		118,
		122,
		126,
		115,
		128,
		133,
		134,
		144,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		129,
		-1,
		127,
		119,
		109,
		103,
		97,
		111,
		109,
		129,
		121,
		133,
		133,
		129,
		137,
		122,
		125,
		137,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		144,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		121,
		117,
		153,
		154,
		132,
		137,
		136,
		146,
		147,
		136,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		131,
		129,
		143,
		134,
		140,
		147,
		150,
		151,
		141,
		130,
		136,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		151,
		135,
		140,
		-1,
		176,
		-1,
		149,
		151,
		143,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		167,
		147,
		141,
		140,
		171,
		169,
		157,
		141,
		134,
		131,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		184,
		172,
		162,
		152,
		186,
		185,
		160,
		153,
		139,
		141,
		139,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		173,
		-1,
		-1,
		164,
		162,
		172,
		156,
		143,
		163,
		166,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		156,
		177,
		201,
		167,
		-1,
		172,
		167,
		147,
		161,
		168,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		135,
		149,
		170,
		176,
		187,
		-1,
		175,
		163,
		149,
		166,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		153,
		168,
		229,
		206,
		179,
		174,
		167,
		161,
		157,
		173,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		167,
		184,
		179,
		161,
		165,
		256,
		-1,
		-1,
		183,
		174,
		165,
		168,
		167,
		170,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		185,
		-1,
		-1,
		-1,
		187,
		-1,
		202,
		-1,
		-1,
		180,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		181,
		173,
		161,
		165,
		188,
		177,
		216,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		216,
		191,
		206,
		252,
		200,
		207,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		178,
		185,
		185,
		177,
		155,
		162,
		178,
		177,
		172,
		208,
		199,
		205,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		222,
		208,
		238,
		228,
		217,
		-1,
		-1,
		232,
		229,
		205,
		188,
		186,
		179,
		174,
		184,
		164,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		194,
		275,
		268,
		251,
		259,
		290,
		-1,
		225,
		234,
		215,
		220,
		228,
		-1,
		-1,
		205,
		202,
		207,
		195,
		192,
		194,
		189,
		180,
		165,
		171,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		208,
		251,
		245,
		248,
		272,
		286,
		-1,
		238,
		-1,
		-1,
		223,
		236,
		220,
		210,
		204,
		254,
		209,
		204,
		188,
		186,
		177,
		168,
		175,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		243,
		231,
		239,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		239,
		-1,
		247,
		-1,
		222,
		226,
		217,
		220,
		202,
		189,
		181,
		173,
		189,
		164,
		174,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		317,
		272,
		239,
		230,
		277,
		292,
		296,
		-1,
		251,
		290,
		277,
		-1,
		248,
		-1,
		-1,
		-1,
		236,
		230,
		222,
		222,
		201,
		201,
		175,
		179,
		169,
		176,
		186,
		188,
		180,
		184,
		197,
		208,
		211,
		313,
		310,
		316,
		261,
		244,
		262,
		271,
		292,
		266,
		257,
		284,
		284,
		273,
		268,
		255,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		208,
		196,
		179,
		180,
		176,
		179,
		194,
		197,
		187,
		185,
		179,
		211,
		-1,
		312,
		311,
		300,
		297,
		273,
		264,
		252,
		263,
		-1,
		-1,
		269,
		285,
		292,
		296,
		312,
		337,
		-1,
		258,
		-1,
		-1,
		253,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		184,
		195,
		205,
		193,
		194,
		184,
		194,
		207,
		296,
		293,
		281,
		279,
		302,
		260,
		255,
		-1,
		268,
		266,
		272,
		279,
		296,
		326,
		-1,
		-1,
		274,
		264,
		-1,
		-1,
		236,
		234,
		223,
		-1,
		213,
		186,
		191,
		211,
		213,
		202,
		196,
		190,
		197,
		196,
		204,
		212,
		305,
		319,
		308,
		304,
		303,
		311,
		260,
		253,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		-1,
		274,
		270,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		204,
		208,
		200,
		193,
		188,
		199,
		191,
		195,
		212,
		-1,
		339,
		-1,
		291,
		267,
		281,
		296,
		304,
		-1,
		-1,
		-1,
		291,
		277,
		270,
		258,
		256,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		194,
		205,
		194,
		197,
		211,
		206,
		-1,
		-1,
		279,
		282,
		-1,
		-1,
		281,
		283,
		-1,
		282,
		271,
		256,
		248,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		198,
		204,
		207,
		196,
		200,
		212,
		-1,
		-1,
		286,
		287,
		288,
		-1,
		266,
		-1,
		284,
		-1,
		251,
		257,
		245,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		227,
		225,
		216,
		202,
		209,
		207,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		258,
		291,
		282,
		265,
		245,
		237,
		256,
		-1,
		226,
		-1,
		201,
		203,
		229,
		232,
		238,
		232,
		205,
		220,
		210,
		201,
		210,
		290,
		-1,
		260,
		293,
		257,
		251,
		227,
		231,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		254,
		239,
		220,
		207,
		214,
		214,
		207,
		-1,
		-1,
		-1,
		262,
		261,
		253,
		247,
		247,
		232,
		223,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		244,
		240,
		227,
		227,
		219,
		-1,
		363,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		256,
		251,
		224,
		212,
		218,
		214,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		220,
		255,
		-1,
		358,
		-1,
		292,
		-1,
		-1,
		274,
		254,
		246,
		235,
		224,
		222,
		213,
		204,
		226,
		242,
		226,
		224,
		227,
		228,
		-1,
		347,
		346,
		-1,
		293,
		285,
		271,
		-1,
		264,
		-1,
		270,
		231,
		-1,
		233,
		213,
		-1,
		235,
		231,
		-1,
		-1,
		334,
		309,
		-1,
		-1,
		-1,
		294,
		274,
		265,
		249,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		319,
		318,
		-1,
		287,
		290,
		-1,
		280,
		271,
		279,
		226,
		230,
		-1,
		-1,
		-1,
		328,
		309,
		303,
		302,
		300,
		295,
		292,
		278,
		262,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		300,
		292,
		285,
		-1,
		-1,
		287,
		270,
		251,
		249,
		-1,
		-1,
		-1,
		322,
		303,
		-1,
		-1,
		277,
		-1,
		-1,
		283,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		311,
		-1,
		-1,
		-1,
		273,
		269,
		270,
		-1,
		-1,
		-1,
		-1,
		333,
		334,
		357,
		321,
		-1,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		336,
		334,
		-1,
		-1,
		-1,
		293,
		277,
		-1,
		263,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		298,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		311,
		303,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		326,
		317,
		-1,
		-1,
		288,
		295,
		317,
		320,
		356,
		-1,
		307
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		152,
		154,
		120,
		114,
		153,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		143,
		142,
		112,
		110,
		119,
		124,
		131,
		-1,
		154,
		-1,
		164,
		143,
		154,
		159,
		105,
		102,
		122,
		141,
		147,
		139,
		179,
		135,
		106,
		100,
		118,
		123,
		141,
		133,
		-1,
		106,
		96,
		118,
		122,
		134,
		117,
		-1,
		-1,
		100,
		101,
		107,
		119,
		124,
		129,
		-1,
		155,
		171,
		-1,
		-1,
		90,
		103,
		99,
		102,
		110,
		126,
		147,
		164,
		166,
		-1,
		-1,
		91,
		95,
		108,
		109,
		107,
		134,
		153,
		161,
		175,
		174,
		-1,
		79,
		97,
		106,
		115,
		121,
		110,
		114,
		132,
		160,
		166,
		169,
		-1,
		71,
		73,
		98,
		106,
		111,
		118,
		113,
		119,
		138,
		148,
		167,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		68,
		76,
		98,
		90,
		86,
		99,
		116,
		116,
		122,
		126,
		140,
		156,
		157,
		167,
		-1,
		-1,
		151,
		124,
		148,
		106,
		94,
		-1,
		64,
		74,
		79,
		83,
		84,
		86,
		113,
		111,
		-1,
		134,
		133,
		164,
		150,
		161,
		133,
		-1,
		-1,
		109,
		101,
		83,
		86,
		63,
		59,
		71,
		70,
		68,
		64,
		60,
		89,
		101,
		99,
		109,
		128,
		138,
		142,
		157,
		168,
		-1,
		-1,
		233,
		-1,
		-1,
		130,
		113,
		-1,
		78,
		85,
		69,
		75,
		61,
		54,
		81,
		57,
		56,
		75,
		63,
		83,
		93,
		116,
		113,
		125,
		150,
		154,
		158,
		178,
		174,
		-1,
		232,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		85,
		82,
		75,
		99,
		71,
		-1,
		16,
		22,
		46,
		49,
		61,
		74,
		69,
		99,
		99,
		114,
		116,
		132,
		134,
		167,
		155,
		177,
		174,
		203,
		208,
		202,
		211,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		103,
		-1,
		65,
		33,
		8,
		26,
		29,
		50,
		50,
		81,
		75,
		93,
		102,
		105,
		125,
		138,
		145,
		150,
		149,
		167,
		182,
		195,
		199,
		205,
		-1,
		188,
		-1,
		130,
		114,
		116,
		92,
		120,
		-1,
		123,
		66,
		25,
		10,
		0,
		-1,
		54,
		51,
		65,
		72,
		77,
		94,
		109,
		113,
		124,
		139,
		153,
		144,
		162,
		169,
		177,
		181,
		201,
		213,
		148,
		138,
		-1,
		120,
		125,
		95,
		107,
		130,
		72,
		36,
		-1,
		11,
		-1,
		56,
		69,
		-1,
		71,
		75,
		83,
		99,
		113,
		126,
		131,
		135,
		132,
		150,
		153,
		170,
		174,
		190,
		-1,
		-1,
		133,
		137,
		145,
		96,
		115,
		114,
		82,
		29,
		18,
		17,
		-1,
		74,
		102,
		99,
		100,
		103,
		96,
		97,
		119,
		132,
		115,
		134,
		137,
		159,
		187,
		165,
		177,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		122,
		93,
		117,
		96,
		47,
		40,
		28,
		45,
		45,
		52,
		-1,
		124,
		108,
		110,
		101,
		109,
		123,
		120,
		134,
		138,
		137,
		156,
		168,
		159,
		179,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		96,
		130,
		148,
		78,
		64,
		69,
		44,
		50,
		55,
		111,
		120,
		117,
		119,
		111,
		100,
		116,
		124,
		126,
		135,
		144,
		150,
		174,
		181,
		187,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		121,
		128,
		160,
		69,
		153,
		-1,
		88,
		-1,
		61,
		95,
		103,
		109,
		116,
		107,
		107,
		116,
		130,
		141,
		137,
		144,
		179,
		179,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		152,
		169,
		144,
		121,
		102,
		138,
		-1,
		123,
		124,
		-1,
		82,
		76,
		92,
		100,
		107,
		104,
		104,
		114,
		121,
		117,
		131,
		142,
		129,
		165,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		105,
		157,
		-1,
		-1,
		108,
		101,
		-1,
		79,
		88,
		95,
		104,
		109,
		114,
		122,
		115,
		128,
		133,
		134,
		144,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		125,
		-1,
		117,
		109,
		99,
		93,
		87,
		101,
		99,
		119,
		111,
		125,
		125,
		129,
		137,
		122,
		125,
		137,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		138,
		-1,
		102,
		116,
		132,
		-1,
		125,
		104,
		119,
		97,
		111,
		107,
		145,
		146,
		124,
		129,
		136,
		146,
		147,
		136,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		99,
		87,
		119,
		-1,
		-1,
		161,
		-1,
		95,
		112,
		121,
		119,
		135,
		126,
		132,
		147,
		150,
		151,
		141,
		130,
		136,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		136,
		-1,
		139,
		129,
		113,
		98,
		131,
		-1,
		143,
		127,
		132,
		-1,
		176,
		-1,
		149,
		151,
		143,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		148,
		133,
		126,
		116,
		130,
		101,
		-1,
		156,
		-1,
		-1,
		126,
		120,
		120,
		104,
		107,
		159,
		139,
		133,
		132,
		171,
		169,
		157,
		141,
		134,
		131,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		153,
		139,
		143,
		103,
		122,
		-1,
		-1,
		188,
		143,
		129,
		-1,
		113,
		176,
		164,
		154,
		144,
		178,
		179,
		160,
		153,
		139,
		141,
		139,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		136,
		141,
		129,
		115,
		134,
		-1,
		-1,
		-1,
		135,
		151,
		143,
		114,
		165,
		-1,
		-1,
		156,
		154,
		164,
		156,
		143,
		163,
		166,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		139,
		126,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		146,
		167,
		192,
		159,
		-1,
		164,
		165,
		147,
		161,
		168,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		151,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		125,
		139,
		160,
		166,
		178,
		-1,
		173,
		163,
		149,
		166,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		174,
		-1,
		157,
		-1,
		-1,
		-1,
		143,
		158,
		220,
		197,
		170,
		174,
		167,
		161,
		157,
		173,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		157,
		174,
		169,
		151,
		155,
		247,
		-1,
		-1,
		183,
		174,
		165,
		168,
		167,
		170,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		185,
		-1,
		-1,
		-1,
		177,
		-1,
		192,
		-1,
		-1,
		170,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		181,
		173,
		161,
		165,
		188,
		177,
		216,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		206,
		181,
		196,
		242,
		190,
		197,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		178,
		185,
		185,
		177,
		155,
		162,
		178,
		177,
		172,
		208,
		199,
		205,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		212,
		198,
		228,
		218,
		207,
		-1,
		-1,
		232,
		229,
		205,
		188,
		186,
		179,
		174,
		184,
		164,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		215,
		224,
		205,
		210,
		218,
		-1,
		-1,
		205,
		202,
		207,
		195,
		192,
		194,
		189,
		180,
		165,
		171,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		228,
		-1,
		-1,
		213,
		231,
		220,
		210,
		204,
		254,
		209,
		204,
		188,
		186,
		177,
		168,
		175,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		229,
		-1,
		247,
		-1,
		222,
		226,
		217,
		220,
		202,
		189,
		181,
		173,
		189,
		164,
		174,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		307,
		262,
		229,
		220,
		267,
		282,
		286,
		-1,
		241,
		280,
		267,
		-1,
		238,
		-1,
		-1,
		-1,
		236,
		230,
		222,
		222,
		201,
		201,
		175,
		179,
		169,
		176,
		186,
		188,
		180,
		184,
		197,
		208,
		211,
		303,
		301,
		306,
		251,
		234,
		252,
		261,
		282,
		256,
		247,
		274,
		274,
		263,
		258,
		245,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		208,
		196,
		179,
		180,
		176,
		179,
		194,
		197,
		187,
		185,
		179,
		211,
		-1,
		303,
		302,
		291,
		288,
		264,
		255,
		242,
		253,
		-1,
		-1,
		259,
		275,
		288,
		292,
		305,
		330,
		-1,
		248,
		-1,
		-1,
		253,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		184,
		195,
		205,
		193,
		194,
		184,
		194,
		207,
		287,
		284,
		272,
		270,
		293,
		250,
		246,
		-1,
		268,
		262,
		268,
		275,
		292,
		319,
		-1,
		-1,
		264,
		255,
		-1,
		-1,
		236,
		234,
		223,
		-1,
		213,
		186,
		191,
		211,
		213,
		202,
		196,
		190,
		197,
		196,
		204,
		212,
		296,
		310,
		299,
		295,
		294,
		302,
		251,
		253,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		-1,
		274,
		270,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		204,
		208,
		200,
		193,
		188,
		199,
		191,
		195,
		212,
		-1,
		330,
		-1,
		282,
		267,
		281,
		296,
		304,
		-1,
		-1,
		-1,
		291,
		277,
		270,
		258,
		256,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		194,
		205,
		194,
		197,
		211,
		206,
		-1,
		-1,
		279,
		282,
		-1,
		-1,
		281,
		283,
		-1,
		282,
		271,
		256,
		248,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		198,
		204,
		207,
		196,
		200,
		212,
		-1,
		-1,
		286,
		287,
		288,
		-1,
		266,
		-1,
		284,
		-1,
		251,
		257,
		245,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		227,
		225,
		216,
		202,
		209,
		207,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		258,
		291,
		282,
		265,
		245,
		237,
		256,
		-1,
		226,
		-1,
		201,
		203,
		229,
		232,
		238,
		232,
		205,
		220,
		210,
		201,
		210,
		290,
		-1,
		260,
		293,
		257,
		251,
		227,
		231,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		254,
		239,
		220,
		207,
		214,
		214,
		207,
		-1,
		-1,
		-1,
		262,
		261,
		253,
		247,
		247,
		232,
		223,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		244,
		240,
		227,
		227,
		219,
		-1,
		363,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		256,
		251,
		224,
		212,
		218,
		214,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		220,
		255,
		-1,
		358,
		-1,
		292,
		-1,
		-1,
		274,
		254,
		246,
		235,
		224,
		222,
		213,
		204,
		226,
		242,
		226,
		224,
		227,
		228,
		-1,
		347,
		346,
		-1,
		293,
		285,
		271,
		-1,
		264,
		-1,
		270,
		231,
		-1,
		233,
		213,
		-1,
		235,
		231,
		-1,
		-1,
		334,
		309,
		-1,
		-1,
		-1,
		294,
		274,
		265,
		249,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		319,
		318,
		-1,
		287,
		290,
		-1,
		280,
		271,
		279,
		226,
		230,
		-1,
		-1,
		-1,
		328,
		309,
		303,
		302,
		300,
		295,
		292,
		278,
		262,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		300,
		292,
		285,
		-1,
		-1,
		287,
		270,
		251,
		249,
		-1,
		-1,
		-1,
		322,
		303,
		-1,
		-1,
		277,
		-1,
		-1,
		283,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		311,
		-1,
		-1,
		-1,
		273,
		269,
		270,
		-1,
		-1,
		-1,
		-1,
		333,
		334,
		357,
		321,
		-1,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		336,
		334,
		-1,
		-1,
		-1,
		293,
		277,
		-1,
		263,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		298,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		311,
		303,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		326,
		317,
		-1,
		-1,
		288,
		295,
		317,
		320,
		356,
		-1,
		307
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		134,
		123,
		134,
		142,
		115,
		122,
		-1,
		143,
		145,
		111,
		105,
		144,
		115,
		121,
		132,
		-1,
		-1,
		-1,
		134,
		133,
		103,
		101,
		110,
		115,
		122,
		-1,
		145,
		-1,
		155,
		134,
		145,
		150,
		96,
		93,
		113,
		132,
		138,
		130,
		170,
		126,
		97,
		91,
		109,
		114,
		132,
		124,
		-1,
		97,
		87,
		109,
		113,
		125,
		108,
		-1,
		-1,
		91,
		92,
		98,
		110,
		115,
		120,
		-1,
		146,
		145,
		-1,
		-1,
		81,
		94,
		90,
		93,
		101,
		117,
		138,
		145,
		140,
		-1,
		-1,
		82,
		86,
		99,
		100,
		98,
		125,
		144,
		135,
		149,
		148,
		-1,
		70,
		88,
		97,
		106,
		112,
		101,
		105,
		123,
		134,
		140,
		143,
		-1,
		79,
		80,
		79,
		87,
		92,
		99,
		104,
		110,
		129,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		78,
		62,
		79,
		71,
		67,
		80,
		97,
		105,
		113,
		117,
		114,
		130,
		131,
		141,
		-1,
		-1,
		172,
		145,
		169,
		127,
		103,
		-1,
		74,
		55,
		60,
		64,
		65,
		67,
		94,
		92,
		-1,
		108,
		107,
		138,
		124,
		135,
		154,
		-1,
		-1,
		130,
		122,
		104,
		107,
		84,
		80,
		52,
		51,
		47,
		45,
		41,
		70,
		82,
		80,
		90,
		102,
		112,
		116,
		131,
		142,
		-1,
		-1,
		206,
		-1,
		-1,
		151,
		134,
		-1,
		99,
		106,
		90,
		96,
		82,
		76,
		62,
		38,
		35,
		56,
		44,
		64,
		74,
		96,
		87,
		99,
		124,
		128,
		131,
		152,
		147,
		-1,
		205,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		106,
		103,
		96,
		120,
		119,
		-1,
		46,
		34,
		31,
		25,
		35,
		48,
		50,
		71,
		75,
		88,
		90,
		106,
		108,
		141,
		128,
		150,
		147,
		176,
		181,
		175,
		184,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		124,
		-1,
		115,
		83,
		58,
		31,
		34,
		26,
		17,
		55,
		56,
		65,
		78,
		79,
		99,
		112,
		119,
		123,
		122,
		140,
		155,
		168,
		172,
		178,
		-1,
		209,
		-1,
		151,
		135,
		137,
		113,
		141,
		-1,
		144,
		116,
		75,
		60,
		60,
		-1,
		0,
		6,
		32,
		39,
		50,
		67,
		83,
		87,
		98,
		112,
		126,
		117,
		135,
		142,
		150,
		154,
		174,
		186,
		169,
		159,
		-1,
		141,
		146,
		116,
		128,
		151,
		132,
		96,
		-1,
		71,
		-1,
		5,
		18,
		-1,
		38,
		42,
		56,
		72,
		86,
		99,
		105,
		108,
		105,
		123,
		126,
		143,
		147,
		163,
		-1,
		-1,
		154,
		158,
		166,
		117,
		136,
		160,
		142,
		89,
		78,
		77,
		-1,
		23,
		69,
		66,
		67,
		74,
		69,
		70,
		92,
		106,
		88,
		107,
		110,
		132,
		160,
		138,
		150,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		143,
		114,
		138,
		156,
		107,
		100,
		88,
		62,
		60,
		47,
		-1,
		91,
		75,
		83,
		74,
		82,
		95,
		93,
		107,
		111,
		110,
		129,
		141,
		132,
		152,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		117,
		140,
		169,
		95,
		81,
		86,
		61,
		49,
		57,
		78,
		87,
		96,
		92,
		84,
		73,
		89,
		97,
		99,
		108,
		117,
		123,
		147,
		154,
		160,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		131,
		138,
		170,
		86,
		155,
		-1,
		90,
		-1,
		63,
		97,
		97,
		92,
		89,
		86,
		80,
		89,
		103,
		114,
		110,
		117,
		152,
		152,
		144,
		164,
		167,
		-1,
		-1,
		-1,
		173,
		176,
		151,
		128,
		112,
		148,
		-1,
		125,
		126,
		-1,
		84,
		78,
		94,
		99,
		95,
		90,
		94,
		87,
		94,
		90,
		104,
		115,
		102,
		138,
		-1,
		152,
		146,
		154,
		144,
		132,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		81,
		90,
		97,
		97,
		91,
		95,
		99,
		88,
		101,
		106,
		107,
		117,
		137,
		141,
		145,
		134,
		130,
		127,
		141,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		103,
		101,
		119,
		103,
		106,
		106,
		102,
		110,
		95,
		98,
		110,
		114,
		132,
		140,
		132,
		126,
		125,
		137,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		113,
		109,
		126,
		127,
		105,
		110,
		109,
		119,
		120,
		109,
		122,
		114,
		136,
		136,
		120,
		121,
		130,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		123,
		121,
		116,
		107,
		113,
		120,
		123,
		124,
		114,
		103,
		109,
		108,
		130,
		116,
		114,
		133,
		149,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		124,
		108,
		113,
		-1,
		149,
		-1,
		122,
		124,
		116,
		105,
		102,
		113,
		111,
		122,
		139,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		140,
		120,
		114,
		113,
		144,
		142,
		130,
		114,
		107,
		104,
		105,
		118,
		138,
		129,
		141,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		157,
		145,
		135,
		125,
		159,
		158,
		133,
		126,
		112,
		114,
		112,
		114,
		119,
		140,
		141,
		154,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		146,
		-1,
		-1,
		137,
		135,
		145,
		129,
		116,
		136,
		139,
		129,
		113,
		128,
		140,
		148,
		153,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		148,
		169,
		174,
		140,
		-1,
		145,
		140,
		120,
		134,
		141,
		131,
		126,
		120,
		123,
		141,
		158,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		162,
		156,
		160,
		-1,
		148,
		136,
		122,
		139,
		144,
		141,
		132,
		124,
		129,
		126,
		139,
		153,
		157,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		145,
		160,
		202,
		179,
		152,
		147,
		140,
		134,
		130,
		146,
		152,
		163,
		131,
		127,
		128,
		132,
		131,
		148,
		158,
		-1,
		-1,
		159,
		176,
		171,
		153,
		157,
		229,
		-1,
		-1,
		156,
		147,
		138,
		141,
		140,
		143,
		137,
		134,
		139,
		144,
		132,
		141,
		159,
		158,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		172,
		227,
		174,
		156,
		152,
		150,
		143,
		152,
		147,
		142,
		152,
		154,
		146,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		238,
		192,
		199,
		189,
		186,
		-1,
		156,
		181,
		153,
		160,
		151,
		158,
		158,
		150,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		291,
		280,
		269,
		275,
		-1,
		214,
		200,
		224,
		214,
		209,
		-1,
		-1,
		205,
		202,
		178,
		161,
		159,
		152,
		147,
		157,
		137,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		186,
		267,
		260,
		243,
		251,
		282,
		-1,
		217,
		220,
		207,
		206,
		208,
		-1,
		-1,
		178,
		175,
		180,
		168,
		165,
		167,
		162,
		153,
		138,
		144,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		200,
		243,
		237,
		240,
		264,
		278,
		-1,
		225,
		-1,
		-1,
		215,
		209,
		193,
		183,
		177,
		227,
		182,
		177,
		161,
		159,
		150,
		141,
		148,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		235,
		223,
		231,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		231,
		-1,
		220,
		-1,
		195,
		199,
		190,
		193,
		175,
		162,
		154,
		146,
		162,
		137,
		147,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		296,
		252,
		231,
		222,
		269,
		284,
		288,
		-1,
		237,
		276,
		269,
		-1,
		240,
		-1,
		-1,
		-1,
		209,
		203,
		195,
		195,
		174,
		174,
		148,
		152,
		142,
		149,
		159,
		161,
		153,
		157,
		170,
		181,
		184,
		292,
		283,
		296,
		241,
		236,
		254,
		263,
		284,
		252,
		243,
		270,
		276,
		265,
		260,
		247,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		181,
		169,
		152,
		153,
		149,
		152,
		167,
		170,
		160,
		158,
		152,
		184,
		-1,
		285,
		284,
		273,
		270,
		246,
		237,
		232,
		255,
		-1,
		-1,
		254,
		271,
		265,
		269,
		285,
		310,
		-1,
		241,
		-1,
		-1,
		226,
		-1,
		-1,
		211,
		174,
		163,
		154,
		160,
		157,
		168,
		178,
		166,
		167,
		157,
		167,
		180,
		269,
		266,
		254,
		252,
		275,
		240,
		228,
		-1,
		241,
		239,
		245,
		252,
		269,
		299,
		-1,
		-1,
		257,
		237,
		-1,
		-1,
		209,
		207,
		196,
		-1,
		186,
		159,
		164,
		184,
		186,
		175,
		169,
		163,
		170,
		169,
		177,
		185,
		278,
		292,
		281,
		277,
		276,
		284,
		233,
		226,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		243,
		-1,
		-1,
		204,
		197,
		185,
		173,
		163,
		173,
		177,
		181,
		173,
		166,
		161,
		172,
		164,
		168,
		185,
		-1,
		312,
		-1,
		264,
		240,
		254,
		269,
		277,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		238,
		222,
		203,
		-1,
		173,
		186,
		217,
		185,
		190,
		185,
		167,
		178,
		167,
		170,
		184,
		179,
		-1,
		-1,
		252,
		255,
		-1,
		-1,
		254,
		256,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		210,
		206,
		-1,
		-1,
		174,
		199,
		188,
		196,
		191,
		171,
		177,
		180,
		169,
		173,
		185,
		-1,
		-1,
		259,
		260,
		261,
		-1,
		239,
		-1,
		257,
		-1,
		224,
		230,
		218,
		-1,
		-1,
		-1,
		212,
		175,
		196,
		206,
		200,
		198,
		189,
		175,
		182,
		180,
		176,
		187,
		-1,
		-1,
		-1,
		257,
		231,
		264,
		255,
		238,
		218,
		210,
		229,
		-1,
		199,
		-1,
		174,
		176,
		202,
		205,
		211,
		205,
		178,
		193,
		183,
		174,
		183,
		263,
		-1,
		233,
		266,
		230,
		224,
		200,
		204,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		227,
		212,
		193,
		180,
		187,
		187,
		180,
		-1,
		-1,
		-1,
		235,
		234,
		226,
		220,
		220,
		205,
		196,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		217,
		213,
		200,
		200,
		192,
		-1,
		336,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		229,
		224,
		197,
		185,
		191,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		193,
		228,
		-1,
		331,
		-1,
		265,
		-1,
		-1,
		247,
		227,
		219,
		208,
		197,
		195,
		186,
		177,
		199,
		215,
		199,
		197,
		200,
		201,
		-1,
		320,
		319,
		-1,
		266,
		258,
		244,
		-1,
		237,
		-1,
		243,
		204,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		307,
		282,
		-1,
		-1,
		-1,
		267,
		247,
		238,
		222,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		292,
		291,
		-1,
		260,
		263,
		-1,
		253,
		244,
		252,
		199,
		203,
		-1,
		-1,
		-1,
		301,
		282,
		276,
		275,
		273,
		268,
		265,
		251,
		235,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		273,
		265,
		258,
		-1,
		-1,
		260,
		243,
		224,
		222,
		-1,
		-1,
		-1,
		295,
		276,
		-1,
		-1,
		250,
		-1,
		-1,
		256,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		284,
		-1,
		-1,
		-1,
		246,
		242,
		243,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		330,
		294,
		-1,
		-1,
		-1,
		238,
		232,
		-1,
		-1,
		309,
		307,
		-1,
		-1,
		-1,
		266,
		250,
		-1,
		236,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		271,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		284,
		276,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		299,
		290,
		-1,
		-1,
		261,
		268,
		290,
		293,
		329,
		-1,
		280
	],
	[
		-1,
		135,
		124,
		135,
		143,
		116,
		123,
		-1,
		144,
		146,
		112,
		106,
		145,
		116,
		122,
		133,
		-1,
		-1,
		-1,
		135,
		134,
		104,
		102,
		111,
		116,
		123,
		-1,
		146,
		-1,
		156,
		135,
		146,
		151,
		97,
		94,
		114,
		133,
		139,
		131,
		171,
		127,
		98,
		92,
		110,
		115,
		133,
		125,
		-1,
		98,
		88,
		110,
		114,
		126,
		109,
		-1,
		-1,
		92,
		93,
		99,
		111,
		116,
		121,
		-1,
		147,
		146,
		-1,
		-1,
		82,
		95,
		91,
		94,
		102,
		118,
		139,
		146,
		141,
		-1,
		-1,
		83,
		87,
		100,
		101,
		99,
		126,
		145,
		136,
		150,
		149,
		-1,
		71,
		89,
		98,
		107,
		113,
		102,
		106,
		124,
		135,
		141,
		144,
		-1,
		80,
		81,
		80,
		88,
		93,
		100,
		105,
		111,
		130,
		123,
		142,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		79,
		63,
		80,
		72,
		68,
		81,
		98,
		106,
		114,
		118,
		115,
		131,
		132,
		142,
		-1,
		-1,
		173,
		146,
		170,
		128,
		104,
		-1,
		75,
		56,
		61,
		65,
		66,
		68,
		95,
		93,
		-1,
		109,
		108,
		139,
		125,
		136,
		155,
		-1,
		-1,
		131,
		123,
		105,
		108,
		85,
		81,
		53,
		52,
		48,
		46,
		42,
		71,
		83,
		81,
		91,
		103,
		113,
		117,
		132,
		143,
		-1,
		-1,
		207,
		-1,
		-1,
		152,
		135,
		-1,
		100,
		107,
		91,
		97,
		83,
		77,
		63,
		39,
		36,
		57,
		45,
		65,
		75,
		97,
		88,
		100,
		125,
		129,
		132,
		153,
		148,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		107,
		104,
		97,
		121,
		120,
		-1,
		47,
		35,
		32,
		26,
		36,
		49,
		51,
		72,
		76,
		89,
		91,
		107,
		109,
		142,
		129,
		151,
		148,
		177,
		182,
		176,
		185,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		125,
		-1,
		116,
		84,
		59,
		32,
		35,
		27,
		18,
		56,
		57,
		66,
		79,
		80,
		100,
		113,
		120,
		124,
		123,
		141,
		156,
		169,
		173,
		179,
		-1,
		210,
		-1,
		152,
		136,
		138,
		114,
		142,
		-1,
		145,
		117,
		76,
		61,
		61,
		-1,
		10,
		0,
		33,
		40,
		51,
		68,
		84,
		88,
		99,
		113,
		127,
		118,
		136,
		143,
		151,
		155,
		175,
		187,
		170,
		160,
		-1,
		142,
		147,
		117,
		129,
		152,
		133,
		97,
		-1,
		72,
		-1,
		12,
		25,
		-1,
		39,
		43,
		57,
		73,
		87,
		100,
		106,
		109,
		106,
		124,
		127,
		144,
		148,
		164,
		-1,
		-1,
		155,
		159,
		167,
		118,
		137,
		161,
		143,
		90,
		79,
		78,
		-1,
		30,
		70,
		67,
		68,
		75,
		70,
		71,
		93,
		107,
		89,
		108,
		111,
		133,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		144,
		115,
		139,
		157,
		108,
		101,
		89,
		69,
		67,
		54,
		-1,
		92,
		76,
		84,
		75,
		83,
		96,
		94,
		108,
		112,
		111,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		118,
		147,
		170,
		102,
		88,
		93,
		68,
		56,
		64,
		79,
		88,
		97,
		93,
		85,
		74,
		90,
		98,
		100,
		109,
		118,
		124,
		148,
		155,
		161,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		138,
		145,
		177,
		93,
		162,
		-1,
		97,
		-1,
		70,
		104,
		98,
		93,
		90,
		87,
		81,
		90,
		104,
		115,
		111,
		118,
		153,
		153,
		145,
		165,
		168,
		-1,
		-1,
		-1,
		174,
		183,
		158,
		135,
		119,
		155,
		-1,
		132,
		133,
		-1,
		91,
		85,
		101,
		100,
		96,
		91,
		95,
		88,
		95,
		91,
		105,
		116,
		103,
		139,
		-1,
		153,
		147,
		155,
		145,
		133,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		114,
		166,
		-1,
		-1,
		117,
		110,
		-1,
		88,
		93,
		100,
		98,
		92,
		96,
		100,
		89,
		102,
		107,
		108,
		118,
		138,
		142,
		146,
		135,
		131,
		128,
		142,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		134,
		-1,
		126,
		118,
		108,
		102,
		96,
		106,
		104,
		120,
		104,
		107,
		107,
		103,
		111,
		96,
		99,
		111,
		115,
		133,
		141,
		133,
		127,
		126,
		138,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		147,
		-1,
		111,
		125,
		141,
		-1,
		134,
		113,
		128,
		106,
		116,
		112,
		127,
		128,
		106,
		111,
		110,
		120,
		121,
		110,
		123,
		115,
		137,
		137,
		121,
		122,
		131,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		108,
		96,
		128,
		-1,
		-1,
		170,
		-1,
		104,
		121,
		126,
		124,
		117,
		108,
		114,
		121,
		124,
		125,
		115,
		104,
		110,
		109,
		131,
		117,
		115,
		134,
		150,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		148,
		138,
		122,
		107,
		140,
		-1,
		125,
		109,
		114,
		-1,
		150,
		-1,
		123,
		125,
		117,
		106,
		103,
		114,
		112,
		123,
		140,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		165,
		-1,
		-1,
		135,
		129,
		129,
		113,
		116,
		141,
		121,
		115,
		114,
		145,
		143,
		131,
		115,
		108,
		105,
		106,
		119,
		139,
		130,
		142,
		-1,
		-1,
		-1,
		162,
		148,
		152,
		112,
		131,
		-1,
		-1,
		197,
		152,
		138,
		-1,
		122,
		158,
		146,
		136,
		126,
		160,
		159,
		134,
		127,
		113,
		115,
		113,
		115,
		120,
		141,
		142,
		155,
		-1,
		-1,
		145,
		150,
		138,
		124,
		143,
		-1,
		-1,
		-1,
		144,
		160,
		152,
		123,
		147,
		-1,
		-1,
		138,
		136,
		146,
		130,
		117,
		137,
		140,
		130,
		114,
		129,
		141,
		149,
		154,
		-1,
		148,
		135,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		155,
		171,
		175,
		141,
		-1,
		146,
		141,
		121,
		135,
		142,
		132,
		127,
		121,
		124,
		142,
		159,
		-1,
		-1,
		160,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		134,
		148,
		164,
		157,
		161,
		-1,
		149,
		137,
		123,
		140,
		145,
		142,
		133,
		125,
		130,
		127,
		140,
		154,
		158,
		183,
		-1,
		166,
		-1,
		-1,
		-1,
		152,
		167,
		203,
		180,
		153,
		148,
		141,
		135,
		131,
		147,
		153,
		164,
		132,
		128,
		129,
		133,
		132,
		149,
		159,
		-1,
		-1,
		166,
		183,
		178,
		160,
		164,
		230,
		-1,
		-1,
		157,
		148,
		139,
		142,
		141,
		144,
		138,
		135,
		140,
		145,
		133,
		142,
		160,
		159,
		-1,
		-1,
		-1,
		186,
		-1,
		201,
		-1,
		-1,
		179,
		228,
		175,
		157,
		153,
		151,
		144,
		153,
		148,
		143,
		153,
		155,
		147,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		215,
		190,
		205,
		239,
		199,
		206,
		190,
		187,
		-1,
		157,
		182,
		154,
		161,
		152,
		159,
		159,
		151,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		221,
		207,
		225,
		215,
		216,
		-1,
		-1,
		206,
		203,
		179,
		162,
		160,
		153,
		148,
		158,
		138,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		224,
		221,
		214,
		207,
		209,
		-1,
		-1,
		179,
		176,
		181,
		169,
		166,
		168,
		163,
		154,
		139,
		145,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		226,
		-1,
		-1,
		222,
		210,
		194,
		184,
		178,
		228,
		183,
		178,
		162,
		160,
		151,
		142,
		149,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		238,
		-1,
		221,
		-1,
		196,
		200,
		191,
		194,
		176,
		163,
		155,
		147,
		163,
		138,
		148,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		297,
		253,
		238,
		229,
		276,
		291,
		295,
		-1,
		238,
		277,
		275,
		-1,
		247,
		-1,
		-1,
		-1,
		210,
		204,
		196,
		196,
		175,
		175,
		149,
		153,
		143,
		150,
		160,
		162,
		154,
		158,
		171,
		182,
		185,
		293,
		284,
		297,
		242,
		242,
		261,
		270,
		291,
		253,
		244,
		271,
		282,
		271,
		266,
		253,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		182,
		170,
		153,
		154,
		150,
		153,
		168,
		171,
		161,
		159,
		153,
		185,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		260,
		-1,
		-1,
		255,
		272,
		266,
		270,
		286,
		311,
		-1,
		242,
		-1,
		-1,
		227,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		158,
		169,
		179,
		167,
		168,
		158,
		168,
		181,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		242,
		240,
		246,
		253,
		270,
		300,
		-1,
		-1,
		258,
		238,
		-1,
		-1,
		210,
		208,
		197,
		-1,
		187,
		160,
		165,
		185,
		187,
		176,
		170,
		164,
		171,
		170,
		178,
		186,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		244,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		178,
		182,
		174,
		167,
		162,
		173,
		165,
		169,
		186,
		-1,
		313,
		-1,
		265,
		241,
		255,
		270,
		278,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		168,
		179,
		168,
		171,
		185,
		180,
		-1,
		-1,
		253,
		256,
		-1,
		-1,
		255,
		257,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		172,
		178,
		181,
		170,
		174,
		186,
		-1,
		-1,
		260,
		261,
		262,
		-1,
		240,
		-1,
		258,
		-1,
		225,
		231,
		219,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		201,
		199,
		190,
		176,
		183,
		181,
		177,
		188,
		-1,
		-1,
		-1,
		258,
		232,
		265,
		256,
		239,
		219,
		211,
		230,
		-1,
		200,
		-1,
		175,
		177,
		203,
		206,
		212,
		206,
		179,
		194,
		184,
		175,
		184,
		264,
		-1,
		234,
		267,
		231,
		225,
		201,
		205,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		228,
		213,
		194,
		181,
		188,
		188,
		181,
		-1,
		-1,
		-1,
		236,
		235,
		227,
		221,
		221,
		206,
		197,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		218,
		214,
		201,
		201,
		193,
		-1,
		337,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		230,
		225,
		198,
		186,
		192,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		194,
		229,
		-1,
		332,
		-1,
		266,
		-1,
		-1,
		248,
		228,
		220,
		209,
		198,
		196,
		187,
		178,
		200,
		216,
		200,
		198,
		201,
		202,
		-1,
		321,
		320,
		-1,
		267,
		259,
		245,
		-1,
		238,
		-1,
		244,
		205,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		308,
		283,
		-1,
		-1,
		-1,
		268,
		248,
		239,
		223,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		293,
		292,
		-1,
		261,
		264,
		-1,
		254,
		245,
		253,
		200,
		204,
		-1,
		-1,
		-1,
		302,
		283,
		277,
		276,
		274,
		269,
		266,
		252,
		236,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		274,
		266,
		259,
		-1,
		-1,
		261,
		244,
		225,
		223,
		-1,
		-1,
		-1,
		296,
		277,
		-1,
		-1,
		251,
		-1,
		-1,
		257,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		285,
		-1,
		-1,
		-1,
		247,
		243,
		244,
		-1,
		-1,
		-1,
		-1,
		307,
		308,
		331,
		295,
		-1,
		-1,
		-1,
		239,
		233,
		-1,
		-1,
		310,
		308,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		237,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		272,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		262,
		269,
		291,
		294,
		330,
		-1,
		281
	],
	[
		-1,
		141,
		130,
		141,
		149,
		122,
		129,
		-1,
		150,
		152,
		118,
		112,
		151,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		141,
		140,
		110,
		108,
		117,
		122,
		129,
		-1,
		152,
		-1,
		162,
		141,
		152,
		157,
		103,
		100,
		120,
		139,
		145,
		137,
		177,
		133,
		104,
		98,
		116,
		121,
		139,
		131,
		-1,
		104,
		94,
		116,
		120,
		132,
		115,
		-1,
		-1,
		98,
		99,
		105,
		117,
		122,
		127,
		-1,
		148,
		132,
		-1,
		-1,
		88,
		101,
		97,
		100,
		108,
		124,
		140,
		132,
		127,
		-1,
		-1,
		89,
		93,
		106,
		107,
		105,
		127,
		140,
		122,
		136,
		135,
		-1,
		77,
		95,
		104,
		113,
		119,
		103,
		101,
		119,
		121,
		127,
		130,
		-1,
		86,
		87,
		86,
		94,
		99,
		106,
		105,
		106,
		116,
		109,
		128,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		85,
		69,
		86,
		78,
		74,
		87,
		95,
		101,
		106,
		104,
		101,
		117,
		118,
		128,
		-1,
		-1,
		179,
		152,
		176,
		134,
		110,
		-1,
		81,
		62,
		67,
		71,
		72,
		74,
		92,
		88,
		-1,
		95,
		94,
		125,
		111,
		122,
		161,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		59,
		58,
		53,
		52,
		48,
		75,
		78,
		78,
		84,
		89,
		99,
		103,
		118,
		129,
		-1,
		-1,
		193,
		-1,
		-1,
		158,
		141,
		-1,
		106,
		113,
		97,
		103,
		89,
		87,
		69,
		45,
		41,
		63,
		51,
		69,
		70,
		83,
		74,
		86,
		111,
		115,
		118,
		139,
		134,
		-1,
		192,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		113,
		110,
		103,
		127,
		126,
		-1,
		57,
		45,
		42,
		31,
		32,
		45,
		49,
		58,
		62,
		75,
		77,
		93,
		95,
		128,
		115,
		137,
		134,
		163,
		168,
		162,
		171,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		131,
		-1,
		126,
		94,
		69,
		42,
		45,
		27,
		14,
		50,
		45,
		52,
		65,
		66,
		86,
		99,
		106,
		110,
		109,
		127,
		142,
		155,
		159,
		165,
		-1,
		216,
		-1,
		158,
		142,
		144,
		120,
		148,
		-1,
		151,
		127,
		86,
		71,
		71,
		-1,
		32,
		29,
		0,
		26,
		37,
		54,
		70,
		74,
		85,
		99,
		113,
		104,
		122,
		129,
		137,
		141,
		161,
		173,
		176,
		166,
		-1,
		148,
		153,
		123,
		135,
		158,
		143,
		107,
		-1,
		82,
		-1,
		34,
		47,
		-1,
		25,
		29,
		43,
		59,
		73,
		86,
		92,
		95,
		92,
		110,
		113,
		130,
		134,
		150,
		-1,
		-1,
		161,
		165,
		173,
		124,
		143,
		167,
		153,
		100,
		89,
		88,
		-1,
		52,
		56,
		53,
		54,
		61,
		56,
		57,
		79,
		93,
		75,
		94,
		97,
		119,
		147,
		125,
		137,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		150,
		121,
		145,
		167,
		118,
		111,
		99,
		91,
		89,
		76,
		-1,
		78,
		62,
		70,
		61,
		69,
		82,
		80,
		94,
		98,
		97,
		116,
		128,
		119,
		139,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		124,
		147,
		176,
		124,
		110,
		115,
		90,
		78,
		86,
		65,
		74,
		83,
		79,
		71,
		60,
		76,
		84,
		86,
		95,
		104,
		110,
		134,
		141,
		147,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		138,
		145,
		177,
		115,
		162,
		-1,
		116,
		-1,
		92,
		100,
		84,
		79,
		76,
		73,
		67,
		76,
		90,
		101,
		97,
		104,
		139,
		139,
		131,
		151,
		154,
		-1,
		-1,
		-1,
		180,
		183,
		158,
		135,
		119,
		155,
		-1,
		132,
		133,
		-1,
		110,
		104,
		101,
		86,
		82,
		77,
		81,
		74,
		81,
		77,
		91,
		102,
		89,
		125,
		-1,
		139,
		133,
		141,
		131,
		119,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		114,
		166,
		-1,
		-1,
		117,
		110,
		-1,
		97,
		79,
		86,
		84,
		78,
		82,
		86,
		75,
		88,
		93,
		94,
		104,
		124,
		128,
		132,
		121,
		117,
		114,
		128,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		134,
		-1,
		126,
		118,
		108,
		102,
		96,
		92,
		90,
		106,
		90,
		93,
		93,
		89,
		97,
		82,
		85,
		97,
		101,
		119,
		127,
		119,
		113,
		112,
		124,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		147,
		-1,
		111,
		125,
		141,
		-1,
		134,
		113,
		128,
		106,
		102,
		98,
		113,
		114,
		92,
		97,
		96,
		106,
		107,
		96,
		109,
		101,
		123,
		123,
		107,
		108,
		117,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		108,
		96,
		128,
		-1,
		-1,
		170,
		-1,
		104,
		121,
		112,
		110,
		103,
		94,
		100,
		107,
		110,
		111,
		101,
		90,
		96,
		95,
		117,
		103,
		101,
		120,
		136,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		148,
		138,
		122,
		107,
		140,
		-1,
		111,
		95,
		100,
		-1,
		136,
		-1,
		109,
		111,
		103,
		92,
		89,
		100,
		98,
		109,
		126,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		165,
		-1,
		-1,
		135,
		129,
		129,
		113,
		116,
		127,
		107,
		101,
		100,
		131,
		129,
		117,
		101,
		94,
		91,
		92,
		105,
		125,
		116,
		128,
		-1,
		-1,
		-1,
		162,
		148,
		152,
		112,
		131,
		-1,
		-1,
		197,
		152,
		138,
		-1,
		122,
		144,
		132,
		122,
		112,
		146,
		145,
		120,
		113,
		99,
		101,
		99,
		101,
		106,
		127,
		128,
		141,
		-1,
		-1,
		145,
		150,
		138,
		124,
		143,
		-1,
		-1,
		-1,
		144,
		160,
		152,
		123,
		133,
		-1,
		-1,
		124,
		122,
		132,
		116,
		103,
		123,
		126,
		116,
		100,
		115,
		127,
		135,
		140,
		-1,
		148,
		135,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		155,
		157,
		161,
		127,
		-1,
		132,
		127,
		107,
		121,
		128,
		118,
		113,
		107,
		110,
		128,
		145,
		-1,
		-1,
		160,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		134,
		148,
		150,
		143,
		147,
		-1,
		135,
		123,
		109,
		126,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		140,
		144,
		183,
		-1,
		166,
		-1,
		-1,
		-1,
		152,
		167,
		189,
		166,
		139,
		134,
		127,
		121,
		117,
		133,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		135,
		145,
		-1,
		-1,
		166,
		183,
		178,
		160,
		164,
		216,
		-1,
		-1,
		143,
		134,
		125,
		128,
		127,
		130,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		145,
		-1,
		-1,
		-1,
		186,
		-1,
		201,
		-1,
		-1,
		179,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		141,
		133,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		215,
		190,
		205,
		225,
		199,
		206,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		138,
		145,
		145,
		137,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		221,
		207,
		211,
		201,
		204,
		-1,
		-1,
		192,
		189,
		165,
		148,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		215,
		207,
		214,
		193,
		195,
		-1,
		-1,
		165,
		162,
		167,
		155,
		152,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		212,
		-1,
		-1,
		222,
		196,
		180,
		170,
		164,
		214,
		169,
		164,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		238,
		-1,
		207,
		-1,
		182,
		186,
		177,
		180,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		283,
		239,
		238,
		229,
		264,
		279,
		283,
		-1,
		224,
		263,
		261,
		-1,
		245,
		-1,
		-1,
		-1,
		196,
		190,
		182,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		279,
		270,
		283,
		228,
		228,
		249,
		258,
		279,
		239,
		230,
		257,
		268,
		257,
		252,
		239,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		272,
		271,
		260,
		257,
		233,
		224,
		219,
		246,
		-1,
		-1,
		241,
		258,
		252,
		256,
		272,
		297,
		-1,
		228,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		256,
		253,
		241,
		239,
		262,
		227,
		215,
		-1,
		228,
		226,
		232,
		239,
		256,
		286,
		-1,
		-1,
		244,
		224,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		265,
		279,
		268,
		264,
		263,
		271,
		220,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		230,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		299,
		-1,
		251,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		246,
		247,
		248,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		126,
		115,
		126,
		134,
		107,
		114,
		-1,
		135,
		137,
		103,
		97,
		136,
		107,
		113,
		124,
		-1,
		-1,
		-1,
		126,
		125,
		95,
		93,
		102,
		107,
		114,
		-1,
		137,
		-1,
		147,
		126,
		137,
		142,
		88,
		85,
		105,
		124,
		130,
		122,
		162,
		118,
		89,
		83,
		101,
		106,
		124,
		116,
		-1,
		89,
		79,
		101,
		105,
		117,
		100,
		-1,
		-1,
		83,
		84,
		90,
		102,
		107,
		112,
		-1,
		129,
		113,
		-1,
		-1,
		73,
		86,
		82,
		85,
		93,
		108,
		121,
		113,
		108,
		-1,
		-1,
		74,
		78,
		91,
		92,
		90,
		108,
		121,
		103,
		117,
		116,
		-1,
		62,
		80,
		89,
		98,
		100,
		84,
		82,
		100,
		102,
		108,
		111,
		-1,
		71,
		72,
		73,
		81,
		86,
		93,
		86,
		87,
		97,
		90,
		109,
		100,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		71,
		54,
		71,
		68,
		61,
		74,
		76,
		82,
		87,
		85,
		82,
		98,
		99,
		109,
		-1,
		-1,
		165,
		138,
		162,
		120,
		101,
		-1,
		67,
		47,
		53,
		57,
		59,
		59,
		73,
		69,
		-1,
		76,
		75,
		106,
		92,
		103,
		147,
		-1,
		-1,
		123,
		115,
		97,
		100,
		77,
		73,
		62,
		61,
		53,
		39,
		35,
		56,
		59,
		59,
		65,
		70,
		80,
		84,
		99,
		110,
		-1,
		-1,
		174,
		-1,
		-1,
		144,
		127,
		-1,
		92,
		99,
		83,
		89,
		75,
		96,
		72,
		55,
		51,
		49,
		37,
		50,
		51,
		64,
		55,
		67,
		92,
		96,
		99,
		120,
		115,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		99,
		96,
		89,
		113,
		112,
		-1,
		67,
		55,
		52,
		41,
		42,
		36,
		30,
		39,
		43,
		56,
		58,
		74,
		76,
		109,
		96,
		118,
		115,
		144,
		149,
		143,
		152,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		117,
		-1,
		120,
		104,
		79,
		52,
		55,
		37,
		24,
		31,
		26,
		33,
		46,
		47,
		67,
		80,
		87,
		91,
		90,
		108,
		123,
		136,
		140,
		146,
		-1,
		202,
		-1,
		144,
		128,
		130,
		106,
		134,
		-1,
		137,
		121,
		96,
		81,
		81,
		-1,
		42,
		39,
		29,
		0,
		18,
		35,
		51,
		55,
		66,
		80,
		94,
		85,
		103,
		110,
		118,
		122,
		142,
		154,
		162,
		152,
		-1,
		134,
		139,
		109,
		121,
		144,
		153,
		117,
		-1,
		92,
		-1,
		44,
		57,
		-1,
		13,
		10,
		24,
		40,
		54,
		67,
		73,
		76,
		73,
		91,
		94,
		111,
		115,
		131,
		-1,
		-1,
		147,
		151,
		159,
		110,
		129,
		153,
		163,
		110,
		99,
		98,
		-1,
		62,
		37,
		34,
		35,
		42,
		37,
		38,
		60,
		74,
		56,
		75,
		78,
		100,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		136,
		107,
		131,
		173,
		128,
		121,
		109,
		101,
		99,
		86,
		-1,
		59,
		43,
		51,
		42,
		50,
		63,
		61,
		75,
		79,
		78,
		97,
		109,
		100,
		120,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		105,
		128,
		162,
		134,
		120,
		125,
		100,
		88,
		92,
		46,
		55,
		64,
		60,
		52,
		41,
		57,
		65,
		67,
		76,
		85,
		91,
		115,
		122,
		128,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		119,
		126,
		158,
		125,
		143,
		-1,
		97,
		-1,
		86,
		81,
		65,
		60,
		57,
		54,
		48,
		57,
		71,
		82,
		78,
		85,
		120,
		120,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		166,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		67,
		63,
		58,
		62,
		55,
		62,
		58,
		72,
		83,
		70,
		106,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		67,
		65,
		59,
		63,
		67,
		56,
		69,
		74,
		75,
		85,
		105,
		109,
		113,
		102,
		98,
		95,
		109,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		87,
		71,
		74,
		74,
		70,
		78,
		63,
		66,
		78,
		82,
		100,
		108,
		100,
		94,
		93,
		105,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		79,
		94,
		95,
		73,
		78,
		77,
		87,
		88,
		77,
		90,
		82,
		104,
		104,
		88,
		89,
		98,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		93,
		91,
		84,
		75,
		81,
		88,
		91,
		92,
		82,
		71,
		77,
		76,
		98,
		84,
		82,
		101,
		117,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		92,
		76,
		81,
		-1,
		117,
		-1,
		90,
		92,
		84,
		73,
		70,
		81,
		79,
		90,
		107,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		108,
		88,
		82,
		81,
		112,
		110,
		98,
		82,
		75,
		72,
		73,
		86,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		125,
		113,
		103,
		93,
		127,
		126,
		101,
		94,
		80,
		82,
		80,
		82,
		87,
		108,
		109,
		122,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		114,
		-1,
		-1,
		105,
		103,
		113,
		97,
		84,
		104,
		107,
		97,
		81,
		96,
		108,
		116,
		121,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		136,
		138,
		142,
		108,
		-1,
		113,
		108,
		88,
		102,
		109,
		99,
		94,
		88,
		91,
		109,
		126,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		129,
		131,
		124,
		128,
		-1,
		116,
		104,
		90,
		107,
		112,
		109,
		100,
		92,
		97,
		94,
		107,
		121,
		125,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		170,
		147,
		120,
		115,
		108,
		102,
		98,
		114,
		120,
		131,
		99,
		95,
		96,
		100,
		99,
		116,
		126,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		197,
		-1,
		-1,
		124,
		115,
		106,
		109,
		108,
		111,
		105,
		102,
		107,
		112,
		100,
		109,
		127,
		126,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		195,
		142,
		124,
		120,
		118,
		111,
		120,
		115,
		110,
		120,
		122,
		114,
		102,
		106,
		129,
		118,
		157,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		196,
		171,
		186,
		206,
		180,
		187,
		157,
		154,
		-1,
		124,
		149,
		121,
		128,
		119,
		126,
		126,
		118,
		96,
		103,
		119,
		118,
		113,
		149,
		140,
		146,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		202,
		188,
		192,
		182,
		185,
		-1,
		-1,
		173,
		170,
		146,
		129,
		127,
		120,
		115,
		125,
		105,
		92,
		96,
		100,
		106,
		111,
		116,
		122,
		137,
		152,
		-1,
		174,
		255,
		248,
		231,
		239,
		270,
		-1,
		196,
		188,
		195,
		174,
		176,
		-1,
		-1,
		146,
		143,
		148,
		136,
		133,
		135,
		130,
		121,
		106,
		112,
		99,
		98,
		116,
		120,
		129,
		136,
		126,
		139,
		143,
		-1,
		188,
		231,
		225,
		228,
		252,
		266,
		-1,
		193,
		-1,
		-1,
		203,
		177,
		161,
		151,
		145,
		195,
		150,
		145,
		129,
		127,
		118,
		109,
		116,
		107,
		107,
		110,
		125,
		130,
		122,
		136,
		136,
		137,
		-1,
		223,
		211,
		219,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		219,
		-1,
		188,
		-1,
		163,
		167,
		158,
		161,
		143,
		130,
		122,
		114,
		130,
		105,
		115,
		111,
		112,
		121,
		132,
		144,
		143,
		144,
		264,
		220,
		219,
		210,
		245,
		260,
		264,
		-1,
		205,
		244,
		242,
		-1,
		226,
		-1,
		-1,
		-1,
		177,
		171,
		163,
		163,
		142,
		142,
		116,
		120,
		110,
		117,
		127,
		129,
		121,
		125,
		138,
		149,
		152,
		260,
		251,
		264,
		209,
		209,
		230,
		239,
		260,
		220,
		211,
		238,
		249,
		238,
		233,
		220,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		149,
		137,
		120,
		121,
		117,
		120,
		135,
		138,
		128,
		126,
		120,
		152,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		200,
		227,
		-1,
		-1,
		222,
		239,
		233,
		237,
		253,
		278,
		-1,
		209,
		-1,
		-1,
		194,
		-1,
		-1,
		179,
		142,
		131,
		122,
		128,
		125,
		136,
		146,
		134,
		135,
		125,
		135,
		148,
		237,
		234,
		222,
		220,
		243,
		208,
		196,
		-1,
		209,
		207,
		213,
		220,
		237,
		267,
		-1,
		-1,
		225,
		205,
		-1,
		-1,
		177,
		175,
		164,
		-1,
		154,
		127,
		132,
		152,
		154,
		143,
		137,
		131,
		138,
		137,
		145,
		153,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		194,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		215,
		211,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		145,
		149,
		141,
		134,
		129,
		140,
		132,
		136,
		153,
		-1,
		280,
		-1,
		232,
		208,
		222,
		237,
		245,
		-1,
		-1,
		-1,
		232,
		218,
		211,
		199,
		197,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		185,
		153,
		158,
		153,
		135,
		146,
		135,
		138,
		152,
		147,
		-1,
		-1,
		220,
		223,
		-1,
		-1,
		222,
		224,
		-1,
		223,
		212,
		197,
		189,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		142,
		167,
		156,
		164,
		159,
		139,
		145,
		148,
		137,
		141,
		153,
		-1,
		-1,
		227,
		228,
		229,
		-1,
		207,
		-1,
		225,
		-1,
		192,
		198,
		186,
		-1,
		-1,
		-1,
		180,
		143,
		164,
		174,
		168,
		166,
		157,
		143,
		150,
		148,
		144,
		155,
		-1,
		-1,
		-1,
		225,
		199,
		232,
		223,
		206,
		186,
		178,
		197,
		-1,
		167,
		-1,
		142,
		144,
		170,
		173,
		179,
		173,
		146,
		161,
		151,
		142,
		151,
		231,
		-1,
		201,
		234,
		198,
		192,
		168,
		172,
		188,
		-1,
		164,
		146,
		-1,
		174,
		164,
		195,
		180,
		161,
		148,
		155,
		155,
		148,
		-1,
		-1,
		-1,
		203,
		202,
		194,
		188,
		188,
		173,
		164,
		-1,
		176,
		158,
		137,
		154,
		154,
		145,
		153,
		185,
		181,
		168,
		168,
		160,
		-1,
		304,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		197,
		192,
		165,
		153,
		159,
		155,
		141,
		147,
		149,
		157,
		155,
		152,
		164,
		160,
		180,
		161,
		196,
		-1,
		299,
		-1,
		233,
		-1,
		-1,
		215,
		195,
		187,
		176,
		165,
		163,
		154,
		145,
		167,
		183,
		167,
		165,
		168,
		169,
		-1,
		288,
		287,
		-1,
		234,
		226,
		212,
		-1,
		205,
		-1,
		211,
		172,
		-1,
		174,
		154,
		-1,
		176,
		172,
		-1,
		-1,
		275,
		250,
		-1,
		-1,
		-1,
		235,
		215,
		206,
		190,
		-1,
		165,
		165,
		-1,
		-1,
		-1,
		260,
		259,
		-1,
		228,
		231,
		-1,
		221,
		212,
		220,
		167,
		171,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		243,
		241,
		236,
		233,
		219,
		203,
		181,
		170,
		191,
		-1,
		-1,
		-1,
		241,
		233,
		226,
		-1,
		-1,
		228,
		211,
		192,
		190,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		218,
		-1,
		-1,
		224,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		252,
		-1,
		-1,
		-1,
		214,
		210,
		211,
		-1,
		-1,
		-1,
		-1,
		274,
		275,
		298,
		262,
		-1,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		277,
		275,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		204,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		239,
		-1,
		239,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		252,
		244,
		252,
		-1,
		224,
		226,
		-1,
		274,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		229,
		236,
		258,
		261,
		297,
		-1,
		248
	],
	[
		-1,
		108,
		97,
		108,
		116,
		89,
		96,
		-1,
		117,
		119,
		85,
		79,
		118,
		89,
		95,
		106,
		-1,
		-1,
		-1,
		108,
		107,
		77,
		75,
		84,
		89,
		96,
		-1,
		119,
		-1,
		129,
		108,
		119,
		124,
		70,
		67,
		87,
		106,
		112,
		104,
		144,
		100,
		71,
		65,
		83,
		88,
		106,
		98,
		-1,
		71,
		61,
		83,
		87,
		99,
		82,
		-1,
		-1,
		65,
		66,
		72,
		84,
		89,
		94,
		-1,
		111,
		95,
		-1,
		-1,
		55,
		68,
		64,
		67,
		75,
		90,
		103,
		95,
		90,
		-1,
		-1,
		56,
		60,
		73,
		74,
		72,
		90,
		103,
		85,
		99,
		98,
		-1,
		44,
		62,
		71,
		80,
		82,
		66,
		64,
		82,
		84,
		90,
		93,
		-1,
		53,
		54,
		55,
		63,
		68,
		75,
		69,
		69,
		79,
		72,
		91,
		82,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		53,
		36,
		53,
		50,
		43,
		56,
		63,
		69,
		69,
		67,
		64,
		80,
		81,
		91,
		-1,
		-1,
		147,
		120,
		144,
		102,
		83,
		-1,
		49,
		29,
		35,
		39,
		41,
		43,
		60,
		56,
		-1,
		58,
		57,
		88,
		74,
		85,
		129,
		-1,
		-1,
		105,
		97,
		79,
		82,
		59,
		55,
		44,
		43,
		35,
		21,
		17,
		43,
		46,
		46,
		52,
		52,
		62,
		66,
		81,
		92,
		-1,
		-1,
		156,
		-1,
		-1,
		126,
		109,
		-1,
		74,
		81,
		65,
		71,
		57,
		78,
		54,
		45,
		37,
		31,
		19,
		32,
		38,
		51,
		42,
		49,
		74,
		78,
		81,
		102,
		97,
		-1,
		155,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		81,
		78,
		71,
		95,
		94,
		-1,
		66,
		54,
		55,
		40,
		37,
		24,
		12,
		25,
		30,
		43,
		45,
		56,
		58,
		91,
		78,
		100,
		97,
		126,
		131,
		125,
		134,
		-1,
		134,
		130,
		126,
		133,
		82,
		-1,
		-1,
		99,
		-1,
		102,
		103,
		78,
		51,
		54,
		41,
		32,
		19,
		8,
		19,
		32,
		29,
		49,
		62,
		69,
		73,
		72,
		90,
		105,
		118,
		122,
		128,
		-1,
		184,
		-1,
		126,
		110,
		112,
		88,
		116,
		-1,
		119,
		103,
		95,
		80,
		80,
		-1,
		50,
		47,
		37,
		15,
		0,
		17,
		33,
		37,
		48,
		62,
		76,
		67,
		85,
		92,
		100,
		104,
		124,
		136,
		144,
		134,
		-1,
		116,
		121,
		91,
		103,
		126,
		146,
		116,
		-1,
		91,
		-1,
		52,
		65,
		-1,
		21,
		17,
		6,
		22,
		36,
		49,
		55,
		58,
		55,
		73,
		76,
		93,
		97,
		113,
		-1,
		-1,
		129,
		133,
		141,
		92,
		111,
		135,
		162,
		109,
		98,
		97,
		-1,
		70,
		42,
		39,
		40,
		26,
		19,
		20,
		42,
		56,
		38,
		57,
		60,
		82,
		110,
		88,
		100,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		118,
		89,
		113,
		155,
		127,
		120,
		108,
		88,
		88,
		82,
		-1,
		57,
		36,
		33,
		24,
		32,
		46,
		43,
		57,
		61,
		60,
		79,
		91,
		82,
		102,
		-1,
		-1,
		-1,
		148,
		137,
		138,
		87,
		110,
		144,
		121,
		107,
		112,
		87,
		80,
		74,
		51,
		53,
		48,
		42,
		34,
		23,
		39,
		47,
		49,
		58,
		67,
		73,
		97,
		104,
		110,
		-1,
		-1,
		155,
		145,
		129,
		131,
		128,
		101,
		108,
		140,
		112,
		125,
		-1,
		79,
		-1,
		68,
		63,
		47,
		42,
		39,
		36,
		30,
		39,
		53,
		64,
		60,
		67,
		102,
		102,
		94,
		114,
		117,
		-1,
		-1,
		-1,
		148,
		146,
		121,
		98,
		82,
		118,
		-1,
		95,
		96,
		-1,
		73,
		67,
		64,
		49,
		45,
		40,
		44,
		37,
		44,
		40,
		54,
		65,
		52,
		88,
		-1,
		102,
		96,
		104,
		94,
		82,
		-1,
		-1,
		-1,
		144,
		123,
		116,
		136,
		77,
		129,
		-1,
		-1,
		80,
		73,
		-1,
		60,
		42,
		49,
		47,
		41,
		45,
		49,
		38,
		51,
		56,
		57,
		67,
		87,
		91,
		95,
		84,
		80,
		77,
		91,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		97,
		-1,
		89,
		81,
		71,
		65,
		59,
		55,
		53,
		69,
		53,
		56,
		56,
		52,
		60,
		45,
		48,
		60,
		64,
		82,
		90,
		82,
		76,
		75,
		87,
		-1,
		164,
		150,
		121,
		-1,
		-1,
		110,
		-1,
		74,
		88,
		104,
		-1,
		97,
		76,
		91,
		69,
		65,
		61,
		76,
		77,
		55,
		60,
		59,
		69,
		70,
		59,
		72,
		64,
		86,
		86,
		70,
		71,
		80,
		-1,
		170,
		157,
		115,
		111,
		100,
		120,
		71,
		59,
		91,
		-1,
		-1,
		133,
		-1,
		67,
		84,
		75,
		73,
		66,
		57,
		63,
		70,
		73,
		74,
		64,
		53,
		59,
		58,
		80,
		66,
		64,
		83,
		99,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		86,
		73,
		67,
		-1,
		108,
		-1,
		111,
		101,
		85,
		70,
		103,
		-1,
		74,
		58,
		63,
		-1,
		99,
		-1,
		72,
		74,
		66,
		55,
		52,
		63,
		61,
		72,
		89,
		-1,
		120,
		105,
		98,
		88,
		102,
		73,
		-1,
		128,
		-1,
		-1,
		98,
		92,
		92,
		76,
		79,
		90,
		70,
		64,
		63,
		94,
		92,
		80,
		64,
		57,
		54,
		55,
		68,
		88,
		79,
		91,
		-1,
		-1,
		-1,
		125,
		111,
		115,
		75,
		94,
		-1,
		-1,
		160,
		115,
		101,
		-1,
		85,
		107,
		95,
		85,
		75,
		109,
		108,
		83,
		76,
		62,
		64,
		62,
		64,
		69,
		90,
		91,
		104,
		-1,
		-1,
		108,
		113,
		101,
		87,
		106,
		-1,
		-1,
		-1,
		107,
		123,
		115,
		86,
		96,
		-1,
		-1,
		87,
		85,
		95,
		79,
		66,
		86,
		89,
		79,
		63,
		78,
		90,
		98,
		103,
		-1,
		111,
		98,
		-1,
		-1,
		109,
		103,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		118,
		120,
		124,
		90,
		-1,
		95,
		90,
		70,
		84,
		91,
		81,
		76,
		70,
		73,
		91,
		108,
		-1,
		-1,
		123,
		-1,
		118,
		-1,
		-1,
		-1,
		-1,
		97,
		111,
		113,
		106,
		110,
		-1,
		98,
		86,
		72,
		89,
		94,
		91,
		82,
		74,
		79,
		76,
		89,
		103,
		107,
		146,
		-1,
		129,
		-1,
		-1,
		-1,
		115,
		130,
		152,
		129,
		102,
		97,
		90,
		84,
		80,
		96,
		102,
		113,
		81,
		77,
		78,
		82,
		81,
		98,
		108,
		-1,
		-1,
		129,
		146,
		141,
		123,
		127,
		179,
		-1,
		-1,
		106,
		97,
		88,
		91,
		90,
		93,
		87,
		84,
		89,
		94,
		82,
		91,
		109,
		108,
		-1,
		-1,
		-1,
		149,
		-1,
		164,
		-1,
		-1,
		142,
		177,
		124,
		106,
		102,
		100,
		93,
		102,
		97,
		92,
		102,
		104,
		96,
		84,
		88,
		111,
		100,
		139,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		178,
		153,
		168,
		188,
		162,
		169,
		139,
		136,
		-1,
		106,
		131,
		103,
		110,
		101,
		108,
		108,
		100,
		78,
		85,
		101,
		100,
		95,
		131,
		122,
		128,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		184,
		170,
		174,
		164,
		167,
		-1,
		-1,
		155,
		152,
		128,
		111,
		109,
		102,
		97,
		107,
		87,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		156,
		237,
		230,
		213,
		221,
		252,
		-1,
		178,
		170,
		177,
		156,
		158,
		-1,
		-1,
		128,
		125,
		130,
		118,
		115,
		117,
		112,
		103,
		88,
		94,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		170,
		213,
		207,
		210,
		234,
		248,
		-1,
		175,
		-1,
		-1,
		185,
		159,
		143,
		133,
		127,
		177,
		132,
		127,
		111,
		109,
		100,
		91,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		205,
		193,
		201,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		201,
		-1,
		170,
		-1,
		145,
		149,
		140,
		143,
		125,
		112,
		104,
		96,
		112,
		87,
		97,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		246,
		202,
		201,
		192,
		227,
		242,
		246,
		-1,
		187,
		226,
		224,
		-1,
		208,
		-1,
		-1,
		-1,
		159,
		153,
		145,
		145,
		124,
		124,
		98,
		102,
		92,
		99,
		109,
		111,
		103,
		107,
		120,
		131,
		134,
		242,
		233,
		246,
		191,
		191,
		212,
		221,
		242,
		202,
		193,
		220,
		231,
		220,
		215,
		202,
		-1,
		-1,
		182,
		163,
		-1,
		-1,
		131,
		119,
		102,
		103,
		99,
		102,
		117,
		120,
		110,
		108,
		102,
		134,
		-1,
		235,
		234,
		223,
		220,
		196,
		187,
		182,
		209,
		-1,
		-1,
		204,
		221,
		215,
		219,
		235,
		260,
		-1,
		191,
		-1,
		-1,
		176,
		-1,
		-1,
		161,
		124,
		113,
		104,
		110,
		107,
		118,
		128,
		116,
		117,
		107,
		117,
		130,
		219,
		216,
		204,
		202,
		225,
		190,
		178,
		-1,
		191,
		189,
		195,
		202,
		219,
		249,
		-1,
		-1,
		207,
		187,
		-1,
		-1,
		159,
		157,
		146,
		-1,
		136,
		109,
		114,
		134,
		136,
		125,
		119,
		113,
		120,
		119,
		127,
		135,
		228,
		242,
		231,
		227,
		226,
		234,
		183,
		176,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		197,
		193,
		-1,
		-1,
		154,
		147,
		135,
		123,
		113,
		123,
		127,
		131,
		123,
		116,
		111,
		122,
		114,
		118,
		135,
		-1,
		262,
		-1,
		214,
		190,
		204,
		219,
		227,
		-1,
		-1,
		-1,
		214,
		200,
		193,
		181,
		179,
		-1,
		188,
		172,
		153,
		-1,
		123,
		136,
		167,
		135,
		140,
		135,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		202,
		205,
		-1,
		-1,
		204,
		206,
		-1,
		205,
		194,
		179,
		171,
		-1,
		-1,
		160,
		156,
		-1,
		-1,
		124,
		149,
		138,
		146,
		141,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		209,
		210,
		211,
		-1,
		189,
		-1,
		207,
		-1,
		174,
		180,
		168,
		-1,
		-1,
		-1,
		162,
		125,
		146,
		156,
		150,
		148,
		139,
		125,
		132,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		207,
		181,
		214,
		205,
		188,
		168,
		160,
		179,
		-1,
		149,
		-1,
		124,
		126,
		152,
		155,
		161,
		155,
		128,
		143,
		133,
		124,
		133,
		213,
		-1,
		183,
		216,
		180,
		174,
		150,
		154,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		177,
		162,
		143,
		130,
		137,
		137,
		130,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		170,
		155,
		146,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		167,
		163,
		150,
		150,
		142,
		-1,
		286,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		174,
		147,
		135,
		141,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		143,
		178,
		-1,
		281,
		-1,
		215,
		-1,
		-1,
		197,
		177,
		169,
		158,
		147,
		145,
		136,
		127,
		149,
		165,
		149,
		147,
		150,
		151,
		-1,
		270,
		269,
		-1,
		216,
		208,
		194,
		-1,
		187,
		-1,
		193,
		154,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		257,
		232,
		-1,
		-1,
		-1,
		217,
		197,
		188,
		172,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		242,
		241,
		-1,
		210,
		213,
		-1,
		203,
		194,
		202,
		149,
		153,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		225,
		223,
		218,
		215,
		201,
		185,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		223,
		215,
		208,
		-1,
		-1,
		210,
		193,
		174,
		172,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		200,
		-1,
		-1,
		206,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		234,
		-1,
		-1,
		-1,
		196,
		192,
		193,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		280,
		244,
		-1,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		216,
		200,
		-1,
		186,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		221,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		234,
		226,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		211,
		218,
		240,
		243,
		279,
		-1,
		230
	],
	[
		-1,
		129,
		118,
		129,
		137,
		110,
		117,
		-1,
		138,
		140,
		106,
		100,
		139,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		129,
		128,
		98,
		96,
		105,
		110,
		117,
		-1,
		123,
		-1,
		150,
		129,
		140,
		145,
		91,
		88,
		108,
		127,
		116,
		108,
		165,
		121,
		92,
		86,
		104,
		101,
		110,
		102,
		-1,
		92,
		82,
		104,
		90,
		101,
		93,
		-1,
		-1,
		86,
		87,
		93,
		86,
		92,
		88,
		-1,
		98,
		82,
		-1,
		-1,
		76,
		84,
		68,
		71,
		79,
		77,
		90,
		82,
		77,
		-1,
		-1,
		74,
		70,
		77,
		64,
		60,
		77,
		90,
		72,
		86,
		85,
		-1,
		65,
		83,
		83,
		71,
		69,
		53,
		51,
		69,
		71,
		77,
		80,
		-1,
		74,
		75,
		58,
		66,
		71,
		69,
		56,
		56,
		66,
		59,
		78,
		69,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		74,
		57,
		72,
		54,
		44,
		59,
		52,
		58,
		56,
		54,
		51,
		67,
		68,
		78,
		-1,
		-1,
		168,
		141,
		165,
		123,
		104,
		-1,
		70,
		50,
		52,
		48,
		42,
		35,
		49,
		45,
		-1,
		45,
		44,
		75,
		61,
		72,
		150,
		-1,
		-1,
		126,
		118,
		100,
		103,
		80,
		76,
		65,
		64,
		56,
		42,
		38,
		32,
		35,
		35,
		41,
		39,
		49,
		53,
		68,
		79,
		-1,
		-1,
		153,
		-1,
		-1,
		147,
		130,
		-1,
		95,
		102,
		86,
		92,
		78,
		99,
		75,
		66,
		58,
		52,
		40,
		30,
		27,
		40,
		31,
		36,
		61,
		65,
		71,
		89,
		90,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		102,
		99,
		92,
		116,
		115,
		-1,
		87,
		75,
		76,
		61,
		58,
		45,
		33,
		26,
		19,
		32,
		34,
		43,
		45,
		78,
		73,
		94,
		91,
		122,
		128,
		122,
		131,
		-1,
		155,
		151,
		147,
		154,
		103,
		-1,
		-1,
		120,
		-1,
		123,
		124,
		99,
		72,
		75,
		62,
		53,
		40,
		29,
		20,
		19,
		16,
		36,
		49,
		56,
		70,
		69,
		87,
		100,
		115,
		119,
		125,
		-1,
		205,
		-1,
		147,
		131,
		133,
		109,
		137,
		-1,
		140,
		124,
		116,
		101,
		101,
		-1,
		71,
		68,
		58,
		36,
		21,
		0,
		20,
		24,
		35,
		56,
		73,
		64,
		82,
		89,
		97,
		101,
		121,
		133,
		165,
		155,
		-1,
		137,
		142,
		112,
		124,
		147,
		167,
		137,
		-1,
		112,
		-1,
		73,
		86,
		-1,
		42,
		38,
		24,
		35,
		30,
		38,
		42,
		55,
		52,
		70,
		73,
		90,
		94,
		110,
		-1,
		-1,
		150,
		154,
		162,
		113,
		132,
		156,
		183,
		130,
		119,
		118,
		-1,
		91,
		60,
		57,
		58,
		44,
		39,
		38,
		37,
		43,
		52,
		54,
		57,
		79,
		107,
		85,
		97,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		139,
		110,
		134,
		176,
		148,
		141,
		129,
		107,
		107,
		101,
		-1,
		75,
		54,
		53,
		44,
		44,
		60,
		55,
		71,
		58,
		60,
		76,
		88,
		79,
		99,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		106,
		129,
		165,
		140,
		126,
		131,
		106,
		99,
		93,
		69,
		71,
		66,
		61,
		53,
		42,
		58,
		65,
		60,
		60,
		69,
		70,
		94,
		101,
		107,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		120,
		127,
		159,
		131,
		144,
		-1,
		98,
		-1,
		87,
		82,
		66,
		61,
		58,
		55,
		49,
		58,
		66,
		74,
		65,
		80,
		99,
		99,
		91,
		116,
		119,
		-1,
		-1,
		-1,
		169,
		165,
		140,
		117,
		101,
		137,
		-1,
		114,
		115,
		-1,
		92,
		86,
		83,
		68,
		64,
		59,
		63,
		56,
		63,
		59,
		73,
		84,
		66,
		102,
		-1,
		99,
		93,
		121,
		113,
		101,
		-1,
		-1,
		-1,
		163,
		142,
		135,
		155,
		96,
		148,
		-1,
		-1,
		99,
		92,
		-1,
		79,
		61,
		68,
		66,
		60,
		64,
		68,
		57,
		70,
		75,
		71,
		81,
		101,
		105,
		112,
		103,
		99,
		96,
		110,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		116,
		-1,
		108,
		100,
		90,
		84,
		78,
		74,
		72,
		88,
		72,
		75,
		75,
		71,
		79,
		64,
		67,
		74,
		78,
		96,
		109,
		101,
		95,
		94,
		106,
		-1,
		183,
		169,
		140,
		-1,
		-1,
		129,
		-1,
		93,
		107,
		123,
		-1,
		116,
		95,
		110,
		88,
		84,
		80,
		95,
		96,
		74,
		79,
		78,
		88,
		89,
		78,
		86,
		83,
		105,
		105,
		89,
		90,
		99,
		-1,
		189,
		176,
		134,
		130,
		119,
		139,
		90,
		78,
		110,
		-1,
		-1,
		152,
		-1,
		86,
		103,
		94,
		92,
		85,
		76,
		82,
		89,
		92,
		93,
		83,
		72,
		78,
		77,
		99,
		85,
		83,
		102,
		118,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		105,
		92,
		86,
		-1,
		127,
		-1,
		130,
		120,
		104,
		89,
		122,
		-1,
		93,
		77,
		82,
		-1,
		118,
		-1,
		91,
		93,
		85,
		74,
		71,
		82,
		80,
		91,
		108,
		-1,
		139,
		124,
		117,
		107,
		121,
		92,
		-1,
		147,
		-1,
		-1,
		117,
		111,
		111,
		95,
		98,
		109,
		89,
		83,
		82,
		113,
		111,
		99,
		83,
		76,
		73,
		74,
		87,
		107,
		98,
		110,
		-1,
		-1,
		-1,
		144,
		130,
		134,
		94,
		113,
		-1,
		-1,
		179,
		134,
		120,
		-1,
		104,
		126,
		114,
		104,
		94,
		128,
		127,
		102,
		95,
		81,
		83,
		81,
		83,
		88,
		109,
		110,
		123,
		-1,
		-1,
		127,
		132,
		120,
		106,
		125,
		-1,
		-1,
		-1,
		126,
		142,
		134,
		105,
		115,
		-1,
		-1,
		106,
		104,
		114,
		98,
		85,
		105,
		108,
		98,
		82,
		97,
		109,
		117,
		122,
		-1,
		130,
		117,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		137,
		139,
		143,
		109,
		-1,
		114,
		109,
		89,
		103,
		110,
		100,
		95,
		89,
		92,
		110,
		127,
		-1,
		-1,
		142,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		116,
		130,
		132,
		125,
		129,
		-1,
		117,
		105,
		91,
		108,
		113,
		110,
		101,
		93,
		98,
		95,
		108,
		122,
		126,
		165,
		-1,
		148,
		-1,
		-1,
		-1,
		134,
		149,
		171,
		148,
		121,
		116,
		109,
		103,
		99,
		115,
		121,
		132,
		100,
		96,
		97,
		101,
		100,
		117,
		127,
		-1,
		-1,
		148,
		165,
		160,
		142,
		146,
		198,
		-1,
		-1,
		125,
		116,
		107,
		110,
		109,
		112,
		106,
		103,
		108,
		113,
		101,
		110,
		128,
		127,
		-1,
		-1,
		-1,
		168,
		-1,
		183,
		-1,
		-1,
		161,
		196,
		143,
		125,
		121,
		119,
		112,
		121,
		116,
		111,
		121,
		123,
		115,
		103,
		107,
		130,
		119,
		158,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		197,
		172,
		187,
		207,
		181,
		188,
		158,
		155,
		-1,
		125,
		150,
		122,
		129,
		120,
		127,
		127,
		119,
		97,
		104,
		120,
		119,
		114,
		150,
		141,
		147,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		203,
		189,
		193,
		183,
		186,
		-1,
		-1,
		174,
		171,
		147,
		130,
		128,
		121,
		116,
		126,
		106,
		93,
		97,
		101,
		107,
		112,
		117,
		123,
		138,
		153,
		-1,
		175,
		256,
		249,
		232,
		240,
		271,
		-1,
		197,
		189,
		196,
		175,
		177,
		-1,
		-1,
		147,
		144,
		149,
		137,
		134,
		136,
		131,
		122,
		107,
		113,
		100,
		99,
		117,
		121,
		130,
		137,
		127,
		140,
		144,
		-1,
		189,
		232,
		226,
		229,
		253,
		267,
		-1,
		194,
		-1,
		-1,
		204,
		178,
		162,
		152,
		146,
		196,
		151,
		146,
		130,
		128,
		119,
		110,
		117,
		108,
		108,
		111,
		126,
		131,
		123,
		137,
		137,
		138,
		-1,
		224,
		212,
		220,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		220,
		-1,
		189,
		-1,
		164,
		168,
		159,
		162,
		144,
		131,
		123,
		115,
		131,
		106,
		116,
		112,
		113,
		122,
		133,
		145,
		144,
		145,
		265,
		221,
		220,
		211,
		246,
		261,
		265,
		-1,
		206,
		245,
		243,
		-1,
		227,
		-1,
		-1,
		-1,
		178,
		172,
		164,
		164,
		143,
		143,
		117,
		121,
		111,
		118,
		128,
		130,
		122,
		126,
		139,
		150,
		153,
		261,
		252,
		265,
		210,
		210,
		231,
		240,
		261,
		221,
		212,
		239,
		250,
		239,
		234,
		221,
		-1,
		-1,
		201,
		182,
		-1,
		-1,
		150,
		138,
		121,
		122,
		118,
		121,
		136,
		139,
		129,
		127,
		121,
		153,
		-1,
		254,
		253,
		242,
		239,
		215,
		206,
		201,
		228,
		-1,
		-1,
		223,
		240,
		234,
		238,
		254,
		279,
		-1,
		210,
		-1,
		-1,
		195,
		-1,
		-1,
		180,
		143,
		132,
		123,
		129,
		126,
		137,
		147,
		135,
		136,
		126,
		136,
		149,
		238,
		235,
		223,
		221,
		244,
		209,
		197,
		-1,
		210,
		208,
		214,
		221,
		238,
		268,
		-1,
		-1,
		226,
		206,
		-1,
		-1,
		178,
		176,
		165,
		-1,
		155,
		128,
		133,
		153,
		155,
		144,
		138,
		132,
		139,
		138,
		146,
		154,
		247,
		261,
		250,
		246,
		245,
		253,
		202,
		195,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		216,
		212,
		-1,
		-1,
		173,
		166,
		154,
		142,
		132,
		142,
		146,
		150,
		142,
		135,
		130,
		141,
		133,
		137,
		154,
		-1,
		281,
		-1,
		233,
		209,
		223,
		238,
		246,
		-1,
		-1,
		-1,
		233,
		219,
		212,
		200,
		198,
		-1,
		207,
		191,
		172,
		-1,
		142,
		155,
		186,
		154,
		159,
		154,
		136,
		147,
		136,
		139,
		153,
		148,
		-1,
		-1,
		221,
		224,
		-1,
		-1,
		223,
		225,
		-1,
		224,
		213,
		198,
		190,
		-1,
		-1,
		179,
		175,
		-1,
		-1,
		143,
		168,
		157,
		165,
		160,
		140,
		146,
		149,
		138,
		142,
		154,
		-1,
		-1,
		228,
		229,
		230,
		-1,
		208,
		-1,
		226,
		-1,
		193,
		199,
		187,
		-1,
		-1,
		-1,
		181,
		144,
		165,
		175,
		169,
		167,
		158,
		144,
		151,
		149,
		145,
		156,
		-1,
		-1,
		-1,
		226,
		200,
		233,
		224,
		207,
		187,
		179,
		198,
		-1,
		168,
		-1,
		143,
		145,
		171,
		174,
		180,
		174,
		147,
		162,
		152,
		143,
		152,
		232,
		-1,
		202,
		235,
		199,
		193,
		169,
		173,
		189,
		-1,
		165,
		147,
		-1,
		175,
		165,
		196,
		181,
		162,
		149,
		156,
		156,
		149,
		-1,
		-1,
		-1,
		204,
		203,
		195,
		189,
		189,
		174,
		165,
		-1,
		177,
		159,
		138,
		155,
		155,
		146,
		154,
		186,
		182,
		169,
		169,
		161,
		-1,
		305,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		198,
		193,
		166,
		154,
		160,
		156,
		142,
		148,
		150,
		158,
		156,
		153,
		165,
		161,
		181,
		162,
		197,
		-1,
		300,
		-1,
		234,
		-1,
		-1,
		216,
		196,
		188,
		177,
		166,
		164,
		155,
		146,
		168,
		184,
		168,
		166,
		169,
		170,
		-1,
		289,
		288,
		-1,
		235,
		227,
		213,
		-1,
		206,
		-1,
		212,
		173,
		-1,
		175,
		155,
		-1,
		177,
		173,
		-1,
		-1,
		276,
		251,
		-1,
		-1,
		-1,
		236,
		216,
		207,
		191,
		-1,
		166,
		166,
		-1,
		-1,
		-1,
		261,
		260,
		-1,
		229,
		232,
		-1,
		222,
		213,
		221,
		168,
		172,
		-1,
		-1,
		-1,
		270,
		251,
		245,
		244,
		242,
		237,
		234,
		220,
		204,
		182,
		171,
		192,
		-1,
		-1,
		-1,
		242,
		234,
		227,
		-1,
		-1,
		229,
		212,
		193,
		191,
		-1,
		-1,
		-1,
		264,
		245,
		-1,
		-1,
		219,
		-1,
		-1,
		225,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		253,
		-1,
		-1,
		-1,
		215,
		211,
		212,
		-1,
		-1,
		-1,
		-1,
		275,
		276,
		299,
		263,
		-1,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		278,
		276,
		-1,
		-1,
		-1,
		235,
		219,
		-1,
		205,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		240,
		-1,
		240,
		215,
		222,
		-1,
		-1,
		-1,
		-1,
		253,
		245,
		253,
		-1,
		225,
		227,
		-1,
		275,
		-1,
		-1,
		268,
		259,
		-1,
		-1,
		230,
		237,
		259,
		262,
		298,
		-1,
		249
	],
	[
		-1,
		127,
		116,
		127,
		135,
		108,
		115,
		-1,
		134,
		138,
		104,
		98,
		137,
		106,
		112,
		123,
		-1,
		-1,
		-1,
		127,
		126,
		94,
		92,
		101,
		106,
		113,
		-1,
		112,
		-1,
		148,
		127,
		138,
		143,
		87,
		84,
		104,
		123,
		105,
		97,
		163,
		117,
		88,
		82,
		100,
		90,
		99,
		91,
		-1,
		88,
		78,
		100,
		79,
		90,
		82,
		-1,
		-1,
		82,
		83,
		89,
		75,
		81,
		77,
		-1,
		87,
		71,
		-1,
		-1,
		72,
		73,
		57,
		60,
		68,
		66,
		79,
		71,
		66,
		-1,
		-1,
		63,
		59,
		66,
		53,
		49,
		66,
		79,
		61,
		75,
		74,
		-1,
		64,
		78,
		74,
		60,
		58,
		42,
		40,
		58,
		60,
		66,
		69,
		-1,
		73,
		74,
		49,
		57,
		62,
		58,
		45,
		45,
		55,
		48,
		67,
		58,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		73,
		56,
		63,
		45,
		35,
		50,
		43,
		48,
		45,
		43,
		40,
		56,
		57,
		67,
		-1,
		-1,
		167,
		140,
		164,
		122,
		103,
		-1,
		69,
		49,
		43,
		39,
		33,
		26,
		40,
		36,
		-1,
		34,
		33,
		64,
		50,
		61,
		149,
		-1,
		-1,
		125,
		117,
		99,
		102,
		79,
		75,
		64,
		63,
		56,
		49,
		45,
		23,
		26,
		26,
		32,
		28,
		38,
		42,
		57,
		68,
		-1,
		-1,
		142,
		-1,
		-1,
		146,
		129,
		-1,
		94,
		101,
		85,
		91,
		77,
		98,
		74,
		65,
		59,
		54,
		46,
		21,
		18,
		31,
		24,
		25,
		50,
		54,
		60,
		78,
		79,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		101,
		98,
		91,
		115,
		114,
		-1,
		94,
		82,
		83,
		68,
		67,
		61,
		49,
		26,
		10,
		23,
		27,
		32,
		34,
		67,
		62,
		83,
		80,
		111,
		117,
		111,
		120,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		119,
		-1,
		122,
		131,
		106,
		79,
		82,
		69,
		69,
		56,
		45,
		27,
		8,
		5,
		25,
		38,
		45,
		59,
		58,
		76,
		89,
		104,
		108,
		114,
		-1,
		204,
		-1,
		146,
		130,
		132,
		108,
		135,
		-1,
		139,
		123,
		123,
		108,
		108,
		-1,
		85,
		82,
		74,
		52,
		37,
		20,
		0,
		9,
		24,
		45,
		62,
		53,
		71,
		78,
		86,
		90,
		110,
		122,
		164,
		154,
		-1,
		136,
		141,
		110,
		118,
		137,
		166,
		139,
		-1,
		119,
		-1,
		87,
		100,
		-1,
		58,
		54,
		29,
		31,
		20,
		24,
		31,
		44,
		41,
		59,
		62,
		79,
		83,
		99,
		-1,
		-1,
		149,
		153,
		152,
		103,
		122,
		146,
		183,
		132,
		121,
		120,
		-1,
		105,
		65,
		62,
		63,
		49,
		44,
		43,
		26,
		32,
		41,
		43,
		46,
		68,
		96,
		74,
		86,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		129,
		100,
		124,
		166,
		150,
		143,
		131,
		96,
		96,
		90,
		-1,
		80,
		59,
		54,
		43,
		33,
		49,
		44,
		60,
		47,
		49,
		65,
		77,
		68,
		88,
		-1,
		-1,
		-1,
		159,
		148,
		149,
		95,
		118,
		155,
		129,
		115,
		120,
		95,
		88,
		82,
		74,
		76,
		61,
		50,
		42,
		31,
		47,
		54,
		49,
		49,
		58,
		59,
		83,
		90,
		96,
		-1,
		-1,
		166,
		156,
		140,
		142,
		139,
		109,
		116,
		148,
		120,
		133,
		-1,
		87,
		-1,
		76,
		71,
		55,
		50,
		47,
		44,
		38,
		47,
		55,
		63,
		54,
		69,
		88,
		88,
		80,
		105,
		108,
		-1,
		-1,
		-1,
		159,
		154,
		129,
		106,
		90,
		126,
		-1,
		103,
		104,
		-1,
		81,
		75,
		72,
		57,
		53,
		48,
		52,
		45,
		52,
		48,
		62,
		73,
		55,
		91,
		-1,
		88,
		82,
		110,
		102,
		90,
		-1,
		-1,
		-1,
		152,
		131,
		124,
		144,
		85,
		137,
		-1,
		-1,
		88,
		81,
		-1,
		68,
		50,
		57,
		55,
		49,
		53,
		57,
		46,
		59,
		64,
		60,
		70,
		90,
		94,
		101,
		92,
		88,
		85,
		99,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		105,
		-1,
		97,
		89,
		79,
		73,
		67,
		63,
		61,
		77,
		61,
		64,
		64,
		60,
		68,
		53,
		56,
		63,
		67,
		85,
		98,
		90,
		84,
		83,
		95,
		-1,
		172,
		158,
		129,
		-1,
		-1,
		118,
		-1,
		82,
		96,
		112,
		-1,
		105,
		84,
		99,
		77,
		73,
		69,
		84,
		85,
		63,
		68,
		67,
		77,
		78,
		67,
		75,
		72,
		94,
		94,
		78,
		79,
		88,
		-1,
		178,
		165,
		123,
		119,
		108,
		128,
		79,
		67,
		99,
		-1,
		-1,
		141,
		-1,
		75,
		92,
		83,
		81,
		74,
		65,
		71,
		78,
		81,
		82,
		72,
		61,
		67,
		66,
		88,
		74,
		72,
		91,
		107,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		94,
		81,
		75,
		-1,
		116,
		-1,
		119,
		109,
		93,
		78,
		111,
		-1,
		82,
		66,
		71,
		-1,
		107,
		-1,
		80,
		82,
		74,
		63,
		60,
		71,
		69,
		80,
		97,
		-1,
		128,
		113,
		106,
		96,
		110,
		81,
		-1,
		136,
		-1,
		-1,
		106,
		100,
		100,
		84,
		87,
		98,
		78,
		72,
		71,
		102,
		100,
		88,
		72,
		65,
		62,
		63,
		76,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		133,
		119,
		123,
		83,
		102,
		-1,
		-1,
		168,
		123,
		109,
		-1,
		93,
		115,
		103,
		93,
		83,
		117,
		116,
		91,
		84,
		70,
		72,
		70,
		72,
		77,
		98,
		99,
		112,
		-1,
		-1,
		116,
		121,
		109,
		95,
		114,
		-1,
		-1,
		-1,
		115,
		131,
		123,
		94,
		104,
		-1,
		-1,
		95,
		93,
		103,
		87,
		74,
		94,
		97,
		87,
		71,
		86,
		98,
		106,
		111,
		-1,
		119,
		106,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		126,
		128,
		132,
		98,
		-1,
		103,
		98,
		78,
		92,
		99,
		89,
		84,
		78,
		81,
		99,
		116,
		-1,
		-1,
		131,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		105,
		119,
		121,
		114,
		118,
		-1,
		106,
		94,
		80,
		97,
		102,
		99,
		90,
		82,
		87,
		84,
		97,
		111,
		115,
		154,
		-1,
		137,
		-1,
		-1,
		-1,
		123,
		138,
		160,
		137,
		110,
		105,
		98,
		92,
		88,
		104,
		110,
		121,
		89,
		85,
		86,
		90,
		89,
		106,
		116,
		-1,
		-1,
		137,
		154,
		149,
		131,
		135,
		187,
		-1,
		-1,
		114,
		105,
		96,
		99,
		98,
		101,
		95,
		92,
		97,
		102,
		90,
		99,
		117,
		116,
		-1,
		-1,
		-1,
		157,
		-1,
		172,
		-1,
		-1,
		150,
		185,
		132,
		114,
		110,
		108,
		101,
		110,
		105,
		100,
		110,
		112,
		104,
		92,
		96,
		119,
		108,
		147,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		186,
		161,
		176,
		196,
		170,
		177,
		147,
		144,
		-1,
		114,
		139,
		111,
		118,
		109,
		116,
		116,
		108,
		86,
		93,
		109,
		108,
		103,
		139,
		130,
		136,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		192,
		178,
		182,
		172,
		175,
		-1,
		-1,
		163,
		160,
		136,
		119,
		117,
		110,
		105,
		115,
		95,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		164,
		245,
		238,
		221,
		229,
		260,
		-1,
		186,
		178,
		185,
		164,
		166,
		-1,
		-1,
		136,
		133,
		138,
		126,
		123,
		125,
		120,
		111,
		96,
		102,
		89,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		178,
		221,
		215,
		218,
		242,
		256,
		-1,
		183,
		-1,
		-1,
		193,
		167,
		151,
		141,
		135,
		185,
		140,
		135,
		119,
		117,
		108,
		99,
		106,
		97,
		97,
		100,
		115,
		120,
		112,
		126,
		126,
		127,
		-1,
		213,
		201,
		209,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		209,
		-1,
		178,
		-1,
		153,
		157,
		148,
		151,
		133,
		120,
		112,
		104,
		120,
		95,
		105,
		101,
		102,
		111,
		122,
		134,
		133,
		134,
		254,
		210,
		209,
		200,
		235,
		250,
		254,
		-1,
		195,
		234,
		232,
		-1,
		216,
		-1,
		-1,
		-1,
		167,
		161,
		153,
		153,
		132,
		132,
		106,
		110,
		100,
		107,
		117,
		119,
		111,
		115,
		128,
		139,
		142,
		250,
		241,
		254,
		199,
		199,
		220,
		229,
		250,
		210,
		201,
		228,
		239,
		228,
		223,
		210,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		139,
		127,
		110,
		111,
		107,
		110,
		125,
		128,
		118,
		116,
		110,
		142,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		217,
		-1,
		-1,
		212,
		229,
		223,
		227,
		243,
		268,
		-1,
		199,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		115,
		126,
		136,
		124,
		125,
		115,
		125,
		138,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		199,
		197,
		203,
		210,
		227,
		257,
		-1,
		-1,
		215,
		195,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		117,
		122,
		142,
		144,
		133,
		127,
		121,
		128,
		127,
		135,
		143,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		205,
		201,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		135,
		139,
		131,
		124,
		119,
		130,
		122,
		126,
		143,
		-1,
		270,
		-1,
		222,
		198,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		222,
		208,
		201,
		189,
		187,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		125,
		136,
		125,
		128,
		142,
		137,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		212,
		214,
		-1,
		213,
		202,
		187,
		179,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		129,
		135,
		138,
		127,
		131,
		143,
		-1,
		-1,
		217,
		218,
		219,
		-1,
		197,
		-1,
		215,
		-1,
		182,
		188,
		176,
		-1,
		-1,
		-1,
		170,
		133,
		154,
		164,
		158,
		156,
		147,
		133,
		140,
		138,
		134,
		145,
		-1,
		-1,
		-1,
		215,
		189,
		222,
		213,
		196,
		176,
		168,
		187,
		-1,
		157,
		-1,
		132,
		134,
		160,
		163,
		169,
		163,
		136,
		151,
		141,
		132,
		141,
		221,
		-1,
		191,
		224,
		188,
		182,
		158,
		162,
		178,
		-1,
		154,
		136,
		-1,
		164,
		154,
		185,
		170,
		151,
		138,
		145,
		145,
		138,
		-1,
		-1,
		-1,
		193,
		192,
		184,
		178,
		178,
		163,
		154,
		-1,
		166,
		148,
		127,
		144,
		144,
		135,
		143,
		175,
		171,
		158,
		158,
		150,
		-1,
		294,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		187,
		182,
		155,
		143,
		149,
		145,
		131,
		137,
		139,
		147,
		145,
		142,
		154,
		150,
		170,
		151,
		186,
		-1,
		289,
		-1,
		223,
		-1,
		-1,
		205,
		185,
		177,
		166,
		155,
		153,
		144,
		135,
		157,
		173,
		157,
		155,
		158,
		159,
		-1,
		278,
		277,
		-1,
		224,
		216,
		202,
		-1,
		195,
		-1,
		201,
		162,
		-1,
		164,
		144,
		-1,
		166,
		162,
		-1,
		-1,
		265,
		240,
		-1,
		-1,
		-1,
		225,
		205,
		196,
		180,
		-1,
		155,
		155,
		-1,
		-1,
		-1,
		250,
		249,
		-1,
		218,
		221,
		-1,
		211,
		202,
		210,
		157,
		161,
		-1,
		-1,
		-1,
		259,
		240,
		234,
		233,
		231,
		226,
		223,
		209,
		193,
		171,
		160,
		181,
		-1,
		-1,
		-1,
		231,
		223,
		216,
		-1,
		-1,
		218,
		201,
		182,
		180,
		-1,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		208,
		-1,
		-1,
		214,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		242,
		-1,
		-1,
		-1,
		204,
		200,
		201,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		288,
		252,
		-1,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		267,
		265,
		-1,
		-1,
		-1,
		224,
		208,
		-1,
		194,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		229,
		-1,
		229,
		204,
		211,
		-1,
		-1,
		-1,
		-1,
		242,
		234,
		242,
		-1,
		214,
		216,
		-1,
		264,
		-1,
		-1,
		257,
		248,
		-1,
		-1,
		219,
		226,
		248,
		251,
		287,
		-1,
		238
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		135,
		139,
		105,
		99,
		138,
		107,
		113,
		124,
		-1,
		-1,
		-1,
		128,
		127,
		95,
		93,
		102,
		107,
		114,
		-1,
		113,
		-1,
		149,
		128,
		139,
		144,
		88,
		85,
		105,
		124,
		106,
		98,
		164,
		118,
		89,
		83,
		101,
		91,
		100,
		92,
		-1,
		89,
		79,
		101,
		80,
		91,
		83,
		-1,
		-1,
		83,
		84,
		90,
		76,
		82,
		78,
		-1,
		88,
		72,
		-1,
		-1,
		73,
		74,
		58,
		61,
		69,
		67,
		80,
		72,
		67,
		-1,
		-1,
		64,
		60,
		67,
		54,
		50,
		67,
		80,
		62,
		76,
		75,
		-1,
		76,
		91,
		87,
		61,
		59,
		43,
		41,
		59,
		61,
		67,
		70,
		-1,
		86,
		87,
		62,
		70,
		75,
		59,
		46,
		46,
		56,
		49,
		68,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		86,
		69,
		76,
		58,
		48,
		63,
		56,
		49,
		46,
		44,
		41,
		57,
		58,
		68,
		-1,
		-1,
		180,
		153,
		177,
		135,
		116,
		-1,
		82,
		62,
		56,
		52,
		46,
		39,
		53,
		49,
		-1,
		35,
		34,
		65,
		51,
		62,
		155,
		-1,
		-1,
		138,
		130,
		112,
		115,
		92,
		88,
		77,
		76,
		69,
		62,
		58,
		36,
		39,
		39,
		45,
		29,
		39,
		43,
		58,
		69,
		-1,
		-1,
		143,
		-1,
		-1,
		152,
		135,
		-1,
		107,
		114,
		98,
		104,
		90,
		111,
		87,
		78,
		72,
		67,
		59,
		34,
		31,
		44,
		30,
		26,
		51,
		55,
		61,
		79,
		80,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		111,
		111,
		104,
		128,
		127,
		-1,
		107,
		95,
		96,
		81,
		80,
		67,
		55,
		39,
		23,
		30,
		27,
		33,
		34,
		63,
		63,
		84,
		81,
		112,
		118,
		112,
		121,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		132,
		-1,
		135,
		144,
		119,
		92,
		95,
		82,
		75,
		62,
		51,
		40,
		21,
		18,
		21,
		34,
		41,
		60,
		59,
		77,
		90,
		105,
		109,
		115,
		-1,
		210,
		-1,
		152,
		136,
		138,
		110,
		131,
		-1,
		152,
		136,
		136,
		121,
		121,
		-1,
		93,
		90,
		80,
		58,
		43,
		33,
		22,
		0,
		25,
		41,
		63,
		54,
		72,
		79,
		87,
		91,
		111,
		123,
		170,
		160,
		-1,
		142,
		147,
		106,
		114,
		133,
		171,
		135,
		-1,
		130,
		-1,
		95,
		108,
		-1,
		64,
		60,
		34,
		27,
		13,
		15,
		32,
		44,
		42,
		60,
		63,
		80,
		84,
		100,
		-1,
		-1,
		155,
		159,
		148,
		99,
		118,
		142,
		179,
		128,
		117,
		116,
		-1,
		107,
		70,
		67,
		68,
		54,
		41,
		39,
		22,
		28,
		37,
		44,
		47,
		69,
		97,
		75,
		87,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		125,
		96,
		120,
		162,
		146,
		139,
		127,
		92,
		92,
		86,
		-1,
		80,
		59,
		50,
		39,
		29,
		45,
		40,
		56,
		48,
		50,
		66,
		78,
		69,
		89,
		-1,
		-1,
		-1,
		155,
		144,
		145,
		91,
		114,
		151,
		125,
		111,
		116,
		91,
		84,
		78,
		79,
		76,
		57,
		46,
		38,
		27,
		43,
		50,
		45,
		50,
		59,
		60,
		84,
		91,
		97,
		-1,
		-1,
		162,
		152,
		136,
		138,
		135,
		105,
		112,
		144,
		116,
		129,
		-1,
		83,
		-1,
		72,
		67,
		51,
		46,
		43,
		40,
		34,
		43,
		51,
		63,
		55,
		70,
		89,
		89,
		81,
		106,
		109,
		-1,
		-1,
		-1,
		155,
		150,
		125,
		102,
		86,
		122,
		-1,
		99,
		100,
		-1,
		77,
		71,
		68,
		53,
		49,
		44,
		48,
		41,
		48,
		44,
		58,
		69,
		56,
		92,
		-1,
		89,
		83,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		148,
		127,
		120,
		140,
		81,
		133,
		-1,
		-1,
		84,
		77,
		-1,
		64,
		46,
		53,
		51,
		45,
		49,
		53,
		42,
		55,
		60,
		61,
		71,
		91,
		95,
		99,
		88,
		84,
		81,
		95,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		101,
		-1,
		93,
		85,
		75,
		69,
		63,
		59,
		57,
		73,
		57,
		60,
		60,
		56,
		64,
		49,
		52,
		64,
		68,
		86,
		94,
		86,
		80,
		79,
		91,
		-1,
		168,
		154,
		125,
		-1,
		-1,
		114,
		-1,
		78,
		92,
		108,
		-1,
		101,
		80,
		95,
		73,
		69,
		65,
		80,
		81,
		59,
		64,
		63,
		73,
		74,
		63,
		76,
		68,
		90,
		90,
		74,
		75,
		84,
		-1,
		174,
		161,
		119,
		115,
		104,
		124,
		75,
		63,
		95,
		-1,
		-1,
		137,
		-1,
		71,
		88,
		79,
		77,
		70,
		61,
		67,
		74,
		77,
		78,
		68,
		57,
		63,
		62,
		84,
		70,
		68,
		87,
		103,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		90,
		77,
		71,
		-1,
		112,
		-1,
		115,
		105,
		89,
		74,
		107,
		-1,
		78,
		62,
		67,
		-1,
		103,
		-1,
		76,
		78,
		70,
		59,
		56,
		67,
		65,
		76,
		93,
		-1,
		124,
		109,
		102,
		92,
		106,
		77,
		-1,
		132,
		-1,
		-1,
		102,
		96,
		96,
		80,
		83,
		94,
		74,
		68,
		67,
		98,
		96,
		84,
		68,
		61,
		58,
		59,
		72,
		92,
		83,
		95,
		-1,
		-1,
		-1,
		129,
		115,
		119,
		79,
		98,
		-1,
		-1,
		164,
		119,
		105,
		-1,
		89,
		111,
		99,
		89,
		79,
		113,
		112,
		87,
		80,
		66,
		68,
		66,
		68,
		73,
		94,
		95,
		108,
		-1,
		-1,
		112,
		117,
		105,
		91,
		110,
		-1,
		-1,
		-1,
		111,
		127,
		119,
		90,
		100,
		-1,
		-1,
		91,
		89,
		99,
		83,
		70,
		90,
		93,
		83,
		67,
		82,
		94,
		102,
		107,
		-1,
		115,
		102,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		-1,
		-1,
		144,
		110,
		122,
		124,
		128,
		94,
		-1,
		99,
		94,
		74,
		88,
		95,
		85,
		80,
		74,
		77,
		95,
		112,
		-1,
		-1,
		127,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		101,
		115,
		117,
		110,
		114,
		-1,
		102,
		90,
		76,
		93,
		98,
		95,
		86,
		78,
		83,
		80,
		93,
		107,
		111,
		150,
		-1,
		133,
		-1,
		-1,
		-1,
		119,
		134,
		156,
		133,
		106,
		101,
		94,
		88,
		84,
		100,
		106,
		117,
		85,
		81,
		82,
		86,
		85,
		102,
		112,
		-1,
		-1,
		133,
		150,
		145,
		127,
		131,
		183,
		-1,
		-1,
		110,
		101,
		92,
		95,
		94,
		97,
		91,
		88,
		93,
		98,
		86,
		95,
		113,
		112,
		-1,
		-1,
		-1,
		153,
		-1,
		168,
		-1,
		-1,
		146,
		181,
		128,
		110,
		106,
		104,
		97,
		106,
		101,
		96,
		106,
		108,
		100,
		88,
		92,
		115,
		104,
		143,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		182,
		157,
		172,
		192,
		166,
		173,
		143,
		140,
		-1,
		110,
		135,
		107,
		114,
		105,
		112,
		112,
		104,
		82,
		89,
		105,
		104,
		99,
		135,
		126,
		132,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		188,
		174,
		178,
		168,
		171,
		-1,
		-1,
		159,
		156,
		132,
		115,
		113,
		106,
		101,
		111,
		91,
		78,
		82,
		86,
		92,
		97,
		102,
		108,
		123,
		138,
		-1,
		160,
		241,
		234,
		217,
		225,
		256,
		-1,
		182,
		174,
		181,
		160,
		162,
		-1,
		-1,
		132,
		129,
		134,
		122,
		119,
		121,
		116,
		107,
		92,
		98,
		85,
		84,
		102,
		106,
		115,
		122,
		112,
		125,
		129,
		-1,
		174,
		217,
		211,
		214,
		238,
		252,
		-1,
		179,
		-1,
		-1,
		189,
		163,
		147,
		137,
		131,
		181,
		136,
		131,
		115,
		113,
		104,
		95,
		102,
		93,
		93,
		96,
		111,
		116,
		108,
		122,
		122,
		123,
		-1,
		209,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		205,
		-1,
		174,
		-1,
		149,
		153,
		144,
		147,
		129,
		116,
		108,
		100,
		116,
		91,
		101,
		97,
		98,
		107,
		118,
		130,
		129,
		130,
		250,
		206,
		205,
		196,
		231,
		246,
		250,
		-1,
		191,
		230,
		228,
		-1,
		212,
		-1,
		-1,
		-1,
		163,
		157,
		149,
		149,
		128,
		128,
		102,
		106,
		96,
		103,
		113,
		115,
		107,
		111,
		124,
		135,
		138,
		246,
		237,
		250,
		195,
		195,
		216,
		225,
		246,
		206,
		197,
		224,
		235,
		224,
		219,
		206,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		135,
		123,
		106,
		107,
		103,
		106,
		121,
		124,
		114,
		112,
		106,
		138,
		-1,
		239,
		238,
		227,
		224,
		200,
		191,
		186,
		213,
		-1,
		-1,
		208,
		225,
		219,
		223,
		239,
		264,
		-1,
		195,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		128,
		117,
		108,
		114,
		111,
		122,
		132,
		120,
		121,
		111,
		121,
		134,
		223,
		220,
		208,
		206,
		229,
		194,
		182,
		-1,
		195,
		193,
		199,
		206,
		223,
		253,
		-1,
		-1,
		211,
		191,
		-1,
		-1,
		163,
		161,
		150,
		-1,
		140,
		113,
		118,
		138,
		140,
		129,
		123,
		117,
		124,
		123,
		131,
		139,
		232,
		246,
		235,
		231,
		230,
		238,
		187,
		180,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		197,
		-1,
		-1,
		158,
		151,
		139,
		127,
		117,
		127,
		131,
		135,
		127,
		120,
		115,
		126,
		118,
		122,
		139,
		-1,
		266,
		-1,
		218,
		194,
		208,
		223,
		231,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		192,
		176,
		157,
		-1,
		127,
		140,
		171,
		139,
		144,
		139,
		121,
		132,
		121,
		124,
		138,
		133,
		-1,
		-1,
		206,
		209,
		-1,
		-1,
		208,
		210,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		164,
		160,
		-1,
		-1,
		128,
		153,
		142,
		150,
		145,
		125,
		131,
		134,
		123,
		127,
		139,
		-1,
		-1,
		213,
		214,
		215,
		-1,
		193,
		-1,
		211,
		-1,
		178,
		184,
		172,
		-1,
		-1,
		-1,
		166,
		129,
		150,
		160,
		154,
		152,
		143,
		129,
		136,
		134,
		130,
		141,
		-1,
		-1,
		-1,
		211,
		185,
		218,
		209,
		192,
		172,
		164,
		183,
		-1,
		153,
		-1,
		128,
		130,
		156,
		159,
		165,
		159,
		132,
		147,
		137,
		128,
		137,
		217,
		-1,
		187,
		220,
		184,
		178,
		154,
		158,
		174,
		-1,
		150,
		132,
		-1,
		160,
		150,
		181,
		166,
		147,
		134,
		141,
		141,
		134,
		-1,
		-1,
		-1,
		189,
		188,
		180,
		174,
		174,
		159,
		150,
		-1,
		162,
		144,
		123,
		140,
		140,
		131,
		139,
		171,
		167,
		154,
		154,
		146,
		-1,
		290,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		183,
		178,
		151,
		139,
		145,
		141,
		127,
		133,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		147,
		182,
		-1,
		285,
		-1,
		219,
		-1,
		-1,
		201,
		181,
		173,
		162,
		151,
		149,
		140,
		131,
		153,
		169,
		153,
		151,
		154,
		155,
		-1,
		274,
		273,
		-1,
		220,
		212,
		198,
		-1,
		191,
		-1,
		197,
		158,
		-1,
		160,
		140,
		-1,
		162,
		158,
		-1,
		-1,
		261,
		236,
		-1,
		-1,
		-1,
		221,
		201,
		192,
		176,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		246,
		245,
		-1,
		214,
		217,
		-1,
		207,
		198,
		206,
		153,
		157,
		-1,
		-1,
		-1,
		255,
		236,
		230,
		229,
		227,
		222,
		219,
		205,
		189,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		227,
		219,
		212,
		-1,
		-1,
		214,
		197,
		178,
		176,
		-1,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		204,
		-1,
		-1,
		210,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		238,
		-1,
		-1,
		-1,
		200,
		196,
		197,
		-1,
		-1,
		-1,
		-1,
		260,
		261,
		284,
		248,
		-1,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		263,
		261,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		190,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		225,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		238,
		230,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		215,
		222,
		244,
		247,
		283,
		-1,
		234
	],
	[
		-1,
		120,
		109,
		120,
		128,
		101,
		108,
		-1,
		127,
		131,
		97,
		91,
		130,
		99,
		105,
		116,
		-1,
		-1,
		-1,
		120,
		119,
		87,
		85,
		94,
		99,
		106,
		-1,
		105,
		-1,
		141,
		120,
		131,
		136,
		80,
		77,
		97,
		116,
		98,
		90,
		156,
		110,
		81,
		75,
		93,
		83,
		92,
		84,
		-1,
		81,
		71,
		93,
		72,
		83,
		75,
		-1,
		-1,
		75,
		76,
		82,
		68,
		74,
		70,
		-1,
		80,
		64,
		-1,
		-1,
		65,
		66,
		50,
		53,
		61,
		59,
		72,
		64,
		59,
		-1,
		-1,
		56,
		52,
		59,
		46,
		42,
		59,
		72,
		54,
		68,
		67,
		-1,
		68,
		85,
		85,
		53,
		51,
		35,
		33,
		51,
		53,
		59,
		62,
		-1,
		85,
		81,
		63,
		71,
		75,
		51,
		38,
		38,
		48,
		41,
		60,
		51,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		86,
		70,
		77,
		59,
		49,
		64,
		57,
		41,
		38,
		36,
		33,
		49,
		50,
		60,
		-1,
		-1,
		179,
		152,
		176,
		134,
		116,
		-1,
		82,
		63,
		57,
		53,
		47,
		40,
		54,
		50,
		-1,
		27,
		26,
		57,
		43,
		54,
		158,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		78,
		77,
		70,
		63,
		59,
		37,
		40,
		40,
		46,
		21,
		31,
		35,
		50,
		61,
		-1,
		-1,
		132,
		-1,
		-1,
		155,
		138,
		-1,
		106,
		113,
		97,
		103,
		89,
		110,
		88,
		79,
		73,
		68,
		60,
		35,
		32,
		45,
		18,
		18,
		43,
		47,
		53,
		71,
		72,
		-1,
		131,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		113,
		110,
		103,
		127,
		126,
		-1,
		108,
		96,
		97,
		82,
		81,
		75,
		63,
		40,
		24,
		24,
		15,
		24,
		22,
		51,
		54,
		76,
		73,
		102,
		107,
		101,
		110,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		131,
		-1,
		134,
		145,
		120,
		93,
		96,
		83,
		83,
		70,
		59,
		41,
		22,
		19,
		9,
		22,
		29,
		49,
		48,
		66,
		81,
		94,
		98,
		104,
		-1,
		213,
		-1,
		155,
		139,
		141,
		113,
		134,
		-1,
		151,
		135,
		137,
		122,
		122,
		-1,
		99,
		96,
		88,
		66,
		51,
		34,
		22,
		17,
		0,
		29,
		52,
		43,
		61,
		68,
		76,
		80,
		100,
		112,
		173,
		163,
		-1,
		145,
		150,
		109,
		117,
		136,
		174,
		138,
		-1,
		133,
		-1,
		101,
		114,
		-1,
		72,
		68,
		42,
		30,
		19,
		26,
		11,
		32,
		31,
		49,
		52,
		69,
		73,
		89,
		-1,
		-1,
		158,
		162,
		151,
		102,
		121,
		145,
		182,
		131,
		120,
		119,
		-1,
		110,
		78,
		75,
		72,
		59,
		44,
		42,
		25,
		31,
		35,
		33,
		36,
		58,
		86,
		64,
		76,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		128,
		99,
		123,
		165,
		149,
		142,
		130,
		95,
		95,
		89,
		-1,
		83,
		62,
		53,
		42,
		32,
		48,
		35,
		54,
		37,
		39,
		55,
		67,
		58,
		78,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		94,
		117,
		154,
		128,
		114,
		119,
		94,
		87,
		81,
		87,
		79,
		60,
		49,
		41,
		30,
		39,
		45,
		40,
		39,
		48,
		49,
		73,
		80,
		86,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		108,
		115,
		147,
		119,
		132,
		-1,
		86,
		-1,
		75,
		70,
		54,
		49,
		46,
		43,
		37,
		46,
		46,
		53,
		44,
		59,
		78,
		78,
		70,
		95,
		98,
		-1,
		-1,
		-1,
		158,
		153,
		128,
		105,
		89,
		125,
		-1,
		102,
		103,
		-1,
		80,
		74,
		71,
		56,
		52,
		47,
		51,
		44,
		51,
		47,
		61,
		63,
		45,
		81,
		-1,
		78,
		72,
		100,
		101,
		89,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		84,
		136,
		-1,
		-1,
		87,
		80,
		-1,
		67,
		49,
		56,
		54,
		48,
		52,
		56,
		45,
		58,
		63,
		50,
		60,
		80,
		84,
		91,
		84,
		87,
		84,
		98,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		104,
		-1,
		96,
		88,
		78,
		72,
		66,
		62,
		60,
		76,
		60,
		63,
		63,
		59,
		67,
		52,
		55,
		53,
		57,
		75,
		97,
		89,
		83,
		82,
		94,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		117,
		-1,
		81,
		95,
		111,
		-1,
		104,
		83,
		98,
		76,
		72,
		68,
		83,
		84,
		62,
		67,
		66,
		76,
		77,
		66,
		65,
		69,
		84,
		93,
		77,
		78,
		87,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		78,
		66,
		98,
		-1,
		-1,
		140,
		-1,
		74,
		91,
		82,
		80,
		73,
		64,
		70,
		77,
		80,
		81,
		71,
		60,
		66,
		65,
		87,
		73,
		71,
		90,
		106,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		115,
		-1,
		118,
		108,
		92,
		77,
		110,
		-1,
		81,
		65,
		70,
		-1,
		106,
		-1,
		79,
		81,
		73,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		127,
		112,
		105,
		95,
		109,
		80,
		-1,
		135,
		-1,
		-1,
		105,
		99,
		99,
		83,
		86,
		97,
		77,
		71,
		70,
		101,
		99,
		87,
		71,
		64,
		61,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		132,
		118,
		122,
		82,
		101,
		-1,
		-1,
		167,
		122,
		108,
		-1,
		92,
		114,
		102,
		92,
		82,
		116,
		115,
		90,
		83,
		69,
		71,
		69,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		115,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		114,
		130,
		122,
		93,
		103,
		-1,
		-1,
		94,
		92,
		102,
		86,
		73,
		93,
		96,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		118,
		105,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		147,
		113,
		125,
		127,
		131,
		97,
		-1,
		102,
		97,
		77,
		91,
		98,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		130,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		104,
		118,
		120,
		113,
		117,
		-1,
		105,
		93,
		79,
		96,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		122,
		137,
		159,
		136,
		109,
		104,
		97,
		91,
		87,
		103,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		136,
		153,
		148,
		130,
		134,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		97,
		100,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		115,
		-1,
		-1,
		-1,
		156,
		-1,
		171,
		-1,
		-1,
		149,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		111,
		103,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		185,
		160,
		175,
		195,
		169,
		176,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		108,
		115,
		115,
		107,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		191,
		177,
		181,
		171,
		174,
		-1,
		-1,
		162,
		159,
		135,
		118,
		116,
		109,
		104,
		114,
		94,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		163,
		244,
		237,
		220,
		228,
		259,
		-1,
		185,
		177,
		184,
		163,
		165,
		-1,
		-1,
		135,
		132,
		137,
		125,
		122,
		124,
		119,
		110,
		95,
		101,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		177,
		220,
		214,
		217,
		241,
		255,
		-1,
		182,
		-1,
		-1,
		192,
		166,
		150,
		140,
		134,
		184,
		139,
		134,
		118,
		116,
		107,
		98,
		105,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		126,
		-1,
		212,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		208,
		-1,
		177,
		-1,
		152,
		156,
		147,
		150,
		132,
		119,
		111,
		103,
		119,
		94,
		104,
		100,
		101,
		110,
		121,
		133,
		132,
		133,
		253,
		209,
		208,
		199,
		234,
		249,
		253,
		-1,
		194,
		233,
		231,
		-1,
		215,
		-1,
		-1,
		-1,
		166,
		160,
		152,
		152,
		131,
		131,
		105,
		109,
		99,
		106,
		116,
		118,
		110,
		114,
		127,
		138,
		141,
		249,
		240,
		253,
		198,
		198,
		219,
		228,
		249,
		209,
		200,
		227,
		238,
		227,
		222,
		209,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		138,
		126,
		109,
		110,
		106,
		109,
		124,
		127,
		117,
		115,
		109,
		141,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		216,
		-1,
		-1,
		211,
		228,
		222,
		226,
		242,
		267,
		-1,
		198,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		131,
		120,
		111,
		117,
		114,
		125,
		135,
		123,
		124,
		114,
		124,
		137,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		198,
		196,
		202,
		209,
		226,
		256,
		-1,
		-1,
		214,
		194,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		116,
		121,
		141,
		143,
		132,
		126,
		120,
		127,
		126,
		134,
		142,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		134,
		138,
		130,
		123,
		118,
		129,
		121,
		125,
		142,
		-1,
		269,
		-1,
		221,
		197,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		174,
		142,
		147,
		142,
		124,
		135,
		124,
		127,
		141,
		136,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		211,
		213,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		131,
		156,
		145,
		153,
		148,
		128,
		134,
		137,
		126,
		130,
		142,
		-1,
		-1,
		216,
		217,
		218,
		-1,
		196,
		-1,
		214,
		-1,
		181,
		187,
		175,
		-1,
		-1,
		-1,
		169,
		132,
		153,
		163,
		157,
		155,
		146,
		132,
		139,
		137,
		133,
		144,
		-1,
		-1,
		-1,
		214,
		188,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		131,
		133,
		159,
		162,
		168,
		162,
		135,
		150,
		140,
		131,
		140,
		220,
		-1,
		190,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		135,
		-1,
		163,
		153,
		184,
		169,
		150,
		137,
		144,
		144,
		137,
		-1,
		-1,
		-1,
		192,
		191,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		174,
		170,
		157,
		157,
		149,
		-1,
		293,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		150,
		185,
		-1,
		288,
		-1,
		222,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		157,
		158,
		-1,
		277,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		125,
		114,
		125,
		133,
		106,
		113,
		-1,
		132,
		136,
		102,
		96,
		135,
		104,
		110,
		121,
		-1,
		-1,
		-1,
		125,
		124,
		92,
		90,
		99,
		104,
		111,
		-1,
		110,
		-1,
		146,
		125,
		136,
		141,
		85,
		82,
		102,
		121,
		103,
		95,
		161,
		115,
		86,
		80,
		98,
		88,
		97,
		89,
		-1,
		86,
		76,
		98,
		77,
		88,
		80,
		-1,
		-1,
		80,
		81,
		87,
		73,
		79,
		75,
		-1,
		85,
		69,
		-1,
		-1,
		70,
		71,
		55,
		58,
		66,
		64,
		77,
		69,
		64,
		-1,
		-1,
		61,
		57,
		64,
		51,
		47,
		64,
		77,
		59,
		73,
		72,
		-1,
		73,
		90,
		90,
		58,
		56,
		40,
		38,
		56,
		58,
		64,
		64,
		-1,
		90,
		86,
		86,
		85,
		80,
		56,
		43,
		43,
		53,
		46,
		65,
		53,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		91,
		82,
		99,
		82,
		72,
		77,
		75,
		46,
		43,
		41,
		38,
		54,
		52,
		62,
		-1,
		-1,
		184,
		157,
		181,
		139,
		121,
		-1,
		87,
		86,
		80,
		76,
		70,
		63,
		77,
		62,
		-1,
		32,
		31,
		59,
		45,
		56,
		166,
		-1,
		-1,
		142,
		134,
		116,
		119,
		96,
		92,
		101,
		100,
		93,
		83,
		79,
		60,
		63,
		63,
		69,
		26,
		36,
		40,
		38,
		63,
		-1,
		-1,
		108,
		-1,
		-1,
		163,
		146,
		-1,
		111,
		118,
		102,
		108,
		94,
		115,
		111,
		102,
		96,
		91,
		81,
		58,
		55,
		68,
		41,
		23,
		48,
		52,
		33,
		54,
		49,
		-1,
		107,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		118,
		115,
		108,
		132,
		131,
		-1,
		128,
		116,
		117,
		102,
		99,
		86,
		74,
		63,
		47,
		47,
		38,
		13,
		11,
		41,
		30,
		52,
		49,
		78,
		83,
		77,
		86,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		136,
		-1,
		139,
		152,
		140,
		113,
		116,
		103,
		94,
		81,
		70,
		64,
		45,
		42,
		25,
		5,
		20,
		25,
		24,
		42,
		57,
		70,
		74,
		80,
		-1,
		221,
		-1,
		163,
		147,
		149,
		123,
		144,
		-1,
		156,
		140,
		157,
		142,
		142,
		-1,
		112,
		109,
		99,
		77,
		62,
		57,
		45,
		40,
		30,
		0,
		28,
		19,
		37,
		44,
		52,
		56,
		76,
		88,
		181,
		171,
		-1,
		153,
		158,
		119,
		127,
		146,
		183,
		148,
		-1,
		143,
		-1,
		114,
		127,
		-1,
		83,
		79,
		61,
		53,
		42,
		49,
		25,
		3,
		7,
		25,
		28,
		45,
		49,
		65,
		-1,
		-1,
		166,
		170,
		161,
		112,
		131,
		155,
		192,
		141,
		130,
		129,
		-1,
		120,
		97,
		94,
		82,
		69,
		54,
		55,
		48,
		45,
		24,
		9,
		12,
		34,
		62,
		40,
		52,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		138,
		109,
		133,
		175,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		93,
		72,
		63,
		52,
		50,
		57,
		30,
		33,
		13,
		15,
		31,
		43,
		34,
		54,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		138,
		124,
		129,
		104,
		97,
		91,
		106,
		89,
		70,
		59,
		51,
		40,
		31,
		41,
		35,
		15,
		24,
		25,
		49,
		56,
		62,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		80,
		64,
		59,
		56,
		49,
		36,
		46,
		43,
		29,
		20,
		35,
		54,
		54,
		46,
		71,
		74,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		81,
		66,
		62,
		53,
		57,
		51,
		50,
		46,
		38,
		39,
		21,
		57,
		-1,
		54,
		48,
		76,
		79,
		69,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		65,
		60,
		58,
		58,
		57,
		46,
		54,
		46,
		26,
		36,
		56,
		60,
		67,
		60,
		65,
		64,
		78,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		72,
		70,
		86,
		70,
		70,
		69,
		60,
		68,
		50,
		43,
		29,
		33,
		51,
		78,
		73,
		68,
		67,
		74,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		82,
		77,
		93,
		94,
		72,
		69,
		67,
		77,
		65,
		54,
		41,
		45,
		60,
		70,
		62,
		63,
		72,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		91,
		89,
		83,
		74,
		80,
		78,
		74,
		69,
		59,
		48,
		54,
		50,
		72,
		58,
		56,
		75,
		90,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		91,
		75,
		80,
		-1,
		94,
		-1,
		67,
		67,
		58,
		47,
		44,
		55,
		53,
		64,
		81,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		107,
		87,
		81,
		80,
		89,
		84,
		75,
		56,
		49,
		46,
		47,
		60,
		80,
		71,
		83,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		124,
		112,
		102,
		92,
		110,
		100,
		75,
		68,
		54,
		56,
		54,
		56,
		61,
		82,
		83,
		96,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		113,
		-1,
		-1,
		104,
		102,
		92,
		71,
		58,
		78,
		81,
		71,
		55,
		70,
		82,
		90,
		95,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		117,
		112,
		116,
		107,
		-1,
		88,
		82,
		62,
		76,
		83,
		73,
		68,
		62,
		65,
		83,
		100,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		105,
		98,
		102,
		-1,
		90,
		78,
		64,
		81,
		86,
		83,
		74,
		66,
		71,
		68,
		81,
		95,
		99,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		144,
		121,
		94,
		89,
		82,
		76,
		72,
		88,
		94,
		105,
		73,
		69,
		70,
		74,
		73,
		90,
		100,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		171,
		-1,
		-1,
		98,
		89,
		80,
		83,
		82,
		85,
		79,
		76,
		81,
		86,
		74,
		83,
		101,
		100,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		169,
		116,
		98,
		94,
		92,
		85,
		94,
		89,
		84,
		94,
		96,
		88,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		187,
		170,
		174,
		180,
		179,
		173,
		131,
		128,
		-1,
		98,
		123,
		95,
		102,
		93,
		100,
		100,
		92,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		147,
		144,
		120,
		103,
		101,
		94,
		89,
		99,
		79,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		173,
		254,
		247,
		229,
		237,
		268,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		120,
		117,
		122,
		110,
		107,
		109,
		104,
		95,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		187,
		230,
		223,
		226,
		250,
		264,
		-1,
		167,
		-1,
		-1,
		179,
		151,
		135,
		125,
		119,
		169,
		124,
		119,
		103,
		101,
		92,
		83,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		213,
		210,
		217,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		195,
		-1,
		162,
		-1,
		137,
		141,
		132,
		135,
		117,
		104,
		96,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		179,
		218,
		216,
		-1,
		200,
		-1,
		-1,
		-1,
		151,
		145,
		137,
		137,
		116,
		116,
		90,
		94,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		194,
		185,
		212,
		223,
		212,
		207,
		194,
		-1,
		-1,
		174,
		155,
		-1,
		-1,
		123,
		111,
		94,
		95,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		213,
		207,
		211,
		227,
		252,
		-1,
		183,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		241,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		119,
		123,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		194,
		197,
		-1,
		-1,
		196,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		201,
		202,
		203,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		154,
		117,
		138,
		148,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		118,
		144,
		147,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		169,
		154,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		159,
		155,
		142,
		142,
		134,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		135,
		170,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		142,
		143,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		140,
		129,
		140,
		148,
		121,
		128,
		-1,
		147,
		151,
		117,
		111,
		150,
		119,
		125,
		136,
		-1,
		-1,
		-1,
		140,
		139,
		107,
		105,
		114,
		119,
		126,
		-1,
		125,
		-1,
		161,
		140,
		151,
		156,
		100,
		97,
		117,
		136,
		118,
		110,
		176,
		130,
		101,
		95,
		113,
		103,
		112,
		104,
		-1,
		101,
		91,
		113,
		92,
		103,
		95,
		-1,
		-1,
		95,
		96,
		102,
		88,
		94,
		90,
		-1,
		100,
		84,
		-1,
		-1,
		85,
		86,
		70,
		73,
		81,
		79,
		92,
		84,
		79,
		-1,
		-1,
		76,
		72,
		79,
		66,
		62,
		79,
		92,
		74,
		83,
		81,
		-1,
		88,
		105,
		105,
		73,
		71,
		55,
		53,
		71,
		73,
		79,
		73,
		-1,
		105,
		101,
		102,
		100,
		95,
		71,
		58,
		58,
		68,
		61,
		75,
		62,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		97,
		114,
		98,
		88,
		92,
		90,
		61,
		58,
		56,
		53,
		69,
		61,
		71,
		-1,
		-1,
		199,
		172,
		196,
		154,
		136,
		-1,
		102,
		102,
		96,
		92,
		86,
		79,
		92,
		77,
		-1,
		47,
		46,
		68,
		54,
		65,
		181,
		-1,
		-1,
		157,
		149,
		131,
		134,
		111,
		107,
		117,
		116,
		109,
		98,
		94,
		76,
		79,
		79,
		85,
		41,
		51,
		55,
		47,
		72,
		-1,
		-1,
		123,
		-1,
		-1,
		178,
		161,
		-1,
		126,
		133,
		117,
		123,
		109,
		130,
		127,
		118,
		112,
		107,
		96,
		74,
		71,
		84,
		63,
		38,
		63,
		67,
		42,
		63,
		58,
		-1,
		122,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		133,
		130,
		123,
		147,
		146,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		79,
		63,
		63,
		60,
		42,
		40,
		70,
		39,
		61,
		58,
		88,
		98,
		92,
		101,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		151,
		-1,
		154,
		167,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		80,
		61,
		58,
		54,
		34,
		49,
		34,
		33,
		51,
		66,
		85,
		89,
		95,
		-1,
		236,
		-1,
		178,
		162,
		164,
		138,
		159,
		-1,
		171,
		155,
		172,
		157,
		157,
		-1,
		127,
		124,
		114,
		92,
		77,
		73,
		61,
		56,
		47,
		29,
		0,
		28,
		46,
		53,
		67,
		71,
		91,
		103,
		196,
		186,
		-1,
		168,
		173,
		134,
		142,
		161,
		198,
		163,
		-1,
		158,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		69,
		58,
		65,
		40,
		25,
		22,
		34,
		37,
		60,
		64,
		80,
		-1,
		-1,
		181,
		185,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		112,
		109,
		97,
		84,
		69,
		70,
		64,
		60,
		39,
		24,
		24,
		43,
		77,
		55,
		67,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		65,
		72,
		45,
		47,
		27,
		29,
		46,
		58,
		49,
		69,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		121,
		104,
		85,
		74,
		66,
		55,
		46,
		55,
		48,
		30,
		39,
		40,
		64,
		71,
		77,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		64,
		51,
		61,
		56,
		44,
		35,
		50,
		69,
		69,
		61,
		86,
		89,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		68,
		72,
		66,
		65,
		61,
		53,
		54,
		36,
		72,
		-1,
		69,
		63,
		91,
		94,
		84,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		80,
		75,
		73,
		73,
		72,
		61,
		69,
		61,
		41,
		51,
		71,
		75,
		82,
		75,
		80,
		79,
		93,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		85,
		84,
		75,
		83,
		65,
		58,
		44,
		48,
		66,
		93,
		88,
		83,
		82,
		89,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		92,
		108,
		109,
		87,
		84,
		82,
		92,
		80,
		69,
		56,
		60,
		75,
		85,
		77,
		78,
		87,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		106,
		104,
		98,
		89,
		95,
		93,
		89,
		84,
		74,
		63,
		69,
		65,
		87,
		73,
		71,
		90,
		105,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		106,
		90,
		95,
		-1,
		109,
		-1,
		82,
		82,
		73,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		122,
		102,
		96,
		95,
		104,
		99,
		90,
		71,
		64,
		61,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		139,
		127,
		117,
		107,
		125,
		115,
		90,
		83,
		69,
		71,
		69,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		128,
		-1,
		-1,
		119,
		117,
		107,
		86,
		73,
		93,
		96,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		132,
		127,
		131,
		122,
		-1,
		103,
		97,
		77,
		91,
		98,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		129,
		143,
		120,
		113,
		117,
		-1,
		105,
		93,
		79,
		96,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		147,
		162,
		159,
		136,
		109,
		104,
		97,
		91,
		87,
		103,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		161,
		178,
		173,
		155,
		159,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		97,
		100,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		115,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		174,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		111,
		103,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		202,
		185,
		189,
		195,
		194,
		188,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		108,
		115,
		115,
		107,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		195,
		191,
		181,
		171,
		174,
		-1,
		-1,
		162,
		159,
		135,
		118,
		116,
		109,
		104,
		114,
		94,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		188,
		269,
		262,
		244,
		252,
		283,
		-1,
		185,
		177,
		188,
		163,
		165,
		-1,
		-1,
		135,
		132,
		137,
		125,
		122,
		124,
		119,
		110,
		95,
		101,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		202,
		245,
		238,
		241,
		265,
		279,
		-1,
		182,
		-1,
		-1,
		194,
		166,
		150,
		140,
		134,
		184,
		139,
		134,
		118,
		116,
		107,
		98,
		105,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		126,
		-1,
		228,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		210,
		-1,
		177,
		-1,
		152,
		156,
		147,
		150,
		132,
		119,
		111,
		103,
		119,
		94,
		104,
		100,
		101,
		110,
		121,
		133,
		132,
		133,
		253,
		209,
		212,
		223,
		234,
		249,
		253,
		-1,
		194,
		233,
		231,
		-1,
		215,
		-1,
		-1,
		-1,
		166,
		160,
		152,
		152,
		131,
		131,
		105,
		109,
		99,
		106,
		116,
		118,
		110,
		114,
		127,
		138,
		141,
		249,
		240,
		253,
		198,
		198,
		219,
		228,
		249,
		209,
		200,
		227,
		238,
		227,
		222,
		209,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		138,
		126,
		109,
		110,
		106,
		109,
		124,
		127,
		117,
		115,
		109,
		141,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		216,
		-1,
		-1,
		211,
		228,
		222,
		226,
		242,
		267,
		-1,
		198,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		131,
		120,
		111,
		117,
		114,
		125,
		135,
		123,
		124,
		114,
		124,
		137,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		198,
		196,
		202,
		209,
		226,
		256,
		-1,
		-1,
		214,
		194,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		116,
		121,
		141,
		143,
		132,
		126,
		120,
		127,
		126,
		134,
		142,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		134,
		138,
		130,
		123,
		118,
		129,
		121,
		125,
		142,
		-1,
		269,
		-1,
		221,
		197,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		174,
		142,
		147,
		142,
		124,
		135,
		124,
		127,
		141,
		136,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		211,
		213,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		131,
		156,
		145,
		153,
		148,
		128,
		134,
		137,
		126,
		130,
		142,
		-1,
		-1,
		216,
		217,
		218,
		-1,
		196,
		-1,
		214,
		-1,
		181,
		187,
		175,
		-1,
		-1,
		-1,
		169,
		132,
		153,
		163,
		157,
		155,
		146,
		132,
		139,
		137,
		133,
		144,
		-1,
		-1,
		-1,
		214,
		188,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		131,
		133,
		159,
		162,
		168,
		162,
		135,
		150,
		140,
		131,
		140,
		220,
		-1,
		190,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		135,
		-1,
		163,
		153,
		184,
		169,
		150,
		137,
		144,
		144,
		137,
		-1,
		-1,
		-1,
		192,
		191,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		174,
		170,
		157,
		157,
		149,
		-1,
		293,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		150,
		185,
		-1,
		288,
		-1,
		222,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		157,
		158,
		-1,
		277,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		138,
		142,
		108,
		102,
		141,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		131,
		130,
		98,
		96,
		105,
		110,
		117,
		-1,
		116,
		-1,
		152,
		131,
		142,
		147,
		91,
		88,
		108,
		127,
		109,
		101,
		167,
		121,
		92,
		86,
		104,
		94,
		103,
		95,
		-1,
		92,
		82,
		104,
		83,
		94,
		86,
		-1,
		-1,
		86,
		87,
		93,
		79,
		85,
		81,
		-1,
		91,
		73,
		-1,
		-1,
		76,
		77,
		61,
		64,
		72,
		70,
		83,
		75,
		68,
		-1,
		-1,
		67,
		63,
		70,
		57,
		53,
		70,
		83,
		65,
		55,
		53,
		-1,
		79,
		96,
		96,
		64,
		62,
		46,
		44,
		62,
		64,
		53,
		45,
		-1,
		96,
		92,
		93,
		91,
		86,
		62,
		49,
		49,
		59,
		52,
		47,
		34,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		97,
		88,
		105,
		89,
		79,
		83,
		81,
		52,
		49,
		47,
		44,
		50,
		33,
		43,
		-1,
		-1,
		190,
		163,
		187,
		145,
		127,
		-1,
		93,
		93,
		87,
		83,
		77,
		70,
		83,
		68,
		-1,
		38,
		37,
		40,
		26,
		37,
		172,
		-1,
		-1,
		148,
		140,
		122,
		125,
		102,
		98,
		108,
		107,
		100,
		89,
		85,
		67,
		70,
		70,
		76,
		32,
		36,
		33,
		19,
		44,
		-1,
		-1,
		111,
		-1,
		-1,
		169,
		152,
		-1,
		117,
		124,
		108,
		114,
		100,
		121,
		118,
		109,
		103,
		98,
		87,
		65,
		62,
		75,
		54,
		29,
		43,
		46,
		14,
		35,
		30,
		-1,
		110,
		94,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		124,
		121,
		114,
		138,
		137,
		-1,
		134,
		122,
		123,
		108,
		105,
		92,
		80,
		70,
		54,
		54,
		51,
		33,
		31,
		43,
		11,
		33,
		30,
		60,
		86,
		80,
		89,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		142,
		-1,
		145,
		158,
		146,
		119,
		122,
		109,
		100,
		87,
		76,
		71,
		52,
		49,
		45,
		25,
		40,
		6,
		5,
		23,
		38,
		73,
		77,
		83,
		-1,
		227,
		-1,
		169,
		153,
		155,
		129,
		150,
		-1,
		162,
		146,
		163,
		148,
		148,
		-1,
		118,
		115,
		105,
		83,
		68,
		64,
		52,
		47,
		38,
		20,
		25,
		0,
		18,
		25,
		45,
		59,
		79,
		91,
		187,
		177,
		-1,
		159,
		164,
		125,
		133,
		152,
		189,
		154,
		-1,
		149,
		-1,
		120,
		133,
		-1,
		89,
		85,
		67,
		60,
		49,
		56,
		31,
		16,
		13,
		6,
		9,
		48,
		50,
		68,
		-1,
		-1,
		172,
		176,
		167,
		118,
		137,
		161,
		198,
		147,
		136,
		135,
		-1,
		126,
		103,
		100,
		88,
		75,
		60,
		61,
		55,
		51,
		30,
		15,
		18,
		15,
		65,
		43,
		55,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		144,
		115,
		139,
		181,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		99,
		78,
		69,
		58,
		56,
		63,
		36,
		39,
		19,
		21,
		21,
		46,
		37,
		57,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		144,
		130,
		135,
		110,
		103,
		97,
		112,
		95,
		76,
		65,
		57,
		46,
		37,
		47,
		41,
		21,
		30,
		28,
		52,
		59,
		65,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		135,
		148,
		-1,
		102,
		-1,
		91,
		86,
		70,
		65,
		62,
		55,
		42,
		52,
		49,
		35,
		26,
		41,
		57,
		57,
		49,
		74,
		77,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		118,
		119,
		-1,
		96,
		90,
		87,
		72,
		68,
		59,
		63,
		57,
		56,
		52,
		44,
		45,
		27,
		62,
		-1,
		57,
		51,
		79,
		82,
		72,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		83,
		65,
		71,
		66,
		64,
		64,
		63,
		52,
		60,
		52,
		32,
		42,
		62,
		66,
		70,
		63,
		68,
		67,
		81,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		78,
		76,
		92,
		76,
		76,
		75,
		66,
		74,
		56,
		49,
		35,
		39,
		57,
		81,
		76,
		74,
		73,
		77,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		88,
		83,
		99,
		100,
		78,
		75,
		73,
		83,
		71,
		60,
		47,
		51,
		66,
		76,
		68,
		69,
		78,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		97,
		95,
		89,
		80,
		86,
		84,
		80,
		75,
		65,
		54,
		60,
		56,
		78,
		64,
		62,
		78,
		93,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		97,
		81,
		86,
		-1,
		100,
		-1,
		73,
		73,
		64,
		53,
		50,
		61,
		59,
		70,
		84,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		113,
		93,
		87,
		86,
		95,
		90,
		81,
		62,
		55,
		52,
		53,
		66,
		86,
		77,
		86,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		130,
		118,
		108,
		98,
		116,
		106,
		81,
		74,
		60,
		62,
		60,
		62,
		67,
		88,
		89,
		101,
		-1,
		-1,
		131,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		119,
		-1,
		-1,
		110,
		108,
		98,
		77,
		64,
		84,
		87,
		77,
		61,
		76,
		88,
		93,
		101,
		-1,
		134,
		121,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		123,
		118,
		122,
		113,
		-1,
		94,
		88,
		68,
		82,
		89,
		79,
		74,
		68,
		71,
		89,
		104,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		111,
		104,
		108,
		-1,
		96,
		84,
		70,
		87,
		92,
		89,
		80,
		72,
		77,
		74,
		87,
		101,
		105,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		138,
		153,
		150,
		127,
		100,
		95,
		88,
		82,
		78,
		94,
		100,
		111,
		79,
		75,
		76,
		80,
		79,
		96,
		106,
		-1,
		-1,
		152,
		169,
		164,
		146,
		150,
		177,
		-1,
		-1,
		104,
		95,
		86,
		89,
		88,
		91,
		85,
		82,
		87,
		92,
		80,
		89,
		107,
		106,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		165,
		175,
		122,
		104,
		100,
		98,
		91,
		100,
		95,
		90,
		100,
		102,
		94,
		82,
		86,
		109,
		98,
		137,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		193,
		176,
		180,
		186,
		185,
		179,
		137,
		134,
		-1,
		104,
		129,
		101,
		108,
		99,
		106,
		106,
		98,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		186,
		182,
		172,
		162,
		165,
		-1,
		-1,
		153,
		150,
		126,
		109,
		107,
		100,
		95,
		105,
		85,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		179,
		260,
		253,
		235,
		243,
		274,
		-1,
		176,
		168,
		179,
		154,
		156,
		-1,
		-1,
		126,
		123,
		128,
		116,
		113,
		115,
		110,
		101,
		86,
		92,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		193,
		236,
		229,
		232,
		256,
		270,
		-1,
		173,
		-1,
		-1,
		185,
		157,
		141,
		131,
		125,
		175,
		130,
		125,
		109,
		107,
		98,
		89,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		219,
		216,
		223,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		201,
		-1,
		168,
		-1,
		143,
		147,
		138,
		141,
		123,
		110,
		102,
		94,
		110,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		244,
		200,
		203,
		214,
		225,
		240,
		244,
		-1,
		185,
		224,
		222,
		-1,
		206,
		-1,
		-1,
		-1,
		157,
		151,
		143,
		143,
		122,
		122,
		96,
		100,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		240,
		231,
		244,
		189,
		189,
		210,
		219,
		240,
		200,
		191,
		218,
		229,
		218,
		213,
		200,
		-1,
		-1,
		180,
		161,
		-1,
		-1,
		129,
		117,
		100,
		101,
		97,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		207,
		-1,
		-1,
		202,
		219,
		213,
		217,
		233,
		258,
		-1,
		189,
		-1,
		-1,
		174,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		105,
		116,
		126,
		114,
		115,
		105,
		115,
		128,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		189,
		187,
		193,
		200,
		217,
		247,
		-1,
		-1,
		205,
		185,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		132,
		134,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		191,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		125,
		129,
		121,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		260,
		-1,
		212,
		188,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		200,
		203,
		-1,
		-1,
		202,
		204,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		207,
		208,
		209,
		-1,
		187,
		-1,
		205,
		-1,
		172,
		178,
		166,
		-1,
		-1,
		-1,
		160,
		123,
		144,
		154,
		148,
		146,
		137,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		205,
		179,
		212,
		203,
		186,
		166,
		158,
		177,
		-1,
		147,
		-1,
		122,
		124,
		150,
		153,
		159,
		153,
		126,
		141,
		131,
		122,
		131,
		211,
		-1,
		181,
		214,
		178,
		172,
		148,
		152,
		168,
		-1,
		144,
		126,
		-1,
		154,
		144,
		175,
		160,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		168,
		153,
		144,
		-1,
		156,
		138,
		117,
		134,
		134,
		125,
		133,
		165,
		161,
		148,
		148,
		140,
		-1,
		284,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		172,
		145,
		133,
		139,
		135,
		121,
		127,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		141,
		176,
		-1,
		279,
		-1,
		213,
		-1,
		-1,
		195,
		175,
		167,
		156,
		145,
		143,
		134,
		125,
		147,
		163,
		147,
		145,
		148,
		149,
		-1,
		268,
		267,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		191,
		152,
		-1,
		154,
		134,
		-1,
		156,
		152,
		-1,
		-1,
		255,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		186,
		170,
		-1,
		145,
		145,
		-1,
		-1,
		-1,
		240,
		239,
		-1,
		208,
		211,
		-1,
		201,
		192,
		200,
		147,
		151,
		-1,
		-1,
		-1,
		249,
		230,
		224,
		223,
		221,
		216,
		213,
		199,
		183,
		161,
		150,
		171,
		-1,
		-1,
		-1,
		221,
		213,
		206,
		-1,
		-1,
		208,
		191,
		172,
		170,
		-1,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		198,
		-1,
		-1,
		204,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		232,
		-1,
		-1,
		-1,
		194,
		190,
		191,
		-1,
		-1,
		-1,
		-1,
		254,
		255,
		278,
		242,
		-1,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		257,
		255,
		-1,
		-1,
		-1,
		214,
		198,
		-1,
		184,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		219,
		-1,
		219,
		194,
		201,
		-1,
		-1,
		-1,
		-1,
		232,
		224,
		232,
		-1,
		204,
		206,
		-1,
		254,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		209,
		216,
		238,
		241,
		277,
		-1,
		228
	],
	[
		-1,
		153,
		142,
		153,
		161,
		134,
		141,
		-1,
		160,
		164,
		130,
		124,
		163,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		153,
		152,
		120,
		118,
		127,
		132,
		139,
		-1,
		138,
		-1,
		174,
		153,
		164,
		169,
		113,
		110,
		130,
		149,
		131,
		123,
		189,
		143,
		114,
		108,
		126,
		116,
		125,
		117,
		-1,
		114,
		104,
		126,
		105,
		116,
		108,
		-1,
		-1,
		108,
		109,
		115,
		101,
		107,
		103,
		-1,
		113,
		95,
		-1,
		-1,
		98,
		99,
		83,
		86,
		94,
		92,
		105,
		97,
		90,
		-1,
		-1,
		89,
		85,
		92,
		79,
		75,
		92,
		105,
		87,
		77,
		75,
		-1,
		101,
		118,
		118,
		86,
		84,
		68,
		66,
		84,
		86,
		75,
		67,
		-1,
		118,
		114,
		115,
		113,
		108,
		84,
		71,
		71,
		81,
		74,
		69,
		56,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		110,
		127,
		111,
		101,
		105,
		103,
		74,
		71,
		69,
		66,
		72,
		55,
		65,
		-1,
		-1,
		212,
		185,
		209,
		167,
		149,
		-1,
		115,
		115,
		109,
		105,
		99,
		92,
		105,
		90,
		-1,
		60,
		59,
		62,
		48,
		59,
		194,
		-1,
		-1,
		170,
		162,
		144,
		147,
		124,
		120,
		130,
		129,
		122,
		111,
		107,
		89,
		92,
		92,
		98,
		54,
		58,
		55,
		41,
		45,
		-1,
		-1,
		97,
		-1,
		-1,
		191,
		174,
		-1,
		139,
		146,
		130,
		136,
		122,
		143,
		140,
		131,
		125,
		120,
		109,
		87,
		84,
		97,
		76,
		51,
		65,
		68,
		36,
		35,
		30,
		-1,
		96,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		146,
		143,
		136,
		160,
		159,
		-1,
		156,
		144,
		145,
		130,
		127,
		114,
		102,
		92,
		76,
		76,
		73,
		55,
		53,
		65,
		33,
		33,
		30,
		60,
		72,
		66,
		75,
		-1,
		199,
		195,
		191,
		198,
		147,
		-1,
		-1,
		164,
		-1,
		167,
		180,
		168,
		141,
		144,
		131,
		122,
		109,
		98,
		93,
		74,
		71,
		67,
		47,
		62,
		28,
		27,
		15,
		38,
		59,
		63,
		69,
		-1,
		249,
		-1,
		191,
		175,
		177,
		151,
		172,
		-1,
		184,
		168,
		185,
		170,
		170,
		-1,
		140,
		137,
		127,
		105,
		90,
		86,
		74,
		69,
		60,
		42,
		47,
		22,
		0,
		7,
		31,
		45,
		67,
		77,
		209,
		199,
		-1,
		181,
		186,
		147,
		155,
		174,
		211,
		176,
		-1,
		171,
		-1,
		142,
		155,
		-1,
		111,
		107,
		89,
		82,
		71,
		78,
		53,
		38,
		35,
		14,
		10,
		35,
		36,
		61,
		-1,
		-1,
		194,
		198,
		189,
		140,
		159,
		183,
		220,
		169,
		158,
		157,
		-1,
		148,
		125,
		122,
		110,
		97,
		82,
		83,
		77,
		73,
		52,
		37,
		40,
		15,
		54,
		41,
		55,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		166,
		137,
		161,
		203,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		121,
		100,
		91,
		80,
		78,
		85,
		58,
		61,
		41,
		43,
		21,
		46,
		37,
		57,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		166,
		152,
		157,
		132,
		125,
		119,
		134,
		117,
		98,
		87,
		79,
		68,
		59,
		69,
		63,
		43,
		48,
		28,
		52,
		59,
		65,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		77,
		64,
		74,
		71,
		53,
		48,
		60,
		57,
		57,
		49,
		74,
		77,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		81,
		85,
		79,
		78,
		74,
		66,
		67,
		49,
		62,
		-1,
		57,
		51,
		79,
		82,
		72,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		93,
		88,
		86,
		86,
		85,
		74,
		82,
		74,
		54,
		64,
		76,
		72,
		70,
		63,
		68,
		67,
		81,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		98,
		97,
		88,
		96,
		78,
		71,
		57,
		61,
		71,
		81,
		76,
		82,
		74,
		77,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		105,
		121,
		122,
		100,
		97,
		95,
		105,
		93,
		82,
		69,
		73,
		80,
		90,
		77,
		77,
		79,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		119,
		117,
		111,
		102,
		108,
		106,
		102,
		97,
		87,
		76,
		82,
		78,
		99,
		85,
		83,
		78,
		93,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		122,
		-1,
		95,
		95,
		86,
		75,
		72,
		83,
		81,
		92,
		84,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		117,
		112,
		103,
		84,
		77,
		74,
		75,
		88,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		152,
		140,
		130,
		120,
		138,
		128,
		103,
		96,
		82,
		84,
		82,
		84,
		89,
		99,
		91,
		101,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		141,
		-1,
		-1,
		132,
		130,
		120,
		99,
		86,
		106,
		109,
		99,
		83,
		98,
		105,
		93,
		102,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		145,
		140,
		144,
		135,
		-1,
		116,
		110,
		90,
		104,
		111,
		101,
		96,
		90,
		93,
		110,
		104,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		133,
		126,
		130,
		-1,
		118,
		106,
		92,
		109,
		114,
		111,
		102,
		94,
		99,
		96,
		109,
		116,
		106,
		191,
		-1,
		174,
		-1,
		-1,
		-1,
		160,
		175,
		172,
		149,
		122,
		117,
		110,
		104,
		100,
		116,
		122,
		133,
		101,
		97,
		98,
		102,
		101,
		118,
		121,
		-1,
		-1,
		174,
		191,
		186,
		168,
		172,
		199,
		-1,
		-1,
		126,
		117,
		108,
		111,
		110,
		113,
		107,
		104,
		109,
		114,
		102,
		111,
		129,
		124,
		-1,
		-1,
		-1,
		194,
		-1,
		209,
		-1,
		-1,
		187,
		197,
		144,
		126,
		122,
		120,
		113,
		122,
		117,
		112,
		122,
		124,
		116,
		104,
		108,
		131,
		120,
		153,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		215,
		198,
		202,
		208,
		207,
		201,
		159,
		156,
		-1,
		126,
		151,
		123,
		130,
		121,
		128,
		128,
		120,
		98,
		105,
		121,
		120,
		115,
		145,
		140,
		148,
		-1,
		-1,
		305,
		294,
		283,
		289,
		-1,
		208,
		204,
		194,
		184,
		187,
		-1,
		-1,
		175,
		172,
		148,
		131,
		129,
		122,
		117,
		127,
		107,
		94,
		98,
		102,
		108,
		113,
		118,
		124,
		139,
		154,
		-1,
		201,
		282,
		275,
		257,
		265,
		296,
		-1,
		198,
		190,
		201,
		176,
		178,
		-1,
		-1,
		148,
		145,
		150,
		138,
		135,
		137,
		132,
		123,
		108,
		114,
		101,
		100,
		118,
		122,
		131,
		138,
		128,
		141,
		145,
		-1,
		215,
		258,
		251,
		254,
		278,
		292,
		-1,
		195,
		-1,
		-1,
		207,
		179,
		163,
		153,
		147,
		197,
		152,
		147,
		131,
		129,
		120,
		111,
		118,
		109,
		109,
		112,
		127,
		132,
		124,
		138,
		138,
		139,
		-1,
		241,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		223,
		-1,
		190,
		-1,
		165,
		169,
		160,
		163,
		145,
		132,
		124,
		116,
		132,
		107,
		117,
		113,
		114,
		123,
		134,
		146,
		145,
		146,
		266,
		222,
		225,
		236,
		247,
		262,
		266,
		-1,
		207,
		246,
		244,
		-1,
		228,
		-1,
		-1,
		-1,
		179,
		173,
		165,
		165,
		144,
		144,
		118,
		122,
		112,
		119,
		129,
		131,
		123,
		127,
		140,
		151,
		154,
		262,
		253,
		266,
		211,
		211,
		232,
		241,
		262,
		222,
		213,
		240,
		251,
		240,
		235,
		222,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		151,
		139,
		122,
		123,
		119,
		122,
		137,
		140,
		130,
		128,
		122,
		154,
		-1,
		255,
		254,
		243,
		240,
		216,
		207,
		202,
		229,
		-1,
		-1,
		224,
		241,
		235,
		239,
		255,
		280,
		-1,
		211,
		-1,
		-1,
		196,
		-1,
		-1,
		181,
		144,
		133,
		124,
		130,
		127,
		138,
		148,
		136,
		137,
		127,
		137,
		150,
		239,
		236,
		224,
		222,
		245,
		210,
		198,
		-1,
		211,
		209,
		215,
		222,
		239,
		269,
		-1,
		-1,
		227,
		207,
		-1,
		-1,
		179,
		177,
		166,
		-1,
		156,
		129,
		134,
		154,
		156,
		145,
		139,
		133,
		140,
		139,
		147,
		155,
		248,
		262,
		251,
		247,
		246,
		254,
		203,
		196,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		217,
		213,
		-1,
		-1,
		174,
		167,
		155,
		143,
		133,
		143,
		147,
		151,
		143,
		136,
		131,
		142,
		134,
		138,
		155,
		-1,
		282,
		-1,
		234,
		210,
		224,
		239,
		247,
		-1,
		-1,
		-1,
		234,
		220,
		213,
		201,
		199,
		-1,
		208,
		192,
		173,
		-1,
		143,
		156,
		187,
		155,
		160,
		155,
		137,
		148,
		137,
		140,
		154,
		149,
		-1,
		-1,
		222,
		225,
		-1,
		-1,
		224,
		226,
		-1,
		225,
		214,
		199,
		191,
		-1,
		-1,
		180,
		176,
		-1,
		-1,
		144,
		169,
		158,
		166,
		161,
		141,
		147,
		150,
		139,
		143,
		155,
		-1,
		-1,
		229,
		230,
		231,
		-1,
		209,
		-1,
		227,
		-1,
		194,
		200,
		188,
		-1,
		-1,
		-1,
		182,
		145,
		166,
		176,
		170,
		168,
		159,
		145,
		152,
		150,
		146,
		157,
		-1,
		-1,
		-1,
		227,
		201,
		234,
		225,
		208,
		188,
		180,
		199,
		-1,
		169,
		-1,
		144,
		146,
		172,
		175,
		181,
		175,
		148,
		163,
		153,
		144,
		153,
		233,
		-1,
		203,
		236,
		200,
		194,
		170,
		174,
		190,
		-1,
		166,
		148,
		-1,
		176,
		166,
		197,
		182,
		163,
		150,
		157,
		157,
		150,
		-1,
		-1,
		-1,
		205,
		204,
		196,
		190,
		190,
		175,
		166,
		-1,
		178,
		160,
		139,
		156,
		156,
		147,
		155,
		187,
		183,
		170,
		170,
		162,
		-1,
		306,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		199,
		194,
		167,
		155,
		161,
		157,
		143,
		149,
		151,
		159,
		157,
		154,
		166,
		162,
		182,
		163,
		198,
		-1,
		301,
		-1,
		235,
		-1,
		-1,
		217,
		197,
		189,
		178,
		167,
		165,
		156,
		147,
		169,
		185,
		169,
		167,
		170,
		171,
		-1,
		290,
		289,
		-1,
		236,
		228,
		214,
		-1,
		207,
		-1,
		213,
		174,
		-1,
		176,
		156,
		-1,
		178,
		174,
		-1,
		-1,
		277,
		252,
		-1,
		-1,
		-1,
		237,
		217,
		208,
		192,
		-1,
		167,
		167,
		-1,
		-1,
		-1,
		262,
		261,
		-1,
		230,
		233,
		-1,
		223,
		214,
		222,
		169,
		173,
		-1,
		-1,
		-1,
		271,
		252,
		246,
		245,
		243,
		238,
		235,
		221,
		205,
		183,
		172,
		193,
		-1,
		-1,
		-1,
		243,
		235,
		228,
		-1,
		-1,
		230,
		213,
		194,
		192,
		-1,
		-1,
		-1,
		265,
		246,
		-1,
		-1,
		220,
		-1,
		-1,
		226,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		254,
		-1,
		-1,
		-1,
		216,
		212,
		213,
		-1,
		-1,
		-1,
		-1,
		276,
		277,
		300,
		264,
		-1,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		279,
		277,
		-1,
		-1,
		-1,
		236,
		220,
		-1,
		206,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		241,
		-1,
		241,
		216,
		223,
		-1,
		-1,
		-1,
		-1,
		254,
		246,
		254,
		-1,
		226,
		228,
		-1,
		276,
		-1,
		-1,
		269,
		260,
		-1,
		-1,
		231,
		238,
		260,
		263,
		299,
		-1,
		250
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		169,
		173,
		139,
		133,
		172,
		141,
		147,
		158,
		-1,
		-1,
		-1,
		162,
		161,
		129,
		127,
		136,
		141,
		148,
		-1,
		147,
		-1,
		183,
		162,
		173,
		178,
		122,
		119,
		139,
		158,
		140,
		132,
		198,
		152,
		123,
		117,
		135,
		125,
		134,
		126,
		-1,
		123,
		113,
		135,
		114,
		125,
		117,
		-1,
		-1,
		117,
		118,
		124,
		110,
		116,
		112,
		-1,
		122,
		98,
		-1,
		-1,
		107,
		108,
		92,
		95,
		103,
		101,
		114,
		106,
		93,
		-1,
		-1,
		98,
		94,
		101,
		88,
		84,
		101,
		114,
		93,
		80,
		78,
		-1,
		110,
		127,
		127,
		95,
		93,
		77,
		75,
		93,
		95,
		78,
		70,
		-1,
		127,
		123,
		124,
		122,
		117,
		93,
		80,
		80,
		90,
		83,
		72,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		119,
		136,
		120,
		110,
		114,
		112,
		83,
		80,
		78,
		75,
		75,
		58,
		68,
		-1,
		-1,
		221,
		194,
		218,
		176,
		158,
		-1,
		124,
		124,
		118,
		114,
		108,
		101,
		114,
		99,
		-1,
		66,
		68,
		65,
		51,
		62,
		203,
		-1,
		-1,
		179,
		171,
		153,
		156,
		133,
		129,
		139,
		138,
		131,
		120,
		116,
		98,
		101,
		101,
		107,
		63,
		61,
		58,
		44,
		44,
		-1,
		-1,
		90,
		-1,
		-1,
		200,
		183,
		-1,
		148,
		155,
		139,
		145,
		131,
		152,
		149,
		140,
		134,
		129,
		118,
		96,
		93,
		106,
		85,
		60,
		68,
		71,
		39,
		34,
		29,
		-1,
		89,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		155,
		152,
		145,
		169,
		168,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		101,
		85,
		85,
		82,
		64,
		62,
		64,
		36,
		32,
		29,
		59,
		65,
		59,
		68,
		-1,
		208,
		204,
		200,
		207,
		156,
		-1,
		-1,
		173,
		-1,
		176,
		189,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		102,
		83,
		80,
		76,
		56,
		71,
		37,
		36,
		10,
		34,
		52,
		56,
		62,
		-1,
		258,
		-1,
		200,
		184,
		186,
		160,
		181,
		-1,
		193,
		177,
		194,
		179,
		179,
		-1,
		149,
		146,
		136,
		114,
		99,
		95,
		83,
		78,
		69,
		51,
		56,
		31,
		9,
		0,
		24,
		38,
		60,
		70,
		218,
		208,
		-1,
		190,
		195,
		156,
		164,
		183,
		220,
		185,
		-1,
		180,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		91,
		80,
		87,
		62,
		47,
		44,
		23,
		19,
		28,
		29,
		54,
		-1,
		-1,
		203,
		207,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		134,
		131,
		119,
		106,
		91,
		92,
		86,
		82,
		61,
		46,
		49,
		24,
		47,
		34,
		59,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		87,
		94,
		67,
		70,
		50,
		52,
		30,
		45,
		41,
		61,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		143,
		126,
		107,
		96,
		88,
		77,
		68,
		78,
		72,
		52,
		57,
		37,
		56,
		63,
		69,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		86,
		73,
		83,
		80,
		62,
		57,
		69,
		61,
		61,
		53,
		78,
		81,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		90,
		94,
		88,
		87,
		83,
		75,
		76,
		58,
		71,
		-1,
		61,
		55,
		83,
		86,
		76,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		102,
		97,
		95,
		95,
		94,
		83,
		91,
		83,
		63,
		73,
		85,
		76,
		74,
		67,
		72,
		71,
		85,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		107,
		106,
		97,
		105,
		87,
		80,
		66,
		70,
		80,
		85,
		80,
		86,
		78,
		81,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		114,
		130,
		131,
		109,
		106,
		104,
		114,
		102,
		91,
		78,
		82,
		89,
		95,
		81,
		81,
		83,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		128,
		126,
		120,
		111,
		117,
		115,
		111,
		106,
		96,
		85,
		91,
		87,
		103,
		89,
		87,
		82,
		97,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		128,
		112,
		117,
		-1,
		131,
		-1,
		104,
		104,
		95,
		84,
		81,
		92,
		90,
		101,
		88,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		144,
		124,
		118,
		117,
		126,
		121,
		112,
		93,
		86,
		83,
		84,
		97,
		117,
		102,
		90,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		161,
		149,
		139,
		129,
		147,
		137,
		112,
		105,
		91,
		93,
		91,
		93,
		98,
		103,
		95,
		105,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		177,
		169,
		140,
		150,
		-1,
		-1,
		141,
		139,
		129,
		108,
		95,
		115,
		118,
		108,
		92,
		107,
		109,
		97,
		106,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		154,
		149,
		153,
		144,
		-1,
		125,
		119,
		99,
		113,
		120,
		110,
		105,
		99,
		102,
		114,
		108,
		-1,
		-1,
		177,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		151,
		165,
		142,
		135,
		139,
		-1,
		127,
		115,
		101,
		118,
		123,
		120,
		111,
		103,
		108,
		105,
		118,
		120,
		110,
		200,
		-1,
		183,
		-1,
		-1,
		-1,
		169,
		184,
		181,
		158,
		131,
		126,
		119,
		113,
		109,
		125,
		131,
		142,
		110,
		106,
		107,
		111,
		110,
		124,
		125,
		-1,
		-1,
		183,
		200,
		195,
		177,
		181,
		208,
		-1,
		-1,
		135,
		126,
		117,
		120,
		119,
		122,
		116,
		113,
		118,
		123,
		111,
		120,
		138,
		128,
		-1,
		-1,
		-1,
		203,
		-1,
		218,
		-1,
		-1,
		196,
		206,
		153,
		135,
		131,
		129,
		122,
		131,
		126,
		121,
		131,
		133,
		125,
		113,
		117,
		140,
		129,
		157,
		-1,
		-1,
		321,
		-1,
		-1,
		-1,
		224,
		207,
		211,
		217,
		216,
		210,
		168,
		165,
		-1,
		135,
		160,
		132,
		139,
		130,
		137,
		137,
		129,
		107,
		114,
		130,
		129,
		124,
		149,
		144,
		153,
		-1,
		-1,
		314,
		303,
		292,
		298,
		-1,
		217,
		213,
		203,
		193,
		196,
		-1,
		-1,
		184,
		181,
		157,
		140,
		138,
		131,
		126,
		136,
		116,
		103,
		107,
		111,
		117,
		122,
		127,
		133,
		148,
		159,
		-1,
		210,
		291,
		284,
		266,
		274,
		305,
		-1,
		207,
		199,
		210,
		185,
		187,
		-1,
		-1,
		157,
		154,
		159,
		147,
		144,
		146,
		141,
		132,
		117,
		123,
		110,
		109,
		127,
		131,
		140,
		147,
		137,
		150,
		154,
		-1,
		224,
		267,
		260,
		263,
		287,
		301,
		-1,
		204,
		-1,
		-1,
		216,
		188,
		172,
		162,
		156,
		206,
		161,
		156,
		140,
		138,
		129,
		120,
		127,
		118,
		118,
		121,
		136,
		141,
		133,
		147,
		147,
		148,
		-1,
		250,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		232,
		-1,
		199,
		-1,
		174,
		178,
		169,
		172,
		154,
		141,
		133,
		125,
		141,
		116,
		126,
		122,
		123,
		132,
		143,
		155,
		154,
		155,
		275,
		231,
		234,
		245,
		256,
		271,
		275,
		-1,
		216,
		255,
		253,
		-1,
		237,
		-1,
		-1,
		-1,
		188,
		182,
		174,
		174,
		153,
		153,
		127,
		131,
		121,
		128,
		138,
		140,
		132,
		136,
		149,
		160,
		163,
		271,
		262,
		275,
		220,
		220,
		241,
		250,
		271,
		231,
		222,
		249,
		260,
		249,
		244,
		231,
		-1,
		-1,
		211,
		192,
		-1,
		-1,
		160,
		148,
		131,
		132,
		128,
		131,
		146,
		149,
		139,
		137,
		131,
		163,
		-1,
		264,
		263,
		252,
		249,
		225,
		216,
		211,
		238,
		-1,
		-1,
		233,
		250,
		244,
		248,
		264,
		289,
		-1,
		220,
		-1,
		-1,
		205,
		-1,
		-1,
		190,
		153,
		142,
		133,
		139,
		136,
		147,
		157,
		145,
		146,
		136,
		146,
		159,
		248,
		245,
		233,
		231,
		254,
		219,
		207,
		-1,
		220,
		218,
		224,
		231,
		248,
		278,
		-1,
		-1,
		236,
		216,
		-1,
		-1,
		188,
		186,
		175,
		-1,
		165,
		138,
		143,
		163,
		165,
		154,
		148,
		142,
		149,
		148,
		156,
		164,
		257,
		271,
		260,
		256,
		255,
		263,
		212,
		205,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		226,
		222,
		-1,
		-1,
		183,
		176,
		164,
		152,
		142,
		152,
		156,
		160,
		152,
		145,
		140,
		151,
		143,
		147,
		164,
		-1,
		291,
		-1,
		243,
		219,
		233,
		248,
		256,
		-1,
		-1,
		-1,
		243,
		229,
		222,
		210,
		208,
		-1,
		217,
		201,
		182,
		-1,
		152,
		165,
		196,
		164,
		169,
		164,
		146,
		157,
		146,
		149,
		163,
		158,
		-1,
		-1,
		231,
		234,
		-1,
		-1,
		233,
		235,
		-1,
		234,
		223,
		208,
		200,
		-1,
		-1,
		189,
		185,
		-1,
		-1,
		153,
		178,
		167,
		175,
		170,
		150,
		156,
		159,
		148,
		152,
		164,
		-1,
		-1,
		238,
		239,
		240,
		-1,
		218,
		-1,
		236,
		-1,
		203,
		209,
		197,
		-1,
		-1,
		-1,
		191,
		154,
		175,
		185,
		179,
		177,
		168,
		154,
		161,
		159,
		155,
		166,
		-1,
		-1,
		-1,
		236,
		210,
		243,
		234,
		217,
		197,
		189,
		208,
		-1,
		178,
		-1,
		153,
		155,
		181,
		184,
		190,
		184,
		157,
		172,
		162,
		153,
		162,
		242,
		-1,
		212,
		245,
		209,
		203,
		179,
		183,
		199,
		-1,
		175,
		157,
		-1,
		185,
		175,
		206,
		191,
		172,
		159,
		166,
		166,
		159,
		-1,
		-1,
		-1,
		214,
		213,
		205,
		199,
		199,
		184,
		175,
		-1,
		187,
		169,
		148,
		165,
		165,
		156,
		164,
		196,
		192,
		179,
		179,
		171,
		-1,
		315,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		208,
		203,
		176,
		164,
		170,
		166,
		152,
		158,
		160,
		168,
		166,
		163,
		175,
		171,
		191,
		172,
		207,
		-1,
		310,
		-1,
		244,
		-1,
		-1,
		226,
		206,
		198,
		187,
		176,
		174,
		165,
		156,
		178,
		194,
		178,
		176,
		179,
		180,
		-1,
		299,
		298,
		-1,
		245,
		237,
		223,
		-1,
		216,
		-1,
		222,
		183,
		-1,
		185,
		165,
		-1,
		187,
		183,
		-1,
		-1,
		286,
		261,
		-1,
		-1,
		-1,
		246,
		226,
		217,
		201,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		271,
		270,
		-1,
		239,
		242,
		-1,
		232,
		223,
		231,
		178,
		182,
		-1,
		-1,
		-1,
		280,
		261,
		255,
		254,
		252,
		247,
		244,
		230,
		214,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		252,
		244,
		237,
		-1,
		-1,
		239,
		222,
		203,
		201,
		-1,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		229,
		-1,
		-1,
		235,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		263,
		-1,
		-1,
		-1,
		225,
		221,
		222,
		-1,
		-1,
		-1,
		-1,
		285,
		286,
		309,
		273,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		288,
		286,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		178,
		182,
		148,
		142,
		181,
		150,
		156,
		167,
		-1,
		-1,
		-1,
		171,
		170,
		138,
		136,
		145,
		150,
		157,
		-1,
		156,
		-1,
		192,
		171,
		182,
		187,
		131,
		128,
		148,
		167,
		149,
		141,
		207,
		161,
		132,
		126,
		144,
		134,
		143,
		135,
		-1,
		132,
		122,
		144,
		123,
		134,
		126,
		-1,
		-1,
		126,
		127,
		133,
		119,
		125,
		121,
		-1,
		131,
		107,
		-1,
		-1,
		116,
		117,
		101,
		104,
		112,
		110,
		123,
		115,
		102,
		-1,
		-1,
		107,
		103,
		110,
		97,
		93,
		110,
		123,
		102,
		89,
		87,
		-1,
		119,
		136,
		136,
		104,
		102,
		86,
		84,
		102,
		104,
		87,
		79,
		-1,
		136,
		132,
		133,
		131,
		126,
		102,
		89,
		89,
		99,
		92,
		81,
		68,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		128,
		145,
		129,
		119,
		123,
		121,
		92,
		89,
		87,
		84,
		84,
		67,
		76,
		-1,
		-1,
		230,
		203,
		227,
		185,
		167,
		-1,
		133,
		133,
		127,
		123,
		117,
		110,
		123,
		108,
		-1,
		75,
		77,
		74,
		60,
		70,
		212,
		-1,
		-1,
		188,
		180,
		162,
		165,
		142,
		138,
		148,
		147,
		140,
		128,
		124,
		107,
		110,
		110,
		116,
		72,
		70,
		67,
		53,
		42,
		-1,
		-1,
		75,
		-1,
		-1,
		209,
		192,
		-1,
		157,
		164,
		148,
		154,
		140,
		161,
		158,
		149,
		143,
		138,
		126,
		105,
		102,
		115,
		94,
		69,
		77,
		80,
		48,
		32,
		27,
		-1,
		74,
		58,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		164,
		161,
		154,
		178,
		177,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		110,
		94,
		94,
		91,
		73,
		71,
		73,
		45,
		31,
		21,
		41,
		50,
		44,
		53,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		182,
		-1,
		185,
		198,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		111,
		92,
		89,
		85,
		65,
		80,
		50,
		51,
		19,
		10,
		37,
		41,
		47,
		-1,
		267,
		-1,
		209,
		193,
		195,
		168,
		189,
		-1,
		202,
		186,
		202,
		187,
		187,
		-1,
		157,
		154,
		144,
		122,
		107,
		104,
		92,
		87,
		78,
		60,
		71,
		46,
		32,
		23,
		0,
		23,
		45,
		55,
		227,
		217,
		-1,
		199,
		204,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		100,
		89,
		96,
		71,
		56,
		53,
		38,
		41,
		13,
		14,
		39,
		-1,
		-1,
		212,
		216,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		142,
		139,
		127,
		114,
		99,
		100,
		95,
		91,
		70,
		55,
		57,
		47,
		32,
		19,
		44,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		103,
		76,
		71,
		55,
		53,
		42,
		30,
		26,
		46,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		151,
		134,
		115,
		104,
		96,
		85,
		77,
		83,
		75,
		51,
		56,
		36,
		41,
		48,
		54,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		95,
		82,
		82,
		80,
		61,
		56,
		68,
		46,
		46,
		38,
		63,
		66,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		99,
		103,
		97,
		92,
		82,
		74,
		75,
		57,
		70,
		-1,
		46,
		40,
		68,
		71,
		61,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		111,
		106,
		103,
		104,
		95,
		84,
		90,
		82,
		62,
		72,
		84,
		61,
		59,
		52,
		57,
		56,
		70,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		116,
		107,
		98,
		106,
		86,
		79,
		65,
		69,
		79,
		70,
		65,
		71,
		63,
		66,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		107,
		105,
		113,
		101,
		90,
		77,
		81,
		83,
		80,
		66,
		66,
		68,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		116,
		110,
		105,
		95,
		84,
		90,
		86,
		88,
		74,
		72,
		67,
		82,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		136,
		120,
		125,
		-1,
		130,
		-1,
		103,
		103,
		94,
		83,
		80,
		84,
		75,
		88,
		73,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		152,
		132,
		126,
		125,
		125,
		120,
		111,
		92,
		85,
		82,
		83,
		96,
		108,
		87,
		75,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		169,
		157,
		147,
		137,
		146,
		136,
		111,
		104,
		90,
		92,
		90,
		92,
		97,
		88,
		80,
		90,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		158,
		-1,
		-1,
		147,
		138,
		128,
		107,
		94,
		114,
		117,
		107,
		91,
		104,
		94,
		82,
		91,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		202,
		164,
		153,
		148,
		152,
		146,
		-1,
		124,
		118,
		98,
		112,
		119,
		109,
		104,
		98,
		99,
		99,
		93,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		159,
		170,
		141,
		134,
		138,
		-1,
		126,
		114,
		100,
		117,
		122,
		119,
		110,
		102,
		107,
		96,
		109,
		105,
		95,
		208,
		-1,
		191,
		-1,
		-1,
		-1,
		177,
		192,
		180,
		157,
		130,
		125,
		118,
		112,
		108,
		124,
		130,
		141,
		109,
		105,
		106,
		102,
		101,
		109,
		110,
		-1,
		-1,
		191,
		208,
		203,
		185,
		189,
		207,
		-1,
		-1,
		134,
		125,
		116,
		119,
		118,
		121,
		115,
		112,
		117,
		119,
		110,
		111,
		128,
		113,
		-1,
		-1,
		-1,
		211,
		-1,
		226,
		-1,
		-1,
		204,
		205,
		152,
		134,
		130,
		128,
		121,
		130,
		125,
		120,
		130,
		132,
		124,
		109,
		116,
		139,
		121,
		142,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		223,
		215,
		210,
		216,
		218,
		209,
		167,
		164,
		-1,
		134,
		159,
		131,
		138,
		129,
		136,
		136,
		128,
		106,
		113,
		129,
		128,
		123,
		134,
		129,
		138,
		-1,
		-1,
		313,
		302,
		291,
		297,
		-1,
		216,
		212,
		202,
		192,
		195,
		-1,
		-1,
		183,
		180,
		156,
		139,
		137,
		130,
		125,
		135,
		115,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		136,
		144,
		-1,
		218,
		299,
		292,
		265,
		273,
		304,
		-1,
		206,
		198,
		209,
		184,
		186,
		-1,
		-1,
		156,
		153,
		158,
		146,
		143,
		145,
		140,
		131,
		116,
		122,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		232,
		275,
		259,
		262,
		286,
		300,
		-1,
		203,
		-1,
		-1,
		215,
		187,
		171,
		161,
		155,
		205,
		160,
		155,
		139,
		137,
		128,
		119,
		126,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		249,
		255,
		253,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		231,
		-1,
		198,
		-1,
		173,
		177,
		168,
		171,
		153,
		140,
		132,
		124,
		140,
		115,
		125,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		274,
		230,
		233,
		244,
		255,
		270,
		274,
		-1,
		215,
		254,
		252,
		-1,
		236,
		-1,
		-1,
		-1,
		187,
		181,
		173,
		173,
		152,
		152,
		126,
		130,
		120,
		127,
		137,
		139,
		131,
		135,
		148,
		159,
		162,
		270,
		261,
		274,
		219,
		219,
		240,
		249,
		270,
		230,
		221,
		248,
		259,
		248,
		243,
		230,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		159,
		147,
		130,
		131,
		127,
		130,
		145,
		148,
		138,
		136,
		130,
		162,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		210,
		237,
		-1,
		-1,
		232,
		249,
		243,
		247,
		263,
		288,
		-1,
		219,
		-1,
		-1,
		204,
		-1,
		-1,
		189,
		152,
		141,
		132,
		138,
		135,
		146,
		156,
		144,
		145,
		135,
		145,
		158,
		247,
		244,
		232,
		230,
		253,
		218,
		206,
		-1,
		219,
		217,
		223,
		230,
		247,
		277,
		-1,
		-1,
		235,
		215,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		137,
		142,
		162,
		164,
		153,
		147,
		141,
		148,
		147,
		155,
		163,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		204,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		225,
		221,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		155,
		159,
		151,
		144,
		139,
		150,
		142,
		146,
		163,
		-1,
		290,
		-1,
		242,
		218,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		242,
		228,
		221,
		209,
		207,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		195,
		163,
		168,
		163,
		145,
		156,
		145,
		148,
		162,
		157,
		-1,
		-1,
		230,
		233,
		-1,
		-1,
		232,
		234,
		-1,
		233,
		222,
		207,
		199,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		152,
		177,
		166,
		174,
		169,
		149,
		155,
		158,
		147,
		151,
		163,
		-1,
		-1,
		237,
		238,
		239,
		-1,
		217,
		-1,
		235,
		-1,
		202,
		208,
		196,
		-1,
		-1,
		-1,
		190,
		153,
		174,
		184,
		178,
		176,
		167,
		153,
		160,
		158,
		154,
		165,
		-1,
		-1,
		-1,
		235,
		209,
		242,
		233,
		216,
		196,
		188,
		207,
		-1,
		177,
		-1,
		152,
		154,
		180,
		183,
		189,
		183,
		156,
		171,
		161,
		152,
		161,
		241,
		-1,
		211,
		244,
		208,
		202,
		178,
		182,
		198,
		-1,
		174,
		156,
		-1,
		184,
		174,
		205,
		190,
		171,
		158,
		165,
		165,
		158,
		-1,
		-1,
		-1,
		213,
		212,
		204,
		198,
		198,
		183,
		174,
		-1,
		186,
		168,
		147,
		164,
		164,
		155,
		163,
		195,
		191,
		178,
		178,
		170,
		-1,
		314,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		207,
		202,
		175,
		163,
		169,
		165,
		151,
		157,
		159,
		167,
		165,
		162,
		174,
		170,
		190,
		171,
		206,
		-1,
		309,
		-1,
		243,
		-1,
		-1,
		225,
		205,
		197,
		186,
		175,
		173,
		164,
		155,
		177,
		193,
		177,
		175,
		178,
		179,
		-1,
		298,
		297,
		-1,
		244,
		236,
		222,
		-1,
		215,
		-1,
		221,
		182,
		-1,
		184,
		164,
		-1,
		186,
		182,
		-1,
		-1,
		285,
		260,
		-1,
		-1,
		-1,
		245,
		225,
		216,
		200,
		-1,
		175,
		175,
		-1,
		-1,
		-1,
		270,
		269,
		-1,
		238,
		241,
		-1,
		231,
		222,
		230,
		177,
		181,
		-1,
		-1,
		-1,
		279,
		260,
		254,
		253,
		251,
		246,
		243,
		229,
		213,
		191,
		180,
		201,
		-1,
		-1,
		-1,
		251,
		243,
		236,
		-1,
		-1,
		238,
		221,
		202,
		200,
		-1,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		228,
		-1,
		-1,
		234,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		262,
		-1,
		-1,
		-1,
		224,
		220,
		221,
		-1,
		-1,
		-1,
		-1,
		284,
		285,
		308,
		272,
		-1,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		287,
		285,
		-1,
		-1,
		-1,
		244,
		228,
		-1,
		214,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		249,
		-1,
		249,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		262,
		254,
		262,
		-1,
		234,
		236,
		-1,
		284,
		-1,
		-1,
		277,
		268,
		-1,
		-1,
		239,
		246,
		268,
		271,
		307,
		-1,
		258
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		178,
		182,
		148,
		142,
		181,
		150,
		156,
		167,
		-1,
		-1,
		-1,
		171,
		170,
		138,
		136,
		145,
		150,
		157,
		-1,
		156,
		-1,
		192,
		171,
		182,
		187,
		131,
		128,
		148,
		167,
		149,
		141,
		207,
		161,
		132,
		126,
		144,
		134,
		143,
		135,
		-1,
		132,
		122,
		144,
		123,
		134,
		126,
		-1,
		-1,
		126,
		127,
		133,
		119,
		125,
		121,
		-1,
		131,
		115,
		-1,
		-1,
		116,
		117,
		101,
		104,
		112,
		110,
		123,
		115,
		110,
		-1,
		-1,
		107,
		103,
		110,
		97,
		93,
		110,
		123,
		105,
		97,
		95,
		-1,
		119,
		136,
		136,
		104,
		102,
		86,
		84,
		102,
		104,
		95,
		87,
		-1,
		136,
		132,
		133,
		131,
		126,
		102,
		89,
		89,
		99,
		92,
		89,
		76,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		128,
		145,
		129,
		119,
		123,
		121,
		92,
		89,
		87,
		84,
		92,
		75,
		85,
		-1,
		-1,
		230,
		203,
		227,
		185,
		167,
		-1,
		133,
		133,
		127,
		123,
		117,
		110,
		123,
		108,
		-1,
		78,
		77,
		82,
		68,
		79,
		212,
		-1,
		-1,
		188,
		180,
		162,
		165,
		142,
		138,
		148,
		147,
		140,
		128,
		124,
		107,
		110,
		110,
		116,
		72,
		78,
		75,
		61,
		59,
		-1,
		-1,
		56,
		-1,
		-1,
		209,
		192,
		-1,
		157,
		164,
		148,
		154,
		140,
		161,
		158,
		149,
		143,
		138,
		126,
		105,
		102,
		115,
		94,
		69,
		85,
		88,
		56,
		49,
		44,
		-1,
		55,
		39,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		164,
		161,
		154,
		178,
		177,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		110,
		94,
		94,
		91,
		73,
		71,
		81,
		53,
		48,
		38,
		26,
		31,
		23,
		32,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		182,
		-1,
		185,
		198,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		111,
		92,
		89,
		85,
		65,
		80,
		58,
		59,
		27,
		27,
		18,
		20,
		26,
		-1,
		267,
		-1,
		209,
		193,
		195,
		168,
		189,
		-1,
		202,
		186,
		202,
		187,
		187,
		-1,
		157,
		154,
		144,
		122,
		107,
		104,
		92,
		87,
		78,
		60,
		74,
		54,
		40,
		31,
		17,
		0,
		26,
		36,
		227,
		217,
		-1,
		199,
		204,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		100,
		89,
		96,
		71,
		56,
		53,
		46,
		49,
		13,
		14,
		20,
		-1,
		-1,
		212,
		216,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		142,
		139,
		127,
		114,
		99,
		100,
		95,
		91,
		70,
		55,
		57,
		47,
		32,
		19,
		44,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		103,
		76,
		71,
		55,
		53,
		42,
		30,
		26,
		46,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		151,
		134,
		115,
		104,
		96,
		85,
		77,
		83,
		75,
		51,
		56,
		36,
		41,
		48,
		54,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		95,
		82,
		82,
		80,
		61,
		56,
		68,
		46,
		46,
		38,
		63,
		66,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		99,
		103,
		97,
		92,
		82,
		74,
		75,
		57,
		70,
		-1,
		46,
		40,
		68,
		71,
		61,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		111,
		106,
		103,
		104,
		95,
		84,
		90,
		82,
		62,
		72,
		84,
		61,
		59,
		52,
		57,
		56,
		70,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		116,
		107,
		98,
		106,
		86,
		79,
		65,
		69,
		79,
		70,
		65,
		71,
		63,
		66,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		107,
		105,
		113,
		101,
		90,
		77,
		81,
		83,
		80,
		66,
		66,
		68,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		116,
		110,
		105,
		95,
		84,
		90,
		86,
		88,
		74,
		72,
		67,
		82,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		136,
		120,
		125,
		-1,
		130,
		-1,
		103,
		103,
		94,
		83,
		80,
		84,
		75,
		88,
		73,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		152,
		132,
		126,
		125,
		125,
		120,
		111,
		92,
		85,
		82,
		83,
		96,
		108,
		87,
		75,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		169,
		157,
		147,
		137,
		146,
		136,
		111,
		104,
		90,
		92,
		90,
		92,
		97,
		88,
		80,
		90,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		158,
		-1,
		-1,
		147,
		138,
		128,
		107,
		94,
		114,
		117,
		107,
		91,
		104,
		94,
		82,
		91,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		202,
		164,
		153,
		148,
		152,
		146,
		-1,
		124,
		118,
		98,
		112,
		119,
		109,
		104,
		98,
		99,
		99,
		93,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		159,
		170,
		141,
		134,
		138,
		-1,
		126,
		114,
		100,
		117,
		122,
		119,
		110,
		102,
		107,
		96,
		109,
		105,
		95,
		208,
		-1,
		191,
		-1,
		-1,
		-1,
		177,
		192,
		180,
		157,
		130,
		125,
		118,
		112,
		108,
		124,
		130,
		141,
		109,
		105,
		106,
		102,
		101,
		109,
		110,
		-1,
		-1,
		191,
		208,
		203,
		185,
		189,
		207,
		-1,
		-1,
		134,
		125,
		116,
		119,
		118,
		121,
		115,
		112,
		117,
		119,
		110,
		111,
		128,
		113,
		-1,
		-1,
		-1,
		211,
		-1,
		226,
		-1,
		-1,
		204,
		205,
		152,
		134,
		130,
		128,
		121,
		130,
		125,
		120,
		130,
		132,
		124,
		109,
		116,
		139,
		121,
		142,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		223,
		215,
		210,
		216,
		218,
		209,
		167,
		164,
		-1,
		134,
		159,
		131,
		138,
		129,
		136,
		136,
		128,
		106,
		113,
		129,
		128,
		123,
		134,
		129,
		138,
		-1,
		-1,
		313,
		302,
		291,
		297,
		-1,
		216,
		212,
		202,
		192,
		195,
		-1,
		-1,
		183,
		180,
		156,
		139,
		137,
		130,
		125,
		135,
		115,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		136,
		144,
		-1,
		218,
		299,
		292,
		265,
		273,
		304,
		-1,
		206,
		198,
		209,
		184,
		186,
		-1,
		-1,
		156,
		153,
		158,
		146,
		143,
		145,
		140,
		131,
		116,
		122,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		232,
		275,
		259,
		262,
		286,
		300,
		-1,
		203,
		-1,
		-1,
		215,
		187,
		171,
		161,
		155,
		205,
		160,
		155,
		139,
		137,
		128,
		119,
		126,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		249,
		255,
		253,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		231,
		-1,
		198,
		-1,
		173,
		177,
		168,
		171,
		153,
		140,
		132,
		124,
		140,
		115,
		125,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		274,
		230,
		233,
		244,
		255,
		270,
		274,
		-1,
		215,
		254,
		252,
		-1,
		236,
		-1,
		-1,
		-1,
		187,
		181,
		173,
		173,
		152,
		152,
		126,
		130,
		120,
		127,
		137,
		139,
		131,
		135,
		148,
		159,
		162,
		270,
		261,
		274,
		219,
		219,
		240,
		249,
		270,
		230,
		221,
		248,
		259,
		248,
		243,
		230,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		159,
		147,
		130,
		131,
		127,
		130,
		145,
		148,
		138,
		136,
		130,
		162,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		210,
		237,
		-1,
		-1,
		232,
		249,
		243,
		247,
		263,
		288,
		-1,
		219,
		-1,
		-1,
		204,
		-1,
		-1,
		189,
		152,
		141,
		132,
		138,
		135,
		146,
		156,
		144,
		145,
		135,
		145,
		158,
		247,
		244,
		232,
		230,
		253,
		218,
		206,
		-1,
		219,
		217,
		223,
		230,
		247,
		277,
		-1,
		-1,
		235,
		215,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		137,
		142,
		162,
		164,
		153,
		147,
		141,
		148,
		147,
		155,
		163,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		204,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		225,
		221,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		155,
		159,
		151,
		144,
		139,
		150,
		142,
		146,
		163,
		-1,
		290,
		-1,
		242,
		218,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		242,
		228,
		221,
		209,
		207,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		195,
		163,
		168,
		163,
		145,
		156,
		145,
		148,
		162,
		157,
		-1,
		-1,
		230,
		233,
		-1,
		-1,
		232,
		234,
		-1,
		233,
		222,
		207,
		199,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		152,
		177,
		166,
		174,
		169,
		149,
		155,
		158,
		147,
		151,
		163,
		-1,
		-1,
		237,
		238,
		239,
		-1,
		217,
		-1,
		235,
		-1,
		202,
		208,
		196,
		-1,
		-1,
		-1,
		190,
		153,
		174,
		184,
		178,
		176,
		167,
		153,
		160,
		158,
		154,
		165,
		-1,
		-1,
		-1,
		235,
		209,
		242,
		233,
		216,
		196,
		188,
		207,
		-1,
		177,
		-1,
		152,
		154,
		180,
		183,
		189,
		183,
		156,
		171,
		161,
		152,
		161,
		241,
		-1,
		211,
		244,
		208,
		202,
		178,
		182,
		198,
		-1,
		174,
		156,
		-1,
		184,
		174,
		205,
		190,
		171,
		158,
		165,
		165,
		158,
		-1,
		-1,
		-1,
		213,
		212,
		204,
		198,
		198,
		183,
		174,
		-1,
		186,
		168,
		147,
		164,
		164,
		155,
		163,
		195,
		191,
		178,
		178,
		170,
		-1,
		314,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		207,
		202,
		175,
		163,
		169,
		165,
		151,
		157,
		159,
		167,
		165,
		162,
		174,
		170,
		190,
		171,
		206,
		-1,
		309,
		-1,
		243,
		-1,
		-1,
		225,
		205,
		197,
		186,
		175,
		173,
		164,
		155,
		177,
		193,
		177,
		175,
		178,
		179,
		-1,
		298,
		297,
		-1,
		244,
		236,
		222,
		-1,
		215,
		-1,
		221,
		182,
		-1,
		184,
		164,
		-1,
		186,
		182,
		-1,
		-1,
		285,
		260,
		-1,
		-1,
		-1,
		245,
		225,
		216,
		200,
		-1,
		175,
		175,
		-1,
		-1,
		-1,
		270,
		269,
		-1,
		238,
		241,
		-1,
		231,
		222,
		230,
		177,
		181,
		-1,
		-1,
		-1,
		279,
		260,
		254,
		253,
		251,
		246,
		243,
		229,
		213,
		191,
		180,
		201,
		-1,
		-1,
		-1,
		251,
		243,
		236,
		-1,
		-1,
		238,
		221,
		202,
		200,
		-1,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		228,
		-1,
		-1,
		234,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		262,
		-1,
		-1,
		-1,
		224,
		220,
		221,
		-1,
		-1,
		-1,
		-1,
		284,
		285,
		308,
		272,
		-1,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		287,
		285,
		-1,
		-1,
		-1,
		244,
		228,
		-1,
		214,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		249,
		-1,
		249,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		262,
		254,
		262,
		-1,
		234,
		236,
		-1,
		284,
		-1,
		-1,
		277,
		268,
		-1,
		-1,
		239,
		246,
		268,
		271,
		307,
		-1,
		258
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		118,
		116,
		-1,
		136,
		153,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		116,
		108,
		-1,
		153,
		149,
		150,
		148,
		143,
		119,
		106,
		106,
		116,
		109,
		110,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		145,
		162,
		146,
		136,
		140,
		138,
		109,
		106,
		104,
		101,
		113,
		96,
		106,
		-1,
		-1,
		247,
		220,
		244,
		202,
		184,
		-1,
		150,
		150,
		144,
		140,
		134,
		127,
		140,
		125,
		-1,
		95,
		94,
		103,
		89,
		100,
		229,
		-1,
		-1,
		205,
		197,
		179,
		182,
		159,
		155,
		165,
		164,
		157,
		145,
		141,
		124,
		127,
		127,
		133,
		89,
		99,
		96,
		82,
		80,
		-1,
		-1,
		45,
		-1,
		-1,
		226,
		209,
		-1,
		174,
		181,
		165,
		171,
		157,
		178,
		175,
		166,
		160,
		155,
		143,
		122,
		119,
		132,
		111,
		86,
		106,
		109,
		77,
		70,
		65,
		-1,
		44,
		28,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		181,
		178,
		171,
		195,
		194,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		127,
		111,
		111,
		108,
		90,
		88,
		102,
		74,
		69,
		59,
		47,
		20,
		10,
		19,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		199,
		-1,
		202,
		215,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		128,
		109,
		106,
		102,
		82,
		97,
		79,
		80,
		48,
		48,
		39,
		7,
		13,
		-1,
		284,
		-1,
		226,
		210,
		212,
		185,
		206,
		-1,
		219,
		203,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		121,
		109,
		104,
		95,
		77,
		91,
		75,
		61,
		52,
		38,
		25,
		0,
		25,
		244,
		234,
		-1,
		216,
		221,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		117,
		106,
		113,
		88,
		73,
		70,
		67,
		68,
		34,
		35,
		11,
		-1,
		-1,
		229,
		233,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		112,
		108,
		87,
		72,
		74,
		64,
		53,
		40,
		55,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		120,
		93,
		88,
		72,
		70,
		59,
		46,
		43,
		57,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		94,
		100,
		92,
		68,
		73,
		53,
		52,
		65,
		71,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		112,
		99,
		99,
		97,
		78,
		73,
		85,
		57,
		57,
		55,
		80,
		83,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		116,
		120,
		114,
		109,
		99,
		91,
		92,
		74,
		87,
		-1,
		63,
		57,
		85,
		88,
		78,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		123,
		120,
		121,
		112,
		101,
		107,
		99,
		79,
		89,
		101,
		78,
		76,
		69,
		74,
		73,
		87,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		133,
		124,
		115,
		123,
		103,
		96,
		82,
		86,
		96,
		87,
		82,
		88,
		80,
		83,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		134,
		124,
		122,
		130,
		118,
		107,
		94,
		98,
		100,
		97,
		83,
		83,
		85,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		136,
		142,
		133,
		127,
		122,
		112,
		101,
		107,
		103,
		105,
		91,
		89,
		84,
		99,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		153,
		137,
		142,
		-1,
		147,
		-1,
		120,
		120,
		111,
		100,
		97,
		101,
		92,
		105,
		90,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		158,
		169,
		149,
		143,
		142,
		142,
		137,
		128,
		109,
		102,
		99,
		100,
		113,
		125,
		104,
		92,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		164,
		186,
		174,
		164,
		154,
		163,
		153,
		128,
		121,
		107,
		109,
		107,
		109,
		114,
		105,
		97,
		107,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		194,
		165,
		175,
		-1,
		-1,
		164,
		155,
		145,
		124,
		111,
		131,
		134,
		124,
		108,
		121,
		111,
		99,
		108,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		219,
		181,
		170,
		165,
		169,
		163,
		-1,
		141,
		135,
		115,
		129,
		136,
		126,
		121,
		115,
		116,
		116,
		110,
		-1,
		-1,
		202,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		176,
		187,
		158,
		151,
		155,
		-1,
		143,
		131,
		117,
		134,
		139,
		136,
		127,
		119,
		124,
		113,
		126,
		122,
		112,
		225,
		-1,
		208,
		-1,
		-1,
		-1,
		194,
		209,
		197,
		174,
		147,
		142,
		135,
		129,
		125,
		141,
		147,
		158,
		126,
		122,
		123,
		119,
		118,
		126,
		127,
		-1,
		-1,
		208,
		225,
		220,
		202,
		206,
		224,
		-1,
		-1,
		151,
		142,
		133,
		136,
		135,
		138,
		132,
		129,
		134,
		136,
		127,
		128,
		145,
		130,
		-1,
		-1,
		-1,
		228,
		-1,
		243,
		-1,
		-1,
		221,
		222,
		169,
		151,
		147,
		145,
		138,
		147,
		142,
		137,
		147,
		149,
		141,
		126,
		133,
		156,
		138,
		159,
		-1,
		-1,
		337,
		-1,
		-1,
		-1,
		240,
		232,
		227,
		233,
		235,
		226,
		184,
		181,
		-1,
		151,
		176,
		148,
		155,
		146,
		153,
		153,
		145,
		123,
		130,
		146,
		145,
		140,
		151,
		146,
		155,
		-1,
		-1,
		330,
		319,
		308,
		314,
		-1,
		233,
		229,
		219,
		209,
		212,
		-1,
		-1,
		200,
		197,
		173,
		156,
		154,
		147,
		142,
		152,
		132,
		119,
		123,
		127,
		133,
		138,
		143,
		149,
		153,
		161,
		-1,
		235,
		316,
		309,
		282,
		290,
		321,
		-1,
		223,
		215,
		226,
		201,
		203,
		-1,
		-1,
		173,
		170,
		175,
		163,
		160,
		162,
		157,
		148,
		133,
		139,
		126,
		125,
		143,
		147,
		156,
		163,
		153,
		166,
		170,
		-1,
		249,
		292,
		276,
		279,
		303,
		317,
		-1,
		220,
		-1,
		-1,
		232,
		204,
		188,
		178,
		172,
		222,
		177,
		172,
		156,
		154,
		145,
		136,
		143,
		134,
		134,
		137,
		152,
		157,
		149,
		163,
		163,
		164,
		-1,
		266,
		272,
		270,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		248,
		-1,
		215,
		-1,
		190,
		194,
		185,
		188,
		170,
		157,
		149,
		141,
		157,
		132,
		142,
		138,
		139,
		148,
		159,
		171,
		170,
		171,
		291,
		247,
		250,
		261,
		272,
		287,
		291,
		-1,
		232,
		271,
		269,
		-1,
		253,
		-1,
		-1,
		-1,
		204,
		198,
		190,
		190,
		169,
		169,
		143,
		147,
		137,
		144,
		154,
		156,
		148,
		152,
		165,
		176,
		179,
		287,
		278,
		291,
		236,
		236,
		257,
		266,
		287,
		247,
		238,
		265,
		276,
		265,
		260,
		247,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		176,
		164,
		147,
		148,
		144,
		147,
		162,
		165,
		155,
		153,
		147,
		179,
		-1,
		280,
		279,
		268,
		265,
		241,
		232,
		227,
		254,
		-1,
		-1,
		249,
		266,
		260,
		264,
		280,
		305,
		-1,
		236,
		-1,
		-1,
		221,
		-1,
		-1,
		206,
		169,
		158,
		149,
		155,
		152,
		163,
		173,
		161,
		162,
		152,
		162,
		175,
		264,
		261,
		249,
		247,
		270,
		235,
		223,
		-1,
		236,
		234,
		240,
		247,
		264,
		294,
		-1,
		-1,
		252,
		232,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		154,
		159,
		179,
		181,
		170,
		164,
		158,
		165,
		164,
		172,
		180,
		273,
		287,
		276,
		272,
		271,
		279,
		228,
		221,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		-1,
		242,
		238,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		172,
		176,
		168,
		161,
		156,
		167,
		159,
		163,
		180,
		-1,
		307,
		-1,
		259,
		235,
		249,
		264,
		272,
		-1,
		-1,
		-1,
		259,
		245,
		238,
		226,
		224,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		212,
		180,
		185,
		180,
		162,
		173,
		162,
		165,
		179,
		174,
		-1,
		-1,
		247,
		250,
		-1,
		-1,
		249,
		251,
		-1,
		250,
		239,
		224,
		216,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		169,
		194,
		183,
		191,
		186,
		166,
		172,
		175,
		164,
		168,
		180,
		-1,
		-1,
		254,
		255,
		256,
		-1,
		234,
		-1,
		252,
		-1,
		219,
		225,
		213,
		-1,
		-1,
		-1,
		207,
		170,
		191,
		201,
		195,
		193,
		184,
		170,
		177,
		175,
		171,
		182,
		-1,
		-1,
		-1,
		252,
		226,
		259,
		250,
		233,
		213,
		205,
		224,
		-1,
		194,
		-1,
		169,
		171,
		197,
		200,
		206,
		200,
		173,
		188,
		178,
		169,
		178,
		258,
		-1,
		228,
		261,
		225,
		219,
		195,
		199,
		215,
		-1,
		191,
		173,
		-1,
		201,
		191,
		222,
		207,
		188,
		175,
		182,
		182,
		175,
		-1,
		-1,
		-1,
		230,
		229,
		221,
		215,
		215,
		200,
		191,
		-1,
		203,
		185,
		164,
		181,
		181,
		172,
		180,
		212,
		208,
		195,
		195,
		187,
		-1,
		331,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		224,
		219,
		192,
		180,
		186,
		182,
		168,
		174,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		188,
		223,
		-1,
		326,
		-1,
		260,
		-1,
		-1,
		242,
		222,
		214,
		203,
		192,
		190,
		181,
		172,
		194,
		210,
		194,
		192,
		195,
		196,
		-1,
		315,
		314,
		-1,
		261,
		253,
		239,
		-1,
		232,
		-1,
		238,
		199,
		-1,
		201,
		181,
		-1,
		203,
		199,
		-1,
		-1,
		302,
		277,
		-1,
		-1,
		-1,
		262,
		242,
		233,
		217,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		287,
		286,
		-1,
		255,
		258,
		-1,
		248,
		239,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		296,
		277,
		271,
		270,
		268,
		263,
		260,
		246,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		268,
		260,
		253,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		290,
		271,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		279,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		301,
		302,
		325,
		289,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		304,
		302,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		133,
		131,
		-1,
		155,
		172,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		131,
		123,
		-1,
		172,
		168,
		169,
		167,
		162,
		138,
		125,
		125,
		135,
		128,
		125,
		112,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		164,
		181,
		165,
		155,
		159,
		157,
		128,
		125,
		123,
		120,
		128,
		111,
		121,
		-1,
		-1,
		266,
		239,
		263,
		221,
		203,
		-1,
		169,
		169,
		163,
		159,
		153,
		146,
		159,
		144,
		-1,
		114,
		113,
		118,
		104,
		115,
		248,
		-1,
		-1,
		224,
		216,
		198,
		201,
		178,
		174,
		184,
		183,
		176,
		164,
		160,
		143,
		146,
		146,
		152,
		108,
		114,
		111,
		97,
		95,
		-1,
		-1,
		60,
		-1,
		-1,
		245,
		228,
		-1,
		193,
		200,
		184,
		190,
		176,
		197,
		194,
		185,
		179,
		174,
		162,
		141,
		138,
		151,
		130,
		105,
		121,
		124,
		92,
		85,
		80,
		-1,
		59,
		43,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		200,
		197,
		190,
		214,
		213,
		-1,
		209,
		197,
		198,
		183,
		180,
		167,
		155,
		146,
		130,
		130,
		127,
		109,
		107,
		117,
		89,
		84,
		74,
		62,
		35,
		29,
		38,
		-1,
		253,
		249,
		245,
		252,
		201,
		-1,
		-1,
		218,
		-1,
		221,
		234,
		221,
		194,
		197,
		184,
		175,
		162,
		151,
		147,
		128,
		125,
		121,
		101,
		116,
		94,
		95,
		63,
		63,
		54,
		26,
		32,
		-1,
		303,
		-1,
		245,
		229,
		231,
		204,
		225,
		-1,
		238,
		222,
		238,
		223,
		223,
		-1,
		193,
		190,
		180,
		158,
		143,
		140,
		128,
		123,
		114,
		96,
		110,
		90,
		76,
		67,
		53,
		40,
		30,
		0,
		263,
		253,
		-1,
		235,
		240,
		200,
		208,
		227,
		265,
		229,
		-1,
		224,
		-1,
		195,
		208,
		-1,
		164,
		160,
		142,
		136,
		125,
		132,
		107,
		92,
		89,
		82,
		85,
		49,
		50,
		41,
		-1,
		-1,
		248,
		252,
		242,
		193,
		212,
		236,
		273,
		222,
		211,
		210,
		-1,
		201,
		178,
		175,
		163,
		150,
		135,
		136,
		131,
		127,
		106,
		91,
		93,
		83,
		68,
		55,
		80,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		219,
		190,
		214,
		256,
		240,
		233,
		221,
		186,
		186,
		180,
		-1,
		174,
		153,
		144,
		133,
		131,
		139,
		112,
		107,
		91,
		89,
		78,
		66,
		62,
		82,
		-1,
		-1,
		-1,
		249,
		238,
		239,
		185,
		208,
		245,
		219,
		205,
		210,
		185,
		178,
		172,
		187,
		170,
		151,
		140,
		132,
		121,
		113,
		119,
		111,
		87,
		92,
		72,
		77,
		84,
		90,
		-1,
		-1,
		256,
		246,
		230,
		232,
		229,
		199,
		206,
		238,
		210,
		223,
		-1,
		177,
		-1,
		166,
		161,
		145,
		140,
		137,
		131,
		118,
		118,
		116,
		97,
		92,
		104,
		82,
		82,
		74,
		99,
		102,
		-1,
		-1,
		-1,
		249,
		244,
		219,
		196,
		180,
		216,
		-1,
		193,
		194,
		-1,
		171,
		165,
		162,
		147,
		143,
		135,
		139,
		133,
		128,
		118,
		110,
		111,
		93,
		106,
		-1,
		82,
		76,
		104,
		107,
		97,
		-1,
		-1,
		-1,
		242,
		221,
		214,
		234,
		175,
		227,
		-1,
		-1,
		178,
		171,
		-1,
		158,
		140,
		147,
		142,
		139,
		140,
		131,
		120,
		126,
		118,
		98,
		108,
		120,
		97,
		95,
		88,
		93,
		92,
		106,
		-1,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		195,
		-1,
		187,
		179,
		169,
		163,
		157,
		153,
		151,
		167,
		151,
		152,
		143,
		134,
		142,
		122,
		115,
		101,
		105,
		115,
		106,
		101,
		107,
		99,
		102,
		-1,
		262,
		248,
		219,
		-1,
		-1,
		208,
		-1,
		172,
		186,
		202,
		-1,
		195,
		174,
		189,
		167,
		163,
		159,
		174,
		175,
		153,
		143,
		141,
		149,
		137,
		126,
		113,
		117,
		119,
		116,
		102,
		102,
		104,
		-1,
		268,
		255,
		213,
		209,
		198,
		218,
		169,
		157,
		189,
		-1,
		-1,
		231,
		-1,
		165,
		182,
		173,
		171,
		164,
		155,
		161,
		152,
		146,
		141,
		131,
		120,
		126,
		122,
		124,
		110,
		108,
		103,
		118,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		184,
		171,
		165,
		-1,
		206,
		-1,
		209,
		199,
		183,
		168,
		201,
		-1,
		172,
		156,
		161,
		-1,
		166,
		-1,
		139,
		139,
		130,
		119,
		116,
		120,
		111,
		124,
		109,
		-1,
		218,
		203,
		196,
		186,
		200,
		171,
		-1,
		226,
		-1,
		-1,
		196,
		190,
		190,
		174,
		177,
		188,
		168,
		162,
		161,
		161,
		156,
		147,
		128,
		121,
		118,
		119,
		132,
		144,
		123,
		111,
		-1,
		-1,
		-1,
		223,
		209,
		213,
		173,
		192,
		-1,
		-1,
		258,
		213,
		199,
		-1,
		183,
		205,
		193,
		183,
		173,
		182,
		172,
		147,
		140,
		126,
		128,
		126,
		128,
		133,
		124,
		116,
		126,
		-1,
		-1,
		206,
		211,
		199,
		185,
		204,
		-1,
		-1,
		-1,
		205,
		221,
		213,
		184,
		194,
		-1,
		-1,
		183,
		174,
		164,
		143,
		130,
		150,
		153,
		143,
		127,
		140,
		130,
		118,
		127,
		-1,
		209,
		196,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		-1,
		-1,
		238,
		200,
		189,
		184,
		188,
		182,
		-1,
		160,
		154,
		134,
		148,
		155,
		145,
		140,
		134,
		135,
		135,
		129,
		-1,
		-1,
		221,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		195,
		206,
		177,
		170,
		174,
		-1,
		162,
		150,
		136,
		153,
		158,
		155,
		146,
		138,
		143,
		132,
		145,
		141,
		131,
		244,
		-1,
		227,
		-1,
		-1,
		-1,
		213,
		228,
		216,
		193,
		166,
		161,
		154,
		148,
		144,
		160,
		166,
		177,
		145,
		141,
		142,
		138,
		137,
		145,
		146,
		-1,
		-1,
		227,
		244,
		239,
		221,
		225,
		243,
		-1,
		-1,
		170,
		161,
		152,
		155,
		154,
		157,
		151,
		148,
		153,
		155,
		146,
		147,
		164,
		149,
		-1,
		-1,
		-1,
		247,
		-1,
		262,
		-1,
		-1,
		240,
		241,
		188,
		170,
		166,
		164,
		157,
		166,
		161,
		156,
		166,
		168,
		160,
		145,
		152,
		175,
		157,
		178,
		-1,
		-1,
		356,
		-1,
		-1,
		-1,
		259,
		251,
		246,
		252,
		254,
		245,
		203,
		200,
		-1,
		170,
		195,
		167,
		174,
		165,
		172,
		172,
		164,
		142,
		149,
		165,
		164,
		159,
		170,
		165,
		174,
		-1,
		-1,
		349,
		338,
		327,
		333,
		-1,
		252,
		248,
		238,
		228,
		231,
		-1,
		-1,
		219,
		216,
		192,
		175,
		173,
		166,
		161,
		171,
		151,
		138,
		142,
		146,
		152,
		157,
		162,
		168,
		172,
		180,
		-1,
		254,
		335,
		328,
		301,
		309,
		340,
		-1,
		242,
		234,
		245,
		220,
		222,
		-1,
		-1,
		192,
		189,
		194,
		182,
		179,
		181,
		176,
		167,
		152,
		158,
		145,
		144,
		162,
		166,
		175,
		182,
		172,
		185,
		189,
		-1,
		268,
		311,
		295,
		298,
		322,
		336,
		-1,
		239,
		-1,
		-1,
		251,
		223,
		207,
		197,
		191,
		241,
		196,
		191,
		175,
		173,
		164,
		155,
		162,
		153,
		153,
		156,
		171,
		176,
		168,
		182,
		182,
		183,
		-1,
		285,
		291,
		289,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		267,
		-1,
		234,
		-1,
		209,
		213,
		204,
		207,
		189,
		176,
		168,
		160,
		176,
		151,
		161,
		157,
		158,
		167,
		178,
		190,
		189,
		190,
		310,
		266,
		269,
		280,
		291,
		306,
		310,
		-1,
		251,
		290,
		288,
		-1,
		272,
		-1,
		-1,
		-1,
		223,
		217,
		209,
		209,
		188,
		188,
		162,
		166,
		156,
		163,
		173,
		175,
		167,
		171,
		184,
		195,
		198,
		306,
		297,
		310,
		255,
		255,
		276,
		285,
		306,
		266,
		257,
		284,
		295,
		284,
		279,
		266,
		-1,
		-1,
		246,
		227,
		-1,
		-1,
		195,
		183,
		166,
		167,
		163,
		166,
		181,
		184,
		174,
		172,
		166,
		198,
		-1,
		299,
		298,
		287,
		284,
		260,
		251,
		246,
		273,
		-1,
		-1,
		268,
		285,
		279,
		283,
		299,
		324,
		-1,
		255,
		-1,
		-1,
		240,
		-1,
		-1,
		225,
		188,
		177,
		168,
		174,
		171,
		182,
		192,
		180,
		181,
		171,
		181,
		194,
		283,
		280,
		268,
		266,
		289,
		254,
		242,
		-1,
		255,
		253,
		259,
		266,
		283,
		313,
		-1,
		-1,
		271,
		251,
		-1,
		-1,
		223,
		221,
		210,
		-1,
		200,
		173,
		178,
		198,
		200,
		189,
		183,
		177,
		184,
		183,
		191,
		199,
		292,
		306,
		295,
		291,
		290,
		298,
		247,
		240,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		-1,
		261,
		257,
		-1,
		-1,
		218,
		211,
		199,
		187,
		177,
		187,
		191,
		195,
		187,
		180,
		175,
		186,
		178,
		182,
		199,
		-1,
		326,
		-1,
		278,
		254,
		268,
		283,
		291,
		-1,
		-1,
		-1,
		278,
		264,
		257,
		245,
		243,
		-1,
		252,
		236,
		217,
		-1,
		187,
		200,
		231,
		199,
		204,
		199,
		181,
		192,
		181,
		184,
		198,
		193,
		-1,
		-1,
		266,
		269,
		-1,
		-1,
		268,
		270,
		-1,
		269,
		258,
		243,
		235,
		-1,
		-1,
		224,
		220,
		-1,
		-1,
		188,
		213,
		202,
		210,
		205,
		185,
		191,
		194,
		183,
		187,
		199,
		-1,
		-1,
		273,
		274,
		275,
		-1,
		253,
		-1,
		271,
		-1,
		238,
		244,
		232,
		-1,
		-1,
		-1,
		226,
		189,
		210,
		220,
		214,
		212,
		203,
		189,
		196,
		194,
		190,
		201,
		-1,
		-1,
		-1,
		271,
		245,
		278,
		269,
		252,
		232,
		224,
		243,
		-1,
		213,
		-1,
		188,
		190,
		216,
		219,
		225,
		219,
		192,
		207,
		197,
		188,
		197,
		277,
		-1,
		247,
		280,
		244,
		238,
		214,
		218,
		234,
		-1,
		210,
		192,
		-1,
		220,
		210,
		241,
		226,
		207,
		194,
		201,
		201,
		194,
		-1,
		-1,
		-1,
		249,
		248,
		240,
		234,
		234,
		219,
		210,
		-1,
		222,
		204,
		183,
		200,
		200,
		191,
		199,
		231,
		227,
		214,
		214,
		206,
		-1,
		350,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		243,
		238,
		211,
		199,
		205,
		201,
		187,
		193,
		195,
		203,
		201,
		198,
		210,
		206,
		226,
		207,
		242,
		-1,
		345,
		-1,
		279,
		-1,
		-1,
		261,
		241,
		233,
		222,
		211,
		209,
		200,
		191,
		213,
		229,
		213,
		211,
		214,
		215,
		-1,
		334,
		333,
		-1,
		280,
		272,
		258,
		-1,
		251,
		-1,
		257,
		218,
		-1,
		220,
		200,
		-1,
		222,
		218,
		-1,
		-1,
		321,
		296,
		-1,
		-1,
		-1,
		281,
		261,
		252,
		236,
		-1,
		211,
		211,
		-1,
		-1,
		-1,
		306,
		305,
		-1,
		274,
		277,
		-1,
		267,
		258,
		266,
		213,
		217,
		-1,
		-1,
		-1,
		315,
		296,
		290,
		289,
		287,
		282,
		279,
		265,
		249,
		227,
		216,
		237,
		-1,
		-1,
		-1,
		287,
		279,
		272,
		-1,
		-1,
		274,
		257,
		238,
		236,
		-1,
		-1,
		-1,
		309,
		290,
		-1,
		-1,
		264,
		-1,
		-1,
		270,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		326,
		298,
		-1,
		-1,
		-1,
		260,
		256,
		257,
		-1,
		-1,
		-1,
		-1,
		320,
		321,
		344,
		308,
		-1,
		-1,
		-1,
		252,
		246,
		-1,
		-1,
		323,
		321,
		-1,
		-1,
		-1,
		280,
		264,
		-1,
		250,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		285,
		-1,
		285,
		260,
		267,
		-1,
		-1,
		-1,
		-1,
		298,
		290,
		298,
		-1,
		270,
		272,
		-1,
		320,
		-1,
		-1,
		313,
		304,
		-1,
		-1,
		275,
		282,
		304,
		307,
		343,
		-1,
		294
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		182,
		184,
		150,
		144,
		183,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		173,
		172,
		142,
		140,
		149,
		154,
		161,
		-1,
		184,
		-1,
		194,
		173,
		184,
		189,
		135,
		132,
		152,
		171,
		177,
		169,
		209,
		165,
		136,
		130,
		148,
		153,
		171,
		163,
		-1,
		136,
		126,
		148,
		152,
		164,
		147,
		-1,
		-1,
		130,
		131,
		137,
		149,
		154,
		159,
		-1,
		185,
		204,
		-1,
		-1,
		120,
		133,
		129,
		132,
		140,
		156,
		177,
		194,
		199,
		-1,
		-1,
		121,
		125,
		138,
		139,
		137,
		164,
		183,
		194,
		208,
		207,
		-1,
		109,
		127,
		136,
		145,
		151,
		140,
		144,
		162,
		193,
		199,
		202,
		-1,
		101,
		103,
		132,
		138,
		150,
		156,
		143,
		149,
		168,
		181,
		200,
		191,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		98,
		106,
		132,
		131,
		127,
		145,
		167,
		146,
		152,
		156,
		173,
		189,
		190,
		200,
		-1,
		-1,
		149,
		118,
		153,
		110,
		95,
		-1,
		94,
		113,
		119,
		123,
		128,
		136,
		164,
		162,
		-1,
		167,
		166,
		197,
		183,
		194,
		109,
		-1,
		-1,
		107,
		99,
		84,
		87,
		84,
		89,
		119,
		118,
		123,
		125,
		127,
		139,
		154,
		154,
		164,
		161,
		171,
		175,
		190,
		201,
		-1,
		-1,
		275,
		-1,
		-1,
		101,
		89,
		-1,
		72,
		79,
		79,
		96,
		87,
		112,
		127,
		131,
		139,
		142,
		130,
		149,
		146,
		170,
		166,
		158,
		183,
		187,
		193,
		211,
		212,
		-1,
		274,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		65,
		68,
		74,
		98,
		108,
		-1,
		134,
		132,
		156,
		150,
		155,
		151,
		136,
		154,
		152,
		167,
		169,
		165,
		167,
		204,
		195,
		216,
		213,
		244,
		250,
		244,
		253,
		-1,
		60,
		56,
		52,
		59,
		62,
		-1,
		-1,
		102,
		-1,
		116,
		129,
		146,
		136,
		139,
		151,
		159,
		158,
		142,
		160,
		155,
		158,
		177,
		173,
		182,
		192,
		191,
		209,
		222,
		237,
		241,
		247,
		-1,
		40,
		-1,
		16,
		30,
		57,
		68,
		96,
		-1,
		122,
		117,
		137,
		148,
		148,
		-1,
		164,
		161,
		174,
		158,
		143,
		160,
		162,
		166,
		176,
		180,
		195,
		186,
		204,
		211,
		219,
		223,
		243,
		255,
		0,
		10,
		-1,
		62,
		67,
		71,
		83,
		119,
		160,
		144,
		-1,
		159,
		-1,
		166,
		179,
		-1,
		164,
		160,
		149,
		165,
		173,
		180,
		183,
		177,
		174,
		192,
		195,
		212,
		216,
		232,
		-1,
		-1,
		75,
		79,
		111,
		77,
		104,
		128,
		165,
		153,
		162,
		164,
		-1,
		184,
		185,
		182,
		183,
		169,
		162,
		163,
		179,
		185,
		177,
		176,
		179,
		201,
		229,
		207,
		219,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		111,
		82,
		106,
		148,
		192,
		185,
		173,
		171,
		171,
		165,
		-1,
		200,
		179,
		176,
		167,
		172,
		185,
		180,
		196,
		180,
		182,
		198,
		210,
		201,
		221,
		-1,
		-1,
		-1,
		141,
		130,
		131,
		85,
		119,
		137,
		204,
		190,
		195,
		170,
		163,
		157,
		194,
		196,
		173,
		181,
		173,
		162,
		176,
		184,
		188,
		182,
		191,
		192,
		216,
		223,
		229,
		-1,
		-1,
		148,
		138,
		122,
		124,
		121,
		110,
		117,
		149,
		195,
		192,
		-1,
		162,
		-1,
		151,
		159,
		158,
		164,
		176,
		162,
		167,
		178,
		190,
		196,
		187,
		202,
		221,
		221,
		213,
		238,
		241,
		-1,
		-1,
		-1,
		141,
		158,
		133,
		110,
		91,
		127,
		-1,
		162,
		163,
		-1,
		156,
		150,
		156,
		155,
		162,
		159,
		159,
		173,
		181,
		177,
		193,
		199,
		188,
		224,
		-1,
		221,
		215,
		236,
		226,
		214,
		-1,
		-1,
		-1,
		156,
		135,
		128,
		148,
		98,
		150,
		-1,
		-1,
		147,
		140,
		-1,
		143,
		143,
		150,
		159,
		164,
		169,
		177,
		172,
		185,
		190,
		193,
		201,
		219,
		223,
		227,
		216,
		212,
		209,
		223,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		118,
		-1,
		155,
		147,
		138,
		132,
		138,
		156,
		154,
		174,
		166,
		180,
		180,
		186,
		194,
		179,
		182,
		196,
		196,
		214,
		222,
		214,
		208,
		207,
		219,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		133,
		-1,
		104,
		128,
		144,
		-1,
		172,
		151,
		174,
		152,
		166,
		162,
		200,
		201,
		179,
		184,
		192,
		202,
		204,
		193,
		204,
		196,
		218,
		218,
		202,
		203,
		212,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		107,
		120,
		131,
		-1,
		-1,
		216,
		-1,
		150,
		167,
		176,
		174,
		190,
		181,
		187,
		203,
		206,
		208,
		198,
		187,
		193,
		190,
		212,
		198,
		196,
		215,
		231,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		194,
		184,
		168,
		153,
		186,
		-1,
		198,
		182,
		187,
		-1,
		233,
		-1,
		206,
		208,
		202,
		187,
		184,
		195,
		193,
		204,
		221,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		164,
		-1,
		-1,
		181,
		175,
		175,
		159,
		162,
		214,
		194,
		188,
		187,
		228,
		228,
		214,
		200,
		193,
		190,
		187,
		200,
		220,
		211,
		223,
		-1,
		-1,
		-1,
		165,
		145,
		151,
		109,
		130,
		-1,
		-1,
		243,
		198,
		184,
		-1,
		168,
		231,
		219,
		209,
		199,
		233,
		234,
		219,
		212,
		198,
		200,
		198,
		196,
		201,
		222,
		223,
		236,
		-1,
		-1,
		142,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		190,
		206,
		198,
		169,
		220,
		-1,
		-1,
		211,
		209,
		219,
		215,
		202,
		222,
		225,
		211,
		195,
		210,
		222,
		230,
		235,
		-1,
		145,
		132,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		201,
		222,
		247,
		214,
		-1,
		219,
		220,
		206,
		220,
		227,
		213,
		208,
		202,
		205,
		223,
		240,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		180,
		194,
		215,
		221,
		233,
		-1,
		228,
		222,
		208,
		225,
		226,
		223,
		214,
		206,
		211,
		208,
		221,
		235,
		239,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		198,
		213,
		275,
		252,
		225,
		229,
		222,
		216,
		216,
		232,
		234,
		245,
		213,
		209,
		210,
		214,
		213,
		230,
		240,
		-1,
		-1,
		165,
		182,
		217,
		206,
		210,
		302,
		-1,
		-1,
		238,
		229,
		220,
		223,
		226,
		229,
		219,
		216,
		221,
		226,
		214,
		223,
		241,
		245,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		225,
		309,
		256,
		238,
		234,
		232,
		225,
		234,
		229,
		224,
		234,
		243,
		235,
		216,
		227,
		250,
		239,
		277,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		214,
		189,
		204,
		250,
		245,
		246,
		271,
		268,
		-1,
		238,
		263,
		235,
		242,
		234,
		242,
		242,
		239,
		217,
		224,
		240,
		239,
		234,
		269,
		261,
		267,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		220,
		206,
		236,
		226,
		232,
		-1,
		-1,
		279,
		276,
		260,
		244,
		248,
		241,
		236,
		246,
		226,
		213,
		217,
		221,
		227,
		232,
		237,
		243,
		258,
		273,
		-1,
		190,
		271,
		264,
		247,
		255,
		286,
		-1,
		223,
		232,
		213,
		218,
		226,
		-1,
		-1,
		252,
		248,
		253,
		251,
		248,
		256,
		251,
		242,
		227,
		233,
		220,
		219,
		237,
		241,
		250,
		257,
		247,
		260,
		264,
		-1,
		204,
		247,
		241,
		244,
		268,
		282,
		-1,
		236,
		-1,
		-1,
		221,
		239,
		247,
		243,
		247,
		300,
		265,
		260,
		250,
		248,
		239,
		230,
		237,
		228,
		228,
		231,
		246,
		251,
		243,
		257,
		257,
		258,
		-1,
		239,
		227,
		235,
		-1,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		237,
		-1,
		273,
		-1,
		266,
		270,
		273,
		276,
		264,
		251,
		243,
		235,
		251,
		226,
		236,
		232,
		233,
		242,
		253,
		265,
		264,
		265,
		313,
		268,
		235,
		226,
		273,
		288,
		292,
		-1,
		249,
		288,
		275,
		-1,
		246,
		-1,
		-1,
		-1,
		280,
		286,
		278,
		284,
		263,
		263,
		237,
		241,
		231,
		238,
		248,
		250,
		242,
		246,
		259,
		270,
		273,
		309,
		307,
		312,
		257,
		240,
		258,
		267,
		288,
		264,
		255,
		282,
		282,
		271,
		266,
		253,
		-1,
		-1,
		303,
		296,
		-1,
		-1,
		270,
		258,
		241,
		242,
		238,
		241,
		256,
		259,
		249,
		247,
		241,
		273,
		-1,
		309,
		308,
		297,
		294,
		270,
		261,
		248,
		259,
		-1,
		-1,
		267,
		283,
		296,
		300,
		313,
		338,
		-1,
		256,
		-1,
		-1,
		315,
		-1,
		-1,
		300,
		263,
		252,
		243,
		249,
		246,
		257,
		267,
		255,
		256,
		246,
		256,
		269,
		293,
		290,
		278,
		276,
		299,
		256,
		252,
		-1,
		282,
		270,
		276,
		283,
		300,
		327,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		298,
		296,
		285,
		-1,
		275,
		248,
		253,
		273,
		275,
		264,
		258,
		252,
		259,
		258,
		266,
		274,
		302,
		316,
		305,
		301,
		300,
		308,
		257,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		322,
		-1,
		307,
		282,
		-1,
		-1,
		293,
		286,
		274,
		262,
		252,
		262,
		266,
		270,
		262,
		255,
		250,
		261,
		253,
		257,
		274,
		-1,
		336,
		-1,
		288,
		281,
		296,
		311,
		319,
		-1,
		-1,
		-1,
		324,
		310,
		303,
		291,
		289,
		-1,
		327,
		311,
		292,
		-1,
		262,
		275,
		306,
		274,
		279,
		274,
		256,
		267,
		256,
		259,
		273,
		268,
		-1,
		-1,
		294,
		297,
		-1,
		-1,
		319,
		338,
		-1,
		315,
		304,
		289,
		281,
		-1,
		-1,
		299,
		295,
		-1,
		-1,
		263,
		288,
		277,
		285,
		280,
		260,
		266,
		269,
		258,
		262,
		274,
		-1,
		-1,
		301,
		302,
		307,
		-1,
		328,
		-1,
		339,
		-1,
		284,
		300,
		302,
		-1,
		-1,
		-1,
		301,
		264,
		285,
		295,
		289,
		287,
		278,
		264,
		271,
		269,
		265,
		276,
		-1,
		-1,
		-1,
		346,
		320,
		346,
		337,
		320,
		300,
		292,
		317,
		-1,
		288,
		-1,
		263,
		265,
		291,
		294,
		300,
		294,
		267,
		282,
		272,
		263,
		272,
		352,
		-1,
		322,
		355,
		319,
		306,
		289,
		293,
		309,
		-1,
		285,
		267,
		-1,
		295,
		285,
		316,
		301,
		282,
		269,
		276,
		276,
		269,
		-1,
		-1,
		-1,
		324,
		323,
		315,
		309,
		309,
		294,
		285,
		-1,
		297,
		279,
		258,
		275,
		275,
		266,
		274,
		306,
		302,
		289,
		289,
		281,
		-1,
		408,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		318,
		313,
		286,
		274,
		280,
		276,
		262,
		268,
		270,
		278,
		276,
		273,
		285,
		281,
		301,
		282,
		317,
		-1,
		415,
		-1,
		354,
		-1,
		-1,
		336,
		316,
		308,
		297,
		286,
		284,
		275,
		266,
		288,
		304,
		288,
		286,
		289,
		290,
		-1,
		409,
		408,
		-1,
		355,
		347,
		333,
		-1,
		326,
		-1,
		332,
		293,
		-1,
		295,
		275,
		-1,
		297,
		293,
		-1,
		-1,
		396,
		371,
		-1,
		-1,
		-1,
		356,
		336,
		327,
		311,
		-1,
		286,
		286,
		-1,
		-1,
		-1,
		381,
		380,
		-1,
		349,
		352,
		-1,
		342,
		333,
		341,
		288,
		292,
		-1,
		-1,
		-1,
		390,
		371,
		365,
		364,
		362,
		357,
		354,
		340,
		324,
		302,
		291,
		312,
		-1,
		-1,
		-1,
		362,
		354,
		347,
		-1,
		-1,
		349,
		332,
		313,
		311,
		-1,
		-1,
		-1,
		384,
		365,
		-1,
		-1,
		339,
		-1,
		-1,
		345,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		401,
		373,
		-1,
		-1,
		-1,
		335,
		331,
		332,
		-1,
		-1,
		-1,
		-1,
		395,
		396,
		419,
		383,
		-1,
		-1,
		-1,
		327,
		321,
		-1,
		-1,
		398,
		396,
		-1,
		-1,
		-1,
		355,
		339,
		-1,
		325,
		-1,
		-1,
		-1,
		346,
		-1,
		-1,
		358,
		-1,
		-1,
		-1,
		360,
		-1,
		360,
		335,
		342,
		-1,
		-1,
		-1,
		-1,
		373,
		365,
		373,
		-1,
		345,
		347,
		-1,
		395,
		-1,
		-1,
		388,
		379,
		-1,
		-1,
		350,
		357,
		379,
		382,
		418,
		-1,
		369
	],
	[
		-1,
		163,
		152,
		163,
		171,
		144,
		151,
		-1,
		172,
		174,
		140,
		134,
		173,
		144,
		150,
		161,
		-1,
		-1,
		-1,
		163,
		162,
		132,
		130,
		139,
		144,
		151,
		-1,
		174,
		-1,
		184,
		163,
		174,
		179,
		125,
		122,
		142,
		161,
		167,
		159,
		199,
		155,
		126,
		120,
		138,
		143,
		161,
		153,
		-1,
		126,
		116,
		138,
		142,
		154,
		137,
		-1,
		-1,
		120,
		121,
		127,
		139,
		144,
		149,
		-1,
		175,
		194,
		-1,
		-1,
		110,
		123,
		119,
		122,
		130,
		146,
		167,
		184,
		189,
		-1,
		-1,
		111,
		115,
		128,
		129,
		127,
		154,
		173,
		184,
		198,
		197,
		-1,
		99,
		117,
		126,
		135,
		141,
		130,
		134,
		152,
		183,
		189,
		192,
		-1,
		91,
		93,
		122,
		128,
		140,
		146,
		133,
		139,
		158,
		171,
		190,
		181,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		88,
		96,
		122,
		121,
		117,
		135,
		157,
		136,
		142,
		146,
		163,
		179,
		180,
		190,
		-1,
		-1,
		139,
		108,
		143,
		100,
		85,
		-1,
		84,
		103,
		109,
		113,
		118,
		126,
		154,
		152,
		-1,
		157,
		156,
		187,
		173,
		184,
		99,
		-1,
		-1,
		97,
		89,
		74,
		77,
		74,
		79,
		109,
		108,
		113,
		115,
		117,
		129,
		144,
		144,
		154,
		151,
		161,
		165,
		180,
		191,
		-1,
		-1,
		265,
		-1,
		-1,
		91,
		79,
		-1,
		62,
		69,
		69,
		86,
		77,
		102,
		117,
		121,
		129,
		132,
		120,
		139,
		136,
		160,
		156,
		148,
		173,
		177,
		183,
		201,
		202,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		55,
		58,
		64,
		88,
		98,
		-1,
		124,
		122,
		146,
		140,
		145,
		141,
		126,
		144,
		142,
		157,
		159,
		155,
		157,
		194,
		185,
		206,
		203,
		234,
		240,
		234,
		243,
		-1,
		50,
		46,
		42,
		49,
		52,
		-1,
		-1,
		92,
		-1,
		106,
		119,
		136,
		126,
		129,
		141,
		149,
		148,
		132,
		150,
		145,
		148,
		167,
		163,
		172,
		182,
		181,
		199,
		212,
		227,
		231,
		237,
		-1,
		50,
		-1,
		6,
		20,
		47,
		58,
		86,
		-1,
		112,
		107,
		127,
		138,
		138,
		-1,
		154,
		151,
		164,
		148,
		133,
		150,
		152,
		156,
		166,
		170,
		185,
		176,
		194,
		201,
		209,
		213,
		233,
		245,
		10,
		0,
		-1,
		52,
		57,
		61,
		73,
		109,
		150,
		134,
		-1,
		149,
		-1,
		156,
		169,
		-1,
		154,
		150,
		139,
		155,
		163,
		170,
		173,
		167,
		164,
		182,
		185,
		202,
		206,
		222,
		-1,
		-1,
		65,
		69,
		101,
		67,
		94,
		118,
		155,
		143,
		152,
		154,
		-1,
		174,
		175,
		172,
		173,
		159,
		152,
		153,
		169,
		175,
		167,
		166,
		169,
		191,
		219,
		197,
		209,
		-1,
		-1,
		-1,
		90,
		-1,
		-1,
		101,
		72,
		96,
		138,
		182,
		175,
		163,
		161,
		161,
		155,
		-1,
		190,
		169,
		166,
		157,
		162,
		175,
		170,
		186,
		170,
		172,
		188,
		200,
		191,
		211,
		-1,
		-1,
		-1,
		131,
		120,
		121,
		75,
		109,
		127,
		194,
		180,
		185,
		160,
		153,
		147,
		184,
		186,
		163,
		171,
		163,
		152,
		166,
		174,
		178,
		172,
		181,
		182,
		206,
		213,
		219,
		-1,
		-1,
		138,
		128,
		112,
		114,
		111,
		100,
		107,
		139,
		185,
		182,
		-1,
		152,
		-1,
		141,
		149,
		148,
		154,
		166,
		152,
		157,
		168,
		180,
		186,
		177,
		192,
		211,
		211,
		203,
		228,
		231,
		-1,
		-1,
		-1,
		131,
		148,
		123,
		100,
		81,
		117,
		-1,
		152,
		153,
		-1,
		146,
		140,
		146,
		145,
		152,
		149,
		149,
		163,
		171,
		167,
		183,
		189,
		178,
		214,
		-1,
		211,
		205,
		226,
		216,
		204,
		-1,
		-1,
		-1,
		146,
		125,
		118,
		138,
		88,
		140,
		-1,
		-1,
		137,
		130,
		-1,
		133,
		133,
		140,
		149,
		154,
		159,
		167,
		162,
		175,
		180,
		183,
		191,
		209,
		213,
		217,
		206,
		202,
		199,
		213,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		108,
		-1,
		145,
		137,
		128,
		122,
		128,
		146,
		144,
		164,
		156,
		170,
		170,
		176,
		184,
		169,
		172,
		186,
		186,
		204,
		212,
		204,
		198,
		197,
		209,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		123,
		-1,
		94,
		118,
		134,
		-1,
		162,
		141,
		164,
		142,
		156,
		152,
		190,
		191,
		169,
		174,
		182,
		192,
		194,
		183,
		194,
		186,
		208,
		208,
		192,
		193,
		202,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		97,
		110,
		121,
		-1,
		-1,
		206,
		-1,
		140,
		157,
		166,
		164,
		180,
		171,
		177,
		193,
		196,
		198,
		188,
		177,
		183,
		180,
		202,
		188,
		186,
		205,
		221,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		184,
		174,
		158,
		143,
		176,
		-1,
		188,
		172,
		177,
		-1,
		223,
		-1,
		196,
		198,
		192,
		177,
		174,
		185,
		183,
		194,
		211,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		154,
		-1,
		-1,
		171,
		165,
		165,
		149,
		152,
		204,
		184,
		178,
		177,
		218,
		218,
		204,
		190,
		183,
		180,
		177,
		190,
		210,
		201,
		213,
		-1,
		-1,
		-1,
		155,
		135,
		141,
		99,
		120,
		-1,
		-1,
		233,
		188,
		174,
		-1,
		158,
		221,
		209,
		199,
		189,
		223,
		224,
		209,
		202,
		188,
		190,
		188,
		186,
		191,
		212,
		213,
		226,
		-1,
		-1,
		132,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		180,
		196,
		188,
		159,
		210,
		-1,
		-1,
		201,
		199,
		209,
		205,
		192,
		212,
		215,
		201,
		185,
		200,
		212,
		220,
		225,
		-1,
		135,
		122,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		191,
		212,
		237,
		204,
		-1,
		209,
		210,
		196,
		210,
		217,
		203,
		198,
		192,
		195,
		213,
		230,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		170,
		184,
		205,
		211,
		223,
		-1,
		218,
		212,
		198,
		215,
		216,
		213,
		204,
		196,
		201,
		198,
		211,
		225,
		229,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		188,
		203,
		265,
		242,
		215,
		219,
		212,
		206,
		206,
		222,
		224,
		235,
		203,
		199,
		200,
		204,
		203,
		220,
		230,
		-1,
		-1,
		155,
		172,
		207,
		196,
		200,
		292,
		-1,
		-1,
		228,
		219,
		210,
		213,
		216,
		219,
		209,
		206,
		211,
		216,
		204,
		213,
		231,
		235,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		215,
		299,
		246,
		228,
		224,
		222,
		215,
		224,
		219,
		214,
		224,
		233,
		225,
		206,
		217,
		240,
		229,
		267,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		204,
		179,
		194,
		240,
		235,
		236,
		261,
		258,
		-1,
		228,
		253,
		225,
		232,
		224,
		232,
		232,
		229,
		207,
		214,
		230,
		229,
		224,
		259,
		251,
		257,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		210,
		196,
		226,
		216,
		222,
		-1,
		-1,
		269,
		266,
		250,
		234,
		238,
		231,
		226,
		236,
		216,
		203,
		207,
		211,
		217,
		222,
		227,
		233,
		248,
		263,
		-1,
		180,
		261,
		254,
		237,
		245,
		276,
		-1,
		213,
		222,
		203,
		208,
		216,
		-1,
		-1,
		242,
		238,
		243,
		241,
		238,
		246,
		241,
		232,
		217,
		223,
		210,
		209,
		227,
		231,
		240,
		247,
		237,
		250,
		254,
		-1,
		194,
		237,
		231,
		234,
		258,
		272,
		-1,
		226,
		-1,
		-1,
		211,
		229,
		237,
		233,
		237,
		290,
		255,
		250,
		240,
		238,
		229,
		220,
		227,
		218,
		218,
		221,
		236,
		241,
		233,
		247,
		247,
		248,
		-1,
		229,
		217,
		225,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		227,
		-1,
		263,
		-1,
		256,
		260,
		263,
		266,
		254,
		241,
		233,
		225,
		241,
		216,
		226,
		222,
		223,
		232,
		243,
		255,
		254,
		255,
		303,
		258,
		225,
		216,
		263,
		278,
		282,
		-1,
		239,
		278,
		265,
		-1,
		236,
		-1,
		-1,
		-1,
		270,
		276,
		268,
		274,
		253,
		253,
		227,
		231,
		221,
		228,
		238,
		240,
		232,
		236,
		249,
		260,
		263,
		299,
		297,
		302,
		247,
		230,
		248,
		257,
		278,
		254,
		245,
		272,
		272,
		261,
		256,
		243,
		-1,
		-1,
		293,
		286,
		-1,
		-1,
		260,
		248,
		231,
		232,
		228,
		231,
		246,
		249,
		239,
		237,
		231,
		263,
		-1,
		299,
		298,
		287,
		284,
		260,
		251,
		238,
		249,
		-1,
		-1,
		257,
		273,
		286,
		290,
		303,
		328,
		-1,
		246,
		-1,
		-1,
		305,
		-1,
		-1,
		290,
		253,
		242,
		233,
		239,
		236,
		247,
		257,
		245,
		246,
		236,
		246,
		259,
		283,
		280,
		268,
		266,
		289,
		246,
		242,
		-1,
		272,
		260,
		266,
		273,
		290,
		317,
		-1,
		-1,
		262,
		253,
		-1,
		-1,
		288,
		286,
		275,
		-1,
		265,
		238,
		243,
		263,
		265,
		254,
		248,
		242,
		249,
		248,
		256,
		264,
		292,
		306,
		295,
		291,
		290,
		298,
		247,
		264,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		-1,
		297,
		272,
		-1,
		-1,
		283,
		276,
		264,
		252,
		242,
		252,
		256,
		260,
		252,
		245,
		240,
		251,
		243,
		247,
		264,
		-1,
		326,
		-1,
		278,
		271,
		286,
		301,
		309,
		-1,
		-1,
		-1,
		314,
		300,
		293,
		281,
		279,
		-1,
		317,
		301,
		282,
		-1,
		252,
		265,
		296,
		264,
		269,
		264,
		246,
		257,
		246,
		249,
		263,
		258,
		-1,
		-1,
		284,
		287,
		-1,
		-1,
		309,
		328,
		-1,
		305,
		294,
		279,
		271,
		-1,
		-1,
		289,
		285,
		-1,
		-1,
		253,
		278,
		267,
		275,
		270,
		250,
		256,
		259,
		248,
		252,
		264,
		-1,
		-1,
		291,
		292,
		297,
		-1,
		318,
		-1,
		329,
		-1,
		274,
		290,
		292,
		-1,
		-1,
		-1,
		291,
		254,
		275,
		285,
		279,
		277,
		268,
		254,
		261,
		259,
		255,
		266,
		-1,
		-1,
		-1,
		336,
		310,
		336,
		327,
		310,
		290,
		282,
		307,
		-1,
		278,
		-1,
		253,
		255,
		281,
		284,
		290,
		284,
		257,
		272,
		262,
		253,
		262,
		342,
		-1,
		312,
		345,
		309,
		296,
		279,
		283,
		299,
		-1,
		275,
		257,
		-1,
		285,
		275,
		306,
		291,
		272,
		259,
		266,
		266,
		259,
		-1,
		-1,
		-1,
		314,
		313,
		305,
		299,
		299,
		284,
		275,
		-1,
		287,
		269,
		248,
		265,
		265,
		256,
		264,
		296,
		292,
		279,
		279,
		271,
		-1,
		398,
		-1,
		-1,
		337,
		-1,
		-1,
		-1,
		308,
		303,
		276,
		264,
		270,
		266,
		252,
		258,
		260,
		268,
		266,
		263,
		275,
		271,
		291,
		272,
		307,
		-1,
		405,
		-1,
		344,
		-1,
		-1,
		326,
		306,
		298,
		287,
		276,
		274,
		265,
		256,
		278,
		294,
		278,
		276,
		279,
		280,
		-1,
		399,
		398,
		-1,
		345,
		337,
		323,
		-1,
		316,
		-1,
		322,
		283,
		-1,
		285,
		265,
		-1,
		287,
		283,
		-1,
		-1,
		386,
		361,
		-1,
		-1,
		-1,
		346,
		326,
		317,
		301,
		-1,
		276,
		276,
		-1,
		-1,
		-1,
		371,
		370,
		-1,
		339,
		342,
		-1,
		332,
		323,
		331,
		278,
		282,
		-1,
		-1,
		-1,
		380,
		361,
		355,
		354,
		352,
		347,
		344,
		330,
		314,
		292,
		281,
		302,
		-1,
		-1,
		-1,
		352,
		344,
		337,
		-1,
		-1,
		339,
		322,
		303,
		301,
		-1,
		-1,
		-1,
		374,
		355,
		-1,
		-1,
		329,
		-1,
		-1,
		335,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		391,
		363,
		-1,
		-1,
		-1,
		325,
		321,
		322,
		-1,
		-1,
		-1,
		-1,
		385,
		386,
		409,
		373,
		-1,
		-1,
		-1,
		317,
		311,
		-1,
		-1,
		388,
		386,
		-1,
		-1,
		-1,
		345,
		329,
		-1,
		315,
		-1,
		-1,
		-1,
		336,
		-1,
		-1,
		348,
		-1,
		-1,
		-1,
		350,
		-1,
		350,
		325,
		332,
		-1,
		-1,
		-1,
		-1,
		363,
		355,
		363,
		-1,
		335,
		337,
		-1,
		385,
		-1,
		-1,
		378,
		369,
		-1,
		-1,
		340,
		347,
		369,
		372,
		408,
		-1,
		359
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		146,
		135,
		146,
		154,
		127,
		134,
		-1,
		155,
		157,
		123,
		117,
		156,
		127,
		133,
		144,
		-1,
		-1,
		-1,
		146,
		145,
		115,
		113,
		122,
		127,
		134,
		-1,
		157,
		-1,
		167,
		146,
		157,
		162,
		108,
		105,
		125,
		144,
		150,
		142,
		182,
		138,
		109,
		103,
		121,
		126,
		144,
		136,
		-1,
		109,
		99,
		121,
		125,
		137,
		120,
		-1,
		-1,
		103,
		104,
		110,
		122,
		127,
		132,
		-1,
		158,
		177,
		-1,
		-1,
		93,
		106,
		102,
		105,
		113,
		129,
		150,
		167,
		172,
		-1,
		-1,
		94,
		98,
		111,
		112,
		110,
		137,
		156,
		167,
		181,
		180,
		-1,
		82,
		100,
		109,
		118,
		124,
		113,
		117,
		135,
		166,
		172,
		175,
		-1,
		74,
		76,
		105,
		111,
		123,
		129,
		116,
		122,
		141,
		154,
		173,
		164,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		71,
		79,
		105,
		104,
		100,
		118,
		140,
		119,
		125,
		129,
		146,
		162,
		163,
		173,
		-1,
		-1,
		122,
		91,
		126,
		83,
		68,
		-1,
		67,
		86,
		92,
		96,
		101,
		109,
		137,
		135,
		-1,
		140,
		139,
		170,
		156,
		167,
		82,
		-1,
		-1,
		80,
		72,
		57,
		60,
		57,
		62,
		92,
		91,
		96,
		98,
		100,
		112,
		127,
		127,
		137,
		134,
		144,
		148,
		163,
		174,
		-1,
		-1,
		248,
		-1,
		-1,
		76,
		62,
		-1,
		45,
		52,
		52,
		69,
		60,
		85,
		100,
		104,
		112,
		115,
		103,
		122,
		119,
		143,
		139,
		131,
		156,
		160,
		166,
		184,
		185,
		-1,
		247,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		38,
		41,
		47,
		71,
		81,
		-1,
		107,
		105,
		129,
		123,
		128,
		124,
		109,
		127,
		125,
		140,
		142,
		138,
		140,
		177,
		168,
		189,
		186,
		217,
		223,
		217,
		226,
		-1,
		53,
		49,
		45,
		52,
		35,
		-1,
		-1,
		75,
		-1,
		89,
		102,
		119,
		109,
		112,
		124,
		132,
		131,
		115,
		133,
		128,
		131,
		150,
		146,
		155,
		165,
		164,
		182,
		195,
		210,
		214,
		220,
		-1,
		103,
		-1,
		45,
		29,
		32,
		41,
		69,
		-1,
		95,
		90,
		110,
		121,
		121,
		-1,
		137,
		134,
		147,
		131,
		116,
		133,
		135,
		139,
		149,
		153,
		168,
		159,
		177,
		184,
		192,
		196,
		216,
		228,
		63,
		53,
		-1,
		0,
		20,
		44,
		56,
		92,
		133,
		117,
		-1,
		132,
		-1,
		139,
		152,
		-1,
		137,
		133,
		122,
		138,
		146,
		153,
		156,
		150,
		147,
		165,
		168,
		185,
		189,
		205,
		-1,
		-1,
		28,
		33,
		65,
		50,
		77,
		101,
		138,
		126,
		135,
		137,
		-1,
		157,
		158,
		155,
		156,
		142,
		135,
		136,
		152,
		158,
		150,
		149,
		152,
		174,
		202,
		180,
		192,
		-1,
		-1,
		-1,
		53,
		-1,
		-1,
		84,
		55,
		79,
		121,
		165,
		158,
		146,
		144,
		144,
		138,
		-1,
		173,
		152,
		149,
		140,
		145,
		158,
		153,
		169,
		153,
		155,
		171,
		183,
		174,
		194,
		-1,
		-1,
		-1,
		114,
		103,
		104,
		58,
		92,
		110,
		177,
		163,
		168,
		143,
		136,
		130,
		167,
		169,
		146,
		154,
		146,
		135,
		149,
		157,
		161,
		155,
		164,
		165,
		189,
		196,
		202,
		-1,
		-1,
		121,
		111,
		95,
		97,
		94,
		83,
		90,
		122,
		168,
		165,
		-1,
		135,
		-1,
		124,
		132,
		131,
		137,
		149,
		135,
		140,
		151,
		163,
		169,
		160,
		175,
		194,
		194,
		186,
		211,
		214,
		-1,
		-1,
		-1,
		114,
		131,
		106,
		83,
		64,
		100,
		-1,
		135,
		136,
		-1,
		129,
		123,
		129,
		128,
		135,
		132,
		132,
		146,
		154,
		150,
		166,
		172,
		161,
		197,
		-1,
		194,
		188,
		209,
		199,
		187,
		-1,
		-1,
		-1,
		129,
		108,
		101,
		121,
		71,
		123,
		-1,
		-1,
		120,
		113,
		-1,
		116,
		116,
		123,
		132,
		137,
		142,
		150,
		145,
		158,
		163,
		166,
		174,
		192,
		196,
		200,
		189,
		185,
		182,
		196,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		91,
		-1,
		128,
		120,
		111,
		105,
		111,
		129,
		127,
		147,
		139,
		153,
		153,
		159,
		167,
		152,
		155,
		169,
		169,
		187,
		195,
		187,
		181,
		180,
		192,
		-1,
		177,
		163,
		134,
		-1,
		-1,
		106,
		-1,
		77,
		101,
		117,
		-1,
		145,
		124,
		147,
		125,
		139,
		135,
		173,
		174,
		152,
		157,
		165,
		175,
		177,
		166,
		177,
		169,
		191,
		191,
		175,
		176,
		185,
		-1,
		183,
		170,
		128,
		124,
		113,
		133,
		80,
		93,
		104,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		149,
		147,
		163,
		154,
		160,
		176,
		179,
		181,
		171,
		160,
		166,
		163,
		185,
		171,
		169,
		188,
		204,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		99,
		86,
		80,
		-1,
		121,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		171,
		155,
		160,
		-1,
		206,
		-1,
		179,
		181,
		175,
		160,
		157,
		168,
		166,
		177,
		194,
		-1,
		133,
		118,
		111,
		101,
		115,
		86,
		-1,
		137,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		187,
		167,
		161,
		160,
		201,
		201,
		187,
		173,
		166,
		163,
		160,
		173,
		193,
		184,
		196,
		-1,
		-1,
		-1,
		138,
		118,
		124,
		82,
		103,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		204,
		192,
		182,
		172,
		206,
		207,
		192,
		185,
		171,
		173,
		171,
		169,
		174,
		195,
		196,
		209,
		-1,
		-1,
		115,
		122,
		110,
		96,
		115,
		-1,
		-1,
		-1,
		163,
		179,
		171,
		142,
		193,
		-1,
		-1,
		184,
		182,
		192,
		188,
		175,
		195,
		198,
		184,
		168,
		183,
		195,
		203,
		208,
		-1,
		118,
		105,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		174,
		195,
		220,
		187,
		-1,
		192,
		193,
		179,
		193,
		200,
		186,
		181,
		175,
		178,
		196,
		213,
		-1,
		-1,
		132,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		153,
		167,
		188,
		194,
		206,
		-1,
		201,
		195,
		181,
		198,
		199,
		196,
		187,
		179,
		184,
		181,
		194,
		208,
		212,
		155,
		-1,
		138,
		-1,
		-1,
		-1,
		171,
		186,
		248,
		225,
		198,
		202,
		195,
		189,
		189,
		205,
		207,
		218,
		186,
		182,
		183,
		187,
		186,
		203,
		213,
		-1,
		-1,
		138,
		155,
		190,
		179,
		183,
		275,
		-1,
		-1,
		211,
		202,
		193,
		196,
		199,
		202,
		192,
		189,
		194,
		199,
		187,
		196,
		214,
		218,
		-1,
		-1,
		-1,
		158,
		-1,
		173,
		-1,
		-1,
		198,
		282,
		229,
		211,
		207,
		205,
		198,
		207,
		202,
		197,
		207,
		216,
		208,
		189,
		200,
		223,
		212,
		250,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		187,
		162,
		177,
		223,
		218,
		219,
		244,
		241,
		-1,
		211,
		236,
		208,
		215,
		207,
		215,
		215,
		212,
		190,
		197,
		213,
		212,
		207,
		242,
		234,
		240,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		193,
		179,
		209,
		199,
		205,
		-1,
		-1,
		252,
		249,
		233,
		217,
		221,
		214,
		209,
		219,
		199,
		186,
		190,
		194,
		200,
		205,
		210,
		216,
		231,
		246,
		-1,
		163,
		244,
		237,
		220,
		228,
		259,
		-1,
		196,
		205,
		186,
		191,
		199,
		-1,
		-1,
		225,
		221,
		226,
		224,
		221,
		229,
		224,
		215,
		200,
		206,
		193,
		192,
		210,
		214,
		223,
		230,
		220,
		233,
		237,
		-1,
		177,
		220,
		214,
		217,
		241,
		255,
		-1,
		209,
		-1,
		-1,
		194,
		212,
		220,
		216,
		220,
		273,
		238,
		233,
		223,
		221,
		212,
		203,
		210,
		201,
		201,
		204,
		219,
		224,
		216,
		230,
		230,
		231,
		-1,
		212,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		210,
		-1,
		246,
		-1,
		239,
		243,
		246,
		249,
		237,
		224,
		216,
		208,
		224,
		199,
		209,
		205,
		206,
		215,
		226,
		238,
		237,
		238,
		286,
		241,
		208,
		199,
		246,
		261,
		265,
		-1,
		222,
		261,
		248,
		-1,
		219,
		-1,
		-1,
		-1,
		253,
		259,
		251,
		257,
		236,
		236,
		210,
		214,
		204,
		211,
		221,
		223,
		215,
		219,
		232,
		243,
		246,
		282,
		280,
		285,
		230,
		213,
		231,
		240,
		261,
		237,
		228,
		255,
		255,
		244,
		239,
		226,
		-1,
		-1,
		276,
		269,
		-1,
		-1,
		243,
		231,
		214,
		215,
		211,
		214,
		229,
		232,
		222,
		220,
		214,
		246,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		221,
		232,
		-1,
		-1,
		240,
		256,
		269,
		273,
		286,
		311,
		-1,
		229,
		-1,
		-1,
		288,
		-1,
		-1,
		273,
		236,
		225,
		216,
		222,
		219,
		230,
		240,
		228,
		229,
		219,
		229,
		242,
		266,
		263,
		251,
		249,
		272,
		229,
		225,
		-1,
		255,
		243,
		249,
		256,
		273,
		300,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		271,
		269,
		258,
		-1,
		248,
		221,
		226,
		246,
		248,
		237,
		231,
		225,
		232,
		231,
		239,
		247,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		-1,
		280,
		255,
		-1,
		-1,
		266,
		259,
		247,
		235,
		225,
		235,
		239,
		243,
		235,
		228,
		223,
		234,
		226,
		230,
		247,
		-1,
		309,
		-1,
		261,
		254,
		269,
		284,
		292,
		-1,
		-1,
		-1,
		297,
		283,
		276,
		264,
		262,
		-1,
		300,
		284,
		265,
		-1,
		235,
		248,
		279,
		247,
		252,
		247,
		229,
		240,
		229,
		232,
		246,
		241,
		-1,
		-1,
		267,
		270,
		-1,
		-1,
		292,
		311,
		-1,
		288,
		277,
		262,
		254,
		-1,
		-1,
		272,
		268,
		-1,
		-1,
		236,
		261,
		250,
		258,
		253,
		233,
		239,
		242,
		231,
		235,
		247,
		-1,
		-1,
		274,
		275,
		280,
		-1,
		301,
		-1,
		312,
		-1,
		257,
		273,
		275,
		-1,
		-1,
		-1,
		274,
		237,
		258,
		268,
		262,
		260,
		251,
		237,
		244,
		242,
		238,
		249,
		-1,
		-1,
		-1,
		319,
		293,
		319,
		310,
		293,
		273,
		265,
		290,
		-1,
		261,
		-1,
		236,
		238,
		264,
		267,
		273,
		267,
		240,
		255,
		245,
		236,
		245,
		325,
		-1,
		295,
		328,
		292,
		279,
		262,
		266,
		282,
		-1,
		258,
		240,
		-1,
		268,
		258,
		289,
		274,
		255,
		242,
		249,
		249,
		242,
		-1,
		-1,
		-1,
		297,
		296,
		288,
		282,
		282,
		267,
		258,
		-1,
		270,
		252,
		231,
		248,
		248,
		239,
		247,
		279,
		275,
		262,
		262,
		254,
		-1,
		381,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		291,
		286,
		259,
		247,
		253,
		249,
		235,
		241,
		243,
		251,
		249,
		246,
		258,
		254,
		274,
		255,
		290,
		-1,
		388,
		-1,
		327,
		-1,
		-1,
		309,
		289,
		281,
		270,
		259,
		257,
		248,
		239,
		261,
		277,
		261,
		259,
		262,
		263,
		-1,
		382,
		381,
		-1,
		328,
		320,
		306,
		-1,
		299,
		-1,
		305,
		266,
		-1,
		268,
		248,
		-1,
		270,
		266,
		-1,
		-1,
		369,
		344,
		-1,
		-1,
		-1,
		329,
		309,
		300,
		284,
		-1,
		259,
		259,
		-1,
		-1,
		-1,
		354,
		353,
		-1,
		322,
		325,
		-1,
		315,
		306,
		314,
		261,
		265,
		-1,
		-1,
		-1,
		363,
		344,
		338,
		337,
		335,
		330,
		327,
		313,
		297,
		275,
		264,
		285,
		-1,
		-1,
		-1,
		335,
		327,
		320,
		-1,
		-1,
		322,
		305,
		286,
		284,
		-1,
		-1,
		-1,
		357,
		338,
		-1,
		-1,
		312,
		-1,
		-1,
		318,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		374,
		346,
		-1,
		-1,
		-1,
		308,
		304,
		305,
		-1,
		-1,
		-1,
		-1,
		368,
		369,
		392,
		356,
		-1,
		-1,
		-1,
		300,
		294,
		-1,
		-1,
		371,
		369,
		-1,
		-1,
		-1,
		328,
		312,
		-1,
		298,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		331,
		-1,
		-1,
		-1,
		333,
		-1,
		333,
		308,
		315,
		-1,
		-1,
		-1,
		-1,
		346,
		338,
		346,
		-1,
		318,
		320,
		-1,
		368,
		-1,
		-1,
		361,
		352,
		-1,
		-1,
		323,
		330,
		352,
		355,
		391,
		-1,
		342
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		173,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		166,
		158,
		198,
		154,
		125,
		119,
		137,
		142,
		160,
		152,
		-1,
		125,
		115,
		137,
		141,
		153,
		136,
		-1,
		-1,
		119,
		120,
		126,
		138,
		143,
		148,
		-1,
		174,
		193,
		-1,
		-1,
		109,
		122,
		118,
		121,
		129,
		145,
		166,
		183,
		188,
		-1,
		-1,
		110,
		114,
		127,
		128,
		126,
		153,
		172,
		183,
		197,
		196,
		-1,
		98,
		116,
		125,
		134,
		140,
		129,
		133,
		151,
		182,
		188,
		191,
		-1,
		90,
		92,
		121,
		127,
		139,
		145,
		132,
		138,
		157,
		170,
		189,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		87,
		95,
		121,
		120,
		116,
		134,
		156,
		135,
		141,
		145,
		162,
		178,
		179,
		189,
		-1,
		-1,
		138,
		107,
		142,
		99,
		84,
		-1,
		83,
		102,
		108,
		112,
		117,
		125,
		153,
		151,
		-1,
		156,
		155,
		186,
		172,
		183,
		98,
		-1,
		-1,
		96,
		88,
		73,
		76,
		73,
		78,
		108,
		107,
		112,
		114,
		116,
		128,
		143,
		143,
		153,
		150,
		160,
		164,
		179,
		190,
		-1,
		-1,
		264,
		-1,
		-1,
		92,
		78,
		-1,
		61,
		68,
		68,
		85,
		76,
		101,
		116,
		120,
		128,
		131,
		119,
		138,
		135,
		159,
		155,
		147,
		172,
		176,
		182,
		200,
		201,
		-1,
		263,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		54,
		57,
		63,
		87,
		97,
		-1,
		123,
		121,
		145,
		139,
		144,
		140,
		125,
		143,
		141,
		156,
		158,
		154,
		156,
		193,
		184,
		205,
		202,
		233,
		239,
		233,
		242,
		-1,
		69,
		65,
		61,
		68,
		51,
		-1,
		-1,
		91,
		-1,
		105,
		118,
		135,
		125,
		128,
		140,
		148,
		147,
		131,
		149,
		144,
		147,
		166,
		162,
		171,
		181,
		180,
		198,
		211,
		226,
		230,
		236,
		-1,
		119,
		-1,
		61,
		45,
		48,
		57,
		85,
		-1,
		111,
		106,
		126,
		137,
		137,
		-1,
		153,
		150,
		163,
		147,
		132,
		149,
		151,
		155,
		165,
		169,
		184,
		175,
		193,
		200,
		208,
		212,
		232,
		244,
		79,
		69,
		-1,
		31,
		0,
		60,
		72,
		108,
		149,
		133,
		-1,
		148,
		-1,
		155,
		168,
		-1,
		153,
		149,
		138,
		154,
		162,
		169,
		172,
		166,
		163,
		181,
		184,
		201,
		205,
		221,
		-1,
		-1,
		44,
		39,
		71,
		66,
		93,
		117,
		154,
		142,
		151,
		153,
		-1,
		173,
		174,
		171,
		172,
		158,
		151,
		152,
		168,
		174,
		166,
		165,
		168,
		190,
		218,
		196,
		208,
		-1,
		-1,
		-1,
		69,
		-1,
		-1,
		100,
		71,
		95,
		137,
		181,
		174,
		162,
		160,
		160,
		154,
		-1,
		189,
		168,
		165,
		156,
		161,
		174,
		169,
		185,
		169,
		171,
		187,
		199,
		190,
		210,
		-1,
		-1,
		-1,
		130,
		119,
		120,
		74,
		108,
		126,
		193,
		179,
		184,
		159,
		152,
		146,
		183,
		185,
		162,
		170,
		162,
		151,
		165,
		173,
		177,
		171,
		180,
		181,
		205,
		212,
		218,
		-1,
		-1,
		137,
		127,
		111,
		113,
		110,
		99,
		106,
		138,
		184,
		181,
		-1,
		151,
		-1,
		140,
		148,
		147,
		153,
		165,
		151,
		156,
		167,
		179,
		185,
		176,
		191,
		210,
		210,
		202,
		227,
		230,
		-1,
		-1,
		-1,
		130,
		147,
		122,
		99,
		80,
		116,
		-1,
		151,
		152,
		-1,
		145,
		139,
		145,
		144,
		151,
		148,
		148,
		162,
		170,
		166,
		182,
		188,
		177,
		213,
		-1,
		210,
		204,
		225,
		215,
		203,
		-1,
		-1,
		-1,
		145,
		124,
		117,
		137,
		87,
		139,
		-1,
		-1,
		136,
		129,
		-1,
		132,
		132,
		139,
		148,
		153,
		158,
		166,
		161,
		174,
		179,
		182,
		190,
		208,
		212,
		216,
		205,
		201,
		198,
		212,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		107,
		-1,
		144,
		136,
		127,
		121,
		127,
		145,
		143,
		163,
		155,
		169,
		169,
		175,
		183,
		168,
		171,
		185,
		185,
		203,
		211,
		203,
		197,
		196,
		208,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		122,
		-1,
		93,
		117,
		133,
		-1,
		161,
		140,
		163,
		141,
		155,
		151,
		189,
		190,
		168,
		173,
		181,
		191,
		193,
		182,
		193,
		185,
		207,
		207,
		191,
		192,
		201,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		96,
		109,
		120,
		-1,
		-1,
		205,
		-1,
		139,
		156,
		165,
		163,
		179,
		170,
		176,
		192,
		195,
		197,
		187,
		176,
		182,
		179,
		201,
		187,
		185,
		204,
		220,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		183,
		173,
		157,
		142,
		175,
		-1,
		187,
		171,
		176,
		-1,
		222,
		-1,
		195,
		197,
		191,
		176,
		173,
		184,
		182,
		193,
		210,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		153,
		-1,
		-1,
		170,
		164,
		164,
		148,
		151,
		203,
		183,
		177,
		176,
		217,
		217,
		203,
		189,
		182,
		179,
		176,
		189,
		209,
		200,
		212,
		-1,
		-1,
		-1,
		154,
		134,
		140,
		98,
		119,
		-1,
		-1,
		232,
		187,
		173,
		-1,
		157,
		220,
		208,
		198,
		188,
		222,
		223,
		208,
		201,
		187,
		189,
		187,
		185,
		190,
		211,
		212,
		225,
		-1,
		-1,
		131,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		179,
		195,
		187,
		158,
		209,
		-1,
		-1,
		200,
		198,
		208,
		204,
		191,
		211,
		214,
		200,
		184,
		199,
		211,
		219,
		224,
		-1,
		134,
		121,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		212,
		178,
		190,
		211,
		236,
		203,
		-1,
		208,
		209,
		195,
		209,
		216,
		202,
		197,
		191,
		194,
		212,
		229,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		169,
		183,
		204,
		210,
		222,
		-1,
		217,
		211,
		197,
		214,
		215,
		212,
		203,
		195,
		200,
		197,
		210,
		224,
		228,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		187,
		202,
		264,
		241,
		214,
		218,
		211,
		205,
		205,
		221,
		223,
		234,
		202,
		198,
		199,
		203,
		202,
		219,
		229,
		-1,
		-1,
		154,
		171,
		206,
		195,
		199,
		291,
		-1,
		-1,
		227,
		218,
		209,
		212,
		215,
		218,
		208,
		205,
		210,
		215,
		203,
		212,
		230,
		234,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		214,
		298,
		245,
		227,
		223,
		221,
		214,
		223,
		218,
		213,
		223,
		232,
		224,
		205,
		216,
		239,
		228,
		266,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		239,
		234,
		235,
		260,
		257,
		-1,
		227,
		252,
		224,
		231,
		223,
		231,
		231,
		228,
		206,
		213,
		229,
		228,
		223,
		258,
		250,
		256,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		209,
		195,
		225,
		215,
		221,
		-1,
		-1,
		268,
		265,
		249,
		233,
		237,
		230,
		225,
		235,
		215,
		202,
		206,
		210,
		216,
		221,
		226,
		232,
		247,
		262,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		212,
		221,
		202,
		207,
		215,
		-1,
		-1,
		241,
		237,
		242,
		240,
		237,
		245,
		240,
		231,
		216,
		222,
		209,
		208,
		226,
		230,
		239,
		246,
		236,
		249,
		253,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		225,
		-1,
		-1,
		210,
		228,
		236,
		232,
		236,
		289,
		254,
		249,
		239,
		237,
		228,
		219,
		226,
		217,
		217,
		220,
		235,
		240,
		232,
		246,
		246,
		247,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		226,
		-1,
		262,
		-1,
		255,
		259,
		262,
		265,
		253,
		240,
		232,
		224,
		240,
		215,
		225,
		221,
		222,
		231,
		242,
		254,
		253,
		254,
		302,
		257,
		224,
		215,
		262,
		277,
		281,
		-1,
		238,
		277,
		264,
		-1,
		235,
		-1,
		-1,
		-1,
		269,
		275,
		267,
		273,
		252,
		252,
		226,
		230,
		220,
		227,
		237,
		239,
		231,
		235,
		248,
		259,
		262,
		298,
		296,
		301,
		246,
		229,
		247,
		256,
		277,
		253,
		244,
		271,
		271,
		260,
		255,
		242,
		-1,
		-1,
		292,
		285,
		-1,
		-1,
		259,
		247,
		230,
		231,
		227,
		230,
		245,
		248,
		238,
		236,
		230,
		262,
		-1,
		298,
		297,
		286,
		283,
		259,
		250,
		237,
		248,
		-1,
		-1,
		256,
		272,
		285,
		289,
		302,
		327,
		-1,
		245,
		-1,
		-1,
		304,
		-1,
		-1,
		289,
		252,
		241,
		232,
		238,
		235,
		246,
		256,
		244,
		245,
		235,
		245,
		258,
		282,
		279,
		267,
		265,
		288,
		245,
		241,
		-1,
		271,
		259,
		265,
		272,
		289,
		316,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		287,
		285,
		274,
		-1,
		264,
		237,
		242,
		262,
		264,
		253,
		247,
		241,
		248,
		247,
		255,
		263,
		291,
		305,
		294,
		290,
		289,
		297,
		246,
		263,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		-1,
		296,
		271,
		-1,
		-1,
		282,
		275,
		263,
		251,
		241,
		251,
		255,
		259,
		251,
		244,
		239,
		250,
		242,
		246,
		263,
		-1,
		325,
		-1,
		277,
		270,
		285,
		300,
		308,
		-1,
		-1,
		-1,
		313,
		299,
		292,
		280,
		278,
		-1,
		316,
		300,
		281,
		-1,
		251,
		264,
		295,
		263,
		268,
		263,
		245,
		256,
		245,
		248,
		262,
		257,
		-1,
		-1,
		283,
		286,
		-1,
		-1,
		308,
		327,
		-1,
		304,
		293,
		278,
		270,
		-1,
		-1,
		288,
		284,
		-1,
		-1,
		252,
		277,
		266,
		274,
		269,
		249,
		255,
		258,
		247,
		251,
		263,
		-1,
		-1,
		290,
		291,
		296,
		-1,
		317,
		-1,
		328,
		-1,
		273,
		289,
		291,
		-1,
		-1,
		-1,
		290,
		253,
		274,
		284,
		278,
		276,
		267,
		253,
		260,
		258,
		254,
		265,
		-1,
		-1,
		-1,
		335,
		309,
		335,
		326,
		309,
		289,
		281,
		306,
		-1,
		277,
		-1,
		252,
		254,
		280,
		283,
		289,
		283,
		256,
		271,
		261,
		252,
		261,
		341,
		-1,
		311,
		344,
		308,
		295,
		278,
		282,
		298,
		-1,
		274,
		256,
		-1,
		284,
		274,
		305,
		290,
		271,
		258,
		265,
		265,
		258,
		-1,
		-1,
		-1,
		313,
		312,
		304,
		298,
		298,
		283,
		274,
		-1,
		286,
		268,
		247,
		264,
		264,
		255,
		263,
		295,
		291,
		278,
		278,
		270,
		-1,
		397,
		-1,
		-1,
		336,
		-1,
		-1,
		-1,
		307,
		302,
		275,
		263,
		269,
		265,
		251,
		257,
		259,
		267,
		265,
		262,
		274,
		270,
		290,
		271,
		306,
		-1,
		404,
		-1,
		343,
		-1,
		-1,
		325,
		305,
		297,
		286,
		275,
		273,
		264,
		255,
		277,
		293,
		277,
		275,
		278,
		279,
		-1,
		398,
		397,
		-1,
		344,
		336,
		322,
		-1,
		315,
		-1,
		321,
		282,
		-1,
		284,
		264,
		-1,
		286,
		282,
		-1,
		-1,
		385,
		360,
		-1,
		-1,
		-1,
		345,
		325,
		316,
		300,
		-1,
		275,
		275,
		-1,
		-1,
		-1,
		370,
		369,
		-1,
		338,
		341,
		-1,
		331,
		322,
		330,
		277,
		281,
		-1,
		-1,
		-1,
		379,
		360,
		354,
		353,
		351,
		346,
		343,
		329,
		313,
		291,
		280,
		301,
		-1,
		-1,
		-1,
		351,
		343,
		336,
		-1,
		-1,
		338,
		321,
		302,
		300,
		-1,
		-1,
		-1,
		373,
		354,
		-1,
		-1,
		328,
		-1,
		-1,
		334,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		390,
		362,
		-1,
		-1,
		-1,
		324,
		320,
		321,
		-1,
		-1,
		-1,
		-1,
		384,
		385,
		408,
		372,
		-1,
		-1,
		-1,
		316,
		310,
		-1,
		-1,
		387,
		385,
		-1,
		-1,
		-1,
		344,
		328,
		-1,
		314,
		-1,
		-1,
		-1,
		335,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		349,
		-1,
		349,
		324,
		331,
		-1,
		-1,
		-1,
		-1,
		362,
		354,
		362,
		-1,
		334,
		336,
		-1,
		384,
		-1,
		-1,
		377,
		368,
		-1,
		-1,
		339,
		346,
		368,
		371,
		407,
		-1,
		358
	],
	[
		-1,
		121,
		110,
		121,
		129,
		102,
		109,
		-1,
		130,
		132,
		98,
		92,
		131,
		102,
		108,
		119,
		-1,
		-1,
		-1,
		121,
		120,
		90,
		88,
		97,
		102,
		109,
		-1,
		132,
		-1,
		142,
		121,
		132,
		137,
		83,
		80,
		100,
		119,
		125,
		117,
		157,
		113,
		84,
		78,
		96,
		101,
		119,
		111,
		-1,
		84,
		74,
		96,
		100,
		112,
		95,
		-1,
		-1,
		78,
		79,
		85,
		97,
		102,
		107,
		-1,
		133,
		152,
		-1,
		-1,
		68,
		81,
		77,
		80,
		88,
		104,
		125,
		142,
		147,
		-1,
		-1,
		69,
		73,
		86,
		87,
		85,
		112,
		131,
		142,
		156,
		155,
		-1,
		57,
		75,
		84,
		93,
		99,
		88,
		92,
		110,
		141,
		147,
		150,
		-1,
		49,
		51,
		80,
		86,
		98,
		104,
		91,
		97,
		116,
		129,
		148,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		47,
		46,
		54,
		80,
		79,
		75,
		93,
		115,
		94,
		100,
		104,
		121,
		137,
		138,
		148,
		-1,
		-1,
		97,
		66,
		101,
		58,
		43,
		-1,
		42,
		61,
		67,
		71,
		76,
		84,
		112,
		110,
		-1,
		115,
		114,
		145,
		131,
		142,
		57,
		-1,
		-1,
		55,
		47,
		32,
		35,
		32,
		37,
		67,
		66,
		71,
		73,
		75,
		87,
		102,
		102,
		112,
		109,
		119,
		123,
		138,
		149,
		-1,
		-1,
		223,
		-1,
		-1,
		54,
		37,
		-1,
		20,
		27,
		27,
		44,
		35,
		60,
		75,
		79,
		87,
		90,
		78,
		97,
		94,
		118,
		114,
		106,
		131,
		135,
		141,
		159,
		160,
		-1,
		222,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		32,
		13,
		16,
		22,
		46,
		56,
		-1,
		82,
		80,
		104,
		98,
		103,
		99,
		84,
		102,
		100,
		115,
		117,
		113,
		115,
		152,
		143,
		164,
		161,
		192,
		198,
		192,
		201,
		-1,
		62,
		58,
		54,
		61,
		10,
		-1,
		-1,
		50,
		-1,
		64,
		77,
		94,
		84,
		87,
		99,
		107,
		106,
		90,
		108,
		103,
		106,
		125,
		121,
		130,
		140,
		139,
		157,
		170,
		185,
		189,
		195,
		-1,
		112,
		-1,
		54,
		38,
		40,
		4,
		25,
		-1,
		70,
		65,
		85,
		96,
		96,
		-1,
		112,
		109,
		122,
		106,
		91,
		108,
		110,
		114,
		124,
		128,
		143,
		134,
		152,
		159,
		167,
		171,
		191,
		203,
		72,
		62,
		-1,
		44,
		49,
		0,
		12,
		48,
		108,
		92,
		-1,
		107,
		-1,
		114,
		127,
		-1,
		112,
		108,
		97,
		113,
		108,
		123,
		129,
		125,
		122,
		140,
		143,
		160,
		164,
		180,
		-1,
		-1,
		57,
		61,
		63,
		6,
		33,
		57,
		94,
		101,
		110,
		112,
		-1,
		115,
		133,
		130,
		128,
		115,
		105,
		106,
		114,
		127,
		106,
		124,
		127,
		149,
		177,
		155,
		167,
		-1,
		-1,
		-1,
		82,
		-1,
		-1,
		40,
		11,
		35,
		77,
		140,
		133,
		121,
		100,
		100,
		94,
		-1,
		135,
		118,
		114,
		103,
		101,
		114,
		109,
		125,
		128,
		128,
		146,
		158,
		149,
		169,
		-1,
		-1,
		-1,
		70,
		59,
		60,
		14,
		48,
		66,
		133,
		119,
		124,
		99,
		92,
		86,
		138,
		135,
		102,
		110,
		102,
		91,
		105,
		113,
		117,
		126,
		135,
		140,
		164,
		165,
		171,
		-1,
		-1,
		77,
		67,
		51,
		53,
		50,
		39,
		46,
		78,
		124,
		121,
		-1,
		91,
		-1,
		80,
		88,
		87,
		93,
		105,
		91,
		96,
		107,
		119,
		132,
		128,
		135,
		169,
		169,
		155,
		175,
		178,
		-1,
		-1,
		-1,
		70,
		87,
		62,
		39,
		20,
		56,
		-1,
		91,
		92,
		-1,
		85,
		79,
		85,
		84,
		91,
		88,
		88,
		102,
		110,
		106,
		122,
		128,
		120,
		156,
		-1,
		163,
		157,
		165,
		155,
		143,
		-1,
		-1,
		-1,
		85,
		64,
		57,
		77,
		27,
		79,
		-1,
		-1,
		76,
		69,
		-1,
		72,
		72,
		79,
		88,
		93,
		98,
		106,
		101,
		114,
		119,
		125,
		130,
		148,
		152,
		156,
		145,
		141,
		138,
		152,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		30,
		47,
		-1,
		84,
		76,
		67,
		61,
		67,
		85,
		83,
		103,
		95,
		109,
		109,
		115,
		123,
		108,
		111,
		127,
		125,
		143,
		151,
		143,
		137,
		136,
		148,
		-1,
		133,
		119,
		90,
		-1,
		-1,
		62,
		-1,
		33,
		57,
		73,
		-1,
		101,
		80,
		103,
		81,
		95,
		91,
		129,
		130,
		108,
		113,
		121,
		131,
		133,
		122,
		133,
		125,
		147,
		147,
		131,
		132,
		141,
		-1,
		139,
		126,
		84,
		80,
		69,
		89,
		36,
		49,
		60,
		-1,
		-1,
		145,
		-1,
		79,
		96,
		105,
		103,
		119,
		110,
		116,
		132,
		135,
		137,
		127,
		116,
		122,
		119,
		141,
		127,
		125,
		144,
		160,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		55,
		42,
		36,
		-1,
		77,
		-1,
		123,
		113,
		97,
		82,
		115,
		-1,
		127,
		111,
		116,
		-1,
		162,
		-1,
		135,
		137,
		131,
		116,
		113,
		124,
		122,
		133,
		150,
		-1,
		89,
		74,
		67,
		57,
		71,
		42,
		-1,
		93,
		-1,
		-1,
		110,
		104,
		104,
		88,
		91,
		143,
		123,
		117,
		116,
		157,
		157,
		143,
		129,
		122,
		119,
		116,
		129,
		149,
		140,
		152,
		-1,
		-1,
		-1,
		94,
		74,
		80,
		38,
		59,
		-1,
		-1,
		172,
		127,
		113,
		-1,
		97,
		160,
		148,
		138,
		128,
		162,
		163,
		148,
		141,
		127,
		129,
		127,
		125,
		130,
		151,
		152,
		165,
		-1,
		-1,
		71,
		78,
		66,
		52,
		71,
		-1,
		-1,
		-1,
		119,
		135,
		127,
		98,
		149,
		-1,
		-1,
		140,
		138,
		148,
		144,
		131,
		151,
		154,
		140,
		124,
		139,
		151,
		159,
		164,
		-1,
		74,
		61,
		-1,
		-1,
		74,
		68,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		130,
		151,
		176,
		143,
		-1,
		148,
		149,
		135,
		149,
		156,
		142,
		137,
		131,
		134,
		152,
		169,
		-1,
		-1,
		88,
		-1,
		83,
		-1,
		-1,
		-1,
		-1,
		109,
		123,
		144,
		150,
		162,
		-1,
		157,
		151,
		137,
		154,
		155,
		152,
		143,
		135,
		140,
		137,
		150,
		164,
		168,
		111,
		-1,
		94,
		-1,
		-1,
		-1,
		127,
		142,
		204,
		181,
		154,
		158,
		151,
		145,
		145,
		161,
		163,
		174,
		142,
		138,
		139,
		143,
		142,
		159,
		169,
		-1,
		-1,
		94,
		111,
		146,
		135,
		139,
		231,
		-1,
		-1,
		167,
		158,
		149,
		152,
		155,
		158,
		148,
		145,
		150,
		155,
		143,
		152,
		170,
		174,
		-1,
		-1,
		-1,
		114,
		-1,
		129,
		-1,
		-1,
		154,
		238,
		185,
		167,
		163,
		161,
		154,
		163,
		158,
		153,
		163,
		172,
		164,
		145,
		156,
		179,
		168,
		206,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		143,
		118,
		133,
		179,
		174,
		175,
		200,
		197,
		-1,
		167,
		192,
		164,
		171,
		163,
		171,
		171,
		168,
		146,
		153,
		169,
		168,
		163,
		198,
		190,
		196,
		-1,
		-1,
		224,
		213,
		202,
		208,
		-1,
		149,
		135,
		165,
		155,
		161,
		-1,
		-1,
		208,
		205,
		189,
		173,
		177,
		170,
		165,
		175,
		155,
		142,
		146,
		150,
		156,
		161,
		166,
		172,
		187,
		202,
		-1,
		119,
		200,
		193,
		176,
		184,
		215,
		-1,
		152,
		161,
		142,
		147,
		155,
		-1,
		-1,
		181,
		177,
		182,
		180,
		177,
		185,
		180,
		171,
		156,
		162,
		149,
		148,
		166,
		170,
		179,
		186,
		176,
		189,
		193,
		-1,
		133,
		176,
		170,
		173,
		197,
		211,
		-1,
		165,
		-1,
		-1,
		150,
		168,
		176,
		172,
		176,
		229,
		194,
		189,
		179,
		177,
		168,
		159,
		166,
		157,
		157,
		160,
		175,
		180,
		172,
		186,
		186,
		187,
		-1,
		168,
		156,
		164,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		166,
		-1,
		202,
		-1,
		195,
		199,
		202,
		205,
		193,
		180,
		172,
		164,
		180,
		155,
		165,
		161,
		162,
		171,
		182,
		194,
		193,
		194,
		242,
		197,
		164,
		155,
		202,
		217,
		221,
		-1,
		178,
		217,
		204,
		-1,
		175,
		-1,
		-1,
		-1,
		209,
		215,
		207,
		213,
		192,
		192,
		166,
		170,
		160,
		167,
		177,
		179,
		171,
		175,
		188,
		199,
		202,
		238,
		236,
		241,
		186,
		169,
		187,
		196,
		217,
		193,
		184,
		211,
		211,
		200,
		195,
		182,
		-1,
		-1,
		232,
		225,
		-1,
		-1,
		199,
		187,
		170,
		171,
		167,
		170,
		185,
		188,
		178,
		176,
		170,
		202,
		-1,
		238,
		237,
		226,
		223,
		199,
		190,
		177,
		188,
		-1,
		-1,
		196,
		212,
		225,
		229,
		242,
		267,
		-1,
		185,
		-1,
		-1,
		244,
		-1,
		-1,
		229,
		192,
		181,
		172,
		178,
		175,
		186,
		196,
		184,
		185,
		175,
		185,
		198,
		222,
		219,
		207,
		205,
		228,
		185,
		181,
		-1,
		211,
		199,
		205,
		212,
		229,
		256,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		227,
		225,
		214,
		-1,
		204,
		177,
		182,
		202,
		204,
		193,
		187,
		181,
		188,
		187,
		195,
		203,
		231,
		245,
		234,
		230,
		229,
		237,
		186,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		236,
		211,
		-1,
		-1,
		222,
		215,
		203,
		191,
		181,
		191,
		195,
		199,
		191,
		184,
		179,
		190,
		182,
		186,
		203,
		-1,
		265,
		-1,
		217,
		210,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		253,
		239,
		232,
		220,
		218,
		-1,
		256,
		240,
		221,
		-1,
		191,
		204,
		235,
		203,
		208,
		203,
		185,
		196,
		185,
		188,
		202,
		197,
		-1,
		-1,
		223,
		226,
		-1,
		-1,
		248,
		267,
		-1,
		244,
		233,
		218,
		210,
		-1,
		-1,
		228,
		224,
		-1,
		-1,
		192,
		217,
		206,
		214,
		209,
		189,
		195,
		198,
		187,
		191,
		203,
		-1,
		-1,
		230,
		231,
		236,
		-1,
		257,
		-1,
		268,
		-1,
		213,
		229,
		231,
		-1,
		-1,
		-1,
		230,
		193,
		214,
		224,
		218,
		216,
		207,
		193,
		200,
		198,
		194,
		205,
		-1,
		-1,
		-1,
		275,
		249,
		275,
		266,
		249,
		229,
		221,
		246,
		-1,
		217,
		-1,
		192,
		194,
		220,
		223,
		229,
		223,
		196,
		211,
		201,
		192,
		201,
		281,
		-1,
		251,
		284,
		248,
		235,
		218,
		222,
		238,
		-1,
		214,
		196,
		-1,
		224,
		214,
		245,
		230,
		211,
		198,
		205,
		205,
		198,
		-1,
		-1,
		-1,
		253,
		252,
		244,
		238,
		238,
		223,
		214,
		-1,
		226,
		208,
		187,
		204,
		204,
		195,
		203,
		235,
		231,
		218,
		218,
		210,
		-1,
		337,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		247,
		242,
		215,
		203,
		209,
		205,
		191,
		197,
		199,
		207,
		205,
		202,
		214,
		210,
		230,
		211,
		246,
		-1,
		344,
		-1,
		283,
		-1,
		-1,
		265,
		245,
		237,
		226,
		215,
		213,
		204,
		195,
		217,
		233,
		217,
		215,
		218,
		219,
		-1,
		338,
		337,
		-1,
		284,
		276,
		262,
		-1,
		255,
		-1,
		261,
		222,
		-1,
		224,
		204,
		-1,
		226,
		222,
		-1,
		-1,
		325,
		300,
		-1,
		-1,
		-1,
		285,
		265,
		256,
		240,
		-1,
		215,
		215,
		-1,
		-1,
		-1,
		310,
		309,
		-1,
		278,
		281,
		-1,
		271,
		262,
		270,
		217,
		221,
		-1,
		-1,
		-1,
		319,
		300,
		294,
		293,
		291,
		286,
		283,
		269,
		253,
		231,
		220,
		241,
		-1,
		-1,
		-1,
		291,
		283,
		276,
		-1,
		-1,
		278,
		261,
		242,
		240,
		-1,
		-1,
		-1,
		313,
		294,
		-1,
		-1,
		268,
		-1,
		-1,
		274,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		330,
		302,
		-1,
		-1,
		-1,
		264,
		260,
		261,
		-1,
		-1,
		-1,
		-1,
		324,
		325,
		348,
		312,
		-1,
		-1,
		-1,
		256,
		250,
		-1,
		-1,
		327,
		325,
		-1,
		-1,
		-1,
		284,
		268,
		-1,
		254,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		289,
		-1,
		289,
		264,
		271,
		-1,
		-1,
		-1,
		-1,
		302,
		294,
		302,
		-1,
		274,
		276,
		-1,
		324,
		-1,
		-1,
		317,
		308,
		-1,
		-1,
		279,
		286,
		308,
		311,
		347,
		-1,
		298
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		140,
		142,
		108,
		102,
		141,
		112,
		118,
		129,
		-1,
		-1,
		-1,
		131,
		130,
		100,
		98,
		107,
		112,
		119,
		-1,
		142,
		-1,
		152,
		131,
		142,
		147,
		93,
		90,
		110,
		129,
		135,
		127,
		167,
		123,
		94,
		88,
		106,
		111,
		129,
		121,
		-1,
		94,
		84,
		106,
		110,
		122,
		105,
		-1,
		-1,
		88,
		89,
		95,
		107,
		112,
		117,
		-1,
		143,
		162,
		-1,
		-1,
		78,
		91,
		87,
		90,
		98,
		114,
		135,
		152,
		157,
		-1,
		-1,
		79,
		83,
		96,
		97,
		95,
		122,
		141,
		152,
		166,
		165,
		-1,
		67,
		85,
		94,
		103,
		109,
		98,
		102,
		120,
		151,
		157,
		160,
		-1,
		59,
		61,
		90,
		96,
		108,
		114,
		101,
		107,
		126,
		139,
		158,
		149,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		56,
		64,
		90,
		89,
		85,
		103,
		125,
		104,
		110,
		114,
		131,
		147,
		148,
		158,
		-1,
		-1,
		107,
		76,
		111,
		68,
		53,
		-1,
		52,
		71,
		77,
		81,
		86,
		94,
		122,
		120,
		-1,
		125,
		124,
		155,
		141,
		152,
		67,
		-1,
		-1,
		65,
		57,
		42,
		45,
		42,
		47,
		77,
		76,
		81,
		83,
		85,
		97,
		112,
		112,
		122,
		119,
		129,
		133,
		148,
		159,
		-1,
		-1,
		232,
		-1,
		-1,
		64,
		47,
		-1,
		30,
		37,
		37,
		54,
		45,
		70,
		85,
		89,
		97,
		100,
		88,
		107,
		104,
		128,
		124,
		116,
		141,
		145,
		151,
		169,
		170,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		42,
		23,
		26,
		32,
		56,
		66,
		-1,
		92,
		90,
		114,
		108,
		113,
		109,
		94,
		112,
		110,
		125,
		127,
		123,
		125,
		162,
		153,
		174,
		171,
		202,
		207,
		201,
		210,
		-1,
		72,
		68,
		64,
		71,
		20,
		-1,
		-1,
		60,
		-1,
		74,
		87,
		104,
		94,
		97,
		109,
		117,
		116,
		100,
		118,
		113,
		116,
		134,
		131,
		140,
		149,
		148,
		166,
		180,
		194,
		198,
		204,
		-1,
		122,
		-1,
		64,
		48,
		50,
		14,
		21,
		-1,
		80,
		75,
		95,
		106,
		106,
		-1,
		122,
		119,
		132,
		116,
		101,
		118,
		120,
		124,
		133,
		138,
		152,
		143,
		161,
		168,
		176,
		180,
		200,
		212,
		82,
		72,
		-1,
		54,
		59,
		10,
		0,
		36,
		118,
		102,
		-1,
		117,
		-1,
		124,
		137,
		-1,
		122,
		118,
		107,
		121,
		116,
		131,
		137,
		134,
		131,
		149,
		152,
		169,
		173,
		189,
		-1,
		-1,
		67,
		71,
		68,
		14,
		34,
		58,
		95,
		111,
		120,
		122,
		-1,
		123,
		143,
		140,
		136,
		123,
		113,
		114,
		122,
		135,
		114,
		133,
		136,
		158,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		45,
		19,
		36,
		78,
		150,
		143,
		131,
		108,
		108,
		102,
		-1,
		143,
		126,
		122,
		111,
		109,
		122,
		117,
		133,
		137,
		136,
		155,
		167,
		158,
		178,
		-1,
		-1,
		-1,
		75,
		64,
		65,
		22,
		56,
		67,
		141,
		127,
		132,
		107,
		100,
		94,
		146,
		143,
		110,
		118,
		110,
		99,
		113,
		121,
		125,
		134,
		143,
		149,
		173,
		173,
		179,
		-1,
		-1,
		82,
		72,
		56,
		58,
		55,
		47,
		54,
		86,
		132,
		129,
		-1,
		99,
		-1,
		88,
		96,
		95,
		101,
		113,
		99,
		104,
		115,
		127,
		140,
		136,
		143,
		178,
		178,
		163,
		183,
		186,
		-1,
		-1,
		-1,
		75,
		95,
		70,
		47,
		28,
		64,
		-1,
		99,
		100,
		-1,
		93,
		87,
		93,
		92,
		99,
		96,
		96,
		110,
		118,
		114,
		130,
		136,
		128,
		164,
		-1,
		171,
		165,
		173,
		163,
		151,
		-1,
		-1,
		-1,
		93,
		72,
		65,
		85,
		35,
		87,
		-1,
		-1,
		84,
		77,
		-1,
		80,
		80,
		87,
		96,
		101,
		106,
		114,
		109,
		122,
		127,
		133,
		138,
		156,
		160,
		164,
		153,
		149,
		146,
		160,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		38,
		55,
		-1,
		92,
		84,
		75,
		69,
		75,
		93,
		91,
		111,
		103,
		117,
		117,
		123,
		131,
		116,
		119,
		135,
		133,
		151,
		159,
		151,
		145,
		144,
		156,
		-1,
		141,
		127,
		98,
		-1,
		-1,
		70,
		-1,
		41,
		65,
		81,
		-1,
		109,
		88,
		111,
		89,
		103,
		99,
		137,
		138,
		116,
		121,
		129,
		139,
		141,
		130,
		141,
		133,
		155,
		155,
		139,
		140,
		149,
		-1,
		147,
		134,
		92,
		88,
		77,
		97,
		44,
		57,
		68,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		113,
		111,
		127,
		118,
		124,
		140,
		143,
		145,
		135,
		124,
		130,
		127,
		149,
		135,
		133,
		152,
		168,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		63,
		50,
		44,
		-1,
		85,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		135,
		119,
		124,
		-1,
		170,
		-1,
		143,
		145,
		139,
		124,
		121,
		132,
		130,
		141,
		158,
		-1,
		97,
		82,
		75,
		65,
		79,
		50,
		-1,
		101,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		151,
		131,
		125,
		124,
		165,
		165,
		151,
		137,
		130,
		127,
		124,
		137,
		157,
		148,
		160,
		-1,
		-1,
		-1,
		102,
		82,
		88,
		46,
		67,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		168,
		156,
		146,
		136,
		170,
		171,
		156,
		149,
		135,
		137,
		135,
		133,
		138,
		159,
		160,
		173,
		-1,
		-1,
		79,
		86,
		74,
		60,
		79,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		157,
		-1,
		-1,
		148,
		146,
		156,
		152,
		139,
		159,
		162,
		148,
		132,
		147,
		159,
		167,
		172,
		-1,
		82,
		69,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		138,
		159,
		184,
		151,
		-1,
		156,
		157,
		143,
		157,
		164,
		150,
		145,
		139,
		142,
		160,
		177,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		117,
		131,
		152,
		158,
		170,
		-1,
		165,
		159,
		145,
		162,
		163,
		160,
		151,
		143,
		148,
		145,
		158,
		172,
		176,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		135,
		150,
		212,
		189,
		162,
		166,
		159,
		153,
		153,
		169,
		171,
		182,
		150,
		146,
		147,
		151,
		150,
		167,
		177,
		-1,
		-1,
		102,
		119,
		154,
		143,
		147,
		239,
		-1,
		-1,
		175,
		166,
		157,
		160,
		163,
		166,
		156,
		153,
		158,
		163,
		151,
		160,
		178,
		182,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		162,
		246,
		193,
		175,
		171,
		169,
		162,
		171,
		166,
		161,
		171,
		180,
		172,
		153,
		164,
		187,
		176,
		214,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		182,
		183,
		208,
		205,
		-1,
		175,
		200,
		172,
		179,
		171,
		179,
		179,
		176,
		154,
		161,
		177,
		176,
		171,
		206,
		198,
		204,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		157,
		143,
		173,
		163,
		169,
		-1,
		-1,
		216,
		213,
		197,
		181,
		185,
		178,
		173,
		183,
		163,
		150,
		154,
		158,
		164,
		169,
		174,
		180,
		195,
		210,
		-1,
		127,
		208,
		201,
		184,
		192,
		223,
		-1,
		160,
		169,
		150,
		155,
		163,
		-1,
		-1,
		189,
		185,
		190,
		188,
		185,
		193,
		188,
		179,
		164,
		170,
		157,
		156,
		174,
		178,
		187,
		194,
		184,
		197,
		201,
		-1,
		141,
		184,
		178,
		181,
		205,
		219,
		-1,
		173,
		-1,
		-1,
		158,
		176,
		184,
		180,
		184,
		237,
		202,
		197,
		187,
		185,
		176,
		167,
		174,
		165,
		165,
		168,
		183,
		188,
		180,
		194,
		194,
		195,
		-1,
		176,
		164,
		172,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		210,
		-1,
		203,
		207,
		210,
		213,
		201,
		188,
		180,
		172,
		188,
		163,
		173,
		169,
		170,
		179,
		190,
		202,
		201,
		202,
		250,
		205,
		172,
		163,
		210,
		225,
		229,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		217,
		223,
		215,
		221,
		200,
		200,
		174,
		178,
		168,
		175,
		185,
		187,
		179,
		183,
		196,
		207,
		210,
		246,
		244,
		249,
		194,
		177,
		195,
		204,
		225,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		240,
		233,
		-1,
		-1,
		207,
		195,
		178,
		179,
		175,
		178,
		193,
		196,
		186,
		184,
		178,
		210,
		-1,
		246,
		245,
		234,
		231,
		207,
		198,
		185,
		196,
		-1,
		-1,
		204,
		220,
		233,
		237,
		250,
		275,
		-1,
		193,
		-1,
		-1,
		252,
		-1,
		-1,
		237,
		200,
		189,
		180,
		186,
		183,
		194,
		204,
		192,
		193,
		183,
		193,
		206,
		230,
		227,
		215,
		213,
		236,
		193,
		189,
		-1,
		219,
		207,
		213,
		220,
		237,
		264,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		235,
		233,
		222,
		-1,
		212,
		185,
		190,
		210,
		212,
		201,
		195,
		189,
		196,
		195,
		203,
		211,
		239,
		253,
		242,
		238,
		237,
		245,
		194,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		219,
		-1,
		-1,
		230,
		223,
		211,
		199,
		189,
		199,
		203,
		207,
		199,
		192,
		187,
		198,
		190,
		194,
		211,
		-1,
		273,
		-1,
		225,
		218,
		233,
		248,
		256,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		264,
		248,
		229,
		-1,
		199,
		212,
		243,
		211,
		216,
		211,
		193,
		204,
		193,
		196,
		210,
		205,
		-1,
		-1,
		231,
		234,
		-1,
		-1,
		256,
		275,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		236,
		232,
		-1,
		-1,
		200,
		225,
		214,
		222,
		217,
		197,
		203,
		206,
		195,
		199,
		211,
		-1,
		-1,
		238,
		239,
		244,
		-1,
		265,
		-1,
		276,
		-1,
		221,
		237,
		239,
		-1,
		-1,
		-1,
		238,
		201,
		222,
		232,
		226,
		224,
		215,
		201,
		208,
		206,
		202,
		213,
		-1,
		-1,
		-1,
		283,
		257,
		283,
		274,
		257,
		237,
		229,
		254,
		-1,
		225,
		-1,
		200,
		202,
		228,
		231,
		237,
		231,
		204,
		219,
		209,
		200,
		209,
		289,
		-1,
		259,
		292,
		256,
		243,
		226,
		230,
		246,
		-1,
		222,
		204,
		-1,
		232,
		222,
		253,
		238,
		219,
		206,
		213,
		213,
		206,
		-1,
		-1,
		-1,
		261,
		260,
		252,
		246,
		246,
		231,
		222,
		-1,
		234,
		216,
		195,
		212,
		212,
		203,
		211,
		243,
		239,
		226,
		226,
		218,
		-1,
		345,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		255,
		250,
		223,
		211,
		217,
		213,
		199,
		205,
		207,
		215,
		213,
		210,
		222,
		218,
		238,
		219,
		254,
		-1,
		352,
		-1,
		291,
		-1,
		-1,
		273,
		253,
		245,
		234,
		223,
		221,
		212,
		203,
		225,
		241,
		225,
		223,
		226,
		227,
		-1,
		346,
		345,
		-1,
		292,
		284,
		270,
		-1,
		263,
		-1,
		269,
		230,
		-1,
		232,
		212,
		-1,
		234,
		230,
		-1,
		-1,
		333,
		308,
		-1,
		-1,
		-1,
		293,
		273,
		264,
		248,
		-1,
		223,
		223,
		-1,
		-1,
		-1,
		318,
		317,
		-1,
		286,
		289,
		-1,
		279,
		270,
		278,
		225,
		229,
		-1,
		-1,
		-1,
		327,
		308,
		302,
		301,
		299,
		294,
		291,
		277,
		261,
		239,
		228,
		249,
		-1,
		-1,
		-1,
		299,
		291,
		284,
		-1,
		-1,
		286,
		269,
		250,
		248,
		-1,
		-1,
		-1,
		321,
		302,
		-1,
		-1,
		276,
		-1,
		-1,
		282,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		338,
		310,
		-1,
		-1,
		-1,
		272,
		268,
		269,
		-1,
		-1,
		-1,
		-1,
		332,
		333,
		356,
		320,
		-1,
		-1,
		-1,
		264,
		258,
		-1,
		-1,
		335,
		333,
		-1,
		-1,
		-1,
		292,
		276,
		-1,
		262,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		297,
		-1,
		297,
		272,
		279,
		-1,
		-1,
		-1,
		-1,
		310,
		302,
		310,
		-1,
		282,
		284,
		-1,
		332,
		-1,
		-1,
		325,
		316,
		-1,
		-1,
		287,
		294,
		316,
		319,
		355,
		-1,
		306
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		173,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		166,
		158,
		198,
		154,
		125,
		119,
		137,
		142,
		160,
		152,
		-1,
		125,
		115,
		137,
		141,
		153,
		136,
		-1,
		-1,
		119,
		120,
		126,
		138,
		143,
		148,
		-1,
		174,
		193,
		-1,
		-1,
		109,
		122,
		118,
		121,
		129,
		145,
		166,
		183,
		188,
		-1,
		-1,
		110,
		114,
		127,
		128,
		126,
		153,
		172,
		183,
		197,
		196,
		-1,
		98,
		116,
		125,
		134,
		140,
		129,
		133,
		151,
		182,
		188,
		191,
		-1,
		90,
		92,
		121,
		127,
		139,
		145,
		132,
		138,
		157,
		170,
		189,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		87,
		95,
		121,
		120,
		116,
		134,
		156,
		135,
		141,
		145,
		162,
		178,
		179,
		189,
		-1,
		-1,
		143,
		112,
		147,
		104,
		89,
		-1,
		83,
		102,
		108,
		112,
		117,
		125,
		153,
		151,
		-1,
		156,
		155,
		186,
		172,
		183,
		103,
		-1,
		-1,
		101,
		93,
		78,
		81,
		78,
		78,
		108,
		107,
		112,
		114,
		116,
		128,
		143,
		143,
		153,
		150,
		160,
		164,
		179,
		190,
		-1,
		-1,
		257,
		-1,
		-1,
		100,
		83,
		-1,
		66,
		73,
		73,
		90,
		80,
		101,
		116,
		120,
		128,
		131,
		119,
		138,
		135,
		159,
		155,
		147,
		172,
		176,
		182,
		200,
		198,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		59,
		62,
		68,
		92,
		102,
		-1,
		123,
		121,
		145,
		139,
		144,
		140,
		125,
		143,
		141,
		156,
		158,
		154,
		156,
		193,
		179,
		201,
		198,
		227,
		232,
		226,
		235,
		-1,
		108,
		104,
		100,
		107,
		56,
		-1,
		-1,
		96,
		-1,
		110,
		123,
		135,
		125,
		128,
		140,
		148,
		147,
		131,
		149,
		144,
		147,
		159,
		162,
		171,
		174,
		173,
		191,
		206,
		219,
		223,
		229,
		-1,
		158,
		-1,
		100,
		84,
		86,
		58,
		66,
		-1,
		116,
		111,
		131,
		137,
		137,
		-1,
		153,
		150,
		163,
		147,
		132,
		149,
		151,
		153,
		158,
		163,
		177,
		168,
		186,
		193,
		201,
		205,
		225,
		237,
		118,
		108,
		-1,
		90,
		95,
		54,
		45,
		0,
		154,
		138,
		-1,
		148,
		-1,
		155,
		168,
		-1,
		153,
		149,
		138,
		146,
		141,
		156,
		162,
		159,
		156,
		174,
		177,
		194,
		198,
		214,
		-1,
		-1,
		103,
		107,
		89,
		47,
		55,
		79,
		116,
		147,
		155,
		154,
		-1,
		148,
		174,
		171,
		161,
		148,
		138,
		139,
		147,
		160,
		139,
		158,
		161,
		183,
		211,
		189,
		201,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		66,
		44,
		57,
		99,
		184,
		177,
		165,
		133,
		133,
		127,
		-1,
		168,
		151,
		147,
		136,
		134,
		147,
		142,
		158,
		162,
		161,
		180,
		192,
		183,
		203,
		-1,
		-1,
		-1,
		96,
		85,
		86,
		47,
		80,
		88,
		166,
		152,
		157,
		132,
		125,
		119,
		171,
		168,
		135,
		143,
		135,
		124,
		138,
		146,
		150,
		159,
		168,
		174,
		198,
		198,
		204,
		-1,
		-1,
		103,
		93,
		77,
		79,
		76,
		72,
		79,
		111,
		157,
		154,
		-1,
		124,
		-1,
		113,
		121,
		120,
		126,
		138,
		124,
		129,
		140,
		152,
		165,
		161,
		168,
		203,
		203,
		188,
		208,
		211,
		-1,
		-1,
		-1,
		96,
		120,
		95,
		72,
		53,
		89,
		-1,
		124,
		125,
		-1,
		118,
		112,
		118,
		117,
		124,
		121,
		121,
		135,
		143,
		139,
		155,
		161,
		153,
		189,
		-1,
		196,
		190,
		198,
		188,
		176,
		-1,
		-1,
		-1,
		118,
		97,
		90,
		110,
		60,
		112,
		-1,
		-1,
		109,
		102,
		-1,
		105,
		105,
		112,
		121,
		126,
		131,
		139,
		134,
		147,
		152,
		158,
		163,
		181,
		185,
		189,
		178,
		174,
		171,
		185,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		80,
		-1,
		117,
		109,
		100,
		94,
		100,
		118,
		116,
		136,
		128,
		142,
		142,
		148,
		156,
		141,
		144,
		160,
		158,
		176,
		184,
		176,
		170,
		169,
		181,
		-1,
		166,
		152,
		123,
		-1,
		-1,
		95,
		-1,
		66,
		90,
		106,
		-1,
		134,
		113,
		136,
		114,
		128,
		124,
		162,
		163,
		141,
		146,
		154,
		164,
		166,
		155,
		166,
		158,
		180,
		180,
		164,
		165,
		174,
		-1,
		172,
		159,
		117,
		113,
		102,
		122,
		69,
		82,
		93,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		138,
		136,
		152,
		143,
		149,
		165,
		168,
		170,
		160,
		149,
		155,
		152,
		174,
		160,
		158,
		177,
		193,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		88,
		75,
		69,
		-1,
		110,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		160,
		144,
		149,
		-1,
		195,
		-1,
		168,
		170,
		164,
		149,
		146,
		157,
		155,
		166,
		183,
		-1,
		122,
		107,
		100,
		90,
		104,
		75,
		-1,
		126,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		176,
		156,
		150,
		149,
		190,
		190,
		176,
		162,
		155,
		152,
		149,
		162,
		182,
		173,
		185,
		-1,
		-1,
		-1,
		127,
		107,
		113,
		71,
		92,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		193,
		181,
		171,
		161,
		195,
		196,
		181,
		174,
		160,
		162,
		160,
		158,
		163,
		184,
		185,
		198,
		-1,
		-1,
		104,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		182,
		-1,
		-1,
		173,
		171,
		181,
		177,
		164,
		184,
		187,
		173,
		157,
		172,
		184,
		192,
		197,
		-1,
		107,
		94,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		184,
		209,
		176,
		-1,
		181,
		182,
		168,
		182,
		189,
		175,
		170,
		164,
		167,
		185,
		202,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		177,
		183,
		195,
		-1,
		190,
		184,
		170,
		187,
		188,
		185,
		176,
		168,
		173,
		170,
		183,
		197,
		201,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		160,
		175,
		237,
		214,
		187,
		191,
		184,
		178,
		178,
		194,
		196,
		207,
		175,
		171,
		172,
		176,
		175,
		192,
		202,
		-1,
		-1,
		127,
		144,
		179,
		168,
		172,
		264,
		-1,
		-1,
		200,
		191,
		182,
		185,
		188,
		191,
		181,
		178,
		183,
		188,
		176,
		185,
		203,
		207,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		187,
		271,
		218,
		200,
		196,
		194,
		187,
		196,
		191,
		186,
		196,
		205,
		197,
		178,
		189,
		212,
		201,
		239,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		212,
		207,
		208,
		233,
		230,
		-1,
		200,
		225,
		197,
		204,
		196,
		204,
		204,
		201,
		179,
		186,
		202,
		201,
		196,
		231,
		223,
		229,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		182,
		168,
		198,
		188,
		194,
		-1,
		-1,
		241,
		238,
		222,
		206,
		210,
		203,
		198,
		208,
		188,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		152,
		233,
		226,
		209,
		217,
		248,
		-1,
		185,
		194,
		175,
		180,
		188,
		-1,
		-1,
		214,
		210,
		215,
		213,
		210,
		218,
		213,
		204,
		189,
		195,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		166,
		209,
		203,
		206,
		230,
		244,
		-1,
		198,
		-1,
		-1,
		183,
		201,
		209,
		205,
		209,
		262,
		227,
		222,
		212,
		210,
		201,
		192,
		199,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		201,
		189,
		197,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		199,
		-1,
		235,
		-1,
		228,
		232,
		235,
		238,
		226,
		213,
		205,
		197,
		213,
		188,
		198,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		275,
		230,
		197,
		188,
		235,
		250,
		254,
		-1,
		211,
		250,
		237,
		-1,
		208,
		-1,
		-1,
		-1,
		242,
		248,
		240,
		246,
		225,
		225,
		199,
		203,
		193,
		200,
		210,
		212,
		204,
		208,
		221,
		232,
		235,
		271,
		269,
		274,
		219,
		202,
		220,
		229,
		250,
		226,
		217,
		244,
		244,
		233,
		228,
		215,
		-1,
		-1,
		265,
		258,
		-1,
		-1,
		232,
		220,
		203,
		204,
		200,
		203,
		218,
		221,
		211,
		209,
		203,
		235,
		-1,
		271,
		270,
		259,
		256,
		232,
		223,
		210,
		221,
		-1,
		-1,
		229,
		245,
		258,
		262,
		275,
		300,
		-1,
		218,
		-1,
		-1,
		277,
		-1,
		-1,
		262,
		225,
		214,
		205,
		211,
		208,
		219,
		229,
		217,
		218,
		208,
		218,
		231,
		255,
		252,
		240,
		238,
		261,
		218,
		214,
		-1,
		244,
		232,
		238,
		245,
		262,
		289,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		260,
		258,
		247,
		-1,
		237,
		210,
		215,
		235,
		237,
		226,
		220,
		214,
		221,
		220,
		228,
		236,
		264,
		278,
		267,
		263,
		262,
		270,
		219,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		-1,
		269,
		244,
		-1,
		-1,
		255,
		248,
		236,
		224,
		214,
		224,
		228,
		232,
		224,
		217,
		212,
		223,
		215,
		219,
		236,
		-1,
		298,
		-1,
		250,
		243,
		258,
		273,
		281,
		-1,
		-1,
		-1,
		286,
		272,
		265,
		253,
		251,
		-1,
		289,
		273,
		254,
		-1,
		224,
		237,
		268,
		236,
		241,
		236,
		218,
		229,
		218,
		221,
		235,
		230,
		-1,
		-1,
		256,
		259,
		-1,
		-1,
		281,
		300,
		-1,
		277,
		266,
		251,
		243,
		-1,
		-1,
		261,
		257,
		-1,
		-1,
		225,
		250,
		239,
		247,
		242,
		222,
		228,
		231,
		220,
		224,
		236,
		-1,
		-1,
		263,
		264,
		269,
		-1,
		290,
		-1,
		301,
		-1,
		246,
		262,
		264,
		-1,
		-1,
		-1,
		263,
		226,
		247,
		257,
		251,
		249,
		240,
		226,
		233,
		231,
		227,
		238,
		-1,
		-1,
		-1,
		308,
		282,
		308,
		299,
		282,
		262,
		254,
		279,
		-1,
		250,
		-1,
		225,
		227,
		253,
		256,
		262,
		256,
		229,
		244,
		234,
		225,
		234,
		314,
		-1,
		284,
		317,
		281,
		268,
		251,
		255,
		271,
		-1,
		247,
		229,
		-1,
		257,
		247,
		278,
		263,
		244,
		231,
		238,
		238,
		231,
		-1,
		-1,
		-1,
		286,
		285,
		277,
		271,
		271,
		256,
		247,
		-1,
		259,
		241,
		220,
		237,
		237,
		228,
		236,
		268,
		264,
		251,
		251,
		243,
		-1,
		370,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		280,
		275,
		248,
		236,
		242,
		238,
		224,
		230,
		232,
		240,
		238,
		235,
		247,
		243,
		263,
		244,
		279,
		-1,
		377,
		-1,
		316,
		-1,
		-1,
		298,
		278,
		270,
		259,
		248,
		246,
		237,
		228,
		250,
		266,
		250,
		248,
		251,
		252,
		-1,
		371,
		370,
		-1,
		317,
		309,
		295,
		-1,
		288,
		-1,
		294,
		255,
		-1,
		257,
		237,
		-1,
		259,
		255,
		-1,
		-1,
		358,
		333,
		-1,
		-1,
		-1,
		318,
		298,
		289,
		273,
		-1,
		248,
		248,
		-1,
		-1,
		-1,
		343,
		342,
		-1,
		311,
		314,
		-1,
		304,
		295,
		303,
		250,
		254,
		-1,
		-1,
		-1,
		352,
		333,
		327,
		326,
		324,
		319,
		316,
		302,
		286,
		264,
		253,
		274,
		-1,
		-1,
		-1,
		324,
		316,
		309,
		-1,
		-1,
		311,
		294,
		275,
		273,
		-1,
		-1,
		-1,
		346,
		327,
		-1,
		-1,
		301,
		-1,
		-1,
		307,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		363,
		335,
		-1,
		-1,
		-1,
		297,
		293,
		294,
		-1,
		-1,
		-1,
		-1,
		357,
		358,
		381,
		345,
		-1,
		-1,
		-1,
		289,
		283,
		-1,
		-1,
		360,
		358,
		-1,
		-1,
		-1,
		317,
		301,
		-1,
		287,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		322,
		-1,
		322,
		297,
		304,
		-1,
		-1,
		-1,
		-1,
		335,
		327,
		335,
		-1,
		307,
		309,
		-1,
		357,
		-1,
		-1,
		350,
		341,
		-1,
		-1,
		312,
		319,
		341,
		344,
		380,
		-1,
		331
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		189,
		191,
		157,
		151,
		190,
		161,
		167,
		178,
		-1,
		-1,
		-1,
		180,
		179,
		149,
		147,
		156,
		161,
		168,
		-1,
		191,
		-1,
		201,
		180,
		191,
		196,
		142,
		139,
		159,
		178,
		184,
		176,
		216,
		172,
		143,
		137,
		155,
		160,
		178,
		170,
		-1,
		143,
		133,
		155,
		159,
		171,
		154,
		-1,
		-1,
		137,
		138,
		144,
		156,
		161,
		166,
		-1,
		192,
		211,
		-1,
		-1,
		127,
		140,
		136,
		139,
		147,
		163,
		184,
		201,
		206,
		-1,
		-1,
		128,
		132,
		145,
		146,
		144,
		171,
		190,
		201,
		215,
		214,
		-1,
		116,
		134,
		143,
		152,
		158,
		147,
		151,
		169,
		200,
		206,
		209,
		-1,
		108,
		110,
		139,
		145,
		157,
		163,
		150,
		156,
		175,
		188,
		207,
		198,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		105,
		113,
		139,
		138,
		134,
		152,
		174,
		153,
		159,
		163,
		180,
		196,
		197,
		207,
		-1,
		-1,
		168,
		141,
		165,
		124,
		111,
		-1,
		101,
		120,
		126,
		130,
		135,
		143,
		171,
		169,
		-1,
		174,
		173,
		204,
		190,
		201,
		150,
		-1,
		-1,
		126,
		118,
		100,
		103,
		91,
		96,
		126,
		125,
		130,
		132,
		131,
		146,
		161,
		161,
		171,
		168,
		178,
		182,
		197,
		208,
		-1,
		-1,
		282,
		-1,
		-1,
		147,
		130,
		-1,
		95,
		102,
		86,
		103,
		94,
		119,
		134,
		128,
		127,
		146,
		134,
		154,
		153,
		177,
		173,
		165,
		190,
		194,
		200,
		218,
		219,
		-1,
		281,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		102,
		99,
		92,
		93,
		81,
		-1,
		87,
		93,
		117,
		120,
		132,
		145,
		140,
		161,
		159,
		174,
		176,
		172,
		174,
		211,
		202,
		223,
		220,
		251,
		257,
		251,
		260,
		-1,
		155,
		151,
		147,
		154,
		103,
		-1,
		-1,
		89,
		-1,
		47,
		82,
		79,
		97,
		100,
		121,
		121,
		152,
		146,
		164,
		162,
		165,
		184,
		180,
		189,
		199,
		198,
		216,
		229,
		244,
		248,
		254,
		-1,
		205,
		-1,
		147,
		131,
		133,
		109,
		137,
		-1,
		101,
		46,
		90,
		81,
		72,
		-1,
		125,
		122,
		136,
		143,
		148,
		165,
		169,
		173,
		183,
		187,
		202,
		193,
		211,
		218,
		226,
		230,
		250,
		262,
		165,
		155,
		-1,
		137,
		142,
		112,
		124,
		160,
		0,
		34,
		-1,
		73,
		-1,
		127,
		140,
		-1,
		142,
		146,
		154,
		170,
		167,
		182,
		188,
		184,
		181,
		199,
		202,
		219,
		223,
		239,
		-1,
		-1,
		150,
		154,
		175,
		118,
		145,
		121,
		89,
		43,
		52,
		54,
		-1,
		120,
		173,
		170,
		171,
		173,
		164,
		165,
		173,
		186,
		165,
		183,
		186,
		208,
		236,
		214,
		226,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		152,
		123,
		147,
		103,
		82,
		75,
		63,
		88,
		88,
		95,
		-1,
		193,
		176,
		173,
		162,
		160,
		173,
		168,
		184,
		187,
		187,
		205,
		217,
		208,
		228,
		-1,
		-1,
		-1,
		182,
		171,
		172,
		126,
		160,
		178,
		121,
		107,
		112,
		87,
		93,
		98,
		182,
		191,
		160,
		169,
		161,
		150,
		164,
		172,
		176,
		185,
		194,
		199,
		223,
		224,
		230,
		-1,
		-1,
		189,
		179,
		163,
		165,
		162,
		151,
		158,
		190,
		112,
		196,
		-1,
		131,
		-1,
		104,
		138,
		146,
		152,
		164,
		150,
		155,
		166,
		178,
		191,
		187,
		194,
		228,
		228,
		214,
		234,
		237,
		-1,
		-1,
		-1,
		182,
		199,
		174,
		151,
		132,
		168,
		-1,
		166,
		167,
		-1,
		125,
		119,
		135,
		143,
		150,
		147,
		147,
		161,
		169,
		165,
		181,
		187,
		179,
		215,
		-1,
		222,
		216,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		139,
		191,
		-1,
		-1,
		151,
		144,
		-1,
		122,
		131,
		138,
		147,
		152,
		157,
		165,
		160,
		173,
		178,
		184,
		189,
		207,
		211,
		215,
		204,
		200,
		197,
		211,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		159,
		-1,
		160,
		152,
		142,
		136,
		130,
		144,
		142,
		162,
		154,
		168,
		168,
		174,
		182,
		167,
		170,
		186,
		184,
		202,
		210,
		202,
		196,
		195,
		207,
		-1,
		235,
		221,
		192,
		-1,
		-1,
		174,
		-1,
		145,
		159,
		175,
		-1,
		168,
		147,
		162,
		140,
		154,
		150,
		188,
		189,
		167,
		172,
		180,
		190,
		192,
		181,
		192,
		184,
		206,
		206,
		190,
		191,
		200,
		-1,
		241,
		228,
		186,
		182,
		171,
		191,
		142,
		130,
		162,
		-1,
		-1,
		204,
		-1,
		138,
		155,
		164,
		162,
		178,
		169,
		175,
		191,
		194,
		196,
		186,
		175,
		181,
		178,
		200,
		186,
		184,
		203,
		219,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		157,
		144,
		138,
		-1,
		179,
		-1,
		182,
		172,
		156,
		141,
		174,
		-1,
		186,
		170,
		175,
		-1,
		221,
		-1,
		194,
		196,
		190,
		175,
		172,
		183,
		181,
		192,
		209,
		-1,
		191,
		176,
		169,
		159,
		173,
		144,
		-1,
		199,
		-1,
		-1,
		169,
		163,
		163,
		147,
		150,
		202,
		182,
		176,
		175,
		216,
		216,
		202,
		188,
		181,
		178,
		175,
		188,
		208,
		199,
		211,
		-1,
		-1,
		-1,
		196,
		182,
		186,
		146,
		165,
		-1,
		-1,
		231,
		186,
		172,
		-1,
		156,
		219,
		207,
		197,
		187,
		221,
		222,
		207,
		200,
		186,
		188,
		186,
		184,
		189,
		210,
		211,
		224,
		-1,
		-1,
		179,
		184,
		172,
		158,
		177,
		-1,
		-1,
		-1,
		178,
		194,
		186,
		157,
		208,
		-1,
		-1,
		199,
		197,
		207,
		203,
		190,
		210,
		213,
		199,
		183,
		198,
		210,
		218,
		223,
		-1,
		182,
		169,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		189,
		210,
		235,
		202,
		-1,
		207,
		208,
		194,
		208,
		215,
		201,
		196,
		190,
		193,
		211,
		228,
		-1,
		-1,
		194,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		168,
		182,
		203,
		209,
		221,
		-1,
		216,
		210,
		196,
		213,
		214,
		211,
		202,
		194,
		199,
		196,
		209,
		223,
		227,
		217,
		-1,
		200,
		-1,
		-1,
		-1,
		186,
		201,
		263,
		240,
		213,
		217,
		210,
		204,
		204,
		220,
		222,
		233,
		201,
		197,
		198,
		202,
		201,
		218,
		228,
		-1,
		-1,
		200,
		217,
		212,
		194,
		198,
		290,
		-1,
		-1,
		226,
		217,
		208,
		211,
		214,
		217,
		207,
		204,
		209,
		214,
		202,
		211,
		229,
		233,
		-1,
		-1,
		-1,
		220,
		-1,
		235,
		-1,
		-1,
		213,
		297,
		244,
		226,
		222,
		220,
		213,
		222,
		217,
		212,
		222,
		231,
		223,
		204,
		215,
		238,
		227,
		265,
		-1,
		-1,
		339,
		-1,
		-1,
		-1,
		249,
		224,
		239,
		285,
		233,
		240,
		259,
		256,
		-1,
		226,
		251,
		223,
		230,
		222,
		230,
		230,
		227,
		205,
		212,
		228,
		227,
		222,
		257,
		249,
		255,
		-1,
		-1,
		332,
		321,
		310,
		316,
		-1,
		255,
		241,
		271,
		261,
		250,
		-1,
		-1,
		275,
		272,
		248,
		232,
		236,
		229,
		224,
		234,
		214,
		201,
		205,
		209,
		215,
		220,
		225,
		231,
		246,
		261,
		-1,
		227,
		308,
		301,
		284,
		292,
		323,
		-1,
		258,
		267,
		248,
		253,
		261,
		-1,
		-1,
		248,
		245,
		250,
		239,
		236,
		244,
		239,
		230,
		215,
		221,
		208,
		207,
		225,
		229,
		238,
		245,
		235,
		248,
		252,
		-1,
		241,
		284,
		278,
		281,
		305,
		319,
		-1,
		271,
		-1,
		-1,
		256,
		274,
		263,
		253,
		247,
		297,
		253,
		248,
		238,
		236,
		227,
		218,
		225,
		216,
		216,
		219,
		234,
		239,
		231,
		245,
		245,
		246,
		-1,
		276,
		264,
		272,
		-1,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		272,
		-1,
		290,
		-1,
		265,
		269,
		261,
		264,
		252,
		239,
		231,
		223,
		239,
		214,
		224,
		220,
		221,
		230,
		241,
		253,
		252,
		253,
		350,
		305,
		272,
		263,
		310,
		325,
		329,
		-1,
		284,
		323,
		310,
		-1,
		281,
		-1,
		-1,
		-1,
		279,
		274,
		266,
		272,
		251,
		251,
		225,
		229,
		219,
		226,
		236,
		238,
		230,
		234,
		247,
		258,
		261,
		346,
		344,
		349,
		294,
		277,
		295,
		304,
		325,
		299,
		290,
		317,
		317,
		306,
		301,
		288,
		-1,
		-1,
		302,
		284,
		-1,
		-1,
		258,
		246,
		229,
		230,
		226,
		229,
		244,
		247,
		237,
		235,
		229,
		261,
		-1,
		346,
		345,
		334,
		331,
		307,
		298,
		285,
		296,
		-1,
		-1,
		302,
		318,
		331,
		335,
		348,
		373,
		-1,
		291,
		-1,
		-1,
		303,
		-1,
		-1,
		288,
		251,
		240,
		231,
		237,
		234,
		245,
		255,
		243,
		244,
		234,
		244,
		257,
		330,
		327,
		315,
		313,
		336,
		293,
		289,
		-1,
		312,
		305,
		311,
		318,
		335,
		362,
		-1,
		-1,
		307,
		298,
		-1,
		-1,
		286,
		284,
		273,
		-1,
		263,
		236,
		241,
		261,
		263,
		252,
		246,
		240,
		247,
		246,
		254,
		262,
		339,
		353,
		342,
		338,
		337,
		345,
		294,
		297,
		309,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		-1,
		324,
		317,
		-1,
		-1,
		281,
		274,
		262,
		250,
		240,
		250,
		254,
		258,
		250,
		243,
		238,
		249,
		241,
		245,
		262,
		-1,
		373,
		-1,
		325,
		311,
		325,
		340,
		348,
		-1,
		-1,
		-1,
		341,
		327,
		320,
		308,
		306,
		-1,
		315,
		299,
		280,
		-1,
		250,
		263,
		294,
		262,
		267,
		262,
		244,
		255,
		244,
		247,
		261,
		256,
		-1,
		-1,
		323,
		326,
		-1,
		-1,
		331,
		333,
		-1,
		332,
		321,
		306,
		298,
		-1,
		-1,
		287,
		283,
		-1,
		-1,
		251,
		276,
		265,
		273,
		268,
		248,
		254,
		257,
		246,
		250,
		262,
		-1,
		-1,
		330,
		331,
		336,
		-1,
		316,
		-1,
		334,
		-1,
		301,
		307,
		295,
		-1,
		-1,
		-1,
		289,
		252,
		273,
		283,
		277,
		275,
		266,
		252,
		259,
		257,
		253,
		264,
		-1,
		-1,
		-1,
		334,
		308,
		341,
		332,
		315,
		295,
		287,
		306,
		-1,
		276,
		-1,
		251,
		253,
		279,
		282,
		288,
		282,
		255,
		270,
		260,
		251,
		260,
		340,
		-1,
		310,
		343,
		307,
		301,
		277,
		281,
		297,
		-1,
		273,
		255,
		-1,
		283,
		273,
		304,
		289,
		270,
		257,
		264,
		264,
		257,
		-1,
		-1,
		-1,
		312,
		311,
		303,
		297,
		297,
		282,
		273,
		-1,
		285,
		267,
		246,
		263,
		263,
		254,
		262,
		294,
		290,
		277,
		277,
		269,
		-1,
		413,
		-1,
		-1,
		335,
		-1,
		-1,
		-1,
		306,
		301,
		274,
		262,
		268,
		264,
		250,
		256,
		258,
		266,
		264,
		261,
		273,
		269,
		289,
		270,
		305,
		-1,
		408,
		-1,
		342,
		-1,
		-1,
		324,
		304,
		296,
		285,
		274,
		272,
		263,
		254,
		276,
		292,
		276,
		274,
		277,
		278,
		-1,
		397,
		396,
		-1,
		343,
		335,
		321,
		-1,
		314,
		-1,
		320,
		281,
		-1,
		283,
		263,
		-1,
		285,
		281,
		-1,
		-1,
		384,
		359,
		-1,
		-1,
		-1,
		344,
		324,
		315,
		299,
		-1,
		274,
		274,
		-1,
		-1,
		-1,
		369,
		368,
		-1,
		337,
		340,
		-1,
		330,
		321,
		329,
		276,
		280,
		-1,
		-1,
		-1,
		378,
		359,
		353,
		352,
		350,
		345,
		342,
		328,
		312,
		290,
		279,
		300,
		-1,
		-1,
		-1,
		350,
		342,
		335,
		-1,
		-1,
		337,
		320,
		301,
		299,
		-1,
		-1,
		-1,
		372,
		353,
		-1,
		-1,
		327,
		-1,
		-1,
		333,
		298,
		-1,
		-1,
		-1,
		-1,
		-1,
		389,
		361,
		-1,
		-1,
		-1,
		323,
		319,
		320,
		-1,
		-1,
		-1,
		-1,
		383,
		384,
		407,
		371,
		-1,
		-1,
		-1,
		315,
		309,
		-1,
		-1,
		386,
		384,
		-1,
		-1,
		-1,
		343,
		327,
		-1,
		313,
		-1,
		-1,
		-1,
		334,
		-1,
		-1,
		346,
		-1,
		-1,
		-1,
		348,
		-1,
		348,
		323,
		330,
		-1,
		-1,
		-1,
		-1,
		361,
		353,
		361,
		-1,
		333,
		335,
		-1,
		383,
		-1,
		-1,
		376,
		367,
		-1,
		-1,
		338,
		345,
		367,
		370,
		406,
		-1,
		357
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		175,
		177,
		143,
		137,
		176,
		147,
		153,
		164,
		-1,
		-1,
		-1,
		166,
		165,
		135,
		133,
		142,
		147,
		154,
		-1,
		177,
		-1,
		187,
		166,
		177,
		182,
		128,
		125,
		145,
		164,
		170,
		162,
		202,
		158,
		129,
		123,
		141,
		146,
		164,
		156,
		-1,
		129,
		119,
		141,
		145,
		157,
		140,
		-1,
		-1,
		123,
		124,
		130,
		142,
		147,
		152,
		-1,
		178,
		197,
		-1,
		-1,
		113,
		126,
		122,
		125,
		133,
		149,
		170,
		187,
		192,
		-1,
		-1,
		114,
		118,
		131,
		132,
		130,
		157,
		176,
		187,
		201,
		200,
		-1,
		102,
		120,
		129,
		138,
		144,
		133,
		137,
		155,
		186,
		192,
		195,
		-1,
		94,
		96,
		125,
		131,
		143,
		149,
		136,
		142,
		161,
		174,
		193,
		184,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		91,
		99,
		125,
		124,
		120,
		136,
		153,
		139,
		145,
		149,
		166,
		182,
		183,
		193,
		-1,
		-1,
		154,
		127,
		151,
		110,
		97,
		-1,
		87,
		106,
		112,
		116,
		121,
		123,
		150,
		148,
		-1,
		160,
		159,
		190,
		176,
		187,
		136,
		-1,
		-1,
		112,
		104,
		86,
		89,
		77,
		82,
		108,
		107,
		105,
		101,
		97,
		126,
		138,
		136,
		146,
		154,
		164,
		168,
		179,
		194,
		-1,
		-1,
		249,
		-1,
		-1,
		133,
		116,
		-1,
		81,
		88,
		72,
		89,
		80,
		91,
		118,
		94,
		93,
		112,
		100,
		120,
		130,
		153,
		150,
		151,
		176,
		180,
		174,
		195,
		190,
		-1,
		248,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		88,
		85,
		78,
		79,
		67,
		-1,
		53,
		59,
		83,
		86,
		98,
		111,
		106,
		136,
		136,
		151,
		153,
		158,
		160,
		193,
		171,
		193,
		190,
		219,
		224,
		218,
		227,
		-1,
		141,
		137,
		133,
		140,
		89,
		-1,
		-1,
		75,
		-1,
		33,
		68,
		45,
		63,
		66,
		87,
		87,
		118,
		112,
		130,
		139,
		142,
		151,
		160,
		171,
		166,
		165,
		183,
		198,
		211,
		215,
		221,
		-1,
		191,
		-1,
		133,
		117,
		119,
		95,
		123,
		-1,
		87,
		32,
		62,
		47,
		38,
		-1,
		91,
		88,
		102,
		109,
		114,
		131,
		146,
		145,
		150,
		155,
		169,
		160,
		178,
		185,
		193,
		197,
		217,
		229,
		151,
		141,
		-1,
		123,
		128,
		98,
		110,
		146,
		36,
		0,
		-1,
		39,
		-1,
		93,
		106,
		-1,
		108,
		112,
		120,
		136,
		133,
		148,
		154,
		151,
		148,
		166,
		169,
		186,
		190,
		206,
		-1,
		-1,
		136,
		140,
		161,
		104,
		111,
		87,
		55,
		9,
		18,
		20,
		-1,
		86,
		139,
		136,
		137,
		139,
		130,
		131,
		139,
		152,
		131,
		150,
		153,
		175,
		203,
		181,
		193,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		138,
		109,
		119,
		69,
		48,
		41,
		29,
		54,
		54,
		61,
		-1,
		159,
		142,
		139,
		128,
		126,
		139,
		134,
		150,
		154,
		153,
		172,
		184,
		175,
		195,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		112,
		146,
		158,
		87,
		73,
		78,
		53,
		59,
		64,
		148,
		157,
		126,
		135,
		127,
		116,
		130,
		138,
		142,
		151,
		160,
		166,
		190,
		190,
		196,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		137,
		144,
		176,
		78,
		162,
		-1,
		97,
		-1,
		70,
		104,
		112,
		118,
		130,
		116,
		121,
		132,
		144,
		157,
		153,
		160,
		195,
		195,
		180,
		200,
		203,
		-1,
		-1,
		-1,
		168,
		183,
		158,
		135,
		118,
		154,
		-1,
		132,
		133,
		-1,
		91,
		85,
		101,
		109,
		116,
		113,
		113,
		127,
		135,
		131,
		147,
		153,
		145,
		181,
		-1,
		188,
		182,
		190,
		180,
		168,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		114,
		166,
		-1,
		-1,
		117,
		110,
		-1,
		88,
		97,
		104,
		113,
		118,
		123,
		131,
		126,
		139,
		144,
		150,
		155,
		173,
		177,
		181,
		170,
		166,
		163,
		177,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		134,
		-1,
		126,
		118,
		108,
		102,
		96,
		110,
		108,
		128,
		120,
		134,
		134,
		140,
		148,
		133,
		136,
		152,
		150,
		168,
		176,
		168,
		162,
		161,
		173,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		147,
		-1,
		111,
		125,
		141,
		-1,
		134,
		113,
		128,
		106,
		120,
		116,
		154,
		155,
		133,
		138,
		146,
		156,
		158,
		147,
		158,
		150,
		172,
		172,
		156,
		157,
		166,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		108,
		96,
		128,
		-1,
		-1,
		170,
		-1,
		104,
		121,
		130,
		128,
		144,
		135,
		141,
		157,
		160,
		162,
		152,
		141,
		147,
		144,
		166,
		152,
		150,
		169,
		185,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		148,
		138,
		122,
		107,
		140,
		-1,
		152,
		136,
		141,
		-1,
		187,
		-1,
		160,
		162,
		156,
		141,
		138,
		149,
		147,
		158,
		175,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		165,
		-1,
		-1,
		135,
		129,
		129,
		113,
		116,
		168,
		148,
		142,
		141,
		182,
		182,
		168,
		154,
		147,
		144,
		141,
		154,
		174,
		165,
		177,
		-1,
		-1,
		-1,
		162,
		148,
		152,
		112,
		131,
		-1,
		-1,
		197,
		152,
		138,
		-1,
		122,
		185,
		173,
		163,
		153,
		187,
		188,
		173,
		166,
		152,
		154,
		152,
		150,
		155,
		176,
		177,
		190,
		-1,
		-1,
		145,
		150,
		138,
		124,
		143,
		-1,
		-1,
		-1,
		144,
		160,
		152,
		123,
		174,
		-1,
		-1,
		165,
		163,
		173,
		169,
		156,
		176,
		179,
		165,
		149,
		164,
		176,
		184,
		189,
		-1,
		148,
		135,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		155,
		176,
		201,
		168,
		-1,
		173,
		174,
		160,
		174,
		181,
		167,
		162,
		156,
		159,
		177,
		194,
		-1,
		-1,
		160,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		134,
		148,
		169,
		175,
		187,
		-1,
		182,
		176,
		162,
		179,
		180,
		177,
		168,
		160,
		165,
		162,
		175,
		189,
		193,
		183,
		-1,
		166,
		-1,
		-1,
		-1,
		152,
		167,
		229,
		206,
		179,
		183,
		176,
		170,
		170,
		186,
		188,
		199,
		167,
		163,
		164,
		168,
		167,
		184,
		194,
		-1,
		-1,
		166,
		183,
		178,
		160,
		164,
		256,
		-1,
		-1,
		192,
		183,
		174,
		177,
		180,
		183,
		173,
		170,
		175,
		180,
		168,
		177,
		195,
		199,
		-1,
		-1,
		-1,
		186,
		-1,
		201,
		-1,
		-1,
		179,
		263,
		210,
		192,
		188,
		186,
		179,
		188,
		183,
		178,
		188,
		197,
		189,
		170,
		181,
		204,
		193,
		231,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		215,
		190,
		205,
		251,
		199,
		206,
		225,
		222,
		-1,
		192,
		217,
		189,
		196,
		188,
		196,
		196,
		193,
		171,
		178,
		194,
		193,
		188,
		223,
		215,
		221,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		221,
		207,
		237,
		227,
		216,
		-1,
		-1,
		241,
		238,
		214,
		198,
		202,
		195,
		190,
		200,
		180,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		193,
		274,
		267,
		250,
		258,
		289,
		-1,
		224,
		233,
		214,
		219,
		227,
		-1,
		-1,
		214,
		211,
		216,
		205,
		202,
		210,
		205,
		196,
		181,
		187,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		207,
		250,
		244,
		247,
		271,
		285,
		-1,
		237,
		-1,
		-1,
		222,
		240,
		229,
		219,
		213,
		263,
		219,
		214,
		204,
		202,
		193,
		184,
		191,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		242,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		238,
		-1,
		256,
		-1,
		231,
		235,
		227,
		230,
		218,
		205,
		197,
		189,
		205,
		180,
		190,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		316,
		271,
		238,
		229,
		276,
		291,
		295,
		-1,
		250,
		289,
		276,
		-1,
		247,
		-1,
		-1,
		-1,
		245,
		240,
		232,
		238,
		217,
		217,
		191,
		195,
		185,
		192,
		202,
		204,
		196,
		200,
		213,
		224,
		227,
		312,
		310,
		315,
		260,
		243,
		261,
		270,
		291,
		265,
		256,
		283,
		283,
		272,
		267,
		254,
		-1,
		-1,
		268,
		250,
		-1,
		-1,
		224,
		212,
		195,
		196,
		192,
		195,
		210,
		213,
		203,
		201,
		195,
		227,
		-1,
		312,
		311,
		300,
		297,
		273,
		264,
		251,
		262,
		-1,
		-1,
		268,
		284,
		297,
		301,
		314,
		339,
		-1,
		257,
		-1,
		-1,
		269,
		-1,
		-1,
		254,
		217,
		206,
		197,
		203,
		200,
		211,
		221,
		209,
		210,
		200,
		210,
		223,
		296,
		293,
		281,
		279,
		302,
		259,
		255,
		-1,
		278,
		271,
		277,
		284,
		301,
		328,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		252,
		250,
		239,
		-1,
		229,
		202,
		207,
		227,
		229,
		218,
		212,
		206,
		213,
		212,
		220,
		228,
		305,
		319,
		308,
		304,
		303,
		311,
		260,
		263,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		-1,
		290,
		283,
		-1,
		-1,
		247,
		240,
		228,
		216,
		206,
		216,
		220,
		224,
		216,
		209,
		204,
		215,
		207,
		211,
		228,
		-1,
		339,
		-1,
		291,
		277,
		291,
		306,
		314,
		-1,
		-1,
		-1,
		307,
		293,
		286,
		274,
		272,
		-1,
		281,
		265,
		246,
		-1,
		216,
		229,
		260,
		228,
		233,
		228,
		210,
		221,
		210,
		213,
		227,
		222,
		-1,
		-1,
		289,
		292,
		-1,
		-1,
		297,
		299,
		-1,
		298,
		287,
		272,
		264,
		-1,
		-1,
		253,
		249,
		-1,
		-1,
		217,
		242,
		231,
		239,
		234,
		214,
		220,
		223,
		212,
		216,
		228,
		-1,
		-1,
		296,
		297,
		302,
		-1,
		282,
		-1,
		300,
		-1,
		267,
		273,
		261,
		-1,
		-1,
		-1,
		255,
		218,
		239,
		249,
		243,
		241,
		232,
		218,
		225,
		223,
		219,
		230,
		-1,
		-1,
		-1,
		300,
		274,
		307,
		298,
		281,
		261,
		253,
		272,
		-1,
		242,
		-1,
		217,
		219,
		245,
		248,
		254,
		248,
		221,
		236,
		226,
		217,
		226,
		306,
		-1,
		276,
		309,
		273,
		267,
		243,
		247,
		263,
		-1,
		239,
		221,
		-1,
		249,
		239,
		270,
		255,
		236,
		223,
		230,
		230,
		223,
		-1,
		-1,
		-1,
		278,
		277,
		269,
		263,
		263,
		248,
		239,
		-1,
		251,
		233,
		212,
		229,
		229,
		220,
		228,
		260,
		256,
		243,
		243,
		235,
		-1,
		379,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		272,
		267,
		240,
		228,
		234,
		230,
		216,
		222,
		224,
		232,
		230,
		227,
		239,
		235,
		255,
		236,
		271,
		-1,
		374,
		-1,
		308,
		-1,
		-1,
		290,
		270,
		262,
		251,
		240,
		238,
		229,
		220,
		242,
		258,
		242,
		240,
		243,
		244,
		-1,
		363,
		362,
		-1,
		309,
		301,
		287,
		-1,
		280,
		-1,
		286,
		247,
		-1,
		249,
		229,
		-1,
		251,
		247,
		-1,
		-1,
		350,
		325,
		-1,
		-1,
		-1,
		310,
		290,
		281,
		265,
		-1,
		240,
		240,
		-1,
		-1,
		-1,
		335,
		334,
		-1,
		303,
		306,
		-1,
		296,
		287,
		295,
		242,
		246,
		-1,
		-1,
		-1,
		344,
		325,
		319,
		318,
		316,
		311,
		308,
		294,
		278,
		256,
		245,
		266,
		-1,
		-1,
		-1,
		316,
		308,
		301,
		-1,
		-1,
		303,
		286,
		267,
		265,
		-1,
		-1,
		-1,
		338,
		319,
		-1,
		-1,
		293,
		-1,
		-1,
		299,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		355,
		327,
		-1,
		-1,
		-1,
		289,
		285,
		286,
		-1,
		-1,
		-1,
		-1,
		349,
		350,
		373,
		337,
		-1,
		-1,
		-1,
		281,
		275,
		-1,
		-1,
		352,
		350,
		-1,
		-1,
		-1,
		309,
		293,
		-1,
		279,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		314,
		-1,
		314,
		289,
		296,
		-1,
		-1,
		-1,
		-1,
		327,
		319,
		327,
		-1,
		299,
		301,
		-1,
		349,
		-1,
		-1,
		342,
		333,
		-1,
		-1,
		304,
		311,
		333,
		336,
		372,
		-1,
		323
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		153,
		142,
		153,
		161,
		134,
		141,
		-1,
		162,
		164,
		130,
		124,
		163,
		134,
		140,
		151,
		-1,
		-1,
		-1,
		153,
		152,
		122,
		120,
		129,
		134,
		141,
		-1,
		164,
		-1,
		174,
		153,
		164,
		169,
		115,
		112,
		132,
		151,
		157,
		149,
		189,
		145,
		116,
		110,
		128,
		133,
		151,
		143,
		-1,
		116,
		106,
		128,
		132,
		144,
		127,
		-1,
		-1,
		110,
		111,
		117,
		129,
		134,
		139,
		-1,
		165,
		181,
		-1,
		-1,
		100,
		113,
		109,
		112,
		120,
		136,
		157,
		174,
		176,
		-1,
		-1,
		101,
		105,
		118,
		119,
		117,
		144,
		163,
		171,
		185,
		184,
		-1,
		89,
		107,
		116,
		125,
		131,
		120,
		124,
		142,
		170,
		176,
		179,
		-1,
		81,
		83,
		108,
		116,
		121,
		128,
		123,
		129,
		148,
		158,
		177,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		78,
		86,
		108,
		100,
		96,
		109,
		126,
		126,
		132,
		136,
		150,
		166,
		167,
		177,
		-1,
		-1,
		161,
		134,
		158,
		116,
		104,
		-1,
		74,
		84,
		89,
		93,
		94,
		96,
		123,
		121,
		-1,
		144,
		143,
		174,
		160,
		171,
		143,
		-1,
		-1,
		119,
		111,
		93,
		96,
		73,
		69,
		81,
		80,
		78,
		74,
		70,
		99,
		111,
		109,
		119,
		138,
		148,
		152,
		167,
		178,
		-1,
		-1,
		241,
		-1,
		-1,
		140,
		123,
		-1,
		88,
		95,
		79,
		85,
		71,
		64,
		91,
		67,
		66,
		85,
		73,
		93,
		103,
		126,
		123,
		135,
		160,
		164,
		166,
		187,
		182,
		-1,
		240,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		95,
		92,
		85,
		109,
		81,
		-1,
		26,
		32,
		56,
		59,
		71,
		84,
		79,
		109,
		109,
		124,
		126,
		142,
		144,
		177,
		163,
		185,
		182,
		211,
		216,
		210,
		219,
		-1,
		148,
		144,
		140,
		147,
		96,
		-1,
		-1,
		112,
		-1,
		70,
		43,
		18,
		36,
		39,
		60,
		60,
		91,
		85,
		103,
		112,
		115,
		135,
		148,
		155,
		158,
		157,
		175,
		190,
		203,
		207,
		213,
		-1,
		198,
		-1,
		140,
		124,
		126,
		102,
		130,
		-1,
		124,
		69,
		35,
		20,
		11,
		-1,
		64,
		61,
		75,
		82,
		87,
		104,
		119,
		123,
		134,
		147,
		161,
		152,
		170,
		177,
		185,
		189,
		209,
		221,
		158,
		148,
		-1,
		130,
		135,
		105,
		117,
		140,
		73,
		37,
		-1,
		0,
		-1,
		66,
		79,
		-1,
		81,
		85,
		93,
		109,
		123,
		136,
		141,
		143,
		140,
		158,
		161,
		178,
		182,
		198,
		-1,
		-1,
		143,
		147,
		155,
		106,
		125,
		115,
		83,
		30,
		19,
		18,
		-1,
		78,
		112,
		109,
		110,
		113,
		106,
		107,
		129,
		142,
		123,
		142,
		145,
		167,
		195,
		173,
		185,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		132,
		103,
		127,
		97,
		48,
		41,
		29,
		46,
		46,
		53,
		-1,
		134,
		118,
		120,
		111,
		118,
		131,
		126,
		142,
		146,
		145,
		164,
		176,
		167,
		187,
		-1,
		-1,
		-1,
		162,
		151,
		152,
		106,
		139,
		158,
		79,
		65,
		70,
		45,
		51,
		56,
		121,
		130,
		118,
		127,
		119,
		108,
		122,
		130,
		134,
		143,
		152,
		158,
		182,
		182,
		188,
		-1,
		-1,
		169,
		159,
		143,
		145,
		142,
		130,
		137,
		169,
		70,
		154,
		-1,
		89,
		-1,
		62,
		96,
		104,
		110,
		122,
		108,
		113,
		124,
		136,
		149,
		145,
		152,
		187,
		187,
		172,
		192,
		195,
		-1,
		-1,
		-1,
		162,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		83,
		77,
		93,
		101,
		108,
		105,
		105,
		119,
		127,
		123,
		139,
		145,
		137,
		173,
		-1,
		180,
		174,
		182,
		172,
		160,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		80,
		89,
		96,
		105,
		110,
		115,
		123,
		118,
		131,
		136,
		142,
		147,
		165,
		169,
		173,
		162,
		158,
		155,
		169,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		102,
		100,
		120,
		112,
		126,
		126,
		132,
		140,
		125,
		128,
		144,
		142,
		160,
		168,
		160,
		154,
		153,
		165,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		112,
		108,
		146,
		147,
		125,
		130,
		138,
		148,
		150,
		139,
		150,
		142,
		164,
		164,
		148,
		149,
		158,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		122,
		120,
		136,
		127,
		133,
		149,
		152,
		154,
		144,
		133,
		139,
		136,
		158,
		144,
		142,
		161,
		177,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		144,
		128,
		133,
		-1,
		179,
		-1,
		152,
		154,
		148,
		133,
		130,
		141,
		139,
		150,
		167,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		160,
		140,
		134,
		133,
		174,
		174,
		160,
		146,
		139,
		136,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		177,
		165,
		155,
		145,
		179,
		180,
		165,
		158,
		144,
		146,
		144,
		142,
		147,
		168,
		169,
		182,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		166,
		-1,
		-1,
		157,
		155,
		165,
		161,
		148,
		168,
		171,
		157,
		141,
		156,
		168,
		176,
		181,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		169,
		135,
		147,
		168,
		193,
		160,
		-1,
		165,
		166,
		152,
		166,
		173,
		159,
		154,
		148,
		151,
		169,
		186,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		126,
		140,
		161,
		167,
		179,
		-1,
		174,
		168,
		154,
		171,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		175,
		-1,
		158,
		-1,
		-1,
		-1,
		144,
		159,
		221,
		198,
		171,
		175,
		168,
		162,
		162,
		178,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		158,
		175,
		170,
		152,
		156,
		248,
		-1,
		-1,
		184,
		175,
		166,
		169,
		172,
		175,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		191,
		-1,
		-1,
		-1,
		178,
		-1,
		193,
		-1,
		-1,
		171,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		189,
		181,
		162,
		173,
		196,
		185,
		223,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		207,
		182,
		197,
		243,
		191,
		198,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		180,
		188,
		188,
		185,
		163,
		170,
		186,
		185,
		180,
		215,
		207,
		213,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		213,
		199,
		229,
		219,
		208,
		-1,
		-1,
		233,
		230,
		206,
		190,
		194,
		187,
		182,
		192,
		172,
		159,
		163,
		167,
		173,
		178,
		183,
		189,
		204,
		219,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		216,
		225,
		206,
		211,
		219,
		-1,
		-1,
		206,
		203,
		208,
		197,
		194,
		202,
		197,
		188,
		173,
		179,
		166,
		165,
		183,
		187,
		196,
		203,
		193,
		206,
		210,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		229,
		-1,
		-1,
		214,
		232,
		221,
		211,
		205,
		255,
		211,
		206,
		196,
		194,
		185,
		176,
		183,
		174,
		174,
		177,
		192,
		197,
		189,
		203,
		203,
		204,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		230,
		-1,
		248,
		-1,
		223,
		227,
		219,
		222,
		210,
		197,
		189,
		181,
		197,
		172,
		182,
		178,
		179,
		188,
		199,
		211,
		210,
		211,
		308,
		263,
		230,
		221,
		268,
		283,
		287,
		-1,
		242,
		281,
		268,
		-1,
		239,
		-1,
		-1,
		-1,
		237,
		232,
		224,
		230,
		209,
		209,
		183,
		187,
		177,
		184,
		194,
		196,
		188,
		192,
		205,
		216,
		219,
		304,
		302,
		307,
		252,
		235,
		253,
		262,
		283,
		257,
		248,
		275,
		275,
		264,
		259,
		246,
		-1,
		-1,
		260,
		242,
		-1,
		-1,
		216,
		204,
		187,
		188,
		184,
		187,
		202,
		205,
		195,
		193,
		187,
		219,
		-1,
		304,
		303,
		292,
		289,
		265,
		256,
		243,
		254,
		-1,
		-1,
		260,
		276,
		289,
		293,
		306,
		331,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		246,
		209,
		198,
		189,
		195,
		192,
		203,
		213,
		201,
		202,
		192,
		202,
		215,
		288,
		285,
		273,
		271,
		294,
		251,
		247,
		-1,
		270,
		263,
		269,
		276,
		293,
		320,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		244,
		242,
		231,
		-1,
		221,
		194,
		199,
		219,
		221,
		210,
		204,
		198,
		205,
		204,
		212,
		220,
		297,
		311,
		300,
		296,
		295,
		303,
		252,
		255,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		-1,
		282,
		275,
		-1,
		-1,
		239,
		232,
		220,
		208,
		198,
		208,
		212,
		216,
		208,
		201,
		196,
		207,
		199,
		203,
		220,
		-1,
		331,
		-1,
		283,
		269,
		283,
		298,
		306,
		-1,
		-1,
		-1,
		299,
		285,
		278,
		266,
		264,
		-1,
		273,
		257,
		238,
		-1,
		208,
		221,
		252,
		220,
		225,
		220,
		202,
		213,
		202,
		205,
		219,
		214,
		-1,
		-1,
		281,
		284,
		-1,
		-1,
		289,
		291,
		-1,
		290,
		279,
		264,
		256,
		-1,
		-1,
		245,
		241,
		-1,
		-1,
		209,
		234,
		223,
		231,
		226,
		206,
		212,
		215,
		204,
		208,
		220,
		-1,
		-1,
		288,
		289,
		294,
		-1,
		274,
		-1,
		292,
		-1,
		259,
		265,
		253,
		-1,
		-1,
		-1,
		247,
		210,
		231,
		241,
		235,
		233,
		224,
		210,
		217,
		215,
		211,
		222,
		-1,
		-1,
		-1,
		292,
		266,
		299,
		290,
		273,
		253,
		245,
		264,
		-1,
		234,
		-1,
		209,
		211,
		237,
		240,
		246,
		240,
		213,
		228,
		218,
		209,
		218,
		298,
		-1,
		268,
		301,
		265,
		259,
		235,
		239,
		255,
		-1,
		231,
		213,
		-1,
		241,
		231,
		262,
		247,
		228,
		215,
		222,
		222,
		215,
		-1,
		-1,
		-1,
		270,
		269,
		261,
		255,
		255,
		240,
		231,
		-1,
		243,
		225,
		204,
		221,
		221,
		212,
		220,
		252,
		248,
		235,
		235,
		227,
		-1,
		371,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		264,
		259,
		232,
		220,
		226,
		222,
		208,
		214,
		216,
		224,
		222,
		219,
		231,
		227,
		247,
		228,
		263,
		-1,
		366,
		-1,
		300,
		-1,
		-1,
		282,
		262,
		254,
		243,
		232,
		230,
		221,
		212,
		234,
		250,
		234,
		232,
		235,
		236,
		-1,
		355,
		354,
		-1,
		301,
		293,
		279,
		-1,
		272,
		-1,
		278,
		239,
		-1,
		241,
		221,
		-1,
		243,
		239,
		-1,
		-1,
		342,
		317,
		-1,
		-1,
		-1,
		302,
		282,
		273,
		257,
		-1,
		232,
		232,
		-1,
		-1,
		-1,
		327,
		326,
		-1,
		295,
		298,
		-1,
		288,
		279,
		287,
		234,
		238,
		-1,
		-1,
		-1,
		336,
		317,
		311,
		310,
		308,
		303,
		300,
		286,
		270,
		248,
		237,
		258,
		-1,
		-1,
		-1,
		308,
		300,
		293,
		-1,
		-1,
		295,
		278,
		259,
		257,
		-1,
		-1,
		-1,
		330,
		311,
		-1,
		-1,
		285,
		-1,
		-1,
		291,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		347,
		319,
		-1,
		-1,
		-1,
		281,
		277,
		278,
		-1,
		-1,
		-1,
		-1,
		341,
		342,
		365,
		329,
		-1,
		-1,
		-1,
		273,
		267,
		-1,
		-1,
		344,
		342,
		-1,
		-1,
		-1,
		301,
		285,
		-1,
		271,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		306,
		-1,
		306,
		281,
		288,
		-1,
		-1,
		-1,
		-1,
		319,
		311,
		319,
		-1,
		291,
		293,
		-1,
		341,
		-1,
		-1,
		334,
		325,
		-1,
		-1,
		296,
		303,
		325,
		328,
		364,
		-1,
		315
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		141,
		130,
		141,
		149,
		122,
		129,
		-1,
		150,
		152,
		118,
		112,
		151,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		141,
		140,
		110,
		108,
		117,
		122,
		129,
		-1,
		152,
		-1,
		162,
		141,
		152,
		157,
		103,
		100,
		120,
		139,
		145,
		137,
		177,
		133,
		104,
		98,
		116,
		121,
		139,
		131,
		-1,
		104,
		94,
		116,
		120,
		132,
		115,
		-1,
		-1,
		98,
		99,
		105,
		117,
		122,
		127,
		-1,
		153,
		152,
		-1,
		-1,
		88,
		101,
		97,
		100,
		108,
		124,
		145,
		152,
		147,
		-1,
		-1,
		89,
		93,
		106,
		107,
		105,
		132,
		151,
		142,
		156,
		155,
		-1,
		77,
		95,
		104,
		113,
		119,
		108,
		112,
		130,
		141,
		147,
		150,
		-1,
		86,
		87,
		86,
		94,
		99,
		106,
		111,
		117,
		136,
		129,
		148,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		85,
		69,
		86,
		78,
		74,
		87,
		104,
		112,
		120,
		124,
		121,
		137,
		138,
		148,
		-1,
		-1,
		179,
		152,
		176,
		134,
		110,
		-1,
		81,
		62,
		67,
		71,
		72,
		74,
		101,
		99,
		-1,
		115,
		114,
		145,
		131,
		142,
		161,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		59,
		58,
		54,
		52,
		48,
		77,
		89,
		87,
		97,
		109,
		119,
		123,
		138,
		149,
		-1,
		-1,
		213,
		-1,
		-1,
		158,
		141,
		-1,
		106,
		113,
		97,
		103,
		89,
		83,
		69,
		45,
		42,
		63,
		51,
		71,
		81,
		103,
		94,
		106,
		131,
		135,
		138,
		159,
		154,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		113,
		110,
		103,
		127,
		126,
		-1,
		53,
		41,
		38,
		32,
		42,
		55,
		57,
		78,
		82,
		95,
		97,
		113,
		115,
		148,
		135,
		157,
		154,
		183,
		188,
		182,
		191,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		131,
		-1,
		122,
		90,
		65,
		38,
		41,
		33,
		24,
		62,
		63,
		72,
		85,
		86,
		106,
		119,
		126,
		130,
		129,
		147,
		162,
		175,
		179,
		185,
		-1,
		216,
		-1,
		158,
		142,
		144,
		120,
		148,
		-1,
		151,
		123,
		82,
		67,
		67,
		-1,
		10,
		13,
		39,
		46,
		57,
		74,
		90,
		94,
		105,
		119,
		133,
		124,
		142,
		149,
		157,
		161,
		181,
		193,
		176,
		166,
		-1,
		148,
		153,
		123,
		135,
		154,
		136,
		100,
		-1,
		78,
		-1,
		0,
		25,
		-1,
		45,
		49,
		63,
		79,
		93,
		106,
		112,
		115,
		112,
		130,
		133,
		150,
		154,
		170,
		-1,
		-1,
		161,
		165,
		169,
		120,
		139,
		163,
		146,
		93,
		82,
		81,
		-1,
		18,
		76,
		73,
		74,
		81,
		76,
		77,
		99,
		113,
		95,
		114,
		117,
		139,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		146,
		117,
		141,
		160,
		111,
		104,
		92,
		57,
		55,
		42,
		-1,
		98,
		82,
		90,
		81,
		89,
		102,
		100,
		114,
		118,
		117,
		136,
		148,
		139,
		159,
		-1,
		-1,
		-1,
		176,
		165,
		166,
		112,
		135,
		172,
		90,
		76,
		81,
		56,
		44,
		52,
		85,
		94,
		103,
		99,
		91,
		80,
		96,
		104,
		106,
		115,
		124,
		130,
		154,
		161,
		167,
		-1,
		-1,
		183,
		173,
		157,
		159,
		156,
		126,
		133,
		165,
		81,
		150,
		-1,
		85,
		-1,
		58,
		92,
		100,
		99,
		96,
		93,
		87,
		96,
		110,
		121,
		117,
		124,
		159,
		159,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		176,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		79,
		73,
		89,
		97,
		102,
		97,
		101,
		94,
		101,
		97,
		111,
		122,
		109,
		145,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		76,
		85,
		92,
		101,
		98,
		102,
		106,
		95,
		108,
		113,
		114,
		124,
		144,
		148,
		152,
		141,
		137,
		134,
		148,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		98,
		96,
		116,
		108,
		113,
		113,
		109,
		117,
		102,
		105,
		117,
		121,
		139,
		147,
		139,
		133,
		132,
		144,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		108,
		104,
		133,
		134,
		112,
		117,
		116,
		126,
		127,
		116,
		129,
		121,
		143,
		143,
		127,
		128,
		137,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		118,
		116,
		123,
		114,
		120,
		127,
		130,
		131,
		121,
		110,
		116,
		115,
		137,
		123,
		121,
		140,
		156,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		131,
		115,
		120,
		-1,
		156,
		-1,
		129,
		131,
		123,
		112,
		109,
		120,
		118,
		129,
		146,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		147,
		127,
		121,
		120,
		151,
		149,
		137,
		121,
		114,
		111,
		112,
		125,
		145,
		136,
		148,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		164,
		152,
		142,
		132,
		166,
		165,
		140,
		133,
		119,
		121,
		119,
		121,
		126,
		147,
		148,
		161,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		140,
		111,
		153,
		-1,
		-1,
		144,
		142,
		152,
		136,
		123,
		143,
		146,
		136,
		120,
		135,
		147,
		155,
		160,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		143,
		164,
		181,
		147,
		-1,
		152,
		147,
		127,
		141,
		148,
		138,
		133,
		127,
		130,
		148,
		165,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		122,
		136,
		157,
		163,
		167,
		-1,
		155,
		143,
		129,
		146,
		151,
		148,
		139,
		131,
		136,
		133,
		146,
		160,
		164,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		140,
		155,
		209,
		186,
		159,
		154,
		147,
		141,
		137,
		153,
		159,
		170,
		138,
		134,
		135,
		139,
		138,
		155,
		165,
		-1,
		-1,
		154,
		171,
		166,
		148,
		152,
		236,
		-1,
		-1,
		163,
		154,
		145,
		148,
		147,
		150,
		144,
		141,
		146,
		151,
		139,
		148,
		166,
		165,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		167,
		234,
		181,
		163,
		159,
		157,
		150,
		159,
		154,
		149,
		159,
		161,
		153,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		239,
		187,
		194,
		196,
		193,
		-1,
		163,
		188,
		160,
		167,
		158,
		165,
		165,
		157,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		209,
		195,
		225,
		215,
		204,
		-1,
		-1,
		212,
		209,
		185,
		168,
		166,
		159,
		154,
		164,
		144,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		181,
		262,
		255,
		238,
		246,
		277,
		-1,
		212,
		221,
		202,
		207,
		215,
		-1,
		-1,
		185,
		182,
		187,
		175,
		172,
		174,
		169,
		160,
		145,
		151,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		195,
		238,
		232,
		235,
		259,
		273,
		-1,
		225,
		-1,
		-1,
		210,
		216,
		200,
		190,
		184,
		234,
		189,
		184,
		168,
		166,
		157,
		148,
		155,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		230,
		218,
		226,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		226,
		-1,
		227,
		-1,
		202,
		206,
		197,
		200,
		182,
		169,
		161,
		153,
		169,
		144,
		154,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		303,
		259,
		226,
		217,
		264,
		279,
		283,
		-1,
		238,
		277,
		264,
		-1,
		235,
		-1,
		-1,
		-1,
		216,
		210,
		202,
		202,
		181,
		181,
		155,
		159,
		149,
		156,
		166,
		168,
		160,
		164,
		177,
		188,
		191,
		299,
		290,
		303,
		248,
		231,
		249,
		258,
		279,
		253,
		244,
		271,
		271,
		260,
		255,
		242,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		188,
		176,
		159,
		160,
		156,
		159,
		174,
		177,
		167,
		165,
		159,
		191,
		-1,
		292,
		291,
		280,
		277,
		253,
		244,
		239,
		250,
		-1,
		-1,
		256,
		272,
		272,
		276,
		292,
		317,
		-1,
		245,
		-1,
		-1,
		233,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		164,
		175,
		185,
		173,
		174,
		164,
		174,
		187,
		276,
		273,
		261,
		259,
		282,
		247,
		235,
		-1,
		248,
		246,
		252,
		259,
		276,
		306,
		-1,
		-1,
		261,
		244,
		-1,
		-1,
		216,
		214,
		203,
		-1,
		193,
		166,
		171,
		191,
		193,
		182,
		176,
		170,
		177,
		176,
		184,
		192,
		285,
		299,
		288,
		284,
		283,
		291,
		240,
		233,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		254,
		250,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		184,
		188,
		180,
		173,
		168,
		179,
		171,
		175,
		192,
		-1,
		319,
		-1,
		271,
		247,
		261,
		276,
		284,
		-1,
		-1,
		-1,
		271,
		257,
		250,
		238,
		236,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		174,
		185,
		174,
		177,
		191,
		186,
		-1,
		-1,
		259,
		262,
		-1,
		-1,
		261,
		263,
		-1,
		262,
		251,
		236,
		228,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		178,
		184,
		187,
		176,
		180,
		192,
		-1,
		-1,
		266,
		267,
		268,
		-1,
		246,
		-1,
		264,
		-1,
		231,
		237,
		225,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		207,
		205,
		196,
		182,
		189,
		187,
		183,
		194,
		-1,
		-1,
		-1,
		264,
		238,
		271,
		262,
		245,
		225,
		217,
		236,
		-1,
		206,
		-1,
		181,
		183,
		209,
		212,
		218,
		212,
		185,
		200,
		190,
		181,
		190,
		270,
		-1,
		240,
		273,
		237,
		231,
		207,
		211,
		227,
		-1,
		203,
		185,
		-1,
		213,
		203,
		234,
		219,
		200,
		187,
		194,
		194,
		187,
		-1,
		-1,
		-1,
		242,
		241,
		233,
		227,
		227,
		212,
		203,
		-1,
		215,
		197,
		176,
		193,
		193,
		184,
		192,
		224,
		220,
		207,
		207,
		199,
		-1,
		343,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		236,
		231,
		204,
		192,
		198,
		194,
		180,
		186,
		188,
		196,
		194,
		191,
		203,
		199,
		219,
		200,
		235,
		-1,
		338,
		-1,
		272,
		-1,
		-1,
		254,
		234,
		226,
		215,
		204,
		202,
		193,
		184,
		206,
		222,
		206,
		204,
		207,
		208,
		-1,
		327,
		326,
		-1,
		273,
		265,
		251,
		-1,
		244,
		-1,
		250,
		211,
		-1,
		213,
		193,
		-1,
		215,
		211,
		-1,
		-1,
		314,
		289,
		-1,
		-1,
		-1,
		274,
		254,
		245,
		229,
		-1,
		204,
		204,
		-1,
		-1,
		-1,
		299,
		298,
		-1,
		267,
		270,
		-1,
		260,
		251,
		259,
		206,
		210,
		-1,
		-1,
		-1,
		308,
		289,
		283,
		282,
		280,
		275,
		272,
		258,
		242,
		220,
		209,
		230,
		-1,
		-1,
		-1,
		280,
		272,
		265,
		-1,
		-1,
		267,
		250,
		231,
		229,
		-1,
		-1,
		-1,
		302,
		283,
		-1,
		-1,
		257,
		-1,
		-1,
		263,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		291,
		-1,
		-1,
		-1,
		253,
		249,
		250,
		-1,
		-1,
		-1,
		-1,
		313,
		314,
		337,
		301,
		-1,
		-1,
		-1,
		245,
		239,
		-1,
		-1,
		316,
		314,
		-1,
		-1,
		-1,
		273,
		257,
		-1,
		243,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		278,
		-1,
		278,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		291,
		283,
		291,
		-1,
		263,
		265,
		-1,
		313,
		-1,
		-1,
		306,
		297,
		-1,
		-1,
		268,
		275,
		297,
		300,
		336,
		-1,
		287
	],
	[
		-1,
		150,
		139,
		150,
		158,
		131,
		138,
		-1,
		159,
		161,
		127,
		121,
		160,
		131,
		137,
		148,
		-1,
		-1,
		-1,
		150,
		149,
		119,
		117,
		126,
		131,
		138,
		-1,
		161,
		-1,
		171,
		150,
		161,
		166,
		112,
		109,
		129,
		148,
		154,
		146,
		186,
		142,
		113,
		107,
		125,
		130,
		148,
		140,
		-1,
		113,
		103,
		125,
		129,
		141,
		124,
		-1,
		-1,
		107,
		108,
		114,
		126,
		131,
		136,
		-1,
		162,
		161,
		-1,
		-1,
		97,
		110,
		106,
		109,
		117,
		133,
		154,
		161,
		156,
		-1,
		-1,
		98,
		102,
		115,
		116,
		114,
		141,
		160,
		151,
		165,
		164,
		-1,
		86,
		104,
		113,
		122,
		128,
		117,
		121,
		139,
		150,
		156,
		159,
		-1,
		95,
		96,
		95,
		103,
		108,
		115,
		120,
		126,
		145,
		138,
		157,
		148,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		94,
		78,
		95,
		87,
		83,
		96,
		113,
		121,
		129,
		133,
		130,
		146,
		147,
		157,
		-1,
		-1,
		188,
		161,
		185,
		143,
		119,
		-1,
		90,
		71,
		76,
		80,
		81,
		83,
		110,
		108,
		-1,
		124,
		123,
		154,
		140,
		151,
		170,
		-1,
		-1,
		146,
		138,
		120,
		123,
		100,
		96,
		68,
		67,
		63,
		61,
		57,
		86,
		98,
		96,
		106,
		118,
		128,
		132,
		147,
		158,
		-1,
		-1,
		222,
		-1,
		-1,
		167,
		150,
		-1,
		115,
		122,
		106,
		112,
		98,
		92,
		78,
		54,
		51,
		72,
		60,
		80,
		90,
		112,
		103,
		115,
		140,
		144,
		147,
		168,
		163,
		-1,
		221,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		122,
		119,
		112,
		136,
		135,
		-1,
		62,
		50,
		47,
		41,
		51,
		64,
		66,
		87,
		91,
		104,
		106,
		122,
		124,
		157,
		144,
		166,
		163,
		192,
		197,
		191,
		200,
		-1,
		175,
		171,
		167,
		174,
		123,
		-1,
		-1,
		140,
		-1,
		131,
		99,
		74,
		47,
		50,
		42,
		33,
		71,
		72,
		81,
		94,
		95,
		115,
		128,
		135,
		139,
		138,
		156,
		171,
		184,
		188,
		194,
		-1,
		225,
		-1,
		167,
		151,
		153,
		129,
		157,
		-1,
		160,
		132,
		91,
		76,
		76,
		-1,
		19,
		22,
		48,
		55,
		66,
		83,
		99,
		103,
		114,
		128,
		142,
		133,
		151,
		158,
		166,
		170,
		190,
		202,
		185,
		175,
		-1,
		157,
		162,
		132,
		144,
		167,
		148,
		112,
		-1,
		87,
		-1,
		21,
		0,
		-1,
		54,
		58,
		72,
		88,
		102,
		115,
		121,
		124,
		121,
		139,
		142,
		159,
		163,
		179,
		-1,
		-1,
		170,
		174,
		182,
		133,
		152,
		176,
		158,
		105,
		94,
		93,
		-1,
		39,
		85,
		82,
		83,
		90,
		85,
		86,
		108,
		122,
		104,
		123,
		126,
		148,
		176,
		154,
		166,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		159,
		130,
		154,
		172,
		123,
		116,
		104,
		78,
		76,
		63,
		-1,
		107,
		91,
		99,
		90,
		98,
		111,
		109,
		123,
		127,
		126,
		145,
		157,
		148,
		168,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		133,
		156,
		185,
		111,
		97,
		102,
		77,
		65,
		73,
		94,
		103,
		112,
		108,
		100,
		89,
		105,
		113,
		115,
		124,
		133,
		139,
		163,
		170,
		176,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		147,
		154,
		186,
		102,
		171,
		-1,
		106,
		-1,
		79,
		113,
		113,
		108,
		105,
		102,
		96,
		105,
		119,
		130,
		126,
		133,
		168,
		168,
		160,
		180,
		183,
		-1,
		-1,
		-1,
		189,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		100,
		94,
		110,
		115,
		111,
		106,
		110,
		103,
		110,
		106,
		120,
		131,
		118,
		154,
		-1,
		168,
		162,
		170,
		160,
		148,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		97,
		106,
		113,
		113,
		107,
		111,
		115,
		104,
		117,
		122,
		123,
		133,
		153,
		157,
		161,
		150,
		146,
		143,
		157,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		119,
		117,
		135,
		119,
		122,
		122,
		118,
		126,
		111,
		114,
		126,
		130,
		148,
		156,
		148,
		142,
		141,
		153,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		129,
		125,
		142,
		143,
		121,
		126,
		125,
		135,
		136,
		125,
		138,
		130,
		152,
		152,
		136,
		137,
		146,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		179,
		-1,
		113,
		130,
		139,
		137,
		132,
		123,
		129,
		136,
		139,
		140,
		130,
		119,
		125,
		124,
		146,
		132,
		130,
		149,
		165,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		157,
		147,
		131,
		116,
		149,
		-1,
		140,
		124,
		129,
		-1,
		165,
		-1,
		138,
		140,
		132,
		121,
		118,
		129,
		127,
		138,
		155,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		144,
		138,
		138,
		122,
		125,
		156,
		136,
		130,
		129,
		160,
		158,
		146,
		130,
		123,
		120,
		121,
		134,
		154,
		145,
		157,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		206,
		161,
		147,
		-1,
		131,
		173,
		161,
		151,
		141,
		175,
		174,
		149,
		142,
		128,
		130,
		128,
		130,
		135,
		156,
		157,
		170,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		153,
		169,
		161,
		132,
		162,
		-1,
		-1,
		153,
		151,
		161,
		145,
		132,
		152,
		155,
		145,
		129,
		144,
		156,
		164,
		169,
		-1,
		157,
		144,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		164,
		185,
		190,
		156,
		-1,
		161,
		156,
		136,
		150,
		157,
		147,
		142,
		136,
		139,
		157,
		174,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		143,
		157,
		178,
		172,
		176,
		-1,
		164,
		152,
		138,
		155,
		160,
		157,
		148,
		140,
		145,
		142,
		155,
		169,
		173,
		192,
		-1,
		175,
		-1,
		-1,
		-1,
		161,
		176,
		218,
		195,
		168,
		163,
		156,
		150,
		146,
		162,
		168,
		179,
		147,
		143,
		144,
		148,
		147,
		164,
		174,
		-1,
		-1,
		175,
		192,
		187,
		169,
		173,
		245,
		-1,
		-1,
		172,
		163,
		154,
		157,
		156,
		159,
		153,
		150,
		155,
		160,
		148,
		157,
		175,
		174,
		-1,
		-1,
		-1,
		195,
		-1,
		210,
		-1,
		-1,
		188,
		243,
		190,
		172,
		168,
		166,
		159,
		168,
		163,
		158,
		168,
		170,
		162,
		150,
		154,
		177,
		166,
		205,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		224,
		199,
		214,
		254,
		208,
		215,
		205,
		202,
		-1,
		172,
		197,
		169,
		176,
		167,
		174,
		174,
		166,
		144,
		151,
		167,
		166,
		161,
		197,
		188,
		194,
		-1,
		-1,
		307,
		296,
		285,
		291,
		-1,
		230,
		216,
		240,
		230,
		225,
		-1,
		-1,
		221,
		218,
		194,
		177,
		175,
		168,
		163,
		173,
		153,
		140,
		144,
		148,
		154,
		159,
		164,
		170,
		185,
		200,
		-1,
		202,
		283,
		276,
		259,
		267,
		298,
		-1,
		233,
		236,
		223,
		222,
		224,
		-1,
		-1,
		194,
		191,
		196,
		184,
		181,
		183,
		178,
		169,
		154,
		160,
		147,
		146,
		164,
		168,
		177,
		184,
		174,
		187,
		191,
		-1,
		216,
		259,
		253,
		256,
		280,
		294,
		-1,
		241,
		-1,
		-1,
		231,
		225,
		209,
		199,
		193,
		243,
		198,
		193,
		177,
		175,
		166,
		157,
		164,
		155,
		155,
		158,
		173,
		178,
		170,
		184,
		184,
		185,
		-1,
		251,
		239,
		247,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		247,
		-1,
		236,
		-1,
		211,
		215,
		206,
		209,
		191,
		178,
		170,
		162,
		178,
		153,
		163,
		159,
		160,
		169,
		180,
		192,
		191,
		192,
		312,
		268,
		247,
		238,
		285,
		300,
		304,
		-1,
		253,
		292,
		285,
		-1,
		256,
		-1,
		-1,
		-1,
		225,
		219,
		211,
		211,
		190,
		190,
		164,
		168,
		158,
		165,
		175,
		177,
		169,
		173,
		186,
		197,
		200,
		308,
		299,
		312,
		257,
		252,
		270,
		279,
		300,
		268,
		259,
		286,
		292,
		281,
		276,
		263,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		197,
		185,
		168,
		169,
		165,
		168,
		183,
		186,
		176,
		174,
		168,
		200,
		-1,
		301,
		300,
		289,
		286,
		262,
		253,
		248,
		271,
		-1,
		-1,
		270,
		287,
		281,
		285,
		301,
		326,
		-1,
		257,
		-1,
		-1,
		242,
		-1,
		-1,
		227,
		190,
		179,
		170,
		176,
		173,
		184,
		194,
		182,
		183,
		173,
		183,
		196,
		285,
		282,
		270,
		268,
		291,
		256,
		244,
		-1,
		257,
		255,
		261,
		268,
		285,
		315,
		-1,
		-1,
		273,
		253,
		-1,
		-1,
		225,
		223,
		212,
		-1,
		202,
		175,
		180,
		200,
		202,
		191,
		185,
		179,
		186,
		185,
		193,
		201,
		294,
		308,
		297,
		293,
		292,
		300,
		249,
		242,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		-1,
		263,
		259,
		-1,
		-1,
		220,
		213,
		201,
		189,
		179,
		189,
		193,
		197,
		189,
		182,
		177,
		188,
		180,
		184,
		201,
		-1,
		328,
		-1,
		280,
		256,
		270,
		285,
		293,
		-1,
		-1,
		-1,
		280,
		266,
		259,
		247,
		245,
		-1,
		254,
		238,
		219,
		-1,
		189,
		202,
		233,
		201,
		206,
		201,
		183,
		194,
		183,
		186,
		200,
		195,
		-1,
		-1,
		268,
		271,
		-1,
		-1,
		270,
		272,
		-1,
		271,
		260,
		245,
		237,
		-1,
		-1,
		226,
		222,
		-1,
		-1,
		190,
		215,
		204,
		212,
		207,
		187,
		193,
		196,
		185,
		189,
		201,
		-1,
		-1,
		275,
		276,
		277,
		-1,
		255,
		-1,
		273,
		-1,
		240,
		246,
		234,
		-1,
		-1,
		-1,
		228,
		191,
		212,
		222,
		216,
		214,
		205,
		191,
		198,
		196,
		192,
		203,
		-1,
		-1,
		-1,
		273,
		247,
		280,
		271,
		254,
		234,
		226,
		245,
		-1,
		215,
		-1,
		190,
		192,
		218,
		221,
		227,
		221,
		194,
		209,
		199,
		190,
		199,
		279,
		-1,
		249,
		282,
		246,
		240,
		216,
		220,
		236,
		-1,
		212,
		194,
		-1,
		222,
		212,
		243,
		228,
		209,
		196,
		203,
		203,
		196,
		-1,
		-1,
		-1,
		251,
		250,
		242,
		236,
		236,
		221,
		212,
		-1,
		224,
		206,
		185,
		202,
		202,
		193,
		201,
		233,
		229,
		216,
		216,
		208,
		-1,
		352,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		245,
		240,
		213,
		201,
		207,
		203,
		189,
		195,
		197,
		205,
		203,
		200,
		212,
		208,
		228,
		209,
		244,
		-1,
		347,
		-1,
		281,
		-1,
		-1,
		263,
		243,
		235,
		224,
		213,
		211,
		202,
		193,
		215,
		231,
		215,
		213,
		216,
		217,
		-1,
		336,
		335,
		-1,
		282,
		274,
		260,
		-1,
		253,
		-1,
		259,
		220,
		-1,
		222,
		202,
		-1,
		224,
		220,
		-1,
		-1,
		323,
		298,
		-1,
		-1,
		-1,
		283,
		263,
		254,
		238,
		-1,
		213,
		213,
		-1,
		-1,
		-1,
		308,
		307,
		-1,
		276,
		279,
		-1,
		269,
		260,
		268,
		215,
		219,
		-1,
		-1,
		-1,
		317,
		298,
		292,
		291,
		289,
		284,
		281,
		267,
		251,
		229,
		218,
		239,
		-1,
		-1,
		-1,
		289,
		281,
		274,
		-1,
		-1,
		276,
		259,
		240,
		238,
		-1,
		-1,
		-1,
		311,
		292,
		-1,
		-1,
		266,
		-1,
		-1,
		272,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		328,
		300,
		-1,
		-1,
		-1,
		262,
		258,
		259,
		-1,
		-1,
		-1,
		-1,
		322,
		323,
		346,
		310,
		-1,
		-1,
		-1,
		254,
		248,
		-1,
		-1,
		325,
		323,
		-1,
		-1,
		-1,
		282,
		266,
		-1,
		252,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		287,
		-1,
		287,
		262,
		269,
		-1,
		-1,
		-1,
		-1,
		300,
		292,
		300,
		-1,
		272,
		274,
		-1,
		322,
		-1,
		-1,
		315,
		306,
		-1,
		-1,
		277,
		284,
		306,
		309,
		345,
		-1,
		296
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		130,
		119,
		130,
		138,
		111,
		118,
		-1,
		139,
		141,
		107,
		101,
		140,
		111,
		117,
		128,
		-1,
		-1,
		-1,
		130,
		129,
		99,
		97,
		106,
		111,
		118,
		-1,
		141,
		-1,
		151,
		130,
		141,
		146,
		92,
		89,
		109,
		128,
		134,
		126,
		166,
		122,
		93,
		87,
		105,
		110,
		128,
		120,
		-1,
		93,
		83,
		105,
		109,
		121,
		104,
		-1,
		-1,
		87,
		88,
		94,
		106,
		111,
		116,
		-1,
		133,
		117,
		-1,
		-1,
		77,
		90,
		86,
		89,
		97,
		112,
		125,
		117,
		112,
		-1,
		-1,
		78,
		82,
		95,
		96,
		94,
		112,
		125,
		107,
		121,
		120,
		-1,
		66,
		84,
		93,
		102,
		104,
		88,
		86,
		104,
		106,
		112,
		115,
		-1,
		75,
		76,
		77,
		85,
		90,
		97,
		90,
		91,
		101,
		94,
		113,
		104,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		58,
		75,
		72,
		65,
		78,
		80,
		86,
		91,
		89,
		86,
		102,
		103,
		113,
		-1,
		-1,
		169,
		142,
		166,
		124,
		105,
		-1,
		71,
		51,
		57,
		61,
		63,
		63,
		77,
		73,
		-1,
		80,
		79,
		110,
		96,
		107,
		151,
		-1,
		-1,
		127,
		119,
		101,
		104,
		81,
		77,
		66,
		65,
		57,
		43,
		39,
		60,
		63,
		63,
		69,
		74,
		84,
		88,
		103,
		114,
		-1,
		-1,
		178,
		-1,
		-1,
		148,
		131,
		-1,
		96,
		103,
		87,
		93,
		79,
		94,
		76,
		52,
		48,
		53,
		41,
		54,
		55,
		68,
		59,
		71,
		96,
		100,
		103,
		124,
		119,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		103,
		100,
		93,
		117,
		116,
		-1,
		64,
		52,
		49,
		38,
		39,
		40,
		34,
		43,
		47,
		60,
		62,
		78,
		80,
		113,
		100,
		122,
		119,
		148,
		153,
		147,
		156,
		-1,
		156,
		152,
		148,
		155,
		104,
		-1,
		-1,
		121,
		-1,
		124,
		101,
		76,
		49,
		52,
		34,
		21,
		35,
		30,
		37,
		50,
		51,
		71,
		84,
		91,
		95,
		94,
		112,
		127,
		140,
		144,
		150,
		-1,
		206,
		-1,
		148,
		132,
		134,
		110,
		138,
		-1,
		141,
		125,
		93,
		78,
		78,
		-1,
		39,
		36,
		26,
		11,
		22,
		39,
		55,
		59,
		70,
		84,
		98,
		89,
		107,
		114,
		122,
		126,
		146,
		158,
		166,
		156,
		-1,
		138,
		143,
		113,
		125,
		148,
		150,
		114,
		-1,
		89,
		-1,
		41,
		54,
		-1,
		0,
		14,
		28,
		44,
		58,
		71,
		77,
		80,
		77,
		95,
		98,
		115,
		119,
		135,
		-1,
		-1,
		151,
		155,
		163,
		114,
		133,
		157,
		160,
		107,
		96,
		95,
		-1,
		59,
		41,
		38,
		39,
		46,
		41,
		42,
		64,
		78,
		60,
		79,
		82,
		104,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		140,
		111,
		135,
		174,
		125,
		118,
		106,
		98,
		96,
		83,
		-1,
		63,
		47,
		55,
		46,
		54,
		67,
		65,
		79,
		83,
		82,
		101,
		113,
		104,
		124,
		-1,
		-1,
		-1,
		170,
		159,
		160,
		109,
		132,
		166,
		131,
		117,
		122,
		97,
		85,
		93,
		50,
		59,
		68,
		64,
		56,
		45,
		61,
		69,
		71,
		80,
		89,
		95,
		119,
		126,
		132,
		-1,
		-1,
		177,
		167,
		151,
		153,
		150,
		123,
		130,
		162,
		122,
		147,
		-1,
		101,
		-1,
		90,
		85,
		69,
		64,
		61,
		58,
		52,
		61,
		75,
		86,
		82,
		89,
		124,
		124,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		170,
		168,
		143,
		120,
		104,
		140,
		-1,
		117,
		118,
		-1,
		95,
		89,
		86,
		71,
		67,
		62,
		66,
		59,
		66,
		62,
		76,
		87,
		74,
		110,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		99,
		151,
		-1,
		-1,
		102,
		95,
		-1,
		82,
		64,
		71,
		69,
		63,
		67,
		71,
		60,
		73,
		78,
		79,
		89,
		109,
		113,
		117,
		106,
		102,
		99,
		113,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		119,
		-1,
		111,
		103,
		93,
		87,
		81,
		77,
		75,
		91,
		75,
		78,
		78,
		74,
		82,
		67,
		70,
		82,
		86,
		104,
		112,
		104,
		98,
		97,
		109,
		-1,
		186,
		172,
		143,
		-1,
		-1,
		132,
		-1,
		96,
		110,
		126,
		-1,
		119,
		98,
		113,
		91,
		87,
		83,
		98,
		99,
		77,
		82,
		81,
		91,
		92,
		81,
		94,
		86,
		108,
		108,
		92,
		93,
		102,
		-1,
		192,
		179,
		137,
		133,
		122,
		142,
		93,
		81,
		113,
		-1,
		-1,
		155,
		-1,
		89,
		106,
		97,
		95,
		88,
		79,
		85,
		92,
		95,
		96,
		86,
		75,
		81,
		80,
		102,
		88,
		86,
		105,
		121,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		108,
		95,
		89,
		-1,
		130,
		-1,
		133,
		123,
		107,
		92,
		125,
		-1,
		96,
		80,
		85,
		-1,
		121,
		-1,
		94,
		96,
		88,
		77,
		74,
		85,
		83,
		94,
		111,
		-1,
		142,
		127,
		120,
		110,
		124,
		95,
		-1,
		150,
		-1,
		-1,
		120,
		114,
		114,
		98,
		101,
		112,
		92,
		86,
		85,
		116,
		114,
		102,
		86,
		79,
		76,
		77,
		90,
		110,
		101,
		113,
		-1,
		-1,
		-1,
		147,
		133,
		137,
		97,
		116,
		-1,
		-1,
		182,
		137,
		123,
		-1,
		107,
		129,
		117,
		107,
		97,
		131,
		130,
		105,
		98,
		84,
		86,
		84,
		86,
		91,
		112,
		113,
		126,
		-1,
		-1,
		130,
		135,
		123,
		109,
		128,
		-1,
		-1,
		-1,
		129,
		145,
		137,
		108,
		118,
		-1,
		-1,
		109,
		107,
		117,
		101,
		88,
		108,
		111,
		101,
		85,
		100,
		112,
		120,
		125,
		-1,
		133,
		120,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		140,
		142,
		146,
		112,
		-1,
		117,
		112,
		92,
		106,
		113,
		103,
		98,
		92,
		95,
		113,
		130,
		-1,
		-1,
		145,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		119,
		133,
		135,
		128,
		132,
		-1,
		120,
		108,
		94,
		111,
		116,
		113,
		104,
		96,
		101,
		98,
		111,
		125,
		129,
		168,
		-1,
		151,
		-1,
		-1,
		-1,
		137,
		152,
		174,
		151,
		124,
		119,
		112,
		106,
		102,
		118,
		124,
		135,
		103,
		99,
		100,
		104,
		103,
		120,
		130,
		-1,
		-1,
		151,
		168,
		163,
		145,
		149,
		201,
		-1,
		-1,
		128,
		119,
		110,
		113,
		112,
		115,
		109,
		106,
		111,
		116,
		104,
		113,
		131,
		130,
		-1,
		-1,
		-1,
		171,
		-1,
		186,
		-1,
		-1,
		164,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		126,
		118,
		106,
		110,
		133,
		122,
		161,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		200,
		175,
		190,
		210,
		184,
		191,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		123,
		130,
		130,
		122,
		100,
		107,
		123,
		122,
		117,
		153,
		144,
		150,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		206,
		192,
		196,
		186,
		189,
		-1,
		-1,
		177,
		174,
		150,
		133,
		131,
		124,
		119,
		129,
		109,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		178,
		259,
		252,
		235,
		243,
		274,
		-1,
		200,
		192,
		199,
		178,
		180,
		-1,
		-1,
		150,
		147,
		152,
		140,
		137,
		139,
		134,
		125,
		110,
		116,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		192,
		235,
		229,
		232,
		256,
		270,
		-1,
		197,
		-1,
		-1,
		207,
		181,
		165,
		155,
		149,
		199,
		154,
		149,
		133,
		131,
		122,
		113,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		227,
		215,
		223,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		223,
		-1,
		192,
		-1,
		167,
		171,
		162,
		165,
		147,
		134,
		126,
		118,
		134,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		268,
		224,
		223,
		214,
		249,
		264,
		268,
		-1,
		209,
		248,
		246,
		-1,
		230,
		-1,
		-1,
		-1,
		181,
		175,
		167,
		167,
		146,
		146,
		120,
		124,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		264,
		255,
		268,
		213,
		213,
		234,
		243,
		264,
		224,
		215,
		242,
		253,
		242,
		237,
		224,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		153,
		141,
		124,
		125,
		121,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		204,
		231,
		-1,
		-1,
		226,
		243,
		237,
		241,
		257,
		282,
		-1,
		213,
		-1,
		-1,
		198,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		129,
		140,
		150,
		138,
		139,
		129,
		139,
		152,
		241,
		238,
		226,
		224,
		247,
		212,
		200,
		-1,
		213,
		211,
		217,
		224,
		241,
		271,
		-1,
		-1,
		229,
		209,
		-1,
		-1,
		181,
		179,
		168,
		-1,
		158,
		131,
		136,
		156,
		158,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		198,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		215,
		-1,
		-1,
		176,
		169,
		157,
		145,
		135,
		145,
		149,
		153,
		145,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		284,
		-1,
		236,
		212,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		226,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		231,
		232,
		233,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		172,
		170,
		161,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		148,
		174,
		177,
		183,
		177,
		150,
		165,
		155,
		146,
		155,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		199,
		184,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		189,
		185,
		172,
		172,
		164,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		165,
		200,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		172,
		173,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		137,
		139,
		105,
		99,
		138,
		109,
		115,
		126,
		-1,
		-1,
		-1,
		128,
		127,
		97,
		95,
		104,
		109,
		116,
		-1,
		139,
		-1,
		149,
		128,
		139,
		144,
		90,
		87,
		107,
		126,
		132,
		124,
		164,
		120,
		91,
		85,
		103,
		108,
		126,
		118,
		-1,
		91,
		81,
		103,
		107,
		119,
		102,
		-1,
		-1,
		85,
		86,
		92,
		104,
		109,
		114,
		-1,
		131,
		115,
		-1,
		-1,
		75,
		88,
		84,
		87,
		95,
		110,
		123,
		115,
		110,
		-1,
		-1,
		76,
		80,
		93,
		94,
		92,
		110,
		123,
		105,
		119,
		118,
		-1,
		64,
		82,
		91,
		100,
		102,
		86,
		84,
		102,
		104,
		110,
		113,
		-1,
		73,
		74,
		75,
		83,
		88,
		95,
		88,
		89,
		99,
		92,
		111,
		102,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		73,
		56,
		73,
		70,
		63,
		76,
		78,
		84,
		89,
		87,
		84,
		100,
		101,
		111,
		-1,
		-1,
		167,
		140,
		164,
		122,
		103,
		-1,
		69,
		49,
		55,
		59,
		61,
		61,
		75,
		71,
		-1,
		78,
		77,
		108,
		94,
		105,
		149,
		-1,
		-1,
		125,
		117,
		99,
		102,
		79,
		75,
		64,
		63,
		55,
		41,
		37,
		58,
		61,
		61,
		67,
		72,
		82,
		86,
		101,
		112,
		-1,
		-1,
		176,
		-1,
		-1,
		146,
		129,
		-1,
		94,
		101,
		85,
		91,
		77,
		98,
		74,
		58,
		54,
		51,
		39,
		52,
		53,
		66,
		57,
		69,
		94,
		98,
		101,
		122,
		117,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		101,
		98,
		91,
		115,
		114,
		-1,
		70,
		58,
		55,
		44,
		45,
		38,
		32,
		41,
		45,
		58,
		60,
		76,
		78,
		111,
		98,
		120,
		117,
		146,
		151,
		145,
		154,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		119,
		-1,
		122,
		107,
		82,
		55,
		58,
		40,
		27,
		33,
		28,
		35,
		48,
		49,
		69,
		82,
		89,
		93,
		92,
		110,
		125,
		138,
		142,
		148,
		-1,
		204,
		-1,
		146,
		130,
		132,
		108,
		136,
		-1,
		139,
		123,
		99,
		84,
		84,
		-1,
		45,
		42,
		32,
		10,
		20,
		37,
		53,
		57,
		68,
		82,
		96,
		87,
		105,
		112,
		120,
		124,
		144,
		156,
		164,
		154,
		-1,
		136,
		141,
		111,
		123,
		146,
		156,
		120,
		-1,
		95,
		-1,
		47,
		60,
		-1,
		16,
		0,
		26,
		42,
		56,
		69,
		75,
		78,
		75,
		93,
		96,
		113,
		117,
		133,
		-1,
		-1,
		149,
		153,
		161,
		112,
		131,
		155,
		166,
		113,
		102,
		101,
		-1,
		65,
		27,
		24,
		25,
		44,
		39,
		40,
		62,
		76,
		58,
		77,
		80,
		102,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		138,
		109,
		133,
		175,
		131,
		124,
		112,
		104,
		102,
		89,
		-1,
		49,
		33,
		49,
		44,
		52,
		65,
		63,
		77,
		81,
		80,
		99,
		111,
		102,
		122,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		107,
		130,
		164,
		137,
		123,
		128,
		103,
		91,
		94,
		36,
		45,
		59,
		61,
		54,
		43,
		59,
		67,
		69,
		78,
		87,
		93,
		117,
		124,
		130,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		121,
		128,
		160,
		128,
		145,
		-1,
		99,
		-1,
		88,
		82,
		67,
		62,
		59,
		56,
		50,
		59,
		73,
		84,
		80,
		87,
		122,
		122,
		114,
		134,
		137,
		-1,
		-1,
		-1,
		168,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		69,
		65,
		60,
		64,
		57,
		64,
		60,
		74,
		85,
		72,
		108,
		-1,
		122,
		116,
		124,
		114,
		102,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		69,
		67,
		61,
		65,
		69,
		58,
		71,
		76,
		77,
		87,
		107,
		111,
		115,
		104,
		100,
		97,
		111,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		89,
		73,
		76,
		76,
		72,
		80,
		65,
		68,
		80,
		84,
		102,
		110,
		102,
		96,
		95,
		107,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		81,
		96,
		97,
		75,
		80,
		79,
		89,
		90,
		79,
		92,
		84,
		106,
		106,
		90,
		91,
		100,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		95,
		93,
		86,
		77,
		83,
		90,
		93,
		94,
		84,
		73,
		79,
		78,
		100,
		86,
		84,
		103,
		119,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		94,
		78,
		83,
		-1,
		119,
		-1,
		92,
		94,
		86,
		75,
		72,
		83,
		81,
		92,
		109,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		110,
		90,
		84,
		83,
		114,
		112,
		100,
		84,
		77,
		74,
		75,
		88,
		108,
		99,
		111,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		127,
		115,
		105,
		95,
		129,
		128,
		103,
		96,
		82,
		84,
		82,
		84,
		89,
		110,
		111,
		124,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		116,
		-1,
		-1,
		107,
		105,
		115,
		99,
		86,
		106,
		109,
		99,
		83,
		98,
		110,
		118,
		123,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		138,
		140,
		144,
		110,
		-1,
		115,
		110,
		90,
		104,
		111,
		101,
		96,
		90,
		93,
		111,
		128,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		117,
		131,
		133,
		126,
		130,
		-1,
		118,
		106,
		92,
		109,
		114,
		111,
		102,
		94,
		99,
		96,
		109,
		123,
		127,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		135,
		150,
		172,
		149,
		122,
		117,
		110,
		104,
		100,
		116,
		122,
		133,
		101,
		97,
		98,
		102,
		101,
		118,
		128,
		-1,
		-1,
		149,
		166,
		161,
		143,
		147,
		199,
		-1,
		-1,
		126,
		117,
		108,
		111,
		110,
		113,
		107,
		104,
		109,
		114,
		102,
		111,
		129,
		128,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		162,
		197,
		144,
		126,
		122,
		120,
		113,
		122,
		117,
		112,
		122,
		124,
		116,
		104,
		108,
		131,
		120,
		159,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		198,
		173,
		188,
		208,
		182,
		189,
		159,
		156,
		-1,
		126,
		151,
		123,
		130,
		121,
		128,
		128,
		120,
		98,
		105,
		121,
		120,
		115,
		151,
		142,
		148,
		-1,
		-1,
		281,
		270,
		259,
		265,
		-1,
		204,
		190,
		194,
		184,
		187,
		-1,
		-1,
		175,
		172,
		148,
		131,
		129,
		122,
		117,
		127,
		107,
		94,
		98,
		102,
		108,
		113,
		118,
		124,
		139,
		154,
		-1,
		176,
		257,
		250,
		233,
		241,
		272,
		-1,
		198,
		190,
		197,
		176,
		178,
		-1,
		-1,
		148,
		145,
		150,
		138,
		135,
		137,
		132,
		123,
		108,
		114,
		101,
		100,
		118,
		122,
		131,
		138,
		128,
		141,
		145,
		-1,
		190,
		233,
		227,
		230,
		254,
		268,
		-1,
		195,
		-1,
		-1,
		205,
		179,
		163,
		153,
		147,
		197,
		152,
		147,
		131,
		129,
		120,
		111,
		118,
		109,
		109,
		112,
		127,
		132,
		124,
		138,
		138,
		139,
		-1,
		225,
		213,
		221,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		221,
		-1,
		190,
		-1,
		165,
		169,
		160,
		163,
		145,
		132,
		124,
		116,
		132,
		107,
		117,
		113,
		114,
		123,
		134,
		146,
		145,
		146,
		266,
		222,
		221,
		212,
		247,
		262,
		266,
		-1,
		207,
		246,
		244,
		-1,
		228,
		-1,
		-1,
		-1,
		179,
		173,
		165,
		165,
		144,
		144,
		118,
		122,
		112,
		119,
		129,
		131,
		123,
		127,
		140,
		151,
		154,
		262,
		253,
		266,
		211,
		211,
		232,
		241,
		262,
		222,
		213,
		240,
		251,
		240,
		235,
		222,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		151,
		139,
		122,
		123,
		119,
		122,
		137,
		140,
		130,
		128,
		122,
		154,
		-1,
		255,
		254,
		243,
		240,
		216,
		207,
		202,
		229,
		-1,
		-1,
		224,
		241,
		235,
		239,
		255,
		280,
		-1,
		211,
		-1,
		-1,
		196,
		-1,
		-1,
		181,
		144,
		133,
		124,
		130,
		127,
		138,
		148,
		136,
		137,
		127,
		137,
		150,
		239,
		236,
		224,
		222,
		245,
		210,
		198,
		-1,
		211,
		209,
		215,
		222,
		239,
		269,
		-1,
		-1,
		227,
		207,
		-1,
		-1,
		179,
		177,
		166,
		-1,
		156,
		129,
		134,
		154,
		156,
		145,
		139,
		133,
		140,
		139,
		147,
		155,
		248,
		262,
		251,
		247,
		246,
		254,
		203,
		196,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		217,
		213,
		-1,
		-1,
		174,
		167,
		155,
		143,
		133,
		143,
		147,
		151,
		143,
		136,
		131,
		142,
		134,
		138,
		155,
		-1,
		282,
		-1,
		234,
		210,
		224,
		239,
		247,
		-1,
		-1,
		-1,
		234,
		220,
		213,
		201,
		199,
		-1,
		208,
		192,
		173,
		-1,
		143,
		156,
		187,
		155,
		160,
		155,
		137,
		148,
		137,
		140,
		154,
		149,
		-1,
		-1,
		222,
		225,
		-1,
		-1,
		224,
		226,
		-1,
		225,
		214,
		199,
		191,
		-1,
		-1,
		180,
		176,
		-1,
		-1,
		144,
		169,
		158,
		166,
		161,
		141,
		147,
		150,
		139,
		143,
		155,
		-1,
		-1,
		229,
		230,
		231,
		-1,
		209,
		-1,
		227,
		-1,
		194,
		200,
		188,
		-1,
		-1,
		-1,
		182,
		145,
		166,
		176,
		170,
		168,
		159,
		145,
		152,
		150,
		146,
		157,
		-1,
		-1,
		-1,
		227,
		201,
		234,
		225,
		208,
		188,
		180,
		199,
		-1,
		169,
		-1,
		144,
		146,
		172,
		175,
		181,
		175,
		148,
		163,
		153,
		144,
		153,
		233,
		-1,
		203,
		236,
		200,
		194,
		170,
		174,
		190,
		-1,
		166,
		148,
		-1,
		176,
		166,
		197,
		182,
		163,
		150,
		157,
		157,
		150,
		-1,
		-1,
		-1,
		205,
		204,
		196,
		190,
		190,
		175,
		166,
		-1,
		178,
		160,
		139,
		156,
		156,
		147,
		155,
		187,
		183,
		170,
		170,
		162,
		-1,
		306,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		199,
		194,
		167,
		155,
		161,
		157,
		143,
		149,
		151,
		159,
		157,
		154,
		166,
		162,
		182,
		163,
		198,
		-1,
		301,
		-1,
		235,
		-1,
		-1,
		217,
		197,
		189,
		178,
		167,
		165,
		156,
		147,
		169,
		185,
		169,
		167,
		170,
		171,
		-1,
		290,
		289,
		-1,
		236,
		228,
		214,
		-1,
		207,
		-1,
		213,
		174,
		-1,
		176,
		156,
		-1,
		178,
		174,
		-1,
		-1,
		277,
		252,
		-1,
		-1,
		-1,
		237,
		217,
		208,
		192,
		-1,
		167,
		167,
		-1,
		-1,
		-1,
		262,
		261,
		-1,
		230,
		233,
		-1,
		223,
		214,
		222,
		169,
		173,
		-1,
		-1,
		-1,
		271,
		252,
		246,
		245,
		243,
		238,
		235,
		221,
		205,
		183,
		172,
		193,
		-1,
		-1,
		-1,
		243,
		235,
		228,
		-1,
		-1,
		230,
		213,
		194,
		192,
		-1,
		-1,
		-1,
		265,
		246,
		-1,
		-1,
		220,
		-1,
		-1,
		226,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		254,
		-1,
		-1,
		-1,
		216,
		212,
		213,
		-1,
		-1,
		-1,
		-1,
		276,
		277,
		300,
		264,
		-1,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		279,
		277,
		-1,
		-1,
		-1,
		236,
		220,
		-1,
		206,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		241,
		-1,
		241,
		216,
		223,
		-1,
		-1,
		-1,
		-1,
		254,
		246,
		254,
		-1,
		226,
		228,
		-1,
		276,
		-1,
		-1,
		269,
		260,
		-1,
		-1,
		231,
		238,
		260,
		263,
		299,
		-1,
		250
	],
	[
		-1,
		118,
		107,
		118,
		126,
		99,
		106,
		-1,
		127,
		129,
		95,
		89,
		128,
		99,
		105,
		116,
		-1,
		-1,
		-1,
		118,
		117,
		87,
		85,
		94,
		99,
		106,
		-1,
		129,
		-1,
		139,
		118,
		129,
		134,
		80,
		77,
		97,
		116,
		122,
		114,
		154,
		110,
		81,
		75,
		93,
		98,
		116,
		108,
		-1,
		81,
		71,
		93,
		97,
		109,
		92,
		-1,
		-1,
		75,
		76,
		82,
		94,
		99,
		102,
		-1,
		112,
		96,
		-1,
		-1,
		65,
		78,
		74,
		77,
		85,
		91,
		104,
		96,
		91,
		-1,
		-1,
		66,
		70,
		83,
		78,
		74,
		91,
		104,
		86,
		100,
		99,
		-1,
		54,
		72,
		81,
		85,
		83,
		67,
		65,
		83,
		85,
		91,
		94,
		-1,
		63,
		64,
		65,
		73,
		78,
		83,
		70,
		70,
		80,
		73,
		92,
		83,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		63,
		46,
		63,
		60,
		53,
		66,
		68,
		73,
		70,
		68,
		65,
		81,
		82,
		92,
		-1,
		-1,
		157,
		130,
		154,
		112,
		93,
		-1,
		59,
		39,
		45,
		49,
		51,
		51,
		65,
		61,
		-1,
		59,
		58,
		89,
		75,
		86,
		139,
		-1,
		-1,
		115,
		107,
		89,
		92,
		69,
		65,
		54,
		53,
		45,
		31,
		27,
		48,
		51,
		51,
		57,
		53,
		63,
		67,
		82,
		93,
		-1,
		-1,
		154,
		-1,
		-1,
		136,
		119,
		-1,
		84,
		91,
		75,
		81,
		67,
		88,
		64,
		55,
		47,
		41,
		29,
		42,
		43,
		56,
		49,
		50,
		75,
		79,
		79,
		100,
		95,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		91,
		88,
		81,
		105,
		104,
		-1,
		76,
		64,
		65,
		50,
		47,
		34,
		22,
		35,
		35,
		48,
		52,
		57,
		59,
		92,
		76,
		98,
		95,
		124,
		129,
		123,
		132,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		109,
		-1,
		112,
		113,
		88,
		61,
		64,
		51,
		42,
		29,
		18,
		29,
		33,
		30,
		50,
		63,
		70,
		71,
		70,
		88,
		103,
		116,
		120,
		126,
		-1,
		194,
		-1,
		136,
		120,
		122,
		98,
		125,
		-1,
		129,
		113,
		105,
		90,
		90,
		-1,
		60,
		57,
		47,
		25,
		10,
		27,
		30,
		34,
		49,
		60,
		74,
		65,
		83,
		90,
		98,
		102,
		122,
		134,
		154,
		144,
		-1,
		126,
		131,
		100,
		108,
		127,
		156,
		126,
		-1,
		101,
		-1,
		62,
		75,
		-1,
		31,
		27,
		0,
		17,
		31,
		44,
		56,
		56,
		53,
		71,
		74,
		91,
		95,
		111,
		-1,
		-1,
		139,
		143,
		142,
		93,
		112,
		136,
		172,
		119,
		108,
		107,
		-1,
		80,
		36,
		33,
		34,
		21,
		16,
		17,
		37,
		56,
		36,
		55,
		58,
		80,
		108,
		86,
		98,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		119,
		90,
		114,
		156,
		137,
		130,
		118,
		86,
		86,
		80,
		-1,
		52,
		31,
		30,
		21,
		29,
		44,
		41,
		55,
		59,
		58,
		77,
		89,
		80,
		100,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		85,
		108,
		145,
		119,
		105,
		110,
		85,
		78,
		72,
		45,
		48,
		43,
		39,
		32,
		21,
		37,
		45,
		47,
		56,
		65,
		71,
		95,
		102,
		108,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		99,
		106,
		138,
		110,
		123,
		-1,
		77,
		-1,
		66,
		61,
		45,
		40,
		37,
		34,
		28,
		37,
		51,
		62,
		58,
		65,
		100,
		100,
		92,
		112,
		115,
		-1,
		-1,
		-1,
		149,
		144,
		119,
		96,
		80,
		116,
		-1,
		93,
		94,
		-1,
		71,
		65,
		62,
		47,
		43,
		38,
		42,
		35,
		42,
		38,
		52,
		63,
		50,
		86,
		-1,
		100,
		94,
		102,
		92,
		80,
		-1,
		-1,
		-1,
		142,
		121,
		114,
		134,
		75,
		127,
		-1,
		-1,
		78,
		71,
		-1,
		58,
		40,
		47,
		45,
		39,
		43,
		47,
		36,
		49,
		54,
		55,
		65,
		85,
		89,
		93,
		82,
		78,
		75,
		89,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		95,
		-1,
		87,
		79,
		69,
		63,
		57,
		53,
		51,
		67,
		51,
		54,
		54,
		50,
		58,
		43,
		46,
		58,
		62,
		80,
		88,
		80,
		74,
		73,
		85,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		108,
		-1,
		72,
		86,
		102,
		-1,
		95,
		74,
		89,
		67,
		63,
		59,
		74,
		75,
		53,
		58,
		57,
		67,
		68,
		57,
		70,
		62,
		84,
		84,
		68,
		69,
		78,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		69,
		57,
		89,
		-1,
		-1,
		131,
		-1,
		65,
		82,
		73,
		71,
		64,
		55,
		61,
		68,
		71,
		72,
		62,
		51,
		57,
		56,
		78,
		64,
		62,
		81,
		97,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		109,
		99,
		83,
		68,
		101,
		-1,
		72,
		56,
		61,
		-1,
		97,
		-1,
		70,
		72,
		64,
		53,
		50,
		61,
		59,
		70,
		87,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		126,
		-1,
		-1,
		96,
		90,
		90,
		74,
		77,
		88,
		68,
		62,
		61,
		92,
		90,
		78,
		62,
		55,
		52,
		53,
		66,
		86,
		77,
		89,
		-1,
		-1,
		-1,
		123,
		109,
		113,
		73,
		92,
		-1,
		-1,
		158,
		113,
		99,
		-1,
		83,
		105,
		93,
		83,
		73,
		107,
		106,
		81,
		74,
		60,
		62,
		60,
		62,
		67,
		88,
		89,
		102,
		-1,
		-1,
		106,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		105,
		121,
		113,
		84,
		94,
		-1,
		-1,
		85,
		83,
		93,
		77,
		64,
		84,
		87,
		77,
		61,
		76,
		88,
		96,
		101,
		-1,
		109,
		96,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		116,
		118,
		122,
		88,
		-1,
		93,
		88,
		68,
		82,
		89,
		79,
		74,
		68,
		71,
		89,
		106,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		95,
		109,
		111,
		104,
		108,
		-1,
		96,
		84,
		70,
		87,
		92,
		89,
		80,
		72,
		77,
		74,
		87,
		101,
		105,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		113,
		128,
		150,
		127,
		100,
		95,
		88,
		82,
		78,
		94,
		100,
		111,
		79,
		75,
		76,
		80,
		79,
		96,
		106,
		-1,
		-1,
		127,
		144,
		139,
		121,
		125,
		177,
		-1,
		-1,
		104,
		95,
		86,
		89,
		88,
		91,
		85,
		82,
		87,
		92,
		80,
		89,
		107,
		106,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		140,
		175,
		122,
		104,
		100,
		98,
		91,
		100,
		95,
		90,
		100,
		102,
		94,
		82,
		86,
		109,
		98,
		137,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		186,
		160,
		167,
		137,
		134,
		-1,
		104,
		129,
		101,
		108,
		99,
		106,
		106,
		98,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		182,
		168,
		172,
		162,
		165,
		-1,
		-1,
		153,
		150,
		126,
		109,
		107,
		100,
		95,
		105,
		85,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		176,
		168,
		175,
		154,
		156,
		-1,
		-1,
		126,
		123,
		128,
		116,
		113,
		115,
		110,
		101,
		86,
		92,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		173,
		-1,
		-1,
		183,
		157,
		141,
		131,
		125,
		175,
		130,
		125,
		109,
		107,
		98,
		89,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		203,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		199,
		-1,
		168,
		-1,
		143,
		147,
		138,
		141,
		123,
		110,
		102,
		94,
		110,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		244,
		200,
		199,
		190,
		225,
		240,
		244,
		-1,
		185,
		224,
		222,
		-1,
		206,
		-1,
		-1,
		-1,
		157,
		151,
		143,
		143,
		122,
		122,
		96,
		100,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		240,
		231,
		244,
		189,
		189,
		210,
		219,
		240,
		200,
		191,
		218,
		229,
		218,
		213,
		200,
		-1,
		-1,
		180,
		161,
		-1,
		-1,
		129,
		117,
		100,
		101,
		97,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		207,
		-1,
		-1,
		202,
		219,
		213,
		217,
		233,
		258,
		-1,
		189,
		-1,
		-1,
		174,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		105,
		116,
		126,
		114,
		115,
		105,
		115,
		128,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		189,
		187,
		193,
		200,
		217,
		247,
		-1,
		-1,
		205,
		185,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		132,
		134,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		191,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		125,
		129,
		121,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		260,
		-1,
		212,
		188,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		200,
		203,
		-1,
		-1,
		202,
		204,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		207,
		208,
		209,
		-1,
		187,
		-1,
		205,
		-1,
		172,
		178,
		166,
		-1,
		-1,
		-1,
		160,
		123,
		144,
		154,
		148,
		146,
		137,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		205,
		179,
		212,
		203,
		186,
		166,
		158,
		177,
		-1,
		147,
		-1,
		122,
		124,
		150,
		153,
		159,
		153,
		126,
		141,
		131,
		122,
		131,
		211,
		-1,
		181,
		214,
		178,
		172,
		148,
		152,
		168,
		-1,
		144,
		126,
		-1,
		154,
		144,
		175,
		160,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		168,
		153,
		144,
		-1,
		156,
		138,
		117,
		134,
		134,
		125,
		133,
		165,
		161,
		148,
		148,
		140,
		-1,
		284,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		172,
		145,
		133,
		139,
		135,
		121,
		127,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		141,
		176,
		-1,
		279,
		-1,
		213,
		-1,
		-1,
		195,
		175,
		167,
		156,
		145,
		143,
		134,
		125,
		147,
		163,
		147,
		145,
		148,
		149,
		-1,
		268,
		267,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		191,
		152,
		-1,
		154,
		134,
		-1,
		156,
		152,
		-1,
		-1,
		255,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		186,
		170,
		-1,
		145,
		145,
		-1,
		-1,
		-1,
		240,
		239,
		-1,
		208,
		211,
		-1,
		201,
		192,
		200,
		147,
		151,
		-1,
		-1,
		-1,
		249,
		230,
		224,
		223,
		221,
		216,
		213,
		199,
		183,
		161,
		150,
		171,
		-1,
		-1,
		-1,
		221,
		213,
		206,
		-1,
		-1,
		208,
		191,
		172,
		170,
		-1,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		198,
		-1,
		-1,
		204,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		232,
		-1,
		-1,
		-1,
		194,
		190,
		191,
		-1,
		-1,
		-1,
		-1,
		254,
		255,
		278,
		242,
		-1,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		257,
		255,
		-1,
		-1,
		-1,
		214,
		198,
		-1,
		184,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		219,
		-1,
		219,
		194,
		201,
		-1,
		-1,
		-1,
		-1,
		232,
		224,
		232,
		-1,
		204,
		206,
		-1,
		254,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		209,
		216,
		238,
		241,
		277,
		-1,
		228
	],
	[
		-1,
		136,
		125,
		136,
		144,
		117,
		124,
		-1,
		145,
		147,
		113,
		107,
		146,
		117,
		123,
		134,
		-1,
		-1,
		-1,
		136,
		135,
		105,
		103,
		112,
		117,
		124,
		-1,
		124,
		-1,
		157,
		136,
		147,
		152,
		98,
		95,
		115,
		134,
		117,
		109,
		172,
		128,
		99,
		93,
		111,
		102,
		111,
		103,
		-1,
		99,
		89,
		111,
		91,
		102,
		94,
		-1,
		-1,
		93,
		94,
		100,
		87,
		93,
		89,
		-1,
		99,
		83,
		-1,
		-1,
		83,
		85,
		69,
		72,
		80,
		78,
		91,
		83,
		78,
		-1,
		-1,
		75,
		71,
		78,
		65,
		61,
		78,
		91,
		73,
		87,
		86,
		-1,
		72,
		90,
		98,
		72,
		70,
		54,
		52,
		70,
		72,
		78,
		81,
		-1,
		81,
		82,
		73,
		81,
		86,
		70,
		57,
		57,
		67,
		60,
		79,
		70,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		81,
		64,
		81,
		69,
		59,
		74,
		67,
		60,
		57,
		55,
		52,
		68,
		69,
		79,
		-1,
		-1,
		175,
		148,
		172,
		130,
		111,
		-1,
		77,
		57,
		63,
		63,
		57,
		50,
		64,
		60,
		-1,
		46,
		45,
		76,
		62,
		73,
		154,
		-1,
		-1,
		133,
		125,
		107,
		110,
		87,
		83,
		72,
		71,
		63,
		49,
		45,
		47,
		50,
		50,
		56,
		40,
		50,
		54,
		69,
		80,
		-1,
		-1,
		154,
		-1,
		-1,
		151,
		134,
		-1,
		102,
		109,
		93,
		99,
		85,
		106,
		82,
		73,
		65,
		59,
		47,
		45,
		42,
		55,
		43,
		37,
		62,
		66,
		72,
		90,
		91,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		109,
		106,
		99,
		123,
		122,
		-1,
		94,
		82,
		83,
		68,
		65,
		52,
		40,
		50,
		34,
		41,
		40,
		44,
		46,
		79,
		74,
		95,
		92,
		123,
		129,
		123,
		132,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		127,
		-1,
		130,
		131,
		106,
		79,
		82,
		69,
		60,
		47,
		36,
		47,
		32,
		29,
		37,
		50,
		57,
		71,
		70,
		88,
		101,
		116,
		120,
		126,
		-1,
		209,
		-1,
		151,
		135,
		137,
		109,
		130,
		-1,
		147,
		131,
		123,
		108,
		108,
		-1,
		78,
		75,
		65,
		43,
		28,
		42,
		31,
		26,
		36,
		57,
		74,
		65,
		83,
		90,
		98,
		102,
		122,
		134,
		169,
		159,
		-1,
		141,
		146,
		105,
		113,
		132,
		170,
		134,
		-1,
		119,
		-1,
		80,
		93,
		-1,
		49,
		45,
		19,
		0,
		14,
		31,
		43,
		56,
		53,
		71,
		74,
		91,
		95,
		111,
		-1,
		-1,
		154,
		158,
		147,
		98,
		117,
		141,
		178,
		127,
		116,
		115,
		-1,
		98,
		55,
		52,
		46,
		33,
		18,
		12,
		20,
		39,
		41,
		55,
		58,
		80,
		108,
		86,
		98,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		124,
		95,
		119,
		161,
		145,
		138,
		126,
		91,
		91,
		85,
		-1,
		57,
		36,
		32,
		26,
		31,
		47,
		46,
		60,
		59,
		61,
		77,
		89,
		80,
		100,
		-1,
		-1,
		-1,
		154,
		143,
		144,
		90,
		113,
		150,
		124,
		110,
		115,
		90,
		83,
		77,
		64,
		53,
		48,
		44,
		37,
		26,
		42,
		50,
		52,
		61,
		70,
		71,
		95,
		102,
		108,
		-1,
		-1,
		161,
		151,
		135,
		137,
		134,
		104,
		111,
		143,
		115,
		128,
		-1,
		82,
		-1,
		71,
		66,
		50,
		45,
		42,
		39,
		33,
		42,
		56,
		67,
		63,
		70,
		100,
		100,
		92,
		117,
		120,
		-1,
		-1,
		-1,
		154,
		149,
		124,
		101,
		85,
		121,
		-1,
		98,
		99,
		-1,
		76,
		70,
		67,
		52,
		48,
		43,
		47,
		40,
		47,
		43,
		57,
		68,
		55,
		91,
		-1,
		100,
		94,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		80,
		132,
		-1,
		-1,
		83,
		76,
		-1,
		63,
		45,
		52,
		50,
		44,
		48,
		52,
		41,
		54,
		59,
		60,
		70,
		90,
		94,
		98,
		87,
		83,
		80,
		94,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		100,
		-1,
		92,
		84,
		74,
		68,
		62,
		58,
		56,
		72,
		56,
		59,
		59,
		55,
		63,
		48,
		51,
		63,
		67,
		85,
		93,
		85,
		79,
		78,
		90,
		-1,
		167,
		153,
		124,
		-1,
		-1,
		113,
		-1,
		77,
		91,
		107,
		-1,
		100,
		79,
		94,
		72,
		68,
		64,
		79,
		80,
		58,
		63,
		62,
		72,
		73,
		62,
		75,
		67,
		89,
		89,
		73,
		74,
		83,
		-1,
		173,
		160,
		118,
		114,
		103,
		123,
		74,
		62,
		94,
		-1,
		-1,
		136,
		-1,
		70,
		87,
		78,
		76,
		69,
		60,
		66,
		73,
		76,
		77,
		67,
		56,
		62,
		61,
		83,
		69,
		67,
		86,
		102,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		89,
		76,
		70,
		-1,
		111,
		-1,
		114,
		104,
		88,
		73,
		106,
		-1,
		77,
		61,
		66,
		-1,
		102,
		-1,
		75,
		77,
		69,
		58,
		55,
		66,
		64,
		75,
		92,
		-1,
		123,
		108,
		101,
		91,
		105,
		76,
		-1,
		131,
		-1,
		-1,
		101,
		95,
		95,
		79,
		82,
		93,
		73,
		67,
		66,
		97,
		95,
		83,
		67,
		60,
		57,
		58,
		71,
		91,
		82,
		94,
		-1,
		-1,
		-1,
		128,
		114,
		118,
		78,
		97,
		-1,
		-1,
		163,
		118,
		104,
		-1,
		88,
		110,
		98,
		88,
		78,
		112,
		111,
		86,
		79,
		65,
		67,
		65,
		67,
		72,
		93,
		94,
		107,
		-1,
		-1,
		111,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		110,
		126,
		118,
		89,
		99,
		-1,
		-1,
		90,
		88,
		98,
		82,
		69,
		89,
		92,
		82,
		66,
		81,
		93,
		101,
		106,
		-1,
		114,
		101,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		121,
		123,
		127,
		93,
		-1,
		98,
		93,
		73,
		87,
		94,
		84,
		79,
		73,
		76,
		94,
		111,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		100,
		114,
		116,
		109,
		113,
		-1,
		101,
		89,
		75,
		92,
		97,
		94,
		85,
		77,
		82,
		79,
		92,
		106,
		110,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		118,
		133,
		155,
		132,
		105,
		100,
		93,
		87,
		83,
		99,
		105,
		116,
		84,
		80,
		81,
		85,
		84,
		101,
		111,
		-1,
		-1,
		132,
		149,
		144,
		126,
		130,
		182,
		-1,
		-1,
		109,
		100,
		91,
		94,
		93,
		96,
		90,
		87,
		92,
		97,
		85,
		94,
		112,
		111,
		-1,
		-1,
		-1,
		152,
		-1,
		167,
		-1,
		-1,
		145,
		180,
		127,
		109,
		105,
		103,
		96,
		105,
		100,
		95,
		105,
		107,
		99,
		87,
		91,
		114,
		103,
		142,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		191,
		165,
		172,
		142,
		139,
		-1,
		109,
		134,
		106,
		113,
		104,
		111,
		111,
		103,
		81,
		88,
		104,
		103,
		98,
		134,
		125,
		131,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		187,
		173,
		177,
		167,
		170,
		-1,
		-1,
		158,
		155,
		131,
		114,
		112,
		105,
		100,
		110,
		90,
		77,
		81,
		85,
		91,
		96,
		101,
		107,
		122,
		137,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		181,
		173,
		180,
		159,
		161,
		-1,
		-1,
		131,
		128,
		133,
		121,
		118,
		120,
		115,
		106,
		91,
		97,
		84,
		83,
		101,
		105,
		114,
		121,
		111,
		124,
		128,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		178,
		-1,
		-1,
		188,
		162,
		146,
		136,
		130,
		180,
		135,
		130,
		114,
		112,
		103,
		94,
		101,
		92,
		92,
		95,
		110,
		115,
		107,
		121,
		121,
		122,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		204,
		-1,
		173,
		-1,
		148,
		152,
		143,
		146,
		128,
		115,
		107,
		99,
		115,
		90,
		100,
		96,
		97,
		106,
		117,
		129,
		128,
		129,
		249,
		205,
		204,
		195,
		230,
		245,
		249,
		-1,
		190,
		229,
		227,
		-1,
		211,
		-1,
		-1,
		-1,
		162,
		156,
		148,
		148,
		127,
		127,
		101,
		105,
		95,
		102,
		112,
		114,
		106,
		110,
		123,
		134,
		137,
		245,
		236,
		249,
		194,
		194,
		215,
		224,
		245,
		205,
		196,
		223,
		234,
		223,
		218,
		205,
		-1,
		-1,
		185,
		166,
		-1,
		-1,
		134,
		122,
		105,
		106,
		102,
		105,
		120,
		123,
		113,
		111,
		105,
		137,
		-1,
		238,
		237,
		226,
		223,
		199,
		190,
		185,
		212,
		-1,
		-1,
		207,
		224,
		218,
		222,
		238,
		263,
		-1,
		194,
		-1,
		-1,
		179,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		110,
		121,
		131,
		119,
		120,
		110,
		120,
		133,
		222,
		219,
		207,
		205,
		228,
		193,
		181,
		-1,
		194,
		192,
		198,
		205,
		222,
		252,
		-1,
		-1,
		210,
		190,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		112,
		117,
		137,
		139,
		128,
		122,
		116,
		123,
		122,
		130,
		138,
		231,
		245,
		234,
		230,
		229,
		237,
		186,
		179,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		200,
		196,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		130,
		134,
		126,
		119,
		114,
		125,
		117,
		121,
		138,
		-1,
		265,
		-1,
		217,
		193,
		207,
		222,
		230,
		-1,
		-1,
		-1,
		217,
		203,
		196,
		184,
		182,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		120,
		131,
		120,
		123,
		137,
		132,
		-1,
		-1,
		205,
		208,
		-1,
		-1,
		207,
		209,
		-1,
		208,
		197,
		182,
		174,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		124,
		130,
		133,
		122,
		126,
		138,
		-1,
		-1,
		212,
		213,
		214,
		-1,
		192,
		-1,
		210,
		-1,
		177,
		183,
		171,
		-1,
		-1,
		-1,
		165,
		128,
		149,
		159,
		153,
		151,
		142,
		128,
		135,
		133,
		129,
		140,
		-1,
		-1,
		-1,
		210,
		184,
		217,
		208,
		191,
		171,
		163,
		182,
		-1,
		152,
		-1,
		127,
		129,
		155,
		158,
		164,
		158,
		131,
		146,
		136,
		127,
		136,
		216,
		-1,
		186,
		219,
		183,
		177,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		180,
		165,
		146,
		133,
		140,
		140,
		133,
		-1,
		-1,
		-1,
		188,
		187,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		170,
		166,
		153,
		153,
		145,
		-1,
		289,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		146,
		181,
		-1,
		284,
		-1,
		218,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		153,
		154,
		-1,
		273,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		135,
		139,
		105,
		99,
		138,
		107,
		113,
		124,
		-1,
		-1,
		-1,
		128,
		127,
		95,
		93,
		102,
		107,
		114,
		-1,
		113,
		-1,
		149,
		128,
		139,
		144,
		88,
		85,
		105,
		124,
		106,
		98,
		164,
		118,
		89,
		83,
		101,
		91,
		100,
		92,
		-1,
		89,
		79,
		101,
		80,
		91,
		83,
		-1,
		-1,
		83,
		84,
		90,
		76,
		82,
		78,
		-1,
		88,
		72,
		-1,
		-1,
		73,
		74,
		58,
		61,
		69,
		67,
		80,
		72,
		67,
		-1,
		-1,
		64,
		60,
		67,
		54,
		50,
		67,
		80,
		62,
		76,
		75,
		-1,
		76,
		90,
		86,
		61,
		59,
		43,
		41,
		59,
		61,
		67,
		70,
		-1,
		85,
		86,
		61,
		69,
		74,
		59,
		46,
		46,
		56,
		49,
		68,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		85,
		68,
		75,
		57,
		47,
		62,
		55,
		49,
		46,
		44,
		41,
		57,
		58,
		68,
		-1,
		-1,
		179,
		152,
		176,
		134,
		115,
		-1,
		81,
		61,
		55,
		51,
		45,
		38,
		52,
		48,
		-1,
		35,
		34,
		65,
		51,
		62,
		146,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		76,
		75,
		68,
		58,
		54,
		35,
		38,
		38,
		44,
		29,
		39,
		43,
		58,
		69,
		-1,
		-1,
		143,
		-1,
		-1,
		143,
		126,
		-1,
		106,
		113,
		97,
		103,
		89,
		110,
		86,
		77,
		71,
		66,
		56,
		33,
		30,
		43,
		32,
		26,
		51,
		55,
		61,
		79,
		80,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		105,
		103,
		127,
		126,
		-1,
		103,
		91,
		92,
		77,
		74,
		61,
		49,
		38,
		22,
		30,
		29,
		33,
		35,
		68,
		63,
		84,
		81,
		112,
		118,
		112,
		121,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		131,
		-1,
		134,
		140,
		115,
		88,
		91,
		78,
		69,
		56,
		45,
		39,
		20,
		17,
		26,
		39,
		46,
		60,
		59,
		77,
		90,
		105,
		109,
		115,
		-1,
		201,
		-1,
		143,
		127,
		129,
		101,
		122,
		-1,
		151,
		135,
		132,
		117,
		117,
		-1,
		87,
		84,
		74,
		52,
		37,
		32,
		17,
		12,
		25,
		46,
		63,
		54,
		72,
		79,
		87,
		91,
		111,
		123,
		161,
		151,
		-1,
		133,
		138,
		97,
		105,
		124,
		162,
		126,
		-1,
		121,
		-1,
		89,
		102,
		-1,
		58,
		54,
		28,
		14,
		0,
		20,
		32,
		45,
		42,
		60,
		63,
		80,
		84,
		100,
		-1,
		-1,
		146,
		150,
		139,
		90,
		109,
		133,
		170,
		119,
		108,
		107,
		-1,
		98,
		64,
		61,
		60,
		47,
		32,
		26,
		9,
		28,
		33,
		44,
		47,
		69,
		97,
		75,
		87,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		116,
		87,
		111,
		153,
		137,
		130,
		118,
		83,
		83,
		77,
		-1,
		71,
		50,
		41,
		30,
		20,
		36,
		38,
		52,
		48,
		50,
		66,
		78,
		69,
		89,
		-1,
		-1,
		-1,
		146,
		135,
		136,
		82,
		105,
		142,
		116,
		102,
		107,
		82,
		75,
		69,
		73,
		67,
		48,
		37,
		29,
		18,
		34,
		42,
		44,
		50,
		59,
		60,
		84,
		91,
		97,
		-1,
		-1,
		153,
		143,
		127,
		129,
		126,
		96,
		103,
		135,
		107,
		120,
		-1,
		74,
		-1,
		63,
		58,
		42,
		37,
		34,
		31,
		25,
		34,
		48,
		59,
		55,
		62,
		89,
		89,
		81,
		106,
		109,
		-1,
		-1,
		-1,
		146,
		141,
		116,
		93,
		77,
		113,
		-1,
		90,
		91,
		-1,
		68,
		62,
		59,
		44,
		40,
		35,
		39,
		32,
		39,
		35,
		49,
		60,
		47,
		83,
		-1,
		89,
		83,
		99,
		89,
		77,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		72,
		124,
		-1,
		-1,
		75,
		68,
		-1,
		55,
		37,
		44,
		42,
		36,
		40,
		44,
		33,
		46,
		51,
		52,
		62,
		82,
		86,
		90,
		79,
		75,
		72,
		86,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		92,
		-1,
		84,
		76,
		66,
		60,
		54,
		50,
		48,
		64,
		48,
		51,
		51,
		47,
		55,
		40,
		43,
		55,
		59,
		77,
		85,
		77,
		71,
		70,
		82,
		-1,
		159,
		145,
		116,
		-1,
		-1,
		105,
		-1,
		69,
		83,
		99,
		-1,
		92,
		71,
		86,
		64,
		60,
		56,
		71,
		72,
		50,
		55,
		54,
		64,
		65,
		54,
		67,
		59,
		81,
		81,
		65,
		66,
		75,
		-1,
		165,
		152,
		110,
		106,
		95,
		115,
		66,
		54,
		86,
		-1,
		-1,
		128,
		-1,
		62,
		79,
		70,
		68,
		61,
		52,
		58,
		65,
		68,
		69,
		59,
		48,
		54,
		53,
		75,
		61,
		59,
		78,
		94,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		68,
		62,
		-1,
		103,
		-1,
		106,
		96,
		80,
		65,
		98,
		-1,
		69,
		53,
		58,
		-1,
		94,
		-1,
		67,
		69,
		61,
		50,
		47,
		58,
		56,
		67,
		84,
		-1,
		115,
		100,
		93,
		83,
		97,
		68,
		-1,
		123,
		-1,
		-1,
		93,
		87,
		87,
		71,
		74,
		85,
		65,
		59,
		58,
		89,
		87,
		75,
		59,
		52,
		49,
		50,
		63,
		83,
		74,
		86,
		-1,
		-1,
		-1,
		120,
		106,
		110,
		70,
		89,
		-1,
		-1,
		155,
		110,
		96,
		-1,
		80,
		102,
		90,
		80,
		70,
		104,
		103,
		78,
		71,
		57,
		59,
		57,
		59,
		64,
		85,
		86,
		99,
		-1,
		-1,
		103,
		108,
		96,
		82,
		101,
		-1,
		-1,
		-1,
		102,
		118,
		110,
		81,
		91,
		-1,
		-1,
		82,
		80,
		90,
		74,
		61,
		81,
		84,
		74,
		58,
		73,
		85,
		93,
		98,
		-1,
		106,
		93,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		113,
		115,
		119,
		85,
		-1,
		90,
		85,
		65,
		79,
		86,
		76,
		71,
		65,
		68,
		86,
		103,
		-1,
		-1,
		118,
		-1,
		113,
		-1,
		-1,
		-1,
		-1,
		92,
		106,
		108,
		101,
		105,
		-1,
		93,
		81,
		67,
		84,
		89,
		86,
		77,
		69,
		74,
		71,
		84,
		98,
		102,
		141,
		-1,
		124,
		-1,
		-1,
		-1,
		110,
		125,
		147,
		124,
		97,
		92,
		85,
		79,
		75,
		91,
		97,
		108,
		76,
		72,
		73,
		77,
		76,
		93,
		103,
		-1,
		-1,
		124,
		141,
		136,
		118,
		122,
		174,
		-1,
		-1,
		101,
		92,
		83,
		86,
		85,
		88,
		82,
		79,
		84,
		89,
		77,
		86,
		104,
		103,
		-1,
		-1,
		-1,
		144,
		-1,
		159,
		-1,
		-1,
		137,
		172,
		119,
		101,
		97,
		95,
		88,
		97,
		92,
		87,
		97,
		99,
		91,
		79,
		83,
		106,
		95,
		134,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		173,
		148,
		163,
		183,
		157,
		164,
		134,
		131,
		-1,
		101,
		126,
		98,
		105,
		96,
		103,
		103,
		95,
		73,
		80,
		96,
		95,
		90,
		126,
		117,
		123,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		179,
		165,
		169,
		159,
		162,
		-1,
		-1,
		150,
		147,
		123,
		106,
		104,
		97,
		92,
		102,
		82,
		69,
		73,
		77,
		83,
		88,
		93,
		99,
		114,
		129,
		-1,
		151,
		232,
		225,
		208,
		216,
		247,
		-1,
		173,
		165,
		172,
		151,
		153,
		-1,
		-1,
		123,
		120,
		125,
		113,
		110,
		112,
		107,
		98,
		83,
		89,
		76,
		75,
		93,
		97,
		106,
		113,
		103,
		116,
		120,
		-1,
		165,
		208,
		202,
		205,
		229,
		243,
		-1,
		170,
		-1,
		-1,
		180,
		154,
		138,
		128,
		122,
		172,
		127,
		122,
		106,
		104,
		95,
		86,
		93,
		84,
		84,
		87,
		102,
		107,
		99,
		113,
		113,
		114,
		-1,
		200,
		188,
		196,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		196,
		-1,
		165,
		-1,
		140,
		144,
		135,
		138,
		120,
		107,
		99,
		91,
		107,
		82,
		92,
		88,
		89,
		98,
		109,
		121,
		120,
		121,
		241,
		197,
		196,
		187,
		222,
		237,
		241,
		-1,
		182,
		221,
		219,
		-1,
		203,
		-1,
		-1,
		-1,
		154,
		148,
		140,
		140,
		119,
		119,
		93,
		97,
		87,
		94,
		104,
		106,
		98,
		102,
		115,
		126,
		129,
		237,
		228,
		241,
		186,
		186,
		207,
		216,
		237,
		197,
		188,
		215,
		226,
		215,
		210,
		197,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		126,
		114,
		97,
		98,
		94,
		97,
		112,
		115,
		105,
		103,
		97,
		129,
		-1,
		230,
		229,
		218,
		215,
		191,
		182,
		177,
		204,
		-1,
		-1,
		199,
		216,
		210,
		214,
		230,
		255,
		-1,
		186,
		-1,
		-1,
		171,
		-1,
		-1,
		156,
		119,
		108,
		99,
		105,
		102,
		113,
		123,
		111,
		112,
		102,
		112,
		125,
		214,
		211,
		199,
		197,
		220,
		185,
		173,
		-1,
		186,
		184,
		190,
		197,
		214,
		244,
		-1,
		-1,
		202,
		182,
		-1,
		-1,
		154,
		152,
		141,
		-1,
		131,
		104,
		109,
		129,
		131,
		120,
		114,
		108,
		115,
		114,
		122,
		130,
		223,
		237,
		226,
		222,
		221,
		229,
		178,
		171,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		192,
		188,
		-1,
		-1,
		149,
		142,
		130,
		118,
		108,
		118,
		122,
		126,
		118,
		111,
		106,
		117,
		109,
		113,
		130,
		-1,
		257,
		-1,
		209,
		185,
		199,
		214,
		222,
		-1,
		-1,
		-1,
		209,
		195,
		188,
		176,
		174,
		-1,
		183,
		167,
		148,
		-1,
		118,
		131,
		162,
		130,
		135,
		130,
		112,
		123,
		112,
		115,
		129,
		124,
		-1,
		-1,
		197,
		200,
		-1,
		-1,
		199,
		201,
		-1,
		200,
		189,
		174,
		166,
		-1,
		-1,
		155,
		151,
		-1,
		-1,
		119,
		144,
		133,
		141,
		136,
		116,
		122,
		125,
		114,
		118,
		130,
		-1,
		-1,
		204,
		205,
		206,
		-1,
		184,
		-1,
		202,
		-1,
		169,
		175,
		163,
		-1,
		-1,
		-1,
		157,
		120,
		141,
		151,
		145,
		143,
		134,
		120,
		127,
		125,
		121,
		132,
		-1,
		-1,
		-1,
		202,
		176,
		209,
		200,
		183,
		163,
		155,
		174,
		-1,
		144,
		-1,
		119,
		121,
		147,
		150,
		156,
		150,
		123,
		138,
		128,
		119,
		128,
		208,
		-1,
		178,
		211,
		175,
		169,
		145,
		149,
		165,
		-1,
		141,
		123,
		-1,
		151,
		141,
		172,
		157,
		138,
		125,
		132,
		132,
		125,
		-1,
		-1,
		-1,
		180,
		179,
		171,
		165,
		165,
		150,
		141,
		-1,
		153,
		135,
		114,
		131,
		131,
		122,
		130,
		162,
		158,
		145,
		145,
		137,
		-1,
		281,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		174,
		169,
		142,
		130,
		136,
		132,
		118,
		124,
		126,
		134,
		132,
		129,
		141,
		137,
		157,
		138,
		173,
		-1,
		276,
		-1,
		210,
		-1,
		-1,
		192,
		172,
		164,
		153,
		142,
		140,
		131,
		122,
		144,
		160,
		144,
		142,
		145,
		146,
		-1,
		265,
		264,
		-1,
		211,
		203,
		189,
		-1,
		182,
		-1,
		188,
		149,
		-1,
		151,
		131,
		-1,
		153,
		149,
		-1,
		-1,
		252,
		227,
		-1,
		-1,
		-1,
		212,
		192,
		183,
		167,
		-1,
		142,
		142,
		-1,
		-1,
		-1,
		237,
		236,
		-1,
		205,
		208,
		-1,
		198,
		189,
		197,
		144,
		148,
		-1,
		-1,
		-1,
		246,
		227,
		221,
		220,
		218,
		213,
		210,
		196,
		180,
		158,
		147,
		168,
		-1,
		-1,
		-1,
		218,
		210,
		203,
		-1,
		-1,
		205,
		188,
		169,
		167,
		-1,
		-1,
		-1,
		240,
		221,
		-1,
		-1,
		195,
		-1,
		-1,
		201,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		229,
		-1,
		-1,
		-1,
		191,
		187,
		188,
		-1,
		-1,
		-1,
		-1,
		251,
		252,
		275,
		239,
		-1,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		254,
		252,
		-1,
		-1,
		-1,
		211,
		195,
		-1,
		181,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		216,
		-1,
		216,
		191,
		198,
		-1,
		-1,
		-1,
		-1,
		229,
		221,
		229,
		-1,
		201,
		203,
		-1,
		251,
		-1,
		-1,
		244,
		235,
		-1,
		-1,
		206,
		213,
		235,
		238,
		274,
		-1,
		225
	],
	[
		-1,
		134,
		123,
		134,
		142,
		115,
		122,
		-1,
		141,
		145,
		111,
		105,
		144,
		113,
		119,
		130,
		-1,
		-1,
		-1,
		134,
		133,
		101,
		99,
		108,
		113,
		120,
		-1,
		119,
		-1,
		155,
		134,
		145,
		150,
		94,
		91,
		111,
		130,
		112,
		104,
		170,
		124,
		95,
		89,
		107,
		97,
		106,
		98,
		-1,
		95,
		85,
		107,
		86,
		97,
		89,
		-1,
		-1,
		89,
		90,
		96,
		82,
		88,
		84,
		-1,
		94,
		78,
		-1,
		-1,
		79,
		80,
		64,
		67,
		75,
		73,
		86,
		78,
		73,
		-1,
		-1,
		70,
		66,
		73,
		60,
		56,
		73,
		86,
		68,
		82,
		81,
		-1,
		82,
		97,
		93,
		67,
		65,
		49,
		47,
		65,
		67,
		73,
		76,
		-1,
		92,
		93,
		68,
		76,
		81,
		65,
		52,
		52,
		62,
		55,
		74,
		65,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		75,
		82,
		64,
		54,
		69,
		62,
		55,
		52,
		50,
		47,
		63,
		64,
		74,
		-1,
		-1,
		186,
		159,
		183,
		141,
		122,
		-1,
		88,
		68,
		62,
		58,
		52,
		45,
		59,
		55,
		-1,
		41,
		40,
		71,
		57,
		68,
		161,
		-1,
		-1,
		144,
		136,
		118,
		121,
		98,
		94,
		83,
		82,
		75,
		68,
		64,
		42,
		45,
		45,
		51,
		35,
		45,
		49,
		64,
		75,
		-1,
		-1,
		149,
		-1,
		-1,
		158,
		141,
		-1,
		113,
		120,
		104,
		110,
		96,
		117,
		93,
		84,
		78,
		73,
		65,
		40,
		37,
		50,
		36,
		32,
		57,
		61,
		67,
		85,
		86,
		-1,
		148,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		117,
		117,
		110,
		134,
		133,
		-1,
		113,
		101,
		102,
		87,
		86,
		76,
		64,
		45,
		29,
		36,
		33,
		39,
		40,
		69,
		69,
		90,
		87,
		118,
		124,
		118,
		127,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		138,
		-1,
		141,
		150,
		125,
		98,
		101,
		88,
		84,
		71,
		60,
		46,
		27,
		24,
		27,
		40,
		47,
		66,
		65,
		83,
		96,
		111,
		115,
		121,
		-1,
		216,
		-1,
		158,
		142,
		144,
		116,
		137,
		-1,
		158,
		142,
		142,
		127,
		127,
		-1,
		102,
		99,
		89,
		67,
		52,
		39,
		28,
		27,
		31,
		47,
		69,
		60,
		78,
		85,
		93,
		97,
		117,
		129,
		176,
		166,
		-1,
		148,
		153,
		112,
		120,
		139,
		177,
		141,
		-1,
		136,
		-1,
		104,
		117,
		-1,
		73,
		69,
		43,
		29,
		15,
		0,
		38,
		50,
		48,
		66,
		69,
		86,
		90,
		106,
		-1,
		-1,
		161,
		165,
		154,
		105,
		124,
		148,
		185,
		134,
		123,
		122,
		-1,
		113,
		79,
		76,
		75,
		62,
		47,
		41,
		24,
		34,
		43,
		50,
		53,
		75,
		103,
		81,
		93,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		131,
		102,
		126,
		168,
		152,
		145,
		133,
		98,
		98,
		92,
		-1,
		86,
		65,
		56,
		45,
		35,
		51,
		46,
		62,
		54,
		56,
		72,
		84,
		75,
		95,
		-1,
		-1,
		-1,
		161,
		150,
		151,
		97,
		120,
		157,
		131,
		117,
		122,
		97,
		90,
		84,
		88,
		82,
		63,
		52,
		44,
		33,
		49,
		56,
		51,
		56,
		65,
		66,
		90,
		97,
		103,
		-1,
		-1,
		168,
		158,
		142,
		144,
		141,
		111,
		118,
		150,
		122,
		135,
		-1,
		89,
		-1,
		78,
		73,
		57,
		52,
		49,
		46,
		40,
		49,
		57,
		69,
		61,
		76,
		95,
		95,
		87,
		112,
		115,
		-1,
		-1,
		-1,
		161,
		156,
		131,
		108,
		92,
		128,
		-1,
		105,
		106,
		-1,
		83,
		77,
		74,
		59,
		55,
		50,
		54,
		47,
		54,
		50,
		64,
		75,
		62,
		98,
		-1,
		95,
		89,
		114,
		104,
		92,
		-1,
		-1,
		-1,
		154,
		133,
		126,
		146,
		87,
		139,
		-1,
		-1,
		90,
		83,
		-1,
		70,
		52,
		59,
		57,
		51,
		55,
		59,
		48,
		61,
		66,
		67,
		77,
		97,
		101,
		105,
		94,
		90,
		87,
		101,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		107,
		-1,
		99,
		91,
		81,
		75,
		69,
		65,
		63,
		79,
		63,
		66,
		66,
		62,
		70,
		55,
		58,
		70,
		74,
		92,
		100,
		92,
		86,
		85,
		97,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		120,
		-1,
		84,
		98,
		114,
		-1,
		107,
		86,
		101,
		79,
		75,
		71,
		86,
		87,
		65,
		70,
		69,
		79,
		80,
		69,
		82,
		74,
		96,
		96,
		80,
		81,
		90,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		81,
		69,
		101,
		-1,
		-1,
		143,
		-1,
		77,
		94,
		85,
		83,
		76,
		67,
		73,
		80,
		83,
		84,
		74,
		63,
		69,
		68,
		90,
		76,
		74,
		93,
		109,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		121,
		111,
		95,
		80,
		113,
		-1,
		84,
		68,
		73,
		-1,
		109,
		-1,
		82,
		84,
		76,
		65,
		62,
		73,
		71,
		82,
		99,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		138,
		-1,
		-1,
		108,
		102,
		102,
		86,
		89,
		100,
		80,
		74,
		73,
		104,
		102,
		90,
		74,
		67,
		64,
		65,
		78,
		98,
		89,
		101,
		-1,
		-1,
		-1,
		135,
		121,
		125,
		85,
		104,
		-1,
		-1,
		170,
		125,
		111,
		-1,
		95,
		117,
		105,
		95,
		85,
		119,
		118,
		93,
		86,
		72,
		74,
		72,
		74,
		79,
		100,
		101,
		114,
		-1,
		-1,
		118,
		123,
		111,
		97,
		116,
		-1,
		-1,
		-1,
		117,
		133,
		125,
		96,
		106,
		-1,
		-1,
		97,
		95,
		105,
		89,
		76,
		96,
		99,
		89,
		73,
		88,
		100,
		108,
		113,
		-1,
		121,
		108,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		128,
		130,
		134,
		100,
		-1,
		105,
		100,
		80,
		94,
		101,
		91,
		86,
		80,
		83,
		101,
		118,
		-1,
		-1,
		133,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		107,
		121,
		123,
		116,
		120,
		-1,
		108,
		96,
		82,
		99,
		104,
		101,
		92,
		84,
		89,
		86,
		99,
		113,
		117,
		156,
		-1,
		139,
		-1,
		-1,
		-1,
		125,
		140,
		162,
		139,
		112,
		107,
		100,
		94,
		90,
		106,
		112,
		123,
		91,
		87,
		88,
		92,
		91,
		108,
		118,
		-1,
		-1,
		139,
		156,
		151,
		133,
		137,
		189,
		-1,
		-1,
		116,
		107,
		98,
		101,
		100,
		103,
		97,
		94,
		99,
		104,
		92,
		101,
		119,
		118,
		-1,
		-1,
		-1,
		159,
		-1,
		174,
		-1,
		-1,
		152,
		187,
		134,
		116,
		112,
		110,
		103,
		112,
		107,
		102,
		112,
		114,
		106,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		188,
		163,
		178,
		198,
		172,
		179,
		149,
		146,
		-1,
		116,
		141,
		113,
		120,
		111,
		118,
		118,
		110,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		194,
		180,
		184,
		174,
		177,
		-1,
		-1,
		165,
		162,
		138,
		121,
		119,
		112,
		107,
		117,
		97,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		166,
		247,
		240,
		223,
		231,
		262,
		-1,
		188,
		180,
		187,
		166,
		168,
		-1,
		-1,
		138,
		135,
		140,
		128,
		125,
		127,
		122,
		113,
		98,
		104,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		180,
		223,
		217,
		220,
		244,
		258,
		-1,
		185,
		-1,
		-1,
		195,
		169,
		153,
		143,
		137,
		187,
		142,
		137,
		121,
		119,
		110,
		101,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		215,
		203,
		211,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		211,
		-1,
		180,
		-1,
		155,
		159,
		150,
		153,
		135,
		122,
		114,
		106,
		122,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		256,
		212,
		211,
		202,
		237,
		252,
		256,
		-1,
		197,
		236,
		234,
		-1,
		218,
		-1,
		-1,
		-1,
		169,
		163,
		155,
		155,
		134,
		134,
		108,
		112,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		252,
		243,
		256,
		201,
		201,
		222,
		231,
		252,
		212,
		203,
		230,
		241,
		230,
		225,
		212,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		141,
		129,
		112,
		113,
		109,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		245,
		244,
		233,
		230,
		206,
		197,
		192,
		219,
		-1,
		-1,
		214,
		231,
		225,
		229,
		245,
		270,
		-1,
		201,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		117,
		128,
		138,
		126,
		127,
		117,
		127,
		140,
		229,
		226,
		214,
		212,
		235,
		200,
		188,
		-1,
		201,
		199,
		205,
		212,
		229,
		259,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		144,
		146,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		238,
		252,
		241,
		237,
		236,
		244,
		193,
		186,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		137,
		141,
		133,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		272,
		-1,
		224,
		200,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		214,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		219,
		220,
		221,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		160,
		158,
		149,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		136,
		162,
		165,
		171,
		165,
		138,
		153,
		143,
		134,
		143,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		187,
		172,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		177,
		173,
		160,
		160,
		152,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		153,
		188,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		160,
		161,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		127,
		116,
		127,
		135,
		108,
		115,
		-1,
		134,
		138,
		104,
		98,
		137,
		106,
		112,
		123,
		-1,
		-1,
		-1,
		127,
		126,
		94,
		92,
		101,
		106,
		113,
		-1,
		112,
		-1,
		148,
		127,
		138,
		143,
		87,
		84,
		104,
		123,
		105,
		97,
		163,
		117,
		88,
		82,
		100,
		90,
		99,
		91,
		-1,
		88,
		78,
		100,
		79,
		90,
		82,
		-1,
		-1,
		82,
		83,
		89,
		75,
		81,
		77,
		-1,
		87,
		71,
		-1,
		-1,
		72,
		73,
		57,
		60,
		68,
		66,
		79,
		71,
		66,
		-1,
		-1,
		63,
		59,
		66,
		53,
		49,
		66,
		79,
		61,
		75,
		74,
		-1,
		75,
		92,
		92,
		60,
		58,
		42,
		40,
		58,
		60,
		66,
		69,
		-1,
		92,
		88,
		70,
		78,
		82,
		58,
		45,
		45,
		55,
		48,
		67,
		58,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		77,
		84,
		66,
		56,
		71,
		64,
		48,
		45,
		43,
		40,
		56,
		57,
		67,
		-1,
		-1,
		186,
		159,
		183,
		141,
		123,
		-1,
		89,
		70,
		64,
		60,
		54,
		47,
		61,
		57,
		-1,
		34,
		33,
		64,
		50,
		61,
		165,
		-1,
		-1,
		144,
		136,
		118,
		121,
		98,
		94,
		85,
		84,
		77,
		70,
		66,
		44,
		47,
		47,
		53,
		28,
		38,
		42,
		51,
		68,
		-1,
		-1,
		121,
		-1,
		-1,
		162,
		145,
		-1,
		113,
		120,
		104,
		110,
		96,
		117,
		95,
		86,
		80,
		75,
		67,
		42,
		39,
		52,
		25,
		25,
		50,
		54,
		46,
		67,
		62,
		-1,
		120,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		120,
		117,
		110,
		134,
		133,
		-1,
		115,
		103,
		104,
		89,
		88,
		82,
		70,
		47,
		31,
		31,
		22,
		31,
		29,
		58,
		43,
		65,
		62,
		91,
		96,
		90,
		99,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		138,
		-1,
		141,
		152,
		127,
		100,
		103,
		90,
		90,
		77,
		66,
		48,
		29,
		26,
		16,
		29,
		36,
		38,
		37,
		55,
		70,
		83,
		87,
		93,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		158,
		142,
		144,
		129,
		129,
		-1,
		106,
		103,
		95,
		73,
		58,
		41,
		29,
		24,
		7,
		27,
		41,
		32,
		50,
		57,
		65,
		69,
		89,
		101,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		181,
		145,
		-1,
		140,
		-1,
		108,
		121,
		-1,
		79,
		75,
		49,
		37,
		26,
		33,
		0,
		23,
		20,
		38,
		41,
		58,
		62,
		78,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		117,
		85,
		82,
		79,
		66,
		51,
		49,
		32,
		34,
		24,
		22,
		25,
		47,
		75,
		53,
		65,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		90,
		69,
		60,
		49,
		39,
		48,
		24,
		43,
		26,
		28,
		44,
		56,
		47,
		67,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		88,
		94,
		86,
		67,
		56,
		48,
		37,
		28,
		34,
		29,
		28,
		37,
		38,
		62,
		69,
		75,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		93,
		-1,
		82,
		77,
		61,
		56,
		53,
		48,
		35,
		45,
		35,
		42,
		33,
		48,
		67,
		67,
		59,
		84,
		87,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		87,
		81,
		78,
		63,
		59,
		52,
		56,
		50,
		49,
		49,
		51,
		52,
		34,
		70,
		-1,
		67,
		61,
		89,
		92,
		82,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		74,
		56,
		63,
		59,
		55,
		57,
		56,
		45,
		58,
		59,
		39,
		49,
		69,
		73,
		80,
		73,
		78,
		77,
		91,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		69,
		67,
		83,
		67,
		69,
		68,
		59,
		67,
		52,
		55,
		42,
		46,
		64,
		91,
		86,
		81,
		80,
		87,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		79,
		75,
		90,
		91,
		69,
		68,
		66,
		76,
		77,
		66,
		54,
		58,
		73,
		83,
		75,
		76,
		85,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		89,
		87,
		80,
		71,
		77,
		77,
		80,
		81,
		71,
		60,
		66,
		63,
		85,
		71,
		69,
		88,
		103,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		88,
		72,
		77,
		-1,
		106,
		-1,
		79,
		80,
		71,
		60,
		57,
		68,
		66,
		77,
		94,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		104,
		84,
		78,
		77,
		101,
		97,
		87,
		69,
		62,
		59,
		60,
		73,
		93,
		84,
		96,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		121,
		109,
		99,
		89,
		123,
		113,
		88,
		81,
		67,
		69,
		67,
		69,
		74,
		95,
		96,
		109,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		110,
		-1,
		-1,
		101,
		99,
		105,
		84,
		71,
		91,
		94,
		84,
		68,
		83,
		95,
		103,
		108,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		154,
		120,
		130,
		125,
		129,
		104,
		-1,
		101,
		95,
		75,
		89,
		96,
		86,
		81,
		75,
		78,
		96,
		113,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		111,
		125,
		118,
		111,
		115,
		-1,
		103,
		91,
		77,
		94,
		99,
		96,
		87,
		79,
		84,
		81,
		94,
		108,
		112,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		129,
		144,
		157,
		134,
		107,
		102,
		95,
		89,
		85,
		101,
		107,
		118,
		86,
		82,
		83,
		87,
		86,
		103,
		113,
		-1,
		-1,
		143,
		160,
		155,
		137,
		141,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		95,
		98,
		92,
		89,
		94,
		99,
		87,
		96,
		114,
		113,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		156,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		97,
		107,
		109,
		101,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		192,
		167,
		182,
		193,
		176,
		183,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		106,
		113,
		113,
		105,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		193,
		184,
		179,
		169,
		172,
		-1,
		-1,
		160,
		157,
		133,
		116,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		170,
		251,
		244,
		227,
		235,
		266,
		-1,
		183,
		175,
		186,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		123,
		120,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		184,
		227,
		221,
		224,
		248,
		262,
		-1,
		180,
		-1,
		-1,
		192,
		164,
		148,
		138,
		132,
		182,
		137,
		132,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		219,
		207,
		215,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		208,
		-1,
		175,
		-1,
		150,
		154,
		145,
		148,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		251,
		207,
		210,
		206,
		232,
		247,
		251,
		-1,
		192,
		231,
		229,
		-1,
		213,
		-1,
		-1,
		-1,
		164,
		158,
		150,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		207,
		198,
		225,
		236,
		225,
		220,
		207,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		226,
		220,
		224,
		240,
		265,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		214,
		215,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		122,
		111,
		122,
		130,
		103,
		110,
		-1,
		129,
		133,
		99,
		93,
		132,
		101,
		107,
		118,
		-1,
		-1,
		-1,
		122,
		121,
		89,
		87,
		96,
		101,
		108,
		-1,
		107,
		-1,
		143,
		122,
		133,
		138,
		82,
		79,
		99,
		118,
		100,
		92,
		158,
		112,
		83,
		77,
		95,
		85,
		94,
		86,
		-1,
		83,
		73,
		95,
		74,
		85,
		77,
		-1,
		-1,
		77,
		78,
		84,
		70,
		76,
		72,
		-1,
		82,
		66,
		-1,
		-1,
		67,
		68,
		52,
		55,
		63,
		61,
		74,
		66,
		61,
		-1,
		-1,
		58,
		54,
		61,
		48,
		44,
		61,
		74,
		56,
		70,
		69,
		-1,
		70,
		87,
		87,
		55,
		53,
		37,
		35,
		53,
		55,
		61,
		61,
		-1,
		87,
		83,
		84,
		82,
		77,
		53,
		40,
		40,
		50,
		43,
		62,
		50,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		88,
		79,
		96,
		80,
		70,
		74,
		72,
		43,
		40,
		38,
		35,
		51,
		49,
		59,
		-1,
		-1,
		181,
		154,
		178,
		136,
		118,
		-1,
		84,
		84,
		78,
		74,
		68,
		61,
		74,
		59,
		-1,
		29,
		28,
		56,
		42,
		53,
		163,
		-1,
		-1,
		139,
		131,
		113,
		116,
		93,
		89,
		99,
		98,
		91,
		80,
		76,
		58,
		61,
		61,
		67,
		23,
		33,
		37,
		35,
		60,
		-1,
		-1,
		105,
		-1,
		-1,
		160,
		143,
		-1,
		108,
		115,
		99,
		105,
		91,
		112,
		109,
		100,
		94,
		89,
		78,
		56,
		53,
		66,
		45,
		20,
		45,
		49,
		30,
		51,
		46,
		-1,
		104,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		115,
		112,
		105,
		129,
		128,
		-1,
		125,
		113,
		114,
		99,
		96,
		83,
		71,
		61,
		45,
		45,
		42,
		17,
		15,
		45,
		27,
		49,
		46,
		75,
		80,
		74,
		83,
		-1,
		168,
		164,
		160,
		167,
		116,
		-1,
		-1,
		133,
		-1,
		136,
		149,
		137,
		110,
		113,
		100,
		91,
		78,
		67,
		62,
		43,
		40,
		29,
		9,
		24,
		22,
		21,
		39,
		54,
		67,
		71,
		77,
		-1,
		218,
		-1,
		160,
		144,
		146,
		120,
		141,
		-1,
		153,
		137,
		154,
		139,
		139,
		-1,
		109,
		106,
		96,
		74,
		59,
		55,
		43,
		38,
		29,
		4,
		25,
		16,
		34,
		41,
		49,
		53,
		73,
		85,
		178,
		168,
		-1,
		150,
		155,
		116,
		124,
		143,
		180,
		145,
		-1,
		140,
		-1,
		111,
		124,
		-1,
		80,
		76,
		58,
		51,
		40,
		47,
		22,
		0,
		4,
		22,
		25,
		42,
		46,
		62,
		-1,
		-1,
		163,
		167,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		117,
		94,
		91,
		79,
		66,
		51,
		52,
		46,
		42,
		21,
		6,
		9,
		31,
		59,
		37,
		49,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		90,
		69,
		60,
		49,
		47,
		54,
		27,
		30,
		10,
		12,
		28,
		40,
		31,
		51,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		88,
		103,
		86,
		67,
		56,
		48,
		37,
		28,
		38,
		32,
		12,
		21,
		22,
		46,
		53,
		59,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		93,
		-1,
		82,
		77,
		61,
		56,
		53,
		46,
		33,
		43,
		40,
		26,
		17,
		32,
		51,
		51,
		43,
		68,
		71,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		87,
		81,
		78,
		63,
		59,
		50,
		54,
		48,
		47,
		43,
		35,
		36,
		18,
		54,
		-1,
		51,
		45,
		73,
		76,
		66,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		74,
		56,
		62,
		57,
		55,
		55,
		54,
		43,
		51,
		43,
		23,
		33,
		53,
		57,
		64,
		57,
		62,
		61,
		75,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		69,
		67,
		83,
		67,
		67,
		66,
		57,
		65,
		47,
		40,
		26,
		30,
		48,
		75,
		70,
		65,
		64,
		71,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		79,
		74,
		90,
		91,
		69,
		66,
		64,
		74,
		62,
		51,
		38,
		42,
		57,
		67,
		59,
		60,
		69,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		88,
		86,
		80,
		71,
		77,
		75,
		71,
		66,
		56,
		45,
		51,
		47,
		69,
		55,
		53,
		72,
		87,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		88,
		72,
		77,
		-1,
		91,
		-1,
		64,
		64,
		55,
		44,
		41,
		52,
		50,
		61,
		78,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		104,
		84,
		78,
		77,
		86,
		81,
		72,
		53,
		46,
		43,
		44,
		57,
		77,
		68,
		80,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		121,
		109,
		99,
		89,
		107,
		97,
		72,
		65,
		51,
		53,
		51,
		53,
		58,
		79,
		80,
		93,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		110,
		-1,
		-1,
		101,
		99,
		89,
		68,
		55,
		75,
		78,
		68,
		52,
		67,
		79,
		87,
		92,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		154,
		120,
		114,
		109,
		113,
		104,
		-1,
		85,
		79,
		59,
		73,
		80,
		70,
		65,
		59,
		62,
		80,
		97,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		111,
		125,
		102,
		95,
		99,
		-1,
		87,
		75,
		61,
		78,
		83,
		80,
		71,
		63,
		68,
		65,
		78,
		92,
		96,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		129,
		144,
		141,
		118,
		91,
		86,
		79,
		73,
		69,
		85,
		91,
		102,
		70,
		66,
		67,
		71,
		70,
		87,
		97,
		-1,
		-1,
		143,
		160,
		155,
		137,
		141,
		168,
		-1,
		-1,
		95,
		86,
		77,
		80,
		79,
		82,
		76,
		73,
		78,
		83,
		71,
		80,
		98,
		97,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		156,
		166,
		113,
		95,
		91,
		89,
		82,
		91,
		86,
		81,
		91,
		93,
		85,
		73,
		77,
		100,
		89,
		128,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		184,
		167,
		171,
		177,
		176,
		170,
		128,
		125,
		-1,
		95,
		120,
		92,
		99,
		90,
		97,
		97,
		89,
		67,
		74,
		90,
		89,
		84,
		120,
		111,
		117,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		177,
		173,
		163,
		153,
		156,
		-1,
		-1,
		144,
		141,
		117,
		100,
		98,
		91,
		86,
		96,
		76,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		170,
		251,
		244,
		226,
		234,
		265,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		117,
		114,
		119,
		107,
		104,
		106,
		101,
		92,
		77,
		83,
		70,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		184,
		227,
		220,
		223,
		247,
		261,
		-1,
		164,
		-1,
		-1,
		176,
		148,
		132,
		122,
		116,
		166,
		121,
		116,
		100,
		98,
		89,
		80,
		87,
		78,
		78,
		81,
		96,
		101,
		93,
		107,
		107,
		108,
		-1,
		210,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		192,
		-1,
		159,
		-1,
		134,
		138,
		129,
		132,
		114,
		101,
		93,
		85,
		101,
		76,
		86,
		82,
		83,
		92,
		103,
		115,
		114,
		115,
		235,
		191,
		194,
		205,
		216,
		231,
		235,
		-1,
		176,
		215,
		213,
		-1,
		197,
		-1,
		-1,
		-1,
		148,
		142,
		134,
		134,
		113,
		113,
		87,
		91,
		81,
		88,
		98,
		100,
		92,
		96,
		109,
		120,
		123,
		231,
		222,
		235,
		180,
		180,
		201,
		210,
		231,
		191,
		182,
		209,
		220,
		209,
		204,
		191,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		120,
		108,
		91,
		92,
		88,
		91,
		106,
		109,
		99,
		97,
		91,
		123,
		-1,
		224,
		223,
		212,
		209,
		185,
		176,
		171,
		198,
		-1,
		-1,
		193,
		210,
		204,
		208,
		224,
		249,
		-1,
		180,
		-1,
		-1,
		165,
		-1,
		-1,
		150,
		113,
		102,
		93,
		99,
		96,
		107,
		117,
		105,
		106,
		96,
		106,
		119,
		208,
		205,
		193,
		191,
		214,
		179,
		167,
		-1,
		180,
		178,
		184,
		191,
		208,
		238,
		-1,
		-1,
		196,
		176,
		-1,
		-1,
		148,
		146,
		135,
		-1,
		125,
		98,
		103,
		123,
		125,
		114,
		108,
		102,
		109,
		108,
		116,
		124,
		217,
		231,
		220,
		216,
		215,
		223,
		172,
		165,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		186,
		182,
		-1,
		-1,
		143,
		136,
		124,
		112,
		102,
		112,
		116,
		120,
		112,
		105,
		100,
		111,
		103,
		107,
		124,
		-1,
		251,
		-1,
		203,
		179,
		193,
		208,
		216,
		-1,
		-1,
		-1,
		203,
		189,
		182,
		170,
		168,
		-1,
		177,
		161,
		142,
		-1,
		112,
		125,
		156,
		124,
		129,
		124,
		106,
		117,
		106,
		109,
		123,
		118,
		-1,
		-1,
		191,
		194,
		-1,
		-1,
		193,
		195,
		-1,
		194,
		183,
		168,
		160,
		-1,
		-1,
		149,
		145,
		-1,
		-1,
		113,
		138,
		127,
		135,
		130,
		110,
		116,
		119,
		108,
		112,
		124,
		-1,
		-1,
		198,
		199,
		200,
		-1,
		178,
		-1,
		196,
		-1,
		163,
		169,
		157,
		-1,
		-1,
		-1,
		151,
		114,
		135,
		145,
		139,
		137,
		128,
		114,
		121,
		119,
		115,
		126,
		-1,
		-1,
		-1,
		196,
		170,
		203,
		194,
		177,
		157,
		149,
		168,
		-1,
		138,
		-1,
		113,
		115,
		141,
		144,
		150,
		144,
		117,
		132,
		122,
		113,
		122,
		202,
		-1,
		172,
		205,
		169,
		163,
		139,
		143,
		159,
		-1,
		135,
		117,
		-1,
		145,
		135,
		166,
		151,
		132,
		119,
		126,
		126,
		119,
		-1,
		-1,
		-1,
		174,
		173,
		165,
		159,
		159,
		144,
		135,
		-1,
		147,
		129,
		108,
		125,
		125,
		116,
		124,
		156,
		152,
		139,
		139,
		131,
		-1,
		275,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		168,
		163,
		136,
		124,
		130,
		126,
		112,
		118,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		132,
		167,
		-1,
		270,
		-1,
		204,
		-1,
		-1,
		186,
		166,
		158,
		147,
		136,
		134,
		125,
		116,
		138,
		154,
		138,
		136,
		139,
		140,
		-1,
		259,
		258,
		-1,
		205,
		197,
		183,
		-1,
		176,
		-1,
		182,
		143,
		-1,
		145,
		125,
		-1,
		147,
		143,
		-1,
		-1,
		246,
		221,
		-1,
		-1,
		-1,
		206,
		186,
		177,
		161,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		231,
		230,
		-1,
		199,
		202,
		-1,
		192,
		183,
		191,
		138,
		142,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		214,
		212,
		207,
		204,
		190,
		174,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		212,
		204,
		197,
		-1,
		-1,
		199,
		182,
		163,
		161,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		189,
		-1,
		-1,
		195,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		223,
		-1,
		-1,
		-1,
		185,
		181,
		182,
		-1,
		-1,
		-1,
		-1,
		245,
		246,
		269,
		233,
		-1,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		248,
		246,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		175,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		210,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		223,
		215,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		200,
		207,
		229,
		232,
		268,
		-1,
		219
	],
	[
		-1,
		118,
		107,
		118,
		126,
		99,
		106,
		-1,
		125,
		129,
		95,
		89,
		128,
		97,
		103,
		114,
		-1,
		-1,
		-1,
		118,
		117,
		85,
		83,
		92,
		97,
		104,
		-1,
		103,
		-1,
		139,
		118,
		129,
		134,
		78,
		75,
		95,
		114,
		96,
		88,
		154,
		108,
		79,
		73,
		91,
		81,
		90,
		82,
		-1,
		79,
		69,
		91,
		70,
		81,
		73,
		-1,
		-1,
		73,
		74,
		80,
		66,
		72,
		68,
		-1,
		78,
		62,
		-1,
		-1,
		63,
		64,
		48,
		51,
		59,
		57,
		70,
		62,
		57,
		-1,
		-1,
		54,
		50,
		57,
		44,
		40,
		57,
		70,
		52,
		66,
		65,
		-1,
		66,
		83,
		83,
		51,
		49,
		33,
		31,
		49,
		51,
		57,
		57,
		-1,
		83,
		79,
		80,
		78,
		73,
		49,
		36,
		36,
		46,
		39,
		58,
		46,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		84,
		75,
		92,
		76,
		66,
		70,
		68,
		39,
		36,
		34,
		31,
		47,
		45,
		55,
		-1,
		-1,
		177,
		150,
		174,
		132,
		114,
		-1,
		80,
		80,
		74,
		70,
		64,
		57,
		70,
		55,
		-1,
		25,
		24,
		52,
		38,
		49,
		159,
		-1,
		-1,
		135,
		127,
		109,
		112,
		89,
		85,
		95,
		94,
		87,
		76,
		72,
		54,
		57,
		57,
		63,
		19,
		29,
		33,
		31,
		56,
		-1,
		-1,
		101,
		-1,
		-1,
		156,
		139,
		-1,
		104,
		111,
		95,
		101,
		87,
		108,
		105,
		96,
		90,
		85,
		74,
		52,
		49,
		62,
		41,
		16,
		41,
		45,
		26,
		47,
		42,
		-1,
		100,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		111,
		108,
		101,
		125,
		124,
		-1,
		121,
		109,
		110,
		95,
		92,
		79,
		67,
		57,
		41,
		41,
		38,
		20,
		18,
		48,
		23,
		45,
		42,
		71,
		76,
		70,
		79,
		-1,
		164,
		160,
		156,
		163,
		112,
		-1,
		-1,
		129,
		-1,
		132,
		145,
		133,
		106,
		109,
		96,
		87,
		74,
		63,
		58,
		39,
		36,
		32,
		12,
		27,
		18,
		17,
		35,
		50,
		63,
		67,
		73,
		-1,
		214,
		-1,
		156,
		140,
		142,
		116,
		137,
		-1,
		149,
		133,
		150,
		135,
		135,
		-1,
		105,
		102,
		92,
		70,
		55,
		51,
		39,
		34,
		25,
		7,
		21,
		12,
		30,
		37,
		45,
		49,
		69,
		81,
		174,
		164,
		-1,
		146,
		151,
		112,
		120,
		139,
		176,
		141,
		-1,
		136,
		-1,
		107,
		120,
		-1,
		76,
		72,
		54,
		47,
		36,
		43,
		18,
		3,
		0,
		18,
		21,
		38,
		42,
		58,
		-1,
		-1,
		159,
		163,
		154,
		105,
		124,
		148,
		185,
		134,
		123,
		122,
		-1,
		113,
		90,
		87,
		75,
		62,
		47,
		48,
		42,
		38,
		17,
		2,
		5,
		27,
		55,
		33,
		45,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		131,
		102,
		126,
		168,
		152,
		145,
		133,
		98,
		98,
		92,
		-1,
		86,
		65,
		56,
		45,
		43,
		50,
		23,
		26,
		6,
		8,
		24,
		36,
		27,
		47,
		-1,
		-1,
		-1,
		161,
		150,
		151,
		97,
		120,
		157,
		131,
		117,
		122,
		97,
		90,
		84,
		99,
		82,
		63,
		52,
		44,
		33,
		24,
		34,
		28,
		8,
		17,
		18,
		42,
		49,
		55,
		-1,
		-1,
		168,
		158,
		142,
		144,
		141,
		111,
		118,
		150,
		122,
		135,
		-1,
		89,
		-1,
		78,
		73,
		57,
		52,
		49,
		42,
		29,
		39,
		36,
		22,
		13,
		28,
		47,
		47,
		39,
		64,
		67,
		-1,
		-1,
		-1,
		161,
		156,
		131,
		108,
		92,
		128,
		-1,
		105,
		106,
		-1,
		83,
		77,
		74,
		59,
		55,
		46,
		50,
		44,
		43,
		39,
		31,
		32,
		14,
		50,
		-1,
		47,
		41,
		69,
		72,
		62,
		-1,
		-1,
		-1,
		154,
		133,
		126,
		146,
		87,
		139,
		-1,
		-1,
		90,
		83,
		-1,
		70,
		52,
		58,
		53,
		51,
		51,
		50,
		39,
		47,
		39,
		19,
		29,
		49,
		53,
		60,
		53,
		58,
		57,
		71,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		107,
		-1,
		99,
		91,
		81,
		75,
		69,
		65,
		63,
		79,
		63,
		63,
		62,
		53,
		61,
		43,
		36,
		22,
		26,
		44,
		71,
		66,
		61,
		60,
		67,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		120,
		-1,
		84,
		98,
		114,
		-1,
		107,
		86,
		101,
		79,
		75,
		70,
		86,
		87,
		65,
		62,
		60,
		70,
		58,
		47,
		34,
		38,
		53,
		63,
		55,
		56,
		65,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		81,
		69,
		101,
		-1,
		-1,
		143,
		-1,
		77,
		94,
		84,
		82,
		76,
		67,
		73,
		71,
		67,
		62,
		52,
		41,
		47,
		43,
		65,
		51,
		49,
		68,
		83,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		121,
		111,
		95,
		80,
		113,
		-1,
		84,
		68,
		73,
		-1,
		87,
		-1,
		60,
		60,
		51,
		40,
		37,
		48,
		46,
		57,
		74,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		138,
		-1,
		-1,
		108,
		102,
		102,
		86,
		89,
		100,
		80,
		74,
		73,
		82,
		77,
		68,
		49,
		42,
		39,
		40,
		53,
		73,
		64,
		76,
		-1,
		-1,
		-1,
		135,
		121,
		125,
		85,
		104,
		-1,
		-1,
		170,
		125,
		111,
		-1,
		95,
		117,
		105,
		95,
		85,
		103,
		93,
		68,
		61,
		47,
		49,
		47,
		49,
		54,
		75,
		76,
		89,
		-1,
		-1,
		118,
		123,
		111,
		97,
		116,
		-1,
		-1,
		-1,
		117,
		133,
		125,
		96,
		106,
		-1,
		-1,
		97,
		95,
		85,
		64,
		51,
		71,
		74,
		64,
		48,
		63,
		75,
		83,
		88,
		-1,
		121,
		108,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		110,
		105,
		109,
		100,
		-1,
		81,
		75,
		55,
		69,
		76,
		66,
		61,
		55,
		58,
		76,
		93,
		-1,
		-1,
		133,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		107,
		121,
		98,
		91,
		95,
		-1,
		83,
		71,
		57,
		74,
		79,
		76,
		67,
		59,
		64,
		61,
		74,
		88,
		92,
		156,
		-1,
		139,
		-1,
		-1,
		-1,
		125,
		140,
		137,
		114,
		87,
		82,
		75,
		69,
		65,
		81,
		87,
		98,
		66,
		62,
		63,
		67,
		66,
		83,
		93,
		-1,
		-1,
		139,
		156,
		151,
		133,
		137,
		164,
		-1,
		-1,
		91,
		82,
		73,
		76,
		75,
		78,
		72,
		69,
		74,
		79,
		67,
		76,
		94,
		93,
		-1,
		-1,
		-1,
		159,
		-1,
		174,
		-1,
		-1,
		152,
		162,
		109,
		91,
		87,
		85,
		78,
		87,
		82,
		77,
		87,
		89,
		81,
		69,
		73,
		96,
		85,
		124,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		180,
		163,
		167,
		173,
		172,
		166,
		124,
		121,
		-1,
		91,
		116,
		88,
		95,
		86,
		93,
		93,
		85,
		63,
		70,
		86,
		85,
		80,
		116,
		107,
		113,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		173,
		169,
		159,
		149,
		152,
		-1,
		-1,
		140,
		137,
		113,
		96,
		94,
		87,
		82,
		92,
		72,
		59,
		63,
		67,
		73,
		78,
		83,
		89,
		104,
		119,
		-1,
		166,
		247,
		240,
		222,
		230,
		261,
		-1,
		163,
		155,
		166,
		141,
		143,
		-1,
		-1,
		113,
		110,
		115,
		103,
		100,
		102,
		97,
		88,
		73,
		79,
		66,
		65,
		83,
		87,
		96,
		103,
		93,
		106,
		110,
		-1,
		180,
		223,
		216,
		219,
		243,
		257,
		-1,
		160,
		-1,
		-1,
		172,
		144,
		128,
		118,
		112,
		162,
		117,
		112,
		96,
		94,
		85,
		76,
		83,
		74,
		74,
		77,
		92,
		97,
		89,
		103,
		103,
		104,
		-1,
		206,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		188,
		-1,
		155,
		-1,
		130,
		134,
		125,
		128,
		110,
		97,
		89,
		81,
		97,
		72,
		82,
		78,
		79,
		88,
		99,
		111,
		110,
		111,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		172,
		211,
		209,
		-1,
		193,
		-1,
		-1,
		-1,
		144,
		138,
		130,
		130,
		109,
		109,
		83,
		87,
		77,
		84,
		94,
		96,
		88,
		92,
		105,
		116,
		119,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		187,
		178,
		205,
		216,
		205,
		200,
		187,
		-1,
		-1,
		167,
		148,
		-1,
		-1,
		116,
		104,
		87,
		88,
		84,
		87,
		102,
		105,
		95,
		93,
		87,
		119,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		206,
		200,
		204,
		220,
		245,
		-1,
		176,
		-1,
		-1,
		161,
		-1,
		-1,
		146,
		109,
		98,
		89,
		95,
		92,
		103,
		113,
		101,
		102,
		92,
		102,
		115,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		192,
		172,
		-1,
		-1,
		144,
		142,
		131,
		-1,
		121,
		94,
		99,
		119,
		121,
		110,
		104,
		98,
		105,
		104,
		112,
		120,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		139,
		132,
		120,
		108,
		98,
		108,
		112,
		116,
		108,
		101,
		96,
		107,
		99,
		103,
		120,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		173,
		157,
		138,
		-1,
		108,
		121,
		152,
		120,
		125,
		120,
		102,
		113,
		102,
		105,
		119,
		114,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		189,
		191,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		134,
		123,
		131,
		126,
		106,
		112,
		115,
		104,
		108,
		120,
		-1,
		-1,
		194,
		195,
		196,
		-1,
		174,
		-1,
		192,
		-1,
		159,
		165,
		153,
		-1,
		-1,
		-1,
		147,
		110,
		131,
		141,
		135,
		133,
		124,
		110,
		117,
		115,
		111,
		122,
		-1,
		-1,
		-1,
		192,
		166,
		199,
		190,
		173,
		153,
		145,
		164,
		-1,
		134,
		-1,
		109,
		111,
		137,
		140,
		146,
		140,
		113,
		128,
		118,
		109,
		118,
		198,
		-1,
		168,
		201,
		165,
		159,
		135,
		139,
		155,
		-1,
		131,
		113,
		-1,
		141,
		131,
		162,
		147,
		128,
		115,
		122,
		122,
		115,
		-1,
		-1,
		-1,
		170,
		169,
		161,
		155,
		155,
		140,
		131,
		-1,
		143,
		125,
		104,
		121,
		121,
		112,
		120,
		152,
		148,
		135,
		135,
		127,
		-1,
		271,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		164,
		159,
		132,
		120,
		126,
		122,
		108,
		114,
		116,
		124,
		122,
		119,
		131,
		127,
		147,
		128,
		163,
		-1,
		266,
		-1,
		200,
		-1,
		-1,
		182,
		162,
		154,
		143,
		132,
		130,
		121,
		112,
		134,
		150,
		134,
		132,
		135,
		136,
		-1,
		255,
		254,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		178,
		139,
		-1,
		141,
		121,
		-1,
		143,
		139,
		-1,
		-1,
		242,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		173,
		157,
		-1,
		132,
		132,
		-1,
		-1,
		-1,
		227,
		226,
		-1,
		195,
		198,
		-1,
		188,
		179,
		187,
		134,
		138,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		210,
		208,
		203,
		200,
		186,
		170,
		148,
		137,
		158,
		-1,
		-1,
		-1,
		208,
		200,
		193,
		-1,
		-1,
		195,
		178,
		159,
		157,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		185,
		-1,
		-1,
		191,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		219,
		-1,
		-1,
		-1,
		181,
		177,
		178,
		-1,
		-1,
		-1,
		-1,
		241,
		242,
		265,
		229,
		-1,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		244,
		242,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		171,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		206,
		-1,
		206,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		219,
		211,
		219,
		-1,
		191,
		193,
		-1,
		241,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		196,
		203,
		225,
		228,
		264,
		-1,
		215
	],
	[
		-1,
		139,
		128,
		139,
		147,
		120,
		127,
		-1,
		146,
		150,
		116,
		110,
		149,
		118,
		124,
		135,
		-1,
		-1,
		-1,
		139,
		138,
		106,
		104,
		113,
		118,
		125,
		-1,
		124,
		-1,
		160,
		139,
		150,
		155,
		99,
		96,
		116,
		135,
		117,
		109,
		175,
		129,
		100,
		94,
		112,
		102,
		111,
		103,
		-1,
		100,
		90,
		112,
		91,
		102,
		94,
		-1,
		-1,
		94,
		95,
		101,
		87,
		93,
		89,
		-1,
		99,
		81,
		-1,
		-1,
		84,
		85,
		69,
		72,
		80,
		78,
		91,
		83,
		76,
		-1,
		-1,
		75,
		71,
		78,
		65,
		61,
		78,
		91,
		73,
		63,
		61,
		-1,
		87,
		104,
		104,
		72,
		70,
		54,
		52,
		70,
		72,
		61,
		53,
		-1,
		104,
		100,
		101,
		99,
		94,
		70,
		57,
		57,
		67,
		60,
		55,
		42,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		105,
		96,
		113,
		97,
		87,
		91,
		89,
		60,
		57,
		55,
		52,
		58,
		41,
		51,
		-1,
		-1,
		198,
		171,
		195,
		153,
		135,
		-1,
		101,
		101,
		95,
		91,
		85,
		78,
		91,
		76,
		-1,
		46,
		45,
		48,
		34,
		45,
		180,
		-1,
		-1,
		156,
		148,
		130,
		133,
		110,
		106,
		116,
		115,
		108,
		97,
		93,
		75,
		78,
		78,
		84,
		40,
		44,
		41,
		27,
		39,
		-1,
		-1,
		105,
		-1,
		-1,
		177,
		160,
		-1,
		125,
		132,
		116,
		122,
		108,
		129,
		126,
		117,
		111,
		106,
		95,
		73,
		70,
		83,
		62,
		37,
		51,
		54,
		22,
		29,
		24,
		-1,
		104,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		132,
		129,
		122,
		146,
		145,
		-1,
		142,
		130,
		131,
		116,
		113,
		100,
		88,
		78,
		62,
		62,
		59,
		41,
		39,
		51,
		19,
		27,
		24,
		54,
		80,
		74,
		83,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		150,
		-1,
		153,
		166,
		154,
		127,
		130,
		117,
		108,
		95,
		84,
		79,
		60,
		57,
		53,
		33,
		48,
		14,
		13,
		17,
		32,
		67,
		71,
		77,
		-1,
		235,
		-1,
		177,
		161,
		163,
		137,
		158,
		-1,
		170,
		154,
		171,
		156,
		156,
		-1,
		126,
		123,
		113,
		91,
		76,
		72,
		60,
		55,
		46,
		28,
		33,
		8,
		12,
		19,
		39,
		53,
		73,
		85,
		195,
		185,
		-1,
		167,
		172,
		133,
		141,
		160,
		197,
		162,
		-1,
		157,
		-1,
		128,
		141,
		-1,
		97,
		93,
		75,
		68,
		57,
		64,
		39,
		24,
		21,
		0,
		3,
		42,
		44,
		62,
		-1,
		-1,
		180,
		184,
		175,
		126,
		145,
		169,
		206,
		155,
		144,
		143,
		-1,
		134,
		111,
		108,
		96,
		83,
		68,
		69,
		63,
		59,
		38,
		23,
		26,
		9,
		59,
		37,
		49,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		152,
		123,
		147,
		189,
		173,
		166,
		154,
		119,
		119,
		113,
		-1,
		107,
		86,
		77,
		66,
		64,
		71,
		44,
		47,
		27,
		29,
		15,
		40,
		31,
		51,
		-1,
		-1,
		-1,
		182,
		171,
		172,
		118,
		141,
		178,
		152,
		138,
		143,
		118,
		111,
		105,
		120,
		103,
		84,
		73,
		65,
		54,
		45,
		55,
		49,
		29,
		38,
		22,
		46,
		53,
		59,
		-1,
		-1,
		189,
		179,
		163,
		165,
		162,
		132,
		139,
		171,
		143,
		156,
		-1,
		110,
		-1,
		99,
		94,
		78,
		73,
		70,
		63,
		50,
		60,
		57,
		43,
		34,
		49,
		51,
		51,
		43,
		68,
		71,
		-1,
		-1,
		-1,
		182,
		177,
		152,
		129,
		113,
		149,
		-1,
		126,
		127,
		-1,
		104,
		98,
		95,
		80,
		76,
		67,
		71,
		65,
		64,
		60,
		52,
		53,
		35,
		56,
		-1,
		51,
		45,
		73,
		76,
		66,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		108,
		160,
		-1,
		-1,
		111,
		104,
		-1,
		91,
		73,
		79,
		74,
		72,
		72,
		71,
		60,
		68,
		60,
		40,
		50,
		70,
		66,
		64,
		57,
		62,
		61,
		75,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		128,
		-1,
		120,
		112,
		102,
		96,
		90,
		86,
		84,
		100,
		84,
		84,
		83,
		74,
		82,
		64,
		57,
		43,
		47,
		65,
		75,
		70,
		76,
		68,
		71,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		141,
		-1,
		105,
		119,
		135,
		-1,
		128,
		107,
		122,
		100,
		96,
		91,
		107,
		108,
		86,
		83,
		81,
		91,
		79,
		68,
		55,
		59,
		74,
		84,
		71,
		71,
		73,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		102,
		90,
		122,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		105,
		103,
		97,
		88,
		94,
		92,
		88,
		83,
		73,
		62,
		68,
		64,
		86,
		72,
		70,
		72,
		87,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		105,
		89,
		94,
		-1,
		108,
		-1,
		81,
		81,
		72,
		61,
		58,
		69,
		67,
		78,
		78,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		159,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		121,
		101,
		95,
		94,
		103,
		98,
		89,
		70,
		63,
		60,
		61,
		74,
		94,
		85,
		80,
		-1,
		-1,
		-1,
		156,
		142,
		146,
		106,
		125,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		138,
		126,
		116,
		106,
		124,
		114,
		89,
		82,
		68,
		70,
		68,
		70,
		75,
		93,
		85,
		95,
		-1,
		-1,
		139,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		138,
		154,
		146,
		117,
		127,
		-1,
		-1,
		118,
		116,
		106,
		85,
		72,
		92,
		95,
		85,
		69,
		84,
		96,
		87,
		96,
		-1,
		142,
		129,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		131,
		126,
		130,
		121,
		-1,
		102,
		96,
		76,
		90,
		97,
		87,
		82,
		76,
		79,
		97,
		98,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		128,
		142,
		119,
		112,
		116,
		-1,
		104,
		92,
		78,
		95,
		100,
		97,
		88,
		80,
		85,
		82,
		95,
		109,
		100,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		146,
		161,
		158,
		135,
		108,
		103,
		96,
		90,
		86,
		102,
		108,
		119,
		87,
		83,
		84,
		88,
		87,
		104,
		114,
		-1,
		-1,
		160,
		177,
		172,
		154,
		158,
		185,
		-1,
		-1,
		112,
		103,
		94,
		97,
		96,
		99,
		93,
		90,
		95,
		100,
		88,
		97,
		115,
		114,
		-1,
		-1,
		-1,
		180,
		-1,
		195,
		-1,
		-1,
		173,
		183,
		130,
		112,
		108,
		106,
		99,
		108,
		103,
		98,
		108,
		110,
		102,
		90,
		94,
		117,
		106,
		145,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		201,
		184,
		188,
		194,
		193,
		187,
		145,
		142,
		-1,
		112,
		137,
		109,
		116,
		107,
		114,
		114,
		106,
		84,
		91,
		107,
		106,
		101,
		137,
		128,
		134,
		-1,
		-1,
		291,
		280,
		269,
		275,
		-1,
		194,
		190,
		180,
		170,
		173,
		-1,
		-1,
		161,
		158,
		134,
		117,
		115,
		108,
		103,
		113,
		93,
		80,
		84,
		88,
		94,
		99,
		104,
		110,
		125,
		140,
		-1,
		187,
		268,
		261,
		243,
		251,
		282,
		-1,
		184,
		176,
		187,
		162,
		164,
		-1,
		-1,
		134,
		131,
		136,
		124,
		121,
		123,
		118,
		109,
		94,
		100,
		87,
		86,
		104,
		108,
		117,
		124,
		114,
		127,
		131,
		-1,
		201,
		244,
		237,
		240,
		264,
		278,
		-1,
		181,
		-1,
		-1,
		193,
		165,
		149,
		139,
		133,
		183,
		138,
		133,
		117,
		115,
		106,
		97,
		104,
		95,
		95,
		98,
		113,
		118,
		110,
		124,
		124,
		125,
		-1,
		227,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		209,
		-1,
		176,
		-1,
		151,
		155,
		146,
		149,
		131,
		118,
		110,
		102,
		118,
		93,
		103,
		99,
		100,
		109,
		120,
		132,
		131,
		132,
		252,
		208,
		211,
		222,
		233,
		248,
		252,
		-1,
		193,
		232,
		230,
		-1,
		214,
		-1,
		-1,
		-1,
		165,
		159,
		151,
		151,
		130,
		130,
		104,
		108,
		98,
		105,
		115,
		117,
		109,
		113,
		126,
		137,
		140,
		248,
		239,
		252,
		197,
		197,
		218,
		227,
		248,
		208,
		199,
		226,
		237,
		226,
		221,
		208,
		-1,
		-1,
		188,
		169,
		-1,
		-1,
		137,
		125,
		108,
		109,
		105,
		108,
		123,
		126,
		116,
		114,
		108,
		140,
		-1,
		241,
		240,
		229,
		226,
		202,
		193,
		188,
		215,
		-1,
		-1,
		210,
		227,
		221,
		225,
		241,
		266,
		-1,
		197,
		-1,
		-1,
		182,
		-1,
		-1,
		167,
		130,
		119,
		110,
		116,
		113,
		124,
		134,
		122,
		123,
		113,
		123,
		136,
		225,
		222,
		210,
		208,
		231,
		196,
		184,
		-1,
		197,
		195,
		201,
		208,
		225,
		255,
		-1,
		-1,
		213,
		193,
		-1,
		-1,
		165,
		163,
		152,
		-1,
		142,
		115,
		120,
		140,
		142,
		131,
		125,
		119,
		126,
		125,
		133,
		141,
		234,
		248,
		237,
		233,
		232,
		240,
		189,
		182,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		203,
		199,
		-1,
		-1,
		160,
		153,
		141,
		129,
		119,
		129,
		133,
		137,
		129,
		122,
		117,
		128,
		120,
		124,
		141,
		-1,
		268,
		-1,
		220,
		196,
		210,
		225,
		233,
		-1,
		-1,
		-1,
		220,
		206,
		199,
		187,
		185,
		-1,
		194,
		178,
		159,
		-1,
		129,
		142,
		173,
		141,
		146,
		141,
		123,
		134,
		123,
		126,
		140,
		135,
		-1,
		-1,
		208,
		211,
		-1,
		-1,
		210,
		212,
		-1,
		211,
		200,
		185,
		177,
		-1,
		-1,
		166,
		162,
		-1,
		-1,
		130,
		155,
		144,
		152,
		147,
		127,
		133,
		136,
		125,
		129,
		141,
		-1,
		-1,
		215,
		216,
		217,
		-1,
		195,
		-1,
		213,
		-1,
		180,
		186,
		174,
		-1,
		-1,
		-1,
		168,
		131,
		152,
		162,
		156,
		154,
		145,
		131,
		138,
		136,
		132,
		143,
		-1,
		-1,
		-1,
		213,
		187,
		220,
		211,
		194,
		174,
		166,
		185,
		-1,
		155,
		-1,
		130,
		132,
		158,
		161,
		167,
		161,
		134,
		149,
		139,
		130,
		139,
		219,
		-1,
		189,
		222,
		186,
		180,
		156,
		160,
		176,
		-1,
		152,
		134,
		-1,
		162,
		152,
		183,
		168,
		149,
		136,
		143,
		143,
		136,
		-1,
		-1,
		-1,
		191,
		190,
		182,
		176,
		176,
		161,
		152,
		-1,
		164,
		146,
		125,
		142,
		142,
		133,
		141,
		173,
		169,
		156,
		156,
		148,
		-1,
		292,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		185,
		180,
		153,
		141,
		147,
		143,
		129,
		135,
		137,
		145,
		143,
		140,
		152,
		148,
		168,
		149,
		184,
		-1,
		287,
		-1,
		221,
		-1,
		-1,
		203,
		183,
		175,
		164,
		153,
		151,
		142,
		133,
		155,
		171,
		155,
		153,
		156,
		157,
		-1,
		276,
		275,
		-1,
		222,
		214,
		200,
		-1,
		193,
		-1,
		199,
		160,
		-1,
		162,
		142,
		-1,
		164,
		160,
		-1,
		-1,
		263,
		238,
		-1,
		-1,
		-1,
		223,
		203,
		194,
		178,
		-1,
		153,
		153,
		-1,
		-1,
		-1,
		248,
		247,
		-1,
		216,
		219,
		-1,
		209,
		200,
		208,
		155,
		159,
		-1,
		-1,
		-1,
		257,
		238,
		232,
		231,
		229,
		224,
		221,
		207,
		191,
		169,
		158,
		179,
		-1,
		-1,
		-1,
		229,
		221,
		214,
		-1,
		-1,
		216,
		199,
		180,
		178,
		-1,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		206,
		-1,
		-1,
		212,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		240,
		-1,
		-1,
		-1,
		202,
		198,
		199,
		-1,
		-1,
		-1,
		-1,
		262,
		263,
		286,
		250,
		-1,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		265,
		263,
		-1,
		-1,
		-1,
		222,
		206,
		-1,
		192,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		227,
		-1,
		227,
		202,
		209,
		-1,
		-1,
		-1,
		-1,
		240,
		232,
		240,
		-1,
		212,
		214,
		-1,
		262,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		217,
		224,
		246,
		249,
		285,
		-1,
		236
	],
	[
		-1,
		144,
		133,
		144,
		152,
		125,
		132,
		-1,
		151,
		155,
		121,
		115,
		154,
		123,
		129,
		140,
		-1,
		-1,
		-1,
		144,
		143,
		111,
		109,
		118,
		123,
		130,
		-1,
		129,
		-1,
		165,
		144,
		155,
		160,
		104,
		101,
		121,
		140,
		122,
		114,
		180,
		134,
		105,
		99,
		117,
		107,
		116,
		108,
		-1,
		105,
		95,
		117,
		96,
		107,
		99,
		-1,
		-1,
		99,
		100,
		106,
		92,
		98,
		94,
		-1,
		104,
		86,
		-1,
		-1,
		89,
		90,
		74,
		77,
		85,
		83,
		96,
		88,
		81,
		-1,
		-1,
		80,
		76,
		83,
		70,
		66,
		83,
		96,
		78,
		68,
		66,
		-1,
		92,
		109,
		109,
		77,
		75,
		59,
		57,
		75,
		77,
		66,
		58,
		-1,
		109,
		105,
		106,
		104,
		99,
		75,
		62,
		62,
		72,
		65,
		60,
		47,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		110,
		101,
		118,
		102,
		92,
		96,
		94,
		65,
		62,
		60,
		57,
		63,
		46,
		56,
		-1,
		-1,
		203,
		176,
		200,
		158,
		140,
		-1,
		106,
		106,
		100,
		96,
		90,
		83,
		96,
		81,
		-1,
		51,
		50,
		53,
		39,
		50,
		185,
		-1,
		-1,
		161,
		153,
		135,
		138,
		115,
		111,
		121,
		120,
		113,
		102,
		98,
		80,
		83,
		83,
		89,
		45,
		49,
		46,
		32,
		44,
		-1,
		-1,
		102,
		-1,
		-1,
		182,
		165,
		-1,
		130,
		137,
		121,
		127,
		113,
		134,
		131,
		122,
		116,
		111,
		100,
		78,
		75,
		88,
		67,
		42,
		56,
		59,
		27,
		34,
		29,
		-1,
		101,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		137,
		134,
		127,
		151,
		150,
		-1,
		147,
		135,
		136,
		121,
		118,
		105,
		93,
		83,
		67,
		67,
		64,
		46,
		44,
		56,
		24,
		32,
		29,
		59,
		77,
		71,
		80,
		-1,
		190,
		186,
		182,
		189,
		138,
		-1,
		-1,
		155,
		-1,
		158,
		171,
		159,
		132,
		135,
		122,
		113,
		100,
		89,
		84,
		65,
		62,
		58,
		38,
		53,
		19,
		18,
		22,
		37,
		64,
		68,
		74,
		-1,
		240,
		-1,
		182,
		166,
		168,
		142,
		163,
		-1,
		175,
		159,
		176,
		161,
		161,
		-1,
		131,
		128,
		118,
		96,
		81,
		77,
		65,
		60,
		51,
		33,
		38,
		13,
		9,
		16,
		40,
		50,
		70,
		82,
		200,
		190,
		-1,
		172,
		177,
		138,
		146,
		165,
		202,
		167,
		-1,
		162,
		-1,
		133,
		146,
		-1,
		102,
		98,
		80,
		73,
		62,
		69,
		44,
		29,
		26,
		5,
		0,
		39,
		43,
		59,
		-1,
		-1,
		185,
		189,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		116,
		113,
		101,
		88,
		73,
		74,
		68,
		64,
		43,
		28,
		31,
		6,
		56,
		34,
		46,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		112,
		91,
		82,
		71,
		69,
		76,
		49,
		52,
		32,
		34,
		12,
		37,
		28,
		48,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		125,
		108,
		89,
		78,
		70,
		59,
		50,
		60,
		54,
		34,
		39,
		19,
		43,
		50,
		56,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		99,
		83,
		78,
		75,
		68,
		55,
		65,
		62,
		44,
		39,
		51,
		48,
		48,
		40,
		65,
		68,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		85,
		81,
		72,
		76,
		70,
		69,
		65,
		57,
		58,
		40,
		53,
		-1,
		48,
		42,
		70,
		73,
		63,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		84,
		79,
		77,
		77,
		76,
		65,
		73,
		65,
		45,
		55,
		67,
		63,
		61,
		54,
		59,
		58,
		72,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		105,
		89,
		89,
		88,
		79,
		87,
		69,
		62,
		48,
		52,
		62,
		72,
		67,
		73,
		65,
		68,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		96,
		112,
		113,
		91,
		88,
		86,
		96,
		84,
		73,
		60,
		64,
		71,
		81,
		68,
		68,
		70,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		110,
		108,
		102,
		93,
		99,
		97,
		93,
		88,
		78,
		67,
		73,
		69,
		90,
		76,
		74,
		69,
		84,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		110,
		94,
		99,
		-1,
		113,
		-1,
		86,
		86,
		77,
		66,
		63,
		74,
		72,
		83,
		75,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		126,
		106,
		100,
		99,
		108,
		103,
		94,
		75,
		68,
		65,
		66,
		79,
		99,
		89,
		77,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		143,
		131,
		121,
		111,
		129,
		119,
		94,
		87,
		73,
		75,
		73,
		75,
		80,
		90,
		82,
		92,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		132,
		-1,
		-1,
		123,
		121,
		111,
		90,
		77,
		97,
		100,
		90,
		74,
		89,
		96,
		84,
		93,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		136,
		131,
		135,
		126,
		-1,
		107,
		101,
		81,
		95,
		102,
		92,
		87,
		81,
		84,
		101,
		95,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		133,
		147,
		124,
		117,
		121,
		-1,
		109,
		97,
		83,
		100,
		105,
		102,
		93,
		85,
		90,
		87,
		100,
		107,
		97,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		151,
		166,
		163,
		140,
		113,
		108,
		101,
		95,
		91,
		107,
		113,
		124,
		92,
		88,
		89,
		93,
		92,
		109,
		112,
		-1,
		-1,
		165,
		182,
		177,
		159,
		163,
		190,
		-1,
		-1,
		117,
		108,
		99,
		102,
		101,
		104,
		98,
		95,
		100,
		105,
		93,
		102,
		120,
		115,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		178,
		188,
		135,
		117,
		113,
		111,
		104,
		113,
		108,
		103,
		113,
		115,
		107,
		95,
		99,
		122,
		111,
		144,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		206,
		189,
		193,
		199,
		198,
		192,
		150,
		147,
		-1,
		117,
		142,
		114,
		121,
		112,
		119,
		119,
		111,
		89,
		96,
		112,
		111,
		106,
		136,
		131,
		139,
		-1,
		-1,
		296,
		285,
		274,
		280,
		-1,
		199,
		195,
		185,
		175,
		178,
		-1,
		-1,
		166,
		163,
		139,
		122,
		120,
		113,
		108,
		118,
		98,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		130,
		145,
		-1,
		192,
		273,
		266,
		248,
		256,
		287,
		-1,
		189,
		181,
		192,
		167,
		169,
		-1,
		-1,
		139,
		136,
		141,
		129,
		126,
		128,
		123,
		114,
		99,
		105,
		92,
		91,
		109,
		113,
		122,
		129,
		119,
		132,
		136,
		-1,
		206,
		249,
		242,
		245,
		269,
		283,
		-1,
		186,
		-1,
		-1,
		198,
		170,
		154,
		144,
		138,
		188,
		143,
		138,
		122,
		120,
		111,
		102,
		109,
		100,
		100,
		103,
		118,
		123,
		115,
		129,
		129,
		130,
		-1,
		232,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		214,
		-1,
		181,
		-1,
		156,
		160,
		151,
		154,
		136,
		123,
		115,
		107,
		123,
		98,
		108,
		104,
		105,
		114,
		125,
		137,
		136,
		137,
		257,
		213,
		216,
		227,
		238,
		253,
		257,
		-1,
		198,
		237,
		235,
		-1,
		219,
		-1,
		-1,
		-1,
		170,
		164,
		156,
		156,
		135,
		135,
		109,
		113,
		103,
		110,
		120,
		122,
		114,
		118,
		131,
		142,
		145,
		253,
		244,
		257,
		202,
		202,
		223,
		232,
		253,
		213,
		204,
		231,
		242,
		231,
		226,
		213,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		142,
		130,
		113,
		114,
		110,
		113,
		128,
		131,
		121,
		119,
		113,
		145,
		-1,
		246,
		245,
		234,
		231,
		207,
		198,
		193,
		220,
		-1,
		-1,
		215,
		232,
		226,
		230,
		246,
		271,
		-1,
		202,
		-1,
		-1,
		187,
		-1,
		-1,
		172,
		135,
		124,
		115,
		121,
		118,
		129,
		139,
		127,
		128,
		118,
		128,
		141,
		230,
		227,
		215,
		213,
		236,
		201,
		189,
		-1,
		202,
		200,
		206,
		213,
		230,
		260,
		-1,
		-1,
		218,
		198,
		-1,
		-1,
		170,
		168,
		157,
		-1,
		147,
		120,
		125,
		145,
		147,
		136,
		130,
		124,
		131,
		130,
		138,
		146,
		239,
		253,
		242,
		238,
		237,
		245,
		194,
		187,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		208,
		204,
		-1,
		-1,
		165,
		158,
		146,
		134,
		124,
		134,
		138,
		142,
		134,
		127,
		122,
		133,
		125,
		129,
		146,
		-1,
		273,
		-1,
		225,
		201,
		215,
		230,
		238,
		-1,
		-1,
		-1,
		225,
		211,
		204,
		192,
		190,
		-1,
		199,
		183,
		164,
		-1,
		134,
		147,
		178,
		146,
		151,
		146,
		128,
		139,
		128,
		131,
		145,
		140,
		-1,
		-1,
		213,
		216,
		-1,
		-1,
		215,
		217,
		-1,
		216,
		205,
		190,
		182,
		-1,
		-1,
		171,
		167,
		-1,
		-1,
		135,
		160,
		149,
		157,
		152,
		132,
		138,
		141,
		130,
		134,
		146,
		-1,
		-1,
		220,
		221,
		222,
		-1,
		200,
		-1,
		218,
		-1,
		185,
		191,
		179,
		-1,
		-1,
		-1,
		173,
		136,
		157,
		167,
		161,
		159,
		150,
		136,
		143,
		141,
		137,
		148,
		-1,
		-1,
		-1,
		218,
		192,
		225,
		216,
		199,
		179,
		171,
		190,
		-1,
		160,
		-1,
		135,
		137,
		163,
		166,
		172,
		166,
		139,
		154,
		144,
		135,
		144,
		224,
		-1,
		194,
		227,
		191,
		185,
		161,
		165,
		181,
		-1,
		157,
		139,
		-1,
		167,
		157,
		188,
		173,
		154,
		141,
		148,
		148,
		141,
		-1,
		-1,
		-1,
		196,
		195,
		187,
		181,
		181,
		166,
		157,
		-1,
		169,
		151,
		130,
		147,
		147,
		138,
		146,
		178,
		174,
		161,
		161,
		153,
		-1,
		297,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		190,
		185,
		158,
		146,
		152,
		148,
		134,
		140,
		142,
		150,
		148,
		145,
		157,
		153,
		173,
		154,
		189,
		-1,
		292,
		-1,
		226,
		-1,
		-1,
		208,
		188,
		180,
		169,
		158,
		156,
		147,
		138,
		160,
		176,
		160,
		158,
		161,
		162,
		-1,
		281,
		280,
		-1,
		227,
		219,
		205,
		-1,
		198,
		-1,
		204,
		165,
		-1,
		167,
		147,
		-1,
		169,
		165,
		-1,
		-1,
		268,
		243,
		-1,
		-1,
		-1,
		228,
		208,
		199,
		183,
		-1,
		158,
		158,
		-1,
		-1,
		-1,
		253,
		252,
		-1,
		221,
		224,
		-1,
		214,
		205,
		213,
		160,
		164,
		-1,
		-1,
		-1,
		262,
		243,
		237,
		236,
		234,
		229,
		226,
		212,
		196,
		174,
		163,
		184,
		-1,
		-1,
		-1,
		234,
		226,
		219,
		-1,
		-1,
		221,
		204,
		185,
		183,
		-1,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		211,
		-1,
		-1,
		217,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		245,
		-1,
		-1,
		-1,
		207,
		203,
		204,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		291,
		255,
		-1,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		270,
		268,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		197,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		232,
		-1,
		232,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		245,
		237,
		245,
		-1,
		217,
		219,
		-1,
		267,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		222,
		229,
		251,
		254,
		290,
		-1,
		241
	],
	[
		-1,
		159,
		148,
		159,
		167,
		140,
		147,
		-1,
		166,
		170,
		136,
		130,
		169,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		159,
		158,
		126,
		124,
		133,
		138,
		145,
		-1,
		144,
		-1,
		180,
		159,
		170,
		175,
		119,
		116,
		136,
		155,
		137,
		129,
		195,
		149,
		120,
		114,
		132,
		122,
		131,
		123,
		-1,
		120,
		110,
		132,
		111,
		122,
		114,
		-1,
		-1,
		114,
		115,
		121,
		107,
		113,
		109,
		-1,
		119,
		103,
		-1,
		-1,
		104,
		105,
		89,
		92,
		100,
		98,
		111,
		103,
		98,
		-1,
		-1,
		95,
		91,
		98,
		85,
		81,
		98,
		111,
		93,
		89,
		87,
		-1,
		107,
		124,
		124,
		92,
		90,
		74,
		72,
		90,
		92,
		87,
		79,
		-1,
		124,
		120,
		121,
		119,
		114,
		90,
		77,
		77,
		87,
		80,
		81,
		68,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		116,
		133,
		117,
		107,
		111,
		109,
		80,
		77,
		75,
		72,
		84,
		67,
		77,
		-1,
		-1,
		218,
		191,
		215,
		173,
		155,
		-1,
		121,
		121,
		115,
		111,
		105,
		98,
		111,
		96,
		-1,
		66,
		65,
		74,
		60,
		71,
		200,
		-1,
		-1,
		176,
		168,
		150,
		153,
		130,
		126,
		136,
		135,
		128,
		116,
		112,
		95,
		98,
		98,
		104,
		60,
		70,
		67,
		53,
		51,
		-1,
		-1,
		66,
		-1,
		-1,
		197,
		180,
		-1,
		145,
		152,
		136,
		142,
		128,
		149,
		146,
		137,
		131,
		126,
		114,
		93,
		90,
		103,
		82,
		57,
		77,
		80,
		48,
		41,
		36,
		-1,
		65,
		49,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		152,
		149,
		142,
		166,
		165,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		98,
		82,
		82,
		79,
		61,
		59,
		73,
		45,
		40,
		30,
		36,
		41,
		35,
		44,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		170,
		-1,
		173,
		186,
		173,
		146,
		149,
		136,
		127,
		114,
		103,
		99,
		80,
		77,
		73,
		53,
		68,
		50,
		51,
		19,
		19,
		28,
		32,
		38,
		-1,
		255,
		-1,
		197,
		181,
		183,
		156,
		177,
		-1,
		190,
		174,
		190,
		175,
		175,
		-1,
		145,
		142,
		132,
		110,
		95,
		92,
		80,
		75,
		66,
		48,
		62,
		46,
		32,
		23,
		9,
		14,
		36,
		46,
		215,
		205,
		-1,
		187,
		192,
		152,
		160,
		179,
		217,
		181,
		-1,
		176,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		88,
		77,
		84,
		59,
		44,
		41,
		38,
		39,
		0,
		6,
		30,
		-1,
		-1,
		200,
		204,
		194,
		145,
		164,
		188,
		225,
		174,
		163,
		162,
		-1,
		153,
		130,
		127,
		115,
		102,
		87,
		88,
		83,
		79,
		58,
		43,
		45,
		35,
		19,
		7,
		32,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		171,
		142,
		166,
		208,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		126,
		105,
		96,
		85,
		83,
		91,
		64,
		59,
		43,
		41,
		30,
		17,
		14,
		34,
		-1,
		-1,
		-1,
		201,
		190,
		191,
		137,
		160,
		197,
		171,
		157,
		162,
		137,
		130,
		124,
		139,
		122,
		103,
		92,
		84,
		73,
		65,
		71,
		63,
		39,
		44,
		24,
		28,
		36,
		42,
		-1,
		-1,
		208,
		198,
		182,
		184,
		181,
		151,
		158,
		190,
		162,
		175,
		-1,
		129,
		-1,
		118,
		113,
		97,
		92,
		89,
		83,
		70,
		70,
		68,
		49,
		44,
		56,
		33,
		33,
		26,
		51,
		54,
		-1,
		-1,
		-1,
		201,
		196,
		171,
		148,
		132,
		168,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		99,
		95,
		87,
		91,
		85,
		80,
		70,
		62,
		63,
		45,
		58,
		-1,
		34,
		28,
		56,
		59,
		49,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		127,
		179,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		99,
		94,
		91,
		92,
		83,
		72,
		78,
		70,
		50,
		60,
		72,
		49,
		47,
		40,
		45,
		44,
		58,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		147,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		119,
		103,
		104,
		95,
		86,
		94,
		74,
		67,
		53,
		57,
		67,
		58,
		53,
		59,
		51,
		54,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		111,
		126,
		127,
		105,
		95,
		93,
		101,
		89,
		78,
		65,
		69,
		71,
		68,
		54,
		54,
		56,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		125,
		123,
		116,
		107,
		113,
		104,
		98,
		93,
		83,
		72,
		78,
		74,
		76,
		62,
		60,
		55,
		70,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		124,
		108,
		113,
		-1,
		118,
		-1,
		91,
		91,
		82,
		71,
		68,
		72,
		63,
		76,
		61,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		140,
		120,
		114,
		113,
		113,
		108,
		99,
		80,
		73,
		70,
		71,
		84,
		96,
		75,
		63,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		157,
		145,
		135,
		125,
		134,
		124,
		99,
		92,
		78,
		80,
		78,
		80,
		85,
		76,
		68,
		78,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		165,
		136,
		146,
		-1,
		-1,
		135,
		126,
		116,
		95,
		82,
		102,
		105,
		95,
		79,
		92,
		82,
		70,
		79,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		190,
		152,
		141,
		136,
		140,
		134,
		-1,
		112,
		106,
		86,
		100,
		107,
		97,
		92,
		86,
		87,
		87,
		81,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		147,
		158,
		129,
		122,
		126,
		-1,
		114,
		102,
		88,
		105,
		110,
		107,
		98,
		90,
		95,
		84,
		97,
		93,
		83,
		196,
		-1,
		179,
		-1,
		-1,
		-1,
		165,
		180,
		168,
		145,
		118,
		113,
		106,
		100,
		96,
		112,
		118,
		129,
		97,
		93,
		94,
		90,
		89,
		97,
		98,
		-1,
		-1,
		179,
		196,
		191,
		173,
		177,
		195,
		-1,
		-1,
		122,
		113,
		104,
		107,
		106,
		109,
		103,
		100,
		105,
		107,
		98,
		99,
		116,
		101,
		-1,
		-1,
		-1,
		199,
		-1,
		214,
		-1,
		-1,
		192,
		193,
		140,
		122,
		118,
		116,
		109,
		118,
		113,
		108,
		118,
		120,
		112,
		97,
		104,
		127,
		109,
		130,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		211,
		203,
		198,
		204,
		206,
		197,
		155,
		152,
		-1,
		122,
		147,
		119,
		126,
		117,
		124,
		124,
		116,
		94,
		101,
		117,
		116,
		111,
		122,
		117,
		126,
		-1,
		-1,
		301,
		290,
		279,
		285,
		-1,
		204,
		200,
		190,
		180,
		183,
		-1,
		-1,
		171,
		168,
		144,
		127,
		125,
		118,
		113,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		124,
		132,
		-1,
		206,
		287,
		280,
		253,
		261,
		292,
		-1,
		194,
		186,
		197,
		172,
		174,
		-1,
		-1,
		144,
		141,
		146,
		134,
		131,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		134,
		124,
		137,
		141,
		-1,
		220,
		263,
		247,
		250,
		274,
		288,
		-1,
		191,
		-1,
		-1,
		203,
		175,
		159,
		149,
		143,
		193,
		148,
		143,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		134,
		134,
		135,
		-1,
		237,
		243,
		241,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		219,
		-1,
		186,
		-1,
		161,
		165,
		156,
		159,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		141,
		142,
		262,
		218,
		221,
		232,
		243,
		258,
		262,
		-1,
		203,
		242,
		240,
		-1,
		224,
		-1,
		-1,
		-1,
		175,
		169,
		161,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		150,
		258,
		249,
		262,
		207,
		207,
		228,
		237,
		258,
		218,
		209,
		236,
		247,
		236,
		231,
		218,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		251,
		250,
		239,
		236,
		212,
		203,
		198,
		225,
		-1,
		-1,
		220,
		237,
		231,
		235,
		251,
		276,
		-1,
		207,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		235,
		232,
		220,
		218,
		241,
		206,
		194,
		-1,
		207,
		205,
		211,
		218,
		235,
		265,
		-1,
		-1,
		223,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		244,
		258,
		247,
		243,
		242,
		250,
		199,
		192,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		278,
		-1,
		230,
		206,
		220,
		235,
		243,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		218,
		221,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		225,
		226,
		227,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		157,
		146,
		157,
		165,
		138,
		145,
		-1,
		164,
		168,
		134,
		128,
		167,
		136,
		142,
		153,
		-1,
		-1,
		-1,
		157,
		156,
		124,
		122,
		131,
		136,
		143,
		-1,
		142,
		-1,
		178,
		157,
		168,
		173,
		117,
		114,
		134,
		153,
		135,
		127,
		193,
		147,
		118,
		112,
		130,
		120,
		129,
		121,
		-1,
		118,
		108,
		130,
		109,
		120,
		112,
		-1,
		-1,
		112,
		113,
		119,
		105,
		111,
		107,
		-1,
		117,
		101,
		-1,
		-1,
		102,
		103,
		87,
		90,
		98,
		96,
		109,
		101,
		96,
		-1,
		-1,
		93,
		89,
		96,
		83,
		79,
		96,
		109,
		91,
		87,
		85,
		-1,
		105,
		122,
		122,
		90,
		88,
		72,
		70,
		88,
		90,
		85,
		77,
		-1,
		122,
		118,
		119,
		117,
		112,
		88,
		75,
		75,
		85,
		78,
		79,
		66,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		114,
		131,
		115,
		105,
		109,
		107,
		78,
		75,
		73,
		70,
		82,
		65,
		75,
		-1,
		-1,
		216,
		189,
		213,
		171,
		153,
		-1,
		119,
		119,
		113,
		109,
		103,
		96,
		109,
		94,
		-1,
		64,
		63,
		72,
		58,
		69,
		198,
		-1,
		-1,
		174,
		166,
		148,
		151,
		128,
		124,
		134,
		133,
		126,
		114,
		110,
		93,
		96,
		96,
		102,
		58,
		68,
		65,
		51,
		49,
		-1,
		-1,
		65,
		-1,
		-1,
		195,
		178,
		-1,
		143,
		150,
		134,
		140,
		126,
		147,
		144,
		135,
		129,
		124,
		112,
		91,
		88,
		101,
		80,
		55,
		75,
		78,
		46,
		39,
		34,
		-1,
		64,
		48,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		150,
		147,
		140,
		164,
		163,
		-1,
		159,
		147,
		148,
		133,
		130,
		117,
		105,
		96,
		80,
		80,
		77,
		59,
		57,
		71,
		43,
		38,
		28,
		35,
		40,
		34,
		43,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		168,
		-1,
		171,
		184,
		171,
		144,
		147,
		134,
		125,
		112,
		101,
		97,
		78,
		75,
		71,
		51,
		66,
		48,
		49,
		17,
		17,
		27,
		31,
		37,
		-1,
		253,
		-1,
		195,
		179,
		181,
		154,
		175,
		-1,
		188,
		172,
		188,
		173,
		173,
		-1,
		143,
		140,
		130,
		108,
		93,
		90,
		78,
		73,
		64,
		46,
		60,
		44,
		30,
		21,
		7,
		12,
		35,
		45,
		213,
		203,
		-1,
		185,
		190,
		150,
		158,
		177,
		215,
		179,
		-1,
		174,
		-1,
		145,
		158,
		-1,
		114,
		110,
		92,
		86,
		75,
		82,
		57,
		42,
		39,
		36,
		37,
		3,
		0,
		29,
		-1,
		-1,
		198,
		202,
		192,
		143,
		162,
		186,
		223,
		172,
		161,
		160,
		-1,
		151,
		128,
		125,
		113,
		100,
		85,
		86,
		81,
		77,
		56,
		41,
		43,
		33,
		22,
		5,
		30,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		169,
		140,
		164,
		206,
		190,
		183,
		171,
		136,
		136,
		130,
		-1,
		124,
		103,
		94,
		83,
		81,
		89,
		62,
		57,
		41,
		39,
		28,
		20,
		12,
		32,
		-1,
		-1,
		-1,
		199,
		188,
		189,
		135,
		158,
		195,
		169,
		155,
		160,
		135,
		128,
		122,
		137,
		120,
		101,
		90,
		82,
		71,
		63,
		69,
		61,
		37,
		42,
		22,
		27,
		34,
		40,
		-1,
		-1,
		206,
		196,
		180,
		182,
		179,
		149,
		156,
		188,
		160,
		173,
		-1,
		127,
		-1,
		116,
		111,
		95,
		90,
		87,
		81,
		68,
		68,
		66,
		47,
		42,
		54,
		32,
		32,
		24,
		49,
		52,
		-1,
		-1,
		-1,
		199,
		194,
		169,
		146,
		130,
		166,
		-1,
		143,
		144,
		-1,
		121,
		115,
		112,
		97,
		93,
		85,
		89,
		83,
		78,
		68,
		60,
		61,
		43,
		56,
		-1,
		32,
		26,
		54,
		57,
		47,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		125,
		177,
		-1,
		-1,
		128,
		121,
		-1,
		108,
		90,
		97,
		92,
		89,
		90,
		81,
		70,
		76,
		68,
		48,
		58,
		70,
		47,
		45,
		38,
		43,
		42,
		56,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		145,
		-1,
		137,
		129,
		119,
		113,
		107,
		103,
		101,
		117,
		101,
		102,
		93,
		84,
		92,
		72,
		65,
		51,
		55,
		65,
		56,
		51,
		57,
		49,
		52,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		158,
		-1,
		122,
		136,
		152,
		-1,
		145,
		124,
		139,
		117,
		113,
		109,
		124,
		125,
		103,
		93,
		91,
		99,
		87,
		76,
		63,
		67,
		69,
		66,
		52,
		52,
		54,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		119,
		107,
		139,
		-1,
		-1,
		181,
		-1,
		115,
		132,
		123,
		121,
		114,
		105,
		111,
		102,
		96,
		91,
		81,
		70,
		76,
		72,
		74,
		60,
		58,
		53,
		68,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		159,
		149,
		133,
		118,
		151,
		-1,
		122,
		106,
		111,
		-1,
		116,
		-1,
		89,
		89,
		80,
		69,
		66,
		70,
		61,
		74,
		59,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		176,
		-1,
		-1,
		146,
		140,
		140,
		124,
		127,
		138,
		118,
		112,
		111,
		111,
		106,
		97,
		78,
		71,
		68,
		69,
		82,
		94,
		73,
		61,
		-1,
		-1,
		-1,
		173,
		159,
		163,
		123,
		142,
		-1,
		-1,
		208,
		163,
		149,
		-1,
		133,
		155,
		143,
		133,
		123,
		132,
		122,
		97,
		90,
		76,
		78,
		76,
		78,
		83,
		74,
		66,
		76,
		-1,
		-1,
		156,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		155,
		171,
		163,
		134,
		144,
		-1,
		-1,
		133,
		124,
		114,
		93,
		80,
		100,
		103,
		93,
		77,
		90,
		80,
		68,
		77,
		-1,
		159,
		146,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		-1,
		-1,
		188,
		150,
		139,
		134,
		138,
		132,
		-1,
		110,
		104,
		84,
		98,
		105,
		95,
		90,
		84,
		85,
		85,
		79,
		-1,
		-1,
		171,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		145,
		156,
		127,
		120,
		124,
		-1,
		112,
		100,
		86,
		103,
		108,
		105,
		96,
		88,
		93,
		82,
		95,
		91,
		81,
		194,
		-1,
		177,
		-1,
		-1,
		-1,
		163,
		178,
		166,
		143,
		116,
		111,
		104,
		98,
		94,
		110,
		116,
		127,
		95,
		91,
		92,
		88,
		87,
		95,
		96,
		-1,
		-1,
		177,
		194,
		189,
		171,
		175,
		193,
		-1,
		-1,
		120,
		111,
		102,
		105,
		104,
		107,
		101,
		98,
		103,
		105,
		96,
		97,
		114,
		99,
		-1,
		-1,
		-1,
		197,
		-1,
		212,
		-1,
		-1,
		190,
		191,
		138,
		120,
		116,
		114,
		107,
		116,
		111,
		106,
		116,
		118,
		110,
		95,
		102,
		125,
		107,
		128,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		209,
		201,
		196,
		202,
		204,
		195,
		153,
		150,
		-1,
		120,
		145,
		117,
		124,
		115,
		122,
		122,
		114,
		92,
		99,
		115,
		114,
		109,
		120,
		115,
		124,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		202,
		198,
		188,
		178,
		181,
		-1,
		-1,
		169,
		166,
		142,
		125,
		123,
		116,
		111,
		121,
		101,
		88,
		92,
		96,
		102,
		107,
		112,
		118,
		122,
		130,
		-1,
		204,
		285,
		278,
		251,
		259,
		290,
		-1,
		192,
		184,
		195,
		170,
		172,
		-1,
		-1,
		142,
		139,
		144,
		132,
		129,
		131,
		126,
		117,
		102,
		108,
		95,
		94,
		112,
		116,
		125,
		132,
		122,
		135,
		139,
		-1,
		218,
		261,
		245,
		248,
		272,
		286,
		-1,
		189,
		-1,
		-1,
		201,
		173,
		157,
		147,
		141,
		191,
		146,
		141,
		125,
		123,
		114,
		105,
		112,
		103,
		103,
		106,
		121,
		126,
		118,
		132,
		132,
		133,
		-1,
		235,
		241,
		239,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		217,
		-1,
		184,
		-1,
		159,
		163,
		154,
		157,
		139,
		126,
		118,
		110,
		126,
		101,
		111,
		107,
		108,
		117,
		128,
		140,
		139,
		140,
		260,
		216,
		219,
		230,
		241,
		256,
		260,
		-1,
		201,
		240,
		238,
		-1,
		222,
		-1,
		-1,
		-1,
		173,
		167,
		159,
		159,
		138,
		138,
		112,
		116,
		106,
		113,
		123,
		125,
		117,
		121,
		134,
		145,
		148,
		256,
		247,
		260,
		205,
		205,
		226,
		235,
		256,
		216,
		207,
		234,
		245,
		234,
		229,
		216,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		145,
		133,
		116,
		117,
		113,
		116,
		131,
		134,
		124,
		122,
		116,
		148,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		196,
		223,
		-1,
		-1,
		218,
		235,
		229,
		233,
		249,
		274,
		-1,
		205,
		-1,
		-1,
		190,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		121,
		132,
		142,
		130,
		131,
		121,
		131,
		144,
		233,
		230,
		218,
		216,
		239,
		204,
		192,
		-1,
		205,
		203,
		209,
		216,
		233,
		263,
		-1,
		-1,
		221,
		201,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		123,
		128,
		148,
		150,
		139,
		133,
		127,
		134,
		133,
		141,
		149,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		190,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		211,
		207,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		141,
		145,
		137,
		130,
		125,
		136,
		128,
		132,
		149,
		-1,
		276,
		-1,
		228,
		204,
		218,
		233,
		241,
		-1,
		-1,
		-1,
		228,
		214,
		207,
		195,
		193,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		131,
		142,
		131,
		134,
		148,
		143,
		-1,
		-1,
		216,
		219,
		-1,
		-1,
		218,
		220,
		-1,
		219,
		208,
		193,
		185,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		135,
		141,
		144,
		133,
		137,
		149,
		-1,
		-1,
		223,
		224,
		225,
		-1,
		203,
		-1,
		221,
		-1,
		188,
		194,
		182,
		-1,
		-1,
		-1,
		176,
		139,
		160,
		170,
		164,
		162,
		153,
		139,
		146,
		144,
		140,
		151,
		-1,
		-1,
		-1,
		221,
		195,
		228,
		219,
		202,
		182,
		174,
		193,
		-1,
		163,
		-1,
		138,
		140,
		166,
		169,
		175,
		169,
		142,
		157,
		147,
		138,
		147,
		227,
		-1,
		197,
		230,
		194,
		188,
		164,
		168,
		184,
		-1,
		160,
		142,
		-1,
		170,
		160,
		191,
		176,
		157,
		144,
		151,
		151,
		144,
		-1,
		-1,
		-1,
		199,
		198,
		190,
		184,
		184,
		169,
		160,
		-1,
		172,
		154,
		133,
		150,
		150,
		141,
		149,
		181,
		177,
		164,
		164,
		156,
		-1,
		300,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		193,
		188,
		161,
		149,
		155,
		151,
		137,
		143,
		145,
		153,
		151,
		148,
		160,
		156,
		176,
		157,
		192,
		-1,
		295,
		-1,
		229,
		-1,
		-1,
		211,
		191,
		183,
		172,
		161,
		159,
		150,
		141,
		163,
		179,
		163,
		161,
		164,
		165,
		-1,
		284,
		283,
		-1,
		230,
		222,
		208,
		-1,
		201,
		-1,
		207,
		168,
		-1,
		170,
		150,
		-1,
		172,
		168,
		-1,
		-1,
		271,
		246,
		-1,
		-1,
		-1,
		231,
		211,
		202,
		186,
		-1,
		161,
		161,
		-1,
		-1,
		-1,
		256,
		255,
		-1,
		224,
		227,
		-1,
		217,
		208,
		216,
		163,
		167,
		-1,
		-1,
		-1,
		265,
		246,
		240,
		239,
		237,
		232,
		229,
		215,
		199,
		177,
		166,
		187,
		-1,
		-1,
		-1,
		237,
		229,
		222,
		-1,
		-1,
		224,
		207,
		188,
		186,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		214,
		-1,
		-1,
		220,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		248,
		-1,
		-1,
		-1,
		210,
		206,
		207,
		-1,
		-1,
		-1,
		-1,
		270,
		271,
		294,
		258,
		-1,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		273,
		271,
		-1,
		-1,
		-1,
		230,
		214,
		-1,
		200,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		235,
		-1,
		235,
		210,
		217,
		-1,
		-1,
		-1,
		-1,
		248,
		240,
		248,
		-1,
		220,
		222,
		-1,
		270,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		225,
		232,
		254,
		257,
		293,
		-1,
		244
	],
	[
		-1,
		177,
		166,
		177,
		185,
		158,
		165,
		-1,
		184,
		188,
		154,
		148,
		187,
		156,
		162,
		173,
		-1,
		-1,
		-1,
		177,
		176,
		144,
		142,
		151,
		156,
		163,
		-1,
		162,
		-1,
		198,
		177,
		188,
		193,
		137,
		134,
		154,
		173,
		155,
		147,
		213,
		167,
		138,
		132,
		150,
		140,
		149,
		141,
		-1,
		138,
		128,
		150,
		129,
		140,
		132,
		-1,
		-1,
		132,
		133,
		139,
		125,
		131,
		127,
		-1,
		137,
		121,
		-1,
		-1,
		122,
		123,
		107,
		110,
		118,
		116,
		129,
		121,
		116,
		-1,
		-1,
		113,
		109,
		116,
		103,
		99,
		116,
		129,
		111,
		112,
		110,
		-1,
		125,
		142,
		142,
		110,
		108,
		92,
		90,
		108,
		110,
		110,
		102,
		-1,
		142,
		138,
		139,
		137,
		132,
		108,
		95,
		95,
		105,
		98,
		104,
		91,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		134,
		151,
		135,
		125,
		129,
		127,
		98,
		95,
		93,
		90,
		106,
		90,
		100,
		-1,
		-1,
		236,
		209,
		233,
		191,
		173,
		-1,
		139,
		139,
		133,
		129,
		123,
		116,
		129,
		114,
		-1,
		84,
		83,
		97,
		83,
		94,
		218,
		-1,
		-1,
		194,
		186,
		168,
		171,
		148,
		144,
		154,
		153,
		146,
		134,
		130,
		113,
		116,
		116,
		122,
		78,
		88,
		90,
		76,
		74,
		-1,
		-1,
		54,
		-1,
		-1,
		215,
		198,
		-1,
		163,
		170,
		154,
		160,
		146,
		167,
		164,
		155,
		149,
		144,
		132,
		111,
		108,
		121,
		100,
		75,
		100,
		103,
		71,
		64,
		59,
		-1,
		53,
		37,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		170,
		167,
		160,
		184,
		183,
		-1,
		179,
		167,
		168,
		153,
		150,
		137,
		125,
		116,
		100,
		100,
		97,
		79,
		77,
		96,
		68,
		63,
		53,
		41,
		29,
		19,
		28,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		188,
		-1,
		191,
		204,
		191,
		164,
		167,
		154,
		145,
		132,
		121,
		117,
		98,
		95,
		91,
		71,
		86,
		73,
		74,
		42,
		42,
		33,
		16,
		22,
		-1,
		273,
		-1,
		215,
		199,
		201,
		174,
		195,
		-1,
		208,
		192,
		208,
		193,
		193,
		-1,
		163,
		160,
		150,
		128,
		113,
		110,
		98,
		93,
		84,
		66,
		80,
		69,
		55,
		46,
		32,
		19,
		11,
		34,
		233,
		223,
		-1,
		205,
		210,
		170,
		178,
		197,
		235,
		199,
		-1,
		194,
		-1,
		165,
		178,
		-1,
		134,
		130,
		112,
		106,
		95,
		102,
		77,
		62,
		59,
		61,
		57,
		28,
		29,
		0,
		-1,
		-1,
		218,
		222,
		212,
		163,
		182,
		206,
		243,
		192,
		181,
		180,
		-1,
		171,
		148,
		145,
		133,
		120,
		105,
		106,
		101,
		97,
		76,
		61,
		63,
		53,
		47,
		34,
		44,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		189,
		160,
		184,
		226,
		210,
		203,
		191,
		156,
		156,
		150,
		-1,
		144,
		123,
		114,
		103,
		101,
		109,
		82,
		77,
		61,
		59,
		48,
		35,
		32,
		46,
		-1,
		-1,
		-1,
		219,
		208,
		209,
		155,
		178,
		215,
		189,
		175,
		180,
		155,
		148,
		142,
		157,
		140,
		121,
		110,
		102,
		91,
		83,
		89,
		81,
		57,
		62,
		42,
		41,
		54,
		60,
		-1,
		-1,
		226,
		216,
		200,
		202,
		199,
		169,
		176,
		208,
		180,
		193,
		-1,
		147,
		-1,
		136,
		131,
		115,
		110,
		107,
		101,
		88,
		88,
		86,
		67,
		62,
		74,
		46,
		46,
		44,
		69,
		72,
		-1,
		-1,
		-1,
		219,
		214,
		189,
		166,
		150,
		186,
		-1,
		163,
		164,
		-1,
		141,
		135,
		132,
		117,
		113,
		105,
		109,
		103,
		98,
		88,
		80,
		81,
		63,
		76,
		-1,
		52,
		46,
		74,
		77,
		67,
		-1,
		-1,
		-1,
		212,
		191,
		184,
		204,
		145,
		197,
		-1,
		-1,
		148,
		141,
		-1,
		128,
		110,
		117,
		112,
		109,
		110,
		101,
		90,
		96,
		88,
		68,
		78,
		90,
		67,
		65,
		58,
		63,
		62,
		76,
		-1,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		165,
		-1,
		157,
		149,
		139,
		133,
		127,
		123,
		121,
		137,
		121,
		122,
		113,
		104,
		112,
		92,
		85,
		71,
		75,
		85,
		76,
		71,
		77,
		69,
		72,
		-1,
		232,
		218,
		189,
		-1,
		-1,
		178,
		-1,
		142,
		156,
		172,
		-1,
		165,
		144,
		159,
		137,
		133,
		129,
		144,
		145,
		123,
		113,
		111,
		119,
		107,
		96,
		83,
		87,
		89,
		86,
		72,
		72,
		74,
		-1,
		238,
		225,
		183,
		179,
		168,
		188,
		139,
		127,
		159,
		-1,
		-1,
		201,
		-1,
		135,
		152,
		143,
		141,
		134,
		125,
		131,
		122,
		116,
		111,
		101,
		90,
		96,
		92,
		94,
		80,
		78,
		73,
		88,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		154,
		141,
		135,
		-1,
		176,
		-1,
		179,
		169,
		153,
		138,
		171,
		-1,
		142,
		126,
		131,
		-1,
		136,
		-1,
		109,
		109,
		100,
		89,
		86,
		90,
		81,
		94,
		79,
		-1,
		188,
		173,
		166,
		156,
		170,
		141,
		-1,
		196,
		-1,
		-1,
		166,
		160,
		160,
		144,
		147,
		158,
		138,
		132,
		131,
		131,
		126,
		117,
		98,
		91,
		88,
		89,
		102,
		114,
		93,
		81,
		-1,
		-1,
		-1,
		193,
		179,
		183,
		143,
		162,
		-1,
		-1,
		228,
		183,
		169,
		-1,
		153,
		175,
		163,
		153,
		143,
		152,
		142,
		117,
		110,
		96,
		98,
		96,
		98,
		103,
		94,
		86,
		96,
		-1,
		-1,
		176,
		181,
		169,
		155,
		174,
		-1,
		-1,
		-1,
		175,
		191,
		183,
		154,
		164,
		-1,
		-1,
		153,
		144,
		134,
		113,
		100,
		120,
		123,
		113,
		97,
		110,
		100,
		88,
		97,
		-1,
		179,
		166,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		-1,
		-1,
		208,
		170,
		159,
		154,
		158,
		152,
		-1,
		130,
		124,
		104,
		118,
		125,
		115,
		110,
		104,
		105,
		105,
		99,
		-1,
		-1,
		191,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		165,
		176,
		147,
		140,
		144,
		-1,
		132,
		120,
		106,
		123,
		128,
		125,
		116,
		108,
		113,
		102,
		115,
		111,
		101,
		214,
		-1,
		197,
		-1,
		-1,
		-1,
		183,
		198,
		186,
		163,
		136,
		131,
		124,
		118,
		114,
		130,
		136,
		147,
		115,
		111,
		112,
		108,
		107,
		115,
		116,
		-1,
		-1,
		197,
		214,
		209,
		191,
		195,
		213,
		-1,
		-1,
		140,
		131,
		122,
		125,
		124,
		127,
		121,
		118,
		123,
		125,
		116,
		117,
		134,
		119,
		-1,
		-1,
		-1,
		217,
		-1,
		232,
		-1,
		-1,
		210,
		211,
		158,
		140,
		136,
		134,
		127,
		136,
		131,
		126,
		136,
		138,
		130,
		115,
		122,
		145,
		127,
		148,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		229,
		221,
		216,
		222,
		224,
		215,
		173,
		170,
		-1,
		140,
		165,
		137,
		144,
		135,
		142,
		142,
		134,
		112,
		119,
		135,
		134,
		129,
		140,
		135,
		144,
		-1,
		-1,
		319,
		308,
		297,
		303,
		-1,
		222,
		218,
		208,
		198,
		201,
		-1,
		-1,
		189,
		186,
		162,
		145,
		143,
		136,
		131,
		141,
		121,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		142,
		150,
		-1,
		224,
		305,
		298,
		271,
		279,
		310,
		-1,
		212,
		204,
		215,
		190,
		192,
		-1,
		-1,
		162,
		159,
		164,
		152,
		149,
		151,
		146,
		137,
		122,
		128,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		238,
		281,
		265,
		268,
		292,
		306,
		-1,
		209,
		-1,
		-1,
		221,
		193,
		177,
		167,
		161,
		211,
		166,
		161,
		145,
		143,
		134,
		125,
		132,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		255,
		261,
		259,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		237,
		-1,
		204,
		-1,
		179,
		183,
		174,
		177,
		159,
		146,
		138,
		130,
		146,
		121,
		131,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		280,
		236,
		239,
		250,
		261,
		276,
		280,
		-1,
		221,
		260,
		258,
		-1,
		242,
		-1,
		-1,
		-1,
		193,
		187,
		179,
		179,
		158,
		158,
		132,
		136,
		126,
		133,
		143,
		145,
		137,
		141,
		154,
		165,
		168,
		276,
		267,
		280,
		225,
		225,
		246,
		255,
		276,
		236,
		227,
		254,
		265,
		254,
		249,
		236,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		165,
		153,
		136,
		137,
		133,
		136,
		151,
		154,
		144,
		142,
		136,
		168,
		-1,
		269,
		268,
		257,
		254,
		230,
		221,
		216,
		243,
		-1,
		-1,
		238,
		255,
		249,
		253,
		269,
		294,
		-1,
		225,
		-1,
		-1,
		210,
		-1,
		-1,
		195,
		158,
		147,
		138,
		144,
		141,
		152,
		162,
		150,
		151,
		141,
		151,
		164,
		253,
		250,
		238,
		236,
		259,
		224,
		212,
		-1,
		225,
		223,
		229,
		236,
		253,
		283,
		-1,
		-1,
		241,
		221,
		-1,
		-1,
		193,
		191,
		180,
		-1,
		170,
		143,
		148,
		168,
		170,
		159,
		153,
		147,
		154,
		153,
		161,
		169,
		262,
		276,
		265,
		261,
		260,
		268,
		217,
		210,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		227,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		161,
		165,
		157,
		150,
		145,
		156,
		148,
		152,
		169,
		-1,
		296,
		-1,
		248,
		224,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		201,
		169,
		174,
		169,
		151,
		162,
		151,
		154,
		168,
		163,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		238,
		240,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		158,
		183,
		172,
		180,
		175,
		155,
		161,
		164,
		153,
		157,
		169,
		-1,
		-1,
		243,
		244,
		245,
		-1,
		223,
		-1,
		241,
		-1,
		208,
		214,
		202,
		-1,
		-1,
		-1,
		196,
		159,
		180,
		190,
		184,
		182,
		173,
		159,
		166,
		164,
		160,
		171,
		-1,
		-1,
		-1,
		241,
		215,
		248,
		239,
		222,
		202,
		194,
		213,
		-1,
		183,
		-1,
		158,
		160,
		186,
		189,
		195,
		189,
		162,
		177,
		167,
		158,
		167,
		247,
		-1,
		217,
		250,
		214,
		208,
		184,
		188,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		211,
		196,
		177,
		164,
		171,
		171,
		164,
		-1,
		-1,
		-1,
		219,
		218,
		210,
		204,
		204,
		189,
		180,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		201,
		197,
		184,
		184,
		176,
		-1,
		320,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		213,
		208,
		181,
		169,
		175,
		171,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		177,
		212,
		-1,
		315,
		-1,
		249,
		-1,
		-1,
		231,
		211,
		203,
		192,
		181,
		179,
		170,
		161,
		183,
		199,
		183,
		181,
		184,
		185,
		-1,
		304,
		303,
		-1,
		250,
		242,
		228,
		-1,
		221,
		-1,
		227,
		188,
		-1,
		190,
		170,
		-1,
		192,
		188,
		-1,
		-1,
		291,
		266,
		-1,
		-1,
		-1,
		251,
		231,
		222,
		206,
		-1,
		181,
		181,
		-1,
		-1,
		-1,
		276,
		275,
		-1,
		244,
		247,
		-1,
		237,
		228,
		236,
		183,
		187,
		-1,
		-1,
		-1,
		285,
		266,
		260,
		259,
		257,
		252,
		249,
		235,
		219,
		197,
		186,
		207,
		-1,
		-1,
		-1,
		257,
		249,
		242,
		-1,
		-1,
		244,
		227,
		208,
		206,
		-1,
		-1,
		-1,
		279,
		260,
		-1,
		-1,
		234,
		-1,
		-1,
		240,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		268,
		-1,
		-1,
		-1,
		230,
		226,
		227,
		-1,
		-1,
		-1,
		-1,
		290,
		291,
		314,
		278,
		-1,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		293,
		291,
		-1,
		-1,
		-1,
		250,
		234,
		-1,
		220,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		255,
		-1,
		255,
		230,
		237,
		-1,
		-1,
		-1,
		-1,
		268,
		260,
		268,
		-1,
		240,
		242,
		-1,
		290,
		-1,
		-1,
		283,
		274,
		-1,
		-1,
		245,
		252,
		274,
		277,
		313,
		-1,
		264
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		169,
		171,
		137,
		131,
		170,
		141,
		147,
		158,
		-1,
		-1,
		-1,
		160,
		159,
		129,
		127,
		136,
		141,
		148,
		-1,
		171,
		-1,
		181,
		160,
		171,
		176,
		122,
		119,
		139,
		158,
		164,
		156,
		196,
		152,
		123,
		117,
		135,
		140,
		158,
		150,
		-1,
		123,
		113,
		135,
		139,
		151,
		134,
		-1,
		-1,
		117,
		118,
		124,
		136,
		141,
		146,
		-1,
		172,
		191,
		-1,
		-1,
		107,
		120,
		116,
		119,
		127,
		143,
		164,
		181,
		186,
		-1,
		-1,
		108,
		112,
		125,
		126,
		124,
		151,
		170,
		181,
		195,
		194,
		-1,
		96,
		114,
		123,
		132,
		138,
		127,
		131,
		149,
		180,
		186,
		189,
		-1,
		88,
		90,
		119,
		125,
		137,
		143,
		130,
		136,
		155,
		168,
		187,
		178,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		85,
		93,
		119,
		118,
		114,
		132,
		154,
		133,
		139,
		143,
		160,
		176,
		177,
		187,
		-1,
		-1,
		136,
		105,
		140,
		97,
		82,
		-1,
		81,
		100,
		106,
		110,
		115,
		123,
		151,
		149,
		-1,
		154,
		153,
		184,
		170,
		181,
		96,
		-1,
		-1,
		94,
		86,
		71,
		74,
		71,
		76,
		106,
		105,
		110,
		112,
		114,
		126,
		141,
		141,
		151,
		148,
		158,
		162,
		177,
		188,
		-1,
		-1,
		262,
		-1,
		-1,
		90,
		76,
		-1,
		59,
		66,
		66,
		83,
		74,
		99,
		114,
		118,
		126,
		129,
		117,
		136,
		133,
		157,
		153,
		145,
		170,
		174,
		180,
		198,
		199,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		52,
		55,
		61,
		85,
		95,
		-1,
		121,
		119,
		143,
		137,
		142,
		138,
		123,
		141,
		139,
		154,
		156,
		152,
		154,
		191,
		182,
		203,
		200,
		231,
		237,
		231,
		240,
		-1,
		67,
		63,
		59,
		66,
		49,
		-1,
		-1,
		89,
		-1,
		103,
		116,
		133,
		123,
		126,
		138,
		146,
		145,
		129,
		147,
		142,
		145,
		164,
		160,
		169,
		179,
		178,
		196,
		209,
		224,
		228,
		234,
		-1,
		117,
		-1,
		59,
		43,
		46,
		55,
		83,
		-1,
		109,
		104,
		124,
		135,
		135,
		-1,
		151,
		148,
		161,
		145,
		130,
		147,
		149,
		153,
		163,
		167,
		182,
		173,
		191,
		198,
		206,
		210,
		230,
		242,
		77,
		67,
		-1,
		29,
		34,
		58,
		70,
		106,
		147,
		131,
		-1,
		146,
		-1,
		153,
		166,
		-1,
		151,
		147,
		136,
		152,
		160,
		167,
		170,
		164,
		161,
		179,
		182,
		199,
		203,
		219,
		-1,
		-1,
		0,
		47,
		79,
		64,
		91,
		115,
		152,
		140,
		149,
		151,
		-1,
		171,
		172,
		169,
		170,
		156,
		149,
		150,
		166,
		172,
		164,
		163,
		166,
		188,
		216,
		194,
		206,
		-1,
		-1,
		-1,
		25,
		-1,
		-1,
		98,
		69,
		93,
		135,
		179,
		172,
		160,
		158,
		158,
		152,
		-1,
		187,
		166,
		163,
		154,
		159,
		172,
		167,
		183,
		167,
		169,
		185,
		197,
		188,
		208,
		-1,
		-1,
		-1,
		128,
		117,
		118,
		72,
		106,
		124,
		191,
		177,
		182,
		157,
		150,
		144,
		181,
		183,
		160,
		168,
		160,
		149,
		163,
		171,
		175,
		169,
		178,
		179,
		203,
		210,
		216,
		-1,
		-1,
		135,
		125,
		109,
		111,
		108,
		97,
		104,
		136,
		182,
		179,
		-1,
		149,
		-1,
		138,
		146,
		145,
		151,
		163,
		149,
		154,
		165,
		177,
		183,
		174,
		189,
		208,
		208,
		200,
		225,
		228,
		-1,
		-1,
		-1,
		128,
		145,
		120,
		97,
		78,
		114,
		-1,
		149,
		150,
		-1,
		143,
		137,
		143,
		142,
		149,
		146,
		146,
		160,
		168,
		164,
		180,
		186,
		175,
		211,
		-1,
		208,
		202,
		223,
		213,
		201,
		-1,
		-1,
		-1,
		143,
		122,
		115,
		135,
		85,
		137,
		-1,
		-1,
		134,
		127,
		-1,
		130,
		130,
		137,
		146,
		151,
		156,
		164,
		159,
		172,
		177,
		180,
		188,
		206,
		210,
		214,
		203,
		199,
		196,
		210,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		105,
		-1,
		142,
		134,
		125,
		119,
		125,
		143,
		141,
		161,
		153,
		167,
		167,
		173,
		181,
		166,
		169,
		183,
		183,
		201,
		209,
		201,
		195,
		194,
		206,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		120,
		-1,
		91,
		115,
		131,
		-1,
		159,
		138,
		161,
		139,
		153,
		149,
		187,
		188,
		166,
		171,
		179,
		189,
		191,
		180,
		191,
		183,
		205,
		205,
		189,
		190,
		199,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		94,
		107,
		118,
		-1,
		-1,
		203,
		-1,
		137,
		154,
		163,
		161,
		177,
		168,
		174,
		190,
		193,
		195,
		185,
		174,
		180,
		177,
		199,
		185,
		183,
		202,
		218,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		181,
		171,
		155,
		140,
		173,
		-1,
		185,
		169,
		174,
		-1,
		220,
		-1,
		193,
		195,
		189,
		174,
		171,
		182,
		180,
		191,
		208,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		151,
		-1,
		-1,
		168,
		162,
		162,
		146,
		149,
		201,
		181,
		175,
		174,
		215,
		215,
		201,
		187,
		180,
		177,
		174,
		187,
		207,
		198,
		210,
		-1,
		-1,
		-1,
		152,
		132,
		138,
		96,
		117,
		-1,
		-1,
		230,
		185,
		171,
		-1,
		155,
		218,
		206,
		196,
		186,
		220,
		221,
		206,
		199,
		185,
		187,
		185,
		183,
		188,
		209,
		210,
		223,
		-1,
		-1,
		129,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		177,
		193,
		185,
		156,
		207,
		-1,
		-1,
		198,
		196,
		206,
		202,
		189,
		209,
		212,
		198,
		182,
		197,
		209,
		217,
		222,
		-1,
		132,
		119,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		188,
		209,
		234,
		201,
		-1,
		206,
		207,
		193,
		207,
		214,
		200,
		195,
		189,
		192,
		210,
		227,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		167,
		181,
		202,
		208,
		220,
		-1,
		215,
		209,
		195,
		212,
		213,
		210,
		201,
		193,
		198,
		195,
		208,
		222,
		226,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		185,
		200,
		262,
		239,
		212,
		216,
		209,
		203,
		203,
		219,
		221,
		232,
		200,
		196,
		197,
		201,
		200,
		217,
		227,
		-1,
		-1,
		152,
		169,
		204,
		193,
		197,
		289,
		-1,
		-1,
		225,
		216,
		207,
		210,
		213,
		216,
		206,
		203,
		208,
		213,
		201,
		210,
		228,
		232,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		212,
		296,
		243,
		225,
		221,
		219,
		212,
		221,
		216,
		211,
		221,
		230,
		222,
		203,
		214,
		237,
		226,
		264,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		201,
		176,
		191,
		237,
		232,
		233,
		258,
		255,
		-1,
		225,
		250,
		222,
		229,
		221,
		229,
		229,
		226,
		204,
		211,
		227,
		226,
		221,
		256,
		248,
		254,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		207,
		193,
		223,
		213,
		219,
		-1,
		-1,
		266,
		263,
		247,
		231,
		235,
		228,
		223,
		233,
		213,
		200,
		204,
		208,
		214,
		219,
		224,
		230,
		245,
		260,
		-1,
		177,
		258,
		251,
		234,
		242,
		273,
		-1,
		210,
		219,
		200,
		205,
		213,
		-1,
		-1,
		239,
		235,
		240,
		238,
		235,
		243,
		238,
		229,
		214,
		220,
		207,
		206,
		224,
		228,
		237,
		244,
		234,
		247,
		251,
		-1,
		191,
		234,
		228,
		231,
		255,
		269,
		-1,
		223,
		-1,
		-1,
		208,
		226,
		234,
		230,
		234,
		287,
		252,
		247,
		237,
		235,
		226,
		217,
		224,
		215,
		215,
		218,
		233,
		238,
		230,
		244,
		244,
		245,
		-1,
		226,
		214,
		222,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		224,
		-1,
		260,
		-1,
		253,
		257,
		260,
		263,
		251,
		238,
		230,
		222,
		238,
		213,
		223,
		219,
		220,
		229,
		240,
		252,
		251,
		252,
		300,
		255,
		222,
		213,
		260,
		275,
		279,
		-1,
		236,
		275,
		262,
		-1,
		233,
		-1,
		-1,
		-1,
		267,
		273,
		265,
		271,
		250,
		250,
		224,
		228,
		218,
		225,
		235,
		237,
		229,
		233,
		246,
		257,
		260,
		296,
		294,
		299,
		244,
		227,
		245,
		254,
		275,
		251,
		242,
		269,
		269,
		258,
		253,
		240,
		-1,
		-1,
		290,
		283,
		-1,
		-1,
		257,
		245,
		228,
		229,
		225,
		228,
		243,
		246,
		236,
		234,
		228,
		260,
		-1,
		296,
		295,
		284,
		281,
		257,
		248,
		235,
		246,
		-1,
		-1,
		254,
		270,
		283,
		287,
		300,
		325,
		-1,
		243,
		-1,
		-1,
		302,
		-1,
		-1,
		287,
		250,
		239,
		230,
		236,
		233,
		244,
		254,
		242,
		243,
		233,
		243,
		256,
		280,
		277,
		265,
		263,
		286,
		243,
		239,
		-1,
		269,
		257,
		263,
		270,
		287,
		314,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		285,
		283,
		272,
		-1,
		262,
		235,
		240,
		260,
		262,
		251,
		245,
		239,
		246,
		245,
		253,
		261,
		289,
		303,
		292,
		288,
		287,
		295,
		244,
		261,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		-1,
		294,
		269,
		-1,
		-1,
		280,
		273,
		261,
		249,
		239,
		249,
		253,
		257,
		249,
		242,
		237,
		248,
		240,
		244,
		261,
		-1,
		323,
		-1,
		275,
		268,
		283,
		298,
		306,
		-1,
		-1,
		-1,
		311,
		297,
		290,
		278,
		276,
		-1,
		314,
		298,
		279,
		-1,
		249,
		262,
		293,
		261,
		266,
		261,
		243,
		254,
		243,
		246,
		260,
		255,
		-1,
		-1,
		281,
		284,
		-1,
		-1,
		306,
		325,
		-1,
		302,
		291,
		276,
		268,
		-1,
		-1,
		286,
		282,
		-1,
		-1,
		250,
		275,
		264,
		272,
		267,
		247,
		253,
		256,
		245,
		249,
		261,
		-1,
		-1,
		288,
		289,
		294,
		-1,
		315,
		-1,
		326,
		-1,
		271,
		287,
		289,
		-1,
		-1,
		-1,
		288,
		251,
		272,
		282,
		276,
		274,
		265,
		251,
		258,
		256,
		252,
		263,
		-1,
		-1,
		-1,
		333,
		307,
		333,
		324,
		307,
		287,
		279,
		304,
		-1,
		275,
		-1,
		250,
		252,
		278,
		281,
		287,
		281,
		254,
		269,
		259,
		250,
		259,
		339,
		-1,
		309,
		342,
		306,
		293,
		276,
		280,
		296,
		-1,
		272,
		254,
		-1,
		282,
		272,
		303,
		288,
		269,
		256,
		263,
		263,
		256,
		-1,
		-1,
		-1,
		311,
		310,
		302,
		296,
		296,
		281,
		272,
		-1,
		284,
		266,
		245,
		262,
		262,
		253,
		261,
		293,
		289,
		276,
		276,
		268,
		-1,
		395,
		-1,
		-1,
		334,
		-1,
		-1,
		-1,
		305,
		300,
		273,
		261,
		267,
		263,
		249,
		255,
		257,
		265,
		263,
		260,
		272,
		268,
		288,
		269,
		304,
		-1,
		402,
		-1,
		341,
		-1,
		-1,
		323,
		303,
		295,
		284,
		273,
		271,
		262,
		253,
		275,
		291,
		275,
		273,
		276,
		277,
		-1,
		396,
		395,
		-1,
		342,
		334,
		320,
		-1,
		313,
		-1,
		319,
		280,
		-1,
		282,
		262,
		-1,
		284,
		280,
		-1,
		-1,
		383,
		358,
		-1,
		-1,
		-1,
		343,
		323,
		314,
		298,
		-1,
		273,
		273,
		-1,
		-1,
		-1,
		368,
		367,
		-1,
		336,
		339,
		-1,
		329,
		320,
		328,
		275,
		279,
		-1,
		-1,
		-1,
		377,
		358,
		352,
		351,
		349,
		344,
		341,
		327,
		311,
		289,
		278,
		299,
		-1,
		-1,
		-1,
		349,
		341,
		334,
		-1,
		-1,
		336,
		319,
		300,
		298,
		-1,
		-1,
		-1,
		371,
		352,
		-1,
		-1,
		326,
		-1,
		-1,
		332,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		388,
		360,
		-1,
		-1,
		-1,
		322,
		318,
		319,
		-1,
		-1,
		-1,
		-1,
		382,
		383,
		406,
		370,
		-1,
		-1,
		-1,
		314,
		308,
		-1,
		-1,
		385,
		383,
		-1,
		-1,
		-1,
		342,
		326,
		-1,
		312,
		-1,
		-1,
		-1,
		333,
		-1,
		-1,
		345,
		-1,
		-1,
		-1,
		347,
		-1,
		347,
		322,
		329,
		-1,
		-1,
		-1,
		-1,
		360,
		352,
		360,
		-1,
		332,
		334,
		-1,
		382,
		-1,
		-1,
		375,
		366,
		-1,
		-1,
		337,
		344,
		366,
		369,
		405,
		-1,
		356
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		173,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		166,
		158,
		198,
		154,
		125,
		119,
		137,
		142,
		160,
		152,
		-1,
		125,
		115,
		137,
		141,
		153,
		136,
		-1,
		-1,
		119,
		120,
		126,
		138,
		143,
		148,
		-1,
		174,
		193,
		-1,
		-1,
		109,
		122,
		118,
		121,
		129,
		145,
		166,
		183,
		188,
		-1,
		-1,
		110,
		114,
		127,
		128,
		126,
		153,
		172,
		183,
		197,
		196,
		-1,
		98,
		116,
		125,
		134,
		140,
		129,
		133,
		151,
		182,
		188,
		191,
		-1,
		90,
		92,
		121,
		127,
		139,
		145,
		132,
		138,
		157,
		170,
		189,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		87,
		95,
		121,
		120,
		116,
		134,
		156,
		135,
		141,
		145,
		162,
		178,
		179,
		189,
		-1,
		-1,
		138,
		107,
		142,
		99,
		84,
		-1,
		83,
		102,
		108,
		112,
		117,
		125,
		153,
		151,
		-1,
		156,
		155,
		186,
		172,
		183,
		98,
		-1,
		-1,
		96,
		88,
		73,
		76,
		73,
		78,
		108,
		107,
		112,
		114,
		116,
		128,
		143,
		143,
		153,
		150,
		160,
		164,
		179,
		190,
		-1,
		-1,
		264,
		-1,
		-1,
		92,
		78,
		-1,
		61,
		68,
		68,
		85,
		76,
		101,
		116,
		120,
		128,
		131,
		119,
		138,
		135,
		159,
		155,
		147,
		172,
		176,
		182,
		200,
		201,
		-1,
		263,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		54,
		57,
		63,
		87,
		97,
		-1,
		123,
		121,
		145,
		139,
		144,
		140,
		125,
		143,
		141,
		156,
		158,
		154,
		156,
		193,
		184,
		205,
		202,
		233,
		239,
		233,
		242,
		-1,
		69,
		65,
		61,
		68,
		51,
		-1,
		-1,
		91,
		-1,
		105,
		118,
		135,
		125,
		128,
		140,
		148,
		147,
		131,
		149,
		144,
		147,
		166,
		162,
		171,
		181,
		180,
		198,
		211,
		226,
		230,
		236,
		-1,
		119,
		-1,
		61,
		45,
		48,
		57,
		85,
		-1,
		111,
		106,
		126,
		137,
		137,
		-1,
		153,
		150,
		163,
		147,
		132,
		149,
		151,
		155,
		165,
		169,
		184,
		175,
		193,
		200,
		208,
		212,
		232,
		244,
		79,
		69,
		-1,
		32,
		37,
		60,
		72,
		108,
		149,
		133,
		-1,
		148,
		-1,
		155,
		168,
		-1,
		153,
		149,
		138,
		154,
		162,
		169,
		172,
		166,
		163,
		181,
		184,
		201,
		205,
		221,
		-1,
		-1,
		45,
		0,
		32,
		66,
		93,
		117,
		154,
		142,
		151,
		153,
		-1,
		173,
		174,
		171,
		172,
		158,
		151,
		152,
		168,
		174,
		166,
		165,
		168,
		190,
		218,
		196,
		208,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		71,
		71,
		95,
		137,
		181,
		174,
		162,
		160,
		160,
		154,
		-1,
		189,
		168,
		165,
		156,
		161,
		174,
		169,
		185,
		169,
		171,
		187,
		199,
		190,
		210,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		74,
		108,
		126,
		193,
		179,
		184,
		159,
		152,
		146,
		183,
		185,
		162,
		170,
		162,
		151,
		165,
		173,
		177,
		171,
		180,
		181,
		205,
		212,
		218,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		99,
		106,
		138,
		184,
		181,
		-1,
		151,
		-1,
		140,
		148,
		147,
		153,
		165,
		151,
		156,
		167,
		179,
		185,
		176,
		191,
		210,
		210,
		202,
		227,
		230,
		-1,
		-1,
		-1,
		127,
		147,
		122,
		99,
		80,
		116,
		-1,
		151,
		152,
		-1,
		145,
		139,
		145,
		144,
		151,
		148,
		148,
		162,
		170,
		166,
		182,
		188,
		177,
		213,
		-1,
		210,
		204,
		225,
		215,
		203,
		-1,
		-1,
		-1,
		145,
		124,
		117,
		137,
		87,
		139,
		-1,
		-1,
		136,
		129,
		-1,
		132,
		132,
		139,
		148,
		153,
		158,
		166,
		161,
		174,
		179,
		182,
		190,
		208,
		212,
		216,
		205,
		201,
		198,
		212,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		107,
		-1,
		144,
		136,
		127,
		121,
		127,
		145,
		143,
		163,
		155,
		169,
		169,
		175,
		183,
		168,
		171,
		185,
		185,
		203,
		211,
		203,
		197,
		196,
		208,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		122,
		-1,
		93,
		117,
		133,
		-1,
		161,
		140,
		163,
		141,
		155,
		151,
		189,
		190,
		168,
		173,
		181,
		191,
		193,
		182,
		193,
		185,
		207,
		207,
		191,
		192,
		201,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		96,
		109,
		120,
		-1,
		-1,
		205,
		-1,
		139,
		156,
		165,
		163,
		179,
		170,
		176,
		192,
		195,
		197,
		187,
		176,
		182,
		179,
		201,
		187,
		185,
		204,
		220,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		183,
		173,
		157,
		142,
		175,
		-1,
		187,
		171,
		176,
		-1,
		222,
		-1,
		195,
		197,
		191,
		176,
		173,
		184,
		182,
		193,
		210,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		153,
		-1,
		-1,
		170,
		164,
		164,
		148,
		151,
		203,
		183,
		177,
		176,
		217,
		217,
		203,
		189,
		182,
		179,
		176,
		189,
		209,
		200,
		212,
		-1,
		-1,
		-1,
		154,
		134,
		140,
		98,
		119,
		-1,
		-1,
		232,
		187,
		173,
		-1,
		157,
		220,
		208,
		198,
		188,
		222,
		223,
		208,
		201,
		187,
		189,
		187,
		185,
		190,
		211,
		212,
		225,
		-1,
		-1,
		131,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		179,
		195,
		187,
		158,
		209,
		-1,
		-1,
		200,
		198,
		208,
		204,
		191,
		211,
		214,
		200,
		184,
		199,
		211,
		219,
		224,
		-1,
		134,
		121,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		212,
		178,
		190,
		211,
		236,
		203,
		-1,
		208,
		209,
		195,
		209,
		216,
		202,
		197,
		191,
		194,
		212,
		229,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		169,
		183,
		204,
		210,
		222,
		-1,
		217,
		211,
		197,
		214,
		215,
		212,
		203,
		195,
		200,
		197,
		210,
		224,
		228,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		187,
		202,
		264,
		241,
		214,
		218,
		211,
		205,
		205,
		221,
		223,
		234,
		202,
		198,
		199,
		203,
		202,
		219,
		229,
		-1,
		-1,
		154,
		171,
		206,
		195,
		199,
		291,
		-1,
		-1,
		227,
		218,
		209,
		212,
		215,
		218,
		208,
		205,
		210,
		215,
		203,
		212,
		230,
		234,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		214,
		298,
		245,
		227,
		223,
		221,
		214,
		223,
		218,
		213,
		223,
		232,
		224,
		205,
		216,
		239,
		228,
		266,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		203,
		178,
		193,
		239,
		234,
		235,
		260,
		257,
		-1,
		227,
		252,
		224,
		231,
		223,
		231,
		231,
		228,
		206,
		213,
		229,
		228,
		223,
		258,
		250,
		256,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		209,
		195,
		225,
		215,
		221,
		-1,
		-1,
		268,
		265,
		249,
		233,
		237,
		230,
		225,
		235,
		215,
		202,
		206,
		210,
		216,
		221,
		226,
		232,
		247,
		262,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		212,
		221,
		202,
		207,
		215,
		-1,
		-1,
		241,
		237,
		242,
		240,
		237,
		245,
		240,
		231,
		216,
		222,
		209,
		208,
		226,
		230,
		239,
		246,
		236,
		249,
		253,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		225,
		-1,
		-1,
		210,
		228,
		236,
		232,
		236,
		289,
		254,
		249,
		239,
		237,
		228,
		219,
		226,
		217,
		217,
		220,
		235,
		240,
		232,
		246,
		246,
		247,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		226,
		-1,
		262,
		-1,
		255,
		259,
		262,
		265,
		253,
		240,
		232,
		224,
		240,
		215,
		225,
		221,
		222,
		231,
		242,
		254,
		253,
		254,
		302,
		257,
		224,
		215,
		262,
		277,
		281,
		-1,
		238,
		277,
		264,
		-1,
		235,
		-1,
		-1,
		-1,
		269,
		275,
		267,
		273,
		252,
		252,
		226,
		230,
		220,
		227,
		237,
		239,
		231,
		235,
		248,
		259,
		262,
		298,
		296,
		301,
		246,
		229,
		247,
		256,
		277,
		253,
		244,
		271,
		271,
		260,
		255,
		242,
		-1,
		-1,
		292,
		285,
		-1,
		-1,
		259,
		247,
		230,
		231,
		227,
		230,
		245,
		248,
		238,
		236,
		230,
		262,
		-1,
		298,
		297,
		286,
		283,
		259,
		250,
		237,
		248,
		-1,
		-1,
		256,
		272,
		285,
		289,
		302,
		327,
		-1,
		245,
		-1,
		-1,
		304,
		-1,
		-1,
		289,
		252,
		241,
		232,
		238,
		235,
		246,
		256,
		244,
		245,
		235,
		245,
		258,
		282,
		279,
		267,
		265,
		288,
		245,
		241,
		-1,
		271,
		259,
		265,
		272,
		289,
		316,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		287,
		285,
		274,
		-1,
		264,
		237,
		242,
		262,
		264,
		253,
		247,
		241,
		248,
		247,
		255,
		263,
		291,
		305,
		294,
		290,
		289,
		297,
		246,
		263,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		-1,
		296,
		271,
		-1,
		-1,
		282,
		275,
		263,
		251,
		241,
		251,
		255,
		259,
		251,
		244,
		239,
		250,
		242,
		246,
		263,
		-1,
		325,
		-1,
		277,
		270,
		285,
		300,
		308,
		-1,
		-1,
		-1,
		313,
		299,
		292,
		280,
		278,
		-1,
		316,
		300,
		281,
		-1,
		251,
		264,
		295,
		263,
		268,
		263,
		245,
		256,
		245,
		248,
		262,
		257,
		-1,
		-1,
		283,
		286,
		-1,
		-1,
		308,
		327,
		-1,
		304,
		293,
		278,
		270,
		-1,
		-1,
		288,
		284,
		-1,
		-1,
		252,
		277,
		266,
		274,
		269,
		249,
		255,
		258,
		247,
		251,
		263,
		-1,
		-1,
		290,
		291,
		296,
		-1,
		317,
		-1,
		328,
		-1,
		273,
		289,
		291,
		-1,
		-1,
		-1,
		290,
		253,
		274,
		284,
		278,
		276,
		267,
		253,
		260,
		258,
		254,
		265,
		-1,
		-1,
		-1,
		335,
		309,
		335,
		326,
		309,
		289,
		281,
		306,
		-1,
		277,
		-1,
		252,
		254,
		280,
		283,
		289,
		283,
		256,
		271,
		261,
		252,
		261,
		341,
		-1,
		311,
		344,
		308,
		295,
		278,
		282,
		298,
		-1,
		274,
		256,
		-1,
		284,
		274,
		305,
		290,
		271,
		258,
		265,
		265,
		258,
		-1,
		-1,
		-1,
		313,
		312,
		304,
		298,
		298,
		283,
		274,
		-1,
		286,
		268,
		247,
		264,
		264,
		255,
		263,
		295,
		291,
		278,
		278,
		270,
		-1,
		397,
		-1,
		-1,
		336,
		-1,
		-1,
		-1,
		307,
		302,
		275,
		263,
		269,
		265,
		251,
		257,
		259,
		267,
		265,
		262,
		274,
		270,
		290,
		271,
		306,
		-1,
		404,
		-1,
		343,
		-1,
		-1,
		325,
		305,
		297,
		286,
		275,
		273,
		264,
		255,
		277,
		293,
		277,
		275,
		278,
		279,
		-1,
		398,
		397,
		-1,
		344,
		336,
		322,
		-1,
		315,
		-1,
		321,
		282,
		-1,
		284,
		264,
		-1,
		286,
		282,
		-1,
		-1,
		385,
		360,
		-1,
		-1,
		-1,
		345,
		325,
		316,
		300,
		-1,
		275,
		275,
		-1,
		-1,
		-1,
		370,
		369,
		-1,
		338,
		341,
		-1,
		331,
		322,
		330,
		277,
		281,
		-1,
		-1,
		-1,
		379,
		360,
		354,
		353,
		351,
		346,
		343,
		329,
		313,
		291,
		280,
		301,
		-1,
		-1,
		-1,
		351,
		343,
		336,
		-1,
		-1,
		338,
		321,
		302,
		300,
		-1,
		-1,
		-1,
		373,
		354,
		-1,
		-1,
		328,
		-1,
		-1,
		334,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		390,
		362,
		-1,
		-1,
		-1,
		324,
		320,
		321,
		-1,
		-1,
		-1,
		-1,
		384,
		385,
		408,
		372,
		-1,
		-1,
		-1,
		316,
		310,
		-1,
		-1,
		387,
		385,
		-1,
		-1,
		-1,
		344,
		328,
		-1,
		314,
		-1,
		-1,
		-1,
		335,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		349,
		-1,
		349,
		324,
		331,
		-1,
		-1,
		-1,
		-1,
		362,
		354,
		362,
		-1,
		334,
		336,
		-1,
		384,
		-1,
		-1,
		377,
		368,
		-1,
		-1,
		339,
		346,
		368,
		371,
		407,
		-1,
		358
	],
	[
		-1,
		169,
		158,
		169,
		177,
		150,
		157,
		-1,
		178,
		180,
		146,
		140,
		179,
		150,
		156,
		167,
		-1,
		-1,
		-1,
		169,
		168,
		138,
		136,
		145,
		150,
		157,
		-1,
		180,
		-1,
		190,
		169,
		180,
		185,
		131,
		128,
		148,
		167,
		173,
		165,
		205,
		161,
		132,
		126,
		144,
		149,
		167,
		159,
		-1,
		132,
		122,
		144,
		148,
		160,
		143,
		-1,
		-1,
		126,
		127,
		133,
		145,
		150,
		155,
		-1,
		181,
		200,
		-1,
		-1,
		116,
		129,
		125,
		128,
		136,
		152,
		173,
		190,
		195,
		-1,
		-1,
		117,
		121,
		134,
		135,
		133,
		160,
		179,
		190,
		204,
		203,
		-1,
		105,
		123,
		132,
		141,
		147,
		136,
		140,
		158,
		189,
		195,
		198,
		-1,
		97,
		99,
		128,
		134,
		146,
		152,
		139,
		145,
		164,
		177,
		196,
		187,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		102,
		128,
		127,
		123,
		141,
		163,
		142,
		148,
		152,
		169,
		185,
		186,
		196,
		-1,
		-1,
		150,
		119,
		154,
		111,
		96,
		-1,
		90,
		109,
		115,
		119,
		124,
		132,
		160,
		158,
		-1,
		163,
		162,
		193,
		179,
		190,
		110,
		-1,
		-1,
		108,
		100,
		85,
		88,
		85,
		85,
		115,
		114,
		119,
		121,
		123,
		135,
		150,
		150,
		160,
		157,
		167,
		171,
		186,
		197,
		-1,
		-1,
		264,
		-1,
		-1,
		107,
		90,
		-1,
		73,
		80,
		80,
		97,
		87,
		108,
		123,
		127,
		135,
		138,
		126,
		145,
		142,
		166,
		162,
		154,
		179,
		183,
		189,
		207,
		205,
		-1,
		263,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		66,
		69,
		75,
		99,
		109,
		-1,
		130,
		128,
		152,
		146,
		151,
		147,
		132,
		150,
		148,
		163,
		165,
		161,
		163,
		200,
		186,
		208,
		205,
		234,
		239,
		233,
		242,
		-1,
		99,
		95,
		91,
		98,
		63,
		-1,
		-1,
		103,
		-1,
		117,
		130,
		142,
		132,
		135,
		147,
		155,
		154,
		138,
		156,
		151,
		154,
		166,
		169,
		178,
		181,
		180,
		198,
		213,
		226,
		230,
		236,
		-1,
		149,
		-1,
		91,
		75,
		78,
		65,
		86,
		-1,
		123,
		118,
		138,
		144,
		144,
		-1,
		160,
		157,
		170,
		154,
		139,
		156,
		158,
		160,
		165,
		170,
		184,
		175,
		193,
		200,
		208,
		212,
		232,
		244,
		109,
		99,
		-1,
		62,
		67,
		61,
		68,
		83,
		161,
		145,
		-1,
		155,
		-1,
		162,
		175,
		-1,
		160,
		156,
		145,
		153,
		148,
		163,
		169,
		166,
		163,
		181,
		184,
		201,
		205,
		221,
		-1,
		-1,
		75,
		30,
		0,
		54,
		65,
		89,
		126,
		154,
		162,
		161,
		-1,
		155,
		181,
		178,
		168,
		155,
		145,
		146,
		154,
		167,
		146,
		165,
		168,
		190,
		218,
		196,
		208,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		39,
		51,
		67,
		109,
		191,
		184,
		172,
		140,
		140,
		134,
		-1,
		175,
		158,
		154,
		143,
		141,
		154,
		149,
		165,
		169,
		168,
		187,
		199,
		190,
		210,
		-1,
		-1,
		-1,
		95,
		84,
		85,
		54,
		88,
		98,
		173,
		159,
		164,
		139,
		132,
		126,
		178,
		175,
		142,
		150,
		142,
		131,
		145,
		153,
		157,
		166,
		175,
		181,
		205,
		205,
		211,
		-1,
		-1,
		102,
		92,
		76,
		78,
		75,
		79,
		86,
		118,
		164,
		161,
		-1,
		131,
		-1,
		120,
		128,
		127,
		133,
		145,
		131,
		136,
		147,
		159,
		172,
		168,
		175,
		210,
		210,
		195,
		215,
		218,
		-1,
		-1,
		-1,
		95,
		127,
		102,
		79,
		60,
		96,
		-1,
		131,
		132,
		-1,
		125,
		119,
		125,
		124,
		131,
		128,
		128,
		142,
		150,
		146,
		162,
		168,
		160,
		196,
		-1,
		203,
		197,
		205,
		195,
		183,
		-1,
		-1,
		-1,
		125,
		104,
		97,
		117,
		67,
		119,
		-1,
		-1,
		116,
		109,
		-1,
		112,
		112,
		119,
		128,
		133,
		138,
		146,
		141,
		154,
		159,
		165,
		170,
		188,
		192,
		196,
		185,
		181,
		178,
		192,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		87,
		-1,
		124,
		116,
		107,
		101,
		107,
		125,
		123,
		143,
		135,
		149,
		149,
		155,
		163,
		148,
		151,
		167,
		165,
		183,
		191,
		183,
		177,
		176,
		188,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		102,
		-1,
		73,
		97,
		113,
		-1,
		141,
		120,
		143,
		121,
		135,
		131,
		169,
		170,
		148,
		153,
		161,
		171,
		173,
		162,
		173,
		165,
		187,
		187,
		171,
		172,
		181,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		76,
		89,
		100,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		145,
		143,
		159,
		150,
		156,
		172,
		175,
		177,
		167,
		156,
		162,
		159,
		181,
		167,
		165,
		184,
		200,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		117,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		167,
		151,
		156,
		-1,
		202,
		-1,
		175,
		177,
		171,
		156,
		153,
		164,
		162,
		173,
		190,
		-1,
		129,
		114,
		107,
		97,
		111,
		82,
		-1,
		133,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		183,
		163,
		157,
		156,
		197,
		197,
		183,
		169,
		162,
		159,
		156,
		169,
		189,
		180,
		192,
		-1,
		-1,
		-1,
		134,
		114,
		120,
		78,
		99,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		137,
		200,
		188,
		178,
		168,
		202,
		203,
		188,
		181,
		167,
		169,
		167,
		165,
		170,
		191,
		192,
		205,
		-1,
		-1,
		111,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		159,
		175,
		167,
		138,
		189,
		-1,
		-1,
		180,
		178,
		188,
		184,
		171,
		191,
		194,
		180,
		164,
		179,
		191,
		199,
		204,
		-1,
		114,
		101,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		170,
		191,
		216,
		183,
		-1,
		188,
		189,
		175,
		189,
		196,
		182,
		177,
		171,
		174,
		192,
		209,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		149,
		163,
		184,
		190,
		202,
		-1,
		197,
		191,
		177,
		194,
		195,
		192,
		183,
		175,
		180,
		177,
		190,
		204,
		208,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		167,
		182,
		244,
		221,
		194,
		198,
		191,
		185,
		185,
		201,
		203,
		214,
		182,
		178,
		179,
		183,
		182,
		199,
		209,
		-1,
		-1,
		134,
		151,
		186,
		175,
		179,
		271,
		-1,
		-1,
		207,
		198,
		189,
		192,
		195,
		198,
		188,
		185,
		190,
		195,
		183,
		192,
		210,
		214,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		194,
		278,
		225,
		207,
		203,
		201,
		194,
		203,
		198,
		193,
		203,
		212,
		204,
		185,
		196,
		219,
		208,
		246,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		183,
		158,
		173,
		219,
		214,
		215,
		240,
		237,
		-1,
		207,
		232,
		204,
		211,
		203,
		211,
		211,
		208,
		186,
		193,
		209,
		208,
		203,
		238,
		230,
		236,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		189,
		175,
		205,
		195,
		201,
		-1,
		-1,
		248,
		245,
		229,
		213,
		217,
		210,
		205,
		215,
		195,
		182,
		186,
		190,
		196,
		201,
		206,
		212,
		227,
		242,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		192,
		201,
		182,
		187,
		195,
		-1,
		-1,
		221,
		217,
		222,
		220,
		217,
		225,
		220,
		211,
		196,
		202,
		189,
		188,
		206,
		210,
		219,
		226,
		216,
		229,
		233,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		205,
		-1,
		-1,
		190,
		208,
		216,
		212,
		216,
		269,
		234,
		229,
		219,
		217,
		208,
		199,
		206,
		197,
		197,
		200,
		215,
		220,
		212,
		226,
		226,
		227,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		206,
		-1,
		242,
		-1,
		235,
		239,
		242,
		245,
		233,
		220,
		212,
		204,
		220,
		195,
		205,
		201,
		202,
		211,
		222,
		234,
		233,
		234,
		282,
		237,
		204,
		195,
		242,
		257,
		261,
		-1,
		218,
		257,
		244,
		-1,
		215,
		-1,
		-1,
		-1,
		249,
		255,
		247,
		253,
		232,
		232,
		206,
		210,
		200,
		207,
		217,
		219,
		211,
		215,
		228,
		239,
		242,
		278,
		276,
		281,
		226,
		209,
		227,
		236,
		257,
		233,
		224,
		251,
		251,
		240,
		235,
		222,
		-1,
		-1,
		272,
		265,
		-1,
		-1,
		239,
		227,
		210,
		211,
		207,
		210,
		225,
		228,
		218,
		216,
		210,
		242,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		217,
		228,
		-1,
		-1,
		236,
		252,
		265,
		269,
		282,
		307,
		-1,
		225,
		-1,
		-1,
		284,
		-1,
		-1,
		269,
		232,
		221,
		212,
		218,
		215,
		226,
		236,
		224,
		225,
		215,
		225,
		238,
		262,
		259,
		247,
		245,
		268,
		225,
		221,
		-1,
		251,
		239,
		245,
		252,
		269,
		296,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		267,
		265,
		254,
		-1,
		244,
		217,
		222,
		242,
		244,
		233,
		227,
		221,
		228,
		227,
		235,
		243,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		243,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		-1,
		276,
		251,
		-1,
		-1,
		262,
		255,
		243,
		231,
		221,
		231,
		235,
		239,
		231,
		224,
		219,
		230,
		222,
		226,
		243,
		-1,
		305,
		-1,
		257,
		250,
		265,
		280,
		288,
		-1,
		-1,
		-1,
		293,
		279,
		272,
		260,
		258,
		-1,
		296,
		280,
		261,
		-1,
		231,
		244,
		275,
		243,
		248,
		243,
		225,
		236,
		225,
		228,
		242,
		237,
		-1,
		-1,
		263,
		266,
		-1,
		-1,
		288,
		307,
		-1,
		284,
		273,
		258,
		250,
		-1,
		-1,
		268,
		264,
		-1,
		-1,
		232,
		257,
		246,
		254,
		249,
		229,
		235,
		238,
		227,
		231,
		243,
		-1,
		-1,
		270,
		271,
		276,
		-1,
		297,
		-1,
		308,
		-1,
		253,
		269,
		271,
		-1,
		-1,
		-1,
		270,
		233,
		254,
		264,
		258,
		256,
		247,
		233,
		240,
		238,
		234,
		245,
		-1,
		-1,
		-1,
		315,
		289,
		315,
		306,
		289,
		269,
		261,
		286,
		-1,
		257,
		-1,
		232,
		234,
		260,
		263,
		269,
		263,
		236,
		251,
		241,
		232,
		241,
		321,
		-1,
		291,
		324,
		288,
		275,
		258,
		262,
		278,
		-1,
		254,
		236,
		-1,
		264,
		254,
		285,
		270,
		251,
		238,
		245,
		245,
		238,
		-1,
		-1,
		-1,
		293,
		292,
		284,
		278,
		278,
		263,
		254,
		-1,
		266,
		248,
		227,
		244,
		244,
		235,
		243,
		275,
		271,
		258,
		258,
		250,
		-1,
		377,
		-1,
		-1,
		316,
		-1,
		-1,
		-1,
		287,
		282,
		255,
		243,
		249,
		245,
		231,
		237,
		239,
		247,
		245,
		242,
		254,
		250,
		270,
		251,
		286,
		-1,
		384,
		-1,
		323,
		-1,
		-1,
		305,
		285,
		277,
		266,
		255,
		253,
		244,
		235,
		257,
		273,
		257,
		255,
		258,
		259,
		-1,
		378,
		377,
		-1,
		324,
		316,
		302,
		-1,
		295,
		-1,
		301,
		262,
		-1,
		264,
		244,
		-1,
		266,
		262,
		-1,
		-1,
		365,
		340,
		-1,
		-1,
		-1,
		325,
		305,
		296,
		280,
		-1,
		255,
		255,
		-1,
		-1,
		-1,
		350,
		349,
		-1,
		318,
		321,
		-1,
		311,
		302,
		310,
		257,
		261,
		-1,
		-1,
		-1,
		359,
		340,
		334,
		333,
		331,
		326,
		323,
		309,
		293,
		271,
		260,
		281,
		-1,
		-1,
		-1,
		331,
		323,
		316,
		-1,
		-1,
		318,
		301,
		282,
		280,
		-1,
		-1,
		-1,
		353,
		334,
		-1,
		-1,
		308,
		-1,
		-1,
		314,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		370,
		342,
		-1,
		-1,
		-1,
		304,
		300,
		301,
		-1,
		-1,
		-1,
		-1,
		364,
		365,
		388,
		352,
		-1,
		-1,
		-1,
		296,
		290,
		-1,
		-1,
		367,
		365,
		-1,
		-1,
		-1,
		324,
		308,
		-1,
		294,
		-1,
		-1,
		-1,
		315,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		329,
		-1,
		329,
		304,
		311,
		-1,
		-1,
		-1,
		-1,
		342,
		334,
		342,
		-1,
		314,
		316,
		-1,
		364,
		-1,
		-1,
		357,
		348,
		-1,
		-1,
		319,
		326,
		348,
		351,
		387,
		-1,
		338
	],
	[
		-1,
		123,
		112,
		123,
		131,
		104,
		111,
		-1,
		132,
		134,
		100,
		94,
		133,
		104,
		110,
		121,
		-1,
		-1,
		-1,
		123,
		122,
		92,
		90,
		99,
		104,
		111,
		-1,
		134,
		-1,
		144,
		123,
		134,
		139,
		85,
		82,
		102,
		121,
		127,
		119,
		159,
		115,
		86,
		80,
		98,
		103,
		121,
		113,
		-1,
		86,
		76,
		98,
		102,
		114,
		97,
		-1,
		-1,
		80,
		81,
		87,
		99,
		104,
		109,
		-1,
		135,
		154,
		-1,
		-1,
		70,
		83,
		79,
		82,
		90,
		106,
		127,
		144,
		149,
		-1,
		-1,
		71,
		75,
		88,
		89,
		87,
		114,
		133,
		144,
		158,
		157,
		-1,
		59,
		77,
		86,
		95,
		101,
		90,
		94,
		112,
		143,
		149,
		152,
		-1,
		51,
		53,
		82,
		88,
		100,
		106,
		93,
		99,
		118,
		131,
		150,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		54,
		48,
		56,
		82,
		81,
		77,
		95,
		117,
		96,
		102,
		106,
		123,
		139,
		140,
		150,
		-1,
		-1,
		104,
		73,
		108,
		65,
		50,
		-1,
		44,
		63,
		69,
		73,
		78,
		86,
		114,
		112,
		-1,
		117,
		116,
		147,
		133,
		144,
		64,
		-1,
		-1,
		62,
		54,
		39,
		42,
		39,
		39,
		69,
		68,
		73,
		75,
		77,
		89,
		104,
		104,
		114,
		111,
		121,
		125,
		140,
		151,
		-1,
		-1,
		218,
		-1,
		-1,
		61,
		44,
		-1,
		27,
		34,
		34,
		51,
		41,
		62,
		77,
		81,
		89,
		92,
		80,
		99,
		96,
		120,
		116,
		108,
		133,
		137,
		143,
		161,
		159,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		39,
		20,
		23,
		29,
		53,
		63,
		-1,
		84,
		82,
		106,
		100,
		105,
		101,
		86,
		104,
		102,
		117,
		119,
		115,
		117,
		154,
		140,
		162,
		159,
		188,
		193,
		187,
		196,
		-1,
		69,
		65,
		61,
		68,
		17,
		-1,
		-1,
		57,
		-1,
		71,
		84,
		96,
		86,
		89,
		101,
		109,
		108,
		92,
		110,
		105,
		108,
		120,
		123,
		132,
		135,
		134,
		152,
		167,
		180,
		184,
		190,
		-1,
		119,
		-1,
		61,
		45,
		47,
		11,
		32,
		-1,
		77,
		72,
		92,
		98,
		98,
		-1,
		114,
		111,
		124,
		108,
		93,
		110,
		112,
		114,
		119,
		124,
		138,
		129,
		147,
		154,
		162,
		166,
		186,
		198,
		79,
		69,
		-1,
		51,
		56,
		7,
		15,
		42,
		115,
		99,
		-1,
		109,
		-1,
		116,
		129,
		-1,
		114,
		110,
		99,
		107,
		102,
		117,
		123,
		120,
		117,
		135,
		138,
		155,
		159,
		175,
		-1,
		-1,
		64,
		68,
		57,
		0,
		27,
		51,
		88,
		108,
		116,
		115,
		-1,
		109,
		135,
		132,
		122,
		109,
		99,
		100,
		108,
		121,
		100,
		119,
		122,
		144,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		89,
		-1,
		-1,
		34,
		5,
		29,
		71,
		145,
		138,
		126,
		94,
		94,
		88,
		-1,
		129,
		112,
		108,
		97,
		95,
		108,
		103,
		119,
		123,
		122,
		141,
		153,
		144,
		164,
		-1,
		-1,
		-1,
		64,
		53,
		54,
		8,
		42,
		60,
		127,
		113,
		118,
		93,
		86,
		80,
		132,
		129,
		96,
		104,
		96,
		85,
		99,
		107,
		111,
		120,
		129,
		135,
		159,
		159,
		165,
		-1,
		-1,
		71,
		61,
		45,
		47,
		44,
		33,
		40,
		72,
		118,
		115,
		-1,
		85,
		-1,
		74,
		82,
		81,
		87,
		99,
		85,
		90,
		101,
		113,
		126,
		122,
		129,
		164,
		164,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		64,
		81,
		56,
		33,
		14,
		50,
		-1,
		85,
		86,
		-1,
		79,
		73,
		79,
		78,
		85,
		82,
		82,
		96,
		104,
		100,
		116,
		122,
		114,
		150,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		79,
		58,
		51,
		71,
		21,
		73,
		-1,
		-1,
		70,
		63,
		-1,
		66,
		66,
		73,
		82,
		87,
		92,
		100,
		95,
		108,
		113,
		119,
		124,
		142,
		146,
		150,
		139,
		135,
		132,
		146,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		24,
		41,
		-1,
		78,
		70,
		61,
		55,
		61,
		79,
		77,
		97,
		89,
		103,
		103,
		109,
		117,
		102,
		105,
		121,
		119,
		137,
		145,
		137,
		131,
		130,
		142,
		-1,
		127,
		113,
		84,
		-1,
		-1,
		56,
		-1,
		27,
		51,
		67,
		-1,
		95,
		74,
		97,
		75,
		89,
		85,
		123,
		124,
		102,
		107,
		115,
		125,
		127,
		116,
		127,
		119,
		141,
		141,
		125,
		126,
		135,
		-1,
		133,
		120,
		78,
		74,
		63,
		83,
		30,
		43,
		54,
		-1,
		-1,
		139,
		-1,
		73,
		90,
		99,
		97,
		113,
		104,
		110,
		126,
		129,
		131,
		121,
		110,
		116,
		113,
		135,
		121,
		119,
		138,
		154,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		49,
		36,
		30,
		-1,
		71,
		-1,
		117,
		107,
		91,
		76,
		109,
		-1,
		121,
		105,
		110,
		-1,
		156,
		-1,
		129,
		131,
		125,
		110,
		107,
		118,
		116,
		127,
		144,
		-1,
		83,
		68,
		61,
		51,
		65,
		36,
		-1,
		87,
		-1,
		-1,
		104,
		98,
		98,
		82,
		85,
		137,
		117,
		111,
		110,
		151,
		151,
		137,
		123,
		116,
		113,
		110,
		123,
		143,
		134,
		146,
		-1,
		-1,
		-1,
		88,
		68,
		74,
		32,
		53,
		-1,
		-1,
		166,
		121,
		107,
		-1,
		91,
		154,
		142,
		132,
		122,
		156,
		157,
		142,
		135,
		121,
		123,
		121,
		119,
		124,
		145,
		146,
		159,
		-1,
		-1,
		65,
		72,
		60,
		46,
		65,
		-1,
		-1,
		-1,
		113,
		129,
		121,
		92,
		143,
		-1,
		-1,
		134,
		132,
		142,
		138,
		125,
		145,
		148,
		134,
		118,
		133,
		145,
		153,
		158,
		-1,
		68,
		55,
		-1,
		-1,
		68,
		62,
		-1,
		-1,
		-1,
		-1,
		146,
		112,
		124,
		145,
		170,
		137,
		-1,
		142,
		143,
		129,
		143,
		150,
		136,
		131,
		125,
		128,
		146,
		163,
		-1,
		-1,
		82,
		-1,
		77,
		-1,
		-1,
		-1,
		-1,
		103,
		117,
		138,
		144,
		156,
		-1,
		151,
		145,
		131,
		148,
		149,
		146,
		137,
		129,
		134,
		131,
		144,
		158,
		162,
		105,
		-1,
		88,
		-1,
		-1,
		-1,
		121,
		136,
		198,
		175,
		148,
		152,
		145,
		139,
		139,
		155,
		157,
		168,
		136,
		132,
		133,
		137,
		136,
		153,
		163,
		-1,
		-1,
		88,
		105,
		140,
		129,
		133,
		225,
		-1,
		-1,
		161,
		152,
		143,
		146,
		149,
		152,
		142,
		139,
		144,
		149,
		137,
		146,
		164,
		168,
		-1,
		-1,
		-1,
		108,
		-1,
		123,
		-1,
		-1,
		148,
		232,
		179,
		161,
		157,
		155,
		148,
		157,
		152,
		147,
		157,
		166,
		158,
		139,
		150,
		173,
		162,
		200,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		137,
		112,
		127,
		173,
		168,
		169,
		194,
		191,
		-1,
		161,
		186,
		158,
		165,
		157,
		165,
		165,
		162,
		140,
		147,
		163,
		162,
		157,
		192,
		184,
		190,
		-1,
		-1,
		218,
		207,
		196,
		202,
		-1,
		143,
		129,
		159,
		149,
		155,
		-1,
		-1,
		202,
		199,
		183,
		167,
		171,
		164,
		159,
		169,
		149,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		113,
		194,
		187,
		170,
		178,
		209,
		-1,
		146,
		155,
		136,
		141,
		149,
		-1,
		-1,
		175,
		171,
		176,
		174,
		171,
		179,
		174,
		165,
		150,
		156,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		127,
		170,
		164,
		167,
		191,
		205,
		-1,
		159,
		-1,
		-1,
		144,
		162,
		170,
		166,
		170,
		223,
		188,
		183,
		173,
		171,
		162,
		153,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		162,
		150,
		158,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		160,
		-1,
		196,
		-1,
		189,
		193,
		196,
		199,
		187,
		174,
		166,
		158,
		174,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		236,
		191,
		158,
		149,
		196,
		211,
		215,
		-1,
		172,
		211,
		198,
		-1,
		169,
		-1,
		-1,
		-1,
		203,
		209,
		201,
		207,
		186,
		186,
		160,
		164,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		232,
		230,
		235,
		180,
		163,
		181,
		190,
		211,
		187,
		178,
		205,
		205,
		194,
		189,
		176,
		-1,
		-1,
		226,
		219,
		-1,
		-1,
		193,
		181,
		164,
		165,
		161,
		164,
		179,
		182,
		172,
		170,
		164,
		196,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		171,
		182,
		-1,
		-1,
		190,
		206,
		219,
		223,
		236,
		261,
		-1,
		179,
		-1,
		-1,
		238,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		169,
		180,
		190,
		178,
		179,
		169,
		179,
		192,
		216,
		213,
		201,
		199,
		222,
		179,
		175,
		-1,
		205,
		193,
		199,
		206,
		223,
		250,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		171,
		176,
		196,
		198,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		205,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		189,
		193,
		185,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		259,
		-1,
		211,
		204,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		242,
		261,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		251,
		-1,
		262,
		-1,
		207,
		223,
		225,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		212,
		210,
		201,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		269,
		243,
		269,
		260,
		243,
		223,
		215,
		240,
		-1,
		211,
		-1,
		186,
		188,
		214,
		217,
		223,
		217,
		190,
		205,
		195,
		186,
		195,
		275,
		-1,
		245,
		278,
		242,
		229,
		212,
		216,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		239,
		224,
		205,
		192,
		199,
		199,
		192,
		-1,
		-1,
		-1,
		247,
		246,
		238,
		232,
		232,
		217,
		208,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		229,
		225,
		212,
		212,
		204,
		-1,
		331,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		241,
		236,
		209,
		197,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		205,
		240,
		-1,
		338,
		-1,
		277,
		-1,
		-1,
		259,
		239,
		231,
		220,
		209,
		207,
		198,
		189,
		211,
		227,
		211,
		209,
		212,
		213,
		-1,
		332,
		331,
		-1,
		278,
		270,
		256,
		-1,
		249,
		-1,
		255,
		216,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		319,
		294,
		-1,
		-1,
		-1,
		279,
		259,
		250,
		234,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		304,
		303,
		-1,
		272,
		275,
		-1,
		265,
		256,
		264,
		211,
		215,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		287,
		285,
		280,
		277,
		263,
		247,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		285,
		277,
		270,
		-1,
		-1,
		272,
		255,
		236,
		234,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		262,
		-1,
		-1,
		268,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		296,
		-1,
		-1,
		-1,
		258,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		318,
		319,
		342,
		306,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		321,
		319,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		140,
		129,
		140,
		148,
		121,
		128,
		-1,
		149,
		151,
		117,
		111,
		150,
		121,
		127,
		138,
		-1,
		-1,
		-1,
		140,
		139,
		109,
		107,
		116,
		121,
		128,
		-1,
		151,
		-1,
		161,
		140,
		151,
		156,
		102,
		99,
		119,
		138,
		144,
		136,
		176,
		132,
		103,
		97,
		115,
		120,
		138,
		130,
		-1,
		103,
		93,
		115,
		119,
		131,
		114,
		-1,
		-1,
		97,
		98,
		104,
		116,
		121,
		126,
		-1,
		152,
		171,
		-1,
		-1,
		87,
		100,
		96,
		99,
		107,
		123,
		144,
		161,
		166,
		-1,
		-1,
		88,
		92,
		105,
		106,
		104,
		131,
		150,
		161,
		175,
		174,
		-1,
		76,
		94,
		103,
		112,
		118,
		107,
		111,
		129,
		160,
		166,
		169,
		-1,
		68,
		70,
		99,
		105,
		117,
		123,
		110,
		116,
		135,
		148,
		167,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		65,
		73,
		99,
		98,
		94,
		112,
		134,
		113,
		119,
		123,
		140,
		156,
		157,
		167,
		-1,
		-1,
		121,
		90,
		125,
		82,
		67,
		-1,
		61,
		80,
		86,
		90,
		95,
		103,
		131,
		129,
		-1,
		134,
		133,
		164,
		150,
		161,
		81,
		-1,
		-1,
		79,
		71,
		56,
		59,
		56,
		56,
		86,
		85,
		90,
		92,
		94,
		106,
		121,
		121,
		131,
		128,
		138,
		142,
		157,
		168,
		-1,
		-1,
		235,
		-1,
		-1,
		78,
		61,
		-1,
		44,
		51,
		51,
		68,
		58,
		79,
		94,
		98,
		106,
		109,
		97,
		116,
		113,
		137,
		133,
		125,
		150,
		154,
		160,
		178,
		176,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		56,
		37,
		40,
		46,
		70,
		80,
		-1,
		101,
		99,
		123,
		117,
		122,
		118,
		103,
		121,
		119,
		134,
		136,
		132,
		134,
		171,
		157,
		179,
		176,
		205,
		210,
		204,
		213,
		-1,
		86,
		82,
		78,
		85,
		34,
		-1,
		-1,
		74,
		-1,
		88,
		101,
		113,
		103,
		106,
		118,
		126,
		125,
		109,
		127,
		122,
		125,
		137,
		140,
		149,
		152,
		151,
		169,
		184,
		197,
		201,
		207,
		-1,
		136,
		-1,
		78,
		62,
		64,
		36,
		57,
		-1,
		94,
		89,
		109,
		115,
		115,
		-1,
		131,
		128,
		141,
		125,
		110,
		127,
		129,
		131,
		136,
		141,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		96,
		86,
		-1,
		68,
		73,
		32,
		37,
		51,
		132,
		116,
		-1,
		126,
		-1,
		133,
		146,
		-1,
		131,
		127,
		116,
		124,
		119,
		134,
		140,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		81,
		85,
		66,
		25,
		0,
		30,
		67,
		118,
		127,
		129,
		-1,
		126,
		152,
		149,
		139,
		126,
		116,
		117,
		125,
		138,
		117,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		43,
		22,
		8,
		50,
		157,
		150,
		138,
		111,
		111,
		105,
		-1,
		146,
		129,
		125,
		114,
		112,
		125,
		120,
		136,
		140,
		139,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		73,
		62,
		63,
		25,
		39,
		47,
		144,
		130,
		135,
		110,
		103,
		97,
		149,
		146,
		113,
		121,
		113,
		102,
		116,
		124,
		128,
		137,
		146,
		152,
		176,
		176,
		182,
		-1,
		-1,
		80,
		70,
		54,
		56,
		53,
		50,
		48,
		88,
		135,
		132,
		-1,
		102,
		-1,
		91,
		99,
		98,
		104,
		116,
		102,
		107,
		118,
		130,
		143,
		139,
		146,
		181,
		181,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		73,
		98,
		73,
		50,
		31,
		62,
		-1,
		102,
		103,
		-1,
		96,
		90,
		96,
		95,
		102,
		99,
		99,
		113,
		121,
		117,
		133,
		139,
		131,
		167,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		96,
		75,
		68,
		88,
		38,
		90,
		-1,
		-1,
		87,
		80,
		-1,
		83,
		83,
		90,
		99,
		104,
		109,
		117,
		112,
		125,
		130,
		136,
		141,
		159,
		163,
		167,
		156,
		152,
		149,
		163,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		41,
		58,
		-1,
		95,
		87,
		78,
		72,
		78,
		96,
		94,
		114,
		106,
		120,
		120,
		126,
		134,
		119,
		122,
		138,
		136,
		154,
		162,
		154,
		148,
		147,
		159,
		-1,
		144,
		130,
		101,
		-1,
		-1,
		73,
		-1,
		44,
		68,
		84,
		-1,
		112,
		91,
		114,
		92,
		106,
		102,
		140,
		141,
		119,
		124,
		132,
		142,
		144,
		133,
		144,
		136,
		158,
		158,
		142,
		143,
		152,
		-1,
		150,
		137,
		95,
		91,
		80,
		100,
		47,
		60,
		71,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		116,
		114,
		130,
		121,
		127,
		143,
		146,
		148,
		138,
		127,
		133,
		130,
		152,
		138,
		136,
		155,
		171,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		66,
		53,
		47,
		-1,
		88,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		138,
		122,
		127,
		-1,
		173,
		-1,
		146,
		148,
		142,
		127,
		124,
		135,
		133,
		144,
		161,
		-1,
		100,
		85,
		78,
		68,
		82,
		53,
		-1,
		104,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		154,
		134,
		128,
		127,
		168,
		168,
		154,
		140,
		133,
		130,
		127,
		140,
		160,
		151,
		163,
		-1,
		-1,
		-1,
		105,
		85,
		91,
		49,
		70,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		171,
		159,
		149,
		139,
		173,
		174,
		159,
		152,
		138,
		140,
		138,
		136,
		141,
		162,
		163,
		176,
		-1,
		-1,
		82,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		160,
		-1,
		-1,
		151,
		149,
		159,
		155,
		142,
		162,
		165,
		151,
		135,
		150,
		162,
		170,
		175,
		-1,
		85,
		72,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		162,
		187,
		154,
		-1,
		159,
		160,
		146,
		160,
		167,
		153,
		148,
		142,
		145,
		163,
		180,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		155,
		161,
		173,
		-1,
		168,
		162,
		148,
		165,
		166,
		163,
		154,
		146,
		151,
		148,
		161,
		175,
		179,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		138,
		153,
		215,
		192,
		165,
		169,
		162,
		156,
		156,
		172,
		174,
		185,
		153,
		149,
		150,
		154,
		153,
		170,
		180,
		-1,
		-1,
		105,
		122,
		157,
		146,
		150,
		242,
		-1,
		-1,
		178,
		169,
		160,
		163,
		166,
		169,
		159,
		156,
		161,
		166,
		154,
		163,
		181,
		185,
		-1,
		-1,
		-1,
		125,
		-1,
		140,
		-1,
		-1,
		165,
		249,
		196,
		178,
		174,
		172,
		165,
		174,
		169,
		164,
		174,
		183,
		175,
		156,
		167,
		190,
		179,
		217,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		154,
		129,
		144,
		190,
		185,
		186,
		211,
		208,
		-1,
		178,
		203,
		175,
		182,
		174,
		182,
		182,
		179,
		157,
		164,
		180,
		179,
		174,
		209,
		201,
		207,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		160,
		146,
		176,
		166,
		172,
		-1,
		-1,
		219,
		216,
		200,
		184,
		188,
		181,
		176,
		186,
		166,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		130,
		211,
		204,
		187,
		195,
		226,
		-1,
		163,
		172,
		153,
		158,
		166,
		-1,
		-1,
		192,
		188,
		193,
		191,
		188,
		196,
		191,
		182,
		167,
		173,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		144,
		187,
		181,
		184,
		208,
		222,
		-1,
		176,
		-1,
		-1,
		161,
		179,
		187,
		183,
		187,
		240,
		205,
		200,
		190,
		188,
		179,
		170,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		179,
		167,
		175,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		177,
		-1,
		213,
		-1,
		206,
		210,
		213,
		216,
		204,
		191,
		183,
		175,
		191,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		253,
		208,
		175,
		166,
		213,
		228,
		232,
		-1,
		189,
		228,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		220,
		226,
		218,
		224,
		203,
		203,
		177,
		181,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		249,
		247,
		252,
		197,
		180,
		198,
		207,
		228,
		204,
		195,
		222,
		222,
		211,
		206,
		193,
		-1,
		-1,
		243,
		236,
		-1,
		-1,
		210,
		198,
		181,
		182,
		178,
		181,
		196,
		199,
		189,
		187,
		181,
		213,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		188,
		199,
		-1,
		-1,
		207,
		223,
		236,
		240,
		253,
		278,
		-1,
		196,
		-1,
		-1,
		255,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		186,
		197,
		207,
		195,
		196,
		186,
		196,
		209,
		233,
		230,
		218,
		216,
		239,
		196,
		192,
		-1,
		222,
		210,
		216,
		223,
		240,
		267,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		238,
		236,
		225,
		-1,
		215,
		188,
		193,
		213,
		215,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		222,
		-1,
		-1,
		233,
		226,
		214,
		202,
		192,
		202,
		206,
		210,
		202,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		276,
		-1,
		228,
		221,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		234,
		237,
		-1,
		-1,
		259,
		278,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		241,
		242,
		247,
		-1,
		268,
		-1,
		279,
		-1,
		224,
		240,
		242,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		229,
		227,
		218,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		286,
		260,
		286,
		277,
		260,
		240,
		232,
		257,
		-1,
		228,
		-1,
		203,
		205,
		231,
		234,
		240,
		234,
		207,
		222,
		212,
		203,
		212,
		292,
		-1,
		262,
		295,
		259,
		246,
		229,
		233,
		249,
		-1,
		225,
		207,
		-1,
		235,
		225,
		256,
		241,
		222,
		209,
		216,
		216,
		209,
		-1,
		-1,
		-1,
		264,
		263,
		255,
		249,
		249,
		234,
		225,
		-1,
		237,
		219,
		198,
		215,
		215,
		206,
		214,
		246,
		242,
		229,
		229,
		221,
		-1,
		348,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		258,
		253,
		226,
		214,
		220,
		216,
		202,
		208,
		210,
		218,
		216,
		213,
		225,
		221,
		241,
		222,
		257,
		-1,
		355,
		-1,
		294,
		-1,
		-1,
		276,
		256,
		248,
		237,
		226,
		224,
		215,
		206,
		228,
		244,
		228,
		226,
		229,
		230,
		-1,
		349,
		348,
		-1,
		295,
		287,
		273,
		-1,
		266,
		-1,
		272,
		233,
		-1,
		235,
		215,
		-1,
		237,
		233,
		-1,
		-1,
		336,
		311,
		-1,
		-1,
		-1,
		296,
		276,
		267,
		251,
		-1,
		226,
		226,
		-1,
		-1,
		-1,
		321,
		320,
		-1,
		289,
		292,
		-1,
		282,
		273,
		281,
		228,
		232,
		-1,
		-1,
		-1,
		330,
		311,
		305,
		304,
		302,
		297,
		294,
		280,
		264,
		242,
		231,
		252,
		-1,
		-1,
		-1,
		302,
		294,
		287,
		-1,
		-1,
		289,
		272,
		253,
		251,
		-1,
		-1,
		-1,
		324,
		305,
		-1,
		-1,
		279,
		-1,
		-1,
		285,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		341,
		313,
		-1,
		-1,
		-1,
		275,
		271,
		272,
		-1,
		-1,
		-1,
		-1,
		335,
		336,
		359,
		323,
		-1,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		338,
		336,
		-1,
		-1,
		-1,
		295,
		279,
		-1,
		265,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		300,
		-1,
		300,
		275,
		282,
		-1,
		-1,
		-1,
		-1,
		313,
		305,
		313,
		-1,
		285,
		287,
		-1,
		335,
		-1,
		-1,
		328,
		319,
		-1,
		-1,
		290,
		297,
		319,
		322,
		358,
		-1,
		309
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		173,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		166,
		158,
		198,
		154,
		125,
		119,
		137,
		142,
		160,
		152,
		-1,
		125,
		115,
		137,
		141,
		153,
		136,
		-1,
		-1,
		119,
		120,
		126,
		138,
		143,
		148,
		-1,
		174,
		193,
		-1,
		-1,
		109,
		122,
		118,
		121,
		129,
		145,
		166,
		183,
		188,
		-1,
		-1,
		110,
		114,
		127,
		128,
		126,
		153,
		172,
		183,
		197,
		196,
		-1,
		98,
		116,
		125,
		134,
		140,
		129,
		133,
		151,
		182,
		188,
		191,
		-1,
		90,
		92,
		121,
		127,
		139,
		145,
		132,
		138,
		157,
		170,
		189,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		87,
		95,
		121,
		120,
		116,
		134,
		156,
		135,
		141,
		145,
		162,
		178,
		179,
		189,
		-1,
		-1,
		143,
		112,
		147,
		104,
		89,
		-1,
		83,
		102,
		108,
		112,
		117,
		125,
		153,
		151,
		-1,
		156,
		155,
		186,
		172,
		183,
		103,
		-1,
		-1,
		101,
		93,
		78,
		81,
		78,
		78,
		108,
		107,
		112,
		114,
		116,
		128,
		143,
		143,
		153,
		150,
		160,
		164,
		179,
		190,
		-1,
		-1,
		257,
		-1,
		-1,
		100,
		83,
		-1,
		66,
		73,
		73,
		90,
		80,
		101,
		116,
		120,
		128,
		131,
		119,
		138,
		135,
		159,
		155,
		147,
		172,
		176,
		182,
		200,
		198,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		59,
		62,
		68,
		92,
		102,
		-1,
		123,
		121,
		145,
		139,
		144,
		140,
		125,
		143,
		141,
		156,
		158,
		154,
		156,
		193,
		179,
		201,
		198,
		227,
		232,
		226,
		235,
		-1,
		108,
		104,
		100,
		107,
		56,
		-1,
		-1,
		96,
		-1,
		110,
		123,
		124,
		125,
		128,
		140,
		148,
		147,
		131,
		149,
		144,
		147,
		159,
		162,
		171,
		174,
		173,
		191,
		206,
		219,
		223,
		229,
		-1,
		158,
		-1,
		100,
		84,
		86,
		58,
		79,
		-1,
		116,
		111,
		131,
		126,
		117,
		-1,
		153,
		150,
		163,
		147,
		132,
		149,
		151,
		153,
		158,
		163,
		177,
		168,
		186,
		193,
		201,
		205,
		225,
		237,
		118,
		108,
		-1,
		90,
		95,
		54,
		59,
		73,
		124,
		88,
		-1,
		118,
		-1,
		155,
		168,
		-1,
		153,
		149,
		138,
		146,
		141,
		156,
		162,
		159,
		156,
		174,
		177,
		194,
		198,
		214,
		-1,
		-1,
		103,
		107,
		88,
		47,
		24,
		0,
		37,
		88,
		97,
		99,
		-1,
		148,
		174,
		171,
		161,
		148,
		138,
		139,
		147,
		160,
		139,
		158,
		161,
		183,
		211,
		189,
		201,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		65,
		44,
		32,
		20,
		127,
		120,
		108,
		133,
		133,
		127,
		-1,
		168,
		151,
		147,
		136,
		134,
		147,
		142,
		158,
		162,
		161,
		180,
		192,
		183,
		203,
		-1,
		-1,
		-1,
		95,
		84,
		85,
		47,
		63,
		71,
		166,
		152,
		157,
		132,
		125,
		119,
		171,
		168,
		135,
		143,
		135,
		124,
		138,
		146,
		150,
		159,
		168,
		174,
		198,
		198,
		204,
		-1,
		-1,
		102,
		92,
		76,
		78,
		75,
		72,
		72,
		111,
		157,
		154,
		-1,
		124,
		-1,
		113,
		121,
		120,
		126,
		138,
		124,
		129,
		140,
		152,
		165,
		161,
		168,
		203,
		203,
		188,
		208,
		211,
		-1,
		-1,
		-1,
		95,
		120,
		95,
		72,
		53,
		86,
		-1,
		124,
		125,
		-1,
		118,
		112,
		118,
		117,
		124,
		121,
		121,
		135,
		143,
		139,
		155,
		161,
		153,
		189,
		-1,
		196,
		190,
		198,
		188,
		176,
		-1,
		-1,
		-1,
		118,
		97,
		90,
		110,
		60,
		112,
		-1,
		-1,
		109,
		102,
		-1,
		105,
		105,
		112,
		121,
		126,
		131,
		139,
		134,
		147,
		152,
		158,
		163,
		181,
		185,
		189,
		178,
		174,
		171,
		185,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		80,
		-1,
		117,
		109,
		100,
		94,
		100,
		118,
		116,
		136,
		128,
		142,
		142,
		148,
		156,
		141,
		144,
		160,
		158,
		176,
		184,
		176,
		170,
		169,
		181,
		-1,
		166,
		152,
		123,
		-1,
		-1,
		95,
		-1,
		66,
		90,
		106,
		-1,
		134,
		113,
		136,
		114,
		128,
		124,
		162,
		163,
		141,
		146,
		154,
		164,
		166,
		155,
		166,
		158,
		180,
		180,
		164,
		165,
		174,
		-1,
		172,
		159,
		117,
		113,
		102,
		122,
		69,
		82,
		93,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		138,
		136,
		152,
		143,
		149,
		165,
		168,
		170,
		160,
		149,
		155,
		152,
		174,
		160,
		158,
		177,
		193,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		88,
		75,
		69,
		-1,
		110,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		160,
		144,
		149,
		-1,
		195,
		-1,
		168,
		170,
		164,
		149,
		146,
		157,
		155,
		166,
		183,
		-1,
		122,
		107,
		100,
		90,
		104,
		75,
		-1,
		126,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		176,
		156,
		150,
		149,
		190,
		190,
		176,
		162,
		155,
		152,
		149,
		162,
		182,
		173,
		185,
		-1,
		-1,
		-1,
		127,
		107,
		113,
		71,
		92,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		193,
		181,
		171,
		161,
		195,
		196,
		181,
		174,
		160,
		162,
		160,
		158,
		163,
		184,
		185,
		198,
		-1,
		-1,
		104,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		182,
		-1,
		-1,
		173,
		171,
		181,
		177,
		164,
		184,
		187,
		173,
		157,
		172,
		184,
		192,
		197,
		-1,
		107,
		94,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		184,
		209,
		176,
		-1,
		181,
		182,
		168,
		182,
		189,
		175,
		170,
		164,
		167,
		185,
		202,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		177,
		183,
		195,
		-1,
		190,
		184,
		170,
		187,
		188,
		185,
		176,
		168,
		173,
		170,
		183,
		197,
		201,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		160,
		175,
		237,
		214,
		187,
		191,
		184,
		178,
		178,
		194,
		196,
		207,
		175,
		171,
		172,
		176,
		175,
		192,
		202,
		-1,
		-1,
		127,
		144,
		179,
		168,
		172,
		264,
		-1,
		-1,
		200,
		191,
		182,
		185,
		188,
		191,
		181,
		178,
		183,
		188,
		176,
		185,
		203,
		207,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		187,
		271,
		218,
		200,
		196,
		194,
		187,
		196,
		191,
		186,
		196,
		205,
		197,
		178,
		189,
		212,
		201,
		239,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		212,
		207,
		208,
		233,
		230,
		-1,
		200,
		225,
		197,
		204,
		196,
		204,
		204,
		201,
		179,
		186,
		202,
		201,
		196,
		231,
		223,
		229,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		182,
		168,
		198,
		188,
		194,
		-1,
		-1,
		241,
		238,
		222,
		206,
		210,
		203,
		198,
		208,
		188,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		152,
		233,
		226,
		209,
		217,
		248,
		-1,
		185,
		194,
		175,
		180,
		188,
		-1,
		-1,
		214,
		210,
		215,
		213,
		210,
		218,
		213,
		204,
		189,
		195,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		166,
		209,
		203,
		206,
		230,
		244,
		-1,
		198,
		-1,
		-1,
		183,
		201,
		209,
		205,
		209,
		262,
		227,
		222,
		212,
		210,
		201,
		192,
		199,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		201,
		189,
		197,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		199,
		-1,
		235,
		-1,
		228,
		232,
		235,
		238,
		226,
		213,
		205,
		197,
		213,
		188,
		198,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		275,
		230,
		197,
		188,
		235,
		250,
		254,
		-1,
		211,
		250,
		237,
		-1,
		208,
		-1,
		-1,
		-1,
		242,
		248,
		240,
		246,
		225,
		225,
		199,
		203,
		193,
		200,
		210,
		212,
		204,
		208,
		221,
		232,
		235,
		271,
		269,
		274,
		219,
		202,
		220,
		229,
		250,
		226,
		217,
		244,
		244,
		233,
		228,
		215,
		-1,
		-1,
		265,
		258,
		-1,
		-1,
		232,
		220,
		203,
		204,
		200,
		203,
		218,
		221,
		211,
		209,
		203,
		235,
		-1,
		271,
		270,
		259,
		256,
		232,
		223,
		210,
		221,
		-1,
		-1,
		229,
		245,
		258,
		262,
		275,
		300,
		-1,
		218,
		-1,
		-1,
		277,
		-1,
		-1,
		262,
		225,
		214,
		205,
		211,
		208,
		219,
		229,
		217,
		218,
		208,
		218,
		231,
		255,
		252,
		240,
		238,
		261,
		218,
		214,
		-1,
		244,
		232,
		238,
		245,
		262,
		289,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		260,
		258,
		247,
		-1,
		237,
		210,
		215,
		235,
		237,
		226,
		220,
		214,
		221,
		220,
		228,
		236,
		264,
		278,
		267,
		263,
		262,
		270,
		219,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		-1,
		269,
		244,
		-1,
		-1,
		255,
		248,
		236,
		224,
		214,
		224,
		228,
		232,
		224,
		217,
		212,
		223,
		215,
		219,
		236,
		-1,
		298,
		-1,
		250,
		243,
		258,
		273,
		281,
		-1,
		-1,
		-1,
		286,
		272,
		265,
		253,
		251,
		-1,
		289,
		273,
		254,
		-1,
		224,
		237,
		268,
		236,
		241,
		236,
		218,
		229,
		218,
		221,
		235,
		230,
		-1,
		-1,
		256,
		259,
		-1,
		-1,
		281,
		300,
		-1,
		277,
		266,
		251,
		243,
		-1,
		-1,
		261,
		257,
		-1,
		-1,
		225,
		250,
		239,
		247,
		242,
		222,
		228,
		231,
		220,
		224,
		236,
		-1,
		-1,
		263,
		264,
		269,
		-1,
		290,
		-1,
		301,
		-1,
		246,
		262,
		264,
		-1,
		-1,
		-1,
		263,
		226,
		247,
		257,
		251,
		249,
		240,
		226,
		233,
		231,
		227,
		238,
		-1,
		-1,
		-1,
		308,
		282,
		308,
		299,
		282,
		262,
		254,
		279,
		-1,
		250,
		-1,
		225,
		227,
		253,
		256,
		262,
		256,
		229,
		244,
		234,
		225,
		234,
		314,
		-1,
		284,
		317,
		281,
		268,
		251,
		255,
		271,
		-1,
		247,
		229,
		-1,
		257,
		247,
		278,
		263,
		244,
		231,
		238,
		238,
		231,
		-1,
		-1,
		-1,
		286,
		285,
		277,
		271,
		271,
		256,
		247,
		-1,
		259,
		241,
		220,
		237,
		237,
		228,
		236,
		268,
		264,
		251,
		251,
		243,
		-1,
		370,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		280,
		275,
		248,
		236,
		242,
		238,
		224,
		230,
		232,
		240,
		238,
		235,
		247,
		243,
		263,
		244,
		279,
		-1,
		377,
		-1,
		316,
		-1,
		-1,
		298,
		278,
		270,
		259,
		248,
		246,
		237,
		228,
		250,
		266,
		250,
		248,
		251,
		252,
		-1,
		371,
		370,
		-1,
		317,
		309,
		295,
		-1,
		288,
		-1,
		294,
		255,
		-1,
		257,
		237,
		-1,
		259,
		255,
		-1,
		-1,
		358,
		333,
		-1,
		-1,
		-1,
		318,
		298,
		289,
		273,
		-1,
		248,
		248,
		-1,
		-1,
		-1,
		343,
		342,
		-1,
		311,
		314,
		-1,
		304,
		295,
		303,
		250,
		254,
		-1,
		-1,
		-1,
		352,
		333,
		327,
		326,
		324,
		319,
		316,
		302,
		286,
		264,
		253,
		274,
		-1,
		-1,
		-1,
		324,
		316,
		309,
		-1,
		-1,
		311,
		294,
		275,
		273,
		-1,
		-1,
		-1,
		346,
		327,
		-1,
		-1,
		301,
		-1,
		-1,
		307,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		363,
		335,
		-1,
		-1,
		-1,
		297,
		293,
		294,
		-1,
		-1,
		-1,
		-1,
		357,
		358,
		381,
		345,
		-1,
		-1,
		-1,
		289,
		283,
		-1,
		-1,
		360,
		358,
		-1,
		-1,
		-1,
		317,
		301,
		-1,
		287,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		322,
		-1,
		322,
		297,
		304,
		-1,
		-1,
		-1,
		-1,
		335,
		327,
		335,
		-1,
		307,
		309,
		-1,
		357,
		-1,
		-1,
		350,
		341,
		-1,
		-1,
		312,
		319,
		341,
		344,
		380,
		-1,
		331
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		203,
		205,
		171,
		165,
		204,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		194,
		193,
		163,
		161,
		170,
		175,
		182,
		-1,
		205,
		-1,
		215,
		194,
		205,
		210,
		156,
		153,
		173,
		192,
		198,
		190,
		230,
		186,
		157,
		151,
		169,
		174,
		192,
		184,
		-1,
		157,
		147,
		169,
		173,
		185,
		168,
		-1,
		-1,
		151,
		152,
		158,
		170,
		175,
		180,
		-1,
		206,
		225,
		-1,
		-1,
		141,
		154,
		150,
		153,
		161,
		177,
		198,
		215,
		220,
		-1,
		-1,
		142,
		146,
		159,
		160,
		158,
		185,
		204,
		215,
		229,
		228,
		-1,
		130,
		148,
		157,
		166,
		172,
		161,
		165,
		183,
		214,
		220,
		223,
		-1,
		122,
		124,
		153,
		159,
		171,
		177,
		164,
		170,
		189,
		202,
		221,
		212,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		119,
		127,
		153,
		152,
		148,
		166,
		188,
		167,
		173,
		177,
		194,
		210,
		211,
		221,
		-1,
		-1,
		175,
		144,
		179,
		136,
		121,
		-1,
		115,
		134,
		140,
		144,
		149,
		157,
		185,
		183,
		-1,
		188,
		187,
		218,
		204,
		215,
		135,
		-1,
		-1,
		133,
		125,
		110,
		113,
		110,
		110,
		140,
		139,
		144,
		143,
		139,
		160,
		175,
		175,
		185,
		182,
		192,
		196,
		211,
		222,
		-1,
		-1,
		289,
		-1,
		-1,
		132,
		115,
		-1,
		98,
		105,
		105,
		122,
		112,
		133,
		148,
		136,
		135,
		154,
		142,
		162,
		167,
		191,
		187,
		179,
		204,
		208,
		214,
		232,
		230,
		-1,
		288,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		91,
		94,
		100,
		124,
		118,
		-1,
		95,
		101,
		125,
		128,
		140,
		153,
		148,
		175,
		173,
		188,
		190,
		186,
		188,
		225,
		211,
		233,
		230,
		259,
		264,
		258,
		267,
		-1,
		140,
		136,
		132,
		139,
		88,
		-1,
		-1,
		126,
		-1,
		84,
		112,
		87,
		105,
		108,
		129,
		129,
		160,
		154,
		172,
		176,
		179,
		191,
		194,
		203,
		206,
		205,
		223,
		238,
		251,
		255,
		261,
		-1,
		190,
		-1,
		132,
		116,
		118,
		90,
		111,
		-1,
		138,
		83,
		104,
		89,
		80,
		-1,
		133,
		130,
		144,
		151,
		156,
		173,
		183,
		185,
		190,
		195,
		209,
		200,
		218,
		225,
		233,
		237,
		257,
		269,
		150,
		140,
		-1,
		122,
		127,
		86,
		91,
		105,
		87,
		51,
		-1,
		81,
		-1,
		135,
		148,
		-1,
		150,
		154,
		162,
		178,
		173,
		188,
		194,
		191,
		188,
		206,
		209,
		226,
		230,
		246,
		-1,
		-1,
		135,
		139,
		120,
		79,
		56,
		32,
		0,
		51,
		60,
		62,
		-1,
		128,
		181,
		178,
		179,
		180,
		170,
		171,
		179,
		192,
		171,
		190,
		193,
		215,
		243,
		221,
		233,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		97,
		76,
		64,
		14,
		90,
		83,
		71,
		96,
		96,
		103,
		-1,
		200,
		183,
		179,
		168,
		166,
		179,
		174,
		190,
		194,
		193,
		212,
		224,
		215,
		235,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		79,
		95,
		103,
		129,
		115,
		120,
		95,
		101,
		106,
		190,
		199,
		167,
		175,
		167,
		156,
		170,
		178,
		182,
		191,
		200,
		206,
		230,
		230,
		236,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		104,
		104,
		143,
		120,
		186,
		-1,
		139,
		-1,
		112,
		146,
		152,
		158,
		170,
		156,
		161,
		172,
		184,
		197,
		193,
		200,
		235,
		235,
		220,
		240,
		243,
		-1,
		-1,
		-1,
		127,
		152,
		127,
		104,
		85,
		118,
		-1,
		156,
		157,
		-1,
		133,
		127,
		143,
		149,
		156,
		153,
		153,
		167,
		175,
		171,
		187,
		193,
		185,
		221,
		-1,
		228,
		222,
		230,
		220,
		208,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		92,
		144,
		-1,
		-1,
		141,
		134,
		-1,
		130,
		137,
		144,
		153,
		158,
		163,
		171,
		166,
		179,
		184,
		190,
		195,
		213,
		217,
		221,
		210,
		206,
		203,
		217,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		112,
		-1,
		149,
		141,
		132,
		126,
		132,
		150,
		148,
		168,
		160,
		174,
		174,
		180,
		188,
		173,
		176,
		192,
		190,
		208,
		216,
		208,
		202,
		201,
		213,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		127,
		-1,
		98,
		122,
		138,
		-1,
		166,
		145,
		168,
		146,
		160,
		156,
		194,
		195,
		173,
		178,
		186,
		196,
		198,
		187,
		198,
		190,
		212,
		212,
		196,
		197,
		206,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		101,
		114,
		125,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		170,
		168,
		184,
		175,
		181,
		197,
		200,
		202,
		192,
		181,
		187,
		184,
		206,
		192,
		190,
		209,
		225,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		192,
		176,
		181,
		-1,
		227,
		-1,
		200,
		202,
		196,
		181,
		178,
		189,
		187,
		198,
		215,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		158,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		208,
		188,
		182,
		181,
		222,
		222,
		208,
		194,
		187,
		184,
		181,
		194,
		214,
		205,
		217,
		-1,
		-1,
		-1,
		159,
		139,
		145,
		103,
		124,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		162,
		225,
		213,
		203,
		193,
		227,
		228,
		213,
		206,
		192,
		194,
		192,
		190,
		195,
		216,
		217,
		230,
		-1,
		-1,
		136,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		184,
		200,
		192,
		163,
		214,
		-1,
		-1,
		205,
		203,
		213,
		209,
		196,
		216,
		219,
		205,
		189,
		204,
		216,
		224,
		229,
		-1,
		139,
		126,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		217,
		183,
		195,
		216,
		241,
		208,
		-1,
		213,
		214,
		200,
		214,
		221,
		207,
		202,
		196,
		199,
		217,
		234,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		174,
		188,
		209,
		215,
		227,
		-1,
		222,
		216,
		202,
		219,
		220,
		217,
		208,
		200,
		205,
		202,
		215,
		229,
		233,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		192,
		207,
		269,
		246,
		219,
		223,
		216,
		210,
		210,
		226,
		228,
		239,
		207,
		203,
		204,
		208,
		207,
		224,
		234,
		-1,
		-1,
		159,
		176,
		211,
		200,
		204,
		296,
		-1,
		-1,
		232,
		223,
		214,
		217,
		220,
		223,
		213,
		210,
		215,
		220,
		208,
		217,
		235,
		239,
		-1,
		-1,
		-1,
		179,
		-1,
		194,
		-1,
		-1,
		219,
		303,
		250,
		232,
		228,
		226,
		219,
		228,
		223,
		218,
		228,
		237,
		229,
		210,
		221,
		244,
		233,
		271,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		208,
		183,
		198,
		244,
		239,
		240,
		265,
		262,
		-1,
		232,
		257,
		229,
		236,
		228,
		236,
		236,
		233,
		211,
		218,
		234,
		233,
		228,
		263,
		255,
		261,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		214,
		200,
		230,
		220,
		226,
		-1,
		-1,
		273,
		270,
		254,
		238,
		242,
		235,
		230,
		240,
		220,
		207,
		211,
		215,
		221,
		226,
		231,
		237,
		252,
		267,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		217,
		226,
		207,
		212,
		220,
		-1,
		-1,
		246,
		242,
		247,
		245,
		242,
		250,
		245,
		236,
		221,
		227,
		214,
		213,
		231,
		235,
		244,
		251,
		241,
		254,
		258,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		230,
		-1,
		-1,
		215,
		233,
		241,
		237,
		241,
		294,
		259,
		254,
		244,
		242,
		233,
		224,
		231,
		222,
		222,
		225,
		240,
		245,
		237,
		251,
		251,
		252,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		231,
		-1,
		267,
		-1,
		260,
		264,
		267,
		270,
		258,
		245,
		237,
		229,
		245,
		220,
		230,
		226,
		227,
		236,
		247,
		259,
		258,
		259,
		307,
		262,
		229,
		220,
		267,
		282,
		286,
		-1,
		243,
		282,
		269,
		-1,
		240,
		-1,
		-1,
		-1,
		274,
		280,
		272,
		278,
		257,
		257,
		231,
		235,
		225,
		232,
		242,
		244,
		236,
		240,
		253,
		264,
		267,
		303,
		301,
		306,
		251,
		234,
		252,
		261,
		282,
		258,
		249,
		276,
		276,
		265,
		260,
		247,
		-1,
		-1,
		297,
		290,
		-1,
		-1,
		264,
		252,
		235,
		236,
		232,
		235,
		250,
		253,
		243,
		241,
		235,
		267,
		-1,
		303,
		302,
		291,
		288,
		264,
		255,
		242,
		253,
		-1,
		-1,
		261,
		277,
		290,
		294,
		307,
		332,
		-1,
		250,
		-1,
		-1,
		309,
		-1,
		-1,
		294,
		257,
		246,
		237,
		243,
		240,
		251,
		261,
		249,
		250,
		240,
		250,
		263,
		287,
		284,
		272,
		270,
		293,
		250,
		246,
		-1,
		276,
		264,
		270,
		277,
		294,
		321,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		292,
		290,
		279,
		-1,
		269,
		242,
		247,
		267,
		269,
		258,
		252,
		246,
		253,
		252,
		260,
		268,
		296,
		310,
		299,
		295,
		294,
		302,
		251,
		268,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		-1,
		301,
		276,
		-1,
		-1,
		287,
		280,
		268,
		256,
		246,
		256,
		260,
		264,
		256,
		249,
		244,
		255,
		247,
		251,
		268,
		-1,
		330,
		-1,
		282,
		275,
		290,
		305,
		313,
		-1,
		-1,
		-1,
		318,
		304,
		297,
		285,
		283,
		-1,
		321,
		305,
		286,
		-1,
		256,
		269,
		300,
		268,
		273,
		268,
		250,
		261,
		250,
		253,
		267,
		262,
		-1,
		-1,
		288,
		291,
		-1,
		-1,
		313,
		332,
		-1,
		309,
		298,
		283,
		275,
		-1,
		-1,
		293,
		289,
		-1,
		-1,
		257,
		282,
		271,
		279,
		274,
		254,
		260,
		263,
		252,
		256,
		268,
		-1,
		-1,
		295,
		296,
		301,
		-1,
		322,
		-1,
		333,
		-1,
		278,
		294,
		296,
		-1,
		-1,
		-1,
		295,
		258,
		279,
		289,
		283,
		281,
		272,
		258,
		265,
		263,
		259,
		270,
		-1,
		-1,
		-1,
		340,
		314,
		340,
		331,
		314,
		294,
		286,
		311,
		-1,
		282,
		-1,
		257,
		259,
		285,
		288,
		294,
		288,
		261,
		276,
		266,
		257,
		266,
		346,
		-1,
		316,
		349,
		313,
		300,
		283,
		287,
		303,
		-1,
		279,
		261,
		-1,
		289,
		279,
		310,
		295,
		276,
		263,
		270,
		270,
		263,
		-1,
		-1,
		-1,
		318,
		317,
		309,
		303,
		303,
		288,
		279,
		-1,
		291,
		273,
		252,
		269,
		269,
		260,
		268,
		300,
		296,
		283,
		283,
		275,
		-1,
		402,
		-1,
		-1,
		341,
		-1,
		-1,
		-1,
		312,
		307,
		280,
		268,
		274,
		270,
		256,
		262,
		264,
		272,
		270,
		267,
		279,
		275,
		295,
		276,
		311,
		-1,
		409,
		-1,
		348,
		-1,
		-1,
		330,
		310,
		302,
		291,
		280,
		278,
		269,
		260,
		282,
		298,
		282,
		280,
		283,
		284,
		-1,
		403,
		402,
		-1,
		349,
		341,
		327,
		-1,
		320,
		-1,
		326,
		287,
		-1,
		289,
		269,
		-1,
		291,
		287,
		-1,
		-1,
		390,
		365,
		-1,
		-1,
		-1,
		350,
		330,
		321,
		305,
		-1,
		280,
		280,
		-1,
		-1,
		-1,
		375,
		374,
		-1,
		343,
		346,
		-1,
		336,
		327,
		335,
		282,
		286,
		-1,
		-1,
		-1,
		384,
		365,
		359,
		358,
		356,
		351,
		348,
		334,
		318,
		296,
		285,
		306,
		-1,
		-1,
		-1,
		356,
		348,
		341,
		-1,
		-1,
		343,
		326,
		307,
		305,
		-1,
		-1,
		-1,
		378,
		359,
		-1,
		-1,
		333,
		-1,
		-1,
		339,
		304,
		-1,
		-1,
		-1,
		-1,
		-1,
		395,
		367,
		-1,
		-1,
		-1,
		329,
		325,
		326,
		-1,
		-1,
		-1,
		-1,
		389,
		390,
		413,
		377,
		-1,
		-1,
		-1,
		321,
		315,
		-1,
		-1,
		392,
		390,
		-1,
		-1,
		-1,
		349,
		333,
		-1,
		319,
		-1,
		-1,
		-1,
		340,
		-1,
		-1,
		352,
		-1,
		-1,
		-1,
		354,
		-1,
		354,
		329,
		336,
		-1,
		-1,
		-1,
		-1,
		367,
		359,
		367,
		-1,
		339,
		341,
		-1,
		389,
		-1,
		-1,
		382,
		373,
		-1,
		-1,
		344,
		351,
		373,
		376,
		412,
		-1,
		363
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		182,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		175,
		167,
		207,
		163,
		134,
		128,
		146,
		151,
		169,
		161,
		-1,
		134,
		124,
		146,
		150,
		162,
		145,
		-1,
		-1,
		128,
		129,
		135,
		147,
		152,
		157,
		-1,
		183,
		188,
		-1,
		-1,
		118,
		131,
		127,
		130,
		138,
		154,
		175,
		188,
		183,
		-1,
		-1,
		119,
		123,
		136,
		137,
		135,
		162,
		181,
		178,
		192,
		191,
		-1,
		107,
		125,
		134,
		143,
		149,
		138,
		142,
		160,
		177,
		183,
		186,
		-1,
		99,
		101,
		126,
		134,
		139,
		146,
		141,
		147,
		166,
		165,
		184,
		175,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		96,
		104,
		126,
		118,
		114,
		127,
		144,
		144,
		150,
		154,
		157,
		173,
		174,
		184,
		-1,
		-1,
		161,
		134,
		158,
		117,
		104,
		-1,
		92,
		102,
		107,
		111,
		112,
		114,
		141,
		139,
		-1,
		151,
		150,
		181,
		167,
		178,
		143,
		-1,
		-1,
		119,
		111,
		93,
		96,
		84,
		87,
		99,
		98,
		96,
		92,
		88,
		117,
		129,
		127,
		137,
		145,
		155,
		159,
		170,
		185,
		-1,
		-1,
		240,
		-1,
		-1,
		140,
		123,
		-1,
		88,
		95,
		79,
		96,
		87,
		82,
		109,
		85,
		84,
		103,
		91,
		111,
		121,
		144,
		141,
		142,
		167,
		171,
		165,
		186,
		181,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		95,
		92,
		85,
		86,
		74,
		-1,
		44,
		50,
		74,
		77,
		89,
		102,
		97,
		127,
		127,
		142,
		144,
		149,
		151,
		184,
		162,
		184,
		181,
		210,
		215,
		209,
		218,
		-1,
		148,
		144,
		140,
		147,
		96,
		-1,
		-1,
		82,
		-1,
		40,
		61,
		36,
		54,
		57,
		78,
		78,
		109,
		103,
		121,
		130,
		133,
		142,
		151,
		162,
		157,
		156,
		174,
		189,
		202,
		206,
		212,
		-1,
		198,
		-1,
		140,
		124,
		126,
		102,
		130,
		-1,
		94,
		39,
		53,
		38,
		29,
		-1,
		82,
		79,
		93,
		100,
		105,
		122,
		137,
		136,
		141,
		146,
		160,
		151,
		169,
		176,
		184,
		188,
		208,
		220,
		158,
		148,
		-1,
		130,
		135,
		105,
		117,
		153,
		43,
		7,
		-1,
		30,
		-1,
		84,
		97,
		-1,
		99,
		103,
		111,
		127,
		124,
		139,
		145,
		142,
		139,
		157,
		160,
		177,
		181,
		197,
		-1,
		-1,
		143,
		147,
		168,
		111,
		109,
		85,
		53,
		0,
		9,
		11,
		-1,
		77,
		130,
		127,
		128,
		130,
		121,
		122,
		130,
		143,
		122,
		141,
		144,
		166,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		145,
		116,
		117,
		67,
		39,
		32,
		20,
		45,
		45,
		52,
		-1,
		150,
		133,
		130,
		119,
		117,
		130,
		125,
		141,
		145,
		144,
		163,
		175,
		166,
		186,
		-1,
		-1,
		-1,
		175,
		164,
		165,
		115,
		138,
		156,
		78,
		64,
		69,
		44,
		50,
		55,
		139,
		148,
		117,
		126,
		118,
		107,
		121,
		129,
		133,
		142,
		151,
		157,
		181,
		181,
		187,
		-1,
		-1,
		182,
		172,
		156,
		158,
		155,
		129,
		136,
		168,
		69,
		153,
		-1,
		88,
		-1,
		61,
		95,
		103,
		109,
		121,
		107,
		112,
		123,
		135,
		148,
		144,
		151,
		186,
		186,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		175,
		174,
		149,
		126,
		110,
		146,
		-1,
		123,
		124,
		-1,
		82,
		76,
		92,
		100,
		107,
		104,
		104,
		118,
		126,
		122,
		138,
		144,
		136,
		172,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		172,
		151,
		144,
		164,
		105,
		157,
		-1,
		-1,
		108,
		101,
		-1,
		79,
		88,
		95,
		104,
		109,
		114,
		122,
		117,
		130,
		135,
		141,
		146,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		125,
		-1,
		117,
		109,
		99,
		93,
		87,
		101,
		99,
		119,
		111,
		125,
		125,
		131,
		139,
		124,
		127,
		143,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		138,
		-1,
		102,
		116,
		132,
		-1,
		125,
		104,
		119,
		97,
		111,
		107,
		145,
		146,
		124,
		129,
		137,
		147,
		149,
		138,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		99,
		87,
		119,
		-1,
		-1,
		161,
		-1,
		95,
		112,
		121,
		119,
		135,
		126,
		132,
		148,
		151,
		153,
		143,
		132,
		138,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		136,
		-1,
		139,
		129,
		113,
		98,
		131,
		-1,
		143,
		127,
		132,
		-1,
		178,
		-1,
		151,
		153,
		147,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		148,
		133,
		126,
		116,
		130,
		101,
		-1,
		156,
		-1,
		-1,
		126,
		120,
		120,
		104,
		107,
		159,
		139,
		133,
		132,
		173,
		173,
		159,
		145,
		138,
		135,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		153,
		139,
		143,
		103,
		122,
		-1,
		-1,
		188,
		143,
		129,
		-1,
		113,
		176,
		164,
		154,
		144,
		178,
		179,
		164,
		157,
		143,
		145,
		143,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		136,
		141,
		129,
		115,
		134,
		-1,
		-1,
		-1,
		135,
		151,
		143,
		114,
		165,
		-1,
		-1,
		156,
		154,
		164,
		160,
		147,
		167,
		170,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		139,
		126,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		146,
		167,
		192,
		159,
		-1,
		164,
		165,
		151,
		165,
		172,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		151,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		125,
		139,
		160,
		166,
		178,
		-1,
		173,
		167,
		153,
		170,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		174,
		-1,
		157,
		-1,
		-1,
		-1,
		143,
		158,
		220,
		197,
		170,
		174,
		167,
		161,
		161,
		177,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		157,
		174,
		169,
		151,
		155,
		247,
		-1,
		-1,
		183,
		174,
		165,
		168,
		171,
		174,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		190,
		-1,
		-1,
		-1,
		177,
		-1,
		192,
		-1,
		-1,
		170,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		188,
		180,
		161,
		172,
		195,
		184,
		222,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		206,
		181,
		196,
		242,
		190,
		197,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		179,
		187,
		187,
		184,
		162,
		169,
		185,
		184,
		179,
		214,
		206,
		212,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		212,
		198,
		228,
		218,
		207,
		-1,
		-1,
		232,
		229,
		205,
		189,
		193,
		186,
		181,
		191,
		171,
		158,
		162,
		166,
		172,
		177,
		182,
		188,
		203,
		218,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		215,
		224,
		205,
		210,
		218,
		-1,
		-1,
		205,
		202,
		207,
		196,
		193,
		201,
		196,
		187,
		172,
		178,
		165,
		164,
		182,
		186,
		195,
		202,
		192,
		205,
		209,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		228,
		-1,
		-1,
		213,
		231,
		220,
		210,
		204,
		254,
		210,
		205,
		195,
		193,
		184,
		175,
		182,
		173,
		173,
		176,
		191,
		196,
		188,
		202,
		202,
		203,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		229,
		-1,
		247,
		-1,
		222,
		226,
		218,
		221,
		209,
		196,
		188,
		180,
		196,
		171,
		181,
		177,
		178,
		187,
		198,
		210,
		209,
		210,
		307,
		262,
		229,
		220,
		267,
		282,
		286,
		-1,
		241,
		280,
		267,
		-1,
		238,
		-1,
		-1,
		-1,
		236,
		231,
		223,
		229,
		208,
		208,
		182,
		186,
		176,
		183,
		193,
		195,
		187,
		191,
		204,
		215,
		218,
		303,
		301,
		306,
		251,
		234,
		252,
		261,
		282,
		256,
		247,
		274,
		274,
		263,
		258,
		245,
		-1,
		-1,
		259,
		241,
		-1,
		-1,
		215,
		203,
		186,
		187,
		183,
		186,
		201,
		204,
		194,
		192,
		186,
		218,
		-1,
		303,
		302,
		291,
		288,
		264,
		255,
		242,
		253,
		-1,
		-1,
		259,
		275,
		288,
		292,
		305,
		330,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		245,
		208,
		197,
		188,
		194,
		191,
		202,
		212,
		200,
		201,
		191,
		201,
		214,
		287,
		284,
		272,
		270,
		293,
		250,
		246,
		-1,
		269,
		262,
		268,
		275,
		292,
		319,
		-1,
		-1,
		264,
		255,
		-1,
		-1,
		243,
		241,
		230,
		-1,
		220,
		193,
		198,
		218,
		220,
		209,
		203,
		197,
		204,
		203,
		211,
		219,
		296,
		310,
		299,
		295,
		294,
		302,
		251,
		254,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		-1,
		281,
		274,
		-1,
		-1,
		238,
		231,
		219,
		207,
		197,
		207,
		211,
		215,
		207,
		200,
		195,
		206,
		198,
		202,
		219,
		-1,
		330,
		-1,
		282,
		268,
		282,
		297,
		305,
		-1,
		-1,
		-1,
		298,
		284,
		277,
		265,
		263,
		-1,
		272,
		256,
		237,
		-1,
		207,
		220,
		251,
		219,
		224,
		219,
		201,
		212,
		201,
		204,
		218,
		213,
		-1,
		-1,
		280,
		283,
		-1,
		-1,
		288,
		290,
		-1,
		289,
		278,
		263,
		255,
		-1,
		-1,
		244,
		240,
		-1,
		-1,
		208,
		233,
		222,
		230,
		225,
		205,
		211,
		214,
		203,
		207,
		219,
		-1,
		-1,
		287,
		288,
		293,
		-1,
		273,
		-1,
		291,
		-1,
		258,
		264,
		252,
		-1,
		-1,
		-1,
		246,
		209,
		230,
		240,
		234,
		232,
		223,
		209,
		216,
		214,
		210,
		221,
		-1,
		-1,
		-1,
		291,
		265,
		298,
		289,
		272,
		252,
		244,
		263,
		-1,
		233,
		-1,
		208,
		210,
		236,
		239,
		245,
		239,
		212,
		227,
		217,
		208,
		217,
		297,
		-1,
		267,
		300,
		264,
		258,
		234,
		238,
		254,
		-1,
		230,
		212,
		-1,
		240,
		230,
		261,
		246,
		227,
		214,
		221,
		221,
		214,
		-1,
		-1,
		-1,
		269,
		268,
		260,
		254,
		254,
		239,
		230,
		-1,
		242,
		224,
		203,
		220,
		220,
		211,
		219,
		251,
		247,
		234,
		234,
		226,
		-1,
		370,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		263,
		258,
		231,
		219,
		225,
		221,
		207,
		213,
		215,
		223,
		221,
		218,
		230,
		226,
		246,
		227,
		262,
		-1,
		365,
		-1,
		299,
		-1,
		-1,
		281,
		261,
		253,
		242,
		231,
		229,
		220,
		211,
		233,
		249,
		233,
		231,
		234,
		235,
		-1,
		354,
		353,
		-1,
		300,
		292,
		278,
		-1,
		271,
		-1,
		277,
		238,
		-1,
		240,
		220,
		-1,
		242,
		238,
		-1,
		-1,
		341,
		316,
		-1,
		-1,
		-1,
		301,
		281,
		272,
		256,
		-1,
		231,
		231,
		-1,
		-1,
		-1,
		326,
		325,
		-1,
		294,
		297,
		-1,
		287,
		278,
		286,
		233,
		237,
		-1,
		-1,
		-1,
		335,
		316,
		310,
		309,
		307,
		302,
		299,
		285,
		269,
		247,
		236,
		257,
		-1,
		-1,
		-1,
		307,
		299,
		292,
		-1,
		-1,
		294,
		277,
		258,
		256,
		-1,
		-1,
		-1,
		329,
		310,
		-1,
		-1,
		284,
		-1,
		-1,
		290,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		346,
		318,
		-1,
		-1,
		-1,
		280,
		276,
		277,
		-1,
		-1,
		-1,
		-1,
		340,
		341,
		364,
		328,
		-1,
		-1,
		-1,
		272,
		266,
		-1,
		-1,
		343,
		341,
		-1,
		-1,
		-1,
		300,
		284,
		-1,
		270,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		305,
		-1,
		305,
		280,
		287,
		-1,
		-1,
		-1,
		-1,
		318,
		310,
		318,
		-1,
		290,
		292,
		-1,
		340,
		-1,
		-1,
		333,
		324,
		-1,
		-1,
		295,
		302,
		324,
		327,
		363,
		-1,
		314
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		173,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		166,
		158,
		198,
		154,
		125,
		119,
		137,
		142,
		160,
		152,
		-1,
		125,
		115,
		137,
		141,
		153,
		136,
		-1,
		-1,
		119,
		120,
		126,
		138,
		143,
		148,
		-1,
		174,
		179,
		-1,
		-1,
		109,
		122,
		118,
		121,
		129,
		145,
		166,
		179,
		174,
		-1,
		-1,
		110,
		114,
		127,
		128,
		126,
		153,
		172,
		169,
		183,
		182,
		-1,
		98,
		116,
		125,
		134,
		140,
		129,
		133,
		151,
		168,
		174,
		177,
		-1,
		90,
		92,
		117,
		125,
		130,
		137,
		132,
		138,
		157,
		156,
		175,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		87,
		95,
		117,
		109,
		105,
		118,
		135,
		135,
		141,
		145,
		148,
		164,
		165,
		175,
		-1,
		-1,
		170,
		143,
		167,
		125,
		113,
		-1,
		83,
		93,
		98,
		102,
		103,
		105,
		132,
		130,
		-1,
		142,
		141,
		172,
		158,
		169,
		152,
		-1,
		-1,
		128,
		120,
		102,
		105,
		82,
		78,
		90,
		89,
		87,
		83,
		79,
		108,
		120,
		118,
		128,
		136,
		146,
		150,
		161,
		176,
		-1,
		-1,
		231,
		-1,
		-1,
		149,
		132,
		-1,
		97,
		104,
		88,
		94,
		80,
		73,
		100,
		76,
		75,
		94,
		82,
		102,
		112,
		135,
		132,
		133,
		158,
		162,
		156,
		177,
		172,
		-1,
		230,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		104,
		101,
		94,
		97,
		85,
		-1,
		35,
		41,
		65,
		68,
		80,
		93,
		88,
		118,
		118,
		133,
		135,
		140,
		142,
		175,
		153,
		175,
		172,
		201,
		206,
		200,
		209,
		-1,
		157,
		153,
		149,
		156,
		105,
		-1,
		-1,
		93,
		-1,
		51,
		52,
		27,
		45,
		48,
		69,
		69,
		100,
		94,
		112,
		121,
		124,
		133,
		142,
		153,
		148,
		147,
		165,
		180,
		193,
		197,
		203,
		-1,
		207,
		-1,
		149,
		133,
		135,
		111,
		139,
		-1,
		105,
		50,
		44,
		29,
		20,
		-1,
		73,
		70,
		84,
		91,
		96,
		113,
		128,
		127,
		132,
		137,
		151,
		142,
		160,
		167,
		175,
		179,
		199,
		211,
		167,
		157,
		-1,
		139,
		144,
		114,
		126,
		148,
		54,
		18,
		-1,
		21,
		-1,
		75,
		88,
		-1,
		90,
		94,
		102,
		118,
		115,
		130,
		136,
		133,
		130,
		148,
		151,
		168,
		172,
		188,
		-1,
		-1,
		152,
		156,
		163,
		114,
		120,
		96,
		64,
		11,
		0,
		2,
		-1,
		68,
		121,
		118,
		119,
		121,
		112,
		113,
		121,
		134,
		113,
		132,
		135,
		157,
		185,
		163,
		175,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		140,
		111,
		128,
		78,
		30,
		23,
		11,
		36,
		36,
		43,
		-1,
		141,
		124,
		121,
		110,
		108,
		121,
		116,
		132,
		136,
		135,
		154,
		166,
		157,
		177,
		-1,
		-1,
		-1,
		170,
		159,
		160,
		106,
		129,
		166,
		69,
		55,
		60,
		35,
		41,
		46,
		130,
		139,
		108,
		117,
		109,
		98,
		112,
		120,
		124,
		133,
		142,
		148,
		172,
		172,
		178,
		-1,
		-1,
		177,
		167,
		151,
		153,
		150,
		120,
		127,
		159,
		60,
		144,
		-1,
		79,
		-1,
		52,
		86,
		94,
		100,
		112,
		98,
		103,
		114,
		126,
		139,
		135,
		142,
		177,
		177,
		162,
		182,
		185,
		-1,
		-1,
		-1,
		170,
		165,
		140,
		117,
		101,
		137,
		-1,
		114,
		115,
		-1,
		73,
		67,
		83,
		91,
		98,
		95,
		95,
		109,
		117,
		113,
		129,
		135,
		127,
		163,
		-1,
		170,
		164,
		172,
		162,
		150,
		-1,
		-1,
		-1,
		163,
		142,
		135,
		155,
		96,
		148,
		-1,
		-1,
		99,
		92,
		-1,
		70,
		79,
		86,
		95,
		100,
		105,
		113,
		108,
		121,
		126,
		132,
		137,
		155,
		159,
		163,
		152,
		148,
		145,
		159,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		116,
		-1,
		108,
		100,
		90,
		84,
		78,
		92,
		90,
		110,
		102,
		116,
		116,
		122,
		130,
		115,
		118,
		134,
		132,
		150,
		158,
		150,
		144,
		143,
		155,
		-1,
		183,
		169,
		140,
		-1,
		-1,
		129,
		-1,
		93,
		107,
		123,
		-1,
		116,
		95,
		110,
		88,
		102,
		98,
		136,
		137,
		115,
		120,
		128,
		138,
		140,
		129,
		140,
		132,
		154,
		154,
		138,
		139,
		148,
		-1,
		189,
		176,
		134,
		130,
		119,
		139,
		90,
		78,
		110,
		-1,
		-1,
		152,
		-1,
		86,
		103,
		112,
		110,
		126,
		117,
		123,
		139,
		142,
		144,
		134,
		123,
		129,
		126,
		148,
		134,
		132,
		151,
		167,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		105,
		92,
		86,
		-1,
		127,
		-1,
		130,
		120,
		104,
		89,
		122,
		-1,
		134,
		118,
		123,
		-1,
		169,
		-1,
		142,
		144,
		138,
		123,
		120,
		131,
		129,
		140,
		157,
		-1,
		139,
		124,
		117,
		107,
		121,
		92,
		-1,
		147,
		-1,
		-1,
		117,
		111,
		111,
		95,
		98,
		150,
		130,
		124,
		123,
		164,
		164,
		150,
		136,
		129,
		126,
		123,
		136,
		156,
		147,
		159,
		-1,
		-1,
		-1,
		144,
		130,
		134,
		94,
		113,
		-1,
		-1,
		179,
		134,
		120,
		-1,
		104,
		167,
		155,
		145,
		135,
		169,
		170,
		155,
		148,
		134,
		136,
		134,
		132,
		137,
		158,
		159,
		172,
		-1,
		-1,
		127,
		132,
		120,
		106,
		125,
		-1,
		-1,
		-1,
		126,
		142,
		134,
		105,
		156,
		-1,
		-1,
		147,
		145,
		155,
		151,
		138,
		158,
		161,
		147,
		131,
		146,
		158,
		166,
		171,
		-1,
		130,
		117,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		137,
		158,
		183,
		150,
		-1,
		155,
		156,
		142,
		156,
		163,
		149,
		144,
		138,
		141,
		159,
		176,
		-1,
		-1,
		142,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		116,
		130,
		151,
		157,
		169,
		-1,
		164,
		158,
		144,
		161,
		162,
		159,
		150,
		142,
		147,
		144,
		157,
		171,
		175,
		165,
		-1,
		148,
		-1,
		-1,
		-1,
		134,
		149,
		211,
		188,
		161,
		165,
		158,
		152,
		152,
		168,
		170,
		181,
		149,
		145,
		146,
		150,
		149,
		166,
		176,
		-1,
		-1,
		148,
		165,
		160,
		142,
		146,
		238,
		-1,
		-1,
		174,
		165,
		156,
		159,
		162,
		165,
		155,
		152,
		157,
		162,
		150,
		159,
		177,
		181,
		-1,
		-1,
		-1,
		168,
		-1,
		183,
		-1,
		-1,
		161,
		245,
		192,
		174,
		170,
		168,
		161,
		170,
		165,
		160,
		170,
		179,
		171,
		152,
		163,
		186,
		175,
		213,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		197,
		172,
		187,
		233,
		181,
		188,
		207,
		204,
		-1,
		174,
		199,
		171,
		178,
		170,
		178,
		178,
		175,
		153,
		160,
		176,
		175,
		170,
		205,
		197,
		203,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		203,
		189,
		219,
		209,
		198,
		-1,
		-1,
		223,
		220,
		196,
		180,
		184,
		177,
		172,
		182,
		162,
		149,
		153,
		157,
		163,
		168,
		173,
		179,
		194,
		209,
		-1,
		175,
		256,
		249,
		232,
		240,
		271,
		-1,
		206,
		215,
		196,
		201,
		209,
		-1,
		-1,
		196,
		193,
		198,
		187,
		184,
		192,
		187,
		178,
		163,
		169,
		156,
		155,
		173,
		177,
		186,
		193,
		183,
		196,
		200,
		-1,
		189,
		232,
		226,
		229,
		253,
		267,
		-1,
		219,
		-1,
		-1,
		204,
		222,
		211,
		201,
		195,
		245,
		201,
		196,
		186,
		184,
		175,
		166,
		173,
		164,
		164,
		167,
		182,
		187,
		179,
		193,
		193,
		194,
		-1,
		224,
		212,
		220,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		220,
		-1,
		238,
		-1,
		213,
		217,
		209,
		212,
		200,
		187,
		179,
		171,
		187,
		162,
		172,
		168,
		169,
		178,
		189,
		201,
		200,
		201,
		298,
		253,
		220,
		211,
		258,
		273,
		277,
		-1,
		232,
		271,
		258,
		-1,
		229,
		-1,
		-1,
		-1,
		227,
		222,
		214,
		220,
		199,
		199,
		173,
		177,
		167,
		174,
		184,
		186,
		178,
		182,
		195,
		206,
		209,
		294,
		292,
		297,
		242,
		225,
		243,
		252,
		273,
		247,
		238,
		265,
		265,
		254,
		249,
		236,
		-1,
		-1,
		250,
		232,
		-1,
		-1,
		206,
		194,
		177,
		178,
		174,
		177,
		192,
		195,
		185,
		183,
		177,
		209,
		-1,
		294,
		293,
		282,
		279,
		255,
		246,
		233,
		244,
		-1,
		-1,
		250,
		266,
		279,
		283,
		296,
		321,
		-1,
		239,
		-1,
		-1,
		251,
		-1,
		-1,
		236,
		199,
		188,
		179,
		185,
		182,
		193,
		203,
		191,
		192,
		182,
		192,
		205,
		278,
		275,
		263,
		261,
		284,
		241,
		237,
		-1,
		260,
		253,
		259,
		266,
		283,
		310,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		234,
		232,
		221,
		-1,
		211,
		184,
		189,
		209,
		211,
		200,
		194,
		188,
		195,
		194,
		202,
		210,
		287,
		301,
		290,
		286,
		285,
		293,
		242,
		245,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		-1,
		272,
		265,
		-1,
		-1,
		229,
		222,
		210,
		198,
		188,
		198,
		202,
		206,
		198,
		191,
		186,
		197,
		189,
		193,
		210,
		-1,
		321,
		-1,
		273,
		259,
		273,
		288,
		296,
		-1,
		-1,
		-1,
		289,
		275,
		268,
		256,
		254,
		-1,
		263,
		247,
		228,
		-1,
		198,
		211,
		242,
		210,
		215,
		210,
		192,
		203,
		192,
		195,
		209,
		204,
		-1,
		-1,
		271,
		274,
		-1,
		-1,
		279,
		281,
		-1,
		280,
		269,
		254,
		246,
		-1,
		-1,
		235,
		231,
		-1,
		-1,
		199,
		224,
		213,
		221,
		216,
		196,
		202,
		205,
		194,
		198,
		210,
		-1,
		-1,
		278,
		279,
		284,
		-1,
		264,
		-1,
		282,
		-1,
		249,
		255,
		243,
		-1,
		-1,
		-1,
		237,
		200,
		221,
		231,
		225,
		223,
		214,
		200,
		207,
		205,
		201,
		212,
		-1,
		-1,
		-1,
		282,
		256,
		289,
		280,
		263,
		243,
		235,
		254,
		-1,
		224,
		-1,
		199,
		201,
		227,
		230,
		236,
		230,
		203,
		218,
		208,
		199,
		208,
		288,
		-1,
		258,
		291,
		255,
		249,
		225,
		229,
		245,
		-1,
		221,
		203,
		-1,
		231,
		221,
		252,
		237,
		218,
		205,
		212,
		212,
		205,
		-1,
		-1,
		-1,
		260,
		259,
		251,
		245,
		245,
		230,
		221,
		-1,
		233,
		215,
		194,
		211,
		211,
		202,
		210,
		242,
		238,
		225,
		225,
		217,
		-1,
		361,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		254,
		249,
		222,
		210,
		216,
		212,
		198,
		204,
		206,
		214,
		212,
		209,
		221,
		217,
		237,
		218,
		253,
		-1,
		356,
		-1,
		290,
		-1,
		-1,
		272,
		252,
		244,
		233,
		222,
		220,
		211,
		202,
		224,
		240,
		224,
		222,
		225,
		226,
		-1,
		345,
		344,
		-1,
		291,
		283,
		269,
		-1,
		262,
		-1,
		268,
		229,
		-1,
		231,
		211,
		-1,
		233,
		229,
		-1,
		-1,
		332,
		307,
		-1,
		-1,
		-1,
		292,
		272,
		263,
		247,
		-1,
		222,
		222,
		-1,
		-1,
		-1,
		317,
		316,
		-1,
		285,
		288,
		-1,
		278,
		269,
		277,
		224,
		228,
		-1,
		-1,
		-1,
		326,
		307,
		301,
		300,
		298,
		293,
		290,
		276,
		260,
		238,
		227,
		248,
		-1,
		-1,
		-1,
		298,
		290,
		283,
		-1,
		-1,
		285,
		268,
		249,
		247,
		-1,
		-1,
		-1,
		320,
		301,
		-1,
		-1,
		275,
		-1,
		-1,
		281,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		337,
		309,
		-1,
		-1,
		-1,
		271,
		267,
		268,
		-1,
		-1,
		-1,
		-1,
		331,
		332,
		355,
		319,
		-1,
		-1,
		-1,
		263,
		257,
		-1,
		-1,
		334,
		332,
		-1,
		-1,
		-1,
		291,
		275,
		-1,
		261,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		296,
		-1,
		296,
		271,
		278,
		-1,
		-1,
		-1,
		-1,
		309,
		301,
		309,
		-1,
		281,
		283,
		-1,
		331,
		-1,
		-1,
		324,
		315,
		-1,
		-1,
		286,
		293,
		315,
		318,
		354,
		-1,
		305
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		169,
		171,
		137,
		131,
		170,
		141,
		147,
		158,
		-1,
		-1,
		-1,
		160,
		159,
		129,
		127,
		136,
		141,
		148,
		-1,
		171,
		-1,
		181,
		160,
		171,
		176,
		122,
		119,
		139,
		158,
		164,
		156,
		196,
		152,
		123,
		117,
		135,
		140,
		158,
		150,
		-1,
		123,
		113,
		135,
		139,
		151,
		134,
		-1,
		-1,
		117,
		118,
		124,
		136,
		141,
		146,
		-1,
		172,
		177,
		-1,
		-1,
		107,
		120,
		116,
		119,
		127,
		143,
		164,
		177,
		172,
		-1,
		-1,
		108,
		112,
		125,
		126,
		124,
		151,
		170,
		167,
		181,
		180,
		-1,
		96,
		114,
		123,
		132,
		138,
		127,
		131,
		149,
		166,
		172,
		175,
		-1,
		88,
		90,
		115,
		123,
		128,
		135,
		130,
		136,
		155,
		154,
		173,
		164,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		85,
		93,
		115,
		107,
		103,
		116,
		133,
		133,
		139,
		143,
		146,
		162,
		163,
		173,
		-1,
		-1,
		168,
		141,
		165,
		123,
		111,
		-1,
		81,
		91,
		96,
		100,
		101,
		103,
		130,
		128,
		-1,
		140,
		139,
		170,
		156,
		167,
		150,
		-1,
		-1,
		126,
		118,
		100,
		103,
		80,
		76,
		88,
		87,
		85,
		81,
		77,
		106,
		118,
		116,
		126,
		134,
		144,
		148,
		159,
		174,
		-1,
		-1,
		229,
		-1,
		-1,
		147,
		130,
		-1,
		95,
		102,
		86,
		92,
		78,
		71,
		98,
		74,
		73,
		92,
		80,
		100,
		110,
		133,
		130,
		131,
		156,
		160,
		154,
		175,
		170,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		102,
		99,
		92,
		98,
		86,
		-1,
		33,
		39,
		63,
		66,
		78,
		91,
		86,
		116,
		116,
		131,
		133,
		138,
		140,
		173,
		151,
		173,
		170,
		199,
		204,
		198,
		207,
		-1,
		155,
		151,
		147,
		154,
		103,
		-1,
		-1,
		94,
		-1,
		52,
		50,
		25,
		43,
		46,
		67,
		67,
		98,
		92,
		110,
		119,
		122,
		131,
		140,
		151,
		146,
		145,
		163,
		178,
		191,
		195,
		201,
		-1,
		205,
		-1,
		147,
		131,
		133,
		109,
		137,
		-1,
		106,
		51,
		42,
		27,
		18,
		-1,
		71,
		68,
		82,
		89,
		94,
		111,
		126,
		125,
		130,
		135,
		149,
		140,
		158,
		165,
		173,
		177,
		197,
		209,
		165,
		155,
		-1,
		137,
		142,
		112,
		124,
		146,
		55,
		19,
		-1,
		19,
		-1,
		73,
		86,
		-1,
		88,
		92,
		100,
		116,
		113,
		128,
		134,
		131,
		128,
		146,
		149,
		166,
		170,
		186,
		-1,
		-1,
		150,
		154,
		161,
		112,
		121,
		97,
		65,
		12,
		1,
		0,
		-1,
		66,
		119,
		116,
		117,
		119,
		110,
		111,
		119,
		132,
		111,
		130,
		133,
		155,
		183,
		161,
		173,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		138,
		109,
		129,
		79,
		30,
		23,
		11,
		34,
		34,
		41,
		-1,
		139,
		122,
		119,
		108,
		106,
		119,
		114,
		130,
		134,
		133,
		152,
		164,
		155,
		175,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		67,
		53,
		58,
		33,
		39,
		44,
		128,
		137,
		106,
		115,
		107,
		96,
		110,
		118,
		122,
		131,
		140,
		146,
		170,
		170,
		176,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		58,
		142,
		-1,
		77,
		-1,
		50,
		84,
		92,
		98,
		110,
		96,
		101,
		112,
		124,
		137,
		133,
		140,
		175,
		175,
		160,
		180,
		183,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		71,
		65,
		81,
		89,
		96,
		93,
		93,
		107,
		115,
		111,
		127,
		133,
		125,
		161,
		-1,
		168,
		162,
		170,
		160,
		148,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		68,
		77,
		84,
		93,
		98,
		103,
		111,
		106,
		119,
		124,
		130,
		135,
		153,
		157,
		161,
		150,
		146,
		143,
		157,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		90,
		88,
		108,
		100,
		114,
		114,
		120,
		128,
		113,
		116,
		132,
		130,
		148,
		156,
		148,
		142,
		141,
		153,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		100,
		96,
		134,
		135,
		113,
		118,
		126,
		136,
		138,
		127,
		138,
		130,
		152,
		152,
		136,
		137,
		146,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		110,
		108,
		124,
		115,
		121,
		137,
		140,
		142,
		132,
		121,
		127,
		124,
		146,
		132,
		130,
		149,
		165,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		132,
		116,
		121,
		-1,
		167,
		-1,
		140,
		142,
		136,
		121,
		118,
		129,
		127,
		138,
		155,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		148,
		128,
		122,
		121,
		162,
		162,
		148,
		134,
		127,
		124,
		121,
		134,
		154,
		145,
		157,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		165,
		153,
		143,
		133,
		167,
		168,
		153,
		146,
		132,
		134,
		132,
		130,
		135,
		156,
		157,
		170,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		154,
		-1,
		-1,
		145,
		143,
		153,
		149,
		136,
		156,
		159,
		145,
		129,
		144,
		156,
		164,
		169,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		135,
		156,
		181,
		148,
		-1,
		153,
		154,
		140,
		154,
		161,
		147,
		142,
		136,
		139,
		157,
		174,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		149,
		155,
		167,
		-1,
		162,
		156,
		142,
		159,
		160,
		157,
		148,
		140,
		145,
		142,
		155,
		169,
		173,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		209,
		186,
		159,
		163,
		156,
		150,
		150,
		166,
		168,
		179,
		147,
		143,
		144,
		148,
		147,
		164,
		174,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		236,
		-1,
		-1,
		172,
		163,
		154,
		157,
		160,
		163,
		153,
		150,
		155,
		160,
		148,
		157,
		175,
		179,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		243,
		190,
		172,
		168,
		166,
		159,
		168,
		163,
		158,
		168,
		177,
		169,
		150,
		161,
		184,
		173,
		211,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		195,
		170,
		185,
		231,
		179,
		186,
		205,
		202,
		-1,
		172,
		197,
		169,
		176,
		168,
		176,
		176,
		173,
		151,
		158,
		174,
		173,
		168,
		203,
		195,
		201,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		201,
		187,
		217,
		207,
		196,
		-1,
		-1,
		221,
		218,
		194,
		178,
		182,
		175,
		170,
		180,
		160,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		204,
		213,
		194,
		199,
		207,
		-1,
		-1,
		194,
		191,
		196,
		185,
		182,
		190,
		185,
		176,
		161,
		167,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		217,
		-1,
		-1,
		202,
		220,
		209,
		199,
		193,
		243,
		199,
		194,
		184,
		182,
		173,
		164,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		222,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		218,
		-1,
		236,
		-1,
		211,
		215,
		207,
		210,
		198,
		185,
		177,
		169,
		185,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		296,
		251,
		218,
		209,
		256,
		271,
		275,
		-1,
		230,
		269,
		256,
		-1,
		227,
		-1,
		-1,
		-1,
		225,
		220,
		212,
		218,
		197,
		197,
		171,
		175,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		292,
		290,
		295,
		240,
		223,
		241,
		250,
		271,
		245,
		236,
		263,
		263,
		252,
		247,
		234,
		-1,
		-1,
		248,
		230,
		-1,
		-1,
		204,
		192,
		175,
		176,
		172,
		175,
		190,
		193,
		183,
		181,
		175,
		207,
		-1,
		292,
		291,
		280,
		277,
		253,
		244,
		231,
		242,
		-1,
		-1,
		248,
		264,
		277,
		281,
		294,
		319,
		-1,
		237,
		-1,
		-1,
		249,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		180,
		191,
		201,
		189,
		190,
		180,
		190,
		203,
		276,
		273,
		261,
		259,
		282,
		239,
		235,
		-1,
		258,
		251,
		257,
		264,
		281,
		308,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		232,
		230,
		219,
		-1,
		209,
		182,
		187,
		207,
		209,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		285,
		299,
		288,
		284,
		283,
		291,
		240,
		243,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		-1,
		270,
		263,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		200,
		204,
		196,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		319,
		-1,
		271,
		257,
		271,
		286,
		294,
		-1,
		-1,
		-1,
		287,
		273,
		266,
		254,
		252,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		269,
		272,
		-1,
		-1,
		277,
		279,
		-1,
		278,
		267,
		252,
		244,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		276,
		277,
		282,
		-1,
		262,
		-1,
		280,
		-1,
		247,
		253,
		241,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		223,
		221,
		212,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		280,
		254,
		287,
		278,
		261,
		241,
		233,
		252,
		-1,
		222,
		-1,
		197,
		199,
		225,
		228,
		234,
		228,
		201,
		216,
		206,
		197,
		206,
		286,
		-1,
		256,
		289,
		253,
		247,
		223,
		227,
		243,
		-1,
		219,
		201,
		-1,
		229,
		219,
		250,
		235,
		216,
		203,
		210,
		210,
		203,
		-1,
		-1,
		-1,
		258,
		257,
		249,
		243,
		243,
		228,
		219,
		-1,
		231,
		213,
		192,
		209,
		209,
		200,
		208,
		240,
		236,
		223,
		223,
		215,
		-1,
		359,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		252,
		247,
		220,
		208,
		214,
		210,
		196,
		202,
		204,
		212,
		210,
		207,
		219,
		215,
		235,
		216,
		251,
		-1,
		354,
		-1,
		288,
		-1,
		-1,
		270,
		250,
		242,
		231,
		220,
		218,
		209,
		200,
		222,
		238,
		222,
		220,
		223,
		224,
		-1,
		343,
		342,
		-1,
		289,
		281,
		267,
		-1,
		260,
		-1,
		266,
		227,
		-1,
		229,
		209,
		-1,
		231,
		227,
		-1,
		-1,
		330,
		305,
		-1,
		-1,
		-1,
		290,
		270,
		261,
		245,
		-1,
		220,
		220,
		-1,
		-1,
		-1,
		315,
		314,
		-1,
		283,
		286,
		-1,
		276,
		267,
		275,
		222,
		226,
		-1,
		-1,
		-1,
		324,
		305,
		299,
		298,
		296,
		291,
		288,
		274,
		258,
		236,
		225,
		246,
		-1,
		-1,
		-1,
		296,
		288,
		281,
		-1,
		-1,
		283,
		266,
		247,
		245,
		-1,
		-1,
		-1,
		318,
		299,
		-1,
		-1,
		273,
		-1,
		-1,
		279,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		335,
		307,
		-1,
		-1,
		-1,
		269,
		265,
		266,
		-1,
		-1,
		-1,
		-1,
		329,
		330,
		353,
		317,
		-1,
		-1,
		-1,
		261,
		255,
		-1,
		-1,
		332,
		330,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		259,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		294,
		-1,
		294,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		307,
		-1,
		279,
		281,
		-1,
		329,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		284,
		291,
		313,
		316,
		352,
		-1,
		303
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		156,
		145,
		156,
		164,
		137,
		144,
		-1,
		165,
		167,
		133,
		127,
		166,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		156,
		155,
		125,
		123,
		132,
		137,
		144,
		-1,
		167,
		-1,
		177,
		156,
		167,
		172,
		118,
		115,
		135,
		154,
		160,
		152,
		192,
		148,
		119,
		113,
		131,
		136,
		154,
		146,
		-1,
		119,
		109,
		131,
		135,
		147,
		130,
		-1,
		-1,
		113,
		114,
		120,
		132,
		137,
		142,
		-1,
		168,
		167,
		-1,
		-1,
		103,
		116,
		112,
		115,
		123,
		139,
		160,
		167,
		162,
		-1,
		-1,
		104,
		108,
		121,
		122,
		120,
		147,
		166,
		157,
		171,
		170,
		-1,
		92,
		110,
		119,
		128,
		134,
		123,
		127,
		145,
		156,
		162,
		165,
		-1,
		101,
		102,
		101,
		109,
		114,
		121,
		126,
		132,
		151,
		144,
		163,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		100,
		84,
		101,
		93,
		89,
		102,
		119,
		127,
		135,
		139,
		136,
		152,
		153,
		163,
		-1,
		-1,
		194,
		167,
		191,
		149,
		125,
		-1,
		96,
		77,
		82,
		86,
		87,
		89,
		116,
		114,
		-1,
		130,
		129,
		160,
		146,
		157,
		158,
		-1,
		-1,
		152,
		144,
		126,
		129,
		106,
		102,
		74,
		73,
		69,
		67,
		63,
		92,
		104,
		102,
		112,
		124,
		134,
		138,
		149,
		164,
		-1,
		-1,
		219,
		-1,
		-1,
		155,
		138,
		-1,
		121,
		128,
		112,
		118,
		104,
		98,
		84,
		60,
		57,
		78,
		66,
		86,
		96,
		118,
		109,
		121,
		146,
		150,
		144,
		165,
		160,
		-1,
		218,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		114,
		117,
		118,
		142,
		141,
		-1,
		68,
		56,
		53,
		47,
		57,
		70,
		72,
		93,
		97,
		110,
		112,
		128,
		130,
		163,
		141,
		163,
		160,
		189,
		194,
		188,
		197,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		146,
		-1,
		115,
		105,
		80,
		53,
		56,
		48,
		39,
		77,
		78,
		87,
		100,
		101,
		121,
		130,
		141,
		136,
		135,
		153,
		168,
		181,
		185,
		191,
		-1,
		213,
		-1,
		155,
		139,
		141,
		113,
		134,
		-1,
		166,
		114,
		97,
		82,
		76,
		-1,
		25,
		28,
		54,
		61,
		72,
		89,
		105,
		109,
		120,
		125,
		139,
		130,
		148,
		155,
		163,
		167,
		187,
		199,
		173,
		163,
		-1,
		145,
		150,
		109,
		117,
		136,
		118,
		82,
		-1,
		77,
		-1,
		15,
		40,
		-1,
		60,
		64,
		78,
		94,
		103,
		118,
		124,
		121,
		118,
		136,
		139,
		156,
		160,
		176,
		-1,
		-1,
		158,
		162,
		151,
		102,
		121,
		145,
		128,
		75,
		64,
		63,
		-1,
		0,
		91,
		88,
		89,
		96,
		91,
		92,
		109,
		122,
		101,
		120,
		123,
		145,
		173,
		151,
		163,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		128,
		99,
		123,
		142,
		93,
		86,
		74,
		39,
		37,
		24,
		-1,
		113,
		97,
		105,
		96,
		96,
		109,
		104,
		120,
		124,
		123,
		142,
		154,
		145,
		165,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		94,
		117,
		154,
		72,
		58,
		63,
		38,
		26,
		34,
		100,
		109,
		96,
		105,
		97,
		86,
		100,
		108,
		112,
		121,
		130,
		136,
		160,
		160,
		166,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		108,
		115,
		147,
		63,
		132,
		-1,
		67,
		-1,
		40,
		74,
		82,
		88,
		100,
		86,
		91,
		102,
		114,
		127,
		123,
		130,
		165,
		165,
		150,
		170,
		173,
		-1,
		-1,
		-1,
		158,
		153,
		128,
		105,
		89,
		125,
		-1,
		102,
		103,
		-1,
		61,
		55,
		71,
		79,
		86,
		83,
		83,
		97,
		105,
		101,
		117,
		123,
		115,
		151,
		-1,
		158,
		152,
		160,
		150,
		138,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		84,
		136,
		-1,
		-1,
		87,
		80,
		-1,
		58,
		67,
		74,
		83,
		88,
		93,
		101,
		96,
		109,
		114,
		120,
		125,
		143,
		147,
		151,
		140,
		136,
		133,
		147,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		104,
		-1,
		96,
		88,
		78,
		72,
		66,
		80,
		78,
		98,
		90,
		104,
		104,
		110,
		118,
		103,
		106,
		122,
		120,
		138,
		146,
		138,
		132,
		131,
		143,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		117,
		-1,
		81,
		95,
		111,
		-1,
		104,
		83,
		98,
		76,
		90,
		86,
		124,
		125,
		103,
		108,
		116,
		126,
		128,
		117,
		128,
		120,
		142,
		142,
		126,
		127,
		136,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		78,
		66,
		98,
		-1,
		-1,
		140,
		-1,
		74,
		91,
		100,
		98,
		114,
		105,
		111,
		127,
		130,
		132,
		122,
		111,
		117,
		114,
		136,
		122,
		120,
		139,
		155,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		115,
		-1,
		118,
		108,
		92,
		77,
		110,
		-1,
		122,
		106,
		111,
		-1,
		157,
		-1,
		130,
		132,
		126,
		111,
		108,
		119,
		117,
		128,
		145,
		-1,
		127,
		112,
		105,
		95,
		109,
		80,
		-1,
		135,
		-1,
		-1,
		105,
		99,
		99,
		83,
		86,
		138,
		118,
		112,
		111,
		152,
		152,
		138,
		124,
		117,
		114,
		111,
		124,
		144,
		135,
		147,
		-1,
		-1,
		-1,
		132,
		118,
		122,
		82,
		101,
		-1,
		-1,
		167,
		122,
		108,
		-1,
		92,
		155,
		143,
		133,
		123,
		157,
		158,
		143,
		136,
		122,
		124,
		122,
		120,
		125,
		146,
		147,
		160,
		-1,
		-1,
		115,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		114,
		130,
		122,
		93,
		144,
		-1,
		-1,
		135,
		133,
		143,
		139,
		126,
		146,
		149,
		135,
		119,
		134,
		146,
		154,
		159,
		-1,
		118,
		105,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		147,
		113,
		125,
		146,
		171,
		138,
		-1,
		143,
		144,
		130,
		144,
		151,
		137,
		132,
		126,
		129,
		147,
		164,
		-1,
		-1,
		130,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		104,
		118,
		139,
		145,
		157,
		-1,
		152,
		146,
		132,
		149,
		150,
		147,
		138,
		130,
		135,
		132,
		145,
		159,
		163,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		122,
		137,
		199,
		176,
		149,
		153,
		146,
		140,
		140,
		156,
		158,
		169,
		137,
		133,
		134,
		138,
		137,
		154,
		164,
		-1,
		-1,
		136,
		153,
		148,
		130,
		134,
		226,
		-1,
		-1,
		162,
		153,
		144,
		147,
		150,
		153,
		143,
		140,
		145,
		150,
		138,
		147,
		165,
		169,
		-1,
		-1,
		-1,
		156,
		-1,
		171,
		-1,
		-1,
		149,
		233,
		180,
		162,
		158,
		156,
		149,
		158,
		153,
		148,
		158,
		167,
		159,
		140,
		151,
		174,
		163,
		201,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		185,
		160,
		175,
		221,
		169,
		176,
		195,
		192,
		-1,
		162,
		187,
		159,
		166,
		158,
		166,
		166,
		163,
		141,
		148,
		164,
		163,
		158,
		193,
		185,
		191,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		191,
		177,
		207,
		197,
		186,
		-1,
		-1,
		211,
		208,
		184,
		168,
		172,
		165,
		160,
		170,
		150,
		137,
		141,
		145,
		151,
		156,
		161,
		167,
		182,
		197,
		-1,
		163,
		244,
		237,
		220,
		228,
		259,
		-1,
		194,
		203,
		184,
		189,
		197,
		-1,
		-1,
		184,
		181,
		186,
		175,
		172,
		180,
		175,
		166,
		151,
		157,
		144,
		143,
		161,
		165,
		174,
		181,
		171,
		184,
		188,
		-1,
		177,
		220,
		214,
		217,
		241,
		255,
		-1,
		207,
		-1,
		-1,
		192,
		210,
		199,
		189,
		183,
		233,
		189,
		184,
		174,
		172,
		163,
		154,
		161,
		152,
		152,
		155,
		170,
		175,
		167,
		181,
		181,
		182,
		-1,
		212,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		208,
		-1,
		226,
		-1,
		201,
		205,
		197,
		200,
		188,
		175,
		167,
		159,
		175,
		150,
		160,
		156,
		157,
		166,
		177,
		189,
		188,
		189,
		286,
		241,
		208,
		199,
		246,
		261,
		265,
		-1,
		220,
		259,
		246,
		-1,
		217,
		-1,
		-1,
		-1,
		215,
		210,
		202,
		208,
		187,
		187,
		161,
		165,
		155,
		162,
		172,
		174,
		166,
		170,
		183,
		194,
		197,
		282,
		280,
		285,
		230,
		213,
		231,
		240,
		261,
		235,
		226,
		253,
		253,
		242,
		237,
		224,
		-1,
		-1,
		238,
		220,
		-1,
		-1,
		194,
		182,
		165,
		166,
		162,
		165,
		180,
		183,
		173,
		171,
		165,
		197,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		221,
		232,
		-1,
		-1,
		238,
		254,
		267,
		271,
		284,
		309,
		-1,
		227,
		-1,
		-1,
		239,
		-1,
		-1,
		224,
		187,
		176,
		167,
		173,
		170,
		181,
		191,
		179,
		180,
		170,
		180,
		193,
		266,
		263,
		251,
		249,
		272,
		229,
		225,
		-1,
		248,
		241,
		247,
		254,
		271,
		298,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		222,
		220,
		209,
		-1,
		199,
		172,
		177,
		197,
		199,
		188,
		182,
		176,
		183,
		182,
		190,
		198,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		233,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		-1,
		260,
		253,
		-1,
		-1,
		217,
		210,
		198,
		186,
		176,
		186,
		190,
		194,
		186,
		179,
		174,
		185,
		177,
		181,
		198,
		-1,
		309,
		-1,
		261,
		247,
		261,
		276,
		284,
		-1,
		-1,
		-1,
		277,
		263,
		256,
		244,
		242,
		-1,
		251,
		235,
		216,
		-1,
		186,
		199,
		230,
		198,
		203,
		198,
		180,
		191,
		180,
		183,
		197,
		192,
		-1,
		-1,
		259,
		262,
		-1,
		-1,
		267,
		269,
		-1,
		268,
		257,
		242,
		234,
		-1,
		-1,
		223,
		219,
		-1,
		-1,
		187,
		212,
		201,
		209,
		204,
		184,
		190,
		193,
		182,
		186,
		198,
		-1,
		-1,
		266,
		267,
		272,
		-1,
		252,
		-1,
		270,
		-1,
		237,
		243,
		231,
		-1,
		-1,
		-1,
		225,
		188,
		209,
		219,
		213,
		211,
		202,
		188,
		195,
		193,
		189,
		200,
		-1,
		-1,
		-1,
		270,
		244,
		277,
		268,
		251,
		231,
		223,
		242,
		-1,
		212,
		-1,
		187,
		189,
		215,
		218,
		224,
		218,
		191,
		206,
		196,
		187,
		196,
		276,
		-1,
		246,
		279,
		243,
		237,
		213,
		217,
		233,
		-1,
		209,
		191,
		-1,
		219,
		209,
		240,
		225,
		206,
		193,
		200,
		200,
		193,
		-1,
		-1,
		-1,
		248,
		247,
		239,
		233,
		233,
		218,
		209,
		-1,
		221,
		203,
		182,
		199,
		199,
		190,
		198,
		230,
		226,
		213,
		213,
		205,
		-1,
		349,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		242,
		237,
		210,
		198,
		204,
		200,
		186,
		192,
		194,
		202,
		200,
		197,
		209,
		205,
		225,
		206,
		241,
		-1,
		344,
		-1,
		278,
		-1,
		-1,
		260,
		240,
		232,
		221,
		210,
		208,
		199,
		190,
		212,
		228,
		212,
		210,
		213,
		214,
		-1,
		333,
		332,
		-1,
		279,
		271,
		257,
		-1,
		250,
		-1,
		256,
		217,
		-1,
		219,
		199,
		-1,
		221,
		217,
		-1,
		-1,
		320,
		295,
		-1,
		-1,
		-1,
		280,
		260,
		251,
		235,
		-1,
		210,
		210,
		-1,
		-1,
		-1,
		305,
		304,
		-1,
		273,
		276,
		-1,
		266,
		257,
		265,
		212,
		216,
		-1,
		-1,
		-1,
		314,
		295,
		289,
		288,
		286,
		281,
		278,
		264,
		248,
		226,
		215,
		236,
		-1,
		-1,
		-1,
		286,
		278,
		271,
		-1,
		-1,
		273,
		256,
		237,
		235,
		-1,
		-1,
		-1,
		308,
		289,
		-1,
		-1,
		263,
		-1,
		-1,
		269,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		325,
		297,
		-1,
		-1,
		-1,
		259,
		255,
		256,
		-1,
		-1,
		-1,
		-1,
		319,
		320,
		343,
		307,
		-1,
		-1,
		-1,
		251,
		245,
		-1,
		-1,
		322,
		320,
		-1,
		-1,
		-1,
		279,
		263,
		-1,
		249,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		284,
		-1,
		284,
		259,
		266,
		-1,
		-1,
		-1,
		-1,
		297,
		289,
		297,
		-1,
		269,
		271,
		-1,
		319,
		-1,
		-1,
		312,
		303,
		-1,
		-1,
		274,
		281,
		303,
		306,
		342,
		-1,
		293
	],
	[
		-1,
		148,
		137,
		148,
		156,
		129,
		136,
		-1,
		157,
		159,
		125,
		119,
		158,
		129,
		135,
		146,
		-1,
		-1,
		-1,
		148,
		147,
		117,
		115,
		124,
		129,
		136,
		-1,
		159,
		-1,
		169,
		148,
		159,
		164,
		110,
		107,
		127,
		146,
		152,
		144,
		184,
		140,
		111,
		105,
		123,
		128,
		146,
		138,
		-1,
		111,
		101,
		123,
		127,
		139,
		122,
		-1,
		-1,
		105,
		106,
		112,
		124,
		129,
		133,
		-1,
		143,
		127,
		-1,
		-1,
		95,
		108,
		104,
		107,
		115,
		122,
		135,
		127,
		122,
		-1,
		-1,
		96,
		100,
		113,
		109,
		105,
		122,
		135,
		117,
		131,
		130,
		-1,
		84,
		102,
		111,
		116,
		114,
		98,
		96,
		114,
		116,
		122,
		125,
		-1,
		93,
		94,
		95,
		103,
		108,
		114,
		101,
		101,
		111,
		104,
		123,
		114,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		76,
		93,
		90,
		83,
		96,
		96,
		102,
		101,
		99,
		96,
		112,
		113,
		123,
		-1,
		-1,
		187,
		160,
		184,
		142,
		123,
		-1,
		89,
		69,
		75,
		79,
		81,
		79,
		93,
		89,
		-1,
		90,
		89,
		120,
		106,
		117,
		169,
		-1,
		-1,
		145,
		137,
		119,
		122,
		99,
		95,
		84,
		83,
		75,
		61,
		57,
		76,
		79,
		79,
		85,
		84,
		94,
		98,
		113,
		124,
		-1,
		-1,
		185,
		-1,
		-1,
		166,
		149,
		-1,
		114,
		121,
		105,
		111,
		97,
		118,
		94,
		80,
		76,
		71,
		59,
		72,
		71,
		84,
		75,
		81,
		106,
		110,
		110,
		131,
		126,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		121,
		118,
		111,
		135,
		134,
		-1,
		92,
		80,
		77,
		66,
		67,
		58,
		52,
		59,
		63,
		76,
		78,
		88,
		90,
		123,
		107,
		129,
		126,
		155,
		160,
		154,
		163,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		139,
		-1,
		142,
		129,
		104,
		77,
		80,
		62,
		49,
		53,
		48,
		53,
		64,
		61,
		81,
		94,
		101,
		102,
		101,
		119,
		134,
		147,
		151,
		157,
		-1,
		224,
		-1,
		166,
		150,
		152,
		128,
		156,
		-1,
		159,
		143,
		121,
		106,
		106,
		-1,
		67,
		64,
		54,
		32,
		40,
		57,
		61,
		65,
		80,
		91,
		105,
		96,
		114,
		121,
		129,
		133,
		153,
		165,
		184,
		174,
		-1,
		156,
		161,
		131,
		139,
		158,
		178,
		142,
		-1,
		117,
		-1,
		69,
		82,
		-1,
		38,
		22,
		31,
		48,
		62,
		75,
		87,
		87,
		84,
		102,
		105,
		122,
		126,
		142,
		-1,
		-1,
		169,
		173,
		173,
		124,
		143,
		167,
		188,
		135,
		124,
		123,
		-1,
		87,
		0,
		6,
		16,
		35,
		45,
		48,
		68,
		87,
		67,
		86,
		89,
		111,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		150,
		121,
		145,
		187,
		153,
		146,
		134,
		117,
		117,
		111,
		-1,
		38,
		24,
		40,
		52,
		60,
		75,
		72,
		86,
		90,
		89,
		108,
		120,
		111,
		131,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		150,
		136,
		141,
		116,
		109,
		103,
		18,
		36,
		50,
		52,
		61,
		52,
		68,
		76,
		78,
		87,
		96,
		102,
		126,
		133,
		139,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		141,
		154,
		-1,
		108,
		-1,
		97,
		73,
		67,
		64,
		68,
		65,
		59,
		68,
		82,
		93,
		89,
		96,
		131,
		131,
		123,
		143,
		146,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		102,
		96,
		77,
		70,
		64,
		69,
		73,
		66,
		73,
		69,
		83,
		94,
		81,
		117,
		-1,
		131,
		125,
		133,
		123,
		111,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		88,
		71,
		78,
		76,
		70,
		74,
		78,
		67,
		80,
		85,
		86,
		96,
		116,
		120,
		124,
		113,
		109,
		106,
		120,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		84,
		82,
		98,
		82,
		85,
		85,
		81,
		89,
		74,
		77,
		89,
		93,
		111,
		119,
		111,
		105,
		104,
		116,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		94,
		90,
		105,
		106,
		84,
		89,
		88,
		98,
		99,
		88,
		101,
		93,
		115,
		115,
		99,
		100,
		109,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		104,
		102,
		95,
		86,
		92,
		99,
		102,
		103,
		93,
		82,
		88,
		87,
		109,
		95,
		93,
		112,
		128,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		103,
		87,
		92,
		-1,
		128,
		-1,
		101,
		103,
		95,
		84,
		81,
		92,
		90,
		101,
		118,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		119,
		99,
		93,
		92,
		123,
		121,
		109,
		93,
		86,
		83,
		84,
		97,
		117,
		108,
		120,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		136,
		124,
		114,
		104,
		138,
		137,
		112,
		105,
		91,
		93,
		91,
		93,
		98,
		119,
		120,
		133,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		125,
		-1,
		-1,
		116,
		114,
		124,
		108,
		95,
		115,
		118,
		108,
		92,
		107,
		119,
		127,
		132,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		169,
		135,
		147,
		149,
		153,
		119,
		-1,
		124,
		119,
		99,
		113,
		120,
		110,
		105,
		99,
		102,
		120,
		137,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		126,
		140,
		142,
		135,
		139,
		-1,
		127,
		115,
		101,
		118,
		123,
		120,
		111,
		103,
		108,
		105,
		118,
		132,
		136,
		175,
		-1,
		158,
		-1,
		-1,
		-1,
		144,
		159,
		181,
		158,
		131,
		126,
		119,
		113,
		109,
		125,
		131,
		142,
		110,
		106,
		107,
		111,
		110,
		127,
		137,
		-1,
		-1,
		158,
		175,
		170,
		152,
		156,
		208,
		-1,
		-1,
		135,
		126,
		117,
		120,
		119,
		122,
		116,
		113,
		118,
		123,
		111,
		120,
		138,
		137,
		-1,
		-1,
		-1,
		178,
		-1,
		193,
		-1,
		-1,
		171,
		206,
		153,
		135,
		131,
		129,
		122,
		131,
		126,
		121,
		131,
		133,
		125,
		113,
		117,
		140,
		129,
		168,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		207,
		182,
		197,
		217,
		191,
		198,
		168,
		165,
		-1,
		135,
		160,
		132,
		139,
		130,
		137,
		137,
		129,
		107,
		114,
		130,
		129,
		124,
		160,
		151,
		157,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		213,
		199,
		203,
		193,
		196,
		-1,
		-1,
		184,
		181,
		157,
		140,
		138,
		131,
		126,
		136,
		116,
		103,
		107,
		111,
		117,
		122,
		127,
		133,
		148,
		163,
		-1,
		185,
		266,
		259,
		242,
		250,
		281,
		-1,
		207,
		199,
		206,
		185,
		187,
		-1,
		-1,
		157,
		154,
		159,
		147,
		144,
		146,
		141,
		132,
		117,
		123,
		110,
		109,
		127,
		131,
		140,
		147,
		137,
		150,
		154,
		-1,
		199,
		242,
		236,
		239,
		263,
		277,
		-1,
		204,
		-1,
		-1,
		214,
		188,
		172,
		162,
		156,
		206,
		161,
		156,
		140,
		138,
		129,
		120,
		127,
		118,
		118,
		121,
		136,
		141,
		133,
		147,
		147,
		148,
		-1,
		234,
		222,
		230,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		230,
		-1,
		199,
		-1,
		174,
		178,
		169,
		172,
		154,
		141,
		133,
		125,
		141,
		116,
		126,
		122,
		123,
		132,
		143,
		155,
		154,
		155,
		275,
		231,
		230,
		221,
		256,
		271,
		275,
		-1,
		216,
		255,
		253,
		-1,
		237,
		-1,
		-1,
		-1,
		188,
		182,
		174,
		174,
		153,
		153,
		127,
		131,
		121,
		128,
		138,
		140,
		132,
		136,
		149,
		160,
		163,
		271,
		262,
		275,
		220,
		220,
		241,
		250,
		271,
		231,
		222,
		249,
		260,
		249,
		244,
		231,
		-1,
		-1,
		211,
		192,
		-1,
		-1,
		160,
		148,
		131,
		132,
		128,
		131,
		146,
		149,
		139,
		137,
		131,
		163,
		-1,
		264,
		263,
		252,
		249,
		225,
		216,
		211,
		238,
		-1,
		-1,
		233,
		250,
		244,
		248,
		264,
		289,
		-1,
		220,
		-1,
		-1,
		205,
		-1,
		-1,
		190,
		153,
		142,
		133,
		139,
		136,
		147,
		157,
		145,
		146,
		136,
		146,
		159,
		248,
		245,
		233,
		231,
		254,
		219,
		207,
		-1,
		220,
		218,
		224,
		231,
		248,
		278,
		-1,
		-1,
		236,
		216,
		-1,
		-1,
		188,
		186,
		175,
		-1,
		165,
		138,
		143,
		163,
		165,
		154,
		148,
		142,
		149,
		148,
		156,
		164,
		257,
		271,
		260,
		256,
		255,
		263,
		212,
		205,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		226,
		222,
		-1,
		-1,
		183,
		176,
		164,
		152,
		142,
		152,
		156,
		160,
		152,
		145,
		140,
		151,
		143,
		147,
		164,
		-1,
		291,
		-1,
		243,
		219,
		233,
		248,
		256,
		-1,
		-1,
		-1,
		243,
		229,
		222,
		210,
		208,
		-1,
		217,
		201,
		182,
		-1,
		152,
		165,
		196,
		164,
		169,
		164,
		146,
		157,
		146,
		149,
		163,
		158,
		-1,
		-1,
		231,
		234,
		-1,
		-1,
		233,
		235,
		-1,
		234,
		223,
		208,
		200,
		-1,
		-1,
		189,
		185,
		-1,
		-1,
		153,
		178,
		167,
		175,
		170,
		150,
		156,
		159,
		148,
		152,
		164,
		-1,
		-1,
		238,
		239,
		240,
		-1,
		218,
		-1,
		236,
		-1,
		203,
		209,
		197,
		-1,
		-1,
		-1,
		191,
		154,
		175,
		185,
		179,
		177,
		168,
		154,
		161,
		159,
		155,
		166,
		-1,
		-1,
		-1,
		236,
		210,
		243,
		234,
		217,
		197,
		189,
		208,
		-1,
		178,
		-1,
		153,
		155,
		181,
		184,
		190,
		184,
		157,
		172,
		162,
		153,
		162,
		242,
		-1,
		212,
		245,
		209,
		203,
		179,
		183,
		199,
		-1,
		175,
		157,
		-1,
		185,
		175,
		206,
		191,
		172,
		159,
		166,
		166,
		159,
		-1,
		-1,
		-1,
		214,
		213,
		205,
		199,
		199,
		184,
		175,
		-1,
		187,
		169,
		148,
		165,
		165,
		156,
		164,
		196,
		192,
		179,
		179,
		171,
		-1,
		315,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		208,
		203,
		176,
		164,
		170,
		166,
		152,
		158,
		160,
		168,
		166,
		163,
		175,
		171,
		191,
		172,
		207,
		-1,
		310,
		-1,
		244,
		-1,
		-1,
		226,
		206,
		198,
		187,
		176,
		174,
		165,
		156,
		178,
		194,
		178,
		176,
		179,
		180,
		-1,
		299,
		298,
		-1,
		245,
		237,
		223,
		-1,
		216,
		-1,
		222,
		183,
		-1,
		185,
		165,
		-1,
		187,
		183,
		-1,
		-1,
		286,
		261,
		-1,
		-1,
		-1,
		246,
		226,
		217,
		201,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		271,
		270,
		-1,
		239,
		242,
		-1,
		232,
		223,
		231,
		178,
		182,
		-1,
		-1,
		-1,
		280,
		261,
		255,
		254,
		252,
		247,
		244,
		230,
		214,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		252,
		244,
		237,
		-1,
		-1,
		239,
		222,
		203,
		201,
		-1,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		229,
		-1,
		-1,
		235,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		263,
		-1,
		-1,
		-1,
		225,
		221,
		222,
		-1,
		-1,
		-1,
		-1,
		285,
		286,
		309,
		273,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		288,
		286,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		146,
		135,
		146,
		154,
		127,
		134,
		-1,
		155,
		157,
		123,
		117,
		156,
		127,
		133,
		144,
		-1,
		-1,
		-1,
		146,
		145,
		115,
		113,
		122,
		127,
		134,
		-1,
		157,
		-1,
		167,
		146,
		157,
		162,
		108,
		105,
		125,
		144,
		150,
		142,
		182,
		138,
		109,
		103,
		121,
		126,
		144,
		136,
		-1,
		109,
		99,
		121,
		125,
		137,
		120,
		-1,
		-1,
		103,
		104,
		110,
		122,
		127,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		93,
		106,
		102,
		105,
		113,
		120,
		133,
		125,
		120,
		-1,
		-1,
		94,
		98,
		111,
		107,
		103,
		120,
		133,
		115,
		129,
		128,
		-1,
		82,
		100,
		109,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		123,
		-1,
		91,
		92,
		93,
		101,
		106,
		112,
		99,
		99,
		109,
		102,
		121,
		112,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		91,
		74,
		91,
		88,
		81,
		94,
		94,
		100,
		99,
		97,
		94,
		110,
		111,
		121,
		-1,
		-1,
		185,
		158,
		182,
		140,
		121,
		-1,
		87,
		67,
		73,
		77,
		79,
		77,
		91,
		87,
		-1,
		88,
		87,
		118,
		104,
		115,
		167,
		-1,
		-1,
		143,
		135,
		117,
		120,
		97,
		93,
		82,
		81,
		73,
		59,
		55,
		74,
		77,
		77,
		83,
		82,
		92,
		96,
		111,
		122,
		-1,
		-1,
		183,
		-1,
		-1,
		164,
		147,
		-1,
		112,
		119,
		103,
		109,
		95,
		116,
		92,
		78,
		74,
		69,
		57,
		70,
		69,
		82,
		73,
		79,
		104,
		108,
		108,
		129,
		124,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		119,
		116,
		109,
		133,
		132,
		-1,
		90,
		78,
		75,
		64,
		65,
		56,
		50,
		57,
		61,
		74,
		76,
		86,
		88,
		121,
		105,
		127,
		124,
		153,
		158,
		152,
		161,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		137,
		-1,
		140,
		127,
		102,
		75,
		78,
		60,
		47,
		51,
		46,
		51,
		62,
		59,
		79,
		92,
		99,
		100,
		99,
		117,
		132,
		145,
		149,
		155,
		-1,
		222,
		-1,
		164,
		148,
		150,
		126,
		154,
		-1,
		157,
		141,
		119,
		104,
		104,
		-1,
		65,
		62,
		52,
		30,
		38,
		55,
		59,
		63,
		78,
		89,
		103,
		94,
		112,
		119,
		127,
		131,
		151,
		163,
		182,
		172,
		-1,
		154,
		159,
		129,
		137,
		156,
		176,
		140,
		-1,
		115,
		-1,
		67,
		80,
		-1,
		36,
		20,
		29,
		46,
		60,
		73,
		85,
		85,
		82,
		100,
		103,
		120,
		124,
		140,
		-1,
		-1,
		167,
		171,
		171,
		122,
		141,
		165,
		186,
		133,
		122,
		121,
		-1,
		85,
		7,
		0,
		14,
		33,
		43,
		46,
		66,
		85,
		65,
		84,
		87,
		109,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		148,
		119,
		143,
		185,
		151,
		144,
		132,
		115,
		115,
		109,
		-1,
		32,
		22,
		38,
		50,
		58,
		73,
		70,
		84,
		88,
		87,
		106,
		118,
		109,
		129,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		114,
		137,
		174,
		148,
		134,
		139,
		114,
		107,
		101,
		12,
		34,
		48,
		50,
		59,
		50,
		66,
		74,
		76,
		85,
		94,
		100,
		124,
		131,
		137,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		128,
		135,
		167,
		139,
		152,
		-1,
		106,
		-1,
		95,
		71,
		65,
		62,
		66,
		63,
		57,
		66,
		80,
		91,
		87,
		94,
		129,
		129,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		178,
		173,
		148,
		125,
		109,
		145,
		-1,
		122,
		123,
		-1,
		100,
		94,
		75,
		68,
		62,
		67,
		71,
		64,
		71,
		67,
		81,
		92,
		79,
		115,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		104,
		156,
		-1,
		-1,
		107,
		100,
		-1,
		86,
		69,
		76,
		74,
		68,
		72,
		76,
		65,
		78,
		83,
		84,
		94,
		114,
		118,
		122,
		111,
		107,
		104,
		118,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		124,
		-1,
		116,
		108,
		98,
		92,
		86,
		82,
		80,
		96,
		80,
		83,
		83,
		79,
		87,
		72,
		75,
		87,
		91,
		109,
		117,
		109,
		103,
		102,
		114,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		137,
		-1,
		101,
		115,
		131,
		-1,
		124,
		103,
		118,
		96,
		92,
		88,
		103,
		104,
		82,
		87,
		86,
		96,
		97,
		86,
		99,
		91,
		113,
		113,
		97,
		98,
		107,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		98,
		86,
		118,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		102,
		100,
		93,
		84,
		90,
		97,
		100,
		101,
		91,
		80,
		86,
		85,
		107,
		93,
		91,
		110,
		126,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		101,
		85,
		90,
		-1,
		126,
		-1,
		99,
		101,
		93,
		82,
		79,
		90,
		88,
		99,
		116,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		155,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		117,
		97,
		91,
		90,
		121,
		119,
		107,
		91,
		84,
		81,
		82,
		95,
		115,
		106,
		118,
		-1,
		-1,
		-1,
		152,
		138,
		142,
		102,
		121,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		134,
		122,
		112,
		102,
		136,
		135,
		110,
		103,
		89,
		91,
		89,
		91,
		96,
		117,
		118,
		131,
		-1,
		-1,
		135,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		123,
		-1,
		-1,
		114,
		112,
		122,
		106,
		93,
		113,
		116,
		106,
		90,
		105,
		117,
		125,
		130,
		-1,
		138,
		125,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		145,
		147,
		151,
		117,
		-1,
		122,
		117,
		97,
		111,
		118,
		108,
		103,
		97,
		100,
		118,
		135,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		140,
		133,
		137,
		-1,
		125,
		113,
		99,
		116,
		121,
		118,
		109,
		101,
		106,
		103,
		116,
		130,
		134,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		142,
		157,
		179,
		156,
		129,
		124,
		117,
		111,
		107,
		123,
		129,
		140,
		108,
		104,
		105,
		109,
		108,
		125,
		135,
		-1,
		-1,
		156,
		173,
		168,
		150,
		154,
		206,
		-1,
		-1,
		133,
		124,
		115,
		118,
		117,
		120,
		114,
		111,
		116,
		121,
		109,
		118,
		136,
		135,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		169,
		204,
		151,
		133,
		129,
		127,
		120,
		129,
		124,
		119,
		129,
		131,
		123,
		111,
		115,
		138,
		127,
		166,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		205,
		180,
		195,
		215,
		189,
		196,
		166,
		163,
		-1,
		133,
		158,
		130,
		137,
		128,
		135,
		135,
		127,
		105,
		112,
		128,
		127,
		122,
		158,
		149,
		155,
		-1,
		-1,
		288,
		277,
		266,
		272,
		-1,
		211,
		197,
		201,
		191,
		194,
		-1,
		-1,
		182,
		179,
		155,
		138,
		136,
		129,
		124,
		134,
		114,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		183,
		264,
		257,
		240,
		248,
		279,
		-1,
		205,
		197,
		204,
		183,
		185,
		-1,
		-1,
		155,
		152,
		157,
		145,
		142,
		144,
		139,
		130,
		115,
		121,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		197,
		240,
		234,
		237,
		261,
		275,
		-1,
		202,
		-1,
		-1,
		212,
		186,
		170,
		160,
		154,
		204,
		159,
		154,
		138,
		136,
		127,
		118,
		125,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		232,
		220,
		228,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		228,
		-1,
		197,
		-1,
		172,
		176,
		167,
		170,
		152,
		139,
		131,
		123,
		139,
		114,
		124,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		273,
		229,
		228,
		219,
		254,
		269,
		273,
		-1,
		214,
		253,
		251,
		-1,
		235,
		-1,
		-1,
		-1,
		186,
		180,
		172,
		172,
		151,
		151,
		125,
		129,
		119,
		126,
		136,
		138,
		130,
		134,
		147,
		158,
		161,
		269,
		260,
		273,
		218,
		218,
		239,
		248,
		269,
		229,
		220,
		247,
		258,
		247,
		242,
		229,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		158,
		146,
		129,
		130,
		126,
		129,
		144,
		147,
		137,
		135,
		129,
		161,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		209,
		236,
		-1,
		-1,
		231,
		248,
		242,
		246,
		262,
		287,
		-1,
		218,
		-1,
		-1,
		203,
		-1,
		-1,
		188,
		151,
		140,
		131,
		137,
		134,
		145,
		155,
		143,
		144,
		134,
		144,
		157,
		246,
		243,
		231,
		229,
		252,
		217,
		205,
		-1,
		218,
		216,
		222,
		229,
		246,
		276,
		-1,
		-1,
		234,
		214,
		-1,
		-1,
		186,
		184,
		173,
		-1,
		163,
		136,
		141,
		161,
		163,
		152,
		146,
		140,
		147,
		146,
		154,
		162,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		203,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		224,
		220,
		-1,
		-1,
		181,
		174,
		162,
		150,
		140,
		150,
		154,
		158,
		150,
		143,
		138,
		149,
		141,
		145,
		162,
		-1,
		289,
		-1,
		241,
		217,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		241,
		227,
		220,
		208,
		206,
		-1,
		215,
		199,
		180,
		-1,
		150,
		163,
		194,
		162,
		167,
		162,
		144,
		155,
		144,
		147,
		161,
		156,
		-1,
		-1,
		229,
		232,
		-1,
		-1,
		231,
		233,
		-1,
		232,
		221,
		206,
		198,
		-1,
		-1,
		187,
		183,
		-1,
		-1,
		151,
		176,
		165,
		173,
		168,
		148,
		154,
		157,
		146,
		150,
		162,
		-1,
		-1,
		236,
		237,
		238,
		-1,
		216,
		-1,
		234,
		-1,
		201,
		207,
		195,
		-1,
		-1,
		-1,
		189,
		152,
		173,
		183,
		177,
		175,
		166,
		152,
		159,
		157,
		153,
		164,
		-1,
		-1,
		-1,
		234,
		208,
		241,
		232,
		215,
		195,
		187,
		206,
		-1,
		176,
		-1,
		151,
		153,
		179,
		182,
		188,
		182,
		155,
		170,
		160,
		151,
		160,
		240,
		-1,
		210,
		243,
		207,
		201,
		177,
		181,
		197,
		-1,
		173,
		155,
		-1,
		183,
		173,
		204,
		189,
		170,
		157,
		164,
		164,
		157,
		-1,
		-1,
		-1,
		212,
		211,
		203,
		197,
		197,
		182,
		173,
		-1,
		185,
		167,
		146,
		163,
		163,
		154,
		162,
		194,
		190,
		177,
		177,
		169,
		-1,
		313,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		206,
		201,
		174,
		162,
		168,
		164,
		150,
		156,
		158,
		166,
		164,
		161,
		173,
		169,
		189,
		170,
		205,
		-1,
		308,
		-1,
		242,
		-1,
		-1,
		224,
		204,
		196,
		185,
		174,
		172,
		163,
		154,
		176,
		192,
		176,
		174,
		177,
		178,
		-1,
		297,
		296,
		-1,
		243,
		235,
		221,
		-1,
		214,
		-1,
		220,
		181,
		-1,
		183,
		163,
		-1,
		185,
		181,
		-1,
		-1,
		284,
		259,
		-1,
		-1,
		-1,
		244,
		224,
		215,
		199,
		-1,
		174,
		174,
		-1,
		-1,
		-1,
		269,
		268,
		-1,
		237,
		240,
		-1,
		230,
		221,
		229,
		176,
		180,
		-1,
		-1,
		-1,
		278,
		259,
		253,
		252,
		250,
		245,
		242,
		228,
		212,
		190,
		179,
		200,
		-1,
		-1,
		-1,
		250,
		242,
		235,
		-1,
		-1,
		237,
		220,
		201,
		199,
		-1,
		-1,
		-1,
		272,
		253,
		-1,
		-1,
		227,
		-1,
		-1,
		233,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		261,
		-1,
		-1,
		-1,
		223,
		219,
		220,
		-1,
		-1,
		-1,
		-1,
		283,
		284,
		307,
		271,
		-1,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		286,
		284,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		213,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		248,
		-1,
		248,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		261,
		-1,
		233,
		235,
		-1,
		283,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		238,
		245,
		267,
		270,
		306,
		-1,
		257
	],
	[
		-1,
		147,
		136,
		147,
		155,
		128,
		135,
		-1,
		156,
		158,
		124,
		118,
		157,
		128,
		134,
		145,
		-1,
		-1,
		-1,
		147,
		146,
		116,
		114,
		123,
		128,
		135,
		-1,
		158,
		-1,
		168,
		147,
		158,
		163,
		109,
		106,
		126,
		145,
		151,
		143,
		183,
		139,
		110,
		104,
		122,
		127,
		145,
		137,
		-1,
		110,
		100,
		122,
		126,
		138,
		121,
		-1,
		-1,
		104,
		105,
		111,
		123,
		128,
		132,
		-1,
		142,
		126,
		-1,
		-1,
		94,
		107,
		103,
		106,
		114,
		121,
		134,
		126,
		121,
		-1,
		-1,
		95,
		99,
		112,
		108,
		104,
		121,
		134,
		116,
		130,
		129,
		-1,
		83,
		101,
		110,
		115,
		113,
		97,
		95,
		113,
		115,
		121,
		124,
		-1,
		92,
		93,
		94,
		102,
		107,
		113,
		100,
		100,
		110,
		103,
		122,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		75,
		92,
		89,
		82,
		95,
		95,
		101,
		100,
		98,
		95,
		111,
		112,
		122,
		-1,
		-1,
		186,
		159,
		183,
		141,
		122,
		-1,
		88,
		68,
		74,
		78,
		80,
		78,
		92,
		88,
		-1,
		89,
		88,
		119,
		105,
		116,
		168,
		-1,
		-1,
		144,
		136,
		118,
		121,
		98,
		94,
		83,
		82,
		74,
		60,
		56,
		75,
		78,
		78,
		84,
		83,
		93,
		97,
		110,
		123,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		148,
		-1,
		113,
		120,
		104,
		110,
		96,
		117,
		93,
		79,
		75,
		70,
		58,
		71,
		70,
		83,
		74,
		80,
		105,
		109,
		105,
		126,
		121,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		120,
		117,
		110,
		134,
		133,
		-1,
		91,
		79,
		76,
		65,
		66,
		57,
		51,
		58,
		62,
		75,
		77,
		87,
		89,
		122,
		102,
		124,
		121,
		150,
		155,
		149,
		158,
		-1,
		173,
		169,
		165,
		172,
		121,
		-1,
		-1,
		138,
		-1,
		141,
		128,
		103,
		76,
		79,
		61,
		48,
		52,
		47,
		52,
		63,
		60,
		80,
		91,
		100,
		97,
		96,
		114,
		129,
		142,
		146,
		152,
		-1,
		223,
		-1,
		165,
		149,
		151,
		127,
		149,
		-1,
		158,
		142,
		120,
		105,
		105,
		-1,
		66,
		63,
		53,
		31,
		39,
		56,
		60,
		64,
		79,
		86,
		100,
		91,
		109,
		116,
		124,
		128,
		148,
		160,
		183,
		173,
		-1,
		155,
		160,
		124,
		132,
		151,
		177,
		141,
		-1,
		116,
		-1,
		68,
		81,
		-1,
		37,
		21,
		30,
		47,
		61,
		74,
		85,
		82,
		79,
		97,
		100,
		117,
		121,
		137,
		-1,
		-1,
		168,
		172,
		166,
		117,
		136,
		160,
		187,
		134,
		123,
		122,
		-1,
		86,
		17,
		14,
		0,
		19,
		37,
		43,
		64,
		83,
		62,
		81,
		84,
		106,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		143,
		114,
		138,
		180,
		152,
		145,
		133,
		110,
		110,
		104,
		-1,
		24,
		8,
		24,
		47,
		51,
		65,
		67,
		81,
		85,
		84,
		103,
		115,
		106,
		126,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		109,
		132,
		169,
		143,
		129,
		134,
		109,
		102,
		95,
		26,
		20,
		34,
		36,
		45,
		47,
		63,
		71,
		73,
		82,
		91,
		97,
		121,
		128,
		134,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		123,
		130,
		162,
		134,
		147,
		-1,
		100,
		-1,
		89,
		57,
		51,
		48,
		53,
		59,
		54,
		63,
		77,
		88,
		84,
		91,
		126,
		126,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		173,
		168,
		143,
		120,
		104,
		140,
		-1,
		117,
		118,
		-1,
		94,
		88,
		61,
		54,
		48,
		64,
		65,
		61,
		64,
		64,
		78,
		89,
		76,
		112,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		99,
		151,
		-1,
		-1,
		102,
		95,
		-1,
		72,
		64,
		69,
		64,
		65,
		69,
		73,
		62,
		75,
		80,
		81,
		91,
		111,
		115,
		119,
		108,
		104,
		101,
		115,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		119,
		-1,
		111,
		103,
		93,
		87,
		81,
		77,
		75,
		93,
		77,
		80,
		80,
		76,
		84,
		69,
		72,
		84,
		88,
		106,
		114,
		106,
		100,
		99,
		111,
		-1,
		186,
		172,
		143,
		-1,
		-1,
		132,
		-1,
		96,
		110,
		126,
		-1,
		119,
		98,
		113,
		91,
		87,
		81,
		100,
		101,
		79,
		84,
		83,
		93,
		94,
		83,
		96,
		88,
		110,
		110,
		94,
		95,
		104,
		-1,
		192,
		179,
		137,
		133,
		122,
		142,
		93,
		81,
		113,
		-1,
		-1,
		155,
		-1,
		89,
		106,
		95,
		93,
		90,
		81,
		87,
		94,
		97,
		98,
		88,
		77,
		83,
		82,
		104,
		90,
		88,
		107,
		123,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		108,
		95,
		89,
		-1,
		130,
		-1,
		133,
		123,
		107,
		92,
		125,
		-1,
		98,
		82,
		87,
		-1,
		123,
		-1,
		96,
		98,
		90,
		79,
		76,
		87,
		85,
		96,
		113,
		-1,
		142,
		127,
		120,
		110,
		124,
		95,
		-1,
		150,
		-1,
		-1,
		120,
		114,
		114,
		98,
		101,
		114,
		94,
		88,
		87,
		118,
		116,
		104,
		88,
		81,
		78,
		79,
		92,
		112,
		103,
		115,
		-1,
		-1,
		-1,
		147,
		133,
		137,
		97,
		116,
		-1,
		-1,
		182,
		137,
		123,
		-1,
		107,
		131,
		119,
		109,
		99,
		133,
		132,
		107,
		100,
		86,
		88,
		86,
		88,
		93,
		114,
		115,
		128,
		-1,
		-1,
		130,
		135,
		123,
		109,
		128,
		-1,
		-1,
		-1,
		129,
		145,
		137,
		108,
		120,
		-1,
		-1,
		111,
		109,
		119,
		103,
		90,
		110,
		113,
		103,
		87,
		102,
		114,
		122,
		127,
		-1,
		133,
		120,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		140,
		144,
		148,
		114,
		-1,
		119,
		114,
		94,
		108,
		115,
		105,
		100,
		94,
		97,
		115,
		132,
		-1,
		-1,
		145,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		119,
		133,
		137,
		130,
		134,
		-1,
		122,
		110,
		96,
		113,
		118,
		115,
		106,
		98,
		103,
		100,
		113,
		127,
		131,
		168,
		-1,
		151,
		-1,
		-1,
		-1,
		137,
		152,
		176,
		153,
		126,
		121,
		114,
		108,
		104,
		120,
		126,
		137,
		105,
		101,
		102,
		106,
		105,
		122,
		132,
		-1,
		-1,
		151,
		168,
		163,
		145,
		149,
		203,
		-1,
		-1,
		130,
		121,
		112,
		115,
		114,
		117,
		111,
		108,
		113,
		118,
		106,
		115,
		133,
		132,
		-1,
		-1,
		-1,
		171,
		-1,
		186,
		-1,
		-1,
		164,
		201,
		148,
		130,
		126,
		124,
		117,
		126,
		121,
		116,
		126,
		128,
		120,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		200,
		175,
		190,
		212,
		184,
		191,
		163,
		160,
		-1,
		130,
		155,
		127,
		134,
		125,
		132,
		132,
		124,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		206,
		192,
		198,
		188,
		191,
		-1,
		-1,
		179,
		176,
		152,
		135,
		133,
		126,
		121,
		131,
		111,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		178,
		259,
		252,
		235,
		243,
		274,
		-1,
		202,
		194,
		199,
		180,
		182,
		-1,
		-1,
		152,
		149,
		154,
		142,
		139,
		141,
		136,
		127,
		112,
		118,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		192,
		235,
		229,
		232,
		256,
		270,
		-1,
		199,
		-1,
		-1,
		207,
		183,
		167,
		157,
		151,
		201,
		156,
		151,
		135,
		133,
		124,
		115,
		122,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		227,
		215,
		223,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		223,
		-1,
		194,
		-1,
		169,
		173,
		164,
		167,
		149,
		136,
		128,
		120,
		136,
		111,
		121,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		270,
		226,
		223,
		214,
		251,
		266,
		270,
		-1,
		211,
		250,
		248,
		-1,
		232,
		-1,
		-1,
		-1,
		183,
		177,
		169,
		169,
		148,
		148,
		122,
		126,
		116,
		123,
		133,
		135,
		127,
		131,
		144,
		155,
		158,
		266,
		257,
		270,
		215,
		215,
		236,
		245,
		266,
		226,
		217,
		244,
		255,
		244,
		239,
		226,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		155,
		143,
		126,
		127,
		123,
		126,
		141,
		144,
		134,
		132,
		126,
		158,
		-1,
		259,
		258,
		247,
		244,
		220,
		211,
		206,
		233,
		-1,
		-1,
		228,
		245,
		239,
		243,
		259,
		284,
		-1,
		215,
		-1,
		-1,
		200,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		131,
		142,
		152,
		140,
		141,
		131,
		141,
		154,
		243,
		240,
		228,
		226,
		249,
		214,
		202,
		-1,
		215,
		213,
		219,
		226,
		243,
		273,
		-1,
		-1,
		231,
		211,
		-1,
		-1,
		183,
		181,
		170,
		-1,
		160,
		133,
		138,
		158,
		160,
		149,
		143,
		137,
		144,
		143,
		151,
		159,
		252,
		266,
		255,
		251,
		250,
		258,
		207,
		200,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		-1,
		221,
		217,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		151,
		155,
		147,
		140,
		135,
		146,
		138,
		142,
		159,
		-1,
		286,
		-1,
		238,
		214,
		228,
		243,
		251,
		-1,
		-1,
		-1,
		238,
		224,
		217,
		205,
		203,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		141,
		152,
		141,
		144,
		158,
		153,
		-1,
		-1,
		226,
		229,
		-1,
		-1,
		228,
		230,
		-1,
		229,
		218,
		203,
		195,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		145,
		151,
		154,
		143,
		147,
		159,
		-1,
		-1,
		233,
		234,
		235,
		-1,
		213,
		-1,
		231,
		-1,
		198,
		204,
		192,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		174,
		172,
		163,
		149,
		156,
		154,
		150,
		161,
		-1,
		-1,
		-1,
		231,
		205,
		238,
		229,
		212,
		192,
		184,
		203,
		-1,
		173,
		-1,
		148,
		150,
		176,
		179,
		185,
		179,
		152,
		167,
		157,
		148,
		157,
		237,
		-1,
		207,
		240,
		204,
		198,
		174,
		178,
		194,
		-1,
		170,
		152,
		-1,
		180,
		170,
		201,
		186,
		167,
		154,
		161,
		161,
		154,
		-1,
		-1,
		-1,
		209,
		208,
		200,
		194,
		194,
		179,
		170,
		-1,
		182,
		164,
		143,
		160,
		160,
		151,
		159,
		191,
		187,
		174,
		174,
		166,
		-1,
		310,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		203,
		198,
		171,
		159,
		165,
		161,
		147,
		153,
		155,
		163,
		161,
		158,
		170,
		166,
		186,
		167,
		202,
		-1,
		305,
		-1,
		239,
		-1,
		-1,
		221,
		201,
		193,
		182,
		171,
		169,
		160,
		151,
		173,
		189,
		173,
		171,
		174,
		175,
		-1,
		294,
		293,
		-1,
		240,
		232,
		218,
		-1,
		211,
		-1,
		217,
		178,
		-1,
		180,
		160,
		-1,
		182,
		178,
		-1,
		-1,
		281,
		256,
		-1,
		-1,
		-1,
		241,
		221,
		212,
		196,
		-1,
		171,
		171,
		-1,
		-1,
		-1,
		266,
		265,
		-1,
		234,
		237,
		-1,
		227,
		218,
		226,
		173,
		177,
		-1,
		-1,
		-1,
		275,
		256,
		250,
		249,
		247,
		242,
		239,
		225,
		209,
		187,
		176,
		197,
		-1,
		-1,
		-1,
		247,
		239,
		232,
		-1,
		-1,
		234,
		217,
		198,
		196,
		-1,
		-1,
		-1,
		269,
		250,
		-1,
		-1,
		224,
		-1,
		-1,
		230,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		258,
		-1,
		-1,
		-1,
		220,
		216,
		217,
		-1,
		-1,
		-1,
		-1,
		280,
		281,
		304,
		268,
		-1,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		283,
		281,
		-1,
		-1,
		-1,
		240,
		224,
		-1,
		210,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		245,
		-1,
		245,
		220,
		227,
		-1,
		-1,
		-1,
		-1,
		258,
		250,
		258,
		-1,
		230,
		232,
		-1,
		280,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		235,
		242,
		264,
		267,
		303,
		-1,
		254
	],
	[
		-1,
		138,
		127,
		138,
		146,
		119,
		126,
		-1,
		147,
		149,
		115,
		109,
		148,
		119,
		125,
		136,
		-1,
		-1,
		-1,
		138,
		137,
		107,
		105,
		114,
		119,
		126,
		-1,
		149,
		-1,
		159,
		138,
		149,
		154,
		100,
		97,
		117,
		136,
		142,
		134,
		174,
		130,
		101,
		95,
		113,
		118,
		136,
		128,
		-1,
		101,
		91,
		113,
		117,
		129,
		112,
		-1,
		-1,
		95,
		96,
		102,
		114,
		119,
		122,
		-1,
		132,
		116,
		-1,
		-1,
		85,
		98,
		94,
		97,
		105,
		111,
		124,
		116,
		111,
		-1,
		-1,
		86,
		90,
		103,
		98,
		94,
		111,
		124,
		106,
		120,
		119,
		-1,
		74,
		92,
		101,
		105,
		103,
		87,
		85,
		103,
		105,
		111,
		114,
		-1,
		83,
		84,
		85,
		93,
		98,
		103,
		90,
		90,
		100,
		93,
		112,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		83,
		66,
		83,
		80,
		73,
		86,
		88,
		93,
		90,
		88,
		85,
		101,
		102,
		112,
		-1,
		-1,
		177,
		150,
		174,
		132,
		113,
		-1,
		79,
		59,
		65,
		69,
		71,
		71,
		85,
		81,
		-1,
		79,
		78,
		109,
		95,
		106,
		159,
		-1,
		-1,
		135,
		127,
		109,
		112,
		89,
		85,
		74,
		73,
		65,
		51,
		47,
		68,
		71,
		71,
		77,
		73,
		83,
		87,
		98,
		113,
		-1,
		-1,
		168,
		-1,
		-1,
		156,
		139,
		-1,
		104,
		111,
		95,
		101,
		87,
		108,
		84,
		75,
		67,
		61,
		49,
		62,
		63,
		76,
		69,
		70,
		95,
		99,
		93,
		114,
		109,
		-1,
		167,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		111,
		108,
		101,
		125,
		124,
		-1,
		96,
		84,
		85,
		70,
		66,
		53,
		42,
		54,
		55,
		68,
		72,
		77,
		79,
		112,
		90,
		112,
		109,
		138,
		143,
		137,
		146,
		-1,
		164,
		160,
		156,
		163,
		112,
		-1,
		-1,
		129,
		-1,
		132,
		133,
		108,
		81,
		84,
		71,
		62,
		48,
		38,
		48,
		53,
		50,
		70,
		79,
		90,
		85,
		84,
		102,
		117,
		130,
		134,
		140,
		-1,
		214,
		-1,
		156,
		140,
		142,
		116,
		137,
		-1,
		149,
		133,
		125,
		110,
		110,
		-1,
		80,
		77,
		67,
		45,
		30,
		47,
		50,
		54,
		69,
		74,
		88,
		79,
		97,
		104,
		112,
		116,
		136,
		148,
		174,
		164,
		-1,
		146,
		151,
		112,
		120,
		139,
		176,
		141,
		-1,
		121,
		-1,
		82,
		95,
		-1,
		51,
		41,
		20,
		37,
		51,
		64,
		73,
		70,
		67,
		85,
		88,
		105,
		109,
		125,
		-1,
		-1,
		159,
		163,
		154,
		105,
		124,
		148,
		185,
		134,
		123,
		122,
		-1,
		100,
		37,
		34,
		20,
		0,
		21,
		31,
		52,
		71,
		50,
		69,
		72,
		94,
		122,
		100,
		112,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		131,
		102,
		126,
		168,
		152,
		145,
		133,
		98,
		98,
		92,
		-1,
		31,
		10,
		12,
		35,
		39,
		53,
		55,
		69,
		73,
		72,
		91,
		103,
		94,
		114,
		-1,
		-1,
		-1,
		161,
		150,
		151,
		97,
		120,
		157,
		131,
		117,
		122,
		97,
		90,
		83,
		46,
		27,
		22,
		24,
		33,
		35,
		51,
		59,
		61,
		70,
		79,
		85,
		109,
		116,
		122,
		-1,
		-1,
		168,
		158,
		142,
		144,
		141,
		111,
		118,
		150,
		122,
		135,
		-1,
		88,
		-1,
		77,
		45,
		39,
		36,
		41,
		47,
		42,
		51,
		65,
		76,
		72,
		79,
		114,
		114,
		106,
		126,
		129,
		-1,
		-1,
		-1,
		161,
		156,
		131,
		108,
		92,
		128,
		-1,
		105,
		106,
		-1,
		82,
		76,
		49,
		42,
		36,
		52,
		53,
		49,
		52,
		52,
		66,
		77,
		64,
		100,
		-1,
		114,
		108,
		116,
		106,
		94,
		-1,
		-1,
		-1,
		154,
		133,
		126,
		146,
		87,
		139,
		-1,
		-1,
		90,
		83,
		-1,
		60,
		52,
		57,
		52,
		53,
		57,
		61,
		50,
		63,
		68,
		69,
		79,
		99,
		103,
		107,
		96,
		92,
		89,
		103,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		107,
		-1,
		99,
		91,
		81,
		75,
		69,
		65,
		63,
		81,
		65,
		68,
		68,
		64,
		72,
		57,
		60,
		72,
		76,
		94,
		102,
		94,
		88,
		87,
		99,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		120,
		-1,
		84,
		98,
		114,
		-1,
		107,
		86,
		101,
		79,
		75,
		69,
		88,
		89,
		67,
		72,
		71,
		81,
		82,
		71,
		84,
		76,
		98,
		98,
		82,
		83,
		92,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		81,
		69,
		101,
		-1,
		-1,
		143,
		-1,
		77,
		94,
		83,
		81,
		78,
		69,
		75,
		82,
		85,
		86,
		76,
		65,
		71,
		70,
		92,
		78,
		76,
		95,
		111,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		121,
		111,
		95,
		80,
		113,
		-1,
		86,
		70,
		75,
		-1,
		111,
		-1,
		84,
		86,
		78,
		67,
		64,
		75,
		73,
		84,
		101,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		138,
		-1,
		-1,
		108,
		102,
		102,
		86,
		89,
		102,
		82,
		76,
		75,
		106,
		104,
		92,
		76,
		69,
		66,
		67,
		80,
		100,
		91,
		103,
		-1,
		-1,
		-1,
		135,
		121,
		125,
		85,
		104,
		-1,
		-1,
		170,
		125,
		111,
		-1,
		95,
		119,
		107,
		97,
		87,
		121,
		120,
		95,
		88,
		74,
		76,
		74,
		76,
		81,
		102,
		103,
		116,
		-1,
		-1,
		118,
		123,
		111,
		97,
		116,
		-1,
		-1,
		-1,
		117,
		133,
		125,
		96,
		108,
		-1,
		-1,
		99,
		97,
		107,
		91,
		78,
		98,
		101,
		91,
		75,
		90,
		102,
		110,
		115,
		-1,
		121,
		108,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		128,
		132,
		136,
		102,
		-1,
		107,
		102,
		82,
		96,
		103,
		93,
		88,
		82,
		85,
		103,
		120,
		-1,
		-1,
		133,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		107,
		121,
		125,
		118,
		122,
		-1,
		110,
		98,
		84,
		101,
		106,
		103,
		94,
		86,
		91,
		88,
		101,
		115,
		119,
		156,
		-1,
		139,
		-1,
		-1,
		-1,
		125,
		140,
		164,
		141,
		114,
		109,
		102,
		96,
		92,
		108,
		114,
		125,
		93,
		89,
		90,
		94,
		93,
		110,
		120,
		-1,
		-1,
		139,
		156,
		151,
		133,
		137,
		191,
		-1,
		-1,
		118,
		109,
		100,
		103,
		102,
		105,
		99,
		96,
		101,
		106,
		94,
		103,
		121,
		120,
		-1,
		-1,
		-1,
		159,
		-1,
		174,
		-1,
		-1,
		152,
		189,
		136,
		118,
		114,
		112,
		105,
		114,
		109,
		104,
		114,
		116,
		108,
		96,
		100,
		123,
		112,
		151,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		188,
		163,
		178,
		200,
		172,
		179,
		151,
		148,
		-1,
		118,
		143,
		115,
		122,
		113,
		120,
		120,
		112,
		90,
		97,
		113,
		112,
		107,
		143,
		134,
		140,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		194,
		180,
		186,
		176,
		179,
		-1,
		-1,
		167,
		164,
		140,
		123,
		121,
		114,
		109,
		119,
		99,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		166,
		247,
		240,
		223,
		231,
		262,
		-1,
		190,
		182,
		187,
		168,
		170,
		-1,
		-1,
		140,
		137,
		142,
		130,
		127,
		129,
		124,
		115,
		100,
		106,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		180,
		223,
		217,
		220,
		244,
		258,
		-1,
		187,
		-1,
		-1,
		195,
		171,
		155,
		145,
		139,
		189,
		144,
		139,
		123,
		121,
		112,
		103,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		215,
		203,
		211,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		211,
		-1,
		182,
		-1,
		157,
		161,
		152,
		155,
		137,
		124,
		116,
		108,
		124,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		258,
		214,
		211,
		202,
		239,
		254,
		258,
		-1,
		199,
		238,
		236,
		-1,
		220,
		-1,
		-1,
		-1,
		171,
		165,
		157,
		157,
		136,
		136,
		110,
		114,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		254,
		245,
		258,
		203,
		203,
		224,
		233,
		254,
		214,
		205,
		232,
		243,
		232,
		227,
		214,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		143,
		131,
		114,
		115,
		111,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		247,
		246,
		235,
		232,
		208,
		199,
		194,
		221,
		-1,
		-1,
		216,
		233,
		227,
		231,
		247,
		272,
		-1,
		203,
		-1,
		-1,
		188,
		-1,
		-1,
		173,
		136,
		125,
		116,
		122,
		119,
		130,
		140,
		128,
		129,
		119,
		129,
		142,
		231,
		228,
		216,
		214,
		237,
		202,
		190,
		-1,
		203,
		201,
		207,
		214,
		231,
		261,
		-1,
		-1,
		219,
		199,
		-1,
		-1,
		171,
		169,
		158,
		-1,
		148,
		121,
		126,
		146,
		148,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		240,
		254,
		243,
		239,
		238,
		246,
		195,
		188,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		205,
		-1,
		-1,
		166,
		159,
		147,
		135,
		125,
		135,
		139,
		143,
		135,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		274,
		-1,
		226,
		202,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		200,
		184,
		165,
		-1,
		135,
		148,
		179,
		147,
		152,
		147,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		214,
		217,
		-1,
		-1,
		216,
		218,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		172,
		168,
		-1,
		-1,
		136,
		161,
		150,
		158,
		153,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		221,
		222,
		223,
		-1,
		201,
		-1,
		219,
		-1,
		186,
		192,
		180,
		-1,
		-1,
		-1,
		174,
		137,
		158,
		168,
		162,
		160,
		151,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		219,
		193,
		226,
		217,
		200,
		180,
		172,
		191,
		-1,
		161,
		-1,
		136,
		138,
		164,
		167,
		173,
		167,
		140,
		155,
		145,
		136,
		145,
		225,
		-1,
		195,
		228,
		192,
		186,
		162,
		166,
		182,
		-1,
		158,
		140,
		-1,
		168,
		158,
		189,
		174,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		182,
		167,
		158,
		-1,
		170,
		152,
		131,
		148,
		148,
		139,
		147,
		179,
		175,
		162,
		162,
		154,
		-1,
		298,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		186,
		159,
		147,
		153,
		149,
		135,
		141,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		155,
		190,
		-1,
		293,
		-1,
		227,
		-1,
		-1,
		209,
		189,
		181,
		170,
		159,
		157,
		148,
		139,
		161,
		177,
		161,
		159,
		162,
		163,
		-1,
		282,
		281,
		-1,
		228,
		220,
		206,
		-1,
		199,
		-1,
		205,
		166,
		-1,
		168,
		148,
		-1,
		170,
		166,
		-1,
		-1,
		269,
		244,
		-1,
		-1,
		-1,
		229,
		209,
		200,
		184,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		254,
		253,
		-1,
		222,
		225,
		-1,
		215,
		206,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		263,
		244,
		238,
		237,
		235,
		230,
		227,
		213,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		235,
		227,
		220,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		246,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		292,
		256,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		127,
		116,
		127,
		135,
		108,
		115,
		-1,
		136,
		138,
		104,
		98,
		137,
		108,
		114,
		125,
		-1,
		-1,
		-1,
		127,
		126,
		96,
		94,
		103,
		108,
		115,
		-1,
		138,
		-1,
		148,
		127,
		138,
		143,
		89,
		86,
		106,
		125,
		131,
		123,
		163,
		119,
		90,
		84,
		102,
		107,
		125,
		117,
		-1,
		90,
		80,
		102,
		105,
		116,
		101,
		-1,
		-1,
		84,
		85,
		91,
		101,
		107,
		103,
		-1,
		113,
		97,
		-1,
		-1,
		74,
		87,
		83,
		86,
		94,
		92,
		105,
		97,
		92,
		-1,
		-1,
		75,
		79,
		92,
		79,
		75,
		92,
		105,
		87,
		101,
		100,
		-1,
		63,
		81,
		90,
		86,
		84,
		68,
		66,
		84,
		86,
		92,
		95,
		-1,
		72,
		73,
		74,
		82,
		87,
		84,
		71,
		71,
		81,
		74,
		93,
		84,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		72,
		55,
		72,
		69,
		62,
		75,
		81,
		74,
		71,
		69,
		66,
		82,
		83,
		93,
		-1,
		-1,
		166,
		139,
		163,
		121,
		102,
		-1,
		68,
		48,
		54,
		58,
		60,
		62,
		78,
		74,
		-1,
		60,
		59,
		90,
		76,
		87,
		144,
		-1,
		-1,
		124,
		116,
		98,
		101,
		78,
		74,
		63,
		62,
		54,
		40,
		36,
		61,
		64,
		64,
		70,
		54,
		64,
		68,
		79,
		94,
		-1,
		-1,
		149,
		-1,
		-1,
		141,
		124,
		-1,
		93,
		100,
		84,
		90,
		76,
		97,
		73,
		64,
		56,
		50,
		38,
		51,
		56,
		69,
		57,
		51,
		76,
		80,
		74,
		95,
		90,
		-1,
		148,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		100,
		97,
		90,
		114,
		113,
		-1,
		85,
		73,
		74,
		59,
		56,
		43,
		31,
		44,
		48,
		55,
		54,
		58,
		60,
		93,
		71,
		93,
		90,
		119,
		124,
		118,
		127,
		-1,
		149,
		145,
		141,
		148,
		97,
		-1,
		-1,
		118,
		-1,
		121,
		122,
		97,
		70,
		73,
		60,
		51,
		38,
		27,
		38,
		46,
		43,
		51,
		60,
		71,
		66,
		65,
		83,
		98,
		111,
		115,
		121,
		-1,
		199,
		-1,
		141,
		125,
		127,
		99,
		120,
		-1,
		138,
		122,
		114,
		99,
		99,
		-1,
		69,
		66,
		56,
		34,
		19,
		36,
		47,
		45,
		50,
		55,
		69,
		60,
		78,
		85,
		93,
		97,
		117,
		129,
		159,
		149,
		-1,
		131,
		136,
		95,
		103,
		122,
		160,
		124,
		-1,
		110,
		-1,
		71,
		84,
		-1,
		40,
		36,
		17,
		19,
		33,
		48,
		54,
		51,
		48,
		66,
		69,
		86,
		90,
		106,
		-1,
		-1,
		144,
		148,
		137,
		88,
		107,
		131,
		168,
		117,
		106,
		105,
		-1,
		89,
		49,
		46,
		34,
		21,
		0,
		12,
		37,
		52,
		31,
		50,
		53,
		75,
		103,
		81,
		93,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		114,
		85,
		109,
		151,
		135,
		128,
		116,
		81,
		81,
		75,
		-1,
		45,
		24,
		20,
		16,
		23,
		36,
		36,
		50,
		54,
		53,
		72,
		84,
		75,
		95,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		80,
		103,
		140,
		114,
		100,
		105,
		80,
		73,
		67,
		58,
		41,
		36,
		32,
		25,
		16,
		32,
		40,
		42,
		51,
		60,
		66,
		90,
		97,
		103,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		94,
		101,
		133,
		105,
		118,
		-1,
		72,
		-1,
		61,
		56,
		40,
		35,
		32,
		29,
		23,
		32,
		46,
		57,
		53,
		60,
		95,
		95,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		144,
		139,
		114,
		91,
		75,
		111,
		-1,
		88,
		89,
		-1,
		66,
		60,
		57,
		42,
		38,
		33,
		37,
		30,
		37,
		33,
		47,
		58,
		45,
		81,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		137,
		116,
		109,
		129,
		70,
		122,
		-1,
		-1,
		73,
		66,
		-1,
		53,
		35,
		42,
		40,
		34,
		38,
		42,
		31,
		44,
		49,
		50,
		60,
		80,
		84,
		88,
		77,
		73,
		70,
		84,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		90,
		-1,
		82,
		74,
		64,
		58,
		52,
		48,
		46,
		62,
		46,
		49,
		49,
		45,
		53,
		38,
		41,
		53,
		57,
		75,
		83,
		75,
		69,
		68,
		80,
		-1,
		157,
		143,
		114,
		-1,
		-1,
		103,
		-1,
		67,
		81,
		97,
		-1,
		90,
		69,
		84,
		62,
		58,
		54,
		69,
		70,
		48,
		53,
		52,
		62,
		63,
		52,
		65,
		57,
		79,
		79,
		63,
		64,
		73,
		-1,
		163,
		150,
		108,
		104,
		93,
		113,
		64,
		52,
		84,
		-1,
		-1,
		126,
		-1,
		60,
		77,
		68,
		66,
		59,
		50,
		56,
		63,
		66,
		67,
		57,
		46,
		52,
		51,
		73,
		59,
		57,
		76,
		92,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		79,
		66,
		60,
		-1,
		101,
		-1,
		104,
		94,
		78,
		63,
		96,
		-1,
		67,
		51,
		56,
		-1,
		92,
		-1,
		65,
		67,
		59,
		48,
		45,
		56,
		54,
		65,
		82,
		-1,
		113,
		98,
		91,
		81,
		95,
		66,
		-1,
		121,
		-1,
		-1,
		91,
		85,
		85,
		69,
		72,
		83,
		63,
		57,
		56,
		87,
		85,
		73,
		57,
		50,
		47,
		48,
		61,
		81,
		72,
		84,
		-1,
		-1,
		-1,
		118,
		104,
		108,
		68,
		87,
		-1,
		-1,
		153,
		108,
		94,
		-1,
		78,
		100,
		88,
		78,
		68,
		102,
		101,
		76,
		69,
		55,
		57,
		55,
		57,
		62,
		83,
		84,
		97,
		-1,
		-1,
		101,
		106,
		94,
		80,
		99,
		-1,
		-1,
		-1,
		100,
		116,
		108,
		79,
		89,
		-1,
		-1,
		80,
		78,
		88,
		72,
		59,
		79,
		82,
		72,
		56,
		71,
		83,
		91,
		96,
		-1,
		104,
		91,
		-1,
		-1,
		102,
		96,
		-1,
		-1,
		-1,
		-1,
		133,
		99,
		111,
		113,
		117,
		83,
		-1,
		88,
		83,
		63,
		77,
		84,
		74,
		69,
		63,
		66,
		84,
		101,
		-1,
		-1,
		116,
		-1,
		111,
		-1,
		-1,
		-1,
		-1,
		90,
		104,
		106,
		99,
		103,
		-1,
		91,
		79,
		65,
		82,
		87,
		84,
		75,
		67,
		72,
		69,
		82,
		96,
		100,
		139,
		-1,
		122,
		-1,
		-1,
		-1,
		108,
		123,
		145,
		122,
		95,
		90,
		83,
		77,
		73,
		89,
		95,
		106,
		74,
		70,
		71,
		75,
		74,
		91,
		101,
		-1,
		-1,
		122,
		139,
		134,
		116,
		120,
		172,
		-1,
		-1,
		99,
		90,
		81,
		84,
		83,
		86,
		80,
		77,
		82,
		87,
		75,
		84,
		102,
		101,
		-1,
		-1,
		-1,
		142,
		-1,
		157,
		-1,
		-1,
		135,
		170,
		117,
		99,
		95,
		93,
		86,
		95,
		90,
		85,
		95,
		97,
		89,
		77,
		81,
		104,
		93,
		132,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		171,
		146,
		161,
		181,
		155,
		162,
		132,
		129,
		-1,
		99,
		124,
		96,
		103,
		94,
		101,
		101,
		93,
		71,
		78,
		94,
		93,
		88,
		124,
		115,
		121,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		177,
		163,
		167,
		157,
		160,
		-1,
		-1,
		148,
		145,
		121,
		104,
		102,
		95,
		90,
		100,
		80,
		67,
		71,
		75,
		81,
		86,
		91,
		97,
		112,
		127,
		-1,
		149,
		230,
		223,
		206,
		214,
		245,
		-1,
		171,
		163,
		170,
		149,
		151,
		-1,
		-1,
		121,
		118,
		123,
		111,
		108,
		110,
		105,
		96,
		81,
		87,
		74,
		73,
		91,
		95,
		104,
		111,
		101,
		114,
		118,
		-1,
		163,
		206,
		200,
		203,
		227,
		241,
		-1,
		168,
		-1,
		-1,
		178,
		152,
		136,
		126,
		120,
		170,
		125,
		120,
		104,
		102,
		93,
		84,
		91,
		82,
		82,
		85,
		100,
		105,
		97,
		111,
		111,
		112,
		-1,
		198,
		186,
		194,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		194,
		-1,
		163,
		-1,
		138,
		142,
		133,
		136,
		118,
		105,
		97,
		89,
		105,
		80,
		90,
		86,
		87,
		96,
		107,
		119,
		118,
		119,
		239,
		195,
		194,
		185,
		220,
		235,
		239,
		-1,
		180,
		219,
		217,
		-1,
		201,
		-1,
		-1,
		-1,
		152,
		146,
		138,
		138,
		117,
		117,
		91,
		95,
		85,
		92,
		102,
		104,
		96,
		100,
		113,
		124,
		127,
		235,
		226,
		239,
		184,
		184,
		205,
		214,
		235,
		195,
		186,
		213,
		224,
		213,
		208,
		195,
		-1,
		-1,
		175,
		156,
		-1,
		-1,
		124,
		112,
		95,
		96,
		92,
		95,
		110,
		113,
		103,
		101,
		95,
		127,
		-1,
		228,
		227,
		216,
		213,
		189,
		180,
		175,
		202,
		-1,
		-1,
		197,
		214,
		208,
		212,
		228,
		253,
		-1,
		184,
		-1,
		-1,
		169,
		-1,
		-1,
		154,
		117,
		106,
		97,
		103,
		100,
		111,
		121,
		109,
		110,
		100,
		110,
		123,
		212,
		209,
		197,
		195,
		218,
		183,
		171,
		-1,
		184,
		182,
		188,
		195,
		212,
		242,
		-1,
		-1,
		200,
		180,
		-1,
		-1,
		152,
		150,
		139,
		-1,
		129,
		102,
		107,
		127,
		129,
		118,
		112,
		106,
		113,
		112,
		120,
		128,
		221,
		235,
		224,
		220,
		219,
		227,
		176,
		169,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		147,
		140,
		128,
		116,
		106,
		116,
		120,
		124,
		116,
		109,
		104,
		115,
		107,
		111,
		128,
		-1,
		255,
		-1,
		207,
		183,
		197,
		212,
		220,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		181,
		165,
		146,
		-1,
		116,
		129,
		160,
		128,
		133,
		128,
		110,
		121,
		110,
		113,
		127,
		122,
		-1,
		-1,
		195,
		198,
		-1,
		-1,
		197,
		199,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		153,
		149,
		-1,
		-1,
		117,
		142,
		131,
		139,
		134,
		114,
		120,
		123,
		112,
		116,
		128,
		-1,
		-1,
		202,
		203,
		204,
		-1,
		182,
		-1,
		200,
		-1,
		167,
		173,
		161,
		-1,
		-1,
		-1,
		155,
		118,
		139,
		149,
		143,
		141,
		132,
		118,
		125,
		123,
		119,
		130,
		-1,
		-1,
		-1,
		200,
		174,
		207,
		198,
		181,
		161,
		153,
		172,
		-1,
		142,
		-1,
		117,
		119,
		145,
		148,
		154,
		148,
		121,
		136,
		126,
		117,
		126,
		206,
		-1,
		176,
		209,
		173,
		167,
		143,
		147,
		163,
		-1,
		139,
		121,
		-1,
		149,
		139,
		170,
		155,
		136,
		123,
		130,
		130,
		123,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		163,
		148,
		139,
		-1,
		151,
		133,
		112,
		129,
		129,
		120,
		128,
		160,
		156,
		143,
		143,
		135,
		-1,
		279,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		167,
		140,
		128,
		134,
		130,
		116,
		122,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		136,
		171,
		-1,
		274,
		-1,
		208,
		-1,
		-1,
		190,
		170,
		162,
		151,
		140,
		138,
		129,
		120,
		142,
		158,
		142,
		140,
		143,
		144,
		-1,
		263,
		262,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		186,
		147,
		-1,
		149,
		129,
		-1,
		151,
		147,
		-1,
		-1,
		250,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		181,
		165,
		-1,
		140,
		140,
		-1,
		-1,
		-1,
		235,
		234,
		-1,
		203,
		206,
		-1,
		196,
		187,
		195,
		142,
		146,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		218,
		216,
		211,
		208,
		194,
		178,
		156,
		145,
		166,
		-1,
		-1,
		-1,
		216,
		208,
		201,
		-1,
		-1,
		203,
		186,
		167,
		165,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		193,
		-1,
		-1,
		199,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		227,
		-1,
		-1,
		-1,
		189,
		185,
		186,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		273,
		237,
		-1,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		179,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		214,
		-1,
		214,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		227,
		219,
		227,
		-1,
		199,
		201,
		-1,
		249,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		204,
		211,
		233,
		236,
		272,
		-1,
		223
	],
	[
		-1,
		129,
		118,
		129,
		137,
		110,
		117,
		-1,
		138,
		140,
		106,
		100,
		139,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		129,
		128,
		98,
		96,
		105,
		110,
		117,
		-1,
		132,
		-1,
		150,
		129,
		140,
		145,
		91,
		88,
		108,
		127,
		125,
		117,
		165,
		121,
		92,
		86,
		104,
		109,
		119,
		111,
		-1,
		92,
		82,
		104,
		99,
		110,
		102,
		-1,
		-1,
		86,
		87,
		93,
		95,
		101,
		97,
		-1,
		107,
		91,
		-1,
		-1,
		76,
		89,
		77,
		80,
		88,
		86,
		99,
		91,
		86,
		-1,
		-1,
		77,
		79,
		86,
		73,
		69,
		86,
		99,
		81,
		95,
		94,
		-1,
		65,
		83,
		92,
		80,
		78,
		62,
		60,
		78,
		80,
		86,
		89,
		-1,
		74,
		75,
		76,
		84,
		89,
		78,
		65,
		65,
		75,
		68,
		87,
		78,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		74,
		57,
		74,
		71,
		64,
		77,
		75,
		68,
		65,
		63,
		60,
		76,
		77,
		87,
		-1,
		-1,
		168,
		141,
		165,
		123,
		104,
		-1,
		70,
		50,
		56,
		60,
		62,
		58,
		72,
		68,
		-1,
		54,
		53,
		84,
		70,
		81,
		146,
		-1,
		-1,
		126,
		118,
		100,
		103,
		80,
		76,
		65,
		64,
		56,
		42,
		38,
		55,
		58,
		58,
		64,
		48,
		58,
		62,
		77,
		88,
		-1,
		-1,
		151,
		-1,
		-1,
		143,
		126,
		-1,
		95,
		102,
		86,
		92,
		78,
		99,
		75,
		66,
		58,
		52,
		40,
		53,
		50,
		63,
		51,
		45,
		70,
		74,
		76,
		97,
		92,
		-1,
		150,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		99,
		92,
		116,
		115,
		-1,
		87,
		75,
		76,
		61,
		58,
		45,
		33,
		46,
		42,
		49,
		48,
		52,
		54,
		87,
		73,
		95,
		92,
		121,
		126,
		120,
		129,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		120,
		-1,
		123,
		124,
		99,
		72,
		75,
		62,
		53,
		40,
		29,
		40,
		40,
		37,
		45,
		58,
		65,
		68,
		67,
		85,
		100,
		113,
		117,
		123,
		-1,
		201,
		-1,
		143,
		127,
		129,
		101,
		122,
		-1,
		140,
		124,
		116,
		101,
		101,
		-1,
		71,
		68,
		58,
		36,
		21,
		38,
		39,
		34,
		44,
		57,
		71,
		62,
		80,
		87,
		95,
		99,
		119,
		131,
		161,
		151,
		-1,
		133,
		138,
		97,
		105,
		124,
		162,
		126,
		-1,
		112,
		-1,
		73,
		86,
		-1,
		42,
		38,
		15,
		8,
		22,
		39,
		51,
		53,
		50,
		68,
		71,
		88,
		92,
		108,
		-1,
		-1,
		146,
		150,
		139,
		90,
		109,
		133,
		170,
		119,
		108,
		107,
		-1,
		91,
		51,
		48,
		36,
		23,
		8,
		0,
		28,
		47,
		33,
		52,
		55,
		77,
		105,
		83,
		95,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		116,
		87,
		111,
		153,
		137,
		130,
		118,
		83,
		83,
		77,
		-1,
		47,
		26,
		22,
		18,
		25,
		38,
		38,
		52,
		56,
		55,
		74,
		86,
		77,
		97,
		-1,
		-1,
		-1,
		146,
		135,
		136,
		82,
		105,
		142,
		116,
		102,
		107,
		82,
		75,
		69,
		60,
		43,
		38,
		34,
		27,
		18,
		34,
		42,
		44,
		53,
		62,
		68,
		92,
		99,
		105,
		-1,
		-1,
		153,
		143,
		127,
		129,
		126,
		96,
		103,
		135,
		107,
		120,
		-1,
		74,
		-1,
		63,
		58,
		42,
		37,
		34,
		31,
		25,
		34,
		48,
		59,
		55,
		62,
		97,
		97,
		89,
		109,
		112,
		-1,
		-1,
		-1,
		146,
		141,
		116,
		93,
		77,
		113,
		-1,
		90,
		91,
		-1,
		68,
		62,
		59,
		44,
		40,
		35,
		39,
		32,
		39,
		35,
		49,
		60,
		47,
		83,
		-1,
		97,
		91,
		99,
		89,
		77,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		72,
		124,
		-1,
		-1,
		75,
		68,
		-1,
		55,
		37,
		44,
		42,
		36,
		40,
		44,
		33,
		46,
		51,
		52,
		62,
		82,
		86,
		90,
		79,
		75,
		72,
		86,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		92,
		-1,
		84,
		76,
		66,
		60,
		54,
		50,
		48,
		64,
		48,
		51,
		51,
		47,
		55,
		40,
		43,
		55,
		59,
		77,
		85,
		77,
		71,
		70,
		82,
		-1,
		159,
		145,
		116,
		-1,
		-1,
		105,
		-1,
		69,
		83,
		99,
		-1,
		92,
		71,
		86,
		64,
		60,
		56,
		71,
		72,
		50,
		55,
		54,
		64,
		65,
		54,
		67,
		59,
		81,
		81,
		65,
		66,
		75,
		-1,
		165,
		152,
		110,
		106,
		95,
		115,
		66,
		54,
		86,
		-1,
		-1,
		128,
		-1,
		62,
		79,
		70,
		68,
		61,
		52,
		58,
		65,
		68,
		69,
		59,
		48,
		54,
		53,
		75,
		61,
		59,
		78,
		94,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		68,
		62,
		-1,
		103,
		-1,
		106,
		96,
		80,
		65,
		98,
		-1,
		69,
		53,
		58,
		-1,
		94,
		-1,
		67,
		69,
		61,
		50,
		47,
		58,
		56,
		67,
		84,
		-1,
		115,
		100,
		93,
		83,
		97,
		68,
		-1,
		123,
		-1,
		-1,
		93,
		87,
		87,
		71,
		74,
		85,
		65,
		59,
		58,
		89,
		87,
		75,
		59,
		52,
		49,
		50,
		63,
		83,
		74,
		86,
		-1,
		-1,
		-1,
		120,
		106,
		110,
		70,
		89,
		-1,
		-1,
		155,
		110,
		96,
		-1,
		80,
		102,
		90,
		80,
		70,
		104,
		103,
		78,
		71,
		57,
		59,
		57,
		59,
		64,
		85,
		86,
		99,
		-1,
		-1,
		103,
		108,
		96,
		82,
		101,
		-1,
		-1,
		-1,
		102,
		118,
		110,
		81,
		91,
		-1,
		-1,
		82,
		80,
		90,
		74,
		61,
		81,
		84,
		74,
		58,
		73,
		85,
		93,
		98,
		-1,
		106,
		93,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		113,
		115,
		119,
		85,
		-1,
		90,
		85,
		65,
		79,
		86,
		76,
		71,
		65,
		68,
		86,
		103,
		-1,
		-1,
		118,
		-1,
		113,
		-1,
		-1,
		-1,
		-1,
		92,
		106,
		108,
		101,
		105,
		-1,
		93,
		81,
		67,
		84,
		89,
		86,
		77,
		69,
		74,
		71,
		84,
		98,
		102,
		141,
		-1,
		124,
		-1,
		-1,
		-1,
		110,
		125,
		147,
		124,
		97,
		92,
		85,
		79,
		75,
		91,
		97,
		108,
		76,
		72,
		73,
		77,
		76,
		93,
		103,
		-1,
		-1,
		124,
		141,
		136,
		118,
		122,
		174,
		-1,
		-1,
		101,
		92,
		83,
		86,
		85,
		88,
		82,
		79,
		84,
		89,
		77,
		86,
		104,
		103,
		-1,
		-1,
		-1,
		144,
		-1,
		159,
		-1,
		-1,
		137,
		172,
		119,
		101,
		97,
		95,
		88,
		97,
		92,
		87,
		97,
		99,
		91,
		79,
		83,
		106,
		95,
		134,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		173,
		148,
		163,
		183,
		157,
		164,
		134,
		131,
		-1,
		101,
		126,
		98,
		105,
		96,
		103,
		103,
		95,
		73,
		80,
		96,
		95,
		90,
		126,
		117,
		123,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		179,
		165,
		169,
		159,
		162,
		-1,
		-1,
		150,
		147,
		123,
		106,
		104,
		97,
		92,
		102,
		82,
		69,
		73,
		77,
		83,
		88,
		93,
		99,
		114,
		129,
		-1,
		151,
		232,
		225,
		208,
		216,
		247,
		-1,
		173,
		165,
		172,
		151,
		153,
		-1,
		-1,
		123,
		120,
		125,
		113,
		110,
		112,
		107,
		98,
		83,
		89,
		76,
		75,
		93,
		97,
		106,
		113,
		103,
		116,
		120,
		-1,
		165,
		208,
		202,
		205,
		229,
		243,
		-1,
		170,
		-1,
		-1,
		180,
		154,
		138,
		128,
		122,
		172,
		127,
		122,
		106,
		104,
		95,
		86,
		93,
		84,
		84,
		87,
		102,
		107,
		99,
		113,
		113,
		114,
		-1,
		200,
		188,
		196,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		196,
		-1,
		165,
		-1,
		140,
		144,
		135,
		138,
		120,
		107,
		99,
		91,
		107,
		82,
		92,
		88,
		89,
		98,
		109,
		121,
		120,
		121,
		241,
		197,
		196,
		187,
		222,
		237,
		241,
		-1,
		182,
		221,
		219,
		-1,
		203,
		-1,
		-1,
		-1,
		154,
		148,
		140,
		140,
		119,
		119,
		93,
		97,
		87,
		94,
		104,
		106,
		98,
		102,
		115,
		126,
		129,
		237,
		228,
		241,
		186,
		186,
		207,
		216,
		237,
		197,
		188,
		215,
		226,
		215,
		210,
		197,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		126,
		114,
		97,
		98,
		94,
		97,
		112,
		115,
		105,
		103,
		97,
		129,
		-1,
		230,
		229,
		218,
		215,
		191,
		182,
		177,
		204,
		-1,
		-1,
		199,
		216,
		210,
		214,
		230,
		255,
		-1,
		186,
		-1,
		-1,
		171,
		-1,
		-1,
		156,
		119,
		108,
		99,
		105,
		102,
		113,
		123,
		111,
		112,
		102,
		112,
		125,
		214,
		211,
		199,
		197,
		220,
		185,
		173,
		-1,
		186,
		184,
		190,
		197,
		214,
		244,
		-1,
		-1,
		202,
		182,
		-1,
		-1,
		154,
		152,
		141,
		-1,
		131,
		104,
		109,
		129,
		131,
		120,
		114,
		108,
		115,
		114,
		122,
		130,
		223,
		237,
		226,
		222,
		221,
		229,
		178,
		171,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		192,
		188,
		-1,
		-1,
		149,
		142,
		130,
		118,
		108,
		118,
		122,
		126,
		118,
		111,
		106,
		117,
		109,
		113,
		130,
		-1,
		257,
		-1,
		209,
		185,
		199,
		214,
		222,
		-1,
		-1,
		-1,
		209,
		195,
		188,
		176,
		174,
		-1,
		183,
		167,
		148,
		-1,
		118,
		131,
		162,
		130,
		135,
		130,
		112,
		123,
		112,
		115,
		129,
		124,
		-1,
		-1,
		197,
		200,
		-1,
		-1,
		199,
		201,
		-1,
		200,
		189,
		174,
		166,
		-1,
		-1,
		155,
		151,
		-1,
		-1,
		119,
		144,
		133,
		141,
		136,
		116,
		122,
		125,
		114,
		118,
		130,
		-1,
		-1,
		204,
		205,
		206,
		-1,
		184,
		-1,
		202,
		-1,
		169,
		175,
		163,
		-1,
		-1,
		-1,
		157,
		120,
		141,
		151,
		145,
		143,
		134,
		120,
		127,
		125,
		121,
		132,
		-1,
		-1,
		-1,
		202,
		176,
		209,
		200,
		183,
		163,
		155,
		174,
		-1,
		144,
		-1,
		119,
		121,
		147,
		150,
		156,
		150,
		123,
		138,
		128,
		119,
		128,
		208,
		-1,
		178,
		211,
		175,
		169,
		145,
		149,
		165,
		-1,
		141,
		123,
		-1,
		151,
		141,
		172,
		157,
		138,
		125,
		132,
		132,
		125,
		-1,
		-1,
		-1,
		180,
		179,
		171,
		165,
		165,
		150,
		141,
		-1,
		153,
		135,
		114,
		131,
		131,
		122,
		130,
		162,
		158,
		145,
		145,
		137,
		-1,
		281,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		174,
		169,
		142,
		130,
		136,
		132,
		118,
		124,
		126,
		134,
		132,
		129,
		141,
		137,
		157,
		138,
		173,
		-1,
		276,
		-1,
		210,
		-1,
		-1,
		192,
		172,
		164,
		153,
		142,
		140,
		131,
		122,
		144,
		160,
		144,
		142,
		145,
		146,
		-1,
		265,
		264,
		-1,
		211,
		203,
		189,
		-1,
		182,
		-1,
		188,
		149,
		-1,
		151,
		131,
		-1,
		153,
		149,
		-1,
		-1,
		252,
		227,
		-1,
		-1,
		-1,
		212,
		192,
		183,
		167,
		-1,
		142,
		142,
		-1,
		-1,
		-1,
		237,
		236,
		-1,
		205,
		208,
		-1,
		198,
		189,
		197,
		144,
		148,
		-1,
		-1,
		-1,
		246,
		227,
		221,
		220,
		218,
		213,
		210,
		196,
		180,
		158,
		147,
		168,
		-1,
		-1,
		-1,
		218,
		210,
		203,
		-1,
		-1,
		205,
		188,
		169,
		167,
		-1,
		-1,
		-1,
		240,
		221,
		-1,
		-1,
		195,
		-1,
		-1,
		201,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		229,
		-1,
		-1,
		-1,
		191,
		187,
		188,
		-1,
		-1,
		-1,
		-1,
		251,
		252,
		275,
		239,
		-1,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		254,
		252,
		-1,
		-1,
		-1,
		211,
		195,
		-1,
		181,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		216,
		-1,
		216,
		191,
		198,
		-1,
		-1,
		-1,
		-1,
		229,
		221,
		229,
		-1,
		201,
		203,
		-1,
		251,
		-1,
		-1,
		244,
		235,
		-1,
		-1,
		206,
		213,
		235,
		238,
		274,
		-1,
		225
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		138,
		142,
		108,
		102,
		141,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		131,
		130,
		98,
		96,
		105,
		110,
		117,
		-1,
		116,
		-1,
		152,
		131,
		142,
		147,
		91,
		88,
		108,
		127,
		109,
		101,
		167,
		121,
		92,
		86,
		104,
		94,
		103,
		95,
		-1,
		92,
		82,
		104,
		83,
		94,
		86,
		-1,
		-1,
		86,
		87,
		93,
		79,
		85,
		81,
		-1,
		91,
		75,
		-1,
		-1,
		76,
		77,
		61,
		64,
		72,
		70,
		83,
		75,
		70,
		-1,
		-1,
		67,
		63,
		70,
		57,
		53,
		70,
		83,
		65,
		79,
		78,
		-1,
		79,
		94,
		90,
		64,
		62,
		46,
		44,
		62,
		64,
		70,
		73,
		-1,
		89,
		90,
		65,
		73,
		78,
		62,
		49,
		49,
		59,
		52,
		71,
		62,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		89,
		72,
		79,
		61,
		51,
		66,
		59,
		52,
		49,
		47,
		44,
		60,
		61,
		71,
		-1,
		-1,
		183,
		156,
		180,
		138,
		119,
		-1,
		85,
		65,
		59,
		55,
		49,
		42,
		56,
		52,
		-1,
		38,
		37,
		68,
		54,
		65,
		149,
		-1,
		-1,
		141,
		133,
		115,
		118,
		95,
		91,
		80,
		79,
		72,
		64,
		60,
		39,
		42,
		42,
		48,
		32,
		42,
		46,
		61,
		72,
		-1,
		-1,
		146,
		-1,
		-1,
		146,
		129,
		-1,
		110,
		117,
		101,
		107,
		93,
		114,
		90,
		81,
		75,
		70,
		62,
		37,
		34,
		47,
		35,
		29,
		54,
		58,
		64,
		82,
		83,
		-1,
		145,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		105,
		108,
		107,
		131,
		130,
		-1,
		109,
		97,
		98,
		83,
		80,
		67,
		55,
		42,
		26,
		33,
		32,
		36,
		38,
		71,
		66,
		87,
		84,
		115,
		121,
		115,
		124,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		135,
		-1,
		138,
		146,
		121,
		94,
		97,
		84,
		75,
		62,
		51,
		43,
		24,
		21,
		29,
		42,
		49,
		63,
		62,
		80,
		93,
		108,
		112,
		118,
		-1,
		204,
		-1,
		146,
		130,
		132,
		104,
		125,
		-1,
		155,
		139,
		138,
		123,
		123,
		-1,
		93,
		90,
		80,
		58,
		43,
		36,
		23,
		18,
		28,
		49,
		66,
		57,
		75,
		82,
		90,
		94,
		114,
		126,
		164,
		154,
		-1,
		136,
		141,
		100,
		108,
		127,
		165,
		129,
		-1,
		124,
		-1,
		95,
		108,
		-1,
		64,
		60,
		34,
		17,
		6,
		23,
		35,
		48,
		45,
		63,
		66,
		83,
		87,
		103,
		-1,
		-1,
		149,
		153,
		142,
		93,
		112,
		136,
		173,
		122,
		111,
		110,
		-1,
		101,
		70,
		67,
		58,
		45,
		35,
		29,
		0,
		31,
		36,
		47,
		50,
		72,
		100,
		78,
		90,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		119,
		90,
		114,
		156,
		140,
		133,
		121,
		86,
		86,
		80,
		-1,
		69,
		48,
		38,
		29,
		19,
		35,
		40,
		55,
		51,
		53,
		69,
		81,
		72,
		92,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		85,
		108,
		145,
		119,
		105,
		110,
		85,
		78,
		72,
		79,
		65,
		51,
		36,
		23,
		21,
		36,
		43,
		47,
		53,
		62,
		63,
		87,
		94,
		100,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		99,
		106,
		138,
		110,
		123,
		-1,
		77,
		-1,
		66,
		61,
		45,
		40,
		32,
		33,
		27,
		37,
		49,
		62,
		58,
		65,
		92,
		92,
		84,
		109,
		112,
		-1,
		-1,
		-1,
		149,
		144,
		119,
		96,
		80,
		116,
		-1,
		93,
		94,
		-1,
		71,
		65,
		62,
		47,
		43,
		38,
		38,
		34,
		35,
		38,
		52,
		62,
		50,
		86,
		-1,
		92,
		86,
		102,
		92,
		80,
		-1,
		-1,
		-1,
		142,
		121,
		114,
		134,
		75,
		127,
		-1,
		-1,
		78,
		71,
		-1,
		58,
		40,
		45,
		43,
		39,
		43,
		47,
		36,
		49,
		54,
		55,
		65,
		85,
		89,
		93,
		82,
		78,
		75,
		89,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		95,
		-1,
		87,
		79,
		69,
		63,
		57,
		53,
		51,
		67,
		51,
		54,
		54,
		50,
		58,
		43,
		46,
		58,
		62,
		80,
		88,
		80,
		74,
		73,
		85,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		108,
		-1,
		72,
		86,
		102,
		-1,
		95,
		74,
		89,
		67,
		63,
		56,
		74,
		75,
		53,
		58,
		57,
		67,
		68,
		57,
		70,
		62,
		84,
		84,
		68,
		69,
		78,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		69,
		57,
		89,
		-1,
		-1,
		131,
		-1,
		65,
		82,
		70,
		68,
		64,
		55,
		61,
		68,
		71,
		72,
		62,
		51,
		57,
		56,
		78,
		64,
		62,
		81,
		97,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		109,
		99,
		83,
		68,
		101,
		-1,
		72,
		56,
		61,
		-1,
		97,
		-1,
		70,
		72,
		64,
		53,
		50,
		61,
		59,
		70,
		87,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		126,
		-1,
		-1,
		96,
		90,
		90,
		74,
		77,
		88,
		68,
		62,
		61,
		92,
		90,
		78,
		62,
		55,
		52,
		53,
		66,
		86,
		77,
		89,
		-1,
		-1,
		-1,
		123,
		109,
		113,
		73,
		92,
		-1,
		-1,
		158,
		113,
		99,
		-1,
		83,
		105,
		93,
		83,
		73,
		107,
		106,
		81,
		74,
		60,
		62,
		60,
		62,
		67,
		88,
		89,
		102,
		-1,
		-1,
		106,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		105,
		121,
		113,
		84,
		94,
		-1,
		-1,
		85,
		83,
		93,
		77,
		64,
		84,
		87,
		77,
		61,
		76,
		88,
		96,
		101,
		-1,
		109,
		96,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		116,
		118,
		122,
		88,
		-1,
		93,
		88,
		68,
		82,
		89,
		79,
		74,
		68,
		71,
		89,
		106,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		95,
		109,
		111,
		104,
		108,
		-1,
		96,
		84,
		70,
		87,
		92,
		89,
		80,
		72,
		77,
		74,
		87,
		101,
		105,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		113,
		128,
		150,
		127,
		100,
		95,
		88,
		82,
		78,
		94,
		100,
		111,
		79,
		75,
		76,
		80,
		79,
		96,
		106,
		-1,
		-1,
		127,
		144,
		139,
		121,
		125,
		177,
		-1,
		-1,
		104,
		95,
		86,
		89,
		88,
		91,
		85,
		82,
		87,
		92,
		80,
		89,
		107,
		106,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		140,
		175,
		122,
		104,
		100,
		98,
		91,
		100,
		95,
		90,
		100,
		102,
		94,
		82,
		86,
		109,
		98,
		137,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		186,
		160,
		167,
		137,
		134,
		-1,
		104,
		129,
		101,
		108,
		99,
		106,
		106,
		98,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		182,
		168,
		172,
		162,
		165,
		-1,
		-1,
		153,
		150,
		126,
		109,
		107,
		100,
		95,
		105,
		85,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		176,
		168,
		175,
		154,
		156,
		-1,
		-1,
		126,
		123,
		128,
		116,
		113,
		115,
		110,
		101,
		86,
		92,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		173,
		-1,
		-1,
		183,
		157,
		141,
		131,
		125,
		175,
		130,
		125,
		109,
		107,
		98,
		89,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		203,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		199,
		-1,
		168,
		-1,
		143,
		147,
		138,
		141,
		123,
		110,
		102,
		94,
		110,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		244,
		200,
		199,
		190,
		225,
		240,
		244,
		-1,
		185,
		224,
		222,
		-1,
		206,
		-1,
		-1,
		-1,
		157,
		151,
		143,
		143,
		122,
		122,
		96,
		100,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		240,
		231,
		244,
		189,
		189,
		210,
		219,
		240,
		200,
		191,
		218,
		229,
		218,
		213,
		200,
		-1,
		-1,
		180,
		161,
		-1,
		-1,
		129,
		117,
		100,
		101,
		97,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		207,
		-1,
		-1,
		202,
		219,
		213,
		217,
		233,
		258,
		-1,
		189,
		-1,
		-1,
		174,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		105,
		116,
		126,
		114,
		115,
		105,
		115,
		128,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		189,
		187,
		193,
		200,
		217,
		247,
		-1,
		-1,
		205,
		185,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		132,
		134,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		191,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		125,
		129,
		121,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		260,
		-1,
		212,
		188,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		200,
		203,
		-1,
		-1,
		202,
		204,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		207,
		208,
		209,
		-1,
		187,
		-1,
		205,
		-1,
		172,
		178,
		166,
		-1,
		-1,
		-1,
		160,
		123,
		144,
		154,
		148,
		146,
		137,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		205,
		179,
		212,
		203,
		186,
		166,
		158,
		177,
		-1,
		147,
		-1,
		122,
		124,
		150,
		153,
		159,
		153,
		126,
		141,
		131,
		122,
		131,
		211,
		-1,
		181,
		214,
		178,
		172,
		148,
		152,
		168,
		-1,
		144,
		126,
		-1,
		154,
		144,
		175,
		160,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		168,
		153,
		144,
		-1,
		156,
		138,
		117,
		134,
		134,
		125,
		133,
		165,
		161,
		148,
		148,
		140,
		-1,
		284,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		172,
		145,
		133,
		139,
		135,
		121,
		127,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		141,
		176,
		-1,
		279,
		-1,
		213,
		-1,
		-1,
		195,
		175,
		167,
		156,
		145,
		143,
		134,
		125,
		147,
		163,
		147,
		145,
		148,
		149,
		-1,
		268,
		267,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		191,
		152,
		-1,
		154,
		134,
		-1,
		156,
		152,
		-1,
		-1,
		255,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		186,
		170,
		-1,
		145,
		145,
		-1,
		-1,
		-1,
		240,
		239,
		-1,
		208,
		211,
		-1,
		201,
		192,
		200,
		147,
		151,
		-1,
		-1,
		-1,
		249,
		230,
		224,
		223,
		221,
		216,
		213,
		199,
		183,
		161,
		150,
		171,
		-1,
		-1,
		-1,
		221,
		213,
		206,
		-1,
		-1,
		208,
		191,
		172,
		170,
		-1,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		198,
		-1,
		-1,
		204,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		232,
		-1,
		-1,
		-1,
		194,
		190,
		191,
		-1,
		-1,
		-1,
		-1,
		254,
		255,
		278,
		242,
		-1,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		257,
		255,
		-1,
		-1,
		-1,
		214,
		198,
		-1,
		184,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		219,
		-1,
		219,
		194,
		201,
		-1,
		-1,
		-1,
		-1,
		232,
		224,
		232,
		-1,
		204,
		206,
		-1,
		254,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		209,
		216,
		238,
		241,
		277,
		-1,
		228
	],
	[
		-1,
		142,
		131,
		142,
		150,
		123,
		130,
		-1,
		149,
		153,
		119,
		113,
		152,
		121,
		127,
		138,
		-1,
		-1,
		-1,
		142,
		141,
		109,
		107,
		116,
		121,
		128,
		-1,
		127,
		-1,
		163,
		142,
		153,
		158,
		102,
		99,
		119,
		138,
		120,
		112,
		178,
		132,
		103,
		97,
		115,
		105,
		114,
		106,
		-1,
		103,
		93,
		115,
		94,
		105,
		97,
		-1,
		-1,
		97,
		98,
		104,
		90,
		96,
		92,
		-1,
		102,
		86,
		-1,
		-1,
		87,
		88,
		72,
		75,
		83,
		81,
		94,
		86,
		81,
		-1,
		-1,
		78,
		74,
		81,
		68,
		64,
		81,
		94,
		76,
		90,
		89,
		-1,
		90,
		107,
		104,
		75,
		73,
		57,
		55,
		73,
		75,
		81,
		81,
		-1,
		103,
		103,
		79,
		87,
		92,
		73,
		60,
		60,
		70,
		63,
		82,
		70,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		103,
		86,
		93,
		75,
		65,
		80,
		73,
		63,
		60,
		58,
		55,
		71,
		69,
		79,
		-1,
		-1,
		197,
		166,
		194,
		152,
		133,
		-1,
		99,
		79,
		73,
		69,
		63,
		56,
		70,
		66,
		-1,
		49,
		48,
		76,
		62,
		73,
		157,
		-1,
		-1,
		155,
		147,
		129,
		132,
		109,
		105,
		94,
		93,
		86,
		72,
		68,
		53,
		56,
		56,
		62,
		43,
		53,
		57,
		55,
		80,
		-1,
		-1,
		125,
		-1,
		-1,
		154,
		137,
		-1,
		120,
		127,
		115,
		121,
		107,
		128,
		104,
		95,
		88,
		82,
		70,
		51,
		48,
		61,
		44,
		40,
		65,
		69,
		50,
		71,
		66,
		-1,
		124,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		113,
		116,
		121,
		145,
		144,
		-1,
		117,
		105,
		106,
		91,
		88,
		75,
		63,
		56,
		40,
		47,
		41,
		44,
		42,
		72,
		47,
		69,
		66,
		95,
		100,
		94,
		103,
		-1,
		162,
		158,
		154,
		161,
		110,
		-1,
		-1,
		149,
		-1,
		152,
		154,
		129,
		102,
		105,
		92,
		83,
		70,
		59,
		57,
		38,
		35,
		35,
		36,
		51,
		42,
		41,
		59,
		74,
		87,
		91,
		97,
		-1,
		212,
		-1,
		154,
		138,
		140,
		112,
		133,
		-1,
		169,
		153,
		146,
		131,
		131,
		-1,
		101,
		98,
		88,
		66,
		51,
		50,
		39,
		40,
		26,
		31,
		45,
		36,
		54,
		61,
		69,
		73,
		93,
		105,
		172,
		162,
		-1,
		144,
		149,
		108,
		116,
		135,
		173,
		137,
		-1,
		132,
		-1,
		103,
		116,
		-1,
		72,
		68,
		50,
		44,
		33,
		40,
		19,
		27,
		24,
		42,
		45,
		62,
		66,
		82,
		-1,
		-1,
		157,
		161,
		150,
		101,
		120,
		144,
		181,
		130,
		119,
		118,
		-1,
		109,
		86,
		83,
		71,
		58,
		43,
		44,
		39,
		0,
		13,
		26,
		29,
		51,
		79,
		57,
		69,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		127,
		98,
		122,
		164,
		148,
		141,
		129,
		94,
		94,
		88,
		-1,
		82,
		61,
		52,
		41,
		35,
		37,
		13,
		32,
		30,
		32,
		48,
		60,
		51,
		71,
		-1,
		-1,
		-1,
		157,
		146,
		147,
		93,
		116,
		153,
		127,
		113,
		118,
		93,
		86,
		80,
		95,
		78,
		59,
		48,
		40,
		29,
		17,
		23,
		18,
		32,
		41,
		42,
		66,
		73,
		79,
		-1,
		-1,
		164,
		154,
		138,
		140,
		137,
		107,
		114,
		146,
		118,
		131,
		-1,
		85,
		-1,
		74,
		69,
		53,
		48,
		45,
		37,
		24,
		34,
		24,
		39,
		37,
		52,
		71,
		71,
		63,
		88,
		91,
		-1,
		-1,
		-1,
		157,
		152,
		127,
		104,
		88,
		124,
		-1,
		101,
		102,
		-1,
		79,
		73,
		70,
		55,
		51,
		41,
		45,
		39,
		38,
		38,
		41,
		56,
		38,
		74,
		-1,
		71,
		65,
		93,
		95,
		83,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		83,
		135,
		-1,
		-1,
		86,
		79,
		-1,
		66,
		48,
		53,
		48,
		47,
		46,
		45,
		34,
		47,
		51,
		43,
		53,
		73,
		77,
		84,
		77,
		81,
		78,
		92,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		103,
		-1,
		95,
		87,
		77,
		71,
		65,
		61,
		59,
		75,
		59,
		58,
		57,
		48,
		56,
		41,
		44,
		46,
		50,
		68,
		91,
		83,
		77,
		76,
		88,
		-1,
		170,
		156,
		127,
		-1,
		-1,
		116,
		-1,
		80,
		94,
		110,
		-1,
		103,
		82,
		97,
		75,
		71,
		65,
		82,
		83,
		61,
		57,
		55,
		65,
		66,
		55,
		58,
		62,
		77,
		87,
		71,
		72,
		81,
		-1,
		176,
		163,
		121,
		117,
		106,
		126,
		77,
		65,
		97,
		-1,
		-1,
		139,
		-1,
		73,
		90,
		79,
		77,
		72,
		63,
		69,
		66,
		69,
		70,
		60,
		49,
		55,
		59,
		81,
		67,
		65,
		84,
		100,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		92,
		79,
		73,
		-1,
		114,
		-1,
		117,
		107,
		91,
		76,
		109,
		-1,
		80,
		64,
		69,
		-1,
		95,
		-1,
		68,
		70,
		68,
		56,
		53,
		64,
		62,
		73,
		90,
		-1,
		126,
		111,
		104,
		94,
		108,
		79,
		-1,
		134,
		-1,
		-1,
		104,
		98,
		98,
		82,
		85,
		96,
		76,
		70,
		69,
		90,
		97,
		76,
		69,
		62,
		59,
		56,
		69,
		89,
		80,
		92,
		-1,
		-1,
		-1,
		131,
		117,
		121,
		81,
		100,
		-1,
		-1,
		166,
		121,
		107,
		-1,
		91,
		113,
		101,
		91,
		81,
		115,
		110,
		88,
		81,
		67,
		69,
		67,
		65,
		70,
		91,
		92,
		105,
		-1,
		-1,
		114,
		119,
		107,
		93,
		112,
		-1,
		-1,
		-1,
		113,
		129,
		121,
		92,
		102,
		-1,
		-1,
		93,
		91,
		101,
		84,
		71,
		91,
		94,
		80,
		64,
		79,
		91,
		99,
		104,
		-1,
		117,
		104,
		-1,
		-1,
		115,
		109,
		-1,
		-1,
		-1,
		-1,
		146,
		112,
		124,
		121,
		125,
		96,
		-1,
		97,
		95,
		75,
		89,
		96,
		82,
		77,
		71,
		74,
		92,
		109,
		-1,
		-1,
		129,
		-1,
		124,
		-1,
		-1,
		-1,
		-1,
		103,
		117,
		114,
		107,
		111,
		-1,
		99,
		91,
		77,
		94,
		95,
		92,
		83,
		75,
		80,
		77,
		90,
		104,
		108,
		152,
		-1,
		135,
		-1,
		-1,
		-1,
		121,
		136,
		153,
		130,
		103,
		98,
		91,
		85,
		85,
		101,
		103,
		114,
		82,
		78,
		79,
		83,
		82,
		99,
		109,
		-1,
		-1,
		135,
		152,
		147,
		129,
		133,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		95,
		98,
		88,
		85,
		90,
		95,
		83,
		92,
		110,
		114,
		-1,
		-1,
		-1,
		155,
		-1,
		170,
		-1,
		-1,
		148,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		110,
		102,
		85,
		94,
		117,
		106,
		145,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		184,
		159,
		174,
		189,
		168,
		175,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		103,
		111,
		111,
		106,
		84,
		91,
		107,
		106,
		101,
		137,
		128,
		134,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		189,
		176,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		113,
		115,
		108,
		103,
		113,
		93,
		80,
		84,
		88,
		94,
		99,
		104,
		110,
		125,
		140,
		-1,
		162,
		243,
		236,
		219,
		227,
		258,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		120,
		117,
		123,
		118,
		109,
		94,
		100,
		87,
		86,
		104,
		108,
		117,
		124,
		114,
		127,
		131,
		-1,
		176,
		219,
		213,
		216,
		240,
		254,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		128,
		178,
		134,
		129,
		117,
		115,
		106,
		97,
		104,
		95,
		95,
		98,
		113,
		118,
		110,
		124,
		124,
		125,
		-1,
		211,
		199,
		207,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		146,
		150,
		142,
		145,
		131,
		118,
		110,
		102,
		118,
		93,
		103,
		99,
		100,
		109,
		120,
		132,
		131,
		132,
		248,
		204,
		207,
		198,
		229,
		244,
		248,
		-1,
		188,
		227,
		230,
		-1,
		213,
		-1,
		-1,
		-1,
		160,
		155,
		147,
		151,
		130,
		130,
		104,
		108,
		98,
		105,
		115,
		117,
		109,
		113,
		126,
		137,
		140,
		244,
		235,
		248,
		193,
		193,
		214,
		223,
		244,
		203,
		194,
		221,
		237,
		226,
		221,
		208,
		-1,
		-1,
		183,
		165,
		-1,
		-1,
		137,
		125,
		108,
		109,
		105,
		108,
		123,
		126,
		116,
		114,
		108,
		140,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		211,
		-1,
		-1,
		206,
		222,
		217,
		221,
		237,
		262,
		-1,
		197,
		-1,
		-1,
		182,
		-1,
		-1,
		167,
		130,
		119,
		110,
		116,
		113,
		124,
		134,
		122,
		123,
		113,
		123,
		136,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		213,
		193,
		-1,
		-1,
		165,
		163,
		152,
		-1,
		142,
		115,
		120,
		140,
		142,
		131,
		125,
		119,
		126,
		125,
		133,
		141,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		203,
		199,
		-1,
		-1,
		160,
		153,
		141,
		129,
		119,
		129,
		133,
		137,
		129,
		122,
		117,
		128,
		120,
		124,
		141,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		220,
		206,
		199,
		187,
		185,
		-1,
		194,
		178,
		159,
		-1,
		129,
		142,
		173,
		141,
		146,
		141,
		123,
		134,
		123,
		126,
		140,
		135,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		210,
		212,
		-1,
		211,
		200,
		185,
		177,
		-1,
		-1,
		166,
		162,
		-1,
		-1,
		130,
		155,
		144,
		152,
		147,
		127,
		133,
		136,
		125,
		129,
		141,
		-1,
		-1,
		211,
		212,
		217,
		-1,
		195,
		-1,
		213,
		-1,
		180,
		186,
		174,
		-1,
		-1,
		-1,
		168,
		131,
		152,
		162,
		156,
		154,
		145,
		131,
		138,
		136,
		132,
		143,
		-1,
		-1,
		-1,
		213,
		187,
		220,
		211,
		194,
		174,
		166,
		185,
		-1,
		155,
		-1,
		130,
		132,
		158,
		161,
		167,
		161,
		134,
		149,
		139,
		130,
		139,
		219,
		-1,
		189,
		222,
		186,
		180,
		156,
		160,
		176,
		-1,
		152,
		134,
		-1,
		162,
		152,
		183,
		168,
		149,
		136,
		143,
		143,
		136,
		-1,
		-1,
		-1,
		191,
		190,
		182,
		176,
		176,
		161,
		152,
		-1,
		164,
		146,
		125,
		142,
		142,
		133,
		141,
		173,
		169,
		156,
		156,
		148,
		-1,
		292,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		185,
		180,
		153,
		141,
		147,
		143,
		129,
		135,
		137,
		145,
		143,
		140,
		152,
		148,
		168,
		149,
		184,
		-1,
		287,
		-1,
		221,
		-1,
		-1,
		203,
		183,
		175,
		164,
		153,
		151,
		142,
		133,
		155,
		171,
		155,
		153,
		156,
		157,
		-1,
		276,
		275,
		-1,
		222,
		214,
		200,
		-1,
		193,
		-1,
		199,
		160,
		-1,
		162,
		142,
		-1,
		164,
		160,
		-1,
		-1,
		263,
		238,
		-1,
		-1,
		-1,
		223,
		203,
		194,
		178,
		-1,
		153,
		153,
		-1,
		-1,
		-1,
		248,
		247,
		-1,
		216,
		219,
		-1,
		209,
		200,
		208,
		155,
		159,
		-1,
		-1,
		-1,
		257,
		238,
		232,
		231,
		229,
		224,
		221,
		207,
		191,
		169,
		158,
		179,
		-1,
		-1,
		-1,
		229,
		221,
		214,
		-1,
		-1,
		216,
		199,
		180,
		178,
		-1,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		206,
		-1,
		-1,
		212,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		240,
		-1,
		-1,
		-1,
		202,
		198,
		199,
		-1,
		-1,
		-1,
		-1,
		262,
		263,
		286,
		250,
		-1,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		265,
		263,
		-1,
		-1,
		-1,
		222,
		206,
		-1,
		192,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		227,
		-1,
		227,
		202,
		209,
		-1,
		-1,
		-1,
		-1,
		240,
		232,
		240,
		-1,
		212,
		214,
		-1,
		262,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		217,
		224,
		246,
		249,
		285,
		-1,
		236
	],
	[
		-1,
		135,
		124,
		135,
		143,
		116,
		123,
		-1,
		142,
		146,
		112,
		106,
		145,
		114,
		120,
		131,
		-1,
		-1,
		-1,
		135,
		134,
		102,
		100,
		109,
		114,
		121,
		-1,
		120,
		-1,
		156,
		135,
		146,
		151,
		95,
		92,
		112,
		131,
		113,
		105,
		171,
		125,
		96,
		90,
		108,
		98,
		107,
		99,
		-1,
		96,
		86,
		108,
		87,
		98,
		90,
		-1,
		-1,
		90,
		91,
		97,
		83,
		89,
		85,
		-1,
		95,
		79,
		-1,
		-1,
		80,
		81,
		65,
		68,
		76,
		74,
		87,
		79,
		74,
		-1,
		-1,
		71,
		67,
		74,
		61,
		57,
		74,
		87,
		69,
		83,
		82,
		-1,
		82,
		100,
		100,
		68,
		66,
		50,
		48,
		66,
		68,
		74,
		74,
		-1,
		91,
		92,
		77,
		85,
		90,
		66,
		53,
		53,
		63,
		56,
		75,
		63,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		91,
		74,
		91,
		73,
		63,
		78,
		71,
		56,
		53,
		51,
		48,
		64,
		62,
		72,
		-1,
		-1,
		184,
		153,
		182,
		140,
		121,
		-1,
		87,
		67,
		71,
		67,
		61,
		54,
		68,
		64,
		-1,
		42,
		41,
		69,
		55,
		66,
		144,
		-1,
		-1,
		142,
		134,
		117,
		120,
		97,
		93,
		82,
		81,
		73,
		59,
		55,
		51,
		54,
		54,
		60,
		36,
		46,
		50,
		48,
		73,
		-1,
		-1,
		118,
		-1,
		-1,
		141,
		124,
		-1,
		107,
		114,
		103,
		109,
		95,
		116,
		92,
		83,
		75,
		69,
		57,
		49,
		46,
		59,
		47,
		33,
		58,
		62,
		43,
		64,
		59,
		-1,
		117,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		100,
		103,
		109,
		133,
		132,
		-1,
		104,
		92,
		93,
		78,
		75,
		62,
		50,
		54,
		38,
		45,
		44,
		37,
		35,
		65,
		40,
		62,
		59,
		88,
		93,
		87,
		96,
		-1,
		149,
		145,
		141,
		148,
		97,
		-1,
		-1,
		137,
		-1,
		140,
		141,
		116,
		89,
		92,
		79,
		70,
		57,
		46,
		55,
		36,
		33,
		39,
		29,
		44,
		35,
		34,
		52,
		67,
		80,
		84,
		90,
		-1,
		199,
		-1,
		141,
		125,
		127,
		99,
		120,
		-1,
		157,
		141,
		133,
		118,
		118,
		-1,
		88,
		85,
		75,
		53,
		38,
		48,
		37,
		38,
		30,
		24,
		38,
		29,
		47,
		54,
		62,
		66,
		86,
		98,
		159,
		149,
		-1,
		131,
		136,
		95,
		103,
		122,
		160,
		124,
		-1,
		119,
		-1,
		90,
		103,
		-1,
		59,
		55,
		37,
		38,
		31,
		38,
		23,
		20,
		17,
		35,
		38,
		55,
		59,
		75,
		-1,
		-1,
		144,
		148,
		137,
		88,
		107,
		131,
		168,
		117,
		106,
		105,
		-1,
		96,
		73,
		70,
		58,
		45,
		30,
		31,
		37,
		21,
		0,
		19,
		22,
		44,
		72,
		50,
		62,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		114,
		85,
		109,
		151,
		135,
		128,
		116,
		81,
		81,
		75,
		-1,
		69,
		48,
		39,
		28,
		26,
		33,
		6,
		19,
		23,
		25,
		41,
		53,
		44,
		64,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		80,
		103,
		140,
		114,
		100,
		105,
		80,
		73,
		67,
		82,
		65,
		46,
		35,
		27,
		16,
		7,
		17,
		11,
		25,
		34,
		35,
		59,
		66,
		72,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		94,
		101,
		133,
		105,
		118,
		-1,
		72,
		-1,
		61,
		56,
		40,
		35,
		32,
		25,
		12,
		26,
		20,
		26,
		30,
		45,
		64,
		64,
		56,
		81,
		84,
		-1,
		-1,
		-1,
		144,
		139,
		114,
		91,
		75,
		111,
		-1,
		88,
		89,
		-1,
		66,
		60,
		57,
		42,
		38,
		29,
		33,
		27,
		26,
		26,
		37,
		49,
		31,
		67,
		-1,
		64,
		58,
		86,
		83,
		71,
		-1,
		-1,
		-1,
		137,
		116,
		109,
		129,
		70,
		122,
		-1,
		-1,
		73,
		66,
		-1,
		53,
		35,
		41,
		36,
		34,
		34,
		33,
		22,
		35,
		40,
		36,
		46,
		66,
		70,
		77,
		70,
		69,
		66,
		80,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		90,
		-1,
		82,
		74,
		64,
		58,
		52,
		48,
		46,
		62,
		46,
		46,
		45,
		36,
		44,
		29,
		32,
		39,
		43,
		61,
		79,
		71,
		65,
		64,
		76,
		-1,
		157,
		143,
		114,
		-1,
		-1,
		103,
		-1,
		67,
		81,
		97,
		-1,
		90,
		69,
		84,
		62,
		58,
		53,
		69,
		70,
		48,
		45,
		43,
		53,
		54,
		43,
		51,
		53,
		70,
		75,
		59,
		60,
		69,
		-1,
		163,
		150,
		108,
		104,
		93,
		113,
		64,
		52,
		84,
		-1,
		-1,
		126,
		-1,
		60,
		77,
		67,
		65,
		59,
		50,
		56,
		54,
		57,
		58,
		48,
		37,
		43,
		47,
		69,
		55,
		53,
		72,
		88,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		79,
		66,
		60,
		-1,
		101,
		-1,
		104,
		94,
		78,
		63,
		96,
		-1,
		67,
		51,
		56,
		-1,
		83,
		-1,
		56,
		58,
		56,
		44,
		41,
		52,
		50,
		61,
		78,
		-1,
		113,
		98,
		91,
		81,
		95,
		66,
		-1,
		121,
		-1,
		-1,
		91,
		85,
		85,
		69,
		72,
		83,
		63,
		57,
		56,
		78,
		85,
		64,
		57,
		50,
		47,
		44,
		57,
		77,
		68,
		80,
		-1,
		-1,
		-1,
		118,
		104,
		108,
		68,
		87,
		-1,
		-1,
		153,
		108,
		94,
		-1,
		78,
		100,
		88,
		78,
		68,
		102,
		98,
		76,
		69,
		55,
		57,
		55,
		53,
		58,
		79,
		80,
		93,
		-1,
		-1,
		101,
		106,
		94,
		80,
		99,
		-1,
		-1,
		-1,
		100,
		116,
		108,
		79,
		89,
		-1,
		-1,
		80,
		78,
		88,
		72,
		59,
		79,
		82,
		68,
		52,
		67,
		79,
		87,
		92,
		-1,
		104,
		91,
		-1,
		-1,
		102,
		96,
		-1,
		-1,
		-1,
		-1,
		133,
		99,
		111,
		109,
		113,
		83,
		-1,
		85,
		83,
		63,
		77,
		84,
		70,
		65,
		59,
		62,
		80,
		97,
		-1,
		-1,
		116,
		-1,
		111,
		-1,
		-1,
		-1,
		-1,
		90,
		104,
		102,
		95,
		99,
		-1,
		87,
		79,
		65,
		82,
		83,
		80,
		71,
		63,
		68,
		65,
		78,
		92,
		96,
		139,
		-1,
		122,
		-1,
		-1,
		-1,
		108,
		123,
		141,
		118,
		91,
		86,
		79,
		73,
		73,
		89,
		91,
		102,
		70,
		66,
		67,
		71,
		70,
		87,
		97,
		-1,
		-1,
		122,
		139,
		134,
		116,
		120,
		168,
		-1,
		-1,
		95,
		86,
		77,
		80,
		83,
		86,
		76,
		73,
		78,
		83,
		71,
		80,
		98,
		101,
		-1,
		-1,
		-1,
		142,
		-1,
		157,
		-1,
		-1,
		135,
		166,
		113,
		95,
		91,
		89,
		82,
		91,
		86,
		81,
		91,
		97,
		89,
		73,
		81,
		104,
		93,
		132,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		171,
		146,
		161,
		177,
		155,
		162,
		128,
		125,
		-1,
		95,
		120,
		92,
		99,
		91,
		99,
		99,
		93,
		71,
		78,
		94,
		93,
		88,
		124,
		115,
		121,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		177,
		163,
		163,
		153,
		156,
		-1,
		-1,
		144,
		141,
		117,
		101,
		102,
		95,
		90,
		100,
		80,
		67,
		71,
		75,
		81,
		86,
		91,
		97,
		112,
		127,
		-1,
		149,
		230,
		223,
		206,
		214,
		245,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		117,
		114,
		119,
		108,
		105,
		110,
		105,
		96,
		81,
		87,
		74,
		73,
		91,
		95,
		104,
		111,
		101,
		114,
		118,
		-1,
		163,
		206,
		200,
		203,
		227,
		241,
		-1,
		164,
		-1,
		-1,
		176,
		148,
		132,
		122,
		116,
		166,
		122,
		117,
		104,
		102,
		93,
		84,
		91,
		82,
		82,
		85,
		100,
		105,
		97,
		111,
		111,
		112,
		-1,
		198,
		186,
		194,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		192,
		-1,
		159,
		-1,
		134,
		138,
		130,
		133,
		118,
		105,
		97,
		89,
		105,
		80,
		90,
		86,
		87,
		96,
		107,
		119,
		118,
		119,
		236,
		192,
		194,
		185,
		217,
		232,
		236,
		-1,
		176,
		215,
		217,
		-1,
		201,
		-1,
		-1,
		-1,
		148,
		143,
		135,
		138,
		117,
		117,
		91,
		95,
		85,
		92,
		102,
		104,
		96,
		100,
		113,
		124,
		127,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		191,
		182,
		209,
		224,
		213,
		208,
		195,
		-1,
		-1,
		171,
		153,
		-1,
		-1,
		124,
		112,
		95,
		96,
		92,
		95,
		110,
		113,
		103,
		101,
		95,
		127,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		210,
		205,
		209,
		225,
		250,
		-1,
		184,
		-1,
		-1,
		169,
		-1,
		-1,
		154,
		117,
		106,
		97,
		103,
		100,
		111,
		121,
		109,
		110,
		100,
		110,
		123,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		239,
		-1,
		-1,
		200,
		180,
		-1,
		-1,
		152,
		150,
		139,
		-1,
		129,
		102,
		107,
		127,
		129,
		118,
		112,
		106,
		113,
		112,
		120,
		128,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		147,
		140,
		128,
		116,
		106,
		116,
		120,
		124,
		116,
		109,
		104,
		115,
		107,
		111,
		128,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		181,
		165,
		146,
		-1,
		116,
		129,
		160,
		128,
		133,
		128,
		110,
		121,
		110,
		113,
		127,
		122,
		-1,
		-1,
		192,
		195,
		-1,
		-1,
		197,
		199,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		153,
		149,
		-1,
		-1,
		117,
		142,
		131,
		139,
		134,
		114,
		120,
		123,
		112,
		116,
		128,
		-1,
		-1,
		199,
		200,
		204,
		-1,
		182,
		-1,
		200,
		-1,
		167,
		173,
		161,
		-1,
		-1,
		-1,
		155,
		118,
		139,
		149,
		143,
		141,
		132,
		118,
		125,
		123,
		119,
		130,
		-1,
		-1,
		-1,
		200,
		174,
		207,
		198,
		181,
		161,
		153,
		172,
		-1,
		142,
		-1,
		117,
		119,
		145,
		148,
		154,
		148,
		121,
		136,
		126,
		117,
		126,
		206,
		-1,
		176,
		209,
		173,
		167,
		143,
		147,
		163,
		-1,
		139,
		121,
		-1,
		149,
		139,
		170,
		155,
		136,
		123,
		130,
		130,
		123,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		163,
		148,
		139,
		-1,
		151,
		133,
		112,
		129,
		129,
		120,
		128,
		160,
		156,
		143,
		143,
		135,
		-1,
		279,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		167,
		140,
		128,
		134,
		130,
		116,
		122,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		136,
		171,
		-1,
		274,
		-1,
		208,
		-1,
		-1,
		190,
		170,
		162,
		151,
		140,
		138,
		129,
		120,
		142,
		158,
		142,
		140,
		143,
		144,
		-1,
		263,
		262,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		186,
		147,
		-1,
		149,
		129,
		-1,
		151,
		147,
		-1,
		-1,
		250,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		181,
		165,
		-1,
		140,
		140,
		-1,
		-1,
		-1,
		235,
		234,
		-1,
		203,
		206,
		-1,
		196,
		187,
		195,
		142,
		146,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		218,
		216,
		211,
		208,
		194,
		178,
		156,
		145,
		166,
		-1,
		-1,
		-1,
		216,
		208,
		201,
		-1,
		-1,
		203,
		186,
		167,
		165,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		193,
		-1,
		-1,
		199,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		227,
		-1,
		-1,
		-1,
		189,
		185,
		186,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		273,
		237,
		-1,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		179,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		214,
		-1,
		214,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		227,
		219,
		227,
		-1,
		199,
		201,
		-1,
		249,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		204,
		211,
		233,
		236,
		272,
		-1,
		223
	],
	[
		-1,
		123,
		112,
		123,
		131,
		104,
		111,
		-1,
		130,
		134,
		100,
		94,
		133,
		102,
		108,
		119,
		-1,
		-1,
		-1,
		123,
		122,
		90,
		88,
		97,
		102,
		109,
		-1,
		108,
		-1,
		144,
		123,
		134,
		139,
		83,
		80,
		100,
		119,
		101,
		93,
		159,
		113,
		84,
		78,
		96,
		86,
		95,
		87,
		-1,
		84,
		74,
		96,
		75,
		86,
		78,
		-1,
		-1,
		78,
		79,
		85,
		71,
		77,
		73,
		-1,
		83,
		67,
		-1,
		-1,
		68,
		69,
		53,
		56,
		64,
		62,
		75,
		67,
		62,
		-1,
		-1,
		59,
		55,
		62,
		49,
		45,
		62,
		75,
		57,
		71,
		70,
		-1,
		71,
		88,
		88,
		56,
		54,
		38,
		36,
		54,
		56,
		62,
		62,
		-1,
		88,
		84,
		85,
		83,
		78,
		54,
		41,
		41,
		51,
		44,
		63,
		51,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		89,
		80,
		97,
		81,
		71,
		75,
		73,
		44,
		41,
		39,
		36,
		52,
		50,
		60,
		-1,
		-1,
		182,
		155,
		179,
		137,
		119,
		-1,
		85,
		85,
		79,
		75,
		69,
		62,
		75,
		60,
		-1,
		30,
		29,
		57,
		43,
		54,
		164,
		-1,
		-1,
		140,
		132,
		114,
		117,
		94,
		90,
		100,
		99,
		92,
		81,
		77,
		59,
		62,
		62,
		68,
		24,
		34,
		38,
		36,
		61,
		-1,
		-1,
		102,
		-1,
		-1,
		161,
		144,
		-1,
		109,
		116,
		100,
		106,
		92,
		113,
		110,
		101,
		95,
		90,
		79,
		57,
		54,
		67,
		46,
		21,
		46,
		50,
		31,
		52,
		47,
		-1,
		101,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		116,
		113,
		106,
		130,
		129,
		-1,
		126,
		114,
		115,
		100,
		97,
		84,
		72,
		62,
		46,
		46,
		43,
		25,
		23,
		53,
		28,
		50,
		47,
		72,
		77,
		71,
		80,
		-1,
		169,
		165,
		161,
		168,
		117,
		-1,
		-1,
		134,
		-1,
		137,
		150,
		138,
		111,
		114,
		101,
		92,
		79,
		68,
		63,
		44,
		41,
		37,
		17,
		32,
		23,
		22,
		40,
		55,
		64,
		68,
		74,
		-1,
		219,
		-1,
		161,
		145,
		147,
		121,
		142,
		-1,
		154,
		138,
		155,
		140,
		140,
		-1,
		110,
		107,
		97,
		75,
		60,
		56,
		44,
		39,
		30,
		12,
		26,
		17,
		35,
		42,
		46,
		50,
		70,
		82,
		179,
		169,
		-1,
		151,
		156,
		117,
		125,
		144,
		181,
		146,
		-1,
		141,
		-1,
		112,
		125,
		-1,
		81,
		77,
		59,
		52,
		41,
		48,
		23,
		8,
		5,
		23,
		26,
		39,
		43,
		59,
		-1,
		-1,
		164,
		168,
		159,
		110,
		129,
		153,
		190,
		139,
		128,
		127,
		-1,
		118,
		95,
		92,
		80,
		67,
		52,
		53,
		47,
		43,
		22,
		0,
		3,
		30,
		56,
		34,
		46,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		136,
		107,
		131,
		173,
		157,
		150,
		138,
		103,
		103,
		97,
		-1,
		91,
		70,
		61,
		50,
		48,
		55,
		28,
		31,
		4,
		6,
		25,
		37,
		28,
		48,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		102,
		125,
		162,
		136,
		122,
		127,
		102,
		95,
		89,
		104,
		87,
		68,
		57,
		49,
		38,
		29,
		39,
		33,
		9,
		18,
		19,
		43,
		50,
		56,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		116,
		123,
		155,
		127,
		140,
		-1,
		94,
		-1,
		83,
		78,
		62,
		57,
		54,
		47,
		34,
		40,
		38,
		23,
		14,
		29,
		48,
		48,
		40,
		65,
		68,
		-1,
		-1,
		-1,
		166,
		161,
		136,
		113,
		97,
		133,
		-1,
		110,
		111,
		-1,
		88,
		82,
		79,
		64,
		60,
		51,
		55,
		49,
		48,
		40,
		32,
		33,
		15,
		51,
		-1,
		48,
		42,
		70,
		73,
		63,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		92,
		144,
		-1,
		-1,
		95,
		88,
		-1,
		75,
		57,
		63,
		58,
		56,
		56,
		53,
		42,
		48,
		40,
		20,
		30,
		50,
		54,
		61,
		54,
		59,
		58,
		72,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		112,
		-1,
		104,
		96,
		86,
		80,
		74,
		70,
		68,
		84,
		68,
		68,
		65,
		56,
		64,
		44,
		37,
		23,
		27,
		45,
		72,
		67,
		62,
		61,
		68,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		125,
		-1,
		89,
		103,
		119,
		-1,
		112,
		91,
		106,
		84,
		80,
		75,
		91,
		92,
		70,
		65,
		63,
		71,
		59,
		48,
		35,
		39,
		54,
		64,
		56,
		57,
		66,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		86,
		74,
		106,
		-1,
		-1,
		148,
		-1,
		82,
		99,
		89,
		87,
		81,
		72,
		78,
		74,
		68,
		63,
		53,
		42,
		48,
		44,
		66,
		52,
		50,
		69,
		84,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		123,
		-1,
		126,
		116,
		100,
		85,
		118,
		-1,
		89,
		73,
		78,
		-1,
		88,
		-1,
		61,
		61,
		52,
		41,
		38,
		49,
		47,
		58,
		75,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		113,
		107,
		107,
		91,
		94,
		105,
		85,
		79,
		78,
		83,
		78,
		69,
		50,
		43,
		40,
		41,
		54,
		74,
		65,
		77,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		175,
		130,
		116,
		-1,
		100,
		122,
		110,
		100,
		90,
		104,
		94,
		69,
		62,
		48,
		50,
		48,
		50,
		55,
		76,
		77,
		90,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		122,
		138,
		130,
		101,
		111,
		-1,
		-1,
		102,
		96,
		86,
		65,
		52,
		72,
		75,
		65,
		49,
		64,
		76,
		84,
		89,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		155,
		121,
		111,
		106,
		110,
		104,
		-1,
		82,
		76,
		56,
		70,
		77,
		67,
		62,
		56,
		59,
		77,
		94,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		112,
		126,
		99,
		92,
		96,
		-1,
		84,
		72,
		58,
		75,
		80,
		77,
		68,
		60,
		65,
		62,
		75,
		89,
		93,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		130,
		145,
		138,
		115,
		88,
		83,
		76,
		70,
		66,
		82,
		88,
		99,
		67,
		63,
		64,
		68,
		67,
		84,
		94,
		-1,
		-1,
		144,
		161,
		156,
		138,
		142,
		165,
		-1,
		-1,
		92,
		83,
		74,
		77,
		76,
		79,
		73,
		70,
		75,
		80,
		68,
		77,
		95,
		94,
		-1,
		-1,
		-1,
		164,
		-1,
		179,
		-1,
		-1,
		157,
		163,
		110,
		92,
		88,
		86,
		79,
		88,
		83,
		78,
		88,
		90,
		82,
		70,
		74,
		97,
		86,
		125,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		181,
		168,
		168,
		174,
		176,
		167,
		125,
		122,
		-1,
		92,
		117,
		89,
		96,
		87,
		94,
		94,
		86,
		64,
		71,
		87,
		86,
		81,
		117,
		108,
		114,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		141,
		138,
		114,
		97,
		95,
		88,
		83,
		93,
		73,
		60,
		64,
		68,
		74,
		79,
		84,
		90,
		105,
		120,
		-1,
		171,
		252,
		245,
		223,
		231,
		262,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		114,
		111,
		116,
		104,
		101,
		103,
		98,
		89,
		74,
		80,
		67,
		66,
		84,
		88,
		97,
		104,
		94,
		107,
		111,
		-1,
		185,
		228,
		217,
		220,
		244,
		258,
		-1,
		161,
		-1,
		-1,
		173,
		145,
		129,
		119,
		113,
		163,
		118,
		113,
		97,
		95,
		86,
		77,
		84,
		75,
		75,
		78,
		93,
		98,
		90,
		104,
		104,
		105,
		-1,
		207,
		208,
		211,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		189,
		-1,
		156,
		-1,
		131,
		135,
		126,
		129,
		111,
		98,
		90,
		82,
		98,
		73,
		83,
		79,
		80,
		89,
		100,
		112,
		111,
		112,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		173,
		212,
		210,
		-1,
		194,
		-1,
		-1,
		-1,
		145,
		139,
		131,
		131,
		110,
		110,
		84,
		88,
		78,
		85,
		95,
		97,
		89,
		93,
		106,
		117,
		120,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		188,
		179,
		206,
		217,
		206,
		201,
		188,
		-1,
		-1,
		168,
		149,
		-1,
		-1,
		117,
		105,
		88,
		89,
		85,
		88,
		103,
		106,
		96,
		94,
		88,
		120,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		207,
		201,
		205,
		221,
		246,
		-1,
		177,
		-1,
		-1,
		162,
		-1,
		-1,
		147,
		110,
		99,
		90,
		96,
		93,
		104,
		114,
		102,
		103,
		93,
		103,
		116,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		235,
		-1,
		-1,
		193,
		173,
		-1,
		-1,
		145,
		143,
		132,
		-1,
		122,
		95,
		100,
		120,
		122,
		111,
		105,
		99,
		106,
		105,
		113,
		121,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		183,
		179,
		-1,
		-1,
		140,
		133,
		121,
		109,
		99,
		109,
		113,
		117,
		109,
		102,
		97,
		108,
		100,
		104,
		121,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		200,
		186,
		179,
		167,
		165,
		-1,
		174,
		158,
		139,
		-1,
		109,
		122,
		153,
		121,
		126,
		121,
		103,
		114,
		103,
		106,
		120,
		115,
		-1,
		-1,
		188,
		191,
		-1,
		-1,
		190,
		192,
		-1,
		191,
		180,
		165,
		157,
		-1,
		-1,
		146,
		142,
		-1,
		-1,
		110,
		135,
		124,
		132,
		127,
		107,
		113,
		116,
		105,
		109,
		121,
		-1,
		-1,
		195,
		196,
		197,
		-1,
		175,
		-1,
		193,
		-1,
		160,
		166,
		154,
		-1,
		-1,
		-1,
		148,
		111,
		132,
		142,
		136,
		134,
		125,
		111,
		118,
		116,
		112,
		123,
		-1,
		-1,
		-1,
		193,
		167,
		200,
		191,
		174,
		154,
		146,
		165,
		-1,
		135,
		-1,
		110,
		112,
		138,
		141,
		147,
		141,
		114,
		129,
		119,
		110,
		119,
		199,
		-1,
		169,
		202,
		166,
		160,
		136,
		140,
		156,
		-1,
		132,
		114,
		-1,
		142,
		132,
		163,
		148,
		129,
		116,
		123,
		123,
		116,
		-1,
		-1,
		-1,
		171,
		170,
		162,
		156,
		156,
		141,
		132,
		-1,
		144,
		126,
		105,
		122,
		122,
		113,
		121,
		153,
		149,
		136,
		136,
		128,
		-1,
		272,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		165,
		160,
		133,
		121,
		127,
		123,
		109,
		115,
		117,
		125,
		123,
		120,
		132,
		128,
		148,
		129,
		164,
		-1,
		267,
		-1,
		201,
		-1,
		-1,
		183,
		163,
		155,
		144,
		133,
		131,
		122,
		113,
		135,
		151,
		135,
		133,
		136,
		137,
		-1,
		256,
		255,
		-1,
		202,
		194,
		180,
		-1,
		173,
		-1,
		179,
		140,
		-1,
		142,
		122,
		-1,
		144,
		140,
		-1,
		-1,
		243,
		218,
		-1,
		-1,
		-1,
		203,
		183,
		174,
		158,
		-1,
		133,
		133,
		-1,
		-1,
		-1,
		228,
		227,
		-1,
		196,
		199,
		-1,
		189,
		180,
		188,
		135,
		139,
		-1,
		-1,
		-1,
		237,
		218,
		212,
		211,
		209,
		204,
		201,
		187,
		171,
		149,
		138,
		159,
		-1,
		-1,
		-1,
		209,
		201,
		194,
		-1,
		-1,
		196,
		179,
		160,
		158,
		-1,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		186,
		-1,
		-1,
		192,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		220,
		-1,
		-1,
		-1,
		182,
		178,
		179,
		-1,
		-1,
		-1,
		-1,
		242,
		243,
		266,
		230,
		-1,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		245,
		243,
		-1,
		-1,
		-1,
		202,
		186,
		-1,
		172,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		207,
		-1,
		207,
		182,
		189,
		-1,
		-1,
		-1,
		-1,
		220,
		212,
		220,
		-1,
		192,
		194,
		-1,
		242,
		-1,
		-1,
		235,
		226,
		-1,
		-1,
		197,
		204,
		226,
		229,
		265,
		-1,
		216
	],
	[
		-1,
		126,
		115,
		126,
		134,
		107,
		114,
		-1,
		133,
		137,
		103,
		97,
		136,
		105,
		111,
		122,
		-1,
		-1,
		-1,
		126,
		125,
		93,
		91,
		100,
		105,
		112,
		-1,
		111,
		-1,
		147,
		126,
		137,
		142,
		86,
		83,
		103,
		122,
		104,
		96,
		162,
		116,
		87,
		81,
		99,
		89,
		98,
		90,
		-1,
		87,
		77,
		99,
		78,
		89,
		81,
		-1,
		-1,
		81,
		82,
		88,
		74,
		80,
		76,
		-1,
		86,
		70,
		-1,
		-1,
		71,
		72,
		56,
		59,
		67,
		65,
		78,
		70,
		65,
		-1,
		-1,
		62,
		58,
		65,
		52,
		48,
		65,
		78,
		60,
		74,
		73,
		-1,
		74,
		91,
		91,
		59,
		57,
		41,
		39,
		57,
		59,
		65,
		65,
		-1,
		91,
		87,
		88,
		86,
		81,
		57,
		44,
		44,
		54,
		47,
		66,
		54,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		83,
		100,
		84,
		74,
		78,
		76,
		47,
		44,
		42,
		39,
		55,
		53,
		63,
		-1,
		-1,
		185,
		158,
		182,
		140,
		122,
		-1,
		88,
		88,
		82,
		78,
		72,
		65,
		78,
		63,
		-1,
		33,
		32,
		60,
		46,
		57,
		167,
		-1,
		-1,
		143,
		135,
		117,
		120,
		97,
		93,
		103,
		102,
		95,
		84,
		80,
		62,
		65,
		65,
		71,
		27,
		37,
		41,
		39,
		64,
		-1,
		-1,
		101,
		-1,
		-1,
		164,
		147,
		-1,
		112,
		119,
		103,
		109,
		95,
		116,
		113,
		104,
		98,
		93,
		82,
		60,
		57,
		70,
		49,
		24,
		49,
		53,
		34,
		55,
		50,
		-1,
		100,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		119,
		116,
		109,
		133,
		132,
		-1,
		129,
		117,
		118,
		103,
		100,
		87,
		75,
		65,
		49,
		49,
		46,
		28,
		26,
		56,
		31,
		53,
		50,
		71,
		76,
		70,
		79,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		137,
		-1,
		140,
		153,
		141,
		114,
		117,
		104,
		95,
		82,
		71,
		66,
		47,
		44,
		40,
		20,
		35,
		26,
		25,
		43,
		55,
		63,
		67,
		73,
		-1,
		222,
		-1,
		164,
		148,
		150,
		124,
		145,
		-1,
		157,
		141,
		158,
		143,
		143,
		-1,
		113,
		110,
		100,
		78,
		63,
		59,
		47,
		42,
		33,
		15,
		27,
		20,
		38,
		45,
		45,
		49,
		69,
		81,
		182,
		172,
		-1,
		154,
		159,
		120,
		128,
		147,
		184,
		149,
		-1,
		144,
		-1,
		115,
		128,
		-1,
		84,
		80,
		62,
		55,
		44,
		51,
		26,
		11,
		8,
		26,
		29,
		38,
		42,
		58,
		-1,
		-1,
		167,
		171,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		98,
		95,
		83,
		70,
		55,
		56,
		50,
		46,
		25,
		3,
		0,
		29,
		55,
		33,
		45,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		94,
		73,
		64,
		53,
		51,
		58,
		31,
		32,
		3,
		5,
		24,
		36,
		27,
		47,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		107,
		90,
		71,
		60,
		52,
		41,
		32,
		42,
		36,
		8,
		17,
		18,
		42,
		49,
		55,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		81,
		65,
		60,
		57,
		50,
		37,
		39,
		37,
		22,
		13,
		28,
		47,
		47,
		39,
		64,
		67,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		67,
		63,
		54,
		58,
		52,
		49,
		39,
		31,
		32,
		14,
		50,
		-1,
		47,
		41,
		69,
		72,
		62,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		66,
		61,
		59,
		59,
		52,
		41,
		47,
		39,
		19,
		29,
		49,
		53,
		60,
		53,
		58,
		57,
		71,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		87,
		71,
		71,
		64,
		55,
		63,
		43,
		36,
		22,
		26,
		44,
		71,
		66,
		61,
		60,
		67,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		78,
		94,
		95,
		73,
		64,
		62,
		70,
		58,
		47,
		34,
		38,
		53,
		63,
		55,
		56,
		65,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		92,
		90,
		84,
		75,
		81,
		73,
		67,
		62,
		52,
		41,
		47,
		43,
		65,
		51,
		49,
		68,
		83,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		92,
		76,
		81,
		-1,
		87,
		-1,
		60,
		60,
		51,
		40,
		37,
		48,
		46,
		57,
		74,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		108,
		88,
		82,
		81,
		82,
		77,
		68,
		49,
		42,
		39,
		40,
		53,
		73,
		64,
		76,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		125,
		113,
		103,
		93,
		103,
		93,
		68,
		61,
		47,
		49,
		47,
		49,
		54,
		75,
		76,
		89,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		114,
		-1,
		-1,
		104,
		95,
		85,
		64,
		51,
		71,
		74,
		64,
		48,
		63,
		75,
		83,
		88,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		121,
		110,
		105,
		109,
		103,
		-1,
		81,
		75,
		55,
		69,
		76,
		66,
		61,
		55,
		58,
		76,
		93,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		127,
		98,
		91,
		95,
		-1,
		83,
		71,
		57,
		74,
		79,
		76,
		67,
		59,
		64,
		61,
		74,
		88,
		92,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		137,
		114,
		87,
		82,
		75,
		69,
		65,
		81,
		87,
		98,
		66,
		62,
		63,
		67,
		66,
		83,
		93,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		164,
		-1,
		-1,
		91,
		82,
		73,
		76,
		75,
		78,
		72,
		69,
		74,
		79,
		67,
		76,
		94,
		93,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		162,
		109,
		91,
		87,
		85,
		78,
		87,
		82,
		77,
		87,
		89,
		81,
		69,
		73,
		96,
		85,
		124,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		180,
		171,
		167,
		173,
		175,
		166,
		124,
		121,
		-1,
		91,
		116,
		88,
		95,
		86,
		93,
		93,
		85,
		63,
		70,
		86,
		85,
		80,
		116,
		107,
		113,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		173,
		169,
		159,
		149,
		152,
		-1,
		-1,
		140,
		137,
		113,
		96,
		94,
		87,
		82,
		92,
		72,
		59,
		63,
		67,
		73,
		78,
		83,
		89,
		104,
		119,
		-1,
		174,
		255,
		248,
		222,
		230,
		261,
		-1,
		163,
		155,
		166,
		141,
		143,
		-1,
		-1,
		113,
		110,
		115,
		103,
		100,
		102,
		97,
		88,
		73,
		79,
		66,
		65,
		83,
		87,
		96,
		103,
		93,
		106,
		110,
		-1,
		188,
		231,
		216,
		219,
		243,
		257,
		-1,
		160,
		-1,
		-1,
		172,
		144,
		128,
		118,
		112,
		162,
		117,
		112,
		96,
		94,
		85,
		76,
		83,
		74,
		74,
		77,
		92,
		97,
		89,
		103,
		103,
		104,
		-1,
		206,
		211,
		210,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		188,
		-1,
		155,
		-1,
		130,
		134,
		125,
		128,
		110,
		97,
		89,
		81,
		97,
		72,
		82,
		78,
		79,
		88,
		99,
		111,
		110,
		111,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		172,
		211,
		209,
		-1,
		193,
		-1,
		-1,
		-1,
		144,
		138,
		130,
		130,
		109,
		109,
		83,
		87,
		77,
		84,
		94,
		96,
		88,
		92,
		105,
		116,
		119,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		187,
		178,
		205,
		216,
		205,
		200,
		187,
		-1,
		-1,
		167,
		148,
		-1,
		-1,
		116,
		104,
		87,
		88,
		84,
		87,
		102,
		105,
		95,
		93,
		87,
		119,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		206,
		200,
		204,
		220,
		245,
		-1,
		176,
		-1,
		-1,
		161,
		-1,
		-1,
		146,
		109,
		98,
		89,
		95,
		92,
		103,
		113,
		101,
		102,
		92,
		102,
		115,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		192,
		172,
		-1,
		-1,
		144,
		142,
		131,
		-1,
		121,
		94,
		99,
		119,
		121,
		110,
		104,
		98,
		105,
		104,
		112,
		120,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		139,
		132,
		120,
		108,
		98,
		108,
		112,
		116,
		108,
		101,
		96,
		107,
		99,
		103,
		120,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		173,
		157,
		138,
		-1,
		108,
		121,
		152,
		120,
		125,
		120,
		102,
		113,
		102,
		105,
		119,
		114,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		189,
		191,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		134,
		123,
		131,
		126,
		106,
		112,
		115,
		104,
		108,
		120,
		-1,
		-1,
		194,
		195,
		196,
		-1,
		174,
		-1,
		192,
		-1,
		159,
		165,
		153,
		-1,
		-1,
		-1,
		147,
		110,
		131,
		141,
		135,
		133,
		124,
		110,
		117,
		115,
		111,
		122,
		-1,
		-1,
		-1,
		192,
		166,
		199,
		190,
		173,
		153,
		145,
		164,
		-1,
		134,
		-1,
		109,
		111,
		137,
		140,
		146,
		140,
		113,
		128,
		118,
		109,
		118,
		198,
		-1,
		168,
		201,
		165,
		159,
		135,
		139,
		155,
		-1,
		131,
		113,
		-1,
		141,
		131,
		162,
		147,
		128,
		115,
		122,
		122,
		115,
		-1,
		-1,
		-1,
		170,
		169,
		161,
		155,
		155,
		140,
		131,
		-1,
		143,
		125,
		104,
		121,
		121,
		112,
		120,
		152,
		148,
		135,
		135,
		127,
		-1,
		271,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		164,
		159,
		132,
		120,
		126,
		122,
		108,
		114,
		116,
		124,
		122,
		119,
		131,
		127,
		147,
		128,
		163,
		-1,
		266,
		-1,
		200,
		-1,
		-1,
		182,
		162,
		154,
		143,
		132,
		130,
		121,
		112,
		134,
		150,
		134,
		132,
		135,
		136,
		-1,
		255,
		254,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		178,
		139,
		-1,
		141,
		121,
		-1,
		143,
		139,
		-1,
		-1,
		242,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		173,
		157,
		-1,
		132,
		132,
		-1,
		-1,
		-1,
		227,
		226,
		-1,
		195,
		198,
		-1,
		188,
		179,
		187,
		134,
		138,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		210,
		208,
		203,
		200,
		186,
		170,
		148,
		137,
		158,
		-1,
		-1,
		-1,
		208,
		200,
		193,
		-1,
		-1,
		195,
		178,
		159,
		157,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		185,
		-1,
		-1,
		191,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		219,
		-1,
		-1,
		-1,
		181,
		177,
		178,
		-1,
		-1,
		-1,
		-1,
		241,
		242,
		265,
		229,
		-1,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		244,
		242,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		171,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		206,
		-1,
		206,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		219,
		211,
		219,
		-1,
		191,
		193,
		-1,
		241,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		196,
		203,
		225,
		228,
		264,
		-1,
		215
	],
	[
		-1,
		148,
		137,
		148,
		156,
		129,
		136,
		-1,
		155,
		159,
		125,
		119,
		158,
		127,
		133,
		144,
		-1,
		-1,
		-1,
		148,
		147,
		115,
		113,
		122,
		127,
		134,
		-1,
		133,
		-1,
		169,
		148,
		159,
		164,
		108,
		105,
		125,
		144,
		126,
		118,
		184,
		138,
		109,
		103,
		121,
		111,
		120,
		112,
		-1,
		109,
		99,
		121,
		100,
		111,
		103,
		-1,
		-1,
		103,
		104,
		110,
		96,
		102,
		98,
		-1,
		108,
		90,
		-1,
		-1,
		93,
		94,
		78,
		81,
		89,
		87,
		100,
		92,
		85,
		-1,
		-1,
		84,
		80,
		87,
		74,
		70,
		87,
		100,
		82,
		72,
		70,
		-1,
		96,
		113,
		113,
		81,
		79,
		63,
		61,
		79,
		81,
		70,
		62,
		-1,
		113,
		109,
		110,
		108,
		103,
		79,
		66,
		66,
		76,
		69,
		64,
		51,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		105,
		122,
		106,
		96,
		100,
		98,
		69,
		66,
		64,
		61,
		67,
		50,
		60,
		-1,
		-1,
		207,
		180,
		204,
		162,
		144,
		-1,
		110,
		110,
		104,
		100,
		94,
		87,
		100,
		85,
		-1,
		55,
		54,
		57,
		43,
		54,
		189,
		-1,
		-1,
		165,
		157,
		139,
		142,
		119,
		115,
		125,
		124,
		117,
		105,
		101,
		84,
		87,
		87,
		93,
		49,
		53,
		50,
		36,
		48,
		-1,
		-1,
		96,
		-1,
		-1,
		186,
		169,
		-1,
		134,
		141,
		125,
		131,
		117,
		138,
		135,
		126,
		120,
		115,
		103,
		82,
		79,
		92,
		71,
		46,
		60,
		63,
		31,
		38,
		33,
		-1,
		95,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		141,
		138,
		131,
		155,
		154,
		-1,
		150,
		138,
		139,
		124,
		121,
		108,
		96,
		87,
		71,
		71,
		68,
		50,
		48,
		60,
		28,
		36,
		33,
		63,
		71,
		65,
		74,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		159,
		-1,
		162,
		175,
		162,
		135,
		138,
		125,
		116,
		103,
		92,
		88,
		69,
		66,
		62,
		42,
		57,
		23,
		22,
		26,
		41,
		58,
		62,
		68,
		-1,
		244,
		-1,
		186,
		170,
		172,
		145,
		166,
		-1,
		179,
		163,
		179,
		164,
		164,
		-1,
		134,
		131,
		121,
		99,
		84,
		81,
		69,
		64,
		55,
		37,
		42,
		17,
		13,
		20,
		40,
		44,
		64,
		76,
		204,
		194,
		-1,
		176,
		181,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		136,
		149,
		-1,
		105,
		101,
		83,
		77,
		66,
		73,
		48,
		33,
		30,
		9,
		4,
		33,
		37,
		53,
		-1,
		-1,
		189,
		193,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		119,
		116,
		104,
		91,
		76,
		77,
		72,
		68,
		47,
		32,
		34,
		0,
		50,
		28,
		40,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		72,
		80,
		53,
		48,
		32,
		30,
		6,
		31,
		22,
		42,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		128,
		111,
		92,
		81,
		73,
		62,
		54,
		60,
		52,
		28,
		33,
		13,
		37,
		44,
		50,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		72,
		59,
		59,
		57,
		38,
		33,
		45,
		42,
		42,
		34,
		59,
		62,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		76,
		80,
		74,
		69,
		59,
		51,
		52,
		34,
		47,
		-1,
		42,
		36,
		64,
		67,
		57,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		88,
		83,
		80,
		81,
		72,
		61,
		67,
		59,
		39,
		49,
		61,
		57,
		55,
		48,
		53,
		52,
		66,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		108,
		92,
		93,
		84,
		75,
		83,
		63,
		56,
		42,
		46,
		56,
		66,
		61,
		67,
		59,
		62,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		100,
		115,
		116,
		94,
		84,
		82,
		90,
		78,
		67,
		54,
		58,
		65,
		75,
		62,
		62,
		64,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		114,
		112,
		105,
		96,
		102,
		93,
		87,
		82,
		72,
		61,
		67,
		63,
		84,
		70,
		68,
		63,
		78,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		113,
		97,
		102,
		-1,
		107,
		-1,
		80,
		80,
		71,
		60,
		57,
		68,
		66,
		77,
		69,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		129,
		109,
		103,
		102,
		102,
		97,
		88,
		69,
		62,
		59,
		60,
		73,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		146,
		134,
		124,
		114,
		123,
		113,
		88,
		81,
		67,
		69,
		67,
		69,
		74,
		84,
		76,
		86,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		135,
		-1,
		-1,
		124,
		115,
		105,
		84,
		71,
		91,
		94,
		84,
		68,
		83,
		90,
		78,
		87,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		179,
		141,
		130,
		125,
		129,
		123,
		-1,
		101,
		95,
		75,
		89,
		96,
		86,
		81,
		75,
		78,
		95,
		89,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		136,
		147,
		118,
		111,
		115,
		-1,
		103,
		91,
		77,
		94,
		99,
		96,
		87,
		79,
		84,
		81,
		94,
		101,
		91,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		154,
		169,
		157,
		134,
		107,
		102,
		95,
		89,
		85,
		101,
		107,
		118,
		86,
		82,
		83,
		87,
		86,
		103,
		106,
		-1,
		-1,
		168,
		185,
		180,
		162,
		166,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		95,
		98,
		92,
		89,
		94,
		99,
		87,
		96,
		114,
		109,
		-1,
		-1,
		-1,
		188,
		-1,
		203,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		97,
		107,
		109,
		101,
		89,
		93,
		116,
		105,
		138,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		200,
		192,
		187,
		193,
		195,
		186,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		106,
		113,
		113,
		105,
		83,
		90,
		106,
		105,
		100,
		130,
		125,
		133,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		193,
		189,
		179,
		169,
		172,
		-1,
		-1,
		160,
		157,
		133,
		116,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		195,
		276,
		269,
		242,
		250,
		281,
		-1,
		183,
		175,
		186,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		123,
		120,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		209,
		252,
		236,
		239,
		263,
		277,
		-1,
		180,
		-1,
		-1,
		192,
		164,
		148,
		138,
		132,
		182,
		137,
		132,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		226,
		232,
		230,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		208,
		-1,
		175,
		-1,
		150,
		154,
		145,
		148,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		251,
		207,
		210,
		221,
		232,
		247,
		251,
		-1,
		192,
		231,
		229,
		-1,
		213,
		-1,
		-1,
		-1,
		164,
		158,
		150,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		207,
		198,
		225,
		236,
		225,
		220,
		207,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		226,
		220,
		224,
		240,
		265,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		214,
		215,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		178,
		182,
		148,
		142,
		181,
		150,
		156,
		167,
		-1,
		-1,
		-1,
		171,
		170,
		138,
		136,
		145,
		150,
		157,
		-1,
		156,
		-1,
		192,
		171,
		182,
		187,
		131,
		128,
		148,
		167,
		149,
		141,
		207,
		161,
		132,
		126,
		144,
		134,
		143,
		135,
		-1,
		132,
		122,
		144,
		123,
		134,
		126,
		-1,
		-1,
		126,
		127,
		133,
		119,
		125,
		121,
		-1,
		131,
		115,
		-1,
		-1,
		116,
		117,
		101,
		104,
		112,
		110,
		123,
		115,
		110,
		-1,
		-1,
		107,
		103,
		110,
		97,
		93,
		110,
		123,
		105,
		101,
		99,
		-1,
		119,
		136,
		136,
		104,
		102,
		86,
		84,
		102,
		104,
		99,
		91,
		-1,
		136,
		132,
		133,
		131,
		126,
		102,
		89,
		89,
		99,
		92,
		93,
		80,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		128,
		145,
		129,
		119,
		123,
		121,
		92,
		89,
		87,
		84,
		96,
		79,
		89,
		-1,
		-1,
		230,
		203,
		227,
		185,
		167,
		-1,
		133,
		133,
		127,
		123,
		117,
		110,
		123,
		108,
		-1,
		78,
		77,
		86,
		72,
		83,
		212,
		-1,
		-1,
		188,
		180,
		162,
		165,
		142,
		138,
		148,
		147,
		140,
		128,
		124,
		107,
		110,
		110,
		116,
		72,
		82,
		79,
		65,
		63,
		-1,
		-1,
		78,
		-1,
		-1,
		209,
		192,
		-1,
		157,
		164,
		148,
		154,
		140,
		161,
		158,
		149,
		143,
		138,
		126,
		105,
		102,
		115,
		94,
		69,
		89,
		92,
		60,
		53,
		48,
		-1,
		77,
		61,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		164,
		161,
		154,
		178,
		177,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		110,
		94,
		94,
		91,
		73,
		71,
		85,
		57,
		52,
		42,
		48,
		53,
		47,
		56,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		182,
		-1,
		185,
		198,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		111,
		92,
		89,
		85,
		65,
		80,
		62,
		63,
		31,
		31,
		40,
		44,
		50,
		-1,
		267,
		-1,
		209,
		193,
		195,
		168,
		189,
		-1,
		202,
		186,
		202,
		187,
		187,
		-1,
		157,
		154,
		144,
		122,
		107,
		104,
		92,
		87,
		78,
		60,
		74,
		58,
		44,
		35,
		21,
		26,
		48,
		58,
		227,
		217,
		-1,
		199,
		204,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		100,
		89,
		96,
		71,
		56,
		53,
		50,
		51,
		14,
		18,
		42,
		-1,
		-1,
		212,
		216,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		142,
		139,
		127,
		114,
		99,
		100,
		95,
		91,
		70,
		55,
		57,
		47,
		0,
		19,
		44,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		103,
		76,
		71,
		55,
		53,
		42,
		29,
		26,
		46,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		151,
		134,
		115,
		104,
		96,
		85,
		77,
		83,
		75,
		51,
		56,
		36,
		40,
		48,
		54,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		95,
		82,
		82,
		80,
		61,
		56,
		68,
		45,
		45,
		38,
		63,
		66,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		99,
		103,
		97,
		92,
		82,
		74,
		75,
		57,
		70,
		-1,
		46,
		40,
		68,
		71,
		61,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		111,
		106,
		103,
		104,
		95,
		84,
		90,
		82,
		62,
		72,
		84,
		61,
		59,
		52,
		57,
		56,
		70,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		116,
		107,
		98,
		106,
		86,
		79,
		65,
		69,
		79,
		70,
		65,
		71,
		63,
		66,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		107,
		105,
		113,
		101,
		90,
		77,
		81,
		83,
		80,
		66,
		66,
		68,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		116,
		110,
		105,
		95,
		84,
		90,
		86,
		88,
		74,
		72,
		67,
		82,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		136,
		120,
		125,
		-1,
		130,
		-1,
		103,
		103,
		94,
		83,
		80,
		84,
		75,
		88,
		73,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		152,
		132,
		126,
		125,
		125,
		120,
		111,
		92,
		85,
		82,
		83,
		96,
		108,
		87,
		75,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		169,
		157,
		147,
		137,
		146,
		136,
		111,
		104,
		90,
		92,
		90,
		92,
		97,
		88,
		80,
		90,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		158,
		-1,
		-1,
		147,
		138,
		128,
		107,
		94,
		114,
		117,
		107,
		91,
		104,
		94,
		82,
		91,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		202,
		164,
		153,
		148,
		152,
		146,
		-1,
		124,
		118,
		98,
		112,
		119,
		109,
		104,
		98,
		99,
		99,
		93,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		159,
		170,
		141,
		134,
		138,
		-1,
		126,
		114,
		100,
		117,
		122,
		119,
		110,
		102,
		107,
		96,
		109,
		105,
		95,
		208,
		-1,
		191,
		-1,
		-1,
		-1,
		177,
		192,
		180,
		157,
		130,
		125,
		118,
		112,
		108,
		124,
		130,
		141,
		109,
		105,
		106,
		102,
		101,
		109,
		110,
		-1,
		-1,
		191,
		208,
		203,
		185,
		189,
		207,
		-1,
		-1,
		134,
		125,
		116,
		119,
		118,
		121,
		115,
		112,
		117,
		119,
		110,
		111,
		128,
		113,
		-1,
		-1,
		-1,
		211,
		-1,
		226,
		-1,
		-1,
		204,
		205,
		152,
		134,
		130,
		128,
		121,
		130,
		125,
		120,
		130,
		132,
		124,
		109,
		116,
		139,
		121,
		142,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		223,
		215,
		210,
		216,
		218,
		209,
		167,
		164,
		-1,
		134,
		159,
		131,
		138,
		129,
		136,
		136,
		128,
		106,
		113,
		129,
		128,
		123,
		134,
		129,
		138,
		-1,
		-1,
		313,
		302,
		291,
		297,
		-1,
		216,
		212,
		202,
		192,
		195,
		-1,
		-1,
		183,
		180,
		156,
		139,
		137,
		130,
		125,
		135,
		115,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		136,
		144,
		-1,
		218,
		299,
		292,
		265,
		273,
		304,
		-1,
		206,
		198,
		209,
		184,
		186,
		-1,
		-1,
		156,
		153,
		158,
		146,
		143,
		145,
		140,
		131,
		116,
		122,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		232,
		275,
		259,
		262,
		286,
		300,
		-1,
		203,
		-1,
		-1,
		215,
		187,
		171,
		161,
		155,
		205,
		160,
		155,
		139,
		137,
		128,
		119,
		126,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		249,
		255,
		253,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		231,
		-1,
		198,
		-1,
		173,
		177,
		168,
		171,
		153,
		140,
		132,
		124,
		140,
		115,
		125,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		274,
		230,
		233,
		244,
		255,
		270,
		274,
		-1,
		215,
		254,
		252,
		-1,
		236,
		-1,
		-1,
		-1,
		187,
		181,
		173,
		173,
		152,
		152,
		126,
		130,
		120,
		127,
		137,
		139,
		131,
		135,
		148,
		159,
		162,
		270,
		261,
		274,
		219,
		219,
		240,
		249,
		270,
		230,
		221,
		248,
		259,
		248,
		243,
		230,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		159,
		147,
		130,
		131,
		127,
		130,
		145,
		148,
		138,
		136,
		130,
		162,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		210,
		237,
		-1,
		-1,
		232,
		249,
		243,
		247,
		263,
		288,
		-1,
		219,
		-1,
		-1,
		204,
		-1,
		-1,
		189,
		152,
		141,
		132,
		138,
		135,
		146,
		156,
		144,
		145,
		135,
		145,
		158,
		247,
		244,
		232,
		230,
		253,
		218,
		206,
		-1,
		219,
		217,
		223,
		230,
		247,
		277,
		-1,
		-1,
		235,
		215,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		137,
		142,
		162,
		164,
		153,
		147,
		141,
		148,
		147,
		155,
		163,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		204,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		225,
		221,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		155,
		159,
		151,
		144,
		139,
		150,
		142,
		146,
		163,
		-1,
		290,
		-1,
		242,
		218,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		242,
		228,
		221,
		209,
		207,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		195,
		163,
		168,
		163,
		145,
		156,
		145,
		148,
		162,
		157,
		-1,
		-1,
		230,
		233,
		-1,
		-1,
		232,
		234,
		-1,
		233,
		222,
		207,
		199,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		152,
		177,
		166,
		174,
		169,
		149,
		155,
		158,
		147,
		151,
		163,
		-1,
		-1,
		237,
		238,
		239,
		-1,
		217,
		-1,
		235,
		-1,
		202,
		208,
		196,
		-1,
		-1,
		-1,
		190,
		153,
		174,
		184,
		178,
		176,
		167,
		153,
		160,
		158,
		154,
		165,
		-1,
		-1,
		-1,
		235,
		209,
		242,
		233,
		216,
		196,
		188,
		207,
		-1,
		177,
		-1,
		152,
		154,
		180,
		183,
		189,
		183,
		156,
		171,
		161,
		152,
		161,
		241,
		-1,
		211,
		244,
		208,
		202,
		178,
		182,
		198,
		-1,
		174,
		156,
		-1,
		184,
		174,
		205,
		190,
		171,
		158,
		165,
		165,
		158,
		-1,
		-1,
		-1,
		213,
		212,
		204,
		198,
		198,
		183,
		174,
		-1,
		186,
		168,
		147,
		164,
		164,
		155,
		163,
		195,
		191,
		178,
		178,
		170,
		-1,
		314,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		207,
		202,
		175,
		163,
		169,
		165,
		151,
		157,
		159,
		167,
		165,
		162,
		174,
		170,
		190,
		171,
		206,
		-1,
		309,
		-1,
		243,
		-1,
		-1,
		225,
		205,
		197,
		186,
		175,
		173,
		164,
		155,
		177,
		193,
		177,
		175,
		178,
		179,
		-1,
		298,
		297,
		-1,
		244,
		236,
		222,
		-1,
		215,
		-1,
		221,
		182,
		-1,
		184,
		164,
		-1,
		186,
		182,
		-1,
		-1,
		285,
		260,
		-1,
		-1,
		-1,
		245,
		225,
		216,
		200,
		-1,
		175,
		175,
		-1,
		-1,
		-1,
		270,
		269,
		-1,
		238,
		241,
		-1,
		231,
		222,
		230,
		177,
		181,
		-1,
		-1,
		-1,
		279,
		260,
		254,
		253,
		251,
		246,
		243,
		229,
		213,
		191,
		180,
		201,
		-1,
		-1,
		-1,
		251,
		243,
		236,
		-1,
		-1,
		238,
		221,
		202,
		200,
		-1,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		228,
		-1,
		-1,
		234,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		262,
		-1,
		-1,
		-1,
		224,
		220,
		221,
		-1,
		-1,
		-1,
		-1,
		284,
		285,
		308,
		272,
		-1,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		287,
		285,
		-1,
		-1,
		-1,
		244,
		228,
		-1,
		214,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		249,
		-1,
		249,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		262,
		254,
		262,
		-1,
		234,
		236,
		-1,
		284,
		-1,
		-1,
		277,
		268,
		-1,
		-1,
		239,
		246,
		268,
		271,
		307,
		-1,
		258
	],
	[
		-1,
		152,
		141,
		152,
		160,
		133,
		140,
		-1,
		159,
		163,
		129,
		123,
		162,
		131,
		137,
		148,
		-1,
		-1,
		-1,
		152,
		151,
		119,
		117,
		126,
		131,
		138,
		-1,
		137,
		-1,
		173,
		152,
		163,
		168,
		112,
		109,
		129,
		148,
		130,
		122,
		188,
		142,
		113,
		107,
		125,
		115,
		124,
		116,
		-1,
		113,
		103,
		125,
		104,
		115,
		107,
		-1,
		-1,
		107,
		108,
		114,
		100,
		106,
		102,
		-1,
		112,
		96,
		-1,
		-1,
		97,
		98,
		82,
		85,
		93,
		91,
		104,
		96,
		91,
		-1,
		-1,
		88,
		84,
		91,
		78,
		74,
		91,
		104,
		86,
		92,
		90,
		-1,
		100,
		117,
		117,
		85,
		83,
		67,
		65,
		83,
		85,
		90,
		82,
		-1,
		117,
		113,
		114,
		112,
		107,
		83,
		70,
		70,
		80,
		73,
		84,
		71,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		109,
		126,
		110,
		100,
		104,
		102,
		73,
		70,
		68,
		65,
		81,
		70,
		80,
		-1,
		-1,
		211,
		184,
		208,
		166,
		148,
		-1,
		114,
		114,
		108,
		104,
		98,
		91,
		104,
		89,
		-1,
		59,
		58,
		77,
		63,
		74,
		193,
		-1,
		-1,
		169,
		161,
		143,
		146,
		123,
		119,
		129,
		128,
		121,
		109,
		105,
		88,
		91,
		91,
		97,
		53,
		63,
		67,
		56,
		54,
		-1,
		-1,
		68,
		-1,
		-1,
		190,
		173,
		-1,
		138,
		145,
		129,
		135,
		121,
		142,
		139,
		130,
		124,
		119,
		107,
		86,
		83,
		96,
		75,
		50,
		75,
		79,
		51,
		44,
		39,
		-1,
		67,
		51,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		145,
		142,
		135,
		159,
		158,
		-1,
		154,
		142,
		143,
		128,
		125,
		112,
		100,
		91,
		75,
		75,
		72,
		54,
		52,
		76,
		48,
		43,
		33,
		38,
		43,
		37,
		46,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		163,
		-1,
		166,
		179,
		166,
		139,
		142,
		129,
		120,
		107,
		96,
		92,
		73,
		70,
		66,
		46,
		61,
		51,
		50,
		22,
		22,
		30,
		34,
		40,
		-1,
		248,
		-1,
		190,
		174,
		176,
		149,
		170,
		-1,
		183,
		167,
		183,
		168,
		168,
		-1,
		138,
		135,
		125,
		103,
		88,
		85,
		73,
		68,
		59,
		41,
		55,
		45,
		35,
		26,
		12,
		16,
		38,
		48,
		208,
		198,
		-1,
		180,
		185,
		145,
		153,
		172,
		210,
		174,
		-1,
		169,
		-1,
		140,
		153,
		-1,
		109,
		105,
		87,
		81,
		70,
		77,
		52,
		37,
		34,
		37,
		32,
		5,
		9,
		32,
		-1,
		-1,
		193,
		197,
		187,
		138,
		157,
		181,
		218,
		167,
		156,
		155,
		-1,
		146,
		123,
		120,
		108,
		95,
		80,
		81,
		76,
		72,
		51,
		36,
		38,
		28,
		22,
		0,
		25,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		164,
		135,
		159,
		201,
		185,
		178,
		166,
		131,
		131,
		125,
		-1,
		119,
		98,
		89,
		78,
		76,
		84,
		57,
		52,
		36,
		34,
		23,
		15,
		7,
		27,
		-1,
		-1,
		-1,
		194,
		183,
		184,
		130,
		153,
		190,
		164,
		150,
		155,
		130,
		123,
		117,
		132,
		115,
		96,
		85,
		77,
		66,
		58,
		64,
		56,
		32,
		37,
		17,
		22,
		29,
		35,
		-1,
		-1,
		201,
		191,
		175,
		177,
		174,
		144,
		151,
		183,
		155,
		168,
		-1,
		122,
		-1,
		111,
		106,
		90,
		85,
		82,
		76,
		63,
		63,
		61,
		42,
		37,
		49,
		27,
		27,
		19,
		44,
		47,
		-1,
		-1,
		-1,
		194,
		189,
		164,
		141,
		125,
		161,
		-1,
		138,
		139,
		-1,
		116,
		110,
		107,
		92,
		88,
		80,
		84,
		78,
		73,
		63,
		55,
		56,
		38,
		51,
		-1,
		27,
		21,
		49,
		52,
		42,
		-1,
		-1,
		-1,
		187,
		166,
		159,
		179,
		120,
		172,
		-1,
		-1,
		123,
		116,
		-1,
		103,
		85,
		92,
		87,
		84,
		85,
		76,
		65,
		71,
		63,
		43,
		53,
		65,
		42,
		40,
		33,
		38,
		37,
		51,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		140,
		-1,
		132,
		124,
		114,
		108,
		102,
		98,
		96,
		112,
		96,
		97,
		88,
		79,
		87,
		67,
		60,
		46,
		50,
		60,
		51,
		46,
		52,
		44,
		47,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		153,
		-1,
		117,
		131,
		147,
		-1,
		140,
		119,
		134,
		112,
		108,
		104,
		119,
		120,
		98,
		88,
		86,
		94,
		82,
		71,
		58,
		62,
		64,
		61,
		47,
		47,
		49,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		114,
		102,
		134,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		118,
		116,
		109,
		100,
		106,
		97,
		91,
		86,
		76,
		65,
		71,
		67,
		69,
		55,
		53,
		48,
		63,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		117,
		101,
		106,
		-1,
		111,
		-1,
		84,
		84,
		75,
		64,
		61,
		65,
		56,
		69,
		54,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		171,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		133,
		113,
		107,
		106,
		106,
		101,
		92,
		73,
		66,
		63,
		64,
		77,
		89,
		68,
		56,
		-1,
		-1,
		-1,
		168,
		154,
		158,
		118,
		137,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		150,
		138,
		128,
		118,
		127,
		117,
		92,
		85,
		71,
		73,
		71,
		73,
		78,
		69,
		61,
		71,
		-1,
		-1,
		151,
		156,
		144,
		130,
		149,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		139,
		-1,
		-1,
		128,
		119,
		109,
		88,
		75,
		95,
		98,
		88,
		72,
		85,
		75,
		63,
		72,
		-1,
		154,
		141,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		-1,
		-1,
		183,
		145,
		134,
		129,
		133,
		127,
		-1,
		105,
		99,
		79,
		93,
		100,
		90,
		85,
		79,
		80,
		80,
		74,
		-1,
		-1,
		166,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		140,
		151,
		122,
		115,
		119,
		-1,
		107,
		95,
		81,
		98,
		103,
		100,
		91,
		83,
		88,
		77,
		90,
		86,
		76,
		189,
		-1,
		172,
		-1,
		-1,
		-1,
		158,
		173,
		161,
		138,
		111,
		106,
		99,
		93,
		89,
		105,
		111,
		122,
		90,
		86,
		87,
		83,
		82,
		90,
		91,
		-1,
		-1,
		172,
		189,
		184,
		166,
		170,
		188,
		-1,
		-1,
		115,
		106,
		97,
		100,
		99,
		102,
		96,
		93,
		98,
		100,
		91,
		92,
		109,
		94,
		-1,
		-1,
		-1,
		192,
		-1,
		207,
		-1,
		-1,
		185,
		186,
		133,
		115,
		111,
		109,
		102,
		111,
		106,
		101,
		111,
		113,
		105,
		90,
		97,
		120,
		102,
		123,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		204,
		196,
		191,
		197,
		199,
		190,
		148,
		145,
		-1,
		115,
		140,
		112,
		119,
		110,
		117,
		117,
		109,
		87,
		94,
		110,
		109,
		104,
		115,
		110,
		119,
		-1,
		-1,
		294,
		283,
		272,
		278,
		-1,
		197,
		193,
		183,
		173,
		176,
		-1,
		-1,
		164,
		161,
		137,
		120,
		118,
		111,
		106,
		116,
		96,
		83,
		87,
		91,
		97,
		102,
		107,
		113,
		117,
		125,
		-1,
		199,
		280,
		273,
		246,
		254,
		285,
		-1,
		187,
		179,
		190,
		165,
		167,
		-1,
		-1,
		137,
		134,
		139,
		127,
		124,
		126,
		121,
		112,
		97,
		103,
		90,
		89,
		107,
		111,
		120,
		127,
		117,
		130,
		134,
		-1,
		213,
		256,
		240,
		243,
		267,
		281,
		-1,
		184,
		-1,
		-1,
		196,
		168,
		152,
		142,
		136,
		186,
		141,
		136,
		120,
		118,
		109,
		100,
		107,
		98,
		98,
		101,
		116,
		121,
		113,
		127,
		127,
		128,
		-1,
		230,
		236,
		234,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		212,
		-1,
		179,
		-1,
		154,
		158,
		149,
		152,
		134,
		121,
		113,
		105,
		121,
		96,
		106,
		102,
		103,
		112,
		123,
		135,
		134,
		135,
		255,
		211,
		214,
		225,
		236,
		251,
		255,
		-1,
		196,
		235,
		233,
		-1,
		217,
		-1,
		-1,
		-1,
		168,
		162,
		154,
		154,
		133,
		133,
		107,
		111,
		101,
		108,
		118,
		120,
		112,
		116,
		129,
		140,
		143,
		251,
		242,
		255,
		200,
		200,
		221,
		230,
		251,
		211,
		202,
		229,
		240,
		229,
		224,
		211,
		-1,
		-1,
		191,
		172,
		-1,
		-1,
		140,
		128,
		111,
		112,
		108,
		111,
		126,
		129,
		119,
		117,
		111,
		143,
		-1,
		244,
		243,
		232,
		229,
		205,
		196,
		191,
		218,
		-1,
		-1,
		213,
		230,
		224,
		228,
		244,
		269,
		-1,
		200,
		-1,
		-1,
		185,
		-1,
		-1,
		170,
		133,
		122,
		113,
		119,
		116,
		127,
		137,
		125,
		126,
		116,
		126,
		139,
		228,
		225,
		213,
		211,
		234,
		199,
		187,
		-1,
		200,
		198,
		204,
		211,
		228,
		258,
		-1,
		-1,
		216,
		196,
		-1,
		-1,
		168,
		166,
		155,
		-1,
		145,
		118,
		123,
		143,
		145,
		134,
		128,
		122,
		129,
		128,
		136,
		144,
		237,
		251,
		240,
		236,
		235,
		243,
		192,
		185,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		202,
		-1,
		-1,
		163,
		156,
		144,
		132,
		122,
		132,
		136,
		140,
		132,
		125,
		120,
		131,
		123,
		127,
		144,
		-1,
		271,
		-1,
		223,
		199,
		213,
		228,
		236,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		197,
		181,
		162,
		-1,
		132,
		145,
		176,
		144,
		149,
		144,
		126,
		137,
		126,
		129,
		143,
		138,
		-1,
		-1,
		211,
		214,
		-1,
		-1,
		213,
		215,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		169,
		165,
		-1,
		-1,
		133,
		158,
		147,
		155,
		150,
		130,
		136,
		139,
		128,
		132,
		144,
		-1,
		-1,
		218,
		219,
		220,
		-1,
		198,
		-1,
		216,
		-1,
		183,
		189,
		177,
		-1,
		-1,
		-1,
		171,
		134,
		155,
		165,
		159,
		157,
		148,
		134,
		141,
		139,
		135,
		146,
		-1,
		-1,
		-1,
		216,
		190,
		223,
		214,
		197,
		177,
		169,
		188,
		-1,
		158,
		-1,
		133,
		135,
		161,
		164,
		170,
		164,
		137,
		152,
		142,
		133,
		142,
		222,
		-1,
		192,
		225,
		189,
		183,
		159,
		163,
		179,
		-1,
		155,
		137,
		-1,
		165,
		155,
		186,
		171,
		152,
		139,
		146,
		146,
		139,
		-1,
		-1,
		-1,
		194,
		193,
		185,
		179,
		179,
		164,
		155,
		-1,
		167,
		149,
		128,
		145,
		145,
		136,
		144,
		176,
		172,
		159,
		159,
		151,
		-1,
		295,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		188,
		183,
		156,
		144,
		150,
		146,
		132,
		138,
		140,
		148,
		146,
		143,
		155,
		151,
		171,
		152,
		187,
		-1,
		290,
		-1,
		224,
		-1,
		-1,
		206,
		186,
		178,
		167,
		156,
		154,
		145,
		136,
		158,
		174,
		158,
		156,
		159,
		160,
		-1,
		279,
		278,
		-1,
		225,
		217,
		203,
		-1,
		196,
		-1,
		202,
		163,
		-1,
		165,
		145,
		-1,
		167,
		163,
		-1,
		-1,
		266,
		241,
		-1,
		-1,
		-1,
		226,
		206,
		197,
		181,
		-1,
		156,
		156,
		-1,
		-1,
		-1,
		251,
		250,
		-1,
		219,
		222,
		-1,
		212,
		203,
		211,
		158,
		162,
		-1,
		-1,
		-1,
		260,
		241,
		235,
		234,
		232,
		227,
		224,
		210,
		194,
		172,
		161,
		182,
		-1,
		-1,
		-1,
		232,
		224,
		217,
		-1,
		-1,
		219,
		202,
		183,
		181,
		-1,
		-1,
		-1,
		254,
		235,
		-1,
		-1,
		209,
		-1,
		-1,
		215,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		243,
		-1,
		-1,
		-1,
		205,
		201,
		202,
		-1,
		-1,
		-1,
		-1,
		265,
		266,
		289,
		253,
		-1,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		268,
		266,
		-1,
		-1,
		-1,
		225,
		209,
		-1,
		195,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		230,
		-1,
		230,
		205,
		212,
		-1,
		-1,
		-1,
		-1,
		243,
		235,
		243,
		-1,
		215,
		217,
		-1,
		265,
		-1,
		-1,
		258,
		249,
		-1,
		-1,
		220,
		227,
		249,
		252,
		288,
		-1,
		239
	],
	[
		-1,
		165,
		154,
		165,
		173,
		146,
		153,
		-1,
		172,
		176,
		142,
		136,
		175,
		144,
		150,
		161,
		-1,
		-1,
		-1,
		165,
		164,
		132,
		130,
		139,
		144,
		151,
		-1,
		150,
		-1,
		186,
		165,
		176,
		181,
		125,
		122,
		142,
		161,
		143,
		135,
		201,
		155,
		126,
		120,
		138,
		128,
		137,
		129,
		-1,
		126,
		116,
		138,
		117,
		128,
		120,
		-1,
		-1,
		120,
		121,
		127,
		113,
		119,
		115,
		-1,
		125,
		109,
		-1,
		-1,
		110,
		111,
		95,
		98,
		106,
		104,
		117,
		109,
		104,
		-1,
		-1,
		101,
		97,
		104,
		91,
		87,
		104,
		117,
		99,
		113,
		111,
		-1,
		113,
		130,
		130,
		98,
		96,
		80,
		78,
		96,
		98,
		104,
		103,
		-1,
		130,
		126,
		127,
		125,
		120,
		96,
		83,
		83,
		93,
		86,
		105,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		122,
		139,
		123,
		113,
		117,
		115,
		86,
		83,
		81,
		78,
		94,
		91,
		101,
		-1,
		-1,
		224,
		197,
		221,
		179,
		161,
		-1,
		127,
		127,
		121,
		117,
		111,
		104,
		117,
		102,
		-1,
		72,
		71,
		98,
		84,
		95,
		206,
		-1,
		-1,
		182,
		174,
		156,
		159,
		136,
		132,
		142,
		141,
		134,
		122,
		118,
		101,
		104,
		104,
		110,
		66,
		76,
		80,
		77,
		80,
		-1,
		-1,
		94,
		-1,
		-1,
		203,
		186,
		-1,
		151,
		158,
		142,
		148,
		134,
		155,
		152,
		143,
		137,
		132,
		120,
		99,
		96,
		109,
		88,
		63,
		88,
		92,
		72,
		70,
		65,
		-1,
		93,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		158,
		155,
		148,
		172,
		171,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		104,
		88,
		88,
		85,
		67,
		65,
		95,
		69,
		69,
		59,
		64,
		69,
		61,
		70,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		176,
		-1,
		179,
		192,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		105,
		86,
		83,
		79,
		59,
		74,
		64,
		63,
		48,
		48,
		56,
		58,
		64,
		-1,
		261,
		-1,
		203,
		187,
		189,
		162,
		183,
		-1,
		196,
		180,
		196,
		181,
		181,
		-1,
		151,
		148,
		138,
		116,
		101,
		98,
		86,
		81,
		72,
		54,
		68,
		58,
		54,
		52,
		38,
		42,
		53,
		74,
		221,
		211,
		-1,
		193,
		198,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		94,
		83,
		90,
		65,
		50,
		47,
		50,
		45,
		31,
		35,
		42,
		-1,
		-1,
		206,
		210,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		136,
		133,
		121,
		108,
		93,
		94,
		89,
		85,
		64,
		49,
		51,
		41,
		48,
		26,
		0,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		89,
		97,
		70,
		65,
		49,
		47,
		36,
		23,
		20,
		22,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		145,
		128,
		109,
		98,
		90,
		79,
		71,
		77,
		69,
		45,
		50,
		30,
		26,
		42,
		38,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		89,
		76,
		76,
		74,
		55,
		50,
		62,
		31,
		31,
		32,
		56,
		59,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		93,
		97,
		91,
		86,
		76,
		68,
		69,
		51,
		64,
		-1,
		40,
		34,
		61,
		65,
		55,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		100,
		97,
		98,
		89,
		78,
		84,
		76,
		56,
		66,
		78,
		55,
		53,
		46,
		51,
		50,
		64,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		110,
		101,
		92,
		100,
		80,
		73,
		59,
		63,
		73,
		64,
		59,
		65,
		57,
		60,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		101,
		99,
		107,
		95,
		84,
		71,
		75,
		77,
		74,
		60,
		60,
		62,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		110,
		104,
		99,
		89,
		78,
		84,
		80,
		82,
		68,
		66,
		61,
		76,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		130,
		114,
		119,
		-1,
		124,
		-1,
		97,
		97,
		88,
		77,
		74,
		78,
		69,
		82,
		67,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		146,
		126,
		120,
		119,
		119,
		114,
		105,
		86,
		79,
		76,
		77,
		90,
		102,
		81,
		69,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		163,
		151,
		141,
		131,
		140,
		130,
		105,
		98,
		84,
		86,
		84,
		86,
		91,
		82,
		74,
		84,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		171,
		142,
		152,
		-1,
		-1,
		141,
		132,
		122,
		101,
		88,
		108,
		111,
		101,
		85,
		98,
		88,
		76,
		85,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		196,
		158,
		147,
		142,
		146,
		140,
		-1,
		118,
		112,
		92,
		106,
		113,
		103,
		98,
		92,
		93,
		93,
		87,
		-1,
		-1,
		179,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		153,
		164,
		135,
		128,
		132,
		-1,
		120,
		108,
		94,
		111,
		116,
		113,
		104,
		96,
		101,
		90,
		103,
		99,
		89,
		202,
		-1,
		185,
		-1,
		-1,
		-1,
		171,
		186,
		174,
		151,
		124,
		119,
		112,
		106,
		102,
		118,
		124,
		135,
		103,
		99,
		100,
		96,
		95,
		103,
		104,
		-1,
		-1,
		185,
		202,
		197,
		179,
		183,
		201,
		-1,
		-1,
		128,
		119,
		110,
		113,
		112,
		115,
		109,
		106,
		111,
		113,
		104,
		105,
		122,
		107,
		-1,
		-1,
		-1,
		205,
		-1,
		220,
		-1,
		-1,
		198,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		126,
		118,
		103,
		110,
		133,
		115,
		136,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		217,
		209,
		204,
		210,
		212,
		203,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		123,
		130,
		130,
		122,
		100,
		107,
		123,
		122,
		117,
		128,
		123,
		132,
		-1,
		-1,
		307,
		296,
		285,
		291,
		-1,
		210,
		206,
		196,
		186,
		189,
		-1,
		-1,
		177,
		174,
		150,
		133,
		131,
		124,
		119,
		129,
		109,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		130,
		138,
		-1,
		212,
		293,
		286,
		259,
		267,
		298,
		-1,
		200,
		192,
		203,
		178,
		180,
		-1,
		-1,
		150,
		147,
		152,
		140,
		137,
		139,
		134,
		125,
		110,
		116,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		226,
		269,
		253,
		256,
		280,
		294,
		-1,
		197,
		-1,
		-1,
		209,
		181,
		165,
		155,
		149,
		199,
		154,
		149,
		133,
		131,
		122,
		113,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		243,
		249,
		247,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		225,
		-1,
		192,
		-1,
		167,
		171,
		162,
		165,
		147,
		134,
		126,
		118,
		134,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		268,
		224,
		227,
		238,
		249,
		264,
		268,
		-1,
		209,
		248,
		246,
		-1,
		230,
		-1,
		-1,
		-1,
		181,
		175,
		167,
		167,
		146,
		146,
		120,
		124,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		264,
		255,
		268,
		213,
		213,
		234,
		243,
		264,
		224,
		215,
		242,
		253,
		242,
		237,
		224,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		153,
		141,
		124,
		125,
		121,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		204,
		231,
		-1,
		-1,
		226,
		243,
		237,
		241,
		257,
		282,
		-1,
		213,
		-1,
		-1,
		198,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		129,
		140,
		150,
		138,
		139,
		129,
		139,
		152,
		241,
		238,
		226,
		224,
		247,
		212,
		200,
		-1,
		213,
		211,
		217,
		224,
		241,
		271,
		-1,
		-1,
		229,
		209,
		-1,
		-1,
		181,
		179,
		168,
		-1,
		158,
		131,
		136,
		156,
		158,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		198,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		215,
		-1,
		-1,
		176,
		169,
		157,
		145,
		135,
		145,
		149,
		153,
		145,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		284,
		-1,
		236,
		212,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		226,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		231,
		232,
		233,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		172,
		170,
		161,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		148,
		174,
		177,
		183,
		177,
		150,
		165,
		155,
		146,
		155,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		199,
		184,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		189,
		185,
		172,
		172,
		164,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		165,
		200,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		172,
		173,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		192,
		194,
		160,
		154,
		193,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		183,
		182,
		152,
		150,
		159,
		164,
		171,
		-1,
		194,
		-1,
		204,
		183,
		194,
		199,
		145,
		142,
		162,
		181,
		187,
		179,
		219,
		175,
		146,
		140,
		158,
		163,
		181,
		173,
		-1,
		146,
		136,
		158,
		162,
		174,
		157,
		-1,
		-1,
		140,
		141,
		147,
		159,
		164,
		169,
		-1,
		195,
		214,
		-1,
		-1,
		130,
		143,
		139,
		142,
		150,
		166,
		187,
		204,
		209,
		-1,
		-1,
		131,
		135,
		148,
		149,
		147,
		174,
		193,
		204,
		218,
		217,
		-1,
		119,
		137,
		146,
		155,
		161,
		150,
		154,
		172,
		203,
		209,
		212,
		-1,
		111,
		113,
		142,
		148,
		160,
		166,
		153,
		159,
		178,
		191,
		210,
		201,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		108,
		116,
		142,
		141,
		137,
		155,
		177,
		156,
		162,
		166,
		183,
		199,
		200,
		210,
		-1,
		-1,
		159,
		128,
		163,
		120,
		105,
		-1,
		104,
		123,
		129,
		133,
		138,
		146,
		174,
		172,
		-1,
		177,
		176,
		207,
		193,
		204,
		119,
		-1,
		-1,
		117,
		109,
		94,
		97,
		94,
		99,
		129,
		128,
		133,
		135,
		137,
		149,
		164,
		164,
		174,
		171,
		181,
		185,
		200,
		211,
		-1,
		-1,
		285,
		-1,
		-1,
		113,
		99,
		-1,
		82,
		89,
		89,
		106,
		97,
		122,
		137,
		141,
		149,
		152,
		140,
		159,
		156,
		180,
		176,
		168,
		193,
		197,
		203,
		221,
		222,
		-1,
		284,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		75,
		78,
		84,
		108,
		118,
		-1,
		144,
		142,
		166,
		160,
		165,
		161,
		146,
		164,
		162,
		177,
		179,
		175,
		177,
		214,
		205,
		226,
		223,
		254,
		260,
		254,
		263,
		-1,
		90,
		86,
		82,
		89,
		72,
		-1,
		-1,
		112,
		-1,
		126,
		139,
		156,
		146,
		149,
		161,
		169,
		168,
		152,
		170,
		165,
		168,
		187,
		183,
		192,
		202,
		201,
		219,
		232,
		247,
		251,
		257,
		-1,
		140,
		-1,
		82,
		66,
		69,
		78,
		106,
		-1,
		132,
		127,
		147,
		158,
		158,
		-1,
		174,
		171,
		184,
		168,
		153,
		170,
		172,
		176,
		186,
		190,
		205,
		196,
		214,
		221,
		229,
		233,
		253,
		265,
		100,
		90,
		-1,
		52,
		57,
		81,
		93,
		129,
		170,
		154,
		-1,
		169,
		-1,
		176,
		189,
		-1,
		174,
		170,
		159,
		175,
		183,
		190,
		193,
		187,
		184,
		202,
		205,
		222,
		226,
		242,
		-1,
		-1,
		23,
		70,
		102,
		87,
		114,
		138,
		175,
		163,
		172,
		174,
		-1,
		194,
		195,
		192,
		193,
		179,
		172,
		173,
		189,
		195,
		187,
		186,
		189,
		211,
		239,
		217,
		229,
		-1,
		-1,
		-1,
		0,
		-1,
		-1,
		121,
		92,
		116,
		158,
		202,
		195,
		183,
		181,
		181,
		175,
		-1,
		210,
		189,
		186,
		177,
		182,
		195,
		190,
		206,
		190,
		192,
		208,
		220,
		211,
		231,
		-1,
		-1,
		-1,
		151,
		140,
		141,
		95,
		129,
		147,
		214,
		200,
		205,
		180,
		173,
		167,
		204,
		206,
		183,
		191,
		183,
		172,
		186,
		194,
		198,
		192,
		201,
		202,
		226,
		233,
		239,
		-1,
		-1,
		158,
		148,
		132,
		134,
		131,
		120,
		127,
		159,
		205,
		202,
		-1,
		172,
		-1,
		161,
		169,
		168,
		174,
		186,
		172,
		177,
		188,
		200,
		206,
		197,
		212,
		231,
		231,
		223,
		248,
		251,
		-1,
		-1,
		-1,
		151,
		168,
		143,
		120,
		101,
		137,
		-1,
		172,
		173,
		-1,
		166,
		160,
		166,
		165,
		172,
		169,
		169,
		183,
		191,
		187,
		203,
		209,
		198,
		234,
		-1,
		231,
		225,
		246,
		236,
		224,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		108,
		160,
		-1,
		-1,
		157,
		150,
		-1,
		153,
		153,
		160,
		169,
		174,
		179,
		187,
		182,
		195,
		200,
		203,
		211,
		229,
		233,
		237,
		226,
		222,
		219,
		233,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		128,
		-1,
		165,
		157,
		148,
		142,
		148,
		166,
		164,
		184,
		176,
		190,
		190,
		196,
		204,
		189,
		192,
		206,
		206,
		224,
		232,
		224,
		218,
		217,
		229,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		143,
		-1,
		114,
		138,
		154,
		-1,
		182,
		161,
		184,
		162,
		176,
		172,
		210,
		211,
		189,
		194,
		202,
		212,
		214,
		203,
		214,
		206,
		228,
		228,
		212,
		213,
		222,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		117,
		130,
		141,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		186,
		184,
		200,
		191,
		197,
		213,
		216,
		218,
		208,
		197,
		203,
		200,
		222,
		208,
		206,
		225,
		241,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		208,
		192,
		197,
		-1,
		243,
		-1,
		216,
		218,
		212,
		197,
		194,
		205,
		203,
		214,
		231,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		174,
		-1,
		-1,
		191,
		185,
		185,
		169,
		172,
		224,
		204,
		198,
		197,
		238,
		238,
		224,
		210,
		203,
		200,
		197,
		210,
		230,
		221,
		233,
		-1,
		-1,
		-1,
		175,
		155,
		161,
		119,
		140,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		178,
		241,
		229,
		219,
		209,
		243,
		244,
		229,
		222,
		208,
		210,
		208,
		206,
		211,
		232,
		233,
		246,
		-1,
		-1,
		152,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		200,
		216,
		208,
		179,
		230,
		-1,
		-1,
		221,
		219,
		229,
		225,
		212,
		232,
		235,
		221,
		205,
		220,
		232,
		240,
		245,
		-1,
		155,
		142,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		233,
		199,
		211,
		232,
		257,
		224,
		-1,
		229,
		230,
		216,
		230,
		237,
		223,
		218,
		212,
		215,
		233,
		250,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		190,
		204,
		225,
		231,
		243,
		-1,
		238,
		232,
		218,
		235,
		236,
		233,
		224,
		216,
		221,
		218,
		231,
		245,
		249,
		192,
		-1,
		175,
		-1,
		-1,
		-1,
		208,
		223,
		285,
		262,
		235,
		239,
		232,
		226,
		226,
		242,
		244,
		255,
		223,
		219,
		220,
		224,
		223,
		240,
		250,
		-1,
		-1,
		175,
		192,
		227,
		216,
		220,
		312,
		-1,
		-1,
		248,
		239,
		230,
		233,
		236,
		239,
		229,
		226,
		231,
		236,
		224,
		233,
		251,
		255,
		-1,
		-1,
		-1,
		195,
		-1,
		210,
		-1,
		-1,
		235,
		319,
		266,
		248,
		244,
		242,
		235,
		244,
		239,
		234,
		244,
		253,
		245,
		226,
		237,
		260,
		249,
		287,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		224,
		199,
		214,
		260,
		255,
		256,
		281,
		278,
		-1,
		248,
		273,
		245,
		252,
		244,
		252,
		252,
		249,
		227,
		234,
		250,
		249,
		244,
		279,
		271,
		277,
		-1,
		-1,
		305,
		294,
		283,
		289,
		-1,
		230,
		216,
		246,
		236,
		242,
		-1,
		-1,
		289,
		286,
		270,
		254,
		258,
		251,
		246,
		256,
		236,
		223,
		227,
		231,
		237,
		242,
		247,
		253,
		268,
		283,
		-1,
		200,
		281,
		274,
		257,
		265,
		296,
		-1,
		233,
		242,
		223,
		228,
		236,
		-1,
		-1,
		262,
		258,
		263,
		261,
		258,
		266,
		261,
		252,
		237,
		243,
		230,
		229,
		247,
		251,
		260,
		267,
		257,
		270,
		274,
		-1,
		214,
		257,
		251,
		254,
		278,
		292,
		-1,
		246,
		-1,
		-1,
		231,
		249,
		257,
		253,
		257,
		310,
		275,
		270,
		260,
		258,
		249,
		240,
		247,
		238,
		238,
		241,
		256,
		261,
		253,
		267,
		267,
		268,
		-1,
		249,
		237,
		245,
		-1,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		247,
		-1,
		283,
		-1,
		276,
		280,
		283,
		286,
		274,
		261,
		253,
		245,
		261,
		236,
		246,
		242,
		243,
		252,
		263,
		275,
		274,
		275,
		323,
		278,
		245,
		236,
		283,
		298,
		302,
		-1,
		259,
		298,
		285,
		-1,
		256,
		-1,
		-1,
		-1,
		290,
		296,
		288,
		294,
		273,
		273,
		247,
		251,
		241,
		248,
		258,
		260,
		252,
		256,
		269,
		280,
		283,
		319,
		317,
		322,
		267,
		250,
		268,
		277,
		298,
		274,
		265,
		292,
		292,
		281,
		276,
		263,
		-1,
		-1,
		313,
		306,
		-1,
		-1,
		280,
		268,
		251,
		252,
		248,
		251,
		266,
		269,
		259,
		257,
		251,
		283,
		-1,
		319,
		318,
		307,
		304,
		280,
		271,
		258,
		269,
		-1,
		-1,
		277,
		293,
		306,
		310,
		323,
		348,
		-1,
		266,
		-1,
		-1,
		325,
		-1,
		-1,
		310,
		273,
		262,
		253,
		259,
		256,
		267,
		277,
		265,
		266,
		256,
		266,
		279,
		303,
		300,
		288,
		286,
		309,
		266,
		262,
		-1,
		292,
		280,
		286,
		293,
		310,
		337,
		-1,
		-1,
		282,
		273,
		-1,
		-1,
		308,
		306,
		295,
		-1,
		285,
		258,
		263,
		283,
		285,
		274,
		268,
		262,
		269,
		268,
		276,
		284,
		312,
		326,
		315,
		311,
		310,
		318,
		267,
		284,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		332,
		-1,
		317,
		292,
		-1,
		-1,
		303,
		296,
		284,
		272,
		262,
		272,
		276,
		280,
		272,
		265,
		260,
		271,
		263,
		267,
		284,
		-1,
		346,
		-1,
		298,
		291,
		306,
		321,
		329,
		-1,
		-1,
		-1,
		334,
		320,
		313,
		301,
		299,
		-1,
		337,
		321,
		302,
		-1,
		272,
		285,
		316,
		284,
		289,
		284,
		266,
		277,
		266,
		269,
		283,
		278,
		-1,
		-1,
		304,
		307,
		-1,
		-1,
		329,
		348,
		-1,
		325,
		314,
		299,
		291,
		-1,
		-1,
		309,
		305,
		-1,
		-1,
		273,
		298,
		287,
		295,
		290,
		270,
		276,
		279,
		268,
		272,
		284,
		-1,
		-1,
		311,
		312,
		317,
		-1,
		338,
		-1,
		349,
		-1,
		294,
		310,
		312,
		-1,
		-1,
		-1,
		311,
		274,
		295,
		305,
		299,
		297,
		288,
		274,
		281,
		279,
		275,
		286,
		-1,
		-1,
		-1,
		356,
		330,
		356,
		347,
		330,
		310,
		302,
		327,
		-1,
		298,
		-1,
		273,
		275,
		301,
		304,
		310,
		304,
		277,
		292,
		282,
		273,
		282,
		362,
		-1,
		332,
		365,
		329,
		316,
		299,
		303,
		319,
		-1,
		295,
		277,
		-1,
		305,
		295,
		326,
		311,
		292,
		279,
		286,
		286,
		279,
		-1,
		-1,
		-1,
		334,
		333,
		325,
		319,
		319,
		304,
		295,
		-1,
		307,
		289,
		268,
		285,
		285,
		276,
		284,
		316,
		312,
		299,
		299,
		291,
		-1,
		418,
		-1,
		-1,
		357,
		-1,
		-1,
		-1,
		328,
		323,
		296,
		284,
		290,
		286,
		272,
		278,
		280,
		288,
		286,
		283,
		295,
		291,
		311,
		292,
		327,
		-1,
		425,
		-1,
		364,
		-1,
		-1,
		346,
		326,
		318,
		307,
		296,
		294,
		285,
		276,
		298,
		314,
		298,
		296,
		299,
		300,
		-1,
		419,
		418,
		-1,
		365,
		357,
		343,
		-1,
		336,
		-1,
		342,
		303,
		-1,
		305,
		285,
		-1,
		307,
		303,
		-1,
		-1,
		406,
		381,
		-1,
		-1,
		-1,
		366,
		346,
		337,
		321,
		-1,
		296,
		296,
		-1,
		-1,
		-1,
		391,
		390,
		-1,
		359,
		362,
		-1,
		352,
		343,
		351,
		298,
		302,
		-1,
		-1,
		-1,
		400,
		381,
		375,
		374,
		372,
		367,
		364,
		350,
		334,
		312,
		301,
		322,
		-1,
		-1,
		-1,
		372,
		364,
		357,
		-1,
		-1,
		359,
		342,
		323,
		321,
		-1,
		-1,
		-1,
		394,
		375,
		-1,
		-1,
		349,
		-1,
		-1,
		355,
		320,
		-1,
		-1,
		-1,
		-1,
		-1,
		411,
		383,
		-1,
		-1,
		-1,
		345,
		341,
		342,
		-1,
		-1,
		-1,
		-1,
		405,
		406,
		429,
		393,
		-1,
		-1,
		-1,
		337,
		331,
		-1,
		-1,
		408,
		406,
		-1,
		-1,
		-1,
		365,
		349,
		-1,
		335,
		-1,
		-1,
		-1,
		356,
		-1,
		-1,
		368,
		-1,
		-1,
		-1,
		370,
		-1,
		370,
		345,
		352,
		-1,
		-1,
		-1,
		-1,
		383,
		375,
		383,
		-1,
		355,
		357,
		-1,
		405,
		-1,
		-1,
		398,
		389,
		-1,
		-1,
		360,
		367,
		389,
		392,
		428,
		-1,
		379
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		148,
		137,
		148,
		156,
		129,
		136,
		-1,
		157,
		159,
		125,
		119,
		158,
		129,
		135,
		146,
		-1,
		-1,
		-1,
		148,
		147,
		117,
		115,
		124,
		129,
		136,
		-1,
		159,
		-1,
		169,
		148,
		159,
		164,
		110,
		107,
		127,
		146,
		152,
		144,
		184,
		140,
		111,
		105,
		123,
		128,
		146,
		138,
		-1,
		111,
		101,
		123,
		127,
		139,
		122,
		-1,
		-1,
		105,
		106,
		112,
		124,
		129,
		134,
		-1,
		160,
		179,
		-1,
		-1,
		95,
		108,
		104,
		107,
		115,
		131,
		152,
		169,
		174,
		-1,
		-1,
		96,
		100,
		113,
		114,
		112,
		139,
		158,
		169,
		183,
		182,
		-1,
		84,
		102,
		111,
		120,
		126,
		115,
		119,
		137,
		168,
		174,
		177,
		-1,
		76,
		78,
		107,
		113,
		125,
		131,
		118,
		124,
		143,
		156,
		175,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		79,
		73,
		81,
		107,
		106,
		102,
		120,
		142,
		121,
		127,
		131,
		148,
		164,
		165,
		175,
		-1,
		-1,
		129,
		98,
		133,
		90,
		75,
		-1,
		69,
		88,
		94,
		98,
		103,
		111,
		139,
		137,
		-1,
		142,
		141,
		172,
		158,
		169,
		89,
		-1,
		-1,
		87,
		79,
		64,
		67,
		64,
		64,
		94,
		93,
		98,
		100,
		102,
		114,
		129,
		129,
		139,
		136,
		146,
		150,
		165,
		176,
		-1,
		-1,
		243,
		-1,
		-1,
		86,
		69,
		-1,
		52,
		59,
		59,
		76,
		66,
		87,
		102,
		106,
		114,
		117,
		105,
		124,
		121,
		145,
		141,
		133,
		158,
		162,
		168,
		186,
		184,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		45,
		48,
		54,
		78,
		88,
		-1,
		109,
		107,
		131,
		125,
		130,
		126,
		111,
		129,
		127,
		142,
		144,
		140,
		142,
		179,
		165,
		187,
		184,
		213,
		218,
		212,
		221,
		-1,
		94,
		90,
		86,
		93,
		42,
		-1,
		-1,
		82,
		-1,
		96,
		109,
		121,
		111,
		114,
		126,
		134,
		133,
		117,
		135,
		130,
		133,
		145,
		148,
		157,
		160,
		159,
		177,
		192,
		205,
		209,
		215,
		-1,
		144,
		-1,
		86,
		70,
		72,
		44,
		65,
		-1,
		102,
		97,
		117,
		123,
		123,
		-1,
		139,
		136,
		149,
		133,
		118,
		135,
		137,
		139,
		144,
		149,
		163,
		154,
		172,
		179,
		187,
		191,
		211,
		223,
		104,
		94,
		-1,
		76,
		81,
		40,
		47,
		62,
		140,
		124,
		-1,
		134,
		-1,
		141,
		154,
		-1,
		139,
		135,
		124,
		132,
		127,
		142,
		148,
		145,
		142,
		160,
		163,
		180,
		184,
		200,
		-1,
		-1,
		89,
		70,
		40,
		33,
		44,
		68,
		105,
		133,
		141,
		140,
		-1,
		134,
		160,
		157,
		147,
		134,
		124,
		125,
		133,
		146,
		125,
		144,
		147,
		169,
		197,
		175,
		187,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		0,
		30,
		46,
		88,
		170,
		163,
		151,
		119,
		119,
		113,
		-1,
		154,
		137,
		133,
		122,
		120,
		133,
		128,
		144,
		148,
		147,
		166,
		178,
		169,
		189,
		-1,
		-1,
		-1,
		74,
		63,
		64,
		33,
		67,
		77,
		152,
		138,
		143,
		118,
		111,
		105,
		157,
		154,
		121,
		129,
		121,
		110,
		124,
		132,
		136,
		145,
		154,
		160,
		184,
		184,
		190,
		-1,
		-1,
		81,
		71,
		55,
		57,
		54,
		58,
		65,
		97,
		143,
		140,
		-1,
		110,
		-1,
		99,
		107,
		106,
		112,
		124,
		110,
		115,
		126,
		138,
		151,
		147,
		154,
		189,
		189,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		74,
		106,
		81,
		58,
		39,
		75,
		-1,
		110,
		111,
		-1,
		104,
		98,
		104,
		103,
		110,
		107,
		107,
		121,
		129,
		125,
		141,
		147,
		139,
		175,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		104,
		83,
		76,
		96,
		46,
		98,
		-1,
		-1,
		95,
		88,
		-1,
		91,
		91,
		98,
		107,
		112,
		117,
		125,
		120,
		133,
		138,
		144,
		149,
		167,
		171,
		175,
		164,
		160,
		157,
		171,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		49,
		66,
		-1,
		103,
		95,
		86,
		80,
		86,
		104,
		102,
		122,
		114,
		128,
		128,
		134,
		142,
		127,
		130,
		146,
		144,
		162,
		170,
		162,
		156,
		155,
		167,
		-1,
		152,
		138,
		109,
		-1,
		-1,
		81,
		-1,
		52,
		76,
		92,
		-1,
		120,
		99,
		122,
		100,
		114,
		110,
		148,
		149,
		127,
		132,
		140,
		150,
		152,
		141,
		152,
		144,
		166,
		166,
		150,
		151,
		160,
		-1,
		158,
		145,
		103,
		99,
		88,
		108,
		55,
		68,
		79,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		124,
		122,
		138,
		129,
		135,
		151,
		154,
		156,
		146,
		135,
		141,
		138,
		160,
		146,
		144,
		163,
		179,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		74,
		61,
		55,
		-1,
		96,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		146,
		130,
		135,
		-1,
		181,
		-1,
		154,
		156,
		150,
		135,
		132,
		143,
		141,
		152,
		169,
		-1,
		108,
		93,
		86,
		76,
		90,
		61,
		-1,
		112,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		162,
		142,
		136,
		135,
		176,
		176,
		162,
		148,
		141,
		138,
		135,
		148,
		168,
		159,
		171,
		-1,
		-1,
		-1,
		113,
		93,
		99,
		57,
		78,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		179,
		167,
		157,
		147,
		181,
		182,
		167,
		160,
		146,
		148,
		146,
		144,
		149,
		170,
		171,
		184,
		-1,
		-1,
		90,
		97,
		85,
		71,
		90,
		-1,
		-1,
		-1,
		138,
		154,
		146,
		117,
		168,
		-1,
		-1,
		159,
		157,
		167,
		163,
		150,
		170,
		173,
		159,
		143,
		158,
		170,
		178,
		183,
		-1,
		93,
		80,
		-1,
		-1,
		93,
		87,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		149,
		170,
		195,
		162,
		-1,
		167,
		168,
		154,
		168,
		175,
		161,
		156,
		150,
		153,
		171,
		188,
		-1,
		-1,
		107,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		128,
		142,
		163,
		169,
		181,
		-1,
		176,
		170,
		156,
		173,
		174,
		171,
		162,
		154,
		159,
		156,
		169,
		183,
		187,
		130,
		-1,
		113,
		-1,
		-1,
		-1,
		146,
		161,
		223,
		200,
		173,
		177,
		170,
		164,
		164,
		180,
		182,
		193,
		161,
		157,
		158,
		162,
		161,
		178,
		188,
		-1,
		-1,
		113,
		130,
		165,
		154,
		158,
		250,
		-1,
		-1,
		186,
		177,
		168,
		171,
		174,
		177,
		167,
		164,
		169,
		174,
		162,
		171,
		189,
		193,
		-1,
		-1,
		-1,
		133,
		-1,
		148,
		-1,
		-1,
		173,
		257,
		204,
		186,
		182,
		180,
		173,
		182,
		177,
		172,
		182,
		191,
		183,
		164,
		175,
		198,
		187,
		225,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		162,
		137,
		152,
		198,
		193,
		194,
		219,
		216,
		-1,
		186,
		211,
		183,
		190,
		182,
		190,
		190,
		187,
		165,
		172,
		188,
		187,
		182,
		217,
		209,
		215,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		168,
		154,
		184,
		174,
		180,
		-1,
		-1,
		227,
		224,
		208,
		192,
		196,
		189,
		184,
		194,
		174,
		161,
		165,
		169,
		175,
		180,
		185,
		191,
		206,
		221,
		-1,
		138,
		219,
		212,
		195,
		203,
		234,
		-1,
		171,
		180,
		161,
		166,
		174,
		-1,
		-1,
		200,
		196,
		201,
		199,
		196,
		204,
		199,
		190,
		175,
		181,
		168,
		167,
		185,
		189,
		198,
		205,
		195,
		208,
		212,
		-1,
		152,
		195,
		189,
		192,
		216,
		230,
		-1,
		184,
		-1,
		-1,
		169,
		187,
		195,
		191,
		195,
		248,
		213,
		208,
		198,
		196,
		187,
		178,
		185,
		176,
		176,
		179,
		194,
		199,
		191,
		205,
		205,
		206,
		-1,
		187,
		175,
		183,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		185,
		-1,
		221,
		-1,
		214,
		218,
		221,
		224,
		212,
		199,
		191,
		183,
		199,
		174,
		184,
		180,
		181,
		190,
		201,
		213,
		212,
		213,
		261,
		216,
		183,
		174,
		221,
		236,
		240,
		-1,
		197,
		236,
		223,
		-1,
		194,
		-1,
		-1,
		-1,
		228,
		234,
		226,
		232,
		211,
		211,
		185,
		189,
		179,
		186,
		196,
		198,
		190,
		194,
		207,
		218,
		221,
		257,
		255,
		260,
		205,
		188,
		206,
		215,
		236,
		212,
		203,
		230,
		230,
		219,
		214,
		201,
		-1,
		-1,
		251,
		244,
		-1,
		-1,
		218,
		206,
		189,
		190,
		186,
		189,
		204,
		207,
		197,
		195,
		189,
		221,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		196,
		207,
		-1,
		-1,
		215,
		231,
		244,
		248,
		261,
		286,
		-1,
		204,
		-1,
		-1,
		263,
		-1,
		-1,
		248,
		211,
		200,
		191,
		197,
		194,
		205,
		215,
		203,
		204,
		194,
		204,
		217,
		241,
		238,
		226,
		224,
		247,
		204,
		200,
		-1,
		230,
		218,
		224,
		231,
		248,
		275,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		246,
		244,
		233,
		-1,
		223,
		196,
		201,
		221,
		223,
		212,
		206,
		200,
		207,
		206,
		214,
		222,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		255,
		230,
		-1,
		-1,
		241,
		234,
		222,
		210,
		200,
		210,
		214,
		218,
		210,
		203,
		198,
		209,
		201,
		205,
		222,
		-1,
		284,
		-1,
		236,
		229,
		244,
		259,
		267,
		-1,
		-1,
		-1,
		272,
		258,
		251,
		239,
		237,
		-1,
		275,
		259,
		240,
		-1,
		210,
		223,
		254,
		222,
		227,
		222,
		204,
		215,
		204,
		207,
		221,
		216,
		-1,
		-1,
		242,
		245,
		-1,
		-1,
		267,
		286,
		-1,
		263,
		252,
		237,
		229,
		-1,
		-1,
		247,
		243,
		-1,
		-1,
		211,
		236,
		225,
		233,
		228,
		208,
		214,
		217,
		206,
		210,
		222,
		-1,
		-1,
		249,
		250,
		255,
		-1,
		276,
		-1,
		287,
		-1,
		232,
		248,
		250,
		-1,
		-1,
		-1,
		249,
		212,
		233,
		243,
		237,
		235,
		226,
		212,
		219,
		217,
		213,
		224,
		-1,
		-1,
		-1,
		294,
		268,
		294,
		285,
		268,
		248,
		240,
		265,
		-1,
		236,
		-1,
		211,
		213,
		239,
		242,
		248,
		242,
		215,
		230,
		220,
		211,
		220,
		300,
		-1,
		270,
		303,
		267,
		254,
		237,
		241,
		257,
		-1,
		233,
		215,
		-1,
		243,
		233,
		264,
		249,
		230,
		217,
		224,
		224,
		217,
		-1,
		-1,
		-1,
		272,
		271,
		263,
		257,
		257,
		242,
		233,
		-1,
		245,
		227,
		206,
		223,
		223,
		214,
		222,
		254,
		250,
		237,
		237,
		229,
		-1,
		356,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		266,
		261,
		234,
		222,
		228,
		224,
		210,
		216,
		218,
		226,
		224,
		221,
		233,
		229,
		249,
		230,
		265,
		-1,
		363,
		-1,
		302,
		-1,
		-1,
		284,
		264,
		256,
		245,
		234,
		232,
		223,
		214,
		236,
		252,
		236,
		234,
		237,
		238,
		-1,
		357,
		356,
		-1,
		303,
		295,
		281,
		-1,
		274,
		-1,
		280,
		241,
		-1,
		243,
		223,
		-1,
		245,
		241,
		-1,
		-1,
		344,
		319,
		-1,
		-1,
		-1,
		304,
		284,
		275,
		259,
		-1,
		234,
		234,
		-1,
		-1,
		-1,
		329,
		328,
		-1,
		297,
		300,
		-1,
		290,
		281,
		289,
		236,
		240,
		-1,
		-1,
		-1,
		338,
		319,
		313,
		312,
		310,
		305,
		302,
		288,
		272,
		250,
		239,
		260,
		-1,
		-1,
		-1,
		310,
		302,
		295,
		-1,
		-1,
		297,
		280,
		261,
		259,
		-1,
		-1,
		-1,
		332,
		313,
		-1,
		-1,
		287,
		-1,
		-1,
		293,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		349,
		321,
		-1,
		-1,
		-1,
		283,
		279,
		280,
		-1,
		-1,
		-1,
		-1,
		343,
		344,
		367,
		331,
		-1,
		-1,
		-1,
		275,
		269,
		-1,
		-1,
		346,
		344,
		-1,
		-1,
		-1,
		303,
		287,
		-1,
		273,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		308,
		-1,
		308,
		283,
		290,
		-1,
		-1,
		-1,
		-1,
		321,
		313,
		321,
		-1,
		293,
		295,
		-1,
		343,
		-1,
		-1,
		336,
		327,
		-1,
		-1,
		298,
		305,
		327,
		330,
		366,
		-1,
		317
	],
	[
		-1,
		118,
		107,
		118,
		126,
		99,
		106,
		-1,
		127,
		129,
		95,
		89,
		128,
		99,
		105,
		116,
		-1,
		-1,
		-1,
		118,
		117,
		87,
		85,
		94,
		99,
		106,
		-1,
		129,
		-1,
		139,
		118,
		129,
		134,
		80,
		77,
		97,
		116,
		122,
		114,
		154,
		110,
		81,
		75,
		93,
		98,
		116,
		108,
		-1,
		81,
		71,
		93,
		97,
		109,
		92,
		-1,
		-1,
		75,
		76,
		82,
		94,
		99,
		104,
		-1,
		130,
		149,
		-1,
		-1,
		65,
		78,
		74,
		77,
		85,
		101,
		122,
		139,
		144,
		-1,
		-1,
		66,
		70,
		83,
		84,
		82,
		109,
		128,
		139,
		153,
		152,
		-1,
		54,
		72,
		81,
		90,
		96,
		85,
		89,
		107,
		138,
		144,
		147,
		-1,
		46,
		48,
		77,
		83,
		95,
		101,
		88,
		94,
		113,
		126,
		145,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		49,
		43,
		51,
		77,
		76,
		72,
		90,
		112,
		91,
		97,
		101,
		118,
		134,
		135,
		145,
		-1,
		-1,
		99,
		68,
		103,
		60,
		45,
		-1,
		39,
		58,
		64,
		68,
		73,
		81,
		109,
		107,
		-1,
		112,
		111,
		142,
		128,
		139,
		59,
		-1,
		-1,
		57,
		49,
		34,
		37,
		34,
		34,
		64,
		63,
		68,
		70,
		72,
		84,
		99,
		99,
		109,
		106,
		116,
		120,
		135,
		146,
		-1,
		-1,
		213,
		-1,
		-1,
		56,
		39,
		-1,
		22,
		29,
		29,
		46,
		36,
		57,
		72,
		76,
		84,
		87,
		75,
		94,
		91,
		115,
		111,
		103,
		128,
		132,
		138,
		156,
		154,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		34,
		15,
		18,
		24,
		48,
		58,
		-1,
		79,
		77,
		101,
		95,
		100,
		96,
		81,
		99,
		97,
		112,
		114,
		110,
		112,
		149,
		135,
		157,
		154,
		183,
		188,
		182,
		191,
		-1,
		64,
		60,
		56,
		63,
		12,
		-1,
		-1,
		52,
		-1,
		66,
		79,
		91,
		81,
		84,
		96,
		104,
		103,
		87,
		105,
		100,
		103,
		115,
		118,
		127,
		130,
		129,
		147,
		162,
		175,
		179,
		185,
		-1,
		114,
		-1,
		56,
		40,
		42,
		14,
		35,
		-1,
		72,
		67,
		87,
		93,
		93,
		-1,
		109,
		106,
		119,
		103,
		88,
		105,
		107,
		109,
		114,
		119,
		133,
		124,
		142,
		149,
		157,
		161,
		181,
		193,
		74,
		64,
		-1,
		46,
		51,
		10,
		18,
		37,
		110,
		94,
		-1,
		104,
		-1,
		111,
		124,
		-1,
		109,
		105,
		94,
		102,
		97,
		112,
		118,
		115,
		112,
		130,
		133,
		150,
		154,
		170,
		-1,
		-1,
		59,
		63,
		52,
		3,
		22,
		46,
		83,
		103,
		111,
		110,
		-1,
		104,
		130,
		127,
		117,
		104,
		94,
		95,
		103,
		116,
		95,
		114,
		117,
		139,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		84,
		-1,
		-1,
		29,
		0,
		24,
		66,
		140,
		133,
		121,
		89,
		89,
		83,
		-1,
		124,
		107,
		103,
		92,
		90,
		103,
		98,
		114,
		118,
		117,
		136,
		148,
		139,
		159,
		-1,
		-1,
		-1,
		59,
		48,
		49,
		3,
		37,
		55,
		122,
		108,
		113,
		88,
		81,
		75,
		127,
		124,
		91,
		99,
		91,
		80,
		94,
		102,
		106,
		115,
		124,
		130,
		154,
		154,
		160,
		-1,
		-1,
		66,
		56,
		40,
		42,
		39,
		28,
		35,
		67,
		113,
		110,
		-1,
		80,
		-1,
		69,
		77,
		76,
		82,
		94,
		80,
		85,
		96,
		108,
		121,
		117,
		124,
		159,
		159,
		144,
		164,
		167,
		-1,
		-1,
		-1,
		59,
		76,
		51,
		28,
		9,
		45,
		-1,
		80,
		81,
		-1,
		74,
		68,
		74,
		73,
		80,
		77,
		77,
		91,
		99,
		95,
		111,
		117,
		109,
		145,
		-1,
		152,
		146,
		154,
		144,
		132,
		-1,
		-1,
		-1,
		74,
		53,
		46,
		66,
		16,
		68,
		-1,
		-1,
		65,
		58,
		-1,
		61,
		61,
		68,
		77,
		82,
		87,
		95,
		90,
		103,
		108,
		114,
		119,
		137,
		141,
		145,
		134,
		130,
		127,
		141,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		19,
		36,
		-1,
		73,
		65,
		56,
		50,
		56,
		74,
		72,
		92,
		84,
		98,
		98,
		104,
		112,
		97,
		100,
		116,
		114,
		132,
		140,
		132,
		126,
		125,
		137,
		-1,
		122,
		108,
		79,
		-1,
		-1,
		51,
		-1,
		22,
		46,
		62,
		-1,
		90,
		69,
		92,
		70,
		84,
		80,
		118,
		119,
		97,
		102,
		110,
		120,
		122,
		111,
		122,
		114,
		136,
		136,
		120,
		121,
		130,
		-1,
		128,
		115,
		73,
		69,
		58,
		78,
		25,
		38,
		49,
		-1,
		-1,
		134,
		-1,
		68,
		85,
		94,
		92,
		108,
		99,
		105,
		121,
		124,
		126,
		116,
		105,
		111,
		108,
		130,
		116,
		114,
		133,
		149,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		44,
		31,
		25,
		-1,
		66,
		-1,
		112,
		102,
		86,
		71,
		104,
		-1,
		116,
		100,
		105,
		-1,
		151,
		-1,
		124,
		126,
		120,
		105,
		102,
		113,
		111,
		122,
		139,
		-1,
		78,
		63,
		56,
		46,
		60,
		31,
		-1,
		82,
		-1,
		-1,
		99,
		93,
		93,
		77,
		80,
		132,
		112,
		106,
		105,
		146,
		146,
		132,
		118,
		111,
		108,
		105,
		118,
		138,
		129,
		141,
		-1,
		-1,
		-1,
		83,
		63,
		69,
		27,
		48,
		-1,
		-1,
		161,
		116,
		102,
		-1,
		86,
		149,
		137,
		127,
		117,
		151,
		152,
		137,
		130,
		116,
		118,
		116,
		114,
		119,
		140,
		141,
		154,
		-1,
		-1,
		60,
		67,
		55,
		41,
		60,
		-1,
		-1,
		-1,
		108,
		124,
		116,
		87,
		138,
		-1,
		-1,
		129,
		127,
		137,
		133,
		120,
		140,
		143,
		129,
		113,
		128,
		140,
		148,
		153,
		-1,
		63,
		50,
		-1,
		-1,
		63,
		57,
		-1,
		-1,
		-1,
		-1,
		141,
		107,
		119,
		140,
		165,
		132,
		-1,
		137,
		138,
		124,
		138,
		145,
		131,
		126,
		120,
		123,
		141,
		158,
		-1,
		-1,
		77,
		-1,
		72,
		-1,
		-1,
		-1,
		-1,
		98,
		112,
		133,
		139,
		151,
		-1,
		146,
		140,
		126,
		143,
		144,
		141,
		132,
		124,
		129,
		126,
		139,
		153,
		157,
		100,
		-1,
		83,
		-1,
		-1,
		-1,
		116,
		131,
		193,
		170,
		143,
		147,
		140,
		134,
		134,
		150,
		152,
		163,
		131,
		127,
		128,
		132,
		131,
		148,
		158,
		-1,
		-1,
		83,
		100,
		135,
		124,
		128,
		220,
		-1,
		-1,
		156,
		147,
		138,
		141,
		144,
		147,
		137,
		134,
		139,
		144,
		132,
		141,
		159,
		163,
		-1,
		-1,
		-1,
		103,
		-1,
		118,
		-1,
		-1,
		143,
		227,
		174,
		156,
		152,
		150,
		143,
		152,
		147,
		142,
		152,
		161,
		153,
		134,
		145,
		168,
		157,
		195,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		132,
		107,
		122,
		168,
		163,
		164,
		189,
		186,
		-1,
		156,
		181,
		153,
		160,
		152,
		160,
		160,
		157,
		135,
		142,
		158,
		157,
		152,
		187,
		179,
		185,
		-1,
		-1,
		213,
		202,
		191,
		197,
		-1,
		138,
		124,
		154,
		144,
		150,
		-1,
		-1,
		197,
		194,
		178,
		162,
		166,
		159,
		154,
		164,
		144,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		108,
		189,
		182,
		165,
		173,
		204,
		-1,
		141,
		150,
		131,
		136,
		144,
		-1,
		-1,
		170,
		166,
		171,
		169,
		166,
		174,
		169,
		160,
		145,
		151,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		122,
		165,
		159,
		162,
		186,
		200,
		-1,
		154,
		-1,
		-1,
		139,
		157,
		165,
		161,
		165,
		218,
		183,
		178,
		168,
		166,
		157,
		148,
		155,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		157,
		145,
		153,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		155,
		-1,
		191,
		-1,
		184,
		188,
		191,
		194,
		182,
		169,
		161,
		153,
		169,
		144,
		154,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		231,
		186,
		153,
		144,
		191,
		206,
		210,
		-1,
		167,
		206,
		193,
		-1,
		164,
		-1,
		-1,
		-1,
		198,
		204,
		196,
		202,
		181,
		181,
		155,
		159,
		149,
		156,
		166,
		168,
		160,
		164,
		177,
		188,
		191,
		227,
		225,
		230,
		175,
		158,
		176,
		185,
		206,
		182,
		173,
		200,
		200,
		189,
		184,
		171,
		-1,
		-1,
		221,
		214,
		-1,
		-1,
		188,
		176,
		159,
		160,
		156,
		159,
		174,
		177,
		167,
		165,
		159,
		191,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		166,
		177,
		-1,
		-1,
		185,
		201,
		214,
		218,
		231,
		256,
		-1,
		174,
		-1,
		-1,
		233,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		164,
		175,
		185,
		173,
		174,
		164,
		174,
		187,
		211,
		208,
		196,
		194,
		217,
		174,
		170,
		-1,
		200,
		188,
		194,
		201,
		218,
		245,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		216,
		214,
		203,
		-1,
		193,
		166,
		171,
		191,
		193,
		182,
		176,
		170,
		177,
		176,
		184,
		192,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		192,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		-1,
		225,
		200,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		184,
		188,
		180,
		173,
		168,
		179,
		171,
		175,
		192,
		-1,
		254,
		-1,
		206,
		199,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		242,
		228,
		221,
		209,
		207,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		174,
		185,
		174,
		177,
		191,
		186,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		237,
		256,
		-1,
		233,
		222,
		207,
		199,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		178,
		184,
		187,
		176,
		180,
		192,
		-1,
		-1,
		219,
		220,
		225,
		-1,
		246,
		-1,
		257,
		-1,
		202,
		218,
		220,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		207,
		205,
		196,
		182,
		189,
		187,
		183,
		194,
		-1,
		-1,
		-1,
		264,
		238,
		264,
		255,
		238,
		218,
		210,
		235,
		-1,
		206,
		-1,
		181,
		183,
		209,
		212,
		218,
		212,
		185,
		200,
		190,
		181,
		190,
		270,
		-1,
		240,
		273,
		237,
		224,
		207,
		211,
		227,
		-1,
		203,
		185,
		-1,
		213,
		203,
		234,
		219,
		200,
		187,
		194,
		194,
		187,
		-1,
		-1,
		-1,
		242,
		241,
		233,
		227,
		227,
		212,
		203,
		-1,
		215,
		197,
		176,
		193,
		193,
		184,
		192,
		224,
		220,
		207,
		207,
		199,
		-1,
		326,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		236,
		231,
		204,
		192,
		198,
		194,
		180,
		186,
		188,
		196,
		194,
		191,
		203,
		199,
		219,
		200,
		235,
		-1,
		333,
		-1,
		272,
		-1,
		-1,
		254,
		234,
		226,
		215,
		204,
		202,
		193,
		184,
		206,
		222,
		206,
		204,
		207,
		208,
		-1,
		327,
		326,
		-1,
		273,
		265,
		251,
		-1,
		244,
		-1,
		250,
		211,
		-1,
		213,
		193,
		-1,
		215,
		211,
		-1,
		-1,
		314,
		289,
		-1,
		-1,
		-1,
		274,
		254,
		245,
		229,
		-1,
		204,
		204,
		-1,
		-1,
		-1,
		299,
		298,
		-1,
		267,
		270,
		-1,
		260,
		251,
		259,
		206,
		210,
		-1,
		-1,
		-1,
		308,
		289,
		283,
		282,
		280,
		275,
		272,
		258,
		242,
		220,
		209,
		230,
		-1,
		-1,
		-1,
		280,
		272,
		265,
		-1,
		-1,
		267,
		250,
		231,
		229,
		-1,
		-1,
		-1,
		302,
		283,
		-1,
		-1,
		257,
		-1,
		-1,
		263,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		291,
		-1,
		-1,
		-1,
		253,
		249,
		250,
		-1,
		-1,
		-1,
		-1,
		313,
		314,
		337,
		301,
		-1,
		-1,
		-1,
		245,
		239,
		-1,
		-1,
		316,
		314,
		-1,
		-1,
		-1,
		273,
		257,
		-1,
		243,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		278,
		-1,
		278,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		291,
		283,
		291,
		-1,
		263,
		265,
		-1,
		313,
		-1,
		-1,
		306,
		297,
		-1,
		-1,
		268,
		275,
		297,
		300,
		336,
		-1,
		287
	],
	[
		-1,
		144,
		133,
		144,
		152,
		125,
		132,
		-1,
		153,
		155,
		121,
		115,
		154,
		125,
		131,
		142,
		-1,
		-1,
		-1,
		144,
		143,
		113,
		111,
		120,
		125,
		132,
		-1,
		155,
		-1,
		165,
		144,
		155,
		160,
		106,
		103,
		123,
		142,
		148,
		140,
		180,
		136,
		107,
		101,
		119,
		124,
		142,
		134,
		-1,
		107,
		97,
		119,
		123,
		135,
		118,
		-1,
		-1,
		101,
		102,
		108,
		120,
		125,
		130,
		-1,
		156,
		175,
		-1,
		-1,
		91,
		104,
		100,
		103,
		111,
		127,
		148,
		165,
		170,
		-1,
		-1,
		92,
		96,
		109,
		110,
		108,
		135,
		154,
		165,
		179,
		178,
		-1,
		80,
		98,
		107,
		116,
		122,
		111,
		115,
		133,
		164,
		170,
		173,
		-1,
		72,
		74,
		103,
		109,
		121,
		127,
		114,
		120,
		139,
		152,
		171,
		162,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		69,
		77,
		103,
		102,
		98,
		116,
		138,
		117,
		123,
		127,
		144,
		160,
		161,
		171,
		-1,
		-1,
		125,
		94,
		129,
		86,
		71,
		-1,
		65,
		84,
		90,
		94,
		99,
		107,
		135,
		133,
		-1,
		138,
		137,
		168,
		154,
		165,
		85,
		-1,
		-1,
		83,
		75,
		60,
		63,
		60,
		60,
		90,
		89,
		94,
		96,
		98,
		110,
		125,
		125,
		135,
		132,
		142,
		146,
		161,
		172,
		-1,
		-1,
		239,
		-1,
		-1,
		82,
		65,
		-1,
		48,
		55,
		55,
		72,
		62,
		83,
		98,
		102,
		110,
		113,
		101,
		120,
		117,
		141,
		137,
		129,
		154,
		158,
		164,
		182,
		180,
		-1,
		238,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		60,
		41,
		44,
		50,
		74,
		84,
		-1,
		105,
		103,
		127,
		121,
		126,
		122,
		107,
		125,
		123,
		138,
		140,
		136,
		138,
		175,
		161,
		183,
		180,
		209,
		214,
		208,
		217,
		-1,
		90,
		86,
		82,
		89,
		38,
		-1,
		-1,
		78,
		-1,
		92,
		105,
		117,
		107,
		110,
		122,
		130,
		129,
		113,
		131,
		126,
		129,
		141,
		144,
		153,
		156,
		155,
		173,
		188,
		201,
		205,
		211,
		-1,
		140,
		-1,
		82,
		66,
		68,
		40,
		61,
		-1,
		98,
		93,
		113,
		119,
		119,
		-1,
		135,
		132,
		145,
		129,
		114,
		131,
		133,
		135,
		140,
		145,
		159,
		150,
		168,
		175,
		183,
		187,
		207,
		219,
		100,
		90,
		-1,
		72,
		77,
		36,
		41,
		55,
		136,
		120,
		-1,
		130,
		-1,
		137,
		150,
		-1,
		135,
		131,
		120,
		128,
		123,
		138,
		144,
		141,
		138,
		156,
		159,
		176,
		180,
		196,
		-1,
		-1,
		85,
		89,
		70,
		29,
		10,
		34,
		71,
		122,
		131,
		133,
		-1,
		130,
		156,
		153,
		143,
		130,
		120,
		121,
		129,
		142,
		121,
		140,
		143,
		165,
		193,
		171,
		183,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		47,
		26,
		0,
		54,
		161,
		154,
		142,
		115,
		115,
		109,
		-1,
		150,
		133,
		129,
		118,
		116,
		129,
		124,
		140,
		144,
		143,
		162,
		174,
		165,
		185,
		-1,
		-1,
		-1,
		77,
		66,
		67,
		29,
		39,
		47,
		148,
		134,
		139,
		114,
		107,
		101,
		153,
		150,
		117,
		125,
		117,
		106,
		120,
		128,
		132,
		141,
		150,
		156,
		180,
		180,
		186,
		-1,
		-1,
		84,
		74,
		58,
		60,
		57,
		54,
		48,
		88,
		139,
		136,
		-1,
		106,
		-1,
		95,
		103,
		102,
		108,
		120,
		106,
		111,
		122,
		134,
		147,
		143,
		150,
		185,
		185,
		170,
		190,
		193,
		-1,
		-1,
		-1,
		77,
		102,
		77,
		54,
		35,
		62,
		-1,
		106,
		107,
		-1,
		100,
		94,
		100,
		99,
		106,
		103,
		103,
		117,
		125,
		121,
		137,
		143,
		135,
		171,
		-1,
		178,
		172,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		100,
		79,
		72,
		92,
		42,
		94,
		-1,
		-1,
		91,
		84,
		-1,
		87,
		87,
		94,
		103,
		108,
		113,
		121,
		116,
		129,
		134,
		140,
		145,
		163,
		167,
		171,
		160,
		156,
		153,
		167,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		62,
		-1,
		99,
		91,
		82,
		76,
		82,
		100,
		98,
		118,
		110,
		124,
		124,
		130,
		138,
		123,
		126,
		142,
		140,
		158,
		166,
		158,
		152,
		151,
		163,
		-1,
		148,
		134,
		105,
		-1,
		-1,
		77,
		-1,
		48,
		72,
		88,
		-1,
		116,
		95,
		118,
		96,
		110,
		106,
		144,
		145,
		123,
		128,
		136,
		146,
		148,
		137,
		148,
		140,
		162,
		162,
		146,
		147,
		156,
		-1,
		154,
		141,
		99,
		95,
		84,
		104,
		51,
		64,
		75,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		120,
		118,
		134,
		125,
		131,
		147,
		150,
		152,
		142,
		131,
		137,
		134,
		156,
		142,
		140,
		159,
		175,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		70,
		57,
		51,
		-1,
		92,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		142,
		126,
		131,
		-1,
		177,
		-1,
		150,
		152,
		146,
		131,
		128,
		139,
		137,
		148,
		165,
		-1,
		104,
		89,
		82,
		72,
		86,
		57,
		-1,
		108,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		158,
		138,
		132,
		131,
		172,
		172,
		158,
		144,
		137,
		134,
		131,
		144,
		164,
		155,
		167,
		-1,
		-1,
		-1,
		109,
		89,
		95,
		53,
		74,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		175,
		163,
		153,
		143,
		177,
		178,
		163,
		156,
		142,
		144,
		142,
		140,
		145,
		166,
		167,
		180,
		-1,
		-1,
		86,
		93,
		81,
		67,
		86,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		164,
		-1,
		-1,
		155,
		153,
		163,
		159,
		146,
		166,
		169,
		155,
		139,
		154,
		166,
		174,
		179,
		-1,
		89,
		76,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		145,
		166,
		191,
		158,
		-1,
		163,
		164,
		150,
		164,
		171,
		157,
		152,
		146,
		149,
		167,
		184,
		-1,
		-1,
		103,
		-1,
		98,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		159,
		165,
		177,
		-1,
		172,
		166,
		152,
		169,
		170,
		167,
		158,
		150,
		155,
		152,
		165,
		179,
		183,
		126,
		-1,
		109,
		-1,
		-1,
		-1,
		142,
		157,
		219,
		196,
		169,
		173,
		166,
		160,
		160,
		176,
		178,
		189,
		157,
		153,
		154,
		158,
		157,
		174,
		184,
		-1,
		-1,
		109,
		126,
		161,
		150,
		154,
		246,
		-1,
		-1,
		182,
		173,
		164,
		167,
		170,
		173,
		163,
		160,
		165,
		170,
		158,
		167,
		185,
		189,
		-1,
		-1,
		-1,
		129,
		-1,
		144,
		-1,
		-1,
		169,
		253,
		200,
		182,
		178,
		176,
		169,
		178,
		173,
		168,
		178,
		187,
		179,
		160,
		171,
		194,
		183,
		221,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		158,
		133,
		148,
		194,
		189,
		190,
		215,
		212,
		-1,
		182,
		207,
		179,
		186,
		178,
		186,
		186,
		183,
		161,
		168,
		184,
		183,
		178,
		213,
		205,
		211,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		164,
		150,
		180,
		170,
		176,
		-1,
		-1,
		223,
		220,
		204,
		188,
		192,
		185,
		180,
		190,
		170,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		134,
		215,
		208,
		191,
		199,
		230,
		-1,
		167,
		176,
		157,
		162,
		170,
		-1,
		-1,
		196,
		192,
		197,
		195,
		192,
		200,
		195,
		186,
		171,
		177,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		148,
		191,
		185,
		188,
		212,
		226,
		-1,
		180,
		-1,
		-1,
		165,
		183,
		191,
		187,
		191,
		244,
		209,
		204,
		194,
		192,
		183,
		174,
		181,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		183,
		171,
		179,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		181,
		-1,
		217,
		-1,
		210,
		214,
		217,
		220,
		208,
		195,
		187,
		179,
		195,
		170,
		180,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		257,
		212,
		179,
		170,
		217,
		232,
		236,
		-1,
		193,
		232,
		219,
		-1,
		190,
		-1,
		-1,
		-1,
		224,
		230,
		222,
		228,
		207,
		207,
		181,
		185,
		175,
		182,
		192,
		194,
		186,
		190,
		203,
		214,
		217,
		253,
		251,
		256,
		201,
		184,
		202,
		211,
		232,
		208,
		199,
		226,
		226,
		215,
		210,
		197,
		-1,
		-1,
		247,
		240,
		-1,
		-1,
		214,
		202,
		185,
		186,
		182,
		185,
		200,
		203,
		193,
		191,
		185,
		217,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		192,
		203,
		-1,
		-1,
		211,
		227,
		240,
		244,
		257,
		282,
		-1,
		200,
		-1,
		-1,
		259,
		-1,
		-1,
		244,
		207,
		196,
		187,
		193,
		190,
		201,
		211,
		199,
		200,
		190,
		200,
		213,
		237,
		234,
		222,
		220,
		243,
		200,
		196,
		-1,
		226,
		214,
		220,
		227,
		244,
		271,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		242,
		240,
		229,
		-1,
		219,
		192,
		197,
		217,
		219,
		208,
		202,
		196,
		203,
		202,
		210,
		218,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		226,
		-1,
		-1,
		237,
		230,
		218,
		206,
		196,
		206,
		210,
		214,
		206,
		199,
		194,
		205,
		197,
		201,
		218,
		-1,
		280,
		-1,
		232,
		225,
		240,
		255,
		263,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		271,
		255,
		236,
		-1,
		206,
		219,
		250,
		218,
		223,
		218,
		200,
		211,
		200,
		203,
		217,
		212,
		-1,
		-1,
		238,
		241,
		-1,
		-1,
		263,
		282,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		243,
		239,
		-1,
		-1,
		207,
		232,
		221,
		229,
		224,
		204,
		210,
		213,
		202,
		206,
		218,
		-1,
		-1,
		245,
		246,
		251,
		-1,
		272,
		-1,
		283,
		-1,
		228,
		244,
		246,
		-1,
		-1,
		-1,
		245,
		208,
		229,
		239,
		233,
		231,
		222,
		208,
		215,
		213,
		209,
		220,
		-1,
		-1,
		-1,
		290,
		264,
		290,
		281,
		264,
		244,
		236,
		261,
		-1,
		232,
		-1,
		207,
		209,
		235,
		238,
		244,
		238,
		211,
		226,
		216,
		207,
		216,
		296,
		-1,
		266,
		299,
		263,
		250,
		233,
		237,
		253,
		-1,
		229,
		211,
		-1,
		239,
		229,
		260,
		245,
		226,
		213,
		220,
		220,
		213,
		-1,
		-1,
		-1,
		268,
		267,
		259,
		253,
		253,
		238,
		229,
		-1,
		241,
		223,
		202,
		219,
		219,
		210,
		218,
		250,
		246,
		233,
		233,
		225,
		-1,
		352,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		262,
		257,
		230,
		218,
		224,
		220,
		206,
		212,
		214,
		222,
		220,
		217,
		229,
		225,
		245,
		226,
		261,
		-1,
		359,
		-1,
		298,
		-1,
		-1,
		280,
		260,
		252,
		241,
		230,
		228,
		219,
		210,
		232,
		248,
		232,
		230,
		233,
		234,
		-1,
		353,
		352,
		-1,
		299,
		291,
		277,
		-1,
		270,
		-1,
		276,
		237,
		-1,
		239,
		219,
		-1,
		241,
		237,
		-1,
		-1,
		340,
		315,
		-1,
		-1,
		-1,
		300,
		280,
		271,
		255,
		-1,
		230,
		230,
		-1,
		-1,
		-1,
		325,
		324,
		-1,
		293,
		296,
		-1,
		286,
		277,
		285,
		232,
		236,
		-1,
		-1,
		-1,
		334,
		315,
		309,
		308,
		306,
		301,
		298,
		284,
		268,
		246,
		235,
		256,
		-1,
		-1,
		-1,
		306,
		298,
		291,
		-1,
		-1,
		293,
		276,
		257,
		255,
		-1,
		-1,
		-1,
		328,
		309,
		-1,
		-1,
		283,
		-1,
		-1,
		289,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		345,
		317,
		-1,
		-1,
		-1,
		279,
		275,
		276,
		-1,
		-1,
		-1,
		-1,
		339,
		340,
		363,
		327,
		-1,
		-1,
		-1,
		271,
		265,
		-1,
		-1,
		342,
		340,
		-1,
		-1,
		-1,
		299,
		283,
		-1,
		269,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		304,
		-1,
		304,
		279,
		286,
		-1,
		-1,
		-1,
		-1,
		317,
		309,
		317,
		-1,
		289,
		291,
		-1,
		339,
		-1,
		-1,
		332,
		323,
		-1,
		-1,
		294,
		301,
		323,
		326,
		362,
		-1,
		313
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		189,
		191,
		157,
		151,
		190,
		161,
		167,
		178,
		-1,
		-1,
		-1,
		180,
		179,
		149,
		147,
		156,
		161,
		168,
		-1,
		191,
		-1,
		201,
		180,
		191,
		196,
		142,
		139,
		159,
		178,
		184,
		176,
		216,
		172,
		143,
		137,
		155,
		160,
		178,
		170,
		-1,
		143,
		133,
		155,
		159,
		171,
		154,
		-1,
		-1,
		137,
		138,
		144,
		156,
		161,
		166,
		-1,
		192,
		211,
		-1,
		-1,
		127,
		140,
		136,
		139,
		147,
		163,
		184,
		201,
		206,
		-1,
		-1,
		128,
		132,
		145,
		146,
		144,
		171,
		190,
		201,
		215,
		214,
		-1,
		116,
		134,
		143,
		152,
		158,
		147,
		151,
		169,
		200,
		206,
		209,
		-1,
		108,
		110,
		139,
		145,
		157,
		163,
		150,
		156,
		175,
		188,
		207,
		198,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		105,
		113,
		139,
		138,
		134,
		152,
		174,
		153,
		159,
		163,
		180,
		196,
		197,
		207,
		-1,
		-1,
		161,
		130,
		165,
		122,
		107,
		-1,
		101,
		120,
		126,
		130,
		135,
		143,
		171,
		169,
		-1,
		174,
		173,
		204,
		190,
		201,
		121,
		-1,
		-1,
		119,
		111,
		96,
		99,
		96,
		96,
		126,
		125,
		130,
		132,
		134,
		146,
		161,
		161,
		171,
		168,
		178,
		182,
		197,
		208,
		-1,
		-1,
		275,
		-1,
		-1,
		118,
		101,
		-1,
		84,
		91,
		91,
		108,
		98,
		119,
		134,
		138,
		146,
		149,
		137,
		156,
		153,
		177,
		173,
		165,
		190,
		194,
		200,
		218,
		216,
		-1,
		274,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		77,
		80,
		86,
		110,
		120,
		-1,
		112,
		118,
		142,
		145,
		157,
		158,
		143,
		161,
		159,
		174,
		176,
		172,
		174,
		211,
		197,
		219,
		216,
		245,
		250,
		244,
		253,
		-1,
		126,
		122,
		118,
		125,
		74,
		-1,
		-1,
		114,
		-1,
		101,
		129,
		104,
		122,
		125,
		146,
		146,
		165,
		149,
		167,
		162,
		165,
		177,
		180,
		189,
		192,
		191,
		209,
		224,
		237,
		241,
		247,
		-1,
		176,
		-1,
		118,
		102,
		104,
		76,
		97,
		-1,
		134,
		100,
		121,
		106,
		97,
		-1,
		150,
		147,
		161,
		165,
		150,
		167,
		169,
		171,
		176,
		181,
		195,
		186,
		204,
		211,
		219,
		223,
		243,
		255,
		136,
		126,
		-1,
		108,
		113,
		72,
		77,
		91,
		104,
		68,
		-1,
		98,
		-1,
		152,
		165,
		-1,
		167,
		167,
		156,
		164,
		159,
		174,
		180,
		177,
		174,
		192,
		195,
		212,
		216,
		232,
		-1,
		-1,
		121,
		125,
		106,
		65,
		42,
		18,
		17,
		68,
		77,
		79,
		-1,
		145,
		192,
		189,
		179,
		166,
		156,
		157,
		165,
		178,
		157,
		176,
		179,
		201,
		229,
		207,
		219,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		83,
		62,
		50,
		0,
		107,
		100,
		88,
		113,
		113,
		120,
		-1,
		186,
		169,
		165,
		154,
		152,
		165,
		160,
		176,
		180,
		179,
		198,
		210,
		201,
		221,
		-1,
		-1,
		-1,
		113,
		102,
		103,
		65,
		81,
		89,
		146,
		132,
		137,
		112,
		118,
		123,
		189,
		186,
		153,
		161,
		153,
		142,
		156,
		164,
		168,
		177,
		186,
		192,
		216,
		216,
		222,
		-1,
		-1,
		120,
		110,
		94,
		96,
		93,
		90,
		90,
		129,
		137,
		172,
		-1,
		142,
		-1,
		129,
		139,
		138,
		144,
		156,
		142,
		147,
		158,
		170,
		183,
		179,
		186,
		221,
		221,
		206,
		226,
		229,
		-1,
		-1,
		-1,
		113,
		138,
		113,
		90,
		71,
		104,
		-1,
		142,
		143,
		-1,
		136,
		130,
		136,
		135,
		142,
		139,
		139,
		153,
		161,
		157,
		173,
		179,
		171,
		207,
		-1,
		214,
		208,
		216,
		206,
		194,
		-1,
		-1,
		-1,
		136,
		115,
		108,
		128,
		78,
		130,
		-1,
		-1,
		127,
		120,
		-1,
		123,
		123,
		130,
		139,
		144,
		149,
		157,
		152,
		165,
		170,
		176,
		181,
		199,
		203,
		207,
		196,
		192,
		189,
		203,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		98,
		-1,
		135,
		127,
		118,
		112,
		118,
		136,
		134,
		154,
		146,
		160,
		160,
		166,
		174,
		159,
		162,
		178,
		176,
		194,
		202,
		194,
		188,
		187,
		199,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		113,
		-1,
		84,
		108,
		124,
		-1,
		152,
		131,
		154,
		132,
		146,
		142,
		180,
		181,
		159,
		164,
		172,
		182,
		184,
		173,
		184,
		176,
		198,
		198,
		182,
		183,
		192,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		87,
		100,
		111,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		156,
		154,
		170,
		161,
		167,
		183,
		186,
		188,
		178,
		167,
		173,
		170,
		192,
		178,
		176,
		195,
		211,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		178,
		162,
		167,
		-1,
		213,
		-1,
		186,
		188,
		182,
		167,
		164,
		175,
		173,
		184,
		201,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		144,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		194,
		174,
		168,
		167,
		208,
		208,
		194,
		180,
		173,
		170,
		167,
		180,
		200,
		191,
		203,
		-1,
		-1,
		-1,
		145,
		125,
		131,
		89,
		110,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		148,
		211,
		199,
		189,
		179,
		213,
		214,
		199,
		192,
		178,
		180,
		178,
		176,
		181,
		202,
		203,
		216,
		-1,
		-1,
		122,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		170,
		186,
		178,
		149,
		200,
		-1,
		-1,
		191,
		189,
		199,
		195,
		182,
		202,
		205,
		191,
		175,
		190,
		202,
		210,
		215,
		-1,
		125,
		112,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		181,
		202,
		227,
		194,
		-1,
		199,
		200,
		186,
		200,
		207,
		193,
		188,
		182,
		185,
		203,
		220,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		160,
		174,
		195,
		201,
		213,
		-1,
		208,
		202,
		188,
		205,
		206,
		203,
		194,
		186,
		191,
		188,
		201,
		215,
		219,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		178,
		193,
		255,
		232,
		205,
		209,
		202,
		196,
		196,
		212,
		214,
		225,
		193,
		189,
		190,
		194,
		193,
		210,
		220,
		-1,
		-1,
		145,
		162,
		197,
		186,
		190,
		282,
		-1,
		-1,
		218,
		209,
		200,
		203,
		206,
		209,
		199,
		196,
		201,
		206,
		194,
		203,
		221,
		225,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		205,
		289,
		236,
		218,
		214,
		212,
		205,
		214,
		209,
		204,
		214,
		223,
		215,
		196,
		207,
		230,
		219,
		257,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		194,
		169,
		184,
		230,
		225,
		226,
		251,
		248,
		-1,
		218,
		243,
		215,
		222,
		214,
		222,
		222,
		219,
		197,
		204,
		220,
		219,
		214,
		249,
		241,
		247,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		200,
		186,
		216,
		206,
		212,
		-1,
		-1,
		259,
		256,
		240,
		224,
		228,
		221,
		216,
		226,
		206,
		193,
		197,
		201,
		207,
		212,
		217,
		223,
		238,
		253,
		-1,
		170,
		251,
		244,
		227,
		235,
		266,
		-1,
		203,
		212,
		193,
		198,
		206,
		-1,
		-1,
		232,
		228,
		233,
		231,
		228,
		236,
		231,
		222,
		207,
		213,
		200,
		199,
		217,
		221,
		230,
		237,
		227,
		240,
		244,
		-1,
		184,
		227,
		221,
		224,
		248,
		262,
		-1,
		216,
		-1,
		-1,
		201,
		219,
		227,
		223,
		227,
		280,
		245,
		240,
		230,
		228,
		219,
		210,
		217,
		208,
		208,
		211,
		226,
		231,
		223,
		237,
		237,
		238,
		-1,
		219,
		207,
		215,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		217,
		-1,
		253,
		-1,
		246,
		250,
		253,
		256,
		244,
		231,
		223,
		215,
		231,
		206,
		216,
		212,
		213,
		222,
		233,
		245,
		244,
		245,
		293,
		248,
		215,
		206,
		253,
		268,
		272,
		-1,
		229,
		268,
		255,
		-1,
		226,
		-1,
		-1,
		-1,
		260,
		266,
		258,
		264,
		243,
		243,
		217,
		221,
		211,
		218,
		228,
		230,
		222,
		226,
		239,
		250,
		253,
		289,
		287,
		292,
		237,
		220,
		238,
		247,
		268,
		244,
		235,
		262,
		262,
		251,
		246,
		233,
		-1,
		-1,
		283,
		276,
		-1,
		-1,
		250,
		238,
		221,
		222,
		218,
		221,
		236,
		239,
		229,
		227,
		221,
		253,
		-1,
		289,
		288,
		277,
		274,
		250,
		241,
		228,
		239,
		-1,
		-1,
		247,
		263,
		276,
		280,
		293,
		318,
		-1,
		236,
		-1,
		-1,
		295,
		-1,
		-1,
		280,
		243,
		232,
		223,
		229,
		226,
		237,
		247,
		235,
		236,
		226,
		236,
		249,
		273,
		270,
		258,
		256,
		279,
		236,
		232,
		-1,
		262,
		250,
		256,
		263,
		280,
		307,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		278,
		276,
		265,
		-1,
		255,
		228,
		233,
		253,
		255,
		244,
		238,
		232,
		239,
		238,
		246,
		254,
		282,
		296,
		285,
		281,
		280,
		288,
		237,
		254,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		-1,
		287,
		262,
		-1,
		-1,
		273,
		266,
		254,
		242,
		232,
		242,
		246,
		250,
		242,
		235,
		230,
		241,
		233,
		237,
		254,
		-1,
		316,
		-1,
		268,
		261,
		276,
		291,
		299,
		-1,
		-1,
		-1,
		304,
		290,
		283,
		271,
		269,
		-1,
		307,
		291,
		272,
		-1,
		242,
		255,
		286,
		254,
		259,
		254,
		236,
		247,
		236,
		239,
		253,
		248,
		-1,
		-1,
		274,
		277,
		-1,
		-1,
		299,
		318,
		-1,
		295,
		284,
		269,
		261,
		-1,
		-1,
		279,
		275,
		-1,
		-1,
		243,
		268,
		257,
		265,
		260,
		240,
		246,
		249,
		238,
		242,
		254,
		-1,
		-1,
		281,
		282,
		287,
		-1,
		308,
		-1,
		319,
		-1,
		264,
		280,
		282,
		-1,
		-1,
		-1,
		281,
		244,
		265,
		275,
		269,
		267,
		258,
		244,
		251,
		249,
		245,
		256,
		-1,
		-1,
		-1,
		326,
		300,
		326,
		317,
		300,
		280,
		272,
		297,
		-1,
		268,
		-1,
		243,
		245,
		271,
		274,
		280,
		274,
		247,
		262,
		252,
		243,
		252,
		332,
		-1,
		302,
		335,
		299,
		286,
		269,
		273,
		289,
		-1,
		265,
		247,
		-1,
		275,
		265,
		296,
		281,
		262,
		249,
		256,
		256,
		249,
		-1,
		-1,
		-1,
		304,
		303,
		295,
		289,
		289,
		274,
		265,
		-1,
		277,
		259,
		238,
		255,
		255,
		246,
		254,
		286,
		282,
		269,
		269,
		261,
		-1,
		388,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		298,
		293,
		266,
		254,
		260,
		256,
		242,
		248,
		250,
		258,
		256,
		253,
		265,
		261,
		281,
		262,
		297,
		-1,
		395,
		-1,
		334,
		-1,
		-1,
		316,
		296,
		288,
		277,
		266,
		264,
		255,
		246,
		268,
		284,
		268,
		266,
		269,
		270,
		-1,
		389,
		388,
		-1,
		335,
		327,
		313,
		-1,
		306,
		-1,
		312,
		273,
		-1,
		275,
		255,
		-1,
		277,
		273,
		-1,
		-1,
		376,
		351,
		-1,
		-1,
		-1,
		336,
		316,
		307,
		291,
		-1,
		266,
		266,
		-1,
		-1,
		-1,
		361,
		360,
		-1,
		329,
		332,
		-1,
		322,
		313,
		321,
		268,
		272,
		-1,
		-1,
		-1,
		370,
		351,
		345,
		344,
		342,
		337,
		334,
		320,
		304,
		282,
		271,
		292,
		-1,
		-1,
		-1,
		342,
		334,
		327,
		-1,
		-1,
		329,
		312,
		293,
		291,
		-1,
		-1,
		-1,
		364,
		345,
		-1,
		-1,
		319,
		-1,
		-1,
		325,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		381,
		353,
		-1,
		-1,
		-1,
		315,
		311,
		312,
		-1,
		-1,
		-1,
		-1,
		375,
		376,
		399,
		363,
		-1,
		-1,
		-1,
		307,
		301,
		-1,
		-1,
		378,
		376,
		-1,
		-1,
		-1,
		335,
		319,
		-1,
		305,
		-1,
		-1,
		-1,
		326,
		-1,
		-1,
		338,
		-1,
		-1,
		-1,
		340,
		-1,
		340,
		315,
		322,
		-1,
		-1,
		-1,
		-1,
		353,
		345,
		353,
		-1,
		325,
		327,
		-1,
		375,
		-1,
		-1,
		368,
		359,
		-1,
		-1,
		330,
		337,
		359,
		362,
		398,
		-1,
		349
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		197,
		199,
		165,
		159,
		198,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		188,
		187,
		157,
		155,
		164,
		169,
		176,
		-1,
		199,
		-1,
		209,
		188,
		199,
		204,
		150,
		147,
		167,
		186,
		192,
		184,
		224,
		180,
		151,
		145,
		163,
		168,
		186,
		178,
		-1,
		151,
		141,
		163,
		167,
		179,
		162,
		-1,
		-1,
		145,
		146,
		152,
		164,
		169,
		174,
		-1,
		200,
		205,
		-1,
		-1,
		135,
		148,
		144,
		147,
		155,
		171,
		192,
		205,
		200,
		-1,
		-1,
		136,
		140,
		153,
		154,
		152,
		179,
		198,
		195,
		209,
		208,
		-1,
		124,
		142,
		151,
		160,
		166,
		155,
		159,
		177,
		194,
		200,
		203,
		-1,
		116,
		118,
		143,
		151,
		156,
		163,
		158,
		164,
		183,
		182,
		201,
		192,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		113,
		121,
		143,
		135,
		131,
		144,
		161,
		161,
		167,
		171,
		174,
		190,
		191,
		201,
		-1,
		-1,
		196,
		169,
		193,
		151,
		139,
		-1,
		109,
		119,
		124,
		128,
		129,
		131,
		158,
		156,
		-1,
		168,
		167,
		198,
		184,
		195,
		178,
		-1,
		-1,
		154,
		146,
		128,
		131,
		108,
		104,
		116,
		115,
		113,
		109,
		105,
		134,
		146,
		144,
		154,
		162,
		172,
		176,
		187,
		202,
		-1,
		-1,
		257,
		-1,
		-1,
		175,
		158,
		-1,
		123,
		130,
		114,
		120,
		106,
		99,
		126,
		102,
		101,
		120,
		108,
		128,
		138,
		161,
		158,
		159,
		184,
		188,
		182,
		203,
		198,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		130,
		127,
		120,
		124,
		112,
		-1,
		61,
		67,
		91,
		94,
		106,
		119,
		114,
		144,
		144,
		159,
		161,
		166,
		168,
		201,
		179,
		201,
		198,
		227,
		232,
		226,
		235,
		-1,
		183,
		179,
		175,
		182,
		131,
		-1,
		-1,
		120,
		-1,
		78,
		78,
		53,
		71,
		74,
		95,
		95,
		126,
		120,
		138,
		147,
		150,
		159,
		168,
		179,
		174,
		173,
		191,
		206,
		219,
		223,
		229,
		-1,
		233,
		-1,
		175,
		159,
		161,
		137,
		165,
		-1,
		132,
		77,
		70,
		55,
		46,
		-1,
		99,
		96,
		110,
		117,
		122,
		139,
		154,
		153,
		158,
		163,
		177,
		168,
		186,
		193,
		201,
		205,
		225,
		237,
		193,
		183,
		-1,
		165,
		170,
		140,
		152,
		174,
		81,
		45,
		-1,
		47,
		-1,
		101,
		114,
		-1,
		116,
		120,
		128,
		144,
		141,
		156,
		162,
		159,
		156,
		174,
		177,
		194,
		198,
		214,
		-1,
		-1,
		178,
		182,
		189,
		140,
		147,
		123,
		91,
		38,
		27,
		28,
		-1,
		94,
		147,
		144,
		145,
		147,
		138,
		139,
		147,
		160,
		139,
		158,
		161,
		183,
		211,
		189,
		201,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		166,
		137,
		155,
		105,
		0,
		2,
		33,
		62,
		62,
		69,
		-1,
		167,
		150,
		147,
		136,
		134,
		147,
		142,
		158,
		162,
		161,
		180,
		192,
		183,
		203,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		95,
		81,
		86,
		61,
		67,
		72,
		156,
		165,
		134,
		143,
		135,
		124,
		138,
		146,
		150,
		159,
		168,
		174,
		198,
		198,
		204,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		86,
		170,
		-1,
		105,
		-1,
		78,
		112,
		120,
		126,
		138,
		124,
		129,
		140,
		152,
		165,
		161,
		168,
		203,
		203,
		188,
		208,
		211,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		99,
		93,
		109,
		117,
		124,
		121,
		121,
		135,
		143,
		139,
		155,
		161,
		153,
		189,
		-1,
		196,
		190,
		198,
		188,
		176,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		96,
		105,
		112,
		121,
		126,
		131,
		139,
		134,
		147,
		152,
		158,
		163,
		181,
		185,
		189,
		178,
		174,
		171,
		185,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		118,
		116,
		136,
		128,
		142,
		142,
		148,
		156,
		141,
		144,
		160,
		158,
		176,
		184,
		176,
		170,
		169,
		181,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		128,
		124,
		162,
		163,
		141,
		146,
		154,
		164,
		166,
		155,
		166,
		158,
		180,
		180,
		164,
		165,
		174,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		138,
		136,
		152,
		143,
		149,
		165,
		168,
		170,
		160,
		149,
		155,
		152,
		174,
		160,
		158,
		177,
		193,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		160,
		144,
		149,
		-1,
		195,
		-1,
		168,
		170,
		164,
		149,
		146,
		157,
		155,
		166,
		183,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		176,
		156,
		150,
		149,
		190,
		190,
		176,
		162,
		155,
		152,
		149,
		162,
		182,
		173,
		185,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		193,
		181,
		171,
		161,
		195,
		196,
		181,
		174,
		160,
		162,
		160,
		158,
		163,
		184,
		185,
		198,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		182,
		-1,
		-1,
		173,
		171,
		181,
		177,
		164,
		184,
		187,
		173,
		157,
		172,
		184,
		192,
		197,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		184,
		209,
		176,
		-1,
		181,
		182,
		168,
		182,
		189,
		175,
		170,
		164,
		167,
		185,
		202,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		177,
		183,
		195,
		-1,
		190,
		184,
		170,
		187,
		188,
		185,
		176,
		168,
		173,
		170,
		183,
		197,
		201,
		191,
		-1,
		174,
		-1,
		-1,
		-1,
		160,
		175,
		237,
		214,
		187,
		191,
		184,
		178,
		178,
		194,
		196,
		207,
		175,
		171,
		172,
		176,
		175,
		192,
		202,
		-1,
		-1,
		174,
		191,
		186,
		168,
		172,
		264,
		-1,
		-1,
		200,
		191,
		182,
		185,
		188,
		191,
		181,
		178,
		183,
		188,
		176,
		185,
		203,
		207,
		-1,
		-1,
		-1,
		194,
		-1,
		209,
		-1,
		-1,
		187,
		271,
		218,
		200,
		196,
		194,
		187,
		196,
		191,
		186,
		196,
		205,
		197,
		178,
		189,
		212,
		201,
		239,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		223,
		198,
		213,
		259,
		207,
		214,
		233,
		230,
		-1,
		200,
		225,
		197,
		204,
		196,
		204,
		204,
		201,
		179,
		186,
		202,
		201,
		196,
		231,
		223,
		229,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		229,
		215,
		245,
		235,
		224,
		-1,
		-1,
		249,
		246,
		222,
		206,
		210,
		203,
		198,
		208,
		188,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		201,
		282,
		275,
		258,
		266,
		297,
		-1,
		232,
		241,
		222,
		227,
		235,
		-1,
		-1,
		222,
		219,
		224,
		213,
		210,
		218,
		213,
		204,
		189,
		195,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		215,
		258,
		252,
		255,
		279,
		293,
		-1,
		245,
		-1,
		-1,
		230,
		248,
		237,
		227,
		221,
		271,
		227,
		222,
		212,
		210,
		201,
		192,
		199,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		250,
		238,
		246,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		246,
		-1,
		264,
		-1,
		239,
		243,
		235,
		238,
		226,
		213,
		205,
		197,
		213,
		188,
		198,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		324,
		279,
		246,
		237,
		284,
		299,
		303,
		-1,
		258,
		297,
		284,
		-1,
		255,
		-1,
		-1,
		-1,
		253,
		248,
		240,
		246,
		225,
		225,
		199,
		203,
		193,
		200,
		210,
		212,
		204,
		208,
		221,
		232,
		235,
		320,
		318,
		323,
		268,
		251,
		269,
		278,
		299,
		273,
		264,
		291,
		291,
		280,
		275,
		262,
		-1,
		-1,
		276,
		258,
		-1,
		-1,
		232,
		220,
		203,
		204,
		200,
		203,
		218,
		221,
		211,
		209,
		203,
		235,
		-1,
		320,
		319,
		308,
		305,
		281,
		272,
		259,
		270,
		-1,
		-1,
		276,
		292,
		305,
		309,
		322,
		347,
		-1,
		265,
		-1,
		-1,
		277,
		-1,
		-1,
		262,
		225,
		214,
		205,
		211,
		208,
		219,
		229,
		217,
		218,
		208,
		218,
		231,
		304,
		301,
		289,
		287,
		310,
		267,
		263,
		-1,
		286,
		279,
		285,
		292,
		309,
		336,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		260,
		258,
		247,
		-1,
		237,
		210,
		215,
		235,
		237,
		226,
		220,
		214,
		221,
		220,
		228,
		236,
		313,
		327,
		316,
		312,
		311,
		319,
		268,
		271,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		-1,
		298,
		291,
		-1,
		-1,
		255,
		248,
		236,
		224,
		214,
		224,
		228,
		232,
		224,
		217,
		212,
		223,
		215,
		219,
		236,
		-1,
		347,
		-1,
		299,
		285,
		299,
		314,
		322,
		-1,
		-1,
		-1,
		315,
		301,
		294,
		282,
		280,
		-1,
		289,
		273,
		254,
		-1,
		224,
		237,
		268,
		236,
		241,
		236,
		218,
		229,
		218,
		221,
		235,
		230,
		-1,
		-1,
		297,
		300,
		-1,
		-1,
		305,
		307,
		-1,
		306,
		295,
		280,
		272,
		-1,
		-1,
		261,
		257,
		-1,
		-1,
		225,
		250,
		239,
		247,
		242,
		222,
		228,
		231,
		220,
		224,
		236,
		-1,
		-1,
		304,
		305,
		310,
		-1,
		290,
		-1,
		308,
		-1,
		275,
		281,
		269,
		-1,
		-1,
		-1,
		263,
		226,
		247,
		257,
		251,
		249,
		240,
		226,
		233,
		231,
		227,
		238,
		-1,
		-1,
		-1,
		308,
		282,
		315,
		306,
		289,
		269,
		261,
		280,
		-1,
		250,
		-1,
		225,
		227,
		253,
		256,
		262,
		256,
		229,
		244,
		234,
		225,
		234,
		314,
		-1,
		284,
		317,
		281,
		275,
		251,
		255,
		271,
		-1,
		247,
		229,
		-1,
		257,
		247,
		278,
		263,
		244,
		231,
		238,
		238,
		231,
		-1,
		-1,
		-1,
		286,
		285,
		277,
		271,
		271,
		256,
		247,
		-1,
		259,
		241,
		220,
		237,
		237,
		228,
		236,
		268,
		264,
		251,
		251,
		243,
		-1,
		387,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		280,
		275,
		248,
		236,
		242,
		238,
		224,
		230,
		232,
		240,
		238,
		235,
		247,
		243,
		263,
		244,
		279,
		-1,
		382,
		-1,
		316,
		-1,
		-1,
		298,
		278,
		270,
		259,
		248,
		246,
		237,
		228,
		250,
		266,
		250,
		248,
		251,
		252,
		-1,
		371,
		370,
		-1,
		317,
		309,
		295,
		-1,
		288,
		-1,
		294,
		255,
		-1,
		257,
		237,
		-1,
		259,
		255,
		-1,
		-1,
		358,
		333,
		-1,
		-1,
		-1,
		318,
		298,
		289,
		273,
		-1,
		248,
		248,
		-1,
		-1,
		-1,
		343,
		342,
		-1,
		311,
		314,
		-1,
		304,
		295,
		303,
		250,
		254,
		-1,
		-1,
		-1,
		352,
		333,
		327,
		326,
		324,
		319,
		316,
		302,
		286,
		264,
		253,
		274,
		-1,
		-1,
		-1,
		324,
		316,
		309,
		-1,
		-1,
		311,
		294,
		275,
		273,
		-1,
		-1,
		-1,
		346,
		327,
		-1,
		-1,
		301,
		-1,
		-1,
		307,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		363,
		335,
		-1,
		-1,
		-1,
		297,
		293,
		294,
		-1,
		-1,
		-1,
		-1,
		357,
		358,
		381,
		345,
		-1,
		-1,
		-1,
		289,
		283,
		-1,
		-1,
		360,
		358,
		-1,
		-1,
		-1,
		317,
		301,
		-1,
		287,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		322,
		-1,
		322,
		297,
		304,
		-1,
		-1,
		-1,
		-1,
		335,
		327,
		335,
		-1,
		307,
		309,
		-1,
		357,
		-1,
		-1,
		350,
		341,
		-1,
		-1,
		312,
		319,
		341,
		344,
		380,
		-1,
		331
	],
	[
		-1,
		186,
		175,
		186,
		194,
		167,
		174,
		-1,
		195,
		197,
		163,
		157,
		196,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		186,
		185,
		155,
		153,
		162,
		167,
		174,
		-1,
		197,
		-1,
		207,
		186,
		197,
		202,
		148,
		145,
		165,
		184,
		190,
		182,
		222,
		178,
		149,
		143,
		161,
		166,
		184,
		176,
		-1,
		149,
		139,
		161,
		165,
		177,
		160,
		-1,
		-1,
		143,
		144,
		150,
		162,
		167,
		172,
		-1,
		198,
		203,
		-1,
		-1,
		133,
		146,
		142,
		145,
		153,
		169,
		190,
		203,
		198,
		-1,
		-1,
		134,
		138,
		151,
		152,
		150,
		177,
		196,
		193,
		207,
		206,
		-1,
		122,
		140,
		149,
		158,
		164,
		153,
		157,
		175,
		192,
		198,
		201,
		-1,
		114,
		116,
		141,
		149,
		154,
		161,
		156,
		162,
		181,
		180,
		199,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		111,
		119,
		141,
		133,
		129,
		142,
		159,
		159,
		165,
		169,
		172,
		188,
		189,
		199,
		-1,
		-1,
		194,
		167,
		191,
		149,
		137,
		-1,
		107,
		117,
		122,
		126,
		127,
		129,
		156,
		154,
		-1,
		166,
		165,
		196,
		182,
		193,
		176,
		-1,
		-1,
		152,
		144,
		126,
		129,
		106,
		102,
		114,
		113,
		111,
		107,
		103,
		132,
		144,
		142,
		152,
		160,
		170,
		174,
		185,
		200,
		-1,
		-1,
		255,
		-1,
		-1,
		173,
		156,
		-1,
		121,
		128,
		112,
		118,
		104,
		97,
		124,
		100,
		99,
		118,
		106,
		126,
		136,
		159,
		156,
		157,
		182,
		186,
		180,
		201,
		196,
		-1,
		254,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		128,
		125,
		118,
		122,
		110,
		-1,
		59,
		65,
		89,
		92,
		104,
		117,
		112,
		142,
		142,
		157,
		159,
		164,
		166,
		199,
		177,
		199,
		196,
		225,
		230,
		224,
		233,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		118,
		-1,
		76,
		76,
		51,
		69,
		72,
		93,
		93,
		124,
		118,
		136,
		145,
		148,
		157,
		166,
		177,
		172,
		171,
		189,
		204,
		217,
		221,
		227,
		-1,
		231,
		-1,
		173,
		157,
		159,
		135,
		163,
		-1,
		130,
		75,
		68,
		53,
		44,
		-1,
		97,
		94,
		108,
		115,
		120,
		137,
		152,
		151,
		156,
		161,
		175,
		166,
		184,
		191,
		199,
		203,
		223,
		235,
		191,
		181,
		-1,
		163,
		168,
		138,
		150,
		172,
		79,
		43,
		-1,
		45,
		-1,
		99,
		112,
		-1,
		114,
		118,
		126,
		142,
		139,
		154,
		160,
		157,
		154,
		172,
		175,
		192,
		196,
		212,
		-1,
		-1,
		176,
		180,
		187,
		138,
		145,
		121,
		89,
		36,
		25,
		26,
		-1,
		92,
		145,
		142,
		143,
		145,
		136,
		137,
		145,
		158,
		137,
		156,
		159,
		181,
		209,
		187,
		199,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		164,
		135,
		153,
		103,
		7,
		0,
		31,
		60,
		60,
		67,
		-1,
		165,
		148,
		145,
		134,
		132,
		145,
		140,
		156,
		160,
		159,
		178,
		190,
		181,
		201,
		-1,
		-1,
		-1,
		194,
		183,
		184,
		130,
		153,
		190,
		93,
		79,
		84,
		59,
		65,
		70,
		154,
		163,
		132,
		141,
		133,
		122,
		136,
		144,
		148,
		157,
		166,
		172,
		196,
		196,
		202,
		-1,
		-1,
		201,
		191,
		175,
		177,
		174,
		144,
		151,
		183,
		84,
		168,
		-1,
		103,
		-1,
		76,
		110,
		118,
		124,
		136,
		122,
		127,
		138,
		150,
		163,
		159,
		166,
		201,
		201,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		194,
		189,
		164,
		141,
		125,
		161,
		-1,
		138,
		139,
		-1,
		97,
		91,
		107,
		115,
		122,
		119,
		119,
		133,
		141,
		137,
		153,
		159,
		151,
		187,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		187,
		166,
		159,
		179,
		120,
		172,
		-1,
		-1,
		123,
		116,
		-1,
		94,
		103,
		110,
		119,
		124,
		129,
		137,
		132,
		145,
		150,
		156,
		161,
		179,
		183,
		187,
		176,
		172,
		169,
		183,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		140,
		-1,
		132,
		124,
		114,
		108,
		102,
		116,
		114,
		134,
		126,
		140,
		140,
		146,
		154,
		139,
		142,
		158,
		156,
		174,
		182,
		174,
		168,
		167,
		179,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		153,
		-1,
		117,
		131,
		147,
		-1,
		140,
		119,
		134,
		112,
		126,
		122,
		160,
		161,
		139,
		144,
		152,
		162,
		164,
		153,
		164,
		156,
		178,
		178,
		162,
		163,
		172,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		114,
		102,
		134,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		136,
		134,
		150,
		141,
		147,
		163,
		166,
		168,
		158,
		147,
		153,
		150,
		172,
		158,
		156,
		175,
		191,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		158,
		142,
		147,
		-1,
		193,
		-1,
		166,
		168,
		162,
		147,
		144,
		155,
		153,
		164,
		181,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		171,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		174,
		154,
		148,
		147,
		188,
		188,
		174,
		160,
		153,
		150,
		147,
		160,
		180,
		171,
		183,
		-1,
		-1,
		-1,
		168,
		154,
		158,
		118,
		137,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		191,
		179,
		169,
		159,
		193,
		194,
		179,
		172,
		158,
		160,
		158,
		156,
		161,
		182,
		183,
		196,
		-1,
		-1,
		151,
		156,
		144,
		130,
		149,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		180,
		-1,
		-1,
		171,
		169,
		179,
		175,
		162,
		182,
		185,
		171,
		155,
		170,
		182,
		190,
		195,
		-1,
		154,
		141,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		161,
		182,
		207,
		174,
		-1,
		179,
		180,
		166,
		180,
		187,
		173,
		168,
		162,
		165,
		183,
		200,
		-1,
		-1,
		166,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		140,
		154,
		175,
		181,
		193,
		-1,
		188,
		182,
		168,
		185,
		186,
		183,
		174,
		166,
		171,
		168,
		181,
		195,
		199,
		189,
		-1,
		172,
		-1,
		-1,
		-1,
		158,
		173,
		235,
		212,
		185,
		189,
		182,
		176,
		176,
		192,
		194,
		205,
		173,
		169,
		170,
		174,
		173,
		190,
		200,
		-1,
		-1,
		172,
		189,
		184,
		166,
		170,
		262,
		-1,
		-1,
		198,
		189,
		180,
		183,
		186,
		189,
		179,
		176,
		181,
		186,
		174,
		183,
		201,
		205,
		-1,
		-1,
		-1,
		192,
		-1,
		207,
		-1,
		-1,
		185,
		269,
		216,
		198,
		194,
		192,
		185,
		194,
		189,
		184,
		194,
		203,
		195,
		176,
		187,
		210,
		199,
		237,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		221,
		196,
		211,
		257,
		205,
		212,
		231,
		228,
		-1,
		198,
		223,
		195,
		202,
		194,
		202,
		202,
		199,
		177,
		184,
		200,
		199,
		194,
		229,
		221,
		227,
		-1,
		-1,
		304,
		293,
		282,
		288,
		-1,
		227,
		213,
		243,
		233,
		222,
		-1,
		-1,
		247,
		244,
		220,
		204,
		208,
		201,
		196,
		206,
		186,
		173,
		177,
		181,
		187,
		192,
		197,
		203,
		218,
		233,
		-1,
		199,
		280,
		273,
		256,
		264,
		295,
		-1,
		230,
		239,
		220,
		225,
		233,
		-1,
		-1,
		220,
		217,
		222,
		211,
		208,
		216,
		211,
		202,
		187,
		193,
		180,
		179,
		197,
		201,
		210,
		217,
		207,
		220,
		224,
		-1,
		213,
		256,
		250,
		253,
		277,
		291,
		-1,
		243,
		-1,
		-1,
		228,
		246,
		235,
		225,
		219,
		269,
		225,
		220,
		210,
		208,
		199,
		190,
		197,
		188,
		188,
		191,
		206,
		211,
		203,
		217,
		217,
		218,
		-1,
		248,
		236,
		244,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		244,
		-1,
		262,
		-1,
		237,
		241,
		233,
		236,
		224,
		211,
		203,
		195,
		211,
		186,
		196,
		192,
		193,
		202,
		213,
		225,
		224,
		225,
		322,
		277,
		244,
		235,
		282,
		297,
		301,
		-1,
		256,
		295,
		282,
		-1,
		253,
		-1,
		-1,
		-1,
		251,
		246,
		238,
		244,
		223,
		223,
		197,
		201,
		191,
		198,
		208,
		210,
		202,
		206,
		219,
		230,
		233,
		318,
		316,
		321,
		266,
		249,
		267,
		276,
		297,
		271,
		262,
		289,
		289,
		278,
		273,
		260,
		-1,
		-1,
		274,
		256,
		-1,
		-1,
		230,
		218,
		201,
		202,
		198,
		201,
		216,
		219,
		209,
		207,
		201,
		233,
		-1,
		318,
		317,
		306,
		303,
		279,
		270,
		257,
		268,
		-1,
		-1,
		274,
		290,
		303,
		307,
		320,
		345,
		-1,
		263,
		-1,
		-1,
		275,
		-1,
		-1,
		260,
		223,
		212,
		203,
		209,
		206,
		217,
		227,
		215,
		216,
		206,
		216,
		229,
		302,
		299,
		287,
		285,
		308,
		265,
		261,
		-1,
		284,
		277,
		283,
		290,
		307,
		334,
		-1,
		-1,
		279,
		270,
		-1,
		-1,
		258,
		256,
		245,
		-1,
		235,
		208,
		213,
		233,
		235,
		224,
		218,
		212,
		219,
		218,
		226,
		234,
		311,
		325,
		314,
		310,
		309,
		317,
		266,
		269,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		-1,
		296,
		289,
		-1,
		-1,
		253,
		246,
		234,
		222,
		212,
		222,
		226,
		230,
		222,
		215,
		210,
		221,
		213,
		217,
		234,
		-1,
		345,
		-1,
		297,
		283,
		297,
		312,
		320,
		-1,
		-1,
		-1,
		313,
		299,
		292,
		280,
		278,
		-1,
		287,
		271,
		252,
		-1,
		222,
		235,
		266,
		234,
		239,
		234,
		216,
		227,
		216,
		219,
		233,
		228,
		-1,
		-1,
		295,
		298,
		-1,
		-1,
		303,
		305,
		-1,
		304,
		293,
		278,
		270,
		-1,
		-1,
		259,
		255,
		-1,
		-1,
		223,
		248,
		237,
		245,
		240,
		220,
		226,
		229,
		218,
		222,
		234,
		-1,
		-1,
		302,
		303,
		308,
		-1,
		288,
		-1,
		306,
		-1,
		273,
		279,
		267,
		-1,
		-1,
		-1,
		261,
		224,
		245,
		255,
		249,
		247,
		238,
		224,
		231,
		229,
		225,
		236,
		-1,
		-1,
		-1,
		306,
		280,
		313,
		304,
		287,
		267,
		259,
		278,
		-1,
		248,
		-1,
		223,
		225,
		251,
		254,
		260,
		254,
		227,
		242,
		232,
		223,
		232,
		312,
		-1,
		282,
		315,
		279,
		273,
		249,
		253,
		269,
		-1,
		245,
		227,
		-1,
		255,
		245,
		276,
		261,
		242,
		229,
		236,
		236,
		229,
		-1,
		-1,
		-1,
		284,
		283,
		275,
		269,
		269,
		254,
		245,
		-1,
		257,
		239,
		218,
		235,
		235,
		226,
		234,
		266,
		262,
		249,
		249,
		241,
		-1,
		385,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		278,
		273,
		246,
		234,
		240,
		236,
		222,
		228,
		230,
		238,
		236,
		233,
		245,
		241,
		261,
		242,
		277,
		-1,
		380,
		-1,
		314,
		-1,
		-1,
		296,
		276,
		268,
		257,
		246,
		244,
		235,
		226,
		248,
		264,
		248,
		246,
		249,
		250,
		-1,
		369,
		368,
		-1,
		315,
		307,
		293,
		-1,
		286,
		-1,
		292,
		253,
		-1,
		255,
		235,
		-1,
		257,
		253,
		-1,
		-1,
		356,
		331,
		-1,
		-1,
		-1,
		316,
		296,
		287,
		271,
		-1,
		246,
		246,
		-1,
		-1,
		-1,
		341,
		340,
		-1,
		309,
		312,
		-1,
		302,
		293,
		301,
		248,
		252,
		-1,
		-1,
		-1,
		350,
		331,
		325,
		324,
		322,
		317,
		314,
		300,
		284,
		262,
		251,
		272,
		-1,
		-1,
		-1,
		322,
		314,
		307,
		-1,
		-1,
		309,
		292,
		273,
		271,
		-1,
		-1,
		-1,
		344,
		325,
		-1,
		-1,
		299,
		-1,
		-1,
		305,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		361,
		333,
		-1,
		-1,
		-1,
		295,
		291,
		292,
		-1,
		-1,
		-1,
		-1,
		355,
		356,
		379,
		343,
		-1,
		-1,
		-1,
		287,
		281,
		-1,
		-1,
		358,
		356,
		-1,
		-1,
		-1,
		315,
		299,
		-1,
		285,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		318,
		-1,
		-1,
		-1,
		320,
		-1,
		320,
		295,
		302,
		-1,
		-1,
		-1,
		-1,
		333,
		325,
		333,
		-1,
		305,
		307,
		-1,
		355,
		-1,
		-1,
		348,
		339,
		-1,
		-1,
		310,
		317,
		339,
		342,
		378,
		-1,
		329
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		182,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		175,
		167,
		207,
		163,
		134,
		128,
		146,
		151,
		169,
		161,
		-1,
		134,
		124,
		146,
		150,
		162,
		145,
		-1,
		-1,
		128,
		129,
		135,
		147,
		152,
		157,
		-1,
		183,
		188,
		-1,
		-1,
		118,
		131,
		127,
		130,
		138,
		154,
		175,
		188,
		183,
		-1,
		-1,
		119,
		123,
		136,
		137,
		135,
		162,
		181,
		178,
		192,
		191,
		-1,
		107,
		125,
		134,
		143,
		149,
		138,
		142,
		160,
		177,
		183,
		186,
		-1,
		99,
		101,
		126,
		134,
		139,
		146,
		141,
		147,
		166,
		165,
		184,
		175,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		96,
		104,
		126,
		118,
		114,
		127,
		144,
		144,
		150,
		154,
		157,
		173,
		174,
		184,
		-1,
		-1,
		179,
		152,
		176,
		134,
		122,
		-1,
		92,
		102,
		107,
		111,
		112,
		114,
		141,
		139,
		-1,
		151,
		150,
		181,
		167,
		178,
		161,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		99,
		98,
		96,
		92,
		88,
		117,
		129,
		127,
		137,
		145,
		155,
		159,
		170,
		185,
		-1,
		-1,
		240,
		-1,
		-1,
		158,
		141,
		-1,
		106,
		113,
		97,
		103,
		89,
		82,
		109,
		85,
		84,
		103,
		91,
		111,
		121,
		144,
		141,
		142,
		167,
		171,
		165,
		186,
		181,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		113,
		110,
		103,
		107,
		95,
		-1,
		44,
		50,
		74,
		77,
		89,
		102,
		97,
		127,
		127,
		142,
		144,
		149,
		151,
		184,
		162,
		184,
		181,
		210,
		215,
		209,
		218,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		103,
		-1,
		61,
		61,
		36,
		54,
		57,
		78,
		78,
		109,
		103,
		121,
		130,
		133,
		142,
		151,
		162,
		157,
		156,
		174,
		189,
		202,
		206,
		212,
		-1,
		216,
		-1,
		158,
		142,
		144,
		120,
		148,
		-1,
		115,
		60,
		53,
		38,
		29,
		-1,
		82,
		79,
		93,
		100,
		105,
		122,
		137,
		136,
		141,
		146,
		160,
		151,
		169,
		176,
		184,
		188,
		208,
		220,
		176,
		166,
		-1,
		148,
		153,
		123,
		135,
		157,
		64,
		28,
		-1,
		30,
		-1,
		84,
		97,
		-1,
		99,
		103,
		111,
		127,
		124,
		139,
		145,
		142,
		139,
		157,
		160,
		177,
		181,
		197,
		-1,
		-1,
		161,
		165,
		172,
		123,
		130,
		106,
		74,
		21,
		10,
		11,
		-1,
		77,
		130,
		127,
		128,
		130,
		121,
		122,
		130,
		143,
		122,
		141,
		144,
		166,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		149,
		120,
		138,
		88,
		35,
		28,
		0,
		45,
		45,
		52,
		-1,
		150,
		133,
		130,
		119,
		117,
		130,
		125,
		141,
		145,
		144,
		163,
		175,
		166,
		186,
		-1,
		-1,
		-1,
		179,
		168,
		169,
		115,
		138,
		175,
		78,
		64,
		69,
		44,
		50,
		55,
		139,
		148,
		117,
		126,
		118,
		107,
		121,
		129,
		133,
		142,
		151,
		157,
		181,
		181,
		187,
		-1,
		-1,
		186,
		176,
		160,
		162,
		159,
		129,
		136,
		168,
		69,
		153,
		-1,
		88,
		-1,
		61,
		95,
		103,
		109,
		121,
		107,
		112,
		123,
		135,
		148,
		144,
		151,
		186,
		186,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		179,
		174,
		149,
		126,
		110,
		146,
		-1,
		123,
		124,
		-1,
		82,
		76,
		92,
		100,
		107,
		104,
		104,
		118,
		126,
		122,
		138,
		144,
		136,
		172,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		172,
		151,
		144,
		164,
		105,
		157,
		-1,
		-1,
		108,
		101,
		-1,
		79,
		88,
		95,
		104,
		109,
		114,
		122,
		117,
		130,
		135,
		141,
		146,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		125,
		-1,
		117,
		109,
		99,
		93,
		87,
		101,
		99,
		119,
		111,
		125,
		125,
		131,
		139,
		124,
		127,
		143,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		138,
		-1,
		102,
		116,
		132,
		-1,
		125,
		104,
		119,
		97,
		111,
		107,
		145,
		146,
		124,
		129,
		137,
		147,
		149,
		138,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		99,
		87,
		119,
		-1,
		-1,
		161,
		-1,
		95,
		112,
		121,
		119,
		135,
		126,
		132,
		148,
		151,
		153,
		143,
		132,
		138,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		136,
		-1,
		139,
		129,
		113,
		98,
		131,
		-1,
		143,
		127,
		132,
		-1,
		178,
		-1,
		151,
		153,
		147,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		148,
		133,
		126,
		116,
		130,
		101,
		-1,
		156,
		-1,
		-1,
		126,
		120,
		120,
		104,
		107,
		159,
		139,
		133,
		132,
		173,
		173,
		159,
		145,
		138,
		135,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		153,
		139,
		143,
		103,
		122,
		-1,
		-1,
		188,
		143,
		129,
		-1,
		113,
		176,
		164,
		154,
		144,
		178,
		179,
		164,
		157,
		143,
		145,
		143,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		136,
		141,
		129,
		115,
		134,
		-1,
		-1,
		-1,
		135,
		151,
		143,
		114,
		165,
		-1,
		-1,
		156,
		154,
		164,
		160,
		147,
		167,
		170,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		139,
		126,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		146,
		167,
		192,
		159,
		-1,
		164,
		165,
		151,
		165,
		172,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		151,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		125,
		139,
		160,
		166,
		178,
		-1,
		173,
		167,
		153,
		170,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		174,
		-1,
		157,
		-1,
		-1,
		-1,
		143,
		158,
		220,
		197,
		170,
		174,
		167,
		161,
		161,
		177,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		157,
		174,
		169,
		151,
		155,
		247,
		-1,
		-1,
		183,
		174,
		165,
		168,
		171,
		174,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		190,
		-1,
		-1,
		-1,
		177,
		-1,
		192,
		-1,
		-1,
		170,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		188,
		180,
		161,
		172,
		195,
		184,
		222,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		206,
		181,
		196,
		242,
		190,
		197,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		179,
		187,
		187,
		184,
		162,
		169,
		185,
		184,
		179,
		214,
		206,
		212,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		212,
		198,
		228,
		218,
		207,
		-1,
		-1,
		232,
		229,
		205,
		189,
		193,
		186,
		181,
		191,
		171,
		158,
		162,
		166,
		172,
		177,
		182,
		188,
		203,
		218,
		-1,
		184,
		265,
		258,
		241,
		249,
		280,
		-1,
		215,
		224,
		205,
		210,
		218,
		-1,
		-1,
		205,
		202,
		207,
		196,
		193,
		201,
		196,
		187,
		172,
		178,
		165,
		164,
		182,
		186,
		195,
		202,
		192,
		205,
		209,
		-1,
		198,
		241,
		235,
		238,
		262,
		276,
		-1,
		228,
		-1,
		-1,
		213,
		231,
		220,
		210,
		204,
		254,
		210,
		205,
		195,
		193,
		184,
		175,
		182,
		173,
		173,
		176,
		191,
		196,
		188,
		202,
		202,
		203,
		-1,
		233,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		229,
		-1,
		247,
		-1,
		222,
		226,
		218,
		221,
		209,
		196,
		188,
		180,
		196,
		171,
		181,
		177,
		178,
		187,
		198,
		210,
		209,
		210,
		307,
		262,
		229,
		220,
		267,
		282,
		286,
		-1,
		241,
		280,
		267,
		-1,
		238,
		-1,
		-1,
		-1,
		236,
		231,
		223,
		229,
		208,
		208,
		182,
		186,
		176,
		183,
		193,
		195,
		187,
		191,
		204,
		215,
		218,
		303,
		301,
		306,
		251,
		234,
		252,
		261,
		282,
		256,
		247,
		274,
		274,
		263,
		258,
		245,
		-1,
		-1,
		259,
		241,
		-1,
		-1,
		215,
		203,
		186,
		187,
		183,
		186,
		201,
		204,
		194,
		192,
		186,
		218,
		-1,
		303,
		302,
		291,
		288,
		264,
		255,
		242,
		253,
		-1,
		-1,
		259,
		275,
		288,
		292,
		305,
		330,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		245,
		208,
		197,
		188,
		194,
		191,
		202,
		212,
		200,
		201,
		191,
		201,
		214,
		287,
		284,
		272,
		270,
		293,
		250,
		246,
		-1,
		269,
		262,
		268,
		275,
		292,
		319,
		-1,
		-1,
		264,
		255,
		-1,
		-1,
		243,
		241,
		230,
		-1,
		220,
		193,
		198,
		218,
		220,
		209,
		203,
		197,
		204,
		203,
		211,
		219,
		296,
		310,
		299,
		295,
		294,
		302,
		251,
		254,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		-1,
		281,
		274,
		-1,
		-1,
		238,
		231,
		219,
		207,
		197,
		207,
		211,
		215,
		207,
		200,
		195,
		206,
		198,
		202,
		219,
		-1,
		330,
		-1,
		282,
		268,
		282,
		297,
		305,
		-1,
		-1,
		-1,
		298,
		284,
		277,
		265,
		263,
		-1,
		272,
		256,
		237,
		-1,
		207,
		220,
		251,
		219,
		224,
		219,
		201,
		212,
		201,
		204,
		218,
		213,
		-1,
		-1,
		280,
		283,
		-1,
		-1,
		288,
		290,
		-1,
		289,
		278,
		263,
		255,
		-1,
		-1,
		244,
		240,
		-1,
		-1,
		208,
		233,
		222,
		230,
		225,
		205,
		211,
		214,
		203,
		207,
		219,
		-1,
		-1,
		287,
		288,
		293,
		-1,
		273,
		-1,
		291,
		-1,
		258,
		264,
		252,
		-1,
		-1,
		-1,
		246,
		209,
		230,
		240,
		234,
		232,
		223,
		209,
		216,
		214,
		210,
		221,
		-1,
		-1,
		-1,
		291,
		265,
		298,
		289,
		272,
		252,
		244,
		263,
		-1,
		233,
		-1,
		208,
		210,
		236,
		239,
		245,
		239,
		212,
		227,
		217,
		208,
		217,
		297,
		-1,
		267,
		300,
		264,
		258,
		234,
		238,
		254,
		-1,
		230,
		212,
		-1,
		240,
		230,
		261,
		246,
		227,
		214,
		221,
		221,
		214,
		-1,
		-1,
		-1,
		269,
		268,
		260,
		254,
		254,
		239,
		230,
		-1,
		242,
		224,
		203,
		220,
		220,
		211,
		219,
		251,
		247,
		234,
		234,
		226,
		-1,
		370,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		263,
		258,
		231,
		219,
		225,
		221,
		207,
		213,
		215,
		223,
		221,
		218,
		230,
		226,
		246,
		227,
		262,
		-1,
		365,
		-1,
		299,
		-1,
		-1,
		281,
		261,
		253,
		242,
		231,
		229,
		220,
		211,
		233,
		249,
		233,
		231,
		234,
		235,
		-1,
		354,
		353,
		-1,
		300,
		292,
		278,
		-1,
		271,
		-1,
		277,
		238,
		-1,
		240,
		220,
		-1,
		242,
		238,
		-1,
		-1,
		341,
		316,
		-1,
		-1,
		-1,
		301,
		281,
		272,
		256,
		-1,
		231,
		231,
		-1,
		-1,
		-1,
		326,
		325,
		-1,
		294,
		297,
		-1,
		287,
		278,
		286,
		233,
		237,
		-1,
		-1,
		-1,
		335,
		316,
		310,
		309,
		307,
		302,
		299,
		285,
		269,
		247,
		236,
		257,
		-1,
		-1,
		-1,
		307,
		299,
		292,
		-1,
		-1,
		294,
		277,
		258,
		256,
		-1,
		-1,
		-1,
		329,
		310,
		-1,
		-1,
		284,
		-1,
		-1,
		290,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		346,
		318,
		-1,
		-1,
		-1,
		280,
		276,
		277,
		-1,
		-1,
		-1,
		-1,
		340,
		341,
		364,
		328,
		-1,
		-1,
		-1,
		272,
		266,
		-1,
		-1,
		343,
		341,
		-1,
		-1,
		-1,
		300,
		284,
		-1,
		270,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		305,
		-1,
		305,
		280,
		287,
		-1,
		-1,
		-1,
		-1,
		318,
		310,
		318,
		-1,
		290,
		292,
		-1,
		340,
		-1,
		-1,
		333,
		324,
		-1,
		-1,
		295,
		302,
		324,
		327,
		363,
		-1,
		314
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		194,
		196,
		162,
		156,
		195,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		185,
		184,
		154,
		152,
		161,
		166,
		173,
		-1,
		190,
		-1,
		206,
		185,
		196,
		201,
		147,
		144,
		164,
		183,
		183,
		175,
		221,
		177,
		148,
		142,
		160,
		165,
		177,
		169,
		-1,
		148,
		138,
		160,
		157,
		168,
		159,
		-1,
		-1,
		142,
		143,
		149,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		132,
		145,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		133,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		121,
		139,
		148,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		147,
		-1,
		113,
		115,
		139,
		147,
		152,
		136,
		123,
		123,
		133,
		126,
		145,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		110,
		118,
		139,
		131,
		125,
		140,
		133,
		126,
		123,
		121,
		118,
		134,
		135,
		145,
		-1,
		-1,
		180,
		149,
		184,
		141,
		126,
		-1,
		106,
		115,
		120,
		124,
		123,
		116,
		130,
		126,
		-1,
		112,
		111,
		142,
		128,
		139,
		140,
		-1,
		-1,
		138,
		130,
		115,
		118,
		105,
		101,
		112,
		111,
		107,
		105,
		101,
		113,
		116,
		116,
		122,
		106,
		116,
		120,
		131,
		146,
		-1,
		-1,
		201,
		-1,
		-1,
		137,
		120,
		-1,
		103,
		110,
		110,
		117,
		103,
		96,
		122,
		98,
		95,
		116,
		104,
		111,
		108,
		121,
		109,
		103,
		128,
		132,
		126,
		147,
		142,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		96,
		99,
		105,
		128,
		113,
		-1,
		58,
		64,
		88,
		85,
		95,
		108,
		102,
		115,
		100,
		107,
		106,
		110,
		112,
		145,
		123,
		145,
		142,
		171,
		176,
		170,
		179,
		-1,
		145,
		141,
		137,
		144,
		93,
		-1,
		-1,
		124,
		-1,
		82,
		75,
		50,
		68,
		71,
		86,
		77,
		109,
		98,
		109,
		98,
		95,
		103,
		112,
		123,
		118,
		117,
		135,
		150,
		163,
		167,
		173,
		-1,
		195,
		-1,
		137,
		121,
		123,
		95,
		116,
		-1,
		136,
		81,
		67,
		52,
		43,
		-1,
		63,
		66,
		92,
		99,
		90,
		107,
		99,
		97,
		102,
		107,
		121,
		112,
		130,
		137,
		145,
		149,
		169,
		181,
		155,
		145,
		-1,
		127,
		132,
		91,
		99,
		118,
		85,
		49,
		-1,
		44,
		-1,
		53,
		78,
		-1,
		98,
		102,
		89,
		90,
		85,
		100,
		106,
		103,
		100,
		118,
		121,
		138,
		142,
		158,
		-1,
		-1,
		140,
		144,
		133,
		84,
		103,
		127,
		95,
		42,
		31,
		30,
		-1,
		38,
		121,
		118,
		104,
		91,
		82,
		83,
		91,
		104,
		83,
		102,
		105,
		127,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		110,
		81,
		105,
		109,
		60,
		53,
		41,
		0,
		6,
		13,
		-1,
		111,
		94,
		91,
		80,
		78,
		91,
		86,
		102,
		106,
		105,
		124,
		136,
		127,
		147,
		-1,
		-1,
		-1,
		140,
		129,
		130,
		76,
		99,
		136,
		39,
		25,
		30,
		5,
		11,
		16,
		114,
		111,
		78,
		87,
		79,
		68,
		82,
		90,
		94,
		103,
		112,
		118,
		142,
		142,
		148,
		-1,
		-1,
		147,
		137,
		121,
		123,
		120,
		90,
		97,
		129,
		30,
		114,
		-1,
		49,
		-1,
		22,
		56,
		64,
		70,
		82,
		68,
		73,
		84,
		96,
		109,
		105,
		112,
		147,
		147,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		140,
		135,
		110,
		87,
		71,
		107,
		-1,
		84,
		85,
		-1,
		43,
		37,
		53,
		61,
		68,
		65,
		65,
		79,
		87,
		83,
		99,
		105,
		97,
		133,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		133,
		112,
		105,
		125,
		66,
		118,
		-1,
		-1,
		69,
		62,
		-1,
		40,
		49,
		56,
		65,
		70,
		75,
		83,
		78,
		91,
		96,
		102,
		107,
		125,
		129,
		133,
		122,
		118,
		115,
		129,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		86,
		-1,
		78,
		70,
		60,
		54,
		48,
		62,
		60,
		80,
		72,
		86,
		86,
		92,
		100,
		85,
		88,
		104,
		102,
		120,
		128,
		120,
		114,
		113,
		125,
		-1,
		153,
		139,
		110,
		-1,
		-1,
		99,
		-1,
		63,
		77,
		93,
		-1,
		86,
		65,
		80,
		58,
		72,
		68,
		106,
		107,
		85,
		90,
		98,
		108,
		110,
		99,
		110,
		102,
		124,
		124,
		108,
		109,
		118,
		-1,
		159,
		146,
		104,
		100,
		89,
		109,
		60,
		48,
		80,
		-1,
		-1,
		122,
		-1,
		56,
		73,
		82,
		80,
		96,
		87,
		93,
		109,
		112,
		114,
		104,
		93,
		99,
		96,
		118,
		104,
		102,
		121,
		137,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		75,
		62,
		56,
		-1,
		97,
		-1,
		100,
		90,
		74,
		59,
		92,
		-1,
		104,
		88,
		93,
		-1,
		139,
		-1,
		112,
		114,
		108,
		93,
		90,
		101,
		99,
		110,
		127,
		-1,
		109,
		94,
		87,
		77,
		91,
		62,
		-1,
		117,
		-1,
		-1,
		87,
		81,
		81,
		65,
		68,
		120,
		100,
		94,
		93,
		134,
		134,
		120,
		106,
		99,
		96,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		114,
		100,
		104,
		64,
		83,
		-1,
		-1,
		149,
		104,
		90,
		-1,
		74,
		137,
		125,
		115,
		105,
		139,
		140,
		125,
		118,
		104,
		106,
		104,
		102,
		107,
		128,
		129,
		142,
		-1,
		-1,
		97,
		102,
		90,
		76,
		95,
		-1,
		-1,
		-1,
		96,
		112,
		104,
		75,
		126,
		-1,
		-1,
		117,
		115,
		125,
		121,
		108,
		128,
		131,
		117,
		101,
		116,
		128,
		136,
		141,
		-1,
		100,
		87,
		-1,
		-1,
		98,
		92,
		-1,
		-1,
		-1,
		-1,
		129,
		95,
		107,
		128,
		153,
		120,
		-1,
		125,
		126,
		112,
		126,
		133,
		119,
		114,
		108,
		111,
		129,
		146,
		-1,
		-1,
		112,
		-1,
		107,
		-1,
		-1,
		-1,
		-1,
		86,
		100,
		121,
		127,
		139,
		-1,
		134,
		128,
		114,
		131,
		132,
		129,
		120,
		112,
		117,
		114,
		127,
		141,
		145,
		135,
		-1,
		118,
		-1,
		-1,
		-1,
		104,
		119,
		181,
		158,
		131,
		135,
		128,
		122,
		122,
		138,
		140,
		151,
		119,
		115,
		116,
		120,
		119,
		136,
		146,
		-1,
		-1,
		118,
		135,
		130,
		112,
		116,
		208,
		-1,
		-1,
		144,
		135,
		126,
		129,
		132,
		135,
		125,
		122,
		127,
		132,
		120,
		129,
		147,
		151,
		-1,
		-1,
		-1,
		138,
		-1,
		153,
		-1,
		-1,
		131,
		215,
		162,
		144,
		140,
		138,
		131,
		140,
		135,
		130,
		140,
		149,
		141,
		122,
		133,
		156,
		145,
		183,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		167,
		142,
		157,
		203,
		151,
		158,
		177,
		174,
		-1,
		144,
		169,
		141,
		148,
		140,
		148,
		148,
		145,
		123,
		130,
		146,
		145,
		140,
		175,
		167,
		173,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		173,
		159,
		189,
		179,
		168,
		-1,
		-1,
		193,
		190,
		166,
		150,
		154,
		147,
		142,
		152,
		132,
		119,
		123,
		127,
		133,
		138,
		143,
		149,
		164,
		179,
		-1,
		145,
		226,
		219,
		202,
		210,
		241,
		-1,
		176,
		185,
		166,
		171,
		179,
		-1,
		-1,
		166,
		163,
		168,
		157,
		154,
		162,
		157,
		148,
		133,
		139,
		126,
		125,
		143,
		147,
		156,
		163,
		153,
		166,
		170,
		-1,
		159,
		202,
		196,
		199,
		223,
		237,
		-1,
		189,
		-1,
		-1,
		174,
		192,
		181,
		171,
		165,
		215,
		171,
		166,
		156,
		154,
		145,
		136,
		143,
		134,
		134,
		137,
		152,
		157,
		149,
		163,
		163,
		164,
		-1,
		194,
		182,
		190,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		190,
		-1,
		208,
		-1,
		183,
		187,
		179,
		182,
		170,
		157,
		149,
		141,
		157,
		132,
		142,
		138,
		139,
		148,
		159,
		171,
		170,
		171,
		268,
		223,
		190,
		181,
		228,
		243,
		247,
		-1,
		202,
		241,
		228,
		-1,
		199,
		-1,
		-1,
		-1,
		197,
		192,
		184,
		190,
		169,
		169,
		143,
		147,
		137,
		144,
		154,
		156,
		148,
		152,
		165,
		176,
		179,
		264,
		262,
		267,
		212,
		195,
		213,
		222,
		243,
		217,
		208,
		235,
		235,
		224,
		219,
		206,
		-1,
		-1,
		220,
		202,
		-1,
		-1,
		176,
		164,
		147,
		148,
		144,
		147,
		162,
		165,
		155,
		153,
		147,
		179,
		-1,
		264,
		263,
		252,
		249,
		225,
		216,
		203,
		214,
		-1,
		-1,
		220,
		236,
		249,
		253,
		266,
		291,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		206,
		169,
		158,
		149,
		155,
		152,
		163,
		173,
		161,
		162,
		152,
		162,
		175,
		248,
		245,
		233,
		231,
		254,
		211,
		207,
		-1,
		230,
		223,
		229,
		236,
		253,
		280,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		154,
		159,
		179,
		181,
		170,
		164,
		158,
		165,
		164,
		172,
		180,
		257,
		271,
		260,
		256,
		255,
		263,
		212,
		215,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		-1,
		242,
		235,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		172,
		176,
		168,
		161,
		156,
		167,
		159,
		163,
		180,
		-1,
		291,
		-1,
		243,
		229,
		243,
		258,
		266,
		-1,
		-1,
		-1,
		259,
		245,
		238,
		226,
		224,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		212,
		180,
		185,
		180,
		162,
		173,
		162,
		165,
		179,
		174,
		-1,
		-1,
		241,
		244,
		-1,
		-1,
		249,
		251,
		-1,
		250,
		239,
		224,
		216,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		169,
		194,
		183,
		191,
		186,
		166,
		172,
		175,
		164,
		168,
		180,
		-1,
		-1,
		248,
		249,
		254,
		-1,
		234,
		-1,
		252,
		-1,
		219,
		225,
		213,
		-1,
		-1,
		-1,
		207,
		170,
		191,
		201,
		195,
		193,
		184,
		170,
		177,
		175,
		171,
		182,
		-1,
		-1,
		-1,
		252,
		226,
		259,
		250,
		233,
		213,
		205,
		224,
		-1,
		194,
		-1,
		169,
		171,
		197,
		200,
		206,
		200,
		173,
		188,
		178,
		169,
		178,
		258,
		-1,
		228,
		261,
		225,
		219,
		195,
		199,
		215,
		-1,
		191,
		173,
		-1,
		201,
		191,
		222,
		207,
		188,
		175,
		182,
		182,
		175,
		-1,
		-1,
		-1,
		230,
		229,
		221,
		215,
		215,
		200,
		191,
		-1,
		203,
		185,
		164,
		181,
		181,
		172,
		180,
		212,
		208,
		195,
		195,
		187,
		-1,
		331,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		224,
		219,
		192,
		180,
		186,
		182,
		168,
		174,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		188,
		223,
		-1,
		326,
		-1,
		260,
		-1,
		-1,
		242,
		222,
		214,
		203,
		192,
		190,
		181,
		172,
		194,
		210,
		194,
		192,
		195,
		196,
		-1,
		315,
		314,
		-1,
		261,
		253,
		239,
		-1,
		232,
		-1,
		238,
		199,
		-1,
		201,
		181,
		-1,
		203,
		199,
		-1,
		-1,
		302,
		277,
		-1,
		-1,
		-1,
		262,
		242,
		233,
		217,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		287,
		286,
		-1,
		255,
		258,
		-1,
		248,
		239,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		296,
		277,
		271,
		270,
		268,
		263,
		260,
		246,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		268,
		260,
		253,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		290,
		271,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		279,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		301,
		302,
		325,
		289,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		304,
		302,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		199,
		201,
		167,
		161,
		200,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		190,
		189,
		159,
		157,
		166,
		171,
		178,
		-1,
		195,
		-1,
		211,
		190,
		201,
		206,
		152,
		149,
		169,
		188,
		188,
		180,
		226,
		182,
		153,
		147,
		165,
		170,
		182,
		174,
		-1,
		153,
		143,
		165,
		162,
		173,
		164,
		-1,
		-1,
		147,
		148,
		154,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		137,
		150,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		138,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		126,
		144,
		153,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		152,
		-1,
		118,
		120,
		144,
		152,
		157,
		141,
		128,
		128,
		138,
		131,
		150,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		115,
		123,
		144,
		136,
		130,
		145,
		138,
		131,
		128,
		126,
		123,
		139,
		140,
		150,
		-1,
		-1,
		185,
		154,
		189,
		146,
		131,
		-1,
		111,
		120,
		125,
		129,
		128,
		121,
		135,
		131,
		-1,
		117,
		116,
		147,
		133,
		144,
		145,
		-1,
		-1,
		143,
		135,
		120,
		123,
		110,
		106,
		117,
		116,
		112,
		110,
		106,
		118,
		121,
		121,
		127,
		111,
		121,
		125,
		136,
		151,
		-1,
		-1,
		206,
		-1,
		-1,
		142,
		125,
		-1,
		108,
		115,
		115,
		122,
		108,
		101,
		127,
		103,
		100,
		121,
		109,
		116,
		113,
		126,
		114,
		108,
		133,
		137,
		131,
		152,
		147,
		-1,
		205,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		101,
		104,
		110,
		133,
		118,
		-1,
		63,
		69,
		93,
		90,
		100,
		113,
		107,
		120,
		105,
		112,
		111,
		115,
		117,
		150,
		128,
		150,
		147,
		176,
		181,
		175,
		184,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		129,
		-1,
		87,
		80,
		55,
		73,
		76,
		91,
		82,
		114,
		103,
		114,
		103,
		100,
		108,
		117,
		128,
		123,
		122,
		140,
		155,
		168,
		172,
		178,
		-1,
		200,
		-1,
		142,
		126,
		128,
		100,
		121,
		-1,
		141,
		86,
		72,
		57,
		48,
		-1,
		68,
		71,
		97,
		104,
		95,
		112,
		104,
		102,
		107,
		112,
		126,
		117,
		135,
		142,
		150,
		154,
		174,
		186,
		160,
		150,
		-1,
		132,
		137,
		96,
		104,
		123,
		90,
		54,
		-1,
		49,
		-1,
		58,
		83,
		-1,
		103,
		107,
		94,
		95,
		90,
		105,
		111,
		108,
		105,
		123,
		126,
		143,
		147,
		163,
		-1,
		-1,
		145,
		149,
		138,
		89,
		108,
		132,
		100,
		47,
		36,
		35,
		-1,
		43,
		126,
		123,
		109,
		96,
		87,
		88,
		96,
		109,
		88,
		107,
		110,
		132,
		160,
		138,
		150,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		115,
		86,
		110,
		114,
		65,
		58,
		46,
		11,
		0,
		18,
		-1,
		116,
		99,
		96,
		85,
		83,
		96,
		91,
		107,
		111,
		110,
		129,
		141,
		132,
		152,
		-1,
		-1,
		-1,
		145,
		134,
		135,
		81,
		104,
		141,
		44,
		30,
		35,
		6,
		16,
		21,
		119,
		116,
		83,
		92,
		84,
		73,
		87,
		95,
		99,
		108,
		117,
		123,
		147,
		147,
		153,
		-1,
		-1,
		152,
		142,
		126,
		128,
		125,
		95,
		102,
		134,
		35,
		119,
		-1,
		54,
		-1,
		27,
		61,
		69,
		75,
		87,
		73,
		78,
		89,
		101,
		114,
		110,
		117,
		152,
		152,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		145,
		140,
		115,
		92,
		76,
		112,
		-1,
		89,
		90,
		-1,
		48,
		42,
		58,
		66,
		73,
		70,
		70,
		84,
		92,
		88,
		104,
		110,
		102,
		138,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		138,
		117,
		110,
		130,
		71,
		123,
		-1,
		-1,
		74,
		67,
		-1,
		45,
		54,
		61,
		70,
		75,
		80,
		88,
		83,
		96,
		101,
		107,
		112,
		130,
		134,
		138,
		127,
		123,
		120,
		134,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		91,
		-1,
		83,
		75,
		65,
		59,
		53,
		67,
		65,
		85,
		77,
		91,
		91,
		97,
		105,
		90,
		93,
		109,
		107,
		125,
		133,
		125,
		119,
		118,
		130,
		-1,
		158,
		144,
		115,
		-1,
		-1,
		104,
		-1,
		68,
		82,
		98,
		-1,
		91,
		70,
		85,
		63,
		77,
		73,
		111,
		112,
		90,
		95,
		103,
		113,
		115,
		104,
		115,
		107,
		129,
		129,
		113,
		114,
		123,
		-1,
		164,
		151,
		109,
		105,
		94,
		114,
		65,
		53,
		85,
		-1,
		-1,
		127,
		-1,
		61,
		78,
		87,
		85,
		101,
		92,
		98,
		114,
		117,
		119,
		109,
		98,
		104,
		101,
		123,
		109,
		107,
		126,
		142,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		80,
		67,
		61,
		-1,
		102,
		-1,
		105,
		95,
		79,
		64,
		97,
		-1,
		109,
		93,
		98,
		-1,
		144,
		-1,
		117,
		119,
		113,
		98,
		95,
		106,
		104,
		115,
		132,
		-1,
		114,
		99,
		92,
		82,
		96,
		67,
		-1,
		122,
		-1,
		-1,
		92,
		86,
		86,
		70,
		73,
		125,
		105,
		99,
		98,
		139,
		139,
		125,
		111,
		104,
		101,
		98,
		111,
		131,
		122,
		134,
		-1,
		-1,
		-1,
		119,
		105,
		109,
		69,
		88,
		-1,
		-1,
		154,
		109,
		95,
		-1,
		79,
		142,
		130,
		120,
		110,
		144,
		145,
		130,
		123,
		109,
		111,
		109,
		107,
		112,
		133,
		134,
		147,
		-1,
		-1,
		102,
		107,
		95,
		81,
		100,
		-1,
		-1,
		-1,
		101,
		117,
		109,
		80,
		131,
		-1,
		-1,
		122,
		120,
		130,
		126,
		113,
		133,
		136,
		122,
		106,
		121,
		133,
		141,
		146,
		-1,
		105,
		92,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		-1,
		-1,
		134,
		100,
		112,
		133,
		158,
		125,
		-1,
		130,
		131,
		117,
		131,
		138,
		124,
		119,
		113,
		116,
		134,
		151,
		-1,
		-1,
		117,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		91,
		105,
		126,
		132,
		144,
		-1,
		139,
		133,
		119,
		136,
		137,
		134,
		125,
		117,
		122,
		119,
		132,
		146,
		150,
		140,
		-1,
		123,
		-1,
		-1,
		-1,
		109,
		124,
		186,
		163,
		136,
		140,
		133,
		127,
		127,
		143,
		145,
		156,
		124,
		120,
		121,
		125,
		124,
		141,
		151,
		-1,
		-1,
		123,
		140,
		135,
		117,
		121,
		213,
		-1,
		-1,
		149,
		140,
		131,
		134,
		137,
		140,
		130,
		127,
		132,
		137,
		125,
		134,
		152,
		156,
		-1,
		-1,
		-1,
		143,
		-1,
		158,
		-1,
		-1,
		136,
		220,
		167,
		149,
		145,
		143,
		136,
		145,
		140,
		135,
		145,
		154,
		146,
		127,
		138,
		161,
		150,
		188,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		172,
		147,
		162,
		208,
		156,
		163,
		182,
		179,
		-1,
		149,
		174,
		146,
		153,
		145,
		153,
		153,
		150,
		128,
		135,
		151,
		150,
		145,
		180,
		172,
		178,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		178,
		164,
		194,
		184,
		173,
		-1,
		-1,
		198,
		195,
		171,
		155,
		159,
		152,
		147,
		157,
		137,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		150,
		231,
		224,
		207,
		215,
		246,
		-1,
		181,
		190,
		171,
		176,
		184,
		-1,
		-1,
		171,
		168,
		173,
		162,
		159,
		167,
		162,
		153,
		138,
		144,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		164,
		207,
		201,
		204,
		228,
		242,
		-1,
		194,
		-1,
		-1,
		179,
		197,
		186,
		176,
		170,
		220,
		176,
		171,
		161,
		159,
		150,
		141,
		148,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		199,
		187,
		195,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		195,
		-1,
		213,
		-1,
		188,
		192,
		184,
		187,
		175,
		162,
		154,
		146,
		162,
		137,
		147,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		273,
		228,
		195,
		186,
		233,
		248,
		252,
		-1,
		207,
		246,
		233,
		-1,
		204,
		-1,
		-1,
		-1,
		202,
		197,
		189,
		195,
		174,
		174,
		148,
		152,
		142,
		149,
		159,
		161,
		153,
		157,
		170,
		181,
		184,
		269,
		267,
		272,
		217,
		200,
		218,
		227,
		248,
		222,
		213,
		240,
		240,
		229,
		224,
		211,
		-1,
		-1,
		225,
		207,
		-1,
		-1,
		181,
		169,
		152,
		153,
		149,
		152,
		167,
		170,
		160,
		158,
		152,
		184,
		-1,
		269,
		268,
		257,
		254,
		230,
		221,
		208,
		219,
		-1,
		-1,
		225,
		241,
		254,
		258,
		271,
		296,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		211,
		174,
		163,
		154,
		160,
		157,
		168,
		178,
		166,
		167,
		157,
		167,
		180,
		253,
		250,
		238,
		236,
		259,
		216,
		212,
		-1,
		235,
		228,
		234,
		241,
		258,
		285,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		209,
		207,
		196,
		-1,
		186,
		159,
		164,
		184,
		186,
		175,
		169,
		163,
		170,
		169,
		177,
		185,
		262,
		276,
		265,
		261,
		260,
		268,
		217,
		220,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		240,
		-1,
		-1,
		204,
		197,
		185,
		173,
		163,
		173,
		177,
		181,
		173,
		166,
		161,
		172,
		164,
		168,
		185,
		-1,
		296,
		-1,
		248,
		234,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		238,
		222,
		203,
		-1,
		173,
		186,
		217,
		185,
		190,
		185,
		167,
		178,
		167,
		170,
		184,
		179,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		254,
		256,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		210,
		206,
		-1,
		-1,
		174,
		199,
		188,
		196,
		191,
		171,
		177,
		180,
		169,
		173,
		185,
		-1,
		-1,
		253,
		254,
		259,
		-1,
		239,
		-1,
		257,
		-1,
		224,
		230,
		218,
		-1,
		-1,
		-1,
		212,
		175,
		196,
		206,
		200,
		198,
		189,
		175,
		182,
		180,
		176,
		187,
		-1,
		-1,
		-1,
		257,
		231,
		264,
		255,
		238,
		218,
		210,
		229,
		-1,
		199,
		-1,
		174,
		176,
		202,
		205,
		211,
		205,
		178,
		193,
		183,
		174,
		183,
		263,
		-1,
		233,
		266,
		230,
		224,
		200,
		204,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		227,
		212,
		193,
		180,
		187,
		187,
		180,
		-1,
		-1,
		-1,
		235,
		234,
		226,
		220,
		220,
		205,
		196,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		217,
		213,
		200,
		200,
		192,
		-1,
		336,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		229,
		224,
		197,
		185,
		191,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		193,
		228,
		-1,
		331,
		-1,
		265,
		-1,
		-1,
		247,
		227,
		219,
		208,
		197,
		195,
		186,
		177,
		199,
		215,
		199,
		197,
		200,
		201,
		-1,
		320,
		319,
		-1,
		266,
		258,
		244,
		-1,
		237,
		-1,
		243,
		204,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		307,
		282,
		-1,
		-1,
		-1,
		267,
		247,
		238,
		222,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		292,
		291,
		-1,
		260,
		263,
		-1,
		253,
		244,
		252,
		199,
		203,
		-1,
		-1,
		-1,
		301,
		282,
		276,
		275,
		273,
		268,
		265,
		251,
		235,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		273,
		265,
		258,
		-1,
		-1,
		260,
		243,
		224,
		222,
		-1,
		-1,
		-1,
		295,
		276,
		-1,
		-1,
		250,
		-1,
		-1,
		256,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		284,
		-1,
		-1,
		-1,
		246,
		242,
		243,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		330,
		294,
		-1,
		-1,
		-1,
		238,
		232,
		-1,
		-1,
		309,
		307,
		-1,
		-1,
		-1,
		266,
		250,
		-1,
		236,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		271,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		284,
		276,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		299,
		290,
		-1,
		-1,
		261,
		268,
		290,
		293,
		329,
		-1,
		280
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		190,
		192,
		158,
		152,
		191,
		162,
		168,
		179,
		-1,
		-1,
		-1,
		181,
		180,
		150,
		148,
		157,
		162,
		169,
		-1,
		185,
		-1,
		202,
		181,
		192,
		197,
		143,
		140,
		160,
		179,
		178,
		170,
		217,
		173,
		144,
		138,
		156,
		161,
		172,
		164,
		-1,
		144,
		134,
		156,
		152,
		163,
		155,
		-1,
		-1,
		138,
		139,
		145,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		128,
		141,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		129,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		117,
		135,
		144,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		142,
		-1,
		122,
		124,
		126,
		134,
		139,
		131,
		118,
		118,
		128,
		121,
		140,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		119,
		109,
		126,
		118,
		114,
		127,
		128,
		121,
		118,
		116,
		113,
		129,
		130,
		140,
		-1,
		-1,
		175,
		144,
		179,
		136,
		121,
		-1,
		115,
		102,
		107,
		111,
		112,
		111,
		125,
		121,
		-1,
		107,
		106,
		137,
		123,
		134,
		135,
		-1,
		-1,
		133,
		125,
		110,
		113,
		110,
		110,
		99,
		98,
		94,
		92,
		88,
		108,
		111,
		111,
		117,
		101,
		111,
		115,
		126,
		141,
		-1,
		-1,
		196,
		-1,
		-1,
		132,
		115,
		-1,
		98,
		105,
		105,
		122,
		112,
		105,
		109,
		85,
		82,
		103,
		91,
		106,
		103,
		116,
		104,
		98,
		123,
		127,
		121,
		142,
		137,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		91,
		94,
		100,
		124,
		122,
		-1,
		67,
		73,
		78,
		72,
		82,
		95,
		97,
		110,
		95,
		102,
		101,
		105,
		107,
		140,
		118,
		140,
		137,
		166,
		171,
		165,
		174,
		-1,
		140,
		136,
		132,
		139,
		88,
		-1,
		-1,
		128,
		-1,
		91,
		84,
		59,
		77,
		80,
		73,
		64,
		102,
		93,
		104,
		93,
		90,
		98,
		107,
		118,
		113,
		112,
		130,
		145,
		158,
		162,
		168,
		-1,
		190,
		-1,
		132,
		116,
		118,
		90,
		111,
		-1,
		145,
		90,
		76,
		61,
		52,
		-1,
		50,
		53,
		79,
		86,
		85,
		102,
		94,
		92,
		97,
		102,
		116,
		107,
		125,
		132,
		140,
		144,
		164,
		176,
		150,
		140,
		-1,
		122,
		127,
		86,
		94,
		113,
		94,
		58,
		-1,
		53,
		-1,
		40,
		65,
		-1,
		85,
		89,
		84,
		85,
		80,
		95,
		101,
		98,
		95,
		113,
		116,
		133,
		137,
		153,
		-1,
		-1,
		135,
		139,
		128,
		79,
		98,
		122,
		104,
		51,
		40,
		39,
		-1,
		25,
		116,
		113,
		99,
		86,
		77,
		78,
		86,
		99,
		78,
		97,
		100,
		122,
		150,
		128,
		140,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		105,
		76,
		100,
		118,
		69,
		62,
		50,
		15,
		13,
		0,
		-1,
		106,
		89,
		86,
		75,
		73,
		86,
		81,
		97,
		101,
		100,
		119,
		131,
		122,
		142,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		71,
		94,
		131,
		48,
		34,
		39,
		14,
		2,
		11,
		109,
		106,
		73,
		82,
		74,
		63,
		77,
		85,
		89,
		98,
		107,
		113,
		137,
		137,
		143,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		85,
		92,
		124,
		39,
		109,
		-1,
		44,
		-1,
		17,
		51,
		59,
		65,
		77,
		63,
		68,
		79,
		91,
		104,
		100,
		107,
		142,
		142,
		127,
		147,
		150,
		-1,
		-1,
		-1,
		135,
		130,
		105,
		82,
		66,
		102,
		-1,
		79,
		80,
		-1,
		38,
		32,
		48,
		56,
		63,
		60,
		60,
		74,
		82,
		78,
		94,
		100,
		92,
		128,
		-1,
		135,
		129,
		137,
		127,
		115,
		-1,
		-1,
		-1,
		128,
		107,
		100,
		120,
		61,
		113,
		-1,
		-1,
		64,
		57,
		-1,
		35,
		44,
		51,
		60,
		65,
		70,
		78,
		73,
		86,
		91,
		97,
		102,
		120,
		124,
		128,
		117,
		113,
		110,
		124,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		61,
		81,
		-1,
		73,
		65,
		55,
		49,
		43,
		57,
		55,
		75,
		67,
		81,
		81,
		87,
		95,
		80,
		83,
		99,
		97,
		115,
		123,
		115,
		109,
		108,
		120,
		-1,
		148,
		134,
		105,
		-1,
		-1,
		94,
		-1,
		58,
		72,
		88,
		-1,
		81,
		60,
		75,
		53,
		67,
		63,
		101,
		102,
		80,
		85,
		93,
		103,
		105,
		94,
		105,
		97,
		119,
		119,
		103,
		104,
		113,
		-1,
		154,
		141,
		99,
		95,
		84,
		104,
		55,
		43,
		75,
		-1,
		-1,
		117,
		-1,
		51,
		68,
		77,
		75,
		91,
		82,
		88,
		104,
		107,
		109,
		99,
		88,
		94,
		91,
		113,
		99,
		97,
		116,
		132,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		70,
		57,
		51,
		-1,
		92,
		-1,
		95,
		85,
		69,
		54,
		87,
		-1,
		99,
		83,
		88,
		-1,
		134,
		-1,
		107,
		109,
		103,
		88,
		85,
		96,
		94,
		105,
		122,
		-1,
		104,
		89,
		82,
		72,
		86,
		57,
		-1,
		112,
		-1,
		-1,
		82,
		76,
		76,
		60,
		63,
		115,
		95,
		89,
		88,
		129,
		129,
		115,
		101,
		94,
		91,
		88,
		101,
		121,
		112,
		124,
		-1,
		-1,
		-1,
		109,
		95,
		99,
		59,
		78,
		-1,
		-1,
		144,
		99,
		85,
		-1,
		69,
		132,
		120,
		110,
		100,
		134,
		135,
		120,
		113,
		99,
		101,
		99,
		97,
		102,
		123,
		124,
		137,
		-1,
		-1,
		92,
		97,
		85,
		71,
		90,
		-1,
		-1,
		-1,
		91,
		107,
		99,
		70,
		121,
		-1,
		-1,
		112,
		110,
		120,
		116,
		103,
		123,
		126,
		112,
		96,
		111,
		123,
		131,
		136,
		-1,
		95,
		82,
		-1,
		-1,
		93,
		87,
		-1,
		-1,
		-1,
		-1,
		124,
		90,
		102,
		123,
		148,
		115,
		-1,
		120,
		121,
		107,
		121,
		128,
		114,
		109,
		103,
		106,
		124,
		141,
		-1,
		-1,
		107,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		81,
		95,
		116,
		122,
		134,
		-1,
		129,
		123,
		109,
		126,
		127,
		124,
		115,
		107,
		112,
		109,
		122,
		136,
		140,
		130,
		-1,
		113,
		-1,
		-1,
		-1,
		99,
		114,
		176,
		153,
		126,
		130,
		123,
		117,
		117,
		133,
		135,
		146,
		114,
		110,
		111,
		115,
		114,
		131,
		141,
		-1,
		-1,
		113,
		130,
		125,
		107,
		111,
		203,
		-1,
		-1,
		139,
		130,
		121,
		124,
		127,
		130,
		120,
		117,
		122,
		127,
		115,
		124,
		142,
		146,
		-1,
		-1,
		-1,
		133,
		-1,
		148,
		-1,
		-1,
		126,
		210,
		157,
		139,
		135,
		133,
		126,
		135,
		130,
		125,
		135,
		144,
		136,
		117,
		128,
		151,
		140,
		178,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		162,
		137,
		152,
		198,
		146,
		153,
		172,
		169,
		-1,
		139,
		164,
		136,
		143,
		135,
		143,
		143,
		140,
		118,
		125,
		141,
		140,
		135,
		170,
		162,
		168,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		168,
		154,
		184,
		174,
		163,
		-1,
		-1,
		188,
		185,
		161,
		145,
		149,
		142,
		137,
		147,
		127,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		140,
		221,
		214,
		197,
		205,
		236,
		-1,
		171,
		180,
		161,
		166,
		174,
		-1,
		-1,
		161,
		158,
		163,
		152,
		149,
		157,
		152,
		143,
		128,
		134,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		154,
		197,
		191,
		194,
		218,
		232,
		-1,
		184,
		-1,
		-1,
		169,
		187,
		176,
		166,
		160,
		210,
		166,
		161,
		151,
		149,
		140,
		131,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		189,
		177,
		185,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		185,
		-1,
		203,
		-1,
		178,
		182,
		174,
		177,
		165,
		152,
		144,
		136,
		152,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		263,
		218,
		185,
		176,
		223,
		238,
		242,
		-1,
		197,
		236,
		223,
		-1,
		194,
		-1,
		-1,
		-1,
		192,
		187,
		179,
		185,
		164,
		164,
		138,
		142,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		259,
		257,
		262,
		207,
		190,
		208,
		217,
		238,
		212,
		203,
		230,
		230,
		219,
		214,
		201,
		-1,
		-1,
		215,
		197,
		-1,
		-1,
		171,
		159,
		142,
		143,
		139,
		142,
		157,
		160,
		150,
		148,
		142,
		174,
		-1,
		259,
		258,
		247,
		244,
		220,
		211,
		198,
		209,
		-1,
		-1,
		215,
		231,
		244,
		248,
		261,
		286,
		-1,
		204,
		-1,
		-1,
		216,
		-1,
		-1,
		201,
		164,
		153,
		144,
		150,
		147,
		158,
		168,
		156,
		157,
		147,
		157,
		170,
		243,
		240,
		228,
		226,
		249,
		206,
		202,
		-1,
		225,
		218,
		224,
		231,
		248,
		275,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		199,
		197,
		186,
		-1,
		176,
		149,
		154,
		174,
		176,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		252,
		266,
		255,
		251,
		250,
		258,
		207,
		210,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		237,
		230,
		-1,
		-1,
		194,
		187,
		175,
		163,
		153,
		163,
		167,
		171,
		163,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		286,
		-1,
		238,
		224,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		254,
		240,
		233,
		221,
		219,
		-1,
		228,
		212,
		193,
		-1,
		163,
		176,
		207,
		175,
		180,
		175,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		244,
		246,
		-1,
		245,
		234,
		219,
		211,
		-1,
		-1,
		200,
		196,
		-1,
		-1,
		164,
		189,
		178,
		186,
		181,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		243,
		244,
		249,
		-1,
		229,
		-1,
		247,
		-1,
		214,
		220,
		208,
		-1,
		-1,
		-1,
		202,
		165,
		186,
		196,
		190,
		188,
		179,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		247,
		221,
		254,
		245,
		228,
		208,
		200,
		219,
		-1,
		189,
		-1,
		164,
		166,
		192,
		195,
		201,
		195,
		168,
		183,
		173,
		164,
		173,
		253,
		-1,
		223,
		256,
		220,
		214,
		190,
		194,
		210,
		-1,
		186,
		168,
		-1,
		196,
		186,
		217,
		202,
		183,
		170,
		177,
		177,
		170,
		-1,
		-1,
		-1,
		225,
		224,
		216,
		210,
		210,
		195,
		186,
		-1,
		198,
		180,
		159,
		176,
		176,
		167,
		175,
		207,
		203,
		190,
		190,
		182,
		-1,
		326,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		219,
		214,
		187,
		175,
		181,
		177,
		163,
		169,
		171,
		179,
		177,
		174,
		186,
		182,
		202,
		183,
		218,
		-1,
		321,
		-1,
		255,
		-1,
		-1,
		237,
		217,
		209,
		198,
		187,
		185,
		176,
		167,
		189,
		205,
		189,
		187,
		190,
		191,
		-1,
		310,
		309,
		-1,
		256,
		248,
		234,
		-1,
		227,
		-1,
		233,
		194,
		-1,
		196,
		176,
		-1,
		198,
		194,
		-1,
		-1,
		297,
		272,
		-1,
		-1,
		-1,
		257,
		237,
		228,
		212,
		-1,
		187,
		187,
		-1,
		-1,
		-1,
		282,
		281,
		-1,
		250,
		253,
		-1,
		243,
		234,
		242,
		189,
		193,
		-1,
		-1,
		-1,
		291,
		272,
		266,
		265,
		263,
		258,
		255,
		241,
		225,
		203,
		192,
		213,
		-1,
		-1,
		-1,
		263,
		255,
		248,
		-1,
		-1,
		250,
		233,
		214,
		212,
		-1,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		240,
		-1,
		-1,
		246,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		274,
		-1,
		-1,
		-1,
		236,
		232,
		233,
		-1,
		-1,
		-1,
		-1,
		296,
		297,
		320,
		284,
		-1,
		-1,
		-1,
		228,
		222,
		-1,
		-1,
		299,
		297,
		-1,
		-1,
		-1,
		256,
		240,
		-1,
		226,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		261,
		-1,
		261,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		274,
		266,
		274,
		-1,
		246,
		248,
		-1,
		296,
		-1,
		-1,
		289,
		280,
		-1,
		-1,
		251,
		258,
		280,
		283,
		319,
		-1,
		270
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		182,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		175,
		167,
		207,
		163,
		134,
		128,
		146,
		151,
		169,
		161,
		-1,
		134,
		124,
		146,
		150,
		161,
		145,
		-1,
		-1,
		128,
		129,
		135,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		118,
		131,
		127,
		130,
		138,
		137,
		150,
		142,
		137,
		-1,
		-1,
		119,
		123,
		136,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		107,
		125,
		134,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		140,
		-1,
		116,
		117,
		118,
		126,
		131,
		129,
		116,
		116,
		126,
		119,
		138,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		99,
		116,
		113,
		106,
		119,
		121,
		119,
		116,
		114,
		111,
		127,
		128,
		138,
		-1,
		-1,
		210,
		183,
		207,
		165,
		146,
		-1,
		112,
		92,
		98,
		102,
		104,
		104,
		118,
		114,
		-1,
		105,
		104,
		135,
		121,
		132,
		187,
		-1,
		-1,
		168,
		160,
		142,
		145,
		122,
		118,
		107,
		106,
		98,
		84,
		80,
		101,
		104,
		104,
		110,
		99,
		109,
		113,
		124,
		139,
		-1,
		-1,
		194,
		-1,
		-1,
		184,
		167,
		-1,
		137,
		144,
		128,
		134,
		120,
		141,
		117,
		105,
		100,
		94,
		82,
		95,
		96,
		109,
		100,
		96,
		121,
		125,
		119,
		140,
		135,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		141,
		134,
		158,
		157,
		-1,
		117,
		105,
		102,
		91,
		92,
		83,
		75,
		84,
		88,
		100,
		99,
		103,
		105,
		138,
		116,
		138,
		135,
		164,
		169,
		163,
		172,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		162,
		-1,
		165,
		154,
		129,
		102,
		105,
		87,
		74,
		78,
		71,
		78,
		86,
		83,
		96,
		105,
		116,
		111,
		110,
		128,
		143,
		156,
		160,
		166,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		182,
		166,
		146,
		131,
		131,
		-1,
		92,
		89,
		79,
		57,
		63,
		80,
		83,
		87,
		95,
		100,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		142,
		-1,
		94,
		107,
		-1,
		63,
		47,
		53,
		64,
		78,
		93,
		99,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		112,
		43,
		40,
		26,
		33,
		51,
		57,
		78,
		97,
		76,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		0,
		26,
		38,
		61,
		65,
		79,
		81,
		95,
		99,
		98,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		109,
		27,
		4,
		48,
		50,
		59,
		61,
		77,
		85,
		87,
		96,
		105,
		111,
		135,
		142,
		148,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		114,
		-1,
		103,
		71,
		65,
		62,
		67,
		73,
		68,
		77,
		91,
		102,
		98,
		105,
		140,
		140,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		108,
		102,
		75,
		68,
		62,
		78,
		79,
		75,
		78,
		78,
		92,
		103,
		90,
		126,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		86,
		78,
		83,
		78,
		79,
		83,
		87,
		76,
		89,
		94,
		95,
		105,
		125,
		129,
		133,
		122,
		118,
		115,
		129,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		107,
		91,
		94,
		94,
		90,
		98,
		83,
		86,
		98,
		102,
		120,
		128,
		120,
		114,
		113,
		125,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		95,
		114,
		115,
		93,
		98,
		97,
		107,
		108,
		97,
		110,
		102,
		124,
		124,
		108,
		109,
		118,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		109,
		107,
		104,
		95,
		101,
		108,
		111,
		112,
		102,
		91,
		97,
		96,
		118,
		104,
		102,
		121,
		137,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		112,
		96,
		101,
		-1,
		137,
		-1,
		110,
		112,
		104,
		93,
		90,
		101,
		99,
		110,
		127,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		128,
		108,
		102,
		101,
		132,
		130,
		118,
		102,
		95,
		92,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		145,
		133,
		123,
		113,
		147,
		146,
		121,
		114,
		100,
		102,
		100,
		102,
		107,
		128,
		129,
		142,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		134,
		-1,
		-1,
		125,
		123,
		133,
		117,
		104,
		124,
		127,
		117,
		101,
		116,
		128,
		136,
		141,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		154,
		158,
		162,
		128,
		-1,
		133,
		128,
		108,
		122,
		129,
		119,
		114,
		108,
		111,
		129,
		146,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		133,
		147,
		151,
		144,
		148,
		-1,
		136,
		124,
		110,
		127,
		132,
		129,
		120,
		112,
		117,
		114,
		127,
		141,
		145,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		151,
		166,
		190,
		167,
		140,
		135,
		128,
		122,
		118,
		134,
		140,
		151,
		119,
		115,
		116,
		120,
		119,
		136,
		146,
		-1,
		-1,
		165,
		182,
		177,
		159,
		163,
		217,
		-1,
		-1,
		144,
		135,
		126,
		129,
		128,
		131,
		125,
		122,
		127,
		132,
		120,
		129,
		147,
		146,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		178,
		215,
		162,
		144,
		140,
		138,
		131,
		140,
		135,
		130,
		140,
		142,
		134,
		122,
		126,
		149,
		138,
		177,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		214,
		189,
		204,
		226,
		198,
		205,
		177,
		174,
		-1,
		144,
		169,
		141,
		148,
		139,
		146,
		146,
		138,
		116,
		123,
		139,
		138,
		133,
		169,
		160,
		166,
		-1,
		-1,
		297,
		286,
		275,
		281,
		-1,
		220,
		206,
		212,
		202,
		205,
		-1,
		-1,
		193,
		190,
		166,
		149,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		192,
		273,
		266,
		249,
		257,
		288,
		-1,
		216,
		208,
		213,
		194,
		196,
		-1,
		-1,
		166,
		163,
		168,
		156,
		153,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		206,
		249,
		243,
		246,
		270,
		284,
		-1,
		213,
		-1,
		-1,
		221,
		197,
		181,
		171,
		165,
		215,
		170,
		165,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		241,
		229,
		237,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		237,
		-1,
		208,
		-1,
		183,
		187,
		178,
		181,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		284,
		240,
		237,
		228,
		265,
		280,
		284,
		-1,
		225,
		264,
		262,
		-1,
		246,
		-1,
		-1,
		-1,
		197,
		191,
		183,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		280,
		271,
		284,
		229,
		229,
		250,
		259,
		280,
		240,
		231,
		258,
		269,
		258,
		253,
		240,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		220,
		247,
		-1,
		-1,
		242,
		259,
		253,
		257,
		273,
		298,
		-1,
		229,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		257,
		254,
		242,
		240,
		263,
		228,
		216,
		-1,
		229,
		227,
		233,
		240,
		257,
		287,
		-1,
		-1,
		245,
		225,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		214,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		231,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		300,
		-1,
		252,
		228,
		242,
		257,
		265,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		240,
		243,
		-1,
		-1,
		242,
		244,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		247,
		248,
		249,
		-1,
		227,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		212,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		324,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		149,
		138,
		149,
		157,
		130,
		137,
		-1,
		158,
		160,
		126,
		120,
		159,
		130,
		136,
		147,
		-1,
		-1,
		-1,
		149,
		148,
		118,
		116,
		125,
		130,
		137,
		-1,
		160,
		-1,
		170,
		149,
		160,
		165,
		111,
		108,
		128,
		147,
		153,
		145,
		185,
		141,
		112,
		106,
		124,
		129,
		147,
		139,
		-1,
		112,
		102,
		124,
		128,
		139,
		123,
		-1,
		-1,
		106,
		107,
		113,
		124,
		130,
		126,
		-1,
		136,
		120,
		-1,
		-1,
		96,
		109,
		105,
		108,
		116,
		115,
		128,
		120,
		115,
		-1,
		-1,
		97,
		101,
		114,
		102,
		98,
		115,
		128,
		110,
		124,
		123,
		-1,
		85,
		103,
		112,
		109,
		107,
		91,
		89,
		107,
		109,
		115,
		118,
		-1,
		94,
		95,
		96,
		104,
		109,
		107,
		94,
		94,
		104,
		97,
		116,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		77,
		94,
		91,
		84,
		97,
		99,
		97,
		94,
		92,
		89,
		105,
		106,
		116,
		-1,
		-1,
		188,
		161,
		185,
		143,
		124,
		-1,
		90,
		70,
		76,
		80,
		82,
		82,
		96,
		92,
		-1,
		83,
		82,
		113,
		99,
		110,
		165,
		-1,
		-1,
		146,
		138,
		120,
		123,
		100,
		96,
		85,
		84,
		76,
		62,
		58,
		79,
		82,
		82,
		88,
		77,
		87,
		91,
		102,
		117,
		-1,
		-1,
		172,
		-1,
		-1,
		162,
		145,
		-1,
		115,
		122,
		106,
		112,
		98,
		119,
		95,
		86,
		78,
		72,
		60,
		73,
		74,
		87,
		80,
		74,
		99,
		103,
		97,
		118,
		113,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		121,
		119,
		112,
		136,
		135,
		-1,
		101,
		89,
		86,
		75,
		76,
		64,
		53,
		65,
		66,
		78,
		77,
		81,
		83,
		116,
		94,
		116,
		113,
		142,
		147,
		141,
		150,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		140,
		-1,
		143,
		138,
		113,
		86,
		89,
		71,
		58,
		59,
		49,
		59,
		64,
		61,
		74,
		83,
		94,
		89,
		88,
		106,
		121,
		134,
		138,
		144,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		160,
		144,
		130,
		115,
		115,
		-1,
		76,
		73,
		63,
		41,
		41,
		58,
		61,
		65,
		73,
		78,
		92,
		83,
		101,
		108,
		116,
		120,
		140,
		152,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		181,
		145,
		-1,
		126,
		-1,
		78,
		91,
		-1,
		47,
		31,
		31,
		42,
		56,
		71,
		77,
		74,
		71,
		89,
		92,
		109,
		113,
		129,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		96,
		27,
		24,
		10,
		11,
		29,
		35,
		56,
		75,
		54,
		73,
		76,
		98,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		26,
		0,
		16,
		39,
		43,
		57,
		59,
		73,
		77,
		76,
		95,
		107,
		98,
		118,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		87,
		36,
		22,
		26,
		28,
		37,
		39,
		55,
		63,
		65,
		74,
		83,
		89,
		113,
		120,
		126,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		92,
		-1,
		81,
		49,
		43,
		40,
		45,
		51,
		46,
		55,
		69,
		80,
		76,
		83,
		118,
		118,
		110,
		130,
		133,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		86,
		80,
		53,
		46,
		40,
		56,
		57,
		53,
		56,
		56,
		70,
		81,
		68,
		104,
		-1,
		118,
		112,
		120,
		110,
		98,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		64,
		56,
		61,
		56,
		57,
		61,
		65,
		54,
		67,
		72,
		73,
		83,
		103,
		107,
		111,
		100,
		96,
		93,
		107,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		69,
		67,
		85,
		69,
		72,
		72,
		68,
		76,
		61,
		64,
		76,
		80,
		98,
		106,
		98,
		92,
		91,
		103,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		79,
		73,
		92,
		93,
		71,
		76,
		75,
		85,
		86,
		75,
		88,
		80,
		102,
		102,
		86,
		87,
		96,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		87,
		85,
		82,
		73,
		79,
		86,
		89,
		90,
		80,
		69,
		75,
		74,
		96,
		82,
		80,
		99,
		115,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		90,
		74,
		79,
		-1,
		115,
		-1,
		88,
		90,
		82,
		71,
		68,
		79,
		77,
		88,
		105,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		106,
		86,
		80,
		79,
		110,
		108,
		96,
		80,
		73,
		70,
		71,
		84,
		104,
		95,
		107,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		123,
		111,
		101,
		91,
		125,
		124,
		99,
		92,
		78,
		80,
		78,
		80,
		85,
		106,
		107,
		120,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		112,
		-1,
		-1,
		103,
		101,
		111,
		95,
		82,
		102,
		105,
		95,
		79,
		94,
		106,
		114,
		119,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		154,
		120,
		132,
		136,
		140,
		106,
		-1,
		111,
		106,
		86,
		100,
		107,
		97,
		92,
		86,
		89,
		107,
		124,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		111,
		125,
		129,
		122,
		126,
		-1,
		114,
		102,
		88,
		105,
		110,
		107,
		98,
		90,
		95,
		92,
		105,
		119,
		123,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		129,
		144,
		168,
		145,
		118,
		113,
		106,
		100,
		96,
		112,
		118,
		129,
		97,
		93,
		94,
		98,
		97,
		114,
		124,
		-1,
		-1,
		143,
		160,
		155,
		137,
		141,
		195,
		-1,
		-1,
		122,
		113,
		104,
		107,
		106,
		109,
		103,
		100,
		105,
		110,
		98,
		107,
		125,
		124,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		156,
		193,
		140,
		122,
		118,
		116,
		109,
		118,
		113,
		108,
		118,
		120,
		112,
		100,
		104,
		127,
		116,
		155,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		192,
		167,
		182,
		204,
		176,
		183,
		155,
		152,
		-1,
		122,
		147,
		119,
		126,
		117,
		124,
		124,
		116,
		94,
		101,
		117,
		116,
		111,
		147,
		138,
		144,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		198,
		184,
		190,
		180,
		183,
		-1,
		-1,
		171,
		168,
		144,
		127,
		125,
		118,
		113,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		135,
		150,
		-1,
		170,
		251,
		244,
		227,
		235,
		266,
		-1,
		194,
		186,
		191,
		172,
		174,
		-1,
		-1,
		144,
		141,
		146,
		134,
		131,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		134,
		124,
		137,
		141,
		-1,
		184,
		227,
		221,
		224,
		248,
		262,
		-1,
		191,
		-1,
		-1,
		199,
		175,
		159,
		149,
		143,
		193,
		148,
		143,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		134,
		134,
		135,
		-1,
		219,
		207,
		215,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		215,
		-1,
		186,
		-1,
		161,
		165,
		156,
		159,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		141,
		142,
		262,
		218,
		215,
		206,
		243,
		258,
		262,
		-1,
		203,
		242,
		240,
		-1,
		224,
		-1,
		-1,
		-1,
		175,
		169,
		161,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		150,
		258,
		249,
		262,
		207,
		207,
		228,
		237,
		258,
		218,
		209,
		236,
		247,
		236,
		231,
		218,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		251,
		250,
		239,
		236,
		212,
		203,
		198,
		225,
		-1,
		-1,
		220,
		237,
		231,
		235,
		251,
		276,
		-1,
		207,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		235,
		232,
		220,
		218,
		241,
		206,
		194,
		-1,
		207,
		205,
		211,
		218,
		235,
		265,
		-1,
		-1,
		223,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		244,
		258,
		247,
		243,
		242,
		250,
		199,
		192,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		278,
		-1,
		230,
		206,
		220,
		235,
		243,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		218,
		221,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		225,
		226,
		227,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		140,
		129,
		140,
		148,
		121,
		128,
		-1,
		149,
		151,
		117,
		111,
		150,
		121,
		127,
		138,
		-1,
		-1,
		-1,
		140,
		139,
		109,
		107,
		116,
		121,
		128,
		-1,
		146,
		-1,
		161,
		140,
		151,
		156,
		102,
		99,
		119,
		138,
		139,
		131,
		176,
		132,
		103,
		97,
		115,
		120,
		133,
		125,
		-1,
		103,
		93,
		115,
		113,
		124,
		114,
		-1,
		-1,
		97,
		98,
		104,
		109,
		115,
		111,
		-1,
		121,
		105,
		-1,
		-1,
		87,
		100,
		91,
		94,
		102,
		100,
		113,
		105,
		100,
		-1,
		-1,
		88,
		92,
		100,
		87,
		83,
		100,
		113,
		95,
		109,
		108,
		-1,
		76,
		94,
		103,
		94,
		92,
		76,
		74,
		92,
		94,
		100,
		103,
		-1,
		85,
		86,
		87,
		95,
		100,
		92,
		79,
		79,
		89,
		82,
		101,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		85,
		68,
		85,
		82,
		75,
		88,
		89,
		82,
		79,
		77,
		74,
		90,
		91,
		101,
		-1,
		-1,
		179,
		152,
		176,
		134,
		115,
		-1,
		81,
		61,
		67,
		71,
		73,
		72,
		86,
		82,
		-1,
		68,
		67,
		98,
		84,
		95,
		156,
		-1,
		-1,
		137,
		129,
		111,
		114,
		91,
		87,
		76,
		75,
		67,
		53,
		49,
		69,
		72,
		72,
		78,
		62,
		72,
		76,
		91,
		102,
		-1,
		-1,
		161,
		-1,
		-1,
		153,
		136,
		-1,
		106,
		113,
		97,
		103,
		89,
		110,
		86,
		77,
		69,
		63,
		51,
		64,
		64,
		77,
		65,
		59,
		84,
		88,
		86,
		107,
		102,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		110,
		103,
		127,
		126,
		-1,
		98,
		86,
		87,
		72,
		69,
		56,
		44,
		57,
		56,
		63,
		62,
		66,
		68,
		101,
		83,
		105,
		102,
		131,
		136,
		130,
		139,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		131,
		-1,
		134,
		135,
		110,
		83,
		86,
		73,
		64,
		51,
		40,
		51,
		54,
		51,
		59,
		72,
		79,
		78,
		77,
		95,
		110,
		123,
		127,
		133,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		151,
		135,
		127,
		112,
		112,
		-1,
		82,
		79,
		69,
		47,
		32,
		49,
		55,
		53,
		58,
		67,
		81,
		72,
		90,
		97,
		105,
		109,
		129,
		141,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		123,
		-1,
		84,
		97,
		-1,
		53,
		41,
		27,
		32,
		41,
		56,
		65,
		63,
		60,
		78,
		81,
		98,
		102,
		118,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		102,
		37,
		34,
		20,
		7,
		19,
		25,
		40,
		61,
		43,
		62,
		65,
		87,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		31,
		10,
		0,
		28,
		27,
		41,
		45,
		62,
		66,
		65,
		84,
		96,
		87,
		107,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		46,
		27,
		22,
		18,
		21,
		28,
		41,
		48,
		52,
		63,
		72,
		78,
		102,
		109,
		115,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		45,
		39,
		36,
		29,
		35,
		32,
		44,
		54,
		69,
		65,
		72,
		107,
		107,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		49,
		42,
		36,
		41,
		41,
		39,
		40,
		45,
		58,
		67,
		57,
		93,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		60,
		47,
		50,
		48,
		46,
		48,
		53,
		42,
		55,
		60,
		62,
		71,
		92,
		96,
		100,
		89,
		85,
		82,
		96,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		60,
		58,
		73,
		58,
		61,
		61,
		56,
		64,
		49,
		52,
		65,
		69,
		87,
		95,
		87,
		81,
		80,
		92,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		70,
		61,
		81,
		82,
		60,
		65,
		63,
		73,
		74,
		63,
		77,
		69,
		91,
		91,
		75,
		76,
		85,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		75,
		73,
		71,
		62,
		68,
		74,
		77,
		78,
		68,
		57,
		63,
		63,
		85,
		71,
		69,
		88,
		104,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		79,
		63,
		68,
		-1,
		103,
		-1,
		76,
		78,
		71,
		60,
		57,
		68,
		66,
		77,
		94,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		95,
		75,
		69,
		68,
		98,
		97,
		84,
		69,
		62,
		59,
		60,
		73,
		93,
		84,
		96,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		112,
		100,
		90,
		80,
		114,
		113,
		88,
		81,
		67,
		69,
		67,
		69,
		74,
		95,
		96,
		109,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		101,
		-1,
		-1,
		92,
		90,
		100,
		84,
		71,
		91,
		94,
		84,
		68,
		83,
		95,
		103,
		108,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		123,
		125,
		129,
		95,
		-1,
		100,
		95,
		75,
		89,
		96,
		86,
		81,
		75,
		78,
		96,
		113,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		102,
		116,
		118,
		111,
		115,
		-1,
		103,
		91,
		77,
		94,
		99,
		96,
		87,
		79,
		84,
		81,
		94,
		108,
		112,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		120,
		135,
		157,
		134,
		107,
		102,
		95,
		89,
		85,
		101,
		107,
		118,
		86,
		82,
		83,
		87,
		86,
		103,
		113,
		-1,
		-1,
		134,
		151,
		146,
		128,
		132,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		95,
		98,
		92,
		89,
		94,
		99,
		87,
		96,
		114,
		113,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		147,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		97,
		107,
		109,
		101,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		183,
		158,
		173,
		193,
		167,
		174,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		106,
		113,
		113,
		105,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		189,
		175,
		179,
		169,
		172,
		-1,
		-1,
		160,
		157,
		133,
		116,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		161,
		242,
		235,
		218,
		226,
		257,
		-1,
		183,
		175,
		182,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		123,
		120,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		175,
		218,
		212,
		215,
		239,
		253,
		-1,
		180,
		-1,
		-1,
		190,
		164,
		148,
		138,
		132,
		182,
		137,
		132,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		210,
		198,
		206,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		206,
		-1,
		175,
		-1,
		150,
		154,
		145,
		148,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		251,
		207,
		206,
		197,
		232,
		247,
		251,
		-1,
		192,
		231,
		229,
		-1,
		213,
		-1,
		-1,
		-1,
		164,
		158,
		150,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		207,
		198,
		225,
		236,
		225,
		220,
		207,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		226,
		220,
		224,
		240,
		265,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		214,
		215,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		140,
		142,
		108,
		102,
		141,
		112,
		118,
		129,
		-1,
		-1,
		-1,
		131,
		130,
		100,
		98,
		107,
		112,
		119,
		-1,
		141,
		-1,
		152,
		131,
		142,
		147,
		93,
		90,
		110,
		129,
		134,
		126,
		167,
		123,
		94,
		88,
		106,
		111,
		128,
		120,
		-1,
		94,
		84,
		106,
		108,
		119,
		105,
		-1,
		-1,
		88,
		89,
		95,
		104,
		110,
		106,
		-1,
		116,
		100,
		-1,
		-1,
		78,
		91,
		86,
		89,
		97,
		95,
		108,
		100,
		95,
		-1,
		-1,
		79,
		83,
		95,
		82,
		78,
		95,
		108,
		90,
		104,
		103,
		-1,
		67,
		85,
		94,
		89,
		87,
		71,
		69,
		87,
		89,
		95,
		98,
		-1,
		76,
		77,
		78,
		86,
		91,
		87,
		74,
		74,
		84,
		77,
		96,
		87,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		76,
		59,
		76,
		73,
		66,
		79,
		84,
		77,
		74,
		72,
		69,
		85,
		86,
		96,
		-1,
		-1,
		170,
		143,
		167,
		125,
		106,
		-1,
		72,
		52,
		58,
		62,
		64,
		66,
		81,
		77,
		-1,
		63,
		62,
		93,
		79,
		90,
		147,
		-1,
		-1,
		128,
		120,
		102,
		105,
		82,
		78,
		67,
		66,
		58,
		44,
		40,
		64,
		67,
		67,
		73,
		57,
		67,
		71,
		82,
		97,
		-1,
		-1,
		152,
		-1,
		-1,
		144,
		127,
		-1,
		97,
		104,
		88,
		94,
		80,
		101,
		77,
		68,
		60,
		54,
		42,
		55,
		59,
		72,
		60,
		54,
		79,
		83,
		77,
		98,
		93,
		-1,
		151,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		103,
		101,
		94,
		118,
		117,
		-1,
		89,
		77,
		78,
		63,
		60,
		47,
		35,
		48,
		51,
		58,
		57,
		61,
		63,
		96,
		74,
		96,
		93,
		122,
		127,
		121,
		130,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		122,
		-1,
		125,
		126,
		101,
		74,
		77,
		64,
		55,
		42,
		31,
		42,
		49,
		46,
		54,
		63,
		74,
		69,
		68,
		86,
		101,
		114,
		118,
		124,
		-1,
		202,
		-1,
		144,
		128,
		130,
		102,
		123,
		-1,
		142,
		126,
		118,
		103,
		103,
		-1,
		73,
		70,
		60,
		38,
		23,
		40,
		50,
		46,
		53,
		58,
		72,
		63,
		81,
		88,
		96,
		100,
		120,
		132,
		162,
		152,
		-1,
		134,
		139,
		98,
		106,
		125,
		163,
		127,
		-1,
		114,
		-1,
		75,
		88,
		-1,
		44,
		40,
		22,
		20,
		34,
		51,
		57,
		54,
		51,
		69,
		72,
		89,
		93,
		109,
		-1,
		-1,
		147,
		151,
		140,
		91,
		110,
		134,
		171,
		120,
		109,
		108,
		-1,
		93,
		58,
		55,
		43,
		30,
		15,
		12,
		39,
		55,
		34,
		53,
		56,
		78,
		106,
		84,
		96,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		117,
		88,
		112,
		154,
		138,
		131,
		119,
		84,
		84,
		78,
		-1,
		54,
		33,
		29,
		0,
		21,
		38,
		39,
		53,
		57,
		56,
		75,
		87,
		78,
		98,
		-1,
		-1,
		-1,
		147,
		136,
		137,
		83,
		106,
		143,
		117,
		103,
		108,
		83,
		76,
		70,
		67,
		50,
		45,
		31,
		26,
		19,
		35,
		43,
		45,
		54,
		63,
		69,
		93,
		100,
		106,
		-1,
		-1,
		154,
		144,
		128,
		130,
		127,
		97,
		104,
		136,
		108,
		121,
		-1,
		75,
		-1,
		64,
		59,
		43,
		38,
		32,
		32,
		26,
		35,
		49,
		60,
		56,
		63,
		98,
		98,
		90,
		110,
		113,
		-1,
		-1,
		-1,
		147,
		142,
		117,
		94,
		78,
		114,
		-1,
		91,
		92,
		-1,
		69,
		63,
		60,
		45,
		41,
		36,
		40,
		33,
		40,
		36,
		50,
		61,
		48,
		84,
		-1,
		98,
		92,
		100,
		90,
		78,
		-1,
		-1,
		-1,
		140,
		119,
		112,
		132,
		73,
		125,
		-1,
		-1,
		76,
		69,
		-1,
		56,
		38,
		45,
		43,
		37,
		41,
		45,
		34,
		47,
		52,
		53,
		63,
		83,
		87,
		91,
		80,
		76,
		73,
		87,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		93,
		-1,
		85,
		77,
		67,
		61,
		55,
		51,
		49,
		65,
		49,
		52,
		52,
		48,
		56,
		41,
		44,
		56,
		60,
		78,
		86,
		78,
		72,
		71,
		83,
		-1,
		160,
		146,
		117,
		-1,
		-1,
		106,
		-1,
		70,
		84,
		100,
		-1,
		93,
		72,
		87,
		65,
		61,
		57,
		72,
		73,
		51,
		56,
		55,
		65,
		66,
		55,
		68,
		60,
		82,
		82,
		66,
		67,
		76,
		-1,
		166,
		153,
		111,
		107,
		96,
		116,
		67,
		55,
		87,
		-1,
		-1,
		129,
		-1,
		63,
		80,
		71,
		69,
		62,
		53,
		59,
		66,
		69,
		70,
		60,
		49,
		55,
		54,
		76,
		62,
		60,
		79,
		95,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		82,
		69,
		63,
		-1,
		104,
		-1,
		107,
		97,
		81,
		66,
		99,
		-1,
		70,
		54,
		59,
		-1,
		95,
		-1,
		68,
		70,
		62,
		51,
		48,
		59,
		57,
		68,
		85,
		-1,
		116,
		101,
		94,
		84,
		98,
		69,
		-1,
		124,
		-1,
		-1,
		94,
		88,
		88,
		72,
		75,
		86,
		66,
		60,
		59,
		90,
		88,
		76,
		60,
		53,
		50,
		51,
		64,
		84,
		75,
		87,
		-1,
		-1,
		-1,
		121,
		107,
		111,
		71,
		90,
		-1,
		-1,
		156,
		111,
		97,
		-1,
		81,
		103,
		91,
		81,
		71,
		105,
		104,
		79,
		72,
		58,
		60,
		58,
		60,
		65,
		86,
		87,
		100,
		-1,
		-1,
		104,
		109,
		97,
		83,
		102,
		-1,
		-1,
		-1,
		103,
		119,
		111,
		82,
		92,
		-1,
		-1,
		83,
		81,
		91,
		75,
		62,
		82,
		85,
		75,
		59,
		74,
		86,
		94,
		99,
		-1,
		107,
		94,
		-1,
		-1,
		105,
		99,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		114,
		116,
		120,
		86,
		-1,
		91,
		86,
		66,
		80,
		87,
		77,
		72,
		66,
		69,
		87,
		104,
		-1,
		-1,
		119,
		-1,
		114,
		-1,
		-1,
		-1,
		-1,
		93,
		107,
		109,
		102,
		106,
		-1,
		94,
		82,
		68,
		85,
		90,
		87,
		78,
		70,
		75,
		72,
		85,
		99,
		103,
		142,
		-1,
		125,
		-1,
		-1,
		-1,
		111,
		126,
		148,
		125,
		98,
		93,
		86,
		80,
		76,
		92,
		98,
		109,
		77,
		73,
		74,
		78,
		77,
		94,
		104,
		-1,
		-1,
		125,
		142,
		137,
		119,
		123,
		175,
		-1,
		-1,
		102,
		93,
		84,
		87,
		86,
		89,
		83,
		80,
		85,
		90,
		78,
		87,
		105,
		104,
		-1,
		-1,
		-1,
		145,
		-1,
		160,
		-1,
		-1,
		138,
		173,
		120,
		102,
		98,
		96,
		89,
		98,
		93,
		88,
		98,
		100,
		92,
		80,
		84,
		107,
		96,
		135,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		174,
		149,
		164,
		184,
		158,
		165,
		135,
		132,
		-1,
		102,
		127,
		99,
		106,
		97,
		104,
		104,
		96,
		74,
		81,
		97,
		96,
		91,
		127,
		118,
		124,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		180,
		166,
		170,
		160,
		163,
		-1,
		-1,
		151,
		148,
		124,
		107,
		105,
		98,
		93,
		103,
		83,
		70,
		74,
		78,
		84,
		89,
		94,
		100,
		115,
		130,
		-1,
		152,
		233,
		226,
		209,
		217,
		248,
		-1,
		174,
		166,
		173,
		152,
		154,
		-1,
		-1,
		124,
		121,
		126,
		114,
		111,
		113,
		108,
		99,
		84,
		90,
		77,
		76,
		94,
		98,
		107,
		114,
		104,
		117,
		121,
		-1,
		166,
		209,
		203,
		206,
		230,
		244,
		-1,
		171,
		-1,
		-1,
		181,
		155,
		139,
		129,
		123,
		173,
		128,
		123,
		107,
		105,
		96,
		87,
		94,
		85,
		85,
		88,
		103,
		108,
		100,
		114,
		114,
		115,
		-1,
		201,
		189,
		197,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		197,
		-1,
		166,
		-1,
		141,
		145,
		136,
		139,
		121,
		108,
		100,
		92,
		108,
		83,
		93,
		89,
		90,
		99,
		110,
		122,
		121,
		122,
		242,
		198,
		197,
		188,
		223,
		238,
		242,
		-1,
		183,
		222,
		220,
		-1,
		204,
		-1,
		-1,
		-1,
		155,
		149,
		141,
		141,
		120,
		120,
		94,
		98,
		88,
		95,
		105,
		107,
		99,
		103,
		116,
		127,
		130,
		238,
		229,
		242,
		187,
		187,
		208,
		217,
		238,
		198,
		189,
		216,
		227,
		216,
		211,
		198,
		-1,
		-1,
		178,
		159,
		-1,
		-1,
		127,
		115,
		98,
		99,
		95,
		98,
		113,
		116,
		106,
		104,
		98,
		130,
		-1,
		231,
		230,
		219,
		216,
		192,
		183,
		178,
		205,
		-1,
		-1,
		200,
		217,
		211,
		215,
		231,
		256,
		-1,
		187,
		-1,
		-1,
		172,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		103,
		114,
		124,
		112,
		113,
		103,
		113,
		126,
		215,
		212,
		200,
		198,
		221,
		186,
		174,
		-1,
		187,
		185,
		191,
		198,
		215,
		245,
		-1,
		-1,
		203,
		183,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		130,
		132,
		121,
		115,
		109,
		116,
		115,
		123,
		131,
		224,
		238,
		227,
		223,
		222,
		230,
		179,
		172,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		189,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		123,
		127,
		119,
		112,
		107,
		118,
		110,
		114,
		131,
		-1,
		258,
		-1,
		210,
		186,
		200,
		215,
		223,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		113,
		124,
		113,
		116,
		130,
		125,
		-1,
		-1,
		198,
		201,
		-1,
		-1,
		200,
		202,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		117,
		123,
		126,
		115,
		119,
		131,
		-1,
		-1,
		205,
		206,
		207,
		-1,
		185,
		-1,
		203,
		-1,
		170,
		176,
		164,
		-1,
		-1,
		-1,
		158,
		121,
		142,
		152,
		146,
		144,
		135,
		121,
		128,
		126,
		122,
		133,
		-1,
		-1,
		-1,
		203,
		177,
		210,
		201,
		184,
		164,
		156,
		175,
		-1,
		145,
		-1,
		120,
		122,
		148,
		151,
		157,
		151,
		124,
		139,
		129,
		120,
		129,
		209,
		-1,
		179,
		212,
		176,
		170,
		146,
		150,
		166,
		-1,
		142,
		124,
		-1,
		152,
		142,
		173,
		158,
		139,
		126,
		133,
		133,
		126,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		151,
		142,
		-1,
		154,
		136,
		115,
		132,
		132,
		123,
		131,
		163,
		159,
		146,
		146,
		138,
		-1,
		282,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		170,
		143,
		131,
		137,
		133,
		119,
		125,
		127,
		135,
		133,
		130,
		142,
		138,
		158,
		139,
		174,
		-1,
		277,
		-1,
		211,
		-1,
		-1,
		193,
		173,
		165,
		154,
		143,
		141,
		132,
		123,
		145,
		161,
		145,
		143,
		146,
		147,
		-1,
		266,
		265,
		-1,
		212,
		204,
		190,
		-1,
		183,
		-1,
		189,
		150,
		-1,
		152,
		132,
		-1,
		154,
		150,
		-1,
		-1,
		253,
		228,
		-1,
		-1,
		-1,
		213,
		193,
		184,
		168,
		-1,
		143,
		143,
		-1,
		-1,
		-1,
		238,
		237,
		-1,
		206,
		209,
		-1,
		199,
		190,
		198,
		145,
		149,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		221,
		219,
		214,
		211,
		197,
		181,
		159,
		148,
		169,
		-1,
		-1,
		-1,
		219,
		211,
		204,
		-1,
		-1,
		206,
		189,
		170,
		168,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		196,
		-1,
		-1,
		202,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		230,
		-1,
		-1,
		-1,
		192,
		188,
		189,
		-1,
		-1,
		-1,
		-1,
		252,
		253,
		276,
		240,
		-1,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		255,
		253,
		-1,
		-1,
		-1,
		212,
		196,
		-1,
		182,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		217,
		-1,
		217,
		192,
		199,
		-1,
		-1,
		-1,
		-1,
		230,
		222,
		230,
		-1,
		202,
		204,
		-1,
		252,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		207,
		214,
		236,
		239,
		275,
		-1,
		226
	],
	[
		-1,
		138,
		127,
		138,
		146,
		119,
		126,
		-1,
		145,
		149,
		115,
		109,
		148,
		117,
		123,
		134,
		-1,
		-1,
		-1,
		138,
		137,
		105,
		103,
		112,
		117,
		124,
		-1,
		123,
		-1,
		159,
		138,
		149,
		154,
		98,
		95,
		115,
		134,
		116,
		108,
		174,
		128,
		99,
		93,
		111,
		101,
		110,
		102,
		-1,
		99,
		89,
		111,
		90,
		101,
		93,
		-1,
		-1,
		93,
		94,
		100,
		86,
		92,
		88,
		-1,
		98,
		82,
		-1,
		-1,
		83,
		84,
		68,
		71,
		79,
		77,
		90,
		82,
		77,
		-1,
		-1,
		74,
		70,
		77,
		64,
		60,
		77,
		90,
		72,
		86,
		85,
		-1,
		77,
		95,
		97,
		71,
		69,
		53,
		51,
		69,
		71,
		77,
		80,
		-1,
		86,
		87,
		72,
		80,
		85,
		69,
		56,
		56,
		66,
		59,
		78,
		69,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		86,
		69,
		86,
		68,
		58,
		73,
		66,
		59,
		56,
		54,
		51,
		67,
		68,
		78,
		-1,
		-1,
		180,
		150,
		177,
		135,
		116,
		-1,
		82,
		62,
		66,
		62,
		56,
		49,
		63,
		59,
		-1,
		45,
		44,
		75,
		61,
		72,
		141,
		-1,
		-1,
		138,
		130,
		112,
		115,
		92,
		88,
		77,
		76,
		68,
		54,
		50,
		46,
		49,
		49,
		55,
		39,
		49,
		53,
		68,
		79,
		-1,
		-1,
		146,
		-1,
		-1,
		138,
		121,
		-1,
		104,
		111,
		98,
		104,
		90,
		111,
		87,
		78,
		70,
		64,
		52,
		44,
		41,
		54,
		42,
		36,
		61,
		65,
		71,
		89,
		87,
		-1,
		145,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		97,
		100,
		104,
		128,
		127,
		-1,
		99,
		87,
		88,
		73,
		70,
		57,
		45,
		49,
		33,
		40,
		39,
		43,
		45,
		78,
		68,
		90,
		87,
		116,
		121,
		115,
		124,
		-1,
		146,
		142,
		138,
		145,
		94,
		-1,
		-1,
		132,
		-1,
		135,
		136,
		111,
		84,
		87,
		74,
		65,
		52,
		41,
		50,
		31,
		28,
		36,
		49,
		56,
		63,
		62,
		80,
		95,
		108,
		112,
		118,
		-1,
		196,
		-1,
		138,
		122,
		124,
		96,
		117,
		-1,
		152,
		136,
		128,
		113,
		113,
		-1,
		83,
		80,
		70,
		48,
		33,
		43,
		32,
		30,
		35,
		52,
		66,
		57,
		75,
		82,
		90,
		94,
		114,
		126,
		156,
		146,
		-1,
		128,
		133,
		92,
		100,
		119,
		157,
		121,
		-1,
		116,
		-1,
		85,
		98,
		-1,
		54,
		50,
		32,
		29,
		18,
		33,
		42,
		48,
		45,
		63,
		66,
		83,
		87,
		103,
		-1,
		-1,
		141,
		145,
		134,
		85,
		104,
		128,
		165,
		114,
		103,
		102,
		-1,
		93,
		67,
		64,
		50,
		37,
		25,
		26,
		18,
		38,
		28,
		47,
		50,
		72,
		100,
		78,
		90,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		111,
		82,
		106,
		148,
		132,
		125,
		113,
		78,
		78,
		72,
		-1,
		61,
		40,
		30,
		15,
		0,
		19,
		32,
		47,
		51,
		50,
		69,
		81,
		72,
		92,
		-1,
		-1,
		-1,
		141,
		130,
		131,
		77,
		100,
		137,
		111,
		97,
		102,
		77,
		70,
		64,
		76,
		57,
		43,
		28,
		14,
		13,
		28,
		35,
		39,
		48,
		57,
		63,
		87,
		94,
		100,
		-1,
		-1,
		148,
		138,
		122,
		124,
		121,
		91,
		98,
		130,
		102,
		115,
		-1,
		69,
		-1,
		58,
		53,
		37,
		32,
		23,
		25,
		19,
		29,
		41,
		54,
		50,
		57,
		92,
		92,
		84,
		104,
		107,
		-1,
		-1,
		-1,
		141,
		136,
		111,
		88,
		72,
		108,
		-1,
		85,
		86,
		-1,
		63,
		57,
		54,
		39,
		35,
		30,
		30,
		26,
		27,
		30,
		44,
		54,
		42,
		78,
		-1,
		92,
		86,
		94,
		84,
		72,
		-1,
		-1,
		-1,
		134,
		113,
		106,
		126,
		67,
		119,
		-1,
		-1,
		70,
		63,
		-1,
		50,
		32,
		37,
		35,
		31,
		35,
		39,
		28,
		41,
		46,
		47,
		57,
		77,
		81,
		85,
		74,
		70,
		67,
		81,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		87,
		-1,
		79,
		71,
		61,
		55,
		49,
		45,
		43,
		59,
		43,
		46,
		46,
		42,
		50,
		35,
		38,
		50,
		54,
		72,
		80,
		72,
		66,
		65,
		77,
		-1,
		154,
		140,
		111,
		-1,
		-1,
		100,
		-1,
		64,
		78,
		94,
		-1,
		87,
		66,
		81,
		59,
		55,
		48,
		66,
		67,
		45,
		50,
		49,
		59,
		60,
		49,
		62,
		54,
		76,
		76,
		60,
		61,
		70,
		-1,
		160,
		147,
		105,
		101,
		90,
		110,
		61,
		49,
		81,
		-1,
		-1,
		123,
		-1,
		57,
		74,
		62,
		60,
		56,
		47,
		53,
		60,
		63,
		64,
		54,
		43,
		49,
		48,
		70,
		56,
		54,
		73,
		89,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		76,
		63,
		57,
		-1,
		98,
		-1,
		101,
		91,
		75,
		60,
		93,
		-1,
		64,
		48,
		53,
		-1,
		89,
		-1,
		62,
		64,
		56,
		45,
		42,
		53,
		51,
		62,
		79,
		-1,
		110,
		95,
		88,
		78,
		92,
		63,
		-1,
		118,
		-1,
		-1,
		88,
		82,
		82,
		66,
		69,
		80,
		60,
		54,
		53,
		84,
		82,
		70,
		54,
		47,
		44,
		45,
		58,
		78,
		69,
		81,
		-1,
		-1,
		-1,
		115,
		101,
		105,
		65,
		84,
		-1,
		-1,
		150,
		105,
		91,
		-1,
		75,
		97,
		85,
		75,
		65,
		99,
		98,
		73,
		66,
		52,
		54,
		52,
		54,
		59,
		80,
		81,
		94,
		-1,
		-1,
		98,
		103,
		91,
		77,
		96,
		-1,
		-1,
		-1,
		97,
		113,
		105,
		76,
		86,
		-1,
		-1,
		77,
		75,
		85,
		69,
		56,
		76,
		79,
		69,
		53,
		68,
		80,
		88,
		93,
		-1,
		101,
		88,
		-1,
		-1,
		99,
		93,
		-1,
		-1,
		-1,
		-1,
		130,
		96,
		108,
		110,
		114,
		80,
		-1,
		85,
		80,
		60,
		74,
		81,
		71,
		66,
		60,
		63,
		81,
		98,
		-1,
		-1,
		113,
		-1,
		108,
		-1,
		-1,
		-1,
		-1,
		87,
		101,
		103,
		96,
		100,
		-1,
		88,
		76,
		62,
		79,
		84,
		81,
		72,
		64,
		69,
		66,
		79,
		93,
		97,
		136,
		-1,
		119,
		-1,
		-1,
		-1,
		105,
		120,
		142,
		119,
		92,
		87,
		80,
		74,
		70,
		86,
		92,
		103,
		71,
		67,
		68,
		72,
		71,
		88,
		98,
		-1,
		-1,
		119,
		136,
		131,
		113,
		117,
		169,
		-1,
		-1,
		96,
		87,
		78,
		81,
		80,
		83,
		77,
		74,
		79,
		84,
		72,
		81,
		99,
		98,
		-1,
		-1,
		-1,
		139,
		-1,
		154,
		-1,
		-1,
		132,
		167,
		114,
		96,
		92,
		90,
		83,
		92,
		87,
		82,
		92,
		94,
		86,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		168,
		143,
		158,
		178,
		152,
		159,
		129,
		126,
		-1,
		96,
		121,
		93,
		100,
		91,
		98,
		98,
		90,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		174,
		160,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		118,
		101,
		99,
		92,
		87,
		97,
		77,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		146,
		227,
		220,
		203,
		211,
		242,
		-1,
		168,
		160,
		167,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		108,
		105,
		107,
		102,
		93,
		78,
		84,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		160,
		203,
		197,
		200,
		224,
		238,
		-1,
		165,
		-1,
		-1,
		175,
		149,
		133,
		123,
		117,
		167,
		122,
		117,
		101,
		99,
		90,
		81,
		88,
		79,
		79,
		82,
		97,
		102,
		94,
		108,
		108,
		109,
		-1,
		195,
		183,
		191,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		191,
		-1,
		160,
		-1,
		135,
		139,
		130,
		133,
		115,
		102,
		94,
		86,
		102,
		77,
		87,
		83,
		84,
		93,
		104,
		116,
		115,
		116,
		236,
		192,
		191,
		182,
		217,
		232,
		236,
		-1,
		177,
		216,
		214,
		-1,
		198,
		-1,
		-1,
		-1,
		149,
		143,
		135,
		135,
		114,
		114,
		88,
		92,
		82,
		89,
		99,
		101,
		93,
		97,
		110,
		121,
		124,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		192,
		183,
		210,
		221,
		210,
		205,
		192,
		-1,
		-1,
		172,
		153,
		-1,
		-1,
		121,
		109,
		92,
		93,
		89,
		92,
		107,
		110,
		100,
		98,
		92,
		124,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		211,
		205,
		209,
		225,
		250,
		-1,
		181,
		-1,
		-1,
		166,
		-1,
		-1,
		151,
		114,
		103,
		94,
		100,
		97,
		108,
		118,
		106,
		107,
		97,
		107,
		120,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		239,
		-1,
		-1,
		197,
		177,
		-1,
		-1,
		149,
		147,
		136,
		-1,
		126,
		99,
		104,
		124,
		126,
		115,
		109,
		103,
		110,
		109,
		117,
		125,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		187,
		183,
		-1,
		-1,
		144,
		137,
		125,
		113,
		103,
		113,
		117,
		121,
		113,
		106,
		101,
		112,
		104,
		108,
		125,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		204,
		190,
		183,
		171,
		169,
		-1,
		178,
		162,
		143,
		-1,
		113,
		126,
		157,
		125,
		130,
		125,
		107,
		118,
		107,
		110,
		124,
		119,
		-1,
		-1,
		192,
		195,
		-1,
		-1,
		194,
		196,
		-1,
		195,
		184,
		169,
		161,
		-1,
		-1,
		150,
		146,
		-1,
		-1,
		114,
		139,
		128,
		136,
		131,
		111,
		117,
		120,
		109,
		113,
		125,
		-1,
		-1,
		199,
		200,
		201,
		-1,
		179,
		-1,
		197,
		-1,
		164,
		170,
		158,
		-1,
		-1,
		-1,
		152,
		115,
		136,
		146,
		140,
		138,
		129,
		115,
		122,
		120,
		116,
		127,
		-1,
		-1,
		-1,
		197,
		171,
		204,
		195,
		178,
		158,
		150,
		169,
		-1,
		139,
		-1,
		114,
		116,
		142,
		145,
		151,
		145,
		118,
		133,
		123,
		114,
		123,
		203,
		-1,
		173,
		206,
		170,
		164,
		140,
		144,
		160,
		-1,
		136,
		118,
		-1,
		146,
		136,
		167,
		152,
		133,
		120,
		127,
		127,
		120,
		-1,
		-1,
		-1,
		175,
		174,
		166,
		160,
		160,
		145,
		136,
		-1,
		148,
		130,
		109,
		126,
		126,
		117,
		125,
		157,
		153,
		140,
		140,
		132,
		-1,
		276,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		169,
		164,
		137,
		125,
		131,
		127,
		113,
		119,
		121,
		129,
		127,
		124,
		136,
		132,
		152,
		133,
		168,
		-1,
		271,
		-1,
		205,
		-1,
		-1,
		187,
		167,
		159,
		148,
		137,
		135,
		126,
		117,
		139,
		155,
		139,
		137,
		140,
		141,
		-1,
		260,
		259,
		-1,
		206,
		198,
		184,
		-1,
		177,
		-1,
		183,
		144,
		-1,
		146,
		126,
		-1,
		148,
		144,
		-1,
		-1,
		247,
		222,
		-1,
		-1,
		-1,
		207,
		187,
		178,
		162,
		-1,
		137,
		137,
		-1,
		-1,
		-1,
		232,
		231,
		-1,
		200,
		203,
		-1,
		193,
		184,
		192,
		139,
		143,
		-1,
		-1,
		-1,
		241,
		222,
		216,
		215,
		213,
		208,
		205,
		191,
		175,
		153,
		142,
		163,
		-1,
		-1,
		-1,
		213,
		205,
		198,
		-1,
		-1,
		200,
		183,
		164,
		162,
		-1,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		190,
		-1,
		-1,
		196,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		224,
		-1,
		-1,
		-1,
		186,
		182,
		183,
		-1,
		-1,
		-1,
		-1,
		246,
		247,
		270,
		234,
		-1,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		249,
		247,
		-1,
		-1,
		-1,
		206,
		190,
		-1,
		176,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		211,
		-1,
		211,
		186,
		193,
		-1,
		-1,
		-1,
		-1,
		224,
		216,
		224,
		-1,
		196,
		198,
		-1,
		246,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		201,
		208,
		230,
		233,
		269,
		-1,
		220
	],
	[
		-1,
		155,
		144,
		155,
		163,
		136,
		143,
		-1,
		162,
		166,
		132,
		126,
		165,
		134,
		140,
		151,
		-1,
		-1,
		-1,
		155,
		154,
		122,
		120,
		129,
		134,
		141,
		-1,
		140,
		-1,
		176,
		155,
		166,
		171,
		115,
		112,
		132,
		151,
		133,
		125,
		191,
		145,
		116,
		110,
		128,
		118,
		127,
		119,
		-1,
		116,
		106,
		128,
		107,
		118,
		110,
		-1,
		-1,
		110,
		111,
		117,
		103,
		109,
		105,
		-1,
		115,
		99,
		-1,
		-1,
		100,
		101,
		85,
		88,
		96,
		94,
		107,
		99,
		94,
		-1,
		-1,
		91,
		87,
		94,
		81,
		77,
		94,
		107,
		89,
		103,
		102,
		-1,
		92,
		110,
		114,
		88,
		86,
		70,
		68,
		86,
		88,
		94,
		97,
		-1,
		101,
		102,
		89,
		97,
		102,
		86,
		73,
		73,
		83,
		76,
		95,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		84,
		101,
		85,
		75,
		90,
		83,
		76,
		73,
		71,
		68,
		84,
		85,
		95,
		-1,
		-1,
		194,
		163,
		192,
		150,
		131,
		-1,
		97,
		77,
		83,
		79,
		73,
		66,
		80,
		76,
		-1,
		62,
		61,
		92,
		78,
		89,
		154,
		-1,
		-1,
		152,
		144,
		127,
		130,
		107,
		103,
		92,
		91,
		83,
		69,
		65,
		63,
		66,
		66,
		72,
		56,
		66,
		70,
		74,
		96,
		-1,
		-1,
		144,
		-1,
		-1,
		151,
		134,
		-1,
		117,
		124,
		113,
		119,
		105,
		126,
		102,
		93,
		85,
		79,
		67,
		61,
		58,
		71,
		59,
		53,
		78,
		82,
		69,
		90,
		85,
		-1,
		143,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		110,
		113,
		119,
		143,
		142,
		-1,
		114,
		102,
		103,
		88,
		85,
		72,
		60,
		66,
		50,
		57,
		56,
		60,
		61,
		91,
		66,
		88,
		85,
		114,
		119,
		113,
		122,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		147,
		-1,
		150,
		151,
		126,
		99,
		102,
		89,
		80,
		67,
		56,
		67,
		48,
		45,
		53,
		55,
		70,
		61,
		60,
		78,
		93,
		106,
		110,
		116,
		-1,
		209,
		-1,
		151,
		135,
		137,
		109,
		130,
		-1,
		167,
		151,
		143,
		128,
		128,
		-1,
		98,
		95,
		85,
		63,
		48,
		60,
		49,
		47,
		45,
		50,
		64,
		55,
		73,
		80,
		88,
		92,
		112,
		124,
		169,
		159,
		-1,
		141,
		146,
		105,
		113,
		132,
		170,
		134,
		-1,
		129,
		-1,
		100,
		113,
		-1,
		69,
		65,
		47,
		46,
		35,
		50,
		38,
		46,
		43,
		61,
		64,
		81,
		85,
		101,
		-1,
		-1,
		154,
		158,
		147,
		98,
		117,
		141,
		178,
		127,
		116,
		115,
		-1,
		106,
		80,
		77,
		63,
		50,
		40,
		41,
		35,
		40,
		30,
		45,
		48,
		70,
		98,
		76,
		88,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		124,
		95,
		119,
		161,
		145,
		138,
		126,
		91,
		91,
		85,
		-1,
		74,
		53,
		43,
		30,
		18,
		0,
		30,
		49,
		49,
		51,
		67,
		79,
		70,
		90,
		-1,
		-1,
		-1,
		154,
		143,
		144,
		90,
		113,
		150,
		124,
		110,
		115,
		90,
		83,
		77,
		89,
		70,
		56,
		41,
		27,
		26,
		31,
		37,
		35,
		51,
		60,
		61,
		85,
		92,
		98,
		-1,
		-1,
		161,
		151,
		135,
		137,
		134,
		104,
		111,
		143,
		115,
		128,
		-1,
		82,
		-1,
		71,
		66,
		50,
		45,
		36,
		37,
		24,
		34,
		41,
		56,
		56,
		70,
		90,
		90,
		82,
		107,
		110,
		-1,
		-1,
		-1,
		154,
		149,
		124,
		101,
		85,
		121,
		-1,
		98,
		99,
		-1,
		76,
		70,
		67,
		52,
		48,
		41,
		43,
		35,
		38,
		38,
		49,
		61,
		55,
		91,
		-1,
		90,
		84,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		80,
		132,
		-1,
		-1,
		83,
		76,
		-1,
		63,
		45,
		50,
		48,
		44,
		46,
		45,
		34,
		47,
		52,
		60,
		63,
		88,
		92,
		96,
		85,
		81,
		78,
		92,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		100,
		-1,
		92,
		84,
		74,
		68,
		62,
		58,
		56,
		72,
		56,
		58,
		57,
		48,
		56,
		41,
		44,
		60,
		65,
		83,
		91,
		83,
		77,
		76,
		88,
		-1,
		167,
		153,
		124,
		-1,
		-1,
		113,
		-1,
		77,
		91,
		107,
		-1,
		100,
		79,
		94,
		72,
		68,
		61,
		79,
		80,
		58,
		57,
		55,
		65,
		66,
		55,
		73,
		65,
		87,
		87,
		71,
		72,
		81,
		-1,
		173,
		160,
		118,
		114,
		103,
		123,
		74,
		62,
		94,
		-1,
		-1,
		136,
		-1,
		70,
		87,
		75,
		73,
		69,
		60,
		66,
		66,
		69,
		70,
		60,
		49,
		55,
		59,
		81,
		67,
		65,
		84,
		100,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		89,
		76,
		70,
		-1,
		111,
		-1,
		114,
		104,
		88,
		73,
		106,
		-1,
		77,
		61,
		66,
		-1,
		95,
		-1,
		68,
		70,
		68,
		56,
		53,
		64,
		62,
		73,
		90,
		-1,
		123,
		108,
		101,
		91,
		105,
		76,
		-1,
		131,
		-1,
		-1,
		101,
		95,
		95,
		79,
		82,
		93,
		73,
		67,
		66,
		90,
		95,
		76,
		67,
		60,
		57,
		56,
		69,
		89,
		80,
		92,
		-1,
		-1,
		-1,
		128,
		114,
		118,
		78,
		97,
		-1,
		-1,
		163,
		118,
		104,
		-1,
		88,
		110,
		98,
		88,
		78,
		112,
		110,
		86,
		79,
		65,
		67,
		65,
		65,
		70,
		91,
		92,
		105,
		-1,
		-1,
		111,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		110,
		126,
		118,
		89,
		99,
		-1,
		-1,
		90,
		88,
		98,
		82,
		69,
		89,
		92,
		80,
		64,
		79,
		91,
		99,
		104,
		-1,
		114,
		101,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		121,
		121,
		125,
		93,
		-1,
		97,
		93,
		73,
		87,
		94,
		82,
		77,
		71,
		74,
		92,
		109,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		100,
		114,
		114,
		107,
		111,
		-1,
		99,
		89,
		75,
		92,
		95,
		92,
		83,
		75,
		80,
		77,
		90,
		104,
		108,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		118,
		133,
		153,
		130,
		103,
		98,
		91,
		85,
		83,
		99,
		103,
		114,
		82,
		78,
		79,
		83,
		82,
		99,
		109,
		-1,
		-1,
		132,
		149,
		144,
		126,
		130,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		93,
		96,
		88,
		85,
		90,
		95,
		83,
		92,
		110,
		111,
		-1,
		-1,
		-1,
		152,
		-1,
		167,
		-1,
		-1,
		145,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		107,
		99,
		85,
		91,
		114,
		103,
		142,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		189,
		165,
		172,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		103,
		111,
		111,
		103,
		81,
		88,
		104,
		103,
		98,
		134,
		125,
		131,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		187,
		173,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		113,
		112,
		105,
		100,
		110,
		90,
		77,
		81,
		85,
		91,
		96,
		101,
		107,
		122,
		137,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		179,
		171,
		180,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		120,
		117,
		120,
		115,
		106,
		91,
		97,
		84,
		83,
		101,
		105,
		114,
		121,
		111,
		124,
		128,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		128,
		178,
		134,
		129,
		114,
		112,
		103,
		94,
		101,
		92,
		92,
		95,
		110,
		115,
		107,
		121,
		121,
		122,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		146,
		150,
		142,
		145,
		128,
		115,
		107,
		99,
		115,
		90,
		100,
		96,
		97,
		106,
		117,
		129,
		128,
		129,
		248,
		204,
		204,
		195,
		229,
		244,
		248,
		-1,
		188,
		227,
		227,
		-1,
		211,
		-1,
		-1,
		-1,
		160,
		155,
		147,
		148,
		127,
		127,
		101,
		105,
		95,
		102,
		112,
		114,
		106,
		110,
		123,
		134,
		137,
		244,
		235,
		248,
		193,
		193,
		214,
		223,
		244,
		203,
		194,
		221,
		234,
		223,
		218,
		205,
		-1,
		-1,
		183,
		165,
		-1,
		-1,
		134,
		122,
		105,
		106,
		102,
		105,
		120,
		123,
		113,
		111,
		105,
		137,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		211,
		-1,
		-1,
		206,
		222,
		217,
		221,
		237,
		262,
		-1,
		194,
		-1,
		-1,
		179,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		110,
		121,
		131,
		119,
		120,
		110,
		120,
		133,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		210,
		190,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		112,
		117,
		137,
		139,
		128,
		122,
		116,
		123,
		122,
		130,
		138,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		200,
		196,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		130,
		134,
		126,
		119,
		114,
		125,
		117,
		121,
		138,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		217,
		203,
		196,
		184,
		182,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		120,
		131,
		120,
		123,
		137,
		132,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		207,
		209,
		-1,
		208,
		197,
		182,
		174,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		124,
		130,
		133,
		122,
		126,
		138,
		-1,
		-1,
		211,
		212,
		214,
		-1,
		192,
		-1,
		210,
		-1,
		177,
		183,
		171,
		-1,
		-1,
		-1,
		165,
		128,
		149,
		159,
		153,
		151,
		142,
		128,
		135,
		133,
		129,
		140,
		-1,
		-1,
		-1,
		210,
		184,
		217,
		208,
		191,
		171,
		163,
		182,
		-1,
		152,
		-1,
		127,
		129,
		155,
		158,
		164,
		158,
		131,
		146,
		136,
		127,
		136,
		216,
		-1,
		186,
		219,
		183,
		177,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		180,
		165,
		146,
		133,
		140,
		140,
		133,
		-1,
		-1,
		-1,
		188,
		187,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		170,
		166,
		153,
		153,
		145,
		-1,
		289,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		146,
		181,
		-1,
		284,
		-1,
		218,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		153,
		154,
		-1,
		273,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		144,
		133,
		144,
		152,
		125,
		132,
		-1,
		151,
		155,
		121,
		115,
		154,
		123,
		129,
		140,
		-1,
		-1,
		-1,
		144,
		143,
		111,
		109,
		118,
		123,
		130,
		-1,
		129,
		-1,
		165,
		144,
		155,
		160,
		104,
		101,
		121,
		140,
		122,
		114,
		180,
		134,
		105,
		99,
		117,
		107,
		116,
		108,
		-1,
		105,
		95,
		117,
		96,
		107,
		99,
		-1,
		-1,
		99,
		100,
		106,
		92,
		98,
		94,
		-1,
		104,
		88,
		-1,
		-1,
		89,
		90,
		74,
		77,
		85,
		83,
		96,
		88,
		83,
		-1,
		-1,
		80,
		76,
		83,
		70,
		66,
		83,
		96,
		78,
		92,
		91,
		-1,
		88,
		106,
		109,
		77,
		75,
		59,
		57,
		75,
		77,
		83,
		83,
		-1,
		97,
		98,
		86,
		94,
		99,
		75,
		62,
		62,
		72,
		65,
		84,
		72,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		97,
		80,
		97,
		82,
		72,
		87,
		80,
		65,
		62,
		60,
		57,
		73,
		71,
		81,
		-1,
		-1,
		189,
		158,
		188,
		146,
		127,
		-1,
		93,
		73,
		79,
		76,
		70,
		63,
		77,
		73,
		-1,
		51,
		50,
		78,
		64,
		75,
		149,
		-1,
		-1,
		147,
		139,
		123,
		126,
		103,
		99,
		88,
		87,
		79,
		65,
		61,
		60,
		63,
		63,
		69,
		45,
		55,
		59,
		57,
		82,
		-1,
		-1,
		127,
		-1,
		-1,
		146,
		129,
		-1,
		112,
		119,
		109,
		115,
		101,
		122,
		98,
		89,
		81,
		75,
		63,
		58,
		55,
		68,
		56,
		42,
		67,
		71,
		52,
		73,
		68,
		-1,
		126,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		105,
		108,
		114,
		138,
		138,
		-1,
		110,
		98,
		99,
		84,
		81,
		68,
		56,
		63,
		47,
		54,
		53,
		46,
		44,
		74,
		49,
		71,
		68,
		97,
		102,
		96,
		105,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		142,
		-1,
		146,
		147,
		122,
		95,
		98,
		85,
		76,
		63,
		52,
		63,
		45,
		42,
		48,
		38,
		53,
		44,
		43,
		61,
		76,
		89,
		93,
		99,
		-1,
		204,
		-1,
		146,
		130,
		132,
		104,
		125,
		-1,
		162,
		147,
		139,
		124,
		123,
		-1,
		94,
		91,
		81,
		59,
		44,
		57,
		46,
		47,
		39,
		33,
		47,
		38,
		56,
		63,
		71,
		75,
		95,
		107,
		164,
		154,
		-1,
		136,
		141,
		100,
		108,
		127,
		165,
		129,
		-1,
		124,
		-1,
		96,
		109,
		-1,
		65,
		61,
		43,
		44,
		39,
		47,
		32,
		29,
		26,
		44,
		47,
		64,
		68,
		84,
		-1,
		-1,
		149,
		153,
		142,
		93,
		112,
		136,
		173,
		122,
		111,
		110,
		-1,
		101,
		79,
		76,
		64,
		51,
		36,
		37,
		44,
		30,
		9,
		28,
		31,
		53,
		81,
		59,
		71,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		119,
		90,
		114,
		156,
		140,
		133,
		121,
		86,
		86,
		80,
		-1,
		75,
		54,
		45,
		34,
		32,
		34,
		0,
		28,
		32,
		34,
		50,
		62,
		53,
		73,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		85,
		108,
		145,
		119,
		105,
		110,
		85,
		78,
		72,
		88,
		71,
		52,
		41,
		32,
		22,
		4,
		14,
		16,
		34,
		43,
		44,
		68,
		75,
		81,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		99,
		106,
		138,
		110,
		123,
		-1,
		77,
		-1,
		66,
		62,
		46,
		41,
		38,
		26,
		13,
		25,
		19,
		35,
		39,
		54,
		73,
		73,
		65,
		90,
		93,
		-1,
		-1,
		-1,
		149,
		144,
		119,
		96,
		80,
		116,
		-1,
		93,
		94,
		-1,
		71,
		65,
		62,
		48,
		44,
		30,
		34,
		28,
		27,
		27,
		36,
		50,
		40,
		76,
		-1,
		73,
		67,
		94,
		84,
		72,
		-1,
		-1,
		-1,
		142,
		121,
		114,
		134,
		75,
		127,
		-1,
		-1,
		78,
		71,
		-1,
		58,
		40,
		42,
		37,
		36,
		35,
		34,
		23,
		36,
		41,
		45,
		52,
		75,
		79,
		85,
		74,
		70,
		67,
		81,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		95,
		-1,
		87,
		79,
		69,
		63,
		57,
		53,
		51,
		64,
		48,
		47,
		46,
		37,
		45,
		30,
		33,
		48,
		52,
		70,
		80,
		72,
		66,
		65,
		77,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		108,
		-1,
		72,
		86,
		102,
		-1,
		95,
		74,
		89,
		67,
		63,
		54,
		71,
		72,
		50,
		46,
		44,
		54,
		55,
		44,
		60,
		54,
		76,
		76,
		60,
		61,
		70,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		69,
		57,
		89,
		-1,
		-1,
		131,
		-1,
		65,
		82,
		68,
		66,
		61,
		52,
		58,
		55,
		58,
		59,
		49,
		38,
		44,
		48,
		70,
		56,
		54,
		73,
		89,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		109,
		99,
		83,
		68,
		101,
		-1,
		69,
		53,
		58,
		-1,
		84,
		-1,
		57,
		59,
		57,
		45,
		42,
		53,
		51,
		62,
		79,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		126,
		-1,
		-1,
		96,
		90,
		90,
		74,
		77,
		85,
		65,
		59,
		58,
		79,
		86,
		65,
		58,
		51,
		48,
		45,
		58,
		78,
		69,
		81,
		-1,
		-1,
		-1,
		123,
		109,
		113,
		73,
		92,
		-1,
		-1,
		158,
		113,
		99,
		-1,
		83,
		102,
		90,
		80,
		70,
		104,
		99,
		77,
		70,
		56,
		58,
		56,
		54,
		59,
		80,
		81,
		94,
		-1,
		-1,
		106,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		105,
		121,
		113,
		84,
		91,
		-1,
		-1,
		82,
		80,
		90,
		73,
		60,
		80,
		83,
		69,
		53,
		68,
		80,
		88,
		93,
		-1,
		109,
		96,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		115,
		110,
		114,
		85,
		-1,
		86,
		84,
		64,
		78,
		85,
		71,
		66,
		60,
		63,
		81,
		98,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		95,
		109,
		103,
		96,
		100,
		-1,
		88,
		80,
		66,
		83,
		84,
		81,
		72,
		64,
		69,
		66,
		79,
		93,
		97,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		113,
		128,
		142,
		119,
		92,
		87,
		80,
		74,
		74,
		90,
		92,
		103,
		71,
		67,
		68,
		72,
		71,
		88,
		98,
		-1,
		-1,
		127,
		144,
		139,
		121,
		125,
		169,
		-1,
		-1,
		96,
		87,
		78,
		81,
		84,
		87,
		77,
		74,
		79,
		84,
		72,
		81,
		99,
		103,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		140,
		167,
		114,
		96,
		92,
		90,
		83,
		92,
		87,
		82,
		92,
		102,
		94,
		74,
		87,
		109,
		99,
		135,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		178,
		160,
		167,
		129,
		126,
		-1,
		96,
		121,
		93,
		100,
		92,
		100,
		100,
		98,
		77,
		84,
		100,
		99,
		94,
		127,
		121,
		127,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		178,
		168,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		118,
		102,
		106,
		99,
		94,
		106,
		86,
		73,
		77,
		81,
		87,
		92,
		97,
		103,
		118,
		133,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		109,
		106,
		116,
		111,
		102,
		87,
		93,
		80,
		79,
		97,
		101,
		110,
		117,
		107,
		120,
		124,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		117,
		167,
		123,
		118,
		110,
		108,
		99,
		90,
		97,
		88,
		88,
		91,
		106,
		111,
		103,
		117,
		117,
		118,
		-1,
		203,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		135,
		139,
		131,
		134,
		124,
		111,
		103,
		95,
		111,
		86,
		96,
		92,
		93,
		102,
		113,
		125,
		124,
		125,
		237,
		193,
		196,
		190,
		218,
		233,
		237,
		-1,
		177,
		216,
		223,
		-1,
		202,
		-1,
		-1,
		-1,
		149,
		144,
		136,
		144,
		123,
		123,
		97,
		101,
		91,
		98,
		108,
		110,
		102,
		106,
		119,
		130,
		133,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		192,
		183,
		210,
		230,
		219,
		214,
		201,
		-1,
		-1,
		172,
		154,
		-1,
		-1,
		130,
		118,
		101,
		102,
		98,
		101,
		116,
		119,
		109,
		107,
		101,
		133,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		211,
		206,
		210,
		226,
		251,
		-1,
		190,
		-1,
		-1,
		175,
		-1,
		-1,
		160,
		123,
		112,
		103,
		109,
		106,
		117,
		127,
		115,
		116,
		106,
		116,
		129,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		206,
		186,
		-1,
		-1,
		158,
		156,
		145,
		-1,
		135,
		108,
		113,
		133,
		135,
		124,
		118,
		112,
		119,
		118,
		126,
		134,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		196,
		192,
		-1,
		-1,
		153,
		146,
		134,
		122,
		112,
		122,
		126,
		130,
		122,
		115,
		110,
		121,
		113,
		117,
		134,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		213,
		199,
		192,
		180,
		178,
		-1,
		187,
		171,
		152,
		-1,
		122,
		135,
		166,
		134,
		139,
		134,
		116,
		127,
		116,
		119,
		133,
		128,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		203,
		205,
		-1,
		204,
		193,
		178,
		170,
		-1,
		-1,
		159,
		155,
		-1,
		-1,
		123,
		148,
		137,
		145,
		140,
		120,
		126,
		129,
		118,
		122,
		134,
		-1,
		-1,
		200,
		201,
		206,
		-1,
		188,
		-1,
		206,
		-1,
		173,
		179,
		167,
		-1,
		-1,
		-1,
		161,
		124,
		145,
		155,
		149,
		147,
		138,
		124,
		131,
		129,
		125,
		136,
		-1,
		-1,
		-1,
		206,
		180,
		213,
		204,
		187,
		167,
		159,
		178,
		-1,
		148,
		-1,
		123,
		125,
		151,
		154,
		160,
		154,
		127,
		142,
		132,
		123,
		132,
		212,
		-1,
		182,
		215,
		179,
		173,
		149,
		153,
		169,
		-1,
		145,
		127,
		-1,
		155,
		145,
		176,
		161,
		142,
		129,
		136,
		136,
		129,
		-1,
		-1,
		-1,
		184,
		183,
		175,
		169,
		169,
		154,
		145,
		-1,
		157,
		139,
		118,
		135,
		135,
		126,
		134,
		166,
		162,
		149,
		149,
		141,
		-1,
		285,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		178,
		173,
		146,
		134,
		140,
		136,
		122,
		128,
		130,
		138,
		136,
		133,
		145,
		141,
		161,
		142,
		177,
		-1,
		280,
		-1,
		214,
		-1,
		-1,
		196,
		176,
		168,
		157,
		146,
		144,
		135,
		126,
		148,
		164,
		148,
		146,
		149,
		150,
		-1,
		269,
		268,
		-1,
		215,
		207,
		193,
		-1,
		186,
		-1,
		192,
		153,
		-1,
		155,
		135,
		-1,
		157,
		153,
		-1,
		-1,
		256,
		231,
		-1,
		-1,
		-1,
		216,
		196,
		187,
		171,
		-1,
		146,
		146,
		-1,
		-1,
		-1,
		241,
		240,
		-1,
		209,
		212,
		-1,
		202,
		193,
		201,
		148,
		152,
		-1,
		-1,
		-1,
		250,
		231,
		225,
		224,
		222,
		217,
		214,
		200,
		184,
		162,
		151,
		172,
		-1,
		-1,
		-1,
		222,
		214,
		207,
		-1,
		-1,
		209,
		192,
		173,
		171,
		-1,
		-1,
		-1,
		244,
		225,
		-1,
		-1,
		199,
		-1,
		-1,
		205,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		233,
		-1,
		-1,
		-1,
		195,
		191,
		192,
		-1,
		-1,
		-1,
		-1,
		255,
		256,
		279,
		243,
		-1,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		258,
		256,
		-1,
		-1,
		-1,
		215,
		199,
		-1,
		185,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		220,
		-1,
		220,
		195,
		202,
		-1,
		-1,
		-1,
		-1,
		233,
		225,
		233,
		-1,
		205,
		207,
		-1,
		255,
		-1,
		-1,
		248,
		239,
		-1,
		-1,
		210,
		217,
		239,
		242,
		278,
		-1,
		229
	],
	[
		-1,
		145,
		134,
		145,
		153,
		126,
		133,
		-1,
		152,
		156,
		122,
		116,
		155,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		145,
		144,
		112,
		110,
		119,
		124,
		131,
		-1,
		130,
		-1,
		166,
		145,
		156,
		161,
		105,
		102,
		122,
		141,
		123,
		115,
		181,
		135,
		106,
		100,
		118,
		108,
		117,
		109,
		-1,
		106,
		96,
		118,
		97,
		108,
		100,
		-1,
		-1,
		100,
		101,
		107,
		93,
		99,
		95,
		-1,
		105,
		89,
		-1,
		-1,
		90,
		91,
		75,
		78,
		86,
		84,
		97,
		89,
		84,
		-1,
		-1,
		81,
		77,
		84,
		71,
		67,
		84,
		97,
		79,
		93,
		92,
		-1,
		92,
		110,
		110,
		78,
		76,
		60,
		58,
		76,
		78,
		84,
		84,
		-1,
		101,
		102,
		87,
		95,
		100,
		76,
		63,
		63,
		73,
		66,
		85,
		73,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		84,
		101,
		83,
		73,
		88,
		81,
		66,
		63,
		61,
		58,
		74,
		72,
		82,
		-1,
		-1,
		194,
		163,
		192,
		150,
		131,
		-1,
		97,
		77,
		81,
		77,
		71,
		64,
		78,
		74,
		-1,
		52,
		51,
		79,
		65,
		76,
		154,
		-1,
		-1,
		152,
		144,
		127,
		130,
		107,
		103,
		92,
		91,
		83,
		69,
		65,
		61,
		64,
		64,
		70,
		46,
		56,
		60,
		58,
		83,
		-1,
		-1,
		128,
		-1,
		-1,
		151,
		134,
		-1,
		117,
		124,
		113,
		119,
		105,
		126,
		102,
		93,
		85,
		79,
		67,
		59,
		56,
		69,
		57,
		43,
		68,
		72,
		53,
		74,
		69,
		-1,
		127,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		110,
		113,
		119,
		143,
		142,
		-1,
		114,
		102,
		103,
		88,
		85,
		72,
		60,
		64,
		48,
		55,
		54,
		47,
		45,
		75,
		50,
		72,
		69,
		98,
		103,
		97,
		106,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		147,
		-1,
		150,
		151,
		126,
		99,
		102,
		89,
		80,
		67,
		56,
		65,
		46,
		43,
		49,
		39,
		54,
		45,
		44,
		62,
		77,
		90,
		94,
		100,
		-1,
		209,
		-1,
		151,
		135,
		137,
		109,
		130,
		-1,
		167,
		151,
		143,
		128,
		128,
		-1,
		98,
		95,
		85,
		63,
		48,
		58,
		47,
		48,
		40,
		34,
		48,
		39,
		57,
		64,
		72,
		76,
		96,
		108,
		169,
		159,
		-1,
		141,
		146,
		105,
		113,
		132,
		170,
		134,
		-1,
		129,
		-1,
		100,
		113,
		-1,
		69,
		65,
		47,
		48,
		41,
		48,
		33,
		30,
		27,
		45,
		48,
		65,
		69,
		85,
		-1,
		-1,
		154,
		158,
		147,
		98,
		117,
		141,
		178,
		127,
		116,
		115,
		-1,
		106,
		83,
		80,
		68,
		55,
		40,
		41,
		47,
		31,
		10,
		29,
		32,
		54,
		82,
		60,
		72,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		124,
		95,
		119,
		161,
		145,
		138,
		126,
		91,
		91,
		85,
		-1,
		79,
		58,
		49,
		38,
		36,
		43,
		14,
		0,
		33,
		35,
		51,
		63,
		54,
		74,
		-1,
		-1,
		-1,
		154,
		143,
		144,
		90,
		113,
		150,
		124,
		110,
		115,
		90,
		83,
		77,
		92,
		75,
		56,
		45,
		37,
		26,
		17,
		19,
		8,
		35,
		42,
		45,
		69,
		76,
		82,
		-1,
		-1,
		161,
		151,
		135,
		137,
		134,
		104,
		111,
		143,
		115,
		128,
		-1,
		82,
		-1,
		71,
		66,
		50,
		45,
		42,
		35,
		22,
		24,
		20,
		31,
		40,
		52,
		74,
		74,
		66,
		91,
		94,
		-1,
		-1,
		-1,
		154,
		149,
		124,
		101,
		85,
		121,
		-1,
		98,
		99,
		-1,
		76,
		70,
		67,
		52,
		48,
		39,
		43,
		37,
		36,
		36,
		35,
		47,
		41,
		77,
		-1,
		74,
		68,
		96,
		93,
		81,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		80,
		132,
		-1,
		-1,
		83,
		76,
		-1,
		63,
		45,
		51,
		46,
		44,
		44,
		43,
		32,
		45,
		45,
		46,
		55,
		76,
		80,
		87,
		80,
		79,
		76,
		90,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		100,
		-1,
		92,
		84,
		74,
		68,
		62,
		58,
		56,
		72,
		56,
		56,
		55,
		46,
		54,
		39,
		42,
		49,
		53,
		71,
		89,
		81,
		75,
		74,
		86,
		-1,
		167,
		153,
		124,
		-1,
		-1,
		113,
		-1,
		77,
		91,
		107,
		-1,
		100,
		79,
		94,
		72,
		68,
		63,
		79,
		80,
		58,
		55,
		53,
		63,
		64,
		53,
		61,
		63,
		80,
		85,
		69,
		70,
		79,
		-1,
		173,
		160,
		118,
		114,
		103,
		123,
		74,
		62,
		94,
		-1,
		-1,
		136,
		-1,
		70,
		87,
		77,
		75,
		69,
		60,
		66,
		64,
		67,
		68,
		58,
		47,
		53,
		57,
		79,
		65,
		63,
		82,
		98,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		89,
		76,
		70,
		-1,
		111,
		-1,
		114,
		104,
		88,
		73,
		106,
		-1,
		77,
		61,
		66,
		-1,
		93,
		-1,
		66,
		68,
		66,
		54,
		51,
		62,
		60,
		71,
		88,
		-1,
		123,
		108,
		101,
		91,
		105,
		76,
		-1,
		131,
		-1,
		-1,
		101,
		95,
		95,
		79,
		82,
		93,
		73,
		67,
		66,
		88,
		95,
		74,
		67,
		60,
		57,
		54,
		67,
		87,
		78,
		90,
		-1,
		-1,
		-1,
		128,
		114,
		118,
		78,
		97,
		-1,
		-1,
		163,
		118,
		104,
		-1,
		88,
		110,
		98,
		88,
		78,
		112,
		108,
		86,
		79,
		65,
		67,
		65,
		63,
		68,
		89,
		90,
		103,
		-1,
		-1,
		111,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		110,
		126,
		118,
		89,
		99,
		-1,
		-1,
		90,
		88,
		98,
		82,
		69,
		89,
		92,
		78,
		62,
		77,
		89,
		97,
		102,
		-1,
		114,
		101,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		121,
		119,
		123,
		93,
		-1,
		95,
		93,
		73,
		87,
		94,
		80,
		75,
		69,
		72,
		90,
		107,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		100,
		114,
		112,
		105,
		109,
		-1,
		97,
		89,
		75,
		92,
		93,
		90,
		81,
		73,
		78,
		75,
		88,
		102,
		106,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		118,
		133,
		151,
		128,
		101,
		96,
		89,
		83,
		83,
		99,
		101,
		112,
		80,
		76,
		77,
		81,
		80,
		97,
		107,
		-1,
		-1,
		132,
		149,
		144,
		126,
		130,
		178,
		-1,
		-1,
		105,
		96,
		87,
		90,
		93,
		96,
		86,
		83,
		88,
		93,
		81,
		90,
		108,
		111,
		-1,
		-1,
		-1,
		152,
		-1,
		167,
		-1,
		-1,
		145,
		176,
		123,
		105,
		101,
		99,
		92,
		101,
		96,
		91,
		101,
		107,
		99,
		83,
		91,
		114,
		103,
		142,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		187,
		165,
		172,
		138,
		135,
		-1,
		105,
		130,
		102,
		109,
		101,
		109,
		109,
		103,
		81,
		88,
		104,
		103,
		98,
		134,
		125,
		131,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		187,
		173,
		173,
		163,
		166,
		-1,
		-1,
		154,
		151,
		127,
		111,
		112,
		105,
		100,
		110,
		90,
		77,
		81,
		85,
		91,
		96,
		101,
		107,
		122,
		137,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		177,
		169,
		180,
		155,
		157,
		-1,
		-1,
		127,
		124,
		129,
		118,
		115,
		120,
		115,
		106,
		91,
		97,
		84,
		83,
		101,
		105,
		114,
		121,
		111,
		124,
		128,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		174,
		-1,
		-1,
		186,
		158,
		142,
		132,
		126,
		176,
		132,
		127,
		114,
		112,
		103,
		94,
		101,
		92,
		92,
		95,
		110,
		115,
		107,
		121,
		121,
		122,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		202,
		-1,
		169,
		-1,
		144,
		148,
		140,
		143,
		128,
		115,
		107,
		99,
		115,
		90,
		100,
		96,
		97,
		106,
		117,
		129,
		128,
		129,
		246,
		202,
		204,
		195,
		227,
		242,
		246,
		-1,
		186,
		225,
		227,
		-1,
		211,
		-1,
		-1,
		-1,
		158,
		153,
		145,
		148,
		127,
		127,
		101,
		105,
		95,
		102,
		112,
		114,
		106,
		110,
		123,
		134,
		137,
		242,
		233,
		246,
		191,
		191,
		212,
		221,
		242,
		201,
		192,
		219,
		234,
		223,
		218,
		205,
		-1,
		-1,
		181,
		163,
		-1,
		-1,
		134,
		122,
		105,
		106,
		102,
		105,
		120,
		123,
		113,
		111,
		105,
		137,
		-1,
		235,
		234,
		223,
		220,
		196,
		187,
		182,
		209,
		-1,
		-1,
		204,
		220,
		215,
		219,
		235,
		260,
		-1,
		194,
		-1,
		-1,
		179,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		110,
		121,
		131,
		119,
		120,
		110,
		120,
		133,
		219,
		216,
		204,
		202,
		225,
		190,
		178,
		-1,
		191,
		189,
		195,
		202,
		219,
		249,
		-1,
		-1,
		210,
		190,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		112,
		117,
		137,
		139,
		128,
		122,
		116,
		123,
		122,
		130,
		138,
		228,
		242,
		231,
		227,
		226,
		234,
		183,
		176,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		200,
		196,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		130,
		134,
		126,
		119,
		114,
		125,
		117,
		121,
		138,
		-1,
		262,
		-1,
		214,
		190,
		204,
		219,
		227,
		-1,
		-1,
		-1,
		217,
		203,
		196,
		184,
		182,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		120,
		131,
		120,
		123,
		137,
		132,
		-1,
		-1,
		202,
		205,
		-1,
		-1,
		207,
		209,
		-1,
		208,
		197,
		182,
		174,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		124,
		130,
		133,
		122,
		126,
		138,
		-1,
		-1,
		209,
		210,
		214,
		-1,
		192,
		-1,
		210,
		-1,
		177,
		183,
		171,
		-1,
		-1,
		-1,
		165,
		128,
		149,
		159,
		153,
		151,
		142,
		128,
		135,
		133,
		129,
		140,
		-1,
		-1,
		-1,
		210,
		184,
		217,
		208,
		191,
		171,
		163,
		182,
		-1,
		152,
		-1,
		127,
		129,
		155,
		158,
		164,
		158,
		131,
		146,
		136,
		127,
		136,
		216,
		-1,
		186,
		219,
		183,
		177,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		180,
		165,
		146,
		133,
		140,
		140,
		133,
		-1,
		-1,
		-1,
		188,
		187,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		170,
		166,
		153,
		153,
		145,
		-1,
		289,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		146,
		181,
		-1,
		284,
		-1,
		218,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		153,
		154,
		-1,
		273,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		135,
		139,
		105,
		99,
		138,
		107,
		113,
		124,
		-1,
		-1,
		-1,
		128,
		127,
		95,
		93,
		102,
		107,
		114,
		-1,
		113,
		-1,
		149,
		128,
		139,
		144,
		88,
		85,
		105,
		124,
		106,
		98,
		164,
		118,
		89,
		83,
		101,
		91,
		100,
		92,
		-1,
		89,
		79,
		101,
		80,
		91,
		83,
		-1,
		-1,
		83,
		84,
		90,
		76,
		82,
		78,
		-1,
		88,
		72,
		-1,
		-1,
		73,
		74,
		58,
		61,
		69,
		67,
		80,
		72,
		67,
		-1,
		-1,
		64,
		60,
		67,
		54,
		50,
		67,
		80,
		62,
		76,
		75,
		-1,
		76,
		93,
		93,
		61,
		59,
		43,
		41,
		59,
		61,
		67,
		67,
		-1,
		93,
		89,
		90,
		88,
		83,
		59,
		46,
		46,
		56,
		49,
		68,
		56,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		85,
		102,
		86,
		76,
		80,
		78,
		49,
		46,
		44,
		41,
		57,
		55,
		65,
		-1,
		-1,
		187,
		160,
		184,
		142,
		124,
		-1,
		90,
		90,
		84,
		80,
		74,
		67,
		80,
		65,
		-1,
		35,
		34,
		62,
		48,
		59,
		167,
		-1,
		-1,
		145,
		137,
		119,
		122,
		99,
		95,
		105,
		104,
		96,
		82,
		78,
		64,
		67,
		67,
		73,
		29,
		39,
		43,
		41,
		66,
		-1,
		-1,
		98,
		-1,
		-1,
		164,
		147,
		-1,
		114,
		121,
		105,
		111,
		97,
		118,
		115,
		106,
		98,
		92,
		80,
		62,
		59,
		72,
		51,
		26,
		51,
		55,
		36,
		57,
		52,
		-1,
		97,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		121,
		118,
		111,
		135,
		134,
		-1,
		127,
		115,
		116,
		101,
		98,
		85,
		73,
		67,
		51,
		51,
		48,
		30,
		28,
		58,
		33,
		55,
		52,
		68,
		73,
		67,
		76,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		139,
		-1,
		142,
		155,
		139,
		112,
		115,
		102,
		93,
		80,
		69,
		68,
		49,
		46,
		42,
		22,
		37,
		28,
		27,
		45,
		52,
		60,
		64,
		70,
		-1,
		222,
		-1,
		164,
		148,
		150,
		122,
		143,
		-1,
		159,
		143,
		156,
		141,
		141,
		-1,
		111,
		108,
		98,
		76,
		61,
		61,
		49,
		44,
		35,
		17,
		29,
		22,
		39,
		46,
		42,
		46,
		66,
		78,
		182,
		172,
		-1,
		154,
		159,
		118,
		126,
		145,
		183,
		147,
		-1,
		142,
		-1,
		113,
		126,
		-1,
		82,
		78,
		60,
		57,
		46,
		53,
		28,
		13,
		10,
		28,
		30,
		35,
		39,
		55,
		-1,
		-1,
		167,
		171,
		160,
		111,
		130,
		154,
		191,
		140,
		129,
		128,
		-1,
		119,
		96,
		93,
		81,
		68,
		53,
		54,
		52,
		48,
		27,
		5,
		2,
		26,
		52,
		30,
		42,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		137,
		108,
		132,
		174,
		158,
		151,
		139,
		104,
		104,
		98,
		-1,
		92,
		71,
		62,
		51,
		49,
		60,
		33,
		29,
		0,
		2,
		21,
		33,
		24,
		44,
		-1,
		-1,
		-1,
		167,
		156,
		157,
		103,
		126,
		163,
		137,
		123,
		128,
		103,
		96,
		90,
		105,
		88,
		69,
		58,
		50,
		39,
		34,
		41,
		33,
		5,
		14,
		15,
		39,
		46,
		52,
		-1,
		-1,
		174,
		164,
		148,
		150,
		147,
		117,
		124,
		156,
		128,
		141,
		-1,
		95,
		-1,
		84,
		79,
		63,
		58,
		55,
		52,
		39,
		36,
		34,
		19,
		10,
		25,
		44,
		44,
		36,
		61,
		64,
		-1,
		-1,
		-1,
		167,
		162,
		137,
		114,
		98,
		134,
		-1,
		111,
		112,
		-1,
		89,
		83,
		80,
		65,
		61,
		56,
		60,
		53,
		46,
		36,
		28,
		29,
		11,
		47,
		-1,
		44,
		38,
		66,
		69,
		59,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		93,
		145,
		-1,
		-1,
		96,
		89,
		-1,
		76,
		58,
		65,
		63,
		57,
		61,
		49,
		38,
		44,
		36,
		16,
		26,
		46,
		50,
		57,
		50,
		55,
		54,
		68,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		113,
		-1,
		105,
		97,
		87,
		81,
		75,
		71,
		69,
		85,
		69,
		72,
		61,
		52,
		60,
		40,
		33,
		19,
		23,
		41,
		68,
		63,
		58,
		57,
		64,
		-1,
		180,
		166,
		137,
		-1,
		-1,
		126,
		-1,
		90,
		104,
		120,
		-1,
		113,
		92,
		107,
		85,
		81,
		77,
		92,
		93,
		71,
		61,
		59,
		67,
		55,
		44,
		31,
		35,
		50,
		60,
		52,
		53,
		62,
		-1,
		186,
		173,
		131,
		127,
		116,
		136,
		87,
		75,
		107,
		-1,
		-1,
		149,
		-1,
		83,
		100,
		91,
		89,
		82,
		73,
		79,
		70,
		64,
		59,
		49,
		38,
		44,
		40,
		62,
		48,
		46,
		65,
		80,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		102,
		89,
		83,
		-1,
		124,
		-1,
		127,
		117,
		101,
		86,
		119,
		-1,
		90,
		74,
		79,
		-1,
		84,
		-1,
		57,
		57,
		48,
		37,
		34,
		45,
		43,
		54,
		71,
		-1,
		136,
		121,
		114,
		104,
		118,
		89,
		-1,
		144,
		-1,
		-1,
		114,
		108,
		108,
		92,
		95,
		106,
		86,
		80,
		79,
		79,
		74,
		65,
		46,
		39,
		36,
		37,
		50,
		70,
		61,
		73,
		-1,
		-1,
		-1,
		141,
		127,
		131,
		91,
		110,
		-1,
		-1,
		176,
		131,
		117,
		-1,
		101,
		123,
		111,
		101,
		91,
		100,
		90,
		65,
		58,
		44,
		46,
		44,
		46,
		51,
		72,
		73,
		86,
		-1,
		-1,
		124,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		123,
		139,
		131,
		102,
		112,
		-1,
		-1,
		101,
		92,
		82,
		61,
		48,
		68,
		71,
		61,
		45,
		60,
		72,
		80,
		85,
		-1,
		127,
		114,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		156,
		118,
		107,
		102,
		106,
		100,
		-1,
		78,
		72,
		52,
		66,
		73,
		63,
		58,
		52,
		55,
		73,
		90,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		113,
		124,
		95,
		88,
		92,
		-1,
		80,
		68,
		54,
		71,
		76,
		73,
		64,
		56,
		61,
		58,
		71,
		85,
		89,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		131,
		146,
		134,
		111,
		84,
		79,
		72,
		66,
		62,
		78,
		84,
		95,
		63,
		59,
		60,
		64,
		63,
		80,
		90,
		-1,
		-1,
		145,
		162,
		157,
		139,
		143,
		161,
		-1,
		-1,
		88,
		79,
		70,
		73,
		72,
		75,
		69,
		66,
		71,
		76,
		64,
		73,
		91,
		90,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		158,
		159,
		106,
		88,
		84,
		82,
		75,
		84,
		79,
		74,
		84,
		86,
		78,
		66,
		70,
		93,
		82,
		121,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		177,
		169,
		164,
		170,
		172,
		163,
		121,
		118,
		-1,
		88,
		113,
		85,
		92,
		83,
		90,
		90,
		82,
		60,
		67,
		83,
		82,
		77,
		113,
		104,
		110,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		170,
		166,
		156,
		146,
		149,
		-1,
		-1,
		137,
		134,
		110,
		93,
		91,
		84,
		79,
		89,
		69,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		116,
		-1,
		172,
		253,
		246,
		219,
		227,
		258,
		-1,
		160,
		152,
		163,
		138,
		140,
		-1,
		-1,
		110,
		107,
		112,
		100,
		97,
		99,
		94,
		85,
		70,
		76,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		186,
		229,
		213,
		216,
		240,
		254,
		-1,
		157,
		-1,
		-1,
		169,
		141,
		125,
		115,
		109,
		159,
		114,
		109,
		93,
		91,
		82,
		73,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		203,
		209,
		207,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		185,
		-1,
		152,
		-1,
		127,
		131,
		122,
		125,
		107,
		94,
		86,
		78,
		94,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		169,
		208,
		206,
		-1,
		190,
		-1,
		-1,
		-1,
		141,
		135,
		127,
		127,
		106,
		106,
		80,
		84,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		184,
		175,
		202,
		213,
		202,
		197,
		184,
		-1,
		-1,
		164,
		145,
		-1,
		-1,
		113,
		101,
		84,
		85,
		81,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		203,
		197,
		201,
		217,
		242,
		-1,
		173,
		-1,
		-1,
		158,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		89,
		100,
		110,
		98,
		99,
		89,
		99,
		112,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		231,
		-1,
		-1,
		189,
		169,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		116,
		118,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		179,
		175,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		109,
		113,
		105,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		196,
		182,
		175,
		163,
		161,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		184,
		187,
		-1,
		-1,
		186,
		188,
		-1,
		187,
		176,
		161,
		153,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		191,
		192,
		193,
		-1,
		171,
		-1,
		189,
		-1,
		156,
		162,
		150,
		-1,
		-1,
		-1,
		144,
		107,
		128,
		138,
		132,
		130,
		121,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		189,
		163,
		196,
		187,
		170,
		150,
		142,
		161,
		-1,
		131,
		-1,
		106,
		108,
		134,
		137,
		143,
		137,
		110,
		125,
		115,
		106,
		115,
		195,
		-1,
		165,
		198,
		162,
		156,
		132,
		136,
		152,
		-1,
		128,
		110,
		-1,
		138,
		128,
		159,
		144,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		167,
		166,
		158,
		152,
		152,
		137,
		128,
		-1,
		140,
		122,
		101,
		118,
		118,
		109,
		117,
		149,
		145,
		132,
		132,
		124,
		-1,
		268,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		161,
		156,
		129,
		117,
		123,
		119,
		105,
		111,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		125,
		160,
		-1,
		263,
		-1,
		197,
		-1,
		-1,
		179,
		159,
		151,
		140,
		129,
		127,
		118,
		109,
		131,
		147,
		131,
		129,
		132,
		133,
		-1,
		252,
		251,
		-1,
		198,
		190,
		176,
		-1,
		169,
		-1,
		175,
		136,
		-1,
		138,
		118,
		-1,
		140,
		136,
		-1,
		-1,
		239,
		214,
		-1,
		-1,
		-1,
		199,
		179,
		170,
		154,
		-1,
		129,
		129,
		-1,
		-1,
		-1,
		224,
		223,
		-1,
		192,
		195,
		-1,
		185,
		176,
		184,
		131,
		135,
		-1,
		-1,
		-1,
		233,
		214,
		208,
		207,
		205,
		200,
		197,
		183,
		167,
		145,
		134,
		155,
		-1,
		-1,
		-1,
		205,
		197,
		190,
		-1,
		-1,
		192,
		175,
		156,
		154,
		-1,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		182,
		-1,
		-1,
		188,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		216,
		-1,
		-1,
		-1,
		178,
		174,
		175,
		-1,
		-1,
		-1,
		-1,
		238,
		239,
		262,
		226,
		-1,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		241,
		239,
		-1,
		-1,
		-1,
		198,
		182,
		-1,
		168,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		203,
		-1,
		203,
		178,
		185,
		-1,
		-1,
		-1,
		-1,
		216,
		208,
		216,
		-1,
		188,
		190,
		-1,
		238,
		-1,
		-1,
		231,
		222,
		-1,
		-1,
		193,
		200,
		222,
		225,
		261,
		-1,
		212
	],
	[
		-1,
		130,
		119,
		130,
		138,
		111,
		118,
		-1,
		137,
		141,
		107,
		101,
		140,
		109,
		115,
		126,
		-1,
		-1,
		-1,
		130,
		129,
		97,
		95,
		104,
		109,
		116,
		-1,
		115,
		-1,
		151,
		130,
		141,
		146,
		90,
		87,
		107,
		126,
		108,
		100,
		166,
		120,
		91,
		85,
		103,
		93,
		102,
		94,
		-1,
		91,
		81,
		103,
		82,
		93,
		85,
		-1,
		-1,
		85,
		86,
		92,
		78,
		84,
		80,
		-1,
		90,
		74,
		-1,
		-1,
		75,
		76,
		60,
		63,
		71,
		69,
		82,
		74,
		69,
		-1,
		-1,
		66,
		62,
		69,
		56,
		52,
		69,
		82,
		64,
		78,
		77,
		-1,
		78,
		95,
		95,
		63,
		61,
		45,
		43,
		61,
		63,
		69,
		69,
		-1,
		95,
		91,
		92,
		90,
		85,
		61,
		48,
		48,
		58,
		51,
		70,
		58,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		96,
		87,
		104,
		88,
		78,
		82,
		80,
		51,
		48,
		46,
		43,
		59,
		57,
		67,
		-1,
		-1,
		189,
		162,
		186,
		144,
		126,
		-1,
		92,
		88,
		86,
		82,
		76,
		69,
		82,
		67,
		-1,
		37,
		36,
		64,
		50,
		61,
		165,
		-1,
		-1,
		147,
		139,
		121,
		124,
		101,
		97,
		103,
		102,
		94,
		80,
		76,
		66,
		69,
		69,
		75,
		31,
		41,
		45,
		43,
		68,
		-1,
		-1,
		96,
		-1,
		-1,
		162,
		145,
		-1,
		116,
		123,
		107,
		113,
		99,
		120,
		113,
		104,
		96,
		90,
		78,
		64,
		61,
		74,
		53,
		28,
		53,
		57,
		38,
		59,
		54,
		-1,
		95,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		121,
		120,
		113,
		137,
		136,
		-1,
		125,
		113,
		114,
		99,
		96,
		83,
		71,
		69,
		53,
		53,
		50,
		32,
		30,
		60,
		35,
		57,
		54,
		66,
		71,
		65,
		74,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		141,
		-1,
		144,
		157,
		137,
		110,
		113,
		100,
		91,
		78,
		67,
		70,
		51,
		48,
		44,
		24,
		39,
		30,
		29,
		47,
		50,
		58,
		62,
		68,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		161,
		145,
		154,
		139,
		139,
		-1,
		109,
		106,
		96,
		74,
		59,
		63,
		51,
		46,
		37,
		19,
		31,
		24,
		37,
		44,
		40,
		44,
		64,
		76,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		181,
		145,
		-1,
		140,
		-1,
		111,
		124,
		-1,
		80,
		76,
		58,
		59,
		48,
		55,
		30,
		15,
		12,
		30,
		28,
		33,
		37,
		53,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		117,
		94,
		91,
		79,
		66,
		51,
		52,
		54,
		50,
		29,
		7,
		4,
		24,
		50,
		28,
		40,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		90,
		69,
		60,
		49,
		47,
		59,
		35,
		27,
		2,
		0,
		19,
		31,
		22,
		42,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		88,
		103,
		86,
		67,
		56,
		48,
		37,
		36,
		39,
		31,
		3,
		12,
		13,
		37,
		44,
		50,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		93,
		-1,
		82,
		77,
		61,
		56,
		53,
		50,
		38,
		34,
		32,
		17,
		8,
		23,
		42,
		42,
		34,
		59,
		62,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		87,
		81,
		78,
		63,
		59,
		54,
		58,
		51,
		44,
		34,
		26,
		27,
		9,
		45,
		-1,
		42,
		36,
		64,
		67,
		57,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		74,
		56,
		63,
		61,
		55,
		59,
		47,
		36,
		42,
		34,
		14,
		24,
		44,
		48,
		55,
		48,
		53,
		52,
		66,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		69,
		67,
		83,
		67,
		70,
		59,
		50,
		58,
		38,
		31,
		17,
		21,
		39,
		66,
		61,
		56,
		55,
		62,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		79,
		75,
		90,
		91,
		69,
		59,
		57,
		65,
		53,
		42,
		29,
		33,
		48,
		58,
		50,
		51,
		60,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		89,
		87,
		80,
		71,
		77,
		68,
		62,
		57,
		47,
		36,
		42,
		38,
		60,
		46,
		44,
		63,
		78,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		88,
		72,
		77,
		-1,
		82,
		-1,
		55,
		55,
		46,
		35,
		32,
		43,
		41,
		52,
		69,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		104,
		84,
		78,
		77,
		77,
		72,
		63,
		44,
		37,
		34,
		35,
		48,
		68,
		59,
		71,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		121,
		109,
		99,
		89,
		98,
		88,
		63,
		56,
		42,
		44,
		42,
		44,
		49,
		70,
		71,
		84,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		110,
		-1,
		-1,
		99,
		90,
		80,
		59,
		46,
		66,
		69,
		59,
		43,
		58,
		70,
		78,
		83,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		154,
		116,
		105,
		100,
		104,
		98,
		-1,
		76,
		70,
		50,
		64,
		71,
		61,
		56,
		50,
		53,
		71,
		88,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		111,
		122,
		93,
		86,
		90,
		-1,
		78,
		66,
		52,
		69,
		74,
		71,
		62,
		54,
		59,
		56,
		69,
		83,
		87,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		129,
		144,
		132,
		109,
		82,
		77,
		70,
		64,
		60,
		76,
		82,
		93,
		61,
		57,
		58,
		62,
		61,
		78,
		88,
		-1,
		-1,
		143,
		160,
		155,
		137,
		141,
		159,
		-1,
		-1,
		86,
		77,
		68,
		71,
		70,
		73,
		67,
		64,
		69,
		74,
		62,
		71,
		89,
		88,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		156,
		157,
		104,
		86,
		82,
		80,
		73,
		82,
		77,
		72,
		82,
		84,
		76,
		64,
		68,
		91,
		80,
		119,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		175,
		167,
		162,
		168,
		170,
		161,
		119,
		116,
		-1,
		86,
		111,
		83,
		90,
		81,
		88,
		88,
		80,
		58,
		65,
		81,
		80,
		75,
		111,
		102,
		108,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		135,
		132,
		108,
		91,
		89,
		82,
		77,
		87,
		67,
		54,
		58,
		62,
		68,
		73,
		78,
		84,
		99,
		114,
		-1,
		170,
		251,
		244,
		217,
		225,
		256,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		108,
		105,
		110,
		98,
		95,
		97,
		92,
		83,
		68,
		74,
		61,
		60,
		78,
		82,
		91,
		98,
		88,
		101,
		105,
		-1,
		184,
		227,
		211,
		214,
		238,
		252,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		107,
		157,
		112,
		107,
		91,
		89,
		80,
		71,
		78,
		69,
		69,
		72,
		87,
		92,
		84,
		98,
		98,
		99,
		-1,
		201,
		207,
		205,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		125,
		129,
		120,
		123,
		105,
		92,
		84,
		76,
		92,
		67,
		77,
		73,
		74,
		83,
		94,
		106,
		105,
		106,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		167,
		206,
		204,
		-1,
		188,
		-1,
		-1,
		-1,
		139,
		133,
		125,
		125,
		104,
		104,
		78,
		82,
		72,
		79,
		89,
		91,
		83,
		87,
		100,
		111,
		114,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		182,
		173,
		200,
		211,
		200,
		195,
		182,
		-1,
		-1,
		162,
		143,
		-1,
		-1,
		111,
		99,
		82,
		83,
		79,
		82,
		97,
		100,
		90,
		88,
		82,
		114,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		201,
		195,
		199,
		215,
		240,
		-1,
		171,
		-1,
		-1,
		156,
		-1,
		-1,
		141,
		104,
		93,
		84,
		90,
		87,
		98,
		108,
		96,
		97,
		87,
		97,
		110,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		199,
		229,
		-1,
		-1,
		187,
		167,
		-1,
		-1,
		139,
		137,
		126,
		-1,
		116,
		89,
		94,
		114,
		116,
		105,
		99,
		93,
		100,
		99,
		107,
		115,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		177,
		173,
		-1,
		-1,
		134,
		127,
		115,
		103,
		93,
		103,
		107,
		111,
		103,
		96,
		91,
		102,
		94,
		98,
		115,
		-1,
		242,
		-1,
		194,
		170,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		194,
		180,
		173,
		161,
		159,
		-1,
		168,
		152,
		133,
		-1,
		103,
		116,
		147,
		115,
		120,
		115,
		97,
		108,
		97,
		100,
		114,
		109,
		-1,
		-1,
		182,
		185,
		-1,
		-1,
		184,
		186,
		-1,
		185,
		174,
		159,
		151,
		-1,
		-1,
		140,
		136,
		-1,
		-1,
		104,
		129,
		118,
		126,
		121,
		101,
		107,
		110,
		99,
		103,
		115,
		-1,
		-1,
		189,
		190,
		191,
		-1,
		169,
		-1,
		187,
		-1,
		154,
		160,
		148,
		-1,
		-1,
		-1,
		142,
		105,
		126,
		136,
		130,
		128,
		119,
		105,
		112,
		110,
		106,
		117,
		-1,
		-1,
		-1,
		187,
		161,
		194,
		185,
		168,
		148,
		140,
		159,
		-1,
		129,
		-1,
		104,
		106,
		132,
		135,
		141,
		135,
		108,
		123,
		113,
		104,
		113,
		193,
		-1,
		163,
		196,
		160,
		154,
		130,
		134,
		150,
		-1,
		126,
		108,
		-1,
		136,
		126,
		157,
		142,
		123,
		110,
		117,
		117,
		110,
		-1,
		-1,
		-1,
		165,
		164,
		156,
		150,
		150,
		135,
		126,
		-1,
		138,
		120,
		99,
		116,
		116,
		107,
		115,
		147,
		143,
		130,
		130,
		122,
		-1,
		266,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		159,
		154,
		127,
		115,
		121,
		117,
		103,
		109,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		123,
		158,
		-1,
		261,
		-1,
		195,
		-1,
		-1,
		177,
		157,
		149,
		138,
		127,
		125,
		116,
		107,
		129,
		145,
		129,
		127,
		130,
		131,
		-1,
		250,
		249,
		-1,
		196,
		188,
		174,
		-1,
		167,
		-1,
		173,
		134,
		-1,
		136,
		116,
		-1,
		138,
		134,
		-1,
		-1,
		237,
		212,
		-1,
		-1,
		-1,
		197,
		177,
		168,
		152,
		-1,
		127,
		127,
		-1,
		-1,
		-1,
		222,
		221,
		-1,
		190,
		193,
		-1,
		183,
		174,
		182,
		129,
		133,
		-1,
		-1,
		-1,
		231,
		212,
		206,
		205,
		203,
		198,
		195,
		181,
		165,
		143,
		132,
		153,
		-1,
		-1,
		-1,
		203,
		195,
		188,
		-1,
		-1,
		190,
		173,
		154,
		152,
		-1,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		180,
		-1,
		-1,
		186,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		214,
		-1,
		-1,
		-1,
		176,
		172,
		173,
		-1,
		-1,
		-1,
		-1,
		236,
		237,
		260,
		224,
		-1,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		239,
		237,
		-1,
		-1,
		-1,
		196,
		180,
		-1,
		166,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		201,
		-1,
		201,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		214,
		206,
		214,
		-1,
		186,
		188,
		-1,
		236,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		191,
		198,
		220,
		223,
		259,
		-1,
		210
	],
	[
		-1,
		142,
		131,
		142,
		150,
		123,
		130,
		-1,
		149,
		153,
		119,
		113,
		152,
		121,
		127,
		138,
		-1,
		-1,
		-1,
		142,
		141,
		109,
		107,
		116,
		121,
		128,
		-1,
		127,
		-1,
		163,
		142,
		153,
		158,
		102,
		99,
		119,
		138,
		120,
		112,
		178,
		132,
		103,
		97,
		115,
		105,
		114,
		106,
		-1,
		103,
		93,
		115,
		94,
		105,
		97,
		-1,
		-1,
		97,
		98,
		104,
		90,
		96,
		92,
		-1,
		102,
		86,
		-1,
		-1,
		87,
		88,
		72,
		75,
		83,
		81,
		94,
		86,
		81,
		-1,
		-1,
		78,
		74,
		81,
		68,
		64,
		81,
		94,
		76,
		77,
		75,
		-1,
		90,
		107,
		107,
		75,
		73,
		57,
		55,
		73,
		75,
		75,
		67,
		-1,
		107,
		103,
		104,
		102,
		97,
		73,
		60,
		60,
		70,
		63,
		69,
		56,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		108,
		99,
		116,
		100,
		90,
		94,
		92,
		63,
		60,
		58,
		55,
		71,
		55,
		65,
		-1,
		-1,
		201,
		174,
		198,
		156,
		138,
		-1,
		104,
		104,
		98,
		94,
		88,
		81,
		94,
		79,
		-1,
		49,
		48,
		62,
		48,
		59,
		183,
		-1,
		-1,
		159,
		151,
		133,
		136,
		113,
		109,
		119,
		118,
		111,
		99,
		95,
		78,
		81,
		81,
		87,
		43,
		53,
		55,
		41,
		53,
		-1,
		-1,
		90,
		-1,
		-1,
		180,
		163,
		-1,
		128,
		135,
		119,
		125,
		111,
		132,
		129,
		120,
		114,
		109,
		97,
		76,
		73,
		86,
		65,
		40,
		65,
		68,
		36,
		43,
		38,
		-1,
		89,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		135,
		132,
		125,
		149,
		148,
		-1,
		144,
		132,
		133,
		118,
		115,
		102,
		90,
		81,
		65,
		65,
		62,
		44,
		42,
		65,
		33,
		41,
		38,
		60,
		65,
		59,
		68,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		153,
		-1,
		156,
		169,
		156,
		129,
		132,
		119,
		110,
		97,
		86,
		82,
		63,
		60,
		56,
		36,
		51,
		28,
		27,
		31,
		44,
		52,
		56,
		62,
		-1,
		238,
		-1,
		180,
		164,
		166,
		139,
		160,
		-1,
		173,
		157,
		173,
		158,
		158,
		-1,
		128,
		125,
		115,
		93,
		78,
		75,
		63,
		58,
		49,
		31,
		45,
		22,
		18,
		25,
		34,
		38,
		58,
		70,
		198,
		188,
		-1,
		170,
		175,
		135,
		143,
		162,
		200,
		164,
		-1,
		159,
		-1,
		130,
		143,
		-1,
		99,
		95,
		77,
		71,
		60,
		67,
		42,
		27,
		24,
		14,
		9,
		27,
		31,
		47,
		-1,
		-1,
		183,
		187,
		177,
		128,
		147,
		171,
		208,
		157,
		146,
		145,
		-1,
		136,
		113,
		110,
		98,
		85,
		70,
		71,
		66,
		62,
		41,
		26,
		28,
		5,
		44,
		22,
		34,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		154,
		125,
		149,
		191,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		109,
		88,
		79,
		68,
		66,
		74,
		47,
		42,
		26,
		24,
		0,
		25,
		16,
		36,
		-1,
		-1,
		-1,
		184,
		173,
		174,
		120,
		143,
		180,
		154,
		140,
		145,
		120,
		113,
		107,
		122,
		105,
		86,
		75,
		67,
		56,
		48,
		54,
		46,
		22,
		27,
		7,
		31,
		38,
		44,
		-1,
		-1,
		191,
		181,
		165,
		167,
		164,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		96,
		80,
		75,
		72,
		66,
		53,
		53,
		51,
		32,
		27,
		39,
		36,
		36,
		28,
		53,
		56,
		-1,
		-1,
		-1,
		184,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		82,
		78,
		70,
		74,
		68,
		63,
		53,
		45,
		46,
		28,
		41,
		-1,
		36,
		30,
		58,
		61,
		51,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		82,
		77,
		74,
		75,
		66,
		55,
		61,
		53,
		33,
		43,
		55,
		51,
		49,
		42,
		47,
		46,
		60,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		102,
		86,
		87,
		78,
		69,
		77,
		57,
		50,
		36,
		40,
		50,
		60,
		55,
		61,
		53,
		56,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		94,
		109,
		110,
		88,
		78,
		76,
		84,
		72,
		61,
		48,
		52,
		59,
		69,
		56,
		56,
		58,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		108,
		106,
		99,
		90,
		96,
		87,
		81,
		76,
		66,
		55,
		61,
		57,
		78,
		64,
		62,
		57,
		72,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		107,
		91,
		96,
		-1,
		101,
		-1,
		74,
		74,
		65,
		54,
		51,
		62,
		60,
		71,
		63,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		123,
		103,
		97,
		96,
		96,
		91,
		82,
		63,
		56,
		53,
		54,
		67,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		140,
		128,
		118,
		108,
		117,
		107,
		82,
		75,
		61,
		63,
		61,
		63,
		68,
		78,
		70,
		80,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		129,
		-1,
		-1,
		118,
		109,
		99,
		78,
		65,
		85,
		88,
		78,
		62,
		77,
		84,
		72,
		81,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		173,
		135,
		124,
		119,
		123,
		117,
		-1,
		95,
		89,
		69,
		83,
		90,
		80,
		75,
		69,
		72,
		89,
		83,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		130,
		141,
		112,
		105,
		109,
		-1,
		97,
		85,
		71,
		88,
		93,
		90,
		81,
		73,
		78,
		75,
		88,
		95,
		85,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		148,
		163,
		151,
		128,
		101,
		96,
		89,
		83,
		79,
		95,
		101,
		112,
		80,
		76,
		77,
		81,
		80,
		97,
		100,
		-1,
		-1,
		162,
		179,
		174,
		156,
		160,
		178,
		-1,
		-1,
		105,
		96,
		87,
		90,
		89,
		92,
		86,
		83,
		88,
		93,
		81,
		90,
		108,
		103,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		175,
		176,
		123,
		105,
		101,
		99,
		92,
		101,
		96,
		91,
		101,
		103,
		95,
		83,
		87,
		110,
		99,
		132,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		194,
		186,
		181,
		187,
		189,
		180,
		138,
		135,
		-1,
		105,
		130,
		102,
		109,
		100,
		107,
		107,
		99,
		77,
		84,
		100,
		99,
		94,
		124,
		119,
		127,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		187,
		183,
		173,
		163,
		166,
		-1,
		-1,
		154,
		151,
		127,
		110,
		108,
		101,
		96,
		106,
		86,
		73,
		77,
		81,
		87,
		92,
		97,
		103,
		118,
		133,
		-1,
		189,
		270,
		263,
		236,
		244,
		275,
		-1,
		177,
		169,
		180,
		155,
		157,
		-1,
		-1,
		127,
		124,
		129,
		117,
		114,
		116,
		111,
		102,
		87,
		93,
		80,
		79,
		97,
		101,
		110,
		117,
		107,
		120,
		124,
		-1,
		203,
		246,
		230,
		233,
		257,
		271,
		-1,
		174,
		-1,
		-1,
		186,
		158,
		142,
		132,
		126,
		176,
		131,
		126,
		110,
		108,
		99,
		90,
		97,
		88,
		88,
		91,
		106,
		111,
		103,
		117,
		117,
		118,
		-1,
		220,
		226,
		224,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		202,
		-1,
		169,
		-1,
		144,
		148,
		139,
		142,
		124,
		111,
		103,
		95,
		111,
		86,
		96,
		92,
		93,
		102,
		113,
		125,
		124,
		125,
		245,
		201,
		204,
		215,
		226,
		241,
		245,
		-1,
		186,
		225,
		223,
		-1,
		207,
		-1,
		-1,
		-1,
		158,
		152,
		144,
		144,
		123,
		123,
		97,
		101,
		91,
		98,
		108,
		110,
		102,
		106,
		119,
		130,
		133,
		241,
		232,
		245,
		190,
		190,
		211,
		220,
		241,
		201,
		192,
		219,
		230,
		219,
		214,
		201,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		130,
		118,
		101,
		102,
		98,
		101,
		116,
		119,
		109,
		107,
		101,
		133,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		181,
		208,
		-1,
		-1,
		203,
		220,
		214,
		218,
		234,
		259,
		-1,
		190,
		-1,
		-1,
		175,
		-1,
		-1,
		160,
		123,
		112,
		103,
		109,
		106,
		117,
		127,
		115,
		116,
		106,
		116,
		129,
		218,
		215,
		203,
		201,
		224,
		189,
		177,
		-1,
		190,
		188,
		194,
		201,
		218,
		248,
		-1,
		-1,
		206,
		186,
		-1,
		-1,
		158,
		156,
		145,
		-1,
		135,
		108,
		113,
		133,
		135,
		124,
		118,
		112,
		119,
		118,
		126,
		134,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		175,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		196,
		192,
		-1,
		-1,
		153,
		146,
		134,
		122,
		112,
		122,
		126,
		130,
		122,
		115,
		110,
		121,
		113,
		117,
		134,
		-1,
		261,
		-1,
		213,
		189,
		203,
		218,
		226,
		-1,
		-1,
		-1,
		213,
		199,
		192,
		180,
		178,
		-1,
		187,
		171,
		152,
		-1,
		122,
		135,
		166,
		134,
		139,
		134,
		116,
		127,
		116,
		119,
		133,
		128,
		-1,
		-1,
		201,
		204,
		-1,
		-1,
		203,
		205,
		-1,
		204,
		193,
		178,
		170,
		-1,
		-1,
		159,
		155,
		-1,
		-1,
		123,
		148,
		137,
		145,
		140,
		120,
		126,
		129,
		118,
		122,
		134,
		-1,
		-1,
		208,
		209,
		210,
		-1,
		188,
		-1,
		206,
		-1,
		173,
		179,
		167,
		-1,
		-1,
		-1,
		161,
		124,
		145,
		155,
		149,
		147,
		138,
		124,
		131,
		129,
		125,
		136,
		-1,
		-1,
		-1,
		206,
		180,
		213,
		204,
		187,
		167,
		159,
		178,
		-1,
		148,
		-1,
		123,
		125,
		151,
		154,
		160,
		154,
		127,
		142,
		132,
		123,
		132,
		212,
		-1,
		182,
		215,
		179,
		173,
		149,
		153,
		169,
		-1,
		145,
		127,
		-1,
		155,
		145,
		176,
		161,
		142,
		129,
		136,
		136,
		129,
		-1,
		-1,
		-1,
		184,
		183,
		175,
		169,
		169,
		154,
		145,
		-1,
		157,
		139,
		118,
		135,
		135,
		126,
		134,
		166,
		162,
		149,
		149,
		141,
		-1,
		285,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		178,
		173,
		146,
		134,
		140,
		136,
		122,
		128,
		130,
		138,
		136,
		133,
		145,
		141,
		161,
		142,
		177,
		-1,
		280,
		-1,
		214,
		-1,
		-1,
		196,
		176,
		168,
		157,
		146,
		144,
		135,
		126,
		148,
		164,
		148,
		146,
		149,
		150,
		-1,
		269,
		268,
		-1,
		215,
		207,
		193,
		-1,
		186,
		-1,
		192,
		153,
		-1,
		155,
		135,
		-1,
		157,
		153,
		-1,
		-1,
		256,
		231,
		-1,
		-1,
		-1,
		216,
		196,
		187,
		171,
		-1,
		146,
		146,
		-1,
		-1,
		-1,
		241,
		240,
		-1,
		209,
		212,
		-1,
		202,
		193,
		201,
		148,
		152,
		-1,
		-1,
		-1,
		250,
		231,
		225,
		224,
		222,
		217,
		214,
		200,
		184,
		162,
		151,
		172,
		-1,
		-1,
		-1,
		222,
		214,
		207,
		-1,
		-1,
		209,
		192,
		173,
		171,
		-1,
		-1,
		-1,
		244,
		225,
		-1,
		-1,
		199,
		-1,
		-1,
		205,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		233,
		-1,
		-1,
		-1,
		195,
		191,
		192,
		-1,
		-1,
		-1,
		-1,
		255,
		256,
		279,
		243,
		-1,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		258,
		256,
		-1,
		-1,
		-1,
		215,
		199,
		-1,
		185,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		220,
		-1,
		220,
		195,
		202,
		-1,
		-1,
		-1,
		-1,
		233,
		225,
		233,
		-1,
		205,
		207,
		-1,
		255,
		-1,
		-1,
		248,
		239,
		-1,
		-1,
		210,
		217,
		239,
		242,
		278,
		-1,
		229
	],
	[
		-1,
		156,
		145,
		156,
		164,
		137,
		144,
		-1,
		163,
		167,
		133,
		127,
		166,
		135,
		141,
		152,
		-1,
		-1,
		-1,
		156,
		155,
		123,
		121,
		130,
		135,
		142,
		-1,
		141,
		-1,
		177,
		156,
		167,
		172,
		116,
		113,
		133,
		152,
		134,
		126,
		192,
		146,
		117,
		111,
		129,
		119,
		128,
		120,
		-1,
		117,
		107,
		129,
		108,
		119,
		111,
		-1,
		-1,
		111,
		112,
		118,
		104,
		110,
		106,
		-1,
		116,
		100,
		-1,
		-1,
		101,
		102,
		86,
		89,
		97,
		95,
		108,
		100,
		95,
		-1,
		-1,
		92,
		88,
		95,
		82,
		78,
		95,
		108,
		90,
		104,
		102,
		-1,
		104,
		121,
		121,
		89,
		87,
		71,
		69,
		87,
		89,
		95,
		94,
		-1,
		121,
		117,
		118,
		116,
		111,
		87,
		74,
		74,
		84,
		77,
		96,
		83,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		122,
		113,
		130,
		114,
		104,
		108,
		106,
		77,
		74,
		72,
		69,
		85,
		82,
		92,
		-1,
		-1,
		215,
		188,
		212,
		170,
		152,
		-1,
		118,
		118,
		112,
		108,
		102,
		95,
		108,
		93,
		-1,
		63,
		62,
		89,
		75,
		86,
		197,
		-1,
		-1,
		173,
		165,
		147,
		150,
		127,
		123,
		133,
		132,
		125,
		113,
		109,
		92,
		95,
		95,
		101,
		57,
		67,
		71,
		68,
		66,
		-1,
		-1,
		80,
		-1,
		-1,
		194,
		177,
		-1,
		142,
		149,
		133,
		139,
		125,
		146,
		143,
		134,
		128,
		123,
		111,
		90,
		87,
		100,
		79,
		54,
		79,
		83,
		63,
		56,
		51,
		-1,
		79,
		63,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		149,
		146,
		139,
		163,
		162,
		-1,
		158,
		146,
		147,
		132,
		129,
		116,
		104,
		95,
		79,
		79,
		76,
		58,
		56,
		86,
		60,
		55,
		45,
		50,
		55,
		49,
		58,
		-1,
		202,
		198,
		194,
		201,
		150,
		-1,
		-1,
		167,
		-1,
		170,
		183,
		170,
		143,
		146,
		133,
		124,
		111,
		100,
		96,
		77,
		74,
		70,
		50,
		65,
		55,
		54,
		34,
		34,
		42,
		46,
		52,
		-1,
		252,
		-1,
		194,
		178,
		180,
		153,
		174,
		-1,
		187,
		171,
		187,
		172,
		172,
		-1,
		142,
		139,
		129,
		107,
		92,
		89,
		77,
		72,
		63,
		45,
		59,
		49,
		45,
		38,
		24,
		28,
		50,
		60,
		212,
		202,
		-1,
		184,
		189,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		144,
		157,
		-1,
		113,
		109,
		91,
		85,
		74,
		81,
		56,
		41,
		38,
		41,
		36,
		17,
		21,
		39,
		-1,
		-1,
		197,
		201,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		127,
		124,
		112,
		99,
		84,
		85,
		80,
		76,
		55,
		40,
		42,
		32,
		34,
		15,
		24,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		123,
		102,
		93,
		82,
		80,
		88,
		61,
		56,
		40,
		38,
		27,
		0,
		11,
		26,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		136,
		119,
		100,
		89,
		81,
		70,
		62,
		68,
		60,
		36,
		41,
		21,
		20,
		33,
		39,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		110,
		94,
		89,
		86,
		80,
		67,
		67,
		65,
		46,
		41,
		53,
		25,
		25,
		23,
		48,
		51,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		96,
		92,
		84,
		88,
		82,
		77,
		67,
		59,
		60,
		42,
		55,
		-1,
		31,
		25,
		53,
		56,
		46,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		96,
		91,
		88,
		89,
		80,
		69,
		75,
		67,
		47,
		57,
		69,
		46,
		44,
		37,
		42,
		41,
		55,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		116,
		100,
		101,
		92,
		83,
		91,
		71,
		64,
		50,
		54,
		64,
		55,
		50,
		56,
		48,
		51,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		108,
		123,
		124,
		102,
		92,
		90,
		98,
		86,
		75,
		62,
		66,
		68,
		65,
		51,
		51,
		53,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		122,
		120,
		113,
		104,
		110,
		101,
		95,
		90,
		80,
		69,
		75,
		71,
		73,
		59,
		57,
		52,
		67,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		121,
		105,
		110,
		-1,
		115,
		-1,
		88,
		88,
		79,
		68,
		65,
		69,
		60,
		73,
		58,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		137,
		117,
		111,
		110,
		110,
		105,
		96,
		77,
		70,
		67,
		68,
		81,
		93,
		72,
		60,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		154,
		142,
		132,
		122,
		131,
		121,
		96,
		89,
		75,
		77,
		75,
		77,
		82,
		73,
		65,
		75,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		143,
		-1,
		-1,
		132,
		123,
		113,
		92,
		79,
		99,
		102,
		92,
		76,
		89,
		79,
		67,
		76,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		187,
		149,
		138,
		133,
		137,
		131,
		-1,
		109,
		103,
		83,
		97,
		104,
		94,
		89,
		83,
		84,
		84,
		78,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		144,
		155,
		126,
		119,
		123,
		-1,
		111,
		99,
		85,
		102,
		107,
		104,
		95,
		87,
		92,
		81,
		94,
		90,
		80,
		193,
		-1,
		176,
		-1,
		-1,
		-1,
		162,
		177,
		165,
		142,
		115,
		110,
		103,
		97,
		93,
		109,
		115,
		126,
		94,
		90,
		91,
		87,
		86,
		94,
		95,
		-1,
		-1,
		176,
		193,
		188,
		170,
		174,
		192,
		-1,
		-1,
		119,
		110,
		101,
		104,
		103,
		106,
		100,
		97,
		102,
		104,
		95,
		96,
		113,
		98,
		-1,
		-1,
		-1,
		196,
		-1,
		211,
		-1,
		-1,
		189,
		190,
		137,
		119,
		115,
		113,
		106,
		115,
		110,
		105,
		115,
		117,
		109,
		94,
		101,
		124,
		106,
		127,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		208,
		200,
		195,
		201,
		203,
		194,
		152,
		149,
		-1,
		119,
		144,
		116,
		123,
		114,
		121,
		121,
		113,
		91,
		98,
		114,
		113,
		108,
		119,
		114,
		123,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		201,
		197,
		187,
		177,
		180,
		-1,
		-1,
		168,
		165,
		141,
		124,
		122,
		115,
		110,
		120,
		100,
		87,
		91,
		95,
		101,
		106,
		111,
		117,
		121,
		129,
		-1,
		203,
		284,
		277,
		250,
		258,
		289,
		-1,
		191,
		183,
		194,
		169,
		171,
		-1,
		-1,
		141,
		138,
		143,
		131,
		128,
		130,
		125,
		116,
		101,
		107,
		94,
		93,
		111,
		115,
		124,
		131,
		121,
		134,
		138,
		-1,
		217,
		260,
		244,
		247,
		271,
		285,
		-1,
		188,
		-1,
		-1,
		200,
		172,
		156,
		146,
		140,
		190,
		145,
		140,
		124,
		122,
		113,
		104,
		111,
		102,
		102,
		105,
		120,
		125,
		117,
		131,
		131,
		132,
		-1,
		234,
		240,
		238,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		216,
		-1,
		183,
		-1,
		158,
		162,
		153,
		156,
		138,
		125,
		117,
		109,
		125,
		100,
		110,
		106,
		107,
		116,
		127,
		139,
		138,
		139,
		259,
		215,
		218,
		229,
		240,
		255,
		259,
		-1,
		200,
		239,
		237,
		-1,
		221,
		-1,
		-1,
		-1,
		172,
		166,
		158,
		158,
		137,
		137,
		111,
		115,
		105,
		112,
		122,
		124,
		116,
		120,
		133,
		144,
		147,
		255,
		246,
		259,
		204,
		204,
		225,
		234,
		255,
		215,
		206,
		233,
		244,
		233,
		228,
		215,
		-1,
		-1,
		195,
		176,
		-1,
		-1,
		144,
		132,
		115,
		116,
		112,
		115,
		130,
		133,
		123,
		121,
		115,
		147,
		-1,
		248,
		247,
		236,
		233,
		209,
		200,
		195,
		222,
		-1,
		-1,
		217,
		234,
		228,
		232,
		248,
		273,
		-1,
		204,
		-1,
		-1,
		189,
		-1,
		-1,
		174,
		137,
		126,
		117,
		123,
		120,
		131,
		141,
		129,
		130,
		120,
		130,
		143,
		232,
		229,
		217,
		215,
		238,
		203,
		191,
		-1,
		204,
		202,
		208,
		215,
		232,
		262,
		-1,
		-1,
		220,
		200,
		-1,
		-1,
		172,
		170,
		159,
		-1,
		149,
		122,
		127,
		147,
		149,
		138,
		132,
		126,
		133,
		132,
		140,
		148,
		241,
		255,
		244,
		240,
		239,
		247,
		196,
		189,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		210,
		206,
		-1,
		-1,
		167,
		160,
		148,
		136,
		126,
		136,
		140,
		144,
		136,
		129,
		124,
		135,
		127,
		131,
		148,
		-1,
		275,
		-1,
		227,
		203,
		217,
		232,
		240,
		-1,
		-1,
		-1,
		227,
		213,
		206,
		194,
		192,
		-1,
		201,
		185,
		166,
		-1,
		136,
		149,
		180,
		148,
		153,
		148,
		130,
		141,
		130,
		133,
		147,
		142,
		-1,
		-1,
		215,
		218,
		-1,
		-1,
		217,
		219,
		-1,
		218,
		207,
		192,
		184,
		-1,
		-1,
		173,
		169,
		-1,
		-1,
		137,
		162,
		151,
		159,
		154,
		134,
		140,
		143,
		132,
		136,
		148,
		-1,
		-1,
		222,
		223,
		224,
		-1,
		202,
		-1,
		220,
		-1,
		187,
		193,
		181,
		-1,
		-1,
		-1,
		175,
		138,
		159,
		169,
		163,
		161,
		152,
		138,
		145,
		143,
		139,
		150,
		-1,
		-1,
		-1,
		220,
		194,
		227,
		218,
		201,
		181,
		173,
		192,
		-1,
		162,
		-1,
		137,
		139,
		165,
		168,
		174,
		168,
		141,
		156,
		146,
		137,
		146,
		226,
		-1,
		196,
		229,
		193,
		187,
		163,
		167,
		183,
		-1,
		159,
		141,
		-1,
		169,
		159,
		190,
		175,
		156,
		143,
		150,
		150,
		143,
		-1,
		-1,
		-1,
		198,
		197,
		189,
		183,
		183,
		168,
		159,
		-1,
		171,
		153,
		132,
		149,
		149,
		140,
		148,
		180,
		176,
		163,
		163,
		155,
		-1,
		299,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		192,
		187,
		160,
		148,
		154,
		150,
		136,
		142,
		144,
		152,
		150,
		147,
		159,
		155,
		175,
		156,
		191,
		-1,
		294,
		-1,
		228,
		-1,
		-1,
		210,
		190,
		182,
		171,
		160,
		158,
		149,
		140,
		162,
		178,
		162,
		160,
		163,
		164,
		-1,
		283,
		282,
		-1,
		229,
		221,
		207,
		-1,
		200,
		-1,
		206,
		167,
		-1,
		169,
		149,
		-1,
		171,
		167,
		-1,
		-1,
		270,
		245,
		-1,
		-1,
		-1,
		230,
		210,
		201,
		185,
		-1,
		160,
		160,
		-1,
		-1,
		-1,
		255,
		254,
		-1,
		223,
		226,
		-1,
		216,
		207,
		215,
		162,
		166,
		-1,
		-1,
		-1,
		264,
		245,
		239,
		238,
		236,
		231,
		228,
		214,
		198,
		176,
		165,
		186,
		-1,
		-1,
		-1,
		236,
		228,
		221,
		-1,
		-1,
		223,
		206,
		187,
		185,
		-1,
		-1,
		-1,
		258,
		239,
		-1,
		-1,
		213,
		-1,
		-1,
		219,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		247,
		-1,
		-1,
		-1,
		209,
		205,
		206,
		-1,
		-1,
		-1,
		-1,
		269,
		270,
		293,
		257,
		-1,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		272,
		270,
		-1,
		-1,
		-1,
		229,
		213,
		-1,
		199,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		234,
		-1,
		234,
		209,
		216,
		-1,
		-1,
		-1,
		-1,
		247,
		239,
		247,
		-1,
		219,
		221,
		-1,
		269,
		-1,
		-1,
		262,
		253,
		-1,
		-1,
		224,
		231,
		253,
		256,
		292,
		-1,
		243
	],
	[
		-1,
		145,
		134,
		145,
		153,
		126,
		133,
		-1,
		152,
		156,
		122,
		116,
		155,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		145,
		144,
		112,
		110,
		119,
		124,
		131,
		-1,
		130,
		-1,
		166,
		145,
		156,
		161,
		105,
		102,
		122,
		141,
		123,
		115,
		181,
		135,
		106,
		100,
		118,
		108,
		117,
		109,
		-1,
		106,
		96,
		118,
		97,
		108,
		100,
		-1,
		-1,
		100,
		101,
		107,
		93,
		99,
		95,
		-1,
		105,
		89,
		-1,
		-1,
		90,
		91,
		75,
		78,
		86,
		84,
		97,
		89,
		84,
		-1,
		-1,
		81,
		77,
		84,
		71,
		67,
		84,
		97,
		79,
		93,
		91,
		-1,
		93,
		110,
		110,
		78,
		76,
		60,
		58,
		76,
		78,
		84,
		83,
		-1,
		110,
		106,
		107,
		105,
		100,
		76,
		63,
		63,
		73,
		66,
		85,
		72,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		102,
		119,
		103,
		93,
		97,
		95,
		66,
		63,
		61,
		58,
		74,
		71,
		81,
		-1,
		-1,
		204,
		177,
		201,
		159,
		141,
		-1,
		107,
		107,
		101,
		97,
		91,
		84,
		97,
		82,
		-1,
		52,
		51,
		78,
		64,
		75,
		186,
		-1,
		-1,
		162,
		154,
		136,
		139,
		116,
		112,
		122,
		121,
		114,
		102,
		98,
		81,
		84,
		84,
		90,
		46,
		56,
		60,
		57,
		60,
		-1,
		-1,
		74,
		-1,
		-1,
		183,
		166,
		-1,
		131,
		138,
		122,
		128,
		114,
		135,
		132,
		123,
		117,
		112,
		100,
		79,
		76,
		89,
		68,
		43,
		68,
		72,
		52,
		50,
		45,
		-1,
		73,
		57,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		138,
		135,
		128,
		152,
		151,
		-1,
		147,
		135,
		136,
		121,
		118,
		105,
		93,
		84,
		68,
		68,
		65,
		47,
		45,
		75,
		49,
		49,
		39,
		44,
		49,
		43,
		52,
		-1,
		191,
		187,
		183,
		190,
		139,
		-1,
		-1,
		156,
		-1,
		159,
		172,
		159,
		132,
		135,
		122,
		113,
		100,
		89,
		85,
		66,
		63,
		59,
		39,
		54,
		44,
		43,
		28,
		28,
		36,
		40,
		46,
		-1,
		241,
		-1,
		183,
		167,
		169,
		142,
		163,
		-1,
		176,
		160,
		176,
		161,
		161,
		-1,
		131,
		128,
		118,
		96,
		81,
		78,
		66,
		61,
		52,
		34,
		48,
		38,
		34,
		32,
		18,
		22,
		42,
		54,
		201,
		191,
		-1,
		173,
		178,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		133,
		146,
		-1,
		102,
		98,
		80,
		74,
		63,
		70,
		45,
		30,
		27,
		30,
		25,
		11,
		15,
		31,
		-1,
		-1,
		186,
		190,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		116,
		113,
		101,
		88,
		73,
		74,
		69,
		65,
		44,
		29,
		31,
		21,
		28,
		6,
		18,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		112,
		91,
		82,
		71,
		69,
		77,
		50,
		45,
		29,
		27,
		16,
		9,
		0,
		20,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		125,
		108,
		89,
		78,
		70,
		59,
		51,
		57,
		49,
		25,
		30,
		10,
		15,
		22,
		28,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		99,
		83,
		78,
		75,
		69,
		56,
		56,
		54,
		35,
		30,
		42,
		20,
		20,
		12,
		37,
		40,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		85,
		81,
		73,
		77,
		71,
		66,
		56,
		48,
		49,
		31,
		44,
		-1,
		20,
		14,
		42,
		45,
		35,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		85,
		80,
		77,
		78,
		69,
		58,
		64,
		56,
		36,
		46,
		58,
		35,
		33,
		26,
		31,
		30,
		44,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		105,
		89,
		90,
		81,
		72,
		80,
		60,
		53,
		39,
		43,
		53,
		44,
		39,
		45,
		37,
		40,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		97,
		112,
		113,
		91,
		81,
		79,
		87,
		75,
		64,
		51,
		55,
		57,
		54,
		40,
		40,
		42,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		111,
		109,
		102,
		93,
		99,
		90,
		84,
		79,
		69,
		58,
		64,
		60,
		62,
		48,
		46,
		41,
		56,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		110,
		94,
		99,
		-1,
		104,
		-1,
		77,
		77,
		68,
		57,
		54,
		58,
		49,
		62,
		47,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		126,
		106,
		100,
		99,
		99,
		94,
		85,
		66,
		59,
		56,
		57,
		70,
		82,
		61,
		49,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		143,
		131,
		121,
		111,
		120,
		110,
		85,
		78,
		64,
		66,
		64,
		66,
		71,
		62,
		54,
		64,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		132,
		-1,
		-1,
		121,
		112,
		102,
		81,
		68,
		88,
		91,
		81,
		65,
		78,
		68,
		56,
		65,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		176,
		138,
		127,
		122,
		126,
		120,
		-1,
		98,
		92,
		72,
		86,
		93,
		83,
		78,
		72,
		73,
		73,
		67,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		133,
		144,
		115,
		108,
		112,
		-1,
		100,
		88,
		74,
		91,
		96,
		93,
		84,
		76,
		81,
		70,
		83,
		79,
		69,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		151,
		166,
		154,
		131,
		104,
		99,
		92,
		86,
		82,
		98,
		104,
		115,
		83,
		79,
		80,
		76,
		75,
		83,
		84,
		-1,
		-1,
		165,
		182,
		177,
		159,
		163,
		181,
		-1,
		-1,
		108,
		99,
		90,
		93,
		92,
		95,
		89,
		86,
		91,
		93,
		84,
		85,
		102,
		87,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		178,
		179,
		126,
		108,
		104,
		102,
		95,
		104,
		99,
		94,
		104,
		106,
		98,
		83,
		90,
		113,
		95,
		116,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		197,
		189,
		184,
		190,
		192,
		183,
		141,
		138,
		-1,
		108,
		133,
		105,
		112,
		103,
		110,
		110,
		102,
		80,
		87,
		103,
		102,
		97,
		108,
		103,
		112,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		190,
		186,
		176,
		166,
		169,
		-1,
		-1,
		157,
		154,
		130,
		113,
		111,
		104,
		99,
		109,
		89,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		110,
		118,
		-1,
		192,
		273,
		266,
		239,
		247,
		278,
		-1,
		180,
		172,
		183,
		158,
		160,
		-1,
		-1,
		130,
		127,
		132,
		120,
		117,
		119,
		114,
		105,
		90,
		96,
		83,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		206,
		249,
		233,
		236,
		260,
		274,
		-1,
		177,
		-1,
		-1,
		189,
		161,
		145,
		135,
		129,
		179,
		134,
		129,
		113,
		111,
		102,
		93,
		100,
		91,
		91,
		94,
		109,
		114,
		106,
		120,
		120,
		121,
		-1,
		223,
		229,
		227,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		205,
		-1,
		172,
		-1,
		147,
		151,
		142,
		145,
		127,
		114,
		106,
		98,
		114,
		89,
		99,
		95,
		96,
		105,
		116,
		128,
		127,
		128,
		248,
		204,
		207,
		218,
		229,
		244,
		248,
		-1,
		189,
		228,
		226,
		-1,
		210,
		-1,
		-1,
		-1,
		161,
		155,
		147,
		147,
		126,
		126,
		100,
		104,
		94,
		101,
		111,
		113,
		105,
		109,
		122,
		133,
		136,
		244,
		235,
		248,
		193,
		193,
		214,
		223,
		244,
		204,
		195,
		222,
		233,
		222,
		217,
		204,
		-1,
		-1,
		184,
		165,
		-1,
		-1,
		133,
		121,
		104,
		105,
		101,
		104,
		119,
		122,
		112,
		110,
		104,
		136,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		211,
		-1,
		-1,
		206,
		223,
		217,
		221,
		237,
		262,
		-1,
		193,
		-1,
		-1,
		178,
		-1,
		-1,
		163,
		126,
		115,
		106,
		112,
		109,
		120,
		130,
		118,
		119,
		109,
		119,
		132,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		209,
		189,
		-1,
		-1,
		161,
		159,
		148,
		-1,
		138,
		111,
		116,
		136,
		138,
		127,
		121,
		115,
		122,
		121,
		129,
		137,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		199,
		195,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		129,
		133,
		125,
		118,
		113,
		124,
		116,
		120,
		137,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		216,
		202,
		195,
		183,
		181,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		169,
		137,
		142,
		137,
		119,
		130,
		119,
		122,
		136,
		131,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		206,
		208,
		-1,
		207,
		196,
		181,
		173,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		126,
		151,
		140,
		148,
		143,
		123,
		129,
		132,
		121,
		125,
		137,
		-1,
		-1,
		211,
		212,
		213,
		-1,
		191,
		-1,
		209,
		-1,
		176,
		182,
		170,
		-1,
		-1,
		-1,
		164,
		127,
		148,
		158,
		152,
		150,
		141,
		127,
		134,
		132,
		128,
		139,
		-1,
		-1,
		-1,
		209,
		183,
		216,
		207,
		190,
		170,
		162,
		181,
		-1,
		151,
		-1,
		126,
		128,
		154,
		157,
		163,
		157,
		130,
		145,
		135,
		126,
		135,
		215,
		-1,
		185,
		218,
		182,
		176,
		152,
		156,
		172,
		-1,
		148,
		130,
		-1,
		158,
		148,
		179,
		164,
		145,
		132,
		139,
		139,
		132,
		-1,
		-1,
		-1,
		187,
		186,
		178,
		172,
		172,
		157,
		148,
		-1,
		160,
		142,
		121,
		138,
		138,
		129,
		137,
		169,
		165,
		152,
		152,
		144,
		-1,
		288,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		181,
		176,
		149,
		137,
		143,
		139,
		125,
		131,
		133,
		141,
		139,
		136,
		148,
		144,
		164,
		145,
		180,
		-1,
		283,
		-1,
		217,
		-1,
		-1,
		199,
		179,
		171,
		160,
		149,
		147,
		138,
		129,
		151,
		167,
		151,
		149,
		152,
		153,
		-1,
		272,
		271,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		195,
		156,
		-1,
		158,
		138,
		-1,
		160,
		156,
		-1,
		-1,
		259,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		190,
		174,
		-1,
		149,
		149,
		-1,
		-1,
		-1,
		244,
		243,
		-1,
		212,
		215,
		-1,
		205,
		196,
		204,
		151,
		155,
		-1,
		-1,
		-1,
		253,
		234,
		228,
		227,
		225,
		220,
		217,
		203,
		187,
		165,
		154,
		175,
		-1,
		-1,
		-1,
		225,
		217,
		210,
		-1,
		-1,
		212,
		195,
		176,
		174,
		-1,
		-1,
		-1,
		247,
		228,
		-1,
		-1,
		202,
		-1,
		-1,
		208,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		236,
		-1,
		-1,
		-1,
		198,
		194,
		195,
		-1,
		-1,
		-1,
		-1,
		258,
		259,
		282,
		246,
		-1,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		261,
		259,
		-1,
		-1,
		-1,
		218,
		202,
		-1,
		188,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		223,
		-1,
		223,
		198,
		205,
		-1,
		-1,
		-1,
		-1,
		236,
		228,
		236,
		-1,
		208,
		210,
		-1,
		258,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		213,
		220,
		242,
		245,
		281,
		-1,
		232
	],
	[
		-1,
		165,
		154,
		165,
		173,
		146,
		153,
		-1,
		172,
		176,
		142,
		136,
		175,
		144,
		150,
		161,
		-1,
		-1,
		-1,
		165,
		164,
		132,
		130,
		139,
		144,
		151,
		-1,
		150,
		-1,
		186,
		165,
		176,
		181,
		125,
		122,
		142,
		161,
		143,
		135,
		201,
		155,
		126,
		120,
		138,
		128,
		137,
		129,
		-1,
		126,
		116,
		138,
		117,
		128,
		120,
		-1,
		-1,
		120,
		121,
		127,
		113,
		119,
		115,
		-1,
		125,
		109,
		-1,
		-1,
		110,
		111,
		95,
		98,
		106,
		104,
		117,
		109,
		104,
		-1,
		-1,
		101,
		97,
		104,
		91,
		87,
		104,
		117,
		99,
		113,
		111,
		-1,
		113,
		130,
		130,
		98,
		96,
		80,
		78,
		96,
		98,
		104,
		103,
		-1,
		130,
		126,
		127,
		125,
		120,
		96,
		83,
		83,
		93,
		86,
		105,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		122,
		139,
		123,
		113,
		117,
		115,
		86,
		83,
		81,
		78,
		94,
		91,
		101,
		-1,
		-1,
		224,
		197,
		221,
		179,
		161,
		-1,
		127,
		127,
		121,
		117,
		111,
		104,
		117,
		102,
		-1,
		72,
		71,
		98,
		84,
		95,
		206,
		-1,
		-1,
		182,
		174,
		156,
		159,
		136,
		132,
		142,
		141,
		134,
		122,
		118,
		101,
		104,
		104,
		110,
		66,
		76,
		80,
		77,
		80,
		-1,
		-1,
		94,
		-1,
		-1,
		203,
		186,
		-1,
		151,
		158,
		142,
		148,
		134,
		155,
		152,
		143,
		137,
		132,
		120,
		99,
		96,
		109,
		88,
		63,
		88,
		92,
		72,
		70,
		65,
		-1,
		93,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		158,
		155,
		148,
		172,
		171,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		104,
		88,
		88,
		85,
		67,
		65,
		95,
		69,
		69,
		59,
		64,
		69,
		61,
		70,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		176,
		-1,
		179,
		192,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		105,
		86,
		83,
		79,
		59,
		74,
		64,
		63,
		48,
		48,
		56,
		58,
		64,
		-1,
		261,
		-1,
		203,
		187,
		189,
		162,
		183,
		-1,
		196,
		180,
		196,
		181,
		181,
		-1,
		151,
		148,
		138,
		116,
		101,
		98,
		86,
		81,
		72,
		54,
		68,
		58,
		54,
		52,
		38,
		42,
		53,
		74,
		221,
		211,
		-1,
		193,
		198,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		94,
		83,
		90,
		65,
		50,
		47,
		50,
		45,
		31,
		35,
		42,
		-1,
		-1,
		206,
		210,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		136,
		133,
		121,
		108,
		93,
		94,
		89,
		85,
		64,
		49,
		51,
		41,
		48,
		26,
		9,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		89,
		97,
		70,
		65,
		49,
		47,
		36,
		23,
		20,
		0,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		145,
		128,
		109,
		98,
		90,
		79,
		71,
		77,
		69,
		45,
		50,
		30,
		26,
		24,
		16,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		89,
		76,
		76,
		74,
		55,
		50,
		62,
		31,
		31,
		24,
		34,
		37,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		93,
		97,
		91,
		86,
		76,
		68,
		69,
		51,
		64,
		-1,
		28,
		26,
		39,
		53,
		47,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		100,
		97,
		98,
		89,
		78,
		84,
		76,
		56,
		66,
		78,
		43,
		41,
		38,
		43,
		42,
		56,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		110,
		101,
		92,
		100,
		80,
		73,
		59,
		63,
		73,
		55,
		51,
		57,
		49,
		52,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		101,
		99,
		106,
		94,
		83,
		71,
		75,
		68,
		65,
		52,
		52,
		54,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		110,
		103,
		98,
		88,
		77,
		77,
		72,
		74,
		60,
		58,
		53,
		68,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		130,
		114,
		119,
		-1,
		123,
		-1,
		96,
		93,
		84,
		69,
		66,
		70,
		61,
		74,
		59,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		146,
		126,
		120,
		119,
		118,
		110,
		104,
		82,
		75,
		72,
		69,
		82,
		94,
		73,
		61,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		163,
		151,
		141,
		131,
		136,
		126,
		101,
		94,
		80,
		82,
		80,
		78,
		83,
		74,
		66,
		76,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		171,
		142,
		152,
		-1,
		-1,
		137,
		128,
		118,
		97,
		84,
		104,
		107,
		93,
		77,
		90,
		80,
		68,
		77,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		196,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		108,
		88,
		102,
		109,
		95,
		90,
		84,
		85,
		85,
		79,
		-1,
		-1,
		179,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		153,
		156,
		127,
		120,
		124,
		-1,
		112,
		104,
		90,
		107,
		108,
		105,
		96,
		88,
		93,
		82,
		95,
		91,
		81,
		202,
		-1,
		185,
		-1,
		-1,
		-1,
		171,
		186,
		166,
		143,
		116,
		111,
		104,
		98,
		98,
		114,
		116,
		127,
		95,
		91,
		92,
		88,
		87,
		95,
		96,
		-1,
		-1,
		185,
		202,
		197,
		179,
		183,
		193,
		-1,
		-1,
		120,
		111,
		102,
		105,
		108,
		111,
		101,
		98,
		103,
		105,
		96,
		97,
		114,
		99,
		-1,
		-1,
		-1,
		205,
		-1,
		220,
		-1,
		-1,
		198,
		191,
		138,
		120,
		116,
		114,
		107,
		116,
		111,
		106,
		116,
		123,
		115,
		95,
		109,
		125,
		107,
		128,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		209,
		201,
		196,
		202,
		204,
		195,
		153,
		150,
		-1,
		120,
		145,
		117,
		124,
		116,
		124,
		124,
		119,
		99,
		106,
		122,
		119,
		116,
		120,
		115,
		124,
		-1,
		-1,
		300,
		289,
		278,
		284,
		-1,
		202,
		198,
		188,
		178,
		181,
		-1,
		-1,
		169,
		166,
		142,
		126,
		130,
		123,
		118,
		128,
		108,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		122,
		130,
		-1,
		212,
		291,
		284,
		252,
		260,
		291,
		-1,
		192,
		184,
		195,
		170,
		172,
		-1,
		-1,
		142,
		139,
		144,
		133,
		130,
		138,
		133,
		124,
		109,
		115,
		102,
		101,
		119,
		123,
		132,
		136,
		125,
		138,
		142,
		-1,
		226,
		267,
		246,
		249,
		273,
		287,
		-1,
		189,
		-1,
		-1,
		201,
		173,
		157,
		147,
		141,
		191,
		147,
		142,
		132,
		130,
		121,
		112,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		135,
		135,
		136,
		-1,
		236,
		247,
		240,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		217,
		-1,
		184,
		-1,
		159,
		163,
		155,
		158,
		146,
		133,
		125,
		117,
		133,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		142,
		143,
		261,
		217,
		220,
		231,
		242,
		257,
		261,
		-1,
		201,
		240,
		245,
		-1,
		226,
		-1,
		-1,
		-1,
		173,
		168,
		160,
		166,
		145,
		145,
		119,
		123,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		151,
		257,
		248,
		261,
		206,
		206,
		227,
		236,
		257,
		216,
		207,
		234,
		252,
		241,
		236,
		223,
		-1,
		-1,
		196,
		178,
		-1,
		-1,
		152,
		140,
		123,
		124,
		120,
		123,
		138,
		141,
		131,
		129,
		123,
		155,
		-1,
		250,
		249,
		238,
		235,
		211,
		202,
		197,
		224,
		-1,
		-1,
		219,
		235,
		230,
		234,
		250,
		275,
		-1,
		212,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		128,
		139,
		149,
		137,
		138,
		128,
		138,
		151,
		234,
		231,
		219,
		217,
		240,
		205,
		193,
		-1,
		206,
		204,
		210,
		217,
		234,
		264,
		-1,
		-1,
		228,
		208,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		130,
		135,
		155,
		157,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		243,
		257,
		246,
		242,
		241,
		249,
		198,
		191,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		218,
		214,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		148,
		152,
		144,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		277,
		-1,
		229,
		205,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		235,
		221,
		214,
		202,
		200,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		225,
		227,
		-1,
		226,
		215,
		200,
		192,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		210,
		-1,
		228,
		-1,
		195,
		201,
		189,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		171,
		169,
		160,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		228,
		202,
		235,
		226,
		209,
		189,
		181,
		200,
		-1,
		170,
		-1,
		145,
		147,
		173,
		176,
		182,
		176,
		149,
		164,
		154,
		145,
		154,
		234,
		-1,
		204,
		237,
		201,
		195,
		171,
		175,
		191,
		-1,
		167,
		149,
		-1,
		177,
		167,
		198,
		183,
		164,
		151,
		158,
		158,
		151,
		-1,
		-1,
		-1,
		206,
		205,
		197,
		191,
		191,
		176,
		167,
		-1,
		179,
		161,
		140,
		157,
		157,
		148,
		156,
		188,
		184,
		171,
		171,
		163,
		-1,
		307,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		200,
		195,
		168,
		156,
		162,
		158,
		144,
		150,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		164,
		199,
		-1,
		302,
		-1,
		236,
		-1,
		-1,
		218,
		198,
		190,
		179,
		168,
		166,
		157,
		148,
		170,
		186,
		170,
		168,
		171,
		172,
		-1,
		291,
		290,
		-1,
		237,
		229,
		215,
		-1,
		208,
		-1,
		214,
		175,
		-1,
		177,
		157,
		-1,
		179,
		175,
		-1,
		-1,
		278,
		253,
		-1,
		-1,
		-1,
		238,
		218,
		209,
		193,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		263,
		262,
		-1,
		231,
		234,
		-1,
		224,
		215,
		223,
		170,
		174,
		-1,
		-1,
		-1,
		272,
		253,
		247,
		246,
		244,
		239,
		236,
		222,
		206,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		244,
		236,
		229,
		-1,
		-1,
		231,
		214,
		195,
		193,
		-1,
		-1,
		-1,
		266,
		247,
		-1,
		-1,
		221,
		-1,
		-1,
		227,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		255,
		-1,
		-1,
		-1,
		217,
		213,
		214,
		-1,
		-1,
		-1,
		-1,
		277,
		278,
		301,
		265,
		-1,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		280,
		278,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		207,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		242,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		255,
		247,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		270,
		261,
		-1,
		-1,
		232,
		239,
		261,
		264,
		300,
		-1,
		251
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		179,
		181,
		147,
		141,
		180,
		151,
		157,
		168,
		-1,
		-1,
		-1,
		170,
		169,
		139,
		137,
		146,
		151,
		158,
		-1,
		181,
		-1,
		191,
		170,
		181,
		186,
		132,
		129,
		149,
		168,
		174,
		166,
		206,
		162,
		133,
		127,
		145,
		150,
		168,
		160,
		-1,
		133,
		123,
		145,
		149,
		161,
		144,
		-1,
		-1,
		127,
		128,
		134,
		146,
		151,
		156,
		-1,
		182,
		201,
		-1,
		-1,
		117,
		130,
		126,
		129,
		137,
		153,
		174,
		191,
		196,
		-1,
		-1,
		118,
		122,
		135,
		136,
		134,
		161,
		180,
		191,
		205,
		204,
		-1,
		106,
		124,
		133,
		142,
		148,
		137,
		141,
		159,
		190,
		196,
		199,
		-1,
		98,
		100,
		129,
		135,
		147,
		153,
		140,
		146,
		165,
		178,
		197,
		188,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		95,
		103,
		129,
		128,
		124,
		142,
		164,
		143,
		149,
		153,
		170,
		186,
		187,
		197,
		-1,
		-1,
		151,
		120,
		155,
		112,
		97,
		-1,
		91,
		110,
		116,
		120,
		125,
		133,
		161,
		159,
		-1,
		164,
		163,
		194,
		180,
		191,
		111,
		-1,
		-1,
		109,
		101,
		86,
		89,
		86,
		86,
		116,
		115,
		120,
		122,
		124,
		136,
		151,
		151,
		161,
		158,
		168,
		172,
		187,
		198,
		-1,
		-1,
		265,
		-1,
		-1,
		108,
		91,
		-1,
		74,
		81,
		81,
		98,
		88,
		109,
		124,
		128,
		136,
		139,
		127,
		146,
		143,
		167,
		163,
		155,
		180,
		184,
		190,
		208,
		206,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		67,
		70,
		76,
		100,
		110,
		-1,
		131,
		129,
		153,
		147,
		152,
		148,
		133,
		151,
		149,
		164,
		166,
		162,
		164,
		201,
		187,
		209,
		206,
		235,
		240,
		234,
		243,
		-1,
		116,
		112,
		108,
		115,
		64,
		-1,
		-1,
		104,
		-1,
		118,
		131,
		143,
		133,
		136,
		148,
		156,
		155,
		139,
		157,
		152,
		155,
		167,
		170,
		179,
		182,
		181,
		199,
		214,
		227,
		231,
		237,
		-1,
		166,
		-1,
		108,
		92,
		94,
		66,
		87,
		-1,
		124,
		119,
		139,
		145,
		145,
		-1,
		161,
		158,
		171,
		155,
		140,
		157,
		159,
		161,
		166,
		171,
		185,
		176,
		194,
		201,
		209,
		213,
		233,
		245,
		126,
		116,
		-1,
		98,
		103,
		62,
		69,
		84,
		162,
		146,
		-1,
		156,
		-1,
		163,
		176,
		-1,
		161,
		157,
		146,
		154,
		149,
		164,
		170,
		167,
		164,
		182,
		185,
		202,
		206,
		222,
		-1,
		-1,
		111,
		115,
		88,
		55,
		66,
		90,
		127,
		155,
		163,
		162,
		-1,
		156,
		182,
		179,
		169,
		156,
		146,
		147,
		155,
		168,
		147,
		166,
		169,
		191,
		219,
		197,
		209,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		65,
		52,
		68,
		110,
		192,
		185,
		173,
		141,
		141,
		135,
		-1,
		176,
		159,
		155,
		144,
		142,
		155,
		150,
		166,
		170,
		169,
		188,
		200,
		191,
		211,
		-1,
		-1,
		-1,
		0,
		6,
		52,
		55,
		89,
		99,
		174,
		160,
		165,
		140,
		133,
		127,
		179,
		176,
		143,
		151,
		143,
		132,
		146,
		154,
		158,
		167,
		176,
		182,
		206,
		206,
		212,
		-1,
		-1,
		84,
		74,
		58,
		60,
		74,
		80,
		87,
		119,
		165,
		162,
		-1,
		132,
		-1,
		121,
		129,
		128,
		134,
		146,
		132,
		137,
		148,
		160,
		173,
		169,
		176,
		211,
		211,
		196,
		216,
		219,
		-1,
		-1,
		-1,
		77,
		128,
		103,
		80,
		61,
		97,
		-1,
		132,
		133,
		-1,
		126,
		120,
		126,
		125,
		132,
		129,
		129,
		143,
		151,
		147,
		163,
		169,
		161,
		197,
		-1,
		204,
		198,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		68,
		120,
		-1,
		-1,
		117,
		110,
		-1,
		113,
		113,
		120,
		129,
		134,
		139,
		147,
		142,
		155,
		160,
		166,
		171,
		189,
		193,
		197,
		186,
		182,
		179,
		193,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		88,
		-1,
		125,
		117,
		108,
		102,
		108,
		126,
		124,
		144,
		136,
		150,
		150,
		156,
		164,
		149,
		152,
		168,
		166,
		184,
		192,
		184,
		178,
		177,
		189,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		103,
		-1,
		74,
		98,
		114,
		-1,
		142,
		121,
		144,
		122,
		136,
		132,
		170,
		171,
		149,
		154,
		162,
		172,
		174,
		163,
		174,
		166,
		188,
		188,
		172,
		173,
		182,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		77,
		90,
		101,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		146,
		144,
		160,
		151,
		157,
		173,
		176,
		178,
		168,
		157,
		163,
		160,
		182,
		168,
		166,
		185,
		201,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		168,
		152,
		157,
		-1,
		203,
		-1,
		176,
		178,
		172,
		157,
		154,
		165,
		163,
		174,
		191,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		134,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		184,
		164,
		158,
		157,
		198,
		198,
		184,
		170,
		163,
		160,
		157,
		170,
		190,
		181,
		193,
		-1,
		-1,
		-1,
		135,
		115,
		121,
		79,
		100,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		201,
		189,
		179,
		169,
		203,
		204,
		189,
		182,
		168,
		170,
		168,
		166,
		171,
		192,
		193,
		206,
		-1,
		-1,
		112,
		119,
		107,
		93,
		112,
		-1,
		-1,
		-1,
		160,
		176,
		168,
		139,
		190,
		-1,
		-1,
		181,
		179,
		189,
		185,
		172,
		192,
		195,
		181,
		165,
		180,
		192,
		200,
		205,
		-1,
		115,
		102,
		-1,
		-1,
		115,
		109,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		171,
		192,
		217,
		184,
		-1,
		189,
		190,
		176,
		190,
		197,
		183,
		178,
		172,
		175,
		193,
		210,
		-1,
		-1,
		129,
		-1,
		124,
		-1,
		-1,
		-1,
		-1,
		150,
		164,
		185,
		191,
		203,
		-1,
		198,
		192,
		178,
		195,
		196,
		193,
		184,
		176,
		181,
		178,
		191,
		205,
		209,
		152,
		-1,
		135,
		-1,
		-1,
		-1,
		168,
		183,
		245,
		222,
		195,
		199,
		192,
		186,
		186,
		202,
		204,
		215,
		183,
		179,
		180,
		184,
		183,
		200,
		210,
		-1,
		-1,
		135,
		152,
		187,
		176,
		180,
		272,
		-1,
		-1,
		208,
		199,
		190,
		193,
		196,
		199,
		189,
		186,
		191,
		196,
		184,
		193,
		211,
		215,
		-1,
		-1,
		-1,
		155,
		-1,
		170,
		-1,
		-1,
		195,
		279,
		226,
		208,
		204,
		202,
		195,
		204,
		199,
		194,
		204,
		213,
		205,
		186,
		197,
		220,
		209,
		247,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		184,
		159,
		174,
		220,
		215,
		216,
		241,
		238,
		-1,
		208,
		233,
		205,
		212,
		204,
		212,
		212,
		209,
		187,
		194,
		210,
		209,
		204,
		239,
		231,
		237,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		190,
		176,
		206,
		196,
		202,
		-1,
		-1,
		249,
		246,
		230,
		214,
		218,
		211,
		206,
		216,
		196,
		183,
		187,
		191,
		197,
		202,
		207,
		213,
		228,
		243,
		-1,
		160,
		241,
		234,
		217,
		225,
		256,
		-1,
		193,
		202,
		183,
		188,
		196,
		-1,
		-1,
		222,
		218,
		223,
		221,
		218,
		226,
		221,
		212,
		197,
		203,
		190,
		189,
		207,
		211,
		220,
		227,
		217,
		230,
		234,
		-1,
		174,
		217,
		211,
		214,
		238,
		252,
		-1,
		206,
		-1,
		-1,
		191,
		209,
		217,
		213,
		217,
		270,
		235,
		230,
		220,
		218,
		209,
		200,
		207,
		198,
		198,
		201,
		216,
		221,
		213,
		227,
		227,
		228,
		-1,
		209,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		207,
		-1,
		243,
		-1,
		236,
		240,
		243,
		246,
		234,
		221,
		213,
		205,
		221,
		196,
		206,
		202,
		203,
		212,
		223,
		235,
		234,
		235,
		283,
		238,
		205,
		196,
		243,
		258,
		262,
		-1,
		219,
		258,
		245,
		-1,
		216,
		-1,
		-1,
		-1,
		250,
		256,
		248,
		254,
		233,
		233,
		207,
		211,
		201,
		208,
		218,
		220,
		212,
		216,
		229,
		240,
		243,
		279,
		277,
		282,
		227,
		210,
		228,
		237,
		258,
		234,
		225,
		252,
		252,
		241,
		236,
		223,
		-1,
		-1,
		273,
		266,
		-1,
		-1,
		240,
		228,
		211,
		212,
		208,
		211,
		226,
		229,
		219,
		217,
		211,
		243,
		-1,
		279,
		278,
		267,
		264,
		240,
		231,
		218,
		229,
		-1,
		-1,
		237,
		253,
		266,
		270,
		283,
		308,
		-1,
		226,
		-1,
		-1,
		285,
		-1,
		-1,
		270,
		233,
		222,
		213,
		219,
		216,
		227,
		237,
		225,
		226,
		216,
		226,
		239,
		263,
		260,
		248,
		246,
		269,
		226,
		222,
		-1,
		252,
		240,
		246,
		253,
		270,
		297,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		268,
		266,
		255,
		-1,
		245,
		218,
		223,
		243,
		245,
		234,
		228,
		222,
		229,
		228,
		236,
		244,
		272,
		286,
		275,
		271,
		270,
		278,
		227,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		-1,
		277,
		252,
		-1,
		-1,
		263,
		256,
		244,
		232,
		222,
		232,
		236,
		240,
		232,
		225,
		220,
		231,
		223,
		227,
		244,
		-1,
		306,
		-1,
		258,
		251,
		266,
		281,
		289,
		-1,
		-1,
		-1,
		294,
		280,
		273,
		261,
		259,
		-1,
		297,
		281,
		262,
		-1,
		232,
		245,
		276,
		244,
		249,
		244,
		226,
		237,
		226,
		229,
		243,
		238,
		-1,
		-1,
		264,
		267,
		-1,
		-1,
		289,
		308,
		-1,
		285,
		274,
		259,
		251,
		-1,
		-1,
		269,
		265,
		-1,
		-1,
		233,
		258,
		247,
		255,
		250,
		230,
		236,
		239,
		228,
		232,
		244,
		-1,
		-1,
		271,
		272,
		277,
		-1,
		298,
		-1,
		309,
		-1,
		254,
		270,
		272,
		-1,
		-1,
		-1,
		271,
		234,
		255,
		265,
		259,
		257,
		248,
		234,
		241,
		239,
		235,
		246,
		-1,
		-1,
		-1,
		316,
		290,
		316,
		307,
		290,
		270,
		262,
		287,
		-1,
		258,
		-1,
		233,
		235,
		261,
		264,
		270,
		264,
		237,
		252,
		242,
		233,
		242,
		322,
		-1,
		292,
		325,
		289,
		276,
		259,
		263,
		279,
		-1,
		255,
		237,
		-1,
		265,
		255,
		286,
		271,
		252,
		239,
		246,
		246,
		239,
		-1,
		-1,
		-1,
		294,
		293,
		285,
		279,
		279,
		264,
		255,
		-1,
		267,
		249,
		228,
		245,
		245,
		236,
		244,
		276,
		272,
		259,
		259,
		251,
		-1,
		378,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		288,
		283,
		256,
		244,
		250,
		246,
		232,
		238,
		240,
		248,
		246,
		243,
		255,
		251,
		271,
		252,
		287,
		-1,
		385,
		-1,
		324,
		-1,
		-1,
		306,
		286,
		278,
		267,
		256,
		254,
		245,
		236,
		258,
		274,
		258,
		256,
		259,
		260,
		-1,
		379,
		378,
		-1,
		325,
		317,
		303,
		-1,
		296,
		-1,
		302,
		263,
		-1,
		265,
		245,
		-1,
		267,
		263,
		-1,
		-1,
		366,
		341,
		-1,
		-1,
		-1,
		326,
		306,
		297,
		281,
		-1,
		256,
		256,
		-1,
		-1,
		-1,
		351,
		350,
		-1,
		319,
		322,
		-1,
		312,
		303,
		311,
		258,
		262,
		-1,
		-1,
		-1,
		360,
		341,
		335,
		334,
		332,
		327,
		324,
		310,
		294,
		272,
		261,
		282,
		-1,
		-1,
		-1,
		332,
		324,
		317,
		-1,
		-1,
		319,
		302,
		283,
		281,
		-1,
		-1,
		-1,
		354,
		335,
		-1,
		-1,
		309,
		-1,
		-1,
		315,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		371,
		343,
		-1,
		-1,
		-1,
		305,
		301,
		302,
		-1,
		-1,
		-1,
		-1,
		365,
		366,
		389,
		353,
		-1,
		-1,
		-1,
		297,
		291,
		-1,
		-1,
		368,
		366,
		-1,
		-1,
		-1,
		325,
		309,
		-1,
		295,
		-1,
		-1,
		-1,
		316,
		-1,
		-1,
		328,
		-1,
		-1,
		-1,
		330,
		-1,
		330,
		305,
		312,
		-1,
		-1,
		-1,
		-1,
		343,
		335,
		343,
		-1,
		315,
		317,
		-1,
		365,
		-1,
		-1,
		358,
		349,
		-1,
		-1,
		320,
		327,
		349,
		352,
		388,
		-1,
		339
	],
	[
		-1,
		164,
		153,
		164,
		172,
		145,
		152,
		-1,
		173,
		175,
		141,
		135,
		174,
		145,
		151,
		162,
		-1,
		-1,
		-1,
		164,
		163,
		133,
		131,
		140,
		145,
		152,
		-1,
		175,
		-1,
		185,
		164,
		175,
		180,
		126,
		123,
		143,
		162,
		168,
		160,
		200,
		156,
		127,
		121,
		139,
		144,
		162,
		154,
		-1,
		127,
		117,
		139,
		143,
		155,
		138,
		-1,
		-1,
		121,
		122,
		128,
		140,
		145,
		150,
		-1,
		176,
		195,
		-1,
		-1,
		111,
		124,
		120,
		123,
		131,
		147,
		168,
		185,
		190,
		-1,
		-1,
		112,
		116,
		129,
		130,
		128,
		155,
		174,
		185,
		199,
		198,
		-1,
		100,
		118,
		127,
		136,
		142,
		131,
		135,
		153,
		184,
		190,
		193,
		-1,
		92,
		94,
		123,
		129,
		141,
		147,
		134,
		140,
		159,
		172,
		191,
		182,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		89,
		97,
		123,
		122,
		118,
		136,
		158,
		137,
		143,
		147,
		164,
		180,
		181,
		191,
		-1,
		-1,
		145,
		114,
		149,
		106,
		91,
		-1,
		85,
		104,
		110,
		114,
		119,
		127,
		155,
		153,
		-1,
		158,
		157,
		188,
		174,
		185,
		105,
		-1,
		-1,
		103,
		95,
		80,
		83,
		80,
		80,
		110,
		109,
		114,
		116,
		118,
		130,
		145,
		145,
		155,
		152,
		162,
		166,
		181,
		192,
		-1,
		-1,
		259,
		-1,
		-1,
		102,
		85,
		-1,
		68,
		75,
		75,
		92,
		82,
		103,
		118,
		122,
		130,
		133,
		121,
		140,
		137,
		161,
		157,
		149,
		174,
		178,
		184,
		202,
		200,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		61,
		64,
		70,
		94,
		104,
		-1,
		125,
		123,
		147,
		141,
		146,
		142,
		127,
		145,
		143,
		158,
		160,
		156,
		158,
		195,
		181,
		203,
		200,
		229,
		234,
		228,
		237,
		-1,
		110,
		106,
		102,
		109,
		58,
		-1,
		-1,
		98,
		-1,
		112,
		125,
		137,
		127,
		130,
		142,
		150,
		149,
		133,
		151,
		146,
		149,
		161,
		164,
		173,
		176,
		175,
		193,
		208,
		221,
		225,
		231,
		-1,
		160,
		-1,
		102,
		86,
		88,
		60,
		81,
		-1,
		118,
		113,
		133,
		139,
		139,
		-1,
		155,
		152,
		165,
		149,
		134,
		151,
		153,
		155,
		160,
		165,
		179,
		170,
		188,
		195,
		203,
		207,
		227,
		239,
		120,
		110,
		-1,
		92,
		97,
		56,
		63,
		78,
		156,
		140,
		-1,
		150,
		-1,
		157,
		170,
		-1,
		155,
		151,
		140,
		148,
		143,
		158,
		164,
		161,
		158,
		176,
		179,
		196,
		200,
		216,
		-1,
		-1,
		105,
		109,
		82,
		49,
		60,
		84,
		121,
		149,
		157,
		156,
		-1,
		150,
		176,
		173,
		163,
		150,
		140,
		141,
		149,
		162,
		141,
		160,
		163,
		185,
		213,
		191,
		203,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		59,
		46,
		62,
		104,
		186,
		179,
		167,
		135,
		135,
		129,
		-1,
		170,
		153,
		149,
		138,
		136,
		149,
		144,
		160,
		164,
		163,
		182,
		194,
		185,
		205,
		-1,
		-1,
		-1,
		11,
		0,
		46,
		49,
		83,
		93,
		168,
		154,
		159,
		134,
		127,
		121,
		173,
		170,
		137,
		145,
		137,
		126,
		140,
		148,
		152,
		161,
		170,
		176,
		200,
		200,
		206,
		-1,
		-1,
		78,
		68,
		52,
		54,
		68,
		74,
		81,
		113,
		159,
		156,
		-1,
		126,
		-1,
		115,
		123,
		122,
		128,
		140,
		126,
		131,
		142,
		154,
		167,
		163,
		170,
		205,
		205,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		71,
		122,
		97,
		74,
		55,
		91,
		-1,
		126,
		127,
		-1,
		120,
		114,
		120,
		119,
		126,
		123,
		123,
		137,
		145,
		141,
		157,
		163,
		155,
		191,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		62,
		114,
		-1,
		-1,
		111,
		104,
		-1,
		107,
		107,
		114,
		123,
		128,
		133,
		141,
		136,
		149,
		154,
		160,
		165,
		183,
		187,
		191,
		180,
		176,
		173,
		187,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		82,
		-1,
		119,
		111,
		102,
		96,
		102,
		120,
		118,
		138,
		130,
		144,
		144,
		150,
		158,
		143,
		146,
		162,
		160,
		178,
		186,
		178,
		172,
		171,
		183,
		-1,
		168,
		154,
		125,
		-1,
		-1,
		97,
		-1,
		68,
		92,
		108,
		-1,
		136,
		115,
		138,
		116,
		130,
		126,
		164,
		165,
		143,
		148,
		156,
		166,
		168,
		157,
		168,
		160,
		182,
		182,
		166,
		167,
		176,
		-1,
		174,
		161,
		119,
		115,
		104,
		124,
		71,
		84,
		95,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		140,
		138,
		154,
		145,
		151,
		167,
		170,
		172,
		162,
		151,
		157,
		154,
		176,
		162,
		160,
		179,
		195,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		90,
		77,
		71,
		-1,
		112,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		162,
		146,
		151,
		-1,
		197,
		-1,
		170,
		172,
		166,
		151,
		148,
		159,
		157,
		168,
		185,
		-1,
		124,
		109,
		102,
		92,
		106,
		77,
		-1,
		128,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		178,
		158,
		152,
		151,
		192,
		192,
		178,
		164,
		157,
		154,
		151,
		164,
		184,
		175,
		187,
		-1,
		-1,
		-1,
		129,
		109,
		115,
		73,
		94,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		195,
		183,
		173,
		163,
		197,
		198,
		183,
		176,
		162,
		164,
		162,
		160,
		165,
		186,
		187,
		200,
		-1,
		-1,
		106,
		113,
		101,
		87,
		106,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		184,
		-1,
		-1,
		175,
		173,
		183,
		179,
		166,
		186,
		189,
		175,
		159,
		174,
		186,
		194,
		199,
		-1,
		109,
		96,
		-1,
		-1,
		109,
		103,
		-1,
		-1,
		-1,
		-1,
		187,
		153,
		165,
		186,
		211,
		178,
		-1,
		183,
		184,
		170,
		184,
		191,
		177,
		172,
		166,
		169,
		187,
		204,
		-1,
		-1,
		123,
		-1,
		118,
		-1,
		-1,
		-1,
		-1,
		144,
		158,
		179,
		185,
		197,
		-1,
		192,
		186,
		172,
		189,
		190,
		187,
		178,
		170,
		175,
		172,
		185,
		199,
		203,
		146,
		-1,
		129,
		-1,
		-1,
		-1,
		162,
		177,
		239,
		216,
		189,
		193,
		186,
		180,
		180,
		196,
		198,
		209,
		177,
		173,
		174,
		178,
		177,
		194,
		204,
		-1,
		-1,
		129,
		146,
		181,
		170,
		174,
		266,
		-1,
		-1,
		202,
		193,
		184,
		187,
		190,
		193,
		183,
		180,
		185,
		190,
		178,
		187,
		205,
		209,
		-1,
		-1,
		-1,
		149,
		-1,
		164,
		-1,
		-1,
		189,
		273,
		220,
		202,
		198,
		196,
		189,
		198,
		193,
		188,
		198,
		207,
		199,
		180,
		191,
		214,
		203,
		241,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		178,
		153,
		168,
		214,
		209,
		210,
		235,
		232,
		-1,
		202,
		227,
		199,
		206,
		198,
		206,
		206,
		203,
		181,
		188,
		204,
		203,
		198,
		233,
		225,
		231,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		184,
		170,
		200,
		190,
		196,
		-1,
		-1,
		243,
		240,
		224,
		208,
		212,
		205,
		200,
		210,
		190,
		177,
		181,
		185,
		191,
		196,
		201,
		207,
		222,
		237,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		187,
		196,
		177,
		182,
		190,
		-1,
		-1,
		216,
		212,
		217,
		215,
		212,
		220,
		215,
		206,
		191,
		197,
		184,
		183,
		201,
		205,
		214,
		221,
		211,
		224,
		228,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		200,
		-1,
		-1,
		185,
		203,
		211,
		207,
		211,
		264,
		229,
		224,
		214,
		212,
		203,
		194,
		201,
		192,
		192,
		195,
		210,
		215,
		207,
		221,
		221,
		222,
		-1,
		203,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		201,
		-1,
		237,
		-1,
		230,
		234,
		237,
		240,
		228,
		215,
		207,
		199,
		215,
		190,
		200,
		196,
		197,
		206,
		217,
		229,
		228,
		229,
		277,
		232,
		199,
		190,
		237,
		252,
		256,
		-1,
		213,
		252,
		239,
		-1,
		210,
		-1,
		-1,
		-1,
		244,
		250,
		242,
		248,
		227,
		227,
		201,
		205,
		195,
		202,
		212,
		214,
		206,
		210,
		223,
		234,
		237,
		273,
		271,
		276,
		221,
		204,
		222,
		231,
		252,
		228,
		219,
		246,
		246,
		235,
		230,
		217,
		-1,
		-1,
		267,
		260,
		-1,
		-1,
		234,
		222,
		205,
		206,
		202,
		205,
		220,
		223,
		213,
		211,
		205,
		237,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		212,
		223,
		-1,
		-1,
		231,
		247,
		260,
		264,
		277,
		302,
		-1,
		220,
		-1,
		-1,
		279,
		-1,
		-1,
		264,
		227,
		216,
		207,
		213,
		210,
		221,
		231,
		219,
		220,
		210,
		220,
		233,
		257,
		254,
		242,
		240,
		263,
		220,
		216,
		-1,
		246,
		234,
		240,
		247,
		264,
		291,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		262,
		260,
		249,
		-1,
		239,
		212,
		217,
		237,
		239,
		228,
		222,
		216,
		223,
		222,
		230,
		238,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		-1,
		271,
		246,
		-1,
		-1,
		257,
		250,
		238,
		226,
		216,
		226,
		230,
		234,
		226,
		219,
		214,
		225,
		217,
		221,
		238,
		-1,
		300,
		-1,
		252,
		245,
		260,
		275,
		283,
		-1,
		-1,
		-1,
		288,
		274,
		267,
		255,
		253,
		-1,
		291,
		275,
		256,
		-1,
		226,
		239,
		270,
		238,
		243,
		238,
		220,
		231,
		220,
		223,
		237,
		232,
		-1,
		-1,
		258,
		261,
		-1,
		-1,
		283,
		302,
		-1,
		279,
		268,
		253,
		245,
		-1,
		-1,
		263,
		259,
		-1,
		-1,
		227,
		252,
		241,
		249,
		244,
		224,
		230,
		233,
		222,
		226,
		238,
		-1,
		-1,
		265,
		266,
		271,
		-1,
		292,
		-1,
		303,
		-1,
		248,
		264,
		266,
		-1,
		-1,
		-1,
		265,
		228,
		249,
		259,
		253,
		251,
		242,
		228,
		235,
		233,
		229,
		240,
		-1,
		-1,
		-1,
		310,
		284,
		310,
		301,
		284,
		264,
		256,
		281,
		-1,
		252,
		-1,
		227,
		229,
		255,
		258,
		264,
		258,
		231,
		246,
		236,
		227,
		236,
		316,
		-1,
		286,
		319,
		283,
		270,
		253,
		257,
		273,
		-1,
		249,
		231,
		-1,
		259,
		249,
		280,
		265,
		246,
		233,
		240,
		240,
		233,
		-1,
		-1,
		-1,
		288,
		287,
		279,
		273,
		273,
		258,
		249,
		-1,
		261,
		243,
		222,
		239,
		239,
		230,
		238,
		270,
		266,
		253,
		253,
		245,
		-1,
		372,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		282,
		277,
		250,
		238,
		244,
		240,
		226,
		232,
		234,
		242,
		240,
		237,
		249,
		245,
		265,
		246,
		281,
		-1,
		379,
		-1,
		318,
		-1,
		-1,
		300,
		280,
		272,
		261,
		250,
		248,
		239,
		230,
		252,
		268,
		252,
		250,
		253,
		254,
		-1,
		373,
		372,
		-1,
		319,
		311,
		297,
		-1,
		290,
		-1,
		296,
		257,
		-1,
		259,
		239,
		-1,
		261,
		257,
		-1,
		-1,
		360,
		335,
		-1,
		-1,
		-1,
		320,
		300,
		291,
		275,
		-1,
		250,
		250,
		-1,
		-1,
		-1,
		345,
		344,
		-1,
		313,
		316,
		-1,
		306,
		297,
		305,
		252,
		256,
		-1,
		-1,
		-1,
		354,
		335,
		329,
		328,
		326,
		321,
		318,
		304,
		288,
		266,
		255,
		276,
		-1,
		-1,
		-1,
		326,
		318,
		311,
		-1,
		-1,
		313,
		296,
		277,
		275,
		-1,
		-1,
		-1,
		348,
		329,
		-1,
		-1,
		303,
		-1,
		-1,
		309,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		365,
		337,
		-1,
		-1,
		-1,
		299,
		295,
		296,
		-1,
		-1,
		-1,
		-1,
		359,
		360,
		383,
		347,
		-1,
		-1,
		-1,
		291,
		285,
		-1,
		-1,
		362,
		360,
		-1,
		-1,
		-1,
		319,
		303,
		-1,
		289,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		322,
		-1,
		-1,
		-1,
		324,
		-1,
		324,
		299,
		306,
		-1,
		-1,
		-1,
		-1,
		337,
		329,
		337,
		-1,
		309,
		311,
		-1,
		359,
		-1,
		-1,
		352,
		343,
		-1,
		-1,
		314,
		321,
		343,
		346,
		382,
		-1,
		333
	],
	[
		-1,
		156,
		145,
		156,
		164,
		137,
		144,
		-1,
		165,
		167,
		133,
		127,
		166,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		156,
		155,
		125,
		123,
		132,
		137,
		144,
		-1,
		167,
		-1,
		177,
		156,
		167,
		172,
		118,
		115,
		135,
		154,
		160,
		152,
		192,
		148,
		119,
		113,
		131,
		136,
		154,
		146,
		-1,
		119,
		109,
		131,
		135,
		147,
		130,
		-1,
		-1,
		113,
		114,
		120,
		132,
		137,
		142,
		-1,
		168,
		187,
		-1,
		-1,
		103,
		116,
		112,
		115,
		123,
		139,
		160,
		177,
		182,
		-1,
		-1,
		104,
		108,
		121,
		122,
		120,
		147,
		166,
		177,
		191,
		190,
		-1,
		92,
		110,
		119,
		128,
		134,
		123,
		127,
		145,
		176,
		182,
		185,
		-1,
		84,
		86,
		115,
		121,
		133,
		139,
		126,
		132,
		151,
		164,
		183,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		81,
		89,
		115,
		114,
		110,
		128,
		150,
		129,
		135,
		139,
		156,
		172,
		173,
		183,
		-1,
		-1,
		137,
		106,
		141,
		98,
		83,
		-1,
		77,
		96,
		102,
		106,
		111,
		119,
		147,
		145,
		-1,
		150,
		149,
		180,
		166,
		177,
		97,
		-1,
		-1,
		95,
		87,
		72,
		75,
		72,
		72,
		102,
		101,
		106,
		108,
		110,
		122,
		137,
		137,
		147,
		144,
		154,
		158,
		173,
		184,
		-1,
		-1,
		251,
		-1,
		-1,
		94,
		77,
		-1,
		60,
		67,
		67,
		84,
		74,
		95,
		110,
		114,
		122,
		125,
		113,
		132,
		129,
		153,
		149,
		141,
		166,
		170,
		176,
		194,
		192,
		-1,
		250,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		53,
		56,
		62,
		86,
		96,
		-1,
		117,
		115,
		139,
		133,
		138,
		134,
		119,
		137,
		135,
		150,
		152,
		148,
		150,
		187,
		173,
		195,
		192,
		221,
		226,
		220,
		229,
		-1,
		102,
		98,
		94,
		101,
		50,
		-1,
		-1,
		90,
		-1,
		104,
		117,
		129,
		119,
		122,
		134,
		142,
		141,
		125,
		143,
		138,
		141,
		153,
		156,
		165,
		168,
		167,
		185,
		200,
		213,
		217,
		223,
		-1,
		152,
		-1,
		94,
		78,
		80,
		52,
		73,
		-1,
		110,
		105,
		125,
		131,
		131,
		-1,
		147,
		144,
		157,
		141,
		126,
		143,
		145,
		147,
		152,
		157,
		171,
		162,
		180,
		187,
		195,
		199,
		219,
		231,
		112,
		102,
		-1,
		84,
		89,
		48,
		55,
		70,
		148,
		132,
		-1,
		142,
		-1,
		149,
		162,
		-1,
		147,
		143,
		132,
		140,
		135,
		150,
		156,
		153,
		150,
		168,
		171,
		188,
		192,
		208,
		-1,
		-1,
		97,
		101,
		74,
		41,
		52,
		76,
		113,
		141,
		149,
		148,
		-1,
		142,
		168,
		165,
		155,
		142,
		132,
		133,
		141,
		154,
		133,
		152,
		155,
		177,
		205,
		183,
		195,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		51,
		38,
		54,
		96,
		178,
		171,
		159,
		127,
		127,
		121,
		-1,
		162,
		145,
		141,
		130,
		128,
		141,
		136,
		152,
		156,
		155,
		174,
		186,
		177,
		197,
		-1,
		-1,
		-1,
		48,
		37,
		0,
		41,
		75,
		85,
		160,
		146,
		151,
		126,
		119,
		113,
		165,
		162,
		129,
		137,
		129,
		118,
		132,
		140,
		144,
		153,
		162,
		168,
		192,
		192,
		198,
		-1,
		-1,
		70,
		60,
		44,
		46,
		60,
		66,
		73,
		105,
		151,
		148,
		-1,
		118,
		-1,
		107,
		115,
		114,
		120,
		132,
		118,
		123,
		134,
		146,
		159,
		155,
		162,
		197,
		197,
		182,
		202,
		205,
		-1,
		-1,
		-1,
		63,
		114,
		89,
		66,
		47,
		83,
		-1,
		118,
		119,
		-1,
		112,
		106,
		112,
		111,
		118,
		115,
		115,
		129,
		137,
		133,
		149,
		155,
		147,
		183,
		-1,
		190,
		184,
		192,
		182,
		170,
		-1,
		-1,
		-1,
		112,
		91,
		84,
		104,
		54,
		106,
		-1,
		-1,
		103,
		96,
		-1,
		99,
		99,
		106,
		115,
		120,
		125,
		133,
		128,
		141,
		146,
		152,
		157,
		175,
		179,
		183,
		172,
		168,
		165,
		179,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		74,
		-1,
		111,
		103,
		94,
		88,
		94,
		112,
		110,
		130,
		122,
		136,
		136,
		142,
		150,
		135,
		138,
		154,
		152,
		170,
		178,
		170,
		164,
		163,
		175,
		-1,
		160,
		146,
		117,
		-1,
		-1,
		89,
		-1,
		60,
		84,
		100,
		-1,
		128,
		107,
		130,
		108,
		122,
		118,
		156,
		157,
		135,
		140,
		148,
		158,
		160,
		149,
		160,
		152,
		174,
		174,
		158,
		159,
		168,
		-1,
		166,
		153,
		111,
		107,
		96,
		116,
		63,
		76,
		87,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		132,
		130,
		146,
		137,
		143,
		159,
		162,
		164,
		154,
		143,
		149,
		146,
		168,
		154,
		152,
		171,
		187,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		82,
		69,
		63,
		-1,
		104,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		154,
		138,
		143,
		-1,
		189,
		-1,
		162,
		164,
		158,
		143,
		140,
		151,
		149,
		160,
		177,
		-1,
		116,
		101,
		94,
		84,
		98,
		69,
		-1,
		120,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		170,
		150,
		144,
		143,
		184,
		184,
		170,
		156,
		149,
		146,
		143,
		156,
		176,
		167,
		179,
		-1,
		-1,
		-1,
		121,
		101,
		107,
		65,
		86,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		187,
		175,
		165,
		155,
		189,
		190,
		175,
		168,
		154,
		156,
		154,
		152,
		157,
		178,
		179,
		192,
		-1,
		-1,
		98,
		105,
		93,
		79,
		98,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		176,
		-1,
		-1,
		167,
		165,
		175,
		171,
		158,
		178,
		181,
		167,
		151,
		166,
		178,
		186,
		191,
		-1,
		101,
		88,
		-1,
		-1,
		101,
		95,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		157,
		178,
		203,
		170,
		-1,
		175,
		176,
		162,
		176,
		183,
		169,
		164,
		158,
		161,
		179,
		196,
		-1,
		-1,
		115,
		-1,
		110,
		-1,
		-1,
		-1,
		-1,
		136,
		150,
		171,
		177,
		189,
		-1,
		184,
		178,
		164,
		181,
		182,
		179,
		170,
		162,
		167,
		164,
		177,
		191,
		195,
		138,
		-1,
		121,
		-1,
		-1,
		-1,
		154,
		169,
		231,
		208,
		181,
		185,
		178,
		172,
		172,
		188,
		190,
		201,
		169,
		165,
		166,
		170,
		169,
		186,
		196,
		-1,
		-1,
		121,
		138,
		173,
		162,
		166,
		258,
		-1,
		-1,
		194,
		185,
		176,
		179,
		182,
		185,
		175,
		172,
		177,
		182,
		170,
		179,
		197,
		201,
		-1,
		-1,
		-1,
		141,
		-1,
		156,
		-1,
		-1,
		181,
		265,
		212,
		194,
		190,
		188,
		181,
		190,
		185,
		180,
		190,
		199,
		191,
		172,
		183,
		206,
		195,
		233,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		170,
		145,
		160,
		206,
		201,
		202,
		227,
		224,
		-1,
		194,
		219,
		191,
		198,
		190,
		198,
		198,
		195,
		173,
		180,
		196,
		195,
		190,
		225,
		217,
		223,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		176,
		162,
		192,
		182,
		188,
		-1,
		-1,
		235,
		232,
		216,
		200,
		204,
		197,
		192,
		202,
		182,
		169,
		173,
		177,
		183,
		188,
		193,
		199,
		214,
		229,
		-1,
		146,
		227,
		220,
		203,
		211,
		242,
		-1,
		179,
		188,
		169,
		174,
		182,
		-1,
		-1,
		208,
		204,
		209,
		207,
		204,
		212,
		207,
		198,
		183,
		189,
		176,
		175,
		193,
		197,
		206,
		213,
		203,
		216,
		220,
		-1,
		160,
		203,
		197,
		200,
		224,
		238,
		-1,
		192,
		-1,
		-1,
		177,
		195,
		203,
		199,
		203,
		256,
		221,
		216,
		206,
		204,
		195,
		186,
		193,
		184,
		184,
		187,
		202,
		207,
		199,
		213,
		213,
		214,
		-1,
		195,
		183,
		191,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		193,
		-1,
		229,
		-1,
		222,
		226,
		229,
		232,
		220,
		207,
		199,
		191,
		207,
		182,
		192,
		188,
		189,
		198,
		209,
		221,
		220,
		221,
		269,
		224,
		191,
		182,
		229,
		244,
		248,
		-1,
		205,
		244,
		231,
		-1,
		202,
		-1,
		-1,
		-1,
		236,
		242,
		234,
		240,
		219,
		219,
		193,
		197,
		187,
		194,
		204,
		206,
		198,
		202,
		215,
		226,
		229,
		265,
		263,
		268,
		213,
		196,
		214,
		223,
		244,
		220,
		211,
		238,
		238,
		227,
		222,
		209,
		-1,
		-1,
		259,
		252,
		-1,
		-1,
		226,
		214,
		197,
		198,
		194,
		197,
		212,
		215,
		205,
		203,
		197,
		229,
		-1,
		265,
		264,
		253,
		250,
		226,
		217,
		204,
		215,
		-1,
		-1,
		223,
		239,
		252,
		256,
		269,
		294,
		-1,
		212,
		-1,
		-1,
		271,
		-1,
		-1,
		256,
		219,
		208,
		199,
		205,
		202,
		213,
		223,
		211,
		212,
		202,
		212,
		225,
		249,
		246,
		234,
		232,
		255,
		212,
		208,
		-1,
		238,
		226,
		232,
		239,
		256,
		283,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		254,
		252,
		241,
		-1,
		231,
		204,
		209,
		229,
		231,
		220,
		214,
		208,
		215,
		214,
		222,
		230,
		258,
		272,
		261,
		257,
		256,
		264,
		213,
		230,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		-1,
		263,
		238,
		-1,
		-1,
		249,
		242,
		230,
		218,
		208,
		218,
		222,
		226,
		218,
		211,
		206,
		217,
		209,
		213,
		230,
		-1,
		292,
		-1,
		244,
		237,
		252,
		267,
		275,
		-1,
		-1,
		-1,
		280,
		266,
		259,
		247,
		245,
		-1,
		283,
		267,
		248,
		-1,
		218,
		231,
		262,
		230,
		235,
		230,
		212,
		223,
		212,
		215,
		229,
		224,
		-1,
		-1,
		250,
		253,
		-1,
		-1,
		275,
		294,
		-1,
		271,
		260,
		245,
		237,
		-1,
		-1,
		255,
		251,
		-1,
		-1,
		219,
		244,
		233,
		241,
		236,
		216,
		222,
		225,
		214,
		218,
		230,
		-1,
		-1,
		257,
		258,
		263,
		-1,
		284,
		-1,
		295,
		-1,
		240,
		256,
		258,
		-1,
		-1,
		-1,
		257,
		220,
		241,
		251,
		245,
		243,
		234,
		220,
		227,
		225,
		221,
		232,
		-1,
		-1,
		-1,
		302,
		276,
		302,
		293,
		276,
		256,
		248,
		273,
		-1,
		244,
		-1,
		219,
		221,
		247,
		250,
		256,
		250,
		223,
		238,
		228,
		219,
		228,
		308,
		-1,
		278,
		311,
		275,
		262,
		245,
		249,
		265,
		-1,
		241,
		223,
		-1,
		251,
		241,
		272,
		257,
		238,
		225,
		232,
		232,
		225,
		-1,
		-1,
		-1,
		280,
		279,
		271,
		265,
		265,
		250,
		241,
		-1,
		253,
		235,
		214,
		231,
		231,
		222,
		230,
		262,
		258,
		245,
		245,
		237,
		-1,
		364,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		274,
		269,
		242,
		230,
		236,
		232,
		218,
		224,
		226,
		234,
		232,
		229,
		241,
		237,
		257,
		238,
		273,
		-1,
		371,
		-1,
		310,
		-1,
		-1,
		292,
		272,
		264,
		253,
		242,
		240,
		231,
		222,
		244,
		260,
		244,
		242,
		245,
		246,
		-1,
		365,
		364,
		-1,
		311,
		303,
		289,
		-1,
		282,
		-1,
		288,
		249,
		-1,
		251,
		231,
		-1,
		253,
		249,
		-1,
		-1,
		352,
		327,
		-1,
		-1,
		-1,
		312,
		292,
		283,
		267,
		-1,
		242,
		242,
		-1,
		-1,
		-1,
		337,
		336,
		-1,
		305,
		308,
		-1,
		298,
		289,
		297,
		244,
		248,
		-1,
		-1,
		-1,
		346,
		327,
		321,
		320,
		318,
		313,
		310,
		296,
		280,
		258,
		247,
		268,
		-1,
		-1,
		-1,
		318,
		310,
		303,
		-1,
		-1,
		305,
		288,
		269,
		267,
		-1,
		-1,
		-1,
		340,
		321,
		-1,
		-1,
		295,
		-1,
		-1,
		301,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		357,
		329,
		-1,
		-1,
		-1,
		291,
		287,
		288,
		-1,
		-1,
		-1,
		-1,
		351,
		352,
		375,
		339,
		-1,
		-1,
		-1,
		283,
		277,
		-1,
		-1,
		354,
		352,
		-1,
		-1,
		-1,
		311,
		295,
		-1,
		281,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		316,
		-1,
		316,
		291,
		298,
		-1,
		-1,
		-1,
		-1,
		329,
		321,
		329,
		-1,
		301,
		303,
		-1,
		351,
		-1,
		-1,
		344,
		335,
		-1,
		-1,
		306,
		313,
		335,
		338,
		374,
		-1,
		325
	],
	[
		-1,
		124,
		113,
		124,
		132,
		105,
		112,
		-1,
		133,
		135,
		101,
		95,
		134,
		105,
		111,
		122,
		-1,
		-1,
		-1,
		124,
		123,
		93,
		91,
		100,
		105,
		112,
		-1,
		135,
		-1,
		145,
		124,
		135,
		140,
		86,
		83,
		103,
		122,
		128,
		120,
		160,
		116,
		87,
		81,
		99,
		104,
		122,
		114,
		-1,
		87,
		77,
		99,
		103,
		115,
		98,
		-1,
		-1,
		81,
		82,
		88,
		100,
		105,
		110,
		-1,
		136,
		155,
		-1,
		-1,
		71,
		84,
		80,
		83,
		91,
		107,
		128,
		145,
		150,
		-1,
		-1,
		72,
		76,
		89,
		90,
		88,
		115,
		134,
		145,
		159,
		158,
		-1,
		60,
		78,
		87,
		96,
		102,
		91,
		95,
		113,
		144,
		150,
		153,
		-1,
		52,
		54,
		83,
		89,
		101,
		107,
		94,
		100,
		119,
		132,
		151,
		142,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		55,
		49,
		57,
		83,
		82,
		78,
		96,
		118,
		97,
		103,
		107,
		124,
		140,
		141,
		151,
		-1,
		-1,
		105,
		74,
		109,
		66,
		51,
		-1,
		45,
		64,
		70,
		74,
		79,
		87,
		115,
		113,
		-1,
		118,
		117,
		148,
		134,
		145,
		65,
		-1,
		-1,
		63,
		55,
		40,
		43,
		40,
		40,
		70,
		69,
		74,
		76,
		78,
		90,
		105,
		105,
		115,
		112,
		122,
		126,
		141,
		152,
		-1,
		-1,
		212,
		-1,
		-1,
		62,
		45,
		-1,
		28,
		35,
		35,
		52,
		42,
		63,
		78,
		82,
		90,
		93,
		81,
		100,
		97,
		121,
		117,
		109,
		134,
		138,
		137,
		158,
		153,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		40,
		21,
		24,
		30,
		54,
		64,
		-1,
		85,
		83,
		107,
		101,
		106,
		102,
		87,
		105,
		103,
		118,
		117,
		116,
		118,
		155,
		134,
		156,
		153,
		182,
		187,
		181,
		190,
		-1,
		70,
		66,
		62,
		69,
		18,
		-1,
		-1,
		58,
		-1,
		72,
		85,
		97,
		87,
		90,
		102,
		110,
		109,
		93,
		111,
		106,
		106,
		114,
		123,
		133,
		129,
		128,
		146,
		161,
		174,
		178,
		184,
		-1,
		120,
		-1,
		62,
		46,
		48,
		20,
		41,
		-1,
		78,
		73,
		93,
		99,
		99,
		-1,
		115,
		112,
		125,
		109,
		94,
		111,
		110,
		108,
		113,
		118,
		132,
		123,
		141,
		148,
		156,
		160,
		180,
		192,
		80,
		70,
		-1,
		52,
		57,
		16,
		24,
		43,
		116,
		100,
		-1,
		110,
		-1,
		117,
		130,
		-1,
		115,
		111,
		100,
		101,
		96,
		111,
		117,
		114,
		111,
		129,
		132,
		149,
		153,
		169,
		-1,
		-1,
		65,
		69,
		58,
		9,
		28,
		52,
		89,
		109,
		113,
		112,
		-1,
		103,
		133,
		130,
		116,
		103,
		93,
		94,
		102,
		115,
		94,
		113,
		116,
		138,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		90,
		-1,
		-1,
		35,
		6,
		30,
		72,
		142,
		135,
		123,
		88,
		88,
		82,
		-1,
		123,
		106,
		102,
		91,
		89,
		102,
		97,
		113,
		117,
		116,
		135,
		147,
		138,
		158,
		-1,
		-1,
		-1,
		65,
		54,
		55,
		0,
		36,
		61,
		121,
		107,
		112,
		87,
		80,
		74,
		126,
		123,
		90,
		98,
		90,
		79,
		93,
		101,
		105,
		114,
		123,
		129,
		153,
		153,
		159,
		-1,
		-1,
		72,
		62,
		46,
		48,
		45,
		27,
		34,
		66,
		112,
		109,
		-1,
		79,
		-1,
		68,
		76,
		75,
		81,
		93,
		79,
		84,
		95,
		107,
		120,
		116,
		123,
		158,
		158,
		143,
		163,
		166,
		-1,
		-1,
		-1,
		65,
		75,
		50,
		27,
		8,
		44,
		-1,
		79,
		80,
		-1,
		73,
		67,
		73,
		72,
		79,
		76,
		76,
		90,
		98,
		94,
		110,
		116,
		108,
		144,
		-1,
		151,
		145,
		153,
		143,
		131,
		-1,
		-1,
		-1,
		73,
		52,
		45,
		65,
		15,
		67,
		-1,
		-1,
		64,
		57,
		-1,
		60,
		60,
		67,
		76,
		81,
		86,
		94,
		89,
		102,
		107,
		113,
		118,
		136,
		140,
		144,
		133,
		129,
		126,
		140,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		18,
		35,
		-1,
		72,
		64,
		55,
		49,
		55,
		73,
		71,
		91,
		83,
		97,
		97,
		103,
		111,
		96,
		99,
		115,
		113,
		131,
		139,
		131,
		125,
		124,
		136,
		-1,
		121,
		107,
		78,
		-1,
		-1,
		50,
		-1,
		21,
		45,
		61,
		-1,
		89,
		68,
		91,
		69,
		83,
		79,
		117,
		118,
		96,
		101,
		109,
		119,
		121,
		110,
		121,
		113,
		135,
		135,
		119,
		120,
		129,
		-1,
		127,
		114,
		72,
		68,
		57,
		77,
		24,
		37,
		48,
		-1,
		-1,
		133,
		-1,
		67,
		84,
		93,
		91,
		107,
		98,
		104,
		120,
		123,
		125,
		115,
		104,
		110,
		107,
		129,
		115,
		113,
		132,
		148,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		43,
		30,
		24,
		-1,
		65,
		-1,
		111,
		101,
		85,
		70,
		103,
		-1,
		115,
		99,
		104,
		-1,
		150,
		-1,
		123,
		125,
		119,
		104,
		101,
		112,
		110,
		121,
		138,
		-1,
		77,
		62,
		55,
		45,
		59,
		30,
		-1,
		85,
		-1,
		-1,
		98,
		92,
		92,
		76,
		79,
		131,
		111,
		105,
		104,
		145,
		145,
		131,
		117,
		110,
		107,
		104,
		117,
		137,
		128,
		140,
		-1,
		-1,
		-1,
		82,
		68,
		72,
		32,
		51,
		-1,
		-1,
		160,
		115,
		101,
		-1,
		85,
		148,
		136,
		126,
		116,
		150,
		151,
		136,
		129,
		115,
		117,
		115,
		113,
		118,
		139,
		140,
		153,
		-1,
		-1,
		65,
		70,
		58,
		44,
		63,
		-1,
		-1,
		-1,
		107,
		123,
		115,
		86,
		137,
		-1,
		-1,
		128,
		126,
		136,
		132,
		119,
		139,
		142,
		128,
		112,
		127,
		139,
		147,
		152,
		-1,
		68,
		55,
		-1,
		-1,
		66,
		60,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		118,
		139,
		164,
		131,
		-1,
		136,
		137,
		123,
		137,
		144,
		130,
		125,
		119,
		122,
		140,
		157,
		-1,
		-1,
		80,
		-1,
		75,
		-1,
		-1,
		-1,
		-1,
		97,
		111,
		132,
		138,
		150,
		-1,
		145,
		139,
		125,
		142,
		143,
		140,
		131,
		123,
		128,
		125,
		138,
		152,
		156,
		103,
		-1,
		86,
		-1,
		-1,
		-1,
		115,
		130,
		192,
		169,
		142,
		146,
		139,
		133,
		133,
		149,
		151,
		162,
		130,
		126,
		127,
		131,
		130,
		147,
		157,
		-1,
		-1,
		86,
		103,
		138,
		123,
		127,
		219,
		-1,
		-1,
		155,
		146,
		137,
		140,
		143,
		146,
		136,
		133,
		138,
		143,
		131,
		140,
		158,
		162,
		-1,
		-1,
		-1,
		106,
		-1,
		121,
		-1,
		-1,
		142,
		226,
		173,
		155,
		151,
		149,
		142,
		151,
		146,
		141,
		151,
		160,
		152,
		133,
		144,
		167,
		156,
		194,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		135,
		110,
		125,
		171,
		162,
		167,
		188,
		185,
		-1,
		155,
		180,
		152,
		159,
		151,
		159,
		159,
		156,
		134,
		141,
		157,
		156,
		151,
		186,
		178,
		184,
		-1,
		-1,
		218,
		207,
		196,
		202,
		-1,
		141,
		127,
		157,
		147,
		153,
		-1,
		-1,
		200,
		197,
		177,
		161,
		165,
		158,
		153,
		163,
		143,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		113,
		194,
		187,
		170,
		178,
		209,
		-1,
		144,
		153,
		134,
		139,
		147,
		-1,
		-1,
		173,
		169,
		174,
		168,
		165,
		173,
		168,
		159,
		144,
		150,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		127,
		170,
		164,
		167,
		191,
		205,
		-1,
		157,
		-1,
		-1,
		142,
		160,
		168,
		164,
		168,
		221,
		182,
		177,
		167,
		165,
		156,
		147,
		154,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		162,
		150,
		158,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		158,
		-1,
		194,
		-1,
		187,
		191,
		190,
		193,
		181,
		168,
		160,
		152,
		168,
		143,
		153,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		236,
		191,
		158,
		149,
		196,
		211,
		215,
		-1,
		170,
		209,
		196,
		-1,
		167,
		-1,
		-1,
		-1,
		201,
		203,
		195,
		201,
		180,
		180,
		154,
		158,
		148,
		155,
		165,
		167,
		159,
		163,
		176,
		187,
		190,
		232,
		230,
		235,
		180,
		163,
		181,
		190,
		211,
		185,
		176,
		203,
		203,
		192,
		187,
		174,
		-1,
		-1,
		224,
		213,
		-1,
		-1,
		187,
		175,
		158,
		159,
		155,
		158,
		173,
		176,
		166,
		164,
		158,
		190,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		171,
		182,
		-1,
		-1,
		188,
		204,
		217,
		221,
		234,
		259,
		-1,
		177,
		-1,
		-1,
		232,
		-1,
		-1,
		217,
		180,
		169,
		160,
		166,
		163,
		174,
		184,
		172,
		173,
		163,
		173,
		186,
		216,
		213,
		201,
		199,
		222,
		179,
		175,
		-1,
		203,
		191,
		197,
		204,
		221,
		248,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		215,
		213,
		202,
		-1,
		192,
		165,
		170,
		190,
		192,
		181,
		175,
		169,
		176,
		175,
		183,
		191,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		-1,
		228,
		203,
		-1,
		-1,
		210,
		203,
		191,
		179,
		169,
		179,
		183,
		187,
		179,
		172,
		167,
		178,
		170,
		174,
		191,
		-1,
		259,
		-1,
		211,
		204,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		245,
		231,
		224,
		212,
		210,
		-1,
		244,
		228,
		209,
		-1,
		179,
		192,
		223,
		191,
		196,
		191,
		173,
		184,
		173,
		176,
		190,
		185,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		242,
		261,
		-1,
		236,
		225,
		210,
		202,
		-1,
		-1,
		216,
		212,
		-1,
		-1,
		180,
		205,
		194,
		202,
		197,
		177,
		183,
		186,
		175,
		179,
		191,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		245,
		-1,
		260,
		-1,
		205,
		221,
		223,
		-1,
		-1,
		-1,
		218,
		181,
		202,
		212,
		206,
		204,
		195,
		181,
		188,
		186,
		182,
		193,
		-1,
		-1,
		-1,
		263,
		237,
		267,
		258,
		241,
		221,
		213,
		235,
		-1,
		205,
		-1,
		180,
		182,
		208,
		211,
		217,
		211,
		184,
		199,
		189,
		180,
		189,
		269,
		-1,
		239,
		272,
		236,
		227,
		206,
		210,
		226,
		-1,
		202,
		184,
		-1,
		212,
		202,
		233,
		218,
		199,
		186,
		193,
		193,
		186,
		-1,
		-1,
		-1,
		241,
		240,
		232,
		226,
		226,
		211,
		202,
		-1,
		214,
		196,
		175,
		192,
		192,
		183,
		191,
		223,
		219,
		206,
		206,
		198,
		-1,
		331,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		235,
		230,
		203,
		191,
		197,
		193,
		179,
		185,
		187,
		195,
		193,
		190,
		202,
		198,
		218,
		199,
		234,
		-1,
		337,
		-1,
		271,
		-1,
		-1,
		253,
		233,
		225,
		214,
		203,
		201,
		192,
		183,
		205,
		221,
		205,
		203,
		206,
		207,
		-1,
		326,
		325,
		-1,
		272,
		264,
		250,
		-1,
		243,
		-1,
		249,
		210,
		-1,
		212,
		192,
		-1,
		214,
		210,
		-1,
		-1,
		313,
		288,
		-1,
		-1,
		-1,
		273,
		253,
		244,
		228,
		-1,
		203,
		203,
		-1,
		-1,
		-1,
		298,
		297,
		-1,
		266,
		269,
		-1,
		259,
		250,
		258,
		205,
		209,
		-1,
		-1,
		-1,
		307,
		288,
		282,
		281,
		279,
		274,
		271,
		257,
		241,
		219,
		208,
		229,
		-1,
		-1,
		-1,
		279,
		271,
		264,
		-1,
		-1,
		266,
		249,
		230,
		228,
		-1,
		-1,
		-1,
		301,
		282,
		-1,
		-1,
		256,
		-1,
		-1,
		262,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		318,
		290,
		-1,
		-1,
		-1,
		252,
		248,
		249,
		-1,
		-1,
		-1,
		-1,
		312,
		313,
		336,
		300,
		-1,
		-1,
		-1,
		244,
		238,
		-1,
		-1,
		315,
		313,
		-1,
		-1,
		-1,
		272,
		256,
		-1,
		242,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		277,
		-1,
		277,
		252,
		259,
		-1,
		-1,
		-1,
		-1,
		290,
		282,
		290,
		-1,
		262,
		264,
		-1,
		312,
		-1,
		-1,
		305,
		296,
		-1,
		-1,
		267,
		274,
		296,
		299,
		335,
		-1,
		286
	],
	[
		-1,
		156,
		145,
		156,
		164,
		137,
		144,
		-1,
		165,
		167,
		133,
		127,
		166,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		156,
		155,
		125,
		123,
		132,
		137,
		144,
		-1,
		167,
		-1,
		177,
		156,
		167,
		172,
		118,
		115,
		135,
		154,
		160,
		152,
		192,
		148,
		119,
		113,
		131,
		136,
		154,
		146,
		-1,
		119,
		109,
		131,
		135,
		147,
		130,
		-1,
		-1,
		113,
		114,
		120,
		132,
		137,
		142,
		-1,
		168,
		180,
		-1,
		-1,
		103,
		116,
		112,
		115,
		123,
		139,
		160,
		177,
		175,
		-1,
		-1,
		104,
		108,
		121,
		122,
		120,
		147,
		166,
		170,
		184,
		183,
		-1,
		92,
		110,
		119,
		128,
		134,
		123,
		127,
		145,
		169,
		175,
		178,
		-1,
		84,
		86,
		115,
		121,
		133,
		139,
		126,
		132,
		151,
		157,
		176,
		167,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		81,
		89,
		115,
		114,
		110,
		128,
		150,
		129,
		135,
		139,
		149,
		165,
		166,
		176,
		-1,
		-1,
		137,
		106,
		141,
		98,
		83,
		-1,
		77,
		96,
		102,
		106,
		111,
		119,
		147,
		145,
		-1,
		143,
		142,
		173,
		159,
		170,
		97,
		-1,
		-1,
		95,
		87,
		72,
		75,
		72,
		72,
		102,
		101,
		106,
		108,
		110,
		122,
		137,
		137,
		147,
		137,
		147,
		151,
		162,
		177,
		-1,
		-1,
		232,
		-1,
		-1,
		94,
		77,
		-1,
		60,
		67,
		67,
		84,
		74,
		95,
		110,
		114,
		122,
		125,
		113,
		132,
		129,
		152,
		140,
		134,
		159,
		163,
		157,
		178,
		173,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		53,
		56,
		62,
		86,
		96,
		-1,
		117,
		115,
		139,
		133,
		138,
		134,
		119,
		137,
		131,
		138,
		137,
		141,
		143,
		176,
		154,
		176,
		173,
		202,
		207,
		201,
		210,
		-1,
		102,
		98,
		94,
		101,
		50,
		-1,
		-1,
		90,
		-1,
		104,
		117,
		129,
		119,
		122,
		134,
		142,
		140,
		125,
		140,
		129,
		126,
		134,
		143,
		154,
		149,
		148,
		166,
		181,
		194,
		198,
		204,
		-1,
		152,
		-1,
		94,
		78,
		80,
		52,
		73,
		-1,
		110,
		105,
		125,
		131,
		131,
		-1,
		147,
		144,
		157,
		136,
		121,
		138,
		130,
		128,
		133,
		138,
		152,
		143,
		161,
		168,
		176,
		180,
		200,
		212,
		112,
		102,
		-1,
		84,
		89,
		48,
		56,
		74,
		148,
		132,
		-1,
		142,
		-1,
		138,
		162,
		-1,
		142,
		138,
		120,
		121,
		116,
		131,
		137,
		134,
		131,
		149,
		152,
		169,
		173,
		189,
		-1,
		-1,
		97,
		101,
		89,
		41,
		39,
		63,
		100,
		141,
		133,
		132,
		-1,
		123,
		153,
		150,
		136,
		123,
		113,
		114,
		122,
		135,
		114,
		133,
		136,
		158,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		66,
		38,
		41,
		83,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		143,
		126,
		122,
		111,
		109,
		122,
		117,
		133,
		137,
		136,
		155,
		167,
		158,
		178,
		-1,
		-1,
		-1,
		96,
		85,
		86,
		33,
		0,
		54,
		141,
		127,
		132,
		107,
		100,
		94,
		146,
		143,
		110,
		118,
		110,
		99,
		113,
		121,
		125,
		134,
		143,
		149,
		173,
		173,
		179,
		-1,
		-1,
		103,
		93,
		77,
		79,
		76,
		40,
		13,
		53,
		132,
		129,
		-1,
		99,
		-1,
		88,
		96,
		95,
		101,
		113,
		99,
		104,
		115,
		127,
		140,
		136,
		143,
		178,
		178,
		163,
		183,
		186,
		-1,
		-1,
		-1,
		96,
		88,
		63,
		40,
		28,
		27,
		-1,
		99,
		100,
		-1,
		93,
		87,
		93,
		92,
		99,
		96,
		96,
		110,
		118,
		114,
		130,
		136,
		128,
		164,
		-1,
		171,
		165,
		173,
		163,
		151,
		-1,
		-1,
		-1,
		86,
		65,
		58,
		78,
		35,
		87,
		-1,
		-1,
		84,
		77,
		-1,
		80,
		80,
		87,
		96,
		101,
		106,
		114,
		109,
		122,
		127,
		133,
		138,
		156,
		160,
		164,
		153,
		149,
		146,
		160,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		38,
		55,
		-1,
		92,
		84,
		75,
		69,
		75,
		93,
		91,
		111,
		103,
		117,
		117,
		123,
		131,
		116,
		119,
		135,
		133,
		151,
		159,
		151,
		145,
		144,
		156,
		-1,
		141,
		127,
		98,
		-1,
		-1,
		70,
		-1,
		41,
		65,
		81,
		-1,
		109,
		88,
		111,
		89,
		103,
		99,
		137,
		138,
		116,
		121,
		129,
		139,
		141,
		130,
		141,
		133,
		155,
		155,
		139,
		140,
		149,
		-1,
		147,
		134,
		92,
		88,
		77,
		97,
		44,
		57,
		68,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		113,
		111,
		127,
		118,
		124,
		140,
		143,
		145,
		135,
		124,
		130,
		127,
		149,
		135,
		133,
		152,
		168,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		63,
		50,
		44,
		-1,
		85,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		135,
		119,
		124,
		-1,
		170,
		-1,
		143,
		145,
		139,
		124,
		121,
		132,
		130,
		141,
		158,
		-1,
		97,
		82,
		75,
		65,
		79,
		50,
		-1,
		105,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		151,
		131,
		125,
		124,
		165,
		165,
		151,
		137,
		130,
		127,
		124,
		137,
		157,
		148,
		160,
		-1,
		-1,
		-1,
		102,
		88,
		92,
		52,
		71,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		168,
		156,
		146,
		136,
		170,
		171,
		156,
		149,
		135,
		137,
		135,
		133,
		138,
		159,
		160,
		173,
		-1,
		-1,
		85,
		90,
		78,
		64,
		83,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		157,
		-1,
		-1,
		148,
		146,
		156,
		152,
		139,
		159,
		162,
		148,
		132,
		147,
		159,
		167,
		172,
		-1,
		88,
		75,
		-1,
		-1,
		86,
		80,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		138,
		159,
		184,
		151,
		-1,
		156,
		157,
		143,
		157,
		164,
		150,
		145,
		139,
		142,
		160,
		177,
		-1,
		-1,
		100,
		-1,
		95,
		-1,
		-1,
		-1,
		-1,
		117,
		131,
		152,
		158,
		170,
		-1,
		165,
		159,
		145,
		162,
		163,
		160,
		151,
		143,
		148,
		145,
		158,
		172,
		176,
		123,
		-1,
		106,
		-1,
		-1,
		-1,
		135,
		150,
		212,
		189,
		162,
		166,
		159,
		153,
		153,
		169,
		171,
		182,
		150,
		146,
		147,
		151,
		150,
		167,
		177,
		-1,
		-1,
		106,
		123,
		158,
		143,
		147,
		239,
		-1,
		-1,
		175,
		166,
		157,
		160,
		163,
		166,
		156,
		153,
		158,
		163,
		151,
		160,
		178,
		182,
		-1,
		-1,
		-1,
		126,
		-1,
		141,
		-1,
		-1,
		162,
		246,
		193,
		175,
		171,
		169,
		162,
		171,
		166,
		161,
		171,
		180,
		172,
		153,
		164,
		187,
		176,
		214,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		155,
		130,
		145,
		191,
		182,
		187,
		208,
		205,
		-1,
		175,
		200,
		172,
		179,
		171,
		179,
		179,
		176,
		154,
		161,
		177,
		176,
		171,
		206,
		198,
		204,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		161,
		147,
		177,
		167,
		173,
		-1,
		-1,
		220,
		217,
		197,
		181,
		185,
		178,
		173,
		183,
		163,
		150,
		154,
		158,
		164,
		169,
		174,
		180,
		195,
		210,
		-1,
		133,
		214,
		207,
		190,
		198,
		229,
		-1,
		164,
		173,
		154,
		159,
		167,
		-1,
		-1,
		193,
		189,
		194,
		188,
		185,
		193,
		188,
		179,
		164,
		170,
		157,
		156,
		174,
		178,
		187,
		194,
		184,
		197,
		201,
		-1,
		147,
		190,
		184,
		187,
		211,
		225,
		-1,
		177,
		-1,
		-1,
		162,
		180,
		188,
		184,
		188,
		241,
		202,
		197,
		187,
		185,
		176,
		167,
		174,
		165,
		165,
		168,
		183,
		188,
		180,
		194,
		194,
		195,
		-1,
		182,
		170,
		178,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		178,
		-1,
		214,
		-1,
		207,
		211,
		210,
		213,
		201,
		188,
		180,
		172,
		188,
		163,
		173,
		169,
		170,
		179,
		190,
		202,
		201,
		202,
		256,
		211,
		178,
		169,
		216,
		231,
		235,
		-1,
		190,
		229,
		216,
		-1,
		187,
		-1,
		-1,
		-1,
		221,
		223,
		215,
		221,
		200,
		200,
		174,
		178,
		168,
		175,
		185,
		187,
		179,
		183,
		196,
		207,
		210,
		252,
		250,
		255,
		200,
		183,
		201,
		210,
		231,
		205,
		196,
		223,
		223,
		212,
		207,
		194,
		-1,
		-1,
		244,
		233,
		-1,
		-1,
		207,
		195,
		178,
		179,
		175,
		178,
		193,
		196,
		186,
		184,
		178,
		210,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		191,
		202,
		-1,
		-1,
		208,
		224,
		237,
		241,
		254,
		279,
		-1,
		197,
		-1,
		-1,
		252,
		-1,
		-1,
		237,
		200,
		189,
		180,
		186,
		183,
		194,
		204,
		192,
		193,
		183,
		193,
		206,
		236,
		233,
		221,
		219,
		242,
		199,
		195,
		-1,
		223,
		211,
		217,
		224,
		241,
		268,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		235,
		233,
		222,
		-1,
		212,
		185,
		190,
		210,
		212,
		201,
		195,
		189,
		196,
		195,
		203,
		211,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		223,
		-1,
		-1,
		230,
		223,
		211,
		199,
		189,
		199,
		203,
		207,
		199,
		192,
		187,
		198,
		190,
		194,
		211,
		-1,
		279,
		-1,
		231,
		224,
		239,
		254,
		262,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		264,
		248,
		229,
		-1,
		199,
		212,
		243,
		211,
		216,
		211,
		193,
		204,
		193,
		196,
		210,
		205,
		-1,
		-1,
		237,
		240,
		-1,
		-1,
		262,
		281,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		236,
		232,
		-1,
		-1,
		200,
		225,
		214,
		222,
		217,
		197,
		203,
		206,
		195,
		199,
		211,
		-1,
		-1,
		244,
		245,
		250,
		-1,
		265,
		-1,
		280,
		-1,
		225,
		241,
		243,
		-1,
		-1,
		-1,
		238,
		201,
		222,
		232,
		226,
		224,
		215,
		201,
		208,
		206,
		202,
		213,
		-1,
		-1,
		-1,
		283,
		257,
		287,
		278,
		261,
		241,
		233,
		255,
		-1,
		225,
		-1,
		200,
		202,
		228,
		231,
		237,
		231,
		204,
		219,
		209,
		200,
		209,
		289,
		-1,
		259,
		292,
		256,
		247,
		226,
		230,
		246,
		-1,
		222,
		204,
		-1,
		232,
		222,
		253,
		238,
		219,
		206,
		213,
		213,
		206,
		-1,
		-1,
		-1,
		261,
		260,
		252,
		246,
		246,
		231,
		222,
		-1,
		234,
		216,
		195,
		212,
		212,
		203,
		211,
		243,
		239,
		226,
		226,
		218,
		-1,
		351,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		255,
		250,
		223,
		211,
		217,
		213,
		199,
		205,
		207,
		215,
		213,
		210,
		222,
		218,
		238,
		219,
		254,
		-1,
		357,
		-1,
		291,
		-1,
		-1,
		273,
		253,
		245,
		234,
		223,
		221,
		212,
		203,
		225,
		241,
		225,
		223,
		226,
		227,
		-1,
		346,
		345,
		-1,
		292,
		284,
		270,
		-1,
		263,
		-1,
		269,
		230,
		-1,
		232,
		212,
		-1,
		234,
		230,
		-1,
		-1,
		333,
		308,
		-1,
		-1,
		-1,
		293,
		273,
		264,
		248,
		-1,
		223,
		223,
		-1,
		-1,
		-1,
		318,
		317,
		-1,
		286,
		289,
		-1,
		279,
		270,
		278,
		225,
		229,
		-1,
		-1,
		-1,
		327,
		308,
		302,
		301,
		299,
		294,
		291,
		277,
		261,
		239,
		228,
		249,
		-1,
		-1,
		-1,
		299,
		291,
		284,
		-1,
		-1,
		286,
		269,
		250,
		248,
		-1,
		-1,
		-1,
		321,
		302,
		-1,
		-1,
		276,
		-1,
		-1,
		282,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		338,
		310,
		-1,
		-1,
		-1,
		272,
		268,
		269,
		-1,
		-1,
		-1,
		-1,
		332,
		333,
		356,
		320,
		-1,
		-1,
		-1,
		264,
		258,
		-1,
		-1,
		335,
		333,
		-1,
		-1,
		-1,
		292,
		276,
		-1,
		262,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		297,
		-1,
		297,
		272,
		279,
		-1,
		-1,
		-1,
		-1,
		310,
		302,
		310,
		-1,
		282,
		284,
		-1,
		332,
		-1,
		-1,
		325,
		316,
		-1,
		-1,
		287,
		294,
		316,
		319,
		355,
		-1,
		306
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		183,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		176,
		168,
		208,
		164,
		135,
		129,
		147,
		152,
		170,
		162,
		-1,
		135,
		125,
		147,
		151,
		163,
		146,
		-1,
		-1,
		129,
		130,
		136,
		148,
		153,
		158,
		-1,
		184,
		203,
		-1,
		-1,
		119,
		132,
		128,
		131,
		139,
		155,
		176,
		193,
		198,
		-1,
		-1,
		120,
		124,
		137,
		138,
		136,
		163,
		182,
		193,
		207,
		206,
		-1,
		108,
		126,
		135,
		144,
		150,
		139,
		143,
		161,
		192,
		198,
		201,
		-1,
		100,
		102,
		131,
		137,
		149,
		155,
		142,
		148,
		167,
		180,
		199,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		97,
		105,
		131,
		130,
		126,
		144,
		166,
		145,
		151,
		155,
		172,
		188,
		189,
		199,
		-1,
		-1,
		153,
		122,
		157,
		114,
		99,
		-1,
		93,
		112,
		118,
		122,
		127,
		135,
		163,
		161,
		-1,
		166,
		165,
		196,
		182,
		193,
		113,
		-1,
		-1,
		111,
		103,
		88,
		91,
		88,
		88,
		118,
		117,
		122,
		124,
		126,
		138,
		153,
		153,
		163,
		160,
		170,
		174,
		189,
		200,
		-1,
		-1,
		267,
		-1,
		-1,
		110,
		93,
		-1,
		76,
		83,
		83,
		100,
		90,
		111,
		126,
		130,
		138,
		141,
		129,
		148,
		145,
		169,
		165,
		157,
		182,
		186,
		192,
		210,
		208,
		-1,
		266,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		69,
		72,
		78,
		102,
		112,
		-1,
		133,
		131,
		155,
		149,
		154,
		150,
		135,
		153,
		151,
		166,
		168,
		164,
		166,
		203,
		189,
		211,
		208,
		237,
		242,
		236,
		245,
		-1,
		118,
		114,
		110,
		117,
		66,
		-1,
		-1,
		106,
		-1,
		120,
		133,
		145,
		135,
		138,
		150,
		158,
		157,
		141,
		159,
		154,
		157,
		169,
		172,
		181,
		184,
		183,
		201,
		216,
		229,
		233,
		239,
		-1,
		168,
		-1,
		110,
		94,
		96,
		68,
		89,
		-1,
		126,
		121,
		141,
		147,
		147,
		-1,
		163,
		160,
		173,
		157,
		142,
		159,
		161,
		163,
		168,
		173,
		187,
		178,
		196,
		203,
		211,
		215,
		235,
		247,
		128,
		118,
		-1,
		100,
		105,
		64,
		69,
		83,
		164,
		148,
		-1,
		158,
		-1,
		165,
		178,
		-1,
		163,
		159,
		148,
		156,
		151,
		166,
		172,
		169,
		166,
		184,
		187,
		204,
		208,
		224,
		-1,
		-1,
		113,
		117,
		98,
		57,
		48,
		72,
		109,
		157,
		165,
		164,
		-1,
		158,
		184,
		181,
		171,
		158,
		148,
		149,
		157,
		170,
		149,
		168,
		171,
		193,
		221,
		199,
		211,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		75,
		54,
		50,
		92,
		194,
		187,
		175,
		143,
		143,
		137,
		-1,
		178,
		161,
		157,
		146,
		144,
		157,
		152,
		168,
		172,
		171,
		190,
		202,
		193,
		213,
		-1,
		-1,
		-1,
		105,
		94,
		95,
		57,
		55,
		0,
		176,
		162,
		167,
		142,
		135,
		129,
		181,
		178,
		145,
		153,
		145,
		134,
		148,
		156,
		160,
		169,
		178,
		184,
		208,
		208,
		214,
		-1,
		-1,
		112,
		102,
		86,
		88,
		85,
		79,
		64,
		104,
		167,
		164,
		-1,
		134,
		-1,
		123,
		131,
		130,
		136,
		148,
		134,
		139,
		150,
		162,
		175,
		171,
		178,
		213,
		213,
		198,
		218,
		221,
		-1,
		-1,
		-1,
		105,
		127,
		102,
		79,
		63,
		78,
		-1,
		134,
		135,
		-1,
		128,
		122,
		128,
		127,
		134,
		131,
		131,
		145,
		153,
		149,
		165,
		171,
		163,
		199,
		-1,
		206,
		200,
		208,
		198,
		186,
		-1,
		-1,
		-1,
		125,
		104,
		97,
		117,
		70,
		122,
		-1,
		-1,
		119,
		112,
		-1,
		115,
		115,
		122,
		131,
		136,
		141,
		149,
		144,
		157,
		162,
		168,
		173,
		191,
		195,
		199,
		188,
		184,
		181,
		195,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		90,
		-1,
		127,
		119,
		110,
		104,
		110,
		128,
		126,
		146,
		138,
		152,
		152,
		158,
		166,
		151,
		154,
		170,
		168,
		186,
		194,
		186,
		180,
		179,
		191,
		-1,
		176,
		162,
		133,
		-1,
		-1,
		105,
		-1,
		76,
		100,
		116,
		-1,
		144,
		123,
		146,
		124,
		138,
		134,
		172,
		173,
		151,
		156,
		164,
		174,
		176,
		165,
		176,
		168,
		190,
		190,
		174,
		175,
		184,
		-1,
		182,
		169,
		127,
		123,
		112,
		132,
		79,
		92,
		103,
		-1,
		-1,
		188,
		-1,
		122,
		139,
		148,
		146,
		162,
		153,
		159,
		175,
		178,
		180,
		170,
		159,
		165,
		162,
		184,
		170,
		168,
		187,
		203,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		98,
		85,
		79,
		-1,
		120,
		-1,
		166,
		156,
		140,
		125,
		158,
		-1,
		170,
		154,
		159,
		-1,
		205,
		-1,
		178,
		180,
		174,
		159,
		156,
		167,
		165,
		176,
		193,
		-1,
		132,
		117,
		110,
		100,
		114,
		85,
		-1,
		136,
		-1,
		-1,
		153,
		147,
		147,
		131,
		134,
		186,
		166,
		160,
		159,
		200,
		200,
		186,
		172,
		165,
		162,
		159,
		172,
		192,
		183,
		195,
		-1,
		-1,
		-1,
		137,
		117,
		123,
		81,
		102,
		-1,
		-1,
		215,
		170,
		156,
		-1,
		140,
		203,
		191,
		181,
		171,
		205,
		206,
		191,
		184,
		170,
		172,
		170,
		168,
		173,
		194,
		195,
		208,
		-1,
		-1,
		114,
		121,
		109,
		95,
		114,
		-1,
		-1,
		-1,
		162,
		178,
		170,
		141,
		192,
		-1,
		-1,
		183,
		181,
		191,
		187,
		174,
		194,
		197,
		183,
		167,
		182,
		194,
		202,
		207,
		-1,
		117,
		104,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		-1,
		-1,
		195,
		161,
		173,
		194,
		219,
		186,
		-1,
		191,
		192,
		178,
		192,
		199,
		185,
		180,
		174,
		177,
		195,
		212,
		-1,
		-1,
		131,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		152,
		166,
		187,
		193,
		205,
		-1,
		200,
		194,
		180,
		197,
		198,
		195,
		186,
		178,
		183,
		180,
		193,
		207,
		211,
		154,
		-1,
		137,
		-1,
		-1,
		-1,
		170,
		185,
		247,
		224,
		197,
		201,
		194,
		188,
		188,
		204,
		206,
		217,
		185,
		181,
		182,
		186,
		185,
		202,
		212,
		-1,
		-1,
		137,
		154,
		189,
		178,
		182,
		274,
		-1,
		-1,
		210,
		201,
		192,
		195,
		198,
		201,
		191,
		188,
		193,
		198,
		186,
		195,
		213,
		217,
		-1,
		-1,
		-1,
		157,
		-1,
		172,
		-1,
		-1,
		197,
		281,
		228,
		210,
		206,
		204,
		197,
		206,
		201,
		196,
		206,
		215,
		207,
		188,
		199,
		222,
		211,
		249,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		186,
		161,
		176,
		222,
		217,
		218,
		243,
		240,
		-1,
		210,
		235,
		207,
		214,
		206,
		214,
		214,
		211,
		189,
		196,
		212,
		211,
		206,
		241,
		233,
		239,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		192,
		178,
		208,
		198,
		204,
		-1,
		-1,
		251,
		248,
		232,
		216,
		220,
		213,
		208,
		218,
		198,
		185,
		189,
		193,
		199,
		204,
		209,
		215,
		230,
		245,
		-1,
		162,
		243,
		236,
		219,
		227,
		258,
		-1,
		195,
		204,
		185,
		190,
		198,
		-1,
		-1,
		224,
		220,
		225,
		223,
		220,
		228,
		223,
		214,
		199,
		205,
		192,
		191,
		209,
		213,
		222,
		229,
		219,
		232,
		236,
		-1,
		176,
		219,
		213,
		216,
		240,
		254,
		-1,
		208,
		-1,
		-1,
		193,
		211,
		219,
		215,
		219,
		272,
		237,
		232,
		222,
		220,
		211,
		202,
		209,
		200,
		200,
		203,
		218,
		223,
		215,
		229,
		229,
		230,
		-1,
		211,
		199,
		207,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		209,
		-1,
		245,
		-1,
		238,
		242,
		245,
		248,
		236,
		223,
		215,
		207,
		223,
		198,
		208,
		204,
		205,
		214,
		225,
		237,
		236,
		237,
		285,
		240,
		207,
		198,
		245,
		260,
		264,
		-1,
		221,
		260,
		247,
		-1,
		218,
		-1,
		-1,
		-1,
		252,
		258,
		250,
		256,
		235,
		235,
		209,
		213,
		203,
		210,
		220,
		222,
		214,
		218,
		231,
		242,
		245,
		281,
		279,
		284,
		229,
		212,
		230,
		239,
		260,
		236,
		227,
		254,
		254,
		243,
		238,
		225,
		-1,
		-1,
		275,
		268,
		-1,
		-1,
		242,
		230,
		213,
		214,
		210,
		213,
		228,
		231,
		221,
		219,
		213,
		245,
		-1,
		281,
		280,
		269,
		266,
		242,
		233,
		220,
		231,
		-1,
		-1,
		239,
		255,
		268,
		272,
		285,
		310,
		-1,
		228,
		-1,
		-1,
		287,
		-1,
		-1,
		272,
		235,
		224,
		215,
		221,
		218,
		229,
		239,
		227,
		228,
		218,
		228,
		241,
		265,
		262,
		250,
		248,
		271,
		228,
		224,
		-1,
		254,
		242,
		248,
		255,
		272,
		299,
		-1,
		-1,
		244,
		235,
		-1,
		-1,
		270,
		268,
		257,
		-1,
		247,
		220,
		225,
		245,
		247,
		236,
		230,
		224,
		231,
		230,
		238,
		246,
		274,
		288,
		277,
		273,
		272,
		280,
		229,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		-1,
		279,
		254,
		-1,
		-1,
		265,
		258,
		246,
		234,
		224,
		234,
		238,
		242,
		234,
		227,
		222,
		233,
		225,
		229,
		246,
		-1,
		308,
		-1,
		260,
		253,
		268,
		283,
		291,
		-1,
		-1,
		-1,
		296,
		282,
		275,
		263,
		261,
		-1,
		299,
		283,
		264,
		-1,
		234,
		247,
		278,
		246,
		251,
		246,
		228,
		239,
		228,
		231,
		245,
		240,
		-1,
		-1,
		266,
		269,
		-1,
		-1,
		291,
		310,
		-1,
		287,
		276,
		261,
		253,
		-1,
		-1,
		271,
		267,
		-1,
		-1,
		235,
		260,
		249,
		257,
		252,
		232,
		238,
		241,
		230,
		234,
		246,
		-1,
		-1,
		273,
		274,
		279,
		-1,
		300,
		-1,
		311,
		-1,
		256,
		272,
		274,
		-1,
		-1,
		-1,
		273,
		236,
		257,
		267,
		261,
		259,
		250,
		236,
		243,
		241,
		237,
		248,
		-1,
		-1,
		-1,
		318,
		292,
		318,
		309,
		292,
		272,
		264,
		289,
		-1,
		260,
		-1,
		235,
		237,
		263,
		266,
		272,
		266,
		239,
		254,
		244,
		235,
		244,
		324,
		-1,
		294,
		327,
		291,
		278,
		261,
		265,
		281,
		-1,
		257,
		239,
		-1,
		267,
		257,
		288,
		273,
		254,
		241,
		248,
		248,
		241,
		-1,
		-1,
		-1,
		296,
		295,
		287,
		281,
		281,
		266,
		257,
		-1,
		269,
		251,
		230,
		247,
		247,
		238,
		246,
		278,
		274,
		261,
		261,
		253,
		-1,
		380,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		290,
		285,
		258,
		246,
		252,
		248,
		234,
		240,
		242,
		250,
		248,
		245,
		257,
		253,
		273,
		254,
		289,
		-1,
		387,
		-1,
		326,
		-1,
		-1,
		308,
		288,
		280,
		269,
		258,
		256,
		247,
		238,
		260,
		276,
		260,
		258,
		261,
		262,
		-1,
		381,
		380,
		-1,
		327,
		319,
		305,
		-1,
		298,
		-1,
		304,
		265,
		-1,
		267,
		247,
		-1,
		269,
		265,
		-1,
		-1,
		368,
		343,
		-1,
		-1,
		-1,
		328,
		308,
		299,
		283,
		-1,
		258,
		258,
		-1,
		-1,
		-1,
		353,
		352,
		-1,
		321,
		324,
		-1,
		314,
		305,
		313,
		260,
		264,
		-1,
		-1,
		-1,
		362,
		343,
		337,
		336,
		334,
		329,
		326,
		312,
		296,
		274,
		263,
		284,
		-1,
		-1,
		-1,
		334,
		326,
		319,
		-1,
		-1,
		321,
		304,
		285,
		283,
		-1,
		-1,
		-1,
		356,
		337,
		-1,
		-1,
		311,
		-1,
		-1,
		317,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		373,
		345,
		-1,
		-1,
		-1,
		307,
		303,
		304,
		-1,
		-1,
		-1,
		-1,
		367,
		368,
		391,
		355,
		-1,
		-1,
		-1,
		299,
		293,
		-1,
		-1,
		370,
		368,
		-1,
		-1,
		-1,
		327,
		311,
		-1,
		297,
		-1,
		-1,
		-1,
		318,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		332,
		-1,
		332,
		307,
		314,
		-1,
		-1,
		-1,
		-1,
		345,
		337,
		345,
		-1,
		317,
		319,
		-1,
		367,
		-1,
		-1,
		360,
		351,
		-1,
		-1,
		322,
		329,
		351,
		354,
		390,
		-1,
		341
	],
	[
		-1,
		219,
		208,
		219,
		227,
		200,
		207,
		-1,
		228,
		230,
		196,
		190,
		229,
		200,
		206,
		217,
		-1,
		-1,
		-1,
		219,
		218,
		188,
		186,
		195,
		200,
		207,
		-1,
		224,
		-1,
		240,
		219,
		230,
		235,
		181,
		178,
		198,
		217,
		217,
		209,
		255,
		211,
		182,
		176,
		194,
		199,
		211,
		203,
		-1,
		182,
		172,
		194,
		191,
		202,
		193,
		-1,
		-1,
		176,
		177,
		183,
		187,
		193,
		189,
		-1,
		199,
		183,
		-1,
		-1,
		166,
		179,
		169,
		172,
		180,
		178,
		191,
		183,
		178,
		-1,
		-1,
		167,
		171,
		178,
		165,
		161,
		178,
		191,
		173,
		187,
		186,
		-1,
		155,
		173,
		182,
		172,
		170,
		154,
		152,
		170,
		172,
		178,
		181,
		-1,
		147,
		149,
		173,
		181,
		186,
		170,
		157,
		157,
		167,
		160,
		179,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		144,
		152,
		173,
		165,
		159,
		174,
		167,
		160,
		157,
		155,
		152,
		168,
		169,
		179,
		-1,
		-1,
		214,
		183,
		218,
		175,
		160,
		-1,
		140,
		149,
		154,
		158,
		157,
		150,
		164,
		160,
		-1,
		146,
		145,
		176,
		162,
		173,
		174,
		-1,
		-1,
		172,
		164,
		149,
		152,
		139,
		135,
		146,
		145,
		141,
		139,
		135,
		147,
		150,
		150,
		156,
		140,
		150,
		154,
		165,
		180,
		-1,
		-1,
		235,
		-1,
		-1,
		171,
		154,
		-1,
		137,
		144,
		144,
		151,
		137,
		130,
		156,
		132,
		129,
		150,
		138,
		145,
		142,
		155,
		143,
		137,
		162,
		166,
		160,
		181,
		176,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		130,
		133,
		139,
		162,
		147,
		-1,
		92,
		98,
		122,
		119,
		129,
		142,
		136,
		149,
		134,
		141,
		140,
		144,
		146,
		179,
		157,
		179,
		176,
		205,
		210,
		204,
		213,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		158,
		-1,
		116,
		109,
		84,
		102,
		105,
		120,
		111,
		143,
		132,
		143,
		132,
		129,
		137,
		146,
		157,
		152,
		151,
		169,
		184,
		197,
		201,
		207,
		-1,
		229,
		-1,
		171,
		155,
		157,
		129,
		150,
		-1,
		170,
		115,
		101,
		86,
		77,
		-1,
		97,
		100,
		126,
		133,
		124,
		141,
		133,
		131,
		136,
		141,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		189,
		179,
		-1,
		161,
		166,
		125,
		133,
		152,
		119,
		83,
		-1,
		78,
		-1,
		87,
		112,
		-1,
		132,
		136,
		123,
		124,
		119,
		134,
		140,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		174,
		178,
		167,
		118,
		137,
		161,
		129,
		76,
		65,
		64,
		-1,
		72,
		155,
		152,
		138,
		125,
		116,
		117,
		125,
		138,
		117,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		144,
		115,
		139,
		143,
		94,
		87,
		75,
		40,
		40,
		47,
		-1,
		145,
		128,
		125,
		114,
		112,
		125,
		120,
		136,
		140,
		139,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		0,
		19,
		24,
		39,
		45,
		50,
		148,
		145,
		112,
		121,
		113,
		102,
		116,
		124,
		128,
		137,
		146,
		152,
		176,
		176,
		182,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		24,
		148,
		-1,
		83,
		-1,
		56,
		90,
		98,
		104,
		116,
		102,
		107,
		118,
		130,
		143,
		139,
		146,
		181,
		181,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		118,
		119,
		-1,
		77,
		71,
		87,
		95,
		102,
		99,
		99,
		113,
		121,
		117,
		133,
		139,
		131,
		167,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		74,
		83,
		90,
		99,
		104,
		109,
		117,
		112,
		125,
		130,
		136,
		141,
		159,
		163,
		167,
		156,
		152,
		149,
		163,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		96,
		94,
		114,
		106,
		120,
		120,
		126,
		134,
		119,
		122,
		138,
		136,
		154,
		162,
		154,
		148,
		147,
		159,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		106,
		102,
		140,
		141,
		119,
		124,
		132,
		142,
		144,
		133,
		144,
		136,
		158,
		158,
		142,
		143,
		152,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		116,
		114,
		130,
		121,
		127,
		143,
		146,
		148,
		138,
		127,
		133,
		130,
		152,
		138,
		136,
		155,
		171,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		138,
		122,
		127,
		-1,
		173,
		-1,
		146,
		148,
		142,
		127,
		124,
		135,
		133,
		144,
		161,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		154,
		134,
		128,
		127,
		168,
		168,
		154,
		140,
		133,
		130,
		127,
		140,
		160,
		151,
		163,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		171,
		159,
		149,
		139,
		173,
		174,
		159,
		152,
		138,
		140,
		138,
		136,
		141,
		162,
		163,
		176,
		-1,
		-1,
		131,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		160,
		-1,
		-1,
		151,
		149,
		159,
		155,
		142,
		162,
		165,
		151,
		135,
		150,
		162,
		170,
		175,
		-1,
		134,
		121,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		162,
		187,
		154,
		-1,
		159,
		160,
		146,
		160,
		167,
		153,
		148,
		142,
		145,
		163,
		180,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		155,
		161,
		173,
		-1,
		168,
		162,
		148,
		165,
		166,
		163,
		154,
		146,
		151,
		148,
		161,
		175,
		179,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		138,
		153,
		215,
		192,
		165,
		169,
		162,
		156,
		156,
		172,
		174,
		185,
		153,
		149,
		150,
		154,
		153,
		170,
		180,
		-1,
		-1,
		152,
		169,
		164,
		146,
		150,
		242,
		-1,
		-1,
		178,
		169,
		160,
		163,
		166,
		169,
		159,
		156,
		161,
		166,
		154,
		163,
		181,
		185,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		165,
		249,
		196,
		178,
		174,
		172,
		165,
		174,
		169,
		164,
		174,
		183,
		175,
		156,
		167,
		190,
		179,
		217,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		201,
		176,
		191,
		237,
		185,
		192,
		211,
		208,
		-1,
		178,
		203,
		175,
		182,
		174,
		182,
		182,
		179,
		157,
		164,
		180,
		179,
		174,
		209,
		201,
		207,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		207,
		193,
		223,
		213,
		202,
		-1,
		-1,
		227,
		224,
		200,
		184,
		188,
		181,
		176,
		186,
		166,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		210,
		219,
		200,
		205,
		213,
		-1,
		-1,
		200,
		197,
		202,
		191,
		188,
		196,
		191,
		182,
		167,
		173,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		223,
		-1,
		-1,
		208,
		226,
		215,
		205,
		199,
		249,
		205,
		200,
		190,
		188,
		179,
		170,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		224,
		-1,
		242,
		-1,
		217,
		221,
		213,
		216,
		204,
		191,
		183,
		175,
		191,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		302,
		257,
		224,
		215,
		262,
		277,
		281,
		-1,
		236,
		275,
		262,
		-1,
		233,
		-1,
		-1,
		-1,
		231,
		226,
		218,
		224,
		203,
		203,
		177,
		181,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		298,
		296,
		301,
		246,
		229,
		247,
		256,
		277,
		251,
		242,
		269,
		269,
		258,
		253,
		240,
		-1,
		-1,
		254,
		236,
		-1,
		-1,
		210,
		198,
		181,
		182,
		178,
		181,
		196,
		199,
		189,
		187,
		181,
		213,
		-1,
		298,
		297,
		286,
		283,
		259,
		250,
		237,
		248,
		-1,
		-1,
		254,
		270,
		283,
		287,
		300,
		325,
		-1,
		243,
		-1,
		-1,
		255,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		186,
		197,
		207,
		195,
		196,
		186,
		196,
		209,
		282,
		279,
		267,
		265,
		288,
		245,
		241,
		-1,
		264,
		257,
		263,
		270,
		287,
		314,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		238,
		236,
		225,
		-1,
		215,
		188,
		193,
		213,
		215,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		291,
		305,
		294,
		290,
		289,
		297,
		246,
		249,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		-1,
		276,
		269,
		-1,
		-1,
		233,
		226,
		214,
		202,
		192,
		202,
		206,
		210,
		202,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		325,
		-1,
		277,
		263,
		277,
		292,
		300,
		-1,
		-1,
		-1,
		293,
		279,
		272,
		260,
		258,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		275,
		278,
		-1,
		-1,
		283,
		285,
		-1,
		284,
		273,
		258,
		250,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		282,
		283,
		288,
		-1,
		268,
		-1,
		286,
		-1,
		253,
		259,
		247,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		229,
		227,
		218,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		286,
		260,
		293,
		284,
		267,
		247,
		239,
		258,
		-1,
		228,
		-1,
		203,
		205,
		231,
		234,
		240,
		234,
		207,
		222,
		212,
		203,
		212,
		292,
		-1,
		262,
		295,
		259,
		253,
		229,
		233,
		249,
		-1,
		225,
		207,
		-1,
		235,
		225,
		256,
		241,
		222,
		209,
		216,
		216,
		209,
		-1,
		-1,
		-1,
		264,
		263,
		255,
		249,
		249,
		234,
		225,
		-1,
		237,
		219,
		198,
		215,
		215,
		206,
		214,
		246,
		242,
		229,
		229,
		221,
		-1,
		365,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		258,
		253,
		226,
		214,
		220,
		216,
		202,
		208,
		210,
		218,
		216,
		213,
		225,
		221,
		241,
		222,
		257,
		-1,
		360,
		-1,
		294,
		-1,
		-1,
		276,
		256,
		248,
		237,
		226,
		224,
		215,
		206,
		228,
		244,
		228,
		226,
		229,
		230,
		-1,
		349,
		348,
		-1,
		295,
		287,
		273,
		-1,
		266,
		-1,
		272,
		233,
		-1,
		235,
		215,
		-1,
		237,
		233,
		-1,
		-1,
		336,
		311,
		-1,
		-1,
		-1,
		296,
		276,
		267,
		251,
		-1,
		226,
		226,
		-1,
		-1,
		-1,
		321,
		320,
		-1,
		289,
		292,
		-1,
		282,
		273,
		281,
		228,
		232,
		-1,
		-1,
		-1,
		330,
		311,
		305,
		304,
		302,
		297,
		294,
		280,
		264,
		242,
		231,
		252,
		-1,
		-1,
		-1,
		302,
		294,
		287,
		-1,
		-1,
		289,
		272,
		253,
		251,
		-1,
		-1,
		-1,
		324,
		305,
		-1,
		-1,
		279,
		-1,
		-1,
		285,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		341,
		313,
		-1,
		-1,
		-1,
		275,
		271,
		272,
		-1,
		-1,
		-1,
		-1,
		335,
		336,
		359,
		323,
		-1,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		338,
		336,
		-1,
		-1,
		-1,
		295,
		279,
		-1,
		265,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		300,
		-1,
		300,
		275,
		282,
		-1,
		-1,
		-1,
		-1,
		313,
		305,
		313,
		-1,
		285,
		287,
		-1,
		335,
		-1,
		-1,
		328,
		319,
		-1,
		-1,
		290,
		297,
		319,
		322,
		358,
		-1,
		309
	],
	[
		-1,
		214,
		203,
		214,
		222,
		195,
		202,
		-1,
		223,
		225,
		191,
		185,
		224,
		195,
		201,
		212,
		-1,
		-1,
		-1,
		214,
		213,
		183,
		181,
		190,
		195,
		202,
		-1,
		219,
		-1,
		235,
		214,
		225,
		230,
		176,
		173,
		193,
		212,
		212,
		204,
		250,
		206,
		177,
		171,
		189,
		194,
		206,
		198,
		-1,
		177,
		167,
		189,
		186,
		197,
		188,
		-1,
		-1,
		171,
		172,
		178,
		182,
		188,
		184,
		-1,
		194,
		178,
		-1,
		-1,
		161,
		174,
		164,
		167,
		175,
		173,
		186,
		178,
		173,
		-1,
		-1,
		162,
		166,
		173,
		160,
		156,
		173,
		186,
		168,
		182,
		181,
		-1,
		150,
		168,
		177,
		167,
		165,
		149,
		147,
		165,
		167,
		173,
		176,
		-1,
		142,
		144,
		168,
		176,
		181,
		165,
		152,
		152,
		162,
		155,
		174,
		165,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		139,
		147,
		168,
		160,
		154,
		169,
		162,
		155,
		152,
		150,
		147,
		163,
		164,
		174,
		-1,
		-1,
		209,
		178,
		213,
		170,
		155,
		-1,
		135,
		144,
		149,
		153,
		152,
		145,
		159,
		155,
		-1,
		141,
		140,
		171,
		157,
		168,
		169,
		-1,
		-1,
		167,
		159,
		144,
		147,
		134,
		130,
		141,
		140,
		136,
		134,
		130,
		142,
		145,
		145,
		151,
		135,
		145,
		149,
		160,
		175,
		-1,
		-1,
		230,
		-1,
		-1,
		166,
		149,
		-1,
		132,
		139,
		139,
		146,
		132,
		125,
		151,
		127,
		124,
		145,
		133,
		140,
		137,
		150,
		138,
		132,
		157,
		161,
		155,
		176,
		171,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		134,
		157,
		142,
		-1,
		87,
		93,
		117,
		114,
		124,
		137,
		131,
		144,
		129,
		136,
		135,
		139,
		141,
		174,
		152,
		174,
		171,
		200,
		205,
		199,
		208,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		153,
		-1,
		111,
		104,
		79,
		97,
		100,
		115,
		106,
		138,
		127,
		138,
		127,
		124,
		132,
		141,
		152,
		147,
		146,
		164,
		179,
		192,
		196,
		202,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		165,
		110,
		96,
		81,
		72,
		-1,
		92,
		95,
		121,
		128,
		119,
		136,
		128,
		126,
		131,
		136,
		150,
		141,
		159,
		166,
		174,
		178,
		198,
		210,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		114,
		78,
		-1,
		73,
		-1,
		82,
		107,
		-1,
		127,
		131,
		118,
		119,
		114,
		129,
		135,
		132,
		129,
		147,
		150,
		167,
		171,
		187,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		124,
		71,
		60,
		59,
		-1,
		67,
		150,
		147,
		133,
		120,
		111,
		112,
		120,
		133,
		112,
		131,
		134,
		156,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		138,
		89,
		82,
		70,
		35,
		35,
		42,
		-1,
		140,
		123,
		120,
		109,
		107,
		120,
		115,
		131,
		135,
		134,
		153,
		165,
		156,
		176,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		27,
		0,
		5,
		34,
		40,
		45,
		143,
		140,
		107,
		116,
		108,
		97,
		111,
		119,
		123,
		132,
		141,
		147,
		171,
		171,
		177,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		19,
		143,
		-1,
		78,
		-1,
		51,
		85,
		93,
		99,
		111,
		97,
		102,
		113,
		125,
		138,
		134,
		141,
		176,
		176,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		72,
		66,
		82,
		90,
		97,
		94,
		94,
		108,
		116,
		112,
		128,
		134,
		126,
		162,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		69,
		78,
		85,
		94,
		99,
		104,
		112,
		107,
		120,
		125,
		131,
		136,
		154,
		158,
		162,
		151,
		147,
		144,
		158,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		91,
		89,
		109,
		101,
		115,
		115,
		121,
		129,
		114,
		117,
		133,
		131,
		149,
		157,
		149,
		143,
		142,
		154,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		101,
		97,
		135,
		136,
		114,
		119,
		127,
		137,
		139,
		128,
		139,
		131,
		153,
		153,
		137,
		138,
		147,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		111,
		109,
		125,
		116,
		122,
		138,
		141,
		143,
		133,
		122,
		128,
		125,
		147,
		133,
		131,
		150,
		166,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		133,
		117,
		122,
		-1,
		168,
		-1,
		141,
		143,
		137,
		122,
		119,
		130,
		128,
		139,
		156,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		149,
		129,
		123,
		122,
		163,
		163,
		149,
		135,
		128,
		125,
		122,
		135,
		155,
		146,
		158,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		166,
		154,
		144,
		134,
		168,
		169,
		154,
		147,
		133,
		135,
		133,
		131,
		136,
		157,
		158,
		171,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		155,
		-1,
		-1,
		146,
		144,
		154,
		150,
		137,
		157,
		160,
		146,
		130,
		145,
		157,
		165,
		170,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		136,
		157,
		182,
		149,
		-1,
		154,
		155,
		141,
		155,
		162,
		148,
		143,
		137,
		140,
		158,
		175,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		129,
		150,
		156,
		168,
		-1,
		163,
		157,
		143,
		160,
		161,
		158,
		149,
		141,
		146,
		143,
		156,
		170,
		174,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		210,
		187,
		160,
		164,
		157,
		151,
		151,
		167,
		169,
		180,
		148,
		144,
		145,
		149,
		148,
		165,
		175,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		237,
		-1,
		-1,
		173,
		164,
		155,
		158,
		161,
		164,
		154,
		151,
		156,
		161,
		149,
		158,
		176,
		180,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		244,
		191,
		173,
		169,
		167,
		160,
		169,
		164,
		159,
		169,
		178,
		170,
		151,
		162,
		185,
		174,
		212,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		196,
		171,
		186,
		232,
		180,
		187,
		206,
		203,
		-1,
		173,
		198,
		170,
		177,
		169,
		177,
		177,
		174,
		152,
		159,
		175,
		174,
		169,
		204,
		196,
		202,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		202,
		188,
		218,
		208,
		197,
		-1,
		-1,
		222,
		219,
		195,
		179,
		183,
		176,
		171,
		181,
		161,
		148,
		152,
		156,
		162,
		167,
		172,
		178,
		193,
		208,
		-1,
		174,
		255,
		248,
		231,
		239,
		270,
		-1,
		205,
		214,
		195,
		200,
		208,
		-1,
		-1,
		195,
		192,
		197,
		186,
		183,
		191,
		186,
		177,
		162,
		168,
		155,
		154,
		172,
		176,
		185,
		192,
		182,
		195,
		199,
		-1,
		188,
		231,
		225,
		228,
		252,
		266,
		-1,
		218,
		-1,
		-1,
		203,
		221,
		210,
		200,
		194,
		244,
		200,
		195,
		185,
		183,
		174,
		165,
		172,
		163,
		163,
		166,
		181,
		186,
		178,
		192,
		192,
		193,
		-1,
		223,
		211,
		219,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		219,
		-1,
		237,
		-1,
		212,
		216,
		208,
		211,
		199,
		186,
		178,
		170,
		186,
		161,
		171,
		167,
		168,
		177,
		188,
		200,
		199,
		200,
		297,
		252,
		219,
		210,
		257,
		272,
		276,
		-1,
		231,
		270,
		257,
		-1,
		228,
		-1,
		-1,
		-1,
		226,
		221,
		213,
		219,
		198,
		198,
		172,
		176,
		166,
		173,
		183,
		185,
		177,
		181,
		194,
		205,
		208,
		293,
		291,
		296,
		241,
		224,
		242,
		251,
		272,
		246,
		237,
		264,
		264,
		253,
		248,
		235,
		-1,
		-1,
		249,
		231,
		-1,
		-1,
		205,
		193,
		176,
		177,
		173,
		176,
		191,
		194,
		184,
		182,
		176,
		208,
		-1,
		293,
		292,
		281,
		278,
		254,
		245,
		232,
		243,
		-1,
		-1,
		249,
		265,
		278,
		282,
		295,
		320,
		-1,
		238,
		-1,
		-1,
		250,
		-1,
		-1,
		235,
		198,
		187,
		178,
		184,
		181,
		192,
		202,
		190,
		191,
		181,
		191,
		204,
		277,
		274,
		262,
		260,
		283,
		240,
		236,
		-1,
		259,
		252,
		258,
		265,
		282,
		309,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		233,
		231,
		220,
		-1,
		210,
		183,
		188,
		208,
		210,
		199,
		193,
		187,
		194,
		193,
		201,
		209,
		286,
		300,
		289,
		285,
		284,
		292,
		241,
		244,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		-1,
		271,
		264,
		-1,
		-1,
		228,
		221,
		209,
		197,
		187,
		197,
		201,
		205,
		197,
		190,
		185,
		196,
		188,
		192,
		209,
		-1,
		320,
		-1,
		272,
		258,
		272,
		287,
		295,
		-1,
		-1,
		-1,
		288,
		274,
		267,
		255,
		253,
		-1,
		262,
		246,
		227,
		-1,
		197,
		210,
		241,
		209,
		214,
		209,
		191,
		202,
		191,
		194,
		208,
		203,
		-1,
		-1,
		270,
		273,
		-1,
		-1,
		278,
		280,
		-1,
		279,
		268,
		253,
		245,
		-1,
		-1,
		234,
		230,
		-1,
		-1,
		198,
		223,
		212,
		220,
		215,
		195,
		201,
		204,
		193,
		197,
		209,
		-1,
		-1,
		277,
		278,
		283,
		-1,
		263,
		-1,
		281,
		-1,
		248,
		254,
		242,
		-1,
		-1,
		-1,
		236,
		199,
		220,
		230,
		224,
		222,
		213,
		199,
		206,
		204,
		200,
		211,
		-1,
		-1,
		-1,
		281,
		255,
		288,
		279,
		262,
		242,
		234,
		253,
		-1,
		223,
		-1,
		198,
		200,
		226,
		229,
		235,
		229,
		202,
		217,
		207,
		198,
		207,
		287,
		-1,
		257,
		290,
		254,
		248,
		224,
		228,
		244,
		-1,
		220,
		202,
		-1,
		230,
		220,
		251,
		236,
		217,
		204,
		211,
		211,
		204,
		-1,
		-1,
		-1,
		259,
		258,
		250,
		244,
		244,
		229,
		220,
		-1,
		232,
		214,
		193,
		210,
		210,
		201,
		209,
		241,
		237,
		224,
		224,
		216,
		-1,
		360,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		253,
		248,
		221,
		209,
		215,
		211,
		197,
		203,
		205,
		213,
		211,
		208,
		220,
		216,
		236,
		217,
		252,
		-1,
		355,
		-1,
		289,
		-1,
		-1,
		271,
		251,
		243,
		232,
		221,
		219,
		210,
		201,
		223,
		239,
		223,
		221,
		224,
		225,
		-1,
		344,
		343,
		-1,
		290,
		282,
		268,
		-1,
		261,
		-1,
		267,
		228,
		-1,
		230,
		210,
		-1,
		232,
		228,
		-1,
		-1,
		331,
		306,
		-1,
		-1,
		-1,
		291,
		271,
		262,
		246,
		-1,
		221,
		221,
		-1,
		-1,
		-1,
		316,
		315,
		-1,
		284,
		287,
		-1,
		277,
		268,
		276,
		223,
		227,
		-1,
		-1,
		-1,
		325,
		306,
		300,
		299,
		297,
		292,
		289,
		275,
		259,
		237,
		226,
		247,
		-1,
		-1,
		-1,
		297,
		289,
		282,
		-1,
		-1,
		284,
		267,
		248,
		246,
		-1,
		-1,
		-1,
		319,
		300,
		-1,
		-1,
		274,
		-1,
		-1,
		280,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		336,
		308,
		-1,
		-1,
		-1,
		270,
		266,
		267,
		-1,
		-1,
		-1,
		-1,
		330,
		331,
		354,
		318,
		-1,
		-1,
		-1,
		262,
		256,
		-1,
		-1,
		333,
		331,
		-1,
		-1,
		-1,
		290,
		274,
		-1,
		260,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		295,
		-1,
		295,
		270,
		277,
		-1,
		-1,
		-1,
		-1,
		308,
		300,
		308,
		-1,
		280,
		282,
		-1,
		330,
		-1,
		-1,
		323,
		314,
		-1,
		-1,
		285,
		292,
		314,
		317,
		353,
		-1,
		304
	],
	[
		-1,
		209,
		198,
		209,
		217,
		190,
		197,
		-1,
		218,
		220,
		186,
		180,
		219,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		209,
		208,
		178,
		176,
		185,
		190,
		197,
		-1,
		214,
		-1,
		230,
		209,
		220,
		225,
		171,
		168,
		188,
		207,
		207,
		199,
		245,
		201,
		172,
		166,
		184,
		189,
		201,
		193,
		-1,
		172,
		162,
		184,
		181,
		192,
		183,
		-1,
		-1,
		166,
		167,
		173,
		177,
		183,
		179,
		-1,
		189,
		173,
		-1,
		-1,
		156,
		169,
		159,
		162,
		170,
		168,
		181,
		173,
		168,
		-1,
		-1,
		157,
		161,
		168,
		155,
		151,
		168,
		181,
		163,
		177,
		176,
		-1,
		145,
		163,
		172,
		162,
		160,
		144,
		142,
		160,
		162,
		168,
		171,
		-1,
		137,
		139,
		163,
		171,
		176,
		160,
		147,
		147,
		157,
		150,
		169,
		160,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		134,
		142,
		163,
		155,
		149,
		164,
		157,
		150,
		147,
		145,
		142,
		158,
		159,
		169,
		-1,
		-1,
		204,
		173,
		208,
		165,
		150,
		-1,
		130,
		139,
		144,
		148,
		147,
		140,
		154,
		150,
		-1,
		136,
		135,
		166,
		152,
		163,
		164,
		-1,
		-1,
		162,
		154,
		139,
		142,
		129,
		125,
		136,
		135,
		131,
		129,
		125,
		137,
		140,
		140,
		146,
		130,
		140,
		144,
		155,
		170,
		-1,
		-1,
		225,
		-1,
		-1,
		161,
		144,
		-1,
		127,
		134,
		134,
		141,
		127,
		120,
		146,
		122,
		119,
		140,
		128,
		135,
		132,
		145,
		133,
		127,
		152,
		156,
		150,
		171,
		166,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		120,
		123,
		129,
		152,
		137,
		-1,
		82,
		88,
		112,
		109,
		119,
		132,
		126,
		139,
		124,
		131,
		130,
		134,
		136,
		169,
		147,
		169,
		166,
		195,
		200,
		194,
		203,
		-1,
		169,
		165,
		161,
		168,
		117,
		-1,
		-1,
		148,
		-1,
		106,
		99,
		74,
		92,
		95,
		110,
		101,
		133,
		122,
		133,
		122,
		119,
		127,
		136,
		147,
		142,
		141,
		159,
		174,
		187,
		191,
		197,
		-1,
		219,
		-1,
		161,
		145,
		147,
		119,
		140,
		-1,
		160,
		105,
		91,
		76,
		67,
		-1,
		87,
		90,
		116,
		123,
		114,
		131,
		123,
		121,
		126,
		131,
		145,
		136,
		154,
		161,
		169,
		173,
		193,
		205,
		179,
		169,
		-1,
		151,
		156,
		115,
		123,
		142,
		109,
		73,
		-1,
		68,
		-1,
		77,
		102,
		-1,
		122,
		126,
		113,
		114,
		109,
		124,
		130,
		127,
		124,
		142,
		145,
		162,
		166,
		182,
		-1,
		-1,
		164,
		168,
		157,
		108,
		127,
		151,
		119,
		66,
		55,
		54,
		-1,
		62,
		145,
		142,
		128,
		115,
		106,
		107,
		115,
		128,
		107,
		126,
		129,
		151,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		134,
		105,
		129,
		133,
		84,
		77,
		65,
		30,
		30,
		37,
		-1,
		135,
		118,
		115,
		104,
		102,
		115,
		110,
		126,
		130,
		129,
		148,
		160,
		151,
		171,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		100,
		123,
		160,
		22,
		9,
		0,
		29,
		35,
		40,
		138,
		135,
		102,
		111,
		103,
		92,
		106,
		114,
		118,
		127,
		136,
		142,
		166,
		166,
		172,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		114,
		121,
		153,
		14,
		138,
		-1,
		73,
		-1,
		46,
		80,
		88,
		94,
		106,
		92,
		97,
		108,
		120,
		133,
		129,
		136,
		171,
		171,
		156,
		176,
		179,
		-1,
		-1,
		-1,
		164,
		159,
		134,
		111,
		95,
		131,
		-1,
		108,
		109,
		-1,
		67,
		61,
		77,
		85,
		92,
		89,
		89,
		103,
		111,
		107,
		123,
		129,
		121,
		157,
		-1,
		164,
		158,
		166,
		156,
		144,
		-1,
		-1,
		-1,
		157,
		136,
		129,
		149,
		90,
		142,
		-1,
		-1,
		93,
		86,
		-1,
		64,
		73,
		80,
		89,
		94,
		99,
		107,
		102,
		115,
		120,
		126,
		131,
		149,
		153,
		157,
		146,
		142,
		139,
		153,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		110,
		-1,
		102,
		94,
		84,
		78,
		72,
		86,
		84,
		104,
		96,
		110,
		110,
		116,
		124,
		109,
		112,
		128,
		126,
		144,
		152,
		144,
		138,
		137,
		149,
		-1,
		177,
		163,
		134,
		-1,
		-1,
		123,
		-1,
		87,
		101,
		117,
		-1,
		110,
		89,
		104,
		82,
		96,
		92,
		130,
		131,
		109,
		114,
		122,
		132,
		134,
		123,
		134,
		126,
		148,
		148,
		132,
		133,
		142,
		-1,
		183,
		170,
		128,
		124,
		113,
		133,
		84,
		72,
		104,
		-1,
		-1,
		146,
		-1,
		80,
		97,
		106,
		104,
		120,
		111,
		117,
		133,
		136,
		138,
		128,
		117,
		123,
		120,
		142,
		128,
		126,
		145,
		161,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		99,
		86,
		80,
		-1,
		121,
		-1,
		124,
		114,
		98,
		83,
		116,
		-1,
		128,
		112,
		117,
		-1,
		163,
		-1,
		136,
		138,
		132,
		117,
		114,
		125,
		123,
		134,
		151,
		-1,
		133,
		118,
		111,
		101,
		115,
		86,
		-1,
		141,
		-1,
		-1,
		111,
		105,
		105,
		89,
		92,
		144,
		124,
		118,
		117,
		158,
		158,
		144,
		130,
		123,
		120,
		117,
		130,
		150,
		141,
		153,
		-1,
		-1,
		-1,
		138,
		124,
		128,
		88,
		107,
		-1,
		-1,
		173,
		128,
		114,
		-1,
		98,
		161,
		149,
		139,
		129,
		163,
		164,
		149,
		142,
		128,
		130,
		128,
		126,
		131,
		152,
		153,
		166,
		-1,
		-1,
		121,
		126,
		114,
		100,
		119,
		-1,
		-1,
		-1,
		120,
		136,
		128,
		99,
		150,
		-1,
		-1,
		141,
		139,
		149,
		145,
		132,
		152,
		155,
		141,
		125,
		140,
		152,
		160,
		165,
		-1,
		124,
		111,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		131,
		152,
		177,
		144,
		-1,
		149,
		150,
		136,
		150,
		157,
		143,
		138,
		132,
		135,
		153,
		170,
		-1,
		-1,
		136,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		110,
		124,
		145,
		151,
		163,
		-1,
		158,
		152,
		138,
		155,
		156,
		153,
		144,
		136,
		141,
		138,
		151,
		165,
		169,
		159,
		-1,
		142,
		-1,
		-1,
		-1,
		128,
		143,
		205,
		182,
		155,
		159,
		152,
		146,
		146,
		162,
		164,
		175,
		143,
		139,
		140,
		144,
		143,
		160,
		170,
		-1,
		-1,
		142,
		159,
		154,
		136,
		140,
		232,
		-1,
		-1,
		168,
		159,
		150,
		153,
		156,
		159,
		149,
		146,
		151,
		156,
		144,
		153,
		171,
		175,
		-1,
		-1,
		-1,
		162,
		-1,
		177,
		-1,
		-1,
		155,
		239,
		186,
		168,
		164,
		162,
		155,
		164,
		159,
		154,
		164,
		173,
		165,
		146,
		157,
		180,
		169,
		207,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		191,
		166,
		181,
		227,
		175,
		182,
		201,
		198,
		-1,
		168,
		193,
		165,
		172,
		164,
		172,
		172,
		169,
		147,
		154,
		170,
		169,
		164,
		199,
		191,
		197,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		197,
		183,
		213,
		203,
		192,
		-1,
		-1,
		217,
		214,
		190,
		174,
		178,
		171,
		166,
		176,
		156,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		169,
		250,
		243,
		226,
		234,
		265,
		-1,
		200,
		209,
		190,
		195,
		203,
		-1,
		-1,
		190,
		187,
		192,
		181,
		178,
		186,
		181,
		172,
		157,
		163,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		183,
		226,
		220,
		223,
		247,
		261,
		-1,
		213,
		-1,
		-1,
		198,
		216,
		205,
		195,
		189,
		239,
		195,
		190,
		180,
		178,
		169,
		160,
		167,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		218,
		206,
		214,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		214,
		-1,
		232,
		-1,
		207,
		211,
		203,
		206,
		194,
		181,
		173,
		165,
		181,
		156,
		166,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		292,
		247,
		214,
		205,
		252,
		267,
		271,
		-1,
		226,
		265,
		252,
		-1,
		223,
		-1,
		-1,
		-1,
		221,
		216,
		208,
		214,
		193,
		193,
		167,
		171,
		161,
		168,
		178,
		180,
		172,
		176,
		189,
		200,
		203,
		288,
		286,
		291,
		236,
		219,
		237,
		246,
		267,
		241,
		232,
		259,
		259,
		248,
		243,
		230,
		-1,
		-1,
		244,
		226,
		-1,
		-1,
		200,
		188,
		171,
		172,
		168,
		171,
		186,
		189,
		179,
		177,
		171,
		203,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		227,
		238,
		-1,
		-1,
		244,
		260,
		273,
		277,
		290,
		315,
		-1,
		233,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		176,
		187,
		197,
		185,
		186,
		176,
		186,
		199,
		272,
		269,
		257,
		255,
		278,
		235,
		231,
		-1,
		254,
		247,
		253,
		260,
		277,
		304,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		178,
		183,
		203,
		205,
		194,
		188,
		182,
		189,
		188,
		196,
		204,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		239,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		266,
		259,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		196,
		200,
		192,
		185,
		180,
		191,
		183,
		187,
		204,
		-1,
		315,
		-1,
		267,
		253,
		267,
		282,
		290,
		-1,
		-1,
		-1,
		283,
		269,
		262,
		250,
		248,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		186,
		197,
		186,
		189,
		203,
		198,
		-1,
		-1,
		265,
		268,
		-1,
		-1,
		273,
		275,
		-1,
		274,
		263,
		248,
		240,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		190,
		196,
		199,
		188,
		192,
		204,
		-1,
		-1,
		272,
		273,
		278,
		-1,
		258,
		-1,
		276,
		-1,
		243,
		249,
		237,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		219,
		217,
		208,
		194,
		201,
		199,
		195,
		206,
		-1,
		-1,
		-1,
		276,
		250,
		283,
		274,
		257,
		237,
		229,
		248,
		-1,
		218,
		-1,
		193,
		195,
		221,
		224,
		230,
		224,
		197,
		212,
		202,
		193,
		202,
		282,
		-1,
		252,
		285,
		249,
		243,
		219,
		223,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		246,
		231,
		212,
		199,
		206,
		206,
		199,
		-1,
		-1,
		-1,
		254,
		253,
		245,
		239,
		239,
		224,
		215,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		236,
		232,
		219,
		219,
		211,
		-1,
		355,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		248,
		243,
		216,
		204,
		210,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		212,
		247,
		-1,
		350,
		-1,
		284,
		-1,
		-1,
		266,
		246,
		238,
		227,
		216,
		214,
		205,
		196,
		218,
		234,
		218,
		216,
		219,
		220,
		-1,
		339,
		338,
		-1,
		285,
		277,
		263,
		-1,
		256,
		-1,
		262,
		223,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		326,
		301,
		-1,
		-1,
		-1,
		286,
		266,
		257,
		241,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		311,
		310,
		-1,
		279,
		282,
		-1,
		272,
		263,
		271,
		218,
		222,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		294,
		292,
		287,
		284,
		270,
		254,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		292,
		284,
		277,
		-1,
		-1,
		279,
		262,
		243,
		241,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		303,
		-1,
		-1,
		-1,
		265,
		261,
		262,
		-1,
		-1,
		-1,
		-1,
		325,
		326,
		349,
		313,
		-1,
		-1,
		-1,
		257,
		251,
		-1,
		-1,
		328,
		326,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		255,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		290,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		280,
		287,
		309,
		312,
		348,
		-1,
		299
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		200,
		202,
		168,
		162,
		201,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		191,
		190,
		160,
		158,
		167,
		172,
		179,
		-1,
		195,
		-1,
		212,
		191,
		202,
		207,
		153,
		150,
		170,
		189,
		188,
		180,
		227,
		183,
		154,
		148,
		166,
		171,
		182,
		174,
		-1,
		154,
		144,
		166,
		162,
		173,
		165,
		-1,
		-1,
		148,
		149,
		155,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		138,
		151,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		139,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		127,
		145,
		154,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		152,
		-1,
		119,
		121,
		140,
		148,
		153,
		141,
		128,
		128,
		138,
		131,
		150,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		116,
		123,
		140,
		132,
		128,
		141,
		138,
		131,
		128,
		126,
		123,
		139,
		140,
		150,
		-1,
		-1,
		185,
		154,
		189,
		146,
		131,
		-1,
		112,
		116,
		121,
		125,
		126,
		121,
		135,
		131,
		-1,
		117,
		116,
		147,
		133,
		144,
		145,
		-1,
		-1,
		143,
		135,
		120,
		123,
		111,
		107,
		113,
		112,
		108,
		106,
		102,
		118,
		121,
		121,
		127,
		111,
		121,
		125,
		136,
		151,
		-1,
		-1,
		206,
		-1,
		-1,
		142,
		125,
		-1,
		108,
		115,
		115,
		123,
		109,
		102,
		123,
		99,
		96,
		117,
		105,
		116,
		113,
		126,
		114,
		108,
		133,
		137,
		131,
		152,
		147,
		-1,
		205,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		101,
		104,
		110,
		134,
		119,
		-1,
		64,
		70,
		92,
		86,
		96,
		109,
		107,
		120,
		105,
		112,
		111,
		115,
		117,
		150,
		128,
		150,
		147,
		176,
		181,
		175,
		184,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		130,
		-1,
		88,
		81,
		56,
		74,
		77,
		87,
		78,
		114,
		103,
		114,
		103,
		100,
		108,
		117,
		128,
		123,
		122,
		140,
		155,
		168,
		172,
		178,
		-1,
		200,
		-1,
		142,
		126,
		128,
		100,
		121,
		-1,
		142,
		87,
		73,
		58,
		49,
		-1,
		64,
		67,
		93,
		100,
		95,
		112,
		104,
		102,
		107,
		112,
		126,
		117,
		135,
		142,
		150,
		154,
		174,
		186,
		160,
		150,
		-1,
		132,
		137,
		96,
		104,
		123,
		91,
		55,
		-1,
		50,
		-1,
		54,
		79,
		-1,
		99,
		103,
		94,
		95,
		90,
		105,
		111,
		108,
		105,
		123,
		126,
		143,
		147,
		163,
		-1,
		-1,
		145,
		149,
		138,
		89,
		108,
		132,
		101,
		48,
		37,
		36,
		-1,
		39,
		126,
		123,
		109,
		96,
		87,
		88,
		96,
		109,
		88,
		107,
		110,
		132,
		160,
		138,
		150,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		115,
		86,
		110,
		115,
		66,
		59,
		47,
		12,
		1,
		14,
		-1,
		116,
		99,
		96,
		85,
		83,
		96,
		91,
		107,
		111,
		110,
		129,
		141,
		132,
		152,
		-1,
		-1,
		-1,
		145,
		134,
		135,
		81,
		104,
		141,
		45,
		31,
		36,
		0,
		12,
		21,
		119,
		116,
		83,
		92,
		84,
		73,
		87,
		95,
		99,
		108,
		117,
		123,
		147,
		147,
		153,
		-1,
		-1,
		152,
		142,
		126,
		128,
		125,
		95,
		102,
		134,
		36,
		119,
		-1,
		54,
		-1,
		27,
		61,
		69,
		75,
		87,
		73,
		78,
		89,
		101,
		114,
		110,
		117,
		152,
		152,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		145,
		140,
		115,
		92,
		76,
		112,
		-1,
		89,
		90,
		-1,
		48,
		42,
		58,
		66,
		73,
		70,
		70,
		84,
		92,
		88,
		104,
		110,
		102,
		138,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		138,
		117,
		110,
		130,
		71,
		123,
		-1,
		-1,
		74,
		67,
		-1,
		45,
		54,
		61,
		70,
		75,
		80,
		88,
		83,
		96,
		101,
		107,
		112,
		130,
		134,
		138,
		127,
		123,
		120,
		134,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		91,
		-1,
		83,
		75,
		65,
		59,
		53,
		67,
		65,
		85,
		77,
		91,
		91,
		97,
		105,
		90,
		93,
		109,
		107,
		125,
		133,
		125,
		119,
		118,
		130,
		-1,
		158,
		144,
		115,
		-1,
		-1,
		104,
		-1,
		68,
		82,
		98,
		-1,
		91,
		70,
		85,
		63,
		77,
		73,
		111,
		112,
		90,
		95,
		103,
		113,
		115,
		104,
		115,
		107,
		129,
		129,
		113,
		114,
		123,
		-1,
		164,
		151,
		109,
		105,
		94,
		114,
		65,
		53,
		85,
		-1,
		-1,
		127,
		-1,
		61,
		78,
		87,
		85,
		101,
		92,
		98,
		114,
		117,
		119,
		109,
		98,
		104,
		101,
		123,
		109,
		107,
		126,
		142,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		80,
		67,
		61,
		-1,
		102,
		-1,
		105,
		95,
		79,
		64,
		97,
		-1,
		109,
		93,
		98,
		-1,
		144,
		-1,
		117,
		119,
		113,
		98,
		95,
		106,
		104,
		115,
		132,
		-1,
		114,
		99,
		92,
		82,
		96,
		67,
		-1,
		122,
		-1,
		-1,
		92,
		86,
		86,
		70,
		73,
		125,
		105,
		99,
		98,
		139,
		139,
		125,
		111,
		104,
		101,
		98,
		111,
		131,
		122,
		134,
		-1,
		-1,
		-1,
		119,
		105,
		109,
		69,
		88,
		-1,
		-1,
		154,
		109,
		95,
		-1,
		79,
		142,
		130,
		120,
		110,
		144,
		145,
		130,
		123,
		109,
		111,
		109,
		107,
		112,
		133,
		134,
		147,
		-1,
		-1,
		102,
		107,
		95,
		81,
		100,
		-1,
		-1,
		-1,
		101,
		117,
		109,
		80,
		131,
		-1,
		-1,
		122,
		120,
		130,
		126,
		113,
		133,
		136,
		122,
		106,
		121,
		133,
		141,
		146,
		-1,
		105,
		92,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		-1,
		-1,
		134,
		100,
		112,
		133,
		158,
		125,
		-1,
		130,
		131,
		117,
		131,
		138,
		124,
		119,
		113,
		116,
		134,
		151,
		-1,
		-1,
		117,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		91,
		105,
		126,
		132,
		144,
		-1,
		139,
		133,
		119,
		136,
		137,
		134,
		125,
		117,
		122,
		119,
		132,
		146,
		150,
		140,
		-1,
		123,
		-1,
		-1,
		-1,
		109,
		124,
		186,
		163,
		136,
		140,
		133,
		127,
		127,
		143,
		145,
		156,
		124,
		120,
		121,
		125,
		124,
		141,
		151,
		-1,
		-1,
		123,
		140,
		135,
		117,
		121,
		213,
		-1,
		-1,
		149,
		140,
		131,
		134,
		137,
		140,
		130,
		127,
		132,
		137,
		125,
		134,
		152,
		156,
		-1,
		-1,
		-1,
		143,
		-1,
		158,
		-1,
		-1,
		136,
		220,
		167,
		149,
		145,
		143,
		136,
		145,
		140,
		135,
		145,
		154,
		146,
		127,
		138,
		161,
		150,
		188,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		172,
		147,
		162,
		208,
		156,
		163,
		182,
		179,
		-1,
		149,
		174,
		146,
		153,
		145,
		153,
		153,
		150,
		128,
		135,
		151,
		150,
		145,
		180,
		172,
		178,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		178,
		164,
		194,
		184,
		173,
		-1,
		-1,
		198,
		195,
		171,
		155,
		159,
		152,
		147,
		157,
		137,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		150,
		231,
		224,
		207,
		215,
		246,
		-1,
		181,
		190,
		171,
		176,
		184,
		-1,
		-1,
		171,
		168,
		173,
		162,
		159,
		167,
		162,
		153,
		138,
		144,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		164,
		207,
		201,
		204,
		228,
		242,
		-1,
		194,
		-1,
		-1,
		179,
		197,
		186,
		176,
		170,
		220,
		176,
		171,
		161,
		159,
		150,
		141,
		148,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		199,
		187,
		195,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		195,
		-1,
		213,
		-1,
		188,
		192,
		184,
		187,
		175,
		162,
		154,
		146,
		162,
		137,
		147,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		273,
		228,
		195,
		186,
		233,
		248,
		252,
		-1,
		207,
		246,
		233,
		-1,
		204,
		-1,
		-1,
		-1,
		202,
		197,
		189,
		195,
		174,
		174,
		148,
		152,
		142,
		149,
		159,
		161,
		153,
		157,
		170,
		181,
		184,
		269,
		267,
		272,
		217,
		200,
		218,
		227,
		248,
		222,
		213,
		240,
		240,
		229,
		224,
		211,
		-1,
		-1,
		225,
		207,
		-1,
		-1,
		181,
		169,
		152,
		153,
		149,
		152,
		167,
		170,
		160,
		158,
		152,
		184,
		-1,
		269,
		268,
		257,
		254,
		230,
		221,
		208,
		219,
		-1,
		-1,
		225,
		241,
		254,
		258,
		271,
		296,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		211,
		174,
		163,
		154,
		160,
		157,
		168,
		178,
		166,
		167,
		157,
		167,
		180,
		253,
		250,
		238,
		236,
		259,
		216,
		212,
		-1,
		235,
		228,
		234,
		241,
		258,
		285,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		209,
		207,
		196,
		-1,
		186,
		159,
		164,
		184,
		186,
		175,
		169,
		163,
		170,
		169,
		177,
		185,
		262,
		276,
		265,
		261,
		260,
		268,
		217,
		220,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		240,
		-1,
		-1,
		204,
		197,
		185,
		173,
		163,
		173,
		177,
		181,
		173,
		166,
		161,
		172,
		164,
		168,
		185,
		-1,
		296,
		-1,
		248,
		234,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		238,
		222,
		203,
		-1,
		173,
		186,
		217,
		185,
		190,
		185,
		167,
		178,
		167,
		170,
		184,
		179,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		254,
		256,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		210,
		206,
		-1,
		-1,
		174,
		199,
		188,
		196,
		191,
		171,
		177,
		180,
		169,
		173,
		185,
		-1,
		-1,
		253,
		254,
		259,
		-1,
		239,
		-1,
		257,
		-1,
		224,
		230,
		218,
		-1,
		-1,
		-1,
		212,
		175,
		196,
		206,
		200,
		198,
		189,
		175,
		182,
		180,
		176,
		187,
		-1,
		-1,
		-1,
		257,
		231,
		264,
		255,
		238,
		218,
		210,
		229,
		-1,
		199,
		-1,
		174,
		176,
		202,
		205,
		211,
		205,
		178,
		193,
		183,
		174,
		183,
		263,
		-1,
		233,
		266,
		230,
		224,
		200,
		204,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		227,
		212,
		193,
		180,
		187,
		187,
		180,
		-1,
		-1,
		-1,
		235,
		234,
		226,
		220,
		220,
		205,
		196,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		217,
		213,
		200,
		200,
		192,
		-1,
		336,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		229,
		224,
		197,
		185,
		191,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		193,
		228,
		-1,
		331,
		-1,
		265,
		-1,
		-1,
		247,
		227,
		219,
		208,
		197,
		195,
		186,
		177,
		199,
		215,
		199,
		197,
		200,
		201,
		-1,
		320,
		319,
		-1,
		266,
		258,
		244,
		-1,
		237,
		-1,
		243,
		204,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		307,
		282,
		-1,
		-1,
		-1,
		267,
		247,
		238,
		222,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		292,
		291,
		-1,
		260,
		263,
		-1,
		253,
		244,
		252,
		199,
		203,
		-1,
		-1,
		-1,
		301,
		282,
		276,
		275,
		273,
		268,
		265,
		251,
		235,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		273,
		265,
		258,
		-1,
		-1,
		260,
		243,
		224,
		222,
		-1,
		-1,
		-1,
		295,
		276,
		-1,
		-1,
		250,
		-1,
		-1,
		256,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		284,
		-1,
		-1,
		-1,
		246,
		242,
		243,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		330,
		294,
		-1,
		-1,
		-1,
		238,
		232,
		-1,
		-1,
		309,
		307,
		-1,
		-1,
		-1,
		266,
		250,
		-1,
		236,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		271,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		284,
		276,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		299,
		290,
		-1,
		-1,
		261,
		268,
		290,
		293,
		329,
		-1,
		280
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		192,
		194,
		160,
		154,
		193,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		183,
		182,
		152,
		150,
		159,
		164,
		171,
		-1,
		183,
		-1,
		204,
		183,
		194,
		199,
		145,
		142,
		162,
		181,
		176,
		168,
		219,
		175,
		146,
		140,
		158,
		161,
		170,
		162,
		-1,
		146,
		136,
		158,
		150,
		161,
		153,
		-1,
		-1,
		140,
		141,
		147,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		130,
		143,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		131,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		119,
		137,
		146,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		140,
		-1,
		120,
		122,
		128,
		136,
		141,
		129,
		116,
		116,
		126,
		119,
		138,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		111,
		128,
		120,
		116,
		129,
		126,
		119,
		116,
		114,
		111,
		127,
		128,
		138,
		-1,
		-1,
		173,
		142,
		177,
		134,
		119,
		-1,
		113,
		104,
		109,
		113,
		114,
		109,
		123,
		119,
		-1,
		105,
		104,
		135,
		121,
		132,
		133,
		-1,
		-1,
		131,
		123,
		108,
		111,
		108,
		108,
		101,
		100,
		96,
		94,
		90,
		106,
		109,
		109,
		115,
		99,
		109,
		113,
		124,
		139,
		-1,
		-1,
		194,
		-1,
		-1,
		130,
		113,
		-1,
		96,
		103,
		103,
		120,
		110,
		103,
		111,
		87,
		84,
		105,
		93,
		104,
		101,
		114,
		102,
		96,
		121,
		125,
		119,
		140,
		135,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		89,
		92,
		98,
		122,
		120,
		-1,
		65,
		71,
		80,
		74,
		84,
		97,
		95,
		108,
		93,
		100,
		99,
		103,
		105,
		138,
		116,
		138,
		135,
		164,
		169,
		163,
		172,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		126,
		-1,
		89,
		82,
		57,
		75,
		78,
		75,
		66,
		102,
		91,
		102,
		91,
		88,
		96,
		105,
		116,
		111,
		110,
		128,
		143,
		156,
		160,
		166,
		-1,
		188,
		-1,
		130,
		114,
		116,
		88,
		109,
		-1,
		143,
		88,
		74,
		59,
		50,
		-1,
		52,
		55,
		81,
		88,
		83,
		100,
		92,
		90,
		95,
		100,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		148,
		138,
		-1,
		120,
		125,
		84,
		92,
		111,
		92,
		56,
		-1,
		51,
		-1,
		42,
		67,
		-1,
		87,
		91,
		82,
		83,
		78,
		93,
		99,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		133,
		137,
		126,
		77,
		96,
		120,
		102,
		49,
		38,
		37,
		-1,
		27,
		114,
		111,
		97,
		84,
		75,
		76,
		84,
		97,
		76,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		103,
		74,
		98,
		116,
		67,
		60,
		48,
		13,
		11,
		2,
		-1,
		104,
		87,
		84,
		73,
		71,
		84,
		79,
		95,
		99,
		98,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		69,
		92,
		129,
		46,
		32,
		37,
		12,
		0,
		9,
		107,
		104,
		71,
		80,
		72,
		61,
		75,
		83,
		87,
		96,
		105,
		111,
		135,
		135,
		141,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		83,
		90,
		122,
		37,
		107,
		-1,
		42,
		-1,
		15,
		49,
		57,
		63,
		75,
		61,
		66,
		77,
		89,
		102,
		98,
		105,
		140,
		140,
		125,
		145,
		148,
		-1,
		-1,
		-1,
		133,
		128,
		103,
		80,
		64,
		100,
		-1,
		77,
		78,
		-1,
		36,
		30,
		46,
		54,
		61,
		58,
		58,
		72,
		80,
		76,
		92,
		98,
		90,
		126,
		-1,
		133,
		127,
		135,
		125,
		113,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		59,
		111,
		-1,
		-1,
		62,
		55,
		-1,
		33,
		42,
		49,
		58,
		63,
		68,
		76,
		71,
		84,
		89,
		95,
		100,
		118,
		122,
		126,
		115,
		111,
		108,
		122,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		79,
		-1,
		71,
		63,
		53,
		47,
		41,
		55,
		53,
		73,
		65,
		79,
		79,
		85,
		93,
		78,
		81,
		97,
		95,
		113,
		121,
		113,
		107,
		106,
		118,
		-1,
		146,
		132,
		103,
		-1,
		-1,
		92,
		-1,
		56,
		70,
		86,
		-1,
		79,
		58,
		73,
		51,
		65,
		61,
		99,
		100,
		78,
		83,
		91,
		101,
		103,
		92,
		103,
		95,
		117,
		117,
		101,
		102,
		111,
		-1,
		152,
		139,
		97,
		93,
		82,
		102,
		53,
		41,
		73,
		-1,
		-1,
		115,
		-1,
		49,
		66,
		75,
		73,
		89,
		80,
		86,
		102,
		105,
		107,
		97,
		86,
		92,
		89,
		111,
		97,
		95,
		114,
		130,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		68,
		55,
		49,
		-1,
		90,
		-1,
		93,
		83,
		67,
		52,
		85,
		-1,
		97,
		81,
		86,
		-1,
		132,
		-1,
		105,
		107,
		101,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		102,
		87,
		80,
		70,
		84,
		55,
		-1,
		110,
		-1,
		-1,
		80,
		74,
		74,
		58,
		61,
		113,
		93,
		87,
		86,
		127,
		127,
		113,
		99,
		92,
		89,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		107,
		93,
		97,
		57,
		76,
		-1,
		-1,
		142,
		97,
		83,
		-1,
		67,
		130,
		118,
		108,
		98,
		132,
		133,
		118,
		111,
		97,
		99,
		97,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		90,
		95,
		83,
		69,
		88,
		-1,
		-1,
		-1,
		89,
		105,
		97,
		68,
		119,
		-1,
		-1,
		110,
		108,
		118,
		114,
		101,
		121,
		124,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		93,
		80,
		-1,
		-1,
		91,
		85,
		-1,
		-1,
		-1,
		-1,
		122,
		88,
		100,
		121,
		146,
		113,
		-1,
		118,
		119,
		105,
		119,
		126,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		105,
		-1,
		100,
		-1,
		-1,
		-1,
		-1,
		79,
		93,
		114,
		120,
		132,
		-1,
		127,
		121,
		107,
		124,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		128,
		-1,
		111,
		-1,
		-1,
		-1,
		97,
		112,
		174,
		151,
		124,
		128,
		121,
		115,
		115,
		131,
		133,
		144,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		111,
		128,
		123,
		105,
		109,
		201,
		-1,
		-1,
		137,
		128,
		119,
		122,
		125,
		128,
		118,
		115,
		120,
		125,
		113,
		122,
		140,
		144,
		-1,
		-1,
		-1,
		131,
		-1,
		146,
		-1,
		-1,
		124,
		208,
		155,
		137,
		133,
		131,
		124,
		133,
		128,
		123,
		133,
		142,
		134,
		115,
		126,
		149,
		138,
		176,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		160,
		135,
		150,
		196,
		144,
		151,
		170,
		167,
		-1,
		137,
		162,
		134,
		141,
		133,
		141,
		141,
		138,
		116,
		123,
		139,
		138,
		133,
		168,
		160,
		166,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		166,
		152,
		182,
		172,
		161,
		-1,
		-1,
		186,
		183,
		159,
		143,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		138,
		219,
		212,
		195,
		203,
		234,
		-1,
		169,
		178,
		159,
		164,
		172,
		-1,
		-1,
		159,
		156,
		161,
		150,
		147,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		152,
		195,
		189,
		192,
		216,
		230,
		-1,
		182,
		-1,
		-1,
		167,
		185,
		174,
		164,
		158,
		208,
		164,
		159,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		187,
		175,
		183,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		183,
		-1,
		201,
		-1,
		176,
		180,
		172,
		175,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		261,
		216,
		183,
		174,
		221,
		236,
		240,
		-1,
		195,
		234,
		221,
		-1,
		192,
		-1,
		-1,
		-1,
		190,
		185,
		177,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		257,
		255,
		260,
		205,
		188,
		206,
		215,
		236,
		210,
		201,
		228,
		228,
		217,
		212,
		199,
		-1,
		-1,
		213,
		195,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		196,
		207,
		-1,
		-1,
		213,
		229,
		242,
		246,
		259,
		284,
		-1,
		202,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		241,
		238,
		226,
		224,
		247,
		204,
		200,
		-1,
		223,
		216,
		222,
		229,
		246,
		273,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		208,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		228,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		284,
		-1,
		236,
		222,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		234,
		237,
		-1,
		-1,
		242,
		244,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		241,
		242,
		247,
		-1,
		227,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		212,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		324,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		191,
		193,
		159,
		153,
		192,
		163,
		169,
		180,
		-1,
		-1,
		-1,
		182,
		181,
		151,
		149,
		158,
		163,
		170,
		-1,
		174,
		-1,
		203,
		182,
		193,
		198,
		144,
		141,
		161,
		180,
		167,
		159,
		218,
		174,
		145,
		139,
		157,
		152,
		161,
		153,
		-1,
		145,
		135,
		157,
		141,
		152,
		144,
		-1,
		-1,
		139,
		140,
		146,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		129,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		118,
		136,
		145,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		131,
		-1,
		111,
		113,
		123,
		131,
		136,
		120,
		107,
		107,
		117,
		110,
		129,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		110,
		127,
		119,
		109,
		124,
		117,
		110,
		107,
		105,
		102,
		118,
		119,
		129,
		-1,
		-1,
		164,
		133,
		168,
		125,
		110,
		-1,
		104,
		103,
		109,
		113,
		107,
		100,
		114,
		110,
		-1,
		96,
		95,
		126,
		112,
		123,
		124,
		-1,
		-1,
		122,
		114,
		99,
		102,
		99,
		99,
		107,
		106,
		102,
		95,
		91,
		97,
		100,
		100,
		106,
		90,
		100,
		104,
		115,
		130,
		-1,
		-1,
		185,
		-1,
		-1,
		121,
		104,
		-1,
		87,
		94,
		94,
		111,
		101,
		108,
		117,
		93,
		90,
		105,
		93,
		95,
		92,
		105,
		93,
		87,
		112,
		116,
		110,
		131,
		126,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		80,
		83,
		89,
		113,
		123,
		-1,
		70,
		76,
		86,
		80,
		90,
		98,
		86,
		99,
		84,
		91,
		90,
		94,
		96,
		129,
		107,
		129,
		126,
		155,
		160,
		154,
		163,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		117,
		-1,
		94,
		87,
		62,
		80,
		83,
		81,
		72,
		93,
		82,
		93,
		82,
		79,
		87,
		96,
		107,
		102,
		101,
		119,
		134,
		147,
		151,
		157,
		-1,
		179,
		-1,
		121,
		105,
		107,
		79,
		100,
		-1,
		137,
		93,
		79,
		64,
		55,
		-1,
		58,
		61,
		87,
		89,
		74,
		91,
		83,
		81,
		86,
		91,
		105,
		96,
		114,
		121,
		129,
		133,
		153,
		165,
		139,
		129,
		-1,
		111,
		116,
		75,
		83,
		102,
		97,
		61,
		-1,
		56,
		-1,
		48,
		73,
		-1,
		93,
		91,
		73,
		74,
		69,
		84,
		90,
		87,
		84,
		102,
		105,
		122,
		126,
		142,
		-1,
		-1,
		124,
		128,
		117,
		68,
		87,
		111,
		107,
		54,
		43,
		42,
		-1,
		33,
		105,
		102,
		88,
		75,
		66,
		67,
		75,
		88,
		67,
		86,
		89,
		111,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		94,
		65,
		89,
		121,
		72,
		65,
		53,
		18,
		18,
		12,
		-1,
		95,
		78,
		75,
		64,
		62,
		75,
		70,
		86,
		90,
		89,
		108,
		120,
		111,
		131,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		60,
		83,
		120,
		51,
		37,
		42,
		17,
		10,
		0,
		98,
		95,
		62,
		71,
		63,
		52,
		66,
		74,
		78,
		87,
		96,
		102,
		126,
		126,
		132,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		74,
		81,
		113,
		42,
		98,
		-1,
		33,
		-1,
		6,
		40,
		48,
		54,
		66,
		52,
		57,
		68,
		80,
		93,
		89,
		96,
		131,
		131,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		124,
		119,
		94,
		71,
		55,
		91,
		-1,
		68,
		69,
		-1,
		27,
		21,
		37,
		45,
		52,
		49,
		49,
		63,
		71,
		67,
		83,
		89,
		81,
		117,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		117,
		96,
		89,
		109,
		50,
		102,
		-1,
		-1,
		53,
		46,
		-1,
		24,
		33,
		40,
		49,
		54,
		59,
		67,
		62,
		75,
		80,
		86,
		91,
		109,
		113,
		117,
		106,
		102,
		99,
		113,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		70,
		-1,
		62,
		54,
		44,
		38,
		32,
		46,
		44,
		64,
		56,
		70,
		70,
		76,
		84,
		69,
		72,
		88,
		86,
		104,
		112,
		104,
		98,
		97,
		109,
		-1,
		137,
		123,
		94,
		-1,
		-1,
		83,
		-1,
		47,
		61,
		77,
		-1,
		70,
		49,
		64,
		42,
		56,
		52,
		90,
		91,
		69,
		74,
		82,
		92,
		94,
		83,
		94,
		86,
		108,
		108,
		92,
		93,
		102,
		-1,
		143,
		130,
		88,
		84,
		73,
		93,
		44,
		32,
		64,
		-1,
		-1,
		106,
		-1,
		40,
		57,
		66,
		64,
		80,
		71,
		77,
		93,
		96,
		98,
		88,
		77,
		83,
		80,
		102,
		88,
		86,
		105,
		121,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		59,
		46,
		40,
		-1,
		81,
		-1,
		84,
		74,
		58,
		43,
		76,
		-1,
		88,
		72,
		77,
		-1,
		123,
		-1,
		96,
		98,
		92,
		77,
		74,
		85,
		83,
		94,
		111,
		-1,
		93,
		78,
		71,
		61,
		75,
		46,
		-1,
		101,
		-1,
		-1,
		71,
		65,
		65,
		49,
		52,
		104,
		84,
		78,
		77,
		118,
		118,
		104,
		90,
		83,
		80,
		77,
		90,
		110,
		101,
		113,
		-1,
		-1,
		-1,
		98,
		84,
		88,
		48,
		67,
		-1,
		-1,
		133,
		88,
		74,
		-1,
		58,
		121,
		109,
		99,
		89,
		123,
		124,
		109,
		102,
		88,
		90,
		88,
		86,
		91,
		112,
		113,
		126,
		-1,
		-1,
		81,
		86,
		74,
		60,
		79,
		-1,
		-1,
		-1,
		80,
		96,
		88,
		59,
		110,
		-1,
		-1,
		101,
		99,
		109,
		105,
		92,
		112,
		115,
		101,
		85,
		100,
		112,
		120,
		125,
		-1,
		84,
		71,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		91,
		112,
		137,
		104,
		-1,
		109,
		110,
		96,
		110,
		117,
		103,
		98,
		92,
		95,
		113,
		130,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		70,
		84,
		105,
		111,
		123,
		-1,
		118,
		112,
		98,
		115,
		116,
		113,
		104,
		96,
		101,
		98,
		111,
		125,
		129,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		88,
		103,
		165,
		142,
		115,
		119,
		112,
		106,
		106,
		122,
		124,
		135,
		103,
		99,
		100,
		104,
		103,
		120,
		130,
		-1,
		-1,
		102,
		119,
		114,
		96,
		100,
		192,
		-1,
		-1,
		128,
		119,
		110,
		113,
		116,
		119,
		109,
		106,
		111,
		116,
		104,
		113,
		131,
		135,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		115,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		133,
		125,
		106,
		117,
		140,
		129,
		167,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		135,
		142,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		124,
		132,
		132,
		129,
		107,
		114,
		130,
		129,
		124,
		159,
		151,
		157,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		157,
		143,
		173,
		163,
		152,
		-1,
		-1,
		177,
		174,
		150,
		134,
		138,
		131,
		126,
		136,
		116,
		103,
		107,
		111,
		117,
		122,
		127,
		133,
		148,
		163,
		-1,
		129,
		210,
		203,
		186,
		194,
		225,
		-1,
		160,
		169,
		150,
		155,
		163,
		-1,
		-1,
		150,
		147,
		152,
		141,
		138,
		146,
		141,
		132,
		117,
		123,
		110,
		109,
		127,
		131,
		140,
		147,
		137,
		150,
		154,
		-1,
		143,
		186,
		180,
		183,
		207,
		221,
		-1,
		173,
		-1,
		-1,
		158,
		176,
		165,
		155,
		149,
		199,
		155,
		150,
		140,
		138,
		129,
		120,
		127,
		118,
		118,
		121,
		136,
		141,
		133,
		147,
		147,
		148,
		-1,
		178,
		166,
		174,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		192,
		-1,
		167,
		171,
		163,
		166,
		154,
		141,
		133,
		125,
		141,
		116,
		126,
		122,
		123,
		132,
		143,
		155,
		154,
		155,
		252,
		207,
		174,
		165,
		212,
		227,
		231,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		181,
		176,
		168,
		174,
		153,
		153,
		127,
		131,
		121,
		128,
		138,
		140,
		132,
		136,
		149,
		160,
		163,
		248,
		246,
		251,
		196,
		179,
		197,
		206,
		227,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		204,
		186,
		-1,
		-1,
		160,
		148,
		131,
		132,
		128,
		131,
		146,
		149,
		139,
		137,
		131,
		163,
		-1,
		248,
		247,
		236,
		233,
		209,
		200,
		187,
		198,
		-1,
		-1,
		204,
		220,
		233,
		237,
		250,
		275,
		-1,
		193,
		-1,
		-1,
		205,
		-1,
		-1,
		190,
		153,
		142,
		133,
		139,
		136,
		147,
		157,
		145,
		146,
		136,
		146,
		159,
		232,
		229,
		217,
		215,
		238,
		195,
		191,
		-1,
		214,
		207,
		213,
		220,
		237,
		264,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		188,
		186,
		175,
		-1,
		165,
		138,
		143,
		163,
		165,
		154,
		148,
		142,
		149,
		148,
		156,
		164,
		241,
		255,
		244,
		240,
		239,
		247,
		196,
		199,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		226,
		219,
		-1,
		-1,
		183,
		176,
		164,
		152,
		142,
		152,
		156,
		160,
		152,
		145,
		140,
		151,
		143,
		147,
		164,
		-1,
		275,
		-1,
		227,
		213,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		243,
		229,
		222,
		210,
		208,
		-1,
		217,
		201,
		182,
		-1,
		152,
		165,
		196,
		164,
		169,
		164,
		146,
		157,
		146,
		149,
		163,
		158,
		-1,
		-1,
		225,
		228,
		-1,
		-1,
		233,
		235,
		-1,
		234,
		223,
		208,
		200,
		-1,
		-1,
		189,
		185,
		-1,
		-1,
		153,
		178,
		167,
		175,
		170,
		150,
		156,
		159,
		148,
		152,
		164,
		-1,
		-1,
		232,
		233,
		238,
		-1,
		218,
		-1,
		236,
		-1,
		203,
		209,
		197,
		-1,
		-1,
		-1,
		191,
		154,
		175,
		185,
		179,
		177,
		168,
		154,
		161,
		159,
		155,
		166,
		-1,
		-1,
		-1,
		236,
		210,
		243,
		234,
		217,
		197,
		189,
		208,
		-1,
		178,
		-1,
		153,
		155,
		181,
		184,
		190,
		184,
		157,
		172,
		162,
		153,
		162,
		242,
		-1,
		212,
		245,
		209,
		203,
		179,
		183,
		199,
		-1,
		175,
		157,
		-1,
		185,
		175,
		206,
		191,
		172,
		159,
		166,
		166,
		159,
		-1,
		-1,
		-1,
		214,
		213,
		205,
		199,
		199,
		184,
		175,
		-1,
		187,
		169,
		148,
		165,
		165,
		156,
		164,
		196,
		192,
		179,
		179,
		171,
		-1,
		315,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		208,
		203,
		176,
		164,
		170,
		166,
		152,
		158,
		160,
		168,
		166,
		163,
		175,
		171,
		191,
		172,
		207,
		-1,
		310,
		-1,
		244,
		-1,
		-1,
		226,
		206,
		198,
		187,
		176,
		174,
		165,
		156,
		178,
		194,
		178,
		176,
		179,
		180,
		-1,
		299,
		298,
		-1,
		245,
		237,
		223,
		-1,
		216,
		-1,
		222,
		183,
		-1,
		185,
		165,
		-1,
		187,
		183,
		-1,
		-1,
		286,
		261,
		-1,
		-1,
		-1,
		246,
		226,
		217,
		201,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		271,
		270,
		-1,
		239,
		242,
		-1,
		232,
		223,
		231,
		178,
		182,
		-1,
		-1,
		-1,
		280,
		261,
		255,
		254,
		252,
		247,
		244,
		230,
		214,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		252,
		244,
		237,
		-1,
		-1,
		239,
		222,
		203,
		201,
		-1,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		229,
		-1,
		-1,
		235,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		263,
		-1,
		-1,
		-1,
		225,
		221,
		222,
		-1,
		-1,
		-1,
		-1,
		285,
		286,
		309,
		273,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		288,
		286,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		169,
		171,
		137,
		131,
		170,
		141,
		147,
		158,
		-1,
		-1,
		-1,
		160,
		159,
		129,
		127,
		136,
		141,
		148,
		-1,
		171,
		-1,
		181,
		160,
		171,
		176,
		122,
		119,
		139,
		158,
		164,
		156,
		196,
		152,
		123,
		117,
		135,
		140,
		158,
		150,
		-1,
		123,
		113,
		135,
		139,
		151,
		134,
		-1,
		-1,
		117,
		118,
		124,
		136,
		141,
		145,
		-1,
		155,
		139,
		-1,
		-1,
		107,
		120,
		116,
		119,
		127,
		134,
		147,
		139,
		134,
		-1,
		-1,
		108,
		112,
		125,
		121,
		117,
		134,
		147,
		129,
		143,
		142,
		-1,
		96,
		114,
		123,
		128,
		126,
		110,
		108,
		126,
		128,
		134,
		137,
		-1,
		105,
		106,
		107,
		115,
		120,
		126,
		113,
		113,
		123,
		116,
		135,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		105,
		88,
		105,
		102,
		95,
		108,
		108,
		114,
		113,
		111,
		108,
		124,
		125,
		135,
		-1,
		-1,
		199,
		172,
		196,
		154,
		135,
		-1,
		101,
		81,
		87,
		91,
		93,
		91,
		105,
		101,
		-1,
		102,
		101,
		132,
		118,
		129,
		181,
		-1,
		-1,
		157,
		149,
		131,
		134,
		111,
		107,
		96,
		95,
		87,
		73,
		69,
		88,
		91,
		91,
		97,
		96,
		106,
		110,
		125,
		136,
		-1,
		-1,
		197,
		-1,
		-1,
		178,
		161,
		-1,
		126,
		133,
		117,
		123,
		109,
		130,
		106,
		92,
		88,
		83,
		71,
		84,
		83,
		96,
		87,
		93,
		118,
		122,
		122,
		143,
		138,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		133,
		130,
		123,
		147,
		146,
		-1,
		104,
		92,
		89,
		78,
		79,
		70,
		64,
		71,
		75,
		88,
		90,
		100,
		102,
		135,
		119,
		141,
		138,
		167,
		172,
		166,
		175,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		151,
		-1,
		154,
		141,
		116,
		89,
		92,
		74,
		61,
		65,
		60,
		65,
		76,
		73,
		93,
		106,
		113,
		114,
		113,
		131,
		146,
		159,
		163,
		169,
		-1,
		236,
		-1,
		178,
		162,
		164,
		140,
		163,
		-1,
		171,
		155,
		133,
		118,
		118,
		-1,
		79,
		76,
		66,
		44,
		52,
		69,
		73,
		77,
		92,
		103,
		117,
		108,
		126,
		133,
		141,
		145,
		165,
		177,
		196,
		186,
		-1,
		168,
		173,
		138,
		146,
		165,
		190,
		154,
		-1,
		129,
		-1,
		81,
		94,
		-1,
		50,
		34,
		43,
		60,
		74,
		87,
		99,
		99,
		96,
		114,
		117,
		134,
		138,
		154,
		-1,
		-1,
		181,
		185,
		180,
		131,
		150,
		174,
		200,
		147,
		136,
		135,
		-1,
		99,
		21,
		14,
		28,
		47,
		57,
		60,
		80,
		99,
		79,
		98,
		101,
		123,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		157,
		128,
		152,
		194,
		165,
		158,
		146,
		124,
		124,
		118,
		-1,
		20,
		36,
		52,
		64,
		72,
		87,
		84,
		98,
		102,
		101,
		120,
		132,
		123,
		143,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		109,
		0,
		24,
		55,
		64,
		73,
		64,
		80,
		88,
		90,
		99,
		108,
		114,
		138,
		145,
		151,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		114,
		-1,
		103,
		71,
		65,
		62,
		76,
		77,
		71,
		80,
		94,
		105,
		101,
		108,
		143,
		143,
		135,
		155,
		158,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		108,
		102,
		75,
		68,
		62,
		79,
		80,
		78,
		85,
		81,
		95,
		106,
		93,
		129,
		-1,
		143,
		137,
		145,
		135,
		123,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		86,
		78,
		83,
		78,
		82,
		86,
		90,
		79,
		92,
		97,
		98,
		108,
		128,
		132,
		136,
		125,
		121,
		118,
		132,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		107,
		92,
		97,
		97,
		93,
		101,
		86,
		89,
		101,
		105,
		123,
		131,
		123,
		117,
		116,
		128,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		95,
		117,
		118,
		96,
		101,
		100,
		110,
		111,
		100,
		113,
		105,
		127,
		127,
		111,
		112,
		121,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		109,
		107,
		107,
		98,
		104,
		111,
		114,
		115,
		105,
		94,
		100,
		99,
		121,
		107,
		105,
		124,
		140,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		115,
		99,
		104,
		-1,
		140,
		-1,
		113,
		115,
		107,
		96,
		93,
		104,
		102,
		113,
		130,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		131,
		111,
		105,
		104,
		135,
		133,
		121,
		105,
		98,
		95,
		96,
		109,
		129,
		120,
		132,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		148,
		136,
		126,
		116,
		150,
		149,
		124,
		117,
		103,
		105,
		103,
		105,
		110,
		131,
		132,
		145,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		137,
		-1,
		-1,
		128,
		126,
		136,
		120,
		107,
		127,
		130,
		120,
		104,
		119,
		131,
		139,
		144,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		154,
		161,
		165,
		131,
		-1,
		136,
		131,
		111,
		125,
		132,
		122,
		117,
		111,
		114,
		132,
		149,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		133,
		147,
		154,
		147,
		151,
		-1,
		139,
		127,
		113,
		130,
		135,
		132,
		123,
		115,
		120,
		117,
		130,
		144,
		148,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		151,
		166,
		193,
		170,
		143,
		138,
		131,
		125,
		121,
		137,
		143,
		154,
		122,
		118,
		119,
		123,
		122,
		139,
		149,
		-1,
		-1,
		165,
		182,
		177,
		159,
		163,
		220,
		-1,
		-1,
		147,
		138,
		129,
		132,
		131,
		134,
		128,
		125,
		130,
		135,
		123,
		132,
		150,
		149,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		178,
		218,
		165,
		147,
		143,
		141,
		134,
		143,
		138,
		133,
		143,
		145,
		137,
		125,
		129,
		152,
		141,
		180,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		214,
		189,
		204,
		229,
		198,
		205,
		180,
		177,
		-1,
		147,
		172,
		144,
		151,
		142,
		149,
		149,
		141,
		119,
		126,
		142,
		141,
		136,
		172,
		163,
		169,
		-1,
		-1,
		297,
		286,
		275,
		281,
		-1,
		220,
		206,
		215,
		205,
		208,
		-1,
		-1,
		196,
		193,
		169,
		152,
		150,
		143,
		138,
		148,
		128,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		192,
		273,
		266,
		249,
		257,
		288,
		-1,
		219,
		211,
		213,
		197,
		199,
		-1,
		-1,
		169,
		166,
		171,
		159,
		156,
		158,
		153,
		144,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		206,
		249,
		243,
		246,
		270,
		284,
		-1,
		216,
		-1,
		-1,
		221,
		200,
		184,
		174,
		168,
		218,
		173,
		168,
		152,
		150,
		141,
		132,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		241,
		229,
		237,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		237,
		-1,
		211,
		-1,
		186,
		190,
		181,
		184,
		166,
		153,
		145,
		137,
		153,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		287,
		243,
		237,
		228,
		268,
		283,
		287,
		-1,
		228,
		267,
		265,
		-1,
		246,
		-1,
		-1,
		-1,
		200,
		194,
		186,
		186,
		165,
		165,
		139,
		143,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		283,
		274,
		287,
		232,
		232,
		253,
		262,
		283,
		243,
		234,
		261,
		272,
		261,
		256,
		243,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		172,
		160,
		143,
		144,
		140,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		276,
		275,
		264,
		261,
		237,
		228,
		223,
		250,
		-1,
		-1,
		245,
		262,
		256,
		260,
		276,
		301,
		-1,
		232,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		165,
		154,
		145,
		151,
		148,
		159,
		169,
		157,
		158,
		148,
		158,
		171,
		260,
		257,
		245,
		243,
		266,
		231,
		219,
		-1,
		232,
		230,
		236,
		243,
		260,
		290,
		-1,
		-1,
		248,
		228,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		150,
		155,
		175,
		177,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		269,
		283,
		272,
		268,
		267,
		275,
		224,
		217,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		238,
		234,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		168,
		172,
		164,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		303,
		-1,
		255,
		231,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		255,
		241,
		234,
		222,
		220,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		208,
		176,
		181,
		176,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		245,
		247,
		-1,
		246,
		235,
		220,
		212,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		165,
		190,
		179,
		187,
		182,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		250,
		251,
		252,
		-1,
		230,
		-1,
		248,
		-1,
		215,
		221,
		209,
		-1,
		-1,
		-1,
		203,
		166,
		187,
		197,
		191,
		189,
		180,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		248,
		222,
		255,
		246,
		229,
		209,
		201,
		220,
		-1,
		190,
		-1,
		165,
		167,
		193,
		196,
		202,
		196,
		169,
		184,
		174,
		165,
		174,
		254,
		-1,
		224,
		257,
		221,
		215,
		191,
		195,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		218,
		203,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		226,
		225,
		217,
		211,
		211,
		196,
		187,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		208,
		204,
		191,
		191,
		183,
		-1,
		327,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		220,
		215,
		188,
		176,
		182,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		184,
		219,
		-1,
		322,
		-1,
		256,
		-1,
		-1,
		238,
		218,
		210,
		199,
		188,
		186,
		177,
		168,
		190,
		206,
		190,
		188,
		191,
		192,
		-1,
		311,
		310,
		-1,
		257,
		249,
		235,
		-1,
		228,
		-1,
		234,
		195,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		298,
		273,
		-1,
		-1,
		-1,
		258,
		238,
		229,
		213,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		283,
		282,
		-1,
		251,
		254,
		-1,
		244,
		235,
		243,
		190,
		194,
		-1,
		-1,
		-1,
		292,
		273,
		267,
		266,
		264,
		259,
		256,
		242,
		226,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		264,
		256,
		249,
		-1,
		-1,
		251,
		234,
		215,
		213,
		-1,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		241,
		-1,
		-1,
		247,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		275,
		-1,
		-1,
		-1,
		237,
		233,
		234,
		-1,
		-1,
		-1,
		-1,
		297,
		298,
		321,
		285,
		-1,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		300,
		298,
		-1,
		-1,
		-1,
		257,
		241,
		-1,
		227,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		262,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		275,
		267,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		290,
		281,
		-1,
		-1,
		252,
		259,
		281,
		284,
		320,
		-1,
		271
	],
	[
		-1,
		167,
		156,
		167,
		175,
		148,
		155,
		-1,
		176,
		178,
		144,
		138,
		177,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		167,
		166,
		136,
		134,
		143,
		148,
		155,
		-1,
		178,
		-1,
		188,
		167,
		178,
		183,
		129,
		126,
		146,
		165,
		171,
		163,
		203,
		159,
		130,
		124,
		142,
		147,
		165,
		157,
		-1,
		130,
		120,
		142,
		146,
		157,
		141,
		-1,
		-1,
		124,
		125,
		131,
		142,
		148,
		144,
		-1,
		154,
		138,
		-1,
		-1,
		114,
		127,
		123,
		126,
		134,
		133,
		146,
		138,
		133,
		-1,
		-1,
		115,
		119,
		132,
		120,
		116,
		133,
		146,
		128,
		142,
		141,
		-1,
		103,
		121,
		130,
		127,
		125,
		109,
		107,
		125,
		127,
		133,
		136,
		-1,
		112,
		113,
		114,
		122,
		127,
		125,
		112,
		112,
		122,
		115,
		134,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		112,
		95,
		112,
		109,
		102,
		115,
		117,
		115,
		112,
		110,
		107,
		123,
		124,
		134,
		-1,
		-1,
		206,
		179,
		203,
		161,
		142,
		-1,
		108,
		88,
		94,
		98,
		100,
		100,
		114,
		110,
		-1,
		101,
		100,
		131,
		117,
		128,
		183,
		-1,
		-1,
		164,
		156,
		138,
		141,
		118,
		114,
		103,
		102,
		94,
		80,
		76,
		97,
		100,
		100,
		106,
		95,
		105,
		109,
		120,
		135,
		-1,
		-1,
		190,
		-1,
		-1,
		180,
		163,
		-1,
		133,
		140,
		124,
		130,
		116,
		137,
		113,
		101,
		96,
		90,
		78,
		91,
		92,
		105,
		96,
		92,
		117,
		121,
		115,
		136,
		131,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		137,
		130,
		154,
		153,
		-1,
		113,
		101,
		98,
		87,
		88,
		79,
		71,
		80,
		84,
		96,
		95,
		99,
		101,
		134,
		112,
		134,
		131,
		160,
		165,
		159,
		168,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		158,
		-1,
		161,
		150,
		125,
		98,
		101,
		83,
		70,
		74,
		67,
		74,
		82,
		79,
		92,
		101,
		112,
		107,
		106,
		124,
		139,
		152,
		156,
		162,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		178,
		162,
		142,
		127,
		127,
		-1,
		88,
		85,
		75,
		53,
		59,
		76,
		79,
		83,
		91,
		96,
		110,
		101,
		119,
		126,
		134,
		138,
		158,
		170,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		138,
		-1,
		90,
		103,
		-1,
		59,
		43,
		49,
		60,
		74,
		89,
		95,
		92,
		89,
		107,
		110,
		127,
		131,
		147,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		108,
		39,
		36,
		22,
		29,
		47,
		53,
		74,
		93,
		72,
		91,
		94,
		116,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		4,
		22,
		34,
		57,
		61,
		75,
		77,
		91,
		95,
		94,
		113,
		125,
		116,
		136,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		105,
		31,
		0,
		44,
		46,
		55,
		57,
		73,
		81,
		83,
		92,
		101,
		107,
		131,
		138,
		144,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		110,
		-1,
		99,
		67,
		61,
		58,
		63,
		69,
		64,
		73,
		87,
		98,
		94,
		101,
		136,
		136,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		104,
		98,
		71,
		64,
		58,
		74,
		75,
		71,
		74,
		74,
		88,
		99,
		86,
		122,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		82,
		74,
		79,
		74,
		75,
		79,
		83,
		72,
		85,
		90,
		91,
		101,
		121,
		125,
		129,
		118,
		114,
		111,
		125,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		103,
		87,
		90,
		90,
		86,
		94,
		79,
		82,
		94,
		98,
		116,
		124,
		116,
		110,
		109,
		121,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		91,
		110,
		111,
		89,
		94,
		93,
		103,
		104,
		93,
		106,
		98,
		120,
		120,
		104,
		105,
		114,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		105,
		103,
		100,
		91,
		97,
		104,
		107,
		108,
		98,
		87,
		93,
		92,
		114,
		100,
		98,
		117,
		133,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		108,
		92,
		97,
		-1,
		133,
		-1,
		106,
		108,
		100,
		89,
		86,
		97,
		95,
		106,
		123,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		124,
		104,
		98,
		97,
		128,
		126,
		114,
		98,
		91,
		88,
		89,
		102,
		122,
		113,
		125,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		141,
		129,
		119,
		109,
		143,
		142,
		117,
		110,
		96,
		98,
		96,
		98,
		103,
		124,
		125,
		138,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		130,
		-1,
		-1,
		121,
		119,
		129,
		113,
		100,
		120,
		123,
		113,
		97,
		112,
		124,
		132,
		137,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		150,
		154,
		158,
		124,
		-1,
		129,
		124,
		104,
		118,
		125,
		115,
		110,
		104,
		107,
		125,
		142,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		129,
		143,
		147,
		140,
		144,
		-1,
		132,
		120,
		106,
		123,
		128,
		125,
		116,
		108,
		113,
		110,
		123,
		137,
		141,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		147,
		162,
		186,
		163,
		136,
		131,
		124,
		118,
		114,
		130,
		136,
		147,
		115,
		111,
		112,
		116,
		115,
		132,
		142,
		-1,
		-1,
		161,
		178,
		173,
		155,
		159,
		213,
		-1,
		-1,
		140,
		131,
		122,
		125,
		124,
		127,
		121,
		118,
		123,
		128,
		116,
		125,
		143,
		142,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		174,
		211,
		158,
		140,
		136,
		134,
		127,
		136,
		131,
		126,
		136,
		138,
		130,
		118,
		122,
		145,
		134,
		173,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		210,
		185,
		200,
		222,
		194,
		201,
		173,
		170,
		-1,
		140,
		165,
		137,
		144,
		135,
		142,
		142,
		134,
		112,
		119,
		135,
		134,
		129,
		165,
		156,
		162,
		-1,
		-1,
		293,
		282,
		271,
		277,
		-1,
		216,
		202,
		208,
		198,
		201,
		-1,
		-1,
		189,
		186,
		162,
		145,
		143,
		136,
		131,
		141,
		121,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		153,
		168,
		-1,
		188,
		269,
		262,
		245,
		253,
		284,
		-1,
		212,
		204,
		209,
		190,
		192,
		-1,
		-1,
		162,
		159,
		164,
		152,
		149,
		151,
		146,
		137,
		122,
		128,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		202,
		245,
		239,
		242,
		266,
		280,
		-1,
		209,
		-1,
		-1,
		217,
		193,
		177,
		167,
		161,
		211,
		166,
		161,
		145,
		143,
		134,
		125,
		132,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		237,
		225,
		233,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		233,
		-1,
		204,
		-1,
		179,
		183,
		174,
		177,
		159,
		146,
		138,
		130,
		146,
		121,
		131,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		280,
		236,
		233,
		224,
		261,
		276,
		280,
		-1,
		221,
		260,
		258,
		-1,
		242,
		-1,
		-1,
		-1,
		193,
		187,
		179,
		179,
		158,
		158,
		132,
		136,
		126,
		133,
		143,
		145,
		137,
		141,
		154,
		165,
		168,
		276,
		267,
		280,
		225,
		225,
		246,
		255,
		276,
		236,
		227,
		254,
		265,
		254,
		249,
		236,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		165,
		153,
		136,
		137,
		133,
		136,
		151,
		154,
		144,
		142,
		136,
		168,
		-1,
		269,
		268,
		257,
		254,
		230,
		221,
		216,
		243,
		-1,
		-1,
		238,
		255,
		249,
		253,
		269,
		294,
		-1,
		225,
		-1,
		-1,
		210,
		-1,
		-1,
		195,
		158,
		147,
		138,
		144,
		141,
		152,
		162,
		150,
		151,
		141,
		151,
		164,
		253,
		250,
		238,
		236,
		259,
		224,
		212,
		-1,
		225,
		223,
		229,
		236,
		253,
		283,
		-1,
		-1,
		241,
		221,
		-1,
		-1,
		193,
		191,
		180,
		-1,
		170,
		143,
		148,
		168,
		170,
		159,
		153,
		147,
		154,
		153,
		161,
		169,
		262,
		276,
		265,
		261,
		260,
		268,
		217,
		210,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		227,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		161,
		165,
		157,
		150,
		145,
		156,
		148,
		152,
		169,
		-1,
		296,
		-1,
		248,
		224,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		201,
		169,
		174,
		169,
		151,
		162,
		151,
		154,
		168,
		163,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		238,
		240,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		158,
		183,
		172,
		180,
		175,
		155,
		161,
		164,
		153,
		157,
		169,
		-1,
		-1,
		243,
		244,
		245,
		-1,
		223,
		-1,
		241,
		-1,
		208,
		214,
		202,
		-1,
		-1,
		-1,
		196,
		159,
		180,
		190,
		184,
		182,
		173,
		159,
		166,
		164,
		160,
		171,
		-1,
		-1,
		-1,
		241,
		215,
		248,
		239,
		222,
		202,
		194,
		213,
		-1,
		183,
		-1,
		158,
		160,
		186,
		189,
		195,
		189,
		162,
		177,
		167,
		158,
		167,
		247,
		-1,
		217,
		250,
		214,
		208,
		184,
		188,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		211,
		196,
		177,
		164,
		171,
		171,
		164,
		-1,
		-1,
		-1,
		219,
		218,
		210,
		204,
		204,
		189,
		180,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		201,
		197,
		184,
		184,
		176,
		-1,
		320,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		213,
		208,
		181,
		169,
		175,
		171,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		177,
		212,
		-1,
		315,
		-1,
		249,
		-1,
		-1,
		231,
		211,
		203,
		192,
		181,
		179,
		170,
		161,
		183,
		199,
		183,
		181,
		184,
		185,
		-1,
		304,
		303,
		-1,
		250,
		242,
		228,
		-1,
		221,
		-1,
		227,
		188,
		-1,
		190,
		170,
		-1,
		192,
		188,
		-1,
		-1,
		291,
		266,
		-1,
		-1,
		-1,
		251,
		231,
		222,
		206,
		-1,
		181,
		181,
		-1,
		-1,
		-1,
		276,
		275,
		-1,
		244,
		247,
		-1,
		237,
		228,
		236,
		183,
		187,
		-1,
		-1,
		-1,
		285,
		266,
		260,
		259,
		257,
		252,
		249,
		235,
		219,
		197,
		186,
		207,
		-1,
		-1,
		-1,
		257,
		249,
		242,
		-1,
		-1,
		244,
		227,
		208,
		206,
		-1,
		-1,
		-1,
		279,
		260,
		-1,
		-1,
		234,
		-1,
		-1,
		240,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		268,
		-1,
		-1,
		-1,
		230,
		226,
		227,
		-1,
		-1,
		-1,
		-1,
		290,
		291,
		314,
		278,
		-1,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		293,
		291,
		-1,
		-1,
		-1,
		250,
		234,
		-1,
		220,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		255,
		-1,
		255,
		230,
		237,
		-1,
		-1,
		-1,
		-1,
		268,
		260,
		268,
		-1,
		240,
		242,
		-1,
		290,
		-1,
		-1,
		283,
		274,
		-1,
		-1,
		245,
		252,
		274,
		277,
		313,
		-1,
		264
	],
	[
		-1,
		151,
		140,
		151,
		159,
		132,
		139,
		-1,
		160,
		162,
		128,
		122,
		161,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		151,
		150,
		120,
		118,
		127,
		132,
		139,
		-1,
		155,
		-1,
		172,
		151,
		162,
		167,
		113,
		110,
		130,
		149,
		148,
		140,
		187,
		143,
		114,
		108,
		126,
		131,
		142,
		134,
		-1,
		114,
		104,
		126,
		122,
		133,
		125,
		-1,
		-1,
		108,
		109,
		115,
		118,
		124,
		120,
		-1,
		130,
		114,
		-1,
		-1,
		98,
		111,
		100,
		103,
		111,
		109,
		122,
		114,
		109,
		-1,
		-1,
		99,
		102,
		109,
		96,
		92,
		109,
		122,
		104,
		118,
		117,
		-1,
		87,
		105,
		114,
		103,
		101,
		85,
		83,
		101,
		103,
		109,
		112,
		-1,
		96,
		97,
		98,
		106,
		111,
		101,
		88,
		88,
		98,
		91,
		110,
		101,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		96,
		79,
		96,
		93,
		86,
		99,
		98,
		91,
		88,
		86,
		83,
		99,
		100,
		110,
		-1,
		-1,
		179,
		148,
		183,
		140,
		125,
		-1,
		92,
		72,
		78,
		82,
		84,
		81,
		95,
		91,
		-1,
		77,
		76,
		107,
		93,
		104,
		139,
		-1,
		-1,
		137,
		129,
		114,
		117,
		102,
		98,
		87,
		86,
		78,
		64,
		60,
		78,
		81,
		81,
		87,
		71,
		81,
		85,
		96,
		111,
		-1,
		-1,
		166,
		-1,
		-1,
		136,
		119,
		-1,
		102,
		109,
		108,
		114,
		100,
		121,
		97,
		88,
		80,
		74,
		62,
		75,
		73,
		86,
		74,
		68,
		93,
		97,
		91,
		112,
		107,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		95,
		98,
		104,
		128,
		137,
		-1,
		109,
		97,
		98,
		83,
		79,
		66,
		55,
		67,
		65,
		72,
		71,
		75,
		77,
		110,
		88,
		110,
		107,
		136,
		141,
		135,
		144,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		132,
		-1,
		145,
		145,
		120,
		94,
		97,
		84,
		74,
		61,
		51,
		61,
		63,
		60,
		68,
		77,
		88,
		83,
		82,
		100,
		115,
		128,
		132,
		138,
		-1,
		194,
		-1,
		136,
		120,
		122,
		94,
		115,
		-1,
		152,
		146,
		137,
		122,
		113,
		-1,
		92,
		89,
		79,
		57,
		43,
		60,
		63,
		62,
		67,
		72,
		86,
		77,
		95,
		102,
		110,
		114,
		134,
		146,
		154,
		144,
		-1,
		126,
		131,
		90,
		98,
		117,
		155,
		119,
		-1,
		114,
		-1,
		94,
		107,
		-1,
		63,
		47,
		33,
		44,
		50,
		65,
		71,
		68,
		65,
		83,
		86,
		103,
		107,
		123,
		-1,
		-1,
		139,
		143,
		132,
		83,
		102,
		126,
		163,
		112,
		101,
		100,
		-1,
		91,
		43,
		40,
		26,
		13,
		31,
		37,
		56,
		69,
		48,
		67,
		70,
		92,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		109,
		80,
		104,
		146,
		130,
		123,
		111,
		76,
		76,
		70,
		-1,
		37,
		16,
		18,
		41,
		43,
		56,
		53,
		67,
		71,
		70,
		89,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		139,
		128,
		129,
		75,
		98,
		135,
		109,
		95,
		100,
		75,
		68,
		61,
		43,
		33,
		0,
		29,
		38,
		33,
		49,
		57,
		59,
		68,
		77,
		83,
		107,
		113,
		119,
		-1,
		-1,
		146,
		136,
		120,
		122,
		119,
		89,
		96,
		128,
		100,
		113,
		-1,
		66,
		-1,
		55,
		23,
		17,
		14,
		28,
		39,
		40,
		49,
		63,
		74,
		70,
		77,
		112,
		112,
		103,
		123,
		126,
		-1,
		-1,
		-1,
		139,
		134,
		109,
		86,
		70,
		106,
		-1,
		83,
		84,
		-1,
		60,
		54,
		27,
		20,
		14,
		31,
		32,
		47,
		54,
		50,
		64,
		75,
		62,
		98,
		-1,
		111,
		105,
		113,
		103,
		91,
		-1,
		-1,
		-1,
		132,
		111,
		104,
		124,
		65,
		117,
		-1,
		-1,
		68,
		61,
		-1,
		38,
		30,
		35,
		30,
		39,
		46,
		55,
		48,
		61,
		66,
		67,
		77,
		96,
		100,
		104,
		93,
		89,
		86,
		100,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		85,
		-1,
		77,
		69,
		59,
		53,
		47,
		43,
		41,
		59,
		44,
		56,
		58,
		62,
		70,
		55,
		58,
		70,
		73,
		91,
		99,
		91,
		85,
		84,
		96,
		-1,
		152,
		138,
		109,
		-1,
		-1,
		98,
		-1,
		62,
		76,
		92,
		-1,
		85,
		64,
		79,
		57,
		53,
		47,
		80,
		81,
		59,
		64,
		69,
		79,
		80,
		69,
		81,
		73,
		95,
		95,
		79,
		80,
		89,
		-1,
		158,
		145,
		103,
		99,
		88,
		108,
		59,
		47,
		79,
		-1,
		-1,
		121,
		-1,
		55,
		72,
		61,
		59,
		70,
		61,
		67,
		80,
		83,
		84,
		74,
		63,
		69,
		67,
		89,
		75,
		73,
		92,
		108,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		74,
		61,
		55,
		-1,
		96,
		-1,
		99,
		89,
		73,
		58,
		91,
		-1,
		78,
		62,
		67,
		-1,
		109,
		-1,
		82,
		84,
		76,
		64,
		61,
		72,
		70,
		81,
		98,
		-1,
		108,
		93,
		86,
		76,
		90,
		61,
		-1,
		116,
		-1,
		-1,
		86,
		80,
		80,
		64,
		67,
		94,
		74,
		68,
		67,
		104,
		102,
		90,
		74,
		67,
		64,
		64,
		77,
		97,
		88,
		100,
		-1,
		-1,
		-1,
		113,
		99,
		103,
		63,
		82,
		-1,
		-1,
		148,
		103,
		89,
		-1,
		73,
		111,
		99,
		89,
		79,
		113,
		114,
		93,
		86,
		72,
		74,
		72,
		73,
		78,
		99,
		100,
		113,
		-1,
		-1,
		96,
		101,
		89,
		75,
		94,
		-1,
		-1,
		-1,
		95,
		111,
		103,
		74,
		100,
		-1,
		-1,
		91,
		89,
		99,
		89,
		76,
		96,
		99,
		88,
		72,
		87,
		99,
		107,
		112,
		-1,
		99,
		86,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		106,
		127,
		133,
		94,
		-1,
		99,
		100,
		80,
		94,
		101,
		90,
		85,
		79,
		82,
		100,
		117,
		-1,
		-1,
		111,
		-1,
		106,
		-1,
		-1,
		-1,
		-1,
		85,
		99,
		120,
		115,
		119,
		-1,
		107,
		96,
		82,
		99,
		103,
		100,
		91,
		83,
		88,
		85,
		98,
		112,
		116,
		134,
		-1,
		117,
		-1,
		-1,
		-1,
		103,
		118,
		161,
		138,
		111,
		106,
		99,
		93,
		90,
		106,
		111,
		122,
		90,
		86,
		87,
		91,
		90,
		107,
		117,
		-1,
		-1,
		117,
		134,
		129,
		111,
		115,
		188,
		-1,
		-1,
		115,
		106,
		97,
		100,
		100,
		103,
		96,
		93,
		98,
		103,
		91,
		100,
		118,
		118,
		-1,
		-1,
		-1,
		137,
		-1,
		152,
		-1,
		-1,
		130,
		186,
		133,
		115,
		111,
		109,
		102,
		111,
		106,
		101,
		111,
		114,
		106,
		93,
		98,
		121,
		110,
		149,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		166,
		141,
		156,
		197,
		150,
		157,
		148,
		145,
		-1,
		115,
		140,
		112,
		119,
		111,
		118,
		118,
		110,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		172,
		158,
		183,
		173,
		167,
		-1,
		-1,
		164,
		161,
		137,
		121,
		119,
		112,
		107,
		117,
		97,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		144,
		225,
		218,
		201,
		209,
		240,
		-1,
		175,
		179,
		165,
		165,
		167,
		-1,
		-1,
		137,
		134,
		139,
		128,
		125,
		127,
		122,
		113,
		98,
		104,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		158,
		201,
		195,
		198,
		222,
		236,
		-1,
		184,
		-1,
		-1,
		173,
		168,
		152,
		142,
		136,
		186,
		142,
		137,
		121,
		119,
		110,
		101,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		193,
		181,
		189,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		189,
		-1,
		179,
		-1,
		154,
		158,
		150,
		153,
		135,
		122,
		114,
		106,
		122,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		256,
		212,
		189,
		180,
		227,
		242,
		246,
		-1,
		196,
		235,
		227,
		-1,
		198,
		-1,
		-1,
		-1,
		168,
		163,
		155,
		155,
		134,
		134,
		108,
		112,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		252,
		243,
		256,
		201,
		194,
		212,
		221,
		242,
		211,
		202,
		229,
		234,
		223,
		218,
		205,
		-1,
		-1,
		191,
		173,
		-1,
		-1,
		141,
		129,
		112,
		113,
		109,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		245,
		244,
		233,
		230,
		206,
		197,
		192,
		213,
		-1,
		-1,
		214,
		230,
		225,
		229,
		245,
		270,
		-1,
		201,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		117,
		128,
		138,
		126,
		127,
		117,
		127,
		140,
		229,
		226,
		214,
		212,
		235,
		200,
		188,
		-1,
		201,
		199,
		205,
		212,
		229,
		259,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		144,
		146,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		238,
		252,
		241,
		237,
		236,
		244,
		193,
		186,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		137,
		141,
		133,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		272,
		-1,
		224,
		200,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		214,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		219,
		220,
		221,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		160,
		158,
		149,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		136,
		162,
		165,
		171,
		165,
		138,
		153,
		143,
		134,
		143,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		187,
		172,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		177,
		173,
		160,
		160,
		152,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		153,
		188,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		160,
		161,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		152,
		141,
		152,
		160,
		133,
		140,
		-1,
		161,
		163,
		129,
		123,
		162,
		133,
		139,
		150,
		-1,
		-1,
		-1,
		152,
		151,
		121,
		119,
		128,
		133,
		140,
		-1,
		142,
		-1,
		173,
		152,
		163,
		168,
		114,
		111,
		131,
		150,
		135,
		127,
		188,
		144,
		115,
		109,
		127,
		120,
		129,
		121,
		-1,
		115,
		105,
		127,
		109,
		120,
		112,
		-1,
		-1,
		109,
		110,
		116,
		105,
		111,
		107,
		-1,
		117,
		101,
		-1,
		-1,
		99,
		103,
		87,
		90,
		98,
		96,
		109,
		101,
		96,
		-1,
		-1,
		93,
		89,
		96,
		83,
		79,
		96,
		109,
		91,
		105,
		104,
		-1,
		88,
		106,
		115,
		90,
		88,
		72,
		70,
		88,
		90,
		96,
		99,
		-1,
		97,
		98,
		91,
		99,
		104,
		88,
		75,
		75,
		85,
		78,
		97,
		88,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		97,
		80,
		97,
		87,
		77,
		92,
		85,
		78,
		75,
		73,
		70,
		86,
		87,
		97,
		-1,
		-1,
		191,
		161,
		188,
		146,
		127,
		-1,
		93,
		73,
		79,
		81,
		75,
		68,
		82,
		78,
		-1,
		64,
		63,
		94,
		80,
		91,
		152,
		-1,
		-1,
		149,
		141,
		123,
		126,
		103,
		99,
		88,
		87,
		79,
		65,
		61,
		65,
		68,
		68,
		74,
		58,
		68,
		72,
		87,
		98,
		-1,
		-1,
		157,
		-1,
		-1,
		149,
		132,
		-1,
		115,
		122,
		109,
		115,
		101,
		122,
		98,
		89,
		81,
		75,
		63,
		63,
		60,
		73,
		61,
		55,
		80,
		84,
		82,
		103,
		98,
		-1,
		156,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		108,
		111,
		115,
		139,
		138,
		-1,
		110,
		98,
		99,
		84,
		81,
		68,
		56,
		68,
		52,
		59,
		58,
		62,
		64,
		97,
		79,
		101,
		98,
		127,
		132,
		126,
		135,
		-1,
		157,
		153,
		149,
		156,
		105,
		-1,
		-1,
		143,
		-1,
		146,
		147,
		122,
		95,
		98,
		85,
		76,
		63,
		52,
		63,
		50,
		47,
		55,
		68,
		75,
		74,
		73,
		91,
		106,
		119,
		123,
		129,
		-1,
		207,
		-1,
		149,
		133,
		135,
		107,
		128,
		-1,
		163,
		147,
		139,
		124,
		124,
		-1,
		94,
		91,
		81,
		59,
		44,
		61,
		51,
		49,
		54,
		63,
		77,
		68,
		86,
		93,
		101,
		105,
		125,
		137,
		167,
		157,
		-1,
		139,
		144,
		103,
		111,
		130,
		168,
		132,
		-1,
		127,
		-1,
		96,
		109,
		-1,
		65,
		55,
		41,
		44,
		37,
		52,
		61,
		59,
		56,
		74,
		77,
		94,
		98,
		114,
		-1,
		-1,
		152,
		156,
		145,
		96,
		115,
		139,
		176,
		125,
		114,
		113,
		-1,
		104,
		51,
		48,
		34,
		21,
		33,
		36,
		36,
		57,
		39,
		58,
		61,
		83,
		111,
		89,
		101,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		122,
		93,
		117,
		159,
		143,
		136,
		124,
		89,
		89,
		83,
		-1,
		45,
		24,
		20,
		24,
		23,
		37,
		41,
		58,
		62,
		61,
		80,
		92,
		83,
		103,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		88,
		111,
		148,
		122,
		108,
		113,
		88,
		81,
		75,
		60,
		41,
		32,
		0,
		17,
		24,
		37,
		44,
		48,
		59,
		68,
		74,
		98,
		105,
		111,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		102,
		109,
		141,
		113,
		126,
		-1,
		80,
		-1,
		69,
		48,
		42,
		38,
		25,
		31,
		28,
		40,
		50,
		65,
		61,
		68,
		103,
		103,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		152,
		147,
		122,
		99,
		83,
		119,
		-1,
		96,
		97,
		-1,
		74,
		68,
		52,
		45,
		39,
		37,
		37,
		35,
		36,
		41,
		54,
		63,
		53,
		89,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		145,
		124,
		117,
		137,
		78,
		130,
		-1,
		-1,
		81,
		74,
		-1,
		61,
		43,
		46,
		44,
		42,
		44,
		49,
		38,
		51,
		56,
		58,
		67,
		88,
		92,
		96,
		85,
		81,
		78,
		92,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		98,
		-1,
		90,
		82,
		72,
		66,
		60,
		56,
		54,
		69,
		54,
		57,
		57,
		52,
		60,
		45,
		48,
		61,
		65,
		83,
		91,
		83,
		77,
		76,
		88,
		-1,
		165,
		151,
		122,
		-1,
		-1,
		111,
		-1,
		75,
		89,
		105,
		-1,
		98,
		77,
		92,
		70,
		66,
		57,
		77,
		78,
		56,
		61,
		59,
		69,
		70,
		59,
		73,
		65,
		87,
		87,
		71,
		72,
		81,
		-1,
		171,
		158,
		116,
		112,
		101,
		121,
		72,
		60,
		92,
		-1,
		-1,
		134,
		-1,
		68,
		85,
		71,
		69,
		67,
		58,
		64,
		70,
		73,
		74,
		64,
		53,
		59,
		59,
		81,
		67,
		65,
		84,
		100,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		87,
		74,
		68,
		-1,
		109,
		-1,
		112,
		102,
		86,
		71,
		104,
		-1,
		75,
		59,
		64,
		-1,
		99,
		-1,
		72,
		74,
		67,
		56,
		53,
		64,
		62,
		73,
		90,
		-1,
		121,
		106,
		99,
		89,
		103,
		74,
		-1,
		129,
		-1,
		-1,
		99,
		93,
		93,
		77,
		80,
		91,
		71,
		65,
		64,
		94,
		93,
		80,
		65,
		58,
		55,
		56,
		69,
		89,
		80,
		92,
		-1,
		-1,
		-1,
		126,
		112,
		116,
		76,
		95,
		-1,
		-1,
		161,
		116,
		102,
		-1,
		86,
		108,
		96,
		86,
		76,
		110,
		109,
		84,
		77,
		63,
		65,
		63,
		65,
		70,
		91,
		92,
		105,
		-1,
		-1,
		109,
		114,
		102,
		88,
		107,
		-1,
		-1,
		-1,
		108,
		124,
		116,
		87,
		97,
		-1,
		-1,
		88,
		86,
		96,
		80,
		67,
		87,
		90,
		80,
		64,
		79,
		91,
		99,
		104,
		-1,
		112,
		99,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		-1,
		-1,
		141,
		107,
		119,
		121,
		125,
		91,
		-1,
		96,
		91,
		71,
		85,
		92,
		82,
		77,
		71,
		74,
		92,
		109,
		-1,
		-1,
		124,
		-1,
		119,
		-1,
		-1,
		-1,
		-1,
		98,
		112,
		114,
		107,
		111,
		-1,
		99,
		87,
		73,
		90,
		95,
		92,
		83,
		75,
		80,
		77,
		90,
		104,
		108,
		147,
		-1,
		130,
		-1,
		-1,
		-1,
		116,
		131,
		153,
		130,
		103,
		98,
		91,
		85,
		81,
		97,
		103,
		114,
		82,
		78,
		79,
		83,
		82,
		99,
		109,
		-1,
		-1,
		130,
		147,
		142,
		124,
		128,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		91,
		94,
		88,
		85,
		90,
		95,
		83,
		92,
		110,
		109,
		-1,
		-1,
		-1,
		150,
		-1,
		165,
		-1,
		-1,
		143,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		105,
		97,
		85,
		89,
		112,
		101,
		140,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		179,
		154,
		169,
		189,
		163,
		170,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		102,
		109,
		109,
		101,
		79,
		86,
		102,
		101,
		96,
		132,
		123,
		129,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		185,
		171,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		112,
		110,
		103,
		98,
		108,
		88,
		75,
		79,
		83,
		89,
		94,
		99,
		105,
		120,
		135,
		-1,
		157,
		238,
		231,
		214,
		222,
		253,
		-1,
		179,
		171,
		178,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		119,
		116,
		118,
		113,
		104,
		89,
		95,
		82,
		81,
		99,
		103,
		112,
		119,
		109,
		122,
		126,
		-1,
		171,
		214,
		208,
		211,
		235,
		249,
		-1,
		176,
		-1,
		-1,
		186,
		160,
		144,
		134,
		128,
		178,
		133,
		128,
		112,
		110,
		101,
		92,
		99,
		90,
		90,
		93,
		108,
		113,
		105,
		119,
		119,
		120,
		-1,
		206,
		194,
		202,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		202,
		-1,
		171,
		-1,
		146,
		150,
		141,
		144,
		126,
		113,
		105,
		97,
		113,
		88,
		98,
		94,
		95,
		104,
		115,
		127,
		126,
		127,
		247,
		203,
		202,
		193,
		228,
		243,
		247,
		-1,
		188,
		227,
		225,
		-1,
		209,
		-1,
		-1,
		-1,
		160,
		154,
		146,
		146,
		125,
		125,
		99,
		103,
		93,
		100,
		110,
		112,
		104,
		108,
		121,
		132,
		135,
		243,
		234,
		247,
		192,
		192,
		213,
		222,
		243,
		203,
		194,
		221,
		232,
		221,
		216,
		203,
		-1,
		-1,
		183,
		164,
		-1,
		-1,
		132,
		120,
		103,
		104,
		100,
		103,
		118,
		121,
		111,
		109,
		103,
		135,
		-1,
		236,
		235,
		224,
		221,
		197,
		188,
		183,
		210,
		-1,
		-1,
		205,
		222,
		216,
		220,
		236,
		261,
		-1,
		192,
		-1,
		-1,
		177,
		-1,
		-1,
		162,
		125,
		114,
		105,
		111,
		108,
		119,
		129,
		117,
		118,
		108,
		118,
		131,
		220,
		217,
		205,
		203,
		226,
		191,
		179,
		-1,
		192,
		190,
		196,
		203,
		220,
		250,
		-1,
		-1,
		208,
		188,
		-1,
		-1,
		160,
		158,
		147,
		-1,
		137,
		110,
		115,
		135,
		137,
		126,
		120,
		114,
		121,
		120,
		128,
		136,
		229,
		243,
		232,
		228,
		227,
		235,
		184,
		177,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		194,
		-1,
		-1,
		155,
		148,
		136,
		124,
		114,
		124,
		128,
		132,
		124,
		117,
		112,
		123,
		115,
		119,
		136,
		-1,
		263,
		-1,
		215,
		191,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		189,
		173,
		154,
		-1,
		124,
		137,
		168,
		136,
		141,
		136,
		118,
		129,
		118,
		121,
		135,
		130,
		-1,
		-1,
		203,
		206,
		-1,
		-1,
		205,
		207,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		161,
		157,
		-1,
		-1,
		125,
		150,
		139,
		147,
		142,
		122,
		128,
		131,
		120,
		124,
		136,
		-1,
		-1,
		210,
		211,
		212,
		-1,
		190,
		-1,
		208,
		-1,
		175,
		181,
		169,
		-1,
		-1,
		-1,
		163,
		126,
		147,
		157,
		151,
		149,
		140,
		126,
		133,
		131,
		127,
		138,
		-1,
		-1,
		-1,
		208,
		182,
		215,
		206,
		189,
		169,
		161,
		180,
		-1,
		150,
		-1,
		125,
		127,
		153,
		156,
		162,
		156,
		129,
		144,
		134,
		125,
		134,
		214,
		-1,
		184,
		217,
		181,
		175,
		151,
		155,
		171,
		-1,
		147,
		129,
		-1,
		157,
		147,
		178,
		163,
		144,
		131,
		138,
		138,
		131,
		-1,
		-1,
		-1,
		186,
		185,
		177,
		171,
		171,
		156,
		147,
		-1,
		159,
		141,
		120,
		137,
		137,
		128,
		136,
		168,
		164,
		151,
		151,
		143,
		-1,
		287,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		180,
		175,
		148,
		136,
		142,
		138,
		124,
		130,
		132,
		140,
		138,
		135,
		147,
		143,
		163,
		144,
		179,
		-1,
		282,
		-1,
		216,
		-1,
		-1,
		198,
		178,
		170,
		159,
		148,
		146,
		137,
		128,
		150,
		166,
		150,
		148,
		151,
		152,
		-1,
		271,
		270,
		-1,
		217,
		209,
		195,
		-1,
		188,
		-1,
		194,
		155,
		-1,
		157,
		137,
		-1,
		159,
		155,
		-1,
		-1,
		258,
		233,
		-1,
		-1,
		-1,
		218,
		198,
		189,
		173,
		-1,
		148,
		148,
		-1,
		-1,
		-1,
		243,
		242,
		-1,
		211,
		214,
		-1,
		204,
		195,
		203,
		150,
		154,
		-1,
		-1,
		-1,
		252,
		233,
		227,
		226,
		224,
		219,
		216,
		202,
		186,
		164,
		153,
		174,
		-1,
		-1,
		-1,
		224,
		216,
		209,
		-1,
		-1,
		211,
		194,
		175,
		173,
		-1,
		-1,
		-1,
		246,
		227,
		-1,
		-1,
		201,
		-1,
		-1,
		207,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		235,
		-1,
		-1,
		-1,
		197,
		193,
		194,
		-1,
		-1,
		-1,
		-1,
		257,
		258,
		281,
		245,
		-1,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		260,
		258,
		-1,
		-1,
		-1,
		217,
		201,
		-1,
		187,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		222,
		-1,
		222,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		235,
		227,
		235,
		-1,
		207,
		209,
		-1,
		257,
		-1,
		-1,
		250,
		241,
		-1,
		-1,
		212,
		219,
		241,
		244,
		280,
		-1,
		231
	],
	[
		-1,
		141,
		130,
		141,
		149,
		122,
		129,
		-1,
		150,
		152,
		118,
		112,
		151,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		141,
		140,
		110,
		108,
		117,
		122,
		129,
		-1,
		132,
		-1,
		162,
		141,
		152,
		157,
		103,
		100,
		120,
		139,
		125,
		117,
		177,
		133,
		104,
		98,
		116,
		110,
		119,
		111,
		-1,
		104,
		94,
		116,
		99,
		110,
		102,
		-1,
		-1,
		98,
		99,
		105,
		95,
		101,
		97,
		-1,
		107,
		91,
		-1,
		-1,
		88,
		93,
		77,
		80,
		88,
		86,
		99,
		91,
		86,
		-1,
		-1,
		83,
		79,
		86,
		73,
		69,
		86,
		99,
		81,
		95,
		94,
		-1,
		77,
		95,
		104,
		80,
		78,
		62,
		60,
		78,
		80,
		86,
		89,
		-1,
		86,
		87,
		81,
		89,
		94,
		78,
		65,
		65,
		75,
		68,
		87,
		78,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		86,
		69,
		86,
		77,
		67,
		82,
		75,
		68,
		65,
		63,
		60,
		76,
		77,
		87,
		-1,
		-1,
		179,
		148,
		177,
		135,
		116,
		-1,
		82,
		62,
		68,
		71,
		65,
		58,
		72,
		68,
		-1,
		54,
		53,
		84,
		70,
		81,
		139,
		-1,
		-1,
		137,
		129,
		112,
		115,
		92,
		88,
		77,
		76,
		68,
		54,
		50,
		55,
		58,
		58,
		64,
		48,
		58,
		62,
		74,
		88,
		-1,
		-1,
		144,
		-1,
		-1,
		136,
		119,
		-1,
		102,
		109,
		98,
		104,
		90,
		111,
		87,
		78,
		70,
		64,
		52,
		53,
		50,
		63,
		51,
		45,
		70,
		74,
		69,
		90,
		85,
		-1,
		143,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		95,
		98,
		104,
		128,
		127,
		-1,
		99,
		87,
		88,
		73,
		70,
		57,
		45,
		58,
		42,
		49,
		48,
		52,
		54,
		87,
		66,
		88,
		85,
		114,
		119,
		113,
		122,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		132,
		-1,
		135,
		136,
		111,
		84,
		87,
		74,
		65,
		52,
		41,
		52,
		40,
		37,
		45,
		55,
		65,
		61,
		60,
		78,
		93,
		106,
		110,
		116,
		-1,
		194,
		-1,
		136,
		120,
		122,
		94,
		115,
		-1,
		152,
		136,
		128,
		113,
		113,
		-1,
		83,
		80,
		70,
		48,
		33,
		50,
		41,
		38,
		44,
		50,
		64,
		55,
		73,
		80,
		88,
		92,
		112,
		124,
		154,
		144,
		-1,
		126,
		131,
		90,
		98,
		117,
		155,
		119,
		-1,
		114,
		-1,
		85,
		98,
		-1,
		54,
		50,
		32,
		33,
		26,
		42,
		49,
		46,
		43,
		61,
		64,
		81,
		85,
		101,
		-1,
		-1,
		139,
		143,
		132,
		83,
		102,
		126,
		163,
		112,
		101,
		100,
		-1,
		91,
		57,
		54,
		40,
		27,
		23,
		26,
		23,
		47,
		26,
		45,
		48,
		70,
		98,
		76,
		88,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		109,
		80,
		104,
		146,
		130,
		123,
		111,
		76,
		76,
		70,
		-1,
		51,
		30,
		20,
		18,
		10,
		24,
		28,
		45,
		49,
		48,
		67,
		79,
		70,
		90,
		-1,
		-1,
		-1,
		139,
		128,
		129,
		75,
		98,
		135,
		109,
		95,
		100,
		75,
		68,
		62,
		66,
		47,
		37,
		18,
		0,
		11,
		24,
		31,
		35,
		46,
		55,
		61,
		85,
		92,
		98,
		-1,
		-1,
		146,
		136,
		120,
		122,
		119,
		89,
		96,
		128,
		100,
		113,
		-1,
		67,
		-1,
		56,
		47,
		31,
		26,
		15,
		18,
		15,
		27,
		37,
		52,
		48,
		55,
		90,
		90,
		82,
		102,
		105,
		-1,
		-1,
		-1,
		139,
		134,
		109,
		86,
		70,
		106,
		-1,
		83,
		84,
		-1,
		61,
		55,
		51,
		33,
		29,
		27,
		24,
		22,
		23,
		28,
		41,
		50,
		40,
		76,
		-1,
		90,
		84,
		92,
		82,
		70,
		-1,
		-1,
		-1,
		132,
		111,
		104,
		124,
		65,
		117,
		-1,
		-1,
		68,
		61,
		-1,
		48,
		30,
		33,
		31,
		29,
		31,
		36,
		25,
		38,
		43,
		45,
		54,
		75,
		79,
		83,
		72,
		68,
		65,
		79,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		85,
		-1,
		77,
		69,
		59,
		53,
		47,
		43,
		41,
		56,
		41,
		44,
		44,
		39,
		47,
		32,
		35,
		48,
		52,
		70,
		78,
		70,
		64,
		63,
		75,
		-1,
		152,
		138,
		109,
		-1,
		-1,
		98,
		-1,
		62,
		76,
		92,
		-1,
		85,
		64,
		79,
		57,
		53,
		44,
		64,
		65,
		43,
		48,
		46,
		56,
		57,
		46,
		60,
		52,
		74,
		74,
		58,
		59,
		68,
		-1,
		158,
		145,
		103,
		99,
		88,
		108,
		59,
		47,
		79,
		-1,
		-1,
		121,
		-1,
		55,
		72,
		58,
		56,
		54,
		45,
		51,
		57,
		60,
		61,
		51,
		40,
		46,
		46,
		68,
		54,
		52,
		71,
		87,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		74,
		61,
		55,
		-1,
		96,
		-1,
		99,
		89,
		73,
		58,
		91,
		-1,
		62,
		46,
		51,
		-1,
		86,
		-1,
		59,
		61,
		54,
		43,
		40,
		51,
		49,
		60,
		77,
		-1,
		108,
		93,
		86,
		76,
		90,
		61,
		-1,
		116,
		-1,
		-1,
		86,
		80,
		80,
		64,
		67,
		78,
		58,
		52,
		51,
		81,
		80,
		67,
		52,
		45,
		42,
		43,
		56,
		76,
		67,
		79,
		-1,
		-1,
		-1,
		113,
		99,
		103,
		63,
		82,
		-1,
		-1,
		148,
		103,
		89,
		-1,
		73,
		95,
		83,
		73,
		63,
		97,
		96,
		71,
		64,
		50,
		52,
		50,
		52,
		57,
		78,
		79,
		92,
		-1,
		-1,
		96,
		101,
		89,
		75,
		94,
		-1,
		-1,
		-1,
		95,
		111,
		103,
		74,
		84,
		-1,
		-1,
		75,
		73,
		83,
		67,
		54,
		74,
		77,
		67,
		51,
		66,
		78,
		86,
		91,
		-1,
		99,
		86,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		106,
		108,
		112,
		78,
		-1,
		83,
		78,
		58,
		72,
		79,
		69,
		64,
		58,
		61,
		79,
		96,
		-1,
		-1,
		111,
		-1,
		106,
		-1,
		-1,
		-1,
		-1,
		85,
		99,
		101,
		94,
		98,
		-1,
		86,
		74,
		60,
		77,
		82,
		79,
		70,
		62,
		67,
		64,
		77,
		91,
		95,
		134,
		-1,
		117,
		-1,
		-1,
		-1,
		103,
		118,
		140,
		117,
		90,
		85,
		78,
		72,
		68,
		84,
		90,
		101,
		69,
		65,
		66,
		70,
		69,
		86,
		96,
		-1,
		-1,
		117,
		134,
		129,
		111,
		115,
		167,
		-1,
		-1,
		94,
		85,
		76,
		79,
		78,
		81,
		75,
		72,
		77,
		82,
		70,
		79,
		97,
		96,
		-1,
		-1,
		-1,
		137,
		-1,
		152,
		-1,
		-1,
		130,
		165,
		112,
		94,
		90,
		88,
		81,
		90,
		85,
		80,
		90,
		92,
		84,
		72,
		76,
		99,
		88,
		127,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		166,
		141,
		156,
		176,
		150,
		157,
		127,
		124,
		-1,
		94,
		119,
		91,
		98,
		89,
		96,
		96,
		88,
		66,
		73,
		89,
		88,
		83,
		119,
		110,
		116,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		172,
		158,
		162,
		152,
		155,
		-1,
		-1,
		143,
		140,
		116,
		99,
		97,
		90,
		85,
		95,
		75,
		62,
		66,
		70,
		76,
		81,
		86,
		92,
		107,
		122,
		-1,
		144,
		225,
		218,
		201,
		209,
		240,
		-1,
		166,
		158,
		165,
		144,
		146,
		-1,
		-1,
		116,
		113,
		118,
		106,
		103,
		105,
		100,
		91,
		76,
		82,
		69,
		68,
		86,
		90,
		99,
		106,
		96,
		109,
		113,
		-1,
		158,
		201,
		195,
		198,
		222,
		236,
		-1,
		163,
		-1,
		-1,
		173,
		147,
		131,
		121,
		115,
		165,
		120,
		115,
		99,
		97,
		88,
		79,
		86,
		77,
		77,
		80,
		95,
		100,
		92,
		106,
		106,
		107,
		-1,
		193,
		181,
		189,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		189,
		-1,
		158,
		-1,
		133,
		137,
		128,
		131,
		113,
		100,
		92,
		84,
		100,
		75,
		85,
		81,
		82,
		91,
		102,
		114,
		113,
		114,
		234,
		190,
		189,
		180,
		215,
		230,
		234,
		-1,
		175,
		214,
		212,
		-1,
		196,
		-1,
		-1,
		-1,
		147,
		141,
		133,
		133,
		112,
		112,
		86,
		90,
		80,
		87,
		97,
		99,
		91,
		95,
		108,
		119,
		122,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		190,
		181,
		208,
		219,
		208,
		203,
		190,
		-1,
		-1,
		170,
		151,
		-1,
		-1,
		119,
		107,
		90,
		91,
		87,
		90,
		105,
		108,
		98,
		96,
		90,
		122,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		209,
		203,
		207,
		223,
		248,
		-1,
		179,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		112,
		101,
		92,
		98,
		95,
		106,
		116,
		104,
		105,
		95,
		105,
		118,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		195,
		175,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		97,
		102,
		122,
		124,
		113,
		107,
		101,
		108,
		107,
		115,
		123,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		181,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		115,
		119,
		111,
		104,
		99,
		110,
		102,
		106,
		123,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		105,
		116,
		105,
		108,
		122,
		117,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		192,
		194,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		109,
		115,
		118,
		107,
		111,
		123,
		-1,
		-1,
		197,
		198,
		199,
		-1,
		177,
		-1,
		195,
		-1,
		162,
		168,
		156,
		-1,
		-1,
		-1,
		150,
		113,
		134,
		144,
		138,
		136,
		127,
		113,
		120,
		118,
		114,
		125,
		-1,
		-1,
		-1,
		195,
		169,
		202,
		193,
		176,
		156,
		148,
		167,
		-1,
		137,
		-1,
		112,
		114,
		140,
		143,
		149,
		143,
		116,
		131,
		121,
		112,
		121,
		201,
		-1,
		171,
		204,
		168,
		162,
		138,
		142,
		158,
		-1,
		134,
		116,
		-1,
		144,
		134,
		165,
		150,
		131,
		118,
		125,
		125,
		118,
		-1,
		-1,
		-1,
		173,
		172,
		164,
		158,
		158,
		143,
		134,
		-1,
		146,
		128,
		107,
		124,
		124,
		115,
		123,
		155,
		151,
		138,
		138,
		130,
		-1,
		274,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		167,
		162,
		135,
		123,
		129,
		125,
		111,
		117,
		119,
		127,
		125,
		122,
		134,
		130,
		150,
		131,
		166,
		-1,
		269,
		-1,
		203,
		-1,
		-1,
		185,
		165,
		157,
		146,
		135,
		133,
		124,
		115,
		137,
		153,
		137,
		135,
		138,
		139,
		-1,
		258,
		257,
		-1,
		204,
		196,
		182,
		-1,
		175,
		-1,
		181,
		142,
		-1,
		144,
		124,
		-1,
		146,
		142,
		-1,
		-1,
		245,
		220,
		-1,
		-1,
		-1,
		205,
		185,
		176,
		160,
		-1,
		135,
		135,
		-1,
		-1,
		-1,
		230,
		229,
		-1,
		198,
		201,
		-1,
		191,
		182,
		190,
		137,
		141,
		-1,
		-1,
		-1,
		239,
		220,
		214,
		213,
		211,
		206,
		203,
		189,
		173,
		151,
		140,
		161,
		-1,
		-1,
		-1,
		211,
		203,
		196,
		-1,
		-1,
		198,
		181,
		162,
		160,
		-1,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		188,
		-1,
		-1,
		194,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		222,
		-1,
		-1,
		-1,
		184,
		180,
		181,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		268,
		232,
		-1,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		247,
		245,
		-1,
		-1,
		-1,
		204,
		188,
		-1,
		174,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		209,
		-1,
		209,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		222,
		214,
		222,
		-1,
		194,
		196,
		-1,
		244,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		199,
		206,
		228,
		231,
		267,
		-1,
		218
	],
	[
		-1,
		130,
		119,
		130,
		138,
		111,
		118,
		-1,
		139,
		141,
		107,
		101,
		140,
		111,
		117,
		128,
		-1,
		-1,
		-1,
		130,
		129,
		99,
		97,
		106,
		111,
		118,
		-1,
		122,
		-1,
		151,
		130,
		141,
		146,
		92,
		89,
		109,
		128,
		115,
		107,
		166,
		122,
		93,
		87,
		105,
		100,
		109,
		101,
		-1,
		93,
		83,
		105,
		89,
		100,
		92,
		-1,
		-1,
		87,
		88,
		94,
		85,
		91,
		87,
		-1,
		97,
		81,
		-1,
		-1,
		77,
		83,
		67,
		70,
		78,
		76,
		89,
		81,
		76,
		-1,
		-1,
		73,
		69,
		76,
		63,
		59,
		76,
		89,
		71,
		85,
		84,
		-1,
		66,
		84,
		93,
		70,
		68,
		52,
		50,
		68,
		70,
		76,
		79,
		-1,
		75,
		76,
		71,
		79,
		84,
		68,
		55,
		55,
		65,
		58,
		77,
		68,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		58,
		75,
		67,
		57,
		72,
		65,
		58,
		55,
		53,
		50,
		66,
		67,
		77,
		-1,
		-1,
		168,
		137,
		166,
		124,
		105,
		-1,
		71,
		51,
		57,
		61,
		55,
		48,
		62,
		58,
		-1,
		44,
		43,
		74,
		60,
		71,
		128,
		-1,
		-1,
		126,
		118,
		101,
		104,
		81,
		77,
		66,
		65,
		57,
		43,
		39,
		45,
		48,
		48,
		54,
		38,
		48,
		52,
		63,
		78,
		-1,
		-1,
		133,
		-1,
		-1,
		125,
		108,
		-1,
		91,
		98,
		87,
		93,
		79,
		100,
		76,
		67,
		59,
		53,
		41,
		43,
		40,
		53,
		41,
		35,
		60,
		64,
		58,
		79,
		74,
		-1,
		132,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		84,
		87,
		93,
		117,
		116,
		-1,
		88,
		76,
		77,
		62,
		59,
		46,
		34,
		47,
		32,
		39,
		38,
		42,
		44,
		77,
		55,
		77,
		74,
		103,
		108,
		102,
		111,
		-1,
		133,
		129,
		125,
		132,
		81,
		-1,
		-1,
		121,
		-1,
		124,
		125,
		100,
		73,
		76,
		63,
		54,
		41,
		30,
		41,
		30,
		27,
		35,
		44,
		55,
		50,
		49,
		67,
		82,
		95,
		99,
		105,
		-1,
		183,
		-1,
		125,
		109,
		111,
		83,
		104,
		-1,
		141,
		125,
		117,
		102,
		102,
		-1,
		72,
		69,
		59,
		37,
		22,
		39,
		31,
		29,
		34,
		39,
		53,
		44,
		62,
		69,
		77,
		81,
		101,
		113,
		143,
		133,
		-1,
		115,
		120,
		79,
		87,
		106,
		144,
		108,
		-1,
		103,
		-1,
		74,
		87,
		-1,
		43,
		39,
		21,
		22,
		17,
		32,
		38,
		35,
		32,
		50,
		53,
		70,
		74,
		90,
		-1,
		-1,
		128,
		132,
		121,
		72,
		91,
		115,
		152,
		101,
		90,
		89,
		-1,
		80,
		57,
		54,
		42,
		29,
		14,
		15,
		23,
		36,
		15,
		34,
		37,
		59,
		87,
		65,
		77,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		98,
		69,
		93,
		135,
		119,
		112,
		100,
		65,
		65,
		59,
		-1,
		53,
		32,
		23,
		12,
		10,
		23,
		20,
		34,
		38,
		37,
		56,
		68,
		59,
		79,
		-1,
		-1,
		-1,
		128,
		117,
		118,
		64,
		87,
		124,
		98,
		84,
		89,
		64,
		57,
		51,
		66,
		49,
		30,
		19,
		11,
		0,
		16,
		24,
		26,
		35,
		44,
		50,
		74,
		81,
		87,
		-1,
		-1,
		135,
		125,
		109,
		111,
		108,
		78,
		85,
		117,
		89,
		102,
		-1,
		56,
		-1,
		45,
		40,
		24,
		19,
		16,
		13,
		7,
		16,
		30,
		41,
		37,
		44,
		79,
		79,
		71,
		91,
		94,
		-1,
		-1,
		-1,
		128,
		123,
		98,
		75,
		59,
		95,
		-1,
		72,
		73,
		-1,
		50,
		44,
		41,
		26,
		22,
		17,
		21,
		14,
		21,
		17,
		31,
		42,
		29,
		65,
		-1,
		79,
		73,
		81,
		71,
		59,
		-1,
		-1,
		-1,
		121,
		100,
		93,
		113,
		54,
		106,
		-1,
		-1,
		57,
		50,
		-1,
		37,
		19,
		26,
		24,
		18,
		22,
		26,
		15,
		28,
		33,
		34,
		44,
		64,
		68,
		72,
		61,
		57,
		54,
		68,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		54,
		74,
		-1,
		66,
		58,
		48,
		42,
		36,
		32,
		30,
		46,
		30,
		33,
		33,
		29,
		37,
		22,
		25,
		37,
		41,
		59,
		67,
		59,
		53,
		52,
		64,
		-1,
		141,
		127,
		98,
		-1,
		-1,
		87,
		-1,
		51,
		65,
		81,
		-1,
		74,
		53,
		68,
		46,
		42,
		38,
		53,
		54,
		32,
		37,
		36,
		46,
		47,
		36,
		49,
		41,
		63,
		63,
		47,
		48,
		57,
		-1,
		147,
		134,
		92,
		88,
		77,
		97,
		48,
		36,
		68,
		-1,
		-1,
		110,
		-1,
		44,
		61,
		52,
		50,
		43,
		34,
		40,
		47,
		50,
		51,
		41,
		30,
		36,
		35,
		57,
		43,
		41,
		60,
		76,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		63,
		50,
		44,
		-1,
		85,
		-1,
		88,
		78,
		62,
		47,
		80,
		-1,
		51,
		35,
		40,
		-1,
		76,
		-1,
		49,
		51,
		43,
		32,
		29,
		40,
		38,
		49,
		66,
		-1,
		97,
		82,
		75,
		65,
		79,
		50,
		-1,
		105,
		-1,
		-1,
		75,
		69,
		69,
		53,
		56,
		67,
		47,
		41,
		40,
		71,
		69,
		57,
		41,
		34,
		31,
		32,
		45,
		65,
		56,
		68,
		-1,
		-1,
		-1,
		102,
		88,
		92,
		52,
		71,
		-1,
		-1,
		137,
		92,
		78,
		-1,
		62,
		84,
		72,
		62,
		52,
		86,
		85,
		60,
		53,
		39,
		41,
		39,
		41,
		46,
		67,
		68,
		81,
		-1,
		-1,
		85,
		90,
		78,
		64,
		83,
		-1,
		-1,
		-1,
		84,
		100,
		92,
		63,
		73,
		-1,
		-1,
		64,
		62,
		72,
		56,
		43,
		63,
		66,
		56,
		40,
		55,
		67,
		75,
		80,
		-1,
		88,
		75,
		-1,
		-1,
		86,
		80,
		-1,
		-1,
		-1,
		-1,
		117,
		83,
		95,
		97,
		101,
		67,
		-1,
		72,
		67,
		47,
		61,
		68,
		58,
		53,
		47,
		50,
		68,
		85,
		-1,
		-1,
		100,
		-1,
		95,
		-1,
		-1,
		-1,
		-1,
		74,
		88,
		90,
		83,
		87,
		-1,
		75,
		63,
		49,
		66,
		71,
		68,
		59,
		51,
		56,
		53,
		66,
		80,
		84,
		123,
		-1,
		106,
		-1,
		-1,
		-1,
		92,
		107,
		129,
		106,
		79,
		74,
		67,
		61,
		57,
		73,
		79,
		90,
		58,
		54,
		55,
		59,
		58,
		75,
		85,
		-1,
		-1,
		106,
		123,
		118,
		100,
		104,
		156,
		-1,
		-1,
		83,
		74,
		65,
		68,
		67,
		70,
		64,
		61,
		66,
		71,
		59,
		68,
		86,
		85,
		-1,
		-1,
		-1,
		126,
		-1,
		141,
		-1,
		-1,
		119,
		154,
		101,
		83,
		79,
		77,
		70,
		79,
		74,
		69,
		79,
		81,
		73,
		61,
		65,
		88,
		77,
		116,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		155,
		130,
		145,
		165,
		139,
		146,
		116,
		113,
		-1,
		83,
		108,
		80,
		87,
		78,
		85,
		85,
		77,
		55,
		62,
		78,
		77,
		72,
		108,
		99,
		105,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		161,
		147,
		151,
		141,
		144,
		-1,
		-1,
		132,
		129,
		105,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		55,
		59,
		65,
		70,
		75,
		81,
		96,
		111,
		-1,
		133,
		214,
		207,
		190,
		198,
		229,
		-1,
		155,
		147,
		154,
		133,
		135,
		-1,
		-1,
		105,
		102,
		107,
		95,
		92,
		94,
		89,
		80,
		65,
		71,
		58,
		57,
		75,
		79,
		88,
		95,
		85,
		98,
		102,
		-1,
		147,
		190,
		184,
		187,
		211,
		225,
		-1,
		152,
		-1,
		-1,
		162,
		136,
		120,
		110,
		104,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		75,
		66,
		66,
		69,
		84,
		89,
		81,
		95,
		95,
		96,
		-1,
		182,
		170,
		178,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		178,
		-1,
		147,
		-1,
		122,
		126,
		117,
		120,
		102,
		89,
		81,
		73,
		89,
		64,
		74,
		70,
		71,
		80,
		91,
		103,
		102,
		103,
		223,
		179,
		178,
		169,
		204,
		219,
		223,
		-1,
		164,
		203,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		136,
		130,
		122,
		122,
		101,
		101,
		75,
		79,
		69,
		76,
		86,
		88,
		80,
		84,
		97,
		108,
		111,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		179,
		170,
		197,
		208,
		197,
		192,
		179,
		-1,
		-1,
		159,
		140,
		-1,
		-1,
		108,
		96,
		79,
		80,
		76,
		79,
		94,
		97,
		87,
		85,
		79,
		111,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		198,
		192,
		196,
		212,
		237,
		-1,
		168,
		-1,
		-1,
		153,
		-1,
		-1,
		138,
		101,
		90,
		81,
		87,
		84,
		95,
		105,
		93,
		94,
		84,
		94,
		107,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		136,
		134,
		123,
		-1,
		113,
		86,
		91,
		111,
		113,
		102,
		96,
		90,
		97,
		96,
		104,
		112,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		131,
		124,
		112,
		100,
		90,
		100,
		104,
		108,
		100,
		93,
		88,
		99,
		91,
		95,
		112,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		144,
		112,
		117,
		112,
		94,
		105,
		94,
		97,
		111,
		106,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		101,
		126,
		115,
		123,
		118,
		98,
		104,
		107,
		96,
		100,
		112,
		-1,
		-1,
		186,
		187,
		188,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		139,
		102,
		123,
		133,
		127,
		125,
		116,
		102,
		109,
		107,
		103,
		114,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		103,
		129,
		132,
		138,
		132,
		105,
		120,
		110,
		101,
		110,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		133,
		123,
		154,
		139,
		120,
		107,
		114,
		114,
		107,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		113,
		104,
		112,
		144,
		140,
		127,
		127,
		119,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		120,
		155,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		126,
		124,
		127,
		128,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		135,
		131,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		150,
		154,
		120,
		114,
		153,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		143,
		142,
		110,
		108,
		117,
		122,
		129,
		-1,
		128,
		-1,
		164,
		143,
		154,
		159,
		103,
		100,
		120,
		139,
		121,
		113,
		179,
		133,
		104,
		98,
		116,
		106,
		115,
		107,
		-1,
		104,
		94,
		116,
		95,
		106,
		98,
		-1,
		-1,
		98,
		99,
		105,
		91,
		97,
		93,
		-1,
		103,
		87,
		-1,
		-1,
		88,
		89,
		73,
		76,
		84,
		82,
		95,
		87,
		82,
		-1,
		-1,
		79,
		75,
		82,
		69,
		65,
		82,
		95,
		77,
		91,
		90,
		-1,
		85,
		103,
		108,
		76,
		74,
		58,
		56,
		74,
		76,
		82,
		82,
		-1,
		94,
		95,
		85,
		93,
		98,
		74,
		61,
		61,
		71,
		64,
		83,
		71,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		77,
		94,
		81,
		71,
		86,
		79,
		64,
		61,
		59,
		56,
		72,
		70,
		80,
		-1,
		-1,
		186,
		155,
		185,
		143,
		124,
		-1,
		90,
		70,
		76,
		75,
		69,
		62,
		76,
		72,
		-1,
		50,
		49,
		77,
		63,
		74,
		146,
		-1,
		-1,
		144,
		136,
		120,
		123,
		100,
		96,
		85,
		84,
		76,
		62,
		58,
		59,
		62,
		62,
		68,
		44,
		54,
		58,
		56,
		81,
		-1,
		-1,
		126,
		-1,
		-1,
		143,
		126,
		-1,
		109,
		116,
		106,
		112,
		98,
		119,
		95,
		86,
		78,
		72,
		60,
		57,
		54,
		67,
		55,
		41,
		66,
		70,
		51,
		72,
		67,
		-1,
		125,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		105,
		111,
		135,
		135,
		-1,
		107,
		95,
		96,
		81,
		78,
		65,
		53,
		62,
		46,
		53,
		52,
		45,
		43,
		73,
		48,
		70,
		67,
		96,
		101,
		95,
		104,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		139,
		-1,
		143,
		144,
		119,
		92,
		95,
		82,
		73,
		60,
		49,
		60,
		44,
		41,
		47,
		37,
		52,
		43,
		42,
		60,
		75,
		88,
		92,
		98,
		-1,
		201,
		-1,
		143,
		127,
		129,
		101,
		122,
		-1,
		159,
		144,
		136,
		121,
		120,
		-1,
		91,
		88,
		78,
		56,
		41,
		56,
		45,
		46,
		38,
		32,
		46,
		37,
		55,
		62,
		70,
		74,
		94,
		106,
		161,
		151,
		-1,
		133,
		138,
		97,
		105,
		124,
		162,
		126,
		-1,
		121,
		-1,
		93,
		106,
		-1,
		62,
		58,
		40,
		41,
		36,
		46,
		31,
		28,
		25,
		43,
		46,
		63,
		67,
		83,
		-1,
		-1,
		146,
		150,
		139,
		90,
		109,
		133,
		170,
		119,
		108,
		107,
		-1,
		98,
		76,
		73,
		61,
		48,
		33,
		34,
		41,
		29,
		8,
		27,
		30,
		52,
		80,
		58,
		70,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		116,
		87,
		111,
		153,
		137,
		130,
		118,
		83,
		83,
		77,
		-1,
		72,
		51,
		42,
		31,
		29,
		31,
		5,
		27,
		31,
		33,
		49,
		61,
		52,
		72,
		-1,
		-1,
		-1,
		146,
		135,
		136,
		82,
		105,
		142,
		116,
		102,
		107,
		82,
		75,
		69,
		85,
		68,
		49,
		38,
		29,
		19,
		0,
		10,
		14,
		33,
		42,
		43,
		67,
		74,
		80,
		-1,
		-1,
		153,
		143,
		127,
		129,
		126,
		96,
		103,
		135,
		107,
		120,
		-1,
		74,
		-1,
		63,
		59,
		43,
		38,
		35,
		23,
		10,
		21,
		16,
		34,
		38,
		53,
		72,
		72,
		64,
		89,
		92,
		-1,
		-1,
		-1,
		146,
		141,
		116,
		93,
		77,
		113,
		-1,
		90,
		91,
		-1,
		68,
		62,
		59,
		45,
		41,
		27,
		31,
		25,
		24,
		24,
		33,
		47,
		39,
		75,
		-1,
		72,
		66,
		91,
		81,
		69,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		72,
		124,
		-1,
		-1,
		75,
		68,
		-1,
		55,
		37,
		39,
		34,
		33,
		32,
		31,
		20,
		33,
		38,
		44,
		49,
		74,
		78,
		82,
		71,
		67,
		64,
		78,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		92,
		-1,
		84,
		76,
		66,
		60,
		54,
		50,
		48,
		61,
		45,
		44,
		43,
		34,
		42,
		27,
		30,
		46,
		51,
		69,
		77,
		69,
		63,
		62,
		74,
		-1,
		159,
		145,
		116,
		-1,
		-1,
		105,
		-1,
		69,
		83,
		99,
		-1,
		92,
		71,
		86,
		64,
		60,
		51,
		68,
		69,
		47,
		43,
		41,
		51,
		52,
		41,
		59,
		51,
		73,
		73,
		57,
		58,
		67,
		-1,
		165,
		152,
		110,
		106,
		95,
		115,
		66,
		54,
		86,
		-1,
		-1,
		128,
		-1,
		62,
		79,
		65,
		63,
		58,
		49,
		55,
		52,
		55,
		56,
		46,
		35,
		41,
		45,
		67,
		53,
		51,
		70,
		86,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		68,
		62,
		-1,
		103,
		-1,
		106,
		96,
		80,
		65,
		98,
		-1,
		66,
		50,
		55,
		-1,
		81,
		-1,
		54,
		56,
		54,
		42,
		39,
		50,
		48,
		59,
		76,
		-1,
		115,
		100,
		93,
		83,
		97,
		68,
		-1,
		123,
		-1,
		-1,
		93,
		87,
		87,
		71,
		74,
		82,
		62,
		56,
		55,
		76,
		83,
		62,
		55,
		48,
		45,
		42,
		55,
		75,
		66,
		78,
		-1,
		-1,
		-1,
		120,
		106,
		110,
		70,
		89,
		-1,
		-1,
		155,
		110,
		96,
		-1,
		80,
		99,
		87,
		77,
		67,
		101,
		96,
		74,
		67,
		53,
		55,
		53,
		51,
		56,
		77,
		78,
		91,
		-1,
		-1,
		103,
		108,
		96,
		82,
		101,
		-1,
		-1,
		-1,
		102,
		118,
		110,
		81,
		88,
		-1,
		-1,
		79,
		77,
		87,
		70,
		57,
		77,
		80,
		66,
		50,
		65,
		77,
		85,
		90,
		-1,
		106,
		93,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		112,
		107,
		111,
		82,
		-1,
		83,
		81,
		61,
		75,
		82,
		68,
		63,
		57,
		60,
		78,
		95,
		-1,
		-1,
		118,
		-1,
		113,
		-1,
		-1,
		-1,
		-1,
		92,
		106,
		100,
		93,
		97,
		-1,
		85,
		77,
		63,
		80,
		81,
		78,
		69,
		61,
		66,
		63,
		76,
		90,
		94,
		141,
		-1,
		124,
		-1,
		-1,
		-1,
		110,
		125,
		139,
		116,
		89,
		84,
		77,
		71,
		71,
		87,
		89,
		100,
		68,
		64,
		65,
		69,
		68,
		85,
		95,
		-1,
		-1,
		124,
		141,
		136,
		118,
		122,
		166,
		-1,
		-1,
		93,
		84,
		75,
		78,
		81,
		84,
		74,
		71,
		76,
		81,
		69,
		78,
		96,
		100,
		-1,
		-1,
		-1,
		144,
		-1,
		159,
		-1,
		-1,
		137,
		164,
		111,
		93,
		89,
		87,
		80,
		89,
		84,
		79,
		89,
		99,
		91,
		71,
		84,
		106,
		96,
		132,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		173,
		148,
		163,
		175,
		157,
		164,
		126,
		123,
		-1,
		93,
		118,
		90,
		97,
		89,
		97,
		97,
		95,
		74,
		81,
		97,
		96,
		91,
		124,
		118,
		124,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		175,
		165,
		161,
		151,
		154,
		-1,
		-1,
		142,
		139,
		115,
		99,
		103,
		96,
		91,
		103,
		83,
		70,
		74,
		78,
		84,
		89,
		94,
		100,
		115,
		130,
		-1,
		151,
		232,
		225,
		208,
		216,
		247,
		-1,
		165,
		157,
		168,
		143,
		145,
		-1,
		-1,
		115,
		112,
		117,
		106,
		103,
		113,
		108,
		99,
		84,
		90,
		77,
		76,
		94,
		98,
		107,
		114,
		104,
		117,
		121,
		-1,
		165,
		208,
		202,
		205,
		229,
		243,
		-1,
		162,
		-1,
		-1,
		174,
		146,
		130,
		120,
		114,
		164,
		120,
		115,
		107,
		105,
		96,
		87,
		94,
		85,
		85,
		88,
		103,
		108,
		100,
		114,
		114,
		115,
		-1,
		200,
		188,
		196,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		190,
		-1,
		157,
		-1,
		132,
		136,
		128,
		131,
		121,
		108,
		100,
		92,
		108,
		83,
		93,
		89,
		90,
		99,
		110,
		122,
		121,
		122,
		234,
		190,
		193,
		187,
		215,
		230,
		234,
		-1,
		174,
		213,
		220,
		-1,
		199,
		-1,
		-1,
		-1,
		146,
		141,
		133,
		141,
		120,
		120,
		94,
		98,
		88,
		95,
		105,
		107,
		99,
		103,
		116,
		127,
		130,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		189,
		180,
		207,
		227,
		216,
		211,
		198,
		-1,
		-1,
		169,
		151,
		-1,
		-1,
		127,
		115,
		98,
		99,
		95,
		98,
		113,
		116,
		106,
		104,
		98,
		130,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		208,
		203,
		207,
		223,
		248,
		-1,
		187,
		-1,
		-1,
		172,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		103,
		114,
		124,
		112,
		113,
		103,
		113,
		126,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		203,
		183,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		130,
		132,
		121,
		115,
		109,
		116,
		115,
		123,
		131,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		189,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		123,
		127,
		119,
		112,
		107,
		118,
		110,
		114,
		131,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		113,
		124,
		113,
		116,
		130,
		125,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		200,
		202,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		117,
		123,
		126,
		115,
		119,
		131,
		-1,
		-1,
		197,
		198,
		203,
		-1,
		185,
		-1,
		203,
		-1,
		170,
		176,
		164,
		-1,
		-1,
		-1,
		158,
		121,
		142,
		152,
		146,
		144,
		135,
		121,
		128,
		126,
		122,
		133,
		-1,
		-1,
		-1,
		203,
		177,
		210,
		201,
		184,
		164,
		156,
		175,
		-1,
		145,
		-1,
		120,
		122,
		148,
		151,
		157,
		151,
		124,
		139,
		129,
		120,
		129,
		209,
		-1,
		179,
		212,
		176,
		170,
		146,
		150,
		166,
		-1,
		142,
		124,
		-1,
		152,
		142,
		173,
		158,
		139,
		126,
		133,
		133,
		126,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		151,
		142,
		-1,
		154,
		136,
		115,
		132,
		132,
		123,
		131,
		163,
		159,
		146,
		146,
		138,
		-1,
		282,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		170,
		143,
		131,
		137,
		133,
		119,
		125,
		127,
		135,
		133,
		130,
		142,
		138,
		158,
		139,
		174,
		-1,
		277,
		-1,
		211,
		-1,
		-1,
		193,
		173,
		165,
		154,
		143,
		141,
		132,
		123,
		145,
		161,
		145,
		143,
		146,
		147,
		-1,
		266,
		265,
		-1,
		212,
		204,
		190,
		-1,
		183,
		-1,
		189,
		150,
		-1,
		152,
		132,
		-1,
		154,
		150,
		-1,
		-1,
		253,
		228,
		-1,
		-1,
		-1,
		213,
		193,
		184,
		168,
		-1,
		143,
		143,
		-1,
		-1,
		-1,
		238,
		237,
		-1,
		206,
		209,
		-1,
		199,
		190,
		198,
		145,
		149,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		221,
		219,
		214,
		211,
		197,
		181,
		159,
		148,
		169,
		-1,
		-1,
		-1,
		219,
		211,
		204,
		-1,
		-1,
		206,
		189,
		170,
		168,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		196,
		-1,
		-1,
		202,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		230,
		-1,
		-1,
		-1,
		192,
		188,
		189,
		-1,
		-1,
		-1,
		-1,
		252,
		253,
		276,
		240,
		-1,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		255,
		253,
		-1,
		-1,
		-1,
		212,
		196,
		-1,
		182,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		217,
		-1,
		217,
		192,
		199,
		-1,
		-1,
		-1,
		-1,
		230,
		222,
		230,
		-1,
		202,
		204,
		-1,
		252,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		207,
		214,
		236,
		239,
		275,
		-1,
		226
	],
	[
		-1,
		150,
		139,
		150,
		158,
		131,
		138,
		-1,
		157,
		161,
		127,
		121,
		160,
		129,
		135,
		146,
		-1,
		-1,
		-1,
		150,
		149,
		117,
		115,
		124,
		129,
		136,
		-1,
		135,
		-1,
		171,
		150,
		161,
		166,
		110,
		107,
		127,
		146,
		128,
		120,
		186,
		140,
		111,
		105,
		123,
		113,
		122,
		114,
		-1,
		111,
		101,
		123,
		102,
		113,
		105,
		-1,
		-1,
		105,
		106,
		112,
		98,
		104,
		100,
		-1,
		110,
		94,
		-1,
		-1,
		95,
		96,
		80,
		83,
		91,
		89,
		102,
		94,
		89,
		-1,
		-1,
		86,
		82,
		89,
		76,
		72,
		89,
		102,
		84,
		98,
		97,
		-1,
		97,
		115,
		115,
		83,
		81,
		65,
		63,
		81,
		83,
		89,
		89,
		-1,
		106,
		107,
		92,
		100,
		105,
		81,
		68,
		68,
		78,
		71,
		90,
		78,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		89,
		106,
		88,
		78,
		93,
		86,
		71,
		68,
		66,
		63,
		79,
		77,
		87,
		-1,
		-1,
		199,
		168,
		197,
		155,
		136,
		-1,
		102,
		82,
		86,
		82,
		76,
		69,
		83,
		79,
		-1,
		57,
		56,
		84,
		70,
		81,
		159,
		-1,
		-1,
		157,
		149,
		132,
		135,
		112,
		108,
		97,
		96,
		88,
		74,
		70,
		66,
		69,
		69,
		75,
		51,
		61,
		65,
		63,
		88,
		-1,
		-1,
		122,
		-1,
		-1,
		156,
		139,
		-1,
		122,
		129,
		118,
		124,
		110,
		131,
		107,
		98,
		90,
		84,
		72,
		64,
		61,
		74,
		62,
		48,
		73,
		77,
		58,
		79,
		74,
		-1,
		121,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		115,
		118,
		124,
		148,
		147,
		-1,
		119,
		107,
		108,
		93,
		90,
		77,
		65,
		69,
		53,
		60,
		59,
		52,
		50,
		80,
		55,
		77,
		74,
		92,
		97,
		91,
		100,
		-1,
		164,
		160,
		156,
		163,
		112,
		-1,
		-1,
		152,
		-1,
		155,
		156,
		131,
		104,
		107,
		94,
		85,
		72,
		61,
		70,
		51,
		48,
		54,
		44,
		59,
		50,
		49,
		67,
		76,
		84,
		88,
		94,
		-1,
		214,
		-1,
		156,
		140,
		142,
		114,
		135,
		-1,
		172,
		156,
		148,
		133,
		133,
		-1,
		103,
		100,
		90,
		68,
		53,
		63,
		52,
		53,
		45,
		39,
		53,
		44,
		62,
		69,
		66,
		70,
		90,
		102,
		174,
		164,
		-1,
		146,
		151,
		110,
		118,
		137,
		175,
		139,
		-1,
		134,
		-1,
		105,
		118,
		-1,
		74,
		70,
		52,
		53,
		46,
		53,
		38,
		35,
		32,
		50,
		53,
		59,
		63,
		79,
		-1,
		-1,
		159,
		163,
		152,
		103,
		122,
		146,
		183,
		132,
		121,
		120,
		-1,
		111,
		88,
		85,
		73,
		60,
		45,
		46,
		52,
		36,
		15,
		34,
		34,
		50,
		76,
		54,
		66,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		129,
		100,
		124,
		166,
		150,
		143,
		131,
		96,
		96,
		90,
		-1,
		84,
		63,
		54,
		43,
		41,
		41,
		18,
		17,
		32,
		30,
		45,
		57,
		48,
		68,
		-1,
		-1,
		-1,
		159,
		148,
		149,
		95,
		118,
		155,
		129,
		115,
		120,
		95,
		88,
		82,
		97,
		80,
		61,
		50,
		40,
		31,
		13,
		0,
		4,
		28,
		35,
		39,
		63,
		70,
		76,
		-1,
		-1,
		166,
		156,
		140,
		142,
		139,
		109,
		116,
		148,
		120,
		133,
		-1,
		87,
		-1,
		76,
		71,
		55,
		50,
		47,
		36,
		23,
		18,
		6,
		24,
		33,
		44,
		68,
		68,
		60,
		85,
		88,
		-1,
		-1,
		-1,
		159,
		154,
		129,
		106,
		90,
		126,
		-1,
		103,
		104,
		-1,
		81,
		75,
		72,
		57,
		53,
		40,
		44,
		38,
		36,
		33,
		23,
		39,
		31,
		67,
		-1,
		68,
		62,
		90,
		93,
		82,
		-1,
		-1,
		-1,
		152,
		131,
		124,
		144,
		85,
		137,
		-1,
		-1,
		88,
		81,
		-1,
		68,
		50,
		52,
		47,
		46,
		45,
		44,
		33,
		41,
		33,
		36,
		46,
		66,
		70,
		81,
		74,
		79,
		77,
		91,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		105,
		-1,
		97,
		89,
		79,
		73,
		67,
		63,
		61,
		74,
		58,
		57,
		56,
		47,
		55,
		40,
		42,
		39,
		43,
		61,
		90,
		82,
		76,
		75,
		87,
		-1,
		172,
		158,
		129,
		-1,
		-1,
		118,
		-1,
		82,
		96,
		112,
		-1,
		105,
		84,
		99,
		77,
		73,
		64,
		81,
		82,
		60,
		56,
		54,
		64,
		64,
		53,
		51,
		55,
		70,
		80,
		70,
		71,
		80,
		-1,
		178,
		165,
		123,
		119,
		108,
		128,
		79,
		67,
		99,
		-1,
		-1,
		141,
		-1,
		75,
		92,
		78,
		76,
		71,
		62,
		68,
		65,
		68,
		68,
		58,
		47,
		53,
		58,
		80,
		66,
		64,
		83,
		99,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		94,
		81,
		75,
		-1,
		116,
		-1,
		119,
		109,
		93,
		78,
		111,
		-1,
		79,
		63,
		68,
		-1,
		93,
		-1,
		66,
		68,
		66,
		55,
		52,
		63,
		61,
		72,
		89,
		-1,
		128,
		113,
		106,
		96,
		110,
		81,
		-1,
		136,
		-1,
		-1,
		106,
		100,
		100,
		84,
		87,
		95,
		75,
		69,
		68,
		88,
		94,
		74,
		66,
		59,
		56,
		55,
		68,
		88,
		79,
		91,
		-1,
		-1,
		-1,
		133,
		119,
		123,
		83,
		102,
		-1,
		-1,
		168,
		123,
		109,
		-1,
		93,
		112,
		100,
		90,
		80,
		114,
		108,
		85,
		78,
		64,
		66,
		64,
		64,
		69,
		90,
		91,
		104,
		-1,
		-1,
		116,
		121,
		109,
		95,
		114,
		-1,
		-1,
		-1,
		115,
		131,
		123,
		94,
		101,
		-1,
		-1,
		92,
		90,
		100,
		81,
		68,
		88,
		91,
		79,
		63,
		78,
		90,
		98,
		103,
		-1,
		119,
		106,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		125,
		120,
		124,
		95,
		-1,
		96,
		92,
		72,
		86,
		93,
		81,
		76,
		70,
		73,
		91,
		108,
		-1,
		-1,
		131,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		105,
		119,
		113,
		106,
		110,
		-1,
		98,
		88,
		74,
		91,
		94,
		91,
		82,
		74,
		79,
		76,
		89,
		103,
		107,
		154,
		-1,
		137,
		-1,
		-1,
		-1,
		123,
		138,
		152,
		129,
		102,
		97,
		90,
		84,
		82,
		98,
		102,
		113,
		81,
		77,
		78,
		82,
		81,
		98,
		108,
		-1,
		-1,
		137,
		154,
		149,
		131,
		135,
		179,
		-1,
		-1,
		106,
		97,
		88,
		91,
		92,
		95,
		87,
		84,
		89,
		94,
		82,
		91,
		109,
		110,
		-1,
		-1,
		-1,
		157,
		-1,
		172,
		-1,
		-1,
		150,
		177,
		124,
		106,
		102,
		100,
		93,
		102,
		97,
		92,
		102,
		106,
		98,
		84,
		90,
		113,
		102,
		141,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		186,
		161,
		176,
		188,
		170,
		177,
		139,
		136,
		-1,
		106,
		131,
		103,
		110,
		102,
		110,
		110,
		102,
		80,
		87,
		103,
		102,
		97,
		133,
		124,
		130,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		188,
		178,
		174,
		164,
		167,
		-1,
		-1,
		155,
		152,
		128,
		112,
		111,
		104,
		99,
		109,
		89,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		121,
		136,
		-1,
		164,
		245,
		238,
		221,
		229,
		260,
		-1,
		178,
		170,
		181,
		156,
		158,
		-1,
		-1,
		128,
		125,
		130,
		119,
		116,
		119,
		114,
		105,
		90,
		96,
		83,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		178,
		221,
		215,
		218,
		242,
		256,
		-1,
		175,
		-1,
		-1,
		187,
		159,
		143,
		133,
		127,
		177,
		133,
		128,
		113,
		111,
		102,
		93,
		100,
		91,
		91,
		94,
		109,
		114,
		106,
		120,
		120,
		121,
		-1,
		213,
		201,
		209,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		203,
		-1,
		170,
		-1,
		145,
		149,
		141,
		144,
		127,
		114,
		106,
		98,
		114,
		89,
		99,
		95,
		96,
		105,
		116,
		128,
		127,
		128,
		247,
		203,
		206,
		200,
		228,
		243,
		247,
		-1,
		187,
		226,
		226,
		-1,
		210,
		-1,
		-1,
		-1,
		159,
		154,
		146,
		147,
		126,
		126,
		100,
		104,
		94,
		101,
		111,
		113,
		105,
		109,
		122,
		133,
		136,
		243,
		234,
		247,
		192,
		192,
		213,
		222,
		243,
		202,
		193,
		220,
		233,
		222,
		217,
		204,
		-1,
		-1,
		182,
		164,
		-1,
		-1,
		133,
		121,
		104,
		105,
		101,
		104,
		119,
		122,
		112,
		110,
		104,
		136,
		-1,
		236,
		235,
		224,
		221,
		197,
		188,
		183,
		210,
		-1,
		-1,
		205,
		221,
		216,
		220,
		236,
		261,
		-1,
		193,
		-1,
		-1,
		178,
		-1,
		-1,
		163,
		126,
		115,
		106,
		112,
		109,
		120,
		130,
		118,
		119,
		109,
		119,
		132,
		220,
		217,
		205,
		203,
		226,
		191,
		179,
		-1,
		192,
		190,
		196,
		203,
		220,
		250,
		-1,
		-1,
		209,
		189,
		-1,
		-1,
		161,
		159,
		148,
		-1,
		138,
		111,
		116,
		136,
		138,
		127,
		121,
		115,
		122,
		121,
		129,
		137,
		229,
		243,
		232,
		228,
		227,
		235,
		184,
		177,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		199,
		195,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		129,
		133,
		125,
		118,
		113,
		124,
		116,
		120,
		137,
		-1,
		263,
		-1,
		215,
		191,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		216,
		202,
		195,
		183,
		181,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		169,
		137,
		142,
		137,
		119,
		130,
		119,
		122,
		136,
		131,
		-1,
		-1,
		203,
		206,
		-1,
		-1,
		206,
		208,
		-1,
		207,
		196,
		181,
		173,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		126,
		151,
		140,
		148,
		143,
		123,
		129,
		132,
		121,
		125,
		137,
		-1,
		-1,
		210,
		211,
		213,
		-1,
		191,
		-1,
		209,
		-1,
		176,
		182,
		170,
		-1,
		-1,
		-1,
		164,
		127,
		148,
		158,
		152,
		150,
		141,
		127,
		134,
		132,
		128,
		139,
		-1,
		-1,
		-1,
		209,
		183,
		216,
		207,
		190,
		170,
		162,
		181,
		-1,
		151,
		-1,
		126,
		128,
		154,
		157,
		163,
		157,
		130,
		145,
		135,
		126,
		135,
		215,
		-1,
		185,
		218,
		182,
		176,
		152,
		156,
		172,
		-1,
		148,
		130,
		-1,
		158,
		148,
		179,
		164,
		145,
		132,
		139,
		139,
		132,
		-1,
		-1,
		-1,
		187,
		186,
		178,
		172,
		172,
		157,
		148,
		-1,
		160,
		142,
		121,
		138,
		138,
		129,
		137,
		169,
		165,
		152,
		152,
		144,
		-1,
		288,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		181,
		176,
		149,
		137,
		143,
		139,
		125,
		131,
		133,
		141,
		139,
		136,
		148,
		144,
		164,
		145,
		180,
		-1,
		283,
		-1,
		217,
		-1,
		-1,
		199,
		179,
		171,
		160,
		149,
		147,
		138,
		129,
		151,
		167,
		151,
		149,
		152,
		153,
		-1,
		272,
		271,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		195,
		156,
		-1,
		158,
		138,
		-1,
		160,
		156,
		-1,
		-1,
		259,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		190,
		174,
		-1,
		149,
		149,
		-1,
		-1,
		-1,
		244,
		243,
		-1,
		212,
		215,
		-1,
		205,
		196,
		204,
		151,
		155,
		-1,
		-1,
		-1,
		253,
		234,
		228,
		227,
		225,
		220,
		217,
		203,
		187,
		165,
		154,
		175,
		-1,
		-1,
		-1,
		225,
		217,
		210,
		-1,
		-1,
		212,
		195,
		176,
		174,
		-1,
		-1,
		-1,
		247,
		228,
		-1,
		-1,
		202,
		-1,
		-1,
		208,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		236,
		-1,
		-1,
		-1,
		198,
		194,
		195,
		-1,
		-1,
		-1,
		-1,
		258,
		259,
		282,
		246,
		-1,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		261,
		259,
		-1,
		-1,
		-1,
		218,
		202,
		-1,
		188,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		223,
		-1,
		223,
		198,
		205,
		-1,
		-1,
		-1,
		-1,
		236,
		228,
		236,
		-1,
		208,
		210,
		-1,
		258,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		213,
		220,
		242,
		245,
		281,
		-1,
		232
	],
	[
		-1,
		146,
		135,
		146,
		154,
		127,
		134,
		-1,
		153,
		157,
		123,
		117,
		156,
		125,
		131,
		142,
		-1,
		-1,
		-1,
		146,
		145,
		113,
		111,
		120,
		125,
		132,
		-1,
		131,
		-1,
		167,
		146,
		157,
		162,
		106,
		103,
		123,
		142,
		124,
		116,
		182,
		136,
		107,
		101,
		119,
		109,
		118,
		110,
		-1,
		107,
		97,
		119,
		98,
		109,
		101,
		-1,
		-1,
		101,
		102,
		108,
		94,
		100,
		96,
		-1,
		106,
		90,
		-1,
		-1,
		91,
		92,
		76,
		79,
		87,
		85,
		98,
		90,
		85,
		-1,
		-1,
		82,
		78,
		85,
		72,
		68,
		85,
		98,
		80,
		94,
		93,
		-1,
		93,
		111,
		111,
		79,
		77,
		61,
		59,
		77,
		79,
		85,
		85,
		-1,
		102,
		103,
		88,
		96,
		101,
		77,
		64,
		64,
		74,
		67,
		86,
		74,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		85,
		102,
		84,
		74,
		89,
		82,
		67,
		64,
		62,
		59,
		75,
		73,
		83,
		-1,
		-1,
		195,
		164,
		193,
		151,
		132,
		-1,
		98,
		78,
		82,
		78,
		72,
		65,
		79,
		75,
		-1,
		53,
		52,
		80,
		66,
		77,
		155,
		-1,
		-1,
		153,
		145,
		128,
		131,
		108,
		104,
		93,
		92,
		84,
		70,
		66,
		62,
		65,
		65,
		71,
		47,
		57,
		61,
		59,
		84,
		-1,
		-1,
		121,
		-1,
		-1,
		152,
		135,
		-1,
		118,
		125,
		114,
		120,
		106,
		127,
		103,
		94,
		86,
		80,
		68,
		60,
		57,
		70,
		58,
		44,
		69,
		73,
		54,
		75,
		70,
		-1,
		120,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		111,
		114,
		120,
		144,
		143,
		-1,
		115,
		103,
		104,
		89,
		86,
		73,
		61,
		65,
		49,
		56,
		55,
		48,
		46,
		76,
		51,
		73,
		70,
		91,
		96,
		90,
		99,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		148,
		-1,
		151,
		152,
		127,
		100,
		103,
		90,
		81,
		68,
		57,
		66,
		47,
		44,
		50,
		40,
		55,
		46,
		45,
		63,
		75,
		83,
		87,
		93,
		-1,
		210,
		-1,
		152,
		136,
		138,
		110,
		131,
		-1,
		168,
		152,
		144,
		129,
		129,
		-1,
		99,
		96,
		86,
		64,
		49,
		59,
		48,
		49,
		41,
		35,
		49,
		40,
		58,
		65,
		65,
		69,
		89,
		101,
		170,
		160,
		-1,
		142,
		147,
		106,
		114,
		133,
		171,
		135,
		-1,
		130,
		-1,
		101,
		114,
		-1,
		70,
		66,
		48,
		49,
		42,
		49,
		34,
		31,
		28,
		46,
		49,
		58,
		62,
		78,
		-1,
		-1,
		155,
		159,
		148,
		99,
		118,
		142,
		179,
		128,
		117,
		116,
		-1,
		107,
		84,
		81,
		69,
		56,
		41,
		42,
		48,
		32,
		11,
		30,
		33,
		49,
		75,
		53,
		65,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		125,
		96,
		120,
		162,
		146,
		139,
		127,
		92,
		92,
		86,
		-1,
		80,
		59,
		50,
		39,
		37,
		43,
		15,
		16,
		31,
		29,
		44,
		56,
		47,
		67,
		-1,
		-1,
		-1,
		155,
		144,
		145,
		91,
		114,
		151,
		125,
		111,
		116,
		91,
		84,
		78,
		93,
		76,
		57,
		46,
		38,
		27,
		15,
		11,
		0,
		27,
		34,
		38,
		62,
		69,
		75,
		-1,
		-1,
		162,
		152,
		136,
		138,
		135,
		105,
		112,
		144,
		116,
		129,
		-1,
		83,
		-1,
		72,
		67,
		51,
		46,
		43,
		36,
		23,
		16,
		12,
		23,
		32,
		44,
		67,
		67,
		59,
		84,
		87,
		-1,
		-1,
		-1,
		155,
		150,
		125,
		102,
		86,
		122,
		-1,
		99,
		100,
		-1,
		77,
		71,
		68,
		53,
		49,
		40,
		44,
		38,
		34,
		36,
		27,
		39,
		33,
		69,
		-1,
		67,
		61,
		89,
		92,
		82,
		-1,
		-1,
		-1,
		148,
		127,
		120,
		140,
		81,
		133,
		-1,
		-1,
		84,
		77,
		-1,
		64,
		46,
		52,
		47,
		45,
		45,
		44,
		33,
		45,
		37,
		38,
		47,
		68,
		72,
		80,
		73,
		78,
		77,
		91,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		101,
		-1,
		93,
		85,
		75,
		69,
		63,
		59,
		57,
		73,
		57,
		57,
		56,
		47,
		55,
		40,
		43,
		41,
		45,
		63,
		90,
		82,
		76,
		75,
		87,
		-1,
		168,
		154,
		125,
		-1,
		-1,
		114,
		-1,
		78,
		92,
		108,
		-1,
		101,
		80,
		95,
		73,
		69,
		64,
		80,
		81,
		59,
		56,
		54,
		64,
		65,
		54,
		53,
		57,
		72,
		82,
		70,
		71,
		80,
		-1,
		174,
		161,
		119,
		115,
		104,
		124,
		75,
		63,
		95,
		-1,
		-1,
		137,
		-1,
		71,
		88,
		78,
		76,
		70,
		61,
		67,
		65,
		68,
		69,
		59,
		48,
		54,
		58,
		80,
		66,
		64,
		83,
		99,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		90,
		77,
		71,
		-1,
		112,
		-1,
		115,
		105,
		89,
		74,
		107,
		-1,
		78,
		62,
		67,
		-1,
		94,
		-1,
		67,
		69,
		67,
		55,
		52,
		63,
		61,
		72,
		89,
		-1,
		124,
		109,
		102,
		92,
		106,
		77,
		-1,
		132,
		-1,
		-1,
		102,
		96,
		96,
		80,
		83,
		94,
		74,
		68,
		67,
		89,
		96,
		75,
		68,
		61,
		58,
		55,
		68,
		88,
		79,
		91,
		-1,
		-1,
		-1,
		129,
		115,
		119,
		79,
		98,
		-1,
		-1,
		164,
		119,
		105,
		-1,
		89,
		111,
		99,
		89,
		79,
		113,
		109,
		87,
		80,
		66,
		68,
		66,
		64,
		69,
		90,
		91,
		104,
		-1,
		-1,
		112,
		117,
		105,
		91,
		110,
		-1,
		-1,
		-1,
		111,
		127,
		119,
		90,
		100,
		-1,
		-1,
		91,
		89,
		99,
		83,
		70,
		90,
		93,
		79,
		63,
		78,
		90,
		98,
		103,
		-1,
		115,
		102,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		-1,
		-1,
		144,
		110,
		122,
		120,
		124,
		94,
		-1,
		96,
		94,
		74,
		88,
		95,
		81,
		76,
		70,
		73,
		91,
		108,
		-1,
		-1,
		127,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		101,
		115,
		113,
		106,
		110,
		-1,
		98,
		90,
		76,
		93,
		94,
		91,
		82,
		74,
		79,
		76,
		89,
		103,
		107,
		150,
		-1,
		133,
		-1,
		-1,
		-1,
		119,
		134,
		152,
		129,
		102,
		97,
		90,
		84,
		84,
		100,
		102,
		113,
		81,
		77,
		78,
		82,
		81,
		98,
		108,
		-1,
		-1,
		133,
		150,
		145,
		127,
		131,
		179,
		-1,
		-1,
		106,
		97,
		88,
		91,
		94,
		97,
		87,
		84,
		89,
		94,
		82,
		91,
		109,
		112,
		-1,
		-1,
		-1,
		153,
		-1,
		168,
		-1,
		-1,
		146,
		177,
		124,
		106,
		102,
		100,
		93,
		102,
		97,
		92,
		102,
		108,
		100,
		84,
		92,
		115,
		104,
		143,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		182,
		157,
		172,
		188,
		166,
		173,
		139,
		136,
		-1,
		106,
		131,
		103,
		110,
		102,
		110,
		110,
		104,
		82,
		89,
		105,
		104,
		99,
		135,
		126,
		132,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		188,
		174,
		174,
		164,
		167,
		-1,
		-1,
		155,
		152,
		128,
		112,
		113,
		106,
		101,
		111,
		91,
		78,
		82,
		86,
		92,
		97,
		102,
		108,
		123,
		138,
		-1,
		160,
		241,
		234,
		217,
		225,
		256,
		-1,
		178,
		170,
		181,
		156,
		158,
		-1,
		-1,
		128,
		125,
		130,
		119,
		116,
		121,
		116,
		107,
		92,
		98,
		85,
		84,
		102,
		106,
		115,
		122,
		112,
		125,
		129,
		-1,
		174,
		217,
		211,
		214,
		238,
		252,
		-1,
		175,
		-1,
		-1,
		187,
		159,
		143,
		133,
		127,
		177,
		133,
		128,
		115,
		113,
		104,
		95,
		102,
		93,
		93,
		96,
		111,
		116,
		108,
		122,
		122,
		123,
		-1,
		209,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		203,
		-1,
		170,
		-1,
		145,
		149,
		141,
		144,
		129,
		116,
		108,
		100,
		116,
		91,
		101,
		97,
		98,
		107,
		118,
		130,
		129,
		130,
		247,
		203,
		205,
		196,
		228,
		243,
		247,
		-1,
		187,
		226,
		228,
		-1,
		212,
		-1,
		-1,
		-1,
		159,
		154,
		146,
		149,
		128,
		128,
		102,
		106,
		96,
		103,
		113,
		115,
		107,
		111,
		124,
		135,
		138,
		243,
		234,
		247,
		192,
		192,
		213,
		222,
		243,
		202,
		193,
		220,
		235,
		224,
		219,
		206,
		-1,
		-1,
		182,
		164,
		-1,
		-1,
		135,
		123,
		106,
		107,
		103,
		106,
		121,
		124,
		114,
		112,
		106,
		138,
		-1,
		236,
		235,
		224,
		221,
		197,
		188,
		183,
		210,
		-1,
		-1,
		205,
		221,
		216,
		220,
		236,
		261,
		-1,
		195,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		128,
		117,
		108,
		114,
		111,
		122,
		132,
		120,
		121,
		111,
		121,
		134,
		220,
		217,
		205,
		203,
		226,
		191,
		179,
		-1,
		192,
		190,
		196,
		203,
		220,
		250,
		-1,
		-1,
		211,
		191,
		-1,
		-1,
		163,
		161,
		150,
		-1,
		140,
		113,
		118,
		138,
		140,
		129,
		123,
		117,
		124,
		123,
		131,
		139,
		229,
		243,
		232,
		228,
		227,
		235,
		184,
		177,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		197,
		-1,
		-1,
		158,
		151,
		139,
		127,
		117,
		127,
		131,
		135,
		127,
		120,
		115,
		126,
		118,
		122,
		139,
		-1,
		263,
		-1,
		215,
		191,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		192,
		176,
		157,
		-1,
		127,
		140,
		171,
		139,
		144,
		139,
		121,
		132,
		121,
		124,
		138,
		133,
		-1,
		-1,
		203,
		206,
		-1,
		-1,
		208,
		210,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		164,
		160,
		-1,
		-1,
		128,
		153,
		142,
		150,
		145,
		125,
		131,
		134,
		123,
		127,
		139,
		-1,
		-1,
		210,
		211,
		215,
		-1,
		193,
		-1,
		211,
		-1,
		178,
		184,
		172,
		-1,
		-1,
		-1,
		166,
		129,
		150,
		160,
		154,
		152,
		143,
		129,
		136,
		134,
		130,
		141,
		-1,
		-1,
		-1,
		211,
		185,
		218,
		209,
		192,
		172,
		164,
		183,
		-1,
		153,
		-1,
		128,
		130,
		156,
		159,
		165,
		159,
		132,
		147,
		137,
		128,
		137,
		217,
		-1,
		187,
		220,
		184,
		178,
		154,
		158,
		174,
		-1,
		150,
		132,
		-1,
		160,
		150,
		181,
		166,
		147,
		134,
		141,
		141,
		134,
		-1,
		-1,
		-1,
		189,
		188,
		180,
		174,
		174,
		159,
		150,
		-1,
		162,
		144,
		123,
		140,
		140,
		131,
		139,
		171,
		167,
		154,
		154,
		146,
		-1,
		290,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		183,
		178,
		151,
		139,
		145,
		141,
		127,
		133,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		147,
		182,
		-1,
		285,
		-1,
		219,
		-1,
		-1,
		201,
		181,
		173,
		162,
		151,
		149,
		140,
		131,
		153,
		169,
		153,
		151,
		154,
		155,
		-1,
		274,
		273,
		-1,
		220,
		212,
		198,
		-1,
		191,
		-1,
		197,
		158,
		-1,
		160,
		140,
		-1,
		162,
		158,
		-1,
		-1,
		261,
		236,
		-1,
		-1,
		-1,
		221,
		201,
		192,
		176,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		246,
		245,
		-1,
		214,
		217,
		-1,
		207,
		198,
		206,
		153,
		157,
		-1,
		-1,
		-1,
		255,
		236,
		230,
		229,
		227,
		222,
		219,
		205,
		189,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		227,
		219,
		212,
		-1,
		-1,
		214,
		197,
		178,
		176,
		-1,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		204,
		-1,
		-1,
		210,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		238,
		-1,
		-1,
		-1,
		200,
		196,
		197,
		-1,
		-1,
		-1,
		-1,
		260,
		261,
		284,
		248,
		-1,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		263,
		261,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		190,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		225,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		238,
		230,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		215,
		222,
		244,
		247,
		283,
		-1,
		234
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		135,
		139,
		105,
		99,
		138,
		107,
		113,
		124,
		-1,
		-1,
		-1,
		128,
		127,
		95,
		93,
		102,
		107,
		114,
		-1,
		113,
		-1,
		149,
		128,
		139,
		144,
		88,
		85,
		105,
		124,
		106,
		98,
		164,
		118,
		89,
		83,
		101,
		91,
		100,
		92,
		-1,
		89,
		79,
		101,
		80,
		91,
		83,
		-1,
		-1,
		83,
		84,
		90,
		76,
		82,
		78,
		-1,
		88,
		72,
		-1,
		-1,
		73,
		74,
		58,
		61,
		69,
		67,
		80,
		72,
		67,
		-1,
		-1,
		64,
		60,
		67,
		54,
		50,
		67,
		80,
		62,
		76,
		75,
		-1,
		76,
		93,
		93,
		61,
		59,
		43,
		41,
		59,
		61,
		67,
		67,
		-1,
		93,
		89,
		90,
		88,
		83,
		59,
		46,
		46,
		56,
		49,
		68,
		56,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		85,
		102,
		86,
		76,
		80,
		78,
		49,
		46,
		44,
		41,
		57,
		55,
		65,
		-1,
		-1,
		187,
		160,
		184,
		142,
		124,
		-1,
		90,
		85,
		84,
		80,
		74,
		67,
		80,
		65,
		-1,
		35,
		34,
		62,
		48,
		59,
		162,
		-1,
		-1,
		145,
		137,
		119,
		122,
		99,
		95,
		100,
		99,
		91,
		77,
		73,
		64,
		67,
		67,
		73,
		29,
		39,
		43,
		41,
		66,
		-1,
		-1,
		98,
		-1,
		-1,
		159,
		142,
		-1,
		114,
		121,
		105,
		111,
		97,
		118,
		110,
		101,
		93,
		87,
		75,
		62,
		59,
		72,
		51,
		26,
		51,
		55,
		36,
		57,
		52,
		-1,
		97,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		118,
		118,
		111,
		135,
		134,
		-1,
		122,
		110,
		111,
		96,
		93,
		80,
		68,
		67,
		51,
		51,
		48,
		30,
		28,
		58,
		33,
		55,
		52,
		68,
		73,
		67,
		76,
		-1,
		167,
		163,
		159,
		166,
		115,
		-1,
		-1,
		139,
		-1,
		142,
		155,
		134,
		107,
		110,
		97,
		88,
		75,
		64,
		68,
		49,
		46,
		42,
		22,
		37,
		28,
		27,
		45,
		52,
		60,
		64,
		70,
		-1,
		217,
		-1,
		159,
		143,
		145,
		117,
		138,
		-1,
		159,
		143,
		151,
		136,
		136,
		-1,
		106,
		103,
		93,
		71,
		56,
		61,
		49,
		44,
		35,
		17,
		31,
		22,
		39,
		46,
		42,
		46,
		66,
		78,
		177,
		167,
		-1,
		149,
		154,
		113,
		121,
		140,
		178,
		142,
		-1,
		137,
		-1,
		108,
		121,
		-1,
		77,
		73,
		55,
		56,
		46,
		53,
		28,
		13,
		10,
		28,
		30,
		35,
		39,
		55,
		-1,
		-1,
		162,
		166,
		155,
		106,
		125,
		149,
		186,
		135,
		124,
		123,
		-1,
		114,
		91,
		88,
		76,
		63,
		48,
		49,
		52,
		48,
		27,
		9,
		6,
		26,
		52,
		30,
		42,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		132,
		103,
		127,
		169,
		153,
		146,
		134,
		99,
		99,
		93,
		-1,
		87,
		66,
		57,
		46,
		44,
		56,
		33,
		24,
		4,
		2,
		21,
		33,
		24,
		44,
		-1,
		-1,
		-1,
		162,
		151,
		152,
		98,
		121,
		158,
		132,
		118,
		123,
		98,
		91,
		85,
		100,
		83,
		64,
		53,
		45,
		34,
		34,
		36,
		28,
		0,
		9,
		15,
		39,
		46,
		52,
		-1,
		-1,
		169,
		159,
		143,
		145,
		142,
		112,
		119,
		151,
		123,
		136,
		-1,
		90,
		-1,
		79,
		74,
		58,
		53,
		50,
		47,
		35,
		31,
		29,
		14,
		5,
		20,
		44,
		44,
		36,
		61,
		64,
		-1,
		-1,
		-1,
		162,
		157,
		132,
		109,
		93,
		129,
		-1,
		106,
		107,
		-1,
		84,
		78,
		75,
		60,
		56,
		51,
		55,
		48,
		41,
		31,
		23,
		24,
		6,
		42,
		-1,
		44,
		38,
		66,
		69,
		59,
		-1,
		-1,
		-1,
		155,
		134,
		127,
		147,
		88,
		140,
		-1,
		-1,
		91,
		84,
		-1,
		71,
		53,
		60,
		58,
		52,
		56,
		44,
		33,
		39,
		31,
		11,
		21,
		41,
		45,
		57,
		50,
		55,
		54,
		68,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		108,
		-1,
		100,
		92,
		82,
		76,
		70,
		66,
		64,
		80,
		64,
		67,
		56,
		47,
		55,
		35,
		28,
		14,
		18,
		36,
		65,
		59,
		53,
		52,
		64,
		-1,
		175,
		161,
		132,
		-1,
		-1,
		121,
		-1,
		85,
		99,
		115,
		-1,
		108,
		87,
		102,
		80,
		76,
		72,
		87,
		88,
		66,
		56,
		54,
		62,
		50,
		39,
		26,
		30,
		45,
		55,
		47,
		48,
		57,
		-1,
		181,
		168,
		126,
		122,
		111,
		131,
		82,
		70,
		102,
		-1,
		-1,
		144,
		-1,
		78,
		95,
		86,
		84,
		77,
		68,
		74,
		65,
		59,
		54,
		44,
		33,
		39,
		35,
		57,
		43,
		41,
		60,
		76,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		97,
		84,
		78,
		-1,
		119,
		-1,
		122,
		112,
		96,
		81,
		114,
		-1,
		85,
		69,
		74,
		-1,
		79,
		-1,
		52,
		52,
		43,
		32,
		29,
		40,
		38,
		49,
		66,
		-1,
		131,
		116,
		109,
		99,
		113,
		84,
		-1,
		139,
		-1,
		-1,
		109,
		103,
		103,
		87,
		90,
		101,
		81,
		75,
		74,
		74,
		69,
		60,
		41,
		34,
		31,
		32,
		45,
		65,
		56,
		68,
		-1,
		-1,
		-1,
		136,
		122,
		126,
		86,
		105,
		-1,
		-1,
		171,
		126,
		112,
		-1,
		96,
		118,
		106,
		96,
		86,
		95,
		85,
		60,
		53,
		39,
		41,
		39,
		41,
		46,
		67,
		68,
		81,
		-1,
		-1,
		119,
		124,
		112,
		98,
		117,
		-1,
		-1,
		-1,
		118,
		134,
		126,
		97,
		107,
		-1,
		-1,
		96,
		87,
		77,
		56,
		43,
		63,
		66,
		56,
		40,
		55,
		67,
		75,
		80,
		-1,
		122,
		109,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		-1,
		-1,
		151,
		113,
		102,
		97,
		101,
		95,
		-1,
		73,
		67,
		47,
		61,
		68,
		58,
		53,
		47,
		50,
		68,
		85,
		-1,
		-1,
		134,
		-1,
		129,
		-1,
		-1,
		-1,
		-1,
		108,
		119,
		90,
		83,
		87,
		-1,
		75,
		63,
		49,
		66,
		71,
		68,
		59,
		51,
		56,
		53,
		66,
		80,
		84,
		157,
		-1,
		140,
		-1,
		-1,
		-1,
		126,
		141,
		129,
		106,
		79,
		74,
		67,
		61,
		57,
		73,
		79,
		90,
		58,
		54,
		55,
		59,
		58,
		75,
		85,
		-1,
		-1,
		140,
		157,
		152,
		134,
		138,
		156,
		-1,
		-1,
		83,
		74,
		65,
		68,
		67,
		70,
		64,
		61,
		66,
		71,
		59,
		68,
		86,
		85,
		-1,
		-1,
		-1,
		160,
		-1,
		175,
		-1,
		-1,
		153,
		154,
		101,
		83,
		79,
		77,
		70,
		79,
		74,
		69,
		79,
		81,
		73,
		61,
		65,
		88,
		77,
		116,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		172,
		164,
		159,
		165,
		167,
		158,
		116,
		113,
		-1,
		83,
		108,
		80,
		87,
		78,
		85,
		85,
		77,
		55,
		62,
		78,
		77,
		72,
		108,
		99,
		105,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		165,
		161,
		151,
		141,
		144,
		-1,
		-1,
		132,
		129,
		105,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		55,
		59,
		65,
		70,
		75,
		81,
		96,
		111,
		-1,
		167,
		248,
		241,
		214,
		222,
		253,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		105,
		102,
		107,
		95,
		92,
		94,
		89,
		80,
		65,
		71,
		58,
		57,
		75,
		79,
		88,
		95,
		85,
		98,
		102,
		-1,
		181,
		224,
		208,
		211,
		235,
		249,
		-1,
		152,
		-1,
		-1,
		164,
		136,
		120,
		110,
		104,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		75,
		66,
		66,
		69,
		84,
		89,
		81,
		95,
		95,
		96,
		-1,
		198,
		204,
		202,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		180,
		-1,
		147,
		-1,
		122,
		126,
		117,
		120,
		102,
		89,
		81,
		73,
		89,
		64,
		74,
		70,
		71,
		80,
		91,
		103,
		102,
		103,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		164,
		203,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		136,
		130,
		122,
		122,
		101,
		101,
		75,
		79,
		69,
		76,
		86,
		88,
		80,
		84,
		97,
		108,
		111,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		179,
		170,
		197,
		208,
		197,
		192,
		179,
		-1,
		-1,
		159,
		140,
		-1,
		-1,
		108,
		96,
		79,
		80,
		76,
		79,
		94,
		97,
		87,
		85,
		79,
		111,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		198,
		192,
		196,
		212,
		237,
		-1,
		168,
		-1,
		-1,
		153,
		-1,
		-1,
		138,
		101,
		90,
		81,
		87,
		84,
		95,
		105,
		93,
		94,
		84,
		94,
		107,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		136,
		134,
		123,
		-1,
		113,
		86,
		91,
		111,
		113,
		102,
		96,
		90,
		97,
		96,
		104,
		112,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		131,
		124,
		112,
		100,
		90,
		100,
		104,
		108,
		100,
		93,
		88,
		99,
		91,
		95,
		112,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		144,
		112,
		117,
		112,
		94,
		105,
		94,
		97,
		111,
		106,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		101,
		126,
		115,
		123,
		118,
		98,
		104,
		107,
		96,
		100,
		112,
		-1,
		-1,
		186,
		187,
		188,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		139,
		102,
		123,
		133,
		127,
		125,
		116,
		102,
		109,
		107,
		103,
		114,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		103,
		129,
		132,
		138,
		132,
		105,
		120,
		110,
		101,
		110,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		133,
		123,
		154,
		139,
		120,
		107,
		114,
		114,
		107,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		113,
		104,
		112,
		144,
		140,
		127,
		127,
		119,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		120,
		155,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		126,
		124,
		127,
		128,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		135,
		131,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		150,
		154,
		120,
		114,
		153,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		143,
		142,
		110,
		108,
		117,
		122,
		129,
		-1,
		128,
		-1,
		164,
		143,
		154,
		159,
		103,
		100,
		120,
		139,
		121,
		113,
		179,
		133,
		104,
		98,
		116,
		106,
		115,
		107,
		-1,
		104,
		94,
		116,
		95,
		106,
		98,
		-1,
		-1,
		98,
		99,
		105,
		91,
		97,
		93,
		-1,
		103,
		87,
		-1,
		-1,
		88,
		89,
		73,
		76,
		84,
		82,
		95,
		87,
		82,
		-1,
		-1,
		79,
		75,
		82,
		69,
		65,
		82,
		95,
		77,
		91,
		90,
		-1,
		91,
		108,
		108,
		76,
		74,
		58,
		56,
		74,
		76,
		82,
		82,
		-1,
		108,
		104,
		105,
		103,
		98,
		74,
		61,
		61,
		71,
		64,
		83,
		71,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		100,
		117,
		101,
		91,
		95,
		93,
		64,
		61,
		59,
		56,
		72,
		70,
		80,
		-1,
		-1,
		202,
		175,
		199,
		157,
		139,
		-1,
		105,
		100,
		99,
		95,
		89,
		82,
		95,
		80,
		-1,
		50,
		49,
		77,
		63,
		74,
		177,
		-1,
		-1,
		160,
		152,
		134,
		137,
		114,
		110,
		115,
		114,
		106,
		92,
		88,
		79,
		82,
		82,
		88,
		44,
		54,
		58,
		56,
		81,
		-1,
		-1,
		107,
		-1,
		-1,
		174,
		157,
		-1,
		129,
		136,
		120,
		126,
		112,
		133,
		125,
		116,
		108,
		102,
		90,
		77,
		74,
		87,
		66,
		41,
		66,
		70,
		51,
		72,
		67,
		-1,
		106,
		90,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		133,
		126,
		150,
		149,
		-1,
		137,
		125,
		126,
		111,
		108,
		95,
		83,
		82,
		66,
		66,
		63,
		45,
		43,
		73,
		48,
		70,
		67,
		77,
		82,
		76,
		85,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		154,
		-1,
		157,
		170,
		149,
		122,
		125,
		112,
		103,
		90,
		79,
		83,
		64,
		61,
		57,
		37,
		52,
		43,
		42,
		60,
		61,
		69,
		73,
		79,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		174,
		158,
		166,
		151,
		151,
		-1,
		121,
		118,
		108,
		86,
		71,
		76,
		64,
		59,
		50,
		32,
		46,
		37,
		48,
		55,
		51,
		55,
		75,
		87,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		123,
		136,
		-1,
		92,
		88,
		70,
		71,
		61,
		68,
		43,
		28,
		25,
		43,
		39,
		44,
		48,
		64,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		106,
		103,
		91,
		78,
		63,
		64,
		67,
		63,
		42,
		24,
		21,
		35,
		61,
		39,
		51,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		102,
		81,
		72,
		61,
		59,
		71,
		48,
		35,
		19,
		17,
		30,
		42,
		33,
		53,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		115,
		98,
		79,
		68,
		60,
		49,
		49,
		47,
		39,
		15,
		0,
		24,
		48,
		55,
		61,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		89,
		73,
		68,
		65,
		62,
		50,
		46,
		44,
		25,
		15,
		26,
		53,
		53,
		45,
		70,
		73,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		75,
		71,
		66,
		70,
		63,
		56,
		46,
		38,
		39,
		21,
		55,
		-1,
		53,
		47,
		75,
		78,
		68,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		75,
		73,
		67,
		71,
		59,
		48,
		54,
		46,
		26,
		34,
		56,
		60,
		66,
		59,
		64,
		63,
		77,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		95,
		79,
		82,
		71,
		62,
		70,
		50,
		43,
		29,
		33,
		51,
		77,
		72,
		68,
		67,
		73,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		87,
		102,
		103,
		81,
		71,
		69,
		77,
		65,
		54,
		41,
		45,
		60,
		70,
		62,
		63,
		72,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		101,
		99,
		92,
		83,
		89,
		80,
		74,
		69,
		59,
		48,
		54,
		50,
		72,
		58,
		56,
		74,
		89,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		100,
		84,
		89,
		-1,
		94,
		-1,
		67,
		67,
		58,
		47,
		44,
		55,
		53,
		64,
		80,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		116,
		96,
		90,
		89,
		89,
		84,
		75,
		56,
		49,
		46,
		47,
		60,
		80,
		71,
		82,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		133,
		121,
		111,
		101,
		110,
		100,
		75,
		68,
		54,
		56,
		54,
		56,
		61,
		82,
		83,
		96,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		122,
		-1,
		-1,
		111,
		102,
		92,
		71,
		58,
		78,
		81,
		71,
		55,
		70,
		82,
		89,
		95,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		166,
		128,
		117,
		112,
		116,
		110,
		-1,
		88,
		82,
		62,
		76,
		83,
		73,
		68,
		62,
		65,
		83,
		100,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		123,
		134,
		105,
		98,
		102,
		-1,
		90,
		78,
		64,
		81,
		86,
		83,
		74,
		66,
		71,
		68,
		81,
		95,
		99,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		141,
		156,
		144,
		121,
		94,
		89,
		82,
		76,
		72,
		88,
		94,
		105,
		73,
		69,
		70,
		74,
		73,
		90,
		100,
		-1,
		-1,
		155,
		172,
		167,
		149,
		153,
		171,
		-1,
		-1,
		98,
		89,
		80,
		83,
		82,
		85,
		79,
		76,
		81,
		86,
		74,
		83,
		101,
		100,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		168,
		169,
		116,
		98,
		94,
		92,
		85,
		94,
		89,
		84,
		94,
		96,
		88,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		131,
		128,
		-1,
		98,
		123,
		95,
		102,
		93,
		100,
		100,
		92,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		147,
		144,
		120,
		103,
		101,
		94,
		89,
		99,
		79,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		182,
		263,
		256,
		229,
		237,
		268,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		120,
		117,
		122,
		110,
		107,
		109,
		104,
		95,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		196,
		239,
		223,
		226,
		250,
		264,
		-1,
		167,
		-1,
		-1,
		179,
		151,
		135,
		125,
		119,
		169,
		124,
		119,
		103,
		101,
		92,
		83,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		213,
		219,
		217,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		195,
		-1,
		162,
		-1,
		137,
		141,
		132,
		135,
		117,
		104,
		96,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		179,
		218,
		216,
		-1,
		200,
		-1,
		-1,
		-1,
		151,
		145,
		137,
		137,
		116,
		116,
		90,
		94,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		194,
		185,
		212,
		223,
		212,
		207,
		194,
		-1,
		-1,
		174,
		155,
		-1,
		-1,
		123,
		111,
		94,
		95,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		213,
		207,
		211,
		227,
		252,
		-1,
		183,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		241,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		119,
		123,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		194,
		197,
		-1,
		-1,
		196,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		201,
		202,
		203,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		154,
		117,
		138,
		148,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		118,
		144,
		147,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		169,
		154,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		159,
		155,
		142,
		142,
		134,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		135,
		170,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		142,
		143,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		135,
		124,
		135,
		143,
		116,
		123,
		-1,
		142,
		146,
		112,
		106,
		145,
		114,
		120,
		131,
		-1,
		-1,
		-1,
		135,
		134,
		102,
		100,
		109,
		114,
		121,
		-1,
		120,
		-1,
		156,
		135,
		146,
		151,
		95,
		92,
		112,
		131,
		113,
		105,
		171,
		125,
		96,
		90,
		108,
		98,
		107,
		99,
		-1,
		96,
		86,
		108,
		87,
		98,
		90,
		-1,
		-1,
		90,
		91,
		97,
		83,
		89,
		85,
		-1,
		95,
		79,
		-1,
		-1,
		80,
		81,
		65,
		68,
		76,
		74,
		87,
		79,
		74,
		-1,
		-1,
		71,
		67,
		74,
		61,
		57,
		74,
		87,
		69,
		83,
		81,
		-1,
		83,
		100,
		100,
		68,
		66,
		50,
		48,
		66,
		68,
		74,
		73,
		-1,
		100,
		96,
		97,
		95,
		90,
		66,
		53,
		53,
		63,
		56,
		75,
		62,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		92,
		109,
		93,
		83,
		87,
		85,
		56,
		53,
		51,
		48,
		64,
		61,
		71,
		-1,
		-1,
		194,
		167,
		191,
		149,
		131,
		-1,
		97,
		97,
		91,
		87,
		81,
		74,
		87,
		72,
		-1,
		42,
		41,
		68,
		54,
		65,
		176,
		-1,
		-1,
		152,
		144,
		126,
		129,
		106,
		102,
		112,
		111,
		104,
		92,
		88,
		71,
		74,
		74,
		80,
		36,
		46,
		50,
		47,
		59,
		-1,
		-1,
		83,
		-1,
		-1,
		173,
		156,
		-1,
		121,
		128,
		112,
		118,
		104,
		125,
		122,
		113,
		107,
		102,
		90,
		69,
		66,
		79,
		58,
		33,
		58,
		62,
		42,
		49,
		44,
		-1,
		82,
		66,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		128,
		125,
		118,
		142,
		141,
		-1,
		137,
		125,
		126,
		111,
		108,
		95,
		83,
		74,
		58,
		58,
		55,
		37,
		35,
		65,
		39,
		47,
		44,
		53,
		58,
		52,
		61,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		146,
		-1,
		149,
		162,
		149,
		122,
		125,
		112,
		103,
		90,
		79,
		75,
		56,
		53,
		49,
		29,
		44,
		34,
		33,
		37,
		37,
		45,
		49,
		55,
		-1,
		231,
		-1,
		173,
		157,
		159,
		132,
		153,
		-1,
		166,
		150,
		166,
		151,
		151,
		-1,
		121,
		118,
		108,
		86,
		71,
		68,
		56,
		51,
		42,
		24,
		38,
		28,
		24,
		31,
		27,
		31,
		51,
		63,
		191,
		181,
		-1,
		163,
		168,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		123,
		136,
		-1,
		92,
		88,
		70,
		64,
		53,
		60,
		35,
		20,
		17,
		20,
		15,
		20,
		24,
		40,
		-1,
		-1,
		176,
		180,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		106,
		103,
		91,
		78,
		63,
		64,
		59,
		55,
		34,
		19,
		21,
		11,
		37,
		15,
		27,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		102,
		81,
		72,
		61,
		59,
		67,
		40,
		35,
		19,
		17,
		6,
		18,
		9,
		29,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		115,
		98,
		79,
		68,
		60,
		49,
		41,
		47,
		39,
		15,
		20,
		0,
		24,
		31,
		37,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		89,
		73,
		68,
		65,
		59,
		46,
		46,
		44,
		25,
		20,
		32,
		29,
		29,
		21,
		46,
		49,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		75,
		71,
		63,
		67,
		61,
		56,
		46,
		38,
		39,
		21,
		34,
		-1,
		29,
		23,
		51,
		54,
		44,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		75,
		70,
		67,
		68,
		59,
		48,
		54,
		46,
		26,
		36,
		48,
		44,
		42,
		35,
		40,
		39,
		53,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		95,
		79,
		80,
		71,
		62,
		70,
		50,
		43,
		29,
		33,
		43,
		53,
		48,
		54,
		46,
		49,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		87,
		102,
		103,
		81,
		71,
		69,
		77,
		65,
		54,
		41,
		45,
		52,
		62,
		49,
		49,
		51,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		101,
		99,
		92,
		83,
		89,
		80,
		74,
		69,
		59,
		48,
		54,
		50,
		71,
		57,
		55,
		50,
		65,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		100,
		84,
		89,
		-1,
		94,
		-1,
		67,
		67,
		58,
		47,
		44,
		55,
		53,
		64,
		56,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		116,
		96,
		90,
		89,
		89,
		84,
		75,
		56,
		49,
		46,
		47,
		60,
		80,
		70,
		58,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		133,
		121,
		111,
		101,
		110,
		100,
		75,
		68,
		54,
		56,
		54,
		56,
		61,
		71,
		63,
		73,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		122,
		-1,
		-1,
		111,
		102,
		92,
		71,
		58,
		78,
		81,
		71,
		55,
		70,
		77,
		65,
		74,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		166,
		128,
		117,
		112,
		116,
		110,
		-1,
		88,
		82,
		62,
		76,
		83,
		73,
		68,
		62,
		65,
		82,
		76,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		123,
		134,
		105,
		98,
		102,
		-1,
		90,
		78,
		64,
		81,
		86,
		83,
		74,
		66,
		71,
		68,
		81,
		88,
		78,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		141,
		156,
		144,
		121,
		94,
		89,
		82,
		76,
		72,
		88,
		94,
		105,
		73,
		69,
		70,
		74,
		73,
		90,
		93,
		-1,
		-1,
		155,
		172,
		167,
		149,
		153,
		171,
		-1,
		-1,
		98,
		89,
		80,
		83,
		82,
		85,
		79,
		76,
		81,
		86,
		74,
		83,
		101,
		96,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		168,
		169,
		116,
		98,
		94,
		92,
		85,
		94,
		89,
		84,
		94,
		96,
		88,
		76,
		80,
		103,
		92,
		125,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		131,
		128,
		-1,
		98,
		123,
		95,
		102,
		93,
		100,
		100,
		92,
		70,
		77,
		93,
		92,
		87,
		117,
		112,
		120,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		147,
		144,
		120,
		103,
		101,
		94,
		89,
		99,
		79,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		182,
		263,
		256,
		229,
		237,
		268,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		120,
		117,
		122,
		110,
		107,
		109,
		104,
		95,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		196,
		239,
		223,
		226,
		250,
		264,
		-1,
		167,
		-1,
		-1,
		179,
		151,
		135,
		125,
		119,
		169,
		124,
		119,
		103,
		101,
		92,
		83,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		213,
		219,
		217,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		195,
		-1,
		162,
		-1,
		137,
		141,
		132,
		135,
		117,
		104,
		96,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		179,
		218,
		216,
		-1,
		200,
		-1,
		-1,
		-1,
		151,
		145,
		137,
		137,
		116,
		116,
		90,
		94,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		194,
		185,
		212,
		223,
		212,
		207,
		194,
		-1,
		-1,
		174,
		155,
		-1,
		-1,
		123,
		111,
		94,
		95,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		213,
		207,
		211,
		227,
		252,
		-1,
		183,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		241,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		119,
		123,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		194,
		197,
		-1,
		-1,
		196,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		201,
		202,
		203,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		154,
		117,
		138,
		148,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		118,
		144,
		147,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		169,
		154,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		159,
		155,
		142,
		142,
		134,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		135,
		170,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		142,
		143,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		167,
		171,
		137,
		131,
		170,
		139,
		145,
		156,
		-1,
		-1,
		-1,
		160,
		159,
		127,
		125,
		134,
		139,
		146,
		-1,
		145,
		-1,
		181,
		160,
		171,
		176,
		120,
		117,
		137,
		156,
		138,
		130,
		196,
		150,
		121,
		115,
		133,
		123,
		132,
		124,
		-1,
		121,
		111,
		133,
		112,
		123,
		115,
		-1,
		-1,
		115,
		116,
		122,
		108,
		114,
		110,
		-1,
		120,
		104,
		-1,
		-1,
		105,
		106,
		90,
		93,
		101,
		99,
		112,
		104,
		99,
		-1,
		-1,
		96,
		92,
		99,
		86,
		82,
		99,
		112,
		94,
		108,
		106,
		-1,
		108,
		125,
		125,
		93,
		91,
		75,
		73,
		91,
		93,
		99,
		98,
		-1,
		125,
		121,
		122,
		120,
		115,
		91,
		78,
		78,
		88,
		81,
		100,
		87,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		117,
		134,
		118,
		108,
		112,
		110,
		81,
		78,
		76,
		73,
		89,
		86,
		96,
		-1,
		-1,
		219,
		192,
		216,
		174,
		156,
		-1,
		122,
		122,
		116,
		112,
		106,
		99,
		112,
		97,
		-1,
		67,
		66,
		93,
		79,
		90,
		201,
		-1,
		-1,
		177,
		169,
		151,
		154,
		131,
		127,
		137,
		136,
		129,
		117,
		113,
		96,
		99,
		99,
		105,
		61,
		71,
		75,
		72,
		75,
		-1,
		-1,
		89,
		-1,
		-1,
		198,
		181,
		-1,
		146,
		153,
		137,
		143,
		129,
		150,
		147,
		138,
		132,
		127,
		115,
		94,
		91,
		104,
		83,
		58,
		83,
		87,
		67,
		65,
		60,
		-1,
		88,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		153,
		150,
		143,
		167,
		166,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		99,
		83,
		83,
		80,
		62,
		60,
		90,
		64,
		64,
		54,
		59,
		64,
		58,
		67,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		171,
		-1,
		174,
		187,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		100,
		81,
		78,
		74,
		54,
		69,
		59,
		58,
		43,
		43,
		51,
		55,
		61,
		-1,
		256,
		-1,
		198,
		182,
		184,
		157,
		178,
		-1,
		191,
		175,
		191,
		176,
		176,
		-1,
		146,
		143,
		133,
		111,
		96,
		93,
		81,
		76,
		67,
		49,
		63,
		53,
		49,
		47,
		33,
		37,
		51,
		69,
		216,
		206,
		-1,
		188,
		193,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		89,
		78,
		85,
		60,
		45,
		42,
		45,
		40,
		26,
		30,
		40,
		-1,
		-1,
		201,
		205,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		131,
		128,
		116,
		103,
		88,
		89,
		84,
		80,
		59,
		44,
		46,
		36,
		43,
		21,
		24,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		127,
		106,
		97,
		86,
		84,
		92,
		65,
		60,
		44,
		42,
		31,
		18,
		15,
		26,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		140,
		123,
		104,
		93,
		85,
		74,
		66,
		72,
		64,
		40,
		45,
		25,
		0,
		37,
		42,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		84,
		71,
		71,
		69,
		50,
		45,
		57,
		5,
		7,
		27,
		52,
		55,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		88,
		92,
		86,
		81,
		71,
		63,
		64,
		46,
		59,
		-1,
		35,
		29,
		57,
		60,
		50,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		100,
		95,
		92,
		93,
		84,
		73,
		79,
		71,
		51,
		61,
		73,
		50,
		48,
		41,
		46,
		45,
		59,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		120,
		104,
		105,
		96,
		87,
		95,
		75,
		68,
		54,
		58,
		68,
		59,
		54,
		60,
		52,
		55,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		112,
		127,
		128,
		106,
		96,
		94,
		102,
		90,
		79,
		66,
		70,
		72,
		69,
		55,
		55,
		57,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		126,
		124,
		117,
		108,
		114,
		105,
		99,
		94,
		84,
		73,
		79,
		75,
		77,
		63,
		61,
		56,
		71,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		125,
		109,
		114,
		-1,
		119,
		-1,
		92,
		92,
		83,
		72,
		69,
		73,
		64,
		77,
		62,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		141,
		121,
		115,
		114,
		114,
		109,
		100,
		81,
		74,
		71,
		72,
		85,
		97,
		76,
		64,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		158,
		146,
		136,
		126,
		135,
		125,
		100,
		93,
		79,
		81,
		79,
		81,
		86,
		77,
		69,
		79,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		147,
		-1,
		-1,
		136,
		127,
		117,
		96,
		83,
		103,
		106,
		96,
		80,
		93,
		83,
		71,
		80,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		191,
		153,
		142,
		137,
		141,
		135,
		-1,
		113,
		107,
		87,
		101,
		108,
		98,
		93,
		87,
		88,
		88,
		82,
		-1,
		-1,
		174,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		148,
		159,
		130,
		123,
		127,
		-1,
		115,
		103,
		89,
		106,
		111,
		108,
		99,
		91,
		96,
		85,
		98,
		94,
		84,
		197,
		-1,
		180,
		-1,
		-1,
		-1,
		166,
		181,
		169,
		146,
		119,
		114,
		107,
		101,
		97,
		113,
		119,
		130,
		98,
		94,
		95,
		91,
		90,
		98,
		99,
		-1,
		-1,
		180,
		197,
		192,
		174,
		178,
		196,
		-1,
		-1,
		123,
		114,
		105,
		108,
		107,
		110,
		104,
		101,
		106,
		108,
		99,
		100,
		117,
		102,
		-1,
		-1,
		-1,
		200,
		-1,
		215,
		-1,
		-1,
		193,
		194,
		141,
		123,
		119,
		117,
		110,
		119,
		114,
		109,
		119,
		121,
		113,
		98,
		105,
		128,
		110,
		131,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		212,
		204,
		199,
		205,
		207,
		198,
		156,
		153,
		-1,
		123,
		148,
		120,
		127,
		118,
		125,
		125,
		117,
		95,
		102,
		118,
		117,
		112,
		123,
		118,
		127,
		-1,
		-1,
		302,
		291,
		280,
		286,
		-1,
		205,
		201,
		191,
		181,
		184,
		-1,
		-1,
		172,
		169,
		145,
		128,
		126,
		119,
		114,
		124,
		104,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		125,
		133,
		-1,
		207,
		288,
		281,
		254,
		262,
		293,
		-1,
		195,
		187,
		198,
		173,
		175,
		-1,
		-1,
		145,
		142,
		147,
		135,
		132,
		134,
		129,
		120,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		221,
		264,
		248,
		251,
		275,
		289,
		-1,
		192,
		-1,
		-1,
		204,
		176,
		160,
		150,
		144,
		194,
		149,
		144,
		128,
		126,
		117,
		108,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		238,
		244,
		242,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		220,
		-1,
		187,
		-1,
		162,
		166,
		157,
		160,
		142,
		129,
		121,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		263,
		219,
		222,
		233,
		244,
		259,
		263,
		-1,
		204,
		243,
		241,
		-1,
		225,
		-1,
		-1,
		-1,
		176,
		170,
		162,
		162,
		141,
		141,
		115,
		119,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		259,
		250,
		263,
		208,
		208,
		229,
		238,
		259,
		219,
		210,
		237,
		248,
		237,
		232,
		219,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		148,
		136,
		119,
		120,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		199,
		226,
		-1,
		-1,
		221,
		238,
		232,
		236,
		252,
		277,
		-1,
		208,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		236,
		233,
		221,
		219,
		242,
		207,
		195,
		-1,
		208,
		206,
		212,
		219,
		236,
		266,
		-1,
		-1,
		224,
		204,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		151,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		193,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		214,
		210,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		144,
		148,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		279,
		-1,
		231,
		207,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		231,
		217,
		210,
		198,
		196,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		221,
		223,
		-1,
		222,
		211,
		196,
		188,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		226,
		227,
		228,
		-1,
		206,
		-1,
		224,
		-1,
		191,
		197,
		185,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		224,
		198,
		231,
		222,
		205,
		185,
		177,
		196,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		230,
		-1,
		200,
		233,
		197,
		191,
		167,
		171,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		194,
		179,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		202,
		201,
		193,
		187,
		187,
		172,
		163,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		184,
		180,
		167,
		167,
		159,
		-1,
		303,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		196,
		191,
		164,
		152,
		158,
		154,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		160,
		195,
		-1,
		298,
		-1,
		232,
		-1,
		-1,
		214,
		194,
		186,
		175,
		164,
		162,
		153,
		144,
		166,
		182,
		166,
		164,
		167,
		168,
		-1,
		287,
		286,
		-1,
		233,
		225,
		211,
		-1,
		204,
		-1,
		210,
		171,
		-1,
		173,
		153,
		-1,
		175,
		171,
		-1,
		-1,
		274,
		249,
		-1,
		-1,
		-1,
		234,
		214,
		205,
		189,
		-1,
		164,
		164,
		-1,
		-1,
		-1,
		259,
		258,
		-1,
		227,
		230,
		-1,
		220,
		211,
		219,
		166,
		170,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		242,
		240,
		235,
		232,
		218,
		202,
		180,
		169,
		190,
		-1,
		-1,
		-1,
		240,
		232,
		225,
		-1,
		-1,
		227,
		210,
		191,
		189,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		217,
		-1,
		-1,
		223,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		251,
		-1,
		-1,
		-1,
		213,
		209,
		210,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		297,
		261,
		-1,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		233,
		217,
		-1,
		203,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		238,
		-1,
		238,
		213,
		220,
		-1,
		-1,
		-1,
		-1,
		251,
		243,
		251,
		-1,
		223,
		225,
		-1,
		273,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		228,
		235,
		257,
		260,
		296,
		-1,
		247
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		180,
		184,
		150,
		144,
		183,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		173,
		172,
		140,
		138,
		147,
		152,
		159,
		-1,
		158,
		-1,
		194,
		173,
		184,
		189,
		133,
		130,
		150,
		169,
		151,
		143,
		209,
		163,
		134,
		128,
		146,
		136,
		145,
		137,
		-1,
		134,
		124,
		146,
		125,
		136,
		128,
		-1,
		-1,
		128,
		129,
		135,
		121,
		127,
		123,
		-1,
		133,
		117,
		-1,
		-1,
		118,
		119,
		103,
		106,
		114,
		112,
		125,
		117,
		112,
		-1,
		-1,
		109,
		105,
		112,
		99,
		95,
		112,
		125,
		107,
		121,
		119,
		-1,
		121,
		138,
		138,
		106,
		104,
		88,
		86,
		104,
		106,
		112,
		111,
		-1,
		138,
		134,
		135,
		133,
		128,
		104,
		91,
		91,
		101,
		94,
		113,
		100,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		130,
		147,
		131,
		121,
		125,
		123,
		94,
		91,
		89,
		86,
		102,
		99,
		109,
		-1,
		-1,
		232,
		205,
		229,
		187,
		169,
		-1,
		135,
		135,
		129,
		125,
		119,
		112,
		125,
		110,
		-1,
		80,
		79,
		106,
		92,
		103,
		212,
		-1,
		-1,
		190,
		182,
		164,
		167,
		144,
		140,
		150,
		149,
		142,
		128,
		124,
		109,
		112,
		112,
		118,
		74,
		84,
		88,
		85,
		88,
		-1,
		-1,
		102,
		-1,
		-1,
		209,
		192,
		-1,
		159,
		166,
		150,
		156,
		142,
		163,
		160,
		151,
		144,
		138,
		126,
		107,
		104,
		117,
		96,
		71,
		96,
		100,
		80,
		78,
		73,
		-1,
		101,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		166,
		163,
		156,
		180,
		179,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		112,
		96,
		96,
		93,
		75,
		73,
		103,
		77,
		77,
		67,
		72,
		77,
		71,
		80,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		184,
		-1,
		187,
		200,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		113,
		94,
		91,
		87,
		67,
		82,
		72,
		71,
		56,
		56,
		64,
		68,
		74,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		204,
		188,
		202,
		187,
		186,
		-1,
		157,
		154,
		144,
		122,
		107,
		106,
		94,
		89,
		80,
		62,
		76,
		66,
		62,
		60,
		46,
		50,
		70,
		82,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		228,
		192,
		-1,
		187,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		102,
		91,
		98,
		73,
		58,
		55,
		58,
		53,
		39,
		43,
		59,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		185,
		174,
		173,
		-1,
		164,
		142,
		139,
		127,
		114,
		99,
		100,
		97,
		93,
		72,
		57,
		59,
		49,
		56,
		34,
		33,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		203,
		196,
		184,
		149,
		149,
		143,
		-1,
		138,
		117,
		108,
		97,
		95,
		105,
		78,
		73,
		57,
		55,
		44,
		37,
		28,
		24,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		182,
		168,
		173,
		148,
		141,
		135,
		151,
		134,
		115,
		104,
		96,
		85,
		79,
		85,
		77,
		53,
		58,
		38,
		43,
		0,
		18,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		173,
		186,
		-1,
		140,
		-1,
		129,
		125,
		109,
		104,
		101,
		89,
		84,
		84,
		82,
		63,
		58,
		70,
		48,
		48,
		14,
		29,
		32,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		111,
		107,
		93,
		97,
		99,
		94,
		84,
		76,
		77,
		59,
		72,
		-1,
		18,
		16,
		34,
		47,
		37,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		105,
		100,
		99,
		98,
		95,
		84,
		92,
		84,
		64,
		74,
		74,
		33,
		31,
		28,
		33,
		32,
		46,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		127,
		111,
		110,
		107,
		98,
		106,
		79,
		72,
		67,
		67,
		69,
		45,
		41,
		47,
		39,
		42,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		149,
		165,
		-1,
		158,
		137,
		152,
		130,
		126,
		117,
		134,
		135,
		113,
		107,
		105,
		96,
		84,
		73,
		73,
		68,
		58,
		55,
		42,
		42,
		44,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		120,
		152,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		131,
		129,
		124,
		115,
		121,
		116,
		93,
		88,
		78,
		67,
		67,
		62,
		64,
		50,
		48,
		43,
		58,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		132,
		116,
		121,
		-1,
		113,
		-1,
		86,
		83,
		74,
		59,
		56,
		60,
		51,
		64,
		49,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		189,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		148,
		128,
		122,
		121,
		108,
		100,
		94,
		72,
		65,
		62,
		59,
		72,
		84,
		63,
		51,
		-1,
		-1,
		-1,
		186,
		172,
		176,
		136,
		155,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		146,
		155,
		143,
		133,
		123,
		126,
		116,
		91,
		84,
		70,
		72,
		70,
		68,
		73,
		64,
		56,
		66,
		-1,
		-1,
		169,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		168,
		184,
		176,
		147,
		144,
		-1,
		-1,
		127,
		118,
		108,
		87,
		74,
		94,
		97,
		83,
		67,
		80,
		70,
		58,
		67,
		-1,
		172,
		159,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		140,
		129,
		124,
		128,
		126,
		-1,
		100,
		98,
		78,
		92,
		99,
		85,
		80,
		74,
		75,
		75,
		69,
		-1,
		-1,
		184,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		152,
		146,
		117,
		110,
		114,
		-1,
		102,
		94,
		80,
		97,
		98,
		95,
		86,
		78,
		83,
		72,
		85,
		81,
		71,
		207,
		-1,
		190,
		-1,
		-1,
		-1,
		170,
		185,
		156,
		133,
		106,
		101,
		94,
		88,
		88,
		104,
		106,
		117,
		85,
		81,
		82,
		78,
		77,
		85,
		86,
		-1,
		-1,
		190,
		204,
		196,
		178,
		182,
		183,
		-1,
		-1,
		110,
		101,
		92,
		95,
		98,
		101,
		91,
		88,
		93,
		95,
		86,
		87,
		104,
		89,
		-1,
		-1,
		-1,
		210,
		-1,
		222,
		-1,
		-1,
		197,
		181,
		128,
		110,
		106,
		104,
		97,
		106,
		101,
		96,
		106,
		113,
		105,
		85,
		99,
		115,
		97,
		118,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		199,
		191,
		186,
		192,
		194,
		185,
		143,
		140,
		-1,
		110,
		135,
		107,
		114,
		106,
		114,
		114,
		109,
		89,
		96,
		112,
		109,
		106,
		110,
		105,
		114,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		192,
		188,
		178,
		168,
		171,
		-1,
		-1,
		159,
		156,
		132,
		116,
		120,
		113,
		108,
		118,
		98,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		112,
		120,
		-1,
		217,
		281,
		274,
		242,
		250,
		281,
		-1,
		182,
		174,
		185,
		160,
		162,
		-1,
		-1,
		132,
		129,
		134,
		123,
		120,
		128,
		123,
		114,
		99,
		105,
		92,
		91,
		109,
		113,
		122,
		126,
		115,
		128,
		132,
		-1,
		231,
		257,
		236,
		239,
		263,
		277,
		-1,
		179,
		-1,
		-1,
		191,
		163,
		147,
		137,
		131,
		181,
		137,
		132,
		122,
		120,
		111,
		102,
		109,
		100,
		100,
		103,
		118,
		123,
		115,
		125,
		125,
		126,
		-1,
		226,
		237,
		230,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		207,
		-1,
		174,
		-1,
		149,
		153,
		145,
		148,
		136,
		123,
		115,
		107,
		123,
		98,
		108,
		104,
		105,
		114,
		125,
		137,
		132,
		133,
		251,
		207,
		210,
		221,
		232,
		247,
		251,
		-1,
		191,
		230,
		235,
		-1,
		216,
		-1,
		-1,
		-1,
		163,
		158,
		150,
		156,
		135,
		135,
		109,
		113,
		103,
		110,
		120,
		122,
		114,
		118,
		131,
		142,
		141,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		206,
		197,
		224,
		242,
		231,
		226,
		213,
		-1,
		-1,
		186,
		168,
		-1,
		-1,
		142,
		130,
		113,
		114,
		110,
		113,
		128,
		131,
		121,
		119,
		113,
		145,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		225,
		220,
		224,
		240,
		265,
		-1,
		202,
		-1,
		-1,
		187,
		-1,
		-1,
		172,
		135,
		124,
		115,
		121,
		118,
		129,
		139,
		127,
		128,
		118,
		128,
		141,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		218,
		198,
		-1,
		-1,
		170,
		168,
		157,
		-1,
		147,
		120,
		125,
		145,
		147,
		136,
		130,
		124,
		131,
		130,
		138,
		146,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		208,
		204,
		-1,
		-1,
		165,
		158,
		146,
		134,
		124,
		134,
		138,
		142,
		134,
		127,
		122,
		133,
		125,
		129,
		146,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		225,
		211,
		204,
		192,
		190,
		-1,
		199,
		183,
		164,
		-1,
		134,
		147,
		178,
		146,
		151,
		146,
		128,
		139,
		128,
		131,
		145,
		140,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		215,
		217,
		-1,
		216,
		205,
		190,
		182,
		-1,
		-1,
		171,
		167,
		-1,
		-1,
		135,
		160,
		149,
		157,
		152,
		132,
		138,
		141,
		130,
		134,
		146,
		-1,
		-1,
		214,
		215,
		220,
		-1,
		200,
		-1,
		218,
		-1,
		185,
		191,
		179,
		-1,
		-1,
		-1,
		173,
		136,
		157,
		167,
		161,
		159,
		150,
		136,
		143,
		141,
		137,
		148,
		-1,
		-1,
		-1,
		218,
		192,
		225,
		216,
		199,
		179,
		171,
		190,
		-1,
		160,
		-1,
		135,
		137,
		163,
		166,
		172,
		166,
		139,
		154,
		144,
		135,
		144,
		224,
		-1,
		194,
		227,
		191,
		185,
		161,
		165,
		181,
		-1,
		157,
		139,
		-1,
		167,
		157,
		188,
		173,
		154,
		141,
		148,
		148,
		141,
		-1,
		-1,
		-1,
		196,
		195,
		187,
		181,
		181,
		166,
		157,
		-1,
		169,
		151,
		130,
		147,
		147,
		138,
		146,
		178,
		174,
		161,
		161,
		153,
		-1,
		297,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		190,
		185,
		158,
		146,
		152,
		148,
		134,
		140,
		142,
		150,
		148,
		145,
		157,
		153,
		173,
		154,
		189,
		-1,
		292,
		-1,
		226,
		-1,
		-1,
		208,
		188,
		180,
		169,
		158,
		156,
		147,
		138,
		160,
		176,
		160,
		158,
		161,
		162,
		-1,
		281,
		280,
		-1,
		227,
		219,
		205,
		-1,
		198,
		-1,
		204,
		165,
		-1,
		167,
		147,
		-1,
		169,
		165,
		-1,
		-1,
		268,
		243,
		-1,
		-1,
		-1,
		228,
		208,
		199,
		183,
		-1,
		158,
		158,
		-1,
		-1,
		-1,
		253,
		252,
		-1,
		221,
		224,
		-1,
		214,
		205,
		213,
		160,
		164,
		-1,
		-1,
		-1,
		262,
		243,
		237,
		236,
		234,
		229,
		226,
		212,
		196,
		174,
		163,
		184,
		-1,
		-1,
		-1,
		234,
		226,
		219,
		-1,
		-1,
		221,
		204,
		185,
		183,
		-1,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		211,
		-1,
		-1,
		217,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		245,
		-1,
		-1,
		-1,
		207,
		203,
		204,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		291,
		255,
		-1,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		270,
		268,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		197,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		232,
		-1,
		232,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		245,
		237,
		245,
		-1,
		217,
		219,
		-1,
		267,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		222,
		229,
		251,
		254,
		290,
		-1,
		241
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		185,
		189,
		155,
		149,
		188,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		178,
		177,
		145,
		143,
		152,
		157,
		164,
		-1,
		163,
		-1,
		199,
		178,
		189,
		194,
		138,
		135,
		155,
		174,
		156,
		148,
		214,
		168,
		139,
		133,
		151,
		141,
		150,
		142,
		-1,
		139,
		129,
		151,
		130,
		141,
		133,
		-1,
		-1,
		133,
		134,
		140,
		126,
		132,
		128,
		-1,
		138,
		122,
		-1,
		-1,
		123,
		124,
		108,
		111,
		119,
		117,
		130,
		122,
		117,
		-1,
		-1,
		114,
		110,
		117,
		104,
		100,
		117,
		130,
		112,
		126,
		124,
		-1,
		126,
		143,
		143,
		111,
		109,
		93,
		91,
		109,
		111,
		117,
		116,
		-1,
		143,
		139,
		140,
		138,
		133,
		109,
		96,
		96,
		106,
		99,
		118,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		135,
		152,
		136,
		126,
		130,
		128,
		99,
		96,
		94,
		91,
		107,
		104,
		114,
		-1,
		-1,
		237,
		210,
		234,
		192,
		174,
		-1,
		140,
		140,
		134,
		130,
		124,
		117,
		130,
		115,
		-1,
		85,
		84,
		111,
		97,
		108,
		217,
		-1,
		-1,
		195,
		187,
		169,
		172,
		149,
		145,
		155,
		154,
		147,
		133,
		129,
		114,
		117,
		117,
		123,
		79,
		89,
		93,
		90,
		93,
		-1,
		-1,
		107,
		-1,
		-1,
		214,
		197,
		-1,
		164,
		171,
		155,
		161,
		147,
		168,
		165,
		156,
		149,
		143,
		131,
		112,
		109,
		122,
		101,
		76,
		101,
		105,
		85,
		83,
		78,
		-1,
		106,
		90,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		171,
		168,
		161,
		185,
		184,
		-1,
		178,
		166,
		167,
		152,
		149,
		136,
		124,
		117,
		101,
		101,
		98,
		80,
		78,
		108,
		82,
		82,
		72,
		77,
		82,
		76,
		85,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		189,
		-1,
		192,
		205,
		190,
		163,
		166,
		153,
		144,
		131,
		120,
		118,
		99,
		96,
		92,
		72,
		87,
		77,
		76,
		61,
		61,
		69,
		73,
		79,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		209,
		193,
		207,
		192,
		191,
		-1,
		162,
		159,
		149,
		127,
		112,
		111,
		99,
		94,
		85,
		67,
		81,
		71,
		67,
		65,
		51,
		55,
		70,
		87,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		164,
		177,
		-1,
		133,
		129,
		111,
		107,
		96,
		103,
		78,
		63,
		60,
		63,
		58,
		44,
		48,
		59,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		147,
		144,
		132,
		119,
		104,
		105,
		102,
		98,
		77,
		62,
		64,
		54,
		61,
		39,
		26,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		143,
		122,
		113,
		102,
		100,
		110,
		83,
		78,
		62,
		60,
		49,
		40,
		33,
		17,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		156,
		139,
		120,
		109,
		101,
		90,
		84,
		90,
		82,
		58,
		63,
		43,
		43,
		19,
		0,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		130,
		114,
		109,
		106,
		94,
		89,
		89,
		87,
		68,
		63,
		75,
		48,
		48,
		19,
		29,
		32,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		116,
		112,
		98,
		102,
		104,
		99,
		89,
		81,
		82,
		64,
		77,
		-1,
		23,
		21,
		34,
		48,
		42,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		110,
		105,
		104,
		103,
		100,
		89,
		97,
		89,
		69,
		79,
		79,
		38,
		36,
		33,
		38,
		37,
		51,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		132,
		116,
		115,
		112,
		103,
		111,
		84,
		77,
		72,
		72,
		74,
		50,
		46,
		52,
		44,
		47,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		122,
		139,
		140,
		118,
		112,
		110,
		101,
		89,
		78,
		78,
		73,
		63,
		60,
		47,
		47,
		49,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		136,
		134,
		129,
		120,
		126,
		121,
		98,
		93,
		83,
		72,
		72,
		67,
		69,
		55,
		53,
		48,
		63,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		137,
		121,
		126,
		-1,
		118,
		-1,
		91,
		88,
		79,
		64,
		61,
		65,
		56,
		69,
		54,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		153,
		133,
		127,
		126,
		113,
		105,
		99,
		77,
		70,
		67,
		64,
		77,
		89,
		68,
		56,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		160,
		148,
		138,
		128,
		131,
		121,
		96,
		89,
		75,
		77,
		75,
		73,
		78,
		69,
		61,
		71,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		181,
		152,
		149,
		-1,
		-1,
		132,
		123,
		113,
		92,
		79,
		99,
		102,
		88,
		72,
		85,
		75,
		63,
		72,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		200,
		145,
		134,
		129,
		133,
		131,
		-1,
		105,
		103,
		83,
		97,
		104,
		90,
		85,
		79,
		80,
		80,
		74,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		157,
		151,
		122,
		115,
		119,
		-1,
		107,
		99,
		85,
		102,
		103,
		100,
		91,
		83,
		88,
		77,
		90,
		86,
		76,
		212,
		-1,
		195,
		-1,
		-1,
		-1,
		175,
		190,
		161,
		138,
		111,
		106,
		99,
		93,
		93,
		109,
		111,
		122,
		90,
		86,
		87,
		83,
		82,
		90,
		91,
		-1,
		-1,
		195,
		209,
		201,
		183,
		187,
		188,
		-1,
		-1,
		115,
		106,
		97,
		100,
		103,
		106,
		96,
		93,
		98,
		100,
		91,
		92,
		109,
		94,
		-1,
		-1,
		-1,
		215,
		-1,
		227,
		-1,
		-1,
		202,
		186,
		133,
		115,
		111,
		109,
		102,
		111,
		106,
		101,
		111,
		118,
		110,
		90,
		104,
		120,
		102,
		123,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		204,
		196,
		191,
		197,
		199,
		190,
		148,
		145,
		-1,
		115,
		140,
		112,
		119,
		111,
		119,
		119,
		114,
		94,
		101,
		117,
		114,
		111,
		115,
		110,
		119,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		197,
		193,
		183,
		173,
		176,
		-1,
		-1,
		164,
		161,
		137,
		121,
		125,
		118,
		113,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		117,
		125,
		-1,
		222,
		286,
		279,
		247,
		255,
		286,
		-1,
		187,
		179,
		190,
		165,
		167,
		-1,
		-1,
		137,
		134,
		139,
		128,
		125,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		131,
		120,
		133,
		137,
		-1,
		236,
		262,
		241,
		244,
		268,
		282,
		-1,
		184,
		-1,
		-1,
		196,
		168,
		152,
		142,
		136,
		186,
		142,
		137,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		130,
		130,
		131,
		-1,
		231,
		242,
		235,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		212,
		-1,
		179,
		-1,
		154,
		158,
		150,
		153,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		137,
		138,
		256,
		212,
		215,
		226,
		237,
		252,
		256,
		-1,
		196,
		235,
		240,
		-1,
		221,
		-1,
		-1,
		-1,
		168,
		163,
		155,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		146,
		252,
		243,
		256,
		201,
		201,
		222,
		231,
		252,
		211,
		202,
		229,
		247,
		236,
		231,
		218,
		-1,
		-1,
		191,
		173,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		245,
		244,
		233,
		230,
		206,
		197,
		192,
		219,
		-1,
		-1,
		214,
		230,
		225,
		229,
		245,
		270,
		-1,
		207,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		229,
		226,
		214,
		212,
		235,
		200,
		188,
		-1,
		201,
		199,
		205,
		212,
		229,
		259,
		-1,
		-1,
		223,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		238,
		252,
		241,
		237,
		236,
		244,
		193,
		186,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		272,
		-1,
		224,
		200,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		219,
		220,
		225,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		194,
		196,
		162,
		156,
		195,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		185,
		184,
		154,
		152,
		161,
		166,
		173,
		-1,
		196,
		-1,
		206,
		185,
		196,
		201,
		147,
		144,
		164,
		183,
		189,
		181,
		221,
		177,
		148,
		142,
		160,
		165,
		183,
		175,
		-1,
		148,
		138,
		160,
		164,
		176,
		159,
		-1,
		-1,
		142,
		143,
		149,
		161,
		166,
		171,
		-1,
		197,
		216,
		-1,
		-1,
		132,
		145,
		141,
		144,
		152,
		168,
		189,
		206,
		211,
		-1,
		-1,
		133,
		137,
		150,
		151,
		149,
		176,
		195,
		206,
		220,
		219,
		-1,
		121,
		139,
		148,
		157,
		163,
		152,
		156,
		174,
		205,
		211,
		214,
		-1,
		113,
		115,
		144,
		150,
		162,
		168,
		155,
		161,
		180,
		193,
		212,
		203,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		118,
		144,
		143,
		139,
		157,
		179,
		158,
		164,
		168,
		185,
		201,
		202,
		212,
		-1,
		-1,
		166,
		135,
		170,
		127,
		112,
		-1,
		106,
		125,
		131,
		135,
		140,
		148,
		176,
		174,
		-1,
		179,
		178,
		209,
		195,
		206,
		126,
		-1,
		-1,
		124,
		116,
		101,
		104,
		101,
		101,
		131,
		130,
		135,
		137,
		139,
		151,
		166,
		166,
		176,
		173,
		183,
		187,
		202,
		213,
		-1,
		-1,
		280,
		-1,
		-1,
		123,
		106,
		-1,
		89,
		96,
		96,
		113,
		103,
		124,
		139,
		143,
		151,
		154,
		142,
		161,
		158,
		182,
		178,
		170,
		195,
		199,
		205,
		223,
		221,
		-1,
		279,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		82,
		85,
		91,
		115,
		125,
		-1,
		146,
		144,
		168,
		162,
		167,
		163,
		148,
		166,
		164,
		179,
		181,
		177,
		179,
		216,
		202,
		224,
		221,
		250,
		255,
		249,
		258,
		-1,
		131,
		127,
		123,
		130,
		79,
		-1,
		-1,
		119,
		-1,
		133,
		146,
		158,
		148,
		151,
		163,
		171,
		170,
		154,
		172,
		167,
		170,
		182,
		185,
		194,
		197,
		196,
		214,
		229,
		242,
		246,
		252,
		-1,
		181,
		-1,
		123,
		107,
		109,
		81,
		102,
		-1,
		139,
		134,
		154,
		160,
		160,
		-1,
		176,
		173,
		186,
		170,
		155,
		172,
		174,
		176,
		181,
		186,
		200,
		191,
		209,
		216,
		224,
		228,
		248,
		260,
		141,
		131,
		-1,
		113,
		118,
		77,
		84,
		99,
		177,
		161,
		-1,
		171,
		-1,
		178,
		191,
		-1,
		176,
		172,
		161,
		169,
		164,
		179,
		185,
		182,
		179,
		197,
		200,
		217,
		221,
		237,
		-1,
		-1,
		126,
		130,
		103,
		70,
		81,
		105,
		142,
		170,
		178,
		177,
		-1,
		171,
		197,
		194,
		184,
		171,
		161,
		162,
		170,
		183,
		162,
		181,
		184,
		206,
		234,
		212,
		224,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		80,
		67,
		83,
		125,
		207,
		200,
		188,
		156,
		156,
		150,
		-1,
		191,
		174,
		170,
		159,
		157,
		170,
		165,
		181,
		185,
		184,
		203,
		215,
		206,
		226,
		-1,
		-1,
		-1,
		92,
		81,
		82,
		70,
		104,
		114,
		189,
		175,
		180,
		155,
		148,
		142,
		194,
		191,
		158,
		166,
		158,
		147,
		161,
		169,
		173,
		182,
		191,
		197,
		221,
		221,
		227,
		-1,
		-1,
		0,
		6,
		28,
		45,
		71,
		95,
		102,
		134,
		180,
		177,
		-1,
		147,
		-1,
		136,
		144,
		143,
		149,
		161,
		147,
		152,
		163,
		175,
		188,
		184,
		191,
		226,
		226,
		211,
		231,
		234,
		-1,
		-1,
		-1,
		37,
		143,
		118,
		95,
		76,
		112,
		-1,
		147,
		148,
		-1,
		141,
		135,
		141,
		140,
		147,
		144,
		144,
		158,
		166,
		162,
		178,
		184,
		176,
		212,
		-1,
		219,
		213,
		221,
		211,
		199,
		-1,
		-1,
		-1,
		141,
		120,
		113,
		133,
		83,
		135,
		-1,
		-1,
		132,
		125,
		-1,
		128,
		128,
		135,
		144,
		149,
		154,
		162,
		157,
		170,
		175,
		181,
		186,
		204,
		208,
		212,
		201,
		197,
		194,
		208,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		103,
		-1,
		140,
		132,
		123,
		117,
		123,
		141,
		139,
		159,
		151,
		165,
		165,
		171,
		179,
		164,
		167,
		183,
		181,
		199,
		207,
		199,
		193,
		192,
		204,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		118,
		-1,
		89,
		113,
		129,
		-1,
		157,
		136,
		159,
		137,
		151,
		147,
		185,
		186,
		164,
		169,
		177,
		187,
		189,
		178,
		189,
		181,
		203,
		203,
		187,
		188,
		197,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		92,
		105,
		116,
		-1,
		-1,
		201,
		-1,
		135,
		152,
		161,
		159,
		175,
		166,
		172,
		188,
		191,
		193,
		183,
		172,
		178,
		175,
		197,
		183,
		181,
		200,
		216,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		179,
		169,
		153,
		138,
		171,
		-1,
		183,
		167,
		172,
		-1,
		218,
		-1,
		191,
		193,
		187,
		172,
		169,
		180,
		178,
		189,
		206,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		149,
		-1,
		-1,
		166,
		160,
		160,
		144,
		147,
		199,
		179,
		173,
		172,
		213,
		213,
		199,
		185,
		178,
		175,
		172,
		185,
		205,
		196,
		208,
		-1,
		-1,
		-1,
		150,
		130,
		136,
		94,
		115,
		-1,
		-1,
		228,
		183,
		169,
		-1,
		153,
		216,
		204,
		194,
		184,
		218,
		219,
		204,
		197,
		183,
		185,
		183,
		181,
		186,
		207,
		208,
		221,
		-1,
		-1,
		127,
		134,
		122,
		108,
		127,
		-1,
		-1,
		-1,
		175,
		191,
		183,
		154,
		205,
		-1,
		-1,
		196,
		194,
		204,
		200,
		187,
		207,
		210,
		196,
		180,
		195,
		207,
		215,
		220,
		-1,
		130,
		117,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		-1,
		-1,
		208,
		174,
		186,
		207,
		232,
		199,
		-1,
		204,
		205,
		191,
		205,
		212,
		198,
		193,
		187,
		190,
		208,
		225,
		-1,
		-1,
		144,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		165,
		179,
		200,
		206,
		218,
		-1,
		213,
		207,
		193,
		210,
		211,
		208,
		199,
		191,
		196,
		193,
		206,
		220,
		224,
		167,
		-1,
		150,
		-1,
		-1,
		-1,
		183,
		198,
		260,
		237,
		210,
		214,
		207,
		201,
		201,
		217,
		219,
		230,
		198,
		194,
		195,
		199,
		198,
		215,
		225,
		-1,
		-1,
		150,
		167,
		202,
		191,
		195,
		287,
		-1,
		-1,
		223,
		214,
		205,
		208,
		211,
		214,
		204,
		201,
		206,
		211,
		199,
		208,
		226,
		230,
		-1,
		-1,
		-1,
		170,
		-1,
		185,
		-1,
		-1,
		210,
		294,
		241,
		223,
		219,
		217,
		210,
		219,
		214,
		209,
		219,
		228,
		220,
		201,
		212,
		235,
		224,
		262,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		199,
		174,
		189,
		235,
		230,
		231,
		256,
		253,
		-1,
		223,
		248,
		220,
		227,
		219,
		227,
		227,
		224,
		202,
		209,
		225,
		224,
		219,
		254,
		246,
		252,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		205,
		191,
		221,
		211,
		217,
		-1,
		-1,
		264,
		261,
		245,
		229,
		233,
		226,
		221,
		231,
		211,
		198,
		202,
		206,
		212,
		217,
		222,
		228,
		243,
		258,
		-1,
		175,
		256,
		249,
		232,
		240,
		271,
		-1,
		208,
		217,
		198,
		203,
		211,
		-1,
		-1,
		237,
		233,
		238,
		236,
		233,
		241,
		236,
		227,
		212,
		218,
		205,
		204,
		222,
		226,
		235,
		242,
		232,
		245,
		249,
		-1,
		189,
		232,
		226,
		229,
		253,
		267,
		-1,
		221,
		-1,
		-1,
		206,
		224,
		232,
		228,
		232,
		285,
		250,
		245,
		235,
		233,
		224,
		215,
		222,
		213,
		213,
		216,
		231,
		236,
		228,
		242,
		242,
		243,
		-1,
		224,
		212,
		220,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		222,
		-1,
		258,
		-1,
		251,
		255,
		258,
		261,
		249,
		236,
		228,
		220,
		236,
		211,
		221,
		217,
		218,
		227,
		238,
		250,
		249,
		250,
		298,
		253,
		220,
		211,
		258,
		273,
		277,
		-1,
		234,
		273,
		260,
		-1,
		231,
		-1,
		-1,
		-1,
		265,
		271,
		263,
		269,
		248,
		248,
		222,
		226,
		216,
		223,
		233,
		235,
		227,
		231,
		244,
		255,
		258,
		294,
		292,
		297,
		242,
		225,
		243,
		252,
		273,
		249,
		240,
		267,
		267,
		256,
		251,
		238,
		-1,
		-1,
		288,
		281,
		-1,
		-1,
		255,
		243,
		226,
		227,
		223,
		226,
		241,
		244,
		234,
		232,
		226,
		258,
		-1,
		294,
		293,
		282,
		279,
		255,
		246,
		233,
		244,
		-1,
		-1,
		252,
		268,
		281,
		285,
		298,
		323,
		-1,
		241,
		-1,
		-1,
		300,
		-1,
		-1,
		285,
		248,
		237,
		228,
		234,
		231,
		242,
		252,
		240,
		241,
		231,
		241,
		254,
		278,
		275,
		263,
		261,
		284,
		241,
		237,
		-1,
		267,
		255,
		261,
		268,
		285,
		312,
		-1,
		-1,
		257,
		248,
		-1,
		-1,
		283,
		281,
		270,
		-1,
		260,
		233,
		238,
		258,
		260,
		249,
		243,
		237,
		244,
		243,
		251,
		259,
		287,
		301,
		290,
		286,
		285,
		293,
		242,
		259,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		-1,
		292,
		267,
		-1,
		-1,
		278,
		271,
		259,
		247,
		237,
		247,
		251,
		255,
		247,
		240,
		235,
		246,
		238,
		242,
		259,
		-1,
		321,
		-1,
		273,
		266,
		281,
		296,
		304,
		-1,
		-1,
		-1,
		309,
		295,
		288,
		276,
		274,
		-1,
		312,
		296,
		277,
		-1,
		247,
		260,
		291,
		259,
		264,
		259,
		241,
		252,
		241,
		244,
		258,
		253,
		-1,
		-1,
		279,
		282,
		-1,
		-1,
		304,
		323,
		-1,
		300,
		289,
		274,
		266,
		-1,
		-1,
		284,
		280,
		-1,
		-1,
		248,
		273,
		262,
		270,
		265,
		245,
		251,
		254,
		243,
		247,
		259,
		-1,
		-1,
		286,
		287,
		292,
		-1,
		313,
		-1,
		324,
		-1,
		269,
		285,
		287,
		-1,
		-1,
		-1,
		286,
		249,
		270,
		280,
		274,
		272,
		263,
		249,
		256,
		254,
		250,
		261,
		-1,
		-1,
		-1,
		331,
		305,
		331,
		322,
		305,
		285,
		277,
		302,
		-1,
		273,
		-1,
		248,
		250,
		276,
		279,
		285,
		279,
		252,
		267,
		257,
		248,
		257,
		337,
		-1,
		307,
		340,
		304,
		291,
		274,
		278,
		294,
		-1,
		270,
		252,
		-1,
		280,
		270,
		301,
		286,
		267,
		254,
		261,
		261,
		254,
		-1,
		-1,
		-1,
		309,
		308,
		300,
		294,
		294,
		279,
		270,
		-1,
		282,
		264,
		243,
		260,
		260,
		251,
		259,
		291,
		287,
		274,
		274,
		266,
		-1,
		393,
		-1,
		-1,
		332,
		-1,
		-1,
		-1,
		303,
		298,
		271,
		259,
		265,
		261,
		247,
		253,
		255,
		263,
		261,
		258,
		270,
		266,
		286,
		267,
		302,
		-1,
		400,
		-1,
		339,
		-1,
		-1,
		321,
		301,
		293,
		282,
		271,
		269,
		260,
		251,
		273,
		289,
		273,
		271,
		274,
		275,
		-1,
		394,
		393,
		-1,
		340,
		332,
		318,
		-1,
		311,
		-1,
		317,
		278,
		-1,
		280,
		260,
		-1,
		282,
		278,
		-1,
		-1,
		381,
		356,
		-1,
		-1,
		-1,
		341,
		321,
		312,
		296,
		-1,
		271,
		271,
		-1,
		-1,
		-1,
		366,
		365,
		-1,
		334,
		337,
		-1,
		327,
		318,
		326,
		273,
		277,
		-1,
		-1,
		-1,
		375,
		356,
		350,
		349,
		347,
		342,
		339,
		325,
		309,
		287,
		276,
		297,
		-1,
		-1,
		-1,
		347,
		339,
		332,
		-1,
		-1,
		334,
		317,
		298,
		296,
		-1,
		-1,
		-1,
		369,
		350,
		-1,
		-1,
		324,
		-1,
		-1,
		330,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		386,
		358,
		-1,
		-1,
		-1,
		320,
		316,
		317,
		-1,
		-1,
		-1,
		-1,
		380,
		381,
		404,
		368,
		-1,
		-1,
		-1,
		312,
		306,
		-1,
		-1,
		383,
		381,
		-1,
		-1,
		-1,
		340,
		324,
		-1,
		310,
		-1,
		-1,
		-1,
		331,
		-1,
		-1,
		343,
		-1,
		-1,
		-1,
		345,
		-1,
		345,
		320,
		327,
		-1,
		-1,
		-1,
		-1,
		358,
		350,
		358,
		-1,
		330,
		332,
		-1,
		380,
		-1,
		-1,
		373,
		364,
		-1,
		-1,
		335,
		342,
		364,
		367,
		403,
		-1,
		354
	],
	[
		-1,
		179,
		168,
		179,
		187,
		160,
		167,
		-1,
		188,
		190,
		156,
		150,
		189,
		160,
		166,
		177,
		-1,
		-1,
		-1,
		179,
		178,
		148,
		146,
		155,
		160,
		167,
		-1,
		190,
		-1,
		200,
		179,
		190,
		195,
		141,
		138,
		158,
		177,
		183,
		175,
		215,
		171,
		142,
		136,
		154,
		159,
		177,
		169,
		-1,
		142,
		132,
		154,
		158,
		170,
		153,
		-1,
		-1,
		136,
		137,
		143,
		155,
		160,
		165,
		-1,
		191,
		210,
		-1,
		-1,
		126,
		139,
		135,
		138,
		146,
		162,
		183,
		200,
		205,
		-1,
		-1,
		127,
		131,
		144,
		145,
		143,
		170,
		189,
		200,
		214,
		213,
		-1,
		115,
		133,
		142,
		151,
		157,
		146,
		150,
		168,
		199,
		205,
		208,
		-1,
		107,
		109,
		138,
		144,
		156,
		162,
		149,
		155,
		174,
		187,
		206,
		197,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		104,
		112,
		138,
		137,
		133,
		151,
		173,
		152,
		158,
		162,
		179,
		195,
		196,
		206,
		-1,
		-1,
		160,
		129,
		164,
		121,
		106,
		-1,
		100,
		119,
		125,
		129,
		134,
		142,
		170,
		168,
		-1,
		173,
		172,
		203,
		189,
		200,
		120,
		-1,
		-1,
		118,
		110,
		95,
		98,
		95,
		95,
		125,
		124,
		129,
		131,
		133,
		145,
		160,
		160,
		170,
		167,
		177,
		181,
		196,
		207,
		-1,
		-1,
		274,
		-1,
		-1,
		117,
		100,
		-1,
		83,
		90,
		90,
		107,
		97,
		118,
		133,
		137,
		145,
		148,
		136,
		155,
		152,
		176,
		172,
		164,
		189,
		193,
		199,
		217,
		215,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		76,
		79,
		85,
		109,
		119,
		-1,
		140,
		138,
		162,
		156,
		161,
		157,
		142,
		160,
		158,
		173,
		175,
		171,
		173,
		210,
		196,
		218,
		215,
		244,
		249,
		243,
		252,
		-1,
		125,
		121,
		117,
		124,
		73,
		-1,
		-1,
		113,
		-1,
		127,
		140,
		152,
		142,
		145,
		157,
		165,
		164,
		148,
		166,
		161,
		164,
		176,
		179,
		188,
		191,
		190,
		208,
		223,
		236,
		240,
		246,
		-1,
		175,
		-1,
		117,
		101,
		103,
		75,
		96,
		-1,
		133,
		128,
		148,
		154,
		154,
		-1,
		170,
		167,
		180,
		164,
		149,
		166,
		168,
		170,
		175,
		180,
		194,
		185,
		203,
		210,
		218,
		222,
		242,
		254,
		135,
		125,
		-1,
		107,
		112,
		71,
		78,
		93,
		171,
		155,
		-1,
		165,
		-1,
		172,
		185,
		-1,
		170,
		166,
		155,
		163,
		158,
		173,
		179,
		176,
		173,
		191,
		194,
		211,
		215,
		231,
		-1,
		-1,
		120,
		124,
		97,
		64,
		75,
		99,
		136,
		164,
		172,
		171,
		-1,
		165,
		191,
		188,
		178,
		165,
		155,
		156,
		164,
		177,
		156,
		175,
		178,
		200,
		228,
		206,
		218,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		74,
		61,
		77,
		119,
		201,
		194,
		182,
		150,
		150,
		144,
		-1,
		185,
		168,
		164,
		153,
		151,
		164,
		159,
		175,
		179,
		178,
		197,
		209,
		200,
		220,
		-1,
		-1,
		-1,
		86,
		75,
		76,
		64,
		98,
		108,
		183,
		169,
		174,
		149,
		142,
		136,
		188,
		185,
		152,
		160,
		152,
		141,
		155,
		163,
		167,
		176,
		185,
		191,
		215,
		215,
		221,
		-1,
		-1,
		10,
		0,
		22,
		39,
		65,
		89,
		96,
		128,
		174,
		171,
		-1,
		141,
		-1,
		130,
		138,
		137,
		143,
		155,
		141,
		146,
		157,
		169,
		182,
		178,
		185,
		220,
		220,
		205,
		225,
		228,
		-1,
		-1,
		-1,
		31,
		137,
		112,
		89,
		70,
		106,
		-1,
		141,
		142,
		-1,
		135,
		129,
		135,
		134,
		141,
		138,
		138,
		152,
		160,
		156,
		172,
		178,
		170,
		206,
		-1,
		213,
		207,
		215,
		205,
		193,
		-1,
		-1,
		-1,
		135,
		114,
		107,
		127,
		77,
		129,
		-1,
		-1,
		126,
		119,
		-1,
		122,
		122,
		129,
		138,
		143,
		148,
		156,
		151,
		164,
		169,
		175,
		180,
		198,
		202,
		206,
		195,
		191,
		188,
		202,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		97,
		-1,
		134,
		126,
		117,
		111,
		117,
		135,
		133,
		153,
		145,
		159,
		159,
		165,
		173,
		158,
		161,
		177,
		175,
		193,
		201,
		193,
		187,
		186,
		198,
		-1,
		183,
		169,
		140,
		-1,
		-1,
		112,
		-1,
		83,
		107,
		123,
		-1,
		151,
		130,
		153,
		131,
		145,
		141,
		179,
		180,
		158,
		163,
		171,
		181,
		183,
		172,
		183,
		175,
		197,
		197,
		181,
		182,
		191,
		-1,
		189,
		176,
		134,
		130,
		119,
		139,
		86,
		99,
		110,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		155,
		153,
		169,
		160,
		166,
		182,
		185,
		187,
		177,
		166,
		172,
		169,
		191,
		177,
		175,
		194,
		210,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		105,
		92,
		86,
		-1,
		127,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		177,
		161,
		166,
		-1,
		212,
		-1,
		185,
		187,
		181,
		166,
		163,
		174,
		172,
		183,
		200,
		-1,
		139,
		124,
		117,
		107,
		121,
		92,
		-1,
		143,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		193,
		173,
		167,
		166,
		207,
		207,
		193,
		179,
		172,
		169,
		166,
		179,
		199,
		190,
		202,
		-1,
		-1,
		-1,
		144,
		124,
		130,
		88,
		109,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		210,
		198,
		188,
		178,
		212,
		213,
		198,
		191,
		177,
		179,
		177,
		175,
		180,
		201,
		202,
		215,
		-1,
		-1,
		121,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		199,
		-1,
		-1,
		190,
		188,
		198,
		194,
		181,
		201,
		204,
		190,
		174,
		189,
		201,
		209,
		214,
		-1,
		124,
		111,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		202,
		168,
		180,
		201,
		226,
		193,
		-1,
		198,
		199,
		185,
		199,
		206,
		192,
		187,
		181,
		184,
		202,
		219,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		159,
		173,
		194,
		200,
		212,
		-1,
		207,
		201,
		187,
		204,
		205,
		202,
		193,
		185,
		190,
		187,
		200,
		214,
		218,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		177,
		192,
		254,
		231,
		204,
		208,
		201,
		195,
		195,
		211,
		213,
		224,
		192,
		188,
		189,
		193,
		192,
		209,
		219,
		-1,
		-1,
		144,
		161,
		196,
		185,
		189,
		281,
		-1,
		-1,
		217,
		208,
		199,
		202,
		205,
		208,
		198,
		195,
		200,
		205,
		193,
		202,
		220,
		224,
		-1,
		-1,
		-1,
		164,
		-1,
		179,
		-1,
		-1,
		204,
		288,
		235,
		217,
		213,
		211,
		204,
		213,
		208,
		203,
		213,
		222,
		214,
		195,
		206,
		229,
		218,
		256,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		193,
		168,
		183,
		229,
		224,
		225,
		250,
		247,
		-1,
		217,
		242,
		214,
		221,
		213,
		221,
		221,
		218,
		196,
		203,
		219,
		218,
		213,
		248,
		240,
		246,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		199,
		185,
		215,
		205,
		211,
		-1,
		-1,
		258,
		255,
		239,
		223,
		227,
		220,
		215,
		225,
		205,
		192,
		196,
		200,
		206,
		211,
		216,
		222,
		237,
		252,
		-1,
		169,
		250,
		243,
		226,
		234,
		265,
		-1,
		202,
		211,
		192,
		197,
		205,
		-1,
		-1,
		231,
		227,
		232,
		230,
		227,
		235,
		230,
		221,
		206,
		212,
		199,
		198,
		216,
		220,
		229,
		236,
		226,
		239,
		243,
		-1,
		183,
		226,
		220,
		223,
		247,
		261,
		-1,
		215,
		-1,
		-1,
		200,
		218,
		226,
		222,
		226,
		279,
		244,
		239,
		229,
		227,
		218,
		209,
		216,
		207,
		207,
		210,
		225,
		230,
		222,
		236,
		236,
		237,
		-1,
		218,
		206,
		214,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		216,
		-1,
		252,
		-1,
		245,
		249,
		252,
		255,
		243,
		230,
		222,
		214,
		230,
		205,
		215,
		211,
		212,
		221,
		232,
		244,
		243,
		244,
		292,
		247,
		214,
		205,
		252,
		267,
		271,
		-1,
		228,
		267,
		254,
		-1,
		225,
		-1,
		-1,
		-1,
		259,
		265,
		257,
		263,
		242,
		242,
		216,
		220,
		210,
		217,
		227,
		229,
		221,
		225,
		238,
		249,
		252,
		288,
		286,
		291,
		236,
		219,
		237,
		246,
		267,
		243,
		234,
		261,
		261,
		250,
		245,
		232,
		-1,
		-1,
		282,
		275,
		-1,
		-1,
		249,
		237,
		220,
		221,
		217,
		220,
		235,
		238,
		228,
		226,
		220,
		252,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		227,
		238,
		-1,
		-1,
		246,
		262,
		275,
		279,
		292,
		317,
		-1,
		235,
		-1,
		-1,
		294,
		-1,
		-1,
		279,
		242,
		231,
		222,
		228,
		225,
		236,
		246,
		234,
		235,
		225,
		235,
		248,
		272,
		269,
		257,
		255,
		278,
		235,
		231,
		-1,
		261,
		249,
		255,
		262,
		279,
		306,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		277,
		275,
		264,
		-1,
		254,
		227,
		232,
		252,
		254,
		243,
		237,
		231,
		238,
		237,
		245,
		253,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		-1,
		286,
		261,
		-1,
		-1,
		272,
		265,
		253,
		241,
		231,
		241,
		245,
		249,
		241,
		234,
		229,
		240,
		232,
		236,
		253,
		-1,
		315,
		-1,
		267,
		260,
		275,
		290,
		298,
		-1,
		-1,
		-1,
		303,
		289,
		282,
		270,
		268,
		-1,
		306,
		290,
		271,
		-1,
		241,
		254,
		285,
		253,
		258,
		253,
		235,
		246,
		235,
		238,
		252,
		247,
		-1,
		-1,
		273,
		276,
		-1,
		-1,
		298,
		317,
		-1,
		294,
		283,
		268,
		260,
		-1,
		-1,
		278,
		274,
		-1,
		-1,
		242,
		267,
		256,
		264,
		259,
		239,
		245,
		248,
		237,
		241,
		253,
		-1,
		-1,
		280,
		281,
		286,
		-1,
		307,
		-1,
		318,
		-1,
		263,
		279,
		281,
		-1,
		-1,
		-1,
		280,
		243,
		264,
		274,
		268,
		266,
		257,
		243,
		250,
		248,
		244,
		255,
		-1,
		-1,
		-1,
		325,
		299,
		325,
		316,
		299,
		279,
		271,
		296,
		-1,
		267,
		-1,
		242,
		244,
		270,
		273,
		279,
		273,
		246,
		261,
		251,
		242,
		251,
		331,
		-1,
		301,
		334,
		298,
		285,
		268,
		272,
		288,
		-1,
		264,
		246,
		-1,
		274,
		264,
		295,
		280,
		261,
		248,
		255,
		255,
		248,
		-1,
		-1,
		-1,
		303,
		302,
		294,
		288,
		288,
		273,
		264,
		-1,
		276,
		258,
		237,
		254,
		254,
		245,
		253,
		285,
		281,
		268,
		268,
		260,
		-1,
		387,
		-1,
		-1,
		326,
		-1,
		-1,
		-1,
		297,
		292,
		265,
		253,
		259,
		255,
		241,
		247,
		249,
		257,
		255,
		252,
		264,
		260,
		280,
		261,
		296,
		-1,
		394,
		-1,
		333,
		-1,
		-1,
		315,
		295,
		287,
		276,
		265,
		263,
		254,
		245,
		267,
		283,
		267,
		265,
		268,
		269,
		-1,
		388,
		387,
		-1,
		334,
		326,
		312,
		-1,
		305,
		-1,
		311,
		272,
		-1,
		274,
		254,
		-1,
		276,
		272,
		-1,
		-1,
		375,
		350,
		-1,
		-1,
		-1,
		335,
		315,
		306,
		290,
		-1,
		265,
		265,
		-1,
		-1,
		-1,
		360,
		359,
		-1,
		328,
		331,
		-1,
		321,
		312,
		320,
		267,
		271,
		-1,
		-1,
		-1,
		369,
		350,
		344,
		343,
		341,
		336,
		333,
		319,
		303,
		281,
		270,
		291,
		-1,
		-1,
		-1,
		341,
		333,
		326,
		-1,
		-1,
		328,
		311,
		292,
		290,
		-1,
		-1,
		-1,
		363,
		344,
		-1,
		-1,
		318,
		-1,
		-1,
		324,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		380,
		352,
		-1,
		-1,
		-1,
		314,
		310,
		311,
		-1,
		-1,
		-1,
		-1,
		374,
		375,
		398,
		362,
		-1,
		-1,
		-1,
		306,
		300,
		-1,
		-1,
		377,
		375,
		-1,
		-1,
		-1,
		334,
		318,
		-1,
		304,
		-1,
		-1,
		-1,
		325,
		-1,
		-1,
		337,
		-1,
		-1,
		-1,
		339,
		-1,
		339,
		314,
		321,
		-1,
		-1,
		-1,
		-1,
		352,
		344,
		352,
		-1,
		324,
		326,
		-1,
		374,
		-1,
		-1,
		367,
		358,
		-1,
		-1,
		329,
		336,
		358,
		361,
		397,
		-1,
		348
	],
	[
		-1,
		157,
		146,
		157,
		165,
		138,
		145,
		-1,
		166,
		168,
		134,
		128,
		167,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		157,
		156,
		126,
		124,
		133,
		138,
		145,
		-1,
		168,
		-1,
		178,
		157,
		168,
		173,
		119,
		116,
		136,
		155,
		161,
		153,
		193,
		149,
		120,
		114,
		132,
		137,
		155,
		147,
		-1,
		120,
		110,
		132,
		136,
		148,
		131,
		-1,
		-1,
		114,
		115,
		121,
		133,
		138,
		143,
		-1,
		169,
		188,
		-1,
		-1,
		104,
		117,
		113,
		116,
		124,
		140,
		161,
		178,
		183,
		-1,
		-1,
		105,
		109,
		122,
		123,
		121,
		148,
		167,
		178,
		192,
		191,
		-1,
		93,
		111,
		120,
		129,
		135,
		124,
		128,
		146,
		177,
		183,
		186,
		-1,
		85,
		87,
		116,
		122,
		134,
		140,
		127,
		133,
		152,
		165,
		184,
		175,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		82,
		90,
		116,
		115,
		111,
		129,
		151,
		130,
		136,
		140,
		157,
		173,
		174,
		184,
		-1,
		-1,
		138,
		107,
		142,
		99,
		84,
		-1,
		78,
		97,
		103,
		107,
		112,
		120,
		148,
		146,
		-1,
		151,
		150,
		181,
		167,
		178,
		98,
		-1,
		-1,
		96,
		88,
		73,
		76,
		73,
		73,
		103,
		102,
		107,
		109,
		111,
		123,
		138,
		138,
		148,
		145,
		155,
		159,
		174,
		185,
		-1,
		-1,
		252,
		-1,
		-1,
		95,
		78,
		-1,
		61,
		68,
		68,
		85,
		75,
		96,
		111,
		115,
		123,
		126,
		114,
		133,
		130,
		154,
		150,
		142,
		167,
		171,
		177,
		195,
		193,
		-1,
		251,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		54,
		57,
		63,
		87,
		97,
		-1,
		118,
		116,
		140,
		134,
		139,
		135,
		120,
		138,
		136,
		151,
		153,
		149,
		151,
		188,
		174,
		196,
		193,
		222,
		227,
		221,
		230,
		-1,
		103,
		99,
		95,
		102,
		51,
		-1,
		-1,
		91,
		-1,
		105,
		118,
		130,
		120,
		123,
		135,
		143,
		142,
		126,
		144,
		139,
		142,
		154,
		157,
		166,
		169,
		168,
		186,
		201,
		214,
		218,
		224,
		-1,
		153,
		-1,
		95,
		79,
		81,
		53,
		74,
		-1,
		111,
		106,
		126,
		132,
		132,
		-1,
		148,
		145,
		158,
		142,
		127,
		144,
		146,
		148,
		153,
		158,
		172,
		163,
		181,
		188,
		196,
		200,
		220,
		232,
		113,
		103,
		-1,
		85,
		90,
		49,
		56,
		71,
		149,
		133,
		-1,
		143,
		-1,
		150,
		163,
		-1,
		148,
		144,
		133,
		141,
		136,
		151,
		157,
		154,
		151,
		169,
		172,
		189,
		193,
		209,
		-1,
		-1,
		98,
		102,
		75,
		42,
		53,
		77,
		114,
		142,
		150,
		149,
		-1,
		143,
		169,
		166,
		156,
		143,
		133,
		134,
		142,
		155,
		134,
		153,
		156,
		178,
		206,
		184,
		196,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		52,
		39,
		55,
		97,
		179,
		172,
		160,
		128,
		128,
		122,
		-1,
		163,
		146,
		142,
		131,
		129,
		142,
		137,
		153,
		157,
		156,
		175,
		187,
		178,
		198,
		-1,
		-1,
		-1,
		64,
		53,
		54,
		42,
		76,
		86,
		161,
		147,
		152,
		127,
		120,
		114,
		166,
		163,
		130,
		138,
		130,
		119,
		133,
		141,
		145,
		154,
		163,
		169,
		193,
		193,
		199,
		-1,
		-1,
		26,
		16,
		0,
		17,
		43,
		67,
		74,
		106,
		152,
		149,
		-1,
		119,
		-1,
		108,
		116,
		115,
		121,
		133,
		119,
		124,
		135,
		147,
		160,
		156,
		163,
		198,
		198,
		183,
		203,
		206,
		-1,
		-1,
		-1,
		19,
		115,
		90,
		67,
		48,
		84,
		-1,
		119,
		120,
		-1,
		113,
		107,
		113,
		112,
		119,
		116,
		116,
		130,
		138,
		134,
		150,
		156,
		148,
		184,
		-1,
		191,
		185,
		193,
		183,
		171,
		-1,
		-1,
		-1,
		113,
		92,
		85,
		105,
		55,
		107,
		-1,
		-1,
		104,
		97,
		-1,
		100,
		100,
		107,
		116,
		121,
		126,
		134,
		129,
		142,
		147,
		153,
		158,
		176,
		180,
		184,
		173,
		169,
		166,
		180,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		75,
		-1,
		112,
		104,
		95,
		89,
		95,
		113,
		111,
		131,
		123,
		137,
		137,
		143,
		151,
		136,
		139,
		155,
		153,
		171,
		179,
		171,
		165,
		164,
		176,
		-1,
		161,
		147,
		118,
		-1,
		-1,
		90,
		-1,
		61,
		85,
		101,
		-1,
		129,
		108,
		131,
		109,
		123,
		119,
		157,
		158,
		136,
		141,
		149,
		159,
		161,
		150,
		161,
		153,
		175,
		175,
		159,
		160,
		169,
		-1,
		167,
		154,
		112,
		108,
		97,
		117,
		64,
		77,
		88,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		133,
		131,
		147,
		138,
		144,
		160,
		163,
		165,
		155,
		144,
		150,
		147,
		169,
		155,
		153,
		172,
		188,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		83,
		70,
		64,
		-1,
		105,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		155,
		139,
		144,
		-1,
		190,
		-1,
		163,
		165,
		159,
		144,
		141,
		152,
		150,
		161,
		178,
		-1,
		117,
		102,
		95,
		85,
		99,
		70,
		-1,
		121,
		-1,
		-1,
		138,
		132,
		132,
		116,
		119,
		171,
		151,
		145,
		144,
		185,
		185,
		171,
		157,
		150,
		147,
		144,
		157,
		177,
		168,
		180,
		-1,
		-1,
		-1,
		122,
		102,
		108,
		66,
		87,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		125,
		188,
		176,
		166,
		156,
		190,
		191,
		176,
		169,
		155,
		157,
		155,
		153,
		158,
		179,
		180,
		193,
		-1,
		-1,
		99,
		106,
		94,
		80,
		99,
		-1,
		-1,
		-1,
		147,
		163,
		155,
		126,
		177,
		-1,
		-1,
		168,
		166,
		176,
		172,
		159,
		179,
		182,
		168,
		152,
		167,
		179,
		187,
		192,
		-1,
		102,
		89,
		-1,
		-1,
		102,
		96,
		-1,
		-1,
		-1,
		-1,
		180,
		146,
		158,
		179,
		204,
		171,
		-1,
		176,
		177,
		163,
		177,
		184,
		170,
		165,
		159,
		162,
		180,
		197,
		-1,
		-1,
		116,
		-1,
		111,
		-1,
		-1,
		-1,
		-1,
		137,
		151,
		172,
		178,
		190,
		-1,
		185,
		179,
		165,
		182,
		183,
		180,
		171,
		163,
		168,
		165,
		178,
		192,
		196,
		139,
		-1,
		122,
		-1,
		-1,
		-1,
		155,
		170,
		232,
		209,
		182,
		186,
		179,
		173,
		173,
		189,
		191,
		202,
		170,
		166,
		167,
		171,
		170,
		187,
		197,
		-1,
		-1,
		122,
		139,
		174,
		163,
		167,
		259,
		-1,
		-1,
		195,
		186,
		177,
		180,
		183,
		186,
		176,
		173,
		178,
		183,
		171,
		180,
		198,
		202,
		-1,
		-1,
		-1,
		142,
		-1,
		157,
		-1,
		-1,
		182,
		266,
		213,
		195,
		191,
		189,
		182,
		191,
		186,
		181,
		191,
		200,
		192,
		173,
		184,
		207,
		196,
		234,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		171,
		146,
		161,
		207,
		202,
		203,
		228,
		225,
		-1,
		195,
		220,
		192,
		199,
		191,
		199,
		199,
		196,
		174,
		181,
		197,
		196,
		191,
		226,
		218,
		224,
		-1,
		-1,
		252,
		241,
		230,
		236,
		-1,
		177,
		163,
		193,
		183,
		189,
		-1,
		-1,
		236,
		233,
		217,
		201,
		205,
		198,
		193,
		203,
		183,
		170,
		174,
		178,
		184,
		189,
		194,
		200,
		215,
		230,
		-1,
		147,
		228,
		221,
		204,
		212,
		243,
		-1,
		180,
		189,
		170,
		175,
		183,
		-1,
		-1,
		209,
		205,
		210,
		208,
		205,
		213,
		208,
		199,
		184,
		190,
		177,
		176,
		194,
		198,
		207,
		214,
		204,
		217,
		221,
		-1,
		161,
		204,
		198,
		201,
		225,
		239,
		-1,
		193,
		-1,
		-1,
		178,
		196,
		204,
		200,
		204,
		257,
		222,
		217,
		207,
		205,
		196,
		187,
		194,
		185,
		185,
		188,
		203,
		208,
		200,
		214,
		214,
		215,
		-1,
		196,
		184,
		192,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		194,
		-1,
		230,
		-1,
		223,
		227,
		230,
		233,
		221,
		208,
		200,
		192,
		208,
		183,
		193,
		189,
		190,
		199,
		210,
		222,
		221,
		222,
		270,
		225,
		192,
		183,
		230,
		245,
		249,
		-1,
		206,
		245,
		232,
		-1,
		203,
		-1,
		-1,
		-1,
		237,
		243,
		235,
		241,
		220,
		220,
		194,
		198,
		188,
		195,
		205,
		207,
		199,
		203,
		216,
		227,
		230,
		266,
		264,
		269,
		214,
		197,
		215,
		224,
		245,
		221,
		212,
		239,
		239,
		228,
		223,
		210,
		-1,
		-1,
		260,
		253,
		-1,
		-1,
		227,
		215,
		198,
		199,
		195,
		198,
		213,
		216,
		206,
		204,
		198,
		230,
		-1,
		266,
		265,
		254,
		251,
		227,
		218,
		205,
		216,
		-1,
		-1,
		224,
		240,
		253,
		257,
		270,
		295,
		-1,
		213,
		-1,
		-1,
		272,
		-1,
		-1,
		257,
		220,
		209,
		200,
		206,
		203,
		214,
		224,
		212,
		213,
		203,
		213,
		226,
		250,
		247,
		235,
		233,
		256,
		213,
		209,
		-1,
		239,
		227,
		233,
		240,
		257,
		284,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		255,
		253,
		242,
		-1,
		232,
		205,
		210,
		230,
		232,
		221,
		215,
		209,
		216,
		215,
		223,
		231,
		259,
		273,
		262,
		258,
		257,
		265,
		214,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		-1,
		264,
		239,
		-1,
		-1,
		250,
		243,
		231,
		219,
		209,
		219,
		223,
		227,
		219,
		212,
		207,
		218,
		210,
		214,
		231,
		-1,
		293,
		-1,
		245,
		238,
		253,
		268,
		276,
		-1,
		-1,
		-1,
		281,
		267,
		260,
		248,
		246,
		-1,
		284,
		268,
		249,
		-1,
		219,
		232,
		263,
		231,
		236,
		231,
		213,
		224,
		213,
		216,
		230,
		225,
		-1,
		-1,
		251,
		254,
		-1,
		-1,
		276,
		295,
		-1,
		272,
		261,
		246,
		238,
		-1,
		-1,
		256,
		252,
		-1,
		-1,
		220,
		245,
		234,
		242,
		237,
		217,
		223,
		226,
		215,
		219,
		231,
		-1,
		-1,
		258,
		259,
		264,
		-1,
		285,
		-1,
		296,
		-1,
		241,
		257,
		259,
		-1,
		-1,
		-1,
		258,
		221,
		242,
		252,
		246,
		244,
		235,
		221,
		228,
		226,
		222,
		233,
		-1,
		-1,
		-1,
		303,
		277,
		303,
		294,
		277,
		257,
		249,
		274,
		-1,
		245,
		-1,
		220,
		222,
		248,
		251,
		257,
		251,
		224,
		239,
		229,
		220,
		229,
		309,
		-1,
		279,
		312,
		276,
		263,
		246,
		250,
		266,
		-1,
		242,
		224,
		-1,
		252,
		242,
		273,
		258,
		239,
		226,
		233,
		233,
		226,
		-1,
		-1,
		-1,
		281,
		280,
		272,
		266,
		266,
		251,
		242,
		-1,
		254,
		236,
		215,
		232,
		232,
		223,
		231,
		263,
		259,
		246,
		246,
		238,
		-1,
		365,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		275,
		270,
		243,
		231,
		237,
		233,
		219,
		225,
		227,
		235,
		233,
		230,
		242,
		238,
		258,
		239,
		274,
		-1,
		372,
		-1,
		311,
		-1,
		-1,
		293,
		273,
		265,
		254,
		243,
		241,
		232,
		223,
		245,
		261,
		245,
		243,
		246,
		247,
		-1,
		366,
		365,
		-1,
		312,
		304,
		290,
		-1,
		283,
		-1,
		289,
		250,
		-1,
		252,
		232,
		-1,
		254,
		250,
		-1,
		-1,
		353,
		328,
		-1,
		-1,
		-1,
		313,
		293,
		284,
		268,
		-1,
		243,
		243,
		-1,
		-1,
		-1,
		338,
		337,
		-1,
		306,
		309,
		-1,
		299,
		290,
		298,
		245,
		249,
		-1,
		-1,
		-1,
		347,
		328,
		322,
		321,
		319,
		314,
		311,
		297,
		281,
		259,
		248,
		269,
		-1,
		-1,
		-1,
		319,
		311,
		304,
		-1,
		-1,
		306,
		289,
		270,
		268,
		-1,
		-1,
		-1,
		341,
		322,
		-1,
		-1,
		296,
		-1,
		-1,
		302,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		358,
		330,
		-1,
		-1,
		-1,
		292,
		288,
		289,
		-1,
		-1,
		-1,
		-1,
		352,
		353,
		376,
		340,
		-1,
		-1,
		-1,
		284,
		278,
		-1,
		-1,
		355,
		353,
		-1,
		-1,
		-1,
		312,
		296,
		-1,
		282,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		315,
		-1,
		-1,
		-1,
		317,
		-1,
		317,
		292,
		299,
		-1,
		-1,
		-1,
		-1,
		330,
		322,
		330,
		-1,
		302,
		304,
		-1,
		352,
		-1,
		-1,
		345,
		336,
		-1,
		-1,
		307,
		314,
		336,
		339,
		375,
		-1,
		326
	],
	[
		-1,
		161,
		150,
		161,
		169,
		142,
		149,
		-1,
		170,
		172,
		138,
		132,
		171,
		142,
		148,
		159,
		-1,
		-1,
		-1,
		161,
		160,
		130,
		128,
		137,
		142,
		149,
		-1,
		172,
		-1,
		182,
		161,
		172,
		177,
		123,
		120,
		140,
		159,
		165,
		157,
		197,
		153,
		124,
		118,
		136,
		141,
		159,
		151,
		-1,
		124,
		114,
		136,
		140,
		152,
		135,
		-1,
		-1,
		118,
		119,
		125,
		137,
		142,
		147,
		-1,
		173,
		192,
		-1,
		-1,
		108,
		121,
		117,
		120,
		128,
		144,
		165,
		182,
		187,
		-1,
		-1,
		109,
		113,
		126,
		127,
		125,
		152,
		171,
		182,
		196,
		195,
		-1,
		97,
		115,
		124,
		133,
		139,
		128,
		132,
		150,
		181,
		187,
		190,
		-1,
		89,
		91,
		120,
		126,
		138,
		144,
		131,
		137,
		156,
		169,
		188,
		179,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		86,
		94,
		120,
		119,
		115,
		133,
		155,
		134,
		140,
		144,
		161,
		177,
		178,
		188,
		-1,
		-1,
		142,
		111,
		146,
		103,
		88,
		-1,
		82,
		101,
		107,
		111,
		116,
		124,
		152,
		150,
		-1,
		155,
		154,
		185,
		171,
		182,
		102,
		-1,
		-1,
		100,
		92,
		77,
		80,
		77,
		77,
		107,
		106,
		111,
		113,
		115,
		127,
		142,
		142,
		152,
		149,
		159,
		163,
		178,
		189,
		-1,
		-1,
		256,
		-1,
		-1,
		99,
		82,
		-1,
		65,
		72,
		72,
		89,
		79,
		100,
		115,
		119,
		127,
		130,
		118,
		137,
		134,
		158,
		154,
		146,
		171,
		175,
		181,
		199,
		197,
		-1,
		255,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		58,
		61,
		67,
		91,
		101,
		-1,
		122,
		120,
		144,
		138,
		143,
		139,
		124,
		142,
		140,
		155,
		157,
		153,
		155,
		192,
		178,
		200,
		197,
		226,
		231,
		225,
		234,
		-1,
		107,
		103,
		99,
		106,
		55,
		-1,
		-1,
		95,
		-1,
		109,
		122,
		134,
		124,
		127,
		139,
		147,
		146,
		130,
		148,
		143,
		146,
		158,
		161,
		170,
		173,
		172,
		190,
		205,
		218,
		222,
		228,
		-1,
		157,
		-1,
		99,
		83,
		85,
		57,
		78,
		-1,
		115,
		110,
		130,
		136,
		136,
		-1,
		152,
		149,
		162,
		146,
		131,
		148,
		150,
		152,
		157,
		162,
		176,
		167,
		185,
		192,
		200,
		204,
		224,
		236,
		117,
		107,
		-1,
		89,
		94,
		53,
		60,
		75,
		153,
		137,
		-1,
		147,
		-1,
		154,
		167,
		-1,
		152,
		148,
		137,
		145,
		140,
		155,
		161,
		158,
		155,
		173,
		176,
		193,
		197,
		213,
		-1,
		-1,
		102,
		106,
		79,
		46,
		57,
		81,
		118,
		146,
		154,
		153,
		-1,
		147,
		173,
		170,
		160,
		147,
		137,
		138,
		146,
		159,
		138,
		157,
		160,
		182,
		210,
		188,
		200,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		56,
		43,
		59,
		101,
		183,
		176,
		164,
		132,
		132,
		126,
		-1,
		167,
		150,
		146,
		135,
		133,
		146,
		141,
		157,
		161,
		160,
		179,
		191,
		182,
		202,
		-1,
		-1,
		-1,
		68,
		57,
		58,
		46,
		80,
		90,
		165,
		151,
		156,
		131,
		124,
		118,
		170,
		167,
		134,
		142,
		134,
		123,
		137,
		145,
		149,
		158,
		167,
		173,
		197,
		197,
		203,
		-1,
		-1,
		45,
		35,
		19,
		0,
		36,
		71,
		78,
		110,
		156,
		153,
		-1,
		123,
		-1,
		112,
		120,
		119,
		125,
		137,
		123,
		128,
		139,
		151,
		164,
		160,
		167,
		202,
		202,
		187,
		207,
		210,
		-1,
		-1,
		-1,
		38,
		119,
		94,
		71,
		52,
		88,
		-1,
		123,
		124,
		-1,
		117,
		111,
		117,
		116,
		123,
		120,
		120,
		134,
		142,
		138,
		154,
		160,
		152,
		188,
		-1,
		195,
		189,
		197,
		187,
		175,
		-1,
		-1,
		-1,
		117,
		96,
		89,
		109,
		59,
		111,
		-1,
		-1,
		108,
		101,
		-1,
		104,
		104,
		111,
		120,
		125,
		130,
		138,
		133,
		146,
		151,
		157,
		162,
		180,
		184,
		188,
		177,
		173,
		170,
		184,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		79,
		-1,
		116,
		108,
		99,
		93,
		99,
		117,
		115,
		135,
		127,
		141,
		141,
		147,
		155,
		140,
		143,
		159,
		157,
		175,
		183,
		175,
		169,
		168,
		180,
		-1,
		165,
		151,
		122,
		-1,
		-1,
		94,
		-1,
		65,
		89,
		105,
		-1,
		133,
		112,
		135,
		113,
		127,
		123,
		161,
		162,
		140,
		145,
		153,
		163,
		165,
		154,
		165,
		157,
		179,
		179,
		163,
		164,
		173,
		-1,
		171,
		158,
		116,
		112,
		101,
		121,
		68,
		81,
		92,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		137,
		135,
		151,
		142,
		148,
		164,
		167,
		169,
		159,
		148,
		154,
		151,
		173,
		159,
		157,
		176,
		192,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		87,
		74,
		68,
		-1,
		109,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		159,
		143,
		148,
		-1,
		194,
		-1,
		167,
		169,
		163,
		148,
		145,
		156,
		154,
		165,
		182,
		-1,
		121,
		106,
		99,
		89,
		103,
		74,
		-1,
		125,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		175,
		155,
		149,
		148,
		189,
		189,
		175,
		161,
		154,
		151,
		148,
		161,
		181,
		172,
		184,
		-1,
		-1,
		-1,
		126,
		106,
		112,
		70,
		91,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		192,
		180,
		170,
		160,
		194,
		195,
		180,
		173,
		159,
		161,
		159,
		157,
		162,
		183,
		184,
		197,
		-1,
		-1,
		103,
		110,
		98,
		84,
		103,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		181,
		-1,
		-1,
		172,
		170,
		180,
		176,
		163,
		183,
		186,
		172,
		156,
		171,
		183,
		191,
		196,
		-1,
		106,
		93,
		-1,
		-1,
		106,
		100,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		162,
		183,
		208,
		175,
		-1,
		180,
		181,
		167,
		181,
		188,
		174,
		169,
		163,
		166,
		184,
		201,
		-1,
		-1,
		120,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		141,
		155,
		176,
		182,
		194,
		-1,
		189,
		183,
		169,
		186,
		187,
		184,
		175,
		167,
		172,
		169,
		182,
		196,
		200,
		143,
		-1,
		126,
		-1,
		-1,
		-1,
		159,
		174,
		236,
		213,
		186,
		190,
		183,
		177,
		177,
		193,
		195,
		206,
		174,
		170,
		171,
		175,
		174,
		191,
		201,
		-1,
		-1,
		126,
		143,
		178,
		167,
		171,
		263,
		-1,
		-1,
		199,
		190,
		181,
		184,
		187,
		190,
		180,
		177,
		182,
		187,
		175,
		184,
		202,
		206,
		-1,
		-1,
		-1,
		146,
		-1,
		161,
		-1,
		-1,
		186,
		270,
		217,
		199,
		195,
		193,
		186,
		195,
		190,
		185,
		195,
		204,
		196,
		177,
		188,
		211,
		200,
		238,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		175,
		150,
		165,
		211,
		206,
		207,
		232,
		229,
		-1,
		199,
		224,
		196,
		203,
		195,
		203,
		203,
		200,
		178,
		185,
		201,
		200,
		195,
		230,
		222,
		228,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		181,
		167,
		197,
		187,
		193,
		-1,
		-1,
		240,
		237,
		221,
		205,
		209,
		202,
		197,
		207,
		187,
		174,
		178,
		182,
		188,
		193,
		198,
		204,
		219,
		234,
		-1,
		151,
		232,
		225,
		208,
		216,
		247,
		-1,
		184,
		193,
		174,
		179,
		187,
		-1,
		-1,
		213,
		209,
		214,
		212,
		209,
		217,
		212,
		203,
		188,
		194,
		181,
		180,
		198,
		202,
		211,
		218,
		208,
		221,
		225,
		-1,
		165,
		208,
		202,
		205,
		229,
		243,
		-1,
		197,
		-1,
		-1,
		182,
		200,
		208,
		204,
		208,
		261,
		226,
		221,
		211,
		209,
		200,
		191,
		198,
		189,
		189,
		192,
		207,
		212,
		204,
		218,
		218,
		219,
		-1,
		200,
		188,
		196,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		198,
		-1,
		234,
		-1,
		227,
		231,
		234,
		237,
		225,
		212,
		204,
		196,
		212,
		187,
		197,
		193,
		194,
		203,
		214,
		226,
		225,
		226,
		274,
		229,
		196,
		187,
		234,
		249,
		253,
		-1,
		210,
		249,
		236,
		-1,
		207,
		-1,
		-1,
		-1,
		241,
		247,
		239,
		245,
		224,
		224,
		198,
		202,
		192,
		199,
		209,
		211,
		203,
		207,
		220,
		231,
		234,
		270,
		268,
		273,
		218,
		201,
		219,
		228,
		249,
		225,
		216,
		243,
		243,
		232,
		227,
		214,
		-1,
		-1,
		264,
		257,
		-1,
		-1,
		231,
		219,
		202,
		203,
		199,
		202,
		217,
		220,
		210,
		208,
		202,
		234,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		209,
		220,
		-1,
		-1,
		228,
		244,
		257,
		261,
		274,
		299,
		-1,
		217,
		-1,
		-1,
		276,
		-1,
		-1,
		261,
		224,
		213,
		204,
		210,
		207,
		218,
		228,
		216,
		217,
		207,
		217,
		230,
		254,
		251,
		239,
		237,
		260,
		217,
		213,
		-1,
		243,
		231,
		237,
		244,
		261,
		288,
		-1,
		-1,
		233,
		224,
		-1,
		-1,
		259,
		257,
		246,
		-1,
		236,
		209,
		214,
		234,
		236,
		225,
		219,
		213,
		220,
		219,
		227,
		235,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		235,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		-1,
		268,
		243,
		-1,
		-1,
		254,
		247,
		235,
		223,
		213,
		223,
		227,
		231,
		223,
		216,
		211,
		222,
		214,
		218,
		235,
		-1,
		297,
		-1,
		249,
		242,
		257,
		272,
		280,
		-1,
		-1,
		-1,
		285,
		271,
		264,
		252,
		250,
		-1,
		288,
		272,
		253,
		-1,
		223,
		236,
		267,
		235,
		240,
		235,
		217,
		228,
		217,
		220,
		234,
		229,
		-1,
		-1,
		255,
		258,
		-1,
		-1,
		280,
		299,
		-1,
		276,
		265,
		250,
		242,
		-1,
		-1,
		260,
		256,
		-1,
		-1,
		224,
		249,
		238,
		246,
		241,
		221,
		227,
		230,
		219,
		223,
		235,
		-1,
		-1,
		262,
		263,
		268,
		-1,
		289,
		-1,
		300,
		-1,
		245,
		261,
		263,
		-1,
		-1,
		-1,
		262,
		225,
		246,
		256,
		250,
		248,
		239,
		225,
		232,
		230,
		226,
		237,
		-1,
		-1,
		-1,
		307,
		281,
		307,
		298,
		281,
		261,
		253,
		278,
		-1,
		249,
		-1,
		224,
		226,
		252,
		255,
		261,
		255,
		228,
		243,
		233,
		224,
		233,
		313,
		-1,
		283,
		316,
		280,
		267,
		250,
		254,
		270,
		-1,
		246,
		228,
		-1,
		256,
		246,
		277,
		262,
		243,
		230,
		237,
		237,
		230,
		-1,
		-1,
		-1,
		285,
		284,
		276,
		270,
		270,
		255,
		246,
		-1,
		258,
		240,
		219,
		236,
		236,
		227,
		235,
		267,
		263,
		250,
		250,
		242,
		-1,
		369,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		279,
		274,
		247,
		235,
		241,
		237,
		223,
		229,
		231,
		239,
		237,
		234,
		246,
		242,
		262,
		243,
		278,
		-1,
		376,
		-1,
		315,
		-1,
		-1,
		297,
		277,
		269,
		258,
		247,
		245,
		236,
		227,
		249,
		265,
		249,
		247,
		250,
		251,
		-1,
		370,
		369,
		-1,
		316,
		308,
		294,
		-1,
		287,
		-1,
		293,
		254,
		-1,
		256,
		236,
		-1,
		258,
		254,
		-1,
		-1,
		357,
		332,
		-1,
		-1,
		-1,
		317,
		297,
		288,
		272,
		-1,
		247,
		247,
		-1,
		-1,
		-1,
		342,
		341,
		-1,
		310,
		313,
		-1,
		303,
		294,
		302,
		249,
		253,
		-1,
		-1,
		-1,
		351,
		332,
		326,
		325,
		323,
		318,
		315,
		301,
		285,
		263,
		252,
		273,
		-1,
		-1,
		-1,
		323,
		315,
		308,
		-1,
		-1,
		310,
		293,
		274,
		272,
		-1,
		-1,
		-1,
		345,
		326,
		-1,
		-1,
		300,
		-1,
		-1,
		306,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		362,
		334,
		-1,
		-1,
		-1,
		296,
		292,
		293,
		-1,
		-1,
		-1,
		-1,
		356,
		357,
		380,
		344,
		-1,
		-1,
		-1,
		288,
		282,
		-1,
		-1,
		359,
		357,
		-1,
		-1,
		-1,
		316,
		300,
		-1,
		286,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		321,
		-1,
		321,
		296,
		303,
		-1,
		-1,
		-1,
		-1,
		334,
		326,
		334,
		-1,
		306,
		308,
		-1,
		356,
		-1,
		-1,
		349,
		340,
		-1,
		-1,
		311,
		318,
		340,
		343,
		379,
		-1,
		330
	],
	[
		-1,
		165,
		154,
		165,
		173,
		146,
		153,
		-1,
		174,
		176,
		142,
		136,
		175,
		146,
		152,
		163,
		-1,
		-1,
		-1,
		165,
		164,
		134,
		132,
		141,
		146,
		153,
		-1,
		176,
		-1,
		186,
		165,
		176,
		181,
		127,
		124,
		144,
		163,
		169,
		161,
		201,
		157,
		128,
		122,
		140,
		145,
		163,
		155,
		-1,
		128,
		118,
		140,
		144,
		156,
		139,
		-1,
		-1,
		122,
		123,
		129,
		141,
		146,
		151,
		-1,
		177,
		196,
		-1,
		-1,
		112,
		125,
		121,
		124,
		132,
		148,
		169,
		186,
		191,
		-1,
		-1,
		113,
		117,
		130,
		131,
		129,
		156,
		175,
		186,
		200,
		199,
		-1,
		101,
		119,
		128,
		137,
		143,
		132,
		136,
		154,
		185,
		191,
		194,
		-1,
		93,
		95,
		124,
		130,
		142,
		148,
		135,
		141,
		160,
		173,
		192,
		183,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		90,
		98,
		124,
		123,
		119,
		137,
		159,
		138,
		144,
		148,
		165,
		181,
		182,
		192,
		-1,
		-1,
		146,
		115,
		150,
		107,
		92,
		-1,
		86,
		105,
		111,
		115,
		120,
		128,
		156,
		154,
		-1,
		159,
		158,
		189,
		175,
		186,
		106,
		-1,
		-1,
		104,
		96,
		81,
		84,
		81,
		81,
		111,
		110,
		115,
		117,
		119,
		131,
		146,
		146,
		156,
		153,
		163,
		167,
		182,
		193,
		-1,
		-1,
		260,
		-1,
		-1,
		103,
		86,
		-1,
		69,
		76,
		76,
		93,
		83,
		104,
		119,
		123,
		131,
		134,
		122,
		141,
		138,
		162,
		158,
		150,
		175,
		179,
		185,
		203,
		201,
		-1,
		259,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		62,
		65,
		71,
		95,
		105,
		-1,
		126,
		124,
		148,
		142,
		147,
		143,
		128,
		146,
		144,
		159,
		161,
		157,
		159,
		196,
		182,
		204,
		201,
		230,
		235,
		229,
		238,
		-1,
		111,
		107,
		103,
		110,
		59,
		-1,
		-1,
		99,
		-1,
		113,
		126,
		138,
		128,
		131,
		143,
		151,
		150,
		134,
		152,
		147,
		150,
		162,
		165,
		174,
		177,
		176,
		194,
		209,
		222,
		226,
		232,
		-1,
		161,
		-1,
		103,
		87,
		89,
		61,
		82,
		-1,
		119,
		114,
		134,
		140,
		140,
		-1,
		156,
		153,
		166,
		150,
		135,
		152,
		154,
		156,
		161,
		166,
		180,
		171,
		189,
		196,
		204,
		208,
		228,
		240,
		121,
		111,
		-1,
		93,
		98,
		57,
		64,
		79,
		157,
		141,
		-1,
		151,
		-1,
		158,
		171,
		-1,
		156,
		152,
		141,
		149,
		144,
		159,
		165,
		162,
		159,
		177,
		180,
		197,
		201,
		217,
		-1,
		-1,
		106,
		110,
		83,
		50,
		61,
		85,
		122,
		150,
		158,
		157,
		-1,
		151,
		177,
		174,
		164,
		151,
		141,
		142,
		150,
		163,
		142,
		161,
		164,
		186,
		214,
		192,
		204,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		60,
		47,
		63,
		105,
		187,
		180,
		168,
		136,
		136,
		130,
		-1,
		171,
		154,
		150,
		139,
		137,
		150,
		145,
		161,
		165,
		164,
		183,
		195,
		186,
		206,
		-1,
		-1,
		-1,
		89,
		78,
		79,
		50,
		84,
		94,
		169,
		155,
		160,
		135,
		128,
		122,
		174,
		171,
		138,
		146,
		138,
		127,
		141,
		149,
		153,
		162,
		171,
		177,
		201,
		201,
		207,
		-1,
		-1,
		69,
		59,
		43,
		34,
		0,
		75,
		82,
		114,
		160,
		157,
		-1,
		127,
		-1,
		116,
		124,
		123,
		129,
		141,
		127,
		132,
		143,
		155,
		168,
		164,
		171,
		206,
		206,
		191,
		211,
		214,
		-1,
		-1,
		-1,
		62,
		123,
		98,
		75,
		56,
		92,
		-1,
		127,
		128,
		-1,
		121,
		115,
		121,
		120,
		127,
		124,
		124,
		138,
		146,
		142,
		158,
		164,
		156,
		192,
		-1,
		199,
		193,
		201,
		191,
		179,
		-1,
		-1,
		-1,
		121,
		100,
		93,
		113,
		63,
		115,
		-1,
		-1,
		112,
		105,
		-1,
		108,
		108,
		115,
		124,
		129,
		134,
		142,
		137,
		150,
		155,
		161,
		166,
		184,
		188,
		192,
		181,
		177,
		174,
		188,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		83,
		-1,
		120,
		112,
		103,
		97,
		103,
		121,
		119,
		139,
		131,
		145,
		145,
		151,
		159,
		144,
		147,
		163,
		161,
		179,
		187,
		179,
		173,
		172,
		184,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		98,
		-1,
		69,
		93,
		109,
		-1,
		137,
		116,
		139,
		117,
		131,
		127,
		165,
		166,
		144,
		149,
		157,
		167,
		169,
		158,
		169,
		161,
		183,
		183,
		167,
		168,
		177,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		72,
		85,
		96,
		-1,
		-1,
		181,
		-1,
		115,
		132,
		141,
		139,
		155,
		146,
		152,
		168,
		171,
		173,
		163,
		152,
		158,
		155,
		177,
		163,
		161,
		180,
		196,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		159,
		149,
		133,
		118,
		151,
		-1,
		163,
		147,
		152,
		-1,
		198,
		-1,
		171,
		173,
		167,
		152,
		149,
		160,
		158,
		169,
		186,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		129,
		-1,
		-1,
		146,
		140,
		140,
		124,
		127,
		179,
		159,
		153,
		152,
		193,
		193,
		179,
		165,
		158,
		155,
		152,
		165,
		185,
		176,
		188,
		-1,
		-1,
		-1,
		130,
		110,
		116,
		74,
		95,
		-1,
		-1,
		208,
		163,
		149,
		-1,
		133,
		196,
		184,
		174,
		164,
		198,
		199,
		184,
		177,
		163,
		165,
		163,
		161,
		166,
		187,
		188,
		201,
		-1,
		-1,
		107,
		114,
		102,
		88,
		107,
		-1,
		-1,
		-1,
		155,
		171,
		163,
		134,
		185,
		-1,
		-1,
		176,
		174,
		184,
		180,
		167,
		187,
		190,
		176,
		160,
		175,
		187,
		195,
		200,
		-1,
		110,
		97,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		166,
		187,
		212,
		179,
		-1,
		184,
		185,
		171,
		185,
		192,
		178,
		173,
		167,
		170,
		188,
		205,
		-1,
		-1,
		124,
		-1,
		119,
		-1,
		-1,
		-1,
		-1,
		145,
		159,
		180,
		186,
		198,
		-1,
		193,
		187,
		173,
		190,
		191,
		188,
		179,
		171,
		176,
		173,
		186,
		200,
		204,
		147,
		-1,
		130,
		-1,
		-1,
		-1,
		163,
		178,
		240,
		217,
		190,
		194,
		187,
		181,
		181,
		197,
		199,
		210,
		178,
		174,
		175,
		179,
		178,
		195,
		205,
		-1,
		-1,
		130,
		147,
		182,
		171,
		175,
		267,
		-1,
		-1,
		203,
		194,
		185,
		188,
		191,
		194,
		184,
		181,
		186,
		191,
		179,
		188,
		206,
		210,
		-1,
		-1,
		-1,
		150,
		-1,
		165,
		-1,
		-1,
		190,
		274,
		221,
		203,
		199,
		197,
		190,
		199,
		194,
		189,
		199,
		208,
		200,
		181,
		192,
		215,
		204,
		242,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		179,
		154,
		169,
		215,
		210,
		211,
		236,
		233,
		-1,
		203,
		228,
		200,
		207,
		199,
		207,
		207,
		204,
		182,
		189,
		205,
		204,
		199,
		234,
		226,
		232,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		185,
		171,
		201,
		191,
		197,
		-1,
		-1,
		244,
		241,
		225,
		209,
		213,
		206,
		201,
		211,
		191,
		178,
		182,
		186,
		192,
		197,
		202,
		208,
		223,
		238,
		-1,
		155,
		236,
		229,
		212,
		220,
		251,
		-1,
		188,
		197,
		178,
		183,
		191,
		-1,
		-1,
		217,
		213,
		218,
		216,
		213,
		221,
		216,
		207,
		192,
		198,
		185,
		184,
		202,
		206,
		215,
		222,
		212,
		225,
		229,
		-1,
		169,
		212,
		206,
		209,
		233,
		247,
		-1,
		201,
		-1,
		-1,
		186,
		204,
		212,
		208,
		212,
		265,
		230,
		225,
		215,
		213,
		204,
		195,
		202,
		193,
		193,
		196,
		211,
		216,
		208,
		222,
		222,
		223,
		-1,
		204,
		192,
		200,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		202,
		-1,
		238,
		-1,
		231,
		235,
		238,
		241,
		229,
		216,
		208,
		200,
		216,
		191,
		201,
		197,
		198,
		207,
		218,
		230,
		229,
		230,
		278,
		233,
		200,
		191,
		238,
		253,
		257,
		-1,
		214,
		253,
		240,
		-1,
		211,
		-1,
		-1,
		-1,
		245,
		251,
		243,
		249,
		228,
		228,
		202,
		206,
		196,
		203,
		213,
		215,
		207,
		211,
		224,
		235,
		238,
		274,
		272,
		277,
		222,
		205,
		223,
		232,
		253,
		229,
		220,
		247,
		247,
		236,
		231,
		218,
		-1,
		-1,
		268,
		261,
		-1,
		-1,
		235,
		223,
		206,
		207,
		203,
		206,
		221,
		224,
		214,
		212,
		206,
		238,
		-1,
		274,
		273,
		262,
		259,
		235,
		226,
		213,
		224,
		-1,
		-1,
		232,
		248,
		261,
		265,
		278,
		303,
		-1,
		221,
		-1,
		-1,
		280,
		-1,
		-1,
		265,
		228,
		217,
		208,
		214,
		211,
		222,
		232,
		220,
		221,
		211,
		221,
		234,
		258,
		255,
		243,
		241,
		264,
		221,
		217,
		-1,
		247,
		235,
		241,
		248,
		265,
		292,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		263,
		261,
		250,
		-1,
		240,
		213,
		218,
		238,
		240,
		229,
		223,
		217,
		224,
		223,
		231,
		239,
		267,
		281,
		270,
		266,
		265,
		273,
		222,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		-1,
		272,
		247,
		-1,
		-1,
		258,
		251,
		239,
		227,
		217,
		227,
		231,
		235,
		227,
		220,
		215,
		226,
		218,
		222,
		239,
		-1,
		301,
		-1,
		253,
		246,
		261,
		276,
		284,
		-1,
		-1,
		-1,
		289,
		275,
		268,
		256,
		254,
		-1,
		292,
		276,
		257,
		-1,
		227,
		240,
		271,
		239,
		244,
		239,
		221,
		232,
		221,
		224,
		238,
		233,
		-1,
		-1,
		259,
		262,
		-1,
		-1,
		284,
		303,
		-1,
		280,
		269,
		254,
		246,
		-1,
		-1,
		264,
		260,
		-1,
		-1,
		228,
		253,
		242,
		250,
		245,
		225,
		231,
		234,
		223,
		227,
		239,
		-1,
		-1,
		266,
		267,
		272,
		-1,
		293,
		-1,
		304,
		-1,
		249,
		265,
		267,
		-1,
		-1,
		-1,
		266,
		229,
		250,
		260,
		254,
		252,
		243,
		229,
		236,
		234,
		230,
		241,
		-1,
		-1,
		-1,
		311,
		285,
		311,
		302,
		285,
		265,
		257,
		282,
		-1,
		253,
		-1,
		228,
		230,
		256,
		259,
		265,
		259,
		232,
		247,
		237,
		228,
		237,
		317,
		-1,
		287,
		320,
		284,
		271,
		254,
		258,
		274,
		-1,
		250,
		232,
		-1,
		260,
		250,
		281,
		266,
		247,
		234,
		241,
		241,
		234,
		-1,
		-1,
		-1,
		289,
		288,
		280,
		274,
		274,
		259,
		250,
		-1,
		262,
		244,
		223,
		240,
		240,
		231,
		239,
		271,
		267,
		254,
		254,
		246,
		-1,
		373,
		-1,
		-1,
		312,
		-1,
		-1,
		-1,
		283,
		278,
		251,
		239,
		245,
		241,
		227,
		233,
		235,
		243,
		241,
		238,
		250,
		246,
		266,
		247,
		282,
		-1,
		380,
		-1,
		319,
		-1,
		-1,
		301,
		281,
		273,
		262,
		251,
		249,
		240,
		231,
		253,
		269,
		253,
		251,
		254,
		255,
		-1,
		374,
		373,
		-1,
		320,
		312,
		298,
		-1,
		291,
		-1,
		297,
		258,
		-1,
		260,
		240,
		-1,
		262,
		258,
		-1,
		-1,
		361,
		336,
		-1,
		-1,
		-1,
		321,
		301,
		292,
		276,
		-1,
		251,
		251,
		-1,
		-1,
		-1,
		346,
		345,
		-1,
		314,
		317,
		-1,
		307,
		298,
		306,
		253,
		257,
		-1,
		-1,
		-1,
		355,
		336,
		330,
		329,
		327,
		322,
		319,
		305,
		289,
		267,
		256,
		277,
		-1,
		-1,
		-1,
		327,
		319,
		312,
		-1,
		-1,
		314,
		297,
		278,
		276,
		-1,
		-1,
		-1,
		349,
		330,
		-1,
		-1,
		304,
		-1,
		-1,
		310,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		366,
		338,
		-1,
		-1,
		-1,
		300,
		296,
		297,
		-1,
		-1,
		-1,
		-1,
		360,
		361,
		384,
		348,
		-1,
		-1,
		-1,
		292,
		286,
		-1,
		-1,
		363,
		361,
		-1,
		-1,
		-1,
		320,
		304,
		-1,
		290,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		323,
		-1,
		-1,
		-1,
		325,
		-1,
		325,
		300,
		307,
		-1,
		-1,
		-1,
		-1,
		338,
		330,
		338,
		-1,
		310,
		312,
		-1,
		360,
		-1,
		-1,
		353,
		344,
		-1,
		-1,
		315,
		322,
		344,
		347,
		383,
		-1,
		334
	],
	[
		-1,
		141,
		130,
		141,
		149,
		122,
		129,
		-1,
		150,
		152,
		118,
		112,
		151,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		141,
		140,
		110,
		108,
		117,
		122,
		129,
		-1,
		152,
		-1,
		162,
		141,
		152,
		157,
		103,
		100,
		120,
		139,
		145,
		137,
		177,
		133,
		104,
		98,
		116,
		121,
		139,
		131,
		-1,
		104,
		94,
		116,
		120,
		132,
		115,
		-1,
		-1,
		98,
		99,
		105,
		117,
		122,
		127,
		-1,
		153,
		165,
		-1,
		-1,
		88,
		101,
		97,
		100,
		108,
		124,
		145,
		162,
		160,
		-1,
		-1,
		89,
		93,
		106,
		107,
		105,
		132,
		151,
		155,
		169,
		168,
		-1,
		77,
		95,
		104,
		113,
		119,
		108,
		112,
		130,
		154,
		160,
		163,
		-1,
		69,
		71,
		100,
		106,
		118,
		124,
		111,
		117,
		136,
		142,
		161,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		66,
		74,
		100,
		99,
		95,
		113,
		135,
		114,
		120,
		124,
		134,
		150,
		151,
		161,
		-1,
		-1,
		122,
		91,
		126,
		83,
		68,
		-1,
		62,
		81,
		87,
		91,
		96,
		104,
		132,
		130,
		-1,
		128,
		127,
		158,
		144,
		155,
		82,
		-1,
		-1,
		80,
		72,
		57,
		60,
		57,
		57,
		87,
		86,
		91,
		93,
		95,
		107,
		122,
		122,
		132,
		122,
		132,
		136,
		147,
		162,
		-1,
		-1,
		217,
		-1,
		-1,
		79,
		62,
		-1,
		45,
		52,
		52,
		69,
		59,
		80,
		95,
		99,
		107,
		110,
		98,
		117,
		114,
		137,
		125,
		119,
		144,
		148,
		142,
		163,
		158,
		-1,
		216,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		38,
		41,
		47,
		71,
		81,
		-1,
		102,
		100,
		124,
		118,
		123,
		119,
		104,
		122,
		116,
		123,
		122,
		126,
		128,
		161,
		139,
		161,
		158,
		187,
		192,
		186,
		195,
		-1,
		87,
		83,
		79,
		86,
		35,
		-1,
		-1,
		75,
		-1,
		89,
		102,
		114,
		104,
		107,
		119,
		127,
		125,
		110,
		125,
		114,
		111,
		119,
		128,
		139,
		134,
		133,
		151,
		166,
		179,
		183,
		189,
		-1,
		137,
		-1,
		79,
		63,
		65,
		37,
		58,
		-1,
		95,
		90,
		110,
		116,
		116,
		-1,
		132,
		129,
		142,
		121,
		106,
		123,
		115,
		113,
		118,
		123,
		137,
		128,
		146,
		153,
		161,
		165,
		185,
		197,
		97,
		87,
		-1,
		69,
		74,
		33,
		41,
		60,
		133,
		117,
		-1,
		127,
		-1,
		123,
		147,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		122,
		119,
		116,
		134,
		137,
		154,
		158,
		174,
		-1,
		-1,
		82,
		86,
		75,
		26,
		45,
		69,
		106,
		126,
		118,
		117,
		-1,
		108,
		138,
		135,
		121,
		108,
		98,
		99,
		107,
		120,
		99,
		118,
		121,
		143,
		171,
		149,
		161,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		52,
		23,
		47,
		89,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		128,
		111,
		107,
		96,
		94,
		107,
		102,
		118,
		122,
		121,
		140,
		152,
		143,
		163,
		-1,
		-1,
		-1,
		82,
		71,
		72,
		18,
		34,
		72,
		126,
		112,
		117,
		92,
		85,
		79,
		131,
		128,
		95,
		103,
		95,
		84,
		98,
		106,
		110,
		119,
		128,
		134,
		158,
		158,
		164,
		-1,
		-1,
		89,
		79,
		63,
		65,
		62,
		0,
		36,
		68,
		117,
		114,
		-1,
		84,
		-1,
		73,
		81,
		80,
		86,
		98,
		84,
		89,
		100,
		112,
		125,
		121,
		128,
		163,
		163,
		148,
		168,
		171,
		-1,
		-1,
		-1,
		82,
		73,
		48,
		25,
		13,
		46,
		-1,
		84,
		85,
		-1,
		78,
		72,
		78,
		77,
		84,
		81,
		81,
		95,
		103,
		99,
		115,
		121,
		113,
		149,
		-1,
		156,
		150,
		158,
		148,
		136,
		-1,
		-1,
		-1,
		71,
		50,
		43,
		63,
		20,
		72,
		-1,
		-1,
		69,
		62,
		-1,
		65,
		65,
		72,
		81,
		86,
		91,
		99,
		94,
		107,
		112,
		118,
		123,
		141,
		145,
		149,
		138,
		134,
		131,
		145,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		23,
		40,
		-1,
		77,
		69,
		60,
		54,
		60,
		78,
		76,
		96,
		88,
		102,
		102,
		108,
		116,
		101,
		104,
		120,
		118,
		136,
		144,
		136,
		130,
		129,
		141,
		-1,
		126,
		112,
		83,
		-1,
		-1,
		55,
		-1,
		26,
		50,
		66,
		-1,
		94,
		73,
		96,
		74,
		88,
		84,
		122,
		123,
		101,
		106,
		114,
		124,
		126,
		115,
		126,
		118,
		140,
		140,
		124,
		125,
		134,
		-1,
		132,
		119,
		77,
		73,
		62,
		82,
		29,
		42,
		53,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		98,
		96,
		112,
		103,
		109,
		125,
		128,
		130,
		120,
		109,
		115,
		112,
		134,
		120,
		118,
		137,
		153,
		-1,
		-1,
		-1,
		99,
		-1,
		-1,
		48,
		35,
		29,
		-1,
		70,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		120,
		104,
		109,
		-1,
		155,
		-1,
		128,
		130,
		124,
		109,
		106,
		117,
		115,
		126,
		143,
		-1,
		82,
		67,
		60,
		50,
		64,
		35,
		-1,
		90,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		136,
		116,
		110,
		109,
		150,
		150,
		136,
		122,
		115,
		112,
		109,
		122,
		142,
		133,
		145,
		-1,
		-1,
		-1,
		87,
		73,
		77,
		37,
		56,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		153,
		141,
		131,
		121,
		155,
		156,
		141,
		134,
		120,
		122,
		120,
		118,
		123,
		144,
		145,
		158,
		-1,
		-1,
		70,
		75,
		63,
		49,
		68,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		142,
		-1,
		-1,
		133,
		131,
		141,
		137,
		124,
		144,
		147,
		133,
		117,
		132,
		144,
		152,
		157,
		-1,
		73,
		60,
		-1,
		-1,
		71,
		65,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		123,
		144,
		169,
		136,
		-1,
		141,
		142,
		128,
		142,
		149,
		135,
		130,
		124,
		127,
		145,
		162,
		-1,
		-1,
		85,
		-1,
		80,
		-1,
		-1,
		-1,
		-1,
		102,
		116,
		137,
		143,
		155,
		-1,
		150,
		144,
		130,
		147,
		148,
		145,
		136,
		128,
		133,
		130,
		143,
		157,
		161,
		108,
		-1,
		91,
		-1,
		-1,
		-1,
		120,
		135,
		197,
		174,
		147,
		151,
		144,
		138,
		138,
		154,
		156,
		167,
		135,
		131,
		132,
		136,
		135,
		152,
		162,
		-1,
		-1,
		91,
		108,
		143,
		128,
		132,
		224,
		-1,
		-1,
		160,
		151,
		142,
		145,
		148,
		151,
		141,
		138,
		143,
		148,
		136,
		145,
		163,
		167,
		-1,
		-1,
		-1,
		111,
		-1,
		126,
		-1,
		-1,
		147,
		231,
		178,
		160,
		156,
		154,
		147,
		156,
		151,
		146,
		156,
		165,
		157,
		138,
		149,
		172,
		161,
		199,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		140,
		115,
		130,
		176,
		167,
		172,
		193,
		190,
		-1,
		160,
		185,
		157,
		164,
		156,
		164,
		164,
		161,
		139,
		146,
		162,
		161,
		156,
		191,
		183,
		189,
		-1,
		-1,
		223,
		212,
		201,
		207,
		-1,
		146,
		132,
		162,
		152,
		158,
		-1,
		-1,
		205,
		202,
		182,
		166,
		170,
		163,
		158,
		168,
		148,
		135,
		139,
		143,
		149,
		154,
		159,
		165,
		180,
		195,
		-1,
		118,
		199,
		192,
		175,
		183,
		214,
		-1,
		149,
		158,
		139,
		144,
		152,
		-1,
		-1,
		178,
		174,
		179,
		173,
		170,
		178,
		173,
		164,
		149,
		155,
		142,
		141,
		159,
		163,
		172,
		179,
		169,
		182,
		186,
		-1,
		132,
		175,
		169,
		172,
		196,
		210,
		-1,
		162,
		-1,
		-1,
		147,
		165,
		173,
		169,
		173,
		226,
		187,
		182,
		172,
		170,
		161,
		152,
		159,
		150,
		150,
		153,
		168,
		173,
		165,
		179,
		179,
		180,
		-1,
		167,
		155,
		163,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		163,
		-1,
		199,
		-1,
		192,
		196,
		195,
		198,
		186,
		173,
		165,
		157,
		173,
		148,
		158,
		154,
		155,
		164,
		175,
		187,
		186,
		187,
		241,
		196,
		163,
		154,
		201,
		216,
		220,
		-1,
		175,
		214,
		201,
		-1,
		172,
		-1,
		-1,
		-1,
		206,
		208,
		200,
		206,
		185,
		185,
		159,
		163,
		153,
		160,
		170,
		172,
		164,
		168,
		181,
		192,
		195,
		237,
		235,
		240,
		185,
		168,
		186,
		195,
		216,
		190,
		181,
		208,
		208,
		197,
		192,
		179,
		-1,
		-1,
		229,
		218,
		-1,
		-1,
		192,
		180,
		163,
		164,
		160,
		163,
		178,
		181,
		171,
		169,
		163,
		195,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		176,
		187,
		-1,
		-1,
		193,
		209,
		222,
		226,
		239,
		264,
		-1,
		182,
		-1,
		-1,
		237,
		-1,
		-1,
		222,
		185,
		174,
		165,
		171,
		168,
		179,
		189,
		177,
		178,
		168,
		178,
		191,
		221,
		218,
		206,
		204,
		227,
		184,
		180,
		-1,
		208,
		196,
		202,
		209,
		226,
		253,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		220,
		218,
		207,
		-1,
		197,
		170,
		175,
		195,
		197,
		186,
		180,
		174,
		181,
		180,
		188,
		196,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		202,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		-1,
		233,
		208,
		-1,
		-1,
		215,
		208,
		196,
		184,
		174,
		184,
		188,
		192,
		184,
		177,
		172,
		183,
		175,
		179,
		196,
		-1,
		264,
		-1,
		216,
		209,
		224,
		239,
		247,
		-1,
		-1,
		-1,
		250,
		236,
		229,
		217,
		215,
		-1,
		249,
		233,
		214,
		-1,
		184,
		197,
		228,
		196,
		201,
		196,
		178,
		189,
		178,
		181,
		195,
		190,
		-1,
		-1,
		222,
		225,
		-1,
		-1,
		247,
		266,
		-1,
		241,
		230,
		215,
		207,
		-1,
		-1,
		221,
		217,
		-1,
		-1,
		185,
		210,
		199,
		207,
		202,
		182,
		188,
		191,
		180,
		184,
		196,
		-1,
		-1,
		229,
		230,
		235,
		-1,
		250,
		-1,
		265,
		-1,
		210,
		226,
		228,
		-1,
		-1,
		-1,
		223,
		186,
		207,
		217,
		211,
		209,
		200,
		186,
		193,
		191,
		187,
		198,
		-1,
		-1,
		-1,
		268,
		242,
		272,
		263,
		246,
		226,
		218,
		240,
		-1,
		210,
		-1,
		185,
		187,
		213,
		216,
		222,
		216,
		189,
		204,
		194,
		185,
		194,
		274,
		-1,
		244,
		277,
		241,
		232,
		211,
		215,
		231,
		-1,
		207,
		189,
		-1,
		217,
		207,
		238,
		223,
		204,
		191,
		198,
		198,
		191,
		-1,
		-1,
		-1,
		246,
		245,
		237,
		231,
		231,
		216,
		207,
		-1,
		219,
		201,
		180,
		197,
		197,
		188,
		196,
		228,
		224,
		211,
		211,
		203,
		-1,
		336,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		240,
		235,
		208,
		196,
		202,
		198,
		184,
		190,
		192,
		200,
		198,
		195,
		207,
		203,
		223,
		204,
		239,
		-1,
		342,
		-1,
		276,
		-1,
		-1,
		258,
		238,
		230,
		219,
		208,
		206,
		197,
		188,
		210,
		226,
		210,
		208,
		211,
		212,
		-1,
		331,
		330,
		-1,
		277,
		269,
		255,
		-1,
		248,
		-1,
		254,
		215,
		-1,
		217,
		197,
		-1,
		219,
		215,
		-1,
		-1,
		318,
		293,
		-1,
		-1,
		-1,
		278,
		258,
		249,
		233,
		-1,
		208,
		208,
		-1,
		-1,
		-1,
		303,
		302,
		-1,
		271,
		274,
		-1,
		264,
		255,
		263,
		210,
		214,
		-1,
		-1,
		-1,
		312,
		293,
		287,
		286,
		284,
		279,
		276,
		262,
		246,
		224,
		213,
		234,
		-1,
		-1,
		-1,
		284,
		276,
		269,
		-1,
		-1,
		271,
		254,
		235,
		233,
		-1,
		-1,
		-1,
		306,
		287,
		-1,
		-1,
		261,
		-1,
		-1,
		267,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		323,
		295,
		-1,
		-1,
		-1,
		257,
		253,
		254,
		-1,
		-1,
		-1,
		-1,
		317,
		318,
		341,
		305,
		-1,
		-1,
		-1,
		249,
		243,
		-1,
		-1,
		320,
		318,
		-1,
		-1,
		-1,
		277,
		261,
		-1,
		247,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		282,
		-1,
		282,
		257,
		264,
		-1,
		-1,
		-1,
		-1,
		295,
		287,
		295,
		-1,
		267,
		269,
		-1,
		317,
		-1,
		-1,
		310,
		301,
		-1,
		-1,
		272,
		279,
		301,
		304,
		340,
		-1,
		291
	],
	[
		-1,
		155,
		144,
		155,
		163,
		136,
		143,
		-1,
		164,
		166,
		132,
		126,
		165,
		136,
		142,
		153,
		-1,
		-1,
		-1,
		155,
		154,
		124,
		122,
		131,
		136,
		143,
		-1,
		166,
		-1,
		176,
		155,
		166,
		171,
		117,
		114,
		134,
		153,
		159,
		151,
		191,
		147,
		118,
		112,
		130,
		135,
		153,
		145,
		-1,
		118,
		108,
		130,
		134,
		146,
		129,
		-1,
		-1,
		112,
		113,
		119,
		131,
		136,
		141,
		-1,
		167,
		179,
		-1,
		-1,
		102,
		115,
		111,
		114,
		122,
		138,
		159,
		176,
		174,
		-1,
		-1,
		103,
		107,
		120,
		121,
		119,
		146,
		165,
		169,
		183,
		182,
		-1,
		91,
		109,
		118,
		127,
		133,
		122,
		126,
		144,
		168,
		174,
		177,
		-1,
		83,
		85,
		114,
		120,
		132,
		138,
		125,
		131,
		150,
		156,
		175,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		80,
		88,
		114,
		113,
		109,
		127,
		149,
		128,
		134,
		138,
		148,
		164,
		165,
		175,
		-1,
		-1,
		136,
		105,
		140,
		97,
		82,
		-1,
		76,
		95,
		101,
		105,
		110,
		118,
		146,
		144,
		-1,
		142,
		141,
		172,
		158,
		169,
		96,
		-1,
		-1,
		94,
		86,
		71,
		74,
		71,
		71,
		101,
		100,
		105,
		107,
		109,
		121,
		136,
		136,
		146,
		136,
		146,
		150,
		161,
		176,
		-1,
		-1,
		231,
		-1,
		-1,
		93,
		76,
		-1,
		59,
		66,
		66,
		83,
		73,
		94,
		109,
		113,
		121,
		124,
		112,
		131,
		128,
		151,
		139,
		133,
		158,
		162,
		156,
		177,
		172,
		-1,
		230,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		52,
		55,
		61,
		85,
		95,
		-1,
		116,
		114,
		138,
		132,
		137,
		133,
		118,
		136,
		130,
		137,
		136,
		140,
		142,
		175,
		153,
		175,
		172,
		201,
		206,
		200,
		209,
		-1,
		101,
		97,
		93,
		100,
		49,
		-1,
		-1,
		89,
		-1,
		103,
		116,
		128,
		118,
		121,
		133,
		141,
		139,
		124,
		139,
		128,
		125,
		133,
		142,
		153,
		148,
		147,
		165,
		180,
		193,
		197,
		203,
		-1,
		151,
		-1,
		93,
		77,
		79,
		51,
		72,
		-1,
		109,
		104,
		124,
		130,
		130,
		-1,
		146,
		143,
		156,
		135,
		120,
		137,
		129,
		127,
		132,
		137,
		151,
		142,
		160,
		167,
		175,
		179,
		199,
		211,
		111,
		101,
		-1,
		83,
		88,
		47,
		55,
		74,
		147,
		131,
		-1,
		141,
		-1,
		137,
		161,
		-1,
		141,
		137,
		119,
		120,
		115,
		130,
		136,
		133,
		130,
		148,
		151,
		168,
		172,
		188,
		-1,
		-1,
		96,
		100,
		89,
		40,
		50,
		74,
		111,
		140,
		132,
		131,
		-1,
		122,
		152,
		149,
		135,
		122,
		112,
		113,
		121,
		134,
		113,
		132,
		135,
		157,
		185,
		163,
		175,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		66,
		37,
		52,
		94,
		161,
		154,
		142,
		107,
		107,
		101,
		-1,
		142,
		125,
		121,
		110,
		108,
		121,
		116,
		132,
		136,
		135,
		154,
		166,
		157,
		177,
		-1,
		-1,
		-1,
		96,
		85,
		86,
		32,
		15,
		65,
		140,
		126,
		131,
		106,
		99,
		93,
		145,
		142,
		109,
		117,
		109,
		98,
		112,
		120,
		124,
		133,
		142,
		148,
		172,
		172,
		178,
		-1,
		-1,
		103,
		93,
		77,
		79,
		76,
		43,
		0,
		49,
		131,
		128,
		-1,
		98,
		-1,
		87,
		95,
		94,
		100,
		112,
		98,
		103,
		114,
		126,
		139,
		135,
		142,
		177,
		177,
		162,
		182,
		185,
		-1,
		-1,
		-1,
		96,
		89,
		64,
		41,
		27,
		23,
		-1,
		98,
		99,
		-1,
		92,
		86,
		92,
		91,
		98,
		95,
		95,
		109,
		117,
		113,
		129,
		135,
		127,
		163,
		-1,
		170,
		164,
		172,
		162,
		150,
		-1,
		-1,
		-1,
		87,
		66,
		59,
		79,
		34,
		86,
		-1,
		-1,
		83,
		76,
		-1,
		79,
		79,
		86,
		95,
		100,
		105,
		113,
		108,
		121,
		126,
		132,
		137,
		155,
		159,
		163,
		152,
		148,
		145,
		159,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		37,
		54,
		-1,
		91,
		83,
		74,
		68,
		74,
		92,
		90,
		110,
		102,
		116,
		116,
		122,
		130,
		115,
		118,
		134,
		132,
		150,
		158,
		150,
		144,
		143,
		155,
		-1,
		140,
		126,
		97,
		-1,
		-1,
		69,
		-1,
		40,
		64,
		80,
		-1,
		108,
		87,
		110,
		88,
		102,
		98,
		136,
		137,
		115,
		120,
		128,
		138,
		140,
		129,
		140,
		132,
		154,
		154,
		138,
		139,
		148,
		-1,
		146,
		133,
		91,
		87,
		76,
		96,
		43,
		56,
		67,
		-1,
		-1,
		152,
		-1,
		86,
		103,
		112,
		110,
		126,
		117,
		123,
		139,
		142,
		144,
		134,
		123,
		129,
		126,
		148,
		134,
		132,
		151,
		167,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		62,
		49,
		43,
		-1,
		84,
		-1,
		130,
		120,
		104,
		89,
		122,
		-1,
		134,
		118,
		123,
		-1,
		169,
		-1,
		142,
		144,
		138,
		123,
		120,
		131,
		129,
		140,
		157,
		-1,
		96,
		81,
		74,
		64,
		78,
		49,
		-1,
		104,
		-1,
		-1,
		117,
		111,
		111,
		95,
		98,
		150,
		130,
		124,
		123,
		164,
		164,
		150,
		136,
		129,
		126,
		123,
		136,
		156,
		147,
		159,
		-1,
		-1,
		-1,
		101,
		87,
		91,
		51,
		70,
		-1,
		-1,
		179,
		134,
		120,
		-1,
		104,
		167,
		155,
		145,
		135,
		169,
		170,
		155,
		148,
		134,
		136,
		134,
		132,
		137,
		158,
		159,
		172,
		-1,
		-1,
		84,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		126,
		142,
		134,
		105,
		156,
		-1,
		-1,
		147,
		145,
		155,
		151,
		138,
		158,
		161,
		147,
		131,
		146,
		158,
		166,
		171,
		-1,
		87,
		74,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		137,
		158,
		183,
		150,
		-1,
		155,
		156,
		142,
		156,
		163,
		149,
		144,
		138,
		141,
		159,
		176,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		116,
		130,
		151,
		157,
		169,
		-1,
		164,
		158,
		144,
		161,
		162,
		159,
		150,
		142,
		147,
		144,
		157,
		171,
		175,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		134,
		149,
		211,
		188,
		161,
		165,
		158,
		152,
		152,
		168,
		170,
		181,
		149,
		145,
		146,
		150,
		149,
		166,
		176,
		-1,
		-1,
		105,
		122,
		157,
		142,
		146,
		238,
		-1,
		-1,
		174,
		165,
		156,
		159,
		162,
		165,
		155,
		152,
		157,
		162,
		150,
		159,
		177,
		181,
		-1,
		-1,
		-1,
		125,
		-1,
		140,
		-1,
		-1,
		161,
		245,
		192,
		174,
		170,
		168,
		161,
		170,
		165,
		160,
		170,
		179,
		171,
		152,
		163,
		186,
		175,
		213,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		154,
		129,
		144,
		190,
		181,
		186,
		207,
		204,
		-1,
		174,
		199,
		171,
		178,
		170,
		178,
		178,
		175,
		153,
		160,
		176,
		175,
		170,
		205,
		197,
		203,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		160,
		146,
		176,
		166,
		172,
		-1,
		-1,
		219,
		216,
		196,
		180,
		184,
		177,
		172,
		182,
		162,
		149,
		153,
		157,
		163,
		168,
		173,
		179,
		194,
		209,
		-1,
		132,
		213,
		206,
		189,
		197,
		228,
		-1,
		163,
		172,
		153,
		158,
		166,
		-1,
		-1,
		192,
		188,
		193,
		187,
		184,
		192,
		187,
		178,
		163,
		169,
		156,
		155,
		173,
		177,
		186,
		193,
		183,
		196,
		200,
		-1,
		146,
		189,
		183,
		186,
		210,
		224,
		-1,
		176,
		-1,
		-1,
		161,
		179,
		187,
		183,
		187,
		240,
		201,
		196,
		186,
		184,
		175,
		166,
		173,
		164,
		164,
		167,
		182,
		187,
		179,
		193,
		193,
		194,
		-1,
		181,
		169,
		177,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		177,
		-1,
		213,
		-1,
		206,
		210,
		209,
		212,
		200,
		187,
		179,
		171,
		187,
		162,
		172,
		168,
		169,
		178,
		189,
		201,
		200,
		201,
		255,
		210,
		177,
		168,
		215,
		230,
		234,
		-1,
		189,
		228,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		220,
		222,
		214,
		220,
		199,
		199,
		173,
		177,
		167,
		174,
		184,
		186,
		178,
		182,
		195,
		206,
		209,
		251,
		249,
		254,
		199,
		182,
		200,
		209,
		230,
		204,
		195,
		222,
		222,
		211,
		206,
		193,
		-1,
		-1,
		243,
		232,
		-1,
		-1,
		206,
		194,
		177,
		178,
		174,
		177,
		192,
		195,
		185,
		183,
		177,
		209,
		-1,
		251,
		250,
		239,
		236,
		212,
		203,
		190,
		201,
		-1,
		-1,
		207,
		223,
		236,
		240,
		253,
		278,
		-1,
		196,
		-1,
		-1,
		251,
		-1,
		-1,
		236,
		199,
		188,
		179,
		185,
		182,
		193,
		203,
		191,
		192,
		182,
		192,
		205,
		235,
		232,
		220,
		218,
		241,
		198,
		194,
		-1,
		222,
		210,
		216,
		223,
		240,
		267,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		234,
		232,
		221,
		-1,
		211,
		184,
		189,
		209,
		211,
		200,
		194,
		188,
		195,
		194,
		202,
		210,
		244,
		258,
		247,
		243,
		242,
		250,
		199,
		216,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		222,
		-1,
		-1,
		229,
		222,
		210,
		198,
		188,
		198,
		202,
		206,
		198,
		191,
		186,
		197,
		189,
		193,
		210,
		-1,
		278,
		-1,
		230,
		223,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		263,
		247,
		228,
		-1,
		198,
		211,
		242,
		210,
		215,
		210,
		192,
		203,
		192,
		195,
		209,
		204,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		261,
		280,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		235,
		231,
		-1,
		-1,
		199,
		224,
		213,
		221,
		216,
		196,
		202,
		205,
		194,
		198,
		210,
		-1,
		-1,
		243,
		244,
		249,
		-1,
		264,
		-1,
		279,
		-1,
		224,
		240,
		242,
		-1,
		-1,
		-1,
		237,
		200,
		221,
		231,
		225,
		223,
		214,
		200,
		207,
		205,
		201,
		212,
		-1,
		-1,
		-1,
		282,
		256,
		286,
		277,
		260,
		240,
		232,
		254,
		-1,
		224,
		-1,
		199,
		201,
		227,
		230,
		236,
		230,
		203,
		218,
		208,
		199,
		208,
		288,
		-1,
		258,
		291,
		255,
		246,
		225,
		229,
		245,
		-1,
		221,
		203,
		-1,
		231,
		221,
		252,
		237,
		218,
		205,
		212,
		212,
		205,
		-1,
		-1,
		-1,
		260,
		259,
		251,
		245,
		245,
		230,
		221,
		-1,
		233,
		215,
		194,
		211,
		211,
		202,
		210,
		242,
		238,
		225,
		225,
		217,
		-1,
		350,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		254,
		249,
		222,
		210,
		216,
		212,
		198,
		204,
		206,
		214,
		212,
		209,
		221,
		217,
		237,
		218,
		253,
		-1,
		356,
		-1,
		290,
		-1,
		-1,
		272,
		252,
		244,
		233,
		222,
		220,
		211,
		202,
		224,
		240,
		224,
		222,
		225,
		226,
		-1,
		345,
		344,
		-1,
		291,
		283,
		269,
		-1,
		262,
		-1,
		268,
		229,
		-1,
		231,
		211,
		-1,
		233,
		229,
		-1,
		-1,
		332,
		307,
		-1,
		-1,
		-1,
		292,
		272,
		263,
		247,
		-1,
		222,
		222,
		-1,
		-1,
		-1,
		317,
		316,
		-1,
		285,
		288,
		-1,
		278,
		269,
		277,
		224,
		228,
		-1,
		-1,
		-1,
		326,
		307,
		301,
		300,
		298,
		293,
		290,
		276,
		260,
		238,
		227,
		248,
		-1,
		-1,
		-1,
		298,
		290,
		283,
		-1,
		-1,
		285,
		268,
		249,
		247,
		-1,
		-1,
		-1,
		320,
		301,
		-1,
		-1,
		275,
		-1,
		-1,
		281,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		337,
		309,
		-1,
		-1,
		-1,
		271,
		267,
		268,
		-1,
		-1,
		-1,
		-1,
		331,
		332,
		355,
		319,
		-1,
		-1,
		-1,
		263,
		257,
		-1,
		-1,
		334,
		332,
		-1,
		-1,
		-1,
		291,
		275,
		-1,
		261,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		296,
		-1,
		296,
		271,
		278,
		-1,
		-1,
		-1,
		-1,
		309,
		301,
		309,
		-1,
		281,
		283,
		-1,
		331,
		-1,
		-1,
		324,
		315,
		-1,
		-1,
		286,
		293,
		315,
		318,
		354,
		-1,
		305
	],
	[
		-1,
		186,
		175,
		186,
		194,
		167,
		174,
		-1,
		195,
		197,
		163,
		157,
		196,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		186,
		185,
		155,
		153,
		162,
		167,
		174,
		-1,
		197,
		-1,
		207,
		186,
		197,
		202,
		148,
		145,
		165,
		184,
		190,
		182,
		222,
		178,
		149,
		143,
		161,
		166,
		184,
		176,
		-1,
		149,
		139,
		161,
		165,
		177,
		160,
		-1,
		-1,
		143,
		144,
		150,
		162,
		167,
		172,
		-1,
		198,
		210,
		-1,
		-1,
		133,
		146,
		142,
		145,
		153,
		169,
		190,
		207,
		205,
		-1,
		-1,
		134,
		138,
		151,
		152,
		150,
		177,
		196,
		200,
		214,
		213,
		-1,
		122,
		140,
		149,
		158,
		164,
		153,
		157,
		175,
		199,
		205,
		208,
		-1,
		114,
		116,
		145,
		151,
		163,
		169,
		156,
		162,
		181,
		187,
		206,
		197,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		111,
		119,
		145,
		144,
		140,
		158,
		180,
		159,
		165,
		169,
		179,
		195,
		196,
		206,
		-1,
		-1,
		167,
		136,
		171,
		128,
		113,
		-1,
		107,
		126,
		132,
		136,
		141,
		149,
		177,
		175,
		-1,
		173,
		172,
		203,
		189,
		200,
		127,
		-1,
		-1,
		125,
		117,
		102,
		105,
		102,
		102,
		132,
		131,
		136,
		138,
		140,
		152,
		167,
		167,
		177,
		167,
		177,
		181,
		192,
		207,
		-1,
		-1,
		262,
		-1,
		-1,
		124,
		107,
		-1,
		90,
		97,
		97,
		114,
		104,
		125,
		140,
		144,
		152,
		155,
		143,
		162,
		159,
		182,
		170,
		164,
		189,
		193,
		187,
		208,
		203,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		83,
		86,
		92,
		116,
		126,
		-1,
		147,
		145,
		169,
		163,
		168,
		164,
		149,
		167,
		161,
		168,
		167,
		171,
		173,
		206,
		184,
		206,
		203,
		232,
		237,
		231,
		240,
		-1,
		132,
		128,
		124,
		131,
		80,
		-1,
		-1,
		120,
		-1,
		134,
		147,
		159,
		149,
		152,
		164,
		172,
		170,
		155,
		170,
		159,
		156,
		164,
		173,
		184,
		179,
		178,
		196,
		211,
		224,
		228,
		234,
		-1,
		182,
		-1,
		124,
		108,
		110,
		82,
		103,
		-1,
		140,
		135,
		155,
		161,
		161,
		-1,
		177,
		174,
		187,
		166,
		151,
		168,
		160,
		158,
		163,
		168,
		182,
		173,
		191,
		198,
		206,
		210,
		230,
		242,
		142,
		132,
		-1,
		114,
		119,
		78,
		86,
		105,
		178,
		162,
		-1,
		172,
		-1,
		168,
		192,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		167,
		164,
		161,
		179,
		182,
		199,
		203,
		219,
		-1,
		-1,
		127,
		131,
		120,
		71,
		89,
		113,
		150,
		171,
		163,
		162,
		-1,
		153,
		183,
		180,
		166,
		153,
		143,
		144,
		152,
		165,
		144,
		163,
		166,
		188,
		216,
		194,
		206,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		97,
		68,
		91,
		133,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		173,
		156,
		152,
		141,
		139,
		152,
		147,
		163,
		167,
		166,
		185,
		197,
		188,
		208,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		63,
		54,
		104,
		171,
		157,
		162,
		137,
		130,
		124,
		176,
		173,
		140,
		148,
		140,
		129,
		143,
		151,
		155,
		164,
		173,
		179,
		203,
		203,
		209,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		74,
		48,
		0,
		162,
		159,
		-1,
		129,
		-1,
		118,
		126,
		125,
		131,
		143,
		129,
		134,
		145,
		157,
		170,
		166,
		173,
		208,
		208,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		127,
		120,
		95,
		72,
		58,
		58,
		-1,
		129,
		130,
		-1,
		123,
		117,
		123,
		122,
		129,
		126,
		126,
		140,
		148,
		144,
		160,
		166,
		158,
		194,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		118,
		97,
		90,
		110,
		65,
		117,
		-1,
		-1,
		114,
		107,
		-1,
		110,
		110,
		117,
		126,
		131,
		136,
		144,
		139,
		152,
		157,
		163,
		168,
		186,
		190,
		194,
		183,
		179,
		176,
		190,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		85,
		-1,
		122,
		114,
		105,
		99,
		105,
		123,
		121,
		141,
		133,
		147,
		147,
		153,
		161,
		146,
		149,
		165,
		163,
		181,
		189,
		181,
		175,
		174,
		186,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		100,
		-1,
		71,
		95,
		111,
		-1,
		139,
		118,
		141,
		119,
		133,
		129,
		167,
		168,
		146,
		151,
		159,
		169,
		171,
		160,
		171,
		163,
		185,
		185,
		169,
		170,
		179,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		74,
		87,
		98,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		143,
		141,
		157,
		148,
		154,
		170,
		173,
		175,
		165,
		154,
		160,
		157,
		179,
		165,
		163,
		182,
		198,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		115,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		165,
		149,
		154,
		-1,
		200,
		-1,
		173,
		175,
		169,
		154,
		151,
		162,
		160,
		171,
		188,
		-1,
		127,
		112,
		105,
		95,
		109,
		80,
		-1,
		135,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		181,
		161,
		155,
		154,
		195,
		195,
		181,
		167,
		160,
		157,
		154,
		167,
		187,
		178,
		190,
		-1,
		-1,
		-1,
		132,
		118,
		122,
		82,
		101,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		198,
		186,
		176,
		166,
		200,
		201,
		186,
		179,
		165,
		167,
		165,
		163,
		168,
		189,
		190,
		203,
		-1,
		-1,
		115,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		157,
		173,
		165,
		136,
		187,
		-1,
		-1,
		178,
		176,
		186,
		182,
		169,
		189,
		192,
		178,
		162,
		177,
		189,
		197,
		202,
		-1,
		118,
		105,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		168,
		189,
		214,
		181,
		-1,
		186,
		187,
		173,
		187,
		194,
		180,
		175,
		169,
		172,
		190,
		207,
		-1,
		-1,
		130,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		147,
		161,
		182,
		188,
		200,
		-1,
		195,
		189,
		175,
		192,
		193,
		190,
		181,
		173,
		178,
		175,
		188,
		202,
		206,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		165,
		180,
		242,
		219,
		192,
		196,
		189,
		183,
		183,
		199,
		201,
		212,
		180,
		176,
		177,
		181,
		180,
		197,
		207,
		-1,
		-1,
		136,
		153,
		188,
		173,
		177,
		269,
		-1,
		-1,
		205,
		196,
		187,
		190,
		193,
		196,
		186,
		183,
		188,
		193,
		181,
		190,
		208,
		212,
		-1,
		-1,
		-1,
		156,
		-1,
		171,
		-1,
		-1,
		192,
		276,
		223,
		205,
		201,
		199,
		192,
		201,
		196,
		191,
		201,
		210,
		202,
		183,
		194,
		217,
		206,
		244,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		185,
		160,
		175,
		221,
		212,
		217,
		238,
		235,
		-1,
		205,
		230,
		202,
		209,
		201,
		209,
		209,
		206,
		184,
		191,
		207,
		206,
		201,
		236,
		228,
		234,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		191,
		177,
		207,
		197,
		203,
		-1,
		-1,
		250,
		247,
		227,
		211,
		215,
		208,
		203,
		213,
		193,
		180,
		184,
		188,
		194,
		199,
		204,
		210,
		225,
		240,
		-1,
		163,
		244,
		237,
		220,
		228,
		259,
		-1,
		194,
		203,
		184,
		189,
		197,
		-1,
		-1,
		223,
		219,
		224,
		218,
		215,
		223,
		218,
		209,
		194,
		200,
		187,
		186,
		204,
		208,
		217,
		224,
		214,
		227,
		231,
		-1,
		177,
		220,
		214,
		217,
		241,
		255,
		-1,
		207,
		-1,
		-1,
		192,
		210,
		218,
		214,
		218,
		271,
		232,
		227,
		217,
		215,
		206,
		197,
		204,
		195,
		195,
		198,
		213,
		218,
		210,
		224,
		224,
		225,
		-1,
		212,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		208,
		-1,
		244,
		-1,
		237,
		241,
		240,
		243,
		231,
		218,
		210,
		202,
		218,
		193,
		203,
		199,
		200,
		209,
		220,
		232,
		231,
		232,
		286,
		241,
		208,
		199,
		246,
		261,
		265,
		-1,
		220,
		259,
		246,
		-1,
		217,
		-1,
		-1,
		-1,
		251,
		253,
		245,
		251,
		230,
		230,
		204,
		208,
		198,
		205,
		215,
		217,
		209,
		213,
		226,
		237,
		240,
		282,
		280,
		285,
		230,
		213,
		231,
		240,
		261,
		235,
		226,
		253,
		253,
		242,
		237,
		224,
		-1,
		-1,
		274,
		263,
		-1,
		-1,
		237,
		225,
		208,
		209,
		205,
		208,
		223,
		226,
		216,
		214,
		208,
		240,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		221,
		232,
		-1,
		-1,
		238,
		254,
		267,
		271,
		284,
		309,
		-1,
		227,
		-1,
		-1,
		282,
		-1,
		-1,
		267,
		230,
		219,
		210,
		216,
		213,
		224,
		234,
		222,
		223,
		213,
		223,
		236,
		266,
		263,
		251,
		249,
		272,
		229,
		225,
		-1,
		253,
		241,
		247,
		254,
		271,
		298,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		265,
		263,
		252,
		-1,
		242,
		215,
		220,
		240,
		242,
		231,
		225,
		219,
		226,
		225,
		233,
		241,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		293,
		-1,
		278,
		253,
		-1,
		-1,
		260,
		253,
		241,
		229,
		219,
		229,
		233,
		237,
		229,
		222,
		217,
		228,
		220,
		224,
		241,
		-1,
		309,
		-1,
		261,
		254,
		269,
		284,
		292,
		-1,
		-1,
		-1,
		295,
		281,
		274,
		262,
		260,
		-1,
		294,
		278,
		259,
		-1,
		229,
		242,
		273,
		241,
		246,
		241,
		223,
		234,
		223,
		226,
		240,
		235,
		-1,
		-1,
		267,
		270,
		-1,
		-1,
		292,
		311,
		-1,
		286,
		275,
		260,
		252,
		-1,
		-1,
		266,
		262,
		-1,
		-1,
		230,
		255,
		244,
		252,
		247,
		227,
		233,
		236,
		225,
		229,
		241,
		-1,
		-1,
		274,
		275,
		280,
		-1,
		295,
		-1,
		310,
		-1,
		255,
		271,
		273,
		-1,
		-1,
		-1,
		268,
		231,
		252,
		262,
		256,
		254,
		245,
		231,
		238,
		236,
		232,
		243,
		-1,
		-1,
		-1,
		313,
		287,
		317,
		308,
		291,
		271,
		263,
		285,
		-1,
		255,
		-1,
		230,
		232,
		258,
		261,
		267,
		261,
		234,
		249,
		239,
		230,
		239,
		319,
		-1,
		289,
		322,
		286,
		277,
		256,
		260,
		276,
		-1,
		252,
		234,
		-1,
		262,
		252,
		283,
		268,
		249,
		236,
		243,
		243,
		236,
		-1,
		-1,
		-1,
		291,
		290,
		282,
		276,
		276,
		261,
		252,
		-1,
		264,
		246,
		225,
		242,
		242,
		233,
		241,
		273,
		269,
		256,
		256,
		248,
		-1,
		381,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		285,
		280,
		253,
		241,
		247,
		243,
		229,
		235,
		237,
		245,
		243,
		240,
		252,
		248,
		268,
		249,
		284,
		-1,
		387,
		-1,
		321,
		-1,
		-1,
		303,
		283,
		275,
		264,
		253,
		251,
		242,
		233,
		255,
		271,
		255,
		253,
		256,
		257,
		-1,
		376,
		375,
		-1,
		322,
		314,
		300,
		-1,
		293,
		-1,
		299,
		260,
		-1,
		262,
		242,
		-1,
		264,
		260,
		-1,
		-1,
		363,
		338,
		-1,
		-1,
		-1,
		323,
		303,
		294,
		278,
		-1,
		253,
		253,
		-1,
		-1,
		-1,
		348,
		347,
		-1,
		316,
		319,
		-1,
		309,
		300,
		308,
		255,
		259,
		-1,
		-1,
		-1,
		357,
		338,
		332,
		331,
		329,
		324,
		321,
		307,
		291,
		269,
		258,
		279,
		-1,
		-1,
		-1,
		329,
		321,
		314,
		-1,
		-1,
		316,
		299,
		280,
		278,
		-1,
		-1,
		-1,
		351,
		332,
		-1,
		-1,
		306,
		-1,
		-1,
		312,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		368,
		340,
		-1,
		-1,
		-1,
		302,
		298,
		299,
		-1,
		-1,
		-1,
		-1,
		362,
		363,
		386,
		350,
		-1,
		-1,
		-1,
		294,
		288,
		-1,
		-1,
		365,
		363,
		-1,
		-1,
		-1,
		322,
		306,
		-1,
		292,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		327,
		-1,
		327,
		302,
		309,
		-1,
		-1,
		-1,
		-1,
		340,
		332,
		340,
		-1,
		312,
		314,
		-1,
		362,
		-1,
		-1,
		355,
		346,
		-1,
		-1,
		317,
		324,
		346,
		349,
		385,
		-1,
		336
	],
	[
		-1,
		209,
		198,
		209,
		217,
		190,
		197,
		-1,
		218,
		220,
		186,
		180,
		219,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		209,
		208,
		178,
		176,
		185,
		190,
		197,
		-1,
		214,
		-1,
		230,
		209,
		220,
		225,
		171,
		168,
		188,
		207,
		207,
		199,
		245,
		201,
		172,
		166,
		184,
		189,
		201,
		193,
		-1,
		172,
		162,
		184,
		181,
		192,
		183,
		-1,
		-1,
		166,
		167,
		173,
		177,
		183,
		179,
		-1,
		189,
		173,
		-1,
		-1,
		156,
		169,
		159,
		162,
		170,
		168,
		181,
		173,
		168,
		-1,
		-1,
		157,
		161,
		168,
		155,
		151,
		168,
		181,
		163,
		177,
		176,
		-1,
		145,
		163,
		172,
		162,
		160,
		144,
		142,
		160,
		162,
		168,
		171,
		-1,
		137,
		139,
		163,
		171,
		176,
		160,
		147,
		147,
		157,
		150,
		169,
		160,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		134,
		142,
		163,
		155,
		149,
		164,
		157,
		150,
		147,
		145,
		142,
		158,
		159,
		169,
		-1,
		-1,
		204,
		173,
		208,
		165,
		150,
		-1,
		130,
		139,
		144,
		148,
		147,
		140,
		154,
		150,
		-1,
		136,
		135,
		166,
		152,
		163,
		164,
		-1,
		-1,
		162,
		154,
		139,
		142,
		129,
		125,
		136,
		135,
		131,
		129,
		125,
		137,
		140,
		140,
		146,
		130,
		140,
		144,
		155,
		170,
		-1,
		-1,
		225,
		-1,
		-1,
		161,
		144,
		-1,
		127,
		134,
		134,
		141,
		127,
		120,
		146,
		122,
		119,
		140,
		128,
		135,
		132,
		145,
		133,
		127,
		152,
		156,
		150,
		171,
		166,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		120,
		123,
		129,
		152,
		137,
		-1,
		82,
		88,
		112,
		109,
		119,
		132,
		126,
		139,
		124,
		131,
		130,
		134,
		136,
		169,
		147,
		169,
		166,
		195,
		200,
		194,
		203,
		-1,
		169,
		165,
		161,
		168,
		117,
		-1,
		-1,
		148,
		-1,
		106,
		99,
		74,
		92,
		95,
		110,
		101,
		133,
		122,
		133,
		122,
		119,
		127,
		136,
		147,
		142,
		141,
		159,
		174,
		187,
		191,
		197,
		-1,
		219,
		-1,
		161,
		145,
		147,
		119,
		140,
		-1,
		160,
		105,
		91,
		76,
		67,
		-1,
		87,
		90,
		116,
		123,
		114,
		131,
		123,
		121,
		126,
		131,
		145,
		136,
		154,
		161,
		169,
		173,
		193,
		205,
		179,
		169,
		-1,
		151,
		156,
		115,
		123,
		142,
		109,
		73,
		-1,
		68,
		-1,
		77,
		102,
		-1,
		122,
		126,
		113,
		114,
		109,
		124,
		130,
		127,
		124,
		142,
		145,
		162,
		166,
		182,
		-1,
		-1,
		164,
		168,
		157,
		108,
		127,
		151,
		119,
		66,
		55,
		54,
		-1,
		62,
		145,
		142,
		128,
		115,
		106,
		107,
		115,
		128,
		107,
		126,
		129,
		151,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		134,
		105,
		129,
		133,
		84,
		77,
		65,
		30,
		30,
		37,
		-1,
		135,
		118,
		115,
		104,
		102,
		115,
		110,
		126,
		130,
		129,
		148,
		160,
		151,
		171,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		100,
		123,
		160,
		23,
		9,
		14,
		29,
		35,
		40,
		138,
		135,
		102,
		111,
		103,
		92,
		106,
		114,
		118,
		127,
		136,
		142,
		166,
		166,
		172,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		114,
		121,
		153,
		0,
		138,
		-1,
		73,
		-1,
		46,
		80,
		88,
		94,
		106,
		92,
		97,
		108,
		120,
		133,
		129,
		136,
		171,
		171,
		156,
		176,
		179,
		-1,
		-1,
		-1,
		164,
		159,
		134,
		111,
		95,
		131,
		-1,
		108,
		109,
		-1,
		67,
		61,
		77,
		85,
		92,
		89,
		89,
		103,
		111,
		107,
		123,
		129,
		121,
		157,
		-1,
		164,
		158,
		166,
		156,
		144,
		-1,
		-1,
		-1,
		157,
		136,
		129,
		149,
		90,
		142,
		-1,
		-1,
		93,
		86,
		-1,
		64,
		73,
		80,
		89,
		94,
		99,
		107,
		102,
		115,
		120,
		126,
		131,
		149,
		153,
		157,
		146,
		142,
		139,
		153,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		110,
		-1,
		102,
		94,
		84,
		78,
		72,
		86,
		84,
		104,
		96,
		110,
		110,
		116,
		124,
		109,
		112,
		128,
		126,
		144,
		152,
		144,
		138,
		137,
		149,
		-1,
		177,
		163,
		134,
		-1,
		-1,
		123,
		-1,
		87,
		101,
		117,
		-1,
		110,
		89,
		104,
		82,
		96,
		92,
		130,
		131,
		109,
		114,
		122,
		132,
		134,
		123,
		134,
		126,
		148,
		148,
		132,
		133,
		142,
		-1,
		183,
		170,
		128,
		124,
		113,
		133,
		84,
		72,
		104,
		-1,
		-1,
		146,
		-1,
		80,
		97,
		106,
		104,
		120,
		111,
		117,
		133,
		136,
		138,
		128,
		117,
		123,
		120,
		142,
		128,
		126,
		145,
		161,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		99,
		86,
		80,
		-1,
		121,
		-1,
		124,
		114,
		98,
		83,
		116,
		-1,
		128,
		112,
		117,
		-1,
		163,
		-1,
		136,
		138,
		132,
		117,
		114,
		125,
		123,
		134,
		151,
		-1,
		133,
		118,
		111,
		101,
		115,
		86,
		-1,
		141,
		-1,
		-1,
		111,
		105,
		105,
		89,
		92,
		144,
		124,
		118,
		117,
		158,
		158,
		144,
		130,
		123,
		120,
		117,
		130,
		150,
		141,
		153,
		-1,
		-1,
		-1,
		138,
		124,
		128,
		88,
		107,
		-1,
		-1,
		173,
		128,
		114,
		-1,
		98,
		161,
		149,
		139,
		129,
		163,
		164,
		149,
		142,
		128,
		130,
		128,
		126,
		131,
		152,
		153,
		166,
		-1,
		-1,
		121,
		126,
		114,
		100,
		119,
		-1,
		-1,
		-1,
		120,
		136,
		128,
		99,
		150,
		-1,
		-1,
		141,
		139,
		149,
		145,
		132,
		152,
		155,
		141,
		125,
		140,
		152,
		160,
		165,
		-1,
		124,
		111,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		131,
		152,
		177,
		144,
		-1,
		149,
		150,
		136,
		150,
		157,
		143,
		138,
		132,
		135,
		153,
		170,
		-1,
		-1,
		136,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		110,
		124,
		145,
		151,
		163,
		-1,
		158,
		152,
		138,
		155,
		156,
		153,
		144,
		136,
		141,
		138,
		151,
		165,
		169,
		159,
		-1,
		142,
		-1,
		-1,
		-1,
		128,
		143,
		205,
		182,
		155,
		159,
		152,
		146,
		146,
		162,
		164,
		175,
		143,
		139,
		140,
		144,
		143,
		160,
		170,
		-1,
		-1,
		142,
		159,
		154,
		136,
		140,
		232,
		-1,
		-1,
		168,
		159,
		150,
		153,
		156,
		159,
		149,
		146,
		151,
		156,
		144,
		153,
		171,
		175,
		-1,
		-1,
		-1,
		162,
		-1,
		177,
		-1,
		-1,
		155,
		239,
		186,
		168,
		164,
		162,
		155,
		164,
		159,
		154,
		164,
		173,
		165,
		146,
		157,
		180,
		169,
		207,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		191,
		166,
		181,
		227,
		175,
		182,
		201,
		198,
		-1,
		168,
		193,
		165,
		172,
		164,
		172,
		172,
		169,
		147,
		154,
		170,
		169,
		164,
		199,
		191,
		197,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		197,
		183,
		213,
		203,
		192,
		-1,
		-1,
		217,
		214,
		190,
		174,
		178,
		171,
		166,
		176,
		156,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		169,
		250,
		243,
		226,
		234,
		265,
		-1,
		200,
		209,
		190,
		195,
		203,
		-1,
		-1,
		190,
		187,
		192,
		181,
		178,
		186,
		181,
		172,
		157,
		163,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		183,
		226,
		220,
		223,
		247,
		261,
		-1,
		213,
		-1,
		-1,
		198,
		216,
		205,
		195,
		189,
		239,
		195,
		190,
		180,
		178,
		169,
		160,
		167,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		218,
		206,
		214,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		214,
		-1,
		232,
		-1,
		207,
		211,
		203,
		206,
		194,
		181,
		173,
		165,
		181,
		156,
		166,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		292,
		247,
		214,
		205,
		252,
		267,
		271,
		-1,
		226,
		265,
		252,
		-1,
		223,
		-1,
		-1,
		-1,
		221,
		216,
		208,
		214,
		193,
		193,
		167,
		171,
		161,
		168,
		178,
		180,
		172,
		176,
		189,
		200,
		203,
		288,
		286,
		291,
		236,
		219,
		237,
		246,
		267,
		241,
		232,
		259,
		259,
		248,
		243,
		230,
		-1,
		-1,
		244,
		226,
		-1,
		-1,
		200,
		188,
		171,
		172,
		168,
		171,
		186,
		189,
		179,
		177,
		171,
		203,
		-1,
		288,
		287,
		276,
		273,
		249,
		240,
		227,
		238,
		-1,
		-1,
		244,
		260,
		273,
		277,
		290,
		315,
		-1,
		233,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		176,
		187,
		197,
		185,
		186,
		176,
		186,
		199,
		272,
		269,
		257,
		255,
		278,
		235,
		231,
		-1,
		254,
		247,
		253,
		260,
		277,
		304,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		178,
		183,
		203,
		205,
		194,
		188,
		182,
		189,
		188,
		196,
		204,
		281,
		295,
		284,
		280,
		279,
		287,
		236,
		239,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		266,
		259,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		196,
		200,
		192,
		185,
		180,
		191,
		183,
		187,
		204,
		-1,
		315,
		-1,
		267,
		253,
		267,
		282,
		290,
		-1,
		-1,
		-1,
		283,
		269,
		262,
		250,
		248,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		186,
		197,
		186,
		189,
		203,
		198,
		-1,
		-1,
		265,
		268,
		-1,
		-1,
		273,
		275,
		-1,
		274,
		263,
		248,
		240,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		190,
		196,
		199,
		188,
		192,
		204,
		-1,
		-1,
		272,
		273,
		278,
		-1,
		258,
		-1,
		276,
		-1,
		243,
		249,
		237,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		219,
		217,
		208,
		194,
		201,
		199,
		195,
		206,
		-1,
		-1,
		-1,
		276,
		250,
		283,
		274,
		257,
		237,
		229,
		248,
		-1,
		218,
		-1,
		193,
		195,
		221,
		224,
		230,
		224,
		197,
		212,
		202,
		193,
		202,
		282,
		-1,
		252,
		285,
		249,
		243,
		219,
		223,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		246,
		231,
		212,
		199,
		206,
		206,
		199,
		-1,
		-1,
		-1,
		254,
		253,
		245,
		239,
		239,
		224,
		215,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		236,
		232,
		219,
		219,
		211,
		-1,
		355,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		248,
		243,
		216,
		204,
		210,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		212,
		247,
		-1,
		350,
		-1,
		284,
		-1,
		-1,
		266,
		246,
		238,
		227,
		216,
		214,
		205,
		196,
		218,
		234,
		218,
		216,
		219,
		220,
		-1,
		339,
		338,
		-1,
		285,
		277,
		263,
		-1,
		256,
		-1,
		262,
		223,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		326,
		301,
		-1,
		-1,
		-1,
		286,
		266,
		257,
		241,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		311,
		310,
		-1,
		279,
		282,
		-1,
		272,
		263,
		271,
		218,
		222,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		294,
		292,
		287,
		284,
		270,
		254,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		292,
		284,
		277,
		-1,
		-1,
		279,
		262,
		243,
		241,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		303,
		-1,
		-1,
		-1,
		265,
		261,
		262,
		-1,
		-1,
		-1,
		-1,
		325,
		326,
		349,
		313,
		-1,
		-1,
		-1,
		257,
		251,
		-1,
		-1,
		328,
		326,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		255,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		290,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		280,
		287,
		309,
		312,
		348,
		-1,
		299
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		222,
		224,
		190,
		184,
		223,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		213,
		212,
		182,
		180,
		189,
		194,
		201,
		-1,
		214,
		-1,
		234,
		213,
		224,
		229,
		175,
		172,
		192,
		211,
		207,
		199,
		249,
		205,
		176,
		170,
		188,
		192,
		201,
		193,
		-1,
		176,
		166,
		188,
		181,
		192,
		184,
		-1,
		-1,
		170,
		171,
		177,
		177,
		183,
		179,
		-1,
		189,
		173,
		-1,
		-1,
		160,
		173,
		159,
		162,
		170,
		168,
		181,
		173,
		168,
		-1,
		-1,
		161,
		161,
		168,
		155,
		151,
		168,
		181,
		163,
		177,
		176,
		-1,
		149,
		167,
		176,
		162,
		160,
		144,
		142,
		160,
		162,
		168,
		171,
		-1,
		141,
		143,
		163,
		171,
		176,
		160,
		147,
		147,
		157,
		150,
		169,
		160,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		138,
		146,
		167,
		159,
		149,
		164,
		157,
		150,
		147,
		145,
		142,
		158,
		159,
		169,
		-1,
		-1,
		194,
		163,
		198,
		155,
		140,
		-1,
		134,
		143,
		149,
		153,
		147,
		140,
		154,
		150,
		-1,
		136,
		135,
		166,
		152,
		163,
		154,
		-1,
		-1,
		152,
		144,
		129,
		132,
		129,
		129,
		158,
		157,
		149,
		135,
		131,
		137,
		140,
		140,
		146,
		130,
		140,
		144,
		155,
		170,
		-1,
		-1,
		225,
		-1,
		-1,
		151,
		134,
		-1,
		117,
		124,
		124,
		141,
		131,
		152,
		167,
		159,
		151,
		145,
		133,
		135,
		132,
		145,
		133,
		127,
		152,
		156,
		150,
		171,
		166,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		110,
		113,
		119,
		143,
		153,
		-1,
		153,
		159,
		169,
		154,
		151,
		138,
		126,
		139,
		124,
		131,
		130,
		134,
		136,
		169,
		147,
		169,
		166,
		195,
		200,
		194,
		203,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		147,
		-1,
		161,
		170,
		145,
		163,
		166,
		155,
		146,
		133,
		122,
		133,
		122,
		119,
		127,
		136,
		147,
		142,
		141,
		159,
		174,
		187,
		191,
		197,
		-1,
		209,
		-1,
		151,
		135,
		137,
		109,
		130,
		-1,
		167,
		162,
		162,
		147,
		138,
		-1,
		141,
		144,
		151,
		129,
		114,
		131,
		123,
		121,
		126,
		131,
		145,
		136,
		154,
		161,
		169,
		173,
		193,
		205,
		169,
		159,
		-1,
		141,
		146,
		105,
		113,
		132,
		180,
		144,
		-1,
		139,
		-1,
		131,
		156,
		-1,
		135,
		131,
		113,
		114,
		109,
		124,
		130,
		127,
		124,
		142,
		145,
		162,
		166,
		182,
		-1,
		-1,
		154,
		158,
		147,
		98,
		117,
		141,
		178,
		137,
		126,
		125,
		-1,
		116,
		146,
		143,
		129,
		116,
		106,
		107,
		115,
		128,
		107,
		126,
		129,
		151,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		124,
		95,
		119,
		161,
		155,
		148,
		136,
		101,
		101,
		95,
		-1,
		136,
		119,
		115,
		104,
		102,
		115,
		110,
		126,
		130,
		129,
		148,
		160,
		151,
		171,
		-1,
		-1,
		-1,
		154,
		143,
		144,
		90,
		113,
		150,
		134,
		120,
		125,
		100,
		93,
		87,
		139,
		136,
		103,
		111,
		103,
		92,
		106,
		114,
		118,
		127,
		136,
		142,
		166,
		166,
		172,
		-1,
		-1,
		161,
		151,
		135,
		137,
		134,
		104,
		111,
		143,
		125,
		0,
		-1,
		92,
		-1,
		81,
		89,
		88,
		94,
		106,
		92,
		97,
		108,
		120,
		133,
		129,
		136,
		171,
		171,
		156,
		176,
		179,
		-1,
		-1,
		-1,
		154,
		149,
		124,
		101,
		85,
		121,
		-1,
		41,
		42,
		-1,
		86,
		80,
		86,
		85,
		92,
		89,
		89,
		103,
		111,
		107,
		123,
		129,
		121,
		157,
		-1,
		164,
		158,
		166,
		156,
		144,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		80,
		132,
		-1,
		-1,
		37,
		44,
		-1,
		73,
		73,
		80,
		89,
		94,
		99,
		107,
		102,
		115,
		120,
		126,
		131,
		149,
		153,
		157,
		146,
		142,
		139,
		153,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		100,
		-1,
		81,
		73,
		59,
		53,
		59,
		86,
		84,
		104,
		96,
		110,
		110,
		116,
		124,
		109,
		112,
		128,
		126,
		144,
		152,
		144,
		138,
		137,
		149,
		-1,
		167,
		153,
		124,
		-1,
		-1,
		113,
		-1,
		77,
		90,
		106,
		-1,
		93,
		72,
		96,
		78,
		96,
		92,
		130,
		131,
		109,
		114,
		122,
		132,
		134,
		123,
		134,
		126,
		148,
		148,
		132,
		133,
		142,
		-1,
		173,
		160,
		118,
		114,
		103,
		123,
		74,
		62,
		93,
		-1,
		-1,
		146,
		-1,
		80,
		97,
		106,
		104,
		120,
		111,
		117,
		133,
		136,
		138,
		128,
		117,
		123,
		120,
		142,
		128,
		126,
		145,
		161,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		89,
		76,
		70,
		-1,
		110,
		-1,
		124,
		114,
		98,
		83,
		116,
		-1,
		128,
		112,
		117,
		-1,
		163,
		-1,
		136,
		138,
		132,
		117,
		114,
		125,
		123,
		134,
		151,
		-1,
		123,
		108,
		101,
		91,
		105,
		76,
		-1,
		131,
		-1,
		-1,
		111,
		105,
		105,
		89,
		92,
		144,
		124,
		118,
		117,
		158,
		158,
		144,
		130,
		123,
		120,
		117,
		130,
		150,
		141,
		153,
		-1,
		-1,
		-1,
		128,
		114,
		118,
		78,
		97,
		-1,
		-1,
		173,
		128,
		114,
		-1,
		98,
		161,
		149,
		139,
		129,
		163,
		164,
		149,
		142,
		128,
		130,
		128,
		126,
		131,
		152,
		153,
		166,
		-1,
		-1,
		111,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		120,
		136,
		128,
		99,
		150,
		-1,
		-1,
		141,
		139,
		149,
		145,
		132,
		152,
		155,
		141,
		125,
		140,
		152,
		160,
		165,
		-1,
		114,
		101,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		131,
		152,
		177,
		144,
		-1,
		149,
		150,
		136,
		150,
		157,
		143,
		138,
		132,
		135,
		153,
		170,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		110,
		124,
		145,
		151,
		163,
		-1,
		158,
		152,
		138,
		155,
		156,
		153,
		144,
		136,
		141,
		138,
		151,
		165,
		169,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		128,
		143,
		205,
		182,
		155,
		159,
		152,
		146,
		146,
		162,
		164,
		175,
		143,
		139,
		140,
		144,
		143,
		160,
		170,
		-1,
		-1,
		132,
		149,
		154,
		136,
		140,
		232,
		-1,
		-1,
		168,
		159,
		150,
		153,
		156,
		159,
		149,
		146,
		151,
		156,
		144,
		153,
		171,
		175,
		-1,
		-1,
		-1,
		152,
		-1,
		167,
		-1,
		-1,
		155,
		239,
		186,
		168,
		164,
		162,
		155,
		164,
		159,
		154,
		164,
		173,
		165,
		146,
		157,
		180,
		169,
		207,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		217,
		175,
		182,
		201,
		198,
		-1,
		168,
		193,
		165,
		172,
		164,
		172,
		172,
		169,
		147,
		154,
		170,
		169,
		164,
		199,
		191,
		197,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		187,
		173,
		203,
		193,
		192,
		-1,
		-1,
		217,
		214,
		190,
		174,
		178,
		171,
		166,
		176,
		156,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		190,
		199,
		180,
		185,
		193,
		-1,
		-1,
		190,
		187,
		192,
		181,
		178,
		186,
		181,
		172,
		157,
		163,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		203,
		-1,
		-1,
		188,
		206,
		205,
		195,
		189,
		239,
		195,
		190,
		180,
		178,
		169,
		160,
		167,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		204,
		-1,
		232,
		-1,
		207,
		211,
		203,
		206,
		194,
		181,
		173,
		165,
		181,
		156,
		166,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		282,
		237,
		204,
		195,
		242,
		257,
		261,
		-1,
		216,
		255,
		242,
		-1,
		213,
		-1,
		-1,
		-1,
		221,
		216,
		208,
		214,
		193,
		193,
		167,
		171,
		161,
		168,
		178,
		180,
		172,
		176,
		189,
		200,
		203,
		278,
		276,
		281,
		226,
		209,
		227,
		236,
		257,
		231,
		222,
		249,
		249,
		238,
		233,
		220,
		-1,
		-1,
		244,
		226,
		-1,
		-1,
		200,
		188,
		171,
		172,
		168,
		171,
		186,
		189,
		179,
		177,
		171,
		203,
		-1,
		278,
		277,
		266,
		263,
		239,
		230,
		217,
		228,
		-1,
		-1,
		234,
		250,
		263,
		267,
		280,
		305,
		-1,
		223,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		176,
		187,
		197,
		185,
		186,
		176,
		186,
		199,
		262,
		259,
		247,
		245,
		268,
		225,
		221,
		-1,
		249,
		237,
		243,
		250,
		267,
		294,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		178,
		183,
		203,
		205,
		194,
		188,
		182,
		189,
		188,
		196,
		204,
		271,
		285,
		274,
		270,
		269,
		277,
		226,
		239,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		266,
		249,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		196,
		200,
		192,
		185,
		180,
		191,
		183,
		187,
		204,
		-1,
		305,
		-1,
		257,
		250,
		265,
		280,
		288,
		-1,
		-1,
		-1,
		283,
		269,
		262,
		250,
		248,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		186,
		197,
		186,
		189,
		203,
		198,
		-1,
		-1,
		263,
		266,
		-1,
		-1,
		273,
		275,
		-1,
		274,
		263,
		248,
		240,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		190,
		196,
		199,
		188,
		192,
		204,
		-1,
		-1,
		270,
		271,
		276,
		-1,
		258,
		-1,
		276,
		-1,
		243,
		249,
		237,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		219,
		217,
		208,
		194,
		201,
		199,
		195,
		206,
		-1,
		-1,
		-1,
		276,
		250,
		283,
		274,
		257,
		237,
		229,
		248,
		-1,
		218,
		-1,
		193,
		195,
		221,
		224,
		230,
		224,
		197,
		212,
		202,
		193,
		202,
		282,
		-1,
		252,
		285,
		249,
		243,
		219,
		223,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		246,
		231,
		212,
		199,
		206,
		206,
		199,
		-1,
		-1,
		-1,
		254,
		253,
		245,
		239,
		239,
		224,
		215,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		236,
		232,
		219,
		219,
		211,
		-1,
		355,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		248,
		243,
		216,
		204,
		210,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		212,
		247,
		-1,
		350,
		-1,
		284,
		-1,
		-1,
		266,
		246,
		238,
		227,
		216,
		214,
		205,
		196,
		218,
		234,
		218,
		216,
		219,
		220,
		-1,
		339,
		338,
		-1,
		285,
		277,
		263,
		-1,
		256,
		-1,
		262,
		223,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		326,
		301,
		-1,
		-1,
		-1,
		286,
		266,
		257,
		241,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		311,
		310,
		-1,
		279,
		282,
		-1,
		272,
		263,
		271,
		218,
		222,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		294,
		292,
		287,
		284,
		270,
		254,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		292,
		284,
		277,
		-1,
		-1,
		279,
		262,
		243,
		241,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		269,
		-1,
		-1,
		275,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		303,
		-1,
		-1,
		-1,
		265,
		261,
		262,
		-1,
		-1,
		-1,
		-1,
		325,
		326,
		349,
		313,
		-1,
		-1,
		-1,
		257,
		251,
		-1,
		-1,
		328,
		326,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		255,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		290,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		280,
		287,
		309,
		312,
		348,
		-1,
		299
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		196,
		185,
		196,
		204,
		177,
		184,
		-1,
		205,
		207,
		173,
		167,
		206,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		196,
		195,
		165,
		163,
		172,
		177,
		184,
		-1,
		188,
		-1,
		217,
		196,
		207,
		212,
		158,
		155,
		175,
		194,
		181,
		173,
		232,
		188,
		159,
		153,
		171,
		166,
		175,
		167,
		-1,
		159,
		149,
		171,
		155,
		166,
		158,
		-1,
		-1,
		153,
		154,
		160,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		143,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		132,
		150,
		159,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		145,
		-1,
		125,
		127,
		137,
		145,
		150,
		134,
		121,
		121,
		131,
		124,
		143,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		124,
		141,
		133,
		123,
		138,
		131,
		124,
		121,
		119,
		116,
		132,
		133,
		143,
		-1,
		-1,
		178,
		147,
		182,
		139,
		124,
		-1,
		118,
		117,
		123,
		127,
		121,
		114,
		128,
		124,
		-1,
		110,
		109,
		140,
		126,
		137,
		138,
		-1,
		-1,
		136,
		128,
		113,
		116,
		113,
		113,
		132,
		131,
		123,
		109,
		105,
		111,
		114,
		114,
		120,
		104,
		114,
		118,
		129,
		144,
		-1,
		-1,
		199,
		-1,
		-1,
		135,
		118,
		-1,
		101,
		108,
		108,
		125,
		115,
		136,
		142,
		133,
		125,
		119,
		107,
		109,
		106,
		119,
		107,
		101,
		126,
		130,
		124,
		145,
		140,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		94,
		97,
		103,
		127,
		137,
		-1,
		110,
		116,
		126,
		120,
		125,
		112,
		100,
		113,
		98,
		105,
		104,
		108,
		110,
		143,
		121,
		143,
		140,
		169,
		174,
		168,
		177,
		-1,
		143,
		139,
		135,
		142,
		91,
		-1,
		-1,
		131,
		-1,
		134,
		127,
		102,
		120,
		123,
		121,
		112,
		107,
		96,
		107,
		96,
		93,
		101,
		110,
		121,
		116,
		115,
		133,
		148,
		161,
		165,
		171,
		-1,
		193,
		-1,
		135,
		119,
		121,
		93,
		114,
		-1,
		151,
		133,
		119,
		104,
		95,
		-1,
		98,
		101,
		125,
		103,
		88,
		105,
		97,
		95,
		100,
		105,
		119,
		110,
		128,
		135,
		143,
		147,
		167,
		179,
		153,
		143,
		-1,
		125,
		130,
		89,
		97,
		116,
		137,
		101,
		-1,
		96,
		-1,
		88,
		113,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		104,
		101,
		98,
		116,
		119,
		136,
		140,
		156,
		-1,
		-1,
		138,
		142,
		131,
		82,
		101,
		125,
		147,
		94,
		83,
		82,
		-1,
		73,
		119,
		116,
		102,
		89,
		80,
		81,
		89,
		102,
		81,
		100,
		103,
		125,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		108,
		79,
		103,
		145,
		112,
		105,
		93,
		58,
		58,
		52,
		-1,
		109,
		92,
		89,
		78,
		76,
		89,
		84,
		100,
		104,
		103,
		122,
		134,
		125,
		145,
		-1,
		-1,
		-1,
		138,
		127,
		128,
		74,
		97,
		134,
		91,
		77,
		82,
		57,
		50,
		42,
		112,
		109,
		76,
		85,
		77,
		66,
		80,
		88,
		92,
		101,
		110,
		116,
		140,
		140,
		146,
		-1,
		-1,
		145,
		135,
		119,
		121,
		118,
		88,
		95,
		127,
		82,
		112,
		-1,
		0,
		-1,
		36,
		54,
		62,
		68,
		80,
		66,
		71,
		82,
		94,
		107,
		103,
		110,
		145,
		145,
		130,
		150,
		153,
		-1,
		-1,
		-1,
		138,
		133,
		108,
		85,
		69,
		105,
		-1,
		82,
		83,
		-1,
		14,
		24,
		51,
		59,
		66,
		63,
		63,
		77,
		85,
		81,
		97,
		103,
		95,
		131,
		-1,
		138,
		132,
		140,
		130,
		118,
		-1,
		-1,
		-1,
		131,
		110,
		103,
		123,
		64,
		116,
		-1,
		-1,
		67,
		60,
		-1,
		38,
		47,
		54,
		63,
		68,
		73,
		81,
		76,
		89,
		94,
		100,
		105,
		123,
		127,
		131,
		120,
		116,
		113,
		127,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		84,
		-1,
		76,
		68,
		58,
		52,
		46,
		60,
		58,
		78,
		70,
		84,
		84,
		90,
		98,
		83,
		86,
		102,
		100,
		118,
		126,
		118,
		112,
		111,
		123,
		-1,
		151,
		137,
		108,
		-1,
		-1,
		97,
		-1,
		61,
		75,
		91,
		-1,
		84,
		63,
		78,
		56,
		70,
		66,
		104,
		105,
		83,
		88,
		96,
		106,
		108,
		97,
		108,
		100,
		122,
		122,
		106,
		107,
		116,
		-1,
		157,
		144,
		102,
		98,
		87,
		107,
		58,
		46,
		78,
		-1,
		-1,
		120,
		-1,
		54,
		71,
		80,
		78,
		94,
		85,
		91,
		107,
		110,
		112,
		102,
		91,
		97,
		94,
		116,
		102,
		100,
		119,
		135,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		73,
		60,
		54,
		-1,
		95,
		-1,
		98,
		88,
		72,
		57,
		90,
		-1,
		102,
		86,
		91,
		-1,
		137,
		-1,
		110,
		112,
		106,
		91,
		88,
		99,
		97,
		108,
		125,
		-1,
		107,
		92,
		85,
		75,
		89,
		60,
		-1,
		115,
		-1,
		-1,
		85,
		79,
		79,
		63,
		66,
		118,
		98,
		92,
		91,
		132,
		132,
		118,
		104,
		97,
		94,
		91,
		104,
		124,
		115,
		127,
		-1,
		-1,
		-1,
		112,
		98,
		102,
		62,
		81,
		-1,
		-1,
		147,
		102,
		88,
		-1,
		72,
		135,
		123,
		113,
		103,
		137,
		138,
		123,
		116,
		102,
		104,
		102,
		100,
		105,
		126,
		127,
		140,
		-1,
		-1,
		95,
		100,
		88,
		74,
		93,
		-1,
		-1,
		-1,
		94,
		110,
		102,
		73,
		124,
		-1,
		-1,
		115,
		113,
		123,
		119,
		106,
		126,
		129,
		115,
		99,
		114,
		126,
		134,
		139,
		-1,
		98,
		85,
		-1,
		-1,
		96,
		90,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		105,
		126,
		151,
		118,
		-1,
		123,
		124,
		110,
		124,
		131,
		117,
		112,
		106,
		109,
		127,
		144,
		-1,
		-1,
		110,
		-1,
		105,
		-1,
		-1,
		-1,
		-1,
		84,
		98,
		119,
		125,
		137,
		-1,
		132,
		126,
		112,
		129,
		130,
		127,
		118,
		110,
		115,
		112,
		125,
		139,
		143,
		133,
		-1,
		116,
		-1,
		-1,
		-1,
		102,
		117,
		179,
		156,
		129,
		133,
		126,
		120,
		120,
		136,
		138,
		149,
		117,
		113,
		114,
		118,
		117,
		134,
		144,
		-1,
		-1,
		116,
		133,
		128,
		110,
		114,
		206,
		-1,
		-1,
		142,
		133,
		124,
		127,
		130,
		133,
		123,
		120,
		125,
		130,
		118,
		127,
		145,
		149,
		-1,
		-1,
		-1,
		136,
		-1,
		151,
		-1,
		-1,
		129,
		213,
		160,
		142,
		138,
		136,
		129,
		138,
		133,
		128,
		138,
		147,
		139,
		120,
		131,
		154,
		143,
		181,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		165,
		140,
		155,
		201,
		149,
		156,
		175,
		172,
		-1,
		142,
		167,
		139,
		146,
		138,
		146,
		146,
		143,
		121,
		128,
		144,
		143,
		138,
		173,
		165,
		171,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		171,
		157,
		187,
		177,
		166,
		-1,
		-1,
		191,
		188,
		164,
		148,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		143,
		224,
		217,
		200,
		208,
		239,
		-1,
		174,
		183,
		164,
		169,
		177,
		-1,
		-1,
		164,
		161,
		166,
		155,
		152,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		157,
		200,
		194,
		197,
		221,
		235,
		-1,
		187,
		-1,
		-1,
		172,
		190,
		179,
		169,
		163,
		213,
		169,
		164,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		192,
		180,
		188,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		188,
		-1,
		206,
		-1,
		181,
		185,
		177,
		180,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		266,
		221,
		188,
		179,
		226,
		241,
		245,
		-1,
		200,
		239,
		226,
		-1,
		197,
		-1,
		-1,
		-1,
		195,
		190,
		182,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		262,
		260,
		265,
		210,
		193,
		211,
		220,
		241,
		215,
		206,
		233,
		233,
		222,
		217,
		204,
		-1,
		-1,
		218,
		200,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		201,
		212,
		-1,
		-1,
		218,
		234,
		247,
		251,
		264,
		289,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		246,
		243,
		231,
		229,
		252,
		209,
		205,
		-1,
		228,
		221,
		227,
		234,
		251,
		278,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		233,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		289,
		-1,
		241,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		247,
		249,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		246,
		247,
		252,
		-1,
		232,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		329,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		185,
		187,
		153,
		147,
		186,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		176,
		175,
		145,
		143,
		152,
		157,
		164,
		-1,
		168,
		-1,
		197,
		176,
		187,
		192,
		138,
		135,
		155,
		174,
		161,
		153,
		212,
		168,
		139,
		133,
		151,
		146,
		155,
		147,
		-1,
		139,
		129,
		151,
		135,
		146,
		138,
		-1,
		-1,
		133,
		134,
		140,
		131,
		137,
		133,
		-1,
		143,
		127,
		-1,
		-1,
		123,
		129,
		113,
		116,
		124,
		122,
		135,
		127,
		122,
		-1,
		-1,
		119,
		115,
		122,
		109,
		105,
		122,
		135,
		117,
		131,
		130,
		-1,
		112,
		130,
		139,
		116,
		114,
		98,
		96,
		114,
		116,
		122,
		125,
		-1,
		105,
		107,
		117,
		125,
		130,
		114,
		101,
		101,
		111,
		104,
		123,
		114,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		104,
		121,
		113,
		103,
		118,
		111,
		104,
		101,
		99,
		96,
		112,
		113,
		123,
		-1,
		-1,
		158,
		127,
		162,
		119,
		104,
		-1,
		98,
		97,
		103,
		107,
		101,
		94,
		108,
		104,
		-1,
		90,
		89,
		120,
		106,
		117,
		118,
		-1,
		-1,
		116,
		108,
		93,
		96,
		93,
		93,
		111,
		110,
		103,
		89,
		85,
		91,
		94,
		94,
		100,
		84,
		94,
		98,
		109,
		124,
		-1,
		-1,
		179,
		-1,
		-1,
		115,
		98,
		-1,
		81,
		88,
		88,
		105,
		95,
		112,
		121,
		97,
		94,
		99,
		87,
		89,
		86,
		99,
		87,
		81,
		106,
		110,
		104,
		125,
		120,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		74,
		77,
		83,
		107,
		117,
		-1,
		74,
		80,
		90,
		84,
		94,
		92,
		80,
		93,
		78,
		85,
		84,
		88,
		90,
		123,
		101,
		123,
		120,
		149,
		154,
		148,
		157,
		-1,
		123,
		119,
		115,
		122,
		71,
		-1,
		-1,
		111,
		-1,
		98,
		91,
		66,
		84,
		87,
		85,
		76,
		87,
		76,
		87,
		76,
		73,
		81,
		90,
		101,
		96,
		95,
		113,
		128,
		141,
		145,
		151,
		-1,
		173,
		-1,
		115,
		99,
		101,
		73,
		94,
		-1,
		131,
		97,
		83,
		68,
		59,
		-1,
		62,
		65,
		91,
		83,
		68,
		85,
		77,
		75,
		80,
		85,
		99,
		90,
		108,
		115,
		123,
		127,
		147,
		159,
		133,
		123,
		-1,
		105,
		110,
		69,
		77,
		96,
		101,
		65,
		-1,
		60,
		-1,
		52,
		77,
		-1,
		89,
		85,
		67,
		68,
		63,
		78,
		84,
		81,
		78,
		96,
		99,
		116,
		120,
		136,
		-1,
		-1,
		118,
		122,
		111,
		62,
		81,
		105,
		111,
		58,
		47,
		46,
		-1,
		37,
		99,
		96,
		82,
		69,
		60,
		61,
		69,
		82,
		61,
		80,
		83,
		105,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		88,
		59,
		83,
		125,
		76,
		69,
		57,
		22,
		22,
		16,
		-1,
		89,
		72,
		69,
		58,
		56,
		69,
		64,
		80,
		84,
		83,
		102,
		114,
		105,
		125,
		-1,
		-1,
		-1,
		118,
		107,
		108,
		54,
		77,
		114,
		55,
		41,
		46,
		21,
		14,
		6,
		92,
		89,
		56,
		65,
		57,
		46,
		60,
		68,
		72,
		81,
		90,
		96,
		120,
		120,
		126,
		-1,
		-1,
		125,
		115,
		99,
		101,
		98,
		68,
		75,
		107,
		46,
		92,
		-1,
		27,
		-1,
		0,
		34,
		42,
		48,
		60,
		46,
		51,
		62,
		74,
		87,
		83,
		90,
		125,
		125,
		110,
		130,
		133,
		-1,
		-1,
		-1,
		118,
		113,
		88,
		65,
		49,
		85,
		-1,
		62,
		63,
		-1,
		21,
		15,
		31,
		39,
		46,
		43,
		43,
		57,
		65,
		61,
		77,
		83,
		75,
		111,
		-1,
		118,
		112,
		120,
		110,
		98,
		-1,
		-1,
		-1,
		111,
		90,
		83,
		103,
		44,
		96,
		-1,
		-1,
		47,
		40,
		-1,
		18,
		27,
		34,
		43,
		48,
		53,
		61,
		56,
		69,
		74,
		80,
		85,
		103,
		107,
		111,
		100,
		96,
		93,
		107,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		44,
		64,
		-1,
		56,
		48,
		38,
		32,
		26,
		40,
		38,
		58,
		50,
		64,
		64,
		70,
		78,
		63,
		66,
		82,
		80,
		98,
		106,
		98,
		92,
		91,
		103,
		-1,
		131,
		117,
		88,
		-1,
		-1,
		77,
		-1,
		41,
		55,
		71,
		-1,
		64,
		43,
		58,
		36,
		50,
		46,
		84,
		85,
		63,
		68,
		76,
		86,
		88,
		77,
		88,
		80,
		102,
		102,
		86,
		87,
		96,
		-1,
		137,
		124,
		82,
		78,
		67,
		87,
		38,
		26,
		58,
		-1,
		-1,
		100,
		-1,
		34,
		51,
		60,
		58,
		74,
		65,
		71,
		87,
		90,
		92,
		82,
		71,
		77,
		74,
		96,
		82,
		80,
		99,
		115,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		53,
		40,
		34,
		-1,
		75,
		-1,
		78,
		68,
		52,
		37,
		70,
		-1,
		82,
		66,
		71,
		-1,
		117,
		-1,
		90,
		92,
		86,
		71,
		68,
		79,
		77,
		88,
		105,
		-1,
		87,
		72,
		65,
		55,
		69,
		40,
		-1,
		95,
		-1,
		-1,
		65,
		59,
		59,
		43,
		46,
		98,
		78,
		72,
		71,
		112,
		112,
		98,
		84,
		77,
		74,
		71,
		84,
		104,
		95,
		107,
		-1,
		-1,
		-1,
		92,
		78,
		82,
		42,
		61,
		-1,
		-1,
		127,
		82,
		68,
		-1,
		52,
		115,
		103,
		93,
		83,
		117,
		118,
		103,
		96,
		82,
		84,
		82,
		80,
		85,
		106,
		107,
		120,
		-1,
		-1,
		75,
		80,
		68,
		54,
		73,
		-1,
		-1,
		-1,
		74,
		90,
		82,
		53,
		104,
		-1,
		-1,
		95,
		93,
		103,
		99,
		86,
		106,
		109,
		95,
		79,
		94,
		106,
		114,
		119,
		-1,
		78,
		65,
		-1,
		-1,
		76,
		70,
		-1,
		-1,
		-1,
		-1,
		107,
		73,
		85,
		106,
		131,
		98,
		-1,
		103,
		104,
		90,
		104,
		111,
		97,
		92,
		86,
		89,
		107,
		124,
		-1,
		-1,
		90,
		-1,
		85,
		-1,
		-1,
		-1,
		-1,
		64,
		78,
		99,
		105,
		117,
		-1,
		112,
		106,
		92,
		109,
		110,
		107,
		98,
		90,
		95,
		92,
		105,
		119,
		123,
		113,
		-1,
		96,
		-1,
		-1,
		-1,
		82,
		97,
		159,
		136,
		109,
		113,
		106,
		100,
		100,
		116,
		118,
		129,
		97,
		93,
		94,
		98,
		97,
		114,
		124,
		-1,
		-1,
		96,
		113,
		108,
		90,
		94,
		186,
		-1,
		-1,
		122,
		113,
		104,
		107,
		110,
		113,
		103,
		100,
		105,
		110,
		98,
		107,
		125,
		129,
		-1,
		-1,
		-1,
		116,
		-1,
		131,
		-1,
		-1,
		109,
		193,
		140,
		122,
		118,
		116,
		109,
		118,
		113,
		108,
		118,
		127,
		119,
		100,
		111,
		134,
		123,
		161,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		145,
		120,
		135,
		181,
		129,
		136,
		155,
		152,
		-1,
		122,
		147,
		119,
		126,
		118,
		126,
		126,
		123,
		101,
		108,
		124,
		123,
		118,
		153,
		145,
		151,
		-1,
		-1,
		228,
		217,
		206,
		212,
		-1,
		151,
		137,
		167,
		157,
		146,
		-1,
		-1,
		171,
		168,
		144,
		128,
		132,
		125,
		120,
		130,
		110,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		123,
		204,
		197,
		180,
		188,
		219,
		-1,
		154,
		163,
		144,
		149,
		157,
		-1,
		-1,
		144,
		141,
		146,
		135,
		132,
		140,
		135,
		126,
		111,
		117,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		137,
		180,
		174,
		177,
		201,
		215,
		-1,
		167,
		-1,
		-1,
		152,
		170,
		159,
		149,
		143,
		193,
		149,
		144,
		134,
		132,
		123,
		114,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		172,
		160,
		168,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		168,
		-1,
		186,
		-1,
		161,
		165,
		157,
		160,
		148,
		135,
		127,
		119,
		135,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		246,
		201,
		168,
		159,
		206,
		221,
		225,
		-1,
		180,
		219,
		206,
		-1,
		177,
		-1,
		-1,
		-1,
		175,
		170,
		162,
		168,
		147,
		147,
		121,
		125,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		242,
		240,
		245,
		190,
		173,
		191,
		200,
		221,
		195,
		186,
		213,
		213,
		202,
		197,
		184,
		-1,
		-1,
		198,
		180,
		-1,
		-1,
		154,
		142,
		125,
		126,
		122,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		181,
		192,
		-1,
		-1,
		198,
		214,
		227,
		231,
		244,
		269,
		-1,
		187,
		-1,
		-1,
		199,
		-1,
		-1,
		184,
		147,
		136,
		127,
		133,
		130,
		141,
		151,
		139,
		140,
		130,
		140,
		153,
		226,
		223,
		211,
		209,
		232,
		189,
		185,
		-1,
		208,
		201,
		207,
		214,
		231,
		258,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		182,
		180,
		169,
		-1,
		159,
		132,
		137,
		157,
		159,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		193,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		213,
		-1,
		-1,
		177,
		170,
		158,
		146,
		136,
		146,
		150,
		154,
		146,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		269,
		-1,
		221,
		207,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		211,
		195,
		176,
		-1,
		146,
		159,
		190,
		158,
		163,
		158,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		227,
		229,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		183,
		179,
		-1,
		-1,
		147,
		172,
		161,
		169,
		164,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		226,
		227,
		232,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		185,
		148,
		169,
		179,
		173,
		171,
		162,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		149,
		175,
		178,
		184,
		178,
		151,
		166,
		156,
		147,
		156,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		200,
		185,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		190,
		186,
		173,
		173,
		165,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		166,
		201,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		173,
		174,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		163,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		156,
		148,
		207,
		163,
		134,
		128,
		146,
		141,
		150,
		142,
		-1,
		134,
		124,
		146,
		130,
		141,
		133,
		-1,
		-1,
		128,
		129,
		135,
		126,
		132,
		128,
		-1,
		138,
		122,
		-1,
		-1,
		118,
		124,
		108,
		111,
		119,
		117,
		130,
		122,
		117,
		-1,
		-1,
		114,
		110,
		117,
		104,
		100,
		117,
		130,
		112,
		126,
		125,
		-1,
		107,
		125,
		134,
		111,
		109,
		93,
		91,
		109,
		111,
		117,
		120,
		-1,
		111,
		113,
		112,
		120,
		125,
		109,
		96,
		96,
		106,
		99,
		118,
		109,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		99,
		116,
		108,
		98,
		113,
		106,
		99,
		96,
		94,
		91,
		107,
		108,
		118,
		-1,
		-1,
		164,
		133,
		168,
		125,
		110,
		-1,
		104,
		92,
		98,
		102,
		96,
		89,
		103,
		99,
		-1,
		85,
		84,
		115,
		101,
		112,
		124,
		-1,
		-1,
		122,
		114,
		99,
		102,
		99,
		99,
		107,
		106,
		98,
		84,
		80,
		86,
		89,
		89,
		95,
		79,
		89,
		93,
		104,
		119,
		-1,
		-1,
		174,
		-1,
		-1,
		121,
		104,
		-1,
		87,
		94,
		94,
		111,
		101,
		122,
		117,
		108,
		100,
		94,
		82,
		84,
		81,
		94,
		82,
		76,
		101,
		105,
		99,
		120,
		115,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		80,
		83,
		89,
		113,
		123,
		-1,
		106,
		112,
		118,
		103,
		100,
		87,
		75,
		88,
		73,
		80,
		79,
		83,
		85,
		118,
		96,
		118,
		115,
		144,
		149,
		143,
		152,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		117,
		-1,
		130,
		123,
		98,
		114,
		117,
		104,
		95,
		82,
		71,
		82,
		71,
		68,
		76,
		85,
		96,
		91,
		90,
		108,
		123,
		136,
		140,
		146,
		-1,
		179,
		-1,
		121,
		105,
		107,
		79,
		100,
		-1,
		137,
		129,
		115,
		100,
		91,
		-1,
		94,
		97,
		100,
		78,
		63,
		80,
		72,
		70,
		75,
		80,
		94,
		85,
		103,
		110,
		118,
		122,
		142,
		154,
		139,
		129,
		-1,
		111,
		116,
		75,
		83,
		102,
		133,
		97,
		-1,
		92,
		-1,
		84,
		109,
		-1,
		84,
		69,
		55,
		63,
		58,
		73,
		79,
		76,
		73,
		91,
		94,
		111,
		115,
		131,
		-1,
		-1,
		124,
		128,
		117,
		68,
		87,
		111,
		143,
		90,
		79,
		78,
		-1,
		69,
		65,
		62,
		48,
		35,
		53,
		56,
		63,
		77,
		56,
		75,
		78,
		100,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		94,
		65,
		89,
		131,
		108,
		101,
		89,
		54,
		54,
		48,
		-1,
		55,
		38,
		40,
		53,
		51,
		64,
		59,
		75,
		79,
		78,
		97,
		109,
		100,
		120,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		60,
		83,
		120,
		87,
		73,
		78,
		53,
		46,
		38,
		58,
		55,
		22,
		44,
		46,
		41,
		55,
		63,
		67,
		76,
		85,
		91,
		115,
		115,
		121,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		74,
		81,
		113,
		78,
		98,
		-1,
		43,
		-1,
		32,
		0,
		18,
		24,
		36,
		41,
		46,
		57,
		69,
		82,
		78,
		85,
		120,
		120,
		105,
		125,
		128,
		-1,
		-1,
		-1,
		124,
		119,
		94,
		71,
		55,
		91,
		-1,
		68,
		69,
		-1,
		37,
		31,
		4,
		13,
		22,
		38,
		38,
		52,
		60,
		56,
		72,
		78,
		70,
		106,
		-1,
		113,
		107,
		115,
		105,
		93,
		-1,
		-1,
		-1,
		117,
		96,
		89,
		109,
		50,
		102,
		-1,
		-1,
		53,
		46,
		-1,
		15,
		22,
		23,
		32,
		43,
		48,
		56,
		51,
		64,
		69,
		75,
		80,
		98,
		102,
		106,
		95,
		91,
		88,
		102,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		70,
		-1,
		62,
		54,
		44,
		38,
		32,
		27,
		25,
		46,
		38,
		59,
		59,
		65,
		73,
		58,
		61,
		77,
		75,
		93,
		101,
		93,
		87,
		86,
		98,
		-1,
		137,
		123,
		94,
		-1,
		-1,
		83,
		-1,
		47,
		61,
		77,
		-1,
		70,
		49,
		60,
		42,
		37,
		34,
		79,
		80,
		58,
		63,
		71,
		81,
		83,
		72,
		83,
		75,
		97,
		97,
		81,
		82,
		91,
		-1,
		143,
		130,
		88,
		84,
		73,
		93,
		44,
		32,
		64,
		-1,
		-1,
		106,
		-1,
		40,
		57,
		48,
		46,
		69,
		60,
		66,
		82,
		85,
		87,
		77,
		66,
		72,
		69,
		91,
		77,
		75,
		94,
		110,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		59,
		46,
		40,
		-1,
		81,
		-1,
		84,
		74,
		58,
		43,
		76,
		-1,
		77,
		61,
		66,
		-1,
		112,
		-1,
		85,
		87,
		81,
		66,
		63,
		74,
		72,
		83,
		100,
		-1,
		93,
		78,
		71,
		61,
		75,
		46,
		-1,
		101,
		-1,
		-1,
		71,
		65,
		65,
		49,
		52,
		93,
		73,
		67,
		66,
		107,
		107,
		93,
		79,
		72,
		69,
		66,
		79,
		99,
		90,
		102,
		-1,
		-1,
		-1,
		98,
		84,
		88,
		48,
		67,
		-1,
		-1,
		133,
		88,
		74,
		-1,
		58,
		110,
		98,
		88,
		78,
		112,
		113,
		98,
		91,
		77,
		79,
		77,
		75,
		80,
		101,
		102,
		115,
		-1,
		-1,
		81,
		86,
		74,
		60,
		79,
		-1,
		-1,
		-1,
		80,
		96,
		88,
		59,
		99,
		-1,
		-1,
		90,
		88,
		98,
		94,
		81,
		101,
		104,
		90,
		74,
		89,
		101,
		109,
		114,
		-1,
		84,
		71,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		91,
		112,
		135,
		93,
		-1,
		98,
		99,
		85,
		99,
		106,
		92,
		87,
		81,
		84,
		102,
		119,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		70,
		84,
		105,
		111,
		121,
		-1,
		107,
		101,
		87,
		104,
		105,
		102,
		93,
		85,
		90,
		87,
		100,
		114,
		118,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		88,
		103,
		163,
		140,
		113,
		108,
		101,
		95,
		95,
		111,
		113,
		124,
		92,
		88,
		89,
		93,
		92,
		109,
		119,
		-1,
		-1,
		102,
		119,
		114,
		96,
		100,
		190,
		-1,
		-1,
		117,
		108,
		99,
		102,
		105,
		108,
		98,
		95,
		100,
		105,
		93,
		102,
		120,
		124,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		115,
		188,
		135,
		117,
		113,
		111,
		104,
		113,
		108,
		103,
		113,
		122,
		114,
		95,
		106,
		129,
		118,
		156,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		135,
		142,
		150,
		147,
		-1,
		117,
		142,
		114,
		121,
		113,
		121,
		121,
		118,
		96,
		103,
		119,
		118,
		113,
		148,
		140,
		146,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		157,
		143,
		173,
		163,
		152,
		-1,
		-1,
		166,
		163,
		139,
		123,
		127,
		120,
		115,
		125,
		105,
		92,
		96,
		100,
		106,
		111,
		116,
		122,
		137,
		152,
		-1,
		129,
		210,
		203,
		186,
		194,
		225,
		-1,
		160,
		169,
		150,
		155,
		163,
		-1,
		-1,
		139,
		136,
		141,
		130,
		127,
		135,
		130,
		121,
		106,
		112,
		99,
		98,
		116,
		120,
		129,
		136,
		126,
		139,
		143,
		-1,
		143,
		186,
		180,
		183,
		207,
		221,
		-1,
		173,
		-1,
		-1,
		158,
		170,
		154,
		144,
		138,
		188,
		144,
		139,
		129,
		127,
		118,
		109,
		116,
		107,
		107,
		110,
		125,
		130,
		122,
		136,
		136,
		137,
		-1,
		178,
		166,
		174,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		181,
		-1,
		156,
		160,
		152,
		155,
		143,
		130,
		122,
		114,
		130,
		105,
		115,
		111,
		112,
		121,
		132,
		144,
		143,
		144,
		252,
		207,
		174,
		165,
		212,
		227,
		231,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		170,
		165,
		157,
		163,
		142,
		142,
		116,
		120,
		110,
		117,
		127,
		129,
		121,
		125,
		138,
		149,
		152,
		248,
		245,
		251,
		196,
		179,
		197,
		206,
		227,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		193,
		175,
		-1,
		-1,
		149,
		137,
		120,
		121,
		117,
		120,
		135,
		138,
		128,
		126,
		120,
		152,
		-1,
		247,
		246,
		235,
		232,
		208,
		199,
		187,
		198,
		-1,
		-1,
		204,
		220,
		227,
		231,
		247,
		272,
		-1,
		193,
		-1,
		-1,
		194,
		-1,
		-1,
		179,
		142,
		131,
		122,
		128,
		125,
		136,
		146,
		134,
		135,
		125,
		135,
		148,
		231,
		228,
		216,
		214,
		237,
		195,
		190,
		-1,
		203,
		201,
		207,
		214,
		231,
		261,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		177,
		175,
		164,
		-1,
		154,
		127,
		132,
		152,
		154,
		143,
		137,
		131,
		138,
		137,
		145,
		153,
		240,
		254,
		243,
		239,
		238,
		246,
		195,
		188,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		215,
		211,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		145,
		149,
		141,
		134,
		129,
		140,
		132,
		136,
		153,
		-1,
		274,
		-1,
		226,
		202,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		232,
		218,
		211,
		199,
		197,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		185,
		153,
		158,
		153,
		135,
		146,
		135,
		138,
		152,
		147,
		-1,
		-1,
		214,
		217,
		-1,
		-1,
		222,
		224,
		-1,
		223,
		212,
		197,
		189,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		142,
		167,
		156,
		164,
		159,
		139,
		145,
		148,
		137,
		141,
		153,
		-1,
		-1,
		221,
		222,
		227,
		-1,
		207,
		-1,
		225,
		-1,
		192,
		198,
		186,
		-1,
		-1,
		-1,
		180,
		143,
		164,
		174,
		168,
		166,
		157,
		143,
		150,
		148,
		144,
		155,
		-1,
		-1,
		-1,
		225,
		199,
		232,
		223,
		206,
		186,
		178,
		197,
		-1,
		167,
		-1,
		142,
		144,
		170,
		173,
		179,
		173,
		146,
		161,
		151,
		142,
		151,
		231,
		-1,
		201,
		234,
		198,
		192,
		168,
		172,
		188,
		-1,
		164,
		146,
		-1,
		174,
		164,
		195,
		180,
		161,
		148,
		155,
		155,
		148,
		-1,
		-1,
		-1,
		203,
		202,
		194,
		188,
		188,
		173,
		164,
		-1,
		176,
		158,
		137,
		154,
		154,
		145,
		153,
		185,
		181,
		168,
		168,
		160,
		-1,
		304,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		197,
		192,
		165,
		153,
		159,
		155,
		141,
		147,
		149,
		157,
		155,
		152,
		164,
		160,
		180,
		161,
		196,
		-1,
		299,
		-1,
		233,
		-1,
		-1,
		215,
		195,
		187,
		176,
		165,
		163,
		154,
		145,
		167,
		183,
		167,
		165,
		168,
		169,
		-1,
		288,
		287,
		-1,
		234,
		226,
		212,
		-1,
		205,
		-1,
		211,
		172,
		-1,
		174,
		154,
		-1,
		176,
		172,
		-1,
		-1,
		275,
		250,
		-1,
		-1,
		-1,
		235,
		215,
		206,
		190,
		-1,
		165,
		165,
		-1,
		-1,
		-1,
		260,
		259,
		-1,
		228,
		231,
		-1,
		221,
		212,
		220,
		167,
		171,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		243,
		241,
		236,
		233,
		219,
		203,
		181,
		170,
		191,
		-1,
		-1,
		-1,
		241,
		233,
		226,
		-1,
		-1,
		228,
		211,
		192,
		190,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		218,
		-1,
		-1,
		224,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		252,
		-1,
		-1,
		-1,
		214,
		210,
		211,
		-1,
		-1,
		-1,
		-1,
		274,
		275,
		298,
		262,
		-1,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		277,
		275,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		204,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		239,
		-1,
		239,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		252,
		244,
		252,
		-1,
		224,
		226,
		-1,
		274,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		229,
		236,
		258,
		261,
		297,
		-1,
		248
	],
	[
		-1,
		157,
		146,
		157,
		165,
		138,
		145,
		-1,
		166,
		168,
		134,
		128,
		167,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		157,
		156,
		126,
		124,
		133,
		138,
		145,
		-1,
		149,
		-1,
		178,
		157,
		168,
		173,
		119,
		116,
		136,
		155,
		142,
		134,
		193,
		149,
		120,
		114,
		132,
		127,
		136,
		128,
		-1,
		120,
		110,
		132,
		116,
		127,
		119,
		-1,
		-1,
		114,
		115,
		121,
		112,
		118,
		114,
		-1,
		124,
		108,
		-1,
		-1,
		104,
		110,
		94,
		97,
		105,
		103,
		116,
		108,
		103,
		-1,
		-1,
		100,
		96,
		103,
		90,
		86,
		103,
		116,
		98,
		112,
		111,
		-1,
		93,
		111,
		120,
		97,
		95,
		79,
		77,
		95,
		97,
		103,
		106,
		-1,
		102,
		103,
		98,
		106,
		111,
		95,
		82,
		82,
		92,
		85,
		104,
		95,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		102,
		85,
		102,
		94,
		84,
		99,
		92,
		85,
		82,
		80,
		77,
		93,
		94,
		104,
		-1,
		-1,
		164,
		133,
		168,
		125,
		110,
		-1,
		98,
		78,
		84,
		88,
		82,
		75,
		89,
		85,
		-1,
		71,
		70,
		101,
		87,
		98,
		124,
		-1,
		-1,
		122,
		114,
		99,
		102,
		99,
		99,
		93,
		92,
		84,
		70,
		66,
		72,
		75,
		75,
		81,
		65,
		75,
		79,
		90,
		105,
		-1,
		-1,
		160,
		-1,
		-1,
		121,
		104,
		-1,
		87,
		94,
		94,
		111,
		101,
		122,
		103,
		94,
		86,
		80,
		68,
		70,
		67,
		80,
		68,
		62,
		87,
		91,
		85,
		106,
		101,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		80,
		83,
		89,
		113,
		123,
		-1,
		113,
		103,
		104,
		89,
		86,
		73,
		61,
		74,
		59,
		66,
		65,
		69,
		71,
		104,
		82,
		104,
		101,
		130,
		135,
		129,
		138,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		117,
		-1,
		131,
		130,
		105,
		100,
		103,
		90,
		81,
		68,
		57,
		68,
		57,
		54,
		62,
		71,
		82,
		77,
		76,
		94,
		109,
		122,
		126,
		132,
		-1,
		179,
		-1,
		121,
		105,
		107,
		79,
		100,
		-1,
		137,
		132,
		122,
		107,
		98,
		-1,
		99,
		96,
		86,
		64,
		49,
		66,
		58,
		56,
		61,
		66,
		80,
		71,
		89,
		96,
		104,
		108,
		128,
		140,
		139,
		129,
		-1,
		111,
		116,
		75,
		83,
		102,
		140,
		104,
		-1,
		99,
		-1,
		91,
		114,
		-1,
		70,
		66,
		48,
		49,
		44,
		59,
		65,
		62,
		59,
		77,
		80,
		97,
		101,
		117,
		-1,
		-1,
		124,
		128,
		117,
		68,
		87,
		111,
		148,
		97,
		86,
		85,
		-1,
		76,
		62,
		59,
		45,
		32,
		41,
		42,
		50,
		63,
		42,
		61,
		64,
		86,
		114,
		92,
		104,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		94,
		65,
		89,
		131,
		115,
		108,
		96,
		61,
		61,
		55,
		-1,
		52,
		35,
		37,
		39,
		37,
		50,
		47,
		61,
		65,
		64,
		83,
		95,
		86,
		106,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		60,
		83,
		120,
		94,
		80,
		85,
		60,
		53,
		47,
		55,
		52,
		19,
		41,
		32,
		27,
		43,
		51,
		53,
		62,
		71,
		77,
		101,
		108,
		114,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		74,
		81,
		113,
		85,
		98,
		-1,
		52,
		-1,
		41,
		17,
		0,
		10,
		22,
		33,
		34,
		43,
		57,
		68,
		64,
		71,
		106,
		106,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		124,
		119,
		94,
		71,
		55,
		91,
		-1,
		68,
		69,
		-1,
		46,
		40,
		21,
		3,
		8,
		25,
		26,
		41,
		48,
		44,
		58,
		69,
		56,
		92,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		117,
		96,
		89,
		109,
		50,
		102,
		-1,
		-1,
		53,
		46,
		-1,
		32,
		15,
		22,
		26,
		35,
		40,
		49,
		42,
		55,
		60,
		61,
		71,
		91,
		95,
		99,
		88,
		84,
		81,
		95,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		70,
		-1,
		62,
		54,
		44,
		38,
		32,
		28,
		26,
		46,
		38,
		52,
		52,
		56,
		64,
		49,
		52,
		64,
		68,
		86,
		94,
		86,
		80,
		79,
		91,
		-1,
		137,
		123,
		94,
		-1,
		-1,
		83,
		-1,
		47,
		61,
		77,
		-1,
		70,
		49,
		64,
		42,
		38,
		34,
		72,
		73,
		51,
		56,
		63,
		73,
		74,
		63,
		76,
		68,
		90,
		90,
		74,
		75,
		84,
		-1,
		143,
		130,
		88,
		84,
		73,
		93,
		44,
		32,
		64,
		-1,
		-1,
		106,
		-1,
		40,
		57,
		48,
		46,
		62,
		53,
		59,
		74,
		77,
		78,
		68,
		57,
		63,
		62,
		84,
		70,
		68,
		87,
		103,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		59,
		46,
		40,
		-1,
		81,
		-1,
		84,
		74,
		58,
		43,
		76,
		-1,
		70,
		54,
		59,
		-1,
		103,
		-1,
		76,
		78,
		70,
		59,
		56,
		67,
		65,
		76,
		93,
		-1,
		93,
		78,
		71,
		61,
		75,
		46,
		-1,
		101,
		-1,
		-1,
		71,
		65,
		65,
		49,
		52,
		86,
		66,
		60,
		59,
		98,
		96,
		84,
		68,
		61,
		58,
		59,
		72,
		92,
		83,
		95,
		-1,
		-1,
		-1,
		98,
		84,
		88,
		48,
		67,
		-1,
		-1,
		133,
		88,
		74,
		-1,
		58,
		103,
		91,
		81,
		71,
		105,
		106,
		87,
		80,
		66,
		68,
		66,
		68,
		73,
		94,
		95,
		108,
		-1,
		-1,
		81,
		86,
		74,
		60,
		79,
		-1,
		-1,
		-1,
		80,
		96,
		88,
		59,
		92,
		-1,
		-1,
		83,
		81,
		91,
		83,
		70,
		90,
		93,
		83,
		67,
		82,
		94,
		102,
		107,
		-1,
		84,
		71,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		91,
		112,
		128,
		86,
		-1,
		91,
		92,
		74,
		88,
		95,
		85,
		80,
		74,
		77,
		95,
		112,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		70,
		84,
		105,
		110,
		114,
		-1,
		100,
		90,
		76,
		93,
		98,
		95,
		86,
		78,
		83,
		80,
		93,
		107,
		111,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		88,
		103,
		156,
		133,
		106,
		101,
		94,
		88,
		84,
		100,
		106,
		117,
		85,
		81,
		82,
		86,
		85,
		102,
		112,
		-1,
		-1,
		102,
		119,
		114,
		96,
		100,
		183,
		-1,
		-1,
		110,
		101,
		92,
		95,
		94,
		97,
		91,
		88,
		93,
		98,
		86,
		95,
		113,
		112,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		115,
		181,
		128,
		110,
		106,
		104,
		97,
		106,
		101,
		96,
		106,
		108,
		100,
		88,
		92,
		115,
		104,
		143,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		135,
		142,
		143,
		140,
		-1,
		110,
		135,
		107,
		114,
		105,
		112,
		112,
		104,
		82,
		89,
		105,
		104,
		99,
		135,
		126,
		132,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		157,
		143,
		173,
		163,
		152,
		-1,
		-1,
		159,
		156,
		132,
		115,
		113,
		106,
		101,
		111,
		91,
		78,
		82,
		86,
		92,
		97,
		102,
		108,
		123,
		138,
		-1,
		129,
		210,
		203,
		186,
		194,
		225,
		-1,
		160,
		169,
		150,
		155,
		162,
		-1,
		-1,
		132,
		129,
		134,
		122,
		119,
		121,
		116,
		107,
		92,
		98,
		85,
		84,
		102,
		106,
		115,
		122,
		112,
		125,
		129,
		-1,
		143,
		186,
		180,
		183,
		207,
		221,
		-1,
		173,
		-1,
		-1,
		158,
		163,
		147,
		137,
		131,
		181,
		136,
		131,
		115,
		113,
		104,
		95,
		102,
		93,
		93,
		96,
		111,
		116,
		108,
		122,
		122,
		123,
		-1,
		178,
		166,
		174,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		174,
		-1,
		149,
		153,
		144,
		147,
		129,
		116,
		108,
		100,
		116,
		91,
		101,
		97,
		98,
		107,
		118,
		130,
		129,
		130,
		250,
		206,
		174,
		165,
		212,
		227,
		231,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		163,
		157,
		149,
		149,
		128,
		128,
		102,
		106,
		96,
		103,
		113,
		115,
		107,
		111,
		124,
		135,
		138,
		246,
		237,
		250,
		195,
		179,
		197,
		206,
		227,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		135,
		123,
		106,
		107,
		103,
		106,
		121,
		124,
		114,
		112,
		106,
		138,
		-1,
		239,
		238,
		227,
		224,
		200,
		191,
		186,
		198,
		-1,
		-1,
		204,
		220,
		219,
		223,
		239,
		264,
		-1,
		193,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		128,
		117,
		108,
		114,
		111,
		122,
		132,
		120,
		121,
		111,
		121,
		134,
		223,
		220,
		208,
		206,
		229,
		194,
		182,
		-1,
		195,
		193,
		199,
		206,
		223,
		253,
		-1,
		-1,
		209,
		191,
		-1,
		-1,
		163,
		161,
		150,
		-1,
		140,
		113,
		118,
		138,
		140,
		129,
		123,
		117,
		124,
		123,
		131,
		139,
		232,
		246,
		235,
		231,
		230,
		238,
		187,
		180,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		197,
		-1,
		-1,
		158,
		151,
		139,
		127,
		117,
		127,
		131,
		135,
		127,
		120,
		115,
		126,
		118,
		122,
		139,
		-1,
		266,
		-1,
		218,
		194,
		208,
		223,
		231,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		192,
		176,
		157,
		-1,
		127,
		140,
		171,
		139,
		144,
		139,
		121,
		132,
		121,
		124,
		138,
		133,
		-1,
		-1,
		206,
		209,
		-1,
		-1,
		208,
		210,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		164,
		160,
		-1,
		-1,
		128,
		153,
		142,
		150,
		145,
		125,
		131,
		134,
		123,
		127,
		139,
		-1,
		-1,
		213,
		214,
		215,
		-1,
		193,
		-1,
		211,
		-1,
		178,
		184,
		172,
		-1,
		-1,
		-1,
		166,
		129,
		150,
		160,
		154,
		152,
		143,
		129,
		136,
		134,
		130,
		141,
		-1,
		-1,
		-1,
		211,
		185,
		218,
		209,
		192,
		172,
		164,
		183,
		-1,
		153,
		-1,
		128,
		130,
		156,
		159,
		165,
		159,
		132,
		147,
		137,
		128,
		137,
		217,
		-1,
		187,
		220,
		184,
		178,
		154,
		158,
		174,
		-1,
		150,
		132,
		-1,
		160,
		150,
		181,
		166,
		147,
		134,
		141,
		141,
		134,
		-1,
		-1,
		-1,
		189,
		188,
		180,
		174,
		174,
		159,
		150,
		-1,
		162,
		144,
		123,
		140,
		140,
		131,
		139,
		171,
		167,
		154,
		154,
		146,
		-1,
		290,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		183,
		178,
		151,
		139,
		145,
		141,
		127,
		133,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		147,
		182,
		-1,
		285,
		-1,
		219,
		-1,
		-1,
		201,
		181,
		173,
		162,
		151,
		149,
		140,
		131,
		153,
		169,
		153,
		151,
		154,
		155,
		-1,
		274,
		273,
		-1,
		220,
		212,
		198,
		-1,
		191,
		-1,
		197,
		158,
		-1,
		160,
		140,
		-1,
		162,
		158,
		-1,
		-1,
		261,
		236,
		-1,
		-1,
		-1,
		221,
		201,
		192,
		176,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		246,
		245,
		-1,
		214,
		217,
		-1,
		207,
		198,
		206,
		153,
		157,
		-1,
		-1,
		-1,
		255,
		236,
		230,
		229,
		227,
		222,
		219,
		205,
		189,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		227,
		219,
		212,
		-1,
		-1,
		214,
		197,
		178,
		176,
		-1,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		204,
		-1,
		-1,
		210,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		238,
		-1,
		-1,
		-1,
		200,
		196,
		197,
		-1,
		-1,
		-1,
		-1,
		260,
		261,
		284,
		248,
		-1,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		263,
		261,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		190,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		225,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		238,
		230,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		215,
		222,
		244,
		247,
		283,
		-1,
		234
	],
	[
		-1,
		156,
		145,
		156,
		164,
		137,
		144,
		-1,
		165,
		167,
		133,
		127,
		166,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		156,
		155,
		125,
		123,
		132,
		137,
		144,
		-1,
		148,
		-1,
		177,
		156,
		167,
		172,
		118,
		115,
		135,
		154,
		141,
		133,
		192,
		148,
		119,
		113,
		131,
		126,
		135,
		127,
		-1,
		119,
		109,
		131,
		115,
		126,
		118,
		-1,
		-1,
		113,
		114,
		120,
		111,
		117,
		113,
		-1,
		123,
		107,
		-1,
		-1,
		103,
		109,
		93,
		96,
		104,
		102,
		115,
		107,
		102,
		-1,
		-1,
		99,
		95,
		102,
		89,
		85,
		102,
		115,
		97,
		111,
		110,
		-1,
		92,
		110,
		119,
		96,
		94,
		78,
		76,
		94,
		96,
		102,
		105,
		-1,
		101,
		102,
		97,
		105,
		110,
		94,
		81,
		81,
		91,
		84,
		103,
		94,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		101,
		84,
		101,
		93,
		83,
		98,
		91,
		84,
		81,
		79,
		76,
		92,
		93,
		103,
		-1,
		-1,
		170,
		139,
		174,
		131,
		116,
		-1,
		97,
		77,
		83,
		87,
		81,
		74,
		88,
		84,
		-1,
		70,
		69,
		100,
		86,
		97,
		130,
		-1,
		-1,
		128,
		120,
		105,
		108,
		105,
		103,
		92,
		91,
		83,
		69,
		65,
		71,
		74,
		74,
		80,
		64,
		74,
		78,
		89,
		104,
		-1,
		-1,
		159,
		-1,
		-1,
		127,
		110,
		-1,
		93,
		100,
		100,
		117,
		105,
		126,
		102,
		93,
		85,
		79,
		67,
		69,
		66,
		79,
		67,
		61,
		86,
		90,
		84,
		105,
		100,
		-1,
		158,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		86,
		89,
		95,
		119,
		129,
		-1,
		114,
		102,
		103,
		88,
		85,
		72,
		60,
		73,
		58,
		65,
		64,
		68,
		70,
		103,
		81,
		103,
		100,
		129,
		134,
		128,
		137,
		-1,
		135,
		131,
		127,
		134,
		83,
		-1,
		-1,
		123,
		-1,
		137,
		136,
		111,
		99,
		102,
		89,
		80,
		67,
		56,
		67,
		56,
		53,
		61,
		70,
		81,
		76,
		75,
		93,
		108,
		121,
		125,
		131,
		-1,
		185,
		-1,
		127,
		111,
		113,
		85,
		106,
		-1,
		143,
		138,
		128,
		113,
		104,
		-1,
		98,
		95,
		85,
		63,
		48,
		65,
		57,
		55,
		60,
		65,
		79,
		70,
		88,
		95,
		103,
		107,
		127,
		139,
		145,
		135,
		-1,
		117,
		122,
		81,
		89,
		108,
		146,
		110,
		-1,
		105,
		-1,
		97,
		113,
		-1,
		69,
		61,
		47,
		48,
		43,
		58,
		64,
		61,
		58,
		76,
		79,
		96,
		100,
		116,
		-1,
		-1,
		130,
		134,
		123,
		74,
		93,
		117,
		154,
		103,
		92,
		91,
		-1,
		82,
		57,
		54,
		40,
		27,
		40,
		41,
		49,
		62,
		41,
		60,
		63,
		85,
		113,
		91,
		103,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		100,
		71,
		95,
		137,
		121,
		114,
		102,
		67,
		67,
		61,
		-1,
		47,
		30,
		32,
		38,
		36,
		49,
		46,
		60,
		64,
		63,
		82,
		94,
		85,
		105,
		-1,
		-1,
		-1,
		130,
		119,
		120,
		66,
		89,
		126,
		100,
		86,
		91,
		66,
		59,
		53,
		50,
		47,
		14,
		36,
		31,
		26,
		42,
		50,
		52,
		61,
		70,
		76,
		100,
		107,
		113,
		-1,
		-1,
		137,
		127,
		111,
		113,
		110,
		80,
		87,
		119,
		91,
		104,
		-1,
		58,
		-1,
		47,
		25,
		8,
		0,
		21,
		32,
		33,
		42,
		56,
		67,
		63,
		70,
		105,
		105,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		130,
		125,
		100,
		77,
		61,
		97,
		-1,
		74,
		75,
		-1,
		52,
		46,
		29,
		11,
		5,
		24,
		25,
		40,
		47,
		43,
		57,
		68,
		55,
		91,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		123,
		102,
		95,
		115,
		56,
		108,
		-1,
		-1,
		59,
		52,
		-1,
		39,
		21,
		28,
		25,
		34,
		39,
		50,
		41,
		54,
		59,
		60,
		70,
		90,
		94,
		98,
		87,
		83,
		80,
		94,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		56,
		76,
		-1,
		68,
		60,
		50,
		44,
		38,
		34,
		32,
		52,
		39,
		51,
		53,
		55,
		63,
		48,
		51,
		63,
		67,
		85,
		93,
		85,
		79,
		78,
		90,
		-1,
		143,
		129,
		100,
		-1,
		-1,
		89,
		-1,
		53,
		67,
		83,
		-1,
		76,
		55,
		70,
		48,
		44,
		40,
		75,
		76,
		54,
		59,
		62,
		72,
		73,
		62,
		75,
		67,
		89,
		89,
		73,
		74,
		83,
		-1,
		149,
		136,
		94,
		90,
		79,
		99,
		50,
		38,
		70,
		-1,
		-1,
		112,
		-1,
		46,
		63,
		54,
		52,
		65,
		56,
		62,
		73,
		76,
		77,
		67,
		56,
		62,
		61,
		83,
		69,
		67,
		86,
		102,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		65,
		52,
		46,
		-1,
		87,
		-1,
		90,
		80,
		64,
		49,
		82,
		-1,
		73,
		57,
		62,
		-1,
		102,
		-1,
		75,
		77,
		69,
		58,
		55,
		66,
		64,
		75,
		92,
		-1,
		99,
		84,
		77,
		67,
		81,
		52,
		-1,
		107,
		-1,
		-1,
		77,
		71,
		71,
		55,
		58,
		89,
		69,
		63,
		62,
		97,
		95,
		83,
		67,
		60,
		57,
		58,
		71,
		91,
		82,
		94,
		-1,
		-1,
		-1,
		104,
		90,
		94,
		54,
		73,
		-1,
		-1,
		139,
		94,
		80,
		-1,
		64,
		106,
		94,
		84,
		74,
		108,
		109,
		86,
		79,
		65,
		67,
		65,
		67,
		72,
		93,
		94,
		107,
		-1,
		-1,
		87,
		92,
		80,
		66,
		85,
		-1,
		-1,
		-1,
		86,
		102,
		94,
		65,
		95,
		-1,
		-1,
		86,
		84,
		94,
		82,
		69,
		89,
		92,
		82,
		66,
		81,
		93,
		101,
		106,
		-1,
		90,
		77,
		-1,
		-1,
		88,
		82,
		-1,
		-1,
		-1,
		-1,
		119,
		85,
		97,
		118,
		127,
		89,
		-1,
		94,
		93,
		73,
		87,
		94,
		84,
		79,
		73,
		76,
		94,
		111,
		-1,
		-1,
		102,
		-1,
		97,
		-1,
		-1,
		-1,
		-1,
		76,
		90,
		111,
		109,
		113,
		-1,
		101,
		89,
		75,
		92,
		97,
		94,
		85,
		77,
		82,
		79,
		92,
		106,
		110,
		125,
		-1,
		108,
		-1,
		-1,
		-1,
		94,
		109,
		155,
		132,
		105,
		100,
		93,
		87,
		83,
		99,
		105,
		116,
		84,
		80,
		81,
		85,
		84,
		101,
		111,
		-1,
		-1,
		108,
		125,
		120,
		102,
		106,
		182,
		-1,
		-1,
		109,
		100,
		91,
		94,
		93,
		96,
		90,
		87,
		92,
		97,
		85,
		94,
		112,
		111,
		-1,
		-1,
		-1,
		128,
		-1,
		143,
		-1,
		-1,
		121,
		180,
		127,
		109,
		105,
		103,
		96,
		105,
		100,
		95,
		105,
		107,
		99,
		87,
		91,
		114,
		103,
		142,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		157,
		132,
		147,
		191,
		141,
		148,
		142,
		139,
		-1,
		109,
		134,
		106,
		113,
		104,
		111,
		111,
		103,
		81,
		88,
		104,
		103,
		98,
		134,
		125,
		131,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		163,
		149,
		177,
		167,
		158,
		-1,
		-1,
		158,
		155,
		131,
		114,
		112,
		105,
		100,
		110,
		90,
		77,
		81,
		85,
		91,
		96,
		101,
		107,
		122,
		137,
		-1,
		135,
		216,
		209,
		192,
		200,
		231,
		-1,
		166,
		173,
		156,
		159,
		161,
		-1,
		-1,
		131,
		128,
		133,
		121,
		118,
		120,
		115,
		106,
		91,
		97,
		84,
		83,
		101,
		105,
		114,
		121,
		111,
		124,
		128,
		-1,
		149,
		192,
		186,
		189,
		213,
		227,
		-1,
		178,
		-1,
		-1,
		164,
		162,
		146,
		136,
		130,
		180,
		135,
		130,
		114,
		112,
		103,
		94,
		101,
		92,
		92,
		95,
		110,
		115,
		107,
		121,
		121,
		122,
		-1,
		184,
		172,
		180,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		180,
		-1,
		173,
		-1,
		148,
		152,
		143,
		146,
		128,
		115,
		107,
		99,
		115,
		90,
		100,
		96,
		97,
		106,
		117,
		129,
		128,
		129,
		249,
		205,
		180,
		171,
		218,
		233,
		237,
		-1,
		190,
		229,
		218,
		-1,
		189,
		-1,
		-1,
		-1,
		162,
		156,
		148,
		148,
		127,
		127,
		101,
		105,
		95,
		102,
		112,
		114,
		106,
		110,
		123,
		134,
		137,
		245,
		236,
		249,
		194,
		185,
		203,
		212,
		233,
		205,
		196,
		223,
		225,
		214,
		209,
		196,
		-1,
		-1,
		185,
		166,
		-1,
		-1,
		134,
		122,
		105,
		106,
		102,
		105,
		120,
		123,
		113,
		111,
		105,
		137,
		-1,
		238,
		237,
		226,
		223,
		199,
		190,
		185,
		204,
		-1,
		-1,
		207,
		224,
		218,
		222,
		238,
		263,
		-1,
		194,
		-1,
		-1,
		179,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		110,
		121,
		131,
		119,
		120,
		110,
		120,
		133,
		222,
		219,
		207,
		205,
		228,
		193,
		181,
		-1,
		194,
		192,
		198,
		205,
		222,
		252,
		-1,
		-1,
		210,
		190,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		112,
		117,
		137,
		139,
		128,
		122,
		116,
		123,
		122,
		130,
		138,
		231,
		245,
		234,
		230,
		229,
		237,
		186,
		179,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		200,
		196,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		130,
		134,
		126,
		119,
		114,
		125,
		117,
		121,
		138,
		-1,
		265,
		-1,
		217,
		193,
		207,
		222,
		230,
		-1,
		-1,
		-1,
		217,
		203,
		196,
		184,
		182,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		120,
		131,
		120,
		123,
		137,
		132,
		-1,
		-1,
		205,
		208,
		-1,
		-1,
		207,
		209,
		-1,
		208,
		197,
		182,
		174,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		124,
		130,
		133,
		122,
		126,
		138,
		-1,
		-1,
		212,
		213,
		214,
		-1,
		192,
		-1,
		210,
		-1,
		177,
		183,
		171,
		-1,
		-1,
		-1,
		165,
		128,
		149,
		159,
		153,
		151,
		142,
		128,
		135,
		133,
		129,
		140,
		-1,
		-1,
		-1,
		210,
		184,
		217,
		208,
		191,
		171,
		163,
		182,
		-1,
		152,
		-1,
		127,
		129,
		155,
		158,
		164,
		158,
		131,
		146,
		136,
		127,
		136,
		216,
		-1,
		186,
		219,
		183,
		177,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		180,
		165,
		146,
		133,
		140,
		140,
		133,
		-1,
		-1,
		-1,
		188,
		187,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		170,
		166,
		153,
		153,
		145,
		-1,
		289,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		146,
		181,
		-1,
		284,
		-1,
		218,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		153,
		154,
		-1,
		273,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		148,
		137,
		148,
		156,
		129,
		136,
		-1,
		157,
		159,
		125,
		119,
		158,
		129,
		135,
		146,
		-1,
		-1,
		-1,
		148,
		147,
		117,
		115,
		124,
		129,
		136,
		-1,
		140,
		-1,
		169,
		148,
		159,
		164,
		110,
		107,
		127,
		146,
		133,
		125,
		184,
		140,
		111,
		105,
		123,
		118,
		127,
		119,
		-1,
		111,
		101,
		123,
		107,
		118,
		110,
		-1,
		-1,
		105,
		106,
		112,
		103,
		109,
		105,
		-1,
		115,
		99,
		-1,
		-1,
		95,
		101,
		85,
		88,
		96,
		94,
		107,
		99,
		94,
		-1,
		-1,
		91,
		87,
		94,
		81,
		77,
		94,
		107,
		89,
		103,
		102,
		-1,
		84,
		102,
		111,
		88,
		86,
		70,
		68,
		86,
		88,
		94,
		97,
		-1,
		93,
		94,
		89,
		97,
		102,
		86,
		73,
		73,
		83,
		76,
		95,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		76,
		93,
		85,
		75,
		90,
		83,
		76,
		73,
		71,
		68,
		84,
		85,
		95,
		-1,
		-1,
		179,
		148,
		183,
		140,
		123,
		-1,
		89,
		69,
		75,
		79,
		73,
		66,
		80,
		76,
		-1,
		62,
		61,
		92,
		78,
		89,
		139,
		-1,
		-1,
		137,
		129,
		114,
		117,
		99,
		95,
		84,
		83,
		75,
		61,
		57,
		63,
		66,
		66,
		72,
		56,
		66,
		70,
		81,
		96,
		-1,
		-1,
		151,
		-1,
		-1,
		136,
		119,
		-1,
		102,
		109,
		105,
		111,
		97,
		118,
		94,
		85,
		77,
		71,
		59,
		61,
		58,
		71,
		59,
		53,
		78,
		82,
		76,
		97,
		92,
		-1,
		150,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		95,
		98,
		104,
		128,
		134,
		-1,
		106,
		94,
		95,
		80,
		77,
		64,
		52,
		65,
		50,
		57,
		56,
		60,
		62,
		95,
		73,
		95,
		92,
		121,
		126,
		120,
		129,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		132,
		-1,
		142,
		143,
		118,
		91,
		94,
		81,
		72,
		59,
		48,
		59,
		48,
		45,
		53,
		62,
		73,
		68,
		67,
		85,
		100,
		113,
		117,
		123,
		-1,
		194,
		-1,
		136,
		120,
		122,
		94,
		115,
		-1,
		152,
		143,
		135,
		120,
		113,
		-1,
		90,
		87,
		77,
		55,
		40,
		57,
		49,
		47,
		52,
		57,
		71,
		62,
		80,
		87,
		95,
		99,
		119,
		131,
		154,
		144,
		-1,
		126,
		131,
		90,
		98,
		117,
		155,
		119,
		-1,
		114,
		-1,
		92,
		105,
		-1,
		61,
		57,
		39,
		40,
		35,
		50,
		56,
		53,
		50,
		68,
		71,
		88,
		92,
		108,
		-1,
		-1,
		139,
		143,
		132,
		83,
		102,
		126,
		163,
		112,
		101,
		100,
		-1,
		91,
		66,
		63,
		49,
		36,
		32,
		33,
		34,
		54,
		33,
		52,
		55,
		77,
		105,
		83,
		95,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		109,
		80,
		104,
		146,
		130,
		123,
		111,
		76,
		76,
		70,
		-1,
		57,
		39,
		29,
		27,
		21,
		35,
		38,
		52,
		56,
		55,
		74,
		86,
		77,
		97,
		-1,
		-1,
		-1,
		139,
		128,
		129,
		75,
		98,
		135,
		109,
		95,
		100,
		75,
		68,
		62,
		60,
		56,
		24,
		25,
		15,
		18,
		34,
		42,
		44,
		53,
		62,
		68,
		92,
		98,
		104,
		-1,
		-1,
		146,
		136,
		120,
		122,
		119,
		89,
		96,
		128,
		100,
		113,
		-1,
		67,
		-1,
		56,
		34,
		18,
		13,
		0,
		20,
		25,
		34,
		48,
		59,
		55,
		62,
		97,
		97,
		88,
		108,
		111,
		-1,
		-1,
		-1,
		139,
		134,
		109,
		86,
		70,
		106,
		-1,
		83,
		84,
		-1,
		61,
		55,
		38,
		20,
		16,
		12,
		13,
		31,
		34,
		35,
		49,
		60,
		47,
		83,
		-1,
		96,
		90,
		98,
		88,
		76,
		-1,
		-1,
		-1,
		132,
		111,
		104,
		124,
		65,
		117,
		-1,
		-1,
		68,
		61,
		-1,
		48,
		30,
		31,
		26,
		26,
		27,
		41,
		33,
		46,
		51,
		52,
		62,
		81,
		85,
		89,
		78,
		74,
		71,
		85,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		85,
		-1,
		77,
		69,
		59,
		53,
		47,
		43,
		41,
		55,
		40,
		39,
		42,
		47,
		55,
		40,
		43,
		55,
		58,
		76,
		84,
		76,
		70,
		69,
		81,
		-1,
		152,
		138,
		109,
		-1,
		-1,
		98,
		-1,
		62,
		76,
		92,
		-1,
		85,
		64,
		79,
		57,
		53,
		43,
		67,
		68,
		46,
		51,
		54,
		64,
		65,
		54,
		66,
		58,
		80,
		80,
		64,
		65,
		74,
		-1,
		158,
		145,
		103,
		99,
		88,
		108,
		59,
		47,
		79,
		-1,
		-1,
		121,
		-1,
		55,
		72,
		57,
		55,
		57,
		48,
		54,
		65,
		68,
		69,
		59,
		48,
		54,
		52,
		74,
		60,
		58,
		77,
		93,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		74,
		61,
		55,
		-1,
		96,
		-1,
		99,
		89,
		73,
		58,
		91,
		-1,
		65,
		49,
		54,
		-1,
		94,
		-1,
		67,
		69,
		61,
		49,
		46,
		57,
		55,
		66,
		83,
		-1,
		108,
		93,
		86,
		76,
		90,
		61,
		-1,
		116,
		-1,
		-1,
		86,
		80,
		80,
		64,
		67,
		81,
		61,
		55,
		54,
		89,
		87,
		75,
		59,
		52,
		49,
		49,
		62,
		82,
		73,
		85,
		-1,
		-1,
		-1,
		113,
		99,
		103,
		63,
		82,
		-1,
		-1,
		148,
		103,
		89,
		-1,
		73,
		98,
		86,
		76,
		66,
		100,
		101,
		78,
		71,
		57,
		59,
		57,
		58,
		63,
		84,
		85,
		98,
		-1,
		-1,
		96,
		101,
		89,
		75,
		94,
		-1,
		-1,
		-1,
		95,
		111,
		103,
		74,
		87,
		-1,
		-1,
		78,
		76,
		86,
		74,
		61,
		81,
		84,
		73,
		57,
		72,
		84,
		92,
		97,
		-1,
		99,
		86,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		106,
		114,
		118,
		81,
		-1,
		86,
		85,
		65,
		79,
		86,
		75,
		70,
		64,
		67,
		85,
		102,
		-1,
		-1,
		111,
		-1,
		106,
		-1,
		-1,
		-1,
		-1,
		85,
		99,
		107,
		100,
		104,
		-1,
		92,
		81,
		67,
		84,
		88,
		85,
		76,
		68,
		73,
		70,
		83,
		97,
		101,
		134,
		-1,
		117,
		-1,
		-1,
		-1,
		103,
		118,
		146,
		123,
		96,
		91,
		84,
		78,
		75,
		91,
		96,
		107,
		75,
		71,
		72,
		76,
		75,
		92,
		102,
		-1,
		-1,
		117,
		134,
		129,
		111,
		115,
		173,
		-1,
		-1,
		100,
		91,
		82,
		85,
		85,
		88,
		81,
		78,
		83,
		88,
		76,
		85,
		103,
		103,
		-1,
		-1,
		-1,
		137,
		-1,
		152,
		-1,
		-1,
		130,
		171,
		118,
		100,
		96,
		94,
		87,
		96,
		91,
		86,
		96,
		99,
		91,
		78,
		83,
		106,
		95,
		134,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		166,
		141,
		156,
		182,
		150,
		157,
		133,
		130,
		-1,
		100,
		125,
		97,
		104,
		96,
		103,
		103,
		95,
		73,
		80,
		96,
		95,
		90,
		126,
		117,
		123,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		172,
		158,
		168,
		158,
		161,
		-1,
		-1,
		149,
		146,
		122,
		106,
		104,
		97,
		92,
		102,
		82,
		69,
		73,
		77,
		83,
		88,
		93,
		99,
		114,
		129,
		-1,
		144,
		225,
		218,
		201,
		209,
		240,
		-1,
		172,
		164,
		165,
		150,
		152,
		-1,
		-1,
		122,
		119,
		124,
		113,
		110,
		112,
		107,
		98,
		83,
		89,
		76,
		75,
		93,
		97,
		106,
		113,
		103,
		116,
		120,
		-1,
		158,
		201,
		195,
		198,
		222,
		236,
		-1,
		169,
		-1,
		-1,
		173,
		153,
		137,
		127,
		121,
		171,
		127,
		122,
		106,
		104,
		95,
		86,
		93,
		84,
		84,
		87,
		102,
		107,
		99,
		113,
		113,
		114,
		-1,
		193,
		181,
		189,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		189,
		-1,
		164,
		-1,
		139,
		143,
		135,
		138,
		120,
		107,
		99,
		91,
		107,
		82,
		92,
		88,
		89,
		98,
		109,
		121,
		120,
		121,
		241,
		197,
		189,
		180,
		222,
		237,
		241,
		-1,
		181,
		220,
		219,
		-1,
		198,
		-1,
		-1,
		-1,
		153,
		148,
		140,
		140,
		119,
		119,
		93,
		97,
		87,
		94,
		104,
		106,
		98,
		102,
		115,
		126,
		129,
		237,
		228,
		241,
		186,
		186,
		207,
		216,
		237,
		196,
		187,
		214,
		226,
		215,
		210,
		197,
		-1,
		-1,
		176,
		158,
		-1,
		-1,
		126,
		114,
		97,
		98,
		94,
		97,
		112,
		115,
		105,
		103,
		97,
		129,
		-1,
		230,
		229,
		218,
		215,
		191,
		182,
		177,
		204,
		-1,
		-1,
		199,
		215,
		210,
		214,
		230,
		255,
		-1,
		186,
		-1,
		-1,
		171,
		-1,
		-1,
		156,
		119,
		108,
		99,
		105,
		102,
		113,
		123,
		111,
		112,
		102,
		112,
		125,
		214,
		211,
		199,
		197,
		220,
		185,
		173,
		-1,
		186,
		184,
		190,
		197,
		214,
		244,
		-1,
		-1,
		202,
		182,
		-1,
		-1,
		154,
		152,
		141,
		-1,
		131,
		104,
		109,
		129,
		131,
		120,
		114,
		108,
		115,
		114,
		122,
		130,
		223,
		237,
		226,
		222,
		221,
		229,
		178,
		171,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		192,
		188,
		-1,
		-1,
		149,
		142,
		130,
		118,
		108,
		118,
		122,
		126,
		118,
		111,
		106,
		117,
		109,
		113,
		130,
		-1,
		257,
		-1,
		209,
		185,
		199,
		214,
		222,
		-1,
		-1,
		-1,
		209,
		195,
		188,
		176,
		174,
		-1,
		183,
		167,
		148,
		-1,
		118,
		131,
		162,
		130,
		135,
		130,
		112,
		123,
		112,
		115,
		129,
		124,
		-1,
		-1,
		197,
		200,
		-1,
		-1,
		199,
		201,
		-1,
		200,
		189,
		174,
		166,
		-1,
		-1,
		155,
		151,
		-1,
		-1,
		119,
		144,
		133,
		141,
		136,
		116,
		122,
		125,
		114,
		118,
		130,
		-1,
		-1,
		204,
		205,
		206,
		-1,
		184,
		-1,
		202,
		-1,
		169,
		175,
		163,
		-1,
		-1,
		-1,
		157,
		120,
		141,
		151,
		145,
		143,
		134,
		120,
		127,
		125,
		121,
		132,
		-1,
		-1,
		-1,
		202,
		176,
		209,
		200,
		183,
		163,
		155,
		174,
		-1,
		144,
		-1,
		119,
		121,
		147,
		150,
		156,
		150,
		123,
		138,
		128,
		119,
		128,
		208,
		-1,
		178,
		211,
		175,
		169,
		145,
		149,
		165,
		-1,
		141,
		123,
		-1,
		151,
		141,
		172,
		157,
		138,
		125,
		132,
		132,
		125,
		-1,
		-1,
		-1,
		180,
		179,
		171,
		165,
		165,
		150,
		141,
		-1,
		153,
		135,
		114,
		131,
		131,
		122,
		130,
		162,
		158,
		145,
		145,
		137,
		-1,
		281,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		174,
		169,
		142,
		130,
		136,
		132,
		118,
		124,
		126,
		134,
		132,
		129,
		141,
		137,
		157,
		138,
		173,
		-1,
		276,
		-1,
		210,
		-1,
		-1,
		192,
		172,
		164,
		153,
		142,
		140,
		131,
		122,
		144,
		160,
		144,
		142,
		145,
		146,
		-1,
		265,
		264,
		-1,
		211,
		203,
		189,
		-1,
		182,
		-1,
		188,
		149,
		-1,
		151,
		131,
		-1,
		153,
		149,
		-1,
		-1,
		252,
		227,
		-1,
		-1,
		-1,
		212,
		192,
		183,
		167,
		-1,
		142,
		142,
		-1,
		-1,
		-1,
		237,
		236,
		-1,
		205,
		208,
		-1,
		198,
		189,
		197,
		144,
		148,
		-1,
		-1,
		-1,
		246,
		227,
		221,
		220,
		218,
		213,
		210,
		196,
		180,
		158,
		147,
		168,
		-1,
		-1,
		-1,
		218,
		210,
		203,
		-1,
		-1,
		205,
		188,
		169,
		167,
		-1,
		-1,
		-1,
		240,
		221,
		-1,
		-1,
		195,
		-1,
		-1,
		201,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		229,
		-1,
		-1,
		-1,
		191,
		187,
		188,
		-1,
		-1,
		-1,
		-1,
		251,
		252,
		275,
		239,
		-1,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		254,
		252,
		-1,
		-1,
		-1,
		211,
		195,
		-1,
		181,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		216,
		-1,
		216,
		191,
		198,
		-1,
		-1,
		-1,
		-1,
		229,
		221,
		229,
		-1,
		201,
		203,
		-1,
		251,
		-1,
		-1,
		244,
		235,
		-1,
		-1,
		206,
		213,
		235,
		238,
		274,
		-1,
		225
	],
	[
		-1,
		147,
		136,
		147,
		155,
		128,
		135,
		-1,
		156,
		158,
		124,
		118,
		157,
		128,
		134,
		145,
		-1,
		-1,
		-1,
		147,
		146,
		116,
		114,
		123,
		128,
		135,
		-1,
		139,
		-1,
		168,
		147,
		158,
		163,
		109,
		106,
		126,
		145,
		132,
		124,
		183,
		139,
		110,
		104,
		122,
		117,
		126,
		118,
		-1,
		110,
		100,
		122,
		106,
		117,
		109,
		-1,
		-1,
		104,
		105,
		111,
		102,
		108,
		104,
		-1,
		114,
		98,
		-1,
		-1,
		94,
		100,
		84,
		87,
		95,
		93,
		106,
		98,
		93,
		-1,
		-1,
		90,
		86,
		93,
		80,
		76,
		93,
		106,
		88,
		102,
		101,
		-1,
		83,
		101,
		110,
		87,
		85,
		69,
		67,
		85,
		87,
		93,
		96,
		-1,
		92,
		93,
		88,
		96,
		101,
		85,
		72,
		72,
		82,
		75,
		94,
		85,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		92,
		75,
		92,
		84,
		74,
		89,
		82,
		75,
		72,
		70,
		67,
		83,
		84,
		94,
		-1,
		-1,
		173,
		142,
		177,
		134,
		119,
		-1,
		88,
		68,
		74,
		78,
		72,
		65,
		79,
		75,
		-1,
		61,
		60,
		91,
		77,
		88,
		133,
		-1,
		-1,
		131,
		123,
		108,
		111,
		98,
		94,
		83,
		82,
		74,
		60,
		56,
		62,
		65,
		65,
		71,
		55,
		65,
		69,
		75,
		95,
		-1,
		-1,
		145,
		-1,
		-1,
		130,
		113,
		-1,
		96,
		103,
		103,
		110,
		96,
		117,
		93,
		84,
		76,
		70,
		58,
		60,
		57,
		70,
		58,
		52,
		77,
		81,
		70,
		91,
		86,
		-1,
		144,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		89,
		92,
		98,
		122,
		132,
		-1,
		105,
		93,
		94,
		79,
		76,
		63,
		51,
		64,
		49,
		56,
		55,
		59,
		61,
		92,
		67,
		89,
		86,
		115,
		120,
		114,
		123,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		126,
		-1,
		140,
		139,
		114,
		90,
		93,
		80,
		71,
		58,
		47,
		58,
		47,
		44,
		52,
		56,
		71,
		62,
		61,
		79,
		94,
		107,
		111,
		117,
		-1,
		188,
		-1,
		130,
		114,
		116,
		88,
		109,
		-1,
		146,
		141,
		131,
		116,
		107,
		-1,
		89,
		86,
		76,
		54,
		39,
		56,
		48,
		46,
		51,
		51,
		65,
		56,
		74,
		81,
		89,
		93,
		113,
		125,
		148,
		138,
		-1,
		120,
		125,
		84,
		92,
		111,
		149,
		113,
		-1,
		108,
		-1,
		91,
		104,
		-1,
		60,
		56,
		38,
		39,
		34,
		49,
		50,
		47,
		44,
		62,
		65,
		82,
		86,
		102,
		-1,
		-1,
		133,
		137,
		126,
		77,
		96,
		120,
		157,
		106,
		95,
		94,
		-1,
		85,
		73,
		70,
		56,
		43,
		31,
		32,
		33,
		48,
		27,
		46,
		49,
		71,
		99,
		77,
		89,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		103,
		74,
		98,
		140,
		124,
		117,
		105,
		70,
		70,
		64,
		-1,
		67,
		46,
		36,
		29,
		22,
		35,
		28,
		46,
		50,
		52,
		68,
		80,
		71,
		91,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		69,
		92,
		129,
		103,
		89,
		94,
		69,
		62,
		56,
		78,
		63,
		42,
		34,
		20,
		17,
		24,
		32,
		36,
		52,
		61,
		62,
		86,
		84,
		90,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		83,
		90,
		122,
		94,
		107,
		-1,
		61,
		-1,
		50,
		46,
		36,
		31,
		28,
		0,
		15,
		29,
		38,
		53,
		54,
		61,
		91,
		91,
		74,
		94,
		97,
		-1,
		-1,
		-1,
		133,
		128,
		103,
		80,
		64,
		100,
		-1,
		77,
		78,
		-1,
		55,
		49,
		46,
		36,
		34,
		14,
		9,
		19,
		29,
		25,
		44,
		47,
		46,
		79,
		-1,
		82,
		76,
		84,
		74,
		62,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		59,
		111,
		-1,
		-1,
		62,
		55,
		-1,
		42,
		24,
		26,
		21,
		20,
		15,
		29,
		20,
		33,
		38,
		51,
		49,
		67,
		71,
		75,
		64,
		60,
		57,
		71,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		79,
		-1,
		71,
		63,
		53,
		47,
		41,
		37,
		35,
		48,
		32,
		31,
		30,
		34,
		42,
		27,
		30,
		46,
		44,
		62,
		70,
		62,
		56,
		55,
		67,
		-1,
		146,
		132,
		103,
		-1,
		-1,
		92,
		-1,
		56,
		70,
		86,
		-1,
		79,
		58,
		73,
		51,
		47,
		38,
		55,
		56,
		34,
		39,
		41,
		51,
		52,
		41,
		52,
		44,
		66,
		66,
		50,
		51,
		60,
		-1,
		152,
		139,
		97,
		93,
		82,
		102,
		53,
		41,
		73,
		-1,
		-1,
		115,
		-1,
		49,
		66,
		52,
		50,
		45,
		36,
		42,
		52,
		55,
		56,
		46,
		35,
		41,
		38,
		60,
		46,
		44,
		63,
		79,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		68,
		55,
		49,
		-1,
		90,
		-1,
		93,
		83,
		67,
		52,
		85,
		-1,
		53,
		37,
		42,
		-1,
		81,
		-1,
		54,
		56,
		50,
		35,
		32,
		43,
		41,
		52,
		69,
		-1,
		102,
		87,
		80,
		70,
		84,
		55,
		-1,
		110,
		-1,
		-1,
		80,
		74,
		74,
		58,
		61,
		69,
		49,
		43,
		42,
		76,
		76,
		62,
		48,
		41,
		38,
		35,
		48,
		68,
		59,
		71,
		-1,
		-1,
		-1,
		107,
		93,
		97,
		57,
		76,
		-1,
		-1,
		142,
		97,
		83,
		-1,
		67,
		86,
		74,
		64,
		54,
		88,
		89,
		67,
		60,
		46,
		48,
		46,
		44,
		49,
		70,
		71,
		84,
		-1,
		-1,
		90,
		95,
		83,
		69,
		88,
		-1,
		-1,
		-1,
		89,
		105,
		97,
		68,
		75,
		-1,
		-1,
		66,
		64,
		74,
		63,
		50,
		70,
		73,
		59,
		43,
		58,
		70,
		78,
		83,
		-1,
		93,
		80,
		-1,
		-1,
		91,
		85,
		-1,
		-1,
		-1,
		-1,
		122,
		88,
		100,
		100,
		104,
		69,
		-1,
		74,
		74,
		54,
		68,
		75,
		61,
		56,
		50,
		53,
		71,
		88,
		-1,
		-1,
		105,
		-1,
		100,
		-1,
		-1,
		-1,
		-1,
		79,
		93,
		93,
		86,
		90,
		-1,
		78,
		70,
		56,
		73,
		74,
		71,
		62,
		54,
		59,
		56,
		69,
		83,
		87,
		128,
		-1,
		111,
		-1,
		-1,
		-1,
		97,
		112,
		132,
		109,
		82,
		77,
		70,
		64,
		64,
		80,
		82,
		93,
		61,
		57,
		58,
		62,
		61,
		78,
		88,
		-1,
		-1,
		111,
		128,
		123,
		105,
		109,
		159,
		-1,
		-1,
		86,
		77,
		68,
		71,
		74,
		77,
		67,
		64,
		69,
		74,
		62,
		71,
		89,
		93,
		-1,
		-1,
		-1,
		131,
		-1,
		146,
		-1,
		-1,
		124,
		157,
		104,
		86,
		82,
		80,
		73,
		82,
		77,
		72,
		82,
		92,
		84,
		64,
		77,
		99,
		89,
		125,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		160,
		135,
		150,
		168,
		144,
		151,
		119,
		116,
		-1,
		86,
		111,
		83,
		90,
		82,
		90,
		90,
		88,
		67,
		74,
		90,
		89,
		84,
		117,
		111,
		117,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		166,
		152,
		154,
		144,
		147,
		-1,
		-1,
		135,
		132,
		108,
		92,
		96,
		89,
		84,
		96,
		76,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		138,
		219,
		212,
		195,
		203,
		234,
		-1,
		158,
		150,
		159,
		136,
		138,
		-1,
		-1,
		108,
		105,
		110,
		99,
		96,
		106,
		101,
		92,
		77,
		83,
		70,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		152,
		195,
		189,
		192,
		216,
		230,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		107,
		157,
		113,
		108,
		100,
		98,
		89,
		80,
		87,
		78,
		78,
		81,
		96,
		101,
		93,
		107,
		107,
		108,
		-1,
		187,
		175,
		183,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		125,
		129,
		121,
		124,
		114,
		101,
		93,
		85,
		101,
		76,
		86,
		82,
		83,
		92,
		103,
		115,
		114,
		115,
		227,
		183,
		183,
		174,
		208,
		223,
		227,
		-1,
		167,
		206,
		213,
		-1,
		192,
		-1,
		-1,
		-1,
		139,
		134,
		126,
		134,
		113,
		113,
		87,
		91,
		81,
		88,
		98,
		100,
		92,
		96,
		109,
		120,
		123,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		182,
		173,
		200,
		220,
		209,
		204,
		191,
		-1,
		-1,
		162,
		144,
		-1,
		-1,
		120,
		108,
		91,
		92,
		88,
		91,
		106,
		109,
		99,
		97,
		91,
		123,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		201,
		196,
		200,
		216,
		241,
		-1,
		180,
		-1,
		-1,
		165,
		-1,
		-1,
		150,
		113,
		102,
		93,
		99,
		96,
		107,
		117,
		105,
		106,
		96,
		106,
		119,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		170,
		176,
		183,
		200,
		230,
		-1,
		-1,
		196,
		176,
		-1,
		-1,
		148,
		146,
		135,
		-1,
		125,
		98,
		103,
		123,
		125,
		114,
		108,
		102,
		109,
		108,
		116,
		124,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		186,
		182,
		-1,
		-1,
		143,
		136,
		124,
		112,
		102,
		112,
		116,
		120,
		112,
		105,
		100,
		111,
		103,
		107,
		124,
		-1,
		243,
		-1,
		195,
		171,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		203,
		189,
		182,
		170,
		168,
		-1,
		177,
		161,
		142,
		-1,
		112,
		125,
		156,
		124,
		129,
		124,
		106,
		117,
		106,
		109,
		123,
		118,
		-1,
		-1,
		183,
		186,
		-1,
		-1,
		193,
		195,
		-1,
		194,
		183,
		168,
		160,
		-1,
		-1,
		149,
		145,
		-1,
		-1,
		113,
		138,
		127,
		135,
		130,
		110,
		116,
		119,
		108,
		112,
		124,
		-1,
		-1,
		190,
		191,
		196,
		-1,
		178,
		-1,
		196,
		-1,
		163,
		169,
		157,
		-1,
		-1,
		-1,
		151,
		114,
		135,
		145,
		139,
		137,
		128,
		114,
		121,
		119,
		115,
		126,
		-1,
		-1,
		-1,
		196,
		170,
		203,
		194,
		177,
		157,
		149,
		168,
		-1,
		138,
		-1,
		113,
		115,
		141,
		144,
		150,
		144,
		117,
		132,
		122,
		113,
		122,
		202,
		-1,
		172,
		205,
		169,
		163,
		139,
		143,
		159,
		-1,
		135,
		117,
		-1,
		145,
		135,
		166,
		151,
		132,
		119,
		126,
		126,
		119,
		-1,
		-1,
		-1,
		174,
		173,
		165,
		159,
		159,
		144,
		135,
		-1,
		147,
		129,
		108,
		125,
		125,
		116,
		124,
		156,
		152,
		139,
		139,
		131,
		-1,
		275,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		168,
		163,
		136,
		124,
		130,
		126,
		112,
		118,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		132,
		167,
		-1,
		270,
		-1,
		204,
		-1,
		-1,
		186,
		166,
		158,
		147,
		136,
		134,
		125,
		116,
		138,
		154,
		138,
		136,
		139,
		140,
		-1,
		259,
		258,
		-1,
		205,
		197,
		183,
		-1,
		176,
		-1,
		182,
		143,
		-1,
		145,
		125,
		-1,
		147,
		143,
		-1,
		-1,
		246,
		221,
		-1,
		-1,
		-1,
		206,
		186,
		177,
		161,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		231,
		230,
		-1,
		199,
		202,
		-1,
		192,
		183,
		191,
		138,
		142,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		214,
		212,
		207,
		204,
		190,
		174,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		212,
		204,
		197,
		-1,
		-1,
		199,
		182,
		163,
		161,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		189,
		-1,
		-1,
		195,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		223,
		-1,
		-1,
		-1,
		185,
		181,
		182,
		-1,
		-1,
		-1,
		-1,
		245,
		246,
		269,
		233,
		-1,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		248,
		246,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		175,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		210,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		223,
		215,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		200,
		207,
		229,
		232,
		268,
		-1,
		219
	],
	[
		-1,
		139,
		128,
		139,
		147,
		120,
		127,
		-1,
		148,
		150,
		116,
		110,
		149,
		120,
		126,
		137,
		-1,
		-1,
		-1,
		139,
		138,
		108,
		106,
		115,
		120,
		127,
		-1,
		131,
		-1,
		160,
		139,
		150,
		155,
		101,
		98,
		118,
		137,
		124,
		116,
		175,
		131,
		102,
		96,
		114,
		109,
		118,
		110,
		-1,
		102,
		92,
		114,
		98,
		109,
		101,
		-1,
		-1,
		96,
		97,
		103,
		94,
		100,
		96,
		-1,
		106,
		90,
		-1,
		-1,
		86,
		92,
		76,
		79,
		87,
		85,
		98,
		90,
		85,
		-1,
		-1,
		82,
		78,
		85,
		72,
		68,
		85,
		98,
		80,
		94,
		93,
		-1,
		75,
		93,
		102,
		79,
		77,
		61,
		59,
		77,
		79,
		85,
		86,
		-1,
		84,
		85,
		80,
		88,
		93,
		77,
		64,
		64,
		74,
		67,
		86,
		75,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		84,
		67,
		84,
		76,
		66,
		81,
		74,
		67,
		64,
		62,
		59,
		75,
		74,
		84,
		-1,
		-1,
		176,
		145,
		175,
		133,
		114,
		-1,
		80,
		60,
		66,
		70,
		64,
		57,
		71,
		67,
		-1,
		53,
		52,
		81,
		67,
		78,
		136,
		-1,
		-1,
		134,
		126,
		110,
		113,
		90,
		86,
		75,
		74,
		66,
		52,
		48,
		54,
		57,
		57,
		63,
		47,
		57,
		61,
		60,
		85,
		-1,
		-1,
		130,
		-1,
		-1,
		133,
		116,
		-1,
		99,
		106,
		96,
		102,
		88,
		109,
		85,
		76,
		68,
		62,
		50,
		52,
		49,
		62,
		50,
		44,
		69,
		73,
		55,
		76,
		71,
		-1,
		129,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		92,
		95,
		101,
		125,
		125,
		-1,
		97,
		85,
		86,
		71,
		68,
		55,
		43,
		56,
		41,
		48,
		47,
		49,
		47,
		77,
		52,
		74,
		71,
		100,
		105,
		99,
		108,
		-1,
		141,
		137,
		133,
		140,
		89,
		-1,
		-1,
		129,
		-1,
		133,
		134,
		109,
		82,
		85,
		72,
		63,
		50,
		39,
		50,
		39,
		36,
		44,
		41,
		56,
		47,
		46,
		64,
		79,
		92,
		96,
		102,
		-1,
		191,
		-1,
		133,
		117,
		119,
		91,
		112,
		-1,
		149,
		134,
		126,
		111,
		110,
		-1,
		81,
		78,
		68,
		46,
		31,
		48,
		40,
		38,
		42,
		36,
		50,
		41,
		59,
		66,
		74,
		78,
		98,
		110,
		151,
		141,
		-1,
		123,
		128,
		87,
		95,
		114,
		152,
		116,
		-1,
		111,
		-1,
		83,
		96,
		-1,
		52,
		48,
		30,
		31,
		26,
		41,
		35,
		32,
		29,
		47,
		50,
		67,
		71,
		87,
		-1,
		-1,
		136,
		140,
		129,
		80,
		99,
		123,
		160,
		109,
		98,
		97,
		-1,
		88,
		66,
		63,
		51,
		38,
		23,
		24,
		31,
		33,
		12,
		31,
		34,
		56,
		84,
		62,
		74,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		106,
		77,
		101,
		143,
		127,
		120,
		108,
		73,
		73,
		67,
		-1,
		62,
		41,
		32,
		21,
		19,
		21,
		13,
		31,
		35,
		37,
		53,
		65,
		56,
		76,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		72,
		95,
		132,
		106,
		92,
		97,
		72,
		65,
		59,
		75,
		58,
		39,
		28,
		19,
		9,
		9,
		17,
		21,
		37,
		46,
		47,
		71,
		78,
		84,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		86,
		93,
		125,
		97,
		110,
		-1,
		64,
		-1,
		53,
		49,
		33,
		28,
		25,
		13,
		0,
		14,
		23,
		38,
		42,
		48,
		76,
		76,
		68,
		91,
		94,
		-1,
		-1,
		-1,
		136,
		131,
		106,
		83,
		67,
		103,
		-1,
		80,
		81,
		-1,
		58,
		52,
		49,
		35,
		31,
		17,
		21,
		15,
		14,
		14,
		29,
		37,
		35,
		71,
		-1,
		76,
		70,
		81,
		71,
		59,
		-1,
		-1,
		-1,
		129,
		108,
		101,
		121,
		62,
		114,
		-1,
		-1,
		65,
		58,
		-1,
		45,
		27,
		29,
		24,
		23,
		22,
		21,
		10,
		23,
		28,
		40,
		39,
		64,
		68,
		72,
		61,
		57,
		54,
		68,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		82,
		-1,
		74,
		66,
		56,
		50,
		44,
		40,
		38,
		51,
		35,
		34,
		33,
		24,
		32,
		17,
		20,
		36,
		41,
		59,
		67,
		59,
		53,
		52,
		64,
		-1,
		149,
		135,
		106,
		-1,
		-1,
		95,
		-1,
		59,
		73,
		89,
		-1,
		82,
		61,
		76,
		54,
		50,
		41,
		58,
		59,
		37,
		33,
		31,
		41,
		42,
		31,
		49,
		41,
		63,
		63,
		47,
		48,
		57,
		-1,
		155,
		142,
		100,
		96,
		85,
		105,
		56,
		44,
		76,
		-1,
		-1,
		118,
		-1,
		52,
		69,
		55,
		53,
		48,
		39,
		45,
		42,
		45,
		46,
		36,
		25,
		31,
		35,
		57,
		43,
		41,
		60,
		76,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		71,
		58,
		52,
		-1,
		93,
		-1,
		96,
		86,
		70,
		55,
		88,
		-1,
		56,
		40,
		45,
		-1,
		71,
		-1,
		44,
		46,
		44,
		32,
		29,
		40,
		38,
		49,
		66,
		-1,
		105,
		90,
		83,
		73,
		87,
		58,
		-1,
		113,
		-1,
		-1,
		83,
		77,
		77,
		61,
		64,
		72,
		52,
		46,
		45,
		66,
		73,
		52,
		45,
		38,
		35,
		32,
		45,
		65,
		56,
		68,
		-1,
		-1,
		-1,
		110,
		96,
		100,
		60,
		79,
		-1,
		-1,
		145,
		100,
		86,
		-1,
		70,
		89,
		77,
		67,
		57,
		91,
		86,
		64,
		57,
		43,
		45,
		43,
		41,
		46,
		67,
		68,
		81,
		-1,
		-1,
		93,
		98,
		86,
		72,
		91,
		-1,
		-1,
		-1,
		92,
		108,
		100,
		71,
		78,
		-1,
		-1,
		69,
		67,
		77,
		60,
		47,
		67,
		70,
		56,
		40,
		55,
		67,
		75,
		80,
		-1,
		96,
		83,
		-1,
		-1,
		94,
		88,
		-1,
		-1,
		-1,
		-1,
		125,
		91,
		102,
		97,
		101,
		72,
		-1,
		73,
		71,
		51,
		65,
		72,
		58,
		53,
		47,
		50,
		68,
		85,
		-1,
		-1,
		108,
		-1,
		103,
		-1,
		-1,
		-1,
		-1,
		82,
		96,
		90,
		83,
		87,
		-1,
		75,
		67,
		53,
		70,
		71,
		68,
		59,
		51,
		56,
		53,
		66,
		80,
		84,
		131,
		-1,
		114,
		-1,
		-1,
		-1,
		100,
		115,
		129,
		106,
		79,
		74,
		67,
		61,
		61,
		77,
		79,
		90,
		58,
		54,
		55,
		59,
		58,
		75,
		85,
		-1,
		-1,
		114,
		131,
		126,
		108,
		112,
		156,
		-1,
		-1,
		83,
		74,
		65,
		68,
		71,
		74,
		64,
		61,
		66,
		71,
		59,
		68,
		86,
		90,
		-1,
		-1,
		-1,
		134,
		-1,
		149,
		-1,
		-1,
		127,
		154,
		101,
		83,
		79,
		77,
		70,
		79,
		74,
		69,
		79,
		89,
		81,
		61,
		74,
		96,
		86,
		122,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		163,
		138,
		153,
		165,
		147,
		154,
		116,
		113,
		-1,
		83,
		108,
		80,
		87,
		79,
		87,
		87,
		85,
		64,
		71,
		87,
		86,
		81,
		114,
		108,
		114,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		165,
		155,
		151,
		141,
		144,
		-1,
		-1,
		132,
		129,
		105,
		89,
		93,
		86,
		81,
		93,
		73,
		60,
		64,
		68,
		74,
		79,
		84,
		90,
		105,
		120,
		-1,
		141,
		222,
		215,
		198,
		206,
		237,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		105,
		102,
		107,
		96,
		93,
		103,
		98,
		89,
		74,
		80,
		67,
		66,
		84,
		88,
		97,
		104,
		94,
		107,
		111,
		-1,
		155,
		198,
		192,
		195,
		219,
		233,
		-1,
		152,
		-1,
		-1,
		164,
		136,
		120,
		110,
		104,
		154,
		110,
		105,
		97,
		95,
		86,
		77,
		84,
		75,
		75,
		78,
		93,
		98,
		90,
		104,
		104,
		105,
		-1,
		190,
		178,
		186,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		180,
		-1,
		147,
		-1,
		122,
		126,
		118,
		121,
		111,
		98,
		90,
		82,
		98,
		73,
		83,
		79,
		80,
		89,
		100,
		112,
		111,
		112,
		224,
		180,
		183,
		177,
		205,
		220,
		224,
		-1,
		164,
		203,
		210,
		-1,
		189,
		-1,
		-1,
		-1,
		136,
		131,
		123,
		131,
		110,
		110,
		84,
		88,
		78,
		85,
		95,
		97,
		89,
		93,
		106,
		117,
		120,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		179,
		170,
		197,
		217,
		206,
		201,
		188,
		-1,
		-1,
		159,
		141,
		-1,
		-1,
		117,
		105,
		88,
		89,
		85,
		88,
		103,
		106,
		96,
		94,
		88,
		120,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		198,
		193,
		197,
		213,
		238,
		-1,
		177,
		-1,
		-1,
		162,
		-1,
		-1,
		147,
		110,
		99,
		90,
		96,
		93,
		104,
		114,
		102,
		103,
		93,
		103,
		116,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		197,
		227,
		-1,
		-1,
		193,
		173,
		-1,
		-1,
		145,
		143,
		132,
		-1,
		122,
		95,
		100,
		120,
		122,
		111,
		105,
		99,
		106,
		105,
		113,
		121,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		183,
		179,
		-1,
		-1,
		140,
		133,
		121,
		109,
		99,
		109,
		113,
		117,
		109,
		102,
		97,
		108,
		100,
		104,
		121,
		-1,
		240,
		-1,
		192,
		168,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		200,
		186,
		179,
		167,
		165,
		-1,
		174,
		158,
		139,
		-1,
		109,
		122,
		153,
		121,
		126,
		121,
		103,
		114,
		103,
		106,
		120,
		115,
		-1,
		-1,
		180,
		183,
		-1,
		-1,
		190,
		192,
		-1,
		191,
		180,
		165,
		157,
		-1,
		-1,
		146,
		142,
		-1,
		-1,
		110,
		135,
		124,
		132,
		127,
		107,
		113,
		116,
		105,
		109,
		121,
		-1,
		-1,
		187,
		188,
		193,
		-1,
		175,
		-1,
		193,
		-1,
		160,
		166,
		154,
		-1,
		-1,
		-1,
		148,
		111,
		132,
		142,
		136,
		134,
		125,
		111,
		118,
		116,
		112,
		123,
		-1,
		-1,
		-1,
		193,
		167,
		200,
		191,
		174,
		154,
		146,
		165,
		-1,
		135,
		-1,
		110,
		112,
		138,
		141,
		147,
		141,
		114,
		129,
		119,
		110,
		119,
		199,
		-1,
		169,
		202,
		166,
		160,
		136,
		140,
		156,
		-1,
		132,
		114,
		-1,
		142,
		132,
		163,
		148,
		129,
		116,
		123,
		123,
		116,
		-1,
		-1,
		-1,
		171,
		170,
		162,
		156,
		156,
		141,
		132,
		-1,
		144,
		126,
		105,
		122,
		122,
		113,
		121,
		153,
		149,
		136,
		136,
		128,
		-1,
		272,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		165,
		160,
		133,
		121,
		127,
		123,
		109,
		115,
		117,
		125,
		123,
		120,
		132,
		128,
		148,
		129,
		164,
		-1,
		267,
		-1,
		201,
		-1,
		-1,
		183,
		163,
		155,
		144,
		133,
		131,
		122,
		113,
		135,
		151,
		135,
		133,
		136,
		137,
		-1,
		256,
		255,
		-1,
		202,
		194,
		180,
		-1,
		173,
		-1,
		179,
		140,
		-1,
		142,
		122,
		-1,
		144,
		140,
		-1,
		-1,
		243,
		218,
		-1,
		-1,
		-1,
		203,
		183,
		174,
		158,
		-1,
		133,
		133,
		-1,
		-1,
		-1,
		228,
		227,
		-1,
		196,
		199,
		-1,
		189,
		180,
		188,
		135,
		139,
		-1,
		-1,
		-1,
		237,
		218,
		212,
		211,
		209,
		204,
		201,
		187,
		171,
		149,
		138,
		159,
		-1,
		-1,
		-1,
		209,
		201,
		194,
		-1,
		-1,
		196,
		179,
		160,
		158,
		-1,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		186,
		-1,
		-1,
		192,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		220,
		-1,
		-1,
		-1,
		182,
		178,
		179,
		-1,
		-1,
		-1,
		-1,
		242,
		243,
		266,
		230,
		-1,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		245,
		243,
		-1,
		-1,
		-1,
		202,
		186,
		-1,
		172,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		207,
		-1,
		207,
		182,
		189,
		-1,
		-1,
		-1,
		-1,
		220,
		212,
		220,
		-1,
		192,
		194,
		-1,
		242,
		-1,
		-1,
		235,
		226,
		-1,
		-1,
		197,
		204,
		226,
		229,
		265,
		-1,
		216
	],
	[
		-1,
		149,
		138,
		149,
		157,
		130,
		137,
		-1,
		158,
		160,
		126,
		120,
		159,
		130,
		136,
		147,
		-1,
		-1,
		-1,
		149,
		148,
		118,
		116,
		125,
		130,
		137,
		-1,
		141,
		-1,
		170,
		149,
		160,
		165,
		111,
		108,
		128,
		147,
		134,
		126,
		185,
		141,
		112,
		106,
		124,
		119,
		128,
		120,
		-1,
		112,
		102,
		124,
		108,
		119,
		111,
		-1,
		-1,
		106,
		107,
		113,
		104,
		110,
		106,
		-1,
		116,
		100,
		-1,
		-1,
		96,
		102,
		86,
		89,
		97,
		95,
		108,
		100,
		95,
		-1,
		-1,
		92,
		88,
		95,
		82,
		78,
		95,
		108,
		90,
		104,
		103,
		-1,
		85,
		103,
		112,
		89,
		87,
		71,
		69,
		87,
		89,
		95,
		98,
		-1,
		94,
		95,
		90,
		98,
		103,
		87,
		74,
		74,
		84,
		77,
		96,
		87,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		77,
		94,
		86,
		76,
		91,
		84,
		77,
		74,
		72,
		69,
		85,
		86,
		96,
		-1,
		-1,
		187,
		156,
		185,
		143,
		124,
		-1,
		90,
		70,
		76,
		80,
		74,
		67,
		81,
		77,
		-1,
		63,
		62,
		93,
		79,
		90,
		147,
		-1,
		-1,
		145,
		137,
		120,
		123,
		100,
		96,
		85,
		84,
		76,
		62,
		58,
		64,
		67,
		67,
		73,
		57,
		67,
		71,
		72,
		97,
		-1,
		-1,
		131,
		-1,
		-1,
		144,
		127,
		-1,
		110,
		117,
		106,
		112,
		98,
		119,
		95,
		86,
		78,
		72,
		60,
		62,
		59,
		72,
		60,
		54,
		79,
		83,
		67,
		88,
		83,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		103,
		106,
		112,
		136,
		135,
		-1,
		107,
		95,
		96,
		81,
		78,
		65,
		53,
		66,
		51,
		58,
		57,
		61,
		59,
		89,
		64,
		86,
		83,
		101,
		106,
		100,
		109,
		-1,
		152,
		148,
		144,
		151,
		100,
		-1,
		-1,
		140,
		-1,
		143,
		144,
		119,
		92,
		95,
		82,
		73,
		60,
		49,
		60,
		49,
		46,
		54,
		53,
		68,
		59,
		58,
		76,
		85,
		93,
		97,
		103,
		-1,
		202,
		-1,
		144,
		128,
		130,
		102,
		123,
		-1,
		160,
		144,
		136,
		121,
		121,
		-1,
		91,
		88,
		78,
		56,
		41,
		58,
		50,
		48,
		53,
		48,
		62,
		53,
		71,
		78,
		75,
		79,
		99,
		111,
		162,
		152,
		-1,
		134,
		139,
		98,
		106,
		125,
		163,
		127,
		-1,
		122,
		-1,
		93,
		106,
		-1,
		62,
		58,
		40,
		41,
		36,
		51,
		47,
		44,
		41,
		59,
		62,
		68,
		72,
		88,
		-1,
		-1,
		147,
		151,
		140,
		91,
		110,
		134,
		171,
		120,
		109,
		108,
		-1,
		99,
		76,
		73,
		61,
		48,
		33,
		34,
		42,
		45,
		24,
		43,
		41,
		59,
		85,
		63,
		75,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		117,
		88,
		112,
		154,
		138,
		131,
		119,
		84,
		84,
		78,
		-1,
		72,
		51,
		42,
		31,
		29,
		32,
		25,
		26,
		39,
		37,
		54,
		66,
		57,
		77,
		-1,
		-1,
		-1,
		147,
		136,
		137,
		83,
		106,
		143,
		117,
		103,
		108,
		83,
		76,
		70,
		85,
		68,
		49,
		38,
		30,
		19,
		21,
		21,
		13,
		35,
		44,
		48,
		72,
		79,
		85,
		-1,
		-1,
		154,
		144,
		128,
		130,
		127,
		97,
		104,
		136,
		108,
		121,
		-1,
		75,
		-1,
		64,
		59,
		43,
		38,
		35,
		25,
		12,
		0,
		15,
		33,
		37,
		42,
		77,
		77,
		69,
		94,
		97,
		-1,
		-1,
		-1,
		147,
		142,
		117,
		94,
		78,
		114,
		-1,
		91,
		92,
		-1,
		69,
		63,
		60,
		45,
		41,
		29,
		33,
		27,
		18,
		20,
		21,
		37,
		29,
		65,
		-1,
		77,
		71,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		140,
		119,
		112,
		132,
		73,
		125,
		-1,
		-1,
		76,
		69,
		-1,
		56,
		38,
		41,
		36,
		35,
		34,
		33,
		22,
		35,
		33,
		34,
		44,
		64,
		68,
		84,
		73,
		69,
		66,
		80,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		93,
		-1,
		85,
		77,
		67,
		61,
		55,
		51,
		49,
		63,
		47,
		46,
		45,
		36,
		44,
		29,
		32,
		37,
		41,
		59,
		79,
		71,
		65,
		64,
		76,
		-1,
		160,
		146,
		117,
		-1,
		-1,
		106,
		-1,
		70,
		84,
		100,
		-1,
		93,
		72,
		87,
		65,
		61,
		53,
		70,
		71,
		49,
		45,
		43,
		53,
		54,
		43,
		49,
		53,
		68,
		75,
		59,
		60,
		69,
		-1,
		166,
		153,
		111,
		107,
		96,
		116,
		67,
		55,
		87,
		-1,
		-1,
		129,
		-1,
		63,
		80,
		67,
		65,
		60,
		51,
		57,
		54,
		57,
		58,
		48,
		37,
		43,
		47,
		69,
		55,
		53,
		72,
		88,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		82,
		69,
		63,
		-1,
		104,
		-1,
		107,
		97,
		81,
		66,
		99,
		-1,
		68,
		52,
		57,
		-1,
		83,
		-1,
		56,
		58,
		56,
		44,
		41,
		52,
		50,
		61,
		78,
		-1,
		116,
		101,
		94,
		84,
		98,
		69,
		-1,
		124,
		-1,
		-1,
		94,
		88,
		88,
		72,
		75,
		84,
		64,
		58,
		57,
		78,
		85,
		64,
		57,
		50,
		47,
		44,
		57,
		77,
		68,
		80,
		-1,
		-1,
		-1,
		121,
		107,
		111,
		71,
		90,
		-1,
		-1,
		156,
		111,
		97,
		-1,
		81,
		101,
		89,
		79,
		69,
		103,
		98,
		76,
		69,
		55,
		57,
		55,
		53,
		58,
		79,
		80,
		93,
		-1,
		-1,
		104,
		109,
		97,
		83,
		102,
		-1,
		-1,
		-1,
		103,
		119,
		111,
		82,
		90,
		-1,
		-1,
		81,
		79,
		89,
		72,
		59,
		79,
		82,
		68,
		52,
		67,
		79,
		87,
		92,
		-1,
		107,
		94,
		-1,
		-1,
		105,
		99,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		114,
		109,
		113,
		84,
		-1,
		85,
		83,
		63,
		77,
		84,
		70,
		65,
		59,
		62,
		80,
		97,
		-1,
		-1,
		119,
		-1,
		114,
		-1,
		-1,
		-1,
		-1,
		93,
		107,
		102,
		95,
		99,
		-1,
		87,
		79,
		65,
		82,
		83,
		80,
		71,
		63,
		68,
		65,
		78,
		92,
		96,
		142,
		-1,
		125,
		-1,
		-1,
		-1,
		111,
		126,
		141,
		118,
		91,
		86,
		79,
		73,
		73,
		89,
		91,
		102,
		70,
		66,
		67,
		71,
		70,
		87,
		97,
		-1,
		-1,
		125,
		142,
		137,
		119,
		123,
		168,
		-1,
		-1,
		95,
		86,
		77,
		80,
		83,
		86,
		76,
		73,
		78,
		83,
		71,
		80,
		98,
		102,
		-1,
		-1,
		-1,
		145,
		-1,
		160,
		-1,
		-1,
		138,
		166,
		113,
		95,
		91,
		89,
		82,
		91,
		86,
		81,
		91,
		100,
		92,
		73,
		84,
		107,
		96,
		134,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		174,
		149,
		164,
		177,
		158,
		165,
		128,
		125,
		-1,
		95,
		120,
		92,
		99,
		91,
		99,
		99,
		96,
		74,
		81,
		97,
		96,
		91,
		126,
		118,
		124,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		177,
		166,
		163,
		153,
		156,
		-1,
		-1,
		144,
		141,
		117,
		101,
		105,
		98,
		93,
		103,
		83,
		70,
		74,
		78,
		84,
		89,
		94,
		100,
		115,
		130,
		-1,
		152,
		233,
		226,
		209,
		217,
		248,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		117,
		114,
		119,
		108,
		105,
		113,
		108,
		99,
		84,
		90,
		77,
		76,
		94,
		98,
		107,
		114,
		104,
		117,
		121,
		-1,
		166,
		209,
		203,
		206,
		230,
		244,
		-1,
		164,
		-1,
		-1,
		176,
		148,
		132,
		122,
		116,
		166,
		122,
		117,
		107,
		105,
		96,
		87,
		94,
		85,
		85,
		88,
		103,
		108,
		100,
		114,
		114,
		115,
		-1,
		201,
		189,
		197,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		192,
		-1,
		159,
		-1,
		134,
		138,
		130,
		133,
		121,
		108,
		100,
		92,
		108,
		83,
		93,
		89,
		90,
		99,
		110,
		122,
		121,
		122,
		236,
		192,
		195,
		188,
		217,
		232,
		236,
		-1,
		176,
		215,
		220,
		-1,
		201,
		-1,
		-1,
		-1,
		148,
		143,
		135,
		141,
		120,
		120,
		94,
		98,
		88,
		95,
		105,
		107,
		99,
		103,
		116,
		127,
		130,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		191,
		182,
		209,
		227,
		216,
		211,
		198,
		-1,
		-1,
		171,
		153,
		-1,
		-1,
		127,
		115,
		98,
		99,
		95,
		98,
		113,
		116,
		106,
		104,
		98,
		130,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		210,
		205,
		209,
		225,
		250,
		-1,
		187,
		-1,
		-1,
		172,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		103,
		114,
		124,
		112,
		113,
		103,
		113,
		126,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		239,
		-1,
		-1,
		203,
		183,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		130,
		132,
		121,
		115,
		109,
		116,
		115,
		123,
		131,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		189,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		123,
		127,
		119,
		112,
		107,
		118,
		110,
		114,
		131,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		113,
		124,
		113,
		116,
		130,
		125,
		-1,
		-1,
		192,
		195,
		-1,
		-1,
		200,
		202,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		117,
		123,
		126,
		115,
		119,
		131,
		-1,
		-1,
		199,
		200,
		205,
		-1,
		185,
		-1,
		203,
		-1,
		170,
		176,
		164,
		-1,
		-1,
		-1,
		158,
		121,
		142,
		152,
		146,
		144,
		135,
		121,
		128,
		126,
		122,
		133,
		-1,
		-1,
		-1,
		203,
		177,
		210,
		201,
		184,
		164,
		156,
		175,
		-1,
		145,
		-1,
		120,
		122,
		148,
		151,
		157,
		151,
		124,
		139,
		129,
		120,
		129,
		209,
		-1,
		179,
		212,
		176,
		170,
		146,
		150,
		166,
		-1,
		142,
		124,
		-1,
		152,
		142,
		173,
		158,
		139,
		126,
		133,
		133,
		126,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		151,
		142,
		-1,
		154,
		136,
		115,
		132,
		132,
		123,
		131,
		163,
		159,
		146,
		146,
		138,
		-1,
		282,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		170,
		143,
		131,
		137,
		133,
		119,
		125,
		127,
		135,
		133,
		130,
		142,
		138,
		158,
		139,
		174,
		-1,
		277,
		-1,
		211,
		-1,
		-1,
		193,
		173,
		165,
		154,
		143,
		141,
		132,
		123,
		145,
		161,
		145,
		143,
		146,
		147,
		-1,
		266,
		265,
		-1,
		212,
		204,
		190,
		-1,
		183,
		-1,
		189,
		150,
		-1,
		152,
		132,
		-1,
		154,
		150,
		-1,
		-1,
		253,
		228,
		-1,
		-1,
		-1,
		213,
		193,
		184,
		168,
		-1,
		143,
		143,
		-1,
		-1,
		-1,
		238,
		237,
		-1,
		206,
		209,
		-1,
		199,
		190,
		198,
		145,
		149,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		221,
		219,
		214,
		211,
		197,
		181,
		159,
		148,
		169,
		-1,
		-1,
		-1,
		219,
		211,
		204,
		-1,
		-1,
		206,
		189,
		170,
		168,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		196,
		-1,
		-1,
		202,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		230,
		-1,
		-1,
		-1,
		192,
		188,
		189,
		-1,
		-1,
		-1,
		-1,
		252,
		253,
		276,
		240,
		-1,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		255,
		253,
		-1,
		-1,
		-1,
		212,
		196,
		-1,
		182,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		217,
		-1,
		217,
		192,
		199,
		-1,
		-1,
		-1,
		-1,
		230,
		222,
		230,
		-1,
		202,
		204,
		-1,
		252,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		207,
		214,
		236,
		239,
		275,
		-1,
		226
	],
	[
		-1,
		158,
		147,
		158,
		166,
		139,
		146,
		-1,
		165,
		169,
		135,
		129,
		168,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		158,
		157,
		125,
		123,
		132,
		137,
		144,
		-1,
		143,
		-1,
		179,
		158,
		169,
		174,
		118,
		115,
		135,
		154,
		136,
		128,
		194,
		148,
		119,
		113,
		131,
		121,
		130,
		122,
		-1,
		119,
		109,
		131,
		110,
		121,
		113,
		-1,
		-1,
		113,
		114,
		120,
		106,
		112,
		108,
		-1,
		118,
		102,
		-1,
		-1,
		103,
		104,
		88,
		91,
		99,
		97,
		110,
		102,
		97,
		-1,
		-1,
		94,
		90,
		97,
		84,
		80,
		97,
		110,
		92,
		106,
		105,
		-1,
		105,
		123,
		123,
		91,
		89,
		73,
		71,
		89,
		91,
		97,
		97,
		-1,
		114,
		115,
		100,
		108,
		113,
		89,
		76,
		76,
		86,
		79,
		98,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		97,
		114,
		96,
		86,
		101,
		94,
		79,
		76,
		74,
		71,
		87,
		85,
		95,
		-1,
		-1,
		207,
		176,
		205,
		163,
		144,
		-1,
		110,
		90,
		94,
		90,
		84,
		77,
		91,
		87,
		-1,
		65,
		64,
		92,
		78,
		89,
		167,
		-1,
		-1,
		165,
		157,
		140,
		143,
		120,
		116,
		105,
		104,
		96,
		82,
		78,
		74,
		77,
		77,
		83,
		59,
		69,
		73,
		71,
		96,
		-1,
		-1,
		130,
		-1,
		-1,
		164,
		147,
		-1,
		130,
		137,
		126,
		132,
		118,
		139,
		115,
		106,
		98,
		92,
		80,
		72,
		69,
		82,
		70,
		56,
		81,
		85,
		66,
		87,
		82,
		-1,
		129,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		123,
		126,
		132,
		156,
		155,
		-1,
		127,
		115,
		116,
		101,
		98,
		85,
		73,
		77,
		61,
		68,
		67,
		60,
		58,
		88,
		63,
		85,
		82,
		100,
		105,
		99,
		108,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		160,
		-1,
		163,
		164,
		139,
		112,
		115,
		102,
		93,
		80,
		69,
		78,
		59,
		56,
		62,
		52,
		67,
		58,
		57,
		75,
		84,
		92,
		96,
		102,
		-1,
		222,
		-1,
		164,
		148,
		150,
		122,
		143,
		-1,
		180,
		164,
		156,
		141,
		141,
		-1,
		111,
		108,
		98,
		76,
		61,
		71,
		60,
		61,
		53,
		47,
		61,
		52,
		70,
		77,
		74,
		78,
		98,
		110,
		182,
		172,
		-1,
		154,
		159,
		118,
		126,
		145,
		183,
		147,
		-1,
		142,
		-1,
		113,
		126,
		-1,
		82,
		78,
		60,
		61,
		54,
		61,
		46,
		43,
		40,
		58,
		61,
		67,
		71,
		87,
		-1,
		-1,
		167,
		171,
		160,
		111,
		130,
		154,
		191,
		140,
		129,
		128,
		-1,
		119,
		96,
		93,
		81,
		68,
		53,
		54,
		60,
		44,
		23,
		42,
		42,
		58,
		84,
		62,
		74,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		137,
		108,
		132,
		174,
		158,
		151,
		139,
		104,
		104,
		98,
		-1,
		92,
		71,
		62,
		51,
		49,
		51,
		27,
		25,
		40,
		38,
		53,
		65,
		56,
		76,
		-1,
		-1,
		-1,
		167,
		156,
		157,
		103,
		126,
		163,
		137,
		123,
		128,
		103,
		96,
		90,
		105,
		88,
		69,
		58,
		50,
		39,
		23,
		19,
		12,
		36,
		43,
		47,
		71,
		78,
		84,
		-1,
		-1,
		174,
		164,
		148,
		150,
		147,
		117,
		124,
		156,
		128,
		141,
		-1,
		95,
		-1,
		84,
		79,
		63,
		58,
		55,
		46,
		33,
		21,
		0,
		32,
		41,
		47,
		76,
		76,
		68,
		93,
		96,
		-1,
		-1,
		-1,
		167,
		162,
		137,
		114,
		98,
		134,
		-1,
		111,
		112,
		-1,
		89,
		83,
		80,
		65,
		61,
		50,
		54,
		48,
		39,
		36,
		26,
		42,
		34,
		70,
		-1,
		76,
		70,
		98,
		99,
		87,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		93,
		145,
		-1,
		-1,
		96,
		89,
		-1,
		76,
		58,
		62,
		57,
		56,
		55,
		53,
		42,
		44,
		36,
		39,
		49,
		69,
		73,
		89,
		82,
		85,
		82,
		96,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		113,
		-1,
		105,
		97,
		87,
		81,
		75,
		71,
		69,
		84,
		68,
		67,
		65,
		56,
		64,
		47,
		45,
		42,
		46,
		64,
		93,
		87,
		81,
		80,
		92,
		-1,
		180,
		166,
		137,
		-1,
		-1,
		126,
		-1,
		90,
		104,
		120,
		-1,
		113,
		92,
		107,
		85,
		81,
		74,
		91,
		92,
		70,
		65,
		63,
		73,
		67,
		56,
		54,
		58,
		73,
		83,
		75,
		76,
		85,
		-1,
		186,
		173,
		131,
		127,
		116,
		136,
		87,
		75,
		107,
		-1,
		-1,
		149,
		-1,
		83,
		100,
		88,
		86,
		81,
		72,
		78,
		74,
		76,
		71,
		61,
		50,
		56,
		63,
		85,
		71,
		69,
		88,
		104,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		102,
		89,
		83,
		-1,
		124,
		-1,
		127,
		117,
		101,
		86,
		119,
		-1,
		89,
		73,
		78,
		-1,
		96,
		-1,
		69,
		71,
		69,
		60,
		57,
		68,
		66,
		77,
		94,
		-1,
		136,
		121,
		114,
		104,
		118,
		89,
		-1,
		144,
		-1,
		-1,
		114,
		108,
		108,
		92,
		95,
		105,
		85,
		79,
		78,
		91,
		97,
		77,
		69,
		62,
		59,
		60,
		73,
		93,
		84,
		96,
		-1,
		-1,
		-1,
		141,
		127,
		131,
		91,
		110,
		-1,
		-1,
		176,
		131,
		117,
		-1,
		101,
		122,
		110,
		100,
		90,
		123,
		111,
		88,
		81,
		67,
		69,
		67,
		69,
		74,
		95,
		96,
		109,
		-1,
		-1,
		124,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		123,
		139,
		131,
		102,
		111,
		-1,
		-1,
		102,
		100,
		103,
		84,
		71,
		91,
		94,
		84,
		68,
		83,
		95,
		103,
		108,
		-1,
		127,
		114,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		156,
		122,
		130,
		125,
		129,
		105,
		-1,
		101,
		95,
		75,
		89,
		96,
		86,
		81,
		75,
		78,
		96,
		113,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		113,
		127,
		118,
		111,
		115,
		-1,
		103,
		91,
		77,
		94,
		99,
		96,
		87,
		79,
		84,
		81,
		94,
		108,
		112,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		131,
		146,
		157,
		134,
		107,
		102,
		95,
		89,
		85,
		101,
		107,
		118,
		86,
		82,
		83,
		87,
		86,
		103,
		113,
		-1,
		-1,
		145,
		162,
		157,
		139,
		143,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		95,
		98,
		92,
		89,
		94,
		99,
		87,
		96,
		114,
		113,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		158,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		97,
		107,
		109,
		101,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		194,
		169,
		184,
		193,
		178,
		185,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		106,
		113,
		113,
		105,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		193,
		186,
		179,
		169,
		172,
		-1,
		-1,
		160,
		157,
		133,
		116,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		172,
		253,
		246,
		229,
		237,
		268,
		-1,
		183,
		175,
		186,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		123,
		120,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		186,
		229,
		223,
		226,
		250,
		264,
		-1,
		180,
		-1,
		-1,
		192,
		164,
		148,
		138,
		132,
		182,
		137,
		132,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		221,
		209,
		217,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		208,
		-1,
		175,
		-1,
		150,
		154,
		145,
		148,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		251,
		207,
		210,
		208,
		232,
		247,
		251,
		-1,
		192,
		231,
		229,
		-1,
		213,
		-1,
		-1,
		-1,
		164,
		158,
		150,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		207,
		198,
		225,
		236,
		225,
		220,
		207,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		226,
		220,
		224,
		240,
		265,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		214,
		215,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		150,
		154,
		120,
		114,
		153,
		122,
		128,
		139,
		-1,
		-1,
		-1,
		143,
		142,
		110,
		108,
		117,
		122,
		129,
		-1,
		128,
		-1,
		164,
		143,
		154,
		159,
		103,
		100,
		120,
		139,
		121,
		113,
		179,
		133,
		104,
		98,
		116,
		106,
		115,
		107,
		-1,
		104,
		94,
		116,
		95,
		106,
		98,
		-1,
		-1,
		98,
		99,
		105,
		91,
		97,
		93,
		-1,
		103,
		87,
		-1,
		-1,
		88,
		89,
		73,
		76,
		84,
		82,
		95,
		87,
		82,
		-1,
		-1,
		79,
		75,
		82,
		69,
		65,
		82,
		95,
		77,
		91,
		90,
		-1,
		91,
		108,
		108,
		76,
		74,
		58,
		56,
		74,
		76,
		82,
		82,
		-1,
		108,
		104,
		105,
		103,
		98,
		74,
		61,
		61,
		71,
		64,
		83,
		71,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		100,
		117,
		101,
		91,
		95,
		93,
		64,
		61,
		59,
		56,
		72,
		70,
		80,
		-1,
		-1,
		202,
		175,
		199,
		157,
		139,
		-1,
		105,
		94,
		99,
		95,
		89,
		82,
		95,
		80,
		-1,
		50,
		49,
		77,
		63,
		74,
		171,
		-1,
		-1,
		160,
		152,
		134,
		137,
		114,
		110,
		109,
		108,
		100,
		86,
		82,
		79,
		82,
		82,
		88,
		44,
		54,
		58,
		56,
		81,
		-1,
		-1,
		109,
		-1,
		-1,
		168,
		151,
		-1,
		129,
		136,
		120,
		126,
		112,
		133,
		119,
		110,
		102,
		96,
		84,
		77,
		74,
		87,
		66,
		41,
		66,
		70,
		51,
		72,
		67,
		-1,
		108,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		126,
		150,
		149,
		-1,
		131,
		119,
		120,
		105,
		102,
		89,
		77,
		82,
		66,
		66,
		63,
		45,
		43,
		73,
		48,
		70,
		67,
		79,
		84,
		78,
		87,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		154,
		-1,
		157,
		168,
		143,
		116,
		119,
		106,
		97,
		84,
		73,
		83,
		64,
		61,
		57,
		37,
		52,
		43,
		42,
		60,
		63,
		71,
		75,
		81,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		174,
		158,
		160,
		145,
		145,
		-1,
		115,
		112,
		102,
		80,
		65,
		76,
		64,
		59,
		50,
		32,
		46,
		37,
		50,
		57,
		53,
		57,
		77,
		89,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		117,
		130,
		-1,
		86,
		82,
		64,
		65,
		60,
		68,
		43,
		28,
		25,
		43,
		41,
		46,
		50,
		66,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		100,
		97,
		85,
		72,
		57,
		58,
		66,
		51,
		30,
		24,
		21,
		37,
		63,
		41,
		53,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		96,
		75,
		66,
		55,
		53,
		61,
		34,
		20,
		19,
		17,
		32,
		44,
		35,
		55,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		109,
		92,
		73,
		62,
		54,
		43,
		36,
		32,
		24,
		15,
		22,
		26,
		50,
		57,
		63,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		83,
		67,
		62,
		59,
		55,
		42,
		39,
		33,
		0,
		20,
		22,
		55,
		55,
		47,
		72,
		75,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		69,
		65,
		59,
		63,
		57,
		50,
		40,
		32,
		27,
		15,
		51,
		-1,
		55,
		49,
		77,
		80,
		68,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		69,
		66,
		61,
		64,
		53,
		42,
		48,
		40,
		20,
		25,
		50,
		54,
		68,
		61,
		66,
		63,
		77,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		89,
		73,
		76,
		65,
		56,
		64,
		41,
		34,
		23,
		27,
		45,
		74,
		68,
		62,
		61,
		73,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		81,
		96,
		97,
		75,
		65,
		63,
		68,
		56,
		45,
		35,
		39,
		54,
		64,
		56,
		57,
		66,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		95,
		93,
		86,
		77,
		83,
		74,
		65,
		60,
		50,
		39,
		45,
		44,
		66,
		52,
		50,
		69,
		85,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		94,
		78,
		83,
		-1,
		85,
		-1,
		58,
		60,
		52,
		41,
		38,
		49,
		47,
		58,
		75,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		110,
		90,
		84,
		83,
		80,
		78,
		66,
		50,
		43,
		40,
		41,
		54,
		74,
		65,
		77,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		127,
		115,
		105,
		95,
		104,
		94,
		69,
		62,
		48,
		50,
		48,
		50,
		55,
		76,
		77,
		90,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		116,
		-1,
		-1,
		105,
		96,
		86,
		65,
		52,
		72,
		75,
		65,
		49,
		64,
		76,
		84,
		89,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		160,
		122,
		111,
		106,
		110,
		104,
		-1,
		82,
		76,
		56,
		70,
		77,
		67,
		62,
		56,
		59,
		77,
		94,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		117,
		128,
		99,
		92,
		96,
		-1,
		84,
		72,
		58,
		75,
		80,
		77,
		68,
		60,
		65,
		62,
		75,
		89,
		93,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		135,
		150,
		138,
		115,
		88,
		83,
		76,
		70,
		66,
		82,
		88,
		99,
		67,
		63,
		64,
		68,
		67,
		84,
		94,
		-1,
		-1,
		149,
		166,
		161,
		143,
		147,
		165,
		-1,
		-1,
		92,
		83,
		74,
		77,
		76,
		79,
		73,
		70,
		75,
		80,
		68,
		77,
		95,
		94,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		162,
		163,
		110,
		92,
		88,
		86,
		79,
		88,
		83,
		78,
		88,
		90,
		82,
		70,
		74,
		97,
		86,
		125,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		125,
		122,
		-1,
		92,
		117,
		89,
		96,
		87,
		94,
		94,
		86,
		64,
		71,
		87,
		86,
		81,
		117,
		108,
		114,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		141,
		138,
		114,
		97,
		95,
		88,
		83,
		93,
		73,
		60,
		64,
		68,
		74,
		79,
		84,
		90,
		105,
		120,
		-1,
		176,
		257,
		250,
		223,
		231,
		262,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		114,
		111,
		116,
		104,
		101,
		103,
		98,
		89,
		74,
		80,
		67,
		66,
		84,
		88,
		97,
		104,
		94,
		107,
		111,
		-1,
		190,
		233,
		217,
		220,
		244,
		258,
		-1,
		161,
		-1,
		-1,
		173,
		145,
		129,
		119,
		113,
		163,
		118,
		113,
		97,
		95,
		86,
		77,
		84,
		75,
		75,
		78,
		93,
		98,
		90,
		104,
		104,
		105,
		-1,
		207,
		213,
		211,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		189,
		-1,
		156,
		-1,
		131,
		135,
		126,
		129,
		111,
		98,
		90,
		82,
		98,
		73,
		83,
		79,
		80,
		89,
		100,
		112,
		111,
		112,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		173,
		212,
		210,
		-1,
		194,
		-1,
		-1,
		-1,
		145,
		139,
		131,
		131,
		110,
		110,
		84,
		88,
		78,
		85,
		95,
		97,
		89,
		93,
		106,
		117,
		120,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		188,
		179,
		206,
		217,
		206,
		201,
		188,
		-1,
		-1,
		168,
		149,
		-1,
		-1,
		117,
		105,
		88,
		89,
		85,
		88,
		103,
		106,
		96,
		94,
		88,
		120,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		207,
		201,
		205,
		221,
		246,
		-1,
		177,
		-1,
		-1,
		162,
		-1,
		-1,
		147,
		110,
		99,
		90,
		96,
		93,
		104,
		114,
		102,
		103,
		93,
		103,
		116,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		235,
		-1,
		-1,
		193,
		173,
		-1,
		-1,
		145,
		143,
		132,
		-1,
		122,
		95,
		100,
		120,
		122,
		111,
		105,
		99,
		106,
		105,
		113,
		121,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		183,
		179,
		-1,
		-1,
		140,
		133,
		121,
		109,
		99,
		109,
		113,
		117,
		109,
		102,
		97,
		108,
		100,
		104,
		121,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		200,
		186,
		179,
		167,
		165,
		-1,
		174,
		158,
		139,
		-1,
		109,
		122,
		153,
		121,
		126,
		121,
		103,
		114,
		103,
		106,
		120,
		115,
		-1,
		-1,
		188,
		191,
		-1,
		-1,
		190,
		192,
		-1,
		191,
		180,
		165,
		157,
		-1,
		-1,
		146,
		142,
		-1,
		-1,
		110,
		135,
		124,
		132,
		127,
		107,
		113,
		116,
		105,
		109,
		121,
		-1,
		-1,
		195,
		196,
		197,
		-1,
		175,
		-1,
		193,
		-1,
		160,
		166,
		154,
		-1,
		-1,
		-1,
		148,
		111,
		132,
		142,
		136,
		134,
		125,
		111,
		118,
		116,
		112,
		123,
		-1,
		-1,
		-1,
		193,
		167,
		200,
		191,
		174,
		154,
		146,
		165,
		-1,
		135,
		-1,
		110,
		112,
		138,
		141,
		147,
		141,
		114,
		129,
		119,
		110,
		119,
		199,
		-1,
		169,
		202,
		166,
		160,
		136,
		140,
		156,
		-1,
		132,
		114,
		-1,
		142,
		132,
		163,
		148,
		129,
		116,
		123,
		123,
		116,
		-1,
		-1,
		-1,
		171,
		170,
		162,
		156,
		156,
		141,
		132,
		-1,
		144,
		126,
		105,
		122,
		122,
		113,
		121,
		153,
		149,
		136,
		136,
		128,
		-1,
		272,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		165,
		160,
		133,
		121,
		127,
		123,
		109,
		115,
		117,
		125,
		123,
		120,
		132,
		128,
		148,
		129,
		164,
		-1,
		267,
		-1,
		201,
		-1,
		-1,
		183,
		163,
		155,
		144,
		133,
		131,
		122,
		113,
		135,
		151,
		135,
		133,
		136,
		137,
		-1,
		256,
		255,
		-1,
		202,
		194,
		180,
		-1,
		173,
		-1,
		179,
		140,
		-1,
		142,
		122,
		-1,
		144,
		140,
		-1,
		-1,
		243,
		218,
		-1,
		-1,
		-1,
		203,
		183,
		174,
		158,
		-1,
		133,
		133,
		-1,
		-1,
		-1,
		228,
		227,
		-1,
		196,
		199,
		-1,
		189,
		180,
		188,
		135,
		139,
		-1,
		-1,
		-1,
		237,
		218,
		212,
		211,
		209,
		204,
		201,
		187,
		171,
		149,
		138,
		159,
		-1,
		-1,
		-1,
		209,
		201,
		194,
		-1,
		-1,
		196,
		179,
		160,
		158,
		-1,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		186,
		-1,
		-1,
		192,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		220,
		-1,
		-1,
		-1,
		182,
		178,
		179,
		-1,
		-1,
		-1,
		-1,
		242,
		243,
		266,
		230,
		-1,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		245,
		243,
		-1,
		-1,
		-1,
		202,
		186,
		-1,
		172,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		207,
		-1,
		207,
		182,
		189,
		-1,
		-1,
		-1,
		-1,
		220,
		212,
		220,
		-1,
		192,
		194,
		-1,
		242,
		-1,
		-1,
		235,
		226,
		-1,
		-1,
		197,
		204,
		226,
		229,
		265,
		-1,
		216
	],
	[
		-1,
		133,
		122,
		133,
		141,
		114,
		121,
		-1,
		140,
		144,
		110,
		104,
		143,
		112,
		118,
		129,
		-1,
		-1,
		-1,
		133,
		132,
		100,
		98,
		107,
		112,
		119,
		-1,
		118,
		-1,
		154,
		133,
		144,
		149,
		93,
		90,
		110,
		129,
		111,
		103,
		169,
		123,
		94,
		88,
		106,
		96,
		105,
		97,
		-1,
		94,
		84,
		106,
		85,
		96,
		88,
		-1,
		-1,
		88,
		89,
		95,
		81,
		87,
		83,
		-1,
		93,
		77,
		-1,
		-1,
		78,
		79,
		63,
		66,
		74,
		72,
		85,
		77,
		72,
		-1,
		-1,
		69,
		65,
		72,
		59,
		55,
		72,
		85,
		67,
		81,
		80,
		-1,
		81,
		98,
		98,
		66,
		64,
		48,
		46,
		64,
		66,
		72,
		72,
		-1,
		98,
		94,
		95,
		93,
		88,
		64,
		51,
		51,
		61,
		54,
		73,
		61,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		99,
		90,
		107,
		91,
		81,
		85,
		83,
		54,
		51,
		49,
		46,
		62,
		60,
		70,
		-1,
		-1,
		192,
		165,
		189,
		147,
		129,
		-1,
		95,
		87,
		89,
		85,
		79,
		72,
		85,
		70,
		-1,
		40,
		39,
		67,
		53,
		64,
		164,
		-1,
		-1,
		150,
		142,
		124,
		127,
		104,
		100,
		102,
		101,
		93,
		79,
		75,
		69,
		72,
		72,
		78,
		34,
		44,
		48,
		46,
		71,
		-1,
		-1,
		103,
		-1,
		-1,
		161,
		144,
		-1,
		119,
		126,
		110,
		116,
		102,
		123,
		112,
		103,
		95,
		89,
		77,
		67,
		64,
		77,
		56,
		31,
		56,
		60,
		41,
		62,
		57,
		-1,
		102,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		120,
		123,
		116,
		140,
		139,
		-1,
		124,
		112,
		113,
		98,
		95,
		82,
		70,
		72,
		56,
		56,
		53,
		35,
		33,
		63,
		38,
		60,
		57,
		73,
		78,
		72,
		81,
		-1,
		169,
		165,
		161,
		168,
		117,
		-1,
		-1,
		144,
		-1,
		147,
		160,
		136,
		109,
		112,
		99,
		90,
		77,
		66,
		73,
		54,
		51,
		47,
		27,
		42,
		33,
		32,
		50,
		57,
		65,
		69,
		75,
		-1,
		219,
		-1,
		161,
		145,
		147,
		119,
		140,
		-1,
		164,
		148,
		153,
		138,
		138,
		-1,
		108,
		105,
		95,
		73,
		58,
		66,
		54,
		49,
		40,
		22,
		36,
		27,
		44,
		51,
		47,
		51,
		71,
		83,
		179,
		169,
		-1,
		151,
		156,
		115,
		123,
		142,
		180,
		144,
		-1,
		139,
		-1,
		110,
		123,
		-1,
		79,
		75,
		57,
		58,
		51,
		58,
		33,
		18,
		15,
		33,
		35,
		40,
		44,
		60,
		-1,
		-1,
		164,
		168,
		157,
		108,
		127,
		151,
		188,
		137,
		126,
		125,
		-1,
		116,
		93,
		90,
		78,
		65,
		50,
		51,
		57,
		53,
		32,
		14,
		11,
		31,
		57,
		35,
		47,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		134,
		105,
		129,
		171,
		155,
		148,
		136,
		101,
		101,
		95,
		-1,
		89,
		68,
		59,
		48,
		46,
		58,
		38,
		29,
		9,
		7,
		26,
		38,
		29,
		49,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		100,
		123,
		160,
		134,
		120,
		125,
		100,
		93,
		87,
		102,
		85,
		66,
		55,
		47,
		36,
		39,
		40,
		32,
		5,
		9,
		20,
		44,
		51,
		57,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		114,
		121,
		153,
		125,
		138,
		-1,
		92,
		-1,
		81,
		76,
		60,
		55,
		52,
		49,
		37,
		33,
		31,
		19,
		0,
		15,
		49,
		49,
		41,
		66,
		69,
		-1,
		-1,
		-1,
		164,
		159,
		134,
		111,
		95,
		131,
		-1,
		108,
		109,
		-1,
		86,
		80,
		77,
		62,
		58,
		53,
		57,
		50,
		43,
		33,
		25,
		26,
		8,
		40,
		-1,
		49,
		43,
		71,
		73,
		61,
		-1,
		-1,
		-1,
		157,
		136,
		129,
		149,
		90,
		142,
		-1,
		-1,
		93,
		86,
		-1,
		73,
		55,
		62,
		60,
		54,
		58,
		46,
		35,
		41,
		33,
		13,
		23,
		43,
		47,
		62,
		55,
		59,
		56,
		70,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		110,
		-1,
		102,
		94,
		84,
		78,
		72,
		68,
		66,
		82,
		66,
		69,
		58,
		49,
		57,
		37,
		30,
		16,
		20,
		38,
		67,
		61,
		55,
		54,
		66,
		-1,
		177,
		163,
		134,
		-1,
		-1,
		123,
		-1,
		87,
		101,
		117,
		-1,
		110,
		89,
		104,
		82,
		78,
		74,
		89,
		90,
		68,
		58,
		56,
		64,
		52,
		41,
		28,
		32,
		47,
		57,
		49,
		50,
		59,
		-1,
		183,
		170,
		128,
		124,
		113,
		133,
		84,
		72,
		104,
		-1,
		-1,
		146,
		-1,
		80,
		97,
		88,
		86,
		79,
		70,
		76,
		67,
		61,
		56,
		46,
		35,
		41,
		37,
		59,
		45,
		43,
		62,
		78,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		99,
		86,
		80,
		-1,
		121,
		-1,
		124,
		114,
		98,
		83,
		116,
		-1,
		87,
		71,
		76,
		-1,
		81,
		-1,
		54,
		54,
		45,
		34,
		31,
		42,
		40,
		51,
		68,
		-1,
		133,
		118,
		111,
		101,
		115,
		86,
		-1,
		141,
		-1,
		-1,
		111,
		105,
		105,
		89,
		92,
		103,
		83,
		77,
		76,
		76,
		71,
		62,
		43,
		36,
		33,
		34,
		47,
		67,
		58,
		70,
		-1,
		-1,
		-1,
		138,
		124,
		128,
		88,
		107,
		-1,
		-1,
		173,
		128,
		114,
		-1,
		98,
		120,
		108,
		98,
		88,
		97,
		87,
		62,
		55,
		41,
		43,
		41,
		43,
		48,
		69,
		70,
		83,
		-1,
		-1,
		121,
		126,
		114,
		100,
		119,
		-1,
		-1,
		-1,
		120,
		136,
		128,
		99,
		109,
		-1,
		-1,
		98,
		89,
		79,
		58,
		45,
		65,
		68,
		58,
		42,
		57,
		69,
		77,
		82,
		-1,
		124,
		111,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		-1,
		-1,
		153,
		115,
		104,
		99,
		103,
		97,
		-1,
		75,
		69,
		49,
		63,
		70,
		60,
		55,
		49,
		52,
		70,
		87,
		-1,
		-1,
		136,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		110,
		121,
		92,
		85,
		89,
		-1,
		77,
		65,
		51,
		68,
		73,
		70,
		61,
		53,
		58,
		55,
		68,
		82,
		86,
		159,
		-1,
		142,
		-1,
		-1,
		-1,
		128,
		143,
		131,
		108,
		81,
		76,
		69,
		63,
		59,
		75,
		81,
		92,
		60,
		56,
		57,
		61,
		60,
		77,
		87,
		-1,
		-1,
		142,
		159,
		154,
		136,
		140,
		158,
		-1,
		-1,
		85,
		76,
		67,
		70,
		69,
		72,
		66,
		63,
		68,
		73,
		61,
		70,
		88,
		87,
		-1,
		-1,
		-1,
		162,
		-1,
		177,
		-1,
		-1,
		155,
		156,
		103,
		85,
		81,
		79,
		72,
		81,
		76,
		71,
		81,
		83,
		75,
		63,
		67,
		90,
		79,
		118,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		169,
		160,
		118,
		115,
		-1,
		85,
		110,
		82,
		89,
		80,
		87,
		87,
		79,
		57,
		64,
		80,
		79,
		74,
		110,
		101,
		107,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		134,
		131,
		107,
		90,
		88,
		81,
		76,
		86,
		66,
		53,
		57,
		61,
		67,
		72,
		77,
		83,
		98,
		113,
		-1,
		169,
		250,
		243,
		216,
		224,
		255,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		107,
		104,
		109,
		97,
		94,
		96,
		91,
		82,
		67,
		73,
		60,
		59,
		77,
		81,
		90,
		97,
		87,
		100,
		104,
		-1,
		183,
		226,
		210,
		213,
		237,
		251,
		-1,
		154,
		-1,
		-1,
		166,
		138,
		122,
		112,
		106,
		156,
		111,
		106,
		90,
		88,
		79,
		70,
		77,
		68,
		68,
		71,
		86,
		91,
		83,
		97,
		97,
		98,
		-1,
		200,
		206,
		204,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		149,
		-1,
		124,
		128,
		119,
		122,
		104,
		91,
		83,
		75,
		91,
		66,
		76,
		72,
		73,
		82,
		93,
		105,
		104,
		105,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		166,
		205,
		203,
		-1,
		187,
		-1,
		-1,
		-1,
		138,
		132,
		124,
		124,
		103,
		103,
		77,
		81,
		71,
		78,
		88,
		90,
		82,
		86,
		99,
		110,
		113,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		181,
		172,
		199,
		210,
		199,
		194,
		181,
		-1,
		-1,
		161,
		142,
		-1,
		-1,
		110,
		98,
		81,
		82,
		78,
		81,
		96,
		99,
		89,
		87,
		81,
		113,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		200,
		194,
		198,
		214,
		239,
		-1,
		170,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		103,
		92,
		83,
		89,
		86,
		97,
		107,
		95,
		96,
		86,
		96,
		109,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		186,
		166,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		88,
		93,
		113,
		115,
		104,
		98,
		92,
		99,
		98,
		106,
		114,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		172,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		102,
		106,
		110,
		102,
		95,
		90,
		101,
		93,
		97,
		114,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		146,
		114,
		119,
		114,
		96,
		107,
		96,
		99,
		113,
		108,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		183,
		185,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		103,
		128,
		117,
		125,
		120,
		100,
		106,
		109,
		98,
		102,
		114,
		-1,
		-1,
		188,
		189,
		190,
		-1,
		168,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		141,
		104,
		125,
		135,
		129,
		127,
		118,
		104,
		111,
		109,
		105,
		116,
		-1,
		-1,
		-1,
		186,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		103,
		105,
		131,
		134,
		140,
		134,
		107,
		122,
		112,
		103,
		112,
		192,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		156,
		141,
		122,
		109,
		116,
		116,
		109,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		146,
		142,
		129,
		129,
		121,
		-1,
		265,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		125,
		121,
		141,
		122,
		157,
		-1,
		260,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		128,
		126,
		129,
		130,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		137,
		133,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		145,
		134,
		145,
		153,
		126,
		133,
		-1,
		152,
		156,
		122,
		116,
		155,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		145,
		144,
		112,
		110,
		119,
		124,
		131,
		-1,
		130,
		-1,
		166,
		145,
		156,
		161,
		105,
		102,
		122,
		141,
		123,
		115,
		181,
		135,
		106,
		100,
		118,
		108,
		117,
		109,
		-1,
		106,
		96,
		118,
		97,
		108,
		100,
		-1,
		-1,
		100,
		101,
		107,
		93,
		99,
		95,
		-1,
		105,
		89,
		-1,
		-1,
		90,
		91,
		75,
		78,
		86,
		84,
		97,
		89,
		84,
		-1,
		-1,
		81,
		77,
		84,
		71,
		67,
		84,
		97,
		79,
		93,
		92,
		-1,
		93,
		110,
		110,
		78,
		76,
		60,
		58,
		76,
		78,
		84,
		84,
		-1,
		110,
		106,
		107,
		105,
		100,
		76,
		63,
		63,
		73,
		66,
		85,
		73,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		100,
		117,
		103,
		93,
		97,
		95,
		66,
		63,
		61,
		58,
		74,
		72,
		82,
		-1,
		-1,
		204,
		177,
		201,
		159,
		141,
		-1,
		107,
		93,
		99,
		97,
		91,
		84,
		97,
		82,
		-1,
		52,
		51,
		79,
		65,
		76,
		170,
		-1,
		-1,
		162,
		154,
		136,
		139,
		116,
		112,
		108,
		107,
		99,
		85,
		81,
		81,
		84,
		84,
		90,
		46,
		56,
		60,
		58,
		83,
		-1,
		-1,
		112,
		-1,
		-1,
		167,
		150,
		-1,
		131,
		138,
		122,
		128,
		114,
		135,
		118,
		109,
		101,
		95,
		83,
		79,
		76,
		89,
		68,
		43,
		68,
		72,
		53,
		74,
		69,
		-1,
		111,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		126,
		129,
		128,
		152,
		151,
		-1,
		130,
		118,
		119,
		104,
		101,
		88,
		76,
		84,
		68,
		68,
		65,
		47,
		45,
		75,
		50,
		72,
		69,
		82,
		87,
		81,
		90,
		-1,
		175,
		171,
		167,
		174,
		123,
		-1,
		-1,
		156,
		-1,
		159,
		167,
		142,
		115,
		118,
		105,
		96,
		83,
		72,
		83,
		66,
		63,
		59,
		39,
		54,
		45,
		44,
		62,
		66,
		74,
		78,
		84,
		-1,
		225,
		-1,
		167,
		151,
		153,
		125,
		146,
		-1,
		176,
		160,
		159,
		144,
		144,
		-1,
		114,
		111,
		101,
		79,
		64,
		78,
		66,
		61,
		52,
		34,
		48,
		39,
		53,
		60,
		56,
		60,
		80,
		92,
		185,
		175,
		-1,
		157,
		162,
		121,
		129,
		148,
		186,
		150,
		-1,
		145,
		-1,
		116,
		129,
		-1,
		85,
		81,
		63,
		64,
		59,
		70,
		45,
		30,
		27,
		45,
		44,
		49,
		53,
		69,
		-1,
		-1,
		170,
		174,
		163,
		114,
		133,
		157,
		194,
		143,
		132,
		131,
		-1,
		122,
		99,
		96,
		84,
		71,
		56,
		57,
		65,
		65,
		44,
		27,
		24,
		40,
		66,
		44,
		56,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		140,
		111,
		135,
		177,
		161,
		154,
		142,
		107,
		107,
		101,
		-1,
		95,
		74,
		65,
		54,
		52,
		63,
		50,
		40,
		22,
		20,
		35,
		47,
		38,
		58,
		-1,
		-1,
		-1,
		170,
		159,
		160,
		106,
		129,
		166,
		140,
		126,
		131,
		106,
		99,
		93,
		108,
		91,
		72,
		61,
		53,
		42,
		50,
		46,
		38,
		18,
		18,
		29,
		53,
		60,
		66,
		-1,
		-1,
		177,
		167,
		151,
		153,
		150,
		120,
		127,
		159,
		131,
		144,
		-1,
		98,
		-1,
		87,
		82,
		66,
		61,
		58,
		55,
		43,
		39,
		37,
		22,
		13,
		0,
		58,
		58,
		50,
		75,
		78,
		-1,
		-1,
		-1,
		170,
		165,
		140,
		117,
		101,
		137,
		-1,
		114,
		115,
		-1,
		92,
		86,
		83,
		68,
		64,
		59,
		63,
		56,
		49,
		39,
		31,
		29,
		14,
		46,
		-1,
		58,
		52,
		80,
		79,
		67,
		-1,
		-1,
		-1,
		163,
		142,
		135,
		155,
		96,
		148,
		-1,
		-1,
		99,
		92,
		-1,
		79,
		61,
		68,
		66,
		60,
		64,
		52,
		41,
		47,
		39,
		19,
		23,
		49,
		53,
		71,
		64,
		65,
		62,
		76,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		116,
		-1,
		108,
		100,
		90,
		84,
		78,
		74,
		72,
		88,
		72,
		75,
		64,
		55,
		63,
		42,
		35,
		22,
		26,
		44,
		73,
		67,
		61,
		60,
		72,
		-1,
		183,
		169,
		140,
		-1,
		-1,
		129,
		-1,
		93,
		107,
		123,
		-1,
		116,
		95,
		110,
		88,
		84,
		80,
		95,
		96,
		74,
		64,
		62,
		69,
		57,
		46,
		34,
		38,
		53,
		63,
		55,
		56,
		65,
		-1,
		189,
		176,
		134,
		130,
		119,
		139,
		90,
		78,
		110,
		-1,
		-1,
		152,
		-1,
		86,
		103,
		94,
		92,
		85,
		76,
		82,
		73,
		66,
		61,
		51,
		40,
		46,
		43,
		65,
		51,
		49,
		68,
		84,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		105,
		92,
		86,
		-1,
		127,
		-1,
		130,
		120,
		104,
		89,
		122,
		-1,
		93,
		77,
		82,
		-1,
		86,
		-1,
		59,
		60,
		51,
		40,
		37,
		48,
		46,
		57,
		74,
		-1,
		139,
		124,
		117,
		107,
		121,
		92,
		-1,
		147,
		-1,
		-1,
		117,
		111,
		111,
		95,
		98,
		109,
		89,
		83,
		82,
		81,
		77,
		67,
		49,
		42,
		39,
		40,
		53,
		73,
		64,
		76,
		-1,
		-1,
		-1,
		144,
		130,
		134,
		94,
		113,
		-1,
		-1,
		179,
		134,
		120,
		-1,
		104,
		126,
		114,
		104,
		94,
		103,
		93,
		68,
		61,
		47,
		49,
		47,
		49,
		54,
		75,
		76,
		89,
		-1,
		-1,
		127,
		132,
		120,
		106,
		125,
		-1,
		-1,
		-1,
		126,
		142,
		134,
		105,
		115,
		-1,
		-1,
		104,
		95,
		85,
		64,
		51,
		71,
		74,
		64,
		48,
		63,
		75,
		83,
		88,
		-1,
		130,
		117,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		-1,
		-1,
		159,
		121,
		110,
		105,
		109,
		103,
		-1,
		81,
		75,
		55,
		69,
		76,
		66,
		61,
		55,
		58,
		76,
		93,
		-1,
		-1,
		142,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		116,
		127,
		98,
		91,
		95,
		-1,
		83,
		71,
		57,
		74,
		79,
		76,
		67,
		59,
		64,
		61,
		74,
		88,
		92,
		165,
		-1,
		148,
		-1,
		-1,
		-1,
		134,
		149,
		137,
		114,
		87,
		82,
		75,
		69,
		65,
		81,
		87,
		98,
		66,
		62,
		63,
		67,
		66,
		83,
		93,
		-1,
		-1,
		148,
		165,
		160,
		142,
		146,
		164,
		-1,
		-1,
		91,
		82,
		73,
		76,
		75,
		78,
		72,
		69,
		74,
		79,
		67,
		76,
		94,
		93,
		-1,
		-1,
		-1,
		168,
		-1,
		183,
		-1,
		-1,
		161,
		162,
		109,
		91,
		87,
		85,
		78,
		87,
		82,
		77,
		87,
		89,
		81,
		69,
		73,
		96,
		85,
		124,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		180,
		172,
		167,
		173,
		175,
		166,
		124,
		121,
		-1,
		91,
		116,
		88,
		95,
		86,
		93,
		93,
		85,
		63,
		70,
		86,
		85,
		80,
		116,
		107,
		113,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		173,
		169,
		159,
		149,
		152,
		-1,
		-1,
		140,
		137,
		113,
		96,
		94,
		87,
		82,
		92,
		72,
		59,
		63,
		67,
		73,
		78,
		83,
		89,
		104,
		119,
		-1,
		175,
		256,
		249,
		222,
		230,
		261,
		-1,
		163,
		155,
		166,
		141,
		143,
		-1,
		-1,
		113,
		110,
		115,
		103,
		100,
		102,
		97,
		88,
		73,
		79,
		66,
		65,
		83,
		87,
		96,
		103,
		93,
		106,
		110,
		-1,
		189,
		232,
		216,
		219,
		243,
		257,
		-1,
		160,
		-1,
		-1,
		172,
		144,
		128,
		118,
		112,
		162,
		117,
		112,
		96,
		94,
		85,
		76,
		83,
		74,
		74,
		77,
		92,
		97,
		89,
		103,
		103,
		104,
		-1,
		206,
		212,
		210,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		188,
		-1,
		155,
		-1,
		130,
		134,
		125,
		128,
		110,
		97,
		89,
		81,
		97,
		72,
		82,
		78,
		79,
		88,
		99,
		111,
		110,
		111,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		172,
		211,
		209,
		-1,
		193,
		-1,
		-1,
		-1,
		144,
		138,
		130,
		130,
		109,
		109,
		83,
		87,
		77,
		84,
		94,
		96,
		88,
		92,
		105,
		116,
		119,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		187,
		178,
		205,
		216,
		205,
		200,
		187,
		-1,
		-1,
		167,
		148,
		-1,
		-1,
		116,
		104,
		87,
		88,
		84,
		87,
		102,
		105,
		95,
		93,
		87,
		119,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		206,
		200,
		204,
		220,
		245,
		-1,
		176,
		-1,
		-1,
		161,
		-1,
		-1,
		146,
		109,
		98,
		89,
		95,
		92,
		103,
		113,
		101,
		102,
		92,
		102,
		115,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		192,
		172,
		-1,
		-1,
		144,
		142,
		131,
		-1,
		121,
		94,
		99,
		119,
		121,
		110,
		104,
		98,
		105,
		104,
		112,
		120,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		139,
		132,
		120,
		108,
		98,
		108,
		112,
		116,
		108,
		101,
		96,
		107,
		99,
		103,
		120,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		173,
		157,
		138,
		-1,
		108,
		121,
		152,
		120,
		125,
		120,
		102,
		113,
		102,
		105,
		119,
		114,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		189,
		191,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		134,
		123,
		131,
		126,
		106,
		112,
		115,
		104,
		108,
		120,
		-1,
		-1,
		194,
		195,
		196,
		-1,
		174,
		-1,
		192,
		-1,
		159,
		165,
		153,
		-1,
		-1,
		-1,
		147,
		110,
		131,
		141,
		135,
		133,
		124,
		110,
		117,
		115,
		111,
		122,
		-1,
		-1,
		-1,
		192,
		166,
		199,
		190,
		173,
		153,
		145,
		164,
		-1,
		134,
		-1,
		109,
		111,
		137,
		140,
		146,
		140,
		113,
		128,
		118,
		109,
		118,
		198,
		-1,
		168,
		201,
		165,
		159,
		135,
		139,
		155,
		-1,
		131,
		113,
		-1,
		141,
		131,
		162,
		147,
		128,
		115,
		122,
		122,
		115,
		-1,
		-1,
		-1,
		170,
		169,
		161,
		155,
		155,
		140,
		131,
		-1,
		143,
		125,
		104,
		121,
		121,
		112,
		120,
		152,
		148,
		135,
		135,
		127,
		-1,
		271,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		164,
		159,
		132,
		120,
		126,
		122,
		108,
		114,
		116,
		124,
		122,
		119,
		131,
		127,
		147,
		128,
		163,
		-1,
		266,
		-1,
		200,
		-1,
		-1,
		182,
		162,
		154,
		143,
		132,
		130,
		121,
		112,
		134,
		150,
		134,
		132,
		135,
		136,
		-1,
		255,
		254,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		178,
		139,
		-1,
		141,
		121,
		-1,
		143,
		139,
		-1,
		-1,
		242,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		173,
		157,
		-1,
		132,
		132,
		-1,
		-1,
		-1,
		227,
		226,
		-1,
		195,
		198,
		-1,
		188,
		179,
		187,
		134,
		138,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		210,
		208,
		203,
		200,
		186,
		170,
		148,
		137,
		158,
		-1,
		-1,
		-1,
		208,
		200,
		193,
		-1,
		-1,
		195,
		178,
		159,
		157,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		185,
		-1,
		-1,
		191,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		219,
		-1,
		-1,
		-1,
		181,
		177,
		178,
		-1,
		-1,
		-1,
		-1,
		241,
		242,
		265,
		229,
		-1,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		244,
		242,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		171,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		206,
		-1,
		206,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		219,
		211,
		219,
		-1,
		191,
		193,
		-1,
		241,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		196,
		203,
		225,
		228,
		264,
		-1,
		215
	],
	[
		-1,
		165,
		154,
		165,
		173,
		146,
		153,
		-1,
		172,
		176,
		142,
		136,
		175,
		144,
		150,
		161,
		-1,
		-1,
		-1,
		165,
		164,
		132,
		130,
		139,
		144,
		151,
		-1,
		150,
		-1,
		186,
		165,
		176,
		181,
		125,
		122,
		142,
		161,
		143,
		135,
		201,
		155,
		126,
		120,
		138,
		128,
		137,
		129,
		-1,
		126,
		116,
		138,
		117,
		128,
		120,
		-1,
		-1,
		120,
		121,
		127,
		113,
		119,
		115,
		-1,
		125,
		109,
		-1,
		-1,
		110,
		111,
		95,
		98,
		106,
		104,
		117,
		109,
		104,
		-1,
		-1,
		101,
		97,
		104,
		91,
		87,
		104,
		117,
		99,
		113,
		111,
		-1,
		113,
		130,
		130,
		98,
		96,
		80,
		78,
		96,
		98,
		104,
		103,
		-1,
		130,
		126,
		127,
		125,
		120,
		96,
		83,
		83,
		93,
		86,
		105,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		122,
		139,
		123,
		113,
		117,
		115,
		86,
		83,
		81,
		78,
		94,
		91,
		101,
		-1,
		-1,
		224,
		197,
		221,
		179,
		161,
		-1,
		127,
		127,
		121,
		117,
		111,
		104,
		117,
		102,
		-1,
		72,
		71,
		98,
		84,
		95,
		206,
		-1,
		-1,
		182,
		174,
		156,
		159,
		136,
		132,
		142,
		141,
		134,
		122,
		118,
		101,
		104,
		104,
		110,
		66,
		76,
		80,
		77,
		80,
		-1,
		-1,
		94,
		-1,
		-1,
		203,
		186,
		-1,
		151,
		158,
		142,
		148,
		134,
		155,
		152,
		143,
		137,
		132,
		120,
		99,
		96,
		109,
		88,
		63,
		88,
		92,
		72,
		70,
		65,
		-1,
		93,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		158,
		155,
		148,
		172,
		171,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		104,
		88,
		88,
		85,
		67,
		65,
		95,
		69,
		69,
		59,
		64,
		69,
		63,
		72,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		176,
		-1,
		179,
		192,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		105,
		86,
		83,
		79,
		59,
		74,
		64,
		63,
		48,
		48,
		56,
		60,
		66,
		-1,
		261,
		-1,
		203,
		187,
		189,
		162,
		183,
		-1,
		196,
		180,
		196,
		181,
		181,
		-1,
		151,
		148,
		138,
		116,
		101,
		98,
		86,
		81,
		72,
		54,
		68,
		58,
		54,
		52,
		38,
		42,
		56,
		74,
		221,
		211,
		-1,
		193,
		198,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		94,
		83,
		90,
		65,
		50,
		47,
		50,
		45,
		31,
		35,
		45,
		-1,
		-1,
		206,
		210,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		136,
		133,
		121,
		108,
		93,
		94,
		89,
		85,
		64,
		49,
		51,
		41,
		48,
		26,
		29,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		89,
		97,
		70,
		65,
		49,
		47,
		36,
		23,
		20,
		31,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		145,
		128,
		109,
		98,
		90,
		79,
		71,
		77,
		69,
		45,
		50,
		30,
		5,
		42,
		47,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		89,
		76,
		76,
		74,
		55,
		50,
		62,
		0,
		12,
		32,
		57,
		60,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		93,
		97,
		91,
		86,
		76,
		68,
		69,
		51,
		64,
		-1,
		40,
		34,
		62,
		65,
		55,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		100,
		97,
		98,
		89,
		78,
		84,
		76,
		56,
		66,
		78,
		55,
		53,
		46,
		51,
		50,
		64,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		110,
		101,
		92,
		100,
		80,
		73,
		59,
		63,
		73,
		64,
		59,
		65,
		57,
		60,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		101,
		99,
		107,
		95,
		84,
		71,
		75,
		77,
		74,
		60,
		60,
		62,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		110,
		104,
		99,
		89,
		78,
		84,
		80,
		82,
		68,
		66,
		61,
		76,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		130,
		114,
		119,
		-1,
		124,
		-1,
		97,
		97,
		88,
		77,
		74,
		78,
		69,
		82,
		67,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		146,
		126,
		120,
		119,
		119,
		114,
		105,
		86,
		79,
		76,
		77,
		90,
		102,
		81,
		69,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		163,
		151,
		141,
		131,
		140,
		130,
		105,
		98,
		84,
		86,
		84,
		86,
		91,
		82,
		74,
		84,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		171,
		142,
		152,
		-1,
		-1,
		141,
		132,
		122,
		101,
		88,
		108,
		111,
		101,
		85,
		98,
		88,
		76,
		85,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		196,
		158,
		147,
		142,
		146,
		140,
		-1,
		118,
		112,
		92,
		106,
		113,
		103,
		98,
		92,
		93,
		93,
		87,
		-1,
		-1,
		179,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		153,
		164,
		135,
		128,
		132,
		-1,
		120,
		108,
		94,
		111,
		116,
		113,
		104,
		96,
		101,
		90,
		103,
		99,
		89,
		202,
		-1,
		185,
		-1,
		-1,
		-1,
		171,
		186,
		174,
		151,
		124,
		119,
		112,
		106,
		102,
		118,
		124,
		135,
		103,
		99,
		100,
		96,
		95,
		103,
		104,
		-1,
		-1,
		185,
		202,
		197,
		179,
		183,
		201,
		-1,
		-1,
		128,
		119,
		110,
		113,
		112,
		115,
		109,
		106,
		111,
		113,
		104,
		105,
		122,
		107,
		-1,
		-1,
		-1,
		205,
		-1,
		220,
		-1,
		-1,
		198,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		126,
		118,
		103,
		110,
		133,
		115,
		136,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		217,
		209,
		204,
		210,
		212,
		203,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		123,
		130,
		130,
		122,
		100,
		107,
		123,
		122,
		117,
		128,
		123,
		132,
		-1,
		-1,
		307,
		296,
		285,
		291,
		-1,
		210,
		206,
		196,
		186,
		189,
		-1,
		-1,
		177,
		174,
		150,
		133,
		131,
		124,
		119,
		129,
		109,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		130,
		138,
		-1,
		212,
		293,
		286,
		259,
		267,
		298,
		-1,
		200,
		192,
		203,
		178,
		180,
		-1,
		-1,
		150,
		147,
		152,
		140,
		137,
		139,
		134,
		125,
		110,
		116,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		226,
		269,
		253,
		256,
		280,
		294,
		-1,
		197,
		-1,
		-1,
		209,
		181,
		165,
		155,
		149,
		199,
		154,
		149,
		133,
		131,
		122,
		113,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		243,
		249,
		247,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		225,
		-1,
		192,
		-1,
		167,
		171,
		162,
		165,
		147,
		134,
		126,
		118,
		134,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		268,
		224,
		227,
		238,
		249,
		264,
		268,
		-1,
		209,
		248,
		246,
		-1,
		230,
		-1,
		-1,
		-1,
		181,
		175,
		167,
		167,
		146,
		146,
		120,
		124,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		264,
		255,
		268,
		213,
		213,
		234,
		243,
		264,
		224,
		215,
		242,
		253,
		242,
		237,
		224,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		153,
		141,
		124,
		125,
		121,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		204,
		231,
		-1,
		-1,
		226,
		243,
		237,
		241,
		257,
		282,
		-1,
		213,
		-1,
		-1,
		198,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		129,
		140,
		150,
		138,
		139,
		129,
		139,
		152,
		241,
		238,
		226,
		224,
		247,
		212,
		200,
		-1,
		213,
		211,
		217,
		224,
		241,
		271,
		-1,
		-1,
		229,
		209,
		-1,
		-1,
		181,
		179,
		168,
		-1,
		158,
		131,
		136,
		156,
		158,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		198,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		215,
		-1,
		-1,
		176,
		169,
		157,
		145,
		135,
		145,
		149,
		153,
		145,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		284,
		-1,
		236,
		212,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		226,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		231,
		232,
		233,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		172,
		170,
		161,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		148,
		174,
		177,
		183,
		177,
		150,
		165,
		155,
		146,
		155,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		199,
		184,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		189,
		185,
		172,
		172,
		164,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		165,
		200,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		172,
		173,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		168,
		157,
		168,
		176,
		149,
		156,
		-1,
		175,
		179,
		145,
		139,
		178,
		147,
		153,
		164,
		-1,
		-1,
		-1,
		168,
		167,
		135,
		133,
		142,
		147,
		154,
		-1,
		153,
		-1,
		189,
		168,
		179,
		184,
		128,
		125,
		145,
		164,
		146,
		138,
		204,
		158,
		129,
		123,
		141,
		131,
		140,
		132,
		-1,
		129,
		119,
		141,
		120,
		131,
		123,
		-1,
		-1,
		123,
		124,
		130,
		116,
		122,
		118,
		-1,
		128,
		112,
		-1,
		-1,
		113,
		114,
		98,
		101,
		109,
		107,
		120,
		112,
		107,
		-1,
		-1,
		104,
		100,
		107,
		94,
		90,
		107,
		120,
		102,
		116,
		114,
		-1,
		116,
		133,
		133,
		101,
		99,
		83,
		81,
		99,
		101,
		107,
		106,
		-1,
		133,
		129,
		130,
		128,
		123,
		99,
		86,
		86,
		96,
		89,
		108,
		95,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		125,
		142,
		126,
		116,
		120,
		118,
		89,
		86,
		84,
		81,
		97,
		94,
		104,
		-1,
		-1,
		227,
		200,
		224,
		182,
		164,
		-1,
		130,
		130,
		124,
		120,
		114,
		107,
		120,
		105,
		-1,
		75,
		74,
		101,
		87,
		98,
		209,
		-1,
		-1,
		185,
		177,
		159,
		162,
		139,
		135,
		145,
		144,
		137,
		125,
		121,
		104,
		107,
		107,
		113,
		69,
		79,
		83,
		80,
		83,
		-1,
		-1,
		97,
		-1,
		-1,
		206,
		189,
		-1,
		154,
		161,
		145,
		151,
		137,
		158,
		155,
		146,
		140,
		135,
		123,
		102,
		99,
		112,
		91,
		66,
		91,
		95,
		75,
		73,
		68,
		-1,
		96,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		161,
		158,
		151,
		175,
		174,
		-1,
		170,
		158,
		159,
		144,
		141,
		128,
		116,
		107,
		91,
		91,
		88,
		70,
		68,
		98,
		72,
		72,
		62,
		67,
		72,
		66,
		75,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		179,
		-1,
		182,
		195,
		182,
		155,
		158,
		145,
		136,
		123,
		112,
		108,
		89,
		86,
		82,
		62,
		77,
		67,
		66,
		51,
		51,
		59,
		63,
		69,
		-1,
		264,
		-1,
		206,
		190,
		192,
		165,
		186,
		-1,
		199,
		183,
		199,
		184,
		184,
		-1,
		154,
		151,
		141,
		119,
		104,
		101,
		89,
		84,
		75,
		57,
		71,
		61,
		57,
		55,
		41,
		45,
		59,
		77,
		224,
		214,
		-1,
		196,
		201,
		161,
		169,
		188,
		226,
		190,
		-1,
		185,
		-1,
		156,
		169,
		-1,
		125,
		121,
		103,
		97,
		86,
		93,
		68,
		53,
		50,
		53,
		48,
		34,
		38,
		48,
		-1,
		-1,
		209,
		213,
		203,
		154,
		173,
		197,
		234,
		183,
		172,
		171,
		-1,
		162,
		139,
		136,
		124,
		111,
		96,
		97,
		92,
		88,
		67,
		52,
		54,
		44,
		51,
		29,
		32,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		180,
		151,
		175,
		217,
		201,
		194,
		182,
		147,
		147,
		141,
		-1,
		135,
		114,
		105,
		94,
		92,
		100,
		73,
		68,
		52,
		50,
		39,
		26,
		23,
		34,
		-1,
		-1,
		-1,
		210,
		199,
		200,
		146,
		169,
		206,
		180,
		166,
		171,
		146,
		139,
		133,
		148,
		131,
		112,
		101,
		93,
		82,
		74,
		80,
		72,
		48,
		53,
		33,
		10,
		45,
		50,
		-1,
		-1,
		217,
		207,
		191,
		193,
		190,
		160,
		167,
		199,
		171,
		184,
		-1,
		138,
		-1,
		127,
		122,
		106,
		101,
		98,
		92,
		79,
		79,
		77,
		58,
		53,
		65,
		15,
		0,
		35,
		60,
		63,
		-1,
		-1,
		-1,
		210,
		205,
		180,
		157,
		141,
		177,
		-1,
		154,
		155,
		-1,
		132,
		126,
		123,
		108,
		104,
		96,
		100,
		94,
		89,
		79,
		71,
		72,
		54,
		67,
		-1,
		43,
		37,
		65,
		68,
		58,
		-1,
		-1,
		-1,
		203,
		182,
		175,
		195,
		136,
		188,
		-1,
		-1,
		139,
		132,
		-1,
		119,
		101,
		108,
		103,
		100,
		101,
		92,
		81,
		87,
		79,
		59,
		69,
		81,
		58,
		56,
		49,
		54,
		53,
		67,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		156,
		-1,
		148,
		140,
		130,
		124,
		118,
		114,
		112,
		128,
		112,
		113,
		104,
		95,
		103,
		83,
		76,
		62,
		66,
		76,
		67,
		62,
		68,
		60,
		63,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		169,
		-1,
		133,
		147,
		163,
		-1,
		156,
		135,
		150,
		128,
		124,
		120,
		135,
		136,
		114,
		104,
		102,
		110,
		98,
		87,
		74,
		78,
		80,
		77,
		63,
		63,
		65,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		130,
		118,
		150,
		-1,
		-1,
		192,
		-1,
		126,
		143,
		134,
		132,
		125,
		116,
		122,
		113,
		107,
		102,
		92,
		81,
		87,
		83,
		85,
		71,
		69,
		64,
		79,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		167,
		-1,
		170,
		160,
		144,
		129,
		162,
		-1,
		133,
		117,
		122,
		-1,
		127,
		-1,
		100,
		100,
		91,
		80,
		77,
		81,
		72,
		85,
		70,
		-1,
		179,
		164,
		157,
		147,
		161,
		132,
		-1,
		187,
		-1,
		-1,
		157,
		151,
		151,
		135,
		138,
		149,
		129,
		123,
		122,
		122,
		117,
		108,
		89,
		82,
		79,
		80,
		93,
		105,
		84,
		72,
		-1,
		-1,
		-1,
		184,
		170,
		174,
		134,
		153,
		-1,
		-1,
		219,
		174,
		160,
		-1,
		144,
		166,
		154,
		144,
		134,
		143,
		133,
		108,
		101,
		87,
		89,
		87,
		89,
		94,
		85,
		77,
		87,
		-1,
		-1,
		167,
		172,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		166,
		182,
		174,
		145,
		155,
		-1,
		-1,
		144,
		135,
		125,
		104,
		91,
		111,
		114,
		104,
		88,
		101,
		91,
		79,
		88,
		-1,
		170,
		157,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		199,
		161,
		150,
		145,
		149,
		143,
		-1,
		121,
		115,
		95,
		109,
		116,
		106,
		101,
		95,
		96,
		96,
		90,
		-1,
		-1,
		182,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		156,
		167,
		138,
		131,
		135,
		-1,
		123,
		111,
		97,
		114,
		119,
		116,
		107,
		99,
		104,
		93,
		106,
		102,
		92,
		205,
		-1,
		188,
		-1,
		-1,
		-1,
		174,
		189,
		177,
		154,
		127,
		122,
		115,
		109,
		105,
		121,
		127,
		138,
		106,
		102,
		103,
		99,
		98,
		106,
		107,
		-1,
		-1,
		188,
		205,
		200,
		182,
		186,
		204,
		-1,
		-1,
		131,
		122,
		113,
		116,
		115,
		118,
		112,
		109,
		114,
		116,
		107,
		108,
		125,
		110,
		-1,
		-1,
		-1,
		208,
		-1,
		223,
		-1,
		-1,
		201,
		202,
		149,
		131,
		127,
		125,
		118,
		127,
		122,
		117,
		127,
		129,
		121,
		106,
		113,
		136,
		118,
		139,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		220,
		212,
		207,
		213,
		215,
		206,
		164,
		161,
		-1,
		131,
		156,
		128,
		135,
		126,
		133,
		133,
		125,
		103,
		110,
		126,
		125,
		120,
		131,
		126,
		135,
		-1,
		-1,
		310,
		299,
		288,
		294,
		-1,
		213,
		209,
		199,
		189,
		192,
		-1,
		-1,
		180,
		177,
		153,
		136,
		134,
		127,
		122,
		132,
		112,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		133,
		141,
		-1,
		215,
		296,
		289,
		262,
		270,
		301,
		-1,
		203,
		195,
		206,
		181,
		183,
		-1,
		-1,
		153,
		150,
		155,
		143,
		140,
		142,
		137,
		128,
		113,
		119,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		229,
		272,
		256,
		259,
		283,
		297,
		-1,
		200,
		-1,
		-1,
		212,
		184,
		168,
		158,
		152,
		202,
		157,
		152,
		136,
		134,
		125,
		116,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		246,
		252,
		250,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		228,
		-1,
		195,
		-1,
		170,
		174,
		165,
		168,
		150,
		137,
		129,
		121,
		137,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		271,
		227,
		230,
		241,
		252,
		267,
		271,
		-1,
		212,
		251,
		249,
		-1,
		233,
		-1,
		-1,
		-1,
		184,
		178,
		170,
		170,
		149,
		149,
		123,
		127,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		267,
		258,
		271,
		216,
		216,
		237,
		246,
		267,
		227,
		218,
		245,
		256,
		245,
		240,
		227,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		156,
		144,
		127,
		128,
		124,
		127,
		142,
		145,
		135,
		133,
		127,
		159,
		-1,
		260,
		259,
		248,
		245,
		221,
		212,
		207,
		234,
		-1,
		-1,
		229,
		246,
		240,
		244,
		260,
		285,
		-1,
		216,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		132,
		143,
		153,
		141,
		142,
		132,
		142,
		155,
		244,
		241,
		229,
		227,
		250,
		215,
		203,
		-1,
		216,
		214,
		220,
		227,
		244,
		274,
		-1,
		-1,
		232,
		212,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		134,
		139,
		159,
		161,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		253,
		267,
		256,
		252,
		251,
		259,
		208,
		201,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		222,
		218,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		152,
		156,
		148,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		287,
		-1,
		239,
		215,
		229,
		244,
		252,
		-1,
		-1,
		-1,
		239,
		225,
		218,
		206,
		204,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		227,
		230,
		-1,
		-1,
		229,
		231,
		-1,
		230,
		219,
		204,
		196,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		234,
		235,
		236,
		-1,
		214,
		-1,
		232,
		-1,
		199,
		205,
		193,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		175,
		173,
		164,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		232,
		206,
		239,
		230,
		213,
		193,
		185,
		204,
		-1,
		174,
		-1,
		149,
		151,
		177,
		180,
		186,
		180,
		153,
		168,
		158,
		149,
		158,
		238,
		-1,
		208,
		241,
		205,
		199,
		175,
		179,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		202,
		187,
		168,
		155,
		162,
		162,
		155,
		-1,
		-1,
		-1,
		210,
		209,
		201,
		195,
		195,
		180,
		171,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		192,
		188,
		175,
		175,
		167,
		-1,
		311,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		204,
		199,
		172,
		160,
		166,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		168,
		203,
		-1,
		306,
		-1,
		240,
		-1,
		-1,
		222,
		202,
		194,
		183,
		172,
		170,
		161,
		152,
		174,
		190,
		174,
		172,
		175,
		176,
		-1,
		295,
		294,
		-1,
		241,
		233,
		219,
		-1,
		212,
		-1,
		218,
		179,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		282,
		257,
		-1,
		-1,
		-1,
		242,
		222,
		213,
		197,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		267,
		266,
		-1,
		235,
		238,
		-1,
		228,
		219,
		227,
		174,
		178,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		250,
		248,
		243,
		240,
		226,
		210,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		248,
		240,
		233,
		-1,
		-1,
		235,
		218,
		199,
		197,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		225,
		-1,
		-1,
		231,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		259,
		-1,
		-1,
		-1,
		221,
		217,
		218,
		-1,
		-1,
		-1,
		-1,
		281,
		282,
		305,
		269,
		-1,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		284,
		282,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		211,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		246,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		236,
		243,
		265,
		268,
		304,
		-1,
		255
	],
	[
		-1,
		159,
		148,
		159,
		167,
		140,
		147,
		-1,
		166,
		170,
		136,
		130,
		169,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		159,
		158,
		126,
		124,
		133,
		138,
		145,
		-1,
		144,
		-1,
		180,
		159,
		170,
		175,
		119,
		116,
		136,
		155,
		137,
		129,
		195,
		149,
		120,
		114,
		132,
		122,
		131,
		123,
		-1,
		120,
		110,
		132,
		111,
		122,
		114,
		-1,
		-1,
		114,
		115,
		121,
		107,
		113,
		109,
		-1,
		119,
		103,
		-1,
		-1,
		104,
		105,
		89,
		92,
		100,
		98,
		111,
		103,
		98,
		-1,
		-1,
		95,
		91,
		98,
		85,
		81,
		98,
		111,
		93,
		107,
		105,
		-1,
		107,
		124,
		124,
		92,
		90,
		74,
		72,
		90,
		92,
		98,
		97,
		-1,
		124,
		120,
		121,
		119,
		114,
		90,
		77,
		77,
		87,
		80,
		99,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		116,
		133,
		117,
		107,
		111,
		109,
		80,
		77,
		75,
		72,
		88,
		85,
		95,
		-1,
		-1,
		218,
		191,
		215,
		173,
		155,
		-1,
		121,
		121,
		115,
		111,
		105,
		98,
		111,
		96,
		-1,
		66,
		65,
		92,
		78,
		89,
		198,
		-1,
		-1,
		176,
		168,
		150,
		153,
		130,
		126,
		136,
		135,
		128,
		114,
		110,
		95,
		98,
		98,
		104,
		60,
		70,
		74,
		71,
		74,
		-1,
		-1,
		88,
		-1,
		-1,
		195,
		178,
		-1,
		145,
		152,
		136,
		142,
		128,
		149,
		146,
		137,
		130,
		124,
		112,
		93,
		90,
		103,
		82,
		57,
		82,
		86,
		66,
		64,
		59,
		-1,
		87,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		152,
		149,
		142,
		166,
		165,
		-1,
		159,
		147,
		148,
		133,
		130,
		117,
		105,
		98,
		82,
		82,
		79,
		61,
		59,
		89,
		63,
		63,
		53,
		58,
		63,
		57,
		66,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		170,
		-1,
		173,
		186,
		171,
		144,
		147,
		134,
		125,
		112,
		101,
		99,
		80,
		77,
		73,
		53,
		68,
		58,
		57,
		42,
		42,
		50,
		54,
		60,
		-1,
		253,
		-1,
		195,
		179,
		181,
		153,
		174,
		-1,
		190,
		174,
		188,
		173,
		172,
		-1,
		143,
		140,
		130,
		108,
		93,
		92,
		80,
		75,
		66,
		48,
		62,
		52,
		48,
		46,
		32,
		36,
		56,
		68,
		213,
		203,
		-1,
		185,
		190,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		145,
		158,
		-1,
		114,
		110,
		92,
		88,
		77,
		84,
		59,
		44,
		41,
		44,
		39,
		25,
		29,
		45,
		-1,
		-1,
		198,
		202,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		128,
		125,
		113,
		100,
		85,
		86,
		83,
		79,
		58,
		43,
		45,
		35,
		42,
		20,
		31,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		124,
		103,
		94,
		83,
		81,
		91,
		64,
		59,
		43,
		41,
		30,
		23,
		14,
		22,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		137,
		120,
		101,
		90,
		82,
		71,
		65,
		71,
		63,
		39,
		44,
		24,
		29,
		10,
		16,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		111,
		95,
		90,
		87,
		75,
		70,
		70,
		68,
		49,
		44,
		56,
		34,
		34,
		0,
		25,
		28,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		97,
		93,
		79,
		83,
		85,
		80,
		70,
		62,
		63,
		45,
		58,
		-1,
		8,
		2,
		30,
		33,
		23,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		91,
		86,
		85,
		84,
		81,
		70,
		78,
		70,
		50,
		60,
		64,
		23,
		21,
		14,
		19,
		18,
		32,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		113,
		97,
		96,
		93,
		84,
		92,
		65,
		58,
		53,
		54,
		59,
		32,
		27,
		33,
		25,
		28,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		103,
		120,
		121,
		99,
		93,
		91,
		82,
		70,
		59,
		62,
		54,
		45,
		42,
		28,
		28,
		30,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		117,
		115,
		110,
		101,
		107,
		102,
		79,
		74,
		64,
		53,
		53,
		48,
		50,
		36,
		34,
		29,
		44,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		118,
		102,
		107,
		-1,
		99,
		-1,
		72,
		69,
		60,
		45,
		42,
		46,
		37,
		50,
		35,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		134,
		114,
		108,
		107,
		94,
		86,
		80,
		58,
		51,
		48,
		45,
		58,
		70,
		49,
		37,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		141,
		129,
		119,
		109,
		112,
		102,
		77,
		70,
		56,
		58,
		56,
		54,
		59,
		50,
		42,
		52,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		130,
		-1,
		-1,
		113,
		104,
		94,
		73,
		60,
		80,
		83,
		69,
		53,
		66,
		56,
		44,
		53,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		126,
		115,
		110,
		114,
		112,
		-1,
		86,
		84,
		64,
		78,
		85,
		71,
		66,
		60,
		61,
		61,
		55,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		103,
		96,
		100,
		-1,
		88,
		80,
		66,
		83,
		84,
		81,
		72,
		64,
		69,
		58,
		71,
		67,
		57,
		193,
		-1,
		176,
		-1,
		-1,
		-1,
		156,
		171,
		142,
		119,
		92,
		87,
		80,
		74,
		74,
		90,
		92,
		103,
		71,
		67,
		68,
		64,
		63,
		71,
		72,
		-1,
		-1,
		176,
		190,
		182,
		164,
		168,
		169,
		-1,
		-1,
		96,
		87,
		78,
		81,
		84,
		87,
		77,
		74,
		79,
		81,
		72,
		73,
		90,
		75,
		-1,
		-1,
		-1,
		196,
		-1,
		208,
		-1,
		-1,
		183,
		167,
		114,
		96,
		92,
		90,
		83,
		92,
		87,
		82,
		92,
		99,
		91,
		71,
		85,
		101,
		83,
		104,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		129,
		126,
		-1,
		96,
		121,
		93,
		100,
		92,
		100,
		100,
		95,
		75,
		82,
		98,
		95,
		92,
		96,
		91,
		100,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		118,
		102,
		106,
		99,
		94,
		104,
		84,
		71,
		75,
		79,
		85,
		90,
		95,
		101,
		98,
		106,
		-1,
		203,
		267,
		260,
		228,
		236,
		267,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		109,
		106,
		114,
		109,
		100,
		85,
		91,
		78,
		77,
		95,
		99,
		108,
		112,
		101,
		114,
		118,
		-1,
		217,
		243,
		222,
		225,
		249,
		263,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		117,
		167,
		123,
		118,
		108,
		106,
		97,
		88,
		95,
		86,
		86,
		89,
		104,
		109,
		101,
		111,
		111,
		112,
		-1,
		212,
		223,
		216,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		135,
		139,
		131,
		134,
		122,
		109,
		101,
		93,
		109,
		84,
		94,
		90,
		91,
		100,
		111,
		123,
		118,
		119,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		177,
		216,
		221,
		-1,
		202,
		-1,
		-1,
		-1,
		149,
		144,
		136,
		142,
		121,
		121,
		95,
		99,
		89,
		96,
		106,
		108,
		100,
		104,
		117,
		128,
		127,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		192,
		183,
		210,
		228,
		217,
		212,
		199,
		-1,
		-1,
		172,
		154,
		-1,
		-1,
		128,
		116,
		99,
		100,
		96,
		99,
		114,
		117,
		107,
		105,
		99,
		131,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		211,
		206,
		210,
		226,
		251,
		-1,
		188,
		-1,
		-1,
		173,
		-1,
		-1,
		158,
		121,
		110,
		101,
		107,
		104,
		115,
		125,
		113,
		114,
		104,
		114,
		127,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		204,
		184,
		-1,
		-1,
		156,
		154,
		143,
		-1,
		133,
		106,
		111,
		131,
		133,
		122,
		116,
		110,
		117,
		116,
		124,
		132,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		194,
		190,
		-1,
		-1,
		151,
		144,
		132,
		120,
		110,
		120,
		124,
		128,
		120,
		113,
		108,
		119,
		111,
		115,
		132,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		211,
		197,
		190,
		178,
		176,
		-1,
		185,
		169,
		150,
		-1,
		120,
		133,
		164,
		132,
		137,
		132,
		114,
		125,
		114,
		117,
		131,
		126,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		201,
		203,
		-1,
		202,
		191,
		176,
		168,
		-1,
		-1,
		157,
		153,
		-1,
		-1,
		121,
		146,
		135,
		143,
		138,
		118,
		124,
		127,
		116,
		120,
		132,
		-1,
		-1,
		200,
		201,
		206,
		-1,
		186,
		-1,
		204,
		-1,
		171,
		177,
		165,
		-1,
		-1,
		-1,
		159,
		122,
		143,
		153,
		147,
		145,
		136,
		122,
		129,
		127,
		123,
		134,
		-1,
		-1,
		-1,
		204,
		178,
		211,
		202,
		185,
		165,
		157,
		176,
		-1,
		146,
		-1,
		121,
		123,
		149,
		152,
		158,
		152,
		125,
		140,
		130,
		121,
		130,
		210,
		-1,
		180,
		213,
		177,
		171,
		147,
		151,
		167,
		-1,
		143,
		125,
		-1,
		153,
		143,
		174,
		159,
		140,
		127,
		134,
		134,
		127,
		-1,
		-1,
		-1,
		182,
		181,
		173,
		167,
		167,
		152,
		143,
		-1,
		155,
		137,
		116,
		133,
		133,
		124,
		132,
		164,
		160,
		147,
		147,
		139,
		-1,
		283,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		176,
		171,
		144,
		132,
		138,
		134,
		120,
		126,
		128,
		136,
		134,
		131,
		143,
		139,
		159,
		140,
		175,
		-1,
		278,
		-1,
		212,
		-1,
		-1,
		194,
		174,
		166,
		155,
		144,
		142,
		133,
		124,
		146,
		162,
		146,
		144,
		147,
		148,
		-1,
		267,
		266,
		-1,
		213,
		205,
		191,
		-1,
		184,
		-1,
		190,
		151,
		-1,
		153,
		133,
		-1,
		155,
		151,
		-1,
		-1,
		254,
		229,
		-1,
		-1,
		-1,
		214,
		194,
		185,
		169,
		-1,
		144,
		144,
		-1,
		-1,
		-1,
		239,
		238,
		-1,
		207,
		210,
		-1,
		200,
		191,
		199,
		146,
		150,
		-1,
		-1,
		-1,
		248,
		229,
		223,
		222,
		220,
		215,
		212,
		198,
		182,
		160,
		149,
		170,
		-1,
		-1,
		-1,
		220,
		212,
		205,
		-1,
		-1,
		207,
		190,
		171,
		169,
		-1,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		197,
		-1,
		-1,
		203,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		231,
		-1,
		-1,
		-1,
		193,
		189,
		190,
		-1,
		-1,
		-1,
		-1,
		253,
		254,
		277,
		241,
		-1,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		256,
		254,
		-1,
		-1,
		-1,
		213,
		197,
		-1,
		183,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		218,
		-1,
		218,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		231,
		223,
		231,
		-1,
		203,
		205,
		-1,
		253,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		208,
		215,
		237,
		240,
		276,
		-1,
		227
	],
	[
		-1,
		201,
		190,
		201,
		209,
		182,
		189,
		-1,
		208,
		212,
		178,
		172,
		211,
		180,
		186,
		197,
		-1,
		-1,
		-1,
		201,
		200,
		168,
		166,
		175,
		180,
		187,
		-1,
		186,
		-1,
		222,
		201,
		212,
		217,
		161,
		158,
		178,
		197,
		179,
		171,
		237,
		191,
		162,
		156,
		174,
		164,
		173,
		165,
		-1,
		162,
		152,
		174,
		153,
		164,
		156,
		-1,
		-1,
		156,
		157,
		163,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		146,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		147,
		-1,
		149,
		166,
		166,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		139,
		-1,
		159,
		160,
		155,
		161,
		156,
		132,
		119,
		119,
		129,
		122,
		141,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		142,
		159,
		151,
		141,
		153,
		149,
		122,
		119,
		117,
		114,
		130,
		127,
		137,
		-1,
		-1,
		252,
		221,
		250,
		208,
		189,
		-1,
		155,
		135,
		141,
		145,
		139,
		132,
		146,
		138,
		-1,
		108,
		107,
		134,
		120,
		131,
		212,
		-1,
		-1,
		210,
		202,
		185,
		188,
		165,
		161,
		150,
		149,
		141,
		127,
		123,
		129,
		132,
		132,
		138,
		102,
		112,
		116,
		113,
		116,
		-1,
		-1,
		130,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		171,
		177,
		163,
		184,
		160,
		151,
		143,
		137,
		125,
		127,
		124,
		137,
		124,
		99,
		124,
		128,
		108,
		106,
		101,
		-1,
		129,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		200,
		-1,
		172,
		160,
		161,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		121,
		103,
		101,
		131,
		105,
		105,
		95,
		100,
		105,
		99,
		108,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		208,
		209,
		184,
		157,
		160,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		115,
		95,
		110,
		100,
		99,
		84,
		84,
		92,
		96,
		102,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		209,
		201,
		186,
		186,
		-1,
		156,
		153,
		143,
		121,
		106,
		123,
		115,
		113,
		108,
		90,
		104,
		94,
		90,
		88,
		74,
		78,
		98,
		110,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		228,
		192,
		-1,
		187,
		-1,
		158,
		171,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		101,
		86,
		83,
		86,
		81,
		67,
		71,
		87,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		185,
		174,
		173,
		-1,
		164,
		141,
		138,
		126,
		113,
		98,
		99,
		107,
		120,
		99,
		85,
		87,
		77,
		84,
		62,
		58,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		203,
		196,
		184,
		149,
		149,
		143,
		-1,
		137,
		116,
		107,
		96,
		94,
		107,
		101,
		101,
		85,
		83,
		72,
		65,
		56,
		49,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		182,
		168,
		173,
		148,
		141,
		135,
		150,
		133,
		114,
		103,
		95,
		84,
		97,
		105,
		103,
		81,
		86,
		66,
		71,
		44,
		43,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		173,
		186,
		-1,
		140,
		-1,
		129,
		124,
		108,
		103,
		100,
		89,
		88,
		100,
		102,
		91,
		86,
		94,
		76,
		76,
		42,
		0,
		3,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		110,
		106,
		93,
		97,
		98,
		102,
		90,
		96,
		97,
		79,
		100,
		-1,
		46,
		39,
		13,
		19,
		35,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		105,
		100,
		99,
		98,
		95,
		84,
		97,
		90,
		84,
		78,
		91,
		61,
		49,
		30,
		26,
		32,
		40,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		127,
		111,
		110,
		107,
		98,
		106,
		79,
		72,
		83,
		68,
		86,
		58,
		53,
		43,
		35,
		40,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		149,
		165,
		-1,
		158,
		137,
		152,
		130,
		126,
		117,
		134,
		135,
		113,
		107,
		105,
		96,
		84,
		73,
		76,
		68,
		65,
		57,
		41,
		38,
		40,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		120,
		152,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		131,
		129,
		124,
		115,
		121,
		116,
		93,
		88,
		78,
		67,
		67,
		62,
		63,
		49,
		47,
		43,
		58,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		132,
		116,
		121,
		-1,
		113,
		-1,
		86,
		83,
		74,
		59,
		56,
		59,
		50,
		63,
		49,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		189,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		148,
		128,
		122,
		121,
		108,
		100,
		94,
		72,
		65,
		62,
		59,
		72,
		83,
		63,
		51,
		-1,
		-1,
		-1,
		186,
		172,
		176,
		136,
		155,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		146,
		155,
		143,
		133,
		123,
		126,
		116,
		91,
		84,
		70,
		72,
		70,
		68,
		72,
		64,
		56,
		66,
		-1,
		-1,
		169,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		168,
		184,
		176,
		147,
		144,
		-1,
		-1,
		127,
		118,
		108,
		87,
		74,
		94,
		97,
		82,
		66,
		80,
		70,
		58,
		67,
		-1,
		172,
		159,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		140,
		129,
		124,
		128,
		126,
		-1,
		100,
		98,
		78,
		92,
		99,
		84,
		79,
		73,
		75,
		75,
		69,
		-1,
		-1,
		184,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		152,
		146,
		117,
		110,
		114,
		-1,
		102,
		94,
		80,
		97,
		97,
		94,
		85,
		77,
		82,
		72,
		85,
		81,
		71,
		207,
		-1,
		190,
		-1,
		-1,
		-1,
		170,
		185,
		156,
		133,
		106,
		101,
		94,
		88,
		88,
		104,
		105,
		116,
		84,
		80,
		81,
		78,
		77,
		85,
		86,
		-1,
		-1,
		190,
		204,
		196,
		178,
		182,
		183,
		-1,
		-1,
		110,
		101,
		92,
		95,
		98,
		101,
		90,
		87,
		92,
		95,
		85,
		87,
		104,
		89,
		-1,
		-1,
		-1,
		210,
		-1,
		222,
		-1,
		-1,
		197,
		181,
		128,
		110,
		106,
		104,
		97,
		106,
		101,
		95,
		105,
		113,
		105,
		85,
		99,
		115,
		97,
		118,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		199,
		191,
		186,
		192,
		194,
		185,
		143,
		140,
		-1,
		110,
		135,
		107,
		114,
		106,
		113,
		113,
		109,
		89,
		96,
		112,
		109,
		106,
		110,
		105,
		114,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		192,
		188,
		178,
		168,
		171,
		-1,
		-1,
		159,
		156,
		132,
		116,
		120,
		113,
		108,
		118,
		98,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		112,
		120,
		-1,
		217,
		281,
		274,
		242,
		250,
		281,
		-1,
		182,
		174,
		185,
		160,
		162,
		-1,
		-1,
		132,
		129,
		134,
		123,
		120,
		128,
		123,
		114,
		99,
		105,
		92,
		91,
		109,
		113,
		122,
		126,
		115,
		128,
		132,
		-1,
		231,
		257,
		236,
		239,
		263,
		277,
		-1,
		179,
		-1,
		-1,
		191,
		163,
		147,
		137,
		131,
		181,
		137,
		132,
		122,
		120,
		111,
		102,
		109,
		100,
		100,
		103,
		118,
		123,
		115,
		125,
		125,
		126,
		-1,
		226,
		237,
		230,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		207,
		-1,
		174,
		-1,
		149,
		153,
		145,
		148,
		136,
		123,
		115,
		107,
		123,
		98,
		108,
		104,
		105,
		114,
		125,
		137,
		132,
		133,
		251,
		207,
		210,
		221,
		232,
		247,
		251,
		-1,
		191,
		230,
		235,
		-1,
		216,
		-1,
		-1,
		-1,
		163,
		158,
		150,
		156,
		135,
		135,
		109,
		113,
		103,
		110,
		120,
		122,
		114,
		118,
		131,
		142,
		141,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		206,
		197,
		224,
		242,
		231,
		226,
		213,
		-1,
		-1,
		186,
		168,
		-1,
		-1,
		142,
		130,
		113,
		114,
		110,
		113,
		128,
		131,
		121,
		119,
		113,
		145,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		225,
		220,
		224,
		240,
		265,
		-1,
		202,
		-1,
		-1,
		187,
		-1,
		-1,
		172,
		135,
		124,
		115,
		121,
		118,
		129,
		139,
		127,
		128,
		118,
		128,
		141,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		218,
		198,
		-1,
		-1,
		170,
		168,
		157,
		-1,
		147,
		120,
		125,
		145,
		147,
		136,
		130,
		124,
		131,
		130,
		138,
		146,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		208,
		204,
		-1,
		-1,
		165,
		158,
		146,
		134,
		124,
		134,
		138,
		142,
		134,
		127,
		122,
		133,
		125,
		129,
		146,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		225,
		211,
		204,
		192,
		190,
		-1,
		199,
		183,
		164,
		-1,
		134,
		147,
		178,
		146,
		151,
		146,
		128,
		139,
		128,
		131,
		145,
		140,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		215,
		217,
		-1,
		216,
		205,
		190,
		182,
		-1,
		-1,
		171,
		167,
		-1,
		-1,
		135,
		160,
		149,
		157,
		152,
		132,
		138,
		141,
		130,
		134,
		146,
		-1,
		-1,
		214,
		215,
		220,
		-1,
		200,
		-1,
		218,
		-1,
		185,
		191,
		179,
		-1,
		-1,
		-1,
		173,
		136,
		157,
		167,
		161,
		159,
		150,
		136,
		143,
		141,
		137,
		148,
		-1,
		-1,
		-1,
		218,
		192,
		225,
		216,
		199,
		179,
		171,
		190,
		-1,
		160,
		-1,
		135,
		137,
		163,
		166,
		172,
		166,
		139,
		154,
		144,
		135,
		144,
		224,
		-1,
		194,
		227,
		191,
		185,
		161,
		165,
		181,
		-1,
		157,
		139,
		-1,
		167,
		157,
		188,
		173,
		154,
		141,
		148,
		148,
		141,
		-1,
		-1,
		-1,
		196,
		195,
		187,
		181,
		181,
		166,
		157,
		-1,
		169,
		151,
		130,
		147,
		147,
		138,
		146,
		178,
		174,
		161,
		161,
		153,
		-1,
		297,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		190,
		185,
		158,
		146,
		152,
		148,
		134,
		140,
		142,
		150,
		148,
		145,
		157,
		153,
		173,
		154,
		189,
		-1,
		292,
		-1,
		226,
		-1,
		-1,
		208,
		188,
		180,
		169,
		158,
		156,
		147,
		138,
		160,
		176,
		160,
		158,
		161,
		162,
		-1,
		281,
		280,
		-1,
		227,
		219,
		205,
		-1,
		198,
		-1,
		204,
		165,
		-1,
		167,
		147,
		-1,
		169,
		165,
		-1,
		-1,
		268,
		243,
		-1,
		-1,
		-1,
		228,
		208,
		199,
		183,
		-1,
		158,
		158,
		-1,
		-1,
		-1,
		253,
		252,
		-1,
		221,
		224,
		-1,
		214,
		205,
		213,
		160,
		164,
		-1,
		-1,
		-1,
		262,
		243,
		237,
		236,
		234,
		229,
		226,
		212,
		196,
		174,
		163,
		184,
		-1,
		-1,
		-1,
		234,
		226,
		219,
		-1,
		-1,
		221,
		204,
		185,
		183,
		-1,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		211,
		-1,
		-1,
		217,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		245,
		-1,
		-1,
		-1,
		207,
		203,
		204,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		291,
		255,
		-1,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		270,
		268,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		197,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		232,
		-1,
		232,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		245,
		237,
		245,
		-1,
		217,
		219,
		-1,
		267,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		222,
		229,
		251,
		254,
		290,
		-1,
		241
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		144,
		-1,
		146,
		163,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		136,
		-1,
		156,
		157,
		152,
		158,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		150,
		146,
		119,
		116,
		114,
		111,
		127,
		124,
		134,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		135,
		-1,
		105,
		104,
		131,
		117,
		128,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		99,
		109,
		113,
		110,
		113,
		-1,
		-1,
		127,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		121,
		96,
		121,
		125,
		105,
		103,
		98,
		-1,
		126,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		118,
		100,
		98,
		128,
		102,
		102,
		92,
		97,
		102,
		96,
		105,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		112,
		92,
		107,
		97,
		96,
		81,
		81,
		89,
		93,
		99,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		105,
		87,
		101,
		91,
		87,
		85,
		71,
		75,
		95,
		107,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		98,
		83,
		80,
		83,
		78,
		64,
		68,
		84,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		117,
		96,
		82,
		84,
		74,
		81,
		59,
		55,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		98,
		98,
		82,
		80,
		69,
		62,
		53,
		46,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		94,
		102,
		100,
		78,
		83,
		63,
		68,
		41,
		40,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		86,
		85,
		97,
		99,
		88,
		83,
		91,
		73,
		73,
		39,
		20,
		0,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		90,
		94,
		95,
		99,
		87,
		93,
		94,
		76,
		97,
		-1,
		43,
		36,
		10,
		16,
		32,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		102,
		97,
		96,
		95,
		92,
		81,
		94,
		87,
		81,
		75,
		88,
		58,
		46,
		27,
		23,
		29,
		37,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		124,
		108,
		107,
		104,
		95,
		103,
		76,
		69,
		80,
		65,
		83,
		55,
		50,
		40,
		32,
		37,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		114,
		131,
		132,
		110,
		104,
		102,
		93,
		81,
		70,
		73,
		65,
		62,
		54,
		38,
		35,
		37,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		128,
		126,
		121,
		112,
		118,
		113,
		90,
		85,
		75,
		64,
		64,
		59,
		60,
		46,
		44,
		40,
		55,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		129,
		113,
		118,
		-1,
		110,
		-1,
		83,
		80,
		71,
		56,
		53,
		56,
		47,
		60,
		46,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		145,
		125,
		119,
		118,
		105,
		97,
		91,
		69,
		62,
		59,
		56,
		69,
		80,
		60,
		48,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		152,
		140,
		130,
		120,
		123,
		113,
		88,
		81,
		67,
		69,
		67,
		65,
		69,
		61,
		53,
		63,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		141,
		-1,
		-1,
		124,
		115,
		105,
		84,
		71,
		91,
		94,
		79,
		63,
		77,
		67,
		55,
		64,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		192,
		137,
		126,
		121,
		125,
		123,
		-1,
		97,
		95,
		75,
		89,
		96,
		81,
		76,
		70,
		72,
		72,
		66,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		149,
		143,
		114,
		107,
		111,
		-1,
		99,
		91,
		77,
		94,
		94,
		91,
		82,
		74,
		79,
		69,
		82,
		78,
		68,
		204,
		-1,
		187,
		-1,
		-1,
		-1,
		167,
		182,
		153,
		130,
		103,
		98,
		91,
		85,
		85,
		101,
		102,
		113,
		81,
		77,
		78,
		75,
		74,
		82,
		83,
		-1,
		-1,
		187,
		201,
		193,
		175,
		179,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		95,
		98,
		87,
		84,
		89,
		92,
		82,
		84,
		101,
		86,
		-1,
		-1,
		-1,
		207,
		-1,
		219,
		-1,
		-1,
		194,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		92,
		102,
		110,
		102,
		82,
		96,
		112,
		94,
		115,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		196,
		188,
		183,
		189,
		191,
		182,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		103,
		110,
		110,
		106,
		86,
		93,
		109,
		106,
		103,
		107,
		102,
		111,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		189,
		185,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		113,
		117,
		110,
		105,
		115,
		95,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		109,
		117,
		-1,
		214,
		278,
		271,
		239,
		247,
		278,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		120,
		117,
		125,
		120,
		111,
		96,
		102,
		89,
		88,
		106,
		110,
		119,
		123,
		112,
		125,
		129,
		-1,
		228,
		254,
		233,
		236,
		260,
		274,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		128,
		178,
		134,
		129,
		119,
		117,
		108,
		99,
		106,
		97,
		97,
		100,
		115,
		120,
		112,
		122,
		122,
		123,
		-1,
		223,
		234,
		227,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		146,
		150,
		142,
		145,
		133,
		120,
		112,
		104,
		120,
		95,
		105,
		101,
		102,
		111,
		122,
		134,
		129,
		130,
		248,
		204,
		207,
		218,
		229,
		244,
		248,
		-1,
		188,
		227,
		232,
		-1,
		213,
		-1,
		-1,
		-1,
		160,
		155,
		147,
		153,
		132,
		132,
		106,
		110,
		100,
		107,
		117,
		119,
		111,
		115,
		128,
		139,
		138,
		244,
		235,
		248,
		193,
		193,
		214,
		223,
		244,
		203,
		194,
		221,
		239,
		228,
		223,
		210,
		-1,
		-1,
		183,
		165,
		-1,
		-1,
		139,
		127,
		110,
		111,
		107,
		110,
		125,
		128,
		118,
		116,
		110,
		142,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		211,
		-1,
		-1,
		206,
		222,
		217,
		221,
		237,
		262,
		-1,
		199,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		115,
		126,
		136,
		124,
		125,
		115,
		125,
		138,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		215,
		195,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		117,
		122,
		142,
		144,
		133,
		127,
		121,
		128,
		127,
		135,
		143,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		205,
		201,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		135,
		139,
		131,
		124,
		119,
		130,
		122,
		126,
		143,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		222,
		208,
		201,
		189,
		187,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		125,
		136,
		125,
		128,
		142,
		137,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		212,
		214,
		-1,
		213,
		202,
		187,
		179,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		129,
		135,
		138,
		127,
		131,
		143,
		-1,
		-1,
		211,
		212,
		217,
		-1,
		197,
		-1,
		215,
		-1,
		182,
		188,
		176,
		-1,
		-1,
		-1,
		170,
		133,
		154,
		164,
		158,
		156,
		147,
		133,
		140,
		138,
		134,
		145,
		-1,
		-1,
		-1,
		215,
		189,
		222,
		213,
		196,
		176,
		168,
		187,
		-1,
		157,
		-1,
		132,
		134,
		160,
		163,
		169,
		163,
		136,
		151,
		141,
		132,
		141,
		221,
		-1,
		191,
		224,
		188,
		182,
		158,
		162,
		178,
		-1,
		154,
		136,
		-1,
		164,
		154,
		185,
		170,
		151,
		138,
		145,
		145,
		138,
		-1,
		-1,
		-1,
		193,
		192,
		184,
		178,
		178,
		163,
		154,
		-1,
		166,
		148,
		127,
		144,
		144,
		135,
		143,
		175,
		171,
		158,
		158,
		150,
		-1,
		294,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		187,
		182,
		155,
		143,
		149,
		145,
		131,
		137,
		139,
		147,
		145,
		142,
		154,
		150,
		170,
		151,
		186,
		-1,
		289,
		-1,
		223,
		-1,
		-1,
		205,
		185,
		177,
		166,
		155,
		153,
		144,
		135,
		157,
		173,
		157,
		155,
		158,
		159,
		-1,
		278,
		277,
		-1,
		224,
		216,
		202,
		-1,
		195,
		-1,
		201,
		162,
		-1,
		164,
		144,
		-1,
		166,
		162,
		-1,
		-1,
		265,
		240,
		-1,
		-1,
		-1,
		225,
		205,
		196,
		180,
		-1,
		155,
		155,
		-1,
		-1,
		-1,
		250,
		249,
		-1,
		218,
		221,
		-1,
		211,
		202,
		210,
		157,
		161,
		-1,
		-1,
		-1,
		259,
		240,
		234,
		233,
		231,
		226,
		223,
		209,
		193,
		171,
		160,
		181,
		-1,
		-1,
		-1,
		231,
		223,
		216,
		-1,
		-1,
		218,
		201,
		182,
		180,
		-1,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		208,
		-1,
		-1,
		214,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		242,
		-1,
		-1,
		-1,
		204,
		200,
		201,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		288,
		252,
		-1,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		267,
		265,
		-1,
		-1,
		-1,
		224,
		208,
		-1,
		194,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		229,
		-1,
		229,
		204,
		211,
		-1,
		-1,
		-1,
		-1,
		242,
		234,
		242,
		-1,
		214,
		216,
		-1,
		264,
		-1,
		-1,
		257,
		248,
		-1,
		-1,
		219,
		226,
		248,
		251,
		287,
		-1,
		238
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		187,
		189,
		155,
		149,
		188,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		178,
		177,
		147,
		145,
		154,
		159,
		166,
		-1,
		189,
		-1,
		199,
		178,
		189,
		194,
		140,
		137,
		157,
		176,
		182,
		174,
		214,
		170,
		141,
		135,
		153,
		158,
		176,
		168,
		-1,
		141,
		131,
		153,
		157,
		169,
		152,
		-1,
		-1,
		135,
		136,
		142,
		154,
		159,
		164,
		-1,
		190,
		209,
		-1,
		-1,
		125,
		138,
		134,
		137,
		145,
		161,
		182,
		199,
		204,
		-1,
		-1,
		126,
		130,
		143,
		144,
		142,
		169,
		188,
		199,
		213,
		212,
		-1,
		114,
		132,
		141,
		150,
		156,
		145,
		149,
		167,
		198,
		204,
		207,
		-1,
		106,
		108,
		137,
		143,
		155,
		161,
		148,
		154,
		173,
		186,
		205,
		196,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		111,
		137,
		136,
		132,
		150,
		172,
		151,
		157,
		161,
		178,
		194,
		195,
		205,
		-1,
		-1,
		159,
		128,
		163,
		120,
		105,
		-1,
		99,
		118,
		124,
		128,
		133,
		141,
		169,
		167,
		-1,
		172,
		171,
		202,
		188,
		199,
		119,
		-1,
		-1,
		117,
		109,
		94,
		97,
		94,
		94,
		124,
		123,
		128,
		130,
		132,
		144,
		159,
		159,
		169,
		166,
		176,
		180,
		195,
		206,
		-1,
		-1,
		273,
		-1,
		-1,
		116,
		99,
		-1,
		82,
		89,
		89,
		106,
		96,
		117,
		132,
		136,
		144,
		147,
		135,
		154,
		151,
		175,
		171,
		163,
		188,
		192,
		198,
		216,
		214,
		-1,
		272,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		75,
		78,
		84,
		108,
		118,
		-1,
		139,
		137,
		161,
		155,
		160,
		156,
		141,
		159,
		157,
		172,
		174,
		170,
		172,
		209,
		195,
		217,
		214,
		243,
		248,
		242,
		251,
		-1,
		124,
		120,
		116,
		123,
		72,
		-1,
		-1,
		112,
		-1,
		126,
		139,
		151,
		141,
		144,
		156,
		164,
		163,
		147,
		165,
		160,
		163,
		175,
		178,
		187,
		190,
		189,
		207,
		222,
		235,
		239,
		245,
		-1,
		174,
		-1,
		116,
		100,
		102,
		74,
		95,
		-1,
		132,
		127,
		147,
		153,
		153,
		-1,
		169,
		166,
		179,
		163,
		148,
		165,
		167,
		169,
		174,
		179,
		193,
		184,
		202,
		209,
		217,
		221,
		241,
		253,
		134,
		124,
		-1,
		106,
		111,
		70,
		77,
		92,
		170,
		154,
		-1,
		164,
		-1,
		171,
		184,
		-1,
		169,
		165,
		154,
		162,
		157,
		172,
		178,
		175,
		172,
		190,
		193,
		210,
		214,
		230,
		-1,
		-1,
		119,
		123,
		96,
		63,
		74,
		98,
		135,
		163,
		171,
		170,
		-1,
		164,
		190,
		187,
		177,
		164,
		154,
		155,
		163,
		176,
		155,
		174,
		177,
		199,
		227,
		205,
		217,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		73,
		60,
		76,
		118,
		200,
		193,
		181,
		149,
		149,
		143,
		-1,
		184,
		167,
		163,
		152,
		150,
		163,
		158,
		174,
		178,
		177,
		196,
		208,
		199,
		219,
		-1,
		-1,
		-1,
		85,
		74,
		75,
		63,
		97,
		107,
		182,
		168,
		173,
		148,
		141,
		135,
		187,
		184,
		151,
		159,
		151,
		140,
		154,
		162,
		166,
		175,
		184,
		190,
		214,
		214,
		220,
		-1,
		-1,
		37,
		27,
		21,
		38,
		64,
		88,
		95,
		127,
		173,
		170,
		-1,
		140,
		-1,
		129,
		137,
		136,
		142,
		154,
		140,
		145,
		156,
		168,
		181,
		177,
		184,
		219,
		219,
		204,
		224,
		227,
		-1,
		-1,
		-1,
		0,
		136,
		111,
		88,
		69,
		105,
		-1,
		140,
		141,
		-1,
		134,
		128,
		134,
		133,
		140,
		137,
		137,
		151,
		159,
		155,
		171,
		177,
		169,
		205,
		-1,
		212,
		206,
		214,
		204,
		192,
		-1,
		-1,
		-1,
		134,
		113,
		106,
		126,
		76,
		128,
		-1,
		-1,
		125,
		118,
		-1,
		121,
		121,
		128,
		137,
		142,
		147,
		155,
		150,
		163,
		168,
		174,
		179,
		197,
		201,
		205,
		194,
		190,
		187,
		201,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		79,
		96,
		-1,
		133,
		125,
		116,
		110,
		116,
		134,
		132,
		152,
		144,
		158,
		158,
		164,
		172,
		157,
		160,
		176,
		174,
		192,
		200,
		192,
		186,
		185,
		197,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		111,
		-1,
		82,
		106,
		122,
		-1,
		150,
		129,
		152,
		130,
		144,
		140,
		178,
		179,
		157,
		162,
		170,
		180,
		182,
		171,
		182,
		174,
		196,
		196,
		180,
		181,
		190,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		85,
		98,
		109,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		154,
		152,
		168,
		159,
		165,
		181,
		184,
		186,
		176,
		165,
		171,
		168,
		190,
		176,
		174,
		193,
		209,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		176,
		160,
		165,
		-1,
		211,
		-1,
		184,
		186,
		180,
		165,
		162,
		173,
		171,
		182,
		199,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		142,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		192,
		172,
		166,
		165,
		206,
		206,
		192,
		178,
		171,
		168,
		165,
		178,
		198,
		189,
		201,
		-1,
		-1,
		-1,
		143,
		123,
		129,
		87,
		108,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		146,
		209,
		197,
		187,
		177,
		211,
		212,
		197,
		190,
		176,
		178,
		176,
		174,
		179,
		200,
		201,
		214,
		-1,
		-1,
		120,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		168,
		184,
		176,
		147,
		198,
		-1,
		-1,
		189,
		187,
		197,
		193,
		180,
		200,
		203,
		189,
		173,
		188,
		200,
		208,
		213,
		-1,
		123,
		110,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		201,
		167,
		179,
		200,
		225,
		192,
		-1,
		197,
		198,
		184,
		198,
		205,
		191,
		186,
		180,
		183,
		201,
		218,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		158,
		172,
		193,
		199,
		211,
		-1,
		206,
		200,
		186,
		203,
		204,
		201,
		192,
		184,
		189,
		186,
		199,
		213,
		217,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		176,
		191,
		253,
		230,
		203,
		207,
		200,
		194,
		194,
		210,
		212,
		223,
		191,
		187,
		188,
		192,
		191,
		208,
		218,
		-1,
		-1,
		143,
		160,
		195,
		184,
		188,
		280,
		-1,
		-1,
		216,
		207,
		198,
		201,
		204,
		207,
		197,
		194,
		199,
		204,
		192,
		201,
		219,
		223,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		203,
		287,
		234,
		216,
		212,
		210,
		203,
		212,
		207,
		202,
		212,
		221,
		213,
		194,
		205,
		228,
		217,
		255,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		192,
		167,
		182,
		228,
		223,
		224,
		249,
		246,
		-1,
		216,
		241,
		213,
		220,
		212,
		220,
		220,
		217,
		195,
		202,
		218,
		217,
		212,
		247,
		239,
		245,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		198,
		184,
		214,
		204,
		210,
		-1,
		-1,
		257,
		254,
		238,
		222,
		226,
		219,
		214,
		224,
		204,
		191,
		195,
		199,
		205,
		210,
		215,
		221,
		236,
		251,
		-1,
		168,
		249,
		242,
		225,
		233,
		264,
		-1,
		201,
		210,
		191,
		196,
		204,
		-1,
		-1,
		230,
		226,
		231,
		229,
		226,
		234,
		229,
		220,
		205,
		211,
		198,
		197,
		215,
		219,
		228,
		235,
		225,
		238,
		242,
		-1,
		182,
		225,
		219,
		222,
		246,
		260,
		-1,
		214,
		-1,
		-1,
		199,
		217,
		225,
		221,
		225,
		278,
		243,
		238,
		228,
		226,
		217,
		208,
		215,
		206,
		206,
		209,
		224,
		229,
		221,
		235,
		235,
		236,
		-1,
		217,
		205,
		213,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		215,
		-1,
		251,
		-1,
		244,
		248,
		251,
		254,
		242,
		229,
		221,
		213,
		229,
		204,
		214,
		210,
		211,
		220,
		231,
		243,
		242,
		243,
		291,
		246,
		213,
		204,
		251,
		266,
		270,
		-1,
		227,
		266,
		253,
		-1,
		224,
		-1,
		-1,
		-1,
		258,
		264,
		256,
		262,
		241,
		241,
		215,
		219,
		209,
		216,
		226,
		228,
		220,
		224,
		237,
		248,
		251,
		287,
		285,
		290,
		235,
		218,
		236,
		245,
		266,
		242,
		233,
		260,
		260,
		249,
		244,
		231,
		-1,
		-1,
		281,
		274,
		-1,
		-1,
		248,
		236,
		219,
		220,
		216,
		219,
		234,
		237,
		227,
		225,
		219,
		251,
		-1,
		287,
		286,
		275,
		272,
		248,
		239,
		226,
		237,
		-1,
		-1,
		245,
		261,
		274,
		278,
		291,
		316,
		-1,
		234,
		-1,
		-1,
		293,
		-1,
		-1,
		278,
		241,
		230,
		221,
		227,
		224,
		235,
		245,
		233,
		234,
		224,
		234,
		247,
		271,
		268,
		256,
		254,
		277,
		234,
		230,
		-1,
		260,
		248,
		254,
		261,
		278,
		305,
		-1,
		-1,
		250,
		241,
		-1,
		-1,
		276,
		274,
		263,
		-1,
		253,
		226,
		231,
		251,
		253,
		242,
		236,
		230,
		237,
		236,
		244,
		252,
		280,
		294,
		283,
		279,
		278,
		286,
		235,
		252,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		-1,
		285,
		260,
		-1,
		-1,
		271,
		264,
		252,
		240,
		230,
		240,
		244,
		248,
		240,
		233,
		228,
		239,
		231,
		235,
		252,
		-1,
		314,
		-1,
		266,
		259,
		274,
		289,
		297,
		-1,
		-1,
		-1,
		302,
		288,
		281,
		269,
		267,
		-1,
		305,
		289,
		270,
		-1,
		240,
		253,
		284,
		252,
		257,
		252,
		234,
		245,
		234,
		237,
		251,
		246,
		-1,
		-1,
		272,
		275,
		-1,
		-1,
		297,
		316,
		-1,
		293,
		282,
		267,
		259,
		-1,
		-1,
		277,
		273,
		-1,
		-1,
		241,
		266,
		255,
		263,
		258,
		238,
		244,
		247,
		236,
		240,
		252,
		-1,
		-1,
		279,
		280,
		285,
		-1,
		306,
		-1,
		317,
		-1,
		262,
		278,
		280,
		-1,
		-1,
		-1,
		279,
		242,
		263,
		273,
		267,
		265,
		256,
		242,
		249,
		247,
		243,
		254,
		-1,
		-1,
		-1,
		324,
		298,
		324,
		315,
		298,
		278,
		270,
		295,
		-1,
		266,
		-1,
		241,
		243,
		269,
		272,
		278,
		272,
		245,
		260,
		250,
		241,
		250,
		330,
		-1,
		300,
		333,
		297,
		284,
		267,
		271,
		287,
		-1,
		263,
		245,
		-1,
		273,
		263,
		294,
		279,
		260,
		247,
		254,
		254,
		247,
		-1,
		-1,
		-1,
		302,
		301,
		293,
		287,
		287,
		272,
		263,
		-1,
		275,
		257,
		236,
		253,
		253,
		244,
		252,
		284,
		280,
		267,
		267,
		259,
		-1,
		386,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		296,
		291,
		264,
		252,
		258,
		254,
		240,
		246,
		248,
		256,
		254,
		251,
		263,
		259,
		279,
		260,
		295,
		-1,
		393,
		-1,
		332,
		-1,
		-1,
		314,
		294,
		286,
		275,
		264,
		262,
		253,
		244,
		266,
		282,
		266,
		264,
		267,
		268,
		-1,
		387,
		386,
		-1,
		333,
		325,
		311,
		-1,
		304,
		-1,
		310,
		271,
		-1,
		273,
		253,
		-1,
		275,
		271,
		-1,
		-1,
		374,
		349,
		-1,
		-1,
		-1,
		334,
		314,
		305,
		289,
		-1,
		264,
		264,
		-1,
		-1,
		-1,
		359,
		358,
		-1,
		327,
		330,
		-1,
		320,
		311,
		319,
		266,
		270,
		-1,
		-1,
		-1,
		368,
		349,
		343,
		342,
		340,
		335,
		332,
		318,
		302,
		280,
		269,
		290,
		-1,
		-1,
		-1,
		340,
		332,
		325,
		-1,
		-1,
		327,
		310,
		291,
		289,
		-1,
		-1,
		-1,
		362,
		343,
		-1,
		-1,
		317,
		-1,
		-1,
		323,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		379,
		351,
		-1,
		-1,
		-1,
		313,
		309,
		310,
		-1,
		-1,
		-1,
		-1,
		373,
		374,
		397,
		361,
		-1,
		-1,
		-1,
		305,
		299,
		-1,
		-1,
		376,
		374,
		-1,
		-1,
		-1,
		333,
		317,
		-1,
		303,
		-1,
		-1,
		-1,
		324,
		-1,
		-1,
		336,
		-1,
		-1,
		-1,
		338,
		-1,
		338,
		313,
		320,
		-1,
		-1,
		-1,
		-1,
		351,
		343,
		351,
		-1,
		323,
		325,
		-1,
		373,
		-1,
		-1,
		366,
		357,
		-1,
		-1,
		328,
		335,
		357,
		360,
		396,
		-1,
		347
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		207,
		209,
		175,
		169,
		208,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		198,
		197,
		167,
		165,
		174,
		179,
		186,
		-1,
		209,
		-1,
		219,
		198,
		209,
		214,
		160,
		157,
		177,
		196,
		202,
		194,
		234,
		190,
		161,
		155,
		173,
		178,
		196,
		188,
		-1,
		161,
		151,
		173,
		177,
		189,
		172,
		-1,
		-1,
		155,
		156,
		162,
		174,
		179,
		184,
		-1,
		210,
		218,
		-1,
		-1,
		145,
		158,
		154,
		157,
		165,
		181,
		202,
		218,
		213,
		-1,
		-1,
		146,
		150,
		163,
		164,
		162,
		189,
		208,
		208,
		222,
		221,
		-1,
		134,
		152,
		161,
		170,
		176,
		165,
		169,
		187,
		207,
		213,
		216,
		-1,
		126,
		128,
		157,
		163,
		175,
		181,
		168,
		174,
		193,
		195,
		214,
		205,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		123,
		131,
		157,
		156,
		152,
		170,
		192,
		171,
		177,
		181,
		187,
		203,
		204,
		214,
		-1,
		-1,
		179,
		148,
		183,
		140,
		125,
		-1,
		119,
		138,
		144,
		148,
		153,
		161,
		189,
		187,
		-1,
		181,
		180,
		211,
		197,
		208,
		139,
		-1,
		-1,
		137,
		129,
		114,
		117,
		114,
		114,
		144,
		143,
		148,
		150,
		152,
		164,
		179,
		179,
		189,
		175,
		185,
		189,
		200,
		215,
		-1,
		-1,
		270,
		-1,
		-1,
		136,
		119,
		-1,
		102,
		109,
		109,
		126,
		116,
		137,
		152,
		156,
		164,
		167,
		155,
		174,
		171,
		190,
		178,
		172,
		197,
		201,
		195,
		216,
		211,
		-1,
		269,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		95,
		98,
		104,
		128,
		138,
		-1,
		159,
		157,
		181,
		175,
		180,
		176,
		161,
		179,
		169,
		176,
		175,
		179,
		181,
		214,
		192,
		214,
		211,
		240,
		245,
		239,
		248,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		132,
		-1,
		146,
		159,
		171,
		161,
		164,
		176,
		184,
		178,
		167,
		178,
		167,
		164,
		172,
		181,
		192,
		187,
		186,
		204,
		219,
		232,
		236,
		242,
		-1,
		194,
		-1,
		136,
		120,
		122,
		94,
		115,
		-1,
		152,
		147,
		167,
		173,
		173,
		-1,
		186,
		186,
		196,
		174,
		159,
		176,
		168,
		166,
		171,
		176,
		190,
		181,
		199,
		206,
		214,
		218,
		238,
		250,
		154,
		144,
		-1,
		126,
		131,
		90,
		98,
		117,
		190,
		174,
		-1,
		184,
		-1,
		176,
		201,
		-1,
		180,
		176,
		158,
		159,
		154,
		169,
		175,
		172,
		169,
		187,
		190,
		207,
		211,
		227,
		-1,
		-1,
		139,
		143,
		132,
		83,
		102,
		126,
		163,
		182,
		171,
		170,
		-1,
		161,
		191,
		188,
		174,
		161,
		151,
		152,
		160,
		173,
		152,
		171,
		174,
		196,
		224,
		202,
		214,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		109,
		80,
		104,
		146,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		181,
		164,
		160,
		149,
		147,
		160,
		155,
		171,
		175,
		174,
		193,
		205,
		196,
		216,
		-1,
		-1,
		-1,
		139,
		128,
		129,
		75,
		90,
		128,
		179,
		165,
		170,
		145,
		138,
		132,
		184,
		181,
		148,
		156,
		148,
		137,
		151,
		159,
		163,
		172,
		181,
		187,
		211,
		211,
		217,
		-1,
		-1,
		146,
		136,
		120,
		122,
		119,
		81,
		91,
		123,
		170,
		167,
		-1,
		137,
		-1,
		126,
		134,
		133,
		139,
		151,
		137,
		142,
		153,
		165,
		178,
		174,
		181,
		216,
		216,
		201,
		221,
		224,
		-1,
		-1,
		-1,
		139,
		0,
		28,
		51,
		70,
		101,
		-1,
		137,
		138,
		-1,
		131,
		125,
		131,
		130,
		137,
		134,
		134,
		148,
		156,
		152,
		168,
		174,
		166,
		202,
		-1,
		209,
		203,
		211,
		201,
		189,
		-1,
		-1,
		-1,
		48,
		31,
		45,
		65,
		71,
		123,
		-1,
		-1,
		122,
		115,
		-1,
		118,
		118,
		125,
		134,
		139,
		144,
		152,
		147,
		160,
		165,
		171,
		176,
		194,
		198,
		202,
		191,
		187,
		184,
		198,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		91,
		-1,
		128,
		120,
		113,
		107,
		113,
		131,
		129,
		149,
		141,
		155,
		155,
		161,
		169,
		154,
		157,
		173,
		171,
		189,
		197,
		189,
		183,
		182,
		194,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		106,
		-1,
		77,
		101,
		117,
		-1,
		147,
		126,
		149,
		127,
		141,
		137,
		175,
		176,
		154,
		159,
		167,
		177,
		179,
		168,
		179,
		171,
		193,
		193,
		177,
		178,
		187,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		80,
		95,
		104,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		151,
		149,
		165,
		156,
		162,
		178,
		181,
		183,
		173,
		162,
		168,
		165,
		187,
		173,
		171,
		190,
		206,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		121,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		173,
		157,
		162,
		-1,
		208,
		-1,
		181,
		183,
		177,
		162,
		159,
		170,
		168,
		179,
		196,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		189,
		169,
		163,
		162,
		203,
		203,
		189,
		175,
		168,
		165,
		162,
		175,
		195,
		186,
		198,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		206,
		194,
		184,
		174,
		208,
		209,
		194,
		187,
		173,
		175,
		173,
		171,
		176,
		197,
		198,
		211,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		195,
		-1,
		-1,
		186,
		184,
		194,
		190,
		177,
		197,
		200,
		186,
		170,
		185,
		197,
		205,
		210,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		176,
		197,
		222,
		189,
		-1,
		194,
		195,
		181,
		195,
		202,
		188,
		183,
		177,
		180,
		198,
		215,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		155,
		169,
		190,
		196,
		208,
		-1,
		203,
		197,
		183,
		200,
		201,
		198,
		189,
		181,
		186,
		183,
		196,
		210,
		214,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		173,
		188,
		250,
		227,
		200,
		204,
		197,
		191,
		191,
		207,
		209,
		220,
		188,
		184,
		185,
		189,
		188,
		205,
		215,
		-1,
		-1,
		144,
		161,
		196,
		181,
		185,
		277,
		-1,
		-1,
		213,
		204,
		195,
		198,
		201,
		204,
		194,
		191,
		196,
		201,
		189,
		198,
		216,
		220,
		-1,
		-1,
		-1,
		164,
		-1,
		179,
		-1,
		-1,
		200,
		284,
		231,
		213,
		209,
		207,
		200,
		209,
		204,
		199,
		209,
		218,
		210,
		191,
		202,
		225,
		214,
		252,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		193,
		168,
		183,
		229,
		220,
		225,
		246,
		243,
		-1,
		213,
		238,
		210,
		217,
		209,
		217,
		217,
		214,
		192,
		199,
		215,
		214,
		209,
		244,
		236,
		242,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		199,
		185,
		215,
		205,
		211,
		-1,
		-1,
		258,
		255,
		235,
		219,
		223,
		216,
		211,
		221,
		201,
		188,
		192,
		196,
		202,
		207,
		212,
		218,
		233,
		248,
		-1,
		171,
		252,
		245,
		228,
		236,
		267,
		-1,
		202,
		211,
		192,
		197,
		205,
		-1,
		-1,
		231,
		227,
		232,
		226,
		223,
		231,
		226,
		217,
		202,
		208,
		195,
		194,
		212,
		216,
		225,
		232,
		222,
		235,
		239,
		-1,
		185,
		228,
		222,
		225,
		249,
		263,
		-1,
		215,
		-1,
		-1,
		200,
		218,
		226,
		222,
		226,
		279,
		240,
		235,
		225,
		223,
		214,
		205,
		212,
		203,
		203,
		206,
		221,
		226,
		218,
		232,
		232,
		233,
		-1,
		220,
		208,
		216,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		216,
		-1,
		252,
		-1,
		245,
		249,
		248,
		251,
		239,
		226,
		218,
		210,
		226,
		201,
		211,
		207,
		208,
		217,
		228,
		240,
		239,
		240,
		294,
		249,
		216,
		207,
		254,
		269,
		273,
		-1,
		228,
		267,
		254,
		-1,
		225,
		-1,
		-1,
		-1,
		259,
		261,
		253,
		259,
		238,
		238,
		212,
		216,
		206,
		213,
		223,
		225,
		217,
		221,
		234,
		245,
		248,
		290,
		288,
		293,
		238,
		221,
		239,
		248,
		269,
		243,
		234,
		261,
		261,
		250,
		245,
		232,
		-1,
		-1,
		282,
		271,
		-1,
		-1,
		245,
		233,
		216,
		217,
		213,
		216,
		231,
		234,
		224,
		222,
		216,
		248,
		-1,
		290,
		289,
		278,
		275,
		251,
		242,
		229,
		240,
		-1,
		-1,
		246,
		262,
		275,
		279,
		292,
		317,
		-1,
		235,
		-1,
		-1,
		290,
		-1,
		-1,
		275,
		238,
		227,
		218,
		224,
		221,
		232,
		242,
		230,
		231,
		221,
		231,
		244,
		274,
		271,
		259,
		257,
		280,
		237,
		233,
		-1,
		261,
		249,
		255,
		262,
		279,
		306,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		273,
		271,
		260,
		-1,
		250,
		223,
		228,
		248,
		250,
		239,
		233,
		227,
		234,
		233,
		241,
		249,
		283,
		297,
		286,
		282,
		281,
		289,
		238,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		-1,
		286,
		261,
		-1,
		-1,
		268,
		261,
		249,
		237,
		227,
		237,
		241,
		245,
		237,
		230,
		225,
		236,
		228,
		232,
		249,
		-1,
		317,
		-1,
		269,
		262,
		277,
		292,
		300,
		-1,
		-1,
		-1,
		303,
		289,
		282,
		270,
		268,
		-1,
		302,
		286,
		267,
		-1,
		237,
		250,
		281,
		249,
		254,
		249,
		231,
		242,
		231,
		234,
		248,
		243,
		-1,
		-1,
		275,
		278,
		-1,
		-1,
		300,
		319,
		-1,
		294,
		283,
		268,
		260,
		-1,
		-1,
		274,
		270,
		-1,
		-1,
		238,
		263,
		252,
		260,
		255,
		235,
		241,
		244,
		233,
		237,
		249,
		-1,
		-1,
		282,
		283,
		288,
		-1,
		303,
		-1,
		318,
		-1,
		263,
		279,
		281,
		-1,
		-1,
		-1,
		276,
		239,
		260,
		270,
		264,
		262,
		253,
		239,
		246,
		244,
		240,
		251,
		-1,
		-1,
		-1,
		321,
		295,
		325,
		316,
		299,
		279,
		271,
		293,
		-1,
		263,
		-1,
		238,
		240,
		266,
		269,
		275,
		269,
		242,
		257,
		247,
		238,
		247,
		327,
		-1,
		297,
		330,
		294,
		285,
		264,
		268,
		284,
		-1,
		260,
		242,
		-1,
		270,
		260,
		291,
		276,
		257,
		244,
		251,
		251,
		244,
		-1,
		-1,
		-1,
		299,
		298,
		290,
		284,
		284,
		269,
		260,
		-1,
		272,
		254,
		233,
		250,
		250,
		241,
		249,
		281,
		277,
		264,
		264,
		256,
		-1,
		389,
		-1,
		-1,
		322,
		-1,
		-1,
		-1,
		293,
		288,
		261,
		249,
		255,
		251,
		237,
		243,
		245,
		253,
		251,
		248,
		260,
		256,
		276,
		257,
		292,
		-1,
		395,
		-1,
		329,
		-1,
		-1,
		311,
		291,
		283,
		272,
		261,
		259,
		250,
		241,
		263,
		279,
		263,
		261,
		264,
		265,
		-1,
		384,
		383,
		-1,
		330,
		322,
		308,
		-1,
		301,
		-1,
		307,
		268,
		-1,
		270,
		250,
		-1,
		272,
		268,
		-1,
		-1,
		371,
		346,
		-1,
		-1,
		-1,
		331,
		311,
		302,
		286,
		-1,
		261,
		261,
		-1,
		-1,
		-1,
		356,
		355,
		-1,
		324,
		327,
		-1,
		317,
		308,
		316,
		263,
		267,
		-1,
		-1,
		-1,
		365,
		346,
		340,
		339,
		337,
		332,
		329,
		315,
		299,
		277,
		266,
		287,
		-1,
		-1,
		-1,
		337,
		329,
		322,
		-1,
		-1,
		324,
		307,
		288,
		286,
		-1,
		-1,
		-1,
		359,
		340,
		-1,
		-1,
		314,
		-1,
		-1,
		320,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		376,
		348,
		-1,
		-1,
		-1,
		310,
		306,
		307,
		-1,
		-1,
		-1,
		-1,
		370,
		371,
		394,
		358,
		-1,
		-1,
		-1,
		302,
		296,
		-1,
		-1,
		373,
		371,
		-1,
		-1,
		-1,
		330,
		314,
		-1,
		300,
		-1,
		-1,
		-1,
		321,
		-1,
		-1,
		333,
		-1,
		-1,
		-1,
		335,
		-1,
		335,
		310,
		317,
		-1,
		-1,
		-1,
		-1,
		348,
		340,
		348,
		-1,
		320,
		322,
		-1,
		370,
		-1,
		-1,
		363,
		354,
		-1,
		-1,
		325,
		332,
		354,
		357,
		393,
		-1,
		344
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		179,
		181,
		147,
		141,
		180,
		151,
		157,
		168,
		-1,
		-1,
		-1,
		170,
		169,
		139,
		137,
		146,
		151,
		158,
		-1,
		181,
		-1,
		191,
		170,
		181,
		186,
		132,
		129,
		149,
		168,
		174,
		166,
		206,
		162,
		133,
		127,
		145,
		150,
		168,
		160,
		-1,
		133,
		123,
		145,
		149,
		161,
		144,
		-1,
		-1,
		127,
		128,
		134,
		146,
		151,
		156,
		-1,
		182,
		190,
		-1,
		-1,
		117,
		130,
		126,
		129,
		137,
		153,
		174,
		190,
		185,
		-1,
		-1,
		118,
		122,
		135,
		136,
		134,
		161,
		180,
		180,
		194,
		193,
		-1,
		106,
		124,
		133,
		142,
		148,
		137,
		141,
		159,
		179,
		185,
		188,
		-1,
		98,
		100,
		129,
		135,
		147,
		153,
		140,
		146,
		165,
		167,
		186,
		177,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		95,
		103,
		129,
		128,
		124,
		142,
		164,
		143,
		149,
		153,
		159,
		175,
		176,
		186,
		-1,
		-1,
		151,
		120,
		155,
		112,
		97,
		-1,
		91,
		110,
		116,
		120,
		125,
		133,
		161,
		159,
		-1,
		153,
		152,
		183,
		169,
		180,
		111,
		-1,
		-1,
		109,
		101,
		86,
		89,
		86,
		86,
		116,
		115,
		120,
		122,
		124,
		136,
		151,
		151,
		161,
		147,
		157,
		161,
		172,
		187,
		-1,
		-1,
		242,
		-1,
		-1,
		108,
		91,
		-1,
		74,
		81,
		81,
		98,
		88,
		109,
		124,
		128,
		136,
		139,
		127,
		146,
		143,
		162,
		150,
		144,
		169,
		173,
		167,
		188,
		183,
		-1,
		241,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		67,
		70,
		76,
		100,
		110,
		-1,
		131,
		129,
		153,
		147,
		152,
		148,
		133,
		151,
		141,
		148,
		147,
		151,
		153,
		186,
		164,
		186,
		183,
		212,
		217,
		211,
		220,
		-1,
		116,
		112,
		108,
		115,
		64,
		-1,
		-1,
		104,
		-1,
		118,
		131,
		143,
		133,
		136,
		148,
		156,
		150,
		139,
		150,
		139,
		136,
		144,
		153,
		164,
		159,
		158,
		176,
		191,
		204,
		208,
		214,
		-1,
		166,
		-1,
		108,
		92,
		94,
		66,
		87,
		-1,
		124,
		119,
		139,
		145,
		145,
		-1,
		158,
		158,
		168,
		146,
		131,
		148,
		140,
		138,
		143,
		148,
		162,
		153,
		171,
		178,
		186,
		190,
		210,
		222,
		126,
		116,
		-1,
		98,
		103,
		62,
		70,
		89,
		162,
		146,
		-1,
		156,
		-1,
		148,
		173,
		-1,
		152,
		148,
		130,
		131,
		126,
		141,
		147,
		144,
		141,
		159,
		162,
		179,
		183,
		199,
		-1,
		-1,
		111,
		115,
		104,
		55,
		74,
		98,
		135,
		154,
		143,
		142,
		-1,
		133,
		163,
		160,
		146,
		133,
		123,
		124,
		132,
		145,
		124,
		143,
		146,
		168,
		196,
		174,
		186,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		81,
		52,
		76,
		118,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		153,
		136,
		132,
		121,
		119,
		132,
		127,
		143,
		147,
		146,
		165,
		177,
		168,
		188,
		-1,
		-1,
		-1,
		111,
		100,
		101,
		47,
		62,
		100,
		151,
		137,
		142,
		117,
		110,
		104,
		156,
		153,
		120,
		128,
		120,
		109,
		123,
		131,
		135,
		144,
		153,
		159,
		183,
		183,
		189,
		-1,
		-1,
		118,
		108,
		92,
		94,
		91,
		53,
		63,
		95,
		142,
		139,
		-1,
		109,
		-1,
		98,
		106,
		105,
		111,
		123,
		109,
		114,
		125,
		137,
		150,
		146,
		153,
		188,
		188,
		173,
		193,
		196,
		-1,
		-1,
		-1,
		111,
		25,
		0,
		23,
		42,
		73,
		-1,
		109,
		110,
		-1,
		103,
		97,
		103,
		102,
		109,
		106,
		106,
		120,
		128,
		124,
		140,
		146,
		138,
		174,
		-1,
		181,
		175,
		183,
		173,
		161,
		-1,
		-1,
		-1,
		35,
		18,
		17,
		37,
		43,
		95,
		-1,
		-1,
		94,
		87,
		-1,
		90,
		90,
		97,
		106,
		111,
		116,
		124,
		119,
		132,
		137,
		143,
		148,
		166,
		170,
		174,
		163,
		159,
		156,
		170,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		46,
		63,
		-1,
		100,
		92,
		85,
		79,
		85,
		103,
		101,
		121,
		113,
		127,
		127,
		133,
		141,
		126,
		129,
		145,
		143,
		161,
		169,
		161,
		155,
		154,
		166,
		-1,
		151,
		137,
		108,
		-1,
		-1,
		78,
		-1,
		49,
		73,
		89,
		-1,
		119,
		98,
		121,
		99,
		113,
		109,
		147,
		148,
		126,
		131,
		139,
		149,
		151,
		140,
		151,
		143,
		165,
		165,
		149,
		150,
		159,
		-1,
		157,
		144,
		102,
		98,
		87,
		107,
		52,
		67,
		76,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		123,
		121,
		137,
		128,
		134,
		150,
		153,
		155,
		145,
		134,
		140,
		137,
		159,
		145,
		143,
		162,
		178,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		73,
		60,
		54,
		-1,
		93,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		145,
		129,
		134,
		-1,
		180,
		-1,
		153,
		155,
		149,
		134,
		131,
		142,
		140,
		151,
		168,
		-1,
		107,
		92,
		85,
		75,
		89,
		60,
		-1,
		115,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		161,
		141,
		135,
		134,
		175,
		175,
		161,
		147,
		140,
		137,
		134,
		147,
		167,
		158,
		170,
		-1,
		-1,
		-1,
		112,
		98,
		102,
		62,
		81,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		178,
		166,
		156,
		146,
		180,
		181,
		166,
		159,
		145,
		147,
		145,
		143,
		148,
		169,
		170,
		183,
		-1,
		-1,
		95,
		100,
		88,
		74,
		93,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		167,
		-1,
		-1,
		158,
		156,
		166,
		162,
		149,
		169,
		172,
		158,
		142,
		157,
		169,
		177,
		182,
		-1,
		98,
		85,
		-1,
		-1,
		96,
		90,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		148,
		169,
		194,
		161,
		-1,
		166,
		167,
		153,
		167,
		174,
		160,
		155,
		149,
		152,
		170,
		187,
		-1,
		-1,
		110,
		-1,
		105,
		-1,
		-1,
		-1,
		-1,
		127,
		141,
		162,
		168,
		180,
		-1,
		175,
		169,
		155,
		172,
		173,
		170,
		161,
		153,
		158,
		155,
		168,
		182,
		186,
		133,
		-1,
		116,
		-1,
		-1,
		-1,
		145,
		160,
		222,
		199,
		172,
		176,
		169,
		163,
		163,
		179,
		181,
		192,
		160,
		156,
		157,
		161,
		160,
		177,
		187,
		-1,
		-1,
		116,
		133,
		168,
		153,
		157,
		249,
		-1,
		-1,
		185,
		176,
		167,
		170,
		173,
		176,
		166,
		163,
		168,
		173,
		161,
		170,
		188,
		192,
		-1,
		-1,
		-1,
		136,
		-1,
		151,
		-1,
		-1,
		172,
		256,
		203,
		185,
		181,
		179,
		172,
		181,
		176,
		171,
		181,
		190,
		182,
		163,
		174,
		197,
		186,
		224,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		165,
		140,
		155,
		201,
		192,
		197,
		218,
		215,
		-1,
		185,
		210,
		182,
		189,
		181,
		189,
		189,
		186,
		164,
		171,
		187,
		186,
		181,
		216,
		208,
		214,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		171,
		157,
		187,
		177,
		183,
		-1,
		-1,
		230,
		227,
		207,
		191,
		195,
		188,
		183,
		193,
		173,
		160,
		164,
		168,
		174,
		179,
		184,
		190,
		205,
		220,
		-1,
		143,
		224,
		217,
		200,
		208,
		239,
		-1,
		174,
		183,
		164,
		169,
		177,
		-1,
		-1,
		203,
		199,
		204,
		198,
		195,
		203,
		198,
		189,
		174,
		180,
		167,
		166,
		184,
		188,
		197,
		204,
		194,
		207,
		211,
		-1,
		157,
		200,
		194,
		197,
		221,
		235,
		-1,
		187,
		-1,
		-1,
		172,
		190,
		198,
		194,
		198,
		251,
		212,
		207,
		197,
		195,
		186,
		177,
		184,
		175,
		175,
		178,
		193,
		198,
		190,
		204,
		204,
		205,
		-1,
		192,
		180,
		188,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		188,
		-1,
		224,
		-1,
		217,
		221,
		220,
		223,
		211,
		198,
		190,
		182,
		198,
		173,
		183,
		179,
		180,
		189,
		200,
		212,
		211,
		212,
		266,
		221,
		188,
		179,
		226,
		241,
		245,
		-1,
		200,
		239,
		226,
		-1,
		197,
		-1,
		-1,
		-1,
		231,
		233,
		225,
		231,
		210,
		210,
		184,
		188,
		178,
		185,
		195,
		197,
		189,
		193,
		206,
		217,
		220,
		262,
		260,
		265,
		210,
		193,
		211,
		220,
		241,
		215,
		206,
		233,
		233,
		222,
		217,
		204,
		-1,
		-1,
		254,
		243,
		-1,
		-1,
		217,
		205,
		188,
		189,
		185,
		188,
		203,
		206,
		196,
		194,
		188,
		220,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		201,
		212,
		-1,
		-1,
		218,
		234,
		247,
		251,
		264,
		289,
		-1,
		207,
		-1,
		-1,
		262,
		-1,
		-1,
		247,
		210,
		199,
		190,
		196,
		193,
		204,
		214,
		202,
		203,
		193,
		203,
		216,
		246,
		243,
		231,
		229,
		252,
		209,
		205,
		-1,
		233,
		221,
		227,
		234,
		251,
		278,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		245,
		243,
		232,
		-1,
		222,
		195,
		200,
		220,
		222,
		211,
		205,
		199,
		206,
		205,
		213,
		221,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		-1,
		258,
		233,
		-1,
		-1,
		240,
		233,
		221,
		209,
		199,
		209,
		213,
		217,
		209,
		202,
		197,
		208,
		200,
		204,
		221,
		-1,
		289,
		-1,
		241,
		234,
		249,
		264,
		272,
		-1,
		-1,
		-1,
		275,
		261,
		254,
		242,
		240,
		-1,
		274,
		258,
		239,
		-1,
		209,
		222,
		253,
		221,
		226,
		221,
		203,
		214,
		203,
		206,
		220,
		215,
		-1,
		-1,
		247,
		250,
		-1,
		-1,
		272,
		291,
		-1,
		266,
		255,
		240,
		232,
		-1,
		-1,
		246,
		242,
		-1,
		-1,
		210,
		235,
		224,
		232,
		227,
		207,
		213,
		216,
		205,
		209,
		221,
		-1,
		-1,
		254,
		255,
		260,
		-1,
		275,
		-1,
		290,
		-1,
		235,
		251,
		253,
		-1,
		-1,
		-1,
		248,
		211,
		232,
		242,
		236,
		234,
		225,
		211,
		218,
		216,
		212,
		223,
		-1,
		-1,
		-1,
		293,
		267,
		297,
		288,
		271,
		251,
		243,
		265,
		-1,
		235,
		-1,
		210,
		212,
		238,
		241,
		247,
		241,
		214,
		229,
		219,
		210,
		219,
		299,
		-1,
		269,
		302,
		266,
		257,
		236,
		240,
		256,
		-1,
		232,
		214,
		-1,
		242,
		232,
		263,
		248,
		229,
		216,
		223,
		223,
		216,
		-1,
		-1,
		-1,
		271,
		270,
		262,
		256,
		256,
		241,
		232,
		-1,
		244,
		226,
		205,
		222,
		222,
		213,
		221,
		253,
		249,
		236,
		236,
		228,
		-1,
		361,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		265,
		260,
		233,
		221,
		227,
		223,
		209,
		215,
		217,
		225,
		223,
		220,
		232,
		228,
		248,
		229,
		264,
		-1,
		367,
		-1,
		301,
		-1,
		-1,
		283,
		263,
		255,
		244,
		233,
		231,
		222,
		213,
		235,
		251,
		235,
		233,
		236,
		237,
		-1,
		356,
		355,
		-1,
		302,
		294,
		280,
		-1,
		273,
		-1,
		279,
		240,
		-1,
		242,
		222,
		-1,
		244,
		240,
		-1,
		-1,
		343,
		318,
		-1,
		-1,
		-1,
		303,
		283,
		274,
		258,
		-1,
		233,
		233,
		-1,
		-1,
		-1,
		328,
		327,
		-1,
		296,
		299,
		-1,
		289,
		280,
		288,
		235,
		239,
		-1,
		-1,
		-1,
		337,
		318,
		312,
		311,
		309,
		304,
		301,
		287,
		271,
		249,
		238,
		259,
		-1,
		-1,
		-1,
		309,
		301,
		294,
		-1,
		-1,
		296,
		279,
		260,
		258,
		-1,
		-1,
		-1,
		331,
		312,
		-1,
		-1,
		286,
		-1,
		-1,
		292,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		348,
		320,
		-1,
		-1,
		-1,
		282,
		278,
		279,
		-1,
		-1,
		-1,
		-1,
		342,
		343,
		366,
		330,
		-1,
		-1,
		-1,
		274,
		268,
		-1,
		-1,
		345,
		343,
		-1,
		-1,
		-1,
		302,
		286,
		-1,
		272,
		-1,
		-1,
		-1,
		293,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		307,
		-1,
		307,
		282,
		289,
		-1,
		-1,
		-1,
		-1,
		320,
		312,
		320,
		-1,
		292,
		294,
		-1,
		342,
		-1,
		-1,
		335,
		326,
		-1,
		-1,
		297,
		304,
		326,
		329,
		365,
		-1,
		316
	],
	[
		-1,
		147,
		136,
		147,
		155,
		128,
		135,
		-1,
		156,
		158,
		124,
		118,
		157,
		128,
		134,
		145,
		-1,
		-1,
		-1,
		147,
		146,
		116,
		114,
		123,
		128,
		135,
		-1,
		158,
		-1,
		168,
		147,
		158,
		163,
		109,
		106,
		126,
		145,
		151,
		143,
		183,
		139,
		110,
		104,
		122,
		127,
		145,
		137,
		-1,
		110,
		100,
		122,
		126,
		138,
		121,
		-1,
		-1,
		104,
		105,
		111,
		123,
		128,
		133,
		-1,
		159,
		167,
		-1,
		-1,
		94,
		107,
		103,
		106,
		114,
		130,
		151,
		167,
		162,
		-1,
		-1,
		95,
		99,
		112,
		113,
		111,
		138,
		157,
		157,
		171,
		170,
		-1,
		83,
		101,
		110,
		119,
		125,
		114,
		118,
		136,
		156,
		162,
		165,
		-1,
		75,
		77,
		106,
		112,
		124,
		130,
		117,
		123,
		142,
		144,
		163,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		72,
		80,
		106,
		105,
		101,
		119,
		141,
		120,
		126,
		130,
		136,
		152,
		153,
		163,
		-1,
		-1,
		128,
		97,
		132,
		89,
		74,
		-1,
		68,
		87,
		93,
		97,
		102,
		110,
		138,
		136,
		-1,
		130,
		129,
		160,
		146,
		157,
		88,
		-1,
		-1,
		86,
		78,
		63,
		66,
		63,
		63,
		93,
		92,
		97,
		99,
		101,
		113,
		128,
		128,
		138,
		124,
		134,
		138,
		149,
		164,
		-1,
		-1,
		219,
		-1,
		-1,
		85,
		68,
		-1,
		51,
		58,
		58,
		75,
		65,
		86,
		101,
		105,
		113,
		116,
		104,
		123,
		120,
		139,
		127,
		121,
		146,
		150,
		144,
		165,
		160,
		-1,
		218,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		44,
		47,
		53,
		77,
		87,
		-1,
		108,
		106,
		130,
		124,
		129,
		125,
		110,
		128,
		118,
		125,
		124,
		128,
		130,
		163,
		141,
		163,
		160,
		189,
		194,
		188,
		197,
		-1,
		93,
		89,
		85,
		92,
		41,
		-1,
		-1,
		81,
		-1,
		95,
		108,
		120,
		110,
		113,
		125,
		133,
		127,
		116,
		127,
		116,
		113,
		121,
		130,
		141,
		136,
		135,
		153,
		168,
		181,
		185,
		191,
		-1,
		143,
		-1,
		85,
		69,
		71,
		43,
		64,
		-1,
		101,
		96,
		116,
		122,
		122,
		-1,
		135,
		135,
		145,
		123,
		108,
		125,
		117,
		115,
		120,
		125,
		139,
		130,
		148,
		155,
		163,
		167,
		187,
		199,
		103,
		93,
		-1,
		75,
		80,
		39,
		47,
		66,
		139,
		123,
		-1,
		133,
		-1,
		125,
		150,
		-1,
		129,
		125,
		107,
		108,
		103,
		118,
		124,
		121,
		118,
		136,
		139,
		156,
		160,
		176,
		-1,
		-1,
		88,
		92,
		81,
		32,
		51,
		75,
		112,
		131,
		120,
		119,
		-1,
		110,
		140,
		137,
		123,
		110,
		100,
		101,
		109,
		122,
		101,
		120,
		123,
		145,
		173,
		151,
		163,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		58,
		29,
		53,
		95,
		149,
		142,
		130,
		95,
		95,
		89,
		-1,
		130,
		113,
		109,
		98,
		96,
		109,
		104,
		120,
		124,
		123,
		142,
		154,
		145,
		165,
		-1,
		-1,
		-1,
		88,
		77,
		78,
		24,
		39,
		77,
		128,
		114,
		119,
		94,
		87,
		81,
		133,
		130,
		97,
		105,
		97,
		86,
		100,
		108,
		112,
		121,
		130,
		136,
		160,
		160,
		166,
		-1,
		-1,
		95,
		85,
		69,
		71,
		68,
		30,
		40,
		72,
		119,
		116,
		-1,
		86,
		-1,
		75,
		83,
		82,
		88,
		100,
		86,
		91,
		102,
		114,
		127,
		123,
		130,
		165,
		165,
		150,
		170,
		173,
		-1,
		-1,
		-1,
		88,
		48,
		23,
		0,
		19,
		50,
		-1,
		86,
		87,
		-1,
		80,
		74,
		80,
		79,
		86,
		83,
		83,
		97,
		105,
		101,
		117,
		123,
		115,
		151,
		-1,
		158,
		152,
		160,
		150,
		138,
		-1,
		-1,
		-1,
		46,
		25,
		18,
		38,
		20,
		72,
		-1,
		-1,
		71,
		64,
		-1,
		67,
		67,
		74,
		83,
		88,
		93,
		101,
		96,
		109,
		114,
		120,
		125,
		143,
		147,
		151,
		140,
		136,
		133,
		147,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		23,
		40,
		-1,
		77,
		69,
		62,
		56,
		62,
		80,
		78,
		98,
		90,
		104,
		104,
		110,
		118,
		103,
		106,
		122,
		120,
		138,
		146,
		138,
		132,
		131,
		143,
		-1,
		128,
		114,
		85,
		-1,
		-1,
		55,
		-1,
		26,
		50,
		66,
		-1,
		96,
		75,
		98,
		76,
		90,
		86,
		124,
		125,
		103,
		108,
		116,
		126,
		128,
		117,
		128,
		120,
		142,
		142,
		126,
		127,
		136,
		-1,
		134,
		121,
		79,
		75,
		64,
		84,
		29,
		44,
		53,
		-1,
		-1,
		140,
		-1,
		74,
		91,
		100,
		98,
		114,
		105,
		111,
		127,
		130,
		132,
		122,
		111,
		117,
		114,
		136,
		122,
		120,
		139,
		155,
		-1,
		-1,
		-1,
		101,
		-1,
		-1,
		50,
		37,
		31,
		-1,
		70,
		-1,
		118,
		108,
		92,
		77,
		110,
		-1,
		122,
		106,
		111,
		-1,
		157,
		-1,
		130,
		132,
		126,
		111,
		108,
		119,
		117,
		128,
		145,
		-1,
		84,
		69,
		62,
		52,
		66,
		37,
		-1,
		92,
		-1,
		-1,
		105,
		99,
		99,
		83,
		86,
		138,
		118,
		112,
		111,
		152,
		152,
		138,
		124,
		117,
		114,
		111,
		124,
		144,
		135,
		147,
		-1,
		-1,
		-1,
		89,
		75,
		79,
		39,
		58,
		-1,
		-1,
		167,
		122,
		108,
		-1,
		92,
		155,
		143,
		133,
		123,
		157,
		158,
		143,
		136,
		122,
		124,
		122,
		120,
		125,
		146,
		147,
		160,
		-1,
		-1,
		72,
		77,
		65,
		51,
		70,
		-1,
		-1,
		-1,
		114,
		130,
		122,
		93,
		144,
		-1,
		-1,
		135,
		133,
		143,
		139,
		126,
		146,
		149,
		135,
		119,
		134,
		146,
		154,
		159,
		-1,
		75,
		62,
		-1,
		-1,
		73,
		67,
		-1,
		-1,
		-1,
		-1,
		147,
		113,
		125,
		146,
		171,
		138,
		-1,
		143,
		144,
		130,
		144,
		151,
		137,
		132,
		126,
		129,
		147,
		164,
		-1,
		-1,
		87,
		-1,
		82,
		-1,
		-1,
		-1,
		-1,
		104,
		118,
		139,
		145,
		157,
		-1,
		152,
		146,
		132,
		149,
		150,
		147,
		138,
		130,
		135,
		132,
		145,
		159,
		163,
		110,
		-1,
		93,
		-1,
		-1,
		-1,
		122,
		137,
		199,
		176,
		149,
		153,
		146,
		140,
		140,
		156,
		158,
		169,
		137,
		133,
		134,
		138,
		137,
		154,
		164,
		-1,
		-1,
		93,
		110,
		145,
		130,
		134,
		226,
		-1,
		-1,
		162,
		153,
		144,
		147,
		150,
		153,
		143,
		140,
		145,
		150,
		138,
		147,
		165,
		169,
		-1,
		-1,
		-1,
		113,
		-1,
		128,
		-1,
		-1,
		149,
		233,
		180,
		162,
		158,
		156,
		149,
		158,
		153,
		148,
		158,
		167,
		159,
		140,
		151,
		174,
		163,
		201,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		142,
		117,
		132,
		178,
		169,
		174,
		195,
		192,
		-1,
		162,
		187,
		159,
		166,
		158,
		166,
		166,
		163,
		141,
		148,
		164,
		163,
		158,
		193,
		185,
		191,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		148,
		134,
		164,
		154,
		160,
		-1,
		-1,
		207,
		204,
		184,
		168,
		172,
		165,
		160,
		170,
		150,
		137,
		141,
		145,
		151,
		156,
		161,
		167,
		182,
		197,
		-1,
		120,
		201,
		194,
		177,
		185,
		216,
		-1,
		151,
		160,
		141,
		146,
		154,
		-1,
		-1,
		180,
		176,
		181,
		175,
		172,
		180,
		175,
		166,
		151,
		157,
		144,
		143,
		161,
		165,
		174,
		181,
		171,
		184,
		188,
		-1,
		134,
		177,
		171,
		174,
		198,
		212,
		-1,
		164,
		-1,
		-1,
		149,
		167,
		175,
		171,
		175,
		228,
		189,
		184,
		174,
		172,
		163,
		154,
		161,
		152,
		152,
		155,
		170,
		175,
		167,
		181,
		181,
		182,
		-1,
		169,
		157,
		165,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		165,
		-1,
		201,
		-1,
		194,
		198,
		197,
		200,
		188,
		175,
		167,
		159,
		175,
		150,
		160,
		156,
		157,
		166,
		177,
		189,
		188,
		189,
		243,
		198,
		165,
		156,
		203,
		218,
		222,
		-1,
		177,
		216,
		203,
		-1,
		174,
		-1,
		-1,
		-1,
		208,
		210,
		202,
		208,
		187,
		187,
		161,
		165,
		155,
		162,
		172,
		174,
		166,
		170,
		183,
		194,
		197,
		239,
		237,
		242,
		187,
		170,
		188,
		197,
		218,
		192,
		183,
		210,
		210,
		199,
		194,
		181,
		-1,
		-1,
		231,
		220,
		-1,
		-1,
		194,
		182,
		165,
		166,
		162,
		165,
		180,
		183,
		173,
		171,
		165,
		197,
		-1,
		239,
		238,
		227,
		224,
		200,
		191,
		178,
		189,
		-1,
		-1,
		195,
		211,
		224,
		228,
		241,
		266,
		-1,
		184,
		-1,
		-1,
		239,
		-1,
		-1,
		224,
		187,
		176,
		167,
		173,
		170,
		181,
		191,
		179,
		180,
		170,
		180,
		193,
		223,
		220,
		208,
		206,
		229,
		186,
		182,
		-1,
		210,
		198,
		204,
		211,
		228,
		255,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		222,
		220,
		209,
		-1,
		199,
		172,
		177,
		197,
		199,
		188,
		182,
		176,
		183,
		182,
		190,
		198,
		232,
		246,
		235,
		231,
		230,
		238,
		187,
		204,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		210,
		-1,
		-1,
		217,
		210,
		198,
		186,
		176,
		186,
		190,
		194,
		186,
		179,
		174,
		185,
		177,
		181,
		198,
		-1,
		266,
		-1,
		218,
		211,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		251,
		235,
		216,
		-1,
		186,
		199,
		230,
		198,
		203,
		198,
		180,
		191,
		180,
		183,
		197,
		192,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		249,
		268,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		223,
		219,
		-1,
		-1,
		187,
		212,
		201,
		209,
		204,
		184,
		190,
		193,
		182,
		186,
		198,
		-1,
		-1,
		231,
		232,
		237,
		-1,
		252,
		-1,
		267,
		-1,
		212,
		228,
		230,
		-1,
		-1,
		-1,
		225,
		188,
		209,
		219,
		213,
		211,
		202,
		188,
		195,
		193,
		189,
		200,
		-1,
		-1,
		-1,
		270,
		244,
		274,
		265,
		248,
		228,
		220,
		242,
		-1,
		212,
		-1,
		187,
		189,
		215,
		218,
		224,
		218,
		191,
		206,
		196,
		187,
		196,
		276,
		-1,
		246,
		279,
		243,
		234,
		213,
		217,
		233,
		-1,
		209,
		191,
		-1,
		219,
		209,
		240,
		225,
		206,
		193,
		200,
		200,
		193,
		-1,
		-1,
		-1,
		248,
		247,
		239,
		233,
		233,
		218,
		209,
		-1,
		221,
		203,
		182,
		199,
		199,
		190,
		198,
		230,
		226,
		213,
		213,
		205,
		-1,
		338,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		242,
		237,
		210,
		198,
		204,
		200,
		186,
		192,
		194,
		202,
		200,
		197,
		209,
		205,
		225,
		206,
		241,
		-1,
		344,
		-1,
		278,
		-1,
		-1,
		260,
		240,
		232,
		221,
		210,
		208,
		199,
		190,
		212,
		228,
		212,
		210,
		213,
		214,
		-1,
		333,
		332,
		-1,
		279,
		271,
		257,
		-1,
		250,
		-1,
		256,
		217,
		-1,
		219,
		199,
		-1,
		221,
		217,
		-1,
		-1,
		320,
		295,
		-1,
		-1,
		-1,
		280,
		260,
		251,
		235,
		-1,
		210,
		210,
		-1,
		-1,
		-1,
		305,
		304,
		-1,
		273,
		276,
		-1,
		266,
		257,
		265,
		212,
		216,
		-1,
		-1,
		-1,
		314,
		295,
		289,
		288,
		286,
		281,
		278,
		264,
		248,
		226,
		215,
		236,
		-1,
		-1,
		-1,
		286,
		278,
		271,
		-1,
		-1,
		273,
		256,
		237,
		235,
		-1,
		-1,
		-1,
		308,
		289,
		-1,
		-1,
		263,
		-1,
		-1,
		269,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		325,
		297,
		-1,
		-1,
		-1,
		259,
		255,
		256,
		-1,
		-1,
		-1,
		-1,
		319,
		320,
		343,
		307,
		-1,
		-1,
		-1,
		251,
		245,
		-1,
		-1,
		322,
		320,
		-1,
		-1,
		-1,
		279,
		263,
		-1,
		249,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		284,
		-1,
		284,
		259,
		266,
		-1,
		-1,
		-1,
		-1,
		297,
		289,
		297,
		-1,
		269,
		271,
		-1,
		319,
		-1,
		-1,
		312,
		303,
		-1,
		-1,
		274,
		281,
		303,
		306,
		342,
		-1,
		293
	],
	[
		-1,
		128,
		117,
		128,
		136,
		109,
		116,
		-1,
		137,
		139,
		105,
		99,
		138,
		109,
		115,
		126,
		-1,
		-1,
		-1,
		128,
		127,
		97,
		95,
		104,
		109,
		116,
		-1,
		139,
		-1,
		149,
		128,
		139,
		144,
		90,
		87,
		107,
		126,
		132,
		124,
		164,
		120,
		91,
		85,
		103,
		108,
		126,
		118,
		-1,
		91,
		81,
		103,
		107,
		119,
		102,
		-1,
		-1,
		85,
		86,
		92,
		104,
		109,
		114,
		-1,
		140,
		152,
		-1,
		-1,
		75,
		88,
		84,
		87,
		95,
		111,
		132,
		149,
		147,
		-1,
		-1,
		76,
		80,
		93,
		94,
		92,
		119,
		138,
		142,
		156,
		155,
		-1,
		64,
		82,
		91,
		100,
		106,
		95,
		99,
		117,
		141,
		147,
		150,
		-1,
		56,
		58,
		87,
		93,
		105,
		111,
		98,
		104,
		123,
		129,
		148,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		53,
		61,
		87,
		86,
		82,
		100,
		122,
		101,
		107,
		111,
		121,
		137,
		138,
		148,
		-1,
		-1,
		109,
		78,
		113,
		70,
		55,
		-1,
		49,
		68,
		74,
		78,
		83,
		91,
		119,
		117,
		-1,
		115,
		114,
		145,
		131,
		142,
		69,
		-1,
		-1,
		67,
		59,
		44,
		47,
		44,
		44,
		74,
		73,
		78,
		80,
		82,
		94,
		109,
		109,
		119,
		109,
		119,
		123,
		134,
		149,
		-1,
		-1,
		204,
		-1,
		-1,
		66,
		49,
		-1,
		32,
		39,
		39,
		56,
		46,
		67,
		82,
		86,
		94,
		97,
		85,
		104,
		101,
		124,
		112,
		106,
		131,
		135,
		129,
		150,
		145,
		-1,
		203,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		44,
		25,
		28,
		34,
		58,
		68,
		-1,
		89,
		87,
		111,
		105,
		110,
		106,
		91,
		109,
		103,
		110,
		109,
		113,
		115,
		148,
		126,
		148,
		145,
		174,
		179,
		173,
		182,
		-1,
		74,
		70,
		66,
		73,
		22,
		-1,
		-1,
		62,
		-1,
		76,
		89,
		101,
		91,
		94,
		106,
		114,
		112,
		97,
		112,
		101,
		98,
		106,
		115,
		126,
		121,
		120,
		138,
		153,
		166,
		170,
		176,
		-1,
		124,
		-1,
		66,
		50,
		52,
		24,
		45,
		-1,
		82,
		77,
		97,
		103,
		103,
		-1,
		119,
		116,
		129,
		108,
		93,
		110,
		102,
		100,
		105,
		110,
		124,
		115,
		133,
		140,
		148,
		152,
		172,
		184,
		84,
		74,
		-1,
		56,
		61,
		20,
		28,
		47,
		120,
		104,
		-1,
		114,
		-1,
		110,
		134,
		-1,
		114,
		110,
		92,
		93,
		88,
		103,
		109,
		106,
		103,
		121,
		124,
		141,
		145,
		161,
		-1,
		-1,
		69,
		73,
		62,
		13,
		32,
		56,
		93,
		113,
		105,
		104,
		-1,
		95,
		125,
		122,
		108,
		95,
		85,
		86,
		94,
		107,
		86,
		105,
		108,
		130,
		158,
		136,
		148,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		39,
		10,
		34,
		76,
		134,
		127,
		115,
		80,
		80,
		74,
		-1,
		115,
		98,
		94,
		83,
		81,
		94,
		89,
		105,
		109,
		108,
		127,
		139,
		130,
		150,
		-1,
		-1,
		-1,
		69,
		58,
		59,
		5,
		28,
		65,
		113,
		99,
		104,
		79,
		72,
		66,
		118,
		115,
		82,
		90,
		82,
		71,
		85,
		93,
		97,
		106,
		115,
		121,
		145,
		145,
		151,
		-1,
		-1,
		76,
		66,
		50,
		52,
		49,
		19,
		26,
		58,
		104,
		101,
		-1,
		71,
		-1,
		60,
		68,
		67,
		73,
		85,
		71,
		76,
		87,
		99,
		112,
		108,
		115,
		150,
		150,
		135,
		155,
		158,
		-1,
		-1,
		-1,
		69,
		67,
		42,
		19,
		0,
		36,
		-1,
		71,
		72,
		-1,
		65,
		59,
		65,
		64,
		71,
		68,
		68,
		82,
		90,
		86,
		102,
		108,
		100,
		136,
		-1,
		143,
		137,
		145,
		135,
		123,
		-1,
		-1,
		-1,
		65,
		44,
		37,
		57,
		7,
		59,
		-1,
		-1,
		56,
		49,
		-1,
		52,
		52,
		59,
		68,
		73,
		78,
		86,
		81,
		94,
		99,
		105,
		110,
		128,
		132,
		136,
		125,
		121,
		118,
		132,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		10,
		27,
		-1,
		64,
		56,
		47,
		41,
		47,
		65,
		63,
		83,
		75,
		89,
		89,
		95,
		103,
		88,
		91,
		107,
		105,
		123,
		131,
		123,
		117,
		116,
		128,
		-1,
		113,
		99,
		70,
		-1,
		-1,
		42,
		-1,
		13,
		37,
		53,
		-1,
		81,
		60,
		83,
		61,
		75,
		71,
		109,
		110,
		88,
		93,
		101,
		111,
		113,
		102,
		113,
		105,
		127,
		127,
		111,
		112,
		121,
		-1,
		119,
		106,
		64,
		60,
		49,
		69,
		16,
		29,
		40,
		-1,
		-1,
		125,
		-1,
		59,
		76,
		85,
		83,
		99,
		90,
		96,
		112,
		115,
		117,
		107,
		96,
		102,
		99,
		121,
		107,
		105,
		124,
		140,
		-1,
		-1,
		-1,
		86,
		-1,
		-1,
		35,
		22,
		16,
		-1,
		57,
		-1,
		103,
		93,
		77,
		62,
		95,
		-1,
		107,
		91,
		96,
		-1,
		142,
		-1,
		115,
		117,
		111,
		96,
		93,
		104,
		102,
		113,
		130,
		-1,
		69,
		54,
		47,
		37,
		51,
		22,
		-1,
		77,
		-1,
		-1,
		90,
		84,
		84,
		68,
		71,
		123,
		103,
		97,
		96,
		137,
		137,
		123,
		109,
		102,
		99,
		96,
		109,
		129,
		120,
		132,
		-1,
		-1,
		-1,
		74,
		60,
		64,
		24,
		43,
		-1,
		-1,
		152,
		107,
		93,
		-1,
		77,
		140,
		128,
		118,
		108,
		142,
		143,
		128,
		121,
		107,
		109,
		107,
		105,
		110,
		131,
		132,
		145,
		-1,
		-1,
		57,
		62,
		50,
		36,
		55,
		-1,
		-1,
		-1,
		99,
		115,
		107,
		78,
		129,
		-1,
		-1,
		120,
		118,
		128,
		124,
		111,
		131,
		134,
		120,
		104,
		119,
		131,
		139,
		144,
		-1,
		60,
		47,
		-1,
		-1,
		58,
		52,
		-1,
		-1,
		-1,
		-1,
		132,
		98,
		110,
		131,
		156,
		123,
		-1,
		128,
		129,
		115,
		129,
		136,
		122,
		117,
		111,
		114,
		132,
		149,
		-1,
		-1,
		72,
		-1,
		67,
		-1,
		-1,
		-1,
		-1,
		89,
		103,
		124,
		130,
		142,
		-1,
		137,
		131,
		117,
		134,
		135,
		132,
		123,
		115,
		120,
		117,
		130,
		144,
		148,
		95,
		-1,
		78,
		-1,
		-1,
		-1,
		107,
		122,
		184,
		161,
		134,
		138,
		131,
		125,
		125,
		141,
		143,
		154,
		122,
		118,
		119,
		123,
		122,
		139,
		149,
		-1,
		-1,
		78,
		95,
		130,
		115,
		119,
		211,
		-1,
		-1,
		147,
		138,
		129,
		132,
		135,
		138,
		128,
		125,
		130,
		135,
		123,
		132,
		150,
		154,
		-1,
		-1,
		-1,
		98,
		-1,
		113,
		-1,
		-1,
		134,
		218,
		165,
		147,
		143,
		141,
		134,
		143,
		138,
		133,
		143,
		152,
		144,
		125,
		136,
		159,
		148,
		186,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		127,
		102,
		117,
		163,
		154,
		159,
		180,
		177,
		-1,
		147,
		172,
		144,
		151,
		143,
		151,
		151,
		148,
		126,
		133,
		149,
		148,
		143,
		178,
		170,
		176,
		-1,
		-1,
		210,
		199,
		188,
		194,
		-1,
		133,
		119,
		149,
		139,
		145,
		-1,
		-1,
		192,
		189,
		169,
		153,
		157,
		150,
		145,
		155,
		135,
		122,
		126,
		130,
		136,
		141,
		146,
		152,
		167,
		182,
		-1,
		105,
		186,
		179,
		162,
		170,
		201,
		-1,
		136,
		145,
		126,
		131,
		139,
		-1,
		-1,
		165,
		161,
		166,
		160,
		157,
		165,
		160,
		151,
		136,
		142,
		129,
		128,
		146,
		150,
		159,
		166,
		156,
		169,
		173,
		-1,
		119,
		162,
		156,
		159,
		183,
		197,
		-1,
		149,
		-1,
		-1,
		134,
		152,
		160,
		156,
		160,
		213,
		174,
		169,
		159,
		157,
		148,
		139,
		146,
		137,
		137,
		140,
		155,
		160,
		152,
		166,
		166,
		167,
		-1,
		154,
		142,
		150,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		150,
		-1,
		186,
		-1,
		179,
		183,
		182,
		185,
		173,
		160,
		152,
		144,
		160,
		135,
		145,
		141,
		142,
		151,
		162,
		174,
		173,
		174,
		228,
		183,
		150,
		141,
		188,
		203,
		207,
		-1,
		162,
		201,
		188,
		-1,
		159,
		-1,
		-1,
		-1,
		193,
		195,
		187,
		193,
		172,
		172,
		146,
		150,
		140,
		147,
		157,
		159,
		151,
		155,
		168,
		179,
		182,
		224,
		222,
		227,
		172,
		155,
		173,
		182,
		203,
		177,
		168,
		195,
		195,
		184,
		179,
		166,
		-1,
		-1,
		216,
		205,
		-1,
		-1,
		179,
		167,
		150,
		151,
		147,
		150,
		165,
		168,
		158,
		156,
		150,
		182,
		-1,
		224,
		223,
		212,
		209,
		185,
		176,
		163,
		174,
		-1,
		-1,
		180,
		196,
		209,
		213,
		226,
		251,
		-1,
		169,
		-1,
		-1,
		224,
		-1,
		-1,
		209,
		172,
		161,
		152,
		158,
		155,
		166,
		176,
		164,
		165,
		155,
		165,
		178,
		208,
		205,
		193,
		191,
		214,
		171,
		167,
		-1,
		195,
		183,
		189,
		196,
		213,
		240,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		207,
		205,
		194,
		-1,
		184,
		157,
		162,
		182,
		184,
		173,
		167,
		161,
		168,
		167,
		175,
		183,
		217,
		231,
		220,
		216,
		215,
		223,
		172,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		195,
		-1,
		-1,
		202,
		195,
		183,
		171,
		161,
		171,
		175,
		179,
		171,
		164,
		159,
		170,
		162,
		166,
		183,
		-1,
		251,
		-1,
		203,
		196,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		236,
		220,
		201,
		-1,
		171,
		184,
		215,
		183,
		188,
		183,
		165,
		176,
		165,
		168,
		182,
		177,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		234,
		253,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		208,
		204,
		-1,
		-1,
		172,
		197,
		186,
		194,
		189,
		169,
		175,
		178,
		167,
		171,
		183,
		-1,
		-1,
		216,
		217,
		222,
		-1,
		237,
		-1,
		252,
		-1,
		197,
		213,
		215,
		-1,
		-1,
		-1,
		210,
		173,
		194,
		204,
		198,
		196,
		187,
		173,
		180,
		178,
		174,
		185,
		-1,
		-1,
		-1,
		255,
		229,
		259,
		250,
		233,
		213,
		205,
		227,
		-1,
		197,
		-1,
		172,
		174,
		200,
		203,
		209,
		203,
		176,
		191,
		181,
		172,
		181,
		261,
		-1,
		231,
		264,
		228,
		219,
		198,
		202,
		218,
		-1,
		194,
		176,
		-1,
		204,
		194,
		225,
		210,
		191,
		178,
		185,
		185,
		178,
		-1,
		-1,
		-1,
		233,
		232,
		224,
		218,
		218,
		203,
		194,
		-1,
		206,
		188,
		167,
		184,
		184,
		175,
		183,
		215,
		211,
		198,
		198,
		190,
		-1,
		323,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		227,
		222,
		195,
		183,
		189,
		185,
		171,
		177,
		179,
		187,
		185,
		182,
		194,
		190,
		210,
		191,
		226,
		-1,
		329,
		-1,
		263,
		-1,
		-1,
		245,
		225,
		217,
		206,
		195,
		193,
		184,
		175,
		197,
		213,
		197,
		195,
		198,
		199,
		-1,
		318,
		317,
		-1,
		264,
		256,
		242,
		-1,
		235,
		-1,
		241,
		202,
		-1,
		204,
		184,
		-1,
		206,
		202,
		-1,
		-1,
		305,
		280,
		-1,
		-1,
		-1,
		265,
		245,
		236,
		220,
		-1,
		195,
		195,
		-1,
		-1,
		-1,
		290,
		289,
		-1,
		258,
		261,
		-1,
		251,
		242,
		250,
		197,
		201,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		273,
		271,
		266,
		263,
		249,
		233,
		211,
		200,
		221,
		-1,
		-1,
		-1,
		271,
		263,
		256,
		-1,
		-1,
		258,
		241,
		222,
		220,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		248,
		-1,
		-1,
		254,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		282,
		-1,
		-1,
		-1,
		244,
		240,
		241,
		-1,
		-1,
		-1,
		-1,
		304,
		305,
		328,
		292,
		-1,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		307,
		305,
		-1,
		-1,
		-1,
		264,
		248,
		-1,
		234,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		269,
		-1,
		269,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		282,
		274,
		282,
		-1,
		254,
		256,
		-1,
		304,
		-1,
		-1,
		297,
		288,
		-1,
		-1,
		259,
		266,
		288,
		291,
		327,
		-1,
		278
	],
	[
		-1,
		165,
		154,
		165,
		173,
		146,
		153,
		-1,
		174,
		176,
		142,
		136,
		175,
		146,
		152,
		163,
		-1,
		-1,
		-1,
		165,
		164,
		134,
		132,
		141,
		146,
		153,
		-1,
		176,
		-1,
		186,
		165,
		176,
		181,
		127,
		124,
		144,
		163,
		169,
		161,
		201,
		157,
		128,
		122,
		140,
		145,
		163,
		155,
		-1,
		128,
		118,
		140,
		144,
		156,
		139,
		-1,
		-1,
		122,
		123,
		129,
		141,
		146,
		151,
		-1,
		177,
		189,
		-1,
		-1,
		112,
		125,
		121,
		124,
		132,
		148,
		169,
		186,
		184,
		-1,
		-1,
		113,
		117,
		130,
		131,
		129,
		156,
		175,
		179,
		193,
		192,
		-1,
		101,
		119,
		128,
		137,
		143,
		132,
		136,
		154,
		178,
		184,
		187,
		-1,
		93,
		95,
		124,
		130,
		142,
		148,
		135,
		141,
		160,
		166,
		185,
		176,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		90,
		98,
		124,
		123,
		119,
		137,
		159,
		138,
		144,
		148,
		158,
		174,
		175,
		185,
		-1,
		-1,
		146,
		115,
		150,
		107,
		92,
		-1,
		86,
		105,
		111,
		115,
		120,
		128,
		156,
		154,
		-1,
		152,
		151,
		182,
		168,
		179,
		106,
		-1,
		-1,
		104,
		96,
		81,
		84,
		81,
		81,
		111,
		110,
		115,
		117,
		119,
		131,
		146,
		146,
		156,
		146,
		156,
		160,
		171,
		186,
		-1,
		-1,
		241,
		-1,
		-1,
		103,
		86,
		-1,
		69,
		76,
		76,
		93,
		83,
		104,
		119,
		123,
		131,
		134,
		122,
		141,
		138,
		161,
		149,
		143,
		168,
		172,
		166,
		187,
		182,
		-1,
		240,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		62,
		65,
		71,
		95,
		105,
		-1,
		126,
		124,
		148,
		142,
		147,
		143,
		128,
		146,
		140,
		147,
		146,
		150,
		152,
		185,
		163,
		185,
		182,
		211,
		216,
		210,
		219,
		-1,
		111,
		107,
		103,
		110,
		59,
		-1,
		-1,
		99,
		-1,
		113,
		126,
		138,
		128,
		131,
		143,
		151,
		149,
		134,
		149,
		138,
		135,
		143,
		152,
		163,
		158,
		157,
		175,
		190,
		203,
		207,
		213,
		-1,
		161,
		-1,
		103,
		87,
		89,
		61,
		82,
		-1,
		119,
		114,
		134,
		140,
		140,
		-1,
		156,
		153,
		166,
		145,
		130,
		147,
		139,
		137,
		142,
		147,
		161,
		152,
		170,
		177,
		185,
		189,
		209,
		221,
		121,
		111,
		-1,
		93,
		98,
		57,
		65,
		84,
		157,
		141,
		-1,
		151,
		-1,
		147,
		171,
		-1,
		151,
		147,
		129,
		130,
		125,
		140,
		146,
		143,
		140,
		158,
		161,
		178,
		182,
		198,
		-1,
		-1,
		106,
		110,
		99,
		50,
		64,
		88,
		125,
		150,
		142,
		141,
		-1,
		132,
		162,
		159,
		145,
		132,
		122,
		123,
		131,
		144,
		123,
		142,
		145,
		167,
		195,
		173,
		185,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		76,
		47,
		66,
		108,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		152,
		135,
		131,
		120,
		118,
		131,
		126,
		142,
		146,
		145,
		164,
		176,
		167,
		187,
		-1,
		-1,
		-1,
		106,
		95,
		96,
		42,
		29,
		79,
		150,
		136,
		141,
		116,
		109,
		103,
		155,
		152,
		119,
		127,
		119,
		108,
		122,
		130,
		134,
		143,
		152,
		158,
		182,
		182,
		188,
		-1,
		-1,
		113,
		103,
		87,
		89,
		86,
		53,
		23,
		59,
		141,
		138,
		-1,
		108,
		-1,
		97,
		105,
		104,
		110,
		122,
		108,
		113,
		124,
		136,
		149,
		145,
		152,
		187,
		187,
		172,
		192,
		195,
		-1,
		-1,
		-1,
		106,
		99,
		74,
		51,
		37,
		0,
		-1,
		108,
		109,
		-1,
		102,
		96,
		102,
		101,
		108,
		105,
		105,
		119,
		127,
		123,
		139,
		145,
		137,
		173,
		-1,
		180,
		174,
		182,
		172,
		160,
		-1,
		-1,
		-1,
		97,
		76,
		69,
		89,
		44,
		96,
		-1,
		-1,
		93,
		86,
		-1,
		89,
		89,
		96,
		105,
		110,
		115,
		123,
		118,
		131,
		136,
		142,
		147,
		165,
		169,
		173,
		162,
		158,
		155,
		169,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		47,
		64,
		-1,
		101,
		93,
		84,
		78,
		84,
		102,
		100,
		120,
		112,
		126,
		126,
		132,
		140,
		125,
		128,
		144,
		142,
		160,
		168,
		160,
		154,
		153,
		165,
		-1,
		150,
		136,
		107,
		-1,
		-1,
		79,
		-1,
		50,
		74,
		90,
		-1,
		118,
		97,
		120,
		98,
		112,
		108,
		146,
		147,
		125,
		130,
		138,
		148,
		150,
		139,
		150,
		142,
		164,
		164,
		148,
		149,
		158,
		-1,
		156,
		143,
		101,
		97,
		86,
		106,
		53,
		66,
		77,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		122,
		120,
		136,
		127,
		133,
		149,
		152,
		154,
		144,
		133,
		139,
		136,
		158,
		144,
		142,
		161,
		177,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		72,
		59,
		53,
		-1,
		94,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		144,
		128,
		133,
		-1,
		179,
		-1,
		152,
		154,
		148,
		133,
		130,
		141,
		139,
		150,
		167,
		-1,
		106,
		91,
		84,
		74,
		88,
		59,
		-1,
		114,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		160,
		140,
		134,
		133,
		174,
		174,
		160,
		146,
		139,
		136,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		111,
		97,
		101,
		61,
		80,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		177,
		165,
		155,
		145,
		179,
		180,
		165,
		158,
		144,
		146,
		144,
		142,
		147,
		168,
		169,
		182,
		-1,
		-1,
		94,
		99,
		87,
		73,
		92,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		166,
		-1,
		-1,
		157,
		155,
		165,
		161,
		148,
		168,
		171,
		157,
		141,
		156,
		168,
		176,
		181,
		-1,
		97,
		84,
		-1,
		-1,
		95,
		89,
		-1,
		-1,
		-1,
		-1,
		169,
		135,
		147,
		168,
		193,
		160,
		-1,
		165,
		166,
		152,
		166,
		173,
		159,
		154,
		148,
		151,
		169,
		186,
		-1,
		-1,
		109,
		-1,
		104,
		-1,
		-1,
		-1,
		-1,
		126,
		140,
		161,
		167,
		179,
		-1,
		174,
		168,
		154,
		171,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		132,
		-1,
		115,
		-1,
		-1,
		-1,
		144,
		159,
		221,
		198,
		171,
		175,
		168,
		162,
		162,
		178,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		115,
		132,
		167,
		152,
		156,
		248,
		-1,
		-1,
		184,
		175,
		166,
		169,
		172,
		175,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		191,
		-1,
		-1,
		-1,
		135,
		-1,
		150,
		-1,
		-1,
		171,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		189,
		181,
		162,
		173,
		196,
		185,
		223,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		164,
		139,
		154,
		200,
		191,
		196,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		180,
		188,
		188,
		185,
		163,
		170,
		186,
		185,
		180,
		215,
		207,
		213,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		170,
		156,
		186,
		176,
		182,
		-1,
		-1,
		229,
		226,
		206,
		190,
		194,
		187,
		182,
		192,
		172,
		159,
		163,
		167,
		173,
		178,
		183,
		189,
		204,
		219,
		-1,
		142,
		223,
		216,
		199,
		207,
		238,
		-1,
		173,
		182,
		163,
		168,
		176,
		-1,
		-1,
		202,
		198,
		203,
		197,
		194,
		202,
		197,
		188,
		173,
		179,
		166,
		165,
		183,
		187,
		196,
		203,
		193,
		206,
		210,
		-1,
		156,
		199,
		193,
		196,
		220,
		234,
		-1,
		186,
		-1,
		-1,
		171,
		189,
		197,
		193,
		197,
		250,
		211,
		206,
		196,
		194,
		185,
		176,
		183,
		174,
		174,
		177,
		192,
		197,
		189,
		203,
		203,
		204,
		-1,
		191,
		179,
		187,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		187,
		-1,
		223,
		-1,
		216,
		220,
		219,
		222,
		210,
		197,
		189,
		181,
		197,
		172,
		182,
		178,
		179,
		188,
		199,
		211,
		210,
		211,
		265,
		220,
		187,
		178,
		225,
		240,
		244,
		-1,
		199,
		238,
		225,
		-1,
		196,
		-1,
		-1,
		-1,
		230,
		232,
		224,
		230,
		209,
		209,
		183,
		187,
		177,
		184,
		194,
		196,
		188,
		192,
		205,
		216,
		219,
		261,
		259,
		264,
		209,
		192,
		210,
		219,
		240,
		214,
		205,
		232,
		232,
		221,
		216,
		203,
		-1,
		-1,
		253,
		242,
		-1,
		-1,
		216,
		204,
		187,
		188,
		184,
		187,
		202,
		205,
		195,
		193,
		187,
		219,
		-1,
		261,
		260,
		249,
		246,
		222,
		213,
		200,
		211,
		-1,
		-1,
		217,
		233,
		246,
		250,
		263,
		288,
		-1,
		206,
		-1,
		-1,
		261,
		-1,
		-1,
		246,
		209,
		198,
		189,
		195,
		192,
		203,
		213,
		201,
		202,
		192,
		202,
		215,
		245,
		242,
		230,
		228,
		251,
		208,
		204,
		-1,
		232,
		220,
		226,
		233,
		250,
		277,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		244,
		242,
		231,
		-1,
		221,
		194,
		199,
		219,
		221,
		210,
		204,
		198,
		205,
		204,
		212,
		220,
		254,
		268,
		257,
		253,
		252,
		260,
		209,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		257,
		232,
		-1,
		-1,
		239,
		232,
		220,
		208,
		198,
		208,
		212,
		216,
		208,
		201,
		196,
		207,
		199,
		203,
		220,
		-1,
		288,
		-1,
		240,
		233,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		274,
		260,
		253,
		241,
		239,
		-1,
		273,
		257,
		238,
		-1,
		208,
		221,
		252,
		220,
		225,
		220,
		202,
		213,
		202,
		205,
		219,
		214,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		271,
		290,
		-1,
		265,
		254,
		239,
		231,
		-1,
		-1,
		245,
		241,
		-1,
		-1,
		209,
		234,
		223,
		231,
		226,
		206,
		212,
		215,
		204,
		208,
		220,
		-1,
		-1,
		253,
		254,
		259,
		-1,
		274,
		-1,
		289,
		-1,
		234,
		250,
		252,
		-1,
		-1,
		-1,
		247,
		210,
		231,
		241,
		235,
		233,
		224,
		210,
		217,
		215,
		211,
		222,
		-1,
		-1,
		-1,
		292,
		266,
		296,
		287,
		270,
		250,
		242,
		264,
		-1,
		234,
		-1,
		209,
		211,
		237,
		240,
		246,
		240,
		213,
		228,
		218,
		209,
		218,
		298,
		-1,
		268,
		301,
		265,
		256,
		235,
		239,
		255,
		-1,
		231,
		213,
		-1,
		241,
		231,
		262,
		247,
		228,
		215,
		222,
		222,
		215,
		-1,
		-1,
		-1,
		270,
		269,
		261,
		255,
		255,
		240,
		231,
		-1,
		243,
		225,
		204,
		221,
		221,
		212,
		220,
		252,
		248,
		235,
		235,
		227,
		-1,
		360,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		264,
		259,
		232,
		220,
		226,
		222,
		208,
		214,
		216,
		224,
		222,
		219,
		231,
		227,
		247,
		228,
		263,
		-1,
		366,
		-1,
		300,
		-1,
		-1,
		282,
		262,
		254,
		243,
		232,
		230,
		221,
		212,
		234,
		250,
		234,
		232,
		235,
		236,
		-1,
		355,
		354,
		-1,
		301,
		293,
		279,
		-1,
		272,
		-1,
		278,
		239,
		-1,
		241,
		221,
		-1,
		243,
		239,
		-1,
		-1,
		342,
		317,
		-1,
		-1,
		-1,
		302,
		282,
		273,
		257,
		-1,
		232,
		232,
		-1,
		-1,
		-1,
		327,
		326,
		-1,
		295,
		298,
		-1,
		288,
		279,
		287,
		234,
		238,
		-1,
		-1,
		-1,
		336,
		317,
		311,
		310,
		308,
		303,
		300,
		286,
		270,
		248,
		237,
		258,
		-1,
		-1,
		-1,
		308,
		300,
		293,
		-1,
		-1,
		295,
		278,
		259,
		257,
		-1,
		-1,
		-1,
		330,
		311,
		-1,
		-1,
		285,
		-1,
		-1,
		291,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		347,
		319,
		-1,
		-1,
		-1,
		281,
		277,
		278,
		-1,
		-1,
		-1,
		-1,
		341,
		342,
		365,
		329,
		-1,
		-1,
		-1,
		273,
		267,
		-1,
		-1,
		344,
		342,
		-1,
		-1,
		-1,
		301,
		285,
		-1,
		271,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		306,
		-1,
		306,
		281,
		288,
		-1,
		-1,
		-1,
		-1,
		319,
		311,
		319,
		-1,
		291,
		293,
		-1,
		341,
		-1,
		-1,
		334,
		325,
		-1,
		-1,
		296,
		303,
		325,
		328,
		364,
		-1,
		315
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		201,
		203,
		169,
		163,
		202,
		173,
		179,
		190,
		-1,
		-1,
		-1,
		192,
		191,
		161,
		159,
		168,
		173,
		180,
		-1,
		193,
		-1,
		213,
		192,
		203,
		208,
		154,
		151,
		171,
		190,
		186,
		178,
		228,
		184,
		155,
		149,
		167,
		171,
		180,
		172,
		-1,
		155,
		145,
		167,
		160,
		171,
		163,
		-1,
		-1,
		149,
		150,
		156,
		156,
		162,
		158,
		-1,
		168,
		152,
		-1,
		-1,
		139,
		152,
		138,
		141,
		149,
		147,
		160,
		152,
		147,
		-1,
		-1,
		140,
		140,
		147,
		134,
		130,
		147,
		160,
		142,
		156,
		155,
		-1,
		128,
		146,
		155,
		141,
		139,
		123,
		121,
		139,
		141,
		147,
		150,
		-1,
		120,
		122,
		142,
		150,
		155,
		139,
		126,
		126,
		136,
		129,
		148,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		125,
		146,
		138,
		128,
		143,
		136,
		129,
		126,
		124,
		121,
		137,
		138,
		148,
		-1,
		-1,
		173,
		142,
		177,
		134,
		119,
		-1,
		113,
		122,
		128,
		132,
		126,
		119,
		133,
		129,
		-1,
		115,
		114,
		145,
		131,
		142,
		133,
		-1,
		-1,
		131,
		123,
		108,
		111,
		108,
		108,
		137,
		136,
		128,
		114,
		110,
		116,
		119,
		119,
		125,
		109,
		119,
		123,
		134,
		149,
		-1,
		-1,
		204,
		-1,
		-1,
		130,
		113,
		-1,
		96,
		103,
		103,
		120,
		110,
		131,
		146,
		138,
		130,
		124,
		112,
		114,
		111,
		124,
		112,
		106,
		131,
		135,
		129,
		150,
		145,
		-1,
		203,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		89,
		92,
		98,
		122,
		132,
		-1,
		132,
		138,
		148,
		133,
		130,
		117,
		105,
		118,
		103,
		110,
		109,
		113,
		115,
		148,
		126,
		148,
		145,
		174,
		179,
		173,
		182,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		126,
		-1,
		140,
		149,
		124,
		142,
		145,
		134,
		125,
		112,
		101,
		112,
		101,
		98,
		106,
		115,
		126,
		121,
		120,
		138,
		153,
		166,
		170,
		176,
		-1,
		188,
		-1,
		130,
		114,
		116,
		88,
		109,
		-1,
		146,
		141,
		141,
		126,
		117,
		-1,
		120,
		123,
		130,
		108,
		93,
		110,
		102,
		100,
		105,
		110,
		124,
		115,
		133,
		140,
		148,
		152,
		172,
		184,
		148,
		138,
		-1,
		120,
		125,
		84,
		92,
		111,
		159,
		123,
		-1,
		118,
		-1,
		110,
		135,
		-1,
		114,
		110,
		92,
		93,
		88,
		103,
		109,
		106,
		103,
		121,
		124,
		141,
		145,
		161,
		-1,
		-1,
		133,
		137,
		126,
		77,
		96,
		120,
		157,
		116,
		105,
		104,
		-1,
		95,
		125,
		122,
		108,
		95,
		85,
		86,
		94,
		107,
		86,
		105,
		108,
		130,
		158,
		136,
		148,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		103,
		74,
		98,
		140,
		134,
		127,
		115,
		80,
		80,
		74,
		-1,
		115,
		98,
		94,
		83,
		81,
		94,
		89,
		105,
		109,
		108,
		127,
		139,
		130,
		150,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		69,
		92,
		129,
		113,
		99,
		104,
		79,
		72,
		66,
		118,
		115,
		82,
		90,
		82,
		71,
		85,
		93,
		97,
		106,
		115,
		121,
		145,
		145,
		151,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		83,
		90,
		122,
		104,
		50,
		-1,
		71,
		-1,
		60,
		68,
		67,
		73,
		85,
		71,
		76,
		87,
		99,
		112,
		108,
		115,
		150,
		150,
		135,
		155,
		158,
		-1,
		-1,
		-1,
		133,
		128,
		103,
		80,
		64,
		100,
		-1,
		0,
		12,
		-1,
		65,
		59,
		65,
		64,
		71,
		68,
		68,
		82,
		90,
		86,
		102,
		108,
		100,
		136,
		-1,
		143,
		137,
		145,
		135,
		123,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		59,
		111,
		-1,
		-1,
		16,
		23,
		-1,
		52,
		52,
		59,
		68,
		73,
		78,
		86,
		81,
		94,
		99,
		105,
		110,
		128,
		132,
		136,
		125,
		121,
		118,
		132,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		79,
		-1,
		60,
		52,
		38,
		32,
		38,
		65,
		63,
		83,
		75,
		89,
		89,
		95,
		103,
		88,
		91,
		107,
		105,
		123,
		131,
		123,
		117,
		116,
		128,
		-1,
		146,
		132,
		103,
		-1,
		-1,
		92,
		-1,
		56,
		69,
		85,
		-1,
		72,
		51,
		75,
		57,
		75,
		71,
		109,
		110,
		88,
		93,
		101,
		111,
		113,
		102,
		113,
		105,
		127,
		127,
		111,
		112,
		121,
		-1,
		152,
		139,
		97,
		93,
		82,
		102,
		53,
		41,
		72,
		-1,
		-1,
		125,
		-1,
		59,
		76,
		85,
		83,
		99,
		90,
		96,
		112,
		115,
		117,
		107,
		96,
		102,
		99,
		121,
		107,
		105,
		124,
		140,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		68,
		55,
		49,
		-1,
		89,
		-1,
		103,
		93,
		77,
		62,
		95,
		-1,
		107,
		91,
		96,
		-1,
		142,
		-1,
		115,
		117,
		111,
		96,
		93,
		104,
		102,
		113,
		130,
		-1,
		102,
		87,
		80,
		70,
		84,
		55,
		-1,
		110,
		-1,
		-1,
		90,
		84,
		84,
		68,
		71,
		123,
		103,
		97,
		96,
		137,
		137,
		123,
		109,
		102,
		99,
		96,
		109,
		129,
		120,
		132,
		-1,
		-1,
		-1,
		107,
		93,
		97,
		57,
		76,
		-1,
		-1,
		152,
		107,
		93,
		-1,
		77,
		140,
		128,
		118,
		108,
		142,
		143,
		128,
		121,
		107,
		109,
		107,
		105,
		110,
		131,
		132,
		145,
		-1,
		-1,
		90,
		95,
		83,
		69,
		88,
		-1,
		-1,
		-1,
		99,
		115,
		107,
		78,
		129,
		-1,
		-1,
		120,
		118,
		128,
		124,
		111,
		131,
		134,
		120,
		104,
		119,
		131,
		139,
		144,
		-1,
		93,
		80,
		-1,
		-1,
		91,
		85,
		-1,
		-1,
		-1,
		-1,
		132,
		98,
		110,
		131,
		156,
		123,
		-1,
		128,
		129,
		115,
		129,
		136,
		122,
		117,
		111,
		114,
		132,
		149,
		-1,
		-1,
		105,
		-1,
		100,
		-1,
		-1,
		-1,
		-1,
		89,
		103,
		124,
		130,
		142,
		-1,
		137,
		131,
		117,
		134,
		135,
		132,
		123,
		115,
		120,
		117,
		130,
		144,
		148,
		128,
		-1,
		111,
		-1,
		-1,
		-1,
		107,
		122,
		184,
		161,
		134,
		138,
		131,
		125,
		125,
		141,
		143,
		154,
		122,
		118,
		119,
		123,
		122,
		139,
		149,
		-1,
		-1,
		111,
		128,
		133,
		115,
		119,
		211,
		-1,
		-1,
		147,
		138,
		129,
		132,
		135,
		138,
		128,
		125,
		130,
		135,
		123,
		132,
		150,
		154,
		-1,
		-1,
		-1,
		131,
		-1,
		146,
		-1,
		-1,
		134,
		218,
		165,
		147,
		143,
		141,
		134,
		143,
		138,
		133,
		143,
		152,
		144,
		125,
		136,
		159,
		148,
		186,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		160,
		135,
		150,
		196,
		154,
		161,
		180,
		177,
		-1,
		147,
		172,
		144,
		151,
		143,
		151,
		151,
		148,
		126,
		133,
		149,
		148,
		143,
		178,
		170,
		176,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		166,
		152,
		182,
		172,
		171,
		-1,
		-1,
		196,
		193,
		169,
		153,
		157,
		150,
		145,
		155,
		135,
		122,
		126,
		130,
		136,
		141,
		146,
		152,
		167,
		182,
		-1,
		138,
		219,
		212,
		195,
		203,
		234,
		-1,
		169,
		178,
		159,
		164,
		172,
		-1,
		-1,
		169,
		166,
		171,
		160,
		157,
		165,
		160,
		151,
		136,
		142,
		129,
		128,
		146,
		150,
		159,
		166,
		156,
		169,
		173,
		-1,
		152,
		195,
		189,
		192,
		216,
		230,
		-1,
		182,
		-1,
		-1,
		167,
		185,
		184,
		174,
		168,
		218,
		174,
		169,
		159,
		157,
		148,
		139,
		146,
		137,
		137,
		140,
		155,
		160,
		152,
		166,
		166,
		167,
		-1,
		187,
		175,
		183,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		183,
		-1,
		211,
		-1,
		186,
		190,
		182,
		185,
		173,
		160,
		152,
		144,
		160,
		135,
		145,
		141,
		142,
		151,
		162,
		174,
		173,
		174,
		261,
		216,
		183,
		174,
		221,
		236,
		240,
		-1,
		195,
		234,
		221,
		-1,
		192,
		-1,
		-1,
		-1,
		200,
		195,
		187,
		193,
		172,
		172,
		146,
		150,
		140,
		147,
		157,
		159,
		151,
		155,
		168,
		179,
		182,
		257,
		255,
		260,
		205,
		188,
		206,
		215,
		236,
		210,
		201,
		228,
		228,
		217,
		212,
		199,
		-1,
		-1,
		223,
		205,
		-1,
		-1,
		179,
		167,
		150,
		151,
		147,
		150,
		165,
		168,
		158,
		156,
		150,
		182,
		-1,
		257,
		256,
		245,
		242,
		218,
		209,
		196,
		207,
		-1,
		-1,
		213,
		229,
		242,
		246,
		259,
		284,
		-1,
		202,
		-1,
		-1,
		224,
		-1,
		-1,
		209,
		172,
		161,
		152,
		158,
		155,
		166,
		176,
		164,
		165,
		155,
		165,
		178,
		241,
		238,
		226,
		224,
		247,
		204,
		200,
		-1,
		228,
		216,
		222,
		229,
		246,
		273,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		207,
		205,
		194,
		-1,
		184,
		157,
		162,
		182,
		184,
		173,
		167,
		161,
		168,
		167,
		175,
		183,
		250,
		264,
		253,
		249,
		248,
		256,
		205,
		218,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		-1,
		245,
		228,
		-1,
		-1,
		202,
		195,
		183,
		171,
		161,
		171,
		175,
		179,
		171,
		164,
		159,
		170,
		162,
		166,
		183,
		-1,
		284,
		-1,
		236,
		229,
		244,
		259,
		267,
		-1,
		-1,
		-1,
		262,
		248,
		241,
		229,
		227,
		-1,
		236,
		220,
		201,
		-1,
		171,
		184,
		215,
		183,
		188,
		183,
		165,
		176,
		165,
		168,
		182,
		177,
		-1,
		-1,
		242,
		245,
		-1,
		-1,
		252,
		254,
		-1,
		253,
		242,
		227,
		219,
		-1,
		-1,
		208,
		204,
		-1,
		-1,
		172,
		197,
		186,
		194,
		189,
		169,
		175,
		178,
		167,
		171,
		183,
		-1,
		-1,
		249,
		250,
		255,
		-1,
		237,
		-1,
		255,
		-1,
		222,
		228,
		216,
		-1,
		-1,
		-1,
		210,
		173,
		194,
		204,
		198,
		196,
		187,
		173,
		180,
		178,
		174,
		185,
		-1,
		-1,
		-1,
		255,
		229,
		262,
		253,
		236,
		216,
		208,
		227,
		-1,
		197,
		-1,
		172,
		174,
		200,
		203,
		209,
		203,
		176,
		191,
		181,
		172,
		181,
		261,
		-1,
		231,
		264,
		228,
		222,
		198,
		202,
		218,
		-1,
		194,
		176,
		-1,
		204,
		194,
		225,
		210,
		191,
		178,
		185,
		185,
		178,
		-1,
		-1,
		-1,
		233,
		232,
		224,
		218,
		218,
		203,
		194,
		-1,
		206,
		188,
		167,
		184,
		184,
		175,
		183,
		215,
		211,
		198,
		198,
		190,
		-1,
		334,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		227,
		222,
		195,
		183,
		189,
		185,
		171,
		177,
		179,
		187,
		185,
		182,
		194,
		190,
		210,
		191,
		226,
		-1,
		329,
		-1,
		263,
		-1,
		-1,
		245,
		225,
		217,
		206,
		195,
		193,
		184,
		175,
		197,
		213,
		197,
		195,
		198,
		199,
		-1,
		318,
		317,
		-1,
		264,
		256,
		242,
		-1,
		235,
		-1,
		241,
		202,
		-1,
		204,
		184,
		-1,
		206,
		202,
		-1,
		-1,
		305,
		280,
		-1,
		-1,
		-1,
		265,
		245,
		236,
		220,
		-1,
		195,
		195,
		-1,
		-1,
		-1,
		290,
		289,
		-1,
		258,
		261,
		-1,
		251,
		242,
		250,
		197,
		201,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		273,
		271,
		266,
		263,
		249,
		233,
		211,
		200,
		221,
		-1,
		-1,
		-1,
		271,
		263,
		256,
		-1,
		-1,
		258,
		241,
		222,
		220,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		248,
		-1,
		-1,
		254,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		282,
		-1,
		-1,
		-1,
		244,
		240,
		241,
		-1,
		-1,
		-1,
		-1,
		304,
		305,
		328,
		292,
		-1,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		307,
		305,
		-1,
		-1,
		-1,
		264,
		248,
		-1,
		234,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		269,
		-1,
		269,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		282,
		274,
		282,
		-1,
		254,
		256,
		-1,
		304,
		-1,
		-1,
		297,
		288,
		-1,
		-1,
		259,
		266,
		288,
		291,
		327,
		-1,
		278
	],
	[
		-1,
		186,
		175,
		186,
		194,
		167,
		174,
		-1,
		195,
		197,
		163,
		157,
		196,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		186,
		185,
		155,
		153,
		162,
		167,
		174,
		-1,
		187,
		-1,
		207,
		186,
		197,
		202,
		148,
		145,
		165,
		184,
		180,
		172,
		222,
		178,
		149,
		143,
		161,
		165,
		174,
		166,
		-1,
		149,
		139,
		161,
		154,
		165,
		157,
		-1,
		-1,
		143,
		144,
		150,
		150,
		156,
		152,
		-1,
		162,
		146,
		-1,
		-1,
		133,
		146,
		132,
		135,
		143,
		141,
		154,
		146,
		141,
		-1,
		-1,
		134,
		134,
		141,
		128,
		124,
		141,
		154,
		136,
		150,
		149,
		-1,
		122,
		140,
		149,
		135,
		133,
		117,
		115,
		133,
		135,
		141,
		144,
		-1,
		114,
		116,
		136,
		144,
		149,
		133,
		120,
		120,
		130,
		123,
		142,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		111,
		119,
		140,
		132,
		122,
		137,
		130,
		123,
		120,
		118,
		115,
		131,
		132,
		142,
		-1,
		-1,
		167,
		136,
		171,
		128,
		113,
		-1,
		107,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		109,
		108,
		139,
		125,
		136,
		127,
		-1,
		-1,
		125,
		117,
		102,
		105,
		102,
		102,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		103,
		113,
		117,
		128,
		143,
		-1,
		-1,
		198,
		-1,
		-1,
		124,
		107,
		-1,
		90,
		97,
		97,
		114,
		104,
		125,
		140,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		100,
		125,
		129,
		123,
		144,
		139,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		83,
		86,
		92,
		116,
		126,
		-1,
		126,
		132,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		107,
		109,
		142,
		120,
		142,
		139,
		168,
		173,
		167,
		176,
		-1,
		132,
		128,
		124,
		131,
		80,
		-1,
		-1,
		120,
		-1,
		134,
		143,
		118,
		136,
		139,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		109,
		120,
		115,
		114,
		132,
		147,
		160,
		164,
		170,
		-1,
		182,
		-1,
		124,
		108,
		110,
		82,
		103,
		-1,
		140,
		135,
		135,
		120,
		111,
		-1,
		114,
		117,
		124,
		102,
		87,
		104,
		96,
		94,
		99,
		104,
		118,
		109,
		127,
		134,
		142,
		146,
		166,
		178,
		142,
		132,
		-1,
		114,
		119,
		78,
		86,
		105,
		153,
		117,
		-1,
		112,
		-1,
		104,
		129,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		103,
		100,
		97,
		115,
		118,
		135,
		139,
		155,
		-1,
		-1,
		127,
		131,
		120,
		71,
		90,
		114,
		151,
		110,
		99,
		98,
		-1,
		89,
		119,
		116,
		102,
		89,
		79,
		80,
		88,
		101,
		80,
		99,
		102,
		124,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		97,
		68,
		92,
		134,
		128,
		121,
		109,
		74,
		74,
		68,
		-1,
		109,
		92,
		88,
		77,
		75,
		88,
		83,
		99,
		103,
		102,
		121,
		133,
		124,
		144,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		63,
		86,
		123,
		107,
		93,
		98,
		73,
		66,
		60,
		112,
		109,
		76,
		84,
		76,
		65,
		79,
		87,
		91,
		100,
		109,
		115,
		139,
		139,
		145,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		77,
		84,
		116,
		98,
		44,
		-1,
		65,
		-1,
		54,
		62,
		61,
		67,
		79,
		65,
		70,
		81,
		93,
		106,
		102,
		109,
		144,
		144,
		129,
		149,
		152,
		-1,
		-1,
		-1,
		127,
		122,
		97,
		74,
		58,
		94,
		-1,
		8,
		0,
		-1,
		59,
		53,
		59,
		58,
		65,
		62,
		62,
		76,
		84,
		80,
		96,
		102,
		94,
		130,
		-1,
		137,
		131,
		139,
		129,
		117,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		53,
		105,
		-1,
		-1,
		10,
		17,
		-1,
		46,
		46,
		53,
		62,
		67,
		72,
		80,
		75,
		88,
		93,
		99,
		104,
		122,
		126,
		130,
		119,
		115,
		112,
		126,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		73,
		-1,
		54,
		46,
		32,
		26,
		32,
		59,
		57,
		77,
		69,
		83,
		83,
		89,
		97,
		82,
		85,
		101,
		99,
		117,
		125,
		117,
		111,
		110,
		122,
		-1,
		140,
		126,
		97,
		-1,
		-1,
		86,
		-1,
		50,
		63,
		79,
		-1,
		66,
		45,
		69,
		51,
		69,
		65,
		103,
		104,
		82,
		87,
		95,
		105,
		107,
		96,
		107,
		99,
		121,
		121,
		105,
		106,
		115,
		-1,
		146,
		133,
		91,
		87,
		76,
		96,
		47,
		35,
		66,
		-1,
		-1,
		119,
		-1,
		53,
		70,
		79,
		77,
		93,
		84,
		90,
		106,
		109,
		111,
		101,
		90,
		96,
		93,
		115,
		101,
		99,
		118,
		134,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		62,
		49,
		43,
		-1,
		83,
		-1,
		97,
		87,
		71,
		56,
		89,
		-1,
		101,
		85,
		90,
		-1,
		136,
		-1,
		109,
		111,
		105,
		90,
		87,
		98,
		96,
		107,
		124,
		-1,
		96,
		81,
		74,
		64,
		78,
		49,
		-1,
		104,
		-1,
		-1,
		84,
		78,
		78,
		62,
		65,
		117,
		97,
		91,
		90,
		131,
		131,
		117,
		103,
		96,
		93,
		90,
		103,
		123,
		114,
		126,
		-1,
		-1,
		-1,
		101,
		87,
		91,
		51,
		70,
		-1,
		-1,
		146,
		101,
		87,
		-1,
		71,
		134,
		122,
		112,
		102,
		136,
		137,
		122,
		115,
		101,
		103,
		101,
		99,
		104,
		125,
		126,
		139,
		-1,
		-1,
		84,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		93,
		109,
		101,
		72,
		123,
		-1,
		-1,
		114,
		112,
		122,
		118,
		105,
		125,
		128,
		114,
		98,
		113,
		125,
		133,
		138,
		-1,
		87,
		74,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		104,
		125,
		150,
		117,
		-1,
		122,
		123,
		109,
		123,
		130,
		116,
		111,
		105,
		108,
		126,
		143,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		83,
		97,
		118,
		124,
		136,
		-1,
		131,
		125,
		111,
		128,
		129,
		126,
		117,
		109,
		114,
		111,
		124,
		138,
		142,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		101,
		116,
		178,
		155,
		128,
		132,
		125,
		119,
		119,
		135,
		137,
		148,
		116,
		112,
		113,
		117,
		116,
		133,
		143,
		-1,
		-1,
		105,
		122,
		127,
		109,
		113,
		205,
		-1,
		-1,
		141,
		132,
		123,
		126,
		129,
		132,
		122,
		119,
		124,
		129,
		117,
		126,
		144,
		148,
		-1,
		-1,
		-1,
		125,
		-1,
		140,
		-1,
		-1,
		128,
		212,
		159,
		141,
		137,
		135,
		128,
		137,
		132,
		127,
		137,
		146,
		138,
		119,
		130,
		153,
		142,
		180,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		154,
		129,
		144,
		190,
		148,
		155,
		174,
		171,
		-1,
		141,
		166,
		138,
		145,
		137,
		145,
		145,
		142,
		120,
		127,
		143,
		142,
		137,
		172,
		164,
		170,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		160,
		146,
		176,
		166,
		165,
		-1,
		-1,
		190,
		187,
		163,
		147,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		132,
		213,
		206,
		189,
		197,
		228,
		-1,
		163,
		172,
		153,
		158,
		166,
		-1,
		-1,
		163,
		160,
		165,
		154,
		151,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		146,
		189,
		183,
		186,
		210,
		224,
		-1,
		176,
		-1,
		-1,
		161,
		179,
		178,
		168,
		162,
		212,
		168,
		163,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		181,
		169,
		177,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		177,
		-1,
		205,
		-1,
		180,
		184,
		176,
		179,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		255,
		210,
		177,
		168,
		215,
		230,
		234,
		-1,
		189,
		228,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		194,
		189,
		181,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		251,
		249,
		254,
		199,
		182,
		200,
		209,
		230,
		204,
		195,
		222,
		222,
		211,
		206,
		193,
		-1,
		-1,
		217,
		199,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		251,
		250,
		239,
		236,
		212,
		203,
		190,
		201,
		-1,
		-1,
		207,
		223,
		236,
		240,
		253,
		278,
		-1,
		196,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		235,
		232,
		220,
		218,
		241,
		198,
		194,
		-1,
		222,
		210,
		216,
		223,
		240,
		267,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		244,
		258,
		247,
		243,
		242,
		250,
		199,
		212,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		222,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		278,
		-1,
		230,
		223,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		246,
		248,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		243,
		244,
		249,
		-1,
		231,
		-1,
		249,
		-1,
		216,
		222,
		210,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		256,
		247,
		230,
		210,
		202,
		221,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		216,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		328,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		187,
		176,
		187,
		195,
		168,
		175,
		-1,
		196,
		198,
		164,
		158,
		197,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		187,
		186,
		156,
		154,
		163,
		168,
		175,
		-1,
		179,
		-1,
		208,
		187,
		198,
		203,
		149,
		146,
		166,
		185,
		172,
		164,
		223,
		179,
		150,
		144,
		162,
		157,
		166,
		158,
		-1,
		150,
		140,
		162,
		146,
		157,
		149,
		-1,
		-1,
		144,
		145,
		151,
		142,
		148,
		144,
		-1,
		154,
		138,
		-1,
		-1,
		134,
		140,
		124,
		127,
		135,
		133,
		146,
		138,
		133,
		-1,
		-1,
		130,
		126,
		133,
		120,
		116,
		133,
		146,
		128,
		142,
		141,
		-1,
		123,
		141,
		150,
		127,
		125,
		109,
		107,
		125,
		127,
		133,
		136,
		-1,
		116,
		118,
		128,
		136,
		141,
		125,
		112,
		112,
		122,
		115,
		134,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		113,
		115,
		132,
		124,
		114,
		129,
		122,
		115,
		112,
		110,
		107,
		123,
		124,
		134,
		-1,
		-1,
		169,
		138,
		173,
		130,
		115,
		-1,
		109,
		108,
		114,
		118,
		112,
		105,
		119,
		115,
		-1,
		101,
		100,
		131,
		117,
		128,
		129,
		-1,
		-1,
		127,
		119,
		104,
		107,
		104,
		104,
		123,
		122,
		114,
		100,
		96,
		102,
		105,
		105,
		111,
		95,
		105,
		109,
		120,
		135,
		-1,
		-1,
		190,
		-1,
		-1,
		126,
		109,
		-1,
		92,
		99,
		99,
		116,
		106,
		127,
		133,
		124,
		116,
		110,
		98,
		100,
		97,
		110,
		98,
		92,
		117,
		121,
		115,
		136,
		131,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		85,
		88,
		94,
		118,
		128,
		-1,
		101,
		107,
		117,
		111,
		116,
		103,
		91,
		104,
		89,
		96,
		95,
		99,
		101,
		134,
		112,
		134,
		131,
		160,
		165,
		159,
		168,
		-1,
		134,
		130,
		126,
		133,
		82,
		-1,
		-1,
		122,
		-1,
		125,
		118,
		93,
		111,
		114,
		112,
		103,
		98,
		87,
		98,
		87,
		84,
		92,
		101,
		112,
		107,
		106,
		124,
		139,
		152,
		156,
		162,
		-1,
		184,
		-1,
		126,
		110,
		112,
		84,
		105,
		-1,
		142,
		124,
		110,
		95,
		86,
		-1,
		89,
		92,
		116,
		94,
		79,
		96,
		88,
		86,
		91,
		96,
		110,
		101,
		119,
		126,
		134,
		138,
		158,
		170,
		144,
		134,
		-1,
		116,
		121,
		80,
		88,
		107,
		128,
		92,
		-1,
		87,
		-1,
		79,
		104,
		-1,
		100,
		96,
		78,
		79,
		74,
		89,
		95,
		92,
		89,
		107,
		110,
		127,
		131,
		147,
		-1,
		-1,
		129,
		133,
		122,
		73,
		92,
		116,
		138,
		85,
		74,
		73,
		-1,
		64,
		110,
		107,
		93,
		80,
		71,
		72,
		80,
		93,
		72,
		91,
		94,
		116,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		99,
		70,
		94,
		136,
		103,
		96,
		84,
		49,
		49,
		43,
		-1,
		100,
		83,
		80,
		69,
		67,
		80,
		75,
		91,
		95,
		94,
		113,
		125,
		116,
		136,
		-1,
		-1,
		-1,
		129,
		118,
		119,
		65,
		88,
		125,
		82,
		68,
		73,
		48,
		41,
		33,
		103,
		100,
		67,
		76,
		68,
		57,
		71,
		79,
		83,
		92,
		101,
		107,
		131,
		131,
		137,
		-1,
		-1,
		136,
		126,
		110,
		112,
		109,
		79,
		86,
		118,
		73,
		103,
		-1,
		8,
		-1,
		27,
		45,
		53,
		59,
		71,
		57,
		62,
		73,
		85,
		98,
		94,
		101,
		136,
		136,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		129,
		124,
		99,
		76,
		60,
		96,
		-1,
		73,
		74,
		-1,
		0,
		15,
		42,
		50,
		57,
		54,
		54,
		68,
		76,
		72,
		88,
		94,
		86,
		122,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		122,
		101,
		94,
		114,
		55,
		107,
		-1,
		-1,
		58,
		51,
		-1,
		29,
		38,
		45,
		54,
		59,
		64,
		72,
		67,
		80,
		85,
		91,
		96,
		114,
		118,
		122,
		111,
		107,
		104,
		118,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		55,
		75,
		-1,
		67,
		59,
		49,
		43,
		37,
		51,
		49,
		69,
		61,
		75,
		75,
		81,
		89,
		74,
		77,
		93,
		91,
		109,
		117,
		109,
		103,
		102,
		114,
		-1,
		142,
		128,
		99,
		-1,
		-1,
		88,
		-1,
		52,
		66,
		82,
		-1,
		75,
		54,
		69,
		47,
		61,
		57,
		95,
		96,
		74,
		79,
		87,
		97,
		99,
		88,
		99,
		91,
		113,
		113,
		97,
		98,
		107,
		-1,
		148,
		135,
		93,
		89,
		78,
		98,
		49,
		37,
		69,
		-1,
		-1,
		111,
		-1,
		45,
		62,
		71,
		69,
		85,
		76,
		82,
		98,
		101,
		103,
		93,
		82,
		88,
		85,
		107,
		93,
		91,
		110,
		126,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		64,
		51,
		45,
		-1,
		86,
		-1,
		89,
		79,
		63,
		48,
		81,
		-1,
		93,
		77,
		82,
		-1,
		128,
		-1,
		101,
		103,
		97,
		82,
		79,
		90,
		88,
		99,
		116,
		-1,
		98,
		83,
		76,
		66,
		80,
		51,
		-1,
		106,
		-1,
		-1,
		76,
		70,
		70,
		54,
		57,
		109,
		89,
		83,
		82,
		123,
		123,
		109,
		95,
		88,
		85,
		82,
		95,
		115,
		106,
		118,
		-1,
		-1,
		-1,
		103,
		89,
		93,
		53,
		72,
		-1,
		-1,
		138,
		93,
		79,
		-1,
		63,
		126,
		114,
		104,
		94,
		128,
		129,
		114,
		107,
		93,
		95,
		93,
		91,
		96,
		117,
		118,
		131,
		-1,
		-1,
		86,
		91,
		79,
		65,
		84,
		-1,
		-1,
		-1,
		85,
		101,
		93,
		64,
		115,
		-1,
		-1,
		106,
		104,
		114,
		110,
		97,
		117,
		120,
		106,
		90,
		105,
		117,
		125,
		130,
		-1,
		89,
		76,
		-1,
		-1,
		87,
		81,
		-1,
		-1,
		-1,
		-1,
		118,
		84,
		96,
		117,
		142,
		109,
		-1,
		114,
		115,
		101,
		115,
		122,
		108,
		103,
		97,
		100,
		118,
		135,
		-1,
		-1,
		101,
		-1,
		96,
		-1,
		-1,
		-1,
		-1,
		75,
		89,
		110,
		116,
		128,
		-1,
		123,
		117,
		103,
		120,
		121,
		118,
		109,
		101,
		106,
		103,
		116,
		130,
		134,
		124,
		-1,
		107,
		-1,
		-1,
		-1,
		93,
		108,
		170,
		147,
		120,
		124,
		117,
		111,
		111,
		127,
		129,
		140,
		108,
		104,
		105,
		109,
		108,
		125,
		135,
		-1,
		-1,
		107,
		124,
		119,
		101,
		105,
		197,
		-1,
		-1,
		133,
		124,
		115,
		118,
		121,
		124,
		114,
		111,
		116,
		121,
		109,
		118,
		136,
		140,
		-1,
		-1,
		-1,
		127,
		-1,
		142,
		-1,
		-1,
		120,
		204,
		151,
		133,
		129,
		127,
		120,
		129,
		124,
		119,
		129,
		138,
		130,
		111,
		122,
		145,
		134,
		172,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		156,
		131,
		146,
		192,
		140,
		147,
		166,
		163,
		-1,
		133,
		158,
		130,
		137,
		129,
		137,
		137,
		134,
		112,
		119,
		135,
		134,
		129,
		164,
		156,
		162,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		162,
		148,
		178,
		168,
		157,
		-1,
		-1,
		182,
		179,
		155,
		139,
		143,
		136,
		131,
		141,
		121,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		153,
		168,
		-1,
		134,
		215,
		208,
		191,
		199,
		230,
		-1,
		165,
		174,
		155,
		160,
		168,
		-1,
		-1,
		155,
		152,
		157,
		146,
		143,
		151,
		146,
		137,
		122,
		128,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		148,
		191,
		185,
		188,
		212,
		226,
		-1,
		178,
		-1,
		-1,
		163,
		181,
		170,
		160,
		154,
		204,
		160,
		155,
		145,
		143,
		134,
		125,
		132,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		183,
		171,
		179,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		179,
		-1,
		197,
		-1,
		172,
		176,
		168,
		171,
		159,
		146,
		138,
		130,
		146,
		121,
		131,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		257,
		212,
		179,
		170,
		217,
		232,
		236,
		-1,
		191,
		230,
		217,
		-1,
		188,
		-1,
		-1,
		-1,
		186,
		181,
		173,
		179,
		158,
		158,
		132,
		136,
		126,
		133,
		143,
		145,
		137,
		141,
		154,
		165,
		168,
		253,
		251,
		256,
		201,
		184,
		202,
		211,
		232,
		206,
		197,
		224,
		224,
		213,
		208,
		195,
		-1,
		-1,
		209,
		191,
		-1,
		-1,
		165,
		153,
		136,
		137,
		133,
		136,
		151,
		154,
		144,
		142,
		136,
		168,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		192,
		203,
		-1,
		-1,
		209,
		225,
		238,
		242,
		255,
		280,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		195,
		158,
		147,
		138,
		144,
		141,
		152,
		162,
		150,
		151,
		141,
		151,
		164,
		237,
		234,
		222,
		220,
		243,
		200,
		196,
		-1,
		219,
		212,
		218,
		225,
		242,
		269,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		193,
		191,
		180,
		-1,
		170,
		143,
		148,
		168,
		170,
		159,
		153,
		147,
		154,
		153,
		161,
		169,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		204,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		224,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		161,
		165,
		157,
		150,
		145,
		156,
		148,
		152,
		169,
		-1,
		280,
		-1,
		232,
		218,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		201,
		169,
		174,
		169,
		151,
		162,
		151,
		154,
		168,
		163,
		-1,
		-1,
		230,
		233,
		-1,
		-1,
		238,
		240,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		158,
		183,
		172,
		180,
		175,
		155,
		161,
		164,
		153,
		157,
		169,
		-1,
		-1,
		237,
		238,
		243,
		-1,
		223,
		-1,
		241,
		-1,
		208,
		214,
		202,
		-1,
		-1,
		-1,
		196,
		159,
		180,
		190,
		184,
		182,
		173,
		159,
		166,
		164,
		160,
		171,
		-1,
		-1,
		-1,
		241,
		215,
		248,
		239,
		222,
		202,
		194,
		213,
		-1,
		183,
		-1,
		158,
		160,
		186,
		189,
		195,
		189,
		162,
		177,
		167,
		158,
		167,
		247,
		-1,
		217,
		250,
		214,
		208,
		184,
		188,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		211,
		196,
		177,
		164,
		171,
		171,
		164,
		-1,
		-1,
		-1,
		219,
		218,
		210,
		204,
		204,
		189,
		180,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		201,
		197,
		184,
		184,
		176,
		-1,
		320,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		213,
		208,
		181,
		169,
		175,
		171,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		177,
		212,
		-1,
		315,
		-1,
		249,
		-1,
		-1,
		231,
		211,
		203,
		192,
		181,
		179,
		170,
		161,
		183,
		199,
		183,
		181,
		184,
		185,
		-1,
		304,
		303,
		-1,
		250,
		242,
		228,
		-1,
		221,
		-1,
		227,
		188,
		-1,
		190,
		170,
		-1,
		192,
		188,
		-1,
		-1,
		291,
		266,
		-1,
		-1,
		-1,
		251,
		231,
		222,
		206,
		-1,
		181,
		181,
		-1,
		-1,
		-1,
		276,
		275,
		-1,
		244,
		247,
		-1,
		237,
		228,
		236,
		183,
		187,
		-1,
		-1,
		-1,
		285,
		266,
		260,
		259,
		257,
		252,
		249,
		235,
		219,
		197,
		186,
		207,
		-1,
		-1,
		-1,
		257,
		249,
		242,
		-1,
		-1,
		244,
		227,
		208,
		206,
		-1,
		-1,
		-1,
		279,
		260,
		-1,
		-1,
		234,
		-1,
		-1,
		240,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		268,
		-1,
		-1,
		-1,
		230,
		226,
		227,
		-1,
		-1,
		-1,
		-1,
		290,
		291,
		314,
		278,
		-1,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		293,
		291,
		-1,
		-1,
		-1,
		250,
		234,
		-1,
		220,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		255,
		-1,
		255,
		230,
		237,
		-1,
		-1,
		-1,
		-1,
		268,
		260,
		268,
		-1,
		240,
		242,
		-1,
		290,
		-1,
		-1,
		283,
		274,
		-1,
		-1,
		245,
		252,
		274,
		277,
		313,
		-1,
		264
	],
	[
		-1,
		177,
		166,
		177,
		185,
		158,
		165,
		-1,
		186,
		188,
		154,
		148,
		187,
		158,
		164,
		175,
		-1,
		-1,
		-1,
		177,
		176,
		146,
		144,
		153,
		158,
		165,
		-1,
		169,
		-1,
		198,
		177,
		188,
		193,
		139,
		136,
		156,
		175,
		162,
		154,
		213,
		169,
		140,
		134,
		152,
		147,
		156,
		148,
		-1,
		140,
		130,
		152,
		136,
		147,
		139,
		-1,
		-1,
		134,
		135,
		141,
		132,
		138,
		134,
		-1,
		144,
		128,
		-1,
		-1,
		124,
		130,
		114,
		117,
		125,
		123,
		136,
		128,
		123,
		-1,
		-1,
		120,
		116,
		123,
		110,
		106,
		123,
		136,
		118,
		132,
		131,
		-1,
		113,
		131,
		140,
		117,
		115,
		99,
		97,
		115,
		117,
		123,
		126,
		-1,
		106,
		108,
		118,
		126,
		131,
		115,
		102,
		102,
		112,
		105,
		124,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		105,
		122,
		114,
		104,
		119,
		112,
		105,
		102,
		100,
		97,
		113,
		114,
		124,
		-1,
		-1,
		159,
		128,
		163,
		120,
		105,
		-1,
		99,
		98,
		104,
		108,
		102,
		95,
		109,
		105,
		-1,
		91,
		90,
		121,
		107,
		118,
		119,
		-1,
		-1,
		117,
		109,
		94,
		97,
		94,
		94,
		113,
		112,
		104,
		90,
		86,
		92,
		95,
		95,
		101,
		85,
		95,
		99,
		110,
		125,
		-1,
		-1,
		180,
		-1,
		-1,
		116,
		99,
		-1,
		82,
		89,
		89,
		106,
		96,
		117,
		123,
		114,
		106,
		100,
		88,
		90,
		87,
		100,
		88,
		82,
		107,
		111,
		105,
		126,
		121,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		75,
		78,
		84,
		108,
		118,
		-1,
		91,
		97,
		107,
		101,
		106,
		93,
		81,
		94,
		79,
		86,
		85,
		89,
		91,
		124,
		102,
		124,
		121,
		150,
		155,
		149,
		158,
		-1,
		124,
		120,
		116,
		123,
		72,
		-1,
		-1,
		112,
		-1,
		115,
		108,
		83,
		101,
		104,
		102,
		93,
		88,
		77,
		88,
		77,
		74,
		82,
		91,
		102,
		97,
		96,
		114,
		129,
		142,
		146,
		152,
		-1,
		174,
		-1,
		116,
		100,
		102,
		74,
		95,
		-1,
		132,
		114,
		100,
		85,
		76,
		-1,
		79,
		82,
		106,
		84,
		69,
		86,
		78,
		76,
		81,
		86,
		100,
		91,
		109,
		116,
		124,
		128,
		148,
		160,
		134,
		124,
		-1,
		106,
		111,
		70,
		78,
		97,
		118,
		82,
		-1,
		77,
		-1,
		69,
		94,
		-1,
		90,
		86,
		68,
		69,
		64,
		79,
		85,
		82,
		79,
		97,
		100,
		117,
		121,
		137,
		-1,
		-1,
		119,
		123,
		112,
		63,
		82,
		106,
		128,
		75,
		64,
		63,
		-1,
		54,
		100,
		97,
		83,
		70,
		61,
		62,
		70,
		83,
		62,
		81,
		84,
		106,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		89,
		60,
		84,
		126,
		93,
		86,
		74,
		39,
		39,
		33,
		-1,
		90,
		73,
		70,
		59,
		57,
		70,
		65,
		81,
		85,
		84,
		103,
		115,
		106,
		126,
		-1,
		-1,
		-1,
		119,
		108,
		109,
		55,
		78,
		115,
		72,
		58,
		63,
		38,
		31,
		23,
		93,
		90,
		57,
		66,
		58,
		47,
		61,
		69,
		73,
		82,
		91,
		97,
		121,
		121,
		127,
		-1,
		-1,
		126,
		116,
		100,
		102,
		99,
		69,
		76,
		108,
		63,
		93,
		-1,
		19,
		-1,
		17,
		35,
		43,
		49,
		61,
		47,
		52,
		63,
		75,
		88,
		84,
		91,
		126,
		126,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		119,
		114,
		89,
		66,
		50,
		86,
		-1,
		63,
		64,
		-1,
		13,
		0,
		32,
		40,
		47,
		44,
		44,
		58,
		66,
		62,
		78,
		84,
		76,
		112,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		112,
		91,
		84,
		104,
		45,
		97,
		-1,
		-1,
		48,
		41,
		-1,
		19,
		28,
		35,
		44,
		49,
		54,
		62,
		57,
		70,
		75,
		81,
		86,
		104,
		108,
		112,
		101,
		97,
		94,
		108,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		65,
		-1,
		57,
		49,
		39,
		33,
		27,
		41,
		39,
		59,
		51,
		65,
		65,
		71,
		79,
		64,
		67,
		83,
		81,
		99,
		107,
		99,
		93,
		92,
		104,
		-1,
		132,
		118,
		89,
		-1,
		-1,
		78,
		-1,
		42,
		56,
		72,
		-1,
		65,
		44,
		59,
		37,
		51,
		47,
		85,
		86,
		64,
		69,
		77,
		87,
		89,
		78,
		89,
		81,
		103,
		103,
		87,
		88,
		97,
		-1,
		138,
		125,
		83,
		79,
		68,
		88,
		39,
		27,
		59,
		-1,
		-1,
		101,
		-1,
		35,
		52,
		61,
		59,
		75,
		66,
		72,
		88,
		91,
		93,
		83,
		72,
		78,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		54,
		41,
		35,
		-1,
		76,
		-1,
		79,
		69,
		53,
		38,
		71,
		-1,
		83,
		67,
		72,
		-1,
		118,
		-1,
		91,
		93,
		87,
		72,
		69,
		80,
		78,
		89,
		106,
		-1,
		88,
		73,
		66,
		56,
		70,
		41,
		-1,
		96,
		-1,
		-1,
		66,
		60,
		60,
		44,
		47,
		99,
		79,
		73,
		72,
		113,
		113,
		99,
		85,
		78,
		75,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		93,
		79,
		83,
		43,
		62,
		-1,
		-1,
		128,
		83,
		69,
		-1,
		53,
		116,
		104,
		94,
		84,
		118,
		119,
		104,
		97,
		83,
		85,
		83,
		81,
		86,
		107,
		108,
		121,
		-1,
		-1,
		76,
		81,
		69,
		55,
		74,
		-1,
		-1,
		-1,
		75,
		91,
		83,
		54,
		105,
		-1,
		-1,
		96,
		94,
		104,
		100,
		87,
		107,
		110,
		96,
		80,
		95,
		107,
		115,
		120,
		-1,
		79,
		66,
		-1,
		-1,
		77,
		71,
		-1,
		-1,
		-1,
		-1,
		108,
		74,
		86,
		107,
		132,
		99,
		-1,
		104,
		105,
		91,
		105,
		112,
		98,
		93,
		87,
		90,
		108,
		125,
		-1,
		-1,
		91,
		-1,
		86,
		-1,
		-1,
		-1,
		-1,
		65,
		79,
		100,
		106,
		118,
		-1,
		113,
		107,
		93,
		110,
		111,
		108,
		99,
		91,
		96,
		93,
		106,
		120,
		124,
		114,
		-1,
		97,
		-1,
		-1,
		-1,
		83,
		98,
		160,
		137,
		110,
		114,
		107,
		101,
		101,
		117,
		119,
		130,
		98,
		94,
		95,
		99,
		98,
		115,
		125,
		-1,
		-1,
		97,
		114,
		109,
		91,
		95,
		187,
		-1,
		-1,
		123,
		114,
		105,
		108,
		111,
		114,
		104,
		101,
		106,
		111,
		99,
		108,
		126,
		130,
		-1,
		-1,
		-1,
		117,
		-1,
		132,
		-1,
		-1,
		110,
		194,
		141,
		123,
		119,
		117,
		110,
		119,
		114,
		109,
		119,
		128,
		120,
		101,
		112,
		135,
		124,
		162,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		146,
		121,
		136,
		182,
		130,
		137,
		156,
		153,
		-1,
		123,
		148,
		120,
		127,
		119,
		127,
		127,
		124,
		102,
		109,
		125,
		124,
		119,
		154,
		146,
		152,
		-1,
		-1,
		229,
		218,
		207,
		213,
		-1,
		152,
		138,
		168,
		158,
		147,
		-1,
		-1,
		172,
		169,
		145,
		129,
		133,
		126,
		121,
		131,
		111,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		124,
		205,
		198,
		181,
		189,
		220,
		-1,
		155,
		164,
		145,
		150,
		158,
		-1,
		-1,
		145,
		142,
		147,
		136,
		133,
		141,
		136,
		127,
		112,
		118,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		138,
		181,
		175,
		178,
		202,
		216,
		-1,
		168,
		-1,
		-1,
		153,
		171,
		160,
		150,
		144,
		194,
		150,
		145,
		135,
		133,
		124,
		115,
		122,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		173,
		161,
		169,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		169,
		-1,
		187,
		-1,
		162,
		166,
		158,
		161,
		149,
		136,
		128,
		120,
		136,
		111,
		121,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		247,
		202,
		169,
		160,
		207,
		222,
		226,
		-1,
		181,
		220,
		207,
		-1,
		178,
		-1,
		-1,
		-1,
		176,
		171,
		163,
		169,
		148,
		148,
		122,
		126,
		116,
		123,
		133,
		135,
		127,
		131,
		144,
		155,
		158,
		243,
		241,
		246,
		191,
		174,
		192,
		201,
		222,
		196,
		187,
		214,
		214,
		203,
		198,
		185,
		-1,
		-1,
		199,
		181,
		-1,
		-1,
		155,
		143,
		126,
		127,
		123,
		126,
		141,
		144,
		134,
		132,
		126,
		158,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		182,
		193,
		-1,
		-1,
		199,
		215,
		228,
		232,
		245,
		270,
		-1,
		188,
		-1,
		-1,
		200,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		131,
		142,
		152,
		140,
		141,
		131,
		141,
		154,
		227,
		224,
		212,
		210,
		233,
		190,
		186,
		-1,
		209,
		202,
		208,
		215,
		232,
		259,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		183,
		181,
		170,
		-1,
		160,
		133,
		138,
		158,
		160,
		149,
		143,
		137,
		144,
		143,
		151,
		159,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		194,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		-1,
		221,
		214,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		151,
		155,
		147,
		140,
		135,
		146,
		138,
		142,
		159,
		-1,
		270,
		-1,
		222,
		208,
		222,
		237,
		245,
		-1,
		-1,
		-1,
		238,
		224,
		217,
		205,
		203,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		141,
		152,
		141,
		144,
		158,
		153,
		-1,
		-1,
		220,
		223,
		-1,
		-1,
		228,
		230,
		-1,
		229,
		218,
		203,
		195,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		145,
		151,
		154,
		143,
		147,
		159,
		-1,
		-1,
		227,
		228,
		233,
		-1,
		213,
		-1,
		231,
		-1,
		198,
		204,
		192,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		174,
		172,
		163,
		149,
		156,
		154,
		150,
		161,
		-1,
		-1,
		-1,
		231,
		205,
		238,
		229,
		212,
		192,
		184,
		203,
		-1,
		173,
		-1,
		148,
		150,
		176,
		179,
		185,
		179,
		152,
		167,
		157,
		148,
		157,
		237,
		-1,
		207,
		240,
		204,
		198,
		174,
		178,
		194,
		-1,
		170,
		152,
		-1,
		180,
		170,
		201,
		186,
		167,
		154,
		161,
		161,
		154,
		-1,
		-1,
		-1,
		209,
		208,
		200,
		194,
		194,
		179,
		170,
		-1,
		182,
		164,
		143,
		160,
		160,
		151,
		159,
		191,
		187,
		174,
		174,
		166,
		-1,
		310,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		203,
		198,
		171,
		159,
		165,
		161,
		147,
		153,
		155,
		163,
		161,
		158,
		170,
		166,
		186,
		167,
		202,
		-1,
		305,
		-1,
		239,
		-1,
		-1,
		221,
		201,
		193,
		182,
		171,
		169,
		160,
		151,
		173,
		189,
		173,
		171,
		174,
		175,
		-1,
		294,
		293,
		-1,
		240,
		232,
		218,
		-1,
		211,
		-1,
		217,
		178,
		-1,
		180,
		160,
		-1,
		182,
		178,
		-1,
		-1,
		281,
		256,
		-1,
		-1,
		-1,
		241,
		221,
		212,
		196,
		-1,
		171,
		171,
		-1,
		-1,
		-1,
		266,
		265,
		-1,
		234,
		237,
		-1,
		227,
		218,
		226,
		173,
		177,
		-1,
		-1,
		-1,
		275,
		256,
		250,
		249,
		247,
		242,
		239,
		225,
		209,
		187,
		176,
		197,
		-1,
		-1,
		-1,
		247,
		239,
		232,
		-1,
		-1,
		234,
		217,
		198,
		196,
		-1,
		-1,
		-1,
		269,
		250,
		-1,
		-1,
		224,
		-1,
		-1,
		230,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		258,
		-1,
		-1,
		-1,
		220,
		216,
		217,
		-1,
		-1,
		-1,
		-1,
		280,
		281,
		304,
		268,
		-1,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		283,
		281,
		-1,
		-1,
		-1,
		240,
		224,
		-1,
		210,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		245,
		-1,
		245,
		220,
		227,
		-1,
		-1,
		-1,
		-1,
		258,
		250,
		258,
		-1,
		230,
		232,
		-1,
		280,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		235,
		242,
		264,
		267,
		303,
		-1,
		254
	],
	[
		-1,
		174,
		163,
		174,
		182,
		155,
		162,
		-1,
		183,
		185,
		151,
		145,
		184,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		174,
		173,
		143,
		141,
		150,
		155,
		162,
		-1,
		166,
		-1,
		195,
		174,
		185,
		190,
		136,
		133,
		153,
		172,
		159,
		151,
		210,
		166,
		137,
		131,
		149,
		144,
		153,
		145,
		-1,
		137,
		127,
		149,
		133,
		144,
		136,
		-1,
		-1,
		131,
		132,
		138,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		121,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		128,
		-1,
		110,
		128,
		137,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		123,
		-1,
		107,
		109,
		115,
		123,
		128,
		112,
		99,
		99,
		109,
		102,
		121,
		112,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		104,
		102,
		119,
		111,
		101,
		116,
		109,
		102,
		99,
		97,
		94,
		110,
		111,
		121,
		-1,
		-1,
		160,
		129,
		164,
		121,
		106,
		-1,
		100,
		95,
		101,
		105,
		99,
		92,
		106,
		102,
		-1,
		88,
		87,
		118,
		104,
		115,
		120,
		-1,
		-1,
		118,
		110,
		95,
		98,
		95,
		95,
		110,
		109,
		101,
		87,
		83,
		89,
		92,
		92,
		98,
		82,
		92,
		96,
		107,
		122,
		-1,
		-1,
		177,
		-1,
		-1,
		117,
		100,
		-1,
		83,
		90,
		90,
		107,
		97,
		118,
		120,
		111,
		103,
		97,
		85,
		87,
		84,
		97,
		85,
		79,
		104,
		108,
		102,
		123,
		118,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		76,
		79,
		85,
		109,
		119,
		-1,
		102,
		108,
		118,
		106,
		103,
		90,
		78,
		91,
		76,
		83,
		82,
		86,
		88,
		121,
		99,
		121,
		118,
		147,
		152,
		146,
		155,
		-1,
		125,
		121,
		117,
		124,
		73,
		-1,
		-1,
		113,
		-1,
		126,
		119,
		94,
		112,
		115,
		107,
		98,
		85,
		74,
		85,
		74,
		71,
		79,
		88,
		99,
		94,
		93,
		111,
		126,
		139,
		143,
		149,
		-1,
		175,
		-1,
		117,
		101,
		103,
		75,
		96,
		-1,
		133,
		125,
		111,
		96,
		87,
		-1,
		90,
		93,
		103,
		81,
		66,
		83,
		75,
		73,
		78,
		83,
		97,
		88,
		106,
		113,
		121,
		125,
		145,
		157,
		135,
		125,
		-1,
		107,
		112,
		71,
		79,
		98,
		129,
		93,
		-1,
		88,
		-1,
		80,
		105,
		-1,
		87,
		75,
		61,
		66,
		61,
		76,
		82,
		79,
		76,
		94,
		97,
		114,
		118,
		134,
		-1,
		-1,
		120,
		124,
		113,
		64,
		83,
		107,
		139,
		86,
		75,
		74,
		-1,
		65,
		71,
		68,
		54,
		41,
		58,
		59,
		67,
		80,
		59,
		78,
		81,
		103,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		90,
		61,
		85,
		127,
		104,
		97,
		85,
		50,
		50,
		44,
		-1,
		61,
		44,
		46,
		56,
		54,
		67,
		62,
		78,
		82,
		81,
		100,
		112,
		103,
		123,
		-1,
		-1,
		-1,
		120,
		109,
		110,
		56,
		79,
		116,
		83,
		69,
		74,
		49,
		42,
		34,
		64,
		61,
		28,
		50,
		52,
		44,
		58,
		66,
		70,
		79,
		88,
		94,
		118,
		118,
		124,
		-1,
		-1,
		127,
		117,
		101,
		103,
		100,
		70,
		77,
		109,
		74,
		94,
		-1,
		39,
		-1,
		28,
		6,
		24,
		30,
		42,
		44,
		49,
		60,
		72,
		85,
		81,
		88,
		123,
		123,
		108,
		128,
		131,
		-1,
		-1,
		-1,
		120,
		115,
		90,
		67,
		51,
		87,
		-1,
		64,
		65,
		-1,
		33,
		27,
		0,
		19,
		28,
		41,
		41,
		55,
		63,
		59,
		75,
		81,
		73,
		109,
		-1,
		116,
		110,
		118,
		108,
		96,
		-1,
		-1,
		-1,
		113,
		92,
		85,
		105,
		46,
		98,
		-1,
		-1,
		49,
		42,
		-1,
		11,
		25,
		29,
		38,
		46,
		51,
		59,
		54,
		67,
		72,
		78,
		83,
		101,
		105,
		109,
		98,
		94,
		91,
		105,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		46,
		66,
		-1,
		58,
		50,
		40,
		34,
		28,
		30,
		28,
		52,
		44,
		62,
		62,
		68,
		76,
		61,
		64,
		80,
		78,
		96,
		104,
		96,
		90,
		89,
		101,
		-1,
		133,
		119,
		90,
		-1,
		-1,
		79,
		-1,
		43,
		57,
		73,
		-1,
		66,
		45,
		56,
		38,
		40,
		40,
		82,
		83,
		61,
		66,
		74,
		84,
		86,
		75,
		86,
		78,
		100,
		100,
		84,
		85,
		94,
		-1,
		139,
		126,
		84,
		80,
		69,
		89,
		40,
		28,
		60,
		-1,
		-1,
		102,
		-1,
		36,
		53,
		54,
		52,
		72,
		63,
		69,
		85,
		88,
		90,
		80,
		69,
		75,
		72,
		94,
		80,
		78,
		97,
		113,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		55,
		42,
		36,
		-1,
		77,
		-1,
		80,
		70,
		54,
		39,
		72,
		-1,
		80,
		64,
		69,
		-1,
		115,
		-1,
		88,
		90,
		84,
		69,
		66,
		77,
		75,
		86,
		103,
		-1,
		89,
		74,
		67,
		57,
		71,
		42,
		-1,
		97,
		-1,
		-1,
		67,
		61,
		61,
		45,
		48,
		96,
		76,
		70,
		69,
		110,
		110,
		96,
		82,
		75,
		72,
		69,
		82,
		102,
		93,
		105,
		-1,
		-1,
		-1,
		94,
		80,
		84,
		44,
		63,
		-1,
		-1,
		129,
		84,
		70,
		-1,
		54,
		113,
		101,
		91,
		81,
		115,
		116,
		101,
		94,
		80,
		82,
		80,
		78,
		83,
		104,
		105,
		118,
		-1,
		-1,
		77,
		82,
		70,
		56,
		75,
		-1,
		-1,
		-1,
		76,
		92,
		84,
		55,
		102,
		-1,
		-1,
		93,
		91,
		101,
		97,
		84,
		104,
		107,
		93,
		77,
		92,
		104,
		112,
		117,
		-1,
		80,
		67,
		-1,
		-1,
		78,
		72,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		87,
		108,
		133,
		96,
		-1,
		101,
		102,
		88,
		102,
		109,
		95,
		90,
		84,
		87,
		105,
		122,
		-1,
		-1,
		92,
		-1,
		87,
		-1,
		-1,
		-1,
		-1,
		66,
		80,
		101,
		107,
		119,
		-1,
		110,
		104,
		90,
		107,
		108,
		105,
		96,
		88,
		93,
		90,
		103,
		117,
		121,
		115,
		-1,
		98,
		-1,
		-1,
		-1,
		84,
		99,
		161,
		138,
		111,
		111,
		104,
		98,
		98,
		114,
		116,
		127,
		95,
		91,
		92,
		96,
		95,
		112,
		122,
		-1,
		-1,
		98,
		115,
		110,
		92,
		96,
		188,
		-1,
		-1,
		120,
		111,
		102,
		105,
		108,
		111,
		101,
		98,
		103,
		108,
		96,
		105,
		123,
		127,
		-1,
		-1,
		-1,
		118,
		-1,
		133,
		-1,
		-1,
		111,
		191,
		138,
		120,
		116,
		114,
		107,
		116,
		111,
		106,
		116,
		125,
		117,
		98,
		109,
		132,
		121,
		159,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		147,
		122,
		137,
		183,
		131,
		138,
		153,
		150,
		-1,
		120,
		145,
		117,
		124,
		116,
		124,
		124,
		121,
		99,
		106,
		122,
		121,
		116,
		151,
		143,
		149,
		-1,
		-1,
		230,
		219,
		208,
		214,
		-1,
		153,
		139,
		169,
		159,
		148,
		-1,
		-1,
		169,
		166,
		142,
		126,
		130,
		123,
		118,
		128,
		108,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		140,
		155,
		-1,
		125,
		206,
		199,
		182,
		190,
		221,
		-1,
		156,
		165,
		146,
		151,
		159,
		-1,
		-1,
		142,
		139,
		144,
		133,
		130,
		138,
		133,
		124,
		109,
		115,
		102,
		101,
		119,
		123,
		132,
		139,
		129,
		142,
		146,
		-1,
		139,
		182,
		176,
		179,
		203,
		217,
		-1,
		169,
		-1,
		-1,
		154,
		172,
		157,
		147,
		141,
		191,
		147,
		142,
		132,
		130,
		121,
		112,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		139,
		139,
		140,
		-1,
		174,
		162,
		170,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		170,
		-1,
		184,
		-1,
		159,
		163,
		155,
		158,
		146,
		133,
		125,
		117,
		133,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		146,
		147,
		248,
		203,
		170,
		161,
		208,
		223,
		227,
		-1,
		182,
		221,
		208,
		-1,
		179,
		-1,
		-1,
		-1,
		173,
		168,
		160,
		166,
		145,
		145,
		119,
		123,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		155,
		244,
		242,
		247,
		192,
		175,
		193,
		202,
		223,
		197,
		188,
		215,
		215,
		204,
		199,
		186,
		-1,
		-1,
		196,
		178,
		-1,
		-1,
		152,
		140,
		123,
		124,
		120,
		123,
		138,
		141,
		131,
		129,
		123,
		155,
		-1,
		244,
		243,
		232,
		229,
		205,
		196,
		183,
		194,
		-1,
		-1,
		200,
		216,
		229,
		233,
		246,
		271,
		-1,
		189,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		128,
		139,
		149,
		137,
		138,
		128,
		138,
		151,
		228,
		225,
		213,
		211,
		234,
		191,
		187,
		-1,
		206,
		203,
		209,
		216,
		233,
		260,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		130,
		135,
		155,
		157,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		237,
		251,
		240,
		236,
		235,
		243,
		192,
		191,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		218,
		214,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		148,
		152,
		144,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		271,
		-1,
		223,
		205,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		235,
		221,
		214,
		202,
		200,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		225,
		227,
		-1,
		226,
		215,
		200,
		192,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		210,
		-1,
		228,
		-1,
		195,
		201,
		189,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		171,
		169,
		160,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		228,
		202,
		235,
		226,
		209,
		189,
		181,
		200,
		-1,
		170,
		-1,
		145,
		147,
		173,
		176,
		182,
		176,
		149,
		164,
		154,
		145,
		154,
		234,
		-1,
		204,
		237,
		201,
		195,
		171,
		175,
		191,
		-1,
		167,
		149,
		-1,
		177,
		167,
		198,
		183,
		164,
		151,
		158,
		158,
		151,
		-1,
		-1,
		-1,
		206,
		205,
		197,
		191,
		191,
		176,
		167,
		-1,
		179,
		161,
		140,
		157,
		157,
		148,
		156,
		188,
		184,
		171,
		171,
		163,
		-1,
		307,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		200,
		195,
		168,
		156,
		162,
		158,
		144,
		150,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		164,
		199,
		-1,
		302,
		-1,
		236,
		-1,
		-1,
		218,
		198,
		190,
		179,
		168,
		166,
		157,
		148,
		170,
		186,
		170,
		168,
		171,
		172,
		-1,
		291,
		290,
		-1,
		237,
		229,
		215,
		-1,
		208,
		-1,
		214,
		175,
		-1,
		177,
		157,
		-1,
		179,
		175,
		-1,
		-1,
		278,
		253,
		-1,
		-1,
		-1,
		238,
		218,
		209,
		193,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		263,
		262,
		-1,
		231,
		234,
		-1,
		224,
		215,
		223,
		170,
		174,
		-1,
		-1,
		-1,
		272,
		253,
		247,
		246,
		244,
		239,
		236,
		222,
		206,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		244,
		236,
		229,
		-1,
		-1,
		231,
		214,
		195,
		193,
		-1,
		-1,
		-1,
		266,
		247,
		-1,
		-1,
		221,
		-1,
		-1,
		227,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		255,
		-1,
		-1,
		-1,
		217,
		213,
		214,
		-1,
		-1,
		-1,
		-1,
		277,
		278,
		301,
		265,
		-1,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		280,
		278,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		207,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		242,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		255,
		247,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		270,
		261,
		-1,
		-1,
		232,
		239,
		261,
		264,
		300,
		-1,
		251
	],
	[
		-1,
		158,
		147,
		158,
		166,
		139,
		146,
		-1,
		167,
		169,
		135,
		129,
		168,
		139,
		145,
		156,
		-1,
		-1,
		-1,
		158,
		157,
		127,
		125,
		134,
		139,
		146,
		-1,
		150,
		-1,
		179,
		158,
		169,
		174,
		120,
		117,
		137,
		156,
		143,
		135,
		194,
		150,
		121,
		115,
		133,
		128,
		137,
		129,
		-1,
		121,
		111,
		133,
		117,
		128,
		120,
		-1,
		-1,
		115,
		116,
		122,
		113,
		119,
		115,
		-1,
		125,
		109,
		-1,
		-1,
		105,
		111,
		95,
		98,
		106,
		104,
		117,
		109,
		104,
		-1,
		-1,
		101,
		97,
		104,
		91,
		87,
		104,
		117,
		99,
		113,
		112,
		-1,
		94,
		112,
		121,
		98,
		96,
		80,
		78,
		96,
		98,
		104,
		107,
		-1,
		103,
		104,
		99,
		107,
		112,
		96,
		83,
		83,
		93,
		86,
		105,
		96,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		103,
		86,
		103,
		95,
		85,
		100,
		93,
		86,
		83,
		81,
		78,
		94,
		95,
		105,
		-1,
		-1,
		161,
		130,
		165,
		122,
		107,
		-1,
		99,
		79,
		85,
		89,
		83,
		76,
		90,
		86,
		-1,
		72,
		71,
		102,
		88,
		99,
		121,
		-1,
		-1,
		119,
		111,
		96,
		99,
		96,
		96,
		94,
		93,
		85,
		71,
		67,
		73,
		76,
		76,
		82,
		66,
		76,
		80,
		91,
		106,
		-1,
		-1,
		161,
		-1,
		-1,
		118,
		101,
		-1,
		84,
		91,
		91,
		108,
		98,
		119,
		104,
		95,
		87,
		81,
		69,
		71,
		68,
		81,
		69,
		63,
		88,
		92,
		86,
		107,
		102,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		77,
		80,
		86,
		110,
		120,
		-1,
		110,
		104,
		105,
		90,
		87,
		74,
		62,
		75,
		60,
		67,
		66,
		70,
		72,
		105,
		83,
		105,
		102,
		131,
		136,
		130,
		139,
		-1,
		126,
		122,
		118,
		125,
		74,
		-1,
		-1,
		114,
		-1,
		128,
		127,
		102,
		101,
		104,
		91,
		82,
		69,
		58,
		69,
		58,
		55,
		63,
		72,
		83,
		78,
		77,
		95,
		110,
		123,
		127,
		133,
		-1,
		176,
		-1,
		118,
		102,
		104,
		76,
		97,
		-1,
		134,
		129,
		119,
		104,
		95,
		-1,
		98,
		97,
		87,
		65,
		50,
		67,
		59,
		57,
		62,
		67,
		81,
		72,
		90,
		97,
		105,
		109,
		129,
		141,
		136,
		126,
		-1,
		108,
		113,
		72,
		80,
		99,
		137,
		101,
		-1,
		96,
		-1,
		88,
		113,
		-1,
		71,
		67,
		49,
		50,
		45,
		60,
		66,
		63,
		60,
		78,
		81,
		98,
		102,
		118,
		-1,
		-1,
		121,
		125,
		114,
		65,
		84,
		108,
		145,
		94,
		83,
		82,
		-1,
		73,
		63,
		60,
		46,
		33,
		42,
		43,
		51,
		64,
		43,
		62,
		65,
		87,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		91,
		62,
		86,
		128,
		112,
		105,
		93,
		58,
		58,
		52,
		-1,
		53,
		36,
		38,
		40,
		38,
		51,
		48,
		62,
		66,
		65,
		84,
		96,
		87,
		107,
		-1,
		-1,
		-1,
		121,
		110,
		111,
		57,
		80,
		117,
		91,
		77,
		82,
		57,
		50,
		44,
		56,
		53,
		20,
		42,
		33,
		28,
		44,
		52,
		54,
		63,
		72,
		78,
		102,
		105,
		111,
		-1,
		-1,
		128,
		118,
		102,
		104,
		101,
		71,
		78,
		110,
		82,
		95,
		-1,
		49,
		-1,
		38,
		14,
		5,
		11,
		23,
		31,
		35,
		44,
		58,
		69,
		65,
		72,
		107,
		107,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		121,
		116,
		91,
		68,
		52,
		88,
		-1,
		65,
		66,
		-1,
		43,
		37,
		18,
		0,
		9,
		26,
		27,
		42,
		49,
		45,
		59,
		68,
		57,
		93,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		114,
		93,
		86,
		106,
		47,
		99,
		-1,
		-1,
		50,
		43,
		-1,
		29,
		12,
		19,
		27,
		33,
		38,
		46,
		41,
		54,
		59,
		62,
		70,
		88,
		92,
		96,
		85,
		81,
		78,
		92,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		47,
		67,
		-1,
		59,
		51,
		41,
		35,
		29,
		25,
		23,
		43,
		35,
		49,
		49,
		55,
		63,
		48,
		51,
		65,
		65,
		83,
		91,
		83,
		77,
		76,
		88,
		-1,
		134,
		120,
		91,
		-1,
		-1,
		80,
		-1,
		44,
		58,
		74,
		-1,
		67,
		46,
		61,
		39,
		35,
		31,
		69,
		70,
		48,
		53,
		61,
		71,
		73,
		62,
		73,
		65,
		87,
		87,
		71,
		72,
		81,
		-1,
		140,
		127,
		85,
		81,
		70,
		90,
		41,
		29,
		61,
		-1,
		-1,
		103,
		-1,
		37,
		54,
		45,
		43,
		59,
		50,
		56,
		72,
		75,
		77,
		67,
		56,
		62,
		59,
		81,
		67,
		65,
		84,
		100,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		56,
		43,
		37,
		-1,
		78,
		-1,
		81,
		71,
		55,
		40,
		73,
		-1,
		67,
		51,
		56,
		-1,
		102,
		-1,
		75,
		77,
		71,
		56,
		53,
		64,
		62,
		73,
		90,
		-1,
		90,
		75,
		68,
		58,
		72,
		43,
		-1,
		98,
		-1,
		-1,
		68,
		62,
		62,
		46,
		49,
		83,
		63,
		57,
		56,
		97,
		97,
		83,
		69,
		62,
		59,
		56,
		69,
		89,
		80,
		92,
		-1,
		-1,
		-1,
		95,
		81,
		85,
		45,
		64,
		-1,
		-1,
		130,
		85,
		71,
		-1,
		55,
		100,
		88,
		78,
		68,
		102,
		103,
		88,
		81,
		67,
		69,
		67,
		65,
		70,
		91,
		92,
		105,
		-1,
		-1,
		78,
		83,
		71,
		57,
		76,
		-1,
		-1,
		-1,
		77,
		93,
		85,
		56,
		89,
		-1,
		-1,
		80,
		78,
		88,
		84,
		71,
		91,
		94,
		80,
		64,
		79,
		91,
		99,
		104,
		-1,
		81,
		68,
		-1,
		-1,
		79,
		73,
		-1,
		-1,
		-1,
		-1,
		110,
		76,
		88,
		109,
		125,
		83,
		-1,
		88,
		89,
		75,
		89,
		96,
		82,
		77,
		71,
		74,
		92,
		109,
		-1,
		-1,
		93,
		-1,
		88,
		-1,
		-1,
		-1,
		-1,
		67,
		81,
		102,
		107,
		111,
		-1,
		97,
		91,
		77,
		94,
		95,
		92,
		83,
		75,
		80,
		77,
		90,
		104,
		108,
		116,
		-1,
		99,
		-1,
		-1,
		-1,
		85,
		100,
		153,
		130,
		103,
		98,
		91,
		85,
		85,
		101,
		103,
		114,
		82,
		78,
		79,
		83,
		82,
		99,
		109,
		-1,
		-1,
		99,
		116,
		111,
		93,
		97,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		95,
		98,
		88,
		85,
		90,
		95,
		83,
		92,
		110,
		113,
		-1,
		-1,
		-1,
		119,
		-1,
		134,
		-1,
		-1,
		112,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		109,
		101,
		85,
		93,
		116,
		105,
		144,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		148,
		123,
		138,
		184,
		132,
		139,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		103,
		111,
		111,
		105,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		154,
		140,
		170,
		160,
		149,
		-1,
		-1,
		156,
		153,
		129,
		113,
		114,
		107,
		102,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		126,
		207,
		200,
		183,
		191,
		222,
		-1,
		157,
		166,
		147,
		152,
		159,
		-1,
		-1,
		129,
		126,
		131,
		120,
		117,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		140,
		183,
		177,
		180,
		204,
		218,
		-1,
		170,
		-1,
		-1,
		155,
		160,
		144,
		134,
		128,
		178,
		134,
		129,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		175,
		163,
		171,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		171,
		-1,
		171,
		-1,
		146,
		150,
		142,
		145,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		248,
		204,
		171,
		162,
		209,
		224,
		228,
		-1,
		183,
		222,
		209,
		-1,
		180,
		-1,
		-1,
		-1,
		160,
		155,
		147,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		244,
		235,
		248,
		193,
		176,
		194,
		203,
		224,
		198,
		189,
		216,
		216,
		205,
		200,
		187,
		-1,
		-1,
		183,
		165,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		195,
		-1,
		-1,
		201,
		217,
		217,
		221,
		237,
		262,
		-1,
		190,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		206,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		211,
		212,
		216,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		169,
		171,
		137,
		131,
		170,
		141,
		147,
		158,
		-1,
		-1,
		-1,
		160,
		159,
		129,
		127,
		136,
		141,
		148,
		-1,
		152,
		-1,
		181,
		160,
		171,
		176,
		122,
		119,
		139,
		158,
		145,
		137,
		196,
		152,
		123,
		117,
		135,
		130,
		139,
		131,
		-1,
		123,
		113,
		135,
		119,
		130,
		122,
		-1,
		-1,
		117,
		118,
		124,
		115,
		121,
		117,
		-1,
		127,
		111,
		-1,
		-1,
		107,
		113,
		97,
		100,
		108,
		106,
		119,
		111,
		106,
		-1,
		-1,
		103,
		99,
		106,
		93,
		89,
		106,
		119,
		101,
		115,
		114,
		-1,
		96,
		114,
		123,
		100,
		98,
		82,
		80,
		98,
		100,
		106,
		109,
		-1,
		105,
		106,
		101,
		109,
		114,
		98,
		85,
		85,
		95,
		88,
		107,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		105,
		88,
		105,
		97,
		87,
		102,
		95,
		88,
		85,
		83,
		80,
		96,
		97,
		107,
		-1,
		-1,
		167,
		136,
		171,
		128,
		113,
		-1,
		101,
		81,
		87,
		91,
		85,
		78,
		92,
		88,
		-1,
		74,
		73,
		104,
		90,
		101,
		127,
		-1,
		-1,
		125,
		117,
		102,
		105,
		102,
		102,
		96,
		95,
		87,
		73,
		69,
		75,
		78,
		78,
		84,
		68,
		78,
		82,
		93,
		108,
		-1,
		-1,
		163,
		-1,
		-1,
		124,
		107,
		-1,
		90,
		97,
		97,
		114,
		104,
		125,
		106,
		97,
		89,
		83,
		71,
		73,
		70,
		83,
		71,
		65,
		90,
		94,
		88,
		109,
		104,
		-1,
		162,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		83,
		86,
		92,
		116,
		126,
		-1,
		116,
		106,
		107,
		92,
		89,
		76,
		64,
		77,
		62,
		69,
		68,
		72,
		74,
		107,
		85,
		107,
		104,
		133,
		138,
		132,
		141,
		-1,
		132,
		128,
		124,
		131,
		80,
		-1,
		-1,
		120,
		-1,
		134,
		133,
		108,
		103,
		106,
		93,
		84,
		71,
		60,
		71,
		60,
		57,
		65,
		74,
		85,
		80,
		79,
		97,
		112,
		125,
		129,
		135,
		-1,
		182,
		-1,
		124,
		108,
		110,
		82,
		103,
		-1,
		140,
		135,
		125,
		110,
		101,
		-1,
		102,
		99,
		89,
		67,
		52,
		69,
		61,
		59,
		64,
		69,
		83,
		74,
		92,
		99,
		107,
		111,
		131,
		143,
		142,
		132,
		-1,
		114,
		119,
		78,
		86,
		105,
		143,
		107,
		-1,
		102,
		-1,
		94,
		117,
		-1,
		73,
		69,
		51,
		52,
		47,
		62,
		68,
		65,
		62,
		80,
		83,
		100,
		104,
		120,
		-1,
		-1,
		127,
		131,
		120,
		71,
		90,
		114,
		151,
		100,
		89,
		88,
		-1,
		79,
		65,
		62,
		48,
		35,
		44,
		45,
		53,
		66,
		45,
		64,
		67,
		89,
		117,
		95,
		107,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		97,
		68,
		92,
		134,
		118,
		111,
		99,
		64,
		64,
		58,
		-1,
		55,
		38,
		40,
		42,
		40,
		53,
		50,
		64,
		68,
		67,
		86,
		98,
		89,
		109,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		63,
		86,
		123,
		97,
		83,
		88,
		63,
		56,
		50,
		58,
		55,
		22,
		44,
		35,
		30,
		46,
		54,
		56,
		65,
		74,
		80,
		104,
		111,
		117,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		77,
		84,
		116,
		88,
		101,
		-1,
		55,
		-1,
		44,
		20,
		3,
		13,
		25,
		36,
		37,
		46,
		60,
		71,
		67,
		74,
		109,
		109,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		127,
		122,
		97,
		74,
		58,
		94,
		-1,
		71,
		72,
		-1,
		49,
		43,
		24,
		6,
		0,
		28,
		29,
		44,
		51,
		47,
		61,
		72,
		59,
		95,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		53,
		105,
		-1,
		-1,
		56,
		49,
		-1,
		35,
		18,
		25,
		29,
		38,
		43,
		52,
		45,
		58,
		63,
		64,
		74,
		94,
		98,
		102,
		91,
		87,
		84,
		98,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		73,
		-1,
		65,
		57,
		47,
		41,
		35,
		31,
		29,
		49,
		41,
		55,
		55,
		59,
		67,
		52,
		55,
		67,
		71,
		89,
		97,
		89,
		83,
		82,
		94,
		-1,
		140,
		126,
		97,
		-1,
		-1,
		86,
		-1,
		50,
		64,
		80,
		-1,
		73,
		52,
		67,
		45,
		41,
		37,
		75,
		76,
		54,
		59,
		66,
		76,
		77,
		66,
		79,
		71,
		93,
		93,
		77,
		78,
		87,
		-1,
		146,
		133,
		91,
		87,
		76,
		96,
		47,
		35,
		67,
		-1,
		-1,
		109,
		-1,
		43,
		60,
		51,
		49,
		65,
		56,
		62,
		77,
		80,
		81,
		71,
		60,
		66,
		65,
		87,
		73,
		71,
		90,
		106,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		62,
		49,
		43,
		-1,
		84,
		-1,
		87,
		77,
		61,
		46,
		79,
		-1,
		73,
		57,
		62,
		-1,
		106,
		-1,
		79,
		81,
		73,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		96,
		81,
		74,
		64,
		78,
		49,
		-1,
		104,
		-1,
		-1,
		74,
		68,
		68,
		52,
		55,
		89,
		69,
		63,
		62,
		101,
		99,
		87,
		71,
		64,
		61,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		101,
		87,
		91,
		51,
		70,
		-1,
		-1,
		136,
		91,
		77,
		-1,
		61,
		106,
		94,
		84,
		74,
		108,
		109,
		90,
		83,
		69,
		71,
		69,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		84,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		83,
		99,
		91,
		62,
		95,
		-1,
		-1,
		86,
		84,
		94,
		86,
		73,
		93,
		96,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		87,
		74,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		116,
		82,
		94,
		115,
		131,
		89,
		-1,
		94,
		95,
		77,
		91,
		98,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		73,
		87,
		108,
		113,
		117,
		-1,
		103,
		93,
		79,
		96,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		91,
		106,
		159,
		136,
		109,
		104,
		97,
		91,
		87,
		103,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		105,
		122,
		117,
		99,
		103,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		97,
		100,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		115,
		-1,
		-1,
		-1,
		125,
		-1,
		140,
		-1,
		-1,
		118,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		111,
		103,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		154,
		129,
		144,
		190,
		138,
		145,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		108,
		115,
		115,
		107,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		160,
		146,
		176,
		166,
		155,
		-1,
		-1,
		162,
		159,
		135,
		118,
		116,
		109,
		104,
		114,
		94,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		132,
		213,
		206,
		189,
		197,
		228,
		-1,
		163,
		172,
		153,
		158,
		165,
		-1,
		-1,
		135,
		132,
		137,
		125,
		122,
		124,
		119,
		110,
		95,
		101,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		146,
		189,
		183,
		186,
		210,
		224,
		-1,
		176,
		-1,
		-1,
		161,
		166,
		150,
		140,
		134,
		184,
		139,
		134,
		118,
		116,
		107,
		98,
		105,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		126,
		-1,
		181,
		169,
		177,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		177,
		-1,
		177,
		-1,
		152,
		156,
		147,
		150,
		132,
		119,
		111,
		103,
		119,
		94,
		104,
		100,
		101,
		110,
		121,
		133,
		132,
		133,
		253,
		209,
		177,
		168,
		215,
		230,
		234,
		-1,
		189,
		228,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		166,
		160,
		152,
		152,
		131,
		131,
		105,
		109,
		99,
		106,
		116,
		118,
		110,
		114,
		127,
		138,
		141,
		249,
		240,
		253,
		198,
		182,
		200,
		209,
		230,
		204,
		195,
		222,
		222,
		211,
		206,
		193,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		138,
		126,
		109,
		110,
		106,
		109,
		124,
		127,
		117,
		115,
		109,
		141,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		201,
		-1,
		-1,
		207,
		223,
		222,
		226,
		242,
		267,
		-1,
		196,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		131,
		120,
		111,
		117,
		114,
		125,
		135,
		123,
		124,
		114,
		124,
		137,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		198,
		196,
		202,
		209,
		226,
		256,
		-1,
		-1,
		212,
		194,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		116,
		121,
		141,
		143,
		132,
		126,
		120,
		127,
		126,
		134,
		142,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		134,
		138,
		130,
		123,
		118,
		129,
		121,
		125,
		142,
		-1,
		269,
		-1,
		221,
		197,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		174,
		142,
		147,
		142,
		124,
		135,
		124,
		127,
		141,
		136,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		211,
		213,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		131,
		156,
		145,
		153,
		148,
		128,
		134,
		137,
		126,
		130,
		142,
		-1,
		-1,
		216,
		217,
		218,
		-1,
		196,
		-1,
		214,
		-1,
		181,
		187,
		175,
		-1,
		-1,
		-1,
		169,
		132,
		153,
		163,
		157,
		155,
		146,
		132,
		139,
		137,
		133,
		144,
		-1,
		-1,
		-1,
		214,
		188,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		131,
		133,
		159,
		162,
		168,
		162,
		135,
		150,
		140,
		131,
		140,
		220,
		-1,
		190,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		135,
		-1,
		163,
		153,
		184,
		169,
		150,
		137,
		144,
		144,
		137,
		-1,
		-1,
		-1,
		192,
		191,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		174,
		170,
		157,
		157,
		149,
		-1,
		293,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		150,
		185,
		-1,
		288,
		-1,
		222,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		157,
		158,
		-1,
		277,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		149,
		138,
		149,
		157,
		130,
		137,
		-1,
		158,
		160,
		126,
		120,
		159,
		130,
		136,
		147,
		-1,
		-1,
		-1,
		149,
		148,
		118,
		116,
		125,
		130,
		137,
		-1,
		141,
		-1,
		170,
		149,
		160,
		165,
		111,
		108,
		128,
		147,
		134,
		126,
		185,
		141,
		112,
		106,
		124,
		119,
		128,
		120,
		-1,
		112,
		102,
		124,
		108,
		119,
		111,
		-1,
		-1,
		106,
		107,
		113,
		104,
		110,
		106,
		-1,
		116,
		100,
		-1,
		-1,
		96,
		102,
		86,
		89,
		97,
		95,
		108,
		100,
		95,
		-1,
		-1,
		92,
		88,
		95,
		82,
		78,
		95,
		108,
		90,
		104,
		103,
		-1,
		85,
		103,
		112,
		89,
		87,
		71,
		69,
		87,
		89,
		95,
		98,
		-1,
		94,
		95,
		90,
		98,
		103,
		87,
		74,
		74,
		84,
		77,
		96,
		87,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		94,
		77,
		94,
		86,
		76,
		91,
		84,
		77,
		74,
		72,
		69,
		85,
		86,
		96,
		-1,
		-1,
		172,
		141,
		176,
		133,
		118,
		-1,
		90,
		70,
		76,
		80,
		74,
		67,
		81,
		77,
		-1,
		63,
		62,
		93,
		79,
		90,
		132,
		-1,
		-1,
		130,
		122,
		107,
		110,
		100,
		96,
		85,
		84,
		76,
		62,
		58,
		64,
		67,
		67,
		73,
		57,
		67,
		71,
		80,
		97,
		-1,
		-1,
		150,
		-1,
		-1,
		129,
		112,
		-1,
		95,
		102,
		102,
		112,
		98,
		119,
		95,
		86,
		78,
		72,
		60,
		62,
		59,
		72,
		60,
		54,
		79,
		83,
		75,
		96,
		91,
		-1,
		149,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		88,
		91,
		97,
		121,
		131,
		-1,
		107,
		95,
		96,
		81,
		78,
		65,
		53,
		66,
		51,
		58,
		57,
		61,
		63,
		96,
		72,
		94,
		91,
		120,
		125,
		119,
		128,
		-1,
		137,
		133,
		129,
		136,
		85,
		-1,
		-1,
		125,
		-1,
		139,
		138,
		113,
		92,
		95,
		82,
		73,
		60,
		49,
		60,
		49,
		46,
		54,
		61,
		74,
		67,
		66,
		84,
		99,
		112,
		116,
		122,
		-1,
		187,
		-1,
		129,
		113,
		115,
		87,
		108,
		-1,
		145,
		140,
		130,
		115,
		106,
		-1,
		91,
		88,
		78,
		56,
		41,
		58,
		50,
		46,
		53,
		56,
		70,
		61,
		79,
		86,
		94,
		98,
		118,
		130,
		147,
		137,
		-1,
		119,
		124,
		83,
		91,
		110,
		148,
		112,
		-1,
		107,
		-1,
		93,
		106,
		-1,
		62,
		58,
		40,
		41,
		34,
		51,
		55,
		52,
		49,
		67,
		70,
		87,
		91,
		107,
		-1,
		-1,
		132,
		136,
		125,
		76,
		95,
		119,
		156,
		105,
		94,
		93,
		-1,
		84,
		71,
		68,
		54,
		41,
		31,
		34,
		31,
		53,
		32,
		51,
		54,
		76,
		104,
		82,
		94,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		102,
		73,
		97,
		139,
		123,
		116,
		104,
		69,
		69,
		63,
		-1,
		61,
		44,
		34,
		29,
		20,
		33,
		33,
		51,
		55,
		56,
		73,
		85,
		76,
		96,
		-1,
		-1,
		-1,
		132,
		121,
		122,
		68,
		91,
		128,
		102,
		88,
		93,
		68,
		61,
		55,
		64,
		61,
		28,
		32,
		18,
		19,
		29,
		37,
		41,
		54,
		63,
		67,
		91,
		89,
		95,
		-1,
		-1,
		139,
		129,
		113,
		115,
		112,
		82,
		89,
		121,
		93,
		106,
		-1,
		60,
		-1,
		49,
		38,
		22,
		17,
		17,
		11,
		20,
		34,
		43,
		58,
		56,
		63,
		96,
		96,
		79,
		99,
		102,
		-1,
		-1,
		-1,
		132,
		127,
		102,
		79,
		63,
		99,
		-1,
		76,
		77,
		-1,
		54,
		48,
		42,
		24,
		20,
		0,
		4,
		22,
		31,
		30,
		49,
		52,
		48,
		84,
		-1,
		87,
		81,
		89,
		79,
		67,
		-1,
		-1,
		-1,
		125,
		104,
		97,
		117,
		58,
		110,
		-1,
		-1,
		61,
		54,
		-1,
		41,
		23,
		22,
		17,
		17,
		18,
		32,
		25,
		38,
		43,
		53,
		54,
		72,
		76,
		80,
		69,
		65,
		62,
		76,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		78,
		-1,
		70,
		62,
		52,
		46,
		40,
		36,
		34,
		46,
		31,
		30,
		33,
		39,
		47,
		32,
		35,
		51,
		49,
		67,
		75,
		67,
		61,
		60,
		72,
		-1,
		145,
		131,
		102,
		-1,
		-1,
		91,
		-1,
		55,
		69,
		85,
		-1,
		78,
		57,
		72,
		50,
		46,
		34,
		58,
		59,
		37,
		42,
		46,
		56,
		57,
		46,
		57,
		49,
		71,
		71,
		55,
		56,
		65,
		-1,
		151,
		138,
		96,
		92,
		81,
		101,
		52,
		40,
		72,
		-1,
		-1,
		114,
		-1,
		48,
		65,
		48,
		46,
		48,
		39,
		45,
		57,
		60,
		61,
		51,
		40,
		46,
		43,
		65,
		51,
		49,
		68,
		84,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		67,
		54,
		48,
		-1,
		89,
		-1,
		92,
		82,
		66,
		51,
		84,
		-1,
		56,
		40,
		45,
		-1,
		86,
		-1,
		59,
		61,
		55,
		40,
		37,
		48,
		46,
		57,
		74,
		-1,
		101,
		86,
		79,
		69,
		83,
		54,
		-1,
		109,
		-1,
		-1,
		79,
		73,
		73,
		57,
		60,
		72,
		52,
		46,
		45,
		81,
		81,
		67,
		53,
		46,
		43,
		40,
		53,
		73,
		64,
		76,
		-1,
		-1,
		-1,
		106,
		92,
		96,
		56,
		75,
		-1,
		-1,
		141,
		96,
		82,
		-1,
		66,
		89,
		77,
		67,
		57,
		91,
		92,
		72,
		65,
		51,
		53,
		51,
		49,
		54,
		75,
		76,
		89,
		-1,
		-1,
		89,
		94,
		82,
		68,
		87,
		-1,
		-1,
		-1,
		88,
		104,
		96,
		67,
		78,
		-1,
		-1,
		69,
		67,
		77,
		68,
		55,
		75,
		78,
		64,
		48,
		63,
		75,
		83,
		88,
		-1,
		92,
		79,
		-1,
		-1,
		90,
		84,
		-1,
		-1,
		-1,
		-1,
		121,
		87,
		99,
		105,
		109,
		72,
		-1,
		77,
		78,
		59,
		73,
		80,
		66,
		61,
		55,
		58,
		76,
		93,
		-1,
		-1,
		104,
		-1,
		99,
		-1,
		-1,
		-1,
		-1,
		78,
		92,
		98,
		91,
		95,
		-1,
		83,
		75,
		61,
		78,
		79,
		76,
		67,
		59,
		64,
		61,
		74,
		88,
		92,
		127,
		-1,
		110,
		-1,
		-1,
		-1,
		96,
		111,
		137,
		114,
		87,
		82,
		75,
		69,
		69,
		85,
		87,
		98,
		66,
		62,
		63,
		67,
		66,
		83,
		93,
		-1,
		-1,
		110,
		127,
		122,
		104,
		108,
		164,
		-1,
		-1,
		91,
		82,
		73,
		76,
		79,
		82,
		72,
		69,
		74,
		79,
		67,
		76,
		94,
		98,
		-1,
		-1,
		-1,
		130,
		-1,
		145,
		-1,
		-1,
		123,
		162,
		109,
		91,
		87,
		85,
		78,
		87,
		82,
		77,
		87,
		97,
		89,
		69,
		82,
		104,
		94,
		130,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		159,
		134,
		149,
		173,
		143,
		150,
		124,
		121,
		-1,
		91,
		116,
		88,
		95,
		87,
		95,
		95,
		93,
		72,
		79,
		95,
		94,
		89,
		122,
		116,
		122,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		165,
		151,
		159,
		149,
		152,
		-1,
		-1,
		140,
		137,
		113,
		97,
		101,
		94,
		89,
		101,
		81,
		68,
		72,
		76,
		82,
		87,
		92,
		98,
		113,
		128,
		-1,
		137,
		218,
		211,
		194,
		202,
		233,
		-1,
		163,
		155,
		158,
		141,
		143,
		-1,
		-1,
		113,
		110,
		115,
		104,
		101,
		111,
		106,
		97,
		82,
		88,
		75,
		74,
		92,
		96,
		105,
		112,
		102,
		115,
		119,
		-1,
		151,
		194,
		188,
		191,
		215,
		229,
		-1,
		160,
		-1,
		-1,
		166,
		144,
		128,
		118,
		112,
		162,
		118,
		113,
		105,
		103,
		94,
		85,
		92,
		83,
		83,
		86,
		101,
		106,
		98,
		112,
		112,
		113,
		-1,
		186,
		174,
		182,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		182,
		-1,
		155,
		-1,
		130,
		134,
		126,
		129,
		119,
		106,
		98,
		90,
		106,
		81,
		91,
		87,
		88,
		97,
		108,
		120,
		119,
		120,
		232,
		188,
		182,
		173,
		213,
		228,
		232,
		-1,
		172,
		211,
		218,
		-1,
		191,
		-1,
		-1,
		-1,
		144,
		139,
		131,
		139,
		118,
		118,
		92,
		96,
		86,
		93,
		103,
		105,
		97,
		101,
		114,
		125,
		128,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		187,
		178,
		205,
		225,
		214,
		209,
		196,
		-1,
		-1,
		167,
		149,
		-1,
		-1,
		125,
		113,
		96,
		97,
		93,
		96,
		111,
		114,
		104,
		102,
		96,
		128,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		206,
		201,
		205,
		221,
		246,
		-1,
		185,
		-1,
		-1,
		170,
		-1,
		-1,
		155,
		118,
		107,
		98,
		104,
		101,
		112,
		122,
		110,
		111,
		101,
		111,
		124,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		235,
		-1,
		-1,
		201,
		181,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		108,
		128,
		130,
		119,
		113,
		107,
		114,
		113,
		121,
		129,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		187,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		121,
		125,
		117,
		110,
		105,
		116,
		108,
		112,
		129,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		161,
		129,
		134,
		129,
		111,
		122,
		111,
		114,
		128,
		123,
		-1,
		-1,
		188,
		191,
		-1,
		-1,
		198,
		200,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		143,
		132,
		140,
		135,
		115,
		121,
		124,
		113,
		117,
		129,
		-1,
		-1,
		195,
		196,
		201,
		-1,
		183,
		-1,
		201,
		-1,
		168,
		174,
		162,
		-1,
		-1,
		-1,
		156,
		119,
		140,
		150,
		144,
		142,
		133,
		119,
		126,
		124,
		120,
		131,
		-1,
		-1,
		-1,
		201,
		175,
		208,
		199,
		182,
		162,
		154,
		173,
		-1,
		143,
		-1,
		118,
		120,
		146,
		149,
		155,
		149,
		122,
		137,
		127,
		118,
		127,
		207,
		-1,
		177,
		210,
		174,
		168,
		144,
		148,
		164,
		-1,
		140,
		122,
		-1,
		150,
		140,
		171,
		156,
		137,
		124,
		131,
		131,
		124,
		-1,
		-1,
		-1,
		179,
		178,
		170,
		164,
		164,
		149,
		140,
		-1,
		152,
		134,
		113,
		130,
		130,
		121,
		129,
		161,
		157,
		144,
		144,
		136,
		-1,
		280,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		173,
		168,
		141,
		129,
		135,
		131,
		117,
		123,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		137,
		172,
		-1,
		275,
		-1,
		209,
		-1,
		-1,
		191,
		171,
		163,
		152,
		141,
		139,
		130,
		121,
		143,
		159,
		143,
		141,
		144,
		145,
		-1,
		264,
		263,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		187,
		148,
		-1,
		150,
		130,
		-1,
		152,
		148,
		-1,
		-1,
		251,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		182,
		166,
		-1,
		141,
		141,
		-1,
		-1,
		-1,
		236,
		235,
		-1,
		204,
		207,
		-1,
		197,
		188,
		196,
		143,
		147,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		219,
		217,
		212,
		209,
		195,
		179,
		157,
		146,
		167,
		-1,
		-1,
		-1,
		217,
		209,
		202,
		-1,
		-1,
		204,
		187,
		168,
		166,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		194,
		-1,
		-1,
		200,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		228,
		-1,
		-1,
		-1,
		190,
		186,
		187,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		274,
		238,
		-1,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		210,
		194,
		-1,
		180,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		215,
		-1,
		215,
		190,
		197,
		-1,
		-1,
		-1,
		-1,
		228,
		220,
		228,
		-1,
		200,
		202,
		-1,
		250,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		205,
		212,
		234,
		237,
		273,
		-1,
		224
	],
	[
		-1,
		154,
		143,
		154,
		162,
		135,
		142,
		-1,
		163,
		165,
		131,
		125,
		164,
		135,
		141,
		152,
		-1,
		-1,
		-1,
		154,
		153,
		123,
		121,
		130,
		135,
		142,
		-1,
		146,
		-1,
		175,
		154,
		165,
		170,
		116,
		113,
		133,
		152,
		139,
		131,
		190,
		146,
		117,
		111,
		129,
		124,
		133,
		125,
		-1,
		117,
		107,
		129,
		113,
		124,
		116,
		-1,
		-1,
		111,
		112,
		118,
		109,
		115,
		111,
		-1,
		121,
		105,
		-1,
		-1,
		101,
		107,
		91,
		94,
		102,
		100,
		113,
		105,
		100,
		-1,
		-1,
		97,
		93,
		100,
		87,
		83,
		100,
		113,
		95,
		109,
		108,
		-1,
		90,
		108,
		117,
		94,
		92,
		76,
		74,
		92,
		94,
		100,
		103,
		-1,
		99,
		100,
		95,
		103,
		108,
		92,
		79,
		79,
		89,
		82,
		101,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		99,
		82,
		99,
		91,
		81,
		96,
		89,
		82,
		79,
		77,
		74,
		90,
		91,
		101,
		-1,
		-1,
		171,
		140,
		175,
		132,
		117,
		-1,
		95,
		75,
		81,
		85,
		79,
		72,
		86,
		82,
		-1,
		68,
		67,
		98,
		84,
		95,
		131,
		-1,
		-1,
		129,
		121,
		106,
		109,
		105,
		101,
		90,
		89,
		81,
		67,
		63,
		69,
		72,
		72,
		78,
		62,
		72,
		76,
		82,
		102,
		-1,
		-1,
		152,
		-1,
		-1,
		128,
		111,
		-1,
		94,
		101,
		101,
		117,
		103,
		124,
		100,
		91,
		83,
		77,
		65,
		67,
		64,
		77,
		65,
		59,
		84,
		88,
		77,
		98,
		93,
		-1,
		151,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		87,
		90,
		96,
		120,
		130,
		-1,
		112,
		100,
		101,
		86,
		83,
		70,
		58,
		71,
		56,
		63,
		62,
		66,
		68,
		99,
		74,
		96,
		93,
		122,
		127,
		121,
		130,
		-1,
		136,
		132,
		128,
		135,
		84,
		-1,
		-1,
		124,
		-1,
		138,
		137,
		112,
		97,
		100,
		87,
		78,
		65,
		54,
		65,
		54,
		51,
		59,
		63,
		78,
		69,
		68,
		86,
		101,
		114,
		118,
		124,
		-1,
		186,
		-1,
		128,
		112,
		114,
		86,
		107,
		-1,
		144,
		139,
		129,
		114,
		105,
		-1,
		96,
		93,
		83,
		61,
		46,
		63,
		55,
		52,
		58,
		58,
		72,
		63,
		81,
		88,
		96,
		100,
		120,
		132,
		146,
		136,
		-1,
		118,
		123,
		82,
		90,
		109,
		147,
		111,
		-1,
		106,
		-1,
		98,
		111,
		-1,
		67,
		63,
		45,
		46,
		40,
		56,
		57,
		54,
		51,
		69,
		72,
		89,
		93,
		109,
		-1,
		-1,
		131,
		135,
		124,
		75,
		94,
		118,
		155,
		104,
		93,
		92,
		-1,
		83,
		77,
		74,
		60,
		47,
		37,
		39,
		37,
		55,
		34,
		53,
		56,
		78,
		106,
		84,
		96,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		101,
		72,
		96,
		138,
		122,
		115,
		103,
		68,
		68,
		62,
		-1,
		69,
		50,
		40,
		35,
		26,
		39,
		35,
		53,
		57,
		59,
		75,
		87,
		78,
		98,
		-1,
		-1,
		-1,
		131,
		120,
		121,
		67,
		90,
		127,
		101,
		87,
		92,
		67,
		60,
		54,
		72,
		67,
		36,
		38,
		24,
		24,
		31,
		39,
		43,
		59,
		68,
		69,
		93,
		91,
		97,
		-1,
		-1,
		138,
		128,
		112,
		114,
		111,
		81,
		88,
		120,
		92,
		105,
		-1,
		59,
		-1,
		48,
		41,
		30,
		25,
		25,
		7,
		22,
		36,
		45,
		60,
		61,
		68,
		98,
		98,
		81,
		101,
		104,
		-1,
		-1,
		-1,
		131,
		126,
		101,
		78,
		62,
		98,
		-1,
		75,
		76,
		-1,
		53,
		47,
		44,
		32,
		28,
		8,
		0,
		26,
		36,
		32,
		51,
		54,
		53,
		86,
		-1,
		89,
		83,
		91,
		81,
		69,
		-1,
		-1,
		-1,
		124,
		103,
		96,
		116,
		57,
		109,
		-1,
		-1,
		60,
		53,
		-1,
		40,
		22,
		18,
		13,
		13,
		22,
		29,
		27,
		40,
		45,
		58,
		56,
		74,
		78,
		82,
		71,
		67,
		64,
		78,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		77,
		-1,
		69,
		61,
		51,
		45,
		39,
		35,
		33,
		42,
		27,
		30,
		32,
		40,
		46,
		34,
		37,
		53,
		51,
		69,
		77,
		69,
		63,
		62,
		74,
		-1,
		144,
		130,
		101,
		-1,
		-1,
		90,
		-1,
		54,
		68,
		84,
		-1,
		77,
		56,
		71,
		49,
		45,
		30,
		54,
		55,
		33,
		38,
		45,
		55,
		59,
		48,
		59,
		51,
		73,
		73,
		57,
		58,
		67,
		-1,
		150,
		137,
		95,
		91,
		80,
		100,
		51,
		39,
		71,
		-1,
		-1,
		113,
		-1,
		47,
		64,
		44,
		42,
		44,
		35,
		41,
		56,
		59,
		63,
		53,
		42,
		48,
		45,
		67,
		53,
		51,
		70,
		86,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		66,
		53,
		47,
		-1,
		88,
		-1,
		91,
		81,
		65,
		50,
		83,
		-1,
		52,
		36,
		41,
		-1,
		88,
		-1,
		61,
		63,
		57,
		42,
		39,
		50,
		48,
		59,
		76,
		-1,
		100,
		85,
		78,
		68,
		82,
		53,
		-1,
		108,
		-1,
		-1,
		78,
		72,
		72,
		56,
		59,
		68,
		48,
		42,
		41,
		83,
		83,
		69,
		55,
		48,
		45,
		42,
		55,
		75,
		66,
		78,
		-1,
		-1,
		-1,
		105,
		91,
		95,
		55,
		74,
		-1,
		-1,
		140,
		95,
		81,
		-1,
		65,
		85,
		73,
		63,
		53,
		87,
		88,
		74,
		67,
		53,
		55,
		53,
		51,
		56,
		77,
		78,
		91,
		-1,
		-1,
		88,
		93,
		81,
		67,
		86,
		-1,
		-1,
		-1,
		87,
		103,
		95,
		66,
		74,
		-1,
		-1,
		65,
		63,
		73,
		70,
		57,
		77,
		80,
		66,
		50,
		65,
		77,
		85,
		90,
		-1,
		91,
		78,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		-1,
		-1,
		120,
		86,
		98,
		107,
		111,
		68,
		-1,
		73,
		74,
		61,
		75,
		82,
		68,
		63,
		57,
		60,
		78,
		95,
		-1,
		-1,
		103,
		-1,
		98,
		-1,
		-1,
		-1,
		-1,
		77,
		91,
		100,
		93,
		97,
		-1,
		82,
		77,
		63,
		80,
		81,
		78,
		69,
		61,
		66,
		63,
		76,
		90,
		94,
		126,
		-1,
		109,
		-1,
		-1,
		-1,
		95,
		110,
		139,
		116,
		89,
		84,
		77,
		71,
		71,
		87,
		89,
		100,
		68,
		64,
		65,
		69,
		68,
		85,
		95,
		-1,
		-1,
		109,
		126,
		121,
		103,
		107,
		166,
		-1,
		-1,
		93,
		84,
		75,
		78,
		81,
		84,
		74,
		71,
		76,
		81,
		69,
		78,
		96,
		100,
		-1,
		-1,
		-1,
		129,
		-1,
		144,
		-1,
		-1,
		122,
		164,
		111,
		93,
		89,
		87,
		80,
		89,
		84,
		79,
		89,
		99,
		91,
		71,
		84,
		106,
		96,
		132,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		158,
		133,
		148,
		175,
		142,
		149,
		126,
		123,
		-1,
		93,
		118,
		90,
		97,
		89,
		97,
		97,
		95,
		74,
		81,
		97,
		96,
		91,
		124,
		118,
		124,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		164,
		150,
		161,
		151,
		154,
		-1,
		-1,
		142,
		139,
		115,
		99,
		103,
		96,
		91,
		103,
		83,
		70,
		74,
		78,
		84,
		89,
		94,
		100,
		115,
		130,
		-1,
		136,
		217,
		210,
		193,
		201,
		232,
		-1,
		165,
		157,
		157,
		143,
		145,
		-1,
		-1,
		115,
		112,
		117,
		106,
		103,
		113,
		108,
		99,
		84,
		90,
		77,
		76,
		94,
		98,
		107,
		114,
		104,
		117,
		121,
		-1,
		150,
		193,
		187,
		190,
		214,
		228,
		-1,
		162,
		-1,
		-1,
		165,
		146,
		130,
		120,
		114,
		164,
		120,
		115,
		107,
		105,
		96,
		87,
		94,
		85,
		85,
		88,
		103,
		108,
		100,
		114,
		114,
		115,
		-1,
		185,
		173,
		181,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		181,
		-1,
		157,
		-1,
		132,
		136,
		128,
		131,
		121,
		108,
		100,
		92,
		108,
		83,
		93,
		89,
		90,
		99,
		110,
		122,
		121,
		122,
		234,
		190,
		181,
		172,
		215,
		230,
		234,
		-1,
		174,
		213,
		219,
		-1,
		190,
		-1,
		-1,
		-1,
		146,
		141,
		133,
		141,
		120,
		120,
		94,
		98,
		88,
		95,
		105,
		107,
		99,
		103,
		116,
		127,
		130,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		189,
		180,
		207,
		226,
		215,
		210,
		197,
		-1,
		-1,
		169,
		151,
		-1,
		-1,
		127,
		115,
		98,
		99,
		95,
		98,
		113,
		116,
		106,
		104,
		98,
		130,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		208,
		203,
		207,
		223,
		248,
		-1,
		187,
		-1,
		-1,
		172,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		103,
		114,
		124,
		112,
		113,
		103,
		113,
		126,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		203,
		183,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		130,
		132,
		121,
		115,
		109,
		116,
		115,
		123,
		131,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		189,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		123,
		127,
		119,
		112,
		107,
		118,
		110,
		114,
		131,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		113,
		124,
		113,
		116,
		130,
		125,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		200,
		202,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		117,
		123,
		126,
		115,
		119,
		131,
		-1,
		-1,
		197,
		198,
		203,
		-1,
		185,
		-1,
		203,
		-1,
		170,
		176,
		164,
		-1,
		-1,
		-1,
		158,
		121,
		142,
		152,
		146,
		144,
		135,
		121,
		128,
		126,
		122,
		133,
		-1,
		-1,
		-1,
		203,
		177,
		210,
		201,
		184,
		164,
		156,
		175,
		-1,
		145,
		-1,
		120,
		122,
		148,
		151,
		157,
		151,
		124,
		139,
		129,
		120,
		129,
		209,
		-1,
		179,
		212,
		176,
		170,
		146,
		150,
		166,
		-1,
		142,
		124,
		-1,
		152,
		142,
		173,
		158,
		139,
		126,
		133,
		133,
		126,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		151,
		142,
		-1,
		154,
		136,
		115,
		132,
		132,
		123,
		131,
		163,
		159,
		146,
		146,
		138,
		-1,
		282,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		170,
		143,
		131,
		137,
		133,
		119,
		125,
		127,
		135,
		133,
		130,
		142,
		138,
		158,
		139,
		174,
		-1,
		277,
		-1,
		211,
		-1,
		-1,
		193,
		173,
		165,
		154,
		143,
		141,
		132,
		123,
		145,
		161,
		145,
		143,
		146,
		147,
		-1,
		266,
		265,
		-1,
		212,
		204,
		190,
		-1,
		183,
		-1,
		189,
		150,
		-1,
		152,
		132,
		-1,
		154,
		150,
		-1,
		-1,
		253,
		228,
		-1,
		-1,
		-1,
		213,
		193,
		184,
		168,
		-1,
		143,
		143,
		-1,
		-1,
		-1,
		238,
		237,
		-1,
		206,
		209,
		-1,
		199,
		190,
		198,
		145,
		149,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		221,
		219,
		214,
		211,
		197,
		181,
		159,
		148,
		169,
		-1,
		-1,
		-1,
		219,
		211,
		204,
		-1,
		-1,
		206,
		189,
		170,
		168,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		196,
		-1,
		-1,
		202,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		230,
		-1,
		-1,
		-1,
		192,
		188,
		189,
		-1,
		-1,
		-1,
		-1,
		252,
		253,
		276,
		240,
		-1,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		255,
		253,
		-1,
		-1,
		-1,
		212,
		196,
		-1,
		182,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		217,
		-1,
		217,
		192,
		199,
		-1,
		-1,
		-1,
		-1,
		230,
		222,
		230,
		-1,
		202,
		204,
		-1,
		252,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		207,
		214,
		236,
		239,
		275,
		-1,
		226
	],
	[
		-1,
		147,
		136,
		147,
		155,
		128,
		135,
		-1,
		156,
		158,
		124,
		118,
		157,
		128,
		134,
		145,
		-1,
		-1,
		-1,
		147,
		146,
		116,
		114,
		123,
		128,
		135,
		-1,
		139,
		-1,
		168,
		147,
		158,
		163,
		109,
		106,
		126,
		145,
		132,
		124,
		183,
		139,
		110,
		104,
		122,
		117,
		126,
		118,
		-1,
		110,
		100,
		122,
		106,
		117,
		109,
		-1,
		-1,
		104,
		105,
		111,
		102,
		108,
		104,
		-1,
		114,
		98,
		-1,
		-1,
		94,
		100,
		84,
		87,
		95,
		93,
		106,
		98,
		93,
		-1,
		-1,
		90,
		86,
		93,
		80,
		76,
		93,
		106,
		88,
		102,
		101,
		-1,
		83,
		101,
		110,
		87,
		85,
		69,
		67,
		85,
		87,
		93,
		96,
		-1,
		92,
		93,
		88,
		96,
		101,
		85,
		72,
		72,
		82,
		75,
		94,
		85,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		75,
		92,
		84,
		74,
		89,
		82,
		75,
		72,
		70,
		67,
		83,
		84,
		94,
		-1,
		-1,
		185,
		154,
		183,
		141,
		122,
		-1,
		88,
		68,
		74,
		78,
		72,
		65,
		79,
		75,
		-1,
		61,
		60,
		91,
		77,
		88,
		145,
		-1,
		-1,
		143,
		135,
		118,
		121,
		98,
		94,
		83,
		82,
		74,
		60,
		56,
		62,
		65,
		65,
		71,
		55,
		65,
		69,
		73,
		95,
		-1,
		-1,
		143,
		-1,
		-1,
		142,
		125,
		-1,
		108,
		115,
		104,
		110,
		96,
		117,
		93,
		84,
		76,
		70,
		58,
		60,
		57,
		70,
		58,
		52,
		77,
		81,
		68,
		89,
		84,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		101,
		104,
		110,
		134,
		133,
		-1,
		105,
		93,
		94,
		79,
		76,
		63,
		51,
		64,
		49,
		56,
		55,
		59,
		60,
		90,
		65,
		87,
		84,
		113,
		118,
		112,
		121,
		-1,
		150,
		146,
		142,
		149,
		98,
		-1,
		-1,
		138,
		-1,
		141,
		142,
		117,
		90,
		93,
		80,
		71,
		58,
		47,
		58,
		47,
		44,
		52,
		54,
		69,
		60,
		59,
		77,
		92,
		105,
		109,
		115,
		-1,
		200,
		-1,
		142,
		126,
		128,
		100,
		121,
		-1,
		158,
		142,
		134,
		119,
		119,
		-1,
		89,
		86,
		76,
		54,
		39,
		56,
		48,
		46,
		51,
		49,
		63,
		54,
		72,
		79,
		87,
		91,
		111,
		123,
		160,
		150,
		-1,
		132,
		137,
		96,
		104,
		123,
		161,
		125,
		-1,
		120,
		-1,
		91,
		104,
		-1,
		60,
		56,
		38,
		39,
		34,
		49,
		48,
		45,
		42,
		60,
		63,
		80,
		84,
		100,
		-1,
		-1,
		145,
		149,
		138,
		89,
		108,
		132,
		169,
		118,
		107,
		106,
		-1,
		97,
		74,
		71,
		58,
		45,
		31,
		32,
		35,
		46,
		25,
		44,
		47,
		69,
		97,
		75,
		87,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		115,
		86,
		110,
		152,
		136,
		129,
		117,
		82,
		82,
		76,
		-1,
		69,
		48,
		38,
		29,
		24,
		34,
		26,
		44,
		48,
		50,
		66,
		78,
		69,
		89,
		-1,
		-1,
		-1,
		145,
		134,
		135,
		81,
		104,
		141,
		115,
		101,
		106,
		81,
		74,
		68,
		83,
		65,
		47,
		36,
		23,
		17,
		22,
		30,
		34,
		50,
		59,
		60,
		84,
		91,
		97,
		-1,
		-1,
		152,
		142,
		126,
		128,
		125,
		95,
		102,
		134,
		106,
		119,
		-1,
		73,
		-1,
		62,
		57,
		41,
		36,
		32,
		18,
		13,
		27,
		36,
		51,
		54,
		61,
		89,
		89,
		81,
		101,
		104,
		-1,
		-1,
		-1,
		145,
		140,
		115,
		92,
		76,
		112,
		-1,
		89,
		90,
		-1,
		67,
		61,
		58,
		43,
		39,
		23,
		27,
		0,
		27,
		27,
		42,
		50,
		46,
		82,
		-1,
		89,
		83,
		91,
		81,
		69,
		-1,
		-1,
		-1,
		138,
		117,
		110,
		130,
		71,
		123,
		-1,
		-1,
		74,
		67,
		-1,
		54,
		36,
		38,
		31,
		25,
		12,
		26,
		23,
		36,
		41,
		51,
		52,
		74,
		78,
		82,
		71,
		67,
		64,
		78,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		91,
		-1,
		83,
		75,
		65,
		59,
		53,
		49,
		47,
		53,
		37,
		28,
		27,
		37,
		43,
		30,
		33,
		49,
		51,
		69,
		77,
		69,
		63,
		62,
		74,
		-1,
		158,
		144,
		115,
		-1,
		-1,
		104,
		-1,
		68,
		82,
		98,
		-1,
		91,
		70,
		85,
		63,
		59,
		50,
		58,
		59,
		39,
		44,
		42,
		52,
		55,
		44,
		59,
		51,
		73,
		73,
		57,
		58,
		67,
		-1,
		164,
		151,
		109,
		105,
		94,
		114,
		65,
		53,
		85,
		-1,
		-1,
		127,
		-1,
		61,
		78,
		64,
		62,
		48,
		41,
		47,
		53,
		56,
		59,
		49,
		38,
		44,
		45,
		67,
		53,
		51,
		70,
		86,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		80,
		67,
		61,
		-1,
		102,
		-1,
		105,
		95,
		79,
		64,
		97,
		-1,
		58,
		42,
		47,
		-1,
		84,
		-1,
		57,
		59,
		57,
		42,
		39,
		50,
		48,
		59,
		76,
		-1,
		114,
		99,
		92,
		82,
		96,
		67,
		-1,
		122,
		-1,
		-1,
		92,
		86,
		86,
		70,
		73,
		74,
		54,
		48,
		47,
		79,
		83,
		65,
		55,
		48,
		45,
		42,
		55,
		75,
		66,
		78,
		-1,
		-1,
		-1,
		119,
		105,
		109,
		69,
		88,
		-1,
		-1,
		154,
		109,
		95,
		-1,
		79,
		91,
		79,
		69,
		59,
		93,
		94,
		74,
		67,
		53,
		55,
		53,
		51,
		56,
		77,
		78,
		91,
		-1,
		-1,
		102,
		107,
		95,
		81,
		100,
		-1,
		-1,
		-1,
		101,
		117,
		109,
		80,
		80,
		-1,
		-1,
		71,
		69,
		79,
		70,
		57,
		77,
		80,
		66,
		50,
		65,
		77,
		85,
		90,
		-1,
		105,
		92,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		-1,
		-1,
		134,
		100,
		112,
		107,
		111,
		74,
		-1,
		79,
		80,
		61,
		75,
		82,
		68,
		63,
		57,
		60,
		78,
		95,
		-1,
		-1,
		117,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		91,
		105,
		100,
		93,
		97,
		-1,
		85,
		77,
		63,
		80,
		81,
		78,
		69,
		61,
		66,
		63,
		76,
		90,
		94,
		140,
		-1,
		123,
		-1,
		-1,
		-1,
		109,
		124,
		139,
		116,
		89,
		84,
		77,
		71,
		71,
		87,
		89,
		100,
		68,
		64,
		65,
		69,
		68,
		85,
		95,
		-1,
		-1,
		123,
		140,
		135,
		117,
		121,
		166,
		-1,
		-1,
		93,
		84,
		75,
		78,
		81,
		84,
		74,
		71,
		76,
		81,
		69,
		78,
		96,
		100,
		-1,
		-1,
		-1,
		143,
		-1,
		158,
		-1,
		-1,
		136,
		164,
		111,
		93,
		89,
		87,
		80,
		89,
		84,
		79,
		89,
		98,
		90,
		71,
		82,
		105,
		94,
		132,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		172,
		147,
		162,
		175,
		156,
		163,
		126,
		123,
		-1,
		93,
		118,
		90,
		97,
		89,
		97,
		97,
		94,
		72,
		79,
		95,
		94,
		89,
		124,
		116,
		122,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		175,
		164,
		161,
		151,
		154,
		-1,
		-1,
		142,
		139,
		115,
		99,
		103,
		96,
		91,
		101,
		81,
		68,
		72,
		76,
		82,
		87,
		92,
		98,
		113,
		128,
		-1,
		150,
		231,
		224,
		207,
		215,
		246,
		-1,
		165,
		157,
		168,
		143,
		145,
		-1,
		-1,
		115,
		112,
		117,
		106,
		103,
		111,
		106,
		97,
		82,
		88,
		75,
		74,
		92,
		96,
		105,
		112,
		102,
		115,
		119,
		-1,
		164,
		207,
		201,
		204,
		228,
		242,
		-1,
		162,
		-1,
		-1,
		174,
		146,
		130,
		120,
		114,
		164,
		120,
		115,
		105,
		103,
		94,
		85,
		92,
		83,
		83,
		86,
		101,
		106,
		98,
		112,
		112,
		113,
		-1,
		199,
		187,
		195,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		190,
		-1,
		157,
		-1,
		132,
		136,
		128,
		131,
		119,
		106,
		98,
		90,
		106,
		81,
		91,
		87,
		88,
		97,
		108,
		120,
		119,
		120,
		234,
		190,
		193,
		186,
		215,
		230,
		234,
		-1,
		174,
		213,
		218,
		-1,
		199,
		-1,
		-1,
		-1,
		146,
		141,
		133,
		139,
		118,
		118,
		92,
		96,
		86,
		93,
		103,
		105,
		97,
		101,
		114,
		125,
		128,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		189,
		180,
		207,
		225,
		214,
		209,
		196,
		-1,
		-1,
		169,
		151,
		-1,
		-1,
		125,
		113,
		96,
		97,
		93,
		96,
		111,
		114,
		104,
		102,
		96,
		128,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		208,
		203,
		207,
		223,
		248,
		-1,
		185,
		-1,
		-1,
		170,
		-1,
		-1,
		155,
		118,
		107,
		98,
		104,
		101,
		112,
		122,
		110,
		111,
		101,
		111,
		124,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		201,
		181,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		108,
		128,
		130,
		119,
		113,
		107,
		114,
		113,
		121,
		129,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		187,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		121,
		125,
		117,
		110,
		105,
		116,
		108,
		112,
		129,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		161,
		129,
		134,
		129,
		111,
		122,
		111,
		114,
		128,
		123,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		198,
		200,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		143,
		132,
		140,
		135,
		115,
		121,
		124,
		113,
		117,
		129,
		-1,
		-1,
		197,
		198,
		203,
		-1,
		183,
		-1,
		201,
		-1,
		168,
		174,
		162,
		-1,
		-1,
		-1,
		156,
		119,
		140,
		150,
		144,
		142,
		133,
		119,
		126,
		124,
		120,
		131,
		-1,
		-1,
		-1,
		201,
		175,
		208,
		199,
		182,
		162,
		154,
		173,
		-1,
		143,
		-1,
		118,
		120,
		146,
		149,
		155,
		149,
		122,
		137,
		127,
		118,
		127,
		207,
		-1,
		177,
		210,
		174,
		168,
		144,
		148,
		164,
		-1,
		140,
		122,
		-1,
		150,
		140,
		171,
		156,
		137,
		124,
		131,
		131,
		124,
		-1,
		-1,
		-1,
		179,
		178,
		170,
		164,
		164,
		149,
		140,
		-1,
		152,
		134,
		113,
		130,
		130,
		121,
		129,
		161,
		157,
		144,
		144,
		136,
		-1,
		280,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		173,
		168,
		141,
		129,
		135,
		131,
		117,
		123,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		137,
		172,
		-1,
		275,
		-1,
		209,
		-1,
		-1,
		191,
		171,
		163,
		152,
		141,
		139,
		130,
		121,
		143,
		159,
		143,
		141,
		144,
		145,
		-1,
		264,
		263,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		187,
		148,
		-1,
		150,
		130,
		-1,
		152,
		148,
		-1,
		-1,
		251,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		182,
		166,
		-1,
		141,
		141,
		-1,
		-1,
		-1,
		236,
		235,
		-1,
		204,
		207,
		-1,
		197,
		188,
		196,
		143,
		147,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		219,
		217,
		212,
		209,
		195,
		179,
		157,
		146,
		167,
		-1,
		-1,
		-1,
		217,
		209,
		202,
		-1,
		-1,
		204,
		187,
		168,
		166,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		194,
		-1,
		-1,
		200,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		228,
		-1,
		-1,
		-1,
		190,
		186,
		187,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		274,
		238,
		-1,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		210,
		194,
		-1,
		180,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		215,
		-1,
		215,
		190,
		197,
		-1,
		-1,
		-1,
		-1,
		228,
		220,
		228,
		-1,
		200,
		202,
		-1,
		250,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		205,
		212,
		234,
		237,
		273,
		-1,
		224
	],
	[
		-1,
		157,
		146,
		157,
		165,
		138,
		145,
		-1,
		166,
		168,
		134,
		128,
		167,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		157,
		156,
		126,
		124,
		133,
		138,
		145,
		-1,
		149,
		-1,
		178,
		157,
		168,
		173,
		119,
		116,
		136,
		155,
		142,
		134,
		193,
		149,
		120,
		114,
		132,
		127,
		136,
		128,
		-1,
		120,
		110,
		132,
		116,
		127,
		119,
		-1,
		-1,
		114,
		115,
		121,
		112,
		118,
		114,
		-1,
		124,
		108,
		-1,
		-1,
		104,
		110,
		94,
		97,
		105,
		103,
		116,
		108,
		103,
		-1,
		-1,
		100,
		96,
		103,
		90,
		86,
		103,
		116,
		98,
		112,
		111,
		-1,
		93,
		111,
		120,
		97,
		95,
		79,
		77,
		95,
		97,
		103,
		104,
		-1,
		102,
		103,
		98,
		106,
		111,
		95,
		82,
		82,
		92,
		85,
		104,
		93,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		85,
		102,
		94,
		84,
		99,
		92,
		85,
		82,
		80,
		77,
		93,
		92,
		102,
		-1,
		-1,
		194,
		163,
		193,
		151,
		132,
		-1,
		98,
		78,
		84,
		88,
		82,
		75,
		89,
		85,
		-1,
		71,
		70,
		99,
		85,
		96,
		154,
		-1,
		-1,
		152,
		144,
		128,
		131,
		108,
		104,
		93,
		92,
		84,
		70,
		66,
		72,
		75,
		75,
		81,
		65,
		75,
		79,
		78,
		103,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		134,
		-1,
		117,
		124,
		114,
		120,
		106,
		127,
		103,
		94,
		86,
		80,
		68,
		70,
		67,
		80,
		68,
		62,
		87,
		91,
		73,
		94,
		89,
		-1,
		144,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		110,
		113,
		119,
		143,
		143,
		-1,
		115,
		103,
		104,
		89,
		86,
		73,
		61,
		74,
		59,
		66,
		65,
		67,
		65,
		95,
		70,
		92,
		89,
		115,
		120,
		114,
		123,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		147,
		-1,
		151,
		152,
		127,
		100,
		103,
		90,
		81,
		68,
		57,
		68,
		57,
		54,
		62,
		59,
		74,
		65,
		64,
		82,
		97,
		107,
		111,
		117,
		-1,
		209,
		-1,
		151,
		135,
		137,
		109,
		130,
		-1,
		167,
		152,
		144,
		129,
		128,
		-1,
		99,
		96,
		86,
		64,
		49,
		66,
		58,
		56,
		60,
		54,
		68,
		59,
		77,
		84,
		89,
		93,
		113,
		125,
		169,
		159,
		-1,
		141,
		146,
		105,
		113,
		132,
		170,
		134,
		-1,
		129,
		-1,
		101,
		114,
		-1,
		70,
		66,
		48,
		49,
		44,
		59,
		53,
		50,
		47,
		65,
		68,
		82,
		86,
		102,
		-1,
		-1,
		154,
		158,
		147,
		98,
		117,
		141,
		178,
		127,
		116,
		115,
		-1,
		106,
		84,
		81,
		69,
		56,
		41,
		42,
		49,
		51,
		30,
		49,
		52,
		73,
		99,
		77,
		89,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		124,
		95,
		119,
		161,
		145,
		138,
		126,
		91,
		91,
		85,
		-1,
		80,
		59,
		50,
		39,
		37,
		39,
		31,
		46,
		51,
		49,
		68,
		80,
		71,
		91,
		-1,
		-1,
		-1,
		154,
		143,
		144,
		90,
		113,
		150,
		124,
		110,
		115,
		90,
		83,
		77,
		93,
		76,
		57,
		46,
		37,
		27,
		27,
		35,
		33,
		47,
		56,
		62,
		86,
		93,
		99,
		-1,
		-1,
		161,
		151,
		135,
		137,
		134,
		104,
		111,
		143,
		115,
		128,
		-1,
		82,
		-1,
		71,
		67,
		51,
		46,
		43,
		31,
		18,
		20,
		35,
		52,
		49,
		54,
		91,
		91,
		83,
		108,
		111,
		-1,
		-1,
		-1,
		154,
		149,
		124,
		101,
		85,
		121,
		-1,
		98,
		99,
		-1,
		76,
		70,
		67,
		53,
		49,
		35,
		39,
		28,
		0,
		20,
		35,
		48,
		41,
		77,
		-1,
		91,
		85,
		99,
		89,
		77,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		80,
		132,
		-1,
		-1,
		83,
		76,
		-1,
		63,
		45,
		47,
		42,
		41,
		34,
		32,
		21,
		31,
		39,
		46,
		50,
		76,
		80,
		90,
		79,
		75,
		72,
		86,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		100,
		-1,
		92,
		84,
		74,
		68,
		62,
		58,
		56,
		69,
		53,
		50,
		44,
		33,
		43,
		28,
		31,
		47,
		53,
		71,
		85,
		77,
		71,
		70,
		82,
		-1,
		167,
		153,
		124,
		-1,
		-1,
		113,
		-1,
		77,
		91,
		107,
		-1,
		100,
		79,
		94,
		72,
		68,
		59,
		76,
		77,
		55,
		44,
		42,
		52,
		53,
		42,
		61,
		59,
		80,
		81,
		65,
		66,
		75,
		-1,
		173,
		160,
		118,
		114,
		103,
		123,
		74,
		62,
		94,
		-1,
		-1,
		136,
		-1,
		70,
		87,
		73,
		71,
		66,
		57,
		63,
		53,
		56,
		57,
		47,
		36,
		42,
		53,
		75,
		61,
		59,
		78,
		94,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		89,
		76,
		70,
		-1,
		111,
		-1,
		114,
		104,
		88,
		73,
		106,
		-1,
		74,
		58,
		63,
		-1,
		82,
		-1,
		55,
		57,
		55,
		47,
		47,
		58,
		56,
		67,
		84,
		-1,
		123,
		108,
		101,
		91,
		105,
		76,
		-1,
		131,
		-1,
		-1,
		101,
		95,
		95,
		79,
		82,
		90,
		70,
		64,
		63,
		77,
		85,
		63,
		60,
		53,
		50,
		50,
		63,
		83,
		74,
		86,
		-1,
		-1,
		-1,
		128,
		114,
		118,
		78,
		97,
		-1,
		-1,
		163,
		118,
		104,
		-1,
		88,
		107,
		95,
		85,
		75,
		109,
		97,
		76,
		72,
		58,
		60,
		58,
		59,
		64,
		85,
		86,
		99,
		-1,
		-1,
		111,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		110,
		126,
		118,
		89,
		96,
		-1,
		-1,
		87,
		85,
		89,
		75,
		62,
		82,
		85,
		74,
		58,
		73,
		85,
		93,
		98,
		-1,
		114,
		101,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		120,
		115,
		119,
		90,
		-1,
		91,
		86,
		66,
		80,
		87,
		76,
		71,
		65,
		68,
		86,
		103,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		100,
		114,
		108,
		101,
		105,
		-1,
		93,
		82,
		68,
		85,
		89,
		86,
		77,
		69,
		74,
		71,
		84,
		98,
		102,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		118,
		133,
		147,
		124,
		97,
		92,
		85,
		79,
		76,
		92,
		97,
		108,
		76,
		72,
		73,
		77,
		76,
		93,
		103,
		-1,
		-1,
		132,
		149,
		144,
		126,
		130,
		174,
		-1,
		-1,
		101,
		92,
		83,
		86,
		86,
		89,
		82,
		79,
		84,
		89,
		77,
		86,
		104,
		108,
		-1,
		-1,
		-1,
		152,
		-1,
		167,
		-1,
		-1,
		145,
		172,
		119,
		101,
		97,
		95,
		88,
		97,
		92,
		87,
		97,
		107,
		99,
		79,
		92,
		114,
		104,
		140,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		183,
		165,
		172,
		134,
		131,
		-1,
		101,
		126,
		98,
		105,
		97,
		105,
		105,
		103,
		82,
		89,
		105,
		104,
		99,
		132,
		126,
		132,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		183,
		173,
		169,
		159,
		162,
		-1,
		-1,
		150,
		147,
		123,
		107,
		111,
		104,
		99,
		111,
		91,
		78,
		82,
		86,
		92,
		97,
		102,
		108,
		123,
		138,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		173,
		165,
		176,
		151,
		153,
		-1,
		-1,
		123,
		120,
		125,
		114,
		111,
		121,
		116,
		107,
		92,
		98,
		85,
		84,
		102,
		106,
		115,
		122,
		112,
		125,
		129,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		170,
		-1,
		-1,
		182,
		154,
		138,
		128,
		122,
		172,
		128,
		123,
		115,
		113,
		104,
		95,
		102,
		93,
		93,
		96,
		111,
		116,
		108,
		122,
		122,
		123,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		198,
		-1,
		165,
		-1,
		140,
		144,
		136,
		139,
		129,
		116,
		108,
		100,
		116,
		91,
		101,
		97,
		98,
		107,
		118,
		130,
		129,
		130,
		242,
		198,
		201,
		195,
		223,
		238,
		242,
		-1,
		182,
		221,
		228,
		-1,
		207,
		-1,
		-1,
		-1,
		154,
		149,
		141,
		149,
		128,
		128,
		102,
		106,
		96,
		103,
		113,
		115,
		107,
		111,
		124,
		135,
		138,
		238,
		229,
		242,
		187,
		187,
		208,
		217,
		238,
		197,
		188,
		215,
		235,
		224,
		219,
		206,
		-1,
		-1,
		177,
		159,
		-1,
		-1,
		135,
		123,
		106,
		107,
		103,
		106,
		121,
		124,
		114,
		112,
		106,
		138,
		-1,
		231,
		230,
		219,
		216,
		192,
		183,
		178,
		205,
		-1,
		-1,
		200,
		216,
		211,
		215,
		231,
		256,
		-1,
		195,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		128,
		117,
		108,
		114,
		111,
		122,
		132,
		120,
		121,
		111,
		121,
		134,
		215,
		212,
		200,
		198,
		221,
		186,
		174,
		-1,
		187,
		185,
		191,
		198,
		215,
		245,
		-1,
		-1,
		211,
		191,
		-1,
		-1,
		163,
		161,
		150,
		-1,
		140,
		113,
		118,
		138,
		140,
		129,
		123,
		117,
		124,
		123,
		131,
		139,
		224,
		238,
		227,
		223,
		222,
		230,
		179,
		172,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		197,
		-1,
		-1,
		158,
		151,
		139,
		127,
		117,
		127,
		131,
		135,
		127,
		120,
		115,
		126,
		118,
		122,
		139,
		-1,
		258,
		-1,
		210,
		186,
		200,
		215,
		223,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		192,
		176,
		157,
		-1,
		127,
		140,
		171,
		139,
		144,
		139,
		121,
		132,
		121,
		124,
		138,
		133,
		-1,
		-1,
		198,
		201,
		-1,
		-1,
		208,
		210,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		164,
		160,
		-1,
		-1,
		128,
		153,
		142,
		150,
		145,
		125,
		131,
		134,
		123,
		127,
		139,
		-1,
		-1,
		205,
		206,
		211,
		-1,
		193,
		-1,
		211,
		-1,
		178,
		184,
		172,
		-1,
		-1,
		-1,
		166,
		129,
		150,
		160,
		154,
		152,
		143,
		129,
		136,
		134,
		130,
		141,
		-1,
		-1,
		-1,
		211,
		185,
		218,
		209,
		192,
		172,
		164,
		183,
		-1,
		153,
		-1,
		128,
		130,
		156,
		159,
		165,
		159,
		132,
		147,
		137,
		128,
		137,
		217,
		-1,
		187,
		220,
		184,
		178,
		154,
		158,
		174,
		-1,
		150,
		132,
		-1,
		160,
		150,
		181,
		166,
		147,
		134,
		141,
		141,
		134,
		-1,
		-1,
		-1,
		189,
		188,
		180,
		174,
		174,
		159,
		150,
		-1,
		162,
		144,
		123,
		140,
		140,
		131,
		139,
		171,
		167,
		154,
		154,
		146,
		-1,
		290,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		183,
		178,
		151,
		139,
		145,
		141,
		127,
		133,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		147,
		182,
		-1,
		285,
		-1,
		219,
		-1,
		-1,
		201,
		181,
		173,
		162,
		151,
		149,
		140,
		131,
		153,
		169,
		153,
		151,
		154,
		155,
		-1,
		274,
		273,
		-1,
		220,
		212,
		198,
		-1,
		191,
		-1,
		197,
		158,
		-1,
		160,
		140,
		-1,
		162,
		158,
		-1,
		-1,
		261,
		236,
		-1,
		-1,
		-1,
		221,
		201,
		192,
		176,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		246,
		245,
		-1,
		214,
		217,
		-1,
		207,
		198,
		206,
		153,
		157,
		-1,
		-1,
		-1,
		255,
		236,
		230,
		229,
		227,
		222,
		219,
		205,
		189,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		227,
		219,
		212,
		-1,
		-1,
		214,
		197,
		178,
		176,
		-1,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		204,
		-1,
		-1,
		210,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		238,
		-1,
		-1,
		-1,
		200,
		196,
		197,
		-1,
		-1,
		-1,
		-1,
		260,
		261,
		284,
		248,
		-1,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		263,
		261,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		190,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		225,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		238,
		230,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		215,
		222,
		244,
		247,
		283,
		-1,
		234
	],
	[
		-1,
		154,
		143,
		154,
		162,
		135,
		142,
		-1,
		163,
		165,
		131,
		125,
		164,
		135,
		141,
		152,
		-1,
		-1,
		-1,
		154,
		153,
		123,
		121,
		130,
		135,
		142,
		-1,
		146,
		-1,
		175,
		154,
		165,
		170,
		116,
		113,
		133,
		152,
		139,
		131,
		190,
		146,
		117,
		111,
		129,
		124,
		133,
		125,
		-1,
		117,
		107,
		129,
		113,
		124,
		116,
		-1,
		-1,
		111,
		112,
		118,
		109,
		115,
		111,
		-1,
		121,
		105,
		-1,
		-1,
		101,
		107,
		91,
		94,
		102,
		100,
		113,
		105,
		100,
		-1,
		-1,
		97,
		93,
		100,
		87,
		83,
		100,
		113,
		95,
		109,
		108,
		-1,
		90,
		108,
		117,
		94,
		92,
		76,
		74,
		92,
		94,
		100,
		100,
		-1,
		99,
		100,
		95,
		103,
		108,
		92,
		79,
		79,
		89,
		82,
		101,
		89,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		99,
		82,
		99,
		91,
		81,
		96,
		89,
		82,
		79,
		77,
		74,
		90,
		88,
		98,
		-1,
		-1,
		191,
		160,
		190,
		148,
		129,
		-1,
		95,
		75,
		81,
		85,
		79,
		72,
		86,
		82,
		-1,
		68,
		67,
		95,
		81,
		92,
		151,
		-1,
		-1,
		149,
		141,
		125,
		128,
		105,
		101,
		90,
		89,
		81,
		67,
		63,
		69,
		72,
		72,
		78,
		62,
		72,
		76,
		74,
		99,
		-1,
		-1,
		134,
		-1,
		-1,
		148,
		131,
		-1,
		114,
		121,
		111,
		117,
		103,
		124,
		100,
		91,
		83,
		77,
		65,
		67,
		64,
		77,
		65,
		59,
		84,
		88,
		69,
		90,
		85,
		-1,
		133,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		107,
		110,
		116,
		140,
		140,
		-1,
		112,
		100,
		101,
		86,
		83,
		70,
		58,
		71,
		56,
		63,
		62,
		63,
		61,
		91,
		66,
		88,
		85,
		104,
		109,
		103,
		112,
		-1,
		156,
		152,
		148,
		155,
		104,
		-1,
		-1,
		144,
		-1,
		148,
		149,
		124,
		97,
		100,
		87,
		78,
		65,
		54,
		65,
		54,
		51,
		59,
		55,
		70,
		61,
		60,
		78,
		88,
		96,
		100,
		106,
		-1,
		206,
		-1,
		148,
		132,
		134,
		106,
		127,
		-1,
		164,
		149,
		141,
		126,
		125,
		-1,
		96,
		93,
		83,
		61,
		46,
		63,
		55,
		53,
		58,
		50,
		64,
		55,
		73,
		80,
		78,
		82,
		102,
		114,
		166,
		156,
		-1,
		138,
		143,
		102,
		110,
		129,
		167,
		131,
		-1,
		126,
		-1,
		98,
		111,
		-1,
		67,
		63,
		45,
		46,
		41,
		56,
		53,
		46,
		43,
		61,
		64,
		71,
		75,
		91,
		-1,
		-1,
		151,
		155,
		144,
		95,
		114,
		138,
		175,
		124,
		113,
		112,
		-1,
		103,
		81,
		78,
		66,
		53,
		38,
		39,
		47,
		51,
		30,
		45,
		42,
		62,
		88,
		66,
		78,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		121,
		92,
		116,
		158,
		142,
		135,
		123,
		88,
		88,
		82,
		-1,
		77,
		56,
		47,
		36,
		34,
		39,
		31,
		47,
		40,
		38,
		57,
		69,
		60,
		80,
		-1,
		-1,
		-1,
		151,
		140,
		141,
		87,
		110,
		147,
		121,
		107,
		112,
		87,
		80,
		74,
		90,
		73,
		54,
		43,
		35,
		24,
		27,
		35,
		34,
		36,
		45,
		51,
		75,
		82,
		88,
		-1,
		-1,
		158,
		148,
		132,
		134,
		131,
		101,
		108,
		140,
		112,
		125,
		-1,
		79,
		-1,
		68,
		64,
		48,
		43,
		40,
		28,
		18,
		21,
		33,
		41,
		38,
		43,
		80,
		80,
		72,
		97,
		100,
		-1,
		-1,
		-1,
		151,
		146,
		121,
		98,
		82,
		118,
		-1,
		95,
		96,
		-1,
		73,
		67,
		64,
		50,
		46,
		32,
		36,
		32,
		26,
		0,
		24,
		31,
		30,
		66,
		-1,
		80,
		74,
		89,
		79,
		67,
		-1,
		-1,
		-1,
		144,
		123,
		116,
		136,
		77,
		129,
		-1,
		-1,
		80,
		73,
		-1,
		60,
		42,
		44,
		39,
		38,
		34,
		22,
		11,
		21,
		25,
		35,
		40,
		65,
		69,
		80,
		69,
		65,
		62,
		76,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		97,
		-1,
		89,
		81,
		71,
		65,
		59,
		55,
		53,
		66,
		50,
		49,
		34,
		25,
		33,
		18,
		21,
		37,
		42,
		60,
		75,
		67,
		61,
		60,
		72,
		-1,
		164,
		150,
		121,
		-1,
		-1,
		110,
		-1,
		74,
		88,
		104,
		-1,
		97,
		76,
		91,
		69,
		65,
		56,
		72,
		73,
		46,
		34,
		32,
		42,
		43,
		32,
		50,
		49,
		69,
		71,
		55,
		56,
		65,
		-1,
		170,
		157,
		115,
		111,
		100,
		120,
		71,
		59,
		91,
		-1,
		-1,
		133,
		-1,
		67,
		84,
		70,
		68,
		62,
		48,
		54,
		43,
		46,
		47,
		37,
		26,
		32,
		43,
		65,
		51,
		49,
		68,
		84,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		86,
		73,
		67,
		-1,
		108,
		-1,
		111,
		101,
		85,
		70,
		103,
		-1,
		65,
		49,
		54,
		-1,
		72,
		-1,
		45,
		47,
		45,
		37,
		37,
		48,
		46,
		57,
		74,
		-1,
		120,
		105,
		98,
		88,
		102,
		73,
		-1,
		128,
		-1,
		-1,
		98,
		92,
		92,
		76,
		79,
		81,
		61,
		55,
		54,
		67,
		75,
		53,
		50,
		43,
		40,
		40,
		53,
		73,
		64,
		76,
		-1,
		-1,
		-1,
		125,
		111,
		115,
		75,
		94,
		-1,
		-1,
		160,
		115,
		101,
		-1,
		85,
		98,
		86,
		76,
		66,
		99,
		87,
		66,
		62,
		48,
		50,
		48,
		49,
		54,
		75,
		76,
		89,
		-1,
		-1,
		108,
		113,
		101,
		87,
		106,
		-1,
		-1,
		-1,
		107,
		123,
		115,
		86,
		87,
		-1,
		-1,
		78,
		76,
		79,
		65,
		52,
		72,
		75,
		64,
		48,
		63,
		75,
		83,
		88,
		-1,
		111,
		98,
		-1,
		-1,
		109,
		103,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		110,
		105,
		109,
		81,
		-1,
		81,
		76,
		56,
		70,
		77,
		66,
		61,
		55,
		58,
		76,
		93,
		-1,
		-1,
		123,
		-1,
		118,
		-1,
		-1,
		-1,
		-1,
		97,
		111,
		98,
		91,
		95,
		-1,
		83,
		72,
		58,
		75,
		79,
		76,
		67,
		59,
		64,
		61,
		74,
		88,
		92,
		146,
		-1,
		129,
		-1,
		-1,
		-1,
		115,
		130,
		137,
		114,
		87,
		82,
		75,
		69,
		66,
		82,
		87,
		98,
		66,
		62,
		63,
		67,
		66,
		83,
		93,
		-1,
		-1,
		129,
		146,
		141,
		123,
		127,
		164,
		-1,
		-1,
		91,
		82,
		73,
		76,
		76,
		79,
		72,
		69,
		74,
		79,
		67,
		76,
		94,
		98,
		-1,
		-1,
		-1,
		149,
		-1,
		164,
		-1,
		-1,
		142,
		162,
		109,
		91,
		87,
		85,
		78,
		87,
		82,
		77,
		87,
		97,
		89,
		69,
		82,
		104,
		94,
		130,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		178,
		153,
		167,
		173,
		162,
		166,
		124,
		121,
		-1,
		91,
		116,
		88,
		95,
		87,
		95,
		95,
		93,
		72,
		79,
		95,
		94,
		89,
		122,
		116,
		122,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		173,
		169,
		159,
		149,
		152,
		-1,
		-1,
		140,
		137,
		113,
		97,
		101,
		94,
		89,
		101,
		81,
		68,
		72,
		76,
		82,
		87,
		92,
		98,
		113,
		128,
		-1,
		156,
		237,
		230,
		213,
		221,
		252,
		-1,
		163,
		155,
		166,
		141,
		143,
		-1,
		-1,
		113,
		110,
		115,
		104,
		101,
		111,
		106,
		97,
		82,
		88,
		75,
		74,
		92,
		96,
		105,
		112,
		102,
		115,
		119,
		-1,
		170,
		213,
		207,
		210,
		234,
		248,
		-1,
		160,
		-1,
		-1,
		172,
		144,
		128,
		118,
		112,
		162,
		118,
		113,
		105,
		103,
		94,
		85,
		92,
		83,
		83,
		86,
		101,
		106,
		98,
		112,
		112,
		113,
		-1,
		205,
		193,
		201,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		188,
		-1,
		155,
		-1,
		130,
		134,
		126,
		129,
		119,
		106,
		98,
		90,
		106,
		81,
		91,
		87,
		88,
		97,
		108,
		120,
		119,
		120,
		232,
		188,
		191,
		192,
		213,
		228,
		232,
		-1,
		172,
		211,
		218,
		-1,
		197,
		-1,
		-1,
		-1,
		144,
		139,
		131,
		139,
		118,
		118,
		92,
		96,
		86,
		93,
		103,
		105,
		97,
		101,
		114,
		125,
		128,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		187,
		178,
		205,
		225,
		214,
		209,
		196,
		-1,
		-1,
		167,
		149,
		-1,
		-1,
		125,
		113,
		96,
		97,
		93,
		96,
		111,
		114,
		104,
		102,
		96,
		128,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		206,
		201,
		205,
		221,
		246,
		-1,
		185,
		-1,
		-1,
		170,
		-1,
		-1,
		155,
		118,
		107,
		98,
		104,
		101,
		112,
		122,
		110,
		111,
		101,
		111,
		124,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		235,
		-1,
		-1,
		201,
		181,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		108,
		128,
		130,
		119,
		113,
		107,
		114,
		113,
		121,
		129,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		187,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		121,
		125,
		117,
		110,
		105,
		116,
		108,
		112,
		129,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		161,
		129,
		134,
		129,
		111,
		122,
		111,
		114,
		128,
		123,
		-1,
		-1,
		188,
		191,
		-1,
		-1,
		198,
		200,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		143,
		132,
		140,
		135,
		115,
		121,
		124,
		113,
		117,
		129,
		-1,
		-1,
		195,
		196,
		201,
		-1,
		183,
		-1,
		201,
		-1,
		168,
		174,
		162,
		-1,
		-1,
		-1,
		156,
		119,
		140,
		150,
		144,
		142,
		133,
		119,
		126,
		124,
		120,
		131,
		-1,
		-1,
		-1,
		201,
		175,
		208,
		199,
		182,
		162,
		154,
		173,
		-1,
		143,
		-1,
		118,
		120,
		146,
		149,
		155,
		149,
		122,
		137,
		127,
		118,
		127,
		207,
		-1,
		177,
		210,
		174,
		168,
		144,
		148,
		164,
		-1,
		140,
		122,
		-1,
		150,
		140,
		171,
		156,
		137,
		124,
		131,
		131,
		124,
		-1,
		-1,
		-1,
		179,
		178,
		170,
		164,
		164,
		149,
		140,
		-1,
		152,
		134,
		113,
		130,
		130,
		121,
		129,
		161,
		157,
		144,
		144,
		136,
		-1,
		280,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		173,
		168,
		141,
		129,
		135,
		131,
		117,
		123,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		137,
		172,
		-1,
		275,
		-1,
		209,
		-1,
		-1,
		191,
		171,
		163,
		152,
		141,
		139,
		130,
		121,
		143,
		159,
		143,
		141,
		144,
		145,
		-1,
		264,
		263,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		187,
		148,
		-1,
		150,
		130,
		-1,
		152,
		148,
		-1,
		-1,
		251,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		182,
		166,
		-1,
		141,
		141,
		-1,
		-1,
		-1,
		236,
		235,
		-1,
		204,
		207,
		-1,
		197,
		188,
		196,
		143,
		147,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		219,
		217,
		212,
		209,
		195,
		179,
		157,
		146,
		167,
		-1,
		-1,
		-1,
		217,
		209,
		202,
		-1,
		-1,
		204,
		187,
		168,
		166,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		194,
		-1,
		-1,
		200,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		228,
		-1,
		-1,
		-1,
		190,
		186,
		187,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		274,
		238,
		-1,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		210,
		194,
		-1,
		180,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		215,
		-1,
		215,
		190,
		197,
		-1,
		-1,
		-1,
		-1,
		228,
		220,
		228,
		-1,
		200,
		202,
		-1,
		250,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		205,
		212,
		234,
		237,
		273,
		-1,
		224
	],
	[
		-1,
		148,
		137,
		148,
		156,
		129,
		136,
		-1,
		155,
		159,
		125,
		119,
		158,
		127,
		133,
		144,
		-1,
		-1,
		-1,
		148,
		147,
		115,
		113,
		122,
		127,
		134,
		-1,
		133,
		-1,
		169,
		148,
		159,
		164,
		108,
		105,
		125,
		144,
		126,
		118,
		184,
		138,
		109,
		103,
		121,
		111,
		120,
		112,
		-1,
		109,
		99,
		121,
		100,
		111,
		103,
		-1,
		-1,
		103,
		104,
		110,
		96,
		102,
		98,
		-1,
		108,
		92,
		-1,
		-1,
		93,
		94,
		78,
		81,
		89,
		87,
		100,
		92,
		87,
		-1,
		-1,
		84,
		80,
		87,
		74,
		70,
		87,
		100,
		82,
		96,
		95,
		-1,
		96,
		113,
		113,
		81,
		79,
		63,
		61,
		79,
		81,
		87,
		87,
		-1,
		106,
		107,
		102,
		108,
		103,
		79,
		66,
		66,
		76,
		69,
		88,
		76,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		89,
		106,
		98,
		88,
		100,
		96,
		69,
		66,
		64,
		61,
		77,
		75,
		85,
		-1,
		-1,
		199,
		168,
		197,
		155,
		136,
		-1,
		102,
		82,
		88,
		92,
		86,
		79,
		93,
		85,
		-1,
		55,
		54,
		82,
		68,
		79,
		159,
		-1,
		-1,
		157,
		149,
		132,
		135,
		112,
		108,
		97,
		96,
		88,
		74,
		70,
		76,
		79,
		79,
		85,
		49,
		59,
		63,
		61,
		86,
		-1,
		-1,
		121,
		-1,
		-1,
		156,
		139,
		-1,
		122,
		129,
		118,
		124,
		110,
		131,
		107,
		98,
		90,
		84,
		72,
		74,
		71,
		84,
		71,
		46,
		71,
		75,
		56,
		77,
		72,
		-1,
		120,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		115,
		118,
		124,
		148,
		147,
		-1,
		119,
		107,
		108,
		93,
		90,
		77,
		65,
		78,
		63,
		70,
		68,
		50,
		48,
		78,
		53,
		75,
		72,
		91,
		96,
		90,
		99,
		-1,
		164,
		160,
		156,
		163,
		112,
		-1,
		-1,
		152,
		-1,
		155,
		156,
		131,
		104,
		107,
		94,
		85,
		72,
		61,
		72,
		61,
		58,
		62,
		42,
		57,
		48,
		47,
		65,
		75,
		83,
		87,
		93,
		-1,
		214,
		-1,
		156,
		140,
		142,
		114,
		135,
		-1,
		172,
		156,
		148,
		133,
		133,
		-1,
		103,
		100,
		90,
		68,
		53,
		70,
		62,
		60,
		55,
		37,
		51,
		42,
		60,
		67,
		65,
		69,
		89,
		101,
		174,
		164,
		-1,
		146,
		151,
		110,
		118,
		137,
		175,
		139,
		-1,
		134,
		-1,
		105,
		118,
		-1,
		74,
		70,
		52,
		53,
		48,
		63,
		48,
		33,
		30,
		48,
		51,
		58,
		62,
		78,
		-1,
		-1,
		159,
		163,
		152,
		103,
		122,
		146,
		183,
		132,
		121,
		120,
		-1,
		111,
		88,
		85,
		73,
		60,
		45,
		46,
		54,
		52,
		31,
		32,
		29,
		49,
		75,
		53,
		65,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		129,
		100,
		124,
		166,
		150,
		143,
		131,
		96,
		96,
		90,
		-1,
		84,
		63,
		54,
		43,
		41,
		44,
		35,
		33,
		27,
		25,
		44,
		56,
		47,
		67,
		-1,
		-1,
		-1,
		159,
		148,
		149,
		95,
		118,
		155,
		129,
		115,
		120,
		95,
		88,
		82,
		97,
		80,
		61,
		50,
		42,
		31,
		32,
		28,
		20,
		23,
		32,
		38,
		62,
		69,
		75,
		-1,
		-1,
		166,
		156,
		140,
		142,
		139,
		109,
		116,
		148,
		120,
		133,
		-1,
		87,
		-1,
		76,
		71,
		55,
		50,
		47,
		37,
		24,
		18,
		19,
		26,
		25,
		28,
		67,
		67,
		59,
		84,
		87,
		-1,
		-1,
		-1,
		159,
		154,
		129,
		106,
		90,
		126,
		-1,
		103,
		104,
		-1,
		81,
		75,
		72,
		57,
		53,
		41,
		45,
		39,
		30,
		20,
		0,
		23,
		17,
		53,
		-1,
		67,
		61,
		89,
		82,
		70,
		-1,
		-1,
		-1,
		152,
		131,
		124,
		144,
		85,
		137,
		-1,
		-1,
		88,
		81,
		-1,
		68,
		50,
		53,
		48,
		47,
		46,
		37,
		26,
		28,
		20,
		22,
		31,
		52,
		56,
		80,
		72,
		68,
		65,
		79,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		105,
		-1,
		97,
		89,
		79,
		73,
		67,
		63,
		61,
		75,
		59,
		58,
		49,
		40,
		48,
		31,
		29,
		25,
		29,
		47,
		76,
		70,
		64,
		63,
		75,
		-1,
		172,
		158,
		129,
		-1,
		-1,
		118,
		-1,
		82,
		96,
		112,
		-1,
		105,
		84,
		99,
		77,
		73,
		65,
		82,
		83,
		61,
		49,
		47,
		57,
		51,
		40,
		37,
		41,
		56,
		66,
		58,
		59,
		68,
		-1,
		178,
		165,
		123,
		119,
		108,
		128,
		79,
		67,
		99,
		-1,
		-1,
		141,
		-1,
		75,
		92,
		79,
		77,
		72,
		63,
		69,
		58,
		60,
		55,
		45,
		34,
		40,
		46,
		68,
		54,
		52,
		71,
		87,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		94,
		81,
		75,
		-1,
		116,
		-1,
		119,
		109,
		93,
		78,
		111,
		-1,
		80,
		64,
		69,
		-1,
		80,
		-1,
		53,
		55,
		53,
		43,
		40,
		51,
		49,
		60,
		77,
		-1,
		128,
		113,
		106,
		96,
		110,
		81,
		-1,
		136,
		-1,
		-1,
		106,
		100,
		100,
		84,
		87,
		96,
		76,
		70,
		69,
		75,
		80,
		61,
		52,
		45,
		42,
		43,
		56,
		76,
		67,
		79,
		-1,
		-1,
		-1,
		133,
		119,
		123,
		83,
		102,
		-1,
		-1,
		168,
		123,
		109,
		-1,
		93,
		113,
		101,
		91,
		81,
		106,
		95,
		71,
		64,
		50,
		52,
		50,
		52,
		57,
		78,
		79,
		92,
		-1,
		-1,
		116,
		121,
		109,
		95,
		114,
		-1,
		-1,
		-1,
		115,
		131,
		123,
		94,
		102,
		-1,
		-1,
		93,
		91,
		87,
		67,
		54,
		74,
		77,
		67,
		51,
		66,
		78,
		86,
		91,
		-1,
		119,
		106,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		113,
		108,
		112,
		96,
		-1,
		84,
		78,
		58,
		72,
		79,
		69,
		64,
		58,
		61,
		79,
		96,
		-1,
		-1,
		131,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		105,
		119,
		101,
		94,
		98,
		-1,
		86,
		74,
		60,
		77,
		82,
		79,
		70,
		62,
		67,
		64,
		77,
		91,
		95,
		154,
		-1,
		137,
		-1,
		-1,
		-1,
		123,
		138,
		140,
		117,
		90,
		85,
		78,
		72,
		68,
		84,
		90,
		101,
		69,
		65,
		66,
		70,
		69,
		86,
		96,
		-1,
		-1,
		137,
		154,
		149,
		131,
		135,
		167,
		-1,
		-1,
		94,
		85,
		76,
		79,
		78,
		81,
		75,
		72,
		77,
		82,
		70,
		79,
		97,
		96,
		-1,
		-1,
		-1,
		157,
		-1,
		172,
		-1,
		-1,
		150,
		165,
		112,
		94,
		90,
		88,
		81,
		90,
		85,
		80,
		90,
		92,
		84,
		72,
		76,
		99,
		88,
		127,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		183,
		161,
		170,
		176,
		170,
		169,
		127,
		124,
		-1,
		94,
		119,
		91,
		98,
		89,
		96,
		96,
		88,
		66,
		73,
		89,
		88,
		83,
		119,
		110,
		116,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		176,
		172,
		162,
		152,
		155,
		-1,
		-1,
		143,
		140,
		116,
		99,
		97,
		90,
		85,
		95,
		75,
		62,
		66,
		70,
		76,
		81,
		86,
		92,
		107,
		122,
		-1,
		164,
		245,
		238,
		221,
		229,
		260,
		-1,
		166,
		158,
		169,
		144,
		146,
		-1,
		-1,
		116,
		113,
		118,
		106,
		103,
		105,
		100,
		91,
		76,
		82,
		69,
		68,
		86,
		90,
		99,
		106,
		96,
		109,
		113,
		-1,
		178,
		221,
		215,
		218,
		242,
		256,
		-1,
		163,
		-1,
		-1,
		175,
		147,
		131,
		121,
		115,
		165,
		120,
		115,
		99,
		97,
		88,
		79,
		86,
		77,
		77,
		80,
		95,
		100,
		92,
		106,
		106,
		107,
		-1,
		209,
		201,
		209,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		191,
		-1,
		158,
		-1,
		133,
		137,
		128,
		131,
		113,
		100,
		92,
		84,
		100,
		75,
		85,
		81,
		82,
		91,
		102,
		114,
		113,
		114,
		234,
		190,
		193,
		200,
		215,
		230,
		234,
		-1,
		175,
		214,
		212,
		-1,
		196,
		-1,
		-1,
		-1,
		147,
		141,
		133,
		133,
		112,
		112,
		86,
		90,
		80,
		87,
		97,
		99,
		91,
		95,
		108,
		119,
		122,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		190,
		181,
		208,
		219,
		208,
		203,
		190,
		-1,
		-1,
		170,
		151,
		-1,
		-1,
		119,
		107,
		90,
		91,
		87,
		90,
		105,
		108,
		98,
		96,
		90,
		122,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		209,
		203,
		207,
		223,
		248,
		-1,
		179,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		112,
		101,
		92,
		98,
		95,
		106,
		116,
		104,
		105,
		95,
		105,
		118,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		195,
		175,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		97,
		102,
		122,
		124,
		113,
		107,
		101,
		108,
		107,
		115,
		123,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		181,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		115,
		119,
		111,
		104,
		99,
		110,
		102,
		106,
		123,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		105,
		116,
		105,
		108,
		122,
		117,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		192,
		194,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		109,
		115,
		118,
		107,
		111,
		123,
		-1,
		-1,
		197,
		198,
		199,
		-1,
		177,
		-1,
		195,
		-1,
		162,
		168,
		156,
		-1,
		-1,
		-1,
		150,
		113,
		134,
		144,
		138,
		136,
		127,
		113,
		120,
		118,
		114,
		125,
		-1,
		-1,
		-1,
		195,
		169,
		202,
		193,
		176,
		156,
		148,
		167,
		-1,
		137,
		-1,
		112,
		114,
		140,
		143,
		149,
		143,
		116,
		131,
		121,
		112,
		121,
		201,
		-1,
		171,
		204,
		168,
		162,
		138,
		142,
		158,
		-1,
		134,
		116,
		-1,
		144,
		134,
		165,
		150,
		131,
		118,
		125,
		125,
		118,
		-1,
		-1,
		-1,
		173,
		172,
		164,
		158,
		158,
		143,
		134,
		-1,
		146,
		128,
		107,
		124,
		124,
		115,
		123,
		155,
		151,
		138,
		138,
		130,
		-1,
		274,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		167,
		162,
		135,
		123,
		129,
		125,
		111,
		117,
		119,
		127,
		125,
		122,
		134,
		130,
		150,
		131,
		166,
		-1,
		269,
		-1,
		203,
		-1,
		-1,
		185,
		165,
		157,
		146,
		135,
		133,
		124,
		115,
		137,
		153,
		137,
		135,
		138,
		139,
		-1,
		258,
		257,
		-1,
		204,
		196,
		182,
		-1,
		175,
		-1,
		181,
		142,
		-1,
		144,
		124,
		-1,
		146,
		142,
		-1,
		-1,
		245,
		220,
		-1,
		-1,
		-1,
		205,
		185,
		176,
		160,
		-1,
		135,
		135,
		-1,
		-1,
		-1,
		230,
		229,
		-1,
		198,
		201,
		-1,
		191,
		182,
		190,
		137,
		141,
		-1,
		-1,
		-1,
		239,
		220,
		214,
		213,
		211,
		206,
		203,
		189,
		173,
		151,
		140,
		161,
		-1,
		-1,
		-1,
		211,
		203,
		196,
		-1,
		-1,
		198,
		181,
		162,
		160,
		-1,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		188,
		-1,
		-1,
		194,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		222,
		-1,
		-1,
		-1,
		184,
		180,
		181,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		268,
		232,
		-1,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		247,
		245,
		-1,
		-1,
		-1,
		204,
		188,
		-1,
		174,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		209,
		-1,
		209,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		222,
		214,
		222,
		-1,
		194,
		196,
		-1,
		244,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		199,
		206,
		228,
		231,
		267,
		-1,
		218
	],
	[
		-1,
		151,
		140,
		151,
		159,
		132,
		139,
		-1,
		158,
		162,
		128,
		122,
		161,
		130,
		136,
		147,
		-1,
		-1,
		-1,
		151,
		150,
		118,
		116,
		125,
		130,
		137,
		-1,
		136,
		-1,
		172,
		151,
		162,
		167,
		111,
		108,
		128,
		147,
		129,
		121,
		187,
		141,
		112,
		106,
		124,
		114,
		123,
		115,
		-1,
		112,
		102,
		124,
		103,
		114,
		106,
		-1,
		-1,
		106,
		107,
		113,
		99,
		105,
		101,
		-1,
		111,
		95,
		-1,
		-1,
		96,
		97,
		81,
		84,
		92,
		90,
		103,
		95,
		90,
		-1,
		-1,
		87,
		83,
		90,
		77,
		73,
		90,
		103,
		85,
		99,
		98,
		-1,
		99,
		116,
		116,
		84,
		82,
		66,
		64,
		82,
		84,
		90,
		90,
		-1,
		116,
		112,
		113,
		111,
		106,
		82,
		69,
		69,
		79,
		72,
		91,
		79,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		117,
		106,
		123,
		109,
		99,
		103,
		101,
		72,
		69,
		67,
		64,
		80,
		78,
		88,
		-1,
		-1,
		210,
		183,
		207,
		165,
		147,
		-1,
		113,
		99,
		105,
		103,
		97,
		90,
		103,
		88,
		-1,
		58,
		57,
		85,
		71,
		82,
		176,
		-1,
		-1,
		168,
		160,
		142,
		145,
		122,
		118,
		114,
		113,
		105,
		91,
		87,
		87,
		90,
		90,
		96,
		52,
		62,
		66,
		64,
		89,
		-1,
		-1,
		124,
		-1,
		-1,
		173,
		156,
		-1,
		137,
		144,
		128,
		134,
		120,
		141,
		124,
		115,
		107,
		101,
		89,
		85,
		82,
		95,
		74,
		49,
		74,
		78,
		59,
		80,
		75,
		-1,
		123,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		132,
		135,
		134,
		158,
		157,
		-1,
		136,
		124,
		125,
		110,
		107,
		94,
		82,
		90,
		74,
		74,
		71,
		53,
		51,
		81,
		56,
		78,
		75,
		94,
		99,
		93,
		102,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		162,
		-1,
		165,
		173,
		148,
		121,
		124,
		111,
		102,
		89,
		78,
		89,
		72,
		69,
		65,
		45,
		60,
		51,
		50,
		68,
		78,
		86,
		90,
		96,
		-1,
		231,
		-1,
		173,
		157,
		159,
		131,
		152,
		-1,
		182,
		166,
		165,
		150,
		150,
		-1,
		120,
		117,
		107,
		85,
		70,
		84,
		72,
		67,
		58,
		40,
		54,
		45,
		63,
		70,
		68,
		72,
		92,
		104,
		191,
		181,
		-1,
		163,
		168,
		127,
		135,
		154,
		192,
		156,
		-1,
		151,
		-1,
		122,
		135,
		-1,
		91,
		87,
		69,
		70,
		65,
		76,
		51,
		36,
		33,
		51,
		54,
		61,
		65,
		81,
		-1,
		-1,
		176,
		180,
		169,
		120,
		139,
		163,
		200,
		149,
		138,
		137,
		-1,
		128,
		105,
		102,
		90,
		77,
		62,
		63,
		71,
		66,
		45,
		35,
		32,
		52,
		78,
		56,
		68,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		146,
		117,
		141,
		183,
		167,
		160,
		148,
		113,
		113,
		107,
		-1,
		101,
		80,
		71,
		60,
		58,
		62,
		49,
		45,
		30,
		28,
		47,
		59,
		50,
		70,
		-1,
		-1,
		-1,
		176,
		165,
		166,
		112,
		135,
		172,
		146,
		132,
		137,
		112,
		105,
		99,
		114,
		97,
		78,
		67,
		59,
		48,
		46,
		42,
		34,
		26,
		35,
		41,
		65,
		72,
		78,
		-1,
		-1,
		183,
		173,
		157,
		159,
		156,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		88,
		72,
		67,
		64,
		54,
		41,
		37,
		33,
		25,
		27,
		27,
		70,
		70,
		62,
		87,
		90,
		-1,
		-1,
		-1,
		176,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		89,
		74,
		70,
		58,
		62,
		56,
		47,
		37,
		27,
		0,
		20,
		56,
		-1,
		70,
		64,
		92,
		84,
		72,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		70,
		65,
		64,
		58,
		46,
		35,
		41,
		33,
		25,
		30,
		55,
		59,
		83,
		74,
		70,
		67,
		81,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		80,
		78,
		92,
		76,
		74,
		58,
		49,
		57,
		33,
		26,
		28,
		32,
		50,
		79,
		72,
		66,
		65,
		77,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		90,
		82,
		96,
		97,
		70,
		58,
		56,
		60,
		48,
		37,
		40,
		44,
		59,
		69,
		60,
		61,
		70,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		96,
		94,
		86,
		72,
		78,
		67,
		57,
		52,
		42,
		31,
		37,
		48,
		70,
		56,
		54,
		73,
		89,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		89,
		73,
		78,
		-1,
		77,
		-1,
		50,
		52,
		50,
		42,
		42,
		53,
		51,
		62,
		79,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		105,
		85,
		79,
		78,
		72,
		80,
		58,
		55,
		48,
		45,
		45,
		58,
		78,
		69,
		81,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		122,
		110,
		100,
		90,
		104,
		92,
		71,
		67,
		53,
		55,
		53,
		54,
		59,
		80,
		81,
		94,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		140,
		111,
		111,
		-1,
		-1,
		102,
		96,
		84,
		70,
		57,
		77,
		80,
		69,
		53,
		68,
		80,
		88,
		93,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		165,
		126,
		115,
		110,
		114,
		102,
		-1,
		86,
		81,
		61,
		75,
		82,
		71,
		66,
		60,
		63,
		81,
		98,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		122,
		132,
		103,
		96,
		100,
		-1,
		88,
		77,
		63,
		80,
		84,
		81,
		72,
		64,
		69,
		66,
		79,
		93,
		97,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		140,
		155,
		142,
		119,
		92,
		87,
		80,
		74,
		71,
		87,
		92,
		103,
		71,
		67,
		68,
		72,
		71,
		88,
		98,
		-1,
		-1,
		154,
		171,
		166,
		148,
		152,
		169,
		-1,
		-1,
		96,
		87,
		78,
		81,
		81,
		84,
		77,
		74,
		79,
		84,
		72,
		81,
		99,
		99,
		-1,
		-1,
		-1,
		174,
		-1,
		189,
		-1,
		-1,
		167,
		167,
		114,
		96,
		92,
		90,
		83,
		92,
		87,
		82,
		92,
		95,
		87,
		74,
		79,
		102,
		91,
		130,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		129,
		126,
		-1,
		96,
		121,
		93,
		100,
		92,
		99,
		99,
		91,
		69,
		76,
		92,
		91,
		86,
		122,
		113,
		119,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		118,
		102,
		100,
		93,
		88,
		98,
		78,
		65,
		69,
		73,
		79,
		84,
		89,
		95,
		110,
		125,
		-1,
		181,
		262,
		255,
		228,
		236,
		267,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		109,
		106,
		108,
		103,
		94,
		79,
		85,
		72,
		71,
		89,
		93,
		102,
		109,
		99,
		112,
		116,
		-1,
		195,
		238,
		222,
		225,
		249,
		263,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		117,
		167,
		123,
		118,
		102,
		100,
		91,
		82,
		89,
		80,
		80,
		83,
		98,
		103,
		95,
		109,
		109,
		110,
		-1,
		212,
		218,
		216,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		135,
		139,
		131,
		134,
		116,
		103,
		95,
		87,
		103,
		78,
		88,
		84,
		85,
		94,
		105,
		117,
		116,
		117,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		177,
		216,
		215,
		-1,
		199,
		-1,
		-1,
		-1,
		149,
		144,
		136,
		136,
		115,
		115,
		89,
		93,
		83,
		90,
		100,
		102,
		94,
		98,
		111,
		122,
		125,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		192,
		183,
		210,
		222,
		211,
		206,
		193,
		-1,
		-1,
		172,
		154,
		-1,
		-1,
		122,
		110,
		93,
		94,
		90,
		93,
		108,
		111,
		101,
		99,
		93,
		125,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		211,
		206,
		210,
		226,
		251,
		-1,
		182,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		115,
		104,
		95,
		101,
		98,
		109,
		119,
		107,
		108,
		98,
		108,
		121,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		100,
		105,
		125,
		127,
		116,
		110,
		104,
		111,
		110,
		118,
		126,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		118,
		122,
		114,
		107,
		102,
		113,
		105,
		109,
		126,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		158,
		126,
		131,
		126,
		108,
		119,
		108,
		111,
		125,
		120,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		195,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		115,
		140,
		129,
		137,
		132,
		112,
		118,
		121,
		110,
		114,
		126,
		-1,
		-1,
		200,
		201,
		202,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		153,
		116,
		137,
		147,
		141,
		139,
		130,
		116,
		123,
		121,
		117,
		128,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		117,
		143,
		146,
		152,
		146,
		119,
		134,
		124,
		115,
		124,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		168,
		153,
		134,
		121,
		128,
		128,
		121,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		158,
		154,
		141,
		141,
		133,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		134,
		169,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		141,
		142,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		131,
		120,
		131,
		139,
		112,
		119,
		-1,
		138,
		142,
		108,
		102,
		141,
		110,
		116,
		127,
		-1,
		-1,
		-1,
		131,
		130,
		98,
		96,
		105,
		110,
		117,
		-1,
		116,
		-1,
		152,
		131,
		142,
		147,
		91,
		88,
		108,
		127,
		109,
		101,
		167,
		121,
		92,
		86,
		104,
		94,
		103,
		95,
		-1,
		92,
		82,
		104,
		83,
		94,
		86,
		-1,
		-1,
		86,
		87,
		93,
		79,
		85,
		81,
		-1,
		91,
		75,
		-1,
		-1,
		76,
		77,
		61,
		64,
		72,
		70,
		83,
		75,
		70,
		-1,
		-1,
		67,
		63,
		70,
		57,
		53,
		70,
		83,
		65,
		79,
		78,
		-1,
		79,
		96,
		96,
		64,
		62,
		46,
		44,
		62,
		64,
		70,
		70,
		-1,
		96,
		92,
		93,
		91,
		86,
		62,
		49,
		49,
		59,
		52,
		71,
		59,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		97,
		86,
		103,
		89,
		79,
		83,
		81,
		52,
		49,
		47,
		44,
		60,
		58,
		68,
		-1,
		-1,
		190,
		163,
		187,
		145,
		127,
		-1,
		93,
		79,
		85,
		83,
		77,
		70,
		83,
		68,
		-1,
		38,
		37,
		65,
		51,
		62,
		156,
		-1,
		-1,
		148,
		140,
		122,
		125,
		102,
		98,
		94,
		93,
		85,
		71,
		67,
		67,
		70,
		70,
		76,
		32,
		42,
		46,
		44,
		69,
		-1,
		-1,
		104,
		-1,
		-1,
		153,
		136,
		-1,
		117,
		124,
		108,
		114,
		100,
		121,
		104,
		95,
		87,
		81,
		69,
		65,
		62,
		75,
		54,
		29,
		54,
		58,
		39,
		60,
		55,
		-1,
		103,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		115,
		114,
		138,
		137,
		-1,
		116,
		104,
		105,
		90,
		87,
		74,
		62,
		70,
		54,
		54,
		51,
		33,
		31,
		61,
		36,
		58,
		55,
		74,
		79,
		73,
		82,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		142,
		-1,
		145,
		153,
		128,
		101,
		104,
		91,
		82,
		69,
		58,
		69,
		52,
		49,
		45,
		25,
		40,
		31,
		30,
		48,
		58,
		66,
		70,
		76,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		162,
		146,
		145,
		130,
		130,
		-1,
		100,
		97,
		87,
		65,
		50,
		64,
		52,
		47,
		38,
		20,
		34,
		25,
		43,
		50,
		48,
		52,
		72,
		84,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		131,
		-1,
		102,
		115,
		-1,
		71,
		67,
		49,
		50,
		45,
		56,
		31,
		16,
		13,
		31,
		34,
		41,
		45,
		61,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		108,
		85,
		82,
		70,
		57,
		42,
		43,
		51,
		51,
		30,
		15,
		12,
		32,
		58,
		36,
		48,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		81,
		60,
		51,
		40,
		38,
		50,
		36,
		30,
		10,
		8,
		27,
		39,
		30,
		50,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		94,
		77,
		58,
		47,
		39,
		28,
		36,
		32,
		24,
		6,
		15,
		21,
		45,
		52,
		58,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		68,
		52,
		47,
		44,
		41,
		29,
		25,
		23,
		13,
		8,
		15,
		50,
		50,
		42,
		67,
		70,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		69,
		54,
		50,
		45,
		49,
		42,
		35,
		25,
		17,
		18,
		0,
		36,
		-1,
		50,
		44,
		72,
		65,
		53,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		65,
		47,
		54,
		52,
		46,
		50,
		38,
		27,
		33,
		25,
		5,
		15,
		35,
		39,
		63,
		55,
		51,
		48,
		62,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		60,
		58,
		74,
		58,
		61,
		50,
		41,
		49,
		29,
		22,
		8,
		12,
		30,
		59,
		53,
		47,
		46,
		58,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		70,
		66,
		81,
		82,
		60,
		50,
		48,
		56,
		44,
		33,
		20,
		24,
		39,
		49,
		41,
		42,
		51,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		80,
		78,
		71,
		62,
		68,
		59,
		53,
		48,
		38,
		27,
		33,
		29,
		51,
		37,
		35,
		54,
		70,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		79,
		63,
		68,
		-1,
		73,
		-1,
		46,
		46,
		37,
		26,
		23,
		34,
		32,
		43,
		60,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		95,
		75,
		69,
		68,
		68,
		63,
		54,
		35,
		28,
		25,
		26,
		39,
		59,
		50,
		62,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		112,
		100,
		90,
		80,
		89,
		79,
		54,
		47,
		33,
		35,
		33,
		35,
		40,
		61,
		62,
		75,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		101,
		-1,
		-1,
		90,
		81,
		71,
		50,
		37,
		57,
		60,
		50,
		34,
		49,
		61,
		69,
		74,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		145,
		107,
		96,
		91,
		95,
		89,
		-1,
		67,
		61,
		41,
		55,
		62,
		52,
		47,
		41,
		44,
		62,
		79,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		102,
		113,
		84,
		77,
		81,
		-1,
		69,
		57,
		43,
		60,
		65,
		62,
		53,
		45,
		50,
		47,
		60,
		74,
		78,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		120,
		135,
		123,
		100,
		73,
		68,
		61,
		55,
		51,
		67,
		73,
		84,
		52,
		48,
		49,
		53,
		52,
		69,
		79,
		-1,
		-1,
		134,
		151,
		146,
		128,
		132,
		150,
		-1,
		-1,
		77,
		68,
		59,
		62,
		61,
		64,
		58,
		55,
		60,
		65,
		53,
		62,
		80,
		79,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		147,
		148,
		95,
		77,
		73,
		71,
		64,
		73,
		68,
		63,
		73,
		75,
		67,
		55,
		59,
		82,
		71,
		110,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		166,
		158,
		153,
		159,
		161,
		152,
		110,
		107,
		-1,
		77,
		102,
		74,
		81,
		72,
		79,
		79,
		71,
		49,
		56,
		72,
		71,
		66,
		102,
		93,
		99,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		159,
		155,
		145,
		135,
		138,
		-1,
		-1,
		126,
		123,
		99,
		82,
		80,
		73,
		68,
		78,
		58,
		45,
		49,
		53,
		59,
		64,
		69,
		75,
		90,
		105,
		-1,
		161,
		242,
		235,
		208,
		216,
		247,
		-1,
		149,
		141,
		152,
		127,
		129,
		-1,
		-1,
		99,
		96,
		101,
		89,
		86,
		88,
		83,
		74,
		59,
		65,
		52,
		51,
		69,
		73,
		82,
		89,
		79,
		92,
		96,
		-1,
		175,
		218,
		202,
		205,
		229,
		243,
		-1,
		146,
		-1,
		-1,
		158,
		130,
		114,
		104,
		98,
		148,
		103,
		98,
		82,
		80,
		71,
		62,
		69,
		60,
		60,
		63,
		78,
		83,
		75,
		89,
		89,
		90,
		-1,
		192,
		198,
		196,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		174,
		-1,
		141,
		-1,
		116,
		120,
		111,
		114,
		96,
		83,
		75,
		67,
		83,
		58,
		68,
		64,
		65,
		74,
		85,
		97,
		96,
		97,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		158,
		197,
		195,
		-1,
		179,
		-1,
		-1,
		-1,
		130,
		124,
		116,
		116,
		95,
		95,
		69,
		73,
		63,
		70,
		80,
		82,
		74,
		78,
		91,
		102,
		105,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		173,
		164,
		191,
		202,
		191,
		186,
		173,
		-1,
		-1,
		153,
		134,
		-1,
		-1,
		102,
		90,
		73,
		74,
		70,
		73,
		88,
		91,
		81,
		79,
		73,
		105,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		192,
		186,
		190,
		206,
		231,
		-1,
		162,
		-1,
		-1,
		147,
		-1,
		-1,
		132,
		95,
		84,
		75,
		81,
		78,
		89,
		99,
		87,
		88,
		78,
		88,
		101,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		178,
		158,
		-1,
		-1,
		130,
		128,
		117,
		-1,
		107,
		80,
		85,
		105,
		107,
		96,
		90,
		84,
		91,
		90,
		98,
		106,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		164,
		-1,
		-1,
		125,
		118,
		106,
		94,
		84,
		94,
		98,
		102,
		94,
		87,
		82,
		93,
		85,
		89,
		106,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		159,
		143,
		124,
		-1,
		94,
		107,
		138,
		106,
		111,
		106,
		88,
		99,
		88,
		91,
		105,
		100,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		175,
		177,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		131,
		127,
		-1,
		-1,
		95,
		120,
		109,
		117,
		112,
		92,
		98,
		101,
		90,
		94,
		106,
		-1,
		-1,
		180,
		181,
		182,
		-1,
		160,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		133,
		96,
		117,
		127,
		121,
		119,
		110,
		96,
		103,
		101,
		97,
		108,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		97,
		123,
		126,
		132,
		126,
		99,
		114,
		104,
		95,
		104,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		117,
		148,
		133,
		114,
		101,
		108,
		108,
		101,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		138,
		134,
		121,
		121,
		113,
		-1,
		257,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		117,
		113,
		133,
		114,
		149,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		120,
		118,
		121,
		122,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		129,
		125,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		168,
		157,
		168,
		176,
		149,
		156,
		-1,
		175,
		179,
		145,
		139,
		178,
		147,
		153,
		164,
		-1,
		-1,
		-1,
		168,
		167,
		135,
		133,
		142,
		147,
		154,
		-1,
		153,
		-1,
		189,
		168,
		179,
		184,
		128,
		125,
		145,
		164,
		146,
		138,
		204,
		158,
		129,
		123,
		141,
		131,
		140,
		132,
		-1,
		129,
		119,
		141,
		120,
		131,
		123,
		-1,
		-1,
		123,
		124,
		130,
		116,
		122,
		118,
		-1,
		128,
		112,
		-1,
		-1,
		113,
		114,
		98,
		101,
		109,
		107,
		120,
		112,
		107,
		-1,
		-1,
		104,
		100,
		107,
		94,
		90,
		107,
		120,
		102,
		116,
		115,
		-1,
		116,
		133,
		133,
		101,
		99,
		83,
		81,
		99,
		101,
		107,
		107,
		-1,
		133,
		129,
		130,
		128,
		123,
		99,
		86,
		86,
		96,
		89,
		108,
		96,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		123,
		140,
		126,
		116,
		120,
		118,
		89,
		86,
		84,
		81,
		97,
		95,
		105,
		-1,
		-1,
		227,
		200,
		224,
		182,
		164,
		-1,
		130,
		116,
		122,
		120,
		114,
		107,
		120,
		105,
		-1,
		75,
		74,
		102,
		88,
		99,
		193,
		-1,
		-1,
		185,
		177,
		159,
		162,
		139,
		135,
		131,
		130,
		122,
		108,
		104,
		104,
		107,
		107,
		113,
		69,
		79,
		83,
		81,
		93,
		-1,
		-1,
		117,
		-1,
		-1,
		190,
		173,
		-1,
		154,
		161,
		145,
		151,
		137,
		158,
		141,
		132,
		124,
		118,
		106,
		102,
		99,
		112,
		91,
		66,
		91,
		95,
		76,
		83,
		78,
		-1,
		116,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		149,
		152,
		151,
		175,
		174,
		-1,
		153,
		141,
		142,
		127,
		124,
		111,
		99,
		107,
		91,
		91,
		88,
		70,
		68,
		98,
		73,
		81,
		78,
		87,
		92,
		86,
		95,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		179,
		-1,
		182,
		190,
		165,
		138,
		141,
		128,
		119,
		106,
		95,
		106,
		89,
		86,
		82,
		62,
		77,
		68,
		67,
		71,
		71,
		79,
		83,
		89,
		-1,
		248,
		-1,
		190,
		174,
		176,
		148,
		169,
		-1,
		199,
		183,
		182,
		167,
		167,
		-1,
		137,
		134,
		124,
		102,
		87,
		101,
		89,
		84,
		75,
		57,
		71,
		62,
		58,
		65,
		61,
		65,
		85,
		97,
		208,
		198,
		-1,
		180,
		185,
		144,
		152,
		171,
		209,
		173,
		-1,
		168,
		-1,
		139,
		152,
		-1,
		108,
		104,
		86,
		87,
		82,
		93,
		68,
		53,
		50,
		54,
		49,
		54,
		58,
		74,
		-1,
		-1,
		193,
		197,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		122,
		119,
		107,
		94,
		79,
		80,
		88,
		88,
		67,
		52,
		49,
		45,
		71,
		49,
		61,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		118,
		97,
		88,
		77,
		75,
		87,
		73,
		67,
		47,
		45,
		40,
		52,
		43,
		63,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		131,
		114,
		95,
		84,
		76,
		65,
		73,
		69,
		61,
		43,
		50,
		34,
		58,
		65,
		71,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		66,
		62,
		60,
		50,
		41,
		47,
		63,
		63,
		55,
		80,
		83,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		72,
		62,
		54,
		55,
		37,
		0,
		-1,
		63,
		57,
		85,
		88,
		78,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		75,
		64,
		70,
		62,
		42,
		47,
		44,
		48,
		74,
		69,
		74,
		73,
		87,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		87,
		78,
		86,
		66,
		59,
		45,
		37,
		39,
		68,
		82,
		78,
		80,
		83,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		87,
		85,
		90,
		78,
		67,
		43,
		48,
		48,
		58,
		76,
		78,
		85,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		96,
		87,
		82,
		72,
		61,
		67,
		57,
		88,
		74,
		72,
		84,
		99,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		116,
		100,
		105,
		-1,
		107,
		-1,
		74,
		76,
		74,
		63,
		60,
		71,
		69,
		80,
		90,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		132,
		112,
		106,
		105,
		102,
		100,
		88,
		72,
		65,
		62,
		63,
		75,
		96,
		87,
		92,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		149,
		137,
		127,
		117,
		126,
		116,
		91,
		84,
		70,
		72,
		70,
		72,
		77,
		98,
		97,
		107,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		138,
		-1,
		-1,
		127,
		118,
		108,
		87,
		74,
		94,
		97,
		87,
		71,
		86,
		98,
		99,
		108,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		182,
		144,
		133,
		128,
		132,
		126,
		-1,
		104,
		98,
		78,
		92,
		99,
		89,
		84,
		78,
		81,
		99,
		110,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		139,
		150,
		121,
		114,
		118,
		-1,
		106,
		94,
		80,
		97,
		102,
		99,
		90,
		82,
		87,
		84,
		97,
		111,
		112,
		188,
		-1,
		171,
		-1,
		-1,
		-1,
		157,
		172,
		160,
		137,
		110,
		105,
		98,
		92,
		88,
		104,
		110,
		121,
		89,
		85,
		86,
		90,
		89,
		106,
		116,
		-1,
		-1,
		171,
		188,
		183,
		165,
		169,
		187,
		-1,
		-1,
		114,
		105,
		96,
		99,
		98,
		101,
		95,
		92,
		97,
		102,
		90,
		99,
		117,
		116,
		-1,
		-1,
		-1,
		191,
		-1,
		206,
		-1,
		-1,
		184,
		185,
		132,
		114,
		110,
		108,
		101,
		110,
		105,
		100,
		110,
		112,
		104,
		92,
		96,
		119,
		108,
		147,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		203,
		195,
		190,
		196,
		198,
		189,
		147,
		144,
		-1,
		114,
		139,
		111,
		118,
		109,
		116,
		116,
		108,
		86,
		93,
		109,
		108,
		103,
		139,
		130,
		136,
		-1,
		-1,
		293,
		282,
		271,
		277,
		-1,
		196,
		192,
		182,
		172,
		175,
		-1,
		-1,
		163,
		160,
		136,
		119,
		117,
		110,
		105,
		115,
		95,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		198,
		279,
		272,
		245,
		253,
		284,
		-1,
		186,
		178,
		189,
		164,
		166,
		-1,
		-1,
		136,
		133,
		138,
		126,
		123,
		125,
		120,
		111,
		96,
		102,
		89,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		212,
		255,
		239,
		242,
		266,
		280,
		-1,
		183,
		-1,
		-1,
		195,
		167,
		151,
		141,
		135,
		185,
		140,
		135,
		119,
		117,
		108,
		99,
		106,
		97,
		97,
		100,
		115,
		120,
		112,
		126,
		126,
		127,
		-1,
		229,
		235,
		233,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		211,
		-1,
		178,
		-1,
		153,
		157,
		148,
		151,
		133,
		120,
		112,
		104,
		120,
		95,
		105,
		101,
		102,
		111,
		122,
		134,
		133,
		134,
		254,
		210,
		213,
		224,
		235,
		250,
		254,
		-1,
		195,
		234,
		232,
		-1,
		216,
		-1,
		-1,
		-1,
		167,
		161,
		153,
		153,
		132,
		132,
		106,
		110,
		100,
		107,
		117,
		119,
		111,
		115,
		128,
		139,
		142,
		250,
		241,
		254,
		199,
		199,
		220,
		229,
		250,
		210,
		201,
		228,
		239,
		228,
		223,
		210,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		139,
		127,
		110,
		111,
		107,
		110,
		125,
		128,
		118,
		116,
		110,
		142,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		217,
		-1,
		-1,
		212,
		229,
		223,
		227,
		243,
		268,
		-1,
		199,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		115,
		126,
		136,
		124,
		125,
		115,
		125,
		138,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		199,
		197,
		203,
		210,
		227,
		257,
		-1,
		-1,
		215,
		195,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		117,
		122,
		142,
		144,
		133,
		127,
		121,
		128,
		127,
		135,
		143,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		205,
		201,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		135,
		139,
		131,
		124,
		119,
		130,
		122,
		126,
		143,
		-1,
		270,
		-1,
		222,
		198,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		222,
		208,
		201,
		189,
		187,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		125,
		136,
		125,
		128,
		142,
		137,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		212,
		214,
		-1,
		213,
		202,
		187,
		179,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		129,
		135,
		138,
		127,
		131,
		143,
		-1,
		-1,
		217,
		218,
		219,
		-1,
		197,
		-1,
		215,
		-1,
		182,
		188,
		176,
		-1,
		-1,
		-1,
		170,
		133,
		154,
		164,
		158,
		156,
		147,
		133,
		140,
		138,
		134,
		145,
		-1,
		-1,
		-1,
		215,
		189,
		222,
		213,
		196,
		176,
		168,
		187,
		-1,
		157,
		-1,
		132,
		134,
		160,
		163,
		169,
		163,
		136,
		151,
		141,
		132,
		141,
		221,
		-1,
		191,
		224,
		188,
		182,
		158,
		162,
		178,
		-1,
		154,
		136,
		-1,
		164,
		154,
		185,
		170,
		151,
		138,
		145,
		145,
		138,
		-1,
		-1,
		-1,
		193,
		192,
		184,
		178,
		178,
		163,
		154,
		-1,
		166,
		148,
		127,
		144,
		144,
		135,
		143,
		175,
		171,
		158,
		158,
		150,
		-1,
		294,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		187,
		182,
		155,
		143,
		149,
		145,
		131,
		137,
		139,
		147,
		145,
		142,
		154,
		150,
		170,
		151,
		186,
		-1,
		289,
		-1,
		223,
		-1,
		-1,
		205,
		185,
		177,
		166,
		155,
		153,
		144,
		135,
		157,
		173,
		157,
		155,
		158,
		159,
		-1,
		278,
		277,
		-1,
		224,
		216,
		202,
		-1,
		195,
		-1,
		201,
		162,
		-1,
		164,
		144,
		-1,
		166,
		162,
		-1,
		-1,
		265,
		240,
		-1,
		-1,
		-1,
		225,
		205,
		196,
		180,
		-1,
		155,
		155,
		-1,
		-1,
		-1,
		250,
		249,
		-1,
		218,
		221,
		-1,
		211,
		202,
		210,
		157,
		161,
		-1,
		-1,
		-1,
		259,
		240,
		234,
		233,
		231,
		226,
		223,
		209,
		193,
		171,
		160,
		181,
		-1,
		-1,
		-1,
		231,
		223,
		216,
		-1,
		-1,
		218,
		201,
		182,
		180,
		-1,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		208,
		-1,
		-1,
		214,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		242,
		-1,
		-1,
		-1,
		204,
		200,
		201,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		288,
		252,
		-1,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		267,
		265,
		-1,
		-1,
		-1,
		224,
		208,
		-1,
		194,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		229,
		-1,
		229,
		204,
		211,
		-1,
		-1,
		-1,
		-1,
		242,
		234,
		242,
		-1,
		214,
		216,
		-1,
		264,
		-1,
		-1,
		257,
		248,
		-1,
		-1,
		219,
		226,
		248,
		251,
		287,
		-1,
		238
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		177,
		181,
		147,
		141,
		180,
		149,
		155,
		166,
		-1,
		-1,
		-1,
		170,
		169,
		137,
		135,
		144,
		149,
		156,
		-1,
		155,
		-1,
		191,
		170,
		181,
		186,
		130,
		127,
		147,
		166,
		148,
		140,
		206,
		160,
		131,
		125,
		143,
		133,
		142,
		134,
		-1,
		131,
		121,
		143,
		122,
		133,
		125,
		-1,
		-1,
		125,
		126,
		132,
		118,
		124,
		120,
		-1,
		130,
		114,
		-1,
		-1,
		115,
		116,
		100,
		103,
		111,
		109,
		122,
		114,
		109,
		-1,
		-1,
		106,
		102,
		109,
		96,
		92,
		109,
		122,
		104,
		118,
		116,
		-1,
		118,
		135,
		135,
		103,
		101,
		85,
		83,
		101,
		103,
		109,
		108,
		-1,
		135,
		131,
		132,
		130,
		125,
		101,
		88,
		88,
		98,
		91,
		110,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		127,
		144,
		128,
		118,
		122,
		120,
		91,
		88,
		86,
		83,
		99,
		96,
		106,
		-1,
		-1,
		229,
		202,
		226,
		184,
		166,
		-1,
		132,
		132,
		126,
		122,
		116,
		109,
		122,
		107,
		-1,
		77,
		76,
		103,
		89,
		100,
		209,
		-1,
		-1,
		187,
		179,
		161,
		164,
		141,
		137,
		147,
		146,
		139,
		125,
		121,
		106,
		109,
		109,
		115,
		71,
		81,
		85,
		82,
		85,
		-1,
		-1,
		99,
		-1,
		-1,
		206,
		189,
		-1,
		156,
		163,
		147,
		153,
		139,
		160,
		157,
		148,
		141,
		135,
		123,
		104,
		101,
		114,
		93,
		68,
		93,
		97,
		77,
		75,
		70,
		-1,
		98,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		163,
		160,
		153,
		177,
		176,
		-1,
		170,
		158,
		159,
		144,
		141,
		128,
		116,
		109,
		93,
		93,
		90,
		72,
		70,
		100,
		74,
		74,
		64,
		69,
		74,
		68,
		77,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		181,
		-1,
		184,
		197,
		182,
		155,
		158,
		145,
		136,
		123,
		112,
		110,
		91,
		88,
		84,
		64,
		79,
		69,
		68,
		53,
		53,
		61,
		65,
		71,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		201,
		185,
		199,
		184,
		183,
		-1,
		154,
		151,
		141,
		119,
		104,
		103,
		91,
		86,
		77,
		59,
		73,
		63,
		59,
		57,
		43,
		47,
		67,
		79,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		156,
		169,
		-1,
		125,
		121,
		103,
		99,
		88,
		95,
		70,
		55,
		52,
		55,
		50,
		36,
		40,
		56,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		139,
		136,
		124,
		111,
		96,
		97,
		94,
		90,
		69,
		54,
		56,
		46,
		53,
		31,
		38,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		135,
		114,
		105,
		94,
		92,
		102,
		75,
		70,
		54,
		52,
		41,
		34,
		25,
		29,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		148,
		131,
		112,
		101,
		93,
		82,
		76,
		82,
		74,
		50,
		55,
		35,
		40,
		17,
		23,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		122,
		106,
		101,
		98,
		86,
		81,
		81,
		79,
		60,
		55,
		67,
		45,
		45,
		11,
		32,
		35,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		108,
		104,
		90,
		94,
		96,
		91,
		81,
		73,
		74,
		56,
		69,
		-1,
		0,
		12,
		37,
		43,
		34,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		102,
		97,
		96,
		95,
		92,
		81,
		89,
		81,
		61,
		66,
		63,
		22,
		13,
		24,
		29,
		29,
		43,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		124,
		108,
		107,
		104,
		95,
		103,
		76,
		69,
		64,
		56,
		58,
		27,
		31,
		44,
		36,
		39,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		114,
		131,
		132,
		110,
		104,
		102,
		93,
		81,
		70,
		62,
		65,
		40,
		37,
		39,
		39,
		41,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		128,
		126,
		121,
		112,
		118,
		113,
		90,
		85,
		75,
		64,
		64,
		59,
		61,
		47,
		45,
		40,
		55,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		129,
		113,
		118,
		-1,
		110,
		-1,
		83,
		80,
		71,
		56,
		53,
		57,
		48,
		61,
		46,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		145,
		125,
		119,
		118,
		105,
		97,
		91,
		69,
		62,
		59,
		56,
		69,
		81,
		60,
		48,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		152,
		140,
		130,
		120,
		123,
		113,
		88,
		81,
		67,
		69,
		67,
		65,
		70,
		61,
		53,
		63,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		173,
		144,
		141,
		-1,
		-1,
		124,
		115,
		105,
		84,
		71,
		91,
		94,
		80,
		64,
		77,
		67,
		55,
		64,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		192,
		137,
		126,
		121,
		125,
		123,
		-1,
		97,
		95,
		75,
		89,
		96,
		82,
		77,
		71,
		72,
		72,
		66,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		149,
		143,
		114,
		107,
		111,
		-1,
		99,
		91,
		77,
		94,
		95,
		92,
		83,
		75,
		80,
		69,
		82,
		78,
		68,
		204,
		-1,
		187,
		-1,
		-1,
		-1,
		167,
		182,
		153,
		130,
		103,
		98,
		91,
		85,
		85,
		101,
		103,
		114,
		82,
		78,
		79,
		75,
		74,
		82,
		83,
		-1,
		-1,
		187,
		201,
		193,
		175,
		179,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		95,
		98,
		88,
		85,
		90,
		92,
		83,
		84,
		101,
		86,
		-1,
		-1,
		-1,
		207,
		-1,
		219,
		-1,
		-1,
		194,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		110,
		102,
		82,
		96,
		112,
		94,
		115,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		196,
		188,
		183,
		189,
		191,
		182,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		103,
		111,
		111,
		106,
		86,
		93,
		109,
		106,
		103,
		107,
		102,
		111,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		189,
		185,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		113,
		117,
		110,
		105,
		115,
		95,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		109,
		117,
		-1,
		214,
		278,
		271,
		239,
		247,
		278,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		120,
		117,
		125,
		120,
		111,
		96,
		102,
		89,
		88,
		106,
		110,
		119,
		123,
		112,
		125,
		129,
		-1,
		228,
		254,
		233,
		236,
		260,
		274,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		128,
		178,
		134,
		129,
		119,
		117,
		108,
		99,
		106,
		97,
		97,
		100,
		115,
		120,
		112,
		122,
		122,
		123,
		-1,
		223,
		234,
		227,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		146,
		150,
		142,
		145,
		133,
		120,
		112,
		104,
		120,
		95,
		105,
		101,
		102,
		111,
		122,
		134,
		129,
		130,
		248,
		204,
		207,
		218,
		229,
		244,
		248,
		-1,
		188,
		227,
		232,
		-1,
		213,
		-1,
		-1,
		-1,
		160,
		155,
		147,
		153,
		132,
		132,
		106,
		110,
		100,
		107,
		117,
		119,
		111,
		115,
		128,
		139,
		138,
		244,
		235,
		248,
		193,
		193,
		214,
		223,
		244,
		203,
		194,
		221,
		239,
		228,
		223,
		210,
		-1,
		-1,
		183,
		165,
		-1,
		-1,
		139,
		127,
		110,
		111,
		107,
		110,
		125,
		128,
		118,
		116,
		110,
		142,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		211,
		-1,
		-1,
		206,
		222,
		217,
		221,
		237,
		262,
		-1,
		199,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		115,
		126,
		136,
		124,
		125,
		115,
		125,
		138,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		215,
		195,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		117,
		122,
		142,
		144,
		133,
		127,
		121,
		128,
		127,
		135,
		143,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		205,
		201,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		135,
		139,
		131,
		124,
		119,
		130,
		122,
		126,
		143,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		222,
		208,
		201,
		189,
		187,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		125,
		136,
		125,
		128,
		142,
		137,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		212,
		214,
		-1,
		213,
		202,
		187,
		179,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		129,
		135,
		138,
		127,
		131,
		143,
		-1,
		-1,
		211,
		212,
		217,
		-1,
		197,
		-1,
		215,
		-1,
		182,
		188,
		176,
		-1,
		-1,
		-1,
		170,
		133,
		154,
		164,
		158,
		156,
		147,
		133,
		140,
		138,
		134,
		145,
		-1,
		-1,
		-1,
		215,
		189,
		222,
		213,
		196,
		176,
		168,
		187,
		-1,
		157,
		-1,
		132,
		134,
		160,
		163,
		169,
		163,
		136,
		151,
		141,
		132,
		141,
		221,
		-1,
		191,
		224,
		188,
		182,
		158,
		162,
		178,
		-1,
		154,
		136,
		-1,
		164,
		154,
		185,
		170,
		151,
		138,
		145,
		145,
		138,
		-1,
		-1,
		-1,
		193,
		192,
		184,
		178,
		178,
		163,
		154,
		-1,
		166,
		148,
		127,
		144,
		144,
		135,
		143,
		175,
		171,
		158,
		158,
		150,
		-1,
		294,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		187,
		182,
		155,
		143,
		149,
		145,
		131,
		137,
		139,
		147,
		145,
		142,
		154,
		150,
		170,
		151,
		186,
		-1,
		289,
		-1,
		223,
		-1,
		-1,
		205,
		185,
		177,
		166,
		155,
		153,
		144,
		135,
		157,
		173,
		157,
		155,
		158,
		159,
		-1,
		278,
		277,
		-1,
		224,
		216,
		202,
		-1,
		195,
		-1,
		201,
		162,
		-1,
		164,
		144,
		-1,
		166,
		162,
		-1,
		-1,
		265,
		240,
		-1,
		-1,
		-1,
		225,
		205,
		196,
		180,
		-1,
		155,
		155,
		-1,
		-1,
		-1,
		250,
		249,
		-1,
		218,
		221,
		-1,
		211,
		202,
		210,
		157,
		161,
		-1,
		-1,
		-1,
		259,
		240,
		234,
		233,
		231,
		226,
		223,
		209,
		193,
		171,
		160,
		181,
		-1,
		-1,
		-1,
		231,
		223,
		216,
		-1,
		-1,
		218,
		201,
		182,
		180,
		-1,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		208,
		-1,
		-1,
		214,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		242,
		-1,
		-1,
		-1,
		204,
		200,
		201,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		288,
		252,
		-1,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		267,
		265,
		-1,
		-1,
		-1,
		224,
		208,
		-1,
		194,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		229,
		-1,
		229,
		204,
		211,
		-1,
		-1,
		-1,
		-1,
		242,
		234,
		242,
		-1,
		214,
		216,
		-1,
		264,
		-1,
		-1,
		257,
		248,
		-1,
		-1,
		219,
		226,
		248,
		251,
		287,
		-1,
		238
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		169,
		173,
		139,
		133,
		172,
		141,
		147,
		158,
		-1,
		-1,
		-1,
		162,
		161,
		129,
		127,
		136,
		141,
		148,
		-1,
		147,
		-1,
		183,
		162,
		173,
		178,
		122,
		119,
		139,
		158,
		140,
		132,
		198,
		152,
		123,
		117,
		135,
		125,
		134,
		126,
		-1,
		123,
		113,
		135,
		114,
		125,
		117,
		-1,
		-1,
		117,
		118,
		124,
		110,
		116,
		112,
		-1,
		122,
		106,
		-1,
		-1,
		107,
		108,
		92,
		95,
		103,
		101,
		114,
		106,
		101,
		-1,
		-1,
		98,
		94,
		101,
		88,
		84,
		101,
		114,
		96,
		110,
		108,
		-1,
		110,
		127,
		127,
		95,
		93,
		77,
		75,
		93,
		95,
		101,
		100,
		-1,
		127,
		123,
		124,
		122,
		117,
		93,
		80,
		80,
		90,
		83,
		102,
		89,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		119,
		136,
		120,
		110,
		114,
		112,
		83,
		80,
		78,
		75,
		91,
		88,
		98,
		-1,
		-1,
		221,
		194,
		218,
		176,
		158,
		-1,
		124,
		124,
		118,
		114,
		108,
		101,
		114,
		99,
		-1,
		69,
		68,
		95,
		81,
		92,
		201,
		-1,
		-1,
		179,
		171,
		153,
		156,
		133,
		129,
		139,
		138,
		131,
		117,
		113,
		98,
		101,
		101,
		107,
		63,
		73,
		77,
		74,
		77,
		-1,
		-1,
		91,
		-1,
		-1,
		198,
		181,
		-1,
		148,
		155,
		139,
		145,
		131,
		152,
		149,
		140,
		133,
		127,
		115,
		96,
		93,
		106,
		85,
		60,
		85,
		89,
		69,
		67,
		62,
		-1,
		90,
		74,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		155,
		152,
		145,
		169,
		168,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		101,
		85,
		85,
		82,
		64,
		62,
		92,
		66,
		66,
		56,
		61,
		66,
		60,
		69,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		173,
		-1,
		176,
		189,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		102,
		83,
		80,
		76,
		56,
		71,
		61,
		60,
		45,
		45,
		53,
		57,
		63,
		-1,
		256,
		-1,
		198,
		182,
		184,
		156,
		177,
		-1,
		193,
		177,
		191,
		176,
		175,
		-1,
		146,
		143,
		133,
		111,
		96,
		95,
		83,
		78,
		69,
		51,
		65,
		55,
		51,
		49,
		35,
		39,
		59,
		71,
		216,
		206,
		-1,
		188,
		193,
		152,
		160,
		179,
		217,
		181,
		-1,
		176,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		91,
		80,
		87,
		62,
		47,
		44,
		47,
		42,
		28,
		32,
		48,
		-1,
		-1,
		201,
		205,
		194,
		145,
		164,
		188,
		225,
		174,
		163,
		162,
		-1,
		153,
		131,
		128,
		116,
		103,
		88,
		89,
		86,
		82,
		61,
		46,
		48,
		38,
		45,
		23,
		34,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		171,
		142,
		166,
		208,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		127,
		106,
		97,
		86,
		84,
		94,
		67,
		62,
		46,
		44,
		33,
		26,
		17,
		25,
		-1,
		-1,
		-1,
		201,
		190,
		191,
		137,
		160,
		197,
		171,
		157,
		162,
		137,
		130,
		124,
		140,
		123,
		104,
		93,
		85,
		74,
		68,
		74,
		66,
		42,
		47,
		27,
		32,
		13,
		19,
		-1,
		-1,
		208,
		198,
		182,
		184,
		181,
		151,
		158,
		190,
		162,
		175,
		-1,
		129,
		-1,
		118,
		114,
		98,
		93,
		90,
		78,
		73,
		73,
		71,
		52,
		47,
		59,
		37,
		37,
		3,
		28,
		31,
		-1,
		-1,
		-1,
		201,
		196,
		171,
		148,
		132,
		168,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		100,
		96,
		82,
		86,
		88,
		83,
		73,
		65,
		66,
		48,
		61,
		-1,
		9,
		0,
		31,
		31,
		26,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		127,
		179,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		94,
		89,
		88,
		87,
		84,
		73,
		81,
		73,
		53,
		63,
		67,
		26,
		21,
		12,
		17,
		21,
		35,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		147,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		116,
		100,
		99,
		96,
		87,
		95,
		68,
		61,
		56,
		57,
		62,
		30,
		25,
		36,
		28,
		31,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		106,
		123,
		124,
		102,
		96,
		94,
		85,
		73,
		62,
		65,
		57,
		43,
		40,
		31,
		31,
		33,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		120,
		118,
		113,
		104,
		110,
		105,
		82,
		77,
		67,
		56,
		56,
		51,
		53,
		39,
		37,
		32,
		47,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		121,
		105,
		110,
		-1,
		102,
		-1,
		75,
		72,
		63,
		48,
		45,
		49,
		40,
		53,
		38,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		137,
		117,
		111,
		110,
		97,
		89,
		83,
		61,
		54,
		51,
		48,
		61,
		73,
		52,
		40,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		144,
		132,
		122,
		112,
		115,
		105,
		80,
		73,
		59,
		61,
		59,
		57,
		62,
		53,
		45,
		55,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		165,
		136,
		133,
		-1,
		-1,
		116,
		107,
		97,
		76,
		63,
		83,
		86,
		72,
		56,
		69,
		59,
		47,
		56,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		184,
		129,
		118,
		113,
		117,
		115,
		-1,
		89,
		87,
		67,
		81,
		88,
		74,
		69,
		63,
		64,
		64,
		58,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		141,
		135,
		106,
		99,
		103,
		-1,
		91,
		83,
		69,
		86,
		87,
		84,
		75,
		67,
		72,
		61,
		74,
		70,
		60,
		196,
		-1,
		179,
		-1,
		-1,
		-1,
		159,
		174,
		145,
		122,
		95,
		90,
		83,
		77,
		77,
		93,
		95,
		106,
		74,
		70,
		71,
		67,
		66,
		74,
		75,
		-1,
		-1,
		179,
		193,
		185,
		167,
		171,
		172,
		-1,
		-1,
		99,
		90,
		81,
		84,
		87,
		90,
		80,
		77,
		82,
		84,
		75,
		76,
		93,
		78,
		-1,
		-1,
		-1,
		199,
		-1,
		211,
		-1,
		-1,
		186,
		170,
		117,
		99,
		95,
		93,
		86,
		95,
		90,
		85,
		95,
		102,
		94,
		74,
		88,
		104,
		86,
		107,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		188,
		180,
		175,
		181,
		183,
		174,
		132,
		129,
		-1,
		99,
		124,
		96,
		103,
		95,
		103,
		103,
		98,
		78,
		85,
		101,
		98,
		95,
		99,
		94,
		103,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		181,
		177,
		167,
		157,
		160,
		-1,
		-1,
		148,
		145,
		121,
		105,
		109,
		102,
		97,
		107,
		87,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		101,
		109,
		-1,
		206,
		270,
		263,
		231,
		239,
		270,
		-1,
		171,
		163,
		174,
		149,
		151,
		-1,
		-1,
		121,
		118,
		123,
		112,
		109,
		117,
		112,
		103,
		88,
		94,
		81,
		80,
		98,
		102,
		111,
		115,
		104,
		117,
		121,
		-1,
		220,
		246,
		225,
		228,
		252,
		266,
		-1,
		168,
		-1,
		-1,
		180,
		152,
		136,
		126,
		120,
		170,
		126,
		121,
		111,
		109,
		100,
		91,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		114,
		114,
		115,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		196,
		-1,
		163,
		-1,
		138,
		142,
		134,
		137,
		125,
		112,
		104,
		96,
		112,
		87,
		97,
		93,
		94,
		103,
		114,
		126,
		121,
		122,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		180,
		219,
		224,
		-1,
		205,
		-1,
		-1,
		-1,
		152,
		147,
		139,
		145,
		124,
		124,
		98,
		102,
		92,
		99,
		109,
		111,
		103,
		107,
		120,
		131,
		130,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		195,
		186,
		213,
		231,
		220,
		215,
		202,
		-1,
		-1,
		175,
		157,
		-1,
		-1,
		131,
		119,
		102,
		103,
		99,
		102,
		117,
		120,
		110,
		108,
		102,
		134,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		214,
		209,
		213,
		229,
		254,
		-1,
		191,
		-1,
		-1,
		176,
		-1,
		-1,
		161,
		124,
		113,
		104,
		110,
		107,
		118,
		128,
		116,
		117,
		107,
		117,
		130,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		185,
		183,
		189,
		196,
		213,
		243,
		-1,
		-1,
		207,
		187,
		-1,
		-1,
		159,
		157,
		146,
		-1,
		136,
		109,
		114,
		134,
		136,
		125,
		119,
		113,
		120,
		119,
		127,
		135,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		197,
		193,
		-1,
		-1,
		154,
		147,
		135,
		123,
		113,
		123,
		127,
		131,
		123,
		116,
		111,
		122,
		114,
		118,
		135,
		-1,
		256,
		-1,
		208,
		184,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		214,
		200,
		193,
		181,
		179,
		-1,
		188,
		172,
		153,
		-1,
		123,
		136,
		167,
		135,
		140,
		135,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		196,
		199,
		-1,
		-1,
		204,
		206,
		-1,
		205,
		194,
		179,
		171,
		-1,
		-1,
		160,
		156,
		-1,
		-1,
		124,
		149,
		138,
		146,
		141,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		203,
		204,
		209,
		-1,
		189,
		-1,
		207,
		-1,
		174,
		180,
		168,
		-1,
		-1,
		-1,
		162,
		125,
		146,
		156,
		150,
		148,
		139,
		125,
		132,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		207,
		181,
		214,
		205,
		188,
		168,
		160,
		179,
		-1,
		149,
		-1,
		124,
		126,
		152,
		155,
		161,
		155,
		128,
		143,
		133,
		124,
		133,
		213,
		-1,
		183,
		216,
		180,
		174,
		150,
		154,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		177,
		162,
		143,
		130,
		137,
		137,
		130,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		170,
		155,
		146,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		167,
		163,
		150,
		150,
		142,
		-1,
		286,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		174,
		147,
		135,
		141,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		143,
		178,
		-1,
		281,
		-1,
		215,
		-1,
		-1,
		197,
		177,
		169,
		158,
		147,
		145,
		136,
		127,
		149,
		165,
		149,
		147,
		150,
		151,
		-1,
		270,
		269,
		-1,
		216,
		208,
		194,
		-1,
		187,
		-1,
		193,
		154,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		257,
		232,
		-1,
		-1,
		-1,
		217,
		197,
		188,
		172,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		242,
		241,
		-1,
		210,
		213,
		-1,
		203,
		194,
		202,
		149,
		153,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		225,
		223,
		218,
		215,
		201,
		185,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		223,
		215,
		208,
		-1,
		-1,
		210,
		193,
		174,
		172,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		200,
		-1,
		-1,
		206,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		234,
		-1,
		-1,
		-1,
		196,
		192,
		193,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		280,
		244,
		-1,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		216,
		200,
		-1,
		186,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		221,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		234,
		226,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		211,
		218,
		240,
		243,
		279,
		-1,
		230
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		197,
		201,
		167,
		161,
		200,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		190,
		189,
		157,
		155,
		164,
		169,
		176,
		-1,
		175,
		-1,
		211,
		190,
		201,
		206,
		150,
		147,
		167,
		186,
		168,
		160,
		226,
		180,
		151,
		145,
		163,
		153,
		162,
		154,
		-1,
		151,
		141,
		163,
		142,
		153,
		145,
		-1,
		-1,
		145,
		146,
		152,
		138,
		144,
		140,
		-1,
		150,
		134,
		-1,
		-1,
		135,
		136,
		120,
		123,
		131,
		129,
		142,
		134,
		129,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		124,
		138,
		136,
		-1,
		138,
		155,
		155,
		123,
		121,
		105,
		103,
		121,
		123,
		129,
		128,
		-1,
		155,
		151,
		152,
		150,
		145,
		121,
		108,
		108,
		118,
		111,
		130,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		147,
		164,
		148,
		138,
		142,
		140,
		111,
		108,
		106,
		103,
		119,
		116,
		126,
		-1,
		-1,
		249,
		222,
		246,
		204,
		186,
		-1,
		152,
		140,
		146,
		142,
		136,
		129,
		142,
		127,
		-1,
		97,
		96,
		123,
		109,
		120,
		217,
		-1,
		-1,
		207,
		199,
		181,
		184,
		161,
		157,
		155,
		154,
		146,
		132,
		128,
		126,
		129,
		129,
		135,
		91,
		101,
		105,
		102,
		105,
		-1,
		-1,
		119,
		-1,
		-1,
		214,
		197,
		-1,
		176,
		183,
		167,
		173,
		159,
		180,
		165,
		156,
		148,
		142,
		130,
		124,
		121,
		134,
		113,
		88,
		113,
		117,
		97,
		95,
		90,
		-1,
		118,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		173,
		197,
		196,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		129,
		113,
		113,
		110,
		92,
		90,
		120,
		94,
		94,
		84,
		89,
		94,
		88,
		97,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		201,
		-1,
		204,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		111,
		108,
		104,
		84,
		99,
		89,
		88,
		73,
		73,
		81,
		85,
		91,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		221,
		205,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		123,
		111,
		106,
		97,
		79,
		93,
		83,
		79,
		77,
		63,
		67,
		87,
		99,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		115,
		90,
		75,
		72,
		75,
		70,
		56,
		60,
		76,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		110,
		89,
		74,
		76,
		66,
		73,
		51,
		47,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		95,
		90,
		74,
		72,
		61,
		54,
		45,
		38,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		96,
		102,
		94,
		70,
		75,
		55,
		60,
		33,
		32,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		94,
		93,
		101,
		99,
		80,
		75,
		87,
		65,
		65,
		31,
		12,
		15,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		98,
		102,
		103,
		107,
		95,
		93,
		94,
		76,
		89,
		-1,
		35,
		33,
		0,
		24,
		40,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		110,
		105,
		104,
		103,
		100,
		89,
		102,
		95,
		81,
		83,
		91,
		50,
		45,
		27,
		31,
		37,
		45,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		132,
		116,
		115,
		112,
		103,
		111,
		84,
		77,
		84,
		73,
		86,
		54,
		49,
		48,
		40,
		45,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		122,
		139,
		140,
		118,
		112,
		110,
		101,
		89,
		78,
		81,
		73,
		67,
		62,
		46,
		43,
		45,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		136,
		134,
		129,
		120,
		126,
		121,
		98,
		93,
		83,
		72,
		72,
		67,
		68,
		54,
		52,
		48,
		63,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		137,
		121,
		126,
		-1,
		118,
		-1,
		91,
		88,
		79,
		64,
		61,
		64,
		55,
		68,
		54,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		153,
		133,
		127,
		126,
		113,
		105,
		99,
		77,
		70,
		67,
		64,
		77,
		88,
		68,
		56,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		160,
		148,
		138,
		128,
		131,
		121,
		96,
		89,
		75,
		77,
		75,
		73,
		77,
		69,
		61,
		71,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		181,
		152,
		149,
		-1,
		-1,
		132,
		123,
		113,
		92,
		79,
		99,
		102,
		87,
		71,
		85,
		75,
		63,
		72,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		200,
		145,
		134,
		129,
		133,
		131,
		-1,
		105,
		103,
		83,
		97,
		104,
		89,
		84,
		78,
		80,
		80,
		74,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		157,
		151,
		122,
		115,
		119,
		-1,
		107,
		99,
		85,
		102,
		102,
		99,
		90,
		82,
		87,
		77,
		90,
		86,
		76,
		212,
		-1,
		195,
		-1,
		-1,
		-1,
		175,
		190,
		161,
		138,
		111,
		106,
		99,
		93,
		93,
		109,
		110,
		121,
		89,
		85,
		86,
		83,
		82,
		90,
		91,
		-1,
		-1,
		195,
		209,
		201,
		183,
		187,
		188,
		-1,
		-1,
		115,
		106,
		97,
		100,
		103,
		106,
		95,
		92,
		97,
		100,
		90,
		92,
		109,
		94,
		-1,
		-1,
		-1,
		215,
		-1,
		227,
		-1,
		-1,
		202,
		186,
		133,
		115,
		111,
		109,
		102,
		111,
		106,
		100,
		110,
		118,
		110,
		90,
		104,
		120,
		102,
		123,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		204,
		196,
		191,
		197,
		199,
		190,
		148,
		145,
		-1,
		115,
		140,
		112,
		119,
		111,
		118,
		118,
		114,
		94,
		101,
		117,
		114,
		111,
		115,
		110,
		119,
		-1,
		-1,
		295,
		284,
		273,
		279,
		-1,
		197,
		193,
		183,
		173,
		176,
		-1,
		-1,
		164,
		161,
		137,
		121,
		125,
		118,
		113,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		117,
		125,
		-1,
		222,
		286,
		279,
		247,
		255,
		286,
		-1,
		187,
		179,
		190,
		165,
		167,
		-1,
		-1,
		137,
		134,
		139,
		128,
		125,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		131,
		120,
		133,
		137,
		-1,
		236,
		262,
		241,
		244,
		268,
		282,
		-1,
		184,
		-1,
		-1,
		196,
		168,
		152,
		142,
		136,
		186,
		142,
		137,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		130,
		130,
		131,
		-1,
		231,
		242,
		235,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		212,
		-1,
		179,
		-1,
		154,
		158,
		150,
		153,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		137,
		138,
		256,
		212,
		215,
		226,
		237,
		252,
		256,
		-1,
		196,
		235,
		240,
		-1,
		221,
		-1,
		-1,
		-1,
		168,
		163,
		155,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		146,
		252,
		243,
		256,
		201,
		201,
		222,
		231,
		252,
		211,
		202,
		229,
		247,
		236,
		231,
		218,
		-1,
		-1,
		191,
		173,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		245,
		244,
		233,
		230,
		206,
		197,
		192,
		219,
		-1,
		-1,
		214,
		230,
		225,
		229,
		245,
		270,
		-1,
		207,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		229,
		226,
		214,
		212,
		235,
		200,
		188,
		-1,
		201,
		199,
		205,
		212,
		229,
		259,
		-1,
		-1,
		223,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		238,
		252,
		241,
		237,
		236,
		244,
		193,
		186,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		272,
		-1,
		224,
		200,
		214,
		229,
		237,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		212,
		215,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		219,
		220,
		225,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		199,
		203,
		169,
		163,
		202,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		192,
		191,
		159,
		157,
		166,
		171,
		178,
		-1,
		177,
		-1,
		213,
		192,
		203,
		208,
		152,
		149,
		169,
		188,
		170,
		162,
		228,
		182,
		153,
		147,
		165,
		155,
		164,
		156,
		-1,
		153,
		143,
		165,
		144,
		155,
		147,
		-1,
		-1,
		147,
		148,
		154,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		137,
		138,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		128,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		138,
		-1,
		136,
		154,
		157,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		130,
		-1,
		145,
		146,
		141,
		149,
		147,
		123,
		110,
		110,
		120,
		113,
		132,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		128,
		145,
		137,
		127,
		142,
		135,
		113,
		110,
		108,
		105,
		121,
		118,
		128,
		-1,
		-1,
		238,
		207,
		236,
		194,
		175,
		-1,
		141,
		121,
		127,
		131,
		125,
		118,
		132,
		128,
		-1,
		99,
		98,
		125,
		111,
		122,
		198,
		-1,
		-1,
		196,
		188,
		171,
		174,
		151,
		147,
		136,
		135,
		127,
		113,
		109,
		115,
		118,
		118,
		124,
		93,
		103,
		107,
		104,
		107,
		-1,
		-1,
		121,
		-1,
		-1,
		195,
		178,
		-1,
		161,
		168,
		157,
		163,
		149,
		170,
		146,
		137,
		129,
		123,
		111,
		113,
		110,
		123,
		111,
		90,
		115,
		119,
		99,
		97,
		92,
		-1,
		120,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		154,
		157,
		163,
		187,
		186,
		-1,
		158,
		146,
		147,
		132,
		129,
		116,
		104,
		117,
		102,
		109,
		108,
		94,
		92,
		122,
		96,
		96,
		86,
		91,
		96,
		90,
		99,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		191,
		-1,
		194,
		195,
		170,
		143,
		146,
		133,
		124,
		111,
		100,
		111,
		100,
		97,
		105,
		86,
		101,
		91,
		90,
		75,
		75,
		83,
		87,
		93,
		-1,
		253,
		-1,
		195,
		179,
		181,
		153,
		174,
		-1,
		211,
		195,
		187,
		172,
		172,
		-1,
		142,
		139,
		129,
		107,
		92,
		109,
		101,
		99,
		99,
		81,
		95,
		85,
		81,
		79,
		65,
		69,
		89,
		101,
		213,
		203,
		-1,
		185,
		190,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		144,
		157,
		-1,
		113,
		109,
		91,
		92,
		87,
		102,
		92,
		77,
		74,
		77,
		72,
		58,
		62,
		78,
		-1,
		-1,
		198,
		202,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		127,
		124,
		112,
		99,
		84,
		85,
		93,
		106,
		85,
		76,
		77,
		68,
		75,
		53,
		60,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		123,
		102,
		93,
		82,
		80,
		93,
		87,
		92,
		75,
		73,
		63,
		56,
		47,
		51,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		136,
		119,
		100,
		89,
		81,
		70,
		83,
		91,
		89,
		71,
		77,
		57,
		62,
		43,
		45,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		110,
		94,
		89,
		86,
		75,
		74,
		86,
		88,
		78,
		73,
		80,
		67,
		67,
		33,
		25,
		28,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		96,
		92,
		79,
		83,
		84,
		88,
		76,
		82,
		83,
		65,
		89,
		-1,
		39,
		30,
		15,
		0,
		21,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		91,
		86,
		85,
		84,
		81,
		70,
		83,
		76,
		70,
		64,
		77,
		56,
		40,
		17,
		12,
		18,
		26,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		113,
		97,
		96,
		93,
		84,
		92,
		65,
		58,
		69,
		54,
		72,
		49,
		39,
		29,
		21,
		26,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		103,
		120,
		121,
		99,
		93,
		91,
		82,
		70,
		59,
		62,
		54,
		51,
		43,
		27,
		24,
		26,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		117,
		115,
		110,
		101,
		107,
		102,
		79,
		74,
		64,
		53,
		53,
		48,
		49,
		35,
		33,
		29,
		44,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		118,
		102,
		107,
		-1,
		99,
		-1,
		72,
		69,
		60,
		45,
		42,
		45,
		36,
		49,
		35,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		134,
		114,
		108,
		107,
		94,
		86,
		80,
		58,
		51,
		48,
		45,
		58,
		69,
		49,
		37,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		141,
		129,
		119,
		109,
		112,
		102,
		77,
		70,
		56,
		58,
		56,
		54,
		58,
		50,
		42,
		52,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		130,
		-1,
		-1,
		113,
		104,
		94,
		73,
		60,
		80,
		83,
		68,
		52,
		66,
		56,
		44,
		53,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		126,
		115,
		110,
		114,
		112,
		-1,
		86,
		84,
		64,
		78,
		85,
		70,
		65,
		59,
		61,
		61,
		55,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		103,
		96,
		100,
		-1,
		88,
		80,
		66,
		83,
		83,
		80,
		71,
		63,
		68,
		58,
		71,
		67,
		57,
		193,
		-1,
		176,
		-1,
		-1,
		-1,
		156,
		171,
		142,
		119,
		92,
		87,
		80,
		74,
		74,
		90,
		91,
		102,
		70,
		66,
		67,
		64,
		63,
		71,
		72,
		-1,
		-1,
		176,
		190,
		182,
		164,
		168,
		169,
		-1,
		-1,
		96,
		87,
		78,
		81,
		84,
		87,
		76,
		73,
		78,
		81,
		71,
		73,
		90,
		75,
		-1,
		-1,
		-1,
		196,
		-1,
		208,
		-1,
		-1,
		183,
		167,
		114,
		96,
		92,
		90,
		83,
		92,
		87,
		81,
		91,
		99,
		91,
		71,
		85,
		101,
		83,
		104,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		129,
		126,
		-1,
		96,
		121,
		93,
		100,
		92,
		99,
		99,
		95,
		75,
		82,
		98,
		95,
		92,
		96,
		91,
		100,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		118,
		102,
		106,
		99,
		94,
		104,
		84,
		71,
		75,
		79,
		85,
		90,
		95,
		101,
		98,
		106,
		-1,
		203,
		267,
		260,
		228,
		236,
		267,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		109,
		106,
		114,
		109,
		100,
		85,
		91,
		78,
		77,
		95,
		99,
		108,
		112,
		101,
		114,
		118,
		-1,
		217,
		243,
		222,
		225,
		249,
		263,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		117,
		167,
		123,
		118,
		108,
		106,
		97,
		88,
		95,
		86,
		86,
		89,
		104,
		109,
		101,
		111,
		111,
		112,
		-1,
		212,
		223,
		216,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		135,
		139,
		131,
		134,
		122,
		109,
		101,
		93,
		109,
		84,
		94,
		90,
		91,
		100,
		111,
		123,
		118,
		119,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		177,
		216,
		221,
		-1,
		202,
		-1,
		-1,
		-1,
		149,
		144,
		136,
		142,
		121,
		121,
		95,
		99,
		89,
		96,
		106,
		108,
		100,
		104,
		117,
		128,
		127,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		192,
		183,
		210,
		228,
		217,
		212,
		199,
		-1,
		-1,
		172,
		154,
		-1,
		-1,
		128,
		116,
		99,
		100,
		96,
		99,
		114,
		117,
		107,
		105,
		99,
		131,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		211,
		206,
		210,
		226,
		251,
		-1,
		188,
		-1,
		-1,
		173,
		-1,
		-1,
		158,
		121,
		110,
		101,
		107,
		104,
		115,
		125,
		113,
		114,
		104,
		114,
		127,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		204,
		184,
		-1,
		-1,
		156,
		154,
		143,
		-1,
		133,
		106,
		111,
		131,
		133,
		122,
		116,
		110,
		117,
		116,
		124,
		132,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		194,
		190,
		-1,
		-1,
		151,
		144,
		132,
		120,
		110,
		120,
		124,
		128,
		120,
		113,
		108,
		119,
		111,
		115,
		132,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		211,
		197,
		190,
		178,
		176,
		-1,
		185,
		169,
		150,
		-1,
		120,
		133,
		164,
		132,
		137,
		132,
		114,
		125,
		114,
		117,
		131,
		126,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		201,
		203,
		-1,
		202,
		191,
		176,
		168,
		-1,
		-1,
		157,
		153,
		-1,
		-1,
		121,
		146,
		135,
		143,
		138,
		118,
		124,
		127,
		116,
		120,
		132,
		-1,
		-1,
		200,
		201,
		206,
		-1,
		186,
		-1,
		204,
		-1,
		171,
		177,
		165,
		-1,
		-1,
		-1,
		159,
		122,
		143,
		153,
		147,
		145,
		136,
		122,
		129,
		127,
		123,
		134,
		-1,
		-1,
		-1,
		204,
		178,
		211,
		202,
		185,
		165,
		157,
		176,
		-1,
		146,
		-1,
		121,
		123,
		149,
		152,
		158,
		152,
		125,
		140,
		130,
		121,
		130,
		210,
		-1,
		180,
		213,
		177,
		171,
		147,
		151,
		167,
		-1,
		143,
		125,
		-1,
		153,
		143,
		174,
		159,
		140,
		127,
		134,
		134,
		127,
		-1,
		-1,
		-1,
		182,
		181,
		173,
		167,
		167,
		152,
		143,
		-1,
		155,
		137,
		116,
		133,
		133,
		124,
		132,
		164,
		160,
		147,
		147,
		139,
		-1,
		283,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		176,
		171,
		144,
		132,
		138,
		134,
		120,
		126,
		128,
		136,
		134,
		131,
		143,
		139,
		159,
		140,
		175,
		-1,
		278,
		-1,
		212,
		-1,
		-1,
		194,
		174,
		166,
		155,
		144,
		142,
		133,
		124,
		146,
		162,
		146,
		144,
		147,
		148,
		-1,
		267,
		266,
		-1,
		213,
		205,
		191,
		-1,
		184,
		-1,
		190,
		151,
		-1,
		153,
		133,
		-1,
		155,
		151,
		-1,
		-1,
		254,
		229,
		-1,
		-1,
		-1,
		214,
		194,
		185,
		169,
		-1,
		144,
		144,
		-1,
		-1,
		-1,
		239,
		238,
		-1,
		207,
		210,
		-1,
		200,
		191,
		199,
		146,
		150,
		-1,
		-1,
		-1,
		248,
		229,
		223,
		222,
		220,
		215,
		212,
		198,
		182,
		160,
		149,
		170,
		-1,
		-1,
		-1,
		220,
		212,
		205,
		-1,
		-1,
		207,
		190,
		171,
		169,
		-1,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		197,
		-1,
		-1,
		203,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		231,
		-1,
		-1,
		-1,
		193,
		189,
		190,
		-1,
		-1,
		-1,
		-1,
		253,
		254,
		277,
		241,
		-1,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		256,
		254,
		-1,
		-1,
		-1,
		213,
		197,
		-1,
		183,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		218,
		-1,
		218,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		231,
		223,
		231,
		-1,
		203,
		205,
		-1,
		253,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		208,
		215,
		237,
		240,
		276,
		-1,
		227
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		188,
		192,
		158,
		152,
		191,
		160,
		166,
		177,
		-1,
		-1,
		-1,
		181,
		180,
		148,
		146,
		155,
		160,
		167,
		-1,
		166,
		-1,
		202,
		181,
		192,
		197,
		141,
		138,
		158,
		177,
		159,
		151,
		217,
		171,
		142,
		136,
		154,
		144,
		153,
		145,
		-1,
		142,
		132,
		154,
		133,
		144,
		136,
		-1,
		-1,
		136,
		137,
		143,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		126,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		127,
		-1,
		124,
		142,
		146,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		119,
		-1,
		133,
		134,
		129,
		137,
		136,
		112,
		99,
		99,
		109,
		102,
		121,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		116,
		133,
		125,
		115,
		130,
		123,
		102,
		99,
		97,
		94,
		110,
		107,
		117,
		-1,
		-1,
		225,
		194,
		224,
		182,
		163,
		-1,
		129,
		109,
		115,
		119,
		113,
		106,
		120,
		116,
		-1,
		88,
		87,
		114,
		100,
		111,
		185,
		-1,
		-1,
		183,
		175,
		159,
		162,
		139,
		135,
		124,
		123,
		115,
		101,
		97,
		103,
		106,
		106,
		112,
		82,
		92,
		96,
		93,
		96,
		-1,
		-1,
		110,
		-1,
		-1,
		182,
		165,
		-1,
		148,
		155,
		145,
		151,
		137,
		158,
		134,
		125,
		117,
		111,
		99,
		101,
		98,
		111,
		99,
		79,
		104,
		108,
		88,
		86,
		81,
		-1,
		109,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		141,
		144,
		150,
		174,
		174,
		-1,
		146,
		134,
		135,
		120,
		117,
		104,
		92,
		105,
		90,
		97,
		96,
		83,
		81,
		111,
		85,
		85,
		75,
		80,
		85,
		79,
		88,
		-1,
		190,
		186,
		182,
		189,
		138,
		-1,
		-1,
		178,
		-1,
		182,
		183,
		158,
		131,
		134,
		121,
		112,
		99,
		88,
		99,
		88,
		85,
		93,
		75,
		90,
		80,
		79,
		64,
		64,
		72,
		76,
		82,
		-1,
		240,
		-1,
		182,
		166,
		168,
		140,
		161,
		-1,
		198,
		183,
		175,
		160,
		159,
		-1,
		130,
		127,
		117,
		95,
		80,
		97,
		89,
		87,
		88,
		70,
		84,
		74,
		70,
		68,
		54,
		58,
		78,
		90,
		200,
		190,
		-1,
		172,
		177,
		136,
		144,
		163,
		201,
		165,
		-1,
		160,
		-1,
		132,
		145,
		-1,
		101,
		97,
		79,
		80,
		75,
		90,
		81,
		66,
		63,
		66,
		61,
		47,
		51,
		67,
		-1,
		-1,
		185,
		189,
		178,
		129,
		148,
		172,
		209,
		158,
		147,
		146,
		-1,
		137,
		115,
		112,
		100,
		87,
		72,
		73,
		81,
		94,
		73,
		65,
		64,
		57,
		64,
		42,
		53,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		155,
		126,
		150,
		192,
		176,
		169,
		157,
		122,
		122,
		116,
		-1,
		111,
		90,
		81,
		70,
		68,
		81,
		74,
		81,
		62,
		60,
		52,
		45,
		36,
		44,
		-1,
		-1,
		-1,
		185,
		174,
		175,
		121,
		144,
		181,
		155,
		141,
		146,
		121,
		114,
		108,
		124,
		107,
		88,
		77,
		69,
		58,
		70,
		78,
		76,
		58,
		66,
		46,
		51,
		32,
		38,
		-1,
		-1,
		192,
		182,
		166,
		168,
		165,
		135,
		142,
		174,
		146,
		159,
		-1,
		113,
		-1,
		102,
		98,
		82,
		77,
		74,
		62,
		61,
		74,
		75,
		65,
		60,
		67,
		56,
		56,
		22,
		42,
		45,
		-1,
		-1,
		-1,
		185,
		180,
		155,
		132,
		116,
		152,
		-1,
		129,
		130,
		-1,
		107,
		101,
		98,
		84,
		80,
		66,
		70,
		72,
		75,
		63,
		69,
		70,
		52,
		76,
		-1,
		30,
		24,
		32,
		22,
		0,
		-1,
		-1,
		-1,
		178,
		157,
		150,
		170,
		111,
		163,
		-1,
		-1,
		114,
		107,
		-1,
		94,
		76,
		78,
		73,
		72,
		71,
		68,
		57,
		70,
		63,
		57,
		51,
		64,
		45,
		35,
		12,
		8,
		5,
		19,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		131,
		-1,
		123,
		115,
		105,
		99,
		93,
		89,
		87,
		100,
		84,
		83,
		80,
		71,
		79,
		52,
		45,
		56,
		41,
		59,
		37,
		27,
		20,
		12,
		15,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		144,
		-1,
		108,
		122,
		138,
		-1,
		131,
		110,
		125,
		103,
		99,
		90,
		107,
		108,
		86,
		80,
		78,
		69,
		57,
		46,
		49,
		41,
		39,
		31,
		15,
		15,
		17,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		93,
		125,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		104,
		102,
		97,
		88,
		94,
		89,
		66,
		61,
		51,
		40,
		40,
		35,
		37,
		23,
		21,
		16,
		31,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		105,
		89,
		94,
		-1,
		86,
		-1,
		59,
		56,
		47,
		32,
		29,
		33,
		24,
		37,
		22,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		162,
		-1,
		-1,
		132,
		126,
		126,
		110,
		113,
		121,
		101,
		95,
		94,
		81,
		73,
		67,
		45,
		38,
		35,
		32,
		45,
		57,
		36,
		24,
		-1,
		-1,
		-1,
		159,
		145,
		149,
		109,
		128,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		119,
		128,
		116,
		106,
		96,
		99,
		89,
		64,
		57,
		43,
		45,
		43,
		41,
		46,
		37,
		29,
		39,
		-1,
		-1,
		142,
		147,
		135,
		121,
		140,
		-1,
		-1,
		-1,
		141,
		157,
		149,
		120,
		117,
		-1,
		-1,
		100,
		91,
		81,
		60,
		47,
		67,
		70,
		56,
		40,
		53,
		43,
		31,
		40,
		-1,
		145,
		132,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		-1,
		-1,
		168,
		113,
		102,
		97,
		101,
		99,
		-1,
		73,
		71,
		51,
		65,
		72,
		58,
		53,
		47,
		48,
		48,
		42,
		-1,
		-1,
		157,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		125,
		119,
		90,
		83,
		87,
		-1,
		75,
		67,
		53,
		70,
		71,
		68,
		59,
		51,
		56,
		45,
		58,
		54,
		44,
		180,
		-1,
		163,
		-1,
		-1,
		-1,
		143,
		158,
		129,
		106,
		79,
		74,
		67,
		61,
		61,
		77,
		79,
		90,
		58,
		54,
		55,
		51,
		50,
		58,
		59,
		-1,
		-1,
		163,
		177,
		169,
		151,
		155,
		156,
		-1,
		-1,
		83,
		74,
		65,
		68,
		71,
		74,
		64,
		61,
		66,
		68,
		59,
		60,
		77,
		62,
		-1,
		-1,
		-1,
		183,
		-1,
		195,
		-1,
		-1,
		170,
		154,
		101,
		83,
		79,
		77,
		70,
		79,
		74,
		69,
		79,
		86,
		78,
		58,
		72,
		88,
		70,
		91,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		172,
		164,
		159,
		165,
		167,
		158,
		116,
		113,
		-1,
		83,
		108,
		80,
		87,
		79,
		87,
		87,
		82,
		62,
		69,
		85,
		82,
		79,
		83,
		78,
		87,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		165,
		161,
		151,
		141,
		144,
		-1,
		-1,
		132,
		129,
		105,
		89,
		93,
		86,
		81,
		91,
		71,
		58,
		62,
		66,
		72,
		77,
		82,
		88,
		85,
		93,
		-1,
		190,
		254,
		247,
		215,
		223,
		254,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		105,
		102,
		107,
		96,
		93,
		101,
		96,
		87,
		72,
		78,
		65,
		64,
		82,
		86,
		95,
		99,
		88,
		101,
		105,
		-1,
		204,
		230,
		209,
		212,
		236,
		250,
		-1,
		152,
		-1,
		-1,
		164,
		136,
		120,
		110,
		104,
		154,
		110,
		105,
		95,
		93,
		84,
		75,
		82,
		73,
		73,
		76,
		91,
		96,
		88,
		98,
		98,
		99,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		180,
		-1,
		147,
		-1,
		122,
		126,
		118,
		121,
		109,
		96,
		88,
		80,
		96,
		71,
		81,
		77,
		78,
		87,
		98,
		110,
		105,
		106,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		164,
		203,
		208,
		-1,
		189,
		-1,
		-1,
		-1,
		136,
		131,
		123,
		129,
		108,
		108,
		82,
		86,
		76,
		83,
		93,
		95,
		87,
		91,
		104,
		115,
		114,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		179,
		170,
		197,
		215,
		204,
		199,
		186,
		-1,
		-1,
		159,
		141,
		-1,
		-1,
		115,
		103,
		86,
		87,
		83,
		86,
		101,
		104,
		94,
		92,
		86,
		118,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		198,
		193,
		197,
		213,
		238,
		-1,
		175,
		-1,
		-1,
		160,
		-1,
		-1,
		145,
		108,
		97,
		88,
		94,
		91,
		102,
		112,
		100,
		101,
		91,
		101,
		114,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		197,
		227,
		-1,
		-1,
		191,
		171,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		93,
		98,
		118,
		120,
		109,
		103,
		97,
		104,
		103,
		111,
		119,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		181,
		177,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		111,
		115,
		107,
		100,
		95,
		106,
		98,
		102,
		119,
		-1,
		240,
		-1,
		192,
		168,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		198,
		184,
		177,
		165,
		163,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		151,
		119,
		124,
		119,
		101,
		112,
		101,
		104,
		118,
		113,
		-1,
		-1,
		180,
		183,
		-1,
		-1,
		188,
		190,
		-1,
		189,
		178,
		163,
		155,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		108,
		133,
		122,
		130,
		125,
		105,
		111,
		114,
		103,
		107,
		119,
		-1,
		-1,
		187,
		188,
		193,
		-1,
		173,
		-1,
		191,
		-1,
		158,
		164,
		152,
		-1,
		-1,
		-1,
		146,
		109,
		130,
		140,
		134,
		132,
		123,
		109,
		116,
		114,
		110,
		121,
		-1,
		-1,
		-1,
		191,
		165,
		198,
		189,
		172,
		152,
		144,
		163,
		-1,
		133,
		-1,
		108,
		110,
		136,
		139,
		145,
		139,
		112,
		127,
		117,
		108,
		117,
		197,
		-1,
		167,
		200,
		164,
		158,
		134,
		138,
		154,
		-1,
		130,
		112,
		-1,
		140,
		130,
		161,
		146,
		127,
		114,
		121,
		121,
		114,
		-1,
		-1,
		-1,
		169,
		168,
		160,
		154,
		154,
		139,
		130,
		-1,
		142,
		124,
		103,
		120,
		120,
		111,
		119,
		151,
		147,
		134,
		134,
		126,
		-1,
		270,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		163,
		158,
		131,
		119,
		125,
		121,
		107,
		113,
		115,
		123,
		121,
		118,
		130,
		126,
		146,
		127,
		162,
		-1,
		265,
		-1,
		199,
		-1,
		-1,
		181,
		161,
		153,
		142,
		131,
		129,
		120,
		111,
		133,
		149,
		133,
		131,
		134,
		135,
		-1,
		254,
		253,
		-1,
		200,
		192,
		178,
		-1,
		171,
		-1,
		177,
		138,
		-1,
		140,
		120,
		-1,
		142,
		138,
		-1,
		-1,
		241,
		216,
		-1,
		-1,
		-1,
		201,
		181,
		172,
		156,
		-1,
		131,
		131,
		-1,
		-1,
		-1,
		226,
		225,
		-1,
		194,
		197,
		-1,
		187,
		178,
		186,
		133,
		137,
		-1,
		-1,
		-1,
		235,
		216,
		210,
		209,
		207,
		202,
		199,
		185,
		169,
		147,
		136,
		157,
		-1,
		-1,
		-1,
		207,
		199,
		192,
		-1,
		-1,
		194,
		177,
		158,
		156,
		-1,
		-1,
		-1,
		229,
		210,
		-1,
		-1,
		184,
		-1,
		-1,
		190,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		218,
		-1,
		-1,
		-1,
		180,
		176,
		177,
		-1,
		-1,
		-1,
		-1,
		240,
		241,
		264,
		228,
		-1,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		243,
		241,
		-1,
		-1,
		-1,
		200,
		184,
		-1,
		170,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		205,
		-1,
		205,
		180,
		187,
		-1,
		-1,
		-1,
		-1,
		218,
		210,
		218,
		-1,
		190,
		192,
		-1,
		240,
		-1,
		-1,
		233,
		224,
		-1,
		-1,
		195,
		202,
		224,
		227,
		263,
		-1,
		214
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		194,
		196,
		162,
		156,
		195,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		185,
		184,
		154,
		152,
		161,
		166,
		173,
		-1,
		196,
		-1,
		206,
		185,
		196,
		201,
		147,
		144,
		164,
		183,
		189,
		181,
		221,
		177,
		148,
		142,
		160,
		165,
		183,
		175,
		-1,
		148,
		138,
		160,
		164,
		176,
		159,
		-1,
		-1,
		142,
		143,
		149,
		161,
		166,
		171,
		-1,
		197,
		205,
		-1,
		-1,
		132,
		145,
		141,
		144,
		152,
		168,
		189,
		205,
		200,
		-1,
		-1,
		133,
		137,
		150,
		151,
		149,
		176,
		195,
		195,
		209,
		208,
		-1,
		121,
		139,
		148,
		157,
		163,
		152,
		156,
		174,
		194,
		200,
		203,
		-1,
		113,
		115,
		144,
		150,
		162,
		168,
		155,
		161,
		180,
		182,
		201,
		192,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		118,
		144,
		143,
		139,
		157,
		179,
		158,
		164,
		168,
		174,
		190,
		191,
		201,
		-1,
		-1,
		166,
		135,
		170,
		127,
		112,
		-1,
		106,
		125,
		131,
		135,
		140,
		148,
		176,
		174,
		-1,
		168,
		167,
		198,
		184,
		195,
		126,
		-1,
		-1,
		124,
		116,
		101,
		104,
		101,
		101,
		131,
		130,
		135,
		137,
		139,
		151,
		166,
		166,
		176,
		162,
		172,
		176,
		187,
		202,
		-1,
		-1,
		257,
		-1,
		-1,
		123,
		106,
		-1,
		89,
		96,
		96,
		113,
		103,
		124,
		139,
		143,
		151,
		154,
		142,
		161,
		158,
		177,
		165,
		159,
		184,
		188,
		182,
		203,
		198,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		82,
		85,
		91,
		115,
		125,
		-1,
		146,
		144,
		168,
		162,
		167,
		163,
		148,
		166,
		156,
		163,
		162,
		166,
		168,
		201,
		179,
		201,
		198,
		227,
		232,
		226,
		235,
		-1,
		131,
		127,
		123,
		130,
		79,
		-1,
		-1,
		119,
		-1,
		133,
		146,
		158,
		148,
		151,
		163,
		171,
		165,
		154,
		165,
		154,
		151,
		159,
		168,
		179,
		174,
		173,
		191,
		206,
		219,
		223,
		229,
		-1,
		181,
		-1,
		123,
		107,
		109,
		81,
		102,
		-1,
		139,
		134,
		154,
		160,
		160,
		-1,
		173,
		173,
		183,
		161,
		146,
		163,
		155,
		153,
		158,
		163,
		177,
		168,
		186,
		193,
		201,
		205,
		225,
		237,
		141,
		131,
		-1,
		113,
		118,
		77,
		85,
		104,
		177,
		161,
		-1,
		171,
		-1,
		163,
		188,
		-1,
		167,
		163,
		145,
		146,
		141,
		156,
		162,
		159,
		156,
		174,
		177,
		194,
		198,
		214,
		-1,
		-1,
		126,
		130,
		119,
		70,
		89,
		113,
		150,
		169,
		158,
		157,
		-1,
		148,
		178,
		175,
		161,
		148,
		138,
		139,
		147,
		160,
		139,
		158,
		161,
		183,
		211,
		189,
		201,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		96,
		67,
		91,
		133,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		168,
		151,
		147,
		136,
		134,
		147,
		142,
		158,
		162,
		161,
		180,
		192,
		183,
		203,
		-1,
		-1,
		-1,
		126,
		115,
		116,
		62,
		77,
		115,
		166,
		152,
		157,
		132,
		125,
		119,
		171,
		168,
		135,
		143,
		135,
		124,
		138,
		146,
		150,
		159,
		168,
		174,
		198,
		198,
		204,
		-1,
		-1,
		133,
		123,
		107,
		109,
		106,
		68,
		78,
		110,
		157,
		154,
		-1,
		124,
		-1,
		113,
		121,
		120,
		126,
		138,
		124,
		129,
		140,
		152,
		165,
		161,
		168,
		203,
		203,
		188,
		208,
		211,
		-1,
		-1,
		-1,
		126,
		36,
		26,
		38,
		57,
		88,
		-1,
		124,
		125,
		-1,
		118,
		112,
		118,
		117,
		124,
		121,
		121,
		135,
		143,
		139,
		155,
		161,
		153,
		189,
		-1,
		196,
		190,
		198,
		188,
		176,
		-1,
		-1,
		-1,
		0,
		14,
		32,
		52,
		58,
		110,
		-1,
		-1,
		109,
		102,
		-1,
		105,
		105,
		112,
		121,
		126,
		131,
		139,
		134,
		147,
		152,
		158,
		163,
		181,
		185,
		189,
		178,
		174,
		171,
		185,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		61,
		78,
		-1,
		115,
		107,
		100,
		94,
		100,
		118,
		116,
		136,
		128,
		142,
		142,
		148,
		156,
		141,
		144,
		160,
		158,
		176,
		184,
		176,
		170,
		169,
		181,
		-1,
		166,
		152,
		123,
		-1,
		-1,
		93,
		-1,
		64,
		88,
		104,
		-1,
		134,
		113,
		136,
		114,
		128,
		124,
		162,
		163,
		141,
		146,
		154,
		164,
		166,
		155,
		166,
		158,
		180,
		180,
		164,
		165,
		174,
		-1,
		172,
		159,
		117,
		113,
		102,
		122,
		67,
		82,
		91,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		138,
		136,
		152,
		143,
		149,
		165,
		168,
		170,
		160,
		149,
		155,
		152,
		174,
		160,
		158,
		177,
		193,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		88,
		75,
		69,
		-1,
		108,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		160,
		144,
		149,
		-1,
		195,
		-1,
		168,
		170,
		164,
		149,
		146,
		157,
		155,
		166,
		183,
		-1,
		122,
		107,
		100,
		90,
		104,
		75,
		-1,
		130,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		176,
		156,
		150,
		149,
		190,
		190,
		176,
		162,
		155,
		152,
		149,
		162,
		182,
		173,
		185,
		-1,
		-1,
		-1,
		127,
		113,
		117,
		77,
		96,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		193,
		181,
		171,
		161,
		195,
		196,
		181,
		174,
		160,
		162,
		160,
		158,
		163,
		184,
		185,
		198,
		-1,
		-1,
		110,
		115,
		103,
		89,
		108,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		182,
		-1,
		-1,
		173,
		171,
		181,
		177,
		164,
		184,
		187,
		173,
		157,
		172,
		184,
		192,
		197,
		-1,
		113,
		100,
		-1,
		-1,
		111,
		105,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		163,
		184,
		209,
		176,
		-1,
		181,
		182,
		168,
		182,
		189,
		175,
		170,
		164,
		167,
		185,
		202,
		-1,
		-1,
		125,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		142,
		156,
		177,
		183,
		195,
		-1,
		190,
		184,
		170,
		187,
		188,
		185,
		176,
		168,
		173,
		170,
		183,
		197,
		201,
		148,
		-1,
		131,
		-1,
		-1,
		-1,
		160,
		175,
		237,
		214,
		187,
		191,
		184,
		178,
		178,
		194,
		196,
		207,
		175,
		171,
		172,
		176,
		175,
		192,
		202,
		-1,
		-1,
		131,
		148,
		183,
		168,
		172,
		264,
		-1,
		-1,
		200,
		191,
		182,
		185,
		188,
		191,
		181,
		178,
		183,
		188,
		176,
		185,
		203,
		207,
		-1,
		-1,
		-1,
		151,
		-1,
		166,
		-1,
		-1,
		187,
		271,
		218,
		200,
		196,
		194,
		187,
		196,
		191,
		186,
		196,
		205,
		197,
		178,
		189,
		212,
		201,
		239,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		180,
		155,
		170,
		216,
		207,
		212,
		233,
		230,
		-1,
		200,
		225,
		197,
		204,
		196,
		204,
		204,
		201,
		179,
		186,
		202,
		201,
		196,
		231,
		223,
		229,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		186,
		172,
		202,
		192,
		198,
		-1,
		-1,
		245,
		242,
		222,
		206,
		210,
		203,
		198,
		208,
		188,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		158,
		239,
		232,
		215,
		223,
		254,
		-1,
		189,
		198,
		179,
		184,
		192,
		-1,
		-1,
		218,
		214,
		219,
		213,
		210,
		218,
		213,
		204,
		189,
		195,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		172,
		215,
		209,
		212,
		236,
		250,
		-1,
		202,
		-1,
		-1,
		187,
		205,
		213,
		209,
		213,
		266,
		227,
		222,
		212,
		210,
		201,
		192,
		199,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		207,
		195,
		203,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		203,
		-1,
		239,
		-1,
		232,
		236,
		235,
		238,
		226,
		213,
		205,
		197,
		213,
		188,
		198,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		281,
		236,
		203,
		194,
		241,
		256,
		260,
		-1,
		215,
		254,
		241,
		-1,
		212,
		-1,
		-1,
		-1,
		246,
		248,
		240,
		246,
		225,
		225,
		199,
		203,
		193,
		200,
		210,
		212,
		204,
		208,
		221,
		232,
		235,
		277,
		275,
		280,
		225,
		208,
		226,
		235,
		256,
		230,
		221,
		248,
		248,
		237,
		232,
		219,
		-1,
		-1,
		269,
		258,
		-1,
		-1,
		232,
		220,
		203,
		204,
		200,
		203,
		218,
		221,
		211,
		209,
		203,
		235,
		-1,
		277,
		276,
		265,
		262,
		238,
		229,
		216,
		227,
		-1,
		-1,
		233,
		249,
		262,
		266,
		279,
		304,
		-1,
		222,
		-1,
		-1,
		277,
		-1,
		-1,
		262,
		225,
		214,
		205,
		211,
		208,
		219,
		229,
		217,
		218,
		208,
		218,
		231,
		261,
		258,
		246,
		244,
		267,
		224,
		220,
		-1,
		248,
		236,
		242,
		249,
		266,
		293,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		260,
		258,
		247,
		-1,
		237,
		210,
		215,
		235,
		237,
		226,
		220,
		214,
		221,
		220,
		228,
		236,
		270,
		284,
		273,
		269,
		268,
		276,
		225,
		242,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		-1,
		273,
		248,
		-1,
		-1,
		255,
		248,
		236,
		224,
		214,
		224,
		228,
		232,
		224,
		217,
		212,
		223,
		215,
		219,
		236,
		-1,
		304,
		-1,
		256,
		249,
		264,
		279,
		287,
		-1,
		-1,
		-1,
		290,
		276,
		269,
		257,
		255,
		-1,
		289,
		273,
		254,
		-1,
		224,
		237,
		268,
		236,
		241,
		236,
		218,
		229,
		218,
		221,
		235,
		230,
		-1,
		-1,
		262,
		265,
		-1,
		-1,
		287,
		306,
		-1,
		281,
		270,
		255,
		247,
		-1,
		-1,
		261,
		257,
		-1,
		-1,
		225,
		250,
		239,
		247,
		242,
		222,
		228,
		231,
		220,
		224,
		236,
		-1,
		-1,
		269,
		270,
		275,
		-1,
		290,
		-1,
		305,
		-1,
		250,
		266,
		268,
		-1,
		-1,
		-1,
		263,
		226,
		247,
		257,
		251,
		249,
		240,
		226,
		233,
		231,
		227,
		238,
		-1,
		-1,
		-1,
		308,
		282,
		312,
		303,
		286,
		266,
		258,
		280,
		-1,
		250,
		-1,
		225,
		227,
		253,
		256,
		262,
		256,
		229,
		244,
		234,
		225,
		234,
		314,
		-1,
		284,
		317,
		281,
		272,
		251,
		255,
		271,
		-1,
		247,
		229,
		-1,
		257,
		247,
		278,
		263,
		244,
		231,
		238,
		238,
		231,
		-1,
		-1,
		-1,
		286,
		285,
		277,
		271,
		271,
		256,
		247,
		-1,
		259,
		241,
		220,
		237,
		237,
		228,
		236,
		268,
		264,
		251,
		251,
		243,
		-1,
		376,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		280,
		275,
		248,
		236,
		242,
		238,
		224,
		230,
		232,
		240,
		238,
		235,
		247,
		243,
		263,
		244,
		279,
		-1,
		382,
		-1,
		316,
		-1,
		-1,
		298,
		278,
		270,
		259,
		248,
		246,
		237,
		228,
		250,
		266,
		250,
		248,
		251,
		252,
		-1,
		371,
		370,
		-1,
		317,
		309,
		295,
		-1,
		288,
		-1,
		294,
		255,
		-1,
		257,
		237,
		-1,
		259,
		255,
		-1,
		-1,
		358,
		333,
		-1,
		-1,
		-1,
		318,
		298,
		289,
		273,
		-1,
		248,
		248,
		-1,
		-1,
		-1,
		343,
		342,
		-1,
		311,
		314,
		-1,
		304,
		295,
		303,
		250,
		254,
		-1,
		-1,
		-1,
		352,
		333,
		327,
		326,
		324,
		319,
		316,
		302,
		286,
		264,
		253,
		274,
		-1,
		-1,
		-1,
		324,
		316,
		309,
		-1,
		-1,
		311,
		294,
		275,
		273,
		-1,
		-1,
		-1,
		346,
		327,
		-1,
		-1,
		301,
		-1,
		-1,
		307,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		363,
		335,
		-1,
		-1,
		-1,
		297,
		293,
		294,
		-1,
		-1,
		-1,
		-1,
		357,
		358,
		381,
		345,
		-1,
		-1,
		-1,
		289,
		283,
		-1,
		-1,
		360,
		358,
		-1,
		-1,
		-1,
		317,
		301,
		-1,
		287,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		322,
		-1,
		322,
		297,
		304,
		-1,
		-1,
		-1,
		-1,
		335,
		327,
		335,
		-1,
		307,
		309,
		-1,
		357,
		-1,
		-1,
		350,
		341,
		-1,
		-1,
		312,
		319,
		341,
		344,
		380,
		-1,
		331
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		182,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		175,
		167,
		207,
		163,
		134,
		128,
		146,
		151,
		169,
		161,
		-1,
		134,
		124,
		146,
		150,
		162,
		145,
		-1,
		-1,
		128,
		129,
		135,
		147,
		152,
		157,
		-1,
		183,
		191,
		-1,
		-1,
		118,
		131,
		127,
		130,
		138,
		154,
		175,
		191,
		186,
		-1,
		-1,
		119,
		123,
		136,
		137,
		135,
		162,
		181,
		181,
		195,
		194,
		-1,
		107,
		125,
		134,
		143,
		149,
		138,
		142,
		160,
		180,
		186,
		189,
		-1,
		99,
		101,
		130,
		136,
		148,
		154,
		141,
		147,
		166,
		168,
		187,
		178,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		96,
		104,
		130,
		129,
		125,
		143,
		165,
		144,
		150,
		154,
		160,
		176,
		177,
		187,
		-1,
		-1,
		152,
		121,
		156,
		113,
		98,
		-1,
		92,
		111,
		117,
		121,
		126,
		134,
		162,
		160,
		-1,
		154,
		153,
		184,
		170,
		181,
		112,
		-1,
		-1,
		110,
		102,
		87,
		90,
		87,
		87,
		117,
		116,
		121,
		123,
		125,
		137,
		152,
		152,
		162,
		148,
		158,
		162,
		173,
		188,
		-1,
		-1,
		243,
		-1,
		-1,
		109,
		92,
		-1,
		75,
		82,
		82,
		99,
		89,
		110,
		125,
		129,
		137,
		140,
		128,
		147,
		144,
		163,
		151,
		145,
		170,
		174,
		168,
		189,
		184,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		68,
		71,
		77,
		101,
		111,
		-1,
		132,
		130,
		154,
		148,
		153,
		149,
		134,
		152,
		142,
		149,
		148,
		152,
		154,
		187,
		165,
		187,
		184,
		213,
		218,
		212,
		221,
		-1,
		117,
		113,
		109,
		116,
		65,
		-1,
		-1,
		105,
		-1,
		119,
		132,
		144,
		134,
		137,
		149,
		157,
		151,
		140,
		151,
		140,
		137,
		145,
		154,
		165,
		160,
		159,
		177,
		192,
		205,
		209,
		215,
		-1,
		167,
		-1,
		109,
		93,
		95,
		67,
		88,
		-1,
		125,
		120,
		140,
		146,
		146,
		-1,
		159,
		159,
		169,
		147,
		132,
		149,
		141,
		139,
		144,
		149,
		163,
		154,
		172,
		179,
		187,
		191,
		211,
		223,
		127,
		117,
		-1,
		99,
		104,
		63,
		71,
		90,
		163,
		147,
		-1,
		157,
		-1,
		149,
		174,
		-1,
		153,
		149,
		131,
		132,
		127,
		142,
		148,
		145,
		142,
		160,
		163,
		180,
		184,
		200,
		-1,
		-1,
		112,
		116,
		105,
		56,
		75,
		99,
		136,
		155,
		144,
		143,
		-1,
		134,
		164,
		161,
		147,
		134,
		124,
		125,
		133,
		146,
		125,
		144,
		147,
		169,
		197,
		175,
		187,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		82,
		53,
		77,
		119,
		173,
		166,
		154,
		119,
		119,
		113,
		-1,
		154,
		137,
		133,
		122,
		120,
		133,
		128,
		144,
		148,
		147,
		166,
		178,
		169,
		189,
		-1,
		-1,
		-1,
		112,
		101,
		102,
		48,
		63,
		101,
		152,
		138,
		143,
		118,
		111,
		105,
		157,
		154,
		121,
		129,
		121,
		110,
		124,
		132,
		136,
		145,
		154,
		160,
		184,
		184,
		190,
		-1,
		-1,
		119,
		109,
		93,
		95,
		92,
		54,
		64,
		96,
		143,
		140,
		-1,
		110,
		-1,
		99,
		107,
		106,
		112,
		124,
		110,
		115,
		126,
		138,
		151,
		147,
		154,
		189,
		189,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		112,
		26,
		16,
		24,
		43,
		74,
		-1,
		110,
		111,
		-1,
		104,
		98,
		104,
		103,
		110,
		107,
		107,
		121,
		129,
		125,
		141,
		147,
		139,
		175,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		21,
		0,
		18,
		38,
		44,
		96,
		-1,
		-1,
		95,
		88,
		-1,
		91,
		91,
		98,
		107,
		112,
		117,
		125,
		120,
		133,
		138,
		144,
		149,
		167,
		171,
		175,
		164,
		160,
		157,
		171,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		47,
		64,
		-1,
		101,
		93,
		86,
		80,
		86,
		104,
		102,
		122,
		114,
		128,
		128,
		134,
		142,
		127,
		130,
		146,
		144,
		162,
		170,
		162,
		156,
		155,
		167,
		-1,
		152,
		138,
		109,
		-1,
		-1,
		79,
		-1,
		50,
		74,
		90,
		-1,
		120,
		99,
		122,
		100,
		114,
		110,
		148,
		149,
		127,
		132,
		140,
		150,
		152,
		141,
		152,
		144,
		166,
		166,
		150,
		151,
		160,
		-1,
		158,
		145,
		103,
		99,
		88,
		108,
		53,
		68,
		77,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		124,
		122,
		138,
		129,
		135,
		151,
		154,
		156,
		146,
		135,
		141,
		138,
		160,
		146,
		144,
		163,
		179,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		74,
		61,
		55,
		-1,
		94,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		146,
		130,
		135,
		-1,
		181,
		-1,
		154,
		156,
		150,
		135,
		132,
		143,
		141,
		152,
		169,
		-1,
		108,
		93,
		86,
		76,
		90,
		61,
		-1,
		116,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		162,
		142,
		136,
		135,
		176,
		176,
		162,
		148,
		141,
		138,
		135,
		148,
		168,
		159,
		171,
		-1,
		-1,
		-1,
		113,
		99,
		103,
		63,
		82,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		179,
		167,
		157,
		147,
		181,
		182,
		167,
		160,
		146,
		148,
		146,
		144,
		149,
		170,
		171,
		184,
		-1,
		-1,
		96,
		101,
		89,
		75,
		94,
		-1,
		-1,
		-1,
		138,
		154,
		146,
		117,
		168,
		-1,
		-1,
		159,
		157,
		167,
		163,
		150,
		170,
		173,
		159,
		143,
		158,
		170,
		178,
		183,
		-1,
		99,
		86,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		149,
		170,
		195,
		162,
		-1,
		167,
		168,
		154,
		168,
		175,
		161,
		156,
		150,
		153,
		171,
		188,
		-1,
		-1,
		111,
		-1,
		106,
		-1,
		-1,
		-1,
		-1,
		128,
		142,
		163,
		169,
		181,
		-1,
		176,
		170,
		156,
		173,
		174,
		171,
		162,
		154,
		159,
		156,
		169,
		183,
		187,
		134,
		-1,
		117,
		-1,
		-1,
		-1,
		146,
		161,
		223,
		200,
		173,
		177,
		170,
		164,
		164,
		180,
		182,
		193,
		161,
		157,
		158,
		162,
		161,
		178,
		188,
		-1,
		-1,
		117,
		134,
		169,
		154,
		158,
		250,
		-1,
		-1,
		186,
		177,
		168,
		171,
		174,
		177,
		167,
		164,
		169,
		174,
		162,
		171,
		189,
		193,
		-1,
		-1,
		-1,
		137,
		-1,
		152,
		-1,
		-1,
		173,
		257,
		204,
		186,
		182,
		180,
		173,
		182,
		177,
		172,
		182,
		191,
		183,
		164,
		175,
		198,
		187,
		225,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		166,
		141,
		156,
		202,
		193,
		198,
		219,
		216,
		-1,
		186,
		211,
		183,
		190,
		182,
		190,
		190,
		187,
		165,
		172,
		188,
		187,
		182,
		217,
		209,
		215,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		172,
		158,
		188,
		178,
		184,
		-1,
		-1,
		231,
		228,
		208,
		192,
		196,
		189,
		184,
		194,
		174,
		161,
		165,
		169,
		175,
		180,
		185,
		191,
		206,
		221,
		-1,
		144,
		225,
		218,
		201,
		209,
		240,
		-1,
		175,
		184,
		165,
		170,
		178,
		-1,
		-1,
		204,
		200,
		205,
		199,
		196,
		204,
		199,
		190,
		175,
		181,
		168,
		167,
		185,
		189,
		198,
		205,
		195,
		208,
		212,
		-1,
		158,
		201,
		195,
		198,
		222,
		236,
		-1,
		188,
		-1,
		-1,
		173,
		191,
		199,
		195,
		199,
		252,
		213,
		208,
		198,
		196,
		187,
		178,
		185,
		176,
		176,
		179,
		194,
		199,
		191,
		205,
		205,
		206,
		-1,
		193,
		181,
		189,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		189,
		-1,
		225,
		-1,
		218,
		222,
		221,
		224,
		212,
		199,
		191,
		183,
		199,
		174,
		184,
		180,
		181,
		190,
		201,
		213,
		212,
		213,
		267,
		222,
		189,
		180,
		227,
		242,
		246,
		-1,
		201,
		240,
		227,
		-1,
		198,
		-1,
		-1,
		-1,
		232,
		234,
		226,
		232,
		211,
		211,
		185,
		189,
		179,
		186,
		196,
		198,
		190,
		194,
		207,
		218,
		221,
		263,
		261,
		266,
		211,
		194,
		212,
		221,
		242,
		216,
		207,
		234,
		234,
		223,
		218,
		205,
		-1,
		-1,
		255,
		244,
		-1,
		-1,
		218,
		206,
		189,
		190,
		186,
		189,
		204,
		207,
		197,
		195,
		189,
		221,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		202,
		213,
		-1,
		-1,
		219,
		235,
		248,
		252,
		265,
		290,
		-1,
		208,
		-1,
		-1,
		263,
		-1,
		-1,
		248,
		211,
		200,
		191,
		197,
		194,
		205,
		215,
		203,
		204,
		194,
		204,
		217,
		247,
		244,
		232,
		230,
		253,
		210,
		206,
		-1,
		234,
		222,
		228,
		235,
		252,
		279,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		246,
		244,
		233,
		-1,
		223,
		196,
		201,
		221,
		223,
		212,
		206,
		200,
		207,
		206,
		214,
		222,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		-1,
		259,
		234,
		-1,
		-1,
		241,
		234,
		222,
		210,
		200,
		210,
		214,
		218,
		210,
		203,
		198,
		209,
		201,
		205,
		222,
		-1,
		290,
		-1,
		242,
		235,
		250,
		265,
		273,
		-1,
		-1,
		-1,
		276,
		262,
		255,
		243,
		241,
		-1,
		275,
		259,
		240,
		-1,
		210,
		223,
		254,
		222,
		227,
		222,
		204,
		215,
		204,
		207,
		221,
		216,
		-1,
		-1,
		248,
		251,
		-1,
		-1,
		273,
		292,
		-1,
		267,
		256,
		241,
		233,
		-1,
		-1,
		247,
		243,
		-1,
		-1,
		211,
		236,
		225,
		233,
		228,
		208,
		214,
		217,
		206,
		210,
		222,
		-1,
		-1,
		255,
		256,
		261,
		-1,
		276,
		-1,
		291,
		-1,
		236,
		252,
		254,
		-1,
		-1,
		-1,
		249,
		212,
		233,
		243,
		237,
		235,
		226,
		212,
		219,
		217,
		213,
		224,
		-1,
		-1,
		-1,
		294,
		268,
		298,
		289,
		272,
		252,
		244,
		266,
		-1,
		236,
		-1,
		211,
		213,
		239,
		242,
		248,
		242,
		215,
		230,
		220,
		211,
		220,
		300,
		-1,
		270,
		303,
		267,
		258,
		237,
		241,
		257,
		-1,
		233,
		215,
		-1,
		243,
		233,
		264,
		249,
		230,
		217,
		224,
		224,
		217,
		-1,
		-1,
		-1,
		272,
		271,
		263,
		257,
		257,
		242,
		233,
		-1,
		245,
		227,
		206,
		223,
		223,
		214,
		222,
		254,
		250,
		237,
		237,
		229,
		-1,
		362,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		266,
		261,
		234,
		222,
		228,
		224,
		210,
		216,
		218,
		226,
		224,
		221,
		233,
		229,
		249,
		230,
		265,
		-1,
		368,
		-1,
		302,
		-1,
		-1,
		284,
		264,
		256,
		245,
		234,
		232,
		223,
		214,
		236,
		252,
		236,
		234,
		237,
		238,
		-1,
		357,
		356,
		-1,
		303,
		295,
		281,
		-1,
		274,
		-1,
		280,
		241,
		-1,
		243,
		223,
		-1,
		245,
		241,
		-1,
		-1,
		344,
		319,
		-1,
		-1,
		-1,
		304,
		284,
		275,
		259,
		-1,
		234,
		234,
		-1,
		-1,
		-1,
		329,
		328,
		-1,
		297,
		300,
		-1,
		290,
		281,
		289,
		236,
		240,
		-1,
		-1,
		-1,
		338,
		319,
		313,
		312,
		310,
		305,
		302,
		288,
		272,
		250,
		239,
		260,
		-1,
		-1,
		-1,
		310,
		302,
		295,
		-1,
		-1,
		297,
		280,
		261,
		259,
		-1,
		-1,
		-1,
		332,
		313,
		-1,
		-1,
		287,
		-1,
		-1,
		293,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		349,
		321,
		-1,
		-1,
		-1,
		283,
		279,
		280,
		-1,
		-1,
		-1,
		-1,
		343,
		344,
		367,
		331,
		-1,
		-1,
		-1,
		275,
		269,
		-1,
		-1,
		346,
		344,
		-1,
		-1,
		-1,
		303,
		287,
		-1,
		273,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		308,
		-1,
		308,
		283,
		290,
		-1,
		-1,
		-1,
		-1,
		321,
		313,
		321,
		-1,
		293,
		295,
		-1,
		343,
		-1,
		-1,
		336,
		327,
		-1,
		-1,
		298,
		305,
		327,
		330,
		366,
		-1,
		317
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		175,
		177,
		143,
		137,
		176,
		147,
		153,
		164,
		-1,
		-1,
		-1,
		166,
		165,
		135,
		133,
		142,
		147,
		154,
		-1,
		177,
		-1,
		187,
		166,
		177,
		182,
		128,
		125,
		145,
		164,
		170,
		162,
		202,
		158,
		129,
		123,
		141,
		146,
		164,
		156,
		-1,
		129,
		119,
		141,
		145,
		157,
		140,
		-1,
		-1,
		123,
		124,
		130,
		142,
		147,
		152,
		-1,
		178,
		186,
		-1,
		-1,
		113,
		126,
		122,
		125,
		133,
		149,
		170,
		186,
		181,
		-1,
		-1,
		114,
		118,
		131,
		132,
		130,
		157,
		176,
		176,
		190,
		189,
		-1,
		102,
		120,
		129,
		138,
		144,
		133,
		137,
		155,
		175,
		181,
		184,
		-1,
		94,
		96,
		125,
		131,
		143,
		149,
		136,
		142,
		161,
		163,
		182,
		173,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		91,
		99,
		125,
		124,
		120,
		138,
		160,
		139,
		145,
		149,
		155,
		171,
		172,
		182,
		-1,
		-1,
		147,
		116,
		151,
		108,
		93,
		-1,
		87,
		106,
		112,
		116,
		121,
		129,
		157,
		155,
		-1,
		149,
		148,
		179,
		165,
		176,
		107,
		-1,
		-1,
		105,
		97,
		82,
		85,
		82,
		82,
		112,
		111,
		116,
		118,
		120,
		132,
		147,
		147,
		157,
		143,
		153,
		157,
		168,
		183,
		-1,
		-1,
		238,
		-1,
		-1,
		104,
		87,
		-1,
		70,
		77,
		77,
		94,
		84,
		105,
		120,
		124,
		132,
		135,
		123,
		142,
		139,
		158,
		146,
		140,
		165,
		169,
		163,
		184,
		179,
		-1,
		237,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		63,
		66,
		72,
		96,
		106,
		-1,
		127,
		125,
		149,
		143,
		148,
		144,
		129,
		147,
		137,
		144,
		143,
		147,
		149,
		182,
		160,
		182,
		179,
		208,
		213,
		207,
		216,
		-1,
		112,
		108,
		104,
		111,
		60,
		-1,
		-1,
		100,
		-1,
		114,
		127,
		139,
		129,
		132,
		144,
		152,
		146,
		135,
		146,
		135,
		132,
		140,
		149,
		160,
		155,
		154,
		172,
		187,
		200,
		204,
		210,
		-1,
		162,
		-1,
		104,
		88,
		90,
		62,
		83,
		-1,
		120,
		115,
		135,
		141,
		141,
		-1,
		154,
		154,
		164,
		142,
		127,
		144,
		136,
		134,
		139,
		144,
		158,
		149,
		167,
		174,
		182,
		186,
		206,
		218,
		122,
		112,
		-1,
		94,
		99,
		58,
		66,
		85,
		158,
		142,
		-1,
		152,
		-1,
		144,
		169,
		-1,
		148,
		144,
		126,
		127,
		122,
		137,
		143,
		140,
		137,
		155,
		158,
		175,
		179,
		195,
		-1,
		-1,
		107,
		111,
		100,
		51,
		70,
		94,
		131,
		150,
		139,
		138,
		-1,
		129,
		159,
		156,
		142,
		129,
		119,
		120,
		128,
		141,
		120,
		139,
		142,
		164,
		192,
		170,
		182,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		77,
		48,
		72,
		114,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		149,
		132,
		128,
		117,
		115,
		128,
		123,
		139,
		143,
		142,
		161,
		173,
		164,
		184,
		-1,
		-1,
		-1,
		107,
		96,
		97,
		43,
		58,
		96,
		147,
		133,
		138,
		113,
		106,
		100,
		152,
		149,
		116,
		124,
		116,
		105,
		119,
		127,
		131,
		140,
		149,
		155,
		179,
		179,
		185,
		-1,
		-1,
		114,
		104,
		88,
		90,
		87,
		49,
		59,
		91,
		138,
		135,
		-1,
		105,
		-1,
		94,
		102,
		101,
		107,
		119,
		105,
		110,
		121,
		133,
		146,
		142,
		149,
		184,
		184,
		169,
		189,
		192,
		-1,
		-1,
		-1,
		107,
		43,
		18,
		19,
		38,
		69,
		-1,
		105,
		106,
		-1,
		99,
		93,
		99,
		98,
		105,
		102,
		102,
		116,
		124,
		120,
		136,
		142,
		134,
		170,
		-1,
		177,
		171,
		179,
		169,
		157,
		-1,
		-1,
		-1,
		41,
		20,
		0,
		20,
		39,
		91,
		-1,
		-1,
		90,
		83,
		-1,
		86,
		86,
		93,
		102,
		107,
		112,
		120,
		115,
		128,
		133,
		139,
		144,
		162,
		166,
		170,
		159,
		155,
		152,
		166,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		42,
		59,
		-1,
		96,
		88,
		81,
		75,
		81,
		99,
		97,
		117,
		109,
		123,
		123,
		129,
		137,
		122,
		125,
		141,
		139,
		157,
		165,
		157,
		151,
		150,
		162,
		-1,
		147,
		133,
		104,
		-1,
		-1,
		74,
		-1,
		45,
		69,
		85,
		-1,
		115,
		94,
		117,
		95,
		109,
		105,
		143,
		144,
		122,
		127,
		135,
		145,
		147,
		136,
		147,
		139,
		161,
		161,
		145,
		146,
		155,
		-1,
		153,
		140,
		98,
		94,
		83,
		103,
		48,
		63,
		72,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		119,
		117,
		133,
		124,
		130,
		146,
		149,
		151,
		141,
		130,
		136,
		133,
		155,
		141,
		139,
		158,
		174,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		69,
		56,
		50,
		-1,
		89,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		141,
		125,
		130,
		-1,
		176,
		-1,
		149,
		151,
		145,
		130,
		127,
		138,
		136,
		147,
		164,
		-1,
		103,
		88,
		81,
		71,
		85,
		56,
		-1,
		111,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		157,
		137,
		131,
		130,
		171,
		171,
		157,
		143,
		136,
		133,
		130,
		143,
		163,
		154,
		166,
		-1,
		-1,
		-1,
		108,
		94,
		98,
		58,
		77,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		174,
		162,
		152,
		142,
		176,
		177,
		162,
		155,
		141,
		143,
		141,
		139,
		144,
		165,
		166,
		179,
		-1,
		-1,
		91,
		96,
		84,
		70,
		89,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		163,
		-1,
		-1,
		154,
		152,
		162,
		158,
		145,
		165,
		168,
		154,
		138,
		153,
		165,
		173,
		178,
		-1,
		94,
		81,
		-1,
		-1,
		92,
		86,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		144,
		165,
		190,
		157,
		-1,
		162,
		163,
		149,
		163,
		170,
		156,
		151,
		145,
		148,
		166,
		183,
		-1,
		-1,
		106,
		-1,
		101,
		-1,
		-1,
		-1,
		-1,
		123,
		137,
		158,
		164,
		176,
		-1,
		171,
		165,
		151,
		168,
		169,
		166,
		157,
		149,
		154,
		151,
		164,
		178,
		182,
		129,
		-1,
		112,
		-1,
		-1,
		-1,
		141,
		156,
		218,
		195,
		168,
		172,
		165,
		159,
		159,
		175,
		177,
		188,
		156,
		152,
		153,
		157,
		156,
		173,
		183,
		-1,
		-1,
		112,
		129,
		164,
		149,
		153,
		245,
		-1,
		-1,
		181,
		172,
		163,
		166,
		169,
		172,
		162,
		159,
		164,
		169,
		157,
		166,
		184,
		188,
		-1,
		-1,
		-1,
		132,
		-1,
		147,
		-1,
		-1,
		168,
		252,
		199,
		181,
		177,
		175,
		168,
		177,
		172,
		167,
		177,
		186,
		178,
		159,
		170,
		193,
		182,
		220,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		161,
		136,
		151,
		197,
		188,
		193,
		214,
		211,
		-1,
		181,
		206,
		178,
		185,
		177,
		185,
		185,
		182,
		160,
		167,
		183,
		182,
		177,
		212,
		204,
		210,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		167,
		153,
		183,
		173,
		179,
		-1,
		-1,
		226,
		223,
		203,
		187,
		191,
		184,
		179,
		189,
		169,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		139,
		220,
		213,
		196,
		204,
		235,
		-1,
		170,
		179,
		160,
		165,
		173,
		-1,
		-1,
		199,
		195,
		200,
		194,
		191,
		199,
		194,
		185,
		170,
		176,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		153,
		196,
		190,
		193,
		217,
		231,
		-1,
		183,
		-1,
		-1,
		168,
		186,
		194,
		190,
		194,
		247,
		208,
		203,
		193,
		191,
		182,
		173,
		180,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		188,
		176,
		184,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		184,
		-1,
		220,
		-1,
		213,
		217,
		216,
		219,
		207,
		194,
		186,
		178,
		194,
		169,
		179,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		262,
		217,
		184,
		175,
		222,
		237,
		241,
		-1,
		196,
		235,
		222,
		-1,
		193,
		-1,
		-1,
		-1,
		227,
		229,
		221,
		227,
		206,
		206,
		180,
		184,
		174,
		181,
		191,
		193,
		185,
		189,
		202,
		213,
		216,
		258,
		256,
		261,
		206,
		189,
		207,
		216,
		237,
		211,
		202,
		229,
		229,
		218,
		213,
		200,
		-1,
		-1,
		250,
		239,
		-1,
		-1,
		213,
		201,
		184,
		185,
		181,
		184,
		199,
		202,
		192,
		190,
		184,
		216,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		197,
		208,
		-1,
		-1,
		214,
		230,
		243,
		247,
		260,
		285,
		-1,
		203,
		-1,
		-1,
		258,
		-1,
		-1,
		243,
		206,
		195,
		186,
		192,
		189,
		200,
		210,
		198,
		199,
		189,
		199,
		212,
		242,
		239,
		227,
		225,
		248,
		205,
		201,
		-1,
		229,
		217,
		223,
		230,
		247,
		274,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		241,
		239,
		228,
		-1,
		218,
		191,
		196,
		216,
		218,
		207,
		201,
		195,
		202,
		201,
		209,
		217,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		254,
		229,
		-1,
		-1,
		236,
		229,
		217,
		205,
		195,
		205,
		209,
		213,
		205,
		198,
		193,
		204,
		196,
		200,
		217,
		-1,
		285,
		-1,
		237,
		230,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		271,
		257,
		250,
		238,
		236,
		-1,
		270,
		254,
		235,
		-1,
		205,
		218,
		249,
		217,
		222,
		217,
		199,
		210,
		199,
		202,
		216,
		211,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		268,
		287,
		-1,
		262,
		251,
		236,
		228,
		-1,
		-1,
		242,
		238,
		-1,
		-1,
		206,
		231,
		220,
		228,
		223,
		203,
		209,
		212,
		201,
		205,
		217,
		-1,
		-1,
		250,
		251,
		256,
		-1,
		271,
		-1,
		286,
		-1,
		231,
		247,
		249,
		-1,
		-1,
		-1,
		244,
		207,
		228,
		238,
		232,
		230,
		221,
		207,
		214,
		212,
		208,
		219,
		-1,
		-1,
		-1,
		289,
		263,
		293,
		284,
		267,
		247,
		239,
		261,
		-1,
		231,
		-1,
		206,
		208,
		234,
		237,
		243,
		237,
		210,
		225,
		215,
		206,
		215,
		295,
		-1,
		265,
		298,
		262,
		253,
		232,
		236,
		252,
		-1,
		228,
		210,
		-1,
		238,
		228,
		259,
		244,
		225,
		212,
		219,
		219,
		212,
		-1,
		-1,
		-1,
		267,
		266,
		258,
		252,
		252,
		237,
		228,
		-1,
		240,
		222,
		201,
		218,
		218,
		209,
		217,
		249,
		245,
		232,
		232,
		224,
		-1,
		357,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		261,
		256,
		229,
		217,
		223,
		219,
		205,
		211,
		213,
		221,
		219,
		216,
		228,
		224,
		244,
		225,
		260,
		-1,
		363,
		-1,
		297,
		-1,
		-1,
		279,
		259,
		251,
		240,
		229,
		227,
		218,
		209,
		231,
		247,
		231,
		229,
		232,
		233,
		-1,
		352,
		351,
		-1,
		298,
		290,
		276,
		-1,
		269,
		-1,
		275,
		236,
		-1,
		238,
		218,
		-1,
		240,
		236,
		-1,
		-1,
		339,
		314,
		-1,
		-1,
		-1,
		299,
		279,
		270,
		254,
		-1,
		229,
		229,
		-1,
		-1,
		-1,
		324,
		323,
		-1,
		292,
		295,
		-1,
		285,
		276,
		284,
		231,
		235,
		-1,
		-1,
		-1,
		333,
		314,
		308,
		307,
		305,
		300,
		297,
		283,
		267,
		245,
		234,
		255,
		-1,
		-1,
		-1,
		305,
		297,
		290,
		-1,
		-1,
		292,
		275,
		256,
		254,
		-1,
		-1,
		-1,
		327,
		308,
		-1,
		-1,
		282,
		-1,
		-1,
		288,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		344,
		316,
		-1,
		-1,
		-1,
		278,
		274,
		275,
		-1,
		-1,
		-1,
		-1,
		338,
		339,
		362,
		326,
		-1,
		-1,
		-1,
		270,
		264,
		-1,
		-1,
		341,
		339,
		-1,
		-1,
		-1,
		298,
		282,
		-1,
		268,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		303,
		-1,
		303,
		278,
		285,
		-1,
		-1,
		-1,
		-1,
		316,
		308,
		316,
		-1,
		288,
		290,
		-1,
		338,
		-1,
		-1,
		331,
		322,
		-1,
		-1,
		293,
		300,
		322,
		325,
		361,
		-1,
		312
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		192,
		194,
		160,
		154,
		193,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		183,
		182,
		152,
		150,
		159,
		164,
		171,
		-1,
		194,
		-1,
		204,
		183,
		194,
		199,
		145,
		142,
		162,
		181,
		187,
		179,
		219,
		175,
		146,
		140,
		158,
		163,
		181,
		173,
		-1,
		146,
		136,
		158,
		162,
		174,
		157,
		-1,
		-1,
		140,
		141,
		147,
		159,
		164,
		169,
		-1,
		195,
		203,
		-1,
		-1,
		130,
		143,
		139,
		142,
		150,
		166,
		187,
		203,
		198,
		-1,
		-1,
		131,
		135,
		148,
		149,
		147,
		174,
		193,
		193,
		207,
		206,
		-1,
		119,
		137,
		146,
		155,
		161,
		150,
		154,
		172,
		192,
		198,
		201,
		-1,
		111,
		113,
		142,
		148,
		160,
		166,
		153,
		159,
		178,
		180,
		199,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		116,
		142,
		141,
		137,
		155,
		177,
		156,
		162,
		166,
		172,
		188,
		189,
		199,
		-1,
		-1,
		164,
		133,
		168,
		125,
		110,
		-1,
		104,
		123,
		129,
		133,
		138,
		146,
		174,
		172,
		-1,
		166,
		165,
		196,
		182,
		193,
		124,
		-1,
		-1,
		122,
		114,
		99,
		102,
		99,
		99,
		129,
		128,
		133,
		135,
		137,
		149,
		164,
		164,
		174,
		160,
		170,
		174,
		185,
		200,
		-1,
		-1,
		255,
		-1,
		-1,
		121,
		104,
		-1,
		87,
		94,
		94,
		111,
		101,
		122,
		137,
		141,
		149,
		152,
		140,
		159,
		156,
		175,
		163,
		157,
		182,
		186,
		180,
		201,
		196,
		-1,
		254,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		80,
		83,
		89,
		113,
		123,
		-1,
		144,
		142,
		166,
		160,
		165,
		161,
		146,
		164,
		154,
		161,
		160,
		164,
		166,
		199,
		177,
		199,
		196,
		225,
		230,
		224,
		233,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		117,
		-1,
		131,
		144,
		156,
		146,
		149,
		161,
		169,
		163,
		152,
		163,
		152,
		149,
		157,
		166,
		177,
		172,
		171,
		189,
		204,
		217,
		221,
		227,
		-1,
		179,
		-1,
		121,
		105,
		107,
		79,
		100,
		-1,
		137,
		132,
		152,
		158,
		158,
		-1,
		171,
		171,
		181,
		159,
		144,
		161,
		153,
		151,
		156,
		161,
		175,
		166,
		184,
		191,
		199,
		203,
		223,
		235,
		139,
		129,
		-1,
		111,
		116,
		75,
		83,
		102,
		175,
		159,
		-1,
		169,
		-1,
		161,
		186,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		160,
		157,
		154,
		172,
		175,
		192,
		196,
		212,
		-1,
		-1,
		124,
		128,
		117,
		68,
		87,
		111,
		148,
		167,
		156,
		155,
		-1,
		146,
		176,
		173,
		159,
		146,
		136,
		137,
		145,
		158,
		137,
		156,
		159,
		181,
		209,
		187,
		199,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		94,
		65,
		89,
		131,
		185,
		178,
		166,
		131,
		131,
		125,
		-1,
		166,
		149,
		145,
		134,
		132,
		145,
		140,
		156,
		160,
		159,
		178,
		190,
		181,
		201,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		60,
		75,
		113,
		164,
		150,
		155,
		130,
		123,
		117,
		169,
		166,
		133,
		141,
		133,
		122,
		136,
		144,
		148,
		157,
		166,
		172,
		196,
		196,
		202,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		66,
		76,
		108,
		155,
		152,
		-1,
		122,
		-1,
		111,
		119,
		118,
		124,
		136,
		122,
		127,
		138,
		150,
		163,
		159,
		166,
		201,
		201,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		124,
		60,
		35,
		36,
		55,
		86,
		-1,
		122,
		123,
		-1,
		116,
		110,
		116,
		115,
		122,
		119,
		119,
		133,
		141,
		137,
		153,
		159,
		151,
		187,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		58,
		37,
		17,
		0,
		56,
		108,
		-1,
		-1,
		107,
		100,
		-1,
		103,
		103,
		110,
		119,
		124,
		129,
		137,
		132,
		145,
		150,
		156,
		161,
		179,
		183,
		187,
		176,
		172,
		169,
		183,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		76,
		-1,
		113,
		105,
		98,
		92,
		98,
		116,
		114,
		134,
		126,
		140,
		140,
		146,
		154,
		139,
		142,
		158,
		156,
		174,
		182,
		174,
		168,
		167,
		179,
		-1,
		164,
		150,
		121,
		-1,
		-1,
		91,
		-1,
		62,
		86,
		102,
		-1,
		132,
		111,
		134,
		112,
		126,
		122,
		160,
		161,
		139,
		144,
		152,
		162,
		164,
		153,
		164,
		156,
		178,
		178,
		162,
		163,
		172,
		-1,
		170,
		157,
		115,
		111,
		100,
		120,
		65,
		80,
		89,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		136,
		134,
		150,
		141,
		147,
		163,
		166,
		168,
		158,
		147,
		153,
		150,
		172,
		158,
		156,
		175,
		191,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		86,
		73,
		67,
		-1,
		106,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		158,
		142,
		147,
		-1,
		193,
		-1,
		166,
		168,
		162,
		147,
		144,
		155,
		153,
		164,
		181,
		-1,
		120,
		105,
		98,
		88,
		102,
		73,
		-1,
		128,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		174,
		154,
		148,
		147,
		188,
		188,
		174,
		160,
		153,
		150,
		147,
		160,
		180,
		171,
		183,
		-1,
		-1,
		-1,
		125,
		111,
		115,
		75,
		94,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		191,
		179,
		169,
		159,
		193,
		194,
		179,
		172,
		158,
		160,
		158,
		156,
		161,
		182,
		183,
		196,
		-1,
		-1,
		108,
		113,
		101,
		87,
		106,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		180,
		-1,
		-1,
		171,
		169,
		179,
		175,
		162,
		182,
		185,
		171,
		155,
		170,
		182,
		190,
		195,
		-1,
		111,
		98,
		-1,
		-1,
		109,
		103,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		161,
		182,
		207,
		174,
		-1,
		179,
		180,
		166,
		180,
		187,
		173,
		168,
		162,
		165,
		183,
		200,
		-1,
		-1,
		123,
		-1,
		118,
		-1,
		-1,
		-1,
		-1,
		140,
		154,
		175,
		181,
		193,
		-1,
		188,
		182,
		168,
		185,
		186,
		183,
		174,
		166,
		171,
		168,
		181,
		195,
		199,
		146,
		-1,
		129,
		-1,
		-1,
		-1,
		158,
		173,
		235,
		212,
		185,
		189,
		182,
		176,
		176,
		192,
		194,
		205,
		173,
		169,
		170,
		174,
		173,
		190,
		200,
		-1,
		-1,
		129,
		146,
		181,
		166,
		170,
		262,
		-1,
		-1,
		198,
		189,
		180,
		183,
		186,
		189,
		179,
		176,
		181,
		186,
		174,
		183,
		201,
		205,
		-1,
		-1,
		-1,
		149,
		-1,
		164,
		-1,
		-1,
		185,
		269,
		216,
		198,
		194,
		192,
		185,
		194,
		189,
		184,
		194,
		203,
		195,
		176,
		187,
		210,
		199,
		237,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		178,
		153,
		168,
		214,
		205,
		210,
		231,
		228,
		-1,
		198,
		223,
		195,
		202,
		194,
		202,
		202,
		199,
		177,
		184,
		200,
		199,
		194,
		229,
		221,
		227,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		184,
		170,
		200,
		190,
		196,
		-1,
		-1,
		243,
		240,
		220,
		204,
		208,
		201,
		196,
		206,
		186,
		173,
		177,
		181,
		187,
		192,
		197,
		203,
		218,
		233,
		-1,
		156,
		237,
		230,
		213,
		221,
		252,
		-1,
		187,
		196,
		177,
		182,
		190,
		-1,
		-1,
		216,
		212,
		217,
		211,
		208,
		216,
		211,
		202,
		187,
		193,
		180,
		179,
		197,
		201,
		210,
		217,
		207,
		220,
		224,
		-1,
		170,
		213,
		207,
		210,
		234,
		248,
		-1,
		200,
		-1,
		-1,
		185,
		203,
		211,
		207,
		211,
		264,
		225,
		220,
		210,
		208,
		199,
		190,
		197,
		188,
		188,
		191,
		206,
		211,
		203,
		217,
		217,
		218,
		-1,
		205,
		193,
		201,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		201,
		-1,
		237,
		-1,
		230,
		234,
		233,
		236,
		224,
		211,
		203,
		195,
		211,
		186,
		196,
		192,
		193,
		202,
		213,
		225,
		224,
		225,
		279,
		234,
		201,
		192,
		239,
		254,
		258,
		-1,
		213,
		252,
		239,
		-1,
		210,
		-1,
		-1,
		-1,
		244,
		246,
		238,
		244,
		223,
		223,
		197,
		201,
		191,
		198,
		208,
		210,
		202,
		206,
		219,
		230,
		233,
		275,
		273,
		278,
		223,
		206,
		224,
		233,
		254,
		228,
		219,
		246,
		246,
		235,
		230,
		217,
		-1,
		-1,
		267,
		256,
		-1,
		-1,
		230,
		218,
		201,
		202,
		198,
		201,
		216,
		219,
		209,
		207,
		201,
		233,
		-1,
		275,
		274,
		263,
		260,
		236,
		227,
		214,
		225,
		-1,
		-1,
		231,
		247,
		260,
		264,
		277,
		302,
		-1,
		220,
		-1,
		-1,
		275,
		-1,
		-1,
		260,
		223,
		212,
		203,
		209,
		206,
		217,
		227,
		215,
		216,
		206,
		216,
		229,
		259,
		256,
		244,
		242,
		265,
		222,
		218,
		-1,
		246,
		234,
		240,
		247,
		264,
		291,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		258,
		256,
		245,
		-1,
		235,
		208,
		213,
		233,
		235,
		224,
		218,
		212,
		219,
		218,
		226,
		234,
		268,
		282,
		271,
		267,
		266,
		274,
		223,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		-1,
		271,
		246,
		-1,
		-1,
		253,
		246,
		234,
		222,
		212,
		222,
		226,
		230,
		222,
		215,
		210,
		221,
		213,
		217,
		234,
		-1,
		302,
		-1,
		254,
		247,
		262,
		277,
		285,
		-1,
		-1,
		-1,
		288,
		274,
		267,
		255,
		253,
		-1,
		287,
		271,
		252,
		-1,
		222,
		235,
		266,
		234,
		239,
		234,
		216,
		227,
		216,
		219,
		233,
		228,
		-1,
		-1,
		260,
		263,
		-1,
		-1,
		285,
		304,
		-1,
		279,
		268,
		253,
		245,
		-1,
		-1,
		259,
		255,
		-1,
		-1,
		223,
		248,
		237,
		245,
		240,
		220,
		226,
		229,
		218,
		222,
		234,
		-1,
		-1,
		267,
		268,
		273,
		-1,
		288,
		-1,
		303,
		-1,
		248,
		264,
		266,
		-1,
		-1,
		-1,
		261,
		224,
		245,
		255,
		249,
		247,
		238,
		224,
		231,
		229,
		225,
		236,
		-1,
		-1,
		-1,
		306,
		280,
		310,
		301,
		284,
		264,
		256,
		278,
		-1,
		248,
		-1,
		223,
		225,
		251,
		254,
		260,
		254,
		227,
		242,
		232,
		223,
		232,
		312,
		-1,
		282,
		315,
		279,
		270,
		249,
		253,
		269,
		-1,
		245,
		227,
		-1,
		255,
		245,
		276,
		261,
		242,
		229,
		236,
		236,
		229,
		-1,
		-1,
		-1,
		284,
		283,
		275,
		269,
		269,
		254,
		245,
		-1,
		257,
		239,
		218,
		235,
		235,
		226,
		234,
		266,
		262,
		249,
		249,
		241,
		-1,
		374,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		278,
		273,
		246,
		234,
		240,
		236,
		222,
		228,
		230,
		238,
		236,
		233,
		245,
		241,
		261,
		242,
		277,
		-1,
		380,
		-1,
		314,
		-1,
		-1,
		296,
		276,
		268,
		257,
		246,
		244,
		235,
		226,
		248,
		264,
		248,
		246,
		249,
		250,
		-1,
		369,
		368,
		-1,
		315,
		307,
		293,
		-1,
		286,
		-1,
		292,
		253,
		-1,
		255,
		235,
		-1,
		257,
		253,
		-1,
		-1,
		356,
		331,
		-1,
		-1,
		-1,
		316,
		296,
		287,
		271,
		-1,
		246,
		246,
		-1,
		-1,
		-1,
		341,
		340,
		-1,
		309,
		312,
		-1,
		302,
		293,
		301,
		248,
		252,
		-1,
		-1,
		-1,
		350,
		331,
		325,
		324,
		322,
		317,
		314,
		300,
		284,
		262,
		251,
		272,
		-1,
		-1,
		-1,
		322,
		314,
		307,
		-1,
		-1,
		309,
		292,
		273,
		271,
		-1,
		-1,
		-1,
		344,
		325,
		-1,
		-1,
		299,
		-1,
		-1,
		305,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		361,
		333,
		-1,
		-1,
		-1,
		295,
		291,
		292,
		-1,
		-1,
		-1,
		-1,
		355,
		356,
		379,
		343,
		-1,
		-1,
		-1,
		287,
		281,
		-1,
		-1,
		358,
		356,
		-1,
		-1,
		-1,
		315,
		299,
		-1,
		285,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		318,
		-1,
		-1,
		-1,
		320,
		-1,
		320,
		295,
		302,
		-1,
		-1,
		-1,
		-1,
		333,
		325,
		333,
		-1,
		305,
		307,
		-1,
		355,
		-1,
		-1,
		348,
		339,
		-1,
		-1,
		310,
		317,
		339,
		342,
		378,
		-1,
		329
	],
	[
		-1,
		135,
		124,
		135,
		143,
		116,
		123,
		-1,
		144,
		146,
		112,
		106,
		145,
		116,
		122,
		133,
		-1,
		-1,
		-1,
		135,
		134,
		104,
		102,
		111,
		116,
		123,
		-1,
		146,
		-1,
		156,
		135,
		146,
		151,
		97,
		94,
		114,
		133,
		139,
		131,
		171,
		127,
		98,
		92,
		110,
		115,
		133,
		125,
		-1,
		98,
		88,
		110,
		114,
		126,
		109,
		-1,
		-1,
		92,
		93,
		99,
		111,
		116,
		121,
		-1,
		147,
		147,
		-1,
		-1,
		82,
		95,
		91,
		94,
		102,
		118,
		139,
		147,
		142,
		-1,
		-1,
		83,
		87,
		100,
		101,
		99,
		126,
		145,
		137,
		151,
		150,
		-1,
		71,
		89,
		98,
		107,
		113,
		102,
		106,
		124,
		136,
		142,
		145,
		-1,
		63,
		65,
		94,
		100,
		112,
		118,
		105,
		111,
		130,
		124,
		143,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		60,
		68,
		94,
		93,
		89,
		107,
		129,
		108,
		114,
		118,
		116,
		132,
		133,
		143,
		-1,
		-1,
		116,
		85,
		120,
		77,
		62,
		-1,
		56,
		75,
		81,
		85,
		90,
		98,
		126,
		124,
		-1,
		110,
		109,
		140,
		126,
		137,
		76,
		-1,
		-1,
		74,
		66,
		51,
		54,
		51,
		51,
		81,
		80,
		85,
		87,
		89,
		101,
		114,
		114,
		120,
		104,
		114,
		118,
		129,
		144,
		-1,
		-1,
		199,
		-1,
		-1,
		73,
		56,
		-1,
		39,
		46,
		46,
		63,
		53,
		74,
		89,
		93,
		101,
		104,
		92,
		109,
		106,
		119,
		107,
		101,
		126,
		130,
		124,
		145,
		140,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		51,
		32,
		35,
		41,
		65,
		75,
		-1,
		96,
		94,
		118,
		112,
		117,
		112,
		98,
		113,
		98,
		105,
		104,
		108,
		110,
		143,
		121,
		143,
		140,
		169,
		174,
		168,
		177,
		-1,
		81,
		77,
		73,
		80,
		29,
		-1,
		-1,
		69,
		-1,
		83,
		96,
		108,
		98,
		101,
		113,
		120,
		107,
		96,
		107,
		96,
		93,
		101,
		110,
		121,
		116,
		115,
		133,
		148,
		161,
		165,
		171,
		-1,
		131,
		-1,
		73,
		57,
		59,
		31,
		52,
		-1,
		89,
		84,
		104,
		110,
		110,
		-1,
		115,
		118,
		125,
		103,
		88,
		105,
		97,
		95,
		100,
		105,
		119,
		110,
		128,
		135,
		143,
		147,
		167,
		179,
		91,
		81,
		-1,
		63,
		68,
		27,
		35,
		54,
		127,
		111,
		-1,
		113,
		-1,
		105,
		130,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		104,
		101,
		98,
		116,
		119,
		136,
		140,
		156,
		-1,
		-1,
		76,
		80,
		69,
		20,
		39,
		63,
		100,
		111,
		100,
		99,
		-1,
		90,
		120,
		117,
		103,
		90,
		80,
		81,
		89,
		102,
		81,
		100,
		103,
		125,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		101,
		-1,
		-1,
		46,
		17,
		41,
		83,
		129,
		122,
		110,
		75,
		75,
		69,
		-1,
		110,
		93,
		89,
		78,
		76,
		89,
		84,
		100,
		104,
		103,
		122,
		134,
		125,
		145,
		-1,
		-1,
		-1,
		76,
		65,
		66,
		12,
		35,
		72,
		108,
		94,
		99,
		74,
		67,
		61,
		113,
		110,
		77,
		85,
		77,
		66,
		80,
		88,
		92,
		101,
		110,
		116,
		140,
		140,
		146,
		-1,
		-1,
		83,
		73,
		57,
		59,
		56,
		26,
		33,
		65,
		99,
		96,
		-1,
		66,
		-1,
		55,
		63,
		62,
		68,
		80,
		66,
		71,
		82,
		94,
		107,
		103,
		110,
		145,
		145,
		130,
		150,
		153,
		-1,
		-1,
		-1,
		76,
		69,
		44,
		21,
		7,
		43,
		-1,
		66,
		67,
		-1,
		60,
		54,
		60,
		59,
		66,
		63,
		63,
		77,
		85,
		81,
		97,
		103,
		95,
		131,
		-1,
		138,
		132,
		140,
		130,
		118,
		-1,
		-1,
		-1,
		67,
		46,
		39,
		59,
		0,
		52,
		-1,
		-1,
		51,
		44,
		-1,
		47,
		47,
		54,
		63,
		68,
		73,
		81,
		76,
		89,
		94,
		100,
		105,
		123,
		127,
		131,
		120,
		116,
		113,
		127,
		-1,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		3,
		20,
		-1,
		57,
		49,
		42,
		36,
		42,
		60,
		58,
		78,
		70,
		84,
		84,
		90,
		98,
		83,
		86,
		102,
		100,
		118,
		126,
		118,
		112,
		111,
		123,
		-1,
		108,
		94,
		65,
		-1,
		-1,
		35,
		-1,
		6,
		30,
		46,
		-1,
		76,
		55,
		78,
		56,
		70,
		66,
		104,
		105,
		83,
		88,
		96,
		106,
		108,
		97,
		108,
		100,
		122,
		122,
		106,
		107,
		116,
		-1,
		114,
		101,
		59,
		55,
		44,
		64,
		9,
		24,
		33,
		-1,
		-1,
		120,
		-1,
		54,
		71,
		80,
		78,
		94,
		85,
		91,
		107,
		110,
		112,
		102,
		91,
		97,
		94,
		116,
		102,
		100,
		119,
		135,
		-1,
		-1,
		-1,
		81,
		-1,
		-1,
		30,
		17,
		11,
		-1,
		50,
		-1,
		98,
		88,
		72,
		57,
		90,
		-1,
		102,
		86,
		91,
		-1,
		137,
		-1,
		110,
		112,
		106,
		91,
		88,
		99,
		97,
		108,
		125,
		-1,
		64,
		49,
		42,
		32,
		46,
		17,
		-1,
		72,
		-1,
		-1,
		85,
		79,
		79,
		63,
		66,
		118,
		98,
		92,
		91,
		132,
		132,
		118,
		104,
		97,
		94,
		91,
		104,
		124,
		115,
		127,
		-1,
		-1,
		-1,
		69,
		55,
		59,
		19,
		38,
		-1,
		-1,
		147,
		102,
		88,
		-1,
		72,
		135,
		123,
		113,
		103,
		137,
		138,
		123,
		116,
		102,
		104,
		102,
		100,
		105,
		126,
		127,
		140,
		-1,
		-1,
		52,
		57,
		45,
		31,
		50,
		-1,
		-1,
		-1,
		94,
		110,
		102,
		73,
		124,
		-1,
		-1,
		115,
		113,
		123,
		119,
		106,
		126,
		129,
		115,
		99,
		114,
		126,
		134,
		139,
		-1,
		55,
		42,
		-1,
		-1,
		53,
		47,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		105,
		126,
		151,
		118,
		-1,
		123,
		124,
		110,
		124,
		131,
		117,
		112,
		106,
		109,
		127,
		144,
		-1,
		-1,
		67,
		-1,
		62,
		-1,
		-1,
		-1,
		-1,
		84,
		98,
		119,
		125,
		137,
		-1,
		132,
		126,
		112,
		129,
		130,
		127,
		118,
		110,
		115,
		112,
		125,
		139,
		143,
		90,
		-1,
		73,
		-1,
		-1,
		-1,
		102,
		117,
		179,
		156,
		129,
		133,
		126,
		120,
		120,
		136,
		138,
		149,
		117,
		113,
		114,
		118,
		117,
		134,
		144,
		-1,
		-1,
		73,
		90,
		125,
		110,
		114,
		206,
		-1,
		-1,
		142,
		133,
		124,
		127,
		130,
		133,
		123,
		120,
		125,
		130,
		118,
		127,
		145,
		149,
		-1,
		-1,
		-1,
		93,
		-1,
		108,
		-1,
		-1,
		129,
		213,
		160,
		142,
		138,
		136,
		129,
		138,
		133,
		128,
		138,
		147,
		139,
		120,
		131,
		154,
		143,
		181,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		122,
		97,
		112,
		158,
		149,
		154,
		175,
		172,
		-1,
		142,
		167,
		139,
		146,
		138,
		146,
		146,
		143,
		121,
		128,
		144,
		143,
		138,
		173,
		165,
		171,
		-1,
		-1,
		205,
		194,
		183,
		189,
		-1,
		128,
		114,
		144,
		134,
		140,
		-1,
		-1,
		187,
		184,
		164,
		148,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		100,
		181,
		174,
		157,
		165,
		196,
		-1,
		131,
		140,
		121,
		126,
		134,
		-1,
		-1,
		160,
		156,
		161,
		155,
		152,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		114,
		157,
		151,
		154,
		178,
		192,
		-1,
		144,
		-1,
		-1,
		129,
		147,
		155,
		151,
		155,
		208,
		169,
		164,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		149,
		137,
		145,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		145,
		-1,
		181,
		-1,
		174,
		178,
		177,
		180,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		223,
		178,
		145,
		136,
		183,
		198,
		202,
		-1,
		157,
		196,
		183,
		-1,
		154,
		-1,
		-1,
		-1,
		188,
		190,
		182,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		219,
		217,
		222,
		167,
		150,
		168,
		177,
		198,
		172,
		163,
		190,
		190,
		179,
		174,
		161,
		-1,
		-1,
		211,
		200,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		158,
		169,
		-1,
		-1,
		175,
		191,
		204,
		208,
		221,
		246,
		-1,
		164,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		203,
		200,
		188,
		186,
		209,
		166,
		162,
		-1,
		190,
		178,
		184,
		191,
		208,
		235,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		215,
		190,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		246,
		-1,
		198,
		191,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		232,
		218,
		211,
		199,
		197,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		229,
		248,
		-1,
		223,
		212,
		197,
		189,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		211,
		212,
		217,
		-1,
		232,
		-1,
		247,
		-1,
		192,
		208,
		210,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		254,
		245,
		228,
		208,
		200,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		214,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		318,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		179,
		181,
		147,
		141,
		180,
		151,
		157,
		168,
		-1,
		-1,
		-1,
		170,
		169,
		139,
		137,
		146,
		151,
		158,
		-1,
		181,
		-1,
		191,
		170,
		181,
		186,
		132,
		129,
		149,
		168,
		174,
		166,
		206,
		162,
		133,
		127,
		145,
		150,
		168,
		160,
		-1,
		133,
		123,
		145,
		149,
		161,
		144,
		-1,
		-1,
		127,
		128,
		134,
		146,
		151,
		156,
		-1,
		182,
		182,
		-1,
		-1,
		117,
		130,
		126,
		129,
		137,
		153,
		174,
		182,
		177,
		-1,
		-1,
		118,
		122,
		135,
		136,
		134,
		161,
		180,
		172,
		186,
		185,
		-1,
		106,
		124,
		133,
		142,
		148,
		137,
		141,
		159,
		171,
		177,
		180,
		-1,
		98,
		100,
		129,
		135,
		147,
		153,
		140,
		146,
		165,
		159,
		178,
		169,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		95,
		103,
		129,
		128,
		124,
		142,
		164,
		143,
		149,
		153,
		151,
		167,
		168,
		178,
		-1,
		-1,
		151,
		120,
		155,
		112,
		97,
		-1,
		91,
		110,
		116,
		120,
		125,
		133,
		161,
		159,
		-1,
		145,
		144,
		175,
		161,
		172,
		111,
		-1,
		-1,
		109,
		101,
		86,
		89,
		86,
		86,
		116,
		115,
		120,
		122,
		124,
		136,
		149,
		149,
		155,
		139,
		149,
		153,
		164,
		179,
		-1,
		-1,
		234,
		-1,
		-1,
		108,
		91,
		-1,
		74,
		81,
		81,
		98,
		88,
		109,
		124,
		128,
		136,
		139,
		127,
		144,
		141,
		154,
		142,
		136,
		161,
		165,
		159,
		180,
		175,
		-1,
		233,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		67,
		70,
		76,
		100,
		110,
		-1,
		131,
		129,
		153,
		147,
		152,
		147,
		133,
		148,
		133,
		140,
		139,
		143,
		145,
		178,
		156,
		178,
		175,
		204,
		209,
		203,
		212,
		-1,
		116,
		112,
		108,
		115,
		64,
		-1,
		-1,
		104,
		-1,
		118,
		131,
		143,
		133,
		136,
		148,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		145,
		156,
		151,
		150,
		168,
		183,
		196,
		200,
		206,
		-1,
		166,
		-1,
		108,
		92,
		94,
		66,
		87,
		-1,
		124,
		119,
		139,
		145,
		145,
		-1,
		150,
		153,
		160,
		138,
		123,
		140,
		132,
		130,
		135,
		140,
		154,
		145,
		163,
		170,
		178,
		182,
		202,
		214,
		126,
		116,
		-1,
		98,
		103,
		62,
		70,
		89,
		162,
		146,
		-1,
		148,
		-1,
		140,
		165,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		139,
		136,
		133,
		151,
		154,
		171,
		175,
		191,
		-1,
		-1,
		111,
		115,
		104,
		55,
		74,
		98,
		135,
		146,
		135,
		134,
		-1,
		125,
		155,
		152,
		138,
		125,
		115,
		116,
		124,
		137,
		116,
		135,
		138,
		160,
		188,
		166,
		178,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		81,
		52,
		76,
		118,
		164,
		157,
		145,
		110,
		110,
		104,
		-1,
		145,
		128,
		124,
		113,
		111,
		124,
		119,
		135,
		139,
		138,
		157,
		169,
		160,
		180,
		-1,
		-1,
		-1,
		111,
		100,
		101,
		47,
		70,
		107,
		143,
		129,
		134,
		109,
		102,
		96,
		148,
		145,
		112,
		120,
		112,
		101,
		115,
		123,
		127,
		136,
		145,
		151,
		175,
		175,
		181,
		-1,
		-1,
		118,
		108,
		92,
		94,
		91,
		61,
		68,
		100,
		134,
		131,
		-1,
		101,
		-1,
		90,
		98,
		97,
		103,
		115,
		101,
		106,
		117,
		129,
		142,
		138,
		145,
		180,
		180,
		165,
		185,
		188,
		-1,
		-1,
		-1,
		111,
		104,
		79,
		56,
		42,
		78,
		-1,
		101,
		102,
		-1,
		95,
		89,
		95,
		94,
		101,
		98,
		98,
		112,
		120,
		116,
		132,
		138,
		130,
		166,
		-1,
		173,
		167,
		175,
		165,
		153,
		-1,
		-1,
		-1,
		102,
		81,
		74,
		94,
		35,
		0,
		-1,
		-1,
		86,
		79,
		-1,
		82,
		82,
		89,
		98,
		103,
		108,
		116,
		111,
		124,
		129,
		135,
		140,
		158,
		162,
		166,
		155,
		151,
		148,
		162,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		38,
		35,
		-1,
		92,
		84,
		77,
		71,
		77,
		95,
		93,
		113,
		105,
		119,
		119,
		125,
		133,
		118,
		121,
		137,
		135,
		153,
		161,
		153,
		147,
		146,
		158,
		-1,
		143,
		129,
		100,
		-1,
		-1,
		68,
		-1,
		41,
		65,
		81,
		-1,
		111,
		90,
		113,
		91,
		105,
		101,
		139,
		140,
		118,
		123,
		131,
		141,
		143,
		132,
		143,
		135,
		157,
		157,
		141,
		142,
		151,
		-1,
		149,
		136,
		94,
		90,
		79,
		99,
		44,
		59,
		68,
		-1,
		-1,
		155,
		-1,
		89,
		106,
		115,
		113,
		129,
		120,
		126,
		142,
		145,
		147,
		137,
		126,
		132,
		129,
		151,
		137,
		135,
		154,
		170,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		65,
		52,
		46,
		-1,
		85,
		-1,
		133,
		123,
		107,
		92,
		125,
		-1,
		137,
		121,
		126,
		-1,
		172,
		-1,
		145,
		147,
		141,
		126,
		123,
		134,
		132,
		143,
		160,
		-1,
		99,
		84,
		77,
		67,
		81,
		52,
		-1,
		107,
		-1,
		-1,
		120,
		114,
		114,
		98,
		101,
		153,
		133,
		127,
		126,
		167,
		167,
		153,
		139,
		132,
		129,
		126,
		139,
		159,
		150,
		162,
		-1,
		-1,
		-1,
		104,
		90,
		94,
		54,
		73,
		-1,
		-1,
		182,
		137,
		123,
		-1,
		107,
		170,
		158,
		148,
		138,
		172,
		173,
		158,
		151,
		137,
		139,
		137,
		135,
		140,
		161,
		162,
		175,
		-1,
		-1,
		87,
		92,
		80,
		66,
		85,
		-1,
		-1,
		-1,
		129,
		145,
		137,
		108,
		159,
		-1,
		-1,
		150,
		148,
		158,
		154,
		141,
		161,
		164,
		150,
		134,
		149,
		161,
		169,
		174,
		-1,
		90,
		77,
		-1,
		-1,
		88,
		82,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		140,
		161,
		186,
		153,
		-1,
		158,
		159,
		145,
		159,
		166,
		152,
		147,
		141,
		144,
		162,
		179,
		-1,
		-1,
		102,
		-1,
		97,
		-1,
		-1,
		-1,
		-1,
		119,
		133,
		154,
		160,
		172,
		-1,
		167,
		161,
		147,
		164,
		165,
		162,
		153,
		145,
		150,
		147,
		160,
		174,
		178,
		125,
		-1,
		108,
		-1,
		-1,
		-1,
		137,
		152,
		214,
		191,
		164,
		168,
		161,
		155,
		155,
		171,
		173,
		184,
		152,
		148,
		149,
		153,
		152,
		169,
		179,
		-1,
		-1,
		108,
		125,
		160,
		145,
		149,
		241,
		-1,
		-1,
		177,
		168,
		159,
		162,
		165,
		168,
		158,
		155,
		160,
		165,
		153,
		162,
		180,
		184,
		-1,
		-1,
		-1,
		128,
		-1,
		143,
		-1,
		-1,
		164,
		248,
		195,
		177,
		173,
		171,
		164,
		173,
		168,
		163,
		173,
		182,
		174,
		155,
		166,
		189,
		178,
		216,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		157,
		132,
		147,
		193,
		184,
		189,
		210,
		207,
		-1,
		177,
		202,
		174,
		181,
		173,
		181,
		181,
		178,
		156,
		163,
		179,
		178,
		173,
		208,
		200,
		206,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		163,
		149,
		179,
		169,
		175,
		-1,
		-1,
		222,
		219,
		199,
		183,
		187,
		180,
		175,
		185,
		165,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		135,
		216,
		209,
		192,
		200,
		231,
		-1,
		166,
		175,
		156,
		161,
		169,
		-1,
		-1,
		195,
		191,
		196,
		190,
		187,
		195,
		190,
		181,
		166,
		172,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		149,
		192,
		186,
		189,
		213,
		227,
		-1,
		179,
		-1,
		-1,
		164,
		182,
		190,
		186,
		190,
		243,
		204,
		199,
		189,
		187,
		178,
		169,
		176,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		184,
		172,
		180,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		180,
		-1,
		216,
		-1,
		209,
		213,
		212,
		215,
		203,
		190,
		182,
		174,
		190,
		165,
		175,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		258,
		213,
		180,
		171,
		218,
		233,
		237,
		-1,
		192,
		231,
		218,
		-1,
		189,
		-1,
		-1,
		-1,
		223,
		225,
		217,
		223,
		202,
		202,
		176,
		180,
		170,
		177,
		187,
		189,
		181,
		185,
		198,
		209,
		212,
		254,
		252,
		257,
		202,
		185,
		203,
		212,
		233,
		207,
		198,
		225,
		225,
		214,
		209,
		196,
		-1,
		-1,
		246,
		235,
		-1,
		-1,
		209,
		197,
		180,
		181,
		177,
		180,
		195,
		198,
		188,
		186,
		180,
		212,
		-1,
		254,
		253,
		242,
		239,
		215,
		206,
		193,
		204,
		-1,
		-1,
		210,
		226,
		239,
		243,
		256,
		281,
		-1,
		199,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		202,
		191,
		182,
		188,
		185,
		196,
		206,
		194,
		195,
		185,
		195,
		208,
		238,
		235,
		223,
		221,
		244,
		201,
		197,
		-1,
		225,
		213,
		219,
		226,
		243,
		270,
		-1,
		-1,
		215,
		206,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		187,
		192,
		212,
		214,
		203,
		197,
		191,
		198,
		197,
		205,
		213,
		247,
		261,
		250,
		246,
		245,
		253,
		202,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		250,
		225,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		205,
		209,
		201,
		194,
		189,
		200,
		192,
		196,
		213,
		-1,
		281,
		-1,
		233,
		226,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		267,
		253,
		246,
		234,
		232,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		245,
		213,
		218,
		213,
		195,
		206,
		195,
		198,
		212,
		207,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		264,
		283,
		-1,
		258,
		247,
		232,
		224,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		202,
		227,
		216,
		224,
		219,
		199,
		205,
		208,
		197,
		201,
		213,
		-1,
		-1,
		246,
		247,
		252,
		-1,
		267,
		-1,
		282,
		-1,
		227,
		243,
		245,
		-1,
		-1,
		-1,
		240,
		203,
		224,
		234,
		228,
		226,
		217,
		203,
		210,
		208,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		259,
		289,
		280,
		263,
		243,
		235,
		257,
		-1,
		227,
		-1,
		202,
		204,
		230,
		233,
		239,
		233,
		206,
		221,
		211,
		202,
		211,
		291,
		-1,
		261,
		294,
		258,
		249,
		228,
		232,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		255,
		240,
		221,
		208,
		215,
		215,
		208,
		-1,
		-1,
		-1,
		263,
		262,
		254,
		248,
		248,
		233,
		224,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		245,
		241,
		228,
		228,
		220,
		-1,
		353,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		257,
		252,
		225,
		213,
		219,
		215,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		221,
		256,
		-1,
		359,
		-1,
		293,
		-1,
		-1,
		275,
		255,
		247,
		236,
		225,
		223,
		214,
		205,
		227,
		243,
		227,
		225,
		228,
		229,
		-1,
		348,
		347,
		-1,
		294,
		286,
		272,
		-1,
		265,
		-1,
		271,
		232,
		-1,
		234,
		214,
		-1,
		236,
		232,
		-1,
		-1,
		335,
		310,
		-1,
		-1,
		-1,
		295,
		275,
		266,
		250,
		-1,
		225,
		225,
		-1,
		-1,
		-1,
		320,
		319,
		-1,
		288,
		291,
		-1,
		281,
		272,
		280,
		227,
		231,
		-1,
		-1,
		-1,
		329,
		310,
		304,
		303,
		301,
		296,
		293,
		279,
		263,
		241,
		230,
		251,
		-1,
		-1,
		-1,
		301,
		293,
		286,
		-1,
		-1,
		288,
		271,
		252,
		250,
		-1,
		-1,
		-1,
		323,
		304,
		-1,
		-1,
		278,
		-1,
		-1,
		284,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		312,
		-1,
		-1,
		-1,
		274,
		270,
		271,
		-1,
		-1,
		-1,
		-1,
		334,
		335,
		358,
		322,
		-1,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		337,
		335,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		264,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		299,
		-1,
		299,
		274,
		281,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		312,
		-1,
		284,
		286,
		-1,
		334,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		289,
		296,
		318,
		321,
		357,
		-1,
		308
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		185,
		187,
		153,
		147,
		186,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		176,
		175,
		145,
		143,
		152,
		157,
		164,
		-1,
		177,
		-1,
		197,
		176,
		187,
		192,
		138,
		135,
		155,
		174,
		170,
		162,
		212,
		168,
		139,
		133,
		151,
		155,
		164,
		156,
		-1,
		139,
		129,
		151,
		144,
		155,
		147,
		-1,
		-1,
		133,
		134,
		140,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		123,
		136,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		124,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		139,
		-1,
		112,
		130,
		139,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		134,
		-1,
		104,
		106,
		126,
		134,
		139,
		123,
		110,
		110,
		120,
		113,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		101,
		109,
		130,
		122,
		112,
		127,
		120,
		113,
		110,
		108,
		105,
		121,
		122,
		132,
		-1,
		-1,
		157,
		126,
		161,
		118,
		103,
		-1,
		97,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		99,
		98,
		129,
		115,
		126,
		117,
		-1,
		-1,
		115,
		107,
		92,
		95,
		92,
		92,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		93,
		103,
		107,
		118,
		133,
		-1,
		-1,
		188,
		-1,
		-1,
		114,
		97,
		-1,
		80,
		87,
		87,
		104,
		94,
		115,
		130,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		90,
		115,
		119,
		113,
		134,
		129,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		73,
		76,
		82,
		106,
		116,
		-1,
		116,
		122,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		97,
		99,
		132,
		110,
		132,
		129,
		158,
		163,
		157,
		166,
		-1,
		122,
		118,
		114,
		121,
		70,
		-1,
		-1,
		110,
		-1,
		124,
		133,
		108,
		126,
		129,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		99,
		110,
		105,
		104,
		122,
		137,
		150,
		154,
		160,
		-1,
		172,
		-1,
		114,
		98,
		100,
		72,
		93,
		-1,
		130,
		125,
		125,
		110,
		101,
		-1,
		104,
		107,
		114,
		92,
		77,
		94,
		86,
		84,
		89,
		94,
		108,
		99,
		117,
		124,
		132,
		136,
		156,
		168,
		132,
		122,
		-1,
		104,
		109,
		68,
		76,
		95,
		143,
		107,
		-1,
		102,
		-1,
		94,
		119,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		93,
		90,
		87,
		105,
		108,
		125,
		129,
		145,
		-1,
		-1,
		117,
		121,
		110,
		61,
		80,
		104,
		141,
		100,
		89,
		88,
		-1,
		79,
		109,
		106,
		92,
		79,
		69,
		70,
		78,
		91,
		70,
		89,
		92,
		114,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		87,
		58,
		82,
		124,
		118,
		111,
		99,
		64,
		64,
		58,
		-1,
		99,
		82,
		78,
		67,
		65,
		78,
		73,
		89,
		93,
		92,
		111,
		123,
		114,
		134,
		-1,
		-1,
		-1,
		117,
		106,
		107,
		53,
		76,
		113,
		97,
		83,
		88,
		63,
		56,
		50,
		102,
		99,
		66,
		74,
		66,
		55,
		69,
		77,
		81,
		90,
		99,
		105,
		129,
		129,
		135,
		-1,
		-1,
		124,
		114,
		98,
		100,
		97,
		67,
		74,
		106,
		88,
		45,
		-1,
		55,
		-1,
		44,
		52,
		51,
		57,
		69,
		55,
		60,
		71,
		83,
		96,
		92,
		99,
		134,
		134,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		117,
		112,
		87,
		64,
		48,
		84,
		-1,
		15,
		16,
		-1,
		49,
		43,
		49,
		48,
		55,
		52,
		52,
		66,
		74,
		70,
		86,
		92,
		84,
		120,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		110,
		89,
		82,
		102,
		43,
		95,
		-1,
		-1,
		0,
		7,
		-1,
		36,
		36,
		43,
		52,
		57,
		62,
		70,
		65,
		78,
		83,
		89,
		94,
		112,
		116,
		120,
		109,
		105,
		102,
		116,
		-1,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		63,
		-1,
		44,
		36,
		22,
		16,
		22,
		49,
		47,
		67,
		59,
		73,
		73,
		79,
		87,
		72,
		75,
		91,
		89,
		107,
		115,
		107,
		101,
		100,
		112,
		-1,
		130,
		116,
		87,
		-1,
		-1,
		76,
		-1,
		40,
		53,
		69,
		-1,
		56,
		35,
		59,
		41,
		59,
		55,
		93,
		94,
		72,
		77,
		85,
		95,
		97,
		86,
		97,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		136,
		123,
		81,
		77,
		66,
		86,
		37,
		25,
		56,
		-1,
		-1,
		109,
		-1,
		43,
		60,
		69,
		67,
		83,
		74,
		80,
		96,
		99,
		101,
		91,
		80,
		86,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		52,
		39,
		33,
		-1,
		73,
		-1,
		87,
		77,
		61,
		46,
		79,
		-1,
		91,
		75,
		80,
		-1,
		126,
		-1,
		99,
		101,
		95,
		80,
		77,
		88,
		86,
		97,
		114,
		-1,
		86,
		71,
		64,
		54,
		68,
		39,
		-1,
		94,
		-1,
		-1,
		74,
		68,
		68,
		52,
		55,
		107,
		87,
		81,
		80,
		121,
		121,
		107,
		93,
		86,
		83,
		80,
		93,
		113,
		104,
		116,
		-1,
		-1,
		-1,
		91,
		77,
		81,
		41,
		60,
		-1,
		-1,
		136,
		91,
		77,
		-1,
		61,
		124,
		112,
		102,
		92,
		126,
		127,
		112,
		105,
		91,
		93,
		91,
		89,
		94,
		115,
		116,
		129,
		-1,
		-1,
		74,
		79,
		67,
		53,
		72,
		-1,
		-1,
		-1,
		83,
		99,
		91,
		62,
		113,
		-1,
		-1,
		104,
		102,
		112,
		108,
		95,
		115,
		118,
		104,
		88,
		103,
		115,
		123,
		128,
		-1,
		77,
		64,
		-1,
		-1,
		75,
		69,
		-1,
		-1,
		-1,
		-1,
		116,
		82,
		94,
		115,
		140,
		107,
		-1,
		112,
		113,
		99,
		113,
		120,
		106,
		101,
		95,
		98,
		116,
		133,
		-1,
		-1,
		89,
		-1,
		84,
		-1,
		-1,
		-1,
		-1,
		73,
		87,
		108,
		114,
		126,
		-1,
		121,
		115,
		101,
		118,
		119,
		116,
		107,
		99,
		104,
		101,
		114,
		128,
		132,
		112,
		-1,
		95,
		-1,
		-1,
		-1,
		91,
		106,
		168,
		145,
		118,
		122,
		115,
		109,
		109,
		125,
		127,
		138,
		106,
		102,
		103,
		107,
		106,
		123,
		133,
		-1,
		-1,
		95,
		112,
		117,
		99,
		103,
		195,
		-1,
		-1,
		131,
		122,
		113,
		116,
		119,
		122,
		112,
		109,
		114,
		119,
		107,
		116,
		134,
		138,
		-1,
		-1,
		-1,
		115,
		-1,
		130,
		-1,
		-1,
		118,
		202,
		149,
		131,
		127,
		125,
		118,
		127,
		122,
		117,
		127,
		136,
		128,
		109,
		120,
		143,
		132,
		170,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		144,
		119,
		134,
		180,
		138,
		145,
		164,
		161,
		-1,
		131,
		156,
		128,
		135,
		127,
		135,
		135,
		132,
		110,
		117,
		133,
		132,
		127,
		162,
		154,
		160,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		150,
		136,
		166,
		156,
		155,
		-1,
		-1,
		180,
		177,
		153,
		137,
		141,
		134,
		129,
		139,
		119,
		106,
		110,
		114,
		120,
		125,
		130,
		136,
		151,
		166,
		-1,
		122,
		203,
		196,
		179,
		187,
		218,
		-1,
		153,
		162,
		143,
		148,
		156,
		-1,
		-1,
		153,
		150,
		155,
		144,
		141,
		149,
		144,
		135,
		120,
		126,
		113,
		112,
		130,
		134,
		143,
		150,
		140,
		153,
		157,
		-1,
		136,
		179,
		173,
		176,
		200,
		214,
		-1,
		166,
		-1,
		-1,
		151,
		169,
		168,
		158,
		152,
		202,
		158,
		153,
		143,
		141,
		132,
		123,
		130,
		121,
		121,
		124,
		139,
		144,
		136,
		150,
		150,
		151,
		-1,
		171,
		159,
		167,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		167,
		-1,
		195,
		-1,
		170,
		174,
		166,
		169,
		157,
		144,
		136,
		128,
		144,
		119,
		129,
		125,
		126,
		135,
		146,
		158,
		157,
		158,
		245,
		200,
		167,
		158,
		205,
		220,
		224,
		-1,
		179,
		218,
		205,
		-1,
		176,
		-1,
		-1,
		-1,
		184,
		179,
		171,
		177,
		156,
		156,
		130,
		134,
		124,
		131,
		141,
		143,
		135,
		139,
		152,
		163,
		166,
		241,
		239,
		244,
		189,
		172,
		190,
		199,
		220,
		194,
		185,
		212,
		212,
		201,
		196,
		183,
		-1,
		-1,
		207,
		189,
		-1,
		-1,
		163,
		151,
		134,
		135,
		131,
		134,
		149,
		152,
		142,
		140,
		134,
		166,
		-1,
		241,
		240,
		229,
		226,
		202,
		193,
		180,
		191,
		-1,
		-1,
		197,
		213,
		226,
		230,
		243,
		268,
		-1,
		186,
		-1,
		-1,
		208,
		-1,
		-1,
		193,
		156,
		145,
		136,
		142,
		139,
		150,
		160,
		148,
		149,
		139,
		149,
		162,
		225,
		222,
		210,
		208,
		231,
		188,
		184,
		-1,
		212,
		200,
		206,
		213,
		230,
		257,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		191,
		189,
		178,
		-1,
		168,
		141,
		146,
		166,
		168,
		157,
		151,
		145,
		152,
		151,
		159,
		167,
		234,
		248,
		237,
		233,
		232,
		240,
		189,
		202,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		-1,
		229,
		212,
		-1,
		-1,
		186,
		179,
		167,
		155,
		145,
		155,
		159,
		163,
		155,
		148,
		143,
		154,
		146,
		150,
		167,
		-1,
		268,
		-1,
		220,
		213,
		228,
		243,
		251,
		-1,
		-1,
		-1,
		246,
		232,
		225,
		213,
		211,
		-1,
		220,
		204,
		185,
		-1,
		155,
		168,
		199,
		167,
		172,
		167,
		149,
		160,
		149,
		152,
		166,
		161,
		-1,
		-1,
		226,
		229,
		-1,
		-1,
		236,
		238,
		-1,
		237,
		226,
		211,
		203,
		-1,
		-1,
		192,
		188,
		-1,
		-1,
		156,
		181,
		170,
		178,
		173,
		153,
		159,
		162,
		151,
		155,
		167,
		-1,
		-1,
		233,
		234,
		239,
		-1,
		221,
		-1,
		239,
		-1,
		206,
		212,
		200,
		-1,
		-1,
		-1,
		194,
		157,
		178,
		188,
		182,
		180,
		171,
		157,
		164,
		162,
		158,
		169,
		-1,
		-1,
		-1,
		239,
		213,
		246,
		237,
		220,
		200,
		192,
		211,
		-1,
		181,
		-1,
		156,
		158,
		184,
		187,
		193,
		187,
		160,
		175,
		165,
		156,
		165,
		245,
		-1,
		215,
		248,
		212,
		206,
		182,
		186,
		202,
		-1,
		178,
		160,
		-1,
		188,
		178,
		209,
		194,
		175,
		162,
		169,
		169,
		162,
		-1,
		-1,
		-1,
		217,
		216,
		208,
		202,
		202,
		187,
		178,
		-1,
		190,
		172,
		151,
		168,
		168,
		159,
		167,
		199,
		195,
		182,
		182,
		174,
		-1,
		318,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		211,
		206,
		179,
		167,
		173,
		169,
		155,
		161,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		175,
		210,
		-1,
		313,
		-1,
		247,
		-1,
		-1,
		229,
		209,
		201,
		190,
		179,
		177,
		168,
		159,
		181,
		197,
		181,
		179,
		182,
		183,
		-1,
		302,
		301,
		-1,
		248,
		240,
		226,
		-1,
		219,
		-1,
		225,
		186,
		-1,
		188,
		168,
		-1,
		190,
		186,
		-1,
		-1,
		289,
		264,
		-1,
		-1,
		-1,
		249,
		229,
		220,
		204,
		-1,
		179,
		179,
		-1,
		-1,
		-1,
		274,
		273,
		-1,
		242,
		245,
		-1,
		235,
		226,
		234,
		181,
		185,
		-1,
		-1,
		-1,
		283,
		264,
		258,
		257,
		255,
		250,
		247,
		233,
		217,
		195,
		184,
		205,
		-1,
		-1,
		-1,
		255,
		247,
		240,
		-1,
		-1,
		242,
		225,
		206,
		204,
		-1,
		-1,
		-1,
		277,
		258,
		-1,
		-1,
		232,
		-1,
		-1,
		238,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		266,
		-1,
		-1,
		-1,
		228,
		224,
		225,
		-1,
		-1,
		-1,
		-1,
		288,
		289,
		312,
		276,
		-1,
		-1,
		-1,
		220,
		214,
		-1,
		-1,
		291,
		289,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		218,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		253,
		-1,
		253,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		266,
		258,
		266,
		-1,
		238,
		240,
		-1,
		288,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		243,
		250,
		272,
		275,
		311,
		-1,
		262
	],
	[
		-1,
		169,
		158,
		169,
		177,
		150,
		157,
		-1,
		178,
		180,
		146,
		140,
		179,
		150,
		156,
		167,
		-1,
		-1,
		-1,
		169,
		168,
		138,
		136,
		145,
		150,
		157,
		-1,
		170,
		-1,
		190,
		169,
		180,
		185,
		131,
		128,
		148,
		167,
		163,
		155,
		205,
		161,
		132,
		126,
		144,
		148,
		157,
		149,
		-1,
		132,
		122,
		144,
		137,
		148,
		140,
		-1,
		-1,
		126,
		127,
		133,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		116,
		129,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		117,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		105,
		123,
		132,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		127,
		-1,
		97,
		99,
		119,
		127,
		132,
		116,
		103,
		103,
		113,
		106,
		125,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		102,
		123,
		115,
		105,
		120,
		113,
		106,
		103,
		101,
		98,
		114,
		115,
		125,
		-1,
		-1,
		150,
		119,
		154,
		111,
		96,
		-1,
		90,
		99,
		105,
		109,
		103,
		96,
		110,
		106,
		-1,
		92,
		91,
		122,
		108,
		119,
		110,
		-1,
		-1,
		108,
		100,
		85,
		88,
		85,
		85,
		114,
		113,
		105,
		91,
		87,
		93,
		96,
		96,
		102,
		86,
		96,
		100,
		111,
		126,
		-1,
		-1,
		181,
		-1,
		-1,
		107,
		90,
		-1,
		73,
		80,
		80,
		97,
		87,
		108,
		123,
		115,
		107,
		101,
		89,
		91,
		88,
		101,
		89,
		83,
		108,
		112,
		106,
		127,
		122,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		66,
		69,
		75,
		99,
		109,
		-1,
		109,
		115,
		125,
		110,
		107,
		94,
		82,
		95,
		80,
		87,
		86,
		90,
		92,
		125,
		103,
		125,
		122,
		151,
		156,
		150,
		159,
		-1,
		115,
		111,
		107,
		114,
		63,
		-1,
		-1,
		103,
		-1,
		117,
		126,
		101,
		119,
		122,
		111,
		102,
		89,
		78,
		89,
		78,
		75,
		83,
		92,
		103,
		98,
		97,
		115,
		130,
		143,
		147,
		153,
		-1,
		165,
		-1,
		107,
		91,
		93,
		65,
		86,
		-1,
		123,
		118,
		118,
		103,
		94,
		-1,
		97,
		100,
		107,
		85,
		70,
		87,
		79,
		77,
		82,
		87,
		101,
		92,
		110,
		117,
		125,
		129,
		149,
		161,
		125,
		115,
		-1,
		97,
		102,
		61,
		69,
		88,
		136,
		100,
		-1,
		95,
		-1,
		87,
		112,
		-1,
		91,
		87,
		69,
		70,
		65,
		80,
		86,
		83,
		80,
		98,
		101,
		118,
		122,
		138,
		-1,
		-1,
		110,
		114,
		103,
		54,
		73,
		97,
		134,
		93,
		82,
		81,
		-1,
		72,
		102,
		99,
		85,
		72,
		62,
		63,
		71,
		84,
		63,
		82,
		85,
		107,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		80,
		51,
		75,
		117,
		111,
		104,
		92,
		57,
		57,
		51,
		-1,
		92,
		75,
		71,
		60,
		58,
		71,
		66,
		82,
		86,
		85,
		104,
		116,
		107,
		127,
		-1,
		-1,
		-1,
		110,
		99,
		100,
		46,
		69,
		106,
		90,
		76,
		81,
		56,
		49,
		43,
		95,
		92,
		59,
		67,
		59,
		48,
		62,
		70,
		74,
		83,
		92,
		98,
		122,
		122,
		128,
		-1,
		-1,
		117,
		107,
		91,
		93,
		90,
		60,
		67,
		99,
		81,
		52,
		-1,
		48,
		-1,
		37,
		45,
		44,
		50,
		62,
		48,
		53,
		64,
		76,
		89,
		85,
		92,
		127,
		127,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		110,
		105,
		80,
		57,
		41,
		77,
		-1,
		22,
		23,
		-1,
		42,
		36,
		42,
		41,
		48,
		45,
		45,
		59,
		67,
		63,
		79,
		85,
		77,
		113,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		103,
		82,
		75,
		95,
		36,
		88,
		-1,
		-1,
		7,
		0,
		-1,
		29,
		29,
		36,
		45,
		50,
		55,
		63,
		58,
		71,
		76,
		82,
		87,
		105,
		109,
		113,
		102,
		98,
		95,
		109,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		36,
		56,
		-1,
		37,
		29,
		15,
		9,
		15,
		42,
		40,
		60,
		52,
		66,
		66,
		72,
		80,
		65,
		68,
		84,
		82,
		100,
		108,
		100,
		94,
		93,
		105,
		-1,
		123,
		109,
		80,
		-1,
		-1,
		69,
		-1,
		33,
		46,
		62,
		-1,
		49,
		28,
		52,
		34,
		52,
		48,
		86,
		87,
		65,
		70,
		78,
		88,
		90,
		79,
		90,
		82,
		104,
		104,
		88,
		89,
		98,
		-1,
		129,
		116,
		74,
		70,
		59,
		79,
		30,
		18,
		49,
		-1,
		-1,
		102,
		-1,
		36,
		53,
		62,
		60,
		76,
		67,
		73,
		89,
		92,
		94,
		84,
		73,
		79,
		76,
		98,
		84,
		82,
		101,
		117,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		45,
		32,
		26,
		-1,
		66,
		-1,
		80,
		70,
		54,
		39,
		72,
		-1,
		84,
		68,
		73,
		-1,
		119,
		-1,
		92,
		94,
		88,
		73,
		70,
		81,
		79,
		90,
		107,
		-1,
		79,
		64,
		57,
		47,
		61,
		32,
		-1,
		87,
		-1,
		-1,
		67,
		61,
		61,
		45,
		48,
		100,
		80,
		74,
		73,
		114,
		114,
		100,
		86,
		79,
		76,
		73,
		86,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		84,
		70,
		74,
		34,
		53,
		-1,
		-1,
		129,
		84,
		70,
		-1,
		54,
		117,
		105,
		95,
		85,
		119,
		120,
		105,
		98,
		84,
		86,
		84,
		82,
		87,
		108,
		109,
		122,
		-1,
		-1,
		67,
		72,
		60,
		46,
		65,
		-1,
		-1,
		-1,
		76,
		92,
		84,
		55,
		106,
		-1,
		-1,
		97,
		95,
		105,
		101,
		88,
		108,
		111,
		97,
		81,
		96,
		108,
		116,
		121,
		-1,
		70,
		57,
		-1,
		-1,
		68,
		62,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		87,
		108,
		133,
		100,
		-1,
		105,
		106,
		92,
		106,
		113,
		99,
		94,
		88,
		91,
		109,
		126,
		-1,
		-1,
		82,
		-1,
		77,
		-1,
		-1,
		-1,
		-1,
		66,
		80,
		101,
		107,
		119,
		-1,
		114,
		108,
		94,
		111,
		112,
		109,
		100,
		92,
		97,
		94,
		107,
		121,
		125,
		105,
		-1,
		88,
		-1,
		-1,
		-1,
		84,
		99,
		161,
		138,
		111,
		115,
		108,
		102,
		102,
		118,
		120,
		131,
		99,
		95,
		96,
		100,
		99,
		116,
		126,
		-1,
		-1,
		88,
		105,
		110,
		92,
		96,
		188,
		-1,
		-1,
		124,
		115,
		106,
		109,
		112,
		115,
		105,
		102,
		107,
		112,
		100,
		109,
		127,
		131,
		-1,
		-1,
		-1,
		108,
		-1,
		123,
		-1,
		-1,
		111,
		195,
		142,
		124,
		120,
		118,
		111,
		120,
		115,
		110,
		120,
		129,
		121,
		102,
		113,
		136,
		125,
		163,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		137,
		112,
		127,
		173,
		131,
		138,
		157,
		154,
		-1,
		124,
		149,
		121,
		128,
		120,
		128,
		128,
		125,
		103,
		110,
		126,
		125,
		120,
		155,
		147,
		153,
		-1,
		-1,
		220,
		209,
		198,
		204,
		-1,
		143,
		129,
		159,
		149,
		148,
		-1,
		-1,
		173,
		170,
		146,
		130,
		134,
		127,
		122,
		132,
		112,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		115,
		196,
		189,
		172,
		180,
		211,
		-1,
		146,
		155,
		136,
		141,
		149,
		-1,
		-1,
		146,
		143,
		148,
		137,
		134,
		142,
		137,
		128,
		113,
		119,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		129,
		172,
		166,
		169,
		193,
		207,
		-1,
		159,
		-1,
		-1,
		144,
		162,
		161,
		151,
		145,
		195,
		151,
		146,
		136,
		134,
		125,
		116,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		164,
		152,
		160,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		160,
		-1,
		188,
		-1,
		163,
		167,
		159,
		162,
		150,
		137,
		129,
		121,
		137,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		238,
		193,
		160,
		151,
		198,
		213,
		217,
		-1,
		172,
		211,
		198,
		-1,
		169,
		-1,
		-1,
		-1,
		177,
		172,
		164,
		170,
		149,
		149,
		123,
		127,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		234,
		232,
		237,
		182,
		165,
		183,
		192,
		213,
		187,
		178,
		205,
		205,
		194,
		189,
		176,
		-1,
		-1,
		200,
		182,
		-1,
		-1,
		156,
		144,
		127,
		128,
		124,
		127,
		142,
		145,
		135,
		133,
		127,
		159,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		173,
		184,
		-1,
		-1,
		190,
		206,
		219,
		223,
		236,
		261,
		-1,
		179,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		132,
		143,
		153,
		141,
		142,
		132,
		142,
		155,
		218,
		215,
		203,
		201,
		224,
		181,
		177,
		-1,
		205,
		193,
		199,
		206,
		223,
		250,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		134,
		139,
		159,
		161,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		195,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		222,
		205,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		152,
		156,
		148,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		261,
		-1,
		213,
		206,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		239,
		225,
		218,
		206,
		204,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		229,
		231,
		-1,
		230,
		219,
		204,
		196,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		226,
		227,
		232,
		-1,
		214,
		-1,
		232,
		-1,
		199,
		205,
		193,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		175,
		173,
		164,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		232,
		206,
		239,
		230,
		213,
		193,
		185,
		204,
		-1,
		174,
		-1,
		149,
		151,
		177,
		180,
		186,
		180,
		153,
		168,
		158,
		149,
		158,
		238,
		-1,
		208,
		241,
		205,
		199,
		175,
		179,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		202,
		187,
		168,
		155,
		162,
		162,
		155,
		-1,
		-1,
		-1,
		210,
		209,
		201,
		195,
		195,
		180,
		171,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		192,
		188,
		175,
		175,
		167,
		-1,
		311,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		204,
		199,
		172,
		160,
		166,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		168,
		203,
		-1,
		306,
		-1,
		240,
		-1,
		-1,
		222,
		202,
		194,
		183,
		172,
		170,
		161,
		152,
		174,
		190,
		174,
		172,
		175,
		176,
		-1,
		295,
		294,
		-1,
		241,
		233,
		219,
		-1,
		212,
		-1,
		218,
		179,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		282,
		257,
		-1,
		-1,
		-1,
		242,
		222,
		213,
		197,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		267,
		266,
		-1,
		235,
		238,
		-1,
		228,
		219,
		227,
		174,
		178,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		250,
		248,
		243,
		240,
		226,
		210,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		248,
		240,
		233,
		-1,
		-1,
		235,
		218,
		199,
		197,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		225,
		-1,
		-1,
		231,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		259,
		-1,
		-1,
		-1,
		221,
		217,
		218,
		-1,
		-1,
		-1,
		-1,
		281,
		282,
		305,
		269,
		-1,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		284,
		282,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		211,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		246,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		236,
		243,
		265,
		268,
		304,
		-1,
		255
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		167,
		156,
		167,
		175,
		148,
		155,
		-1,
		176,
		178,
		144,
		138,
		177,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		167,
		166,
		136,
		134,
		143,
		148,
		155,
		-1,
		159,
		-1,
		188,
		167,
		178,
		183,
		129,
		126,
		146,
		165,
		152,
		144,
		203,
		159,
		130,
		124,
		142,
		137,
		146,
		138,
		-1,
		130,
		120,
		142,
		126,
		137,
		129,
		-1,
		-1,
		124,
		125,
		131,
		122,
		128,
		124,
		-1,
		134,
		118,
		-1,
		-1,
		114,
		120,
		104,
		107,
		115,
		113,
		126,
		118,
		113,
		-1,
		-1,
		110,
		106,
		113,
		100,
		96,
		113,
		126,
		108,
		122,
		121,
		-1,
		103,
		121,
		130,
		107,
		105,
		89,
		87,
		105,
		107,
		113,
		116,
		-1,
		96,
		98,
		108,
		116,
		121,
		105,
		92,
		92,
		102,
		95,
		114,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		93,
		95,
		112,
		104,
		94,
		109,
		102,
		95,
		92,
		90,
		87,
		103,
		104,
		114,
		-1,
		-1,
		149,
		118,
		153,
		110,
		95,
		-1,
		89,
		88,
		94,
		98,
		92,
		85,
		99,
		95,
		-1,
		81,
		80,
		111,
		97,
		108,
		109,
		-1,
		-1,
		107,
		99,
		84,
		87,
		84,
		84,
		103,
		102,
		94,
		80,
		76,
		82,
		85,
		85,
		91,
		75,
		85,
		89,
		100,
		115,
		-1,
		-1,
		170,
		-1,
		-1,
		106,
		89,
		-1,
		72,
		79,
		79,
		96,
		86,
		107,
		113,
		104,
		96,
		90,
		78,
		80,
		77,
		90,
		78,
		72,
		97,
		101,
		95,
		116,
		111,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		65,
		68,
		74,
		98,
		108,
		-1,
		91,
		97,
		107,
		99,
		96,
		83,
		71,
		84,
		69,
		76,
		75,
		79,
		81,
		114,
		92,
		114,
		111,
		140,
		145,
		139,
		148,
		-1,
		114,
		110,
		106,
		113,
		62,
		-1,
		-1,
		102,
		-1,
		115,
		108,
		83,
		101,
		104,
		100,
		91,
		78,
		67,
		78,
		67,
		64,
		72,
		81,
		92,
		87,
		86,
		104,
		119,
		132,
		136,
		142,
		-1,
		164,
		-1,
		106,
		90,
		92,
		64,
		85,
		-1,
		122,
		114,
		100,
		85,
		76,
		-1,
		79,
		82,
		96,
		74,
		59,
		76,
		68,
		66,
		71,
		76,
		90,
		81,
		99,
		106,
		114,
		118,
		138,
		150,
		124,
		114,
		-1,
		96,
		101,
		60,
		68,
		87,
		118,
		82,
		-1,
		77,
		-1,
		69,
		94,
		-1,
		80,
		76,
		58,
		59,
		54,
		69,
		75,
		72,
		69,
		87,
		90,
		107,
		111,
		127,
		-1,
		-1,
		109,
		113,
		102,
		53,
		72,
		96,
		128,
		75,
		64,
		63,
		-1,
		54,
		88,
		85,
		71,
		58,
		51,
		52,
		60,
		73,
		52,
		71,
		74,
		96,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		79,
		50,
		74,
		116,
		93,
		86,
		74,
		39,
		39,
		33,
		-1,
		78,
		61,
		60,
		49,
		47,
		60,
		55,
		71,
		75,
		74,
		93,
		105,
		96,
		116,
		-1,
		-1,
		-1,
		109,
		98,
		99,
		45,
		68,
		105,
		72,
		58,
		63,
		38,
		31,
		23,
		81,
		78,
		45,
		56,
		48,
		37,
		51,
		59,
		63,
		72,
		81,
		87,
		111,
		111,
		117,
		-1,
		-1,
		116,
		106,
		90,
		92,
		89,
		59,
		66,
		98,
		63,
		83,
		-1,
		28,
		-1,
		17,
		23,
		33,
		39,
		51,
		37,
		42,
		53,
		65,
		78,
		74,
		81,
		116,
		116,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		109,
		104,
		79,
		56,
		40,
		76,
		-1,
		53,
		54,
		-1,
		22,
		16,
		20,
		30,
		37,
		34,
		34,
		48,
		56,
		52,
		68,
		74,
		66,
		102,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		102,
		81,
		74,
		94,
		35,
		87,
		-1,
		-1,
		38,
		31,
		-1,
		0,
		18,
		25,
		34,
		39,
		44,
		52,
		47,
		60,
		65,
		71,
		76,
		94,
		98,
		102,
		91,
		87,
		84,
		98,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		35,
		55,
		-1,
		47,
		39,
		29,
		23,
		17,
		31,
		29,
		49,
		41,
		55,
		55,
		61,
		69,
		54,
		57,
		73,
		71,
		89,
		97,
		89,
		83,
		82,
		94,
		-1,
		122,
		108,
		79,
		-1,
		-1,
		68,
		-1,
		32,
		46,
		62,
		-1,
		55,
		34,
		49,
		27,
		41,
		37,
		75,
		76,
		54,
		59,
		67,
		77,
		79,
		68,
		79,
		71,
		93,
		93,
		77,
		78,
		87,
		-1,
		128,
		115,
		73,
		69,
		58,
		78,
		29,
		17,
		49,
		-1,
		-1,
		91,
		-1,
		25,
		42,
		51,
		49,
		65,
		56,
		62,
		78,
		81,
		83,
		73,
		62,
		68,
		65,
		87,
		73,
		71,
		90,
		106,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		44,
		31,
		25,
		-1,
		66,
		-1,
		69,
		59,
		43,
		28,
		61,
		-1,
		73,
		57,
		62,
		-1,
		108,
		-1,
		81,
		83,
		77,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		78,
		63,
		56,
		46,
		60,
		31,
		-1,
		86,
		-1,
		-1,
		56,
		50,
		50,
		34,
		37,
		89,
		69,
		63,
		62,
		103,
		103,
		89,
		75,
		68,
		65,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		83,
		69,
		73,
		33,
		52,
		-1,
		-1,
		118,
		73,
		59,
		-1,
		43,
		106,
		94,
		84,
		74,
		108,
		109,
		94,
		87,
		73,
		75,
		73,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		66,
		71,
		59,
		45,
		64,
		-1,
		-1,
		-1,
		65,
		81,
		73,
		44,
		95,
		-1,
		-1,
		86,
		84,
		94,
		90,
		77,
		97,
		100,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		69,
		56,
		-1,
		-1,
		67,
		61,
		-1,
		-1,
		-1,
		-1,
		98,
		64,
		76,
		97,
		122,
		89,
		-1,
		94,
		95,
		81,
		95,
		102,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		81,
		-1,
		76,
		-1,
		-1,
		-1,
		-1,
		55,
		69,
		90,
		96,
		108,
		-1,
		103,
		97,
		83,
		100,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		104,
		-1,
		87,
		-1,
		-1,
		-1,
		73,
		88,
		150,
		127,
		100,
		104,
		97,
		91,
		91,
		107,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		87,
		104,
		99,
		81,
		85,
		177,
		-1,
		-1,
		113,
		104,
		95,
		98,
		101,
		104,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		120,
		-1,
		-1,
		-1,
		107,
		-1,
		122,
		-1,
		-1,
		100,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		118,
		110,
		91,
		102,
		125,
		114,
		152,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		136,
		111,
		126,
		172,
		120,
		127,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		109,
		117,
		117,
		114,
		92,
		99,
		115,
		114,
		109,
		144,
		136,
		142,
		-1,
		-1,
		219,
		208,
		197,
		203,
		-1,
		142,
		128,
		158,
		148,
		137,
		-1,
		-1,
		162,
		159,
		135,
		119,
		123,
		116,
		111,
		121,
		101,
		88,
		92,
		96,
		102,
		107,
		112,
		118,
		133,
		148,
		-1,
		114,
		195,
		188,
		171,
		179,
		210,
		-1,
		145,
		154,
		135,
		140,
		148,
		-1,
		-1,
		135,
		132,
		137,
		126,
		123,
		131,
		126,
		117,
		102,
		108,
		95,
		94,
		112,
		116,
		125,
		132,
		122,
		135,
		139,
		-1,
		128,
		171,
		165,
		168,
		192,
		206,
		-1,
		158,
		-1,
		-1,
		143,
		161,
		150,
		140,
		134,
		184,
		140,
		135,
		125,
		123,
		114,
		105,
		112,
		103,
		103,
		106,
		121,
		126,
		118,
		132,
		132,
		133,
		-1,
		163,
		151,
		159,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		159,
		-1,
		177,
		-1,
		152,
		156,
		148,
		151,
		139,
		126,
		118,
		110,
		126,
		101,
		111,
		107,
		108,
		117,
		128,
		140,
		139,
		140,
		237,
		192,
		159,
		150,
		197,
		212,
		216,
		-1,
		171,
		210,
		197,
		-1,
		168,
		-1,
		-1,
		-1,
		166,
		161,
		153,
		159,
		138,
		138,
		112,
		116,
		106,
		113,
		123,
		125,
		117,
		121,
		134,
		145,
		148,
		233,
		231,
		236,
		181,
		164,
		182,
		191,
		212,
		186,
		177,
		204,
		204,
		193,
		188,
		175,
		-1,
		-1,
		189,
		171,
		-1,
		-1,
		145,
		133,
		116,
		117,
		113,
		116,
		131,
		134,
		124,
		122,
		116,
		148,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		172,
		183,
		-1,
		-1,
		189,
		205,
		218,
		222,
		235,
		260,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		121,
		132,
		142,
		130,
		131,
		121,
		131,
		144,
		217,
		214,
		202,
		200,
		223,
		180,
		176,
		-1,
		199,
		192,
		198,
		205,
		222,
		249,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		123,
		128,
		148,
		150,
		139,
		133,
		127,
		134,
		133,
		141,
		149,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		184,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		211,
		204,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		141,
		145,
		137,
		130,
		125,
		136,
		128,
		132,
		149,
		-1,
		260,
		-1,
		212,
		198,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		228,
		214,
		207,
		195,
		193,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		131,
		142,
		131,
		134,
		148,
		143,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		218,
		220,
		-1,
		219,
		208,
		193,
		185,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		135,
		141,
		144,
		133,
		137,
		149,
		-1,
		-1,
		217,
		218,
		223,
		-1,
		203,
		-1,
		221,
		-1,
		188,
		194,
		182,
		-1,
		-1,
		-1,
		176,
		139,
		160,
		170,
		164,
		162,
		153,
		139,
		146,
		144,
		140,
		151,
		-1,
		-1,
		-1,
		221,
		195,
		228,
		219,
		202,
		182,
		174,
		193,
		-1,
		163,
		-1,
		138,
		140,
		166,
		169,
		175,
		169,
		142,
		157,
		147,
		138,
		147,
		227,
		-1,
		197,
		230,
		194,
		188,
		164,
		168,
		184,
		-1,
		160,
		142,
		-1,
		170,
		160,
		191,
		176,
		157,
		144,
		151,
		151,
		144,
		-1,
		-1,
		-1,
		199,
		198,
		190,
		184,
		184,
		169,
		160,
		-1,
		172,
		154,
		133,
		150,
		150,
		141,
		149,
		181,
		177,
		164,
		164,
		156,
		-1,
		300,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		193,
		188,
		161,
		149,
		155,
		151,
		137,
		143,
		145,
		153,
		151,
		148,
		160,
		156,
		176,
		157,
		192,
		-1,
		295,
		-1,
		229,
		-1,
		-1,
		211,
		191,
		183,
		172,
		161,
		159,
		150,
		141,
		163,
		179,
		163,
		161,
		164,
		165,
		-1,
		284,
		283,
		-1,
		230,
		222,
		208,
		-1,
		201,
		-1,
		207,
		168,
		-1,
		170,
		150,
		-1,
		172,
		168,
		-1,
		-1,
		271,
		246,
		-1,
		-1,
		-1,
		231,
		211,
		202,
		186,
		-1,
		161,
		161,
		-1,
		-1,
		-1,
		256,
		255,
		-1,
		224,
		227,
		-1,
		217,
		208,
		216,
		163,
		167,
		-1,
		-1,
		-1,
		265,
		246,
		240,
		239,
		237,
		232,
		229,
		215,
		199,
		177,
		166,
		187,
		-1,
		-1,
		-1,
		237,
		229,
		222,
		-1,
		-1,
		224,
		207,
		188,
		186,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		214,
		-1,
		-1,
		220,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		248,
		-1,
		-1,
		-1,
		210,
		206,
		207,
		-1,
		-1,
		-1,
		-1,
		270,
		271,
		294,
		258,
		-1,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		273,
		271,
		-1,
		-1,
		-1,
		230,
		214,
		-1,
		200,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		235,
		-1,
		235,
		210,
		217,
		-1,
		-1,
		-1,
		-1,
		248,
		240,
		248,
		-1,
		220,
		222,
		-1,
		270,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		225,
		232,
		254,
		257,
		293,
		-1,
		244
	],
	[
		-1,
		149,
		138,
		149,
		157,
		130,
		137,
		-1,
		158,
		160,
		126,
		120,
		159,
		130,
		136,
		147,
		-1,
		-1,
		-1,
		149,
		148,
		118,
		116,
		125,
		130,
		137,
		-1,
		141,
		-1,
		170,
		149,
		160,
		165,
		111,
		108,
		128,
		147,
		134,
		126,
		185,
		141,
		112,
		106,
		124,
		119,
		128,
		120,
		-1,
		112,
		102,
		124,
		108,
		119,
		111,
		-1,
		-1,
		106,
		107,
		113,
		104,
		110,
		106,
		-1,
		116,
		100,
		-1,
		-1,
		96,
		102,
		86,
		89,
		97,
		95,
		108,
		100,
		95,
		-1,
		-1,
		92,
		88,
		95,
		82,
		78,
		95,
		108,
		90,
		104,
		103,
		-1,
		85,
		103,
		112,
		89,
		87,
		71,
		69,
		87,
		89,
		95,
		98,
		-1,
		94,
		95,
		90,
		98,
		103,
		87,
		74,
		74,
		84,
		77,
		96,
		87,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		93,
		77,
		94,
		86,
		76,
		91,
		84,
		77,
		74,
		72,
		69,
		85,
		86,
		96,
		-1,
		-1,
		149,
		118,
		153,
		110,
		95,
		-1,
		89,
		70,
		76,
		80,
		74,
		67,
		81,
		77,
		-1,
		63,
		62,
		93,
		79,
		90,
		109,
		-1,
		-1,
		107,
		99,
		84,
		87,
		84,
		84,
		85,
		84,
		76,
		62,
		58,
		64,
		67,
		67,
		73,
		57,
		67,
		71,
		82,
		97,
		-1,
		-1,
		152,
		-1,
		-1,
		106,
		89,
		-1,
		72,
		79,
		79,
		96,
		86,
		107,
		95,
		86,
		78,
		72,
		60,
		62,
		59,
		72,
		60,
		54,
		79,
		83,
		77,
		98,
		93,
		-1,
		151,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		65,
		68,
		74,
		98,
		108,
		-1,
		98,
		95,
		96,
		81,
		78,
		65,
		53,
		66,
		51,
		58,
		57,
		61,
		63,
		96,
		74,
		96,
		93,
		122,
		127,
		121,
		130,
		-1,
		114,
		110,
		106,
		113,
		62,
		-1,
		-1,
		102,
		-1,
		116,
		115,
		90,
		92,
		95,
		82,
		73,
		60,
		49,
		60,
		49,
		46,
		54,
		63,
		74,
		69,
		68,
		86,
		101,
		114,
		118,
		124,
		-1,
		164,
		-1,
		106,
		90,
		92,
		64,
		85,
		-1,
		122,
		117,
		107,
		92,
		83,
		-1,
		86,
		88,
		78,
		56,
		41,
		58,
		50,
		48,
		53,
		58,
		72,
		63,
		81,
		88,
		96,
		100,
		120,
		132,
		124,
		114,
		-1,
		96,
		101,
		60,
		68,
		87,
		125,
		89,
		-1,
		84,
		-1,
		76,
		101,
		-1,
		62,
		58,
		40,
		41,
		36,
		51,
		57,
		54,
		51,
		69,
		72,
		89,
		93,
		109,
		-1,
		-1,
		109,
		113,
		102,
		53,
		72,
		96,
		133,
		82,
		71,
		70,
		-1,
		61,
		73,
		70,
		56,
		43,
		33,
		34,
		42,
		55,
		34,
		53,
		56,
		78,
		106,
		84,
		96,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		79,
		50,
		74,
		116,
		100,
		93,
		81,
		46,
		46,
		40,
		-1,
		63,
		46,
		42,
		31,
		29,
		42,
		37,
		53,
		57,
		56,
		75,
		87,
		78,
		98,
		-1,
		-1,
		-1,
		109,
		98,
		99,
		45,
		68,
		105,
		79,
		65,
		70,
		45,
		38,
		32,
		66,
		63,
		30,
		38,
		30,
		19,
		33,
		41,
		45,
		54,
		63,
		69,
		93,
		93,
		99,
		-1,
		-1,
		116,
		106,
		90,
		92,
		89,
		59,
		66,
		98,
		70,
		83,
		-1,
		37,
		-1,
		26,
		22,
		15,
		21,
		33,
		19,
		24,
		35,
		47,
		60,
		56,
		63,
		98,
		98,
		83,
		103,
		106,
		-1,
		-1,
		-1,
		109,
		104,
		79,
		56,
		40,
		76,
		-1,
		53,
		54,
		-1,
		31,
		25,
		22,
		12,
		19,
		16,
		16,
		30,
		38,
		34,
		50,
		56,
		48,
		84,
		-1,
		91,
		85,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		102,
		81,
		74,
		94,
		35,
		87,
		-1,
		-1,
		38,
		31,
		-1,
		18,
		0,
		7,
		16,
		21,
		26,
		34,
		29,
		42,
		47,
		53,
		58,
		76,
		80,
		84,
		73,
		69,
		66,
		80,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		35,
		55,
		-1,
		47,
		39,
		29,
		23,
		17,
		13,
		11,
		31,
		23,
		37,
		37,
		43,
		51,
		36,
		39,
		55,
		53,
		71,
		79,
		71,
		65,
		64,
		76,
		-1,
		122,
		108,
		79,
		-1,
		-1,
		68,
		-1,
		32,
		46,
		62,
		-1,
		55,
		34,
		49,
		27,
		23,
		19,
		57,
		58,
		36,
		41,
		49,
		59,
		61,
		50,
		61,
		53,
		75,
		75,
		59,
		60,
		69,
		-1,
		128,
		115,
		73,
		69,
		58,
		78,
		29,
		17,
		49,
		-1,
		-1,
		91,
		-1,
		25,
		42,
		33,
		31,
		47,
		38,
		44,
		60,
		63,
		65,
		55,
		44,
		50,
		47,
		69,
		55,
		53,
		72,
		88,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		44,
		31,
		25,
		-1,
		66,
		-1,
		69,
		59,
		43,
		28,
		61,
		-1,
		55,
		39,
		44,
		-1,
		90,
		-1,
		63,
		65,
		59,
		44,
		41,
		52,
		50,
		61,
		78,
		-1,
		78,
		63,
		56,
		46,
		60,
		31,
		-1,
		86,
		-1,
		-1,
		56,
		50,
		50,
		34,
		37,
		71,
		51,
		45,
		44,
		85,
		85,
		71,
		57,
		50,
		47,
		44,
		57,
		77,
		68,
		80,
		-1,
		-1,
		-1,
		83,
		69,
		73,
		33,
		52,
		-1,
		-1,
		118,
		73,
		59,
		-1,
		43,
		88,
		76,
		66,
		56,
		90,
		91,
		76,
		69,
		55,
		57,
		55,
		53,
		58,
		79,
		80,
		93,
		-1,
		-1,
		66,
		71,
		59,
		45,
		64,
		-1,
		-1,
		-1,
		65,
		81,
		73,
		44,
		77,
		-1,
		-1,
		68,
		66,
		76,
		72,
		59,
		79,
		82,
		68,
		52,
		67,
		79,
		87,
		92,
		-1,
		69,
		56,
		-1,
		-1,
		67,
		61,
		-1,
		-1,
		-1,
		-1,
		98,
		64,
		76,
		97,
		113,
		71,
		-1,
		76,
		77,
		63,
		77,
		84,
		70,
		65,
		59,
		62,
		80,
		97,
		-1,
		-1,
		81,
		-1,
		76,
		-1,
		-1,
		-1,
		-1,
		55,
		69,
		90,
		95,
		99,
		-1,
		85,
		79,
		65,
		82,
		83,
		80,
		71,
		63,
		68,
		65,
		78,
		92,
		96,
		104,
		-1,
		87,
		-1,
		-1,
		-1,
		73,
		88,
		141,
		118,
		91,
		86,
		79,
		73,
		73,
		89,
		91,
		102,
		70,
		66,
		67,
		71,
		70,
		87,
		97,
		-1,
		-1,
		87,
		104,
		99,
		81,
		85,
		168,
		-1,
		-1,
		95,
		86,
		77,
		80,
		83,
		86,
		76,
		73,
		78,
		83,
		71,
		80,
		98,
		102,
		-1,
		-1,
		-1,
		107,
		-1,
		122,
		-1,
		-1,
		100,
		166,
		113,
		95,
		91,
		89,
		82,
		91,
		86,
		81,
		91,
		100,
		92,
		73,
		84,
		107,
		96,
		134,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		136,
		111,
		126,
		172,
		120,
		127,
		128,
		125,
		-1,
		95,
		120,
		92,
		99,
		91,
		99,
		99,
		96,
		74,
		81,
		97,
		96,
		91,
		126,
		118,
		124,
		-1,
		-1,
		219,
		208,
		197,
		203,
		-1,
		142,
		128,
		158,
		148,
		137,
		-1,
		-1,
		144,
		141,
		117,
		101,
		105,
		98,
		93,
		103,
		83,
		70,
		74,
		78,
		84,
		89,
		94,
		100,
		115,
		130,
		-1,
		114,
		195,
		188,
		171,
		179,
		210,
		-1,
		145,
		154,
		135,
		140,
		147,
		-1,
		-1,
		117,
		114,
		119,
		108,
		105,
		113,
		108,
		99,
		84,
		90,
		77,
		76,
		94,
		98,
		107,
		114,
		104,
		117,
		121,
		-1,
		128,
		171,
		165,
		168,
		192,
		206,
		-1,
		158,
		-1,
		-1,
		143,
		148,
		132,
		122,
		116,
		166,
		122,
		117,
		107,
		105,
		96,
		87,
		94,
		85,
		85,
		88,
		103,
		108,
		100,
		114,
		114,
		115,
		-1,
		163,
		151,
		159,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		159,
		-1,
		159,
		-1,
		134,
		138,
		130,
		133,
		121,
		108,
		100,
		92,
		108,
		83,
		93,
		89,
		90,
		99,
		110,
		122,
		121,
		122,
		236,
		192,
		159,
		150,
		197,
		212,
		216,
		-1,
		171,
		210,
		197,
		-1,
		168,
		-1,
		-1,
		-1,
		148,
		143,
		135,
		141,
		120,
		120,
		94,
		98,
		88,
		95,
		105,
		107,
		99,
		103,
		116,
		127,
		130,
		232,
		223,
		236,
		181,
		164,
		182,
		191,
		212,
		186,
		177,
		204,
		204,
		193,
		188,
		175,
		-1,
		-1,
		171,
		153,
		-1,
		-1,
		127,
		115,
		98,
		99,
		95,
		98,
		113,
		116,
		106,
		104,
		98,
		130,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		183,
		-1,
		-1,
		189,
		205,
		205,
		209,
		225,
		250,
		-1,
		178,
		-1,
		-1,
		172,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		103,
		114,
		124,
		112,
		113,
		103,
		113,
		126,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		239,
		-1,
		-1,
		194,
		183,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		130,
		132,
		121,
		115,
		109,
		116,
		115,
		123,
		131,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		189,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		123,
		127,
		119,
		112,
		107,
		118,
		110,
		114,
		131,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		113,
		124,
		113,
		116,
		130,
		125,
		-1,
		-1,
		192,
		195,
		-1,
		-1,
		200,
		202,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		117,
		123,
		126,
		115,
		119,
		131,
		-1,
		-1,
		199,
		200,
		205,
		-1,
		185,
		-1,
		203,
		-1,
		170,
		176,
		164,
		-1,
		-1,
		-1,
		158,
		121,
		142,
		152,
		146,
		144,
		135,
		121,
		128,
		126,
		122,
		133,
		-1,
		-1,
		-1,
		203,
		177,
		210,
		201,
		184,
		164,
		156,
		175,
		-1,
		145,
		-1,
		120,
		122,
		148,
		151,
		157,
		151,
		124,
		139,
		129,
		120,
		129,
		209,
		-1,
		179,
		212,
		176,
		170,
		146,
		150,
		166,
		-1,
		142,
		124,
		-1,
		152,
		142,
		173,
		158,
		139,
		126,
		133,
		133,
		126,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		151,
		142,
		-1,
		154,
		136,
		115,
		132,
		132,
		123,
		131,
		163,
		159,
		146,
		146,
		138,
		-1,
		282,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		170,
		143,
		131,
		137,
		133,
		119,
		125,
		127,
		135,
		133,
		130,
		142,
		138,
		158,
		139,
		174,
		-1,
		277,
		-1,
		211,
		-1,
		-1,
		193,
		173,
		165,
		154,
		143,
		141,
		132,
		123,
		145,
		161,
		145,
		143,
		146,
		147,
		-1,
		266,
		265,
		-1,
		212,
		204,
		190,
		-1,
		183,
		-1,
		189,
		150,
		-1,
		152,
		132,
		-1,
		154,
		150,
		-1,
		-1,
		253,
		228,
		-1,
		-1,
		-1,
		213,
		193,
		184,
		168,
		-1,
		143,
		143,
		-1,
		-1,
		-1,
		238,
		237,
		-1,
		206,
		209,
		-1,
		199,
		190,
		198,
		145,
		149,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		221,
		219,
		214,
		211,
		197,
		181,
		159,
		148,
		169,
		-1,
		-1,
		-1,
		219,
		211,
		204,
		-1,
		-1,
		206,
		189,
		170,
		168,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		196,
		-1,
		-1,
		202,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		230,
		-1,
		-1,
		-1,
		192,
		188,
		189,
		-1,
		-1,
		-1,
		-1,
		252,
		253,
		276,
		240,
		-1,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		255,
		253,
		-1,
		-1,
		-1,
		212,
		196,
		-1,
		182,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		217,
		-1,
		217,
		192,
		199,
		-1,
		-1,
		-1,
		-1,
		230,
		222,
		230,
		-1,
		202,
		204,
		-1,
		252,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		207,
		214,
		236,
		239,
		275,
		-1,
		226
	],
	[
		-1,
		161,
		150,
		161,
		169,
		142,
		149,
		-1,
		170,
		172,
		138,
		132,
		171,
		142,
		148,
		159,
		-1,
		-1,
		-1,
		161,
		160,
		130,
		128,
		137,
		142,
		149,
		-1,
		153,
		-1,
		182,
		161,
		172,
		177,
		123,
		120,
		140,
		159,
		146,
		138,
		197,
		153,
		124,
		118,
		136,
		131,
		140,
		132,
		-1,
		124,
		114,
		136,
		120,
		131,
		123,
		-1,
		-1,
		118,
		119,
		125,
		116,
		122,
		118,
		-1,
		128,
		112,
		-1,
		-1,
		108,
		114,
		98,
		101,
		109,
		107,
		120,
		112,
		107,
		-1,
		-1,
		104,
		100,
		107,
		94,
		90,
		107,
		120,
		102,
		116,
		115,
		-1,
		97,
		115,
		124,
		101,
		99,
		83,
		81,
		99,
		101,
		107,
		110,
		-1,
		106,
		107,
		102,
		110,
		115,
		99,
		86,
		86,
		96,
		89,
		108,
		99,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		105,
		89,
		106,
		98,
		88,
		103,
		96,
		89,
		86,
		84,
		81,
		97,
		98,
		108,
		-1,
		-1,
		161,
		130,
		165,
		122,
		107,
		-1,
		101,
		82,
		88,
		92,
		86,
		79,
		93,
		89,
		-1,
		75,
		74,
		105,
		91,
		102,
		121,
		-1,
		-1,
		119,
		111,
		96,
		99,
		96,
		96,
		97,
		96,
		88,
		74,
		70,
		76,
		79,
		79,
		85,
		69,
		79,
		83,
		92,
		109,
		-1,
		-1,
		162,
		-1,
		-1,
		118,
		101,
		-1,
		84,
		91,
		91,
		108,
		98,
		119,
		107,
		98,
		90,
		84,
		72,
		74,
		71,
		84,
		72,
		66,
		91,
		95,
		87,
		108,
		103,
		-1,
		161,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		77,
		80,
		86,
		110,
		120,
		-1,
		110,
		107,
		108,
		93,
		90,
		77,
		65,
		78,
		63,
		70,
		69,
		73,
		75,
		108,
		84,
		106,
		103,
		132,
		137,
		131,
		140,
		-1,
		126,
		122,
		118,
		125,
		74,
		-1,
		-1,
		114,
		-1,
		128,
		127,
		102,
		104,
		107,
		94,
		85,
		72,
		61,
		72,
		61,
		58,
		66,
		73,
		86,
		79,
		78,
		96,
		111,
		124,
		128,
		134,
		-1,
		176,
		-1,
		118,
		102,
		104,
		76,
		97,
		-1,
		134,
		129,
		119,
		104,
		95,
		-1,
		98,
		100,
		90,
		68,
		53,
		70,
		62,
		60,
		65,
		68,
		82,
		73,
		91,
		98,
		106,
		110,
		130,
		142,
		136,
		126,
		-1,
		108,
		113,
		72,
		80,
		99,
		137,
		101,
		-1,
		96,
		-1,
		88,
		113,
		-1,
		74,
		70,
		52,
		53,
		48,
		63,
		67,
		64,
		61,
		79,
		82,
		99,
		103,
		119,
		-1,
		-1,
		121,
		125,
		114,
		65,
		84,
		108,
		145,
		94,
		83,
		82,
		-1,
		73,
		82,
		79,
		65,
		52,
		45,
		46,
		52,
		65,
		44,
		63,
		66,
		88,
		116,
		94,
		106,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		91,
		62,
		86,
		128,
		112,
		105,
		93,
		58,
		58,
		52,
		-1,
		72,
		55,
		54,
		43,
		41,
		53,
		45,
		63,
		67,
		68,
		85,
		97,
		88,
		108,
		-1,
		-1,
		-1,
		121,
		110,
		111,
		57,
		80,
		117,
		91,
		77,
		82,
		57,
		50,
		44,
		75,
		72,
		39,
		50,
		39,
		31,
		41,
		49,
		53,
		66,
		75,
		79,
		103,
		101,
		107,
		-1,
		-1,
		128,
		118,
		102,
		104,
		101,
		71,
		78,
		110,
		82,
		95,
		-1,
		49,
		-1,
		38,
		23,
		27,
		28,
		38,
		27,
		32,
		46,
		55,
		70,
		68,
		75,
		108,
		108,
		91,
		111,
		114,
		-1,
		-1,
		-1,
		121,
		116,
		91,
		68,
		52,
		88,
		-1,
		65,
		66,
		-1,
		43,
		37,
		26,
		24,
		31,
		21,
		20,
		38,
		46,
		42,
		61,
		64,
		60,
		96,
		-1,
		99,
		93,
		101,
		91,
		79,
		-1,
		-1,
		-1,
		114,
		93,
		86,
		106,
		47,
		99,
		-1,
		-1,
		50,
		43,
		-1,
		28,
		12,
		0,
		9,
		22,
		31,
		34,
		37,
		50,
		55,
		65,
		66,
		84,
		88,
		92,
		81,
		77,
		74,
		88,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		47,
		67,
		-1,
		59,
		51,
		41,
		35,
		29,
		17,
		15,
		24,
		16,
		37,
		37,
		45,
		51,
		44,
		47,
		63,
		61,
		79,
		87,
		79,
		73,
		72,
		84,
		-1,
		134,
		120,
		91,
		-1,
		-1,
		80,
		-1,
		44,
		58,
		74,
		-1,
		67,
		46,
		58,
		39,
		27,
		12,
		57,
		58,
		36,
		41,
		49,
		59,
		69,
		58,
		69,
		61,
		83,
		83,
		67,
		68,
		77,
		-1,
		140,
		127,
		85,
		81,
		70,
		90,
		41,
		29,
		61,
		-1,
		-1,
		103,
		-1,
		37,
		54,
		26,
		24,
		47,
		38,
		44,
		60,
		63,
		73,
		63,
		52,
		58,
		55,
		77,
		63,
		61,
		80,
		96,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		56,
		43,
		37,
		-1,
		78,
		-1,
		81,
		71,
		55,
		40,
		73,
		-1,
		55,
		39,
		44,
		-1,
		98,
		-1,
		71,
		73,
		67,
		52,
		49,
		60,
		58,
		69,
		86,
		-1,
		90,
		75,
		68,
		58,
		72,
		43,
		-1,
		98,
		-1,
		-1,
		68,
		62,
		62,
		46,
		49,
		71,
		51,
		45,
		44,
		93,
		90,
		79,
		65,
		58,
		55,
		52,
		65,
		85,
		76,
		88,
		-1,
		-1,
		-1,
		95,
		81,
		85,
		45,
		64,
		-1,
		-1,
		130,
		85,
		71,
		-1,
		55,
		88,
		76,
		66,
		56,
		90,
		91,
		81,
		77,
		63,
		65,
		63,
		61,
		66,
		87,
		88,
		101,
		-1,
		-1,
		78,
		83,
		71,
		57,
		76,
		-1,
		-1,
		-1,
		77,
		93,
		85,
		56,
		77,
		-1,
		-1,
		68,
		66,
		76,
		80,
		67,
		87,
		90,
		76,
		60,
		75,
		87,
		95,
		100,
		-1,
		81,
		68,
		-1,
		-1,
		79,
		73,
		-1,
		-1,
		-1,
		-1,
		110,
		76,
		88,
		109,
		121,
		71,
		-1,
		76,
		77,
		71,
		85,
		92,
		78,
		73,
		67,
		70,
		88,
		105,
		-1,
		-1,
		93,
		-1,
		88,
		-1,
		-1,
		-1,
		-1,
		67,
		81,
		102,
		103,
		107,
		-1,
		85,
		85,
		73,
		90,
		91,
		88,
		79,
		71,
		76,
		73,
		86,
		100,
		104,
		116,
		-1,
		99,
		-1,
		-1,
		-1,
		85,
		100,
		149,
		126,
		99,
		94,
		87,
		81,
		81,
		97,
		99,
		110,
		78,
		74,
		75,
		79,
		78,
		95,
		105,
		-1,
		-1,
		99,
		116,
		111,
		93,
		97,
		176,
		-1,
		-1,
		103,
		94,
		85,
		88,
		91,
		94,
		84,
		81,
		86,
		91,
		79,
		88,
		106,
		110,
		-1,
		-1,
		-1,
		119,
		-1,
		134,
		-1,
		-1,
		112,
		174,
		121,
		103,
		99,
		97,
		90,
		99,
		94,
		89,
		99,
		109,
		101,
		81,
		94,
		116,
		106,
		142,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		148,
		123,
		138,
		184,
		132,
		139,
		136,
		133,
		-1,
		103,
		128,
		100,
		107,
		99,
		107,
		107,
		105,
		84,
		91,
		107,
		106,
		101,
		134,
		128,
		134,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		154,
		140,
		170,
		160,
		149,
		-1,
		-1,
		152,
		149,
		125,
		109,
		113,
		106,
		101,
		113,
		93,
		80,
		84,
		88,
		94,
		99,
		104,
		110,
		125,
		140,
		-1,
		126,
		207,
		200,
		183,
		191,
		222,
		-1,
		157,
		166,
		147,
		152,
		155,
		-1,
		-1,
		125,
		122,
		127,
		116,
		113,
		123,
		118,
		109,
		94,
		100,
		87,
		86,
		104,
		108,
		117,
		124,
		114,
		127,
		131,
		-1,
		140,
		183,
		177,
		180,
		204,
		218,
		-1,
		170,
		-1,
		-1,
		155,
		156,
		140,
		130,
		124,
		174,
		130,
		125,
		117,
		115,
		106,
		97,
		104,
		95,
		95,
		98,
		113,
		118,
		110,
		124,
		124,
		125,
		-1,
		175,
		163,
		171,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		171,
		-1,
		167,
		-1,
		142,
		146,
		138,
		141,
		131,
		118,
		110,
		102,
		118,
		93,
		103,
		99,
		100,
		109,
		120,
		132,
		131,
		132,
		244,
		200,
		171,
		162,
		209,
		224,
		228,
		-1,
		183,
		222,
		209,
		-1,
		180,
		-1,
		-1,
		-1,
		156,
		151,
		143,
		151,
		130,
		130,
		104,
		108,
		98,
		105,
		115,
		117,
		109,
		113,
		126,
		137,
		140,
		240,
		231,
		244,
		189,
		176,
		194,
		203,
		224,
		198,
		189,
		216,
		216,
		205,
		200,
		187,
		-1,
		-1,
		179,
		161,
		-1,
		-1,
		137,
		125,
		108,
		109,
		105,
		108,
		123,
		126,
		116,
		114,
		108,
		140,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		195,
		-1,
		-1,
		201,
		217,
		213,
		217,
		233,
		258,
		-1,
		190,
		-1,
		-1,
		182,
		-1,
		-1,
		167,
		130,
		119,
		110,
		116,
		113,
		124,
		134,
		122,
		123,
		113,
		123,
		136,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		189,
		187,
		193,
		200,
		217,
		247,
		-1,
		-1,
		206,
		193,
		-1,
		-1,
		165,
		163,
		152,
		-1,
		142,
		115,
		120,
		140,
		142,
		131,
		125,
		119,
		126,
		125,
		133,
		141,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		203,
		199,
		-1,
		-1,
		160,
		153,
		141,
		129,
		119,
		129,
		133,
		137,
		129,
		122,
		117,
		128,
		120,
		124,
		141,
		-1,
		260,
		-1,
		212,
		188,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		220,
		206,
		199,
		187,
		185,
		-1,
		194,
		178,
		159,
		-1,
		129,
		142,
		173,
		141,
		146,
		141,
		123,
		134,
		123,
		126,
		140,
		135,
		-1,
		-1,
		200,
		203,
		-1,
		-1,
		210,
		212,
		-1,
		211,
		200,
		185,
		177,
		-1,
		-1,
		166,
		162,
		-1,
		-1,
		130,
		155,
		144,
		152,
		147,
		127,
		133,
		136,
		125,
		129,
		141,
		-1,
		-1,
		207,
		208,
		213,
		-1,
		195,
		-1,
		213,
		-1,
		180,
		186,
		174,
		-1,
		-1,
		-1,
		168,
		131,
		152,
		162,
		156,
		154,
		145,
		131,
		138,
		136,
		132,
		143,
		-1,
		-1,
		-1,
		213,
		187,
		220,
		211,
		194,
		174,
		166,
		185,
		-1,
		155,
		-1,
		130,
		132,
		158,
		161,
		167,
		161,
		134,
		149,
		139,
		130,
		139,
		219,
		-1,
		189,
		222,
		186,
		180,
		156,
		160,
		176,
		-1,
		152,
		134,
		-1,
		162,
		152,
		183,
		168,
		149,
		136,
		143,
		143,
		136,
		-1,
		-1,
		-1,
		191,
		190,
		182,
		176,
		176,
		161,
		152,
		-1,
		164,
		146,
		125,
		142,
		142,
		133,
		141,
		173,
		169,
		156,
		156,
		148,
		-1,
		292,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		185,
		180,
		153,
		141,
		147,
		143,
		129,
		135,
		137,
		145,
		143,
		140,
		152,
		148,
		168,
		149,
		184,
		-1,
		287,
		-1,
		221,
		-1,
		-1,
		203,
		183,
		175,
		164,
		153,
		151,
		142,
		133,
		155,
		171,
		155,
		153,
		156,
		157,
		-1,
		276,
		275,
		-1,
		222,
		214,
		200,
		-1,
		193,
		-1,
		199,
		160,
		-1,
		162,
		142,
		-1,
		164,
		160,
		-1,
		-1,
		263,
		238,
		-1,
		-1,
		-1,
		223,
		203,
		194,
		178,
		-1,
		153,
		153,
		-1,
		-1,
		-1,
		248,
		247,
		-1,
		216,
		219,
		-1,
		209,
		200,
		208,
		155,
		159,
		-1,
		-1,
		-1,
		257,
		238,
		232,
		231,
		229,
		224,
		221,
		207,
		191,
		169,
		158,
		179,
		-1,
		-1,
		-1,
		229,
		221,
		214,
		-1,
		-1,
		216,
		199,
		180,
		178,
		-1,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		206,
		-1,
		-1,
		212,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		240,
		-1,
		-1,
		-1,
		202,
		198,
		199,
		-1,
		-1,
		-1,
		-1,
		262,
		263,
		286,
		250,
		-1,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		265,
		263,
		-1,
		-1,
		-1,
		222,
		206,
		-1,
		192,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		227,
		-1,
		227,
		202,
		209,
		-1,
		-1,
		-1,
		-1,
		240,
		232,
		240,
		-1,
		212,
		214,
		-1,
		262,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		217,
		224,
		246,
		249,
		285,
		-1,
		236
	],
	[
		-1,
		158,
		147,
		158,
		166,
		139,
		146,
		-1,
		167,
		169,
		135,
		129,
		168,
		139,
		145,
		156,
		-1,
		-1,
		-1,
		158,
		157,
		127,
		125,
		134,
		139,
		146,
		-1,
		150,
		-1,
		179,
		158,
		169,
		174,
		120,
		117,
		137,
		156,
		143,
		135,
		194,
		150,
		121,
		115,
		133,
		128,
		137,
		129,
		-1,
		121,
		111,
		133,
		117,
		128,
		120,
		-1,
		-1,
		115,
		116,
		122,
		113,
		119,
		115,
		-1,
		125,
		109,
		-1,
		-1,
		105,
		111,
		95,
		98,
		106,
		104,
		117,
		109,
		104,
		-1,
		-1,
		101,
		97,
		104,
		91,
		87,
		104,
		117,
		99,
		113,
		112,
		-1,
		94,
		112,
		121,
		98,
		96,
		80,
		78,
		96,
		98,
		104,
		107,
		-1,
		103,
		104,
		99,
		107,
		112,
		96,
		83,
		83,
		93,
		86,
		105,
		96,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		103,
		86,
		103,
		95,
		85,
		100,
		93,
		86,
		83,
		81,
		78,
		94,
		95,
		105,
		-1,
		-1,
		167,
		136,
		171,
		128,
		113,
		-1,
		99,
		79,
		85,
		89,
		83,
		76,
		90,
		86,
		-1,
		72,
		71,
		102,
		88,
		99,
		127,
		-1,
		-1,
		125,
		117,
		102,
		105,
		102,
		102,
		94,
		93,
		85,
		71,
		67,
		73,
		76,
		76,
		82,
		66,
		76,
		80,
		86,
		106,
		-1,
		-1,
		156,
		-1,
		-1,
		124,
		107,
		-1,
		90,
		97,
		97,
		114,
		104,
		125,
		104,
		95,
		87,
		81,
		69,
		71,
		68,
		81,
		69,
		63,
		88,
		92,
		81,
		102,
		97,
		-1,
		155,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		83,
		86,
		92,
		116,
		126,
		-1,
		116,
		104,
		105,
		90,
		87,
		74,
		62,
		75,
		60,
		67,
		66,
		70,
		72,
		103,
		78,
		100,
		97,
		126,
		131,
		125,
		134,
		-1,
		132,
		128,
		124,
		131,
		80,
		-1,
		-1,
		120,
		-1,
		134,
		133,
		108,
		101,
		104,
		91,
		82,
		69,
		58,
		69,
		58,
		55,
		63,
		67,
		82,
		73,
		72,
		90,
		105,
		118,
		122,
		128,
		-1,
		182,
		-1,
		124,
		108,
		110,
		82,
		103,
		-1,
		140,
		135,
		125,
		110,
		101,
		-1,
		100,
		97,
		87,
		65,
		50,
		67,
		59,
		57,
		62,
		62,
		76,
		67,
		85,
		92,
		100,
		104,
		124,
		136,
		142,
		132,
		-1,
		114,
		119,
		78,
		86,
		105,
		143,
		107,
		-1,
		102,
		-1,
		94,
		115,
		-1,
		71,
		67,
		49,
		50,
		45,
		60,
		61,
		58,
		55,
		73,
		76,
		93,
		97,
		113,
		-1,
		-1,
		127,
		131,
		120,
		71,
		90,
		114,
		151,
		100,
		89,
		88,
		-1,
		79,
		79,
		76,
		62,
		49,
		42,
		43,
		46,
		59,
		38,
		57,
		60,
		82,
		110,
		88,
		100,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		97,
		68,
		92,
		134,
		118,
		111,
		99,
		64,
		64,
		58,
		-1,
		69,
		52,
		49,
		40,
		35,
		47,
		39,
		57,
		61,
		63,
		79,
		91,
		82,
		102,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		63,
		86,
		123,
		97,
		83,
		88,
		63,
		56,
		50,
		72,
		69,
		36,
		47,
		33,
		28,
		35,
		43,
		47,
		63,
		72,
		73,
		97,
		95,
		101,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		77,
		84,
		116,
		88,
		101,
		-1,
		55,
		-1,
		44,
		31,
		29,
		22,
		32,
		21,
		26,
		40,
		49,
		64,
		65,
		72,
		102,
		102,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		127,
		122,
		97,
		74,
		58,
		94,
		-1,
		71,
		72,
		-1,
		49,
		43,
		34,
		30,
		27,
		15,
		14,
		32,
		40,
		36,
		55,
		58,
		57,
		90,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		53,
		105,
		-1,
		-1,
		56,
		49,
		-1,
		36,
		18,
		8,
		0,
		16,
		25,
		28,
		31,
		44,
		49,
		62,
		60,
		78,
		82,
		86,
		75,
		71,
		68,
		82,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		73,
		-1,
		65,
		57,
		47,
		41,
		35,
		25,
		23,
		30,
		14,
		31,
		31,
		39,
		45,
		38,
		41,
		57,
		55,
		73,
		81,
		73,
		67,
		66,
		78,
		-1,
		140,
		126,
		97,
		-1,
		-1,
		86,
		-1,
		50,
		64,
		80,
		-1,
		73,
		52,
		66,
		45,
		35,
		20,
		51,
		52,
		30,
		35,
		43,
		53,
		63,
		52,
		63,
		55,
		77,
		77,
		61,
		62,
		71,
		-1,
		146,
		133,
		91,
		87,
		76,
		96,
		47,
		35,
		67,
		-1,
		-1,
		109,
		-1,
		43,
		60,
		34,
		32,
		41,
		32,
		38,
		54,
		57,
		67,
		57,
		46,
		52,
		49,
		71,
		57,
		55,
		74,
		90,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		62,
		49,
		43,
		-1,
		84,
		-1,
		87,
		77,
		61,
		46,
		79,
		-1,
		49,
		33,
		38,
		-1,
		92,
		-1,
		65,
		67,
		61,
		46,
		43,
		54,
		52,
		63,
		80,
		-1,
		96,
		81,
		74,
		64,
		78,
		49,
		-1,
		104,
		-1,
		-1,
		74,
		68,
		68,
		52,
		55,
		65,
		45,
		39,
		38,
		87,
		84,
		73,
		59,
		52,
		49,
		46,
		59,
		79,
		70,
		82,
		-1,
		-1,
		-1,
		101,
		87,
		91,
		51,
		70,
		-1,
		-1,
		136,
		91,
		77,
		-1,
		61,
		82,
		70,
		60,
		50,
		84,
		85,
		75,
		71,
		57,
		59,
		57,
		55,
		60,
		81,
		82,
		95,
		-1,
		-1,
		84,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		83,
		99,
		91,
		62,
		71,
		-1,
		-1,
		62,
		60,
		70,
		74,
		61,
		81,
		84,
		70,
		54,
		69,
		81,
		89,
		94,
		-1,
		87,
		74,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		116,
		82,
		94,
		111,
		115,
		65,
		-1,
		70,
		71,
		65,
		79,
		86,
		72,
		67,
		61,
		64,
		82,
		99,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		73,
		87,
		104,
		97,
		101,
		-1,
		79,
		79,
		67,
		84,
		85,
		82,
		73,
		65,
		70,
		67,
		80,
		94,
		98,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		91,
		106,
		143,
		120,
		93,
		88,
		81,
		75,
		75,
		91,
		93,
		104,
		72,
		68,
		69,
		73,
		72,
		89,
		99,
		-1,
		-1,
		105,
		122,
		117,
		99,
		103,
		170,
		-1,
		-1,
		97,
		88,
		79,
		82,
		85,
		88,
		78,
		75,
		80,
		85,
		73,
		82,
		100,
		104,
		-1,
		-1,
		-1,
		125,
		-1,
		140,
		-1,
		-1,
		118,
		168,
		115,
		97,
		93,
		91,
		84,
		93,
		88,
		83,
		93,
		103,
		95,
		75,
		88,
		110,
		100,
		136,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		154,
		129,
		144,
		179,
		138,
		145,
		130,
		127,
		-1,
		97,
		122,
		94,
		101,
		93,
		101,
		101,
		99,
		78,
		85,
		101,
		100,
		95,
		128,
		122,
		128,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		160,
		146,
		165,
		155,
		155,
		-1,
		-1,
		146,
		143,
		119,
		103,
		107,
		100,
		95,
		107,
		87,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		132,
		213,
		206,
		189,
		197,
		228,
		-1,
		163,
		161,
		153,
		147,
		149,
		-1,
		-1,
		119,
		116,
		121,
		110,
		107,
		117,
		112,
		103,
		88,
		94,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		146,
		189,
		183,
		186,
		210,
		224,
		-1,
		166,
		-1,
		-1,
		161,
		150,
		134,
		124,
		118,
		168,
		124,
		119,
		111,
		109,
		100,
		91,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		181,
		169,
		177,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		177,
		-1,
		161,
		-1,
		136,
		140,
		132,
		135,
		125,
		112,
		104,
		96,
		112,
		87,
		97,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		238,
		194,
		177,
		168,
		215,
		230,
		234,
		-1,
		178,
		217,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		150,
		145,
		137,
		145,
		124,
		124,
		98,
		102,
		92,
		99,
		109,
		111,
		103,
		107,
		120,
		131,
		134,
		234,
		225,
		238,
		183,
		182,
		200,
		209,
		230,
		193,
		184,
		211,
		222,
		211,
		206,
		193,
		-1,
		-1,
		173,
		155,
		-1,
		-1,
		131,
		119,
		102,
		103,
		99,
		102,
		117,
		120,
		110,
		108,
		102,
		134,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		212,
		207,
		211,
		227,
		252,
		-1,
		191,
		-1,
		-1,
		176,
		-1,
		-1,
		161,
		124,
		113,
		104,
		110,
		107,
		118,
		128,
		116,
		117,
		107,
		117,
		130,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		241,
		-1,
		-1,
		207,
		187,
		-1,
		-1,
		159,
		157,
		146,
		-1,
		136,
		109,
		114,
		134,
		136,
		125,
		119,
		113,
		120,
		119,
		127,
		135,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		197,
		193,
		-1,
		-1,
		154,
		147,
		135,
		123,
		113,
		123,
		127,
		131,
		123,
		116,
		111,
		122,
		114,
		118,
		135,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		214,
		200,
		193,
		181,
		179,
		-1,
		188,
		172,
		153,
		-1,
		123,
		136,
		167,
		135,
		140,
		135,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		194,
		197,
		-1,
		-1,
		204,
		206,
		-1,
		205,
		194,
		179,
		171,
		-1,
		-1,
		160,
		156,
		-1,
		-1,
		124,
		149,
		138,
		146,
		141,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		201,
		202,
		207,
		-1,
		189,
		-1,
		207,
		-1,
		174,
		180,
		168,
		-1,
		-1,
		-1,
		162,
		125,
		146,
		156,
		150,
		148,
		139,
		125,
		132,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		207,
		181,
		214,
		205,
		188,
		168,
		160,
		179,
		-1,
		149,
		-1,
		124,
		126,
		152,
		155,
		161,
		155,
		128,
		143,
		133,
		124,
		133,
		213,
		-1,
		183,
		216,
		180,
		174,
		150,
		154,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		177,
		162,
		143,
		130,
		137,
		137,
		130,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		170,
		155,
		146,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		167,
		163,
		150,
		150,
		142,
		-1,
		286,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		174,
		147,
		135,
		141,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		143,
		178,
		-1,
		281,
		-1,
		215,
		-1,
		-1,
		197,
		177,
		169,
		158,
		147,
		145,
		136,
		127,
		149,
		165,
		149,
		147,
		150,
		151,
		-1,
		270,
		269,
		-1,
		216,
		208,
		194,
		-1,
		187,
		-1,
		193,
		154,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		257,
		232,
		-1,
		-1,
		-1,
		217,
		197,
		188,
		172,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		242,
		241,
		-1,
		210,
		213,
		-1,
		203,
		194,
		202,
		149,
		153,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		225,
		223,
		218,
		215,
		201,
		185,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		223,
		215,
		208,
		-1,
		-1,
		210,
		193,
		174,
		172,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		200,
		-1,
		-1,
		206,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		234,
		-1,
		-1,
		-1,
		196,
		192,
		193,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		280,
		244,
		-1,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		216,
		200,
		-1,
		186,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		221,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		234,
		226,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		211,
		218,
		240,
		243,
		279,
		-1,
		230
	],
	[
		-1,
		154,
		143,
		154,
		162,
		135,
		142,
		-1,
		163,
		165,
		131,
		125,
		164,
		135,
		141,
		152,
		-1,
		-1,
		-1,
		154,
		153,
		123,
		121,
		130,
		135,
		142,
		-1,
		146,
		-1,
		175,
		154,
		165,
		170,
		116,
		113,
		133,
		152,
		139,
		131,
		190,
		146,
		117,
		111,
		129,
		124,
		133,
		125,
		-1,
		117,
		107,
		129,
		113,
		124,
		116,
		-1,
		-1,
		111,
		112,
		118,
		109,
		115,
		111,
		-1,
		121,
		105,
		-1,
		-1,
		101,
		107,
		91,
		94,
		102,
		100,
		113,
		105,
		100,
		-1,
		-1,
		97,
		93,
		100,
		87,
		83,
		100,
		113,
		95,
		109,
		108,
		-1,
		90,
		108,
		117,
		94,
		92,
		76,
		74,
		92,
		94,
		100,
		103,
		-1,
		99,
		100,
		95,
		103,
		108,
		92,
		79,
		79,
		89,
		82,
		101,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		99,
		82,
		99,
		91,
		81,
		96,
		89,
		82,
		79,
		77,
		74,
		90,
		91,
		101,
		-1,
		-1,
		178,
		147,
		182,
		139,
		124,
		-1,
		95,
		75,
		81,
		85,
		79,
		72,
		86,
		82,
		-1,
		68,
		67,
		98,
		84,
		95,
		138,
		-1,
		-1,
		136,
		128,
		113,
		116,
		105,
		101,
		90,
		89,
		81,
		67,
		63,
		69,
		72,
		72,
		78,
		62,
		72,
		76,
		86,
		102,
		-1,
		-1,
		156,
		-1,
		-1,
		135,
		118,
		-1,
		101,
		108,
		108,
		117,
		103,
		124,
		100,
		91,
		83,
		77,
		65,
		67,
		64,
		77,
		65,
		59,
		84,
		88,
		81,
		102,
		97,
		-1,
		155,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		94,
		97,
		103,
		127,
		137,
		-1,
		112,
		100,
		101,
		86,
		83,
		70,
		58,
		71,
		56,
		63,
		62,
		66,
		68,
		101,
		78,
		100,
		97,
		126,
		131,
		125,
		134,
		-1,
		143,
		139,
		135,
		142,
		91,
		-1,
		-1,
		131,
		-1,
		145,
		144,
		119,
		97,
		100,
		87,
		78,
		65,
		54,
		65,
		54,
		51,
		59,
		67,
		79,
		73,
		72,
		90,
		105,
		118,
		122,
		128,
		-1,
		193,
		-1,
		135,
		119,
		121,
		93,
		114,
		-1,
		151,
		146,
		136,
		121,
		112,
		-1,
		96,
		93,
		83,
		61,
		46,
		63,
		55,
		53,
		58,
		62,
		76,
		67,
		85,
		92,
		100,
		104,
		124,
		136,
		153,
		143,
		-1,
		125,
		130,
		89,
		97,
		116,
		154,
		118,
		-1,
		113,
		-1,
		98,
		111,
		-1,
		67,
		63,
		45,
		46,
		41,
		56,
		61,
		58,
		55,
		73,
		76,
		93,
		97,
		113,
		-1,
		-1,
		138,
		142,
		131,
		82,
		101,
		125,
		162,
		111,
		100,
		99,
		-1,
		90,
		81,
		78,
		66,
		53,
		38,
		39,
		47,
		59,
		38,
		57,
		60,
		82,
		110,
		88,
		100,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		108,
		79,
		103,
		145,
		129,
		122,
		110,
		75,
		75,
		69,
		-1,
		77,
		56,
		47,
		36,
		34,
		47,
		39,
		57,
		61,
		61,
		79,
		91,
		82,
		102,
		-1,
		-1,
		-1,
		138,
		127,
		128,
		74,
		97,
		134,
		108,
		94,
		99,
		74,
		67,
		61,
		84,
		73,
		48,
		43,
		35,
		24,
		35,
		43,
		47,
		59,
		68,
		73,
		97,
		95,
		101,
		-1,
		-1,
		145,
		135,
		119,
		121,
		118,
		88,
		95,
		127,
		99,
		112,
		-1,
		66,
		-1,
		55,
		46,
		42,
		36,
		37,
		21,
		26,
		40,
		49,
		64,
		61,
		68,
		102,
		102,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		138,
		133,
		108,
		85,
		69,
		105,
		-1,
		82,
		83,
		-1,
		60,
		54,
		49,
		41,
		40,
		20,
		19,
		23,
		40,
		35,
		54,
		56,
		53,
		89,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		131,
		110,
		103,
		123,
		64,
		116,
		-1,
		-1,
		67,
		60,
		-1,
		47,
		29,
		23,
		15,
		0,
		13,
		16,
		29,
		42,
		47,
		58,
		58,
		78,
		82,
		86,
		75,
		71,
		68,
		82,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		84,
		-1,
		76,
		68,
		58,
		52,
		46,
		40,
		38,
		37,
		21,
		17,
		19,
		27,
		33,
		36,
		39,
		55,
		55,
		73,
		81,
		73,
		67,
		66,
		78,
		-1,
		151,
		137,
		108,
		-1,
		-1,
		97,
		-1,
		61,
		75,
		91,
		-1,
		84,
		63,
		78,
		56,
		50,
		35,
		44,
		45,
		23,
		28,
		32,
		42,
		61,
		50,
		63,
		55,
		77,
		77,
		61,
		62,
		71,
		-1,
		157,
		144,
		102,
		98,
		87,
		107,
		58,
		46,
		78,
		-1,
		-1,
		120,
		-1,
		54,
		71,
		49,
		47,
		34,
		25,
		31,
		43,
		46,
		56,
		55,
		44,
		50,
		49,
		71,
		57,
		55,
		74,
		90,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		73,
		60,
		54,
		-1,
		95,
		-1,
		98,
		88,
		72,
		57,
		90,
		-1,
		42,
		26,
		31,
		-1,
		81,
		-1,
		63,
		65,
		61,
		46,
		43,
		54,
		52,
		63,
		80,
		-1,
		107,
		92,
		85,
		75,
		89,
		60,
		-1,
		115,
		-1,
		-1,
		85,
		79,
		79,
		63,
		66,
		58,
		38,
		32,
		31,
		80,
		77,
		66,
		59,
		52,
		49,
		46,
		59,
		79,
		70,
		82,
		-1,
		-1,
		-1,
		112,
		98,
		102,
		62,
		81,
		-1,
		-1,
		147,
		102,
		88,
		-1,
		72,
		75,
		63,
		53,
		43,
		77,
		78,
		68,
		71,
		57,
		59,
		57,
		55,
		60,
		81,
		82,
		95,
		-1,
		-1,
		95,
		100,
		88,
		74,
		93,
		-1,
		-1,
		-1,
		94,
		110,
		102,
		73,
		64,
		-1,
		-1,
		55,
		53,
		63,
		69,
		61,
		81,
		84,
		70,
		54,
		69,
		81,
		89,
		94,
		-1,
		98,
		85,
		-1,
		-1,
		96,
		90,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		105,
		107,
		111,
		58,
		-1,
		63,
		64,
		65,
		79,
		86,
		72,
		67,
		61,
		64,
		82,
		99,
		-1,
		-1,
		110,
		-1,
		105,
		-1,
		-1,
		-1,
		-1,
		84,
		98,
		100,
		93,
		97,
		-1,
		72,
		72,
		67,
		84,
		85,
		82,
		73,
		65,
		70,
		67,
		80,
		94,
		98,
		133,
		-1,
		116,
		-1,
		-1,
		-1,
		102,
		117,
		139,
		116,
		89,
		84,
		77,
		71,
		75,
		91,
		93,
		104,
		72,
		68,
		69,
		73,
		72,
		89,
		99,
		-1,
		-1,
		116,
		133,
		128,
		110,
		114,
		166,
		-1,
		-1,
		93,
		84,
		75,
		78,
		85,
		88,
		78,
		75,
		80,
		85,
		73,
		82,
		100,
		104,
		-1,
		-1,
		-1,
		136,
		-1,
		151,
		-1,
		-1,
		129,
		164,
		111,
		93,
		89,
		87,
		80,
		89,
		84,
		83,
		93,
		103,
		95,
		75,
		88,
		110,
		100,
		136,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		165,
		140,
		155,
		175,
		149,
		156,
		126,
		123,
		-1,
		93,
		118,
		90,
		97,
		89,
		101,
		101,
		99,
		78,
		85,
		101,
		100,
		95,
		128,
		122,
		128,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		171,
		157,
		161,
		151,
		154,
		-1,
		-1,
		142,
		139,
		115,
		99,
		103,
		96,
		91,
		107,
		87,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		143,
		224,
		217,
		200,
		208,
		239,
		-1,
		165,
		157,
		164,
		143,
		145,
		-1,
		-1,
		115,
		112,
		117,
		106,
		103,
		115,
		112,
		103,
		88,
		94,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		157,
		200,
		194,
		197,
		221,
		235,
		-1,
		162,
		-1,
		-1,
		172,
		146,
		130,
		120,
		114,
		164,
		120,
		115,
		111,
		109,
		100,
		91,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		192,
		180,
		188,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		188,
		-1,
		157,
		-1,
		132,
		136,
		128,
		131,
		125,
		112,
		104,
		96,
		112,
		87,
		97,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		234,
		190,
		188,
		179,
		215,
		230,
		234,
		-1,
		174,
		213,
		224,
		-1,
		197,
		-1,
		-1,
		-1,
		146,
		141,
		133,
		145,
		124,
		124,
		98,
		102,
		92,
		99,
		109,
		111,
		103,
		107,
		120,
		131,
		134,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		189,
		180,
		207,
		231,
		220,
		215,
		202,
		-1,
		-1,
		169,
		151,
		-1,
		-1,
		131,
		119,
		102,
		103,
		99,
		102,
		117,
		120,
		110,
		108,
		102,
		134,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		208,
		203,
		207,
		223,
		248,
		-1,
		191,
		-1,
		-1,
		176,
		-1,
		-1,
		161,
		124,
		113,
		104,
		110,
		107,
		118,
		128,
		116,
		117,
		107,
		117,
		130,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		207,
		187,
		-1,
		-1,
		159,
		157,
		146,
		-1,
		136,
		109,
		114,
		134,
		136,
		125,
		119,
		113,
		120,
		119,
		127,
		135,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		197,
		193,
		-1,
		-1,
		154,
		147,
		135,
		123,
		113,
		123,
		127,
		131,
		123,
		116,
		111,
		122,
		114,
		118,
		135,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		214,
		200,
		193,
		181,
		179,
		-1,
		188,
		172,
		153,
		-1,
		123,
		136,
		167,
		135,
		140,
		135,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		204,
		206,
		-1,
		205,
		194,
		179,
		171,
		-1,
		-1,
		160,
		156,
		-1,
		-1,
		124,
		149,
		138,
		146,
		141,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		197,
		198,
		203,
		-1,
		189,
		-1,
		207,
		-1,
		174,
		180,
		168,
		-1,
		-1,
		-1,
		162,
		125,
		146,
		156,
		150,
		148,
		139,
		125,
		132,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		207,
		181,
		214,
		205,
		188,
		168,
		160,
		179,
		-1,
		149,
		-1,
		124,
		126,
		152,
		155,
		161,
		155,
		128,
		143,
		133,
		124,
		133,
		213,
		-1,
		183,
		216,
		180,
		174,
		150,
		154,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		177,
		162,
		143,
		130,
		137,
		137,
		130,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		170,
		155,
		146,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		167,
		163,
		150,
		150,
		142,
		-1,
		286,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		174,
		147,
		135,
		141,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		143,
		178,
		-1,
		281,
		-1,
		215,
		-1,
		-1,
		197,
		177,
		169,
		158,
		147,
		145,
		136,
		127,
		149,
		165,
		149,
		147,
		150,
		151,
		-1,
		270,
		269,
		-1,
		216,
		208,
		194,
		-1,
		187,
		-1,
		193,
		154,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		257,
		232,
		-1,
		-1,
		-1,
		217,
		197,
		188,
		172,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		242,
		241,
		-1,
		210,
		213,
		-1,
		203,
		194,
		202,
		149,
		153,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		225,
		223,
		218,
		215,
		201,
		185,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		223,
		215,
		208,
		-1,
		-1,
		210,
		193,
		174,
		172,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		200,
		-1,
		-1,
		206,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		234,
		-1,
		-1,
		-1,
		196,
		192,
		193,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		280,
		244,
		-1,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		216,
		200,
		-1,
		186,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		221,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		234,
		226,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		211,
		218,
		240,
		243,
		279,
		-1,
		230
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		169,
		171,
		137,
		131,
		170,
		141,
		147,
		158,
		-1,
		-1,
		-1,
		160,
		159,
		129,
		127,
		136,
		141,
		148,
		-1,
		152,
		-1,
		181,
		160,
		171,
		176,
		122,
		119,
		139,
		158,
		145,
		137,
		196,
		152,
		123,
		117,
		135,
		130,
		139,
		131,
		-1,
		123,
		113,
		135,
		119,
		130,
		122,
		-1,
		-1,
		117,
		118,
		124,
		115,
		121,
		117,
		-1,
		127,
		111,
		-1,
		-1,
		107,
		113,
		97,
		100,
		108,
		106,
		119,
		111,
		106,
		-1,
		-1,
		103,
		99,
		106,
		93,
		89,
		106,
		119,
		101,
		115,
		114,
		-1,
		96,
		114,
		123,
		100,
		98,
		82,
		80,
		98,
		100,
		106,
		109,
		-1,
		105,
		106,
		101,
		109,
		114,
		98,
		85,
		85,
		95,
		88,
		107,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		105,
		88,
		105,
		97,
		87,
		102,
		95,
		88,
		85,
		83,
		80,
		96,
		97,
		107,
		-1,
		-1,
		186,
		155,
		190,
		147,
		132,
		-1,
		101,
		81,
		87,
		91,
		85,
		78,
		92,
		88,
		-1,
		74,
		73,
		104,
		90,
		101,
		146,
		-1,
		-1,
		144,
		136,
		121,
		124,
		111,
		107,
		96,
		95,
		87,
		73,
		69,
		75,
		78,
		78,
		84,
		68,
		78,
		82,
		88,
		108,
		-1,
		-1,
		157,
		-1,
		-1,
		143,
		126,
		-1,
		109,
		116,
		116,
		123,
		109,
		130,
		106,
		97,
		89,
		83,
		71,
		73,
		70,
		83,
		71,
		65,
		90,
		94,
		83,
		104,
		99,
		-1,
		156,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		105,
		111,
		135,
		145,
		-1,
		118,
		106,
		107,
		92,
		89,
		76,
		64,
		77,
		62,
		69,
		68,
		72,
		74,
		105,
		80,
		102,
		99,
		127,
		132,
		126,
		135,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		139,
		-1,
		153,
		152,
		127,
		103,
		106,
		93,
		84,
		71,
		60,
		71,
		60,
		57,
		65,
		69,
		84,
		75,
		74,
		92,
		107,
		119,
		123,
		129,
		-1,
		201,
		-1,
		143,
		127,
		129,
		101,
		122,
		-1,
		159,
		154,
		144,
		129,
		120,
		-1,
		102,
		99,
		89,
		67,
		52,
		69,
		61,
		59,
		64,
		64,
		78,
		69,
		87,
		94,
		101,
		105,
		125,
		137,
		161,
		151,
		-1,
		133,
		138,
		97,
		105,
		124,
		162,
		126,
		-1,
		121,
		-1,
		104,
		117,
		-1,
		73,
		69,
		51,
		52,
		47,
		62,
		63,
		60,
		57,
		75,
		78,
		94,
		98,
		114,
		-1,
		-1,
		146,
		150,
		139,
		90,
		109,
		133,
		170,
		119,
		108,
		107,
		-1,
		98,
		84,
		81,
		67,
		54,
		44,
		45,
		44,
		61,
		40,
		59,
		62,
		84,
		111,
		89,
		101,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		116,
		87,
		111,
		153,
		137,
		130,
		118,
		83,
		83,
		77,
		-1,
		78,
		57,
		47,
		42,
		33,
		46,
		41,
		59,
		63,
		61,
		80,
		92,
		83,
		103,
		-1,
		-1,
		-1,
		146,
		135,
		136,
		82,
		105,
		142,
		116,
		102,
		107,
		82,
		75,
		69,
		87,
		74,
		51,
		45,
		32,
		30,
		37,
		45,
		49,
		59,
		68,
		74,
		98,
		97,
		103,
		-1,
		-1,
		153,
		143,
		127,
		129,
		126,
		96,
		103,
		135,
		107,
		120,
		-1,
		74,
		-1,
		63,
		54,
		45,
		40,
		40,
		18,
		28,
		42,
		51,
		66,
		61,
		68,
		103,
		103,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		146,
		141,
		116,
		93,
		77,
		113,
		-1,
		90,
		91,
		-1,
		68,
		62,
		57,
		47,
		43,
		23,
		27,
		16,
		42,
		33,
		52,
		54,
		53,
		89,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		72,
		124,
		-1,
		-1,
		75,
		68,
		-1,
		55,
		37,
		31,
		23,
		17,
		0,
		14,
		27,
		40,
		45,
		58,
		56,
		80,
		84,
		88,
		77,
		73,
		70,
		84,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		92,
		-1,
		84,
		76,
		66,
		60,
		54,
		48,
		46,
		45,
		29,
		23,
		15,
		25,
		31,
		34,
		37,
		53,
		57,
		75,
		83,
		75,
		69,
		68,
		80,
		-1,
		159,
		145,
		116,
		-1,
		-1,
		105,
		-1,
		69,
		83,
		99,
		-1,
		92,
		71,
		86,
		64,
		58,
		43,
		52,
		53,
		31,
		32,
		30,
		40,
		59,
		48,
		65,
		57,
		79,
		79,
		63,
		64,
		73,
		-1,
		165,
		152,
		110,
		106,
		95,
		115,
		66,
		54,
		86,
		-1,
		-1,
		128,
		-1,
		62,
		79,
		57,
		55,
		42,
		33,
		39,
		41,
		44,
		54,
		53,
		42,
		48,
		51,
		73,
		59,
		57,
		76,
		92,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		68,
		62,
		-1,
		103,
		-1,
		106,
		96,
		80,
		65,
		98,
		-1,
		50,
		34,
		39,
		-1,
		79,
		-1,
		61,
		63,
		61,
		48,
		45,
		56,
		54,
		65,
		82,
		-1,
		115,
		100,
		93,
		83,
		97,
		68,
		-1,
		123,
		-1,
		-1,
		93,
		87,
		87,
		71,
		74,
		66,
		46,
		40,
		39,
		78,
		85,
		64,
		61,
		54,
		51,
		48,
		61,
		81,
		72,
		84,
		-1,
		-1,
		-1,
		120,
		106,
		110,
		70,
		89,
		-1,
		-1,
		155,
		110,
		96,
		-1,
		80,
		83,
		71,
		61,
		51,
		85,
		86,
		76,
		73,
		59,
		61,
		59,
		57,
		62,
		83,
		84,
		97,
		-1,
		-1,
		103,
		108,
		96,
		82,
		101,
		-1,
		-1,
		-1,
		102,
		118,
		110,
		81,
		72,
		-1,
		-1,
		63,
		61,
		71,
		76,
		63,
		83,
		86,
		72,
		56,
		71,
		83,
		91,
		96,
		-1,
		106,
		93,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		113,
		113,
		117,
		66,
		-1,
		71,
		72,
		67,
		81,
		88,
		74,
		69,
		63,
		66,
		84,
		101,
		-1,
		-1,
		118,
		-1,
		113,
		-1,
		-1,
		-1,
		-1,
		92,
		106,
		106,
		99,
		103,
		-1,
		80,
		80,
		69,
		86,
		87,
		84,
		75,
		67,
		72,
		69,
		82,
		96,
		100,
		141,
		-1,
		124,
		-1,
		-1,
		-1,
		110,
		125,
		145,
		122,
		95,
		90,
		83,
		77,
		77,
		93,
		95,
		106,
		74,
		70,
		71,
		75,
		74,
		91,
		101,
		-1,
		-1,
		124,
		141,
		136,
		118,
		122,
		172,
		-1,
		-1,
		99,
		90,
		81,
		84,
		87,
		90,
		80,
		77,
		82,
		87,
		75,
		84,
		102,
		106,
		-1,
		-1,
		-1,
		144,
		-1,
		159,
		-1,
		-1,
		137,
		170,
		117,
		99,
		95,
		93,
		86,
		95,
		90,
		85,
		95,
		105,
		97,
		77,
		90,
		112,
		102,
		138,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		173,
		148,
		163,
		181,
		157,
		164,
		132,
		129,
		-1,
		99,
		124,
		96,
		103,
		95,
		103,
		103,
		101,
		80,
		87,
		103,
		102,
		97,
		130,
		124,
		130,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		179,
		165,
		167,
		157,
		160,
		-1,
		-1,
		148,
		145,
		121,
		105,
		109,
		102,
		97,
		109,
		89,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		121,
		136,
		-1,
		151,
		232,
		225,
		208,
		216,
		247,
		-1,
		171,
		163,
		172,
		149,
		151,
		-1,
		-1,
		121,
		118,
		123,
		112,
		109,
		119,
		114,
		105,
		90,
		96,
		83,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		165,
		208,
		202,
		205,
		229,
		243,
		-1,
		168,
		-1,
		-1,
		180,
		152,
		136,
		126,
		120,
		170,
		126,
		121,
		113,
		111,
		102,
		93,
		100,
		91,
		91,
		94,
		109,
		114,
		106,
		120,
		120,
		121,
		-1,
		200,
		188,
		196,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		196,
		-1,
		163,
		-1,
		138,
		142,
		134,
		137,
		127,
		114,
		106,
		98,
		114,
		89,
		99,
		95,
		96,
		105,
		116,
		128,
		127,
		128,
		240,
		196,
		196,
		187,
		221,
		236,
		240,
		-1,
		180,
		219,
		226,
		-1,
		205,
		-1,
		-1,
		-1,
		152,
		147,
		139,
		147,
		126,
		126,
		100,
		104,
		94,
		101,
		111,
		113,
		105,
		109,
		122,
		133,
		136,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		195,
		186,
		213,
		233,
		222,
		217,
		204,
		-1,
		-1,
		175,
		157,
		-1,
		-1,
		133,
		121,
		104,
		105,
		101,
		104,
		119,
		122,
		112,
		110,
		104,
		136,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		214,
		209,
		213,
		229,
		254,
		-1,
		193,
		-1,
		-1,
		178,
		-1,
		-1,
		163,
		126,
		115,
		106,
		112,
		109,
		120,
		130,
		118,
		119,
		109,
		119,
		132,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		185,
		183,
		189,
		196,
		213,
		243,
		-1,
		-1,
		209,
		189,
		-1,
		-1,
		161,
		159,
		148,
		-1,
		138,
		111,
		116,
		136,
		138,
		127,
		121,
		115,
		122,
		121,
		129,
		137,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		199,
		195,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		129,
		133,
		125,
		118,
		113,
		124,
		116,
		120,
		137,
		-1,
		256,
		-1,
		208,
		184,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		216,
		202,
		195,
		183,
		181,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		169,
		137,
		142,
		137,
		119,
		130,
		119,
		122,
		136,
		131,
		-1,
		-1,
		196,
		199,
		-1,
		-1,
		206,
		208,
		-1,
		207,
		196,
		181,
		173,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		126,
		151,
		140,
		148,
		143,
		123,
		129,
		132,
		121,
		125,
		137,
		-1,
		-1,
		203,
		204,
		209,
		-1,
		191,
		-1,
		209,
		-1,
		176,
		182,
		170,
		-1,
		-1,
		-1,
		164,
		127,
		148,
		158,
		152,
		150,
		141,
		127,
		134,
		132,
		128,
		139,
		-1,
		-1,
		-1,
		209,
		183,
		216,
		207,
		190,
		170,
		162,
		181,
		-1,
		151,
		-1,
		126,
		128,
		154,
		157,
		163,
		157,
		130,
		145,
		135,
		126,
		135,
		215,
		-1,
		185,
		218,
		182,
		176,
		152,
		156,
		172,
		-1,
		148,
		130,
		-1,
		158,
		148,
		179,
		164,
		145,
		132,
		139,
		139,
		132,
		-1,
		-1,
		-1,
		187,
		186,
		178,
		172,
		172,
		157,
		148,
		-1,
		160,
		142,
		121,
		138,
		138,
		129,
		137,
		169,
		165,
		152,
		152,
		144,
		-1,
		288,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		181,
		176,
		149,
		137,
		143,
		139,
		125,
		131,
		133,
		141,
		139,
		136,
		148,
		144,
		164,
		145,
		180,
		-1,
		283,
		-1,
		217,
		-1,
		-1,
		199,
		179,
		171,
		160,
		149,
		147,
		138,
		129,
		151,
		167,
		151,
		149,
		152,
		153,
		-1,
		272,
		271,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		195,
		156,
		-1,
		158,
		138,
		-1,
		160,
		156,
		-1,
		-1,
		259,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		190,
		174,
		-1,
		149,
		149,
		-1,
		-1,
		-1,
		244,
		243,
		-1,
		212,
		215,
		-1,
		205,
		196,
		204,
		151,
		155,
		-1,
		-1,
		-1,
		253,
		234,
		228,
		227,
		225,
		220,
		217,
		203,
		187,
		165,
		154,
		175,
		-1,
		-1,
		-1,
		225,
		217,
		210,
		-1,
		-1,
		212,
		195,
		176,
		174,
		-1,
		-1,
		-1,
		247,
		228,
		-1,
		-1,
		202,
		-1,
		-1,
		208,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		236,
		-1,
		-1,
		-1,
		198,
		194,
		195,
		-1,
		-1,
		-1,
		-1,
		258,
		259,
		282,
		246,
		-1,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		261,
		259,
		-1,
		-1,
		-1,
		218,
		202,
		-1,
		188,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		223,
		-1,
		223,
		198,
		205,
		-1,
		-1,
		-1,
		-1,
		236,
		228,
		236,
		-1,
		208,
		210,
		-1,
		258,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		213,
		220,
		242,
		245,
		281,
		-1,
		232
	],
	[
		-1,
		159,
		148,
		159,
		167,
		140,
		147,
		-1,
		168,
		170,
		136,
		130,
		169,
		140,
		146,
		157,
		-1,
		-1,
		-1,
		159,
		158,
		128,
		126,
		135,
		140,
		147,
		-1,
		151,
		-1,
		180,
		159,
		170,
		175,
		121,
		118,
		138,
		157,
		144,
		136,
		195,
		151,
		122,
		116,
		134,
		129,
		138,
		130,
		-1,
		122,
		112,
		134,
		118,
		129,
		121,
		-1,
		-1,
		116,
		117,
		123,
		114,
		120,
		116,
		-1,
		126,
		110,
		-1,
		-1,
		106,
		112,
		96,
		99,
		107,
		105,
		118,
		110,
		105,
		-1,
		-1,
		102,
		98,
		105,
		92,
		88,
		105,
		118,
		100,
		114,
		113,
		-1,
		95,
		113,
		122,
		99,
		97,
		81,
		79,
		97,
		99,
		105,
		108,
		-1,
		104,
		105,
		100,
		108,
		113,
		97,
		84,
		84,
		94,
		87,
		106,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		87,
		104,
		96,
		86,
		101,
		94,
		87,
		84,
		82,
		79,
		95,
		96,
		106,
		-1,
		-1,
		192,
		161,
		195,
		153,
		134,
		-1,
		100,
		80,
		86,
		90,
		84,
		77,
		91,
		87,
		-1,
		73,
		72,
		103,
		89,
		100,
		152,
		-1,
		-1,
		150,
		142,
		127,
		130,
		110,
		106,
		95,
		94,
		86,
		72,
		68,
		74,
		77,
		77,
		83,
		67,
		77,
		81,
		84,
		107,
		-1,
		-1,
		144,
		-1,
		-1,
		149,
		132,
		-1,
		115,
		122,
		116,
		122,
		108,
		129,
		105,
		96,
		88,
		82,
		70,
		72,
		69,
		82,
		70,
		64,
		89,
		93,
		79,
		100,
		95,
		-1,
		143,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		108,
		111,
		117,
		141,
		145,
		-1,
		117,
		105,
		106,
		91,
		88,
		75,
		63,
		76,
		61,
		68,
		67,
		71,
		71,
		101,
		76,
		98,
		95,
		114,
		119,
		113,
		122,
		-1,
		157,
		153,
		149,
		156,
		105,
		-1,
		-1,
		145,
		-1,
		153,
		154,
		129,
		102,
		105,
		92,
		83,
		70,
		59,
		70,
		59,
		56,
		64,
		65,
		80,
		71,
		70,
		88,
		98,
		106,
		110,
		116,
		-1,
		207,
		-1,
		149,
		133,
		135,
		107,
		128,
		-1,
		165,
		154,
		146,
		131,
		126,
		-1,
		101,
		98,
		88,
		66,
		51,
		68,
		60,
		58,
		63,
		60,
		74,
		65,
		83,
		90,
		88,
		92,
		112,
		124,
		167,
		157,
		-1,
		139,
		144,
		103,
		111,
		130,
		168,
		132,
		-1,
		127,
		-1,
		103,
		116,
		-1,
		72,
		68,
		50,
		51,
		46,
		61,
		59,
		56,
		53,
		71,
		74,
		81,
		85,
		101,
		-1,
		-1,
		152,
		156,
		145,
		96,
		115,
		139,
		176,
		125,
		114,
		113,
		-1,
		104,
		86,
		83,
		71,
		58,
		43,
		44,
		52,
		57,
		36,
		55,
		52,
		72,
		98,
		76,
		88,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		122,
		93,
		117,
		159,
		143,
		136,
		124,
		89,
		89,
		83,
		-1,
		82,
		61,
		52,
		41,
		39,
		45,
		37,
		55,
		50,
		48,
		67,
		79,
		70,
		90,
		-1,
		-1,
		-1,
		152,
		141,
		142,
		88,
		111,
		148,
		122,
		108,
		113,
		88,
		81,
		75,
		95,
		78,
		59,
		48,
		40,
		29,
		33,
		41,
		45,
		46,
		55,
		61,
		85,
		92,
		98,
		-1,
		-1,
		159,
		149,
		133,
		135,
		132,
		102,
		109,
		141,
		113,
		126,
		-1,
		80,
		-1,
		69,
		60,
		53,
		48,
		45,
		29,
		24,
		37,
		47,
		53,
		48,
		55,
		90,
		90,
		82,
		102,
		105,
		-1,
		-1,
		-1,
		152,
		147,
		122,
		99,
		83,
		119,
		-1,
		96,
		97,
		-1,
		74,
		68,
		63,
		55,
		51,
		34,
		38,
		27,
		36,
		20,
		39,
		41,
		40,
		76,
		-1,
		90,
		84,
		92,
		82,
		70,
		-1,
		-1,
		-1,
		145,
		124,
		117,
		137,
		78,
		130,
		-1,
		-1,
		81,
		74,
		-1,
		61,
		43,
		37,
		29,
		23,
		13,
		0,
		14,
		27,
		32,
		45,
		43,
		73,
		77,
		83,
		72,
		68,
		65,
		79,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		98,
		-1,
		90,
		82,
		72,
		66,
		60,
		54,
		52,
		51,
		35,
		29,
		19,
		12,
		18,
		21,
		24,
		40,
		50,
		68,
		78,
		70,
		64,
		63,
		75,
		-1,
		165,
		151,
		122,
		-1,
		-1,
		111,
		-1,
		75,
		89,
		105,
		-1,
		98,
		77,
		92,
		70,
		64,
		49,
		57,
		58,
		31,
		19,
		17,
		27,
		46,
		35,
		58,
		52,
		74,
		74,
		58,
		59,
		68,
		-1,
		171,
		158,
		116,
		112,
		101,
		121,
		72,
		60,
		92,
		-1,
		-1,
		134,
		-1,
		68,
		85,
		63,
		61,
		47,
		33,
		39,
		28,
		31,
		41,
		40,
		29,
		35,
		46,
		68,
		54,
		52,
		71,
		87,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		87,
		74,
		68,
		-1,
		109,
		-1,
		112,
		102,
		86,
		71,
		104,
		-1,
		50,
		34,
		39,
		-1,
		66,
		-1,
		48,
		50,
		48,
		40,
		40,
		51,
		49,
		60,
		77,
		-1,
		121,
		106,
		99,
		89,
		103,
		74,
		-1,
		129,
		-1,
		-1,
		99,
		93,
		93,
		77,
		80,
		66,
		46,
		40,
		39,
		65,
		73,
		51,
		53,
		46,
		43,
		43,
		56,
		76,
		67,
		79,
		-1,
		-1,
		-1,
		126,
		112,
		116,
		76,
		95,
		-1,
		-1,
		161,
		116,
		102,
		-1,
		86,
		83,
		71,
		61,
		51,
		85,
		85,
		64,
		65,
		51,
		53,
		51,
		52,
		57,
		78,
		79,
		92,
		-1,
		-1,
		109,
		114,
		102,
		88,
		107,
		-1,
		-1,
		-1,
		108,
		124,
		116,
		87,
		72,
		-1,
		-1,
		63,
		61,
		71,
		68,
		55,
		75,
		78,
		67,
		51,
		66,
		78,
		86,
		91,
		-1,
		112,
		99,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		-1,
		-1,
		141,
		107,
		113,
		108,
		112,
		66,
		-1,
		71,
		72,
		59,
		73,
		80,
		69,
		64,
		58,
		61,
		79,
		96,
		-1,
		-1,
		124,
		-1,
		119,
		-1,
		-1,
		-1,
		-1,
		98,
		112,
		101,
		94,
		98,
		-1,
		80,
		75,
		61,
		78,
		82,
		79,
		70,
		62,
		67,
		64,
		77,
		91,
		95,
		147,
		-1,
		130,
		-1,
		-1,
		-1,
		116,
		131,
		140,
		117,
		90,
		85,
		78,
		72,
		69,
		85,
		90,
		101,
		69,
		65,
		66,
		70,
		69,
		86,
		96,
		-1,
		-1,
		130,
		147,
		142,
		124,
		128,
		167,
		-1,
		-1,
		94,
		85,
		76,
		79,
		79,
		82,
		75,
		72,
		77,
		82,
		70,
		79,
		97,
		101,
		-1,
		-1,
		-1,
		150,
		-1,
		165,
		-1,
		-1,
		143,
		165,
		112,
		94,
		90,
		88,
		81,
		90,
		85,
		80,
		90,
		100,
		92,
		72,
		85,
		107,
		97,
		133,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		179,
		154,
		169,
		176,
		163,
		169,
		127,
		124,
		-1,
		94,
		119,
		91,
		98,
		90,
		98,
		98,
		96,
		75,
		82,
		98,
		97,
		92,
		125,
		119,
		125,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		176,
		171,
		162,
		152,
		155,
		-1,
		-1,
		143,
		140,
		116,
		100,
		104,
		97,
		92,
		104,
		84,
		71,
		75,
		79,
		85,
		90,
		95,
		101,
		116,
		131,
		-1,
		157,
		238,
		231,
		214,
		222,
		253,
		-1,
		166,
		158,
		169,
		144,
		146,
		-1,
		-1,
		116,
		113,
		118,
		107,
		104,
		114,
		109,
		100,
		85,
		91,
		78,
		77,
		95,
		99,
		108,
		115,
		105,
		118,
		122,
		-1,
		171,
		214,
		208,
		211,
		235,
		249,
		-1,
		163,
		-1,
		-1,
		175,
		147,
		131,
		121,
		115,
		165,
		121,
		116,
		108,
		106,
		97,
		88,
		95,
		86,
		86,
		89,
		104,
		109,
		101,
		115,
		115,
		116,
		-1,
		206,
		194,
		202,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		191,
		-1,
		158,
		-1,
		133,
		137,
		129,
		132,
		122,
		109,
		101,
		93,
		109,
		84,
		94,
		90,
		91,
		100,
		111,
		123,
		122,
		123,
		235,
		191,
		194,
		193,
		216,
		231,
		235,
		-1,
		175,
		214,
		221,
		-1,
		200,
		-1,
		-1,
		-1,
		147,
		142,
		134,
		142,
		121,
		121,
		95,
		99,
		89,
		96,
		106,
		108,
		100,
		104,
		117,
		128,
		131,
		231,
		222,
		235,
		180,
		180,
		201,
		210,
		231,
		190,
		181,
		208,
		228,
		217,
		212,
		199,
		-1,
		-1,
		170,
		152,
		-1,
		-1,
		128,
		116,
		99,
		100,
		96,
		99,
		114,
		117,
		107,
		105,
		99,
		131,
		-1,
		224,
		223,
		212,
		209,
		185,
		176,
		171,
		198,
		-1,
		-1,
		193,
		209,
		204,
		208,
		224,
		249,
		-1,
		188,
		-1,
		-1,
		173,
		-1,
		-1,
		158,
		121,
		110,
		101,
		107,
		104,
		115,
		125,
		113,
		114,
		104,
		114,
		127,
		208,
		205,
		193,
		191,
		214,
		179,
		167,
		-1,
		180,
		178,
		184,
		191,
		208,
		238,
		-1,
		-1,
		204,
		184,
		-1,
		-1,
		156,
		154,
		143,
		-1,
		133,
		106,
		111,
		131,
		133,
		122,
		116,
		110,
		117,
		116,
		124,
		132,
		217,
		231,
		220,
		216,
		215,
		223,
		172,
		165,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		194,
		190,
		-1,
		-1,
		151,
		144,
		132,
		120,
		110,
		120,
		124,
		128,
		120,
		113,
		108,
		119,
		111,
		115,
		132,
		-1,
		251,
		-1,
		203,
		179,
		193,
		208,
		216,
		-1,
		-1,
		-1,
		211,
		197,
		190,
		178,
		176,
		-1,
		185,
		169,
		150,
		-1,
		120,
		133,
		164,
		132,
		137,
		132,
		114,
		125,
		114,
		117,
		131,
		126,
		-1,
		-1,
		191,
		194,
		-1,
		-1,
		201,
		203,
		-1,
		202,
		191,
		176,
		168,
		-1,
		-1,
		157,
		153,
		-1,
		-1,
		121,
		146,
		135,
		143,
		138,
		118,
		124,
		127,
		116,
		120,
		132,
		-1,
		-1,
		198,
		199,
		204,
		-1,
		186,
		-1,
		204,
		-1,
		171,
		177,
		165,
		-1,
		-1,
		-1,
		159,
		122,
		143,
		153,
		147,
		145,
		136,
		122,
		129,
		127,
		123,
		134,
		-1,
		-1,
		-1,
		204,
		178,
		211,
		202,
		185,
		165,
		157,
		176,
		-1,
		146,
		-1,
		121,
		123,
		149,
		152,
		158,
		152,
		125,
		140,
		130,
		121,
		130,
		210,
		-1,
		180,
		213,
		177,
		171,
		147,
		151,
		167,
		-1,
		143,
		125,
		-1,
		153,
		143,
		174,
		159,
		140,
		127,
		134,
		134,
		127,
		-1,
		-1,
		-1,
		182,
		181,
		173,
		167,
		167,
		152,
		143,
		-1,
		155,
		137,
		116,
		133,
		133,
		124,
		132,
		164,
		160,
		147,
		147,
		139,
		-1,
		283,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		176,
		171,
		144,
		132,
		138,
		134,
		120,
		126,
		128,
		136,
		134,
		131,
		143,
		139,
		159,
		140,
		175,
		-1,
		278,
		-1,
		212,
		-1,
		-1,
		194,
		174,
		166,
		155,
		144,
		142,
		133,
		124,
		146,
		162,
		146,
		144,
		147,
		148,
		-1,
		267,
		266,
		-1,
		213,
		205,
		191,
		-1,
		184,
		-1,
		190,
		151,
		-1,
		153,
		133,
		-1,
		155,
		151,
		-1,
		-1,
		254,
		229,
		-1,
		-1,
		-1,
		214,
		194,
		185,
		169,
		-1,
		144,
		144,
		-1,
		-1,
		-1,
		239,
		238,
		-1,
		207,
		210,
		-1,
		200,
		191,
		199,
		146,
		150,
		-1,
		-1,
		-1,
		248,
		229,
		223,
		222,
		220,
		215,
		212,
		198,
		182,
		160,
		149,
		170,
		-1,
		-1,
		-1,
		220,
		212,
		205,
		-1,
		-1,
		207,
		190,
		171,
		169,
		-1,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		197,
		-1,
		-1,
		203,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		231,
		-1,
		-1,
		-1,
		193,
		189,
		190,
		-1,
		-1,
		-1,
		-1,
		253,
		254,
		277,
		241,
		-1,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		256,
		254,
		-1,
		-1,
		-1,
		213,
		197,
		-1,
		183,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		218,
		-1,
		218,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		231,
		223,
		231,
		-1,
		203,
		205,
		-1,
		253,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		208,
		215,
		237,
		240,
		276,
		-1,
		227
	],
	[
		-1,
		145,
		134,
		145,
		153,
		126,
		133,
		-1,
		154,
		156,
		122,
		116,
		155,
		126,
		132,
		143,
		-1,
		-1,
		-1,
		145,
		144,
		114,
		112,
		121,
		126,
		133,
		-1,
		137,
		-1,
		166,
		145,
		156,
		161,
		107,
		104,
		124,
		143,
		130,
		122,
		181,
		137,
		108,
		102,
		120,
		115,
		124,
		116,
		-1,
		108,
		98,
		120,
		104,
		115,
		107,
		-1,
		-1,
		102,
		103,
		109,
		100,
		106,
		102,
		-1,
		112,
		96,
		-1,
		-1,
		92,
		98,
		82,
		85,
		93,
		91,
		104,
		96,
		91,
		-1,
		-1,
		88,
		84,
		91,
		78,
		74,
		91,
		104,
		86,
		100,
		99,
		-1,
		81,
		99,
		108,
		85,
		83,
		67,
		65,
		83,
		85,
		91,
		94,
		-1,
		90,
		91,
		86,
		94,
		99,
		83,
		70,
		70,
		80,
		73,
		92,
		83,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		90,
		73,
		90,
		82,
		72,
		87,
		80,
		73,
		70,
		68,
		65,
		81,
		82,
		92,
		-1,
		-1,
		183,
		152,
		181,
		139,
		120,
		-1,
		86,
		66,
		72,
		76,
		70,
		63,
		77,
		73,
		-1,
		59,
		58,
		89,
		75,
		86,
		143,
		-1,
		-1,
		141,
		133,
		116,
		119,
		96,
		92,
		81,
		80,
		72,
		58,
		54,
		60,
		63,
		63,
		69,
		53,
		63,
		67,
		70,
		93,
		-1,
		-1,
		130,
		-1,
		-1,
		140,
		123,
		-1,
		106,
		113,
		102,
		108,
		94,
		115,
		91,
		82,
		74,
		68,
		56,
		58,
		55,
		68,
		56,
		50,
		75,
		79,
		65,
		86,
		81,
		-1,
		129,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		99,
		102,
		108,
		132,
		131,
		-1,
		103,
		91,
		92,
		77,
		74,
		61,
		49,
		62,
		47,
		54,
		53,
		57,
		57,
		87,
		62,
		84,
		81,
		100,
		105,
		99,
		108,
		-1,
		148,
		144,
		140,
		147,
		96,
		-1,
		-1,
		136,
		-1,
		139,
		140,
		115,
		88,
		91,
		78,
		69,
		56,
		45,
		56,
		45,
		42,
		50,
		51,
		66,
		57,
		56,
		74,
		84,
		92,
		96,
		102,
		-1,
		198,
		-1,
		140,
		124,
		126,
		98,
		119,
		-1,
		156,
		140,
		132,
		117,
		117,
		-1,
		87,
		84,
		74,
		52,
		37,
		54,
		46,
		44,
		49,
		46,
		60,
		51,
		69,
		76,
		74,
		78,
		98,
		110,
		158,
		148,
		-1,
		130,
		135,
		94,
		102,
		121,
		159,
		123,
		-1,
		118,
		-1,
		89,
		102,
		-1,
		58,
		54,
		36,
		37,
		32,
		47,
		45,
		42,
		39,
		57,
		60,
		67,
		71,
		87,
		-1,
		-1,
		143,
		147,
		136,
		87,
		106,
		130,
		167,
		116,
		105,
		104,
		-1,
		95,
		72,
		69,
		57,
		44,
		29,
		30,
		38,
		43,
		22,
		41,
		38,
		58,
		84,
		62,
		74,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		113,
		84,
		108,
		150,
		134,
		127,
		115,
		80,
		80,
		74,
		-1,
		68,
		47,
		38,
		27,
		25,
		31,
		23,
		41,
		36,
		34,
		53,
		65,
		56,
		76,
		-1,
		-1,
		-1,
		143,
		132,
		133,
		79,
		102,
		139,
		113,
		99,
		104,
		79,
		72,
		66,
		81,
		64,
		45,
		34,
		26,
		15,
		19,
		27,
		31,
		32,
		41,
		47,
		71,
		78,
		84,
		-1,
		-1,
		150,
		140,
		124,
		126,
		123,
		93,
		100,
		132,
		104,
		117,
		-1,
		71,
		-1,
		60,
		55,
		39,
		34,
		31,
		23,
		10,
		23,
		33,
		39,
		34,
		41,
		76,
		76,
		68,
		88,
		91,
		-1,
		-1,
		-1,
		143,
		138,
		113,
		90,
		74,
		110,
		-1,
		87,
		88,
		-1,
		65,
		59,
		56,
		41,
		37,
		27,
		31,
		25,
		22,
		6,
		25,
		27,
		26,
		62,
		-1,
		76,
		70,
		78,
		68,
		56,
		-1,
		-1,
		-1,
		136,
		115,
		108,
		128,
		69,
		121,
		-1,
		-1,
		72,
		65,
		-1,
		52,
		34,
		39,
		34,
		33,
		23,
		11,
		0,
		13,
		18,
		31,
		29,
		59,
		63,
		69,
		58,
		54,
		51,
		65,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		89,
		-1,
		81,
		73,
		63,
		57,
		51,
		47,
		45,
		61,
		45,
		39,
		23,
		14,
		22,
		7,
		10,
		26,
		36,
		54,
		64,
		56,
		50,
		49,
		61,
		-1,
		156,
		142,
		113,
		-1,
		-1,
		102,
		-1,
		66,
		80,
		96,
		-1,
		89,
		68,
		83,
		61,
		57,
		51,
		61,
		62,
		35,
		23,
		21,
		31,
		32,
		21,
		44,
		38,
		60,
		60,
		44,
		45,
		54,
		-1,
		162,
		149,
		107,
		103,
		92,
		112,
		63,
		51,
		83,
		-1,
		-1,
		125,
		-1,
		59,
		76,
		65,
		63,
		51,
		37,
		43,
		32,
		35,
		36,
		26,
		15,
		21,
		32,
		54,
		40,
		38,
		57,
		73,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		78,
		65,
		59,
		-1,
		100,
		-1,
		103,
		93,
		77,
		62,
		95,
		-1,
		54,
		38,
		43,
		-1,
		61,
		-1,
		34,
		36,
		34,
		26,
		26,
		37,
		35,
		46,
		63,
		-1,
		112,
		97,
		90,
		80,
		94,
		65,
		-1,
		120,
		-1,
		-1,
		90,
		84,
		84,
		68,
		71,
		70,
		50,
		44,
		43,
		56,
		64,
		42,
		39,
		32,
		29,
		29,
		42,
		62,
		53,
		65,
		-1,
		-1,
		-1,
		117,
		103,
		107,
		67,
		86,
		-1,
		-1,
		152,
		107,
		93,
		-1,
		77,
		87,
		75,
		65,
		55,
		88,
		76,
		55,
		51,
		37,
		39,
		37,
		38,
		43,
		64,
		65,
		78,
		-1,
		-1,
		100,
		105,
		93,
		79,
		98,
		-1,
		-1,
		-1,
		99,
		115,
		107,
		78,
		76,
		-1,
		-1,
		67,
		65,
		68,
		54,
		41,
		61,
		64,
		53,
		37,
		52,
		64,
		72,
		77,
		-1,
		103,
		90,
		-1,
		-1,
		101,
		95,
		-1,
		-1,
		-1,
		-1,
		132,
		98,
		99,
		94,
		98,
		70,
		-1,
		70,
		65,
		45,
		59,
		66,
		55,
		50,
		44,
		47,
		65,
		82,
		-1,
		-1,
		115,
		-1,
		110,
		-1,
		-1,
		-1,
		-1,
		89,
		103,
		87,
		80,
		84,
		-1,
		72,
		61,
		47,
		64,
		68,
		65,
		56,
		48,
		53,
		50,
		63,
		77,
		81,
		138,
		-1,
		121,
		-1,
		-1,
		-1,
		107,
		122,
		126,
		103,
		76,
		71,
		64,
		58,
		55,
		71,
		76,
		87,
		55,
		51,
		52,
		56,
		55,
		72,
		82,
		-1,
		-1,
		121,
		138,
		133,
		115,
		119,
		153,
		-1,
		-1,
		80,
		71,
		62,
		65,
		65,
		68,
		61,
		58,
		63,
		68,
		56,
		65,
		83,
		87,
		-1,
		-1,
		-1,
		141,
		-1,
		156,
		-1,
		-1,
		134,
		151,
		98,
		80,
		76,
		74,
		67,
		76,
		71,
		66,
		76,
		86,
		78,
		58,
		71,
		93,
		83,
		119,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		169,
		145,
		156,
		162,
		154,
		155,
		113,
		110,
		-1,
		80,
		105,
		77,
		84,
		76,
		84,
		84,
		82,
		61,
		68,
		84,
		83,
		78,
		111,
		105,
		111,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		162,
		158,
		148,
		138,
		141,
		-1,
		-1,
		129,
		126,
		102,
		86,
		90,
		83,
		78,
		90,
		70,
		57,
		61,
		65,
		71,
		76,
		81,
		87,
		102,
		117,
		-1,
		148,
		229,
		222,
		205,
		213,
		244,
		-1,
		152,
		144,
		155,
		130,
		132,
		-1,
		-1,
		102,
		99,
		104,
		93,
		90,
		100,
		95,
		86,
		71,
		77,
		64,
		63,
		81,
		85,
		94,
		101,
		91,
		104,
		108,
		-1,
		162,
		205,
		199,
		202,
		226,
		240,
		-1,
		149,
		-1,
		-1,
		161,
		133,
		117,
		107,
		101,
		151,
		107,
		102,
		94,
		92,
		83,
		74,
		81,
		72,
		72,
		75,
		90,
		95,
		87,
		101,
		101,
		102,
		-1,
		196,
		185,
		193,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		177,
		-1,
		144,
		-1,
		119,
		123,
		115,
		118,
		108,
		95,
		87,
		79,
		95,
		70,
		80,
		76,
		77,
		86,
		97,
		109,
		108,
		109,
		221,
		177,
		180,
		184,
		202,
		217,
		221,
		-1,
		161,
		200,
		207,
		-1,
		186,
		-1,
		-1,
		-1,
		133,
		128,
		120,
		128,
		107,
		107,
		81,
		85,
		75,
		82,
		92,
		94,
		86,
		90,
		103,
		114,
		117,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		176,
		167,
		194,
		214,
		203,
		198,
		185,
		-1,
		-1,
		156,
		138,
		-1,
		-1,
		114,
		102,
		85,
		86,
		82,
		85,
		100,
		103,
		93,
		91,
		85,
		117,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		195,
		190,
		194,
		210,
		235,
		-1,
		174,
		-1,
		-1,
		159,
		-1,
		-1,
		144,
		107,
		96,
		87,
		93,
		90,
		101,
		111,
		99,
		100,
		90,
		100,
		113,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		166,
		164,
		170,
		177,
		194,
		224,
		-1,
		-1,
		190,
		170,
		-1,
		-1,
		142,
		140,
		129,
		-1,
		119,
		92,
		97,
		117,
		119,
		108,
		102,
		96,
		103,
		102,
		110,
		118,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		180,
		176,
		-1,
		-1,
		137,
		130,
		118,
		106,
		96,
		106,
		110,
		114,
		106,
		99,
		94,
		105,
		97,
		101,
		118,
		-1,
		237,
		-1,
		189,
		165,
		179,
		194,
		202,
		-1,
		-1,
		-1,
		197,
		183,
		176,
		164,
		162,
		-1,
		171,
		155,
		136,
		-1,
		106,
		119,
		150,
		118,
		123,
		118,
		100,
		111,
		100,
		103,
		117,
		112,
		-1,
		-1,
		177,
		180,
		-1,
		-1,
		187,
		189,
		-1,
		188,
		177,
		162,
		154,
		-1,
		-1,
		143,
		139,
		-1,
		-1,
		107,
		132,
		121,
		129,
		124,
		104,
		110,
		113,
		102,
		106,
		118,
		-1,
		-1,
		184,
		185,
		190,
		-1,
		172,
		-1,
		190,
		-1,
		157,
		163,
		151,
		-1,
		-1,
		-1,
		145,
		108,
		129,
		139,
		133,
		131,
		122,
		108,
		115,
		113,
		109,
		120,
		-1,
		-1,
		-1,
		190,
		164,
		197,
		188,
		171,
		151,
		143,
		162,
		-1,
		132,
		-1,
		107,
		109,
		135,
		138,
		144,
		138,
		111,
		126,
		116,
		107,
		116,
		196,
		-1,
		166,
		199,
		163,
		157,
		133,
		137,
		153,
		-1,
		129,
		111,
		-1,
		139,
		129,
		160,
		145,
		126,
		113,
		120,
		120,
		113,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		153,
		138,
		129,
		-1,
		141,
		123,
		102,
		119,
		119,
		110,
		118,
		150,
		146,
		133,
		133,
		125,
		-1,
		269,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		157,
		130,
		118,
		124,
		120,
		106,
		112,
		114,
		122,
		120,
		117,
		129,
		125,
		145,
		126,
		161,
		-1,
		264,
		-1,
		198,
		-1,
		-1,
		180,
		160,
		152,
		141,
		130,
		128,
		119,
		110,
		132,
		148,
		132,
		130,
		133,
		134,
		-1,
		253,
		252,
		-1,
		199,
		191,
		177,
		-1,
		170,
		-1,
		176,
		137,
		-1,
		139,
		119,
		-1,
		141,
		137,
		-1,
		-1,
		240,
		215,
		-1,
		-1,
		-1,
		200,
		180,
		171,
		155,
		-1,
		130,
		130,
		-1,
		-1,
		-1,
		225,
		224,
		-1,
		193,
		196,
		-1,
		186,
		177,
		185,
		132,
		136,
		-1,
		-1,
		-1,
		234,
		215,
		209,
		208,
		206,
		201,
		198,
		184,
		168,
		146,
		135,
		156,
		-1,
		-1,
		-1,
		206,
		198,
		191,
		-1,
		-1,
		193,
		176,
		157,
		155,
		-1,
		-1,
		-1,
		228,
		209,
		-1,
		-1,
		183,
		-1,
		-1,
		189,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		217,
		-1,
		-1,
		-1,
		179,
		175,
		176,
		-1,
		-1,
		-1,
		-1,
		239,
		240,
		263,
		227,
		-1,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		242,
		240,
		-1,
		-1,
		-1,
		199,
		183,
		-1,
		169,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		204,
		-1,
		204,
		179,
		186,
		-1,
		-1,
		-1,
		-1,
		217,
		209,
		217,
		-1,
		189,
		191,
		-1,
		239,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		194,
		201,
		223,
		226,
		262,
		-1,
		213
	],
	[
		-1,
		163,
		152,
		163,
		171,
		144,
		151,
		-1,
		172,
		174,
		140,
		134,
		173,
		144,
		150,
		161,
		-1,
		-1,
		-1,
		163,
		162,
		132,
		130,
		139,
		144,
		151,
		-1,
		153,
		-1,
		184,
		163,
		174,
		179,
		125,
		122,
		142,
		161,
		146,
		138,
		199,
		155,
		126,
		120,
		138,
		131,
		140,
		132,
		-1,
		126,
		116,
		138,
		120,
		131,
		123,
		-1,
		-1,
		120,
		121,
		127,
		116,
		122,
		118,
		-1,
		128,
		112,
		-1,
		-1,
		110,
		114,
		98,
		101,
		109,
		107,
		120,
		112,
		107,
		-1,
		-1,
		104,
		100,
		107,
		94,
		90,
		107,
		120,
		102,
		116,
		115,
		-1,
		99,
		117,
		126,
		101,
		99,
		83,
		81,
		99,
		101,
		107,
		107,
		-1,
		108,
		109,
		104,
		112,
		117,
		99,
		86,
		86,
		96,
		89,
		108,
		96,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		108,
		91,
		108,
		100,
		90,
		105,
		98,
		89,
		86,
		84,
		81,
		97,
		95,
		105,
		-1,
		-1,
		201,
		170,
		199,
		157,
		138,
		-1,
		104,
		84,
		90,
		94,
		88,
		81,
		95,
		91,
		-1,
		75,
		74,
		102,
		88,
		99,
		161,
		-1,
		-1,
		159,
		151,
		134,
		137,
		114,
		110,
		99,
		98,
		90,
		76,
		72,
		78,
		81,
		81,
		87,
		69,
		79,
		83,
		81,
		106,
		-1,
		-1,
		141,
		-1,
		-1,
		158,
		141,
		-1,
		124,
		131,
		120,
		126,
		112,
		133,
		109,
		100,
		92,
		86,
		74,
		76,
		73,
		86,
		74,
		66,
		91,
		95,
		76,
		97,
		92,
		-1,
		140,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		117,
		120,
		126,
		150,
		149,
		-1,
		121,
		109,
		110,
		95,
		92,
		79,
		67,
		80,
		65,
		72,
		71,
		70,
		68,
		98,
		73,
		95,
		92,
		111,
		116,
		110,
		119,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		154,
		-1,
		157,
		158,
		133,
		106,
		109,
		96,
		87,
		74,
		63,
		74,
		63,
		60,
		68,
		62,
		77,
		68,
		67,
		85,
		95,
		103,
		107,
		113,
		-1,
		216,
		-1,
		158,
		142,
		144,
		116,
		137,
		-1,
		174,
		158,
		150,
		135,
		135,
		-1,
		105,
		102,
		92,
		70,
		55,
		72,
		64,
		62,
		67,
		57,
		71,
		62,
		80,
		87,
		85,
		89,
		109,
		121,
		176,
		166,
		-1,
		148,
		153,
		112,
		120,
		139,
		177,
		141,
		-1,
		136,
		-1,
		107,
		120,
		-1,
		76,
		72,
		54,
		55,
		50,
		65,
		63,
		53,
		50,
		68,
		71,
		78,
		82,
		98,
		-1,
		-1,
		161,
		165,
		154,
		105,
		124,
		148,
		185,
		134,
		123,
		122,
		-1,
		113,
		90,
		87,
		75,
		62,
		47,
		48,
		56,
		61,
		40,
		52,
		49,
		69,
		95,
		73,
		85,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		131,
		102,
		126,
		168,
		152,
		145,
		133,
		98,
		98,
		92,
		-1,
		86,
		65,
		56,
		45,
		43,
		49,
		41,
		53,
		47,
		45,
		64,
		76,
		67,
		87,
		-1,
		-1,
		-1,
		161,
		150,
		151,
		97,
		120,
		157,
		131,
		117,
		122,
		97,
		90,
		84,
		99,
		82,
		63,
		52,
		44,
		33,
		37,
		45,
		40,
		43,
		52,
		58,
		82,
		87,
		93,
		-1,
		-1,
		168,
		158,
		142,
		144,
		141,
		111,
		118,
		150,
		122,
		135,
		-1,
		89,
		-1,
		78,
		73,
		57,
		52,
		49,
		41,
		28,
		39,
		39,
		44,
		45,
		46,
		87,
		87,
		77,
		97,
		100,
		-1,
		-1,
		-1,
		161,
		156,
		131,
		108,
		92,
		128,
		-1,
		105,
		106,
		-1,
		83,
		77,
		74,
		59,
		55,
		45,
		49,
		43,
		40,
		23,
		30,
		38,
		37,
		73,
		-1,
		85,
		79,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		154,
		133,
		126,
		146,
		87,
		139,
		-1,
		-1,
		90,
		83,
		-1,
		70,
		52,
		57,
		52,
		51,
		41,
		29,
		18,
		0,
		10,
		39,
		36,
		68,
		72,
		78,
		67,
		63,
		60,
		74,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		107,
		-1,
		99,
		91,
		81,
		75,
		69,
		65,
		63,
		79,
		63,
		57,
		41,
		27,
		37,
		21,
		19,
		33,
		45,
		63,
		73,
		65,
		59,
		58,
		70,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		120,
		-1,
		84,
		98,
		114,
		-1,
		107,
		86,
		101,
		79,
		75,
		69,
		79,
		80,
		53,
		41,
		39,
		47,
		41,
		30,
		53,
		47,
		69,
		69,
		53,
		54,
		63,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		81,
		69,
		101,
		-1,
		-1,
		143,
		-1,
		77,
		94,
		83,
		81,
		69,
		55,
		61,
		50,
		50,
		45,
		35,
		24,
		30,
		41,
		63,
		49,
		47,
		66,
		82,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		118,
		-1,
		121,
		111,
		95,
		80,
		113,
		-1,
		72,
		56,
		61,
		-1,
		70,
		-1,
		43,
		45,
		43,
		35,
		35,
		46,
		44,
		55,
		72,
		-1,
		130,
		115,
		108,
		98,
		112,
		83,
		-1,
		138,
		-1,
		-1,
		108,
		102,
		102,
		86,
		89,
		88,
		68,
		62,
		61,
		65,
		73,
		51,
		48,
		41,
		38,
		38,
		51,
		71,
		62,
		74,
		-1,
		-1,
		-1,
		135,
		121,
		125,
		85,
		104,
		-1,
		-1,
		170,
		125,
		111,
		-1,
		95,
		105,
		93,
		83,
		73,
		97,
		85,
		64,
		60,
		46,
		48,
		46,
		47,
		52,
		73,
		74,
		87,
		-1,
		-1,
		118,
		123,
		111,
		97,
		116,
		-1,
		-1,
		-1,
		117,
		133,
		125,
		96,
		94,
		-1,
		-1,
		85,
		83,
		77,
		63,
		50,
		70,
		73,
		62,
		46,
		61,
		73,
		81,
		86,
		-1,
		121,
		108,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		108,
		103,
		107,
		88,
		-1,
		79,
		74,
		54,
		68,
		75,
		64,
		59,
		53,
		56,
		74,
		91,
		-1,
		-1,
		133,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		107,
		121,
		96,
		89,
		93,
		-1,
		81,
		70,
		56,
		73,
		77,
		74,
		65,
		57,
		62,
		59,
		72,
		86,
		90,
		156,
		-1,
		139,
		-1,
		-1,
		-1,
		125,
		140,
		135,
		112,
		85,
		80,
		73,
		67,
		64,
		80,
		85,
		96,
		64,
		60,
		61,
		65,
		64,
		81,
		91,
		-1,
		-1,
		139,
		156,
		151,
		133,
		137,
		162,
		-1,
		-1,
		89,
		80,
		71,
		74,
		74,
		77,
		70,
		67,
		72,
		77,
		65,
		74,
		92,
		96,
		-1,
		-1,
		-1,
		159,
		-1,
		174,
		-1,
		-1,
		152,
		160,
		107,
		89,
		85,
		83,
		76,
		85,
		80,
		75,
		85,
		95,
		87,
		67,
		80,
		102,
		92,
		128,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		178,
		163,
		165,
		171,
		172,
		164,
		122,
		119,
		-1,
		89,
		114,
		86,
		93,
		85,
		93,
		93,
		91,
		70,
		77,
		93,
		92,
		87,
		120,
		114,
		120,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		138,
		135,
		111,
		95,
		99,
		92,
		87,
		99,
		79,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		166,
		247,
		240,
		221,
		229,
		260,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		111,
		108,
		113,
		102,
		99,
		109,
		104,
		95,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		180,
		223,
		215,
		218,
		242,
		256,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		110,
		160,
		116,
		111,
		103,
		101,
		92,
		83,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		205,
		203,
		209,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		186,
		-1,
		153,
		-1,
		128,
		132,
		124,
		127,
		117,
		104,
		96,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		170,
		209,
		216,
		-1,
		195,
		-1,
		-1,
		-1,
		142,
		137,
		129,
		137,
		116,
		116,
		90,
		94,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		185,
		176,
		203,
		223,
		212,
		207,
		194,
		-1,
		-1,
		165,
		147,
		-1,
		-1,
		123,
		111,
		94,
		95,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		204,
		199,
		203,
		219,
		244,
		-1,
		183,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		203,
		233,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		119,
		123,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		196,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		193,
		194,
		199,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		154,
		117,
		138,
		148,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		118,
		144,
		147,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		169,
		154,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		159,
		155,
		142,
		142,
		134,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		135,
		170,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		142,
		143,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		161,
		150,
		161,
		169,
		142,
		149,
		-1,
		168,
		172,
		138,
		132,
		171,
		140,
		146,
		157,
		-1,
		-1,
		-1,
		161,
		160,
		128,
		126,
		135,
		140,
		147,
		-1,
		146,
		-1,
		182,
		161,
		172,
		177,
		121,
		118,
		138,
		157,
		139,
		131,
		197,
		151,
		122,
		116,
		134,
		124,
		133,
		125,
		-1,
		122,
		112,
		134,
		113,
		124,
		116,
		-1,
		-1,
		116,
		117,
		123,
		109,
		115,
		111,
		-1,
		121,
		105,
		-1,
		-1,
		106,
		107,
		91,
		94,
		102,
		100,
		113,
		105,
		100,
		-1,
		-1,
		97,
		93,
		100,
		87,
		83,
		100,
		113,
		95,
		109,
		108,
		-1,
		101,
		119,
		126,
		94,
		92,
		76,
		74,
		92,
		94,
		100,
		100,
		-1,
		110,
		111,
		106,
		114,
		116,
		92,
		79,
		79,
		89,
		82,
		101,
		89,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		110,
		93,
		110,
		102,
		92,
		107,
		100,
		82,
		79,
		77,
		74,
		90,
		88,
		98,
		-1,
		-1,
		203,
		172,
		201,
		159,
		140,
		-1,
		106,
		86,
		92,
		96,
		90,
		83,
		97,
		93,
		-1,
		68,
		67,
		95,
		81,
		92,
		163,
		-1,
		-1,
		161,
		153,
		136,
		139,
		116,
		112,
		101,
		100,
		92,
		78,
		74,
		80,
		83,
		83,
		89,
		62,
		72,
		76,
		74,
		99,
		-1,
		-1,
		134,
		-1,
		-1,
		160,
		143,
		-1,
		126,
		133,
		122,
		128,
		114,
		135,
		111,
		102,
		94,
		88,
		76,
		78,
		75,
		88,
		76,
		59,
		84,
		88,
		69,
		90,
		85,
		-1,
		133,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		119,
		122,
		128,
		152,
		151,
		-1,
		123,
		111,
		112,
		97,
		94,
		81,
		69,
		82,
		67,
		74,
		73,
		63,
		61,
		91,
		66,
		88,
		85,
		104,
		109,
		103,
		112,
		-1,
		168,
		164,
		160,
		167,
		116,
		-1,
		-1,
		156,
		-1,
		159,
		160,
		135,
		108,
		111,
		98,
		89,
		76,
		65,
		76,
		65,
		62,
		70,
		55,
		70,
		61,
		60,
		78,
		88,
		96,
		100,
		106,
		-1,
		218,
		-1,
		160,
		144,
		146,
		118,
		139,
		-1,
		176,
		160,
		152,
		137,
		137,
		-1,
		107,
		104,
		94,
		72,
		57,
		74,
		66,
		64,
		68,
		50,
		64,
		55,
		73,
		80,
		78,
		82,
		102,
		114,
		178,
		168,
		-1,
		150,
		155,
		114,
		122,
		141,
		179,
		143,
		-1,
		138,
		-1,
		109,
		122,
		-1,
		78,
		74,
		56,
		57,
		52,
		67,
		61,
		46,
		43,
		61,
		64,
		71,
		75,
		91,
		-1,
		-1,
		163,
		167,
		156,
		107,
		126,
		150,
		187,
		136,
		125,
		124,
		-1,
		115,
		92,
		89,
		77,
		64,
		49,
		50,
		58,
		63,
		42,
		45,
		42,
		62,
		88,
		66,
		78,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		133,
		104,
		128,
		170,
		154,
		147,
		135,
		100,
		100,
		94,
		-1,
		88,
		67,
		58,
		47,
		45,
		51,
		43,
		46,
		40,
		38,
		57,
		69,
		60,
		80,
		-1,
		-1,
		-1,
		163,
		152,
		153,
		99,
		122,
		159,
		133,
		119,
		124,
		99,
		92,
		86,
		101,
		84,
		65,
		54,
		46,
		35,
		39,
		41,
		33,
		36,
		45,
		51,
		75,
		80,
		86,
		-1,
		-1,
		170,
		160,
		144,
		146,
		143,
		113,
		120,
		152,
		124,
		137,
		-1,
		91,
		-1,
		80,
		75,
		59,
		54,
		51,
		43,
		30,
		33,
		32,
		37,
		38,
		39,
		80,
		80,
		70,
		90,
		93,
		-1,
		-1,
		-1,
		163,
		158,
		133,
		110,
		94,
		130,
		-1,
		107,
		108,
		-1,
		85,
		79,
		76,
		61,
		57,
		47,
		51,
		45,
		42,
		26,
		23,
		31,
		30,
		66,
		-1,
		78,
		72,
		80,
		70,
		58,
		-1,
		-1,
		-1,
		156,
		135,
		128,
		148,
		89,
		141,
		-1,
		-1,
		92,
		85,
		-1,
		72,
		54,
		59,
		54,
		53,
		43,
		31,
		20,
		11,
		0,
		32,
		29,
		61,
		65,
		71,
		60,
		56,
		53,
		67,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		109,
		-1,
		101,
		93,
		83,
		77,
		71,
		67,
		65,
		81,
		65,
		59,
		43,
		34,
		42,
		14,
		12,
		26,
		38,
		56,
		66,
		58,
		52,
		51,
		63,
		-1,
		176,
		162,
		133,
		-1,
		-1,
		122,
		-1,
		86,
		100,
		116,
		-1,
		109,
		88,
		103,
		81,
		77,
		71,
		81,
		82,
		55,
		43,
		41,
		46,
		34,
		23,
		46,
		40,
		62,
		62,
		46,
		47,
		56,
		-1,
		182,
		169,
		127,
		123,
		112,
		132,
		83,
		71,
		103,
		-1,
		-1,
		145,
		-1,
		79,
		96,
		85,
		83,
		71,
		57,
		63,
		52,
		43,
		38,
		28,
		17,
		23,
		34,
		56,
		42,
		40,
		59,
		75,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		98,
		85,
		79,
		-1,
		120,
		-1,
		123,
		113,
		97,
		82,
		115,
		-1,
		74,
		58,
		63,
		-1,
		63,
		-1,
		36,
		38,
		36,
		28,
		28,
		39,
		37,
		48,
		65,
		-1,
		132,
		117,
		110,
		100,
		114,
		85,
		-1,
		140,
		-1,
		-1,
		110,
		104,
		104,
		88,
		91,
		90,
		70,
		64,
		63,
		58,
		66,
		44,
		41,
		34,
		31,
		31,
		44,
		64,
		55,
		67,
		-1,
		-1,
		-1,
		137,
		123,
		127,
		87,
		106,
		-1,
		-1,
		172,
		127,
		113,
		-1,
		97,
		107,
		95,
		85,
		75,
		90,
		78,
		57,
		53,
		39,
		41,
		39,
		40,
		45,
		66,
		67,
		80,
		-1,
		-1,
		120,
		125,
		113,
		99,
		118,
		-1,
		-1,
		-1,
		119,
		135,
		127,
		98,
		96,
		-1,
		-1,
		87,
		82,
		70,
		56,
		43,
		63,
		66,
		55,
		39,
		54,
		66,
		74,
		79,
		-1,
		123,
		110,
		-1,
		-1,
		121,
		115,
		-1,
		-1,
		-1,
		-1,
		152,
		112,
		101,
		96,
		100,
		88,
		-1,
		72,
		67,
		47,
		61,
		68,
		57,
		52,
		46,
		49,
		67,
		84,
		-1,
		-1,
		135,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		109,
		118,
		89,
		82,
		86,
		-1,
		74,
		63,
		49,
		66,
		70,
		67,
		58,
		50,
		55,
		52,
		65,
		79,
		83,
		158,
		-1,
		141,
		-1,
		-1,
		-1,
		127,
		142,
		128,
		105,
		78,
		73,
		66,
		60,
		57,
		73,
		78,
		89,
		57,
		53,
		54,
		58,
		57,
		74,
		84,
		-1,
		-1,
		141,
		158,
		153,
		135,
		139,
		155,
		-1,
		-1,
		82,
		73,
		64,
		67,
		67,
		70,
		63,
		60,
		65,
		70,
		58,
		67,
		85,
		89,
		-1,
		-1,
		-1,
		161,
		-1,
		176,
		-1,
		-1,
		154,
		153,
		100,
		82,
		78,
		76,
		69,
		78,
		73,
		68,
		78,
		88,
		80,
		60,
		73,
		95,
		85,
		121,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		115,
		112,
		-1,
		82,
		107,
		79,
		86,
		78,
		86,
		86,
		84,
		63,
		70,
		86,
		85,
		80,
		113,
		107,
		113,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		131,
		128,
		104,
		88,
		92,
		85,
		80,
		92,
		72,
		59,
		63,
		67,
		73,
		78,
		83,
		89,
		104,
		119,
		-1,
		168,
		249,
		242,
		214,
		222,
		253,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		104,
		101,
		106,
		95,
		92,
		102,
		97,
		88,
		73,
		79,
		66,
		65,
		83,
		87,
		96,
		103,
		93,
		106,
		110,
		-1,
		182,
		225,
		208,
		211,
		235,
		249,
		-1,
		151,
		-1,
		-1,
		163,
		135,
		119,
		109,
		103,
		153,
		109,
		104,
		96,
		94,
		85,
		76,
		83,
		74,
		74,
		77,
		92,
		97,
		89,
		103,
		103,
		104,
		-1,
		198,
		205,
		202,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		179,
		-1,
		146,
		-1,
		121,
		125,
		117,
		120,
		110,
		97,
		89,
		81,
		97,
		72,
		82,
		78,
		79,
		88,
		99,
		111,
		110,
		111,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		163,
		202,
		209,
		-1,
		188,
		-1,
		-1,
		-1,
		135,
		130,
		122,
		130,
		109,
		109,
		83,
		87,
		77,
		84,
		94,
		96,
		88,
		92,
		105,
		116,
		119,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		178,
		169,
		196,
		216,
		205,
		200,
		187,
		-1,
		-1,
		158,
		140,
		-1,
		-1,
		116,
		104,
		87,
		88,
		84,
		87,
		102,
		105,
		95,
		93,
		87,
		119,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		197,
		192,
		196,
		212,
		237,
		-1,
		176,
		-1,
		-1,
		161,
		-1,
		-1,
		146,
		109,
		98,
		89,
		95,
		92,
		103,
		113,
		101,
		102,
		92,
		102,
		115,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		192,
		172,
		-1,
		-1,
		144,
		142,
		131,
		-1,
		121,
		94,
		99,
		119,
		121,
		110,
		104,
		98,
		105,
		104,
		112,
		120,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		139,
		132,
		120,
		108,
		98,
		108,
		112,
		116,
		108,
		101,
		96,
		107,
		99,
		103,
		120,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		173,
		157,
		138,
		-1,
		108,
		121,
		152,
		120,
		125,
		120,
		102,
		113,
		102,
		105,
		119,
		114,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		189,
		191,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		134,
		123,
		131,
		126,
		106,
		112,
		115,
		104,
		108,
		120,
		-1,
		-1,
		186,
		187,
		192,
		-1,
		174,
		-1,
		192,
		-1,
		159,
		165,
		153,
		-1,
		-1,
		-1,
		147,
		110,
		131,
		141,
		135,
		133,
		124,
		110,
		117,
		115,
		111,
		122,
		-1,
		-1,
		-1,
		192,
		166,
		199,
		190,
		173,
		153,
		145,
		164,
		-1,
		134,
		-1,
		109,
		111,
		137,
		140,
		146,
		140,
		113,
		128,
		118,
		109,
		118,
		198,
		-1,
		168,
		201,
		165,
		159,
		135,
		139,
		155,
		-1,
		131,
		113,
		-1,
		141,
		131,
		162,
		147,
		128,
		115,
		122,
		122,
		115,
		-1,
		-1,
		-1,
		170,
		169,
		161,
		155,
		155,
		140,
		131,
		-1,
		143,
		125,
		104,
		121,
		121,
		112,
		120,
		152,
		148,
		135,
		135,
		127,
		-1,
		271,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		164,
		159,
		132,
		120,
		126,
		122,
		108,
		114,
		116,
		124,
		122,
		119,
		131,
		127,
		147,
		128,
		163,
		-1,
		266,
		-1,
		200,
		-1,
		-1,
		182,
		162,
		154,
		143,
		132,
		130,
		121,
		112,
		134,
		150,
		134,
		132,
		135,
		136,
		-1,
		255,
		254,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		178,
		139,
		-1,
		141,
		121,
		-1,
		143,
		139,
		-1,
		-1,
		242,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		173,
		157,
		-1,
		132,
		132,
		-1,
		-1,
		-1,
		227,
		226,
		-1,
		195,
		198,
		-1,
		188,
		179,
		187,
		134,
		138,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		210,
		208,
		203,
		200,
		186,
		170,
		148,
		137,
		158,
		-1,
		-1,
		-1,
		208,
		200,
		193,
		-1,
		-1,
		195,
		178,
		159,
		157,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		185,
		-1,
		-1,
		191,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		219,
		-1,
		-1,
		-1,
		181,
		177,
		178,
		-1,
		-1,
		-1,
		-1,
		241,
		242,
		265,
		229,
		-1,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		244,
		242,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		171,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		206,
		-1,
		206,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		219,
		211,
		219,
		-1,
		191,
		193,
		-1,
		241,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		196,
		203,
		225,
		228,
		264,
		-1,
		215
	],
	[
		-1,
		144,
		133,
		144,
		152,
		125,
		132,
		-1,
		151,
		155,
		121,
		115,
		154,
		123,
		129,
		140,
		-1,
		-1,
		-1,
		144,
		143,
		111,
		109,
		118,
		123,
		130,
		-1,
		129,
		-1,
		165,
		144,
		155,
		160,
		104,
		101,
		121,
		140,
		122,
		114,
		180,
		134,
		105,
		99,
		117,
		107,
		116,
		108,
		-1,
		105,
		95,
		117,
		96,
		107,
		99,
		-1,
		-1,
		99,
		100,
		106,
		92,
		98,
		94,
		-1,
		104,
		88,
		-1,
		-1,
		89,
		90,
		74,
		77,
		85,
		83,
		96,
		88,
		83,
		-1,
		-1,
		80,
		76,
		83,
		70,
		66,
		83,
		96,
		78,
		92,
		91,
		-1,
		92,
		109,
		109,
		77,
		75,
		59,
		57,
		75,
		77,
		83,
		83,
		-1,
		109,
		105,
		106,
		104,
		99,
		75,
		62,
		62,
		72,
		65,
		84,
		72,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		110,
		99,
		116,
		102,
		92,
		96,
		94,
		65,
		62,
		60,
		57,
		73,
		71,
		81,
		-1,
		-1,
		203,
		176,
		200,
		158,
		140,
		-1,
		106,
		92,
		98,
		96,
		90,
		83,
		96,
		81,
		-1,
		51,
		50,
		78,
		64,
		75,
		169,
		-1,
		-1,
		161,
		153,
		135,
		138,
		115,
		111,
		107,
		106,
		98,
		84,
		80,
		80,
		83,
		83,
		89,
		45,
		55,
		59,
		57,
		82,
		-1,
		-1,
		117,
		-1,
		-1,
		166,
		149,
		-1,
		130,
		137,
		121,
		127,
		113,
		134,
		117,
		108,
		100,
		94,
		82,
		78,
		75,
		88,
		67,
		42,
		67,
		71,
		52,
		73,
		68,
		-1,
		116,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		127,
		151,
		150,
		-1,
		129,
		117,
		118,
		103,
		100,
		87,
		75,
		83,
		67,
		67,
		64,
		46,
		44,
		74,
		49,
		71,
		68,
		87,
		92,
		86,
		95,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		155,
		-1,
		158,
		166,
		141,
		114,
		117,
		104,
		95,
		82,
		71,
		82,
		65,
		62,
		58,
		38,
		53,
		44,
		43,
		61,
		71,
		79,
		83,
		89,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		175,
		159,
		158,
		143,
		143,
		-1,
		113,
		110,
		100,
		78,
		63,
		77,
		65,
		60,
		51,
		33,
		47,
		38,
		56,
		63,
		61,
		65,
		85,
		97,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		185,
		149,
		-1,
		144,
		-1,
		115,
		128,
		-1,
		84,
		80,
		62,
		63,
		58,
		69,
		44,
		29,
		26,
		44,
		47,
		54,
		58,
		74,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		98,
		95,
		83,
		70,
		55,
		56,
		64,
		64,
		43,
		28,
		25,
		45,
		71,
		49,
		61,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		94,
		73,
		64,
		53,
		51,
		60,
		49,
		43,
		23,
		21,
		40,
		52,
		43,
		63,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		107,
		90,
		71,
		60,
		52,
		41,
		48,
		45,
		37,
		19,
		28,
		34,
		58,
		65,
		71,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		81,
		65,
		60,
		57,
		52,
		39,
		38,
		36,
		26,
		21,
		28,
		63,
		63,
		55,
		80,
		83,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		67,
		63,
		56,
		60,
		54,
		48,
		35,
		30,
		31,
		13,
		49,
		-1,
		63,
		57,
		85,
		75,
		63,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		67,
		63,
		59,
		52,
		40,
		29,
		42,
		35,
		0,
		10,
		41,
		45,
		71,
		65,
		61,
		58,
		72,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		87,
		71,
		68,
		52,
		43,
		51,
		24,
		17,
		3,
		18,
		36,
		65,
		63,
		57,
		56,
		68,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		79,
		90,
		91,
		64,
		52,
		50,
		51,
		39,
		28,
		26,
		30,
		45,
		55,
		51,
		52,
		61,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		93,
		91,
		80,
		66,
		72,
		61,
		48,
		43,
		33,
		22,
		28,
		39,
		61,
		47,
		45,
		64,
		80,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		83,
		67,
		72,
		-1,
		68,
		-1,
		41,
		43,
		41,
		33,
		33,
		44,
		42,
		53,
		70,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		99,
		79,
		73,
		72,
		63,
		71,
		49,
		46,
		39,
		36,
		36,
		49,
		69,
		60,
		72,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		116,
		104,
		94,
		84,
		95,
		83,
		62,
		58,
		44,
		46,
		44,
		45,
		50,
		71,
		72,
		85,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		105,
		-1,
		-1,
		94,
		87,
		75,
		61,
		48,
		68,
		71,
		60,
		44,
		59,
		71,
		79,
		84,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		117,
		106,
		101,
		105,
		93,
		-1,
		77,
		72,
		52,
		66,
		73,
		62,
		57,
		51,
		54,
		72,
		89,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		123,
		94,
		87,
		91,
		-1,
		79,
		68,
		54,
		71,
		75,
		72,
		63,
		55,
		60,
		57,
		70,
		84,
		88,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		133,
		110,
		83,
		78,
		71,
		65,
		62,
		78,
		83,
		94,
		62,
		58,
		59,
		63,
		62,
		79,
		89,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		160,
		-1,
		-1,
		87,
		78,
		69,
		72,
		72,
		75,
		68,
		65,
		70,
		75,
		63,
		72,
		90,
		92,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		158,
		105,
		87,
		83,
		81,
		74,
		83,
		78,
		73,
		83,
		88,
		80,
		65,
		72,
		95,
		84,
		123,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		120,
		117,
		-1,
		87,
		112,
		84,
		91,
		83,
		91,
		91,
		84,
		62,
		69,
		85,
		84,
		79,
		115,
		106,
		112,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		136,
		133,
		109,
		93,
		93,
		86,
		81,
		91,
		71,
		58,
		62,
		66,
		72,
		77,
		82,
		88,
		103,
		118,
		-1,
		174,
		255,
		248,
		219,
		227,
		258,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		109,
		106,
		111,
		100,
		97,
		101,
		96,
		87,
		72,
		78,
		65,
		64,
		82,
		86,
		95,
		102,
		92,
		105,
		109,
		-1,
		188,
		231,
		213,
		216,
		240,
		254,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		108,
		158,
		114,
		109,
		95,
		93,
		84,
		75,
		82,
		73,
		73,
		76,
		91,
		96,
		88,
		102,
		102,
		103,
		-1,
		203,
		211,
		207,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		126,
		130,
		122,
		125,
		109,
		96,
		88,
		80,
		96,
		71,
		81,
		77,
		78,
		87,
		98,
		110,
		109,
		110,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		168,
		207,
		208,
		-1,
		192,
		-1,
		-1,
		-1,
		140,
		135,
		127,
		129,
		108,
		108,
		82,
		86,
		76,
		83,
		93,
		95,
		87,
		91,
		104,
		115,
		118,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		183,
		174,
		201,
		215,
		204,
		199,
		186,
		-1,
		-1,
		163,
		145,
		-1,
		-1,
		115,
		103,
		86,
		87,
		83,
		86,
		101,
		104,
		94,
		92,
		86,
		118,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		202,
		197,
		201,
		217,
		242,
		-1,
		175,
		-1,
		-1,
		160,
		-1,
		-1,
		145,
		108,
		97,
		88,
		94,
		91,
		102,
		112,
		100,
		101,
		91,
		101,
		114,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		231,
		-1,
		-1,
		191,
		171,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		93,
		98,
		118,
		120,
		109,
		103,
		97,
		104,
		103,
		111,
		119,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		181,
		177,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		111,
		115,
		107,
		100,
		95,
		106,
		98,
		102,
		119,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		198,
		184,
		177,
		165,
		163,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		151,
		119,
		124,
		119,
		101,
		112,
		101,
		104,
		118,
		113,
		-1,
		-1,
		184,
		187,
		-1,
		-1,
		188,
		190,
		-1,
		189,
		178,
		163,
		155,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		108,
		133,
		122,
		130,
		125,
		105,
		111,
		114,
		103,
		107,
		119,
		-1,
		-1,
		191,
		192,
		195,
		-1,
		173,
		-1,
		191,
		-1,
		158,
		164,
		152,
		-1,
		-1,
		-1,
		146,
		109,
		130,
		140,
		134,
		132,
		123,
		109,
		116,
		114,
		110,
		121,
		-1,
		-1,
		-1,
		191,
		165,
		198,
		189,
		172,
		152,
		144,
		163,
		-1,
		133,
		-1,
		108,
		110,
		136,
		139,
		145,
		139,
		112,
		127,
		117,
		108,
		117,
		197,
		-1,
		167,
		200,
		164,
		158,
		134,
		138,
		154,
		-1,
		130,
		112,
		-1,
		140,
		130,
		161,
		146,
		127,
		114,
		121,
		121,
		114,
		-1,
		-1,
		-1,
		169,
		168,
		160,
		154,
		154,
		139,
		130,
		-1,
		142,
		124,
		103,
		120,
		120,
		111,
		119,
		151,
		147,
		134,
		134,
		126,
		-1,
		270,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		163,
		158,
		131,
		119,
		125,
		121,
		107,
		113,
		115,
		123,
		121,
		118,
		130,
		126,
		146,
		127,
		162,
		-1,
		265,
		-1,
		199,
		-1,
		-1,
		181,
		161,
		153,
		142,
		131,
		129,
		120,
		111,
		133,
		149,
		133,
		131,
		134,
		135,
		-1,
		254,
		253,
		-1,
		200,
		192,
		178,
		-1,
		171,
		-1,
		177,
		138,
		-1,
		140,
		120,
		-1,
		142,
		138,
		-1,
		-1,
		241,
		216,
		-1,
		-1,
		-1,
		201,
		181,
		172,
		156,
		-1,
		131,
		131,
		-1,
		-1,
		-1,
		226,
		225,
		-1,
		194,
		197,
		-1,
		187,
		178,
		186,
		133,
		137,
		-1,
		-1,
		-1,
		235,
		216,
		210,
		209,
		207,
		202,
		199,
		185,
		169,
		147,
		136,
		157,
		-1,
		-1,
		-1,
		207,
		199,
		192,
		-1,
		-1,
		194,
		177,
		158,
		156,
		-1,
		-1,
		-1,
		229,
		210,
		-1,
		-1,
		184,
		-1,
		-1,
		190,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		218,
		-1,
		-1,
		-1,
		180,
		176,
		177,
		-1,
		-1,
		-1,
		-1,
		240,
		241,
		264,
		228,
		-1,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		243,
		241,
		-1,
		-1,
		-1,
		200,
		184,
		-1,
		170,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		205,
		-1,
		205,
		180,
		187,
		-1,
		-1,
		-1,
		-1,
		218,
		210,
		218,
		-1,
		190,
		192,
		-1,
		240,
		-1,
		-1,
		233,
		224,
		-1,
		-1,
		195,
		202,
		224,
		227,
		263,
		-1,
		214
	],
	[
		-1,
		153,
		142,
		153,
		161,
		134,
		141,
		-1,
		160,
		164,
		130,
		124,
		163,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		153,
		152,
		120,
		118,
		127,
		132,
		139,
		-1,
		138,
		-1,
		174,
		153,
		164,
		169,
		113,
		110,
		130,
		149,
		131,
		123,
		189,
		143,
		114,
		108,
		126,
		116,
		125,
		117,
		-1,
		114,
		104,
		126,
		105,
		116,
		108,
		-1,
		-1,
		108,
		109,
		115,
		101,
		107,
		103,
		-1,
		113,
		97,
		-1,
		-1,
		98,
		99,
		83,
		86,
		94,
		92,
		105,
		97,
		92,
		-1,
		-1,
		89,
		85,
		92,
		79,
		75,
		92,
		105,
		87,
		101,
		100,
		-1,
		101,
		118,
		118,
		86,
		84,
		68,
		66,
		84,
		86,
		92,
		92,
		-1,
		118,
		114,
		115,
		113,
		108,
		84,
		71,
		71,
		81,
		74,
		93,
		81,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		103,
		120,
		111,
		101,
		105,
		103,
		74,
		71,
		69,
		66,
		82,
		80,
		90,
		-1,
		-1,
		212,
		182,
		209,
		167,
		149,
		-1,
		115,
		96,
		102,
		105,
		99,
		92,
		105,
		90,
		-1,
		60,
		59,
		87,
		73,
		84,
		173,
		-1,
		-1,
		170,
		162,
		144,
		147,
		124,
		120,
		111,
		110,
		102,
		88,
		84,
		89,
		92,
		92,
		98,
		54,
		64,
		68,
		66,
		91,
		-1,
		-1,
		126,
		-1,
		-1,
		170,
		153,
		-1,
		136,
		143,
		130,
		136,
		122,
		143,
		121,
		112,
		104,
		98,
		86,
		87,
		84,
		97,
		76,
		51,
		76,
		80,
		61,
		82,
		77,
		-1,
		125,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		129,
		132,
		136,
		160,
		159,
		-1,
		133,
		121,
		122,
		107,
		104,
		91,
		79,
		92,
		76,
		76,
		73,
		55,
		53,
		83,
		58,
		80,
		77,
		96,
		101,
		95,
		104,
		-1,
		178,
		174,
		170,
		177,
		126,
		-1,
		-1,
		164,
		-1,
		167,
		170,
		145,
		118,
		121,
		108,
		99,
		86,
		75,
		86,
		74,
		71,
		67,
		47,
		62,
		53,
		52,
		70,
		80,
		88,
		92,
		98,
		-1,
		228,
		-1,
		170,
		154,
		156,
		128,
		149,
		-1,
		184,
		168,
		162,
		147,
		147,
		-1,
		117,
		114,
		104,
		82,
		67,
		84,
		74,
		69,
		60,
		42,
		56,
		47,
		65,
		72,
		70,
		74,
		94,
		106,
		188,
		178,
		-1,
		160,
		165,
		124,
		132,
		151,
		189,
		153,
		-1,
		148,
		-1,
		119,
		132,
		-1,
		88,
		84,
		66,
		67,
		62,
		77,
		53,
		38,
		35,
		53,
		56,
		63,
		67,
		83,
		-1,
		-1,
		173,
		177,
		166,
		117,
		136,
		160,
		197,
		146,
		135,
		134,
		-1,
		125,
		102,
		99,
		87,
		74,
		59,
		60,
		68,
		73,
		52,
		37,
		34,
		54,
		80,
		58,
		70,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		143,
		114,
		138,
		180,
		164,
		157,
		145,
		110,
		110,
		104,
		-1,
		98,
		77,
		68,
		57,
		55,
		61,
		53,
		49,
		32,
		30,
		49,
		61,
		52,
		72,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		109,
		132,
		169,
		143,
		129,
		134,
		109,
		102,
		96,
		111,
		94,
		75,
		64,
		56,
		45,
		49,
		54,
		46,
		28,
		35,
		43,
		67,
		74,
		80,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		123,
		130,
		162,
		134,
		147,
		-1,
		101,
		-1,
		90,
		85,
		69,
		64,
		61,
		53,
		40,
		47,
		45,
		29,
		27,
		27,
		72,
		72,
		64,
		89,
		92,
		-1,
		-1,
		-1,
		173,
		168,
		143,
		120,
		104,
		140,
		-1,
		117,
		118,
		-1,
		95,
		89,
		86,
		71,
		67,
		57,
		61,
		55,
		52,
		36,
		39,
		35,
		22,
		49,
		-1,
		66,
		66,
		86,
		76,
		64,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		99,
		151,
		-1,
		-1,
		102,
		95,
		-1,
		82,
		64,
		69,
		64,
		63,
		53,
		41,
		30,
		43,
		36,
		16,
		0,
		37,
		41,
		67,
		66,
		62,
		59,
		73,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		119,
		-1,
		111,
		103,
		93,
		87,
		81,
		77,
		75,
		91,
		75,
		69,
		53,
		44,
		52,
		25,
		18,
		10,
		14,
		32,
		61,
		64,
		58,
		57,
		69,
		-1,
		186,
		172,
		143,
		-1,
		-1,
		132,
		-1,
		96,
		110,
		126,
		-1,
		119,
		98,
		113,
		91,
		87,
		81,
		91,
		92,
		65,
		53,
		51,
		52,
		40,
		29,
		22,
		26,
		41,
		51,
		52,
		53,
		62,
		-1,
		192,
		179,
		137,
		133,
		122,
		142,
		93,
		81,
		113,
		-1,
		-1,
		155,
		-1,
		89,
		106,
		95,
		93,
		81,
		67,
		73,
		62,
		49,
		44,
		34,
		23,
		29,
		37,
		62,
		48,
		46,
		65,
		81,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		108,
		95,
		89,
		-1,
		130,
		-1,
		133,
		123,
		107,
		92,
		125,
		-1,
		84,
		68,
		73,
		-1,
		69,
		-1,
		42,
		44,
		42,
		34,
		34,
		45,
		43,
		54,
		71,
		-1,
		142,
		127,
		120,
		110,
		124,
		95,
		-1,
		150,
		-1,
		-1,
		120,
		114,
		114,
		98,
		101,
		100,
		80,
		74,
		73,
		64,
		72,
		50,
		47,
		40,
		37,
		37,
		50,
		70,
		61,
		73,
		-1,
		-1,
		-1,
		147,
		133,
		137,
		97,
		116,
		-1,
		-1,
		182,
		137,
		123,
		-1,
		107,
		117,
		105,
		95,
		85,
		96,
		84,
		63,
		59,
		45,
		47,
		45,
		46,
		51,
		72,
		73,
		86,
		-1,
		-1,
		130,
		135,
		123,
		109,
		128,
		-1,
		-1,
		-1,
		129,
		145,
		137,
		108,
		106,
		-1,
		-1,
		95,
		88,
		76,
		62,
		49,
		69,
		72,
		61,
		45,
		60,
		72,
		80,
		85,
		-1,
		133,
		120,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		-1,
		-1,
		162,
		118,
		107,
		102,
		106,
		94,
		-1,
		78,
		73,
		53,
		67,
		74,
		63,
		58,
		52,
		55,
		73,
		90,
		-1,
		-1,
		145,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		119,
		124,
		95,
		88,
		92,
		-1,
		80,
		69,
		55,
		72,
		76,
		73,
		64,
		56,
		61,
		58,
		71,
		85,
		89,
		168,
		-1,
		151,
		-1,
		-1,
		-1,
		137,
		152,
		134,
		111,
		84,
		79,
		72,
		66,
		63,
		79,
		84,
		95,
		63,
		59,
		60,
		64,
		63,
		80,
		90,
		-1,
		-1,
		151,
		168,
		163,
		145,
		149,
		161,
		-1,
		-1,
		88,
		79,
		70,
		73,
		73,
		76,
		69,
		66,
		71,
		76,
		64,
		73,
		91,
		95,
		-1,
		-1,
		-1,
		171,
		-1,
		186,
		-1,
		-1,
		164,
		159,
		106,
		88,
		84,
		82,
		75,
		84,
		79,
		74,
		84,
		94,
		86,
		66,
		79,
		101,
		91,
		127,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		177,
		169,
		164,
		170,
		172,
		163,
		121,
		118,
		-1,
		88,
		113,
		85,
		92,
		84,
		92,
		92,
		90,
		69,
		76,
		92,
		91,
		86,
		119,
		113,
		119,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		170,
		166,
		156,
		146,
		149,
		-1,
		-1,
		137,
		134,
		110,
		94,
		98,
		91,
		86,
		98,
		78,
		65,
		69,
		73,
		79,
		84,
		89,
		95,
		110,
		125,
		-1,
		178,
		259,
		252,
		220,
		228,
		259,
		-1,
		160,
		152,
		163,
		138,
		140,
		-1,
		-1,
		110,
		107,
		112,
		101,
		98,
		108,
		103,
		94,
		79,
		85,
		72,
		71,
		89,
		93,
		102,
		109,
		99,
		112,
		116,
		-1,
		192,
		235,
		214,
		217,
		241,
		255,
		-1,
		157,
		-1,
		-1,
		169,
		141,
		125,
		115,
		109,
		159,
		115,
		110,
		102,
		100,
		91,
		82,
		89,
		80,
		80,
		83,
		98,
		103,
		95,
		109,
		109,
		110,
		-1,
		204,
		215,
		208,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		185,
		-1,
		152,
		-1,
		127,
		131,
		123,
		126,
		116,
		103,
		95,
		87,
		103,
		78,
		88,
		84,
		85,
		94,
		105,
		117,
		116,
		117,
		229,
		185,
		188,
		199,
		210,
		225,
		229,
		-1,
		169,
		208,
		215,
		-1,
		194,
		-1,
		-1,
		-1,
		141,
		136,
		128,
		136,
		115,
		115,
		89,
		93,
		83,
		90,
		100,
		102,
		94,
		98,
		111,
		122,
		125,
		225,
		216,
		229,
		174,
		174,
		195,
		204,
		225,
		184,
		175,
		202,
		222,
		211,
		206,
		193,
		-1,
		-1,
		164,
		146,
		-1,
		-1,
		122,
		110,
		93,
		94,
		90,
		93,
		108,
		111,
		101,
		99,
		93,
		125,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		165,
		192,
		-1,
		-1,
		187,
		203,
		198,
		202,
		218,
		243,
		-1,
		182,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		115,
		104,
		95,
		101,
		98,
		109,
		119,
		107,
		108,
		98,
		108,
		121,
		202,
		199,
		187,
		185,
		208,
		173,
		161,
		-1,
		174,
		172,
		178,
		185,
		202,
		232,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		100,
		105,
		125,
		127,
		116,
		110,
		104,
		111,
		110,
		118,
		126,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		159,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		118,
		122,
		114,
		107,
		102,
		113,
		105,
		109,
		126,
		-1,
		245,
		-1,
		197,
		173,
		187,
		202,
		210,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		158,
		126,
		131,
		126,
		108,
		119,
		108,
		111,
		125,
		120,
		-1,
		-1,
		185,
		188,
		-1,
		-1,
		195,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		115,
		140,
		129,
		137,
		132,
		112,
		118,
		121,
		110,
		114,
		126,
		-1,
		-1,
		192,
		193,
		198,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		153,
		116,
		137,
		147,
		141,
		139,
		130,
		116,
		123,
		121,
		117,
		128,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		117,
		143,
		146,
		152,
		146,
		119,
		134,
		124,
		115,
		124,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		168,
		153,
		134,
		121,
		128,
		128,
		121,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		158,
		154,
		141,
		141,
		133,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		134,
		169,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		141,
		142,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		177,
		181,
		147,
		141,
		180,
		149,
		155,
		166,
		-1,
		-1,
		-1,
		170,
		169,
		137,
		135,
		144,
		149,
		156,
		-1,
		155,
		-1,
		191,
		170,
		181,
		186,
		130,
		127,
		147,
		166,
		148,
		140,
		206,
		160,
		131,
		125,
		143,
		133,
		142,
		134,
		-1,
		131,
		121,
		143,
		122,
		133,
		125,
		-1,
		-1,
		125,
		126,
		132,
		118,
		124,
		120,
		-1,
		130,
		114,
		-1,
		-1,
		115,
		116,
		100,
		103,
		111,
		109,
		122,
		114,
		109,
		-1,
		-1,
		106,
		102,
		109,
		96,
		92,
		109,
		122,
		104,
		118,
		117,
		-1,
		118,
		135,
		135,
		103,
		101,
		85,
		83,
		101,
		103,
		109,
		109,
		-1,
		135,
		131,
		132,
		130,
		125,
		101,
		88,
		88,
		98,
		91,
		110,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		125,
		142,
		128,
		118,
		122,
		120,
		91,
		88,
		86,
		83,
		99,
		97,
		107,
		-1,
		-1,
		229,
		202,
		226,
		184,
		166,
		-1,
		132,
		118,
		124,
		122,
		116,
		109,
		122,
		107,
		-1,
		77,
		76,
		104,
		90,
		101,
		195,
		-1,
		-1,
		187,
		179,
		161,
		164,
		141,
		137,
		133,
		132,
		124,
		110,
		106,
		106,
		109,
		109,
		115,
		71,
		81,
		85,
		83,
		108,
		-1,
		-1,
		136,
		-1,
		-1,
		192,
		175,
		-1,
		156,
		163,
		147,
		153,
		139,
		160,
		143,
		134,
		126,
		120,
		108,
		104,
		101,
		114,
		93,
		68,
		93,
		97,
		78,
		99,
		94,
		-1,
		135,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		151,
		154,
		153,
		177,
		176,
		-1,
		155,
		143,
		144,
		129,
		126,
		113,
		101,
		109,
		93,
		93,
		90,
		72,
		70,
		100,
		75,
		97,
		94,
		106,
		111,
		105,
		114,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		181,
		-1,
		184,
		192,
		167,
		140,
		143,
		130,
		121,
		108,
		97,
		108,
		91,
		88,
		84,
		64,
		79,
		70,
		69,
		87,
		90,
		98,
		102,
		108,
		-1,
		250,
		-1,
		192,
		176,
		178,
		150,
		171,
		-1,
		201,
		185,
		184,
		169,
		169,
		-1,
		139,
		136,
		126,
		104,
		89,
		103,
		91,
		86,
		77,
		59,
		73,
		64,
		77,
		84,
		80,
		84,
		104,
		116,
		210,
		200,
		-1,
		182,
		187,
		146,
		154,
		173,
		211,
		175,
		-1,
		170,
		-1,
		141,
		154,
		-1,
		110,
		106,
		88,
		89,
		84,
		95,
		70,
		55,
		52,
		70,
		68,
		73,
		77,
		93,
		-1,
		-1,
		195,
		199,
		188,
		139,
		158,
		182,
		219,
		168,
		157,
		156,
		-1,
		147,
		124,
		121,
		109,
		96,
		81,
		82,
		90,
		90,
		69,
		54,
		51,
		64,
		90,
		68,
		80,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		165,
		136,
		160,
		202,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		120,
		99,
		90,
		79,
		77,
		89,
		75,
		69,
		49,
		47,
		59,
		71,
		62,
		82,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		131,
		154,
		191,
		165,
		151,
		156,
		131,
		124,
		118,
		133,
		116,
		97,
		86,
		78,
		67,
		75,
		71,
		63,
		45,
		54,
		53,
		77,
		74,
		80,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		145,
		152,
		184,
		156,
		169,
		-1,
		123,
		-1,
		112,
		107,
		91,
		86,
		83,
		80,
		68,
		64,
		62,
		52,
		47,
		54,
		82,
		82,
		68,
		89,
		92,
		-1,
		-1,
		-1,
		195,
		190,
		165,
		142,
		126,
		162,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		93,
		89,
		84,
		88,
		81,
		74,
		64,
		56,
		57,
		39,
		49,
		-1,
		64,
		70,
		94,
		95,
		83,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		121,
		173,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		93,
		91,
		85,
		86,
		74,
		63,
		72,
		64,
		44,
		38,
		0,
		39,
		65,
		82,
		81,
		78,
		92,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		141,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		113,
		97,
		100,
		86,
		77,
		85,
		58,
		51,
		43,
		28,
		4,
		59,
		74,
		69,
		73,
		88,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		105,
		120,
		121,
		98,
		86,
		84,
		81,
		69,
		58,
		34,
		39,
		39,
		49,
		67,
		69,
		78,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		119,
		117,
		110,
		100,
		106,
		95,
		78,
		73,
		63,
		52,
		58,
		48,
		81,
		67,
		65,
		81,
		97,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		117,
		101,
		106,
		-1,
		98,
		-1,
		65,
		67,
		65,
		56,
		53,
		64,
		62,
		73,
		87,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		133,
		113,
		107,
		106,
		93,
		97,
		79,
		69,
		62,
		59,
		56,
		66,
		89,
		80,
		89,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		150,
		138,
		128,
		118,
		123,
		111,
		88,
		81,
		67,
		69,
		67,
		65,
		70,
		91,
		92,
		104,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		139,
		-1,
		-1,
		122,
		115,
		103,
		84,
		71,
		91,
		94,
		80,
		64,
		79,
		91,
		96,
		104,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		184,
		137,
		126,
		121,
		125,
		121,
		-1,
		97,
		95,
		75,
		89,
		96,
		82,
		77,
		71,
		74,
		92,
		107,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		141,
		143,
		114,
		107,
		111,
		-1,
		99,
		91,
		77,
		94,
		95,
		92,
		83,
		75,
		80,
		77,
		90,
		104,
		108,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		159,
		174,
		153,
		130,
		103,
		98,
		91,
		85,
		85,
		101,
		103,
		114,
		82,
		78,
		79,
		83,
		82,
		99,
		109,
		-1,
		-1,
		173,
		190,
		185,
		167,
		171,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		95,
		98,
		88,
		85,
		90,
		95,
		83,
		92,
		110,
		114,
		-1,
		-1,
		-1,
		193,
		-1,
		208,
		-1,
		-1,
		186,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		113,
		105,
		85,
		98,
		120,
		110,
		146,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		196,
		188,
		183,
		189,
		191,
		182,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		103,
		111,
		111,
		109,
		88,
		95,
		111,
		110,
		105,
		138,
		132,
		138,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		189,
		185,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		113,
		117,
		110,
		105,
		117,
		97,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		200,
		278,
		271,
		239,
		247,
		278,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		120,
		117,
		127,
		122,
		113,
		98,
		104,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		214,
		254,
		233,
		236,
		260,
		274,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		128,
		178,
		134,
		129,
		121,
		119,
		110,
		101,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		223,
		234,
		227,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		146,
		150,
		142,
		145,
		135,
		122,
		114,
		106,
		122,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		248,
		204,
		207,
		218,
		229,
		244,
		248,
		-1,
		188,
		227,
		234,
		-1,
		213,
		-1,
		-1,
		-1,
		160,
		155,
		147,
		155,
		134,
		134,
		108,
		112,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		244,
		235,
		248,
		193,
		193,
		214,
		223,
		244,
		203,
		194,
		221,
		241,
		230,
		225,
		212,
		-1,
		-1,
		183,
		165,
		-1,
		-1,
		141,
		129,
		112,
		113,
		109,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		211,
		-1,
		-1,
		206,
		222,
		217,
		221,
		237,
		262,
		-1,
		201,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		117,
		128,
		138,
		126,
		127,
		117,
		127,
		140,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		144,
		146,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		137,
		141,
		133,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		214,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		211,
		212,
		217,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		160,
		158,
		149,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		136,
		162,
		165,
		171,
		165,
		138,
		153,
		143,
		134,
		143,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		187,
		172,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		177,
		173,
		160,
		160,
		152,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		153,
		188,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		160,
		161,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		183,
		187,
		153,
		147,
		186,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		176,
		175,
		143,
		141,
		150,
		155,
		162,
		-1,
		161,
		-1,
		197,
		176,
		187,
		192,
		136,
		133,
		153,
		172,
		154,
		146,
		212,
		166,
		137,
		131,
		149,
		139,
		148,
		140,
		-1,
		137,
		127,
		149,
		128,
		139,
		131,
		-1,
		-1,
		131,
		132,
		138,
		124,
		130,
		126,
		-1,
		136,
		120,
		-1,
		-1,
		121,
		122,
		106,
		109,
		117,
		115,
		128,
		120,
		115,
		-1,
		-1,
		112,
		108,
		115,
		102,
		98,
		115,
		128,
		110,
		124,
		123,
		-1,
		124,
		141,
		141,
		109,
		107,
		91,
		89,
		107,
		109,
		115,
		115,
		-1,
		141,
		137,
		138,
		136,
		131,
		107,
		94,
		94,
		104,
		97,
		116,
		104,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		131,
		148,
		134,
		124,
		128,
		126,
		97,
		94,
		92,
		89,
		105,
		103,
		113,
		-1,
		-1,
		235,
		208,
		232,
		190,
		172,
		-1,
		138,
		124,
		130,
		128,
		122,
		115,
		128,
		113,
		-1,
		83,
		82,
		110,
		96,
		107,
		201,
		-1,
		-1,
		193,
		185,
		167,
		170,
		147,
		143,
		139,
		138,
		130,
		116,
		112,
		112,
		115,
		115,
		121,
		77,
		87,
		91,
		89,
		103,
		-1,
		-1,
		117,
		-1,
		-1,
		198,
		181,
		-1,
		162,
		169,
		153,
		159,
		145,
		166,
		149,
		140,
		132,
		126,
		114,
		110,
		107,
		120,
		99,
		74,
		99,
		103,
		84,
		93,
		88,
		-1,
		116,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		157,
		160,
		159,
		183,
		182,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		115,
		99,
		99,
		96,
		78,
		76,
		106,
		81,
		92,
		82,
		87,
		92,
		86,
		95,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		187,
		-1,
		190,
		198,
		173,
		146,
		149,
		136,
		127,
		114,
		103,
		114,
		97,
		94,
		90,
		70,
		85,
		76,
		75,
		71,
		71,
		79,
		83,
		89,
		-1,
		256,
		-1,
		198,
		182,
		184,
		156,
		177,
		-1,
		207,
		191,
		190,
		175,
		175,
		-1,
		145,
		142,
		132,
		110,
		95,
		109,
		97,
		92,
		83,
		65,
		79,
		70,
		77,
		75,
		61,
		65,
		85,
		97,
		216,
		206,
		-1,
		188,
		193,
		152,
		160,
		179,
		217,
		181,
		-1,
		176,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		95,
		90,
		101,
		76,
		61,
		58,
		73,
		68,
		54,
		58,
		74,
		-1,
		-1,
		201,
		205,
		194,
		145,
		164,
		188,
		225,
		174,
		163,
		162,
		-1,
		153,
		130,
		127,
		115,
		102,
		87,
		88,
		96,
		96,
		75,
		60,
		57,
		64,
		71,
		49,
		56,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		171,
		142,
		166,
		208,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		126,
		105,
		96,
		85,
		83,
		95,
		81,
		75,
		55,
		53,
		59,
		52,
		43,
		47,
		-1,
		-1,
		-1,
		201,
		190,
		191,
		137,
		160,
		197,
		171,
		157,
		162,
		137,
		130,
		124,
		139,
		122,
		103,
		92,
		84,
		73,
		81,
		77,
		69,
		51,
		60,
		53,
		58,
		35,
		41,
		-1,
		-1,
		208,
		198,
		182,
		184,
		181,
		151,
		158,
		190,
		162,
		175,
		-1,
		129,
		-1,
		118,
		113,
		97,
		92,
		89,
		86,
		74,
		70,
		68,
		58,
		53,
		60,
		63,
		63,
		29,
		50,
		53,
		-1,
		-1,
		-1,
		201,
		196,
		171,
		148,
		132,
		168,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		99,
		95,
		90,
		94,
		87,
		80,
		70,
		62,
		63,
		45,
		55,
		-1,
		25,
		31,
		55,
		62,
		52,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		127,
		179,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		99,
		97,
		91,
		92,
		80,
		69,
		78,
		70,
		50,
		44,
		41,
		0,
		38,
		43,
		48,
		47,
		61,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		147,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		119,
		103,
		106,
		92,
		83,
		91,
		64,
		57,
		49,
		34,
		36,
		52,
		56,
		62,
		54,
		57,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		111,
		126,
		127,
		104,
		92,
		90,
		87,
		75,
		64,
		40,
		45,
		41,
		51,
		57,
		57,
		59,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		125,
		123,
		116,
		106,
		112,
		101,
		84,
		79,
		69,
		58,
		64,
		50,
		79,
		65,
		63,
		58,
		73,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		123,
		107,
		112,
		-1,
		104,
		-1,
		71,
		73,
		71,
		62,
		59,
		70,
		66,
		79,
		64,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		139,
		119,
		113,
		112,
		99,
		103,
		85,
		75,
		68,
		65,
		62,
		68,
		91,
		78,
		66,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		156,
		144,
		134,
		124,
		129,
		117,
		94,
		87,
		73,
		75,
		73,
		71,
		76,
		79,
		71,
		81,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		165,
		136,
		145,
		-1,
		-1,
		128,
		121,
		109,
		90,
		77,
		97,
		100,
		86,
		70,
		85,
		85,
		73,
		82,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		190,
		143,
		132,
		127,
		131,
		127,
		-1,
		103,
		101,
		81,
		95,
		102,
		88,
		83,
		77,
		80,
		90,
		84,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		147,
		149,
		120,
		113,
		117,
		-1,
		105,
		97,
		83,
		100,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		96,
		86,
		196,
		-1,
		179,
		-1,
		-1,
		-1,
		165,
		180,
		159,
		136,
		109,
		104,
		97,
		91,
		91,
		107,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		100,
		101,
		-1,
		-1,
		179,
		196,
		191,
		173,
		177,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		101,
		104,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		104,
		-1,
		-1,
		-1,
		199,
		-1,
		214,
		-1,
		-1,
		192,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		119,
		111,
		91,
		104,
		126,
		112,
		133,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		202,
		194,
		189,
		195,
		197,
		188,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		109,
		117,
		117,
		115,
		94,
		101,
		117,
		116,
		111,
		125,
		120,
		129,
		-1,
		-1,
		293,
		282,
		271,
		277,
		-1,
		195,
		191,
		181,
		171,
		174,
		-1,
		-1,
		162,
		159,
		135,
		119,
		123,
		116,
		111,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		127,
		135,
		-1,
		206,
		284,
		277,
		245,
		253,
		284,
		-1,
		185,
		177,
		188,
		163,
		165,
		-1,
		-1,
		135,
		132,
		137,
		126,
		123,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		134,
		124,
		137,
		141,
		-1,
		220,
		260,
		239,
		242,
		266,
		280,
		-1,
		182,
		-1,
		-1,
		194,
		166,
		150,
		140,
		134,
		184,
		140,
		135,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		134,
		134,
		135,
		-1,
		229,
		240,
		233,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		210,
		-1,
		177,
		-1,
		152,
		156,
		148,
		151,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		141,
		142,
		254,
		210,
		213,
		224,
		235,
		250,
		254,
		-1,
		194,
		233,
		240,
		-1,
		219,
		-1,
		-1,
		-1,
		166,
		161,
		153,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		150,
		250,
		241,
		254,
		199,
		199,
		220,
		229,
		250,
		209,
		200,
		227,
		247,
		236,
		231,
		218,
		-1,
		-1,
		189,
		171,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		217,
		-1,
		-1,
		212,
		228,
		223,
		227,
		243,
		268,
		-1,
		207,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		199,
		197,
		203,
		210,
		227,
		257,
		-1,
		-1,
		223,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		270,
		-1,
		222,
		198,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		217,
		218,
		223,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		188,
		192,
		158,
		152,
		191,
		160,
		166,
		177,
		-1,
		-1,
		-1,
		181,
		180,
		148,
		146,
		155,
		160,
		167,
		-1,
		166,
		-1,
		202,
		181,
		192,
		197,
		141,
		138,
		158,
		177,
		159,
		151,
		217,
		171,
		142,
		136,
		154,
		144,
		153,
		145,
		-1,
		142,
		132,
		154,
		133,
		144,
		136,
		-1,
		-1,
		136,
		137,
		143,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		126,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		127,
		-1,
		129,
		146,
		146,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		119,
		-1,
		146,
		142,
		143,
		141,
		136,
		112,
		99,
		99,
		109,
		102,
		121,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		132,
		149,
		139,
		129,
		133,
		131,
		102,
		99,
		97,
		94,
		110,
		107,
		117,
		-1,
		-1,
		240,
		211,
		237,
		195,
		177,
		-1,
		143,
		125,
		131,
		133,
		127,
		120,
		133,
		118,
		-1,
		88,
		87,
		114,
		100,
		111,
		202,
		-1,
		-1,
		198,
		190,
		172,
		175,
		152,
		148,
		140,
		139,
		131,
		117,
		113,
		117,
		120,
		120,
		126,
		82,
		92,
		96,
		93,
		96,
		-1,
		-1,
		110,
		-1,
		-1,
		199,
		182,
		-1,
		165,
		172,
		158,
		164,
		150,
		171,
		150,
		141,
		133,
		127,
		115,
		115,
		112,
		125,
		104,
		79,
		104,
		108,
		88,
		86,
		81,
		-1,
		109,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		158,
		161,
		164,
		188,
		187,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		120,
		104,
		104,
		101,
		83,
		81,
		111,
		85,
		85,
		75,
		80,
		85,
		79,
		88,
		-1,
		207,
		203,
		199,
		206,
		155,
		-1,
		-1,
		192,
		-1,
		195,
		199,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		102,
		99,
		95,
		75,
		90,
		80,
		79,
		64,
		64,
		72,
		76,
		82,
		-1,
		257,
		-1,
		199,
		183,
		185,
		157,
		178,
		-1,
		212,
		196,
		191,
		176,
		176,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		102,
		97,
		88,
		70,
		84,
		74,
		70,
		68,
		54,
		58,
		78,
		90,
		217,
		207,
		-1,
		189,
		194,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		81,
		66,
		63,
		66,
		61,
		47,
		51,
		67,
		-1,
		-1,
		202,
		206,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		101,
		80,
		65,
		67,
		57,
		64,
		42,
		49,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		86,
		81,
		65,
		63,
		52,
		45,
		36,
		40,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		140,
		123,
		104,
		93,
		85,
		74,
		87,
		93,
		85,
		61,
		66,
		46,
		51,
		28,
		34,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		81,
		80,
		90,
		88,
		71,
		66,
		78,
		56,
		56,
		22,
		43,
		46,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		85,
		89,
		88,
		94,
		82,
		82,
		83,
		65,
		75,
		-1,
		11,
		23,
		45,
		45,
		42,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		97,
		92,
		91,
		90,
		87,
		76,
		89,
		82,
		70,
		64,
		61,
		33,
		0,
		26,
		31,
		37,
		51,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		119,
		103,
		102,
		99,
		90,
		98,
		71,
		64,
		69,
		54,
		56,
		14,
		18,
		33,
		37,
		47,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		109,
		126,
		127,
		105,
		99,
		97,
		88,
		76,
		65,
		60,
		56,
		27,
		24,
		31,
		33,
		42,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		123,
		121,
		116,
		107,
		113,
		108,
		85,
		80,
		70,
		59,
		59,
		52,
		51,
		37,
		35,
		45,
		61,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		124,
		108,
		113,
		-1,
		105,
		-1,
		78,
		75,
		66,
		51,
		48,
		47,
		38,
		51,
		51,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		140,
		120,
		114,
		113,
		100,
		92,
		86,
		64,
		57,
		54,
		51,
		64,
		71,
		58,
		53,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		147,
		135,
		125,
		115,
		118,
		108,
		83,
		76,
		62,
		64,
		62,
		60,
		60,
		66,
		58,
		68,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		136,
		-1,
		-1,
		119,
		110,
		100,
		79,
		66,
		86,
		85,
		70,
		54,
		69,
		72,
		60,
		69,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		187,
		132,
		121,
		116,
		120,
		118,
		-1,
		92,
		90,
		70,
		84,
		91,
		72,
		67,
		61,
		64,
		77,
		71,
		-1,
		-1,
		174,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		144,
		138,
		109,
		102,
		106,
		-1,
		94,
		86,
		72,
		89,
		85,
		82,
		73,
		65,
		70,
		67,
		80,
		83,
		73,
		197,
		-1,
		180,
		-1,
		-1,
		-1,
		162,
		177,
		148,
		125,
		98,
		93,
		86,
		80,
		80,
		96,
		93,
		104,
		72,
		68,
		69,
		73,
		72,
		87,
		88,
		-1,
		-1,
		180,
		196,
		188,
		170,
		174,
		175,
		-1,
		-1,
		102,
		93,
		84,
		87,
		90,
		93,
		78,
		75,
		80,
		85,
		73,
		82,
		100,
		91,
		-1,
		-1,
		-1,
		200,
		-1,
		214,
		-1,
		-1,
		189,
		173,
		120,
		102,
		98,
		96,
		89,
		98,
		90,
		83,
		93,
		103,
		95,
		75,
		93,
		110,
		99,
		123,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		191,
		183,
		178,
		184,
		186,
		177,
		135,
		132,
		-1,
		102,
		127,
		96,
		103,
		95,
		101,
		101,
		99,
		80,
		90,
		106,
		105,
		100,
		115,
		110,
		119,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		184,
		180,
		170,
		160,
		163,
		-1,
		-1,
		151,
		148,
		124,
		105,
		111,
		104,
		99,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		117,
		125,
		-1,
		207,
		270,
		263,
		231,
		239,
		270,
		-1,
		174,
		166,
		177,
		152,
		154,
		-1,
		-1,
		124,
		121,
		124,
		112,
		109,
		122,
		117,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		221,
		246,
		225,
		228,
		252,
		266,
		-1,
		171,
		-1,
		-1,
		183,
		155,
		139,
		129,
		123,
		171,
		126,
		121,
		116,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		199,
		-1,
		166,
		-1,
		141,
		145,
		134,
		137,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		183,
		222,
		229,
		-1,
		208,
		-1,
		-1,
		-1,
		155,
		147,
		139,
		150,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		198,
		189,
		216,
		236,
		225,
		220,
		207,
		-1,
		-1,
		178,
		157,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		217,
		209,
		213,
		229,
		254,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		185,
		183,
		189,
		196,
		213,
		243,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		256,
		-1,
		208,
		184,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		196,
		199,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		203,
		204,
		209,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		175,
		164,
		175,
		183,
		156,
		163,
		-1,
		182,
		186,
		152,
		146,
		185,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		175,
		174,
		142,
		140,
		149,
		154,
		161,
		-1,
		160,
		-1,
		196,
		175,
		186,
		191,
		135,
		132,
		152,
		171,
		153,
		145,
		211,
		165,
		136,
		130,
		148,
		138,
		147,
		139,
		-1,
		136,
		126,
		148,
		127,
		138,
		130,
		-1,
		-1,
		130,
		131,
		137,
		123,
		129,
		125,
		-1,
		135,
		119,
		-1,
		-1,
		120,
		121,
		105,
		108,
		116,
		114,
		127,
		119,
		114,
		-1,
		-1,
		111,
		107,
		114,
		101,
		97,
		114,
		127,
		109,
		123,
		121,
		-1,
		123,
		140,
		140,
		108,
		106,
		90,
		88,
		106,
		108,
		114,
		113,
		-1,
		139,
		136,
		135,
		135,
		130,
		106,
		93,
		93,
		103,
		96,
		115,
		102,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		122,
		139,
		131,
		121,
		127,
		125,
		96,
		93,
		91,
		88,
		104,
		101,
		111,
		-1,
		-1,
		231,
		200,
		230,
		188,
		169,
		-1,
		135,
		115,
		121,
		125,
		119,
		112,
		126,
		112,
		-1,
		82,
		81,
		108,
		94,
		105,
		191,
		-1,
		-1,
		189,
		181,
		165,
		168,
		145,
		141,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		76,
		86,
		90,
		87,
		90,
		-1,
		-1,
		104,
		-1,
		-1,
		188,
		171,
		-1,
		154,
		161,
		151,
		157,
		143,
		164,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		98,
		73,
		98,
		102,
		82,
		80,
		75,
		-1,
		103,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		156,
		180,
		180,
		-1,
		152,
		140,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		98,
		95,
		77,
		75,
		105,
		79,
		79,
		69,
		74,
		79,
		73,
		82,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		184,
		-1,
		188,
		189,
		164,
		137,
		140,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		89,
		69,
		84,
		74,
		73,
		58,
		58,
		66,
		70,
		76,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		204,
		189,
		181,
		166,
		165,
		-1,
		136,
		133,
		123,
		101,
		86,
		103,
		95,
		91,
		82,
		64,
		78,
		68,
		64,
		62,
		48,
		52,
		72,
		84,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		207,
		171,
		-1,
		166,
		-1,
		138,
		151,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		75,
		60,
		57,
		60,
		55,
		41,
		45,
		61,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		164,
		153,
		152,
		-1,
		143,
		121,
		118,
		106,
		93,
		78,
		79,
		87,
		95,
		74,
		59,
		61,
		51,
		58,
		36,
		47,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		117,
		96,
		87,
		76,
		74,
		87,
		80,
		75,
		59,
		57,
		46,
		39,
		30,
		38,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		161,
		147,
		152,
		127,
		120,
		114,
		130,
		113,
		94,
		83,
		75,
		64,
		76,
		84,
		79,
		55,
		60,
		40,
		45,
		26,
		32,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		152,
		165,
		-1,
		119,
		-1,
		108,
		104,
		88,
		83,
		80,
		68,
		67,
		80,
		81,
		65,
		60,
		72,
		50,
		50,
		16,
		34,
		37,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		135,
		136,
		-1,
		113,
		107,
		104,
		90,
		86,
		72,
		76,
		78,
		81,
		69,
		75,
		76,
		58,
		74,
		-1,
		22,
		13,
		24,
		19,
		16,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		120,
		113,
		-1,
		100,
		82,
		84,
		79,
		78,
		77,
		74,
		63,
		76,
		69,
		63,
		57,
		70,
		39,
		23,
		0,
		5,
		11,
		25,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		129,
		121,
		111,
		105,
		99,
		95,
		93,
		106,
		90,
		89,
		86,
		77,
		85,
		58,
		51,
		62,
		47,
		65,
		32,
		27,
		26,
		18,
		21,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		150,
		-1,
		114,
		128,
		144,
		-1,
		137,
		116,
		131,
		109,
		105,
		96,
		113,
		114,
		92,
		86,
		84,
		75,
		63,
		52,
		55,
		47,
		45,
		37,
		21,
		21,
		23,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		111,
		99,
		131,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		110,
		108,
		103,
		94,
		100,
		95,
		72,
		67,
		57,
		46,
		46,
		41,
		43,
		29,
		27,
		22,
		37,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		111,
		95,
		100,
		-1,
		92,
		-1,
		65,
		62,
		53,
		38,
		35,
		39,
		30,
		43,
		28,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		168,
		-1,
		-1,
		138,
		132,
		132,
		116,
		119,
		127,
		107,
		101,
		100,
		87,
		79,
		73,
		51,
		44,
		41,
		38,
		51,
		63,
		42,
		30,
		-1,
		-1,
		-1,
		165,
		151,
		155,
		115,
		134,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		125,
		134,
		122,
		112,
		102,
		105,
		95,
		70,
		63,
		49,
		51,
		49,
		47,
		52,
		43,
		35,
		45,
		-1,
		-1,
		148,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		147,
		163,
		155,
		126,
		123,
		-1,
		-1,
		106,
		97,
		87,
		66,
		53,
		73,
		76,
		62,
		46,
		59,
		49,
		37,
		46,
		-1,
		151,
		138,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		77,
		57,
		71,
		78,
		64,
		59,
		53,
		54,
		54,
		48,
		-1,
		-1,
		163,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		73,
		59,
		76,
		77,
		74,
		65,
		57,
		62,
		51,
		64,
		60,
		50,
		186,
		-1,
		169,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		67,
		83,
		85,
		96,
		64,
		60,
		61,
		57,
		56,
		64,
		65,
		-1,
		-1,
		169,
		183,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		74,
		77,
		80,
		70,
		67,
		72,
		74,
		65,
		66,
		83,
		68,
		-1,
		-1,
		-1,
		189,
		-1,
		201,
		-1,
		-1,
		176,
		160,
		107,
		89,
		85,
		83,
		76,
		85,
		80,
		75,
		85,
		92,
		84,
		64,
		78,
		94,
		76,
		97,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		178,
		170,
		165,
		171,
		173,
		164,
		122,
		119,
		-1,
		89,
		114,
		86,
		93,
		85,
		93,
		93,
		88,
		68,
		75,
		91,
		88,
		85,
		89,
		84,
		93,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		138,
		135,
		111,
		95,
		99,
		92,
		87,
		97,
		77,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		91,
		99,
		-1,
		196,
		260,
		253,
		221,
		229,
		260,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		111,
		108,
		113,
		102,
		99,
		107,
		102,
		93,
		78,
		84,
		71,
		70,
		88,
		92,
		101,
		105,
		94,
		107,
		111,
		-1,
		210,
		236,
		215,
		218,
		242,
		256,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		110,
		160,
		116,
		111,
		101,
		99,
		90,
		81,
		88,
		79,
		79,
		82,
		97,
		102,
		94,
		104,
		104,
		105,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		186,
		-1,
		153,
		-1,
		128,
		132,
		124,
		127,
		115,
		102,
		94,
		86,
		102,
		77,
		87,
		83,
		84,
		93,
		104,
		116,
		111,
		112,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		170,
		209,
		214,
		-1,
		195,
		-1,
		-1,
		-1,
		142,
		137,
		129,
		135,
		114,
		114,
		88,
		92,
		82,
		89,
		99,
		101,
		93,
		97,
		110,
		121,
		120,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		185,
		176,
		203,
		221,
		210,
		205,
		192,
		-1,
		-1,
		165,
		147,
		-1,
		-1,
		121,
		109,
		92,
		93,
		89,
		92,
		107,
		110,
		100,
		98,
		92,
		124,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		204,
		199,
		203,
		219,
		244,
		-1,
		181,
		-1,
		-1,
		166,
		-1,
		-1,
		151,
		114,
		103,
		94,
		100,
		97,
		108,
		118,
		106,
		107,
		97,
		107,
		120,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		203,
		233,
		-1,
		-1,
		197,
		177,
		-1,
		-1,
		149,
		147,
		136,
		-1,
		126,
		99,
		104,
		124,
		126,
		115,
		109,
		103,
		110,
		109,
		117,
		125,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		187,
		183,
		-1,
		-1,
		144,
		137,
		125,
		113,
		103,
		113,
		117,
		121,
		113,
		106,
		101,
		112,
		104,
		108,
		125,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		204,
		190,
		183,
		171,
		169,
		-1,
		178,
		162,
		143,
		-1,
		113,
		126,
		157,
		125,
		130,
		125,
		107,
		118,
		107,
		110,
		124,
		119,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		194,
		196,
		-1,
		195,
		184,
		169,
		161,
		-1,
		-1,
		150,
		146,
		-1,
		-1,
		114,
		139,
		128,
		136,
		131,
		111,
		117,
		120,
		109,
		113,
		125,
		-1,
		-1,
		193,
		194,
		199,
		-1,
		179,
		-1,
		197,
		-1,
		164,
		170,
		158,
		-1,
		-1,
		-1,
		152,
		115,
		136,
		146,
		140,
		138,
		129,
		115,
		122,
		120,
		116,
		127,
		-1,
		-1,
		-1,
		197,
		171,
		204,
		195,
		178,
		158,
		150,
		169,
		-1,
		139,
		-1,
		114,
		116,
		142,
		145,
		151,
		145,
		118,
		133,
		123,
		114,
		123,
		203,
		-1,
		173,
		206,
		170,
		164,
		140,
		144,
		160,
		-1,
		136,
		118,
		-1,
		146,
		136,
		167,
		152,
		133,
		120,
		127,
		127,
		120,
		-1,
		-1,
		-1,
		175,
		174,
		166,
		160,
		160,
		145,
		136,
		-1,
		148,
		130,
		109,
		126,
		126,
		117,
		125,
		157,
		153,
		140,
		140,
		132,
		-1,
		276,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		169,
		164,
		137,
		125,
		131,
		127,
		113,
		119,
		121,
		129,
		127,
		124,
		136,
		132,
		152,
		133,
		168,
		-1,
		271,
		-1,
		205,
		-1,
		-1,
		187,
		167,
		159,
		148,
		137,
		135,
		126,
		117,
		139,
		155,
		139,
		137,
		140,
		141,
		-1,
		260,
		259,
		-1,
		206,
		198,
		184,
		-1,
		177,
		-1,
		183,
		144,
		-1,
		146,
		126,
		-1,
		148,
		144,
		-1,
		-1,
		247,
		222,
		-1,
		-1,
		-1,
		207,
		187,
		178,
		162,
		-1,
		137,
		137,
		-1,
		-1,
		-1,
		232,
		231,
		-1,
		200,
		203,
		-1,
		193,
		184,
		192,
		139,
		143,
		-1,
		-1,
		-1,
		241,
		222,
		216,
		215,
		213,
		208,
		205,
		191,
		175,
		153,
		142,
		163,
		-1,
		-1,
		-1,
		213,
		205,
		198,
		-1,
		-1,
		200,
		183,
		164,
		162,
		-1,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		190,
		-1,
		-1,
		196,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		224,
		-1,
		-1,
		-1,
		186,
		182,
		183,
		-1,
		-1,
		-1,
		-1,
		246,
		247,
		270,
		234,
		-1,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		249,
		247,
		-1,
		-1,
		-1,
		206,
		190,
		-1,
		176,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		211,
		-1,
		211,
		186,
		193,
		-1,
		-1,
		-1,
		-1,
		224,
		216,
		224,
		-1,
		196,
		198,
		-1,
		246,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		201,
		208,
		230,
		233,
		269,
		-1,
		220
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		187,
		191,
		157,
		151,
		190,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		180,
		179,
		147,
		145,
		154,
		159,
		166,
		-1,
		165,
		-1,
		201,
		180,
		191,
		196,
		140,
		137,
		157,
		176,
		158,
		150,
		216,
		170,
		141,
		135,
		153,
		143,
		152,
		144,
		-1,
		141,
		131,
		153,
		132,
		143,
		135,
		-1,
		-1,
		135,
		136,
		142,
		128,
		134,
		130,
		-1,
		140,
		124,
		-1,
		-1,
		125,
		126,
		110,
		113,
		121,
		119,
		132,
		124,
		119,
		-1,
		-1,
		116,
		112,
		119,
		106,
		102,
		119,
		132,
		114,
		128,
		126,
		-1,
		125,
		143,
		145,
		113,
		111,
		95,
		93,
		111,
		113,
		119,
		118,
		-1,
		134,
		135,
		130,
		138,
		135,
		111,
		98,
		98,
		108,
		101,
		120,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		117,
		134,
		126,
		116,
		131,
		124,
		101,
		98,
		96,
		93,
		109,
		106,
		116,
		-1,
		-1,
		226,
		195,
		225,
		183,
		164,
		-1,
		130,
		110,
		116,
		120,
		114,
		107,
		121,
		117,
		-1,
		87,
		86,
		113,
		99,
		110,
		186,
		-1,
		-1,
		184,
		176,
		160,
		163,
		140,
		136,
		125,
		124,
		116,
		102,
		98,
		104,
		107,
		107,
		113,
		81,
		91,
		95,
		92,
		95,
		-1,
		-1,
		109,
		-1,
		-1,
		183,
		166,
		-1,
		149,
		156,
		146,
		152,
		138,
		159,
		135,
		126,
		118,
		112,
		100,
		102,
		99,
		112,
		100,
		78,
		103,
		107,
		87,
		85,
		80,
		-1,
		108,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		142,
		145,
		151,
		175,
		175,
		-1,
		147,
		135,
		136,
		121,
		118,
		105,
		93,
		106,
		91,
		98,
		97,
		82,
		80,
		110,
		84,
		84,
		74,
		79,
		84,
		78,
		87,
		-1,
		191,
		187,
		183,
		190,
		139,
		-1,
		-1,
		179,
		-1,
		183,
		184,
		159,
		132,
		135,
		122,
		113,
		100,
		89,
		100,
		89,
		86,
		94,
		74,
		89,
		79,
		78,
		63,
		63,
		71,
		75,
		81,
		-1,
		241,
		-1,
		183,
		167,
		169,
		141,
		162,
		-1,
		199,
		184,
		176,
		161,
		160,
		-1,
		131,
		128,
		118,
		96,
		81,
		98,
		90,
		88,
		87,
		69,
		83,
		73,
		69,
		67,
		53,
		57,
		77,
		89,
		201,
		191,
		-1,
		173,
		178,
		137,
		145,
		164,
		202,
		166,
		-1,
		161,
		-1,
		133,
		146,
		-1,
		102,
		98,
		80,
		81,
		76,
		91,
		80,
		65,
		62,
		65,
		60,
		46,
		50,
		66,
		-1,
		-1,
		186,
		190,
		179,
		130,
		149,
		173,
		210,
		159,
		148,
		147,
		-1,
		138,
		116,
		113,
		101,
		88,
		73,
		74,
		82,
		95,
		74,
		64,
		65,
		56,
		63,
		41,
		52,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		156,
		127,
		151,
		193,
		177,
		170,
		158,
		123,
		123,
		117,
		-1,
		112,
		91,
		82,
		71,
		69,
		82,
		75,
		80,
		63,
		61,
		51,
		44,
		35,
		43,
		-1,
		-1,
		-1,
		186,
		175,
		176,
		122,
		145,
		182,
		156,
		142,
		147,
		122,
		115,
		109,
		125,
		108,
		89,
		78,
		70,
		59,
		71,
		79,
		77,
		59,
		65,
		45,
		50,
		31,
		37,
		-1,
		-1,
		193,
		183,
		167,
		169,
		166,
		136,
		143,
		175,
		147,
		160,
		-1,
		114,
		-1,
		103,
		99,
		83,
		78,
		75,
		63,
		62,
		75,
		76,
		66,
		61,
		68,
		55,
		55,
		21,
		34,
		37,
		-1,
		-1,
		-1,
		186,
		181,
		156,
		133,
		117,
		153,
		-1,
		130,
		131,
		-1,
		108,
		102,
		99,
		85,
		81,
		67,
		71,
		73,
		76,
		64,
		70,
		71,
		53,
		77,
		-1,
		27,
		18,
		24,
		14,
		11,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		112,
		164,
		-1,
		-1,
		115,
		108,
		-1,
		95,
		77,
		79,
		74,
		73,
		72,
		69,
		58,
		71,
		64,
		58,
		52,
		65,
		44,
		28,
		5,
		0,
		6,
		20,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		132,
		-1,
		124,
		116,
		106,
		100,
		94,
		90,
		88,
		101,
		85,
		84,
		81,
		72,
		80,
		53,
		46,
		57,
		42,
		60,
		37,
		28,
		21,
		13,
		16,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		145,
		-1,
		109,
		123,
		139,
		-1,
		132,
		111,
		126,
		104,
		100,
		91,
		108,
		109,
		87,
		81,
		79,
		70,
		58,
		47,
		50,
		42,
		40,
		32,
		16,
		16,
		18,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		106,
		94,
		126,
		-1,
		-1,
		168,
		-1,
		102,
		119,
		105,
		103,
		98,
		89,
		95,
		90,
		67,
		62,
		52,
		41,
		41,
		36,
		38,
		24,
		22,
		17,
		32,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		146,
		136,
		120,
		105,
		138,
		-1,
		106,
		90,
		95,
		-1,
		87,
		-1,
		60,
		57,
		48,
		33,
		30,
		34,
		25,
		38,
		23,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		163,
		-1,
		-1,
		133,
		127,
		127,
		111,
		114,
		122,
		102,
		96,
		95,
		82,
		74,
		68,
		46,
		39,
		36,
		33,
		46,
		58,
		37,
		25,
		-1,
		-1,
		-1,
		160,
		146,
		150,
		110,
		129,
		-1,
		-1,
		195,
		150,
		136,
		-1,
		120,
		129,
		117,
		107,
		97,
		100,
		90,
		65,
		58,
		44,
		46,
		44,
		42,
		47,
		38,
		30,
		40,
		-1,
		-1,
		143,
		148,
		136,
		122,
		141,
		-1,
		-1,
		-1,
		142,
		158,
		150,
		121,
		118,
		-1,
		-1,
		101,
		92,
		82,
		61,
		48,
		68,
		71,
		57,
		41,
		54,
		44,
		32,
		41,
		-1,
		146,
		133,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		-1,
		-1,
		169,
		114,
		103,
		98,
		102,
		100,
		-1,
		74,
		72,
		52,
		66,
		73,
		59,
		54,
		48,
		49,
		49,
		43,
		-1,
		-1,
		158,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		126,
		120,
		91,
		84,
		88,
		-1,
		76,
		68,
		54,
		71,
		72,
		69,
		60,
		52,
		57,
		46,
		59,
		55,
		45,
		181,
		-1,
		164,
		-1,
		-1,
		-1,
		144,
		159,
		130,
		107,
		80,
		75,
		68,
		62,
		62,
		78,
		80,
		91,
		59,
		55,
		56,
		52,
		51,
		59,
		60,
		-1,
		-1,
		164,
		178,
		170,
		152,
		156,
		157,
		-1,
		-1,
		84,
		75,
		66,
		69,
		72,
		75,
		65,
		62,
		67,
		69,
		60,
		61,
		78,
		63,
		-1,
		-1,
		-1,
		184,
		-1,
		196,
		-1,
		-1,
		171,
		155,
		102,
		84,
		80,
		78,
		71,
		80,
		75,
		70,
		80,
		87,
		79,
		59,
		73,
		89,
		71,
		92,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		117,
		114,
		-1,
		84,
		109,
		81,
		88,
		80,
		88,
		88,
		83,
		63,
		70,
		86,
		83,
		80,
		84,
		79,
		88,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		133,
		130,
		106,
		90,
		94,
		87,
		82,
		92,
		72,
		59,
		63,
		67,
		73,
		78,
		83,
		89,
		86,
		94,
		-1,
		191,
		255,
		248,
		216,
		224,
		255,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		106,
		103,
		108,
		97,
		94,
		102,
		97,
		88,
		73,
		79,
		66,
		65,
		83,
		87,
		96,
		100,
		89,
		102,
		106,
		-1,
		205,
		231,
		210,
		213,
		237,
		251,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		105,
		155,
		111,
		106,
		96,
		94,
		85,
		76,
		83,
		74,
		74,
		77,
		92,
		97,
		89,
		99,
		99,
		100,
		-1,
		200,
		211,
		204,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		-1,
		148,
		-1,
		123,
		127,
		119,
		122,
		110,
		97,
		89,
		81,
		97,
		72,
		82,
		78,
		79,
		88,
		99,
		111,
		106,
		107,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		165,
		204,
		209,
		-1,
		190,
		-1,
		-1,
		-1,
		137,
		132,
		124,
		130,
		109,
		109,
		83,
		87,
		77,
		84,
		94,
		96,
		88,
		92,
		105,
		116,
		115,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		180,
		171,
		198,
		216,
		205,
		200,
		187,
		-1,
		-1,
		160,
		142,
		-1,
		-1,
		116,
		104,
		87,
		88,
		84,
		87,
		102,
		105,
		95,
		93,
		87,
		119,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		199,
		194,
		198,
		214,
		239,
		-1,
		176,
		-1,
		-1,
		161,
		-1,
		-1,
		146,
		109,
		98,
		89,
		95,
		92,
		103,
		113,
		101,
		102,
		92,
		102,
		115,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		192,
		172,
		-1,
		-1,
		144,
		142,
		131,
		-1,
		121,
		94,
		99,
		119,
		121,
		110,
		104,
		98,
		105,
		104,
		112,
		120,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		139,
		132,
		120,
		108,
		98,
		108,
		112,
		116,
		108,
		101,
		96,
		107,
		99,
		103,
		120,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		173,
		157,
		138,
		-1,
		108,
		121,
		152,
		120,
		125,
		120,
		102,
		113,
		102,
		105,
		119,
		114,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		189,
		191,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		134,
		123,
		131,
		126,
		106,
		112,
		115,
		104,
		108,
		120,
		-1,
		-1,
		188,
		189,
		194,
		-1,
		174,
		-1,
		192,
		-1,
		159,
		165,
		153,
		-1,
		-1,
		-1,
		147,
		110,
		131,
		141,
		135,
		133,
		124,
		110,
		117,
		115,
		111,
		122,
		-1,
		-1,
		-1,
		192,
		166,
		199,
		190,
		173,
		153,
		145,
		164,
		-1,
		134,
		-1,
		109,
		111,
		137,
		140,
		146,
		140,
		113,
		128,
		118,
		109,
		118,
		198,
		-1,
		168,
		201,
		165,
		159,
		135,
		139,
		155,
		-1,
		131,
		113,
		-1,
		141,
		131,
		162,
		147,
		128,
		115,
		122,
		122,
		115,
		-1,
		-1,
		-1,
		170,
		169,
		161,
		155,
		155,
		140,
		131,
		-1,
		143,
		125,
		104,
		121,
		121,
		112,
		120,
		152,
		148,
		135,
		135,
		127,
		-1,
		271,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		164,
		159,
		132,
		120,
		126,
		122,
		108,
		114,
		116,
		124,
		122,
		119,
		131,
		127,
		147,
		128,
		163,
		-1,
		266,
		-1,
		200,
		-1,
		-1,
		182,
		162,
		154,
		143,
		132,
		130,
		121,
		112,
		134,
		150,
		134,
		132,
		135,
		136,
		-1,
		255,
		254,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		178,
		139,
		-1,
		141,
		121,
		-1,
		143,
		139,
		-1,
		-1,
		242,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		173,
		157,
		-1,
		132,
		132,
		-1,
		-1,
		-1,
		227,
		226,
		-1,
		195,
		198,
		-1,
		188,
		179,
		187,
		134,
		138,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		210,
		208,
		203,
		200,
		186,
		170,
		148,
		137,
		158,
		-1,
		-1,
		-1,
		208,
		200,
		193,
		-1,
		-1,
		195,
		178,
		159,
		157,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		185,
		-1,
		-1,
		191,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		219,
		-1,
		-1,
		-1,
		181,
		177,
		178,
		-1,
		-1,
		-1,
		-1,
		241,
		242,
		265,
		229,
		-1,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		244,
		242,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		171,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		206,
		-1,
		206,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		219,
		211,
		219,
		-1,
		191,
		193,
		-1,
		241,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		196,
		203,
		225,
		228,
		264,
		-1,
		215
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		183,
		187,
		153,
		147,
		186,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		176,
		175,
		143,
		141,
		150,
		155,
		162,
		-1,
		161,
		-1,
		197,
		176,
		187,
		192,
		136,
		133,
		153,
		172,
		154,
		146,
		212,
		166,
		137,
		131,
		149,
		139,
		148,
		140,
		-1,
		137,
		127,
		149,
		128,
		139,
		131,
		-1,
		-1,
		131,
		132,
		138,
		124,
		130,
		126,
		-1,
		136,
		120,
		-1,
		-1,
		121,
		122,
		106,
		109,
		117,
		115,
		128,
		120,
		115,
		-1,
		-1,
		112,
		108,
		115,
		102,
		98,
		115,
		128,
		110,
		124,
		122,
		-1,
		119,
		137,
		141,
		109,
		107,
		91,
		89,
		107,
		109,
		115,
		114,
		-1,
		128,
		129,
		124,
		132,
		131,
		107,
		94,
		94,
		104,
		97,
		116,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		111,
		128,
		120,
		110,
		125,
		118,
		97,
		94,
		92,
		89,
		105,
		102,
		112,
		-1,
		-1,
		220,
		189,
		219,
		177,
		158,
		-1,
		124,
		104,
		110,
		114,
		108,
		101,
		115,
		111,
		-1,
		83,
		82,
		109,
		95,
		106,
		180,
		-1,
		-1,
		178,
		170,
		154,
		157,
		134,
		130,
		119,
		118,
		110,
		96,
		92,
		98,
		101,
		101,
		107,
		77,
		87,
		91,
		88,
		91,
		-1,
		-1,
		105,
		-1,
		-1,
		177,
		160,
		-1,
		143,
		150,
		140,
		146,
		132,
		153,
		129,
		120,
		112,
		106,
		94,
		96,
		93,
		106,
		94,
		74,
		99,
		103,
		83,
		81,
		76,
		-1,
		104,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		139,
		145,
		169,
		169,
		-1,
		141,
		129,
		130,
		115,
		112,
		99,
		87,
		100,
		85,
		92,
		91,
		78,
		76,
		106,
		80,
		80,
		70,
		75,
		80,
		74,
		83,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		173,
		-1,
		177,
		178,
		153,
		126,
		129,
		116,
		107,
		94,
		83,
		94,
		83,
		80,
		88,
		70,
		85,
		75,
		74,
		59,
		59,
		67,
		71,
		77,
		-1,
		235,
		-1,
		177,
		161,
		163,
		135,
		156,
		-1,
		193,
		178,
		170,
		155,
		154,
		-1,
		125,
		122,
		112,
		90,
		75,
		92,
		84,
		82,
		83,
		65,
		79,
		69,
		65,
		63,
		49,
		53,
		73,
		85,
		195,
		185,
		-1,
		167,
		172,
		131,
		139,
		158,
		196,
		160,
		-1,
		155,
		-1,
		127,
		140,
		-1,
		96,
		92,
		74,
		75,
		70,
		85,
		76,
		61,
		58,
		61,
		56,
		42,
		46,
		62,
		-1,
		-1,
		180,
		184,
		173,
		124,
		143,
		167,
		204,
		153,
		142,
		141,
		-1,
		132,
		110,
		107,
		95,
		82,
		67,
		68,
		76,
		89,
		68,
		60,
		59,
		52,
		59,
		37,
		48,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		150,
		121,
		145,
		187,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		106,
		85,
		76,
		65,
		63,
		76,
		69,
		76,
		57,
		55,
		47,
		40,
		31,
		39,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		150,
		136,
		141,
		116,
		109,
		103,
		119,
		102,
		83,
		72,
		64,
		53,
		65,
		73,
		71,
		53,
		61,
		41,
		46,
		27,
		33,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		141,
		154,
		-1,
		108,
		-1,
		97,
		93,
		77,
		72,
		69,
		57,
		56,
		69,
		70,
		60,
		55,
		62,
		51,
		51,
		17,
		37,
		40,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		102,
		96,
		93,
		79,
		75,
		61,
		65,
		67,
		70,
		58,
		64,
		65,
		47,
		71,
		-1,
		25,
		19,
		27,
		17,
		5,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		89,
		71,
		73,
		68,
		67,
		66,
		63,
		52,
		65,
		58,
		52,
		46,
		59,
		40,
		30,
		7,
		3,
		0,
		14,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		84,
		82,
		95,
		79,
		78,
		75,
		66,
		74,
		47,
		40,
		51,
		36,
		54,
		32,
		22,
		15,
		7,
		10,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		94,
		85,
		102,
		103,
		81,
		75,
		73,
		64,
		52,
		41,
		44,
		36,
		34,
		26,
		10,
		10,
		12,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		99,
		97,
		92,
		83,
		89,
		84,
		61,
		56,
		46,
		35,
		35,
		30,
		32,
		18,
		16,
		11,
		26,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		100,
		84,
		89,
		-1,
		81,
		-1,
		54,
		51,
		42,
		27,
		24,
		28,
		19,
		32,
		17,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		116,
		96,
		90,
		89,
		76,
		68,
		62,
		40,
		33,
		30,
		27,
		40,
		52,
		31,
		19,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		123,
		111,
		101,
		91,
		94,
		84,
		59,
		52,
		38,
		40,
		38,
		36,
		41,
		32,
		24,
		34,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		112,
		-1,
		-1,
		95,
		86,
		76,
		55,
		42,
		62,
		65,
		51,
		35,
		48,
		38,
		26,
		35,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		163,
		108,
		97,
		92,
		96,
		94,
		-1,
		68,
		66,
		46,
		60,
		67,
		53,
		48,
		42,
		43,
		43,
		37,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		120,
		114,
		85,
		78,
		82,
		-1,
		70,
		62,
		48,
		65,
		66,
		63,
		54,
		46,
		51,
		40,
		53,
		49,
		39,
		175,
		-1,
		158,
		-1,
		-1,
		-1,
		138,
		153,
		124,
		101,
		74,
		69,
		62,
		56,
		56,
		72,
		74,
		85,
		53,
		49,
		50,
		46,
		45,
		53,
		54,
		-1,
		-1,
		158,
		172,
		164,
		146,
		150,
		151,
		-1,
		-1,
		78,
		69,
		60,
		63,
		66,
		69,
		59,
		56,
		61,
		63,
		54,
		55,
		72,
		57,
		-1,
		-1,
		-1,
		178,
		-1,
		190,
		-1,
		-1,
		165,
		149,
		96,
		78,
		74,
		72,
		65,
		74,
		69,
		64,
		74,
		81,
		73,
		53,
		67,
		83,
		65,
		86,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		167,
		159,
		154,
		160,
		162,
		153,
		111,
		108,
		-1,
		78,
		103,
		75,
		82,
		74,
		82,
		82,
		77,
		57,
		64,
		80,
		77,
		74,
		78,
		73,
		82,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		160,
		156,
		146,
		136,
		139,
		-1,
		-1,
		127,
		124,
		100,
		84,
		88,
		81,
		76,
		86,
		66,
		53,
		57,
		61,
		67,
		72,
		77,
		83,
		80,
		88,
		-1,
		185,
		249,
		242,
		210,
		218,
		249,
		-1,
		150,
		142,
		153,
		128,
		130,
		-1,
		-1,
		100,
		97,
		102,
		91,
		88,
		96,
		91,
		82,
		67,
		73,
		60,
		59,
		77,
		81,
		90,
		94,
		83,
		96,
		100,
		-1,
		199,
		225,
		204,
		207,
		231,
		245,
		-1,
		147,
		-1,
		-1,
		159,
		131,
		115,
		105,
		99,
		149,
		105,
		100,
		90,
		88,
		79,
		70,
		77,
		68,
		68,
		71,
		86,
		91,
		83,
		93,
		93,
		94,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		175,
		-1,
		142,
		-1,
		117,
		121,
		113,
		116,
		104,
		91,
		83,
		75,
		91,
		66,
		76,
		72,
		73,
		82,
		93,
		105,
		100,
		101,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		159,
		198,
		203,
		-1,
		184,
		-1,
		-1,
		-1,
		131,
		126,
		118,
		124,
		103,
		103,
		77,
		81,
		71,
		78,
		88,
		90,
		82,
		86,
		99,
		110,
		109,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		174,
		165,
		192,
		210,
		199,
		194,
		181,
		-1,
		-1,
		154,
		136,
		-1,
		-1,
		110,
		98,
		81,
		82,
		78,
		81,
		96,
		99,
		89,
		87,
		81,
		113,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		193,
		188,
		192,
		208,
		233,
		-1,
		170,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		103,
		92,
		83,
		89,
		86,
		97,
		107,
		95,
		96,
		86,
		96,
		109,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		192,
		222,
		-1,
		-1,
		186,
		166,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		88,
		93,
		113,
		115,
		104,
		98,
		92,
		99,
		98,
		106,
		114,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		172,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		102,
		106,
		110,
		102,
		95,
		90,
		101,
		93,
		97,
		114,
		-1,
		235,
		-1,
		187,
		163,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		146,
		114,
		119,
		114,
		96,
		107,
		96,
		99,
		113,
		108,
		-1,
		-1,
		175,
		178,
		-1,
		-1,
		183,
		185,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		103,
		128,
		117,
		125,
		120,
		100,
		106,
		109,
		98,
		102,
		114,
		-1,
		-1,
		182,
		183,
		188,
		-1,
		168,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		141,
		104,
		125,
		135,
		129,
		127,
		118,
		104,
		111,
		109,
		105,
		116,
		-1,
		-1,
		-1,
		186,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		103,
		105,
		131,
		134,
		140,
		134,
		107,
		122,
		112,
		103,
		112,
		192,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		156,
		141,
		122,
		109,
		116,
		116,
		109,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		146,
		142,
		129,
		129,
		121,
		-1,
		265,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		125,
		121,
		141,
		122,
		157,
		-1,
		260,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		128,
		126,
		129,
		130,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		137,
		133,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		200,
		204,
		170,
		164,
		203,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		193,
		192,
		160,
		158,
		167,
		172,
		179,
		-1,
		178,
		-1,
		214,
		193,
		204,
		209,
		153,
		150,
		170,
		189,
		171,
		163,
		229,
		183,
		154,
		148,
		166,
		156,
		165,
		157,
		-1,
		154,
		144,
		166,
		145,
		156,
		148,
		-1,
		-1,
		148,
		149,
		155,
		141,
		147,
		143,
		-1,
		153,
		137,
		-1,
		-1,
		138,
		139,
		123,
		126,
		134,
		132,
		145,
		137,
		132,
		-1,
		-1,
		129,
		125,
		132,
		119,
		115,
		132,
		145,
		127,
		141,
		139,
		-1,
		136,
		154,
		158,
		126,
		124,
		108,
		106,
		124,
		126,
		132,
		131,
		-1,
		145,
		146,
		141,
		149,
		148,
		124,
		111,
		111,
		121,
		114,
		133,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		128,
		145,
		137,
		127,
		142,
		135,
		114,
		111,
		109,
		106,
		122,
		119,
		129,
		-1,
		-1,
		237,
		206,
		236,
		194,
		175,
		-1,
		141,
		121,
		127,
		131,
		125,
		118,
		132,
		128,
		-1,
		100,
		99,
		126,
		112,
		123,
		197,
		-1,
		-1,
		195,
		187,
		171,
		174,
		151,
		147,
		136,
		135,
		127,
		113,
		109,
		115,
		118,
		118,
		124,
		94,
		104,
		108,
		105,
		108,
		-1,
		-1,
		122,
		-1,
		-1,
		194,
		177,
		-1,
		160,
		167,
		157,
		163,
		149,
		170,
		146,
		137,
		129,
		123,
		111,
		113,
		110,
		123,
		111,
		91,
		116,
		120,
		100,
		98,
		93,
		-1,
		121,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		153,
		156,
		162,
		186,
		186,
		-1,
		158,
		146,
		147,
		132,
		129,
		116,
		104,
		117,
		102,
		109,
		108,
		95,
		93,
		123,
		97,
		97,
		87,
		92,
		97,
		91,
		100,
		-1,
		202,
		198,
		194,
		201,
		150,
		-1,
		-1,
		190,
		-1,
		194,
		195,
		170,
		143,
		146,
		133,
		124,
		111,
		100,
		111,
		100,
		97,
		105,
		87,
		102,
		92,
		91,
		76,
		76,
		84,
		88,
		94,
		-1,
		252,
		-1,
		194,
		178,
		180,
		152,
		173,
		-1,
		210,
		195,
		187,
		172,
		171,
		-1,
		142,
		139,
		129,
		107,
		92,
		109,
		101,
		99,
		100,
		82,
		96,
		86,
		82,
		80,
		66,
		70,
		90,
		102,
		212,
		202,
		-1,
		184,
		189,
		148,
		156,
		175,
		213,
		177,
		-1,
		172,
		-1,
		144,
		157,
		-1,
		113,
		109,
		91,
		92,
		87,
		102,
		93,
		78,
		75,
		78,
		73,
		59,
		63,
		79,
		-1,
		-1,
		197,
		201,
		190,
		141,
		160,
		184,
		221,
		170,
		159,
		158,
		-1,
		149,
		127,
		124,
		112,
		99,
		84,
		85,
		93,
		106,
		85,
		77,
		76,
		69,
		76,
		54,
		65,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		167,
		138,
		162,
		204,
		188,
		181,
		169,
		134,
		134,
		128,
		-1,
		123,
		102,
		93,
		82,
		80,
		93,
		86,
		93,
		74,
		72,
		64,
		57,
		48,
		56,
		-1,
		-1,
		-1,
		197,
		186,
		187,
		133,
		156,
		193,
		167,
		153,
		158,
		133,
		126,
		120,
		136,
		119,
		100,
		89,
		81,
		70,
		82,
		90,
		88,
		70,
		78,
		58,
		63,
		44,
		50,
		-1,
		-1,
		204,
		194,
		178,
		180,
		177,
		147,
		154,
		186,
		158,
		171,
		-1,
		125,
		-1,
		114,
		110,
		94,
		89,
		86,
		74,
		73,
		86,
		87,
		77,
		72,
		79,
		68,
		68,
		34,
		53,
		56,
		-1,
		-1,
		-1,
		197,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		119,
		113,
		110,
		96,
		92,
		78,
		82,
		84,
		87,
		75,
		81,
		82,
		64,
		88,
		-1,
		42,
		36,
		43,
		33,
		22,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		90,
		85,
		84,
		83,
		80,
		69,
		82,
		75,
		69,
		63,
		76,
		57,
		47,
		24,
		20,
		17,
		0,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		101,
		99,
		112,
		96,
		95,
		92,
		83,
		91,
		64,
		57,
		68,
		53,
		71,
		49,
		39,
		32,
		24,
		12,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		111,
		102,
		119,
		120,
		98,
		92,
		90,
		81,
		69,
		58,
		61,
		53,
		51,
		43,
		27,
		27,
		29,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		179,
		-1,
		113,
		130,
		116,
		114,
		109,
		100,
		106,
		101,
		78,
		73,
		63,
		52,
		52,
		47,
		49,
		35,
		33,
		28,
		32,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		157,
		147,
		131,
		116,
		149,
		-1,
		117,
		101,
		106,
		-1,
		98,
		-1,
		71,
		68,
		59,
		44,
		41,
		45,
		36,
		49,
		34,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		144,
		138,
		138,
		122,
		125,
		133,
		113,
		107,
		106,
		93,
		85,
		79,
		57,
		50,
		47,
		44,
		57,
		69,
		48,
		36,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		206,
		161,
		147,
		-1,
		131,
		140,
		128,
		118,
		108,
		111,
		101,
		76,
		69,
		55,
		57,
		55,
		53,
		58,
		49,
		41,
		51,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		153,
		169,
		161,
		132,
		129,
		-1,
		-1,
		112,
		103,
		93,
		72,
		59,
		79,
		82,
		68,
		52,
		65,
		55,
		43,
		52,
		-1,
		157,
		144,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		83,
		63,
		77,
		84,
		70,
		65,
		59,
		57,
		60,
		54,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		79,
		65,
		82,
		83,
		80,
		71,
		63,
		68,
		54,
		67,
		62,
		56,
		192,
		-1,
		175,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		73,
		89,
		91,
		102,
		70,
		66,
		67,
		60,
		59,
		66,
		67,
		-1,
		-1,
		175,
		189,
		181,
		163,
		167,
		168,
		-1,
		-1,
		95,
		86,
		77,
		80,
		83,
		86,
		76,
		73,
		78,
		77,
		70,
		69,
		87,
		73,
		-1,
		-1,
		-1,
		195,
		-1,
		207,
		-1,
		-1,
		182,
		166,
		113,
		95,
		91,
		89,
		82,
		91,
		86,
		81,
		91,
		95,
		87,
		67,
		84,
		97,
		81,
		92,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		184,
		176,
		171,
		177,
		179,
		170,
		128,
		125,
		-1,
		95,
		120,
		92,
		99,
		91,
		99,
		99,
		91,
		72,
		81,
		97,
		93,
		91,
		84,
		79,
		88,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		177,
		173,
		163,
		153,
		156,
		-1,
		-1,
		144,
		141,
		117,
		101,
		105,
		98,
		93,
		103,
		83,
		70,
		74,
		78,
		84,
		89,
		94,
		97,
		86,
		94,
		-1,
		202,
		266,
		259,
		227,
		235,
		266,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		117,
		114,
		119,
		108,
		105,
		113,
		108,
		99,
		84,
		90,
		77,
		76,
		94,
		98,
		107,
		100,
		89,
		102,
		106,
		-1,
		216,
		242,
		221,
		224,
		248,
		262,
		-1,
		164,
		-1,
		-1,
		176,
		148,
		132,
		122,
		116,
		166,
		122,
		117,
		107,
		105,
		96,
		87,
		94,
		85,
		85,
		88,
		103,
		108,
		100,
		99,
		99,
		100,
		-1,
		211,
		222,
		215,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		192,
		-1,
		159,
		-1,
		134,
		138,
		130,
		133,
		121,
		108,
		100,
		92,
		108,
		83,
		93,
		89,
		90,
		99,
		110,
		120,
		106,
		107,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		176,
		215,
		220,
		-1,
		201,
		-1,
		-1,
		-1,
		148,
		143,
		135,
		141,
		120,
		120,
		94,
		98,
		88,
		95,
		105,
		107,
		99,
		103,
		116,
		116,
		115,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		191,
		182,
		209,
		227,
		216,
		211,
		198,
		-1,
		-1,
		171,
		153,
		-1,
		-1,
		127,
		115,
		98,
		99,
		95,
		98,
		113,
		116,
		106,
		104,
		98,
		121,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		210,
		205,
		209,
		225,
		250,
		-1,
		187,
		-1,
		-1,
		172,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		103,
		114,
		124,
		112,
		113,
		103,
		113,
		126,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		239,
		-1,
		-1,
		203,
		183,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		130,
		132,
		121,
		115,
		109,
		116,
		115,
		123,
		131,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		189,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		123,
		127,
		119,
		112,
		107,
		118,
		110,
		114,
		131,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		113,
		124,
		113,
		116,
		130,
		125,
		-1,
		-1,
		192,
		195,
		-1,
		-1,
		200,
		202,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		117,
		123,
		126,
		115,
		119,
		130,
		-1,
		-1,
		199,
		200,
		205,
		-1,
		185,
		-1,
		203,
		-1,
		170,
		176,
		164,
		-1,
		-1,
		-1,
		158,
		121,
		142,
		152,
		146,
		144,
		135,
		121,
		128,
		126,
		122,
		133,
		-1,
		-1,
		-1,
		203,
		177,
		210,
		201,
		184,
		164,
		156,
		175,
		-1,
		145,
		-1,
		120,
		122,
		148,
		151,
		157,
		151,
		124,
		139,
		129,
		120,
		129,
		209,
		-1,
		179,
		212,
		176,
		170,
		146,
		150,
		166,
		-1,
		142,
		124,
		-1,
		152,
		142,
		173,
		158,
		139,
		126,
		133,
		133,
		126,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		151,
		142,
		-1,
		154,
		136,
		115,
		132,
		132,
		123,
		131,
		163,
		159,
		146,
		146,
		138,
		-1,
		282,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		170,
		143,
		131,
		137,
		133,
		119,
		125,
		127,
		135,
		133,
		130,
		142,
		138,
		158,
		139,
		174,
		-1,
		277,
		-1,
		211,
		-1,
		-1,
		193,
		173,
		165,
		154,
		143,
		141,
		132,
		123,
		145,
		161,
		145,
		143,
		146,
		147,
		-1,
		266,
		265,
		-1,
		212,
		204,
		190,
		-1,
		183,
		-1,
		189,
		150,
		-1,
		152,
		132,
		-1,
		154,
		150,
		-1,
		-1,
		253,
		228,
		-1,
		-1,
		-1,
		213,
		193,
		184,
		168,
		-1,
		143,
		143,
		-1,
		-1,
		-1,
		238,
		237,
		-1,
		206,
		209,
		-1,
		199,
		190,
		198,
		145,
		149,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		221,
		219,
		214,
		211,
		197,
		181,
		159,
		148,
		169,
		-1,
		-1,
		-1,
		219,
		211,
		204,
		-1,
		-1,
		206,
		189,
		170,
		168,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		196,
		-1,
		-1,
		202,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		230,
		-1,
		-1,
		-1,
		192,
		188,
		189,
		-1,
		-1,
		-1,
		-1,
		252,
		253,
		276,
		240,
		-1,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		255,
		253,
		-1,
		-1,
		-1,
		212,
		196,
		-1,
		182,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		217,
		-1,
		217,
		192,
		199,
		-1,
		-1,
		-1,
		-1,
		230,
		222,
		230,
		-1,
		202,
		204,
		-1,
		252,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		207,
		214,
		236,
		239,
		275,
		-1,
		226
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		232,
		221,
		232,
		240,
		213,
		220,
		-1,
		241,
		243,
		209,
		203,
		242,
		213,
		219,
		230,
		-1,
		-1,
		-1,
		232,
		231,
		201,
		199,
		208,
		213,
		220,
		-1,
		243,
		-1,
		253,
		232,
		243,
		248,
		194,
		191,
		211,
		230,
		236,
		228,
		268,
		224,
		195,
		189,
		207,
		212,
		230,
		222,
		-1,
		195,
		185,
		207,
		211,
		223,
		206,
		-1,
		-1,
		189,
		190,
		196,
		208,
		213,
		218,
		-1,
		241,
		225,
		-1,
		-1,
		179,
		192,
		188,
		191,
		199,
		215,
		233,
		225,
		220,
		-1,
		-1,
		180,
		184,
		197,
		198,
		196,
		220,
		233,
		215,
		229,
		228,
		-1,
		168,
		186,
		195,
		204,
		210,
		196,
		194,
		212,
		214,
		220,
		223,
		-1,
		160,
		162,
		191,
		197,
		209,
		212,
		199,
		199,
		209,
		202,
		221,
		212,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		157,
		165,
		191,
		190,
		186,
		204,
		209,
		202,
		199,
		197,
		194,
		210,
		211,
		221,
		-1,
		-1,
		213,
		182,
		217,
		174,
		159,
		-1,
		153,
		172,
		178,
		182,
		187,
		192,
		206,
		202,
		-1,
		188,
		187,
		218,
		204,
		215,
		173,
		-1,
		-1,
		171,
		163,
		148,
		151,
		148,
		148,
		178,
		177,
		182,
		184,
		183,
		189,
		192,
		192,
		198,
		182,
		192,
		196,
		207,
		222,
		-1,
		-1,
		277,
		-1,
		-1,
		170,
		153,
		-1,
		136,
		143,
		143,
		160,
		150,
		171,
		186,
		190,
		198,
		197,
		185,
		187,
		184,
		197,
		185,
		179,
		204,
		208,
		202,
		223,
		218,
		-1,
		276,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		129,
		132,
		138,
		162,
		172,
		-1,
		193,
		191,
		215,
		206,
		203,
		190,
		178,
		191,
		176,
		183,
		182,
		186,
		188,
		221,
		199,
		221,
		218,
		247,
		252,
		246,
		255,
		-1,
		178,
		174,
		170,
		177,
		126,
		-1,
		-1,
		166,
		-1,
		180,
		193,
		197,
		195,
		198,
		207,
		198,
		185,
		174,
		185,
		174,
		171,
		179,
		188,
		199,
		194,
		193,
		211,
		226,
		239,
		243,
		249,
		-1,
		228,
		-1,
		170,
		154,
		156,
		128,
		149,
		-1,
		186,
		181,
		201,
		199,
		190,
		-1,
		193,
		196,
		203,
		181,
		166,
		183,
		175,
		173,
		178,
		183,
		197,
		188,
		206,
		213,
		221,
		225,
		245,
		257,
		188,
		178,
		-1,
		160,
		165,
		124,
		132,
		151,
		224,
		196,
		-1,
		191,
		-1,
		183,
		208,
		-1,
		187,
		183,
		165,
		166,
		161,
		176,
		182,
		179,
		176,
		194,
		197,
		214,
		218,
		234,
		-1,
		-1,
		173,
		177,
		166,
		117,
		136,
		160,
		197,
		189,
		178,
		177,
		-1,
		168,
		198,
		195,
		181,
		168,
		158,
		159,
		167,
		180,
		159,
		178,
		181,
		203,
		231,
		209,
		221,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		143,
		114,
		138,
		180,
		207,
		200,
		188,
		153,
		153,
		147,
		-1,
		188,
		171,
		167,
		156,
		154,
		167,
		162,
		178,
		182,
		181,
		200,
		212,
		203,
		223,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		109,
		132,
		169,
		186,
		172,
		177,
		152,
		145,
		139,
		191,
		188,
		155,
		163,
		155,
		144,
		158,
		166,
		170,
		179,
		188,
		194,
		218,
		218,
		224,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		123,
		130,
		162,
		177,
		174,
		-1,
		144,
		-1,
		133,
		141,
		140,
		146,
		158,
		144,
		149,
		160,
		172,
		185,
		181,
		188,
		223,
		223,
		208,
		228,
		231,
		-1,
		-1,
		-1,
		173,
		168,
		143,
		120,
		104,
		140,
		-1,
		144,
		145,
		-1,
		138,
		132,
		138,
		137,
		144,
		141,
		141,
		155,
		163,
		159,
		175,
		181,
		173,
		209,
		-1,
		216,
		210,
		218,
		208,
		196,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		99,
		151,
		-1,
		-1,
		129,
		122,
		-1,
		125,
		125,
		132,
		141,
		146,
		151,
		159,
		154,
		167,
		172,
		178,
		183,
		201,
		205,
		209,
		198,
		194,
		191,
		205,
		-1,
		0,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		119,
		-1,
		138,
		130,
		120,
		114,
		120,
		138,
		136,
		156,
		148,
		162,
		162,
		168,
		176,
		161,
		164,
		180,
		178,
		196,
		204,
		196,
		190,
		189,
		201,
		-1,
		9,
		41,
		38,
		-1,
		-1,
		132,
		-1,
		96,
		120,
		136,
		-1,
		154,
		133,
		156,
		134,
		148,
		144,
		182,
		183,
		161,
		166,
		174,
		184,
		186,
		175,
		186,
		178,
		200,
		200,
		184,
		185,
		194,
		-1,
		61,
		38,
		42,
		54,
		60,
		121,
		93,
		102,
		123,
		-1,
		-1,
		198,
		-1,
		132,
		149,
		158,
		156,
		172,
		163,
		169,
		185,
		188,
		190,
		180,
		169,
		175,
		172,
		194,
		180,
		178,
		197,
		213,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		87,
		87,
		89,
		-1,
		140,
		-1,
		176,
		166,
		150,
		135,
		168,
		-1,
		180,
		164,
		169,
		-1,
		215,
		-1,
		188,
		190,
		184,
		169,
		166,
		177,
		175,
		186,
		203,
		-1,
		121,
		106,
		99,
		89,
		116,
		87,
		-1,
		143,
		-1,
		-1,
		163,
		157,
		157,
		141,
		144,
		196,
		176,
		170,
		169,
		210,
		210,
		196,
		182,
		175,
		172,
		169,
		182,
		202,
		193,
		205,
		-1,
		-1,
		-1,
		126,
		133,
		130,
		97,
		109,
		-1,
		-1,
		225,
		180,
		166,
		-1,
		150,
		213,
		201,
		191,
		181,
		215,
		216,
		201,
		194,
		180,
		182,
		180,
		178,
		183,
		204,
		205,
		218,
		-1,
		-1,
		130,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		172,
		188,
		180,
		151,
		202,
		-1,
		-1,
		193,
		191,
		201,
		197,
		184,
		204,
		207,
		193,
		177,
		192,
		204,
		212,
		217,
		-1,
		133,
		120,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		183,
		204,
		229,
		196,
		-1,
		201,
		202,
		188,
		202,
		209,
		195,
		190,
		184,
		187,
		205,
		222,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		162,
		176,
		197,
		203,
		215,
		-1,
		210,
		204,
		190,
		207,
		208,
		205,
		196,
		188,
		193,
		190,
		203,
		217,
		221,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		180,
		195,
		257,
		234,
		207,
		211,
		204,
		198,
		198,
		214,
		216,
		227,
		195,
		191,
		192,
		196,
		195,
		212,
		222,
		-1,
		-1,
		144,
		161,
		196,
		188,
		192,
		284,
		-1,
		-1,
		220,
		211,
		202,
		205,
		208,
		211,
		201,
		198,
		203,
		208,
		196,
		205,
		223,
		227,
		-1,
		-1,
		-1,
		164,
		-1,
		179,
		-1,
		-1,
		207,
		291,
		238,
		220,
		216,
		214,
		207,
		216,
		211,
		206,
		216,
		225,
		217,
		198,
		209,
		232,
		221,
		259,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		193,
		168,
		183,
		229,
		227,
		225,
		253,
		250,
		-1,
		220,
		245,
		217,
		224,
		216,
		224,
		224,
		221,
		199,
		206,
		222,
		221,
		216,
		251,
		243,
		249,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		199,
		185,
		215,
		205,
		211,
		-1,
		-1,
		258,
		255,
		242,
		226,
		230,
		223,
		218,
		228,
		208,
		195,
		199,
		203,
		209,
		214,
		219,
		225,
		240,
		255,
		-1,
		178,
		259,
		252,
		235,
		243,
		274,
		-1,
		202,
		211,
		192,
		197,
		205,
		-1,
		-1,
		231,
		227,
		232,
		233,
		230,
		238,
		233,
		224,
		209,
		215,
		202,
		201,
		219,
		223,
		232,
		239,
		229,
		242,
		246,
		-1,
		192,
		235,
		229,
		232,
		256,
		270,
		-1,
		215,
		-1,
		-1,
		200,
		218,
		226,
		222,
		226,
		279,
		247,
		242,
		232,
		230,
		221,
		212,
		219,
		210,
		210,
		213,
		228,
		233,
		225,
		239,
		239,
		240,
		-1,
		227,
		215,
		223,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		216,
		-1,
		252,
		-1,
		245,
		249,
		255,
		258,
		246,
		233,
		225,
		217,
		233,
		208,
		218,
		214,
		215,
		224,
		235,
		247,
		246,
		247,
		301,
		256,
		223,
		214,
		261,
		276,
		280,
		-1,
		228,
		267,
		254,
		-1,
		225,
		-1,
		-1,
		-1,
		259,
		268,
		260,
		266,
		245,
		245,
		219,
		223,
		213,
		220,
		230,
		232,
		224,
		228,
		241,
		252,
		255,
		297,
		295,
		300,
		245,
		228,
		246,
		255,
		276,
		243,
		234,
		261,
		261,
		250,
		245,
		232,
		-1,
		-1,
		282,
		278,
		-1,
		-1,
		252,
		240,
		223,
		224,
		220,
		223,
		238,
		241,
		231,
		229,
		223,
		255,
		-1,
		297,
		296,
		285,
		282,
		258,
		249,
		236,
		247,
		-1,
		-1,
		246,
		262,
		275,
		279,
		292,
		317,
		-1,
		235,
		-1,
		-1,
		297,
		-1,
		-1,
		282,
		245,
		234,
		225,
		231,
		228,
		239,
		249,
		237,
		238,
		228,
		238,
		251,
		281,
		278,
		266,
		264,
		287,
		244,
		240,
		-1,
		261,
		249,
		255,
		262,
		279,
		306,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		280,
		278,
		267,
		-1,
		257,
		230,
		235,
		255,
		257,
		246,
		240,
		234,
		241,
		240,
		248,
		256,
		290,
		304,
		293,
		289,
		288,
		296,
		245,
		262,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		-1,
		286,
		261,
		-1,
		-1,
		275,
		268,
		256,
		244,
		234,
		244,
		248,
		252,
		244,
		237,
		232,
		243,
		235,
		239,
		256,
		-1,
		324,
		-1,
		276,
		269,
		284,
		299,
		307,
		-1,
		-1,
		-1,
		303,
		289,
		282,
		270,
		268,
		-1,
		309,
		293,
		274,
		-1,
		244,
		257,
		288,
		256,
		261,
		256,
		238,
		249,
		238,
		241,
		255,
		250,
		-1,
		-1,
		282,
		285,
		-1,
		-1,
		307,
		326,
		-1,
		294,
		283,
		268,
		260,
		-1,
		-1,
		281,
		277,
		-1,
		-1,
		245,
		270,
		259,
		267,
		262,
		242,
		248,
		251,
		240,
		244,
		256,
		-1,
		-1,
		289,
		290,
		295,
		-1,
		310,
		-1,
		318,
		-1,
		263,
		279,
		281,
		-1,
		-1,
		-1,
		283,
		246,
		267,
		277,
		271,
		269,
		260,
		246,
		253,
		251,
		247,
		258,
		-1,
		-1,
		-1,
		328,
		302,
		325,
		316,
		299,
		279,
		271,
		296,
		-1,
		270,
		-1,
		245,
		247,
		273,
		276,
		282,
		276,
		249,
		264,
		254,
		245,
		254,
		334,
		-1,
		304,
		337,
		301,
		285,
		271,
		275,
		291,
		-1,
		267,
		249,
		-1,
		277,
		267,
		298,
		283,
		264,
		251,
		258,
		258,
		251,
		-1,
		-1,
		-1,
		306,
		305,
		297,
		291,
		291,
		276,
		267,
		-1,
		279,
		261,
		240,
		257,
		257,
		248,
		256,
		288,
		284,
		271,
		271,
		263,
		-1,
		396,
		-1,
		-1,
		329,
		-1,
		-1,
		-1,
		300,
		295,
		268,
		256,
		262,
		258,
		244,
		250,
		252,
		260,
		258,
		255,
		267,
		263,
		283,
		264,
		299,
		-1,
		402,
		-1,
		336,
		-1,
		-1,
		318,
		298,
		290,
		279,
		268,
		266,
		257,
		248,
		270,
		286,
		270,
		268,
		271,
		272,
		-1,
		391,
		390,
		-1,
		337,
		329,
		315,
		-1,
		308,
		-1,
		314,
		275,
		-1,
		277,
		257,
		-1,
		279,
		275,
		-1,
		-1,
		378,
		353,
		-1,
		-1,
		-1,
		338,
		318,
		309,
		293,
		-1,
		268,
		268,
		-1,
		-1,
		-1,
		363,
		362,
		-1,
		331,
		334,
		-1,
		324,
		315,
		323,
		270,
		274,
		-1,
		-1,
		-1,
		372,
		353,
		347,
		346,
		344,
		339,
		336,
		322,
		306,
		284,
		273,
		294,
		-1,
		-1,
		-1,
		344,
		336,
		329,
		-1,
		-1,
		331,
		314,
		295,
		293,
		-1,
		-1,
		-1,
		366,
		347,
		-1,
		-1,
		321,
		-1,
		-1,
		327,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		383,
		355,
		-1,
		-1,
		-1,
		317,
		313,
		314,
		-1,
		-1,
		-1,
		-1,
		377,
		378,
		401,
		365,
		-1,
		-1,
		-1,
		309,
		303,
		-1,
		-1,
		380,
		378,
		-1,
		-1,
		-1,
		337,
		321,
		-1,
		307,
		-1,
		-1,
		-1,
		328,
		-1,
		-1,
		340,
		-1,
		-1,
		-1,
		342,
		-1,
		342,
		317,
		324,
		-1,
		-1,
		-1,
		-1,
		355,
		347,
		355,
		-1,
		327,
		329,
		-1,
		377,
		-1,
		-1,
		370,
		361,
		-1,
		-1,
		332,
		339,
		361,
		364,
		400,
		-1,
		351
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		139,
		128,
		139,
		147,
		120,
		127,
		-1,
		148,
		150,
		116,
		110,
		149,
		120,
		126,
		137,
		-1,
		-1,
		-1,
		139,
		138,
		108,
		106,
		115,
		120,
		127,
		-1,
		150,
		-1,
		160,
		139,
		150,
		155,
		101,
		98,
		118,
		137,
		143,
		135,
		175,
		131,
		102,
		96,
		114,
		119,
		137,
		129,
		-1,
		102,
		92,
		114,
		118,
		130,
		113,
		-1,
		-1,
		96,
		97,
		103,
		115,
		120,
		125,
		-1,
		151,
		148,
		-1,
		-1,
		86,
		99,
		95,
		98,
		106,
		122,
		143,
		148,
		143,
		-1,
		-1,
		87,
		91,
		104,
		105,
		103,
		130,
		149,
		138,
		152,
		151,
		-1,
		75,
		93,
		102,
		111,
		117,
		106,
		110,
		128,
		137,
		143,
		146,
		-1,
		67,
		69,
		98,
		104,
		116,
		122,
		109,
		115,
		132,
		125,
		144,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		64,
		72,
		98,
		97,
		93,
		111,
		132,
		112,
		118,
		120,
		117,
		133,
		134,
		144,
		-1,
		-1,
		120,
		89,
		124,
		81,
		66,
		-1,
		60,
		79,
		85,
		89,
		94,
		102,
		129,
		125,
		-1,
		111,
		110,
		141,
		127,
		138,
		80,
		-1,
		-1,
		78,
		70,
		55,
		58,
		55,
		55,
		85,
		84,
		89,
		91,
		93,
		105,
		115,
		115,
		121,
		105,
		115,
		119,
		130,
		145,
		-1,
		-1,
		200,
		-1,
		-1,
		77,
		60,
		-1,
		43,
		50,
		50,
		67,
		57,
		78,
		93,
		97,
		105,
		108,
		96,
		110,
		107,
		120,
		108,
		102,
		127,
		131,
		125,
		146,
		141,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		55,
		36,
		39,
		45,
		69,
		79,
		-1,
		100,
		98,
		122,
		116,
		121,
		113,
		101,
		114,
		99,
		106,
		105,
		109,
		111,
		144,
		122,
		144,
		141,
		170,
		175,
		169,
		178,
		-1,
		85,
		81,
		77,
		84,
		33,
		-1,
		-1,
		73,
		-1,
		87,
		100,
		112,
		102,
		105,
		117,
		121,
		108,
		97,
		108,
		97,
		94,
		102,
		111,
		122,
		117,
		116,
		134,
		149,
		162,
		166,
		172,
		-1,
		135,
		-1,
		77,
		61,
		63,
		35,
		56,
		-1,
		93,
		88,
		108,
		114,
		113,
		-1,
		116,
		119,
		126,
		104,
		89,
		106,
		98,
		96,
		101,
		106,
		120,
		111,
		129,
		136,
		144,
		148,
		168,
		180,
		95,
		85,
		-1,
		67,
		72,
		31,
		39,
		58,
		131,
		115,
		-1,
		114,
		-1,
		106,
		131,
		-1,
		110,
		106,
		88,
		89,
		84,
		99,
		105,
		102,
		99,
		117,
		120,
		137,
		141,
		157,
		-1,
		-1,
		80,
		84,
		73,
		24,
		43,
		67,
		104,
		112,
		101,
		100,
		-1,
		91,
		121,
		118,
		104,
		91,
		81,
		82,
		90,
		103,
		82,
		101,
		104,
		126,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		50,
		21,
		45,
		87,
		130,
		123,
		111,
		76,
		76,
		70,
		-1,
		111,
		94,
		90,
		79,
		77,
		90,
		85,
		101,
		105,
		104,
		123,
		135,
		126,
		146,
		-1,
		-1,
		-1,
		80,
		69,
		70,
		16,
		39,
		76,
		109,
		95,
		100,
		75,
		68,
		62,
		114,
		111,
		78,
		86,
		78,
		67,
		81,
		89,
		93,
		102,
		111,
		117,
		141,
		141,
		147,
		-1,
		-1,
		87,
		77,
		61,
		63,
		60,
		30,
		37,
		69,
		100,
		97,
		-1,
		67,
		-1,
		56,
		64,
		63,
		69,
		81,
		67,
		72,
		83,
		95,
		108,
		104,
		111,
		146,
		146,
		131,
		151,
		154,
		-1,
		-1,
		-1,
		80,
		73,
		48,
		25,
		11,
		47,
		-1,
		67,
		68,
		-1,
		61,
		55,
		61,
		60,
		67,
		64,
		64,
		78,
		86,
		82,
		98,
		104,
		96,
		132,
		-1,
		139,
		133,
		141,
		131,
		119,
		-1,
		-1,
		-1,
		71,
		50,
		43,
		63,
		4,
		56,
		-1,
		-1,
		52,
		45,
		-1,
		48,
		48,
		55,
		64,
		69,
		74,
		82,
		77,
		90,
		95,
		101,
		106,
		124,
		128,
		132,
		121,
		117,
		114,
		128,
		-1,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		0,
		24,
		-1,
		54,
		46,
		43,
		37,
		43,
		61,
		59,
		79,
		71,
		85,
		85,
		91,
		99,
		84,
		87,
		103,
		101,
		119,
		127,
		119,
		113,
		112,
		124,
		-1,
		109,
		95,
		66,
		-1,
		-1,
		33,
		-1,
		3,
		27,
		43,
		-1,
		77,
		56,
		79,
		57,
		71,
		67,
		105,
		106,
		84,
		89,
		97,
		107,
		109,
		98,
		109,
		101,
		123,
		123,
		107,
		108,
		117,
		-1,
		115,
		102,
		60,
		56,
		45,
		65,
		6,
		25,
		30,
		-1,
		-1,
		121,
		-1,
		55,
		72,
		81,
		79,
		95,
		86,
		92,
		108,
		111,
		113,
		103,
		92,
		98,
		95,
		117,
		103,
		101,
		120,
		136,
		-1,
		-1,
		-1,
		82,
		-1,
		-1,
		31,
		18,
		12,
		-1,
		47,
		-1,
		99,
		89,
		73,
		58,
		91,
		-1,
		103,
		87,
		92,
		-1,
		138,
		-1,
		111,
		113,
		107,
		92,
		89,
		100,
		98,
		109,
		126,
		-1,
		65,
		50,
		43,
		33,
		47,
		18,
		-1,
		73,
		-1,
		-1,
		86,
		80,
		80,
		64,
		67,
		119,
		99,
		93,
		92,
		133,
		133,
		119,
		105,
		98,
		95,
		92,
		105,
		125,
		116,
		128,
		-1,
		-1,
		-1,
		70,
		56,
		60,
		20,
		39,
		-1,
		-1,
		148,
		103,
		89,
		-1,
		73,
		136,
		124,
		114,
		104,
		138,
		139,
		124,
		117,
		103,
		105,
		103,
		101,
		106,
		127,
		128,
		141,
		-1,
		-1,
		53,
		58,
		46,
		32,
		51,
		-1,
		-1,
		-1,
		95,
		111,
		103,
		74,
		125,
		-1,
		-1,
		116,
		114,
		124,
		120,
		107,
		127,
		130,
		116,
		100,
		115,
		127,
		135,
		140,
		-1,
		56,
		43,
		-1,
		-1,
		54,
		48,
		-1,
		-1,
		-1,
		-1,
		128,
		94,
		106,
		127,
		152,
		119,
		-1,
		124,
		125,
		111,
		125,
		132,
		118,
		113,
		107,
		110,
		128,
		145,
		-1,
		-1,
		68,
		-1,
		63,
		-1,
		-1,
		-1,
		-1,
		85,
		99,
		120,
		126,
		138,
		-1,
		133,
		127,
		113,
		130,
		131,
		128,
		119,
		111,
		116,
		113,
		126,
		140,
		144,
		91,
		-1,
		74,
		-1,
		-1,
		-1,
		103,
		118,
		180,
		157,
		130,
		134,
		127,
		121,
		121,
		137,
		139,
		150,
		118,
		114,
		115,
		119,
		118,
		135,
		145,
		-1,
		-1,
		74,
		91,
		126,
		111,
		115,
		207,
		-1,
		-1,
		143,
		134,
		125,
		128,
		131,
		134,
		124,
		121,
		126,
		131,
		119,
		128,
		146,
		150,
		-1,
		-1,
		-1,
		94,
		-1,
		109,
		-1,
		-1,
		130,
		214,
		161,
		143,
		139,
		137,
		130,
		139,
		134,
		129,
		139,
		148,
		140,
		121,
		132,
		155,
		144,
		182,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		123,
		98,
		113,
		159,
		150,
		155,
		176,
		173,
		-1,
		143,
		168,
		140,
		147,
		139,
		147,
		147,
		144,
		122,
		129,
		145,
		144,
		139,
		174,
		166,
		172,
		-1,
		-1,
		206,
		195,
		184,
		190,
		-1,
		129,
		115,
		145,
		135,
		141,
		-1,
		-1,
		188,
		185,
		165,
		149,
		153,
		146,
		141,
		151,
		131,
		118,
		122,
		126,
		132,
		137,
		142,
		148,
		163,
		178,
		-1,
		101,
		182,
		175,
		158,
		166,
		197,
		-1,
		132,
		141,
		122,
		127,
		135,
		-1,
		-1,
		161,
		157,
		162,
		156,
		153,
		161,
		156,
		147,
		132,
		138,
		125,
		124,
		142,
		146,
		155,
		162,
		152,
		165,
		169,
		-1,
		115,
		158,
		152,
		155,
		179,
		193,
		-1,
		145,
		-1,
		-1,
		130,
		148,
		156,
		152,
		156,
		209,
		170,
		165,
		155,
		153,
		144,
		135,
		142,
		133,
		133,
		136,
		151,
		156,
		148,
		162,
		162,
		163,
		-1,
		150,
		138,
		146,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		146,
		-1,
		182,
		-1,
		175,
		179,
		178,
		181,
		169,
		156,
		148,
		140,
		156,
		131,
		141,
		137,
		138,
		147,
		158,
		170,
		169,
		170,
		224,
		179,
		146,
		137,
		184,
		199,
		203,
		-1,
		158,
		197,
		184,
		-1,
		155,
		-1,
		-1,
		-1,
		189,
		191,
		183,
		189,
		168,
		168,
		142,
		146,
		136,
		143,
		153,
		155,
		147,
		151,
		164,
		175,
		178,
		220,
		218,
		223,
		168,
		151,
		169,
		178,
		199,
		173,
		164,
		191,
		191,
		180,
		175,
		162,
		-1,
		-1,
		212,
		201,
		-1,
		-1,
		175,
		163,
		146,
		147,
		143,
		146,
		161,
		164,
		154,
		152,
		146,
		178,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		159,
		170,
		-1,
		-1,
		176,
		192,
		205,
		209,
		222,
		247,
		-1,
		165,
		-1,
		-1,
		220,
		-1,
		-1,
		205,
		168,
		157,
		148,
		154,
		151,
		162,
		172,
		160,
		161,
		151,
		161,
		174,
		204,
		201,
		189,
		187,
		210,
		167,
		163,
		-1,
		191,
		179,
		185,
		192,
		209,
		236,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		203,
		201,
		190,
		-1,
		180,
		153,
		158,
		178,
		180,
		169,
		163,
		157,
		164,
		163,
		171,
		179,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		216,
		191,
		-1,
		-1,
		198,
		191,
		179,
		167,
		157,
		167,
		171,
		175,
		167,
		160,
		155,
		166,
		158,
		162,
		179,
		-1,
		247,
		-1,
		199,
		192,
		207,
		222,
		230,
		-1,
		-1,
		-1,
		233,
		219,
		212,
		200,
		198,
		-1,
		232,
		216,
		197,
		-1,
		167,
		180,
		211,
		179,
		184,
		179,
		161,
		172,
		161,
		164,
		178,
		173,
		-1,
		-1,
		205,
		208,
		-1,
		-1,
		230,
		249,
		-1,
		224,
		213,
		198,
		190,
		-1,
		-1,
		204,
		200,
		-1,
		-1,
		168,
		193,
		182,
		190,
		185,
		165,
		171,
		174,
		163,
		167,
		179,
		-1,
		-1,
		212,
		213,
		218,
		-1,
		233,
		-1,
		248,
		-1,
		193,
		209,
		211,
		-1,
		-1,
		-1,
		206,
		169,
		190,
		200,
		194,
		192,
		183,
		169,
		176,
		174,
		170,
		181,
		-1,
		-1,
		-1,
		251,
		225,
		255,
		246,
		229,
		209,
		201,
		223,
		-1,
		193,
		-1,
		168,
		170,
		196,
		199,
		205,
		199,
		172,
		187,
		177,
		168,
		177,
		257,
		-1,
		227,
		260,
		224,
		215,
		194,
		198,
		214,
		-1,
		190,
		172,
		-1,
		200,
		190,
		221,
		206,
		187,
		174,
		181,
		181,
		174,
		-1,
		-1,
		-1,
		229,
		228,
		220,
		214,
		214,
		199,
		190,
		-1,
		202,
		184,
		163,
		180,
		180,
		171,
		179,
		211,
		207,
		194,
		194,
		186,
		-1,
		319,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		223,
		218,
		191,
		179,
		185,
		181,
		167,
		173,
		175,
		183,
		181,
		178,
		190,
		186,
		206,
		187,
		222,
		-1,
		325,
		-1,
		259,
		-1,
		-1,
		241,
		221,
		213,
		202,
		191,
		189,
		180,
		171,
		193,
		209,
		193,
		191,
		194,
		195,
		-1,
		314,
		313,
		-1,
		260,
		252,
		238,
		-1,
		231,
		-1,
		237,
		198,
		-1,
		200,
		180,
		-1,
		202,
		198,
		-1,
		-1,
		301,
		276,
		-1,
		-1,
		-1,
		261,
		241,
		232,
		216,
		-1,
		191,
		191,
		-1,
		-1,
		-1,
		286,
		285,
		-1,
		254,
		257,
		-1,
		247,
		238,
		246,
		193,
		197,
		-1,
		-1,
		-1,
		295,
		276,
		270,
		269,
		267,
		262,
		259,
		245,
		229,
		207,
		196,
		217,
		-1,
		-1,
		-1,
		267,
		259,
		252,
		-1,
		-1,
		254,
		237,
		218,
		216,
		-1,
		-1,
		-1,
		289,
		270,
		-1,
		-1,
		244,
		-1,
		-1,
		250,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		278,
		-1,
		-1,
		-1,
		240,
		236,
		237,
		-1,
		-1,
		-1,
		-1,
		300,
		301,
		324,
		288,
		-1,
		-1,
		-1,
		232,
		226,
		-1,
		-1,
		303,
		301,
		-1,
		-1,
		-1,
		260,
		244,
		-1,
		230,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		265,
		-1,
		265,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		278,
		270,
		278,
		-1,
		250,
		252,
		-1,
		300,
		-1,
		-1,
		293,
		284,
		-1,
		-1,
		255,
		262,
		284,
		287,
		323,
		-1,
		274
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		182,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		175,
		167,
		207,
		163,
		134,
		128,
		146,
		151,
		169,
		161,
		-1,
		134,
		124,
		146,
		150,
		162,
		145,
		-1,
		-1,
		128,
		129,
		135,
		147,
		152,
		157,
		-1,
		183,
		183,
		-1,
		-1,
		118,
		131,
		127,
		130,
		138,
		154,
		175,
		183,
		178,
		-1,
		-1,
		119,
		123,
		136,
		137,
		135,
		162,
		181,
		173,
		187,
		186,
		-1,
		107,
		125,
		134,
		143,
		149,
		138,
		142,
		160,
		172,
		178,
		181,
		-1,
		99,
		101,
		130,
		136,
		148,
		154,
		141,
		147,
		166,
		160,
		179,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		96,
		104,
		130,
		129,
		125,
		143,
		165,
		144,
		150,
		154,
		152,
		168,
		169,
		179,
		-1,
		-1,
		152,
		121,
		156,
		113,
		98,
		-1,
		92,
		111,
		117,
		121,
		126,
		134,
		162,
		160,
		-1,
		146,
		145,
		176,
		162,
		173,
		112,
		-1,
		-1,
		110,
		102,
		87,
		90,
		87,
		87,
		117,
		116,
		121,
		123,
		125,
		137,
		150,
		150,
		156,
		140,
		150,
		154,
		165,
		180,
		-1,
		-1,
		235,
		-1,
		-1,
		109,
		92,
		-1,
		75,
		82,
		82,
		99,
		89,
		110,
		125,
		129,
		137,
		140,
		128,
		145,
		142,
		155,
		143,
		137,
		162,
		166,
		160,
		181,
		176,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		68,
		71,
		77,
		101,
		111,
		-1,
		132,
		130,
		154,
		148,
		153,
		148,
		134,
		149,
		134,
		141,
		140,
		144,
		146,
		179,
		157,
		179,
		176,
		205,
		210,
		204,
		213,
		-1,
		117,
		113,
		109,
		116,
		65,
		-1,
		-1,
		105,
		-1,
		119,
		132,
		144,
		134,
		137,
		149,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		146,
		157,
		152,
		151,
		169,
		184,
		197,
		201,
		207,
		-1,
		167,
		-1,
		109,
		93,
		95,
		67,
		88,
		-1,
		125,
		120,
		140,
		146,
		146,
		-1,
		151,
		154,
		161,
		139,
		124,
		141,
		133,
		131,
		136,
		141,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		127,
		117,
		-1,
		99,
		104,
		63,
		71,
		90,
		163,
		147,
		-1,
		149,
		-1,
		141,
		166,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		140,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		112,
		116,
		105,
		56,
		75,
		99,
		136,
		147,
		136,
		135,
		-1,
		126,
		156,
		153,
		139,
		126,
		116,
		117,
		125,
		138,
		117,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		82,
		53,
		77,
		119,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		146,
		129,
		125,
		114,
		112,
		125,
		120,
		136,
		140,
		139,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		112,
		101,
		102,
		48,
		71,
		108,
		144,
		130,
		135,
		110,
		103,
		97,
		149,
		146,
		113,
		121,
		113,
		102,
		116,
		124,
		128,
		137,
		146,
		152,
		176,
		176,
		182,
		-1,
		-1,
		119,
		109,
		93,
		95,
		92,
		62,
		69,
		101,
		135,
		132,
		-1,
		102,
		-1,
		91,
		99,
		98,
		104,
		116,
		102,
		107,
		118,
		130,
		143,
		139,
		146,
		181,
		181,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		112,
		105,
		80,
		57,
		43,
		79,
		-1,
		102,
		103,
		-1,
		96,
		90,
		96,
		95,
		102,
		99,
		99,
		113,
		121,
		117,
		133,
		139,
		131,
		167,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		103,
		82,
		75,
		95,
		36,
		68,
		-1,
		-1,
		87,
		80,
		-1,
		83,
		83,
		90,
		99,
		104,
		109,
		117,
		112,
		125,
		130,
		136,
		141,
		159,
		163,
		167,
		156,
		152,
		149,
		163,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		39,
		0,
		-1,
		93,
		85,
		78,
		72,
		78,
		96,
		94,
		114,
		106,
		120,
		120,
		126,
		134,
		119,
		122,
		138,
		136,
		154,
		162,
		154,
		148,
		147,
		159,
		-1,
		144,
		130,
		101,
		-1,
		-1,
		69,
		-1,
		42,
		66,
		82,
		-1,
		112,
		91,
		114,
		92,
		106,
		102,
		140,
		141,
		119,
		124,
		132,
		142,
		144,
		133,
		144,
		136,
		158,
		158,
		142,
		143,
		152,
		-1,
		150,
		137,
		95,
		91,
		80,
		100,
		45,
		60,
		69,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		116,
		114,
		130,
		121,
		127,
		143,
		146,
		148,
		138,
		127,
		133,
		130,
		152,
		138,
		136,
		155,
		171,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		66,
		53,
		47,
		-1,
		86,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		138,
		122,
		127,
		-1,
		173,
		-1,
		146,
		148,
		142,
		127,
		124,
		135,
		133,
		144,
		161,
		-1,
		100,
		85,
		78,
		68,
		82,
		53,
		-1,
		108,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		154,
		134,
		128,
		127,
		168,
		168,
		154,
		140,
		133,
		130,
		127,
		140,
		160,
		151,
		163,
		-1,
		-1,
		-1,
		105,
		91,
		95,
		55,
		74,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		171,
		159,
		149,
		139,
		173,
		174,
		159,
		152,
		138,
		140,
		138,
		136,
		141,
		162,
		163,
		176,
		-1,
		-1,
		88,
		93,
		81,
		67,
		86,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		160,
		-1,
		-1,
		151,
		149,
		159,
		155,
		142,
		162,
		165,
		151,
		135,
		150,
		162,
		170,
		175,
		-1,
		91,
		78,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		162,
		187,
		154,
		-1,
		159,
		160,
		146,
		160,
		167,
		153,
		148,
		142,
		145,
		163,
		180,
		-1,
		-1,
		103,
		-1,
		98,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		155,
		161,
		173,
		-1,
		168,
		162,
		148,
		165,
		166,
		163,
		154,
		146,
		151,
		148,
		161,
		175,
		179,
		126,
		-1,
		109,
		-1,
		-1,
		-1,
		138,
		153,
		215,
		192,
		165,
		169,
		162,
		156,
		156,
		172,
		174,
		185,
		153,
		149,
		150,
		154,
		153,
		170,
		180,
		-1,
		-1,
		109,
		126,
		161,
		146,
		150,
		242,
		-1,
		-1,
		178,
		169,
		160,
		163,
		166,
		169,
		159,
		156,
		161,
		166,
		154,
		163,
		181,
		185,
		-1,
		-1,
		-1,
		129,
		-1,
		144,
		-1,
		-1,
		165,
		249,
		196,
		178,
		174,
		172,
		165,
		174,
		169,
		164,
		174,
		183,
		175,
		156,
		167,
		190,
		179,
		217,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		158,
		133,
		148,
		194,
		185,
		190,
		211,
		208,
		-1,
		178,
		203,
		175,
		182,
		174,
		182,
		182,
		179,
		157,
		164,
		180,
		179,
		174,
		209,
		201,
		207,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		164,
		150,
		180,
		170,
		176,
		-1,
		-1,
		223,
		220,
		200,
		184,
		188,
		181,
		176,
		186,
		166,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		136,
		217,
		210,
		193,
		201,
		232,
		-1,
		167,
		176,
		157,
		162,
		170,
		-1,
		-1,
		196,
		192,
		197,
		191,
		188,
		196,
		191,
		182,
		167,
		173,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		150,
		193,
		187,
		190,
		214,
		228,
		-1,
		180,
		-1,
		-1,
		165,
		183,
		191,
		187,
		191,
		244,
		205,
		200,
		190,
		188,
		179,
		170,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		185,
		173,
		181,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		181,
		-1,
		217,
		-1,
		210,
		214,
		213,
		216,
		204,
		191,
		183,
		175,
		191,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		259,
		214,
		181,
		172,
		219,
		234,
		238,
		-1,
		193,
		232,
		219,
		-1,
		190,
		-1,
		-1,
		-1,
		224,
		226,
		218,
		224,
		203,
		203,
		177,
		181,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		255,
		253,
		258,
		203,
		186,
		204,
		213,
		234,
		208,
		199,
		226,
		226,
		215,
		210,
		197,
		-1,
		-1,
		247,
		236,
		-1,
		-1,
		210,
		198,
		181,
		182,
		178,
		181,
		196,
		199,
		189,
		187,
		181,
		213,
		-1,
		255,
		254,
		243,
		240,
		216,
		207,
		194,
		205,
		-1,
		-1,
		211,
		227,
		240,
		244,
		257,
		282,
		-1,
		200,
		-1,
		-1,
		255,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		186,
		197,
		207,
		195,
		196,
		186,
		196,
		209,
		239,
		236,
		224,
		222,
		245,
		202,
		198,
		-1,
		226,
		214,
		220,
		227,
		244,
		271,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		238,
		236,
		225,
		-1,
		215,
		188,
		193,
		213,
		215,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		248,
		262,
		251,
		247,
		246,
		254,
		203,
		220,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		226,
		-1,
		-1,
		233,
		226,
		214,
		202,
		192,
		202,
		206,
		210,
		202,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		282,
		-1,
		234,
		227,
		242,
		257,
		265,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		240,
		243,
		-1,
		-1,
		265,
		284,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		247,
		248,
		253,
		-1,
		268,
		-1,
		283,
		-1,
		228,
		244,
		246,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		229,
		227,
		218,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		286,
		260,
		290,
		281,
		264,
		244,
		236,
		258,
		-1,
		228,
		-1,
		203,
		205,
		231,
		234,
		240,
		234,
		207,
		222,
		212,
		203,
		212,
		292,
		-1,
		262,
		295,
		259,
		250,
		229,
		233,
		249,
		-1,
		225,
		207,
		-1,
		235,
		225,
		256,
		241,
		222,
		209,
		216,
		216,
		209,
		-1,
		-1,
		-1,
		264,
		263,
		255,
		249,
		249,
		234,
		225,
		-1,
		237,
		219,
		198,
		215,
		215,
		206,
		214,
		246,
		242,
		229,
		229,
		221,
		-1,
		354,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		258,
		253,
		226,
		214,
		220,
		216,
		202,
		208,
		210,
		218,
		216,
		213,
		225,
		221,
		241,
		222,
		257,
		-1,
		360,
		-1,
		294,
		-1,
		-1,
		276,
		256,
		248,
		237,
		226,
		224,
		215,
		206,
		228,
		244,
		228,
		226,
		229,
		230,
		-1,
		349,
		348,
		-1,
		295,
		287,
		273,
		-1,
		266,
		-1,
		272,
		233,
		-1,
		235,
		215,
		-1,
		237,
		233,
		-1,
		-1,
		336,
		311,
		-1,
		-1,
		-1,
		296,
		276,
		267,
		251,
		-1,
		226,
		226,
		-1,
		-1,
		-1,
		321,
		320,
		-1,
		289,
		292,
		-1,
		282,
		273,
		281,
		228,
		232,
		-1,
		-1,
		-1,
		330,
		311,
		305,
		304,
		302,
		297,
		294,
		280,
		264,
		242,
		231,
		252,
		-1,
		-1,
		-1,
		302,
		294,
		287,
		-1,
		-1,
		289,
		272,
		253,
		251,
		-1,
		-1,
		-1,
		324,
		305,
		-1,
		-1,
		279,
		-1,
		-1,
		285,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		341,
		313,
		-1,
		-1,
		-1,
		275,
		271,
		272,
		-1,
		-1,
		-1,
		-1,
		335,
		336,
		359,
		323,
		-1,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		338,
		336,
		-1,
		-1,
		-1,
		295,
		279,
		-1,
		265,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		300,
		-1,
		300,
		275,
		282,
		-1,
		-1,
		-1,
		-1,
		313,
		305,
		313,
		-1,
		285,
		287,
		-1,
		335,
		-1,
		-1,
		328,
		319,
		-1,
		-1,
		290,
		297,
		319,
		322,
		358,
		-1,
		309
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		187,
		176,
		187,
		195,
		168,
		175,
		-1,
		196,
		198,
		164,
		158,
		197,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		187,
		186,
		156,
		154,
		163,
		168,
		175,
		-1,
		188,
		-1,
		208,
		187,
		198,
		203,
		149,
		146,
		166,
		185,
		181,
		173,
		223,
		179,
		150,
		144,
		162,
		166,
		175,
		167,
		-1,
		150,
		140,
		162,
		155,
		166,
		158,
		-1,
		-1,
		144,
		145,
		151,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		134,
		147,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		135,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		123,
		141,
		150,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		145,
		-1,
		115,
		117,
		137,
		145,
		150,
		134,
		121,
		121,
		131,
		124,
		143,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		112,
		120,
		141,
		133,
		123,
		138,
		131,
		124,
		121,
		119,
		116,
		132,
		133,
		143,
		-1,
		-1,
		168,
		137,
		172,
		129,
		114,
		-1,
		108,
		117,
		123,
		127,
		121,
		114,
		128,
		124,
		-1,
		110,
		109,
		140,
		126,
		137,
		128,
		-1,
		-1,
		126,
		118,
		103,
		106,
		103,
		103,
		132,
		131,
		123,
		109,
		105,
		111,
		114,
		114,
		120,
		104,
		114,
		118,
		129,
		144,
		-1,
		-1,
		199,
		-1,
		-1,
		125,
		108,
		-1,
		91,
		98,
		98,
		115,
		105,
		126,
		141,
		133,
		125,
		119,
		107,
		109,
		106,
		119,
		107,
		101,
		126,
		130,
		124,
		145,
		140,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		84,
		87,
		93,
		117,
		127,
		-1,
		127,
		133,
		143,
		128,
		125,
		112,
		100,
		113,
		98,
		105,
		104,
		108,
		110,
		143,
		121,
		143,
		140,
		169,
		174,
		168,
		177,
		-1,
		133,
		129,
		125,
		132,
		81,
		-1,
		-1,
		121,
		-1,
		135,
		144,
		119,
		137,
		140,
		129,
		120,
		107,
		96,
		107,
		96,
		93,
		101,
		110,
		121,
		116,
		115,
		133,
		148,
		161,
		165,
		171,
		-1,
		183,
		-1,
		125,
		109,
		111,
		83,
		104,
		-1,
		141,
		136,
		136,
		121,
		112,
		-1,
		115,
		118,
		125,
		103,
		88,
		105,
		97,
		95,
		100,
		105,
		119,
		110,
		128,
		135,
		143,
		147,
		167,
		179,
		143,
		133,
		-1,
		115,
		120,
		79,
		87,
		106,
		154,
		118,
		-1,
		113,
		-1,
		105,
		130,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		104,
		101,
		98,
		116,
		119,
		136,
		140,
		156,
		-1,
		-1,
		128,
		132,
		121,
		72,
		91,
		115,
		152,
		111,
		100,
		99,
		-1,
		90,
		120,
		117,
		103,
		90,
		80,
		81,
		89,
		102,
		81,
		100,
		103,
		125,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		98,
		69,
		93,
		135,
		129,
		122,
		110,
		75,
		75,
		69,
		-1,
		110,
		93,
		89,
		78,
		76,
		89,
		84,
		100,
		104,
		103,
		122,
		134,
		125,
		145,
		-1,
		-1,
		-1,
		128,
		117,
		118,
		64,
		87,
		124,
		108,
		94,
		99,
		74,
		67,
		61,
		113,
		110,
		77,
		85,
		77,
		66,
		80,
		88,
		92,
		101,
		110,
		116,
		140,
		140,
		146,
		-1,
		-1,
		135,
		125,
		109,
		111,
		108,
		78,
		85,
		117,
		99,
		91,
		-1,
		66,
		-1,
		55,
		63,
		62,
		68,
		80,
		66,
		71,
		82,
		94,
		107,
		103,
		110,
		145,
		145,
		130,
		150,
		153,
		-1,
		-1,
		-1,
		128,
		122,
		97,
		74,
		59,
		95,
		-1,
		61,
		62,
		-1,
		60,
		54,
		60,
		59,
		66,
		63,
		63,
		77,
		85,
		81,
		97,
		103,
		95,
		131,
		-1,
		138,
		132,
		140,
		130,
		118,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		53,
		105,
		-1,
		-1,
		46,
		39,
		-1,
		47,
		47,
		54,
		63,
		68,
		73,
		81,
		76,
		89,
		94,
		100,
		105,
		123,
		127,
		131,
		120,
		116,
		113,
		127,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		49,
		73,
		-1,
		0,
		12,
		24,
		28,
		37,
		60,
		58,
		78,
		70,
		84,
		84,
		90,
		98,
		83,
		86,
		102,
		100,
		118,
		126,
		118,
		112,
		111,
		123,
		-1,
		141,
		127,
		98,
		-1,
		-1,
		82,
		-1,
		46,
		33,
		49,
		-1,
		71,
		50,
		74,
		56,
		70,
		66,
		104,
		105,
		83,
		88,
		96,
		106,
		108,
		97,
		108,
		100,
		122,
		122,
		106,
		107,
		116,
		-1,
		147,
		134,
		92,
		88,
		77,
		97,
		48,
		36,
		36,
		-1,
		-1,
		120,
		-1,
		54,
		71,
		80,
		78,
		94,
		85,
		91,
		107,
		110,
		112,
		102,
		91,
		97,
		94,
		116,
		102,
		100,
		119,
		135,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		63,
		50,
		44,
		-1,
		53,
		-1,
		98,
		88,
		72,
		57,
		90,
		-1,
		102,
		86,
		91,
		-1,
		137,
		-1,
		110,
		112,
		106,
		91,
		88,
		99,
		97,
		108,
		125,
		-1,
		97,
		82,
		75,
		65,
		79,
		50,
		-1,
		98,
		-1,
		-1,
		85,
		79,
		79,
		63,
		66,
		118,
		98,
		92,
		91,
		132,
		132,
		118,
		104,
		97,
		94,
		91,
		104,
		124,
		115,
		127,
		-1,
		-1,
		-1,
		102,
		79,
		85,
		43,
		64,
		-1,
		-1,
		147,
		102,
		88,
		-1,
		72,
		135,
		123,
		113,
		103,
		137,
		138,
		123,
		116,
		102,
		104,
		102,
		100,
		105,
		126,
		127,
		140,
		-1,
		-1,
		76,
		83,
		71,
		57,
		76,
		-1,
		-1,
		-1,
		94,
		110,
		102,
		73,
		124,
		-1,
		-1,
		115,
		113,
		123,
		119,
		106,
		126,
		129,
		115,
		99,
		114,
		126,
		134,
		139,
		-1,
		79,
		66,
		-1,
		-1,
		79,
		73,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		105,
		126,
		151,
		118,
		-1,
		123,
		124,
		110,
		124,
		131,
		117,
		112,
		106,
		109,
		127,
		144,
		-1,
		-1,
		93,
		-1,
		88,
		-1,
		-1,
		-1,
		-1,
		84,
		98,
		119,
		125,
		137,
		-1,
		132,
		126,
		112,
		129,
		130,
		127,
		118,
		110,
		115,
		112,
		125,
		139,
		143,
		116,
		-1,
		99,
		-1,
		-1,
		-1,
		102,
		117,
		179,
		156,
		129,
		133,
		126,
		120,
		120,
		136,
		138,
		149,
		117,
		113,
		114,
		118,
		117,
		134,
		144,
		-1,
		-1,
		99,
		116,
		128,
		110,
		114,
		206,
		-1,
		-1,
		142,
		133,
		124,
		127,
		130,
		133,
		123,
		120,
		125,
		130,
		118,
		127,
		145,
		149,
		-1,
		-1,
		-1,
		119,
		-1,
		134,
		-1,
		-1,
		129,
		213,
		160,
		142,
		138,
		136,
		129,
		138,
		133,
		128,
		138,
		147,
		139,
		120,
		131,
		154,
		143,
		181,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		148,
		123,
		138,
		184,
		149,
		156,
		175,
		172,
		-1,
		142,
		167,
		139,
		146,
		138,
		146,
		146,
		143,
		121,
		128,
		144,
		143,
		138,
		173,
		165,
		171,
		-1,
		-1,
		229,
		218,
		207,
		213,
		-1,
		154,
		140,
		170,
		160,
		166,
		-1,
		-1,
		191,
		188,
		164,
		148,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		124,
		205,
		198,
		181,
		189,
		220,
		-1,
		157,
		166,
		147,
		152,
		160,
		-1,
		-1,
		164,
		161,
		166,
		155,
		152,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		138,
		181,
		175,
		178,
		202,
		216,
		-1,
		170,
		-1,
		-1,
		155,
		173,
		179,
		169,
		163,
		213,
		169,
		164,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		173,
		161,
		169,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		171,
		-1,
		206,
		-1,
		181,
		185,
		177,
		180,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		247,
		202,
		169,
		160,
		207,
		222,
		226,
		-1,
		183,
		222,
		209,
		-1,
		180,
		-1,
		-1,
		-1,
		195,
		190,
		182,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		243,
		241,
		246,
		191,
		174,
		192,
		201,
		222,
		198,
		189,
		216,
		216,
		205,
		200,
		187,
		-1,
		-1,
		218,
		200,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		182,
		193,
		-1,
		-1,
		201,
		217,
		230,
		234,
		247,
		272,
		-1,
		190,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		227,
		224,
		212,
		210,
		233,
		190,
		186,
		-1,
		216,
		204,
		210,
		217,
		234,
		261,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		216,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		270,
		-1,
		222,
		215,
		230,
		245,
		253,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		228,
		231,
		-1,
		-1,
		247,
		249,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		235,
		236,
		241,
		-1,
		232,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		329,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		190,
		192,
		158,
		152,
		191,
		162,
		168,
		179,
		-1,
		-1,
		-1,
		181,
		180,
		150,
		148,
		157,
		162,
		169,
		-1,
		182,
		-1,
		202,
		181,
		192,
		197,
		143,
		140,
		160,
		179,
		175,
		167,
		217,
		173,
		144,
		138,
		156,
		160,
		169,
		161,
		-1,
		144,
		134,
		156,
		149,
		160,
		152,
		-1,
		-1,
		138,
		139,
		145,
		145,
		151,
		147,
		-1,
		157,
		141,
		-1,
		-1,
		128,
		141,
		127,
		130,
		138,
		136,
		149,
		141,
		136,
		-1,
		-1,
		129,
		129,
		136,
		123,
		119,
		136,
		149,
		131,
		145,
		144,
		-1,
		117,
		135,
		144,
		130,
		128,
		112,
		110,
		128,
		130,
		136,
		139,
		-1,
		109,
		111,
		131,
		139,
		144,
		128,
		115,
		115,
		125,
		118,
		137,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		106,
		114,
		135,
		127,
		117,
		132,
		125,
		118,
		115,
		113,
		110,
		126,
		127,
		137,
		-1,
		-1,
		162,
		131,
		166,
		123,
		108,
		-1,
		102,
		111,
		117,
		121,
		115,
		108,
		122,
		118,
		-1,
		104,
		103,
		134,
		120,
		131,
		122,
		-1,
		-1,
		120,
		112,
		97,
		100,
		97,
		97,
		126,
		125,
		117,
		103,
		99,
		105,
		108,
		108,
		114,
		98,
		108,
		112,
		123,
		138,
		-1,
		-1,
		193,
		-1,
		-1,
		119,
		102,
		-1,
		85,
		92,
		92,
		109,
		99,
		120,
		135,
		127,
		119,
		113,
		101,
		103,
		100,
		113,
		101,
		95,
		120,
		124,
		118,
		139,
		134,
		-1,
		192,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		78,
		81,
		87,
		111,
		121,
		-1,
		121,
		127,
		137,
		122,
		119,
		106,
		94,
		107,
		92,
		99,
		98,
		102,
		104,
		137,
		115,
		137,
		134,
		163,
		168,
		162,
		171,
		-1,
		127,
		123,
		119,
		126,
		75,
		-1,
		-1,
		115,
		-1,
		129,
		138,
		113,
		131,
		134,
		123,
		114,
		101,
		90,
		101,
		90,
		87,
		95,
		104,
		115,
		110,
		109,
		127,
		142,
		155,
		159,
		165,
		-1,
		177,
		-1,
		119,
		103,
		105,
		77,
		98,
		-1,
		135,
		130,
		130,
		115,
		106,
		-1,
		109,
		112,
		119,
		97,
		82,
		99,
		91,
		89,
		94,
		99,
		113,
		104,
		122,
		129,
		137,
		141,
		161,
		173,
		137,
		127,
		-1,
		109,
		114,
		73,
		81,
		100,
		148,
		112,
		-1,
		107,
		-1,
		99,
		124,
		-1,
		103,
		99,
		81,
		82,
		77,
		92,
		98,
		95,
		92,
		110,
		113,
		130,
		134,
		150,
		-1,
		-1,
		122,
		126,
		115,
		66,
		85,
		109,
		146,
		105,
		94,
		93,
		-1,
		84,
		114,
		111,
		97,
		84,
		74,
		75,
		83,
		96,
		75,
		94,
		97,
		119,
		147,
		125,
		137,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		92,
		63,
		87,
		129,
		123,
		116,
		104,
		69,
		69,
		63,
		-1,
		104,
		87,
		83,
		72,
		70,
		83,
		78,
		94,
		98,
		97,
		116,
		128,
		119,
		139,
		-1,
		-1,
		-1,
		122,
		111,
		112,
		58,
		81,
		118,
		102,
		88,
		93,
		68,
		61,
		55,
		107,
		104,
		71,
		79,
		71,
		60,
		74,
		82,
		86,
		95,
		104,
		110,
		134,
		134,
		140,
		-1,
		-1,
		129,
		119,
		103,
		105,
		102,
		72,
		79,
		111,
		93,
		85,
		-1,
		60,
		-1,
		49,
		57,
		56,
		62,
		74,
		60,
		65,
		76,
		88,
		101,
		97,
		104,
		139,
		139,
		124,
		144,
		147,
		-1,
		-1,
		-1,
		122,
		116,
		91,
		68,
		53,
		89,
		-1,
		55,
		56,
		-1,
		54,
		48,
		54,
		53,
		60,
		57,
		57,
		71,
		79,
		75,
		91,
		97,
		89,
		125,
		-1,
		132,
		126,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		114,
		93,
		86,
		106,
		47,
		99,
		-1,
		-1,
		40,
		33,
		-1,
		41,
		41,
		48,
		57,
		62,
		67,
		75,
		70,
		83,
		88,
		94,
		99,
		117,
		121,
		125,
		114,
		110,
		107,
		121,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		67,
		-1,
		14,
		0,
		14,
		18,
		31,
		54,
		52,
		72,
		64,
		78,
		78,
		84,
		92,
		77,
		80,
		96,
		94,
		112,
		120,
		112,
		106,
		105,
		117,
		-1,
		135,
		121,
		92,
		-1,
		-1,
		76,
		-1,
		40,
		27,
		43,
		-1,
		65,
		44,
		68,
		50,
		64,
		60,
		98,
		99,
		77,
		82,
		90,
		100,
		102,
		91,
		102,
		94,
		116,
		116,
		100,
		101,
		110,
		-1,
		141,
		128,
		86,
		82,
		71,
		91,
		42,
		30,
		30,
		-1,
		-1,
		114,
		-1,
		48,
		65,
		74,
		72,
		88,
		79,
		85,
		101,
		104,
		106,
		96,
		85,
		91,
		88,
		110,
		96,
		94,
		113,
		129,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		57,
		44,
		38,
		-1,
		47,
		-1,
		92,
		82,
		66,
		51,
		84,
		-1,
		96,
		80,
		85,
		-1,
		131,
		-1,
		104,
		106,
		100,
		85,
		82,
		93,
		91,
		102,
		119,
		-1,
		91,
		76,
		69,
		59,
		73,
		44,
		-1,
		92,
		-1,
		-1,
		79,
		73,
		73,
		57,
		60,
		112,
		92,
		86,
		85,
		126,
		126,
		112,
		98,
		91,
		88,
		85,
		98,
		118,
		109,
		121,
		-1,
		-1,
		-1,
		96,
		73,
		79,
		37,
		58,
		-1,
		-1,
		141,
		96,
		82,
		-1,
		66,
		129,
		117,
		107,
		97,
		131,
		132,
		117,
		110,
		96,
		98,
		96,
		94,
		99,
		120,
		121,
		134,
		-1,
		-1,
		70,
		77,
		65,
		51,
		70,
		-1,
		-1,
		-1,
		88,
		104,
		96,
		67,
		118,
		-1,
		-1,
		109,
		107,
		117,
		113,
		100,
		120,
		123,
		109,
		93,
		108,
		120,
		128,
		133,
		-1,
		73,
		60,
		-1,
		-1,
		73,
		67,
		-1,
		-1,
		-1,
		-1,
		121,
		87,
		99,
		120,
		145,
		112,
		-1,
		117,
		118,
		104,
		118,
		125,
		111,
		106,
		100,
		103,
		121,
		138,
		-1,
		-1,
		87,
		-1,
		82,
		-1,
		-1,
		-1,
		-1,
		78,
		92,
		113,
		119,
		131,
		-1,
		126,
		120,
		106,
		123,
		124,
		121,
		112,
		104,
		109,
		106,
		119,
		133,
		137,
		110,
		-1,
		93,
		-1,
		-1,
		-1,
		96,
		111,
		173,
		150,
		123,
		127,
		120,
		114,
		114,
		130,
		132,
		143,
		111,
		107,
		108,
		112,
		111,
		128,
		138,
		-1,
		-1,
		93,
		110,
		122,
		104,
		108,
		200,
		-1,
		-1,
		136,
		127,
		118,
		121,
		124,
		127,
		117,
		114,
		119,
		124,
		112,
		121,
		139,
		143,
		-1,
		-1,
		-1,
		113,
		-1,
		128,
		-1,
		-1,
		123,
		207,
		154,
		136,
		132,
		130,
		123,
		132,
		127,
		122,
		132,
		141,
		133,
		114,
		125,
		148,
		137,
		175,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		142,
		117,
		132,
		178,
		143,
		150,
		169,
		166,
		-1,
		136,
		161,
		133,
		140,
		132,
		140,
		140,
		137,
		115,
		122,
		138,
		137,
		132,
		167,
		159,
		165,
		-1,
		-1,
		223,
		212,
		201,
		207,
		-1,
		148,
		134,
		164,
		154,
		160,
		-1,
		-1,
		185,
		182,
		158,
		142,
		146,
		139,
		134,
		144,
		124,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		118,
		199,
		192,
		175,
		183,
		214,
		-1,
		151,
		160,
		141,
		146,
		154,
		-1,
		-1,
		158,
		155,
		160,
		149,
		146,
		154,
		149,
		140,
		125,
		131,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		132,
		175,
		169,
		172,
		196,
		210,
		-1,
		164,
		-1,
		-1,
		149,
		167,
		173,
		163,
		157,
		207,
		163,
		158,
		148,
		146,
		137,
		128,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		167,
		155,
		163,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		165,
		-1,
		200,
		-1,
		175,
		179,
		171,
		174,
		162,
		149,
		141,
		133,
		149,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		241,
		196,
		163,
		154,
		201,
		216,
		220,
		-1,
		177,
		216,
		203,
		-1,
		174,
		-1,
		-1,
		-1,
		189,
		184,
		176,
		182,
		161,
		161,
		135,
		139,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		237,
		235,
		240,
		185,
		168,
		186,
		195,
		216,
		192,
		183,
		210,
		210,
		199,
		194,
		181,
		-1,
		-1,
		212,
		194,
		-1,
		-1,
		168,
		156,
		139,
		140,
		136,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		176,
		187,
		-1,
		-1,
		195,
		211,
		224,
		228,
		241,
		266,
		-1,
		184,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		144,
		155,
		165,
		153,
		154,
		144,
		154,
		167,
		221,
		218,
		206,
		204,
		227,
		184,
		180,
		-1,
		210,
		198,
		204,
		211,
		228,
		255,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		146,
		151,
		171,
		173,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		202,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		210,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		164,
		168,
		160,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		264,
		-1,
		216,
		209,
		224,
		239,
		247,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		222,
		225,
		-1,
		-1,
		241,
		243,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		229,
		230,
		235,
		-1,
		226,
		-1,
		244,
		-1,
		211,
		217,
		205,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		187,
		185,
		176,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		244,
		218,
		251,
		242,
		225,
		205,
		197,
		216,
		-1,
		186,
		-1,
		161,
		163,
		189,
		192,
		198,
		192,
		165,
		180,
		170,
		161,
		170,
		250,
		-1,
		220,
		253,
		217,
		211,
		187,
		191,
		207,
		-1,
		183,
		165,
		-1,
		193,
		183,
		214,
		199,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		222,
		221,
		213,
		207,
		207,
		192,
		183,
		-1,
		195,
		177,
		156,
		173,
		173,
		164,
		172,
		204,
		200,
		187,
		187,
		179,
		-1,
		323,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		216,
		211,
		184,
		172,
		178,
		174,
		160,
		166,
		168,
		176,
		174,
		171,
		183,
		179,
		199,
		180,
		215,
		-1,
		318,
		-1,
		252,
		-1,
		-1,
		234,
		214,
		206,
		195,
		184,
		182,
		173,
		164,
		186,
		202,
		186,
		184,
		187,
		188,
		-1,
		307,
		306,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		230,
		191,
		-1,
		193,
		173,
		-1,
		195,
		191,
		-1,
		-1,
		294,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		225,
		209,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		279,
		278,
		-1,
		247,
		250,
		-1,
		240,
		231,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		288,
		269,
		263,
		262,
		260,
		255,
		252,
		238,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		260,
		252,
		245,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		282,
		263,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		271,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		317,
		281,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		182,
		184,
		150,
		144,
		183,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		173,
		172,
		142,
		140,
		149,
		154,
		161,
		-1,
		174,
		-1,
		194,
		173,
		184,
		189,
		135,
		132,
		152,
		171,
		167,
		159,
		209,
		165,
		136,
		130,
		148,
		152,
		161,
		153,
		-1,
		136,
		126,
		148,
		141,
		152,
		144,
		-1,
		-1,
		130,
		131,
		137,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		120,
		133,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		121,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		109,
		127,
		136,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		131,
		-1,
		101,
		103,
		123,
		131,
		136,
		120,
		107,
		107,
		117,
		110,
		129,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		98,
		106,
		127,
		119,
		109,
		124,
		117,
		110,
		107,
		105,
		102,
		118,
		119,
		129,
		-1,
		-1,
		154,
		123,
		158,
		115,
		100,
		-1,
		94,
		103,
		109,
		113,
		107,
		100,
		114,
		110,
		-1,
		96,
		95,
		126,
		112,
		123,
		114,
		-1,
		-1,
		112,
		104,
		89,
		92,
		89,
		89,
		118,
		117,
		109,
		95,
		91,
		97,
		100,
		100,
		106,
		90,
		100,
		104,
		115,
		130,
		-1,
		-1,
		185,
		-1,
		-1,
		111,
		94,
		-1,
		77,
		84,
		84,
		101,
		91,
		112,
		127,
		119,
		111,
		105,
		93,
		95,
		92,
		105,
		93,
		87,
		112,
		116,
		110,
		131,
		126,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		70,
		73,
		79,
		103,
		113,
		-1,
		113,
		119,
		129,
		114,
		111,
		98,
		86,
		99,
		84,
		91,
		90,
		94,
		96,
		129,
		107,
		129,
		126,
		155,
		160,
		154,
		163,
		-1,
		119,
		115,
		111,
		118,
		67,
		-1,
		-1,
		107,
		-1,
		121,
		130,
		105,
		123,
		126,
		115,
		106,
		93,
		82,
		93,
		82,
		79,
		87,
		96,
		107,
		102,
		101,
		119,
		134,
		147,
		151,
		157,
		-1,
		169,
		-1,
		111,
		95,
		97,
		69,
		90,
		-1,
		127,
		122,
		122,
		107,
		98,
		-1,
		101,
		104,
		111,
		89,
		74,
		91,
		83,
		81,
		86,
		91,
		105,
		96,
		114,
		121,
		129,
		133,
		153,
		165,
		129,
		119,
		-1,
		101,
		106,
		65,
		73,
		92,
		140,
		104,
		-1,
		99,
		-1,
		91,
		116,
		-1,
		95,
		91,
		73,
		74,
		69,
		84,
		90,
		87,
		84,
		102,
		105,
		122,
		126,
		142,
		-1,
		-1,
		114,
		118,
		107,
		58,
		77,
		101,
		138,
		97,
		86,
		85,
		-1,
		76,
		106,
		103,
		89,
		76,
		66,
		67,
		75,
		88,
		67,
		86,
		89,
		111,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		84,
		55,
		79,
		121,
		115,
		108,
		96,
		61,
		61,
		55,
		-1,
		96,
		79,
		75,
		64,
		62,
		75,
		70,
		86,
		90,
		89,
		108,
		120,
		111,
		131,
		-1,
		-1,
		-1,
		114,
		103,
		104,
		50,
		73,
		110,
		94,
		80,
		85,
		60,
		53,
		47,
		99,
		96,
		63,
		71,
		63,
		52,
		66,
		74,
		78,
		87,
		96,
		102,
		126,
		126,
		132,
		-1,
		-1,
		121,
		111,
		95,
		97,
		94,
		64,
		71,
		103,
		85,
		73,
		-1,
		52,
		-1,
		41,
		49,
		48,
		54,
		66,
		52,
		57,
		68,
		80,
		93,
		89,
		96,
		131,
		131,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		114,
		109,
		84,
		61,
		45,
		81,
		-1,
		43,
		44,
		-1,
		46,
		40,
		46,
		45,
		52,
		49,
		49,
		63,
		71,
		67,
		83,
		89,
		81,
		117,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		107,
		86,
		79,
		99,
		40,
		92,
		-1,
		-1,
		28,
		21,
		-1,
		33,
		33,
		40,
		49,
		54,
		59,
		67,
		62,
		75,
		80,
		86,
		91,
		109,
		113,
		117,
		106,
		102,
		99,
		113,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		40,
		60,
		-1,
		27,
		15,
		0,
		4,
		19,
		46,
		44,
		64,
		56,
		70,
		70,
		76,
		84,
		69,
		72,
		88,
		86,
		104,
		112,
		104,
		98,
		97,
		109,
		-1,
		127,
		113,
		84,
		-1,
		-1,
		73,
		-1,
		37,
		40,
		56,
		-1,
		53,
		32,
		56,
		38,
		56,
		52,
		90,
		91,
		69,
		74,
		82,
		92,
		94,
		83,
		94,
		86,
		108,
		108,
		92,
		93,
		102,
		-1,
		133,
		120,
		78,
		74,
		63,
		83,
		34,
		22,
		43,
		-1,
		-1,
		106,
		-1,
		40,
		57,
		66,
		64,
		80,
		71,
		77,
		93,
		96,
		98,
		88,
		77,
		83,
		80,
		102,
		88,
		86,
		105,
		121,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		49,
		36,
		30,
		-1,
		60,
		-1,
		84,
		74,
		58,
		43,
		76,
		-1,
		88,
		72,
		77,
		-1,
		123,
		-1,
		96,
		98,
		92,
		77,
		74,
		85,
		83,
		94,
		111,
		-1,
		83,
		68,
		61,
		51,
		65,
		36,
		-1,
		91,
		-1,
		-1,
		71,
		65,
		65,
		49,
		52,
		104,
		84,
		78,
		77,
		118,
		118,
		104,
		90,
		83,
		80,
		77,
		90,
		110,
		101,
		113,
		-1,
		-1,
		-1,
		88,
		74,
		78,
		38,
		57,
		-1,
		-1,
		133,
		88,
		74,
		-1,
		58,
		121,
		109,
		99,
		89,
		123,
		124,
		109,
		102,
		88,
		90,
		88,
		86,
		91,
		112,
		113,
		126,
		-1,
		-1,
		71,
		76,
		64,
		50,
		69,
		-1,
		-1,
		-1,
		80,
		96,
		88,
		59,
		110,
		-1,
		-1,
		101,
		99,
		109,
		105,
		92,
		112,
		115,
		101,
		85,
		100,
		112,
		120,
		125,
		-1,
		74,
		61,
		-1,
		-1,
		72,
		66,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		91,
		112,
		137,
		104,
		-1,
		109,
		110,
		96,
		110,
		117,
		103,
		98,
		92,
		95,
		113,
		130,
		-1,
		-1,
		86,
		-1,
		81,
		-1,
		-1,
		-1,
		-1,
		70,
		84,
		105,
		111,
		123,
		-1,
		118,
		112,
		98,
		115,
		116,
		113,
		104,
		96,
		101,
		98,
		111,
		125,
		129,
		109,
		-1,
		92,
		-1,
		-1,
		-1,
		88,
		103,
		165,
		142,
		115,
		119,
		112,
		106,
		106,
		122,
		124,
		135,
		103,
		99,
		100,
		104,
		103,
		120,
		130,
		-1,
		-1,
		92,
		109,
		114,
		96,
		100,
		192,
		-1,
		-1,
		128,
		119,
		110,
		113,
		116,
		119,
		109,
		106,
		111,
		116,
		104,
		113,
		131,
		135,
		-1,
		-1,
		-1,
		112,
		-1,
		127,
		-1,
		-1,
		115,
		199,
		146,
		128,
		124,
		122,
		115,
		124,
		119,
		114,
		124,
		133,
		125,
		106,
		117,
		140,
		129,
		167,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		141,
		116,
		131,
		177,
		135,
		142,
		161,
		158,
		-1,
		128,
		153,
		125,
		132,
		124,
		132,
		132,
		129,
		107,
		114,
		130,
		129,
		124,
		159,
		151,
		157,
		-1,
		-1,
		224,
		213,
		202,
		208,
		-1,
		147,
		133,
		163,
		153,
		152,
		-1,
		-1,
		177,
		174,
		150,
		134,
		138,
		131,
		126,
		136,
		116,
		103,
		107,
		111,
		117,
		122,
		127,
		133,
		148,
		163,
		-1,
		119,
		200,
		193,
		176,
		184,
		215,
		-1,
		150,
		159,
		140,
		145,
		153,
		-1,
		-1,
		150,
		147,
		152,
		141,
		138,
		146,
		141,
		132,
		117,
		123,
		110,
		109,
		127,
		131,
		140,
		147,
		137,
		150,
		154,
		-1,
		133,
		176,
		170,
		173,
		197,
		211,
		-1,
		163,
		-1,
		-1,
		148,
		166,
		165,
		155,
		149,
		199,
		155,
		150,
		140,
		138,
		129,
		120,
		127,
		118,
		118,
		121,
		136,
		141,
		133,
		147,
		147,
		148,
		-1,
		168,
		156,
		164,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		164,
		-1,
		192,
		-1,
		167,
		171,
		163,
		166,
		154,
		141,
		133,
		125,
		141,
		116,
		126,
		122,
		123,
		132,
		143,
		155,
		154,
		155,
		242,
		197,
		164,
		155,
		202,
		217,
		221,
		-1,
		176,
		215,
		202,
		-1,
		173,
		-1,
		-1,
		-1,
		181,
		176,
		168,
		174,
		153,
		153,
		127,
		131,
		121,
		128,
		138,
		140,
		132,
		136,
		149,
		160,
		163,
		238,
		236,
		241,
		186,
		169,
		187,
		196,
		217,
		191,
		182,
		209,
		209,
		198,
		193,
		180,
		-1,
		-1,
		204,
		186,
		-1,
		-1,
		160,
		148,
		131,
		132,
		128,
		131,
		146,
		149,
		139,
		137,
		131,
		163,
		-1,
		238,
		237,
		226,
		223,
		199,
		190,
		177,
		188,
		-1,
		-1,
		194,
		210,
		223,
		227,
		240,
		265,
		-1,
		183,
		-1,
		-1,
		205,
		-1,
		-1,
		190,
		153,
		142,
		133,
		139,
		136,
		147,
		157,
		145,
		146,
		136,
		146,
		159,
		222,
		219,
		207,
		205,
		228,
		185,
		181,
		-1,
		209,
		197,
		203,
		210,
		227,
		254,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		188,
		186,
		175,
		-1,
		165,
		138,
		143,
		163,
		165,
		154,
		148,
		142,
		149,
		148,
		156,
		164,
		231,
		245,
		234,
		230,
		229,
		237,
		186,
		199,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		226,
		209,
		-1,
		-1,
		183,
		176,
		164,
		152,
		142,
		152,
		156,
		160,
		152,
		145,
		140,
		151,
		143,
		147,
		164,
		-1,
		265,
		-1,
		217,
		210,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		243,
		229,
		222,
		210,
		208,
		-1,
		217,
		201,
		182,
		-1,
		152,
		165,
		196,
		164,
		169,
		164,
		146,
		157,
		146,
		149,
		163,
		158,
		-1,
		-1,
		223,
		226,
		-1,
		-1,
		233,
		235,
		-1,
		234,
		223,
		208,
		200,
		-1,
		-1,
		189,
		185,
		-1,
		-1,
		153,
		178,
		167,
		175,
		170,
		150,
		156,
		159,
		148,
		152,
		164,
		-1,
		-1,
		230,
		231,
		236,
		-1,
		218,
		-1,
		236,
		-1,
		203,
		209,
		197,
		-1,
		-1,
		-1,
		191,
		154,
		175,
		185,
		179,
		177,
		168,
		154,
		161,
		159,
		155,
		166,
		-1,
		-1,
		-1,
		236,
		210,
		243,
		234,
		217,
		197,
		189,
		208,
		-1,
		178,
		-1,
		153,
		155,
		181,
		184,
		190,
		184,
		157,
		172,
		162,
		153,
		162,
		242,
		-1,
		212,
		245,
		209,
		203,
		179,
		183,
		199,
		-1,
		175,
		157,
		-1,
		185,
		175,
		206,
		191,
		172,
		159,
		166,
		166,
		159,
		-1,
		-1,
		-1,
		214,
		213,
		205,
		199,
		199,
		184,
		175,
		-1,
		187,
		169,
		148,
		165,
		165,
		156,
		164,
		196,
		192,
		179,
		179,
		171,
		-1,
		315,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		208,
		203,
		176,
		164,
		170,
		166,
		152,
		158,
		160,
		168,
		166,
		163,
		175,
		171,
		191,
		172,
		207,
		-1,
		310,
		-1,
		244,
		-1,
		-1,
		226,
		206,
		198,
		187,
		176,
		174,
		165,
		156,
		178,
		194,
		178,
		176,
		179,
		180,
		-1,
		299,
		298,
		-1,
		245,
		237,
		223,
		-1,
		216,
		-1,
		222,
		183,
		-1,
		185,
		165,
		-1,
		187,
		183,
		-1,
		-1,
		286,
		261,
		-1,
		-1,
		-1,
		246,
		226,
		217,
		201,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		271,
		270,
		-1,
		239,
		242,
		-1,
		232,
		223,
		231,
		178,
		182,
		-1,
		-1,
		-1,
		280,
		261,
		255,
		254,
		252,
		247,
		244,
		230,
		214,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		252,
		244,
		237,
		-1,
		-1,
		239,
		222,
		203,
		201,
		-1,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		229,
		-1,
		-1,
		235,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		263,
		-1,
		-1,
		-1,
		225,
		221,
		222,
		-1,
		-1,
		-1,
		-1,
		285,
		286,
		309,
		273,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		288,
		286,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		169,
		158,
		169,
		177,
		150,
		157,
		-1,
		178,
		180,
		146,
		140,
		179,
		150,
		156,
		167,
		-1,
		-1,
		-1,
		169,
		168,
		138,
		136,
		145,
		150,
		157,
		-1,
		170,
		-1,
		190,
		169,
		180,
		185,
		131,
		128,
		148,
		167,
		163,
		155,
		205,
		161,
		132,
		126,
		144,
		148,
		157,
		149,
		-1,
		132,
		122,
		144,
		137,
		148,
		140,
		-1,
		-1,
		126,
		127,
		133,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		116,
		129,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		117,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		105,
		123,
		132,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		127,
		-1,
		97,
		99,
		119,
		127,
		132,
		116,
		103,
		103,
		113,
		106,
		125,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		102,
		123,
		115,
		105,
		120,
		113,
		106,
		103,
		101,
		98,
		114,
		115,
		125,
		-1,
		-1,
		150,
		119,
		154,
		111,
		96,
		-1,
		90,
		99,
		105,
		109,
		103,
		96,
		110,
		106,
		-1,
		92,
		91,
		122,
		108,
		119,
		110,
		-1,
		-1,
		108,
		100,
		85,
		88,
		85,
		85,
		114,
		113,
		105,
		91,
		87,
		93,
		96,
		96,
		102,
		86,
		96,
		100,
		111,
		126,
		-1,
		-1,
		181,
		-1,
		-1,
		107,
		90,
		-1,
		73,
		80,
		80,
		97,
		87,
		108,
		123,
		115,
		107,
		101,
		89,
		91,
		88,
		101,
		89,
		83,
		108,
		112,
		106,
		127,
		122,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		66,
		69,
		75,
		99,
		109,
		-1,
		109,
		115,
		125,
		110,
		107,
		94,
		82,
		95,
		80,
		87,
		86,
		90,
		92,
		125,
		103,
		125,
		122,
		151,
		156,
		150,
		159,
		-1,
		115,
		111,
		107,
		114,
		63,
		-1,
		-1,
		103,
		-1,
		117,
		126,
		101,
		119,
		122,
		111,
		102,
		89,
		78,
		89,
		78,
		75,
		83,
		92,
		103,
		98,
		97,
		115,
		130,
		143,
		147,
		153,
		-1,
		165,
		-1,
		107,
		91,
		93,
		65,
		86,
		-1,
		123,
		118,
		118,
		103,
		94,
		-1,
		97,
		100,
		107,
		85,
		70,
		87,
		79,
		77,
		82,
		87,
		101,
		92,
		110,
		117,
		125,
		129,
		149,
		161,
		125,
		115,
		-1,
		97,
		102,
		61,
		69,
		88,
		136,
		100,
		-1,
		95,
		-1,
		87,
		112,
		-1,
		91,
		87,
		69,
		70,
		65,
		80,
		86,
		83,
		80,
		98,
		101,
		118,
		122,
		138,
		-1,
		-1,
		110,
		114,
		103,
		54,
		73,
		97,
		134,
		93,
		82,
		81,
		-1,
		72,
		102,
		99,
		85,
		72,
		62,
		63,
		71,
		84,
		63,
		82,
		85,
		107,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		80,
		51,
		75,
		117,
		111,
		104,
		92,
		57,
		57,
		51,
		-1,
		92,
		75,
		71,
		60,
		58,
		71,
		66,
		82,
		86,
		85,
		104,
		116,
		107,
		127,
		-1,
		-1,
		-1,
		110,
		99,
		100,
		46,
		69,
		106,
		90,
		76,
		81,
		56,
		49,
		43,
		95,
		92,
		59,
		67,
		59,
		48,
		62,
		70,
		74,
		83,
		92,
		98,
		122,
		122,
		128,
		-1,
		-1,
		117,
		107,
		91,
		93,
		90,
		60,
		67,
		99,
		81,
		69,
		-1,
		48,
		-1,
		37,
		45,
		44,
		50,
		62,
		48,
		53,
		64,
		76,
		89,
		85,
		92,
		127,
		127,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		110,
		105,
		80,
		57,
		41,
		77,
		-1,
		39,
		40,
		-1,
		42,
		36,
		42,
		41,
		48,
		45,
		45,
		59,
		67,
		63,
		79,
		85,
		77,
		113,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		103,
		82,
		75,
		95,
		36,
		88,
		-1,
		-1,
		24,
		17,
		-1,
		29,
		29,
		36,
		45,
		50,
		55,
		63,
		58,
		71,
		76,
		82,
		87,
		105,
		109,
		113,
		102,
		98,
		95,
		109,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		36,
		56,
		-1,
		33,
		21,
		6,
		0,
		15,
		42,
		40,
		60,
		52,
		66,
		66,
		72,
		80,
		65,
		68,
		84,
		82,
		100,
		108,
		100,
		94,
		93,
		105,
		-1,
		123,
		109,
		80,
		-1,
		-1,
		69,
		-1,
		33,
		46,
		62,
		-1,
		49,
		28,
		52,
		34,
		52,
		48,
		86,
		87,
		65,
		70,
		78,
		88,
		90,
		79,
		90,
		82,
		104,
		104,
		88,
		89,
		98,
		-1,
		129,
		116,
		74,
		70,
		59,
		79,
		30,
		18,
		49,
		-1,
		-1,
		102,
		-1,
		36,
		53,
		62,
		60,
		76,
		67,
		73,
		89,
		92,
		94,
		84,
		73,
		79,
		76,
		98,
		84,
		82,
		101,
		117,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		45,
		32,
		26,
		-1,
		66,
		-1,
		80,
		70,
		54,
		39,
		72,
		-1,
		84,
		68,
		73,
		-1,
		119,
		-1,
		92,
		94,
		88,
		73,
		70,
		81,
		79,
		90,
		107,
		-1,
		79,
		64,
		57,
		47,
		61,
		32,
		-1,
		87,
		-1,
		-1,
		67,
		61,
		61,
		45,
		48,
		100,
		80,
		74,
		73,
		114,
		114,
		100,
		86,
		79,
		76,
		73,
		86,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		84,
		70,
		74,
		34,
		53,
		-1,
		-1,
		129,
		84,
		70,
		-1,
		54,
		117,
		105,
		95,
		85,
		119,
		120,
		105,
		98,
		84,
		86,
		84,
		82,
		87,
		108,
		109,
		122,
		-1,
		-1,
		67,
		72,
		60,
		46,
		65,
		-1,
		-1,
		-1,
		76,
		92,
		84,
		55,
		106,
		-1,
		-1,
		97,
		95,
		105,
		101,
		88,
		108,
		111,
		97,
		81,
		96,
		108,
		116,
		121,
		-1,
		70,
		57,
		-1,
		-1,
		68,
		62,
		-1,
		-1,
		-1,
		-1,
		109,
		75,
		87,
		108,
		133,
		100,
		-1,
		105,
		106,
		92,
		106,
		113,
		99,
		94,
		88,
		91,
		109,
		126,
		-1,
		-1,
		82,
		-1,
		77,
		-1,
		-1,
		-1,
		-1,
		66,
		80,
		101,
		107,
		119,
		-1,
		114,
		108,
		94,
		111,
		112,
		109,
		100,
		92,
		97,
		94,
		107,
		121,
		125,
		105,
		-1,
		88,
		-1,
		-1,
		-1,
		84,
		99,
		161,
		138,
		111,
		115,
		108,
		102,
		102,
		118,
		120,
		131,
		99,
		95,
		96,
		100,
		99,
		116,
		126,
		-1,
		-1,
		88,
		105,
		110,
		92,
		96,
		188,
		-1,
		-1,
		124,
		115,
		106,
		109,
		112,
		115,
		105,
		102,
		107,
		112,
		100,
		109,
		127,
		131,
		-1,
		-1,
		-1,
		108,
		-1,
		123,
		-1,
		-1,
		111,
		195,
		142,
		124,
		120,
		118,
		111,
		120,
		115,
		110,
		120,
		129,
		121,
		102,
		113,
		136,
		125,
		163,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		137,
		112,
		127,
		173,
		131,
		138,
		157,
		154,
		-1,
		124,
		149,
		121,
		128,
		120,
		128,
		128,
		125,
		103,
		110,
		126,
		125,
		120,
		155,
		147,
		153,
		-1,
		-1,
		220,
		209,
		198,
		204,
		-1,
		143,
		129,
		159,
		149,
		148,
		-1,
		-1,
		173,
		170,
		146,
		130,
		134,
		127,
		122,
		132,
		112,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		115,
		196,
		189,
		172,
		180,
		211,
		-1,
		146,
		155,
		136,
		141,
		149,
		-1,
		-1,
		146,
		143,
		148,
		137,
		134,
		142,
		137,
		128,
		113,
		119,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		129,
		172,
		166,
		169,
		193,
		207,
		-1,
		159,
		-1,
		-1,
		144,
		162,
		161,
		151,
		145,
		195,
		151,
		146,
		136,
		134,
		125,
		116,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		164,
		152,
		160,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		160,
		-1,
		188,
		-1,
		163,
		167,
		159,
		162,
		150,
		137,
		129,
		121,
		137,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		238,
		193,
		160,
		151,
		198,
		213,
		217,
		-1,
		172,
		211,
		198,
		-1,
		169,
		-1,
		-1,
		-1,
		177,
		172,
		164,
		170,
		149,
		149,
		123,
		127,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		234,
		232,
		237,
		182,
		165,
		183,
		192,
		213,
		187,
		178,
		205,
		205,
		194,
		189,
		176,
		-1,
		-1,
		200,
		182,
		-1,
		-1,
		156,
		144,
		127,
		128,
		124,
		127,
		142,
		145,
		135,
		133,
		127,
		159,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		173,
		184,
		-1,
		-1,
		190,
		206,
		219,
		223,
		236,
		261,
		-1,
		179,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		132,
		143,
		153,
		141,
		142,
		132,
		142,
		155,
		218,
		215,
		203,
		201,
		224,
		181,
		177,
		-1,
		205,
		193,
		199,
		206,
		223,
		250,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		134,
		139,
		159,
		161,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		195,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		222,
		205,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		152,
		156,
		148,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		261,
		-1,
		213,
		206,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		239,
		225,
		218,
		206,
		204,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		229,
		231,
		-1,
		230,
		219,
		204,
		196,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		226,
		227,
		232,
		-1,
		214,
		-1,
		232,
		-1,
		199,
		205,
		193,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		175,
		173,
		164,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		232,
		206,
		239,
		230,
		213,
		193,
		185,
		204,
		-1,
		174,
		-1,
		149,
		151,
		177,
		180,
		186,
		180,
		153,
		168,
		158,
		149,
		158,
		238,
		-1,
		208,
		241,
		205,
		199,
		175,
		179,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		202,
		187,
		168,
		155,
		162,
		162,
		155,
		-1,
		-1,
		-1,
		210,
		209,
		201,
		195,
		195,
		180,
		171,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		192,
		188,
		175,
		175,
		167,
		-1,
		311,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		204,
		199,
		172,
		160,
		166,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		168,
		203,
		-1,
		306,
		-1,
		240,
		-1,
		-1,
		222,
		202,
		194,
		183,
		172,
		170,
		161,
		152,
		174,
		190,
		174,
		172,
		175,
		176,
		-1,
		295,
		294,
		-1,
		241,
		233,
		219,
		-1,
		212,
		-1,
		218,
		179,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		282,
		257,
		-1,
		-1,
		-1,
		242,
		222,
		213,
		197,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		267,
		266,
		-1,
		235,
		238,
		-1,
		228,
		219,
		227,
		174,
		178,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		250,
		248,
		243,
		240,
		226,
		210,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		248,
		240,
		233,
		-1,
		-1,
		235,
		218,
		199,
		197,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		225,
		-1,
		-1,
		231,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		259,
		-1,
		-1,
		-1,
		221,
		217,
		218,
		-1,
		-1,
		-1,
		-1,
		281,
		282,
		305,
		269,
		-1,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		284,
		282,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		211,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		246,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		236,
		243,
		265,
		268,
		304,
		-1,
		255
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		175,
		177,
		143,
		137,
		176,
		147,
		153,
		164,
		-1,
		-1,
		-1,
		166,
		165,
		135,
		133,
		142,
		147,
		154,
		-1,
		158,
		-1,
		187,
		166,
		177,
		182,
		128,
		125,
		145,
		164,
		151,
		143,
		202,
		158,
		129,
		123,
		141,
		136,
		145,
		137,
		-1,
		129,
		119,
		141,
		125,
		136,
		128,
		-1,
		-1,
		123,
		124,
		130,
		121,
		127,
		123,
		-1,
		133,
		117,
		-1,
		-1,
		113,
		119,
		103,
		106,
		114,
		112,
		125,
		117,
		112,
		-1,
		-1,
		109,
		105,
		112,
		99,
		95,
		112,
		125,
		107,
		121,
		120,
		-1,
		102,
		120,
		129,
		106,
		104,
		88,
		86,
		104,
		106,
		112,
		115,
		-1,
		95,
		97,
		107,
		115,
		120,
		104,
		91,
		91,
		101,
		94,
		113,
		104,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		94,
		111,
		103,
		93,
		108,
		101,
		94,
		91,
		89,
		86,
		102,
		103,
		113,
		-1,
		-1,
		148,
		117,
		152,
		109,
		94,
		-1,
		88,
		87,
		93,
		97,
		91,
		84,
		98,
		94,
		-1,
		80,
		79,
		110,
		96,
		107,
		108,
		-1,
		-1,
		106,
		98,
		83,
		86,
		83,
		83,
		102,
		101,
		93,
		79,
		75,
		81,
		84,
		84,
		90,
		74,
		84,
		88,
		99,
		114,
		-1,
		-1,
		169,
		-1,
		-1,
		105,
		88,
		-1,
		71,
		78,
		78,
		95,
		85,
		106,
		112,
		103,
		95,
		89,
		77,
		79,
		76,
		89,
		77,
		71,
		96,
		100,
		94,
		115,
		110,
		-1,
		168,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		64,
		67,
		73,
		97,
		107,
		-1,
		97,
		103,
		113,
		98,
		95,
		82,
		70,
		83,
		68,
		75,
		74,
		78,
		80,
		113,
		91,
		113,
		110,
		139,
		144,
		138,
		147,
		-1,
		113,
		109,
		105,
		112,
		61,
		-1,
		-1,
		101,
		-1,
		115,
		114,
		89,
		107,
		110,
		99,
		90,
		77,
		66,
		77,
		66,
		63,
		71,
		80,
		91,
		86,
		85,
		103,
		118,
		131,
		135,
		141,
		-1,
		163,
		-1,
		105,
		89,
		91,
		63,
		84,
		-1,
		121,
		116,
		106,
		91,
		82,
		-1,
		85,
		88,
		95,
		73,
		58,
		75,
		67,
		65,
		70,
		75,
		89,
		80,
		98,
		105,
		113,
		117,
		137,
		149,
		123,
		113,
		-1,
		95,
		100,
		59,
		67,
		86,
		124,
		88,
		-1,
		83,
		-1,
		75,
		100,
		-1,
		79,
		75,
		57,
		58,
		53,
		68,
		74,
		71,
		68,
		86,
		89,
		106,
		110,
		126,
		-1,
		-1,
		108,
		112,
		101,
		52,
		71,
		95,
		132,
		81,
		70,
		69,
		-1,
		60,
		90,
		87,
		73,
		60,
		50,
		51,
		59,
		72,
		51,
		70,
		73,
		95,
		123,
		101,
		113,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		78,
		49,
		73,
		115,
		99,
		92,
		80,
		45,
		45,
		39,
		-1,
		80,
		63,
		59,
		48,
		46,
		59,
		54,
		70,
		74,
		73,
		92,
		104,
		95,
		115,
		-1,
		-1,
		-1,
		108,
		97,
		98,
		44,
		67,
		104,
		78,
		64,
		69,
		44,
		37,
		31,
		83,
		80,
		47,
		55,
		47,
		36,
		50,
		58,
		62,
		71,
		80,
		86,
		110,
		110,
		116,
		-1,
		-1,
		115,
		105,
		89,
		91,
		88,
		58,
		65,
		97,
		69,
		69,
		-1,
		36,
		-1,
		25,
		33,
		32,
		38,
		50,
		36,
		41,
		52,
		64,
		77,
		73,
		80,
		115,
		115,
		100,
		120,
		123,
		-1,
		-1,
		-1,
		108,
		103,
		78,
		55,
		39,
		75,
		-1,
		39,
		40,
		-1,
		30,
		24,
		30,
		29,
		36,
		33,
		33,
		47,
		55,
		51,
		67,
		73,
		65,
		101,
		-1,
		108,
		102,
		110,
		100,
		88,
		-1,
		-1,
		-1,
		101,
		80,
		73,
		93,
		34,
		86,
		-1,
		-1,
		24,
		17,
		-1,
		17,
		17,
		24,
		33,
		38,
		43,
		51,
		46,
		59,
		64,
		70,
		75,
		93,
		97,
		101,
		90,
		86,
		83,
		97,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		34,
		54,
		-1,
		36,
		28,
		17,
		11,
		0,
		30,
		28,
		48,
		40,
		54,
		54,
		60,
		68,
		53,
		56,
		72,
		70,
		88,
		96,
		88,
		82,
		81,
		93,
		-1,
		121,
		107,
		78,
		-1,
		-1,
		67,
		-1,
		31,
		45,
		61,
		-1,
		38,
		17,
		37,
		19,
		40,
		36,
		74,
		75,
		53,
		58,
		66,
		76,
		78,
		67,
		78,
		70,
		92,
		92,
		76,
		77,
		86,
		-1,
		127,
		114,
		72,
		68,
		57,
		77,
		28,
		16,
		48,
		-1,
		-1,
		90,
		-1,
		24,
		41,
		50,
		48,
		64,
		55,
		61,
		77,
		80,
		82,
		72,
		61,
		67,
		64,
		86,
		72,
		70,
		89,
		105,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		43,
		30,
		24,
		-1,
		65,
		-1,
		68,
		58,
		42,
		27,
		60,
		-1,
		72,
		56,
		61,
		-1,
		107,
		-1,
		80,
		82,
		76,
		61,
		58,
		69,
		67,
		78,
		95,
		-1,
		77,
		62,
		55,
		45,
		59,
		30,
		-1,
		85,
		-1,
		-1,
		55,
		49,
		49,
		33,
		36,
		88,
		68,
		62,
		61,
		102,
		102,
		88,
		74,
		67,
		64,
		61,
		74,
		94,
		85,
		97,
		-1,
		-1,
		-1,
		82,
		68,
		72,
		32,
		51,
		-1,
		-1,
		117,
		72,
		58,
		-1,
		42,
		105,
		93,
		83,
		73,
		107,
		108,
		93,
		86,
		72,
		74,
		72,
		70,
		75,
		96,
		97,
		110,
		-1,
		-1,
		65,
		70,
		58,
		44,
		63,
		-1,
		-1,
		-1,
		64,
		80,
		72,
		43,
		94,
		-1,
		-1,
		85,
		83,
		93,
		89,
		76,
		96,
		99,
		85,
		69,
		84,
		96,
		104,
		109,
		-1,
		68,
		55,
		-1,
		-1,
		66,
		60,
		-1,
		-1,
		-1,
		-1,
		97,
		63,
		75,
		96,
		121,
		88,
		-1,
		93,
		94,
		80,
		94,
		101,
		87,
		82,
		76,
		79,
		97,
		114,
		-1,
		-1,
		80,
		-1,
		75,
		-1,
		-1,
		-1,
		-1,
		54,
		68,
		89,
		95,
		107,
		-1,
		102,
		96,
		82,
		99,
		100,
		97,
		88,
		80,
		85,
		82,
		95,
		109,
		113,
		103,
		-1,
		86,
		-1,
		-1,
		-1,
		72,
		87,
		149,
		126,
		99,
		103,
		96,
		90,
		90,
		106,
		108,
		119,
		87,
		83,
		84,
		88,
		87,
		104,
		114,
		-1,
		-1,
		86,
		103,
		98,
		80,
		84,
		176,
		-1,
		-1,
		112,
		103,
		94,
		97,
		100,
		103,
		93,
		90,
		95,
		100,
		88,
		97,
		115,
		119,
		-1,
		-1,
		-1,
		106,
		-1,
		121,
		-1,
		-1,
		99,
		183,
		130,
		112,
		108,
		106,
		99,
		108,
		103,
		98,
		108,
		117,
		109,
		90,
		101,
		124,
		113,
		151,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		135,
		110,
		125,
		171,
		119,
		126,
		145,
		142,
		-1,
		112,
		137,
		109,
		116,
		108,
		116,
		116,
		113,
		91,
		98,
		114,
		113,
		108,
		143,
		135,
		141,
		-1,
		-1,
		218,
		207,
		196,
		202,
		-1,
		141,
		127,
		157,
		147,
		136,
		-1,
		-1,
		161,
		158,
		134,
		118,
		122,
		115,
		110,
		120,
		100,
		87,
		91,
		95,
		101,
		106,
		111,
		117,
		132,
		147,
		-1,
		113,
		194,
		187,
		170,
		178,
		209,
		-1,
		144,
		153,
		134,
		139,
		147,
		-1,
		-1,
		134,
		131,
		136,
		125,
		122,
		130,
		125,
		116,
		101,
		107,
		94,
		93,
		111,
		115,
		124,
		131,
		121,
		134,
		138,
		-1,
		127,
		170,
		164,
		167,
		191,
		205,
		-1,
		157,
		-1,
		-1,
		142,
		160,
		149,
		139,
		133,
		183,
		139,
		134,
		124,
		122,
		113,
		104,
		111,
		102,
		102,
		105,
		120,
		125,
		117,
		131,
		131,
		132,
		-1,
		162,
		150,
		158,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		158,
		-1,
		176,
		-1,
		151,
		155,
		147,
		150,
		138,
		125,
		117,
		109,
		125,
		100,
		110,
		106,
		107,
		116,
		127,
		139,
		138,
		139,
		236,
		191,
		158,
		149,
		196,
		211,
		215,
		-1,
		170,
		209,
		196,
		-1,
		167,
		-1,
		-1,
		-1,
		165,
		160,
		152,
		158,
		137,
		137,
		111,
		115,
		105,
		112,
		122,
		124,
		116,
		120,
		133,
		144,
		147,
		232,
		230,
		235,
		180,
		163,
		181,
		190,
		211,
		185,
		176,
		203,
		203,
		192,
		187,
		174,
		-1,
		-1,
		188,
		170,
		-1,
		-1,
		144,
		132,
		115,
		116,
		112,
		115,
		130,
		133,
		123,
		121,
		115,
		147,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		171,
		182,
		-1,
		-1,
		188,
		204,
		217,
		221,
		234,
		259,
		-1,
		177,
		-1,
		-1,
		189,
		-1,
		-1,
		174,
		137,
		126,
		117,
		123,
		120,
		131,
		141,
		129,
		130,
		120,
		130,
		143,
		216,
		213,
		201,
		199,
		222,
		179,
		175,
		-1,
		198,
		191,
		197,
		204,
		221,
		248,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		172,
		170,
		159,
		-1,
		149,
		122,
		127,
		147,
		149,
		138,
		132,
		126,
		133,
		132,
		140,
		148,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		183,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		210,
		203,
		-1,
		-1,
		167,
		160,
		148,
		136,
		126,
		136,
		140,
		144,
		136,
		129,
		124,
		135,
		127,
		131,
		148,
		-1,
		259,
		-1,
		211,
		197,
		211,
		226,
		234,
		-1,
		-1,
		-1,
		227,
		213,
		206,
		194,
		192,
		-1,
		201,
		185,
		166,
		-1,
		136,
		149,
		180,
		148,
		153,
		148,
		130,
		141,
		130,
		133,
		147,
		142,
		-1,
		-1,
		209,
		212,
		-1,
		-1,
		217,
		219,
		-1,
		218,
		207,
		192,
		184,
		-1,
		-1,
		173,
		169,
		-1,
		-1,
		137,
		162,
		151,
		159,
		154,
		134,
		140,
		143,
		132,
		136,
		148,
		-1,
		-1,
		216,
		217,
		222,
		-1,
		202,
		-1,
		220,
		-1,
		187,
		193,
		181,
		-1,
		-1,
		-1,
		175,
		138,
		159,
		169,
		163,
		161,
		152,
		138,
		145,
		143,
		139,
		150,
		-1,
		-1,
		-1,
		220,
		194,
		227,
		218,
		201,
		181,
		173,
		192,
		-1,
		162,
		-1,
		137,
		139,
		165,
		168,
		174,
		168,
		141,
		156,
		146,
		137,
		146,
		226,
		-1,
		196,
		229,
		193,
		187,
		163,
		167,
		183,
		-1,
		159,
		141,
		-1,
		169,
		159,
		190,
		175,
		156,
		143,
		150,
		150,
		143,
		-1,
		-1,
		-1,
		198,
		197,
		189,
		183,
		183,
		168,
		159,
		-1,
		171,
		153,
		132,
		149,
		149,
		140,
		148,
		180,
		176,
		163,
		163,
		155,
		-1,
		299,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		192,
		187,
		160,
		148,
		154,
		150,
		136,
		142,
		144,
		152,
		150,
		147,
		159,
		155,
		175,
		156,
		191,
		-1,
		294,
		-1,
		228,
		-1,
		-1,
		210,
		190,
		182,
		171,
		160,
		158,
		149,
		140,
		162,
		178,
		162,
		160,
		163,
		164,
		-1,
		283,
		282,
		-1,
		229,
		221,
		207,
		-1,
		200,
		-1,
		206,
		167,
		-1,
		169,
		149,
		-1,
		171,
		167,
		-1,
		-1,
		270,
		245,
		-1,
		-1,
		-1,
		230,
		210,
		201,
		185,
		-1,
		160,
		160,
		-1,
		-1,
		-1,
		255,
		254,
		-1,
		223,
		226,
		-1,
		216,
		207,
		215,
		162,
		166,
		-1,
		-1,
		-1,
		264,
		245,
		239,
		238,
		236,
		231,
		228,
		214,
		198,
		176,
		165,
		186,
		-1,
		-1,
		-1,
		236,
		228,
		221,
		-1,
		-1,
		223,
		206,
		187,
		185,
		-1,
		-1,
		-1,
		258,
		239,
		-1,
		-1,
		213,
		-1,
		-1,
		219,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		247,
		-1,
		-1,
		-1,
		209,
		205,
		206,
		-1,
		-1,
		-1,
		-1,
		269,
		270,
		293,
		257,
		-1,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		272,
		270,
		-1,
		-1,
		-1,
		229,
		213,
		-1,
		199,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		234,
		-1,
		234,
		209,
		216,
		-1,
		-1,
		-1,
		-1,
		247,
		239,
		247,
		-1,
		219,
		221,
		-1,
		269,
		-1,
		-1,
		262,
		253,
		-1,
		-1,
		224,
		231,
		253,
		256,
		292,
		-1,
		243
	],
	[
		-1,
		167,
		156,
		167,
		175,
		148,
		155,
		-1,
		176,
		178,
		144,
		138,
		177,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		167,
		166,
		136,
		134,
		143,
		148,
		155,
		-1,
		159,
		-1,
		188,
		167,
		178,
		183,
		129,
		126,
		146,
		165,
		152,
		144,
		203,
		159,
		130,
		124,
		142,
		137,
		146,
		138,
		-1,
		130,
		120,
		142,
		126,
		137,
		129,
		-1,
		-1,
		124,
		125,
		131,
		122,
		128,
		124,
		-1,
		134,
		118,
		-1,
		-1,
		114,
		120,
		104,
		107,
		115,
		113,
		126,
		118,
		113,
		-1,
		-1,
		110,
		106,
		113,
		100,
		96,
		113,
		126,
		108,
		122,
		121,
		-1,
		103,
		121,
		130,
		107,
		105,
		89,
		87,
		105,
		107,
		113,
		116,
		-1,
		112,
		113,
		108,
		116,
		121,
		105,
		92,
		92,
		102,
		95,
		114,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		111,
		95,
		112,
		104,
		94,
		109,
		102,
		95,
		92,
		90,
		87,
		103,
		104,
		114,
		-1,
		-1,
		167,
		136,
		171,
		128,
		113,
		-1,
		107,
		88,
		94,
		98,
		92,
		85,
		99,
		95,
		-1,
		81,
		80,
		111,
		97,
		108,
		127,
		-1,
		-1,
		125,
		117,
		102,
		105,
		102,
		102,
		103,
		102,
		94,
		80,
		76,
		82,
		85,
		85,
		91,
		75,
		85,
		89,
		100,
		115,
		-1,
		-1,
		170,
		-1,
		-1,
		124,
		107,
		-1,
		90,
		97,
		97,
		114,
		104,
		125,
		113,
		104,
		96,
		90,
		78,
		80,
		77,
		90,
		78,
		72,
		97,
		101,
		95,
		116,
		111,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		83,
		86,
		92,
		116,
		126,
		-1,
		116,
		113,
		114,
		99,
		96,
		83,
		71,
		84,
		69,
		76,
		75,
		79,
		81,
		114,
		92,
		114,
		111,
		140,
		145,
		139,
		148,
		-1,
		132,
		128,
		124,
		131,
		80,
		-1,
		-1,
		120,
		-1,
		134,
		133,
		108,
		110,
		113,
		100,
		91,
		78,
		67,
		78,
		67,
		64,
		72,
		81,
		92,
		87,
		86,
		104,
		119,
		132,
		136,
		142,
		-1,
		182,
		-1,
		124,
		108,
		110,
		82,
		103,
		-1,
		140,
		135,
		125,
		110,
		101,
		-1,
		104,
		106,
		96,
		74,
		59,
		76,
		68,
		66,
		71,
		76,
		90,
		81,
		99,
		106,
		114,
		118,
		138,
		150,
		142,
		132,
		-1,
		114,
		119,
		78,
		86,
		105,
		143,
		107,
		-1,
		102,
		-1,
		94,
		119,
		-1,
		80,
		76,
		58,
		59,
		54,
		69,
		75,
		72,
		69,
		87,
		90,
		107,
		111,
		127,
		-1,
		-1,
		127,
		131,
		120,
		71,
		90,
		114,
		151,
		100,
		89,
		88,
		-1,
		79,
		91,
		88,
		74,
		61,
		51,
		52,
		60,
		73,
		52,
		71,
		74,
		96,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		97,
		68,
		92,
		134,
		118,
		111,
		99,
		64,
		64,
		58,
		-1,
		81,
		64,
		60,
		49,
		47,
		60,
		55,
		71,
		75,
		74,
		93,
		105,
		96,
		116,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		63,
		86,
		123,
		97,
		83,
		88,
		63,
		56,
		50,
		84,
		81,
		48,
		56,
		48,
		37,
		51,
		59,
		63,
		72,
		81,
		87,
		111,
		111,
		117,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		77,
		84,
		116,
		88,
		101,
		-1,
		55,
		-1,
		44,
		32,
		33,
		39,
		51,
		37,
		42,
		53,
		65,
		78,
		74,
		81,
		116,
		116,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		127,
		122,
		97,
		74,
		58,
		94,
		-1,
		71,
		72,
		-1,
		49,
		43,
		32,
		30,
		37,
		34,
		34,
		48,
		56,
		52,
		68,
		74,
		66,
		102,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		53,
		105,
		-1,
		-1,
		56,
		49,
		-1,
		34,
		18,
		22,
		31,
		39,
		44,
		52,
		47,
		60,
		65,
		71,
		76,
		94,
		98,
		102,
		91,
		87,
		84,
		98,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		73,
		-1,
		65,
		57,
		47,
		41,
		35,
		0,
		9,
		45,
		37,
		55,
		55,
		61,
		69,
		54,
		57,
		73,
		71,
		89,
		97,
		89,
		83,
		82,
		94,
		-1,
		140,
		126,
		97,
		-1,
		-1,
		86,
		-1,
		50,
		64,
		80,
		-1,
		73,
		52,
		64,
		45,
		14,
		33,
		75,
		76,
		54,
		59,
		67,
		77,
		79,
		68,
		79,
		71,
		93,
		93,
		77,
		78,
		87,
		-1,
		146,
		133,
		91,
		87,
		76,
		96,
		47,
		35,
		67,
		-1,
		-1,
		103,
		-1,
		43,
		42,
		47,
		45,
		65,
		56,
		62,
		78,
		81,
		83,
		73,
		62,
		68,
		65,
		87,
		73,
		71,
		90,
		106,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		62,
		49,
		43,
		-1,
		84,
		-1,
		81,
		71,
		55,
		46,
		71,
		-1,
		73,
		57,
		62,
		-1,
		108,
		-1,
		81,
		83,
		77,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		96,
		81,
		74,
		64,
		78,
		49,
		-1,
		104,
		-1,
		-1,
		68,
		62,
		62,
		52,
		55,
		89,
		69,
		63,
		62,
		103,
		103,
		89,
		75,
		68,
		65,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		101,
		87,
		91,
		51,
		70,
		-1,
		-1,
		130,
		85,
		71,
		-1,
		61,
		106,
		94,
		84,
		74,
		108,
		109,
		94,
		87,
		73,
		75,
		73,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		84,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		79,
		95,
		90,
		62,
		95,
		-1,
		-1,
		86,
		84,
		94,
		90,
		77,
		97,
		100,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		87,
		74,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		116,
		82,
		94,
		115,
		131,
		89,
		-1,
		94,
		95,
		81,
		95,
		102,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		73,
		87,
		108,
		113,
		117,
		-1,
		103,
		97,
		83,
		100,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		91,
		106,
		159,
		136,
		109,
		104,
		97,
		91,
		91,
		107,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		105,
		122,
		117,
		99,
		103,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		101,
		104,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		120,
		-1,
		-1,
		-1,
		125,
		-1,
		140,
		-1,
		-1,
		118,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		99,
		109,
		118,
		110,
		91,
		102,
		125,
		114,
		152,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		154,
		129,
		144,
		190,
		138,
		145,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		109,
		117,
		117,
		114,
		92,
		99,
		115,
		114,
		109,
		144,
		136,
		142,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		160,
		146,
		176,
		166,
		155,
		-1,
		-1,
		162,
		159,
		135,
		119,
		123,
		116,
		111,
		121,
		101,
		88,
		92,
		96,
		102,
		107,
		112,
		118,
		133,
		148,
		-1,
		132,
		213,
		206,
		189,
		197,
		228,
		-1,
		163,
		172,
		153,
		158,
		165,
		-1,
		-1,
		135,
		132,
		137,
		126,
		123,
		131,
		126,
		117,
		102,
		108,
		95,
		94,
		112,
		116,
		125,
		132,
		122,
		135,
		139,
		-1,
		146,
		189,
		183,
		186,
		210,
		224,
		-1,
		176,
		-1,
		-1,
		161,
		166,
		150,
		140,
		134,
		184,
		140,
		135,
		125,
		123,
		114,
		105,
		112,
		103,
		103,
		106,
		121,
		126,
		118,
		132,
		132,
		133,
		-1,
		181,
		169,
		177,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		177,
		-1,
		177,
		-1,
		152,
		156,
		148,
		151,
		139,
		126,
		118,
		110,
		126,
		101,
		111,
		107,
		108,
		117,
		128,
		140,
		139,
		140,
		254,
		210,
		177,
		168,
		215,
		230,
		234,
		-1,
		189,
		228,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		166,
		161,
		153,
		159,
		138,
		138,
		112,
		116,
		106,
		113,
		123,
		125,
		117,
		121,
		134,
		145,
		148,
		250,
		241,
		254,
		199,
		182,
		200,
		209,
		230,
		204,
		195,
		222,
		222,
		211,
		206,
		193,
		-1,
		-1,
		189,
		171,
		-1,
		-1,
		145,
		133,
		116,
		117,
		113,
		116,
		131,
		134,
		124,
		122,
		116,
		148,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		201,
		-1,
		-1,
		207,
		223,
		223,
		227,
		243,
		268,
		-1,
		196,
		-1,
		-1,
		190,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		121,
		132,
		142,
		130,
		131,
		121,
		131,
		144,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		199,
		197,
		203,
		210,
		227,
		257,
		-1,
		-1,
		212,
		201,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		123,
		128,
		148,
		150,
		139,
		133,
		127,
		134,
		133,
		141,
		149,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		211,
		207,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		141,
		145,
		137,
		130,
		125,
		136,
		128,
		132,
		149,
		-1,
		270,
		-1,
		222,
		198,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		228,
		214,
		207,
		195,
		193,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		131,
		142,
		131,
		134,
		148,
		143,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		218,
		220,
		-1,
		219,
		208,
		193,
		185,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		135,
		141,
		144,
		133,
		137,
		149,
		-1,
		-1,
		217,
		218,
		223,
		-1,
		203,
		-1,
		221,
		-1,
		188,
		194,
		182,
		-1,
		-1,
		-1,
		176,
		139,
		160,
		170,
		164,
		162,
		153,
		139,
		146,
		144,
		140,
		151,
		-1,
		-1,
		-1,
		221,
		195,
		228,
		219,
		202,
		182,
		174,
		193,
		-1,
		163,
		-1,
		138,
		140,
		166,
		169,
		175,
		169,
		142,
		157,
		147,
		138,
		147,
		227,
		-1,
		197,
		230,
		194,
		188,
		164,
		168,
		184,
		-1,
		160,
		142,
		-1,
		170,
		160,
		191,
		176,
		157,
		144,
		151,
		151,
		144,
		-1,
		-1,
		-1,
		199,
		198,
		190,
		184,
		184,
		169,
		160,
		-1,
		172,
		154,
		133,
		150,
		150,
		141,
		149,
		181,
		177,
		164,
		164,
		156,
		-1,
		300,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		193,
		188,
		161,
		149,
		155,
		151,
		137,
		143,
		145,
		153,
		151,
		148,
		160,
		156,
		176,
		157,
		192,
		-1,
		295,
		-1,
		229,
		-1,
		-1,
		211,
		191,
		183,
		172,
		161,
		159,
		150,
		141,
		163,
		179,
		163,
		161,
		164,
		165,
		-1,
		284,
		283,
		-1,
		230,
		222,
		208,
		-1,
		201,
		-1,
		207,
		168,
		-1,
		170,
		150,
		-1,
		172,
		168,
		-1,
		-1,
		271,
		246,
		-1,
		-1,
		-1,
		231,
		211,
		202,
		186,
		-1,
		161,
		161,
		-1,
		-1,
		-1,
		256,
		255,
		-1,
		224,
		227,
		-1,
		217,
		208,
		216,
		163,
		167,
		-1,
		-1,
		-1,
		265,
		246,
		240,
		239,
		237,
		232,
		229,
		215,
		199,
		177,
		166,
		187,
		-1,
		-1,
		-1,
		237,
		229,
		222,
		-1,
		-1,
		224,
		207,
		188,
		186,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		214,
		-1,
		-1,
		220,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		248,
		-1,
		-1,
		-1,
		210,
		206,
		207,
		-1,
		-1,
		-1,
		-1,
		270,
		271,
		294,
		258,
		-1,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		273,
		271,
		-1,
		-1,
		-1,
		230,
		214,
		-1,
		200,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		235,
		-1,
		235,
		210,
		217,
		-1,
		-1,
		-1,
		-1,
		248,
		240,
		248,
		-1,
		220,
		222,
		-1,
		270,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		225,
		232,
		254,
		257,
		293,
		-1,
		244
	],
	[
		-1,
		164,
		153,
		164,
		172,
		145,
		152,
		-1,
		173,
		175,
		141,
		135,
		174,
		145,
		151,
		162,
		-1,
		-1,
		-1,
		164,
		163,
		133,
		131,
		140,
		145,
		152,
		-1,
		156,
		-1,
		185,
		164,
		175,
		180,
		126,
		123,
		143,
		162,
		149,
		141,
		200,
		156,
		127,
		121,
		139,
		134,
		143,
		135,
		-1,
		127,
		117,
		139,
		123,
		134,
		126,
		-1,
		-1,
		121,
		122,
		128,
		119,
		125,
		121,
		-1,
		131,
		115,
		-1,
		-1,
		111,
		117,
		101,
		104,
		112,
		110,
		123,
		115,
		110,
		-1,
		-1,
		107,
		103,
		110,
		97,
		93,
		110,
		123,
		105,
		119,
		118,
		-1,
		100,
		118,
		127,
		104,
		102,
		86,
		84,
		102,
		104,
		110,
		113,
		-1,
		109,
		110,
		105,
		113,
		118,
		102,
		89,
		89,
		99,
		92,
		111,
		102,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		92,
		109,
		101,
		91,
		106,
		99,
		92,
		89,
		87,
		84,
		100,
		101,
		111,
		-1,
		-1,
		164,
		133,
		168,
		125,
		110,
		-1,
		104,
		85,
		91,
		95,
		89,
		82,
		96,
		92,
		-1,
		78,
		77,
		108,
		94,
		105,
		124,
		-1,
		-1,
		122,
		114,
		99,
		102,
		99,
		99,
		100,
		99,
		91,
		77,
		73,
		79,
		82,
		82,
		88,
		72,
		82,
		86,
		97,
		112,
		-1,
		-1,
		167,
		-1,
		-1,
		121,
		104,
		-1,
		87,
		94,
		94,
		111,
		101,
		122,
		110,
		101,
		93,
		87,
		75,
		77,
		74,
		87,
		75,
		69,
		94,
		98,
		92,
		113,
		108,
		-1,
		166,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		80,
		83,
		89,
		113,
		123,
		-1,
		113,
		110,
		111,
		96,
		93,
		80,
		68,
		81,
		66,
		73,
		72,
		76,
		78,
		111,
		89,
		111,
		108,
		137,
		142,
		136,
		145,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		117,
		-1,
		131,
		130,
		105,
		107,
		110,
		97,
		88,
		75,
		64,
		75,
		64,
		61,
		69,
		78,
		89,
		84,
		83,
		101,
		116,
		129,
		133,
		139,
		-1,
		179,
		-1,
		121,
		105,
		107,
		79,
		100,
		-1,
		137,
		132,
		122,
		107,
		98,
		-1,
		101,
		103,
		93,
		71,
		56,
		73,
		65,
		63,
		68,
		73,
		87,
		78,
		96,
		103,
		111,
		115,
		135,
		147,
		139,
		129,
		-1,
		111,
		116,
		75,
		83,
		102,
		140,
		104,
		-1,
		99,
		-1,
		91,
		116,
		-1,
		77,
		73,
		55,
		56,
		51,
		66,
		72,
		69,
		66,
		84,
		87,
		104,
		108,
		124,
		-1,
		-1,
		124,
		128,
		117,
		68,
		87,
		111,
		148,
		97,
		86,
		85,
		-1,
		76,
		88,
		85,
		71,
		58,
		48,
		49,
		57,
		70,
		49,
		68,
		71,
		93,
		121,
		99,
		111,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		94,
		65,
		89,
		131,
		115,
		108,
		96,
		61,
		61,
		55,
		-1,
		78,
		61,
		57,
		46,
		44,
		57,
		52,
		68,
		72,
		71,
		90,
		102,
		93,
		113,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		60,
		83,
		120,
		94,
		80,
		85,
		60,
		53,
		47,
		81,
		78,
		45,
		53,
		45,
		34,
		48,
		56,
		60,
		69,
		78,
		84,
		108,
		108,
		114,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		74,
		81,
		113,
		85,
		98,
		-1,
		52,
		-1,
		41,
		29,
		30,
		36,
		48,
		34,
		39,
		50,
		62,
		75,
		71,
		78,
		113,
		113,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		124,
		119,
		94,
		71,
		55,
		91,
		-1,
		68,
		69,
		-1,
		46,
		40,
		29,
		27,
		34,
		31,
		31,
		45,
		53,
		49,
		65,
		71,
		63,
		99,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		117,
		96,
		89,
		109,
		50,
		102,
		-1,
		-1,
		53,
		46,
		-1,
		31,
		15,
		19,
		28,
		36,
		41,
		49,
		44,
		57,
		62,
		68,
		73,
		91,
		95,
		99,
		88,
		84,
		81,
		95,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		70,
		-1,
		62,
		54,
		44,
		38,
		32,
		8,
		0,
		42,
		34,
		52,
		52,
		58,
		66,
		51,
		54,
		70,
		68,
		86,
		94,
		86,
		80,
		79,
		91,
		-1,
		137,
		123,
		94,
		-1,
		-1,
		83,
		-1,
		47,
		61,
		77,
		-1,
		70,
		49,
		61,
		42,
		18,
		30,
		72,
		73,
		51,
		56,
		64,
		74,
		76,
		65,
		76,
		68,
		90,
		90,
		74,
		75,
		84,
		-1,
		143,
		130,
		88,
		84,
		73,
		93,
		44,
		32,
		64,
		-1,
		-1,
		106,
		-1,
		40,
		46,
		44,
		42,
		62,
		53,
		59,
		75,
		78,
		80,
		70,
		59,
		65,
		62,
		84,
		70,
		68,
		87,
		103,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		59,
		46,
		40,
		-1,
		81,
		-1,
		84,
		74,
		58,
		43,
		75,
		-1,
		70,
		54,
		59,
		-1,
		105,
		-1,
		78,
		80,
		74,
		59,
		56,
		67,
		65,
		76,
		93,
		-1,
		93,
		78,
		71,
		61,
		75,
		46,
		-1,
		101,
		-1,
		-1,
		71,
		65,
		65,
		49,
		52,
		86,
		66,
		60,
		59,
		100,
		100,
		86,
		72,
		65,
		62,
		59,
		72,
		92,
		83,
		95,
		-1,
		-1,
		-1,
		98,
		84,
		88,
		48,
		67,
		-1,
		-1,
		133,
		88,
		74,
		-1,
		58,
		103,
		91,
		81,
		71,
		105,
		106,
		91,
		84,
		70,
		72,
		70,
		68,
		73,
		94,
		95,
		108,
		-1,
		-1,
		81,
		86,
		74,
		60,
		79,
		-1,
		-1,
		-1,
		80,
		96,
		88,
		59,
		92,
		-1,
		-1,
		83,
		81,
		91,
		87,
		74,
		94,
		97,
		83,
		67,
		82,
		94,
		102,
		107,
		-1,
		84,
		71,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		91,
		112,
		128,
		86,
		-1,
		91,
		92,
		78,
		92,
		99,
		85,
		80,
		74,
		77,
		95,
		112,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		70,
		84,
		105,
		110,
		114,
		-1,
		100,
		94,
		80,
		97,
		98,
		95,
		86,
		78,
		83,
		80,
		93,
		107,
		111,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		88,
		103,
		156,
		133,
		106,
		101,
		94,
		88,
		88,
		104,
		106,
		117,
		85,
		81,
		82,
		86,
		85,
		102,
		112,
		-1,
		-1,
		102,
		119,
		114,
		96,
		100,
		183,
		-1,
		-1,
		110,
		101,
		92,
		95,
		98,
		101,
		91,
		88,
		93,
		98,
		86,
		95,
		113,
		117,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		115,
		181,
		128,
		110,
		106,
		104,
		97,
		106,
		101,
		96,
		106,
		115,
		107,
		88,
		99,
		122,
		111,
		149,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		135,
		142,
		143,
		140,
		-1,
		110,
		135,
		107,
		114,
		106,
		114,
		114,
		111,
		89,
		96,
		112,
		111,
		106,
		141,
		133,
		139,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		157,
		143,
		173,
		163,
		152,
		-1,
		-1,
		159,
		156,
		132,
		116,
		120,
		113,
		108,
		118,
		98,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		130,
		145,
		-1,
		129,
		210,
		203,
		186,
		194,
		225,
		-1,
		160,
		169,
		150,
		155,
		162,
		-1,
		-1,
		132,
		129,
		134,
		123,
		120,
		128,
		123,
		114,
		99,
		105,
		92,
		91,
		109,
		113,
		122,
		129,
		119,
		132,
		136,
		-1,
		143,
		186,
		180,
		183,
		207,
		221,
		-1,
		173,
		-1,
		-1,
		158,
		163,
		147,
		137,
		131,
		181,
		137,
		132,
		122,
		120,
		111,
		102,
		109,
		100,
		100,
		103,
		118,
		123,
		115,
		129,
		129,
		130,
		-1,
		178,
		166,
		174,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		174,
		-1,
		149,
		153,
		145,
		148,
		136,
		123,
		115,
		107,
		123,
		98,
		108,
		104,
		105,
		114,
		125,
		137,
		136,
		137,
		251,
		207,
		174,
		165,
		212,
		227,
		231,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		163,
		158,
		150,
		156,
		135,
		135,
		109,
		113,
		103,
		110,
		120,
		122,
		114,
		118,
		131,
		142,
		145,
		247,
		238,
		251,
		196,
		179,
		197,
		206,
		227,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		186,
		168,
		-1,
		-1,
		142,
		130,
		113,
		114,
		110,
		113,
		128,
		131,
		121,
		119,
		113,
		145,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		198,
		-1,
		-1,
		204,
		220,
		220,
		224,
		240,
		265,
		-1,
		193,
		-1,
		-1,
		187,
		-1,
		-1,
		172,
		135,
		124,
		115,
		121,
		118,
		129,
		139,
		127,
		128,
		118,
		128,
		141,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		209,
		198,
		-1,
		-1,
		170,
		168,
		157,
		-1,
		147,
		120,
		125,
		145,
		147,
		136,
		130,
		124,
		131,
		130,
		138,
		146,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		208,
		204,
		-1,
		-1,
		165,
		158,
		146,
		134,
		124,
		134,
		138,
		142,
		134,
		127,
		122,
		133,
		125,
		129,
		146,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		225,
		211,
		204,
		192,
		190,
		-1,
		199,
		183,
		164,
		-1,
		134,
		147,
		178,
		146,
		151,
		146,
		128,
		139,
		128,
		131,
		145,
		140,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		215,
		217,
		-1,
		216,
		205,
		190,
		182,
		-1,
		-1,
		171,
		167,
		-1,
		-1,
		135,
		160,
		149,
		157,
		152,
		132,
		138,
		141,
		130,
		134,
		146,
		-1,
		-1,
		214,
		215,
		220,
		-1,
		200,
		-1,
		218,
		-1,
		185,
		191,
		179,
		-1,
		-1,
		-1,
		173,
		136,
		157,
		167,
		161,
		159,
		150,
		136,
		143,
		141,
		137,
		148,
		-1,
		-1,
		-1,
		218,
		192,
		225,
		216,
		199,
		179,
		171,
		190,
		-1,
		160,
		-1,
		135,
		137,
		163,
		166,
		172,
		166,
		139,
		154,
		144,
		135,
		144,
		224,
		-1,
		194,
		227,
		191,
		185,
		161,
		165,
		181,
		-1,
		157,
		139,
		-1,
		167,
		157,
		188,
		173,
		154,
		141,
		148,
		148,
		141,
		-1,
		-1,
		-1,
		196,
		195,
		187,
		181,
		181,
		166,
		157,
		-1,
		169,
		151,
		130,
		147,
		147,
		138,
		146,
		178,
		174,
		161,
		161,
		153,
		-1,
		297,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		190,
		185,
		158,
		146,
		152,
		148,
		134,
		140,
		142,
		150,
		148,
		145,
		157,
		153,
		173,
		154,
		189,
		-1,
		292,
		-1,
		226,
		-1,
		-1,
		208,
		188,
		180,
		169,
		158,
		156,
		147,
		138,
		160,
		176,
		160,
		158,
		161,
		162,
		-1,
		281,
		280,
		-1,
		227,
		219,
		205,
		-1,
		198,
		-1,
		204,
		165,
		-1,
		167,
		147,
		-1,
		169,
		165,
		-1,
		-1,
		268,
		243,
		-1,
		-1,
		-1,
		228,
		208,
		199,
		183,
		-1,
		158,
		158,
		-1,
		-1,
		-1,
		253,
		252,
		-1,
		221,
		224,
		-1,
		214,
		205,
		213,
		160,
		164,
		-1,
		-1,
		-1,
		262,
		243,
		237,
		236,
		234,
		229,
		226,
		212,
		196,
		174,
		163,
		184,
		-1,
		-1,
		-1,
		234,
		226,
		219,
		-1,
		-1,
		221,
		204,
		185,
		183,
		-1,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		211,
		-1,
		-1,
		217,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		245,
		-1,
		-1,
		-1,
		207,
		203,
		204,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		291,
		255,
		-1,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		270,
		268,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		197,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		232,
		-1,
		232,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		245,
		237,
		245,
		-1,
		217,
		219,
		-1,
		267,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		222,
		229,
		251,
		254,
		290,
		-1,
		241
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		192,
		194,
		160,
		154,
		193,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		183,
		182,
		152,
		150,
		159,
		164,
		171,
		-1,
		175,
		-1,
		204,
		183,
		194,
		199,
		145,
		142,
		162,
		181,
		168,
		160,
		219,
		175,
		146,
		140,
		158,
		153,
		162,
		154,
		-1,
		146,
		136,
		158,
		142,
		153,
		145,
		-1,
		-1,
		140,
		141,
		147,
		138,
		144,
		140,
		-1,
		150,
		134,
		-1,
		-1,
		130,
		136,
		120,
		123,
		131,
		129,
		142,
		134,
		129,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		124,
		138,
		137,
		-1,
		119,
		137,
		146,
		123,
		121,
		105,
		103,
		121,
		123,
		129,
		132,
		-1,
		128,
		129,
		124,
		132,
		137,
		121,
		108,
		108,
		118,
		111,
		130,
		121,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		127,
		111,
		128,
		120,
		110,
		125,
		118,
		111,
		108,
		106,
		103,
		119,
		120,
		130,
		-1,
		-1,
		183,
		152,
		187,
		144,
		129,
		-1,
		123,
		104,
		110,
		114,
		108,
		101,
		115,
		111,
		-1,
		97,
		96,
		127,
		113,
		124,
		143,
		-1,
		-1,
		141,
		133,
		118,
		121,
		118,
		118,
		119,
		118,
		110,
		96,
		92,
		98,
		101,
		101,
		107,
		91,
		101,
		105,
		116,
		131,
		-1,
		-1,
		186,
		-1,
		-1,
		140,
		123,
		-1,
		106,
		113,
		113,
		130,
		120,
		141,
		129,
		120,
		112,
		106,
		94,
		96,
		93,
		106,
		94,
		88,
		113,
		117,
		111,
		132,
		127,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		99,
		102,
		108,
		132,
		142,
		-1,
		132,
		129,
		130,
		115,
		112,
		99,
		87,
		100,
		85,
		92,
		91,
		95,
		97,
		130,
		108,
		130,
		127,
		156,
		161,
		155,
		164,
		-1,
		148,
		144,
		140,
		147,
		96,
		-1,
		-1,
		136,
		-1,
		150,
		149,
		124,
		126,
		129,
		116,
		107,
		94,
		83,
		94,
		83,
		80,
		88,
		97,
		108,
		103,
		102,
		120,
		135,
		148,
		152,
		158,
		-1,
		198,
		-1,
		140,
		124,
		126,
		98,
		119,
		-1,
		156,
		151,
		141,
		126,
		117,
		-1,
		120,
		122,
		112,
		90,
		75,
		92,
		84,
		82,
		87,
		92,
		106,
		97,
		115,
		122,
		130,
		134,
		154,
		166,
		158,
		148,
		-1,
		130,
		135,
		94,
		102,
		121,
		159,
		123,
		-1,
		118,
		-1,
		110,
		135,
		-1,
		96,
		92,
		74,
		75,
		70,
		85,
		91,
		88,
		85,
		103,
		106,
		123,
		127,
		143,
		-1,
		-1,
		143,
		147,
		136,
		87,
		106,
		130,
		167,
		116,
		105,
		104,
		-1,
		95,
		104,
		101,
		87,
		74,
		67,
		68,
		75,
		89,
		68,
		87,
		90,
		112,
		140,
		118,
		130,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		113,
		84,
		108,
		150,
		134,
		127,
		115,
		80,
		80,
		74,
		-1,
		94,
		77,
		76,
		65,
		63,
		76,
		69,
		87,
		91,
		90,
		109,
		121,
		112,
		132,
		-1,
		-1,
		-1,
		143,
		132,
		133,
		79,
		102,
		139,
		113,
		99,
		104,
		79,
		72,
		66,
		97,
		94,
		61,
		72,
		62,
		53,
		65,
		73,
		77,
		88,
		97,
		103,
		127,
		125,
		131,
		-1,
		-1,
		150,
		140,
		124,
		126,
		123,
		93,
		100,
		132,
		104,
		117,
		-1,
		71,
		-1,
		60,
		45,
		49,
		52,
		62,
		51,
		56,
		69,
		79,
		94,
		90,
		97,
		132,
		132,
		115,
		135,
		138,
		-1,
		-1,
		-1,
		143,
		138,
		113,
		90,
		74,
		110,
		-1,
		87,
		88,
		-1,
		65,
		59,
		48,
		46,
		53,
		45,
		44,
		58,
		70,
		66,
		84,
		88,
		82,
		118,
		-1,
		123,
		117,
		125,
		115,
		103,
		-1,
		-1,
		-1,
		136,
		115,
		108,
		128,
		69,
		121,
		-1,
		-1,
		72,
		65,
		-1,
		50,
		34,
		28,
		30,
		41,
		50,
		53,
		61,
		74,
		79,
		87,
		90,
		108,
		112,
		116,
		105,
		101,
		98,
		112,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		89,
		-1,
		81,
		73,
		63,
		57,
		51,
		39,
		37,
		0,
		14,
		56,
		56,
		64,
		70,
		68,
		71,
		87,
		85,
		103,
		111,
		103,
		97,
		96,
		108,
		-1,
		156,
		142,
		113,
		-1,
		-1,
		102,
		-1,
		66,
		80,
		96,
		-1,
		89,
		68,
		80,
		61,
		49,
		22,
		76,
		77,
		55,
		60,
		68,
		78,
		93,
		82,
		93,
		85,
		107,
		107,
		91,
		92,
		101,
		-1,
		162,
		149,
		107,
		103,
		92,
		112,
		63,
		51,
		83,
		-1,
		-1,
		125,
		-1,
		59,
		76,
		36,
		34,
		66,
		57,
		63,
		79,
		82,
		92,
		87,
		76,
		82,
		79,
		101,
		87,
		85,
		104,
		120,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		78,
		65,
		59,
		-1,
		100,
		-1,
		103,
		93,
		77,
		62,
		95,
		-1,
		74,
		58,
		63,
		-1,
		117,
		-1,
		95,
		97,
		91,
		76,
		73,
		84,
		82,
		93,
		110,
		-1,
		112,
		97,
		90,
		80,
		94,
		65,
		-1,
		120,
		-1,
		-1,
		90,
		84,
		84,
		68,
		71,
		90,
		70,
		64,
		63,
		116,
		109,
		102,
		89,
		82,
		79,
		76,
		89,
		109,
		100,
		112,
		-1,
		-1,
		-1,
		117,
		103,
		107,
		67,
		86,
		-1,
		-1,
		152,
		107,
		93,
		-1,
		77,
		107,
		95,
		85,
		75,
		109,
		110,
		100,
		101,
		87,
		89,
		87,
		85,
		90,
		111,
		112,
		125,
		-1,
		-1,
		100,
		105,
		93,
		79,
		98,
		-1,
		-1,
		-1,
		99,
		115,
		107,
		78,
		96,
		-1,
		-1,
		87,
		85,
		95,
		101,
		91,
		111,
		114,
		100,
		84,
		99,
		111,
		119,
		124,
		-1,
		103,
		90,
		-1,
		-1,
		101,
		95,
		-1,
		-1,
		-1,
		-1,
		132,
		98,
		110,
		131,
		143,
		90,
		-1,
		95,
		96,
		95,
		109,
		116,
		102,
		97,
		91,
		94,
		112,
		129,
		-1,
		-1,
		115,
		-1,
		110,
		-1,
		-1,
		-1,
		-1,
		89,
		103,
		124,
		125,
		129,
		-1,
		104,
		104,
		97,
		114,
		115,
		112,
		103,
		95,
		100,
		97,
		110,
		124,
		128,
		138,
		-1,
		121,
		-1,
		-1,
		-1,
		107,
		122,
		171,
		148,
		121,
		116,
		109,
		103,
		105,
		121,
		123,
		134,
		102,
		98,
		99,
		103,
		102,
		119,
		129,
		-1,
		-1,
		121,
		138,
		133,
		115,
		119,
		198,
		-1,
		-1,
		125,
		116,
		107,
		110,
		115,
		118,
		108,
		105,
		110,
		115,
		103,
		112,
		130,
		134,
		-1,
		-1,
		-1,
		141,
		-1,
		156,
		-1,
		-1,
		134,
		196,
		143,
		125,
		121,
		119,
		112,
		121,
		116,
		113,
		123,
		133,
		125,
		105,
		118,
		140,
		130,
		166,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		170,
		145,
		160,
		206,
		154,
		161,
		158,
		155,
		-1,
		125,
		150,
		122,
		129,
		121,
		131,
		131,
		129,
		108,
		115,
		131,
		130,
		125,
		158,
		152,
		158,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		176,
		162,
		192,
		182,
		171,
		-1,
		-1,
		174,
		171,
		147,
		131,
		135,
		128,
		123,
		137,
		117,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		148,
		229,
		222,
		205,
		213,
		244,
		-1,
		179,
		188,
		169,
		174,
		177,
		-1,
		-1,
		147,
		144,
		149,
		138,
		135,
		147,
		142,
		133,
		118,
		124,
		111,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		162,
		205,
		199,
		202,
		226,
		240,
		-1,
		192,
		-1,
		-1,
		177,
		178,
		162,
		152,
		146,
		196,
		152,
		147,
		141,
		139,
		130,
		121,
		128,
		119,
		119,
		122,
		137,
		142,
		134,
		148,
		148,
		149,
		-1,
		197,
		185,
		193,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		193,
		-1,
		189,
		-1,
		164,
		168,
		160,
		163,
		155,
		142,
		134,
		126,
		142,
		117,
		127,
		123,
		124,
		133,
		144,
		156,
		155,
		156,
		266,
		222,
		193,
		184,
		231,
		246,
		250,
		-1,
		205,
		244,
		231,
		-1,
		202,
		-1,
		-1,
		-1,
		178,
		173,
		165,
		175,
		154,
		154,
		128,
		132,
		122,
		129,
		139,
		141,
		133,
		137,
		150,
		161,
		164,
		262,
		253,
		266,
		211,
		198,
		216,
		225,
		246,
		220,
		211,
		238,
		238,
		227,
		222,
		209,
		-1,
		-1,
		201,
		183,
		-1,
		-1,
		161,
		149,
		132,
		133,
		129,
		132,
		147,
		150,
		140,
		138,
		132,
		164,
		-1,
		255,
		254,
		243,
		240,
		216,
		207,
		202,
		217,
		-1,
		-1,
		223,
		239,
		235,
		239,
		255,
		280,
		-1,
		212,
		-1,
		-1,
		206,
		-1,
		-1,
		191,
		154,
		143,
		134,
		140,
		137,
		148,
		158,
		146,
		147,
		137,
		147,
		160,
		239,
		236,
		224,
		222,
		245,
		210,
		198,
		-1,
		211,
		209,
		215,
		222,
		239,
		269,
		-1,
		-1,
		228,
		217,
		-1,
		-1,
		189,
		187,
		176,
		-1,
		166,
		139,
		144,
		164,
		166,
		155,
		149,
		143,
		150,
		149,
		157,
		165,
		248,
		262,
		251,
		247,
		246,
		254,
		203,
		196,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		227,
		223,
		-1,
		-1,
		184,
		177,
		165,
		153,
		143,
		153,
		157,
		161,
		153,
		146,
		141,
		152,
		144,
		148,
		165,
		-1,
		282,
		-1,
		234,
		210,
		224,
		239,
		247,
		-1,
		-1,
		-1,
		244,
		230,
		223,
		211,
		209,
		-1,
		218,
		202,
		183,
		-1,
		153,
		166,
		197,
		165,
		170,
		165,
		147,
		158,
		147,
		150,
		164,
		159,
		-1,
		-1,
		222,
		225,
		-1,
		-1,
		234,
		236,
		-1,
		235,
		224,
		209,
		201,
		-1,
		-1,
		190,
		186,
		-1,
		-1,
		154,
		179,
		168,
		176,
		171,
		151,
		157,
		160,
		149,
		153,
		165,
		-1,
		-1,
		229,
		230,
		235,
		-1,
		219,
		-1,
		237,
		-1,
		204,
		210,
		198,
		-1,
		-1,
		-1,
		192,
		155,
		176,
		186,
		180,
		178,
		169,
		155,
		162,
		160,
		156,
		167,
		-1,
		-1,
		-1,
		237,
		211,
		244,
		235,
		218,
		198,
		190,
		209,
		-1,
		179,
		-1,
		154,
		156,
		182,
		185,
		191,
		185,
		158,
		173,
		163,
		154,
		163,
		243,
		-1,
		213,
		246,
		210,
		204,
		180,
		184,
		200,
		-1,
		176,
		158,
		-1,
		186,
		176,
		207,
		192,
		173,
		160,
		167,
		167,
		160,
		-1,
		-1,
		-1,
		215,
		214,
		206,
		200,
		200,
		185,
		176,
		-1,
		188,
		170,
		149,
		166,
		166,
		157,
		165,
		197,
		193,
		180,
		180,
		172,
		-1,
		316,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		209,
		204,
		177,
		165,
		171,
		167,
		153,
		159,
		161,
		169,
		167,
		164,
		176,
		172,
		192,
		173,
		208,
		-1,
		311,
		-1,
		245,
		-1,
		-1,
		227,
		207,
		199,
		188,
		177,
		175,
		166,
		157,
		179,
		195,
		179,
		177,
		180,
		181,
		-1,
		300,
		299,
		-1,
		246,
		238,
		224,
		-1,
		217,
		-1,
		223,
		184,
		-1,
		186,
		166,
		-1,
		188,
		184,
		-1,
		-1,
		287,
		262,
		-1,
		-1,
		-1,
		247,
		227,
		218,
		202,
		-1,
		177,
		177,
		-1,
		-1,
		-1,
		272,
		271,
		-1,
		240,
		243,
		-1,
		233,
		224,
		232,
		179,
		183,
		-1,
		-1,
		-1,
		281,
		262,
		256,
		255,
		253,
		248,
		245,
		231,
		215,
		193,
		182,
		203,
		-1,
		-1,
		-1,
		253,
		245,
		238,
		-1,
		-1,
		240,
		223,
		204,
		202,
		-1,
		-1,
		-1,
		275,
		256,
		-1,
		-1,
		230,
		-1,
		-1,
		236,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		264,
		-1,
		-1,
		-1,
		226,
		222,
		223,
		-1,
		-1,
		-1,
		-1,
		286,
		287,
		310,
		274,
		-1,
		-1,
		-1,
		218,
		212,
		-1,
		-1,
		289,
		287,
		-1,
		-1,
		-1,
		246,
		230,
		-1,
		216,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		251,
		-1,
		251,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		264,
		256,
		264,
		-1,
		236,
		238,
		-1,
		286,
		-1,
		-1,
		279,
		270,
		-1,
		-1,
		241,
		248,
		270,
		273,
		309,
		-1,
		260
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		164,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		157,
		149,
		208,
		164,
		135,
		129,
		147,
		142,
		151,
		143,
		-1,
		135,
		125,
		147,
		131,
		142,
		134,
		-1,
		-1,
		129,
		130,
		136,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		119,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		108,
		126,
		135,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		121,
		-1,
		117,
		118,
		113,
		121,
		126,
		110,
		97,
		97,
		107,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		117,
		100,
		117,
		109,
		99,
		114,
		107,
		100,
		97,
		95,
		92,
		108,
		109,
		119,
		-1,
		-1,
		177,
		146,
		181,
		138,
		123,
		-1,
		113,
		93,
		99,
		103,
		97,
		90,
		104,
		100,
		-1,
		86,
		85,
		116,
		102,
		113,
		137,
		-1,
		-1,
		135,
		127,
		112,
		115,
		112,
		112,
		108,
		107,
		99,
		85,
		81,
		87,
		90,
		90,
		96,
		80,
		90,
		94,
		102,
		120,
		-1,
		-1,
		172,
		-1,
		-1,
		134,
		117,
		-1,
		100,
		107,
		107,
		124,
		114,
		135,
		118,
		109,
		101,
		95,
		83,
		85,
		82,
		95,
		83,
		77,
		102,
		106,
		97,
		118,
		113,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		93,
		96,
		102,
		126,
		136,
		-1,
		126,
		118,
		119,
		104,
		101,
		88,
		76,
		89,
		74,
		81,
		80,
		84,
		86,
		119,
		94,
		116,
		113,
		142,
		147,
		141,
		150,
		-1,
		142,
		138,
		134,
		141,
		90,
		-1,
		-1,
		130,
		-1,
		144,
		143,
		118,
		115,
		118,
		105,
		96,
		83,
		72,
		83,
		72,
		69,
		77,
		83,
		97,
		89,
		88,
		106,
		121,
		134,
		138,
		144,
		-1,
		192,
		-1,
		134,
		118,
		120,
		92,
		113,
		-1,
		150,
		145,
		135,
		120,
		111,
		-1,
		114,
		111,
		101,
		79,
		64,
		81,
		73,
		71,
		76,
		78,
		92,
		83,
		101,
		108,
		116,
		120,
		140,
		152,
		152,
		142,
		-1,
		124,
		129,
		88,
		96,
		115,
		153,
		117,
		-1,
		112,
		-1,
		104,
		129,
		-1,
		85,
		81,
		63,
		64,
		59,
		74,
		77,
		74,
		71,
		89,
		92,
		109,
		113,
		129,
		-1,
		-1,
		137,
		141,
		130,
		81,
		100,
		124,
		161,
		110,
		99,
		98,
		-1,
		89,
		95,
		92,
		78,
		65,
		56,
		57,
		62,
		75,
		54,
		73,
		76,
		98,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		107,
		78,
		102,
		144,
		128,
		121,
		109,
		74,
		74,
		68,
		-1,
		85,
		68,
		65,
		54,
		51,
		63,
		55,
		73,
		77,
		79,
		95,
		107,
		98,
		118,
		-1,
		-1,
		-1,
		137,
		126,
		127,
		73,
		96,
		133,
		107,
		93,
		98,
		73,
		66,
		60,
		88,
		85,
		52,
		61,
		49,
		42,
		51,
		59,
		63,
		77,
		86,
		89,
		113,
		111,
		117,
		-1,
		-1,
		144,
		134,
		118,
		120,
		117,
		87,
		94,
		126,
		98,
		111,
		-1,
		65,
		-1,
		54,
		39,
		43,
		38,
		48,
		37,
		42,
		56,
		65,
		80,
		79,
		86,
		118,
		118,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		137,
		132,
		107,
		84,
		68,
		104,
		-1,
		81,
		82,
		-1,
		59,
		53,
		42,
		40,
		43,
		31,
		30,
		44,
		56,
		52,
		71,
		74,
		71,
		106,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		130,
		109,
		102,
		122,
		63,
		115,
		-1,
		-1,
		66,
		59,
		-1,
		44,
		28,
		22,
		16,
		27,
		36,
		39,
		47,
		60,
		65,
		76,
		76,
		94,
		98,
		102,
		91,
		87,
		84,
		98,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		83,
		-1,
		75,
		67,
		57,
		51,
		45,
		33,
		31,
		16,
		0,
		42,
		42,
		50,
		56,
		54,
		57,
		73,
		71,
		89,
		97,
		89,
		83,
		82,
		94,
		-1,
		150,
		136,
		107,
		-1,
		-1,
		96,
		-1,
		60,
		74,
		90,
		-1,
		83,
		62,
		74,
		55,
		43,
		16,
		62,
		63,
		41,
		46,
		54,
		64,
		79,
		68,
		79,
		71,
		93,
		93,
		77,
		78,
		87,
		-1,
		156,
		143,
		101,
		97,
		86,
		106,
		57,
		45,
		77,
		-1,
		-1,
		119,
		-1,
		53,
		70,
		30,
		28,
		52,
		43,
		49,
		65,
		68,
		78,
		73,
		62,
		68,
		65,
		87,
		73,
		71,
		90,
		106,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		72,
		59,
		53,
		-1,
		94,
		-1,
		97,
		87,
		71,
		56,
		89,
		-1,
		60,
		44,
		49,
		-1,
		103,
		-1,
		81,
		83,
		77,
		62,
		59,
		70,
		68,
		79,
		96,
		-1,
		106,
		91,
		84,
		74,
		88,
		59,
		-1,
		114,
		-1,
		-1,
		84,
		78,
		78,
		62,
		65,
		76,
		56,
		50,
		49,
		102,
		95,
		88,
		75,
		68,
		65,
		62,
		75,
		95,
		86,
		98,
		-1,
		-1,
		-1,
		111,
		97,
		101,
		61,
		80,
		-1,
		-1,
		146,
		101,
		87,
		-1,
		71,
		93,
		81,
		71,
		61,
		95,
		96,
		86,
		87,
		73,
		75,
		73,
		71,
		76,
		97,
		98,
		111,
		-1,
		-1,
		94,
		99,
		87,
		73,
		92,
		-1,
		-1,
		-1,
		93,
		109,
		101,
		72,
		82,
		-1,
		-1,
		73,
		71,
		81,
		87,
		77,
		97,
		100,
		86,
		70,
		85,
		97,
		105,
		110,
		-1,
		97,
		84,
		-1,
		-1,
		95,
		89,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		104,
		125,
		129,
		76,
		-1,
		81,
		82,
		81,
		95,
		102,
		88,
		83,
		77,
		80,
		98,
		115,
		-1,
		-1,
		109,
		-1,
		104,
		-1,
		-1,
		-1,
		-1,
		83,
		97,
		118,
		111,
		115,
		-1,
		90,
		90,
		83,
		100,
		101,
		98,
		89,
		81,
		86,
		83,
		96,
		110,
		114,
		132,
		-1,
		115,
		-1,
		-1,
		-1,
		101,
		116,
		157,
		134,
		107,
		102,
		95,
		89,
		91,
		107,
		109,
		120,
		88,
		84,
		85,
		89,
		88,
		105,
		115,
		-1,
		-1,
		115,
		132,
		127,
		109,
		113,
		184,
		-1,
		-1,
		111,
		102,
		93,
		96,
		101,
		104,
		94,
		91,
		96,
		101,
		89,
		98,
		116,
		120,
		-1,
		-1,
		-1,
		135,
		-1,
		150,
		-1,
		-1,
		128,
		182,
		129,
		111,
		107,
		105,
		98,
		107,
		102,
		99,
		109,
		119,
		111,
		91,
		104,
		126,
		116,
		152,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		164,
		139,
		154,
		193,
		148,
		155,
		144,
		141,
		-1,
		111,
		136,
		108,
		115,
		107,
		117,
		117,
		115,
		94,
		101,
		117,
		116,
		111,
		144,
		138,
		144,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		170,
		156,
		179,
		169,
		165,
		-1,
		-1,
		160,
		157,
		133,
		117,
		121,
		114,
		109,
		123,
		103,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		135,
		150,
		-1,
		142,
		223,
		216,
		199,
		207,
		238,
		-1,
		173,
		175,
		163,
		161,
		163,
		-1,
		-1,
		133,
		130,
		135,
		124,
		121,
		133,
		128,
		119,
		104,
		110,
		97,
		96,
		114,
		118,
		127,
		134,
		124,
		137,
		141,
		-1,
		156,
		199,
		193,
		196,
		220,
		234,
		-1,
		180,
		-1,
		-1,
		171,
		164,
		148,
		138,
		132,
		182,
		138,
		133,
		127,
		125,
		116,
		107,
		114,
		105,
		105,
		108,
		123,
		128,
		120,
		134,
		134,
		135,
		-1,
		191,
		179,
		187,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		187,
		-1,
		175,
		-1,
		150,
		154,
		146,
		149,
		141,
		128,
		120,
		112,
		128,
		103,
		113,
		109,
		110,
		119,
		130,
		142,
		141,
		142,
		252,
		208,
		187,
		178,
		225,
		240,
		244,
		-1,
		192,
		231,
		225,
		-1,
		196,
		-1,
		-1,
		-1,
		164,
		159,
		151,
		161,
		140,
		140,
		114,
		118,
		108,
		115,
		125,
		127,
		119,
		123,
		136,
		147,
		150,
		248,
		239,
		252,
		197,
		192,
		210,
		219,
		240,
		207,
		198,
		225,
		232,
		221,
		216,
		203,
		-1,
		-1,
		187,
		169,
		-1,
		-1,
		147,
		135,
		118,
		119,
		115,
		118,
		133,
		136,
		126,
		124,
		118,
		150,
		-1,
		241,
		240,
		229,
		226,
		202,
		193,
		188,
		211,
		-1,
		-1,
		210,
		226,
		221,
		225,
		241,
		266,
		-1,
		206,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		123,
		134,
		144,
		132,
		133,
		123,
		133,
		146,
		225,
		222,
		210,
		208,
		231,
		196,
		184,
		-1,
		197,
		195,
		201,
		208,
		225,
		255,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		150,
		152,
		141,
		135,
		129,
		136,
		135,
		143,
		151,
		234,
		248,
		237,
		233,
		232,
		240,
		189,
		182,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		209,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		143,
		147,
		139,
		132,
		127,
		138,
		130,
		134,
		151,
		-1,
		268,
		-1,
		220,
		196,
		210,
		225,
		233,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		133,
		144,
		133,
		136,
		150,
		145,
		-1,
		-1,
		208,
		211,
		-1,
		-1,
		220,
		222,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		137,
		143,
		146,
		135,
		139,
		151,
		-1,
		-1,
		215,
		216,
		221,
		-1,
		205,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		166,
		164,
		155,
		141,
		148,
		146,
		142,
		153,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		142,
		168,
		171,
		177,
		171,
		144,
		159,
		149,
		140,
		149,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		193,
		178,
		159,
		146,
		153,
		153,
		146,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		183,
		179,
		166,
		166,
		158,
		-1,
		302,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		159,
		194,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		166,
		167,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		175,
		177,
		143,
		137,
		176,
		147,
		153,
		164,
		-1,
		-1,
		-1,
		166,
		165,
		135,
		133,
		142,
		147,
		154,
		-1,
		158,
		-1,
		187,
		166,
		177,
		182,
		128,
		125,
		145,
		164,
		151,
		143,
		202,
		158,
		129,
		123,
		141,
		136,
		145,
		137,
		-1,
		129,
		119,
		141,
		125,
		136,
		128,
		-1,
		-1,
		123,
		124,
		130,
		121,
		127,
		123,
		-1,
		133,
		117,
		-1,
		-1,
		113,
		119,
		103,
		106,
		114,
		112,
		125,
		117,
		112,
		-1,
		-1,
		109,
		105,
		112,
		99,
		95,
		112,
		125,
		107,
		121,
		120,
		-1,
		102,
		120,
		129,
		106,
		104,
		88,
		86,
		104,
		106,
		112,
		115,
		-1,
		111,
		112,
		107,
		115,
		120,
		104,
		91,
		91,
		101,
		94,
		113,
		104,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		111,
		94,
		111,
		103,
		93,
		108,
		101,
		94,
		91,
		89,
		86,
		102,
		103,
		113,
		-1,
		-1,
		190,
		159,
		194,
		151,
		136,
		-1,
		107,
		87,
		93,
		97,
		91,
		84,
		98,
		94,
		-1,
		80,
		79,
		110,
		96,
		107,
		150,
		-1,
		-1,
		148,
		140,
		125,
		128,
		117,
		113,
		102,
		101,
		93,
		79,
		75,
		81,
		84,
		84,
		90,
		74,
		84,
		88,
		98,
		114,
		-1,
		-1,
		168,
		-1,
		-1,
		147,
		130,
		-1,
		113,
		120,
		120,
		129,
		115,
		136,
		112,
		103,
		95,
		89,
		77,
		79,
		76,
		89,
		77,
		71,
		96,
		100,
		93,
		114,
		109,
		-1,
		167,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		106,
		109,
		115,
		139,
		149,
		-1,
		124,
		112,
		113,
		98,
		95,
		82,
		70,
		83,
		68,
		75,
		74,
		78,
		80,
		113,
		90,
		112,
		109,
		138,
		143,
		137,
		146,
		-1,
		155,
		151,
		147,
		154,
		103,
		-1,
		-1,
		143,
		-1,
		157,
		156,
		131,
		109,
		112,
		99,
		90,
		77,
		66,
		77,
		66,
		63,
		71,
		79,
		91,
		85,
		84,
		102,
		117,
		130,
		134,
		140,
		-1,
		205,
		-1,
		147,
		131,
		133,
		105,
		126,
		-1,
		163,
		158,
		148,
		133,
		124,
		-1,
		108,
		105,
		95,
		73,
		58,
		75,
		67,
		65,
		70,
		74,
		88,
		79,
		97,
		104,
		112,
		116,
		136,
		148,
		165,
		155,
		-1,
		137,
		142,
		101,
		109,
		128,
		166,
		130,
		-1,
		125,
		-1,
		110,
		123,
		-1,
		79,
		75,
		57,
		58,
		53,
		68,
		73,
		70,
		67,
		85,
		88,
		105,
		109,
		125,
		-1,
		-1,
		150,
		154,
		143,
		94,
		113,
		137,
		174,
		123,
		112,
		111,
		-1,
		102,
		93,
		90,
		78,
		65,
		50,
		51,
		59,
		71,
		50,
		69,
		72,
		94,
		122,
		100,
		112,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		120,
		91,
		115,
		157,
		141,
		134,
		122,
		87,
		87,
		81,
		-1,
		89,
		68,
		59,
		48,
		46,
		59,
		51,
		69,
		73,
		73,
		91,
		103,
		94,
		114,
		-1,
		-1,
		-1,
		150,
		139,
		140,
		86,
		109,
		146,
		120,
		106,
		111,
		86,
		79,
		73,
		99,
		85,
		63,
		55,
		47,
		36,
		47,
		55,
		59,
		71,
		80,
		85,
		109,
		107,
		113,
		-1,
		-1,
		157,
		147,
		131,
		133,
		130,
		100,
		107,
		139,
		111,
		124,
		-1,
		78,
		-1,
		67,
		58,
		56,
		49,
		52,
		33,
		38,
		52,
		61,
		76,
		73,
		80,
		114,
		114,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		150,
		145,
		120,
		97,
		81,
		117,
		-1,
		94,
		95,
		-1,
		72,
		66,
		61,
		53,
		54,
		37,
		37,
		38,
		52,
		45,
		64,
		66,
		65,
		101,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		143,
		122,
		115,
		135,
		76,
		128,
		-1,
		-1,
		79,
		72,
		-1,
		59,
		41,
		35,
		27,
		21,
		30,
		32,
		39,
		52,
		57,
		70,
		68,
		90,
		94,
		98,
		87,
		83,
		80,
		94,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		76,
		96,
		-1,
		88,
		80,
		70,
		64,
		58,
		52,
		50,
		49,
		33,
		0,
		36,
		37,
		43,
		46,
		49,
		65,
		67,
		85,
		93,
		85,
		79,
		78,
		90,
		-1,
		163,
		149,
		120,
		-1,
		-1,
		109,
		-1,
		73,
		87,
		103,
		-1,
		96,
		75,
		90,
		68,
		62,
		47,
		30,
		31,
		18,
		19,
		33,
		43,
		71,
		60,
		75,
		67,
		89,
		89,
		73,
		74,
		83,
		-1,
		169,
		156,
		114,
		110,
		99,
		119,
		70,
		58,
		90,
		-1,
		-1,
		132,
		-1,
		66,
		83,
		61,
		59,
		20,
		20,
		26,
		44,
		47,
		57,
		65,
		54,
		60,
		61,
		83,
		69,
		67,
		86,
		102,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		85,
		72,
		66,
		-1,
		107,
		-1,
		110,
		100,
		84,
		69,
		102,
		-1,
		39,
		23,
		28,
		-1,
		82,
		-1,
		73,
		75,
		73,
		58,
		55,
		66,
		64,
		75,
		92,
		-1,
		119,
		104,
		97,
		87,
		101,
		72,
		-1,
		127,
		-1,
		-1,
		97,
		91,
		91,
		75,
		78,
		55,
		35,
		29,
		28,
		81,
		74,
		67,
		71,
		64,
		61,
		58,
		71,
		91,
		82,
		94,
		-1,
		-1,
		-1,
		124,
		110,
		114,
		74,
		93,
		-1,
		-1,
		159,
		114,
		100,
		-1,
		84,
		72,
		60,
		50,
		40,
		74,
		75,
		65,
		70,
		69,
		71,
		69,
		67,
		72,
		93,
		94,
		107,
		-1,
		-1,
		107,
		112,
		100,
		86,
		105,
		-1,
		-1,
		-1,
		106,
		122,
		114,
		85,
		61,
		-1,
		-1,
		52,
		50,
		60,
		66,
		73,
		93,
		96,
		82,
		66,
		81,
		93,
		101,
		106,
		-1,
		110,
		97,
		-1,
		-1,
		108,
		102,
		-1,
		-1,
		-1,
		-1,
		139,
		105,
		109,
		104,
		108,
		55,
		-1,
		60,
		61,
		77,
		91,
		98,
		84,
		79,
		73,
		76,
		94,
		111,
		-1,
		-1,
		122,
		-1,
		117,
		-1,
		-1,
		-1,
		-1,
		96,
		110,
		97,
		90,
		94,
		-1,
		69,
		69,
		79,
		92,
		97,
		94,
		85,
		77,
		82,
		79,
		92,
		106,
		110,
		145,
		-1,
		128,
		-1,
		-1,
		-1,
		114,
		129,
		136,
		113,
		86,
		81,
		74,
		68,
		73,
		93,
		99,
		110,
		84,
		80,
		81,
		85,
		84,
		101,
		111,
		-1,
		-1,
		128,
		145,
		140,
		122,
		126,
		163,
		-1,
		-1,
		90,
		81,
		72,
		75,
		83,
		86,
		90,
		87,
		92,
		97,
		85,
		94,
		112,
		116,
		-1,
		-1,
		-1,
		148,
		-1,
		163,
		-1,
		-1,
		141,
		161,
		108,
		90,
		86,
		84,
		77,
		86,
		81,
		86,
		105,
		106,
		107,
		87,
		100,
		122,
		112,
		148,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		177,
		152,
		166,
		172,
		161,
		165,
		123,
		120,
		-1,
		90,
		115,
		87,
		94,
		86,
		99,
		104,
		110,
		90,
		97,
		113,
		112,
		107,
		140,
		134,
		140,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		172,
		168,
		158,
		148,
		151,
		-1,
		-1,
		139,
		136,
		112,
		96,
		100,
		93,
		88,
		119,
		99,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		155,
		236,
		229,
		212,
		220,
		251,
		-1,
		162,
		154,
		165,
		140,
		142,
		-1,
		-1,
		112,
		109,
		114,
		103,
		100,
		112,
		111,
		115,
		100,
		106,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		169,
		212,
		206,
		209,
		233,
		247,
		-1,
		159,
		-1,
		-1,
		171,
		143,
		127,
		117,
		111,
		161,
		117,
		112,
		114,
		116,
		112,
		103,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		204,
		192,
		200,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		187,
		-1,
		154,
		-1,
		129,
		133,
		125,
		128,
		137,
		124,
		116,
		108,
		124,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		231,
		187,
		190,
		191,
		212,
		227,
		231,
		-1,
		171,
		210,
		225,
		-1,
		196,
		-1,
		-1,
		-1,
		143,
		138,
		130,
		146,
		136,
		136,
		110,
		114,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		186,
		177,
		204,
		230,
		221,
		216,
		203,
		-1,
		-1,
		166,
		148,
		-1,
		-1,
		143,
		131,
		114,
		115,
		111,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		205,
		200,
		204,
		220,
		245,
		-1,
		203,
		-1,
		-1,
		187,
		-1,
		-1,
		173,
		136,
		125,
		116,
		122,
		119,
		130,
		140,
		128,
		129,
		119,
		129,
		142,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		219,
		199,
		-1,
		-1,
		171,
		169,
		158,
		-1,
		148,
		121,
		126,
		146,
		148,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		205,
		-1,
		-1,
		166,
		159,
		147,
		135,
		125,
		135,
		139,
		143,
		135,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		200,
		184,
		165,
		-1,
		135,
		148,
		179,
		147,
		152,
		147,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		212,
		218,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		172,
		168,
		-1,
		-1,
		136,
		161,
		150,
		158,
		153,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		194,
		195,
		200,
		-1,
		201,
		-1,
		219,
		-1,
		186,
		192,
		180,
		-1,
		-1,
		-1,
		174,
		137,
		158,
		168,
		162,
		160,
		151,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		219,
		193,
		226,
		217,
		200,
		180,
		172,
		191,
		-1,
		161,
		-1,
		136,
		138,
		164,
		167,
		173,
		167,
		140,
		155,
		145,
		136,
		145,
		225,
		-1,
		195,
		228,
		192,
		186,
		162,
		166,
		182,
		-1,
		158,
		140,
		-1,
		168,
		158,
		189,
		174,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		182,
		167,
		158,
		-1,
		170,
		152,
		131,
		148,
		148,
		139,
		147,
		179,
		175,
		162,
		162,
		154,
		-1,
		298,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		186,
		159,
		147,
		153,
		149,
		135,
		141,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		155,
		190,
		-1,
		293,
		-1,
		227,
		-1,
		-1,
		209,
		189,
		181,
		170,
		159,
		157,
		148,
		139,
		161,
		177,
		161,
		159,
		162,
		163,
		-1,
		282,
		281,
		-1,
		228,
		220,
		206,
		-1,
		199,
		-1,
		205,
		166,
		-1,
		168,
		148,
		-1,
		170,
		166,
		-1,
		-1,
		269,
		244,
		-1,
		-1,
		-1,
		229,
		209,
		200,
		184,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		254,
		253,
		-1,
		222,
		225,
		-1,
		215,
		206,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		263,
		244,
		238,
		237,
		235,
		230,
		227,
		213,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		235,
		227,
		220,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		246,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		292,
		256,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		164,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		157,
		149,
		208,
		164,
		135,
		129,
		147,
		142,
		151,
		143,
		-1,
		135,
		125,
		147,
		131,
		142,
		134,
		-1,
		-1,
		129,
		130,
		136,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		119,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		108,
		126,
		135,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		121,
		-1,
		117,
		118,
		113,
		121,
		126,
		110,
		97,
		97,
		107,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		117,
		100,
		117,
		109,
		99,
		114,
		107,
		100,
		97,
		95,
		92,
		108,
		109,
		119,
		-1,
		-1,
		196,
		165,
		200,
		157,
		142,
		-1,
		113,
		93,
		99,
		103,
		97,
		90,
		104,
		100,
		-1,
		86,
		85,
		116,
		102,
		113,
		156,
		-1,
		-1,
		154,
		146,
		131,
		134,
		123,
		119,
		108,
		107,
		99,
		85,
		81,
		87,
		90,
		90,
		96,
		80,
		90,
		94,
		97,
		120,
		-1,
		-1,
		157,
		-1,
		-1,
		153,
		136,
		-1,
		119,
		126,
		126,
		135,
		121,
		142,
		118,
		109,
		101,
		95,
		83,
		85,
		82,
		95,
		83,
		77,
		102,
		106,
		92,
		113,
		108,
		-1,
		156,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		115,
		121,
		145,
		155,
		-1,
		130,
		118,
		119,
		104,
		101,
		88,
		76,
		89,
		74,
		81,
		80,
		84,
		84,
		114,
		89,
		111,
		108,
		127,
		132,
		126,
		135,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		149,
		-1,
		163,
		162,
		137,
		115,
		118,
		105,
		96,
		83,
		72,
		83,
		72,
		69,
		77,
		78,
		93,
		84,
		83,
		101,
		111,
		119,
		123,
		129,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		169,
		164,
		154,
		139,
		130,
		-1,
		114,
		111,
		101,
		79,
		64,
		81,
		73,
		71,
		76,
		73,
		87,
		78,
		96,
		103,
		101,
		105,
		125,
		137,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		131,
		-1,
		116,
		129,
		-1,
		85,
		81,
		63,
		64,
		59,
		74,
		72,
		69,
		66,
		84,
		87,
		94,
		98,
		114,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		108,
		97,
		94,
		80,
		67,
		56,
		57,
		57,
		70,
		49,
		68,
		65,
		85,
		111,
		89,
		101,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		91,
		70,
		60,
		54,
		46,
		58,
		50,
		68,
		63,
		61,
		80,
		92,
		83,
		103,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		100,
		87,
		64,
		58,
		45,
		42,
		46,
		54,
		58,
		59,
		68,
		74,
		98,
		105,
		111,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		64,
		58,
		53,
		53,
		31,
		37,
		50,
		60,
		66,
		61,
		68,
		103,
		103,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		67,
		59,
		56,
		36,
		40,
		29,
		49,
		33,
		52,
		54,
		53,
		89,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		65,
		47,
		41,
		33,
		27,
		19,
		20,
		27,
		40,
		45,
		58,
		56,
		86,
		90,
		96,
		85,
		81,
		78,
		92,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		58,
		56,
		55,
		39,
		33,
		0,
		25,
		31,
		34,
		37,
		53,
		63,
		81,
		91,
		83,
		77,
		76,
		88,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		68,
		53,
		62,
		63,
		37,
		24,
		22,
		32,
		59,
		48,
		71,
		65,
		87,
		87,
		71,
		72,
		81,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		67,
		65,
		52,
		39,
		45,
		33,
		36,
		46,
		53,
		42,
		48,
		59,
		81,
		67,
		65,
		84,
		100,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		58,
		42,
		47,
		-1,
		71,
		-1,
		61,
		63,
		61,
		53,
		53,
		64,
		62,
		73,
		90,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		74,
		54,
		48,
		47,
		70,
		78,
		56,
		66,
		59,
		56,
		56,
		69,
		89,
		80,
		92,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		91,
		79,
		69,
		59,
		93,
		90,
		69,
		74,
		64,
		66,
		64,
		65,
		70,
		91,
		92,
		105,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		80,
		-1,
		-1,
		71,
		69,
		79,
		81,
		68,
		88,
		91,
		80,
		64,
		79,
		91,
		99,
		104,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		123,
		121,
		125,
		74,
		-1,
		79,
		80,
		72,
		86,
		93,
		82,
		77,
		71,
		74,
		92,
		109,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		102,
		116,
		114,
		107,
		111,
		-1,
		88,
		88,
		74,
		91,
		95,
		92,
		83,
		75,
		80,
		77,
		90,
		104,
		108,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		120,
		135,
		153,
		130,
		103,
		98,
		91,
		85,
		82,
		98,
		103,
		114,
		82,
		78,
		79,
		83,
		82,
		99,
		109,
		-1,
		-1,
		134,
		151,
		146,
		128,
		132,
		180,
		-1,
		-1,
		107,
		98,
		89,
		92,
		92,
		95,
		88,
		85,
		90,
		95,
		83,
		92,
		110,
		114,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		147,
		178,
		125,
		107,
		103,
		101,
		94,
		103,
		98,
		93,
		103,
		113,
		105,
		85,
		98,
		120,
		110,
		146,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		183,
		158,
		173,
		189,
		167,
		174,
		140,
		137,
		-1,
		107,
		132,
		104,
		111,
		103,
		111,
		111,
		109,
		88,
		95,
		111,
		110,
		105,
		138,
		132,
		138,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		189,
		175,
		175,
		165,
		168,
		-1,
		-1,
		156,
		153,
		129,
		113,
		117,
		110,
		105,
		117,
		97,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		161,
		242,
		235,
		218,
		226,
		257,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		129,
		126,
		131,
		120,
		117,
		127,
		122,
		113,
		98,
		104,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		175,
		218,
		212,
		215,
		239,
		253,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		128,
		178,
		134,
		129,
		121,
		119,
		110,
		101,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		210,
		198,
		206,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		146,
		150,
		142,
		145,
		135,
		122,
		114,
		106,
		122,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		248,
		204,
		206,
		197,
		229,
		244,
		248,
		-1,
		188,
		227,
		234,
		-1,
		213,
		-1,
		-1,
		-1,
		160,
		155,
		147,
		155,
		134,
		134,
		108,
		112,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		244,
		235,
		248,
		193,
		193,
		214,
		223,
		244,
		203,
		194,
		221,
		241,
		230,
		225,
		212,
		-1,
		-1,
		183,
		165,
		-1,
		-1,
		141,
		129,
		112,
		113,
		109,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		184,
		211,
		-1,
		-1,
		206,
		222,
		217,
		221,
		237,
		262,
		-1,
		201,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		117,
		128,
		138,
		126,
		127,
		117,
		127,
		140,
		221,
		218,
		206,
		204,
		227,
		192,
		180,
		-1,
		193,
		191,
		197,
		204,
		221,
		251,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		144,
		146,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		178,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		137,
		141,
		133,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		264,
		-1,
		216,
		192,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		214,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		211,
		212,
		217,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		160,
		158,
		149,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		136,
		162,
		165,
		171,
		165,
		138,
		153,
		143,
		134,
		143,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		187,
		172,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		177,
		173,
		160,
		160,
		152,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		153,
		188,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		160,
		161,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		154,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		147,
		139,
		198,
		154,
		125,
		119,
		137,
		132,
		141,
		133,
		-1,
		125,
		115,
		137,
		121,
		132,
		124,
		-1,
		-1,
		119,
		120,
		126,
		117,
		123,
		119,
		-1,
		129,
		113,
		-1,
		-1,
		109,
		115,
		99,
		102,
		110,
		108,
		121,
		113,
		108,
		-1,
		-1,
		105,
		101,
		108,
		95,
		91,
		108,
		121,
		103,
		117,
		116,
		-1,
		98,
		116,
		125,
		102,
		100,
		84,
		82,
		100,
		102,
		108,
		111,
		-1,
		107,
		108,
		103,
		111,
		116,
		100,
		87,
		87,
		97,
		90,
		109,
		100,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		107,
		90,
		107,
		99,
		89,
		104,
		97,
		90,
		87,
		85,
		82,
		98,
		99,
		109,
		-1,
		-1,
		200,
		169,
		198,
		156,
		137,
		-1,
		103,
		83,
		89,
		93,
		87,
		80,
		94,
		90,
		-1,
		76,
		75,
		106,
		92,
		103,
		160,
		-1,
		-1,
		158,
		150,
		133,
		136,
		113,
		109,
		98,
		97,
		89,
		75,
		71,
		77,
		80,
		80,
		86,
		70,
		80,
		84,
		87,
		110,
		-1,
		-1,
		147,
		-1,
		-1,
		157,
		140,
		-1,
		123,
		130,
		119,
		125,
		111,
		132,
		108,
		99,
		91,
		85,
		73,
		75,
		72,
		85,
		73,
		67,
		92,
		96,
		82,
		103,
		98,
		-1,
		146,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		116,
		119,
		125,
		149,
		148,
		-1,
		120,
		108,
		109,
		94,
		91,
		78,
		66,
		79,
		64,
		71,
		70,
		74,
		74,
		104,
		79,
		101,
		98,
		117,
		122,
		116,
		125,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		153,
		-1,
		156,
		157,
		132,
		105,
		108,
		95,
		86,
		73,
		62,
		73,
		62,
		59,
		67,
		68,
		83,
		74,
		73,
		91,
		101,
		109,
		113,
		119,
		-1,
		215,
		-1,
		157,
		141,
		143,
		115,
		136,
		-1,
		173,
		157,
		149,
		134,
		134,
		-1,
		104,
		101,
		91,
		69,
		54,
		71,
		63,
		61,
		66,
		63,
		77,
		68,
		86,
		93,
		91,
		95,
		115,
		127,
		175,
		165,
		-1,
		147,
		152,
		111,
		119,
		138,
		176,
		140,
		-1,
		135,
		-1,
		106,
		119,
		-1,
		75,
		71,
		53,
		54,
		49,
		64,
		62,
		59,
		56,
		74,
		77,
		84,
		88,
		104,
		-1,
		-1,
		160,
		164,
		153,
		104,
		123,
		147,
		184,
		133,
		122,
		121,
		-1,
		112,
		89,
		86,
		74,
		61,
		46,
		47,
		55,
		60,
		39,
		58,
		55,
		75,
		101,
		79,
		91,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		130,
		101,
		125,
		167,
		151,
		144,
		132,
		97,
		97,
		91,
		-1,
		85,
		64,
		55,
		44,
		42,
		48,
		40,
		58,
		53,
		51,
		70,
		82,
		73,
		93,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		96,
		119,
		156,
		130,
		116,
		121,
		96,
		89,
		83,
		98,
		81,
		62,
		51,
		43,
		32,
		36,
		44,
		48,
		49,
		58,
		64,
		88,
		95,
		101,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		110,
		117,
		149,
		121,
		134,
		-1,
		88,
		-1,
		77,
		69,
		56,
		51,
		48,
		38,
		27,
		40,
		50,
		56,
		51,
		58,
		93,
		93,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		160,
		155,
		130,
		107,
		91,
		127,
		-1,
		104,
		105,
		-1,
		82,
		76,
		72,
		58,
		54,
		43,
		47,
		36,
		39,
		23,
		42,
		44,
		43,
		79,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		86,
		138,
		-1,
		-1,
		89,
		82,
		-1,
		69,
		51,
		46,
		38,
		32,
		22,
		10,
		17,
		28,
		35,
		48,
		46,
		76,
		80,
		86,
		75,
		71,
		68,
		82,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		106,
		-1,
		98,
		90,
		80,
		74,
		68,
		63,
		61,
		60,
		44,
		38,
		19,
		0,
		15,
		24,
		27,
		43,
		53,
		71,
		81,
		73,
		67,
		66,
		78,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		119,
		-1,
		83,
		97,
		113,
		-1,
		106,
		85,
		100,
		78,
		73,
		58,
		57,
		58,
		32,
		19,
		17,
		25,
		49,
		38,
		61,
		55,
		77,
		77,
		61,
		62,
		71,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		80,
		68,
		100,
		-1,
		-1,
		142,
		-1,
		76,
		93,
		72,
		70,
		47,
		34,
		40,
		28,
		29,
		39,
		43,
		32,
		38,
		49,
		71,
		57,
		55,
		74,
		90,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		117,
		-1,
		120,
		110,
		94,
		79,
		112,
		-1,
		53,
		37,
		42,
		-1,
		64,
		-1,
		51,
		53,
		51,
		43,
		43,
		54,
		52,
		63,
		80,
		-1,
		129,
		114,
		107,
		97,
		111,
		82,
		-1,
		137,
		-1,
		-1,
		107,
		101,
		101,
		85,
		88,
		69,
		49,
		43,
		42,
		63,
		71,
		49,
		56,
		49,
		46,
		46,
		59,
		79,
		70,
		82,
		-1,
		-1,
		-1,
		134,
		120,
		124,
		84,
		103,
		-1,
		-1,
		169,
		124,
		110,
		-1,
		94,
		86,
		74,
		64,
		54,
		88,
		83,
		62,
		67,
		54,
		56,
		54,
		55,
		60,
		81,
		82,
		95,
		-1,
		-1,
		117,
		122,
		110,
		96,
		115,
		-1,
		-1,
		-1,
		116,
		132,
		124,
		95,
		75,
		-1,
		-1,
		66,
		64,
		74,
		71,
		58,
		78,
		81,
		70,
		54,
		69,
		81,
		89,
		94,
		-1,
		120,
		107,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		-1,
		-1,
		149,
		115,
		116,
		111,
		115,
		69,
		-1,
		74,
		75,
		62,
		76,
		83,
		72,
		67,
		61,
		64,
		82,
		99,
		-1,
		-1,
		132,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		106,
		120,
		104,
		97,
		101,
		-1,
		83,
		78,
		64,
		81,
		85,
		82,
		73,
		65,
		70,
		67,
		80,
		94,
		98,
		155,
		-1,
		138,
		-1,
		-1,
		-1,
		124,
		139,
		143,
		120,
		93,
		88,
		81,
		75,
		72,
		88,
		93,
		104,
		72,
		68,
		69,
		73,
		72,
		89,
		99,
		-1,
		-1,
		138,
		155,
		150,
		132,
		136,
		170,
		-1,
		-1,
		97,
		88,
		79,
		82,
		82,
		85,
		78,
		75,
		80,
		85,
		73,
		82,
		100,
		104,
		-1,
		-1,
		-1,
		158,
		-1,
		173,
		-1,
		-1,
		151,
		168,
		115,
		97,
		93,
		91,
		84,
		93,
		88,
		83,
		93,
		103,
		95,
		75,
		88,
		110,
		100,
		136,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		186,
		162,
		173,
		179,
		171,
		172,
		130,
		127,
		-1,
		97,
		122,
		94,
		101,
		93,
		101,
		101,
		99,
		78,
		85,
		101,
		100,
		95,
		128,
		122,
		128,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		179,
		175,
		165,
		155,
		158,
		-1,
		-1,
		146,
		143,
		119,
		103,
		107,
		100,
		95,
		107,
		87,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		165,
		246,
		239,
		222,
		230,
		261,
		-1,
		169,
		161,
		172,
		147,
		149,
		-1,
		-1,
		119,
		116,
		121,
		110,
		107,
		117,
		112,
		103,
		88,
		94,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		179,
		222,
		216,
		219,
		243,
		257,
		-1,
		166,
		-1,
		-1,
		178,
		150,
		134,
		124,
		118,
		168,
		124,
		119,
		111,
		109,
		100,
		91,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		213,
		202,
		210,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		194,
		-1,
		161,
		-1,
		136,
		140,
		132,
		135,
		125,
		112,
		104,
		96,
		112,
		87,
		97,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		238,
		194,
		197,
		201,
		219,
		234,
		238,
		-1,
		178,
		217,
		224,
		-1,
		203,
		-1,
		-1,
		-1,
		150,
		145,
		137,
		145,
		124,
		124,
		98,
		102,
		92,
		99,
		109,
		111,
		103,
		107,
		120,
		131,
		134,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		193,
		184,
		211,
		231,
		220,
		215,
		202,
		-1,
		-1,
		173,
		155,
		-1,
		-1,
		131,
		119,
		102,
		103,
		99,
		102,
		117,
		120,
		110,
		108,
		102,
		134,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		212,
		207,
		211,
		227,
		252,
		-1,
		191,
		-1,
		-1,
		176,
		-1,
		-1,
		161,
		124,
		113,
		104,
		110,
		107,
		118,
		128,
		116,
		117,
		107,
		117,
		130,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		241,
		-1,
		-1,
		207,
		187,
		-1,
		-1,
		159,
		157,
		146,
		-1,
		136,
		109,
		114,
		134,
		136,
		125,
		119,
		113,
		120,
		119,
		127,
		135,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		197,
		193,
		-1,
		-1,
		154,
		147,
		135,
		123,
		113,
		123,
		127,
		131,
		123,
		116,
		111,
		122,
		114,
		118,
		135,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		214,
		200,
		193,
		181,
		179,
		-1,
		188,
		172,
		153,
		-1,
		123,
		136,
		167,
		135,
		140,
		135,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		194,
		197,
		-1,
		-1,
		204,
		206,
		-1,
		205,
		194,
		179,
		171,
		-1,
		-1,
		160,
		156,
		-1,
		-1,
		124,
		149,
		138,
		146,
		141,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		201,
		202,
		207,
		-1,
		189,
		-1,
		207,
		-1,
		174,
		180,
		168,
		-1,
		-1,
		-1,
		162,
		125,
		146,
		156,
		150,
		148,
		139,
		125,
		132,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		207,
		181,
		214,
		205,
		188,
		168,
		160,
		179,
		-1,
		149,
		-1,
		124,
		126,
		152,
		155,
		161,
		155,
		128,
		143,
		133,
		124,
		133,
		213,
		-1,
		183,
		216,
		180,
		174,
		150,
		154,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		177,
		162,
		143,
		130,
		137,
		137,
		130,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		170,
		155,
		146,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		167,
		163,
		150,
		150,
		142,
		-1,
		286,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		174,
		147,
		135,
		141,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		143,
		178,
		-1,
		281,
		-1,
		215,
		-1,
		-1,
		197,
		177,
		169,
		158,
		147,
		145,
		136,
		127,
		149,
		165,
		149,
		147,
		150,
		151,
		-1,
		270,
		269,
		-1,
		216,
		208,
		194,
		-1,
		187,
		-1,
		193,
		154,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		257,
		232,
		-1,
		-1,
		-1,
		217,
		197,
		188,
		172,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		242,
		241,
		-1,
		210,
		213,
		-1,
		203,
		194,
		202,
		149,
		153,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		225,
		223,
		218,
		215,
		201,
		185,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		223,
		215,
		208,
		-1,
		-1,
		210,
		193,
		174,
		172,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		200,
		-1,
		-1,
		206,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		234,
		-1,
		-1,
		-1,
		196,
		192,
		193,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		280,
		244,
		-1,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		216,
		200,
		-1,
		186,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		221,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		234,
		226,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		211,
		218,
		240,
		243,
		279,
		-1,
		230
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		179,
		181,
		147,
		141,
		180,
		151,
		157,
		168,
		-1,
		-1,
		-1,
		170,
		169,
		139,
		137,
		146,
		151,
		158,
		-1,
		162,
		-1,
		191,
		170,
		181,
		186,
		132,
		129,
		149,
		168,
		155,
		147,
		206,
		162,
		133,
		127,
		145,
		140,
		149,
		141,
		-1,
		133,
		123,
		145,
		129,
		140,
		132,
		-1,
		-1,
		127,
		128,
		134,
		125,
		131,
		127,
		-1,
		137,
		121,
		-1,
		-1,
		117,
		123,
		107,
		110,
		118,
		116,
		129,
		121,
		116,
		-1,
		-1,
		113,
		109,
		116,
		103,
		99,
		116,
		129,
		111,
		125,
		124,
		-1,
		106,
		124,
		133,
		110,
		108,
		92,
		90,
		108,
		110,
		116,
		119,
		-1,
		115,
		116,
		111,
		119,
		124,
		108,
		95,
		95,
		105,
		98,
		117,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		115,
		98,
		115,
		107,
		97,
		112,
		105,
		98,
		95,
		93,
		90,
		106,
		107,
		117,
		-1,
		-1,
		208,
		177,
		206,
		164,
		145,
		-1,
		111,
		91,
		97,
		101,
		95,
		88,
		102,
		98,
		-1,
		84,
		83,
		114,
		100,
		111,
		168,
		-1,
		-1,
		166,
		158,
		141,
		144,
		121,
		117,
		106,
		105,
		97,
		83,
		79,
		85,
		88,
		88,
		94,
		78,
		88,
		92,
		95,
		118,
		-1,
		-1,
		155,
		-1,
		-1,
		165,
		148,
		-1,
		131,
		138,
		127,
		133,
		119,
		140,
		116,
		107,
		99,
		93,
		81,
		83,
		80,
		93,
		81,
		75,
		100,
		104,
		90,
		111,
		106,
		-1,
		154,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		124,
		127,
		133,
		157,
		156,
		-1,
		128,
		116,
		117,
		102,
		99,
		86,
		74,
		87,
		72,
		79,
		78,
		82,
		82,
		112,
		87,
		109,
		106,
		125,
		130,
		124,
		133,
		-1,
		173,
		169,
		165,
		172,
		121,
		-1,
		-1,
		161,
		-1,
		164,
		165,
		140,
		113,
		116,
		103,
		94,
		81,
		70,
		81,
		70,
		67,
		75,
		76,
		91,
		82,
		81,
		99,
		109,
		117,
		121,
		127,
		-1,
		223,
		-1,
		165,
		149,
		151,
		123,
		144,
		-1,
		181,
		165,
		157,
		142,
		142,
		-1,
		112,
		109,
		99,
		77,
		62,
		79,
		71,
		69,
		74,
		71,
		85,
		76,
		94,
		101,
		99,
		103,
		123,
		135,
		183,
		173,
		-1,
		155,
		160,
		119,
		127,
		146,
		184,
		148,
		-1,
		143,
		-1,
		114,
		127,
		-1,
		83,
		79,
		61,
		62,
		57,
		72,
		70,
		67,
		64,
		82,
		85,
		92,
		96,
		112,
		-1,
		-1,
		168,
		172,
		161,
		112,
		131,
		155,
		192,
		141,
		130,
		129,
		-1,
		120,
		97,
		94,
		82,
		69,
		54,
		55,
		63,
		68,
		47,
		66,
		63,
		83,
		109,
		87,
		99,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		138,
		109,
		133,
		175,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		93,
		72,
		63,
		52,
		50,
		56,
		48,
		66,
		61,
		59,
		78,
		90,
		81,
		101,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		138,
		124,
		129,
		104,
		97,
		91,
		106,
		89,
		70,
		59,
		51,
		40,
		44,
		52,
		56,
		57,
		66,
		72,
		96,
		103,
		109,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		77,
		64,
		59,
		56,
		46,
		35,
		48,
		58,
		64,
		59,
		66,
		101,
		101,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		80,
		66,
		62,
		51,
		55,
		44,
		47,
		31,
		50,
		52,
		51,
		87,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		54,
		46,
		40,
		30,
		18,
		25,
		38,
		43,
		56,
		54,
		84,
		88,
		94,
		83,
		79,
		76,
		90,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		71,
		69,
		68,
		52,
		46,
		27,
		17,
		0,
		32,
		35,
		51,
		61,
		79,
		89,
		81,
		75,
		74,
		86,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		81,
		66,
		65,
		66,
		40,
		27,
		11,
		10,
		39,
		46,
		69,
		63,
		85,
		85,
		69,
		70,
		79,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		80,
		78,
		55,
		42,
		42,
		23,
		14,
		24,
		51,
		40,
		46,
		57,
		79,
		65,
		63,
		82,
		98,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		61,
		45,
		50,
		-1,
		49,
		-1,
		41,
		54,
		54,
		51,
		51,
		62,
		60,
		71,
		88,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		77,
		57,
		51,
		50,
		48,
		56,
		34,
		61,
		57,
		54,
		54,
		67,
		87,
		78,
		90,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		94,
		82,
		72,
		62,
		80,
		68,
		47,
		52,
		61,
		64,
		62,
		63,
		68,
		89,
		90,
		103,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		83,
		-1,
		-1,
		74,
		72,
		60,
		61,
		65,
		77,
		84,
		78,
		62,
		77,
		89,
		97,
		102,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		115,
		110,
		114,
		77,
		-1,
		66,
		67,
		69,
		75,
		82,
		80,
		75,
		69,
		72,
		90,
		107,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		103,
		96,
		100,
		-1,
		75,
		75,
		71,
		87,
		93,
		90,
		81,
		73,
		78,
		75,
		88,
		102,
		106,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		142,
		119,
		92,
		87,
		80,
		74,
		79,
		95,
		101,
		112,
		80,
		76,
		77,
		81,
		80,
		97,
		107,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		169,
		-1,
		-1,
		96,
		87,
		78,
		81,
		89,
		92,
		86,
		83,
		88,
		93,
		81,
		90,
		108,
		112,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		167,
		114,
		96,
		92,
		90,
		83,
		92,
		87,
		91,
		101,
		111,
		103,
		83,
		96,
		118,
		108,
		144,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		185,
		170,
		172,
		178,
		179,
		171,
		129,
		126,
		-1,
		96,
		121,
		93,
		100,
		92,
		105,
		109,
		107,
		86,
		93,
		109,
		108,
		103,
		136,
		130,
		136,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		118,
		102,
		106,
		99,
		94,
		115,
		95,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		173,
		254,
		247,
		228,
		236,
		267,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		109,
		106,
		118,
		117,
		111,
		96,
		102,
		89,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		187,
		230,
		222,
		225,
		249,
		263,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		117,
		167,
		123,
		118,
		119,
		117,
		108,
		99,
		106,
		97,
		97,
		100,
		115,
		120,
		112,
		126,
		126,
		127,
		-1,
		212,
		210,
		216,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		135,
		139,
		131,
		134,
		133,
		120,
		112,
		104,
		120,
		95,
		105,
		101,
		102,
		111,
		122,
		134,
		133,
		134,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		177,
		216,
		231,
		-1,
		202,
		-1,
		-1,
		-1,
		149,
		144,
		136,
		152,
		132,
		132,
		106,
		110,
		100,
		107,
		117,
		119,
		111,
		115,
		128,
		139,
		142,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		192,
		183,
		210,
		236,
		227,
		222,
		209,
		-1,
		-1,
		172,
		154,
		-1,
		-1,
		139,
		127,
		110,
		111,
		107,
		110,
		125,
		128,
		118,
		116,
		110,
		142,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		211,
		206,
		210,
		226,
		251,
		-1,
		199,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		115,
		126,
		136,
		124,
		125,
		115,
		125,
		138,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		215,
		195,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		117,
		122,
		142,
		144,
		133,
		127,
		121,
		128,
		127,
		135,
		143,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		205,
		201,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		135,
		139,
		131,
		124,
		119,
		130,
		122,
		126,
		143,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		222,
		208,
		201,
		189,
		187,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		125,
		136,
		125,
		128,
		142,
		137,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		212,
		214,
		-1,
		213,
		202,
		187,
		179,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		129,
		135,
		138,
		127,
		131,
		143,
		-1,
		-1,
		200,
		201,
		206,
		-1,
		197,
		-1,
		215,
		-1,
		182,
		188,
		176,
		-1,
		-1,
		-1,
		170,
		133,
		154,
		164,
		158,
		156,
		147,
		133,
		140,
		138,
		134,
		145,
		-1,
		-1,
		-1,
		215,
		189,
		222,
		213,
		196,
		176,
		168,
		187,
		-1,
		157,
		-1,
		132,
		134,
		160,
		163,
		169,
		163,
		136,
		151,
		141,
		132,
		141,
		221,
		-1,
		191,
		224,
		188,
		182,
		158,
		162,
		178,
		-1,
		154,
		136,
		-1,
		164,
		154,
		185,
		170,
		151,
		138,
		145,
		145,
		138,
		-1,
		-1,
		-1,
		193,
		192,
		184,
		178,
		178,
		163,
		154,
		-1,
		166,
		148,
		127,
		144,
		144,
		135,
		143,
		175,
		171,
		158,
		158,
		150,
		-1,
		294,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		187,
		182,
		155,
		143,
		149,
		145,
		131,
		137,
		139,
		147,
		145,
		142,
		154,
		150,
		170,
		151,
		186,
		-1,
		289,
		-1,
		223,
		-1,
		-1,
		205,
		185,
		177,
		166,
		155,
		153,
		144,
		135,
		157,
		173,
		157,
		155,
		158,
		159,
		-1,
		278,
		277,
		-1,
		224,
		216,
		202,
		-1,
		195,
		-1,
		201,
		162,
		-1,
		164,
		144,
		-1,
		166,
		162,
		-1,
		-1,
		265,
		240,
		-1,
		-1,
		-1,
		225,
		205,
		196,
		180,
		-1,
		155,
		155,
		-1,
		-1,
		-1,
		250,
		249,
		-1,
		218,
		221,
		-1,
		211,
		202,
		210,
		157,
		161,
		-1,
		-1,
		-1,
		259,
		240,
		234,
		233,
		231,
		226,
		223,
		209,
		193,
		171,
		160,
		181,
		-1,
		-1,
		-1,
		231,
		223,
		216,
		-1,
		-1,
		218,
		201,
		182,
		180,
		-1,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		208,
		-1,
		-1,
		214,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		242,
		-1,
		-1,
		-1,
		204,
		200,
		201,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		288,
		252,
		-1,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		267,
		265,
		-1,
		-1,
		-1,
		224,
		208,
		-1,
		194,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		229,
		-1,
		229,
		204,
		211,
		-1,
		-1,
		-1,
		-1,
		242,
		234,
		242,
		-1,
		214,
		216,
		-1,
		264,
		-1,
		-1,
		257,
		248,
		-1,
		-1,
		219,
		226,
		248,
		251,
		287,
		-1,
		238
	],
	[
		-1,
		151,
		140,
		151,
		159,
		132,
		139,
		-1,
		160,
		162,
		128,
		122,
		161,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		151,
		150,
		120,
		118,
		127,
		132,
		139,
		-1,
		143,
		-1,
		172,
		151,
		162,
		167,
		113,
		110,
		130,
		149,
		136,
		128,
		187,
		143,
		114,
		108,
		126,
		121,
		130,
		122,
		-1,
		114,
		104,
		126,
		110,
		121,
		113,
		-1,
		-1,
		108,
		109,
		115,
		106,
		112,
		108,
		-1,
		118,
		102,
		-1,
		-1,
		98,
		104,
		88,
		91,
		99,
		97,
		110,
		102,
		97,
		-1,
		-1,
		94,
		90,
		97,
		84,
		80,
		97,
		110,
		92,
		106,
		105,
		-1,
		87,
		105,
		114,
		91,
		89,
		73,
		71,
		89,
		91,
		97,
		100,
		-1,
		96,
		97,
		92,
		100,
		105,
		89,
		76,
		76,
		86,
		79,
		98,
		89,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		96,
		79,
		96,
		88,
		78,
		93,
		86,
		79,
		76,
		74,
		71,
		87,
		88,
		98,
		-1,
		-1,
		189,
		158,
		187,
		145,
		126,
		-1,
		92,
		72,
		78,
		82,
		76,
		69,
		83,
		79,
		-1,
		65,
		64,
		95,
		81,
		92,
		149,
		-1,
		-1,
		147,
		139,
		122,
		125,
		102,
		98,
		87,
		86,
		78,
		64,
		60,
		66,
		69,
		69,
		75,
		59,
		69,
		73,
		76,
		99,
		-1,
		-1,
		136,
		-1,
		-1,
		146,
		129,
		-1,
		112,
		119,
		108,
		114,
		100,
		121,
		97,
		88,
		80,
		74,
		62,
		64,
		61,
		74,
		62,
		56,
		81,
		85,
		71,
		92,
		87,
		-1,
		135,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		105,
		108,
		114,
		138,
		137,
		-1,
		109,
		97,
		98,
		83,
		80,
		67,
		55,
		68,
		53,
		60,
		59,
		63,
		63,
		93,
		68,
		90,
		87,
		106,
		111,
		105,
		114,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		142,
		-1,
		145,
		146,
		121,
		94,
		97,
		84,
		75,
		62,
		51,
		62,
		51,
		48,
		56,
		57,
		72,
		63,
		62,
		80,
		90,
		98,
		102,
		108,
		-1,
		204,
		-1,
		146,
		130,
		132,
		104,
		125,
		-1,
		162,
		146,
		138,
		123,
		123,
		-1,
		93,
		90,
		80,
		58,
		43,
		60,
		52,
		50,
		55,
		52,
		66,
		57,
		75,
		82,
		80,
		84,
		104,
		116,
		164,
		154,
		-1,
		136,
		141,
		100,
		108,
		127,
		165,
		129,
		-1,
		124,
		-1,
		95,
		108,
		-1,
		64,
		60,
		42,
		43,
		38,
		53,
		51,
		48,
		45,
		63,
		66,
		73,
		77,
		93,
		-1,
		-1,
		149,
		153,
		142,
		93,
		112,
		136,
		173,
		122,
		111,
		110,
		-1,
		101,
		78,
		75,
		63,
		50,
		35,
		36,
		44,
		49,
		28,
		47,
		44,
		64,
		90,
		68,
		80,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		119,
		90,
		114,
		156,
		140,
		133,
		121,
		86,
		86,
		80,
		-1,
		74,
		53,
		44,
		33,
		31,
		37,
		29,
		47,
		42,
		40,
		59,
		71,
		62,
		82,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		85,
		108,
		145,
		119,
		105,
		110,
		85,
		78,
		72,
		87,
		70,
		51,
		40,
		32,
		21,
		25,
		33,
		37,
		38,
		47,
		53,
		77,
		77,
		83,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		99,
		106,
		138,
		110,
		123,
		-1,
		77,
		-1,
		66,
		61,
		45,
		40,
		37,
		29,
		16,
		29,
		39,
		41,
		40,
		43,
		82,
		82,
		67,
		87,
		90,
		-1,
		-1,
		-1,
		149,
		144,
		119,
		96,
		80,
		116,
		-1,
		93,
		94,
		-1,
		71,
		65,
		62,
		47,
		43,
		33,
		37,
		31,
		28,
		12,
		31,
		33,
		32,
		68,
		-1,
		75,
		69,
		77,
		67,
		55,
		-1,
		-1,
		-1,
		142,
		121,
		114,
		134,
		75,
		127,
		-1,
		-1,
		78,
		71,
		-1,
		58,
		40,
		45,
		40,
		39,
		29,
		17,
		6,
		19,
		11,
		31,
		28,
		58,
		62,
		68,
		57,
		53,
		50,
		64,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		95,
		-1,
		87,
		79,
		69,
		63,
		57,
		53,
		51,
		67,
		51,
		45,
		29,
		20,
		28,
		0,
		9,
		25,
		35,
		53,
		63,
		55,
		49,
		48,
		60,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		108,
		-1,
		72,
		86,
		102,
		-1,
		95,
		74,
		89,
		67,
		63,
		57,
		67,
		68,
		41,
		29,
		27,
		37,
		31,
		20,
		43,
		37,
		59,
		59,
		43,
		44,
		53,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		69,
		57,
		89,
		-1,
		-1,
		131,
		-1,
		65,
		82,
		71,
		69,
		57,
		43,
		49,
		38,
		40,
		35,
		25,
		14,
		20,
		31,
		53,
		39,
		37,
		56,
		72,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		109,
		99,
		83,
		68,
		101,
		-1,
		60,
		44,
		49,
		-1,
		60,
		-1,
		33,
		35,
		33,
		25,
		25,
		36,
		34,
		45,
		62,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		126,
		-1,
		-1,
		96,
		90,
		90,
		74,
		77,
		76,
		56,
		50,
		49,
		55,
		63,
		41,
		38,
		31,
		28,
		28,
		41,
		61,
		52,
		64,
		-1,
		-1,
		-1,
		123,
		109,
		113,
		73,
		92,
		-1,
		-1,
		158,
		113,
		99,
		-1,
		83,
		93,
		81,
		71,
		61,
		87,
		75,
		54,
		50,
		36,
		38,
		36,
		37,
		42,
		63,
		64,
		77,
		-1,
		-1,
		106,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		105,
		121,
		113,
		84,
		82,
		-1,
		-1,
		73,
		71,
		67,
		53,
		40,
		60,
		63,
		52,
		36,
		51,
		63,
		71,
		76,
		-1,
		109,
		96,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		98,
		93,
		97,
		76,
		-1,
		69,
		64,
		44,
		58,
		65,
		54,
		49,
		43,
		46,
		64,
		81,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		95,
		109,
		86,
		79,
		83,
		-1,
		71,
		60,
		46,
		63,
		67,
		64,
		55,
		47,
		52,
		49,
		62,
		76,
		80,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		113,
		128,
		125,
		102,
		75,
		70,
		63,
		57,
		54,
		70,
		75,
		86,
		54,
		50,
		51,
		55,
		54,
		71,
		81,
		-1,
		-1,
		127,
		144,
		139,
		121,
		125,
		152,
		-1,
		-1,
		79,
		70,
		61,
		64,
		64,
		67,
		60,
		57,
		62,
		67,
		55,
		64,
		82,
		86,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		140,
		150,
		97,
		79,
		75,
		73,
		66,
		75,
		70,
		65,
		75,
		85,
		77,
		57,
		70,
		92,
		82,
		118,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		168,
		151,
		155,
		161,
		160,
		154,
		112,
		109,
		-1,
		79,
		104,
		76,
		83,
		75,
		83,
		83,
		81,
		60,
		67,
		83,
		82,
		77,
		110,
		104,
		110,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		128,
		125,
		101,
		85,
		89,
		82,
		77,
		89,
		69,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		116,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		101,
		98,
		103,
		92,
		89,
		99,
		94,
		85,
		70,
		76,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		148,
		-1,
		-1,
		160,
		132,
		116,
		106,
		100,
		150,
		106,
		101,
		93,
		91,
		82,
		73,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		195,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		176,
		-1,
		143,
		-1,
		118,
		122,
		114,
		117,
		107,
		94,
		86,
		78,
		94,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		160,
		199,
		206,
		-1,
		185,
		-1,
		-1,
		-1,
		132,
		127,
		119,
		127,
		106,
		106,
		80,
		84,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		175,
		166,
		193,
		213,
		202,
		197,
		184,
		-1,
		-1,
		155,
		137,
		-1,
		-1,
		113,
		101,
		84,
		85,
		81,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		194,
		189,
		193,
		209,
		234,
		-1,
		173,
		-1,
		-1,
		158,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		89,
		100,
		110,
		98,
		99,
		89,
		99,
		112,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		223,
		-1,
		-1,
		189,
		169,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		116,
		118,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		179,
		175,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		109,
		113,
		105,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		196,
		182,
		175,
		163,
		161,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		176,
		179,
		-1,
		-1,
		186,
		188,
		-1,
		187,
		176,
		161,
		153,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		183,
		184,
		189,
		-1,
		171,
		-1,
		189,
		-1,
		156,
		162,
		150,
		-1,
		-1,
		-1,
		144,
		107,
		128,
		138,
		132,
		130,
		121,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		189,
		163,
		196,
		187,
		170,
		150,
		142,
		161,
		-1,
		131,
		-1,
		106,
		108,
		134,
		137,
		143,
		137,
		110,
		125,
		115,
		106,
		115,
		195,
		-1,
		165,
		198,
		162,
		156,
		132,
		136,
		152,
		-1,
		128,
		110,
		-1,
		138,
		128,
		159,
		144,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		167,
		166,
		158,
		152,
		152,
		137,
		128,
		-1,
		140,
		122,
		101,
		118,
		118,
		109,
		117,
		149,
		145,
		132,
		132,
		124,
		-1,
		268,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		161,
		156,
		129,
		117,
		123,
		119,
		105,
		111,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		125,
		160,
		-1,
		263,
		-1,
		197,
		-1,
		-1,
		179,
		159,
		151,
		140,
		129,
		127,
		118,
		109,
		131,
		147,
		131,
		129,
		132,
		133,
		-1,
		252,
		251,
		-1,
		198,
		190,
		176,
		-1,
		169,
		-1,
		175,
		136,
		-1,
		138,
		118,
		-1,
		140,
		136,
		-1,
		-1,
		239,
		214,
		-1,
		-1,
		-1,
		199,
		179,
		170,
		154,
		-1,
		129,
		129,
		-1,
		-1,
		-1,
		224,
		223,
		-1,
		192,
		195,
		-1,
		185,
		176,
		184,
		131,
		135,
		-1,
		-1,
		-1,
		233,
		214,
		208,
		207,
		205,
		200,
		197,
		183,
		167,
		145,
		134,
		155,
		-1,
		-1,
		-1,
		205,
		197,
		190,
		-1,
		-1,
		192,
		175,
		156,
		154,
		-1,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		182,
		-1,
		-1,
		188,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		216,
		-1,
		-1,
		-1,
		178,
		174,
		175,
		-1,
		-1,
		-1,
		-1,
		238,
		239,
		262,
		226,
		-1,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		241,
		239,
		-1,
		-1,
		-1,
		198,
		182,
		-1,
		168,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		203,
		-1,
		203,
		178,
		185,
		-1,
		-1,
		-1,
		-1,
		216,
		208,
		216,
		-1,
		188,
		190,
		-1,
		238,
		-1,
		-1,
		231,
		222,
		-1,
		-1,
		193,
		200,
		222,
		225,
		261,
		-1,
		212
	],
	[
		-1,
		157,
		146,
		157,
		165,
		138,
		145,
		-1,
		165,
		168,
		134,
		128,
		167,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		157,
		156,
		125,
		123,
		132,
		137,
		144,
		-1,
		143,
		-1,
		178,
		157,
		168,
		173,
		118,
		115,
		135,
		154,
		136,
		128,
		193,
		148,
		119,
		113,
		131,
		121,
		130,
		122,
		-1,
		119,
		109,
		131,
		110,
		121,
		113,
		-1,
		-1,
		113,
		114,
		120,
		106,
		112,
		108,
		-1,
		118,
		102,
		-1,
		-1,
		103,
		104,
		88,
		91,
		99,
		97,
		110,
		102,
		97,
		-1,
		-1,
		94,
		90,
		97,
		84,
		80,
		97,
		110,
		92,
		106,
		105,
		-1,
		93,
		111,
		120,
		91,
		89,
		73,
		71,
		89,
		91,
		97,
		97,
		-1,
		102,
		103,
		98,
		106,
		111,
		89,
		76,
		76,
		86,
		79,
		98,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		85,
		102,
		94,
		84,
		99,
		92,
		79,
		76,
		74,
		71,
		87,
		85,
		95,
		-1,
		-1,
		195,
		164,
		193,
		151,
		132,
		-1,
		98,
		78,
		84,
		88,
		82,
		75,
		89,
		85,
		-1,
		65,
		64,
		92,
		78,
		89,
		155,
		-1,
		-1,
		153,
		145,
		128,
		131,
		108,
		104,
		93,
		92,
		84,
		70,
		66,
		72,
		75,
		75,
		81,
		59,
		69,
		73,
		71,
		96,
		-1,
		-1,
		131,
		-1,
		-1,
		152,
		135,
		-1,
		118,
		125,
		114,
		120,
		106,
		127,
		103,
		94,
		86,
		80,
		68,
		70,
		67,
		80,
		68,
		56,
		81,
		85,
		66,
		87,
		82,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		111,
		114,
		120,
		144,
		143,
		-1,
		115,
		103,
		104,
		89,
		86,
		73,
		61,
		74,
		59,
		66,
		65,
		60,
		58,
		88,
		63,
		85,
		82,
		101,
		106,
		100,
		109,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		148,
		-1,
		151,
		152,
		127,
		100,
		103,
		90,
		81,
		68,
		57,
		68,
		57,
		54,
		62,
		52,
		67,
		58,
		57,
		75,
		85,
		93,
		97,
		103,
		-1,
		210,
		-1,
		152,
		136,
		138,
		110,
		131,
		-1,
		168,
		152,
		144,
		129,
		129,
		-1,
		99,
		96,
		86,
		64,
		49,
		66,
		58,
		56,
		61,
		47,
		61,
		52,
		70,
		77,
		75,
		79,
		99,
		111,
		170,
		160,
		-1,
		142,
		147,
		106,
		114,
		133,
		171,
		135,
		-1,
		130,
		-1,
		101,
		114,
		-1,
		70,
		66,
		48,
		49,
		44,
		59,
		57,
		43,
		40,
		58,
		61,
		68,
		72,
		88,
		-1,
		-1,
		155,
		159,
		148,
		99,
		118,
		142,
		179,
		128,
		117,
		116,
		-1,
		107,
		84,
		81,
		69,
		56,
		41,
		42,
		50,
		55,
		34,
		42,
		39,
		59,
		85,
		63,
		75,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		125,
		96,
		120,
		162,
		146,
		139,
		127,
		92,
		92,
		86,
		-1,
		80,
		59,
		50,
		39,
		37,
		43,
		35,
		52,
		37,
		35,
		54,
		66,
		57,
		77,
		-1,
		-1,
		-1,
		155,
		144,
		145,
		91,
		114,
		151,
		125,
		111,
		116,
		91,
		84,
		78,
		93,
		76,
		57,
		46,
		38,
		27,
		31,
		39,
		43,
		33,
		42,
		48,
		72,
		68,
		74,
		-1,
		-1,
		162,
		152,
		136,
		138,
		135,
		105,
		112,
		144,
		116,
		129,
		-1,
		83,
		-1,
		72,
		67,
		51,
		46,
		43,
		35,
		22,
		35,
		45,
		32,
		34,
		34,
		77,
		77,
		58,
		78,
		81,
		-1,
		-1,
		-1,
		155,
		150,
		125,
		102,
		86,
		122,
		-1,
		99,
		100,
		-1,
		77,
		71,
		68,
		53,
		49,
		39,
		43,
		37,
		34,
		18,
		36,
		26,
		27,
		61,
		-1,
		66,
		60,
		68,
		58,
		46,
		-1,
		-1,
		-1,
		148,
		127,
		120,
		140,
		81,
		133,
		-1,
		-1,
		84,
		77,
		-1,
		64,
		46,
		51,
		46,
		45,
		35,
		23,
		12,
		25,
		18,
		22,
		19,
		49,
		53,
		59,
		48,
		44,
		41,
		55,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		101,
		-1,
		93,
		85,
		75,
		69,
		63,
		59,
		57,
		73,
		57,
		51,
		35,
		26,
		34,
		7,
		0,
		16,
		26,
		44,
		54,
		46,
		40,
		39,
		51,
		-1,
		168,
		154,
		125,
		-1,
		-1,
		114,
		-1,
		78,
		92,
		108,
		-1,
		101,
		80,
		95,
		73,
		69,
		63,
		73,
		74,
		47,
		35,
		33,
		34,
		22,
		11,
		34,
		28,
		50,
		50,
		34,
		35,
		44,
		-1,
		174,
		161,
		119,
		115,
		104,
		124,
		75,
		63,
		95,
		-1,
		-1,
		137,
		-1,
		71,
		88,
		77,
		75,
		63,
		49,
		55,
		44,
		31,
		26,
		16,
		5,
		11,
		22,
		44,
		30,
		28,
		47,
		63,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		90,
		77,
		71,
		-1,
		112,
		-1,
		115,
		105,
		89,
		74,
		107,
		-1,
		66,
		50,
		55,
		-1,
		51,
		-1,
		24,
		26,
		24,
		16,
		16,
		27,
		25,
		36,
		53,
		-1,
		124,
		109,
		102,
		92,
		106,
		77,
		-1,
		132,
		-1,
		-1,
		102,
		96,
		96,
		80,
		83,
		82,
		62,
		56,
		55,
		46,
		54,
		32,
		29,
		22,
		19,
		19,
		32,
		52,
		43,
		55,
		-1,
		-1,
		-1,
		129,
		115,
		119,
		79,
		98,
		-1,
		-1,
		164,
		119,
		105,
		-1,
		89,
		99,
		87,
		77,
		67,
		78,
		66,
		45,
		41,
		27,
		29,
		27,
		28,
		33,
		54,
		55,
		68,
		-1,
		-1,
		112,
		117,
		105,
		91,
		110,
		-1,
		-1,
		-1,
		111,
		127,
		119,
		90,
		88,
		-1,
		-1,
		77,
		70,
		58,
		44,
		31,
		51,
		54,
		43,
		27,
		42,
		54,
		62,
		67,
		-1,
		115,
		102,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		-1,
		-1,
		144,
		100,
		89,
		84,
		88,
		76,
		-1,
		60,
		55,
		35,
		49,
		56,
		45,
		40,
		34,
		37,
		55,
		72,
		-1,
		-1,
		127,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		101,
		106,
		77,
		70,
		74,
		-1,
		62,
		51,
		37,
		54,
		58,
		55,
		46,
		38,
		43,
		40,
		53,
		67,
		71,
		150,
		-1,
		133,
		-1,
		-1,
		-1,
		119,
		134,
		116,
		93,
		66,
		61,
		54,
		48,
		45,
		61,
		66,
		77,
		45,
		41,
		42,
		46,
		45,
		62,
		72,
		-1,
		-1,
		133,
		150,
		145,
		127,
		131,
		143,
		-1,
		-1,
		70,
		61,
		52,
		55,
		55,
		58,
		51,
		48,
		53,
		58,
		46,
		55,
		73,
		77,
		-1,
		-1,
		-1,
		153,
		-1,
		168,
		-1,
		-1,
		146,
		141,
		88,
		70,
		66,
		64,
		57,
		66,
		61,
		56,
		66,
		76,
		68,
		48,
		61,
		83,
		73,
		109,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		159,
		151,
		146,
		152,
		154,
		145,
		103,
		100,
		-1,
		70,
		95,
		67,
		74,
		66,
		74,
		74,
		72,
		51,
		58,
		74,
		73,
		68,
		101,
		95,
		101,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		152,
		148,
		138,
		128,
		131,
		-1,
		-1,
		119,
		116,
		92,
		76,
		80,
		73,
		68,
		80,
		60,
		47,
		51,
		55,
		61,
		66,
		71,
		77,
		92,
		107,
		-1,
		160,
		241,
		234,
		202,
		210,
		241,
		-1,
		142,
		134,
		145,
		120,
		122,
		-1,
		-1,
		92,
		89,
		94,
		83,
		80,
		90,
		85,
		76,
		61,
		67,
		54,
		53,
		71,
		75,
		84,
		91,
		81,
		94,
		98,
		-1,
		174,
		217,
		196,
		199,
		223,
		237,
		-1,
		139,
		-1,
		-1,
		151,
		123,
		107,
		97,
		91,
		141,
		97,
		92,
		84,
		82,
		73,
		64,
		71,
		62,
		62,
		65,
		80,
		85,
		77,
		91,
		91,
		92,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		167,
		-1,
		134,
		-1,
		109,
		113,
		105,
		108,
		98,
		85,
		77,
		69,
		85,
		60,
		70,
		66,
		67,
		76,
		87,
		99,
		98,
		99,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		151,
		190,
		197,
		-1,
		176,
		-1,
		-1,
		-1,
		123,
		118,
		110,
		118,
		97,
		97,
		71,
		75,
		65,
		72,
		82,
		84,
		76,
		80,
		93,
		104,
		107,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		166,
		157,
		184,
		204,
		193,
		188,
		175,
		-1,
		-1,
		146,
		128,
		-1,
		-1,
		104,
		92,
		75,
		76,
		72,
		75,
		90,
		93,
		83,
		81,
		75,
		107,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		185,
		180,
		184,
		200,
		225,
		-1,
		164,
		-1,
		-1,
		149,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		80,
		91,
		101,
		89,
		90,
		80,
		90,
		103,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		180,
		160,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		107,
		109,
		98,
		92,
		86,
		93,
		92,
		100,
		108,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		166,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		100,
		104,
		96,
		89,
		84,
		95,
		87,
		91,
		108,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		90,
		101,
		90,
		93,
		107,
		102,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		177,
		179,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		94,
		100,
		103,
		92,
		96,
		108,
		-1,
		-1,
		174,
		175,
		180,
		-1,
		162,
		-1,
		180,
		-1,
		147,
		153,
		141,
		-1,
		-1,
		-1,
		135,
		98,
		119,
		129,
		123,
		121,
		112,
		98,
		105,
		103,
		99,
		110,
		-1,
		-1,
		-1,
		180,
		154,
		187,
		178,
		161,
		141,
		133,
		152,
		-1,
		122,
		-1,
		97,
		99,
		125,
		128,
		134,
		128,
		101,
		116,
		106,
		97,
		106,
		186,
		-1,
		156,
		189,
		153,
		147,
		123,
		127,
		143,
		-1,
		119,
		101,
		-1,
		129,
		119,
		150,
		135,
		116,
		103,
		110,
		110,
		103,
		-1,
		-1,
		-1,
		158,
		157,
		149,
		143,
		143,
		128,
		119,
		-1,
		131,
		113,
		92,
		109,
		109,
		100,
		108,
		140,
		136,
		123,
		123,
		115,
		-1,
		259,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		152,
		147,
		120,
		108,
		114,
		110,
		96,
		102,
		104,
		112,
		110,
		107,
		119,
		115,
		135,
		116,
		151,
		-1,
		254,
		-1,
		188,
		-1,
		-1,
		170,
		150,
		142,
		131,
		120,
		118,
		109,
		100,
		122,
		138,
		122,
		120,
		123,
		124,
		-1,
		243,
		242,
		-1,
		189,
		181,
		167,
		-1,
		160,
		-1,
		166,
		127,
		-1,
		129,
		109,
		-1,
		131,
		127,
		-1,
		-1,
		230,
		205,
		-1,
		-1,
		-1,
		190,
		170,
		161,
		145,
		-1,
		120,
		120,
		-1,
		-1,
		-1,
		215,
		214,
		-1,
		183,
		186,
		-1,
		176,
		167,
		175,
		122,
		126,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		198,
		196,
		191,
		188,
		174,
		158,
		136,
		125,
		146,
		-1,
		-1,
		-1,
		196,
		188,
		181,
		-1,
		-1,
		183,
		166,
		147,
		145,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		173,
		-1,
		-1,
		179,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		207,
		-1,
		-1,
		-1,
		169,
		165,
		166,
		-1,
		-1,
		-1,
		-1,
		229,
		230,
		253,
		217,
		-1,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		232,
		230,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		194,
		-1,
		194,
		169,
		176,
		-1,
		-1,
		-1,
		-1,
		207,
		199,
		207,
		-1,
		179,
		181,
		-1,
		229,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		184,
		191,
		213,
		216,
		252,
		-1,
		203
	],
	[
		-1,
		150,
		139,
		150,
		158,
		131,
		138,
		-1,
		157,
		161,
		127,
		121,
		160,
		129,
		135,
		146,
		-1,
		-1,
		-1,
		150,
		149,
		117,
		115,
		124,
		129,
		136,
		-1,
		135,
		-1,
		171,
		150,
		161,
		166,
		110,
		107,
		127,
		146,
		128,
		120,
		186,
		140,
		111,
		105,
		123,
		113,
		122,
		114,
		-1,
		111,
		101,
		123,
		102,
		113,
		105,
		-1,
		-1,
		105,
		106,
		112,
		98,
		104,
		100,
		-1,
		110,
		94,
		-1,
		-1,
		95,
		96,
		80,
		83,
		91,
		89,
		102,
		94,
		89,
		-1,
		-1,
		86,
		82,
		89,
		76,
		72,
		89,
		102,
		84,
		98,
		97,
		-1,
		98,
		115,
		115,
		83,
		81,
		65,
		63,
		81,
		83,
		89,
		89,
		-1,
		115,
		111,
		112,
		110,
		105,
		81,
		68,
		68,
		78,
		71,
		90,
		78,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		99,
		116,
		108,
		98,
		102,
		100,
		71,
		68,
		66,
		63,
		79,
		77,
		87,
		-1,
		-1,
		209,
		178,
		206,
		164,
		146,
		-1,
		112,
		92,
		98,
		102,
		96,
		89,
		102,
		87,
		-1,
		57,
		56,
		84,
		70,
		81,
		169,
		-1,
		-1,
		167,
		159,
		141,
		144,
		121,
		117,
		107,
		106,
		98,
		84,
		80,
		86,
		89,
		89,
		95,
		51,
		61,
		65,
		63,
		88,
		-1,
		-1,
		123,
		-1,
		-1,
		166,
		149,
		-1,
		132,
		139,
		127,
		133,
		119,
		140,
		117,
		108,
		100,
		94,
		82,
		84,
		81,
		94,
		73,
		48,
		73,
		77,
		58,
		79,
		74,
		-1,
		122,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		133,
		157,
		156,
		-1,
		129,
		117,
		118,
		103,
		100,
		87,
		75,
		88,
		73,
		73,
		70,
		52,
		50,
		80,
		55,
		77,
		74,
		93,
		98,
		92,
		101,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		161,
		-1,
		164,
		166,
		141,
		114,
		117,
		104,
		95,
		82,
		71,
		82,
		71,
		68,
		64,
		44,
		59,
		50,
		49,
		67,
		77,
		85,
		89,
		95,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		181,
		165,
		158,
		143,
		143,
		-1,
		113,
		110,
		100,
		78,
		63,
		80,
		71,
		66,
		57,
		39,
		53,
		44,
		62,
		69,
		67,
		71,
		91,
		103,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		185,
		149,
		-1,
		144,
		-1,
		115,
		128,
		-1,
		84,
		80,
		62,
		63,
		58,
		73,
		50,
		35,
		32,
		50,
		53,
		60,
		64,
		80,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		98,
		95,
		83,
		70,
		55,
		56,
		64,
		69,
		48,
		34,
		31,
		51,
		77,
		55,
		67,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		94,
		73,
		64,
		53,
		51,
		57,
		49,
		48,
		29,
		27,
		46,
		58,
		49,
		69,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		107,
		90,
		71,
		60,
		52,
		41,
		45,
		51,
		43,
		25,
		34,
		40,
		64,
		71,
		77,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		81,
		65,
		60,
		57,
		49,
		36,
		44,
		42,
		28,
		27,
		30,
		69,
		69,
		61,
		86,
		89,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		67,
		63,
		53,
		57,
		51,
		48,
		32,
		36,
		30,
		19,
		50,
		-1,
		67,
		63,
		82,
		72,
		60,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		65,
		60,
		59,
		49,
		37,
		26,
		39,
		32,
		6,
		7,
		38,
		42,
		68,
		62,
		58,
		55,
		69,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		87,
		71,
		65,
		49,
		40,
		48,
		21,
		14,
		0,
		15,
		33,
		62,
		60,
		54,
		53,
		65,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		77,
		87,
		88,
		61,
		49,
		47,
		48,
		36,
		25,
		23,
		27,
		42,
		52,
		48,
		49,
		58,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		91,
		89,
		77,
		63,
		69,
		58,
		45,
		40,
		30,
		19,
		25,
		36,
		58,
		44,
		42,
		61,
		77,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		80,
		64,
		69,
		-1,
		65,
		-1,
		38,
		40,
		38,
		30,
		30,
		41,
		39,
		50,
		67,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		96,
		76,
		70,
		69,
		60,
		68,
		46,
		43,
		36,
		33,
		33,
		46,
		66,
		57,
		69,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		113,
		101,
		91,
		81,
		92,
		80,
		59,
		55,
		41,
		43,
		41,
		42,
		47,
		68,
		69,
		82,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		102,
		-1,
		-1,
		91,
		84,
		72,
		58,
		45,
		65,
		68,
		57,
		41,
		56,
		68,
		76,
		81,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		114,
		103,
		98,
		102,
		90,
		-1,
		74,
		69,
		49,
		63,
		70,
		59,
		54,
		48,
		51,
		69,
		86,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		120,
		91,
		84,
		88,
		-1,
		76,
		65,
		51,
		68,
		72,
		69,
		60,
		52,
		57,
		54,
		67,
		81,
		85,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		130,
		107,
		80,
		75,
		68,
		62,
		59,
		75,
		80,
		91,
		59,
		55,
		56,
		60,
		59,
		76,
		86,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		157,
		-1,
		-1,
		84,
		75,
		66,
		69,
		69,
		72,
		65,
		62,
		67,
		72,
		60,
		69,
		87,
		91,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		155,
		102,
		84,
		80,
		78,
		71,
		80,
		75,
		70,
		80,
		90,
		82,
		62,
		75,
		97,
		87,
		123,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		117,
		114,
		-1,
		84,
		109,
		81,
		88,
		80,
		88,
		88,
		86,
		65,
		72,
		88,
		87,
		82,
		115,
		109,
		115,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		133,
		130,
		106,
		90,
		94,
		87,
		82,
		94,
		74,
		61,
		65,
		69,
		75,
		80,
		85,
		91,
		106,
		121,
		-1,
		174,
		255,
		248,
		216,
		224,
		255,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		106,
		103,
		108,
		97,
		94,
		104,
		99,
		90,
		75,
		81,
		68,
		67,
		85,
		89,
		98,
		105,
		95,
		108,
		112,
		-1,
		188,
		231,
		210,
		213,
		237,
		251,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		105,
		155,
		111,
		106,
		98,
		96,
		87,
		78,
		85,
		76,
		76,
		79,
		94,
		99,
		91,
		105,
		105,
		106,
		-1,
		200,
		211,
		204,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		-1,
		148,
		-1,
		123,
		127,
		119,
		122,
		112,
		99,
		91,
		83,
		99,
		74,
		84,
		80,
		81,
		90,
		101,
		113,
		112,
		113,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		165,
		204,
		211,
		-1,
		190,
		-1,
		-1,
		-1,
		137,
		132,
		124,
		132,
		111,
		111,
		85,
		89,
		79,
		86,
		96,
		98,
		90,
		94,
		107,
		118,
		121,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		180,
		171,
		198,
		218,
		207,
		202,
		189,
		-1,
		-1,
		160,
		142,
		-1,
		-1,
		118,
		106,
		89,
		90,
		86,
		89,
		104,
		107,
		97,
		95,
		89,
		121,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		199,
		194,
		198,
		214,
		239,
		-1,
		178,
		-1,
		-1,
		163,
		-1,
		-1,
		148,
		111,
		100,
		91,
		97,
		94,
		105,
		115,
		103,
		104,
		94,
		104,
		117,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		194,
		174,
		-1,
		-1,
		146,
		144,
		133,
		-1,
		123,
		96,
		101,
		121,
		123,
		112,
		106,
		100,
		107,
		106,
		114,
		122,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		180,
		-1,
		-1,
		141,
		134,
		122,
		110,
		100,
		110,
		114,
		118,
		110,
		103,
		98,
		109,
		101,
		105,
		122,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		175,
		159,
		140,
		-1,
		110,
		123,
		154,
		122,
		127,
		122,
		104,
		115,
		104,
		107,
		121,
		116,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		191,
		193,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		147,
		143,
		-1,
		-1,
		111,
		136,
		125,
		133,
		128,
		108,
		114,
		117,
		106,
		110,
		122,
		-1,
		-1,
		188,
		189,
		194,
		-1,
		176,
		-1,
		194,
		-1,
		161,
		167,
		155,
		-1,
		-1,
		-1,
		149,
		112,
		133,
		143,
		137,
		135,
		126,
		112,
		119,
		117,
		113,
		124,
		-1,
		-1,
		-1,
		194,
		168,
		201,
		192,
		175,
		155,
		147,
		166,
		-1,
		136,
		-1,
		111,
		113,
		139,
		142,
		148,
		142,
		115,
		130,
		120,
		111,
		120,
		200,
		-1,
		170,
		203,
		167,
		161,
		137,
		141,
		157,
		-1,
		133,
		115,
		-1,
		143,
		133,
		164,
		149,
		130,
		117,
		124,
		124,
		117,
		-1,
		-1,
		-1,
		172,
		171,
		163,
		157,
		157,
		142,
		133,
		-1,
		145,
		127,
		106,
		123,
		123,
		114,
		122,
		154,
		150,
		137,
		137,
		129,
		-1,
		273,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		166,
		161,
		134,
		122,
		128,
		124,
		110,
		116,
		118,
		126,
		124,
		121,
		133,
		129,
		149,
		130,
		165,
		-1,
		268,
		-1,
		202,
		-1,
		-1,
		184,
		164,
		156,
		145,
		134,
		132,
		123,
		114,
		136,
		152,
		136,
		134,
		137,
		138,
		-1,
		257,
		256,
		-1,
		203,
		195,
		181,
		-1,
		174,
		-1,
		180,
		141,
		-1,
		143,
		123,
		-1,
		145,
		141,
		-1,
		-1,
		244,
		219,
		-1,
		-1,
		-1,
		204,
		184,
		175,
		159,
		-1,
		134,
		134,
		-1,
		-1,
		-1,
		229,
		228,
		-1,
		197,
		200,
		-1,
		190,
		181,
		189,
		136,
		140,
		-1,
		-1,
		-1,
		238,
		219,
		213,
		212,
		210,
		205,
		202,
		188,
		172,
		150,
		139,
		160,
		-1,
		-1,
		-1,
		210,
		202,
		195,
		-1,
		-1,
		197,
		180,
		161,
		159,
		-1,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		187,
		-1,
		-1,
		193,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		221,
		-1,
		-1,
		-1,
		183,
		179,
		180,
		-1,
		-1,
		-1,
		-1,
		243,
		244,
		267,
		231,
		-1,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		246,
		244,
		-1,
		-1,
		-1,
		203,
		187,
		-1,
		173,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		208,
		-1,
		208,
		183,
		190,
		-1,
		-1,
		-1,
		-1,
		221,
		213,
		221,
		-1,
		193,
		195,
		-1,
		243,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		198,
		205,
		227,
		230,
		266,
		-1,
		217
	],
	[
		-1,
		142,
		131,
		142,
		150,
		123,
		130,
		-1,
		149,
		153,
		119,
		113,
		152,
		121,
		127,
		138,
		-1,
		-1,
		-1,
		142,
		141,
		109,
		107,
		116,
		121,
		128,
		-1,
		127,
		-1,
		163,
		142,
		153,
		158,
		102,
		99,
		119,
		138,
		120,
		112,
		178,
		132,
		103,
		97,
		115,
		105,
		114,
		106,
		-1,
		103,
		93,
		115,
		94,
		105,
		97,
		-1,
		-1,
		97,
		98,
		104,
		90,
		96,
		92,
		-1,
		102,
		86,
		-1,
		-1,
		87,
		88,
		72,
		75,
		83,
		81,
		94,
		86,
		81,
		-1,
		-1,
		78,
		74,
		81,
		68,
		64,
		81,
		94,
		76,
		90,
		89,
		-1,
		90,
		107,
		107,
		75,
		73,
		57,
		55,
		73,
		75,
		81,
		81,
		-1,
		107,
		103,
		104,
		102,
		97,
		73,
		60,
		60,
		70,
		63,
		82,
		70,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		108,
		97,
		114,
		100,
		90,
		94,
		92,
		63,
		60,
		58,
		55,
		71,
		69,
		79,
		-1,
		-1,
		201,
		174,
		198,
		156,
		138,
		-1,
		104,
		90,
		96,
		94,
		88,
		81,
		94,
		79,
		-1,
		49,
		48,
		76,
		62,
		73,
		167,
		-1,
		-1,
		159,
		151,
		133,
		136,
		113,
		109,
		105,
		104,
		96,
		82,
		78,
		78,
		81,
		81,
		87,
		43,
		53,
		57,
		55,
		80,
		-1,
		-1,
		115,
		-1,
		-1,
		164,
		147,
		-1,
		128,
		135,
		119,
		125,
		111,
		132,
		115,
		106,
		98,
		92,
		80,
		76,
		73,
		86,
		65,
		40,
		65,
		69,
		50,
		71,
		66,
		-1,
		114,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		123,
		126,
		125,
		149,
		148,
		-1,
		127,
		115,
		116,
		101,
		98,
		85,
		73,
		81,
		65,
		65,
		62,
		44,
		42,
		72,
		47,
		69,
		66,
		85,
		90,
		84,
		93,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		153,
		-1,
		156,
		164,
		139,
		112,
		115,
		102,
		93,
		80,
		69,
		80,
		63,
		60,
		56,
		36,
		51,
		42,
		41,
		59,
		69,
		77,
		81,
		87,
		-1,
		222,
		-1,
		164,
		148,
		150,
		122,
		143,
		-1,
		173,
		157,
		156,
		141,
		141,
		-1,
		111,
		108,
		98,
		76,
		61,
		75,
		63,
		58,
		49,
		31,
		45,
		36,
		54,
		61,
		59,
		63,
		83,
		95,
		182,
		172,
		-1,
		154,
		159,
		118,
		126,
		145,
		183,
		147,
		-1,
		142,
		-1,
		113,
		126,
		-1,
		82,
		78,
		60,
		61,
		56,
		67,
		42,
		27,
		24,
		42,
		45,
		52,
		56,
		72,
		-1,
		-1,
		167,
		171,
		160,
		111,
		130,
		154,
		191,
		140,
		129,
		128,
		-1,
		119,
		96,
		93,
		81,
		68,
		53,
		54,
		62,
		62,
		41,
		26,
		23,
		43,
		69,
		47,
		59,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		137,
		108,
		132,
		174,
		158,
		151,
		139,
		104,
		104,
		98,
		-1,
		92,
		71,
		62,
		51,
		49,
		61,
		47,
		41,
		21,
		19,
		38,
		50,
		41,
		61,
		-1,
		-1,
		-1,
		167,
		156,
		157,
		103,
		126,
		163,
		137,
		123,
		128,
		103,
		96,
		90,
		105,
		88,
		69,
		58,
		50,
		39,
		47,
		43,
		35,
		17,
		26,
		32,
		56,
		62,
		68,
		-1,
		-1,
		174,
		164,
		148,
		150,
		147,
		117,
		124,
		156,
		128,
		141,
		-1,
		95,
		-1,
		84,
		79,
		63,
		58,
		55,
		52,
		40,
		36,
		34,
		24,
		19,
		26,
		61,
		61,
		53,
		77,
		80,
		-1,
		-1,
		-1,
		167,
		162,
		137,
		114,
		98,
		134,
		-1,
		111,
		112,
		-1,
		89,
		83,
		80,
		65,
		61,
		56,
		60,
		53,
		46,
		36,
		28,
		29,
		11,
		35,
		-1,
		52,
		55,
		77,
		67,
		55,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		93,
		145,
		-1,
		-1,
		96,
		89,
		-1,
		76,
		58,
		65,
		63,
		57,
		58,
		46,
		35,
		44,
		36,
		16,
		10,
		23,
		27,
		53,
		57,
		53,
		50,
		64,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		113,
		-1,
		105,
		97,
		87,
		81,
		75,
		71,
		69,
		85,
		69,
		72,
		58,
		49,
		57,
		30,
		23,
		15,
		0,
		18,
		47,
		55,
		49,
		48,
		60,
		-1,
		180,
		166,
		137,
		-1,
		-1,
		126,
		-1,
		90,
		104,
		120,
		-1,
		113,
		92,
		107,
		85,
		81,
		77,
		92,
		93,
		70,
		58,
		56,
		53,
		41,
		30,
		8,
		12,
		27,
		37,
		43,
		44,
		53,
		-1,
		186,
		173,
		131,
		127,
		116,
		136,
		87,
		75,
		107,
		-1,
		-1,
		149,
		-1,
		83,
		100,
		91,
		89,
		82,
		72,
		78,
		67,
		50,
		45,
		35,
		24,
		30,
		23,
		53,
		39,
		37,
		56,
		72,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		102,
		89,
		83,
		-1,
		124,
		-1,
		127,
		117,
		101,
		86,
		119,
		-1,
		89,
		73,
		78,
		-1,
		70,
		-1,
		37,
		39,
		37,
		28,
		25,
		36,
		34,
		45,
		62,
		-1,
		136,
		121,
		114,
		104,
		118,
		89,
		-1,
		144,
		-1,
		-1,
		114,
		108,
		108,
		92,
		95,
		105,
		85,
		79,
		78,
		65,
		69,
		51,
		41,
		34,
		31,
		28,
		41,
		61,
		52,
		64,
		-1,
		-1,
		-1,
		141,
		127,
		131,
		91,
		110,
		-1,
		-1,
		176,
		131,
		117,
		-1,
		101,
		122,
		110,
		100,
		90,
		95,
		83,
		60,
		53,
		39,
		41,
		39,
		37,
		42,
		63,
		64,
		77,
		-1,
		-1,
		124,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		123,
		139,
		131,
		102,
		111,
		-1,
		-1,
		94,
		87,
		75,
		56,
		43,
		63,
		66,
		52,
		36,
		51,
		63,
		71,
		76,
		-1,
		127,
		114,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		156,
		109,
		98,
		93,
		97,
		93,
		-1,
		69,
		67,
		47,
		61,
		68,
		54,
		49,
		43,
		46,
		64,
		81,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		113,
		115,
		86,
		79,
		83,
		-1,
		71,
		63,
		49,
		66,
		67,
		64,
		55,
		47,
		52,
		49,
		62,
		76,
		80,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		131,
		146,
		125,
		102,
		75,
		70,
		63,
		57,
		57,
		73,
		75,
		86,
		54,
		50,
		51,
		55,
		54,
		71,
		81,
		-1,
		-1,
		145,
		162,
		157,
		139,
		143,
		152,
		-1,
		-1,
		79,
		70,
		61,
		64,
		67,
		70,
		60,
		57,
		62,
		67,
		55,
		64,
		82,
		86,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		158,
		150,
		97,
		79,
		75,
		73,
		66,
		75,
		70,
		65,
		75,
		85,
		77,
		57,
		70,
		92,
		82,
		118,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		112,
		109,
		-1,
		79,
		104,
		76,
		83,
		75,
		83,
		83,
		81,
		60,
		67,
		83,
		82,
		77,
		110,
		104,
		110,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		128,
		125,
		101,
		85,
		89,
		82,
		77,
		89,
		69,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		116,
		-1,
		172,
		250,
		243,
		211,
		219,
		250,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		101,
		98,
		103,
		92,
		89,
		99,
		94,
		85,
		70,
		76,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		186,
		226,
		205,
		208,
		232,
		246,
		-1,
		148,
		-1,
		-1,
		160,
		132,
		116,
		106,
		100,
		150,
		106,
		101,
		93,
		91,
		82,
		73,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		176,
		-1,
		143,
		-1,
		118,
		122,
		114,
		117,
		107,
		94,
		86,
		78,
		94,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		160,
		199,
		206,
		-1,
		185,
		-1,
		-1,
		-1,
		132,
		127,
		119,
		127,
		106,
		106,
		80,
		84,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		175,
		166,
		193,
		213,
		202,
		197,
		184,
		-1,
		-1,
		155,
		137,
		-1,
		-1,
		113,
		101,
		84,
		85,
		81,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		194,
		189,
		193,
		209,
		234,
		-1,
		173,
		-1,
		-1,
		158,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		89,
		100,
		110,
		98,
		99,
		89,
		99,
		112,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		223,
		-1,
		-1,
		189,
		169,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		116,
		118,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		179,
		175,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		109,
		113,
		105,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		196,
		182,
		175,
		163,
		161,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		176,
		179,
		-1,
		-1,
		186,
		188,
		-1,
		187,
		176,
		161,
		153,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		183,
		184,
		189,
		-1,
		171,
		-1,
		189,
		-1,
		156,
		162,
		150,
		-1,
		-1,
		-1,
		144,
		107,
		128,
		138,
		132,
		130,
		121,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		189,
		163,
		196,
		187,
		170,
		150,
		142,
		161,
		-1,
		131,
		-1,
		106,
		108,
		134,
		137,
		143,
		137,
		110,
		125,
		115,
		106,
		115,
		195,
		-1,
		165,
		198,
		162,
		156,
		132,
		136,
		152,
		-1,
		128,
		110,
		-1,
		138,
		128,
		159,
		144,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		167,
		166,
		158,
		152,
		152,
		137,
		128,
		-1,
		140,
		122,
		101,
		118,
		118,
		109,
		117,
		149,
		145,
		132,
		132,
		124,
		-1,
		268,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		161,
		156,
		129,
		117,
		123,
		119,
		105,
		111,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		125,
		160,
		-1,
		263,
		-1,
		197,
		-1,
		-1,
		179,
		159,
		151,
		140,
		129,
		127,
		118,
		109,
		131,
		147,
		131,
		129,
		132,
		133,
		-1,
		252,
		251,
		-1,
		198,
		190,
		176,
		-1,
		169,
		-1,
		175,
		136,
		-1,
		138,
		118,
		-1,
		140,
		136,
		-1,
		-1,
		239,
		214,
		-1,
		-1,
		-1,
		199,
		179,
		170,
		154,
		-1,
		129,
		129,
		-1,
		-1,
		-1,
		224,
		223,
		-1,
		192,
		195,
		-1,
		185,
		176,
		184,
		131,
		135,
		-1,
		-1,
		-1,
		233,
		214,
		208,
		207,
		205,
		200,
		197,
		183,
		167,
		145,
		134,
		155,
		-1,
		-1,
		-1,
		205,
		197,
		190,
		-1,
		-1,
		192,
		175,
		156,
		154,
		-1,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		182,
		-1,
		-1,
		188,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		216,
		-1,
		-1,
		-1,
		178,
		174,
		175,
		-1,
		-1,
		-1,
		-1,
		238,
		239,
		262,
		226,
		-1,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		241,
		239,
		-1,
		-1,
		-1,
		198,
		182,
		-1,
		168,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		203,
		-1,
		203,
		178,
		185,
		-1,
		-1,
		-1,
		-1,
		216,
		208,
		216,
		-1,
		188,
		190,
		-1,
		238,
		-1,
		-1,
		231,
		222,
		-1,
		-1,
		193,
		200,
		222,
		225,
		261,
		-1,
		212
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		173,
		177,
		143,
		137,
		176,
		145,
		151,
		162,
		-1,
		-1,
		-1,
		166,
		165,
		133,
		131,
		140,
		145,
		152,
		-1,
		151,
		-1,
		187,
		166,
		177,
		182,
		126,
		123,
		143,
		162,
		144,
		136,
		202,
		156,
		127,
		121,
		139,
		129,
		138,
		130,
		-1,
		127,
		117,
		139,
		118,
		129,
		121,
		-1,
		-1,
		121,
		122,
		128,
		114,
		120,
		116,
		-1,
		126,
		110,
		-1,
		-1,
		111,
		112,
		96,
		99,
		107,
		105,
		118,
		110,
		105,
		-1,
		-1,
		102,
		98,
		105,
		92,
		88,
		105,
		118,
		100,
		114,
		113,
		-1,
		114,
		131,
		131,
		99,
		97,
		81,
		79,
		97,
		99,
		105,
		105,
		-1,
		131,
		127,
		128,
		126,
		121,
		97,
		84,
		84,
		94,
		87,
		106,
		94,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		121,
		138,
		124,
		114,
		118,
		116,
		87,
		84,
		82,
		79,
		95,
		93,
		103,
		-1,
		-1,
		225,
		198,
		222,
		180,
		162,
		-1,
		128,
		114,
		120,
		118,
		112,
		105,
		118,
		103,
		-1,
		73,
		72,
		100,
		86,
		97,
		191,
		-1,
		-1,
		183,
		175,
		157,
		160,
		137,
		133,
		129,
		128,
		120,
		106,
		102,
		102,
		105,
		105,
		111,
		67,
		77,
		81,
		79,
		104,
		-1,
		-1,
		132,
		-1,
		-1,
		188,
		171,
		-1,
		152,
		159,
		143,
		149,
		135,
		156,
		139,
		130,
		122,
		116,
		104,
		100,
		97,
		110,
		89,
		64,
		89,
		93,
		74,
		95,
		90,
		-1,
		131,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		149,
		173,
		172,
		-1,
		151,
		139,
		140,
		125,
		122,
		109,
		97,
		105,
		89,
		89,
		86,
		68,
		66,
		96,
		71,
		93,
		90,
		102,
		107,
		101,
		110,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		177,
		-1,
		180,
		188,
		163,
		136,
		139,
		126,
		117,
		104,
		93,
		104,
		87,
		84,
		80,
		60,
		75,
		66,
		65,
		83,
		86,
		94,
		98,
		104,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		197,
		181,
		180,
		165,
		165,
		-1,
		135,
		132,
		122,
		100,
		85,
		99,
		87,
		82,
		73,
		55,
		69,
		60,
		73,
		80,
		76,
		80,
		100,
		112,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		207,
		171,
		-1,
		166,
		-1,
		137,
		150,
		-1,
		106,
		102,
		84,
		85,
		80,
		91,
		66,
		51,
		48,
		66,
		64,
		69,
		73,
		89,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		164,
		153,
		152,
		-1,
		143,
		120,
		117,
		105,
		92,
		77,
		78,
		86,
		86,
		65,
		50,
		47,
		60,
		86,
		64,
		76,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		116,
		95,
		86,
		75,
		73,
		85,
		71,
		65,
		45,
		43,
		55,
		67,
		58,
		78,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		161,
		147,
		152,
		127,
		120,
		114,
		129,
		112,
		93,
		82,
		74,
		63,
		71,
		67,
		59,
		41,
		50,
		49,
		73,
		70,
		76,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		152,
		165,
		-1,
		119,
		-1,
		108,
		103,
		87,
		82,
		79,
		76,
		64,
		60,
		58,
		48,
		43,
		50,
		78,
		78,
		64,
		85,
		88,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		135,
		136,
		-1,
		113,
		107,
		104,
		89,
		85,
		80,
		84,
		77,
		70,
		60,
		52,
		53,
		35,
		45,
		-1,
		60,
		66,
		90,
		91,
		79,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		120,
		113,
		-1,
		100,
		82,
		89,
		87,
		81,
		82,
		70,
		59,
		68,
		60,
		40,
		34,
		5,
		35,
		61,
		78,
		77,
		74,
		88,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		129,
		121,
		111,
		105,
		99,
		95,
		93,
		109,
		93,
		96,
		82,
		73,
		81,
		54,
		47,
		39,
		24,
		0,
		55,
		70,
		65,
		69,
		84,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		150,
		-1,
		114,
		128,
		144,
		-1,
		137,
		116,
		131,
		109,
		105,
		101,
		116,
		117,
		94,
		82,
		80,
		77,
		65,
		54,
		30,
		35,
		35,
		45,
		63,
		65,
		74,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		111,
		99,
		131,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		115,
		113,
		106,
		96,
		102,
		91,
		74,
		69,
		59,
		48,
		54,
		44,
		77,
		63,
		61,
		77,
		93,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		113,
		97,
		102,
		-1,
		94,
		-1,
		61,
		63,
		61,
		52,
		49,
		60,
		58,
		69,
		83,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		168,
		-1,
		-1,
		138,
		132,
		132,
		116,
		119,
		129,
		109,
		103,
		102,
		89,
		93,
		75,
		65,
		58,
		55,
		52,
		62,
		85,
		76,
		85,
		-1,
		-1,
		-1,
		165,
		151,
		155,
		115,
		134,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		125,
		146,
		134,
		124,
		114,
		119,
		107,
		84,
		77,
		63,
		65,
		63,
		61,
		66,
		87,
		88,
		100,
		-1,
		-1,
		148,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		147,
		163,
		155,
		126,
		135,
		-1,
		-1,
		118,
		111,
		99,
		80,
		67,
		87,
		90,
		76,
		60,
		75,
		87,
		92,
		100,
		-1,
		151,
		138,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		180,
		133,
		122,
		117,
		121,
		117,
		-1,
		93,
		91,
		71,
		85,
		92,
		78,
		73,
		67,
		70,
		88,
		103,
		-1,
		-1,
		163,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		137,
		139,
		110,
		103,
		107,
		-1,
		95,
		87,
		73,
		90,
		91,
		88,
		79,
		71,
		76,
		73,
		86,
		100,
		104,
		186,
		-1,
		169,
		-1,
		-1,
		-1,
		155,
		170,
		149,
		126,
		99,
		94,
		87,
		81,
		81,
		97,
		99,
		110,
		78,
		74,
		75,
		79,
		78,
		95,
		105,
		-1,
		-1,
		169,
		186,
		181,
		163,
		167,
		176,
		-1,
		-1,
		103,
		94,
		85,
		88,
		91,
		94,
		84,
		81,
		86,
		91,
		79,
		88,
		106,
		110,
		-1,
		-1,
		-1,
		189,
		-1,
		204,
		-1,
		-1,
		182,
		174,
		121,
		103,
		99,
		97,
		90,
		99,
		94,
		89,
		99,
		109,
		101,
		81,
		94,
		116,
		106,
		142,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		192,
		184,
		179,
		185,
		187,
		178,
		136,
		133,
		-1,
		103,
		128,
		100,
		107,
		99,
		107,
		107,
		105,
		84,
		91,
		107,
		106,
		101,
		134,
		128,
		134,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		185,
		181,
		171,
		161,
		164,
		-1,
		-1,
		152,
		149,
		125,
		109,
		113,
		106,
		101,
		113,
		93,
		80,
		84,
		88,
		94,
		99,
		104,
		110,
		125,
		140,
		-1,
		196,
		274,
		267,
		235,
		243,
		274,
		-1,
		175,
		167,
		178,
		153,
		155,
		-1,
		-1,
		125,
		122,
		127,
		116,
		113,
		123,
		118,
		109,
		94,
		100,
		87,
		86,
		104,
		108,
		117,
		124,
		114,
		127,
		131,
		-1,
		210,
		250,
		229,
		232,
		256,
		270,
		-1,
		172,
		-1,
		-1,
		184,
		156,
		140,
		130,
		124,
		174,
		130,
		125,
		117,
		115,
		106,
		97,
		104,
		95,
		95,
		98,
		113,
		118,
		110,
		124,
		124,
		125,
		-1,
		219,
		230,
		223,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		200,
		-1,
		167,
		-1,
		142,
		146,
		138,
		141,
		131,
		118,
		110,
		102,
		118,
		93,
		103,
		99,
		100,
		109,
		120,
		132,
		131,
		132,
		244,
		200,
		203,
		214,
		225,
		240,
		244,
		-1,
		184,
		223,
		230,
		-1,
		209,
		-1,
		-1,
		-1,
		156,
		151,
		143,
		151,
		130,
		130,
		104,
		108,
		98,
		105,
		115,
		117,
		109,
		113,
		126,
		137,
		140,
		240,
		231,
		244,
		189,
		189,
		210,
		219,
		240,
		199,
		190,
		217,
		237,
		226,
		221,
		208,
		-1,
		-1,
		179,
		161,
		-1,
		-1,
		137,
		125,
		108,
		109,
		105,
		108,
		123,
		126,
		116,
		114,
		108,
		140,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		207,
		-1,
		-1,
		202,
		218,
		213,
		217,
		233,
		258,
		-1,
		197,
		-1,
		-1,
		182,
		-1,
		-1,
		167,
		130,
		119,
		110,
		116,
		113,
		124,
		134,
		122,
		123,
		113,
		123,
		136,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		189,
		187,
		193,
		200,
		217,
		247,
		-1,
		-1,
		213,
		193,
		-1,
		-1,
		165,
		163,
		152,
		-1,
		142,
		115,
		120,
		140,
		142,
		131,
		125,
		119,
		126,
		125,
		133,
		141,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		203,
		199,
		-1,
		-1,
		160,
		153,
		141,
		129,
		119,
		129,
		133,
		137,
		129,
		122,
		117,
		128,
		120,
		124,
		141,
		-1,
		260,
		-1,
		212,
		188,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		220,
		206,
		199,
		187,
		185,
		-1,
		194,
		178,
		159,
		-1,
		129,
		142,
		173,
		141,
		146,
		141,
		123,
		134,
		123,
		126,
		140,
		135,
		-1,
		-1,
		200,
		203,
		-1,
		-1,
		210,
		212,
		-1,
		211,
		200,
		185,
		177,
		-1,
		-1,
		166,
		162,
		-1,
		-1,
		130,
		155,
		144,
		152,
		147,
		127,
		133,
		136,
		125,
		129,
		141,
		-1,
		-1,
		207,
		208,
		213,
		-1,
		195,
		-1,
		213,
		-1,
		180,
		186,
		174,
		-1,
		-1,
		-1,
		168,
		131,
		152,
		162,
		156,
		154,
		145,
		131,
		138,
		136,
		132,
		143,
		-1,
		-1,
		-1,
		213,
		187,
		220,
		211,
		194,
		174,
		166,
		185,
		-1,
		155,
		-1,
		130,
		132,
		158,
		161,
		167,
		161,
		134,
		149,
		139,
		130,
		139,
		219,
		-1,
		189,
		222,
		186,
		180,
		156,
		160,
		176,
		-1,
		152,
		134,
		-1,
		162,
		152,
		183,
		168,
		149,
		136,
		143,
		143,
		136,
		-1,
		-1,
		-1,
		191,
		190,
		182,
		176,
		176,
		161,
		152,
		-1,
		164,
		146,
		125,
		142,
		142,
		133,
		141,
		173,
		169,
		156,
		156,
		148,
		-1,
		292,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		185,
		180,
		153,
		141,
		147,
		143,
		129,
		135,
		137,
		145,
		143,
		140,
		152,
		148,
		168,
		149,
		184,
		-1,
		287,
		-1,
		221,
		-1,
		-1,
		203,
		183,
		175,
		164,
		153,
		151,
		142,
		133,
		155,
		171,
		155,
		153,
		156,
		157,
		-1,
		276,
		275,
		-1,
		222,
		214,
		200,
		-1,
		193,
		-1,
		199,
		160,
		-1,
		162,
		142,
		-1,
		164,
		160,
		-1,
		-1,
		263,
		238,
		-1,
		-1,
		-1,
		223,
		203,
		194,
		178,
		-1,
		153,
		153,
		-1,
		-1,
		-1,
		248,
		247,
		-1,
		216,
		219,
		-1,
		209,
		200,
		208,
		155,
		159,
		-1,
		-1,
		-1,
		257,
		238,
		232,
		231,
		229,
		224,
		221,
		207,
		191,
		169,
		158,
		179,
		-1,
		-1,
		-1,
		229,
		221,
		214,
		-1,
		-1,
		216,
		199,
		180,
		178,
		-1,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		206,
		-1,
		-1,
		212,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		240,
		-1,
		-1,
		-1,
		202,
		198,
		199,
		-1,
		-1,
		-1,
		-1,
		262,
		263,
		286,
		250,
		-1,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		265,
		263,
		-1,
		-1,
		-1,
		222,
		206,
		-1,
		192,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		227,
		-1,
		227,
		202,
		209,
		-1,
		-1,
		-1,
		-1,
		240,
		232,
		240,
		-1,
		212,
		214,
		-1,
		262,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		217,
		224,
		246,
		249,
		285,
		-1,
		236
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		197,
		201,
		167,
		161,
		200,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		190,
		189,
		157,
		155,
		164,
		169,
		176,
		-1,
		175,
		-1,
		211,
		190,
		201,
		206,
		150,
		147,
		167,
		186,
		168,
		160,
		226,
		180,
		151,
		145,
		163,
		153,
		162,
		154,
		-1,
		151,
		141,
		163,
		142,
		153,
		145,
		-1,
		-1,
		145,
		146,
		152,
		138,
		144,
		140,
		-1,
		150,
		134,
		-1,
		-1,
		135,
		136,
		120,
		123,
		131,
		129,
		142,
		134,
		129,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		124,
		138,
		137,
		-1,
		133,
		151,
		155,
		123,
		121,
		105,
		103,
		121,
		123,
		129,
		129,
		-1,
		142,
		143,
		138,
		146,
		145,
		121,
		108,
		108,
		118,
		111,
		130,
		118,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		125,
		142,
		134,
		124,
		139,
		132,
		111,
		108,
		106,
		103,
		119,
		117,
		127,
		-1,
		-1,
		235,
		204,
		233,
		191,
		172,
		-1,
		138,
		118,
		124,
		128,
		122,
		115,
		129,
		125,
		-1,
		97,
		96,
		124,
		110,
		121,
		195,
		-1,
		-1,
		193,
		185,
		168,
		171,
		148,
		144,
		133,
		132,
		124,
		110,
		106,
		112,
		115,
		115,
		121,
		91,
		101,
		105,
		103,
		110,
		-1,
		-1,
		124,
		-1,
		-1,
		192,
		175,
		-1,
		158,
		165,
		154,
		160,
		146,
		167,
		143,
		134,
		126,
		120,
		108,
		110,
		107,
		120,
		108,
		88,
		113,
		117,
		98,
		100,
		95,
		-1,
		123,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		151,
		154,
		160,
		184,
		183,
		-1,
		155,
		143,
		144,
		129,
		126,
		113,
		101,
		114,
		99,
		106,
		105,
		92,
		90,
		120,
		95,
		99,
		89,
		94,
		99,
		93,
		102,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		188,
		-1,
		191,
		192,
		167,
		140,
		143,
		130,
		121,
		108,
		97,
		108,
		97,
		94,
		102,
		84,
		99,
		90,
		89,
		78,
		78,
		86,
		90,
		96,
		-1,
		250,
		-1,
		192,
		176,
		178,
		150,
		171,
		-1,
		208,
		192,
		184,
		169,
		169,
		-1,
		139,
		136,
		126,
		104,
		89,
		106,
		98,
		96,
		97,
		79,
		93,
		84,
		84,
		82,
		68,
		72,
		92,
		104,
		210,
		200,
		-1,
		182,
		187,
		146,
		154,
		173,
		211,
		175,
		-1,
		170,
		-1,
		141,
		154,
		-1,
		110,
		106,
		88,
		89,
		84,
		99,
		90,
		75,
		72,
		80,
		75,
		61,
		65,
		81,
		-1,
		-1,
		195,
		199,
		188,
		139,
		158,
		182,
		219,
		168,
		157,
		156,
		-1,
		147,
		124,
		121,
		109,
		96,
		81,
		82,
		90,
		103,
		82,
		74,
		71,
		71,
		78,
		56,
		63,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		165,
		136,
		160,
		202,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		120,
		99,
		90,
		79,
		77,
		90,
		86,
		89,
		69,
		67,
		66,
		59,
		50,
		54,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		131,
		154,
		191,
		165,
		151,
		156,
		131,
		124,
		118,
		133,
		116,
		97,
		86,
		78,
		67,
		82,
		90,
		83,
		65,
		74,
		60,
		65,
		42,
		48,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		145,
		152,
		184,
		156,
		169,
		-1,
		123,
		-1,
		112,
		107,
		91,
		86,
		83,
		74,
		73,
		83,
		82,
		72,
		67,
		74,
		70,
		70,
		36,
		57,
		60,
		-1,
		-1,
		-1,
		195,
		190,
		165,
		142,
		126,
		162,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		93,
		89,
		78,
		82,
		81,
		87,
		75,
		76,
		77,
		59,
		69,
		-1,
		25,
		34,
		54,
		53,
		43,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		121,
		173,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		90,
		85,
		84,
		83,
		80,
		69,
		82,
		75,
		64,
		58,
		55,
		47,
		14,
		35,
		40,
		38,
		52,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		141,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		112,
		96,
		95,
		92,
		83,
		91,
		64,
		57,
		63,
		48,
		50,
		0,
		27,
		26,
		30,
		48,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		102,
		119,
		120,
		98,
		92,
		90,
		81,
		69,
		58,
		54,
		50,
		21,
		18,
		24,
		26,
		35,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		116,
		114,
		109,
		100,
		106,
		101,
		78,
		73,
		63,
		52,
		52,
		46,
		44,
		30,
		28,
		38,
		54,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		117,
		101,
		106,
		-1,
		98,
		-1,
		71,
		68,
		59,
		44,
		41,
		40,
		31,
		44,
		44,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		133,
		113,
		107,
		106,
		93,
		85,
		79,
		57,
		50,
		47,
		44,
		57,
		64,
		51,
		46,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		140,
		128,
		118,
		108,
		111,
		101,
		76,
		69,
		55,
		57,
		55,
		53,
		53,
		59,
		51,
		61,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		129,
		-1,
		-1,
		112,
		103,
		93,
		72,
		59,
		79,
		78,
		63,
		47,
		62,
		65,
		53,
		62,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		83,
		63,
		77,
		84,
		65,
		60,
		54,
		57,
		70,
		64,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		79,
		65,
		82,
		78,
		75,
		66,
		58,
		63,
		60,
		73,
		76,
		66,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		73,
		89,
		86,
		97,
		65,
		61,
		62,
		66,
		65,
		80,
		81,
		-1,
		-1,
		173,
		189,
		181,
		163,
		167,
		168,
		-1,
		-1,
		95,
		86,
		77,
		80,
		83,
		86,
		71,
		68,
		73,
		78,
		66,
		75,
		93,
		84,
		-1,
		-1,
		-1,
		193,
		-1,
		207,
		-1,
		-1,
		182,
		166,
		113,
		95,
		91,
		89,
		82,
		91,
		83,
		76,
		86,
		96,
		88,
		68,
		86,
		103,
		92,
		117,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		184,
		176,
		171,
		177,
		179,
		170,
		128,
		125,
		-1,
		95,
		120,
		89,
		96,
		88,
		94,
		94,
		92,
		73,
		83,
		99,
		98,
		93,
		109,
		104,
		113,
		-1,
		-1,
		272,
		261,
		250,
		256,
		-1,
		177,
		173,
		163,
		153,
		156,
		-1,
		-1,
		144,
		141,
		117,
		98,
		104,
		97,
		92,
		105,
		85,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		111,
		119,
		-1,
		200,
		263,
		256,
		224,
		232,
		263,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		117,
		114,
		117,
		105,
		102,
		115,
		110,
		101,
		86,
		92,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		214,
		239,
		218,
		221,
		245,
		259,
		-1,
		164,
		-1,
		-1,
		176,
		148,
		132,
		122,
		116,
		164,
		119,
		114,
		109,
		107,
		98,
		89,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		208,
		219,
		212,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		192,
		-1,
		159,
		-1,
		134,
		138,
		127,
		130,
		123,
		110,
		102,
		94,
		110,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		233,
		189,
		192,
		203,
		214,
		229,
		233,
		-1,
		176,
		215,
		222,
		-1,
		201,
		-1,
		-1,
		-1,
		148,
		140,
		132,
		143,
		122,
		122,
		96,
		100,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		229,
		220,
		233,
		178,
		178,
		199,
		208,
		229,
		191,
		182,
		209,
		229,
		218,
		213,
		200,
		-1,
		-1,
		171,
		150,
		-1,
		-1,
		129,
		117,
		100,
		101,
		97,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		222,
		221,
		210,
		207,
		183,
		174,
		169,
		196,
		-1,
		-1,
		191,
		210,
		202,
		206,
		222,
		247,
		-1,
		189,
		-1,
		-1,
		174,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		105,
		116,
		126,
		114,
		115,
		105,
		115,
		128,
		206,
		203,
		191,
		189,
		212,
		177,
		165,
		-1,
		178,
		176,
		182,
		189,
		206,
		236,
		-1,
		-1,
		205,
		185,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		132,
		134,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		215,
		229,
		218,
		214,
		213,
		221,
		170,
		163,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		191,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		125,
		129,
		121,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		249,
		-1,
		201,
		177,
		191,
		206,
		214,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		189,
		192,
		-1,
		-1,
		202,
		204,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		196,
		197,
		202,
		-1,
		187,
		-1,
		205,
		-1,
		172,
		178,
		166,
		-1,
		-1,
		-1,
		160,
		123,
		144,
		154,
		148,
		146,
		137,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		205,
		179,
		212,
		203,
		186,
		166,
		158,
		177,
		-1,
		147,
		-1,
		122,
		124,
		150,
		153,
		159,
		153,
		126,
		141,
		131,
		122,
		131,
		211,
		-1,
		181,
		214,
		178,
		172,
		148,
		152,
		168,
		-1,
		144,
		126,
		-1,
		154,
		144,
		175,
		160,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		168,
		153,
		144,
		-1,
		156,
		138,
		117,
		134,
		134,
		125,
		133,
		165,
		161,
		148,
		148,
		140,
		-1,
		284,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		172,
		145,
		133,
		139,
		135,
		121,
		127,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		141,
		176,
		-1,
		279,
		-1,
		213,
		-1,
		-1,
		195,
		175,
		167,
		156,
		145,
		143,
		134,
		125,
		147,
		163,
		147,
		145,
		148,
		149,
		-1,
		268,
		267,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		191,
		152,
		-1,
		154,
		134,
		-1,
		156,
		152,
		-1,
		-1,
		255,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		186,
		170,
		-1,
		145,
		145,
		-1,
		-1,
		-1,
		240,
		239,
		-1,
		208,
		211,
		-1,
		201,
		192,
		200,
		147,
		151,
		-1,
		-1,
		-1,
		249,
		230,
		224,
		223,
		221,
		216,
		213,
		199,
		183,
		161,
		150,
		171,
		-1,
		-1,
		-1,
		221,
		213,
		206,
		-1,
		-1,
		208,
		191,
		172,
		170,
		-1,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		198,
		-1,
		-1,
		204,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		232,
		-1,
		-1,
		-1,
		194,
		190,
		191,
		-1,
		-1,
		-1,
		-1,
		254,
		255,
		278,
		242,
		-1,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		257,
		255,
		-1,
		-1,
		-1,
		214,
		198,
		-1,
		184,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		219,
		-1,
		219,
		194,
		201,
		-1,
		-1,
		-1,
		-1,
		232,
		224,
		232,
		-1,
		204,
		206,
		-1,
		254,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		209,
		216,
		238,
		241,
		277,
		-1,
		228
	],
	[
		-1,
		186,
		175,
		186,
		194,
		167,
		174,
		-1,
		193,
		197,
		163,
		157,
		196,
		165,
		171,
		182,
		-1,
		-1,
		-1,
		186,
		185,
		153,
		151,
		160,
		165,
		172,
		-1,
		171,
		-1,
		207,
		186,
		197,
		202,
		146,
		143,
		163,
		182,
		164,
		156,
		222,
		176,
		147,
		141,
		159,
		149,
		158,
		150,
		-1,
		147,
		137,
		159,
		138,
		149,
		141,
		-1,
		-1,
		141,
		142,
		148,
		134,
		140,
		136,
		-1,
		146,
		130,
		-1,
		-1,
		131,
		132,
		116,
		119,
		127,
		125,
		138,
		130,
		125,
		-1,
		-1,
		122,
		118,
		125,
		112,
		108,
		125,
		138,
		120,
		134,
		132,
		-1,
		125,
		143,
		151,
		119,
		117,
		101,
		99,
		117,
		119,
		125,
		124,
		-1,
		134,
		135,
		130,
		138,
		141,
		117,
		104,
		104,
		114,
		107,
		126,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		117,
		134,
		126,
		116,
		131,
		124,
		107,
		104,
		102,
		99,
		115,
		112,
		122,
		-1,
		-1,
		227,
		196,
		225,
		183,
		164,
		-1,
		130,
		110,
		116,
		120,
		114,
		107,
		121,
		117,
		-1,
		93,
		92,
		119,
		105,
		116,
		187,
		-1,
		-1,
		185,
		177,
		160,
		163,
		140,
		136,
		125,
		124,
		116,
		102,
		98,
		104,
		107,
		107,
		113,
		87,
		97,
		101,
		98,
		101,
		-1,
		-1,
		115,
		-1,
		-1,
		184,
		167,
		-1,
		150,
		157,
		146,
		152,
		138,
		159,
		135,
		126,
		118,
		112,
		100,
		102,
		99,
		112,
		100,
		84,
		109,
		113,
		93,
		91,
		86,
		-1,
		114,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		146,
		152,
		176,
		175,
		-1,
		147,
		135,
		136,
		121,
		118,
		105,
		93,
		106,
		91,
		98,
		97,
		88,
		86,
		116,
		90,
		90,
		80,
		85,
		90,
		84,
		93,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		180,
		-1,
		183,
		184,
		159,
		132,
		135,
		122,
		113,
		100,
		89,
		100,
		89,
		86,
		94,
		80,
		95,
		85,
		84,
		69,
		69,
		77,
		81,
		87,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		200,
		184,
		176,
		161,
		161,
		-1,
		131,
		128,
		118,
		96,
		81,
		98,
		90,
		88,
		93,
		75,
		89,
		79,
		75,
		73,
		59,
		63,
		83,
		95,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		133,
		146,
		-1,
		102,
		98,
		80,
		81,
		76,
		91,
		86,
		71,
		68,
		71,
		66,
		52,
		56,
		72,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		116,
		113,
		101,
		88,
		73,
		74,
		82,
		95,
		74,
		70,
		70,
		62,
		69,
		47,
		58,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		112,
		91,
		82,
		71,
		69,
		82,
		79,
		86,
		68,
		66,
		57,
		50,
		41,
		49,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		125,
		108,
		89,
		78,
		70,
		59,
		75,
		83,
		82,
		64,
		71,
		51,
		56,
		37,
		43,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		99,
		83,
		78,
		75,
		68,
		66,
		75,
		81,
		71,
		66,
		73,
		61,
		61,
		27,
		52,
		55,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		85,
		81,
		72,
		76,
		73,
		80,
		69,
		75,
		76,
		58,
		82,
		-1,
		24,
		24,
		44,
		44,
		35,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		84,
		79,
		77,
		77,
		74,
		63,
		76,
		69,
		63,
		57,
		69,
		46,
		13,
		25,
		30,
		30,
		44,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		105,
		89,
		89,
		86,
		77,
		85,
		58,
		51,
		62,
		47,
		64,
		22,
		0,
		17,
		22,
		40,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		96,
		112,
		113,
		91,
		86,
		84,
		75,
		63,
		52,
		55,
		47,
		35,
		30,
		16,
		18,
		27,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		110,
		108,
		102,
		93,
		99,
		95,
		72,
		67,
		57,
		46,
		46,
		41,
		38,
		24,
		22,
		30,
		46,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		110,
		94,
		99,
		-1,
		92,
		-1,
		65,
		62,
		53,
		38,
		35,
		34,
		25,
		38,
		36,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		126,
		106,
		100,
		99,
		87,
		79,
		73,
		51,
		44,
		41,
		38,
		51,
		58,
		45,
		38,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		134,
		122,
		112,
		102,
		105,
		95,
		70,
		63,
		49,
		51,
		49,
		47,
		47,
		51,
		43,
		53,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		123,
		-1,
		-1,
		106,
		97,
		87,
		66,
		53,
		73,
		72,
		57,
		41,
		56,
		57,
		45,
		54,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		77,
		57,
		71,
		78,
		59,
		54,
		48,
		51,
		62,
		56,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		73,
		59,
		76,
		72,
		69,
		60,
		52,
		57,
		54,
		67,
		68,
		58,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		67,
		83,
		80,
		91,
		59,
		55,
		56,
		60,
		59,
		72,
		73,
		-1,
		-1,
		165,
		182,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		74,
		77,
		80,
		65,
		62,
		67,
		72,
		60,
		69,
		87,
		76,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		176,
		160,
		107,
		89,
		85,
		83,
		76,
		85,
		77,
		70,
		80,
		90,
		82,
		62,
		80,
		97,
		84,
		109,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		178,
		170,
		165,
		171,
		173,
		164,
		122,
		119,
		-1,
		89,
		114,
		83,
		90,
		82,
		88,
		88,
		86,
		67,
		77,
		93,
		92,
		87,
		101,
		96,
		105,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		138,
		135,
		111,
		92,
		98,
		91,
		86,
		99,
		79,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		103,
		111,
		-1,
		192,
		257,
		250,
		218,
		226,
		257,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		111,
		108,
		111,
		99,
		96,
		109,
		104,
		95,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		206,
		233,
		212,
		215,
		239,
		253,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		110,
		158,
		113,
		108,
		103,
		101,
		92,
		83,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		202,
		213,
		206,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		186,
		-1,
		153,
		-1,
		128,
		132,
		121,
		124,
		117,
		104,
		96,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		227,
		183,
		186,
		197,
		208,
		223,
		227,
		-1,
		170,
		209,
		216,
		-1,
		195,
		-1,
		-1,
		-1,
		142,
		134,
		126,
		137,
		116,
		116,
		90,
		94,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		185,
		176,
		203,
		223,
		212,
		207,
		194,
		-1,
		-1,
		165,
		144,
		-1,
		-1,
		123,
		111,
		94,
		95,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		204,
		196,
		200,
		216,
		241,
		-1,
		183,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		170,
		176,
		183,
		200,
		230,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		119,
		123,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		243,
		-1,
		195,
		171,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		183,
		186,
		-1,
		-1,
		196,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		190,
		191,
		196,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		154,
		117,
		138,
		148,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		118,
		144,
		147,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		169,
		154,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		159,
		155,
		142,
		142,
		134,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		135,
		170,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		142,
		143,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		187,
		191,
		157,
		151,
		190,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		180,
		179,
		147,
		145,
		154,
		159,
		166,
		-1,
		165,
		-1,
		201,
		180,
		191,
		196,
		140,
		137,
		157,
		176,
		158,
		150,
		216,
		170,
		141,
		135,
		153,
		143,
		152,
		144,
		-1,
		141,
		131,
		153,
		132,
		143,
		135,
		-1,
		-1,
		135,
		136,
		142,
		128,
		134,
		130,
		-1,
		140,
		124,
		-1,
		-1,
		125,
		126,
		110,
		113,
		121,
		119,
		132,
		124,
		119,
		-1,
		-1,
		116,
		112,
		119,
		106,
		102,
		119,
		132,
		114,
		128,
		127,
		-1,
		116,
		134,
		143,
		113,
		111,
		95,
		93,
		111,
		113,
		119,
		119,
		-1,
		125,
		126,
		121,
		129,
		134,
		111,
		98,
		98,
		108,
		101,
		120,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		108,
		125,
		117,
		107,
		122,
		115,
		101,
		98,
		96,
		93,
		109,
		107,
		117,
		-1,
		-1,
		218,
		187,
		216,
		174,
		155,
		-1,
		121,
		101,
		107,
		111,
		105,
		98,
		112,
		108,
		-1,
		87,
		86,
		114,
		100,
		111,
		178,
		-1,
		-1,
		176,
		168,
		151,
		154,
		131,
		127,
		116,
		115,
		107,
		93,
		89,
		95,
		98,
		98,
		104,
		81,
		91,
		95,
		93,
		108,
		-1,
		-1,
		122,
		-1,
		-1,
		175,
		158,
		-1,
		141,
		148,
		137,
		143,
		129,
		150,
		126,
		117,
		109,
		103,
		91,
		93,
		90,
		103,
		91,
		78,
		103,
		107,
		88,
		98,
		93,
		-1,
		121,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		134,
		137,
		143,
		167,
		166,
		-1,
		138,
		126,
		127,
		112,
		109,
		96,
		84,
		97,
		82,
		89,
		88,
		82,
		80,
		110,
		85,
		97,
		87,
		92,
		97,
		91,
		100,
		-1,
		183,
		179,
		175,
		182,
		131,
		-1,
		-1,
		171,
		-1,
		174,
		175,
		150,
		123,
		126,
		113,
		104,
		91,
		80,
		91,
		80,
		77,
		85,
		74,
		89,
		80,
		79,
		76,
		76,
		84,
		88,
		94,
		-1,
		233,
		-1,
		175,
		159,
		161,
		133,
		154,
		-1,
		191,
		175,
		167,
		152,
		152,
		-1,
		122,
		119,
		109,
		87,
		72,
		89,
		81,
		79,
		84,
		69,
		83,
		74,
		82,
		80,
		66,
		70,
		90,
		102,
		193,
		183,
		-1,
		165,
		170,
		129,
		137,
		156,
		194,
		158,
		-1,
		153,
		-1,
		124,
		137,
		-1,
		93,
		89,
		71,
		72,
		67,
		82,
		80,
		65,
		62,
		78,
		73,
		59,
		63,
		79,
		-1,
		-1,
		178,
		182,
		171,
		122,
		141,
		165,
		202,
		151,
		140,
		139,
		-1,
		130,
		107,
		104,
		92,
		79,
		64,
		65,
		73,
		86,
		65,
		64,
		61,
		69,
		76,
		54,
		65,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		148,
		119,
		143,
		185,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		103,
		82,
		73,
		62,
		60,
		73,
		70,
		79,
		59,
		57,
		64,
		57,
		48,
		56,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		114,
		137,
		174,
		148,
		134,
		139,
		114,
		107,
		101,
		116,
		99,
		80,
		69,
		61,
		50,
		66,
		74,
		73,
		55,
		64,
		58,
		63,
		44,
		50,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		128,
		135,
		167,
		139,
		152,
		-1,
		106,
		-1,
		95,
		90,
		74,
		69,
		66,
		59,
		57,
		66,
		72,
		62,
		57,
		64,
		68,
		68,
		34,
		52,
		55,
		-1,
		-1,
		-1,
		178,
		173,
		148,
		125,
		109,
		145,
		-1,
		122,
		123,
		-1,
		100,
		94,
		91,
		76,
		72,
		63,
		67,
		64,
		71,
		60,
		66,
		67,
		49,
		73,
		-1,
		37,
		36,
		42,
		32,
		22,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		104,
		156,
		-1,
		-1,
		107,
		100,
		-1,
		87,
		69,
		75,
		70,
		68,
		68,
		65,
		54,
		67,
		60,
		54,
		48,
		61,
		57,
		26,
		24,
		20,
		17,
		31,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		124,
		-1,
		116,
		108,
		98,
		92,
		86,
		82,
		80,
		96,
		80,
		80,
		77,
		68,
		76,
		49,
		42,
		53,
		38,
		56,
		25,
		13,
		0,
		9,
		27,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		137,
		-1,
		101,
		115,
		131,
		-1,
		124,
		103,
		118,
		96,
		92,
		87,
		103,
		104,
		82,
		77,
		75,
		66,
		54,
		43,
		46,
		38,
		29,
		21,
		7,
		5,
		14,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		98,
		86,
		118,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		101,
		99,
		93,
		84,
		90,
		86,
		63,
		58,
		48,
		37,
		37,
		32,
		29,
		15,
		13,
		17,
		33,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		101,
		85,
		90,
		-1,
		83,
		-1,
		56,
		53,
		44,
		29,
		26,
		25,
		16,
		29,
		23,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		155,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		117,
		97,
		91,
		90,
		78,
		70,
		64,
		42,
		35,
		32,
		29,
		42,
		49,
		36,
		25,
		-1,
		-1,
		-1,
		152,
		138,
		142,
		102,
		121,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		125,
		113,
		103,
		93,
		96,
		86,
		61,
		54,
		40,
		42,
		40,
		38,
		38,
		38,
		30,
		40,
		-1,
		-1,
		135,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		114,
		-1,
		-1,
		97,
		88,
		78,
		57,
		44,
		64,
		63,
		48,
		32,
		47,
		44,
		32,
		41,
		-1,
		138,
		125,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		165,
		110,
		99,
		94,
		98,
		96,
		-1,
		70,
		68,
		48,
		62,
		69,
		50,
		45,
		39,
		42,
		49,
		43,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		122,
		116,
		87,
		80,
		84,
		-1,
		72,
		64,
		50,
		67,
		63,
		60,
		51,
		43,
		48,
		45,
		58,
		55,
		45,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		140,
		155,
		126,
		103,
		76,
		71,
		64,
		58,
		58,
		74,
		71,
		82,
		50,
		46,
		47,
		51,
		50,
		59,
		60,
		-1,
		-1,
		156,
		173,
		166,
		148,
		152,
		153,
		-1,
		-1,
		80,
		71,
		62,
		65,
		68,
		71,
		56,
		53,
		58,
		63,
		51,
		60,
		78,
		63,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		167,
		151,
		98,
		80,
		76,
		74,
		67,
		76,
		68,
		61,
		71,
		81,
		73,
		53,
		71,
		88,
		71,
		96,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		169,
		161,
		156,
		162,
		164,
		155,
		113,
		110,
		-1,
		80,
		105,
		74,
		81,
		73,
		79,
		79,
		77,
		58,
		68,
		84,
		83,
		78,
		88,
		83,
		92,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		162,
		158,
		148,
		138,
		141,
		-1,
		-1,
		129,
		126,
		102,
		83,
		89,
		82,
		77,
		90,
		70,
		57,
		61,
		65,
		71,
		76,
		81,
		87,
		90,
		98,
		-1,
		183,
		248,
		241,
		209,
		217,
		248,
		-1,
		152,
		144,
		155,
		130,
		132,
		-1,
		-1,
		102,
		99,
		102,
		90,
		87,
		100,
		95,
		86,
		71,
		77,
		64,
		63,
		81,
		85,
		94,
		101,
		91,
		104,
		108,
		-1,
		197,
		224,
		203,
		206,
		230,
		244,
		-1,
		149,
		-1,
		-1,
		161,
		133,
		117,
		107,
		101,
		149,
		104,
		99,
		94,
		92,
		83,
		74,
		81,
		72,
		72,
		75,
		90,
		95,
		87,
		101,
		101,
		102,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		177,
		-1,
		144,
		-1,
		119,
		123,
		112,
		115,
		108,
		95,
		87,
		79,
		95,
		70,
		80,
		76,
		77,
		86,
		97,
		109,
		108,
		109,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		161,
		200,
		207,
		-1,
		186,
		-1,
		-1,
		-1,
		133,
		125,
		117,
		128,
		107,
		107,
		81,
		85,
		75,
		82,
		92,
		94,
		86,
		90,
		103,
		114,
		117,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		176,
		167,
		194,
		214,
		203,
		198,
		185,
		-1,
		-1,
		156,
		135,
		-1,
		-1,
		114,
		102,
		85,
		86,
		82,
		85,
		100,
		103,
		93,
		91,
		85,
		117,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		195,
		187,
		191,
		207,
		232,
		-1,
		174,
		-1,
		-1,
		159,
		-1,
		-1,
		144,
		107,
		96,
		87,
		93,
		90,
		101,
		111,
		99,
		100,
		90,
		100,
		113,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		191,
		221,
		-1,
		-1,
		190,
		170,
		-1,
		-1,
		142,
		140,
		129,
		-1,
		119,
		92,
		97,
		117,
		119,
		108,
		102,
		96,
		103,
		102,
		110,
		118,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		180,
		176,
		-1,
		-1,
		137,
		130,
		118,
		106,
		96,
		106,
		110,
		114,
		106,
		99,
		94,
		105,
		97,
		101,
		118,
		-1,
		234,
		-1,
		186,
		162,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		197,
		183,
		176,
		164,
		162,
		-1,
		171,
		155,
		136,
		-1,
		106,
		119,
		150,
		118,
		123,
		118,
		100,
		111,
		100,
		103,
		117,
		112,
		-1,
		-1,
		174,
		177,
		-1,
		-1,
		187,
		189,
		-1,
		188,
		177,
		162,
		154,
		-1,
		-1,
		143,
		139,
		-1,
		-1,
		107,
		132,
		121,
		129,
		124,
		104,
		110,
		113,
		102,
		106,
		118,
		-1,
		-1,
		181,
		182,
		187,
		-1,
		172,
		-1,
		190,
		-1,
		157,
		163,
		151,
		-1,
		-1,
		-1,
		145,
		108,
		129,
		139,
		133,
		131,
		122,
		108,
		115,
		113,
		109,
		120,
		-1,
		-1,
		-1,
		190,
		164,
		197,
		188,
		171,
		151,
		143,
		162,
		-1,
		132,
		-1,
		107,
		109,
		135,
		138,
		144,
		138,
		111,
		126,
		116,
		107,
		116,
		196,
		-1,
		166,
		199,
		163,
		157,
		133,
		137,
		153,
		-1,
		129,
		111,
		-1,
		139,
		129,
		160,
		145,
		126,
		113,
		120,
		120,
		113,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		153,
		138,
		129,
		-1,
		141,
		123,
		102,
		119,
		119,
		110,
		118,
		150,
		146,
		133,
		133,
		125,
		-1,
		269,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		157,
		130,
		118,
		124,
		120,
		106,
		112,
		114,
		122,
		120,
		117,
		129,
		125,
		145,
		126,
		161,
		-1,
		264,
		-1,
		198,
		-1,
		-1,
		180,
		160,
		152,
		141,
		130,
		128,
		119,
		110,
		132,
		148,
		132,
		130,
		133,
		134,
		-1,
		253,
		252,
		-1,
		199,
		191,
		177,
		-1,
		170,
		-1,
		176,
		137,
		-1,
		139,
		119,
		-1,
		141,
		137,
		-1,
		-1,
		240,
		215,
		-1,
		-1,
		-1,
		200,
		180,
		171,
		155,
		-1,
		130,
		130,
		-1,
		-1,
		-1,
		225,
		224,
		-1,
		193,
		196,
		-1,
		186,
		177,
		185,
		132,
		136,
		-1,
		-1,
		-1,
		234,
		215,
		209,
		208,
		206,
		201,
		198,
		184,
		168,
		146,
		135,
		156,
		-1,
		-1,
		-1,
		206,
		198,
		191,
		-1,
		-1,
		193,
		176,
		157,
		155,
		-1,
		-1,
		-1,
		228,
		209,
		-1,
		-1,
		183,
		-1,
		-1,
		189,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		217,
		-1,
		-1,
		-1,
		179,
		175,
		176,
		-1,
		-1,
		-1,
		-1,
		239,
		240,
		263,
		227,
		-1,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		242,
		240,
		-1,
		-1,
		-1,
		199,
		183,
		-1,
		169,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		204,
		-1,
		204,
		179,
		186,
		-1,
		-1,
		-1,
		-1,
		217,
		209,
		217,
		-1,
		189,
		191,
		-1,
		239,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		194,
		201,
		223,
		226,
		262,
		-1,
		213
	],
	[
		-1,
		179,
		168,
		179,
		187,
		160,
		167,
		-1,
		186,
		190,
		156,
		150,
		189,
		158,
		164,
		175,
		-1,
		-1,
		-1,
		179,
		178,
		146,
		144,
		153,
		158,
		165,
		-1,
		164,
		-1,
		200,
		179,
		190,
		195,
		139,
		136,
		156,
		175,
		157,
		149,
		215,
		169,
		140,
		134,
		152,
		142,
		151,
		143,
		-1,
		140,
		130,
		152,
		131,
		142,
		134,
		-1,
		-1,
		134,
		135,
		141,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		124,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		115,
		133,
		142,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		118,
		-1,
		124,
		125,
		120,
		128,
		133,
		110,
		97,
		97,
		107,
		100,
		119,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		107,
		124,
		116,
		106,
		121,
		114,
		100,
		97,
		95,
		92,
		108,
		106,
		116,
		-1,
		-1,
		217,
		186,
		215,
		173,
		154,
		-1,
		120,
		100,
		106,
		110,
		104,
		97,
		111,
		107,
		-1,
		86,
		85,
		113,
		99,
		110,
		177,
		-1,
		-1,
		175,
		167,
		150,
		153,
		130,
		126,
		115,
		114,
		106,
		92,
		88,
		94,
		97,
		97,
		103,
		80,
		90,
		94,
		92,
		99,
		-1,
		-1,
		113,
		-1,
		-1,
		174,
		157,
		-1,
		140,
		147,
		136,
		142,
		128,
		149,
		125,
		116,
		108,
		102,
		90,
		92,
		89,
		102,
		90,
		77,
		102,
		106,
		87,
		89,
		84,
		-1,
		112,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		136,
		142,
		166,
		165,
		-1,
		137,
		125,
		126,
		111,
		108,
		95,
		83,
		96,
		81,
		88,
		87,
		81,
		79,
		109,
		84,
		88,
		78,
		83,
		88,
		82,
		91,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		170,
		-1,
		173,
		174,
		149,
		122,
		125,
		112,
		103,
		90,
		79,
		90,
		79,
		76,
		84,
		73,
		88,
		79,
		78,
		67,
		67,
		75,
		79,
		85,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		190,
		174,
		166,
		151,
		151,
		-1,
		121,
		118,
		108,
		86,
		71,
		88,
		80,
		78,
		83,
		68,
		82,
		73,
		73,
		71,
		57,
		61,
		81,
		93,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		123,
		136,
		-1,
		92,
		88,
		70,
		71,
		66,
		81,
		79,
		64,
		61,
		69,
		64,
		50,
		54,
		70,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		106,
		103,
		91,
		78,
		63,
		64,
		72,
		85,
		64,
		63,
		60,
		60,
		67,
		45,
		56,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		102,
		81,
		72,
		61,
		59,
		72,
		69,
		78,
		58,
		56,
		55,
		48,
		39,
		47,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		115,
		98,
		79,
		68,
		60,
		49,
		65,
		73,
		72,
		54,
		63,
		49,
		54,
		35,
		41,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		89,
		73,
		68,
		65,
		58,
		56,
		65,
		71,
		61,
		56,
		63,
		59,
		59,
		25,
		43,
		46,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		75,
		71,
		62,
		66,
		63,
		70,
		59,
		65,
		66,
		48,
		72,
		-1,
		33,
		27,
		33,
		23,
		13,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		74,
		69,
		67,
		67,
		64,
		53,
		66,
		59,
		53,
		47,
		60,
		48,
		31,
		15,
		11,
		8,
		22,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		95,
		79,
		79,
		76,
		67,
		75,
		48,
		41,
		52,
		37,
		55,
		28,
		18,
		8,
		0,
		18,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		86,
		102,
		103,
		81,
		76,
		74,
		65,
		53,
		42,
		45,
		37,
		30,
		22,
		6,
		3,
		5,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		100,
		98,
		92,
		83,
		89,
		85,
		62,
		57,
		47,
		36,
		36,
		31,
		28,
		14,
		12,
		8,
		24,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		100,
		84,
		89,
		-1,
		82,
		-1,
		55,
		52,
		43,
		28,
		25,
		24,
		15,
		28,
		14,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		116,
		96,
		90,
		89,
		77,
		69,
		63,
		41,
		34,
		31,
		28,
		41,
		48,
		28,
		16,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		124,
		112,
		102,
		92,
		95,
		85,
		60,
		53,
		39,
		41,
		39,
		37,
		37,
		29,
		21,
		31,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		113,
		-1,
		-1,
		96,
		87,
		77,
		56,
		43,
		63,
		62,
		47,
		31,
		45,
		35,
		23,
		32,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		164,
		109,
		98,
		93,
		97,
		95,
		-1,
		69,
		67,
		47,
		61,
		68,
		49,
		44,
		38,
		40,
		40,
		34,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		86,
		79,
		83,
		-1,
		71,
		63,
		49,
		66,
		62,
		59,
		50,
		42,
		47,
		37,
		50,
		46,
		36,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		139,
		154,
		125,
		102,
		75,
		70,
		63,
		57,
		57,
		73,
		70,
		81,
		49,
		45,
		46,
		43,
		42,
		50,
		51,
		-1,
		-1,
		155,
		172,
		165,
		147,
		151,
		152,
		-1,
		-1,
		79,
		70,
		61,
		64,
		67,
		70,
		55,
		52,
		57,
		60,
		50,
		52,
		69,
		54,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		166,
		150,
		97,
		79,
		75,
		73,
		66,
		75,
		67,
		60,
		70,
		78,
		70,
		50,
		68,
		80,
		62,
		87,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		112,
		109,
		-1,
		79,
		104,
		73,
		80,
		72,
		78,
		78,
		74,
		55,
		67,
		83,
		74,
		73,
		79,
		74,
		83,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		128,
		125,
		101,
		82,
		88,
		81,
		76,
		89,
		69,
		56,
		60,
		64,
		70,
		71,
		76,
		82,
		81,
		89,
		-1,
		182,
		247,
		240,
		208,
		216,
		247,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		101,
		98,
		101,
		89,
		86,
		99,
		94,
		85,
		70,
		76,
		63,
		62,
		80,
		84,
		89,
		95,
		84,
		97,
		101,
		-1,
		196,
		223,
		202,
		205,
		229,
		243,
		-1,
		148,
		-1,
		-1,
		160,
		132,
		116,
		106,
		100,
		148,
		103,
		98,
		93,
		91,
		82,
		73,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		94,
		94,
		95,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		176,
		-1,
		143,
		-1,
		118,
		122,
		111,
		114,
		107,
		94,
		86,
		78,
		94,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		101,
		102,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		160,
		199,
		206,
		-1,
		185,
		-1,
		-1,
		-1,
		132,
		124,
		116,
		127,
		106,
		106,
		80,
		84,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		111,
		110,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		175,
		166,
		193,
		213,
		202,
		197,
		184,
		-1,
		-1,
		155,
		134,
		-1,
		-1,
		113,
		101,
		84,
		85,
		81,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		194,
		186,
		190,
		206,
		231,
		-1,
		173,
		-1,
		-1,
		158,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		89,
		100,
		110,
		98,
		99,
		89,
		99,
		112,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		189,
		169,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		116,
		118,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		179,
		175,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		109,
		113,
		105,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		196,
		182,
		175,
		163,
		161,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		186,
		188,
		-1,
		187,
		176,
		161,
		153,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		180,
		181,
		186,
		-1,
		171,
		-1,
		189,
		-1,
		156,
		162,
		150,
		-1,
		-1,
		-1,
		144,
		107,
		128,
		138,
		132,
		130,
		121,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		189,
		163,
		196,
		187,
		170,
		150,
		142,
		161,
		-1,
		131,
		-1,
		106,
		108,
		134,
		137,
		143,
		137,
		110,
		125,
		115,
		106,
		115,
		195,
		-1,
		165,
		198,
		162,
		156,
		132,
		136,
		152,
		-1,
		128,
		110,
		-1,
		138,
		128,
		159,
		144,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		167,
		166,
		158,
		152,
		152,
		137,
		128,
		-1,
		140,
		122,
		101,
		118,
		118,
		109,
		117,
		149,
		145,
		132,
		132,
		124,
		-1,
		268,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		161,
		156,
		129,
		117,
		123,
		119,
		105,
		111,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		125,
		160,
		-1,
		263,
		-1,
		197,
		-1,
		-1,
		179,
		159,
		151,
		140,
		129,
		127,
		118,
		109,
		131,
		147,
		131,
		129,
		132,
		133,
		-1,
		252,
		251,
		-1,
		198,
		190,
		176,
		-1,
		169,
		-1,
		175,
		136,
		-1,
		138,
		118,
		-1,
		140,
		136,
		-1,
		-1,
		239,
		214,
		-1,
		-1,
		-1,
		199,
		179,
		170,
		154,
		-1,
		129,
		129,
		-1,
		-1,
		-1,
		224,
		223,
		-1,
		192,
		195,
		-1,
		185,
		176,
		184,
		131,
		135,
		-1,
		-1,
		-1,
		233,
		214,
		208,
		207,
		205,
		200,
		197,
		183,
		167,
		145,
		134,
		155,
		-1,
		-1,
		-1,
		205,
		197,
		190,
		-1,
		-1,
		192,
		175,
		156,
		154,
		-1,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		182,
		-1,
		-1,
		188,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		216,
		-1,
		-1,
		-1,
		178,
		174,
		175,
		-1,
		-1,
		-1,
		-1,
		238,
		239,
		262,
		226,
		-1,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		241,
		239,
		-1,
		-1,
		-1,
		198,
		182,
		-1,
		168,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		203,
		-1,
		203,
		178,
		185,
		-1,
		-1,
		-1,
		-1,
		216,
		208,
		216,
		-1,
		188,
		190,
		-1,
		238,
		-1,
		-1,
		231,
		222,
		-1,
		-1,
		193,
		200,
		222,
		225,
		261,
		-1,
		212
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		134,
		-1,
		131,
		149,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		126,
		-1,
		140,
		141,
		136,
		144,
		143,
		119,
		106,
		106,
		116,
		109,
		128,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		123,
		140,
		132,
		122,
		137,
		130,
		109,
		106,
		104,
		101,
		117,
		114,
		124,
		-1,
		-1,
		232,
		201,
		231,
		189,
		170,
		-1,
		136,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		95,
		94,
		121,
		107,
		118,
		192,
		-1,
		-1,
		190,
		182,
		166,
		169,
		146,
		142,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		89,
		99,
		103,
		100,
		103,
		-1,
		-1,
		117,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		152,
		158,
		144,
		165,
		141,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		86,
		111,
		115,
		95,
		93,
		88,
		-1,
		116,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		181,
		-1,
		153,
		141,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		90,
		88,
		118,
		92,
		92,
		82,
		87,
		92,
		86,
		95,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		189,
		190,
		165,
		138,
		141,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		82,
		97,
		87,
		86,
		71,
		71,
		79,
		83,
		89,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		190,
		182,
		167,
		166,
		-1,
		137,
		134,
		124,
		102,
		87,
		104,
		96,
		94,
		95,
		77,
		91,
		81,
		77,
		75,
		61,
		65,
		85,
		97,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		139,
		152,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		88,
		73,
		70,
		73,
		68,
		54,
		58,
		74,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		122,
		119,
		107,
		94,
		79,
		80,
		88,
		101,
		80,
		72,
		71,
		64,
		71,
		49,
		60,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		118,
		97,
		88,
		77,
		75,
		88,
		81,
		88,
		69,
		67,
		59,
		52,
		43,
		51,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		131,
		114,
		95,
		84,
		76,
		65,
		77,
		85,
		83,
		65,
		73,
		53,
		58,
		39,
		45,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		105,
		89,
		84,
		81,
		69,
		68,
		81,
		82,
		72,
		67,
		74,
		63,
		63,
		29,
		49,
		52,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		91,
		87,
		73,
		77,
		79,
		82,
		70,
		76,
		77,
		59,
		83,
		-1,
		37,
		31,
		39,
		29,
		17,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		85,
		80,
		79,
		78,
		75,
		64,
		77,
		70,
		64,
		58,
		71,
		52,
		42,
		19,
		15,
		12,
		14,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		107,
		91,
		90,
		87,
		78,
		86,
		59,
		52,
		63,
		48,
		66,
		44,
		34,
		27,
		19,
		0,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		97,
		114,
		115,
		93,
		87,
		85,
		76,
		64,
		53,
		56,
		48,
		46,
		38,
		22,
		22,
		24,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		111,
		109,
		104,
		95,
		101,
		96,
		73,
		68,
		58,
		47,
		47,
		42,
		44,
		30,
		28,
		23,
		27,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		112,
		96,
		101,
		-1,
		93,
		-1,
		66,
		63,
		54,
		39,
		36,
		40,
		31,
		44,
		29,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		128,
		108,
		102,
		101,
		88,
		80,
		74,
		52,
		45,
		42,
		39,
		52,
		64,
		43,
		31,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		135,
		123,
		113,
		103,
		106,
		96,
		71,
		64,
		50,
		52,
		50,
		48,
		53,
		44,
		36,
		46,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		156,
		127,
		124,
		-1,
		-1,
		107,
		98,
		88,
		67,
		54,
		74,
		77,
		63,
		47,
		60,
		50,
		38,
		47,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		120,
		109,
		104,
		108,
		106,
		-1,
		80,
		78,
		58,
		72,
		79,
		65,
		60,
		54,
		52,
		55,
		49,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		97,
		90,
		94,
		-1,
		82,
		74,
		60,
		77,
		78,
		75,
		66,
		58,
		63,
		49,
		62,
		57,
		51,
		187,
		-1,
		170,
		-1,
		-1,
		-1,
		150,
		165,
		136,
		113,
		86,
		81,
		74,
		68,
		68,
		84,
		86,
		97,
		65,
		61,
		62,
		55,
		54,
		61,
		62,
		-1,
		-1,
		170,
		184,
		176,
		158,
		162,
		163,
		-1,
		-1,
		90,
		81,
		72,
		75,
		78,
		81,
		71,
		68,
		73,
		72,
		65,
		64,
		82,
		68,
		-1,
		-1,
		-1,
		190,
		-1,
		202,
		-1,
		-1,
		177,
		161,
		108,
		90,
		86,
		84,
		77,
		86,
		81,
		76,
		86,
		90,
		82,
		62,
		79,
		92,
		76,
		87,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		179,
		171,
		166,
		172,
		174,
		165,
		123,
		120,
		-1,
		90,
		115,
		87,
		94,
		86,
		94,
		94,
		86,
		67,
		76,
		92,
		88,
		86,
		79,
		74,
		83,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		172,
		168,
		158,
		148,
		151,
		-1,
		-1,
		139,
		136,
		112,
		96,
		100,
		93,
		88,
		98,
		78,
		65,
		69,
		73,
		79,
		84,
		89,
		92,
		81,
		89,
		-1,
		197,
		261,
		254,
		222,
		230,
		261,
		-1,
		162,
		154,
		165,
		140,
		142,
		-1,
		-1,
		112,
		109,
		114,
		103,
		100,
		108,
		103,
		94,
		79,
		85,
		72,
		71,
		89,
		93,
		102,
		95,
		84,
		97,
		101,
		-1,
		211,
		237,
		216,
		219,
		243,
		257,
		-1,
		159,
		-1,
		-1,
		171,
		143,
		127,
		117,
		111,
		161,
		117,
		112,
		102,
		100,
		91,
		82,
		89,
		80,
		80,
		83,
		98,
		103,
		95,
		94,
		94,
		95,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		187,
		-1,
		154,
		-1,
		129,
		133,
		125,
		128,
		116,
		103,
		95,
		87,
		103,
		78,
		88,
		84,
		85,
		94,
		105,
		115,
		101,
		102,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		171,
		210,
		215,
		-1,
		196,
		-1,
		-1,
		-1,
		143,
		138,
		130,
		136,
		115,
		115,
		89,
		93,
		83,
		90,
		100,
		102,
		94,
		98,
		111,
		111,
		110,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		186,
		177,
		204,
		222,
		211,
		206,
		193,
		-1,
		-1,
		166,
		148,
		-1,
		-1,
		122,
		110,
		93,
		94,
		90,
		93,
		108,
		111,
		101,
		99,
		93,
		116,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		205,
		200,
		204,
		220,
		245,
		-1,
		182,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		115,
		104,
		95,
		101,
		98,
		109,
		119,
		107,
		108,
		98,
		108,
		121,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		100,
		105,
		125,
		127,
		116,
		110,
		104,
		111,
		110,
		118,
		126,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		118,
		122,
		114,
		107,
		102,
		113,
		105,
		109,
		126,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		158,
		126,
		131,
		126,
		108,
		119,
		108,
		111,
		125,
		120,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		195,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		115,
		140,
		129,
		137,
		132,
		112,
		118,
		121,
		110,
		114,
		125,
		-1,
		-1,
		194,
		195,
		200,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		153,
		116,
		137,
		147,
		141,
		139,
		130,
		116,
		123,
		121,
		117,
		128,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		117,
		143,
		146,
		152,
		146,
		119,
		134,
		124,
		115,
		124,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		168,
		153,
		134,
		121,
		128,
		128,
		121,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		158,
		154,
		141,
		141,
		133,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		134,
		169,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		141,
		142,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		233,
		222,
		233,
		241,
		214,
		221,
		-1,
		242,
		244,
		210,
		204,
		243,
		214,
		220,
		231,
		-1,
		-1,
		-1,
		233,
		232,
		202,
		200,
		209,
		214,
		221,
		-1,
		244,
		-1,
		254,
		233,
		244,
		249,
		195,
		192,
		212,
		231,
		237,
		229,
		269,
		225,
		196,
		190,
		208,
		213,
		231,
		223,
		-1,
		196,
		186,
		208,
		212,
		224,
		207,
		-1,
		-1,
		190,
		191,
		197,
		209,
		214,
		219,
		-1,
		242,
		226,
		-1,
		-1,
		180,
		193,
		189,
		192,
		200,
		216,
		234,
		226,
		221,
		-1,
		-1,
		181,
		185,
		198,
		199,
		197,
		221,
		234,
		216,
		230,
		229,
		-1,
		169,
		187,
		196,
		205,
		211,
		197,
		195,
		213,
		215,
		221,
		224,
		-1,
		161,
		163,
		192,
		198,
		210,
		213,
		200,
		200,
		210,
		203,
		222,
		213,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		166,
		192,
		191,
		187,
		205,
		210,
		203,
		200,
		198,
		195,
		211,
		212,
		222,
		-1,
		-1,
		214,
		183,
		218,
		175,
		160,
		-1,
		154,
		173,
		179,
		183,
		188,
		193,
		207,
		203,
		-1,
		189,
		188,
		219,
		205,
		216,
		174,
		-1,
		-1,
		172,
		164,
		149,
		152,
		149,
		149,
		179,
		178,
		183,
		185,
		184,
		190,
		193,
		193,
		199,
		183,
		193,
		197,
		208,
		223,
		-1,
		-1,
		278,
		-1,
		-1,
		171,
		154,
		-1,
		137,
		144,
		144,
		161,
		151,
		172,
		187,
		191,
		199,
		198,
		186,
		188,
		185,
		198,
		186,
		180,
		205,
		209,
		203,
		224,
		219,
		-1,
		277,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		130,
		133,
		139,
		163,
		173,
		-1,
		194,
		192,
		216,
		207,
		204,
		191,
		179,
		192,
		177,
		184,
		183,
		187,
		189,
		222,
		200,
		222,
		219,
		248,
		253,
		247,
		256,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		167,
		-1,
		181,
		194,
		198,
		196,
		199,
		208,
		199,
		186,
		175,
		186,
		175,
		172,
		180,
		189,
		200,
		195,
		194,
		212,
		227,
		240,
		244,
		250,
		-1,
		229,
		-1,
		171,
		155,
		157,
		129,
		150,
		-1,
		187,
		182,
		202,
		200,
		191,
		-1,
		194,
		197,
		204,
		182,
		167,
		184,
		176,
		174,
		179,
		184,
		198,
		189,
		207,
		214,
		222,
		226,
		246,
		258,
		189,
		179,
		-1,
		161,
		166,
		125,
		133,
		152,
		225,
		197,
		-1,
		192,
		-1,
		184,
		209,
		-1,
		188,
		184,
		166,
		167,
		162,
		177,
		183,
		180,
		177,
		195,
		198,
		215,
		219,
		235,
		-1,
		-1,
		174,
		178,
		167,
		118,
		137,
		161,
		198,
		190,
		179,
		178,
		-1,
		169,
		199,
		196,
		182,
		169,
		159,
		160,
		168,
		181,
		160,
		179,
		182,
		204,
		232,
		210,
		222,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		144,
		115,
		139,
		181,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		189,
		172,
		168,
		157,
		155,
		168,
		163,
		179,
		183,
		182,
		201,
		213,
		204,
		224,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		187,
		173,
		178,
		153,
		146,
		140,
		192,
		189,
		156,
		164,
		156,
		145,
		159,
		167,
		171,
		180,
		189,
		195,
		219,
		219,
		225,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		178,
		175,
		-1,
		145,
		-1,
		134,
		142,
		141,
		147,
		159,
		145,
		150,
		161,
		173,
		186,
		182,
		189,
		224,
		224,
		209,
		229,
		232,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		145,
		146,
		-1,
		139,
		133,
		139,
		138,
		145,
		142,
		142,
		156,
		164,
		160,
		176,
		182,
		174,
		210,
		-1,
		217,
		211,
		219,
		209,
		197,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		130,
		123,
		-1,
		126,
		126,
		133,
		142,
		147,
		152,
		160,
		155,
		168,
		173,
		179,
		184,
		202,
		206,
		210,
		199,
		195,
		192,
		206,
		-1,
		9,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		139,
		131,
		121,
		115,
		121,
		139,
		137,
		157,
		149,
		163,
		163,
		169,
		177,
		162,
		165,
		181,
		179,
		197,
		205,
		197,
		191,
		190,
		202,
		-1,
		0,
		42,
		39,
		-1,
		-1,
		133,
		-1,
		97,
		121,
		137,
		-1,
		155,
		134,
		157,
		135,
		149,
		145,
		183,
		184,
		162,
		167,
		175,
		185,
		187,
		176,
		187,
		179,
		201,
		201,
		185,
		186,
		195,
		-1,
		62,
		39,
		43,
		55,
		61,
		122,
		94,
		103,
		124,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		159,
		157,
		173,
		164,
		170,
		186,
		189,
		191,
		181,
		170,
		176,
		173,
		195,
		181,
		179,
		198,
		214,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		88,
		88,
		90,
		-1,
		141,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		181,
		165,
		170,
		-1,
		216,
		-1,
		189,
		191,
		185,
		170,
		167,
		178,
		176,
		187,
		204,
		-1,
		122,
		107,
		100,
		90,
		117,
		88,
		-1,
		144,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		197,
		177,
		171,
		170,
		211,
		211,
		197,
		183,
		176,
		173,
		170,
		183,
		203,
		194,
		206,
		-1,
		-1,
		-1,
		127,
		134,
		131,
		98,
		110,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		214,
		202,
		192,
		182,
		216,
		217,
		202,
		195,
		181,
		183,
		181,
		179,
		184,
		205,
		206,
		219,
		-1,
		-1,
		131,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		173,
		189,
		181,
		152,
		203,
		-1,
		-1,
		194,
		192,
		202,
		198,
		185,
		205,
		208,
		194,
		178,
		193,
		205,
		213,
		218,
		-1,
		134,
		121,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		184,
		205,
		230,
		197,
		-1,
		202,
		203,
		189,
		203,
		210,
		196,
		191,
		185,
		188,
		206,
		223,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		163,
		177,
		198,
		204,
		216,
		-1,
		211,
		205,
		191,
		208,
		209,
		206,
		197,
		189,
		194,
		191,
		204,
		218,
		222,
		162,
		-1,
		145,
		-1,
		-1,
		-1,
		181,
		196,
		258,
		235,
		208,
		212,
		205,
		199,
		199,
		215,
		217,
		228,
		196,
		192,
		193,
		197,
		196,
		213,
		223,
		-1,
		-1,
		145,
		162,
		197,
		189,
		193,
		285,
		-1,
		-1,
		221,
		212,
		203,
		206,
		209,
		212,
		202,
		199,
		204,
		209,
		197,
		206,
		224,
		228,
		-1,
		-1,
		-1,
		165,
		-1,
		180,
		-1,
		-1,
		208,
		292,
		239,
		221,
		217,
		215,
		208,
		217,
		212,
		207,
		217,
		226,
		218,
		199,
		210,
		233,
		222,
		260,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		194,
		169,
		184,
		230,
		228,
		226,
		254,
		251,
		-1,
		221,
		246,
		218,
		225,
		217,
		225,
		225,
		222,
		200,
		207,
		223,
		222,
		217,
		252,
		244,
		250,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		200,
		186,
		216,
		206,
		212,
		-1,
		-1,
		259,
		256,
		243,
		227,
		231,
		224,
		219,
		229,
		209,
		196,
		200,
		204,
		210,
		215,
		220,
		226,
		241,
		256,
		-1,
		179,
		260,
		253,
		236,
		244,
		275,
		-1,
		203,
		212,
		193,
		198,
		206,
		-1,
		-1,
		232,
		228,
		233,
		234,
		231,
		239,
		234,
		225,
		210,
		216,
		203,
		202,
		220,
		224,
		233,
		240,
		230,
		243,
		247,
		-1,
		193,
		236,
		230,
		233,
		257,
		271,
		-1,
		216,
		-1,
		-1,
		201,
		219,
		227,
		223,
		227,
		280,
		248,
		243,
		233,
		231,
		222,
		213,
		220,
		211,
		211,
		214,
		229,
		234,
		226,
		240,
		240,
		241,
		-1,
		228,
		216,
		224,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		217,
		-1,
		253,
		-1,
		246,
		250,
		256,
		259,
		247,
		234,
		226,
		218,
		234,
		209,
		219,
		215,
		216,
		225,
		236,
		248,
		247,
		248,
		302,
		257,
		224,
		215,
		262,
		277,
		281,
		-1,
		229,
		268,
		255,
		-1,
		226,
		-1,
		-1,
		-1,
		260,
		269,
		261,
		267,
		246,
		246,
		220,
		224,
		214,
		221,
		231,
		233,
		225,
		229,
		242,
		253,
		256,
		298,
		296,
		301,
		246,
		229,
		247,
		256,
		277,
		244,
		235,
		262,
		262,
		251,
		246,
		233,
		-1,
		-1,
		283,
		279,
		-1,
		-1,
		253,
		241,
		224,
		225,
		221,
		224,
		239,
		242,
		232,
		230,
		224,
		256,
		-1,
		298,
		297,
		286,
		283,
		259,
		250,
		237,
		248,
		-1,
		-1,
		247,
		263,
		276,
		280,
		293,
		318,
		-1,
		236,
		-1,
		-1,
		298,
		-1,
		-1,
		283,
		246,
		235,
		226,
		232,
		229,
		240,
		250,
		238,
		239,
		229,
		239,
		252,
		282,
		279,
		267,
		265,
		288,
		245,
		241,
		-1,
		262,
		250,
		256,
		263,
		280,
		307,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		281,
		279,
		268,
		-1,
		258,
		231,
		236,
		256,
		258,
		247,
		241,
		235,
		242,
		241,
		249,
		257,
		291,
		305,
		294,
		290,
		289,
		297,
		246,
		263,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		-1,
		287,
		262,
		-1,
		-1,
		276,
		269,
		257,
		245,
		235,
		245,
		249,
		253,
		245,
		238,
		233,
		244,
		236,
		240,
		257,
		-1,
		325,
		-1,
		277,
		270,
		285,
		300,
		308,
		-1,
		-1,
		-1,
		304,
		290,
		283,
		271,
		269,
		-1,
		310,
		294,
		275,
		-1,
		245,
		258,
		289,
		257,
		262,
		257,
		239,
		250,
		239,
		242,
		256,
		251,
		-1,
		-1,
		283,
		286,
		-1,
		-1,
		308,
		327,
		-1,
		295,
		284,
		269,
		261,
		-1,
		-1,
		282,
		278,
		-1,
		-1,
		246,
		271,
		260,
		268,
		263,
		243,
		249,
		252,
		241,
		245,
		257,
		-1,
		-1,
		290,
		291,
		296,
		-1,
		311,
		-1,
		319,
		-1,
		264,
		280,
		282,
		-1,
		-1,
		-1,
		284,
		247,
		268,
		278,
		272,
		270,
		261,
		247,
		254,
		252,
		248,
		259,
		-1,
		-1,
		-1,
		329,
		303,
		326,
		317,
		300,
		280,
		272,
		297,
		-1,
		271,
		-1,
		246,
		248,
		274,
		277,
		283,
		277,
		250,
		265,
		255,
		246,
		255,
		335,
		-1,
		305,
		338,
		302,
		286,
		272,
		276,
		292,
		-1,
		268,
		250,
		-1,
		278,
		268,
		299,
		284,
		265,
		252,
		259,
		259,
		252,
		-1,
		-1,
		-1,
		307,
		306,
		298,
		292,
		292,
		277,
		268,
		-1,
		280,
		262,
		241,
		258,
		258,
		249,
		257,
		289,
		285,
		272,
		272,
		264,
		-1,
		397,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		301,
		296,
		269,
		257,
		263,
		259,
		245,
		251,
		253,
		261,
		259,
		256,
		268,
		264,
		284,
		265,
		300,
		-1,
		403,
		-1,
		337,
		-1,
		-1,
		319,
		299,
		291,
		280,
		269,
		267,
		258,
		249,
		271,
		287,
		271,
		269,
		272,
		273,
		-1,
		392,
		391,
		-1,
		338,
		330,
		316,
		-1,
		309,
		-1,
		315,
		276,
		-1,
		278,
		258,
		-1,
		280,
		276,
		-1,
		-1,
		379,
		354,
		-1,
		-1,
		-1,
		339,
		319,
		310,
		294,
		-1,
		269,
		269,
		-1,
		-1,
		-1,
		364,
		363,
		-1,
		332,
		335,
		-1,
		325,
		316,
		324,
		271,
		275,
		-1,
		-1,
		-1,
		373,
		354,
		348,
		347,
		345,
		340,
		337,
		323,
		307,
		285,
		274,
		295,
		-1,
		-1,
		-1,
		345,
		337,
		330,
		-1,
		-1,
		332,
		315,
		296,
		294,
		-1,
		-1,
		-1,
		367,
		348,
		-1,
		-1,
		322,
		-1,
		-1,
		328,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		384,
		356,
		-1,
		-1,
		-1,
		318,
		314,
		315,
		-1,
		-1,
		-1,
		-1,
		378,
		379,
		402,
		366,
		-1,
		-1,
		-1,
		310,
		304,
		-1,
		-1,
		381,
		379,
		-1,
		-1,
		-1,
		338,
		322,
		-1,
		308,
		-1,
		-1,
		-1,
		329,
		-1,
		-1,
		341,
		-1,
		-1,
		-1,
		343,
		-1,
		343,
		318,
		325,
		-1,
		-1,
		-1,
		-1,
		356,
		348,
		356,
		-1,
		328,
		330,
		-1,
		378,
		-1,
		-1,
		371,
		362,
		-1,
		-1,
		333,
		340,
		362,
		365,
		401,
		-1,
		352
	],
	[
		-1,
		216,
		205,
		216,
		224,
		197,
		204,
		-1,
		225,
		227,
		193,
		187,
		226,
		197,
		203,
		214,
		-1,
		-1,
		-1,
		216,
		215,
		185,
		183,
		192,
		197,
		204,
		-1,
		227,
		-1,
		237,
		216,
		227,
		232,
		178,
		175,
		195,
		214,
		220,
		212,
		252,
		208,
		179,
		173,
		191,
		196,
		214,
		206,
		-1,
		179,
		169,
		191,
		195,
		207,
		190,
		-1,
		-1,
		173,
		174,
		180,
		192,
		197,
		202,
		-1,
		225,
		209,
		-1,
		-1,
		163,
		176,
		172,
		175,
		183,
		199,
		217,
		209,
		204,
		-1,
		-1,
		164,
		168,
		181,
		182,
		180,
		204,
		217,
		199,
		213,
		212,
		-1,
		152,
		170,
		179,
		188,
		194,
		180,
		178,
		196,
		198,
		204,
		207,
		-1,
		144,
		146,
		175,
		181,
		193,
		196,
		183,
		183,
		193,
		186,
		205,
		196,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		149,
		175,
		174,
		170,
		188,
		193,
		186,
		183,
		181,
		178,
		194,
		195,
		205,
		-1,
		-1,
		197,
		166,
		201,
		158,
		143,
		-1,
		137,
		156,
		162,
		166,
		171,
		176,
		190,
		186,
		-1,
		172,
		171,
		202,
		188,
		199,
		157,
		-1,
		-1,
		155,
		147,
		132,
		135,
		132,
		132,
		162,
		161,
		166,
		168,
		167,
		173,
		176,
		176,
		182,
		166,
		176,
		180,
		191,
		206,
		-1,
		-1,
		261,
		-1,
		-1,
		154,
		137,
		-1,
		120,
		127,
		127,
		144,
		134,
		155,
		170,
		174,
		182,
		181,
		169,
		171,
		168,
		181,
		169,
		163,
		188,
		192,
		186,
		207,
		202,
		-1,
		260,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		113,
		116,
		122,
		146,
		156,
		-1,
		177,
		175,
		199,
		190,
		187,
		174,
		162,
		175,
		160,
		167,
		166,
		170,
		172,
		205,
		183,
		205,
		202,
		231,
		236,
		230,
		239,
		-1,
		162,
		158,
		154,
		161,
		110,
		-1,
		-1,
		150,
		-1,
		164,
		177,
		181,
		179,
		182,
		191,
		182,
		169,
		158,
		169,
		158,
		155,
		163,
		172,
		183,
		178,
		177,
		195,
		210,
		223,
		227,
		233,
		-1,
		212,
		-1,
		154,
		138,
		140,
		112,
		133,
		-1,
		170,
		165,
		185,
		183,
		174,
		-1,
		177,
		180,
		187,
		165,
		150,
		167,
		159,
		157,
		162,
		167,
		181,
		172,
		190,
		197,
		205,
		209,
		229,
		241,
		172,
		162,
		-1,
		144,
		149,
		108,
		116,
		135,
		208,
		180,
		-1,
		175,
		-1,
		167,
		192,
		-1,
		171,
		167,
		149,
		150,
		145,
		160,
		166,
		163,
		160,
		178,
		181,
		198,
		202,
		218,
		-1,
		-1,
		157,
		161,
		150,
		101,
		120,
		144,
		181,
		173,
		162,
		161,
		-1,
		152,
		182,
		179,
		165,
		152,
		142,
		143,
		151,
		164,
		143,
		162,
		165,
		187,
		215,
		193,
		205,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		127,
		98,
		122,
		164,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		172,
		155,
		151,
		140,
		138,
		151,
		146,
		162,
		166,
		165,
		184,
		196,
		187,
		207,
		-1,
		-1,
		-1,
		157,
		146,
		147,
		93,
		116,
		153,
		170,
		156,
		161,
		136,
		129,
		123,
		175,
		172,
		139,
		147,
		139,
		128,
		142,
		150,
		154,
		163,
		172,
		178,
		202,
		202,
		208,
		-1,
		-1,
		164,
		154,
		138,
		140,
		137,
		107,
		114,
		146,
		161,
		158,
		-1,
		128,
		-1,
		117,
		125,
		124,
		130,
		142,
		128,
		133,
		144,
		156,
		169,
		165,
		172,
		207,
		207,
		192,
		212,
		215,
		-1,
		-1,
		-1,
		157,
		152,
		127,
		104,
		88,
		124,
		-1,
		128,
		129,
		-1,
		122,
		116,
		122,
		121,
		128,
		125,
		125,
		139,
		147,
		143,
		159,
		165,
		157,
		193,
		-1,
		200,
		194,
		202,
		192,
		180,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		83,
		135,
		-1,
		-1,
		113,
		106,
		-1,
		109,
		109,
		116,
		125,
		130,
		135,
		143,
		138,
		151,
		156,
		162,
		167,
		185,
		189,
		193,
		182,
		178,
		175,
		189,
		-1,
		38,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		103,
		-1,
		122,
		114,
		104,
		98,
		104,
		122,
		120,
		140,
		132,
		146,
		146,
		152,
		160,
		145,
		148,
		164,
		162,
		180,
		188,
		180,
		174,
		173,
		185,
		-1,
		39,
		0,
		22,
		-1,
		-1,
		116,
		-1,
		80,
		104,
		120,
		-1,
		138,
		117,
		140,
		118,
		132,
		128,
		166,
		167,
		145,
		150,
		158,
		168,
		170,
		159,
		170,
		162,
		184,
		184,
		168,
		169,
		178,
		-1,
		45,
		32,
		26,
		38,
		44,
		105,
		77,
		86,
		107,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		142,
		140,
		156,
		147,
		153,
		169,
		172,
		174,
		164,
		153,
		159,
		156,
		178,
		164,
		162,
		181,
		197,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		71,
		71,
		73,
		-1,
		124,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		164,
		148,
		153,
		-1,
		199,
		-1,
		172,
		174,
		168,
		153,
		150,
		161,
		159,
		170,
		187,
		-1,
		105,
		90,
		83,
		73,
		100,
		71,
		-1,
		127,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		180,
		160,
		154,
		153,
		194,
		194,
		180,
		166,
		159,
		156,
		153,
		166,
		186,
		177,
		189,
		-1,
		-1,
		-1,
		110,
		117,
		114,
		81,
		93,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		197,
		185,
		175,
		165,
		199,
		200,
		185,
		178,
		164,
		166,
		164,
		162,
		167,
		188,
		189,
		202,
		-1,
		-1,
		114,
		112,
		100,
		86,
		105,
		-1,
		-1,
		-1,
		156,
		172,
		164,
		135,
		186,
		-1,
		-1,
		177,
		175,
		185,
		181,
		168,
		188,
		191,
		177,
		161,
		176,
		188,
		196,
		201,
		-1,
		117,
		104,
		-1,
		-1,
		108,
		102,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		167,
		188,
		213,
		180,
		-1,
		185,
		186,
		172,
		186,
		193,
		179,
		174,
		168,
		171,
		189,
		206,
		-1,
		-1,
		122,
		-1,
		117,
		-1,
		-1,
		-1,
		-1,
		146,
		160,
		181,
		187,
		199,
		-1,
		194,
		188,
		174,
		191,
		192,
		189,
		180,
		172,
		177,
		174,
		187,
		201,
		205,
		145,
		-1,
		128,
		-1,
		-1,
		-1,
		164,
		179,
		241,
		218,
		191,
		195,
		188,
		182,
		182,
		198,
		200,
		211,
		179,
		175,
		176,
		180,
		179,
		196,
		206,
		-1,
		-1,
		128,
		145,
		180,
		172,
		176,
		268,
		-1,
		-1,
		204,
		195,
		186,
		189,
		192,
		195,
		185,
		182,
		187,
		192,
		180,
		189,
		207,
		211,
		-1,
		-1,
		-1,
		148,
		-1,
		163,
		-1,
		-1,
		191,
		275,
		222,
		204,
		200,
		198,
		191,
		200,
		195,
		190,
		200,
		209,
		201,
		182,
		193,
		216,
		205,
		243,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		177,
		152,
		167,
		213,
		211,
		209,
		237,
		234,
		-1,
		204,
		229,
		201,
		208,
		200,
		208,
		208,
		205,
		183,
		190,
		206,
		205,
		200,
		235,
		227,
		233,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		183,
		169,
		199,
		189,
		195,
		-1,
		-1,
		242,
		239,
		226,
		210,
		214,
		207,
		202,
		212,
		192,
		179,
		183,
		187,
		193,
		198,
		203,
		209,
		224,
		239,
		-1,
		162,
		243,
		236,
		219,
		227,
		258,
		-1,
		186,
		195,
		176,
		181,
		189,
		-1,
		-1,
		215,
		211,
		216,
		217,
		214,
		222,
		217,
		208,
		193,
		199,
		186,
		185,
		203,
		207,
		216,
		223,
		213,
		226,
		230,
		-1,
		176,
		219,
		213,
		216,
		240,
		254,
		-1,
		199,
		-1,
		-1,
		184,
		202,
		210,
		206,
		210,
		263,
		231,
		226,
		216,
		214,
		205,
		196,
		203,
		194,
		194,
		197,
		212,
		217,
		209,
		223,
		223,
		224,
		-1,
		211,
		199,
		207,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		200,
		-1,
		236,
		-1,
		229,
		233,
		239,
		242,
		230,
		217,
		209,
		201,
		217,
		192,
		202,
		198,
		199,
		208,
		219,
		231,
		230,
		231,
		285,
		240,
		207,
		198,
		245,
		260,
		264,
		-1,
		212,
		251,
		238,
		-1,
		209,
		-1,
		-1,
		-1,
		243,
		252,
		244,
		250,
		229,
		229,
		203,
		207,
		197,
		204,
		214,
		216,
		208,
		212,
		225,
		236,
		239,
		281,
		279,
		284,
		229,
		212,
		230,
		239,
		260,
		227,
		218,
		245,
		245,
		234,
		229,
		216,
		-1,
		-1,
		266,
		262,
		-1,
		-1,
		236,
		224,
		207,
		208,
		204,
		207,
		222,
		225,
		215,
		213,
		207,
		239,
		-1,
		281,
		280,
		269,
		266,
		242,
		233,
		220,
		231,
		-1,
		-1,
		230,
		246,
		259,
		263,
		276,
		301,
		-1,
		219,
		-1,
		-1,
		281,
		-1,
		-1,
		266,
		229,
		218,
		209,
		215,
		212,
		223,
		233,
		221,
		222,
		212,
		222,
		235,
		265,
		262,
		250,
		248,
		271,
		228,
		224,
		-1,
		245,
		233,
		239,
		246,
		263,
		290,
		-1,
		-1,
		235,
		226,
		-1,
		-1,
		264,
		262,
		251,
		-1,
		241,
		214,
		219,
		239,
		241,
		230,
		224,
		218,
		225,
		224,
		232,
		240,
		274,
		288,
		277,
		273,
		272,
		280,
		229,
		246,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		-1,
		270,
		245,
		-1,
		-1,
		259,
		252,
		240,
		228,
		218,
		228,
		232,
		236,
		228,
		221,
		216,
		227,
		219,
		223,
		240,
		-1,
		308,
		-1,
		260,
		253,
		268,
		283,
		291,
		-1,
		-1,
		-1,
		287,
		273,
		266,
		254,
		252,
		-1,
		293,
		277,
		258,
		-1,
		228,
		241,
		272,
		240,
		245,
		240,
		222,
		233,
		222,
		225,
		239,
		234,
		-1,
		-1,
		266,
		269,
		-1,
		-1,
		291,
		310,
		-1,
		278,
		267,
		252,
		244,
		-1,
		-1,
		265,
		261,
		-1,
		-1,
		229,
		254,
		243,
		251,
		246,
		226,
		232,
		235,
		224,
		228,
		240,
		-1,
		-1,
		273,
		274,
		279,
		-1,
		294,
		-1,
		302,
		-1,
		247,
		263,
		265,
		-1,
		-1,
		-1,
		267,
		230,
		251,
		261,
		255,
		253,
		244,
		230,
		237,
		235,
		231,
		242,
		-1,
		-1,
		-1,
		312,
		286,
		309,
		300,
		283,
		263,
		255,
		280,
		-1,
		254,
		-1,
		229,
		231,
		257,
		260,
		266,
		260,
		233,
		248,
		238,
		229,
		238,
		318,
		-1,
		288,
		321,
		285,
		269,
		255,
		259,
		275,
		-1,
		251,
		233,
		-1,
		261,
		251,
		282,
		267,
		248,
		235,
		242,
		242,
		235,
		-1,
		-1,
		-1,
		290,
		289,
		281,
		275,
		275,
		260,
		251,
		-1,
		263,
		245,
		224,
		241,
		241,
		232,
		240,
		272,
		268,
		255,
		255,
		247,
		-1,
		380,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		284,
		279,
		252,
		240,
		246,
		242,
		228,
		234,
		236,
		244,
		242,
		239,
		251,
		247,
		267,
		248,
		283,
		-1,
		386,
		-1,
		320,
		-1,
		-1,
		302,
		282,
		274,
		263,
		252,
		250,
		241,
		232,
		254,
		270,
		254,
		252,
		255,
		256,
		-1,
		375,
		374,
		-1,
		321,
		313,
		299,
		-1,
		292,
		-1,
		298,
		259,
		-1,
		261,
		241,
		-1,
		263,
		259,
		-1,
		-1,
		362,
		337,
		-1,
		-1,
		-1,
		322,
		302,
		293,
		277,
		-1,
		252,
		252,
		-1,
		-1,
		-1,
		347,
		346,
		-1,
		315,
		318,
		-1,
		308,
		299,
		307,
		254,
		258,
		-1,
		-1,
		-1,
		356,
		337,
		331,
		330,
		328,
		323,
		320,
		306,
		290,
		268,
		257,
		278,
		-1,
		-1,
		-1,
		328,
		320,
		313,
		-1,
		-1,
		315,
		298,
		279,
		277,
		-1,
		-1,
		-1,
		350,
		331,
		-1,
		-1,
		305,
		-1,
		-1,
		311,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		367,
		339,
		-1,
		-1,
		-1,
		301,
		297,
		298,
		-1,
		-1,
		-1,
		-1,
		361,
		362,
		385,
		349,
		-1,
		-1,
		-1,
		293,
		287,
		-1,
		-1,
		364,
		362,
		-1,
		-1,
		-1,
		321,
		305,
		-1,
		291,
		-1,
		-1,
		-1,
		312,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		326,
		-1,
		326,
		301,
		308,
		-1,
		-1,
		-1,
		-1,
		339,
		331,
		339,
		-1,
		311,
		313,
		-1,
		361,
		-1,
		-1,
		354,
		345,
		-1,
		-1,
		316,
		323,
		345,
		348,
		384,
		-1,
		335
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		203,
		205,
		171,
		165,
		204,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		194,
		193,
		163,
		161,
		170,
		175,
		182,
		-1,
		205,
		-1,
		215,
		194,
		205,
		210,
		156,
		153,
		173,
		192,
		198,
		190,
		230,
		186,
		157,
		151,
		169,
		174,
		192,
		184,
		-1,
		157,
		147,
		169,
		173,
		185,
		168,
		-1,
		-1,
		151,
		152,
		158,
		170,
		175,
		180,
		-1,
		203,
		187,
		-1,
		-1,
		141,
		154,
		150,
		153,
		161,
		177,
		195,
		187,
		182,
		-1,
		-1,
		142,
		146,
		159,
		160,
		158,
		182,
		195,
		177,
		191,
		190,
		-1,
		130,
		148,
		157,
		166,
		172,
		158,
		156,
		174,
		176,
		182,
		185,
		-1,
		122,
		124,
		153,
		159,
		171,
		174,
		161,
		161,
		171,
		164,
		183,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		119,
		127,
		153,
		152,
		148,
		166,
		171,
		164,
		161,
		159,
		156,
		172,
		173,
		183,
		-1,
		-1,
		175,
		144,
		179,
		136,
		121,
		-1,
		115,
		134,
		140,
		144,
		149,
		154,
		168,
		164,
		-1,
		150,
		149,
		180,
		166,
		177,
		135,
		-1,
		-1,
		133,
		125,
		110,
		113,
		110,
		110,
		140,
		139,
		144,
		146,
		145,
		151,
		154,
		154,
		160,
		144,
		154,
		158,
		169,
		184,
		-1,
		-1,
		239,
		-1,
		-1,
		132,
		115,
		-1,
		98,
		105,
		105,
		122,
		112,
		133,
		148,
		152,
		160,
		159,
		147,
		149,
		146,
		159,
		147,
		141,
		166,
		170,
		164,
		185,
		180,
		-1,
		238,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		91,
		94,
		100,
		124,
		134,
		-1,
		155,
		153,
		177,
		168,
		165,
		152,
		140,
		153,
		138,
		145,
		144,
		148,
		150,
		183,
		161,
		183,
		180,
		209,
		214,
		208,
		217,
		-1,
		140,
		136,
		132,
		139,
		88,
		-1,
		-1,
		128,
		-1,
		142,
		155,
		159,
		157,
		160,
		169,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		150,
		161,
		156,
		155,
		173,
		188,
		201,
		205,
		211,
		-1,
		190,
		-1,
		132,
		116,
		118,
		90,
		111,
		-1,
		148,
		143,
		163,
		161,
		152,
		-1,
		155,
		158,
		165,
		143,
		128,
		145,
		137,
		135,
		140,
		145,
		159,
		150,
		168,
		175,
		183,
		187,
		207,
		219,
		150,
		140,
		-1,
		122,
		127,
		86,
		94,
		113,
		186,
		158,
		-1,
		153,
		-1,
		145,
		170,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		144,
		141,
		138,
		156,
		159,
		176,
		180,
		196,
		-1,
		-1,
		135,
		139,
		128,
		79,
		98,
		122,
		159,
		151,
		140,
		139,
		-1,
		130,
		160,
		157,
		143,
		130,
		120,
		121,
		129,
		142,
		121,
		140,
		143,
		165,
		193,
		171,
		183,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		105,
		76,
		100,
		142,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		150,
		133,
		129,
		118,
		116,
		129,
		124,
		140,
		144,
		143,
		162,
		174,
		165,
		185,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		71,
		94,
		131,
		148,
		134,
		139,
		114,
		107,
		101,
		153,
		150,
		117,
		125,
		117,
		106,
		120,
		128,
		132,
		141,
		150,
		156,
		180,
		180,
		186,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		85,
		92,
		124,
		139,
		136,
		-1,
		106,
		-1,
		95,
		103,
		102,
		108,
		120,
		106,
		111,
		122,
		134,
		147,
		143,
		150,
		185,
		185,
		170,
		190,
		193,
		-1,
		-1,
		-1,
		135,
		130,
		105,
		82,
		66,
		102,
		-1,
		106,
		107,
		-1,
		100,
		94,
		100,
		99,
		106,
		103,
		103,
		117,
		125,
		121,
		137,
		143,
		135,
		171,
		-1,
		178,
		172,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		128,
		107,
		100,
		120,
		61,
		113,
		-1,
		-1,
		91,
		84,
		-1,
		87,
		87,
		94,
		103,
		108,
		113,
		121,
		116,
		129,
		134,
		140,
		145,
		163,
		167,
		171,
		160,
		156,
		153,
		167,
		-1,
		42,
		-1,
		-1,
		-1,
		-1,
		-1,
		61,
		81,
		-1,
		100,
		92,
		82,
		76,
		82,
		100,
		98,
		118,
		110,
		124,
		124,
		130,
		138,
		123,
		126,
		142,
		140,
		158,
		166,
		158,
		152,
		151,
		163,
		-1,
		43,
		29,
		0,
		-1,
		-1,
		94,
		-1,
		58,
		82,
		98,
		-1,
		116,
		95,
		118,
		96,
		110,
		106,
		144,
		145,
		123,
		128,
		136,
		146,
		148,
		137,
		148,
		140,
		162,
		162,
		146,
		147,
		156,
		-1,
		49,
		36,
		4,
		16,
		22,
		83,
		55,
		64,
		85,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		120,
		118,
		134,
		125,
		131,
		147,
		150,
		152,
		142,
		131,
		137,
		134,
		156,
		142,
		140,
		159,
		175,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		49,
		49,
		51,
		-1,
		102,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		142,
		126,
		131,
		-1,
		177,
		-1,
		150,
		152,
		146,
		131,
		128,
		139,
		137,
		148,
		165,
		-1,
		83,
		68,
		61,
		51,
		78,
		49,
		-1,
		105,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		158,
		138,
		132,
		131,
		172,
		172,
		158,
		144,
		137,
		134,
		131,
		144,
		164,
		155,
		167,
		-1,
		-1,
		-1,
		88,
		95,
		92,
		59,
		71,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		175,
		163,
		153,
		143,
		177,
		178,
		163,
		156,
		142,
		144,
		142,
		140,
		145,
		166,
		167,
		180,
		-1,
		-1,
		92,
		90,
		78,
		64,
		83,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		164,
		-1,
		-1,
		155,
		153,
		163,
		159,
		146,
		166,
		169,
		155,
		139,
		154,
		166,
		174,
		179,
		-1,
		95,
		82,
		-1,
		-1,
		86,
		80,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		145,
		166,
		191,
		158,
		-1,
		163,
		164,
		150,
		164,
		171,
		157,
		152,
		146,
		149,
		167,
		184,
		-1,
		-1,
		100,
		-1,
		95,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		159,
		165,
		177,
		-1,
		172,
		166,
		152,
		169,
		170,
		167,
		158,
		150,
		155,
		152,
		165,
		179,
		183,
		123,
		-1,
		106,
		-1,
		-1,
		-1,
		142,
		157,
		219,
		196,
		169,
		173,
		166,
		160,
		160,
		176,
		178,
		189,
		157,
		153,
		154,
		158,
		157,
		174,
		184,
		-1,
		-1,
		106,
		123,
		158,
		150,
		154,
		246,
		-1,
		-1,
		182,
		173,
		164,
		167,
		170,
		173,
		163,
		160,
		165,
		170,
		158,
		167,
		185,
		189,
		-1,
		-1,
		-1,
		126,
		-1,
		141,
		-1,
		-1,
		169,
		253,
		200,
		182,
		178,
		176,
		169,
		178,
		173,
		168,
		178,
		187,
		179,
		160,
		171,
		194,
		183,
		221,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		155,
		130,
		145,
		191,
		189,
		187,
		215,
		212,
		-1,
		182,
		207,
		179,
		186,
		178,
		186,
		186,
		183,
		161,
		168,
		184,
		183,
		178,
		213,
		205,
		211,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		161,
		147,
		177,
		167,
		173,
		-1,
		-1,
		220,
		217,
		204,
		188,
		192,
		185,
		180,
		190,
		170,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		140,
		221,
		214,
		197,
		205,
		236,
		-1,
		164,
		173,
		154,
		159,
		167,
		-1,
		-1,
		193,
		189,
		194,
		195,
		192,
		200,
		195,
		186,
		171,
		177,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		154,
		197,
		191,
		194,
		218,
		232,
		-1,
		177,
		-1,
		-1,
		162,
		180,
		188,
		184,
		188,
		241,
		209,
		204,
		194,
		192,
		183,
		174,
		181,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		189,
		177,
		185,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		178,
		-1,
		214,
		-1,
		207,
		211,
		217,
		220,
		208,
		195,
		187,
		179,
		195,
		170,
		180,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		263,
		218,
		185,
		176,
		223,
		238,
		242,
		-1,
		190,
		229,
		216,
		-1,
		187,
		-1,
		-1,
		-1,
		221,
		230,
		222,
		228,
		207,
		207,
		181,
		185,
		175,
		182,
		192,
		194,
		186,
		190,
		203,
		214,
		217,
		259,
		257,
		262,
		207,
		190,
		208,
		217,
		238,
		205,
		196,
		223,
		223,
		212,
		207,
		194,
		-1,
		-1,
		244,
		240,
		-1,
		-1,
		214,
		202,
		185,
		186,
		182,
		185,
		200,
		203,
		193,
		191,
		185,
		217,
		-1,
		259,
		258,
		247,
		244,
		220,
		211,
		198,
		209,
		-1,
		-1,
		208,
		224,
		237,
		241,
		254,
		279,
		-1,
		197,
		-1,
		-1,
		259,
		-1,
		-1,
		244,
		207,
		196,
		187,
		193,
		190,
		201,
		211,
		199,
		200,
		190,
		200,
		213,
		243,
		240,
		228,
		226,
		249,
		206,
		202,
		-1,
		223,
		211,
		217,
		224,
		241,
		268,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		242,
		240,
		229,
		-1,
		219,
		192,
		197,
		217,
		219,
		208,
		202,
		196,
		203,
		202,
		210,
		218,
		252,
		266,
		255,
		251,
		250,
		258,
		207,
		224,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		223,
		-1,
		-1,
		237,
		230,
		218,
		206,
		196,
		206,
		210,
		214,
		206,
		199,
		194,
		205,
		197,
		201,
		218,
		-1,
		286,
		-1,
		238,
		231,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		271,
		255,
		236,
		-1,
		206,
		219,
		250,
		218,
		223,
		218,
		200,
		211,
		200,
		203,
		217,
		212,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		269,
		288,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		243,
		239,
		-1,
		-1,
		207,
		232,
		221,
		229,
		224,
		204,
		210,
		213,
		202,
		206,
		218,
		-1,
		-1,
		251,
		252,
		257,
		-1,
		272,
		-1,
		280,
		-1,
		225,
		241,
		243,
		-1,
		-1,
		-1,
		245,
		208,
		229,
		239,
		233,
		231,
		222,
		208,
		215,
		213,
		209,
		220,
		-1,
		-1,
		-1,
		290,
		264,
		287,
		278,
		261,
		241,
		233,
		258,
		-1,
		232,
		-1,
		207,
		209,
		235,
		238,
		244,
		238,
		211,
		226,
		216,
		207,
		216,
		296,
		-1,
		266,
		299,
		263,
		247,
		233,
		237,
		253,
		-1,
		229,
		211,
		-1,
		239,
		229,
		260,
		245,
		226,
		213,
		220,
		220,
		213,
		-1,
		-1,
		-1,
		268,
		267,
		259,
		253,
		253,
		238,
		229,
		-1,
		241,
		223,
		202,
		219,
		219,
		210,
		218,
		250,
		246,
		233,
		233,
		225,
		-1,
		358,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		262,
		257,
		230,
		218,
		224,
		220,
		206,
		212,
		214,
		222,
		220,
		217,
		229,
		225,
		245,
		226,
		261,
		-1,
		364,
		-1,
		298,
		-1,
		-1,
		280,
		260,
		252,
		241,
		230,
		228,
		219,
		210,
		232,
		248,
		232,
		230,
		233,
		234,
		-1,
		353,
		352,
		-1,
		299,
		291,
		277,
		-1,
		270,
		-1,
		276,
		237,
		-1,
		239,
		219,
		-1,
		241,
		237,
		-1,
		-1,
		340,
		315,
		-1,
		-1,
		-1,
		300,
		280,
		271,
		255,
		-1,
		230,
		230,
		-1,
		-1,
		-1,
		325,
		324,
		-1,
		293,
		296,
		-1,
		286,
		277,
		285,
		232,
		236,
		-1,
		-1,
		-1,
		334,
		315,
		309,
		308,
		306,
		301,
		298,
		284,
		268,
		246,
		235,
		256,
		-1,
		-1,
		-1,
		306,
		298,
		291,
		-1,
		-1,
		293,
		276,
		257,
		255,
		-1,
		-1,
		-1,
		328,
		309,
		-1,
		-1,
		283,
		-1,
		-1,
		289,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		345,
		317,
		-1,
		-1,
		-1,
		279,
		275,
		276,
		-1,
		-1,
		-1,
		-1,
		339,
		340,
		363,
		327,
		-1,
		-1,
		-1,
		271,
		265,
		-1,
		-1,
		342,
		340,
		-1,
		-1,
		-1,
		299,
		283,
		-1,
		269,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		304,
		-1,
		304,
		279,
		286,
		-1,
		-1,
		-1,
		-1,
		317,
		309,
		317,
		-1,
		289,
		291,
		-1,
		339,
		-1,
		-1,
		332,
		323,
		-1,
		-1,
		294,
		301,
		323,
		326,
		362,
		-1,
		313
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		185,
		187,
		153,
		147,
		186,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		176,
		175,
		145,
		143,
		152,
		157,
		164,
		-1,
		187,
		-1,
		197,
		176,
		187,
		192,
		138,
		135,
		155,
		174,
		180,
		172,
		212,
		168,
		139,
		133,
		151,
		156,
		174,
		166,
		-1,
		139,
		129,
		151,
		155,
		167,
		150,
		-1,
		-1,
		133,
		134,
		140,
		152,
		157,
		162,
		-1,
		188,
		187,
		-1,
		-1,
		123,
		136,
		132,
		135,
		143,
		159,
		180,
		187,
		182,
		-1,
		-1,
		124,
		128,
		141,
		142,
		140,
		167,
		186,
		177,
		191,
		190,
		-1,
		112,
		130,
		139,
		148,
		154,
		143,
		147,
		165,
		176,
		182,
		185,
		-1,
		104,
		106,
		135,
		141,
		153,
		159,
		146,
		152,
		171,
		164,
		183,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		101,
		109,
		135,
		134,
		130,
		148,
		170,
		149,
		155,
		159,
		156,
		172,
		173,
		183,
		-1,
		-1,
		157,
		126,
		161,
		118,
		103,
		-1,
		97,
		116,
		122,
		126,
		131,
		139,
		167,
		164,
		-1,
		150,
		149,
		180,
		166,
		177,
		117,
		-1,
		-1,
		115,
		107,
		92,
		95,
		92,
		92,
		122,
		121,
		126,
		128,
		130,
		142,
		154,
		154,
		160,
		144,
		154,
		158,
		169,
		184,
		-1,
		-1,
		239,
		-1,
		-1,
		114,
		97,
		-1,
		80,
		87,
		87,
		104,
		94,
		115,
		130,
		134,
		142,
		145,
		133,
		149,
		146,
		159,
		147,
		141,
		166,
		170,
		164,
		185,
		180,
		-1,
		238,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		73,
		76,
		82,
		106,
		116,
		-1,
		137,
		135,
		159,
		153,
		158,
		152,
		139,
		153,
		138,
		145,
		144,
		148,
		150,
		183,
		161,
		183,
		180,
		209,
		214,
		208,
		217,
		-1,
		122,
		118,
		114,
		121,
		70,
		-1,
		-1,
		110,
		-1,
		124,
		137,
		149,
		139,
		142,
		154,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		150,
		161,
		156,
		155,
		173,
		188,
		201,
		205,
		211,
		-1,
		172,
		-1,
		114,
		98,
		100,
		72,
		93,
		-1,
		130,
		125,
		145,
		151,
		151,
		-1,
		155,
		158,
		165,
		143,
		128,
		145,
		137,
		135,
		140,
		145,
		159,
		150,
		168,
		175,
		183,
		187,
		207,
		219,
		132,
		122,
		-1,
		104,
		109,
		68,
		76,
		95,
		168,
		152,
		-1,
		153,
		-1,
		145,
		170,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		144,
		141,
		138,
		156,
		159,
		176,
		180,
		196,
		-1,
		-1,
		117,
		121,
		110,
		61,
		80,
		104,
		141,
		151,
		140,
		139,
		-1,
		130,
		160,
		157,
		143,
		130,
		120,
		121,
		129,
		142,
		121,
		140,
		143,
		165,
		193,
		171,
		183,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		87,
		58,
		82,
		124,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		150,
		133,
		129,
		118,
		116,
		129,
		124,
		140,
		144,
		143,
		162,
		174,
		165,
		185,
		-1,
		-1,
		-1,
		117,
		106,
		107,
		53,
		76,
		113,
		148,
		134,
		139,
		114,
		107,
		101,
		153,
		150,
		117,
		125,
		117,
		106,
		120,
		128,
		132,
		141,
		150,
		156,
		180,
		180,
		186,
		-1,
		-1,
		124,
		114,
		98,
		100,
		97,
		67,
		74,
		106,
		139,
		136,
		-1,
		106,
		-1,
		95,
		103,
		102,
		108,
		120,
		106,
		111,
		122,
		134,
		147,
		143,
		150,
		185,
		185,
		170,
		190,
		193,
		-1,
		-1,
		-1,
		117,
		110,
		85,
		62,
		48,
		84,
		-1,
		106,
		107,
		-1,
		100,
		94,
		100,
		99,
		106,
		103,
		103,
		117,
		125,
		121,
		137,
		143,
		135,
		171,
		-1,
		178,
		172,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		108,
		87,
		80,
		100,
		41,
		91,
		-1,
		-1,
		91,
		84,
		-1,
		87,
		87,
		94,
		103,
		108,
		113,
		121,
		116,
		129,
		134,
		140,
		145,
		163,
		167,
		171,
		160,
		156,
		153,
		167,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		39,
		59,
		-1,
		90,
		82,
		82,
		76,
		82,
		100,
		98,
		118,
		110,
		124,
		124,
		130,
		138,
		123,
		126,
		142,
		140,
		158,
		166,
		158,
		152,
		151,
		163,
		-1,
		148,
		134,
		105,
		-1,
		-1,
		0,
		-1,
		42,
		63,
		79,
		-1,
		116,
		95,
		118,
		96,
		110,
		106,
		144,
		145,
		123,
		128,
		136,
		146,
		148,
		137,
		148,
		140,
		162,
		162,
		146,
		147,
		156,
		-1,
		154,
		141,
		99,
		95,
		84,
		104,
		45,
		64,
		66,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		120,
		118,
		134,
		125,
		131,
		147,
		150,
		152,
		142,
		131,
		137,
		134,
		156,
		142,
		140,
		159,
		175,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		70,
		57,
		51,
		-1,
		83,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		142,
		126,
		131,
		-1,
		177,
		-1,
		150,
		152,
		146,
		131,
		128,
		139,
		137,
		148,
		165,
		-1,
		104,
		89,
		82,
		72,
		86,
		57,
		-1,
		112,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		158,
		138,
		132,
		131,
		172,
		172,
		158,
		144,
		137,
		134,
		131,
		144,
		164,
		155,
		167,
		-1,
		-1,
		-1,
		109,
		95,
		99,
		59,
		78,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		175,
		163,
		153,
		143,
		177,
		178,
		163,
		156,
		142,
		144,
		142,
		140,
		145,
		166,
		167,
		180,
		-1,
		-1,
		92,
		97,
		85,
		71,
		90,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		164,
		-1,
		-1,
		155,
		153,
		163,
		159,
		146,
		166,
		169,
		155,
		139,
		154,
		166,
		174,
		179,
		-1,
		95,
		82,
		-1,
		-1,
		93,
		87,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		145,
		166,
		191,
		158,
		-1,
		163,
		164,
		150,
		164,
		171,
		157,
		152,
		146,
		149,
		167,
		184,
		-1,
		-1,
		107,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		159,
		165,
		177,
		-1,
		172,
		166,
		152,
		169,
		170,
		167,
		158,
		150,
		155,
		152,
		165,
		179,
		183,
		130,
		-1,
		113,
		-1,
		-1,
		-1,
		142,
		157,
		219,
		196,
		169,
		173,
		166,
		160,
		160,
		176,
		178,
		189,
		157,
		153,
		154,
		158,
		157,
		174,
		184,
		-1,
		-1,
		113,
		130,
		165,
		150,
		154,
		246,
		-1,
		-1,
		182,
		173,
		164,
		167,
		170,
		173,
		163,
		160,
		165,
		170,
		158,
		167,
		185,
		189,
		-1,
		-1,
		-1,
		133,
		-1,
		148,
		-1,
		-1,
		169,
		253,
		200,
		182,
		178,
		176,
		169,
		178,
		173,
		168,
		178,
		187,
		179,
		160,
		171,
		194,
		183,
		221,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		162,
		137,
		152,
		198,
		189,
		194,
		215,
		212,
		-1,
		182,
		207,
		179,
		186,
		178,
		186,
		186,
		183,
		161,
		168,
		184,
		183,
		178,
		213,
		205,
		211,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		168,
		154,
		184,
		174,
		180,
		-1,
		-1,
		227,
		224,
		204,
		188,
		192,
		185,
		180,
		190,
		170,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		140,
		221,
		214,
		197,
		205,
		236,
		-1,
		171,
		180,
		161,
		166,
		174,
		-1,
		-1,
		200,
		196,
		201,
		195,
		192,
		200,
		195,
		186,
		171,
		177,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		154,
		197,
		191,
		194,
		218,
		232,
		-1,
		184,
		-1,
		-1,
		169,
		187,
		195,
		191,
		195,
		248,
		209,
		204,
		194,
		192,
		183,
		174,
		181,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		189,
		177,
		185,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		185,
		-1,
		221,
		-1,
		214,
		218,
		217,
		220,
		208,
		195,
		187,
		179,
		195,
		170,
		180,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		263,
		218,
		185,
		176,
		223,
		238,
		242,
		-1,
		197,
		236,
		223,
		-1,
		194,
		-1,
		-1,
		-1,
		228,
		230,
		222,
		228,
		207,
		207,
		181,
		185,
		175,
		182,
		192,
		194,
		186,
		190,
		203,
		214,
		217,
		259,
		257,
		262,
		207,
		190,
		208,
		217,
		238,
		212,
		203,
		230,
		230,
		219,
		214,
		201,
		-1,
		-1,
		251,
		240,
		-1,
		-1,
		214,
		202,
		185,
		186,
		182,
		185,
		200,
		203,
		193,
		191,
		185,
		217,
		-1,
		259,
		258,
		247,
		244,
		220,
		211,
		198,
		209,
		-1,
		-1,
		215,
		231,
		244,
		248,
		261,
		286,
		-1,
		204,
		-1,
		-1,
		259,
		-1,
		-1,
		244,
		207,
		196,
		187,
		193,
		190,
		201,
		211,
		199,
		200,
		190,
		200,
		213,
		243,
		240,
		228,
		226,
		249,
		206,
		202,
		-1,
		230,
		218,
		224,
		231,
		248,
		275,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		242,
		240,
		229,
		-1,
		219,
		192,
		197,
		217,
		219,
		208,
		202,
		196,
		203,
		202,
		210,
		218,
		252,
		266,
		255,
		251,
		250,
		258,
		207,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		255,
		230,
		-1,
		-1,
		237,
		230,
		218,
		206,
		196,
		206,
		210,
		214,
		206,
		199,
		194,
		205,
		197,
		201,
		218,
		-1,
		286,
		-1,
		238,
		231,
		246,
		261,
		269,
		-1,
		-1,
		-1,
		272,
		258,
		251,
		239,
		237,
		-1,
		271,
		255,
		236,
		-1,
		206,
		219,
		250,
		218,
		223,
		218,
		200,
		211,
		200,
		203,
		217,
		212,
		-1,
		-1,
		244,
		247,
		-1,
		-1,
		269,
		288,
		-1,
		263,
		252,
		237,
		229,
		-1,
		-1,
		243,
		239,
		-1,
		-1,
		207,
		232,
		221,
		229,
		224,
		204,
		210,
		213,
		202,
		206,
		218,
		-1,
		-1,
		251,
		252,
		257,
		-1,
		272,
		-1,
		287,
		-1,
		232,
		248,
		250,
		-1,
		-1,
		-1,
		245,
		208,
		229,
		239,
		233,
		231,
		222,
		208,
		215,
		213,
		209,
		220,
		-1,
		-1,
		-1,
		290,
		264,
		294,
		285,
		268,
		248,
		240,
		262,
		-1,
		232,
		-1,
		207,
		209,
		235,
		238,
		244,
		238,
		211,
		226,
		216,
		207,
		216,
		296,
		-1,
		266,
		299,
		263,
		254,
		233,
		237,
		253,
		-1,
		229,
		211,
		-1,
		239,
		229,
		260,
		245,
		226,
		213,
		220,
		220,
		213,
		-1,
		-1,
		-1,
		268,
		267,
		259,
		253,
		253,
		238,
		229,
		-1,
		241,
		223,
		202,
		219,
		219,
		210,
		218,
		250,
		246,
		233,
		233,
		225,
		-1,
		358,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		262,
		257,
		230,
		218,
		224,
		220,
		206,
		212,
		214,
		222,
		220,
		217,
		229,
		225,
		245,
		226,
		261,
		-1,
		364,
		-1,
		298,
		-1,
		-1,
		280,
		260,
		252,
		241,
		230,
		228,
		219,
		210,
		232,
		248,
		232,
		230,
		233,
		234,
		-1,
		353,
		352,
		-1,
		299,
		291,
		277,
		-1,
		270,
		-1,
		276,
		237,
		-1,
		239,
		219,
		-1,
		241,
		237,
		-1,
		-1,
		340,
		315,
		-1,
		-1,
		-1,
		300,
		280,
		271,
		255,
		-1,
		230,
		230,
		-1,
		-1,
		-1,
		325,
		324,
		-1,
		293,
		296,
		-1,
		286,
		277,
		285,
		232,
		236,
		-1,
		-1,
		-1,
		334,
		315,
		309,
		308,
		306,
		301,
		298,
		284,
		268,
		246,
		235,
		256,
		-1,
		-1,
		-1,
		306,
		298,
		291,
		-1,
		-1,
		293,
		276,
		257,
		255,
		-1,
		-1,
		-1,
		328,
		309,
		-1,
		-1,
		283,
		-1,
		-1,
		289,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		345,
		317,
		-1,
		-1,
		-1,
		279,
		275,
		276,
		-1,
		-1,
		-1,
		-1,
		339,
		340,
		363,
		327,
		-1,
		-1,
		-1,
		271,
		265,
		-1,
		-1,
		342,
		340,
		-1,
		-1,
		-1,
		299,
		283,
		-1,
		269,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		304,
		-1,
		304,
		279,
		286,
		-1,
		-1,
		-1,
		-1,
		317,
		309,
		317,
		-1,
		289,
		291,
		-1,
		339,
		-1,
		-1,
		332,
		323,
		-1,
		-1,
		294,
		301,
		323,
		326,
		362,
		-1,
		313
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		142,
		131,
		142,
		150,
		123,
		130,
		-1,
		151,
		153,
		119,
		113,
		152,
		123,
		129,
		140,
		-1,
		-1,
		-1,
		142,
		141,
		111,
		109,
		118,
		123,
		130,
		-1,
		153,
		-1,
		163,
		142,
		153,
		158,
		104,
		101,
		121,
		140,
		146,
		138,
		178,
		134,
		105,
		99,
		117,
		122,
		140,
		132,
		-1,
		105,
		95,
		117,
		121,
		133,
		116,
		-1,
		-1,
		99,
		100,
		106,
		118,
		123,
		128,
		-1,
		154,
		145,
		-1,
		-1,
		89,
		102,
		98,
		101,
		109,
		125,
		146,
		145,
		140,
		-1,
		-1,
		90,
		94,
		107,
		108,
		106,
		133,
		152,
		135,
		149,
		148,
		-1,
		78,
		96,
		105,
		114,
		120,
		109,
		113,
		131,
		134,
		140,
		143,
		-1,
		70,
		72,
		101,
		107,
		119,
		125,
		112,
		118,
		129,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		67,
		75,
		101,
		100,
		96,
		114,
		129,
		115,
		119,
		117,
		114,
		130,
		131,
		141,
		-1,
		-1,
		123,
		92,
		127,
		84,
		69,
		-1,
		63,
		82,
		88,
		92,
		97,
		105,
		126,
		122,
		-1,
		108,
		107,
		138,
		124,
		135,
		83,
		-1,
		-1,
		81,
		73,
		58,
		61,
		58,
		58,
		88,
		87,
		92,
		94,
		96,
		108,
		112,
		112,
		118,
		102,
		112,
		116,
		127,
		142,
		-1,
		-1,
		197,
		-1,
		-1,
		80,
		63,
		-1,
		46,
		53,
		53,
		70,
		60,
		81,
		96,
		100,
		108,
		111,
		99,
		107,
		104,
		117,
		105,
		99,
		124,
		128,
		122,
		143,
		138,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		39,
		42,
		48,
		72,
		82,
		-1,
		103,
		101,
		125,
		119,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		106,
		108,
		141,
		119,
		141,
		138,
		167,
		172,
		166,
		175,
		-1,
		88,
		84,
		80,
		87,
		36,
		-1,
		-1,
		76,
		-1,
		90,
		103,
		115,
		105,
		108,
		120,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		108,
		119,
		114,
		113,
		131,
		146,
		159,
		163,
		169,
		-1,
		138,
		-1,
		80,
		64,
		66,
		38,
		59,
		-1,
		96,
		91,
		111,
		117,
		110,
		-1,
		113,
		116,
		123,
		101,
		86,
		103,
		95,
		93,
		98,
		103,
		117,
		108,
		126,
		133,
		141,
		145,
		165,
		177,
		98,
		88,
		-1,
		70,
		75,
		34,
		42,
		61,
		134,
		116,
		-1,
		111,
		-1,
		103,
		128,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		102,
		99,
		96,
		114,
		117,
		134,
		138,
		154,
		-1,
		-1,
		83,
		87,
		76,
		27,
		46,
		70,
		107,
		109,
		98,
		97,
		-1,
		88,
		118,
		115,
		101,
		88,
		78,
		79,
		87,
		100,
		79,
		98,
		101,
		123,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		53,
		24,
		48,
		90,
		127,
		120,
		108,
		73,
		73,
		67,
		-1,
		108,
		91,
		87,
		76,
		74,
		87,
		82,
		98,
		102,
		101,
		120,
		132,
		123,
		143,
		-1,
		-1,
		-1,
		83,
		72,
		73,
		19,
		42,
		79,
		106,
		92,
		97,
		72,
		65,
		59,
		111,
		108,
		75,
		83,
		75,
		64,
		78,
		86,
		90,
		99,
		108,
		114,
		138,
		138,
		144,
		-1,
		-1,
		90,
		80,
		64,
		66,
		63,
		33,
		40,
		72,
		97,
		94,
		-1,
		64,
		-1,
		53,
		61,
		60,
		66,
		78,
		64,
		69,
		80,
		92,
		105,
		101,
		108,
		143,
		143,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		83,
		76,
		51,
		28,
		14,
		50,
		-1,
		64,
		65,
		-1,
		58,
		52,
		58,
		57,
		64,
		61,
		61,
		75,
		83,
		79,
		95,
		101,
		93,
		129,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		74,
		53,
		46,
		66,
		7,
		59,
		-1,
		-1,
		49,
		42,
		-1,
		45,
		45,
		52,
		61,
		66,
		71,
		79,
		74,
		87,
		92,
		98,
		103,
		121,
		125,
		129,
		118,
		114,
		111,
		125,
		-1,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		3,
		27,
		-1,
		51,
		43,
		40,
		34,
		40,
		58,
		56,
		76,
		68,
		82,
		82,
		88,
		96,
		81,
		84,
		100,
		98,
		116,
		124,
		116,
		110,
		109,
		121,
		-1,
		106,
		92,
		63,
		-1,
		-1,
		36,
		-1,
		0,
		24,
		40,
		-1,
		74,
		53,
		76,
		54,
		68,
		64,
		102,
		103,
		81,
		86,
		94,
		104,
		106,
		95,
		106,
		98,
		120,
		120,
		104,
		105,
		114,
		-1,
		112,
		99,
		57,
		53,
		42,
		62,
		3,
		22,
		27,
		-1,
		-1,
		118,
		-1,
		52,
		69,
		78,
		76,
		92,
		83,
		89,
		105,
		108,
		110,
		100,
		89,
		95,
		92,
		114,
		100,
		98,
		117,
		133,
		-1,
		-1,
		-1,
		79,
		-1,
		-1,
		28,
		15,
		9,
		-1,
		44,
		-1,
		96,
		86,
		70,
		55,
		88,
		-1,
		100,
		84,
		89,
		-1,
		135,
		-1,
		108,
		110,
		104,
		89,
		86,
		97,
		95,
		106,
		123,
		-1,
		62,
		47,
		40,
		30,
		44,
		15,
		-1,
		70,
		-1,
		-1,
		83,
		77,
		77,
		61,
		64,
		116,
		96,
		90,
		89,
		130,
		130,
		116,
		102,
		95,
		92,
		89,
		102,
		122,
		113,
		125,
		-1,
		-1,
		-1,
		67,
		53,
		57,
		17,
		36,
		-1,
		-1,
		145,
		100,
		86,
		-1,
		70,
		133,
		121,
		111,
		101,
		135,
		136,
		121,
		114,
		100,
		102,
		100,
		98,
		103,
		124,
		125,
		138,
		-1,
		-1,
		50,
		55,
		43,
		29,
		48,
		-1,
		-1,
		-1,
		92,
		108,
		100,
		71,
		122,
		-1,
		-1,
		113,
		111,
		121,
		117,
		104,
		124,
		127,
		113,
		97,
		112,
		124,
		132,
		137,
		-1,
		53,
		40,
		-1,
		-1,
		51,
		45,
		-1,
		-1,
		-1,
		-1,
		125,
		91,
		103,
		124,
		149,
		116,
		-1,
		121,
		122,
		108,
		122,
		129,
		115,
		110,
		104,
		107,
		125,
		142,
		-1,
		-1,
		65,
		-1,
		60,
		-1,
		-1,
		-1,
		-1,
		82,
		96,
		117,
		123,
		135,
		-1,
		130,
		124,
		110,
		127,
		128,
		125,
		116,
		108,
		113,
		110,
		123,
		137,
		141,
		88,
		-1,
		71,
		-1,
		-1,
		-1,
		100,
		115,
		177,
		154,
		127,
		131,
		124,
		118,
		118,
		134,
		136,
		147,
		115,
		111,
		112,
		116,
		115,
		132,
		142,
		-1,
		-1,
		71,
		88,
		123,
		108,
		112,
		204,
		-1,
		-1,
		140,
		131,
		122,
		125,
		128,
		131,
		121,
		118,
		123,
		128,
		116,
		125,
		143,
		147,
		-1,
		-1,
		-1,
		91,
		-1,
		106,
		-1,
		-1,
		127,
		211,
		158,
		140,
		136,
		134,
		127,
		136,
		131,
		126,
		136,
		145,
		137,
		118,
		129,
		152,
		141,
		179,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		120,
		95,
		110,
		156,
		147,
		152,
		173,
		170,
		-1,
		140,
		165,
		137,
		144,
		136,
		144,
		144,
		141,
		119,
		126,
		142,
		141,
		136,
		171,
		163,
		169,
		-1,
		-1,
		203,
		192,
		181,
		187,
		-1,
		126,
		112,
		142,
		132,
		138,
		-1,
		-1,
		185,
		182,
		162,
		146,
		150,
		143,
		138,
		148,
		128,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		98,
		179,
		172,
		155,
		163,
		194,
		-1,
		129,
		138,
		119,
		124,
		132,
		-1,
		-1,
		158,
		154,
		159,
		153,
		150,
		158,
		153,
		144,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		112,
		155,
		149,
		152,
		176,
		190,
		-1,
		142,
		-1,
		-1,
		127,
		145,
		153,
		149,
		153,
		206,
		167,
		162,
		152,
		150,
		141,
		132,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		147,
		135,
		143,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		143,
		-1,
		179,
		-1,
		172,
		176,
		175,
		178,
		166,
		153,
		145,
		137,
		153,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		221,
		176,
		143,
		134,
		181,
		196,
		200,
		-1,
		155,
		194,
		181,
		-1,
		152,
		-1,
		-1,
		-1,
		186,
		188,
		180,
		186,
		165,
		165,
		139,
		143,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		217,
		215,
		220,
		165,
		148,
		166,
		175,
		196,
		170,
		161,
		188,
		188,
		177,
		172,
		159,
		-1,
		-1,
		209,
		198,
		-1,
		-1,
		172,
		160,
		143,
		144,
		140,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		156,
		167,
		-1,
		-1,
		173,
		189,
		202,
		206,
		219,
		244,
		-1,
		162,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		165,
		154,
		145,
		151,
		148,
		159,
		169,
		157,
		158,
		148,
		158,
		171,
		201,
		198,
		186,
		184,
		207,
		164,
		160,
		-1,
		188,
		176,
		182,
		189,
		206,
		233,
		-1,
		-1,
		178,
		169,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		150,
		155,
		175,
		177,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		182,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		188,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		168,
		172,
		164,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		244,
		-1,
		196,
		189,
		204,
		219,
		227,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		208,
		176,
		181,
		176,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		202,
		205,
		-1,
		-1,
		227,
		246,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		165,
		190,
		179,
		187,
		182,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		209,
		210,
		215,
		-1,
		230,
		-1,
		245,
		-1,
		190,
		206,
		208,
		-1,
		-1,
		-1,
		203,
		166,
		187,
		197,
		191,
		189,
		180,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		248,
		222,
		252,
		243,
		226,
		206,
		198,
		220,
		-1,
		190,
		-1,
		165,
		167,
		193,
		196,
		202,
		196,
		169,
		184,
		174,
		165,
		174,
		254,
		-1,
		224,
		257,
		221,
		212,
		191,
		195,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		218,
		203,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		226,
		225,
		217,
		211,
		211,
		196,
		187,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		208,
		204,
		191,
		191,
		183,
		-1,
		316,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		220,
		215,
		188,
		176,
		182,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		184,
		219,
		-1,
		322,
		-1,
		256,
		-1,
		-1,
		238,
		218,
		210,
		199,
		188,
		186,
		177,
		168,
		190,
		206,
		190,
		188,
		191,
		192,
		-1,
		311,
		310,
		-1,
		257,
		249,
		235,
		-1,
		228,
		-1,
		234,
		195,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		298,
		273,
		-1,
		-1,
		-1,
		258,
		238,
		229,
		213,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		283,
		282,
		-1,
		251,
		254,
		-1,
		244,
		235,
		243,
		190,
		194,
		-1,
		-1,
		-1,
		292,
		273,
		267,
		266,
		264,
		259,
		256,
		242,
		226,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		264,
		256,
		249,
		-1,
		-1,
		251,
		234,
		215,
		213,
		-1,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		241,
		-1,
		-1,
		247,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		275,
		-1,
		-1,
		-1,
		237,
		233,
		234,
		-1,
		-1,
		-1,
		-1,
		297,
		298,
		321,
		285,
		-1,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		300,
		298,
		-1,
		-1,
		-1,
		257,
		241,
		-1,
		227,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		262,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		275,
		267,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		290,
		281,
		-1,
		-1,
		252,
		259,
		281,
		284,
		320,
		-1,
		271
	],
	[
		-1,
		168,
		157,
		168,
		176,
		149,
		156,
		-1,
		177,
		179,
		145,
		139,
		178,
		149,
		155,
		166,
		-1,
		-1,
		-1,
		168,
		167,
		137,
		135,
		144,
		149,
		156,
		-1,
		179,
		-1,
		189,
		168,
		179,
		184,
		130,
		127,
		147,
		166,
		172,
		164,
		204,
		160,
		131,
		125,
		143,
		148,
		166,
		158,
		-1,
		131,
		121,
		143,
		147,
		159,
		142,
		-1,
		-1,
		125,
		126,
		132,
		144,
		149,
		154,
		-1,
		172,
		156,
		-1,
		-1,
		115,
		128,
		124,
		127,
		135,
		151,
		164,
		156,
		151,
		-1,
		-1,
		116,
		120,
		133,
		134,
		132,
		151,
		164,
		146,
		160,
		159,
		-1,
		104,
		122,
		131,
		140,
		143,
		127,
		125,
		143,
		145,
		151,
		154,
		-1,
		96,
		98,
		127,
		133,
		145,
		143,
		130,
		130,
		140,
		133,
		152,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		93,
		101,
		127,
		126,
		122,
		140,
		140,
		133,
		130,
		128,
		125,
		141,
		142,
		152,
		-1,
		-1,
		149,
		118,
		153,
		110,
		95,
		-1,
		89,
		108,
		114,
		118,
		123,
		123,
		137,
		133,
		-1,
		119,
		118,
		149,
		135,
		146,
		109,
		-1,
		-1,
		107,
		99,
		84,
		87,
		84,
		84,
		114,
		113,
		118,
		118,
		114,
		120,
		123,
		123,
		129,
		113,
		123,
		127,
		138,
		153,
		-1,
		-1,
		208,
		-1,
		-1,
		106,
		89,
		-1,
		72,
		79,
		79,
		96,
		86,
		107,
		122,
		126,
		134,
		128,
		116,
		118,
		115,
		128,
		116,
		110,
		135,
		139,
		133,
		154,
		149,
		-1,
		207,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		65,
		68,
		74,
		98,
		108,
		-1,
		129,
		127,
		151,
		137,
		134,
		121,
		109,
		122,
		107,
		114,
		113,
		117,
		119,
		152,
		130,
		152,
		149,
		178,
		183,
		177,
		186,
		-1,
		114,
		110,
		106,
		113,
		62,
		-1,
		-1,
		102,
		-1,
		116,
		129,
		128,
		131,
		134,
		138,
		129,
		116,
		105,
		116,
		105,
		102,
		110,
		119,
		130,
		125,
		124,
		142,
		157,
		170,
		174,
		180,
		-1,
		164,
		-1,
		106,
		90,
		92,
		64,
		85,
		-1,
		122,
		117,
		137,
		130,
		121,
		-1,
		124,
		127,
		134,
		112,
		97,
		114,
		106,
		104,
		109,
		114,
		128,
		119,
		137,
		144,
		152,
		156,
		176,
		188,
		124,
		114,
		-1,
		96,
		101,
		60,
		68,
		87,
		160,
		127,
		-1,
		122,
		-1,
		114,
		139,
		-1,
		118,
		114,
		96,
		97,
		92,
		107,
		113,
		110,
		107,
		125,
		128,
		145,
		149,
		165,
		-1,
		-1,
		109,
		113,
		102,
		53,
		72,
		96,
		133,
		120,
		109,
		108,
		-1,
		99,
		129,
		126,
		112,
		99,
		89,
		90,
		98,
		111,
		90,
		109,
		112,
		134,
		162,
		140,
		152,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		79,
		50,
		74,
		116,
		138,
		131,
		119,
		84,
		84,
		78,
		-1,
		119,
		102,
		98,
		87,
		85,
		98,
		93,
		109,
		113,
		112,
		131,
		143,
		134,
		154,
		-1,
		-1,
		-1,
		109,
		98,
		99,
		45,
		68,
		105,
		117,
		103,
		108,
		83,
		76,
		70,
		122,
		119,
		86,
		94,
		86,
		75,
		89,
		97,
		101,
		110,
		119,
		125,
		149,
		149,
		155,
		-1,
		-1,
		116,
		106,
		90,
		92,
		89,
		59,
		66,
		98,
		108,
		107,
		-1,
		75,
		-1,
		64,
		72,
		71,
		77,
		89,
		75,
		80,
		91,
		103,
		116,
		112,
		119,
		154,
		154,
		139,
		159,
		162,
		-1,
		-1,
		-1,
		109,
		102,
		77,
		54,
		40,
		76,
		-1,
		77,
		78,
		-1,
		69,
		63,
		69,
		68,
		75,
		72,
		72,
		86,
		94,
		90,
		106,
		112,
		104,
		140,
		-1,
		147,
		141,
		149,
		139,
		127,
		-1,
		-1,
		-1,
		100,
		79,
		72,
		92,
		33,
		85,
		-1,
		-1,
		62,
		55,
		-1,
		56,
		56,
		63,
		72,
		77,
		82,
		90,
		85,
		98,
		103,
		109,
		114,
		132,
		136,
		140,
		129,
		125,
		122,
		136,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		29,
		53,
		-1,
		40,
		32,
		44,
		47,
		53,
		69,
		67,
		87,
		79,
		93,
		93,
		99,
		107,
		92,
		95,
		111,
		109,
		127,
		135,
		127,
		121,
		120,
		132,
		-1,
		132,
		118,
		89,
		-1,
		-1,
		62,
		-1,
		26,
		0,
		16,
		-1,
		87,
		66,
		87,
		65,
		79,
		75,
		113,
		114,
		92,
		97,
		105,
		115,
		117,
		106,
		117,
		109,
		131,
		131,
		115,
		116,
		125,
		-1,
		138,
		125,
		83,
		79,
		68,
		88,
		29,
		48,
		3,
		-1,
		-1,
		129,
		-1,
		63,
		80,
		89,
		87,
		103,
		94,
		100,
		116,
		119,
		121,
		111,
		100,
		106,
		103,
		125,
		111,
		109,
		128,
		144,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		54,
		41,
		35,
		-1,
		20,
		-1,
		107,
		97,
		81,
		66,
		99,
		-1,
		111,
		95,
		100,
		-1,
		146,
		-1,
		119,
		121,
		115,
		100,
		97,
		108,
		106,
		117,
		134,
		-1,
		88,
		73,
		66,
		56,
		70,
		41,
		-1,
		87,
		-1,
		-1,
		94,
		88,
		88,
		72,
		75,
		127,
		107,
		101,
		100,
		141,
		141,
		127,
		113,
		106,
		103,
		100,
		113,
		133,
		124,
		136,
		-1,
		-1,
		-1,
		93,
		68,
		74,
		32,
		53,
		-1,
		-1,
		156,
		111,
		97,
		-1,
		81,
		144,
		132,
		122,
		112,
		146,
		147,
		132,
		125,
		111,
		113,
		111,
		109,
		114,
		135,
		136,
		149,
		-1,
		-1,
		65,
		72,
		60,
		46,
		65,
		-1,
		-1,
		-1,
		103,
		119,
		111,
		82,
		133,
		-1,
		-1,
		124,
		122,
		132,
		128,
		115,
		135,
		138,
		124,
		108,
		123,
		135,
		143,
		148,
		-1,
		68,
		55,
		-1,
		-1,
		68,
		62,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		114,
		135,
		160,
		127,
		-1,
		132,
		133,
		119,
		133,
		140,
		126,
		121,
		115,
		118,
		136,
		153,
		-1,
		-1,
		82,
		-1,
		77,
		-1,
		-1,
		-1,
		-1,
		93,
		107,
		128,
		134,
		146,
		-1,
		141,
		135,
		121,
		138,
		139,
		136,
		127,
		119,
		124,
		121,
		134,
		148,
		152,
		105,
		-1,
		88,
		-1,
		-1,
		-1,
		111,
		126,
		188,
		165,
		138,
		142,
		135,
		129,
		129,
		145,
		147,
		158,
		126,
		122,
		123,
		127,
		126,
		143,
		153,
		-1,
		-1,
		88,
		105,
		137,
		119,
		123,
		215,
		-1,
		-1,
		151,
		142,
		133,
		136,
		139,
		142,
		132,
		129,
		134,
		139,
		127,
		136,
		154,
		158,
		-1,
		-1,
		-1,
		108,
		-1,
		123,
		-1,
		-1,
		138,
		222,
		169,
		151,
		147,
		145,
		138,
		147,
		142,
		137,
		147,
		156,
		148,
		129,
		140,
		163,
		152,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		137,
		112,
		127,
		173,
		158,
		165,
		184,
		181,
		-1,
		151,
		176,
		148,
		155,
		147,
		155,
		155,
		152,
		130,
		137,
		153,
		152,
		147,
		182,
		174,
		180,
		-1,
		-1,
		218,
		207,
		196,
		202,
		-1,
		143,
		129,
		159,
		149,
		155,
		-1,
		-1,
		200,
		197,
		173,
		157,
		161,
		154,
		149,
		159,
		139,
		126,
		130,
		134,
		140,
		145,
		150,
		156,
		171,
		186,
		-1,
		113,
		194,
		187,
		170,
		178,
		209,
		-1,
		146,
		155,
		136,
		141,
		149,
		-1,
		-1,
		173,
		170,
		175,
		164,
		161,
		169,
		164,
		155,
		140,
		146,
		133,
		132,
		150,
		154,
		163,
		170,
		160,
		173,
		177,
		-1,
		127,
		170,
		164,
		167,
		191,
		205,
		-1,
		159,
		-1,
		-1,
		144,
		162,
		170,
		166,
		170,
		222,
		178,
		173,
		163,
		161,
		152,
		143,
		150,
		141,
		141,
		144,
		159,
		164,
		156,
		170,
		170,
		171,
		-1,
		162,
		150,
		158,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		160,
		-1,
		196,
		-1,
		189,
		193,
		186,
		189,
		177,
		164,
		156,
		148,
		164,
		139,
		149,
		145,
		146,
		155,
		166,
		178,
		177,
		178,
		236,
		191,
		158,
		149,
		196,
		211,
		215,
		-1,
		172,
		211,
		198,
		-1,
		169,
		-1,
		-1,
		-1,
		203,
		199,
		191,
		197,
		176,
		176,
		150,
		154,
		144,
		151,
		161,
		163,
		155,
		159,
		172,
		183,
		186,
		232,
		230,
		235,
		180,
		163,
		181,
		190,
		211,
		187,
		178,
		205,
		205,
		194,
		189,
		176,
		-1,
		-1,
		226,
		209,
		-1,
		-1,
		183,
		171,
		154,
		155,
		151,
		154,
		169,
		172,
		162,
		160,
		154,
		186,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		171,
		182,
		-1,
		-1,
		190,
		206,
		219,
		223,
		236,
		261,
		-1,
		179,
		-1,
		-1,
		228,
		-1,
		-1,
		213,
		176,
		165,
		156,
		162,
		159,
		170,
		180,
		168,
		169,
		159,
		169,
		182,
		216,
		213,
		201,
		199,
		222,
		179,
		175,
		-1,
		205,
		193,
		199,
		206,
		223,
		250,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		211,
		209,
		198,
		-1,
		188,
		161,
		166,
		186,
		188,
		177,
		171,
		165,
		172,
		171,
		179,
		187,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		205,
		-1,
		-1,
		206,
		199,
		187,
		175,
		165,
		175,
		179,
		183,
		175,
		168,
		163,
		174,
		166,
		170,
		187,
		-1,
		259,
		-1,
		211,
		204,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		240,
		224,
		205,
		-1,
		175,
		188,
		219,
		187,
		192,
		187,
		169,
		180,
		169,
		172,
		186,
		181,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		242,
		258,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		212,
		208,
		-1,
		-1,
		176,
		201,
		190,
		198,
		193,
		173,
		179,
		182,
		171,
		175,
		187,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		241,
		-1,
		259,
		-1,
		207,
		223,
		220,
		-1,
		-1,
		-1,
		214,
		177,
		198,
		208,
		202,
		200,
		191,
		177,
		184,
		182,
		178,
		189,
		-1,
		-1,
		-1,
		259,
		233,
		266,
		257,
		240,
		220,
		212,
		231,
		-1,
		201,
		-1,
		176,
		178,
		204,
		207,
		213,
		207,
		180,
		195,
		185,
		176,
		185,
		265,
		-1,
		235,
		268,
		232,
		226,
		202,
		206,
		222,
		-1,
		198,
		180,
		-1,
		208,
		198,
		229,
		214,
		195,
		182,
		189,
		189,
		182,
		-1,
		-1,
		-1,
		237,
		236,
		228,
		222,
		222,
		207,
		198,
		-1,
		210,
		192,
		171,
		188,
		188,
		179,
		187,
		219,
		215,
		202,
		202,
		194,
		-1,
		331,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		231,
		226,
		199,
		187,
		193,
		189,
		175,
		181,
		183,
		191,
		189,
		186,
		198,
		194,
		214,
		195,
		230,
		-1,
		333,
		-1,
		267,
		-1,
		-1,
		249,
		229,
		221,
		210,
		199,
		197,
		188,
		179,
		201,
		217,
		201,
		199,
		202,
		203,
		-1,
		322,
		321,
		-1,
		268,
		260,
		246,
		-1,
		239,
		-1,
		245,
		206,
		-1,
		208,
		188,
		-1,
		210,
		206,
		-1,
		-1,
		309,
		284,
		-1,
		-1,
		-1,
		269,
		249,
		240,
		224,
		-1,
		199,
		199,
		-1,
		-1,
		-1,
		294,
		293,
		-1,
		262,
		265,
		-1,
		255,
		246,
		254,
		201,
		205,
		-1,
		-1,
		-1,
		303,
		284,
		278,
		277,
		275,
		270,
		267,
		253,
		237,
		215,
		204,
		225,
		-1,
		-1,
		-1,
		275,
		267,
		260,
		-1,
		-1,
		262,
		245,
		226,
		224,
		-1,
		-1,
		-1,
		297,
		278,
		-1,
		-1,
		252,
		-1,
		-1,
		258,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		286,
		-1,
		-1,
		-1,
		248,
		244,
		245,
		-1,
		-1,
		-1,
		-1,
		308,
		309,
		332,
		296,
		-1,
		-1,
		-1,
		240,
		234,
		-1,
		-1,
		311,
		309,
		-1,
		-1,
		-1,
		268,
		252,
		-1,
		238,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		273,
		-1,
		273,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		286,
		278,
		286,
		-1,
		258,
		260,
		-1,
		308,
		-1,
		-1,
		301,
		292,
		-1,
		-1,
		263,
		270,
		292,
		295,
		331,
		-1,
		282
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		0,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		212,
		214,
		180,
		174,
		213,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		203,
		202,
		172,
		170,
		179,
		184,
		191,
		-1,
		197,
		-1,
		224,
		203,
		214,
		219,
		165,
		162,
		182,
		201,
		190,
		182,
		239,
		195,
		166,
		160,
		178,
		175,
		184,
		176,
		-1,
		166,
		156,
		178,
		164,
		175,
		167,
		-1,
		-1,
		160,
		161,
		167,
		160,
		166,
		162,
		-1,
		172,
		156,
		-1,
		-1,
		150,
		158,
		142,
		145,
		153,
		151,
		164,
		156,
		151,
		-1,
		-1,
		148,
		144,
		151,
		138,
		134,
		151,
		164,
		146,
		160,
		159,
		-1,
		139,
		157,
		166,
		145,
		143,
		127,
		125,
		143,
		145,
		151,
		154,
		-1,
		131,
		133,
		146,
		154,
		159,
		143,
		130,
		130,
		140,
		133,
		152,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		128,
		133,
		150,
		142,
		132,
		147,
		140,
		133,
		130,
		128,
		125,
		141,
		142,
		152,
		-1,
		-1,
		184,
		153,
		188,
		145,
		130,
		-1,
		124,
		126,
		132,
		136,
		130,
		123,
		137,
		133,
		-1,
		119,
		118,
		149,
		135,
		146,
		144,
		-1,
		-1,
		142,
		134,
		119,
		122,
		119,
		119,
		141,
		140,
		132,
		118,
		114,
		120,
		123,
		123,
		129,
		113,
		123,
		127,
		138,
		153,
		-1,
		-1,
		208,
		-1,
		-1,
		141,
		124,
		-1,
		107,
		114,
		114,
		131,
		121,
		142,
		151,
		142,
		134,
		128,
		116,
		118,
		115,
		128,
		116,
		110,
		135,
		139,
		133,
		154,
		149,
		-1,
		207,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		100,
		103,
		109,
		133,
		143,
		-1,
		136,
		142,
		152,
		137,
		134,
		121,
		109,
		122,
		107,
		114,
		113,
		117,
		119,
		152,
		130,
		152,
		149,
		178,
		183,
		177,
		186,
		-1,
		149,
		145,
		141,
		148,
		97,
		-1,
		-1,
		137,
		-1,
		151,
		153,
		128,
		146,
		149,
		138,
		129,
		116,
		105,
		116,
		105,
		102,
		110,
		119,
		130,
		125,
		124,
		142,
		157,
		170,
		174,
		180,
		-1,
		199,
		-1,
		141,
		125,
		127,
		99,
		120,
		-1,
		157,
		152,
		145,
		130,
		121,
		-1,
		124,
		127,
		134,
		112,
		97,
		114,
		106,
		104,
		109,
		114,
		128,
		119,
		137,
		144,
		152,
		156,
		176,
		188,
		159,
		149,
		-1,
		131,
		136,
		95,
		103,
		122,
		163,
		127,
		-1,
		122,
		-1,
		114,
		139,
		-1,
		118,
		114,
		96,
		97,
		92,
		107,
		113,
		110,
		107,
		125,
		128,
		145,
		149,
		165,
		-1,
		-1,
		144,
		148,
		137,
		88,
		107,
		131,
		168,
		120,
		109,
		108,
		-1,
		99,
		129,
		126,
		112,
		99,
		89,
		90,
		98,
		111,
		90,
		109,
		112,
		134,
		162,
		140,
		152,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		114,
		85,
		109,
		151,
		138,
		131,
		119,
		84,
		84,
		78,
		-1,
		119,
		102,
		98,
		87,
		85,
		98,
		93,
		109,
		113,
		112,
		131,
		143,
		134,
		154,
		-1,
		-1,
		-1,
		144,
		133,
		134,
		80,
		103,
		140,
		117,
		103,
		108,
		83,
		76,
		70,
		122,
		119,
		86,
		94,
		86,
		75,
		89,
		97,
		101,
		110,
		119,
		125,
		149,
		149,
		155,
		-1,
		-1,
		151,
		141,
		125,
		127,
		124,
		94,
		101,
		133,
		108,
		104,
		-1,
		75,
		-1,
		64,
		72,
		71,
		77,
		89,
		75,
		80,
		91,
		103,
		116,
		112,
		119,
		154,
		154,
		139,
		159,
		162,
		-1,
		-1,
		-1,
		144,
		139,
		114,
		91,
		75,
		111,
		-1,
		74,
		75,
		-1,
		69,
		63,
		69,
		68,
		75,
		72,
		72,
		86,
		94,
		90,
		106,
		112,
		104,
		140,
		-1,
		147,
		141,
		149,
		139,
		127,
		-1,
		-1,
		-1,
		137,
		116,
		109,
		129,
		70,
		122,
		-1,
		-1,
		59,
		52,
		-1,
		56,
		56,
		63,
		72,
		77,
		82,
		90,
		85,
		98,
		103,
		109,
		114,
		132,
		136,
		140,
		129,
		125,
		122,
		136,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		70,
		90,
		-1,
		71,
		63,
		52,
		46,
		39,
		69,
		67,
		87,
		79,
		93,
		93,
		99,
		107,
		92,
		95,
		111,
		109,
		127,
		135,
		127,
		121,
		120,
		132,
		-1,
		157,
		143,
		114,
		-1,
		-1,
		103,
		-1,
		67,
		80,
		96,
		-1,
		0,
		19,
		76,
		58,
		79,
		75,
		113,
		114,
		92,
		97,
		105,
		115,
		117,
		106,
		117,
		109,
		131,
		131,
		115,
		116,
		125,
		-1,
		163,
		150,
		108,
		104,
		93,
		113,
		64,
		52,
		83,
		-1,
		-1,
		129,
		-1,
		63,
		80,
		89,
		87,
		103,
		94,
		100,
		116,
		119,
		121,
		111,
		100,
		106,
		103,
		125,
		111,
		109,
		128,
		144,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		79,
		66,
		60,
		-1,
		100,
		-1,
		107,
		97,
		81,
		66,
		99,
		-1,
		111,
		95,
		100,
		-1,
		146,
		-1,
		119,
		121,
		115,
		100,
		97,
		108,
		106,
		117,
		134,
		-1,
		113,
		98,
		91,
		81,
		95,
		66,
		-1,
		121,
		-1,
		-1,
		94,
		88,
		88,
		72,
		75,
		127,
		107,
		101,
		100,
		141,
		141,
		127,
		113,
		106,
		103,
		100,
		113,
		133,
		124,
		136,
		-1,
		-1,
		-1,
		118,
		104,
		108,
		68,
		87,
		-1,
		-1,
		156,
		111,
		97,
		-1,
		81,
		144,
		132,
		122,
		112,
		146,
		147,
		132,
		125,
		111,
		113,
		111,
		109,
		114,
		135,
		136,
		149,
		-1,
		-1,
		101,
		106,
		94,
		80,
		99,
		-1,
		-1,
		-1,
		103,
		119,
		111,
		82,
		133,
		-1,
		-1,
		124,
		122,
		132,
		128,
		115,
		135,
		138,
		124,
		108,
		123,
		135,
		143,
		148,
		-1,
		104,
		91,
		-1,
		-1,
		102,
		96,
		-1,
		-1,
		-1,
		-1,
		136,
		102,
		114,
		135,
		160,
		127,
		-1,
		132,
		133,
		119,
		133,
		140,
		126,
		121,
		115,
		118,
		136,
		153,
		-1,
		-1,
		116,
		-1,
		111,
		-1,
		-1,
		-1,
		-1,
		93,
		107,
		128,
		134,
		146,
		-1,
		141,
		135,
		121,
		138,
		139,
		136,
		127,
		119,
		124,
		121,
		134,
		148,
		152,
		139,
		-1,
		122,
		-1,
		-1,
		-1,
		111,
		126,
		188,
		165,
		138,
		142,
		135,
		129,
		129,
		145,
		147,
		158,
		126,
		122,
		123,
		127,
		126,
		143,
		153,
		-1,
		-1,
		122,
		139,
		137,
		119,
		123,
		215,
		-1,
		-1,
		151,
		142,
		133,
		136,
		139,
		142,
		132,
		129,
		134,
		139,
		127,
		136,
		154,
		158,
		-1,
		-1,
		-1,
		142,
		-1,
		157,
		-1,
		-1,
		138,
		222,
		169,
		151,
		147,
		145,
		138,
		147,
		142,
		137,
		147,
		156,
		148,
		129,
		140,
		163,
		152,
		190,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		171,
		146,
		161,
		207,
		158,
		165,
		184,
		181,
		-1,
		151,
		176,
		148,
		155,
		147,
		155,
		155,
		152,
		130,
		137,
		153,
		152,
		147,
		182,
		174,
		180,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		177,
		163,
		193,
		183,
		175,
		-1,
		-1,
		200,
		197,
		173,
		157,
		161,
		154,
		149,
		159,
		139,
		126,
		130,
		134,
		140,
		145,
		150,
		156,
		171,
		186,
		-1,
		149,
		230,
		223,
		206,
		214,
		245,
		-1,
		180,
		189,
		170,
		175,
		183,
		-1,
		-1,
		173,
		170,
		175,
		164,
		161,
		169,
		164,
		155,
		140,
		146,
		133,
		132,
		150,
		154,
		163,
		170,
		160,
		173,
		177,
		-1,
		163,
		206,
		200,
		203,
		227,
		241,
		-1,
		193,
		-1,
		-1,
		178,
		196,
		188,
		178,
		172,
		222,
		178,
		173,
		163,
		161,
		152,
		143,
		150,
		141,
		141,
		144,
		159,
		164,
		156,
		170,
		170,
		171,
		-1,
		198,
		186,
		194,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		194,
		-1,
		215,
		-1,
		190,
		194,
		186,
		189,
		177,
		164,
		156,
		148,
		164,
		139,
		149,
		145,
		146,
		155,
		166,
		178,
		177,
		178,
		272,
		227,
		194,
		185,
		232,
		247,
		251,
		-1,
		206,
		245,
		232,
		-1,
		203,
		-1,
		-1,
		-1,
		204,
		199,
		191,
		197,
		176,
		176,
		150,
		154,
		144,
		151,
		161,
		163,
		155,
		159,
		172,
		183,
		186,
		268,
		266,
		271,
		216,
		199,
		217,
		226,
		247,
		221,
		212,
		239,
		239,
		228,
		223,
		210,
		-1,
		-1,
		227,
		209,
		-1,
		-1,
		183,
		171,
		154,
		155,
		151,
		154,
		169,
		172,
		162,
		160,
		154,
		186,
		-1,
		268,
		267,
		256,
		253,
		229,
		220,
		207,
		218,
		-1,
		-1,
		224,
		240,
		253,
		257,
		270,
		295,
		-1,
		213,
		-1,
		-1,
		228,
		-1,
		-1,
		213,
		176,
		165,
		156,
		162,
		159,
		170,
		180,
		168,
		169,
		159,
		169,
		182,
		252,
		249,
		237,
		235,
		258,
		215,
		211,
		-1,
		237,
		227,
		233,
		240,
		257,
		284,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		211,
		209,
		198,
		-1,
		188,
		161,
		166,
		186,
		188,
		177,
		171,
		165,
		172,
		171,
		179,
		187,
		261,
		275,
		264,
		260,
		259,
		267,
		216,
		222,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		-1,
		249,
		239,
		-1,
		-1,
		206,
		199,
		187,
		175,
		165,
		175,
		179,
		183,
		175,
		168,
		163,
		174,
		166,
		170,
		187,
		-1,
		295,
		-1,
		247,
		236,
		250,
		265,
		273,
		-1,
		-1,
		-1,
		266,
		252,
		245,
		233,
		231,
		-1,
		240,
		224,
		205,
		-1,
		175,
		188,
		219,
		187,
		192,
		187,
		169,
		180,
		169,
		172,
		186,
		181,
		-1,
		-1,
		248,
		251,
		-1,
		-1,
		256,
		258,
		-1,
		257,
		246,
		231,
		223,
		-1,
		-1,
		212,
		208,
		-1,
		-1,
		176,
		201,
		190,
		198,
		193,
		173,
		179,
		182,
		171,
		175,
		187,
		-1,
		-1,
		255,
		256,
		261,
		-1,
		241,
		-1,
		259,
		-1,
		226,
		232,
		220,
		-1,
		-1,
		-1,
		214,
		177,
		198,
		208,
		202,
		200,
		191,
		177,
		184,
		182,
		178,
		189,
		-1,
		-1,
		-1,
		259,
		233,
		266,
		257,
		240,
		220,
		212,
		231,
		-1,
		201,
		-1,
		176,
		178,
		204,
		207,
		213,
		207,
		180,
		195,
		185,
		176,
		185,
		265,
		-1,
		235,
		268,
		232,
		226,
		202,
		206,
		222,
		-1,
		198,
		180,
		-1,
		208,
		198,
		229,
		214,
		195,
		182,
		189,
		189,
		182,
		-1,
		-1,
		-1,
		237,
		236,
		228,
		222,
		222,
		207,
		198,
		-1,
		210,
		192,
		171,
		188,
		188,
		179,
		187,
		219,
		215,
		202,
		202,
		194,
		-1,
		338,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		231,
		226,
		199,
		187,
		193,
		189,
		175,
		181,
		183,
		191,
		189,
		186,
		198,
		194,
		214,
		195,
		230,
		-1,
		333,
		-1,
		267,
		-1,
		-1,
		249,
		229,
		221,
		210,
		199,
		197,
		188,
		179,
		201,
		217,
		201,
		199,
		202,
		203,
		-1,
		322,
		321,
		-1,
		268,
		260,
		246,
		-1,
		239,
		-1,
		245,
		206,
		-1,
		208,
		188,
		-1,
		210,
		206,
		-1,
		-1,
		309,
		284,
		-1,
		-1,
		-1,
		269,
		249,
		240,
		224,
		-1,
		199,
		199,
		-1,
		-1,
		-1,
		294,
		293,
		-1,
		262,
		265,
		-1,
		255,
		246,
		254,
		201,
		205,
		-1,
		-1,
		-1,
		303,
		284,
		278,
		277,
		275,
		270,
		267,
		253,
		237,
		215,
		204,
		225,
		-1,
		-1,
		-1,
		275,
		267,
		260,
		-1,
		-1,
		262,
		245,
		226,
		224,
		-1,
		-1,
		-1,
		297,
		278,
		-1,
		-1,
		252,
		-1,
		-1,
		258,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		286,
		-1,
		-1,
		-1,
		248,
		244,
		245,
		-1,
		-1,
		-1,
		-1,
		308,
		309,
		332,
		296,
		-1,
		-1,
		-1,
		240,
		234,
		-1,
		-1,
		311,
		309,
		-1,
		-1,
		-1,
		268,
		252,
		-1,
		238,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		273,
		-1,
		273,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		286,
		278,
		286,
		-1,
		258,
		260,
		-1,
		308,
		-1,
		-1,
		301,
		292,
		-1,
		-1,
		263,
		270,
		292,
		295,
		331,
		-1,
		282
	],
	[
		-1,
		184,
		173,
		184,
		192,
		165,
		172,
		-1,
		193,
		195,
		161,
		155,
		194,
		165,
		171,
		182,
		-1,
		-1,
		-1,
		184,
		183,
		153,
		151,
		160,
		165,
		172,
		-1,
		178,
		-1,
		205,
		184,
		195,
		200,
		146,
		143,
		163,
		182,
		171,
		163,
		220,
		176,
		147,
		141,
		159,
		156,
		165,
		157,
		-1,
		147,
		137,
		159,
		145,
		156,
		148,
		-1,
		-1,
		141,
		142,
		148,
		141,
		147,
		143,
		-1,
		153,
		137,
		-1,
		-1,
		131,
		139,
		123,
		126,
		134,
		132,
		145,
		137,
		132,
		-1,
		-1,
		129,
		125,
		132,
		119,
		115,
		132,
		145,
		127,
		141,
		140,
		-1,
		120,
		138,
		147,
		126,
		124,
		108,
		106,
		124,
		126,
		132,
		135,
		-1,
		112,
		114,
		127,
		135,
		140,
		124,
		111,
		111,
		121,
		114,
		133,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		114,
		131,
		123,
		113,
		128,
		121,
		114,
		111,
		109,
		106,
		122,
		123,
		133,
		-1,
		-1,
		165,
		134,
		169,
		126,
		111,
		-1,
		105,
		107,
		113,
		117,
		111,
		104,
		118,
		114,
		-1,
		100,
		99,
		130,
		116,
		127,
		125,
		-1,
		-1,
		123,
		115,
		100,
		103,
		100,
		100,
		122,
		121,
		113,
		99,
		95,
		101,
		104,
		104,
		110,
		94,
		104,
		108,
		119,
		134,
		-1,
		-1,
		189,
		-1,
		-1,
		122,
		105,
		-1,
		88,
		95,
		95,
		112,
		102,
		123,
		132,
		123,
		115,
		109,
		97,
		99,
		96,
		109,
		97,
		91,
		116,
		120,
		114,
		135,
		130,
		-1,
		188,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		81,
		84,
		90,
		114,
		124,
		-1,
		117,
		123,
		133,
		118,
		115,
		102,
		90,
		103,
		88,
		95,
		94,
		98,
		100,
		133,
		111,
		133,
		130,
		159,
		164,
		158,
		167,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		118,
		-1,
		132,
		134,
		109,
		127,
		130,
		119,
		110,
		97,
		86,
		97,
		86,
		83,
		91,
		100,
		111,
		106,
		105,
		123,
		138,
		151,
		155,
		161,
		-1,
		180,
		-1,
		122,
		106,
		108,
		80,
		101,
		-1,
		138,
		133,
		126,
		111,
		102,
		-1,
		105,
		108,
		115,
		93,
		78,
		95,
		87,
		85,
		90,
		95,
		109,
		100,
		118,
		125,
		133,
		137,
		157,
		169,
		140,
		130,
		-1,
		112,
		117,
		76,
		84,
		103,
		144,
		108,
		-1,
		103,
		-1,
		95,
		120,
		-1,
		99,
		95,
		77,
		78,
		73,
		88,
		94,
		91,
		88,
		106,
		109,
		126,
		130,
		146,
		-1,
		-1,
		125,
		129,
		118,
		69,
		88,
		112,
		149,
		101,
		90,
		89,
		-1,
		80,
		110,
		107,
		93,
		80,
		70,
		71,
		79,
		92,
		71,
		90,
		93,
		115,
		143,
		121,
		133,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		95,
		66,
		90,
		132,
		119,
		112,
		100,
		65,
		65,
		59,
		-1,
		100,
		83,
		79,
		68,
		66,
		79,
		74,
		90,
		94,
		93,
		112,
		124,
		115,
		135,
		-1,
		-1,
		-1,
		125,
		114,
		115,
		61,
		84,
		121,
		98,
		84,
		89,
		64,
		57,
		51,
		103,
		100,
		67,
		75,
		67,
		56,
		70,
		78,
		82,
		91,
		100,
		106,
		130,
		130,
		136,
		-1,
		-1,
		132,
		122,
		106,
		108,
		105,
		75,
		82,
		114,
		89,
		85,
		-1,
		56,
		-1,
		45,
		53,
		52,
		58,
		70,
		56,
		61,
		72,
		84,
		97,
		93,
		100,
		135,
		135,
		120,
		140,
		143,
		-1,
		-1,
		-1,
		125,
		120,
		95,
		72,
		56,
		92,
		-1,
		55,
		56,
		-1,
		50,
		44,
		50,
		49,
		56,
		53,
		53,
		67,
		75,
		71,
		87,
		93,
		85,
		121,
		-1,
		128,
		122,
		130,
		120,
		108,
		-1,
		-1,
		-1,
		118,
		97,
		90,
		110,
		51,
		103,
		-1,
		-1,
		40,
		33,
		-1,
		37,
		37,
		44,
		53,
		58,
		63,
		71,
		66,
		79,
		84,
		90,
		95,
		113,
		117,
		121,
		110,
		106,
		103,
		117,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		51,
		71,
		-1,
		52,
		44,
		33,
		27,
		20,
		50,
		48,
		68,
		60,
		74,
		74,
		80,
		88,
		73,
		76,
		92,
		90,
		108,
		116,
		108,
		102,
		101,
		113,
		-1,
		138,
		124,
		95,
		-1,
		-1,
		84,
		-1,
		48,
		61,
		77,
		-1,
		21,
		0,
		57,
		39,
		60,
		56,
		94,
		95,
		73,
		78,
		86,
		96,
		98,
		87,
		98,
		90,
		112,
		112,
		96,
		97,
		106,
		-1,
		144,
		131,
		89,
		85,
		74,
		94,
		45,
		33,
		64,
		-1,
		-1,
		110,
		-1,
		44,
		61,
		70,
		68,
		84,
		75,
		81,
		97,
		100,
		102,
		92,
		81,
		87,
		84,
		106,
		92,
		90,
		109,
		125,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		60,
		47,
		41,
		-1,
		81,
		-1,
		88,
		78,
		62,
		47,
		80,
		-1,
		92,
		76,
		81,
		-1,
		127,
		-1,
		100,
		102,
		96,
		81,
		78,
		89,
		87,
		98,
		115,
		-1,
		94,
		79,
		72,
		62,
		76,
		47,
		-1,
		102,
		-1,
		-1,
		75,
		69,
		69,
		53,
		56,
		108,
		88,
		82,
		81,
		122,
		122,
		108,
		94,
		87,
		84,
		81,
		94,
		114,
		105,
		117,
		-1,
		-1,
		-1,
		99,
		85,
		89,
		49,
		68,
		-1,
		-1,
		137,
		92,
		78,
		-1,
		62,
		125,
		113,
		103,
		93,
		127,
		128,
		113,
		106,
		92,
		94,
		92,
		90,
		95,
		116,
		117,
		130,
		-1,
		-1,
		82,
		87,
		75,
		61,
		80,
		-1,
		-1,
		-1,
		84,
		100,
		92,
		63,
		114,
		-1,
		-1,
		105,
		103,
		113,
		109,
		96,
		116,
		119,
		105,
		89,
		104,
		116,
		124,
		129,
		-1,
		85,
		72,
		-1,
		-1,
		83,
		77,
		-1,
		-1,
		-1,
		-1,
		117,
		83,
		95,
		116,
		141,
		108,
		-1,
		113,
		114,
		100,
		114,
		121,
		107,
		102,
		96,
		99,
		117,
		134,
		-1,
		-1,
		97,
		-1,
		92,
		-1,
		-1,
		-1,
		-1,
		74,
		88,
		109,
		115,
		127,
		-1,
		122,
		116,
		102,
		119,
		120,
		117,
		108,
		100,
		105,
		102,
		115,
		129,
		133,
		120,
		-1,
		103,
		-1,
		-1,
		-1,
		92,
		107,
		169,
		146,
		119,
		123,
		116,
		110,
		110,
		126,
		128,
		139,
		107,
		103,
		104,
		108,
		107,
		124,
		134,
		-1,
		-1,
		103,
		120,
		118,
		100,
		104,
		196,
		-1,
		-1,
		132,
		123,
		114,
		117,
		120,
		123,
		113,
		110,
		115,
		120,
		108,
		117,
		135,
		139,
		-1,
		-1,
		-1,
		123,
		-1,
		138,
		-1,
		-1,
		119,
		203,
		150,
		132,
		128,
		126,
		119,
		128,
		123,
		118,
		128,
		137,
		129,
		110,
		121,
		144,
		133,
		171,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		152,
		127,
		142,
		188,
		139,
		146,
		165,
		162,
		-1,
		132,
		157,
		129,
		136,
		128,
		136,
		136,
		133,
		111,
		118,
		134,
		133,
		128,
		163,
		155,
		161,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		158,
		144,
		174,
		164,
		156,
		-1,
		-1,
		181,
		178,
		154,
		138,
		142,
		135,
		130,
		140,
		120,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		130,
		211,
		204,
		187,
		195,
		226,
		-1,
		161,
		170,
		151,
		156,
		164,
		-1,
		-1,
		154,
		151,
		156,
		145,
		142,
		150,
		145,
		136,
		121,
		127,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		144,
		187,
		181,
		184,
		208,
		222,
		-1,
		174,
		-1,
		-1,
		159,
		177,
		169,
		159,
		153,
		203,
		159,
		154,
		144,
		142,
		133,
		124,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		179,
		167,
		175,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		175,
		-1,
		196,
		-1,
		171,
		175,
		167,
		170,
		158,
		145,
		137,
		129,
		145,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		253,
		208,
		175,
		166,
		213,
		228,
		232,
		-1,
		187,
		226,
		213,
		-1,
		184,
		-1,
		-1,
		-1,
		185,
		180,
		172,
		178,
		157,
		157,
		131,
		135,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		249,
		247,
		252,
		197,
		180,
		198,
		207,
		228,
		202,
		193,
		220,
		220,
		209,
		204,
		191,
		-1,
		-1,
		208,
		190,
		-1,
		-1,
		164,
		152,
		135,
		136,
		132,
		135,
		150,
		153,
		143,
		141,
		135,
		167,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		188,
		199,
		-1,
		-1,
		205,
		221,
		234,
		238,
		251,
		276,
		-1,
		194,
		-1,
		-1,
		209,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		140,
		151,
		161,
		149,
		150,
		140,
		150,
		163,
		233,
		230,
		218,
		216,
		239,
		196,
		192,
		-1,
		218,
		208,
		214,
		221,
		238,
		265,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		192,
		190,
		179,
		-1,
		169,
		142,
		147,
		167,
		169,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		203,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		220,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		160,
		164,
		156,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		276,
		-1,
		228,
		217,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		229,
		232,
		-1,
		-1,
		237,
		239,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		236,
		237,
		242,
		-1,
		222,
		-1,
		240,
		-1,
		207,
		213,
		201,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		183,
		181,
		172,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		240,
		214,
		247,
		238,
		221,
		201,
		193,
		212,
		-1,
		182,
		-1,
		157,
		159,
		185,
		188,
		194,
		188,
		161,
		176,
		166,
		157,
		166,
		246,
		-1,
		216,
		249,
		213,
		207,
		183,
		187,
		203,
		-1,
		179,
		161,
		-1,
		189,
		179,
		210,
		195,
		176,
		163,
		170,
		170,
		163,
		-1,
		-1,
		-1,
		218,
		217,
		209,
		203,
		203,
		188,
		179,
		-1,
		191,
		173,
		152,
		169,
		169,
		160,
		168,
		200,
		196,
		183,
		183,
		175,
		-1,
		319,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		212,
		207,
		180,
		168,
		174,
		170,
		156,
		162,
		164,
		172,
		170,
		167,
		179,
		175,
		195,
		176,
		211,
		-1,
		314,
		-1,
		248,
		-1,
		-1,
		230,
		210,
		202,
		191,
		180,
		178,
		169,
		160,
		182,
		198,
		182,
		180,
		183,
		184,
		-1,
		303,
		302,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		226,
		187,
		-1,
		189,
		169,
		-1,
		191,
		187,
		-1,
		-1,
		290,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		221,
		205,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		275,
		274,
		-1,
		243,
		246,
		-1,
		236,
		227,
		235,
		182,
		186,
		-1,
		-1,
		-1,
		284,
		265,
		259,
		258,
		256,
		251,
		248,
		234,
		218,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		256,
		248,
		241,
		-1,
		-1,
		243,
		226,
		207,
		205,
		-1,
		-1,
		-1,
		278,
		259,
		-1,
		-1,
		233,
		-1,
		-1,
		239,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		267,
		-1,
		-1,
		-1,
		229,
		225,
		226,
		-1,
		-1,
		-1,
		-1,
		289,
		290,
		313,
		277,
		-1,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		292,
		290,
		-1,
		-1,
		-1,
		249,
		233,
		-1,
		219,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		254,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		267,
		259,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		282,
		273,
		-1,
		-1,
		244,
		251,
		273,
		276,
		312,
		-1,
		263
	],
	[
		-1,
		196,
		185,
		196,
		204,
		177,
		184,
		-1,
		205,
		207,
		173,
		167,
		206,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		196,
		195,
		165,
		163,
		172,
		177,
		184,
		-1,
		188,
		-1,
		217,
		196,
		207,
		212,
		158,
		155,
		175,
		194,
		181,
		173,
		232,
		188,
		159,
		153,
		171,
		166,
		175,
		167,
		-1,
		159,
		149,
		171,
		155,
		166,
		158,
		-1,
		-1,
		153,
		154,
		160,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		143,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		132,
		150,
		159,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		145,
		-1,
		125,
		127,
		137,
		145,
		150,
		134,
		121,
		121,
		131,
		124,
		143,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		124,
		141,
		133,
		123,
		138,
		131,
		124,
		121,
		119,
		116,
		132,
		133,
		143,
		-1,
		-1,
		178,
		147,
		182,
		139,
		124,
		-1,
		118,
		117,
		123,
		127,
		121,
		114,
		128,
		124,
		-1,
		110,
		109,
		140,
		126,
		137,
		138,
		-1,
		-1,
		136,
		128,
		113,
		116,
		113,
		113,
		132,
		131,
		123,
		109,
		105,
		111,
		114,
		114,
		120,
		104,
		114,
		118,
		129,
		144,
		-1,
		-1,
		199,
		-1,
		-1,
		135,
		118,
		-1,
		101,
		108,
		108,
		125,
		115,
		136,
		142,
		133,
		125,
		119,
		107,
		109,
		106,
		119,
		107,
		101,
		126,
		130,
		124,
		145,
		140,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		94,
		97,
		103,
		127,
		137,
		-1,
		127,
		133,
		143,
		128,
		125,
		112,
		100,
		113,
		98,
		105,
		104,
		108,
		110,
		143,
		121,
		143,
		140,
		169,
		174,
		168,
		177,
		-1,
		143,
		139,
		135,
		142,
		91,
		-1,
		-1,
		131,
		-1,
		145,
		144,
		119,
		137,
		140,
		129,
		120,
		107,
		96,
		107,
		96,
		93,
		101,
		110,
		121,
		116,
		115,
		133,
		148,
		161,
		165,
		171,
		-1,
		193,
		-1,
		135,
		119,
		121,
		93,
		114,
		-1,
		151,
		146,
		136,
		121,
		112,
		-1,
		115,
		118,
		125,
		103,
		88,
		105,
		97,
		95,
		100,
		105,
		119,
		110,
		128,
		135,
		143,
		147,
		167,
		179,
		153,
		143,
		-1,
		125,
		130,
		89,
		97,
		116,
		154,
		118,
		-1,
		113,
		-1,
		105,
		130,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		104,
		101,
		98,
		116,
		119,
		136,
		140,
		156,
		-1,
		-1,
		138,
		142,
		131,
		82,
		101,
		125,
		162,
		111,
		100,
		99,
		-1,
		90,
		120,
		117,
		103,
		90,
		80,
		81,
		89,
		102,
		81,
		100,
		103,
		125,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		108,
		79,
		103,
		145,
		129,
		122,
		110,
		75,
		75,
		69,
		-1,
		110,
		93,
		89,
		78,
		76,
		89,
		84,
		100,
		104,
		103,
		122,
		134,
		125,
		145,
		-1,
		-1,
		-1,
		138,
		127,
		128,
		74,
		97,
		134,
		108,
		94,
		99,
		74,
		67,
		61,
		113,
		110,
		77,
		85,
		77,
		66,
		80,
		88,
		92,
		101,
		110,
		116,
		140,
		140,
		146,
		-1,
		-1,
		145,
		135,
		119,
		121,
		118,
		88,
		95,
		127,
		99,
		99,
		-1,
		66,
		-1,
		55,
		59,
		62,
		68,
		80,
		66,
		71,
		82,
		94,
		107,
		103,
		110,
		145,
		145,
		130,
		150,
		153,
		-1,
		-1,
		-1,
		138,
		133,
		108,
		85,
		69,
		105,
		-1,
		69,
		70,
		-1,
		60,
		54,
		56,
		59,
		66,
		63,
		63,
		77,
		85,
		81,
		97,
		103,
		95,
		131,
		-1,
		138,
		132,
		140,
		130,
		118,
		-1,
		-1,
		-1,
		131,
		110,
		103,
		123,
		64,
		116,
		-1,
		-1,
		54,
		47,
		-1,
		47,
		47,
		54,
		63,
		68,
		73,
		81,
		76,
		89,
		94,
		100,
		105,
		123,
		127,
		131,
		120,
		116,
		113,
		127,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		84,
		-1,
		66,
		58,
		47,
		41,
		30,
		59,
		57,
		78,
		70,
		84,
		84,
		90,
		98,
		83,
		86,
		102,
		100,
		118,
		126,
		118,
		112,
		111,
		123,
		-1,
		151,
		137,
		108,
		-1,
		-1,
		97,
		-1,
		61,
		75,
		91,
		-1,
		68,
		47,
		0,
		34,
		69,
		66,
		104,
		105,
		83,
		88,
		96,
		106,
		108,
		97,
		108,
		100,
		122,
		122,
		106,
		107,
		116,
		-1,
		157,
		144,
		102,
		98,
		87,
		107,
		58,
		46,
		78,
		-1,
		-1,
		120,
		-1,
		49,
		71,
		80,
		78,
		94,
		85,
		91,
		107,
		110,
		112,
		102,
		91,
		97,
		94,
		116,
		102,
		100,
		119,
		135,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		73,
		60,
		54,
		-1,
		95,
		-1,
		98,
		88,
		72,
		57,
		90,
		-1,
		102,
		86,
		91,
		-1,
		137,
		-1,
		110,
		112,
		106,
		91,
		88,
		99,
		97,
		108,
		125,
		-1,
		107,
		92,
		85,
		75,
		89,
		60,
		-1,
		115,
		-1,
		-1,
		85,
		79,
		79,
		63,
		66,
		118,
		98,
		92,
		91,
		132,
		132,
		118,
		104,
		97,
		94,
		91,
		104,
		124,
		115,
		127,
		-1,
		-1,
		-1,
		112,
		98,
		102,
		62,
		81,
		-1,
		-1,
		147,
		102,
		88,
		-1,
		72,
		135,
		123,
		113,
		103,
		137,
		138,
		123,
		116,
		102,
		104,
		102,
		100,
		105,
		126,
		127,
		140,
		-1,
		-1,
		95,
		100,
		88,
		74,
		93,
		-1,
		-1,
		-1,
		94,
		110,
		102,
		73,
		124,
		-1,
		-1,
		115,
		113,
		123,
		119,
		106,
		126,
		129,
		115,
		99,
		114,
		126,
		134,
		139,
		-1,
		98,
		85,
		-1,
		-1,
		96,
		90,
		-1,
		-1,
		-1,
		-1,
		127,
		93,
		105,
		126,
		151,
		118,
		-1,
		123,
		124,
		110,
		124,
		131,
		117,
		112,
		106,
		109,
		127,
		144,
		-1,
		-1,
		110,
		-1,
		105,
		-1,
		-1,
		-1,
		-1,
		84,
		98,
		119,
		125,
		137,
		-1,
		132,
		126,
		112,
		129,
		130,
		127,
		118,
		110,
		115,
		112,
		125,
		139,
		143,
		133,
		-1,
		116,
		-1,
		-1,
		-1,
		102,
		117,
		179,
		156,
		129,
		133,
		126,
		120,
		120,
		136,
		138,
		149,
		117,
		113,
		114,
		118,
		117,
		134,
		144,
		-1,
		-1,
		116,
		133,
		128,
		110,
		114,
		206,
		-1,
		-1,
		142,
		133,
		124,
		127,
		130,
		133,
		123,
		120,
		125,
		130,
		118,
		127,
		145,
		149,
		-1,
		-1,
		-1,
		136,
		-1,
		151,
		-1,
		-1,
		129,
		213,
		160,
		142,
		138,
		136,
		129,
		138,
		133,
		128,
		138,
		147,
		139,
		120,
		131,
		154,
		143,
		181,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		165,
		140,
		155,
		201,
		149,
		156,
		175,
		172,
		-1,
		142,
		167,
		139,
		146,
		138,
		146,
		146,
		143,
		121,
		128,
		144,
		143,
		138,
		173,
		165,
		171,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		171,
		157,
		187,
		177,
		166,
		-1,
		-1,
		191,
		188,
		164,
		148,
		152,
		145,
		140,
		150,
		130,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		143,
		224,
		217,
		200,
		208,
		239,
		-1,
		174,
		183,
		164,
		169,
		177,
		-1,
		-1,
		164,
		161,
		166,
		155,
		152,
		160,
		155,
		146,
		131,
		137,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		157,
		200,
		194,
		197,
		221,
		235,
		-1,
		187,
		-1,
		-1,
		172,
		190,
		179,
		169,
		163,
		213,
		169,
		164,
		154,
		152,
		143,
		134,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		192,
		180,
		188,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		188,
		-1,
		206,
		-1,
		181,
		185,
		177,
		180,
		168,
		155,
		147,
		139,
		155,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		266,
		221,
		188,
		179,
		226,
		241,
		245,
		-1,
		200,
		239,
		226,
		-1,
		197,
		-1,
		-1,
		-1,
		195,
		190,
		182,
		188,
		167,
		167,
		141,
		145,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		262,
		260,
		265,
		210,
		193,
		211,
		220,
		241,
		215,
		206,
		233,
		233,
		222,
		217,
		204,
		-1,
		-1,
		218,
		200,
		-1,
		-1,
		174,
		162,
		145,
		146,
		142,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		201,
		212,
		-1,
		-1,
		218,
		234,
		247,
		251,
		264,
		289,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		150,
		161,
		171,
		159,
		160,
		150,
		160,
		173,
		246,
		243,
		231,
		229,
		252,
		209,
		205,
		-1,
		228,
		221,
		227,
		234,
		251,
		278,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		152,
		157,
		177,
		179,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		213,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		233,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		170,
		174,
		166,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		289,
		-1,
		241,
		227,
		241,
		256,
		264,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		247,
		249,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		246,
		247,
		252,
		-1,
		232,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		193,
		191,
		182,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		169,
		195,
		198,
		204,
		198,
		171,
		186,
		176,
		167,
		176,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		220,
		205,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		210,
		206,
		193,
		193,
		185,
		-1,
		329,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		186,
		221,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		193,
		194,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		174,
		163,
		174,
		182,
		155,
		162,
		-1,
		183,
		185,
		151,
		145,
		184,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		174,
		173,
		143,
		141,
		150,
		155,
		162,
		-1,
		166,
		-1,
		195,
		174,
		185,
		190,
		136,
		133,
		153,
		172,
		159,
		151,
		210,
		166,
		137,
		131,
		149,
		144,
		153,
		145,
		-1,
		137,
		127,
		149,
		133,
		144,
		136,
		-1,
		-1,
		131,
		132,
		138,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		121,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		128,
		-1,
		110,
		128,
		137,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		123,
		-1,
		103,
		105,
		115,
		123,
		128,
		112,
		99,
		99,
		109,
		102,
		121,
		112,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		100,
		102,
		119,
		111,
		101,
		116,
		109,
		102,
		99,
		97,
		94,
		110,
		111,
		121,
		-1,
		-1,
		156,
		125,
		160,
		117,
		102,
		-1,
		96,
		95,
		101,
		105,
		99,
		92,
		106,
		102,
		-1,
		88,
		87,
		118,
		104,
		115,
		116,
		-1,
		-1,
		114,
		106,
		91,
		94,
		91,
		91,
		110,
		109,
		101,
		87,
		83,
		89,
		92,
		92,
		98,
		82,
		92,
		96,
		107,
		122,
		-1,
		-1,
		177,
		-1,
		-1,
		113,
		96,
		-1,
		79,
		86,
		86,
		103,
		93,
		114,
		120,
		111,
		103,
		97,
		85,
		87,
		84,
		97,
		85,
		79,
		104,
		108,
		102,
		123,
		118,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		72,
		75,
		81,
		105,
		115,
		-1,
		105,
		111,
		121,
		106,
		103,
		90,
		78,
		91,
		76,
		83,
		82,
		86,
		88,
		121,
		99,
		121,
		118,
		147,
		152,
		146,
		155,
		-1,
		121,
		117,
		113,
		120,
		69,
		-1,
		-1,
		109,
		-1,
		123,
		122,
		97,
		115,
		118,
		107,
		98,
		85,
		74,
		85,
		74,
		71,
		79,
		88,
		99,
		94,
		93,
		111,
		126,
		139,
		143,
		149,
		-1,
		171,
		-1,
		113,
		97,
		99,
		71,
		92,
		-1,
		129,
		124,
		114,
		99,
		90,
		-1,
		93,
		96,
		103,
		81,
		66,
		83,
		75,
		73,
		78,
		83,
		97,
		88,
		106,
		113,
		121,
		125,
		145,
		157,
		131,
		121,
		-1,
		103,
		108,
		67,
		75,
		94,
		132,
		96,
		-1,
		91,
		-1,
		83,
		108,
		-1,
		87,
		83,
		65,
		66,
		61,
		76,
		82,
		79,
		76,
		94,
		97,
		114,
		118,
		134,
		-1,
		-1,
		116,
		120,
		109,
		60,
		79,
		103,
		140,
		89,
		78,
		77,
		-1,
		68,
		98,
		95,
		81,
		68,
		58,
		59,
		67,
		80,
		59,
		78,
		81,
		103,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		86,
		57,
		81,
		123,
		107,
		100,
		88,
		53,
		53,
		47,
		-1,
		88,
		71,
		67,
		56,
		54,
		67,
		62,
		78,
		82,
		81,
		100,
		112,
		103,
		123,
		-1,
		-1,
		-1,
		116,
		105,
		106,
		52,
		75,
		112,
		86,
		72,
		77,
		52,
		45,
		39,
		91,
		88,
		55,
		63,
		55,
		44,
		58,
		66,
		70,
		79,
		88,
		94,
		118,
		118,
		124,
		-1,
		-1,
		123,
		113,
		97,
		99,
		96,
		66,
		73,
		105,
		77,
		83,
		-1,
		44,
		-1,
		33,
		36,
		40,
		46,
		58,
		44,
		49,
		60,
		72,
		85,
		81,
		88,
		123,
		123,
		108,
		128,
		131,
		-1,
		-1,
		-1,
		116,
		111,
		86,
		63,
		47,
		83,
		-1,
		53,
		54,
		-1,
		38,
		32,
		33,
		37,
		44,
		41,
		41,
		55,
		63,
		59,
		75,
		81,
		73,
		109,
		-1,
		116,
		110,
		118,
		108,
		96,
		-1,
		-1,
		-1,
		109,
		88,
		81,
		101,
		42,
		94,
		-1,
		-1,
		38,
		31,
		-1,
		25,
		25,
		32,
		41,
		46,
		51,
		59,
		54,
		67,
		72,
		78,
		83,
		101,
		105,
		109,
		98,
		94,
		91,
		105,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		42,
		62,
		-1,
		50,
		42,
		31,
		25,
		14,
		36,
		34,
		56,
		48,
		62,
		62,
		68,
		76,
		61,
		64,
		80,
		78,
		96,
		104,
		96,
		90,
		89,
		101,
		-1,
		129,
		115,
		86,
		-1,
		-1,
		75,
		-1,
		39,
		53,
		69,
		-1,
		52,
		31,
		36,
		0,
		44,
		44,
		82,
		83,
		61,
		66,
		74,
		84,
		86,
		75,
		86,
		78,
		100,
		100,
		84,
		85,
		94,
		-1,
		135,
		122,
		80,
		76,
		65,
		85,
		36,
		24,
		56,
		-1,
		-1,
		98,
		-1,
		24,
		49,
		58,
		56,
		72,
		63,
		69,
		85,
		88,
		90,
		80,
		69,
		75,
		72,
		94,
		80,
		78,
		97,
		113,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		51,
		38,
		32,
		-1,
		73,
		-1,
		76,
		66,
		50,
		35,
		68,
		-1,
		80,
		64,
		69,
		-1,
		115,
		-1,
		88,
		90,
		84,
		69,
		66,
		77,
		75,
		86,
		103,
		-1,
		85,
		70,
		63,
		53,
		67,
		38,
		-1,
		93,
		-1,
		-1,
		63,
		57,
		57,
		41,
		44,
		96,
		76,
		70,
		69,
		110,
		110,
		96,
		82,
		75,
		72,
		69,
		82,
		102,
		93,
		105,
		-1,
		-1,
		-1,
		90,
		76,
		80,
		40,
		59,
		-1,
		-1,
		125,
		80,
		66,
		-1,
		50,
		113,
		101,
		91,
		81,
		115,
		116,
		101,
		94,
		80,
		82,
		80,
		78,
		83,
		104,
		105,
		118,
		-1,
		-1,
		73,
		78,
		66,
		52,
		71,
		-1,
		-1,
		-1,
		72,
		88,
		80,
		51,
		102,
		-1,
		-1,
		93,
		91,
		101,
		97,
		84,
		104,
		107,
		93,
		77,
		92,
		104,
		112,
		117,
		-1,
		76,
		63,
		-1,
		-1,
		74,
		68,
		-1,
		-1,
		-1,
		-1,
		105,
		71,
		83,
		104,
		129,
		96,
		-1,
		101,
		102,
		88,
		102,
		109,
		95,
		90,
		84,
		87,
		105,
		122,
		-1,
		-1,
		88,
		-1,
		83,
		-1,
		-1,
		-1,
		-1,
		62,
		76,
		97,
		103,
		115,
		-1,
		110,
		104,
		90,
		107,
		108,
		105,
		96,
		88,
		93,
		90,
		103,
		117,
		121,
		111,
		-1,
		94,
		-1,
		-1,
		-1,
		80,
		95,
		157,
		134,
		107,
		111,
		104,
		98,
		98,
		114,
		116,
		127,
		95,
		91,
		92,
		96,
		95,
		112,
		122,
		-1,
		-1,
		94,
		111,
		106,
		88,
		92,
		184,
		-1,
		-1,
		120,
		111,
		102,
		105,
		108,
		111,
		101,
		98,
		103,
		108,
		96,
		105,
		123,
		127,
		-1,
		-1,
		-1,
		114,
		-1,
		129,
		-1,
		-1,
		107,
		191,
		138,
		120,
		116,
		114,
		107,
		116,
		111,
		106,
		116,
		125,
		117,
		98,
		109,
		132,
		121,
		159,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		143,
		118,
		133,
		179,
		127,
		134,
		153,
		150,
		-1,
		120,
		145,
		117,
		124,
		116,
		124,
		124,
		121,
		99,
		106,
		122,
		121,
		116,
		151,
		143,
		149,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		149,
		135,
		165,
		155,
		144,
		-1,
		-1,
		169,
		166,
		142,
		126,
		130,
		123,
		118,
		128,
		108,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		140,
		155,
		-1,
		121,
		202,
		195,
		178,
		186,
		217,
		-1,
		152,
		161,
		142,
		147,
		155,
		-1,
		-1,
		142,
		139,
		144,
		133,
		130,
		138,
		133,
		124,
		109,
		115,
		102,
		101,
		119,
		123,
		132,
		139,
		129,
		142,
		146,
		-1,
		135,
		178,
		172,
		175,
		199,
		213,
		-1,
		165,
		-1,
		-1,
		150,
		168,
		157,
		147,
		141,
		191,
		147,
		142,
		132,
		130,
		121,
		112,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		139,
		139,
		140,
		-1,
		170,
		158,
		166,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		166,
		-1,
		184,
		-1,
		159,
		163,
		155,
		158,
		146,
		133,
		125,
		117,
		133,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		146,
		147,
		244,
		199,
		166,
		157,
		204,
		219,
		223,
		-1,
		178,
		217,
		204,
		-1,
		175,
		-1,
		-1,
		-1,
		173,
		168,
		160,
		166,
		145,
		145,
		119,
		123,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		155,
		240,
		238,
		243,
		188,
		171,
		189,
		198,
		219,
		193,
		184,
		211,
		211,
		200,
		195,
		182,
		-1,
		-1,
		196,
		178,
		-1,
		-1,
		152,
		140,
		123,
		124,
		120,
		123,
		138,
		141,
		131,
		129,
		123,
		155,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		179,
		190,
		-1,
		-1,
		196,
		212,
		225,
		229,
		242,
		267,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		128,
		139,
		149,
		137,
		138,
		128,
		138,
		151,
		224,
		221,
		209,
		207,
		230,
		187,
		183,
		-1,
		206,
		199,
		205,
		212,
		229,
		256,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		130,
		135,
		155,
		157,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		191,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		218,
		211,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		148,
		152,
		144,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		267,
		-1,
		219,
		205,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		235,
		221,
		214,
		202,
		200,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		225,
		227,
		-1,
		226,
		215,
		200,
		192,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		210,
		-1,
		228,
		-1,
		195,
		201,
		189,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		171,
		169,
		160,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		228,
		202,
		235,
		226,
		209,
		189,
		181,
		200,
		-1,
		170,
		-1,
		145,
		147,
		173,
		176,
		182,
		176,
		149,
		164,
		154,
		145,
		154,
		234,
		-1,
		204,
		237,
		201,
		195,
		171,
		175,
		191,
		-1,
		167,
		149,
		-1,
		177,
		167,
		198,
		183,
		164,
		151,
		158,
		158,
		151,
		-1,
		-1,
		-1,
		206,
		205,
		197,
		191,
		191,
		176,
		167,
		-1,
		179,
		161,
		140,
		157,
		157,
		148,
		156,
		188,
		184,
		171,
		171,
		163,
		-1,
		307,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		200,
		195,
		168,
		156,
		162,
		158,
		144,
		150,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		164,
		199,
		-1,
		302,
		-1,
		236,
		-1,
		-1,
		218,
		198,
		190,
		179,
		168,
		166,
		157,
		148,
		170,
		186,
		170,
		168,
		171,
		172,
		-1,
		291,
		290,
		-1,
		237,
		229,
		215,
		-1,
		208,
		-1,
		214,
		175,
		-1,
		177,
		157,
		-1,
		179,
		175,
		-1,
		-1,
		278,
		253,
		-1,
		-1,
		-1,
		238,
		218,
		209,
		193,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		263,
		262,
		-1,
		231,
		234,
		-1,
		224,
		215,
		223,
		170,
		174,
		-1,
		-1,
		-1,
		272,
		253,
		247,
		246,
		244,
		239,
		236,
		222,
		206,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		244,
		236,
		229,
		-1,
		-1,
		231,
		214,
		195,
		193,
		-1,
		-1,
		-1,
		266,
		247,
		-1,
		-1,
		221,
		-1,
		-1,
		227,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		255,
		-1,
		-1,
		-1,
		217,
		213,
		214,
		-1,
		-1,
		-1,
		-1,
		277,
		278,
		301,
		265,
		-1,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		280,
		278,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		207,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		242,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		255,
		247,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		270,
		261,
		-1,
		-1,
		232,
		239,
		261,
		264,
		300,
		-1,
		251
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		182,
		184,
		150,
		144,
		183,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		173,
		172,
		142,
		140,
		149,
		154,
		161,
		-1,
		165,
		-1,
		194,
		173,
		184,
		189,
		135,
		132,
		152,
		171,
		158,
		150,
		209,
		165,
		136,
		130,
		148,
		143,
		152,
		144,
		-1,
		136,
		126,
		148,
		132,
		143,
		135,
		-1,
		-1,
		130,
		131,
		137,
		128,
		134,
		130,
		-1,
		140,
		124,
		-1,
		-1,
		120,
		126,
		110,
		113,
		121,
		119,
		132,
		124,
		119,
		-1,
		-1,
		116,
		112,
		119,
		106,
		102,
		119,
		132,
		114,
		128,
		127,
		-1,
		109,
		127,
		136,
		113,
		111,
		95,
		93,
		111,
		113,
		119,
		122,
		-1,
		118,
		119,
		114,
		122,
		127,
		111,
		98,
		98,
		108,
		101,
		120,
		111,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		101,
		118,
		110,
		100,
		115,
		108,
		101,
		98,
		96,
		93,
		109,
		110,
		120,
		-1,
		-1,
		173,
		142,
		177,
		134,
		119,
		-1,
		113,
		94,
		100,
		104,
		98,
		91,
		105,
		101,
		-1,
		87,
		86,
		117,
		103,
		114,
		133,
		-1,
		-1,
		131,
		123,
		108,
		111,
		108,
		108,
		109,
		108,
		100,
		86,
		82,
		88,
		91,
		91,
		97,
		81,
		91,
		95,
		106,
		121,
		-1,
		-1,
		176,
		-1,
		-1,
		130,
		113,
		-1,
		96,
		103,
		103,
		120,
		110,
		131,
		119,
		110,
		102,
		96,
		84,
		86,
		83,
		96,
		84,
		78,
		103,
		107,
		101,
		122,
		117,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		89,
		92,
		98,
		122,
		132,
		-1,
		122,
		119,
		120,
		105,
		102,
		89,
		77,
		90,
		75,
		82,
		81,
		85,
		87,
		120,
		98,
		120,
		117,
		146,
		151,
		145,
		154,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		126,
		-1,
		140,
		139,
		114,
		116,
		119,
		106,
		97,
		84,
		73,
		84,
		73,
		70,
		78,
		87,
		98,
		93,
		92,
		110,
		125,
		138,
		142,
		148,
		-1,
		188,
		-1,
		130,
		114,
		116,
		88,
		109,
		-1,
		146,
		141,
		131,
		116,
		107,
		-1,
		110,
		112,
		102,
		80,
		65,
		82,
		74,
		72,
		77,
		82,
		96,
		87,
		105,
		112,
		120,
		124,
		144,
		156,
		148,
		138,
		-1,
		120,
		125,
		84,
		92,
		111,
		149,
		113,
		-1,
		108,
		-1,
		100,
		125,
		-1,
		86,
		82,
		64,
		65,
		60,
		75,
		81,
		78,
		75,
		93,
		96,
		113,
		117,
		133,
		-1,
		-1,
		133,
		137,
		126,
		77,
		96,
		120,
		157,
		106,
		95,
		94,
		-1,
		85,
		97,
		94,
		80,
		67,
		57,
		58,
		66,
		79,
		58,
		77,
		80,
		102,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		103,
		74,
		98,
		140,
		124,
		117,
		105,
		70,
		70,
		64,
		-1,
		87,
		70,
		66,
		55,
		53,
		66,
		61,
		77,
		81,
		80,
		99,
		111,
		102,
		122,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		69,
		92,
		129,
		103,
		89,
		94,
		69,
		62,
		56,
		90,
		87,
		54,
		62,
		54,
		43,
		57,
		65,
		69,
		78,
		87,
		93,
		117,
		117,
		123,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		83,
		90,
		122,
		94,
		107,
		-1,
		61,
		-1,
		50,
		38,
		39,
		45,
		57,
		43,
		48,
		59,
		71,
		84,
		80,
		87,
		122,
		122,
		107,
		127,
		130,
		-1,
		-1,
		-1,
		133,
		128,
		103,
		80,
		64,
		100,
		-1,
		77,
		78,
		-1,
		55,
		49,
		38,
		36,
		43,
		40,
		40,
		54,
		62,
		58,
		74,
		80,
		72,
		108,
		-1,
		115,
		109,
		117,
		107,
		95,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		59,
		111,
		-1,
		-1,
		62,
		55,
		-1,
		40,
		24,
		28,
		37,
		45,
		50,
		58,
		53,
		66,
		71,
		77,
		82,
		100,
		104,
		108,
		97,
		93,
		90,
		104,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		79,
		-1,
		71,
		63,
		53,
		47,
		41,
		13,
		15,
		51,
		43,
		61,
		61,
		67,
		75,
		60,
		63,
		79,
		77,
		95,
		103,
		95,
		89,
		88,
		100,
		-1,
		146,
		132,
		103,
		-1,
		-1,
		92,
		-1,
		56,
		70,
		86,
		-1,
		79,
		58,
		70,
		51,
		0,
		39,
		81,
		82,
		60,
		65,
		73,
		83,
		85,
		74,
		85,
		77,
		99,
		99,
		83,
		84,
		93,
		-1,
		152,
		139,
		97,
		93,
		82,
		102,
		53,
		41,
		73,
		-1,
		-1,
		103,
		-1,
		47,
		42,
		53,
		51,
		71,
		62,
		68,
		84,
		87,
		89,
		79,
		68,
		74,
		71,
		93,
		79,
		77,
		96,
		112,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		68,
		55,
		49,
		-1,
		90,
		-1,
		81,
		71,
		55,
		48,
		71,
		-1,
		79,
		63,
		68,
		-1,
		114,
		-1,
		87,
		89,
		83,
		68,
		65,
		76,
		74,
		85,
		102,
		-1,
		102,
		87,
		80,
		70,
		84,
		55,
		-1,
		110,
		-1,
		-1,
		68,
		62,
		62,
		54,
		57,
		95,
		75,
		69,
		68,
		109,
		109,
		95,
		81,
		74,
		71,
		68,
		81,
		101,
		92,
		104,
		-1,
		-1,
		-1,
		107,
		93,
		97,
		57,
		76,
		-1,
		-1,
		130,
		85,
		71,
		-1,
		63,
		112,
		100,
		90,
		80,
		114,
		115,
		100,
		93,
		79,
		81,
		79,
		77,
		82,
		103,
		104,
		117,
		-1,
		-1,
		90,
		95,
		83,
		69,
		88,
		-1,
		-1,
		-1,
		79,
		95,
		90,
		64,
		101,
		-1,
		-1,
		92,
		90,
		100,
		96,
		83,
		103,
		106,
		92,
		76,
		91,
		103,
		111,
		116,
		-1,
		93,
		80,
		-1,
		-1,
		91,
		85,
		-1,
		-1,
		-1,
		-1,
		118,
		84,
		96,
		117,
		137,
		95,
		-1,
		100,
		101,
		87,
		101,
		108,
		94,
		89,
		83,
		86,
		104,
		121,
		-1,
		-1,
		105,
		-1,
		100,
		-1,
		-1,
		-1,
		-1,
		75,
		89,
		110,
		116,
		123,
		-1,
		109,
		103,
		89,
		106,
		107,
		104,
		95,
		87,
		92,
		89,
		102,
		116,
		120,
		128,
		-1,
		111,
		-1,
		-1,
		-1,
		93,
		108,
		165,
		142,
		115,
		110,
		103,
		97,
		97,
		113,
		115,
		126,
		94,
		90,
		91,
		95,
		94,
		111,
		121,
		-1,
		-1,
		111,
		128,
		119,
		101,
		105,
		192,
		-1,
		-1,
		119,
		110,
		101,
		104,
		107,
		110,
		100,
		97,
		102,
		107,
		95,
		104,
		122,
		126,
		-1,
		-1,
		-1,
		131,
		-1,
		146,
		-1,
		-1,
		120,
		190,
		137,
		119,
		115,
		113,
		106,
		115,
		110,
		105,
		115,
		124,
		116,
		97,
		108,
		131,
		120,
		158,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		160,
		135,
		150,
		196,
		140,
		147,
		152,
		149,
		-1,
		119,
		144,
		116,
		123,
		115,
		123,
		123,
		120,
		98,
		105,
		121,
		120,
		115,
		150,
		142,
		148,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		166,
		152,
		182,
		172,
		157,
		-1,
		-1,
		168,
		165,
		141,
		125,
		129,
		122,
		117,
		127,
		107,
		94,
		98,
		102,
		108,
		113,
		118,
		124,
		139,
		154,
		-1,
		138,
		219,
		212,
		195,
		203,
		234,
		-1,
		169,
		178,
		159,
		164,
		168,
		-1,
		-1,
		141,
		138,
		143,
		132,
		129,
		137,
		132,
		123,
		108,
		114,
		101,
		100,
		118,
		122,
		131,
		138,
		128,
		141,
		145,
		-1,
		152,
		195,
		189,
		192,
		216,
		230,
		-1,
		182,
		-1,
		-1,
		167,
		172,
		156,
		146,
		140,
		190,
		146,
		141,
		131,
		129,
		120,
		111,
		118,
		109,
		109,
		112,
		127,
		132,
		124,
		138,
		138,
		139,
		-1,
		187,
		175,
		183,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		183,
		-1,
		183,
		-1,
		158,
		162,
		154,
		157,
		145,
		132,
		124,
		116,
		132,
		107,
		117,
		113,
		114,
		123,
		134,
		146,
		145,
		146,
		260,
		216,
		183,
		174,
		221,
		236,
		240,
		-1,
		195,
		234,
		221,
		-1,
		192,
		-1,
		-1,
		-1,
		172,
		167,
		159,
		165,
		144,
		144,
		118,
		122,
		112,
		119,
		129,
		131,
		123,
		127,
		140,
		151,
		154,
		256,
		247,
		260,
		205,
		188,
		206,
		215,
		236,
		210,
		201,
		228,
		228,
		217,
		212,
		199,
		-1,
		-1,
		195,
		177,
		-1,
		-1,
		151,
		139,
		122,
		123,
		119,
		122,
		137,
		140,
		130,
		128,
		122,
		154,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		196,
		207,
		-1,
		-1,
		213,
		229,
		229,
		233,
		249,
		274,
		-1,
		202,
		-1,
		-1,
		196,
		-1,
		-1,
		181,
		144,
		133,
		124,
		130,
		127,
		138,
		148,
		136,
		137,
		127,
		137,
		150,
		233,
		230,
		218,
		216,
		239,
		204,
		192,
		-1,
		205,
		203,
		209,
		216,
		233,
		263,
		-1,
		-1,
		218,
		207,
		-1,
		-1,
		179,
		177,
		166,
		-1,
		156,
		129,
		134,
		154,
		156,
		145,
		139,
		133,
		140,
		139,
		147,
		155,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		190,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		217,
		213,
		-1,
		-1,
		174,
		167,
		155,
		143,
		133,
		143,
		147,
		151,
		143,
		136,
		131,
		142,
		134,
		138,
		155,
		-1,
		276,
		-1,
		228,
		204,
		218,
		233,
		241,
		-1,
		-1,
		-1,
		234,
		220,
		213,
		201,
		199,
		-1,
		208,
		192,
		173,
		-1,
		143,
		156,
		187,
		155,
		160,
		155,
		137,
		148,
		137,
		140,
		154,
		149,
		-1,
		-1,
		216,
		219,
		-1,
		-1,
		224,
		226,
		-1,
		225,
		214,
		199,
		191,
		-1,
		-1,
		180,
		176,
		-1,
		-1,
		144,
		169,
		158,
		166,
		161,
		141,
		147,
		150,
		139,
		143,
		155,
		-1,
		-1,
		223,
		224,
		229,
		-1,
		209,
		-1,
		227,
		-1,
		194,
		200,
		188,
		-1,
		-1,
		-1,
		182,
		145,
		166,
		176,
		170,
		168,
		159,
		145,
		152,
		150,
		146,
		157,
		-1,
		-1,
		-1,
		227,
		201,
		234,
		225,
		208,
		188,
		180,
		199,
		-1,
		169,
		-1,
		144,
		146,
		172,
		175,
		181,
		175,
		148,
		163,
		153,
		144,
		153,
		233,
		-1,
		203,
		236,
		200,
		194,
		170,
		174,
		190,
		-1,
		166,
		148,
		-1,
		176,
		166,
		197,
		182,
		163,
		150,
		157,
		157,
		150,
		-1,
		-1,
		-1,
		205,
		204,
		196,
		190,
		190,
		175,
		166,
		-1,
		178,
		160,
		139,
		156,
		156,
		147,
		155,
		187,
		183,
		170,
		170,
		162,
		-1,
		306,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		199,
		194,
		167,
		155,
		161,
		157,
		143,
		149,
		151,
		159,
		157,
		154,
		166,
		162,
		182,
		163,
		198,
		-1,
		301,
		-1,
		235,
		-1,
		-1,
		217,
		197,
		189,
		178,
		167,
		165,
		156,
		147,
		169,
		185,
		169,
		167,
		170,
		171,
		-1,
		290,
		289,
		-1,
		236,
		228,
		214,
		-1,
		207,
		-1,
		213,
		174,
		-1,
		176,
		156,
		-1,
		178,
		174,
		-1,
		-1,
		277,
		252,
		-1,
		-1,
		-1,
		237,
		217,
		208,
		192,
		-1,
		167,
		167,
		-1,
		-1,
		-1,
		262,
		261,
		-1,
		230,
		233,
		-1,
		223,
		214,
		222,
		169,
		173,
		-1,
		-1,
		-1,
		271,
		252,
		246,
		245,
		243,
		238,
		235,
		221,
		205,
		183,
		172,
		193,
		-1,
		-1,
		-1,
		243,
		235,
		228,
		-1,
		-1,
		230,
		213,
		194,
		192,
		-1,
		-1,
		-1,
		265,
		246,
		-1,
		-1,
		220,
		-1,
		-1,
		226,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		254,
		-1,
		-1,
		-1,
		216,
		212,
		213,
		-1,
		-1,
		-1,
		-1,
		276,
		277,
		300,
		264,
		-1,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		279,
		277,
		-1,
		-1,
		-1,
		236,
		220,
		-1,
		206,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		241,
		-1,
		241,
		216,
		223,
		-1,
		-1,
		-1,
		-1,
		254,
		246,
		254,
		-1,
		226,
		228,
		-1,
		276,
		-1,
		-1,
		269,
		260,
		-1,
		-1,
		231,
		238,
		260,
		263,
		299,
		-1,
		250
	],
	[
		-1,
		174,
		163,
		174,
		182,
		155,
		162,
		-1,
		183,
		185,
		151,
		145,
		184,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		174,
		173,
		143,
		141,
		150,
		155,
		162,
		-1,
		166,
		-1,
		195,
		174,
		185,
		190,
		136,
		133,
		153,
		172,
		159,
		151,
		210,
		166,
		137,
		131,
		149,
		144,
		153,
		145,
		-1,
		137,
		127,
		149,
		133,
		144,
		136,
		-1,
		-1,
		131,
		132,
		138,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		121,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		128,
		-1,
		110,
		128,
		137,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		123,
		-1,
		119,
		120,
		115,
		123,
		128,
		112,
		99,
		99,
		109,
		102,
		121,
		112,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		118,
		102,
		119,
		111,
		101,
		116,
		109,
		102,
		99,
		97,
		94,
		110,
		111,
		121,
		-1,
		-1,
		174,
		143,
		178,
		135,
		120,
		-1,
		114,
		95,
		101,
		105,
		99,
		92,
		106,
		102,
		-1,
		88,
		87,
		118,
		104,
		115,
		134,
		-1,
		-1,
		132,
		124,
		109,
		112,
		109,
		109,
		110,
		109,
		101,
		87,
		83,
		89,
		92,
		92,
		98,
		82,
		92,
		96,
		107,
		122,
		-1,
		-1,
		177,
		-1,
		-1,
		131,
		114,
		-1,
		97,
		104,
		104,
		121,
		111,
		132,
		120,
		111,
		103,
		97,
		85,
		87,
		84,
		97,
		85,
		79,
		104,
		108,
		102,
		123,
		118,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		90,
		93,
		99,
		123,
		133,
		-1,
		123,
		120,
		121,
		106,
		103,
		90,
		78,
		91,
		76,
		83,
		82,
		86,
		88,
		121,
		99,
		121,
		118,
		147,
		152,
		146,
		155,
		-1,
		139,
		135,
		131,
		138,
		87,
		-1,
		-1,
		127,
		-1,
		141,
		140,
		115,
		117,
		120,
		107,
		98,
		85,
		74,
		85,
		74,
		71,
		79,
		88,
		99,
		94,
		93,
		111,
		126,
		139,
		143,
		149,
		-1,
		189,
		-1,
		131,
		115,
		117,
		89,
		110,
		-1,
		147,
		142,
		132,
		117,
		108,
		-1,
		111,
		113,
		103,
		81,
		66,
		83,
		75,
		73,
		78,
		83,
		97,
		88,
		106,
		113,
		121,
		125,
		145,
		157,
		149,
		139,
		-1,
		121,
		126,
		85,
		93,
		112,
		150,
		114,
		-1,
		109,
		-1,
		101,
		126,
		-1,
		87,
		83,
		65,
		66,
		61,
		76,
		82,
		79,
		76,
		94,
		97,
		114,
		118,
		134,
		-1,
		-1,
		134,
		138,
		127,
		78,
		97,
		121,
		158,
		107,
		96,
		95,
		-1,
		86,
		95,
		92,
		78,
		65,
		58,
		59,
		66,
		80,
		59,
		78,
		81,
		103,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		104,
		75,
		99,
		141,
		125,
		118,
		106,
		71,
		71,
		65,
		-1,
		85,
		68,
		67,
		56,
		54,
		67,
		62,
		78,
		82,
		81,
		100,
		112,
		103,
		123,
		-1,
		-1,
		-1,
		134,
		123,
		124,
		70,
		93,
		130,
		104,
		90,
		95,
		70,
		63,
		57,
		88,
		85,
		52,
		63,
		53,
		44,
		58,
		66,
		70,
		79,
		88,
		94,
		118,
		118,
		124,
		-1,
		-1,
		141,
		131,
		115,
		117,
		114,
		84,
		91,
		123,
		95,
		108,
		-1,
		62,
		-1,
		51,
		36,
		40,
		46,
		57,
		44,
		49,
		60,
		72,
		85,
		81,
		88,
		123,
		123,
		108,
		128,
		131,
		-1,
		-1,
		-1,
		134,
		129,
		104,
		81,
		65,
		101,
		-1,
		78,
		79,
		-1,
		56,
		50,
		39,
		37,
		44,
		40,
		39,
		55,
		63,
		59,
		75,
		81,
		73,
		109,
		-1,
		116,
		110,
		118,
		108,
		96,
		-1,
		-1,
		-1,
		127,
		106,
		99,
		119,
		60,
		112,
		-1,
		-1,
		63,
		56,
		-1,
		41,
		25,
		19,
		28,
		41,
		50,
		53,
		54,
		67,
		72,
		78,
		83,
		101,
		105,
		109,
		98,
		94,
		91,
		105,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		60,
		80,
		-1,
		72,
		64,
		54,
		48,
		42,
		30,
		28,
		25,
		17,
		56,
		56,
		64,
		70,
		61,
		64,
		80,
		78,
		96,
		104,
		96,
		90,
		89,
		101,
		-1,
		147,
		133,
		104,
		-1,
		-1,
		93,
		-1,
		57,
		71,
		87,
		-1,
		80,
		59,
		71,
		52,
		40,
		0,
		76,
		77,
		55,
		60,
		68,
		78,
		86,
		75,
		86,
		78,
		100,
		100,
		84,
		85,
		94,
		-1,
		153,
		140,
		98,
		94,
		83,
		103,
		54,
		42,
		74,
		-1,
		-1,
		116,
		-1,
		50,
		67,
		17,
		15,
		66,
		57,
		63,
		79,
		82,
		90,
		80,
		69,
		75,
		72,
		94,
		80,
		78,
		97,
		113,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		69,
		56,
		50,
		-1,
		91,
		-1,
		94,
		84,
		68,
		53,
		86,
		-1,
		74,
		58,
		63,
		-1,
		115,
		-1,
		88,
		90,
		84,
		69,
		66,
		77,
		75,
		86,
		103,
		-1,
		103,
		88,
		81,
		71,
		85,
		56,
		-1,
		111,
		-1,
		-1,
		81,
		75,
		75,
		59,
		62,
		90,
		70,
		64,
		63,
		110,
		109,
		96,
		82,
		75,
		72,
		69,
		82,
		102,
		93,
		105,
		-1,
		-1,
		-1,
		108,
		94,
		98,
		58,
		77,
		-1,
		-1,
		143,
		98,
		84,
		-1,
		68,
		107,
		95,
		85,
		75,
		109,
		110,
		100,
		94,
		80,
		82,
		80,
		78,
		83,
		104,
		105,
		118,
		-1,
		-1,
		91,
		96,
		84,
		70,
		89,
		-1,
		-1,
		-1,
		90,
		106,
		98,
		69,
		96,
		-1,
		-1,
		87,
		85,
		95,
		97,
		84,
		104,
		107,
		93,
		77,
		92,
		104,
		112,
		117,
		-1,
		94,
		81,
		-1,
		-1,
		92,
		86,
		-1,
		-1,
		-1,
		-1,
		123,
		89,
		101,
		122,
		138,
		90,
		-1,
		95,
		96,
		88,
		102,
		109,
		95,
		90,
		84,
		87,
		105,
		122,
		-1,
		-1,
		106,
		-1,
		101,
		-1,
		-1,
		-1,
		-1,
		80,
		94,
		115,
		120,
		124,
		-1,
		104,
		104,
		90,
		107,
		108,
		105,
		96,
		88,
		93,
		90,
		103,
		117,
		121,
		129,
		-1,
		112,
		-1,
		-1,
		-1,
		98,
		113,
		166,
		143,
		116,
		111,
		104,
		98,
		98,
		114,
		116,
		127,
		95,
		91,
		92,
		96,
		95,
		112,
		122,
		-1,
		-1,
		112,
		129,
		124,
		106,
		110,
		193,
		-1,
		-1,
		120,
		111,
		102,
		105,
		108,
		111,
		101,
		98,
		103,
		108,
		96,
		105,
		123,
		127,
		-1,
		-1,
		-1,
		132,
		-1,
		147,
		-1,
		-1,
		125,
		191,
		138,
		120,
		116,
		114,
		107,
		116,
		111,
		106,
		116,
		125,
		117,
		98,
		109,
		132,
		121,
		159,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		161,
		136,
		151,
		197,
		145,
		152,
		153,
		150,
		-1,
		120,
		145,
		117,
		124,
		116,
		124,
		124,
		121,
		99,
		106,
		122,
		121,
		116,
		151,
		143,
		149,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		167,
		153,
		183,
		173,
		162,
		-1,
		-1,
		169,
		166,
		142,
		126,
		130,
		123,
		118,
		128,
		108,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		140,
		155,
		-1,
		139,
		220,
		213,
		196,
		204,
		235,
		-1,
		170,
		179,
		160,
		165,
		172,
		-1,
		-1,
		142,
		139,
		144,
		133,
		130,
		138,
		133,
		124,
		109,
		115,
		102,
		101,
		119,
		123,
		132,
		139,
		129,
		142,
		146,
		-1,
		153,
		196,
		190,
		193,
		217,
		231,
		-1,
		183,
		-1,
		-1,
		168,
		173,
		157,
		147,
		141,
		191,
		147,
		142,
		132,
		130,
		121,
		112,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		139,
		139,
		140,
		-1,
		188,
		176,
		184,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		184,
		-1,
		184,
		-1,
		159,
		163,
		155,
		158,
		146,
		133,
		125,
		117,
		133,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		146,
		147,
		261,
		217,
		184,
		175,
		222,
		237,
		241,
		-1,
		196,
		235,
		222,
		-1,
		193,
		-1,
		-1,
		-1,
		173,
		168,
		160,
		166,
		145,
		145,
		119,
		123,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		155,
		257,
		248,
		261,
		206,
		189,
		207,
		216,
		237,
		211,
		202,
		229,
		229,
		218,
		213,
		200,
		-1,
		-1,
		196,
		178,
		-1,
		-1,
		152,
		140,
		123,
		124,
		120,
		123,
		138,
		141,
		131,
		129,
		123,
		155,
		-1,
		250,
		249,
		238,
		235,
		211,
		202,
		197,
		208,
		-1,
		-1,
		214,
		230,
		230,
		234,
		250,
		275,
		-1,
		203,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		128,
		139,
		149,
		137,
		138,
		128,
		138,
		151,
		234,
		231,
		219,
		217,
		240,
		205,
		193,
		-1,
		206,
		204,
		210,
		217,
		234,
		264,
		-1,
		-1,
		219,
		208,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		130,
		135,
		155,
		157,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		243,
		257,
		246,
		242,
		241,
		249,
		198,
		191,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		218,
		214,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		148,
		152,
		144,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		277,
		-1,
		229,
		205,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		235,
		221,
		214,
		202,
		200,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		225,
		227,
		-1,
		226,
		215,
		200,
		192,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		210,
		-1,
		228,
		-1,
		195,
		201,
		189,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		171,
		169,
		160,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		228,
		202,
		235,
		226,
		209,
		189,
		181,
		200,
		-1,
		170,
		-1,
		145,
		147,
		173,
		176,
		182,
		176,
		149,
		164,
		154,
		145,
		154,
		234,
		-1,
		204,
		237,
		201,
		195,
		171,
		175,
		191,
		-1,
		167,
		149,
		-1,
		177,
		167,
		198,
		183,
		164,
		151,
		158,
		158,
		151,
		-1,
		-1,
		-1,
		206,
		205,
		197,
		191,
		191,
		176,
		167,
		-1,
		179,
		161,
		140,
		157,
		157,
		148,
		156,
		188,
		184,
		171,
		171,
		163,
		-1,
		307,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		200,
		195,
		168,
		156,
		162,
		158,
		144,
		150,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		164,
		199,
		-1,
		302,
		-1,
		236,
		-1,
		-1,
		218,
		198,
		190,
		179,
		168,
		166,
		157,
		148,
		170,
		186,
		170,
		168,
		171,
		172,
		-1,
		291,
		290,
		-1,
		237,
		229,
		215,
		-1,
		208,
		-1,
		214,
		175,
		-1,
		177,
		157,
		-1,
		179,
		175,
		-1,
		-1,
		278,
		253,
		-1,
		-1,
		-1,
		238,
		218,
		209,
		193,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		263,
		262,
		-1,
		231,
		234,
		-1,
		224,
		215,
		223,
		170,
		174,
		-1,
		-1,
		-1,
		272,
		253,
		247,
		246,
		244,
		239,
		236,
		222,
		206,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		244,
		236,
		229,
		-1,
		-1,
		231,
		214,
		195,
		193,
		-1,
		-1,
		-1,
		266,
		247,
		-1,
		-1,
		221,
		-1,
		-1,
		227,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		255,
		-1,
		-1,
		-1,
		217,
		213,
		214,
		-1,
		-1,
		-1,
		-1,
		277,
		278,
		301,
		265,
		-1,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		280,
		278,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		207,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		242,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		255,
		247,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		270,
		261,
		-1,
		-1,
		232,
		239,
		261,
		264,
		300,
		-1,
		251
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		202,
		204,
		170,
		164,
		203,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		193,
		192,
		162,
		160,
		169,
		174,
		181,
		-1,
		185,
		-1,
		214,
		193,
		204,
		209,
		155,
		152,
		172,
		191,
		178,
		170,
		229,
		185,
		156,
		150,
		168,
		163,
		172,
		164,
		-1,
		156,
		146,
		168,
		152,
		163,
		155,
		-1,
		-1,
		150,
		151,
		157,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		140,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		129,
		147,
		156,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		142,
		-1,
		138,
		139,
		134,
		142,
		147,
		131,
		118,
		118,
		128,
		121,
		140,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		138,
		121,
		138,
		130,
		120,
		135,
		128,
		121,
		118,
		116,
		113,
		129,
		130,
		140,
		-1,
		-1,
		217,
		186,
		221,
		178,
		163,
		-1,
		134,
		114,
		120,
		124,
		118,
		111,
		125,
		121,
		-1,
		107,
		106,
		137,
		123,
		134,
		177,
		-1,
		-1,
		175,
		167,
		152,
		155,
		144,
		140,
		129,
		128,
		120,
		106,
		102,
		108,
		111,
		111,
		117,
		101,
		111,
		115,
		125,
		141,
		-1,
		-1,
		190,
		-1,
		-1,
		174,
		157,
		-1,
		140,
		147,
		147,
		156,
		142,
		163,
		139,
		130,
		122,
		116,
		104,
		106,
		103,
		116,
		104,
		98,
		123,
		127,
		120,
		141,
		136,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		136,
		142,
		166,
		176,
		-1,
		151,
		139,
		140,
		125,
		122,
		109,
		97,
		110,
		95,
		102,
		101,
		105,
		107,
		140,
		117,
		139,
		136,
		160,
		165,
		159,
		168,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		170,
		-1,
		184,
		183,
		158,
		136,
		139,
		126,
		117,
		104,
		93,
		104,
		93,
		90,
		98,
		106,
		118,
		112,
		111,
		129,
		144,
		152,
		156,
		162,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		190,
		185,
		175,
		160,
		151,
		-1,
		135,
		132,
		122,
		100,
		85,
		102,
		94,
		92,
		97,
		101,
		115,
		106,
		124,
		131,
		134,
		138,
		158,
		170,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		137,
		150,
		-1,
		106,
		102,
		84,
		85,
		80,
		95,
		100,
		97,
		94,
		112,
		115,
		127,
		131,
		147,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		120,
		117,
		105,
		92,
		77,
		78,
		86,
		98,
		77,
		96,
		98,
		118,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		116,
		95,
		86,
		75,
		73,
		86,
		78,
		96,
		96,
		94,
		113,
		125,
		116,
		136,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		126,
		112,
		90,
		82,
		74,
		63,
		74,
		82,
		86,
		92,
		101,
		107,
		131,
		134,
		140,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		85,
		83,
		76,
		79,
		60,
		65,
		79,
		88,
		99,
		94,
		101,
		136,
		136,
		124,
		144,
		147,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		88,
		80,
		81,
		64,
		64,
		65,
		79,
		66,
		85,
		87,
		86,
		122,
		-1,
		132,
		126,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		62,
		54,
		48,
		57,
		53,
		60,
		73,
		78,
		91,
		89,
		117,
		121,
		125,
		114,
		110,
		107,
		121,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		79,
		77,
		76,
		60,
		63,
		61,
		58,
		64,
		67,
		70,
		86,
		94,
		112,
		120,
		112,
		106,
		105,
		117,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		89,
		74,
		0,
		1,
		37,
		38,
		54,
		64,
		92,
		81,
		102,
		94,
		116,
		116,
		100,
		101,
		110,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		88,
		86,
		9,
		39,
		45,
		65,
		68,
		78,
		86,
		75,
		81,
		88,
		110,
		96,
		94,
		113,
		129,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		62,
		46,
		51,
		-1,
		103,
		-1,
		94,
		96,
		94,
		85,
		82,
		93,
		91,
		102,
		119,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		78,
		58,
		52,
		51,
		102,
		97,
		88,
		98,
		91,
		88,
		85,
		98,
		118,
		109,
		121,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		95,
		83,
		73,
		63,
		97,
		98,
		88,
		93,
		96,
		98,
		96,
		94,
		99,
		120,
		121,
		134,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		84,
		-1,
		-1,
		75,
		73,
		83,
		89,
		100,
		118,
		123,
		109,
		93,
		108,
		120,
		128,
		133,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		132,
		127,
		131,
		78,
		-1,
		83,
		84,
		102,
		114,
		121,
		111,
		106,
		100,
		103,
		121,
		138,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		123,
		137,
		120,
		113,
		117,
		-1,
		92,
		92,
		104,
		115,
		124,
		121,
		112,
		104,
		109,
		106,
		119,
		133,
		137,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		141,
		156,
		159,
		136,
		109,
		104,
		97,
		91,
		96,
		116,
		122,
		133,
		111,
		107,
		108,
		112,
		111,
		128,
		138,
		-1,
		-1,
		155,
		172,
		167,
		149,
		153,
		186,
		-1,
		-1,
		113,
		104,
		95,
		98,
		106,
		109,
		114,
		114,
		119,
		124,
		112,
		121,
		139,
		143,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		168,
		184,
		131,
		113,
		109,
		107,
		100,
		109,
		104,
		109,
		132,
		129,
		134,
		114,
		127,
		149,
		139,
		175,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		202,
		179,
		189,
		195,
		188,
		188,
		146,
		143,
		-1,
		113,
		138,
		110,
		117,
		109,
		122,
		127,
		133,
		117,
		124,
		140,
		139,
		134,
		167,
		161,
		167,
		-1,
		-1,
		287,
		276,
		265,
		271,
		-1,
		195,
		191,
		181,
		171,
		174,
		-1,
		-1,
		162,
		159,
		135,
		119,
		123,
		116,
		111,
		146,
		125,
		113,
		117,
		121,
		127,
		132,
		137,
		143,
		158,
		173,
		-1,
		182,
		263,
		256,
		239,
		247,
		278,
		-1,
		185,
		177,
		188,
		163,
		165,
		-1,
		-1,
		135,
		132,
		137,
		126,
		123,
		135,
		134,
		142,
		127,
		133,
		120,
		119,
		137,
		141,
		150,
		157,
		147,
		160,
		164,
		-1,
		196,
		239,
		233,
		236,
		260,
		274,
		-1,
		182,
		-1,
		-1,
		194,
		166,
		150,
		140,
		134,
		184,
		140,
		135,
		137,
		139,
		139,
		130,
		137,
		128,
		128,
		131,
		146,
		151,
		143,
		157,
		157,
		158,
		-1,
		229,
		219,
		227,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		210,
		-1,
		177,
		-1,
		152,
		156,
		148,
		151,
		162,
		149,
		143,
		135,
		151,
		126,
		136,
		132,
		133,
		142,
		153,
		165,
		164,
		165,
		254,
		210,
		213,
		218,
		235,
		250,
		254,
		-1,
		194,
		233,
		248,
		-1,
		219,
		-1,
		-1,
		-1,
		166,
		161,
		153,
		169,
		161,
		161,
		137,
		141,
		131,
		138,
		148,
		150,
		142,
		146,
		159,
		170,
		173,
		250,
		241,
		254,
		199,
		199,
		220,
		229,
		250,
		209,
		200,
		227,
		253,
		244,
		239,
		226,
		-1,
		-1,
		189,
		171,
		-1,
		-1,
		168,
		158,
		141,
		142,
		138,
		141,
		156,
		159,
		149,
		147,
		141,
		173,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		217,
		-1,
		-1,
		212,
		228,
		223,
		227,
		243,
		268,
		-1,
		229,
		-1,
		-1,
		210,
		-1,
		-1,
		200,
		163,
		152,
		143,
		149,
		146,
		157,
		167,
		155,
		156,
		146,
		156,
		169,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		199,
		197,
		203,
		210,
		227,
		257,
		-1,
		-1,
		245,
		225,
		-1,
		-1,
		198,
		196,
		185,
		-1,
		175,
		148,
		153,
		173,
		175,
		164,
		158,
		152,
		159,
		158,
		166,
		174,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		231,
		-1,
		-1,
		193,
		186,
		174,
		162,
		152,
		162,
		166,
		170,
		162,
		155,
		150,
		161,
		153,
		157,
		174,
		-1,
		270,
		-1,
		222,
		198,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		227,
		211,
		192,
		-1,
		162,
		175,
		206,
		174,
		179,
		174,
		156,
		167,
		156,
		159,
		173,
		168,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		235,
		244,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		199,
		195,
		-1,
		-1,
		163,
		188,
		177,
		185,
		180,
		160,
		166,
		169,
		158,
		162,
		174,
		-1,
		-1,
		217,
		218,
		223,
		-1,
		227,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		201,
		164,
		185,
		195,
		189,
		187,
		178,
		164,
		171,
		169,
		165,
		176,
		-1,
		-1,
		-1,
		245,
		219,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		187,
		-1,
		162,
		165,
		190,
		194,
		200,
		194,
		167,
		182,
		172,
		163,
		172,
		251,
		-1,
		221,
		254,
		218,
		212,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		216,
		201,
		182,
		169,
		176,
		176,
		169,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		206,
		202,
		189,
		189,
		181,
		-1,
		324,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		182,
		217,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		189,
		190,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		203,
		205,
		171,
		165,
		204,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		194,
		193,
		163,
		161,
		170,
		175,
		182,
		-1,
		186,
		-1,
		215,
		194,
		205,
		210,
		156,
		153,
		173,
		192,
		179,
		171,
		230,
		186,
		157,
		151,
		169,
		164,
		173,
		165,
		-1,
		157,
		147,
		169,
		153,
		164,
		156,
		-1,
		-1,
		151,
		152,
		158,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		141,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		130,
		148,
		157,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		143,
		-1,
		139,
		140,
		135,
		143,
		148,
		132,
		119,
		119,
		129,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		139,
		122,
		139,
		131,
		121,
		136,
		129,
		122,
		119,
		117,
		114,
		130,
		131,
		141,
		-1,
		-1,
		218,
		187,
		222,
		179,
		164,
		-1,
		135,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		108,
		107,
		138,
		124,
		135,
		178,
		-1,
		-1,
		176,
		168,
		153,
		156,
		145,
		141,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		102,
		112,
		116,
		126,
		142,
		-1,
		-1,
		191,
		-1,
		-1,
		175,
		158,
		-1,
		141,
		148,
		148,
		157,
		143,
		164,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		99,
		124,
		128,
		121,
		142,
		137,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		134,
		137,
		143,
		167,
		177,
		-1,
		152,
		140,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		106,
		108,
		141,
		118,
		140,
		137,
		161,
		166,
		160,
		169,
		-1,
		183,
		179,
		175,
		182,
		131,
		-1,
		-1,
		171,
		-1,
		185,
		184,
		159,
		137,
		140,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		107,
		119,
		113,
		112,
		130,
		145,
		153,
		157,
		163,
		-1,
		233,
		-1,
		175,
		159,
		161,
		133,
		154,
		-1,
		191,
		186,
		176,
		161,
		152,
		-1,
		136,
		133,
		123,
		101,
		86,
		103,
		95,
		93,
		98,
		102,
		116,
		107,
		125,
		132,
		135,
		139,
		159,
		171,
		193,
		183,
		-1,
		165,
		170,
		129,
		137,
		156,
		194,
		158,
		-1,
		153,
		-1,
		138,
		151,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		101,
		98,
		95,
		113,
		116,
		128,
		132,
		148,
		-1,
		-1,
		178,
		182,
		171,
		122,
		141,
		165,
		202,
		151,
		140,
		139,
		-1,
		130,
		121,
		118,
		106,
		93,
		78,
		79,
		87,
		99,
		78,
		97,
		99,
		119,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		148,
		119,
		143,
		185,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		117,
		96,
		87,
		76,
		74,
		87,
		79,
		97,
		97,
		95,
		114,
		126,
		117,
		137,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		114,
		137,
		174,
		148,
		134,
		139,
		114,
		107,
		101,
		127,
		113,
		91,
		83,
		75,
		64,
		75,
		83,
		87,
		93,
		102,
		108,
		132,
		135,
		141,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		128,
		135,
		167,
		139,
		152,
		-1,
		106,
		-1,
		95,
		86,
		84,
		77,
		80,
		61,
		66,
		80,
		89,
		100,
		95,
		102,
		137,
		137,
		125,
		145,
		148,
		-1,
		-1,
		-1,
		178,
		173,
		148,
		125,
		109,
		145,
		-1,
		122,
		123,
		-1,
		100,
		94,
		89,
		81,
		82,
		65,
		65,
		66,
		80,
		67,
		86,
		88,
		87,
		123,
		-1,
		133,
		127,
		135,
		125,
		113,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		104,
		156,
		-1,
		-1,
		107,
		100,
		-1,
		87,
		69,
		63,
		55,
		49,
		58,
		54,
		61,
		74,
		79,
		92,
		90,
		118,
		122,
		126,
		115,
		111,
		108,
		122,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		124,
		-1,
		116,
		108,
		98,
		92,
		86,
		80,
		78,
		77,
		61,
		64,
		62,
		59,
		65,
		68,
		71,
		87,
		95,
		113,
		121,
		113,
		107,
		106,
		118,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		137,
		-1,
		101,
		115,
		131,
		-1,
		124,
		103,
		118,
		96,
		90,
		75,
		1,
		0,
		38,
		39,
		55,
		65,
		93,
		82,
		103,
		95,
		117,
		117,
		101,
		102,
		111,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		98,
		86,
		118,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		89,
		87,
		10,
		40,
		46,
		66,
		69,
		79,
		87,
		76,
		82,
		89,
		111,
		97,
		95,
		114,
		130,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		63,
		47,
		52,
		-1,
		104,
		-1,
		95,
		97,
		95,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		155,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		79,
		59,
		53,
		52,
		103,
		98,
		89,
		99,
		92,
		89,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		152,
		138,
		142,
		102,
		121,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		96,
		84,
		74,
		64,
		98,
		99,
		89,
		94,
		97,
		99,
		97,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		135,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		85,
		-1,
		-1,
		76,
		74,
		84,
		90,
		101,
		119,
		124,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		138,
		125,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		133,
		128,
		132,
		79,
		-1,
		84,
		85,
		103,
		115,
		122,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		121,
		114,
		118,
		-1,
		93,
		93,
		105,
		116,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		142,
		157,
		160,
		137,
		110,
		105,
		98,
		92,
		97,
		117,
		123,
		134,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		156,
		173,
		168,
		150,
		154,
		187,
		-1,
		-1,
		114,
		105,
		96,
		99,
		107,
		110,
		115,
		115,
		120,
		125,
		113,
		122,
		140,
		144,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		169,
		185,
		132,
		114,
		110,
		108,
		101,
		110,
		105,
		110,
		133,
		130,
		135,
		115,
		128,
		150,
		140,
		176,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		203,
		180,
		190,
		196,
		189,
		189,
		147,
		144,
		-1,
		114,
		139,
		111,
		118,
		110,
		123,
		128,
		134,
		118,
		125,
		141,
		140,
		135,
		168,
		162,
		168,
		-1,
		-1,
		288,
		277,
		266,
		272,
		-1,
		196,
		192,
		182,
		172,
		175,
		-1,
		-1,
		163,
		160,
		136,
		120,
		124,
		117,
		112,
		147,
		126,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		183,
		264,
		257,
		240,
		248,
		279,
		-1,
		186,
		178,
		189,
		164,
		166,
		-1,
		-1,
		136,
		133,
		138,
		127,
		124,
		136,
		135,
		143,
		128,
		134,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		197,
		240,
		234,
		237,
		261,
		275,
		-1,
		183,
		-1,
		-1,
		195,
		167,
		151,
		141,
		135,
		185,
		141,
		136,
		138,
		140,
		140,
		131,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		230,
		220,
		228,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		211,
		-1,
		178,
		-1,
		153,
		157,
		149,
		152,
		163,
		150,
		144,
		136,
		152,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		255,
		211,
		214,
		219,
		236,
		251,
		255,
		-1,
		195,
		234,
		249,
		-1,
		220,
		-1,
		-1,
		-1,
		167,
		162,
		154,
		170,
		162,
		162,
		138,
		142,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		251,
		242,
		255,
		200,
		200,
		221,
		230,
		251,
		210,
		201,
		228,
		254,
		245,
		240,
		227,
		-1,
		-1,
		190,
		172,
		-1,
		-1,
		169,
		159,
		142,
		143,
		139,
		142,
		157,
		160,
		150,
		148,
		142,
		174,
		-1,
		244,
		243,
		232,
		229,
		205,
		196,
		191,
		218,
		-1,
		-1,
		213,
		229,
		224,
		228,
		244,
		269,
		-1,
		230,
		-1,
		-1,
		211,
		-1,
		-1,
		201,
		164,
		153,
		144,
		150,
		147,
		158,
		168,
		156,
		157,
		147,
		157,
		170,
		228,
		225,
		213,
		211,
		234,
		199,
		187,
		-1,
		200,
		198,
		204,
		211,
		228,
		258,
		-1,
		-1,
		246,
		226,
		-1,
		-1,
		199,
		197,
		186,
		-1,
		176,
		149,
		154,
		174,
		176,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		237,
		251,
		240,
		236,
		235,
		243,
		192,
		185,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		236,
		232,
		-1,
		-1,
		194,
		187,
		175,
		163,
		153,
		163,
		167,
		171,
		163,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		271,
		-1,
		223,
		199,
		213,
		228,
		236,
		-1,
		-1,
		-1,
		253,
		239,
		232,
		220,
		218,
		-1,
		228,
		212,
		193,
		-1,
		163,
		176,
		207,
		175,
		180,
		175,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		211,
		214,
		-1,
		-1,
		236,
		245,
		-1,
		244,
		233,
		218,
		210,
		-1,
		-1,
		200,
		196,
		-1,
		-1,
		164,
		189,
		178,
		186,
		181,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		218,
		219,
		224,
		-1,
		228,
		-1,
		246,
		-1,
		213,
		219,
		207,
		-1,
		-1,
		-1,
		202,
		165,
		186,
		196,
		190,
		188,
		179,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		246,
		220,
		253,
		244,
		227,
		207,
		199,
		218,
		-1,
		188,
		-1,
		163,
		166,
		191,
		195,
		201,
		195,
		168,
		183,
		173,
		164,
		173,
		252,
		-1,
		222,
		255,
		219,
		213,
		189,
		193,
		209,
		-1,
		185,
		167,
		-1,
		195,
		185,
		217,
		202,
		183,
		170,
		177,
		177,
		170,
		-1,
		-1,
		-1,
		224,
		223,
		215,
		209,
		209,
		194,
		185,
		-1,
		197,
		179,
		158,
		175,
		175,
		166,
		174,
		207,
		203,
		190,
		190,
		182,
		-1,
		325,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		218,
		213,
		186,
		174,
		180,
		176,
		162,
		168,
		170,
		178,
		176,
		173,
		185,
		181,
		201,
		183,
		218,
		-1,
		320,
		-1,
		254,
		-1,
		-1,
		236,
		216,
		208,
		197,
		186,
		184,
		175,
		166,
		188,
		204,
		188,
		186,
		190,
		191,
		-1,
		309,
		308,
		-1,
		255,
		247,
		233,
		-1,
		226,
		-1,
		232,
		193,
		-1,
		195,
		175,
		-1,
		197,
		193,
		-1,
		-1,
		296,
		271,
		-1,
		-1,
		-1,
		256,
		236,
		227,
		211,
		-1,
		186,
		186,
		-1,
		-1,
		-1,
		281,
		280,
		-1,
		249,
		252,
		-1,
		242,
		233,
		241,
		188,
		192,
		-1,
		-1,
		-1,
		290,
		271,
		265,
		264,
		262,
		257,
		254,
		240,
		224,
		202,
		191,
		212,
		-1,
		-1,
		-1,
		262,
		254,
		247,
		-1,
		-1,
		249,
		232,
		213,
		211,
		-1,
		-1,
		-1,
		284,
		265,
		-1,
		-1,
		239,
		-1,
		-1,
		245,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		273,
		-1,
		-1,
		-1,
		235,
		231,
		232,
		-1,
		-1,
		-1,
		-1,
		295,
		296,
		319,
		283,
		-1,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		298,
		296,
		-1,
		-1,
		-1,
		255,
		239,
		-1,
		225,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		260,
		-1,
		260,
		235,
		242,
		-1,
		-1,
		-1,
		-1,
		273,
		265,
		273,
		-1,
		245,
		247,
		-1,
		295,
		-1,
		-1,
		288,
		279,
		-1,
		-1,
		250,
		257,
		279,
		282,
		318,
		-1,
		269
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		164,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		157,
		149,
		208,
		164,
		135,
		129,
		147,
		142,
		151,
		143,
		-1,
		135,
		125,
		147,
		131,
		142,
		134,
		-1,
		-1,
		129,
		130,
		136,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		119,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		108,
		126,
		135,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		121,
		-1,
		117,
		118,
		113,
		121,
		126,
		110,
		97,
		97,
		107,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		117,
		100,
		117,
		109,
		99,
		114,
		107,
		100,
		97,
		95,
		92,
		108,
		109,
		119,
		-1,
		-1,
		196,
		165,
		200,
		157,
		142,
		-1,
		113,
		93,
		99,
		103,
		97,
		90,
		104,
		100,
		-1,
		86,
		85,
		116,
		102,
		113,
		156,
		-1,
		-1,
		154,
		146,
		131,
		134,
		123,
		119,
		108,
		107,
		99,
		85,
		81,
		87,
		90,
		90,
		96,
		80,
		90,
		94,
		104,
		120,
		-1,
		-1,
		166,
		-1,
		-1,
		153,
		136,
		-1,
		119,
		126,
		126,
		135,
		121,
		142,
		118,
		109,
		101,
		95,
		83,
		85,
		82,
		95,
		83,
		77,
		102,
		106,
		99,
		120,
		115,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		115,
		121,
		145,
		155,
		-1,
		130,
		118,
		119,
		104,
		101,
		88,
		76,
		89,
		74,
		81,
		80,
		84,
		86,
		119,
		96,
		118,
		115,
		136,
		141,
		135,
		144,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		149,
		-1,
		163,
		162,
		137,
		115,
		118,
		105,
		96,
		83,
		72,
		83,
		72,
		69,
		77,
		85,
		97,
		91,
		90,
		108,
		120,
		128,
		132,
		138,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		169,
		164,
		154,
		139,
		130,
		-1,
		114,
		111,
		101,
		79,
		64,
		81,
		73,
		71,
		76,
		80,
		94,
		85,
		103,
		110,
		110,
		114,
		134,
		146,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		131,
		-1,
		116,
		129,
		-1,
		85,
		81,
		63,
		64,
		59,
		74,
		79,
		76,
		73,
		91,
		94,
		103,
		107,
		123,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		108,
		99,
		96,
		84,
		71,
		56,
		57,
		65,
		77,
		56,
		75,
		74,
		94,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		95,
		74,
		65,
		54,
		52,
		65,
		57,
		75,
		72,
		70,
		89,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		105,
		91,
		69,
		61,
		53,
		42,
		53,
		61,
		65,
		68,
		77,
		83,
		107,
		113,
		119,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		64,
		62,
		55,
		58,
		39,
		44,
		58,
		67,
		75,
		70,
		77,
		112,
		112,
		103,
		123,
		126,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		67,
		59,
		60,
		43,
		43,
		44,
		58,
		42,
		61,
		63,
		62,
		98,
		-1,
		111,
		105,
		113,
		103,
		91,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		65,
		47,
		41,
		33,
		27,
		36,
		29,
		36,
		49,
		54,
		67,
		65,
		95,
		99,
		104,
		93,
		89,
		86,
		100,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		58,
		56,
		55,
		39,
		42,
		37,
		34,
		40,
		43,
		46,
		62,
		72,
		90,
		99,
		91,
		85,
		84,
		96,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		68,
		53,
		40,
		41,
		0,
		16,
		30,
		40,
		68,
		57,
		80,
		73,
		95,
		95,
		79,
		80,
		89,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		67,
		65,
		30,
		13,
		19,
		41,
		44,
		54,
		62,
		51,
		57,
		67,
		89,
		75,
		73,
		92,
		108,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		36,
		20,
		25,
		-1,
		79,
		-1,
		70,
		72,
		70,
		62,
		61,
		72,
		70,
		81,
		98,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		52,
		32,
		26,
		25,
		78,
		71,
		64,
		75,
		68,
		65,
		64,
		77,
		97,
		88,
		100,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		69,
		57,
		47,
		37,
		71,
		72,
		62,
		67,
		73,
		75,
		73,
		73,
		78,
		99,
		100,
		113,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		58,
		-1,
		-1,
		49,
		47,
		57,
		63,
		77,
		92,
		99,
		88,
		72,
		87,
		99,
		107,
		112,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		106,
		101,
		105,
		52,
		-1,
		57,
		58,
		76,
		88,
		95,
		90,
		85,
		79,
		82,
		100,
		117,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		102,
		116,
		94,
		87,
		91,
		-1,
		66,
		66,
		78,
		89,
		101,
		100,
		91,
		83,
		88,
		85,
		98,
		112,
		116,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		120,
		135,
		133,
		110,
		83,
		78,
		71,
		65,
		70,
		90,
		96,
		107,
		90,
		86,
		87,
		91,
		90,
		107,
		117,
		-1,
		-1,
		134,
		151,
		146,
		128,
		132,
		160,
		-1,
		-1,
		87,
		78,
		69,
		72,
		80,
		83,
		88,
		90,
		98,
		103,
		91,
		100,
		118,
		122,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		147,
		158,
		105,
		87,
		83,
		81,
		74,
		83,
		78,
		83,
		108,
		103,
		112,
		93,
		106,
		128,
		118,
		154,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		176,
		158,
		163,
		169,
		167,
		162,
		120,
		117,
		-1,
		87,
		112,
		84,
		91,
		83,
		96,
		101,
		107,
		96,
		103,
		119,
		118,
		113,
		146,
		140,
		146,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		136,
		133,
		109,
		93,
		97,
		90,
		85,
		123,
		99,
		92,
		96,
		100,
		106,
		111,
		116,
		122,
		137,
		152,
		-1,
		161,
		242,
		235,
		218,
		226,
		257,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		109,
		106,
		111,
		100,
		97,
		109,
		108,
		119,
		106,
		112,
		99,
		98,
		116,
		120,
		129,
		136,
		126,
		139,
		143,
		-1,
		175,
		218,
		212,
		215,
		239,
		253,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		108,
		158,
		114,
		109,
		111,
		113,
		117,
		108,
		116,
		107,
		107,
		110,
		125,
		130,
		122,
		136,
		136,
		137,
		-1,
		203,
		198,
		206,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		126,
		130,
		122,
		125,
		136,
		123,
		121,
		114,
		130,
		105,
		115,
		111,
		112,
		121,
		132,
		144,
		143,
		144,
		228,
		184,
		187,
		197,
		209,
		224,
		228,
		-1,
		168,
		207,
		222,
		-1,
		193,
		-1,
		-1,
		-1,
		140,
		135,
		127,
		143,
		135,
		135,
		115,
		119,
		110,
		117,
		127,
		129,
		121,
		125,
		138,
		149,
		152,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		183,
		174,
		201,
		227,
		218,
		213,
		200,
		-1,
		-1,
		163,
		145,
		-1,
		-1,
		142,
		136,
		119,
		121,
		117,
		120,
		135,
		138,
		128,
		126,
		120,
		152,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		202,
		197,
		201,
		217,
		242,
		-1,
		203,
		-1,
		-1,
		184,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		125,
		136,
		146,
		134,
		135,
		125,
		135,
		148,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		231,
		-1,
		-1,
		219,
		199,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		152,
		154,
		143,
		137,
		131,
		138,
		137,
		145,
		153,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		205,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		145,
		148,
		141,
		134,
		129,
		140,
		132,
		136,
		153,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		135,
		146,
		135,
		138,
		152,
		147,
		-1,
		-1,
		184,
		187,
		-1,
		-1,
		209,
		218,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		139,
		145,
		148,
		137,
		141,
		153,
		-1,
		-1,
		191,
		192,
		197,
		-1,
		201,
		-1,
		219,
		-1,
		186,
		192,
		180,
		-1,
		-1,
		-1,
		179,
		142,
		159,
		173,
		168,
		166,
		157,
		143,
		150,
		148,
		144,
		155,
		-1,
		-1,
		-1,
		219,
		193,
		226,
		217,
		200,
		180,
		172,
		191,
		-1,
		161,
		-1,
		136,
		139,
		164,
		172,
		179,
		173,
		146,
		161,
		151,
		142,
		151,
		225,
		-1,
		195,
		228,
		192,
		186,
		162,
		166,
		182,
		-1,
		158,
		140,
		-1,
		168,
		158,
		195,
		180,
		161,
		148,
		155,
		155,
		148,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		182,
		167,
		158,
		-1,
		170,
		152,
		131,
		148,
		148,
		139,
		147,
		185,
		181,
		168,
		168,
		160,
		-1,
		298,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		186,
		159,
		147,
		153,
		149,
		135,
		141,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		161,
		196,
		-1,
		293,
		-1,
		227,
		-1,
		-1,
		209,
		189,
		181,
		170,
		159,
		157,
		148,
		139,
		161,
		177,
		161,
		159,
		164,
		169,
		-1,
		282,
		281,
		-1,
		228,
		220,
		206,
		-1,
		199,
		-1,
		205,
		166,
		-1,
		168,
		148,
		-1,
		170,
		166,
		-1,
		-1,
		269,
		244,
		-1,
		-1,
		-1,
		229,
		209,
		200,
		184,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		254,
		253,
		-1,
		222,
		225,
		-1,
		215,
		206,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		263,
		244,
		238,
		237,
		235,
		230,
		227,
		213,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		235,
		227,
		220,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		246,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		292,
		256,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		167,
		156,
		167,
		175,
		148,
		155,
		-1,
		176,
		178,
		144,
		138,
		177,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		167,
		166,
		136,
		134,
		143,
		148,
		155,
		-1,
		159,
		-1,
		188,
		167,
		178,
		183,
		129,
		126,
		146,
		165,
		152,
		144,
		203,
		159,
		130,
		124,
		142,
		137,
		146,
		138,
		-1,
		130,
		120,
		142,
		126,
		137,
		129,
		-1,
		-1,
		124,
		125,
		131,
		122,
		128,
		124,
		-1,
		134,
		118,
		-1,
		-1,
		114,
		120,
		104,
		107,
		115,
		113,
		126,
		118,
		113,
		-1,
		-1,
		110,
		106,
		113,
		100,
		96,
		113,
		126,
		108,
		122,
		121,
		-1,
		103,
		121,
		130,
		107,
		105,
		89,
		87,
		105,
		107,
		113,
		116,
		-1,
		112,
		113,
		108,
		116,
		121,
		105,
		92,
		92,
		102,
		95,
		114,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		112,
		95,
		112,
		104,
		94,
		109,
		102,
		95,
		92,
		90,
		87,
		103,
		104,
		114,
		-1,
		-1,
		198,
		167,
		202,
		159,
		142,
		-1,
		108,
		88,
		94,
		98,
		92,
		85,
		99,
		95,
		-1,
		81,
		80,
		111,
		97,
		108,
		158,
		-1,
		-1,
		156,
		148,
		133,
		136,
		118,
		114,
		103,
		102,
		94,
		80,
		76,
		82,
		85,
		85,
		91,
		75,
		85,
		89,
		92,
		115,
		-1,
		-1,
		152,
		-1,
		-1,
		155,
		138,
		-1,
		121,
		128,
		124,
		130,
		116,
		137,
		113,
		104,
		96,
		90,
		78,
		80,
		77,
		90,
		78,
		72,
		97,
		101,
		87,
		108,
		103,
		-1,
		151,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		114,
		117,
		123,
		147,
		153,
		-1,
		125,
		113,
		114,
		99,
		96,
		83,
		71,
		84,
		69,
		76,
		75,
		79,
		79,
		109,
		84,
		106,
		103,
		122,
		127,
		121,
		130,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		151,
		-1,
		161,
		162,
		137,
		110,
		113,
		100,
		91,
		78,
		67,
		78,
		67,
		64,
		72,
		73,
		88,
		79,
		78,
		96,
		106,
		114,
		118,
		124,
		-1,
		213,
		-1,
		155,
		139,
		141,
		113,
		134,
		-1,
		171,
		162,
		154,
		139,
		132,
		-1,
		109,
		106,
		96,
		74,
		59,
		76,
		68,
		66,
		71,
		68,
		82,
		73,
		91,
		98,
		96,
		100,
		120,
		132,
		173,
		163,
		-1,
		145,
		150,
		109,
		117,
		136,
		174,
		138,
		-1,
		133,
		-1,
		111,
		124,
		-1,
		80,
		76,
		58,
		59,
		54,
		69,
		67,
		64,
		61,
		79,
		82,
		89,
		93,
		109,
		-1,
		-1,
		158,
		162,
		151,
		102,
		121,
		145,
		182,
		131,
		120,
		119,
		-1,
		110,
		94,
		91,
		79,
		66,
		51,
		52,
		60,
		65,
		44,
		63,
		60,
		80,
		106,
		84,
		96,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		128,
		99,
		123,
		165,
		149,
		142,
		130,
		95,
		95,
		89,
		-1,
		90,
		69,
		60,
		49,
		47,
		53,
		45,
		63,
		58,
		56,
		75,
		87,
		78,
		98,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		94,
		117,
		154,
		128,
		114,
		119,
		94,
		87,
		81,
		103,
		86,
		67,
		56,
		48,
		37,
		41,
		49,
		53,
		54,
		63,
		69,
		93,
		100,
		106,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		108,
		115,
		147,
		119,
		132,
		-1,
		86,
		-1,
		75,
		66,
		61,
		56,
		53,
		41,
		32,
		45,
		55,
		61,
		56,
		63,
		98,
		98,
		90,
		110,
		113,
		-1,
		-1,
		-1,
		158,
		153,
		128,
		105,
		89,
		125,
		-1,
		102,
		103,
		-1,
		80,
		74,
		69,
		61,
		59,
		45,
		45,
		41,
		44,
		28,
		47,
		49,
		48,
		84,
		-1,
		98,
		92,
		100,
		90,
		78,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		84,
		136,
		-1,
		-1,
		87,
		80,
		-1,
		67,
		49,
		43,
		35,
		29,
		27,
		15,
		22,
		35,
		40,
		53,
		51,
		81,
		85,
		91,
		80,
		76,
		73,
		87,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		104,
		-1,
		96,
		88,
		78,
		72,
		66,
		60,
		58,
		57,
		41,
		43,
		23,
		20,
		26,
		29,
		32,
		48,
		58,
		76,
		86,
		78,
		72,
		71,
		83,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		117,
		-1,
		81,
		95,
		111,
		-1,
		104,
		83,
		98,
		76,
		70,
		55,
		38,
		39,
		13,
		0,
		16,
		26,
		54,
		43,
		66,
		60,
		82,
		82,
		66,
		67,
		76,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		78,
		66,
		98,
		-1,
		-1,
		140,
		-1,
		74,
		91,
		69,
		67,
		28,
		15,
		21,
		27,
		30,
		40,
		48,
		37,
		43,
		54,
		76,
		62,
		60,
		79,
		95,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		115,
		-1,
		118,
		108,
		92,
		77,
		110,
		-1,
		38,
		22,
		27,
		-1,
		65,
		-1,
		56,
		58,
		56,
		48,
		48,
		59,
		57,
		68,
		85,
		-1,
		127,
		112,
		105,
		95,
		109,
		80,
		-1,
		135,
		-1,
		-1,
		105,
		99,
		99,
		83,
		86,
		54,
		34,
		28,
		27,
		64,
		72,
		50,
		61,
		54,
		51,
		51,
		64,
		84,
		75,
		87,
		-1,
		-1,
		-1,
		132,
		118,
		122,
		82,
		101,
		-1,
		-1,
		167,
		122,
		108,
		-1,
		92,
		71,
		59,
		49,
		39,
		73,
		74,
		63,
		68,
		59,
		61,
		59,
		60,
		65,
		86,
		87,
		100,
		-1,
		-1,
		115,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		114,
		130,
		122,
		93,
		60,
		-1,
		-1,
		51,
		49,
		59,
		65,
		63,
		83,
		86,
		75,
		59,
		74,
		86,
		94,
		99,
		-1,
		118,
		105,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		147,
		113,
		108,
		103,
		107,
		54,
		-1,
		59,
		60,
		67,
		81,
		88,
		77,
		72,
		66,
		69,
		87,
		104,
		-1,
		-1,
		130,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		104,
		118,
		96,
		89,
		93,
		-1,
		68,
		68,
		69,
		86,
		90,
		87,
		78,
		70,
		75,
		72,
		85,
		99,
		103,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		122,
		137,
		135,
		112,
		85,
		80,
		73,
		67,
		72,
		92,
		98,
		109,
		77,
		73,
		74,
		78,
		77,
		94,
		104,
		-1,
		-1,
		136,
		153,
		148,
		130,
		134,
		162,
		-1,
		-1,
		89,
		80,
		71,
		74,
		82,
		85,
		83,
		80,
		85,
		90,
		78,
		87,
		105,
		109,
		-1,
		-1,
		-1,
		156,
		-1,
		171,
		-1,
		-1,
		149,
		160,
		107,
		89,
		85,
		83,
		76,
		85,
		80,
		85,
		98,
		105,
		100,
		80,
		93,
		115,
		105,
		141,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		178,
		160,
		165,
		171,
		169,
		164,
		122,
		119,
		-1,
		89,
		114,
		86,
		93,
		85,
		98,
		103,
		104,
		83,
		90,
		106,
		105,
		100,
		133,
		127,
		133,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		138,
		135,
		111,
		95,
		99,
		92,
		87,
		112,
		92,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		163,
		244,
		237,
		220,
		228,
		259,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		111,
		108,
		113,
		102,
		99,
		111,
		110,
		108,
		93,
		99,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		177,
		220,
		214,
		217,
		241,
		255,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		110,
		160,
		116,
		111,
		113,
		114,
		105,
		96,
		103,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		205,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		186,
		-1,
		153,
		-1,
		128,
		132,
		124,
		127,
		130,
		117,
		109,
		101,
		117,
		92,
		102,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		230,
		186,
		189,
		199,
		211,
		226,
		230,
		-1,
		170,
		209,
		224,
		-1,
		195,
		-1,
		-1,
		-1,
		142,
		137,
		129,
		145,
		129,
		129,
		103,
		107,
		97,
		104,
		114,
		116,
		108,
		112,
		125,
		136,
		139,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		185,
		176,
		203,
		229,
		220,
		215,
		202,
		-1,
		-1,
		165,
		147,
		-1,
		-1,
		136,
		124,
		107,
		108,
		104,
		107,
		122,
		125,
		115,
		113,
		107,
		139,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		204,
		199,
		203,
		219,
		244,
		-1,
		196,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		112,
		123,
		133,
		121,
		122,
		112,
		122,
		135,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		203,
		233,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		139,
		141,
		130,
		124,
		118,
		125,
		124,
		132,
		140,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		132,
		136,
		128,
		121,
		116,
		127,
		119,
		123,
		140,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		122,
		133,
		122,
		125,
		139,
		134,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		209,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		126,
		132,
		135,
		124,
		128,
		140,
		-1,
		-1,
		193,
		194,
		199,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		167,
		130,
		151,
		161,
		155,
		153,
		144,
		130,
		137,
		135,
		131,
		142,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		131,
		157,
		160,
		166,
		160,
		133,
		148,
		138,
		129,
		138,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		182,
		167,
		148,
		135,
		142,
		142,
		135,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		172,
		168,
		155,
		155,
		147,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		148,
		183,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		155,
		156,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		163,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		156,
		148,
		207,
		163,
		134,
		128,
		146,
		141,
		150,
		142,
		-1,
		134,
		124,
		146,
		130,
		141,
		133,
		-1,
		-1,
		128,
		129,
		135,
		126,
		132,
		128,
		-1,
		138,
		122,
		-1,
		-1,
		118,
		124,
		108,
		111,
		119,
		117,
		130,
		122,
		117,
		-1,
		-1,
		114,
		110,
		117,
		104,
		100,
		117,
		130,
		112,
		126,
		125,
		-1,
		107,
		125,
		134,
		111,
		109,
		93,
		91,
		109,
		111,
		117,
		120,
		-1,
		116,
		117,
		112,
		120,
		125,
		109,
		96,
		96,
		106,
		99,
		118,
		109,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		99,
		116,
		108,
		98,
		113,
		106,
		99,
		96,
		94,
		91,
		107,
		108,
		118,
		-1,
		-1,
		209,
		178,
		207,
		165,
		146,
		-1,
		112,
		92,
		98,
		102,
		96,
		89,
		103,
		99,
		-1,
		85,
		84,
		115,
		101,
		112,
		169,
		-1,
		-1,
		167,
		159,
		142,
		145,
		122,
		118,
		107,
		106,
		98,
		84,
		80,
		86,
		89,
		89,
		95,
		79,
		89,
		93,
		96,
		119,
		-1,
		-1,
		156,
		-1,
		-1,
		166,
		149,
		-1,
		132,
		139,
		128,
		134,
		120,
		141,
		117,
		108,
		100,
		94,
		82,
		84,
		81,
		94,
		82,
		76,
		101,
		105,
		91,
		112,
		107,
		-1,
		155,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		134,
		158,
		157,
		-1,
		129,
		117,
		118,
		103,
		100,
		87,
		75,
		88,
		73,
		80,
		79,
		83,
		83,
		113,
		88,
		110,
		107,
		126,
		131,
		125,
		134,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		162,
		-1,
		165,
		166,
		141,
		114,
		117,
		104,
		95,
		82,
		71,
		82,
		71,
		68,
		76,
		77,
		92,
		83,
		82,
		100,
		110,
		118,
		122,
		128,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		182,
		166,
		158,
		143,
		143,
		-1,
		113,
		110,
		100,
		78,
		63,
		80,
		72,
		70,
		75,
		72,
		86,
		77,
		95,
		102,
		100,
		104,
		124,
		136,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		185,
		149,
		-1,
		144,
		-1,
		115,
		128,
		-1,
		84,
		80,
		62,
		63,
		58,
		73,
		71,
		68,
		65,
		83,
		86,
		93,
		97,
		113,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		98,
		95,
		83,
		70,
		55,
		56,
		64,
		69,
		48,
		67,
		64,
		84,
		110,
		88,
		100,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		94,
		73,
		64,
		53,
		51,
		57,
		49,
		67,
		62,
		60,
		79,
		91,
		82,
		102,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		107,
		90,
		71,
		60,
		52,
		41,
		45,
		53,
		57,
		58,
		67,
		73,
		97,
		104,
		110,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		78,
		65,
		60,
		57,
		47,
		36,
		49,
		59,
		65,
		60,
		67,
		102,
		102,
		94,
		114,
		117,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		81,
		67,
		63,
		52,
		56,
		45,
		48,
		32,
		51,
		53,
		52,
		88,
		-1,
		102,
		96,
		104,
		94,
		82,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		55,
		47,
		41,
		31,
		19,
		26,
		39,
		44,
		57,
		55,
		85,
		89,
		95,
		84,
		80,
		77,
		91,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		72,
		70,
		69,
		53,
		47,
		27,
		24,
		11,
		33,
		36,
		52,
		62,
		80,
		90,
		82,
		76,
		75,
		87,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		82,
		67,
		59,
		60,
		33,
		21,
		0,
		10,
		39,
		47,
		70,
		64,
		86,
		86,
		70,
		71,
		80,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		81,
		79,
		49,
		35,
		31,
		12,
		14,
		24,
		52,
		41,
		47,
		58,
		80,
		66,
		64,
		83,
		99,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		52,
		36,
		41,
		-1,
		49,
		-1,
		41,
		54,
		54,
		52,
		52,
		63,
		61,
		72,
		89,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		68,
		48,
		42,
		41,
		48,
		56,
		34,
		61,
		58,
		55,
		55,
		68,
		88,
		79,
		91,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		85,
		73,
		63,
		53,
		80,
		68,
		47,
		52,
		61,
		65,
		63,
		64,
		69,
		90,
		91,
		104,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		74,
		-1,
		-1,
		65,
		63,
		60,
		61,
		65,
		77,
		84,
		79,
		63,
		78,
		90,
		98,
		103,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		115,
		110,
		114,
		68,
		-1,
		66,
		67,
		69,
		75,
		82,
		81,
		76,
		70,
		73,
		91,
		108,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		115,
		129,
		103,
		96,
		100,
		-1,
		75,
		75,
		71,
		87,
		94,
		91,
		82,
		74,
		79,
		76,
		89,
		103,
		107,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		133,
		148,
		142,
		119,
		92,
		87,
		80,
		74,
		79,
		95,
		102,
		113,
		81,
		77,
		78,
		82,
		81,
		98,
		108,
		-1,
		-1,
		147,
		164,
		159,
		141,
		145,
		169,
		-1,
		-1,
		96,
		87,
		78,
		81,
		89,
		92,
		87,
		84,
		89,
		94,
		82,
		91,
		109,
		113,
		-1,
		-1,
		-1,
		167,
		-1,
		182,
		-1,
		-1,
		160,
		167,
		114,
		96,
		92,
		90,
		83,
		92,
		87,
		92,
		102,
		112,
		104,
		84,
		97,
		119,
		109,
		145,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		185,
		171,
		172,
		178,
		180,
		171,
		129,
		126,
		-1,
		96,
		121,
		93,
		100,
		92,
		105,
		110,
		108,
		87,
		94,
		110,
		109,
		104,
		137,
		131,
		137,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		118,
		102,
		106,
		99,
		94,
		116,
		96,
		83,
		87,
		91,
		97,
		102,
		107,
		113,
		128,
		143,
		-1,
		174,
		255,
		248,
		228,
		236,
		267,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		109,
		106,
		118,
		117,
		112,
		97,
		103,
		90,
		89,
		107,
		111,
		120,
		127,
		117,
		130,
		134,
		-1,
		188,
		231,
		222,
		225,
		249,
		263,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		117,
		167,
		123,
		118,
		120,
		118,
		109,
		100,
		107,
		98,
		98,
		101,
		116,
		121,
		113,
		127,
		127,
		128,
		-1,
		212,
		211,
		216,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		135,
		139,
		131,
		134,
		134,
		121,
		113,
		105,
		121,
		96,
		106,
		102,
		103,
		112,
		123,
		135,
		134,
		135,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		177,
		216,
		231,
		-1,
		202,
		-1,
		-1,
		-1,
		149,
		144,
		136,
		152,
		133,
		133,
		107,
		111,
		101,
		108,
		118,
		120,
		112,
		116,
		129,
		140,
		143,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		192,
		183,
		210,
		236,
		227,
		222,
		209,
		-1,
		-1,
		172,
		154,
		-1,
		-1,
		140,
		128,
		111,
		112,
		108,
		111,
		126,
		129,
		119,
		117,
		111,
		143,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		211,
		206,
		210,
		226,
		251,
		-1,
		200,
		-1,
		-1,
		185,
		-1,
		-1,
		170,
		133,
		122,
		113,
		119,
		116,
		127,
		137,
		125,
		126,
		116,
		126,
		139,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		216,
		196,
		-1,
		-1,
		168,
		166,
		155,
		-1,
		145,
		118,
		123,
		143,
		145,
		134,
		128,
		122,
		129,
		128,
		136,
		144,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		202,
		-1,
		-1,
		163,
		156,
		144,
		132,
		122,
		132,
		136,
		140,
		132,
		125,
		120,
		131,
		123,
		127,
		144,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		197,
		181,
		162,
		-1,
		132,
		145,
		176,
		144,
		149,
		144,
		126,
		137,
		126,
		129,
		143,
		138,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		213,
		215,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		169,
		165,
		-1,
		-1,
		133,
		158,
		147,
		155,
		150,
		130,
		136,
		139,
		128,
		132,
		144,
		-1,
		-1,
		200,
		201,
		206,
		-1,
		198,
		-1,
		216,
		-1,
		183,
		189,
		177,
		-1,
		-1,
		-1,
		171,
		134,
		155,
		165,
		159,
		157,
		148,
		134,
		141,
		139,
		135,
		146,
		-1,
		-1,
		-1,
		216,
		190,
		223,
		214,
		197,
		177,
		169,
		188,
		-1,
		158,
		-1,
		133,
		135,
		161,
		164,
		170,
		164,
		137,
		152,
		142,
		133,
		142,
		222,
		-1,
		192,
		225,
		189,
		183,
		159,
		163,
		179,
		-1,
		155,
		137,
		-1,
		165,
		155,
		186,
		171,
		152,
		139,
		146,
		146,
		139,
		-1,
		-1,
		-1,
		194,
		193,
		185,
		179,
		179,
		164,
		155,
		-1,
		167,
		149,
		128,
		145,
		145,
		136,
		144,
		176,
		172,
		159,
		159,
		151,
		-1,
		295,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		188,
		183,
		156,
		144,
		150,
		146,
		132,
		138,
		140,
		148,
		146,
		143,
		155,
		151,
		171,
		152,
		187,
		-1,
		290,
		-1,
		224,
		-1,
		-1,
		206,
		186,
		178,
		167,
		156,
		154,
		145,
		136,
		158,
		174,
		158,
		156,
		159,
		160,
		-1,
		279,
		278,
		-1,
		225,
		217,
		203,
		-1,
		196,
		-1,
		202,
		163,
		-1,
		165,
		145,
		-1,
		167,
		163,
		-1,
		-1,
		266,
		241,
		-1,
		-1,
		-1,
		226,
		206,
		197,
		181,
		-1,
		156,
		156,
		-1,
		-1,
		-1,
		251,
		250,
		-1,
		219,
		222,
		-1,
		212,
		203,
		211,
		158,
		162,
		-1,
		-1,
		-1,
		260,
		241,
		235,
		234,
		232,
		227,
		224,
		210,
		194,
		172,
		161,
		182,
		-1,
		-1,
		-1,
		232,
		224,
		217,
		-1,
		-1,
		219,
		202,
		183,
		181,
		-1,
		-1,
		-1,
		254,
		235,
		-1,
		-1,
		209,
		-1,
		-1,
		215,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		243,
		-1,
		-1,
		-1,
		205,
		201,
		202,
		-1,
		-1,
		-1,
		-1,
		265,
		266,
		289,
		253,
		-1,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		268,
		266,
		-1,
		-1,
		-1,
		225,
		209,
		-1,
		195,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		230,
		-1,
		230,
		205,
		212,
		-1,
		-1,
		-1,
		-1,
		243,
		235,
		243,
		-1,
		215,
		217,
		-1,
		265,
		-1,
		-1,
		258,
		249,
		-1,
		-1,
		220,
		227,
		249,
		252,
		288,
		-1,
		239
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		191,
		193,
		159,
		153,
		192,
		163,
		169,
		180,
		-1,
		-1,
		-1,
		182,
		181,
		151,
		149,
		158,
		163,
		170,
		-1,
		174,
		-1,
		203,
		182,
		193,
		198,
		144,
		141,
		161,
		180,
		167,
		159,
		218,
		174,
		145,
		139,
		157,
		152,
		161,
		153,
		-1,
		145,
		135,
		157,
		141,
		152,
		144,
		-1,
		-1,
		139,
		140,
		146,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		129,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		118,
		136,
		145,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		131,
		-1,
		127,
		128,
		123,
		131,
		136,
		120,
		107,
		107,
		117,
		110,
		129,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		127,
		110,
		127,
		119,
		109,
		124,
		117,
		110,
		107,
		105,
		102,
		118,
		119,
		129,
		-1,
		-1,
		220,
		189,
		218,
		176,
		157,
		-1,
		123,
		103,
		109,
		113,
		107,
		100,
		114,
		110,
		-1,
		96,
		95,
		126,
		112,
		123,
		180,
		-1,
		-1,
		178,
		170,
		153,
		156,
		133,
		129,
		118,
		117,
		109,
		95,
		91,
		97,
		100,
		100,
		106,
		90,
		100,
		104,
		107,
		130,
		-1,
		-1,
		167,
		-1,
		-1,
		177,
		160,
		-1,
		143,
		150,
		139,
		145,
		131,
		152,
		128,
		119,
		111,
		105,
		93,
		95,
		92,
		105,
		93,
		87,
		112,
		116,
		102,
		123,
		118,
		-1,
		166,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		139,
		145,
		169,
		168,
		-1,
		140,
		128,
		129,
		114,
		111,
		98,
		86,
		99,
		84,
		91,
		90,
		94,
		94,
		124,
		99,
		121,
		118,
		137,
		142,
		136,
		145,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		173,
		-1,
		176,
		177,
		152,
		125,
		128,
		115,
		106,
		93,
		82,
		93,
		82,
		79,
		87,
		88,
		103,
		94,
		93,
		111,
		121,
		129,
		133,
		139,
		-1,
		235,
		-1,
		177,
		161,
		163,
		135,
		156,
		-1,
		193,
		177,
		169,
		154,
		154,
		-1,
		124,
		121,
		111,
		89,
		74,
		91,
		83,
		81,
		86,
		83,
		97,
		88,
		106,
		113,
		111,
		115,
		135,
		147,
		195,
		185,
		-1,
		167,
		172,
		131,
		139,
		158,
		196,
		160,
		-1,
		155,
		-1,
		126,
		139,
		-1,
		95,
		91,
		73,
		74,
		69,
		84,
		82,
		79,
		76,
		94,
		97,
		104,
		108,
		124,
		-1,
		-1,
		180,
		184,
		173,
		124,
		143,
		167,
		204,
		153,
		142,
		141,
		-1,
		132,
		109,
		106,
		94,
		81,
		66,
		67,
		75,
		80,
		59,
		78,
		75,
		95,
		121,
		99,
		111,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		150,
		121,
		145,
		187,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		105,
		84,
		75,
		64,
		62,
		68,
		60,
		78,
		73,
		71,
		90,
		102,
		93,
		113,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		150,
		136,
		141,
		116,
		109,
		103,
		118,
		101,
		82,
		71,
		63,
		52,
		56,
		64,
		68,
		69,
		78,
		84,
		108,
		101,
		107,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		141,
		154,
		-1,
		108,
		-1,
		97,
		89,
		76,
		71,
		68,
		58,
		47,
		60,
		70,
		75,
		71,
		77,
		113,
		113,
		91,
		111,
		114,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		102,
		96,
		92,
		78,
		74,
		63,
		67,
		56,
		59,
		43,
		62,
		64,
		63,
		94,
		-1,
		99,
		93,
		101,
		91,
		79,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		89,
		71,
		66,
		58,
		52,
		42,
		30,
		37,
		50,
		55,
		65,
		62,
		82,
		86,
		92,
		81,
		77,
		74,
		88,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		83,
		81,
		80,
		64,
		58,
		39,
		29,
		12,
		44,
		43,
		59,
		59,
		77,
		87,
		79,
		73,
		72,
		84,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		93,
		78,
		71,
		72,
		45,
		33,
		12,
		0,
		29,
		44,
		67,
		61,
		83,
		83,
		67,
		68,
		77,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		92,
		90,
		61,
		47,
		43,
		24,
		4,
		14,
		43,
		38,
		44,
		55,
		77,
		63,
		61,
		80,
		96,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		64,
		48,
		53,
		-1,
		39,
		-1,
		31,
		44,
		44,
		49,
		49,
		60,
		58,
		69,
		86,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		80,
		60,
		54,
		53,
		38,
		46,
		24,
		51,
		55,
		52,
		52,
		65,
		85,
		76,
		88,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		97,
		85,
		75,
		65,
		70,
		58,
		37,
		42,
		51,
		61,
		60,
		61,
		66,
		87,
		88,
		101,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		86,
		-1,
		-1,
		69,
		62,
		50,
		51,
		55,
		67,
		74,
		76,
		60,
		75,
		87,
		95,
		100,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		169,
		116,
		105,
		100,
		104,
		68,
		-1,
		56,
		57,
		59,
		65,
		72,
		78,
		73,
		67,
		70,
		88,
		105,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		126,
		122,
		93,
		86,
		90,
		-1,
		65,
		65,
		61,
		77,
		91,
		88,
		79,
		71,
		76,
		73,
		86,
		100,
		104,
		175,
		-1,
		158,
		-1,
		-1,
		-1,
		144,
		159,
		132,
		109,
		82,
		77,
		70,
		64,
		69,
		85,
		94,
		105,
		78,
		74,
		75,
		79,
		78,
		95,
		105,
		-1,
		-1,
		158,
		175,
		170,
		152,
		156,
		159,
		-1,
		-1,
		86,
		77,
		68,
		71,
		79,
		82,
		84,
		81,
		86,
		91,
		79,
		88,
		106,
		110,
		-1,
		-1,
		-1,
		178,
		-1,
		193,
		-1,
		-1,
		171,
		157,
		104,
		86,
		82,
		80,
		73,
		82,
		77,
		82,
		99,
		102,
		101,
		81,
		94,
		116,
		106,
		142,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		175,
		167,
		162,
		168,
		170,
		161,
		119,
		116,
		-1,
		86,
		111,
		83,
		90,
		82,
		95,
		100,
		105,
		84,
		91,
		107,
		106,
		101,
		134,
		128,
		134,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		135,
		132,
		108,
		92,
		96,
		89,
		84,
		113,
		93,
		80,
		84,
		88,
		94,
		99,
		104,
		110,
		125,
		140,
		-1,
		185,
		257,
		250,
		218,
		226,
		257,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		108,
		105,
		110,
		99,
		96,
		108,
		107,
		109,
		94,
		100,
		87,
		86,
		104,
		108,
		117,
		124,
		114,
		127,
		131,
		-1,
		199,
		233,
		212,
		215,
		239,
		253,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		107,
		157,
		113,
		108,
		110,
		112,
		106,
		97,
		104,
		95,
		95,
		98,
		113,
		118,
		110,
		124,
		124,
		125,
		-1,
		202,
		213,
		206,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		125,
		129,
		121,
		124,
		131,
		118,
		110,
		102,
		118,
		93,
		103,
		99,
		100,
		109,
		120,
		132,
		131,
		132,
		227,
		183,
		186,
		197,
		208,
		223,
		227,
		-1,
		167,
		206,
		221,
		-1,
		192,
		-1,
		-1,
		-1,
		139,
		134,
		126,
		142,
		130,
		130,
		104,
		108,
		98,
		105,
		115,
		117,
		109,
		113,
		126,
		137,
		140,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		182,
		173,
		200,
		226,
		217,
		212,
		199,
		-1,
		-1,
		162,
		144,
		-1,
		-1,
		137,
		125,
		108,
		109,
		105,
		108,
		123,
		126,
		116,
		114,
		108,
		140,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		201,
		196,
		200,
		216,
		241,
		-1,
		197,
		-1,
		-1,
		182,
		-1,
		-1,
		167,
		130,
		119,
		110,
		116,
		113,
		124,
		134,
		122,
		123,
		113,
		123,
		136,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		170,
		176,
		183,
		200,
		230,
		-1,
		-1,
		213,
		193,
		-1,
		-1,
		165,
		163,
		152,
		-1,
		142,
		115,
		120,
		140,
		142,
		131,
		125,
		119,
		126,
		125,
		133,
		141,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		203,
		199,
		-1,
		-1,
		160,
		153,
		141,
		129,
		119,
		129,
		133,
		137,
		129,
		122,
		117,
		128,
		120,
		124,
		141,
		-1,
		243,
		-1,
		195,
		171,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		220,
		206,
		199,
		187,
		185,
		-1,
		194,
		178,
		159,
		-1,
		129,
		142,
		173,
		141,
		146,
		141,
		123,
		134,
		123,
		126,
		140,
		135,
		-1,
		-1,
		183,
		186,
		-1,
		-1,
		208,
		212,
		-1,
		211,
		200,
		185,
		177,
		-1,
		-1,
		166,
		162,
		-1,
		-1,
		130,
		155,
		144,
		152,
		147,
		127,
		133,
		136,
		125,
		129,
		141,
		-1,
		-1,
		190,
		191,
		196,
		-1,
		195,
		-1,
		213,
		-1,
		180,
		186,
		174,
		-1,
		-1,
		-1,
		168,
		131,
		152,
		162,
		156,
		154,
		145,
		131,
		138,
		136,
		132,
		143,
		-1,
		-1,
		-1,
		213,
		187,
		220,
		211,
		194,
		174,
		166,
		185,
		-1,
		155,
		-1,
		130,
		132,
		158,
		161,
		167,
		161,
		134,
		149,
		139,
		130,
		139,
		219,
		-1,
		189,
		222,
		186,
		180,
		156,
		160,
		176,
		-1,
		152,
		134,
		-1,
		162,
		152,
		183,
		168,
		149,
		136,
		143,
		143,
		136,
		-1,
		-1,
		-1,
		191,
		190,
		182,
		176,
		176,
		161,
		152,
		-1,
		164,
		146,
		125,
		142,
		142,
		133,
		141,
		173,
		169,
		156,
		156,
		148,
		-1,
		292,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		185,
		180,
		153,
		141,
		147,
		143,
		129,
		135,
		137,
		145,
		143,
		140,
		152,
		148,
		168,
		149,
		184,
		-1,
		287,
		-1,
		221,
		-1,
		-1,
		203,
		183,
		175,
		164,
		153,
		151,
		142,
		133,
		155,
		171,
		155,
		153,
		156,
		157,
		-1,
		276,
		275,
		-1,
		222,
		214,
		200,
		-1,
		193,
		-1,
		199,
		160,
		-1,
		162,
		142,
		-1,
		164,
		160,
		-1,
		-1,
		263,
		238,
		-1,
		-1,
		-1,
		223,
		203,
		194,
		178,
		-1,
		153,
		153,
		-1,
		-1,
		-1,
		248,
		247,
		-1,
		216,
		219,
		-1,
		209,
		200,
		208,
		155,
		159,
		-1,
		-1,
		-1,
		257,
		238,
		232,
		231,
		229,
		224,
		221,
		207,
		191,
		169,
		158,
		179,
		-1,
		-1,
		-1,
		229,
		221,
		214,
		-1,
		-1,
		216,
		199,
		180,
		178,
		-1,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		206,
		-1,
		-1,
		212,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		240,
		-1,
		-1,
		-1,
		202,
		198,
		199,
		-1,
		-1,
		-1,
		-1,
		262,
		263,
		286,
		250,
		-1,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		265,
		263,
		-1,
		-1,
		-1,
		222,
		206,
		-1,
		192,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		227,
		-1,
		227,
		202,
		209,
		-1,
		-1,
		-1,
		-1,
		240,
		232,
		240,
		-1,
		212,
		214,
		-1,
		262,
		-1,
		-1,
		255,
		246,
		-1,
		-1,
		217,
		224,
		246,
		249,
		285,
		-1,
		236
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		193,
		196,
		162,
		156,
		195,
		165,
		171,
		182,
		-1,
		-1,
		-1,
		185,
		184,
		153,
		151,
		160,
		165,
		172,
		-1,
		171,
		-1,
		206,
		185,
		196,
		201,
		146,
		143,
		163,
		182,
		164,
		156,
		221,
		176,
		147,
		141,
		159,
		149,
		158,
		150,
		-1,
		147,
		137,
		159,
		138,
		149,
		141,
		-1,
		-1,
		141,
		142,
		148,
		134,
		140,
		136,
		-1,
		146,
		130,
		-1,
		-1,
		131,
		132,
		116,
		119,
		127,
		125,
		138,
		130,
		125,
		-1,
		-1,
		122,
		118,
		125,
		112,
		108,
		125,
		138,
		120,
		134,
		133,
		-1,
		121,
		139,
		148,
		119,
		117,
		101,
		99,
		117,
		119,
		125,
		125,
		-1,
		130,
		131,
		126,
		134,
		139,
		117,
		104,
		104,
		114,
		107,
		126,
		114,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		113,
		130,
		122,
		112,
		127,
		120,
		107,
		104,
		102,
		99,
		115,
		113,
		123,
		-1,
		-1,
		223,
		192,
		221,
		179,
		160,
		-1,
		126,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		93,
		92,
		120,
		106,
		117,
		183,
		-1,
		-1,
		181,
		173,
		156,
		159,
		136,
		132,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		87,
		97,
		101,
		99,
		124,
		-1,
		-1,
		159,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		142,
		148,
		134,
		155,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		84,
		109,
		113,
		94,
		115,
		110,
		-1,
		158,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		171,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		88,
		86,
		116,
		91,
		113,
		110,
		129,
		134,
		128,
		137,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		179,
		180,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		80,
		95,
		86,
		85,
		103,
		113,
		121,
		125,
		131,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		180,
		172,
		157,
		157,
		-1,
		127,
		124,
		114,
		92,
		77,
		94,
		86,
		84,
		89,
		75,
		89,
		80,
		98,
		105,
		103,
		107,
		127,
		139,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		85,
		71,
		68,
		86,
		89,
		96,
		100,
		116,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		112,
		109,
		97,
		84,
		69,
		70,
		78,
		83,
		62,
		70,
		67,
		87,
		113,
		91,
		103,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		65,
		71,
		63,
		80,
		65,
		63,
		82,
		94,
		85,
		98,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		121,
		104,
		85,
		74,
		66,
		55,
		59,
		67,
		71,
		61,
		70,
		76,
		100,
		86,
		92,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		63,
		50,
		63,
		73,
		60,
		62,
		62,
		105,
		105,
		76,
		96,
		99,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		67,
		71,
		65,
		62,
		46,
		64,
		54,
		55,
		79,
		-1,
		84,
		78,
		86,
		76,
		64,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		79,
		74,
		73,
		63,
		51,
		40,
		53,
		46,
		50,
		47,
		67,
		71,
		77,
		66,
		62,
		59,
		73,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		79,
		63,
		54,
		38,
		35,
		28,
		44,
		44,
		62,
		72,
		64,
		58,
		57,
		69,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		91,
		97,
		98,
		71,
		59,
		38,
		26,
		0,
		29,
		52,
		46,
		68,
		68,
		52,
		53,
		62,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		105,
		103,
		87,
		73,
		69,
		50,
		23,
		18,
		28,
		23,
		29,
		40,
		62,
		48,
		46,
		65,
		81,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		81,
		74,
		79,
		-1,
		43,
		-1,
		31,
		44,
		42,
		34,
		34,
		45,
		43,
		54,
		71,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		97,
		77,
		69,
		79,
		38,
		46,
		24,
		47,
		40,
		37,
		37,
		50,
		70,
		61,
		73,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		97,
		85,
		75,
		65,
		70,
		58,
		37,
		42,
		45,
		47,
		45,
		46,
		51,
		72,
		73,
		86,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		86,
		-1,
		-1,
		69,
		62,
		50,
		51,
		49,
		67,
		72,
		61,
		45,
		60,
		72,
		80,
		85,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		171,
		116,
		105,
		100,
		104,
		68,
		-1,
		56,
		57,
		53,
		65,
		72,
		63,
		58,
		52,
		55,
		73,
		90,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		93,
		86,
		90,
		-1,
		65,
		65,
		55,
		72,
		76,
		73,
		64,
		56,
		61,
		58,
		71,
		85,
		89,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		146,
		161,
		132,
		109,
		82,
		77,
		70,
		64,
		63,
		79,
		84,
		95,
		63,
		59,
		60,
		64,
		63,
		80,
		90,
		-1,
		-1,
		161,
		178,
		172,
		154,
		158,
		159,
		-1,
		-1,
		86,
		77,
		68,
		71,
		73,
		76,
		69,
		66,
		71,
		76,
		64,
		73,
		91,
		95,
		-1,
		-1,
		-1,
		181,
		-1,
		196,
		-1,
		-1,
		173,
		157,
		104,
		86,
		82,
		80,
		73,
		82,
		77,
		74,
		84,
		94,
		86,
		66,
		79,
		101,
		91,
		127,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		175,
		167,
		162,
		168,
		170,
		161,
		119,
		116,
		-1,
		86,
		111,
		83,
		90,
		82,
		92,
		92,
		90,
		69,
		76,
		92,
		91,
		86,
		119,
		113,
		119,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		135,
		132,
		108,
		92,
		96,
		89,
		84,
		98,
		78,
		65,
		69,
		73,
		79,
		84,
		89,
		95,
		110,
		125,
		-1,
		188,
		257,
		250,
		218,
		226,
		257,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		108,
		105,
		110,
		99,
		96,
		108,
		103,
		94,
		79,
		85,
		72,
		71,
		89,
		93,
		102,
		109,
		99,
		112,
		116,
		-1,
		202,
		233,
		212,
		215,
		239,
		253,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		107,
		157,
		113,
		108,
		102,
		100,
		91,
		82,
		89,
		80,
		80,
		83,
		98,
		103,
		95,
		109,
		109,
		110,
		-1,
		202,
		213,
		206,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		125,
		129,
		121,
		124,
		116,
		103,
		95,
		87,
		103,
		78,
		88,
		84,
		85,
		94,
		105,
		117,
		116,
		117,
		227,
		183,
		186,
		197,
		208,
		223,
		227,
		-1,
		167,
		206,
		215,
		-1,
		192,
		-1,
		-1,
		-1,
		139,
		134,
		126,
		136,
		115,
		115,
		89,
		93,
		83,
		90,
		100,
		102,
		94,
		98,
		111,
		122,
		125,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		182,
		173,
		200,
		222,
		211,
		206,
		193,
		-1,
		-1,
		162,
		144,
		-1,
		-1,
		122,
		110,
		93,
		94,
		90,
		93,
		108,
		111,
		101,
		99,
		93,
		125,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		201,
		196,
		200,
		216,
		241,
		-1,
		182,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		115,
		104,
		95,
		101,
		98,
		109,
		119,
		107,
		108,
		98,
		108,
		121,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		170,
		176,
		183,
		200,
		230,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		100,
		105,
		125,
		127,
		116,
		110,
		104,
		111,
		110,
		118,
		126,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		118,
		122,
		114,
		107,
		102,
		113,
		105,
		109,
		126,
		-1,
		243,
		-1,
		195,
		171,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		158,
		126,
		131,
		126,
		108,
		119,
		108,
		111,
		125,
		120,
		-1,
		-1,
		183,
		186,
		-1,
		-1,
		195,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		115,
		140,
		129,
		137,
		132,
		112,
		118,
		121,
		110,
		114,
		126,
		-1,
		-1,
		190,
		191,
		196,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		153,
		116,
		137,
		147,
		141,
		139,
		130,
		116,
		123,
		121,
		117,
		128,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		117,
		143,
		146,
		152,
		146,
		119,
		134,
		124,
		115,
		124,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		168,
		153,
		134,
		121,
		128,
		128,
		121,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		158,
		154,
		141,
		141,
		133,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		134,
		169,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		141,
		142,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		168,
		157,
		168,
		176,
		149,
		156,
		-1,
		176,
		179,
		145,
		139,
		178,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		168,
		167,
		136,
		134,
		143,
		148,
		155,
		-1,
		154,
		-1,
		189,
		168,
		179,
		184,
		129,
		126,
		146,
		165,
		147,
		139,
		204,
		159,
		130,
		124,
		142,
		132,
		141,
		133,
		-1,
		130,
		120,
		142,
		121,
		132,
		124,
		-1,
		-1,
		124,
		125,
		131,
		117,
		123,
		119,
		-1,
		129,
		113,
		-1,
		-1,
		114,
		115,
		99,
		102,
		110,
		108,
		121,
		113,
		108,
		-1,
		-1,
		105,
		101,
		108,
		95,
		91,
		108,
		121,
		103,
		117,
		116,
		-1,
		104,
		122,
		131,
		102,
		100,
		84,
		82,
		100,
		102,
		108,
		108,
		-1,
		113,
		114,
		109,
		117,
		122,
		100,
		87,
		87,
		97,
		90,
		109,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		113,
		96,
		113,
		105,
		95,
		110,
		103,
		90,
		87,
		85,
		82,
		98,
		96,
		106,
		-1,
		-1,
		206,
		175,
		204,
		162,
		143,
		-1,
		109,
		89,
		95,
		99,
		93,
		86,
		100,
		96,
		-1,
		76,
		75,
		103,
		89,
		100,
		166,
		-1,
		-1,
		164,
		156,
		139,
		142,
		119,
		115,
		104,
		103,
		95,
		81,
		77,
		83,
		86,
		86,
		92,
		70,
		80,
		84,
		82,
		107,
		-1,
		-1,
		142,
		-1,
		-1,
		163,
		146,
		-1,
		129,
		136,
		125,
		131,
		117,
		138,
		114,
		105,
		97,
		91,
		79,
		81,
		78,
		91,
		79,
		67,
		92,
		96,
		77,
		98,
		93,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		122,
		125,
		131,
		155,
		154,
		-1,
		126,
		114,
		115,
		100,
		97,
		84,
		72,
		85,
		70,
		77,
		76,
		71,
		69,
		99,
		74,
		96,
		93,
		112,
		117,
		111,
		120,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		159,
		-1,
		162,
		163,
		138,
		111,
		114,
		101,
		92,
		79,
		68,
		79,
		68,
		65,
		73,
		63,
		78,
		69,
		68,
		86,
		96,
		104,
		108,
		114,
		-1,
		221,
		-1,
		163,
		147,
		149,
		121,
		142,
		-1,
		179,
		163,
		155,
		140,
		140,
		-1,
		110,
		107,
		97,
		75,
		60,
		77,
		69,
		67,
		72,
		58,
		72,
		63,
		81,
		88,
		86,
		90,
		110,
		122,
		181,
		171,
		-1,
		153,
		158,
		117,
		125,
		144,
		182,
		146,
		-1,
		141,
		-1,
		112,
		125,
		-1,
		81,
		77,
		59,
		60,
		55,
		70,
		68,
		54,
		51,
		69,
		72,
		79,
		83,
		99,
		-1,
		-1,
		166,
		170,
		159,
		110,
		129,
		153,
		190,
		139,
		128,
		127,
		-1,
		118,
		95,
		92,
		80,
		67,
		52,
		53,
		61,
		66,
		45,
		53,
		50,
		70,
		96,
		74,
		86,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		136,
		107,
		131,
		173,
		157,
		150,
		138,
		103,
		103,
		97,
		-1,
		91,
		70,
		61,
		50,
		48,
		54,
		46,
		63,
		48,
		46,
		65,
		77,
		68,
		81,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		102,
		125,
		162,
		136,
		122,
		127,
		102,
		95,
		89,
		104,
		87,
		68,
		57,
		49,
		38,
		42,
		50,
		54,
		44,
		53,
		59,
		83,
		69,
		75,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		116,
		123,
		155,
		127,
		140,
		-1,
		94,
		-1,
		83,
		78,
		62,
		57,
		54,
		46,
		33,
		46,
		56,
		43,
		45,
		45,
		88,
		88,
		59,
		79,
		82,
		-1,
		-1,
		-1,
		166,
		161,
		136,
		113,
		97,
		133,
		-1,
		110,
		111,
		-1,
		88,
		82,
		79,
		64,
		60,
		50,
		54,
		48,
		45,
		29,
		47,
		37,
		38,
		62,
		-1,
		67,
		61,
		69,
		59,
		47,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		92,
		144,
		-1,
		-1,
		95,
		88,
		-1,
		75,
		57,
		62,
		57,
		56,
		46,
		34,
		23,
		36,
		29,
		33,
		30,
		50,
		54,
		60,
		49,
		45,
		42,
		56,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		112,
		-1,
		104,
		96,
		86,
		80,
		74,
		70,
		68,
		84,
		68,
		62,
		46,
		37,
		45,
		18,
		11,
		27,
		27,
		45,
		55,
		47,
		41,
		40,
		52,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		125,
		-1,
		89,
		103,
		119,
		-1,
		112,
		91,
		106,
		84,
		80,
		74,
		84,
		85,
		58,
		46,
		44,
		35,
		23,
		0,
		35,
		29,
		51,
		51,
		35,
		36,
		45,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		86,
		74,
		106,
		-1,
		-1,
		148,
		-1,
		82,
		99,
		88,
		86,
		74,
		60,
		66,
		55,
		32,
		27,
		12,
		6,
		12,
		23,
		45,
		31,
		29,
		48,
		64,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		123,
		-1,
		126,
		116,
		100,
		85,
		118,
		-1,
		77,
		61,
		66,
		-1,
		52,
		-1,
		23,
		27,
		25,
		17,
		17,
		28,
		26,
		37,
		54,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		113,
		107,
		107,
		91,
		94,
		93,
		73,
		67,
		66,
		47,
		55,
		33,
		30,
		23,
		20,
		20,
		33,
		53,
		44,
		56,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		175,
		130,
		116,
		-1,
		100,
		106,
		94,
		84,
		74,
		79,
		67,
		46,
		42,
		28,
		30,
		28,
		29,
		34,
		55,
		56,
		69,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		122,
		138,
		130,
		101,
		95,
		-1,
		-1,
		78,
		71,
		59,
		45,
		32,
		52,
		55,
		44,
		28,
		43,
		55,
		63,
		68,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		155,
		101,
		90,
		85,
		89,
		77,
		-1,
		61,
		56,
		36,
		50,
		57,
		46,
		41,
		35,
		38,
		56,
		73,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		112,
		107,
		78,
		71,
		75,
		-1,
		63,
		52,
		38,
		55,
		59,
		56,
		47,
		39,
		44,
		41,
		54,
		68,
		72,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		130,
		145,
		117,
		94,
		67,
		62,
		55,
		49,
		46,
		62,
		67,
		78,
		46,
		42,
		43,
		47,
		46,
		63,
		73,
		-1,
		-1,
		144,
		161,
		156,
		138,
		142,
		144,
		-1,
		-1,
		71,
		62,
		53,
		56,
		56,
		59,
		52,
		49,
		54,
		59,
		47,
		56,
		74,
		78,
		-1,
		-1,
		-1,
		164,
		-1,
		179,
		-1,
		-1,
		157,
		142,
		89,
		71,
		67,
		65,
		58,
		67,
		62,
		57,
		67,
		77,
		69,
		49,
		62,
		84,
		74,
		110,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		104,
		101,
		-1,
		71,
		96,
		68,
		75,
		67,
		75,
		75,
		73,
		52,
		59,
		75,
		74,
		69,
		102,
		96,
		102,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		120,
		117,
		93,
		77,
		81,
		74,
		69,
		81,
		61,
		48,
		52,
		56,
		62,
		67,
		72,
		78,
		93,
		108,
		-1,
		171,
		242,
		235,
		203,
		211,
		242,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		93,
		90,
		95,
		84,
		81,
		91,
		86,
		77,
		62,
		68,
		55,
		54,
		72,
		76,
		85,
		92,
		82,
		95,
		99,
		-1,
		185,
		218,
		197,
		200,
		224,
		238,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		92,
		142,
		98,
		93,
		85,
		83,
		74,
		65,
		72,
		63,
		63,
		66,
		81,
		86,
		78,
		92,
		92,
		93,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		168,
		-1,
		135,
		-1,
		110,
		114,
		106,
		109,
		99,
		86,
		78,
		70,
		86,
		61,
		71,
		67,
		68,
		77,
		88,
		100,
		99,
		100,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		152,
		191,
		198,
		-1,
		177,
		-1,
		-1,
		-1,
		124,
		119,
		111,
		119,
		98,
		98,
		72,
		76,
		66,
		73,
		83,
		85,
		77,
		81,
		94,
		105,
		108,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		167,
		158,
		185,
		205,
		194,
		189,
		176,
		-1,
		-1,
		147,
		129,
		-1,
		-1,
		105,
		93,
		76,
		77,
		73,
		76,
		91,
		94,
		84,
		82,
		76,
		108,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		170,
		186,
		181,
		185,
		201,
		226,
		-1,
		165,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		98,
		87,
		78,
		84,
		81,
		92,
		102,
		90,
		91,
		81,
		91,
		104,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		157,
		155,
		161,
		168,
		185,
		215,
		-1,
		-1,
		181,
		161,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		83,
		88,
		108,
		110,
		99,
		93,
		87,
		94,
		93,
		101,
		109,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		171,
		167,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		101,
		105,
		97,
		90,
		85,
		96,
		88,
		92,
		109,
		-1,
		228,
		-1,
		180,
		156,
		170,
		185,
		193,
		-1,
		-1,
		-1,
		188,
		174,
		167,
		155,
		153,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		141,
		109,
		114,
		109,
		91,
		102,
		91,
		94,
		108,
		103,
		-1,
		-1,
		168,
		171,
		-1,
		-1,
		178,
		180,
		-1,
		179,
		168,
		153,
		145,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		98,
		123,
		112,
		120,
		115,
		95,
		101,
		104,
		93,
		97,
		109,
		-1,
		-1,
		175,
		176,
		181,
		-1,
		163,
		-1,
		181,
		-1,
		148,
		154,
		142,
		-1,
		-1,
		-1,
		136,
		99,
		120,
		130,
		124,
		122,
		113,
		99,
		106,
		104,
		100,
		111,
		-1,
		-1,
		-1,
		181,
		155,
		188,
		179,
		162,
		142,
		134,
		153,
		-1,
		123,
		-1,
		98,
		100,
		126,
		129,
		135,
		129,
		102,
		117,
		107,
		98,
		107,
		187,
		-1,
		157,
		190,
		154,
		148,
		124,
		128,
		144,
		-1,
		120,
		102,
		-1,
		130,
		120,
		151,
		136,
		117,
		104,
		111,
		111,
		104,
		-1,
		-1,
		-1,
		159,
		158,
		150,
		144,
		144,
		129,
		120,
		-1,
		132,
		114,
		93,
		110,
		110,
		101,
		109,
		141,
		137,
		124,
		124,
		116,
		-1,
		260,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		153,
		148,
		121,
		109,
		115,
		111,
		97,
		103,
		105,
		113,
		111,
		108,
		120,
		116,
		136,
		117,
		152,
		-1,
		255,
		-1,
		189,
		-1,
		-1,
		171,
		151,
		143,
		132,
		121,
		119,
		110,
		101,
		123,
		139,
		123,
		121,
		124,
		125,
		-1,
		244,
		243,
		-1,
		190,
		182,
		168,
		-1,
		161,
		-1,
		167,
		128,
		-1,
		130,
		110,
		-1,
		132,
		128,
		-1,
		-1,
		231,
		206,
		-1,
		-1,
		-1,
		191,
		171,
		162,
		146,
		-1,
		121,
		121,
		-1,
		-1,
		-1,
		216,
		215,
		-1,
		184,
		187,
		-1,
		177,
		168,
		176,
		123,
		127,
		-1,
		-1,
		-1,
		225,
		206,
		200,
		199,
		197,
		192,
		189,
		175,
		159,
		137,
		126,
		147,
		-1,
		-1,
		-1,
		197,
		189,
		182,
		-1,
		-1,
		184,
		167,
		148,
		146,
		-1,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		174,
		-1,
		-1,
		180,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		208,
		-1,
		-1,
		-1,
		170,
		166,
		167,
		-1,
		-1,
		-1,
		-1,
		230,
		231,
		254,
		218,
		-1,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		233,
		231,
		-1,
		-1,
		-1,
		190,
		174,
		-1,
		160,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		195,
		-1,
		195,
		170,
		177,
		-1,
		-1,
		-1,
		-1,
		208,
		200,
		208,
		-1,
		180,
		182,
		-1,
		230,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		185,
		192,
		214,
		217,
		253,
		-1,
		204
	],
	[
		-1,
		150,
		139,
		150,
		158,
		131,
		138,
		-1,
		157,
		161,
		127,
		121,
		160,
		129,
		135,
		146,
		-1,
		-1,
		-1,
		150,
		149,
		117,
		115,
		124,
		129,
		136,
		-1,
		135,
		-1,
		171,
		150,
		161,
		166,
		110,
		107,
		127,
		146,
		128,
		120,
		186,
		140,
		111,
		105,
		123,
		113,
		122,
		114,
		-1,
		111,
		101,
		123,
		102,
		113,
		105,
		-1,
		-1,
		105,
		106,
		112,
		98,
		104,
		100,
		-1,
		110,
		94,
		-1,
		-1,
		95,
		96,
		80,
		83,
		91,
		89,
		102,
		94,
		89,
		-1,
		-1,
		86,
		82,
		89,
		76,
		72,
		89,
		102,
		84,
		98,
		97,
		-1,
		98,
		115,
		115,
		83,
		81,
		65,
		63,
		81,
		83,
		89,
		89,
		-1,
		115,
		111,
		112,
		110,
		105,
		81,
		68,
		68,
		78,
		71,
		90,
		78,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		105,
		122,
		108,
		98,
		102,
		100,
		71,
		68,
		66,
		63,
		79,
		77,
		87,
		-1,
		-1,
		209,
		182,
		206,
		164,
		146,
		-1,
		112,
		98,
		104,
		102,
		96,
		89,
		102,
		87,
		-1,
		57,
		56,
		84,
		70,
		81,
		175,
		-1,
		-1,
		167,
		159,
		141,
		144,
		121,
		117,
		113,
		112,
		104,
		90,
		86,
		86,
		89,
		89,
		95,
		51,
		61,
		65,
		63,
		88,
		-1,
		-1,
		123,
		-1,
		-1,
		172,
		155,
		-1,
		136,
		143,
		127,
		133,
		119,
		140,
		123,
		114,
		106,
		100,
		88,
		84,
		81,
		94,
		73,
		48,
		73,
		77,
		58,
		79,
		74,
		-1,
		122,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		131,
		134,
		133,
		157,
		156,
		-1,
		135,
		123,
		124,
		109,
		106,
		93,
		81,
		89,
		73,
		73,
		70,
		52,
		50,
		80,
		55,
		77,
		74,
		93,
		98,
		92,
		101,
		-1,
		180,
		176,
		172,
		179,
		128,
		-1,
		-1,
		161,
		-1,
		164,
		172,
		147,
		120,
		123,
		110,
		101,
		88,
		77,
		88,
		71,
		68,
		64,
		44,
		59,
		50,
		49,
		67,
		77,
		85,
		89,
		95,
		-1,
		230,
		-1,
		172,
		156,
		158,
		130,
		151,
		-1,
		181,
		165,
		164,
		149,
		149,
		-1,
		119,
		116,
		106,
		84,
		69,
		83,
		71,
		66,
		57,
		39,
		53,
		44,
		62,
		69,
		67,
		71,
		91,
		103,
		190,
		180,
		-1,
		162,
		167,
		126,
		134,
		153,
		191,
		155,
		-1,
		150,
		-1,
		121,
		134,
		-1,
		90,
		86,
		68,
		69,
		64,
		75,
		50,
		35,
		32,
		50,
		53,
		60,
		64,
		80,
		-1,
		-1,
		175,
		179,
		168,
		119,
		138,
		162,
		199,
		148,
		137,
		136,
		-1,
		127,
		104,
		101,
		89,
		76,
		61,
		62,
		70,
		70,
		49,
		34,
		31,
		51,
		77,
		55,
		67,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		145,
		116,
		140,
		182,
		166,
		159,
		147,
		112,
		112,
		106,
		-1,
		100,
		79,
		70,
		59,
		57,
		69,
		55,
		49,
		29,
		27,
		46,
		58,
		49,
		69,
		-1,
		-1,
		-1,
		175,
		164,
		165,
		111,
		134,
		171,
		145,
		131,
		136,
		111,
		104,
		98,
		113,
		96,
		77,
		66,
		58,
		47,
		55,
		51,
		43,
		25,
		34,
		40,
		64,
		69,
		75,
		-1,
		-1,
		182,
		172,
		156,
		158,
		155,
		125,
		132,
		164,
		136,
		149,
		-1,
		103,
		-1,
		92,
		87,
		71,
		66,
		63,
		60,
		48,
		44,
		42,
		32,
		27,
		34,
		69,
		69,
		61,
		84,
		87,
		-1,
		-1,
		-1,
		175,
		170,
		145,
		122,
		106,
		142,
		-1,
		119,
		120,
		-1,
		97,
		91,
		88,
		73,
		69,
		64,
		68,
		61,
		54,
		44,
		36,
		37,
		19,
		42,
		-1,
		59,
		63,
		82,
		72,
		60,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		101,
		153,
		-1,
		-1,
		104,
		97,
		-1,
		84,
		66,
		73,
		71,
		65,
		66,
		54,
		43,
		52,
		44,
		24,
		18,
		30,
		34,
		60,
		62,
		58,
		55,
		69,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		121,
		-1,
		113,
		105,
		95,
		89,
		83,
		79,
		77,
		93,
		77,
		80,
		66,
		57,
		65,
		38,
		31,
		23,
		8,
		25,
		54,
		60,
		54,
		53,
		65,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		134,
		-1,
		98,
		112,
		128,
		-1,
		121,
		100,
		115,
		93,
		89,
		85,
		100,
		101,
		78,
		66,
		64,
		61,
		49,
		38,
		0,
		10,
		34,
		44,
		48,
		49,
		58,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		95,
		83,
		115,
		-1,
		-1,
		157,
		-1,
		91,
		108,
		99,
		97,
		90,
		80,
		86,
		75,
		58,
		53,
		43,
		32,
		33,
		19,
		58,
		44,
		42,
		61,
		77,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		135,
		125,
		109,
		94,
		127,
		-1,
		97,
		81,
		86,
		-1,
		78,
		-1,
		45,
		47,
		41,
		26,
		30,
		41,
		39,
		50,
		67,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		152,
		-1,
		-1,
		122,
		116,
		116,
		100,
		103,
		113,
		93,
		87,
		86,
		73,
		67,
		59,
		39,
		32,
		29,
		33,
		41,
		64,
		57,
		69,
		-1,
		-1,
		-1,
		149,
		135,
		139,
		99,
		118,
		-1,
		-1,
		184,
		139,
		125,
		-1,
		109,
		122,
		110,
		100,
		90,
		93,
		83,
		58,
		51,
		37,
		39,
		37,
		42,
		47,
		68,
		69,
		82,
		-1,
		-1,
		132,
		137,
		125,
		111,
		130,
		-1,
		-1,
		-1,
		131,
		147,
		139,
		110,
		111,
		-1,
		-1,
		94,
		85,
		75,
		54,
		41,
		61,
		64,
		57,
		41,
		56,
		68,
		76,
		81,
		-1,
		135,
		122,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		-1,
		-1,
		164,
		114,
		103,
		98,
		102,
		93,
		-1,
		74,
		65,
		45,
		59,
		66,
		59,
		54,
		48,
		51,
		69,
		86,
		-1,
		-1,
		147,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		121,
		120,
		91,
		84,
		88,
		-1,
		75,
		61,
		47,
		64,
		72,
		69,
		60,
		52,
		57,
		54,
		67,
		81,
		85,
		170,
		-1,
		153,
		-1,
		-1,
		-1,
		139,
		154,
		130,
		107,
		80,
		75,
		68,
		62,
		55,
		71,
		80,
		91,
		59,
		55,
		56,
		60,
		59,
		76,
		86,
		-1,
		-1,
		153,
		170,
		165,
		147,
		151,
		157,
		-1,
		-1,
		84,
		75,
		66,
		69,
		65,
		68,
		65,
		62,
		67,
		72,
		60,
		69,
		87,
		91,
		-1,
		-1,
		-1,
		173,
		-1,
		188,
		-1,
		-1,
		166,
		155,
		102,
		84,
		80,
		78,
		71,
		80,
		74,
		70,
		80,
		90,
		82,
		62,
		75,
		97,
		87,
		123,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		167,
		158,
		117,
		114,
		-1,
		84,
		109,
		80,
		87,
		79,
		88,
		88,
		86,
		65,
		72,
		88,
		87,
		82,
		115,
		109,
		115,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		166,
		162,
		152,
		142,
		144,
		-1,
		-1,
		132,
		129,
		106,
		89,
		94,
		87,
		82,
		94,
		74,
		61,
		65,
		69,
		75,
		80,
		85,
		91,
		106,
		121,
		-1,
		180,
		254,
		247,
		215,
		223,
		254,
		-1,
		156,
		148,
		159,
		134,
		135,
		-1,
		-1,
		105,
		103,
		108,
		96,
		93,
		104,
		99,
		90,
		75,
		81,
		68,
		67,
		85,
		89,
		98,
		105,
		95,
		108,
		112,
		-1,
		194,
		230,
		209,
		212,
		236,
		250,
		-1,
		153,
		-1,
		-1,
		165,
		136,
		120,
		111,
		104,
		155,
		110,
		105,
		98,
		96,
		87,
		78,
		85,
		76,
		76,
		79,
		94,
		99,
		91,
		105,
		105,
		106,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		-1,
		147,
		-1,
		122,
		126,
		118,
		121,
		112,
		99,
		91,
		83,
		99,
		74,
		84,
		80,
		81,
		90,
		101,
		113,
		112,
		113,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		165,
		204,
		211,
		-1,
		190,
		-1,
		-1,
		-1,
		136,
		131,
		123,
		132,
		111,
		111,
		85,
		89,
		79,
		86,
		96,
		98,
		90,
		94,
		107,
		118,
		121,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		180,
		171,
		198,
		218,
		207,
		202,
		189,
		-1,
		-1,
		159,
		141,
		-1,
		-1,
		118,
		106,
		89,
		90,
		86,
		89,
		104,
		107,
		97,
		95,
		89,
		121,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		199,
		193,
		197,
		213,
		238,
		-1,
		178,
		-1,
		-1,
		163,
		-1,
		-1,
		148,
		111,
		100,
		91,
		97,
		94,
		105,
		115,
		103,
		104,
		94,
		104,
		117,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		197,
		227,
		-1,
		-1,
		194,
		174,
		-1,
		-1,
		146,
		144,
		133,
		-1,
		123,
		96,
		101,
		121,
		123,
		112,
		106,
		100,
		107,
		106,
		114,
		122,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		180,
		-1,
		-1,
		141,
		134,
		122,
		110,
		100,
		110,
		114,
		118,
		110,
		103,
		98,
		109,
		101,
		105,
		122,
		-1,
		240,
		-1,
		192,
		168,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		175,
		159,
		140,
		-1,
		110,
		123,
		154,
		122,
		127,
		122,
		104,
		115,
		104,
		107,
		121,
		116,
		-1,
		-1,
		180,
		183,
		-1,
		-1,
		191,
		193,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		147,
		143,
		-1,
		-1,
		111,
		136,
		125,
		133,
		128,
		108,
		114,
		117,
		106,
		110,
		122,
		-1,
		-1,
		187,
		188,
		193,
		-1,
		176,
		-1,
		194,
		-1,
		161,
		167,
		155,
		-1,
		-1,
		-1,
		149,
		112,
		133,
		143,
		137,
		135,
		126,
		112,
		119,
		117,
		113,
		124,
		-1,
		-1,
		-1,
		194,
		168,
		201,
		192,
		175,
		155,
		147,
		166,
		-1,
		136,
		-1,
		111,
		113,
		139,
		142,
		148,
		142,
		115,
		130,
		120,
		111,
		120,
		200,
		-1,
		170,
		203,
		167,
		161,
		137,
		141,
		157,
		-1,
		133,
		115,
		-1,
		143,
		133,
		164,
		149,
		130,
		117,
		124,
		124,
		117,
		-1,
		-1,
		-1,
		172,
		171,
		163,
		157,
		157,
		142,
		133,
		-1,
		145,
		127,
		106,
		123,
		123,
		114,
		122,
		154,
		150,
		137,
		137,
		129,
		-1,
		273,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		166,
		161,
		134,
		122,
		128,
		124,
		110,
		116,
		118,
		126,
		124,
		121,
		133,
		129,
		149,
		130,
		165,
		-1,
		268,
		-1,
		202,
		-1,
		-1,
		184,
		164,
		156,
		145,
		134,
		132,
		123,
		114,
		136,
		152,
		136,
		134,
		137,
		138,
		-1,
		257,
		256,
		-1,
		203,
		195,
		181,
		-1,
		174,
		-1,
		180,
		141,
		-1,
		143,
		123,
		-1,
		145,
		141,
		-1,
		-1,
		244,
		219,
		-1,
		-1,
		-1,
		204,
		184,
		175,
		159,
		-1,
		134,
		134,
		-1,
		-1,
		-1,
		229,
		228,
		-1,
		197,
		200,
		-1,
		190,
		181,
		189,
		136,
		140,
		-1,
		-1,
		-1,
		238,
		219,
		213,
		212,
		210,
		205,
		202,
		188,
		172,
		150,
		139,
		160,
		-1,
		-1,
		-1,
		210,
		202,
		195,
		-1,
		-1,
		197,
		180,
		161,
		159,
		-1,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		187,
		-1,
		-1,
		193,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		221,
		-1,
		-1,
		-1,
		183,
		179,
		180,
		-1,
		-1,
		-1,
		-1,
		243,
		244,
		267,
		231,
		-1,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		246,
		244,
		-1,
		-1,
		-1,
		203,
		187,
		-1,
		173,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		208,
		-1,
		208,
		183,
		190,
		-1,
		-1,
		-1,
		-1,
		221,
		213,
		221,
		-1,
		193,
		195,
		-1,
		243,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		198,
		205,
		227,
		230,
		266,
		-1,
		217
	],
	[
		-1,
		153,
		142,
		153,
		161,
		134,
		141,
		-1,
		160,
		164,
		130,
		124,
		163,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		153,
		152,
		120,
		118,
		127,
		132,
		139,
		-1,
		138,
		-1,
		174,
		153,
		164,
		169,
		113,
		110,
		130,
		149,
		131,
		123,
		189,
		143,
		114,
		108,
		126,
		116,
		125,
		117,
		-1,
		114,
		104,
		126,
		105,
		116,
		108,
		-1,
		-1,
		108,
		109,
		115,
		101,
		107,
		103,
		-1,
		113,
		97,
		-1,
		-1,
		98,
		99,
		83,
		86,
		94,
		92,
		105,
		97,
		92,
		-1,
		-1,
		89,
		85,
		92,
		79,
		75,
		92,
		105,
		87,
		101,
		100,
		-1,
		101,
		118,
		118,
		86,
		84,
		68,
		66,
		84,
		86,
		92,
		92,
		-1,
		118,
		114,
		115,
		113,
		108,
		84,
		71,
		71,
		81,
		74,
		93,
		81,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		108,
		125,
		111,
		101,
		105,
		103,
		74,
		71,
		69,
		66,
		82,
		80,
		90,
		-1,
		-1,
		212,
		185,
		209,
		167,
		149,
		-1,
		115,
		101,
		107,
		105,
		99,
		92,
		105,
		90,
		-1,
		60,
		59,
		87,
		73,
		84,
		178,
		-1,
		-1,
		170,
		162,
		144,
		147,
		124,
		120,
		116,
		115,
		107,
		93,
		89,
		89,
		92,
		92,
		98,
		54,
		64,
		68,
		66,
		91,
		-1,
		-1,
		126,
		-1,
		-1,
		175,
		158,
		-1,
		139,
		146,
		130,
		136,
		122,
		143,
		126,
		117,
		109,
		103,
		91,
		87,
		84,
		97,
		76,
		51,
		76,
		80,
		61,
		82,
		77,
		-1,
		125,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		134,
		137,
		136,
		160,
		159,
		-1,
		138,
		126,
		127,
		112,
		109,
		96,
		84,
		92,
		76,
		76,
		73,
		55,
		53,
		83,
		58,
		80,
		77,
		96,
		101,
		95,
		104,
		-1,
		183,
		179,
		175,
		182,
		131,
		-1,
		-1,
		164,
		-1,
		167,
		175,
		150,
		123,
		126,
		113,
		104,
		91,
		80,
		91,
		74,
		71,
		67,
		47,
		62,
		53,
		52,
		70,
		80,
		88,
		92,
		98,
		-1,
		233,
		-1,
		175,
		159,
		161,
		133,
		154,
		-1,
		184,
		168,
		167,
		152,
		152,
		-1,
		122,
		119,
		109,
		87,
		72,
		86,
		74,
		69,
		60,
		42,
		56,
		47,
		65,
		72,
		70,
		74,
		94,
		106,
		193,
		183,
		-1,
		165,
		170,
		129,
		137,
		156,
		194,
		158,
		-1,
		153,
		-1,
		124,
		137,
		-1,
		93,
		89,
		71,
		72,
		67,
		78,
		53,
		38,
		35,
		53,
		56,
		63,
		67,
		83,
		-1,
		-1,
		178,
		182,
		171,
		122,
		141,
		165,
		202,
		151,
		140,
		139,
		-1,
		130,
		107,
		104,
		92,
		79,
		64,
		65,
		73,
		73,
		52,
		37,
		34,
		54,
		80,
		58,
		70,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		148,
		119,
		143,
		185,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		103,
		82,
		73,
		62,
		60,
		72,
		58,
		52,
		32,
		30,
		49,
		61,
		52,
		72,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		114,
		137,
		174,
		148,
		134,
		139,
		114,
		107,
		101,
		116,
		99,
		80,
		69,
		61,
		50,
		58,
		54,
		46,
		28,
		37,
		43,
		67,
		73,
		79,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		128,
		135,
		167,
		139,
		152,
		-1,
		106,
		-1,
		95,
		90,
		74,
		69,
		66,
		63,
		51,
		47,
		45,
		35,
		30,
		37,
		72,
		72,
		64,
		88,
		91,
		-1,
		-1,
		-1,
		178,
		173,
		148,
		125,
		109,
		145,
		-1,
		122,
		123,
		-1,
		100,
		94,
		91,
		76,
		72,
		67,
		71,
		64,
		57,
		47,
		39,
		40,
		22,
		46,
		-1,
		63,
		66,
		83,
		73,
		61,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		104,
		156,
		-1,
		-1,
		107,
		100,
		-1,
		87,
		69,
		76,
		74,
		68,
		69,
		57,
		46,
		55,
		47,
		27,
		21,
		34,
		38,
		63,
		63,
		59,
		56,
		70,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		124,
		-1,
		116,
		108,
		98,
		92,
		86,
		82,
		80,
		96,
		80,
		83,
		69,
		60,
		68,
		41,
		34,
		26,
		11,
		29,
		57,
		61,
		55,
		54,
		66,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		137,
		-1,
		101,
		115,
		131,
		-1,
		124,
		103,
		118,
		96,
		92,
		88,
		103,
		104,
		81,
		69,
		67,
		64,
		52,
		41,
		11,
		0,
		37,
		47,
		49,
		50,
		59,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		98,
		86,
		118,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		102,
		100,
		93,
		83,
		89,
		78,
		61,
		56,
		46,
		35,
		41,
		17,
		59,
		45,
		43,
		62,
		78,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		100,
		84,
		89,
		-1,
		81,
		-1,
		48,
		50,
		48,
		34,
		31,
		42,
		40,
		51,
		68,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		155,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		116,
		96,
		90,
		89,
		76,
		75,
		62,
		47,
		40,
		37,
		34,
		38,
		61,
		58,
		70,
		-1,
		-1,
		-1,
		152,
		138,
		142,
		102,
		121,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		130,
		118,
		108,
		98,
		101,
		91,
		66,
		59,
		45,
		47,
		45,
		43,
		48,
		69,
		70,
		83,
		-1,
		-1,
		135,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		119,
		-1,
		-1,
		102,
		93,
		83,
		62,
		49,
		69,
		72,
		58,
		42,
		57,
		69,
		77,
		82,
		-1,
		138,
		125,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		167,
		115,
		104,
		99,
		103,
		101,
		-1,
		75,
		73,
		53,
		67,
		74,
		60,
		55,
		49,
		52,
		70,
		87,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		124,
		121,
		92,
		85,
		89,
		-1,
		77,
		69,
		55,
		72,
		73,
		70,
		61,
		53,
		58,
		55,
		68,
		82,
		86,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		142,
		157,
		131,
		108,
		81,
		76,
		69,
		63,
		63,
		79,
		81,
		92,
		60,
		56,
		57,
		61,
		60,
		77,
		87,
		-1,
		-1,
		156,
		173,
		168,
		150,
		154,
		158,
		-1,
		-1,
		85,
		76,
		67,
		70,
		73,
		76,
		66,
		63,
		68,
		73,
		61,
		70,
		88,
		92,
		-1,
		-1,
		-1,
		176,
		-1,
		191,
		-1,
		-1,
		169,
		156,
		103,
		85,
		81,
		79,
		72,
		81,
		76,
		71,
		81,
		91,
		83,
		63,
		76,
		98,
		88,
		124,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		169,
		160,
		118,
		115,
		-1,
		85,
		110,
		82,
		89,
		81,
		89,
		89,
		87,
		66,
		73,
		89,
		88,
		83,
		116,
		110,
		116,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		134,
		131,
		107,
		91,
		95,
		88,
		83,
		95,
		75,
		62,
		66,
		70,
		76,
		81,
		86,
		92,
		107,
		122,
		-1,
		183,
		256,
		249,
		217,
		225,
		256,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		107,
		104,
		109,
		98,
		95,
		105,
		100,
		91,
		76,
		82,
		69,
		68,
		86,
		90,
		99,
		106,
		96,
		109,
		113,
		-1,
		197,
		232,
		211,
		214,
		238,
		252,
		-1,
		154,
		-1,
		-1,
		166,
		138,
		122,
		112,
		106,
		156,
		112,
		107,
		99,
		97,
		88,
		79,
		86,
		77,
		77,
		80,
		95,
		100,
		92,
		106,
		106,
		107,
		-1,
		201,
		212,
		205,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		149,
		-1,
		124,
		128,
		120,
		123,
		113,
		100,
		92,
		84,
		100,
		75,
		85,
		81,
		82,
		91,
		102,
		114,
		113,
		114,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		166,
		205,
		212,
		-1,
		191,
		-1,
		-1,
		-1,
		138,
		133,
		125,
		133,
		112,
		112,
		86,
		90,
		80,
		87,
		97,
		99,
		91,
		95,
		108,
		119,
		122,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		181,
		172,
		199,
		219,
		208,
		203,
		190,
		-1,
		-1,
		161,
		143,
		-1,
		-1,
		119,
		107,
		90,
		91,
		87,
		90,
		105,
		108,
		98,
		96,
		90,
		122,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		200,
		195,
		199,
		215,
		240,
		-1,
		179,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		112,
		101,
		92,
		98,
		95,
		106,
		116,
		104,
		105,
		95,
		105,
		118,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		199,
		229,
		-1,
		-1,
		195,
		175,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		97,
		102,
		122,
		124,
		113,
		107,
		101,
		108,
		107,
		115,
		123,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		181,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		115,
		119,
		111,
		104,
		99,
		110,
		102,
		106,
		123,
		-1,
		242,
		-1,
		194,
		170,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		105,
		116,
		105,
		108,
		122,
		117,
		-1,
		-1,
		182,
		185,
		-1,
		-1,
		192,
		194,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		109,
		115,
		118,
		107,
		111,
		123,
		-1,
		-1,
		189,
		190,
		195,
		-1,
		177,
		-1,
		195,
		-1,
		162,
		168,
		156,
		-1,
		-1,
		-1,
		150,
		113,
		134,
		144,
		138,
		136,
		127,
		113,
		120,
		118,
		114,
		125,
		-1,
		-1,
		-1,
		195,
		169,
		202,
		193,
		176,
		156,
		148,
		167,
		-1,
		137,
		-1,
		112,
		114,
		140,
		143,
		149,
		143,
		116,
		131,
		121,
		112,
		121,
		201,
		-1,
		171,
		204,
		168,
		162,
		138,
		142,
		158,
		-1,
		134,
		116,
		-1,
		144,
		134,
		165,
		150,
		131,
		118,
		125,
		125,
		118,
		-1,
		-1,
		-1,
		173,
		172,
		164,
		158,
		158,
		143,
		134,
		-1,
		146,
		128,
		107,
		124,
		124,
		115,
		123,
		155,
		151,
		138,
		138,
		130,
		-1,
		274,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		167,
		162,
		135,
		123,
		129,
		125,
		111,
		117,
		119,
		127,
		125,
		122,
		134,
		130,
		150,
		131,
		166,
		-1,
		269,
		-1,
		203,
		-1,
		-1,
		185,
		165,
		157,
		146,
		135,
		133,
		124,
		115,
		137,
		153,
		137,
		135,
		138,
		139,
		-1,
		258,
		257,
		-1,
		204,
		196,
		182,
		-1,
		175,
		-1,
		181,
		142,
		-1,
		144,
		124,
		-1,
		146,
		142,
		-1,
		-1,
		245,
		220,
		-1,
		-1,
		-1,
		205,
		185,
		176,
		160,
		-1,
		135,
		135,
		-1,
		-1,
		-1,
		230,
		229,
		-1,
		198,
		201,
		-1,
		191,
		182,
		190,
		137,
		141,
		-1,
		-1,
		-1,
		239,
		220,
		214,
		213,
		211,
		206,
		203,
		189,
		173,
		151,
		140,
		161,
		-1,
		-1,
		-1,
		211,
		203,
		196,
		-1,
		-1,
		198,
		181,
		162,
		160,
		-1,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		188,
		-1,
		-1,
		194,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		222,
		-1,
		-1,
		-1,
		184,
		180,
		181,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		268,
		232,
		-1,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		247,
		245,
		-1,
		-1,
		-1,
		204,
		188,
		-1,
		174,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		209,
		-1,
		209,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		222,
		214,
		222,
		-1,
		194,
		196,
		-1,
		244,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		199,
		206,
		228,
		231,
		267,
		-1,
		218
	],
	[
		-1,
		169,
		158,
		169,
		177,
		150,
		157,
		-1,
		176,
		180,
		146,
		140,
		179,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		169,
		168,
		136,
		134,
		143,
		148,
		155,
		-1,
		154,
		-1,
		190,
		169,
		180,
		185,
		129,
		126,
		146,
		165,
		147,
		139,
		205,
		159,
		130,
		124,
		142,
		132,
		141,
		133,
		-1,
		130,
		120,
		142,
		121,
		132,
		124,
		-1,
		-1,
		124,
		125,
		131,
		117,
		123,
		119,
		-1,
		129,
		113,
		-1,
		-1,
		114,
		115,
		99,
		102,
		110,
		108,
		121,
		113,
		108,
		-1,
		-1,
		105,
		101,
		108,
		95,
		91,
		108,
		121,
		103,
		117,
		116,
		-1,
		117,
		134,
		134,
		102,
		100,
		84,
		82,
		100,
		102,
		108,
		108,
		-1,
		134,
		130,
		131,
		129,
		124,
		100,
		87,
		87,
		97,
		90,
		109,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		135,
		124,
		141,
		127,
		117,
		121,
		119,
		90,
		87,
		85,
		82,
		98,
		96,
		106,
		-1,
		-1,
		228,
		201,
		225,
		183,
		165,
		-1,
		131,
		117,
		123,
		121,
		115,
		108,
		121,
		106,
		-1,
		76,
		75,
		103,
		89,
		100,
		192,
		-1,
		-1,
		186,
		178,
		160,
		163,
		140,
		136,
		132,
		131,
		123,
		109,
		105,
		105,
		108,
		108,
		114,
		70,
		80,
		84,
		82,
		107,
		-1,
		-1,
		135,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		146,
		152,
		138,
		159,
		142,
		133,
		125,
		119,
		107,
		103,
		100,
		113,
		92,
		67,
		92,
		96,
		77,
		98,
		93,
		-1,
		134,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		152,
		176,
		175,
		-1,
		154,
		142,
		143,
		128,
		125,
		112,
		100,
		108,
		92,
		92,
		89,
		71,
		69,
		99,
		74,
		96,
		93,
		105,
		110,
		104,
		113,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		180,
		-1,
		183,
		191,
		166,
		139,
		142,
		129,
		120,
		107,
		96,
		107,
		90,
		87,
		83,
		63,
		78,
		69,
		68,
		86,
		89,
		97,
		101,
		107,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		200,
		184,
		183,
		168,
		166,
		-1,
		138,
		135,
		125,
		103,
		88,
		102,
		90,
		85,
		76,
		58,
		72,
		63,
		76,
		83,
		79,
		83,
		103,
		115,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		140,
		153,
		-1,
		109,
		105,
		87,
		88,
		83,
		94,
		69,
		54,
		51,
		69,
		67,
		72,
		76,
		92,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		123,
		120,
		108,
		95,
		80,
		81,
		89,
		89,
		68,
		53,
		50,
		63,
		89,
		67,
		75,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		119,
		98,
		89,
		78,
		76,
		88,
		74,
		68,
		48,
		46,
		58,
		70,
		61,
		66,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		132,
		115,
		96,
		85,
		77,
		66,
		74,
		70,
		62,
		44,
		53,
		52,
		76,
		54,
		60,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		105,
		90,
		85,
		82,
		69,
		67,
		63,
		61,
		51,
		46,
		53,
		81,
		81,
		48,
		69,
		72,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		92,
		88,
		73,
		77,
		79,
		73,
		63,
		55,
		56,
		38,
		48,
		-1,
		37,
		46,
		66,
		57,
		47,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		85,
		80,
		79,
		78,
		73,
		62,
		71,
		63,
		43,
		37,
		34,
		34,
		26,
		47,
		45,
		42,
		56,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		107,
		91,
		90,
		85,
		76,
		84,
		57,
		50,
		42,
		27,
		29,
		20,
		35,
		30,
		34,
		52,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		97,
		114,
		115,
		93,
		85,
		83,
		76,
		64,
		53,
		33,
		29,
		0,
		10,
		28,
		30,
		39,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		111,
		109,
		104,
		95,
		101,
		94,
		73,
		68,
		58,
		47,
		47,
		25,
		48,
		34,
		32,
		42,
		58,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		112,
		96,
		101,
		-1,
		93,
		-1,
		64,
		63,
		54,
		39,
		36,
		44,
		35,
		48,
		48,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		128,
		108,
		102,
		101,
		88,
		80,
		74,
		52,
		45,
		42,
		39,
		43,
		66,
		55,
		50,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		135,
		123,
		113,
		103,
		106,
		96,
		71,
		64,
		50,
		52,
		50,
		48,
		53,
		63,
		55,
		65,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		156,
		127,
		124,
		-1,
		-1,
		107,
		98,
		88,
		67,
		54,
		74,
		77,
		63,
		47,
		62,
		69,
		57,
		66,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		120,
		109,
		104,
		108,
		106,
		-1,
		80,
		78,
		58,
		72,
		79,
		65,
		60,
		54,
		57,
		74,
		68,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		97,
		90,
		94,
		-1,
		82,
		74,
		60,
		77,
		78,
		75,
		66,
		58,
		63,
		60,
		73,
		80,
		70,
		187,
		-1,
		170,
		-1,
		-1,
		-1,
		150,
		165,
		136,
		113,
		86,
		81,
		74,
		68,
		68,
		84,
		86,
		97,
		65,
		61,
		62,
		66,
		65,
		82,
		85,
		-1,
		-1,
		170,
		184,
		176,
		158,
		162,
		163,
		-1,
		-1,
		90,
		81,
		72,
		75,
		78,
		81,
		71,
		68,
		73,
		78,
		66,
		75,
		93,
		88,
		-1,
		-1,
		-1,
		190,
		-1,
		202,
		-1,
		-1,
		177,
		161,
		108,
		90,
		86,
		84,
		77,
		86,
		81,
		76,
		86,
		96,
		88,
		68,
		81,
		103,
		93,
		121,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		179,
		171,
		166,
		172,
		174,
		165,
		123,
		120,
		-1,
		90,
		115,
		87,
		94,
		86,
		94,
		94,
		92,
		71,
		78,
		94,
		93,
		88,
		113,
		108,
		117,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		172,
		168,
		158,
		148,
		151,
		-1,
		-1,
		139,
		136,
		112,
		96,
		100,
		93,
		88,
		100,
		80,
		67,
		71,
		75,
		81,
		86,
		91,
		97,
		112,
		123,
		-1,
		197,
		261,
		254,
		222,
		230,
		261,
		-1,
		162,
		154,
		165,
		140,
		142,
		-1,
		-1,
		112,
		109,
		114,
		103,
		100,
		110,
		105,
		96,
		81,
		87,
		74,
		73,
		91,
		95,
		104,
		111,
		101,
		114,
		118,
		-1,
		211,
		237,
		216,
		219,
		243,
		257,
		-1,
		159,
		-1,
		-1,
		171,
		143,
		127,
		117,
		111,
		161,
		117,
		112,
		104,
		102,
		93,
		84,
		91,
		82,
		82,
		85,
		100,
		105,
		97,
		111,
		111,
		112,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		187,
		-1,
		154,
		-1,
		129,
		133,
		125,
		128,
		118,
		105,
		97,
		89,
		105,
		80,
		90,
		86,
		87,
		96,
		107,
		119,
		118,
		119,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		171,
		210,
		217,
		-1,
		196,
		-1,
		-1,
		-1,
		143,
		138,
		130,
		138,
		117,
		117,
		91,
		95,
		85,
		92,
		102,
		104,
		96,
		100,
		113,
		124,
		127,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		186,
		177,
		204,
		224,
		213,
		208,
		195,
		-1,
		-1,
		166,
		148,
		-1,
		-1,
		124,
		112,
		95,
		96,
		92,
		95,
		110,
		113,
		103,
		101,
		95,
		127,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		205,
		200,
		204,
		220,
		245,
		-1,
		184,
		-1,
		-1,
		169,
		-1,
		-1,
		154,
		117,
		106,
		97,
		103,
		100,
		111,
		121,
		109,
		110,
		100,
		110,
		123,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		200,
		180,
		-1,
		-1,
		152,
		150,
		139,
		-1,
		129,
		102,
		107,
		127,
		129,
		118,
		112,
		106,
		113,
		112,
		120,
		128,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		147,
		140,
		128,
		116,
		106,
		116,
		120,
		124,
		116,
		109,
		104,
		115,
		107,
		111,
		128,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		181,
		165,
		146,
		-1,
		116,
		129,
		160,
		128,
		133,
		128,
		110,
		121,
		110,
		113,
		127,
		122,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		197,
		199,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		153,
		149,
		-1,
		-1,
		117,
		142,
		131,
		139,
		134,
		114,
		120,
		123,
		112,
		116,
		128,
		-1,
		-1,
		194,
		195,
		200,
		-1,
		182,
		-1,
		200,
		-1,
		167,
		173,
		161,
		-1,
		-1,
		-1,
		155,
		118,
		139,
		149,
		143,
		141,
		132,
		118,
		125,
		123,
		119,
		130,
		-1,
		-1,
		-1,
		200,
		174,
		207,
		198,
		181,
		161,
		153,
		172,
		-1,
		142,
		-1,
		117,
		119,
		145,
		148,
		154,
		148,
		121,
		136,
		126,
		117,
		126,
		206,
		-1,
		176,
		209,
		173,
		167,
		143,
		147,
		163,
		-1,
		139,
		121,
		-1,
		149,
		139,
		170,
		155,
		136,
		123,
		130,
		130,
		123,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		163,
		148,
		139,
		-1,
		151,
		133,
		112,
		129,
		129,
		120,
		128,
		160,
		156,
		143,
		143,
		135,
		-1,
		279,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		167,
		140,
		128,
		134,
		130,
		116,
		122,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		136,
		171,
		-1,
		274,
		-1,
		208,
		-1,
		-1,
		190,
		170,
		162,
		151,
		140,
		138,
		129,
		120,
		142,
		158,
		142,
		140,
		143,
		144,
		-1,
		263,
		262,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		186,
		147,
		-1,
		149,
		129,
		-1,
		151,
		147,
		-1,
		-1,
		250,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		181,
		165,
		-1,
		140,
		140,
		-1,
		-1,
		-1,
		235,
		234,
		-1,
		203,
		206,
		-1,
		196,
		187,
		195,
		142,
		146,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		218,
		216,
		211,
		208,
		194,
		178,
		156,
		145,
		166,
		-1,
		-1,
		-1,
		216,
		208,
		201,
		-1,
		-1,
		203,
		186,
		167,
		165,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		193,
		-1,
		-1,
		199,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		227,
		-1,
		-1,
		-1,
		189,
		185,
		186,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		273,
		237,
		-1,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		179,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		214,
		-1,
		214,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		227,
		219,
		227,
		-1,
		199,
		201,
		-1,
		249,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		204,
		211,
		233,
		236,
		272,
		-1,
		223
	],
	[
		-1,
		177,
		166,
		177,
		185,
		158,
		165,
		-1,
		184,
		188,
		154,
		148,
		187,
		156,
		162,
		173,
		-1,
		-1,
		-1,
		177,
		176,
		144,
		142,
		151,
		156,
		163,
		-1,
		162,
		-1,
		198,
		177,
		188,
		193,
		137,
		134,
		154,
		173,
		155,
		147,
		213,
		167,
		138,
		132,
		150,
		140,
		149,
		141,
		-1,
		138,
		128,
		150,
		129,
		140,
		132,
		-1,
		-1,
		132,
		133,
		139,
		125,
		131,
		127,
		-1,
		137,
		121,
		-1,
		-1,
		122,
		123,
		107,
		110,
		118,
		116,
		129,
		121,
		116,
		-1,
		-1,
		113,
		109,
		116,
		103,
		99,
		116,
		129,
		111,
		125,
		124,
		-1,
		125,
		142,
		142,
		110,
		108,
		92,
		90,
		108,
		110,
		116,
		116,
		-1,
		136,
		137,
		132,
		137,
		132,
		108,
		95,
		95,
		105,
		98,
		117,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		119,
		136,
		128,
		118,
		129,
		126,
		98,
		95,
		93,
		90,
		106,
		104,
		114,
		-1,
		-1,
		229,
		198,
		227,
		185,
		166,
		-1,
		132,
		112,
		118,
		122,
		116,
		109,
		123,
		114,
		-1,
		84,
		83,
		111,
		97,
		108,
		189,
		-1,
		-1,
		187,
		179,
		162,
		165,
		142,
		138,
		127,
		126,
		118,
		104,
		100,
		106,
		109,
		109,
		115,
		78,
		88,
		92,
		90,
		115,
		-1,
		-1,
		131,
		-1,
		-1,
		186,
		169,
		-1,
		152,
		159,
		148,
		154,
		140,
		161,
		137,
		128,
		120,
		114,
		102,
		104,
		101,
		114,
		100,
		75,
		100,
		104,
		85,
		106,
		101,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		145,
		148,
		154,
		178,
		177,
		-1,
		149,
		137,
		138,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		97,
		79,
		77,
		107,
		82,
		104,
		96,
		101,
		106,
		100,
		109,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		182,
		-1,
		185,
		186,
		161,
		134,
		137,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		91,
		71,
		86,
		77,
		76,
		85,
		85,
		93,
		97,
		103,
		-1,
		244,
		-1,
		186,
		170,
		172,
		144,
		165,
		-1,
		202,
		186,
		178,
		163,
		163,
		-1,
		133,
		130,
		120,
		98,
		83,
		100,
		92,
		90,
		84,
		66,
		80,
		71,
		84,
		89,
		75,
		79,
		99,
		111,
		204,
		194,
		-1,
		176,
		181,
		140,
		148,
		167,
		205,
		169,
		-1,
		164,
		-1,
		135,
		148,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		77,
		62,
		59,
		77,
		75,
		68,
		72,
		88,
		-1,
		-1,
		189,
		193,
		182,
		133,
		152,
		176,
		213,
		162,
		151,
		150,
		-1,
		141,
		118,
		115,
		103,
		90,
		75,
		76,
		84,
		97,
		76,
		61,
		58,
		71,
		85,
		63,
		70,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		159,
		130,
		154,
		196,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		114,
		93,
		84,
		73,
		71,
		84,
		80,
		76,
		56,
		54,
		66,
		66,
		57,
		61,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		125,
		148,
		185,
		159,
		145,
		150,
		125,
		118,
		112,
		127,
		110,
		91,
		80,
		72,
		61,
		76,
		78,
		70,
		52,
		61,
		60,
		72,
		49,
		55,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		101,
		85,
		80,
		77,
		68,
		67,
		71,
		69,
		59,
		54,
		61,
		77,
		77,
		43,
		64,
		67,
		-1,
		-1,
		-1,
		189,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		87,
		83,
		72,
		76,
		75,
		81,
		69,
		63,
		64,
		46,
		56,
		-1,
		32,
		41,
		57,
		47,
		37,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		84,
		79,
		78,
		77,
		74,
		63,
		76,
		69,
		51,
		45,
		42,
		42,
		21,
		39,
		35,
		32,
		46,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		106,
		90,
		89,
		86,
		77,
		85,
		58,
		51,
		50,
		35,
		37,
		15,
		25,
		20,
		24,
		42,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		96,
		113,
		114,
		92,
		86,
		84,
		75,
		63,
		52,
		41,
		37,
		8,
		0,
		18,
		20,
		29,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		110,
		108,
		103,
		94,
		100,
		95,
		72,
		67,
		57,
		46,
		46,
		33,
		38,
		24,
		22,
		32,
		48,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		111,
		95,
		100,
		-1,
		92,
		-1,
		65,
		62,
		53,
		38,
		35,
		34,
		25,
		38,
		38,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		127,
		107,
		101,
		100,
		87,
		79,
		73,
		51,
		44,
		41,
		38,
		51,
		58,
		45,
		40,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		134,
		122,
		112,
		102,
		105,
		95,
		70,
		63,
		49,
		51,
		49,
		47,
		47,
		53,
		45,
		55,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		123,
		-1,
		-1,
		106,
		97,
		87,
		66,
		53,
		73,
		72,
		57,
		41,
		56,
		59,
		47,
		56,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		77,
		57,
		71,
		78,
		59,
		54,
		48,
		51,
		64,
		58,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		73,
		59,
		76,
		72,
		69,
		60,
		52,
		57,
		54,
		67,
		70,
		60,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		67,
		83,
		80,
		91,
		59,
		55,
		56,
		60,
		59,
		74,
		75,
		-1,
		-1,
		167,
		183,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		74,
		77,
		80,
		65,
		62,
		67,
		72,
		60,
		69,
		87,
		78,
		-1,
		-1,
		-1,
		187,
		-1,
		201,
		-1,
		-1,
		176,
		160,
		107,
		89,
		85,
		83,
		76,
		85,
		77,
		70,
		80,
		90,
		82,
		62,
		80,
		97,
		86,
		111,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		178,
		170,
		165,
		171,
		173,
		164,
		122,
		119,
		-1,
		89,
		114,
		83,
		90,
		82,
		88,
		88,
		86,
		67,
		77,
		93,
		92,
		87,
		103,
		98,
		107,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		138,
		135,
		111,
		92,
		98,
		91,
		86,
		99,
		79,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		105,
		113,
		-1,
		194,
		257,
		250,
		218,
		226,
		257,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		111,
		108,
		111,
		99,
		96,
		109,
		104,
		95,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		208,
		233,
		212,
		215,
		239,
		253,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		110,
		158,
		113,
		108,
		103,
		101,
		92,
		83,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		202,
		213,
		206,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		186,
		-1,
		153,
		-1,
		128,
		132,
		121,
		124,
		117,
		104,
		96,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		227,
		183,
		186,
		197,
		208,
		223,
		227,
		-1,
		170,
		209,
		216,
		-1,
		195,
		-1,
		-1,
		-1,
		142,
		134,
		126,
		137,
		116,
		116,
		90,
		94,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		185,
		176,
		203,
		223,
		212,
		207,
		194,
		-1,
		-1,
		165,
		144,
		-1,
		-1,
		123,
		111,
		94,
		95,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		204,
		196,
		200,
		216,
		241,
		-1,
		183,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		170,
		176,
		183,
		200,
		230,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		119,
		123,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		243,
		-1,
		195,
		171,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		183,
		186,
		-1,
		-1,
		196,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		190,
		191,
		196,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		154,
		117,
		138,
		148,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		118,
		144,
		147,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		169,
		154,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		159,
		155,
		142,
		142,
		134,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		135,
		170,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		142,
		143,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		180,
		184,
		150,
		144,
		183,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		173,
		172,
		140,
		138,
		147,
		152,
		159,
		-1,
		158,
		-1,
		194,
		173,
		184,
		189,
		133,
		130,
		150,
		169,
		151,
		143,
		209,
		163,
		134,
		128,
		146,
		136,
		145,
		137,
		-1,
		134,
		124,
		146,
		125,
		136,
		128,
		-1,
		-1,
		128,
		129,
		135,
		121,
		127,
		123,
		-1,
		133,
		117,
		-1,
		-1,
		118,
		119,
		103,
		106,
		114,
		112,
		125,
		117,
		112,
		-1,
		-1,
		109,
		105,
		112,
		99,
		95,
		112,
		125,
		107,
		121,
		120,
		-1,
		109,
		127,
		136,
		106,
		104,
		88,
		86,
		104,
		106,
		112,
		112,
		-1,
		118,
		119,
		114,
		122,
		127,
		104,
		91,
		91,
		101,
		94,
		113,
		101,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		101,
		118,
		110,
		100,
		115,
		108,
		94,
		91,
		89,
		86,
		102,
		100,
		110,
		-1,
		-1,
		211,
		180,
		209,
		167,
		148,
		-1,
		114,
		94,
		100,
		104,
		98,
		91,
		105,
		101,
		-1,
		80,
		79,
		107,
		93,
		104,
		171,
		-1,
		-1,
		169,
		161,
		144,
		147,
		124,
		120,
		109,
		108,
		100,
		86,
		82,
		88,
		91,
		91,
		97,
		74,
		84,
		88,
		86,
		105,
		-1,
		-1,
		119,
		-1,
		-1,
		168,
		151,
		-1,
		134,
		141,
		130,
		136,
		122,
		143,
		119,
		110,
		102,
		96,
		84,
		86,
		83,
		96,
		84,
		71,
		96,
		100,
		81,
		95,
		90,
		-1,
		118,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		136,
		160,
		159,
		-1,
		131,
		119,
		120,
		105,
		102,
		89,
		77,
		90,
		75,
		82,
		81,
		75,
		73,
		103,
		78,
		94,
		84,
		89,
		94,
		88,
		97,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		164,
		-1,
		167,
		168,
		143,
		116,
		119,
		106,
		97,
		84,
		73,
		84,
		73,
		70,
		78,
		67,
		82,
		73,
		72,
		73,
		73,
		81,
		85,
		91,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		184,
		168,
		160,
		145,
		145,
		-1,
		115,
		112,
		102,
		80,
		65,
		82,
		74,
		72,
		77,
		62,
		76,
		67,
		79,
		77,
		63,
		67,
		87,
		99,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		117,
		130,
		-1,
		86,
		82,
		64,
		65,
		60,
		75,
		73,
		58,
		55,
		73,
		70,
		56,
		60,
		76,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		100,
		97,
		85,
		72,
		57,
		58,
		66,
		79,
		58,
		57,
		54,
		66,
		73,
		51,
		62,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		96,
		75,
		66,
		55,
		53,
		66,
		63,
		72,
		52,
		50,
		61,
		54,
		45,
		53,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		109,
		92,
		73,
		62,
		54,
		43,
		59,
		67,
		66,
		48,
		57,
		55,
		60,
		41,
		47,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		83,
		67,
		62,
		59,
		52,
		50,
		59,
		65,
		55,
		50,
		57,
		65,
		65,
		31,
		49,
		52,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		69,
		65,
		56,
		60,
		57,
		64,
		53,
		59,
		60,
		42,
		66,
		-1,
		36,
		33,
		39,
		29,
		19,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		68,
		63,
		61,
		61,
		58,
		47,
		60,
		53,
		47,
		41,
		54,
		54,
		25,
		21,
		17,
		14,
		28,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		89,
		73,
		73,
		70,
		61,
		69,
		42,
		35,
		46,
		31,
		49,
		22,
		12,
		7,
		6,
		24,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		80,
		96,
		97,
		75,
		70,
		68,
		59,
		47,
		36,
		39,
		31,
		24,
		16,
		0,
		2,
		11,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		94,
		92,
		86,
		77,
		83,
		79,
		56,
		51,
		41,
		30,
		30,
		25,
		22,
		8,
		6,
		14,
		30,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		94,
		78,
		83,
		-1,
		76,
		-1,
		49,
		46,
		37,
		22,
		19,
		18,
		9,
		22,
		20,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		110,
		90,
		84,
		83,
		71,
		63,
		57,
		35,
		28,
		25,
		22,
		35,
		42,
		29,
		22,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		118,
		106,
		96,
		86,
		89,
		79,
		54,
		47,
		33,
		35,
		33,
		31,
		31,
		35,
		27,
		37,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		107,
		-1,
		-1,
		90,
		81,
		71,
		50,
		37,
		57,
		56,
		41,
		25,
		40,
		41,
		29,
		38,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		158,
		103,
		92,
		87,
		91,
		89,
		-1,
		63,
		61,
		41,
		55,
		62,
		43,
		38,
		32,
		35,
		46,
		40,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		80,
		73,
		77,
		-1,
		65,
		57,
		43,
		60,
		56,
		53,
		44,
		36,
		41,
		38,
		51,
		52,
		42,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		133,
		148,
		119,
		96,
		69,
		64,
		57,
		51,
		51,
		67,
		64,
		75,
		43,
		39,
		40,
		44,
		43,
		56,
		57,
		-1,
		-1,
		149,
		166,
		159,
		141,
		145,
		146,
		-1,
		-1,
		73,
		64,
		55,
		58,
		61,
		64,
		49,
		46,
		51,
		56,
		44,
		53,
		71,
		60,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		160,
		144,
		91,
		73,
		69,
		67,
		60,
		69,
		61,
		54,
		64,
		74,
		66,
		46,
		64,
		81,
		68,
		93,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		162,
		154,
		149,
		155,
		157,
		148,
		106,
		103,
		-1,
		73,
		98,
		67,
		74,
		66,
		72,
		72,
		70,
		51,
		61,
		77,
		76,
		71,
		85,
		80,
		89,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		155,
		151,
		141,
		131,
		134,
		-1,
		-1,
		122,
		119,
		95,
		76,
		82,
		75,
		70,
		83,
		63,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		87,
		95,
		-1,
		176,
		241,
		234,
		202,
		210,
		241,
		-1,
		145,
		137,
		148,
		123,
		125,
		-1,
		-1,
		95,
		92,
		95,
		83,
		80,
		93,
		88,
		79,
		64,
		70,
		57,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		190,
		217,
		196,
		199,
		223,
		237,
		-1,
		142,
		-1,
		-1,
		154,
		126,
		110,
		100,
		94,
		142,
		97,
		92,
		87,
		85,
		76,
		67,
		74,
		65,
		65,
		68,
		83,
		88,
		80,
		94,
		94,
		95,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		170,
		-1,
		137,
		-1,
		112,
		116,
		105,
		108,
		101,
		88,
		80,
		72,
		88,
		63,
		73,
		69,
		70,
		79,
		90,
		102,
		101,
		102,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		154,
		193,
		200,
		-1,
		179,
		-1,
		-1,
		-1,
		126,
		118,
		110,
		121,
		100,
		100,
		74,
		78,
		68,
		75,
		85,
		87,
		79,
		83,
		96,
		107,
		110,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		169,
		160,
		187,
		207,
		196,
		191,
		178,
		-1,
		-1,
		149,
		128,
		-1,
		-1,
		107,
		95,
		78,
		79,
		75,
		78,
		93,
		96,
		86,
		84,
		78,
		110,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		188,
		180,
		184,
		200,
		225,
		-1,
		167,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		100,
		89,
		80,
		86,
		83,
		94,
		104,
		92,
		93,
		83,
		93,
		106,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		90,
		110,
		112,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		99,
		103,
		107,
		99,
		92,
		87,
		98,
		90,
		94,
		111,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		143,
		111,
		116,
		111,
		93,
		104,
		93,
		96,
		110,
		105,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		180,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		125,
		114,
		122,
		117,
		97,
		103,
		106,
		95,
		99,
		111,
		-1,
		-1,
		174,
		175,
		180,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		138,
		101,
		122,
		132,
		126,
		124,
		115,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		102,
		128,
		131,
		137,
		131,
		104,
		119,
		109,
		100,
		109,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		132,
		122,
		153,
		138,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		111,
		143,
		139,
		126,
		126,
		118,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		113,
		110,
		122,
		118,
		138,
		119,
		154,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		125,
		123,
		126,
		127,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		134,
		130,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		183,
		187,
		153,
		147,
		186,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		176,
		175,
		143,
		141,
		150,
		155,
		162,
		-1,
		161,
		-1,
		197,
		176,
		187,
		192,
		136,
		133,
		153,
		172,
		154,
		146,
		212,
		166,
		137,
		131,
		149,
		139,
		148,
		140,
		-1,
		137,
		127,
		149,
		128,
		139,
		131,
		-1,
		-1,
		131,
		132,
		138,
		124,
		130,
		126,
		-1,
		136,
		120,
		-1,
		-1,
		121,
		122,
		106,
		109,
		117,
		115,
		128,
		120,
		115,
		-1,
		-1,
		112,
		108,
		115,
		102,
		98,
		115,
		128,
		110,
		124,
		123,
		-1,
		112,
		130,
		139,
		109,
		107,
		91,
		89,
		107,
		109,
		115,
		115,
		-1,
		121,
		122,
		117,
		125,
		130,
		107,
		94,
		94,
		104,
		97,
		116,
		104,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		121,
		104,
		121,
		113,
		103,
		118,
		111,
		97,
		94,
		92,
		89,
		105,
		103,
		113,
		-1,
		-1,
		214,
		183,
		212,
		170,
		151,
		-1,
		117,
		97,
		103,
		107,
		101,
		94,
		108,
		104,
		-1,
		83,
		82,
		110,
		96,
		107,
		174,
		-1,
		-1,
		172,
		164,
		147,
		150,
		127,
		123,
		112,
		111,
		103,
		89,
		85,
		91,
		94,
		94,
		100,
		77,
		87,
		91,
		89,
		103,
		-1,
		-1,
		117,
		-1,
		-1,
		171,
		154,
		-1,
		137,
		144,
		133,
		139,
		125,
		146,
		122,
		113,
		105,
		99,
		87,
		89,
		86,
		99,
		87,
		74,
		99,
		103,
		84,
		93,
		88,
		-1,
		116,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		130,
		133,
		139,
		163,
		162,
		-1,
		134,
		122,
		123,
		108,
		105,
		92,
		80,
		93,
		78,
		85,
		84,
		78,
		76,
		106,
		81,
		92,
		82,
		87,
		92,
		86,
		95,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		167,
		-1,
		170,
		171,
		146,
		119,
		122,
		109,
		100,
		87,
		76,
		87,
		76,
		73,
		81,
		70,
		85,
		76,
		75,
		71,
		71,
		79,
		83,
		89,
		-1,
		229,
		-1,
		171,
		155,
		157,
		129,
		150,
		-1,
		187,
		171,
		163,
		148,
		148,
		-1,
		118,
		115,
		105,
		83,
		68,
		85,
		77,
		75,
		80,
		65,
		79,
		70,
		77,
		75,
		61,
		65,
		85,
		97,
		189,
		179,
		-1,
		161,
		166,
		125,
		133,
		152,
		190,
		154,
		-1,
		149,
		-1,
		120,
		133,
		-1,
		89,
		85,
		67,
		68,
		63,
		78,
		76,
		61,
		58,
		73,
		68,
		54,
		58,
		74,
		-1,
		-1,
		174,
		178,
		167,
		118,
		137,
		161,
		198,
		147,
		136,
		135,
		-1,
		126,
		103,
		100,
		88,
		75,
		60,
		61,
		69,
		82,
		61,
		60,
		57,
		64,
		71,
		49,
		60,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		144,
		115,
		139,
		181,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		99,
		78,
		69,
		58,
		56,
		69,
		66,
		75,
		55,
		53,
		59,
		52,
		43,
		51,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		144,
		130,
		135,
		110,
		103,
		97,
		112,
		95,
		76,
		65,
		57,
		46,
		62,
		70,
		69,
		51,
		60,
		53,
		58,
		39,
		45,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		135,
		148,
		-1,
		102,
		-1,
		91,
		86,
		70,
		65,
		62,
		55,
		53,
		62,
		68,
		58,
		53,
		60,
		63,
		63,
		29,
		47,
		50,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		118,
		119,
		-1,
		96,
		90,
		87,
		72,
		68,
		59,
		63,
		60,
		67,
		56,
		62,
		63,
		45,
		69,
		-1,
		37,
		31,
		37,
		27,
		17,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		83,
		65,
		71,
		66,
		64,
		64,
		61,
		50,
		63,
		56,
		50,
		44,
		57,
		52,
		28,
		19,
		15,
		12,
		26,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		78,
		76,
		92,
		76,
		76,
		73,
		64,
		72,
		45,
		38,
		49,
		34,
		52,
		25,
		15,
		5,
		4,
		22,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		88,
		83,
		99,
		100,
		78,
		73,
		71,
		62,
		50,
		39,
		42,
		34,
		27,
		19,
		3,
		0,
		9,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		97,
		95,
		89,
		80,
		86,
		82,
		59,
		54,
		44,
		33,
		33,
		28,
		25,
		11,
		9,
		12,
		28,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		97,
		81,
		86,
		-1,
		79,
		-1,
		52,
		49,
		40,
		25,
		22,
		21,
		12,
		25,
		18,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		113,
		93,
		87,
		86,
		74,
		66,
		60,
		38,
		31,
		28,
		25,
		38,
		45,
		32,
		20,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		121,
		109,
		99,
		89,
		92,
		82,
		57,
		50,
		36,
		38,
		36,
		34,
		34,
		33,
		25,
		35,
		-1,
		-1,
		131,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		110,
		-1,
		-1,
		93,
		84,
		74,
		53,
		40,
		60,
		59,
		44,
		28,
		43,
		39,
		27,
		36,
		-1,
		134,
		121,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		161,
		106,
		95,
		90,
		94,
		92,
		-1,
		66,
		64,
		44,
		58,
		65,
		46,
		41,
		35,
		38,
		44,
		38,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		118,
		112,
		83,
		76,
		80,
		-1,
		68,
		60,
		46,
		63,
		59,
		56,
		47,
		39,
		44,
		41,
		54,
		50,
		40,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		136,
		151,
		122,
		99,
		72,
		67,
		60,
		54,
		54,
		70,
		67,
		78,
		46,
		42,
		43,
		47,
		46,
		54,
		55,
		-1,
		-1,
		152,
		169,
		162,
		144,
		148,
		149,
		-1,
		-1,
		76,
		67,
		58,
		61,
		64,
		67,
		52,
		49,
		54,
		59,
		47,
		56,
		73,
		58,
		-1,
		-1,
		-1,
		172,
		-1,
		187,
		-1,
		-1,
		163,
		147,
		94,
		76,
		72,
		70,
		63,
		72,
		64,
		57,
		67,
		77,
		69,
		49,
		67,
		84,
		66,
		91,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		165,
		157,
		152,
		158,
		160,
		151,
		109,
		106,
		-1,
		76,
		101,
		70,
		77,
		69,
		75,
		75,
		73,
		54,
		64,
		80,
		78,
		74,
		83,
		78,
		87,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		158,
		154,
		144,
		134,
		137,
		-1,
		-1,
		125,
		122,
		98,
		79,
		85,
		78,
		73,
		86,
		66,
		53,
		57,
		61,
		67,
		72,
		77,
		83,
		85,
		93,
		-1,
		179,
		244,
		237,
		205,
		213,
		244,
		-1,
		148,
		140,
		151,
		126,
		128,
		-1,
		-1,
		98,
		95,
		98,
		86,
		83,
		96,
		91,
		82,
		67,
		73,
		60,
		59,
		77,
		81,
		90,
		97,
		87,
		100,
		104,
		-1,
		193,
		220,
		199,
		202,
		226,
		240,
		-1,
		145,
		-1,
		-1,
		157,
		129,
		113,
		103,
		97,
		145,
		100,
		95,
		90,
		88,
		79,
		70,
		77,
		68,
		68,
		71,
		86,
		91,
		83,
		97,
		97,
		98,
		-1,
		189,
		200,
		193,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		173,
		-1,
		140,
		-1,
		115,
		119,
		108,
		111,
		104,
		91,
		83,
		75,
		91,
		66,
		76,
		72,
		73,
		82,
		93,
		105,
		104,
		105,
		214,
		170,
		173,
		184,
		195,
		210,
		214,
		-1,
		157,
		196,
		203,
		-1,
		182,
		-1,
		-1,
		-1,
		129,
		121,
		113,
		124,
		103,
		103,
		77,
		81,
		71,
		78,
		88,
		90,
		82,
		86,
		99,
		110,
		113,
		210,
		201,
		214,
		159,
		159,
		180,
		189,
		210,
		172,
		163,
		190,
		210,
		199,
		194,
		181,
		-1,
		-1,
		152,
		131,
		-1,
		-1,
		110,
		98,
		81,
		82,
		78,
		81,
		96,
		99,
		89,
		87,
		81,
		113,
		-1,
		203,
		202,
		191,
		188,
		164,
		155,
		150,
		177,
		-1,
		-1,
		172,
		191,
		183,
		187,
		203,
		228,
		-1,
		170,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		103,
		92,
		83,
		89,
		86,
		97,
		107,
		95,
		96,
		86,
		96,
		109,
		187,
		184,
		172,
		170,
		193,
		158,
		146,
		-1,
		159,
		157,
		163,
		170,
		187,
		217,
		-1,
		-1,
		186,
		166,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		88,
		93,
		113,
		115,
		104,
		98,
		92,
		99,
		98,
		106,
		114,
		196,
		210,
		199,
		195,
		194,
		202,
		151,
		144,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		172,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		102,
		106,
		110,
		102,
		95,
		90,
		101,
		93,
		97,
		114,
		-1,
		230,
		-1,
		182,
		158,
		172,
		187,
		195,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		146,
		114,
		119,
		114,
		96,
		107,
		96,
		99,
		113,
		108,
		-1,
		-1,
		170,
		173,
		-1,
		-1,
		183,
		185,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		103,
		128,
		117,
		125,
		120,
		100,
		106,
		109,
		98,
		102,
		114,
		-1,
		-1,
		177,
		178,
		183,
		-1,
		168,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		141,
		104,
		125,
		135,
		129,
		127,
		118,
		104,
		111,
		109,
		105,
		116,
		-1,
		-1,
		-1,
		186,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		103,
		105,
		131,
		134,
		140,
		134,
		107,
		122,
		112,
		103,
		112,
		192,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		156,
		141,
		122,
		109,
		116,
		116,
		109,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		146,
		142,
		129,
		129,
		121,
		-1,
		265,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		125,
		121,
		141,
		122,
		157,
		-1,
		260,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		128,
		126,
		129,
		130,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		137,
		133,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		186,
		175,
		186,
		194,
		167,
		174,
		-1,
		193,
		197,
		163,
		157,
		196,
		165,
		171,
		182,
		-1,
		-1,
		-1,
		186,
		185,
		153,
		151,
		160,
		165,
		172,
		-1,
		171,
		-1,
		207,
		186,
		197,
		202,
		146,
		143,
		163,
		182,
		164,
		156,
		222,
		176,
		147,
		141,
		159,
		149,
		158,
		150,
		-1,
		147,
		137,
		159,
		138,
		149,
		141,
		-1,
		-1,
		141,
		142,
		148,
		134,
		140,
		136,
		-1,
		146,
		130,
		-1,
		-1,
		131,
		132,
		116,
		119,
		127,
		125,
		138,
		130,
		125,
		-1,
		-1,
		122,
		118,
		125,
		112,
		108,
		125,
		138,
		120,
		134,
		133,
		-1,
		122,
		140,
		149,
		119,
		117,
		101,
		99,
		117,
		119,
		125,
		125,
		-1,
		131,
		132,
		127,
		135,
		140,
		117,
		104,
		104,
		114,
		107,
		126,
		114,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		114,
		131,
		123,
		113,
		128,
		121,
		107,
		104,
		102,
		99,
		115,
		113,
		123,
		-1,
		-1,
		224,
		193,
		222,
		180,
		161,
		-1,
		127,
		107,
		113,
		117,
		111,
		104,
		118,
		114,
		-1,
		93,
		92,
		120,
		106,
		117,
		184,
		-1,
		-1,
		182,
		174,
		157,
		160,
		137,
		133,
		122,
		121,
		113,
		99,
		95,
		101,
		104,
		104,
		110,
		87,
		97,
		101,
		99,
		106,
		-1,
		-1,
		120,
		-1,
		-1,
		181,
		164,
		-1,
		147,
		154,
		143,
		149,
		135,
		156,
		132,
		123,
		115,
		109,
		97,
		99,
		96,
		109,
		97,
		84,
		109,
		113,
		94,
		96,
		91,
		-1,
		119,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		140,
		143,
		149,
		173,
		172,
		-1,
		144,
		132,
		133,
		118,
		115,
		102,
		90,
		103,
		88,
		95,
		94,
		88,
		86,
		116,
		91,
		95,
		85,
		90,
		95,
		89,
		98,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		177,
		-1,
		180,
		181,
		156,
		129,
		132,
		119,
		110,
		97,
		86,
		97,
		86,
		83,
		91,
		80,
		95,
		86,
		85,
		74,
		74,
		82,
		86,
		92,
		-1,
		239,
		-1,
		181,
		165,
		167,
		139,
		160,
		-1,
		197,
		181,
		173,
		158,
		158,
		-1,
		128,
		125,
		115,
		93,
		78,
		95,
		87,
		85,
		90,
		75,
		89,
		80,
		80,
		78,
		64,
		68,
		88,
		100,
		199,
		189,
		-1,
		171,
		176,
		135,
		143,
		162,
		200,
		164,
		-1,
		159,
		-1,
		130,
		143,
		-1,
		99,
		95,
		77,
		78,
		73,
		88,
		86,
		71,
		68,
		76,
		71,
		57,
		61,
		77,
		-1,
		-1,
		184,
		188,
		177,
		128,
		147,
		171,
		208,
		157,
		146,
		145,
		-1,
		136,
		113,
		110,
		98,
		85,
		70,
		71,
		79,
		92,
		71,
		70,
		67,
		67,
		74,
		52,
		63,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		154,
		125,
		149,
		191,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		109,
		88,
		79,
		68,
		66,
		79,
		76,
		85,
		65,
		63,
		62,
		55,
		46,
		54,
		-1,
		-1,
		-1,
		184,
		173,
		174,
		120,
		143,
		180,
		154,
		140,
		145,
		120,
		113,
		107,
		122,
		105,
		86,
		75,
		67,
		56,
		72,
		80,
		79,
		61,
		70,
		56,
		61,
		42,
		48,
		-1,
		-1,
		191,
		181,
		165,
		167,
		164,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		96,
		80,
		75,
		72,
		65,
		63,
		72,
		78,
		68,
		63,
		70,
		66,
		66,
		32,
		50,
		53,
		-1,
		-1,
		-1,
		184,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		82,
		78,
		69,
		73,
		70,
		77,
		66,
		72,
		73,
		55,
		79,
		-1,
		40,
		34,
		40,
		30,
		20,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		81,
		76,
		74,
		74,
		71,
		60,
		73,
		66,
		60,
		54,
		67,
		55,
		38,
		22,
		18,
		15,
		29,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		102,
		86,
		86,
		83,
		74,
		82,
		55,
		48,
		59,
		44,
		62,
		35,
		25,
		15,
		7,
		25,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		93,
		109,
		110,
		88,
		83,
		81,
		72,
		60,
		49,
		52,
		44,
		37,
		29,
		13,
		10,
		0,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		107,
		105,
		99,
		90,
		96,
		92,
		69,
		64,
		54,
		43,
		43,
		38,
		35,
		21,
		19,
		3,
		19,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		107,
		91,
		96,
		-1,
		89,
		-1,
		62,
		59,
		50,
		35,
		32,
		31,
		22,
		31,
		9,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		123,
		103,
		97,
		96,
		84,
		76,
		70,
		48,
		41,
		38,
		35,
		48,
		55,
		23,
		11,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		131,
		119,
		109,
		99,
		102,
		92,
		67,
		60,
		46,
		48,
		46,
		44,
		39,
		24,
		16,
		26,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		120,
		-1,
		-1,
		103,
		94,
		84,
		63,
		50,
		70,
		69,
		54,
		38,
		40,
		30,
		18,
		27,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		171,
		116,
		105,
		100,
		104,
		102,
		-1,
		76,
		74,
		54,
		68,
		75,
		56,
		50,
		44,
		35,
		35,
		29,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		93,
		86,
		90,
		-1,
		78,
		70,
		56,
		73,
		68,
		65,
		56,
		46,
		46,
		32,
		45,
		41,
		31,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		146,
		161,
		132,
		109,
		82,
		77,
		70,
		64,
		64,
		80,
		76,
		87,
		53,
		49,
		45,
		38,
		37,
		45,
		46,
		-1,
		-1,
		162,
		179,
		172,
		154,
		158,
		159,
		-1,
		-1,
		86,
		77,
		68,
		71,
		74,
		77,
		59,
		56,
		61,
		55,
		48,
		47,
		64,
		49,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		173,
		157,
		104,
		86,
		82,
		80,
		73,
		82,
		71,
		64,
		74,
		73,
		65,
		45,
		63,
		75,
		57,
		82,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		169,
		160,
		119,
		116,
		-1,
		86,
		111,
		77,
		84,
		76,
		80,
		77,
		69,
		50,
		64,
		80,
		69,
		68,
		74,
		69,
		78,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		135,
		132,
		108,
		86,
		89,
		82,
		77,
		87,
		67,
		54,
		57,
		61,
		67,
		66,
		71,
		77,
		76,
		84,
		-1,
		189,
		251,
		244,
		212,
		220,
		251,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		108,
		104,
		105,
		93,
		90,
		97,
		92,
		83,
		68,
		74,
		61,
		59,
		77,
		81,
		84,
		90,
		79,
		92,
		96,
		-1,
		203,
		227,
		206,
		209,
		233,
		247,
		-1,
		154,
		-1,
		-1,
		166,
		138,
		122,
		112,
		107,
		152,
		107,
		102,
		91,
		89,
		80,
		71,
		78,
		69,
		68,
		71,
		87,
		92,
		84,
		89,
		89,
		90,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		149,
		-1,
		125,
		129,
		115,
		118,
		105,
		92,
		84,
		76,
		92,
		67,
		76,
		72,
		74,
		83,
		94,
		106,
		96,
		97,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		166,
		205,
		204,
		-1,
		188,
		-1,
		-1,
		-1,
		139,
		128,
		120,
		125,
		104,
		104,
		78,
		82,
		72,
		79,
		88,
		90,
		83,
		87,
		100,
		106,
		105,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		181,
		172,
		199,
		211,
		200,
		195,
		182,
		-1,
		-1,
		162,
		138,
		-1,
		-1,
		111,
		99,
		82,
		83,
		79,
		82,
		97,
		99,
		90,
		88,
		82,
		111,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		200,
		190,
		194,
		210,
		235,
		-1,
		171,
		-1,
		-1,
		156,
		-1,
		-1,
		141,
		104,
		93,
		84,
		90,
		87,
		98,
		108,
		96,
		97,
		87,
		97,
		110,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		166,
		164,
		170,
		177,
		194,
		224,
		-1,
		-1,
		187,
		167,
		-1,
		-1,
		139,
		137,
		126,
		-1,
		116,
		89,
		94,
		114,
		116,
		105,
		99,
		93,
		100,
		99,
		107,
		115,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		177,
		173,
		-1,
		-1,
		134,
		127,
		115,
		103,
		93,
		103,
		107,
		111,
		103,
		96,
		91,
		102,
		94,
		98,
		115,
		-1,
		237,
		-1,
		189,
		165,
		179,
		194,
		202,
		-1,
		-1,
		-1,
		194,
		180,
		173,
		161,
		159,
		-1,
		168,
		152,
		133,
		-1,
		103,
		116,
		147,
		115,
		120,
		115,
		97,
		108,
		97,
		100,
		114,
		109,
		-1,
		-1,
		177,
		180,
		-1,
		-1,
		184,
		186,
		-1,
		185,
		174,
		159,
		151,
		-1,
		-1,
		140,
		136,
		-1,
		-1,
		104,
		129,
		118,
		126,
		121,
		101,
		107,
		110,
		99,
		103,
		115,
		-1,
		-1,
		184,
		185,
		190,
		-1,
		169,
		-1,
		187,
		-1,
		154,
		160,
		148,
		-1,
		-1,
		-1,
		142,
		105,
		126,
		136,
		130,
		128,
		119,
		105,
		112,
		110,
		106,
		117,
		-1,
		-1,
		-1,
		187,
		161,
		194,
		185,
		168,
		148,
		140,
		159,
		-1,
		129,
		-1,
		104,
		106,
		132,
		135,
		141,
		135,
		108,
		123,
		113,
		104,
		113,
		193,
		-1,
		163,
		196,
		160,
		154,
		130,
		134,
		150,
		-1,
		126,
		108,
		-1,
		136,
		126,
		157,
		142,
		123,
		110,
		117,
		117,
		110,
		-1,
		-1,
		-1,
		165,
		164,
		156,
		150,
		150,
		135,
		126,
		-1,
		138,
		120,
		99,
		116,
		116,
		107,
		115,
		147,
		143,
		130,
		130,
		122,
		-1,
		266,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		159,
		154,
		127,
		115,
		121,
		117,
		103,
		109,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		123,
		158,
		-1,
		261,
		-1,
		195,
		-1,
		-1,
		177,
		157,
		149,
		138,
		127,
		125,
		116,
		107,
		129,
		145,
		129,
		127,
		130,
		131,
		-1,
		250,
		249,
		-1,
		196,
		188,
		174,
		-1,
		167,
		-1,
		173,
		134,
		-1,
		136,
		116,
		-1,
		138,
		134,
		-1,
		-1,
		237,
		212,
		-1,
		-1,
		-1,
		197,
		177,
		168,
		152,
		-1,
		127,
		127,
		-1,
		-1,
		-1,
		222,
		221,
		-1,
		190,
		193,
		-1,
		183,
		174,
		182,
		129,
		133,
		-1,
		-1,
		-1,
		231,
		212,
		206,
		205,
		203,
		198,
		195,
		181,
		165,
		143,
		132,
		153,
		-1,
		-1,
		-1,
		203,
		195,
		188,
		-1,
		-1,
		190,
		173,
		154,
		152,
		-1,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		180,
		-1,
		-1,
		186,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		214,
		-1,
		-1,
		-1,
		176,
		172,
		173,
		-1,
		-1,
		-1,
		-1,
		236,
		237,
		260,
		224,
		-1,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		239,
		237,
		-1,
		-1,
		-1,
		196,
		180,
		-1,
		166,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		201,
		-1,
		201,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		214,
		206,
		214,
		-1,
		186,
		188,
		-1,
		236,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		191,
		198,
		220,
		223,
		259,
		-1,
		210
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		250,
		239,
		250,
		258,
		231,
		238,
		-1,
		259,
		261,
		227,
		221,
		260,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		250,
		249,
		219,
		217,
		226,
		231,
		238,
		-1,
		261,
		-1,
		271,
		250,
		261,
		266,
		212,
		209,
		229,
		248,
		254,
		246,
		286,
		242,
		213,
		207,
		225,
		230,
		248,
		240,
		-1,
		213,
		203,
		225,
		229,
		241,
		224,
		-1,
		-1,
		207,
		208,
		214,
		226,
		231,
		236,
		-1,
		259,
		243,
		-1,
		-1,
		197,
		210,
		206,
		209,
		217,
		233,
		251,
		243,
		238,
		-1,
		-1,
		198,
		202,
		215,
		216,
		214,
		238,
		251,
		233,
		247,
		246,
		-1,
		186,
		204,
		213,
		222,
		228,
		214,
		212,
		230,
		232,
		238,
		241,
		-1,
		178,
		180,
		209,
		215,
		227,
		230,
		217,
		217,
		227,
		220,
		239,
		230,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		175,
		183,
		209,
		208,
		204,
		222,
		227,
		220,
		217,
		215,
		212,
		228,
		229,
		239,
		-1,
		-1,
		231,
		200,
		235,
		192,
		177,
		-1,
		171,
		190,
		196,
		200,
		205,
		210,
		224,
		220,
		-1,
		206,
		205,
		236,
		222,
		233,
		191,
		-1,
		-1,
		189,
		181,
		166,
		169,
		166,
		166,
		196,
		195,
		200,
		202,
		201,
		207,
		210,
		210,
		216,
		200,
		210,
		214,
		225,
		240,
		-1,
		-1,
		295,
		-1,
		-1,
		188,
		171,
		-1,
		154,
		161,
		161,
		178,
		168,
		189,
		204,
		208,
		216,
		215,
		203,
		205,
		202,
		215,
		203,
		197,
		222,
		226,
		220,
		241,
		236,
		-1,
		294,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		156,
		180,
		190,
		-1,
		211,
		209,
		233,
		224,
		221,
		208,
		196,
		209,
		194,
		201,
		200,
		204,
		206,
		239,
		217,
		239,
		236,
		265,
		270,
		264,
		273,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		184,
		-1,
		198,
		211,
		215,
		213,
		216,
		225,
		216,
		203,
		192,
		203,
		192,
		189,
		197,
		206,
		217,
		212,
		211,
		229,
		244,
		257,
		261,
		267,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		204,
		199,
		219,
		217,
		208,
		-1,
		211,
		214,
		221,
		199,
		184,
		201,
		193,
		191,
		196,
		201,
		215,
		206,
		224,
		231,
		239,
		243,
		263,
		275,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		242,
		214,
		-1,
		209,
		-1,
		201,
		226,
		-1,
		205,
		201,
		183,
		184,
		179,
		194,
		200,
		197,
		194,
		212,
		215,
		232,
		236,
		252,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		207,
		196,
		195,
		-1,
		186,
		216,
		213,
		199,
		186,
		176,
		177,
		185,
		198,
		177,
		196,
		199,
		221,
		249,
		227,
		239,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		225,
		218,
		206,
		171,
		171,
		165,
		-1,
		206,
		189,
		185,
		174,
		172,
		185,
		180,
		196,
		200,
		199,
		218,
		230,
		221,
		241,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		204,
		190,
		195,
		170,
		163,
		157,
		209,
		206,
		173,
		181,
		173,
		162,
		176,
		184,
		188,
		197,
		206,
		212,
		236,
		236,
		242,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		195,
		192,
		-1,
		162,
		-1,
		151,
		159,
		158,
		164,
		176,
		162,
		167,
		178,
		190,
		203,
		199,
		206,
		241,
		241,
		226,
		246,
		249,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		162,
		163,
		-1,
		156,
		150,
		156,
		155,
		162,
		159,
		159,
		173,
		181,
		177,
		193,
		199,
		191,
		227,
		-1,
		234,
		228,
		236,
		226,
		214,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		147,
		140,
		-1,
		143,
		143,
		150,
		159,
		164,
		169,
		177,
		172,
		185,
		190,
		196,
		201,
		219,
		223,
		227,
		216,
		212,
		209,
		223,
		-1,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		156,
		148,
		138,
		132,
		138,
		156,
		154,
		174,
		166,
		180,
		180,
		186,
		194,
		179,
		182,
		198,
		196,
		214,
		222,
		214,
		208,
		207,
		219,
		-1,
		73,
		59,
		56,
		-1,
		-1,
		150,
		-1,
		114,
		138,
		154,
		-1,
		172,
		151,
		174,
		152,
		166,
		162,
		200,
		201,
		179,
		184,
		192,
		202,
		204,
		193,
		204,
		196,
		218,
		218,
		202,
		203,
		212,
		-1,
		0,
		66,
		60,
		72,
		78,
		139,
		111,
		120,
		141,
		-1,
		-1,
		216,
		-1,
		150,
		167,
		176,
		174,
		190,
		181,
		187,
		203,
		206,
		208,
		198,
		187,
		193,
		190,
		212,
		198,
		196,
		215,
		231,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		105,
		105,
		107,
		-1,
		158,
		-1,
		194,
		184,
		168,
		153,
		186,
		-1,
		198,
		182,
		187,
		-1,
		233,
		-1,
		206,
		208,
		202,
		187,
		184,
		195,
		193,
		204,
		221,
		-1,
		139,
		124,
		117,
		107,
		134,
		105,
		-1,
		161,
		-1,
		-1,
		181,
		175,
		175,
		159,
		162,
		214,
		194,
		188,
		187,
		228,
		228,
		214,
		200,
		193,
		190,
		187,
		200,
		220,
		211,
		223,
		-1,
		-1,
		-1,
		144,
		151,
		148,
		115,
		127,
		-1,
		-1,
		243,
		198,
		184,
		-1,
		168,
		231,
		219,
		209,
		199,
		233,
		234,
		219,
		212,
		198,
		200,
		198,
		196,
		201,
		222,
		223,
		236,
		-1,
		-1,
		148,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		190,
		206,
		198,
		169,
		220,
		-1,
		-1,
		211,
		209,
		219,
		215,
		202,
		222,
		225,
		211,
		195,
		210,
		222,
		230,
		235,
		-1,
		151,
		138,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		201,
		222,
		247,
		214,
		-1,
		219,
		220,
		206,
		220,
		227,
		213,
		208,
		202,
		205,
		223,
		240,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		180,
		194,
		215,
		221,
		233,
		-1,
		228,
		222,
		208,
		225,
		226,
		223,
		214,
		206,
		211,
		208,
		221,
		235,
		239,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		198,
		213,
		275,
		252,
		225,
		229,
		222,
		216,
		216,
		232,
		234,
		245,
		213,
		209,
		210,
		214,
		213,
		230,
		240,
		-1,
		-1,
		162,
		179,
		214,
		206,
		210,
		302,
		-1,
		-1,
		238,
		229,
		220,
		223,
		226,
		229,
		219,
		216,
		221,
		226,
		214,
		223,
		241,
		245,
		-1,
		-1,
		-1,
		182,
		-1,
		197,
		-1,
		-1,
		225,
		309,
		256,
		238,
		234,
		232,
		225,
		234,
		229,
		224,
		234,
		243,
		235,
		216,
		227,
		250,
		239,
		277,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		211,
		186,
		201,
		247,
		245,
		243,
		271,
		268,
		-1,
		238,
		263,
		235,
		242,
		234,
		242,
		242,
		239,
		217,
		224,
		240,
		239,
		234,
		269,
		261,
		267,
		-1,
		-1,
		301,
		290,
		279,
		285,
		-1,
		217,
		203,
		233,
		223,
		229,
		-1,
		-1,
		276,
		273,
		260,
		244,
		248,
		241,
		236,
		246,
		226,
		213,
		217,
		221,
		227,
		232,
		237,
		243,
		258,
		273,
		-1,
		196,
		277,
		270,
		253,
		261,
		292,
		-1,
		220,
		229,
		210,
		215,
		223,
		-1,
		-1,
		249,
		245,
		250,
		251,
		248,
		256,
		251,
		242,
		227,
		233,
		220,
		219,
		237,
		241,
		250,
		257,
		247,
		260,
		264,
		-1,
		210,
		253,
		247,
		250,
		274,
		288,
		-1,
		233,
		-1,
		-1,
		218,
		236,
		244,
		240,
		244,
		297,
		265,
		260,
		250,
		248,
		239,
		230,
		237,
		228,
		228,
		231,
		246,
		251,
		243,
		257,
		257,
		258,
		-1,
		245,
		233,
		241,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		234,
		-1,
		270,
		-1,
		263,
		267,
		273,
		276,
		264,
		251,
		243,
		235,
		251,
		226,
		236,
		232,
		233,
		242,
		253,
		265,
		264,
		265,
		319,
		274,
		241,
		232,
		279,
		294,
		298,
		-1,
		246,
		285,
		272,
		-1,
		243,
		-1,
		-1,
		-1,
		277,
		286,
		278,
		284,
		263,
		263,
		237,
		241,
		231,
		238,
		248,
		250,
		242,
		246,
		259,
		270,
		273,
		315,
		313,
		318,
		263,
		246,
		264,
		273,
		294,
		261,
		252,
		279,
		279,
		268,
		263,
		250,
		-1,
		-1,
		300,
		296,
		-1,
		-1,
		270,
		258,
		241,
		242,
		238,
		241,
		256,
		259,
		249,
		247,
		241,
		273,
		-1,
		315,
		314,
		303,
		300,
		276,
		267,
		254,
		265,
		-1,
		-1,
		264,
		280,
		293,
		297,
		310,
		335,
		-1,
		253,
		-1,
		-1,
		315,
		-1,
		-1,
		300,
		263,
		252,
		243,
		249,
		246,
		257,
		267,
		255,
		256,
		246,
		256,
		269,
		299,
		296,
		284,
		282,
		305,
		262,
		258,
		-1,
		279,
		267,
		273,
		280,
		297,
		324,
		-1,
		-1,
		269,
		260,
		-1,
		-1,
		298,
		296,
		285,
		-1,
		275,
		248,
		253,
		273,
		275,
		264,
		258,
		252,
		259,
		258,
		266,
		274,
		308,
		322,
		311,
		307,
		306,
		314,
		263,
		280,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		-1,
		304,
		279,
		-1,
		-1,
		293,
		286,
		274,
		262,
		252,
		262,
		266,
		270,
		262,
		255,
		250,
		261,
		253,
		257,
		274,
		-1,
		342,
		-1,
		294,
		287,
		302,
		317,
		325,
		-1,
		-1,
		-1,
		321,
		307,
		300,
		288,
		286,
		-1,
		327,
		311,
		292,
		-1,
		262,
		275,
		306,
		274,
		279,
		274,
		256,
		267,
		256,
		259,
		273,
		268,
		-1,
		-1,
		300,
		303,
		-1,
		-1,
		325,
		344,
		-1,
		312,
		301,
		286,
		278,
		-1,
		-1,
		299,
		295,
		-1,
		-1,
		263,
		288,
		277,
		285,
		280,
		260,
		266,
		269,
		258,
		262,
		274,
		-1,
		-1,
		307,
		308,
		313,
		-1,
		328,
		-1,
		336,
		-1,
		281,
		297,
		299,
		-1,
		-1,
		-1,
		301,
		264,
		285,
		295,
		289,
		287,
		278,
		264,
		271,
		269,
		265,
		276,
		-1,
		-1,
		-1,
		346,
		320,
		343,
		334,
		317,
		297,
		289,
		314,
		-1,
		288,
		-1,
		263,
		265,
		291,
		294,
		300,
		294,
		267,
		282,
		272,
		263,
		272,
		352,
		-1,
		322,
		355,
		319,
		303,
		289,
		293,
		309,
		-1,
		285,
		267,
		-1,
		295,
		285,
		316,
		301,
		282,
		269,
		276,
		276,
		269,
		-1,
		-1,
		-1,
		324,
		323,
		315,
		309,
		309,
		294,
		285,
		-1,
		297,
		279,
		258,
		275,
		275,
		266,
		274,
		306,
		302,
		289,
		289,
		281,
		-1,
		414,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		318,
		313,
		286,
		274,
		280,
		276,
		262,
		268,
		270,
		278,
		276,
		273,
		285,
		281,
		301,
		282,
		317,
		-1,
		420,
		-1,
		354,
		-1,
		-1,
		336,
		316,
		308,
		297,
		286,
		284,
		275,
		266,
		288,
		304,
		288,
		286,
		289,
		290,
		-1,
		409,
		408,
		-1,
		355,
		347,
		333,
		-1,
		326,
		-1,
		332,
		293,
		-1,
		295,
		275,
		-1,
		297,
		293,
		-1,
		-1,
		396,
		371,
		-1,
		-1,
		-1,
		356,
		336,
		327,
		311,
		-1,
		286,
		286,
		-1,
		-1,
		-1,
		381,
		380,
		-1,
		349,
		352,
		-1,
		342,
		333,
		341,
		288,
		292,
		-1,
		-1,
		-1,
		390,
		371,
		365,
		364,
		362,
		357,
		354,
		340,
		324,
		302,
		291,
		312,
		-1,
		-1,
		-1,
		362,
		354,
		347,
		-1,
		-1,
		349,
		332,
		313,
		311,
		-1,
		-1,
		-1,
		384,
		365,
		-1,
		-1,
		339,
		-1,
		-1,
		345,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		401,
		373,
		-1,
		-1,
		-1,
		335,
		331,
		332,
		-1,
		-1,
		-1,
		-1,
		395,
		396,
		419,
		383,
		-1,
		-1,
		-1,
		327,
		321,
		-1,
		-1,
		398,
		396,
		-1,
		-1,
		-1,
		355,
		339,
		-1,
		325,
		-1,
		-1,
		-1,
		346,
		-1,
		-1,
		358,
		-1,
		-1,
		-1,
		360,
		-1,
		360,
		335,
		342,
		-1,
		-1,
		-1,
		-1,
		373,
		365,
		373,
		-1,
		345,
		347,
		-1,
		395,
		-1,
		-1,
		388,
		379,
		-1,
		-1,
		350,
		357,
		379,
		382,
		418,
		-1,
		369
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		235,
		237,
		203,
		197,
		236,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		226,
		225,
		195,
		193,
		202,
		207,
		214,
		-1,
		237,
		-1,
		247,
		226,
		237,
		242,
		188,
		185,
		205,
		224,
		230,
		222,
		262,
		218,
		189,
		183,
		201,
		206,
		224,
		216,
		-1,
		189,
		179,
		201,
		205,
		217,
		200,
		-1,
		-1,
		183,
		184,
		190,
		202,
		207,
		212,
		-1,
		235,
		219,
		-1,
		-1,
		173,
		186,
		182,
		185,
		193,
		209,
		227,
		219,
		214,
		-1,
		-1,
		174,
		178,
		191,
		192,
		190,
		214,
		227,
		209,
		223,
		222,
		-1,
		162,
		180,
		189,
		198,
		204,
		190,
		188,
		206,
		208,
		214,
		217,
		-1,
		154,
		156,
		185,
		191,
		203,
		206,
		193,
		193,
		203,
		196,
		215,
		206,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		151,
		159,
		185,
		184,
		180,
		198,
		203,
		196,
		193,
		191,
		188,
		204,
		205,
		215,
		-1,
		-1,
		207,
		176,
		211,
		168,
		153,
		-1,
		147,
		166,
		172,
		176,
		181,
		186,
		200,
		196,
		-1,
		182,
		181,
		212,
		198,
		209,
		167,
		-1,
		-1,
		165,
		157,
		142,
		145,
		142,
		142,
		172,
		171,
		176,
		178,
		177,
		183,
		186,
		186,
		192,
		176,
		186,
		190,
		201,
		216,
		-1,
		-1,
		271,
		-1,
		-1,
		164,
		147,
		-1,
		130,
		137,
		137,
		154,
		144,
		165,
		180,
		184,
		192,
		191,
		179,
		181,
		178,
		191,
		179,
		173,
		198,
		202,
		196,
		217,
		212,
		-1,
		270,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		123,
		126,
		132,
		156,
		166,
		-1,
		187,
		185,
		209,
		200,
		197,
		184,
		172,
		185,
		170,
		177,
		176,
		180,
		182,
		215,
		193,
		215,
		212,
		241,
		246,
		240,
		249,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		160,
		-1,
		174,
		187,
		191,
		189,
		192,
		201,
		192,
		179,
		168,
		179,
		168,
		165,
		173,
		182,
		193,
		188,
		187,
		205,
		220,
		233,
		237,
		243,
		-1,
		222,
		-1,
		164,
		148,
		150,
		122,
		143,
		-1,
		180,
		175,
		195,
		193,
		184,
		-1,
		187,
		190,
		197,
		175,
		160,
		177,
		169,
		167,
		172,
		177,
		191,
		182,
		200,
		207,
		215,
		219,
		239,
		251,
		182,
		172,
		-1,
		154,
		159,
		118,
		126,
		145,
		218,
		190,
		-1,
		185,
		-1,
		177,
		202,
		-1,
		181,
		177,
		159,
		160,
		155,
		170,
		176,
		173,
		170,
		188,
		191,
		208,
		212,
		228,
		-1,
		-1,
		167,
		171,
		160,
		111,
		130,
		154,
		191,
		183,
		172,
		171,
		-1,
		162,
		192,
		189,
		175,
		162,
		152,
		153,
		161,
		174,
		153,
		172,
		175,
		197,
		225,
		203,
		215,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		137,
		108,
		132,
		174,
		201,
		194,
		182,
		147,
		147,
		141,
		-1,
		182,
		165,
		161,
		150,
		148,
		161,
		156,
		172,
		176,
		175,
		194,
		206,
		197,
		217,
		-1,
		-1,
		-1,
		167,
		156,
		157,
		103,
		126,
		163,
		180,
		166,
		171,
		146,
		139,
		133,
		185,
		182,
		149,
		157,
		149,
		138,
		152,
		160,
		164,
		173,
		182,
		188,
		212,
		212,
		218,
		-1,
		-1,
		174,
		164,
		148,
		150,
		147,
		117,
		124,
		156,
		171,
		168,
		-1,
		138,
		-1,
		127,
		135,
		134,
		140,
		152,
		138,
		143,
		154,
		166,
		179,
		175,
		182,
		217,
		217,
		202,
		222,
		225,
		-1,
		-1,
		-1,
		167,
		162,
		137,
		114,
		98,
		134,
		-1,
		138,
		139,
		-1,
		132,
		126,
		132,
		131,
		138,
		135,
		135,
		149,
		157,
		153,
		169,
		175,
		167,
		203,
		-1,
		210,
		204,
		212,
		202,
		190,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		93,
		145,
		-1,
		-1,
		123,
		116,
		-1,
		119,
		119,
		126,
		135,
		140,
		145,
		153,
		148,
		161,
		166,
		172,
		177,
		195,
		199,
		203,
		192,
		188,
		185,
		199,
		-1,
		38,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		113,
		-1,
		132,
		124,
		114,
		108,
		114,
		132,
		130,
		150,
		142,
		156,
		156,
		162,
		170,
		155,
		158,
		174,
		172,
		190,
		198,
		190,
		184,
		183,
		195,
		-1,
		39,
		35,
		32,
		-1,
		-1,
		126,
		-1,
		90,
		114,
		130,
		-1,
		148,
		127,
		150,
		128,
		142,
		138,
		176,
		177,
		155,
		160,
		168,
		178,
		180,
		169,
		180,
		172,
		194,
		194,
		178,
		179,
		188,
		-1,
		55,
		0,
		36,
		48,
		54,
		115,
		87,
		96,
		117,
		-1,
		-1,
		192,
		-1,
		126,
		143,
		152,
		150,
		166,
		157,
		163,
		179,
		182,
		184,
		174,
		163,
		169,
		166,
		188,
		174,
		172,
		191,
		207,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		81,
		83,
		-1,
		134,
		-1,
		170,
		160,
		144,
		129,
		162,
		-1,
		174,
		158,
		163,
		-1,
		209,
		-1,
		182,
		184,
		178,
		163,
		160,
		171,
		169,
		180,
		197,
		-1,
		115,
		100,
		93,
		83,
		110,
		81,
		-1,
		137,
		-1,
		-1,
		157,
		151,
		151,
		135,
		138,
		190,
		170,
		164,
		163,
		204,
		204,
		190,
		176,
		169,
		166,
		163,
		176,
		196,
		187,
		199,
		-1,
		-1,
		-1,
		120,
		127,
		124,
		91,
		103,
		-1,
		-1,
		219,
		174,
		160,
		-1,
		144,
		207,
		195,
		185,
		175,
		209,
		210,
		195,
		188,
		174,
		176,
		174,
		172,
		177,
		198,
		199,
		212,
		-1,
		-1,
		124,
		122,
		110,
		96,
		115,
		-1,
		-1,
		-1,
		166,
		182,
		174,
		145,
		196,
		-1,
		-1,
		187,
		185,
		195,
		191,
		178,
		198,
		201,
		187,
		171,
		186,
		198,
		206,
		211,
		-1,
		127,
		114,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		-1,
		-1,
		199,
		165,
		177,
		198,
		223,
		190,
		-1,
		195,
		196,
		182,
		196,
		203,
		189,
		184,
		178,
		181,
		199,
		216,
		-1,
		-1,
		132,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		156,
		170,
		191,
		197,
		209,
		-1,
		204,
		198,
		184,
		201,
		202,
		199,
		190,
		182,
		187,
		184,
		197,
		211,
		215,
		155,
		-1,
		138,
		-1,
		-1,
		-1,
		174,
		189,
		251,
		228,
		201,
		205,
		198,
		192,
		192,
		208,
		210,
		221,
		189,
		185,
		186,
		190,
		189,
		206,
		216,
		-1,
		-1,
		138,
		155,
		190,
		182,
		186,
		278,
		-1,
		-1,
		214,
		205,
		196,
		199,
		202,
		205,
		195,
		192,
		197,
		202,
		190,
		199,
		217,
		221,
		-1,
		-1,
		-1,
		158,
		-1,
		173,
		-1,
		-1,
		201,
		285,
		232,
		214,
		210,
		208,
		201,
		210,
		205,
		200,
		210,
		219,
		211,
		192,
		203,
		226,
		215,
		253,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		187,
		162,
		177,
		223,
		221,
		219,
		247,
		244,
		-1,
		214,
		239,
		211,
		218,
		210,
		218,
		218,
		215,
		193,
		200,
		216,
		215,
		210,
		245,
		237,
		243,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		193,
		179,
		209,
		199,
		205,
		-1,
		-1,
		252,
		249,
		236,
		220,
		224,
		217,
		212,
		222,
		202,
		189,
		193,
		197,
		203,
		208,
		213,
		219,
		234,
		249,
		-1,
		172,
		253,
		246,
		229,
		237,
		268,
		-1,
		196,
		205,
		186,
		191,
		199,
		-1,
		-1,
		225,
		221,
		226,
		227,
		224,
		232,
		227,
		218,
		203,
		209,
		196,
		195,
		213,
		217,
		226,
		233,
		223,
		236,
		240,
		-1,
		186,
		229,
		223,
		226,
		250,
		264,
		-1,
		209,
		-1,
		-1,
		194,
		212,
		220,
		216,
		220,
		273,
		241,
		236,
		226,
		224,
		215,
		206,
		213,
		204,
		204,
		207,
		222,
		227,
		219,
		233,
		233,
		234,
		-1,
		221,
		209,
		217,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		210,
		-1,
		246,
		-1,
		239,
		243,
		249,
		252,
		240,
		227,
		219,
		211,
		227,
		202,
		212,
		208,
		209,
		218,
		229,
		241,
		240,
		241,
		295,
		250,
		217,
		208,
		255,
		270,
		274,
		-1,
		222,
		261,
		248,
		-1,
		219,
		-1,
		-1,
		-1,
		253,
		262,
		254,
		260,
		239,
		239,
		213,
		217,
		207,
		214,
		224,
		226,
		218,
		222,
		235,
		246,
		249,
		291,
		289,
		294,
		239,
		222,
		240,
		249,
		270,
		237,
		228,
		255,
		255,
		244,
		239,
		226,
		-1,
		-1,
		276,
		272,
		-1,
		-1,
		246,
		234,
		217,
		218,
		214,
		217,
		232,
		235,
		225,
		223,
		217,
		249,
		-1,
		291,
		290,
		279,
		276,
		252,
		243,
		230,
		241,
		-1,
		-1,
		240,
		256,
		269,
		273,
		286,
		311,
		-1,
		229,
		-1,
		-1,
		291,
		-1,
		-1,
		276,
		239,
		228,
		219,
		225,
		222,
		233,
		243,
		231,
		232,
		222,
		232,
		245,
		275,
		272,
		260,
		258,
		281,
		238,
		234,
		-1,
		255,
		243,
		249,
		256,
		273,
		300,
		-1,
		-1,
		245,
		236,
		-1,
		-1,
		274,
		272,
		261,
		-1,
		251,
		224,
		229,
		249,
		251,
		240,
		234,
		228,
		235,
		234,
		242,
		250,
		284,
		298,
		287,
		283,
		282,
		290,
		239,
		256,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		-1,
		280,
		255,
		-1,
		-1,
		269,
		262,
		250,
		238,
		228,
		238,
		242,
		246,
		238,
		231,
		226,
		237,
		229,
		233,
		250,
		-1,
		318,
		-1,
		270,
		263,
		278,
		293,
		301,
		-1,
		-1,
		-1,
		297,
		283,
		276,
		264,
		262,
		-1,
		303,
		287,
		268,
		-1,
		238,
		251,
		282,
		250,
		255,
		250,
		232,
		243,
		232,
		235,
		249,
		244,
		-1,
		-1,
		276,
		279,
		-1,
		-1,
		301,
		320,
		-1,
		288,
		277,
		262,
		254,
		-1,
		-1,
		275,
		271,
		-1,
		-1,
		239,
		264,
		253,
		261,
		256,
		236,
		242,
		245,
		234,
		238,
		250,
		-1,
		-1,
		283,
		284,
		289,
		-1,
		304,
		-1,
		312,
		-1,
		257,
		273,
		275,
		-1,
		-1,
		-1,
		277,
		240,
		261,
		271,
		265,
		263,
		254,
		240,
		247,
		245,
		241,
		252,
		-1,
		-1,
		-1,
		322,
		296,
		319,
		310,
		293,
		273,
		265,
		290,
		-1,
		264,
		-1,
		239,
		241,
		267,
		270,
		276,
		270,
		243,
		258,
		248,
		239,
		248,
		328,
		-1,
		298,
		331,
		295,
		279,
		265,
		269,
		285,
		-1,
		261,
		243,
		-1,
		271,
		261,
		292,
		277,
		258,
		245,
		252,
		252,
		245,
		-1,
		-1,
		-1,
		300,
		299,
		291,
		285,
		285,
		270,
		261,
		-1,
		273,
		255,
		234,
		251,
		251,
		242,
		250,
		282,
		278,
		265,
		265,
		257,
		-1,
		390,
		-1,
		-1,
		323,
		-1,
		-1,
		-1,
		294,
		289,
		262,
		250,
		256,
		252,
		238,
		244,
		246,
		254,
		252,
		249,
		261,
		257,
		277,
		258,
		293,
		-1,
		396,
		-1,
		330,
		-1,
		-1,
		312,
		292,
		284,
		273,
		262,
		260,
		251,
		242,
		264,
		280,
		264,
		262,
		265,
		266,
		-1,
		385,
		384,
		-1,
		331,
		323,
		309,
		-1,
		302,
		-1,
		308,
		269,
		-1,
		271,
		251,
		-1,
		273,
		269,
		-1,
		-1,
		372,
		347,
		-1,
		-1,
		-1,
		332,
		312,
		303,
		287,
		-1,
		262,
		262,
		-1,
		-1,
		-1,
		357,
		356,
		-1,
		325,
		328,
		-1,
		318,
		309,
		317,
		264,
		268,
		-1,
		-1,
		-1,
		366,
		347,
		341,
		340,
		338,
		333,
		330,
		316,
		300,
		278,
		267,
		288,
		-1,
		-1,
		-1,
		338,
		330,
		323,
		-1,
		-1,
		325,
		308,
		289,
		287,
		-1,
		-1,
		-1,
		360,
		341,
		-1,
		-1,
		315,
		-1,
		-1,
		321,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		377,
		349,
		-1,
		-1,
		-1,
		311,
		307,
		308,
		-1,
		-1,
		-1,
		-1,
		371,
		372,
		395,
		359,
		-1,
		-1,
		-1,
		303,
		297,
		-1,
		-1,
		374,
		372,
		-1,
		-1,
		-1,
		331,
		315,
		-1,
		301,
		-1,
		-1,
		-1,
		322,
		-1,
		-1,
		334,
		-1,
		-1,
		-1,
		336,
		-1,
		336,
		311,
		318,
		-1,
		-1,
		-1,
		-1,
		349,
		341,
		349,
		-1,
		321,
		323,
		-1,
		371,
		-1,
		-1,
		364,
		355,
		-1,
		-1,
		326,
		333,
		355,
		358,
		394,
		-1,
		345
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		199,
		201,
		167,
		161,
		200,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		190,
		189,
		159,
		157,
		166,
		171,
		178,
		-1,
		201,
		-1,
		211,
		190,
		201,
		206,
		152,
		149,
		169,
		188,
		194,
		186,
		226,
		182,
		153,
		147,
		165,
		170,
		188,
		180,
		-1,
		153,
		143,
		165,
		169,
		181,
		164,
		-1,
		-1,
		147,
		148,
		154,
		166,
		171,
		176,
		-1,
		199,
		183,
		-1,
		-1,
		137,
		150,
		146,
		149,
		157,
		173,
		191,
		183,
		178,
		-1,
		-1,
		138,
		142,
		155,
		156,
		154,
		178,
		191,
		173,
		187,
		186,
		-1,
		126,
		144,
		153,
		162,
		168,
		154,
		152,
		170,
		172,
		178,
		181,
		-1,
		118,
		120,
		149,
		155,
		167,
		170,
		157,
		157,
		167,
		160,
		179,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		123,
		149,
		148,
		144,
		162,
		167,
		160,
		157,
		155,
		152,
		168,
		169,
		179,
		-1,
		-1,
		171,
		140,
		175,
		132,
		117,
		-1,
		111,
		130,
		136,
		140,
		145,
		150,
		164,
		160,
		-1,
		146,
		145,
		176,
		162,
		173,
		131,
		-1,
		-1,
		129,
		121,
		106,
		109,
		106,
		106,
		136,
		135,
		140,
		142,
		141,
		147,
		150,
		150,
		156,
		140,
		150,
		154,
		165,
		180,
		-1,
		-1,
		235,
		-1,
		-1,
		128,
		111,
		-1,
		94,
		101,
		101,
		118,
		108,
		129,
		144,
		148,
		156,
		155,
		143,
		145,
		142,
		155,
		143,
		137,
		162,
		166,
		160,
		181,
		176,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		87,
		90,
		96,
		120,
		130,
		-1,
		151,
		149,
		173,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		144,
		146,
		179,
		157,
		179,
		176,
		205,
		210,
		204,
		213,
		-1,
		136,
		132,
		128,
		135,
		84,
		-1,
		-1,
		124,
		-1,
		138,
		151,
		155,
		153,
		156,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		146,
		157,
		152,
		151,
		169,
		184,
		197,
		201,
		207,
		-1,
		186,
		-1,
		128,
		112,
		114,
		86,
		107,
		-1,
		144,
		139,
		159,
		157,
		148,
		-1,
		151,
		154,
		161,
		139,
		124,
		141,
		133,
		131,
		136,
		141,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		146,
		136,
		-1,
		118,
		123,
		82,
		90,
		109,
		182,
		154,
		-1,
		149,
		-1,
		141,
		166,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		140,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		131,
		135,
		124,
		75,
		94,
		118,
		155,
		147,
		136,
		135,
		-1,
		126,
		156,
		153,
		139,
		126,
		116,
		117,
		125,
		138,
		117,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		101,
		72,
		96,
		138,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		146,
		129,
		125,
		114,
		112,
		125,
		120,
		136,
		140,
		139,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		131,
		120,
		121,
		67,
		90,
		127,
		144,
		130,
		135,
		110,
		103,
		97,
		149,
		146,
		113,
		121,
		113,
		102,
		116,
		124,
		128,
		137,
		146,
		152,
		176,
		176,
		182,
		-1,
		-1,
		138,
		128,
		112,
		114,
		111,
		81,
		88,
		120,
		135,
		132,
		-1,
		102,
		-1,
		91,
		99,
		98,
		104,
		116,
		102,
		107,
		118,
		130,
		143,
		139,
		146,
		181,
		181,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		131,
		126,
		101,
		78,
		62,
		98,
		-1,
		102,
		103,
		-1,
		96,
		90,
		96,
		95,
		102,
		99,
		99,
		113,
		121,
		117,
		133,
		139,
		131,
		167,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		124,
		103,
		96,
		116,
		57,
		109,
		-1,
		-1,
		87,
		80,
		-1,
		83,
		83,
		90,
		99,
		104,
		109,
		117,
		112,
		125,
		130,
		136,
		141,
		159,
		163,
		167,
		156,
		152,
		149,
		163,
		-1,
		48,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		77,
		-1,
		96,
		88,
		78,
		72,
		78,
		96,
		94,
		114,
		106,
		120,
		120,
		126,
		134,
		119,
		122,
		138,
		136,
		154,
		162,
		154,
		148,
		147,
		159,
		-1,
		49,
		35,
		6,
		-1,
		-1,
		90,
		-1,
		54,
		78,
		94,
		-1,
		112,
		91,
		114,
		92,
		106,
		102,
		140,
		141,
		119,
		124,
		132,
		142,
		144,
		133,
		144,
		136,
		158,
		158,
		142,
		143,
		152,
		-1,
		55,
		42,
		0,
		12,
		18,
		79,
		51,
		60,
		81,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		116,
		114,
		130,
		121,
		127,
		143,
		146,
		148,
		138,
		127,
		133,
		130,
		152,
		138,
		136,
		155,
		171,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		45,
		45,
		47,
		-1,
		98,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		138,
		122,
		127,
		-1,
		173,
		-1,
		146,
		148,
		142,
		127,
		124,
		135,
		133,
		144,
		161,
		-1,
		79,
		64,
		57,
		47,
		74,
		45,
		-1,
		101,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		154,
		134,
		128,
		127,
		168,
		168,
		154,
		140,
		133,
		130,
		127,
		140,
		160,
		151,
		163,
		-1,
		-1,
		-1,
		84,
		91,
		88,
		55,
		67,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		171,
		159,
		149,
		139,
		173,
		174,
		159,
		152,
		138,
		140,
		138,
		136,
		141,
		162,
		163,
		176,
		-1,
		-1,
		88,
		86,
		74,
		60,
		79,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		160,
		-1,
		-1,
		151,
		149,
		159,
		155,
		142,
		162,
		165,
		151,
		135,
		150,
		162,
		170,
		175,
		-1,
		91,
		78,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		162,
		187,
		154,
		-1,
		159,
		160,
		146,
		160,
		167,
		153,
		148,
		142,
		145,
		163,
		180,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		155,
		161,
		173,
		-1,
		168,
		162,
		148,
		165,
		166,
		163,
		154,
		146,
		151,
		148,
		161,
		175,
		179,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		138,
		153,
		215,
		192,
		165,
		169,
		162,
		156,
		156,
		172,
		174,
		185,
		153,
		149,
		150,
		154,
		153,
		170,
		180,
		-1,
		-1,
		102,
		119,
		154,
		146,
		150,
		242,
		-1,
		-1,
		178,
		169,
		160,
		163,
		166,
		169,
		159,
		156,
		161,
		166,
		154,
		163,
		181,
		185,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		165,
		249,
		196,
		178,
		174,
		172,
		165,
		174,
		169,
		164,
		174,
		183,
		175,
		156,
		167,
		190,
		179,
		217,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		185,
		183,
		211,
		208,
		-1,
		178,
		203,
		175,
		182,
		174,
		182,
		182,
		179,
		157,
		164,
		180,
		179,
		174,
		209,
		201,
		207,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		157,
		143,
		173,
		163,
		169,
		-1,
		-1,
		216,
		213,
		200,
		184,
		188,
		181,
		176,
		186,
		166,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		136,
		217,
		210,
		193,
		201,
		232,
		-1,
		160,
		169,
		150,
		155,
		163,
		-1,
		-1,
		189,
		185,
		190,
		191,
		188,
		196,
		191,
		182,
		167,
		173,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		150,
		193,
		187,
		190,
		214,
		228,
		-1,
		173,
		-1,
		-1,
		158,
		176,
		184,
		180,
		184,
		237,
		205,
		200,
		190,
		188,
		179,
		170,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		185,
		173,
		181,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		210,
		-1,
		203,
		207,
		213,
		216,
		204,
		191,
		183,
		175,
		191,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		259,
		214,
		181,
		172,
		219,
		234,
		238,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		217,
		226,
		218,
		224,
		203,
		203,
		177,
		181,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		255,
		253,
		258,
		203,
		186,
		204,
		213,
		234,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		240,
		236,
		-1,
		-1,
		210,
		198,
		181,
		182,
		178,
		181,
		196,
		199,
		189,
		187,
		181,
		213,
		-1,
		255,
		254,
		243,
		240,
		216,
		207,
		194,
		205,
		-1,
		-1,
		204,
		220,
		233,
		237,
		250,
		275,
		-1,
		193,
		-1,
		-1,
		255,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		186,
		197,
		207,
		195,
		196,
		186,
		196,
		209,
		239,
		236,
		224,
		222,
		245,
		202,
		198,
		-1,
		219,
		207,
		213,
		220,
		237,
		264,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		238,
		236,
		225,
		-1,
		215,
		188,
		193,
		213,
		215,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		248,
		262,
		251,
		247,
		246,
		254,
		203,
		220,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		219,
		-1,
		-1,
		233,
		226,
		214,
		202,
		192,
		202,
		206,
		210,
		202,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		282,
		-1,
		234,
		227,
		242,
		257,
		265,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		240,
		243,
		-1,
		-1,
		265,
		284,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		247,
		248,
		253,
		-1,
		268,
		-1,
		276,
		-1,
		221,
		237,
		239,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		229,
		227,
		218,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		286,
		260,
		283,
		274,
		257,
		237,
		229,
		254,
		-1,
		228,
		-1,
		203,
		205,
		231,
		234,
		240,
		234,
		207,
		222,
		212,
		203,
		212,
		292,
		-1,
		262,
		295,
		259,
		243,
		229,
		233,
		249,
		-1,
		225,
		207,
		-1,
		235,
		225,
		256,
		241,
		222,
		209,
		216,
		216,
		209,
		-1,
		-1,
		-1,
		264,
		263,
		255,
		249,
		249,
		234,
		225,
		-1,
		237,
		219,
		198,
		215,
		215,
		206,
		214,
		246,
		242,
		229,
		229,
		221,
		-1,
		354,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		258,
		253,
		226,
		214,
		220,
		216,
		202,
		208,
		210,
		218,
		216,
		213,
		225,
		221,
		241,
		222,
		257,
		-1,
		360,
		-1,
		294,
		-1,
		-1,
		276,
		256,
		248,
		237,
		226,
		224,
		215,
		206,
		228,
		244,
		228,
		226,
		229,
		230,
		-1,
		349,
		348,
		-1,
		295,
		287,
		273,
		-1,
		266,
		-1,
		272,
		233,
		-1,
		235,
		215,
		-1,
		237,
		233,
		-1,
		-1,
		336,
		311,
		-1,
		-1,
		-1,
		296,
		276,
		267,
		251,
		-1,
		226,
		226,
		-1,
		-1,
		-1,
		321,
		320,
		-1,
		289,
		292,
		-1,
		282,
		273,
		281,
		228,
		232,
		-1,
		-1,
		-1,
		330,
		311,
		305,
		304,
		302,
		297,
		294,
		280,
		264,
		242,
		231,
		252,
		-1,
		-1,
		-1,
		302,
		294,
		287,
		-1,
		-1,
		289,
		272,
		253,
		251,
		-1,
		-1,
		-1,
		324,
		305,
		-1,
		-1,
		279,
		-1,
		-1,
		285,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		341,
		313,
		-1,
		-1,
		-1,
		275,
		271,
		272,
		-1,
		-1,
		-1,
		-1,
		335,
		336,
		359,
		323,
		-1,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		338,
		336,
		-1,
		-1,
		-1,
		295,
		279,
		-1,
		265,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		300,
		-1,
		300,
		275,
		282,
		-1,
		-1,
		-1,
		-1,
		313,
		305,
		313,
		-1,
		285,
		287,
		-1,
		335,
		-1,
		-1,
		328,
		319,
		-1,
		-1,
		290,
		297,
		319,
		322,
		358,
		-1,
		309
	],
	[
		-1,
		184,
		173,
		184,
		192,
		165,
		172,
		-1,
		193,
		195,
		161,
		155,
		194,
		165,
		171,
		182,
		-1,
		-1,
		-1,
		184,
		183,
		153,
		151,
		160,
		165,
		172,
		-1,
		195,
		-1,
		205,
		184,
		195,
		200,
		146,
		143,
		163,
		182,
		188,
		180,
		220,
		176,
		147,
		141,
		159,
		164,
		182,
		174,
		-1,
		147,
		137,
		159,
		163,
		175,
		158,
		-1,
		-1,
		141,
		142,
		148,
		160,
		165,
		170,
		-1,
		193,
		177,
		-1,
		-1,
		131,
		144,
		140,
		143,
		151,
		167,
		185,
		177,
		172,
		-1,
		-1,
		132,
		136,
		149,
		150,
		148,
		172,
		185,
		167,
		181,
		180,
		-1,
		120,
		138,
		147,
		156,
		162,
		148,
		146,
		164,
		166,
		172,
		175,
		-1,
		112,
		114,
		143,
		149,
		161,
		164,
		151,
		151,
		161,
		154,
		173,
		164,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		117,
		143,
		142,
		138,
		156,
		161,
		154,
		151,
		149,
		146,
		162,
		163,
		173,
		-1,
		-1,
		165,
		134,
		169,
		126,
		111,
		-1,
		105,
		124,
		130,
		134,
		139,
		144,
		158,
		154,
		-1,
		140,
		139,
		170,
		156,
		167,
		125,
		-1,
		-1,
		123,
		115,
		100,
		103,
		100,
		100,
		130,
		129,
		134,
		136,
		135,
		141,
		144,
		144,
		150,
		134,
		144,
		148,
		159,
		174,
		-1,
		-1,
		229,
		-1,
		-1,
		122,
		105,
		-1,
		88,
		95,
		95,
		112,
		102,
		123,
		138,
		142,
		150,
		149,
		137,
		139,
		136,
		149,
		137,
		131,
		156,
		160,
		154,
		175,
		170,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		81,
		84,
		90,
		114,
		124,
		-1,
		145,
		143,
		167,
		158,
		155,
		142,
		130,
		143,
		128,
		135,
		134,
		138,
		140,
		173,
		151,
		173,
		170,
		199,
		204,
		198,
		207,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		118,
		-1,
		132,
		145,
		149,
		147,
		150,
		159,
		150,
		137,
		126,
		137,
		126,
		123,
		131,
		140,
		151,
		146,
		145,
		163,
		178,
		191,
		195,
		201,
		-1,
		180,
		-1,
		122,
		106,
		108,
		80,
		101,
		-1,
		138,
		133,
		153,
		151,
		142,
		-1,
		145,
		148,
		155,
		133,
		118,
		135,
		127,
		125,
		130,
		135,
		149,
		140,
		158,
		165,
		173,
		177,
		197,
		209,
		140,
		130,
		-1,
		112,
		117,
		76,
		84,
		103,
		176,
		148,
		-1,
		143,
		-1,
		135,
		160,
		-1,
		139,
		135,
		117,
		118,
		113,
		128,
		134,
		131,
		128,
		146,
		149,
		166,
		170,
		186,
		-1,
		-1,
		125,
		129,
		118,
		69,
		88,
		112,
		149,
		141,
		130,
		129,
		-1,
		120,
		150,
		147,
		133,
		120,
		110,
		111,
		119,
		132,
		111,
		130,
		133,
		155,
		183,
		161,
		173,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		95,
		66,
		90,
		132,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		140,
		123,
		119,
		108,
		106,
		119,
		114,
		130,
		134,
		133,
		152,
		164,
		155,
		175,
		-1,
		-1,
		-1,
		125,
		114,
		115,
		61,
		84,
		121,
		138,
		124,
		129,
		104,
		97,
		91,
		143,
		140,
		107,
		115,
		107,
		96,
		110,
		118,
		122,
		131,
		140,
		146,
		170,
		170,
		176,
		-1,
		-1,
		132,
		122,
		106,
		108,
		105,
		75,
		82,
		114,
		129,
		126,
		-1,
		96,
		-1,
		85,
		93,
		92,
		98,
		110,
		96,
		101,
		112,
		124,
		137,
		133,
		140,
		175,
		175,
		160,
		180,
		183,
		-1,
		-1,
		-1,
		125,
		120,
		95,
		72,
		56,
		92,
		-1,
		96,
		97,
		-1,
		90,
		84,
		90,
		89,
		96,
		93,
		93,
		107,
		115,
		111,
		127,
		133,
		125,
		161,
		-1,
		168,
		162,
		170,
		160,
		148,
		-1,
		-1,
		-1,
		118,
		97,
		90,
		110,
		51,
		103,
		-1,
		-1,
		81,
		74,
		-1,
		77,
		77,
		84,
		93,
		98,
		103,
		111,
		106,
		119,
		124,
		130,
		135,
		153,
		157,
		161,
		150,
		146,
		143,
		157,
		-1,
		62,
		-1,
		-1,
		-1,
		-1,
		-1,
		51,
		71,
		-1,
		90,
		82,
		72,
		66,
		72,
		90,
		88,
		108,
		100,
		114,
		114,
		120,
		128,
		113,
		116,
		132,
		130,
		148,
		156,
		148,
		142,
		141,
		153,
		-1,
		63,
		49,
		20,
		-1,
		-1,
		84,
		-1,
		48,
		72,
		88,
		-1,
		106,
		85,
		108,
		86,
		100,
		96,
		134,
		135,
		113,
		118,
		126,
		136,
		138,
		127,
		138,
		130,
		152,
		152,
		136,
		137,
		146,
		-1,
		69,
		56,
		14,
		0,
		12,
		75,
		45,
		54,
		75,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		110,
		108,
		124,
		115,
		121,
		137,
		140,
		142,
		132,
		121,
		127,
		124,
		146,
		132,
		130,
		149,
		165,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		41,
		39,
		41,
		-1,
		92,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		132,
		116,
		121,
		-1,
		167,
		-1,
		140,
		142,
		136,
		121,
		118,
		129,
		127,
		138,
		155,
		-1,
		75,
		60,
		53,
		43,
		68,
		39,
		-1,
		95,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		148,
		128,
		122,
		121,
		162,
		162,
		148,
		134,
		127,
		124,
		121,
		134,
		154,
		145,
		157,
		-1,
		-1,
		-1,
		80,
		85,
		82,
		49,
		61,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		165,
		153,
		143,
		133,
		167,
		168,
		153,
		146,
		132,
		134,
		132,
		130,
		135,
		156,
		157,
		170,
		-1,
		-1,
		82,
		80,
		68,
		54,
		73,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		154,
		-1,
		-1,
		145,
		143,
		153,
		149,
		136,
		156,
		159,
		145,
		129,
		144,
		156,
		164,
		169,
		-1,
		85,
		72,
		-1,
		-1,
		76,
		70,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		135,
		156,
		181,
		148,
		-1,
		153,
		154,
		140,
		154,
		161,
		147,
		142,
		136,
		139,
		157,
		174,
		-1,
		-1,
		90,
		-1,
		85,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		149,
		155,
		167,
		-1,
		162,
		156,
		142,
		159,
		160,
		157,
		148,
		140,
		145,
		142,
		155,
		169,
		173,
		113,
		-1,
		96,
		-1,
		-1,
		-1,
		132,
		147,
		209,
		186,
		159,
		163,
		156,
		150,
		150,
		166,
		168,
		179,
		147,
		143,
		144,
		148,
		147,
		164,
		174,
		-1,
		-1,
		96,
		113,
		148,
		140,
		144,
		236,
		-1,
		-1,
		172,
		163,
		154,
		157,
		160,
		163,
		153,
		150,
		155,
		160,
		148,
		157,
		175,
		179,
		-1,
		-1,
		-1,
		116,
		-1,
		131,
		-1,
		-1,
		159,
		243,
		190,
		172,
		168,
		166,
		159,
		168,
		163,
		158,
		168,
		177,
		169,
		150,
		161,
		184,
		173,
		211,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		145,
		120,
		135,
		181,
		179,
		177,
		205,
		202,
		-1,
		172,
		197,
		169,
		176,
		168,
		176,
		176,
		173,
		151,
		158,
		174,
		173,
		168,
		203,
		195,
		201,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		151,
		137,
		167,
		157,
		163,
		-1,
		-1,
		210,
		207,
		194,
		178,
		182,
		175,
		170,
		180,
		160,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		130,
		211,
		204,
		187,
		195,
		226,
		-1,
		154,
		163,
		144,
		149,
		157,
		-1,
		-1,
		183,
		179,
		184,
		185,
		182,
		190,
		185,
		176,
		161,
		167,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		144,
		187,
		181,
		184,
		208,
		222,
		-1,
		167,
		-1,
		-1,
		152,
		170,
		178,
		174,
		178,
		231,
		199,
		194,
		184,
		182,
		173,
		164,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		179,
		167,
		175,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		168,
		-1,
		204,
		-1,
		197,
		201,
		207,
		210,
		198,
		185,
		177,
		169,
		185,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		253,
		208,
		175,
		166,
		213,
		228,
		232,
		-1,
		180,
		219,
		206,
		-1,
		177,
		-1,
		-1,
		-1,
		211,
		220,
		212,
		218,
		197,
		197,
		171,
		175,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		249,
		247,
		252,
		197,
		180,
		198,
		207,
		228,
		195,
		186,
		213,
		213,
		202,
		197,
		184,
		-1,
		-1,
		234,
		230,
		-1,
		-1,
		204,
		192,
		175,
		176,
		172,
		175,
		190,
		193,
		183,
		181,
		175,
		207,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		188,
		199,
		-1,
		-1,
		198,
		214,
		227,
		231,
		244,
		269,
		-1,
		187,
		-1,
		-1,
		249,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		180,
		191,
		201,
		189,
		190,
		180,
		190,
		203,
		233,
		230,
		218,
		216,
		239,
		196,
		192,
		-1,
		213,
		201,
		207,
		214,
		231,
		258,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		232,
		230,
		219,
		-1,
		209,
		182,
		187,
		207,
		209,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		214,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		238,
		213,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		200,
		204,
		196,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		276,
		-1,
		228,
		221,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		255,
		241,
		234,
		222,
		220,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		234,
		237,
		-1,
		-1,
		259,
		278,
		-1,
		246,
		235,
		220,
		212,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		241,
		242,
		247,
		-1,
		262,
		-1,
		270,
		-1,
		215,
		231,
		233,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		223,
		221,
		212,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		280,
		254,
		277,
		268,
		251,
		231,
		223,
		248,
		-1,
		222,
		-1,
		197,
		199,
		225,
		228,
		234,
		228,
		201,
		216,
		206,
		197,
		206,
		286,
		-1,
		256,
		289,
		253,
		237,
		223,
		227,
		243,
		-1,
		219,
		201,
		-1,
		229,
		219,
		250,
		235,
		216,
		203,
		210,
		210,
		203,
		-1,
		-1,
		-1,
		258,
		257,
		249,
		243,
		243,
		228,
		219,
		-1,
		231,
		213,
		192,
		209,
		209,
		200,
		208,
		240,
		236,
		223,
		223,
		215,
		-1,
		348,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		252,
		247,
		220,
		208,
		214,
		210,
		196,
		202,
		204,
		212,
		210,
		207,
		219,
		215,
		235,
		216,
		251,
		-1,
		354,
		-1,
		288,
		-1,
		-1,
		270,
		250,
		242,
		231,
		220,
		218,
		209,
		200,
		222,
		238,
		222,
		220,
		223,
		224,
		-1,
		343,
		342,
		-1,
		289,
		281,
		267,
		-1,
		260,
		-1,
		266,
		227,
		-1,
		229,
		209,
		-1,
		231,
		227,
		-1,
		-1,
		330,
		305,
		-1,
		-1,
		-1,
		290,
		270,
		261,
		245,
		-1,
		220,
		220,
		-1,
		-1,
		-1,
		315,
		314,
		-1,
		283,
		286,
		-1,
		276,
		267,
		275,
		222,
		226,
		-1,
		-1,
		-1,
		324,
		305,
		299,
		298,
		296,
		291,
		288,
		274,
		258,
		236,
		225,
		246,
		-1,
		-1,
		-1,
		296,
		288,
		281,
		-1,
		-1,
		283,
		266,
		247,
		245,
		-1,
		-1,
		-1,
		318,
		299,
		-1,
		-1,
		273,
		-1,
		-1,
		279,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		335,
		307,
		-1,
		-1,
		-1,
		269,
		265,
		266,
		-1,
		-1,
		-1,
		-1,
		329,
		330,
		353,
		317,
		-1,
		-1,
		-1,
		261,
		255,
		-1,
		-1,
		332,
		330,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		259,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		294,
		-1,
		294,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		307,
		-1,
		279,
		281,
		-1,
		329,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		284,
		291,
		313,
		316,
		352,
		-1,
		303
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		182,
		184,
		150,
		144,
		183,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		173,
		172,
		142,
		140,
		149,
		154,
		161,
		-1,
		184,
		-1,
		194,
		173,
		184,
		189,
		135,
		132,
		152,
		171,
		177,
		169,
		209,
		165,
		136,
		130,
		148,
		153,
		171,
		163,
		-1,
		136,
		126,
		148,
		152,
		164,
		147,
		-1,
		-1,
		130,
		131,
		137,
		149,
		154,
		159,
		-1,
		182,
		166,
		-1,
		-1,
		120,
		133,
		129,
		132,
		140,
		156,
		174,
		166,
		161,
		-1,
		-1,
		121,
		125,
		138,
		139,
		137,
		161,
		174,
		156,
		170,
		169,
		-1,
		109,
		127,
		136,
		145,
		151,
		137,
		135,
		153,
		155,
		161,
		164,
		-1,
		101,
		103,
		132,
		138,
		150,
		153,
		140,
		140,
		150,
		143,
		162,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		98,
		106,
		132,
		131,
		127,
		145,
		150,
		143,
		140,
		138,
		135,
		151,
		152,
		162,
		-1,
		-1,
		154,
		123,
		158,
		115,
		100,
		-1,
		94,
		113,
		119,
		123,
		128,
		133,
		147,
		143,
		-1,
		129,
		128,
		159,
		145,
		156,
		114,
		-1,
		-1,
		112,
		104,
		89,
		92,
		89,
		89,
		119,
		118,
		123,
		125,
		124,
		130,
		133,
		133,
		139,
		123,
		133,
		137,
		148,
		163,
		-1,
		-1,
		218,
		-1,
		-1,
		111,
		94,
		-1,
		77,
		84,
		84,
		101,
		91,
		112,
		127,
		131,
		139,
		138,
		126,
		128,
		125,
		138,
		126,
		120,
		145,
		149,
		143,
		164,
		159,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		70,
		73,
		79,
		103,
		113,
		-1,
		134,
		132,
		156,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		127,
		129,
		162,
		140,
		162,
		159,
		188,
		193,
		187,
		196,
		-1,
		119,
		115,
		111,
		118,
		67,
		-1,
		-1,
		107,
		-1,
		121,
		134,
		138,
		136,
		139,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		129,
		140,
		135,
		134,
		152,
		167,
		180,
		184,
		190,
		-1,
		169,
		-1,
		111,
		95,
		97,
		69,
		90,
		-1,
		127,
		122,
		142,
		140,
		131,
		-1,
		134,
		137,
		144,
		122,
		107,
		124,
		116,
		114,
		119,
		124,
		138,
		129,
		147,
		154,
		162,
		166,
		186,
		198,
		129,
		119,
		-1,
		101,
		106,
		65,
		73,
		92,
		165,
		137,
		-1,
		132,
		-1,
		124,
		149,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		123,
		120,
		117,
		135,
		138,
		155,
		159,
		175,
		-1,
		-1,
		114,
		118,
		107,
		58,
		77,
		101,
		138,
		130,
		119,
		118,
		-1,
		109,
		139,
		136,
		122,
		109,
		99,
		100,
		108,
		121,
		100,
		119,
		122,
		144,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		84,
		55,
		79,
		121,
		148,
		141,
		129,
		94,
		94,
		88,
		-1,
		129,
		112,
		108,
		97,
		95,
		108,
		103,
		119,
		123,
		122,
		141,
		153,
		144,
		164,
		-1,
		-1,
		-1,
		114,
		103,
		104,
		50,
		73,
		110,
		127,
		113,
		118,
		93,
		86,
		80,
		132,
		129,
		96,
		104,
		96,
		85,
		99,
		107,
		111,
		120,
		129,
		135,
		159,
		159,
		165,
		-1,
		-1,
		121,
		111,
		95,
		97,
		94,
		64,
		71,
		103,
		118,
		115,
		-1,
		85,
		-1,
		74,
		82,
		81,
		87,
		99,
		85,
		90,
		101,
		113,
		126,
		122,
		129,
		164,
		164,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		114,
		109,
		84,
		61,
		45,
		81,
		-1,
		85,
		86,
		-1,
		79,
		73,
		79,
		78,
		85,
		82,
		82,
		96,
		104,
		100,
		116,
		122,
		114,
		150,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		107,
		86,
		79,
		99,
		40,
		92,
		-1,
		-1,
		70,
		63,
		-1,
		66,
		66,
		73,
		82,
		87,
		92,
		100,
		95,
		108,
		113,
		119,
		124,
		142,
		146,
		150,
		139,
		135,
		132,
		146,
		-1,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		40,
		60,
		-1,
		79,
		71,
		61,
		55,
		61,
		79,
		77,
		97,
		89,
		103,
		103,
		109,
		117,
		102,
		105,
		121,
		119,
		137,
		145,
		137,
		131,
		130,
		142,
		-1,
		68,
		54,
		25,
		-1,
		-1,
		73,
		-1,
		37,
		61,
		77,
		-1,
		95,
		74,
		97,
		75,
		89,
		85,
		123,
		124,
		102,
		107,
		115,
		125,
		127,
		116,
		127,
		119,
		141,
		141,
		125,
		126,
		135,
		-1,
		74,
		61,
		19,
		12,
		0,
		63,
		34,
		43,
		64,
		-1,
		-1,
		139,
		-1,
		73,
		90,
		99,
		97,
		113,
		104,
		110,
		126,
		129,
		131,
		121,
		110,
		116,
		113,
		135,
		121,
		119,
		138,
		154,
		-1,
		-1,
		-1,
		80,
		-1,
		-1,
		29,
		28,
		30,
		-1,
		81,
		-1,
		117,
		107,
		91,
		76,
		109,
		-1,
		121,
		105,
		110,
		-1,
		156,
		-1,
		129,
		131,
		125,
		110,
		107,
		118,
		116,
		127,
		144,
		-1,
		63,
		48,
		41,
		31,
		57,
		28,
		-1,
		84,
		-1,
		-1,
		104,
		98,
		98,
		82,
		85,
		137,
		117,
		111,
		110,
		151,
		151,
		137,
		123,
		116,
		113,
		110,
		123,
		143,
		134,
		146,
		-1,
		-1,
		-1,
		68,
		74,
		71,
		38,
		50,
		-1,
		-1,
		166,
		121,
		107,
		-1,
		91,
		154,
		142,
		132,
		122,
		156,
		157,
		142,
		135,
		121,
		123,
		121,
		119,
		124,
		145,
		146,
		159,
		-1,
		-1,
		71,
		69,
		57,
		43,
		62,
		-1,
		-1,
		-1,
		113,
		129,
		121,
		92,
		143,
		-1,
		-1,
		134,
		132,
		142,
		138,
		125,
		145,
		148,
		134,
		118,
		133,
		145,
		153,
		158,
		-1,
		74,
		61,
		-1,
		-1,
		65,
		59,
		-1,
		-1,
		-1,
		-1,
		146,
		112,
		124,
		145,
		170,
		137,
		-1,
		142,
		143,
		129,
		143,
		150,
		136,
		131,
		125,
		128,
		146,
		163,
		-1,
		-1,
		79,
		-1,
		74,
		-1,
		-1,
		-1,
		-1,
		103,
		117,
		138,
		144,
		156,
		-1,
		151,
		145,
		131,
		148,
		149,
		146,
		137,
		129,
		134,
		131,
		144,
		158,
		162,
		102,
		-1,
		85,
		-1,
		-1,
		-1,
		121,
		136,
		198,
		175,
		148,
		152,
		145,
		139,
		139,
		155,
		157,
		168,
		136,
		132,
		133,
		137,
		136,
		153,
		163,
		-1,
		-1,
		85,
		102,
		137,
		129,
		133,
		225,
		-1,
		-1,
		161,
		152,
		143,
		146,
		149,
		152,
		142,
		139,
		144,
		149,
		137,
		146,
		164,
		168,
		-1,
		-1,
		-1,
		105,
		-1,
		120,
		-1,
		-1,
		148,
		232,
		179,
		161,
		157,
		155,
		148,
		157,
		152,
		147,
		157,
		166,
		158,
		139,
		150,
		173,
		162,
		200,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		134,
		109,
		124,
		170,
		168,
		166,
		194,
		191,
		-1,
		161,
		186,
		158,
		165,
		157,
		165,
		165,
		162,
		140,
		147,
		163,
		162,
		157,
		192,
		184,
		190,
		-1,
		-1,
		224,
		213,
		202,
		208,
		-1,
		140,
		126,
		156,
		146,
		152,
		-1,
		-1,
		199,
		196,
		183,
		167,
		171,
		164,
		159,
		169,
		149,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		119,
		200,
		193,
		176,
		184,
		215,
		-1,
		143,
		152,
		133,
		138,
		146,
		-1,
		-1,
		172,
		168,
		173,
		174,
		171,
		179,
		174,
		165,
		150,
		156,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		133,
		176,
		170,
		173,
		197,
		211,
		-1,
		156,
		-1,
		-1,
		141,
		159,
		167,
		163,
		167,
		220,
		188,
		183,
		173,
		171,
		162,
		153,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		168,
		156,
		164,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		157,
		-1,
		193,
		-1,
		186,
		190,
		196,
		199,
		187,
		174,
		166,
		158,
		174,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		242,
		197,
		164,
		155,
		202,
		217,
		221,
		-1,
		169,
		208,
		195,
		-1,
		166,
		-1,
		-1,
		-1,
		200,
		209,
		201,
		207,
		186,
		186,
		160,
		164,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		238,
		236,
		241,
		186,
		169,
		187,
		196,
		217,
		184,
		175,
		202,
		202,
		191,
		186,
		173,
		-1,
		-1,
		223,
		219,
		-1,
		-1,
		193,
		181,
		164,
		165,
		161,
		164,
		179,
		182,
		172,
		170,
		164,
		196,
		-1,
		238,
		237,
		226,
		223,
		199,
		190,
		177,
		188,
		-1,
		-1,
		187,
		203,
		216,
		220,
		233,
		258,
		-1,
		176,
		-1,
		-1,
		238,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		169,
		180,
		190,
		178,
		179,
		169,
		179,
		192,
		222,
		219,
		207,
		205,
		228,
		185,
		181,
		-1,
		202,
		190,
		196,
		203,
		220,
		247,
		-1,
		-1,
		192,
		183,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		171,
		176,
		196,
		198,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		231,
		245,
		234,
		230,
		229,
		237,
		186,
		203,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		227,
		202,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		189,
		193,
		185,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		265,
		-1,
		217,
		210,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		244,
		230,
		223,
		211,
		209,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		223,
		226,
		-1,
		-1,
		248,
		267,
		-1,
		235,
		224,
		209,
		201,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		230,
		231,
		236,
		-1,
		251,
		-1,
		259,
		-1,
		204,
		220,
		222,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		212,
		210,
		201,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		269,
		243,
		266,
		257,
		240,
		220,
		212,
		237,
		-1,
		211,
		-1,
		186,
		188,
		214,
		217,
		223,
		217,
		190,
		205,
		195,
		186,
		195,
		275,
		-1,
		245,
		278,
		242,
		226,
		212,
		216,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		239,
		224,
		205,
		192,
		199,
		199,
		192,
		-1,
		-1,
		-1,
		247,
		246,
		238,
		232,
		232,
		217,
		208,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		229,
		225,
		212,
		212,
		204,
		-1,
		337,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		241,
		236,
		209,
		197,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		205,
		240,
		-1,
		343,
		-1,
		277,
		-1,
		-1,
		259,
		239,
		231,
		220,
		209,
		207,
		198,
		189,
		211,
		227,
		211,
		209,
		212,
		213,
		-1,
		332,
		331,
		-1,
		278,
		270,
		256,
		-1,
		249,
		-1,
		255,
		216,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		319,
		294,
		-1,
		-1,
		-1,
		279,
		259,
		250,
		234,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		304,
		303,
		-1,
		272,
		275,
		-1,
		265,
		256,
		264,
		211,
		215,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		287,
		285,
		280,
		277,
		263,
		247,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		285,
		277,
		270,
		-1,
		-1,
		272,
		255,
		236,
		234,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		262,
		-1,
		-1,
		268,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		296,
		-1,
		-1,
		-1,
		258,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		318,
		319,
		342,
		306,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		321,
		319,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		207,
		209,
		175,
		169,
		208,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		198,
		197,
		167,
		165,
		174,
		179,
		186,
		-1,
		209,
		-1,
		219,
		198,
		209,
		214,
		160,
		157,
		177,
		196,
		202,
		194,
		234,
		190,
		161,
		155,
		173,
		178,
		196,
		188,
		-1,
		161,
		151,
		173,
		177,
		189,
		172,
		-1,
		-1,
		155,
		156,
		162,
		174,
		179,
		184,
		-1,
		207,
		191,
		-1,
		-1,
		145,
		158,
		154,
		157,
		165,
		181,
		199,
		191,
		186,
		-1,
		-1,
		146,
		150,
		163,
		164,
		162,
		186,
		199,
		181,
		195,
		194,
		-1,
		134,
		152,
		161,
		170,
		176,
		162,
		160,
		178,
		180,
		186,
		189,
		-1,
		126,
		128,
		157,
		163,
		175,
		178,
		165,
		165,
		175,
		168,
		187,
		178,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		123,
		131,
		157,
		156,
		152,
		170,
		175,
		168,
		165,
		163,
		160,
		176,
		177,
		187,
		-1,
		-1,
		179,
		148,
		183,
		140,
		125,
		-1,
		119,
		138,
		144,
		148,
		153,
		158,
		172,
		168,
		-1,
		154,
		153,
		184,
		170,
		181,
		139,
		-1,
		-1,
		137,
		129,
		114,
		117,
		114,
		114,
		144,
		143,
		148,
		150,
		149,
		155,
		158,
		158,
		164,
		148,
		158,
		162,
		173,
		188,
		-1,
		-1,
		243,
		-1,
		-1,
		136,
		119,
		-1,
		102,
		109,
		109,
		126,
		116,
		137,
		152,
		156,
		164,
		163,
		151,
		153,
		150,
		163,
		151,
		145,
		170,
		174,
		168,
		189,
		184,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		95,
		98,
		104,
		128,
		138,
		-1,
		159,
		157,
		181,
		172,
		169,
		156,
		144,
		157,
		142,
		149,
		148,
		152,
		154,
		187,
		165,
		187,
		184,
		213,
		218,
		212,
		221,
		-1,
		144,
		140,
		136,
		143,
		92,
		-1,
		-1,
		132,
		-1,
		146,
		159,
		163,
		161,
		164,
		173,
		164,
		151,
		140,
		151,
		140,
		137,
		145,
		154,
		165,
		160,
		159,
		177,
		192,
		205,
		209,
		215,
		-1,
		194,
		-1,
		136,
		120,
		122,
		94,
		115,
		-1,
		152,
		147,
		167,
		165,
		156,
		-1,
		159,
		162,
		169,
		147,
		132,
		149,
		141,
		139,
		144,
		149,
		163,
		154,
		172,
		179,
		187,
		191,
		211,
		223,
		154,
		144,
		-1,
		126,
		131,
		90,
		98,
		117,
		190,
		162,
		-1,
		157,
		-1,
		149,
		174,
		-1,
		153,
		149,
		131,
		132,
		127,
		142,
		148,
		145,
		142,
		160,
		163,
		180,
		184,
		200,
		-1,
		-1,
		139,
		143,
		132,
		83,
		102,
		126,
		163,
		155,
		144,
		143,
		-1,
		134,
		164,
		161,
		147,
		134,
		124,
		125,
		133,
		146,
		125,
		144,
		147,
		169,
		197,
		175,
		187,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		109,
		80,
		104,
		146,
		173,
		166,
		154,
		119,
		119,
		113,
		-1,
		154,
		137,
		133,
		122,
		120,
		133,
		128,
		144,
		148,
		147,
		166,
		178,
		169,
		189,
		-1,
		-1,
		-1,
		139,
		128,
		129,
		75,
		98,
		135,
		152,
		138,
		143,
		118,
		111,
		105,
		157,
		154,
		121,
		129,
		121,
		110,
		124,
		132,
		136,
		145,
		154,
		160,
		184,
		184,
		190,
		-1,
		-1,
		146,
		136,
		120,
		122,
		119,
		89,
		96,
		128,
		143,
		140,
		-1,
		110,
		-1,
		99,
		107,
		106,
		112,
		124,
		110,
		115,
		126,
		138,
		151,
		147,
		154,
		189,
		189,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		139,
		134,
		109,
		86,
		70,
		106,
		-1,
		110,
		111,
		-1,
		104,
		98,
		104,
		103,
		110,
		107,
		107,
		121,
		129,
		125,
		141,
		147,
		139,
		175,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		132,
		111,
		104,
		124,
		65,
		117,
		-1,
		-1,
		95,
		88,
		-1,
		91,
		91,
		98,
		107,
		112,
		117,
		125,
		120,
		133,
		138,
		144,
		149,
		167,
		171,
		175,
		164,
		160,
		157,
		171,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		65,
		85,
		-1,
		104,
		96,
		86,
		80,
		86,
		104,
		102,
		122,
		114,
		128,
		128,
		134,
		142,
		127,
		130,
		146,
		144,
		162,
		170,
		162,
		156,
		155,
		167,
		-1,
		131,
		117,
		88,
		-1,
		-1,
		98,
		-1,
		62,
		86,
		102,
		-1,
		120,
		99,
		122,
		100,
		114,
		110,
		148,
		149,
		127,
		132,
		140,
		150,
		152,
		141,
		152,
		144,
		166,
		166,
		150,
		151,
		160,
		-1,
		137,
		124,
		82,
		77,
		66,
		0,
		59,
		68,
		89,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		124,
		122,
		138,
		129,
		135,
		151,
		154,
		156,
		146,
		135,
		141,
		138,
		160,
		146,
		144,
		163,
		179,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		31,
		55,
		55,
		-1,
		106,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		146,
		130,
		135,
		-1,
		181,
		-1,
		154,
		156,
		150,
		135,
		132,
		143,
		141,
		152,
		169,
		-1,
		79,
		64,
		57,
		47,
		84,
		55,
		-1,
		111,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		162,
		142,
		136,
		135,
		176,
		176,
		162,
		148,
		141,
		138,
		135,
		148,
		168,
		159,
		171,
		-1,
		-1,
		-1,
		84,
		99,
		98,
		63,
		77,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		179,
		167,
		157,
		147,
		181,
		182,
		167,
		160,
		146,
		148,
		146,
		144,
		149,
		170,
		171,
		184,
		-1,
		-1,
		96,
		96,
		84,
		70,
		89,
		-1,
		-1,
		-1,
		138,
		154,
		146,
		117,
		168,
		-1,
		-1,
		159,
		157,
		167,
		163,
		150,
		170,
		173,
		159,
		143,
		158,
		170,
		178,
		183,
		-1,
		99,
		86,
		-1,
		-1,
		92,
		86,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		149,
		170,
		195,
		162,
		-1,
		167,
		168,
		154,
		168,
		175,
		161,
		156,
		150,
		153,
		171,
		188,
		-1,
		-1,
		106,
		-1,
		101,
		-1,
		-1,
		-1,
		-1,
		128,
		142,
		163,
		169,
		181,
		-1,
		176,
		170,
		156,
		173,
		174,
		171,
		162,
		154,
		159,
		156,
		169,
		183,
		187,
		129,
		-1,
		112,
		-1,
		-1,
		-1,
		146,
		161,
		223,
		200,
		173,
		177,
		170,
		164,
		164,
		180,
		182,
		193,
		161,
		157,
		158,
		162,
		161,
		178,
		188,
		-1,
		-1,
		112,
		129,
		164,
		154,
		158,
		250,
		-1,
		-1,
		186,
		177,
		168,
		171,
		174,
		177,
		167,
		164,
		169,
		174,
		162,
		171,
		189,
		193,
		-1,
		-1,
		-1,
		132,
		-1,
		147,
		-1,
		-1,
		173,
		257,
		204,
		186,
		182,
		180,
		173,
		182,
		177,
		172,
		182,
		191,
		183,
		164,
		175,
		198,
		187,
		225,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		161,
		136,
		151,
		197,
		193,
		193,
		219,
		216,
		-1,
		186,
		211,
		183,
		190,
		182,
		190,
		190,
		187,
		165,
		172,
		188,
		187,
		182,
		217,
		209,
		215,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		167,
		153,
		183,
		173,
		179,
		-1,
		-1,
		226,
		223,
		208,
		192,
		196,
		189,
		184,
		194,
		174,
		161,
		165,
		169,
		175,
		180,
		185,
		191,
		206,
		221,
		-1,
		144,
		225,
		218,
		201,
		209,
		240,
		-1,
		170,
		179,
		160,
		165,
		173,
		-1,
		-1,
		199,
		195,
		200,
		199,
		196,
		204,
		199,
		190,
		175,
		181,
		168,
		167,
		185,
		189,
		198,
		205,
		195,
		208,
		212,
		-1,
		158,
		201,
		195,
		198,
		222,
		236,
		-1,
		183,
		-1,
		-1,
		168,
		186,
		194,
		190,
		194,
		247,
		213,
		208,
		198,
		196,
		187,
		178,
		185,
		176,
		176,
		179,
		194,
		199,
		191,
		205,
		205,
		206,
		-1,
		193,
		181,
		189,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		184,
		-1,
		220,
		-1,
		213,
		217,
		221,
		224,
		212,
		199,
		191,
		183,
		199,
		174,
		184,
		180,
		181,
		190,
		201,
		213,
		212,
		213,
		267,
		222,
		189,
		180,
		227,
		242,
		246,
		-1,
		196,
		235,
		222,
		-1,
		193,
		-1,
		-1,
		-1,
		227,
		234,
		226,
		232,
		211,
		211,
		185,
		189,
		179,
		186,
		196,
		198,
		190,
		194,
		207,
		218,
		221,
		263,
		261,
		266,
		211,
		194,
		212,
		221,
		242,
		211,
		202,
		229,
		229,
		218,
		213,
		200,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		218,
		206,
		189,
		190,
		186,
		189,
		204,
		207,
		197,
		195,
		189,
		221,
		-1,
		263,
		262,
		251,
		248,
		224,
		215,
		202,
		213,
		-1,
		-1,
		214,
		230,
		243,
		247,
		260,
		285,
		-1,
		203,
		-1,
		-1,
		263,
		-1,
		-1,
		248,
		211,
		200,
		191,
		197,
		194,
		205,
		215,
		203,
		204,
		194,
		204,
		217,
		247,
		244,
		232,
		230,
		253,
		210,
		206,
		-1,
		229,
		217,
		223,
		230,
		247,
		274,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		246,
		244,
		233,
		-1,
		223,
		196,
		201,
		221,
		223,
		212,
		206,
		200,
		207,
		206,
		214,
		222,
		256,
		270,
		259,
		255,
		254,
		262,
		211,
		228,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		-1,
		254,
		229,
		-1,
		-1,
		241,
		234,
		222,
		210,
		200,
		210,
		214,
		218,
		210,
		203,
		198,
		209,
		201,
		205,
		222,
		-1,
		290,
		-1,
		242,
		235,
		250,
		265,
		273,
		-1,
		-1,
		-1,
		271,
		257,
		250,
		238,
		236,
		-1,
		275,
		259,
		240,
		-1,
		210,
		223,
		254,
		222,
		227,
		222,
		204,
		215,
		204,
		207,
		221,
		216,
		-1,
		-1,
		248,
		251,
		-1,
		-1,
		273,
		292,
		-1,
		262,
		251,
		236,
		228,
		-1,
		-1,
		247,
		243,
		-1,
		-1,
		211,
		236,
		225,
		233,
		228,
		208,
		214,
		217,
		206,
		210,
		222,
		-1,
		-1,
		255,
		256,
		261,
		-1,
		276,
		-1,
		286,
		-1,
		231,
		247,
		249,
		-1,
		-1,
		-1,
		249,
		212,
		233,
		243,
		237,
		235,
		226,
		212,
		219,
		217,
		213,
		224,
		-1,
		-1,
		-1,
		294,
		268,
		293,
		284,
		267,
		247,
		239,
		264,
		-1,
		236,
		-1,
		211,
		213,
		239,
		242,
		248,
		242,
		215,
		230,
		220,
		211,
		220,
		300,
		-1,
		270,
		303,
		267,
		253,
		237,
		241,
		257,
		-1,
		233,
		215,
		-1,
		243,
		233,
		264,
		249,
		230,
		217,
		224,
		224,
		217,
		-1,
		-1,
		-1,
		272,
		271,
		263,
		257,
		257,
		242,
		233,
		-1,
		245,
		227,
		206,
		223,
		223,
		214,
		222,
		254,
		250,
		237,
		237,
		229,
		-1,
		362,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		266,
		261,
		234,
		222,
		228,
		224,
		210,
		216,
		218,
		226,
		224,
		221,
		233,
		229,
		249,
		230,
		265,
		-1,
		368,
		-1,
		302,
		-1,
		-1,
		284,
		264,
		256,
		245,
		234,
		232,
		223,
		214,
		236,
		252,
		236,
		234,
		237,
		238,
		-1,
		357,
		356,
		-1,
		303,
		295,
		281,
		-1,
		274,
		-1,
		280,
		241,
		-1,
		243,
		223,
		-1,
		245,
		241,
		-1,
		-1,
		344,
		319,
		-1,
		-1,
		-1,
		304,
		284,
		275,
		259,
		-1,
		234,
		234,
		-1,
		-1,
		-1,
		329,
		328,
		-1,
		297,
		300,
		-1,
		290,
		281,
		289,
		236,
		240,
		-1,
		-1,
		-1,
		338,
		319,
		313,
		312,
		310,
		305,
		302,
		288,
		272,
		250,
		239,
		260,
		-1,
		-1,
		-1,
		310,
		302,
		295,
		-1,
		-1,
		297,
		280,
		261,
		259,
		-1,
		-1,
		-1,
		332,
		313,
		-1,
		-1,
		287,
		-1,
		-1,
		293,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		349,
		321,
		-1,
		-1,
		-1,
		283,
		279,
		280,
		-1,
		-1,
		-1,
		-1,
		343,
		344,
		367,
		331,
		-1,
		-1,
		-1,
		275,
		269,
		-1,
		-1,
		346,
		344,
		-1,
		-1,
		-1,
		303,
		287,
		-1,
		273,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		308,
		-1,
		308,
		283,
		290,
		-1,
		-1,
		-1,
		-1,
		321,
		313,
		321,
		-1,
		293,
		295,
		-1,
		343,
		-1,
		-1,
		336,
		327,
		-1,
		-1,
		298,
		305,
		327,
		330,
		366,
		-1,
		317
	],
	[
		-1,
		145,
		134,
		145,
		153,
		126,
		133,
		-1,
		154,
		156,
		122,
		116,
		155,
		126,
		132,
		143,
		-1,
		-1,
		-1,
		145,
		144,
		114,
		112,
		121,
		126,
		133,
		-1,
		156,
		-1,
		166,
		145,
		156,
		161,
		107,
		104,
		124,
		143,
		149,
		141,
		181,
		137,
		108,
		102,
		120,
		125,
		143,
		135,
		-1,
		108,
		98,
		120,
		124,
		136,
		119,
		-1,
		-1,
		102,
		103,
		109,
		121,
		126,
		131,
		-1,
		157,
		142,
		-1,
		-1,
		92,
		105,
		101,
		104,
		112,
		128,
		149,
		142,
		137,
		-1,
		-1,
		93,
		97,
		110,
		111,
		109,
		136,
		150,
		132,
		146,
		145,
		-1,
		81,
		99,
		108,
		117,
		123,
		112,
		111,
		129,
		131,
		137,
		140,
		-1,
		73,
		75,
		104,
		110,
		122,
		128,
		115,
		116,
		126,
		119,
		138,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		76,
		70,
		78,
		104,
		103,
		99,
		117,
		126,
		118,
		116,
		114,
		111,
		127,
		128,
		138,
		-1,
		-1,
		126,
		95,
		130,
		87,
		72,
		-1,
		66,
		85,
		91,
		95,
		100,
		108,
		123,
		119,
		-1,
		105,
		104,
		135,
		121,
		132,
		86,
		-1,
		-1,
		84,
		76,
		61,
		64,
		61,
		61,
		91,
		90,
		95,
		97,
		99,
		106,
		109,
		109,
		115,
		99,
		109,
		113,
		124,
		139,
		-1,
		-1,
		194,
		-1,
		-1,
		83,
		66,
		-1,
		49,
		56,
		56,
		73,
		63,
		84,
		99,
		103,
		111,
		114,
		102,
		104,
		101,
		114,
		102,
		96,
		121,
		125,
		119,
		140,
		135,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		61,
		42,
		45,
		51,
		75,
		85,
		-1,
		106,
		104,
		128,
		122,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		103,
		105,
		138,
		116,
		138,
		135,
		164,
		169,
		163,
		172,
		-1,
		91,
		87,
		83,
		90,
		39,
		-1,
		-1,
		79,
		-1,
		93,
		106,
		114,
		108,
		111,
		123,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		105,
		116,
		111,
		110,
		128,
		143,
		156,
		160,
		166,
		-1,
		141,
		-1,
		83,
		67,
		69,
		41,
		62,
		-1,
		99,
		94,
		114,
		116,
		107,
		-1,
		110,
		113,
		120,
		98,
		83,
		100,
		92,
		90,
		95,
		100,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		101,
		91,
		-1,
		73,
		78,
		37,
		45,
		64,
		137,
		113,
		-1,
		108,
		-1,
		100,
		125,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		99,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		86,
		90,
		79,
		30,
		49,
		73,
		110,
		106,
		95,
		94,
		-1,
		85,
		115,
		112,
		98,
		85,
		75,
		76,
		84,
		97,
		76,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		56,
		27,
		51,
		93,
		124,
		117,
		105,
		70,
		70,
		64,
		-1,
		105,
		88,
		84,
		73,
		71,
		84,
		79,
		95,
		99,
		98,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		86,
		75,
		76,
		22,
		45,
		82,
		103,
		89,
		94,
		69,
		62,
		56,
		108,
		105,
		72,
		80,
		72,
		61,
		75,
		83,
		87,
		96,
		105,
		111,
		135,
		135,
		141,
		-1,
		-1,
		93,
		83,
		67,
		69,
		66,
		36,
		43,
		75,
		94,
		91,
		-1,
		61,
		-1,
		50,
		58,
		57,
		63,
		75,
		61,
		66,
		77,
		89,
		102,
		98,
		105,
		140,
		140,
		125,
		145,
		148,
		-1,
		-1,
		-1,
		86,
		79,
		54,
		31,
		17,
		53,
		-1,
		61,
		62,
		-1,
		55,
		49,
		55,
		54,
		61,
		58,
		58,
		72,
		80,
		76,
		92,
		98,
		90,
		126,
		-1,
		133,
		127,
		135,
		125,
		113,
		-1,
		-1,
		-1,
		77,
		56,
		49,
		69,
		10,
		62,
		-1,
		-1,
		46,
		39,
		-1,
		42,
		42,
		49,
		58,
		63,
		68,
		76,
		71,
		84,
		89,
		95,
		100,
		118,
		122,
		126,
		115,
		111,
		108,
		122,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		6,
		30,
		-1,
		54,
		46,
		37,
		31,
		37,
		55,
		53,
		73,
		65,
		79,
		79,
		85,
		93,
		78,
		81,
		97,
		95,
		113,
		121,
		113,
		107,
		106,
		118,
		-1,
		103,
		89,
		60,
		-1,
		-1,
		39,
		-1,
		3,
		27,
		43,
		-1,
		71,
		50,
		73,
		51,
		65,
		61,
		99,
		100,
		78,
		83,
		91,
		101,
		103,
		92,
		103,
		95,
		117,
		117,
		101,
		102,
		111,
		-1,
		109,
		96,
		54,
		50,
		39,
		59,
		0,
		19,
		30,
		-1,
		-1,
		115,
		-1,
		49,
		66,
		75,
		73,
		89,
		80,
		86,
		102,
		105,
		107,
		97,
		86,
		92,
		89,
		111,
		97,
		95,
		114,
		130,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		25,
		12,
		6,
		-1,
		47,
		-1,
		93,
		83,
		67,
		52,
		85,
		-1,
		97,
		81,
		86,
		-1,
		132,
		-1,
		105,
		107,
		101,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		59,
		44,
		37,
		27,
		41,
		12,
		-1,
		67,
		-1,
		-1,
		80,
		74,
		74,
		58,
		61,
		113,
		93,
		87,
		86,
		127,
		127,
		113,
		99,
		92,
		89,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		64,
		50,
		54,
		14,
		33,
		-1,
		-1,
		142,
		97,
		83,
		-1,
		67,
		130,
		118,
		108,
		98,
		132,
		133,
		118,
		111,
		97,
		99,
		97,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		47,
		52,
		40,
		26,
		45,
		-1,
		-1,
		-1,
		89,
		105,
		97,
		68,
		119,
		-1,
		-1,
		110,
		108,
		118,
		114,
		101,
		121,
		124,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		50,
		37,
		-1,
		-1,
		48,
		42,
		-1,
		-1,
		-1,
		-1,
		122,
		88,
		100,
		121,
		146,
		113,
		-1,
		118,
		119,
		105,
		119,
		126,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		62,
		-1,
		57,
		-1,
		-1,
		-1,
		-1,
		79,
		93,
		114,
		120,
		132,
		-1,
		127,
		121,
		107,
		124,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		85,
		-1,
		68,
		-1,
		-1,
		-1,
		97,
		112,
		174,
		151,
		124,
		128,
		121,
		115,
		115,
		131,
		133,
		144,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		68,
		85,
		120,
		105,
		109,
		201,
		-1,
		-1,
		137,
		128,
		119,
		122,
		125,
		128,
		118,
		115,
		120,
		125,
		113,
		122,
		140,
		144,
		-1,
		-1,
		-1,
		88,
		-1,
		103,
		-1,
		-1,
		124,
		208,
		155,
		137,
		133,
		131,
		124,
		133,
		128,
		123,
		133,
		142,
		134,
		115,
		126,
		149,
		138,
		176,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		117,
		92,
		107,
		153,
		144,
		149,
		170,
		167,
		-1,
		137,
		162,
		134,
		141,
		133,
		141,
		141,
		138,
		116,
		123,
		139,
		138,
		133,
		168,
		160,
		166,
		-1,
		-1,
		200,
		189,
		178,
		184,
		-1,
		123,
		109,
		139,
		129,
		135,
		-1,
		-1,
		182,
		179,
		159,
		143,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		95,
		176,
		169,
		152,
		160,
		191,
		-1,
		126,
		135,
		116,
		121,
		129,
		-1,
		-1,
		155,
		151,
		156,
		150,
		147,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		109,
		152,
		146,
		149,
		173,
		187,
		-1,
		139,
		-1,
		-1,
		124,
		142,
		150,
		146,
		150,
		203,
		164,
		159,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		144,
		132,
		140,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		140,
		-1,
		176,
		-1,
		169,
		173,
		172,
		175,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		218,
		173,
		140,
		131,
		178,
		193,
		197,
		-1,
		152,
		191,
		178,
		-1,
		149,
		-1,
		-1,
		-1,
		183,
		185,
		177,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		214,
		212,
		217,
		162,
		145,
		163,
		172,
		193,
		167,
		158,
		185,
		185,
		174,
		169,
		156,
		-1,
		-1,
		206,
		195,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		153,
		164,
		-1,
		-1,
		170,
		186,
		199,
		203,
		216,
		241,
		-1,
		159,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		198,
		195,
		183,
		181,
		204,
		161,
		157,
		-1,
		185,
		173,
		179,
		186,
		203,
		230,
		-1,
		-1,
		175,
		166,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		179,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		210,
		185,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		241,
		-1,
		193,
		186,
		201,
		216,
		224,
		-1,
		-1,
		-1,
		227,
		213,
		206,
		194,
		192,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		199,
		202,
		-1,
		-1,
		224,
		243,
		-1,
		218,
		207,
		192,
		184,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		206,
		207,
		212,
		-1,
		227,
		-1,
		242,
		-1,
		187,
		203,
		205,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		249,
		240,
		223,
		203,
		195,
		217,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		209,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		313,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		319,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		151,
		140,
		151,
		159,
		132,
		139,
		-1,
		160,
		162,
		128,
		122,
		161,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		151,
		150,
		120,
		118,
		127,
		132,
		139,
		-1,
		162,
		-1,
		172,
		151,
		162,
		167,
		113,
		110,
		130,
		149,
		155,
		147,
		187,
		143,
		114,
		108,
		126,
		131,
		149,
		141,
		-1,
		114,
		104,
		126,
		130,
		142,
		125,
		-1,
		-1,
		108,
		109,
		115,
		127,
		132,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		98,
		111,
		107,
		110,
		118,
		118,
		131,
		123,
		118,
		-1,
		-1,
		99,
		103,
		116,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		87,
		105,
		114,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		121,
		-1,
		79,
		81,
		110,
		116,
		126,
		110,
		97,
		97,
		107,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		76,
		84,
		110,
		109,
		99,
		114,
		107,
		100,
		97,
		95,
		92,
		108,
		109,
		119,
		-1,
		-1,
		132,
		101,
		136,
		93,
		78,
		-1,
		72,
		91,
		97,
		101,
		97,
		90,
		104,
		100,
		-1,
		86,
		85,
		116,
		102,
		113,
		92,
		-1,
		-1,
		90,
		82,
		67,
		70,
		67,
		67,
		97,
		96,
		99,
		85,
		81,
		87,
		90,
		90,
		96,
		80,
		90,
		94,
		105,
		120,
		-1,
		-1,
		175,
		-1,
		-1,
		89,
		72,
		-1,
		55,
		62,
		62,
		79,
		69,
		90,
		105,
		109,
		101,
		95,
		83,
		85,
		82,
		95,
		83,
		77,
		102,
		106,
		100,
		121,
		116,
		-1,
		174,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		48,
		51,
		57,
		81,
		91,
		-1,
		103,
		109,
		119,
		104,
		101,
		88,
		76,
		89,
		74,
		81,
		80,
		84,
		86,
		119,
		97,
		119,
		116,
		145,
		150,
		144,
		153,
		-1,
		97,
		93,
		89,
		96,
		45,
		-1,
		-1,
		85,
		-1,
		99,
		112,
		95,
		113,
		116,
		105,
		96,
		83,
		72,
		83,
		72,
		69,
		77,
		86,
		97,
		92,
		91,
		109,
		124,
		137,
		141,
		147,
		-1,
		147,
		-1,
		89,
		73,
		75,
		47,
		68,
		-1,
		105,
		100,
		112,
		97,
		88,
		-1,
		91,
		94,
		101,
		79,
		64,
		81,
		73,
		71,
		76,
		81,
		95,
		86,
		104,
		111,
		119,
		123,
		143,
		155,
		107,
		97,
		-1,
		79,
		84,
		43,
		51,
		70,
		130,
		94,
		-1,
		89,
		-1,
		81,
		106,
		-1,
		85,
		81,
		63,
		64,
		59,
		74,
		80,
		77,
		74,
		92,
		95,
		112,
		116,
		132,
		-1,
		-1,
		92,
		96,
		85,
		36,
		55,
		79,
		116,
		87,
		76,
		75,
		-1,
		66,
		96,
		93,
		79,
		66,
		56,
		57,
		65,
		78,
		57,
		76,
		79,
		101,
		129,
		107,
		119,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		62,
		33,
		57,
		99,
		105,
		98,
		86,
		51,
		51,
		45,
		-1,
		86,
		69,
		65,
		54,
		52,
		65,
		60,
		76,
		80,
		79,
		98,
		110,
		101,
		121,
		-1,
		-1,
		-1,
		92,
		81,
		82,
		28,
		51,
		88,
		84,
		70,
		75,
		50,
		43,
		37,
		89,
		86,
		53,
		61,
		53,
		42,
		56,
		64,
		68,
		77,
		86,
		92,
		116,
		116,
		122,
		-1,
		-1,
		99,
		89,
		73,
		75,
		72,
		42,
		49,
		81,
		75,
		72,
		-1,
		42,
		-1,
		31,
		39,
		38,
		44,
		56,
		42,
		47,
		58,
		70,
		83,
		79,
		86,
		121,
		121,
		106,
		126,
		129,
		-1,
		-1,
		-1,
		92,
		87,
		62,
		39,
		23,
		59,
		-1,
		42,
		43,
		-1,
		36,
		30,
		36,
		35,
		42,
		39,
		39,
		53,
		61,
		57,
		73,
		79,
		71,
		107,
		-1,
		114,
		108,
		116,
		106,
		94,
		-1,
		-1,
		-1,
		85,
		64,
		57,
		77,
		18,
		70,
		-1,
		-1,
		27,
		20,
		-1,
		23,
		23,
		30,
		39,
		44,
		49,
		57,
		52,
		65,
		70,
		76,
		81,
		99,
		103,
		107,
		96,
		92,
		89,
		103,
		-1,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		18,
		38,
		-1,
		36,
		28,
		18,
		12,
		18,
		36,
		34,
		54,
		46,
		60,
		60,
		66,
		74,
		59,
		62,
		78,
		76,
		94,
		102,
		94,
		88,
		87,
		99,
		-1,
		105,
		91,
		62,
		-1,
		-1,
		51,
		-1,
		15,
		39,
		55,
		-1,
		52,
		31,
		54,
		32,
		46,
		42,
		80,
		81,
		59,
		64,
		72,
		82,
		84,
		73,
		84,
		76,
		98,
		98,
		82,
		83,
		92,
		-1,
		111,
		98,
		56,
		52,
		41,
		61,
		12,
		0,
		42,
		-1,
		-1,
		96,
		-1,
		30,
		47,
		56,
		54,
		70,
		61,
		67,
		83,
		86,
		88,
		78,
		67,
		73,
		70,
		92,
		78,
		76,
		95,
		111,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		27,
		14,
		8,
		-1,
		59,
		-1,
		74,
		64,
		48,
		33,
		66,
		-1,
		78,
		62,
		67,
		-1,
		113,
		-1,
		86,
		88,
		82,
		67,
		64,
		75,
		73,
		84,
		101,
		-1,
		61,
		46,
		39,
		29,
		43,
		14,
		-1,
		69,
		-1,
		-1,
		61,
		55,
		55,
		39,
		42,
		94,
		74,
		68,
		67,
		108,
		108,
		94,
		80,
		73,
		70,
		67,
		80,
		100,
		91,
		103,
		-1,
		-1,
		-1,
		66,
		52,
		56,
		16,
		35,
		-1,
		-1,
		123,
		78,
		64,
		-1,
		48,
		111,
		99,
		89,
		79,
		113,
		114,
		99,
		92,
		78,
		80,
		78,
		76,
		81,
		102,
		103,
		116,
		-1,
		-1,
		49,
		54,
		42,
		28,
		47,
		-1,
		-1,
		-1,
		70,
		86,
		78,
		49,
		100,
		-1,
		-1,
		91,
		89,
		99,
		95,
		82,
		102,
		105,
		91,
		75,
		90,
		102,
		110,
		115,
		-1,
		52,
		39,
		-1,
		-1,
		50,
		44,
		-1,
		-1,
		-1,
		-1,
		103,
		69,
		81,
		102,
		127,
		94,
		-1,
		99,
		100,
		86,
		100,
		107,
		93,
		88,
		82,
		85,
		103,
		120,
		-1,
		-1,
		64,
		-1,
		59,
		-1,
		-1,
		-1,
		-1,
		60,
		74,
		95,
		101,
		113,
		-1,
		108,
		102,
		88,
		105,
		106,
		103,
		94,
		86,
		91,
		88,
		101,
		115,
		119,
		87,
		-1,
		70,
		-1,
		-1,
		-1,
		78,
		93,
		155,
		132,
		105,
		109,
		102,
		96,
		96,
		112,
		114,
		125,
		93,
		89,
		90,
		94,
		93,
		110,
		120,
		-1,
		-1,
		70,
		87,
		104,
		86,
		90,
		182,
		-1,
		-1,
		118,
		109,
		100,
		103,
		106,
		109,
		99,
		96,
		101,
		106,
		94,
		103,
		121,
		125,
		-1,
		-1,
		-1,
		90,
		-1,
		105,
		-1,
		-1,
		105,
		189,
		136,
		118,
		114,
		112,
		105,
		114,
		109,
		104,
		114,
		123,
		115,
		96,
		107,
		130,
		119,
		157,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		119,
		94,
		109,
		155,
		125,
		132,
		151,
		148,
		-1,
		118,
		143,
		115,
		122,
		114,
		122,
		122,
		119,
		97,
		104,
		120,
		119,
		114,
		149,
		141,
		147,
		-1,
		-1,
		202,
		191,
		180,
		186,
		-1,
		125,
		111,
		141,
		131,
		137,
		-1,
		-1,
		167,
		164,
		140,
		124,
		128,
		121,
		116,
		126,
		106,
		93,
		97,
		101,
		107,
		112,
		117,
		123,
		138,
		153,
		-1,
		97,
		178,
		171,
		154,
		162,
		193,
		-1,
		128,
		137,
		118,
		123,
		131,
		-1,
		-1,
		140,
		137,
		142,
		131,
		128,
		136,
		131,
		122,
		107,
		113,
		100,
		99,
		117,
		121,
		130,
		137,
		127,
		140,
		144,
		-1,
		111,
		154,
		148,
		151,
		175,
		189,
		-1,
		141,
		-1,
		-1,
		126,
		144,
		152,
		145,
		139,
		189,
		145,
		140,
		130,
		128,
		119,
		110,
		117,
		108,
		108,
		111,
		126,
		131,
		123,
		137,
		137,
		138,
		-1,
		146,
		134,
		142,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		142,
		-1,
		178,
		-1,
		157,
		161,
		153,
		156,
		144,
		131,
		123,
		115,
		131,
		106,
		116,
		112,
		113,
		122,
		133,
		145,
		144,
		145,
		220,
		175,
		142,
		133,
		180,
		195,
		199,
		-1,
		154,
		193,
		180,
		-1,
		151,
		-1,
		-1,
		-1,
		171,
		166,
		158,
		164,
		143,
		143,
		117,
		121,
		111,
		118,
		128,
		130,
		122,
		126,
		139,
		150,
		153,
		216,
		214,
		219,
		164,
		147,
		165,
		174,
		195,
		169,
		160,
		187,
		187,
		176,
		171,
		158,
		-1,
		-1,
		194,
		176,
		-1,
		-1,
		150,
		138,
		121,
		122,
		118,
		121,
		136,
		139,
		129,
		127,
		121,
		153,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		155,
		166,
		-1,
		-1,
		172,
		188,
		201,
		205,
		218,
		243,
		-1,
		161,
		-1,
		-1,
		195,
		-1,
		-1,
		180,
		143,
		132,
		123,
		129,
		126,
		137,
		147,
		135,
		136,
		126,
		136,
		149,
		200,
		197,
		185,
		183,
		206,
		163,
		159,
		-1,
		187,
		175,
		181,
		188,
		205,
		232,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		178,
		176,
		165,
		-1,
		155,
		128,
		133,
		153,
		155,
		144,
		138,
		132,
		139,
		138,
		146,
		154,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		212,
		187,
		-1,
		-1,
		173,
		166,
		154,
		142,
		132,
		142,
		146,
		150,
		142,
		135,
		130,
		141,
		133,
		137,
		154,
		-1,
		243,
		-1,
		195,
		188,
		203,
		218,
		226,
		-1,
		-1,
		-1,
		229,
		215,
		208,
		196,
		194,
		-1,
		207,
		191,
		172,
		-1,
		142,
		155,
		186,
		154,
		159,
		154,
		136,
		147,
		136,
		139,
		153,
		148,
		-1,
		-1,
		201,
		204,
		-1,
		-1,
		223,
		225,
		-1,
		220,
		209,
		194,
		186,
		-1,
		-1,
		179,
		175,
		-1,
		-1,
		143,
		168,
		157,
		165,
		160,
		140,
		146,
		149,
		138,
		142,
		154,
		-1,
		-1,
		208,
		209,
		214,
		-1,
		208,
		-1,
		226,
		-1,
		189,
		199,
		187,
		-1,
		-1,
		-1,
		181,
		144,
		165,
		175,
		169,
		167,
		158,
		144,
		151,
		149,
		145,
		156,
		-1,
		-1,
		-1,
		226,
		200,
		233,
		224,
		207,
		187,
		179,
		198,
		-1,
		168,
		-1,
		143,
		145,
		171,
		174,
		180,
		174,
		147,
		162,
		152,
		143,
		152,
		232,
		-1,
		202,
		235,
		199,
		193,
		169,
		173,
		189,
		-1,
		165,
		147,
		-1,
		175,
		165,
		196,
		181,
		162,
		149,
		156,
		156,
		149,
		-1,
		-1,
		-1,
		204,
		203,
		195,
		189,
		189,
		174,
		165,
		-1,
		177,
		159,
		138,
		155,
		155,
		146,
		154,
		186,
		182,
		169,
		169,
		161,
		-1,
		305,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		198,
		193,
		166,
		154,
		160,
		156,
		142,
		148,
		150,
		158,
		156,
		153,
		165,
		161,
		181,
		162,
		197,
		-1,
		300,
		-1,
		234,
		-1,
		-1,
		216,
		196,
		188,
		177,
		166,
		164,
		155,
		146,
		168,
		184,
		168,
		166,
		169,
		170,
		-1,
		289,
		288,
		-1,
		235,
		227,
		213,
		-1,
		206,
		-1,
		212,
		173,
		-1,
		175,
		155,
		-1,
		177,
		173,
		-1,
		-1,
		276,
		251,
		-1,
		-1,
		-1,
		236,
		216,
		207,
		191,
		-1,
		166,
		166,
		-1,
		-1,
		-1,
		261,
		260,
		-1,
		229,
		232,
		-1,
		222,
		213,
		221,
		168,
		172,
		-1,
		-1,
		-1,
		270,
		251,
		245,
		244,
		242,
		237,
		234,
		220,
		204,
		182,
		171,
		192,
		-1,
		-1,
		-1,
		242,
		234,
		227,
		-1,
		-1,
		229,
		212,
		193,
		191,
		-1,
		-1,
		-1,
		264,
		245,
		-1,
		-1,
		219,
		-1,
		-1,
		225,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		253,
		-1,
		-1,
		-1,
		215,
		211,
		212,
		-1,
		-1,
		-1,
		-1,
		275,
		276,
		299,
		263,
		-1,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		278,
		276,
		-1,
		-1,
		-1,
		235,
		219,
		-1,
		205,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		240,
		-1,
		240,
		215,
		222,
		-1,
		-1,
		-1,
		-1,
		253,
		245,
		253,
		-1,
		225,
		227,
		-1,
		275,
		-1,
		-1,
		268,
		259,
		-1,
		-1,
		230,
		237,
		259,
		262,
		298,
		-1,
		249
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		180,
		182,
		148,
		142,
		181,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		171,
		170,
		140,
		138,
		147,
		152,
		159,
		-1,
		182,
		-1,
		192,
		171,
		182,
		187,
		133,
		130,
		150,
		169,
		175,
		167,
		207,
		163,
		134,
		128,
		146,
		151,
		169,
		161,
		-1,
		134,
		124,
		146,
		150,
		162,
		145,
		-1,
		-1,
		128,
		129,
		135,
		147,
		152,
		157,
		-1,
		175,
		159,
		-1,
		-1,
		118,
		131,
		127,
		130,
		138,
		154,
		167,
		159,
		154,
		-1,
		-1,
		119,
		123,
		136,
		137,
		135,
		154,
		167,
		149,
		163,
		162,
		-1,
		107,
		125,
		134,
		143,
		146,
		130,
		128,
		146,
		148,
		154,
		157,
		-1,
		99,
		101,
		130,
		136,
		148,
		146,
		133,
		133,
		143,
		136,
		155,
		146,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		96,
		104,
		130,
		129,
		125,
		143,
		143,
		136,
		133,
		131,
		128,
		144,
		145,
		155,
		-1,
		-1,
		152,
		121,
		156,
		113,
		98,
		-1,
		92,
		111,
		117,
		121,
		126,
		126,
		140,
		136,
		-1,
		122,
		121,
		152,
		138,
		149,
		112,
		-1,
		-1,
		110,
		102,
		87,
		90,
		87,
		87,
		117,
		116,
		121,
		121,
		117,
		123,
		126,
		126,
		132,
		116,
		126,
		130,
		141,
		156,
		-1,
		-1,
		211,
		-1,
		-1,
		109,
		92,
		-1,
		75,
		82,
		82,
		99,
		89,
		110,
		125,
		129,
		137,
		131,
		119,
		121,
		118,
		131,
		119,
		113,
		138,
		142,
		136,
		157,
		152,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		68,
		71,
		77,
		101,
		111,
		-1,
		132,
		130,
		154,
		140,
		137,
		124,
		112,
		125,
		110,
		117,
		116,
		120,
		122,
		155,
		133,
		155,
		152,
		181,
		186,
		180,
		189,
		-1,
		117,
		113,
		109,
		116,
		65,
		-1,
		-1,
		105,
		-1,
		119,
		132,
		131,
		134,
		137,
		141,
		132,
		119,
		108,
		119,
		108,
		105,
		113,
		122,
		133,
		128,
		127,
		145,
		160,
		173,
		177,
		183,
		-1,
		167,
		-1,
		109,
		93,
		95,
		67,
		88,
		-1,
		125,
		120,
		140,
		133,
		124,
		-1,
		127,
		130,
		137,
		115,
		100,
		117,
		109,
		107,
		112,
		117,
		131,
		122,
		140,
		147,
		155,
		159,
		179,
		191,
		127,
		117,
		-1,
		99,
		104,
		63,
		71,
		90,
		163,
		130,
		-1,
		125,
		-1,
		117,
		142,
		-1,
		121,
		117,
		99,
		100,
		95,
		110,
		116,
		113,
		110,
		128,
		131,
		148,
		152,
		168,
		-1,
		-1,
		112,
		116,
		105,
		56,
		75,
		99,
		136,
		123,
		112,
		111,
		-1,
		102,
		132,
		129,
		115,
		102,
		92,
		93,
		101,
		114,
		93,
		112,
		115,
		137,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		82,
		53,
		77,
		119,
		141,
		134,
		122,
		87,
		87,
		81,
		-1,
		122,
		105,
		101,
		90,
		88,
		101,
		96,
		112,
		116,
		115,
		134,
		146,
		137,
		157,
		-1,
		-1,
		-1,
		112,
		101,
		102,
		48,
		71,
		108,
		120,
		106,
		111,
		86,
		79,
		73,
		125,
		122,
		89,
		97,
		89,
		78,
		92,
		100,
		104,
		113,
		122,
		128,
		152,
		152,
		158,
		-1,
		-1,
		119,
		109,
		93,
		95,
		92,
		62,
		69,
		101,
		111,
		110,
		-1,
		78,
		-1,
		67,
		75,
		74,
		80,
		92,
		78,
		83,
		94,
		106,
		119,
		115,
		122,
		157,
		157,
		142,
		162,
		165,
		-1,
		-1,
		-1,
		112,
		105,
		80,
		57,
		43,
		79,
		-1,
		80,
		81,
		-1,
		72,
		66,
		72,
		71,
		78,
		75,
		75,
		89,
		97,
		93,
		109,
		115,
		107,
		143,
		-1,
		150,
		144,
		152,
		142,
		130,
		-1,
		-1,
		-1,
		103,
		82,
		75,
		95,
		36,
		88,
		-1,
		-1,
		65,
		58,
		-1,
		59,
		59,
		66,
		75,
		80,
		85,
		93,
		88,
		101,
		106,
		112,
		117,
		135,
		139,
		143,
		132,
		128,
		125,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		32,
		56,
		-1,
		43,
		35,
		47,
		50,
		56,
		72,
		70,
		90,
		82,
		96,
		96,
		102,
		110,
		95,
		98,
		114,
		112,
		130,
		138,
		130,
		124,
		123,
		135,
		-1,
		135,
		121,
		92,
		-1,
		-1,
		65,
		-1,
		29,
		3,
		13,
		-1,
		90,
		69,
		90,
		68,
		82,
		78,
		116,
		117,
		95,
		100,
		108,
		118,
		120,
		109,
		120,
		112,
		134,
		134,
		118,
		119,
		128,
		-1,
		141,
		128,
		86,
		82,
		71,
		91,
		32,
		51,
		0,
		-1,
		-1,
		132,
		-1,
		66,
		83,
		92,
		90,
		106,
		97,
		103,
		119,
		122,
		124,
		114,
		103,
		109,
		106,
		128,
		114,
		112,
		131,
		147,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		57,
		44,
		38,
		-1,
		17,
		-1,
		110,
		100,
		84,
		69,
		102,
		-1,
		114,
		98,
		103,
		-1,
		149,
		-1,
		122,
		124,
		118,
		103,
		100,
		111,
		109,
		120,
		137,
		-1,
		91,
		76,
		69,
		59,
		73,
		44,
		-1,
		90,
		-1,
		-1,
		97,
		91,
		91,
		75,
		78,
		130,
		110,
		104,
		103,
		144,
		144,
		130,
		116,
		109,
		106,
		103,
		116,
		136,
		127,
		139,
		-1,
		-1,
		-1,
		96,
		71,
		77,
		35,
		56,
		-1,
		-1,
		159,
		114,
		100,
		-1,
		84,
		147,
		135,
		125,
		115,
		149,
		150,
		135,
		128,
		114,
		116,
		114,
		112,
		117,
		138,
		139,
		152,
		-1,
		-1,
		68,
		75,
		63,
		49,
		68,
		-1,
		-1,
		-1,
		106,
		122,
		114,
		85,
		136,
		-1,
		-1,
		127,
		125,
		135,
		131,
		118,
		138,
		141,
		127,
		111,
		126,
		138,
		146,
		151,
		-1,
		71,
		58,
		-1,
		-1,
		71,
		65,
		-1,
		-1,
		-1,
		-1,
		139,
		105,
		117,
		138,
		163,
		130,
		-1,
		135,
		136,
		122,
		136,
		143,
		129,
		124,
		118,
		121,
		139,
		156,
		-1,
		-1,
		85,
		-1,
		80,
		-1,
		-1,
		-1,
		-1,
		96,
		110,
		131,
		137,
		149,
		-1,
		144,
		138,
		124,
		141,
		142,
		139,
		130,
		122,
		127,
		124,
		137,
		151,
		155,
		108,
		-1,
		91,
		-1,
		-1,
		-1,
		114,
		129,
		191,
		168,
		141,
		145,
		138,
		132,
		132,
		148,
		150,
		161,
		129,
		125,
		126,
		130,
		129,
		146,
		156,
		-1,
		-1,
		91,
		108,
		140,
		122,
		126,
		218,
		-1,
		-1,
		154,
		145,
		136,
		139,
		142,
		145,
		135,
		132,
		137,
		142,
		130,
		139,
		157,
		161,
		-1,
		-1,
		-1,
		111,
		-1,
		126,
		-1,
		-1,
		141,
		225,
		172,
		154,
		150,
		148,
		141,
		150,
		145,
		140,
		150,
		159,
		151,
		132,
		143,
		166,
		155,
		193,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		140,
		115,
		130,
		176,
		161,
		168,
		187,
		184,
		-1,
		154,
		179,
		151,
		158,
		150,
		158,
		158,
		155,
		133,
		140,
		156,
		155,
		150,
		185,
		177,
		183,
		-1,
		-1,
		221,
		210,
		199,
		205,
		-1,
		146,
		132,
		162,
		152,
		158,
		-1,
		-1,
		203,
		200,
		176,
		160,
		164,
		157,
		152,
		162,
		142,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		116,
		197,
		190,
		173,
		181,
		212,
		-1,
		149,
		158,
		139,
		144,
		152,
		-1,
		-1,
		176,
		173,
		178,
		167,
		164,
		172,
		167,
		158,
		143,
		149,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		130,
		173,
		167,
		170,
		194,
		208,
		-1,
		162,
		-1,
		-1,
		147,
		165,
		173,
		169,
		173,
		225,
		181,
		176,
		166,
		164,
		155,
		146,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		165,
		153,
		161,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		163,
		-1,
		199,
		-1,
		192,
		196,
		189,
		192,
		180,
		167,
		159,
		151,
		167,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		239,
		194,
		161,
		152,
		199,
		214,
		218,
		-1,
		175,
		214,
		201,
		-1,
		172,
		-1,
		-1,
		-1,
		206,
		202,
		194,
		200,
		179,
		179,
		153,
		157,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		235,
		233,
		238,
		183,
		166,
		184,
		193,
		214,
		190,
		181,
		208,
		208,
		197,
		192,
		179,
		-1,
		-1,
		229,
		212,
		-1,
		-1,
		186,
		174,
		157,
		158,
		154,
		157,
		172,
		175,
		165,
		163,
		157,
		189,
		-1,
		235,
		234,
		223,
		220,
		196,
		187,
		174,
		185,
		-1,
		-1,
		193,
		209,
		222,
		226,
		239,
		264,
		-1,
		182,
		-1,
		-1,
		231,
		-1,
		-1,
		216,
		179,
		168,
		159,
		165,
		162,
		173,
		183,
		171,
		172,
		162,
		172,
		185,
		219,
		216,
		204,
		202,
		225,
		182,
		178,
		-1,
		208,
		196,
		202,
		209,
		226,
		253,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		214,
		212,
		201,
		-1,
		191,
		164,
		169,
		189,
		191,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		228,
		242,
		231,
		227,
		226,
		234,
		183,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		-1,
		233,
		208,
		-1,
		-1,
		209,
		202,
		190,
		178,
		168,
		178,
		182,
		186,
		178,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		262,
		-1,
		214,
		207,
		222,
		237,
		245,
		-1,
		-1,
		-1,
		250,
		236,
		229,
		217,
		215,
		-1,
		243,
		227,
		208,
		-1,
		178,
		191,
		222,
		190,
		195,
		190,
		172,
		183,
		172,
		175,
		189,
		184,
		-1,
		-1,
		220,
		223,
		-1,
		-1,
		245,
		261,
		-1,
		241,
		230,
		215,
		207,
		-1,
		-1,
		215,
		211,
		-1,
		-1,
		179,
		204,
		193,
		201,
		196,
		176,
		182,
		185,
		174,
		178,
		190,
		-1,
		-1,
		227,
		228,
		233,
		-1,
		244,
		-1,
		262,
		-1,
		210,
		226,
		223,
		-1,
		-1,
		-1,
		217,
		180,
		201,
		211,
		205,
		203,
		194,
		180,
		187,
		185,
		181,
		192,
		-1,
		-1,
		-1,
		262,
		236,
		269,
		260,
		243,
		223,
		215,
		234,
		-1,
		204,
		-1,
		179,
		181,
		207,
		210,
		216,
		210,
		183,
		198,
		188,
		179,
		188,
		268,
		-1,
		238,
		271,
		235,
		229,
		205,
		209,
		225,
		-1,
		201,
		183,
		-1,
		211,
		201,
		232,
		217,
		198,
		185,
		192,
		192,
		185,
		-1,
		-1,
		-1,
		240,
		239,
		231,
		225,
		225,
		210,
		201,
		-1,
		213,
		195,
		174,
		191,
		191,
		182,
		190,
		222,
		218,
		205,
		205,
		197,
		-1,
		334,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		234,
		229,
		202,
		190,
		196,
		192,
		178,
		184,
		186,
		194,
		192,
		189,
		201,
		197,
		217,
		198,
		233,
		-1,
		336,
		-1,
		270,
		-1,
		-1,
		252,
		232,
		224,
		213,
		202,
		200,
		191,
		182,
		204,
		220,
		204,
		202,
		205,
		206,
		-1,
		325,
		324,
		-1,
		271,
		263,
		249,
		-1,
		242,
		-1,
		248,
		209,
		-1,
		211,
		191,
		-1,
		213,
		209,
		-1,
		-1,
		312,
		287,
		-1,
		-1,
		-1,
		272,
		252,
		243,
		227,
		-1,
		202,
		202,
		-1,
		-1,
		-1,
		297,
		296,
		-1,
		265,
		268,
		-1,
		258,
		249,
		257,
		204,
		208,
		-1,
		-1,
		-1,
		306,
		287,
		281,
		280,
		278,
		273,
		270,
		256,
		240,
		218,
		207,
		228,
		-1,
		-1,
		-1,
		278,
		270,
		263,
		-1,
		-1,
		265,
		248,
		229,
		227,
		-1,
		-1,
		-1,
		300,
		281,
		-1,
		-1,
		255,
		-1,
		-1,
		261,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		317,
		289,
		-1,
		-1,
		-1,
		251,
		247,
		248,
		-1,
		-1,
		-1,
		-1,
		311,
		312,
		335,
		299,
		-1,
		-1,
		-1,
		243,
		237,
		-1,
		-1,
		314,
		312,
		-1,
		-1,
		-1,
		271,
		255,
		-1,
		241,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		276,
		-1,
		276,
		251,
		258,
		-1,
		-1,
		-1,
		-1,
		289,
		281,
		289,
		-1,
		261,
		263,
		-1,
		311,
		-1,
		-1,
		304,
		295,
		-1,
		-1,
		266,
		273,
		295,
		298,
		334,
		-1,
		285
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		254,
		243,
		254,
		262,
		235,
		242,
		-1,
		263,
		265,
		231,
		225,
		264,
		235,
		241,
		252,
		-1,
		-1,
		-1,
		254,
		253,
		223,
		221,
		230,
		235,
		242,
		-1,
		246,
		-1,
		275,
		254,
		265,
		270,
		216,
		213,
		233,
		252,
		239,
		231,
		290,
		246,
		217,
		211,
		229,
		224,
		233,
		225,
		-1,
		217,
		207,
		229,
		213,
		224,
		216,
		-1,
		-1,
		211,
		212,
		218,
		209,
		215,
		211,
		-1,
		221,
		205,
		-1,
		-1,
		201,
		207,
		191,
		194,
		202,
		200,
		213,
		205,
		200,
		-1,
		-1,
		197,
		193,
		200,
		187,
		183,
		200,
		213,
		195,
		209,
		208,
		-1,
		190,
		208,
		217,
		194,
		192,
		176,
		174,
		192,
		194,
		200,
		203,
		-1,
		183,
		185,
		195,
		203,
		208,
		192,
		179,
		179,
		189,
		182,
		201,
		192,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		180,
		182,
		199,
		191,
		181,
		196,
		189,
		182,
		179,
		177,
		174,
		190,
		191,
		201,
		-1,
		-1,
		236,
		205,
		240,
		197,
		182,
		-1,
		176,
		175,
		181,
		185,
		179,
		172,
		186,
		182,
		-1,
		168,
		167,
		198,
		184,
		195,
		196,
		-1,
		-1,
		194,
		186,
		171,
		174,
		171,
		171,
		190,
		189,
		181,
		167,
		163,
		169,
		172,
		172,
		178,
		162,
		172,
		176,
		187,
		202,
		-1,
		-1,
		257,
		-1,
		-1,
		193,
		176,
		-1,
		159,
		166,
		166,
		183,
		173,
		194,
		200,
		191,
		183,
		177,
		165,
		167,
		164,
		177,
		165,
		159,
		184,
		188,
		182,
		203,
		198,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		152,
		155,
		161,
		185,
		195,
		-1,
		185,
		191,
		201,
		186,
		183,
		170,
		158,
		171,
		156,
		163,
		162,
		166,
		168,
		201,
		179,
		201,
		198,
		227,
		232,
		226,
		235,
		-1,
		201,
		197,
		193,
		200,
		149,
		-1,
		-1,
		189,
		-1,
		203,
		202,
		177,
		195,
		198,
		187,
		178,
		165,
		154,
		165,
		154,
		151,
		159,
		168,
		179,
		174,
		173,
		191,
		206,
		219,
		223,
		229,
		-1,
		251,
		-1,
		193,
		177,
		179,
		151,
		172,
		-1,
		209,
		204,
		194,
		179,
		170,
		-1,
		173,
		176,
		183,
		161,
		146,
		163,
		155,
		153,
		158,
		163,
		177,
		168,
		186,
		193,
		201,
		205,
		225,
		237,
		211,
		201,
		-1,
		183,
		188,
		147,
		155,
		174,
		212,
		176,
		-1,
		171,
		-1,
		163,
		188,
		-1,
		167,
		163,
		145,
		146,
		141,
		156,
		162,
		159,
		156,
		174,
		177,
		194,
		198,
		214,
		-1,
		-1,
		196,
		200,
		189,
		140,
		159,
		183,
		220,
		169,
		158,
		157,
		-1,
		148,
		178,
		175,
		161,
		148,
		138,
		139,
		147,
		160,
		139,
		158,
		161,
		183,
		211,
		189,
		201,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		166,
		137,
		161,
		203,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		168,
		151,
		147,
		136,
		134,
		147,
		142,
		158,
		162,
		161,
		180,
		192,
		183,
		203,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		166,
		152,
		157,
		132,
		125,
		119,
		171,
		168,
		135,
		143,
		135,
		124,
		138,
		146,
		150,
		159,
		168,
		174,
		198,
		198,
		204,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		157,
		170,
		-1,
		124,
		-1,
		113,
		121,
		120,
		126,
		138,
		124,
		129,
		140,
		152,
		165,
		161,
		168,
		203,
		203,
		188,
		208,
		211,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		118,
		112,
		118,
		117,
		124,
		121,
		121,
		135,
		143,
		139,
		155,
		161,
		153,
		189,
		-1,
		196,
		190,
		198,
		188,
		176,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		105,
		112,
		121,
		126,
		131,
		139,
		134,
		147,
		152,
		158,
		163,
		181,
		185,
		189,
		178,
		174,
		171,
		185,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		107,
		109,
		136,
		128,
		142,
		142,
		148,
		156,
		141,
		144,
		160,
		158,
		176,
		184,
		176,
		170,
		169,
		181,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		124,
		162,
		163,
		141,
		146,
		154,
		164,
		166,
		155,
		166,
		158,
		180,
		180,
		164,
		165,
		174,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		0,
		-1,
		88,
		90,
		138,
		136,
		152,
		143,
		149,
		165,
		168,
		170,
		160,
		149,
		155,
		152,
		174,
		160,
		158,
		177,
		193,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		30,
		46,
		61,
		77,
		109,
		-1,
		160,
		144,
		149,
		-1,
		195,
		-1,
		168,
		170,
		164,
		149,
		146,
		157,
		155,
		166,
		183,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		42,
		47,
		56,
		83,
		86,
		176,
		156,
		150,
		149,
		190,
		190,
		176,
		162,
		155,
		152,
		149,
		162,
		182,
		173,
		185,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		124,
		79,
		65,
		-1,
		92,
		193,
		181,
		171,
		161,
		195,
		196,
		181,
		174,
		160,
		162,
		160,
		158,
		163,
		184,
		185,
		198,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		73,
		89,
		122,
		93,
		182,
		-1,
		-1,
		173,
		171,
		181,
		177,
		164,
		184,
		187,
		173,
		157,
		172,
		184,
		192,
		197,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		112,
		113,
		125,
		146,
		171,
		176,
		-1,
		181,
		182,
		168,
		182,
		189,
		175,
		170,
		164,
		167,
		185,
		202,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		104,
		118,
		139,
		145,
		157,
		-1,
		183,
		184,
		170,
		187,
		188,
		185,
		176,
		168,
		173,
		170,
		183,
		197,
		201,
		191,
		-1,
		174,
		-1,
		-1,
		-1,
		122,
		137,
		199,
		176,
		149,
		154,
		164,
		169,
		174,
		194,
		196,
		207,
		175,
		171,
		172,
		176,
		175,
		192,
		202,
		-1,
		-1,
		174,
		183,
		148,
		130,
		134,
		226,
		-1,
		-1,
		164,
		170,
		166,
		176,
		184,
		187,
		181,
		178,
		183,
		188,
		176,
		185,
		203,
		207,
		-1,
		-1,
		-1,
		194,
		-1,
		181,
		-1,
		-1,
		149,
		250,
		197,
		179,
		175,
		173,
		178,
		187,
		182,
		186,
		196,
		205,
		197,
		178,
		189,
		212,
		201,
		239,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		223,
		198,
		213,
		234,
		169,
		176,
		212,
		209,
		-1,
		179,
		216,
		188,
		195,
		187,
		200,
		204,
		201,
		179,
		186,
		202,
		201,
		196,
		231,
		223,
		229,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		229,
		215,
		220,
		210,
		186,
		-1,
		-1,
		228,
		225,
		203,
		197,
		201,
		194,
		189,
		208,
		188,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		201,
		282,
		275,
		258,
		266,
		297,
		-1,
		228,
		220,
		222,
		206,
		197,
		-1,
		-1,
		201,
		198,
		203,
		204,
		201,
		213,
		212,
		204,
		189,
		195,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		215,
		258,
		252,
		255,
		279,
		293,
		-1,
		225,
		-1,
		-1,
		230,
		210,
		216,
		206,
		200,
		250,
		218,
		213,
		212,
		210,
		201,
		192,
		199,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		250,
		238,
		246,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		246,
		-1,
		243,
		-1,
		218,
		222,
		226,
		229,
		226,
		213,
		205,
		197,
		213,
		188,
		198,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		320,
		276,
		246,
		237,
		284,
		299,
		303,
		-1,
		237,
		276,
		284,
		-1,
		255,
		-1,
		-1,
		-1,
		232,
		239,
		231,
		246,
		225,
		225,
		199,
		203,
		193,
		200,
		210,
		212,
		204,
		208,
		221,
		232,
		235,
		316,
		307,
		320,
		265,
		251,
		269,
		278,
		299,
		252,
		243,
		270,
		291,
		280,
		275,
		262,
		-1,
		-1,
		255,
		249,
		-1,
		-1,
		232,
		220,
		203,
		204,
		200,
		203,
		218,
		221,
		211,
		209,
		203,
		235,
		-1,
		309,
		308,
		297,
		294,
		270,
		261,
		256,
		270,
		-1,
		-1,
		255,
		271,
		284,
		288,
		304,
		329,
		-1,
		265,
		-1,
		-1,
		276,
		-1,
		-1,
		262,
		225,
		214,
		205,
		211,
		208,
		219,
		229,
		217,
		218,
		208,
		218,
		231,
		293,
		290,
		278,
		276,
		299,
		264,
		252,
		-1,
		265,
		258,
		264,
		271,
		288,
		318,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		260,
		258,
		247,
		-1,
		237,
		210,
		215,
		235,
		237,
		226,
		220,
		214,
		221,
		220,
		228,
		236,
		302,
		316,
		305,
		301,
		300,
		308,
		257,
		250,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		-1,
		298,
		291,
		-1,
		-1,
		255,
		248,
		236,
		224,
		214,
		224,
		228,
		232,
		224,
		217,
		212,
		223,
		215,
		219,
		236,
		-1,
		336,
		-1,
		288,
		264,
		278,
		293,
		301,
		-1,
		-1,
		-1,
		315,
		301,
		294,
		282,
		280,
		-1,
		289,
		273,
		254,
		-1,
		224,
		237,
		268,
		236,
		241,
		236,
		218,
		229,
		218,
		221,
		235,
		230,
		-1,
		-1,
		276,
		279,
		-1,
		-1,
		301,
		307,
		-1,
		306,
		295,
		280,
		272,
		-1,
		-1,
		261,
		257,
		-1,
		-1,
		225,
		250,
		239,
		247,
		242,
		222,
		228,
		231,
		220,
		224,
		236,
		-1,
		-1,
		283,
		284,
		289,
		-1,
		290,
		-1,
		308,
		-1,
		275,
		281,
		269,
		-1,
		-1,
		-1,
		263,
		226,
		247,
		257,
		251,
		249,
		240,
		226,
		233,
		231,
		227,
		238,
		-1,
		-1,
		-1,
		308,
		282,
		315,
		306,
		289,
		269,
		261,
		280,
		-1,
		250,
		-1,
		225,
		227,
		253,
		256,
		262,
		256,
		229,
		244,
		234,
		225,
		234,
		314,
		-1,
		284,
		317,
		281,
		275,
		251,
		255,
		271,
		-1,
		247,
		229,
		-1,
		257,
		247,
		278,
		263,
		244,
		231,
		238,
		238,
		231,
		-1,
		-1,
		-1,
		286,
		285,
		277,
		271,
		271,
		256,
		247,
		-1,
		259,
		241,
		220,
		237,
		237,
		228,
		236,
		268,
		264,
		251,
		251,
		243,
		-1,
		387,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		280,
		275,
		248,
		236,
		242,
		238,
		224,
		230,
		232,
		240,
		238,
		235,
		247,
		243,
		263,
		244,
		279,
		-1,
		382,
		-1,
		316,
		-1,
		-1,
		298,
		278,
		270,
		259,
		248,
		246,
		237,
		228,
		250,
		266,
		250,
		248,
		251,
		252,
		-1,
		371,
		370,
		-1,
		317,
		309,
		295,
		-1,
		288,
		-1,
		294,
		255,
		-1,
		257,
		237,
		-1,
		259,
		255,
		-1,
		-1,
		358,
		333,
		-1,
		-1,
		-1,
		318,
		298,
		289,
		273,
		-1,
		248,
		248,
		-1,
		-1,
		-1,
		343,
		342,
		-1,
		311,
		314,
		-1,
		304,
		295,
		303,
		250,
		254,
		-1,
		-1,
		-1,
		352,
		333,
		327,
		326,
		324,
		319,
		316,
		302,
		286,
		264,
		253,
		274,
		-1,
		-1,
		-1,
		324,
		316,
		309,
		-1,
		-1,
		311,
		294,
		275,
		273,
		-1,
		-1,
		-1,
		346,
		327,
		-1,
		-1,
		301,
		-1,
		-1,
		307,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		363,
		335,
		-1,
		-1,
		-1,
		297,
		293,
		294,
		-1,
		-1,
		-1,
		-1,
		357,
		358,
		381,
		345,
		-1,
		-1,
		-1,
		289,
		283,
		-1,
		-1,
		360,
		358,
		-1,
		-1,
		-1,
		317,
		301,
		-1,
		287,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		322,
		-1,
		322,
		297,
		304,
		-1,
		-1,
		-1,
		-1,
		335,
		327,
		335,
		-1,
		307,
		309,
		-1,
		357,
		-1,
		-1,
		350,
		341,
		-1,
		-1,
		312,
		319,
		341,
		344,
		380,
		-1,
		331
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		175,
		164,
		175,
		183,
		156,
		163,
		-1,
		184,
		186,
		152,
		146,
		185,
		156,
		162,
		173,
		-1,
		-1,
		-1,
		175,
		174,
		144,
		142,
		151,
		156,
		163,
		-1,
		167,
		-1,
		196,
		175,
		186,
		191,
		137,
		134,
		154,
		173,
		160,
		152,
		211,
		167,
		138,
		132,
		150,
		145,
		154,
		146,
		-1,
		138,
		128,
		150,
		134,
		145,
		137,
		-1,
		-1,
		132,
		133,
		139,
		130,
		136,
		132,
		-1,
		142,
		126,
		-1,
		-1,
		122,
		128,
		112,
		115,
		123,
		121,
		134,
		126,
		121,
		-1,
		-1,
		118,
		114,
		121,
		108,
		104,
		121,
		134,
		116,
		130,
		129,
		-1,
		111,
		129,
		138,
		115,
		113,
		97,
		95,
		113,
		115,
		121,
		124,
		-1,
		104,
		106,
		116,
		124,
		129,
		113,
		100,
		100,
		110,
		103,
		122,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		101,
		103,
		120,
		112,
		102,
		117,
		110,
		103,
		100,
		98,
		95,
		111,
		112,
		122,
		-1,
		-1,
		157,
		126,
		161,
		118,
		103,
		-1,
		97,
		96,
		102,
		106,
		100,
		93,
		107,
		103,
		-1,
		89,
		88,
		119,
		105,
		116,
		117,
		-1,
		-1,
		115,
		107,
		92,
		95,
		92,
		92,
		111,
		110,
		102,
		88,
		84,
		90,
		93,
		93,
		99,
		83,
		93,
		97,
		108,
		123,
		-1,
		-1,
		178,
		-1,
		-1,
		114,
		97,
		-1,
		80,
		87,
		87,
		104,
		94,
		115,
		121,
		112,
		104,
		98,
		86,
		88,
		85,
		98,
		86,
		80,
		105,
		109,
		103,
		124,
		119,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		73,
		76,
		82,
		106,
		116,
		-1,
		106,
		112,
		122,
		107,
		104,
		91,
		79,
		92,
		77,
		84,
		83,
		87,
		89,
		122,
		100,
		122,
		119,
		148,
		153,
		147,
		156,
		-1,
		122,
		118,
		114,
		121,
		70,
		-1,
		-1,
		110,
		-1,
		124,
		123,
		98,
		116,
		119,
		108,
		99,
		86,
		75,
		86,
		75,
		72,
		80,
		89,
		100,
		95,
		94,
		112,
		127,
		140,
		144,
		150,
		-1,
		172,
		-1,
		114,
		98,
		100,
		72,
		93,
		-1,
		130,
		125,
		115,
		100,
		91,
		-1,
		94,
		97,
		104,
		82,
		67,
		84,
		76,
		74,
		79,
		84,
		98,
		89,
		107,
		114,
		122,
		126,
		146,
		158,
		132,
		122,
		-1,
		104,
		109,
		68,
		76,
		95,
		133,
		97,
		-1,
		92,
		-1,
		84,
		109,
		-1,
		88,
		84,
		66,
		67,
		62,
		77,
		83,
		80,
		77,
		95,
		98,
		115,
		119,
		135,
		-1,
		-1,
		117,
		121,
		110,
		61,
		80,
		104,
		141,
		90,
		79,
		78,
		-1,
		69,
		99,
		96,
		82,
		69,
		59,
		60,
		68,
		81,
		60,
		79,
		82,
		104,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		87,
		58,
		82,
		124,
		108,
		101,
		89,
		54,
		54,
		48,
		-1,
		89,
		72,
		68,
		57,
		55,
		68,
		63,
		79,
		83,
		82,
		101,
		113,
		104,
		124,
		-1,
		-1,
		-1,
		117,
		106,
		107,
		53,
		76,
		113,
		87,
		73,
		78,
		53,
		46,
		40,
		92,
		89,
		56,
		64,
		56,
		45,
		59,
		67,
		71,
		80,
		89,
		95,
		119,
		119,
		125,
		-1,
		-1,
		124,
		114,
		98,
		100,
		97,
		67,
		74,
		106,
		78,
		91,
		-1,
		45,
		-1,
		34,
		37,
		41,
		47,
		59,
		45,
		50,
		61,
		73,
		86,
		82,
		89,
		124,
		124,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		117,
		112,
		87,
		64,
		48,
		84,
		-1,
		61,
		62,
		-1,
		39,
		33,
		34,
		38,
		45,
		42,
		42,
		56,
		64,
		60,
		76,
		82,
		74,
		110,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		110,
		89,
		82,
		102,
		43,
		95,
		-1,
		-1,
		46,
		39,
		-1,
		26,
		26,
		33,
		42,
		47,
		52,
		60,
		55,
		68,
		73,
		79,
		84,
		102,
		106,
		110,
		99,
		95,
		92,
		106,
		-1,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		63,
		-1,
		55,
		47,
		37,
		31,
		25,
		37,
		35,
		57,
		49,
		63,
		63,
		69,
		77,
		62,
		65,
		81,
		79,
		97,
		105,
		97,
		91,
		90,
		102,
		-1,
		130,
		116,
		87,
		-1,
		-1,
		76,
		-1,
		40,
		54,
		70,
		-1,
		63,
		42,
		49,
		27,
		45,
		45,
		83,
		84,
		62,
		67,
		75,
		85,
		87,
		76,
		87,
		79,
		101,
		101,
		85,
		86,
		95,
		-1,
		136,
		123,
		81,
		77,
		66,
		86,
		37,
		25,
		57,
		-1,
		-1,
		75,
		-1,
		0,
		26,
		59,
		57,
		73,
		64,
		70,
		86,
		89,
		91,
		81,
		70,
		76,
		73,
		95,
		81,
		79,
		98,
		114,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		52,
		39,
		33,
		-1,
		74,
		-1,
		53,
		43,
		27,
		20,
		45,
		-1,
		81,
		65,
		70,
		-1,
		116,
		-1,
		89,
		91,
		85,
		70,
		67,
		78,
		76,
		87,
		104,
		-1,
		86,
		71,
		64,
		54,
		68,
		39,
		-1,
		94,
		-1,
		-1,
		40,
		34,
		34,
		26,
		29,
		97,
		77,
		71,
		70,
		111,
		111,
		97,
		83,
		76,
		73,
		70,
		83,
		103,
		94,
		106,
		-1,
		-1,
		-1,
		91,
		77,
		81,
		41,
		60,
		-1,
		-1,
		102,
		57,
		43,
		-1,
		35,
		114,
		102,
		92,
		82,
		116,
		117,
		102,
		95,
		81,
		83,
		81,
		79,
		84,
		105,
		106,
		119,
		-1,
		-1,
		74,
		79,
		67,
		53,
		72,
		-1,
		-1,
		-1,
		51,
		67,
		62,
		36,
		103,
		-1,
		-1,
		94,
		92,
		102,
		98,
		85,
		105,
		108,
		94,
		78,
		93,
		105,
		113,
		118,
		-1,
		77,
		64,
		-1,
		-1,
		75,
		69,
		-1,
		-1,
		-1,
		-1,
		90,
		56,
		68,
		89,
		114,
		97,
		-1,
		102,
		103,
		89,
		103,
		110,
		96,
		91,
		85,
		88,
		106,
		123,
		-1,
		-1,
		89,
		-1,
		84,
		-1,
		-1,
		-1,
		-1,
		47,
		61,
		82,
		88,
		100,
		-1,
		111,
		105,
		91,
		108,
		109,
		106,
		97,
		89,
		94,
		91,
		104,
		118,
		122,
		112,
		-1,
		95,
		-1,
		-1,
		-1,
		65,
		80,
		142,
		119,
		92,
		97,
		105,
		99,
		99,
		115,
		117,
		128,
		96,
		92,
		93,
		97,
		96,
		113,
		123,
		-1,
		-1,
		95,
		112,
		91,
		73,
		77,
		169,
		-1,
		-1,
		107,
		112,
		103,
		106,
		109,
		112,
		102,
		99,
		104,
		109,
		97,
		106,
		124,
		128,
		-1,
		-1,
		-1,
		115,
		-1,
		124,
		-1,
		-1,
		92,
		192,
		139,
		121,
		117,
		115,
		108,
		117,
		112,
		107,
		117,
		126,
		118,
		99,
		110,
		133,
		122,
		160,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		144,
		119,
		134,
		177,
		112,
		119,
		154,
		151,
		-1,
		121,
		146,
		118,
		125,
		117,
		125,
		125,
		122,
		100,
		107,
		123,
		122,
		117,
		152,
		144,
		150,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		150,
		136,
		163,
		153,
		129,
		-1,
		-1,
		170,
		167,
		143,
		127,
		131,
		124,
		119,
		129,
		109,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		122,
		203,
		196,
		179,
		187,
		218,
		-1,
		153,
		162,
		143,
		148,
		140,
		-1,
		-1,
		143,
		140,
		145,
		134,
		131,
		139,
		134,
		125,
		110,
		116,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		136,
		179,
		173,
		176,
		200,
		214,
		-1,
		166,
		-1,
		-1,
		151,
		153,
		158,
		148,
		142,
		192,
		148,
		143,
		133,
		131,
		122,
		113,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		171,
		159,
		167,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		167,
		-1,
		185,
		-1,
		160,
		164,
		156,
		159,
		147,
		134,
		126,
		118,
		134,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		245,
		200,
		167,
		158,
		205,
		220,
		224,
		-1,
		179,
		218,
		205,
		-1,
		176,
		-1,
		-1,
		-1,
		174,
		169,
		161,
		167,
		146,
		146,
		120,
		124,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		241,
		239,
		244,
		189,
		172,
		190,
		199,
		220,
		194,
		185,
		212,
		212,
		201,
		196,
		183,
		-1,
		-1,
		197,
		179,
		-1,
		-1,
		153,
		141,
		124,
		125,
		121,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		241,
		240,
		229,
		226,
		202,
		193,
		180,
		191,
		-1,
		-1,
		197,
		213,
		226,
		230,
		243,
		268,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		129,
		140,
		150,
		138,
		139,
		129,
		139,
		152,
		225,
		222,
		210,
		208,
		231,
		188,
		184,
		-1,
		207,
		200,
		206,
		213,
		230,
		257,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		181,
		179,
		168,
		-1,
		158,
		131,
		136,
		156,
		158,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		234,
		248,
		237,
		233,
		232,
		240,
		189,
		192,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		212,
		-1,
		-1,
		176,
		169,
		157,
		145,
		135,
		145,
		149,
		153,
		145,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		268,
		-1,
		220,
		206,
		220,
		235,
		243,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		218,
		221,
		-1,
		-1,
		226,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		225,
		226,
		231,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		172,
		170,
		161,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		148,
		174,
		177,
		183,
		177,
		150,
		165,
		155,
		146,
		155,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		199,
		184,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		189,
		185,
		172,
		172,
		164,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		165,
		200,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		172,
		173,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		203,
		205,
		171,
		165,
		204,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		194,
		193,
		163,
		161,
		170,
		175,
		182,
		-1,
		186,
		-1,
		215,
		194,
		205,
		210,
		156,
		153,
		173,
		192,
		179,
		171,
		230,
		186,
		157,
		151,
		169,
		164,
		173,
		165,
		-1,
		157,
		147,
		169,
		153,
		164,
		156,
		-1,
		-1,
		151,
		152,
		158,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		141,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		130,
		148,
		157,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		143,
		-1,
		123,
		125,
		135,
		143,
		148,
		132,
		119,
		119,
		129,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		120,
		122,
		139,
		131,
		121,
		136,
		129,
		122,
		119,
		117,
		114,
		130,
		131,
		141,
		-1,
		-1,
		176,
		145,
		180,
		137,
		122,
		-1,
		116,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		108,
		107,
		138,
		124,
		135,
		136,
		-1,
		-1,
		134,
		126,
		111,
		114,
		111,
		111,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		102,
		112,
		116,
		127,
		142,
		-1,
		-1,
		197,
		-1,
		-1,
		133,
		116,
		-1,
		99,
		106,
		106,
		123,
		113,
		134,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		99,
		124,
		128,
		122,
		143,
		138,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		92,
		95,
		101,
		125,
		135,
		-1,
		125,
		131,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		106,
		108,
		141,
		119,
		141,
		138,
		167,
		172,
		166,
		175,
		-1,
		141,
		137,
		133,
		140,
		89,
		-1,
		-1,
		129,
		-1,
		143,
		142,
		117,
		135,
		138,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		108,
		119,
		114,
		113,
		131,
		146,
		159,
		163,
		169,
		-1,
		191,
		-1,
		133,
		117,
		119,
		91,
		112,
		-1,
		149,
		144,
		134,
		119,
		110,
		-1,
		113,
		116,
		123,
		101,
		86,
		103,
		95,
		93,
		98,
		103,
		117,
		108,
		126,
		133,
		141,
		145,
		165,
		177,
		151,
		141,
		-1,
		123,
		128,
		87,
		95,
		114,
		152,
		116,
		-1,
		111,
		-1,
		103,
		128,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		102,
		99,
		96,
		114,
		117,
		134,
		138,
		154,
		-1,
		-1,
		136,
		140,
		129,
		80,
		99,
		123,
		160,
		109,
		98,
		97,
		-1,
		88,
		118,
		115,
		101,
		88,
		78,
		79,
		87,
		100,
		79,
		98,
		101,
		123,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		106,
		77,
		101,
		143,
		127,
		120,
		108,
		73,
		73,
		67,
		-1,
		108,
		91,
		87,
		76,
		74,
		87,
		82,
		98,
		102,
		101,
		120,
		132,
		123,
		143,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		72,
		95,
		132,
		106,
		92,
		97,
		72,
		65,
		59,
		111,
		108,
		75,
		83,
		75,
		64,
		78,
		86,
		90,
		99,
		108,
		114,
		138,
		138,
		144,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		86,
		93,
		125,
		97,
		110,
		-1,
		64,
		-1,
		53,
		61,
		60,
		66,
		78,
		64,
		69,
		80,
		92,
		105,
		101,
		108,
		143,
		143,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		136,
		131,
		106,
		83,
		67,
		103,
		-1,
		80,
		81,
		-1,
		58,
		52,
		58,
		57,
		64,
		61,
		61,
		75,
		83,
		79,
		95,
		101,
		93,
		129,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		129,
		108,
		101,
		121,
		62,
		114,
		-1,
		-1,
		65,
		58,
		-1,
		45,
		45,
		52,
		61,
		66,
		71,
		79,
		74,
		87,
		92,
		98,
		103,
		121,
		125,
		129,
		118,
		114,
		111,
		125,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		82,
		-1,
		74,
		66,
		56,
		50,
		44,
		38,
		40,
		76,
		68,
		82,
		82,
		88,
		96,
		81,
		84,
		100,
		98,
		116,
		124,
		116,
		110,
		109,
		121,
		-1,
		149,
		135,
		106,
		-1,
		-1,
		95,
		-1,
		59,
		73,
		89,
		-1,
		82,
		61,
		76,
		54,
		41,
		64,
		102,
		103,
		81,
		86,
		94,
		104,
		106,
		95,
		106,
		98,
		120,
		120,
		104,
		105,
		114,
		-1,
		155,
		142,
		100,
		96,
		85,
		105,
		56,
		44,
		76,
		-1,
		-1,
		79,
		-1,
		28,
		0,
		78,
		76,
		92,
		83,
		89,
		105,
		108,
		110,
		100,
		89,
		95,
		92,
		114,
		100,
		98,
		117,
		133,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		71,
		58,
		52,
		-1,
		93,
		-1,
		57,
		47,
		31,
		24,
		42,
		-1,
		100,
		84,
		89,
		-1,
		135,
		-1,
		108,
		110,
		104,
		89,
		86,
		97,
		95,
		106,
		123,
		-1,
		105,
		90,
		83,
		73,
		87,
		58,
		-1,
		113,
		-1,
		-1,
		44,
		38,
		38,
		30,
		33,
		116,
		96,
		90,
		89,
		130,
		130,
		116,
		102,
		95,
		92,
		89,
		102,
		122,
		113,
		125,
		-1,
		-1,
		-1,
		110,
		96,
		100,
		60,
		79,
		-1,
		-1,
		106,
		61,
		47,
		-1,
		39,
		133,
		121,
		111,
		101,
		135,
		136,
		121,
		114,
		100,
		102,
		100,
		98,
		103,
		124,
		125,
		138,
		-1,
		-1,
		93,
		98,
		86,
		72,
		91,
		-1,
		-1,
		-1,
		55,
		71,
		66,
		40,
		122,
		-1,
		-1,
		113,
		111,
		121,
		117,
		104,
		124,
		127,
		113,
		97,
		112,
		124,
		132,
		137,
		-1,
		96,
		83,
		-1,
		-1,
		94,
		88,
		-1,
		-1,
		-1,
		-1,
		94,
		60,
		72,
		93,
		118,
		116,
		-1,
		121,
		122,
		108,
		122,
		129,
		115,
		110,
		104,
		107,
		125,
		142,
		-1,
		-1,
		108,
		-1,
		103,
		-1,
		-1,
		-1,
		-1,
		51,
		65,
		86,
		92,
		104,
		-1,
		130,
		124,
		110,
		127,
		128,
		125,
		116,
		108,
		113,
		110,
		123,
		137,
		141,
		131,
		-1,
		114,
		-1,
		-1,
		-1,
		69,
		84,
		146,
		123,
		96,
		101,
		111,
		116,
		118,
		134,
		136,
		147,
		115,
		111,
		112,
		116,
		115,
		132,
		142,
		-1,
		-1,
		114,
		130,
		95,
		77,
		81,
		173,
		-1,
		-1,
		111,
		117,
		113,
		123,
		128,
		131,
		121,
		118,
		123,
		128,
		116,
		125,
		143,
		147,
		-1,
		-1,
		-1,
		134,
		-1,
		128,
		-1,
		-1,
		96,
		197,
		144,
		126,
		122,
		120,
		125,
		134,
		129,
		126,
		136,
		145,
		137,
		118,
		129,
		152,
		141,
		179,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		163,
		138,
		153,
		181,
		116,
		123,
		159,
		156,
		-1,
		126,
		163,
		135,
		142,
		134,
		144,
		144,
		141,
		119,
		126,
		142,
		141,
		136,
		171,
		163,
		169,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		169,
		155,
		167,
		157,
		133,
		-1,
		-1,
		175,
		172,
		150,
		144,
		148,
		141,
		136,
		148,
		128,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		141,
		222,
		215,
		198,
		206,
		237,
		-1,
		172,
		167,
		162,
		153,
		144,
		-1,
		-1,
		148,
		145,
		150,
		151,
		148,
		158,
		153,
		144,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		155,
		198,
		192,
		195,
		219,
		233,
		-1,
		172,
		-1,
		-1,
		170,
		157,
		163,
		153,
		147,
		197,
		165,
		160,
		152,
		150,
		141,
		132,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		190,
		178,
		186,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		186,
		-1,
		190,
		-1,
		165,
		169,
		173,
		176,
		166,
		153,
		145,
		137,
		153,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		264,
		219,
		186,
		177,
		224,
		239,
		243,
		-1,
		184,
		223,
		224,
		-1,
		195,
		-1,
		-1,
		-1,
		179,
		186,
		178,
		186,
		165,
		165,
		139,
		143,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		260,
		254,
		263,
		208,
		191,
		209,
		218,
		239,
		199,
		190,
		217,
		231,
		220,
		215,
		202,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		172,
		160,
		143,
		144,
		140,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		256,
		255,
		244,
		241,
		217,
		208,
		199,
		210,
		-1,
		-1,
		202,
		218,
		231,
		235,
		251,
		276,
		-1,
		205,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		165,
		154,
		145,
		151,
		148,
		159,
		169,
		157,
		158,
		148,
		158,
		171,
		240,
		237,
		225,
		223,
		246,
		207,
		199,
		-1,
		212,
		205,
		211,
		218,
		235,
		265,
		-1,
		-1,
		221,
		212,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		150,
		155,
		175,
		177,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		249,
		263,
		252,
		248,
		247,
		255,
		204,
		197,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		-1,
		238,
		231,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		168,
		172,
		164,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		283,
		-1,
		235,
		211,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		255,
		241,
		234,
		222,
		220,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		208,
		176,
		181,
		176,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		223,
		226,
		-1,
		-1,
		245,
		247,
		-1,
		246,
		235,
		220,
		212,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		165,
		190,
		179,
		187,
		182,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		230,
		231,
		236,
		-1,
		230,
		-1,
		248,
		-1,
		215,
		221,
		209,
		-1,
		-1,
		-1,
		203,
		166,
		187,
		197,
		191,
		189,
		180,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		248,
		222,
		255,
		246,
		229,
		209,
		201,
		220,
		-1,
		190,
		-1,
		165,
		167,
		193,
		196,
		202,
		196,
		169,
		184,
		174,
		165,
		174,
		254,
		-1,
		224,
		257,
		221,
		215,
		191,
		195,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		218,
		203,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		226,
		225,
		217,
		211,
		211,
		196,
		187,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		208,
		204,
		191,
		191,
		183,
		-1,
		327,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		220,
		215,
		188,
		176,
		182,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		184,
		219,
		-1,
		322,
		-1,
		256,
		-1,
		-1,
		238,
		218,
		210,
		199,
		188,
		186,
		177,
		168,
		190,
		206,
		190,
		188,
		191,
		192,
		-1,
		311,
		310,
		-1,
		257,
		249,
		235,
		-1,
		228,
		-1,
		234,
		195,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		298,
		273,
		-1,
		-1,
		-1,
		258,
		238,
		229,
		213,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		283,
		282,
		-1,
		251,
		254,
		-1,
		244,
		235,
		243,
		190,
		194,
		-1,
		-1,
		-1,
		292,
		273,
		267,
		266,
		264,
		259,
		256,
		242,
		226,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		264,
		256,
		249,
		-1,
		-1,
		251,
		234,
		215,
		213,
		-1,
		-1,
		-1,
		286,
		267,
		-1,
		-1,
		241,
		-1,
		-1,
		247,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		275,
		-1,
		-1,
		-1,
		237,
		233,
		234,
		-1,
		-1,
		-1,
		-1,
		297,
		298,
		321,
		285,
		-1,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		300,
		298,
		-1,
		-1,
		-1,
		257,
		241,
		-1,
		227,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		262,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		275,
		267,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		290,
		281,
		-1,
		-1,
		252,
		259,
		281,
		284,
		320,
		-1,
		271
	],
	[
		-1,
		189,
		178,
		189,
		197,
		170,
		177,
		-1,
		198,
		200,
		166,
		160,
		199,
		170,
		176,
		187,
		-1,
		-1,
		-1,
		189,
		188,
		158,
		156,
		165,
		170,
		177,
		-1,
		181,
		-1,
		210,
		189,
		200,
		205,
		151,
		148,
		168,
		187,
		174,
		166,
		225,
		181,
		152,
		146,
		164,
		159,
		168,
		160,
		-1,
		152,
		142,
		164,
		148,
		159,
		151,
		-1,
		-1,
		146,
		147,
		153,
		144,
		150,
		146,
		-1,
		156,
		140,
		-1,
		-1,
		136,
		142,
		126,
		129,
		137,
		135,
		148,
		140,
		135,
		-1,
		-1,
		132,
		128,
		135,
		122,
		118,
		135,
		148,
		130,
		144,
		143,
		-1,
		125,
		143,
		152,
		129,
		127,
		111,
		109,
		127,
		129,
		135,
		138,
		-1,
		134,
		135,
		130,
		138,
		143,
		127,
		114,
		114,
		124,
		117,
		136,
		127,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		117,
		134,
		126,
		116,
		131,
		124,
		117,
		114,
		112,
		109,
		125,
		126,
		136,
		-1,
		-1,
		189,
		158,
		193,
		150,
		135,
		-1,
		129,
		110,
		116,
		120,
		114,
		107,
		121,
		117,
		-1,
		103,
		102,
		133,
		119,
		130,
		149,
		-1,
		-1,
		147,
		139,
		124,
		127,
		124,
		124,
		125,
		124,
		116,
		102,
		98,
		104,
		107,
		107,
		113,
		97,
		107,
		111,
		122,
		137,
		-1,
		-1,
		192,
		-1,
		-1,
		146,
		129,
		-1,
		112,
		119,
		119,
		136,
		126,
		147,
		135,
		126,
		118,
		112,
		100,
		102,
		99,
		112,
		100,
		94,
		119,
		123,
		117,
		138,
		133,
		-1,
		191,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		105,
		108,
		114,
		138,
		148,
		-1,
		138,
		135,
		136,
		121,
		118,
		105,
		93,
		106,
		91,
		98,
		97,
		101,
		103,
		136,
		114,
		136,
		133,
		162,
		167,
		161,
		170,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		142,
		-1,
		156,
		155,
		130,
		132,
		135,
		122,
		113,
		100,
		89,
		100,
		89,
		86,
		94,
		103,
		114,
		109,
		108,
		126,
		141,
		154,
		158,
		164,
		-1,
		204,
		-1,
		146,
		130,
		132,
		104,
		125,
		-1,
		162,
		157,
		147,
		132,
		123,
		-1,
		126,
		128,
		118,
		96,
		81,
		98,
		90,
		88,
		93,
		98,
		112,
		103,
		121,
		128,
		136,
		140,
		160,
		172,
		164,
		154,
		-1,
		136,
		141,
		100,
		108,
		127,
		165,
		129,
		-1,
		124,
		-1,
		116,
		141,
		-1,
		102,
		98,
		80,
		81,
		76,
		91,
		97,
		94,
		91,
		109,
		112,
		129,
		133,
		149,
		-1,
		-1,
		149,
		153,
		142,
		93,
		112,
		136,
		173,
		122,
		111,
		110,
		-1,
		101,
		110,
		107,
		93,
		80,
		73,
		74,
		81,
		95,
		74,
		93,
		96,
		118,
		146,
		124,
		136,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		119,
		90,
		114,
		156,
		140,
		133,
		121,
		86,
		86,
		80,
		-1,
		100,
		83,
		82,
		71,
		69,
		82,
		77,
		93,
		97,
		96,
		115,
		127,
		118,
		138,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		85,
		108,
		145,
		119,
		105,
		110,
		85,
		78,
		72,
		103,
		100,
		67,
		78,
		68,
		59,
		73,
		81,
		85,
		94,
		103,
		109,
		133,
		133,
		139,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		99,
		106,
		138,
		110,
		123,
		-1,
		77,
		-1,
		66,
		51,
		55,
		61,
		72,
		59,
		64,
		75,
		87,
		100,
		96,
		103,
		138,
		138,
		123,
		143,
		146,
		-1,
		-1,
		-1,
		149,
		144,
		119,
		96,
		80,
		116,
		-1,
		93,
		94,
		-1,
		71,
		65,
		54,
		52,
		59,
		55,
		54,
		70,
		78,
		74,
		90,
		96,
		88,
		124,
		-1,
		131,
		125,
		133,
		123,
		111,
		-1,
		-1,
		-1,
		142,
		121,
		114,
		134,
		75,
		127,
		-1,
		-1,
		78,
		71,
		-1,
		56,
		40,
		34,
		43,
		56,
		65,
		68,
		69,
		82,
		87,
		93,
		98,
		116,
		120,
		124,
		113,
		109,
		106,
		120,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		95,
		-1,
		87,
		79,
		69,
		63,
		57,
		45,
		43,
		40,
		32,
		71,
		71,
		79,
		85,
		76,
		79,
		95,
		93,
		111,
		119,
		111,
		105,
		104,
		116,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		108,
		-1,
		72,
		86,
		102,
		-1,
		95,
		74,
		86,
		67,
		55,
		18,
		91,
		92,
		70,
		75,
		83,
		93,
		101,
		90,
		101,
		93,
		115,
		115,
		99,
		100,
		109,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		69,
		57,
		89,
		-1,
		-1,
		131,
		-1,
		65,
		82,
		0,
		1,
		81,
		72,
		78,
		94,
		97,
		105,
		95,
		84,
		90,
		87,
		109,
		95,
		93,
		112,
		128,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		109,
		99,
		83,
		68,
		101,
		-1,
		89,
		73,
		78,
		-1,
		130,
		-1,
		103,
		105,
		99,
		84,
		81,
		92,
		90,
		101,
		118,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		126,
		-1,
		-1,
		96,
		90,
		90,
		74,
		77,
		105,
		85,
		79,
		78,
		125,
		124,
		111,
		97,
		90,
		87,
		84,
		97,
		117,
		108,
		120,
		-1,
		-1,
		-1,
		123,
		109,
		113,
		73,
		92,
		-1,
		-1,
		158,
		113,
		99,
		-1,
		83,
		122,
		110,
		100,
		90,
		124,
		125,
		115,
		109,
		95,
		97,
		95,
		93,
		98,
		119,
		120,
		133,
		-1,
		-1,
		106,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		105,
		121,
		113,
		84,
		111,
		-1,
		-1,
		102,
		100,
		110,
		112,
		99,
		119,
		122,
		108,
		92,
		107,
		119,
		127,
		132,
		-1,
		109,
		96,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		138,
		104,
		116,
		137,
		153,
		105,
		-1,
		110,
		111,
		103,
		117,
		124,
		110,
		105,
		99,
		102,
		120,
		137,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		95,
		109,
		130,
		135,
		139,
		-1,
		119,
		119,
		105,
		122,
		123,
		120,
		111,
		103,
		108,
		105,
		118,
		132,
		136,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		113,
		128,
		181,
		158,
		131,
		126,
		119,
		113,
		113,
		129,
		131,
		142,
		110,
		106,
		107,
		111,
		110,
		127,
		137,
		-1,
		-1,
		127,
		144,
		139,
		121,
		125,
		208,
		-1,
		-1,
		135,
		126,
		117,
		120,
		123,
		126,
		116,
		113,
		118,
		123,
		111,
		120,
		138,
		142,
		-1,
		-1,
		-1,
		147,
		-1,
		162,
		-1,
		-1,
		140,
		206,
		153,
		135,
		131,
		129,
		122,
		131,
		126,
		121,
		131,
		140,
		132,
		113,
		124,
		147,
		136,
		174,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		212,
		160,
		167,
		168,
		165,
		-1,
		135,
		160,
		132,
		139,
		131,
		139,
		139,
		136,
		114,
		121,
		137,
		136,
		131,
		166,
		158,
		164,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		182,
		168,
		198,
		188,
		177,
		-1,
		-1,
		184,
		181,
		157,
		141,
		145,
		138,
		133,
		143,
		123,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		185,
		194,
		175,
		180,
		187,
		-1,
		-1,
		157,
		154,
		159,
		148,
		145,
		153,
		148,
		139,
		124,
		130,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		198,
		-1,
		-1,
		183,
		188,
		172,
		162,
		156,
		206,
		162,
		157,
		147,
		145,
		136,
		127,
		134,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		203,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		199,
		-1,
		199,
		-1,
		174,
		178,
		170,
		173,
		161,
		148,
		140,
		132,
		148,
		123,
		133,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		276,
		232,
		199,
		190,
		237,
		252,
		256,
		-1,
		211,
		250,
		237,
		-1,
		208,
		-1,
		-1,
		-1,
		188,
		183,
		175,
		181,
		160,
		160,
		134,
		138,
		128,
		135,
		145,
		147,
		139,
		143,
		156,
		167,
		170,
		272,
		263,
		276,
		221,
		204,
		222,
		231,
		252,
		226,
		217,
		244,
		244,
		233,
		228,
		215,
		-1,
		-1,
		211,
		193,
		-1,
		-1,
		167,
		155,
		138,
		139,
		135,
		138,
		153,
		156,
		146,
		144,
		138,
		170,
		-1,
		265,
		264,
		253,
		250,
		226,
		217,
		212,
		223,
		-1,
		-1,
		229,
		245,
		245,
		249,
		265,
		290,
		-1,
		218,
		-1,
		-1,
		212,
		-1,
		-1,
		197,
		160,
		149,
		140,
		146,
		143,
		154,
		164,
		152,
		153,
		143,
		153,
		166,
		249,
		246,
		234,
		232,
		255,
		220,
		208,
		-1,
		221,
		219,
		225,
		232,
		249,
		279,
		-1,
		-1,
		234,
		223,
		-1,
		-1,
		195,
		193,
		182,
		-1,
		172,
		145,
		150,
		170,
		172,
		161,
		155,
		149,
		156,
		155,
		163,
		171,
		258,
		272,
		261,
		257,
		256,
		264,
		213,
		206,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		-1,
		233,
		229,
		-1,
		-1,
		190,
		183,
		171,
		159,
		149,
		159,
		163,
		167,
		159,
		152,
		147,
		158,
		150,
		154,
		171,
		-1,
		292,
		-1,
		244,
		220,
		234,
		249,
		257,
		-1,
		-1,
		-1,
		250,
		236,
		229,
		217,
		215,
		-1,
		224,
		208,
		189,
		-1,
		159,
		172,
		203,
		171,
		176,
		171,
		153,
		164,
		153,
		156,
		170,
		165,
		-1,
		-1,
		232,
		235,
		-1,
		-1,
		240,
		242,
		-1,
		241,
		230,
		215,
		207,
		-1,
		-1,
		196,
		192,
		-1,
		-1,
		160,
		185,
		174,
		182,
		177,
		157,
		163,
		166,
		155,
		159,
		171,
		-1,
		-1,
		239,
		240,
		245,
		-1,
		225,
		-1,
		243,
		-1,
		210,
		216,
		204,
		-1,
		-1,
		-1,
		198,
		161,
		182,
		192,
		186,
		184,
		175,
		161,
		168,
		166,
		162,
		173,
		-1,
		-1,
		-1,
		243,
		217,
		250,
		241,
		224,
		204,
		196,
		215,
		-1,
		185,
		-1,
		160,
		162,
		188,
		191,
		197,
		191,
		164,
		179,
		169,
		160,
		169,
		249,
		-1,
		219,
		252,
		216,
		210,
		186,
		190,
		206,
		-1,
		182,
		164,
		-1,
		192,
		182,
		213,
		198,
		179,
		166,
		173,
		173,
		166,
		-1,
		-1,
		-1,
		221,
		220,
		212,
		206,
		206,
		191,
		182,
		-1,
		194,
		176,
		155,
		172,
		172,
		163,
		171,
		203,
		199,
		186,
		186,
		178,
		-1,
		322,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		215,
		210,
		183,
		171,
		177,
		173,
		159,
		165,
		167,
		175,
		173,
		170,
		182,
		178,
		198,
		179,
		214,
		-1,
		317,
		-1,
		251,
		-1,
		-1,
		233,
		213,
		205,
		194,
		183,
		181,
		172,
		163,
		185,
		201,
		185,
		183,
		186,
		187,
		-1,
		306,
		305,
		-1,
		252,
		244,
		230,
		-1,
		223,
		-1,
		229,
		190,
		-1,
		192,
		172,
		-1,
		194,
		190,
		-1,
		-1,
		293,
		268,
		-1,
		-1,
		-1,
		253,
		233,
		224,
		208,
		-1,
		183,
		183,
		-1,
		-1,
		-1,
		278,
		277,
		-1,
		246,
		249,
		-1,
		239,
		230,
		238,
		185,
		189,
		-1,
		-1,
		-1,
		287,
		268,
		262,
		261,
		259,
		254,
		251,
		237,
		221,
		199,
		188,
		209,
		-1,
		-1,
		-1,
		259,
		251,
		244,
		-1,
		-1,
		246,
		229,
		210,
		208,
		-1,
		-1,
		-1,
		281,
		262,
		-1,
		-1,
		236,
		-1,
		-1,
		242,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		298,
		270,
		-1,
		-1,
		-1,
		232,
		228,
		229,
		-1,
		-1,
		-1,
		-1,
		292,
		293,
		316,
		280,
		-1,
		-1,
		-1,
		224,
		218,
		-1,
		-1,
		295,
		293,
		-1,
		-1,
		-1,
		252,
		236,
		-1,
		222,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		257,
		-1,
		257,
		232,
		239,
		-1,
		-1,
		-1,
		-1,
		270,
		262,
		270,
		-1,
		242,
		244,
		-1,
		292,
		-1,
		-1,
		285,
		276,
		-1,
		-1,
		247,
		254,
		276,
		279,
		315,
		-1,
		266
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		197,
		199,
		165,
		159,
		198,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		188,
		187,
		157,
		155,
		164,
		169,
		176,
		-1,
		180,
		-1,
		209,
		188,
		199,
		204,
		150,
		147,
		167,
		186,
		173,
		165,
		224,
		180,
		151,
		145,
		163,
		158,
		167,
		159,
		-1,
		151,
		141,
		163,
		147,
		158,
		150,
		-1,
		-1,
		145,
		146,
		152,
		143,
		149,
		145,
		-1,
		155,
		139,
		-1,
		-1,
		135,
		141,
		125,
		128,
		136,
		134,
		147,
		139,
		134,
		-1,
		-1,
		131,
		127,
		134,
		121,
		117,
		134,
		147,
		129,
		143,
		142,
		-1,
		124,
		142,
		151,
		128,
		126,
		110,
		108,
		126,
		128,
		134,
		137,
		-1,
		133,
		134,
		129,
		137,
		142,
		126,
		113,
		113,
		123,
		116,
		135,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		116,
		133,
		125,
		115,
		130,
		123,
		116,
		113,
		111,
		108,
		124,
		125,
		135,
		-1,
		-1,
		188,
		157,
		192,
		149,
		134,
		-1,
		128,
		109,
		115,
		119,
		113,
		106,
		120,
		116,
		-1,
		102,
		101,
		132,
		118,
		129,
		148,
		-1,
		-1,
		146,
		138,
		123,
		126,
		123,
		123,
		124,
		123,
		115,
		101,
		97,
		103,
		106,
		106,
		112,
		96,
		106,
		110,
		121,
		136,
		-1,
		-1,
		191,
		-1,
		-1,
		145,
		128,
		-1,
		111,
		118,
		118,
		135,
		125,
		146,
		134,
		125,
		117,
		111,
		99,
		101,
		98,
		111,
		99,
		93,
		118,
		122,
		116,
		137,
		132,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		104,
		107,
		113,
		137,
		147,
		-1,
		137,
		134,
		135,
		120,
		117,
		104,
		92,
		105,
		90,
		97,
		96,
		100,
		102,
		135,
		113,
		135,
		132,
		161,
		166,
		160,
		169,
		-1,
		153,
		149,
		145,
		152,
		101,
		-1,
		-1,
		141,
		-1,
		155,
		154,
		129,
		131,
		134,
		121,
		112,
		99,
		88,
		99,
		88,
		85,
		93,
		102,
		113,
		108,
		107,
		125,
		140,
		153,
		157,
		163,
		-1,
		203,
		-1,
		145,
		129,
		131,
		103,
		124,
		-1,
		161,
		156,
		146,
		131,
		122,
		-1,
		125,
		127,
		117,
		95,
		80,
		97,
		89,
		87,
		92,
		97,
		111,
		102,
		120,
		127,
		135,
		139,
		159,
		171,
		163,
		153,
		-1,
		135,
		140,
		99,
		107,
		126,
		164,
		128,
		-1,
		123,
		-1,
		115,
		140,
		-1,
		101,
		97,
		79,
		80,
		75,
		90,
		96,
		93,
		90,
		108,
		111,
		128,
		132,
		148,
		-1,
		-1,
		148,
		152,
		141,
		92,
		111,
		135,
		172,
		121,
		110,
		109,
		-1,
		100,
		109,
		106,
		92,
		79,
		72,
		73,
		80,
		94,
		73,
		92,
		95,
		117,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		118,
		89,
		113,
		155,
		139,
		132,
		120,
		85,
		85,
		79,
		-1,
		99,
		82,
		81,
		70,
		68,
		81,
		76,
		92,
		96,
		95,
		114,
		126,
		117,
		137,
		-1,
		-1,
		-1,
		148,
		137,
		138,
		84,
		107,
		144,
		118,
		104,
		109,
		84,
		77,
		71,
		102,
		99,
		66,
		77,
		67,
		58,
		72,
		80,
		84,
		93,
		102,
		108,
		132,
		132,
		138,
		-1,
		-1,
		155,
		145,
		129,
		131,
		128,
		98,
		105,
		137,
		109,
		122,
		-1,
		76,
		-1,
		65,
		50,
		54,
		60,
		71,
		58,
		63,
		74,
		86,
		99,
		95,
		102,
		137,
		137,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		148,
		143,
		118,
		95,
		79,
		115,
		-1,
		92,
		93,
		-1,
		70,
		64,
		53,
		51,
		58,
		54,
		53,
		69,
		77,
		73,
		89,
		95,
		87,
		123,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		141,
		120,
		113,
		133,
		74,
		126,
		-1,
		-1,
		77,
		70,
		-1,
		55,
		39,
		33,
		42,
		55,
		64,
		67,
		68,
		81,
		86,
		92,
		97,
		115,
		119,
		123,
		112,
		108,
		105,
		119,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		94,
		-1,
		86,
		78,
		68,
		62,
		56,
		44,
		42,
		39,
		31,
		70,
		70,
		78,
		84,
		75,
		78,
		94,
		92,
		110,
		118,
		110,
		104,
		103,
		115,
		-1,
		161,
		147,
		118,
		-1,
		-1,
		107,
		-1,
		71,
		85,
		101,
		-1,
		94,
		73,
		85,
		66,
		54,
		17,
		90,
		91,
		69,
		74,
		82,
		92,
		100,
		89,
		100,
		92,
		114,
		114,
		98,
		99,
		108,
		-1,
		167,
		154,
		112,
		108,
		97,
		117,
		68,
		56,
		88,
		-1,
		-1,
		130,
		-1,
		64,
		81,
		2,
		0,
		80,
		71,
		77,
		93,
		96,
		104,
		94,
		83,
		89,
		86,
		108,
		94,
		92,
		111,
		127,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		83,
		70,
		64,
		-1,
		105,
		-1,
		108,
		98,
		82,
		67,
		100,
		-1,
		88,
		72,
		77,
		-1,
		129,
		-1,
		102,
		104,
		98,
		83,
		80,
		91,
		89,
		100,
		117,
		-1,
		117,
		102,
		95,
		85,
		99,
		70,
		-1,
		125,
		-1,
		-1,
		95,
		89,
		89,
		73,
		76,
		104,
		84,
		78,
		77,
		124,
		123,
		110,
		96,
		89,
		86,
		83,
		96,
		116,
		107,
		119,
		-1,
		-1,
		-1,
		122,
		108,
		112,
		72,
		91,
		-1,
		-1,
		157,
		112,
		98,
		-1,
		82,
		121,
		109,
		99,
		89,
		123,
		124,
		114,
		108,
		94,
		96,
		94,
		92,
		97,
		118,
		119,
		132,
		-1,
		-1,
		105,
		110,
		98,
		84,
		103,
		-1,
		-1,
		-1,
		104,
		120,
		112,
		83,
		110,
		-1,
		-1,
		101,
		99,
		109,
		111,
		98,
		118,
		121,
		107,
		91,
		106,
		118,
		126,
		131,
		-1,
		108,
		95,
		-1,
		-1,
		106,
		100,
		-1,
		-1,
		-1,
		-1,
		137,
		103,
		115,
		136,
		152,
		104,
		-1,
		109,
		110,
		102,
		116,
		123,
		109,
		104,
		98,
		101,
		119,
		136,
		-1,
		-1,
		120,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		94,
		108,
		129,
		134,
		138,
		-1,
		118,
		118,
		104,
		121,
		122,
		119,
		110,
		102,
		107,
		104,
		117,
		131,
		135,
		143,
		-1,
		126,
		-1,
		-1,
		-1,
		112,
		127,
		180,
		157,
		130,
		125,
		118,
		112,
		112,
		128,
		130,
		141,
		109,
		105,
		106,
		110,
		109,
		126,
		136,
		-1,
		-1,
		126,
		143,
		138,
		120,
		124,
		207,
		-1,
		-1,
		134,
		125,
		116,
		119,
		122,
		125,
		115,
		112,
		117,
		122,
		110,
		119,
		137,
		141,
		-1,
		-1,
		-1,
		146,
		-1,
		161,
		-1,
		-1,
		139,
		205,
		152,
		134,
		130,
		128,
		121,
		130,
		125,
		120,
		130,
		139,
		131,
		112,
		123,
		146,
		135,
		173,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		175,
		150,
		165,
		211,
		159,
		166,
		167,
		164,
		-1,
		134,
		159,
		131,
		138,
		130,
		138,
		138,
		135,
		113,
		120,
		136,
		135,
		130,
		165,
		157,
		163,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		181,
		167,
		197,
		187,
		176,
		-1,
		-1,
		183,
		180,
		156,
		140,
		144,
		137,
		132,
		142,
		122,
		109,
		113,
		117,
		123,
		128,
		133,
		139,
		154,
		169,
		-1,
		153,
		234,
		227,
		210,
		218,
		249,
		-1,
		184,
		193,
		174,
		179,
		186,
		-1,
		-1,
		156,
		153,
		158,
		147,
		144,
		152,
		147,
		138,
		123,
		129,
		116,
		115,
		133,
		137,
		146,
		153,
		143,
		156,
		160,
		-1,
		167,
		210,
		204,
		207,
		231,
		245,
		-1,
		197,
		-1,
		-1,
		182,
		187,
		171,
		161,
		155,
		205,
		161,
		156,
		146,
		144,
		135,
		126,
		133,
		124,
		124,
		127,
		142,
		147,
		139,
		153,
		153,
		154,
		-1,
		202,
		190,
		198,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		198,
		-1,
		198,
		-1,
		173,
		177,
		169,
		172,
		160,
		147,
		139,
		131,
		147,
		122,
		132,
		128,
		129,
		138,
		149,
		161,
		160,
		161,
		275,
		231,
		198,
		189,
		236,
		251,
		255,
		-1,
		210,
		249,
		236,
		-1,
		207,
		-1,
		-1,
		-1,
		187,
		182,
		174,
		180,
		159,
		159,
		133,
		137,
		127,
		134,
		144,
		146,
		138,
		142,
		155,
		166,
		169,
		271,
		262,
		275,
		220,
		203,
		221,
		230,
		251,
		225,
		216,
		243,
		243,
		232,
		227,
		214,
		-1,
		-1,
		210,
		192,
		-1,
		-1,
		166,
		154,
		137,
		138,
		134,
		137,
		152,
		155,
		145,
		143,
		137,
		169,
		-1,
		264,
		263,
		252,
		249,
		225,
		216,
		211,
		222,
		-1,
		-1,
		228,
		244,
		244,
		248,
		264,
		289,
		-1,
		217,
		-1,
		-1,
		211,
		-1,
		-1,
		196,
		159,
		148,
		139,
		145,
		142,
		153,
		163,
		151,
		152,
		142,
		152,
		165,
		248,
		245,
		233,
		231,
		254,
		219,
		207,
		-1,
		220,
		218,
		224,
		231,
		248,
		278,
		-1,
		-1,
		233,
		222,
		-1,
		-1,
		194,
		192,
		181,
		-1,
		171,
		144,
		149,
		169,
		171,
		160,
		154,
		148,
		155,
		154,
		162,
		170,
		257,
		271,
		260,
		256,
		255,
		263,
		212,
		205,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		232,
		228,
		-1,
		-1,
		189,
		182,
		170,
		158,
		148,
		158,
		162,
		166,
		158,
		151,
		146,
		157,
		149,
		153,
		170,
		-1,
		291,
		-1,
		243,
		219,
		233,
		248,
		256,
		-1,
		-1,
		-1,
		249,
		235,
		228,
		216,
		214,
		-1,
		223,
		207,
		188,
		-1,
		158,
		171,
		202,
		170,
		175,
		170,
		152,
		163,
		152,
		155,
		169,
		164,
		-1,
		-1,
		231,
		234,
		-1,
		-1,
		239,
		241,
		-1,
		240,
		229,
		214,
		206,
		-1,
		-1,
		195,
		191,
		-1,
		-1,
		159,
		184,
		173,
		181,
		176,
		156,
		162,
		165,
		154,
		158,
		170,
		-1,
		-1,
		238,
		239,
		244,
		-1,
		224,
		-1,
		242,
		-1,
		209,
		215,
		203,
		-1,
		-1,
		-1,
		197,
		160,
		181,
		191,
		185,
		183,
		174,
		160,
		167,
		165,
		161,
		172,
		-1,
		-1,
		-1,
		242,
		216,
		249,
		240,
		223,
		203,
		195,
		214,
		-1,
		184,
		-1,
		159,
		161,
		187,
		190,
		196,
		190,
		163,
		178,
		168,
		159,
		168,
		248,
		-1,
		218,
		251,
		215,
		209,
		185,
		189,
		205,
		-1,
		181,
		163,
		-1,
		191,
		181,
		212,
		197,
		178,
		165,
		172,
		172,
		165,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		205,
		190,
		181,
		-1,
		193,
		175,
		154,
		171,
		171,
		162,
		170,
		202,
		198,
		185,
		185,
		177,
		-1,
		321,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		209,
		182,
		170,
		176,
		172,
		158,
		164,
		166,
		174,
		172,
		169,
		181,
		177,
		197,
		178,
		213,
		-1,
		316,
		-1,
		250,
		-1,
		-1,
		232,
		212,
		204,
		193,
		182,
		180,
		171,
		162,
		184,
		200,
		184,
		182,
		185,
		186,
		-1,
		305,
		304,
		-1,
		251,
		243,
		229,
		-1,
		222,
		-1,
		228,
		189,
		-1,
		191,
		171,
		-1,
		193,
		189,
		-1,
		-1,
		292,
		267,
		-1,
		-1,
		-1,
		252,
		232,
		223,
		207,
		-1,
		182,
		182,
		-1,
		-1,
		-1,
		277,
		276,
		-1,
		245,
		248,
		-1,
		238,
		229,
		237,
		184,
		188,
		-1,
		-1,
		-1,
		286,
		267,
		261,
		260,
		258,
		253,
		250,
		236,
		220,
		198,
		187,
		208,
		-1,
		-1,
		-1,
		258,
		250,
		243,
		-1,
		-1,
		245,
		228,
		209,
		207,
		-1,
		-1,
		-1,
		280,
		261,
		-1,
		-1,
		235,
		-1,
		-1,
		241,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		269,
		-1,
		-1,
		-1,
		231,
		227,
		228,
		-1,
		-1,
		-1,
		-1,
		291,
		292,
		315,
		279,
		-1,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		294,
		292,
		-1,
		-1,
		-1,
		251,
		235,
		-1,
		221,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		256,
		-1,
		256,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		269,
		261,
		269,
		-1,
		241,
		243,
		-1,
		291,
		-1,
		-1,
		284,
		275,
		-1,
		-1,
		246,
		253,
		275,
		278,
		314,
		-1,
		265
	],
	[
		-1,
		184,
		173,
		184,
		192,
		165,
		172,
		-1,
		193,
		195,
		161,
		155,
		194,
		165,
		171,
		182,
		-1,
		-1,
		-1,
		184,
		183,
		153,
		151,
		160,
		165,
		172,
		-1,
		176,
		-1,
		205,
		184,
		195,
		200,
		146,
		143,
		163,
		182,
		169,
		161,
		220,
		176,
		147,
		141,
		159,
		154,
		163,
		155,
		-1,
		147,
		137,
		159,
		143,
		154,
		146,
		-1,
		-1,
		141,
		142,
		148,
		139,
		145,
		141,
		-1,
		151,
		135,
		-1,
		-1,
		131,
		137,
		121,
		124,
		132,
		130,
		143,
		135,
		130,
		-1,
		-1,
		127,
		123,
		130,
		117,
		113,
		130,
		143,
		125,
		139,
		138,
		-1,
		120,
		138,
		147,
		124,
		122,
		106,
		104,
		122,
		124,
		130,
		133,
		-1,
		129,
		130,
		125,
		133,
		138,
		122,
		109,
		109,
		119,
		112,
		131,
		122,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		129,
		112,
		129,
		121,
		111,
		126,
		119,
		112,
		109,
		107,
		104,
		120,
		121,
		131,
		-1,
		-1,
		208,
		177,
		212,
		169,
		154,
		-1,
		125,
		105,
		111,
		115,
		109,
		102,
		116,
		112,
		-1,
		98,
		97,
		128,
		114,
		125,
		168,
		-1,
		-1,
		166,
		158,
		143,
		146,
		135,
		131,
		120,
		119,
		111,
		97,
		93,
		99,
		102,
		102,
		108,
		92,
		102,
		106,
		116,
		132,
		-1,
		-1,
		181,
		-1,
		-1,
		165,
		148,
		-1,
		131,
		138,
		138,
		147,
		133,
		154,
		130,
		121,
		113,
		107,
		95,
		97,
		94,
		107,
		95,
		89,
		114,
		118,
		111,
		132,
		127,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		124,
		127,
		133,
		157,
		167,
		-1,
		142,
		130,
		131,
		116,
		113,
		100,
		88,
		101,
		86,
		93,
		92,
		96,
		98,
		131,
		108,
		130,
		127,
		151,
		156,
		150,
		159,
		-1,
		173,
		169,
		165,
		172,
		121,
		-1,
		-1,
		161,
		-1,
		175,
		174,
		149,
		127,
		130,
		117,
		108,
		95,
		84,
		95,
		84,
		81,
		89,
		97,
		109,
		103,
		102,
		120,
		135,
		143,
		147,
		153,
		-1,
		223,
		-1,
		165,
		149,
		151,
		123,
		144,
		-1,
		181,
		176,
		166,
		151,
		142,
		-1,
		126,
		123,
		113,
		91,
		76,
		93,
		85,
		83,
		88,
		92,
		106,
		97,
		115,
		122,
		125,
		129,
		149,
		161,
		183,
		173,
		-1,
		155,
		160,
		119,
		127,
		146,
		184,
		148,
		-1,
		143,
		-1,
		128,
		141,
		-1,
		97,
		93,
		75,
		76,
		71,
		86,
		91,
		88,
		85,
		103,
		106,
		118,
		122,
		138,
		-1,
		-1,
		168,
		172,
		161,
		112,
		131,
		155,
		192,
		141,
		130,
		129,
		-1,
		120,
		111,
		108,
		96,
		83,
		68,
		69,
		77,
		89,
		68,
		87,
		89,
		109,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		138,
		109,
		133,
		175,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		107,
		86,
		77,
		66,
		64,
		77,
		69,
		87,
		87,
		85,
		104,
		116,
		107,
		127,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		138,
		124,
		129,
		104,
		97,
		91,
		117,
		103,
		81,
		73,
		65,
		54,
		65,
		73,
		77,
		83,
		92,
		98,
		122,
		125,
		131,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		76,
		74,
		67,
		70,
		51,
		56,
		70,
		79,
		90,
		85,
		92,
		127,
		127,
		115,
		135,
		138,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		79,
		71,
		72,
		55,
		55,
		56,
		70,
		57,
		76,
		78,
		77,
		113,
		-1,
		123,
		117,
		125,
		115,
		103,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		53,
		45,
		39,
		48,
		44,
		51,
		64,
		69,
		82,
		80,
		108,
		112,
		116,
		105,
		101,
		98,
		112,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		70,
		68,
		67,
		51,
		54,
		52,
		49,
		55,
		58,
		61,
		77,
		85,
		103,
		111,
		103,
		97,
		96,
		108,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		80,
		65,
		10,
		11,
		28,
		29,
		45,
		55,
		83,
		72,
		93,
		85,
		107,
		107,
		91,
		92,
		101,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		79,
		77,
		0,
		30,
		36,
		56,
		59,
		69,
		77,
		66,
		72,
		79,
		101,
		87,
		85,
		104,
		120,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		53,
		37,
		42,
		-1,
		94,
		-1,
		85,
		87,
		85,
		76,
		73,
		84,
		82,
		93,
		110,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		69,
		49,
		43,
		42,
		93,
		88,
		79,
		89,
		82,
		79,
		76,
		89,
		109,
		100,
		112,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		86,
		74,
		64,
		54,
		88,
		89,
		79,
		84,
		87,
		89,
		87,
		85,
		90,
		111,
		112,
		125,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		75,
		-1,
		-1,
		66,
		64,
		74,
		80,
		91,
		109,
		114,
		100,
		84,
		99,
		111,
		119,
		124,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		123,
		118,
		122,
		69,
		-1,
		74,
		75,
		93,
		105,
		112,
		102,
		97,
		91,
		94,
		112,
		129,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		111,
		104,
		108,
		-1,
		83,
		83,
		95,
		106,
		115,
		112,
		103,
		95,
		100,
		97,
		110,
		124,
		128,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		147,
		150,
		127,
		100,
		95,
		88,
		82,
		87,
		107,
		113,
		124,
		102,
		98,
		99,
		103,
		102,
		119,
		129,
		-1,
		-1,
		146,
		163,
		158,
		140,
		144,
		177,
		-1,
		-1,
		104,
		95,
		86,
		89,
		97,
		100,
		105,
		105,
		110,
		115,
		103,
		112,
		130,
		134,
		-1,
		-1,
		-1,
		166,
		-1,
		181,
		-1,
		-1,
		159,
		175,
		122,
		104,
		100,
		98,
		91,
		100,
		95,
		100,
		123,
		120,
		125,
		105,
		118,
		140,
		130,
		166,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		193,
		170,
		180,
		186,
		179,
		179,
		137,
		134,
		-1,
		104,
		129,
		101,
		108,
		100,
		113,
		118,
		124,
		108,
		115,
		131,
		130,
		125,
		158,
		152,
		158,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		186,
		182,
		172,
		162,
		165,
		-1,
		-1,
		153,
		150,
		126,
		110,
		114,
		107,
		102,
		137,
		116,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		173,
		254,
		247,
		230,
		238,
		269,
		-1,
		176,
		168,
		179,
		154,
		156,
		-1,
		-1,
		126,
		123,
		128,
		117,
		114,
		126,
		125,
		133,
		118,
		124,
		111,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		187,
		230,
		224,
		227,
		251,
		265,
		-1,
		173,
		-1,
		-1,
		185,
		157,
		141,
		131,
		125,
		175,
		131,
		126,
		128,
		130,
		130,
		121,
		128,
		119,
		119,
		122,
		137,
		142,
		134,
		148,
		148,
		149,
		-1,
		220,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		201,
		-1,
		168,
		-1,
		143,
		147,
		139,
		142,
		153,
		140,
		134,
		126,
		142,
		117,
		127,
		123,
		124,
		133,
		144,
		156,
		155,
		156,
		245,
		201,
		204,
		209,
		226,
		241,
		245,
		-1,
		185,
		224,
		239,
		-1,
		210,
		-1,
		-1,
		-1,
		157,
		152,
		144,
		160,
		152,
		152,
		128,
		132,
		122,
		129,
		139,
		141,
		133,
		137,
		150,
		161,
		164,
		241,
		232,
		245,
		190,
		190,
		211,
		220,
		241,
		200,
		191,
		218,
		244,
		235,
		230,
		217,
		-1,
		-1,
		180,
		162,
		-1,
		-1,
		159,
		149,
		132,
		133,
		129,
		132,
		147,
		150,
		140,
		138,
		132,
		164,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		181,
		208,
		-1,
		-1,
		203,
		219,
		214,
		218,
		234,
		259,
		-1,
		220,
		-1,
		-1,
		201,
		-1,
		-1,
		191,
		154,
		143,
		134,
		140,
		137,
		148,
		158,
		146,
		147,
		137,
		147,
		160,
		218,
		215,
		203,
		201,
		224,
		189,
		177,
		-1,
		190,
		188,
		194,
		201,
		218,
		248,
		-1,
		-1,
		236,
		216,
		-1,
		-1,
		189,
		187,
		176,
		-1,
		166,
		139,
		144,
		164,
		166,
		155,
		149,
		143,
		150,
		149,
		157,
		165,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		175,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		226,
		222,
		-1,
		-1,
		184,
		177,
		165,
		153,
		143,
		153,
		157,
		161,
		153,
		146,
		141,
		152,
		144,
		148,
		165,
		-1,
		261,
		-1,
		213,
		189,
		203,
		218,
		226,
		-1,
		-1,
		-1,
		243,
		229,
		222,
		210,
		208,
		-1,
		218,
		202,
		183,
		-1,
		153,
		166,
		197,
		165,
		170,
		165,
		147,
		158,
		147,
		150,
		164,
		159,
		-1,
		-1,
		201,
		204,
		-1,
		-1,
		226,
		235,
		-1,
		234,
		223,
		208,
		200,
		-1,
		-1,
		190,
		186,
		-1,
		-1,
		154,
		179,
		168,
		176,
		171,
		151,
		157,
		160,
		149,
		153,
		165,
		-1,
		-1,
		208,
		209,
		214,
		-1,
		218,
		-1,
		236,
		-1,
		203,
		209,
		197,
		-1,
		-1,
		-1,
		192,
		155,
		176,
		186,
		180,
		178,
		169,
		155,
		162,
		160,
		156,
		167,
		-1,
		-1,
		-1,
		236,
		210,
		243,
		234,
		217,
		197,
		189,
		208,
		-1,
		178,
		-1,
		153,
		156,
		181,
		185,
		191,
		185,
		158,
		173,
		163,
		154,
		163,
		242,
		-1,
		212,
		245,
		209,
		203,
		179,
		183,
		199,
		-1,
		175,
		157,
		-1,
		185,
		175,
		207,
		192,
		173,
		160,
		167,
		167,
		160,
		-1,
		-1,
		-1,
		214,
		213,
		205,
		199,
		199,
		184,
		175,
		-1,
		187,
		169,
		148,
		165,
		165,
		156,
		164,
		197,
		193,
		180,
		180,
		172,
		-1,
		315,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		208,
		203,
		176,
		164,
		170,
		166,
		152,
		158,
		160,
		168,
		166,
		163,
		175,
		171,
		191,
		173,
		208,
		-1,
		310,
		-1,
		244,
		-1,
		-1,
		226,
		206,
		198,
		187,
		176,
		174,
		165,
		156,
		178,
		194,
		178,
		176,
		180,
		181,
		-1,
		299,
		298,
		-1,
		245,
		237,
		223,
		-1,
		216,
		-1,
		222,
		183,
		-1,
		185,
		165,
		-1,
		187,
		183,
		-1,
		-1,
		286,
		261,
		-1,
		-1,
		-1,
		246,
		226,
		217,
		201,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		271,
		270,
		-1,
		239,
		242,
		-1,
		232,
		223,
		231,
		178,
		182,
		-1,
		-1,
		-1,
		280,
		261,
		255,
		254,
		252,
		247,
		244,
		230,
		214,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		252,
		244,
		237,
		-1,
		-1,
		239,
		222,
		203,
		201,
		-1,
		-1,
		-1,
		274,
		255,
		-1,
		-1,
		229,
		-1,
		-1,
		235,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		263,
		-1,
		-1,
		-1,
		225,
		221,
		222,
		-1,
		-1,
		-1,
		-1,
		285,
		286,
		309,
		273,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		288,
		286,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		164,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		157,
		149,
		208,
		164,
		135,
		129,
		147,
		142,
		151,
		143,
		-1,
		135,
		125,
		147,
		131,
		142,
		134,
		-1,
		-1,
		129,
		130,
		136,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		119,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		108,
		126,
		135,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		121,
		-1,
		117,
		118,
		113,
		121,
		126,
		110,
		97,
		97,
		107,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		117,
		100,
		117,
		109,
		99,
		114,
		107,
		100,
		97,
		95,
		92,
		108,
		109,
		119,
		-1,
		-1,
		196,
		165,
		200,
		157,
		142,
		-1,
		113,
		93,
		99,
		103,
		97,
		90,
		104,
		100,
		-1,
		86,
		85,
		116,
		102,
		113,
		156,
		-1,
		-1,
		154,
		146,
		131,
		134,
		123,
		119,
		108,
		107,
		99,
		85,
		81,
		87,
		90,
		90,
		96,
		80,
		90,
		94,
		104,
		120,
		-1,
		-1,
		164,
		-1,
		-1,
		153,
		136,
		-1,
		119,
		126,
		126,
		135,
		121,
		142,
		118,
		109,
		101,
		95,
		83,
		85,
		82,
		95,
		83,
		77,
		102,
		106,
		99,
		120,
		115,
		-1,
		163,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		115,
		121,
		145,
		155,
		-1,
		130,
		118,
		119,
		104,
		101,
		88,
		76,
		89,
		74,
		81,
		80,
		84,
		86,
		119,
		96,
		118,
		115,
		134,
		139,
		133,
		142,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		149,
		-1,
		163,
		162,
		137,
		115,
		118,
		105,
		96,
		83,
		72,
		83,
		72,
		69,
		77,
		85,
		97,
		91,
		90,
		108,
		118,
		126,
		130,
		136,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		169,
		164,
		154,
		139,
		130,
		-1,
		114,
		111,
		101,
		79,
		64,
		81,
		73,
		71,
		76,
		80,
		94,
		85,
		103,
		110,
		108,
		112,
		132,
		144,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		131,
		-1,
		116,
		129,
		-1,
		85,
		81,
		63,
		64,
		59,
		74,
		79,
		76,
		73,
		91,
		94,
		101,
		105,
		121,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		108,
		99,
		96,
		84,
		71,
		56,
		57,
		65,
		77,
		56,
		75,
		72,
		92,
		118,
		96,
		108,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		95,
		74,
		65,
		54,
		52,
		65,
		57,
		75,
		70,
		68,
		87,
		99,
		90,
		110,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		105,
		91,
		69,
		61,
		53,
		42,
		53,
		61,
		65,
		66,
		75,
		81,
		105,
		112,
		118,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		64,
		62,
		55,
		58,
		39,
		44,
		57,
		67,
		73,
		68,
		75,
		110,
		110,
		102,
		122,
		125,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		67,
		59,
		60,
		43,
		43,
		44,
		56,
		40,
		59,
		61,
		60,
		96,
		-1,
		110,
		104,
		112,
		102,
		90,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		65,
		47,
		41,
		33,
		27,
		36,
		27,
		34,
		47,
		52,
		65,
		63,
		93,
		97,
		103,
		92,
		88,
		85,
		99,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		58,
		56,
		55,
		39,
		42,
		35,
		32,
		38,
		41,
		44,
		60,
		70,
		88,
		98,
		90,
		84,
		83,
		95,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		68,
		53,
		36,
		37,
		7,
		12,
		28,
		38,
		66,
		55,
		78,
		72,
		94,
		94,
		78,
		79,
		88,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		67,
		65,
		26,
		0,
		7,
		35,
		42,
		52,
		60,
		49,
		55,
		66,
		88,
		74,
		72,
		91,
		107,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		24,
		8,
		13,
		-1,
		77,
		-1,
		65,
		70,
		68,
		60,
		60,
		71,
		69,
		80,
		97,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		40,
		20,
		18,
		13,
		76,
		63,
		62,
		68,
		66,
		63,
		63,
		76,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		61,
		49,
		39,
		29,
		63,
		64,
		54,
		59,
		68,
		73,
		71,
		72,
		77,
		98,
		99,
		112,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		50,
		-1,
		-1,
		41,
		39,
		49,
		55,
		70,
		84,
		91,
		87,
		71,
		86,
		98,
		106,
		111,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		145,
		109,
		98,
		93,
		97,
		44,
		-1,
		49,
		50,
		68,
		80,
		87,
		89,
		84,
		78,
		81,
		99,
		116,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		102,
		115,
		86,
		79,
		83,
		-1,
		58,
		58,
		70,
		81,
		93,
		98,
		90,
		82,
		87,
		84,
		97,
		111,
		115,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		120,
		135,
		125,
		102,
		75,
		70,
		63,
		57,
		62,
		82,
		88,
		99,
		84,
		85,
		86,
		90,
		89,
		106,
		116,
		-1,
		-1,
		134,
		151,
		146,
		128,
		132,
		152,
		-1,
		-1,
		79,
		70,
		61,
		64,
		72,
		75,
		80,
		82,
		97,
		102,
		90,
		99,
		117,
		121,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		147,
		150,
		97,
		79,
		75,
		73,
		66,
		75,
		70,
		75,
		100,
		95,
		104,
		92,
		105,
		127,
		117,
		153,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		168,
		158,
		155,
		161,
		163,
		154,
		112,
		109,
		-1,
		79,
		104,
		76,
		83,
		75,
		88,
		93,
		99,
		95,
		102,
		118,
		117,
		112,
		145,
		139,
		145,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		128,
		125,
		101,
		85,
		89,
		82,
		77,
		115,
		91,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		161,
		242,
		235,
		211,
		219,
		250,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		101,
		98,
		103,
		92,
		89,
		101,
		100,
		111,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		175,
		218,
		205,
		208,
		232,
		246,
		-1,
		148,
		-1,
		-1,
		160,
		132,
		116,
		106,
		100,
		150,
		106,
		101,
		103,
		105,
		109,
		100,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		195,
		198,
		199,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		176,
		-1,
		143,
		-1,
		118,
		122,
		114,
		117,
		128,
		115,
		113,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		160,
		199,
		214,
		-1,
		185,
		-1,
		-1,
		-1,
		132,
		127,
		119,
		135,
		127,
		127,
		107,
		111,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		175,
		166,
		193,
		219,
		210,
		205,
		192,
		-1,
		-1,
		155,
		137,
		-1,
		-1,
		134,
		128,
		111,
		113,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		194,
		189,
		193,
		209,
		234,
		-1,
		195,
		-1,
		-1,
		176,
		-1,
		-1,
		170,
		133,
		122,
		113,
		119,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		223,
		-1,
		-1,
		211,
		191,
		-1,
		-1,
		168,
		166,
		155,
		-1,
		145,
		118,
		123,
		148,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		197,
		-1,
		-1,
		163,
		156,
		144,
		132,
		122,
		132,
		140,
		140,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		197,
		181,
		162,
		-1,
		132,
		145,
		176,
		144,
		149,
		144,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		176,
		179,
		-1,
		-1,
		201,
		210,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		169,
		165,
		-1,
		-1,
		133,
		158,
		147,
		155,
		150,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		183,
		184,
		189,
		-1,
		193,
		-1,
		211,
		-1,
		178,
		184,
		172,
		-1,
		-1,
		-1,
		171,
		134,
		151,
		165,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		211,
		185,
		218,
		209,
		192,
		172,
		164,
		183,
		-1,
		153,
		-1,
		128,
		131,
		156,
		164,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		217,
		-1,
		187,
		220,
		184,
		178,
		154,
		158,
		174,
		-1,
		150,
		132,
		-1,
		160,
		150,
		194,
		173,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		189,
		188,
		180,
		174,
		174,
		159,
		150,
		-1,
		162,
		144,
		123,
		140,
		140,
		131,
		139,
		184,
		180,
		167,
		167,
		159,
		-1,
		290,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		183,
		178,
		151,
		139,
		145,
		141,
		127,
		133,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		160,
		194,
		-1,
		285,
		-1,
		219,
		-1,
		-1,
		201,
		181,
		173,
		162,
		151,
		149,
		140,
		131,
		153,
		169,
		153,
		151,
		156,
		161,
		-1,
		274,
		273,
		-1,
		220,
		212,
		198,
		-1,
		191,
		-1,
		197,
		158,
		-1,
		160,
		140,
		-1,
		162,
		158,
		-1,
		-1,
		261,
		236,
		-1,
		-1,
		-1,
		221,
		201,
		192,
		176,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		246,
		245,
		-1,
		214,
		217,
		-1,
		207,
		198,
		206,
		153,
		157,
		-1,
		-1,
		-1,
		255,
		236,
		230,
		229,
		227,
		222,
		219,
		205,
		189,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		227,
		219,
		212,
		-1,
		-1,
		214,
		197,
		178,
		176,
		-1,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		204,
		-1,
		-1,
		210,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		238,
		-1,
		-1,
		-1,
		200,
		196,
		197,
		-1,
		-1,
		-1,
		-1,
		260,
		261,
		284,
		248,
		-1,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		263,
		261,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		190,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		225,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		238,
		230,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		215,
		222,
		244,
		247,
		283,
		-1,
		234
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		187,
		189,
		155,
		149,
		188,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		178,
		177,
		147,
		145,
		154,
		159,
		166,
		-1,
		170,
		-1,
		199,
		178,
		189,
		194,
		140,
		137,
		157,
		176,
		163,
		155,
		214,
		170,
		141,
		135,
		153,
		148,
		157,
		149,
		-1,
		141,
		131,
		153,
		137,
		148,
		140,
		-1,
		-1,
		135,
		136,
		142,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		125,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		114,
		132,
		141,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		127,
		-1,
		123,
		124,
		119,
		127,
		132,
		116,
		103,
		103,
		113,
		106,
		125,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		123,
		106,
		123,
		115,
		105,
		120,
		113,
		106,
		103,
		101,
		98,
		114,
		115,
		125,
		-1,
		-1,
		202,
		171,
		206,
		163,
		148,
		-1,
		119,
		99,
		105,
		109,
		103,
		96,
		110,
		106,
		-1,
		92,
		91,
		122,
		108,
		119,
		162,
		-1,
		-1,
		160,
		152,
		137,
		140,
		129,
		125,
		114,
		113,
		105,
		91,
		87,
		93,
		96,
		96,
		102,
		86,
		96,
		100,
		110,
		126,
		-1,
		-1,
		170,
		-1,
		-1,
		159,
		142,
		-1,
		125,
		132,
		132,
		141,
		127,
		148,
		124,
		115,
		107,
		101,
		89,
		91,
		88,
		101,
		89,
		83,
		108,
		112,
		105,
		126,
		121,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		118,
		121,
		127,
		151,
		161,
		-1,
		136,
		124,
		125,
		110,
		107,
		94,
		82,
		95,
		80,
		87,
		86,
		90,
		92,
		125,
		102,
		124,
		121,
		140,
		145,
		139,
		148,
		-1,
		167,
		163,
		159,
		166,
		115,
		-1,
		-1,
		155,
		-1,
		169,
		168,
		143,
		121,
		124,
		111,
		102,
		89,
		78,
		89,
		78,
		75,
		83,
		91,
		103,
		97,
		96,
		114,
		124,
		132,
		136,
		142,
		-1,
		217,
		-1,
		159,
		143,
		145,
		117,
		138,
		-1,
		175,
		170,
		160,
		145,
		136,
		-1,
		120,
		117,
		107,
		85,
		70,
		87,
		79,
		77,
		82,
		86,
		100,
		91,
		109,
		116,
		114,
		118,
		138,
		150,
		177,
		167,
		-1,
		149,
		154,
		113,
		121,
		140,
		178,
		142,
		-1,
		137,
		-1,
		122,
		135,
		-1,
		91,
		87,
		69,
		70,
		65,
		80,
		85,
		82,
		79,
		97,
		100,
		107,
		111,
		127,
		-1,
		-1,
		162,
		166,
		155,
		106,
		125,
		149,
		186,
		135,
		124,
		123,
		-1,
		114,
		105,
		102,
		90,
		77,
		62,
		63,
		71,
		83,
		62,
		81,
		78,
		98,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		132,
		103,
		127,
		169,
		153,
		146,
		134,
		99,
		99,
		93,
		-1,
		101,
		80,
		71,
		60,
		58,
		71,
		63,
		81,
		76,
		74,
		93,
		105,
		96,
		116,
		-1,
		-1,
		-1,
		162,
		151,
		152,
		98,
		121,
		158,
		132,
		118,
		123,
		98,
		91,
		85,
		111,
		97,
		75,
		67,
		59,
		48,
		59,
		67,
		71,
		72,
		81,
		87,
		111,
		118,
		124,
		-1,
		-1,
		169,
		159,
		143,
		145,
		142,
		112,
		119,
		151,
		123,
		136,
		-1,
		90,
		-1,
		79,
		70,
		68,
		61,
		64,
		45,
		50,
		63,
		73,
		79,
		74,
		81,
		116,
		116,
		108,
		128,
		131,
		-1,
		-1,
		-1,
		162,
		157,
		132,
		109,
		93,
		129,
		-1,
		106,
		107,
		-1,
		84,
		78,
		73,
		65,
		66,
		49,
		49,
		50,
		62,
		46,
		65,
		67,
		66,
		102,
		-1,
		116,
		110,
		118,
		108,
		96,
		-1,
		-1,
		-1,
		155,
		134,
		127,
		147,
		88,
		140,
		-1,
		-1,
		91,
		84,
		-1,
		71,
		53,
		47,
		39,
		33,
		42,
		33,
		40,
		53,
		58,
		71,
		69,
		99,
		103,
		109,
		98,
		94,
		91,
		105,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		108,
		-1,
		100,
		92,
		82,
		76,
		70,
		64,
		62,
		61,
		45,
		48,
		41,
		38,
		44,
		47,
		50,
		66,
		76,
		94,
		104,
		96,
		90,
		89,
		101,
		-1,
		175,
		161,
		132,
		-1,
		-1,
		121,
		-1,
		85,
		99,
		115,
		-1,
		108,
		87,
		102,
		80,
		74,
		59,
		42,
		43,
		13,
		18,
		33,
		43,
		72,
		61,
		84,
		78,
		100,
		100,
		84,
		85,
		94,
		-1,
		181,
		168,
		126,
		122,
		111,
		131,
		82,
		70,
		102,
		-1,
		-1,
		144,
		-1,
		78,
		95,
		73,
		71,
		32,
		7,
		0,
		28,
		47,
		57,
		66,
		55,
		61,
		72,
		94,
		80,
		78,
		97,
		113,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		97,
		84,
		78,
		-1,
		119,
		-1,
		122,
		112,
		96,
		81,
		114,
		-1,
		31,
		15,
		20,
		-1,
		82,
		-1,
		72,
		76,
		74,
		66,
		66,
		77,
		75,
		86,
		103,
		-1,
		131,
		116,
		109,
		99,
		113,
		84,
		-1,
		139,
		-1,
		-1,
		109,
		103,
		103,
		87,
		90,
		47,
		27,
		25,
		20,
		81,
		70,
		67,
		75,
		72,
		69,
		69,
		82,
		102,
		93,
		105,
		-1,
		-1,
		-1,
		136,
		122,
		126,
		86,
		105,
		-1,
		-1,
		171,
		126,
		112,
		-1,
		96,
		68,
		56,
		46,
		36,
		70,
		71,
		61,
		66,
		75,
		79,
		77,
		78,
		83,
		104,
		105,
		118,
		-1,
		-1,
		119,
		124,
		112,
		98,
		117,
		-1,
		-1,
		-1,
		118,
		134,
		126,
		97,
		57,
		-1,
		-1,
		48,
		46,
		56,
		62,
		77,
		91,
		98,
		93,
		77,
		92,
		104,
		112,
		117,
		-1,
		122,
		109,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		-1,
		-1,
		151,
		116,
		105,
		100,
		104,
		51,
		-1,
		56,
		57,
		75,
		87,
		94,
		95,
		90,
		84,
		87,
		105,
		122,
		-1,
		-1,
		134,
		-1,
		129,
		-1,
		-1,
		-1,
		-1,
		108,
		122,
		93,
		86,
		90,
		-1,
		65,
		65,
		77,
		88,
		100,
		105,
		96,
		88,
		93,
		90,
		103,
		117,
		121,
		157,
		-1,
		140,
		-1,
		-1,
		-1,
		126,
		141,
		132,
		109,
		82,
		77,
		70,
		64,
		69,
		89,
		95,
		106,
		91,
		91,
		92,
		96,
		95,
		112,
		122,
		-1,
		-1,
		140,
		157,
		152,
		134,
		138,
		159,
		-1,
		-1,
		86,
		77,
		68,
		71,
		79,
		82,
		87,
		89,
		103,
		108,
		96,
		105,
		123,
		127,
		-1,
		-1,
		-1,
		160,
		-1,
		175,
		-1,
		-1,
		153,
		157,
		104,
		86,
		82,
		80,
		73,
		82,
		77,
		82,
		107,
		102,
		111,
		98,
		111,
		133,
		123,
		159,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		175,
		164,
		162,
		168,
		170,
		161,
		119,
		116,
		-1,
		86,
		111,
		83,
		90,
		82,
		95,
		100,
		106,
		101,
		108,
		124,
		123,
		118,
		151,
		145,
		151,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		135,
		132,
		108,
		92,
		96,
		89,
		84,
		122,
		98,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		167,
		248,
		241,
		218,
		226,
		257,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		108,
		105,
		110,
		99,
		96,
		108,
		107,
		118,
		111,
		117,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		181,
		224,
		212,
		215,
		239,
		253,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		107,
		157,
		113,
		108,
		110,
		112,
		116,
		107,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		202,
		204,
		206,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		125,
		129,
		121,
		124,
		135,
		122,
		120,
		119,
		135,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		227,
		183,
		186,
		197,
		208,
		223,
		227,
		-1,
		167,
		206,
		221,
		-1,
		192,
		-1,
		-1,
		-1,
		139,
		134,
		126,
		142,
		134,
		134,
		114,
		118,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		182,
		173,
		200,
		226,
		217,
		212,
		199,
		-1,
		-1,
		162,
		144,
		-1,
		-1,
		141,
		135,
		118,
		120,
		122,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		201,
		196,
		200,
		216,
		241,
		-1,
		202,
		-1,
		-1,
		183,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		130,
		141,
		151,
		139,
		140,
		130,
		140,
		153,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		170,
		176,
		183,
		200,
		230,
		-1,
		-1,
		218,
		198,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		155,
		159,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		208,
		204,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		147,
		147,
		146,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		243,
		-1,
		195,
		171,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		225,
		211,
		204,
		192,
		190,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		183,
		186,
		-1,
		-1,
		208,
		217,
		-1,
		216,
		205,
		190,
		182,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		190,
		191,
		196,
		-1,
		200,
		-1,
		218,
		-1,
		185,
		191,
		179,
		-1,
		-1,
		-1,
		178,
		141,
		158,
		172,
		173,
		171,
		162,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		218,
		192,
		225,
		216,
		199,
		179,
		171,
		190,
		-1,
		160,
		-1,
		135,
		138,
		163,
		171,
		184,
		178,
		151,
		166,
		156,
		147,
		156,
		224,
		-1,
		194,
		227,
		191,
		185,
		161,
		165,
		181,
		-1,
		157,
		139,
		-1,
		167,
		157,
		200,
		180,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		196,
		195,
		187,
		181,
		181,
		166,
		157,
		-1,
		169,
		151,
		130,
		147,
		147,
		138,
		146,
		190,
		186,
		173,
		173,
		165,
		-1,
		297,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		190,
		185,
		158,
		146,
		152,
		148,
		134,
		140,
		142,
		150,
		148,
		145,
		157,
		153,
		173,
		166,
		201,
		-1,
		292,
		-1,
		226,
		-1,
		-1,
		208,
		188,
		180,
		169,
		158,
		156,
		147,
		138,
		160,
		176,
		160,
		158,
		163,
		168,
		-1,
		281,
		280,
		-1,
		227,
		219,
		205,
		-1,
		198,
		-1,
		204,
		165,
		-1,
		167,
		147,
		-1,
		169,
		165,
		-1,
		-1,
		268,
		243,
		-1,
		-1,
		-1,
		228,
		208,
		199,
		183,
		-1,
		158,
		158,
		-1,
		-1,
		-1,
		253,
		252,
		-1,
		221,
		224,
		-1,
		214,
		205,
		213,
		160,
		164,
		-1,
		-1,
		-1,
		262,
		243,
		237,
		236,
		234,
		229,
		226,
		212,
		196,
		174,
		163,
		184,
		-1,
		-1,
		-1,
		234,
		226,
		219,
		-1,
		-1,
		221,
		204,
		185,
		183,
		-1,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		211,
		-1,
		-1,
		217,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		245,
		-1,
		-1,
		-1,
		207,
		203,
		204,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		291,
		255,
		-1,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		270,
		268,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		197,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		232,
		-1,
		232,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		245,
		237,
		245,
		-1,
		217,
		219,
		-1,
		267,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		222,
		229,
		251,
		254,
		290,
		-1,
		241
	],
	[
		-1,
		179,
		168,
		179,
		187,
		160,
		167,
		-1,
		188,
		190,
		156,
		150,
		189,
		160,
		166,
		177,
		-1,
		-1,
		-1,
		179,
		178,
		148,
		146,
		155,
		160,
		167,
		-1,
		171,
		-1,
		200,
		179,
		190,
		195,
		141,
		138,
		158,
		177,
		164,
		156,
		215,
		171,
		142,
		136,
		154,
		149,
		158,
		150,
		-1,
		142,
		132,
		154,
		138,
		149,
		141,
		-1,
		-1,
		136,
		137,
		143,
		134,
		140,
		136,
		-1,
		146,
		130,
		-1,
		-1,
		126,
		132,
		116,
		119,
		127,
		125,
		138,
		130,
		125,
		-1,
		-1,
		122,
		118,
		125,
		112,
		108,
		125,
		138,
		120,
		134,
		133,
		-1,
		115,
		133,
		142,
		119,
		117,
		101,
		99,
		117,
		119,
		125,
		128,
		-1,
		124,
		125,
		120,
		128,
		133,
		117,
		104,
		104,
		114,
		107,
		126,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		107,
		124,
		116,
		106,
		121,
		114,
		107,
		104,
		102,
		99,
		115,
		116,
		126,
		-1,
		-1,
		217,
		186,
		215,
		173,
		154,
		-1,
		120,
		100,
		106,
		110,
		104,
		97,
		111,
		107,
		-1,
		93,
		92,
		123,
		109,
		120,
		177,
		-1,
		-1,
		175,
		167,
		150,
		153,
		130,
		126,
		115,
		114,
		106,
		92,
		88,
		94,
		97,
		97,
		103,
		87,
		97,
		101,
		104,
		127,
		-1,
		-1,
		164,
		-1,
		-1,
		174,
		157,
		-1,
		140,
		147,
		136,
		142,
		128,
		149,
		125,
		116,
		108,
		102,
		90,
		92,
		89,
		102,
		90,
		84,
		109,
		113,
		99,
		120,
		115,
		-1,
		163,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		136,
		142,
		166,
		165,
		-1,
		137,
		125,
		126,
		111,
		108,
		95,
		83,
		96,
		81,
		88,
		87,
		91,
		91,
		121,
		96,
		118,
		115,
		134,
		139,
		133,
		142,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		170,
		-1,
		173,
		174,
		149,
		122,
		125,
		112,
		103,
		90,
		79,
		90,
		79,
		76,
		84,
		85,
		100,
		91,
		90,
		108,
		118,
		126,
		130,
		136,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		190,
		174,
		166,
		151,
		151,
		-1,
		121,
		118,
		108,
		86,
		71,
		88,
		80,
		78,
		83,
		80,
		94,
		85,
		103,
		110,
		108,
		112,
		132,
		144,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		123,
		136,
		-1,
		92,
		88,
		70,
		71,
		66,
		81,
		79,
		76,
		73,
		91,
		94,
		101,
		105,
		121,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		106,
		103,
		91,
		78,
		63,
		64,
		72,
		77,
		56,
		75,
		72,
		92,
		118,
		96,
		108,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		102,
		81,
		72,
		61,
		59,
		65,
		57,
		75,
		70,
		68,
		87,
		99,
		90,
		110,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		115,
		98,
		79,
		68,
		60,
		49,
		53,
		61,
		65,
		66,
		75,
		81,
		105,
		112,
		118,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		86,
		73,
		68,
		65,
		55,
		44,
		57,
		67,
		73,
		68,
		75,
		110,
		110,
		102,
		122,
		125,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		89,
		75,
		71,
		60,
		64,
		53,
		56,
		40,
		59,
		61,
		60,
		96,
		-1,
		110,
		104,
		112,
		102,
		90,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		63,
		55,
		49,
		39,
		27,
		34,
		47,
		52,
		65,
		63,
		93,
		97,
		103,
		92,
		88,
		85,
		99,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		80,
		78,
		77,
		61,
		55,
		35,
		32,
		20,
		41,
		44,
		60,
		70,
		88,
		98,
		90,
		84,
		83,
		95,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		90,
		75,
		65,
		66,
		36,
		29,
		9,
		19,
		48,
		55,
		78,
		72,
		94,
		94,
		78,
		79,
		88,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		89,
		87,
		55,
		30,
		23,
		0,
		23,
		33,
		60,
		49,
		55,
		66,
		88,
		74,
		72,
		91,
		107,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		54,
		38,
		43,
		-1,
		58,
		-1,
		50,
		63,
		63,
		60,
		60,
		71,
		69,
		80,
		97,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		70,
		50,
		48,
		43,
		57,
		65,
		43,
		70,
		66,
		63,
		63,
		76,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		91,
		79,
		69,
		59,
		89,
		77,
		56,
		61,
		70,
		73,
		71,
		72,
		77,
		98,
		99,
		112,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		80,
		-1,
		-1,
		71,
		69,
		69,
		70,
		74,
		86,
		93,
		87,
		71,
		86,
		98,
		106,
		111,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		124,
		119,
		123,
		74,
		-1,
		75,
		76,
		78,
		84,
		91,
		89,
		84,
		78,
		81,
		99,
		116,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		123,
		137,
		112,
		105,
		109,
		-1,
		84,
		84,
		80,
		96,
		102,
		99,
		90,
		82,
		87,
		84,
		97,
		111,
		115,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		141,
		156,
		151,
		128,
		101,
		96,
		89,
		83,
		88,
		104,
		110,
		121,
		89,
		85,
		86,
		90,
		89,
		106,
		116,
		-1,
		-1,
		155,
		172,
		167,
		149,
		153,
		178,
		-1,
		-1,
		105,
		96,
		87,
		90,
		98,
		101,
		95,
		92,
		97,
		102,
		90,
		99,
		117,
		121,
		-1,
		-1,
		-1,
		175,
		-1,
		190,
		-1,
		-1,
		168,
		176,
		123,
		105,
		101,
		99,
		92,
		101,
		96,
		100,
		110,
		120,
		112,
		92,
		105,
		127,
		117,
		153,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		194,
		179,
		181,
		187,
		188,
		180,
		138,
		135,
		-1,
		105,
		130,
		102,
		109,
		101,
		114,
		118,
		116,
		95,
		102,
		118,
		117,
		112,
		145,
		139,
		145,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		187,
		183,
		173,
		163,
		166,
		-1,
		-1,
		154,
		151,
		127,
		111,
		115,
		108,
		103,
		124,
		104,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		182,
		263,
		256,
		237,
		245,
		276,
		-1,
		177,
		169,
		180,
		155,
		157,
		-1,
		-1,
		127,
		124,
		129,
		118,
		115,
		127,
		126,
		120,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		196,
		239,
		231,
		234,
		258,
		272,
		-1,
		174,
		-1,
		-1,
		186,
		158,
		142,
		132,
		126,
		176,
		132,
		127,
		128,
		126,
		117,
		108,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		221,
		219,
		225,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		202,
		-1,
		169,
		-1,
		144,
		148,
		140,
		143,
		142,
		129,
		121,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		246,
		202,
		205,
		216,
		227,
		242,
		246,
		-1,
		186,
		225,
		240,
		-1,
		211,
		-1,
		-1,
		-1,
		158,
		153,
		145,
		161,
		141,
		141,
		115,
		119,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		242,
		233,
		246,
		191,
		191,
		212,
		221,
		242,
		201,
		192,
		219,
		245,
		236,
		231,
		218,
		-1,
		-1,
		181,
		163,
		-1,
		-1,
		148,
		136,
		119,
		120,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		235,
		234,
		223,
		220,
		196,
		187,
		182,
		209,
		-1,
		-1,
		204,
		220,
		215,
		219,
		235,
		260,
		-1,
		208,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		219,
		216,
		204,
		202,
		225,
		190,
		178,
		-1,
		191,
		189,
		195,
		202,
		219,
		249,
		-1,
		-1,
		224,
		204,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		151,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		228,
		242,
		231,
		227,
		226,
		234,
		183,
		176,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		214,
		210,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		144,
		148,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		262,
		-1,
		214,
		190,
		204,
		219,
		227,
		-1,
		-1,
		-1,
		231,
		217,
		210,
		198,
		196,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		202,
		205,
		-1,
		-1,
		221,
		223,
		-1,
		222,
		211,
		196,
		188,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		209,
		210,
		215,
		-1,
		206,
		-1,
		224,
		-1,
		191,
		197,
		185,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		224,
		198,
		231,
		222,
		205,
		185,
		177,
		196,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		230,
		-1,
		200,
		233,
		197,
		191,
		167,
		171,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		194,
		179,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		202,
		201,
		193,
		187,
		187,
		172,
		163,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		184,
		180,
		167,
		167,
		159,
		-1,
		303,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		196,
		191,
		164,
		152,
		158,
		154,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		160,
		195,
		-1,
		298,
		-1,
		232,
		-1,
		-1,
		214,
		194,
		186,
		175,
		164,
		162,
		153,
		144,
		166,
		182,
		166,
		164,
		167,
		168,
		-1,
		287,
		286,
		-1,
		233,
		225,
		211,
		-1,
		204,
		-1,
		210,
		171,
		-1,
		173,
		153,
		-1,
		175,
		171,
		-1,
		-1,
		274,
		249,
		-1,
		-1,
		-1,
		234,
		214,
		205,
		189,
		-1,
		164,
		164,
		-1,
		-1,
		-1,
		259,
		258,
		-1,
		227,
		230,
		-1,
		220,
		211,
		219,
		166,
		170,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		242,
		240,
		235,
		232,
		218,
		202,
		180,
		169,
		190,
		-1,
		-1,
		-1,
		240,
		232,
		225,
		-1,
		-1,
		227,
		210,
		191,
		189,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		217,
		-1,
		-1,
		223,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		251,
		-1,
		-1,
		-1,
		213,
		209,
		210,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		297,
		261,
		-1,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		233,
		217,
		-1,
		203,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		238,
		-1,
		238,
		213,
		220,
		-1,
		-1,
		-1,
		-1,
		251,
		243,
		251,
		-1,
		223,
		225,
		-1,
		273,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		228,
		235,
		257,
		260,
		296,
		-1,
		247
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		194,
		196,
		162,
		156,
		195,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		185,
		184,
		154,
		152,
		161,
		166,
		173,
		-1,
		177,
		-1,
		206,
		185,
		196,
		201,
		147,
		144,
		164,
		183,
		170,
		162,
		221,
		177,
		148,
		142,
		160,
		155,
		164,
		156,
		-1,
		148,
		138,
		160,
		144,
		155,
		147,
		-1,
		-1,
		142,
		143,
		149,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		132,
		138,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		128,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		139,
		-1,
		121,
		139,
		148,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		134,
		-1,
		130,
		131,
		126,
		134,
		139,
		123,
		110,
		110,
		120,
		113,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		113,
		130,
		122,
		112,
		127,
		120,
		113,
		110,
		108,
		105,
		121,
		122,
		132,
		-1,
		-1,
		223,
		192,
		221,
		179,
		160,
		-1,
		126,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		99,
		98,
		129,
		115,
		126,
		183,
		-1,
		-1,
		181,
		173,
		156,
		159,
		136,
		132,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		93,
		103,
		107,
		110,
		133,
		-1,
		-1,
		170,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		142,
		148,
		134,
		155,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		90,
		115,
		119,
		105,
		126,
		121,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		171,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		97,
		97,
		127,
		102,
		124,
		121,
		140,
		145,
		139,
		148,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		179,
		180,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		91,
		106,
		97,
		96,
		114,
		124,
		132,
		136,
		142,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		180,
		172,
		157,
		157,
		-1,
		127,
		124,
		114,
		92,
		77,
		94,
		86,
		84,
		89,
		86,
		100,
		91,
		109,
		116,
		114,
		118,
		138,
		150,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		85,
		82,
		79,
		97,
		100,
		107,
		111,
		127,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		112,
		109,
		97,
		84,
		69,
		70,
		78,
		83,
		62,
		81,
		78,
		98,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		65,
		71,
		63,
		81,
		76,
		74,
		93,
		105,
		96,
		109,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		121,
		104,
		85,
		74,
		66,
		55,
		59,
		67,
		71,
		72,
		81,
		87,
		111,
		97,
		103,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		92,
		79,
		74,
		71,
		61,
		50,
		63,
		73,
		71,
		73,
		73,
		116,
		116,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		95,
		81,
		77,
		66,
		70,
		59,
		62,
		46,
		65,
		65,
		66,
		90,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		69,
		61,
		55,
		45,
		33,
		40,
		53,
		57,
		61,
		58,
		78,
		82,
		88,
		77,
		73,
		70,
		84,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		86,
		84,
		83,
		67,
		61,
		42,
		32,
		15,
		46,
		39,
		55,
		55,
		73,
		83,
		75,
		69,
		68,
		80,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		96,
		81,
		74,
		75,
		48,
		36,
		15,
		3,
		25,
		40,
		63,
		57,
		79,
		79,
		63,
		64,
		73,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		95,
		93,
		64,
		50,
		46,
		27,
		0,
		10,
		39,
		34,
		40,
		51,
		73,
		59,
		57,
		76,
		92,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		67,
		51,
		56,
		-1,
		35,
		-1,
		27,
		40,
		40,
		45,
		45,
		56,
		54,
		65,
		82,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		83,
		63,
		57,
		56,
		34,
		42,
		20,
		47,
		51,
		48,
		48,
		61,
		81,
		72,
		84,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		93,
		81,
		71,
		61,
		66,
		54,
		33,
		38,
		47,
		57,
		56,
		57,
		62,
		83,
		84,
		97,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		82,
		-1,
		-1,
		65,
		58,
		46,
		47,
		51,
		63,
		70,
		72,
		56,
		71,
		83,
		91,
		96,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		167,
		112,
		101,
		96,
		100,
		64,
		-1,
		52,
		53,
		55,
		61,
		68,
		74,
		69,
		63,
		66,
		84,
		101,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		124,
		118,
		89,
		82,
		86,
		-1,
		61,
		61,
		57,
		73,
		87,
		84,
		75,
		67,
		72,
		69,
		82,
		96,
		100,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		142,
		157,
		128,
		105,
		78,
		73,
		66,
		60,
		65,
		81,
		90,
		101,
		74,
		70,
		71,
		75,
		74,
		91,
		101,
		-1,
		-1,
		161,
		176,
		168,
		150,
		154,
		155,
		-1,
		-1,
		82,
		73,
		64,
		67,
		75,
		78,
		80,
		77,
		82,
		87,
		75,
		84,
		102,
		106,
		-1,
		-1,
		-1,
		181,
		-1,
		194,
		-1,
		-1,
		169,
		153,
		100,
		82,
		78,
		76,
		69,
		78,
		73,
		78,
		95,
		98,
		97,
		77,
		90,
		112,
		102,
		138,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		115,
		112,
		-1,
		82,
		107,
		79,
		86,
		78,
		91,
		96,
		101,
		80,
		87,
		103,
		102,
		97,
		130,
		124,
		130,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		131,
		128,
		104,
		88,
		92,
		85,
		80,
		109,
		89,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		121,
		136,
		-1,
		188,
		253,
		246,
		214,
		222,
		253,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		104,
		101,
		106,
		95,
		92,
		104,
		103,
		105,
		90,
		96,
		83,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		202,
		229,
		208,
		211,
		235,
		249,
		-1,
		151,
		-1,
		-1,
		163,
		135,
		119,
		109,
		103,
		153,
		109,
		104,
		106,
		108,
		102,
		93,
		100,
		91,
		91,
		94,
		109,
		114,
		106,
		120,
		120,
		121,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		179,
		-1,
		146,
		-1,
		121,
		125,
		117,
		120,
		127,
		114,
		106,
		98,
		114,
		89,
		99,
		95,
		96,
		105,
		116,
		128,
		127,
		128,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		163,
		202,
		217,
		-1,
		188,
		-1,
		-1,
		-1,
		135,
		130,
		122,
		138,
		126,
		126,
		100,
		104,
		94,
		101,
		111,
		113,
		105,
		109,
		122,
		133,
		136,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		178,
		169,
		196,
		222,
		213,
		208,
		195,
		-1,
		-1,
		158,
		140,
		-1,
		-1,
		133,
		121,
		104,
		105,
		101,
		104,
		119,
		122,
		112,
		110,
		104,
		136,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		197,
		192,
		196,
		212,
		237,
		-1,
		193,
		-1,
		-1,
		178,
		-1,
		-1,
		163,
		126,
		115,
		106,
		112,
		109,
		120,
		130,
		118,
		119,
		109,
		119,
		132,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		209,
		189,
		-1,
		-1,
		161,
		159,
		148,
		-1,
		138,
		111,
		116,
		136,
		138,
		127,
		121,
		115,
		122,
		121,
		129,
		137,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		199,
		195,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		129,
		133,
		125,
		118,
		113,
		124,
		116,
		120,
		137,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		216,
		202,
		195,
		183,
		181,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		169,
		137,
		142,
		137,
		119,
		130,
		119,
		122,
		136,
		131,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		204,
		208,
		-1,
		207,
		196,
		181,
		173,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		126,
		151,
		140,
		148,
		143,
		123,
		129,
		132,
		121,
		125,
		137,
		-1,
		-1,
		186,
		187,
		192,
		-1,
		191,
		-1,
		209,
		-1,
		176,
		182,
		170,
		-1,
		-1,
		-1,
		164,
		127,
		148,
		158,
		152,
		150,
		141,
		127,
		134,
		132,
		128,
		139,
		-1,
		-1,
		-1,
		209,
		183,
		216,
		207,
		190,
		170,
		162,
		181,
		-1,
		151,
		-1,
		126,
		128,
		154,
		157,
		163,
		157,
		130,
		145,
		135,
		126,
		135,
		215,
		-1,
		185,
		218,
		182,
		176,
		152,
		156,
		172,
		-1,
		148,
		130,
		-1,
		158,
		148,
		179,
		164,
		145,
		132,
		139,
		139,
		132,
		-1,
		-1,
		-1,
		187,
		186,
		178,
		172,
		172,
		157,
		148,
		-1,
		160,
		142,
		121,
		138,
		138,
		129,
		137,
		169,
		165,
		152,
		152,
		144,
		-1,
		288,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		181,
		176,
		149,
		137,
		143,
		139,
		125,
		131,
		133,
		141,
		139,
		136,
		148,
		144,
		164,
		145,
		180,
		-1,
		283,
		-1,
		217,
		-1,
		-1,
		199,
		179,
		171,
		160,
		149,
		147,
		138,
		129,
		151,
		167,
		151,
		149,
		152,
		153,
		-1,
		272,
		271,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		195,
		156,
		-1,
		158,
		138,
		-1,
		160,
		156,
		-1,
		-1,
		259,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		190,
		174,
		-1,
		149,
		149,
		-1,
		-1,
		-1,
		244,
		243,
		-1,
		212,
		215,
		-1,
		205,
		196,
		204,
		151,
		155,
		-1,
		-1,
		-1,
		253,
		234,
		228,
		227,
		225,
		220,
		217,
		203,
		187,
		165,
		154,
		175,
		-1,
		-1,
		-1,
		225,
		217,
		210,
		-1,
		-1,
		212,
		195,
		176,
		174,
		-1,
		-1,
		-1,
		247,
		228,
		-1,
		-1,
		202,
		-1,
		-1,
		208,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		236,
		-1,
		-1,
		-1,
		198,
		194,
		195,
		-1,
		-1,
		-1,
		-1,
		258,
		259,
		282,
		246,
		-1,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		261,
		259,
		-1,
		-1,
		-1,
		218,
		202,
		-1,
		188,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		223,
		-1,
		223,
		198,
		205,
		-1,
		-1,
		-1,
		-1,
		236,
		228,
		236,
		-1,
		208,
		210,
		-1,
		258,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		213,
		220,
		242,
		245,
		281,
		-1,
		232
	],
	[
		-1,
		186,
		175,
		186,
		194,
		167,
		174,
		-1,
		194,
		197,
		163,
		157,
		196,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		186,
		185,
		154,
		152,
		161,
		166,
		173,
		-1,
		172,
		-1,
		207,
		186,
		197,
		202,
		147,
		144,
		164,
		183,
		165,
		157,
		222,
		177,
		148,
		142,
		160,
		150,
		159,
		151,
		-1,
		148,
		138,
		160,
		139,
		150,
		142,
		-1,
		-1,
		142,
		143,
		149,
		135,
		141,
		137,
		-1,
		147,
		131,
		-1,
		-1,
		132,
		133,
		117,
		120,
		128,
		126,
		139,
		131,
		126,
		-1,
		-1,
		123,
		119,
		126,
		113,
		109,
		126,
		139,
		121,
		135,
		134,
		-1,
		122,
		140,
		149,
		120,
		118,
		102,
		100,
		118,
		120,
		126,
		126,
		-1,
		131,
		132,
		127,
		135,
		140,
		118,
		105,
		105,
		115,
		108,
		127,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		114,
		131,
		123,
		113,
		128,
		121,
		108,
		105,
		103,
		100,
		116,
		114,
		124,
		-1,
		-1,
		224,
		193,
		222,
		180,
		161,
		-1,
		127,
		107,
		113,
		117,
		111,
		104,
		118,
		114,
		-1,
		94,
		93,
		121,
		107,
		118,
		184,
		-1,
		-1,
		182,
		174,
		157,
		160,
		137,
		133,
		122,
		121,
		113,
		99,
		95,
		101,
		104,
		104,
		110,
		88,
		98,
		102,
		100,
		125,
		-1,
		-1,
		160,
		-1,
		-1,
		181,
		164,
		-1,
		147,
		154,
		143,
		149,
		135,
		156,
		132,
		123,
		115,
		109,
		97,
		99,
		96,
		109,
		97,
		85,
		110,
		114,
		95,
		116,
		111,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		140,
		143,
		149,
		173,
		172,
		-1,
		144,
		132,
		133,
		118,
		115,
		102,
		90,
		103,
		88,
		95,
		94,
		89,
		87,
		117,
		92,
		114,
		111,
		130,
		135,
		129,
		138,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		177,
		-1,
		180,
		181,
		156,
		129,
		132,
		119,
		110,
		97,
		86,
		97,
		86,
		83,
		91,
		81,
		96,
		87,
		86,
		104,
		114,
		122,
		126,
		132,
		-1,
		239,
		-1,
		181,
		165,
		167,
		139,
		160,
		-1,
		197,
		181,
		173,
		158,
		158,
		-1,
		128,
		125,
		115,
		93,
		78,
		95,
		87,
		85,
		90,
		76,
		90,
		81,
		99,
		106,
		104,
		108,
		128,
		140,
		199,
		189,
		-1,
		171,
		176,
		135,
		143,
		162,
		200,
		164,
		-1,
		159,
		-1,
		130,
		143,
		-1,
		99,
		95,
		77,
		78,
		73,
		88,
		86,
		72,
		69,
		87,
		90,
		97,
		101,
		117,
		-1,
		-1,
		184,
		188,
		177,
		128,
		147,
		171,
		208,
		157,
		146,
		145,
		-1,
		136,
		113,
		110,
		98,
		85,
		70,
		71,
		79,
		84,
		63,
		71,
		68,
		88,
		114,
		92,
		104,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		154,
		125,
		149,
		191,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		109,
		88,
		79,
		68,
		66,
		72,
		64,
		81,
		66,
		64,
		83,
		95,
		86,
		99,
		-1,
		-1,
		-1,
		184,
		173,
		174,
		120,
		143,
		180,
		154,
		140,
		145,
		120,
		113,
		107,
		122,
		105,
		86,
		75,
		67,
		56,
		60,
		68,
		72,
		62,
		71,
		77,
		101,
		87,
		93,
		-1,
		-1,
		191,
		181,
		165,
		167,
		164,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		96,
		80,
		75,
		72,
		64,
		51,
		64,
		74,
		61,
		63,
		63,
		106,
		106,
		77,
		97,
		100,
		-1,
		-1,
		-1,
		184,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		82,
		78,
		68,
		72,
		64,
		63,
		47,
		65,
		55,
		56,
		80,
		-1,
		85,
		79,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		74,
		66,
		60,
		50,
		38,
		41,
		54,
		47,
		51,
		48,
		68,
		72,
		78,
		67,
		63,
		60,
		74,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		88,
		72,
		66,
		47,
		37,
		20,
		36,
		29,
		45,
		45,
		63,
		73,
		65,
		59,
		58,
		70,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		86,
		79,
		80,
		53,
		41,
		20,
		8,
		15,
		30,
		53,
		47,
		69,
		69,
		53,
		54,
		63,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		100,
		98,
		69,
		55,
		51,
		32,
		5,
		0,
		29,
		24,
		30,
		41,
		63,
		49,
		47,
		66,
		82,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		67,
		56,
		61,
		-1,
		25,
		-1,
		17,
		30,
		30,
		35,
		35,
		46,
		44,
		55,
		72,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		83,
		63,
		55,
		61,
		24,
		32,
		10,
		37,
		41,
		38,
		38,
		51,
		71,
		62,
		74,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		83,
		71,
		61,
		51,
		56,
		44,
		23,
		28,
		37,
		47,
		46,
		47,
		52,
		73,
		74,
		87,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		145,
		119,
		72,
		-1,
		-1,
		55,
		48,
		36,
		37,
		41,
		53,
		60,
		62,
		46,
		61,
		73,
		81,
		86,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		157,
		102,
		91,
		86,
		90,
		54,
		-1,
		42,
		43,
		45,
		51,
		58,
		64,
		59,
		53,
		56,
		74,
		91,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		79,
		72,
		76,
		-1,
		51,
		51,
		47,
		63,
		77,
		74,
		65,
		57,
		62,
		59,
		72,
		86,
		90,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		132,
		147,
		118,
		95,
		68,
		63,
		56,
		50,
		55,
		71,
		80,
		91,
		64,
		60,
		61,
		65,
		64,
		81,
		91,
		-1,
		-1,
		162,
		166,
		158,
		140,
		144,
		145,
		-1,
		-1,
		72,
		63,
		54,
		57,
		65,
		68,
		70,
		67,
		72,
		77,
		65,
		74,
		92,
		96,
		-1,
		-1,
		-1,
		182,
		-1,
		184,
		-1,
		-1,
		159,
		143,
		90,
		72,
		68,
		66,
		59,
		68,
		63,
		68,
		85,
		88,
		87,
		67,
		80,
		102,
		92,
		128,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		161,
		153,
		148,
		154,
		156,
		147,
		105,
		102,
		-1,
		72,
		97,
		69,
		76,
		68,
		81,
		86,
		91,
		70,
		77,
		93,
		92,
		87,
		120,
		114,
		120,
		-1,
		-1,
		252,
		241,
		230,
		236,
		-1,
		154,
		150,
		140,
		130,
		133,
		-1,
		-1,
		121,
		118,
		94,
		78,
		82,
		75,
		70,
		99,
		79,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		189,
		243,
		236,
		204,
		212,
		243,
		-1,
		144,
		136,
		147,
		122,
		124,
		-1,
		-1,
		94,
		91,
		96,
		85,
		82,
		94,
		93,
		95,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		199,
		219,
		198,
		201,
		225,
		239,
		-1,
		141,
		-1,
		-1,
		153,
		125,
		109,
		99,
		93,
		143,
		99,
		94,
		96,
		98,
		92,
		83,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		188,
		199,
		192,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		169,
		-1,
		136,
		-1,
		111,
		115,
		107,
		110,
		117,
		104,
		96,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		213,
		169,
		172,
		183,
		194,
		209,
		213,
		-1,
		153,
		192,
		207,
		-1,
		178,
		-1,
		-1,
		-1,
		125,
		120,
		112,
		128,
		116,
		116,
		90,
		94,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		209,
		200,
		213,
		158,
		158,
		179,
		188,
		209,
		168,
		159,
		186,
		212,
		203,
		198,
		185,
		-1,
		-1,
		148,
		130,
		-1,
		-1,
		123,
		111,
		94,
		95,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		202,
		201,
		190,
		187,
		163,
		154,
		149,
		176,
		-1,
		-1,
		171,
		187,
		182,
		186,
		202,
		227,
		-1,
		183,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		186,
		183,
		171,
		169,
		192,
		157,
		145,
		-1,
		158,
		156,
		162,
		169,
		186,
		216,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		195,
		209,
		198,
		194,
		193,
		201,
		150,
		143,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		119,
		123,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		229,
		-1,
		181,
		157,
		171,
		186,
		194,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		169,
		172,
		-1,
		-1,
		194,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		176,
		177,
		182,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		154,
		117,
		138,
		148,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		118,
		144,
		147,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		169,
		154,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		159,
		155,
		142,
		142,
		134,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		135,
		170,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		142,
		143,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		181,
		184,
		150,
		144,
		183,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		173,
		172,
		141,
		139,
		148,
		153,
		160,
		-1,
		159,
		-1,
		194,
		173,
		184,
		189,
		134,
		131,
		151,
		170,
		152,
		144,
		209,
		164,
		135,
		129,
		147,
		137,
		146,
		138,
		-1,
		135,
		125,
		147,
		126,
		137,
		129,
		-1,
		-1,
		129,
		130,
		136,
		122,
		128,
		124,
		-1,
		134,
		118,
		-1,
		-1,
		119,
		120,
		104,
		107,
		115,
		113,
		126,
		118,
		113,
		-1,
		-1,
		110,
		106,
		113,
		100,
		96,
		113,
		126,
		108,
		122,
		121,
		-1,
		109,
		127,
		136,
		107,
		105,
		89,
		87,
		105,
		107,
		113,
		113,
		-1,
		118,
		119,
		114,
		122,
		127,
		105,
		92,
		92,
		102,
		95,
		114,
		102,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		101,
		118,
		110,
		100,
		115,
		108,
		95,
		92,
		90,
		87,
		103,
		101,
		111,
		-1,
		-1,
		211,
		180,
		209,
		167,
		148,
		-1,
		114,
		94,
		100,
		104,
		98,
		91,
		105,
		101,
		-1,
		81,
		80,
		108,
		94,
		105,
		171,
		-1,
		-1,
		169,
		161,
		144,
		147,
		124,
		120,
		109,
		108,
		100,
		86,
		82,
		88,
		91,
		91,
		97,
		75,
		85,
		89,
		87,
		112,
		-1,
		-1,
		147,
		-1,
		-1,
		168,
		151,
		-1,
		134,
		141,
		130,
		136,
		122,
		143,
		119,
		110,
		102,
		96,
		84,
		86,
		83,
		96,
		84,
		72,
		97,
		101,
		82,
		103,
		98,
		-1,
		146,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		136,
		160,
		159,
		-1,
		131,
		119,
		120,
		105,
		102,
		89,
		77,
		90,
		75,
		82,
		81,
		76,
		74,
		104,
		79,
		101,
		98,
		117,
		122,
		116,
		125,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		164,
		-1,
		167,
		168,
		143,
		116,
		119,
		106,
		97,
		84,
		73,
		84,
		73,
		70,
		78,
		68,
		83,
		74,
		73,
		91,
		101,
		109,
		113,
		119,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		184,
		168,
		160,
		145,
		145,
		-1,
		115,
		112,
		102,
		80,
		65,
		82,
		74,
		72,
		77,
		63,
		77,
		68,
		86,
		93,
		91,
		95,
		115,
		127,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		117,
		130,
		-1,
		86,
		82,
		64,
		65,
		60,
		75,
		73,
		59,
		56,
		74,
		77,
		84,
		88,
		104,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		100,
		97,
		85,
		72,
		57,
		58,
		66,
		71,
		50,
		58,
		55,
		75,
		101,
		79,
		91,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		96,
		75,
		66,
		55,
		53,
		59,
		51,
		68,
		53,
		51,
		70,
		82,
		73,
		86,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		109,
		92,
		73,
		62,
		54,
		43,
		47,
		55,
		59,
		49,
		58,
		64,
		88,
		74,
		80,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		83,
		67,
		62,
		59,
		51,
		38,
		51,
		61,
		48,
		50,
		50,
		93,
		93,
		64,
		84,
		87,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		69,
		65,
		55,
		59,
		53,
		50,
		34,
		52,
		42,
		43,
		67,
		-1,
		72,
		66,
		74,
		64,
		52,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		67,
		62,
		61,
		51,
		39,
		28,
		41,
		34,
		38,
		35,
		55,
		59,
		65,
		54,
		50,
		47,
		61,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		89,
		73,
		67,
		51,
		42,
		46,
		23,
		16,
		32,
		32,
		50,
		60,
		52,
		46,
		45,
		57,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		79,
		89,
		90,
		63,
		51,
		46,
		34,
		22,
		14,
		40,
		34,
		56,
		56,
		40,
		41,
		50,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		93,
		91,
		79,
		65,
		71,
		58,
		31,
		26,
		0,
		11,
		17,
		28,
		50,
		36,
		34,
		53,
		69,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		82,
		66,
		71,
		-1,
		51,
		-1,
		23,
		30,
		30,
		22,
		22,
		33,
		31,
		42,
		59,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		98,
		78,
		72,
		71,
		46,
		54,
		32,
		35,
		28,
		25,
		25,
		38,
		58,
		49,
		61,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		105,
		93,
		83,
		73,
		78,
		66,
		45,
		47,
		33,
		35,
		33,
		34,
		39,
		60,
		61,
		74,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		94,
		-1,
		-1,
		77,
		70,
		58,
		50,
		37,
		57,
		60,
		49,
		33,
		48,
		60,
		68,
		73,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		160,
		106,
		95,
		90,
		94,
		76,
		-1,
		64,
		61,
		41,
		55,
		62,
		51,
		46,
		40,
		43,
		61,
		78,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		117,
		112,
		83,
		76,
		80,
		-1,
		68,
		57,
		43,
		60,
		64,
		61,
		52,
		44,
		49,
		46,
		59,
		73,
		77,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		135,
		150,
		122,
		99,
		72,
		67,
		60,
		54,
		51,
		67,
		72,
		83,
		51,
		47,
		48,
		52,
		51,
		68,
		78,
		-1,
		-1,
		149,
		166,
		161,
		143,
		147,
		149,
		-1,
		-1,
		76,
		67,
		58,
		61,
		61,
		64,
		57,
		54,
		59,
		64,
		52,
		61,
		79,
		83,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		162,
		147,
		94,
		76,
		72,
		70,
		63,
		72,
		67,
		62,
		72,
		82,
		74,
		54,
		67,
		89,
		79,
		115,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		165,
		157,
		152,
		158,
		160,
		151,
		109,
		106,
		-1,
		76,
		101,
		73,
		80,
		72,
		80,
		80,
		78,
		57,
		64,
		80,
		79,
		74,
		107,
		101,
		107,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		158,
		154,
		144,
		134,
		137,
		-1,
		-1,
		125,
		122,
		98,
		82,
		86,
		79,
		74,
		86,
		66,
		53,
		57,
		61,
		67,
		72,
		77,
		83,
		98,
		113,
		-1,
		176,
		247,
		240,
		208,
		216,
		247,
		-1,
		148,
		140,
		151,
		126,
		128,
		-1,
		-1,
		98,
		95,
		100,
		89,
		86,
		96,
		91,
		82,
		67,
		73,
		60,
		59,
		77,
		81,
		90,
		97,
		87,
		100,
		104,
		-1,
		190,
		223,
		202,
		205,
		229,
		243,
		-1,
		145,
		-1,
		-1,
		157,
		129,
		113,
		103,
		97,
		147,
		103,
		98,
		90,
		88,
		79,
		70,
		77,
		68,
		68,
		71,
		86,
		91,
		83,
		97,
		97,
		98,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		173,
		-1,
		140,
		-1,
		115,
		119,
		111,
		114,
		104,
		91,
		83,
		75,
		91,
		66,
		76,
		72,
		73,
		82,
		93,
		105,
		104,
		105,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		157,
		196,
		203,
		-1,
		182,
		-1,
		-1,
		-1,
		129,
		124,
		116,
		124,
		103,
		103,
		77,
		81,
		71,
		78,
		88,
		90,
		82,
		86,
		99,
		110,
		113,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		172,
		163,
		190,
		210,
		199,
		194,
		181,
		-1,
		-1,
		152,
		134,
		-1,
		-1,
		110,
		98,
		81,
		82,
		78,
		81,
		96,
		99,
		89,
		87,
		81,
		113,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		191,
		186,
		190,
		206,
		231,
		-1,
		170,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		103,
		92,
		83,
		89,
		86,
		97,
		107,
		95,
		96,
		86,
		96,
		109,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		186,
		166,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		88,
		93,
		113,
		115,
		104,
		98,
		92,
		99,
		98,
		106,
		114,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		172,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		102,
		106,
		110,
		102,
		95,
		90,
		101,
		93,
		97,
		114,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		146,
		114,
		119,
		114,
		96,
		107,
		96,
		99,
		113,
		108,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		183,
		185,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		103,
		128,
		117,
		125,
		120,
		100,
		106,
		109,
		98,
		102,
		114,
		-1,
		-1,
		180,
		181,
		186,
		-1,
		168,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		141,
		104,
		125,
		135,
		129,
		127,
		118,
		104,
		111,
		109,
		105,
		116,
		-1,
		-1,
		-1,
		186,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		103,
		105,
		131,
		134,
		140,
		134,
		107,
		122,
		112,
		103,
		112,
		192,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		156,
		141,
		122,
		109,
		116,
		116,
		109,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		146,
		142,
		129,
		129,
		121,
		-1,
		265,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		125,
		121,
		141,
		122,
		157,
		-1,
		260,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		128,
		126,
		129,
		130,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		137,
		133,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		170,
		173,
		139,
		133,
		172,
		142,
		148,
		159,
		-1,
		-1,
		-1,
		162,
		161,
		130,
		128,
		137,
		142,
		149,
		-1,
		148,
		-1,
		183,
		162,
		173,
		178,
		123,
		120,
		140,
		159,
		141,
		133,
		198,
		153,
		124,
		118,
		136,
		126,
		135,
		127,
		-1,
		124,
		114,
		136,
		115,
		126,
		118,
		-1,
		-1,
		118,
		119,
		125,
		111,
		117,
		113,
		-1,
		123,
		107,
		-1,
		-1,
		108,
		109,
		93,
		96,
		104,
		102,
		115,
		107,
		102,
		-1,
		-1,
		99,
		95,
		102,
		89,
		85,
		102,
		115,
		97,
		111,
		110,
		-1,
		98,
		116,
		125,
		96,
		94,
		78,
		76,
		94,
		96,
		102,
		102,
		-1,
		107,
		108,
		103,
		111,
		116,
		94,
		81,
		81,
		91,
		84,
		103,
		91,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		107,
		90,
		107,
		99,
		89,
		104,
		97,
		84,
		81,
		79,
		76,
		92,
		90,
		100,
		-1,
		-1,
		200,
		169,
		198,
		156,
		137,
		-1,
		103,
		83,
		89,
		93,
		87,
		80,
		94,
		90,
		-1,
		70,
		69,
		97,
		83,
		94,
		160,
		-1,
		-1,
		158,
		150,
		133,
		136,
		113,
		109,
		98,
		97,
		89,
		75,
		71,
		77,
		80,
		80,
		86,
		64,
		74,
		78,
		76,
		101,
		-1,
		-1,
		136,
		-1,
		-1,
		157,
		140,
		-1,
		123,
		130,
		119,
		125,
		111,
		132,
		108,
		99,
		91,
		85,
		73,
		75,
		72,
		85,
		73,
		61,
		86,
		90,
		71,
		92,
		87,
		-1,
		135,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		116,
		119,
		125,
		149,
		148,
		-1,
		120,
		108,
		109,
		94,
		91,
		78,
		66,
		79,
		64,
		71,
		70,
		65,
		63,
		93,
		68,
		90,
		87,
		106,
		111,
		105,
		114,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		153,
		-1,
		156,
		157,
		132,
		105,
		108,
		95,
		86,
		73,
		62,
		73,
		62,
		59,
		67,
		57,
		72,
		63,
		62,
		80,
		90,
		98,
		102,
		108,
		-1,
		215,
		-1,
		157,
		141,
		143,
		115,
		136,
		-1,
		173,
		157,
		149,
		134,
		134,
		-1,
		104,
		101,
		91,
		69,
		54,
		71,
		63,
		61,
		66,
		52,
		66,
		57,
		75,
		82,
		80,
		84,
		104,
		116,
		175,
		165,
		-1,
		147,
		152,
		111,
		119,
		138,
		176,
		140,
		-1,
		135,
		-1,
		106,
		119,
		-1,
		75,
		71,
		53,
		54,
		49,
		64,
		62,
		48,
		45,
		63,
		66,
		73,
		77,
		93,
		-1,
		-1,
		160,
		164,
		153,
		104,
		123,
		147,
		184,
		133,
		122,
		121,
		-1,
		112,
		89,
		86,
		74,
		61,
		46,
		47,
		55,
		60,
		39,
		47,
		44,
		64,
		90,
		68,
		80,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		130,
		101,
		125,
		167,
		151,
		144,
		132,
		97,
		97,
		91,
		-1,
		85,
		64,
		55,
		44,
		42,
		48,
		40,
		57,
		42,
		40,
		59,
		71,
		62,
		75,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		96,
		119,
		156,
		130,
		116,
		121,
		96,
		89,
		83,
		98,
		81,
		62,
		51,
		43,
		32,
		36,
		44,
		48,
		38,
		47,
		53,
		77,
		63,
		69,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		110,
		117,
		149,
		121,
		134,
		-1,
		88,
		-1,
		77,
		72,
		56,
		51,
		48,
		40,
		27,
		40,
		50,
		37,
		39,
		39,
		82,
		82,
		53,
		73,
		76,
		-1,
		-1,
		-1,
		160,
		155,
		130,
		107,
		91,
		127,
		-1,
		104,
		105,
		-1,
		82,
		76,
		73,
		58,
		54,
		44,
		48,
		42,
		39,
		23,
		41,
		31,
		32,
		56,
		-1,
		61,
		55,
		63,
		53,
		41,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		86,
		138,
		-1,
		-1,
		89,
		82,
		-1,
		69,
		51,
		56,
		51,
		50,
		40,
		28,
		17,
		30,
		23,
		27,
		24,
		44,
		48,
		54,
		43,
		39,
		36,
		50,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		106,
		-1,
		98,
		90,
		80,
		74,
		68,
		64,
		62,
		78,
		62,
		56,
		40,
		31,
		39,
		12,
		5,
		21,
		21,
		39,
		49,
		41,
		35,
		34,
		46,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		119,
		-1,
		83,
		97,
		113,
		-1,
		106,
		85,
		100,
		78,
		74,
		68,
		78,
		79,
		52,
		40,
		38,
		29,
		17,
		6,
		29,
		23,
		45,
		45,
		29,
		30,
		39,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		80,
		68,
		100,
		-1,
		-1,
		142,
		-1,
		76,
		93,
		82,
		80,
		68,
		54,
		60,
		49,
		26,
		21,
		11,
		0,
		6,
		17,
		39,
		25,
		23,
		42,
		58,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		117,
		-1,
		120,
		110,
		94,
		79,
		112,
		-1,
		71,
		55,
		60,
		-1,
		46,
		-1,
		19,
		21,
		19,
		11,
		11,
		22,
		20,
		31,
		48,
		-1,
		129,
		114,
		107,
		97,
		111,
		82,
		-1,
		137,
		-1,
		-1,
		107,
		101,
		101,
		85,
		88,
		87,
		67,
		61,
		60,
		41,
		49,
		27,
		24,
		17,
		14,
		14,
		27,
		47,
		38,
		50,
		-1,
		-1,
		-1,
		134,
		120,
		124,
		84,
		103,
		-1,
		-1,
		169,
		124,
		110,
		-1,
		94,
		100,
		88,
		78,
		68,
		73,
		61,
		40,
		36,
		22,
		24,
		22,
		23,
		28,
		49,
		50,
		63,
		-1,
		-1,
		117,
		122,
		110,
		96,
		115,
		-1,
		-1,
		-1,
		116,
		132,
		124,
		95,
		89,
		-1,
		-1,
		72,
		65,
		53,
		39,
		26,
		46,
		49,
		38,
		22,
		37,
		49,
		57,
		62,
		-1,
		120,
		107,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		-1,
		-1,
		149,
		95,
		84,
		79,
		83,
		71,
		-1,
		55,
		50,
		30,
		44,
		51,
		40,
		35,
		29,
		32,
		50,
		67,
		-1,
		-1,
		132,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		106,
		101,
		72,
		65,
		69,
		-1,
		57,
		46,
		32,
		49,
		53,
		50,
		41,
		33,
		38,
		35,
		48,
		62,
		66,
		155,
		-1,
		138,
		-1,
		-1,
		-1,
		124,
		139,
		111,
		88,
		61,
		56,
		49,
		43,
		40,
		56,
		61,
		72,
		40,
		36,
		37,
		41,
		40,
		57,
		67,
		-1,
		-1,
		138,
		155,
		150,
		132,
		136,
		138,
		-1,
		-1,
		65,
		56,
		47,
		50,
		50,
		53,
		46,
		43,
		48,
		53,
		41,
		50,
		68,
		72,
		-1,
		-1,
		-1,
		158,
		-1,
		173,
		-1,
		-1,
		151,
		136,
		83,
		65,
		61,
		59,
		52,
		61,
		56,
		51,
		61,
		71,
		63,
		43,
		56,
		78,
		68,
		104,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		98,
		95,
		-1,
		65,
		90,
		62,
		69,
		61,
		69,
		69,
		67,
		46,
		53,
		69,
		68,
		63,
		96,
		90,
		96,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		114,
		111,
		87,
		71,
		75,
		68,
		63,
		75,
		55,
		42,
		46,
		50,
		56,
		61,
		66,
		72,
		87,
		102,
		-1,
		165,
		236,
		229,
		197,
		205,
		236,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		87,
		84,
		89,
		78,
		75,
		85,
		80,
		71,
		56,
		62,
		49,
		48,
		66,
		70,
		79,
		86,
		76,
		89,
		93,
		-1,
		179,
		212,
		191,
		194,
		218,
		232,
		-1,
		134,
		-1,
		-1,
		146,
		118,
		102,
		92,
		86,
		136,
		92,
		87,
		79,
		77,
		68,
		59,
		66,
		57,
		57,
		60,
		75,
		80,
		72,
		86,
		86,
		87,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		162,
		-1,
		129,
		-1,
		104,
		108,
		100,
		103,
		93,
		80,
		72,
		64,
		80,
		55,
		65,
		61,
		62,
		71,
		82,
		94,
		93,
		94,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		146,
		185,
		192,
		-1,
		171,
		-1,
		-1,
		-1,
		118,
		113,
		105,
		113,
		92,
		92,
		66,
		70,
		60,
		67,
		77,
		79,
		71,
		75,
		88,
		99,
		102,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		161,
		152,
		179,
		199,
		188,
		183,
		170,
		-1,
		-1,
		141,
		123,
		-1,
		-1,
		99,
		87,
		70,
		71,
		67,
		70,
		85,
		88,
		78,
		76,
		70,
		102,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		180,
		175,
		179,
		195,
		220,
		-1,
		159,
		-1,
		-1,
		144,
		-1,
		-1,
		129,
		92,
		81,
		72,
		78,
		75,
		86,
		96,
		84,
		85,
		75,
		85,
		98,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		151,
		149,
		155,
		162,
		179,
		209,
		-1,
		-1,
		175,
		155,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		77,
		82,
		102,
		104,
		93,
		87,
		81,
		88,
		87,
		95,
		103,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		165,
		161,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		95,
		99,
		91,
		84,
		79,
		90,
		82,
		86,
		103,
		-1,
		222,
		-1,
		174,
		150,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		182,
		168,
		161,
		149,
		147,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		135,
		103,
		108,
		103,
		85,
		96,
		85,
		88,
		102,
		97,
		-1,
		-1,
		162,
		165,
		-1,
		-1,
		172,
		174,
		-1,
		173,
		162,
		147,
		139,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		117,
		106,
		114,
		109,
		89,
		95,
		98,
		87,
		91,
		103,
		-1,
		-1,
		169,
		170,
		175,
		-1,
		157,
		-1,
		175,
		-1,
		142,
		148,
		136,
		-1,
		-1,
		-1,
		130,
		93,
		114,
		124,
		118,
		116,
		107,
		93,
		100,
		98,
		94,
		105,
		-1,
		-1,
		-1,
		175,
		149,
		182,
		173,
		156,
		136,
		128,
		147,
		-1,
		117,
		-1,
		92,
		94,
		120,
		123,
		129,
		123,
		96,
		111,
		101,
		92,
		101,
		181,
		-1,
		151,
		184,
		148,
		142,
		118,
		122,
		138,
		-1,
		114,
		96,
		-1,
		124,
		114,
		145,
		130,
		111,
		98,
		105,
		105,
		98,
		-1,
		-1,
		-1,
		153,
		152,
		144,
		138,
		138,
		123,
		114,
		-1,
		126,
		108,
		87,
		104,
		104,
		95,
		103,
		135,
		131,
		118,
		118,
		110,
		-1,
		254,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		147,
		142,
		115,
		103,
		109,
		105,
		91,
		97,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		111,
		146,
		-1,
		249,
		-1,
		183,
		-1,
		-1,
		165,
		145,
		137,
		126,
		115,
		113,
		104,
		95,
		117,
		133,
		117,
		115,
		118,
		119,
		-1,
		238,
		237,
		-1,
		184,
		176,
		162,
		-1,
		155,
		-1,
		161,
		122,
		-1,
		124,
		104,
		-1,
		126,
		122,
		-1,
		-1,
		225,
		200,
		-1,
		-1,
		-1,
		185,
		165,
		156,
		140,
		-1,
		115,
		115,
		-1,
		-1,
		-1,
		210,
		209,
		-1,
		178,
		181,
		-1,
		171,
		162,
		170,
		117,
		121,
		-1,
		-1,
		-1,
		219,
		200,
		194,
		193,
		191,
		186,
		183,
		169,
		153,
		131,
		120,
		141,
		-1,
		-1,
		-1,
		191,
		183,
		176,
		-1,
		-1,
		178,
		161,
		142,
		140,
		-1,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		168,
		-1,
		-1,
		174,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		202,
		-1,
		-1,
		-1,
		164,
		160,
		161,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		248,
		212,
		-1,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		227,
		225,
		-1,
		-1,
		-1,
		184,
		168,
		-1,
		154,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		189,
		-1,
		189,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		202,
		194,
		202,
		-1,
		174,
		176,
		-1,
		224,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		179,
		186,
		208,
		211,
		247,
		-1,
		198
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		173,
		177,
		143,
		137,
		176,
		145,
		151,
		162,
		-1,
		-1,
		-1,
		166,
		165,
		133,
		131,
		140,
		145,
		152,
		-1,
		151,
		-1,
		187,
		166,
		177,
		182,
		126,
		123,
		143,
		162,
		144,
		136,
		202,
		156,
		127,
		121,
		139,
		129,
		138,
		130,
		-1,
		127,
		117,
		139,
		118,
		129,
		121,
		-1,
		-1,
		121,
		122,
		128,
		114,
		120,
		116,
		-1,
		126,
		110,
		-1,
		-1,
		111,
		112,
		96,
		99,
		107,
		105,
		118,
		110,
		105,
		-1,
		-1,
		102,
		98,
		105,
		92,
		88,
		105,
		118,
		100,
		114,
		113,
		-1,
		106,
		124,
		131,
		99,
		97,
		81,
		79,
		97,
		99,
		105,
		105,
		-1,
		115,
		116,
		111,
		119,
		121,
		97,
		84,
		84,
		94,
		87,
		106,
		94,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		115,
		98,
		115,
		107,
		97,
		112,
		105,
		87,
		84,
		82,
		79,
		95,
		93,
		103,
		-1,
		-1,
		208,
		177,
		206,
		164,
		145,
		-1,
		111,
		91,
		97,
		101,
		95,
		88,
		102,
		98,
		-1,
		73,
		72,
		100,
		86,
		97,
		168,
		-1,
		-1,
		166,
		158,
		141,
		144,
		121,
		117,
		106,
		105,
		97,
		83,
		79,
		85,
		88,
		88,
		94,
		67,
		77,
		81,
		79,
		104,
		-1,
		-1,
		139,
		-1,
		-1,
		165,
		148,
		-1,
		131,
		138,
		127,
		133,
		119,
		140,
		116,
		107,
		99,
		93,
		81,
		83,
		80,
		93,
		81,
		64,
		89,
		93,
		74,
		95,
		90,
		-1,
		138,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		124,
		127,
		133,
		157,
		156,
		-1,
		128,
		116,
		117,
		102,
		99,
		86,
		74,
		87,
		72,
		79,
		78,
		68,
		66,
		96,
		71,
		93,
		90,
		109,
		114,
		108,
		117,
		-1,
		173,
		169,
		165,
		172,
		121,
		-1,
		-1,
		161,
		-1,
		164,
		165,
		140,
		113,
		116,
		103,
		94,
		81,
		70,
		81,
		70,
		67,
		75,
		60,
		75,
		66,
		65,
		83,
		93,
		101,
		105,
		111,
		-1,
		223,
		-1,
		165,
		149,
		151,
		123,
		144,
		-1,
		181,
		165,
		157,
		142,
		142,
		-1,
		112,
		109,
		99,
		77,
		62,
		79,
		71,
		69,
		73,
		55,
		69,
		60,
		78,
		85,
		83,
		87,
		107,
		119,
		183,
		173,
		-1,
		155,
		160,
		119,
		127,
		146,
		184,
		148,
		-1,
		143,
		-1,
		114,
		127,
		-1,
		83,
		79,
		61,
		62,
		57,
		72,
		66,
		51,
		48,
		66,
		69,
		76,
		80,
		96,
		-1,
		-1,
		168,
		172,
		161,
		112,
		131,
		155,
		192,
		141,
		130,
		129,
		-1,
		120,
		97,
		94,
		82,
		69,
		54,
		55,
		63,
		68,
		47,
		50,
		47,
		67,
		93,
		71,
		83,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		138,
		109,
		133,
		175,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		93,
		72,
		63,
		52,
		50,
		56,
		48,
		65,
		45,
		43,
		62,
		74,
		65,
		76,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		138,
		124,
		129,
		104,
		97,
		91,
		106,
		89,
		70,
		59,
		51,
		40,
		44,
		52,
		56,
		41,
		50,
		56,
		80,
		64,
		70,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		80,
		64,
		59,
		56,
		45,
		35,
		48,
		58,
		45,
		43,
		47,
		85,
		85,
		54,
		74,
		77,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		81,
		66,
		62,
		49,
		53,
		50,
		47,
		31,
		49,
		39,
		35,
		59,
		-1,
		62,
		56,
		64,
		54,
		42,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		61,
		56,
		55,
		48,
		36,
		25,
		38,
		31,
		35,
		32,
		47,
		51,
		55,
		44,
		40,
		37,
		51,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		72,
		70,
		83,
		67,
		64,
		48,
		39,
		47,
		20,
		13,
		29,
		24,
		42,
		50,
		42,
		36,
		35,
		47,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		82,
		73,
		86,
		87,
		60,
		48,
		46,
		37,
		25,
		14,
		32,
		24,
		46,
		46,
		30,
		31,
		40,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		87,
		85,
		76,
		62,
		68,
		57,
		34,
		29,
		19,
		8,
		0,
		18,
		40,
		26,
		24,
		43,
		59,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		79,
		63,
		68,
		-1,
		54,
		-1,
		27,
		29,
		23,
		8,
		12,
		23,
		21,
		32,
		49,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		95,
		75,
		69,
		68,
		49,
		49,
		35,
		21,
		14,
		11,
		15,
		28,
		48,
		39,
		51,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		104,
		92,
		82,
		72,
		75,
		65,
		40,
		33,
		19,
		21,
		19,
		24,
		29,
		50,
		51,
		64,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		93,
		-1,
		-1,
		76,
		67,
		57,
		36,
		23,
		43,
		46,
		39,
		23,
		38,
		50,
		58,
		63,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		151,
		96,
		85,
		80,
		84,
		75,
		-1,
		56,
		47,
		27,
		41,
		48,
		41,
		36,
		30,
		33,
		51,
		68,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		73,
		66,
		70,
		-1,
		57,
		43,
		29,
		46,
		54,
		51,
		42,
		34,
		39,
		36,
		49,
		63,
		67,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		126,
		141,
		112,
		89,
		62,
		57,
		50,
		44,
		37,
		53,
		62,
		73,
		41,
		37,
		38,
		42,
		41,
		58,
		68,
		-1,
		-1,
		146,
		160,
		152,
		134,
		138,
		139,
		-1,
		-1,
		66,
		57,
		48,
		51,
		47,
		50,
		47,
		44,
		49,
		54,
		42,
		51,
		69,
		73,
		-1,
		-1,
		-1,
		166,
		-1,
		178,
		-1,
		-1,
		153,
		137,
		84,
		66,
		62,
		60,
		53,
		62,
		56,
		52,
		62,
		72,
		64,
		44,
		57,
		79,
		69,
		105,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		155,
		147,
		142,
		148,
		149,
		140,
		99,
		96,
		-1,
		66,
		91,
		62,
		69,
		61,
		70,
		70,
		68,
		47,
		54,
		70,
		69,
		64,
		97,
		91,
		97,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		148,
		144,
		134,
		124,
		126,
		-1,
		-1,
		114,
		111,
		88,
		71,
		76,
		69,
		64,
		76,
		56,
		43,
		47,
		51,
		57,
		62,
		67,
		73,
		88,
		103,
		-1,
		173,
		236,
		229,
		197,
		205,
		236,
		-1,
		138,
		130,
		141,
		116,
		117,
		-1,
		-1,
		87,
		85,
		90,
		78,
		75,
		86,
		81,
		72,
		57,
		63,
		50,
		49,
		67,
		71,
		80,
		87,
		77,
		90,
		94,
		-1,
		187,
		212,
		191,
		194,
		218,
		232,
		-1,
		135,
		-1,
		-1,
		147,
		118,
		102,
		93,
		86,
		137,
		92,
		87,
		80,
		78,
		69,
		60,
		67,
		58,
		58,
		61,
		76,
		81,
		73,
		87,
		87,
		88,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		163,
		-1,
		129,
		-1,
		104,
		108,
		100,
		103,
		94,
		81,
		73,
		65,
		81,
		56,
		66,
		62,
		63,
		72,
		83,
		95,
		94,
		95,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		147,
		186,
		193,
		-1,
		172,
		-1,
		-1,
		-1,
		118,
		113,
		105,
		114,
		93,
		93,
		67,
		71,
		61,
		68,
		78,
		80,
		72,
		76,
		89,
		100,
		103,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		162,
		153,
		180,
		200,
		189,
		184,
		171,
		-1,
		-1,
		141,
		123,
		-1,
		-1,
		100,
		88,
		71,
		72,
		68,
		71,
		86,
		89,
		79,
		77,
		71,
		103,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		181,
		175,
		179,
		195,
		220,
		-1,
		160,
		-1,
		-1,
		145,
		-1,
		-1,
		130,
		93,
		82,
		73,
		79,
		76,
		87,
		97,
		85,
		86,
		76,
		86,
		99,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		151,
		149,
		155,
		162,
		179,
		209,
		-1,
		-1,
		176,
		156,
		-1,
		-1,
		128,
		126,
		115,
		-1,
		105,
		78,
		83,
		103,
		105,
		94,
		88,
		82,
		89,
		88,
		96,
		104,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		166,
		162,
		-1,
		-1,
		123,
		116,
		104,
		92,
		82,
		92,
		96,
		100,
		92,
		85,
		80,
		91,
		83,
		87,
		104,
		-1,
		222,
		-1,
		174,
		150,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		183,
		169,
		162,
		150,
		148,
		-1,
		157,
		141,
		122,
		-1,
		92,
		105,
		136,
		104,
		109,
		104,
		86,
		97,
		86,
		89,
		103,
		98,
		-1,
		-1,
		162,
		165,
		-1,
		-1,
		173,
		175,
		-1,
		174,
		163,
		148,
		140,
		-1,
		-1,
		129,
		125,
		-1,
		-1,
		93,
		118,
		107,
		115,
		110,
		90,
		96,
		99,
		88,
		92,
		104,
		-1,
		-1,
		169,
		170,
		175,
		-1,
		158,
		-1,
		176,
		-1,
		143,
		149,
		137,
		-1,
		-1,
		-1,
		131,
		94,
		115,
		125,
		119,
		117,
		108,
		94,
		101,
		99,
		95,
		106,
		-1,
		-1,
		-1,
		176,
		150,
		183,
		174,
		157,
		137,
		129,
		148,
		-1,
		118,
		-1,
		93,
		95,
		121,
		124,
		130,
		124,
		97,
		112,
		102,
		93,
		102,
		182,
		-1,
		152,
		185,
		149,
		143,
		119,
		123,
		139,
		-1,
		115,
		97,
		-1,
		125,
		115,
		146,
		131,
		112,
		99,
		106,
		106,
		99,
		-1,
		-1,
		-1,
		154,
		153,
		145,
		139,
		139,
		124,
		115,
		-1,
		127,
		109,
		88,
		105,
		105,
		96,
		104,
		136,
		132,
		119,
		119,
		111,
		-1,
		255,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		148,
		143,
		116,
		104,
		110,
		106,
		92,
		98,
		100,
		108,
		106,
		103,
		115,
		111,
		131,
		112,
		147,
		-1,
		250,
		-1,
		184,
		-1,
		-1,
		166,
		146,
		138,
		127,
		116,
		114,
		105,
		96,
		118,
		134,
		118,
		116,
		119,
		120,
		-1,
		239,
		238,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		162,
		123,
		-1,
		125,
		105,
		-1,
		127,
		123,
		-1,
		-1,
		226,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		157,
		141,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		211,
		210,
		-1,
		179,
		182,
		-1,
		172,
		163,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		220,
		201,
		195,
		194,
		192,
		187,
		184,
		170,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		192,
		184,
		177,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		203,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		226,
		249,
		213,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		228,
		226,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		159,
		148,
		159,
		167,
		140,
		147,
		-1,
		166,
		170,
		136,
		130,
		169,
		138,
		144,
		155,
		-1,
		-1,
		-1,
		159,
		158,
		126,
		124,
		133,
		138,
		145,
		-1,
		144,
		-1,
		180,
		159,
		170,
		175,
		119,
		116,
		136,
		155,
		137,
		129,
		195,
		149,
		120,
		114,
		132,
		122,
		131,
		123,
		-1,
		120,
		110,
		132,
		111,
		122,
		114,
		-1,
		-1,
		114,
		115,
		121,
		107,
		113,
		109,
		-1,
		119,
		103,
		-1,
		-1,
		104,
		105,
		89,
		92,
		100,
		98,
		111,
		103,
		98,
		-1,
		-1,
		95,
		91,
		98,
		85,
		81,
		98,
		111,
		93,
		107,
		106,
		-1,
		107,
		124,
		124,
		92,
		90,
		74,
		72,
		90,
		92,
		98,
		98,
		-1,
		123,
		120,
		119,
		119,
		114,
		90,
		77,
		77,
		87,
		80,
		99,
		87,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		106,
		123,
		115,
		105,
		111,
		109,
		80,
		77,
		75,
		72,
		88,
		86,
		96,
		-1,
		-1,
		214,
		183,
		214,
		172,
		153,
		-1,
		119,
		99,
		105,
		109,
		103,
		96,
		110,
		96,
		-1,
		66,
		65,
		93,
		79,
		90,
		174,
		-1,
		-1,
		172,
		164,
		149,
		152,
		129,
		125,
		114,
		113,
		105,
		91,
		87,
		93,
		96,
		96,
		102,
		60,
		70,
		74,
		72,
		97,
		-1,
		-1,
		132,
		-1,
		-1,
		171,
		154,
		-1,
		137,
		144,
		135,
		141,
		127,
		148,
		124,
		115,
		107,
		101,
		89,
		91,
		88,
		101,
		82,
		57,
		82,
		86,
		67,
		88,
		83,
		-1,
		131,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		130,
		133,
		139,
		163,
		164,
		-1,
		136,
		124,
		125,
		110,
		107,
		94,
		82,
		95,
		80,
		82,
		79,
		61,
		59,
		89,
		64,
		86,
		83,
		102,
		107,
		101,
		110,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		167,
		-1,
		172,
		173,
		148,
		121,
		124,
		111,
		102,
		89,
		78,
		89,
		78,
		75,
		73,
		53,
		68,
		59,
		58,
		76,
		86,
		94,
		98,
		104,
		-1,
		229,
		-1,
		171,
		155,
		157,
		129,
		150,
		-1,
		187,
		173,
		165,
		150,
		148,
		-1,
		120,
		117,
		107,
		85,
		70,
		87,
		79,
		75,
		66,
		48,
		62,
		53,
		71,
		78,
		76,
		80,
		100,
		112,
		189,
		179,
		-1,
		161,
		166,
		125,
		133,
		152,
		190,
		154,
		-1,
		149,
		-1,
		122,
		135,
		-1,
		91,
		87,
		69,
		70,
		65,
		80,
		59,
		44,
		41,
		59,
		62,
		69,
		73,
		89,
		-1,
		-1,
		174,
		178,
		167,
		118,
		137,
		161,
		198,
		147,
		136,
		135,
		-1,
		126,
		105,
		102,
		90,
		77,
		62,
		63,
		71,
		79,
		58,
		43,
		40,
		60,
		86,
		64,
		76,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		144,
		115,
		139,
		181,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		101,
		80,
		71,
		60,
		58,
		71,
		63,
		58,
		38,
		36,
		55,
		67,
		58,
		78,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		144,
		130,
		135,
		110,
		103,
		97,
		114,
		97,
		78,
		67,
		59,
		48,
		59,
		60,
		52,
		34,
		43,
		49,
		73,
		70,
		76,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		135,
		148,
		-1,
		102,
		-1,
		91,
		87,
		72,
		67,
		64,
		51,
		50,
		53,
		51,
		41,
		36,
		43,
		78,
		78,
		60,
		80,
		83,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		118,
		119,
		-1,
		96,
		90,
		87,
		74,
		70,
		55,
		59,
		61,
		63,
		52,
		45,
		46,
		28,
		52,
		-1,
		65,
		62,
		70,
		60,
		48,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		83,
		65,
		67,
		62,
		61,
		60,
		57,
		46,
		59,
		52,
		33,
		27,
		40,
		44,
		54,
		50,
		46,
		43,
		57,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		78,
		76,
		89,
		73,
		72,
		69,
		60,
		68,
		41,
		34,
		32,
		17,
		35,
		48,
		48,
		42,
		41,
		53,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		88,
		79,
		96,
		97,
		75,
		69,
		67,
		58,
		46,
		35,
		17,
		6,
		28,
		38,
		36,
		37,
		46,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		93,
		91,
		86,
		77,
		83,
		78,
		55,
		50,
		40,
		29,
		29,
		0,
		46,
		32,
		30,
		49,
		65,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		94,
		78,
		83,
		-1,
		75,
		-1,
		48,
		45,
		36,
		21,
		18,
		29,
		27,
		38,
		55,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		110,
		90,
		84,
		83,
		70,
		62,
		56,
		34,
		27,
		24,
		21,
		28,
		51,
		45,
		57,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		117,
		105,
		95,
		85,
		88,
		78,
		53,
		46,
		32,
		34,
		32,
		30,
		35,
		56,
		57,
		70,
		-1,
		-1,
		131,
		136,
		124,
		110,
		129,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		106,
		-1,
		-1,
		89,
		80,
		70,
		49,
		36,
		56,
		59,
		45,
		29,
		44,
		56,
		64,
		69,
		-1,
		134,
		121,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		-1,
		-1,
		157,
		102,
		91,
		86,
		90,
		88,
		-1,
		62,
		60,
		40,
		54,
		61,
		47,
		42,
		36,
		39,
		57,
		74,
		-1,
		-1,
		146,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		79,
		72,
		76,
		-1,
		64,
		56,
		42,
		59,
		60,
		57,
		48,
		40,
		45,
		42,
		55,
		69,
		73,
		169,
		-1,
		152,
		-1,
		-1,
		-1,
		132,
		147,
		118,
		95,
		68,
		63,
		56,
		50,
		50,
		66,
		68,
		79,
		47,
		43,
		44,
		48,
		47,
		64,
		74,
		-1,
		-1,
		152,
		166,
		158,
		140,
		144,
		145,
		-1,
		-1,
		72,
		63,
		54,
		57,
		60,
		63,
		53,
		50,
		55,
		60,
		48,
		57,
		75,
		79,
		-1,
		-1,
		-1,
		172,
		-1,
		184,
		-1,
		-1,
		159,
		143,
		90,
		72,
		68,
		66,
		59,
		68,
		63,
		58,
		68,
		78,
		70,
		50,
		63,
		85,
		75,
		111,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		161,
		153,
		148,
		154,
		156,
		147,
		105,
		102,
		-1,
		72,
		97,
		69,
		76,
		68,
		76,
		76,
		74,
		53,
		60,
		76,
		75,
		70,
		103,
		97,
		103,
		-1,
		-1,
		252,
		241,
		230,
		236,
		-1,
		154,
		150,
		140,
		130,
		133,
		-1,
		-1,
		121,
		118,
		94,
		78,
		82,
		75,
		70,
		82,
		62,
		49,
		53,
		57,
		63,
		68,
		73,
		79,
		94,
		109,
		-1,
		179,
		243,
		236,
		204,
		212,
		243,
		-1,
		144,
		136,
		147,
		122,
		124,
		-1,
		-1,
		94,
		91,
		96,
		85,
		82,
		92,
		87,
		78,
		63,
		69,
		56,
		55,
		73,
		77,
		86,
		93,
		83,
		96,
		100,
		-1,
		193,
		219,
		198,
		201,
		225,
		239,
		-1,
		141,
		-1,
		-1,
		153,
		125,
		109,
		99,
		93,
		143,
		99,
		94,
		86,
		84,
		75,
		66,
		73,
		64,
		64,
		67,
		82,
		87,
		79,
		93,
		93,
		94,
		-1,
		188,
		199,
		192,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		169,
		-1,
		136,
		-1,
		111,
		115,
		107,
		110,
		100,
		87,
		79,
		71,
		87,
		62,
		72,
		68,
		69,
		78,
		89,
		101,
		100,
		101,
		213,
		169,
		172,
		183,
		194,
		209,
		213,
		-1,
		153,
		192,
		199,
		-1,
		178,
		-1,
		-1,
		-1,
		125,
		120,
		112,
		120,
		99,
		99,
		73,
		77,
		67,
		74,
		84,
		86,
		78,
		82,
		95,
		106,
		109,
		209,
		200,
		213,
		158,
		158,
		179,
		188,
		209,
		168,
		159,
		186,
		206,
		195,
		190,
		177,
		-1,
		-1,
		148,
		130,
		-1,
		-1,
		106,
		94,
		77,
		78,
		74,
		77,
		92,
		95,
		85,
		83,
		77,
		109,
		-1,
		202,
		201,
		190,
		187,
		163,
		154,
		149,
		176,
		-1,
		-1,
		171,
		187,
		182,
		186,
		202,
		227,
		-1,
		166,
		-1,
		-1,
		151,
		-1,
		-1,
		136,
		99,
		88,
		79,
		85,
		82,
		93,
		103,
		91,
		92,
		82,
		92,
		105,
		186,
		183,
		171,
		169,
		192,
		157,
		145,
		-1,
		158,
		156,
		162,
		169,
		186,
		216,
		-1,
		-1,
		182,
		162,
		-1,
		-1,
		134,
		132,
		121,
		-1,
		111,
		84,
		89,
		109,
		111,
		100,
		94,
		88,
		95,
		94,
		102,
		110,
		195,
		209,
		198,
		194,
		193,
		201,
		150,
		143,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		172,
		168,
		-1,
		-1,
		129,
		122,
		110,
		98,
		88,
		98,
		102,
		106,
		98,
		91,
		86,
		97,
		89,
		93,
		110,
		-1,
		229,
		-1,
		181,
		157,
		171,
		186,
		194,
		-1,
		-1,
		-1,
		189,
		175,
		168,
		156,
		154,
		-1,
		163,
		147,
		128,
		-1,
		98,
		111,
		142,
		110,
		115,
		110,
		92,
		103,
		92,
		95,
		109,
		104,
		-1,
		-1,
		169,
		172,
		-1,
		-1,
		179,
		181,
		-1,
		180,
		169,
		154,
		146,
		-1,
		-1,
		135,
		131,
		-1,
		-1,
		99,
		124,
		113,
		121,
		116,
		96,
		102,
		105,
		94,
		98,
		110,
		-1,
		-1,
		176,
		177,
		182,
		-1,
		164,
		-1,
		182,
		-1,
		149,
		155,
		143,
		-1,
		-1,
		-1,
		137,
		100,
		121,
		131,
		125,
		123,
		114,
		100,
		107,
		105,
		101,
		112,
		-1,
		-1,
		-1,
		182,
		156,
		189,
		180,
		163,
		143,
		135,
		154,
		-1,
		124,
		-1,
		99,
		101,
		127,
		130,
		136,
		130,
		103,
		118,
		108,
		99,
		108,
		188,
		-1,
		158,
		191,
		155,
		149,
		125,
		129,
		145,
		-1,
		121,
		103,
		-1,
		131,
		121,
		152,
		137,
		118,
		105,
		112,
		112,
		105,
		-1,
		-1,
		-1,
		160,
		159,
		151,
		145,
		145,
		130,
		121,
		-1,
		133,
		115,
		94,
		111,
		111,
		102,
		110,
		142,
		138,
		125,
		125,
		117,
		-1,
		261,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		154,
		149,
		122,
		110,
		116,
		112,
		98,
		104,
		106,
		114,
		112,
		109,
		121,
		117,
		137,
		118,
		153,
		-1,
		256,
		-1,
		190,
		-1,
		-1,
		172,
		152,
		144,
		133,
		122,
		120,
		111,
		102,
		124,
		140,
		124,
		122,
		125,
		126,
		-1,
		245,
		244,
		-1,
		191,
		183,
		169,
		-1,
		162,
		-1,
		168,
		129,
		-1,
		131,
		111,
		-1,
		133,
		129,
		-1,
		-1,
		232,
		207,
		-1,
		-1,
		-1,
		192,
		172,
		163,
		147,
		-1,
		122,
		122,
		-1,
		-1,
		-1,
		217,
		216,
		-1,
		185,
		188,
		-1,
		178,
		169,
		177,
		124,
		128,
		-1,
		-1,
		-1,
		226,
		207,
		201,
		200,
		198,
		193,
		190,
		176,
		160,
		138,
		127,
		148,
		-1,
		-1,
		-1,
		198,
		190,
		183,
		-1,
		-1,
		185,
		168,
		149,
		147,
		-1,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		175,
		-1,
		-1,
		181,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		209,
		-1,
		-1,
		-1,
		171,
		167,
		168,
		-1,
		-1,
		-1,
		-1,
		231,
		232,
		255,
		219,
		-1,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		234,
		232,
		-1,
		-1,
		-1,
		191,
		175,
		-1,
		161,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		196,
		-1,
		196,
		171,
		178,
		-1,
		-1,
		-1,
		-1,
		209,
		201,
		209,
		-1,
		181,
		183,
		-1,
		231,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		186,
		193,
		215,
		218,
		254,
		-1,
		205
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		185,
		189,
		155,
		149,
		188,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		178,
		177,
		145,
		143,
		152,
		157,
		164,
		-1,
		163,
		-1,
		199,
		178,
		189,
		194,
		138,
		135,
		155,
		174,
		156,
		148,
		214,
		168,
		139,
		133,
		151,
		141,
		150,
		142,
		-1,
		139,
		129,
		151,
		130,
		141,
		133,
		-1,
		-1,
		133,
		134,
		140,
		126,
		132,
		128,
		-1,
		138,
		122,
		-1,
		-1,
		123,
		124,
		108,
		111,
		119,
		117,
		130,
		122,
		117,
		-1,
		-1,
		114,
		110,
		117,
		104,
		100,
		117,
		130,
		112,
		126,
		125,
		-1,
		120,
		138,
		143,
		111,
		109,
		93,
		91,
		109,
		111,
		117,
		117,
		-1,
		129,
		130,
		125,
		133,
		133,
		109,
		96,
		96,
		106,
		99,
		118,
		106,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		112,
		129,
		121,
		111,
		126,
		119,
		99,
		96,
		94,
		91,
		107,
		105,
		115,
		-1,
		-1,
		220,
		189,
		220,
		178,
		159,
		-1,
		125,
		105,
		111,
		115,
		109,
		102,
		116,
		112,
		-1,
		85,
		84,
		112,
		98,
		109,
		180,
		-1,
		-1,
		178,
		170,
		155,
		158,
		135,
		131,
		120,
		119,
		111,
		97,
		93,
		99,
		102,
		102,
		108,
		79,
		89,
		93,
		91,
		116,
		-1,
		-1,
		137,
		-1,
		-1,
		177,
		160,
		-1,
		143,
		150,
		141,
		147,
		133,
		154,
		130,
		121,
		113,
		107,
		95,
		97,
		94,
		107,
		95,
		76,
		101,
		105,
		86,
		107,
		102,
		-1,
		136,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		139,
		145,
		169,
		170,
		-1,
		142,
		130,
		131,
		116,
		113,
		100,
		88,
		101,
		86,
		93,
		92,
		80,
		78,
		108,
		83,
		105,
		102,
		107,
		112,
		106,
		115,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		173,
		-1,
		178,
		179,
		154,
		127,
		130,
		117,
		108,
		95,
		84,
		95,
		84,
		81,
		89,
		72,
		87,
		78,
		77,
		91,
		91,
		99,
		103,
		109,
		-1,
		235,
		-1,
		177,
		161,
		163,
		135,
		156,
		-1,
		193,
		179,
		171,
		156,
		154,
		-1,
		126,
		123,
		113,
		91,
		76,
		93,
		85,
		83,
		85,
		67,
		81,
		72,
		90,
		95,
		81,
		85,
		105,
		117,
		195,
		185,
		-1,
		167,
		172,
		131,
		139,
		158,
		196,
		160,
		-1,
		155,
		-1,
		128,
		141,
		-1,
		97,
		93,
		75,
		76,
		71,
		86,
		78,
		63,
		60,
		78,
		81,
		74,
		78,
		94,
		-1,
		-1,
		180,
		184,
		173,
		124,
		143,
		167,
		204,
		153,
		142,
		141,
		-1,
		132,
		111,
		108,
		96,
		83,
		68,
		69,
		77,
		89,
		68,
		62,
		59,
		79,
		91,
		69,
		80,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		150,
		121,
		145,
		187,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		107,
		86,
		77,
		66,
		64,
		77,
		69,
		77,
		57,
		55,
		74,
		72,
		63,
		71,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		150,
		136,
		141,
		116,
		109,
		103,
		120,
		103,
		84,
		73,
		65,
		54,
		65,
		73,
		71,
		53,
		62,
		68,
		78,
		59,
		65,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		141,
		154,
		-1,
		108,
		-1,
		97,
		93,
		78,
		73,
		70,
		57,
		56,
		70,
		70,
		60,
		55,
		62,
		83,
		83,
		49,
		69,
		72,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		102,
		96,
		93,
		80,
		76,
		61,
		65,
		67,
		70,
		58,
		64,
		65,
		47,
		71,
		-1,
		57,
		51,
		59,
		49,
		37,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		89,
		71,
		73,
		68,
		67,
		66,
		63,
		52,
		65,
		58,
		52,
		46,
		59,
		63,
		50,
		39,
		35,
		32,
		46,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		84,
		82,
		95,
		79,
		78,
		75,
		66,
		74,
		47,
		40,
		51,
		36,
		54,
		46,
		37,
		32,
		31,
		42,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		94,
		85,
		102,
		103,
		81,
		75,
		73,
		64,
		52,
		41,
		44,
		36,
		49,
		41,
		25,
		27,
		36,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		99,
		97,
		92,
		83,
		89,
		84,
		61,
		56,
		46,
		35,
		35,
		30,
		0,
		21,
		19,
		39,
		55,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		100,
		84,
		89,
		-1,
		81,
		-1,
		54,
		51,
		42,
		27,
		24,
		15,
		22,
		32,
		45,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		116,
		96,
		90,
		89,
		76,
		68,
		62,
		40,
		33,
		30,
		27,
		32,
		52,
		39,
		47,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		123,
		111,
		101,
		91,
		94,
		84,
		59,
		52,
		38,
		40,
		38,
		36,
		41,
		60,
		52,
		62,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		112,
		-1,
		-1,
		95,
		86,
		76,
		55,
		42,
		62,
		65,
		51,
		35,
		50,
		62,
		54,
		63,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		163,
		108,
		97,
		92,
		96,
		94,
		-1,
		68,
		66,
		46,
		60,
		67,
		53,
		48,
		42,
		45,
		63,
		65,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		120,
		114,
		85,
		78,
		82,
		-1,
		70,
		62,
		48,
		65,
		66,
		63,
		54,
		46,
		51,
		48,
		61,
		75,
		67,
		175,
		-1,
		158,
		-1,
		-1,
		-1,
		138,
		153,
		124,
		101,
		74,
		69,
		62,
		56,
		56,
		72,
		74,
		85,
		53,
		49,
		50,
		54,
		53,
		70,
		80,
		-1,
		-1,
		158,
		172,
		164,
		146,
		150,
		151,
		-1,
		-1,
		78,
		69,
		60,
		63,
		66,
		69,
		59,
		56,
		61,
		66,
		54,
		63,
		81,
		85,
		-1,
		-1,
		-1,
		178,
		-1,
		190,
		-1,
		-1,
		165,
		149,
		96,
		78,
		74,
		72,
		65,
		74,
		69,
		64,
		74,
		84,
		76,
		56,
		69,
		91,
		81,
		117,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		167,
		159,
		154,
		160,
		162,
		153,
		111,
		108,
		-1,
		78,
		103,
		75,
		82,
		74,
		82,
		82,
		80,
		59,
		66,
		82,
		81,
		76,
		109,
		103,
		109,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		160,
		156,
		146,
		136,
		139,
		-1,
		-1,
		127,
		124,
		100,
		84,
		88,
		81,
		76,
		88,
		68,
		55,
		59,
		63,
		69,
		74,
		79,
		85,
		100,
		115,
		-1,
		185,
		249,
		242,
		210,
		218,
		249,
		-1,
		150,
		142,
		153,
		128,
		130,
		-1,
		-1,
		100,
		97,
		102,
		91,
		88,
		98,
		93,
		84,
		69,
		75,
		62,
		61,
		79,
		83,
		92,
		99,
		89,
		102,
		106,
		-1,
		199,
		225,
		204,
		207,
		231,
		245,
		-1,
		147,
		-1,
		-1,
		159,
		131,
		115,
		105,
		99,
		149,
		105,
		100,
		92,
		90,
		81,
		72,
		79,
		70,
		70,
		73,
		88,
		93,
		85,
		99,
		99,
		100,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		175,
		-1,
		142,
		-1,
		117,
		121,
		113,
		116,
		106,
		93,
		85,
		77,
		93,
		68,
		78,
		74,
		75,
		84,
		95,
		107,
		106,
		107,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		159,
		198,
		205,
		-1,
		184,
		-1,
		-1,
		-1,
		131,
		126,
		118,
		126,
		105,
		105,
		79,
		83,
		73,
		80,
		90,
		92,
		84,
		88,
		101,
		112,
		115,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		174,
		165,
		192,
		212,
		201,
		196,
		183,
		-1,
		-1,
		154,
		136,
		-1,
		-1,
		112,
		100,
		83,
		84,
		80,
		83,
		98,
		101,
		91,
		89,
		83,
		115,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		193,
		188,
		192,
		208,
		233,
		-1,
		172,
		-1,
		-1,
		157,
		-1,
		-1,
		142,
		105,
		94,
		85,
		91,
		88,
		99,
		109,
		97,
		98,
		88,
		98,
		111,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		192,
		222,
		-1,
		-1,
		188,
		168,
		-1,
		-1,
		140,
		138,
		127,
		-1,
		117,
		90,
		95,
		115,
		117,
		106,
		100,
		94,
		101,
		100,
		108,
		116,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		178,
		174,
		-1,
		-1,
		135,
		128,
		116,
		104,
		94,
		104,
		108,
		112,
		104,
		97,
		92,
		103,
		95,
		99,
		116,
		-1,
		235,
		-1,
		187,
		163,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		195,
		181,
		174,
		162,
		160,
		-1,
		169,
		153,
		134,
		-1,
		104,
		117,
		148,
		116,
		121,
		116,
		98,
		109,
		98,
		101,
		115,
		110,
		-1,
		-1,
		175,
		178,
		-1,
		-1,
		185,
		187,
		-1,
		186,
		175,
		160,
		152,
		-1,
		-1,
		141,
		137,
		-1,
		-1,
		105,
		130,
		119,
		127,
		122,
		102,
		108,
		111,
		100,
		104,
		116,
		-1,
		-1,
		182,
		183,
		188,
		-1,
		170,
		-1,
		188,
		-1,
		155,
		161,
		149,
		-1,
		-1,
		-1,
		143,
		106,
		127,
		137,
		131,
		129,
		120,
		106,
		113,
		111,
		107,
		118,
		-1,
		-1,
		-1,
		188,
		162,
		195,
		186,
		169,
		149,
		141,
		160,
		-1,
		130,
		-1,
		105,
		107,
		133,
		136,
		142,
		136,
		109,
		124,
		114,
		105,
		114,
		194,
		-1,
		164,
		197,
		161,
		155,
		131,
		135,
		151,
		-1,
		127,
		109,
		-1,
		137,
		127,
		158,
		143,
		124,
		111,
		118,
		118,
		111,
		-1,
		-1,
		-1,
		166,
		165,
		157,
		151,
		151,
		136,
		127,
		-1,
		139,
		121,
		100,
		117,
		117,
		108,
		116,
		148,
		144,
		131,
		131,
		123,
		-1,
		267,
		-1,
		-1,
		189,
		-1,
		-1,
		-1,
		160,
		155,
		128,
		116,
		122,
		118,
		104,
		110,
		112,
		120,
		118,
		115,
		127,
		123,
		143,
		124,
		159,
		-1,
		262,
		-1,
		196,
		-1,
		-1,
		178,
		158,
		150,
		139,
		128,
		126,
		117,
		108,
		130,
		146,
		130,
		128,
		131,
		132,
		-1,
		251,
		250,
		-1,
		197,
		189,
		175,
		-1,
		168,
		-1,
		174,
		135,
		-1,
		137,
		117,
		-1,
		139,
		135,
		-1,
		-1,
		238,
		213,
		-1,
		-1,
		-1,
		198,
		178,
		169,
		153,
		-1,
		128,
		128,
		-1,
		-1,
		-1,
		223,
		222,
		-1,
		191,
		194,
		-1,
		184,
		175,
		183,
		130,
		134,
		-1,
		-1,
		-1,
		232,
		213,
		207,
		206,
		204,
		199,
		196,
		182,
		166,
		144,
		133,
		154,
		-1,
		-1,
		-1,
		204,
		196,
		189,
		-1,
		-1,
		191,
		174,
		155,
		153,
		-1,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		181,
		-1,
		-1,
		187,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		215,
		-1,
		-1,
		-1,
		177,
		173,
		174,
		-1,
		-1,
		-1,
		-1,
		237,
		238,
		261,
		225,
		-1,
		-1,
		-1,
		169,
		163,
		-1,
		-1,
		240,
		238,
		-1,
		-1,
		-1,
		197,
		181,
		-1,
		167,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		202,
		-1,
		202,
		177,
		184,
		-1,
		-1,
		-1,
		-1,
		215,
		207,
		215,
		-1,
		187,
		189,
		-1,
		237,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		192,
		199,
		221,
		224,
		260,
		-1,
		211
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		180,
		184,
		150,
		144,
		183,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		173,
		172,
		140,
		138,
		147,
		152,
		159,
		-1,
		158,
		-1,
		194,
		173,
		184,
		189,
		133,
		130,
		150,
		169,
		151,
		143,
		209,
		163,
		134,
		128,
		146,
		136,
		145,
		137,
		-1,
		134,
		124,
		146,
		125,
		136,
		128,
		-1,
		-1,
		128,
		129,
		135,
		121,
		127,
		123,
		-1,
		133,
		117,
		-1,
		-1,
		118,
		119,
		103,
		106,
		114,
		112,
		125,
		117,
		112,
		-1,
		-1,
		109,
		105,
		112,
		99,
		95,
		112,
		125,
		107,
		121,
		120,
		-1,
		115,
		133,
		138,
		106,
		104,
		88,
		86,
		104,
		106,
		112,
		112,
		-1,
		124,
		125,
		120,
		128,
		128,
		104,
		91,
		91,
		101,
		94,
		113,
		101,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		124,
		107,
		124,
		116,
		106,
		121,
		114,
		94,
		91,
		89,
		86,
		102,
		100,
		110,
		-1,
		-1,
		215,
		184,
		215,
		173,
		154,
		-1,
		120,
		100,
		106,
		110,
		104,
		97,
		111,
		107,
		-1,
		80,
		79,
		107,
		93,
		104,
		175,
		-1,
		-1,
		173,
		165,
		150,
		153,
		130,
		126,
		115,
		114,
		106,
		92,
		88,
		94,
		97,
		97,
		103,
		74,
		84,
		88,
		86,
		110,
		-1,
		-1,
		124,
		-1,
		-1,
		172,
		155,
		-1,
		138,
		145,
		136,
		142,
		128,
		149,
		125,
		116,
		108,
		102,
		90,
		92,
		89,
		102,
		90,
		71,
		96,
		100,
		81,
		100,
		95,
		-1,
		123,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		131,
		134,
		140,
		164,
		165,
		-1,
		137,
		125,
		126,
		111,
		108,
		95,
		83,
		96,
		81,
		88,
		87,
		75,
		73,
		103,
		78,
		99,
		89,
		94,
		99,
		93,
		102,
		-1,
		180,
		176,
		172,
		179,
		128,
		-1,
		-1,
		168,
		-1,
		173,
		174,
		149,
		122,
		125,
		112,
		103,
		90,
		79,
		90,
		79,
		76,
		84,
		67,
		82,
		73,
		72,
		78,
		78,
		86,
		90,
		96,
		-1,
		230,
		-1,
		172,
		156,
		158,
		130,
		151,
		-1,
		188,
		174,
		166,
		151,
		149,
		-1,
		121,
		118,
		108,
		86,
		71,
		88,
		80,
		78,
		80,
		62,
		76,
		67,
		84,
		82,
		68,
		72,
		92,
		104,
		190,
		180,
		-1,
		162,
		167,
		126,
		134,
		153,
		191,
		155,
		-1,
		150,
		-1,
		123,
		136,
		-1,
		92,
		88,
		70,
		71,
		66,
		81,
		73,
		58,
		55,
		73,
		75,
		61,
		65,
		81,
		-1,
		-1,
		175,
		179,
		168,
		119,
		138,
		162,
		199,
		148,
		137,
		136,
		-1,
		127,
		106,
		103,
		91,
		78,
		63,
		64,
		72,
		84,
		63,
		57,
		54,
		71,
		78,
		56,
		67,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		145,
		116,
		140,
		182,
		166,
		159,
		147,
		112,
		112,
		106,
		-1,
		102,
		81,
		72,
		61,
		59,
		72,
		64,
		72,
		52,
		50,
		66,
		59,
		50,
		58,
		-1,
		-1,
		-1,
		175,
		164,
		165,
		111,
		134,
		171,
		145,
		131,
		136,
		111,
		104,
		98,
		115,
		98,
		79,
		68,
		60,
		49,
		60,
		68,
		66,
		48,
		57,
		60,
		65,
		46,
		52,
		-1,
		-1,
		182,
		172,
		156,
		158,
		155,
		125,
		132,
		164,
		136,
		149,
		-1,
		103,
		-1,
		92,
		88,
		73,
		68,
		65,
		52,
		51,
		65,
		65,
		55,
		50,
		57,
		70,
		70,
		36,
		56,
		59,
		-1,
		-1,
		-1,
		175,
		170,
		145,
		122,
		106,
		142,
		-1,
		119,
		120,
		-1,
		97,
		91,
		88,
		75,
		71,
		56,
		60,
		62,
		65,
		53,
		59,
		60,
		42,
		66,
		-1,
		44,
		38,
		46,
		36,
		24,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		101,
		153,
		-1,
		-1,
		104,
		97,
		-1,
		84,
		66,
		68,
		63,
		62,
		61,
		58,
		47,
		60,
		53,
		47,
		41,
		54,
		58,
		37,
		26,
		22,
		19,
		33,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		121,
		-1,
		113,
		105,
		95,
		89,
		83,
		79,
		77,
		90,
		74,
		73,
		70,
		61,
		69,
		42,
		35,
		46,
		31,
		49,
		33,
		24,
		19,
		18,
		29,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		134,
		-1,
		98,
		112,
		128,
		-1,
		121,
		100,
		115,
		93,
		89,
		80,
		97,
		98,
		76,
		70,
		68,
		59,
		47,
		36,
		39,
		31,
		36,
		28,
		12,
		14,
		23,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		95,
		83,
		115,
		-1,
		-1,
		157,
		-1,
		91,
		108,
		94,
		92,
		87,
		78,
		84,
		79,
		56,
		51,
		41,
		30,
		30,
		25,
		22,
		0,
		6,
		26,
		42,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		135,
		125,
		109,
		94,
		127,
		-1,
		95,
		79,
		84,
		-1,
		76,
		-1,
		49,
		46,
		37,
		22,
		19,
		10,
		9,
		22,
		32,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		152,
		-1,
		-1,
		122,
		116,
		116,
		100,
		103,
		111,
		91,
		85,
		84,
		71,
		63,
		57,
		35,
		28,
		25,
		22,
		27,
		42,
		29,
		34,
		-1,
		-1,
		-1,
		149,
		135,
		139,
		99,
		118,
		-1,
		-1,
		184,
		139,
		125,
		-1,
		109,
		118,
		106,
		96,
		86,
		89,
		79,
		54,
		47,
		33,
		35,
		33,
		31,
		31,
		47,
		39,
		49,
		-1,
		-1,
		132,
		137,
		125,
		111,
		130,
		-1,
		-1,
		-1,
		131,
		147,
		139,
		110,
		107,
		-1,
		-1,
		90,
		81,
		71,
		50,
		37,
		57,
		56,
		41,
		25,
		40,
		52,
		41,
		50,
		-1,
		135,
		122,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		-1,
		-1,
		158,
		103,
		92,
		87,
		91,
		89,
		-1,
		63,
		61,
		41,
		55,
		62,
		43,
		38,
		32,
		35,
		53,
		52,
		-1,
		-1,
		147,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		80,
		73,
		77,
		-1,
		65,
		57,
		43,
		60,
		56,
		53,
		44,
		36,
		41,
		38,
		51,
		64,
		54,
		170,
		-1,
		153,
		-1,
		-1,
		-1,
		133,
		148,
		119,
		96,
		69,
		64,
		57,
		51,
		51,
		67,
		64,
		75,
		43,
		39,
		40,
		44,
		43,
		60,
		69,
		-1,
		-1,
		153,
		167,
		159,
		141,
		145,
		146,
		-1,
		-1,
		73,
		64,
		55,
		58,
		61,
		64,
		49,
		46,
		51,
		56,
		44,
		53,
		71,
		72,
		-1,
		-1,
		-1,
		173,
		-1,
		185,
		-1,
		-1,
		160,
		144,
		91,
		73,
		69,
		67,
		60,
		69,
		61,
		54,
		64,
		74,
		66,
		46,
		64,
		81,
		76,
		105,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		162,
		154,
		149,
		155,
		157,
		148,
		106,
		103,
		-1,
		73,
		98,
		67,
		74,
		66,
		72,
		72,
		70,
		51,
		61,
		77,
		76,
		71,
		97,
		92,
		101,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		155,
		151,
		141,
		131,
		134,
		-1,
		-1,
		122,
		119,
		95,
		76,
		82,
		75,
		70,
		83,
		63,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		95,
		107,
		-1,
		180,
		241,
		234,
		202,
		210,
		241,
		-1,
		145,
		137,
		148,
		123,
		125,
		-1,
		-1,
		95,
		92,
		95,
		83,
		80,
		93,
		88,
		79,
		64,
		70,
		57,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		194,
		217,
		196,
		199,
		223,
		237,
		-1,
		142,
		-1,
		-1,
		154,
		126,
		110,
		100,
		94,
		142,
		97,
		92,
		87,
		85,
		76,
		67,
		74,
		65,
		65,
		68,
		83,
		88,
		80,
		94,
		94,
		95,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		170,
		-1,
		137,
		-1,
		112,
		116,
		105,
		108,
		101,
		88,
		80,
		72,
		88,
		63,
		73,
		69,
		70,
		79,
		90,
		102,
		101,
		102,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		154,
		193,
		200,
		-1,
		179,
		-1,
		-1,
		-1,
		126,
		118,
		110,
		121,
		100,
		100,
		74,
		78,
		68,
		75,
		85,
		87,
		79,
		83,
		96,
		107,
		110,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		169,
		160,
		187,
		207,
		196,
		191,
		178,
		-1,
		-1,
		149,
		128,
		-1,
		-1,
		107,
		95,
		78,
		79,
		75,
		78,
		93,
		96,
		86,
		84,
		78,
		110,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		188,
		180,
		184,
		200,
		225,
		-1,
		167,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		100,
		89,
		80,
		86,
		83,
		94,
		104,
		92,
		93,
		83,
		93,
		106,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		90,
		110,
		112,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		99,
		103,
		107,
		99,
		92,
		87,
		98,
		90,
		94,
		111,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		143,
		111,
		116,
		111,
		93,
		104,
		93,
		96,
		110,
		105,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		180,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		125,
		114,
		122,
		117,
		97,
		103,
		106,
		95,
		99,
		111,
		-1,
		-1,
		174,
		175,
		180,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		138,
		101,
		122,
		132,
		126,
		124,
		115,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		102,
		128,
		131,
		137,
		131,
		104,
		119,
		109,
		100,
		109,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		132,
		122,
		153,
		138,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		111,
		143,
		139,
		126,
		126,
		118,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		113,
		110,
		122,
		118,
		138,
		119,
		154,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		125,
		123,
		126,
		127,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		134,
		130,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		167,
		156,
		167,
		175,
		148,
		155,
		-1,
		174,
		178,
		144,
		138,
		177,
		146,
		152,
		163,
		-1,
		-1,
		-1,
		167,
		166,
		134,
		132,
		141,
		146,
		153,
		-1,
		152,
		-1,
		188,
		167,
		178,
		183,
		127,
		124,
		144,
		163,
		145,
		137,
		203,
		157,
		128,
		122,
		140,
		130,
		139,
		131,
		-1,
		128,
		118,
		140,
		119,
		130,
		122,
		-1,
		-1,
		122,
		123,
		129,
		115,
		121,
		117,
		-1,
		127,
		111,
		-1,
		-1,
		112,
		113,
		97,
		100,
		108,
		106,
		119,
		111,
		106,
		-1,
		-1,
		103,
		99,
		106,
		93,
		89,
		106,
		119,
		101,
		115,
		114,
		-1,
		109,
		127,
		132,
		100,
		98,
		82,
		80,
		98,
		100,
		106,
		106,
		-1,
		118,
		119,
		114,
		122,
		122,
		98,
		85,
		85,
		95,
		88,
		107,
		95,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		101,
		118,
		110,
		100,
		115,
		108,
		88,
		85,
		83,
		80,
		96,
		94,
		104,
		-1,
		-1,
		209,
		178,
		209,
		167,
		148,
		-1,
		114,
		94,
		100,
		104,
		98,
		91,
		105,
		101,
		-1,
		74,
		73,
		101,
		87,
		98,
		169,
		-1,
		-1,
		167,
		159,
		144,
		147,
		124,
		120,
		109,
		108,
		100,
		86,
		82,
		88,
		91,
		91,
		97,
		68,
		78,
		82,
		80,
		104,
		-1,
		-1,
		118,
		-1,
		-1,
		166,
		149,
		-1,
		132,
		139,
		130,
		136,
		122,
		143,
		119,
		110,
		102,
		96,
		84,
		86,
		83,
		96,
		84,
		65,
		90,
		94,
		75,
		94,
		89,
		-1,
		117,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		134,
		158,
		159,
		-1,
		131,
		119,
		120,
		105,
		102,
		89,
		77,
		90,
		75,
		82,
		81,
		69,
		67,
		97,
		72,
		93,
		83,
		88,
		93,
		87,
		96,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		162,
		-1,
		167,
		168,
		143,
		116,
		119,
		106,
		97,
		84,
		73,
		84,
		73,
		70,
		78,
		61,
		76,
		67,
		66,
		72,
		72,
		80,
		84,
		90,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		182,
		168,
		160,
		145,
		143,
		-1,
		115,
		112,
		102,
		80,
		65,
		82,
		74,
		72,
		74,
		56,
		70,
		61,
		78,
		76,
		62,
		66,
		86,
		98,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		185,
		149,
		-1,
		144,
		-1,
		117,
		130,
		-1,
		86,
		82,
		64,
		65,
		60,
		75,
		67,
		52,
		49,
		67,
		69,
		55,
		59,
		75,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		100,
		97,
		85,
		72,
		57,
		58,
		66,
		78,
		57,
		51,
		48,
		65,
		72,
		50,
		61,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		96,
		75,
		66,
		55,
		53,
		66,
		58,
		66,
		46,
		44,
		60,
		53,
		44,
		52,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		109,
		92,
		73,
		62,
		54,
		43,
		54,
		62,
		60,
		42,
		51,
		54,
		59,
		40,
		46,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		82,
		67,
		62,
		59,
		46,
		45,
		59,
		59,
		49,
		44,
		51,
		64,
		64,
		30,
		50,
		53,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		69,
		65,
		50,
		54,
		56,
		59,
		47,
		53,
		54,
		36,
		60,
		-1,
		38,
		32,
		40,
		30,
		18,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		62,
		57,
		56,
		55,
		52,
		41,
		54,
		47,
		41,
		35,
		48,
		52,
		31,
		20,
		16,
		13,
		27,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		84,
		68,
		67,
		64,
		55,
		63,
		36,
		29,
		40,
		25,
		43,
		27,
		18,
		13,
		12,
		23,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		74,
		91,
		92,
		70,
		64,
		62,
		53,
		41,
		30,
		33,
		25,
		30,
		22,
		6,
		8,
		17,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		88,
		86,
		81,
		72,
		78,
		73,
		50,
		45,
		35,
		24,
		24,
		19,
		16,
		2,
		0,
		20,
		36,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		89,
		73,
		78,
		-1,
		70,
		-1,
		43,
		40,
		31,
		16,
		13,
		12,
		3,
		16,
		26,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		105,
		85,
		79,
		78,
		65,
		57,
		51,
		29,
		22,
		19,
		16,
		29,
		36,
		23,
		28,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		112,
		100,
		90,
		80,
		83,
		73,
		48,
		41,
		27,
		29,
		27,
		25,
		25,
		41,
		33,
		43,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		101,
		-1,
		-1,
		84,
		75,
		65,
		44,
		31,
		51,
		50,
		35,
		19,
		34,
		46,
		35,
		44,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		152,
		97,
		86,
		81,
		85,
		83,
		-1,
		57,
		55,
		35,
		49,
		56,
		37,
		32,
		26,
		29,
		47,
		46,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		74,
		67,
		71,
		-1,
		59,
		51,
		37,
		54,
		50,
		47,
		38,
		30,
		35,
		32,
		45,
		58,
		48,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		127,
		142,
		113,
		90,
		63,
		58,
		51,
		45,
		45,
		61,
		58,
		69,
		37,
		33,
		34,
		38,
		37,
		54,
		63,
		-1,
		-1,
		147,
		161,
		153,
		135,
		139,
		140,
		-1,
		-1,
		67,
		58,
		49,
		52,
		55,
		58,
		43,
		40,
		45,
		50,
		38,
		47,
		65,
		66,
		-1,
		-1,
		-1,
		167,
		-1,
		179,
		-1,
		-1,
		154,
		138,
		85,
		67,
		63,
		61,
		54,
		63,
		55,
		48,
		58,
		68,
		60,
		40,
		58,
		75,
		70,
		99,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		100,
		97,
		-1,
		67,
		92,
		61,
		68,
		60,
		66,
		66,
		64,
		45,
		55,
		71,
		70,
		65,
		91,
		86,
		95,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		116,
		113,
		89,
		70,
		76,
		69,
		64,
		77,
		57,
		44,
		48,
		52,
		58,
		63,
		68,
		74,
		89,
		101,
		-1,
		174,
		235,
		228,
		196,
		204,
		235,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		89,
		86,
		89,
		77,
		74,
		87,
		82,
		73,
		58,
		64,
		51,
		50,
		68,
		72,
		81,
		88,
		78,
		91,
		95,
		-1,
		188,
		211,
		190,
		193,
		217,
		231,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		88,
		136,
		91,
		86,
		81,
		79,
		70,
		61,
		68,
		59,
		59,
		62,
		77,
		82,
		74,
		88,
		88,
		89,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		164,
		-1,
		131,
		-1,
		106,
		110,
		99,
		102,
		95,
		82,
		74,
		66,
		82,
		57,
		67,
		63,
		64,
		73,
		84,
		96,
		95,
		96,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		148,
		187,
		194,
		-1,
		173,
		-1,
		-1,
		-1,
		120,
		112,
		104,
		115,
		94,
		94,
		68,
		72,
		62,
		69,
		79,
		81,
		73,
		77,
		90,
		101,
		104,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		163,
		154,
		181,
		201,
		190,
		185,
		172,
		-1,
		-1,
		143,
		122,
		-1,
		-1,
		101,
		89,
		72,
		73,
		69,
		72,
		87,
		90,
		80,
		78,
		72,
		104,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		163,
		182,
		174,
		178,
		194,
		219,
		-1,
		161,
		-1,
		-1,
		146,
		-1,
		-1,
		131,
		94,
		83,
		74,
		80,
		77,
		88,
		98,
		86,
		87,
		77,
		87,
		100,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		150,
		148,
		154,
		161,
		178,
		208,
		-1,
		-1,
		177,
		157,
		-1,
		-1,
		129,
		127,
		116,
		-1,
		106,
		79,
		84,
		104,
		106,
		95,
		89,
		83,
		90,
		89,
		97,
		105,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		167,
		163,
		-1,
		-1,
		124,
		117,
		105,
		93,
		83,
		93,
		97,
		101,
		93,
		86,
		81,
		92,
		84,
		88,
		105,
		-1,
		221,
		-1,
		173,
		149,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		184,
		170,
		163,
		151,
		149,
		-1,
		158,
		142,
		123,
		-1,
		93,
		106,
		137,
		105,
		110,
		105,
		87,
		98,
		87,
		90,
		104,
		99,
		-1,
		-1,
		161,
		164,
		-1,
		-1,
		174,
		176,
		-1,
		175,
		164,
		149,
		141,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		94,
		119,
		108,
		116,
		111,
		91,
		97,
		100,
		89,
		93,
		105,
		-1,
		-1,
		168,
		169,
		174,
		-1,
		159,
		-1,
		177,
		-1,
		144,
		150,
		138,
		-1,
		-1,
		-1,
		132,
		95,
		116,
		126,
		120,
		118,
		109,
		95,
		102,
		100,
		96,
		107,
		-1,
		-1,
		-1,
		177,
		151,
		184,
		175,
		158,
		138,
		130,
		149,
		-1,
		119,
		-1,
		94,
		96,
		122,
		125,
		131,
		125,
		98,
		113,
		103,
		94,
		103,
		183,
		-1,
		153,
		186,
		150,
		144,
		120,
		124,
		140,
		-1,
		116,
		98,
		-1,
		126,
		116,
		147,
		132,
		113,
		100,
		107,
		107,
		100,
		-1,
		-1,
		-1,
		155,
		154,
		146,
		140,
		140,
		125,
		116,
		-1,
		128,
		110,
		89,
		106,
		106,
		97,
		105,
		137,
		133,
		120,
		120,
		112,
		-1,
		256,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		149,
		144,
		117,
		105,
		111,
		107,
		93,
		99,
		101,
		109,
		107,
		104,
		116,
		112,
		132,
		113,
		148,
		-1,
		251,
		-1,
		185,
		-1,
		-1,
		167,
		147,
		139,
		128,
		117,
		115,
		106,
		97,
		119,
		135,
		119,
		117,
		120,
		121,
		-1,
		240,
		239,
		-1,
		186,
		178,
		164,
		-1,
		157,
		-1,
		163,
		124,
		-1,
		126,
		106,
		-1,
		128,
		124,
		-1,
		-1,
		227,
		202,
		-1,
		-1,
		-1,
		187,
		167,
		158,
		142,
		-1,
		117,
		117,
		-1,
		-1,
		-1,
		212,
		211,
		-1,
		180,
		183,
		-1,
		173,
		164,
		172,
		119,
		123,
		-1,
		-1,
		-1,
		221,
		202,
		196,
		195,
		193,
		188,
		185,
		171,
		155,
		133,
		122,
		143,
		-1,
		-1,
		-1,
		193,
		185,
		178,
		-1,
		-1,
		180,
		163,
		144,
		142,
		-1,
		-1,
		-1,
		215,
		196,
		-1,
		-1,
		170,
		-1,
		-1,
		176,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		204,
		-1,
		-1,
		-1,
		166,
		162,
		163,
		-1,
		-1,
		-1,
		-1,
		226,
		227,
		250,
		214,
		-1,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		229,
		227,
		-1,
		-1,
		-1,
		186,
		170,
		-1,
		156,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		189,
		-1,
		-1,
		-1,
		191,
		-1,
		191,
		166,
		173,
		-1,
		-1,
		-1,
		-1,
		204,
		196,
		204,
		-1,
		176,
		178,
		-1,
		226,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		181,
		188,
		210,
		213,
		249,
		-1,
		200
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		192,
		196,
		162,
		156,
		195,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		185,
		184,
		152,
		150,
		159,
		164,
		171,
		-1,
		170,
		-1,
		206,
		185,
		196,
		201,
		145,
		142,
		162,
		181,
		163,
		155,
		221,
		175,
		146,
		140,
		158,
		148,
		157,
		149,
		-1,
		146,
		136,
		158,
		137,
		148,
		140,
		-1,
		-1,
		140,
		141,
		147,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		130,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		121,
		139,
		148,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		124,
		-1,
		130,
		131,
		126,
		134,
		139,
		116,
		103,
		103,
		113,
		106,
		125,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		113,
		130,
		122,
		112,
		127,
		120,
		106,
		103,
		101,
		98,
		114,
		112,
		122,
		-1,
		-1,
		223,
		192,
		221,
		179,
		160,
		-1,
		126,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		92,
		91,
		119,
		105,
		116,
		183,
		-1,
		-1,
		181,
		173,
		156,
		159,
		136,
		132,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		86,
		96,
		100,
		98,
		104,
		-1,
		-1,
		118,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		142,
		148,
		134,
		155,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		83,
		108,
		112,
		93,
		94,
		89,
		-1,
		117,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		171,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		87,
		85,
		115,
		90,
		93,
		83,
		88,
		93,
		87,
		96,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		179,
		180,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		79,
		94,
		85,
		84,
		72,
		72,
		80,
		84,
		90,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		180,
		172,
		157,
		157,
		-1,
		127,
		124,
		114,
		92,
		77,
		94,
		86,
		84,
		89,
		74,
		88,
		79,
		78,
		76,
		62,
		66,
		86,
		98,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		85,
		70,
		67,
		74,
		69,
		55,
		59,
		75,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		112,
		109,
		97,
		84,
		69,
		70,
		78,
		91,
		70,
		69,
		66,
		65,
		72,
		50,
		61,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		65,
		78,
		75,
		84,
		64,
		62,
		60,
		53,
		44,
		52,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		121,
		104,
		85,
		74,
		66,
		55,
		71,
		79,
		78,
		60,
		69,
		54,
		59,
		40,
		46,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		64,
		62,
		71,
		77,
		67,
		62,
		69,
		64,
		64,
		30,
		49,
		52,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		68,
		72,
		69,
		76,
		65,
		71,
		72,
		54,
		78,
		-1,
		38,
		32,
		39,
		29,
		18,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		80,
		75,
		73,
		73,
		70,
		59,
		72,
		65,
		59,
		53,
		66,
		53,
		37,
		20,
		16,
		13,
		27,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		85,
		82,
		73,
		81,
		54,
		47,
		58,
		43,
		61,
		34,
		24,
		14,
		6,
		23,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		92,
		108,
		109,
		87,
		82,
		80,
		71,
		59,
		48,
		51,
		43,
		36,
		28,
		12,
		9,
		2,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		106,
		104,
		98,
		89,
		95,
		91,
		68,
		63,
		53,
		42,
		42,
		37,
		34,
		20,
		18,
		0,
		16,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		106,
		90,
		95,
		-1,
		88,
		-1,
		61,
		58,
		49,
		34,
		31,
		30,
		21,
		28,
		6,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		122,
		102,
		96,
		95,
		83,
		75,
		69,
		47,
		40,
		37,
		34,
		47,
		53,
		20,
		8,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		130,
		118,
		108,
		98,
		101,
		91,
		66,
		59,
		45,
		47,
		45,
		43,
		36,
		21,
		13,
		23,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		119,
		-1,
		-1,
		102,
		93,
		83,
		62,
		49,
		69,
		68,
		53,
		37,
		37,
		27,
		15,
		24,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		170,
		115,
		104,
		99,
		103,
		101,
		-1,
		75,
		73,
		53,
		67,
		74,
		55,
		47,
		41,
		32,
		32,
		26,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		127,
		121,
		92,
		85,
		89,
		-1,
		77,
		69,
		55,
		72,
		65,
		62,
		53,
		43,
		43,
		29,
		42,
		38,
		28,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		145,
		160,
		131,
		108,
		81,
		76,
		69,
		63,
		63,
		79,
		73,
		84,
		50,
		46,
		42,
		35,
		34,
		42,
		43,
		-1,
		-1,
		161,
		176,
		171,
		153,
		157,
		158,
		-1,
		-1,
		85,
		76,
		67,
		70,
		73,
		76,
		56,
		53,
		58,
		52,
		45,
		44,
		61,
		46,
		-1,
		-1,
		-1,
		181,
		-1,
		194,
		-1,
		-1,
		172,
		156,
		103,
		85,
		81,
		79,
		72,
		80,
		68,
		61,
		71,
		70,
		62,
		42,
		60,
		72,
		54,
		79,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		118,
		115,
		-1,
		85,
		109,
		74,
		81,
		73,
		77,
		74,
		66,
		47,
		61,
		77,
		66,
		65,
		71,
		66,
		75,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		134,
		131,
		106,
		83,
		86,
		79,
		74,
		84,
		64,
		51,
		54,
		58,
		64,
		63,
		68,
		74,
		73,
		81,
		-1,
		188,
		248,
		241,
		209,
		217,
		248,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		107,
		101,
		102,
		90,
		87,
		94,
		89,
		80,
		65,
		71,
		58,
		56,
		74,
		78,
		81,
		87,
		76,
		89,
		93,
		-1,
		202,
		224,
		203,
		206,
		230,
		244,
		-1,
		151,
		-1,
		-1,
		163,
		135,
		119,
		109,
		106,
		149,
		104,
		99,
		88,
		86,
		77,
		68,
		75,
		66,
		65,
		68,
		84,
		89,
		81,
		86,
		86,
		87,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		179,
		-1,
		146,
		-1,
		124,
		128,
		112,
		115,
		102,
		89,
		81,
		73,
		89,
		64,
		73,
		69,
		71,
		80,
		91,
		103,
		93,
		94,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		163,
		202,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		138,
		125,
		117,
		122,
		101,
		101,
		75,
		79,
		69,
		76,
		85,
		87,
		80,
		84,
		97,
		103,
		102,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		169,
		196,
		208,
		197,
		192,
		179,
		-1,
		-1,
		161,
		135,
		-1,
		-1,
		108,
		96,
		79,
		80,
		76,
		79,
		94,
		96,
		87,
		85,
		79,
		108,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		197,
		187,
		191,
		207,
		232,
		-1,
		168,
		-1,
		-1,
		153,
		-1,
		-1,
		138,
		101,
		90,
		81,
		87,
		84,
		95,
		105,
		93,
		94,
		84,
		94,
		107,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		191,
		221,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		136,
		134,
		123,
		-1,
		113,
		86,
		91,
		111,
		113,
		102,
		96,
		90,
		97,
		96,
		104,
		112,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		131,
		124,
		112,
		100,
		90,
		100,
		104,
		108,
		100,
		93,
		88,
		99,
		91,
		95,
		112,
		-1,
		234,
		-1,
		186,
		162,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		144,
		112,
		117,
		112,
		94,
		105,
		94,
		97,
		111,
		106,
		-1,
		-1,
		174,
		177,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		101,
		126,
		115,
		123,
		118,
		98,
		104,
		107,
		96,
		100,
		112,
		-1,
		-1,
		181,
		182,
		187,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		139,
		102,
		123,
		133,
		127,
		125,
		116,
		102,
		109,
		107,
		103,
		114,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		103,
		129,
		132,
		138,
		132,
		105,
		120,
		110,
		101,
		110,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		133,
		123,
		154,
		139,
		120,
		107,
		114,
		114,
		107,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		113,
		104,
		112,
		144,
		140,
		127,
		127,
		119,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		120,
		155,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		126,
		124,
		127,
		128,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		135,
		131,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		202,
		191,
		202,
		210,
		183,
		190,
		-1,
		209,
		213,
		179,
		173,
		212,
		181,
		187,
		198,
		-1,
		-1,
		-1,
		202,
		201,
		169,
		167,
		176,
		181,
		188,
		-1,
		187,
		-1,
		223,
		202,
		213,
		218,
		162,
		159,
		179,
		198,
		180,
		172,
		238,
		192,
		163,
		157,
		175,
		165,
		174,
		166,
		-1,
		163,
		153,
		175,
		154,
		165,
		157,
		-1,
		-1,
		157,
		158,
		164,
		150,
		156,
		152,
		-1,
		162,
		146,
		-1,
		-1,
		147,
		148,
		132,
		135,
		143,
		141,
		154,
		146,
		141,
		-1,
		-1,
		138,
		134,
		141,
		128,
		124,
		141,
		154,
		136,
		150,
		149,
		-1,
		138,
		156,
		165,
		135,
		133,
		117,
		115,
		133,
		135,
		141,
		141,
		-1,
		147,
		148,
		143,
		151,
		156,
		133,
		120,
		120,
		130,
		123,
		142,
		130,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		123,
		120,
		118,
		115,
		131,
		129,
		139,
		-1,
		-1,
		240,
		209,
		238,
		196,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		109,
		108,
		136,
		122,
		133,
		200,
		-1,
		-1,
		198,
		190,
		173,
		176,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		103,
		113,
		117,
		115,
		118,
		-1,
		-1,
		132,
		-1,
		-1,
		197,
		180,
		-1,
		163,
		170,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		100,
		125,
		129,
		110,
		108,
		103,
		-1,
		131,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		156,
		159,
		165,
		189,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		104,
		102,
		132,
		107,
		107,
		97,
		102,
		107,
		101,
		110,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		193,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		96,
		111,
		102,
		101,
		86,
		86,
		94,
		98,
		104,
		-1,
		255,
		-1,
		197,
		181,
		183,
		155,
		176,
		-1,
		213,
		197,
		189,
		174,
		174,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		106,
		91,
		105,
		96,
		92,
		90,
		76,
		80,
		100,
		112,
		215,
		205,
		-1,
		187,
		192,
		151,
		159,
		178,
		216,
		180,
		-1,
		175,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		102,
		87,
		84,
		88,
		83,
		69,
		73,
		89,
		-1,
		-1,
		200,
		204,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		108,
		87,
		86,
		83,
		79,
		86,
		64,
		75,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		92,
		101,
		81,
		79,
		74,
		67,
		58,
		66,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		138,
		121,
		102,
		91,
		83,
		72,
		88,
		96,
		95,
		77,
		86,
		68,
		73,
		54,
		60,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		112,
		96,
		91,
		88,
		81,
		79,
		88,
		94,
		84,
		79,
		86,
		78,
		78,
		44,
		64,
		67,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		98,
		94,
		85,
		89,
		86,
		93,
		82,
		88,
		89,
		71,
		95,
		-1,
		52,
		46,
		54,
		44,
		32,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		97,
		92,
		90,
		90,
		87,
		76,
		89,
		82,
		76,
		70,
		83,
		67,
		54,
		34,
		30,
		27,
		30,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		118,
		102,
		102,
		99,
		90,
		98,
		71,
		64,
		75,
		60,
		78,
		51,
		41,
		31,
		23,
		26,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		109,
		125,
		126,
		104,
		99,
		97,
		88,
		76,
		65,
		68,
		60,
		53,
		45,
		29,
		26,
		19,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		123,
		121,
		115,
		106,
		112,
		108,
		85,
		80,
		70,
		59,
		59,
		54,
		51,
		37,
		35,
		17,
		0,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		123,
		107,
		112,
		-1,
		105,
		-1,
		78,
		75,
		66,
		51,
		48,
		47,
		38,
		45,
		23,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		139,
		119,
		113,
		112,
		100,
		92,
		86,
		64,
		57,
		54,
		51,
		64,
		68,
		37,
		25,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		147,
		135,
		125,
		115,
		118,
		108,
		83,
		76,
		62,
		64,
		62,
		60,
		53,
		38,
		30,
		40,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		164,
		135,
		136,
		-1,
		-1,
		119,
		110,
		100,
		79,
		66,
		86,
		85,
		70,
		54,
		54,
		44,
		32,
		41,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		187,
		132,
		121,
		116,
		120,
		118,
		-1,
		92,
		90,
		70,
		84,
		91,
		72,
		64,
		58,
		49,
		49,
		43,
		-1,
		-1,
		172,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		144,
		138,
		109,
		102,
		106,
		-1,
		94,
		86,
		72,
		89,
		82,
		79,
		70,
		60,
		60,
		46,
		59,
		41,
		45,
		195,
		-1,
		178,
		-1,
		-1,
		-1,
		162,
		177,
		148,
		125,
		98,
		93,
		86,
		80,
		80,
		96,
		90,
		101,
		67,
		63,
		59,
		52,
		51,
		45,
		46,
		-1,
		-1,
		178,
		193,
		188,
		170,
		174,
		175,
		-1,
		-1,
		102,
		93,
		84,
		87,
		90,
		93,
		73,
		70,
		75,
		69,
		62,
		61,
		67,
		52,
		-1,
		-1,
		-1,
		198,
		-1,
		211,
		-1,
		-1,
		189,
		173,
		120,
		102,
		98,
		96,
		89,
		97,
		85,
		78,
		88,
		87,
		79,
		59,
		77,
		81,
		60,
		71,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		188,
		180,
		175,
		181,
		183,
		174,
		135,
		132,
		-1,
		102,
		126,
		91,
		98,
		90,
		94,
		91,
		83,
		64,
		78,
		84,
		72,
		71,
		63,
		58,
		67,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		181,
		177,
		167,
		157,
		160,
		-1,
		-1,
		151,
		148,
		123,
		100,
		103,
		96,
		91,
		101,
		81,
		68,
		71,
		75,
		76,
		69,
		74,
		76,
		65,
		73,
		-1,
		205,
		265,
		258,
		226,
		234,
		265,
		-1,
		171,
		163,
		174,
		149,
		151,
		-1,
		-1,
		124,
		118,
		119,
		107,
		104,
		111,
		106,
		97,
		82,
		88,
		75,
		73,
		91,
		90,
		87,
		79,
		68,
		81,
		85,
		-1,
		219,
		241,
		220,
		223,
		247,
		261,
		-1,
		168,
		-1,
		-1,
		180,
		152,
		136,
		126,
		123,
		166,
		121,
		116,
		105,
		103,
		94,
		85,
		92,
		83,
		82,
		85,
		98,
		91,
		81,
		78,
		78,
		79,
		-1,
		210,
		221,
		214,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		196,
		-1,
		163,
		-1,
		141,
		145,
		129,
		132,
		119,
		106,
		98,
		90,
		106,
		81,
		90,
		86,
		88,
		97,
		91,
		99,
		85,
		86,
		235,
		191,
		194,
		205,
		216,
		231,
		235,
		-1,
		180,
		219,
		218,
		-1,
		202,
		-1,
		-1,
		-1,
		155,
		142,
		134,
		139,
		118,
		118,
		92,
		96,
		86,
		93,
		102,
		104,
		97,
		101,
		107,
		95,
		94,
		231,
		222,
		235,
		180,
		180,
		201,
		210,
		231,
		195,
		186,
		213,
		225,
		214,
		209,
		196,
		-1,
		-1,
		178,
		152,
		-1,
		-1,
		125,
		113,
		96,
		97,
		93,
		96,
		111,
		113,
		104,
		102,
		96,
		100,
		-1,
		224,
		223,
		212,
		209,
		185,
		176,
		171,
		198,
		-1,
		-1,
		193,
		214,
		204,
		208,
		224,
		249,
		-1,
		185,
		-1,
		-1,
		170,
		-1,
		-1,
		155,
		118,
		107,
		98,
		104,
		101,
		112,
		122,
		110,
		111,
		101,
		111,
		114,
		208,
		205,
		193,
		191,
		214,
		179,
		167,
		-1,
		180,
		178,
		184,
		191,
		208,
		238,
		-1,
		-1,
		201,
		181,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		108,
		128,
		130,
		119,
		113,
		107,
		114,
		113,
		121,
		119,
		217,
		231,
		220,
		216,
		215,
		223,
		172,
		165,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		187,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		121,
		125,
		117,
		110,
		105,
		116,
		108,
		112,
		116,
		-1,
		251,
		-1,
		203,
		179,
		193,
		208,
		216,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		161,
		129,
		134,
		129,
		111,
		122,
		111,
		114,
		109,
		112,
		-1,
		-1,
		191,
		194,
		-1,
		-1,
		198,
		200,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		143,
		132,
		140,
		135,
		115,
		121,
		124,
		113,
		115,
		109,
		-1,
		-1,
		198,
		199,
		204,
		-1,
		183,
		-1,
		201,
		-1,
		168,
		174,
		162,
		-1,
		-1,
		-1,
		156,
		119,
		140,
		150,
		144,
		142,
		133,
		119,
		126,
		124,
		120,
		119,
		-1,
		-1,
		-1,
		201,
		175,
		208,
		199,
		182,
		162,
		154,
		173,
		-1,
		143,
		-1,
		118,
		120,
		146,
		149,
		155,
		149,
		122,
		137,
		127,
		118,
		125,
		207,
		-1,
		177,
		210,
		174,
		168,
		144,
		148,
		164,
		-1,
		140,
		122,
		-1,
		150,
		140,
		171,
		156,
		137,
		124,
		131,
		129,
		122,
		-1,
		-1,
		-1,
		179,
		178,
		170,
		164,
		164,
		149,
		140,
		-1,
		152,
		134,
		113,
		130,
		130,
		121,
		129,
		161,
		157,
		144,
		144,
		136,
		-1,
		280,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		173,
		168,
		141,
		129,
		135,
		131,
		117,
		123,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		137,
		170,
		-1,
		275,
		-1,
		209,
		-1,
		-1,
		191,
		171,
		163,
		152,
		141,
		139,
		130,
		121,
		143,
		159,
		143,
		141,
		144,
		145,
		-1,
		264,
		263,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		187,
		148,
		-1,
		150,
		130,
		-1,
		152,
		148,
		-1,
		-1,
		251,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		182,
		166,
		-1,
		141,
		141,
		-1,
		-1,
		-1,
		236,
		235,
		-1,
		204,
		207,
		-1,
		197,
		188,
		196,
		143,
		147,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		219,
		217,
		212,
		209,
		195,
		179,
		157,
		146,
		167,
		-1,
		-1,
		-1,
		217,
		209,
		202,
		-1,
		-1,
		204,
		187,
		168,
		166,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		194,
		-1,
		-1,
		200,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		228,
		-1,
		-1,
		-1,
		190,
		186,
		187,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		274,
		238,
		-1,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		210,
		194,
		-1,
		180,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		215,
		-1,
		215,
		190,
		197,
		-1,
		-1,
		-1,
		-1,
		228,
		220,
		228,
		-1,
		200,
		202,
		-1,
		250,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		205,
		212,
		234,
		237,
		273,
		-1,
		224
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		217,
		206,
		217,
		225,
		198,
		205,
		-1,
		226,
		228,
		194,
		188,
		227,
		198,
		204,
		215,
		-1,
		-1,
		-1,
		217,
		216,
		186,
		184,
		193,
		198,
		205,
		-1,
		228,
		-1,
		238,
		217,
		228,
		233,
		179,
		176,
		196,
		215,
		221,
		213,
		253,
		209,
		180,
		174,
		192,
		197,
		215,
		207,
		-1,
		180,
		170,
		192,
		196,
		208,
		191,
		-1,
		-1,
		174,
		175,
		181,
		193,
		198,
		203,
		-1,
		226,
		210,
		-1,
		-1,
		164,
		177,
		173,
		176,
		184,
		200,
		218,
		210,
		205,
		-1,
		-1,
		165,
		169,
		182,
		183,
		181,
		205,
		218,
		200,
		214,
		213,
		-1,
		153,
		171,
		180,
		189,
		195,
		181,
		179,
		197,
		199,
		205,
		208,
		-1,
		145,
		147,
		176,
		182,
		194,
		197,
		184,
		184,
		194,
		187,
		206,
		197,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		142,
		150,
		176,
		175,
		171,
		189,
		194,
		187,
		184,
		182,
		179,
		195,
		196,
		206,
		-1,
		-1,
		198,
		167,
		202,
		159,
		144,
		-1,
		138,
		157,
		163,
		167,
		172,
		177,
		191,
		187,
		-1,
		173,
		172,
		203,
		189,
		200,
		158,
		-1,
		-1,
		156,
		148,
		133,
		136,
		133,
		133,
		163,
		162,
		167,
		169,
		168,
		174,
		177,
		177,
		183,
		167,
		177,
		181,
		192,
		207,
		-1,
		-1,
		262,
		-1,
		-1,
		155,
		138,
		-1,
		121,
		128,
		128,
		145,
		135,
		156,
		171,
		175,
		183,
		182,
		170,
		172,
		169,
		182,
		170,
		164,
		189,
		193,
		187,
		208,
		203,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		114,
		117,
		123,
		147,
		157,
		-1,
		178,
		176,
		200,
		191,
		188,
		175,
		163,
		176,
		161,
		168,
		167,
		171,
		173,
		206,
		184,
		206,
		203,
		232,
		237,
		231,
		240,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		151,
		-1,
		165,
		178,
		182,
		180,
		183,
		192,
		183,
		170,
		159,
		170,
		159,
		156,
		164,
		173,
		184,
		179,
		178,
		196,
		211,
		224,
		228,
		234,
		-1,
		213,
		-1,
		155,
		139,
		141,
		113,
		134,
		-1,
		171,
		166,
		186,
		184,
		175,
		-1,
		178,
		181,
		188,
		166,
		151,
		168,
		160,
		158,
		163,
		168,
		182,
		173,
		191,
		198,
		206,
		210,
		230,
		242,
		173,
		163,
		-1,
		145,
		150,
		109,
		117,
		136,
		209,
		181,
		-1,
		176,
		-1,
		168,
		193,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		167,
		164,
		161,
		179,
		182,
		199,
		203,
		219,
		-1,
		-1,
		158,
		162,
		151,
		102,
		121,
		145,
		182,
		174,
		163,
		162,
		-1,
		153,
		183,
		180,
		166,
		153,
		143,
		144,
		152,
		165,
		144,
		163,
		166,
		188,
		216,
		194,
		206,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		128,
		99,
		123,
		165,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		173,
		156,
		152,
		141,
		139,
		152,
		147,
		163,
		167,
		166,
		185,
		197,
		188,
		208,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		94,
		117,
		154,
		171,
		157,
		162,
		137,
		130,
		124,
		176,
		173,
		140,
		148,
		140,
		129,
		143,
		151,
		155,
		164,
		173,
		179,
		203,
		203,
		209,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		108,
		115,
		147,
		162,
		159,
		-1,
		129,
		-1,
		118,
		126,
		125,
		131,
		143,
		129,
		134,
		145,
		157,
		170,
		166,
		173,
		208,
		208,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		158,
		153,
		128,
		105,
		89,
		125,
		-1,
		129,
		130,
		-1,
		123,
		117,
		123,
		122,
		129,
		126,
		126,
		140,
		148,
		144,
		160,
		166,
		158,
		194,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		84,
		136,
		-1,
		-1,
		114,
		107,
		-1,
		110,
		110,
		117,
		126,
		131,
		136,
		144,
		139,
		152,
		157,
		163,
		168,
		186,
		190,
		194,
		183,
		179,
		176,
		190,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		104,
		-1,
		123,
		115,
		105,
		99,
		105,
		123,
		121,
		141,
		133,
		147,
		147,
		153,
		161,
		146,
		149,
		165,
		163,
		181,
		189,
		181,
		175,
		174,
		186,
		-1,
		150,
		136,
		107,
		-1,
		-1,
		117,
		-1,
		81,
		105,
		121,
		-1,
		139,
		118,
		141,
		119,
		133,
		129,
		167,
		168,
		146,
		151,
		159,
		169,
		171,
		160,
		171,
		163,
		185,
		185,
		169,
		170,
		179,
		-1,
		156,
		143,
		101,
		96,
		85,
		98,
		78,
		87,
		108,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		143,
		141,
		157,
		148,
		154,
		170,
		173,
		175,
		165,
		154,
		160,
		157,
		179,
		165,
		163,
		182,
		198,
		-1,
		-1,
		-1,
		0,
		-1,
		-1,
		64,
		74,
		74,
		-1,
		125,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		165,
		149,
		154,
		-1,
		200,
		-1,
		173,
		175,
		169,
		154,
		151,
		162,
		160,
		171,
		188,
		-1,
		57,
		42,
		35,
		45,
		103,
		74,
		-1,
		130,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		181,
		161,
		155,
		154,
		195,
		195,
		181,
		167,
		160,
		157,
		154,
		167,
		187,
		178,
		190,
		-1,
		-1,
		-1,
		65,
		118,
		117,
		82,
		96,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		198,
		186,
		176,
		166,
		200,
		201,
		186,
		179,
		165,
		167,
		165,
		163,
		168,
		189,
		190,
		203,
		-1,
		-1,
		115,
		115,
		103,
		89,
		108,
		-1,
		-1,
		-1,
		157,
		173,
		165,
		136,
		187,
		-1,
		-1,
		178,
		176,
		186,
		182,
		169,
		189,
		192,
		178,
		162,
		177,
		189,
		197,
		202,
		-1,
		118,
		105,
		-1,
		-1,
		111,
		105,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		168,
		189,
		214,
		181,
		-1,
		186,
		187,
		173,
		187,
		194,
		180,
		175,
		169,
		172,
		190,
		207,
		-1,
		-1,
		125,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		147,
		161,
		182,
		188,
		200,
		-1,
		195,
		189,
		175,
		192,
		193,
		190,
		181,
		173,
		178,
		175,
		188,
		202,
		206,
		148,
		-1,
		131,
		-1,
		-1,
		-1,
		165,
		180,
		242,
		219,
		192,
		196,
		189,
		183,
		183,
		199,
		201,
		212,
		180,
		176,
		177,
		181,
		180,
		197,
		207,
		-1,
		-1,
		131,
		148,
		183,
		173,
		177,
		269,
		-1,
		-1,
		205,
		196,
		187,
		190,
		193,
		196,
		186,
		183,
		188,
		193,
		181,
		190,
		208,
		212,
		-1,
		-1,
		-1,
		151,
		-1,
		166,
		-1,
		-1,
		192,
		276,
		223,
		205,
		201,
		199,
		192,
		201,
		196,
		191,
		201,
		210,
		202,
		183,
		194,
		217,
		206,
		244,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		180,
		155,
		170,
		216,
		212,
		212,
		238,
		235,
		-1,
		205,
		230,
		202,
		209,
		201,
		209,
		209,
		206,
		184,
		191,
		207,
		206,
		201,
		236,
		228,
		234,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		186,
		172,
		202,
		192,
		198,
		-1,
		-1,
		245,
		242,
		227,
		211,
		215,
		208,
		203,
		213,
		193,
		180,
		184,
		188,
		194,
		199,
		204,
		210,
		225,
		240,
		-1,
		163,
		244,
		237,
		220,
		228,
		259,
		-1,
		189,
		198,
		179,
		184,
		192,
		-1,
		-1,
		218,
		214,
		219,
		218,
		215,
		223,
		218,
		209,
		194,
		200,
		187,
		186,
		204,
		208,
		217,
		224,
		214,
		227,
		231,
		-1,
		177,
		220,
		214,
		217,
		241,
		255,
		-1,
		202,
		-1,
		-1,
		187,
		205,
		213,
		209,
		213,
		266,
		232,
		227,
		217,
		215,
		206,
		197,
		204,
		195,
		195,
		198,
		213,
		218,
		210,
		224,
		224,
		225,
		-1,
		212,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		203,
		-1,
		239,
		-1,
		232,
		236,
		240,
		243,
		231,
		218,
		210,
		202,
		218,
		193,
		203,
		199,
		200,
		209,
		220,
		232,
		231,
		232,
		286,
		241,
		208,
		199,
		246,
		261,
		265,
		-1,
		215,
		254,
		241,
		-1,
		212,
		-1,
		-1,
		-1,
		246,
		253,
		245,
		251,
		230,
		230,
		204,
		208,
		198,
		205,
		215,
		217,
		209,
		213,
		226,
		237,
		240,
		282,
		280,
		285,
		230,
		213,
		231,
		240,
		261,
		230,
		221,
		248,
		248,
		237,
		232,
		219,
		-1,
		-1,
		269,
		263,
		-1,
		-1,
		237,
		225,
		208,
		209,
		205,
		208,
		223,
		226,
		216,
		214,
		208,
		240,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		221,
		232,
		-1,
		-1,
		233,
		249,
		262,
		266,
		279,
		304,
		-1,
		222,
		-1,
		-1,
		282,
		-1,
		-1,
		267,
		230,
		219,
		210,
		216,
		213,
		224,
		234,
		222,
		223,
		213,
		223,
		236,
		266,
		263,
		251,
		249,
		272,
		229,
		225,
		-1,
		248,
		236,
		242,
		249,
		266,
		293,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		265,
		263,
		252,
		-1,
		242,
		215,
		220,
		240,
		242,
		231,
		225,
		219,
		226,
		225,
		233,
		241,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		247,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		-1,
		273,
		248,
		-1,
		-1,
		260,
		253,
		241,
		229,
		219,
		229,
		233,
		237,
		229,
		222,
		217,
		228,
		220,
		224,
		241,
		-1,
		309,
		-1,
		261,
		254,
		269,
		284,
		292,
		-1,
		-1,
		-1,
		290,
		276,
		269,
		257,
		255,
		-1,
		294,
		278,
		259,
		-1,
		229,
		242,
		273,
		241,
		246,
		241,
		223,
		234,
		223,
		226,
		240,
		235,
		-1,
		-1,
		267,
		270,
		-1,
		-1,
		292,
		311,
		-1,
		281,
		270,
		255,
		247,
		-1,
		-1,
		266,
		262,
		-1,
		-1,
		230,
		255,
		244,
		252,
		247,
		227,
		233,
		236,
		225,
		229,
		241,
		-1,
		-1,
		274,
		275,
		280,
		-1,
		295,
		-1,
		305,
		-1,
		250,
		266,
		268,
		-1,
		-1,
		-1,
		268,
		231,
		252,
		262,
		256,
		254,
		245,
		231,
		238,
		236,
		232,
		243,
		-1,
		-1,
		-1,
		313,
		287,
		312,
		303,
		286,
		266,
		258,
		283,
		-1,
		255,
		-1,
		230,
		232,
		258,
		261,
		267,
		261,
		234,
		249,
		239,
		230,
		239,
		319,
		-1,
		289,
		322,
		286,
		272,
		256,
		260,
		276,
		-1,
		252,
		234,
		-1,
		262,
		252,
		283,
		268,
		249,
		236,
		243,
		243,
		236,
		-1,
		-1,
		-1,
		291,
		290,
		282,
		276,
		276,
		261,
		252,
		-1,
		264,
		246,
		225,
		242,
		242,
		233,
		241,
		273,
		269,
		256,
		256,
		248,
		-1,
		381,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		285,
		280,
		253,
		241,
		247,
		243,
		229,
		235,
		237,
		245,
		243,
		240,
		252,
		248,
		268,
		249,
		284,
		-1,
		387,
		-1,
		321,
		-1,
		-1,
		303,
		283,
		275,
		264,
		253,
		251,
		242,
		233,
		255,
		271,
		255,
		253,
		256,
		257,
		-1,
		376,
		375,
		-1,
		322,
		314,
		300,
		-1,
		293,
		-1,
		299,
		260,
		-1,
		262,
		242,
		-1,
		264,
		260,
		-1,
		-1,
		363,
		338,
		-1,
		-1,
		-1,
		323,
		303,
		294,
		278,
		-1,
		253,
		253,
		-1,
		-1,
		-1,
		348,
		347,
		-1,
		316,
		319,
		-1,
		309,
		300,
		308,
		255,
		259,
		-1,
		-1,
		-1,
		357,
		338,
		332,
		331,
		329,
		324,
		321,
		307,
		291,
		269,
		258,
		279,
		-1,
		-1,
		-1,
		329,
		321,
		314,
		-1,
		-1,
		316,
		299,
		280,
		278,
		-1,
		-1,
		-1,
		351,
		332,
		-1,
		-1,
		306,
		-1,
		-1,
		312,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		368,
		340,
		-1,
		-1,
		-1,
		302,
		298,
		299,
		-1,
		-1,
		-1,
		-1,
		362,
		363,
		386,
		350,
		-1,
		-1,
		-1,
		294,
		288,
		-1,
		-1,
		365,
		363,
		-1,
		-1,
		-1,
		322,
		306,
		-1,
		292,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		325,
		-1,
		-1,
		-1,
		327,
		-1,
		327,
		302,
		309,
		-1,
		-1,
		-1,
		-1,
		340,
		332,
		340,
		-1,
		312,
		314,
		-1,
		362,
		-1,
		-1,
		355,
		346,
		-1,
		-1,
		317,
		324,
		346,
		349,
		385,
		-1,
		336
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		167,
		156,
		167,
		175,
		148,
		155,
		-1,
		176,
		178,
		144,
		138,
		177,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		167,
		166,
		136,
		134,
		143,
		148,
		155,
		-1,
		178,
		-1,
		188,
		167,
		178,
		183,
		129,
		126,
		146,
		165,
		171,
		163,
		203,
		159,
		130,
		124,
		142,
		147,
		165,
		157,
		-1,
		130,
		120,
		142,
		146,
		158,
		141,
		-1,
		-1,
		124,
		125,
		131,
		143,
		148,
		153,
		-1,
		176,
		160,
		-1,
		-1,
		114,
		127,
		123,
		126,
		134,
		150,
		168,
		160,
		155,
		-1,
		-1,
		115,
		119,
		132,
		133,
		131,
		155,
		168,
		150,
		164,
		163,
		-1,
		103,
		121,
		130,
		139,
		145,
		131,
		129,
		147,
		149,
		155,
		158,
		-1,
		95,
		97,
		126,
		132,
		144,
		147,
		134,
		134,
		144,
		137,
		156,
		147,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		100,
		126,
		125,
		121,
		139,
		144,
		137,
		134,
		132,
		129,
		145,
		146,
		156,
		-1,
		-1,
		148,
		117,
		152,
		109,
		94,
		-1,
		88,
		107,
		113,
		117,
		122,
		127,
		141,
		137,
		-1,
		123,
		122,
		153,
		139,
		150,
		108,
		-1,
		-1,
		106,
		98,
		83,
		86,
		83,
		83,
		113,
		112,
		117,
		119,
		118,
		124,
		127,
		127,
		133,
		117,
		127,
		131,
		142,
		157,
		-1,
		-1,
		212,
		-1,
		-1,
		105,
		88,
		-1,
		71,
		78,
		78,
		95,
		85,
		106,
		121,
		125,
		133,
		132,
		120,
		122,
		119,
		132,
		120,
		114,
		139,
		143,
		137,
		158,
		153,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		64,
		67,
		73,
		97,
		107,
		-1,
		128,
		126,
		150,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		121,
		123,
		156,
		134,
		156,
		153,
		182,
		187,
		181,
		190,
		-1,
		113,
		109,
		105,
		112,
		61,
		-1,
		-1,
		101,
		-1,
		115,
		128,
		132,
		130,
		133,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		123,
		134,
		129,
		128,
		146,
		161,
		174,
		178,
		184,
		-1,
		163,
		-1,
		105,
		89,
		91,
		63,
		84,
		-1,
		121,
		116,
		136,
		134,
		125,
		-1,
		128,
		131,
		138,
		116,
		101,
		118,
		110,
		108,
		113,
		118,
		132,
		123,
		141,
		148,
		156,
		160,
		180,
		192,
		123,
		113,
		-1,
		95,
		100,
		59,
		67,
		86,
		159,
		131,
		-1,
		126,
		-1,
		118,
		143,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		117,
		114,
		111,
		129,
		132,
		149,
		153,
		169,
		-1,
		-1,
		108,
		112,
		101,
		52,
		71,
		95,
		132,
		124,
		113,
		112,
		-1,
		103,
		133,
		130,
		116,
		103,
		93,
		94,
		102,
		115,
		94,
		113,
		116,
		138,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		78,
		49,
		73,
		115,
		142,
		135,
		123,
		88,
		88,
		82,
		-1,
		123,
		106,
		102,
		91,
		89,
		102,
		97,
		113,
		117,
		116,
		135,
		147,
		138,
		158,
		-1,
		-1,
		-1,
		108,
		97,
		98,
		44,
		67,
		104,
		121,
		107,
		112,
		87,
		80,
		74,
		126,
		123,
		90,
		98,
		90,
		79,
		93,
		101,
		105,
		114,
		123,
		129,
		153,
		153,
		159,
		-1,
		-1,
		115,
		105,
		89,
		91,
		88,
		58,
		65,
		97,
		112,
		109,
		-1,
		79,
		-1,
		68,
		76,
		75,
		81,
		93,
		79,
		84,
		95,
		107,
		120,
		116,
		123,
		158,
		158,
		143,
		163,
		166,
		-1,
		-1,
		-1,
		108,
		103,
		78,
		55,
		39,
		75,
		-1,
		79,
		80,
		-1,
		73,
		67,
		73,
		72,
		79,
		76,
		76,
		90,
		98,
		94,
		110,
		116,
		108,
		144,
		-1,
		151,
		145,
		153,
		143,
		131,
		-1,
		-1,
		-1,
		101,
		80,
		73,
		93,
		34,
		86,
		-1,
		-1,
		64,
		57,
		-1,
		60,
		60,
		67,
		76,
		81,
		86,
		94,
		89,
		102,
		107,
		113,
		118,
		136,
		140,
		144,
		133,
		129,
		126,
		140,
		-1,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		34,
		54,
		-1,
		73,
		65,
		55,
		49,
		55,
		73,
		71,
		91,
		83,
		97,
		97,
		103,
		111,
		96,
		99,
		115,
		113,
		131,
		139,
		131,
		125,
		124,
		136,
		-1,
		100,
		86,
		57,
		-1,
		-1,
		67,
		-1,
		31,
		55,
		71,
		-1,
		89,
		68,
		91,
		69,
		83,
		79,
		117,
		118,
		96,
		101,
		109,
		119,
		121,
		110,
		121,
		113,
		135,
		135,
		119,
		120,
		129,
		-1,
		106,
		93,
		51,
		46,
		35,
		34,
		28,
		37,
		58,
		-1,
		-1,
		133,
		-1,
		67,
		84,
		93,
		91,
		107,
		98,
		104,
		120,
		123,
		125,
		115,
		104,
		110,
		107,
		129,
		115,
		113,
		132,
		148,
		-1,
		-1,
		-1,
		65,
		-1,
		-1,
		0,
		24,
		24,
		-1,
		75,
		-1,
		111,
		101,
		85,
		70,
		103,
		-1,
		115,
		99,
		104,
		-1,
		150,
		-1,
		123,
		125,
		119,
		104,
		101,
		112,
		110,
		121,
		138,
		-1,
		48,
		33,
		26,
		16,
		53,
		24,
		-1,
		80,
		-1,
		-1,
		98,
		92,
		92,
		76,
		79,
		131,
		111,
		105,
		104,
		145,
		145,
		131,
		117,
		110,
		107,
		104,
		117,
		137,
		128,
		140,
		-1,
		-1,
		-1,
		53,
		68,
		67,
		32,
		46,
		-1,
		-1,
		160,
		115,
		101,
		-1,
		85,
		148,
		136,
		126,
		116,
		150,
		151,
		136,
		129,
		115,
		117,
		115,
		113,
		118,
		139,
		140,
		153,
		-1,
		-1,
		65,
		65,
		53,
		39,
		58,
		-1,
		-1,
		-1,
		107,
		123,
		115,
		86,
		137,
		-1,
		-1,
		128,
		126,
		136,
		132,
		119,
		139,
		142,
		128,
		112,
		127,
		139,
		147,
		152,
		-1,
		68,
		55,
		-1,
		-1,
		61,
		55,
		-1,
		-1,
		-1,
		-1,
		140,
		106,
		118,
		139,
		164,
		131,
		-1,
		136,
		137,
		123,
		137,
		144,
		130,
		125,
		119,
		122,
		140,
		157,
		-1,
		-1,
		75,
		-1,
		70,
		-1,
		-1,
		-1,
		-1,
		97,
		111,
		132,
		138,
		150,
		-1,
		145,
		139,
		125,
		142,
		143,
		140,
		131,
		123,
		128,
		125,
		138,
		152,
		156,
		98,
		-1,
		81,
		-1,
		-1,
		-1,
		115,
		130,
		192,
		169,
		142,
		146,
		139,
		133,
		133,
		149,
		151,
		162,
		130,
		126,
		127,
		131,
		130,
		147,
		157,
		-1,
		-1,
		81,
		98,
		133,
		123,
		127,
		219,
		-1,
		-1,
		155,
		146,
		137,
		140,
		143,
		146,
		136,
		133,
		138,
		143,
		131,
		140,
		158,
		162,
		-1,
		-1,
		-1,
		101,
		-1,
		116,
		-1,
		-1,
		142,
		226,
		173,
		155,
		151,
		149,
		142,
		151,
		146,
		141,
		151,
		160,
		152,
		133,
		144,
		167,
		156,
		194,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		130,
		105,
		120,
		166,
		162,
		162,
		188,
		185,
		-1,
		155,
		180,
		152,
		159,
		151,
		159,
		159,
		156,
		134,
		141,
		157,
		156,
		151,
		186,
		178,
		184,
		-1,
		-1,
		218,
		207,
		196,
		202,
		-1,
		136,
		122,
		152,
		142,
		148,
		-1,
		-1,
		195,
		192,
		177,
		161,
		165,
		158,
		153,
		163,
		143,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		113,
		194,
		187,
		170,
		178,
		209,
		-1,
		139,
		148,
		129,
		134,
		142,
		-1,
		-1,
		168,
		164,
		169,
		168,
		165,
		173,
		168,
		159,
		144,
		150,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		127,
		170,
		164,
		167,
		191,
		205,
		-1,
		152,
		-1,
		-1,
		137,
		155,
		163,
		159,
		163,
		216,
		182,
		177,
		167,
		165,
		156,
		147,
		154,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		162,
		150,
		158,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		153,
		-1,
		189,
		-1,
		182,
		186,
		190,
		193,
		181,
		168,
		160,
		152,
		168,
		143,
		153,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		236,
		191,
		158,
		149,
		196,
		211,
		215,
		-1,
		165,
		204,
		191,
		-1,
		162,
		-1,
		-1,
		-1,
		196,
		203,
		195,
		201,
		180,
		180,
		154,
		158,
		148,
		155,
		165,
		167,
		159,
		163,
		176,
		187,
		190,
		232,
		230,
		235,
		180,
		163,
		181,
		190,
		211,
		180,
		171,
		198,
		198,
		187,
		182,
		169,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		187,
		175,
		158,
		159,
		155,
		158,
		173,
		176,
		166,
		164,
		158,
		190,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		171,
		182,
		-1,
		-1,
		183,
		199,
		212,
		216,
		229,
		254,
		-1,
		172,
		-1,
		-1,
		232,
		-1,
		-1,
		217,
		180,
		169,
		160,
		166,
		163,
		174,
		184,
		172,
		173,
		163,
		173,
		186,
		216,
		213,
		201,
		199,
		222,
		179,
		175,
		-1,
		198,
		186,
		192,
		199,
		216,
		243,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		215,
		213,
		202,
		-1,
		192,
		165,
		170,
		190,
		192,
		181,
		175,
		169,
		176,
		175,
		183,
		191,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		197,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		-1,
		223,
		198,
		-1,
		-1,
		210,
		203,
		191,
		179,
		169,
		179,
		183,
		187,
		179,
		172,
		167,
		178,
		170,
		174,
		191,
		-1,
		259,
		-1,
		211,
		204,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		240,
		226,
		219,
		207,
		205,
		-1,
		244,
		228,
		209,
		-1,
		179,
		192,
		223,
		191,
		196,
		191,
		173,
		184,
		173,
		176,
		190,
		185,
		-1,
		-1,
		217,
		220,
		-1,
		-1,
		242,
		261,
		-1,
		231,
		220,
		205,
		197,
		-1,
		-1,
		216,
		212,
		-1,
		-1,
		180,
		205,
		194,
		202,
		197,
		177,
		183,
		186,
		175,
		179,
		191,
		-1,
		-1,
		224,
		225,
		230,
		-1,
		245,
		-1,
		255,
		-1,
		200,
		216,
		218,
		-1,
		-1,
		-1,
		218,
		181,
		202,
		212,
		206,
		204,
		195,
		181,
		188,
		186,
		182,
		193,
		-1,
		-1,
		-1,
		263,
		237,
		262,
		253,
		236,
		216,
		208,
		233,
		-1,
		205,
		-1,
		180,
		182,
		208,
		211,
		217,
		211,
		184,
		199,
		189,
		180,
		189,
		269,
		-1,
		239,
		272,
		236,
		222,
		206,
		210,
		226,
		-1,
		202,
		184,
		-1,
		212,
		202,
		233,
		218,
		199,
		186,
		193,
		193,
		186,
		-1,
		-1,
		-1,
		241,
		240,
		232,
		226,
		226,
		211,
		202,
		-1,
		214,
		196,
		175,
		192,
		192,
		183,
		191,
		223,
		219,
		206,
		206,
		198,
		-1,
		331,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		235,
		230,
		203,
		191,
		197,
		193,
		179,
		185,
		187,
		195,
		193,
		190,
		202,
		198,
		218,
		199,
		234,
		-1,
		337,
		-1,
		271,
		-1,
		-1,
		253,
		233,
		225,
		214,
		203,
		201,
		192,
		183,
		205,
		221,
		205,
		203,
		206,
		207,
		-1,
		326,
		325,
		-1,
		272,
		264,
		250,
		-1,
		243,
		-1,
		249,
		210,
		-1,
		212,
		192,
		-1,
		214,
		210,
		-1,
		-1,
		313,
		288,
		-1,
		-1,
		-1,
		273,
		253,
		244,
		228,
		-1,
		203,
		203,
		-1,
		-1,
		-1,
		298,
		297,
		-1,
		266,
		269,
		-1,
		259,
		250,
		258,
		205,
		209,
		-1,
		-1,
		-1,
		307,
		288,
		282,
		281,
		279,
		274,
		271,
		257,
		241,
		219,
		208,
		229,
		-1,
		-1,
		-1,
		279,
		271,
		264,
		-1,
		-1,
		266,
		249,
		230,
		228,
		-1,
		-1,
		-1,
		301,
		282,
		-1,
		-1,
		256,
		-1,
		-1,
		262,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		318,
		290,
		-1,
		-1,
		-1,
		252,
		248,
		249,
		-1,
		-1,
		-1,
		-1,
		312,
		313,
		336,
		300,
		-1,
		-1,
		-1,
		244,
		238,
		-1,
		-1,
		315,
		313,
		-1,
		-1,
		-1,
		272,
		256,
		-1,
		242,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		277,
		-1,
		277,
		252,
		259,
		-1,
		-1,
		-1,
		-1,
		290,
		282,
		290,
		-1,
		262,
		264,
		-1,
		312,
		-1,
		-1,
		305,
		296,
		-1,
		-1,
		267,
		274,
		296,
		299,
		335,
		-1,
		286
	],
	[
		-1,
		153,
		142,
		153,
		161,
		134,
		141,
		-1,
		162,
		164,
		130,
		124,
		163,
		134,
		140,
		151,
		-1,
		-1,
		-1,
		153,
		152,
		122,
		120,
		129,
		134,
		141,
		-1,
		164,
		-1,
		174,
		153,
		164,
		169,
		115,
		112,
		132,
		151,
		157,
		149,
		189,
		145,
		116,
		110,
		128,
		133,
		151,
		143,
		-1,
		116,
		106,
		128,
		132,
		144,
		127,
		-1,
		-1,
		110,
		111,
		117,
		129,
		134,
		139,
		-1,
		162,
		146,
		-1,
		-1,
		100,
		113,
		109,
		112,
		120,
		136,
		154,
		146,
		141,
		-1,
		-1,
		101,
		105,
		118,
		119,
		117,
		141,
		154,
		136,
		150,
		149,
		-1,
		89,
		107,
		116,
		125,
		131,
		117,
		115,
		133,
		135,
		141,
		144,
		-1,
		81,
		83,
		112,
		118,
		130,
		133,
		120,
		120,
		130,
		123,
		142,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		78,
		86,
		112,
		111,
		107,
		125,
		130,
		123,
		120,
		118,
		115,
		131,
		132,
		142,
		-1,
		-1,
		134,
		103,
		138,
		95,
		80,
		-1,
		74,
		93,
		99,
		103,
		108,
		113,
		127,
		123,
		-1,
		109,
		108,
		139,
		125,
		136,
		94,
		-1,
		-1,
		92,
		84,
		69,
		72,
		69,
		69,
		99,
		98,
		103,
		105,
		104,
		110,
		113,
		113,
		119,
		103,
		113,
		117,
		128,
		143,
		-1,
		-1,
		198,
		-1,
		-1,
		91,
		74,
		-1,
		57,
		64,
		64,
		81,
		71,
		92,
		107,
		111,
		119,
		118,
		106,
		108,
		105,
		118,
		106,
		100,
		125,
		129,
		123,
		144,
		139,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		50,
		53,
		59,
		83,
		93,
		-1,
		114,
		112,
		136,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		107,
		109,
		142,
		120,
		142,
		139,
		168,
		173,
		167,
		176,
		-1,
		99,
		95,
		91,
		98,
		47,
		-1,
		-1,
		87,
		-1,
		101,
		114,
		118,
		116,
		119,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		109,
		120,
		115,
		114,
		132,
		147,
		160,
		164,
		170,
		-1,
		149,
		-1,
		91,
		75,
		77,
		49,
		70,
		-1,
		107,
		102,
		122,
		120,
		111,
		-1,
		114,
		117,
		124,
		102,
		87,
		104,
		96,
		94,
		99,
		104,
		118,
		109,
		127,
		134,
		142,
		146,
		166,
		178,
		109,
		99,
		-1,
		81,
		86,
		45,
		53,
		72,
		145,
		117,
		-1,
		112,
		-1,
		104,
		129,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		103,
		100,
		97,
		115,
		118,
		135,
		139,
		155,
		-1,
		-1,
		94,
		98,
		87,
		38,
		57,
		81,
		118,
		110,
		99,
		98,
		-1,
		89,
		119,
		116,
		102,
		89,
		79,
		80,
		88,
		101,
		80,
		99,
		102,
		124,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		64,
		35,
		59,
		101,
		128,
		121,
		109,
		74,
		74,
		68,
		-1,
		109,
		92,
		88,
		77,
		75,
		88,
		83,
		99,
		103,
		102,
		121,
		133,
		124,
		144,
		-1,
		-1,
		-1,
		94,
		83,
		84,
		30,
		53,
		90,
		107,
		93,
		98,
		73,
		66,
		60,
		112,
		109,
		76,
		84,
		76,
		65,
		79,
		87,
		91,
		100,
		109,
		115,
		139,
		139,
		145,
		-1,
		-1,
		101,
		91,
		75,
		77,
		74,
		44,
		51,
		83,
		98,
		95,
		-1,
		65,
		-1,
		54,
		62,
		61,
		67,
		79,
		65,
		70,
		81,
		93,
		106,
		102,
		109,
		144,
		144,
		129,
		149,
		152,
		-1,
		-1,
		-1,
		94,
		89,
		64,
		41,
		25,
		61,
		-1,
		65,
		66,
		-1,
		59,
		53,
		59,
		58,
		65,
		62,
		62,
		76,
		84,
		80,
		96,
		102,
		94,
		130,
		-1,
		137,
		131,
		139,
		129,
		117,
		-1,
		-1,
		-1,
		87,
		66,
		59,
		79,
		20,
		72,
		-1,
		-1,
		50,
		43,
		-1,
		46,
		46,
		53,
		62,
		67,
		72,
		80,
		75,
		88,
		93,
		99,
		104,
		122,
		126,
		130,
		119,
		115,
		112,
		126,
		-1,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		20,
		40,
		-1,
		59,
		51,
		41,
		35,
		41,
		59,
		57,
		77,
		69,
		83,
		83,
		89,
		97,
		82,
		85,
		101,
		99,
		117,
		125,
		117,
		111,
		110,
		122,
		-1,
		104,
		90,
		61,
		-1,
		-1,
		53,
		-1,
		17,
		41,
		57,
		-1,
		75,
		54,
		77,
		55,
		69,
		65,
		103,
		104,
		82,
		87,
		95,
		105,
		107,
		96,
		107,
		99,
		121,
		121,
		105,
		106,
		115,
		-1,
		110,
		97,
		55,
		50,
		39,
		55,
		14,
		23,
		44,
		-1,
		-1,
		119,
		-1,
		53,
		70,
		79,
		77,
		93,
		84,
		90,
		106,
		109,
		111,
		101,
		90,
		96,
		93,
		115,
		101,
		99,
		118,
		134,
		-1,
		-1,
		-1,
		74,
		-1,
		-1,
		23,
		0,
		10,
		-1,
		61,
		-1,
		97,
		87,
		71,
		56,
		89,
		-1,
		101,
		85,
		90,
		-1,
		136,
		-1,
		109,
		111,
		105,
		90,
		87,
		98,
		96,
		107,
		124,
		-1,
		57,
		42,
		35,
		25,
		30,
		7,
		-1,
		63,
		-1,
		-1,
		84,
		78,
		78,
		62,
		65,
		117,
		97,
		91,
		90,
		131,
		131,
		117,
		103,
		96,
		93,
		90,
		103,
		123,
		114,
		126,
		-1,
		-1,
		-1,
		62,
		54,
		50,
		18,
		29,
		-1,
		-1,
		146,
		101,
		87,
		-1,
		71,
		134,
		122,
		112,
		102,
		136,
		137,
		122,
		115,
		101,
		103,
		101,
		99,
		104,
		125,
		126,
		139,
		-1,
		-1,
		51,
		48,
		36,
		22,
		41,
		-1,
		-1,
		-1,
		93,
		109,
		101,
		72,
		123,
		-1,
		-1,
		114,
		112,
		122,
		118,
		105,
		125,
		128,
		114,
		98,
		113,
		125,
		133,
		138,
		-1,
		54,
		41,
		-1,
		-1,
		44,
		38,
		-1,
		-1,
		-1,
		-1,
		126,
		92,
		104,
		125,
		150,
		117,
		-1,
		122,
		123,
		109,
		123,
		130,
		116,
		111,
		105,
		108,
		126,
		143,
		-1,
		-1,
		58,
		-1,
		53,
		-1,
		-1,
		-1,
		-1,
		83,
		97,
		118,
		124,
		136,
		-1,
		131,
		125,
		111,
		128,
		129,
		126,
		117,
		109,
		114,
		111,
		124,
		138,
		142,
		81,
		-1,
		64,
		-1,
		-1,
		-1,
		101,
		116,
		178,
		155,
		128,
		132,
		125,
		119,
		119,
		135,
		137,
		148,
		116,
		112,
		113,
		117,
		116,
		133,
		143,
		-1,
		-1,
		64,
		81,
		116,
		109,
		113,
		205,
		-1,
		-1,
		141,
		132,
		123,
		126,
		129,
		132,
		122,
		119,
		124,
		129,
		117,
		126,
		144,
		148,
		-1,
		-1,
		-1,
		84,
		-1,
		99,
		-1,
		-1,
		128,
		212,
		159,
		141,
		137,
		135,
		128,
		137,
		132,
		127,
		137,
		146,
		138,
		119,
		130,
		153,
		142,
		180,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		113,
		88,
		103,
		149,
		148,
		145,
		174,
		171,
		-1,
		141,
		166,
		138,
		145,
		137,
		145,
		145,
		142,
		120,
		127,
		143,
		142,
		137,
		172,
		164,
		170,
		-1,
		-1,
		204,
		193,
		182,
		188,
		-1,
		119,
		105,
		135,
		125,
		131,
		-1,
		-1,
		178,
		175,
		163,
		147,
		151,
		144,
		139,
		149,
		129,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		99,
		180,
		173,
		156,
		164,
		195,
		-1,
		122,
		131,
		112,
		117,
		125,
		-1,
		-1,
		151,
		147,
		152,
		154,
		151,
		159,
		154,
		145,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		113,
		156,
		150,
		153,
		177,
		191,
		-1,
		135,
		-1,
		-1,
		120,
		138,
		146,
		142,
		146,
		199,
		168,
		163,
		153,
		151,
		142,
		133,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		148,
		136,
		144,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		136,
		-1,
		172,
		-1,
		165,
		169,
		176,
		179,
		167,
		154,
		146,
		138,
		154,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		222,
		177,
		144,
		135,
		182,
		197,
		201,
		-1,
		148,
		187,
		174,
		-1,
		145,
		-1,
		-1,
		-1,
		179,
		189,
		181,
		187,
		166,
		166,
		140,
		144,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		218,
		216,
		221,
		166,
		149,
		167,
		176,
		197,
		163,
		154,
		181,
		181,
		170,
		165,
		152,
		-1,
		-1,
		202,
		199,
		-1,
		-1,
		173,
		161,
		144,
		145,
		141,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		157,
		168,
		-1,
		-1,
		166,
		182,
		195,
		199,
		212,
		237,
		-1,
		155,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		149,
		160,
		170,
		158,
		159,
		149,
		159,
		172,
		202,
		199,
		187,
		185,
		208,
		165,
		161,
		-1,
		181,
		169,
		175,
		182,
		199,
		226,
		-1,
		-1,
		171,
		162,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		151,
		156,
		176,
		178,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		181,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		169,
		173,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		245,
		-1,
		197,
		190,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		203,
		206,
		-1,
		-1,
		228,
		247,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		210,
		211,
		216,
		-1,
		231,
		-1,
		238,
		-1,
		183,
		199,
		201,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		249,
		223,
		245,
		236,
		219,
		199,
		191,
		216,
		-1,
		191,
		-1,
		166,
		168,
		194,
		197,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		255,
		-1,
		225,
		258,
		222,
		205,
		192,
		196,
		212,
		-1,
		188,
		170,
		-1,
		198,
		188,
		219,
		204,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		227,
		226,
		218,
		212,
		212,
		197,
		188,
		-1,
		200,
		182,
		161,
		178,
		178,
		169,
		177,
		209,
		205,
		192,
		192,
		184,
		-1,
		317,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		221,
		216,
		189,
		177,
		183,
		179,
		165,
		171,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		185,
		220,
		-1,
		323,
		-1,
		257,
		-1,
		-1,
		239,
		219,
		211,
		200,
		189,
		187,
		178,
		169,
		191,
		207,
		191,
		189,
		192,
		193,
		-1,
		312,
		311,
		-1,
		258,
		250,
		236,
		-1,
		229,
		-1,
		235,
		196,
		-1,
		198,
		178,
		-1,
		200,
		196,
		-1,
		-1,
		299,
		274,
		-1,
		-1,
		-1,
		259,
		239,
		230,
		214,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		284,
		283,
		-1,
		252,
		255,
		-1,
		245,
		236,
		244,
		191,
		195,
		-1,
		-1,
		-1,
		293,
		274,
		268,
		267,
		265,
		260,
		257,
		243,
		227,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		265,
		257,
		250,
		-1,
		-1,
		252,
		235,
		216,
		214,
		-1,
		-1,
		-1,
		287,
		268,
		-1,
		-1,
		242,
		-1,
		-1,
		248,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		276,
		-1,
		-1,
		-1,
		238,
		234,
		235,
		-1,
		-1,
		-1,
		-1,
		298,
		299,
		322,
		286,
		-1,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		301,
		299,
		-1,
		-1,
		-1,
		258,
		242,
		-1,
		228,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		263,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		276,
		268,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		291,
		282,
		-1,
		-1,
		253,
		260,
		282,
		285,
		321,
		-1,
		272
	],
	[
		-1,
		143,
		132,
		143,
		151,
		124,
		131,
		-1,
		152,
		154,
		120,
		114,
		153,
		124,
		130,
		141,
		-1,
		-1,
		-1,
		143,
		142,
		112,
		110,
		119,
		124,
		131,
		-1,
		154,
		-1,
		164,
		143,
		154,
		159,
		105,
		102,
		122,
		141,
		147,
		139,
		179,
		135,
		106,
		100,
		118,
		123,
		141,
		133,
		-1,
		106,
		96,
		118,
		122,
		134,
		117,
		-1,
		-1,
		100,
		101,
		107,
		119,
		124,
		129,
		-1,
		152,
		136,
		-1,
		-1,
		90,
		103,
		99,
		102,
		110,
		126,
		144,
		136,
		131,
		-1,
		-1,
		91,
		95,
		108,
		109,
		107,
		131,
		144,
		126,
		140,
		139,
		-1,
		79,
		97,
		106,
		115,
		121,
		107,
		105,
		123,
		125,
		131,
		134,
		-1,
		71,
		73,
		102,
		108,
		120,
		123,
		110,
		110,
		120,
		113,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		68,
		76,
		102,
		101,
		97,
		115,
		120,
		113,
		110,
		108,
		105,
		121,
		122,
		132,
		-1,
		-1,
		124,
		93,
		128,
		85,
		70,
		-1,
		64,
		83,
		89,
		93,
		98,
		103,
		117,
		113,
		-1,
		99,
		98,
		129,
		115,
		126,
		84,
		-1,
		-1,
		82,
		74,
		59,
		62,
		59,
		59,
		89,
		88,
		93,
		95,
		94,
		100,
		103,
		103,
		109,
		93,
		103,
		107,
		118,
		133,
		-1,
		-1,
		188,
		-1,
		-1,
		81,
		64,
		-1,
		47,
		54,
		54,
		71,
		61,
		82,
		97,
		101,
		109,
		108,
		96,
		98,
		95,
		108,
		96,
		90,
		115,
		119,
		113,
		134,
		129,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		40,
		43,
		49,
		73,
		83,
		-1,
		104,
		102,
		126,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		97,
		99,
		132,
		110,
		132,
		129,
		158,
		163,
		157,
		166,
		-1,
		89,
		85,
		81,
		88,
		37,
		-1,
		-1,
		77,
		-1,
		91,
		104,
		108,
		106,
		109,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		99,
		110,
		105,
		104,
		122,
		137,
		150,
		154,
		160,
		-1,
		139,
		-1,
		81,
		65,
		67,
		39,
		60,
		-1,
		97,
		92,
		112,
		110,
		101,
		-1,
		104,
		107,
		114,
		92,
		77,
		94,
		86,
		84,
		89,
		94,
		108,
		99,
		117,
		124,
		132,
		136,
		156,
		168,
		99,
		89,
		-1,
		71,
		76,
		35,
		43,
		62,
		135,
		107,
		-1,
		102,
		-1,
		94,
		119,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		93,
		90,
		87,
		105,
		108,
		125,
		129,
		145,
		-1,
		-1,
		84,
		88,
		77,
		28,
		47,
		71,
		108,
		100,
		89,
		88,
		-1,
		79,
		109,
		106,
		92,
		79,
		69,
		70,
		78,
		91,
		70,
		89,
		92,
		114,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		54,
		25,
		49,
		91,
		118,
		111,
		99,
		64,
		64,
		58,
		-1,
		99,
		82,
		78,
		67,
		65,
		78,
		73,
		89,
		93,
		92,
		111,
		123,
		114,
		134,
		-1,
		-1,
		-1,
		84,
		73,
		74,
		20,
		43,
		80,
		97,
		83,
		88,
		63,
		56,
		50,
		102,
		99,
		66,
		74,
		66,
		55,
		69,
		77,
		81,
		90,
		99,
		105,
		129,
		129,
		135,
		-1,
		-1,
		91,
		81,
		65,
		67,
		64,
		34,
		41,
		73,
		88,
		85,
		-1,
		55,
		-1,
		44,
		52,
		51,
		57,
		69,
		55,
		60,
		71,
		83,
		96,
		92,
		99,
		134,
		134,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		84,
		79,
		54,
		31,
		15,
		51,
		-1,
		55,
		56,
		-1,
		49,
		43,
		49,
		48,
		55,
		52,
		52,
		66,
		74,
		70,
		86,
		92,
		84,
		120,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		77,
		56,
		49,
		69,
		10,
		62,
		-1,
		-1,
		40,
		33,
		-1,
		36,
		36,
		43,
		52,
		57,
		62,
		70,
		65,
		78,
		83,
		89,
		94,
		112,
		116,
		120,
		109,
		105,
		102,
		116,
		-1,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		10,
		30,
		-1,
		49,
		41,
		31,
		25,
		31,
		49,
		47,
		67,
		59,
		73,
		73,
		79,
		87,
		72,
		75,
		91,
		89,
		107,
		115,
		107,
		101,
		100,
		112,
		-1,
		97,
		83,
		54,
		-1,
		-1,
		43,
		-1,
		7,
		31,
		47,
		-1,
		65,
		44,
		67,
		45,
		59,
		55,
		93,
		94,
		72,
		77,
		85,
		95,
		97,
		86,
		97,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		103,
		90,
		48,
		44,
		33,
		53,
		4,
		13,
		34,
		-1,
		-1,
		109,
		-1,
		43,
		60,
		69,
		67,
		83,
		74,
		80,
		96,
		99,
		101,
		91,
		80,
		86,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		19,
		6,
		0,
		-1,
		51,
		-1,
		87,
		77,
		61,
		46,
		79,
		-1,
		91,
		75,
		80,
		-1,
		126,
		-1,
		99,
		101,
		95,
		80,
		77,
		88,
		86,
		97,
		114,
		-1,
		53,
		38,
		31,
		21,
		35,
		6,
		-1,
		61,
		-1,
		-1,
		74,
		68,
		68,
		52,
		55,
		107,
		87,
		81,
		80,
		121,
		121,
		107,
		93,
		86,
		83,
		80,
		93,
		113,
		104,
		116,
		-1,
		-1,
		-1,
		58,
		44,
		48,
		8,
		27,
		-1,
		-1,
		136,
		91,
		77,
		-1,
		61,
		124,
		112,
		102,
		92,
		126,
		127,
		112,
		105,
		91,
		93,
		91,
		89,
		94,
		115,
		116,
		129,
		-1,
		-1,
		41,
		46,
		34,
		20,
		39,
		-1,
		-1,
		-1,
		83,
		99,
		91,
		62,
		113,
		-1,
		-1,
		104,
		102,
		112,
		108,
		95,
		115,
		118,
		104,
		88,
		103,
		115,
		123,
		128,
		-1,
		44,
		31,
		-1,
		-1,
		42,
		36,
		-1,
		-1,
		-1,
		-1,
		116,
		82,
		94,
		115,
		140,
		107,
		-1,
		112,
		113,
		99,
		113,
		120,
		106,
		101,
		95,
		98,
		116,
		133,
		-1,
		-1,
		56,
		-1,
		51,
		-1,
		-1,
		-1,
		-1,
		73,
		87,
		108,
		114,
		126,
		-1,
		121,
		115,
		101,
		118,
		119,
		116,
		107,
		99,
		104,
		101,
		114,
		128,
		132,
		79,
		-1,
		62,
		-1,
		-1,
		-1,
		91,
		106,
		168,
		145,
		118,
		122,
		115,
		109,
		109,
		125,
		127,
		138,
		106,
		102,
		103,
		107,
		106,
		123,
		133,
		-1,
		-1,
		62,
		79,
		114,
		99,
		103,
		195,
		-1,
		-1,
		131,
		122,
		113,
		116,
		119,
		122,
		112,
		109,
		114,
		119,
		107,
		116,
		134,
		138,
		-1,
		-1,
		-1,
		82,
		-1,
		97,
		-1,
		-1,
		118,
		202,
		149,
		131,
		127,
		125,
		118,
		127,
		122,
		117,
		127,
		136,
		128,
		109,
		120,
		143,
		132,
		170,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		111,
		86,
		101,
		147,
		138,
		143,
		164,
		161,
		-1,
		131,
		156,
		128,
		135,
		127,
		135,
		135,
		132,
		110,
		117,
		133,
		132,
		127,
		162,
		154,
		160,
		-1,
		-1,
		194,
		183,
		172,
		178,
		-1,
		117,
		103,
		133,
		123,
		129,
		-1,
		-1,
		176,
		173,
		153,
		137,
		141,
		134,
		129,
		139,
		119,
		106,
		110,
		114,
		120,
		125,
		130,
		136,
		151,
		166,
		-1,
		89,
		170,
		163,
		146,
		154,
		185,
		-1,
		120,
		129,
		110,
		115,
		123,
		-1,
		-1,
		149,
		145,
		150,
		144,
		141,
		149,
		144,
		135,
		120,
		126,
		113,
		112,
		130,
		134,
		143,
		150,
		140,
		153,
		157,
		-1,
		103,
		146,
		140,
		143,
		167,
		181,
		-1,
		133,
		-1,
		-1,
		118,
		136,
		144,
		140,
		144,
		197,
		158,
		153,
		143,
		141,
		132,
		123,
		130,
		121,
		121,
		124,
		139,
		144,
		136,
		150,
		150,
		151,
		-1,
		138,
		126,
		134,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		134,
		-1,
		170,
		-1,
		163,
		167,
		166,
		169,
		157,
		144,
		136,
		128,
		144,
		119,
		129,
		125,
		126,
		135,
		146,
		158,
		157,
		158,
		212,
		167,
		134,
		125,
		172,
		187,
		191,
		-1,
		146,
		185,
		172,
		-1,
		143,
		-1,
		-1,
		-1,
		177,
		179,
		171,
		177,
		156,
		156,
		130,
		134,
		124,
		131,
		141,
		143,
		135,
		139,
		152,
		163,
		166,
		208,
		206,
		211,
		156,
		139,
		157,
		166,
		187,
		161,
		152,
		179,
		179,
		168,
		163,
		150,
		-1,
		-1,
		200,
		189,
		-1,
		-1,
		163,
		151,
		134,
		135,
		131,
		134,
		149,
		152,
		142,
		140,
		134,
		166,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		147,
		158,
		-1,
		-1,
		164,
		180,
		193,
		197,
		210,
		235,
		-1,
		153,
		-1,
		-1,
		208,
		-1,
		-1,
		193,
		156,
		145,
		136,
		142,
		139,
		150,
		160,
		148,
		149,
		139,
		149,
		162,
		192,
		189,
		177,
		175,
		198,
		155,
		151,
		-1,
		179,
		167,
		173,
		180,
		197,
		224,
		-1,
		-1,
		169,
		160,
		-1,
		-1,
		191,
		189,
		178,
		-1,
		168,
		141,
		146,
		166,
		168,
		157,
		151,
		145,
		152,
		151,
		159,
		167,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		179,
		-1,
		-1,
		186,
		179,
		167,
		155,
		145,
		155,
		159,
		163,
		155,
		148,
		143,
		154,
		146,
		150,
		167,
		-1,
		235,
		-1,
		187,
		180,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		220,
		204,
		185,
		-1,
		155,
		168,
		199,
		167,
		172,
		167,
		149,
		160,
		149,
		152,
		166,
		161,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		218,
		237,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		192,
		188,
		-1,
		-1,
		156,
		181,
		170,
		178,
		173,
		153,
		159,
		162,
		151,
		155,
		167,
		-1,
		-1,
		200,
		201,
		206,
		-1,
		221,
		-1,
		236,
		-1,
		181,
		197,
		199,
		-1,
		-1,
		-1,
		194,
		157,
		178,
		188,
		182,
		180,
		171,
		157,
		164,
		162,
		158,
		169,
		-1,
		-1,
		-1,
		239,
		213,
		243,
		234,
		217,
		197,
		189,
		211,
		-1,
		181,
		-1,
		156,
		158,
		184,
		187,
		193,
		187,
		160,
		175,
		165,
		156,
		165,
		245,
		-1,
		215,
		248,
		212,
		203,
		182,
		186,
		202,
		-1,
		178,
		160,
		-1,
		188,
		178,
		209,
		194,
		175,
		162,
		169,
		169,
		162,
		-1,
		-1,
		-1,
		217,
		216,
		208,
		202,
		202,
		187,
		178,
		-1,
		190,
		172,
		151,
		168,
		168,
		159,
		167,
		199,
		195,
		182,
		182,
		174,
		-1,
		307,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		211,
		206,
		179,
		167,
		173,
		169,
		155,
		161,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		175,
		210,
		-1,
		313,
		-1,
		247,
		-1,
		-1,
		229,
		209,
		201,
		190,
		179,
		177,
		168,
		159,
		181,
		197,
		181,
		179,
		182,
		183,
		-1,
		302,
		301,
		-1,
		248,
		240,
		226,
		-1,
		219,
		-1,
		225,
		186,
		-1,
		188,
		168,
		-1,
		190,
		186,
		-1,
		-1,
		289,
		264,
		-1,
		-1,
		-1,
		249,
		229,
		220,
		204,
		-1,
		179,
		179,
		-1,
		-1,
		-1,
		274,
		273,
		-1,
		242,
		245,
		-1,
		235,
		226,
		234,
		181,
		185,
		-1,
		-1,
		-1,
		283,
		264,
		258,
		257,
		255,
		250,
		247,
		233,
		217,
		195,
		184,
		205,
		-1,
		-1,
		-1,
		255,
		247,
		240,
		-1,
		-1,
		242,
		225,
		206,
		204,
		-1,
		-1,
		-1,
		277,
		258,
		-1,
		-1,
		232,
		-1,
		-1,
		238,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		266,
		-1,
		-1,
		-1,
		228,
		224,
		225,
		-1,
		-1,
		-1,
		-1,
		288,
		289,
		312,
		276,
		-1,
		-1,
		-1,
		220,
		214,
		-1,
		-1,
		291,
		289,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		218,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		253,
		-1,
		253,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		266,
		258,
		266,
		-1,
		238,
		240,
		-1,
		288,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		243,
		250,
		272,
		275,
		311,
		-1,
		262
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		191,
		193,
		159,
		153,
		192,
		163,
		169,
		180,
		-1,
		-1,
		-1,
		182,
		181,
		151,
		149,
		158,
		163,
		170,
		-1,
		193,
		-1,
		203,
		182,
		193,
		198,
		144,
		141,
		161,
		180,
		186,
		178,
		218,
		174,
		145,
		139,
		157,
		162,
		180,
		172,
		-1,
		145,
		135,
		157,
		161,
		173,
		156,
		-1,
		-1,
		139,
		140,
		146,
		158,
		163,
		168,
		-1,
		186,
		170,
		-1,
		-1,
		129,
		142,
		138,
		141,
		149,
		165,
		178,
		170,
		165,
		-1,
		-1,
		130,
		134,
		147,
		148,
		146,
		165,
		178,
		160,
		174,
		173,
		-1,
		118,
		136,
		145,
		154,
		157,
		141,
		139,
		157,
		159,
		165,
		168,
		-1,
		110,
		112,
		141,
		147,
		159,
		157,
		144,
		144,
		154,
		147,
		166,
		157,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		107,
		115,
		141,
		140,
		136,
		154,
		154,
		147,
		144,
		142,
		139,
		155,
		156,
		166,
		-1,
		-1,
		163,
		132,
		167,
		124,
		109,
		-1,
		103,
		122,
		128,
		132,
		137,
		137,
		151,
		147,
		-1,
		133,
		132,
		163,
		149,
		160,
		123,
		-1,
		-1,
		121,
		113,
		98,
		101,
		98,
		98,
		128,
		127,
		132,
		132,
		128,
		134,
		137,
		137,
		143,
		127,
		137,
		141,
		152,
		167,
		-1,
		-1,
		222,
		-1,
		-1,
		120,
		103,
		-1,
		86,
		93,
		93,
		110,
		100,
		121,
		136,
		140,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		124,
		149,
		153,
		147,
		168,
		163,
		-1,
		221,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		79,
		82,
		88,
		112,
		122,
		-1,
		143,
		141,
		165,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		131,
		133,
		166,
		144,
		166,
		163,
		192,
		197,
		191,
		200,
		-1,
		128,
		124,
		120,
		127,
		76,
		-1,
		-1,
		116,
		-1,
		130,
		143,
		142,
		145,
		148,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		133,
		144,
		139,
		138,
		156,
		171,
		184,
		188,
		194,
		-1,
		178,
		-1,
		120,
		104,
		106,
		78,
		99,
		-1,
		136,
		131,
		151,
		144,
		135,
		-1,
		138,
		141,
		148,
		126,
		111,
		128,
		120,
		118,
		123,
		128,
		142,
		133,
		151,
		158,
		166,
		170,
		190,
		202,
		138,
		128,
		-1,
		110,
		115,
		74,
		82,
		101,
		174,
		141,
		-1,
		136,
		-1,
		128,
		153,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		127,
		124,
		121,
		139,
		142,
		159,
		163,
		179,
		-1,
		-1,
		123,
		127,
		116,
		67,
		86,
		110,
		147,
		134,
		123,
		122,
		-1,
		113,
		143,
		140,
		126,
		113,
		103,
		104,
		112,
		125,
		104,
		123,
		126,
		148,
		176,
		154,
		166,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		93,
		64,
		88,
		130,
		152,
		145,
		133,
		98,
		98,
		92,
		-1,
		133,
		116,
		112,
		101,
		99,
		112,
		107,
		123,
		127,
		126,
		145,
		157,
		148,
		168,
		-1,
		-1,
		-1,
		123,
		112,
		113,
		59,
		82,
		119,
		131,
		117,
		122,
		97,
		90,
		84,
		136,
		133,
		100,
		108,
		100,
		89,
		103,
		111,
		115,
		124,
		133,
		139,
		163,
		163,
		169,
		-1,
		-1,
		130,
		120,
		104,
		106,
		103,
		73,
		80,
		112,
		122,
		121,
		-1,
		89,
		-1,
		78,
		86,
		85,
		91,
		103,
		89,
		94,
		105,
		117,
		130,
		126,
		133,
		168,
		168,
		153,
		173,
		176,
		-1,
		-1,
		-1,
		123,
		116,
		91,
		68,
		54,
		90,
		-1,
		91,
		92,
		-1,
		83,
		77,
		83,
		82,
		89,
		86,
		86,
		100,
		108,
		104,
		120,
		126,
		118,
		154,
		-1,
		161,
		155,
		163,
		153,
		141,
		-1,
		-1,
		-1,
		114,
		93,
		86,
		106,
		47,
		99,
		-1,
		-1,
		76,
		69,
		-1,
		70,
		70,
		77,
		86,
		91,
		96,
		104,
		99,
		112,
		117,
		123,
		128,
		146,
		150,
		154,
		143,
		139,
		136,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		67,
		-1,
		54,
		46,
		58,
		61,
		67,
		83,
		81,
		101,
		93,
		107,
		107,
		113,
		121,
		106,
		109,
		125,
		123,
		141,
		149,
		141,
		135,
		134,
		146,
		-1,
		146,
		132,
		103,
		-1,
		-1,
		76,
		-1,
		40,
		14,
		22,
		-1,
		101,
		80,
		101,
		79,
		93,
		89,
		127,
		128,
		106,
		111,
		119,
		129,
		131,
		120,
		131,
		123,
		145,
		145,
		129,
		130,
		139,
		-1,
		152,
		139,
		97,
		93,
		82,
		102,
		43,
		62,
		11,
		-1,
		-1,
		143,
		-1,
		77,
		94,
		103,
		101,
		117,
		108,
		114,
		130,
		133,
		135,
		125,
		114,
		120,
		117,
		139,
		125,
		123,
		142,
		158,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		68,
		55,
		49,
		-1,
		0,
		-1,
		121,
		111,
		95,
		80,
		113,
		-1,
		125,
		109,
		114,
		-1,
		160,
		-1,
		133,
		135,
		129,
		114,
		111,
		122,
		120,
		131,
		148,
		-1,
		102,
		87,
		80,
		70,
		84,
		55,
		-1,
		101,
		-1,
		-1,
		108,
		102,
		102,
		86,
		89,
		141,
		121,
		115,
		114,
		155,
		155,
		141,
		127,
		120,
		117,
		114,
		127,
		147,
		138,
		150,
		-1,
		-1,
		-1,
		107,
		82,
		88,
		46,
		67,
		-1,
		-1,
		170,
		125,
		111,
		-1,
		95,
		158,
		146,
		136,
		126,
		160,
		161,
		146,
		139,
		125,
		127,
		125,
		123,
		128,
		149,
		150,
		163,
		-1,
		-1,
		79,
		86,
		74,
		60,
		79,
		-1,
		-1,
		-1,
		117,
		133,
		125,
		96,
		147,
		-1,
		-1,
		138,
		136,
		146,
		142,
		129,
		149,
		152,
		138,
		122,
		137,
		149,
		157,
		162,
		-1,
		82,
		69,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		150,
		116,
		128,
		149,
		174,
		141,
		-1,
		146,
		147,
		133,
		147,
		154,
		140,
		135,
		129,
		132,
		150,
		167,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		107,
		121,
		142,
		148,
		160,
		-1,
		155,
		149,
		135,
		152,
		153,
		150,
		141,
		133,
		138,
		135,
		148,
		162,
		166,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		125,
		140,
		202,
		179,
		152,
		156,
		149,
		143,
		143,
		159,
		161,
		172,
		140,
		136,
		137,
		141,
		140,
		157,
		167,
		-1,
		-1,
		102,
		119,
		151,
		133,
		137,
		229,
		-1,
		-1,
		165,
		156,
		147,
		150,
		153,
		156,
		146,
		143,
		148,
		153,
		141,
		150,
		168,
		172,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		152,
		236,
		183,
		165,
		161,
		159,
		152,
		161,
		156,
		151,
		161,
		170,
		162,
		143,
		154,
		177,
		166,
		204,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		172,
		179,
		198,
		195,
		-1,
		165,
		190,
		162,
		169,
		161,
		169,
		169,
		166,
		144,
		151,
		167,
		166,
		161,
		196,
		188,
		194,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		157,
		143,
		173,
		163,
		169,
		-1,
		-1,
		214,
		211,
		187,
		171,
		175,
		168,
		163,
		173,
		153,
		140,
		144,
		148,
		154,
		159,
		164,
		170,
		185,
		200,
		-1,
		127,
		208,
		201,
		184,
		192,
		223,
		-1,
		160,
		169,
		150,
		155,
		163,
		-1,
		-1,
		187,
		184,
		189,
		178,
		175,
		183,
		178,
		169,
		154,
		160,
		147,
		146,
		164,
		168,
		177,
		184,
		174,
		187,
		191,
		-1,
		141,
		184,
		178,
		181,
		205,
		219,
		-1,
		173,
		-1,
		-1,
		158,
		176,
		184,
		180,
		184,
		236,
		192,
		187,
		177,
		175,
		166,
		157,
		164,
		155,
		155,
		158,
		173,
		178,
		170,
		184,
		184,
		185,
		-1,
		176,
		164,
		172,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		210,
		-1,
		203,
		207,
		200,
		203,
		191,
		178,
		170,
		162,
		178,
		153,
		163,
		159,
		160,
		169,
		180,
		192,
		191,
		192,
		250,
		205,
		172,
		163,
		210,
		225,
		229,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		217,
		213,
		205,
		211,
		190,
		190,
		164,
		168,
		158,
		165,
		175,
		177,
		169,
		173,
		186,
		197,
		200,
		246,
		244,
		249,
		194,
		177,
		195,
		204,
		225,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		240,
		223,
		-1,
		-1,
		197,
		185,
		168,
		169,
		165,
		168,
		183,
		186,
		176,
		174,
		168,
		200,
		-1,
		246,
		245,
		234,
		231,
		207,
		198,
		185,
		196,
		-1,
		-1,
		204,
		220,
		233,
		237,
		250,
		275,
		-1,
		193,
		-1,
		-1,
		242,
		-1,
		-1,
		227,
		190,
		179,
		170,
		176,
		173,
		184,
		194,
		182,
		183,
		173,
		183,
		196,
		230,
		227,
		215,
		213,
		236,
		193,
		189,
		-1,
		219,
		207,
		213,
		220,
		237,
		264,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		225,
		223,
		212,
		-1,
		202,
		175,
		180,
		200,
		202,
		191,
		185,
		179,
		186,
		185,
		193,
		201,
		239,
		253,
		242,
		238,
		237,
		245,
		194,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		219,
		-1,
		-1,
		220,
		213,
		201,
		189,
		179,
		189,
		193,
		197,
		189,
		182,
		177,
		188,
		180,
		184,
		201,
		-1,
		273,
		-1,
		225,
		218,
		233,
		248,
		256,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		254,
		238,
		219,
		-1,
		189,
		202,
		233,
		201,
		206,
		201,
		183,
		194,
		183,
		186,
		200,
		195,
		-1,
		-1,
		231,
		234,
		-1,
		-1,
		256,
		272,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		226,
		222,
		-1,
		-1,
		190,
		215,
		204,
		212,
		207,
		187,
		193,
		196,
		185,
		189,
		201,
		-1,
		-1,
		238,
		239,
		244,
		-1,
		255,
		-1,
		273,
		-1,
		221,
		237,
		234,
		-1,
		-1,
		-1,
		228,
		191,
		212,
		222,
		216,
		214,
		205,
		191,
		198,
		196,
		192,
		203,
		-1,
		-1,
		-1,
		273,
		247,
		280,
		271,
		254,
		234,
		226,
		245,
		-1,
		215,
		-1,
		190,
		192,
		218,
		221,
		227,
		221,
		194,
		209,
		199,
		190,
		199,
		279,
		-1,
		249,
		282,
		246,
		240,
		216,
		220,
		236,
		-1,
		212,
		194,
		-1,
		222,
		212,
		243,
		228,
		209,
		196,
		203,
		203,
		196,
		-1,
		-1,
		-1,
		251,
		250,
		242,
		236,
		236,
		221,
		212,
		-1,
		224,
		206,
		185,
		202,
		202,
		193,
		201,
		233,
		229,
		216,
		216,
		208,
		-1,
		345,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		245,
		240,
		213,
		201,
		207,
		203,
		189,
		195,
		197,
		205,
		203,
		200,
		212,
		208,
		228,
		209,
		244,
		-1,
		347,
		-1,
		281,
		-1,
		-1,
		263,
		243,
		235,
		224,
		213,
		211,
		202,
		193,
		215,
		231,
		215,
		213,
		216,
		217,
		-1,
		336,
		335,
		-1,
		282,
		274,
		260,
		-1,
		253,
		-1,
		259,
		220,
		-1,
		222,
		202,
		-1,
		224,
		220,
		-1,
		-1,
		323,
		298,
		-1,
		-1,
		-1,
		283,
		263,
		254,
		238,
		-1,
		213,
		213,
		-1,
		-1,
		-1,
		308,
		307,
		-1,
		276,
		279,
		-1,
		269,
		260,
		268,
		215,
		219,
		-1,
		-1,
		-1,
		317,
		298,
		292,
		291,
		289,
		284,
		281,
		267,
		251,
		229,
		218,
		239,
		-1,
		-1,
		-1,
		289,
		281,
		274,
		-1,
		-1,
		276,
		259,
		240,
		238,
		-1,
		-1,
		-1,
		311,
		292,
		-1,
		-1,
		266,
		-1,
		-1,
		272,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		328,
		300,
		-1,
		-1,
		-1,
		262,
		258,
		259,
		-1,
		-1,
		-1,
		-1,
		322,
		323,
		346,
		310,
		-1,
		-1,
		-1,
		254,
		248,
		-1,
		-1,
		325,
		323,
		-1,
		-1,
		-1,
		282,
		266,
		-1,
		252,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		287,
		-1,
		287,
		262,
		269,
		-1,
		-1,
		-1,
		-1,
		300,
		292,
		300,
		-1,
		272,
		274,
		-1,
		322,
		-1,
		-1,
		315,
		306,
		-1,
		-1,
		277,
		284,
		306,
		309,
		345,
		-1,
		296
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		224,
		213,
		224,
		232,
		205,
		212,
		-1,
		233,
		235,
		201,
		195,
		234,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		224,
		223,
		193,
		191,
		200,
		205,
		212,
		-1,
		216,
		-1,
		245,
		224,
		235,
		240,
		186,
		183,
		203,
		222,
		209,
		201,
		260,
		216,
		187,
		181,
		199,
		194,
		203,
		195,
		-1,
		187,
		177,
		199,
		183,
		194,
		186,
		-1,
		-1,
		181,
		182,
		188,
		179,
		185,
		181,
		-1,
		191,
		175,
		-1,
		-1,
		171,
		177,
		161,
		164,
		172,
		170,
		183,
		175,
		170,
		-1,
		-1,
		167,
		163,
		170,
		157,
		153,
		170,
		183,
		165,
		179,
		178,
		-1,
		160,
		178,
		187,
		164,
		162,
		146,
		144,
		162,
		164,
		170,
		173,
		-1,
		153,
		155,
		165,
		173,
		178,
		162,
		149,
		149,
		159,
		152,
		171,
		162,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		150,
		152,
		169,
		161,
		151,
		166,
		159,
		152,
		149,
		147,
		144,
		160,
		161,
		171,
		-1,
		-1,
		206,
		175,
		210,
		167,
		152,
		-1,
		146,
		145,
		151,
		155,
		149,
		142,
		156,
		152,
		-1,
		138,
		137,
		168,
		154,
		165,
		166,
		-1,
		-1,
		164,
		156,
		141,
		144,
		141,
		141,
		160,
		159,
		151,
		137,
		133,
		139,
		142,
		142,
		148,
		132,
		142,
		146,
		157,
		172,
		-1,
		-1,
		227,
		-1,
		-1,
		163,
		146,
		-1,
		129,
		136,
		136,
		153,
		143,
		164,
		170,
		161,
		153,
		147,
		135,
		137,
		134,
		147,
		135,
		129,
		154,
		158,
		152,
		173,
		168,
		-1,
		226,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		122,
		125,
		131,
		155,
		165,
		-1,
		155,
		161,
		171,
		156,
		153,
		140,
		128,
		141,
		126,
		133,
		132,
		136,
		138,
		171,
		149,
		171,
		168,
		197,
		202,
		196,
		205,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		159,
		-1,
		173,
		172,
		147,
		165,
		168,
		157,
		148,
		135,
		124,
		135,
		124,
		121,
		129,
		138,
		149,
		144,
		143,
		161,
		176,
		189,
		193,
		199,
		-1,
		221,
		-1,
		163,
		147,
		149,
		121,
		142,
		-1,
		179,
		174,
		164,
		149,
		140,
		-1,
		143,
		146,
		153,
		131,
		116,
		133,
		125,
		123,
		128,
		133,
		147,
		138,
		156,
		163,
		171,
		175,
		195,
		207,
		181,
		171,
		-1,
		153,
		158,
		117,
		125,
		144,
		182,
		146,
		-1,
		141,
		-1,
		133,
		158,
		-1,
		137,
		133,
		115,
		116,
		111,
		126,
		132,
		129,
		126,
		144,
		147,
		164,
		168,
		184,
		-1,
		-1,
		166,
		170,
		159,
		110,
		129,
		153,
		190,
		139,
		128,
		127,
		-1,
		118,
		148,
		145,
		131,
		118,
		108,
		109,
		117,
		130,
		109,
		128,
		131,
		153,
		181,
		159,
		171,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		136,
		107,
		131,
		173,
		157,
		150,
		138,
		103,
		103,
		97,
		-1,
		138,
		121,
		117,
		106,
		104,
		117,
		112,
		128,
		132,
		131,
		150,
		162,
		153,
		173,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		102,
		125,
		162,
		136,
		122,
		127,
		102,
		95,
		89,
		141,
		138,
		105,
		113,
		105,
		94,
		108,
		116,
		120,
		129,
		138,
		144,
		168,
		168,
		174,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		116,
		123,
		155,
		127,
		140,
		-1,
		94,
		-1,
		83,
		91,
		90,
		96,
		108,
		94,
		99,
		110,
		122,
		135,
		131,
		138,
		173,
		173,
		158,
		178,
		181,
		-1,
		-1,
		-1,
		166,
		161,
		136,
		113,
		97,
		133,
		-1,
		110,
		111,
		-1,
		88,
		82,
		88,
		87,
		94,
		91,
		91,
		105,
		113,
		109,
		125,
		131,
		123,
		159,
		-1,
		166,
		160,
		168,
		158,
		146,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		92,
		144,
		-1,
		-1,
		95,
		88,
		-1,
		75,
		75,
		82,
		91,
		96,
		101,
		109,
		104,
		117,
		122,
		128,
		133,
		151,
		155,
		159,
		148,
		144,
		141,
		155,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		112,
		-1,
		104,
		96,
		86,
		80,
		74,
		77,
		79,
		106,
		98,
		112,
		112,
		118,
		126,
		111,
		114,
		130,
		128,
		146,
		154,
		146,
		140,
		139,
		151,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		125,
		-1,
		89,
		103,
		119,
		-1,
		112,
		91,
		106,
		84,
		80,
		94,
		132,
		133,
		111,
		116,
		124,
		134,
		136,
		125,
		136,
		128,
		150,
		150,
		134,
		135,
		144,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		86,
		74,
		106,
		-1,
		-1,
		22,
		-1,
		58,
		60,
		108,
		106,
		122,
		113,
		119,
		135,
		138,
		140,
		130,
		119,
		125,
		122,
		144,
		130,
		128,
		147,
		163,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		123,
		-1,
		0,
		26,
		31,
		47,
		79,
		-1,
		130,
		114,
		119,
		-1,
		165,
		-1,
		138,
		140,
		134,
		119,
		116,
		127,
		125,
		136,
		153,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		12,
		17,
		26,
		53,
		56,
		146,
		126,
		120,
		119,
		160,
		160,
		146,
		132,
		125,
		122,
		119,
		132,
		152,
		143,
		155,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		94,
		49,
		35,
		-1,
		62,
		163,
		151,
		141,
		131,
		165,
		166,
		151,
		144,
		130,
		132,
		130,
		128,
		133,
		154,
		155,
		168,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		43,
		59,
		92,
		63,
		152,
		-1,
		-1,
		143,
		141,
		151,
		147,
		134,
		154,
		157,
		143,
		127,
		142,
		154,
		162,
		167,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		82,
		83,
		95,
		116,
		141,
		146,
		-1,
		151,
		152,
		138,
		152,
		159,
		145,
		140,
		134,
		137,
		155,
		172,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		74,
		88,
		109,
		115,
		127,
		-1,
		153,
		154,
		140,
		157,
		158,
		155,
		146,
		138,
		143,
		140,
		153,
		167,
		171,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		92,
		107,
		169,
		146,
		119,
		124,
		134,
		139,
		144,
		164,
		166,
		177,
		145,
		141,
		142,
		146,
		145,
		162,
		172,
		-1,
		-1,
		144,
		153,
		118,
		100,
		104,
		196,
		-1,
		-1,
		134,
		140,
		136,
		146,
		154,
		157,
		151,
		148,
		153,
		158,
		146,
		155,
		173,
		177,
		-1,
		-1,
		-1,
		164,
		-1,
		151,
		-1,
		-1,
		119,
		220,
		167,
		149,
		145,
		143,
		148,
		157,
		152,
		156,
		166,
		175,
		167,
		148,
		159,
		182,
		171,
		209,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		193,
		168,
		183,
		204,
		139,
		146,
		182,
		179,
		-1,
		149,
		186,
		158,
		165,
		157,
		170,
		174,
		171,
		149,
		156,
		172,
		171,
		166,
		201,
		193,
		199,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		199,
		185,
		190,
		180,
		156,
		-1,
		-1,
		198,
		195,
		173,
		167,
		171,
		164,
		159,
		178,
		158,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		171,
		252,
		245,
		228,
		236,
		267,
		-1,
		198,
		190,
		192,
		176,
		167,
		-1,
		-1,
		171,
		168,
		173,
		174,
		171,
		183,
		182,
		174,
		159,
		165,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		185,
		228,
		222,
		225,
		249,
		263,
		-1,
		195,
		-1,
		-1,
		200,
		180,
		186,
		176,
		170,
		220,
		188,
		183,
		182,
		180,
		171,
		162,
		169,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		220,
		208,
		216,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		216,
		-1,
		213,
		-1,
		188,
		192,
		196,
		199,
		196,
		183,
		175,
		167,
		183,
		158,
		168,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		290,
		246,
		216,
		207,
		254,
		269,
		273,
		-1,
		207,
		246,
		254,
		-1,
		225,
		-1,
		-1,
		-1,
		202,
		209,
		201,
		216,
		195,
		195,
		169,
		173,
		163,
		170,
		180,
		182,
		174,
		178,
		191,
		202,
		205,
		286,
		277,
		290,
		235,
		221,
		239,
		248,
		269,
		222,
		213,
		240,
		261,
		250,
		245,
		232,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		202,
		190,
		173,
		174,
		170,
		173,
		188,
		191,
		181,
		179,
		173,
		205,
		-1,
		279,
		278,
		267,
		264,
		240,
		231,
		226,
		240,
		-1,
		-1,
		225,
		241,
		254,
		258,
		274,
		299,
		-1,
		235,
		-1,
		-1,
		246,
		-1,
		-1,
		232,
		195,
		184,
		175,
		181,
		178,
		189,
		199,
		187,
		188,
		178,
		188,
		201,
		263,
		260,
		248,
		246,
		269,
		234,
		222,
		-1,
		235,
		228,
		234,
		241,
		258,
		288,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		230,
		228,
		217,
		-1,
		207,
		180,
		185,
		205,
		207,
		196,
		190,
		184,
		191,
		190,
		198,
		206,
		272,
		286,
		275,
		271,
		270,
		278,
		227,
		220,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		-1,
		268,
		261,
		-1,
		-1,
		225,
		218,
		206,
		194,
		184,
		194,
		198,
		202,
		194,
		187,
		182,
		193,
		185,
		189,
		206,
		-1,
		306,
		-1,
		258,
		234,
		248,
		263,
		271,
		-1,
		-1,
		-1,
		285,
		271,
		264,
		252,
		250,
		-1,
		259,
		243,
		224,
		-1,
		194,
		207,
		238,
		206,
		211,
		206,
		188,
		199,
		188,
		191,
		205,
		200,
		-1,
		-1,
		246,
		249,
		-1,
		-1,
		271,
		277,
		-1,
		276,
		265,
		250,
		242,
		-1,
		-1,
		231,
		227,
		-1,
		-1,
		195,
		220,
		209,
		217,
		212,
		192,
		198,
		201,
		190,
		194,
		206,
		-1,
		-1,
		253,
		254,
		259,
		-1,
		260,
		-1,
		278,
		-1,
		245,
		251,
		239,
		-1,
		-1,
		-1,
		233,
		196,
		217,
		227,
		221,
		219,
		210,
		196,
		203,
		201,
		197,
		208,
		-1,
		-1,
		-1,
		278,
		252,
		285,
		276,
		259,
		239,
		231,
		250,
		-1,
		220,
		-1,
		195,
		197,
		223,
		226,
		232,
		226,
		199,
		214,
		204,
		195,
		204,
		284,
		-1,
		254,
		287,
		251,
		245,
		221,
		225,
		241,
		-1,
		217,
		199,
		-1,
		227,
		217,
		248,
		233,
		214,
		201,
		208,
		208,
		201,
		-1,
		-1,
		-1,
		256,
		255,
		247,
		241,
		241,
		226,
		217,
		-1,
		229,
		211,
		190,
		207,
		207,
		198,
		206,
		238,
		234,
		221,
		221,
		213,
		-1,
		357,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		250,
		245,
		218,
		206,
		212,
		208,
		194,
		200,
		202,
		210,
		208,
		205,
		217,
		213,
		233,
		214,
		249,
		-1,
		352,
		-1,
		286,
		-1,
		-1,
		268,
		248,
		240,
		229,
		218,
		216,
		207,
		198,
		220,
		236,
		220,
		218,
		221,
		222,
		-1,
		341,
		340,
		-1,
		287,
		279,
		265,
		-1,
		258,
		-1,
		264,
		225,
		-1,
		227,
		207,
		-1,
		229,
		225,
		-1,
		-1,
		328,
		303,
		-1,
		-1,
		-1,
		288,
		268,
		259,
		243,
		-1,
		218,
		218,
		-1,
		-1,
		-1,
		313,
		312,
		-1,
		281,
		284,
		-1,
		274,
		265,
		273,
		220,
		224,
		-1,
		-1,
		-1,
		322,
		303,
		297,
		296,
		294,
		289,
		286,
		272,
		256,
		234,
		223,
		244,
		-1,
		-1,
		-1,
		294,
		286,
		279,
		-1,
		-1,
		281,
		264,
		245,
		243,
		-1,
		-1,
		-1,
		316,
		297,
		-1,
		-1,
		271,
		-1,
		-1,
		277,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		333,
		305,
		-1,
		-1,
		-1,
		267,
		263,
		264,
		-1,
		-1,
		-1,
		-1,
		327,
		328,
		351,
		315,
		-1,
		-1,
		-1,
		259,
		253,
		-1,
		-1,
		330,
		328,
		-1,
		-1,
		-1,
		287,
		271,
		-1,
		257,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		292,
		-1,
		292,
		267,
		274,
		-1,
		-1,
		-1,
		-1,
		305,
		297,
		305,
		-1,
		277,
		279,
		-1,
		327,
		-1,
		-1,
		320,
		311,
		-1,
		-1,
		282,
		289,
		311,
		314,
		350,
		-1,
		301
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		222,
		224,
		190,
		184,
		223,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		213,
		212,
		182,
		180,
		189,
		194,
		201,
		-1,
		205,
		-1,
		234,
		213,
		224,
		229,
		175,
		172,
		192,
		211,
		198,
		190,
		249,
		205,
		176,
		170,
		188,
		183,
		192,
		184,
		-1,
		176,
		166,
		188,
		172,
		183,
		175,
		-1,
		-1,
		170,
		171,
		177,
		168,
		174,
		170,
		-1,
		180,
		164,
		-1,
		-1,
		160,
		166,
		150,
		153,
		161,
		159,
		172,
		164,
		159,
		-1,
		-1,
		156,
		152,
		159,
		146,
		142,
		159,
		172,
		154,
		168,
		167,
		-1,
		149,
		167,
		176,
		153,
		151,
		135,
		133,
		151,
		153,
		159,
		162,
		-1,
		142,
		144,
		154,
		162,
		167,
		151,
		138,
		138,
		148,
		141,
		160,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		139,
		141,
		158,
		150,
		140,
		155,
		148,
		141,
		138,
		136,
		133,
		149,
		150,
		160,
		-1,
		-1,
		195,
		164,
		199,
		156,
		141,
		-1,
		135,
		134,
		140,
		144,
		138,
		131,
		145,
		141,
		-1,
		127,
		126,
		157,
		143,
		154,
		155,
		-1,
		-1,
		153,
		145,
		130,
		133,
		130,
		130,
		149,
		148,
		140,
		126,
		122,
		128,
		131,
		131,
		137,
		121,
		131,
		135,
		146,
		161,
		-1,
		-1,
		216,
		-1,
		-1,
		152,
		135,
		-1,
		118,
		125,
		125,
		142,
		132,
		153,
		159,
		150,
		142,
		136,
		124,
		126,
		123,
		136,
		124,
		118,
		143,
		147,
		141,
		162,
		157,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		111,
		114,
		120,
		144,
		154,
		-1,
		144,
		150,
		160,
		145,
		142,
		129,
		117,
		130,
		115,
		122,
		121,
		125,
		127,
		160,
		138,
		160,
		157,
		186,
		191,
		185,
		194,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		148,
		-1,
		162,
		161,
		136,
		154,
		157,
		146,
		137,
		124,
		113,
		124,
		113,
		110,
		118,
		127,
		138,
		133,
		132,
		150,
		165,
		178,
		182,
		188,
		-1,
		210,
		-1,
		152,
		136,
		138,
		110,
		131,
		-1,
		168,
		163,
		153,
		138,
		129,
		-1,
		132,
		135,
		142,
		120,
		105,
		122,
		114,
		112,
		117,
		122,
		136,
		127,
		145,
		152,
		160,
		164,
		184,
		196,
		170,
		160,
		-1,
		142,
		147,
		106,
		114,
		133,
		171,
		135,
		-1,
		130,
		-1,
		122,
		147,
		-1,
		126,
		122,
		104,
		105,
		100,
		115,
		121,
		118,
		115,
		133,
		136,
		153,
		157,
		173,
		-1,
		-1,
		155,
		159,
		148,
		99,
		118,
		142,
		179,
		128,
		117,
		116,
		-1,
		107,
		137,
		134,
		120,
		107,
		97,
		98,
		106,
		119,
		98,
		117,
		120,
		142,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		125,
		96,
		120,
		162,
		146,
		139,
		127,
		92,
		92,
		86,
		-1,
		127,
		110,
		106,
		95,
		93,
		106,
		101,
		117,
		121,
		120,
		139,
		151,
		142,
		162,
		-1,
		-1,
		-1,
		155,
		144,
		145,
		91,
		114,
		151,
		125,
		111,
		116,
		91,
		84,
		78,
		130,
		127,
		94,
		102,
		94,
		83,
		97,
		105,
		109,
		118,
		127,
		133,
		157,
		157,
		163,
		-1,
		-1,
		162,
		152,
		136,
		138,
		135,
		105,
		112,
		144,
		116,
		129,
		-1,
		83,
		-1,
		72,
		80,
		79,
		85,
		97,
		83,
		88,
		99,
		111,
		124,
		120,
		127,
		162,
		162,
		147,
		167,
		170,
		-1,
		-1,
		-1,
		155,
		150,
		125,
		102,
		86,
		122,
		-1,
		99,
		100,
		-1,
		77,
		71,
		77,
		76,
		83,
		80,
		80,
		94,
		102,
		98,
		114,
		120,
		112,
		148,
		-1,
		155,
		149,
		157,
		147,
		135,
		-1,
		-1,
		-1,
		148,
		127,
		120,
		140,
		81,
		133,
		-1,
		-1,
		84,
		77,
		-1,
		64,
		64,
		71,
		80,
		85,
		90,
		98,
		93,
		106,
		111,
		117,
		122,
		140,
		144,
		148,
		137,
		133,
		130,
		144,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		101,
		-1,
		93,
		85,
		75,
		69,
		63,
		66,
		68,
		95,
		87,
		101,
		101,
		107,
		115,
		100,
		103,
		119,
		117,
		135,
		143,
		135,
		129,
		128,
		140,
		-1,
		168,
		154,
		125,
		-1,
		-1,
		114,
		-1,
		78,
		92,
		108,
		-1,
		101,
		80,
		95,
		73,
		69,
		83,
		121,
		122,
		100,
		105,
		113,
		123,
		125,
		114,
		125,
		117,
		139,
		139,
		123,
		124,
		133,
		-1,
		174,
		161,
		119,
		115,
		104,
		124,
		75,
		63,
		95,
		-1,
		-1,
		41,
		-1,
		47,
		49,
		97,
		95,
		111,
		102,
		108,
		124,
		127,
		129,
		119,
		108,
		114,
		111,
		133,
		119,
		117,
		136,
		152,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		90,
		77,
		71,
		-1,
		112,
		-1,
		29,
		0,
		22,
		36,
		68,
		-1,
		119,
		103,
		108,
		-1,
		154,
		-1,
		127,
		129,
		123,
		108,
		105,
		116,
		114,
		125,
		142,
		-1,
		124,
		109,
		102,
		92,
		106,
		77,
		-1,
		132,
		-1,
		-1,
		23,
		17,
		17,
		42,
		45,
		135,
		115,
		109,
		108,
		149,
		149,
		135,
		121,
		114,
		111,
		108,
		121,
		141,
		132,
		144,
		-1,
		-1,
		-1,
		129,
		115,
		119,
		79,
		98,
		-1,
		-1,
		85,
		40,
		26,
		-1,
		51,
		152,
		140,
		130,
		120,
		154,
		155,
		140,
		133,
		119,
		121,
		119,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		112,
		117,
		105,
		91,
		110,
		-1,
		-1,
		-1,
		34,
		50,
		81,
		52,
		141,
		-1,
		-1,
		132,
		130,
		140,
		136,
		123,
		143,
		146,
		132,
		116,
		131,
		143,
		151,
		156,
		-1,
		115,
		102,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		-1,
		-1,
		73,
		72,
		84,
		105,
		130,
		135,
		-1,
		140,
		141,
		127,
		141,
		148,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		127,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		63,
		77,
		98,
		104,
		116,
		-1,
		142,
		143,
		129,
		146,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		150,
		-1,
		133,
		-1,
		-1,
		-1,
		81,
		96,
		158,
		135,
		108,
		113,
		123,
		128,
		133,
		153,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		133,
		142,
		107,
		89,
		93,
		185,
		-1,
		-1,
		123,
		129,
		125,
		135,
		143,
		146,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		166,
		-1,
		-1,
		-1,
		153,
		-1,
		140,
		-1,
		-1,
		108,
		209,
		156,
		138,
		134,
		132,
		137,
		146,
		141,
		145,
		155,
		164,
		156,
		137,
		148,
		171,
		160,
		198,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		182,
		157,
		172,
		193,
		128,
		135,
		171,
		168,
		-1,
		138,
		175,
		147,
		154,
		146,
		159,
		163,
		160,
		138,
		145,
		161,
		160,
		155,
		190,
		182,
		188,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		188,
		174,
		179,
		169,
		145,
		-1,
		-1,
		187,
		184,
		162,
		156,
		160,
		153,
		148,
		167,
		147,
		134,
		138,
		142,
		148,
		153,
		158,
		164,
		179,
		194,
		-1,
		160,
		241,
		234,
		217,
		225,
		256,
		-1,
		187,
		179,
		181,
		165,
		156,
		-1,
		-1,
		160,
		157,
		162,
		163,
		160,
		172,
		171,
		163,
		148,
		154,
		141,
		140,
		158,
		162,
		171,
		178,
		168,
		181,
		185,
		-1,
		174,
		217,
		211,
		214,
		238,
		252,
		-1,
		184,
		-1,
		-1,
		189,
		169,
		175,
		165,
		159,
		209,
		177,
		172,
		171,
		169,
		160,
		151,
		158,
		149,
		149,
		152,
		167,
		172,
		164,
		178,
		178,
		179,
		-1,
		209,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		205,
		-1,
		202,
		-1,
		177,
		181,
		185,
		188,
		185,
		172,
		164,
		156,
		172,
		147,
		157,
		153,
		154,
		163,
		174,
		186,
		185,
		186,
		279,
		235,
		205,
		196,
		243,
		258,
		262,
		-1,
		196,
		235,
		243,
		-1,
		214,
		-1,
		-1,
		-1,
		191,
		198,
		190,
		205,
		184,
		184,
		158,
		162,
		152,
		159,
		169,
		171,
		163,
		167,
		180,
		191,
		194,
		275,
		266,
		279,
		224,
		210,
		228,
		237,
		258,
		211,
		202,
		229,
		250,
		239,
		234,
		221,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		191,
		179,
		162,
		163,
		159,
		162,
		177,
		180,
		170,
		168,
		162,
		194,
		-1,
		268,
		267,
		256,
		253,
		229,
		220,
		215,
		229,
		-1,
		-1,
		214,
		230,
		243,
		247,
		263,
		288,
		-1,
		224,
		-1,
		-1,
		235,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		167,
		178,
		188,
		176,
		177,
		167,
		177,
		190,
		252,
		249,
		237,
		235,
		258,
		223,
		211,
		-1,
		224,
		217,
		223,
		230,
		247,
		277,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		219,
		217,
		206,
		-1,
		196,
		169,
		174,
		194,
		196,
		185,
		179,
		173,
		180,
		179,
		187,
		195,
		261,
		275,
		264,
		260,
		259,
		267,
		216,
		209,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		257,
		250,
		-1,
		-1,
		214,
		207,
		195,
		183,
		173,
		183,
		187,
		191,
		183,
		176,
		171,
		182,
		174,
		178,
		195,
		-1,
		295,
		-1,
		247,
		223,
		237,
		252,
		260,
		-1,
		-1,
		-1,
		274,
		260,
		253,
		241,
		239,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		177,
		188,
		177,
		180,
		194,
		189,
		-1,
		-1,
		235,
		238,
		-1,
		-1,
		260,
		266,
		-1,
		265,
		254,
		239,
		231,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		184,
		209,
		198,
		206,
		201,
		181,
		187,
		190,
		179,
		183,
		195,
		-1,
		-1,
		242,
		243,
		248,
		-1,
		249,
		-1,
		267,
		-1,
		234,
		240,
		228,
		-1,
		-1,
		-1,
		222,
		185,
		206,
		216,
		210,
		208,
		199,
		185,
		192,
		190,
		186,
		197,
		-1,
		-1,
		-1,
		267,
		241,
		274,
		265,
		248,
		228,
		220,
		239,
		-1,
		209,
		-1,
		184,
		186,
		212,
		215,
		221,
		215,
		188,
		203,
		193,
		184,
		193,
		273,
		-1,
		243,
		276,
		240,
		234,
		210,
		214,
		230,
		-1,
		206,
		188,
		-1,
		216,
		206,
		237,
		222,
		203,
		190,
		197,
		197,
		190,
		-1,
		-1,
		-1,
		245,
		244,
		236,
		230,
		230,
		215,
		206,
		-1,
		218,
		200,
		179,
		196,
		196,
		187,
		195,
		227,
		223,
		210,
		210,
		202,
		-1,
		346,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		239,
		234,
		207,
		195,
		201,
		197,
		183,
		189,
		191,
		199,
		197,
		194,
		206,
		202,
		222,
		203,
		238,
		-1,
		341,
		-1,
		275,
		-1,
		-1,
		257,
		237,
		229,
		218,
		207,
		205,
		196,
		187,
		209,
		225,
		209,
		207,
		210,
		211,
		-1,
		330,
		329,
		-1,
		276,
		268,
		254,
		-1,
		247,
		-1,
		253,
		214,
		-1,
		216,
		196,
		-1,
		218,
		214,
		-1,
		-1,
		317,
		292,
		-1,
		-1,
		-1,
		277,
		257,
		248,
		232,
		-1,
		207,
		207,
		-1,
		-1,
		-1,
		302,
		301,
		-1,
		270,
		273,
		-1,
		263,
		254,
		262,
		209,
		213,
		-1,
		-1,
		-1,
		311,
		292,
		286,
		285,
		283,
		278,
		275,
		261,
		245,
		223,
		212,
		233,
		-1,
		-1,
		-1,
		283,
		275,
		268,
		-1,
		-1,
		270,
		253,
		234,
		232,
		-1,
		-1,
		-1,
		305,
		286,
		-1,
		-1,
		260,
		-1,
		-1,
		266,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		322,
		294,
		-1,
		-1,
		-1,
		256,
		252,
		253,
		-1,
		-1,
		-1,
		-1,
		316,
		317,
		340,
		304,
		-1,
		-1,
		-1,
		248,
		242,
		-1,
		-1,
		319,
		317,
		-1,
		-1,
		-1,
		276,
		260,
		-1,
		246,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		281,
		-1,
		281,
		256,
		263,
		-1,
		-1,
		-1,
		-1,
		294,
		286,
		294,
		-1,
		266,
		268,
		-1,
		316,
		-1,
		-1,
		309,
		300,
		-1,
		-1,
		271,
		278,
		300,
		303,
		339,
		-1,
		290
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		202,
		204,
		170,
		164,
		203,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		193,
		192,
		162,
		160,
		169,
		174,
		181,
		-1,
		185,
		-1,
		214,
		193,
		204,
		209,
		155,
		152,
		172,
		191,
		178,
		170,
		229,
		185,
		156,
		150,
		168,
		163,
		172,
		164,
		-1,
		156,
		146,
		168,
		152,
		163,
		155,
		-1,
		-1,
		150,
		151,
		157,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		140,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		129,
		147,
		156,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		142,
		-1,
		122,
		124,
		134,
		142,
		147,
		131,
		118,
		118,
		128,
		121,
		140,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		119,
		121,
		138,
		130,
		120,
		135,
		128,
		121,
		118,
		116,
		113,
		129,
		130,
		140,
		-1,
		-1,
		175,
		144,
		179,
		136,
		121,
		-1,
		115,
		114,
		120,
		124,
		118,
		111,
		125,
		121,
		-1,
		107,
		106,
		137,
		123,
		134,
		135,
		-1,
		-1,
		133,
		125,
		110,
		113,
		110,
		110,
		129,
		128,
		120,
		106,
		102,
		108,
		111,
		111,
		117,
		101,
		111,
		115,
		126,
		141,
		-1,
		-1,
		196,
		-1,
		-1,
		132,
		115,
		-1,
		98,
		105,
		105,
		122,
		112,
		133,
		139,
		130,
		122,
		116,
		104,
		106,
		103,
		116,
		104,
		98,
		123,
		127,
		121,
		142,
		137,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		91,
		94,
		100,
		124,
		134,
		-1,
		124,
		130,
		140,
		125,
		122,
		109,
		97,
		110,
		95,
		102,
		101,
		105,
		107,
		140,
		118,
		140,
		137,
		166,
		171,
		165,
		174,
		-1,
		140,
		136,
		132,
		139,
		88,
		-1,
		-1,
		128,
		-1,
		142,
		141,
		116,
		134,
		137,
		126,
		117,
		104,
		93,
		104,
		93,
		90,
		98,
		107,
		118,
		113,
		112,
		130,
		145,
		158,
		162,
		168,
		-1,
		190,
		-1,
		132,
		116,
		118,
		90,
		111,
		-1,
		148,
		143,
		133,
		118,
		109,
		-1,
		112,
		115,
		122,
		100,
		85,
		102,
		94,
		92,
		97,
		102,
		116,
		107,
		125,
		132,
		140,
		144,
		164,
		176,
		150,
		140,
		-1,
		122,
		127,
		86,
		94,
		113,
		151,
		115,
		-1,
		110,
		-1,
		102,
		127,
		-1,
		106,
		102,
		84,
		85,
		80,
		95,
		101,
		98,
		95,
		113,
		116,
		133,
		137,
		153,
		-1,
		-1,
		135,
		139,
		128,
		79,
		98,
		122,
		159,
		108,
		97,
		96,
		-1,
		87,
		117,
		114,
		100,
		87,
		77,
		78,
		86,
		99,
		78,
		97,
		100,
		122,
		150,
		128,
		140,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		105,
		76,
		100,
		142,
		126,
		119,
		107,
		72,
		72,
		66,
		-1,
		107,
		90,
		86,
		75,
		73,
		86,
		81,
		97,
		101,
		100,
		119,
		131,
		122,
		142,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		71,
		94,
		131,
		105,
		91,
		96,
		71,
		64,
		58,
		110,
		107,
		74,
		82,
		74,
		63,
		77,
		85,
		89,
		98,
		107,
		113,
		137,
		137,
		143,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		85,
		92,
		124,
		96,
		109,
		-1,
		63,
		-1,
		52,
		60,
		59,
		65,
		77,
		63,
		68,
		79,
		91,
		104,
		100,
		107,
		142,
		142,
		127,
		147,
		150,
		-1,
		-1,
		-1,
		135,
		130,
		105,
		82,
		66,
		102,
		-1,
		79,
		80,
		-1,
		57,
		51,
		57,
		56,
		63,
		60,
		60,
		74,
		82,
		78,
		94,
		100,
		92,
		128,
		-1,
		135,
		129,
		137,
		127,
		115,
		-1,
		-1,
		-1,
		128,
		107,
		100,
		120,
		61,
		113,
		-1,
		-1,
		64,
		57,
		-1,
		44,
		44,
		51,
		60,
		65,
		70,
		78,
		73,
		86,
		91,
		97,
		102,
		120,
		124,
		128,
		117,
		113,
		110,
		124,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		61,
		81,
		-1,
		73,
		65,
		55,
		49,
		43,
		46,
		48,
		75,
		67,
		81,
		81,
		87,
		95,
		80,
		83,
		99,
		97,
		115,
		123,
		115,
		109,
		108,
		120,
		-1,
		148,
		134,
		105,
		-1,
		-1,
		94,
		-1,
		58,
		72,
		88,
		-1,
		81,
		60,
		75,
		53,
		49,
		63,
		101,
		102,
		80,
		85,
		93,
		103,
		105,
		94,
		105,
		97,
		119,
		119,
		103,
		104,
		113,
		-1,
		154,
		141,
		99,
		95,
		84,
		104,
		55,
		43,
		75,
		-1,
		-1,
		48,
		-1,
		27,
		29,
		77,
		75,
		91,
		82,
		88,
		104,
		107,
		109,
		99,
		88,
		94,
		91,
		113,
		99,
		97,
		116,
		132,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		70,
		57,
		51,
		-1,
		92,
		-1,
		26,
		16,
		0,
		22,
		48,
		-1,
		99,
		83,
		88,
		-1,
		134,
		-1,
		107,
		109,
		103,
		88,
		85,
		96,
		94,
		105,
		122,
		-1,
		104,
		89,
		82,
		72,
		86,
		57,
		-1,
		112,
		-1,
		-1,
		13,
		7,
		7,
		28,
		31,
		115,
		95,
		89,
		88,
		129,
		129,
		115,
		101,
		94,
		91,
		88,
		101,
		121,
		112,
		124,
		-1,
		-1,
		-1,
		109,
		95,
		99,
		59,
		78,
		-1,
		-1,
		75,
		30,
		16,
		-1,
		37,
		132,
		120,
		110,
		100,
		134,
		135,
		120,
		113,
		99,
		101,
		99,
		97,
		102,
		123,
		124,
		137,
		-1,
		-1,
		92,
		97,
		85,
		71,
		90,
		-1,
		-1,
		-1,
		24,
		40,
		62,
		37,
		121,
		-1,
		-1,
		112,
		110,
		120,
		116,
		103,
		123,
		126,
		112,
		96,
		111,
		123,
		131,
		136,
		-1,
		95,
		82,
		-1,
		-1,
		93,
		87,
		-1,
		-1,
		-1,
		-1,
		63,
		57,
		69,
		90,
		115,
		115,
		-1,
		120,
		121,
		107,
		121,
		128,
		114,
		109,
		103,
		106,
		124,
		141,
		-1,
		-1,
		107,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		48,
		62,
		83,
		89,
		101,
		-1,
		127,
		123,
		109,
		126,
		127,
		124,
		115,
		107,
		112,
		109,
		122,
		136,
		140,
		130,
		-1,
		113,
		-1,
		-1,
		-1,
		66,
		81,
		143,
		120,
		93,
		98,
		108,
		113,
		117,
		133,
		135,
		146,
		114,
		110,
		111,
		115,
		114,
		131,
		141,
		-1,
		-1,
		113,
		127,
		92,
		74,
		78,
		170,
		-1,
		-1,
		108,
		114,
		110,
		120,
		127,
		130,
		120,
		117,
		122,
		127,
		115,
		124,
		142,
		146,
		-1,
		-1,
		-1,
		133,
		-1,
		125,
		-1,
		-1,
		93,
		194,
		141,
		123,
		119,
		117,
		122,
		131,
		126,
		125,
		135,
		144,
		136,
		117,
		128,
		151,
		140,
		178,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		162,
		137,
		152,
		178,
		113,
		120,
		156,
		153,
		-1,
		123,
		160,
		132,
		139,
		131,
		143,
		143,
		140,
		118,
		125,
		141,
		140,
		135,
		170,
		162,
		168,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		168,
		154,
		164,
		154,
		130,
		-1,
		-1,
		172,
		169,
		147,
		141,
		145,
		138,
		133,
		147,
		127,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		140,
		221,
		214,
		197,
		205,
		236,
		-1,
		171,
		164,
		161,
		150,
		141,
		-1,
		-1,
		145,
		142,
		147,
		148,
		145,
		157,
		152,
		143,
		128,
		134,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		154,
		197,
		191,
		194,
		218,
		232,
		-1,
		169,
		-1,
		-1,
		169,
		154,
		160,
		150,
		144,
		194,
		162,
		157,
		151,
		149,
		140,
		131,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		189,
		177,
		185,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		162,
		166,
		170,
		173,
		165,
		152,
		144,
		136,
		152,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		263,
		218,
		185,
		176,
		223,
		238,
		242,
		-1,
		181,
		220,
		223,
		-1,
		194,
		-1,
		-1,
		-1,
		176,
		183,
		175,
		185,
		164,
		164,
		138,
		142,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		259,
		251,
		262,
		207,
		190,
		208,
		217,
		238,
		196,
		187,
		214,
		230,
		219,
		214,
		201,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		171,
		159,
		142,
		143,
		139,
		142,
		157,
		160,
		150,
		148,
		142,
		174,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		198,
		209,
		-1,
		-1,
		199,
		215,
		228,
		232,
		248,
		273,
		-1,
		204,
		-1,
		-1,
		216,
		-1,
		-1,
		201,
		164,
		153,
		144,
		150,
		147,
		158,
		168,
		156,
		157,
		147,
		157,
		170,
		237,
		234,
		222,
		220,
		243,
		206,
		196,
		-1,
		209,
		202,
		208,
		215,
		232,
		262,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		199,
		197,
		186,
		-1,
		176,
		149,
		154,
		174,
		176,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		194,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		237,
		230,
		-1,
		-1,
		194,
		187,
		175,
		163,
		153,
		163,
		167,
		171,
		163,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		280,
		-1,
		232,
		208,
		222,
		237,
		245,
		-1,
		-1,
		-1,
		254,
		240,
		233,
		221,
		219,
		-1,
		228,
		212,
		193,
		-1,
		163,
		176,
		207,
		175,
		180,
		175,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		220,
		223,
		-1,
		-1,
		244,
		246,
		-1,
		245,
		234,
		219,
		211,
		-1,
		-1,
		200,
		196,
		-1,
		-1,
		164,
		189,
		178,
		186,
		181,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		227,
		228,
		233,
		-1,
		229,
		-1,
		247,
		-1,
		214,
		220,
		208,
		-1,
		-1,
		-1,
		202,
		165,
		186,
		196,
		190,
		188,
		179,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		247,
		221,
		254,
		245,
		228,
		208,
		200,
		219,
		-1,
		189,
		-1,
		164,
		166,
		192,
		195,
		201,
		195,
		168,
		183,
		173,
		164,
		173,
		253,
		-1,
		223,
		256,
		220,
		214,
		190,
		194,
		210,
		-1,
		186,
		168,
		-1,
		196,
		186,
		217,
		202,
		183,
		170,
		177,
		177,
		170,
		-1,
		-1,
		-1,
		225,
		224,
		216,
		210,
		210,
		195,
		186,
		-1,
		198,
		180,
		159,
		176,
		176,
		167,
		175,
		207,
		203,
		190,
		190,
		182,
		-1,
		326,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		219,
		214,
		187,
		175,
		181,
		177,
		163,
		169,
		171,
		179,
		177,
		174,
		186,
		182,
		202,
		183,
		218,
		-1,
		321,
		-1,
		255,
		-1,
		-1,
		237,
		217,
		209,
		198,
		187,
		185,
		176,
		167,
		189,
		205,
		189,
		187,
		190,
		191,
		-1,
		310,
		309,
		-1,
		256,
		248,
		234,
		-1,
		227,
		-1,
		233,
		194,
		-1,
		196,
		176,
		-1,
		198,
		194,
		-1,
		-1,
		297,
		272,
		-1,
		-1,
		-1,
		257,
		237,
		228,
		212,
		-1,
		187,
		187,
		-1,
		-1,
		-1,
		282,
		281,
		-1,
		250,
		253,
		-1,
		243,
		234,
		242,
		189,
		193,
		-1,
		-1,
		-1,
		291,
		272,
		266,
		265,
		263,
		258,
		255,
		241,
		225,
		203,
		192,
		213,
		-1,
		-1,
		-1,
		263,
		255,
		248,
		-1,
		-1,
		250,
		233,
		214,
		212,
		-1,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		240,
		-1,
		-1,
		246,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		274,
		-1,
		-1,
		-1,
		236,
		232,
		233,
		-1,
		-1,
		-1,
		-1,
		296,
		297,
		320,
		284,
		-1,
		-1,
		-1,
		228,
		222,
		-1,
		-1,
		299,
		297,
		-1,
		-1,
		-1,
		256,
		240,
		-1,
		226,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		261,
		-1,
		261,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		274,
		266,
		274,
		-1,
		246,
		248,
		-1,
		296,
		-1,
		-1,
		289,
		280,
		-1,
		-1,
		251,
		258,
		280,
		283,
		319,
		-1,
		270
	],
	[
		-1,
		177,
		166,
		177,
		185,
		158,
		165,
		-1,
		186,
		188,
		154,
		148,
		187,
		158,
		164,
		175,
		-1,
		-1,
		-1,
		177,
		176,
		146,
		144,
		153,
		158,
		165,
		-1,
		169,
		-1,
		198,
		177,
		188,
		193,
		139,
		136,
		156,
		175,
		162,
		154,
		213,
		169,
		140,
		134,
		152,
		147,
		156,
		148,
		-1,
		140,
		130,
		152,
		136,
		147,
		139,
		-1,
		-1,
		134,
		135,
		141,
		132,
		138,
		134,
		-1,
		144,
		128,
		-1,
		-1,
		124,
		130,
		114,
		117,
		125,
		123,
		136,
		128,
		123,
		-1,
		-1,
		120,
		116,
		123,
		110,
		106,
		123,
		136,
		118,
		132,
		131,
		-1,
		113,
		131,
		140,
		117,
		115,
		99,
		97,
		115,
		117,
		123,
		126,
		-1,
		106,
		108,
		118,
		126,
		131,
		115,
		102,
		102,
		112,
		105,
		124,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		105,
		122,
		114,
		104,
		119,
		112,
		105,
		102,
		100,
		97,
		113,
		114,
		124,
		-1,
		-1,
		159,
		128,
		163,
		120,
		105,
		-1,
		99,
		98,
		104,
		108,
		102,
		95,
		109,
		105,
		-1,
		91,
		90,
		121,
		107,
		118,
		119,
		-1,
		-1,
		117,
		109,
		94,
		97,
		94,
		94,
		113,
		112,
		104,
		90,
		86,
		92,
		95,
		95,
		101,
		85,
		95,
		99,
		110,
		125,
		-1,
		-1,
		180,
		-1,
		-1,
		116,
		99,
		-1,
		82,
		89,
		89,
		106,
		96,
		117,
		123,
		114,
		106,
		100,
		88,
		90,
		87,
		100,
		88,
		82,
		107,
		111,
		105,
		126,
		121,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		75,
		78,
		84,
		108,
		118,
		-1,
		108,
		114,
		124,
		109,
		106,
		93,
		81,
		94,
		79,
		86,
		85,
		89,
		91,
		124,
		102,
		124,
		121,
		150,
		155,
		149,
		158,
		-1,
		124,
		120,
		116,
		123,
		72,
		-1,
		-1,
		112,
		-1,
		126,
		125,
		100,
		118,
		121,
		110,
		101,
		88,
		77,
		88,
		77,
		74,
		82,
		91,
		102,
		97,
		96,
		114,
		129,
		142,
		146,
		152,
		-1,
		174,
		-1,
		116,
		100,
		102,
		74,
		95,
		-1,
		132,
		127,
		117,
		102,
		93,
		-1,
		96,
		99,
		106,
		84,
		69,
		86,
		78,
		76,
		81,
		86,
		100,
		91,
		109,
		116,
		124,
		128,
		148,
		160,
		134,
		124,
		-1,
		106,
		111,
		70,
		78,
		97,
		135,
		99,
		-1,
		94,
		-1,
		86,
		111,
		-1,
		90,
		86,
		68,
		69,
		64,
		79,
		85,
		82,
		79,
		97,
		100,
		117,
		121,
		137,
		-1,
		-1,
		119,
		123,
		112,
		63,
		82,
		106,
		143,
		92,
		81,
		80,
		-1,
		71,
		101,
		98,
		84,
		71,
		61,
		62,
		70,
		83,
		62,
		81,
		84,
		106,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		89,
		60,
		84,
		126,
		110,
		103,
		91,
		56,
		56,
		50,
		-1,
		91,
		74,
		70,
		59,
		57,
		70,
		65,
		81,
		85,
		84,
		103,
		115,
		106,
		126,
		-1,
		-1,
		-1,
		119,
		108,
		109,
		55,
		78,
		115,
		89,
		75,
		80,
		55,
		48,
		42,
		94,
		91,
		58,
		66,
		58,
		47,
		61,
		69,
		73,
		82,
		91,
		97,
		121,
		121,
		127,
		-1,
		-1,
		126,
		116,
		100,
		102,
		99,
		69,
		76,
		108,
		80,
		93,
		-1,
		47,
		-1,
		36,
		44,
		43,
		49,
		61,
		47,
		52,
		63,
		75,
		88,
		84,
		91,
		126,
		126,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		119,
		114,
		89,
		66,
		50,
		86,
		-1,
		63,
		64,
		-1,
		41,
		35,
		41,
		40,
		47,
		44,
		44,
		58,
		66,
		62,
		78,
		84,
		76,
		112,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		112,
		91,
		84,
		104,
		45,
		97,
		-1,
		-1,
		48,
		41,
		-1,
		28,
		28,
		35,
		44,
		49,
		54,
		62,
		57,
		70,
		75,
		81,
		86,
		104,
		108,
		112,
		101,
		97,
		94,
		108,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		65,
		-1,
		57,
		49,
		39,
		33,
		27,
		38,
		39,
		59,
		51,
		65,
		65,
		71,
		79,
		64,
		67,
		83,
		81,
		99,
		107,
		99,
		93,
		92,
		104,
		-1,
		132,
		118,
		89,
		-1,
		-1,
		78,
		-1,
		42,
		56,
		72,
		-1,
		65,
		44,
		59,
		37,
		41,
		47,
		85,
		86,
		64,
		69,
		77,
		87,
		89,
		78,
		89,
		81,
		103,
		103,
		87,
		88,
		97,
		-1,
		138,
		125,
		83,
		79,
		68,
		88,
		39,
		27,
		59,
		-1,
		-1,
		65,
		-1,
		19,
		21,
		61,
		59,
		75,
		66,
		72,
		88,
		91,
		93,
		83,
		72,
		78,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		54,
		41,
		35,
		-1,
		76,
		-1,
		43,
		31,
		18,
		0,
		40,
		-1,
		83,
		67,
		72,
		-1,
		118,
		-1,
		91,
		93,
		87,
		72,
		69,
		80,
		78,
		89,
		106,
		-1,
		88,
		73,
		66,
		56,
		70,
		41,
		-1,
		96,
		-1,
		-1,
		30,
		24,
		24,
		6,
		9,
		99,
		79,
		73,
		72,
		113,
		113,
		99,
		85,
		78,
		75,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		93,
		79,
		83,
		43,
		62,
		-1,
		-1,
		91,
		47,
		33,
		-1,
		15,
		116,
		104,
		94,
		84,
		118,
		119,
		104,
		97,
		83,
		85,
		83,
		81,
		86,
		107,
		108,
		121,
		-1,
		-1,
		76,
		81,
		69,
		55,
		74,
		-1,
		-1,
		-1,
		37,
		53,
		45,
		16,
		105,
		-1,
		-1,
		96,
		94,
		104,
		100,
		87,
		107,
		110,
		96,
		80,
		95,
		107,
		115,
		120,
		-1,
		79,
		66,
		-1,
		-1,
		77,
		71,
		-1,
		-1,
		-1,
		-1,
		70,
		36,
		48,
		69,
		94,
		99,
		-1,
		104,
		105,
		91,
		105,
		112,
		98,
		93,
		87,
		90,
		108,
		125,
		-1,
		-1,
		91,
		-1,
		86,
		-1,
		-1,
		-1,
		-1,
		27,
		41,
		62,
		68,
		80,
		-1,
		106,
		107,
		93,
		110,
		111,
		108,
		99,
		91,
		96,
		93,
		106,
		120,
		124,
		114,
		-1,
		97,
		-1,
		-1,
		-1,
		45,
		60,
		122,
		99,
		72,
		77,
		87,
		92,
		97,
		117,
		119,
		130,
		98,
		94,
		95,
		99,
		98,
		115,
		125,
		-1,
		-1,
		97,
		106,
		71,
		53,
		57,
		149,
		-1,
		-1,
		87,
		93,
		89,
		99,
		107,
		110,
		104,
		101,
		106,
		111,
		99,
		108,
		126,
		130,
		-1,
		-1,
		-1,
		117,
		-1,
		104,
		-1,
		-1,
		72,
		173,
		120,
		102,
		98,
		96,
		101,
		110,
		105,
		109,
		119,
		128,
		120,
		101,
		112,
		135,
		124,
		162,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		146,
		121,
		136,
		157,
		92,
		99,
		135,
		132,
		-1,
		102,
		139,
		111,
		118,
		110,
		123,
		127,
		124,
		102,
		109,
		125,
		124,
		119,
		154,
		146,
		152,
		-1,
		-1,
		229,
		218,
		207,
		213,
		-1,
		152,
		138,
		143,
		133,
		109,
		-1,
		-1,
		151,
		148,
		126,
		120,
		124,
		117,
		112,
		131,
		111,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		124,
		205,
		198,
		181,
		189,
		220,
		-1,
		151,
		143,
		145,
		129,
		120,
		-1,
		-1,
		124,
		121,
		126,
		127,
		124,
		136,
		135,
		127,
		112,
		118,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		138,
		181,
		175,
		178,
		202,
		216,
		-1,
		148,
		-1,
		-1,
		153,
		133,
		139,
		129,
		123,
		173,
		141,
		136,
		135,
		133,
		124,
		115,
		122,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		173,
		161,
		169,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		169,
		-1,
		166,
		-1,
		141,
		145,
		149,
		152,
		149,
		136,
		128,
		120,
		136,
		111,
		121,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		243,
		199,
		169,
		160,
		207,
		222,
		226,
		-1,
		160,
		199,
		207,
		-1,
		178,
		-1,
		-1,
		-1,
		155,
		162,
		154,
		169,
		148,
		148,
		122,
		126,
		116,
		123,
		133,
		135,
		127,
		131,
		144,
		155,
		158,
		239,
		230,
		243,
		188,
		174,
		192,
		201,
		222,
		175,
		166,
		193,
		214,
		203,
		198,
		185,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		155,
		143,
		126,
		127,
		123,
		126,
		141,
		144,
		134,
		132,
		126,
		158,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		179,
		193,
		-1,
		-1,
		178,
		194,
		207,
		211,
		227,
		252,
		-1,
		188,
		-1,
		-1,
		199,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		131,
		142,
		152,
		140,
		141,
		131,
		141,
		154,
		216,
		213,
		201,
		199,
		222,
		187,
		175,
		-1,
		188,
		181,
		187,
		194,
		211,
		241,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		183,
		181,
		170,
		-1,
		160,
		133,
		138,
		158,
		160,
		149,
		143,
		137,
		144,
		143,
		151,
		159,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		173,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		-1,
		221,
		214,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		151,
		155,
		147,
		140,
		135,
		146,
		138,
		142,
		159,
		-1,
		259,
		-1,
		211,
		187,
		201,
		216,
		224,
		-1,
		-1,
		-1,
		238,
		224,
		217,
		205,
		203,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		141,
		152,
		141,
		144,
		158,
		153,
		-1,
		-1,
		199,
		202,
		-1,
		-1,
		224,
		230,
		-1,
		229,
		218,
		203,
		195,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		145,
		151,
		154,
		143,
		147,
		159,
		-1,
		-1,
		206,
		207,
		212,
		-1,
		213,
		-1,
		231,
		-1,
		198,
		204,
		192,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		174,
		172,
		163,
		149,
		156,
		154,
		150,
		161,
		-1,
		-1,
		-1,
		231,
		205,
		238,
		229,
		212,
		192,
		184,
		203,
		-1,
		173,
		-1,
		148,
		150,
		176,
		179,
		185,
		179,
		152,
		167,
		157,
		148,
		157,
		237,
		-1,
		207,
		240,
		204,
		198,
		174,
		178,
		194,
		-1,
		170,
		152,
		-1,
		180,
		170,
		201,
		186,
		167,
		154,
		161,
		161,
		154,
		-1,
		-1,
		-1,
		209,
		208,
		200,
		194,
		194,
		179,
		170,
		-1,
		182,
		164,
		143,
		160,
		160,
		151,
		159,
		191,
		187,
		174,
		174,
		166,
		-1,
		310,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		203,
		198,
		171,
		159,
		165,
		161,
		147,
		153,
		155,
		163,
		161,
		158,
		170,
		166,
		186,
		167,
		202,
		-1,
		305,
		-1,
		239,
		-1,
		-1,
		221,
		201,
		193,
		182,
		171,
		169,
		160,
		151,
		173,
		189,
		173,
		171,
		174,
		175,
		-1,
		294,
		293,
		-1,
		240,
		232,
		218,
		-1,
		211,
		-1,
		217,
		178,
		-1,
		180,
		160,
		-1,
		182,
		178,
		-1,
		-1,
		281,
		256,
		-1,
		-1,
		-1,
		241,
		221,
		212,
		196,
		-1,
		171,
		171,
		-1,
		-1,
		-1,
		266,
		265,
		-1,
		234,
		237,
		-1,
		227,
		218,
		226,
		173,
		177,
		-1,
		-1,
		-1,
		275,
		256,
		250,
		249,
		247,
		242,
		239,
		225,
		209,
		187,
		176,
		197,
		-1,
		-1,
		-1,
		247,
		239,
		232,
		-1,
		-1,
		234,
		217,
		198,
		196,
		-1,
		-1,
		-1,
		269,
		250,
		-1,
		-1,
		224,
		-1,
		-1,
		230,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		258,
		-1,
		-1,
		-1,
		220,
		216,
		217,
		-1,
		-1,
		-1,
		-1,
		280,
		281,
		304,
		268,
		-1,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		283,
		281,
		-1,
		-1,
		-1,
		240,
		224,
		-1,
		210,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		245,
		-1,
		245,
		220,
		227,
		-1,
		-1,
		-1,
		-1,
		258,
		250,
		258,
		-1,
		230,
		232,
		-1,
		280,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		235,
		242,
		264,
		267,
		303,
		-1,
		254
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		222,
		224,
		190,
		184,
		223,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		213,
		212,
		182,
		180,
		189,
		194,
		201,
		-1,
		205,
		-1,
		234,
		213,
		224,
		229,
		175,
		172,
		192,
		211,
		198,
		190,
		249,
		205,
		176,
		170,
		188,
		183,
		192,
		184,
		-1,
		176,
		166,
		188,
		172,
		183,
		175,
		-1,
		-1,
		170,
		171,
		177,
		168,
		174,
		170,
		-1,
		180,
		164,
		-1,
		-1,
		160,
		166,
		150,
		153,
		161,
		159,
		172,
		164,
		159,
		-1,
		-1,
		156,
		152,
		159,
		146,
		142,
		159,
		172,
		154,
		168,
		167,
		-1,
		149,
		167,
		176,
		153,
		151,
		135,
		133,
		151,
		153,
		159,
		162,
		-1,
		142,
		144,
		154,
		162,
		167,
		151,
		138,
		138,
		148,
		141,
		160,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		139,
		141,
		158,
		150,
		140,
		155,
		148,
		141,
		138,
		136,
		133,
		149,
		150,
		160,
		-1,
		-1,
		195,
		164,
		199,
		156,
		141,
		-1,
		135,
		134,
		140,
		144,
		138,
		131,
		145,
		141,
		-1,
		127,
		126,
		157,
		143,
		154,
		155,
		-1,
		-1,
		153,
		145,
		130,
		133,
		130,
		130,
		149,
		148,
		140,
		126,
		122,
		128,
		131,
		131,
		137,
		121,
		131,
		135,
		146,
		161,
		-1,
		-1,
		216,
		-1,
		-1,
		152,
		135,
		-1,
		118,
		125,
		125,
		142,
		132,
		153,
		159,
		150,
		142,
		136,
		124,
		126,
		123,
		136,
		124,
		118,
		143,
		147,
		141,
		162,
		157,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		111,
		114,
		120,
		144,
		154,
		-1,
		144,
		150,
		160,
		145,
		142,
		129,
		117,
		130,
		115,
		122,
		121,
		125,
		127,
		160,
		138,
		160,
		157,
		186,
		191,
		185,
		194,
		-1,
		160,
		156,
		152,
		159,
		108,
		-1,
		-1,
		148,
		-1,
		162,
		161,
		136,
		154,
		157,
		146,
		137,
		124,
		113,
		124,
		113,
		110,
		118,
		127,
		138,
		133,
		132,
		150,
		165,
		178,
		182,
		188,
		-1,
		210,
		-1,
		152,
		136,
		138,
		110,
		131,
		-1,
		168,
		163,
		153,
		138,
		129,
		-1,
		132,
		135,
		142,
		120,
		105,
		122,
		114,
		112,
		117,
		122,
		136,
		127,
		145,
		152,
		160,
		164,
		184,
		196,
		170,
		160,
		-1,
		142,
		147,
		106,
		114,
		133,
		171,
		135,
		-1,
		130,
		-1,
		122,
		147,
		-1,
		126,
		122,
		104,
		105,
		100,
		115,
		121,
		118,
		115,
		133,
		136,
		153,
		157,
		173,
		-1,
		-1,
		155,
		159,
		148,
		99,
		118,
		142,
		179,
		128,
		117,
		116,
		-1,
		107,
		137,
		134,
		120,
		107,
		97,
		98,
		106,
		119,
		98,
		117,
		120,
		142,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		125,
		96,
		120,
		162,
		146,
		139,
		127,
		92,
		92,
		86,
		-1,
		127,
		110,
		106,
		95,
		93,
		106,
		101,
		117,
		121,
		120,
		139,
		151,
		142,
		162,
		-1,
		-1,
		-1,
		155,
		144,
		145,
		91,
		114,
		151,
		125,
		111,
		116,
		91,
		84,
		78,
		130,
		127,
		94,
		102,
		94,
		83,
		97,
		105,
		109,
		118,
		127,
		133,
		157,
		157,
		163,
		-1,
		-1,
		162,
		152,
		136,
		138,
		135,
		105,
		112,
		144,
		116,
		129,
		-1,
		83,
		-1,
		72,
		80,
		79,
		85,
		97,
		83,
		88,
		99,
		111,
		124,
		120,
		127,
		162,
		162,
		147,
		167,
		170,
		-1,
		-1,
		-1,
		155,
		150,
		125,
		102,
		86,
		122,
		-1,
		99,
		100,
		-1,
		77,
		71,
		77,
		76,
		83,
		80,
		80,
		94,
		102,
		98,
		114,
		120,
		112,
		148,
		-1,
		155,
		149,
		157,
		147,
		135,
		-1,
		-1,
		-1,
		148,
		127,
		120,
		140,
		81,
		133,
		-1,
		-1,
		84,
		77,
		-1,
		64,
		64,
		71,
		80,
		85,
		90,
		98,
		93,
		106,
		111,
		117,
		122,
		140,
		144,
		148,
		137,
		133,
		130,
		144,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		101,
		-1,
		93,
		85,
		75,
		69,
		63,
		64,
		66,
		95,
		87,
		101,
		101,
		107,
		115,
		100,
		103,
		119,
		117,
		135,
		143,
		135,
		129,
		128,
		140,
		-1,
		168,
		154,
		125,
		-1,
		-1,
		114,
		-1,
		78,
		92,
		108,
		-1,
		101,
		80,
		95,
		73,
		67,
		83,
		121,
		122,
		100,
		105,
		113,
		123,
		125,
		114,
		125,
		117,
		139,
		139,
		123,
		124,
		133,
		-1,
		174,
		161,
		119,
		115,
		104,
		124,
		75,
		63,
		95,
		-1,
		-1,
		98,
		-1,
		47,
		42,
		97,
		95,
		111,
		102,
		108,
		124,
		127,
		129,
		119,
		108,
		114,
		111,
		133,
		119,
		117,
		136,
		152,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		90,
		77,
		71,
		-1,
		112,
		-1,
		76,
		66,
		50,
		43,
		0,
		-1,
		119,
		103,
		108,
		-1,
		154,
		-1,
		127,
		129,
		123,
		108,
		105,
		116,
		114,
		125,
		142,
		-1,
		124,
		109,
		102,
		92,
		106,
		77,
		-1,
		132,
		-1,
		-1,
		63,
		57,
		57,
		49,
		52,
		135,
		115,
		109,
		108,
		149,
		149,
		135,
		121,
		114,
		111,
		108,
		121,
		141,
		132,
		144,
		-1,
		-1,
		-1,
		129,
		115,
		119,
		79,
		98,
		-1,
		-1,
		125,
		80,
		66,
		-1,
		58,
		152,
		140,
		130,
		120,
		154,
		155,
		140,
		133,
		119,
		121,
		119,
		117,
		122,
		143,
		144,
		157,
		-1,
		-1,
		112,
		117,
		105,
		91,
		110,
		-1,
		-1,
		-1,
		74,
		90,
		85,
		59,
		141,
		-1,
		-1,
		132,
		130,
		140,
		136,
		123,
		143,
		146,
		132,
		116,
		131,
		143,
		151,
		156,
		-1,
		115,
		102,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		-1,
		-1,
		113,
		79,
		91,
		112,
		137,
		135,
		-1,
		140,
		141,
		127,
		141,
		148,
		134,
		129,
		123,
		126,
		144,
		161,
		-1,
		-1,
		127,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		70,
		84,
		105,
		111,
		123,
		-1,
		149,
		143,
		129,
		146,
		147,
		144,
		135,
		127,
		132,
		129,
		142,
		156,
		160,
		150,
		-1,
		133,
		-1,
		-1,
		-1,
		88,
		103,
		165,
		142,
		115,
		120,
		130,
		135,
		137,
		153,
		155,
		166,
		134,
		130,
		131,
		135,
		134,
		151,
		161,
		-1,
		-1,
		133,
		149,
		114,
		96,
		100,
		192,
		-1,
		-1,
		130,
		136,
		132,
		142,
		147,
		150,
		140,
		137,
		142,
		147,
		135,
		144,
		162,
		166,
		-1,
		-1,
		-1,
		153,
		-1,
		147,
		-1,
		-1,
		115,
		216,
		163,
		145,
		141,
		139,
		144,
		153,
		148,
		145,
		155,
		164,
		156,
		137,
		148,
		171,
		160,
		198,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		182,
		157,
		172,
		200,
		135,
		142,
		178,
		175,
		-1,
		145,
		182,
		154,
		161,
		153,
		163,
		163,
		160,
		138,
		145,
		161,
		160,
		155,
		190,
		182,
		188,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		188,
		174,
		186,
		176,
		152,
		-1,
		-1,
		194,
		191,
		169,
		163,
		167,
		160,
		155,
		167,
		147,
		134,
		138,
		142,
		148,
		153,
		158,
		164,
		179,
		194,
		-1,
		160,
		241,
		234,
		217,
		225,
		256,
		-1,
		191,
		186,
		181,
		172,
		163,
		-1,
		-1,
		167,
		164,
		169,
		170,
		167,
		177,
		172,
		163,
		148,
		154,
		141,
		140,
		158,
		162,
		171,
		178,
		168,
		181,
		185,
		-1,
		174,
		217,
		211,
		214,
		238,
		252,
		-1,
		191,
		-1,
		-1,
		189,
		176,
		182,
		172,
		166,
		216,
		184,
		179,
		171,
		169,
		160,
		151,
		158,
		149,
		149,
		152,
		167,
		172,
		164,
		178,
		178,
		179,
		-1,
		209,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		205,
		-1,
		209,
		-1,
		184,
		188,
		192,
		195,
		185,
		172,
		164,
		156,
		172,
		147,
		157,
		153,
		154,
		163,
		174,
		186,
		185,
		186,
		283,
		238,
		205,
		196,
		243,
		258,
		262,
		-1,
		203,
		242,
		243,
		-1,
		214,
		-1,
		-1,
		-1,
		198,
		205,
		197,
		205,
		184,
		184,
		158,
		162,
		152,
		159,
		169,
		171,
		163,
		167,
		180,
		191,
		194,
		279,
		273,
		282,
		227,
		210,
		228,
		237,
		258,
		218,
		209,
		236,
		250,
		239,
		234,
		221,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		191,
		179,
		162,
		163,
		159,
		162,
		177,
		180,
		170,
		168,
		162,
		194,
		-1,
		275,
		274,
		263,
		260,
		236,
		227,
		218,
		229,
		-1,
		-1,
		221,
		237,
		250,
		254,
		270,
		295,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		167,
		178,
		188,
		176,
		177,
		167,
		177,
		190,
		259,
		256,
		244,
		242,
		265,
		226,
		218,
		-1,
		231,
		224,
		230,
		237,
		254,
		284,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		219,
		217,
		206,
		-1,
		196,
		169,
		174,
		194,
		196,
		185,
		179,
		173,
		180,
		179,
		187,
		195,
		268,
		282,
		271,
		267,
		266,
		274,
		223,
		216,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		-1,
		257,
		250,
		-1,
		-1,
		214,
		207,
		195,
		183,
		173,
		183,
		187,
		191,
		183,
		176,
		171,
		182,
		174,
		178,
		195,
		-1,
		302,
		-1,
		254,
		230,
		244,
		259,
		267,
		-1,
		-1,
		-1,
		274,
		260,
		253,
		241,
		239,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		177,
		188,
		177,
		180,
		194,
		189,
		-1,
		-1,
		242,
		245,
		-1,
		-1,
		264,
		266,
		-1,
		265,
		254,
		239,
		231,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		184,
		209,
		198,
		206,
		201,
		181,
		187,
		190,
		179,
		183,
		195,
		-1,
		-1,
		249,
		250,
		255,
		-1,
		249,
		-1,
		267,
		-1,
		234,
		240,
		228,
		-1,
		-1,
		-1,
		222,
		185,
		206,
		216,
		210,
		208,
		199,
		185,
		192,
		190,
		186,
		197,
		-1,
		-1,
		-1,
		267,
		241,
		274,
		265,
		248,
		228,
		220,
		239,
		-1,
		209,
		-1,
		184,
		186,
		212,
		215,
		221,
		215,
		188,
		203,
		193,
		184,
		193,
		273,
		-1,
		243,
		276,
		240,
		234,
		210,
		214,
		230,
		-1,
		206,
		188,
		-1,
		216,
		206,
		237,
		222,
		203,
		190,
		197,
		197,
		190,
		-1,
		-1,
		-1,
		245,
		244,
		236,
		230,
		230,
		215,
		206,
		-1,
		218,
		200,
		179,
		196,
		196,
		187,
		195,
		227,
		223,
		210,
		210,
		202,
		-1,
		346,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		239,
		234,
		207,
		195,
		201,
		197,
		183,
		189,
		191,
		199,
		197,
		194,
		206,
		202,
		222,
		203,
		238,
		-1,
		341,
		-1,
		275,
		-1,
		-1,
		257,
		237,
		229,
		218,
		207,
		205,
		196,
		187,
		209,
		225,
		209,
		207,
		210,
		211,
		-1,
		330,
		329,
		-1,
		276,
		268,
		254,
		-1,
		247,
		-1,
		253,
		214,
		-1,
		216,
		196,
		-1,
		218,
		214,
		-1,
		-1,
		317,
		292,
		-1,
		-1,
		-1,
		277,
		257,
		248,
		232,
		-1,
		207,
		207,
		-1,
		-1,
		-1,
		302,
		301,
		-1,
		270,
		273,
		-1,
		263,
		254,
		262,
		209,
		213,
		-1,
		-1,
		-1,
		311,
		292,
		286,
		285,
		283,
		278,
		275,
		261,
		245,
		223,
		212,
		233,
		-1,
		-1,
		-1,
		283,
		275,
		268,
		-1,
		-1,
		270,
		253,
		234,
		232,
		-1,
		-1,
		-1,
		305,
		286,
		-1,
		-1,
		260,
		-1,
		-1,
		266,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		322,
		294,
		-1,
		-1,
		-1,
		256,
		252,
		253,
		-1,
		-1,
		-1,
		-1,
		316,
		317,
		340,
		304,
		-1,
		-1,
		-1,
		248,
		242,
		-1,
		-1,
		319,
		317,
		-1,
		-1,
		-1,
		276,
		260,
		-1,
		246,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		281,
		-1,
		281,
		256,
		263,
		-1,
		-1,
		-1,
		-1,
		294,
		286,
		294,
		-1,
		266,
		268,
		-1,
		316,
		-1,
		-1,
		309,
		300,
		-1,
		-1,
		271,
		278,
		300,
		303,
		339,
		-1,
		290
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		187,
		176,
		187,
		195,
		168,
		175,
		-1,
		196,
		198,
		164,
		158,
		197,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		187,
		186,
		156,
		154,
		163,
		168,
		175,
		-1,
		179,
		-1,
		208,
		187,
		198,
		203,
		149,
		146,
		166,
		185,
		172,
		164,
		223,
		179,
		150,
		144,
		162,
		157,
		166,
		158,
		-1,
		150,
		140,
		162,
		146,
		157,
		149,
		-1,
		-1,
		144,
		145,
		151,
		142,
		148,
		144,
		-1,
		154,
		138,
		-1,
		-1,
		134,
		140,
		124,
		127,
		135,
		133,
		146,
		138,
		133,
		-1,
		-1,
		130,
		126,
		133,
		120,
		116,
		133,
		146,
		128,
		142,
		141,
		-1,
		123,
		141,
		150,
		127,
		125,
		109,
		107,
		125,
		127,
		133,
		136,
		-1,
		132,
		133,
		128,
		136,
		141,
		125,
		112,
		112,
		122,
		115,
		134,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		132,
		115,
		132,
		124,
		114,
		129,
		122,
		115,
		112,
		110,
		107,
		123,
		124,
		134,
		-1,
		-1,
		211,
		180,
		215,
		172,
		157,
		-1,
		128,
		108,
		114,
		118,
		112,
		105,
		119,
		115,
		-1,
		101,
		100,
		131,
		117,
		128,
		171,
		-1,
		-1,
		169,
		161,
		146,
		149,
		138,
		134,
		123,
		122,
		114,
		100,
		96,
		102,
		105,
		105,
		111,
		95,
		105,
		109,
		119,
		135,
		-1,
		-1,
		181,
		-1,
		-1,
		168,
		151,
		-1,
		134,
		141,
		141,
		150,
		136,
		157,
		133,
		124,
		116,
		110,
		98,
		100,
		97,
		110,
		98,
		92,
		117,
		121,
		114,
		135,
		130,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		136,
		160,
		170,
		-1,
		145,
		133,
		134,
		119,
		116,
		103,
		91,
		104,
		89,
		96,
		95,
		99,
		101,
		134,
		111,
		133,
		130,
		151,
		156,
		150,
		159,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		164,
		-1,
		178,
		177,
		152,
		130,
		133,
		120,
		111,
		98,
		87,
		98,
		87,
		84,
		92,
		100,
		112,
		106,
		105,
		123,
		135,
		143,
		147,
		153,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		184,
		179,
		169,
		154,
		145,
		-1,
		129,
		126,
		116,
		94,
		79,
		96,
		88,
		86,
		91,
		95,
		109,
		100,
		118,
		125,
		125,
		129,
		149,
		161,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		131,
		144,
		-1,
		100,
		96,
		78,
		79,
		74,
		89,
		94,
		91,
		88,
		106,
		109,
		118,
		122,
		138,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		114,
		111,
		99,
		86,
		71,
		72,
		80,
		92,
		71,
		90,
		89,
		109,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		110,
		89,
		80,
		69,
		67,
		80,
		72,
		90,
		87,
		85,
		104,
		116,
		107,
		127,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		120,
		106,
		84,
		76,
		68,
		57,
		68,
		76,
		80,
		83,
		92,
		98,
		122,
		128,
		134,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		79,
		77,
		70,
		73,
		54,
		59,
		73,
		82,
		90,
		85,
		92,
		127,
		127,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		82,
		74,
		75,
		58,
		58,
		59,
		73,
		57,
		76,
		78,
		77,
		113,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		56,
		48,
		42,
		51,
		44,
		51,
		64,
		69,
		82,
		80,
		110,
		114,
		119,
		108,
		104,
		101,
		115,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		73,
		71,
		70,
		54,
		57,
		52,
		49,
		55,
		58,
		61,
		77,
		87,
		105,
		114,
		106,
		100,
		99,
		111,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		83,
		68,
		58,
		59,
		29,
		34,
		45,
		55,
		82,
		72,
		95,
		88,
		110,
		110,
		94,
		95,
		104,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		82,
		80,
		48,
		22,
		29,
		56,
		59,
		69,
		77,
		66,
		72,
		82,
		104,
		90,
		88,
		107,
		123,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		0,
		15,
		24,
		-1,
		94,
		-1,
		68,
		81,
		81,
		77,
		76,
		87,
		85,
		96,
		113,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		16,
		5,
		17,
		24,
		79,
		66,
		65,
		71,
		76,
		80,
		79,
		92,
		112,
		103,
		115,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		61,
		49,
		39,
		29,
		66,
		67,
		57,
		62,
		71,
		83,
		88,
		88,
		93,
		114,
		115,
		128,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		50,
		-1,
		-1,
		44,
		42,
		52,
		58,
		73,
		87,
		94,
		103,
		87,
		102,
		114,
		122,
		127,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		160,
		112,
		101,
		96,
		100,
		47,
		-1,
		52,
		53,
		71,
		83,
		90,
		105,
		100,
		94,
		97,
		115,
		132,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		117,
		118,
		89,
		82,
		86,
		-1,
		61,
		61,
		73,
		84,
		96,
		101,
		106,
		93,
		103,
		100,
		113,
		127,
		131,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		135,
		150,
		128,
		105,
		78,
		73,
		66,
		60,
		65,
		85,
		91,
		102,
		87,
		91,
		102,
		106,
		105,
		122,
		132,
		-1,
		-1,
		149,
		166,
		161,
		143,
		147,
		155,
		-1,
		-1,
		82,
		73,
		64,
		67,
		75,
		78,
		83,
		85,
		103,
		118,
		106,
		115,
		133,
		136,
		-1,
		-1,
		-1,
		169,
		-1,
		184,
		-1,
		-1,
		162,
		153,
		100,
		82,
		78,
		76,
		69,
		78,
		73,
		78,
		103,
		98,
		107,
		108,
		116,
		139,
		128,
		167,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		115,
		112,
		-1,
		82,
		107,
		79,
		86,
		78,
		91,
		96,
		102,
		106,
		113,
		129,
		128,
		123,
		159,
		150,
		156,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		131,
		128,
		104,
		88,
		92,
		85,
		80,
		118,
		94,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		147,
		162,
		-1,
		176,
		253,
		246,
		214,
		222,
		253,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		104,
		101,
		106,
		95,
		92,
		104,
		103,
		114,
		116,
		121,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		190,
		229,
		208,
		211,
		235,
		249,
		-1,
		151,
		-1,
		-1,
		163,
		135,
		119,
		109,
		103,
		153,
		109,
		104,
		106,
		108,
		112,
		103,
		126,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		179,
		-1,
		146,
		-1,
		121,
		125,
		117,
		120,
		131,
		118,
		116,
		124,
		132,
		115,
		125,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		163,
		202,
		217,
		-1,
		188,
		-1,
		-1,
		-1,
		135,
		130,
		122,
		138,
		130,
		130,
		110,
		114,
		120,
		127,
		137,
		139,
		131,
		135,
		148,
		159,
		162,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		178,
		169,
		196,
		222,
		213,
		208,
		195,
		-1,
		-1,
		158,
		140,
		-1,
		-1,
		137,
		131,
		114,
		116,
		120,
		130,
		145,
		148,
		138,
		136,
		130,
		162,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		197,
		192,
		196,
		212,
		237,
		-1,
		198,
		-1,
		-1,
		179,
		-1,
		-1,
		173,
		136,
		125,
		116,
		122,
		128,
		139,
		156,
		144,
		145,
		135,
		145,
		158,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		214,
		194,
		-1,
		-1,
		171,
		169,
		158,
		-1,
		148,
		121,
		126,
		151,
		158,
		153,
		147,
		141,
		148,
		147,
		155,
		163,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		166,
		159,
		147,
		135,
		125,
		135,
		143,
		143,
		146,
		144,
		139,
		150,
		142,
		146,
		163,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		200,
		184,
		165,
		-1,
		135,
		148,
		179,
		147,
		152,
		147,
		145,
		156,
		145,
		148,
		162,
		157,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		204,
		213,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		172,
		168,
		-1,
		-1,
		136,
		161,
		150,
		158,
		153,
		149,
		155,
		158,
		147,
		151,
		163,
		-1,
		-1,
		186,
		187,
		192,
		-1,
		196,
		-1,
		214,
		-1,
		181,
		187,
		175,
		-1,
		-1,
		-1,
		174,
		137,
		154,
		168,
		173,
		171,
		162,
		153,
		160,
		158,
		154,
		165,
		-1,
		-1,
		-1,
		214,
		188,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		131,
		134,
		159,
		167,
		184,
		178,
		156,
		171,
		161,
		152,
		161,
		220,
		-1,
		190,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		135,
		-1,
		163,
		153,
		201,
		176,
		171,
		158,
		165,
		165,
		158,
		-1,
		-1,
		-1,
		192,
		191,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		191,
		187,
		178,
		178,
		166,
		-1,
		293,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		165,
		197,
		-1,
		288,
		-1,
		222,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		159,
		164,
		-1,
		277,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		164,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		157,
		149,
		208,
		164,
		135,
		129,
		147,
		142,
		151,
		143,
		-1,
		135,
		125,
		147,
		131,
		142,
		134,
		-1,
		-1,
		129,
		130,
		136,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		119,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		108,
		126,
		135,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		121,
		-1,
		117,
		118,
		113,
		121,
		126,
		110,
		97,
		97,
		107,
		100,
		119,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		117,
		100,
		117,
		109,
		99,
		114,
		107,
		100,
		97,
		95,
		92,
		108,
		109,
		119,
		-1,
		-1,
		196,
		165,
		200,
		157,
		142,
		-1,
		113,
		93,
		99,
		103,
		97,
		90,
		104,
		100,
		-1,
		86,
		85,
		116,
		102,
		113,
		156,
		-1,
		-1,
		154,
		146,
		131,
		134,
		123,
		119,
		108,
		107,
		99,
		85,
		81,
		87,
		90,
		90,
		96,
		80,
		90,
		94,
		104,
		120,
		-1,
		-1,
		166,
		-1,
		-1,
		153,
		136,
		-1,
		119,
		126,
		126,
		135,
		121,
		142,
		118,
		109,
		101,
		95,
		83,
		85,
		82,
		95,
		83,
		77,
		102,
		106,
		99,
		120,
		115,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		115,
		121,
		145,
		155,
		-1,
		130,
		118,
		119,
		104,
		101,
		88,
		76,
		89,
		74,
		81,
		80,
		84,
		86,
		119,
		96,
		118,
		115,
		136,
		141,
		135,
		144,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		149,
		-1,
		163,
		162,
		137,
		115,
		118,
		105,
		96,
		83,
		72,
		83,
		72,
		69,
		77,
		85,
		97,
		91,
		90,
		108,
		120,
		128,
		132,
		138,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		169,
		164,
		154,
		139,
		130,
		-1,
		114,
		111,
		101,
		79,
		64,
		81,
		73,
		71,
		76,
		80,
		94,
		85,
		103,
		110,
		110,
		114,
		134,
		146,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		131,
		-1,
		116,
		129,
		-1,
		85,
		81,
		63,
		64,
		59,
		74,
		79,
		76,
		73,
		91,
		94,
		103,
		107,
		123,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		108,
		99,
		96,
		84,
		71,
		56,
		57,
		65,
		77,
		56,
		75,
		74,
		94,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		95,
		74,
		65,
		54,
		52,
		65,
		57,
		75,
		72,
		70,
		89,
		101,
		92,
		112,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		105,
		91,
		69,
		61,
		53,
		42,
		53,
		61,
		65,
		68,
		77,
		83,
		107,
		113,
		119,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		64,
		62,
		55,
		58,
		39,
		44,
		58,
		67,
		75,
		70,
		77,
		112,
		112,
		103,
		123,
		126,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		67,
		59,
		60,
		43,
		43,
		44,
		58,
		42,
		61,
		63,
		62,
		98,
		-1,
		111,
		105,
		113,
		103,
		91,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		65,
		47,
		41,
		33,
		27,
		36,
		29,
		36,
		49,
		54,
		67,
		65,
		95,
		99,
		104,
		93,
		89,
		86,
		100,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		58,
		56,
		55,
		39,
		42,
		37,
		34,
		40,
		43,
		46,
		62,
		72,
		90,
		99,
		91,
		85,
		84,
		96,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		68,
		53,
		43,
		44,
		14,
		19,
		30,
		40,
		68,
		57,
		80,
		73,
		95,
		95,
		79,
		80,
		89,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		67,
		65,
		33,
		7,
		14,
		41,
		44,
		54,
		62,
		51,
		57,
		67,
		89,
		75,
		73,
		92,
		108,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		16,
		0,
		9,
		-1,
		79,
		-1,
		61,
		72,
		70,
		62,
		61,
		72,
		70,
		81,
		98,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		32,
		12,
		14,
		9,
		72,
		59,
		58,
		64,
		68,
		65,
		64,
		77,
		97,
		88,
		100,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		57,
		45,
		35,
		25,
		59,
		60,
		50,
		55,
		64,
		75,
		73,
		73,
		78,
		99,
		100,
		113,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		46,
		-1,
		-1,
		37,
		35,
		45,
		51,
		66,
		80,
		87,
		88,
		72,
		87,
		99,
		107,
		112,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		145,
		105,
		94,
		89,
		93,
		40,
		-1,
		45,
		46,
		64,
		76,
		83,
		90,
		85,
		79,
		82,
		100,
		117,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		102,
		111,
		82,
		75,
		79,
		-1,
		54,
		54,
		66,
		77,
		89,
		94,
		91,
		83,
		88,
		85,
		98,
		112,
		116,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		120,
		135,
		121,
		98,
		71,
		66,
		59,
		53,
		58,
		78,
		84,
		95,
		80,
		84,
		87,
		91,
		90,
		107,
		117,
		-1,
		-1,
		134,
		151,
		146,
		128,
		132,
		148,
		-1,
		-1,
		75,
		66,
		57,
		60,
		68,
		71,
		76,
		78,
		96,
		103,
		91,
		100,
		118,
		122,
		-1,
		-1,
		-1,
		154,
		-1,
		169,
		-1,
		-1,
		147,
		146,
		93,
		75,
		71,
		69,
		62,
		71,
		66,
		71,
		96,
		91,
		100,
		93,
		106,
		128,
		118,
		154,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		108,
		105,
		-1,
		75,
		100,
		72,
		79,
		71,
		84,
		89,
		95,
		96,
		103,
		119,
		118,
		113,
		146,
		140,
		146,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		124,
		121,
		97,
		81,
		85,
		78,
		73,
		111,
		87,
		92,
		96,
		100,
		106,
		111,
		116,
		122,
		137,
		152,
		-1,
		161,
		242,
		235,
		207,
		215,
		246,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		97,
		94,
		99,
		88,
		85,
		97,
		96,
		107,
		106,
		112,
		99,
		98,
		116,
		120,
		129,
		136,
		126,
		139,
		143,
		-1,
		175,
		218,
		201,
		204,
		228,
		242,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		96,
		146,
		102,
		97,
		99,
		101,
		105,
		96,
		116,
		107,
		107,
		110,
		125,
		130,
		122,
		136,
		136,
		137,
		-1,
		191,
		198,
		195,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		139,
		-1,
		114,
		118,
		110,
		113,
		124,
		111,
		109,
		114,
		125,
		105,
		115,
		111,
		112,
		121,
		132,
		144,
		143,
		144,
		216,
		172,
		175,
		186,
		197,
		212,
		216,
		-1,
		156,
		195,
		210,
		-1,
		181,
		-1,
		-1,
		-1,
		128,
		123,
		115,
		131,
		123,
		123,
		103,
		107,
		110,
		117,
		127,
		129,
		121,
		125,
		138,
		149,
		152,
		212,
		203,
		216,
		161,
		161,
		182,
		191,
		212,
		171,
		162,
		189,
		215,
		206,
		201,
		188,
		-1,
		-1,
		151,
		133,
		-1,
		-1,
		130,
		124,
		107,
		109,
		113,
		120,
		135,
		138,
		128,
		126,
		120,
		152,
		-1,
		205,
		204,
		193,
		190,
		166,
		157,
		152,
		179,
		-1,
		-1,
		174,
		190,
		185,
		189,
		205,
		230,
		-1,
		191,
		-1,
		-1,
		172,
		-1,
		-1,
		166,
		129,
		118,
		109,
		115,
		121,
		132,
		146,
		134,
		135,
		125,
		135,
		148,
		189,
		186,
		174,
		172,
		195,
		160,
		148,
		-1,
		161,
		159,
		165,
		172,
		189,
		219,
		-1,
		-1,
		207,
		187,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		114,
		119,
		144,
		151,
		143,
		137,
		131,
		138,
		137,
		145,
		153,
		198,
		212,
		201,
		197,
		196,
		204,
		153,
		146,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		197,
		193,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		136,
		136,
		139,
		134,
		129,
		140,
		132,
		136,
		153,
		-1,
		232,
		-1,
		184,
		160,
		174,
		189,
		197,
		-1,
		-1,
		-1,
		214,
		200,
		193,
		181,
		179,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		172,
		140,
		145,
		140,
		135,
		146,
		135,
		138,
		152,
		147,
		-1,
		-1,
		172,
		175,
		-1,
		-1,
		197,
		206,
		-1,
		205,
		194,
		179,
		171,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		129,
		154,
		143,
		151,
		146,
		139,
		145,
		148,
		137,
		141,
		153,
		-1,
		-1,
		179,
		180,
		185,
		-1,
		189,
		-1,
		207,
		-1,
		174,
		180,
		168,
		-1,
		-1,
		-1,
		167,
		130,
		147,
		161,
		166,
		164,
		155,
		143,
		150,
		148,
		144,
		155,
		-1,
		-1,
		-1,
		207,
		181,
		214,
		205,
		188,
		168,
		160,
		179,
		-1,
		149,
		-1,
		124,
		127,
		152,
		160,
		177,
		171,
		146,
		161,
		151,
		142,
		151,
		213,
		-1,
		183,
		216,
		180,
		174,
		150,
		154,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		194,
		169,
		161,
		148,
		155,
		155,
		148,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		170,
		155,
		146,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		184,
		180,
		168,
		168,
		159,
		-1,
		286,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		174,
		147,
		135,
		141,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		158,
		190,
		-1,
		281,
		-1,
		215,
		-1,
		-1,
		197,
		177,
		169,
		158,
		147,
		145,
		136,
		127,
		149,
		165,
		149,
		147,
		152,
		157,
		-1,
		270,
		269,
		-1,
		216,
		208,
		194,
		-1,
		187,
		-1,
		193,
		154,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		257,
		232,
		-1,
		-1,
		-1,
		217,
		197,
		188,
		172,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		242,
		241,
		-1,
		210,
		213,
		-1,
		203,
		194,
		202,
		149,
		153,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		225,
		223,
		218,
		215,
		201,
		185,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		223,
		215,
		208,
		-1,
		-1,
		210,
		193,
		174,
		172,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		200,
		-1,
		-1,
		206,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		234,
		-1,
		-1,
		-1,
		196,
		192,
		193,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		280,
		244,
		-1,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		216,
		200,
		-1,
		186,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		221,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		234,
		226,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		211,
		218,
		240,
		243,
		279,
		-1,
		230
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		190,
		192,
		158,
		152,
		191,
		162,
		168,
		179,
		-1,
		-1,
		-1,
		181,
		180,
		150,
		148,
		157,
		162,
		169,
		-1,
		173,
		-1,
		202,
		181,
		192,
		197,
		143,
		140,
		160,
		179,
		166,
		158,
		217,
		173,
		144,
		138,
		156,
		151,
		160,
		152,
		-1,
		144,
		134,
		156,
		140,
		151,
		143,
		-1,
		-1,
		138,
		139,
		145,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		128,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		117,
		135,
		144,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		130,
		-1,
		126,
		127,
		122,
		130,
		135,
		119,
		106,
		106,
		116,
		109,
		128,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		126,
		109,
		126,
		118,
		108,
		123,
		116,
		109,
		106,
		104,
		101,
		117,
		118,
		128,
		-1,
		-1,
		205,
		174,
		209,
		166,
		151,
		-1,
		122,
		102,
		108,
		112,
		106,
		99,
		113,
		109,
		-1,
		95,
		94,
		125,
		111,
		122,
		165,
		-1,
		-1,
		163,
		155,
		140,
		143,
		132,
		128,
		117,
		116,
		108,
		94,
		90,
		96,
		99,
		99,
		105,
		89,
		99,
		103,
		113,
		129,
		-1,
		-1,
		175,
		-1,
		-1,
		162,
		145,
		-1,
		128,
		135,
		135,
		144,
		130,
		151,
		127,
		118,
		110,
		104,
		92,
		94,
		91,
		104,
		92,
		86,
		111,
		115,
		108,
		129,
		124,
		-1,
		174,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		121,
		124,
		130,
		154,
		164,
		-1,
		139,
		127,
		128,
		113,
		110,
		97,
		85,
		98,
		83,
		90,
		89,
		93,
		95,
		128,
		105,
		127,
		124,
		145,
		150,
		144,
		153,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		158,
		-1,
		172,
		171,
		146,
		124,
		127,
		114,
		105,
		92,
		81,
		92,
		81,
		78,
		86,
		94,
		106,
		100,
		99,
		117,
		129,
		137,
		141,
		147,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		178,
		173,
		163,
		148,
		139,
		-1,
		123,
		120,
		110,
		88,
		73,
		90,
		82,
		80,
		85,
		89,
		103,
		94,
		112,
		119,
		119,
		123,
		143,
		155,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		181,
		145,
		-1,
		140,
		-1,
		125,
		138,
		-1,
		94,
		90,
		72,
		73,
		68,
		83,
		88,
		85,
		82,
		100,
		103,
		112,
		116,
		132,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		117,
		108,
		105,
		93,
		80,
		65,
		66,
		74,
		86,
		65,
		84,
		83,
		103,
		129,
		107,
		119,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		104,
		83,
		74,
		63,
		61,
		74,
		66,
		84,
		81,
		79,
		98,
		110,
		101,
		121,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		88,
		114,
		100,
		78,
		70,
		62,
		51,
		62,
		70,
		74,
		77,
		86,
		92,
		116,
		122,
		128,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		93,
		-1,
		82,
		73,
		71,
		64,
		67,
		48,
		53,
		67,
		76,
		84,
		79,
		86,
		121,
		121,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		87,
		81,
		76,
		68,
		69,
		52,
		52,
		53,
		67,
		51,
		70,
		72,
		71,
		107,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		74,
		56,
		50,
		42,
		36,
		45,
		38,
		45,
		58,
		63,
		76,
		74,
		104,
		108,
		113,
		102,
		98,
		95,
		109,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		67,
		65,
		64,
		48,
		51,
		46,
		43,
		49,
		52,
		55,
		71,
		81,
		99,
		108,
		100,
		94,
		93,
		105,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		77,
		62,
		52,
		53,
		23,
		28,
		39,
		49,
		77,
		66,
		89,
		82,
		104,
		104,
		88,
		89,
		98,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		76,
		74,
		42,
		16,
		23,
		50,
		53,
		63,
		71,
		60,
		66,
		76,
		98,
		84,
		82,
		101,
		117,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		29,
		13,
		0,
		-1,
		88,
		-1,
		70,
		81,
		79,
		71,
		70,
		81,
		79,
		90,
		107,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		45,
		25,
		23,
		0,
		81,
		68,
		67,
		73,
		77,
		74,
		73,
		86,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		66,
		54,
		44,
		34,
		68,
		69,
		59,
		64,
		73,
		84,
		82,
		82,
		87,
		108,
		109,
		122,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		55,
		-1,
		-1,
		46,
		44,
		54,
		60,
		75,
		89,
		96,
		97,
		81,
		96,
		108,
		116,
		121,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		154,
		114,
		103,
		98,
		102,
		49,
		-1,
		54,
		55,
		73,
		85,
		92,
		99,
		94,
		88,
		91,
		109,
		126,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		111,
		120,
		91,
		84,
		88,
		-1,
		63,
		63,
		75,
		86,
		98,
		103,
		100,
		92,
		97,
		94,
		107,
		121,
		125,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		129,
		144,
		130,
		107,
		80,
		75,
		68,
		62,
		67,
		87,
		93,
		104,
		89,
		93,
		96,
		100,
		99,
		116,
		126,
		-1,
		-1,
		143,
		160,
		155,
		137,
		141,
		157,
		-1,
		-1,
		84,
		75,
		66,
		69,
		77,
		80,
		85,
		87,
		105,
		112,
		100,
		109,
		127,
		131,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		156,
		155,
		102,
		84,
		80,
		78,
		71,
		80,
		75,
		80,
		105,
		100,
		109,
		102,
		115,
		137,
		127,
		163,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		117,
		114,
		-1,
		84,
		109,
		81,
		88,
		80,
		93,
		98,
		104,
		105,
		112,
		128,
		127,
		122,
		155,
		149,
		155,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		133,
		130,
		106,
		90,
		94,
		87,
		82,
		120,
		96,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		170,
		251,
		244,
		216,
		224,
		255,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		106,
		103,
		108,
		97,
		94,
		106,
		105,
		116,
		115,
		121,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		184,
		227,
		210,
		213,
		237,
		251,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		105,
		155,
		111,
		106,
		108,
		110,
		114,
		105,
		125,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		200,
		207,
		204,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		-1,
		148,
		-1,
		123,
		127,
		119,
		122,
		133,
		120,
		118,
		123,
		134,
		114,
		124,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		165,
		204,
		219,
		-1,
		190,
		-1,
		-1,
		-1,
		137,
		132,
		124,
		140,
		132,
		132,
		112,
		116,
		119,
		126,
		136,
		138,
		130,
		134,
		147,
		158,
		161,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		180,
		171,
		198,
		224,
		215,
		210,
		197,
		-1,
		-1,
		160,
		142,
		-1,
		-1,
		139,
		133,
		116,
		118,
		122,
		129,
		144,
		147,
		137,
		135,
		129,
		161,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		199,
		194,
		198,
		214,
		239,
		-1,
		200,
		-1,
		-1,
		181,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		130,
		141,
		155,
		143,
		144,
		134,
		144,
		157,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		216,
		196,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		123,
		128,
		153,
		160,
		152,
		146,
		140,
		147,
		146,
		154,
		162,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		202,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		145,
		145,
		148,
		143,
		138,
		149,
		141,
		145,
		162,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		144,
		155,
		144,
		147,
		161,
		156,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		206,
		215,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		148,
		154,
		157,
		146,
		150,
		162,
		-1,
		-1,
		188,
		189,
		194,
		-1,
		198,
		-1,
		216,
		-1,
		183,
		189,
		177,
		-1,
		-1,
		-1,
		176,
		139,
		156,
		170,
		175,
		173,
		164,
		152,
		159,
		157,
		153,
		164,
		-1,
		-1,
		-1,
		216,
		190,
		223,
		214,
		197,
		177,
		169,
		188,
		-1,
		158,
		-1,
		133,
		136,
		161,
		169,
		186,
		180,
		155,
		170,
		160,
		151,
		160,
		222,
		-1,
		192,
		225,
		189,
		183,
		159,
		163,
		179,
		-1,
		155,
		137,
		-1,
		165,
		155,
		203,
		178,
		170,
		157,
		164,
		164,
		157,
		-1,
		-1,
		-1,
		194,
		193,
		185,
		179,
		179,
		164,
		155,
		-1,
		167,
		149,
		128,
		145,
		145,
		136,
		144,
		193,
		189,
		177,
		177,
		168,
		-1,
		295,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		188,
		183,
		156,
		144,
		150,
		146,
		132,
		138,
		140,
		148,
		146,
		143,
		155,
		151,
		171,
		167,
		199,
		-1,
		290,
		-1,
		224,
		-1,
		-1,
		206,
		186,
		178,
		167,
		156,
		154,
		145,
		136,
		158,
		174,
		158,
		156,
		161,
		166,
		-1,
		279,
		278,
		-1,
		225,
		217,
		203,
		-1,
		196,
		-1,
		202,
		163,
		-1,
		165,
		145,
		-1,
		167,
		163,
		-1,
		-1,
		266,
		241,
		-1,
		-1,
		-1,
		226,
		206,
		197,
		181,
		-1,
		156,
		156,
		-1,
		-1,
		-1,
		251,
		250,
		-1,
		219,
		222,
		-1,
		212,
		203,
		211,
		158,
		162,
		-1,
		-1,
		-1,
		260,
		241,
		235,
		234,
		232,
		227,
		224,
		210,
		194,
		172,
		161,
		182,
		-1,
		-1,
		-1,
		232,
		224,
		217,
		-1,
		-1,
		219,
		202,
		183,
		181,
		-1,
		-1,
		-1,
		254,
		235,
		-1,
		-1,
		209,
		-1,
		-1,
		215,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		243,
		-1,
		-1,
		-1,
		205,
		201,
		202,
		-1,
		-1,
		-1,
		-1,
		265,
		266,
		289,
		253,
		-1,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		268,
		266,
		-1,
		-1,
		-1,
		225,
		209,
		-1,
		195,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		230,
		-1,
		230,
		205,
		212,
		-1,
		-1,
		-1,
		-1,
		243,
		235,
		243,
		-1,
		215,
		217,
		-1,
		265,
		-1,
		-1,
		258,
		249,
		-1,
		-1,
		220,
		227,
		249,
		252,
		288,
		-1,
		239
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		219,
		222,
		188,
		182,
		221,
		191,
		197,
		208,
		-1,
		-1,
		-1,
		211,
		210,
		179,
		177,
		186,
		191,
		198,
		-1,
		197,
		-1,
		232,
		211,
		222,
		227,
		172,
		169,
		189,
		208,
		190,
		182,
		247,
		202,
		173,
		167,
		185,
		175,
		184,
		176,
		-1,
		173,
		163,
		185,
		164,
		175,
		167,
		-1,
		-1,
		167,
		168,
		174,
		160,
		166,
		162,
		-1,
		172,
		156,
		-1,
		-1,
		157,
		158,
		142,
		145,
		153,
		151,
		164,
		156,
		151,
		-1,
		-1,
		148,
		144,
		151,
		138,
		134,
		151,
		164,
		146,
		160,
		159,
		-1,
		147,
		165,
		174,
		145,
		143,
		127,
		125,
		143,
		145,
		151,
		151,
		-1,
		156,
		157,
		152,
		160,
		165,
		143,
		130,
		130,
		140,
		133,
		152,
		140,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		133,
		130,
		128,
		125,
		141,
		139,
		149,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		119,
		118,
		146,
		132,
		143,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		113,
		123,
		127,
		125,
		150,
		-1,
		-1,
		185,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		110,
		135,
		139,
		120,
		141,
		136,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		114,
		112,
		142,
		117,
		139,
		136,
		155,
		160,
		154,
		163,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		106,
		121,
		112,
		111,
		129,
		139,
		147,
		151,
		157,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		115,
		101,
		115,
		106,
		124,
		131,
		129,
		133,
		153,
		165,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		111,
		97,
		94,
		112,
		115,
		122,
		126,
		142,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		109,
		88,
		96,
		93,
		113,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		97,
		89,
		106,
		91,
		89,
		108,
		120,
		111,
		124,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		85,
		93,
		97,
		87,
		96,
		102,
		126,
		112,
		118,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		89,
		76,
		89,
		99,
		86,
		88,
		88,
		131,
		131,
		102,
		122,
		125,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		93,
		97,
		89,
		88,
		72,
		90,
		80,
		81,
		105,
		-1,
		110,
		104,
		112,
		102,
		90,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		99,
		91,
		85,
		75,
		63,
		66,
		79,
		72,
		76,
		73,
		93,
		97,
		103,
		92,
		88,
		85,
		99,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		113,
		97,
		91,
		72,
		62,
		45,
		61,
		54,
		70,
		70,
		88,
		98,
		90,
		84,
		83,
		95,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		111,
		104,
		105,
		78,
		66,
		45,
		33,
		40,
		55,
		78,
		72,
		94,
		94,
		78,
		79,
		88,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		125,
		123,
		94,
		80,
		76,
		57,
		30,
		25,
		54,
		49,
		55,
		66,
		88,
		74,
		72,
		91,
		107,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		92,
		81,
		86,
		-1,
		0,
		-1,
		42,
		55,
		55,
		60,
		60,
		71,
		69,
		80,
		97,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		108,
		88,
		80,
		86,
		49,
		57,
		35,
		62,
		66,
		63,
		63,
		76,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		108,
		96,
		86,
		76,
		81,
		69,
		48,
		53,
		62,
		72,
		71,
		72,
		77,
		98,
		99,
		112,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		170,
		144,
		97,
		-1,
		-1,
		80,
		73,
		61,
		62,
		66,
		78,
		85,
		87,
		71,
		86,
		98,
		106,
		111,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		79,
		-1,
		67,
		68,
		70,
		76,
		83,
		89,
		84,
		78,
		81,
		99,
		116,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		76,
		76,
		72,
		88,
		102,
		99,
		90,
		82,
		87,
		84,
		97,
		111,
		115,
		204,
		-1,
		187,
		-1,
		-1,
		-1,
		157,
		172,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		96,
		105,
		116,
		89,
		85,
		86,
		90,
		89,
		106,
		116,
		-1,
		-1,
		187,
		191,
		183,
		165,
		169,
		170,
		-1,
		-1,
		97,
		88,
		79,
		82,
		90,
		93,
		95,
		92,
		97,
		102,
		90,
		99,
		117,
		121,
		-1,
		-1,
		-1,
		207,
		-1,
		209,
		-1,
		-1,
		184,
		168,
		115,
		97,
		93,
		91,
		84,
		93,
		88,
		93,
		110,
		113,
		112,
		92,
		105,
		127,
		117,
		153,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		186,
		178,
		173,
		179,
		181,
		172,
		130,
		127,
		-1,
		97,
		122,
		94,
		101,
		93,
		106,
		111,
		116,
		95,
		102,
		118,
		117,
		112,
		145,
		139,
		145,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		179,
		175,
		165,
		155,
		158,
		-1,
		-1,
		146,
		143,
		119,
		103,
		107,
		100,
		95,
		124,
		104,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		214,
		268,
		261,
		229,
		237,
		268,
		-1,
		169,
		161,
		172,
		147,
		149,
		-1,
		-1,
		119,
		116,
		121,
		110,
		107,
		119,
		118,
		120,
		105,
		111,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		224,
		244,
		223,
		226,
		250,
		264,
		-1,
		166,
		-1,
		-1,
		178,
		150,
		134,
		124,
		118,
		168,
		124,
		119,
		121,
		123,
		117,
		108,
		115,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		213,
		224,
		217,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		194,
		-1,
		161,
		-1,
		136,
		140,
		132,
		135,
		142,
		129,
		121,
		113,
		129,
		104,
		114,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		178,
		217,
		232,
		-1,
		203,
		-1,
		-1,
		-1,
		150,
		145,
		137,
		153,
		141,
		141,
		115,
		119,
		109,
		116,
		126,
		128,
		120,
		124,
		137,
		148,
		151,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		193,
		184,
		211,
		237,
		228,
		223,
		210,
		-1,
		-1,
		173,
		155,
		-1,
		-1,
		148,
		136,
		119,
		120,
		116,
		119,
		134,
		137,
		127,
		125,
		119,
		151,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		212,
		207,
		211,
		227,
		252,
		-1,
		208,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		124,
		135,
		145,
		133,
		134,
		124,
		134,
		147,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		241,
		-1,
		-1,
		224,
		204,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		151,
		153,
		142,
		136,
		130,
		137,
		136,
		144,
		152,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		214,
		210,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		144,
		148,
		140,
		133,
		128,
		139,
		131,
		135,
		152,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		231,
		217,
		210,
		198,
		196,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		134,
		145,
		134,
		137,
		151,
		146,
		-1,
		-1,
		194,
		197,
		-1,
		-1,
		219,
		223,
		-1,
		222,
		211,
		196,
		188,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		138,
		144,
		147,
		136,
		140,
		152,
		-1,
		-1,
		201,
		202,
		207,
		-1,
		206,
		-1,
		224,
		-1,
		191,
		197,
		185,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		167,
		165,
		156,
		142,
		149,
		147,
		143,
		154,
		-1,
		-1,
		-1,
		224,
		198,
		231,
		222,
		205,
		185,
		177,
		196,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		178,
		172,
		145,
		160,
		150,
		141,
		150,
		230,
		-1,
		200,
		233,
		197,
		191,
		167,
		171,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		194,
		179,
		160,
		147,
		154,
		154,
		147,
		-1,
		-1,
		-1,
		202,
		201,
		193,
		187,
		187,
		172,
		163,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		184,
		180,
		167,
		167,
		159,
		-1,
		303,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		196,
		191,
		164,
		152,
		158,
		154,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		160,
		195,
		-1,
		298,
		-1,
		232,
		-1,
		-1,
		214,
		194,
		186,
		175,
		164,
		162,
		153,
		144,
		166,
		182,
		166,
		164,
		167,
		168,
		-1,
		287,
		286,
		-1,
		233,
		225,
		211,
		-1,
		204,
		-1,
		210,
		171,
		-1,
		173,
		153,
		-1,
		175,
		171,
		-1,
		-1,
		274,
		249,
		-1,
		-1,
		-1,
		234,
		214,
		205,
		189,
		-1,
		164,
		164,
		-1,
		-1,
		-1,
		259,
		258,
		-1,
		227,
		230,
		-1,
		220,
		211,
		219,
		166,
		170,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		242,
		240,
		235,
		232,
		218,
		202,
		180,
		169,
		190,
		-1,
		-1,
		-1,
		240,
		232,
		225,
		-1,
		-1,
		227,
		210,
		191,
		189,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		217,
		-1,
		-1,
		223,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		251,
		-1,
		-1,
		-1,
		213,
		209,
		210,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		297,
		261,
		-1,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		233,
		217,
		-1,
		203,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		238,
		-1,
		238,
		213,
		220,
		-1,
		-1,
		-1,
		-1,
		251,
		243,
		251,
		-1,
		223,
		225,
		-1,
		273,
		-1,
		-1,
		266,
		257,
		-1,
		-1,
		228,
		235,
		257,
		260,
		296,
		-1,
		247
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		196,
		199,
		165,
		159,
		198,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		188,
		187,
		156,
		154,
		163,
		168,
		175,
		-1,
		174,
		-1,
		209,
		188,
		199,
		204,
		149,
		146,
		166,
		185,
		167,
		159,
		224,
		179,
		150,
		144,
		162,
		152,
		161,
		153,
		-1,
		150,
		140,
		162,
		141,
		152,
		144,
		-1,
		-1,
		144,
		145,
		151,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		134,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		124,
		142,
		151,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		128,
		-1,
		133,
		134,
		129,
		137,
		142,
		120,
		107,
		107,
		117,
		110,
		129,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		116,
		133,
		125,
		115,
		130,
		123,
		110,
		107,
		105,
		102,
		118,
		116,
		126,
		-1,
		-1,
		226,
		195,
		224,
		182,
		163,
		-1,
		129,
		109,
		115,
		119,
		113,
		106,
		120,
		116,
		-1,
		96,
		95,
		123,
		109,
		120,
		186,
		-1,
		-1,
		184,
		176,
		159,
		162,
		139,
		135,
		124,
		123,
		115,
		101,
		97,
		103,
		106,
		106,
		112,
		90,
		100,
		104,
		102,
		127,
		-1,
		-1,
		162,
		-1,
		-1,
		183,
		166,
		-1,
		149,
		156,
		145,
		151,
		137,
		158,
		134,
		125,
		117,
		111,
		99,
		101,
		98,
		111,
		99,
		87,
		112,
		116,
		97,
		118,
		113,
		-1,
		161,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		142,
		145,
		151,
		175,
		174,
		-1,
		146,
		134,
		135,
		120,
		117,
		104,
		92,
		105,
		90,
		97,
		96,
		91,
		89,
		119,
		94,
		116,
		113,
		132,
		137,
		131,
		140,
		-1,
		191,
		187,
		183,
		190,
		139,
		-1,
		-1,
		179,
		-1,
		182,
		183,
		158,
		131,
		134,
		121,
		112,
		99,
		88,
		99,
		88,
		85,
		93,
		83,
		98,
		89,
		88,
		106,
		116,
		124,
		128,
		134,
		-1,
		241,
		-1,
		183,
		167,
		169,
		141,
		162,
		-1,
		199,
		183,
		175,
		160,
		160,
		-1,
		130,
		127,
		117,
		95,
		80,
		97,
		89,
		87,
		92,
		78,
		92,
		83,
		101,
		108,
		106,
		110,
		130,
		142,
		201,
		191,
		-1,
		173,
		178,
		137,
		145,
		164,
		202,
		166,
		-1,
		161,
		-1,
		132,
		145,
		-1,
		101,
		97,
		79,
		80,
		75,
		90,
		88,
		74,
		71,
		89,
		92,
		99,
		103,
		119,
		-1,
		-1,
		186,
		190,
		179,
		130,
		149,
		173,
		210,
		159,
		148,
		147,
		-1,
		138,
		115,
		112,
		100,
		87,
		72,
		73,
		81,
		86,
		65,
		73,
		70,
		90,
		116,
		94,
		106,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		156,
		127,
		151,
		193,
		177,
		170,
		158,
		123,
		123,
		117,
		-1,
		111,
		90,
		81,
		70,
		68,
		74,
		66,
		83,
		68,
		66,
		85,
		97,
		88,
		101,
		-1,
		-1,
		-1,
		186,
		175,
		176,
		122,
		145,
		182,
		156,
		142,
		147,
		122,
		115,
		109,
		124,
		107,
		88,
		77,
		69,
		58,
		62,
		70,
		74,
		64,
		73,
		79,
		103,
		89,
		95,
		-1,
		-1,
		193,
		183,
		167,
		169,
		166,
		136,
		143,
		175,
		147,
		160,
		-1,
		114,
		-1,
		103,
		98,
		82,
		77,
		74,
		66,
		53,
		66,
		76,
		63,
		65,
		65,
		108,
		108,
		79,
		99,
		102,
		-1,
		-1,
		-1,
		186,
		181,
		156,
		133,
		117,
		153,
		-1,
		130,
		131,
		-1,
		108,
		102,
		99,
		84,
		80,
		70,
		74,
		66,
		65,
		49,
		67,
		57,
		58,
		82,
		-1,
		87,
		81,
		89,
		79,
		67,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		112,
		164,
		-1,
		-1,
		115,
		108,
		-1,
		95,
		77,
		76,
		68,
		62,
		52,
		40,
		43,
		56,
		49,
		53,
		50,
		70,
		74,
		80,
		69,
		65,
		62,
		76,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		132,
		-1,
		124,
		116,
		106,
		100,
		94,
		90,
		88,
		90,
		74,
		68,
		49,
		39,
		22,
		38,
		31,
		47,
		47,
		65,
		75,
		67,
		61,
		60,
		72,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		145,
		-1,
		109,
		123,
		139,
		-1,
		132,
		111,
		126,
		104,
		100,
		88,
		81,
		82,
		55,
		43,
		22,
		10,
		17,
		32,
		55,
		49,
		71,
		71,
		55,
		56,
		65,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		106,
		94,
		126,
		-1,
		-1,
		168,
		-1,
		102,
		119,
		102,
		100,
		71,
		57,
		53,
		34,
		7,
		2,
		31,
		26,
		32,
		43,
		65,
		51,
		49,
		68,
		84,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		146,
		136,
		120,
		105,
		138,
		-1,
		69,
		58,
		63,
		-1,
		27,
		0,
		19,
		32,
		32,
		37,
		37,
		48,
		46,
		57,
		74,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		163,
		-1,
		-1,
		133,
		127,
		127,
		111,
		114,
		85,
		65,
		57,
		63,
		26,
		34,
		12,
		39,
		43,
		40,
		40,
		53,
		73,
		64,
		76,
		-1,
		-1,
		-1,
		160,
		146,
		150,
		110,
		129,
		-1,
		-1,
		195,
		150,
		136,
		-1,
		120,
		85,
		73,
		63,
		53,
		58,
		46,
		25,
		30,
		39,
		49,
		48,
		49,
		54,
		75,
		76,
		89,
		-1,
		-1,
		143,
		148,
		136,
		122,
		141,
		-1,
		-1,
		-1,
		142,
		158,
		147,
		121,
		74,
		-1,
		-1,
		57,
		50,
		38,
		39,
		43,
		55,
		62,
		64,
		48,
		63,
		75,
		83,
		88,
		-1,
		146,
		133,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		-1,
		-1,
		159,
		104,
		93,
		88,
		92,
		56,
		-1,
		44,
		45,
		47,
		53,
		60,
		66,
		61,
		55,
		58,
		76,
		93,
		-1,
		-1,
		158,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		81,
		74,
		78,
		-1,
		53,
		53,
		49,
		65,
		79,
		76,
		67,
		59,
		64,
		61,
		74,
		88,
		92,
		181,
		-1,
		164,
		-1,
		-1,
		-1,
		134,
		149,
		120,
		97,
		70,
		65,
		58,
		52,
		57,
		73,
		82,
		93,
		66,
		62,
		63,
		67,
		66,
		83,
		93,
		-1,
		-1,
		164,
		168,
		160,
		142,
		146,
		147,
		-1,
		-1,
		74,
		65,
		56,
		59,
		67,
		70,
		72,
		69,
		74,
		79,
		67,
		76,
		94,
		98,
		-1,
		-1,
		-1,
		184,
		-1,
		186,
		-1,
		-1,
		161,
		145,
		92,
		74,
		70,
		68,
		61,
		70,
		65,
		70,
		87,
		90,
		89,
		69,
		82,
		104,
		94,
		130,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		163,
		155,
		150,
		156,
		158,
		149,
		107,
		104,
		-1,
		74,
		99,
		71,
		78,
		70,
		83,
		88,
		93,
		72,
		79,
		95,
		94,
		89,
		122,
		116,
		122,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		156,
		152,
		142,
		132,
		135,
		-1,
		-1,
		123,
		120,
		96,
		80,
		84,
		77,
		72,
		101,
		81,
		68,
		72,
		76,
		82,
		87,
		92,
		98,
		113,
		128,
		-1,
		191,
		245,
		238,
		206,
		214,
		245,
		-1,
		146,
		138,
		149,
		124,
		126,
		-1,
		-1,
		96,
		93,
		98,
		87,
		84,
		96,
		95,
		97,
		82,
		88,
		75,
		74,
		92,
		96,
		105,
		112,
		102,
		115,
		119,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		143,
		-1,
		-1,
		155,
		127,
		111,
		101,
		95,
		145,
		101,
		96,
		98,
		100,
		94,
		85,
		92,
		83,
		83,
		86,
		101,
		106,
		98,
		112,
		112,
		113,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		171,
		-1,
		138,
		-1,
		113,
		117,
		109,
		112,
		119,
		106,
		98,
		90,
		106,
		81,
		91,
		87,
		88,
		97,
		108,
		120,
		119,
		120,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		155,
		194,
		209,
		-1,
		180,
		-1,
		-1,
		-1,
		127,
		122,
		114,
		130,
		118,
		118,
		92,
		96,
		86,
		93,
		103,
		105,
		97,
		101,
		114,
		125,
		128,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		170,
		161,
		188,
		214,
		205,
		200,
		187,
		-1,
		-1,
		150,
		132,
		-1,
		-1,
		125,
		113,
		96,
		97,
		93,
		96,
		111,
		114,
		104,
		102,
		96,
		128,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		189,
		184,
		188,
		204,
		229,
		-1,
		185,
		-1,
		-1,
		170,
		-1,
		-1,
		155,
		118,
		107,
		98,
		104,
		101,
		112,
		122,
		110,
		111,
		101,
		111,
		124,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		188,
		218,
		-1,
		-1,
		201,
		181,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		108,
		128,
		130,
		119,
		113,
		107,
		114,
		113,
		121,
		129,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		187,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		121,
		125,
		117,
		110,
		105,
		116,
		108,
		112,
		129,
		-1,
		231,
		-1,
		183,
		159,
		173,
		188,
		196,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		161,
		129,
		134,
		129,
		111,
		122,
		111,
		114,
		128,
		123,
		-1,
		-1,
		171,
		174,
		-1,
		-1,
		196,
		200,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		143,
		132,
		140,
		135,
		115,
		121,
		124,
		113,
		117,
		129,
		-1,
		-1,
		178,
		179,
		184,
		-1,
		183,
		-1,
		201,
		-1,
		168,
		174,
		162,
		-1,
		-1,
		-1,
		156,
		119,
		140,
		150,
		144,
		142,
		133,
		119,
		126,
		124,
		120,
		131,
		-1,
		-1,
		-1,
		201,
		175,
		208,
		199,
		182,
		162,
		154,
		173,
		-1,
		143,
		-1,
		118,
		120,
		146,
		149,
		155,
		149,
		122,
		137,
		127,
		118,
		127,
		207,
		-1,
		177,
		210,
		174,
		168,
		144,
		148,
		164,
		-1,
		140,
		122,
		-1,
		150,
		140,
		171,
		156,
		137,
		124,
		131,
		131,
		124,
		-1,
		-1,
		-1,
		179,
		178,
		170,
		164,
		164,
		149,
		140,
		-1,
		152,
		134,
		113,
		130,
		130,
		121,
		129,
		161,
		157,
		144,
		144,
		136,
		-1,
		280,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		173,
		168,
		141,
		129,
		135,
		131,
		117,
		123,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		137,
		172,
		-1,
		275,
		-1,
		209,
		-1,
		-1,
		191,
		171,
		163,
		152,
		141,
		139,
		130,
		121,
		143,
		159,
		143,
		141,
		144,
		145,
		-1,
		264,
		263,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		187,
		148,
		-1,
		150,
		130,
		-1,
		152,
		148,
		-1,
		-1,
		251,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		182,
		166,
		-1,
		141,
		141,
		-1,
		-1,
		-1,
		236,
		235,
		-1,
		204,
		207,
		-1,
		197,
		188,
		196,
		143,
		147,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		219,
		217,
		212,
		209,
		195,
		179,
		157,
		146,
		167,
		-1,
		-1,
		-1,
		217,
		209,
		202,
		-1,
		-1,
		204,
		187,
		168,
		166,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		194,
		-1,
		-1,
		200,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		228,
		-1,
		-1,
		-1,
		190,
		186,
		187,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		274,
		238,
		-1,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		210,
		194,
		-1,
		180,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		215,
		-1,
		215,
		190,
		197,
		-1,
		-1,
		-1,
		-1,
		228,
		220,
		228,
		-1,
		200,
		202,
		-1,
		250,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		205,
		212,
		234,
		237,
		273,
		-1,
		224
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		187,
		191,
		157,
		151,
		190,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		180,
		179,
		147,
		145,
		154,
		159,
		166,
		-1,
		165,
		-1,
		201,
		180,
		191,
		196,
		140,
		137,
		157,
		176,
		158,
		150,
		216,
		170,
		141,
		135,
		153,
		143,
		152,
		144,
		-1,
		141,
		131,
		153,
		132,
		143,
		135,
		-1,
		-1,
		135,
		136,
		142,
		128,
		134,
		130,
		-1,
		140,
		124,
		-1,
		-1,
		125,
		126,
		110,
		113,
		121,
		119,
		132,
		124,
		119,
		-1,
		-1,
		116,
		112,
		119,
		106,
		102,
		119,
		132,
		114,
		128,
		127,
		-1,
		121,
		139,
		145,
		113,
		111,
		95,
		93,
		111,
		113,
		119,
		119,
		-1,
		130,
		131,
		126,
		134,
		135,
		111,
		98,
		98,
		108,
		101,
		120,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		113,
		130,
		122,
		112,
		127,
		120,
		101,
		98,
		96,
		93,
		109,
		107,
		117,
		-1,
		-1,
		223,
		192,
		221,
		179,
		160,
		-1,
		126,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		87,
		86,
		114,
		100,
		111,
		183,
		-1,
		-1,
		181,
		173,
		156,
		159,
		136,
		132,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		81,
		91,
		95,
		93,
		118,
		-1,
		-1,
		153,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		142,
		148,
		134,
		155,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		78,
		103,
		107,
		88,
		109,
		104,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		171,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		82,
		80,
		110,
		85,
		107,
		104,
		123,
		128,
		122,
		131,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		179,
		180,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		74,
		89,
		80,
		79,
		97,
		107,
		115,
		119,
		125,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		180,
		172,
		157,
		157,
		-1,
		127,
		124,
		114,
		92,
		77,
		94,
		86,
		84,
		87,
		69,
		83,
		74,
		92,
		99,
		97,
		101,
		121,
		133,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		80,
		65,
		62,
		80,
		83,
		90,
		94,
		110,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		112,
		109,
		97,
		84,
		69,
		70,
		78,
		83,
		62,
		64,
		61,
		81,
		107,
		85,
		97,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		65,
		71,
		63,
		79,
		59,
		57,
		76,
		88,
		79,
		98,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		121,
		104,
		85,
		74,
		66,
		55,
		59,
		67,
		71,
		55,
		64,
		70,
		94,
		86,
		92,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		63,
		50,
		63,
		72,
		60,
		57,
		62,
		99,
		99,
		76,
		96,
		99,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		67,
		71,
		65,
		62,
		46,
		64,
		54,
		49,
		73,
		-1,
		84,
		78,
		86,
		76,
		64,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		79,
		74,
		73,
		63,
		51,
		40,
		53,
		46,
		50,
		42,
		61,
		65,
		77,
		66,
		62,
		59,
		73,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		79,
		63,
		54,
		42,
		35,
		28,
		44,
		38,
		56,
		72,
		64,
		58,
		57,
		69,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		91,
		101,
		102,
		75,
		63,
		42,
		30,
		33,
		28,
		46,
		46,
		65,
		68,
		52,
		53,
		62,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		105,
		103,
		91,
		70,
		73,
		54,
		27,
		22,
		26,
		23,
		29,
		40,
		62,
		48,
		46,
		65,
		81,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		69,
		65,
		72,
		-1,
		47,
		-1,
		0,
		13,
		13,
		32,
		34,
		45,
		43,
		54,
		71,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		85,
		65,
		57,
		72,
		29,
		34,
		15,
		32,
		25,
		29,
		37,
		50,
		70,
		61,
		73,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		85,
		73,
		63,
		53,
		58,
		46,
		25,
		30,
		30,
		30,
		37,
		46,
		51,
		72,
		73,
		86,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		74,
		-1,
		-1,
		57,
		50,
		38,
		39,
		38,
		55,
		62,
		58,
		45,
		60,
		72,
		80,
		85,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		159,
		104,
		93,
		88,
		92,
		56,
		-1,
		44,
		45,
		42,
		53,
		60,
		60,
		55,
		49,
		55,
		73,
		90,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		81,
		74,
		78,
		-1,
		53,
		53,
		44,
		61,
		73,
		70,
		61,
		53,
		58,
		58,
		71,
		85,
		89,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		134,
		149,
		120,
		97,
		70,
		65,
		58,
		52,
		52,
		68,
		77,
		88,
		60,
		56,
		57,
		64,
		63,
		80,
		90,
		-1,
		-1,
		161,
		168,
		160,
		142,
		146,
		147,
		-1,
		-1,
		74,
		65,
		56,
		59,
		62,
		65,
		66,
		63,
		68,
		73,
		61,
		73,
		91,
		95,
		-1,
		-1,
		-1,
		181,
		-1,
		186,
		-1,
		-1,
		161,
		145,
		92,
		74,
		70,
		68,
		61,
		70,
		65,
		70,
		81,
		90,
		83,
		63,
		79,
		101,
		91,
		127,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		163,
		155,
		150,
		156,
		158,
		149,
		107,
		104,
		-1,
		74,
		99,
		71,
		78,
		70,
		83,
		88,
		87,
		68,
		76,
		92,
		91,
		86,
		119,
		113,
		119,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		156,
		152,
		142,
		132,
		135,
		-1,
		-1,
		123,
		120,
		96,
		80,
		84,
		77,
		72,
		98,
		78,
		65,
		69,
		73,
		79,
		84,
		89,
		95,
		110,
		125,
		-1,
		188,
		245,
		238,
		206,
		214,
		245,
		-1,
		146,
		138,
		149,
		124,
		126,
		-1,
		-1,
		96,
		93,
		98,
		87,
		84,
		96,
		95,
		94,
		79,
		85,
		72,
		71,
		89,
		93,
		102,
		109,
		99,
		112,
		116,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		143,
		-1,
		-1,
		155,
		127,
		111,
		101,
		95,
		145,
		101,
		96,
		98,
		100,
		91,
		82,
		89,
		80,
		80,
		83,
		98,
		103,
		95,
		109,
		109,
		110,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		171,
		-1,
		138,
		-1,
		113,
		117,
		109,
		112,
		116,
		103,
		95,
		87,
		103,
		78,
		88,
		84,
		85,
		94,
		105,
		117,
		116,
		117,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		155,
		194,
		209,
		-1,
		180,
		-1,
		-1,
		-1,
		127,
		122,
		114,
		130,
		115,
		115,
		89,
		93,
		83,
		90,
		100,
		102,
		94,
		98,
		111,
		122,
		125,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		170,
		161,
		188,
		214,
		205,
		200,
		187,
		-1,
		-1,
		150,
		132,
		-1,
		-1,
		122,
		110,
		93,
		94,
		90,
		93,
		108,
		111,
		101,
		99,
		93,
		125,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		189,
		184,
		188,
		204,
		229,
		-1,
		182,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		115,
		104,
		95,
		101,
		98,
		109,
		119,
		107,
		108,
		98,
		108,
		121,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		188,
		218,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		100,
		105,
		125,
		127,
		116,
		110,
		104,
		111,
		110,
		118,
		126,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		118,
		122,
		114,
		107,
		102,
		113,
		105,
		109,
		126,
		-1,
		231,
		-1,
		183,
		159,
		173,
		188,
		196,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		158,
		126,
		131,
		126,
		108,
		119,
		108,
		111,
		125,
		120,
		-1,
		-1,
		171,
		174,
		-1,
		-1,
		195,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		115,
		140,
		129,
		137,
		132,
		112,
		118,
		121,
		110,
		114,
		126,
		-1,
		-1,
		178,
		179,
		184,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		153,
		116,
		137,
		147,
		141,
		139,
		130,
		116,
		123,
		121,
		117,
		128,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		117,
		143,
		146,
		152,
		146,
		119,
		134,
		124,
		115,
		124,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		168,
		153,
		134,
		121,
		128,
		128,
		121,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		158,
		154,
		141,
		141,
		133,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		134,
		169,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		141,
		142,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		185,
		189,
		155,
		149,
		188,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		178,
		177,
		145,
		143,
		152,
		157,
		164,
		-1,
		163,
		-1,
		199,
		178,
		189,
		194,
		138,
		135,
		155,
		174,
		156,
		148,
		214,
		168,
		139,
		133,
		151,
		141,
		150,
		142,
		-1,
		139,
		129,
		151,
		130,
		141,
		133,
		-1,
		-1,
		133,
		134,
		140,
		126,
		132,
		128,
		-1,
		138,
		122,
		-1,
		-1,
		123,
		124,
		108,
		111,
		119,
		117,
		130,
		122,
		117,
		-1,
		-1,
		114,
		110,
		117,
		104,
		100,
		117,
		130,
		112,
		126,
		125,
		-1,
		119,
		137,
		143,
		111,
		109,
		93,
		91,
		109,
		111,
		117,
		117,
		-1,
		128,
		129,
		124,
		132,
		133,
		109,
		96,
		96,
		106,
		99,
		118,
		106,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		111,
		128,
		120,
		110,
		125,
		118,
		99,
		96,
		94,
		91,
		107,
		105,
		115,
		-1,
		-1,
		221,
		190,
		219,
		177,
		158,
		-1,
		124,
		104,
		110,
		114,
		108,
		101,
		115,
		111,
		-1,
		85,
		84,
		112,
		98,
		109,
		181,
		-1,
		-1,
		179,
		171,
		154,
		157,
		134,
		130,
		119,
		118,
		110,
		96,
		92,
		98,
		101,
		101,
		107,
		79,
		89,
		93,
		91,
		116,
		-1,
		-1,
		151,
		-1,
		-1,
		178,
		161,
		-1,
		144,
		151,
		140,
		146,
		132,
		153,
		129,
		120,
		112,
		106,
		94,
		96,
		93,
		106,
		94,
		76,
		101,
		105,
		86,
		107,
		102,
		-1,
		150,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		137,
		140,
		146,
		170,
		169,
		-1,
		141,
		129,
		130,
		115,
		112,
		99,
		87,
		100,
		85,
		92,
		91,
		80,
		78,
		108,
		83,
		105,
		102,
		121,
		126,
		120,
		129,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		174,
		-1,
		177,
		178,
		153,
		126,
		129,
		116,
		107,
		94,
		83,
		94,
		83,
		80,
		88,
		72,
		87,
		78,
		77,
		95,
		105,
		113,
		117,
		123,
		-1,
		236,
		-1,
		178,
		162,
		164,
		136,
		157,
		-1,
		194,
		178,
		170,
		155,
		155,
		-1,
		125,
		122,
		112,
		90,
		75,
		92,
		84,
		82,
		85,
		67,
		81,
		72,
		90,
		97,
		95,
		99,
		119,
		131,
		196,
		186,
		-1,
		168,
		173,
		132,
		140,
		159,
		197,
		161,
		-1,
		156,
		-1,
		127,
		140,
		-1,
		96,
		92,
		74,
		75,
		70,
		85,
		78,
		63,
		60,
		78,
		81,
		88,
		92,
		108,
		-1,
		-1,
		181,
		185,
		174,
		125,
		144,
		168,
		205,
		154,
		143,
		142,
		-1,
		133,
		110,
		107,
		95,
		82,
		67,
		68,
		76,
		81,
		60,
		62,
		59,
		79,
		105,
		83,
		95,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		151,
		122,
		146,
		188,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		106,
		85,
		76,
		65,
		63,
		69,
		61,
		77,
		57,
		55,
		74,
		86,
		77,
		96,
		-1,
		-1,
		-1,
		181,
		170,
		171,
		117,
		140,
		177,
		151,
		137,
		142,
		117,
		110,
		104,
		119,
		102,
		83,
		72,
		64,
		53,
		57,
		65,
		69,
		53,
		62,
		68,
		92,
		84,
		90,
		-1,
		-1,
		188,
		178,
		162,
		164,
		161,
		131,
		138,
		170,
		142,
		155,
		-1,
		109,
		-1,
		98,
		93,
		77,
		72,
		69,
		61,
		48,
		61,
		70,
		58,
		55,
		60,
		97,
		97,
		74,
		94,
		97,
		-1,
		-1,
		-1,
		181,
		176,
		151,
		128,
		112,
		148,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		79,
		75,
		65,
		69,
		63,
		60,
		44,
		62,
		52,
		47,
		71,
		-1,
		82,
		76,
		84,
		74,
		62,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		77,
		72,
		71,
		61,
		49,
		38,
		51,
		44,
		48,
		40,
		59,
		63,
		75,
		64,
		60,
		57,
		71,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		99,
		83,
		77,
		61,
		52,
		46,
		33,
		26,
		42,
		36,
		54,
		70,
		62,
		56,
		55,
		67,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		95,
		89,
		99,
		100,
		73,
		61,
		46,
		34,
		37,
		26,
		44,
		44,
		63,
		66,
		50,
		51,
		60,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		103,
		101,
		89,
		74,
		77,
		58,
		31,
		26,
		24,
		21,
		27,
		38,
		60,
		46,
		44,
		63,
		79,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		73,
		69,
		76,
		-1,
		51,
		-1,
		4,
		0,
		11,
		30,
		32,
		43,
		41,
		52,
		69,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		89,
		69,
		61,
		76,
		33,
		38,
		19,
		30,
		23,
		27,
		35,
		48,
		68,
		59,
		71,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		89,
		77,
		67,
		57,
		62,
		50,
		29,
		34,
		28,
		28,
		35,
		44,
		49,
		70,
		71,
		84,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		78,
		-1,
		-1,
		61,
		54,
		42,
		43,
		36,
		56,
		62,
		56,
		43,
		58,
		70,
		78,
		83,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		163,
		108,
		97,
		92,
		96,
		60,
		-1,
		48,
		49,
		40,
		54,
		61,
		58,
		53,
		47,
		53,
		71,
		88,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		120,
		114,
		85,
		78,
		82,
		-1,
		57,
		56,
		42,
		59,
		71,
		68,
		59,
		51,
		56,
		56,
		69,
		83,
		87,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		138,
		153,
		124,
		101,
		74,
		69,
		62,
		56,
		50,
		66,
		75,
		86,
		58,
		54,
		55,
		62,
		61,
		78,
		88,
		-1,
		-1,
		159,
		172,
		164,
		146,
		150,
		151,
		-1,
		-1,
		78,
		69,
		60,
		63,
		60,
		63,
		64,
		61,
		66,
		71,
		59,
		71,
		89,
		93,
		-1,
		-1,
		-1,
		179,
		-1,
		190,
		-1,
		-1,
		165,
		149,
		96,
		78,
		74,
		72,
		65,
		74,
		69,
		69,
		79,
		89,
		81,
		61,
		77,
		99,
		89,
		125,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		167,
		159,
		154,
		160,
		162,
		153,
		111,
		108,
		-1,
		78,
		103,
		75,
		82,
		74,
		87,
		87,
		85,
		66,
		74,
		90,
		89,
		84,
		117,
		111,
		117,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		160,
		156,
		146,
		136,
		139,
		-1,
		-1,
		127,
		124,
		100,
		84,
		88,
		81,
		76,
		96,
		76,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		186,
		249,
		242,
		210,
		218,
		249,
		-1,
		150,
		142,
		153,
		128,
		130,
		-1,
		-1,
		100,
		97,
		102,
		91,
		88,
		100,
		99,
		92,
		77,
		83,
		70,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		200,
		225,
		204,
		207,
		231,
		245,
		-1,
		147,
		-1,
		-1,
		159,
		131,
		115,
		105,
		99,
		149,
		105,
		100,
		100,
		98,
		89,
		80,
		87,
		78,
		78,
		81,
		96,
		101,
		93,
		107,
		107,
		108,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		175,
		-1,
		142,
		-1,
		117,
		121,
		113,
		116,
		114,
		101,
		93,
		85,
		101,
		76,
		86,
		82,
		83,
		92,
		103,
		115,
		114,
		115,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		159,
		198,
		213,
		-1,
		184,
		-1,
		-1,
		-1,
		131,
		126,
		118,
		134,
		113,
		113,
		87,
		91,
		81,
		88,
		98,
		100,
		92,
		96,
		109,
		120,
		123,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		174,
		165,
		192,
		218,
		209,
		204,
		191,
		-1,
		-1,
		154,
		136,
		-1,
		-1,
		120,
		108,
		91,
		92,
		88,
		91,
		106,
		109,
		99,
		97,
		91,
		123,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		193,
		188,
		192,
		208,
		233,
		-1,
		180,
		-1,
		-1,
		165,
		-1,
		-1,
		150,
		113,
		102,
		93,
		99,
		96,
		107,
		117,
		105,
		106,
		96,
		106,
		119,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		192,
		222,
		-1,
		-1,
		196,
		176,
		-1,
		-1,
		148,
		146,
		135,
		-1,
		125,
		98,
		103,
		123,
		125,
		114,
		108,
		102,
		109,
		108,
		116,
		124,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		186,
		182,
		-1,
		-1,
		143,
		136,
		124,
		112,
		102,
		112,
		116,
		120,
		112,
		105,
		100,
		111,
		103,
		107,
		124,
		-1,
		235,
		-1,
		187,
		163,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		203,
		189,
		182,
		170,
		168,
		-1,
		177,
		161,
		142,
		-1,
		112,
		125,
		156,
		124,
		129,
		124,
		106,
		117,
		106,
		109,
		123,
		118,
		-1,
		-1,
		175,
		178,
		-1,
		-1,
		193,
		195,
		-1,
		194,
		183,
		168,
		160,
		-1,
		-1,
		149,
		145,
		-1,
		-1,
		113,
		138,
		127,
		135,
		130,
		110,
		116,
		119,
		108,
		112,
		124,
		-1,
		-1,
		182,
		183,
		188,
		-1,
		178,
		-1,
		196,
		-1,
		163,
		169,
		157,
		-1,
		-1,
		-1,
		151,
		114,
		135,
		145,
		139,
		137,
		128,
		114,
		121,
		119,
		115,
		126,
		-1,
		-1,
		-1,
		196,
		170,
		203,
		194,
		177,
		157,
		149,
		168,
		-1,
		138,
		-1,
		113,
		115,
		141,
		144,
		150,
		144,
		117,
		132,
		122,
		113,
		122,
		202,
		-1,
		172,
		205,
		169,
		163,
		139,
		143,
		159,
		-1,
		135,
		117,
		-1,
		145,
		135,
		166,
		151,
		132,
		119,
		126,
		126,
		119,
		-1,
		-1,
		-1,
		174,
		173,
		165,
		159,
		159,
		144,
		135,
		-1,
		147,
		129,
		108,
		125,
		125,
		116,
		124,
		156,
		152,
		139,
		139,
		131,
		-1,
		275,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		168,
		163,
		136,
		124,
		130,
		126,
		112,
		118,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		132,
		167,
		-1,
		270,
		-1,
		204,
		-1,
		-1,
		186,
		166,
		158,
		147,
		136,
		134,
		125,
		116,
		138,
		154,
		138,
		136,
		139,
		140,
		-1,
		259,
		258,
		-1,
		205,
		197,
		183,
		-1,
		176,
		-1,
		182,
		143,
		-1,
		145,
		125,
		-1,
		147,
		143,
		-1,
		-1,
		246,
		221,
		-1,
		-1,
		-1,
		206,
		186,
		177,
		161,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		231,
		230,
		-1,
		199,
		202,
		-1,
		192,
		183,
		191,
		138,
		142,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		214,
		212,
		207,
		204,
		190,
		174,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		212,
		204,
		197,
		-1,
		-1,
		199,
		182,
		163,
		161,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		189,
		-1,
		-1,
		195,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		223,
		-1,
		-1,
		-1,
		185,
		181,
		182,
		-1,
		-1,
		-1,
		-1,
		245,
		246,
		269,
		233,
		-1,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		248,
		246,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		175,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		210,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		223,
		215,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		200,
		207,
		229,
		232,
		268,
		-1,
		219
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		183,
		187,
		153,
		147,
		186,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		176,
		175,
		143,
		141,
		150,
		155,
		162,
		-1,
		161,
		-1,
		197,
		176,
		187,
		192,
		136,
		133,
		153,
		172,
		154,
		146,
		212,
		166,
		137,
		131,
		149,
		139,
		148,
		140,
		-1,
		137,
		127,
		149,
		128,
		139,
		131,
		-1,
		-1,
		131,
		132,
		138,
		124,
		130,
		126,
		-1,
		136,
		120,
		-1,
		-1,
		121,
		122,
		106,
		109,
		117,
		115,
		128,
		120,
		115,
		-1,
		-1,
		112,
		108,
		115,
		102,
		98,
		115,
		128,
		110,
		124,
		123,
		-1,
		116,
		134,
		141,
		109,
		107,
		91,
		89,
		107,
		109,
		115,
		115,
		-1,
		125,
		126,
		121,
		129,
		131,
		107,
		94,
		94,
		104,
		97,
		116,
		104,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		108,
		125,
		117,
		107,
		122,
		115,
		97,
		94,
		92,
		89,
		105,
		103,
		113,
		-1,
		-1,
		218,
		187,
		216,
		174,
		155,
		-1,
		121,
		101,
		107,
		111,
		105,
		98,
		112,
		108,
		-1,
		83,
		82,
		110,
		96,
		107,
		178,
		-1,
		-1,
		176,
		168,
		151,
		154,
		131,
		127,
		116,
		115,
		107,
		93,
		89,
		95,
		98,
		98,
		104,
		77,
		87,
		91,
		89,
		114,
		-1,
		-1,
		149,
		-1,
		-1,
		175,
		158,
		-1,
		141,
		148,
		137,
		143,
		129,
		150,
		126,
		117,
		109,
		103,
		91,
		93,
		90,
		103,
		91,
		74,
		99,
		103,
		84,
		105,
		100,
		-1,
		148,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		134,
		137,
		143,
		167,
		166,
		-1,
		138,
		126,
		127,
		112,
		109,
		96,
		84,
		97,
		82,
		89,
		88,
		78,
		76,
		106,
		81,
		103,
		100,
		119,
		124,
		118,
		127,
		-1,
		183,
		179,
		175,
		182,
		131,
		-1,
		-1,
		171,
		-1,
		174,
		175,
		150,
		123,
		126,
		113,
		104,
		91,
		80,
		91,
		80,
		77,
		85,
		70,
		85,
		76,
		75,
		93,
		103,
		111,
		115,
		121,
		-1,
		233,
		-1,
		175,
		159,
		161,
		133,
		154,
		-1,
		191,
		175,
		167,
		152,
		152,
		-1,
		122,
		119,
		109,
		87,
		72,
		89,
		81,
		79,
		83,
		65,
		79,
		70,
		88,
		95,
		93,
		97,
		117,
		129,
		193,
		183,
		-1,
		165,
		170,
		129,
		137,
		156,
		194,
		158,
		-1,
		153,
		-1,
		124,
		137,
		-1,
		93,
		89,
		71,
		72,
		67,
		82,
		76,
		61,
		58,
		76,
		79,
		86,
		90,
		106,
		-1,
		-1,
		178,
		182,
		171,
		122,
		141,
		165,
		202,
		151,
		140,
		139,
		-1,
		130,
		107,
		104,
		92,
		79,
		64,
		65,
		73,
		80,
		59,
		60,
		57,
		77,
		103,
		81,
		93,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		148,
		119,
		143,
		185,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		103,
		82,
		73,
		62,
		60,
		68,
		60,
		75,
		55,
		53,
		72,
		84,
		75,
		87,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		114,
		137,
		174,
		148,
		134,
		139,
		114,
		107,
		101,
		116,
		99,
		80,
		69,
		61,
		50,
		56,
		64,
		68,
		51,
		60,
		66,
		90,
		75,
		81,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		128,
		135,
		167,
		139,
		152,
		-1,
		106,
		-1,
		95,
		90,
		74,
		69,
		66,
		56,
		47,
		60,
		68,
		57,
		53,
		59,
		95,
		95,
		65,
		85,
		88,
		-1,
		-1,
		-1,
		178,
		173,
		148,
		125,
		109,
		145,
		-1,
		122,
		123,
		-1,
		100,
		94,
		91,
		76,
		72,
		60,
		64,
		62,
		59,
		43,
		61,
		51,
		45,
		70,
		-1,
		73,
		67,
		75,
		65,
		53,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		104,
		156,
		-1,
		-1,
		107,
		100,
		-1,
		87,
		69,
		72,
		67,
		66,
		60,
		48,
		37,
		50,
		43,
		47,
		39,
		58,
		62,
		66,
		55,
		51,
		48,
		62,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		124,
		-1,
		116,
		108,
		98,
		92,
		86,
		82,
		80,
		94,
		78,
		76,
		60,
		51,
		55,
		32,
		25,
		41,
		35,
		53,
		61,
		53,
		47,
		46,
		58,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		137,
		-1,
		101,
		115,
		131,
		-1,
		124,
		103,
		118,
		96,
		92,
		84,
		98,
		99,
		72,
		60,
		55,
		43,
		37,
		26,
		43,
		35,
		57,
		57,
		41,
		42,
		51,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		98,
		86,
		118,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		98,
		96,
		88,
		74,
		80,
		67,
		40,
		35,
		31,
		20,
		26,
		29,
		51,
		37,
		35,
		54,
		70,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		82,
		75,
		80,
		-1,
		60,
		-1,
		13,
		9,
		0,
		19,
		23,
		34,
		32,
		43,
		60,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		155,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		98,
		78,
		70,
		80,
		42,
		47,
		28,
		19,
		12,
		16,
		26,
		39,
		59,
		50,
		62,
		-1,
		-1,
		-1,
		152,
		138,
		142,
		102,
		121,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		98,
		86,
		76,
		66,
		71,
		59,
		38,
		31,
		17,
		17,
		24,
		35,
		40,
		61,
		62,
		75,
		-1,
		-1,
		135,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		134,
		150,
		141,
		113,
		87,
		-1,
		-1,
		70,
		63,
		51,
		38,
		25,
		45,
		51,
		45,
		34,
		49,
		61,
		69,
		74,
		-1,
		138,
		125,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		153,
		98,
		87,
		82,
		86,
		69,
		-1,
		57,
		47,
		29,
		43,
		50,
		47,
		42,
		36,
		44,
		62,
		79,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		110,
		104,
		75,
		68,
		72,
		-1,
		59,
		45,
		31,
		48,
		60,
		57,
		48,
		40,
		45,
		47,
		60,
		74,
		78,
		173,
		-1,
		156,
		-1,
		-1,
		-1,
		128,
		143,
		114,
		91,
		64,
		59,
		52,
		46,
		39,
		55,
		64,
		75,
		47,
		43,
		44,
		53,
		52,
		69,
		79,
		-1,
		-1,
		156,
		162,
		154,
		136,
		140,
		141,
		-1,
		-1,
		68,
		59,
		50,
		53,
		49,
		52,
		53,
		50,
		55,
		60,
		48,
		62,
		78,
		84,
		-1,
		-1,
		-1,
		176,
		-1,
		180,
		-1,
		-1,
		155,
		139,
		86,
		68,
		64,
		62,
		55,
		64,
		58,
		58,
		68,
		78,
		70,
		50,
		68,
		88,
		80,
		116,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		151,
		142,
		101,
		98,
		-1,
		68,
		93,
		64,
		71,
		63,
		76,
		76,
		74,
		55,
		65,
		81,
		80,
		75,
		108,
		102,
		108,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		150,
		146,
		136,
		126,
		128,
		-1,
		-1,
		116,
		113,
		90,
		73,
		78,
		71,
		66,
		87,
		67,
		54,
		58,
		62,
		68,
		73,
		78,
		84,
		99,
		114,
		-1,
		183,
		238,
		231,
		199,
		207,
		238,
		-1,
		140,
		132,
		143,
		118,
		119,
		-1,
		-1,
		89,
		87,
		92,
		80,
		77,
		90,
		89,
		83,
		68,
		74,
		61,
		60,
		78,
		82,
		91,
		98,
		88,
		101,
		105,
		-1,
		194,
		214,
		193,
		196,
		220,
		234,
		-1,
		137,
		-1,
		-1,
		149,
		120,
		104,
		95,
		88,
		139,
		94,
		89,
		91,
		89,
		80,
		71,
		78,
		69,
		69,
		72,
		87,
		92,
		84,
		98,
		98,
		99,
		-1,
		183,
		194,
		187,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		165,
		-1,
		131,
		-1,
		106,
		110,
		102,
		105,
		105,
		92,
		84,
		76,
		92,
		67,
		77,
		73,
		74,
		83,
		94,
		106,
		105,
		106,
		208,
		164,
		167,
		178,
		189,
		204,
		208,
		-1,
		149,
		188,
		203,
		-1,
		174,
		-1,
		-1,
		-1,
		120,
		115,
		107,
		123,
		104,
		104,
		78,
		82,
		72,
		79,
		89,
		91,
		83,
		87,
		100,
		111,
		114,
		204,
		195,
		208,
		153,
		153,
		174,
		183,
		204,
		164,
		155,
		182,
		207,
		199,
		194,
		181,
		-1,
		-1,
		143,
		125,
		-1,
		-1,
		111,
		99,
		82,
		83,
		79,
		82,
		97,
		100,
		90,
		88,
		82,
		114,
		-1,
		197,
		196,
		185,
		182,
		158,
		149,
		144,
		171,
		-1,
		-1,
		166,
		183,
		177,
		181,
		197,
		222,
		-1,
		171,
		-1,
		-1,
		156,
		-1,
		-1,
		141,
		104,
		93,
		84,
		90,
		87,
		98,
		108,
		96,
		97,
		87,
		97,
		110,
		181,
		178,
		166,
		164,
		187,
		152,
		140,
		-1,
		153,
		151,
		157,
		164,
		181,
		211,
		-1,
		-1,
		187,
		167,
		-1,
		-1,
		139,
		137,
		126,
		-1,
		116,
		89,
		94,
		114,
		116,
		105,
		99,
		93,
		100,
		99,
		107,
		115,
		190,
		204,
		193,
		189,
		188,
		196,
		145,
		138,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		177,
		173,
		-1,
		-1,
		134,
		127,
		115,
		103,
		93,
		103,
		107,
		111,
		103,
		96,
		91,
		102,
		94,
		98,
		115,
		-1,
		224,
		-1,
		176,
		152,
		166,
		181,
		189,
		-1,
		-1,
		-1,
		194,
		180,
		173,
		161,
		159,
		-1,
		168,
		152,
		133,
		-1,
		103,
		116,
		147,
		115,
		120,
		115,
		97,
		108,
		97,
		100,
		114,
		109,
		-1,
		-1,
		164,
		167,
		-1,
		-1,
		184,
		186,
		-1,
		185,
		174,
		159,
		151,
		-1,
		-1,
		140,
		136,
		-1,
		-1,
		104,
		129,
		118,
		126,
		121,
		101,
		107,
		110,
		99,
		103,
		115,
		-1,
		-1,
		171,
		172,
		177,
		-1,
		169,
		-1,
		187,
		-1,
		154,
		160,
		148,
		-1,
		-1,
		-1,
		142,
		105,
		126,
		136,
		130,
		128,
		119,
		105,
		112,
		110,
		106,
		117,
		-1,
		-1,
		-1,
		187,
		161,
		194,
		185,
		168,
		148,
		140,
		159,
		-1,
		129,
		-1,
		104,
		106,
		132,
		135,
		141,
		135,
		108,
		123,
		113,
		104,
		113,
		193,
		-1,
		163,
		196,
		160,
		154,
		130,
		134,
		150,
		-1,
		126,
		108,
		-1,
		136,
		126,
		157,
		142,
		123,
		110,
		117,
		117,
		110,
		-1,
		-1,
		-1,
		165,
		164,
		156,
		150,
		150,
		135,
		126,
		-1,
		138,
		120,
		99,
		116,
		116,
		107,
		115,
		147,
		143,
		130,
		130,
		122,
		-1,
		266,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		159,
		154,
		127,
		115,
		121,
		117,
		103,
		109,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		123,
		158,
		-1,
		261,
		-1,
		195,
		-1,
		-1,
		177,
		157,
		149,
		138,
		127,
		125,
		116,
		107,
		129,
		145,
		129,
		127,
		130,
		131,
		-1,
		250,
		249,
		-1,
		196,
		188,
		174,
		-1,
		167,
		-1,
		173,
		134,
		-1,
		136,
		116,
		-1,
		138,
		134,
		-1,
		-1,
		237,
		212,
		-1,
		-1,
		-1,
		197,
		177,
		168,
		152,
		-1,
		127,
		127,
		-1,
		-1,
		-1,
		222,
		221,
		-1,
		190,
		193,
		-1,
		183,
		174,
		182,
		129,
		133,
		-1,
		-1,
		-1,
		231,
		212,
		206,
		205,
		203,
		198,
		195,
		181,
		165,
		143,
		132,
		153,
		-1,
		-1,
		-1,
		203,
		195,
		188,
		-1,
		-1,
		190,
		173,
		154,
		152,
		-1,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		180,
		-1,
		-1,
		186,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		214,
		-1,
		-1,
		-1,
		176,
		172,
		173,
		-1,
		-1,
		-1,
		-1,
		236,
		237,
		260,
		224,
		-1,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		239,
		237,
		-1,
		-1,
		-1,
		196,
		180,
		-1,
		166,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		201,
		-1,
		201,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		214,
		206,
		214,
		-1,
		186,
		188,
		-1,
		236,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		191,
		198,
		220,
		223,
		259,
		-1,
		210
	],
	[
		-1,
		158,
		147,
		158,
		166,
		139,
		146,
		-1,
		165,
		169,
		135,
		129,
		168,
		137,
		143,
		154,
		-1,
		-1,
		-1,
		158,
		157,
		125,
		123,
		132,
		137,
		144,
		-1,
		143,
		-1,
		179,
		158,
		169,
		174,
		118,
		115,
		135,
		154,
		136,
		128,
		194,
		148,
		119,
		113,
		131,
		121,
		130,
		122,
		-1,
		119,
		109,
		131,
		110,
		121,
		113,
		-1,
		-1,
		113,
		114,
		120,
		106,
		112,
		108,
		-1,
		118,
		102,
		-1,
		-1,
		103,
		104,
		88,
		91,
		99,
		97,
		110,
		102,
		97,
		-1,
		-1,
		94,
		90,
		97,
		84,
		80,
		97,
		110,
		92,
		106,
		105,
		-1,
		100,
		118,
		123,
		91,
		89,
		73,
		71,
		89,
		91,
		97,
		97,
		-1,
		109,
		110,
		105,
		113,
		113,
		89,
		76,
		76,
		86,
		79,
		98,
		86,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		92,
		109,
		101,
		91,
		106,
		99,
		79,
		76,
		74,
		71,
		87,
		85,
		95,
		-1,
		-1,
		200,
		169,
		200,
		158,
		139,
		-1,
		105,
		85,
		91,
		95,
		89,
		82,
		96,
		92,
		-1,
		65,
		64,
		92,
		78,
		89,
		160,
		-1,
		-1,
		158,
		150,
		135,
		138,
		115,
		111,
		100,
		99,
		91,
		77,
		73,
		79,
		82,
		82,
		88,
		59,
		69,
		73,
		71,
		96,
		-1,
		-1,
		131,
		-1,
		-1,
		157,
		140,
		-1,
		123,
		130,
		121,
		127,
		113,
		134,
		110,
		101,
		93,
		87,
		75,
		77,
		74,
		87,
		75,
		56,
		81,
		85,
		66,
		87,
		82,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		116,
		119,
		125,
		149,
		150,
		-1,
		122,
		110,
		111,
		96,
		93,
		80,
		68,
		81,
		66,
		73,
		72,
		60,
		58,
		88,
		63,
		85,
		82,
		101,
		106,
		100,
		109,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		153,
		-1,
		158,
		159,
		134,
		107,
		110,
		97,
		88,
		75,
		64,
		75,
		64,
		61,
		69,
		52,
		67,
		58,
		57,
		75,
		85,
		93,
		97,
		103,
		-1,
		215,
		-1,
		157,
		141,
		143,
		115,
		136,
		-1,
		173,
		159,
		151,
		136,
		134,
		-1,
		106,
		103,
		93,
		71,
		56,
		73,
		65,
		63,
		65,
		47,
		61,
		52,
		70,
		77,
		75,
		79,
		99,
		111,
		175,
		165,
		-1,
		147,
		152,
		111,
		119,
		138,
		176,
		140,
		-1,
		135,
		-1,
		108,
		121,
		-1,
		77,
		73,
		55,
		56,
		51,
		66,
		58,
		43,
		40,
		58,
		61,
		68,
		72,
		88,
		-1,
		-1,
		160,
		164,
		153,
		104,
		123,
		147,
		184,
		133,
		122,
		121,
		-1,
		112,
		91,
		88,
		76,
		63,
		48,
		49,
		57,
		69,
		48,
		42,
		39,
		59,
		85,
		63,
		75,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		130,
		101,
		125,
		167,
		151,
		144,
		132,
		97,
		97,
		91,
		-1,
		87,
		66,
		57,
		46,
		44,
		57,
		49,
		57,
		37,
		35,
		54,
		66,
		57,
		68,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		96,
		119,
		156,
		130,
		116,
		121,
		96,
		89,
		83,
		100,
		83,
		64,
		53,
		45,
		34,
		45,
		53,
		51,
		33,
		42,
		48,
		72,
		56,
		62,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		110,
		117,
		149,
		121,
		134,
		-1,
		88,
		-1,
		77,
		73,
		58,
		53,
		50,
		37,
		36,
		50,
		50,
		40,
		35,
		42,
		77,
		77,
		46,
		66,
		69,
		-1,
		-1,
		-1,
		160,
		155,
		130,
		107,
		91,
		127,
		-1,
		104,
		105,
		-1,
		82,
		76,
		73,
		60,
		56,
		41,
		45,
		47,
		50,
		38,
		44,
		45,
		27,
		51,
		-1,
		54,
		48,
		56,
		46,
		34,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		86,
		138,
		-1,
		-1,
		89,
		82,
		-1,
		69,
		51,
		53,
		48,
		47,
		46,
		43,
		32,
		45,
		38,
		32,
		26,
		39,
		43,
		47,
		36,
		32,
		29,
		43,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		106,
		-1,
		98,
		90,
		80,
		74,
		68,
		64,
		62,
		75,
		59,
		58,
		55,
		46,
		54,
		27,
		20,
		31,
		16,
		34,
		42,
		34,
		28,
		27,
		39,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		119,
		-1,
		83,
		97,
		113,
		-1,
		106,
		85,
		100,
		78,
		74,
		65,
		82,
		83,
		61,
		55,
		53,
		44,
		32,
		21,
		24,
		16,
		38,
		38,
		22,
		23,
		32,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		80,
		68,
		100,
		-1,
		-1,
		142,
		-1,
		76,
		93,
		79,
		77,
		72,
		63,
		69,
		64,
		41,
		36,
		26,
		15,
		8,
		10,
		32,
		18,
		16,
		35,
		51,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		117,
		-1,
		120,
		110,
		94,
		79,
		112,
		-1,
		80,
		64,
		69,
		-1,
		61,
		-1,
		28,
		24,
		15,
		0,
		4,
		15,
		13,
		24,
		41,
		-1,
		129,
		114,
		107,
		97,
		111,
		82,
		-1,
		137,
		-1,
		-1,
		107,
		101,
		101,
		85,
		88,
		96,
		76,
		68,
		69,
		56,
		41,
		42,
		13,
		6,
		3,
		7,
		20,
		40,
		31,
		43,
		-1,
		-1,
		-1,
		134,
		120,
		124,
		84,
		103,
		-1,
		-1,
		169,
		124,
		110,
		-1,
		94,
		96,
		84,
		74,
		64,
		67,
		57,
		32,
		25,
		11,
		13,
		11,
		16,
		21,
		42,
		43,
		56,
		-1,
		-1,
		117,
		122,
		110,
		96,
		115,
		-1,
		-1,
		-1,
		116,
		132,
		124,
		95,
		85,
		-1,
		-1,
		68,
		59,
		49,
		28,
		15,
		35,
		38,
		31,
		15,
		30,
		42,
		50,
		55,
		-1,
		120,
		107,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		-1,
		-1,
		143,
		88,
		77,
		72,
		76,
		67,
		-1,
		48,
		39,
		19,
		33,
		40,
		33,
		28,
		22,
		25,
		43,
		60,
		-1,
		-1,
		132,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		65,
		58,
		62,
		-1,
		49,
		35,
		21,
		38,
		46,
		43,
		34,
		26,
		31,
		28,
		41,
		55,
		59,
		155,
		-1,
		138,
		-1,
		-1,
		-1,
		118,
		133,
		104,
		81,
		54,
		49,
		42,
		36,
		29,
		45,
		54,
		65,
		33,
		29,
		30,
		34,
		33,
		50,
		60,
		-1,
		-1,
		138,
		152,
		144,
		126,
		130,
		131,
		-1,
		-1,
		58,
		49,
		40,
		43,
		39,
		42,
		39,
		36,
		41,
		46,
		34,
		43,
		61,
		65,
		-1,
		-1,
		-1,
		158,
		-1,
		170,
		-1,
		-1,
		145,
		129,
		76,
		58,
		54,
		52,
		45,
		54,
		48,
		44,
		54,
		64,
		56,
		36,
		49,
		71,
		61,
		97,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		147,
		139,
		134,
		140,
		141,
		132,
		91,
		88,
		-1,
		58,
		83,
		54,
		61,
		53,
		62,
		62,
		60,
		39,
		46,
		62,
		61,
		56,
		89,
		83,
		89,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		140,
		136,
		126,
		116,
		118,
		-1,
		-1,
		106,
		103,
		80,
		63,
		68,
		61,
		56,
		68,
		48,
		35,
		39,
		43,
		49,
		54,
		59,
		65,
		80,
		95,
		-1,
		165,
		228,
		221,
		189,
		197,
		228,
		-1,
		130,
		122,
		133,
		108,
		109,
		-1,
		-1,
		79,
		77,
		82,
		70,
		67,
		78,
		73,
		64,
		49,
		55,
		42,
		41,
		59,
		63,
		72,
		79,
		69,
		82,
		86,
		-1,
		179,
		204,
		183,
		186,
		210,
		224,
		-1,
		127,
		-1,
		-1,
		139,
		110,
		94,
		85,
		78,
		129,
		84,
		79,
		72,
		70,
		61,
		52,
		59,
		50,
		50,
		53,
		68,
		73,
		65,
		79,
		79,
		80,
		-1,
		173,
		184,
		177,
		-1,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		155,
		-1,
		121,
		-1,
		96,
		100,
		92,
		95,
		86,
		73,
		65,
		57,
		73,
		48,
		58,
		54,
		55,
		64,
		75,
		87,
		86,
		87,
		198,
		154,
		157,
		168,
		179,
		194,
		198,
		-1,
		139,
		178,
		185,
		-1,
		164,
		-1,
		-1,
		-1,
		110,
		105,
		97,
		106,
		85,
		85,
		59,
		63,
		53,
		60,
		70,
		72,
		64,
		68,
		81,
		92,
		95,
		194,
		185,
		198,
		143,
		143,
		164,
		173,
		194,
		154,
		145,
		172,
		192,
		181,
		176,
		163,
		-1,
		-1,
		133,
		115,
		-1,
		-1,
		92,
		80,
		63,
		64,
		60,
		63,
		78,
		81,
		71,
		69,
		63,
		95,
		-1,
		187,
		186,
		175,
		172,
		148,
		139,
		134,
		161,
		-1,
		-1,
		156,
		173,
		167,
		171,
		187,
		212,
		-1,
		152,
		-1,
		-1,
		137,
		-1,
		-1,
		122,
		85,
		74,
		65,
		71,
		68,
		79,
		89,
		77,
		78,
		68,
		78,
		91,
		171,
		168,
		156,
		154,
		177,
		142,
		130,
		-1,
		143,
		141,
		147,
		154,
		171,
		201,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		120,
		118,
		107,
		-1,
		97,
		70,
		75,
		95,
		97,
		86,
		80,
		74,
		81,
		80,
		88,
		96,
		180,
		194,
		183,
		179,
		178,
		186,
		135,
		128,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		115,
		108,
		96,
		84,
		74,
		84,
		88,
		92,
		84,
		77,
		72,
		83,
		75,
		79,
		96,
		-1,
		214,
		-1,
		166,
		142,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		149,
		133,
		114,
		-1,
		84,
		97,
		128,
		96,
		101,
		96,
		78,
		89,
		78,
		81,
		95,
		90,
		-1,
		-1,
		154,
		157,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		121,
		117,
		-1,
		-1,
		85,
		110,
		99,
		107,
		102,
		82,
		88,
		91,
		80,
		84,
		96,
		-1,
		-1,
		161,
		162,
		167,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		123,
		86,
		107,
		117,
		111,
		109,
		100,
		86,
		93,
		91,
		87,
		98,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		87,
		113,
		116,
		122,
		116,
		89,
		104,
		94,
		85,
		94,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		107,
		138,
		123,
		104,
		91,
		98,
		98,
		91,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		96,
		128,
		124,
		111,
		111,
		103,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		104,
		139,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		110,
		108,
		111,
		112,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		119,
		115,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		154,
		143,
		154,
		162,
		135,
		142,
		-1,
		161,
		165,
		131,
		125,
		164,
		133,
		139,
		150,
		-1,
		-1,
		-1,
		154,
		153,
		121,
		119,
		128,
		133,
		140,
		-1,
		139,
		-1,
		175,
		154,
		165,
		170,
		114,
		111,
		131,
		150,
		132,
		124,
		190,
		144,
		115,
		109,
		127,
		117,
		126,
		118,
		-1,
		115,
		105,
		127,
		106,
		117,
		109,
		-1,
		-1,
		109,
		110,
		116,
		102,
		108,
		104,
		-1,
		114,
		98,
		-1,
		-1,
		99,
		100,
		84,
		87,
		95,
		93,
		106,
		98,
		93,
		-1,
		-1,
		90,
		86,
		93,
		80,
		76,
		93,
		106,
		88,
		102,
		101,
		-1,
		96,
		114,
		119,
		87,
		85,
		69,
		67,
		85,
		87,
		93,
		93,
		-1,
		105,
		106,
		101,
		109,
		109,
		85,
		72,
		72,
		82,
		75,
		94,
		82,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		105,
		88,
		105,
		97,
		87,
		102,
		95,
		75,
		72,
		70,
		67,
		83,
		81,
		91,
		-1,
		-1,
		196,
		165,
		196,
		154,
		135,
		-1,
		101,
		81,
		87,
		91,
		85,
		78,
		92,
		88,
		-1,
		61,
		60,
		88,
		74,
		85,
		156,
		-1,
		-1,
		154,
		146,
		131,
		134,
		111,
		107,
		96,
		95,
		87,
		73,
		69,
		75,
		78,
		78,
		84,
		55,
		65,
		69,
		67,
		92,
		-1,
		-1,
		127,
		-1,
		-1,
		153,
		136,
		-1,
		119,
		126,
		117,
		123,
		109,
		130,
		106,
		97,
		89,
		83,
		71,
		73,
		70,
		83,
		71,
		52,
		77,
		81,
		62,
		83,
		78,
		-1,
		126,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		115,
		121,
		145,
		146,
		-1,
		118,
		106,
		107,
		92,
		89,
		76,
		64,
		77,
		62,
		69,
		68,
		56,
		54,
		84,
		59,
		81,
		78,
		97,
		102,
		96,
		105,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		149,
		-1,
		154,
		155,
		130,
		103,
		106,
		93,
		84,
		71,
		60,
		71,
		60,
		57,
		65,
		48,
		63,
		54,
		53,
		71,
		81,
		89,
		93,
		99,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		169,
		155,
		147,
		132,
		130,
		-1,
		102,
		99,
		89,
		67,
		52,
		69,
		61,
		59,
		61,
		43,
		57,
		48,
		66,
		73,
		71,
		75,
		95,
		107,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		131,
		-1,
		104,
		117,
		-1,
		73,
		69,
		51,
		52,
		47,
		62,
		54,
		39,
		36,
		54,
		57,
		64,
		68,
		84,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		108,
		87,
		84,
		72,
		59,
		44,
		45,
		53,
		65,
		44,
		38,
		35,
		55,
		81,
		59,
		71,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		83,
		62,
		53,
		42,
		40,
		53,
		45,
		53,
		33,
		31,
		50,
		62,
		53,
		64,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		96,
		79,
		60,
		49,
		41,
		30,
		41,
		49,
		47,
		29,
		38,
		44,
		68,
		52,
		58,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		69,
		54,
		49,
		46,
		33,
		32,
		46,
		46,
		36,
		31,
		38,
		73,
		73,
		42,
		62,
		65,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		69,
		56,
		52,
		37,
		41,
		43,
		46,
		34,
		40,
		41,
		23,
		47,
		-1,
		50,
		44,
		52,
		42,
		30,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		65,
		47,
		49,
		44,
		43,
		42,
		39,
		28,
		41,
		34,
		28,
		22,
		35,
		39,
		43,
		32,
		28,
		25,
		39,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		60,
		58,
		71,
		55,
		54,
		51,
		42,
		50,
		23,
		16,
		27,
		12,
		30,
		38,
		30,
		24,
		23,
		35,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		70,
		61,
		78,
		79,
		57,
		51,
		49,
		40,
		28,
		17,
		20,
		12,
		34,
		34,
		18,
		19,
		28,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		75,
		73,
		68,
		59,
		65,
		60,
		37,
		32,
		22,
		11,
		11,
		6,
		28,
		14,
		12,
		31,
		47,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		76,
		60,
		65,
		-1,
		57,
		-1,
		30,
		27,
		18,
		3,
		0,
		11,
		9,
		20,
		37,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		92,
		72,
		66,
		65,
		52,
		44,
		38,
		16,
		9,
		6,
		3,
		16,
		36,
		27,
		39,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		99,
		87,
		77,
		67,
		70,
		60,
		35,
		28,
		14,
		16,
		14,
		12,
		17,
		38,
		39,
		52,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		88,
		-1,
		-1,
		71,
		62,
		52,
		31,
		18,
		38,
		41,
		27,
		11,
		26,
		38,
		46,
		51,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		139,
		84,
		73,
		68,
		72,
		70,
		-1,
		44,
		42,
		22,
		36,
		43,
		29,
		24,
		18,
		21,
		39,
		56,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		96,
		90,
		61,
		54,
		58,
		-1,
		46,
		38,
		24,
		41,
		42,
		39,
		30,
		22,
		27,
		24,
		37,
		51,
		55,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		114,
		129,
		100,
		77,
		50,
		45,
		38,
		32,
		32,
		48,
		50,
		61,
		29,
		25,
		26,
		30,
		29,
		46,
		56,
		-1,
		-1,
		134,
		148,
		140,
		122,
		126,
		127,
		-1,
		-1,
		54,
		45,
		36,
		39,
		42,
		45,
		35,
		32,
		37,
		42,
		30,
		39,
		57,
		61,
		-1,
		-1,
		-1,
		154,
		-1,
		166,
		-1,
		-1,
		141,
		125,
		72,
		54,
		50,
		48,
		41,
		50,
		45,
		40,
		50,
		60,
		52,
		32,
		45,
		67,
		57,
		93,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		143,
		135,
		130,
		136,
		138,
		129,
		87,
		84,
		-1,
		54,
		79,
		51,
		58,
		50,
		58,
		58,
		56,
		35,
		42,
		58,
		57,
		52,
		85,
		79,
		85,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		136,
		132,
		122,
		112,
		115,
		-1,
		-1,
		103,
		100,
		76,
		60,
		64,
		57,
		52,
		64,
		44,
		31,
		35,
		39,
		45,
		50,
		55,
		61,
		76,
		91,
		-1,
		161,
		225,
		218,
		186,
		194,
		225,
		-1,
		126,
		118,
		129,
		104,
		106,
		-1,
		-1,
		76,
		73,
		78,
		67,
		64,
		74,
		69,
		60,
		45,
		51,
		38,
		37,
		55,
		59,
		68,
		75,
		65,
		78,
		82,
		-1,
		175,
		201,
		180,
		183,
		207,
		221,
		-1,
		123,
		-1,
		-1,
		135,
		107,
		91,
		81,
		75,
		125,
		81,
		76,
		68,
		66,
		57,
		48,
		55,
		46,
		46,
		49,
		64,
		69,
		61,
		75,
		75,
		76,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		151,
		-1,
		118,
		-1,
		93,
		97,
		89,
		92,
		82,
		69,
		61,
		53,
		69,
		44,
		54,
		50,
		51,
		60,
		71,
		83,
		82,
		83,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		135,
		174,
		181,
		-1,
		160,
		-1,
		-1,
		-1,
		107,
		102,
		94,
		102,
		81,
		81,
		55,
		59,
		49,
		56,
		66,
		68,
		60,
		64,
		77,
		88,
		91,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		150,
		141,
		168,
		188,
		177,
		172,
		159,
		-1,
		-1,
		130,
		112,
		-1,
		-1,
		88,
		76,
		59,
		60,
		56,
		59,
		74,
		77,
		67,
		65,
		59,
		91,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		169,
		164,
		168,
		184,
		209,
		-1,
		148,
		-1,
		-1,
		133,
		-1,
		-1,
		118,
		81,
		70,
		61,
		67,
		64,
		75,
		85,
		73,
		74,
		64,
		74,
		87,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		164,
		144,
		-1,
		-1,
		116,
		114,
		103,
		-1,
		93,
		66,
		71,
		91,
		93,
		82,
		76,
		70,
		77,
		76,
		84,
		92,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		150,
		-1,
		-1,
		111,
		104,
		92,
		80,
		70,
		80,
		84,
		88,
		80,
		73,
		68,
		79,
		71,
		75,
		92,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		145,
		129,
		110,
		-1,
		80,
		93,
		124,
		92,
		97,
		92,
		74,
		85,
		74,
		77,
		91,
		86,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		161,
		163,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		117,
		113,
		-1,
		-1,
		81,
		106,
		95,
		103,
		98,
		78,
		84,
		87,
		76,
		80,
		92,
		-1,
		-1,
		158,
		159,
		164,
		-1,
		146,
		-1,
		164,
		-1,
		131,
		137,
		125,
		-1,
		-1,
		-1,
		119,
		82,
		103,
		113,
		107,
		105,
		96,
		82,
		89,
		87,
		83,
		94,
		-1,
		-1,
		-1,
		164,
		138,
		171,
		162,
		145,
		125,
		117,
		136,
		-1,
		106,
		-1,
		81,
		83,
		109,
		112,
		118,
		112,
		85,
		100,
		90,
		81,
		90,
		170,
		-1,
		140,
		173,
		137,
		131,
		107,
		111,
		127,
		-1,
		103,
		85,
		-1,
		113,
		103,
		134,
		119,
		100,
		87,
		94,
		94,
		87,
		-1,
		-1,
		-1,
		142,
		141,
		133,
		127,
		127,
		112,
		103,
		-1,
		115,
		97,
		76,
		93,
		93,
		84,
		92,
		124,
		120,
		107,
		107,
		99,
		-1,
		243,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		136,
		131,
		104,
		92,
		98,
		94,
		80,
		86,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		100,
		135,
		-1,
		238,
		-1,
		172,
		-1,
		-1,
		154,
		134,
		126,
		115,
		104,
		102,
		93,
		84,
		106,
		122,
		106,
		104,
		107,
		108,
		-1,
		227,
		226,
		-1,
		173,
		165,
		151,
		-1,
		144,
		-1,
		150,
		111,
		-1,
		113,
		93,
		-1,
		115,
		111,
		-1,
		-1,
		214,
		189,
		-1,
		-1,
		-1,
		174,
		154,
		145,
		129,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		199,
		198,
		-1,
		167,
		170,
		-1,
		160,
		151,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		208,
		189,
		183,
		182,
		180,
		175,
		172,
		158,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		180,
		172,
		165,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		191,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		213,
		214,
		237,
		201,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		216,
		214,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		163,
		152,
		163,
		171,
		144,
		151,
		-1,
		170,
		174,
		140,
		134,
		173,
		142,
		148,
		159,
		-1,
		-1,
		-1,
		163,
		162,
		130,
		128,
		137,
		142,
		149,
		-1,
		148,
		-1,
		184,
		163,
		174,
		179,
		123,
		120,
		140,
		159,
		141,
		133,
		199,
		153,
		124,
		118,
		136,
		126,
		135,
		127,
		-1,
		124,
		114,
		136,
		115,
		126,
		118,
		-1,
		-1,
		118,
		119,
		125,
		111,
		117,
		113,
		-1,
		123,
		107,
		-1,
		-1,
		108,
		109,
		93,
		96,
		104,
		102,
		115,
		107,
		102,
		-1,
		-1,
		99,
		95,
		102,
		89,
		85,
		102,
		115,
		97,
		111,
		110,
		-1,
		105,
		123,
		128,
		96,
		94,
		78,
		76,
		94,
		96,
		102,
		102,
		-1,
		114,
		115,
		110,
		118,
		118,
		94,
		81,
		81,
		91,
		84,
		103,
		91,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		97,
		114,
		106,
		96,
		111,
		104,
		84,
		81,
		79,
		76,
		92,
		90,
		100,
		-1,
		-1,
		205,
		174,
		205,
		163,
		144,
		-1,
		110,
		90,
		96,
		100,
		94,
		87,
		101,
		97,
		-1,
		70,
		69,
		97,
		83,
		94,
		165,
		-1,
		-1,
		163,
		155,
		140,
		143,
		120,
		116,
		105,
		104,
		96,
		82,
		78,
		84,
		87,
		87,
		93,
		64,
		74,
		78,
		76,
		101,
		-1,
		-1,
		134,
		-1,
		-1,
		162,
		145,
		-1,
		128,
		135,
		126,
		132,
		118,
		139,
		115,
		106,
		98,
		92,
		80,
		82,
		79,
		92,
		80,
		61,
		86,
		90,
		71,
		92,
		87,
		-1,
		133,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		121,
		124,
		130,
		154,
		155,
		-1,
		127,
		115,
		116,
		101,
		98,
		85,
		73,
		86,
		71,
		78,
		77,
		65,
		63,
		93,
		68,
		90,
		87,
		104,
		109,
		103,
		112,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		158,
		-1,
		163,
		164,
		139,
		112,
		115,
		102,
		93,
		80,
		69,
		80,
		69,
		66,
		74,
		57,
		72,
		63,
		62,
		80,
		88,
		96,
		100,
		106,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		178,
		164,
		156,
		141,
		139,
		-1,
		111,
		108,
		98,
		76,
		61,
		78,
		70,
		68,
		70,
		52,
		66,
		57,
		75,
		82,
		78,
		82,
		102,
		114,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		181,
		145,
		-1,
		140,
		-1,
		113,
		126,
		-1,
		82,
		78,
		60,
		61,
		56,
		71,
		63,
		48,
		45,
		63,
		66,
		71,
		75,
		91,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		117,
		96,
		93,
		81,
		68,
		53,
		54,
		62,
		74,
		53,
		47,
		44,
		64,
		88,
		66,
		77,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		92,
		71,
		62,
		51,
		49,
		62,
		54,
		62,
		42,
		40,
		59,
		69,
		60,
		68,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		88,
		105,
		88,
		69,
		58,
		50,
		39,
		50,
		58,
		56,
		38,
		47,
		53,
		75,
		56,
		62,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		93,
		-1,
		82,
		78,
		63,
		58,
		55,
		42,
		41,
		55,
		55,
		45,
		40,
		47,
		80,
		80,
		46,
		66,
		69,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		87,
		81,
		78,
		65,
		61,
		46,
		50,
		52,
		55,
		43,
		49,
		50,
		32,
		56,
		-1,
		54,
		48,
		56,
		46,
		34,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		74,
		56,
		58,
		53,
		52,
		51,
		48,
		37,
		50,
		43,
		37,
		31,
		44,
		48,
		47,
		36,
		32,
		29,
		43,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		69,
		67,
		80,
		64,
		63,
		60,
		51,
		59,
		32,
		25,
		36,
		21,
		39,
		43,
		34,
		29,
		28,
		39,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		79,
		70,
		87,
		88,
		66,
		60,
		58,
		49,
		37,
		26,
		29,
		21,
		43,
		38,
		22,
		24,
		33,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		84,
		82,
		77,
		68,
		74,
		69,
		46,
		41,
		31,
		20,
		20,
		15,
		28,
		12,
		16,
		36,
		52,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		85,
		69,
		74,
		-1,
		66,
		-1,
		39,
		36,
		27,
		12,
		9,
		0,
		18,
		27,
		42,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		101,
		81,
		75,
		74,
		61,
		53,
		47,
		25,
		18,
		15,
		12,
		17,
		40,
		34,
		44,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		108,
		96,
		86,
		76,
		79,
		69,
		44,
		37,
		23,
		25,
		23,
		21,
		26,
		47,
		48,
		59,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		97,
		-1,
		-1,
		80,
		71,
		61,
		40,
		27,
		47,
		50,
		36,
		20,
		35,
		47,
		51,
		60,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		148,
		93,
		82,
		77,
		81,
		79,
		-1,
		53,
		51,
		31,
		45,
		52,
		38,
		33,
		27,
		30,
		48,
		62,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		105,
		99,
		70,
		63,
		67,
		-1,
		55,
		47,
		33,
		50,
		51,
		48,
		39,
		31,
		36,
		33,
		46,
		60,
		64,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		123,
		138,
		109,
		86,
		59,
		54,
		47,
		41,
		41,
		57,
		59,
		70,
		38,
		34,
		35,
		39,
		38,
		55,
		65,
		-1,
		-1,
		143,
		157,
		149,
		131,
		135,
		136,
		-1,
		-1,
		63,
		54,
		45,
		48,
		51,
		54,
		44,
		41,
		46,
		51,
		39,
		48,
		66,
		70,
		-1,
		-1,
		-1,
		163,
		-1,
		175,
		-1,
		-1,
		150,
		134,
		81,
		63,
		59,
		57,
		50,
		59,
		54,
		49,
		59,
		69,
		61,
		41,
		54,
		76,
		66,
		102,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		96,
		93,
		-1,
		63,
		88,
		60,
		67,
		59,
		67,
		67,
		65,
		44,
		51,
		67,
		66,
		61,
		94,
		88,
		94,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		112,
		109,
		85,
		69,
		73,
		66,
		61,
		73,
		53,
		40,
		44,
		48,
		54,
		59,
		64,
		70,
		85,
		100,
		-1,
		170,
		234,
		227,
		195,
		203,
		234,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		85,
		82,
		87,
		76,
		73,
		83,
		78,
		69,
		54,
		60,
		47,
		46,
		64,
		68,
		77,
		84,
		74,
		87,
		91,
		-1,
		184,
		210,
		189,
		192,
		216,
		230,
		-1,
		132,
		-1,
		-1,
		144,
		116,
		100,
		90,
		84,
		134,
		90,
		85,
		77,
		75,
		66,
		57,
		64,
		55,
		55,
		58,
		73,
		78,
		70,
		84,
		84,
		85,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		127,
		-1,
		102,
		106,
		98,
		101,
		91,
		78,
		70,
		62,
		78,
		53,
		63,
		59,
		60,
		69,
		80,
		92,
		91,
		92,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		144,
		183,
		190,
		-1,
		169,
		-1,
		-1,
		-1,
		116,
		111,
		103,
		111,
		90,
		90,
		64,
		68,
		58,
		65,
		75,
		77,
		69,
		73,
		86,
		97,
		100,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		159,
		150,
		177,
		197,
		186,
		181,
		168,
		-1,
		-1,
		139,
		121,
		-1,
		-1,
		97,
		85,
		68,
		69,
		65,
		68,
		83,
		86,
		76,
		74,
		68,
		100,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		178,
		173,
		177,
		193,
		218,
		-1,
		157,
		-1,
		-1,
		142,
		-1,
		-1,
		127,
		90,
		79,
		70,
		76,
		73,
		84,
		94,
		82,
		83,
		73,
		83,
		96,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		149,
		147,
		153,
		160,
		177,
		207,
		-1,
		-1,
		173,
		153,
		-1,
		-1,
		125,
		123,
		112,
		-1,
		102,
		75,
		80,
		100,
		102,
		91,
		85,
		79,
		86,
		85,
		93,
		101,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		163,
		159,
		-1,
		-1,
		120,
		113,
		101,
		89,
		79,
		89,
		93,
		97,
		89,
		82,
		77,
		88,
		80,
		84,
		101,
		-1,
		220,
		-1,
		172,
		148,
		162,
		177,
		185,
		-1,
		-1,
		-1,
		180,
		166,
		159,
		147,
		145,
		-1,
		154,
		138,
		119,
		-1,
		89,
		102,
		133,
		101,
		106,
		101,
		83,
		94,
		83,
		86,
		100,
		95,
		-1,
		-1,
		160,
		163,
		-1,
		-1,
		170,
		172,
		-1,
		171,
		160,
		145,
		137,
		-1,
		-1,
		126,
		122,
		-1,
		-1,
		90,
		115,
		104,
		112,
		107,
		87,
		93,
		96,
		85,
		89,
		101,
		-1,
		-1,
		167,
		168,
		173,
		-1,
		155,
		-1,
		173,
		-1,
		140,
		146,
		134,
		-1,
		-1,
		-1,
		128,
		91,
		112,
		122,
		116,
		114,
		105,
		91,
		98,
		96,
		92,
		103,
		-1,
		-1,
		-1,
		173,
		147,
		180,
		171,
		154,
		134,
		126,
		145,
		-1,
		115,
		-1,
		90,
		92,
		118,
		121,
		127,
		121,
		94,
		109,
		99,
		90,
		99,
		179,
		-1,
		149,
		182,
		146,
		140,
		116,
		120,
		136,
		-1,
		112,
		94,
		-1,
		122,
		112,
		143,
		128,
		109,
		96,
		103,
		103,
		96,
		-1,
		-1,
		-1,
		151,
		150,
		142,
		136,
		136,
		121,
		112,
		-1,
		124,
		106,
		85,
		102,
		102,
		93,
		101,
		133,
		129,
		116,
		116,
		108,
		-1,
		252,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		145,
		140,
		113,
		101,
		107,
		103,
		89,
		95,
		97,
		105,
		103,
		100,
		112,
		108,
		128,
		109,
		144,
		-1,
		247,
		-1,
		181,
		-1,
		-1,
		163,
		143,
		135,
		124,
		113,
		111,
		102,
		93,
		115,
		131,
		115,
		113,
		116,
		117,
		-1,
		236,
		235,
		-1,
		182,
		174,
		160,
		-1,
		153,
		-1,
		159,
		120,
		-1,
		122,
		102,
		-1,
		124,
		120,
		-1,
		-1,
		223,
		198,
		-1,
		-1,
		-1,
		183,
		163,
		154,
		138,
		-1,
		113,
		113,
		-1,
		-1,
		-1,
		208,
		207,
		-1,
		176,
		179,
		-1,
		169,
		160,
		168,
		115,
		119,
		-1,
		-1,
		-1,
		217,
		198,
		192,
		191,
		189,
		184,
		181,
		167,
		151,
		129,
		118,
		139,
		-1,
		-1,
		-1,
		189,
		181,
		174,
		-1,
		-1,
		176,
		159,
		140,
		138,
		-1,
		-1,
		-1,
		211,
		192,
		-1,
		-1,
		166,
		-1,
		-1,
		172,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		200,
		-1,
		-1,
		-1,
		162,
		158,
		159,
		-1,
		-1,
		-1,
		-1,
		222,
		223,
		246,
		210,
		-1,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		225,
		223,
		-1,
		-1,
		-1,
		182,
		166,
		-1,
		152,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		187,
		-1,
		187,
		162,
		169,
		-1,
		-1,
		-1,
		-1,
		200,
		192,
		200,
		-1,
		172,
		174,
		-1,
		222,
		-1,
		-1,
		215,
		206,
		-1,
		-1,
		177,
		184,
		206,
		209,
		245,
		-1,
		196
	],
	[
		-1,
		164,
		153,
		164,
		172,
		145,
		152,
		-1,
		171,
		175,
		141,
		135,
		174,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		164,
		163,
		131,
		129,
		138,
		143,
		150,
		-1,
		149,
		-1,
		185,
		164,
		175,
		180,
		124,
		121,
		141,
		160,
		142,
		134,
		200,
		154,
		125,
		119,
		137,
		127,
		136,
		128,
		-1,
		125,
		115,
		137,
		116,
		127,
		119,
		-1,
		-1,
		119,
		120,
		126,
		112,
		118,
		114,
		-1,
		124,
		108,
		-1,
		-1,
		109,
		110,
		94,
		97,
		105,
		103,
		116,
		108,
		103,
		-1,
		-1,
		100,
		96,
		103,
		90,
		86,
		103,
		116,
		98,
		112,
		111,
		-1,
		106,
		124,
		129,
		97,
		95,
		79,
		77,
		95,
		97,
		103,
		103,
		-1,
		115,
		116,
		111,
		119,
		119,
		95,
		82,
		82,
		92,
		85,
		104,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		115,
		98,
		115,
		107,
		97,
		112,
		105,
		85,
		82,
		80,
		77,
		93,
		91,
		101,
		-1,
		-1,
		206,
		175,
		206,
		164,
		145,
		-1,
		111,
		91,
		97,
		101,
		95,
		88,
		102,
		98,
		-1,
		71,
		70,
		98,
		84,
		95,
		166,
		-1,
		-1,
		164,
		156,
		141,
		144,
		121,
		117,
		106,
		105,
		97,
		83,
		79,
		85,
		88,
		88,
		94,
		65,
		75,
		79,
		77,
		102,
		-1,
		-1,
		121,
		-1,
		-1,
		163,
		146,
		-1,
		129,
		136,
		127,
		133,
		119,
		140,
		116,
		107,
		99,
		93,
		81,
		83,
		80,
		93,
		81,
		62,
		87,
		91,
		72,
		93,
		88,
		-1,
		120,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		122,
		125,
		131,
		155,
		156,
		-1,
		128,
		116,
		117,
		102,
		99,
		86,
		74,
		87,
		72,
		79,
		78,
		66,
		64,
		94,
		69,
		91,
		86,
		91,
		96,
		90,
		99,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		159,
		-1,
		164,
		165,
		140,
		113,
		116,
		103,
		94,
		81,
		70,
		81,
		70,
		67,
		75,
		58,
		73,
		64,
		63,
		75,
		75,
		83,
		87,
		93,
		-1,
		221,
		-1,
		163,
		147,
		149,
		121,
		142,
		-1,
		179,
		165,
		157,
		142,
		140,
		-1,
		112,
		109,
		99,
		77,
		62,
		79,
		71,
		69,
		71,
		53,
		67,
		58,
		76,
		79,
		65,
		69,
		89,
		101,
		181,
		171,
		-1,
		153,
		158,
		117,
		125,
		144,
		182,
		146,
		-1,
		141,
		-1,
		114,
		127,
		-1,
		83,
		79,
		61,
		62,
		57,
		72,
		64,
		49,
		46,
		64,
		67,
		58,
		62,
		78,
		-1,
		-1,
		166,
		170,
		159,
		110,
		129,
		153,
		190,
		139,
		128,
		127,
		-1,
		118,
		97,
		94,
		82,
		69,
		54,
		55,
		63,
		75,
		54,
		48,
		45,
		65,
		75,
		53,
		64,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		136,
		107,
		131,
		173,
		157,
		150,
		138,
		103,
		103,
		97,
		-1,
		93,
		72,
		63,
		52,
		50,
		63,
		55,
		63,
		43,
		41,
		60,
		56,
		47,
		55,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		102,
		125,
		162,
		136,
		122,
		127,
		102,
		95,
		89,
		106,
		89,
		70,
		59,
		51,
		40,
		51,
		59,
		57,
		39,
		48,
		54,
		62,
		43,
		49,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		116,
		123,
		155,
		127,
		140,
		-1,
		94,
		-1,
		83,
		79,
		64,
		59,
		56,
		43,
		42,
		56,
		56,
		46,
		41,
		48,
		67,
		67,
		33,
		53,
		56,
		-1,
		-1,
		-1,
		166,
		161,
		136,
		113,
		97,
		133,
		-1,
		110,
		111,
		-1,
		88,
		82,
		79,
		66,
		62,
		47,
		51,
		53,
		56,
		44,
		50,
		51,
		33,
		57,
		-1,
		41,
		35,
		43,
		33,
		21,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		92,
		144,
		-1,
		-1,
		95,
		88,
		-1,
		75,
		57,
		59,
		54,
		53,
		52,
		49,
		38,
		51,
		44,
		38,
		32,
		45,
		49,
		34,
		23,
		19,
		16,
		30,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		112,
		-1,
		104,
		96,
		86,
		80,
		74,
		70,
		68,
		81,
		65,
		64,
		61,
		52,
		60,
		33,
		26,
		37,
		22,
		40,
		29,
		21,
		15,
		14,
		26,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		125,
		-1,
		89,
		103,
		119,
		-1,
		112,
		91,
		106,
		84,
		80,
		71,
		88,
		89,
		67,
		61,
		59,
		50,
		38,
		27,
		30,
		22,
		33,
		25,
		9,
		10,
		19,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		86,
		74,
		106,
		-1,
		-1,
		148,
		-1,
		82,
		99,
		85,
		83,
		78,
		69,
		75,
		70,
		47,
		42,
		32,
		21,
		21,
		16,
		19,
		5,
		3,
		22,
		38,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		123,
		-1,
		126,
		116,
		100,
		85,
		118,
		-1,
		86,
		70,
		75,
		-1,
		67,
		-1,
		40,
		37,
		28,
		13,
		10,
		15,
		0,
		13,
		28,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		113,
		107,
		107,
		91,
		94,
		102,
		82,
		76,
		75,
		62,
		54,
		48,
		26,
		19,
		16,
		13,
		26,
		33,
		20,
		30,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		175,
		130,
		116,
		-1,
		100,
		109,
		97,
		87,
		77,
		80,
		70,
		45,
		38,
		24,
		26,
		24,
		22,
		27,
		43,
		35,
		45,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		122,
		138,
		130,
		101,
		98,
		-1,
		-1,
		81,
		72,
		62,
		41,
		28,
		48,
		51,
		37,
		21,
		36,
		48,
		37,
		46,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		149,
		94,
		83,
		78,
		82,
		80,
		-1,
		54,
		52,
		32,
		46,
		53,
		39,
		34,
		28,
		31,
		49,
		48,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		106,
		100,
		71,
		64,
		68,
		-1,
		56,
		48,
		34,
		51,
		52,
		49,
		40,
		32,
		37,
		34,
		47,
		60,
		50,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		124,
		139,
		110,
		87,
		60,
		55,
		48,
		42,
		42,
		58,
		60,
		71,
		39,
		35,
		36,
		40,
		39,
		56,
		65,
		-1,
		-1,
		144,
		158,
		150,
		132,
		136,
		137,
		-1,
		-1,
		64,
		55,
		46,
		49,
		52,
		55,
		45,
		42,
		47,
		52,
		40,
		49,
		67,
		68,
		-1,
		-1,
		-1,
		164,
		-1,
		176,
		-1,
		-1,
		151,
		135,
		82,
		64,
		60,
		58,
		51,
		60,
		55,
		50,
		60,
		70,
		62,
		42,
		55,
		77,
		67,
		101,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		153,
		145,
		140,
		146,
		148,
		139,
		97,
		94,
		-1,
		64,
		89,
		61,
		68,
		60,
		68,
		68,
		66,
		45,
		52,
		68,
		67,
		62,
		93,
		88,
		95,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		146,
		142,
		132,
		122,
		125,
		-1,
		-1,
		113,
		110,
		86,
		70,
		74,
		67,
		62,
		74,
		54,
		41,
		45,
		49,
		55,
		60,
		65,
		71,
		86,
		101,
		-1,
		171,
		235,
		228,
		196,
		204,
		235,
		-1,
		136,
		128,
		139,
		114,
		116,
		-1,
		-1,
		86,
		83,
		88,
		77,
		74,
		84,
		79,
		70,
		55,
		61,
		48,
		47,
		65,
		69,
		78,
		85,
		75,
		88,
		92,
		-1,
		185,
		211,
		190,
		193,
		217,
		231,
		-1,
		133,
		-1,
		-1,
		145,
		117,
		101,
		91,
		85,
		135,
		91,
		86,
		78,
		76,
		67,
		58,
		65,
		56,
		56,
		59,
		74,
		79,
		71,
		85,
		85,
		86,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		161,
		-1,
		128,
		-1,
		103,
		107,
		99,
		102,
		92,
		79,
		71,
		63,
		79,
		54,
		64,
		60,
		61,
		70,
		81,
		93,
		92,
		93,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		145,
		184,
		191,
		-1,
		170,
		-1,
		-1,
		-1,
		117,
		112,
		104,
		112,
		91,
		91,
		65,
		69,
		59,
		66,
		76,
		78,
		70,
		74,
		87,
		98,
		101,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		160,
		151,
		178,
		198,
		187,
		182,
		169,
		-1,
		-1,
		140,
		122,
		-1,
		-1,
		98,
		86,
		69,
		70,
		66,
		69,
		84,
		87,
		77,
		75,
		69,
		101,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		163,
		179,
		174,
		178,
		194,
		219,
		-1,
		158,
		-1,
		-1,
		143,
		-1,
		-1,
		128,
		91,
		80,
		71,
		77,
		74,
		85,
		95,
		83,
		84,
		74,
		84,
		97,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		150,
		148,
		154,
		161,
		178,
		208,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		126,
		124,
		113,
		-1,
		103,
		76,
		81,
		101,
		103,
		92,
		86,
		80,
		87,
		86,
		94,
		102,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		121,
		114,
		102,
		90,
		80,
		90,
		94,
		98,
		90,
		83,
		78,
		89,
		81,
		85,
		102,
		-1,
		221,
		-1,
		173,
		149,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		155,
		139,
		120,
		-1,
		90,
		103,
		134,
		102,
		107,
		102,
		84,
		95,
		84,
		87,
		101,
		96,
		-1,
		-1,
		161,
		164,
		-1,
		-1,
		171,
		173,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		127,
		123,
		-1,
		-1,
		91,
		116,
		105,
		113,
		108,
		88,
		94,
		97,
		86,
		90,
		102,
		-1,
		-1,
		168,
		169,
		174,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		129,
		92,
		113,
		123,
		117,
		115,
		106,
		92,
		99,
		97,
		93,
		104,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		93,
		119,
		122,
		128,
		122,
		95,
		110,
		100,
		91,
		100,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		123,
		113,
		144,
		129,
		110,
		97,
		104,
		104,
		97,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		134,
		130,
		117,
		117,
		109,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		110,
		145,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		117,
		118,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		121,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		179,
		168,
		179,
		187,
		160,
		167,
		-1,
		186,
		190,
		156,
		150,
		189,
		158,
		164,
		175,
		-1,
		-1,
		-1,
		179,
		178,
		146,
		144,
		153,
		158,
		165,
		-1,
		164,
		-1,
		200,
		179,
		190,
		195,
		139,
		136,
		156,
		175,
		157,
		149,
		215,
		169,
		140,
		134,
		152,
		142,
		151,
		143,
		-1,
		140,
		130,
		152,
		131,
		142,
		134,
		-1,
		-1,
		134,
		135,
		141,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		124,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		121,
		139,
		144,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		118,
		-1,
		130,
		131,
		126,
		134,
		134,
		110,
		97,
		97,
		107,
		100,
		119,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		113,
		130,
		122,
		112,
		127,
		120,
		100,
		97,
		95,
		92,
		108,
		106,
		116,
		-1,
		-1,
		221,
		190,
		221,
		179,
		160,
		-1,
		126,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		86,
		85,
		113,
		99,
		110,
		181,
		-1,
		-1,
		179,
		171,
		156,
		159,
		136,
		132,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		80,
		90,
		94,
		92,
		117,
		-1,
		-1,
		136,
		-1,
		-1,
		178,
		161,
		-1,
		144,
		151,
		142,
		148,
		134,
		155,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		77,
		102,
		106,
		87,
		108,
		103,
		-1,
		135,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		137,
		140,
		146,
		170,
		171,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		81,
		79,
		109,
		84,
		106,
		101,
		106,
		111,
		105,
		114,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		174,
		-1,
		179,
		180,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		73,
		88,
		79,
		78,
		90,
		90,
		98,
		102,
		108,
		-1,
		236,
		-1,
		178,
		162,
		164,
		136,
		157,
		-1,
		194,
		180,
		172,
		157,
		155,
		-1,
		127,
		124,
		114,
		92,
		77,
		94,
		86,
		84,
		86,
		68,
		82,
		73,
		91,
		94,
		80,
		84,
		104,
		116,
		196,
		186,
		-1,
		168,
		173,
		132,
		140,
		159,
		197,
		161,
		-1,
		156,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		79,
		64,
		61,
		79,
		82,
		73,
		77,
		93,
		-1,
		-1,
		181,
		185,
		174,
		125,
		144,
		168,
		205,
		154,
		143,
		142,
		-1,
		133,
		112,
		109,
		97,
		84,
		69,
		70,
		78,
		90,
		69,
		63,
		60,
		80,
		90,
		68,
		79,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		151,
		122,
		146,
		188,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		108,
		87,
		78,
		67,
		65,
		78,
		70,
		78,
		58,
		56,
		75,
		71,
		62,
		70,
		-1,
		-1,
		-1,
		181,
		170,
		171,
		117,
		140,
		177,
		151,
		137,
		142,
		117,
		110,
		104,
		121,
		104,
		85,
		74,
		66,
		55,
		66,
		74,
		72,
		54,
		63,
		69,
		77,
		58,
		64,
		-1,
		-1,
		188,
		178,
		162,
		164,
		161,
		131,
		138,
		170,
		142,
		155,
		-1,
		109,
		-1,
		98,
		94,
		79,
		74,
		71,
		58,
		57,
		71,
		71,
		61,
		56,
		63,
		82,
		82,
		48,
		68,
		71,
		-1,
		-1,
		-1,
		181,
		176,
		151,
		128,
		112,
		148,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		81,
		77,
		62,
		66,
		68,
		71,
		59,
		65,
		66,
		48,
		72,
		-1,
		56,
		50,
		58,
		48,
		36,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		74,
		69,
		68,
		67,
		64,
		53,
		66,
		59,
		53,
		47,
		60,
		64,
		49,
		38,
		34,
		31,
		45,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		96,
		80,
		79,
		76,
		67,
		75,
		48,
		41,
		52,
		37,
		55,
		44,
		36,
		30,
		29,
		41,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		95,
		86,
		103,
		104,
		82,
		76,
		74,
		65,
		53,
		42,
		45,
		37,
		48,
		40,
		24,
		25,
		34,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		100,
		98,
		93,
		84,
		90,
		85,
		62,
		57,
		47,
		36,
		36,
		31,
		30,
		20,
		18,
		32,
		48,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		101,
		85,
		90,
		-1,
		82,
		-1,
		55,
		52,
		43,
		28,
		25,
		28,
		15,
		0,
		26,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		117,
		97,
		91,
		90,
		77,
		69,
		63,
		41,
		34,
		31,
		28,
		41,
		27,
		8,
		28,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		124,
		112,
		102,
		92,
		95,
		85,
		60,
		53,
		39,
		41,
		39,
		37,
		39,
		42,
		34,
		33,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		113,
		-1,
		-1,
		96,
		87,
		77,
		56,
		43,
		63,
		66,
		52,
		36,
		40,
		48,
		35,
		44,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		164,
		109,
		98,
		93,
		97,
		95,
		-1,
		69,
		67,
		47,
		61,
		68,
		54,
		49,
		43,
		46,
		53,
		46,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		86,
		79,
		83,
		-1,
		71,
		63,
		49,
		66,
		67,
		64,
		55,
		47,
		52,
		49,
		62,
		58,
		48,
		176,
		-1,
		159,
		-1,
		-1,
		-1,
		139,
		154,
		125,
		102,
		75,
		70,
		63,
		57,
		57,
		73,
		75,
		86,
		54,
		50,
		51,
		55,
		54,
		62,
		63,
		-1,
		-1,
		159,
		173,
		165,
		147,
		151,
		152,
		-1,
		-1,
		79,
		70,
		61,
		64,
		67,
		70,
		60,
		57,
		62,
		67,
		55,
		64,
		81,
		66,
		-1,
		-1,
		-1,
		179,
		-1,
		191,
		-1,
		-1,
		166,
		150,
		97,
		79,
		75,
		73,
		66,
		75,
		70,
		65,
		75,
		85,
		77,
		57,
		70,
		92,
		74,
		100,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		112,
		109,
		-1,
		79,
		104,
		76,
		83,
		75,
		83,
		83,
		81,
		60,
		67,
		83,
		82,
		77,
		92,
		87,
		96,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		128,
		125,
		101,
		85,
		89,
		82,
		77,
		89,
		69,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		94,
		102,
		-1,
		186,
		250,
		243,
		211,
		219,
		250,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		101,
		98,
		103,
		92,
		89,
		99,
		94,
		85,
		70,
		76,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		200,
		226,
		205,
		208,
		232,
		246,
		-1,
		148,
		-1,
		-1,
		160,
		132,
		116,
		106,
		100,
		150,
		106,
		101,
		93,
		91,
		82,
		73,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		176,
		-1,
		143,
		-1,
		118,
		122,
		114,
		117,
		107,
		94,
		86,
		78,
		94,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		160,
		199,
		206,
		-1,
		185,
		-1,
		-1,
		-1,
		132,
		127,
		119,
		127,
		106,
		106,
		80,
		84,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		175,
		166,
		193,
		213,
		202,
		197,
		184,
		-1,
		-1,
		155,
		137,
		-1,
		-1,
		113,
		101,
		84,
		85,
		81,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		194,
		189,
		193,
		209,
		234,
		-1,
		173,
		-1,
		-1,
		158,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		89,
		100,
		110,
		98,
		99,
		89,
		99,
		112,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		223,
		-1,
		-1,
		189,
		169,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		116,
		118,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		179,
		175,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		109,
		113,
		105,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		196,
		182,
		175,
		163,
		161,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		176,
		179,
		-1,
		-1,
		186,
		188,
		-1,
		187,
		176,
		161,
		153,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		183,
		184,
		189,
		-1,
		171,
		-1,
		189,
		-1,
		156,
		162,
		150,
		-1,
		-1,
		-1,
		144,
		107,
		128,
		138,
		132,
		130,
		121,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		189,
		163,
		196,
		187,
		170,
		150,
		142,
		161,
		-1,
		131,
		-1,
		106,
		108,
		134,
		137,
		143,
		137,
		110,
		125,
		115,
		106,
		115,
		195,
		-1,
		165,
		198,
		162,
		156,
		132,
		136,
		152,
		-1,
		128,
		110,
		-1,
		138,
		128,
		159,
		144,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		167,
		166,
		158,
		152,
		152,
		137,
		128,
		-1,
		140,
		122,
		101,
		118,
		118,
		109,
		117,
		149,
		145,
		132,
		132,
		124,
		-1,
		268,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		161,
		156,
		129,
		117,
		123,
		119,
		105,
		111,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		125,
		160,
		-1,
		263,
		-1,
		197,
		-1,
		-1,
		179,
		159,
		151,
		140,
		129,
		127,
		118,
		109,
		131,
		147,
		131,
		129,
		132,
		133,
		-1,
		252,
		251,
		-1,
		198,
		190,
		176,
		-1,
		169,
		-1,
		175,
		136,
		-1,
		138,
		118,
		-1,
		140,
		136,
		-1,
		-1,
		239,
		214,
		-1,
		-1,
		-1,
		199,
		179,
		170,
		154,
		-1,
		129,
		129,
		-1,
		-1,
		-1,
		224,
		223,
		-1,
		192,
		195,
		-1,
		185,
		176,
		184,
		131,
		135,
		-1,
		-1,
		-1,
		233,
		214,
		208,
		207,
		205,
		200,
		197,
		183,
		167,
		145,
		134,
		155,
		-1,
		-1,
		-1,
		205,
		197,
		190,
		-1,
		-1,
		192,
		175,
		156,
		154,
		-1,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		182,
		-1,
		-1,
		188,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		216,
		-1,
		-1,
		-1,
		178,
		174,
		175,
		-1,
		-1,
		-1,
		-1,
		238,
		239,
		262,
		226,
		-1,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		241,
		239,
		-1,
		-1,
		-1,
		198,
		182,
		-1,
		168,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		203,
		-1,
		203,
		178,
		185,
		-1,
		-1,
		-1,
		-1,
		216,
		208,
		216,
		-1,
		188,
		190,
		-1,
		238,
		-1,
		-1,
		231,
		222,
		-1,
		-1,
		193,
		200,
		222,
		225,
		261,
		-1,
		212
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		198,
		202,
		168,
		162,
		201,
		170,
		176,
		187,
		-1,
		-1,
		-1,
		191,
		190,
		158,
		156,
		165,
		170,
		177,
		-1,
		176,
		-1,
		212,
		191,
		202,
		207,
		151,
		148,
		168,
		187,
		169,
		161,
		227,
		181,
		152,
		146,
		164,
		154,
		163,
		155,
		-1,
		152,
		142,
		164,
		143,
		154,
		146,
		-1,
		-1,
		146,
		147,
		153,
		139,
		145,
		141,
		-1,
		151,
		135,
		-1,
		-1,
		136,
		137,
		121,
		124,
		132,
		130,
		143,
		135,
		130,
		-1,
		-1,
		127,
		123,
		130,
		117,
		113,
		130,
		143,
		125,
		139,
		138,
		-1,
		127,
		145,
		154,
		124,
		122,
		106,
		104,
		122,
		124,
		130,
		130,
		-1,
		136,
		137,
		132,
		140,
		145,
		122,
		109,
		109,
		119,
		112,
		131,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		119,
		136,
		128,
		118,
		133,
		126,
		112,
		109,
		107,
		104,
		120,
		118,
		128,
		-1,
		-1,
		229,
		198,
		227,
		185,
		166,
		-1,
		132,
		112,
		118,
		122,
		116,
		109,
		123,
		119,
		-1,
		98,
		97,
		125,
		111,
		122,
		189,
		-1,
		-1,
		187,
		179,
		162,
		165,
		142,
		138,
		127,
		126,
		118,
		104,
		100,
		106,
		109,
		109,
		115,
		92,
		102,
		106,
		104,
		110,
		-1,
		-1,
		124,
		-1,
		-1,
		186,
		169,
		-1,
		152,
		159,
		148,
		154,
		140,
		161,
		137,
		128,
		120,
		114,
		102,
		104,
		101,
		114,
		102,
		89,
		114,
		118,
		99,
		100,
		95,
		-1,
		123,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		145,
		148,
		154,
		178,
		177,
		-1,
		149,
		137,
		138,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		93,
		91,
		121,
		96,
		99,
		89,
		94,
		99,
		93,
		102,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		182,
		-1,
		185,
		186,
		161,
		134,
		137,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		85,
		100,
		91,
		90,
		78,
		78,
		86,
		90,
		96,
		-1,
		244,
		-1,
		186,
		170,
		172,
		144,
		165,
		-1,
		202,
		186,
		178,
		163,
		163,
		-1,
		133,
		130,
		120,
		98,
		83,
		100,
		92,
		90,
		95,
		80,
		94,
		85,
		84,
		82,
		68,
		72,
		92,
		104,
		204,
		194,
		-1,
		176,
		181,
		140,
		148,
		167,
		205,
		169,
		-1,
		164,
		-1,
		135,
		148,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		91,
		76,
		73,
		80,
		75,
		61,
		65,
		81,
		-1,
		-1,
		189,
		193,
		182,
		133,
		152,
		176,
		213,
		162,
		151,
		150,
		-1,
		141,
		118,
		115,
		103,
		90,
		75,
		76,
		84,
		97,
		76,
		75,
		72,
		71,
		78,
		56,
		67,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		159,
		130,
		154,
		196,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		114,
		93,
		84,
		73,
		71,
		84,
		81,
		90,
		70,
		68,
		66,
		59,
		50,
		58,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		125,
		148,
		185,
		159,
		145,
		150,
		125,
		118,
		112,
		127,
		110,
		91,
		80,
		72,
		61,
		77,
		85,
		84,
		66,
		75,
		60,
		65,
		46,
		52,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		101,
		85,
		80,
		77,
		70,
		68,
		77,
		83,
		73,
		68,
		75,
		70,
		70,
		36,
		55,
		58,
		-1,
		-1,
		-1,
		189,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		87,
		83,
		74,
		78,
		75,
		82,
		71,
		77,
		78,
		60,
		84,
		-1,
		44,
		38,
		45,
		35,
		24,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		86,
		81,
		79,
		79,
		76,
		65,
		78,
		71,
		65,
		59,
		72,
		59,
		43,
		26,
		22,
		19,
		33,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		107,
		91,
		91,
		88,
		79,
		87,
		60,
		53,
		64,
		49,
		67,
		40,
		30,
		20,
		12,
		29,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		98,
		114,
		115,
		93,
		88,
		86,
		77,
		65,
		54,
		57,
		49,
		42,
		34,
		18,
		15,
		8,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		112,
		110,
		104,
		95,
		101,
		97,
		74,
		69,
		59,
		48,
		48,
		43,
		40,
		26,
		24,
		6,
		22,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		112,
		96,
		101,
		-1,
		94,
		-1,
		67,
		64,
		55,
		40,
		37,
		36,
		27,
		22,
		0,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		128,
		108,
		102,
		101,
		89,
		81,
		75,
		53,
		46,
		43,
		40,
		53,
		47,
		14,
		3,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		136,
		124,
		114,
		104,
		107,
		97,
		72,
		65,
		51,
		53,
		51,
		44,
		32,
		17,
		9,
		17,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		153,
		124,
		125,
		-1,
		-1,
		108,
		99,
		89,
		68,
		55,
		71,
		66,
		53,
		37,
		33,
		23,
		10,
		19,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		176,
		121,
		110,
		105,
		109,
		107,
		-1,
		81,
		79,
		59,
		73,
		80,
		55,
		43,
		37,
		28,
		28,
		21,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		133,
		127,
		98,
		91,
		95,
		-1,
		83,
		75,
		61,
		78,
		61,
		58,
		49,
		39,
		39,
		25,
		38,
		33,
		23,
		184,
		-1,
		167,
		-1,
		-1,
		-1,
		151,
		166,
		137,
		114,
		87,
		82,
		75,
		69,
		69,
		83,
		69,
		80,
		46,
		42,
		38,
		31,
		30,
		37,
		38,
		-1,
		-1,
		167,
		172,
		177,
		159,
		163,
		164,
		-1,
		-1,
		91,
		82,
		73,
		73,
		79,
		82,
		52,
		49,
		54,
		48,
		41,
		40,
		56,
		41,
		-1,
		-1,
		-1,
		187,
		-1,
		190,
		-1,
		-1,
		178,
		162,
		109,
		91,
		87,
		85,
		78,
		76,
		64,
		57,
		67,
		66,
		58,
		38,
		56,
		68,
		49,
		75,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		167,
		159,
		154,
		160,
		162,
		153,
		124,
		121,
		-1,
		91,
		105,
		70,
		77,
		69,
		73,
		70,
		62,
		43,
		57,
		73,
		61,
		60,
		67,
		62,
		71,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		160,
		156,
		146,
		136,
		139,
		-1,
		-1,
		133,
		130,
		102,
		79,
		82,
		75,
		70,
		80,
		60,
		47,
		50,
		54,
		60,
		58,
		63,
		69,
		69,
		77,
		-1,
		194,
		244,
		237,
		205,
		213,
		244,
		-1,
		150,
		142,
		153,
		128,
		130,
		-1,
		-1,
		106,
		97,
		98,
		86,
		83,
		90,
		85,
		76,
		61,
		67,
		54,
		52,
		70,
		74,
		76,
		83,
		72,
		85,
		89,
		-1,
		200,
		220,
		199,
		202,
		226,
		240,
		-1,
		147,
		-1,
		-1,
		159,
		131,
		115,
		105,
		102,
		145,
		100,
		95,
		84,
		82,
		73,
		64,
		71,
		62,
		61,
		64,
		80,
		85,
		77,
		82,
		82,
		83,
		-1,
		189,
		200,
		193,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		175,
		-1,
		142,
		-1,
		125,
		129,
		108,
		111,
		98,
		85,
		77,
		69,
		85,
		60,
		69,
		65,
		67,
		76,
		87,
		99,
		89,
		90,
		214,
		170,
		173,
		184,
		195,
		210,
		214,
		-1,
		159,
		198,
		197,
		-1,
		181,
		-1,
		-1,
		-1,
		139,
		121,
		113,
		118,
		97,
		97,
		71,
		75,
		65,
		72,
		81,
		83,
		76,
		80,
		93,
		99,
		98,
		210,
		201,
		214,
		159,
		159,
		180,
		189,
		210,
		174,
		165,
		192,
		204,
		193,
		188,
		175,
		-1,
		-1,
		162,
		131,
		-1,
		-1,
		104,
		92,
		75,
		76,
		72,
		75,
		90,
		92,
		83,
		81,
		75,
		104,
		-1,
		203,
		202,
		191,
		188,
		164,
		155,
		150,
		177,
		-1,
		-1,
		172,
		193,
		183,
		187,
		203,
		228,
		-1,
		164,
		-1,
		-1,
		149,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		80,
		91,
		101,
		89,
		90,
		80,
		90,
		103,
		187,
		184,
		172,
		170,
		193,
		158,
		146,
		-1,
		159,
		157,
		163,
		170,
		187,
		217,
		-1,
		-1,
		180,
		160,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		107,
		109,
		98,
		92,
		86,
		93,
		92,
		100,
		108,
		196,
		210,
		199,
		195,
		194,
		202,
		151,
		144,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		166,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		100,
		104,
		96,
		89,
		84,
		95,
		87,
		91,
		108,
		-1,
		230,
		-1,
		182,
		158,
		172,
		187,
		195,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		90,
		101,
		90,
		93,
		107,
		102,
		-1,
		-1,
		170,
		173,
		-1,
		-1,
		177,
		179,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		94,
		100,
		103,
		92,
		96,
		108,
		-1,
		-1,
		177,
		178,
		183,
		-1,
		162,
		-1,
		180,
		-1,
		147,
		153,
		141,
		-1,
		-1,
		-1,
		135,
		98,
		119,
		129,
		123,
		121,
		112,
		98,
		105,
		103,
		99,
		110,
		-1,
		-1,
		-1,
		180,
		154,
		187,
		178,
		161,
		141,
		133,
		152,
		-1,
		122,
		-1,
		97,
		99,
		125,
		128,
		134,
		128,
		101,
		116,
		106,
		97,
		106,
		186,
		-1,
		156,
		189,
		153,
		147,
		123,
		127,
		143,
		-1,
		119,
		101,
		-1,
		129,
		119,
		150,
		135,
		116,
		103,
		110,
		110,
		103,
		-1,
		-1,
		-1,
		158,
		157,
		149,
		143,
		143,
		128,
		119,
		-1,
		131,
		113,
		92,
		109,
		109,
		100,
		108,
		140,
		136,
		123,
		123,
		115,
		-1,
		259,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		152,
		147,
		120,
		108,
		114,
		110,
		96,
		102,
		104,
		112,
		110,
		107,
		119,
		115,
		135,
		116,
		151,
		-1,
		254,
		-1,
		188,
		-1,
		-1,
		170,
		150,
		142,
		131,
		120,
		118,
		109,
		100,
		122,
		138,
		122,
		120,
		123,
		124,
		-1,
		243,
		242,
		-1,
		189,
		181,
		167,
		-1,
		160,
		-1,
		166,
		127,
		-1,
		129,
		109,
		-1,
		131,
		127,
		-1,
		-1,
		230,
		205,
		-1,
		-1,
		-1,
		190,
		170,
		161,
		145,
		-1,
		120,
		120,
		-1,
		-1,
		-1,
		215,
		214,
		-1,
		183,
		186,
		-1,
		176,
		167,
		175,
		122,
		126,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		198,
		196,
		191,
		188,
		174,
		158,
		136,
		125,
		146,
		-1,
		-1,
		-1,
		196,
		188,
		181,
		-1,
		-1,
		183,
		166,
		147,
		145,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		173,
		-1,
		-1,
		179,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		207,
		-1,
		-1,
		-1,
		169,
		165,
		166,
		-1,
		-1,
		-1,
		-1,
		229,
		230,
		253,
		217,
		-1,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		232,
		230,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		194,
		-1,
		194,
		169,
		176,
		-1,
		-1,
		-1,
		-1,
		207,
		199,
		207,
		-1,
		179,
		181,
		-1,
		229,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		184,
		191,
		213,
		216,
		252,
		-1,
		203
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		202,
		191,
		202,
		210,
		183,
		190,
		-1,
		211,
		213,
		179,
		173,
		212,
		183,
		189,
		200,
		-1,
		-1,
		-1,
		202,
		201,
		171,
		169,
		178,
		183,
		190,
		-1,
		213,
		-1,
		223,
		202,
		213,
		218,
		164,
		161,
		181,
		200,
		206,
		198,
		238,
		194,
		165,
		159,
		177,
		182,
		200,
		192,
		-1,
		165,
		155,
		177,
		181,
		193,
		176,
		-1,
		-1,
		159,
		160,
		166,
		178,
		183,
		188,
		-1,
		211,
		195,
		-1,
		-1,
		149,
		162,
		158,
		161,
		169,
		185,
		203,
		195,
		190,
		-1,
		-1,
		150,
		154,
		167,
		168,
		166,
		190,
		203,
		185,
		199,
		198,
		-1,
		138,
		156,
		165,
		174,
		180,
		166,
		164,
		182,
		184,
		190,
		193,
		-1,
		130,
		132,
		161,
		167,
		179,
		182,
		169,
		169,
		179,
		172,
		191,
		182,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		127,
		135,
		161,
		160,
		156,
		174,
		179,
		172,
		169,
		167,
		164,
		180,
		181,
		191,
		-1,
		-1,
		183,
		152,
		187,
		144,
		129,
		-1,
		123,
		142,
		148,
		152,
		157,
		162,
		176,
		172,
		-1,
		158,
		157,
		188,
		174,
		185,
		143,
		-1,
		-1,
		141,
		133,
		118,
		121,
		118,
		118,
		148,
		147,
		152,
		154,
		153,
		159,
		162,
		162,
		168,
		152,
		162,
		166,
		177,
		192,
		-1,
		-1,
		247,
		-1,
		-1,
		140,
		123,
		-1,
		106,
		113,
		113,
		130,
		120,
		141,
		156,
		160,
		168,
		167,
		155,
		157,
		154,
		167,
		155,
		149,
		174,
		178,
		172,
		193,
		188,
		-1,
		246,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		99,
		102,
		108,
		132,
		142,
		-1,
		163,
		161,
		185,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		156,
		158,
		191,
		169,
		191,
		188,
		217,
		222,
		216,
		225,
		-1,
		148,
		144,
		140,
		147,
		96,
		-1,
		-1,
		136,
		-1,
		150,
		163,
		167,
		165,
		168,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		158,
		169,
		164,
		163,
		181,
		196,
		209,
		213,
		219,
		-1,
		198,
		-1,
		140,
		124,
		126,
		98,
		119,
		-1,
		156,
		151,
		171,
		169,
		160,
		-1,
		163,
		166,
		173,
		151,
		136,
		153,
		145,
		143,
		148,
		153,
		167,
		158,
		176,
		183,
		191,
		195,
		215,
		227,
		158,
		148,
		-1,
		130,
		135,
		94,
		102,
		121,
		194,
		166,
		-1,
		161,
		-1,
		153,
		178,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		152,
		149,
		146,
		164,
		167,
		184,
		188,
		204,
		-1,
		-1,
		143,
		147,
		136,
		87,
		106,
		130,
		167,
		159,
		148,
		147,
		-1,
		138,
		168,
		165,
		151,
		138,
		128,
		129,
		137,
		150,
		129,
		148,
		151,
		173,
		201,
		179,
		191,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		113,
		84,
		108,
		150,
		177,
		170,
		158,
		123,
		123,
		117,
		-1,
		158,
		141,
		137,
		126,
		124,
		137,
		132,
		148,
		152,
		151,
		170,
		182,
		173,
		193,
		-1,
		-1,
		-1,
		143,
		132,
		133,
		79,
		102,
		139,
		156,
		142,
		147,
		122,
		115,
		109,
		161,
		158,
		125,
		133,
		125,
		114,
		128,
		136,
		140,
		149,
		158,
		164,
		188,
		188,
		194,
		-1,
		-1,
		150,
		140,
		124,
		126,
		123,
		93,
		100,
		132,
		147,
		144,
		-1,
		114,
		-1,
		103,
		111,
		110,
		116,
		128,
		114,
		119,
		130,
		142,
		155,
		151,
		158,
		193,
		193,
		178,
		198,
		201,
		-1,
		-1,
		-1,
		143,
		138,
		113,
		90,
		74,
		110,
		-1,
		114,
		115,
		-1,
		108,
		102,
		108,
		107,
		114,
		111,
		111,
		125,
		133,
		129,
		145,
		151,
		143,
		179,
		-1,
		186,
		180,
		188,
		178,
		166,
		-1,
		-1,
		-1,
		136,
		115,
		108,
		128,
		69,
		121,
		-1,
		-1,
		99,
		92,
		-1,
		95,
		95,
		102,
		111,
		116,
		121,
		129,
		124,
		137,
		142,
		148,
		153,
		171,
		175,
		179,
		168,
		164,
		161,
		175,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		89,
		-1,
		108,
		100,
		90,
		84,
		90,
		108,
		106,
		126,
		118,
		132,
		132,
		138,
		146,
		131,
		134,
		150,
		148,
		166,
		174,
		166,
		160,
		159,
		171,
		-1,
		135,
		121,
		92,
		-1,
		-1,
		102,
		-1,
		66,
		90,
		106,
		-1,
		124,
		103,
		126,
		104,
		118,
		114,
		152,
		153,
		131,
		136,
		144,
		154,
		156,
		145,
		156,
		148,
		170,
		170,
		154,
		155,
		164,
		-1,
		141,
		128,
		86,
		81,
		70,
		83,
		63,
		72,
		93,
		-1,
		-1,
		168,
		-1,
		102,
		119,
		128,
		126,
		142,
		133,
		139,
		155,
		158,
		160,
		150,
		139,
		145,
		142,
		164,
		150,
		148,
		167,
		183,
		-1,
		-1,
		-1,
		59,
		-1,
		-1,
		49,
		59,
		59,
		-1,
		110,
		-1,
		146,
		136,
		120,
		105,
		138,
		-1,
		150,
		134,
		139,
		-1,
		185,
		-1,
		158,
		160,
		154,
		139,
		136,
		147,
		145,
		156,
		173,
		-1,
		0,
		11,
		18,
		30,
		88,
		59,
		-1,
		115,
		-1,
		-1,
		133,
		127,
		127,
		111,
		114,
		166,
		146,
		140,
		139,
		180,
		180,
		166,
		152,
		145,
		142,
		139,
		152,
		172,
		163,
		175,
		-1,
		-1,
		-1,
		50,
		103,
		102,
		67,
		81,
		-1,
		-1,
		195,
		150,
		136,
		-1,
		120,
		183,
		171,
		161,
		151,
		185,
		186,
		171,
		164,
		150,
		152,
		150,
		148,
		153,
		174,
		175,
		188,
		-1,
		-1,
		100,
		100,
		88,
		74,
		93,
		-1,
		-1,
		-1,
		142,
		158,
		150,
		121,
		172,
		-1,
		-1,
		163,
		161,
		171,
		167,
		154,
		174,
		177,
		163,
		147,
		162,
		174,
		182,
		187,
		-1,
		103,
		90,
		-1,
		-1,
		96,
		90,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		153,
		174,
		199,
		166,
		-1,
		171,
		172,
		158,
		172,
		179,
		165,
		160,
		154,
		157,
		175,
		192,
		-1,
		-1,
		110,
		-1,
		105,
		-1,
		-1,
		-1,
		-1,
		132,
		146,
		167,
		173,
		185,
		-1,
		180,
		174,
		160,
		177,
		178,
		175,
		166,
		158,
		163,
		160,
		173,
		187,
		191,
		133,
		-1,
		116,
		-1,
		-1,
		-1,
		150,
		165,
		227,
		204,
		177,
		181,
		174,
		168,
		168,
		184,
		186,
		197,
		165,
		161,
		162,
		166,
		165,
		182,
		192,
		-1,
		-1,
		116,
		133,
		168,
		158,
		162,
		254,
		-1,
		-1,
		190,
		181,
		172,
		175,
		178,
		181,
		171,
		168,
		173,
		178,
		166,
		175,
		193,
		197,
		-1,
		-1,
		-1,
		136,
		-1,
		151,
		-1,
		-1,
		177,
		261,
		208,
		190,
		186,
		184,
		177,
		186,
		181,
		176,
		186,
		195,
		187,
		168,
		179,
		202,
		191,
		229,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		165,
		140,
		155,
		201,
		197,
		197,
		223,
		220,
		-1,
		190,
		215,
		187,
		194,
		186,
		194,
		194,
		191,
		169,
		176,
		192,
		191,
		186,
		221,
		213,
		219,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		171,
		157,
		187,
		177,
		183,
		-1,
		-1,
		230,
		227,
		212,
		196,
		200,
		193,
		188,
		198,
		178,
		165,
		169,
		173,
		179,
		184,
		189,
		195,
		210,
		225,
		-1,
		148,
		229,
		222,
		205,
		213,
		244,
		-1,
		174,
		183,
		164,
		169,
		177,
		-1,
		-1,
		203,
		199,
		204,
		203,
		200,
		208,
		203,
		194,
		179,
		185,
		172,
		171,
		189,
		193,
		202,
		209,
		199,
		212,
		216,
		-1,
		162,
		205,
		199,
		202,
		226,
		240,
		-1,
		187,
		-1,
		-1,
		172,
		190,
		198,
		194,
		198,
		251,
		217,
		212,
		202,
		200,
		191,
		182,
		189,
		180,
		180,
		183,
		198,
		203,
		195,
		209,
		209,
		210,
		-1,
		197,
		185,
		193,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		188,
		-1,
		224,
		-1,
		217,
		221,
		225,
		228,
		216,
		203,
		195,
		187,
		203,
		178,
		188,
		184,
		185,
		194,
		205,
		217,
		216,
		217,
		271,
		226,
		193,
		184,
		231,
		246,
		250,
		-1,
		200,
		239,
		226,
		-1,
		197,
		-1,
		-1,
		-1,
		231,
		238,
		230,
		236,
		215,
		215,
		189,
		193,
		183,
		190,
		200,
		202,
		194,
		198,
		211,
		222,
		225,
		267,
		265,
		270,
		215,
		198,
		216,
		225,
		246,
		215,
		206,
		233,
		233,
		222,
		217,
		204,
		-1,
		-1,
		254,
		248,
		-1,
		-1,
		222,
		210,
		193,
		194,
		190,
		193,
		208,
		211,
		201,
		199,
		193,
		225,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		206,
		217,
		-1,
		-1,
		218,
		234,
		247,
		251,
		264,
		289,
		-1,
		207,
		-1,
		-1,
		267,
		-1,
		-1,
		252,
		215,
		204,
		195,
		201,
		198,
		209,
		219,
		207,
		208,
		198,
		208,
		221,
		251,
		248,
		236,
		234,
		257,
		214,
		210,
		-1,
		233,
		221,
		227,
		234,
		251,
		278,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		250,
		248,
		237,
		-1,
		227,
		200,
		205,
		225,
		227,
		216,
		210,
		204,
		211,
		210,
		218,
		226,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		232,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		-1,
		258,
		233,
		-1,
		-1,
		245,
		238,
		226,
		214,
		204,
		214,
		218,
		222,
		214,
		207,
		202,
		213,
		205,
		209,
		226,
		-1,
		294,
		-1,
		246,
		239,
		254,
		269,
		277,
		-1,
		-1,
		-1,
		275,
		261,
		254,
		242,
		240,
		-1,
		279,
		263,
		244,
		-1,
		214,
		227,
		258,
		226,
		231,
		226,
		208,
		219,
		208,
		211,
		225,
		220,
		-1,
		-1,
		252,
		255,
		-1,
		-1,
		277,
		296,
		-1,
		266,
		255,
		240,
		232,
		-1,
		-1,
		251,
		247,
		-1,
		-1,
		215,
		240,
		229,
		237,
		232,
		212,
		218,
		221,
		210,
		214,
		226,
		-1,
		-1,
		259,
		260,
		265,
		-1,
		280,
		-1,
		290,
		-1,
		235,
		251,
		253,
		-1,
		-1,
		-1,
		253,
		216,
		237,
		247,
		241,
		239,
		230,
		216,
		223,
		221,
		217,
		228,
		-1,
		-1,
		-1,
		298,
		272,
		297,
		288,
		271,
		251,
		243,
		268,
		-1,
		240,
		-1,
		215,
		217,
		243,
		246,
		252,
		246,
		219,
		234,
		224,
		215,
		224,
		304,
		-1,
		274,
		307,
		271,
		257,
		241,
		245,
		261,
		-1,
		237,
		219,
		-1,
		247,
		237,
		268,
		253,
		234,
		221,
		228,
		228,
		221,
		-1,
		-1,
		-1,
		276,
		275,
		267,
		261,
		261,
		246,
		237,
		-1,
		249,
		231,
		210,
		227,
		227,
		218,
		226,
		258,
		254,
		241,
		241,
		233,
		-1,
		366,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		270,
		265,
		238,
		226,
		232,
		228,
		214,
		220,
		222,
		230,
		228,
		225,
		237,
		233,
		253,
		234,
		269,
		-1,
		372,
		-1,
		306,
		-1,
		-1,
		288,
		268,
		260,
		249,
		238,
		236,
		227,
		218,
		240,
		256,
		240,
		238,
		241,
		242,
		-1,
		361,
		360,
		-1,
		307,
		299,
		285,
		-1,
		278,
		-1,
		284,
		245,
		-1,
		247,
		227,
		-1,
		249,
		245,
		-1,
		-1,
		348,
		323,
		-1,
		-1,
		-1,
		308,
		288,
		279,
		263,
		-1,
		238,
		238,
		-1,
		-1,
		-1,
		333,
		332,
		-1,
		301,
		304,
		-1,
		294,
		285,
		293,
		240,
		244,
		-1,
		-1,
		-1,
		342,
		323,
		317,
		316,
		314,
		309,
		306,
		292,
		276,
		254,
		243,
		264,
		-1,
		-1,
		-1,
		314,
		306,
		299,
		-1,
		-1,
		301,
		284,
		265,
		263,
		-1,
		-1,
		-1,
		336,
		317,
		-1,
		-1,
		291,
		-1,
		-1,
		297,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		353,
		325,
		-1,
		-1,
		-1,
		287,
		283,
		284,
		-1,
		-1,
		-1,
		-1,
		347,
		348,
		371,
		335,
		-1,
		-1,
		-1,
		279,
		273,
		-1,
		-1,
		350,
		348,
		-1,
		-1,
		-1,
		307,
		291,
		-1,
		277,
		-1,
		-1,
		-1,
		298,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		312,
		-1,
		312,
		287,
		294,
		-1,
		-1,
		-1,
		-1,
		325,
		317,
		325,
		-1,
		297,
		299,
		-1,
		347,
		-1,
		-1,
		340,
		331,
		-1,
		-1,
		302,
		309,
		331,
		334,
		370,
		-1,
		321
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		200,
		202,
		168,
		162,
		201,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		191,
		190,
		160,
		158,
		167,
		172,
		179,
		-1,
		202,
		-1,
		212,
		191,
		202,
		207,
		153,
		150,
		170,
		189,
		195,
		187,
		227,
		183,
		154,
		148,
		166,
		171,
		189,
		181,
		-1,
		154,
		144,
		166,
		170,
		182,
		165,
		-1,
		-1,
		148,
		149,
		155,
		167,
		172,
		177,
		-1,
		200,
		184,
		-1,
		-1,
		138,
		151,
		147,
		150,
		158,
		174,
		192,
		184,
		179,
		-1,
		-1,
		139,
		143,
		156,
		157,
		155,
		179,
		192,
		174,
		188,
		187,
		-1,
		127,
		145,
		154,
		163,
		169,
		155,
		153,
		171,
		173,
		179,
		182,
		-1,
		119,
		121,
		150,
		156,
		168,
		171,
		158,
		158,
		168,
		161,
		180,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		116,
		124,
		150,
		149,
		145,
		163,
		168,
		161,
		158,
		156,
		153,
		169,
		170,
		180,
		-1,
		-1,
		172,
		141,
		176,
		133,
		118,
		-1,
		112,
		131,
		137,
		141,
		146,
		151,
		165,
		161,
		-1,
		147,
		146,
		177,
		163,
		174,
		132,
		-1,
		-1,
		130,
		122,
		107,
		110,
		107,
		107,
		137,
		136,
		141,
		143,
		142,
		148,
		151,
		151,
		157,
		141,
		151,
		155,
		166,
		181,
		-1,
		-1,
		236,
		-1,
		-1,
		129,
		112,
		-1,
		95,
		102,
		102,
		119,
		109,
		130,
		145,
		149,
		157,
		156,
		144,
		146,
		143,
		156,
		144,
		138,
		163,
		167,
		161,
		182,
		177,
		-1,
		235,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		88,
		91,
		97,
		121,
		131,
		-1,
		152,
		150,
		174,
		165,
		162,
		149,
		137,
		150,
		135,
		142,
		141,
		145,
		147,
		180,
		158,
		180,
		177,
		206,
		211,
		205,
		214,
		-1,
		137,
		133,
		129,
		136,
		85,
		-1,
		-1,
		125,
		-1,
		139,
		152,
		156,
		154,
		157,
		166,
		157,
		144,
		133,
		144,
		133,
		130,
		138,
		147,
		158,
		153,
		152,
		170,
		185,
		198,
		202,
		208,
		-1,
		187,
		-1,
		129,
		113,
		115,
		87,
		108,
		-1,
		145,
		140,
		160,
		158,
		149,
		-1,
		152,
		155,
		162,
		140,
		125,
		142,
		134,
		132,
		137,
		142,
		156,
		147,
		165,
		172,
		180,
		184,
		204,
		216,
		147,
		137,
		-1,
		119,
		124,
		83,
		91,
		110,
		183,
		155,
		-1,
		150,
		-1,
		142,
		167,
		-1,
		146,
		142,
		124,
		125,
		120,
		135,
		141,
		138,
		135,
		153,
		156,
		173,
		177,
		193,
		-1,
		-1,
		132,
		136,
		125,
		76,
		95,
		119,
		156,
		148,
		137,
		136,
		-1,
		127,
		157,
		154,
		140,
		127,
		117,
		118,
		126,
		139,
		118,
		137,
		140,
		162,
		190,
		168,
		180,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		102,
		73,
		97,
		139,
		166,
		159,
		147,
		112,
		112,
		106,
		-1,
		147,
		130,
		126,
		115,
		113,
		126,
		121,
		137,
		141,
		140,
		159,
		171,
		162,
		182,
		-1,
		-1,
		-1,
		132,
		121,
		122,
		68,
		91,
		128,
		145,
		131,
		136,
		111,
		104,
		98,
		150,
		147,
		114,
		122,
		114,
		103,
		117,
		125,
		129,
		138,
		147,
		153,
		177,
		177,
		183,
		-1,
		-1,
		139,
		129,
		113,
		115,
		112,
		82,
		89,
		121,
		136,
		133,
		-1,
		103,
		-1,
		92,
		100,
		99,
		105,
		117,
		103,
		108,
		119,
		131,
		144,
		140,
		147,
		182,
		182,
		167,
		187,
		190,
		-1,
		-1,
		-1,
		132,
		127,
		102,
		79,
		63,
		99,
		-1,
		103,
		104,
		-1,
		97,
		91,
		97,
		96,
		103,
		100,
		100,
		114,
		122,
		118,
		134,
		140,
		132,
		168,
		-1,
		175,
		169,
		177,
		167,
		155,
		-1,
		-1,
		-1,
		125,
		104,
		97,
		117,
		58,
		110,
		-1,
		-1,
		88,
		81,
		-1,
		84,
		84,
		91,
		100,
		105,
		110,
		118,
		113,
		126,
		131,
		137,
		142,
		160,
		164,
		168,
		157,
		153,
		150,
		164,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		78,
		-1,
		97,
		89,
		79,
		73,
		79,
		97,
		95,
		115,
		107,
		121,
		121,
		127,
		135,
		120,
		123,
		139,
		137,
		155,
		163,
		155,
		149,
		148,
		160,
		-1,
		124,
		110,
		81,
		-1,
		-1,
		91,
		-1,
		55,
		79,
		95,
		-1,
		113,
		92,
		115,
		93,
		107,
		103,
		141,
		142,
		120,
		125,
		133,
		143,
		145,
		134,
		145,
		137,
		159,
		159,
		143,
		144,
		153,
		-1,
		130,
		117,
		75,
		70,
		59,
		72,
		52,
		61,
		82,
		-1,
		-1,
		157,
		-1,
		91,
		108,
		117,
		115,
		131,
		122,
		128,
		144,
		147,
		149,
		139,
		128,
		134,
		131,
		153,
		139,
		137,
		156,
		172,
		-1,
		-1,
		-1,
		48,
		-1,
		-1,
		38,
		48,
		48,
		-1,
		99,
		-1,
		135,
		125,
		109,
		94,
		127,
		-1,
		139,
		123,
		128,
		-1,
		174,
		-1,
		147,
		149,
		143,
		128,
		125,
		136,
		134,
		145,
		162,
		-1,
		15,
		0,
		7,
		19,
		77,
		48,
		-1,
		104,
		-1,
		-1,
		122,
		116,
		116,
		100,
		103,
		155,
		135,
		129,
		128,
		169,
		169,
		155,
		141,
		134,
		131,
		128,
		141,
		161,
		152,
		164,
		-1,
		-1,
		-1,
		39,
		92,
		91,
		56,
		70,
		-1,
		-1,
		184,
		139,
		125,
		-1,
		109,
		172,
		160,
		150,
		140,
		174,
		175,
		160,
		153,
		139,
		141,
		139,
		137,
		142,
		163,
		164,
		177,
		-1,
		-1,
		89,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		131,
		147,
		139,
		110,
		161,
		-1,
		-1,
		152,
		150,
		160,
		156,
		143,
		163,
		166,
		152,
		136,
		151,
		163,
		171,
		176,
		-1,
		92,
		79,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		142,
		163,
		188,
		155,
		-1,
		160,
		161,
		147,
		161,
		168,
		154,
		149,
		143,
		146,
		164,
		181,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		121,
		135,
		156,
		162,
		174,
		-1,
		169,
		163,
		149,
		166,
		167,
		164,
		155,
		147,
		152,
		149,
		162,
		176,
		180,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		139,
		154,
		216,
		193,
		166,
		170,
		163,
		157,
		157,
		173,
		175,
		186,
		154,
		150,
		151,
		155,
		154,
		171,
		181,
		-1,
		-1,
		105,
		122,
		157,
		147,
		151,
		243,
		-1,
		-1,
		179,
		170,
		161,
		164,
		167,
		170,
		160,
		157,
		162,
		167,
		155,
		164,
		182,
		186,
		-1,
		-1,
		-1,
		125,
		-1,
		140,
		-1,
		-1,
		166,
		250,
		197,
		179,
		175,
		173,
		166,
		175,
		170,
		165,
		175,
		184,
		176,
		157,
		168,
		191,
		180,
		218,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		154,
		129,
		144,
		190,
		186,
		186,
		212,
		209,
		-1,
		179,
		204,
		176,
		183,
		175,
		183,
		183,
		180,
		158,
		165,
		181,
		180,
		175,
		210,
		202,
		208,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		160,
		146,
		176,
		166,
		172,
		-1,
		-1,
		219,
		216,
		201,
		185,
		189,
		182,
		177,
		187,
		167,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		137,
		218,
		211,
		194,
		202,
		233,
		-1,
		163,
		172,
		153,
		158,
		166,
		-1,
		-1,
		192,
		188,
		193,
		192,
		189,
		197,
		192,
		183,
		168,
		174,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		151,
		194,
		188,
		191,
		215,
		229,
		-1,
		176,
		-1,
		-1,
		161,
		179,
		187,
		183,
		187,
		240,
		206,
		201,
		191,
		189,
		180,
		171,
		178,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		186,
		174,
		182,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		177,
		-1,
		213,
		-1,
		206,
		210,
		214,
		217,
		205,
		192,
		184,
		176,
		192,
		167,
		177,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		260,
		215,
		182,
		173,
		220,
		235,
		239,
		-1,
		189,
		228,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		220,
		227,
		219,
		225,
		204,
		204,
		178,
		182,
		172,
		179,
		189,
		191,
		183,
		187,
		200,
		211,
		214,
		256,
		254,
		259,
		204,
		187,
		205,
		214,
		235,
		204,
		195,
		222,
		222,
		211,
		206,
		193,
		-1,
		-1,
		243,
		237,
		-1,
		-1,
		211,
		199,
		182,
		183,
		179,
		182,
		197,
		200,
		190,
		188,
		182,
		214,
		-1,
		256,
		255,
		244,
		241,
		217,
		208,
		195,
		206,
		-1,
		-1,
		207,
		223,
		236,
		240,
		253,
		278,
		-1,
		196,
		-1,
		-1,
		256,
		-1,
		-1,
		241,
		204,
		193,
		184,
		190,
		187,
		198,
		208,
		196,
		197,
		187,
		197,
		210,
		240,
		237,
		225,
		223,
		246,
		203,
		199,
		-1,
		222,
		210,
		216,
		223,
		240,
		267,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		239,
		237,
		226,
		-1,
		216,
		189,
		194,
		214,
		216,
		205,
		199,
		193,
		200,
		199,
		207,
		215,
		249,
		263,
		252,
		248,
		247,
		255,
		204,
		221,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		-1,
		247,
		222,
		-1,
		-1,
		234,
		227,
		215,
		203,
		193,
		203,
		207,
		211,
		203,
		196,
		191,
		202,
		194,
		198,
		215,
		-1,
		283,
		-1,
		235,
		228,
		243,
		258,
		266,
		-1,
		-1,
		-1,
		264,
		250,
		243,
		231,
		229,
		-1,
		268,
		252,
		233,
		-1,
		203,
		216,
		247,
		215,
		220,
		215,
		197,
		208,
		197,
		200,
		214,
		209,
		-1,
		-1,
		241,
		244,
		-1,
		-1,
		266,
		285,
		-1,
		255,
		244,
		229,
		221,
		-1,
		-1,
		240,
		236,
		-1,
		-1,
		204,
		229,
		218,
		226,
		221,
		201,
		207,
		210,
		199,
		203,
		215,
		-1,
		-1,
		248,
		249,
		254,
		-1,
		269,
		-1,
		279,
		-1,
		224,
		240,
		242,
		-1,
		-1,
		-1,
		242,
		205,
		226,
		236,
		230,
		228,
		219,
		205,
		212,
		210,
		206,
		217,
		-1,
		-1,
		-1,
		287,
		261,
		286,
		277,
		260,
		240,
		232,
		257,
		-1,
		229,
		-1,
		204,
		206,
		232,
		235,
		241,
		235,
		208,
		223,
		213,
		204,
		213,
		293,
		-1,
		263,
		296,
		260,
		246,
		230,
		234,
		250,
		-1,
		226,
		208,
		-1,
		236,
		226,
		257,
		242,
		223,
		210,
		217,
		217,
		210,
		-1,
		-1,
		-1,
		265,
		264,
		256,
		250,
		250,
		235,
		226,
		-1,
		238,
		220,
		199,
		216,
		216,
		207,
		215,
		247,
		243,
		230,
		230,
		222,
		-1,
		355,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		259,
		254,
		227,
		215,
		221,
		217,
		203,
		209,
		211,
		219,
		217,
		214,
		226,
		222,
		242,
		223,
		258,
		-1,
		361,
		-1,
		295,
		-1,
		-1,
		277,
		257,
		249,
		238,
		227,
		225,
		216,
		207,
		229,
		245,
		229,
		227,
		230,
		231,
		-1,
		350,
		349,
		-1,
		296,
		288,
		274,
		-1,
		267,
		-1,
		273,
		234,
		-1,
		236,
		216,
		-1,
		238,
		234,
		-1,
		-1,
		337,
		312,
		-1,
		-1,
		-1,
		297,
		277,
		268,
		252,
		-1,
		227,
		227,
		-1,
		-1,
		-1,
		322,
		321,
		-1,
		290,
		293,
		-1,
		283,
		274,
		282,
		229,
		233,
		-1,
		-1,
		-1,
		331,
		312,
		306,
		305,
		303,
		298,
		295,
		281,
		265,
		243,
		232,
		253,
		-1,
		-1,
		-1,
		303,
		295,
		288,
		-1,
		-1,
		290,
		273,
		254,
		252,
		-1,
		-1,
		-1,
		325,
		306,
		-1,
		-1,
		280,
		-1,
		-1,
		286,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		342,
		314,
		-1,
		-1,
		-1,
		276,
		272,
		273,
		-1,
		-1,
		-1,
		-1,
		336,
		337,
		360,
		324,
		-1,
		-1,
		-1,
		268,
		262,
		-1,
		-1,
		339,
		337,
		-1,
		-1,
		-1,
		296,
		280,
		-1,
		266,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		301,
		-1,
		301,
		276,
		283,
		-1,
		-1,
		-1,
		-1,
		314,
		306,
		314,
		-1,
		286,
		288,
		-1,
		336,
		-1,
		-1,
		329,
		320,
		-1,
		-1,
		291,
		298,
		320,
		323,
		359,
		-1,
		310
	],
	[
		-1,
		184,
		173,
		184,
		192,
		165,
		172,
		-1,
		193,
		195,
		161,
		155,
		194,
		165,
		171,
		182,
		-1,
		-1,
		-1,
		184,
		183,
		153,
		151,
		160,
		165,
		172,
		-1,
		195,
		-1,
		205,
		184,
		195,
		200,
		146,
		143,
		163,
		182,
		188,
		180,
		220,
		176,
		147,
		141,
		159,
		164,
		182,
		174,
		-1,
		147,
		137,
		159,
		163,
		175,
		158,
		-1,
		-1,
		141,
		142,
		148,
		160,
		165,
		170,
		-1,
		193,
		177,
		-1,
		-1,
		131,
		144,
		140,
		143,
		151,
		167,
		185,
		177,
		172,
		-1,
		-1,
		132,
		136,
		149,
		150,
		148,
		172,
		185,
		167,
		181,
		180,
		-1,
		120,
		138,
		147,
		156,
		162,
		148,
		146,
		164,
		166,
		172,
		175,
		-1,
		112,
		114,
		143,
		149,
		161,
		164,
		151,
		151,
		161,
		154,
		173,
		164,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		117,
		143,
		142,
		138,
		156,
		161,
		154,
		151,
		149,
		146,
		162,
		163,
		173,
		-1,
		-1,
		165,
		134,
		169,
		126,
		111,
		-1,
		105,
		124,
		130,
		134,
		139,
		144,
		158,
		154,
		-1,
		140,
		139,
		170,
		156,
		167,
		125,
		-1,
		-1,
		123,
		115,
		100,
		103,
		100,
		100,
		130,
		129,
		134,
		136,
		135,
		141,
		144,
		144,
		150,
		134,
		144,
		148,
		159,
		174,
		-1,
		-1,
		229,
		-1,
		-1,
		122,
		105,
		-1,
		88,
		95,
		95,
		112,
		102,
		123,
		138,
		142,
		150,
		149,
		137,
		139,
		136,
		149,
		137,
		131,
		156,
		160,
		154,
		175,
		170,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		81,
		84,
		90,
		114,
		124,
		-1,
		145,
		143,
		167,
		158,
		155,
		142,
		130,
		143,
		128,
		135,
		134,
		138,
		140,
		173,
		151,
		173,
		170,
		199,
		204,
		198,
		207,
		-1,
		130,
		126,
		122,
		129,
		78,
		-1,
		-1,
		118,
		-1,
		132,
		145,
		149,
		147,
		150,
		159,
		150,
		137,
		126,
		137,
		126,
		123,
		131,
		140,
		151,
		146,
		145,
		163,
		178,
		191,
		195,
		201,
		-1,
		180,
		-1,
		122,
		106,
		108,
		80,
		101,
		-1,
		138,
		133,
		153,
		151,
		142,
		-1,
		145,
		148,
		155,
		133,
		118,
		135,
		127,
		125,
		130,
		135,
		149,
		140,
		158,
		165,
		173,
		177,
		197,
		209,
		140,
		130,
		-1,
		112,
		117,
		76,
		84,
		103,
		176,
		148,
		-1,
		143,
		-1,
		135,
		160,
		-1,
		139,
		135,
		117,
		118,
		113,
		128,
		134,
		131,
		128,
		146,
		149,
		166,
		170,
		186,
		-1,
		-1,
		125,
		129,
		118,
		69,
		88,
		112,
		149,
		141,
		130,
		129,
		-1,
		120,
		150,
		147,
		133,
		120,
		110,
		111,
		119,
		132,
		111,
		130,
		133,
		155,
		183,
		161,
		173,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		95,
		66,
		90,
		132,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		140,
		123,
		119,
		108,
		106,
		119,
		114,
		130,
		134,
		133,
		152,
		164,
		155,
		175,
		-1,
		-1,
		-1,
		125,
		114,
		115,
		61,
		84,
		121,
		138,
		124,
		129,
		104,
		97,
		91,
		143,
		140,
		107,
		115,
		107,
		96,
		110,
		118,
		122,
		131,
		140,
		146,
		170,
		170,
		176,
		-1,
		-1,
		132,
		122,
		106,
		108,
		105,
		75,
		82,
		114,
		129,
		126,
		-1,
		96,
		-1,
		85,
		93,
		92,
		98,
		110,
		96,
		101,
		112,
		124,
		137,
		133,
		140,
		175,
		175,
		160,
		180,
		183,
		-1,
		-1,
		-1,
		125,
		120,
		95,
		72,
		56,
		92,
		-1,
		96,
		97,
		-1,
		90,
		84,
		90,
		89,
		96,
		93,
		93,
		107,
		115,
		111,
		127,
		133,
		125,
		161,
		-1,
		168,
		162,
		170,
		160,
		148,
		-1,
		-1,
		-1,
		118,
		97,
		90,
		110,
		51,
		103,
		-1,
		-1,
		81,
		74,
		-1,
		77,
		77,
		84,
		93,
		98,
		103,
		111,
		106,
		119,
		124,
		130,
		135,
		153,
		157,
		161,
		150,
		146,
		143,
		157,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		51,
		71,
		-1,
		90,
		82,
		72,
		66,
		72,
		90,
		88,
		108,
		100,
		114,
		114,
		120,
		128,
		113,
		116,
		132,
		130,
		148,
		156,
		148,
		142,
		141,
		153,
		-1,
		117,
		103,
		74,
		-1,
		-1,
		84,
		-1,
		48,
		72,
		88,
		-1,
		106,
		85,
		108,
		86,
		100,
		96,
		134,
		135,
		113,
		118,
		126,
		136,
		138,
		127,
		138,
		130,
		152,
		152,
		136,
		137,
		146,
		-1,
		123,
		110,
		68,
		63,
		52,
		65,
		45,
		54,
		75,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		110,
		108,
		124,
		115,
		121,
		137,
		140,
		142,
		132,
		121,
		127,
		124,
		146,
		132,
		130,
		149,
		165,
		-1,
		-1,
		-1,
		41,
		-1,
		-1,
		31,
		41,
		41,
		-1,
		92,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		132,
		116,
		121,
		-1,
		167,
		-1,
		140,
		142,
		136,
		121,
		118,
		129,
		127,
		138,
		155,
		-1,
		22,
		7,
		0,
		12,
		70,
		41,
		-1,
		97,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		148,
		128,
		122,
		121,
		162,
		162,
		148,
		134,
		127,
		124,
		121,
		134,
		154,
		145,
		157,
		-1,
		-1,
		-1,
		32,
		85,
		84,
		49,
		63,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		165,
		153,
		143,
		133,
		167,
		168,
		153,
		146,
		132,
		134,
		132,
		130,
		135,
		156,
		157,
		170,
		-1,
		-1,
		82,
		82,
		70,
		56,
		75,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		154,
		-1,
		-1,
		145,
		143,
		153,
		149,
		136,
		156,
		159,
		145,
		129,
		144,
		156,
		164,
		169,
		-1,
		85,
		72,
		-1,
		-1,
		78,
		72,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		135,
		156,
		181,
		148,
		-1,
		153,
		154,
		140,
		154,
		161,
		147,
		142,
		136,
		139,
		157,
		174,
		-1,
		-1,
		92,
		-1,
		87,
		-1,
		-1,
		-1,
		-1,
		114,
		128,
		149,
		155,
		167,
		-1,
		162,
		156,
		142,
		159,
		160,
		157,
		148,
		140,
		145,
		142,
		155,
		169,
		173,
		115,
		-1,
		98,
		-1,
		-1,
		-1,
		132,
		147,
		209,
		186,
		159,
		163,
		156,
		150,
		150,
		166,
		168,
		179,
		147,
		143,
		144,
		148,
		147,
		164,
		174,
		-1,
		-1,
		98,
		115,
		150,
		140,
		144,
		236,
		-1,
		-1,
		172,
		163,
		154,
		157,
		160,
		163,
		153,
		150,
		155,
		160,
		148,
		157,
		175,
		179,
		-1,
		-1,
		-1,
		118,
		-1,
		133,
		-1,
		-1,
		159,
		243,
		190,
		172,
		168,
		166,
		159,
		168,
		163,
		158,
		168,
		177,
		169,
		150,
		161,
		184,
		173,
		211,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		147,
		122,
		137,
		183,
		179,
		179,
		205,
		202,
		-1,
		172,
		197,
		169,
		176,
		168,
		176,
		176,
		173,
		151,
		158,
		174,
		173,
		168,
		203,
		195,
		201,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		153,
		139,
		169,
		159,
		165,
		-1,
		-1,
		212,
		209,
		194,
		178,
		182,
		175,
		170,
		180,
		160,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		130,
		211,
		204,
		187,
		195,
		226,
		-1,
		156,
		165,
		146,
		151,
		159,
		-1,
		-1,
		185,
		181,
		186,
		185,
		182,
		190,
		185,
		176,
		161,
		167,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		144,
		187,
		181,
		184,
		208,
		222,
		-1,
		169,
		-1,
		-1,
		154,
		172,
		180,
		176,
		180,
		233,
		199,
		194,
		184,
		182,
		173,
		164,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		179,
		167,
		175,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		170,
		-1,
		206,
		-1,
		199,
		203,
		207,
		210,
		198,
		185,
		177,
		169,
		185,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		253,
		208,
		175,
		166,
		213,
		228,
		232,
		-1,
		182,
		221,
		208,
		-1,
		179,
		-1,
		-1,
		-1,
		213,
		220,
		212,
		218,
		197,
		197,
		171,
		175,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		249,
		247,
		252,
		197,
		180,
		198,
		207,
		228,
		197,
		188,
		215,
		215,
		204,
		199,
		186,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		204,
		192,
		175,
		176,
		172,
		175,
		190,
		193,
		183,
		181,
		175,
		207,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		188,
		199,
		-1,
		-1,
		200,
		216,
		229,
		233,
		246,
		271,
		-1,
		189,
		-1,
		-1,
		249,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		180,
		191,
		201,
		189,
		190,
		180,
		190,
		203,
		233,
		230,
		218,
		216,
		239,
		196,
		192,
		-1,
		215,
		203,
		209,
		216,
		233,
		260,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		232,
		230,
		219,
		-1,
		209,
		182,
		187,
		207,
		209,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		214,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		215,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		200,
		204,
		196,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		276,
		-1,
		228,
		221,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		234,
		237,
		-1,
		-1,
		259,
		278,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		241,
		242,
		247,
		-1,
		262,
		-1,
		272,
		-1,
		217,
		233,
		235,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		223,
		221,
		212,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		280,
		254,
		279,
		270,
		253,
		233,
		225,
		250,
		-1,
		222,
		-1,
		197,
		199,
		225,
		228,
		234,
		228,
		201,
		216,
		206,
		197,
		206,
		286,
		-1,
		256,
		289,
		253,
		239,
		223,
		227,
		243,
		-1,
		219,
		201,
		-1,
		229,
		219,
		250,
		235,
		216,
		203,
		210,
		210,
		203,
		-1,
		-1,
		-1,
		258,
		257,
		249,
		243,
		243,
		228,
		219,
		-1,
		231,
		213,
		192,
		209,
		209,
		200,
		208,
		240,
		236,
		223,
		223,
		215,
		-1,
		348,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		252,
		247,
		220,
		208,
		214,
		210,
		196,
		202,
		204,
		212,
		210,
		207,
		219,
		215,
		235,
		216,
		251,
		-1,
		354,
		-1,
		288,
		-1,
		-1,
		270,
		250,
		242,
		231,
		220,
		218,
		209,
		200,
		222,
		238,
		222,
		220,
		223,
		224,
		-1,
		343,
		342,
		-1,
		289,
		281,
		267,
		-1,
		260,
		-1,
		266,
		227,
		-1,
		229,
		209,
		-1,
		231,
		227,
		-1,
		-1,
		330,
		305,
		-1,
		-1,
		-1,
		290,
		270,
		261,
		245,
		-1,
		220,
		220,
		-1,
		-1,
		-1,
		315,
		314,
		-1,
		283,
		286,
		-1,
		276,
		267,
		275,
		222,
		226,
		-1,
		-1,
		-1,
		324,
		305,
		299,
		298,
		296,
		291,
		288,
		274,
		258,
		236,
		225,
		246,
		-1,
		-1,
		-1,
		296,
		288,
		281,
		-1,
		-1,
		283,
		266,
		247,
		245,
		-1,
		-1,
		-1,
		318,
		299,
		-1,
		-1,
		273,
		-1,
		-1,
		279,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		335,
		307,
		-1,
		-1,
		-1,
		269,
		265,
		266,
		-1,
		-1,
		-1,
		-1,
		329,
		330,
		353,
		317,
		-1,
		-1,
		-1,
		261,
		255,
		-1,
		-1,
		332,
		330,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		259,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		294,
		-1,
		294,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		307,
		-1,
		279,
		281,
		-1,
		329,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		284,
		291,
		313,
		316,
		352,
		-1,
		303
	],
	[
		-1,
		172,
		161,
		172,
		180,
		153,
		160,
		-1,
		181,
		183,
		149,
		143,
		182,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		172,
		171,
		141,
		139,
		148,
		153,
		160,
		-1,
		183,
		-1,
		193,
		172,
		183,
		188,
		134,
		131,
		151,
		170,
		176,
		168,
		208,
		164,
		135,
		129,
		147,
		152,
		170,
		162,
		-1,
		135,
		125,
		147,
		151,
		163,
		146,
		-1,
		-1,
		129,
		130,
		136,
		148,
		153,
		158,
		-1,
		181,
		165,
		-1,
		-1,
		119,
		132,
		128,
		131,
		139,
		155,
		173,
		165,
		160,
		-1,
		-1,
		120,
		124,
		137,
		138,
		136,
		160,
		173,
		155,
		169,
		168,
		-1,
		108,
		126,
		135,
		144,
		150,
		136,
		134,
		152,
		154,
		160,
		163,
		-1,
		100,
		102,
		131,
		137,
		149,
		152,
		139,
		139,
		149,
		142,
		161,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		97,
		105,
		131,
		130,
		126,
		144,
		149,
		142,
		139,
		137,
		134,
		150,
		151,
		161,
		-1,
		-1,
		153,
		122,
		157,
		114,
		99,
		-1,
		93,
		112,
		118,
		122,
		127,
		132,
		146,
		142,
		-1,
		128,
		127,
		158,
		144,
		155,
		113,
		-1,
		-1,
		111,
		103,
		88,
		91,
		88,
		88,
		118,
		117,
		122,
		124,
		123,
		129,
		132,
		132,
		138,
		122,
		132,
		136,
		147,
		162,
		-1,
		-1,
		217,
		-1,
		-1,
		110,
		93,
		-1,
		76,
		83,
		83,
		100,
		90,
		111,
		126,
		130,
		138,
		137,
		125,
		127,
		124,
		137,
		125,
		119,
		144,
		148,
		142,
		163,
		158,
		-1,
		216,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		69,
		72,
		78,
		102,
		112,
		-1,
		133,
		131,
		155,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		122,
		126,
		128,
		161,
		139,
		161,
		158,
		187,
		192,
		186,
		195,
		-1,
		118,
		114,
		110,
		117,
		66,
		-1,
		-1,
		106,
		-1,
		120,
		133,
		137,
		135,
		138,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		119,
		128,
		139,
		134,
		133,
		151,
		166,
		179,
		183,
		189,
		-1,
		168,
		-1,
		110,
		94,
		96,
		68,
		89,
		-1,
		126,
		121,
		141,
		139,
		130,
		-1,
		133,
		136,
		143,
		121,
		106,
		123,
		115,
		113,
		118,
		123,
		137,
		128,
		146,
		153,
		161,
		165,
		185,
		197,
		128,
		118,
		-1,
		100,
		105,
		64,
		72,
		91,
		164,
		136,
		-1,
		131,
		-1,
		123,
		148,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		122,
		119,
		116,
		134,
		137,
		154,
		158,
		174,
		-1,
		-1,
		113,
		117,
		106,
		57,
		76,
		100,
		137,
		129,
		118,
		117,
		-1,
		108,
		138,
		135,
		121,
		108,
		98,
		99,
		107,
		120,
		99,
		118,
		121,
		143,
		171,
		149,
		161,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		83,
		54,
		78,
		120,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		128,
		111,
		107,
		96,
		94,
		107,
		102,
		118,
		122,
		121,
		140,
		152,
		143,
		163,
		-1,
		-1,
		-1,
		113,
		102,
		103,
		49,
		72,
		109,
		126,
		112,
		117,
		92,
		85,
		79,
		131,
		128,
		95,
		103,
		95,
		84,
		98,
		106,
		110,
		119,
		128,
		134,
		158,
		158,
		164,
		-1,
		-1,
		120,
		110,
		94,
		96,
		93,
		63,
		70,
		102,
		117,
		114,
		-1,
		84,
		-1,
		73,
		81,
		80,
		86,
		98,
		84,
		89,
		100,
		112,
		125,
		121,
		128,
		163,
		163,
		148,
		168,
		171,
		-1,
		-1,
		-1,
		113,
		108,
		83,
		60,
		44,
		80,
		-1,
		84,
		85,
		-1,
		78,
		72,
		78,
		77,
		84,
		81,
		81,
		95,
		103,
		99,
		115,
		121,
		113,
		149,
		-1,
		156,
		150,
		158,
		148,
		136,
		-1,
		-1,
		-1,
		106,
		85,
		78,
		98,
		39,
		91,
		-1,
		-1,
		69,
		62,
		-1,
		65,
		65,
		72,
		81,
		86,
		91,
		99,
		94,
		107,
		112,
		118,
		123,
		141,
		145,
		149,
		138,
		134,
		131,
		145,
		-1,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		39,
		59,
		-1,
		78,
		70,
		60,
		54,
		60,
		78,
		76,
		96,
		88,
		102,
		102,
		108,
		116,
		101,
		104,
		120,
		118,
		136,
		144,
		136,
		130,
		129,
		141,
		-1,
		105,
		91,
		62,
		-1,
		-1,
		72,
		-1,
		36,
		60,
		76,
		-1,
		94,
		73,
		96,
		74,
		88,
		84,
		122,
		123,
		101,
		106,
		114,
		124,
		126,
		115,
		126,
		118,
		140,
		140,
		124,
		125,
		134,
		-1,
		111,
		98,
		56,
		51,
		40,
		53,
		33,
		42,
		63,
		-1,
		-1,
		138,
		-1,
		72,
		89,
		98,
		96,
		112,
		103,
		109,
		125,
		128,
		130,
		120,
		109,
		115,
		112,
		134,
		120,
		118,
		137,
		153,
		-1,
		-1,
		-1,
		49,
		-1,
		-1,
		19,
		29,
		29,
		-1,
		80,
		-1,
		116,
		106,
		90,
		75,
		108,
		-1,
		120,
		104,
		109,
		-1,
		155,
		-1,
		128,
		130,
		124,
		109,
		106,
		117,
		115,
		126,
		143,
		-1,
		32,
		17,
		10,
		0,
		58,
		29,
		-1,
		85,
		-1,
		-1,
		103,
		97,
		97,
		81,
		84,
		136,
		116,
		110,
		109,
		150,
		150,
		136,
		122,
		115,
		112,
		109,
		122,
		142,
		133,
		145,
		-1,
		-1,
		-1,
		37,
		73,
		72,
		37,
		51,
		-1,
		-1,
		165,
		120,
		106,
		-1,
		90,
		153,
		141,
		131,
		121,
		155,
		156,
		141,
		134,
		120,
		122,
		120,
		118,
		123,
		144,
		145,
		158,
		-1,
		-1,
		70,
		70,
		58,
		44,
		63,
		-1,
		-1,
		-1,
		112,
		128,
		120,
		91,
		142,
		-1,
		-1,
		133,
		131,
		141,
		137,
		124,
		144,
		147,
		133,
		117,
		132,
		144,
		152,
		157,
		-1,
		73,
		60,
		-1,
		-1,
		66,
		60,
		-1,
		-1,
		-1,
		-1,
		145,
		111,
		123,
		144,
		169,
		136,
		-1,
		141,
		142,
		128,
		142,
		149,
		135,
		130,
		124,
		127,
		145,
		162,
		-1,
		-1,
		80,
		-1,
		75,
		-1,
		-1,
		-1,
		-1,
		102,
		116,
		137,
		143,
		155,
		-1,
		150,
		144,
		130,
		147,
		148,
		145,
		136,
		128,
		133,
		130,
		143,
		157,
		161,
		103,
		-1,
		86,
		-1,
		-1,
		-1,
		120,
		135,
		197,
		174,
		147,
		151,
		144,
		138,
		138,
		154,
		156,
		167,
		135,
		131,
		132,
		136,
		135,
		152,
		162,
		-1,
		-1,
		86,
		103,
		138,
		128,
		132,
		224,
		-1,
		-1,
		160,
		151,
		142,
		145,
		148,
		151,
		141,
		138,
		143,
		148,
		136,
		145,
		163,
		167,
		-1,
		-1,
		-1,
		106,
		-1,
		121,
		-1,
		-1,
		147,
		231,
		178,
		160,
		156,
		154,
		147,
		156,
		151,
		146,
		156,
		165,
		157,
		138,
		149,
		172,
		161,
		199,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		135,
		110,
		125,
		171,
		167,
		167,
		193,
		190,
		-1,
		160,
		185,
		157,
		164,
		156,
		164,
		164,
		161,
		139,
		146,
		162,
		161,
		156,
		191,
		183,
		189,
		-1,
		-1,
		223,
		212,
		201,
		207,
		-1,
		141,
		127,
		157,
		147,
		153,
		-1,
		-1,
		200,
		197,
		182,
		166,
		170,
		163,
		158,
		168,
		148,
		135,
		139,
		143,
		149,
		154,
		159,
		165,
		180,
		195,
		-1,
		118,
		199,
		192,
		175,
		183,
		214,
		-1,
		144,
		153,
		134,
		139,
		147,
		-1,
		-1,
		173,
		169,
		174,
		173,
		170,
		178,
		173,
		164,
		149,
		155,
		142,
		141,
		159,
		163,
		172,
		179,
		169,
		182,
		186,
		-1,
		132,
		175,
		169,
		172,
		196,
		210,
		-1,
		157,
		-1,
		-1,
		142,
		160,
		168,
		164,
		168,
		221,
		187,
		182,
		172,
		170,
		161,
		152,
		159,
		150,
		150,
		153,
		168,
		173,
		165,
		179,
		179,
		180,
		-1,
		167,
		155,
		163,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		158,
		-1,
		194,
		-1,
		187,
		191,
		195,
		198,
		186,
		173,
		165,
		157,
		173,
		148,
		158,
		154,
		155,
		164,
		175,
		187,
		186,
		187,
		241,
		196,
		163,
		154,
		201,
		216,
		220,
		-1,
		170,
		209,
		196,
		-1,
		167,
		-1,
		-1,
		-1,
		201,
		208,
		200,
		206,
		185,
		185,
		159,
		163,
		153,
		160,
		170,
		172,
		164,
		168,
		181,
		192,
		195,
		237,
		235,
		240,
		185,
		168,
		186,
		195,
		216,
		185,
		176,
		203,
		203,
		192,
		187,
		174,
		-1,
		-1,
		224,
		218,
		-1,
		-1,
		192,
		180,
		163,
		164,
		160,
		163,
		178,
		181,
		171,
		169,
		163,
		195,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		176,
		187,
		-1,
		-1,
		188,
		204,
		217,
		221,
		234,
		259,
		-1,
		177,
		-1,
		-1,
		237,
		-1,
		-1,
		222,
		185,
		174,
		165,
		171,
		168,
		179,
		189,
		177,
		178,
		168,
		178,
		191,
		221,
		218,
		206,
		204,
		227,
		184,
		180,
		-1,
		203,
		191,
		197,
		204,
		221,
		248,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		220,
		218,
		207,
		-1,
		197,
		170,
		175,
		195,
		197,
		186,
		180,
		174,
		181,
		180,
		188,
		196,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		202,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		-1,
		228,
		203,
		-1,
		-1,
		215,
		208,
		196,
		184,
		174,
		184,
		188,
		192,
		184,
		177,
		172,
		183,
		175,
		179,
		196,
		-1,
		264,
		-1,
		216,
		209,
		224,
		239,
		247,
		-1,
		-1,
		-1,
		245,
		231,
		224,
		212,
		210,
		-1,
		249,
		233,
		214,
		-1,
		184,
		197,
		228,
		196,
		201,
		196,
		178,
		189,
		178,
		181,
		195,
		190,
		-1,
		-1,
		222,
		225,
		-1,
		-1,
		247,
		266,
		-1,
		236,
		225,
		210,
		202,
		-1,
		-1,
		221,
		217,
		-1,
		-1,
		185,
		210,
		199,
		207,
		202,
		182,
		188,
		191,
		180,
		184,
		196,
		-1,
		-1,
		229,
		230,
		235,
		-1,
		250,
		-1,
		260,
		-1,
		205,
		221,
		223,
		-1,
		-1,
		-1,
		223,
		186,
		207,
		217,
		211,
		209,
		200,
		186,
		193,
		191,
		187,
		198,
		-1,
		-1,
		-1,
		268,
		242,
		267,
		258,
		241,
		221,
		213,
		238,
		-1,
		210,
		-1,
		185,
		187,
		213,
		216,
		222,
		216,
		189,
		204,
		194,
		185,
		194,
		274,
		-1,
		244,
		277,
		241,
		227,
		211,
		215,
		231,
		-1,
		207,
		189,
		-1,
		217,
		207,
		238,
		223,
		204,
		191,
		198,
		198,
		191,
		-1,
		-1,
		-1,
		246,
		245,
		237,
		231,
		231,
		216,
		207,
		-1,
		219,
		201,
		180,
		197,
		197,
		188,
		196,
		228,
		224,
		211,
		211,
		203,
		-1,
		336,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		240,
		235,
		208,
		196,
		202,
		198,
		184,
		190,
		192,
		200,
		198,
		195,
		207,
		203,
		223,
		204,
		239,
		-1,
		342,
		-1,
		276,
		-1,
		-1,
		258,
		238,
		230,
		219,
		208,
		206,
		197,
		188,
		210,
		226,
		210,
		208,
		211,
		212,
		-1,
		331,
		330,
		-1,
		277,
		269,
		255,
		-1,
		248,
		-1,
		254,
		215,
		-1,
		217,
		197,
		-1,
		219,
		215,
		-1,
		-1,
		318,
		293,
		-1,
		-1,
		-1,
		278,
		258,
		249,
		233,
		-1,
		208,
		208,
		-1,
		-1,
		-1,
		303,
		302,
		-1,
		271,
		274,
		-1,
		264,
		255,
		263,
		210,
		214,
		-1,
		-1,
		-1,
		312,
		293,
		287,
		286,
		284,
		279,
		276,
		262,
		246,
		224,
		213,
		234,
		-1,
		-1,
		-1,
		284,
		276,
		269,
		-1,
		-1,
		271,
		254,
		235,
		233,
		-1,
		-1,
		-1,
		306,
		287,
		-1,
		-1,
		261,
		-1,
		-1,
		267,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		323,
		295,
		-1,
		-1,
		-1,
		257,
		253,
		254,
		-1,
		-1,
		-1,
		-1,
		317,
		318,
		341,
		305,
		-1,
		-1,
		-1,
		249,
		243,
		-1,
		-1,
		320,
		318,
		-1,
		-1,
		-1,
		277,
		261,
		-1,
		247,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		282,
		-1,
		282,
		257,
		264,
		-1,
		-1,
		-1,
		-1,
		295,
		287,
		295,
		-1,
		267,
		269,
		-1,
		317,
		-1,
		-1,
		310,
		301,
		-1,
		-1,
		272,
		279,
		301,
		304,
		340,
		-1,
		291
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		187,
		189,
		155,
		149,
		188,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		178,
		177,
		147,
		145,
		154,
		159,
		166,
		-1,
		189,
		-1,
		199,
		178,
		189,
		194,
		140,
		137,
		157,
		176,
		182,
		174,
		214,
		170,
		141,
		135,
		153,
		158,
		176,
		168,
		-1,
		141,
		131,
		153,
		157,
		169,
		152,
		-1,
		-1,
		135,
		136,
		142,
		154,
		159,
		164,
		-1,
		187,
		171,
		-1,
		-1,
		125,
		138,
		134,
		137,
		145,
		161,
		179,
		171,
		166,
		-1,
		-1,
		126,
		130,
		143,
		144,
		142,
		166,
		179,
		161,
		175,
		174,
		-1,
		114,
		132,
		141,
		150,
		156,
		142,
		140,
		158,
		160,
		166,
		169,
		-1,
		106,
		108,
		137,
		143,
		155,
		158,
		145,
		145,
		155,
		148,
		167,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		111,
		137,
		136,
		132,
		150,
		155,
		148,
		145,
		143,
		140,
		156,
		157,
		167,
		-1,
		-1,
		159,
		128,
		163,
		120,
		105,
		-1,
		99,
		118,
		124,
		128,
		133,
		138,
		152,
		148,
		-1,
		134,
		133,
		164,
		150,
		161,
		119,
		-1,
		-1,
		117,
		109,
		94,
		97,
		94,
		94,
		124,
		123,
		128,
		130,
		129,
		135,
		138,
		138,
		144,
		128,
		138,
		142,
		153,
		168,
		-1,
		-1,
		223,
		-1,
		-1,
		116,
		99,
		-1,
		82,
		89,
		89,
		106,
		96,
		117,
		132,
		136,
		144,
		143,
		131,
		133,
		130,
		143,
		131,
		125,
		150,
		154,
		148,
		169,
		164,
		-1,
		222,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		75,
		78,
		84,
		108,
		118,
		-1,
		139,
		137,
		161,
		152,
		149,
		136,
		124,
		137,
		122,
		129,
		128,
		132,
		134,
		167,
		145,
		167,
		164,
		193,
		198,
		192,
		201,
		-1,
		124,
		120,
		116,
		123,
		72,
		-1,
		-1,
		112,
		-1,
		126,
		139,
		143,
		141,
		144,
		153,
		144,
		131,
		120,
		131,
		120,
		117,
		125,
		134,
		145,
		140,
		139,
		157,
		172,
		185,
		189,
		195,
		-1,
		174,
		-1,
		116,
		100,
		102,
		74,
		95,
		-1,
		132,
		127,
		147,
		145,
		136,
		-1,
		139,
		142,
		149,
		127,
		112,
		129,
		121,
		119,
		124,
		129,
		143,
		134,
		152,
		159,
		167,
		171,
		191,
		203,
		134,
		124,
		-1,
		106,
		111,
		70,
		78,
		97,
		170,
		142,
		-1,
		137,
		-1,
		129,
		154,
		-1,
		133,
		129,
		111,
		112,
		107,
		122,
		128,
		125,
		122,
		140,
		143,
		160,
		164,
		180,
		-1,
		-1,
		119,
		123,
		112,
		63,
		82,
		106,
		143,
		135,
		124,
		123,
		-1,
		114,
		144,
		141,
		127,
		114,
		104,
		105,
		113,
		126,
		105,
		124,
		127,
		149,
		177,
		155,
		167,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		89,
		60,
		84,
		126,
		153,
		146,
		134,
		99,
		99,
		93,
		-1,
		134,
		117,
		113,
		102,
		100,
		113,
		108,
		124,
		128,
		127,
		146,
		158,
		149,
		169,
		-1,
		-1,
		-1,
		119,
		108,
		109,
		55,
		78,
		115,
		132,
		118,
		123,
		98,
		91,
		85,
		137,
		134,
		101,
		109,
		101,
		90,
		104,
		112,
		116,
		125,
		134,
		140,
		164,
		164,
		170,
		-1,
		-1,
		126,
		116,
		100,
		102,
		99,
		69,
		76,
		108,
		123,
		120,
		-1,
		90,
		-1,
		79,
		87,
		86,
		92,
		104,
		90,
		95,
		106,
		118,
		131,
		127,
		134,
		169,
		169,
		154,
		174,
		177,
		-1,
		-1,
		-1,
		119,
		114,
		89,
		66,
		50,
		86,
		-1,
		90,
		91,
		-1,
		84,
		78,
		84,
		83,
		90,
		87,
		87,
		101,
		109,
		105,
		121,
		127,
		119,
		155,
		-1,
		162,
		156,
		164,
		154,
		142,
		-1,
		-1,
		-1,
		112,
		91,
		84,
		104,
		45,
		97,
		-1,
		-1,
		75,
		68,
		-1,
		71,
		71,
		78,
		87,
		92,
		97,
		105,
		100,
		113,
		118,
		124,
		129,
		147,
		151,
		155,
		144,
		140,
		137,
		151,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		45,
		65,
		-1,
		84,
		76,
		66,
		60,
		66,
		84,
		82,
		102,
		94,
		108,
		108,
		114,
		122,
		107,
		110,
		126,
		124,
		142,
		150,
		142,
		136,
		135,
		147,
		-1,
		129,
		115,
		86,
		-1,
		-1,
		78,
		-1,
		42,
		66,
		82,
		-1,
		100,
		79,
		102,
		80,
		94,
		90,
		128,
		129,
		107,
		112,
		120,
		130,
		132,
		121,
		132,
		124,
		146,
		146,
		130,
		131,
		140,
		-1,
		135,
		122,
		80,
		75,
		64,
		80,
		39,
		48,
		69,
		-1,
		-1,
		144,
		-1,
		78,
		95,
		104,
		102,
		118,
		109,
		115,
		131,
		134,
		136,
		126,
		115,
		121,
		118,
		140,
		126,
		124,
		143,
		159,
		-1,
		-1,
		-1,
		99,
		-1,
		-1,
		48,
		28,
		35,
		-1,
		86,
		-1,
		122,
		112,
		96,
		81,
		114,
		-1,
		126,
		110,
		115,
		-1,
		161,
		-1,
		134,
		136,
		130,
		115,
		112,
		123,
		121,
		132,
		149,
		-1,
		82,
		67,
		60,
		50,
		0,
		32,
		-1,
		88,
		-1,
		-1,
		109,
		103,
		103,
		87,
		90,
		142,
		122,
		116,
		115,
		156,
		156,
		142,
		128,
		121,
		118,
		115,
		128,
		148,
		139,
		151,
		-1,
		-1,
		-1,
		87,
		79,
		75,
		43,
		54,
		-1,
		-1,
		171,
		126,
		112,
		-1,
		96,
		159,
		147,
		137,
		127,
		161,
		162,
		147,
		140,
		126,
		128,
		126,
		124,
		129,
		150,
		151,
		164,
		-1,
		-1,
		76,
		73,
		61,
		47,
		66,
		-1,
		-1,
		-1,
		118,
		134,
		126,
		97,
		148,
		-1,
		-1,
		139,
		137,
		147,
		143,
		130,
		150,
		153,
		139,
		123,
		138,
		150,
		158,
		163,
		-1,
		79,
		66,
		-1,
		-1,
		69,
		63,
		-1,
		-1,
		-1,
		-1,
		151,
		117,
		129,
		150,
		175,
		142,
		-1,
		147,
		148,
		134,
		148,
		155,
		141,
		136,
		130,
		133,
		151,
		168,
		-1,
		-1,
		83,
		-1,
		78,
		-1,
		-1,
		-1,
		-1,
		108,
		122,
		143,
		149,
		161,
		-1,
		156,
		150,
		136,
		153,
		154,
		151,
		142,
		134,
		139,
		136,
		149,
		163,
		167,
		106,
		-1,
		89,
		-1,
		-1,
		-1,
		126,
		141,
		203,
		180,
		153,
		157,
		150,
		144,
		144,
		160,
		162,
		173,
		141,
		137,
		138,
		142,
		141,
		158,
		168,
		-1,
		-1,
		89,
		106,
		141,
		134,
		138,
		230,
		-1,
		-1,
		166,
		157,
		148,
		151,
		154,
		157,
		147,
		144,
		149,
		154,
		142,
		151,
		169,
		173,
		-1,
		-1,
		-1,
		109,
		-1,
		124,
		-1,
		-1,
		153,
		237,
		184,
		166,
		162,
		160,
		153,
		162,
		157,
		152,
		162,
		171,
		163,
		144,
		155,
		178,
		167,
		205,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		138,
		113,
		128,
		174,
		173,
		170,
		199,
		196,
		-1,
		166,
		191,
		163,
		170,
		162,
		170,
		170,
		167,
		145,
		152,
		168,
		167,
		162,
		197,
		189,
		195,
		-1,
		-1,
		229,
		218,
		207,
		213,
		-1,
		144,
		130,
		160,
		150,
		156,
		-1,
		-1,
		203,
		200,
		188,
		172,
		176,
		169,
		164,
		174,
		154,
		141,
		145,
		149,
		155,
		160,
		165,
		171,
		186,
		201,
		-1,
		124,
		205,
		198,
		181,
		189,
		220,
		-1,
		147,
		156,
		137,
		142,
		150,
		-1,
		-1,
		176,
		172,
		177,
		179,
		176,
		184,
		179,
		170,
		155,
		161,
		148,
		147,
		165,
		169,
		178,
		185,
		175,
		188,
		192,
		-1,
		138,
		181,
		175,
		178,
		202,
		216,
		-1,
		160,
		-1,
		-1,
		145,
		163,
		171,
		167,
		171,
		224,
		193,
		188,
		178,
		176,
		167,
		158,
		165,
		156,
		156,
		159,
		174,
		179,
		171,
		185,
		185,
		186,
		-1,
		173,
		161,
		169,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		161,
		-1,
		197,
		-1,
		190,
		194,
		201,
		204,
		192,
		179,
		171,
		163,
		179,
		154,
		164,
		160,
		161,
		170,
		181,
		193,
		192,
		193,
		247,
		202,
		169,
		160,
		207,
		222,
		226,
		-1,
		173,
		212,
		199,
		-1,
		170,
		-1,
		-1,
		-1,
		204,
		214,
		206,
		212,
		191,
		191,
		165,
		169,
		159,
		166,
		176,
		178,
		170,
		174,
		187,
		198,
		201,
		243,
		241,
		246,
		191,
		174,
		192,
		201,
		222,
		188,
		179,
		206,
		206,
		195,
		190,
		177,
		-1,
		-1,
		227,
		224,
		-1,
		-1,
		198,
		186,
		169,
		170,
		166,
		169,
		184,
		187,
		177,
		175,
		169,
		201,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		182,
		193,
		-1,
		-1,
		191,
		207,
		220,
		224,
		237,
		262,
		-1,
		180,
		-1,
		-1,
		243,
		-1,
		-1,
		228,
		191,
		180,
		171,
		177,
		174,
		185,
		195,
		183,
		184,
		174,
		184,
		197,
		227,
		224,
		212,
		210,
		233,
		190,
		186,
		-1,
		206,
		194,
		200,
		207,
		224,
		251,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		226,
		224,
		213,
		-1,
		203,
		176,
		181,
		201,
		203,
		192,
		186,
		180,
		187,
		186,
		194,
		202,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		206,
		-1,
		-1,
		221,
		214,
		202,
		190,
		180,
		190,
		194,
		198,
		190,
		183,
		178,
		189,
		181,
		185,
		202,
		-1,
		270,
		-1,
		222,
		215,
		230,
		245,
		253,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		255,
		239,
		220,
		-1,
		190,
		203,
		234,
		202,
		207,
		202,
		184,
		195,
		184,
		187,
		201,
		196,
		-1,
		-1,
		228,
		231,
		-1,
		-1,
		253,
		272,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		227,
		223,
		-1,
		-1,
		191,
		216,
		205,
		213,
		208,
		188,
		194,
		197,
		186,
		190,
		202,
		-1,
		-1,
		235,
		236,
		241,
		-1,
		256,
		-1,
		263,
		-1,
		208,
		224,
		226,
		-1,
		-1,
		-1,
		229,
		192,
		213,
		223,
		217,
		215,
		206,
		192,
		199,
		197,
		193,
		204,
		-1,
		-1,
		-1,
		274,
		248,
		270,
		261,
		244,
		224,
		216,
		241,
		-1,
		216,
		-1,
		191,
		193,
		219,
		222,
		228,
		222,
		195,
		210,
		200,
		191,
		200,
		280,
		-1,
		250,
		283,
		247,
		230,
		217,
		221,
		237,
		-1,
		213,
		195,
		-1,
		223,
		213,
		244,
		229,
		210,
		197,
		204,
		204,
		197,
		-1,
		-1,
		-1,
		252,
		251,
		243,
		237,
		237,
		222,
		213,
		-1,
		225,
		207,
		186,
		203,
		203,
		194,
		202,
		234,
		230,
		217,
		217,
		209,
		-1,
		342,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		246,
		241,
		214,
		202,
		208,
		204,
		190,
		196,
		198,
		206,
		204,
		201,
		213,
		209,
		229,
		210,
		245,
		-1,
		348,
		-1,
		282,
		-1,
		-1,
		264,
		244,
		236,
		225,
		214,
		212,
		203,
		194,
		216,
		232,
		216,
		214,
		217,
		218,
		-1,
		337,
		336,
		-1,
		283,
		275,
		261,
		-1,
		254,
		-1,
		260,
		221,
		-1,
		223,
		203,
		-1,
		225,
		221,
		-1,
		-1,
		324,
		299,
		-1,
		-1,
		-1,
		284,
		264,
		255,
		239,
		-1,
		214,
		214,
		-1,
		-1,
		-1,
		309,
		308,
		-1,
		277,
		280,
		-1,
		270,
		261,
		269,
		216,
		220,
		-1,
		-1,
		-1,
		318,
		299,
		293,
		292,
		290,
		285,
		282,
		268,
		252,
		230,
		219,
		240,
		-1,
		-1,
		-1,
		290,
		282,
		275,
		-1,
		-1,
		277,
		260,
		241,
		239,
		-1,
		-1,
		-1,
		312,
		293,
		-1,
		-1,
		267,
		-1,
		-1,
		273,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		329,
		301,
		-1,
		-1,
		-1,
		263,
		259,
		260,
		-1,
		-1,
		-1,
		-1,
		323,
		324,
		347,
		311,
		-1,
		-1,
		-1,
		255,
		249,
		-1,
		-1,
		326,
		324,
		-1,
		-1,
		-1,
		283,
		267,
		-1,
		253,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		288,
		-1,
		288,
		263,
		270,
		-1,
		-1,
		-1,
		-1,
		301,
		293,
		301,
		-1,
		273,
		275,
		-1,
		323,
		-1,
		-1,
		316,
		307,
		-1,
		-1,
		278,
		285,
		307,
		310,
		346,
		-1,
		297
	],
	[
		-1,
		151,
		140,
		151,
		159,
		132,
		139,
		-1,
		160,
		162,
		128,
		122,
		161,
		132,
		138,
		149,
		-1,
		-1,
		-1,
		151,
		150,
		120,
		118,
		127,
		132,
		139,
		-1,
		162,
		-1,
		172,
		151,
		162,
		167,
		113,
		110,
		130,
		149,
		155,
		147,
		187,
		143,
		114,
		108,
		126,
		131,
		149,
		141,
		-1,
		114,
		104,
		126,
		130,
		142,
		125,
		-1,
		-1,
		108,
		109,
		115,
		127,
		132,
		137,
		-1,
		160,
		144,
		-1,
		-1,
		98,
		111,
		107,
		110,
		118,
		134,
		152,
		144,
		139,
		-1,
		-1,
		99,
		103,
		116,
		117,
		115,
		139,
		152,
		134,
		148,
		147,
		-1,
		87,
		105,
		114,
		123,
		129,
		115,
		113,
		131,
		133,
		139,
		142,
		-1,
		79,
		81,
		110,
		116,
		128,
		131,
		118,
		118,
		128,
		121,
		140,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		76,
		84,
		110,
		109,
		105,
		123,
		128,
		121,
		118,
		116,
		113,
		129,
		130,
		140,
		-1,
		-1,
		132,
		101,
		136,
		93,
		78,
		-1,
		72,
		91,
		97,
		101,
		106,
		111,
		125,
		121,
		-1,
		107,
		106,
		137,
		123,
		134,
		92,
		-1,
		-1,
		90,
		82,
		67,
		70,
		67,
		67,
		97,
		96,
		101,
		103,
		102,
		108,
		111,
		111,
		117,
		101,
		111,
		115,
		126,
		141,
		-1,
		-1,
		196,
		-1,
		-1,
		89,
		72,
		-1,
		55,
		62,
		62,
		79,
		69,
		90,
		105,
		109,
		117,
		116,
		104,
		106,
		103,
		116,
		104,
		98,
		123,
		127,
		121,
		142,
		137,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		48,
		51,
		57,
		81,
		91,
		-1,
		112,
		110,
		134,
		125,
		122,
		109,
		97,
		110,
		95,
		102,
		101,
		105,
		107,
		140,
		118,
		140,
		137,
		166,
		171,
		165,
		174,
		-1,
		97,
		93,
		89,
		96,
		45,
		-1,
		-1,
		85,
		-1,
		99,
		112,
		116,
		114,
		117,
		126,
		117,
		104,
		93,
		104,
		93,
		90,
		98,
		107,
		118,
		113,
		112,
		130,
		145,
		158,
		162,
		168,
		-1,
		147,
		-1,
		89,
		73,
		75,
		47,
		68,
		-1,
		105,
		100,
		120,
		118,
		109,
		-1,
		112,
		115,
		122,
		100,
		85,
		102,
		94,
		92,
		97,
		102,
		116,
		107,
		125,
		132,
		140,
		144,
		164,
		176,
		107,
		97,
		-1,
		79,
		84,
		43,
		51,
		70,
		143,
		115,
		-1,
		110,
		-1,
		102,
		127,
		-1,
		106,
		102,
		84,
		85,
		80,
		95,
		101,
		98,
		95,
		113,
		116,
		133,
		137,
		153,
		-1,
		-1,
		92,
		96,
		85,
		36,
		55,
		79,
		116,
		108,
		97,
		96,
		-1,
		87,
		117,
		114,
		100,
		87,
		77,
		78,
		86,
		99,
		78,
		97,
		100,
		122,
		150,
		128,
		140,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		62,
		33,
		57,
		99,
		126,
		119,
		107,
		72,
		72,
		66,
		-1,
		107,
		90,
		86,
		75,
		73,
		86,
		81,
		97,
		101,
		100,
		119,
		131,
		122,
		142,
		-1,
		-1,
		-1,
		92,
		81,
		82,
		28,
		51,
		88,
		105,
		91,
		96,
		71,
		64,
		58,
		110,
		107,
		74,
		82,
		74,
		63,
		77,
		85,
		89,
		98,
		107,
		113,
		137,
		137,
		143,
		-1,
		-1,
		99,
		89,
		73,
		75,
		72,
		42,
		49,
		81,
		96,
		93,
		-1,
		63,
		-1,
		52,
		60,
		59,
		65,
		77,
		63,
		68,
		79,
		91,
		104,
		100,
		107,
		142,
		142,
		127,
		147,
		150,
		-1,
		-1,
		-1,
		92,
		87,
		62,
		39,
		23,
		59,
		-1,
		63,
		64,
		-1,
		57,
		51,
		57,
		56,
		63,
		60,
		60,
		74,
		82,
		78,
		94,
		100,
		92,
		128,
		-1,
		135,
		129,
		137,
		127,
		115,
		-1,
		-1,
		-1,
		85,
		64,
		57,
		77,
		18,
		70,
		-1,
		-1,
		48,
		41,
		-1,
		44,
		44,
		51,
		60,
		65,
		70,
		78,
		73,
		86,
		91,
		97,
		102,
		120,
		124,
		128,
		117,
		113,
		110,
		124,
		-1,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		18,
		38,
		-1,
		57,
		49,
		39,
		33,
		39,
		57,
		55,
		75,
		67,
		81,
		81,
		87,
		95,
		80,
		83,
		99,
		97,
		115,
		123,
		115,
		109,
		108,
		120,
		-1,
		102,
		88,
		59,
		-1,
		-1,
		51,
		-1,
		15,
		39,
		55,
		-1,
		73,
		52,
		75,
		53,
		67,
		63,
		101,
		102,
		80,
		85,
		93,
		103,
		105,
		94,
		105,
		97,
		119,
		119,
		103,
		104,
		113,
		-1,
		108,
		95,
		53,
		48,
		37,
		53,
		12,
		21,
		42,
		-1,
		-1,
		117,
		-1,
		51,
		68,
		77,
		75,
		91,
		82,
		88,
		104,
		107,
		109,
		99,
		88,
		94,
		91,
		113,
		99,
		97,
		116,
		132,
		-1,
		-1,
		-1,
		72,
		-1,
		-1,
		21,
		6,
		8,
		-1,
		59,
		-1,
		95,
		85,
		69,
		54,
		87,
		-1,
		99,
		83,
		88,
		-1,
		134,
		-1,
		107,
		109,
		103,
		88,
		85,
		96,
		94,
		105,
		122,
		-1,
		55,
		40,
		33,
		23,
		35,
		0,
		-1,
		57,
		-1,
		-1,
		82,
		76,
		76,
		60,
		63,
		115,
		95,
		89,
		88,
		129,
		129,
		115,
		101,
		94,
		91,
		88,
		101,
		121,
		112,
		124,
		-1,
		-1,
		-1,
		60,
		50,
		44,
		16,
		23,
		-1,
		-1,
		144,
		99,
		85,
		-1,
		69,
		132,
		120,
		110,
		100,
		134,
		135,
		120,
		113,
		99,
		101,
		99,
		97,
		102,
		123,
		124,
		137,
		-1,
		-1,
		49,
		42,
		30,
		16,
		35,
		-1,
		-1,
		-1,
		91,
		107,
		99,
		70,
		121,
		-1,
		-1,
		112,
		110,
		120,
		116,
		103,
		123,
		126,
		112,
		96,
		111,
		123,
		131,
		136,
		-1,
		52,
		39,
		-1,
		-1,
		38,
		32,
		-1,
		-1,
		-1,
		-1,
		124,
		90,
		102,
		123,
		148,
		115,
		-1,
		120,
		121,
		107,
		121,
		128,
		114,
		109,
		103,
		106,
		124,
		141,
		-1,
		-1,
		52,
		-1,
		47,
		-1,
		-1,
		-1,
		-1,
		81,
		95,
		116,
		122,
		134,
		-1,
		129,
		123,
		109,
		126,
		127,
		124,
		115,
		107,
		112,
		109,
		122,
		136,
		140,
		75,
		-1,
		58,
		-1,
		-1,
		-1,
		99,
		114,
		176,
		153,
		126,
		130,
		123,
		117,
		117,
		133,
		135,
		146,
		114,
		110,
		111,
		115,
		114,
		131,
		141,
		-1,
		-1,
		58,
		75,
		110,
		107,
		111,
		203,
		-1,
		-1,
		139,
		130,
		121,
		124,
		127,
		130,
		120,
		117,
		122,
		127,
		115,
		124,
		142,
		146,
		-1,
		-1,
		-1,
		78,
		-1,
		93,
		-1,
		-1,
		126,
		210,
		157,
		139,
		135,
		133,
		126,
		135,
		130,
		125,
		135,
		144,
		136,
		117,
		128,
		151,
		140,
		178,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		107,
		82,
		97,
		143,
		146,
		139,
		172,
		169,
		-1,
		139,
		164,
		136,
		143,
		135,
		143,
		143,
		140,
		118,
		125,
		141,
		140,
		135,
		170,
		162,
		168,
		-1,
		-1,
		202,
		191,
		180,
		186,
		-1,
		113,
		99,
		129,
		119,
		125,
		-1,
		-1,
		172,
		169,
		161,
		145,
		149,
		142,
		137,
		147,
		127,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		97,
		178,
		171,
		154,
		162,
		193,
		-1,
		116,
		125,
		106,
		111,
		119,
		-1,
		-1,
		145,
		141,
		146,
		152,
		149,
		157,
		152,
		143,
		128,
		134,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		111,
		154,
		148,
		151,
		175,
		189,
		-1,
		129,
		-1,
		-1,
		114,
		132,
		140,
		136,
		140,
		193,
		166,
		161,
		151,
		149,
		140,
		131,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		146,
		134,
		142,
		-1,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		130,
		-1,
		166,
		-1,
		159,
		163,
		174,
		177,
		165,
		152,
		144,
		136,
		152,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		220,
		175,
		142,
		133,
		180,
		195,
		199,
		-1,
		142,
		181,
		168,
		-1,
		139,
		-1,
		-1,
		-1,
		173,
		187,
		179,
		185,
		164,
		164,
		138,
		142,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		216,
		214,
		219,
		164,
		147,
		165,
		174,
		195,
		157,
		148,
		175,
		175,
		164,
		159,
		146,
		-1,
		-1,
		196,
		197,
		-1,
		-1,
		171,
		159,
		142,
		143,
		139,
		142,
		157,
		160,
		150,
		148,
		142,
		174,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		155,
		166,
		-1,
		-1,
		160,
		176,
		189,
		193,
		206,
		231,
		-1,
		149,
		-1,
		-1,
		216,
		-1,
		-1,
		201,
		164,
		153,
		144,
		150,
		147,
		158,
		168,
		156,
		157,
		147,
		157,
		170,
		200,
		197,
		185,
		183,
		206,
		163,
		159,
		-1,
		175,
		163,
		169,
		176,
		193,
		220,
		-1,
		-1,
		165,
		156,
		-1,
		-1,
		199,
		197,
		186,
		-1,
		176,
		149,
		154,
		174,
		176,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		178,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		200,
		175,
		-1,
		-1,
		194,
		187,
		175,
		163,
		153,
		163,
		167,
		171,
		163,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		243,
		-1,
		195,
		184,
		203,
		218,
		226,
		-1,
		-1,
		-1,
		217,
		203,
		196,
		184,
		182,
		-1,
		228,
		212,
		193,
		-1,
		163,
		176,
		207,
		175,
		180,
		175,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		201,
		204,
		-1,
		-1,
		226,
		245,
		-1,
		208,
		197,
		182,
		174,
		-1,
		-1,
		200,
		196,
		-1,
		-1,
		164,
		189,
		178,
		186,
		181,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		208,
		209,
		214,
		-1,
		229,
		-1,
		232,
		-1,
		177,
		193,
		195,
		-1,
		-1,
		-1,
		202,
		165,
		186,
		196,
		190,
		188,
		179,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		247,
		221,
		239,
		230,
		213,
		193,
		185,
		210,
		-1,
		189,
		-1,
		164,
		166,
		192,
		195,
		201,
		195,
		168,
		183,
		173,
		164,
		173,
		253,
		-1,
		223,
		256,
		220,
		199,
		190,
		194,
		210,
		-1,
		186,
		168,
		-1,
		196,
		186,
		217,
		202,
		183,
		170,
		177,
		177,
		170,
		-1,
		-1,
		-1,
		225,
		224,
		216,
		210,
		210,
		195,
		186,
		-1,
		198,
		180,
		159,
		176,
		176,
		167,
		175,
		207,
		203,
		190,
		190,
		182,
		-1,
		315,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		219,
		214,
		187,
		175,
		181,
		177,
		163,
		169,
		171,
		179,
		177,
		174,
		186,
		182,
		202,
		183,
		218,
		-1,
		321,
		-1,
		255,
		-1,
		-1,
		237,
		217,
		209,
		198,
		187,
		185,
		176,
		167,
		189,
		205,
		189,
		187,
		190,
		191,
		-1,
		310,
		309,
		-1,
		256,
		248,
		234,
		-1,
		227,
		-1,
		233,
		194,
		-1,
		196,
		176,
		-1,
		198,
		194,
		-1,
		-1,
		297,
		272,
		-1,
		-1,
		-1,
		257,
		237,
		228,
		212,
		-1,
		187,
		187,
		-1,
		-1,
		-1,
		282,
		281,
		-1,
		250,
		253,
		-1,
		243,
		234,
		242,
		189,
		193,
		-1,
		-1,
		-1,
		291,
		272,
		266,
		265,
		263,
		258,
		255,
		241,
		225,
		203,
		192,
		213,
		-1,
		-1,
		-1,
		263,
		255,
		248,
		-1,
		-1,
		250,
		233,
		214,
		212,
		-1,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		240,
		-1,
		-1,
		246,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		274,
		-1,
		-1,
		-1,
		236,
		232,
		233,
		-1,
		-1,
		-1,
		-1,
		296,
		297,
		320,
		284,
		-1,
		-1,
		-1,
		228,
		222,
		-1,
		-1,
		299,
		297,
		-1,
		-1,
		-1,
		256,
		240,
		-1,
		226,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		261,
		-1,
		261,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		274,
		266,
		274,
		-1,
		246,
		248,
		-1,
		296,
		-1,
		-1,
		289,
		280,
		-1,
		-1,
		251,
		258,
		280,
		283,
		319,
		-1,
		270
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		201,
		190,
		201,
		209,
		182,
		189,
		-1,
		210,
		212,
		178,
		172,
		211,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		201,
		200,
		170,
		168,
		177,
		182,
		189,
		-1,
		212,
		-1,
		222,
		201,
		212,
		217,
		163,
		160,
		180,
		199,
		205,
		197,
		237,
		193,
		164,
		158,
		176,
		181,
		199,
		191,
		-1,
		164,
		154,
		176,
		180,
		192,
		175,
		-1,
		-1,
		158,
		159,
		165,
		177,
		182,
		187,
		-1,
		210,
		194,
		-1,
		-1,
		148,
		161,
		157,
		160,
		168,
		184,
		202,
		194,
		189,
		-1,
		-1,
		149,
		153,
		166,
		167,
		165,
		189,
		202,
		184,
		198,
		197,
		-1,
		137,
		155,
		164,
		173,
		179,
		165,
		163,
		181,
		183,
		189,
		192,
		-1,
		129,
		131,
		160,
		166,
		178,
		181,
		168,
		168,
		178,
		171,
		190,
		181,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		134,
		160,
		159,
		155,
		173,
		178,
		171,
		168,
		166,
		163,
		179,
		180,
		190,
		-1,
		-1,
		182,
		151,
		186,
		143,
		128,
		-1,
		122,
		141,
		147,
		151,
		156,
		161,
		175,
		171,
		-1,
		157,
		156,
		187,
		173,
		184,
		142,
		-1,
		-1,
		140,
		132,
		117,
		120,
		117,
		117,
		147,
		146,
		151,
		153,
		152,
		158,
		161,
		161,
		167,
		151,
		161,
		165,
		176,
		191,
		-1,
		-1,
		246,
		-1,
		-1,
		139,
		122,
		-1,
		105,
		112,
		112,
		129,
		119,
		140,
		155,
		159,
		167,
		166,
		154,
		156,
		153,
		166,
		154,
		148,
		173,
		177,
		171,
		192,
		187,
		-1,
		245,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		98,
		101,
		107,
		131,
		141,
		-1,
		162,
		160,
		184,
		175,
		172,
		159,
		147,
		160,
		145,
		152,
		151,
		155,
		157,
		190,
		168,
		190,
		187,
		216,
		221,
		215,
		224,
		-1,
		147,
		143,
		139,
		146,
		95,
		-1,
		-1,
		135,
		-1,
		149,
		162,
		166,
		164,
		167,
		176,
		167,
		154,
		143,
		154,
		143,
		140,
		148,
		157,
		168,
		163,
		162,
		180,
		195,
		208,
		212,
		218,
		-1,
		197,
		-1,
		139,
		123,
		125,
		97,
		118,
		-1,
		155,
		150,
		170,
		168,
		159,
		-1,
		162,
		165,
		172,
		150,
		135,
		152,
		144,
		142,
		147,
		152,
		166,
		157,
		175,
		182,
		190,
		194,
		214,
		226,
		157,
		147,
		-1,
		129,
		134,
		93,
		101,
		120,
		193,
		165,
		-1,
		160,
		-1,
		152,
		177,
		-1,
		156,
		152,
		134,
		135,
		130,
		145,
		151,
		148,
		145,
		163,
		166,
		183,
		187,
		203,
		-1,
		-1,
		142,
		146,
		135,
		86,
		105,
		129,
		166,
		158,
		147,
		146,
		-1,
		137,
		167,
		164,
		150,
		137,
		127,
		128,
		136,
		149,
		128,
		147,
		150,
		172,
		200,
		178,
		190,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		112,
		83,
		107,
		149,
		176,
		169,
		157,
		122,
		122,
		116,
		-1,
		157,
		140,
		136,
		125,
		123,
		136,
		131,
		147,
		151,
		150,
		169,
		181,
		172,
		192,
		-1,
		-1,
		-1,
		142,
		131,
		132,
		78,
		101,
		138,
		155,
		141,
		146,
		121,
		114,
		108,
		160,
		157,
		124,
		132,
		124,
		113,
		127,
		135,
		139,
		148,
		157,
		163,
		187,
		187,
		193,
		-1,
		-1,
		149,
		139,
		123,
		125,
		122,
		92,
		99,
		131,
		146,
		143,
		-1,
		113,
		-1,
		102,
		110,
		109,
		115,
		127,
		113,
		118,
		129,
		141,
		154,
		150,
		157,
		192,
		192,
		177,
		197,
		200,
		-1,
		-1,
		-1,
		142,
		137,
		112,
		89,
		73,
		109,
		-1,
		113,
		114,
		-1,
		107,
		101,
		107,
		106,
		113,
		110,
		110,
		124,
		132,
		128,
		144,
		150,
		142,
		178,
		-1,
		185,
		179,
		187,
		177,
		165,
		-1,
		-1,
		-1,
		135,
		114,
		107,
		127,
		68,
		120,
		-1,
		-1,
		98,
		91,
		-1,
		94,
		94,
		101,
		110,
		115,
		120,
		128,
		123,
		136,
		141,
		147,
		152,
		170,
		174,
		178,
		167,
		163,
		160,
		174,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		68,
		88,
		-1,
		104,
		96,
		89,
		83,
		89,
		107,
		105,
		125,
		117,
		131,
		131,
		137,
		145,
		130,
		133,
		149,
		147,
		165,
		173,
		165,
		159,
		158,
		170,
		-1,
		155,
		141,
		112,
		-1,
		-1,
		101,
		-1,
		65,
		82,
		98,
		-1,
		123,
		102,
		125,
		103,
		117,
		113,
		151,
		152,
		130,
		135,
		143,
		153,
		155,
		144,
		155,
		147,
		169,
		169,
		153,
		154,
		163,
		-1,
		161,
		148,
		106,
		102,
		91,
		111,
		62,
		71,
		85,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		127,
		125,
		141,
		132,
		138,
		154,
		157,
		159,
		149,
		138,
		144,
		141,
		163,
		149,
		147,
		166,
		182,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		77,
		64,
		58,
		-1,
		102,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		149,
		133,
		138,
		-1,
		184,
		-1,
		157,
		159,
		153,
		138,
		135,
		146,
		144,
		155,
		172,
		-1,
		111,
		96,
		89,
		79,
		93,
		59,
		-1,
		0,
		-1,
		-1,
		132,
		126,
		126,
		110,
		113,
		165,
		145,
		139,
		138,
		179,
		179,
		165,
		151,
		144,
		141,
		138,
		151,
		171,
		162,
		174,
		-1,
		-1,
		-1,
		116,
		89,
		83,
		55,
		34,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		119,
		182,
		170,
		160,
		150,
		184,
		185,
		170,
		163,
		149,
		151,
		149,
		147,
		152,
		173,
		174,
		187,
		-1,
		-1,
		88,
		81,
		69,
		52,
		71,
		-1,
		-1,
		-1,
		141,
		157,
		149,
		120,
		171,
		-1,
		-1,
		162,
		160,
		170,
		166,
		153,
		173,
		176,
		162,
		146,
		161,
		173,
		181,
		186,
		-1,
		91,
		78,
		-1,
		-1,
		74,
		68,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		152,
		173,
		198,
		165,
		-1,
		170,
		171,
		157,
		171,
		178,
		164,
		159,
		153,
		156,
		174,
		191,
		-1,
		-1,
		88,
		-1,
		83,
		-1,
		-1,
		-1,
		-1,
		131,
		145,
		166,
		172,
		184,
		-1,
		179,
		173,
		159,
		176,
		177,
		174,
		165,
		157,
		162,
		159,
		172,
		186,
		190,
		111,
		-1,
		94,
		-1,
		-1,
		-1,
		149,
		164,
		226,
		203,
		176,
		180,
		173,
		167,
		167,
		183,
		185,
		196,
		164,
		160,
		161,
		165,
		164,
		181,
		191,
		-1,
		-1,
		94,
		111,
		146,
		157,
		161,
		253,
		-1,
		-1,
		189,
		180,
		171,
		174,
		177,
		180,
		170,
		167,
		172,
		177,
		165,
		174,
		192,
		196,
		-1,
		-1,
		-1,
		114,
		-1,
		129,
		-1,
		-1,
		176,
		260,
		207,
		189,
		185,
		183,
		176,
		185,
		180,
		175,
		185,
		194,
		186,
		167,
		178,
		201,
		190,
		228,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		143,
		118,
		133,
		179,
		184,
		175,
		222,
		219,
		-1,
		189,
		214,
		186,
		193,
		185,
		193,
		193,
		190,
		168,
		175,
		191,
		190,
		185,
		220,
		212,
		218,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		149,
		135,
		165,
		155,
		161,
		-1,
		-1,
		208,
		205,
		208,
		195,
		199,
		192,
		187,
		197,
		177,
		164,
		168,
		172,
		178,
		183,
		188,
		194,
		209,
		224,
		-1,
		136,
		217,
		210,
		193,
		201,
		232,
		-1,
		152,
		161,
		142,
		147,
		155,
		-1,
		-1,
		181,
		177,
		182,
		191,
		194,
		207,
		202,
		193,
		178,
		184,
		171,
		170,
		188,
		192,
		201,
		208,
		198,
		211,
		215,
		-1,
		150,
		193,
		187,
		190,
		214,
		228,
		-1,
		165,
		-1,
		-1,
		150,
		168,
		176,
		172,
		176,
		229,
		205,
		200,
		201,
		199,
		190,
		181,
		188,
		179,
		179,
		182,
		197,
		202,
		194,
		208,
		208,
		209,
		-1,
		185,
		173,
		181,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		166,
		-1,
		202,
		-1,
		195,
		199,
		213,
		216,
		215,
		202,
		194,
		186,
		202,
		177,
		187,
		183,
		184,
		193,
		204,
		216,
		215,
		216,
		259,
		214,
		181,
		172,
		219,
		234,
		238,
		-1,
		178,
		217,
		204,
		-1,
		175,
		-1,
		-1,
		-1,
		209,
		226,
		218,
		234,
		214,
		214,
		188,
		192,
		182,
		189,
		199,
		201,
		193,
		197,
		210,
		221,
		224,
		255,
		253,
		258,
		203,
		186,
		204,
		213,
		234,
		193,
		184,
		211,
		211,
		200,
		195,
		182,
		-1,
		-1,
		232,
		236,
		-1,
		-1,
		221,
		209,
		192,
		193,
		189,
		192,
		207,
		210,
		200,
		198,
		192,
		224,
		-1,
		255,
		254,
		243,
		240,
		216,
		207,
		194,
		205,
		-1,
		-1,
		196,
		212,
		225,
		229,
		242,
		267,
		-1,
		185,
		-1,
		-1,
		253,
		-1,
		-1,
		251,
		214,
		203,
		194,
		200,
		197,
		208,
		218,
		206,
		207,
		197,
		207,
		220,
		239,
		236,
		224,
		222,
		245,
		202,
		198,
		-1,
		211,
		199,
		205,
		212,
		229,
		256,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		249,
		247,
		236,
		-1,
		226,
		199,
		204,
		224,
		226,
		215,
		209,
		203,
		210,
		209,
		217,
		225,
		248,
		262,
		251,
		247,
		246,
		254,
		203,
		214,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		236,
		211,
		-1,
		-1,
		244,
		237,
		225,
		213,
		203,
		213,
		217,
		221,
		213,
		206,
		201,
		212,
		204,
		208,
		225,
		-1,
		282,
		-1,
		234,
		220,
		240,
		255,
		263,
		-1,
		-1,
		-1,
		253,
		239,
		232,
		220,
		218,
		-1,
		278,
		262,
		243,
		-1,
		213,
		226,
		257,
		225,
		230,
		225,
		207,
		218,
		207,
		210,
		224,
		219,
		-1,
		-1,
		238,
		241,
		-1,
		-1,
		265,
		284,
		-1,
		244,
		233,
		218,
		210,
		-1,
		-1,
		250,
		246,
		-1,
		-1,
		214,
		239,
		228,
		236,
		231,
		211,
		217,
		220,
		209,
		213,
		225,
		-1,
		-1,
		245,
		248,
		253,
		-1,
		274,
		-1,
		268,
		-1,
		213,
		229,
		231,
		-1,
		-1,
		-1,
		252,
		215,
		236,
		246,
		240,
		238,
		229,
		215,
		222,
		220,
		216,
		227,
		-1,
		-1,
		-1,
		294,
		268,
		275,
		266,
		249,
		229,
		221,
		246,
		-1,
		239,
		-1,
		214,
		216,
		242,
		245,
		251,
		245,
		218,
		233,
		223,
		214,
		223,
		300,
		-1,
		270,
		303,
		267,
		235,
		235,
		234,
		260,
		-1,
		236,
		218,
		-1,
		246,
		236,
		267,
		252,
		233,
		220,
		227,
		227,
		220,
		-1,
		-1,
		-1,
		272,
		271,
		263,
		257,
		255,
		240,
		235,
		-1,
		248,
		230,
		209,
		226,
		226,
		217,
		225,
		257,
		253,
		240,
		240,
		232,
		-1,
		354,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		266,
		264,
		237,
		225,
		231,
		227,
		213,
		219,
		221,
		229,
		227,
		224,
		236,
		232,
		252,
		233,
		268,
		-1,
		361,
		-1,
		302,
		-1,
		-1,
		282,
		267,
		259,
		248,
		237,
		235,
		226,
		217,
		239,
		255,
		239,
		237,
		240,
		241,
		-1,
		360,
		359,
		-1,
		301,
		293,
		279,
		-1,
		272,
		-1,
		283,
		244,
		-1,
		246,
		226,
		-1,
		248,
		244,
		-1,
		-1,
		347,
		317,
		-1,
		-1,
		-1,
		302,
		282,
		278,
		262,
		-1,
		237,
		237,
		-1,
		-1,
		-1,
		332,
		326,
		-1,
		295,
		298,
		-1,
		289,
		284,
		292,
		239,
		243,
		-1,
		-1,
		-1,
		341,
		322,
		316,
		310,
		313,
		303,
		305,
		291,
		275,
		253,
		242,
		263,
		-1,
		-1,
		-1,
		313,
		305,
		298,
		-1,
		-1,
		300,
		283,
		264,
		262,
		-1,
		-1,
		-1,
		335,
		316,
		-1,
		-1,
		290,
		-1,
		-1,
		296,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		352,
		324,
		-1,
		-1,
		-1,
		286,
		282,
		283,
		-1,
		-1,
		-1,
		-1,
		346,
		347,
		370,
		334,
		-1,
		-1,
		-1,
		278,
		272,
		-1,
		-1,
		349,
		347,
		-1,
		-1,
		-1,
		306,
		290,
		-1,
		276,
		-1,
		-1,
		-1,
		297,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		311,
		-1,
		311,
		286,
		293,
		-1,
		-1,
		-1,
		-1,
		324,
		316,
		324,
		-1,
		296,
		298,
		-1,
		346,
		-1,
		-1,
		339,
		330,
		-1,
		-1,
		301,
		308,
		330,
		333,
		369,
		-1,
		320
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		212,
		201,
		212,
		220,
		193,
		200,
		-1,
		221,
		223,
		189,
		183,
		222,
		193,
		199,
		210,
		-1,
		-1,
		-1,
		212,
		211,
		181,
		179,
		188,
		193,
		200,
		-1,
		204,
		-1,
		233,
		212,
		223,
		228,
		174,
		171,
		191,
		210,
		197,
		189,
		248,
		204,
		175,
		169,
		187,
		182,
		191,
		183,
		-1,
		175,
		165,
		187,
		171,
		182,
		174,
		-1,
		-1,
		169,
		170,
		176,
		167,
		173,
		169,
		-1,
		179,
		163,
		-1,
		-1,
		159,
		165,
		149,
		152,
		160,
		158,
		171,
		163,
		158,
		-1,
		-1,
		155,
		151,
		158,
		145,
		141,
		158,
		171,
		153,
		167,
		166,
		-1,
		148,
		166,
		175,
		152,
		150,
		134,
		132,
		150,
		152,
		158,
		161,
		-1,
		141,
		143,
		153,
		161,
		166,
		150,
		137,
		137,
		147,
		140,
		159,
		150,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		138,
		140,
		157,
		149,
		139,
		154,
		147,
		140,
		137,
		135,
		132,
		148,
		149,
		159,
		-1,
		-1,
		194,
		163,
		198,
		155,
		140,
		-1,
		134,
		133,
		139,
		143,
		137,
		130,
		144,
		140,
		-1,
		126,
		125,
		156,
		142,
		153,
		154,
		-1,
		-1,
		152,
		144,
		129,
		132,
		129,
		129,
		148,
		147,
		139,
		125,
		121,
		127,
		130,
		130,
		136,
		120,
		130,
		134,
		145,
		160,
		-1,
		-1,
		215,
		-1,
		-1,
		151,
		134,
		-1,
		117,
		124,
		124,
		141,
		131,
		152,
		158,
		149,
		141,
		135,
		123,
		125,
		122,
		135,
		123,
		117,
		142,
		146,
		140,
		161,
		156,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		110,
		113,
		119,
		143,
		153,
		-1,
		143,
		149,
		159,
		144,
		141,
		128,
		116,
		129,
		114,
		121,
		120,
		124,
		126,
		159,
		137,
		159,
		156,
		185,
		190,
		184,
		193,
		-1,
		159,
		155,
		151,
		158,
		107,
		-1,
		-1,
		147,
		-1,
		161,
		160,
		135,
		153,
		156,
		145,
		136,
		123,
		112,
		123,
		112,
		109,
		117,
		126,
		137,
		132,
		131,
		149,
		164,
		177,
		181,
		187,
		-1,
		209,
		-1,
		151,
		135,
		137,
		109,
		130,
		-1,
		167,
		162,
		152,
		137,
		128,
		-1,
		131,
		134,
		141,
		119,
		104,
		121,
		113,
		111,
		116,
		121,
		135,
		126,
		144,
		151,
		159,
		163,
		183,
		195,
		169,
		159,
		-1,
		141,
		146,
		105,
		113,
		132,
		170,
		134,
		-1,
		129,
		-1,
		121,
		146,
		-1,
		125,
		121,
		103,
		104,
		99,
		114,
		120,
		117,
		114,
		132,
		135,
		152,
		156,
		172,
		-1,
		-1,
		154,
		158,
		147,
		98,
		117,
		141,
		178,
		127,
		116,
		115,
		-1,
		106,
		136,
		133,
		119,
		106,
		96,
		97,
		105,
		118,
		97,
		116,
		119,
		141,
		169,
		147,
		159,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		124,
		95,
		119,
		161,
		145,
		138,
		126,
		91,
		91,
		85,
		-1,
		126,
		109,
		105,
		94,
		92,
		105,
		100,
		116,
		120,
		119,
		138,
		150,
		141,
		161,
		-1,
		-1,
		-1,
		154,
		143,
		144,
		90,
		113,
		150,
		124,
		110,
		115,
		90,
		83,
		77,
		129,
		126,
		93,
		101,
		93,
		82,
		96,
		104,
		108,
		117,
		126,
		132,
		156,
		156,
		162,
		-1,
		-1,
		161,
		151,
		135,
		137,
		134,
		104,
		111,
		143,
		115,
		128,
		-1,
		82,
		-1,
		71,
		79,
		78,
		84,
		96,
		82,
		87,
		98,
		110,
		123,
		119,
		126,
		161,
		161,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		154,
		149,
		124,
		101,
		85,
		121,
		-1,
		98,
		99,
		-1,
		76,
		70,
		76,
		75,
		82,
		79,
		79,
		93,
		101,
		97,
		113,
		119,
		111,
		147,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		147,
		126,
		119,
		139,
		80,
		132,
		-1,
		-1,
		83,
		76,
		-1,
		63,
		63,
		70,
		79,
		84,
		89,
		97,
		92,
		105,
		110,
		116,
		121,
		139,
		143,
		147,
		136,
		132,
		129,
		143,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		100,
		-1,
		92,
		84,
		74,
		68,
		62,
		65,
		67,
		94,
		86,
		100,
		100,
		106,
		114,
		99,
		102,
		118,
		116,
		134,
		142,
		134,
		128,
		127,
		139,
		-1,
		167,
		153,
		124,
		-1,
		-1,
		113,
		-1,
		77,
		91,
		107,
		-1,
		100,
		79,
		94,
		72,
		68,
		82,
		120,
		121,
		99,
		104,
		112,
		122,
		124,
		113,
		124,
		116,
		138,
		138,
		122,
		123,
		132,
		-1,
		173,
		160,
		118,
		114,
		103,
		123,
		74,
		62,
		94,
		-1,
		-1,
		35,
		-1,
		46,
		48,
		96,
		94,
		110,
		101,
		107,
		123,
		126,
		128,
		118,
		107,
		113,
		110,
		132,
		118,
		116,
		135,
		151,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		89,
		76,
		70,
		-1,
		111,
		-1,
		13,
		23,
		19,
		35,
		67,
		-1,
		118,
		102,
		107,
		-1,
		153,
		-1,
		126,
		128,
		122,
		107,
		104,
		115,
		113,
		124,
		141,
		-1,
		123,
		108,
		101,
		91,
		105,
		76,
		-1,
		131,
		-1,
		-1,
		0,
		5,
		14,
		41,
		44,
		134,
		114,
		108,
		107,
		148,
		148,
		134,
		120,
		113,
		110,
		107,
		120,
		140,
		131,
		143,
		-1,
		-1,
		-1,
		128,
		114,
		118,
		78,
		97,
		-1,
		-1,
		82,
		37,
		23,
		-1,
		50,
		151,
		139,
		129,
		119,
		153,
		154,
		139,
		132,
		118,
		120,
		118,
		116,
		121,
		142,
		143,
		156,
		-1,
		-1,
		111,
		116,
		104,
		90,
		109,
		-1,
		-1,
		-1,
		31,
		47,
		80,
		51,
		140,
		-1,
		-1,
		131,
		129,
		139,
		135,
		122,
		142,
		145,
		131,
		115,
		130,
		142,
		150,
		155,
		-1,
		114,
		101,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		-1,
		-1,
		70,
		71,
		83,
		104,
		129,
		134,
		-1,
		139,
		140,
		126,
		140,
		147,
		133,
		128,
		122,
		125,
		143,
		160,
		-1,
		-1,
		126,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		62,
		76,
		97,
		103,
		115,
		-1,
		141,
		142,
		128,
		145,
		146,
		143,
		134,
		126,
		131,
		128,
		141,
		155,
		159,
		149,
		-1,
		132,
		-1,
		-1,
		-1,
		80,
		95,
		157,
		134,
		107,
		112,
		122,
		127,
		132,
		152,
		154,
		165,
		133,
		129,
		130,
		134,
		133,
		150,
		160,
		-1,
		-1,
		132,
		141,
		106,
		88,
		92,
		184,
		-1,
		-1,
		122,
		128,
		124,
		134,
		142,
		145,
		139,
		136,
		141,
		146,
		134,
		143,
		161,
		165,
		-1,
		-1,
		-1,
		152,
		-1,
		139,
		-1,
		-1,
		107,
		208,
		155,
		137,
		133,
		131,
		136,
		145,
		140,
		144,
		154,
		163,
		155,
		136,
		147,
		170,
		159,
		197,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		181,
		156,
		171,
		192,
		127,
		134,
		170,
		167,
		-1,
		137,
		174,
		146,
		153,
		145,
		158,
		162,
		159,
		137,
		144,
		160,
		159,
		154,
		189,
		181,
		187,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		187,
		173,
		178,
		168,
		144,
		-1,
		-1,
		186,
		183,
		161,
		155,
		159,
		152,
		147,
		166,
		146,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		159,
		240,
		233,
		216,
		224,
		255,
		-1,
		186,
		178,
		180,
		164,
		155,
		-1,
		-1,
		159,
		156,
		161,
		162,
		159,
		171,
		170,
		162,
		147,
		153,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		173,
		216,
		210,
		213,
		237,
		251,
		-1,
		183,
		-1,
		-1,
		188,
		168,
		174,
		164,
		158,
		208,
		176,
		171,
		170,
		168,
		159,
		150,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		208,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		204,
		-1,
		201,
		-1,
		176,
		180,
		184,
		187,
		184,
		171,
		163,
		155,
		171,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		278,
		234,
		204,
		195,
		242,
		257,
		261,
		-1,
		195,
		234,
		242,
		-1,
		213,
		-1,
		-1,
		-1,
		190,
		197,
		189,
		204,
		183,
		183,
		157,
		161,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		274,
		265,
		278,
		223,
		209,
		227,
		236,
		257,
		210,
		201,
		228,
		249,
		238,
		233,
		220,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		190,
		178,
		161,
		162,
		158,
		161,
		176,
		179,
		169,
		167,
		161,
		193,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		214,
		228,
		-1,
		-1,
		213,
		229,
		242,
		246,
		262,
		287,
		-1,
		223,
		-1,
		-1,
		234,
		-1,
		-1,
		220,
		183,
		172,
		163,
		169,
		166,
		177,
		187,
		175,
		176,
		166,
		176,
		189,
		251,
		248,
		236,
		234,
		257,
		222,
		210,
		-1,
		223,
		216,
		222,
		229,
		246,
		276,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		218,
		216,
		205,
		-1,
		195,
		168,
		173,
		193,
		195,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		208,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		-1,
		256,
		249,
		-1,
		-1,
		213,
		206,
		194,
		182,
		172,
		182,
		186,
		190,
		182,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		294,
		-1,
		246,
		222,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		273,
		259,
		252,
		240,
		238,
		-1,
		247,
		231,
		212,
		-1,
		182,
		195,
		226,
		194,
		199,
		194,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		234,
		237,
		-1,
		-1,
		259,
		265,
		-1,
		264,
		253,
		238,
		230,
		-1,
		-1,
		219,
		215,
		-1,
		-1,
		183,
		208,
		197,
		205,
		200,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		241,
		242,
		247,
		-1,
		248,
		-1,
		266,
		-1,
		233,
		239,
		227,
		-1,
		-1,
		-1,
		221,
		184,
		205,
		215,
		209,
		207,
		198,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		266,
		240,
		273,
		264,
		247,
		227,
		219,
		238,
		-1,
		208,
		-1,
		183,
		185,
		211,
		214,
		220,
		214,
		187,
		202,
		192,
		183,
		192,
		272,
		-1,
		242,
		275,
		239,
		233,
		209,
		213,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		236,
		221,
		202,
		189,
		196,
		196,
		189,
		-1,
		-1,
		-1,
		244,
		243,
		235,
		229,
		229,
		214,
		205,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		226,
		222,
		209,
		209,
		201,
		-1,
		345,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		238,
		233,
		206,
		194,
		200,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		202,
		237,
		-1,
		340,
		-1,
		274,
		-1,
		-1,
		256,
		236,
		228,
		217,
		206,
		204,
		195,
		186,
		208,
		224,
		208,
		206,
		209,
		210,
		-1,
		329,
		328,
		-1,
		275,
		267,
		253,
		-1,
		246,
		-1,
		252,
		213,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		316,
		291,
		-1,
		-1,
		-1,
		276,
		256,
		247,
		231,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		301,
		300,
		-1,
		269,
		272,
		-1,
		262,
		253,
		261,
		208,
		212,
		-1,
		-1,
		-1,
		310,
		291,
		285,
		284,
		282,
		277,
		274,
		260,
		244,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		282,
		274,
		267,
		-1,
		-1,
		269,
		252,
		233,
		231,
		-1,
		-1,
		-1,
		304,
		285,
		-1,
		-1,
		259,
		-1,
		-1,
		265,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		321,
		293,
		-1,
		-1,
		-1,
		255,
		251,
		252,
		-1,
		-1,
		-1,
		-1,
		315,
		316,
		339,
		303,
		-1,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		318,
		316,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		245,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		280,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		293,
		285,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		308,
		299,
		-1,
		-1,
		270,
		277,
		299,
		302,
		338,
		-1,
		289
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		216,
		218,
		184,
		178,
		217,
		188,
		194,
		205,
		-1,
		-1,
		-1,
		207,
		206,
		176,
		174,
		183,
		188,
		195,
		-1,
		199,
		-1,
		228,
		207,
		218,
		223,
		169,
		166,
		186,
		205,
		192,
		184,
		243,
		199,
		170,
		164,
		182,
		177,
		186,
		178,
		-1,
		170,
		160,
		182,
		166,
		177,
		169,
		-1,
		-1,
		164,
		165,
		171,
		162,
		168,
		164,
		-1,
		174,
		158,
		-1,
		-1,
		154,
		160,
		144,
		147,
		155,
		153,
		166,
		158,
		153,
		-1,
		-1,
		150,
		146,
		153,
		140,
		136,
		153,
		166,
		148,
		162,
		161,
		-1,
		143,
		161,
		170,
		147,
		145,
		129,
		127,
		145,
		147,
		153,
		156,
		-1,
		136,
		138,
		148,
		156,
		161,
		145,
		132,
		132,
		142,
		135,
		154,
		145,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		135,
		152,
		144,
		134,
		149,
		142,
		135,
		132,
		130,
		127,
		143,
		144,
		154,
		-1,
		-1,
		189,
		158,
		193,
		150,
		135,
		-1,
		129,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		121,
		120,
		151,
		137,
		148,
		149,
		-1,
		-1,
		147,
		139,
		124,
		127,
		124,
		124,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		115,
		125,
		129,
		140,
		155,
		-1,
		-1,
		210,
		-1,
		-1,
		146,
		129,
		-1,
		112,
		119,
		119,
		136,
		126,
		147,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		112,
		137,
		141,
		135,
		156,
		151,
		-1,
		209,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		105,
		108,
		114,
		138,
		148,
		-1,
		138,
		144,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		119,
		121,
		154,
		132,
		154,
		151,
		180,
		185,
		179,
		188,
		-1,
		154,
		150,
		146,
		153,
		102,
		-1,
		-1,
		142,
		-1,
		156,
		155,
		130,
		148,
		151,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		121,
		132,
		127,
		126,
		144,
		159,
		172,
		176,
		182,
		-1,
		204,
		-1,
		146,
		130,
		132,
		104,
		125,
		-1,
		162,
		157,
		147,
		132,
		123,
		-1,
		126,
		129,
		136,
		114,
		99,
		116,
		108,
		106,
		111,
		116,
		130,
		121,
		139,
		146,
		154,
		158,
		178,
		190,
		164,
		154,
		-1,
		136,
		141,
		100,
		108,
		127,
		165,
		129,
		-1,
		124,
		-1,
		116,
		141,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		115,
		112,
		109,
		127,
		130,
		147,
		151,
		167,
		-1,
		-1,
		149,
		153,
		142,
		93,
		112,
		136,
		173,
		122,
		111,
		110,
		-1,
		101,
		131,
		128,
		114,
		101,
		91,
		92,
		100,
		113,
		92,
		111,
		114,
		136,
		164,
		142,
		154,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		119,
		90,
		114,
		156,
		140,
		133,
		121,
		86,
		86,
		80,
		-1,
		121,
		104,
		100,
		89,
		87,
		100,
		95,
		111,
		115,
		114,
		133,
		145,
		136,
		156,
		-1,
		-1,
		-1,
		149,
		138,
		139,
		85,
		108,
		145,
		119,
		105,
		110,
		85,
		78,
		72,
		124,
		121,
		88,
		96,
		88,
		77,
		91,
		99,
		103,
		112,
		121,
		127,
		151,
		151,
		157,
		-1,
		-1,
		156,
		146,
		130,
		132,
		129,
		99,
		106,
		138,
		110,
		123,
		-1,
		77,
		-1,
		66,
		74,
		73,
		79,
		91,
		77,
		82,
		93,
		105,
		118,
		114,
		121,
		156,
		156,
		141,
		161,
		164,
		-1,
		-1,
		-1,
		149,
		144,
		119,
		96,
		80,
		116,
		-1,
		93,
		94,
		-1,
		71,
		65,
		71,
		70,
		77,
		74,
		74,
		88,
		96,
		92,
		108,
		114,
		106,
		142,
		-1,
		149,
		143,
		151,
		141,
		129,
		-1,
		-1,
		-1,
		142,
		121,
		114,
		134,
		75,
		127,
		-1,
		-1,
		78,
		71,
		-1,
		58,
		58,
		65,
		74,
		79,
		84,
		92,
		87,
		100,
		105,
		111,
		116,
		134,
		138,
		142,
		131,
		127,
		124,
		138,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		95,
		-1,
		87,
		79,
		69,
		63,
		57,
		60,
		62,
		89,
		81,
		95,
		95,
		101,
		109,
		94,
		97,
		113,
		111,
		129,
		137,
		129,
		123,
		122,
		134,
		-1,
		162,
		148,
		119,
		-1,
		-1,
		108,
		-1,
		72,
		86,
		102,
		-1,
		95,
		74,
		89,
		67,
		63,
		77,
		115,
		116,
		94,
		99,
		107,
		117,
		119,
		108,
		119,
		111,
		133,
		133,
		117,
		118,
		127,
		-1,
		168,
		155,
		113,
		109,
		98,
		118,
		69,
		57,
		89,
		-1,
		-1,
		41,
		-1,
		41,
		43,
		91,
		89,
		105,
		96,
		102,
		118,
		121,
		123,
		113,
		102,
		108,
		105,
		127,
		113,
		111,
		130,
		146,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		84,
		71,
		65,
		-1,
		106,
		-1,
		19,
		18,
		14,
		30,
		62,
		-1,
		113,
		97,
		102,
		-1,
		148,
		-1,
		121,
		123,
		117,
		102,
		99,
		110,
		108,
		119,
		136,
		-1,
		118,
		103,
		96,
		86,
		100,
		71,
		-1,
		126,
		-1,
		-1,
		6,
		0,
		9,
		36,
		39,
		129,
		109,
		103,
		102,
		143,
		143,
		129,
		115,
		108,
		105,
		102,
		115,
		135,
		126,
		138,
		-1,
		-1,
		-1,
		123,
		109,
		113,
		73,
		92,
		-1,
		-1,
		77,
		32,
		18,
		-1,
		45,
		146,
		134,
		124,
		114,
		148,
		149,
		134,
		127,
		113,
		115,
		113,
		111,
		116,
		137,
		138,
		151,
		-1,
		-1,
		106,
		111,
		99,
		85,
		104,
		-1,
		-1,
		-1,
		26,
		42,
		75,
		46,
		135,
		-1,
		-1,
		126,
		124,
		134,
		130,
		117,
		137,
		140,
		126,
		110,
		125,
		137,
		145,
		150,
		-1,
		109,
		96,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		-1,
		-1,
		65,
		66,
		78,
		99,
		124,
		129,
		-1,
		134,
		135,
		121,
		135,
		142,
		128,
		123,
		117,
		120,
		138,
		155,
		-1,
		-1,
		121,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		57,
		71,
		92,
		98,
		110,
		-1,
		136,
		137,
		123,
		140,
		141,
		138,
		129,
		121,
		126,
		123,
		136,
		150,
		154,
		144,
		-1,
		127,
		-1,
		-1,
		-1,
		75,
		90,
		152,
		129,
		102,
		107,
		117,
		122,
		127,
		147,
		149,
		160,
		128,
		124,
		125,
		129,
		128,
		145,
		155,
		-1,
		-1,
		127,
		136,
		101,
		83,
		87,
		179,
		-1,
		-1,
		117,
		123,
		119,
		129,
		137,
		140,
		134,
		131,
		136,
		141,
		129,
		138,
		156,
		160,
		-1,
		-1,
		-1,
		147,
		-1,
		134,
		-1,
		-1,
		102,
		203,
		150,
		132,
		128,
		126,
		131,
		140,
		135,
		139,
		149,
		158,
		150,
		131,
		142,
		165,
		154,
		192,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		176,
		151,
		166,
		187,
		122,
		129,
		165,
		162,
		-1,
		132,
		169,
		141,
		148,
		140,
		153,
		157,
		154,
		132,
		139,
		155,
		154,
		149,
		184,
		176,
		182,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		182,
		168,
		173,
		163,
		139,
		-1,
		-1,
		181,
		178,
		156,
		150,
		154,
		147,
		142,
		161,
		141,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		154,
		235,
		228,
		211,
		219,
		250,
		-1,
		181,
		173,
		175,
		159,
		150,
		-1,
		-1,
		154,
		151,
		156,
		157,
		154,
		166,
		165,
		157,
		142,
		148,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		168,
		211,
		205,
		208,
		232,
		246,
		-1,
		178,
		-1,
		-1,
		183,
		163,
		169,
		159,
		153,
		203,
		171,
		166,
		165,
		163,
		154,
		145,
		152,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		203,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		199,
		-1,
		196,
		-1,
		171,
		175,
		179,
		182,
		179,
		166,
		158,
		150,
		166,
		141,
		151,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		273,
		229,
		199,
		190,
		237,
		252,
		256,
		-1,
		190,
		229,
		237,
		-1,
		208,
		-1,
		-1,
		-1,
		185,
		192,
		184,
		199,
		178,
		178,
		152,
		156,
		146,
		153,
		163,
		165,
		157,
		161,
		174,
		185,
		188,
		269,
		260,
		273,
		218,
		204,
		222,
		231,
		252,
		205,
		196,
		223,
		244,
		233,
		228,
		215,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		185,
		173,
		156,
		157,
		153,
		156,
		171,
		174,
		164,
		162,
		156,
		188,
		-1,
		262,
		261,
		250,
		247,
		223,
		214,
		209,
		223,
		-1,
		-1,
		208,
		224,
		237,
		241,
		257,
		282,
		-1,
		218,
		-1,
		-1,
		229,
		-1,
		-1,
		215,
		178,
		167,
		158,
		164,
		161,
		172,
		182,
		170,
		171,
		161,
		171,
		184,
		246,
		243,
		231,
		229,
		252,
		217,
		205,
		-1,
		218,
		211,
		217,
		224,
		241,
		271,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		213,
		211,
		200,
		-1,
		190,
		163,
		168,
		188,
		190,
		179,
		173,
		167,
		174,
		173,
		181,
		189,
		255,
		269,
		258,
		254,
		253,
		261,
		210,
		203,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		251,
		244,
		-1,
		-1,
		208,
		201,
		189,
		177,
		167,
		177,
		181,
		185,
		177,
		170,
		165,
		176,
		168,
		172,
		189,
		-1,
		289,
		-1,
		241,
		217,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		268,
		254,
		247,
		235,
		233,
		-1,
		242,
		226,
		207,
		-1,
		177,
		190,
		221,
		189,
		194,
		189,
		171,
		182,
		171,
		174,
		188,
		183,
		-1,
		-1,
		229,
		232,
		-1,
		-1,
		254,
		260,
		-1,
		259,
		248,
		233,
		225,
		-1,
		-1,
		214,
		210,
		-1,
		-1,
		178,
		203,
		192,
		200,
		195,
		175,
		181,
		184,
		173,
		177,
		189,
		-1,
		-1,
		236,
		237,
		242,
		-1,
		243,
		-1,
		261,
		-1,
		228,
		234,
		222,
		-1,
		-1,
		-1,
		216,
		179,
		200,
		210,
		204,
		202,
		193,
		179,
		186,
		184,
		180,
		191,
		-1,
		-1,
		-1,
		261,
		235,
		268,
		259,
		242,
		222,
		214,
		233,
		-1,
		203,
		-1,
		178,
		180,
		206,
		209,
		215,
		209,
		182,
		197,
		187,
		178,
		187,
		267,
		-1,
		237,
		270,
		234,
		228,
		204,
		208,
		224,
		-1,
		200,
		182,
		-1,
		210,
		200,
		231,
		216,
		197,
		184,
		191,
		191,
		184,
		-1,
		-1,
		-1,
		239,
		238,
		230,
		224,
		224,
		209,
		200,
		-1,
		212,
		194,
		173,
		190,
		190,
		181,
		189,
		221,
		217,
		204,
		204,
		196,
		-1,
		340,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		233,
		228,
		201,
		189,
		195,
		191,
		177,
		183,
		185,
		193,
		191,
		188,
		200,
		196,
		216,
		197,
		232,
		-1,
		335,
		-1,
		269,
		-1,
		-1,
		251,
		231,
		223,
		212,
		201,
		199,
		190,
		181,
		203,
		219,
		203,
		201,
		204,
		205,
		-1,
		324,
		323,
		-1,
		270,
		262,
		248,
		-1,
		241,
		-1,
		247,
		208,
		-1,
		210,
		190,
		-1,
		212,
		208,
		-1,
		-1,
		311,
		286,
		-1,
		-1,
		-1,
		271,
		251,
		242,
		226,
		-1,
		201,
		201,
		-1,
		-1,
		-1,
		296,
		295,
		-1,
		264,
		267,
		-1,
		257,
		248,
		256,
		203,
		207,
		-1,
		-1,
		-1,
		305,
		286,
		280,
		279,
		277,
		272,
		269,
		255,
		239,
		217,
		206,
		227,
		-1,
		-1,
		-1,
		277,
		269,
		262,
		-1,
		-1,
		264,
		247,
		228,
		226,
		-1,
		-1,
		-1,
		299,
		280,
		-1,
		-1,
		254,
		-1,
		-1,
		260,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		288,
		-1,
		-1,
		-1,
		250,
		246,
		247,
		-1,
		-1,
		-1,
		-1,
		310,
		311,
		334,
		298,
		-1,
		-1,
		-1,
		242,
		236,
		-1,
		-1,
		313,
		311,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		240,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		275,
		-1,
		275,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		288,
		280,
		288,
		-1,
		260,
		262,
		-1,
		310,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		265,
		272,
		294,
		297,
		333,
		-1,
		284
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		207,
		209,
		175,
		169,
		208,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		198,
		197,
		167,
		165,
		174,
		179,
		186,
		-1,
		190,
		-1,
		219,
		198,
		209,
		214,
		160,
		157,
		177,
		196,
		183,
		175,
		234,
		190,
		161,
		155,
		173,
		168,
		177,
		169,
		-1,
		161,
		151,
		173,
		157,
		168,
		160,
		-1,
		-1,
		155,
		156,
		162,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		145,
		151,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		141,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		134,
		152,
		161,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		147,
		-1,
		127,
		129,
		139,
		147,
		152,
		136,
		123,
		123,
		133,
		126,
		145,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		124,
		126,
		143,
		135,
		125,
		140,
		133,
		126,
		123,
		121,
		118,
		134,
		135,
		145,
		-1,
		-1,
		180,
		149,
		184,
		141,
		126,
		-1,
		120,
		119,
		125,
		129,
		123,
		116,
		130,
		126,
		-1,
		112,
		111,
		142,
		128,
		139,
		140,
		-1,
		-1,
		138,
		130,
		115,
		118,
		115,
		115,
		134,
		133,
		125,
		111,
		107,
		113,
		116,
		116,
		122,
		106,
		116,
		120,
		131,
		146,
		-1,
		-1,
		201,
		-1,
		-1,
		137,
		120,
		-1,
		103,
		110,
		110,
		127,
		117,
		138,
		144,
		135,
		127,
		121,
		109,
		111,
		108,
		121,
		109,
		103,
		128,
		132,
		126,
		147,
		142,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		96,
		99,
		105,
		129,
		139,
		-1,
		129,
		135,
		145,
		130,
		127,
		114,
		102,
		115,
		100,
		107,
		106,
		110,
		112,
		145,
		123,
		145,
		142,
		171,
		176,
		170,
		179,
		-1,
		145,
		141,
		137,
		144,
		93,
		-1,
		-1,
		133,
		-1,
		147,
		146,
		121,
		139,
		142,
		131,
		122,
		109,
		98,
		109,
		98,
		95,
		103,
		112,
		123,
		118,
		117,
		135,
		150,
		163,
		167,
		173,
		-1,
		195,
		-1,
		137,
		121,
		123,
		95,
		116,
		-1,
		153,
		148,
		138,
		123,
		114,
		-1,
		117,
		120,
		127,
		105,
		90,
		107,
		99,
		97,
		102,
		107,
		121,
		112,
		130,
		137,
		145,
		149,
		169,
		181,
		155,
		145,
		-1,
		127,
		132,
		91,
		99,
		118,
		156,
		120,
		-1,
		115,
		-1,
		107,
		132,
		-1,
		111,
		107,
		89,
		90,
		85,
		100,
		106,
		103,
		100,
		118,
		121,
		138,
		142,
		158,
		-1,
		-1,
		140,
		144,
		133,
		84,
		103,
		127,
		164,
		113,
		102,
		101,
		-1,
		92,
		122,
		119,
		105,
		92,
		82,
		83,
		91,
		104,
		83,
		102,
		105,
		127,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		110,
		81,
		105,
		147,
		131,
		124,
		112,
		77,
		77,
		71,
		-1,
		112,
		95,
		91,
		80,
		78,
		91,
		86,
		102,
		106,
		105,
		124,
		136,
		127,
		147,
		-1,
		-1,
		-1,
		140,
		129,
		130,
		76,
		99,
		136,
		110,
		96,
		101,
		76,
		69,
		63,
		115,
		112,
		79,
		87,
		79,
		68,
		82,
		90,
		94,
		103,
		112,
		118,
		142,
		142,
		148,
		-1,
		-1,
		147,
		137,
		121,
		123,
		120,
		90,
		97,
		129,
		101,
		114,
		-1,
		68,
		-1,
		57,
		65,
		64,
		70,
		82,
		68,
		73,
		84,
		96,
		109,
		105,
		112,
		147,
		147,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		140,
		135,
		110,
		87,
		71,
		107,
		-1,
		84,
		85,
		-1,
		62,
		56,
		62,
		61,
		68,
		65,
		65,
		79,
		87,
		83,
		99,
		105,
		97,
		133,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		133,
		112,
		105,
		125,
		66,
		118,
		-1,
		-1,
		69,
		62,
		-1,
		49,
		49,
		56,
		65,
		70,
		75,
		83,
		78,
		91,
		96,
		102,
		107,
		125,
		129,
		133,
		122,
		118,
		115,
		129,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		86,
		-1,
		78,
		70,
		60,
		54,
		48,
		51,
		53,
		80,
		72,
		86,
		86,
		92,
		100,
		85,
		88,
		104,
		102,
		120,
		128,
		120,
		114,
		113,
		125,
		-1,
		153,
		139,
		110,
		-1,
		-1,
		99,
		-1,
		63,
		77,
		93,
		-1,
		86,
		65,
		80,
		58,
		54,
		68,
		106,
		107,
		85,
		90,
		98,
		108,
		110,
		99,
		110,
		102,
		124,
		124,
		108,
		109,
		118,
		-1,
		159,
		146,
		104,
		100,
		89,
		109,
		60,
		48,
		80,
		-1,
		-1,
		53,
		-1,
		32,
		34,
		82,
		80,
		96,
		87,
		93,
		109,
		112,
		114,
		104,
		93,
		99,
		96,
		118,
		104,
		102,
		121,
		137,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		75,
		62,
		56,
		-1,
		97,
		-1,
		31,
		21,
		5,
		27,
		53,
		-1,
		104,
		88,
		93,
		-1,
		139,
		-1,
		112,
		114,
		108,
		93,
		90,
		101,
		99,
		110,
		127,
		-1,
		109,
		94,
		87,
		77,
		91,
		62,
		-1,
		117,
		-1,
		-1,
		18,
		12,
		0,
		33,
		36,
		120,
		100,
		94,
		93,
		134,
		134,
		120,
		106,
		99,
		96,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		114,
		100,
		104,
		64,
		83,
		-1,
		-1,
		68,
		23,
		9,
		-1,
		42,
		137,
		125,
		115,
		105,
		139,
		140,
		125,
		118,
		104,
		106,
		104,
		102,
		107,
		128,
		129,
		142,
		-1,
		-1,
		97,
		102,
		90,
		76,
		95,
		-1,
		-1,
		-1,
		17,
		33,
		67,
		42,
		126,
		-1,
		-1,
		117,
		115,
		125,
		121,
		108,
		128,
		131,
		117,
		101,
		116,
		128,
		136,
		141,
		-1,
		100,
		87,
		-1,
		-1,
		98,
		92,
		-1,
		-1,
		-1,
		-1,
		56,
		62,
		74,
		95,
		120,
		120,
		-1,
		125,
		126,
		112,
		126,
		133,
		119,
		114,
		108,
		111,
		129,
		146,
		-1,
		-1,
		112,
		-1,
		107,
		-1,
		-1,
		-1,
		-1,
		53,
		67,
		88,
		94,
		106,
		-1,
		132,
		128,
		114,
		131,
		132,
		129,
		120,
		112,
		117,
		114,
		127,
		141,
		145,
		135,
		-1,
		118,
		-1,
		-1,
		-1,
		71,
		86,
		148,
		125,
		98,
		103,
		113,
		118,
		122,
		138,
		140,
		151,
		119,
		115,
		116,
		120,
		119,
		136,
		146,
		-1,
		-1,
		118,
		132,
		97,
		79,
		83,
		175,
		-1,
		-1,
		113,
		119,
		115,
		125,
		132,
		135,
		125,
		122,
		127,
		132,
		120,
		129,
		147,
		151,
		-1,
		-1,
		-1,
		138,
		-1,
		130,
		-1,
		-1,
		98,
		199,
		146,
		128,
		124,
		122,
		127,
		136,
		131,
		130,
		140,
		149,
		141,
		122,
		133,
		156,
		145,
		183,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		167,
		142,
		157,
		183,
		118,
		125,
		161,
		158,
		-1,
		128,
		165,
		137,
		144,
		136,
		148,
		148,
		145,
		123,
		130,
		146,
		145,
		140,
		175,
		167,
		173,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		173,
		159,
		169,
		159,
		135,
		-1,
		-1,
		177,
		174,
		152,
		146,
		150,
		143,
		138,
		152,
		132,
		119,
		123,
		127,
		133,
		138,
		143,
		149,
		164,
		179,
		-1,
		145,
		226,
		219,
		202,
		210,
		241,
		-1,
		176,
		169,
		166,
		155,
		146,
		-1,
		-1,
		150,
		147,
		152,
		153,
		150,
		162,
		157,
		148,
		133,
		139,
		126,
		125,
		143,
		147,
		156,
		163,
		153,
		166,
		170,
		-1,
		159,
		202,
		196,
		199,
		223,
		237,
		-1,
		174,
		-1,
		-1,
		174,
		159,
		165,
		155,
		149,
		199,
		167,
		162,
		156,
		154,
		145,
		136,
		143,
		134,
		134,
		137,
		152,
		157,
		149,
		163,
		163,
		164,
		-1,
		194,
		182,
		190,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		190,
		-1,
		192,
		-1,
		167,
		171,
		175,
		178,
		170,
		157,
		149,
		141,
		157,
		132,
		142,
		138,
		139,
		148,
		159,
		171,
		170,
		171,
		268,
		223,
		190,
		181,
		228,
		243,
		247,
		-1,
		186,
		225,
		228,
		-1,
		199,
		-1,
		-1,
		-1,
		181,
		188,
		180,
		190,
		169,
		169,
		143,
		147,
		137,
		144,
		154,
		156,
		148,
		152,
		165,
		176,
		179,
		264,
		256,
		267,
		212,
		195,
		213,
		222,
		243,
		201,
		192,
		219,
		235,
		224,
		219,
		206,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		176,
		164,
		147,
		148,
		144,
		147,
		162,
		165,
		155,
		153,
		147,
		179,
		-1,
		258,
		257,
		246,
		243,
		219,
		210,
		203,
		214,
		-1,
		-1,
		204,
		220,
		233,
		237,
		253,
		278,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		206,
		169,
		158,
		149,
		155,
		152,
		163,
		173,
		161,
		162,
		152,
		162,
		175,
		242,
		239,
		227,
		225,
		248,
		211,
		201,
		-1,
		214,
		207,
		213,
		220,
		237,
		267,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		154,
		159,
		179,
		181,
		170,
		164,
		158,
		165,
		164,
		172,
		180,
		251,
		265,
		254,
		250,
		249,
		257,
		206,
		199,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		-1,
		242,
		235,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		172,
		176,
		168,
		161,
		156,
		167,
		159,
		163,
		180,
		-1,
		285,
		-1,
		237,
		213,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		259,
		245,
		238,
		226,
		224,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		212,
		180,
		185,
		180,
		162,
		173,
		162,
		165,
		179,
		174,
		-1,
		-1,
		225,
		228,
		-1,
		-1,
		249,
		251,
		-1,
		250,
		239,
		224,
		216,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		169,
		194,
		183,
		191,
		186,
		166,
		172,
		175,
		164,
		168,
		180,
		-1,
		-1,
		232,
		233,
		238,
		-1,
		234,
		-1,
		252,
		-1,
		219,
		225,
		213,
		-1,
		-1,
		-1,
		207,
		170,
		191,
		201,
		195,
		193,
		184,
		170,
		177,
		175,
		171,
		182,
		-1,
		-1,
		-1,
		252,
		226,
		259,
		250,
		233,
		213,
		205,
		224,
		-1,
		194,
		-1,
		169,
		171,
		197,
		200,
		206,
		200,
		173,
		188,
		178,
		169,
		178,
		258,
		-1,
		228,
		261,
		225,
		219,
		195,
		199,
		215,
		-1,
		191,
		173,
		-1,
		201,
		191,
		222,
		207,
		188,
		175,
		182,
		182,
		175,
		-1,
		-1,
		-1,
		230,
		229,
		221,
		215,
		215,
		200,
		191,
		-1,
		203,
		185,
		164,
		181,
		181,
		172,
		180,
		212,
		208,
		195,
		195,
		187,
		-1,
		331,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		224,
		219,
		192,
		180,
		186,
		182,
		168,
		174,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		188,
		223,
		-1,
		326,
		-1,
		260,
		-1,
		-1,
		242,
		222,
		214,
		203,
		192,
		190,
		181,
		172,
		194,
		210,
		194,
		192,
		195,
		196,
		-1,
		315,
		314,
		-1,
		261,
		253,
		239,
		-1,
		232,
		-1,
		238,
		199,
		-1,
		201,
		181,
		-1,
		203,
		199,
		-1,
		-1,
		302,
		277,
		-1,
		-1,
		-1,
		262,
		242,
		233,
		217,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		287,
		286,
		-1,
		255,
		258,
		-1,
		248,
		239,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		296,
		277,
		271,
		270,
		268,
		263,
		260,
		246,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		268,
		260,
		253,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		290,
		271,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		279,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		301,
		302,
		325,
		289,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		304,
		302,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		194,
		196,
		162,
		156,
		195,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		185,
		184,
		154,
		152,
		161,
		166,
		173,
		-1,
		177,
		-1,
		206,
		185,
		196,
		201,
		147,
		144,
		164,
		183,
		170,
		162,
		221,
		177,
		148,
		142,
		160,
		155,
		164,
		156,
		-1,
		148,
		138,
		160,
		144,
		155,
		147,
		-1,
		-1,
		142,
		143,
		149,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		132,
		138,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		128,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		139,
		-1,
		121,
		139,
		148,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		134,
		-1,
		114,
		116,
		126,
		134,
		139,
		123,
		110,
		110,
		120,
		113,
		132,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		111,
		113,
		130,
		122,
		112,
		127,
		120,
		113,
		110,
		108,
		105,
		121,
		122,
		132,
		-1,
		-1,
		167,
		136,
		171,
		128,
		113,
		-1,
		107,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		99,
		98,
		129,
		115,
		126,
		127,
		-1,
		-1,
		125,
		117,
		102,
		105,
		102,
		102,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		93,
		103,
		107,
		118,
		133,
		-1,
		-1,
		188,
		-1,
		-1,
		124,
		107,
		-1,
		90,
		97,
		97,
		114,
		104,
		125,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		90,
		115,
		119,
		113,
		134,
		129,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		83,
		86,
		92,
		116,
		126,
		-1,
		116,
		122,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		97,
		99,
		132,
		110,
		132,
		129,
		158,
		163,
		157,
		166,
		-1,
		132,
		128,
		124,
		131,
		80,
		-1,
		-1,
		120,
		-1,
		134,
		133,
		108,
		126,
		129,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		99,
		110,
		105,
		104,
		122,
		137,
		150,
		154,
		160,
		-1,
		182,
		-1,
		124,
		108,
		110,
		82,
		103,
		-1,
		140,
		135,
		125,
		110,
		101,
		-1,
		104,
		107,
		114,
		92,
		77,
		94,
		86,
		84,
		89,
		94,
		108,
		99,
		117,
		124,
		132,
		136,
		156,
		168,
		142,
		132,
		-1,
		114,
		119,
		78,
		86,
		105,
		143,
		107,
		-1,
		102,
		-1,
		94,
		119,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		93,
		90,
		87,
		105,
		108,
		125,
		129,
		145,
		-1,
		-1,
		127,
		131,
		120,
		71,
		90,
		114,
		151,
		100,
		89,
		88,
		-1,
		79,
		109,
		106,
		92,
		79,
		69,
		70,
		78,
		91,
		70,
		89,
		92,
		114,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		97,
		68,
		92,
		134,
		118,
		111,
		99,
		64,
		64,
		58,
		-1,
		99,
		82,
		78,
		67,
		65,
		78,
		73,
		89,
		93,
		92,
		111,
		123,
		114,
		134,
		-1,
		-1,
		-1,
		127,
		116,
		117,
		63,
		86,
		123,
		97,
		83,
		88,
		63,
		56,
		50,
		102,
		99,
		66,
		74,
		66,
		55,
		69,
		77,
		81,
		90,
		99,
		105,
		129,
		129,
		135,
		-1,
		-1,
		134,
		124,
		108,
		110,
		107,
		77,
		84,
		116,
		88,
		101,
		-1,
		55,
		-1,
		44,
		52,
		51,
		57,
		69,
		55,
		60,
		71,
		83,
		96,
		92,
		99,
		134,
		134,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		127,
		122,
		97,
		74,
		58,
		94,
		-1,
		71,
		72,
		-1,
		49,
		43,
		49,
		48,
		55,
		52,
		52,
		66,
		74,
		70,
		86,
		92,
		84,
		120,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		53,
		105,
		-1,
		-1,
		56,
		49,
		-1,
		36,
		36,
		43,
		52,
		57,
		62,
		70,
		65,
		78,
		83,
		89,
		94,
		112,
		116,
		120,
		109,
		105,
		102,
		116,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		73,
		-1,
		65,
		57,
		47,
		41,
		35,
		46,
		47,
		67,
		59,
		73,
		73,
		79,
		87,
		72,
		75,
		91,
		89,
		107,
		115,
		107,
		101,
		100,
		112,
		-1,
		140,
		126,
		97,
		-1,
		-1,
		86,
		-1,
		50,
		64,
		80,
		-1,
		73,
		52,
		67,
		45,
		49,
		55,
		93,
		94,
		72,
		77,
		85,
		95,
		97,
		86,
		97,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		146,
		133,
		91,
		87,
		76,
		96,
		47,
		35,
		67,
		-1,
		-1,
		73,
		-1,
		27,
		29,
		69,
		67,
		83,
		74,
		80,
		96,
		99,
		101,
		91,
		80,
		86,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		62,
		49,
		43,
		-1,
		84,
		-1,
		51,
		39,
		26,
		8,
		48,
		-1,
		91,
		75,
		80,
		-1,
		126,
		-1,
		99,
		101,
		95,
		80,
		77,
		88,
		86,
		97,
		114,
		-1,
		96,
		81,
		74,
		64,
		78,
		49,
		-1,
		104,
		-1,
		-1,
		38,
		32,
		32,
		0,
		5,
		107,
		87,
		81,
		80,
		121,
		121,
		107,
		93,
		86,
		83,
		80,
		93,
		113,
		104,
		116,
		-1,
		-1,
		-1,
		101,
		87,
		91,
		51,
		70,
		-1,
		-1,
		99,
		55,
		41,
		-1,
		11,
		123,
		112,
		102,
		92,
		126,
		127,
		112,
		105,
		91,
		93,
		91,
		89,
		94,
		115,
		116,
		129,
		-1,
		-1,
		84,
		89,
		77,
		63,
		82,
		-1,
		-1,
		-1,
		45,
		61,
		41,
		12,
		111,
		-1,
		-1,
		104,
		102,
		112,
		108,
		95,
		115,
		118,
		104,
		88,
		103,
		115,
		123,
		128,
		-1,
		87,
		74,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		-1,
		-1,
		66,
		32,
		44,
		65,
		90,
		107,
		-1,
		100,
		111,
		99,
		113,
		120,
		106,
		101,
		95,
		98,
		116,
		133,
		-1,
		-1,
		99,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		23,
		37,
		58,
		64,
		76,
		-1,
		102,
		104,
		101,
		113,
		119,
		116,
		107,
		99,
		104,
		101,
		114,
		128,
		132,
		122,
		-1,
		105,
		-1,
		-1,
		-1,
		41,
		56,
		118,
		95,
		68,
		73,
		83,
		88,
		93,
		113,
		119,
		130,
		106,
		102,
		103,
		107,
		106,
		123,
		133,
		-1,
		-1,
		105,
		102,
		67,
		49,
		53,
		145,
		-1,
		-1,
		83,
		89,
		85,
		95,
		103,
		106,
		111,
		109,
		114,
		119,
		107,
		116,
		134,
		138,
		-1,
		-1,
		-1,
		125,
		-1,
		100,
		-1,
		-1,
		68,
		169,
		116,
		98,
		94,
		92,
		97,
		106,
		101,
		106,
		127,
		126,
		128,
		109,
		120,
		143,
		132,
		170,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		154,
		119,
		134,
		153,
		88,
		95,
		131,
		128,
		-1,
		98,
		135,
		107,
		114,
		106,
		119,
		124,
		130,
		110,
		117,
		133,
		132,
		127,
		162,
		154,
		160,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		157,
		136,
		139,
		129,
		105,
		-1,
		-1,
		147,
		144,
		122,
		116,
		120,
		113,
		108,
		139,
		119,
		106,
		110,
		114,
		120,
		125,
		130,
		136,
		151,
		166,
		-1,
		132,
		213,
		206,
		189,
		197,
		228,
		-1,
		147,
		139,
		143,
		125,
		116,
		-1,
		-1,
		120,
		117,
		122,
		123,
		120,
		132,
		131,
		135,
		120,
		126,
		113,
		112,
		130,
		134,
		143,
		150,
		140,
		153,
		157,
		-1,
		146,
		189,
		183,
		186,
		210,
		224,
		-1,
		144,
		-1,
		-1,
		156,
		129,
		135,
		125,
		119,
		169,
		137,
		132,
		134,
		136,
		132,
		123,
		130,
		121,
		121,
		124,
		139,
		144,
		136,
		150,
		150,
		151,
		-1,
		181,
		169,
		177,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		162,
		-1,
		137,
		141,
		145,
		148,
		157,
		144,
		136,
		128,
		144,
		119,
		129,
		125,
		126,
		135,
		146,
		158,
		157,
		158,
		239,
		195,
		177,
		168,
		215,
		230,
		234,
		-1,
		156,
		195,
		210,
		-1,
		181,
		-1,
		-1,
		-1,
		151,
		158,
		150,
		166,
		156,
		156,
		130,
		134,
		124,
		131,
		141,
		143,
		135,
		139,
		152,
		163,
		166,
		235,
		226,
		239,
		184,
		182,
		200,
		209,
		230,
		171,
		162,
		189,
		217,
		206,
		201,
		188,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		163,
		151,
		134,
		135,
		131,
		134,
		149,
		152,
		142,
		140,
		134,
		166,
		-1,
		228,
		227,
		216,
		213,
		189,
		180,
		175,
		201,
		-1,
		-1,
		174,
		190,
		203,
		207,
		223,
		248,
		-1,
		191,
		-1,
		-1,
		195,
		-1,
		-1,
		193,
		156,
		145,
		136,
		142,
		139,
		150,
		160,
		148,
		149,
		139,
		149,
		162,
		212,
		209,
		197,
		195,
		218,
		183,
		171,
		-1,
		184,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		191,
		189,
		178,
		-1,
		168,
		141,
		146,
		166,
		168,
		157,
		151,
		145,
		152,
		151,
		159,
		167,
		221,
		235,
		224,
		220,
		219,
		227,
		176,
		169,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		-1,
		229,
		217,
		-1,
		-1,
		186,
		179,
		167,
		155,
		145,
		155,
		159,
		163,
		155,
		148,
		143,
		154,
		146,
		150,
		167,
		-1,
		255,
		-1,
		207,
		183,
		197,
		212,
		220,
		-1,
		-1,
		-1,
		246,
		232,
		225,
		213,
		211,
		-1,
		220,
		204,
		185,
		-1,
		155,
		168,
		199,
		167,
		172,
		167,
		149,
		160,
		149,
		152,
		166,
		161,
		-1,
		-1,
		195,
		198,
		-1,
		-1,
		220,
		238,
		-1,
		237,
		226,
		211,
		203,
		-1,
		-1,
		192,
		188,
		-1,
		-1,
		156,
		181,
		170,
		178,
		173,
		153,
		159,
		162,
		151,
		155,
		167,
		-1,
		-1,
		202,
		203,
		208,
		-1,
		221,
		-1,
		239,
		-1,
		206,
		212,
		200,
		-1,
		-1,
		-1,
		194,
		157,
		178,
		188,
		182,
		180,
		171,
		157,
		164,
		162,
		158,
		169,
		-1,
		-1,
		-1,
		239,
		213,
		246,
		237,
		220,
		200,
		192,
		211,
		-1,
		181,
		-1,
		156,
		158,
		184,
		187,
		193,
		187,
		160,
		175,
		165,
		156,
		165,
		245,
		-1,
		215,
		248,
		212,
		206,
		182,
		186,
		202,
		-1,
		178,
		160,
		-1,
		188,
		178,
		209,
		194,
		175,
		162,
		169,
		169,
		162,
		-1,
		-1,
		-1,
		217,
		216,
		208,
		202,
		202,
		187,
		178,
		-1,
		190,
		172,
		151,
		168,
		168,
		159,
		167,
		199,
		195,
		182,
		182,
		174,
		-1,
		318,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		211,
		206,
		179,
		167,
		173,
		169,
		155,
		161,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		175,
		210,
		-1,
		313,
		-1,
		247,
		-1,
		-1,
		229,
		209,
		201,
		190,
		179,
		177,
		168,
		159,
		181,
		197,
		181,
		179,
		182,
		183,
		-1,
		302,
		301,
		-1,
		248,
		240,
		226,
		-1,
		219,
		-1,
		225,
		186,
		-1,
		188,
		168,
		-1,
		190,
		186,
		-1,
		-1,
		289,
		264,
		-1,
		-1,
		-1,
		249,
		229,
		220,
		204,
		-1,
		179,
		179,
		-1,
		-1,
		-1,
		274,
		273,
		-1,
		242,
		245,
		-1,
		235,
		226,
		234,
		181,
		185,
		-1,
		-1,
		-1,
		283,
		264,
		258,
		257,
		255,
		250,
		247,
		233,
		217,
		195,
		184,
		205,
		-1,
		-1,
		-1,
		255,
		247,
		240,
		-1,
		-1,
		242,
		225,
		206,
		204,
		-1,
		-1,
		-1,
		277,
		258,
		-1,
		-1,
		232,
		-1,
		-1,
		238,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		266,
		-1,
		-1,
		-1,
		228,
		224,
		225,
		-1,
		-1,
		-1,
		-1,
		288,
		289,
		312,
		276,
		-1,
		-1,
		-1,
		220,
		214,
		-1,
		-1,
		291,
		289,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		218,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		253,
		-1,
		253,
		228,
		235,
		-1,
		-1,
		-1,
		-1,
		266,
		258,
		266,
		-1,
		238,
		240,
		-1,
		288,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		243,
		250,
		272,
		275,
		311,
		-1,
		262
	],
	[
		-1,
		187,
		176,
		187,
		195,
		168,
		175,
		-1,
		196,
		198,
		164,
		158,
		197,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		187,
		186,
		156,
		154,
		163,
		168,
		175,
		-1,
		179,
		-1,
		208,
		187,
		198,
		203,
		149,
		146,
		166,
		185,
		172,
		164,
		223,
		179,
		150,
		144,
		162,
		157,
		166,
		158,
		-1,
		150,
		140,
		162,
		146,
		157,
		149,
		-1,
		-1,
		144,
		145,
		151,
		142,
		148,
		144,
		-1,
		154,
		138,
		-1,
		-1,
		134,
		140,
		124,
		127,
		135,
		133,
		146,
		138,
		133,
		-1,
		-1,
		130,
		126,
		133,
		120,
		116,
		133,
		146,
		128,
		142,
		141,
		-1,
		123,
		141,
		150,
		127,
		125,
		109,
		107,
		125,
		127,
		133,
		136,
		-1,
		116,
		118,
		128,
		136,
		141,
		125,
		112,
		112,
		122,
		115,
		134,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		113,
		115,
		132,
		124,
		114,
		129,
		122,
		115,
		112,
		110,
		107,
		123,
		124,
		134,
		-1,
		-1,
		169,
		138,
		173,
		130,
		115,
		-1,
		109,
		108,
		114,
		118,
		112,
		105,
		119,
		115,
		-1,
		101,
		100,
		131,
		117,
		128,
		129,
		-1,
		-1,
		127,
		119,
		104,
		107,
		104,
		104,
		123,
		122,
		114,
		100,
		96,
		102,
		105,
		105,
		111,
		95,
		105,
		109,
		120,
		135,
		-1,
		-1,
		190,
		-1,
		-1,
		126,
		109,
		-1,
		92,
		99,
		99,
		116,
		106,
		127,
		133,
		124,
		116,
		110,
		98,
		100,
		97,
		110,
		98,
		92,
		117,
		121,
		115,
		136,
		131,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		85,
		88,
		94,
		118,
		128,
		-1,
		118,
		124,
		134,
		119,
		116,
		103,
		91,
		104,
		89,
		96,
		95,
		99,
		101,
		134,
		112,
		134,
		131,
		160,
		165,
		159,
		168,
		-1,
		134,
		130,
		126,
		133,
		82,
		-1,
		-1,
		122,
		-1,
		136,
		135,
		110,
		128,
		131,
		120,
		111,
		98,
		87,
		98,
		87,
		84,
		92,
		101,
		112,
		107,
		106,
		124,
		139,
		152,
		156,
		162,
		-1,
		184,
		-1,
		126,
		110,
		112,
		84,
		105,
		-1,
		142,
		137,
		127,
		112,
		103,
		-1,
		106,
		109,
		116,
		94,
		79,
		96,
		88,
		86,
		91,
		96,
		110,
		101,
		119,
		126,
		134,
		138,
		158,
		170,
		144,
		134,
		-1,
		116,
		121,
		80,
		88,
		107,
		145,
		109,
		-1,
		104,
		-1,
		96,
		121,
		-1,
		100,
		96,
		78,
		79,
		74,
		89,
		95,
		92,
		89,
		107,
		110,
		127,
		131,
		147,
		-1,
		-1,
		129,
		133,
		122,
		73,
		92,
		116,
		153,
		102,
		91,
		90,
		-1,
		81,
		111,
		108,
		94,
		81,
		71,
		72,
		80,
		93,
		72,
		91,
		94,
		116,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		99,
		70,
		94,
		136,
		120,
		113,
		101,
		66,
		66,
		60,
		-1,
		101,
		84,
		80,
		69,
		67,
		80,
		75,
		91,
		95,
		94,
		113,
		125,
		116,
		136,
		-1,
		-1,
		-1,
		129,
		118,
		119,
		65,
		88,
		125,
		99,
		85,
		90,
		65,
		58,
		52,
		104,
		101,
		68,
		76,
		68,
		57,
		71,
		79,
		83,
		92,
		101,
		107,
		131,
		131,
		137,
		-1,
		-1,
		136,
		126,
		110,
		112,
		109,
		79,
		86,
		118,
		90,
		103,
		-1,
		57,
		-1,
		46,
		54,
		53,
		59,
		71,
		57,
		62,
		73,
		85,
		98,
		94,
		101,
		136,
		136,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		129,
		124,
		99,
		76,
		60,
		96,
		-1,
		73,
		74,
		-1,
		51,
		45,
		51,
		50,
		57,
		54,
		54,
		68,
		76,
		72,
		88,
		94,
		86,
		122,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		122,
		101,
		94,
		114,
		55,
		107,
		-1,
		-1,
		58,
		51,
		-1,
		38,
		38,
		45,
		54,
		59,
		64,
		72,
		67,
		80,
		85,
		91,
		96,
		114,
		118,
		122,
		111,
		107,
		104,
		118,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		55,
		75,
		-1,
		67,
		59,
		49,
		43,
		37,
		48,
		49,
		69,
		61,
		75,
		75,
		81,
		89,
		74,
		77,
		93,
		91,
		109,
		117,
		109,
		103,
		102,
		114,
		-1,
		142,
		128,
		99,
		-1,
		-1,
		88,
		-1,
		52,
		66,
		82,
		-1,
		75,
		54,
		69,
		47,
		51,
		57,
		95,
		96,
		74,
		79,
		87,
		97,
		99,
		88,
		99,
		91,
		113,
		113,
		97,
		98,
		107,
		-1,
		148,
		135,
		93,
		89,
		78,
		98,
		49,
		37,
		69,
		-1,
		-1,
		75,
		-1,
		29,
		31,
		71,
		69,
		85,
		76,
		82,
		98,
		101,
		103,
		93,
		82,
		88,
		85,
		107,
		93,
		91,
		110,
		126,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		64,
		51,
		45,
		-1,
		86,
		-1,
		53,
		41,
		28,
		10,
		50,
		-1,
		93,
		77,
		82,
		-1,
		128,
		-1,
		101,
		103,
		97,
		82,
		79,
		90,
		88,
		99,
		116,
		-1,
		98,
		83,
		76,
		66,
		80,
		51,
		-1,
		106,
		-1,
		-1,
		40,
		34,
		34,
		3,
		0,
		109,
		89,
		83,
		82,
		123,
		123,
		109,
		95,
		88,
		85,
		82,
		95,
		115,
		106,
		118,
		-1,
		-1,
		-1,
		103,
		89,
		93,
		53,
		72,
		-1,
		-1,
		101,
		57,
		43,
		-1,
		6,
		118,
		108,
		104,
		94,
		123,
		124,
		114,
		107,
		93,
		95,
		93,
		91,
		96,
		117,
		118,
		131,
		-1,
		-1,
		86,
		91,
		79,
		65,
		84,
		-1,
		-1,
		-1,
		47,
		63,
		36,
		7,
		106,
		-1,
		-1,
		106,
		104,
		109,
		110,
		97,
		117,
		120,
		106,
		90,
		105,
		117,
		125,
		130,
		-1,
		89,
		76,
		-1,
		-1,
		87,
		81,
		-1,
		-1,
		-1,
		-1,
		61,
		27,
		39,
		60,
		85,
		109,
		-1,
		95,
		106,
		99,
		115,
		122,
		108,
		103,
		97,
		100,
		118,
		135,
		-1,
		-1,
		101,
		-1,
		96,
		-1,
		-1,
		-1,
		-1,
		18,
		32,
		53,
		59,
		71,
		-1,
		97,
		99,
		96,
		108,
		119,
		118,
		109,
		101,
		106,
		103,
		116,
		130,
		134,
		124,
		-1,
		107,
		-1,
		-1,
		-1,
		36,
		51,
		113,
		90,
		63,
		68,
		78,
		83,
		88,
		108,
		114,
		125,
		108,
		104,
		105,
		109,
		108,
		125,
		135,
		-1,
		-1,
		107,
		97,
		62,
		44,
		48,
		140,
		-1,
		-1,
		78,
		84,
		80,
		90,
		98,
		101,
		106,
		108,
		116,
		121,
		109,
		118,
		136,
		140,
		-1,
		-1,
		-1,
		123,
		-1,
		95,
		-1,
		-1,
		63,
		164,
		111,
		93,
		89,
		87,
		92,
		101,
		96,
		101,
		126,
		121,
		130,
		111,
		122,
		145,
		134,
		172,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		152,
		114,
		129,
		148,
		83,
		90,
		126,
		123,
		-1,
		93,
		130,
		102,
		109,
		101,
		114,
		119,
		125,
		112,
		119,
		135,
		134,
		129,
		164,
		156,
		162,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		152,
		131,
		134,
		124,
		100,
		-1,
		-1,
		142,
		139,
		117,
		111,
		115,
		108,
		103,
		141,
		117,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		153,
		168,
		-1,
		134,
		215,
		208,
		191,
		199,
		230,
		-1,
		142,
		134,
		138,
		120,
		111,
		-1,
		-1,
		115,
		112,
		117,
		118,
		115,
		127,
		126,
		137,
		122,
		128,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		148,
		191,
		185,
		188,
		212,
		226,
		-1,
		139,
		-1,
		-1,
		151,
		124,
		130,
		120,
		114,
		164,
		132,
		127,
		129,
		131,
		134,
		125,
		132,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		183,
		171,
		179,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		167,
		-1,
		157,
		-1,
		132,
		136,
		140,
		143,
		154,
		141,
		138,
		130,
		146,
		121,
		131,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		234,
		190,
		179,
		170,
		215,
		230,
		234,
		-1,
		151,
		190,
		205,
		-1,
		176,
		-1,
		-1,
		-1,
		146,
		153,
		145,
		161,
		153,
		153,
		132,
		136,
		126,
		133,
		143,
		145,
		137,
		141,
		154,
		165,
		168,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		166,
		157,
		184,
		212,
		201,
		196,
		183,
		-1,
		-1,
		169,
		163,
		-1,
		-1,
		160,
		153,
		136,
		137,
		133,
		136,
		151,
		154,
		144,
		142,
		136,
		168,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		169,
		185,
		198,
		202,
		218,
		243,
		-1,
		186,
		-1,
		-1,
		190,
		-1,
		-1,
		195,
		158,
		147,
		138,
		144,
		141,
		152,
		162,
		150,
		151,
		141,
		151,
		164,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		172,
		178,
		185,
		202,
		232,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		193,
		191,
		180,
		-1,
		170,
		143,
		148,
		168,
		170,
		159,
		153,
		147,
		154,
		153,
		161,
		169,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		227,
		212,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		161,
		165,
		157,
		150,
		145,
		156,
		148,
		152,
		169,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		244,
		230,
		223,
		211,
		209,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		201,
		169,
		174,
		169,
		151,
		162,
		151,
		154,
		168,
		163,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		215,
		234,
		-1,
		235,
		224,
		209,
		201,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		158,
		183,
		172,
		180,
		175,
		155,
		161,
		164,
		153,
		157,
		169,
		-1,
		-1,
		197,
		198,
		203,
		-1,
		219,
		-1,
		237,
		-1,
		204,
		210,
		198,
		-1,
		-1,
		-1,
		196,
		159,
		177,
		190,
		184,
		182,
		173,
		159,
		166,
		164,
		160,
		171,
		-1,
		-1,
		-1,
		237,
		211,
		244,
		235,
		218,
		198,
		190,
		209,
		-1,
		179,
		-1,
		154,
		157,
		182,
		189,
		195,
		189,
		162,
		177,
		167,
		158,
		167,
		243,
		-1,
		213,
		246,
		210,
		204,
		180,
		184,
		200,
		-1,
		176,
		158,
		-1,
		186,
		176,
		211,
		196,
		177,
		164,
		171,
		171,
		164,
		-1,
		-1,
		-1,
		215,
		214,
		206,
		200,
		200,
		185,
		176,
		-1,
		188,
		170,
		149,
		166,
		166,
		157,
		165,
		201,
		197,
		184,
		184,
		176,
		-1,
		316,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		209,
		204,
		177,
		165,
		171,
		167,
		153,
		159,
		161,
		169,
		167,
		164,
		176,
		172,
		192,
		177,
		212,
		-1,
		311,
		-1,
		245,
		-1,
		-1,
		227,
		207,
		199,
		188,
		177,
		175,
		166,
		157,
		179,
		195,
		179,
		177,
		182,
		185,
		-1,
		300,
		299,
		-1,
		246,
		238,
		224,
		-1,
		217,
		-1,
		223,
		184,
		-1,
		186,
		166,
		-1,
		188,
		184,
		-1,
		-1,
		287,
		262,
		-1,
		-1,
		-1,
		247,
		227,
		218,
		202,
		-1,
		177,
		177,
		-1,
		-1,
		-1,
		272,
		271,
		-1,
		240,
		243,
		-1,
		233,
		224,
		232,
		179,
		183,
		-1,
		-1,
		-1,
		281,
		262,
		256,
		255,
		253,
		248,
		245,
		231,
		215,
		193,
		182,
		203,
		-1,
		-1,
		-1,
		253,
		245,
		238,
		-1,
		-1,
		240,
		223,
		204,
		202,
		-1,
		-1,
		-1,
		275,
		256,
		-1,
		-1,
		230,
		-1,
		-1,
		236,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		264,
		-1,
		-1,
		-1,
		226,
		222,
		223,
		-1,
		-1,
		-1,
		-1,
		286,
		287,
		310,
		274,
		-1,
		-1,
		-1,
		218,
		212,
		-1,
		-1,
		289,
		287,
		-1,
		-1,
		-1,
		246,
		230,
		-1,
		216,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		251,
		-1,
		251,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		264,
		256,
		264,
		-1,
		236,
		238,
		-1,
		286,
		-1,
		-1,
		279,
		270,
		-1,
		-1,
		241,
		248,
		270,
		273,
		309,
		-1,
		260
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		212,
		214,
		180,
		174,
		213,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		203,
		202,
		172,
		170,
		179,
		184,
		191,
		-1,
		195,
		-1,
		224,
		203,
		214,
		219,
		165,
		162,
		182,
		201,
		188,
		180,
		239,
		195,
		166,
		160,
		178,
		173,
		182,
		174,
		-1,
		166,
		156,
		178,
		162,
		173,
		165,
		-1,
		-1,
		160,
		161,
		167,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		150,
		156,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		146,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		139,
		157,
		166,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		152,
		-1,
		148,
		149,
		144,
		152,
		157,
		141,
		128,
		128,
		138,
		131,
		150,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		148,
		131,
		148,
		140,
		130,
		145,
		138,
		131,
		128,
		126,
		123,
		139,
		140,
		150,
		-1,
		-1,
		227,
		196,
		231,
		188,
		173,
		-1,
		144,
		124,
		130,
		134,
		128,
		121,
		135,
		131,
		-1,
		117,
		116,
		147,
		133,
		144,
		187,
		-1,
		-1,
		185,
		177,
		162,
		165,
		154,
		150,
		139,
		138,
		130,
		116,
		112,
		118,
		121,
		121,
		127,
		111,
		121,
		125,
		135,
		151,
		-1,
		-1,
		197,
		-1,
		-1,
		184,
		167,
		-1,
		150,
		157,
		157,
		166,
		152,
		173,
		149,
		140,
		132,
		126,
		114,
		116,
		113,
		126,
		114,
		108,
		133,
		137,
		130,
		151,
		146,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		146,
		152,
		176,
		186,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		120,
		105,
		112,
		111,
		115,
		117,
		150,
		127,
		149,
		146,
		167,
		172,
		166,
		175,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		180,
		-1,
		194,
		193,
		168,
		146,
		149,
		136,
		127,
		114,
		103,
		114,
		103,
		100,
		108,
		116,
		128,
		122,
		121,
		139,
		151,
		159,
		163,
		169,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		200,
		195,
		185,
		170,
		161,
		-1,
		145,
		142,
		132,
		110,
		95,
		112,
		104,
		102,
		107,
		111,
		125,
		116,
		134,
		141,
		141,
		145,
		165,
		177,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		95,
		90,
		105,
		110,
		107,
		104,
		122,
		125,
		134,
		138,
		154,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		130,
		127,
		115,
		102,
		87,
		88,
		96,
		108,
		87,
		106,
		105,
		125,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		126,
		105,
		96,
		85,
		83,
		96,
		88,
		106,
		103,
		101,
		120,
		132,
		123,
		143,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		136,
		122,
		100,
		92,
		84,
		73,
		84,
		92,
		96,
		99,
		108,
		114,
		138,
		144,
		150,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		95,
		93,
		86,
		89,
		70,
		75,
		89,
		98,
		106,
		101,
		108,
		143,
		143,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		98,
		90,
		91,
		74,
		74,
		75,
		89,
		73,
		92,
		94,
		93,
		129,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		72,
		64,
		58,
		67,
		60,
		67,
		80,
		85,
		98,
		96,
		126,
		130,
		135,
		124,
		120,
		117,
		131,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		89,
		87,
		86,
		70,
		73,
		68,
		65,
		71,
		74,
		77,
		93,
		103,
		121,
		130,
		122,
		116,
		115,
		127,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		99,
		84,
		74,
		75,
		45,
		50,
		61,
		71,
		98,
		88,
		111,
		104,
		126,
		126,
		110,
		111,
		120,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		98,
		96,
		64,
		38,
		45,
		72,
		75,
		85,
		93,
		82,
		88,
		98,
		120,
		106,
		104,
		123,
		139,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		16,
		31,
		40,
		-1,
		110,
		-1,
		84,
		97,
		97,
		93,
		92,
		103,
		101,
		112,
		129,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		0,
		21,
		33,
		40,
		95,
		82,
		81,
		87,
		92,
		96,
		95,
		108,
		128,
		119,
		131,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		77,
		65,
		55,
		45,
		82,
		83,
		73,
		78,
		87,
		99,
		104,
		104,
		109,
		130,
		131,
		144,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		66,
		-1,
		-1,
		60,
		58,
		68,
		74,
		89,
		103,
		110,
		119,
		103,
		118,
		130,
		138,
		143,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		176,
		128,
		117,
		112,
		116,
		63,
		-1,
		68,
		69,
		87,
		99,
		106,
		121,
		116,
		110,
		113,
		131,
		148,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		133,
		134,
		105,
		98,
		102,
		-1,
		77,
		77,
		89,
		100,
		112,
		117,
		122,
		109,
		119,
		116,
		129,
		143,
		147,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		151,
		166,
		144,
		121,
		94,
		89,
		82,
		76,
		81,
		101,
		107,
		118,
		103,
		107,
		118,
		122,
		121,
		138,
		148,
		-1,
		-1,
		165,
		182,
		177,
		159,
		163,
		171,
		-1,
		-1,
		98,
		89,
		80,
		83,
		91,
		94,
		99,
		101,
		119,
		134,
		122,
		131,
		149,
		152,
		-1,
		-1,
		-1,
		185,
		-1,
		200,
		-1,
		-1,
		178,
		169,
		116,
		98,
		94,
		92,
		85,
		94,
		89,
		94,
		119,
		114,
		123,
		124,
		132,
		155,
		144,
		183,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		131,
		128,
		-1,
		98,
		123,
		95,
		102,
		94,
		107,
		112,
		118,
		122,
		129,
		145,
		144,
		139,
		175,
		166,
		172,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		147,
		144,
		120,
		104,
		108,
		101,
		96,
		134,
		110,
		118,
		122,
		126,
		132,
		137,
		142,
		148,
		163,
		178,
		-1,
		192,
		269,
		262,
		230,
		238,
		269,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		120,
		117,
		122,
		111,
		108,
		120,
		119,
		130,
		132,
		137,
		125,
		124,
		142,
		146,
		155,
		162,
		152,
		165,
		169,
		-1,
		206,
		245,
		224,
		227,
		251,
		265,
		-1,
		167,
		-1,
		-1,
		179,
		151,
		135,
		125,
		119,
		169,
		125,
		120,
		122,
		124,
		128,
		119,
		142,
		133,
		133,
		136,
		151,
		156,
		148,
		162,
		162,
		163,
		-1,
		214,
		225,
		218,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		195,
		-1,
		162,
		-1,
		137,
		141,
		133,
		136,
		147,
		134,
		132,
		140,
		148,
		131,
		141,
		137,
		138,
		147,
		158,
		170,
		169,
		170,
		239,
		195,
		198,
		209,
		220,
		235,
		239,
		-1,
		179,
		218,
		233,
		-1,
		204,
		-1,
		-1,
		-1,
		151,
		146,
		138,
		154,
		146,
		146,
		126,
		130,
		136,
		143,
		153,
		155,
		147,
		151,
		164,
		175,
		178,
		235,
		226,
		239,
		184,
		184,
		205,
		214,
		235,
		194,
		185,
		212,
		238,
		229,
		224,
		211,
		-1,
		-1,
		174,
		156,
		-1,
		-1,
		153,
		147,
		130,
		132,
		136,
		146,
		161,
		164,
		154,
		152,
		146,
		178,
		-1,
		228,
		227,
		216,
		213,
		189,
		180,
		175,
		202,
		-1,
		-1,
		197,
		213,
		208,
		212,
		228,
		253,
		-1,
		214,
		-1,
		-1,
		195,
		-1,
		-1,
		189,
		152,
		141,
		132,
		138,
		144,
		155,
		172,
		160,
		161,
		151,
		161,
		174,
		212,
		209,
		197,
		195,
		218,
		183,
		171,
		-1,
		184,
		182,
		188,
		195,
		212,
		242,
		-1,
		-1,
		230,
		210,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		137,
		142,
		167,
		174,
		169,
		163,
		157,
		164,
		163,
		171,
		179,
		221,
		235,
		224,
		220,
		219,
		227,
		176,
		169,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		216,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		159,
		159,
		162,
		160,
		155,
		166,
		158,
		162,
		179,
		-1,
		255,
		-1,
		207,
		183,
		197,
		212,
		220,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		195,
		163,
		168,
		163,
		161,
		172,
		161,
		164,
		178,
		173,
		-1,
		-1,
		195,
		198,
		-1,
		-1,
		220,
		229,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		152,
		177,
		166,
		174,
		169,
		165,
		171,
		174,
		163,
		167,
		179,
		-1,
		-1,
		202,
		203,
		208,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		190,
		153,
		170,
		184,
		189,
		187,
		178,
		169,
		176,
		174,
		170,
		181,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		150,
		175,
		183,
		200,
		194,
		172,
		187,
		177,
		168,
		177,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		217,
		192,
		187,
		174,
		181,
		181,
		174,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		207,
		203,
		194,
		194,
		182,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		181,
		213,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		175,
		180,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		191,
		193,
		159,
		153,
		192,
		163,
		169,
		180,
		-1,
		-1,
		-1,
		182,
		181,
		151,
		149,
		158,
		163,
		170,
		-1,
		174,
		-1,
		203,
		182,
		193,
		198,
		144,
		141,
		161,
		180,
		167,
		159,
		218,
		174,
		145,
		139,
		157,
		152,
		161,
		153,
		-1,
		145,
		135,
		157,
		141,
		152,
		144,
		-1,
		-1,
		139,
		140,
		146,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		129,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		118,
		136,
		145,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		131,
		-1,
		127,
		128,
		123,
		131,
		136,
		120,
		107,
		107,
		117,
		110,
		129,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		127,
		110,
		127,
		119,
		109,
		124,
		117,
		110,
		107,
		105,
		102,
		118,
		119,
		129,
		-1,
		-1,
		206,
		175,
		210,
		167,
		152,
		-1,
		123,
		103,
		109,
		113,
		107,
		100,
		114,
		110,
		-1,
		96,
		95,
		126,
		112,
		123,
		166,
		-1,
		-1,
		164,
		156,
		141,
		144,
		133,
		129,
		118,
		117,
		109,
		95,
		91,
		97,
		100,
		100,
		106,
		90,
		100,
		104,
		114,
		130,
		-1,
		-1,
		176,
		-1,
		-1,
		163,
		146,
		-1,
		129,
		136,
		136,
		145,
		131,
		152,
		128,
		119,
		111,
		105,
		93,
		95,
		92,
		105,
		93,
		87,
		112,
		116,
		109,
		130,
		125,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		122,
		125,
		131,
		155,
		165,
		-1,
		140,
		128,
		129,
		114,
		111,
		98,
		86,
		99,
		84,
		91,
		90,
		94,
		96,
		129,
		106,
		128,
		125,
		146,
		151,
		145,
		154,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		159,
		-1,
		173,
		172,
		147,
		125,
		128,
		115,
		106,
		93,
		82,
		93,
		82,
		79,
		87,
		95,
		107,
		101,
		100,
		118,
		130,
		138,
		142,
		148,
		-1,
		221,
		-1,
		163,
		147,
		149,
		121,
		142,
		-1,
		179,
		174,
		164,
		149,
		140,
		-1,
		124,
		121,
		111,
		89,
		74,
		91,
		83,
		81,
		86,
		90,
		104,
		95,
		113,
		120,
		120,
		124,
		144,
		156,
		181,
		171,
		-1,
		153,
		158,
		117,
		125,
		144,
		182,
		146,
		-1,
		141,
		-1,
		126,
		139,
		-1,
		95,
		91,
		73,
		74,
		69,
		84,
		89,
		86,
		83,
		101,
		104,
		113,
		117,
		133,
		-1,
		-1,
		166,
		170,
		159,
		110,
		129,
		153,
		190,
		139,
		128,
		127,
		-1,
		118,
		109,
		106,
		94,
		81,
		66,
		67,
		75,
		87,
		66,
		85,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		136,
		107,
		131,
		173,
		157,
		150,
		138,
		103,
		103,
		97,
		-1,
		105,
		84,
		75,
		64,
		62,
		75,
		67,
		85,
		82,
		80,
		99,
		111,
		102,
		122,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		102,
		125,
		162,
		136,
		122,
		127,
		102,
		95,
		89,
		115,
		101,
		79,
		71,
		63,
		52,
		63,
		71,
		75,
		78,
		87,
		93,
		117,
		123,
		129,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		116,
		123,
		155,
		127,
		140,
		-1,
		94,
		-1,
		83,
		74,
		72,
		65,
		68,
		49,
		54,
		68,
		77,
		85,
		80,
		87,
		122,
		122,
		113,
		133,
		136,
		-1,
		-1,
		-1,
		166,
		161,
		136,
		113,
		97,
		133,
		-1,
		110,
		111,
		-1,
		88,
		82,
		77,
		69,
		70,
		53,
		53,
		54,
		68,
		52,
		71,
		73,
		72,
		108,
		-1,
		121,
		115,
		123,
		113,
		101,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		92,
		144,
		-1,
		-1,
		95,
		88,
		-1,
		75,
		57,
		51,
		43,
		37,
		46,
		39,
		46,
		59,
		64,
		77,
		75,
		105,
		109,
		114,
		103,
		99,
		96,
		110,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		112,
		-1,
		104,
		96,
		86,
		80,
		74,
		68,
		66,
		65,
		49,
		52,
		47,
		44,
		50,
		53,
		56,
		72,
		82,
		100,
		109,
		101,
		95,
		94,
		106,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		125,
		-1,
		89,
		103,
		119,
		-1,
		112,
		91,
		106,
		84,
		78,
		63,
		53,
		54,
		24,
		29,
		40,
		50,
		77,
		67,
		90,
		83,
		105,
		105,
		89,
		90,
		99,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		86,
		74,
		106,
		-1,
		-1,
		148,
		-1,
		82,
		99,
		77,
		75,
		43,
		17,
		24,
		51,
		54,
		64,
		72,
		61,
		67,
		77,
		99,
		85,
		83,
		102,
		118,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		123,
		-1,
		126,
		116,
		100,
		85,
		118,
		-1,
		4,
		10,
		19,
		-1,
		89,
		-1,
		63,
		76,
		76,
		72,
		71,
		82,
		80,
		91,
		108,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		113,
		107,
		107,
		91,
		94,
		20,
		0,
		12,
		19,
		74,
		61,
		60,
		66,
		71,
		75,
		74,
		87,
		107,
		98,
		110,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		175,
		130,
		116,
		-1,
		100,
		56,
		44,
		34,
		24,
		61,
		62,
		52,
		57,
		66,
		78,
		83,
		83,
		88,
		109,
		110,
		123,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		122,
		138,
		130,
		101,
		45,
		-1,
		-1,
		39,
		37,
		47,
		53,
		68,
		82,
		89,
		98,
		82,
		97,
		109,
		117,
		122,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		155,
		107,
		96,
		91,
		95,
		42,
		-1,
		47,
		48,
		66,
		78,
		85,
		100,
		95,
		89,
		92,
		110,
		127,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		112,
		113,
		84,
		77,
		81,
		-1,
		56,
		56,
		68,
		79,
		91,
		96,
		101,
		88,
		98,
		95,
		108,
		122,
		126,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		130,
		145,
		123,
		100,
		73,
		68,
		61,
		55,
		60,
		80,
		86,
		97,
		82,
		86,
		97,
		101,
		100,
		117,
		127,
		-1,
		-1,
		144,
		161,
		156,
		138,
		142,
		150,
		-1,
		-1,
		77,
		68,
		59,
		62,
		70,
		73,
		78,
		80,
		98,
		113,
		101,
		110,
		128,
		131,
		-1,
		-1,
		-1,
		164,
		-1,
		179,
		-1,
		-1,
		157,
		148,
		95,
		77,
		73,
		71,
		64,
		73,
		68,
		73,
		98,
		93,
		102,
		103,
		111,
		134,
		123,
		162,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		166,
		158,
		153,
		159,
		161,
		152,
		110,
		107,
		-1,
		77,
		102,
		74,
		81,
		73,
		86,
		91,
		97,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		159,
		155,
		145,
		135,
		138,
		-1,
		-1,
		126,
		123,
		99,
		83,
		87,
		80,
		75,
		113,
		89,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		171,
		248,
		241,
		209,
		217,
		248,
		-1,
		149,
		141,
		152,
		127,
		129,
		-1,
		-1,
		99,
		96,
		101,
		90,
		87,
		99,
		98,
		109,
		111,
		116,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		185,
		224,
		203,
		206,
		230,
		244,
		-1,
		146,
		-1,
		-1,
		158,
		130,
		114,
		104,
		98,
		148,
		104,
		99,
		101,
		103,
		107,
		98,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		174,
		-1,
		141,
		-1,
		116,
		120,
		112,
		115,
		126,
		113,
		111,
		119,
		127,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		158,
		197,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		130,
		125,
		117,
		133,
		125,
		125,
		105,
		109,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		173,
		164,
		191,
		217,
		208,
		203,
		190,
		-1,
		-1,
		153,
		135,
		-1,
		-1,
		132,
		126,
		109,
		111,
		115,
		125,
		140,
		143,
		133,
		131,
		125,
		157,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		192,
		187,
		191,
		207,
		232,
		-1,
		193,
		-1,
		-1,
		174,
		-1,
		-1,
		168,
		131,
		120,
		111,
		117,
		123,
		134,
		151,
		139,
		140,
		130,
		140,
		153,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		191,
		221,
		-1,
		-1,
		209,
		189,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		116,
		121,
		146,
		153,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		199,
		195,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		138,
		138,
		141,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		234,
		-1,
		186,
		162,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		216,
		202,
		195,
		183,
		181,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		174,
		142,
		147,
		142,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		174,
		177,
		-1,
		-1,
		199,
		208,
		-1,
		207,
		196,
		181,
		173,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		131,
		156,
		145,
		153,
		148,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		181,
		182,
		187,
		-1,
		191,
		-1,
		209,
		-1,
		176,
		182,
		170,
		-1,
		-1,
		-1,
		169,
		132,
		149,
		163,
		168,
		166,
		157,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		209,
		183,
		216,
		207,
		190,
		170,
		162,
		181,
		-1,
		151,
		-1,
		126,
		129,
		154,
		162,
		179,
		173,
		151,
		166,
		156,
		147,
		156,
		215,
		-1,
		185,
		218,
		182,
		176,
		152,
		156,
		172,
		-1,
		148,
		130,
		-1,
		158,
		148,
		196,
		171,
		166,
		153,
		160,
		160,
		153,
		-1,
		-1,
		-1,
		187,
		186,
		178,
		172,
		172,
		157,
		148,
		-1,
		160,
		142,
		121,
		138,
		138,
		129,
		137,
		186,
		182,
		173,
		173,
		161,
		-1,
		288,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		181,
		176,
		149,
		137,
		143,
		139,
		125,
		131,
		133,
		141,
		139,
		136,
		148,
		144,
		164,
		160,
		192,
		-1,
		283,
		-1,
		217,
		-1,
		-1,
		199,
		179,
		171,
		160,
		149,
		147,
		138,
		129,
		151,
		167,
		151,
		149,
		154,
		159,
		-1,
		272,
		271,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		195,
		156,
		-1,
		158,
		138,
		-1,
		160,
		156,
		-1,
		-1,
		259,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		190,
		174,
		-1,
		149,
		149,
		-1,
		-1,
		-1,
		244,
		243,
		-1,
		212,
		215,
		-1,
		205,
		196,
		204,
		151,
		155,
		-1,
		-1,
		-1,
		253,
		234,
		228,
		227,
		225,
		220,
		217,
		203,
		187,
		165,
		154,
		175,
		-1,
		-1,
		-1,
		225,
		217,
		210,
		-1,
		-1,
		212,
		195,
		176,
		174,
		-1,
		-1,
		-1,
		247,
		228,
		-1,
		-1,
		202,
		-1,
		-1,
		208,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		236,
		-1,
		-1,
		-1,
		198,
		194,
		195,
		-1,
		-1,
		-1,
		-1,
		258,
		259,
		282,
		246,
		-1,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		261,
		259,
		-1,
		-1,
		-1,
		218,
		202,
		-1,
		188,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		223,
		-1,
		223,
		198,
		205,
		-1,
		-1,
		-1,
		-1,
		236,
		228,
		236,
		-1,
		208,
		210,
		-1,
		258,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		213,
		220,
		242,
		245,
		281,
		-1,
		232
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		189,
		191,
		157,
		151,
		190,
		161,
		167,
		178,
		-1,
		-1,
		-1,
		180,
		179,
		149,
		147,
		156,
		161,
		168,
		-1,
		172,
		-1,
		201,
		180,
		191,
		196,
		142,
		139,
		159,
		178,
		165,
		157,
		216,
		172,
		143,
		137,
		155,
		150,
		159,
		151,
		-1,
		143,
		133,
		155,
		139,
		150,
		142,
		-1,
		-1,
		137,
		138,
		144,
		135,
		141,
		137,
		-1,
		147,
		131,
		-1,
		-1,
		127,
		133,
		117,
		120,
		128,
		126,
		139,
		131,
		126,
		-1,
		-1,
		123,
		119,
		126,
		113,
		109,
		126,
		139,
		121,
		135,
		134,
		-1,
		116,
		134,
		143,
		120,
		118,
		102,
		100,
		118,
		120,
		126,
		129,
		-1,
		125,
		126,
		121,
		129,
		134,
		118,
		105,
		105,
		115,
		108,
		127,
		118,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		125,
		108,
		125,
		117,
		107,
		122,
		115,
		108,
		105,
		103,
		100,
		116,
		117,
		127,
		-1,
		-1,
		204,
		173,
		208,
		165,
		150,
		-1,
		121,
		101,
		107,
		111,
		105,
		98,
		112,
		108,
		-1,
		94,
		93,
		124,
		110,
		121,
		164,
		-1,
		-1,
		162,
		154,
		139,
		142,
		131,
		127,
		116,
		115,
		107,
		93,
		89,
		95,
		98,
		98,
		104,
		88,
		98,
		102,
		112,
		128,
		-1,
		-1,
		174,
		-1,
		-1,
		161,
		144,
		-1,
		127,
		134,
		134,
		143,
		129,
		150,
		126,
		117,
		109,
		103,
		91,
		93,
		90,
		103,
		91,
		85,
		110,
		114,
		107,
		128,
		123,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		120,
		123,
		129,
		153,
		163,
		-1,
		138,
		126,
		127,
		112,
		109,
		96,
		84,
		97,
		82,
		89,
		88,
		92,
		94,
		127,
		104,
		126,
		123,
		144,
		149,
		143,
		152,
		-1,
		169,
		165,
		161,
		168,
		117,
		-1,
		-1,
		157,
		-1,
		171,
		170,
		145,
		123,
		126,
		113,
		104,
		91,
		80,
		91,
		80,
		77,
		85,
		93,
		105,
		99,
		98,
		116,
		128,
		136,
		140,
		146,
		-1,
		219,
		-1,
		161,
		145,
		147,
		119,
		140,
		-1,
		177,
		172,
		162,
		147,
		138,
		-1,
		122,
		119,
		109,
		87,
		72,
		89,
		81,
		79,
		84,
		88,
		102,
		93,
		111,
		118,
		118,
		122,
		142,
		154,
		179,
		169,
		-1,
		151,
		156,
		115,
		123,
		142,
		180,
		144,
		-1,
		139,
		-1,
		124,
		137,
		-1,
		93,
		89,
		71,
		72,
		67,
		82,
		87,
		84,
		81,
		99,
		102,
		111,
		115,
		131,
		-1,
		-1,
		164,
		168,
		157,
		108,
		127,
		151,
		188,
		137,
		126,
		125,
		-1,
		116,
		107,
		104,
		92,
		79,
		64,
		65,
		73,
		85,
		64,
		83,
		82,
		102,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		134,
		105,
		129,
		171,
		155,
		148,
		136,
		101,
		101,
		95,
		-1,
		103,
		82,
		73,
		62,
		60,
		73,
		65,
		83,
		80,
		78,
		97,
		109,
		100,
		120,
		-1,
		-1,
		-1,
		164,
		153,
		154,
		100,
		123,
		160,
		134,
		120,
		125,
		100,
		93,
		87,
		113,
		99,
		77,
		69,
		61,
		50,
		61,
		69,
		73,
		76,
		85,
		91,
		115,
		121,
		127,
		-1,
		-1,
		171,
		161,
		145,
		147,
		144,
		114,
		121,
		153,
		125,
		138,
		-1,
		92,
		-1,
		81,
		72,
		70,
		63,
		66,
		47,
		52,
		66,
		75,
		83,
		78,
		85,
		120,
		120,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		164,
		159,
		134,
		111,
		95,
		131,
		-1,
		108,
		109,
		-1,
		86,
		80,
		75,
		67,
		68,
		51,
		51,
		52,
		66,
		50,
		69,
		71,
		70,
		106,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		157,
		136,
		129,
		149,
		90,
		142,
		-1,
		-1,
		93,
		86,
		-1,
		73,
		55,
		49,
		41,
		35,
		44,
		37,
		44,
		57,
		62,
		75,
		73,
		103,
		107,
		112,
		101,
		97,
		94,
		108,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		110,
		-1,
		102,
		94,
		84,
		78,
		72,
		66,
		64,
		63,
		47,
		50,
		45,
		42,
		48,
		51,
		54,
		70,
		80,
		98,
		107,
		99,
		93,
		92,
		104,
		-1,
		177,
		163,
		134,
		-1,
		-1,
		123,
		-1,
		87,
		101,
		117,
		-1,
		110,
		89,
		104,
		82,
		76,
		61,
		53,
		54,
		24,
		29,
		38,
		48,
		67,
		65,
		88,
		81,
		103,
		103,
		87,
		88,
		97,
		-1,
		183,
		170,
		128,
		124,
		113,
		133,
		84,
		72,
		104,
		-1,
		-1,
		146,
		-1,
		80,
		97,
		75,
		73,
		43,
		17,
		24,
		49,
		52,
		56,
		70,
		59,
		65,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		99,
		86,
		80,
		-1,
		121,
		-1,
		124,
		114,
		98,
		83,
		116,
		-1,
		14,
		10,
		19,
		-1,
		81,
		-1,
		53,
		66,
		66,
		68,
		69,
		80,
		78,
		89,
		106,
		-1,
		133,
		118,
		111,
		101,
		115,
		86,
		-1,
		141,
		-1,
		-1,
		111,
		105,
		105,
		89,
		92,
		30,
		10,
		0,
		19,
		64,
		51,
		50,
		56,
		61,
		65,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		138,
		124,
		128,
		88,
		107,
		-1,
		-1,
		173,
		128,
		114,
		-1,
		98,
		44,
		32,
		22,
		12,
		51,
		52,
		42,
		47,
		56,
		68,
		73,
		81,
		86,
		107,
		108,
		121,
		-1,
		-1,
		121,
		126,
		114,
		100,
		119,
		-1,
		-1,
		-1,
		120,
		136,
		128,
		99,
		33,
		-1,
		-1,
		28,
		27,
		37,
		43,
		58,
		72,
		79,
		94,
		80,
		95,
		107,
		115,
		120,
		-1,
		124,
		111,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		-1,
		-1,
		152,
		97,
		86,
		79,
		85,
		32,
		-1,
		37,
		38,
		56,
		68,
		75,
		96,
		90,
		84,
		90,
		108,
		125,
		-1,
		-1,
		136,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		74,
		67,
		71,
		-1,
		46,
		46,
		58,
		69,
		81,
		86,
		94,
		78,
		92,
		93,
		106,
		120,
		124,
		159,
		-1,
		142,
		-1,
		-1,
		-1,
		127,
		142,
		113,
		90,
		63,
		58,
		51,
		45,
		50,
		70,
		76,
		87,
		72,
		76,
		91,
		99,
		98,
		115,
		125,
		-1,
		-1,
		142,
		159,
		153,
		135,
		139,
		140,
		-1,
		-1,
		67,
		58,
		49,
		52,
		60,
		63,
		68,
		70,
		88,
		107,
		95,
		108,
		125,
		121,
		-1,
		-1,
		-1,
		162,
		-1,
		177,
		-1,
		-1,
		154,
		138,
		85,
		67,
		63,
		61,
		54,
		63,
		58,
		63,
		88,
		83,
		92,
		97,
		101,
		124,
		113,
		152,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		100,
		97,
		-1,
		67,
		92,
		64,
		71,
		63,
		76,
		81,
		87,
		91,
		98,
		114,
		113,
		108,
		144,
		135,
		141,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		116,
		113,
		89,
		73,
		77,
		70,
		65,
		103,
		79,
		87,
		91,
		95,
		101,
		106,
		111,
		117,
		132,
		147,
		-1,
		169,
		238,
		231,
		199,
		207,
		238,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		89,
		86,
		91,
		80,
		77,
		89,
		88,
		99,
		101,
		106,
		94,
		93,
		111,
		115,
		124,
		131,
		121,
		134,
		138,
		-1,
		183,
		214,
		193,
		196,
		220,
		234,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		88,
		138,
		94,
		89,
		91,
		93,
		97,
		88,
		111,
		102,
		102,
		105,
		120,
		125,
		117,
		131,
		131,
		132,
		-1,
		183,
		194,
		187,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		164,
		-1,
		131,
		-1,
		106,
		110,
		102,
		105,
		116,
		103,
		101,
		109,
		117,
		100,
		110,
		106,
		107,
		116,
		127,
		139,
		138,
		139,
		208,
		164,
		167,
		178,
		189,
		204,
		208,
		-1,
		148,
		187,
		202,
		-1,
		173,
		-1,
		-1,
		-1,
		120,
		115,
		107,
		123,
		115,
		115,
		95,
		99,
		105,
		112,
		122,
		124,
		116,
		120,
		133,
		144,
		147,
		204,
		195,
		208,
		153,
		153,
		174,
		183,
		204,
		163,
		154,
		181,
		207,
		198,
		193,
		180,
		-1,
		-1,
		143,
		125,
		-1,
		-1,
		122,
		116,
		99,
		101,
		105,
		115,
		130,
		133,
		123,
		121,
		115,
		147,
		-1,
		197,
		196,
		185,
		182,
		158,
		149,
		144,
		171,
		-1,
		-1,
		166,
		182,
		177,
		181,
		197,
		222,
		-1,
		183,
		-1,
		-1,
		164,
		-1,
		-1,
		158,
		121,
		110,
		101,
		107,
		113,
		124,
		141,
		129,
		130,
		120,
		130,
		143,
		181,
		178,
		166,
		164,
		187,
		152,
		140,
		-1,
		153,
		151,
		157,
		164,
		181,
		211,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		156,
		154,
		143,
		-1,
		133,
		106,
		111,
		136,
		143,
		138,
		132,
		126,
		133,
		132,
		140,
		148,
		190,
		204,
		193,
		189,
		188,
		196,
		145,
		138,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		151,
		144,
		132,
		120,
		110,
		120,
		128,
		128,
		131,
		129,
		124,
		135,
		127,
		131,
		148,
		-1,
		224,
		-1,
		176,
		152,
		166,
		181,
		189,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		185,
		169,
		150,
		-1,
		120,
		133,
		164,
		132,
		137,
		132,
		130,
		141,
		130,
		133,
		147,
		142,
		-1,
		-1,
		164,
		167,
		-1,
		-1,
		189,
		198,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		157,
		153,
		-1,
		-1,
		121,
		146,
		135,
		143,
		138,
		134,
		140,
		143,
		132,
		136,
		148,
		-1,
		-1,
		171,
		172,
		177,
		-1,
		181,
		-1,
		199,
		-1,
		166,
		172,
		160,
		-1,
		-1,
		-1,
		159,
		122,
		139,
		153,
		158,
		156,
		147,
		138,
		145,
		143,
		139,
		150,
		-1,
		-1,
		-1,
		199,
		173,
		206,
		197,
		180,
		160,
		152,
		171,
		-1,
		141,
		-1,
		116,
		119,
		144,
		152,
		169,
		163,
		141,
		156,
		146,
		137,
		146,
		205,
		-1,
		175,
		208,
		172,
		166,
		142,
		146,
		162,
		-1,
		138,
		120,
		-1,
		148,
		138,
		186,
		161,
		156,
		143,
		150,
		150,
		143,
		-1,
		-1,
		-1,
		177,
		176,
		168,
		162,
		162,
		147,
		138,
		-1,
		150,
		132,
		111,
		128,
		128,
		119,
		127,
		176,
		172,
		163,
		163,
		151,
		-1,
		278,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		171,
		166,
		139,
		127,
		133,
		129,
		115,
		121,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		150,
		182,
		-1,
		273,
		-1,
		207,
		-1,
		-1,
		189,
		169,
		161,
		150,
		139,
		137,
		128,
		119,
		141,
		157,
		141,
		139,
		144,
		149,
		-1,
		262,
		261,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		185,
		146,
		-1,
		148,
		128,
		-1,
		150,
		146,
		-1,
		-1,
		249,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		180,
		164,
		-1,
		139,
		139,
		-1,
		-1,
		-1,
		234,
		233,
		-1,
		202,
		205,
		-1,
		195,
		186,
		194,
		141,
		145,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		217,
		215,
		210,
		207,
		193,
		177,
		155,
		144,
		165,
		-1,
		-1,
		-1,
		215,
		207,
		200,
		-1,
		-1,
		202,
		185,
		166,
		164,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		192,
		-1,
		-1,
		198,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		226,
		-1,
		-1,
		-1,
		188,
		184,
		185,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		272,
		236,
		-1,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		178,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		213,
		-1,
		213,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		226,
		218,
		226,
		-1,
		198,
		200,
		-1,
		248,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		203,
		210,
		232,
		235,
		271,
		-1,
		222
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		190,
		192,
		158,
		152,
		191,
		162,
		168,
		179,
		-1,
		-1,
		-1,
		181,
		180,
		150,
		148,
		157,
		162,
		169,
		-1,
		173,
		-1,
		202,
		181,
		192,
		197,
		143,
		140,
		160,
		179,
		166,
		158,
		217,
		173,
		144,
		138,
		156,
		151,
		160,
		152,
		-1,
		144,
		134,
		156,
		140,
		151,
		143,
		-1,
		-1,
		138,
		139,
		145,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		128,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		117,
		135,
		144,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		130,
		-1,
		126,
		127,
		122,
		130,
		135,
		119,
		106,
		106,
		116,
		109,
		128,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		126,
		109,
		126,
		118,
		108,
		123,
		116,
		109,
		106,
		104,
		101,
		117,
		118,
		128,
		-1,
		-1,
		205,
		174,
		209,
		166,
		151,
		-1,
		122,
		102,
		108,
		112,
		106,
		99,
		113,
		109,
		-1,
		95,
		94,
		125,
		111,
		122,
		165,
		-1,
		-1,
		163,
		155,
		140,
		143,
		132,
		128,
		117,
		116,
		108,
		94,
		90,
		96,
		99,
		99,
		105,
		89,
		99,
		103,
		113,
		129,
		-1,
		-1,
		175,
		-1,
		-1,
		162,
		145,
		-1,
		128,
		135,
		135,
		144,
		130,
		151,
		127,
		118,
		110,
		104,
		92,
		94,
		91,
		104,
		92,
		86,
		111,
		115,
		108,
		129,
		124,
		-1,
		174,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		121,
		124,
		130,
		154,
		164,
		-1,
		139,
		127,
		128,
		113,
		110,
		97,
		85,
		98,
		83,
		90,
		89,
		93,
		95,
		128,
		105,
		127,
		124,
		145,
		150,
		144,
		153,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		158,
		-1,
		172,
		171,
		146,
		124,
		127,
		114,
		105,
		92,
		81,
		92,
		81,
		78,
		86,
		94,
		106,
		100,
		99,
		117,
		129,
		137,
		141,
		147,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		178,
		173,
		163,
		148,
		139,
		-1,
		123,
		120,
		110,
		88,
		73,
		90,
		82,
		80,
		85,
		89,
		103,
		94,
		112,
		119,
		119,
		123,
		143,
		155,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		181,
		145,
		-1,
		140,
		-1,
		125,
		138,
		-1,
		94,
		90,
		72,
		73,
		68,
		83,
		88,
		85,
		82,
		100,
		103,
		112,
		116,
		132,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		117,
		108,
		105,
		93,
		80,
		65,
		66,
		74,
		86,
		65,
		84,
		83,
		103,
		129,
		107,
		119,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		104,
		83,
		74,
		63,
		61,
		74,
		66,
		84,
		81,
		79,
		98,
		110,
		101,
		121,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		88,
		114,
		100,
		78,
		70,
		62,
		51,
		62,
		70,
		74,
		77,
		86,
		92,
		116,
		122,
		128,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		93,
		-1,
		82,
		73,
		71,
		64,
		67,
		48,
		53,
		67,
		76,
		84,
		79,
		86,
		121,
		121,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		87,
		81,
		76,
		68,
		69,
		52,
		52,
		53,
		67,
		51,
		70,
		72,
		71,
		107,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		74,
		56,
		50,
		42,
		36,
		45,
		38,
		45,
		58,
		63,
		76,
		74,
		104,
		108,
		113,
		102,
		98,
		95,
		109,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		67,
		65,
		64,
		48,
		51,
		46,
		43,
		49,
		52,
		55,
		71,
		81,
		99,
		108,
		100,
		94,
		93,
		105,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		77,
		62,
		52,
		53,
		23,
		28,
		39,
		49,
		77,
		66,
		89,
		82,
		104,
		104,
		88,
		89,
		98,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		76,
		74,
		42,
		16,
		23,
		50,
		53,
		63,
		71,
		60,
		66,
		76,
		98,
		84,
		82,
		101,
		117,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		29,
		13,
		0,
		-1,
		88,
		-1,
		70,
		81,
		79,
		71,
		70,
		81,
		79,
		90,
		107,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		45,
		25,
		23,
		0,
		81,
		68,
		67,
		73,
		77,
		74,
		73,
		86,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		66,
		54,
		44,
		34,
		68,
		69,
		59,
		64,
		73,
		84,
		82,
		82,
		87,
		108,
		109,
		122,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		55,
		-1,
		-1,
		46,
		44,
		54,
		60,
		75,
		89,
		96,
		97,
		81,
		96,
		108,
		116,
		121,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		154,
		114,
		103,
		98,
		102,
		49,
		-1,
		54,
		55,
		73,
		85,
		92,
		99,
		94,
		88,
		91,
		109,
		126,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		111,
		120,
		91,
		84,
		88,
		-1,
		63,
		63,
		75,
		86,
		98,
		103,
		100,
		92,
		97,
		94,
		107,
		121,
		125,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		129,
		144,
		130,
		107,
		80,
		75,
		68,
		62,
		67,
		87,
		93,
		104,
		89,
		93,
		96,
		100,
		99,
		116,
		126,
		-1,
		-1,
		143,
		160,
		155,
		137,
		141,
		157,
		-1,
		-1,
		84,
		75,
		66,
		69,
		77,
		80,
		85,
		87,
		105,
		112,
		100,
		109,
		127,
		131,
		-1,
		-1,
		-1,
		163,
		-1,
		178,
		-1,
		-1,
		156,
		155,
		102,
		84,
		80,
		78,
		71,
		80,
		75,
		80,
		105,
		100,
		109,
		102,
		115,
		137,
		127,
		163,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		117,
		114,
		-1,
		84,
		109,
		81,
		88,
		80,
		93,
		98,
		104,
		105,
		112,
		128,
		127,
		122,
		155,
		149,
		155,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		133,
		130,
		106,
		90,
		94,
		87,
		82,
		120,
		96,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		170,
		251,
		244,
		216,
		224,
		255,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		106,
		103,
		108,
		97,
		94,
		106,
		105,
		116,
		115,
		121,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		184,
		227,
		210,
		213,
		237,
		251,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		105,
		155,
		111,
		106,
		108,
		110,
		114,
		105,
		125,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		200,
		207,
		204,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		-1,
		148,
		-1,
		123,
		127,
		119,
		122,
		133,
		120,
		118,
		123,
		134,
		114,
		124,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		165,
		204,
		219,
		-1,
		190,
		-1,
		-1,
		-1,
		137,
		132,
		124,
		140,
		132,
		132,
		112,
		116,
		119,
		126,
		136,
		138,
		130,
		134,
		147,
		158,
		161,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		180,
		171,
		198,
		224,
		215,
		210,
		197,
		-1,
		-1,
		160,
		142,
		-1,
		-1,
		139,
		133,
		116,
		118,
		122,
		129,
		144,
		147,
		137,
		135,
		129,
		161,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		199,
		194,
		198,
		214,
		239,
		-1,
		200,
		-1,
		-1,
		181,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		130,
		141,
		155,
		143,
		144,
		134,
		144,
		157,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		216,
		196,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		123,
		128,
		153,
		160,
		152,
		146,
		140,
		147,
		146,
		154,
		162,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		202,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		145,
		145,
		148,
		143,
		138,
		149,
		141,
		145,
		162,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		144,
		155,
		144,
		147,
		161,
		156,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		206,
		215,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		148,
		154,
		157,
		146,
		150,
		162,
		-1,
		-1,
		188,
		189,
		194,
		-1,
		198,
		-1,
		216,
		-1,
		183,
		189,
		177,
		-1,
		-1,
		-1,
		176,
		139,
		156,
		170,
		175,
		173,
		164,
		152,
		159,
		157,
		153,
		164,
		-1,
		-1,
		-1,
		216,
		190,
		223,
		214,
		197,
		177,
		169,
		188,
		-1,
		158,
		-1,
		133,
		136,
		161,
		169,
		186,
		180,
		155,
		170,
		160,
		151,
		160,
		222,
		-1,
		192,
		225,
		189,
		183,
		159,
		163,
		179,
		-1,
		155,
		137,
		-1,
		165,
		155,
		203,
		178,
		170,
		157,
		164,
		164,
		157,
		-1,
		-1,
		-1,
		194,
		193,
		185,
		179,
		179,
		164,
		155,
		-1,
		167,
		149,
		128,
		145,
		145,
		136,
		144,
		193,
		189,
		177,
		177,
		168,
		-1,
		295,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		188,
		183,
		156,
		144,
		150,
		146,
		132,
		138,
		140,
		148,
		146,
		143,
		155,
		151,
		171,
		167,
		199,
		-1,
		290,
		-1,
		224,
		-1,
		-1,
		206,
		186,
		178,
		167,
		156,
		154,
		145,
		136,
		158,
		174,
		158,
		156,
		161,
		166,
		-1,
		279,
		278,
		-1,
		225,
		217,
		203,
		-1,
		196,
		-1,
		202,
		163,
		-1,
		165,
		145,
		-1,
		167,
		163,
		-1,
		-1,
		266,
		241,
		-1,
		-1,
		-1,
		226,
		206,
		197,
		181,
		-1,
		156,
		156,
		-1,
		-1,
		-1,
		251,
		250,
		-1,
		219,
		222,
		-1,
		212,
		203,
		211,
		158,
		162,
		-1,
		-1,
		-1,
		260,
		241,
		235,
		234,
		232,
		227,
		224,
		210,
		194,
		172,
		161,
		182,
		-1,
		-1,
		-1,
		232,
		224,
		217,
		-1,
		-1,
		219,
		202,
		183,
		181,
		-1,
		-1,
		-1,
		254,
		235,
		-1,
		-1,
		209,
		-1,
		-1,
		215,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		243,
		-1,
		-1,
		-1,
		205,
		201,
		202,
		-1,
		-1,
		-1,
		-1,
		265,
		266,
		289,
		253,
		-1,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		268,
		266,
		-1,
		-1,
		-1,
		225,
		209,
		-1,
		195,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		230,
		-1,
		230,
		205,
		212,
		-1,
		-1,
		-1,
		-1,
		243,
		235,
		243,
		-1,
		215,
		217,
		-1,
		265,
		-1,
		-1,
		258,
		249,
		-1,
		-1,
		220,
		227,
		249,
		252,
		288,
		-1,
		239
	],
	[
		-1,
		204,
		193,
		204,
		212,
		185,
		192,
		-1,
		211,
		215,
		181,
		175,
		214,
		183,
		189,
		200,
		-1,
		-1,
		-1,
		204,
		203,
		171,
		169,
		178,
		183,
		190,
		-1,
		189,
		-1,
		225,
		204,
		215,
		220,
		164,
		161,
		181,
		200,
		182,
		174,
		240,
		194,
		165,
		159,
		177,
		167,
		176,
		168,
		-1,
		165,
		155,
		177,
		156,
		167,
		159,
		-1,
		-1,
		159,
		160,
		166,
		152,
		158,
		154,
		-1,
		164,
		148,
		-1,
		-1,
		149,
		150,
		134,
		137,
		145,
		143,
		156,
		148,
		143,
		-1,
		-1,
		140,
		136,
		143,
		130,
		126,
		143,
		156,
		138,
		152,
		151,
		-1,
		142,
		160,
		169,
		137,
		135,
		119,
		117,
		135,
		137,
		143,
		143,
		-1,
		151,
		152,
		147,
		155,
		159,
		135,
		122,
		122,
		132,
		125,
		144,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		125,
		122,
		120,
		117,
		133,
		131,
		141,
		-1,
		-1,
		244,
		213,
		242,
		200,
		181,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		111,
		110,
		138,
		124,
		135,
		204,
		-1,
		-1,
		202,
		194,
		177,
		180,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		105,
		115,
		119,
		117,
		142,
		-1,
		-1,
		177,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		163,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		102,
		127,
		131,
		112,
		133,
		128,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		192,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		106,
		104,
		134,
		109,
		131,
		128,
		147,
		152,
		146,
		155,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		200,
		201,
		176,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		98,
		113,
		104,
		103,
		121,
		131,
		139,
		143,
		149,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		201,
		193,
		178,
		178,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		110,
		93,
		107,
		98,
		116,
		123,
		121,
		125,
		145,
		157,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		220,
		184,
		-1,
		179,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		104,
		89,
		86,
		104,
		107,
		114,
		118,
		134,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		177,
		166,
		165,
		-1,
		156,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		104,
		83,
		88,
		85,
		105,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		195,
		188,
		176,
		141,
		141,
		135,
		-1,
		129,
		108,
		99,
		88,
		86,
		92,
		84,
		101,
		83,
		81,
		100,
		112,
		103,
		119,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		140,
		163,
		200,
		174,
		160,
		165,
		140,
		133,
		127,
		142,
		125,
		106,
		95,
		87,
		76,
		80,
		88,
		92,
		79,
		88,
		94,
		118,
		107,
		113,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		154,
		161,
		193,
		165,
		178,
		-1,
		132,
		-1,
		121,
		116,
		100,
		95,
		92,
		84,
		71,
		84,
		94,
		81,
		81,
		83,
		123,
		123,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		204,
		199,
		174,
		151,
		135,
		171,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		102,
		98,
		88,
		92,
		86,
		83,
		67,
		85,
		75,
		73,
		97,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		130,
		182,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		98,
		90,
		84,
		74,
		62,
		61,
		74,
		67,
		71,
		66,
		85,
		89,
		98,
		87,
		83,
		80,
		94,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		150,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		112,
		96,
		90,
		71,
		61,
		44,
		56,
		49,
		65,
		62,
		80,
		93,
		85,
		79,
		78,
		90,
		-1,
		217,
		203,
		174,
		-1,
		-1,
		163,
		-1,
		127,
		141,
		157,
		-1,
		150,
		129,
		144,
		122,
		118,
		110,
		103,
		104,
		77,
		65,
		44,
		32,
		35,
		50,
		70,
		67,
		89,
		89,
		73,
		74,
		83,
		-1,
		223,
		210,
		168,
		164,
		153,
		173,
		124,
		112,
		144,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		124,
		122,
		93,
		76,
		75,
		56,
		29,
		24,
		49,
		44,
		50,
		61,
		83,
		69,
		67,
		86,
		102,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		139,
		126,
		120,
		-1,
		161,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		75,
		71,
		78,
		-1,
		49,
		-1,
		24,
		37,
		37,
		55,
		55,
		66,
		64,
		75,
		92,
		-1,
		173,
		158,
		151,
		141,
		155,
		126,
		-1,
		181,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		91,
		71,
		63,
		78,
		0,
		40,
		12,
		45,
		49,
		53,
		58,
		71,
		91,
		82,
		94,
		-1,
		-1,
		-1,
		178,
		164,
		168,
		128,
		147,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		134,
		91,
		79,
		69,
		59,
		64,
		52,
		31,
		36,
		45,
		54,
		61,
		67,
		72,
		93,
		94,
		107,
		-1,
		-1,
		161,
		166,
		154,
		140,
		159,
		-1,
		-1,
		-1,
		160,
		176,
		153,
		132,
		80,
		-1,
		-1,
		63,
		56,
		44,
		45,
		49,
		61,
		68,
		82,
		66,
		81,
		93,
		101,
		106,
		-1,
		164,
		151,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		-1,
		-1,
		165,
		110,
		99,
		94,
		98,
		62,
		-1,
		50,
		51,
		53,
		59,
		66,
		84,
		79,
		73,
		76,
		94,
		111,
		-1,
		-1,
		176,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		122,
		116,
		87,
		80,
		84,
		-1,
		59,
		59,
		55,
		71,
		85,
		82,
		85,
		77,
		82,
		79,
		92,
		106,
		110,
		199,
		-1,
		180,
		-1,
		-1,
		-1,
		140,
		155,
		126,
		103,
		76,
		71,
		64,
		58,
		63,
		79,
		88,
		99,
		84,
		80,
		81,
		85,
		84,
		101,
		111,
		-1,
		-1,
		178,
		174,
		166,
		148,
		152,
		153,
		-1,
		-1,
		80,
		71,
		62,
		65,
		73,
		76,
		81,
		83,
		92,
		97,
		85,
		94,
		112,
		116,
		-1,
		-1,
		-1,
		190,
		-1,
		192,
		-1,
		-1,
		167,
		151,
		98,
		80,
		76,
		74,
		67,
		76,
		71,
		76,
		101,
		96,
		105,
		87,
		100,
		122,
		112,
		148,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		169,
		161,
		156,
		162,
		164,
		155,
		113,
		110,
		-1,
		80,
		105,
		77,
		84,
		76,
		89,
		94,
		100,
		90,
		97,
		113,
		112,
		107,
		140,
		134,
		140,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		162,
		158,
		148,
		138,
		141,
		-1,
		-1,
		129,
		126,
		102,
		86,
		90,
		83,
		78,
		116,
		92,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		209,
		251,
		244,
		212,
		220,
		251,
		-1,
		152,
		144,
		155,
		130,
		132,
		-1,
		-1,
		102,
		99,
		104,
		93,
		90,
		102,
		101,
		112,
		100,
		106,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		207,
		227,
		206,
		209,
		233,
		247,
		-1,
		149,
		-1,
		-1,
		161,
		133,
		117,
		107,
		101,
		151,
		107,
		102,
		104,
		106,
		110,
		101,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		177,
		-1,
		144,
		-1,
		119,
		123,
		115,
		118,
		129,
		116,
		114,
		108,
		124,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		161,
		200,
		215,
		-1,
		186,
		-1,
		-1,
		-1,
		133,
		128,
		120,
		136,
		128,
		128,
		108,
		112,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		176,
		167,
		194,
		220,
		211,
		206,
		193,
		-1,
		-1,
		156,
		138,
		-1,
		-1,
		135,
		129,
		112,
		114,
		111,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		195,
		190,
		194,
		210,
		235,
		-1,
		196,
		-1,
		-1,
		177,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		119,
		130,
		140,
		128,
		129,
		119,
		129,
		142,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		166,
		164,
		170,
		177,
		194,
		224,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		119,
		124,
		146,
		148,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		139,
		141,
		135,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		237,
		-1,
		189,
		165,
		179,
		194,
		202,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		177,
		180,
		-1,
		-1,
		202,
		211,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		184,
		185,
		190,
		-1,
		194,
		-1,
		212,
		-1,
		179,
		185,
		173,
		-1,
		-1,
		-1,
		172,
		135,
		152,
		166,
		162,
		160,
		151,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		212,
		186,
		219,
		210,
		193,
		173,
		165,
		184,
		-1,
		154,
		-1,
		129,
		132,
		157,
		165,
		173,
		167,
		140,
		155,
		145,
		136,
		145,
		218,
		-1,
		188,
		221,
		185,
		179,
		155,
		159,
		175,
		-1,
		151,
		133,
		-1,
		161,
		151,
		189,
		174,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		175,
		160,
		151,
		-1,
		163,
		145,
		124,
		141,
		141,
		132,
		140,
		179,
		175,
		162,
		162,
		154,
		-1,
		291,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		179,
		152,
		140,
		146,
		142,
		128,
		134,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		155,
		190,
		-1,
		286,
		-1,
		220,
		-1,
		-1,
		202,
		182,
		174,
		163,
		152,
		150,
		141,
		132,
		154,
		170,
		154,
		152,
		157,
		162,
		-1,
		275,
		274,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		198,
		159,
		-1,
		161,
		141,
		-1,
		163,
		159,
		-1,
		-1,
		262,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		193,
		177,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		247,
		246,
		-1,
		215,
		218,
		-1,
		208,
		199,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		230,
		228,
		223,
		220,
		206,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		228,
		220,
		213,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		239,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		285,
		249,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		138,
		156,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		147,
		148,
		143,
		151,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		240,
		209,
		238,
		196,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		105,
		104,
		132,
		118,
		129,
		200,
		-1,
		-1,
		198,
		190,
		173,
		176,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		99,
		109,
		113,
		111,
		136,
		-1,
		-1,
		171,
		-1,
		-1,
		197,
		180,
		-1,
		163,
		170,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		96,
		121,
		125,
		106,
		127,
		122,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		156,
		159,
		165,
		189,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		100,
		98,
		128,
		103,
		125,
		122,
		141,
		146,
		140,
		149,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		193,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		92,
		107,
		98,
		97,
		115,
		125,
		133,
		137,
		143,
		-1,
		255,
		-1,
		197,
		181,
		183,
		155,
		176,
		-1,
		213,
		197,
		189,
		174,
		174,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		105,
		87,
		101,
		92,
		110,
		117,
		115,
		119,
		139,
		151,
		215,
		205,
		-1,
		187,
		192,
		151,
		159,
		178,
		216,
		180,
		-1,
		175,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		98,
		83,
		80,
		98,
		101,
		108,
		112,
		128,
		-1,
		-1,
		200,
		204,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		107,
		86,
		82,
		79,
		99,
		125,
		103,
		115,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		87,
		97,
		77,
		75,
		94,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		138,
		121,
		102,
		91,
		83,
		72,
		83,
		91,
		91,
		73,
		82,
		88,
		112,
		97,
		103,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		112,
		96,
		91,
		88,
		78,
		74,
		88,
		90,
		80,
		75,
		82,
		117,
		117,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		98,
		94,
		82,
		86,
		86,
		88,
		76,
		84,
		84,
		67,
		92,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		94,
		86,
		80,
		83,
		71,
		70,
		83,
		76,
		72,
		67,
		80,
		84,
		88,
		77,
		73,
		70,
		84,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		108,
		92,
		95,
		80,
		70,
		53,
		65,
		58,
		72,
		57,
		75,
		83,
		75,
		69,
		68,
		80,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		106,
		99,
		100,
		70,
		74,
		53,
		41,
		44,
		58,
		65,
		57,
		79,
		79,
		63,
		64,
		73,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		120,
		118,
		89,
		64,
		71,
		65,
		38,
		33,
		56,
		53,
		49,
		51,
		73,
		59,
		57,
		76,
		92,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		63,
		59,
		66,
		-1,
		58,
		-1,
		30,
		43,
		43,
		41,
		45,
		56,
		54,
		65,
		82,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		127,
		79,
		59,
		51,
		66,
		41,
		0,
		27,
		29,
		34,
		38,
		48,
		61,
		81,
		72,
		84,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		122,
		79,
		67,
		57,
		47,
		52,
		40,
		10,
		20,
		29,
		41,
		46,
		57,
		62,
		83,
		84,
		97,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		141,
		120,
		68,
		-1,
		-1,
		51,
		44,
		32,
		29,
		33,
		45,
		52,
		67,
		56,
		71,
		83,
		91,
		96,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		153,
		98,
		87,
		82,
		86,
		50,
		-1,
		38,
		36,
		37,
		43,
		50,
		69,
		64,
		58,
		66,
		84,
		101,
		-1,
		-1,
		172,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		110,
		104,
		75,
		68,
		72,
		-1,
		47,
		44,
		39,
		55,
		69,
		66,
		70,
		62,
		67,
		69,
		82,
		96,
		100,
		195,
		-1,
		168,
		-1,
		-1,
		-1,
		128,
		143,
		114,
		91,
		64,
		59,
		52,
		46,
		47,
		63,
		72,
		83,
		69,
		65,
		66,
		75,
		74,
		91,
		101,
		-1,
		-1,
		166,
		162,
		154,
		136,
		140,
		141,
		-1,
		-1,
		68,
		59,
		50,
		53,
		57,
		60,
		69,
		71,
		77,
		82,
		70,
		84,
		100,
		106,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		155,
		139,
		86,
		68,
		64,
		62,
		55,
		64,
		59,
		64,
		89,
		84,
		92,
		72,
		90,
		110,
		102,
		138,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		101,
		98,
		-1,
		68,
		93,
		65,
		72,
		64,
		77,
		82,
		88,
		77,
		87,
		103,
		102,
		97,
		130,
		124,
		130,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		117,
		114,
		90,
		74,
		78,
		71,
		66,
		104,
		80,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		121,
		136,
		-1,
		202,
		239,
		232,
		200,
		208,
		239,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		90,
		87,
		92,
		81,
		78,
		90,
		89,
		100,
		90,
		96,
		83,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		137,
		-1,
		-1,
		149,
		121,
		105,
		95,
		89,
		139,
		95,
		90,
		92,
		94,
		98,
		89,
		100,
		91,
		91,
		94,
		109,
		114,
		106,
		120,
		120,
		121,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		165,
		-1,
		132,
		-1,
		107,
		111,
		103,
		106,
		117,
		104,
		102,
		98,
		114,
		89,
		99,
		95,
		96,
		105,
		116,
		128,
		127,
		128,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		149,
		188,
		203,
		-1,
		174,
		-1,
		-1,
		-1,
		121,
		116,
		108,
		124,
		116,
		116,
		96,
		100,
		94,
		101,
		111,
		113,
		105,
		109,
		122,
		133,
		136,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		164,
		155,
		182,
		208,
		199,
		194,
		181,
		-1,
		-1,
		144,
		126,
		-1,
		-1,
		123,
		117,
		100,
		102,
		101,
		104,
		119,
		122,
		112,
		110,
		104,
		136,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		167,
		183,
		178,
		182,
		198,
		223,
		-1,
		184,
		-1,
		-1,
		165,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		109,
		120,
		130,
		118,
		119,
		109,
		119,
		132,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		154,
		152,
		158,
		165,
		182,
		212,
		-1,
		-1,
		200,
		180,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		136,
		138,
		127,
		121,
		115,
		122,
		121,
		129,
		137,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		129,
		129,
		125,
		118,
		113,
		124,
		116,
		120,
		137,
		-1,
		225,
		-1,
		177,
		153,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		119,
		130,
		119,
		122,
		136,
		131,
		-1,
		-1,
		165,
		168,
		-1,
		-1,
		190,
		199,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		123,
		129,
		132,
		121,
		125,
		137,
		-1,
		-1,
		172,
		173,
		178,
		-1,
		182,
		-1,
		200,
		-1,
		167,
		173,
		161,
		-1,
		-1,
		-1,
		160,
		123,
		140,
		154,
		152,
		150,
		141,
		127,
		134,
		132,
		128,
		139,
		-1,
		-1,
		-1,
		200,
		174,
		207,
		198,
		181,
		161,
		153,
		172,
		-1,
		142,
		-1,
		117,
		120,
		145,
		153,
		163,
		157,
		130,
		145,
		135,
		126,
		135,
		206,
		-1,
		176,
		209,
		173,
		167,
		143,
		147,
		163,
		-1,
		139,
		121,
		-1,
		149,
		139,
		179,
		162,
		145,
		132,
		139,
		139,
		132,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		163,
		148,
		139,
		-1,
		151,
		133,
		112,
		129,
		129,
		120,
		128,
		169,
		165,
		152,
		152,
		144,
		-1,
		279,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		167,
		140,
		128,
		134,
		130,
		116,
		122,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		145,
		180,
		-1,
		274,
		-1,
		208,
		-1,
		-1,
		190,
		170,
		162,
		151,
		140,
		138,
		129,
		120,
		142,
		158,
		142,
		140,
		145,
		150,
		-1,
		263,
		262,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		186,
		147,
		-1,
		149,
		129,
		-1,
		151,
		147,
		-1,
		-1,
		250,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		181,
		165,
		-1,
		140,
		140,
		-1,
		-1,
		-1,
		235,
		234,
		-1,
		203,
		206,
		-1,
		196,
		187,
		195,
		142,
		146,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		218,
		216,
		211,
		208,
		194,
		178,
		156,
		145,
		166,
		-1,
		-1,
		-1,
		216,
		208,
		201,
		-1,
		-1,
		203,
		186,
		167,
		165,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		193,
		-1,
		-1,
		199,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		227,
		-1,
		-1,
		-1,
		189,
		185,
		186,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		273,
		237,
		-1,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		179,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		214,
		-1,
		214,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		227,
		219,
		227,
		-1,
		199,
		201,
		-1,
		249,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		204,
		211,
		233,
		236,
		272,
		-1,
		223
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		199,
		203,
		169,
		163,
		202,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		192,
		191,
		159,
		157,
		166,
		171,
		178,
		-1,
		177,
		-1,
		213,
		192,
		203,
		208,
		152,
		149,
		169,
		188,
		170,
		162,
		228,
		182,
		153,
		147,
		165,
		155,
		164,
		156,
		-1,
		153,
		143,
		165,
		144,
		155,
		147,
		-1,
		-1,
		147,
		148,
		154,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		137,
		138,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		128,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		139,
		-1,
		130,
		148,
		157,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		131,
		-1,
		139,
		140,
		135,
		143,
		147,
		123,
		110,
		110,
		120,
		113,
		132,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		122,
		139,
		131,
		121,
		136,
		129,
		113,
		110,
		108,
		105,
		121,
		119,
		129,
		-1,
		-1,
		232,
		201,
		230,
		188,
		169,
		-1,
		135,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		99,
		98,
		126,
		112,
		123,
		192,
		-1,
		-1,
		190,
		182,
		165,
		168,
		145,
		141,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		93,
		103,
		107,
		105,
		130,
		-1,
		-1,
		165,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		151,
		157,
		143,
		164,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		90,
		115,
		119,
		100,
		121,
		116,
		-1,
		164,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		180,
		-1,
		152,
		140,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		94,
		92,
		122,
		97,
		119,
		116,
		135,
		140,
		134,
		143,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		188,
		189,
		164,
		137,
		140,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		86,
		101,
		92,
		91,
		109,
		119,
		127,
		131,
		137,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		189,
		181,
		166,
		166,
		-1,
		136,
		133,
		123,
		101,
		86,
		103,
		95,
		93,
		98,
		81,
		95,
		86,
		104,
		111,
		109,
		113,
		133,
		145,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		138,
		151,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		92,
		77,
		74,
		92,
		95,
		102,
		106,
		122,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		121,
		118,
		106,
		93,
		78,
		79,
		87,
		92,
		71,
		76,
		73,
		93,
		119,
		97,
		109,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		117,
		96,
		87,
		76,
		74,
		80,
		72,
		89,
		71,
		69,
		88,
		100,
		91,
		107,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		130,
		113,
		94,
		83,
		75,
		64,
		68,
		76,
		80,
		67,
		76,
		82,
		106,
		95,
		101,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		104,
		88,
		83,
		80,
		72,
		59,
		72,
		82,
		69,
		69,
		71,
		111,
		111,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		90,
		86,
		76,
		80,
		74,
		71,
		55,
		73,
		63,
		61,
		85,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		86,
		78,
		72,
		62,
		50,
		49,
		62,
		55,
		59,
		54,
		73,
		77,
		86,
		75,
		71,
		68,
		82,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		100,
		84,
		78,
		59,
		49,
		32,
		44,
		37,
		53,
		50,
		68,
		81,
		73,
		67,
		66,
		78,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		98,
		91,
		92,
		65,
		53,
		32,
		20,
		23,
		38,
		58,
		55,
		77,
		77,
		61,
		62,
		71,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		112,
		110,
		81,
		64,
		63,
		44,
		17,
		12,
		37,
		32,
		38,
		49,
		71,
		57,
		55,
		74,
		90,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		63,
		59,
		66,
		-1,
		37,
		-1,
		12,
		25,
		25,
		43,
		43,
		54,
		52,
		63,
		80,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		79,
		59,
		51,
		66,
		14,
		28,
		0,
		33,
		37,
		41,
		46,
		59,
		79,
		70,
		82,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		122,
		79,
		67,
		57,
		47,
		52,
		40,
		19,
		24,
		33,
		42,
		49,
		55,
		60,
		81,
		82,
		95,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		141,
		120,
		68,
		-1,
		-1,
		51,
		44,
		32,
		33,
		37,
		49,
		56,
		70,
		54,
		69,
		81,
		89,
		94,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		153,
		98,
		87,
		82,
		86,
		50,
		-1,
		38,
		39,
		41,
		47,
		54,
		72,
		67,
		61,
		64,
		82,
		99,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		110,
		104,
		75,
		68,
		72,
		-1,
		47,
		47,
		43,
		59,
		73,
		70,
		73,
		65,
		70,
		67,
		80,
		94,
		98,
		187,
		-1,
		168,
		-1,
		-1,
		-1,
		128,
		143,
		114,
		91,
		64,
		59,
		52,
		46,
		51,
		67,
		76,
		87,
		72,
		68,
		69,
		73,
		72,
		89,
		99,
		-1,
		-1,
		166,
		162,
		154,
		136,
		140,
		141,
		-1,
		-1,
		68,
		59,
		50,
		53,
		61,
		64,
		69,
		71,
		80,
		85,
		73,
		82,
		100,
		104,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		155,
		139,
		86,
		68,
		64,
		62,
		55,
		64,
		59,
		64,
		89,
		84,
		93,
		75,
		88,
		110,
		100,
		136,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		101,
		98,
		-1,
		68,
		93,
		65,
		72,
		64,
		77,
		82,
		88,
		78,
		85,
		101,
		100,
		95,
		128,
		122,
		128,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		117,
		114,
		90,
		74,
		78,
		71,
		66,
		104,
		80,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		197,
		239,
		232,
		200,
		208,
		239,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		90,
		87,
		92,
		81,
		78,
		90,
		89,
		100,
		88,
		94,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		137,
		-1,
		-1,
		149,
		121,
		105,
		95,
		89,
		139,
		95,
		90,
		92,
		94,
		98,
		89,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		165,
		-1,
		132,
		-1,
		107,
		111,
		103,
		106,
		117,
		104,
		102,
		96,
		112,
		87,
		97,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		149,
		188,
		203,
		-1,
		174,
		-1,
		-1,
		-1,
		121,
		116,
		108,
		124,
		116,
		116,
		96,
		100,
		92,
		99,
		109,
		111,
		103,
		107,
		120,
		131,
		134,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		164,
		155,
		182,
		208,
		199,
		194,
		181,
		-1,
		-1,
		144,
		126,
		-1,
		-1,
		123,
		117,
		100,
		102,
		99,
		102,
		117,
		120,
		110,
		108,
		102,
		134,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		167,
		183,
		178,
		182,
		198,
		223,
		-1,
		184,
		-1,
		-1,
		165,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		107,
		118,
		128,
		116,
		117,
		107,
		117,
		130,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		154,
		152,
		158,
		165,
		182,
		212,
		-1,
		-1,
		200,
		180,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		134,
		136,
		125,
		119,
		113,
		120,
		119,
		127,
		135,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		127,
		129,
		123,
		116,
		111,
		122,
		114,
		118,
		135,
		-1,
		225,
		-1,
		177,
		153,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		165,
		168,
		-1,
		-1,
		190,
		199,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		172,
		173,
		178,
		-1,
		182,
		-1,
		200,
		-1,
		167,
		173,
		161,
		-1,
		-1,
		-1,
		160,
		123,
		140,
		154,
		150,
		148,
		139,
		125,
		132,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		200,
		174,
		207,
		198,
		181,
		161,
		153,
		172,
		-1,
		142,
		-1,
		117,
		120,
		145,
		153,
		161,
		155,
		128,
		143,
		133,
		124,
		133,
		206,
		-1,
		176,
		209,
		173,
		167,
		143,
		147,
		163,
		-1,
		139,
		121,
		-1,
		149,
		139,
		177,
		162,
		143,
		130,
		137,
		137,
		130,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		163,
		148,
		139,
		-1,
		151,
		133,
		112,
		129,
		129,
		120,
		128,
		167,
		163,
		150,
		150,
		142,
		-1,
		279,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		167,
		140,
		128,
		134,
		130,
		116,
		122,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		143,
		178,
		-1,
		274,
		-1,
		208,
		-1,
		-1,
		190,
		170,
		162,
		151,
		140,
		138,
		129,
		120,
		142,
		158,
		142,
		140,
		145,
		150,
		-1,
		263,
		262,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		186,
		147,
		-1,
		149,
		129,
		-1,
		151,
		147,
		-1,
		-1,
		250,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		181,
		165,
		-1,
		140,
		140,
		-1,
		-1,
		-1,
		235,
		234,
		-1,
		203,
		206,
		-1,
		196,
		187,
		195,
		142,
		146,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		218,
		216,
		211,
		208,
		194,
		178,
		156,
		145,
		166,
		-1,
		-1,
		-1,
		216,
		208,
		201,
		-1,
		-1,
		203,
		186,
		167,
		165,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		193,
		-1,
		-1,
		199,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		227,
		-1,
		-1,
		-1,
		189,
		185,
		186,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		273,
		237,
		-1,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		179,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		214,
		-1,
		214,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		227,
		219,
		227,
		-1,
		199,
		201,
		-1,
		249,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		204,
		211,
		233,
		236,
		272,
		-1,
		223
	],
	[
		-1,
		174,
		163,
		174,
		182,
		155,
		162,
		-1,
		181,
		185,
		151,
		145,
		184,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		174,
		173,
		141,
		139,
		148,
		153,
		160,
		-1,
		159,
		-1,
		195,
		174,
		185,
		190,
		134,
		131,
		151,
		170,
		152,
		144,
		210,
		164,
		135,
		129,
		147,
		137,
		146,
		138,
		-1,
		135,
		125,
		147,
		126,
		137,
		129,
		-1,
		-1,
		129,
		130,
		136,
		122,
		128,
		124,
		-1,
		134,
		118,
		-1,
		-1,
		119,
		120,
		104,
		107,
		115,
		113,
		126,
		118,
		113,
		-1,
		-1,
		110,
		106,
		113,
		100,
		96,
		113,
		126,
		108,
		122,
		121,
		-1,
		114,
		132,
		139,
		107,
		105,
		89,
		87,
		105,
		107,
		113,
		113,
		-1,
		123,
		124,
		119,
		127,
		129,
		105,
		92,
		92,
		102,
		95,
		114,
		102,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		123,
		106,
		123,
		115,
		105,
		120,
		113,
		95,
		92,
		90,
		87,
		103,
		101,
		111,
		-1,
		-1,
		216,
		185,
		214,
		172,
		153,
		-1,
		119,
		99,
		105,
		109,
		103,
		96,
		110,
		106,
		-1,
		81,
		80,
		108,
		94,
		105,
		176,
		-1,
		-1,
		174,
		166,
		149,
		152,
		129,
		125,
		114,
		113,
		105,
		91,
		87,
		93,
		96,
		96,
		102,
		75,
		85,
		89,
		87,
		112,
		-1,
		-1,
		147,
		-1,
		-1,
		173,
		156,
		-1,
		139,
		146,
		135,
		141,
		127,
		148,
		124,
		115,
		107,
		101,
		89,
		91,
		88,
		101,
		89,
		72,
		97,
		101,
		82,
		103,
		98,
		-1,
		146,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		132,
		135,
		141,
		165,
		164,
		-1,
		136,
		124,
		125,
		110,
		107,
		94,
		82,
		95,
		80,
		87,
		86,
		76,
		74,
		104,
		79,
		101,
		98,
		117,
		122,
		116,
		125,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		169,
		-1,
		172,
		173,
		148,
		121,
		124,
		111,
		102,
		89,
		78,
		89,
		78,
		75,
		83,
		68,
		83,
		74,
		73,
		91,
		101,
		109,
		113,
		119,
		-1,
		231,
		-1,
		173,
		157,
		159,
		131,
		152,
		-1,
		189,
		173,
		165,
		150,
		150,
		-1,
		120,
		117,
		107,
		85,
		70,
		87,
		79,
		77,
		81,
		63,
		77,
		68,
		86,
		93,
		91,
		95,
		115,
		127,
		191,
		181,
		-1,
		163,
		168,
		127,
		135,
		154,
		192,
		156,
		-1,
		151,
		-1,
		122,
		135,
		-1,
		91,
		87,
		69,
		70,
		65,
		80,
		74,
		59,
		56,
		74,
		77,
		84,
		88,
		104,
		-1,
		-1,
		176,
		180,
		169,
		120,
		139,
		163,
		200,
		149,
		138,
		137,
		-1,
		128,
		105,
		102,
		90,
		77,
		62,
		63,
		71,
		83,
		62,
		58,
		55,
		75,
		101,
		79,
		91,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		146,
		117,
		141,
		183,
		167,
		160,
		148,
		113,
		113,
		107,
		-1,
		101,
		80,
		71,
		60,
		58,
		71,
		63,
		73,
		53,
		51,
		70,
		82,
		73,
		85,
		-1,
		-1,
		-1,
		176,
		165,
		166,
		112,
		135,
		172,
		146,
		132,
		137,
		112,
		105,
		99,
		114,
		97,
		78,
		67,
		59,
		48,
		59,
		67,
		67,
		49,
		58,
		64,
		88,
		73,
		79,
		-1,
		-1,
		183,
		173,
		157,
		159,
		156,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		88,
		72,
		67,
		64,
		54,
		50,
		64,
		66,
		56,
		51,
		58,
		93,
		93,
		63,
		83,
		86,
		-1,
		-1,
		-1,
		176,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		89,
		74,
		70,
		58,
		62,
		62,
		64,
		55,
		60,
		61,
		43,
		68,
		-1,
		71,
		65,
		73,
		63,
		51,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		70,
		65,
		64,
		63,
		60,
		49,
		62,
		55,
		48,
		43,
		56,
		60,
		64,
		53,
		49,
		46,
		60,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		80,
		78,
		92,
		76,
		75,
		72,
		63,
		62,
		44,
		37,
		48,
		33,
		51,
		59,
		51,
		45,
		44,
		56,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		90,
		82,
		99,
		100,
		78,
		72,
		62,
		50,
		49,
		38,
		41,
		33,
		55,
		55,
		39,
		40,
		49,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		96,
		94,
		89,
		73,
		80,
		74,
		47,
		42,
		43,
		32,
		25,
		27,
		49,
		35,
		33,
		52,
		68,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		72,
		68,
		75,
		-1,
		67,
		-1,
		32,
		28,
		19,
		17,
		21,
		32,
		30,
		41,
		58,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		88,
		68,
		60,
		75,
		50,
		33,
		36,
		0,
		10,
		14,
		24,
		37,
		57,
		48,
		60,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		88,
		76,
		66,
		56,
		61,
		49,
		24,
		17,
		5,
		17,
		22,
		33,
		38,
		59,
		60,
		73,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		129,
		108,
		77,
		-1,
		-1,
		60,
		53,
		41,
		26,
		13,
		28,
		35,
		43,
		32,
		47,
		59,
		67,
		72,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		141,
		86,
		75,
		70,
		74,
		59,
		-1,
		46,
		33,
		17,
		31,
		38,
		45,
		40,
		34,
		42,
		60,
		77,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		63,
		56,
		60,
		-1,
		47,
		33,
		19,
		36,
		57,
		54,
		46,
		38,
		43,
		45,
		58,
		72,
		76,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		116,
		131,
		102,
		79,
		52,
		47,
		40,
		34,
		27,
		43,
		52,
		63,
		45,
		41,
		42,
		51,
		50,
		67,
		77,
		-1,
		-1,
		154,
		150,
		142,
		124,
		128,
		129,
		-1,
		-1,
		56,
		47,
		38,
		41,
		37,
		40,
		51,
		48,
		53,
		58,
		46,
		60,
		76,
		82,
		-1,
		-1,
		-1,
		166,
		-1,
		168,
		-1,
		-1,
		143,
		127,
		74,
		56,
		52,
		50,
		43,
		52,
		46,
		51,
		66,
		72,
		68,
		48,
		66,
		86,
		78,
		114,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		145,
		137,
		132,
		138,
		139,
		130,
		89,
		86,
		-1,
		56,
		81,
		52,
		59,
		51,
		65,
		70,
		72,
		53,
		63,
		79,
		78,
		73,
		106,
		100,
		106,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		138,
		134,
		124,
		114,
		116,
		-1,
		-1,
		104,
		101,
		78,
		61,
		66,
		59,
		54,
		85,
		65,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		181,
		226,
		219,
		187,
		195,
		226,
		-1,
		128,
		120,
		131,
		106,
		107,
		-1,
		-1,
		77,
		75,
		80,
		68,
		65,
		78,
		77,
		81,
		66,
		72,
		59,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		125,
		-1,
		-1,
		137,
		108,
		92,
		83,
		76,
		127,
		82,
		77,
		79,
		81,
		78,
		69,
		76,
		67,
		67,
		70,
		85,
		90,
		82,
		96,
		96,
		97,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		153,
		-1,
		119,
		-1,
		94,
		98,
		90,
		93,
		103,
		90,
		82,
		74,
		90,
		65,
		75,
		71,
		72,
		81,
		92,
		104,
		103,
		104,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		137,
		176,
		191,
		-1,
		162,
		-1,
		-1,
		-1,
		108,
		103,
		95,
		111,
		102,
		102,
		76,
		80,
		70,
		77,
		87,
		89,
		81,
		85,
		98,
		109,
		112,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		152,
		143,
		170,
		195,
		187,
		182,
		169,
		-1,
		-1,
		131,
		113,
		-1,
		-1,
		109,
		97,
		80,
		81,
		77,
		80,
		95,
		98,
		88,
		86,
		80,
		112,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		171,
		165,
		169,
		185,
		210,
		-1,
		169,
		-1,
		-1,
		152,
		-1,
		-1,
		139,
		102,
		91,
		82,
		88,
		85,
		96,
		106,
		94,
		95,
		85,
		95,
		108,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		141,
		139,
		145,
		152,
		169,
		199,
		-1,
		-1,
		185,
		165,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		87,
		92,
		112,
		114,
		103,
		97,
		91,
		98,
		97,
		105,
		113,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		171,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		101,
		105,
		109,
		101,
		94,
		89,
		100,
		92,
		96,
		113,
		-1,
		212,
		-1,
		164,
		140,
		154,
		169,
		177,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		145,
		113,
		118,
		113,
		95,
		106,
		95,
		98,
		112,
		107,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		177,
		184,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		102,
		127,
		116,
		124,
		119,
		99,
		105,
		108,
		97,
		101,
		113,
		-1,
		-1,
		159,
		160,
		165,
		-1,
		167,
		-1,
		185,
		-1,
		152,
		158,
		146,
		-1,
		-1,
		-1,
		140,
		103,
		124,
		134,
		128,
		126,
		117,
		103,
		110,
		108,
		104,
		115,
		-1,
		-1,
		-1,
		185,
		159,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		127,
		-1,
		102,
		104,
		130,
		133,
		139,
		133,
		106,
		121,
		111,
		102,
		111,
		191,
		-1,
		161,
		194,
		158,
		152,
		128,
		132,
		148,
		-1,
		124,
		106,
		-1,
		134,
		124,
		155,
		140,
		121,
		108,
		115,
		115,
		108,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		136,
		118,
		97,
		114,
		114,
		105,
		113,
		145,
		141,
		128,
		128,
		120,
		-1,
		264,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		152,
		125,
		113,
		119,
		115,
		101,
		107,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		121,
		156,
		-1,
		259,
		-1,
		193,
		-1,
		-1,
		175,
		155,
		147,
		136,
		125,
		123,
		114,
		105,
		127,
		143,
		127,
		125,
		128,
		129,
		-1,
		248,
		247,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		171,
		132,
		-1,
		134,
		114,
		-1,
		136,
		132,
		-1,
		-1,
		235,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		166,
		150,
		-1,
		125,
		125,
		-1,
		-1,
		-1,
		220,
		219,
		-1,
		188,
		191,
		-1,
		181,
		172,
		180,
		127,
		131,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		203,
		201,
		196,
		193,
		179,
		163,
		141,
		130,
		151,
		-1,
		-1,
		-1,
		201,
		193,
		186,
		-1,
		-1,
		188,
		171,
		152,
		150,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		178,
		-1,
		-1,
		184,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		212,
		-1,
		-1,
		-1,
		174,
		170,
		171,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		258,
		222,
		-1,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		237,
		235,
		-1,
		-1,
		-1,
		194,
		178,
		-1,
		164,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		199,
		-1,
		199,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		212,
		204,
		212,
		-1,
		184,
		186,
		-1,
		234,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		189,
		196,
		218,
		221,
		257,
		-1,
		208
	],
	[
		-1,
		164,
		153,
		164,
		172,
		145,
		152,
		-1,
		171,
		175,
		141,
		135,
		174,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		164,
		163,
		131,
		129,
		138,
		143,
		150,
		-1,
		149,
		-1,
		185,
		164,
		175,
		180,
		124,
		121,
		141,
		160,
		142,
		134,
		200,
		154,
		125,
		119,
		137,
		127,
		136,
		128,
		-1,
		125,
		115,
		137,
		116,
		127,
		119,
		-1,
		-1,
		119,
		120,
		126,
		112,
		118,
		114,
		-1,
		124,
		108,
		-1,
		-1,
		109,
		110,
		94,
		97,
		105,
		103,
		116,
		108,
		103,
		-1,
		-1,
		100,
		96,
		103,
		90,
		86,
		103,
		116,
		98,
		112,
		111,
		-1,
		104,
		122,
		129,
		97,
		95,
		79,
		77,
		95,
		97,
		103,
		103,
		-1,
		113,
		114,
		109,
		117,
		119,
		95,
		82,
		82,
		92,
		85,
		104,
		92,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		113,
		96,
		113,
		105,
		95,
		110,
		103,
		85,
		82,
		80,
		77,
		93,
		91,
		101,
		-1,
		-1,
		206,
		175,
		204,
		162,
		143,
		-1,
		109,
		89,
		95,
		99,
		93,
		86,
		100,
		96,
		-1,
		71,
		70,
		98,
		84,
		95,
		166,
		-1,
		-1,
		164,
		156,
		139,
		142,
		119,
		115,
		104,
		103,
		95,
		81,
		77,
		83,
		86,
		86,
		92,
		65,
		75,
		79,
		77,
		102,
		-1,
		-1,
		137,
		-1,
		-1,
		163,
		146,
		-1,
		129,
		136,
		125,
		131,
		117,
		138,
		114,
		105,
		97,
		91,
		79,
		81,
		78,
		91,
		79,
		62,
		87,
		91,
		72,
		93,
		88,
		-1,
		136,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		122,
		125,
		131,
		155,
		154,
		-1,
		126,
		114,
		115,
		100,
		97,
		84,
		72,
		85,
		70,
		77,
		76,
		66,
		64,
		94,
		69,
		91,
		88,
		107,
		112,
		106,
		115,
		-1,
		171,
		167,
		163,
		170,
		119,
		-1,
		-1,
		159,
		-1,
		162,
		163,
		138,
		111,
		114,
		101,
		92,
		79,
		68,
		79,
		68,
		65,
		73,
		58,
		73,
		64,
		63,
		81,
		91,
		99,
		103,
		109,
		-1,
		221,
		-1,
		163,
		147,
		149,
		121,
		142,
		-1,
		179,
		163,
		155,
		140,
		140,
		-1,
		110,
		107,
		97,
		75,
		60,
		77,
		69,
		67,
		71,
		53,
		67,
		58,
		76,
		83,
		81,
		85,
		105,
		117,
		181,
		171,
		-1,
		153,
		158,
		117,
		125,
		144,
		182,
		146,
		-1,
		141,
		-1,
		112,
		125,
		-1,
		81,
		77,
		59,
		60,
		55,
		70,
		64,
		49,
		46,
		64,
		67,
		74,
		78,
		94,
		-1,
		-1,
		166,
		170,
		159,
		110,
		129,
		153,
		190,
		139,
		128,
		127,
		-1,
		118,
		95,
		92,
		80,
		67,
		52,
		53,
		61,
		73,
		52,
		48,
		45,
		65,
		91,
		69,
		81,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		136,
		107,
		131,
		173,
		157,
		150,
		138,
		103,
		103,
		97,
		-1,
		91,
		70,
		61,
		50,
		48,
		61,
		53,
		63,
		43,
		41,
		60,
		72,
		63,
		75,
		-1,
		-1,
		-1,
		166,
		155,
		156,
		102,
		125,
		162,
		136,
		122,
		127,
		102,
		95,
		89,
		104,
		87,
		68,
		57,
		49,
		38,
		49,
		57,
		57,
		39,
		48,
		54,
		78,
		63,
		69,
		-1,
		-1,
		173,
		163,
		147,
		149,
		146,
		116,
		123,
		155,
		127,
		140,
		-1,
		94,
		-1,
		83,
		78,
		62,
		57,
		54,
		44,
		40,
		54,
		56,
		46,
		41,
		48,
		83,
		83,
		53,
		73,
		76,
		-1,
		-1,
		-1,
		166,
		161,
		136,
		113,
		97,
		133,
		-1,
		110,
		111,
		-1,
		88,
		82,
		79,
		64,
		60,
		48,
		52,
		52,
		54,
		45,
		50,
		51,
		33,
		58,
		-1,
		61,
		55,
		63,
		53,
		41,
		-1,
		-1,
		-1,
		159,
		138,
		131,
		151,
		92,
		144,
		-1,
		-1,
		95,
		88,
		-1,
		75,
		57,
		60,
		55,
		54,
		53,
		50,
		39,
		52,
		45,
		38,
		33,
		46,
		50,
		54,
		43,
		39,
		36,
		50,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		112,
		-1,
		104,
		96,
		86,
		80,
		74,
		70,
		68,
		82,
		66,
		65,
		62,
		53,
		61,
		34,
		27,
		38,
		23,
		41,
		49,
		41,
		35,
		34,
		46,
		-1,
		179,
		165,
		136,
		-1,
		-1,
		125,
		-1,
		89,
		103,
		119,
		-1,
		112,
		91,
		106,
		84,
		80,
		72,
		89,
		90,
		68,
		62,
		60,
		51,
		39,
		28,
		31,
		23,
		45,
		45,
		29,
		30,
		39,
		-1,
		185,
		172,
		130,
		126,
		115,
		135,
		86,
		74,
		106,
		-1,
		-1,
		148,
		-1,
		82,
		99,
		86,
		84,
		79,
		70,
		76,
		71,
		48,
		43,
		33,
		22,
		15,
		17,
		39,
		25,
		23,
		42,
		58,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		101,
		88,
		82,
		-1,
		123,
		-1,
		126,
		116,
		100,
		85,
		118,
		-1,
		74,
		70,
		76,
		-1,
		68,
		-1,
		22,
		18,
		9,
		7,
		11,
		22,
		20,
		31,
		48,
		-1,
		135,
		120,
		113,
		103,
		117,
		88,
		-1,
		143,
		-1,
		-1,
		113,
		107,
		107,
		91,
		94,
		90,
		70,
		62,
		76,
		51,
		35,
		37,
		7,
		0,
		4,
		14,
		27,
		47,
		38,
		50,
		-1,
		-1,
		-1,
		140,
		126,
		130,
		90,
		109,
		-1,
		-1,
		175,
		130,
		116,
		-1,
		100,
		90,
		78,
		68,
		58,
		63,
		51,
		26,
		19,
		5,
		7,
		12,
		23,
		28,
		49,
		50,
		63,
		-1,
		-1,
		123,
		128,
		116,
		102,
		121,
		-1,
		-1,
		-1,
		122,
		138,
		129,
		101,
		79,
		-1,
		-1,
		62,
		55,
		43,
		26,
		13,
		33,
		39,
		33,
		22,
		37,
		49,
		57,
		62,
		-1,
		126,
		113,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		-1,
		-1,
		141,
		86,
		75,
		70,
		74,
		61,
		-1,
		46,
		35,
		17,
		31,
		38,
		35,
		30,
		24,
		32,
		50,
		67,
		-1,
		-1,
		138,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		63,
		56,
		60,
		-1,
		47,
		33,
		19,
		36,
		48,
		45,
		36,
		28,
		33,
		35,
		48,
		62,
		66,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		116,
		131,
		102,
		79,
		52,
		47,
		40,
		34,
		27,
		43,
		52,
		63,
		35,
		31,
		32,
		41,
		40,
		57,
		67,
		-1,
		-1,
		144,
		150,
		142,
		124,
		128,
		129,
		-1,
		-1,
		56,
		47,
		38,
		41,
		37,
		40,
		41,
		38,
		43,
		48,
		36,
		50,
		66,
		72,
		-1,
		-1,
		-1,
		164,
		-1,
		168,
		-1,
		-1,
		143,
		127,
		74,
		56,
		52,
		50,
		43,
		52,
		46,
		46,
		56,
		66,
		58,
		38,
		56,
		76,
		68,
		104,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		145,
		137,
		132,
		138,
		139,
		130,
		89,
		86,
		-1,
		56,
		81,
		52,
		59,
		51,
		64,
		64,
		62,
		43,
		53,
		69,
		68,
		63,
		96,
		90,
		96,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		138,
		134,
		124,
		114,
		116,
		-1,
		-1,
		104,
		101,
		78,
		61,
		66,
		59,
		54,
		75,
		55,
		42,
		46,
		50,
		56,
		61,
		66,
		72,
		87,
		102,
		-1,
		171,
		226,
		219,
		187,
		195,
		226,
		-1,
		128,
		120,
		131,
		106,
		107,
		-1,
		-1,
		77,
		75,
		80,
		68,
		65,
		78,
		77,
		71,
		56,
		62,
		49,
		48,
		66,
		70,
		79,
		86,
		76,
		89,
		93,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		125,
		-1,
		-1,
		137,
		108,
		92,
		83,
		76,
		127,
		82,
		77,
		79,
		77,
		68,
		59,
		66,
		57,
		57,
		60,
		75,
		80,
		72,
		86,
		86,
		87,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		153,
		-1,
		119,
		-1,
		94,
		98,
		90,
		93,
		93,
		80,
		72,
		64,
		80,
		55,
		65,
		61,
		62,
		71,
		82,
		94,
		93,
		94,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		137,
		176,
		191,
		-1,
		162,
		-1,
		-1,
		-1,
		108,
		103,
		95,
		111,
		92,
		92,
		66,
		70,
		60,
		67,
		77,
		79,
		71,
		75,
		88,
		99,
		102,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		152,
		143,
		170,
		195,
		187,
		182,
		169,
		-1,
		-1,
		131,
		113,
		-1,
		-1,
		99,
		87,
		70,
		71,
		67,
		70,
		85,
		88,
		78,
		76,
		70,
		102,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		171,
		165,
		169,
		185,
		210,
		-1,
		159,
		-1,
		-1,
		144,
		-1,
		-1,
		129,
		92,
		81,
		72,
		78,
		75,
		86,
		96,
		84,
		85,
		75,
		85,
		98,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		141,
		139,
		145,
		152,
		169,
		199,
		-1,
		-1,
		175,
		155,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		77,
		82,
		102,
		104,
		93,
		87,
		81,
		88,
		87,
		95,
		103,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		165,
		161,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		95,
		99,
		91,
		84,
		79,
		90,
		82,
		86,
		103,
		-1,
		212,
		-1,
		164,
		140,
		154,
		169,
		177,
		-1,
		-1,
		-1,
		182,
		168,
		161,
		149,
		147,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		135,
		103,
		108,
		103,
		85,
		96,
		85,
		88,
		102,
		97,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		172,
		174,
		-1,
		173,
		162,
		147,
		139,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		117,
		106,
		114,
		109,
		89,
		95,
		98,
		87,
		91,
		103,
		-1,
		-1,
		159,
		160,
		165,
		-1,
		157,
		-1,
		175,
		-1,
		142,
		148,
		136,
		-1,
		-1,
		-1,
		130,
		93,
		114,
		124,
		118,
		116,
		107,
		93,
		100,
		98,
		94,
		105,
		-1,
		-1,
		-1,
		175,
		149,
		182,
		173,
		156,
		136,
		128,
		147,
		-1,
		117,
		-1,
		92,
		94,
		120,
		123,
		129,
		123,
		96,
		111,
		101,
		92,
		101,
		181,
		-1,
		151,
		184,
		148,
		142,
		118,
		122,
		138,
		-1,
		114,
		96,
		-1,
		124,
		114,
		145,
		130,
		111,
		98,
		105,
		105,
		98,
		-1,
		-1,
		-1,
		153,
		152,
		144,
		138,
		138,
		123,
		114,
		-1,
		126,
		108,
		87,
		104,
		104,
		95,
		103,
		135,
		131,
		118,
		118,
		110,
		-1,
		254,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		147,
		142,
		115,
		103,
		109,
		105,
		91,
		97,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		111,
		146,
		-1,
		249,
		-1,
		183,
		-1,
		-1,
		165,
		145,
		137,
		126,
		115,
		113,
		104,
		95,
		117,
		133,
		117,
		115,
		118,
		119,
		-1,
		238,
		237,
		-1,
		184,
		176,
		162,
		-1,
		155,
		-1,
		161,
		122,
		-1,
		124,
		104,
		-1,
		126,
		122,
		-1,
		-1,
		225,
		200,
		-1,
		-1,
		-1,
		185,
		165,
		156,
		140,
		-1,
		115,
		115,
		-1,
		-1,
		-1,
		210,
		209,
		-1,
		178,
		181,
		-1,
		171,
		162,
		170,
		117,
		121,
		-1,
		-1,
		-1,
		219,
		200,
		194,
		193,
		191,
		186,
		183,
		169,
		153,
		131,
		120,
		141,
		-1,
		-1,
		-1,
		191,
		183,
		176,
		-1,
		-1,
		178,
		161,
		142,
		140,
		-1,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		168,
		-1,
		-1,
		174,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		202,
		-1,
		-1,
		-1,
		164,
		160,
		161,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		248,
		212,
		-1,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		227,
		225,
		-1,
		-1,
		-1,
		184,
		168,
		-1,
		154,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		189,
		-1,
		189,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		202,
		194,
		202,
		-1,
		174,
		176,
		-1,
		224,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		179,
		186,
		208,
		211,
		247,
		-1,
		198
	],
	[
		-1,
		160,
		149,
		160,
		168,
		141,
		148,
		-1,
		167,
		171,
		137,
		131,
		170,
		139,
		145,
		156,
		-1,
		-1,
		-1,
		160,
		159,
		127,
		125,
		134,
		139,
		146,
		-1,
		145,
		-1,
		181,
		160,
		171,
		176,
		120,
		117,
		137,
		156,
		138,
		130,
		196,
		150,
		121,
		115,
		133,
		123,
		132,
		124,
		-1,
		121,
		111,
		133,
		112,
		123,
		115,
		-1,
		-1,
		115,
		116,
		122,
		108,
		114,
		110,
		-1,
		120,
		104,
		-1,
		-1,
		105,
		106,
		90,
		93,
		101,
		99,
		112,
		104,
		99,
		-1,
		-1,
		96,
		92,
		99,
		86,
		82,
		99,
		112,
		94,
		108,
		107,
		-1,
		100,
		118,
		125,
		93,
		91,
		75,
		73,
		91,
		93,
		99,
		99,
		-1,
		109,
		110,
		105,
		113,
		115,
		91,
		78,
		78,
		88,
		81,
		100,
		88,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		92,
		109,
		101,
		91,
		106,
		99,
		81,
		78,
		76,
		73,
		89,
		87,
		97,
		-1,
		-1,
		202,
		171,
		200,
		158,
		139,
		-1,
		105,
		85,
		91,
		95,
		89,
		82,
		96,
		92,
		-1,
		67,
		66,
		94,
		80,
		91,
		162,
		-1,
		-1,
		160,
		152,
		135,
		138,
		115,
		111,
		100,
		99,
		91,
		77,
		73,
		79,
		82,
		82,
		88,
		61,
		71,
		75,
		73,
		98,
		-1,
		-1,
		133,
		-1,
		-1,
		159,
		142,
		-1,
		125,
		132,
		121,
		127,
		113,
		134,
		110,
		101,
		93,
		87,
		75,
		77,
		74,
		87,
		75,
		58,
		83,
		87,
		68,
		89,
		84,
		-1,
		132,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		118,
		121,
		127,
		151,
		150,
		-1,
		122,
		110,
		111,
		96,
		93,
		80,
		68,
		81,
		66,
		73,
		72,
		62,
		60,
		90,
		65,
		87,
		84,
		103,
		108,
		102,
		111,
		-1,
		167,
		163,
		159,
		166,
		115,
		-1,
		-1,
		155,
		-1,
		158,
		159,
		134,
		107,
		110,
		97,
		88,
		75,
		64,
		75,
		64,
		61,
		69,
		54,
		69,
		60,
		59,
		77,
		87,
		95,
		99,
		105,
		-1,
		217,
		-1,
		159,
		143,
		145,
		117,
		138,
		-1,
		175,
		159,
		151,
		136,
		136,
		-1,
		106,
		103,
		93,
		71,
		56,
		73,
		65,
		63,
		67,
		49,
		63,
		54,
		72,
		79,
		77,
		81,
		101,
		113,
		177,
		167,
		-1,
		149,
		154,
		113,
		121,
		140,
		178,
		142,
		-1,
		137,
		-1,
		108,
		121,
		-1,
		77,
		73,
		55,
		56,
		51,
		66,
		60,
		45,
		42,
		60,
		63,
		70,
		74,
		90,
		-1,
		-1,
		162,
		166,
		155,
		106,
		125,
		149,
		186,
		135,
		124,
		123,
		-1,
		114,
		91,
		88,
		76,
		63,
		48,
		49,
		57,
		69,
		48,
		44,
		41,
		61,
		87,
		65,
		77,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		132,
		103,
		127,
		169,
		153,
		146,
		134,
		99,
		99,
		93,
		-1,
		87,
		66,
		57,
		46,
		44,
		57,
		49,
		59,
		39,
		37,
		56,
		68,
		59,
		71,
		-1,
		-1,
		-1,
		162,
		151,
		152,
		98,
		121,
		158,
		132,
		118,
		123,
		98,
		91,
		85,
		100,
		83,
		64,
		53,
		45,
		34,
		45,
		53,
		53,
		35,
		44,
		50,
		74,
		59,
		65,
		-1,
		-1,
		169,
		159,
		143,
		145,
		142,
		112,
		119,
		151,
		123,
		136,
		-1,
		90,
		-1,
		79,
		74,
		58,
		53,
		50,
		40,
		36,
		50,
		52,
		42,
		37,
		44,
		79,
		79,
		49,
		69,
		72,
		-1,
		-1,
		-1,
		162,
		157,
		132,
		109,
		93,
		129,
		-1,
		106,
		107,
		-1,
		84,
		78,
		75,
		60,
		56,
		44,
		48,
		48,
		50,
		41,
		46,
		47,
		29,
		54,
		-1,
		57,
		51,
		59,
		49,
		37,
		-1,
		-1,
		-1,
		155,
		134,
		127,
		147,
		88,
		140,
		-1,
		-1,
		91,
		84,
		-1,
		71,
		53,
		56,
		51,
		50,
		49,
		46,
		35,
		48,
		41,
		34,
		29,
		42,
		46,
		50,
		39,
		35,
		32,
		46,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		108,
		-1,
		100,
		92,
		82,
		76,
		70,
		66,
		64,
		78,
		62,
		61,
		58,
		49,
		57,
		30,
		23,
		34,
		19,
		37,
		45,
		37,
		31,
		30,
		42,
		-1,
		175,
		161,
		132,
		-1,
		-1,
		121,
		-1,
		85,
		99,
		115,
		-1,
		108,
		87,
		102,
		80,
		76,
		68,
		85,
		86,
		64,
		58,
		56,
		47,
		35,
		24,
		27,
		19,
		41,
		41,
		25,
		26,
		35,
		-1,
		181,
		168,
		126,
		122,
		111,
		131,
		82,
		70,
		102,
		-1,
		-1,
		144,
		-1,
		78,
		95,
		82,
		80,
		75,
		66,
		72,
		67,
		44,
		39,
		29,
		18,
		11,
		13,
		35,
		21,
		19,
		38,
		54,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		97,
		84,
		78,
		-1,
		119,
		-1,
		122,
		112,
		96,
		81,
		114,
		-1,
		77,
		67,
		72,
		-1,
		64,
		-1,
		25,
		21,
		12,
		3,
		7,
		18,
		16,
		27,
		44,
		-1,
		131,
		116,
		109,
		99,
		113,
		84,
		-1,
		139,
		-1,
		-1,
		109,
		103,
		103,
		87,
		90,
		93,
		73,
		65,
		72,
		54,
		38,
		40,
		10,
		3,
		0,
		10,
		23,
		43,
		34,
		46,
		-1,
		-1,
		-1,
		136,
		122,
		126,
		86,
		105,
		-1,
		-1,
		171,
		126,
		112,
		-1,
		96,
		93,
		81,
		71,
		61,
		64,
		54,
		29,
		22,
		8,
		10,
		8,
		19,
		24,
		45,
		46,
		59,
		-1,
		-1,
		119,
		124,
		112,
		98,
		117,
		-1,
		-1,
		-1,
		118,
		134,
		126,
		97,
		82,
		-1,
		-1,
		65,
		56,
		46,
		25,
		12,
		32,
		35,
		29,
		18,
		33,
		45,
		53,
		58,
		-1,
		122,
		109,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		-1,
		-1,
		140,
		85,
		74,
		69,
		73,
		64,
		-1,
		45,
		36,
		16,
		30,
		37,
		31,
		26,
		20,
		28,
		46,
		63,
		-1,
		-1,
		134,
		-1,
		129,
		-1,
		-1,
		-1,
		-1,
		97,
		91,
		62,
		55,
		59,
		-1,
		46,
		32,
		18,
		35,
		44,
		41,
		32,
		24,
		29,
		31,
		44,
		58,
		62,
		157,
		-1,
		140,
		-1,
		-1,
		-1,
		115,
		130,
		101,
		78,
		51,
		46,
		39,
		33,
		26,
		42,
		51,
		62,
		31,
		27,
		28,
		37,
		36,
		53,
		63,
		-1,
		-1,
		140,
		149,
		141,
		123,
		127,
		128,
		-1,
		-1,
		55,
		46,
		37,
		40,
		36,
		39,
		37,
		34,
		39,
		44,
		32,
		46,
		62,
		68,
		-1,
		-1,
		-1,
		160,
		-1,
		167,
		-1,
		-1,
		142,
		126,
		73,
		55,
		51,
		49,
		42,
		51,
		45,
		42,
		52,
		62,
		54,
		34,
		52,
		72,
		64,
		100,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		144,
		136,
		131,
		137,
		138,
		129,
		88,
		85,
		-1,
		55,
		80,
		51,
		58,
		50,
		60,
		60,
		58,
		39,
		49,
		65,
		64,
		59,
		92,
		86,
		92,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		137,
		133,
		123,
		113,
		115,
		-1,
		-1,
		103,
		100,
		77,
		60,
		65,
		58,
		53,
		71,
		51,
		38,
		42,
		46,
		52,
		57,
		62,
		68,
		83,
		98,
		-1,
		167,
		225,
		218,
		186,
		194,
		225,
		-1,
		127,
		119,
		130,
		105,
		106,
		-1,
		-1,
		76,
		74,
		79,
		67,
		64,
		77,
		76,
		67,
		52,
		58,
		45,
		44,
		62,
		66,
		75,
		82,
		72,
		85,
		89,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		124,
		-1,
		-1,
		136,
		107,
		91,
		82,
		75,
		126,
		81,
		76,
		75,
		73,
		64,
		55,
		62,
		53,
		53,
		56,
		71,
		76,
		68,
		82,
		82,
		83,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		152,
		-1,
		118,
		-1,
		93,
		97,
		89,
		92,
		89,
		76,
		68,
		60,
		76,
		51,
		61,
		57,
		58,
		67,
		78,
		90,
		89,
		90,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		136,
		175,
		188,
		-1,
		161,
		-1,
		-1,
		-1,
		107,
		102,
		94,
		109,
		88,
		88,
		62,
		66,
		56,
		63,
		73,
		75,
		67,
		71,
		84,
		95,
		98,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		151,
		142,
		169,
		194,
		184,
		179,
		166,
		-1,
		-1,
		130,
		112,
		-1,
		-1,
		95,
		83,
		66,
		67,
		63,
		66,
		81,
		84,
		74,
		72,
		66,
		98,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		170,
		164,
		168,
		184,
		209,
		-1,
		155,
		-1,
		-1,
		140,
		-1,
		-1,
		125,
		88,
		77,
		68,
		74,
		71,
		82,
		92,
		80,
		81,
		71,
		81,
		94,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		171,
		151,
		-1,
		-1,
		123,
		121,
		110,
		-1,
		100,
		73,
		78,
		98,
		100,
		89,
		83,
		77,
		84,
		83,
		91,
		99,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		161,
		157,
		-1,
		-1,
		118,
		111,
		99,
		87,
		77,
		87,
		91,
		95,
		87,
		80,
		75,
		86,
		78,
		82,
		99,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		178,
		164,
		157,
		145,
		143,
		-1,
		152,
		136,
		117,
		-1,
		87,
		100,
		131,
		99,
		104,
		99,
		81,
		92,
		81,
		84,
		98,
		93,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		168,
		170,
		-1,
		169,
		158,
		143,
		135,
		-1,
		-1,
		124,
		120,
		-1,
		-1,
		88,
		113,
		102,
		110,
		105,
		85,
		91,
		94,
		83,
		87,
		99,
		-1,
		-1,
		158,
		159,
		164,
		-1,
		153,
		-1,
		171,
		-1,
		138,
		144,
		132,
		-1,
		-1,
		-1,
		126,
		89,
		110,
		120,
		114,
		112,
		103,
		89,
		96,
		94,
		90,
		101,
		-1,
		-1,
		-1,
		171,
		145,
		178,
		169,
		152,
		132,
		124,
		143,
		-1,
		113,
		-1,
		88,
		90,
		116,
		119,
		125,
		119,
		92,
		107,
		97,
		88,
		97,
		177,
		-1,
		147,
		180,
		144,
		138,
		114,
		118,
		134,
		-1,
		110,
		92,
		-1,
		120,
		110,
		141,
		126,
		107,
		94,
		101,
		101,
		94,
		-1,
		-1,
		-1,
		149,
		148,
		140,
		134,
		134,
		119,
		110,
		-1,
		122,
		104,
		83,
		100,
		100,
		91,
		99,
		131,
		127,
		114,
		114,
		106,
		-1,
		250,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		143,
		138,
		111,
		99,
		105,
		101,
		87,
		93,
		95,
		103,
		101,
		98,
		110,
		106,
		126,
		107,
		142,
		-1,
		245,
		-1,
		179,
		-1,
		-1,
		161,
		141,
		133,
		122,
		111,
		109,
		100,
		91,
		113,
		129,
		113,
		111,
		114,
		115,
		-1,
		234,
		233,
		-1,
		180,
		172,
		158,
		-1,
		151,
		-1,
		157,
		118,
		-1,
		120,
		100,
		-1,
		122,
		118,
		-1,
		-1,
		221,
		196,
		-1,
		-1,
		-1,
		181,
		161,
		152,
		136,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		206,
		205,
		-1,
		174,
		177,
		-1,
		167,
		158,
		166,
		113,
		117,
		-1,
		-1,
		-1,
		215,
		196,
		190,
		189,
		187,
		182,
		179,
		165,
		149,
		127,
		116,
		137,
		-1,
		-1,
		-1,
		187,
		179,
		172,
		-1,
		-1,
		174,
		157,
		138,
		136,
		-1,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		164,
		-1,
		-1,
		170,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		198,
		-1,
		-1,
		-1,
		160,
		156,
		157,
		-1,
		-1,
		-1,
		-1,
		220,
		221,
		244,
		208,
		-1,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		223,
		221,
		-1,
		-1,
		-1,
		180,
		164,
		-1,
		150,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		185,
		-1,
		185,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		198,
		190,
		198,
		-1,
		170,
		172,
		-1,
		220,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		175,
		182,
		204,
		207,
		243,
		-1,
		194
	],
	[
		-1,
		166,
		155,
		166,
		174,
		147,
		154,
		-1,
		173,
		177,
		143,
		137,
		176,
		145,
		151,
		162,
		-1,
		-1,
		-1,
		166,
		165,
		133,
		131,
		140,
		145,
		152,
		-1,
		151,
		-1,
		187,
		166,
		177,
		182,
		126,
		123,
		143,
		162,
		144,
		136,
		202,
		156,
		127,
		121,
		139,
		129,
		138,
		130,
		-1,
		127,
		117,
		139,
		118,
		129,
		121,
		-1,
		-1,
		121,
		122,
		128,
		114,
		120,
		116,
		-1,
		126,
		110,
		-1,
		-1,
		111,
		112,
		96,
		99,
		107,
		105,
		118,
		110,
		105,
		-1,
		-1,
		102,
		98,
		105,
		92,
		88,
		105,
		118,
		100,
		114,
		113,
		-1,
		108,
		126,
		131,
		99,
		97,
		81,
		79,
		97,
		99,
		105,
		105,
		-1,
		117,
		118,
		113,
		121,
		121,
		97,
		84,
		84,
		94,
		87,
		106,
		94,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		117,
		100,
		117,
		109,
		99,
		114,
		107,
		87,
		84,
		82,
		79,
		95,
		93,
		103,
		-1,
		-1,
		208,
		177,
		208,
		166,
		147,
		-1,
		113,
		93,
		99,
		103,
		97,
		90,
		104,
		100,
		-1,
		73,
		72,
		100,
		86,
		97,
		168,
		-1,
		-1,
		166,
		158,
		143,
		146,
		123,
		119,
		108,
		107,
		99,
		85,
		81,
		87,
		90,
		90,
		96,
		67,
		77,
		81,
		79,
		104,
		-1,
		-1,
		134,
		-1,
		-1,
		165,
		148,
		-1,
		131,
		138,
		129,
		135,
		121,
		142,
		118,
		109,
		101,
		95,
		83,
		85,
		82,
		95,
		83,
		64,
		89,
		93,
		74,
		95,
		90,
		-1,
		133,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		124,
		127,
		133,
		157,
		158,
		-1,
		130,
		118,
		119,
		104,
		101,
		88,
		76,
		89,
		74,
		81,
		80,
		68,
		66,
		96,
		71,
		93,
		90,
		104,
		109,
		103,
		112,
		-1,
		173,
		169,
		165,
		172,
		121,
		-1,
		-1,
		161,
		-1,
		166,
		167,
		142,
		115,
		118,
		105,
		96,
		83,
		72,
		83,
		72,
		69,
		77,
		60,
		75,
		66,
		65,
		83,
		88,
		96,
		100,
		106,
		-1,
		223,
		-1,
		165,
		149,
		151,
		123,
		144,
		-1,
		181,
		167,
		159,
		144,
		142,
		-1,
		114,
		111,
		101,
		79,
		64,
		81,
		73,
		71,
		73,
		55,
		69,
		60,
		78,
		85,
		78,
		82,
		102,
		114,
		183,
		173,
		-1,
		155,
		160,
		119,
		127,
		146,
		184,
		148,
		-1,
		143,
		-1,
		116,
		129,
		-1,
		85,
		81,
		63,
		64,
		59,
		74,
		66,
		51,
		48,
		66,
		69,
		71,
		75,
		91,
		-1,
		-1,
		168,
		172,
		161,
		112,
		131,
		155,
		192,
		141,
		130,
		129,
		-1,
		120,
		99,
		96,
		84,
		71,
		56,
		57,
		65,
		77,
		56,
		50,
		47,
		67,
		88,
		66,
		77,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		138,
		109,
		133,
		175,
		159,
		152,
		140,
		105,
		105,
		99,
		-1,
		95,
		74,
		65,
		54,
		52,
		65,
		57,
		65,
		45,
		43,
		62,
		69,
		60,
		68,
		-1,
		-1,
		-1,
		168,
		157,
		158,
		104,
		127,
		164,
		138,
		124,
		129,
		104,
		97,
		91,
		108,
		91,
		72,
		61,
		53,
		42,
		53,
		61,
		59,
		41,
		50,
		56,
		75,
		56,
		62,
		-1,
		-1,
		175,
		165,
		149,
		151,
		148,
		118,
		125,
		157,
		129,
		142,
		-1,
		96,
		-1,
		85,
		81,
		66,
		61,
		58,
		45,
		44,
		58,
		58,
		48,
		43,
		50,
		80,
		80,
		46,
		66,
		69,
		-1,
		-1,
		-1,
		168,
		163,
		138,
		115,
		99,
		135,
		-1,
		112,
		113,
		-1,
		90,
		84,
		81,
		68,
		64,
		49,
		53,
		55,
		58,
		46,
		52,
		53,
		35,
		59,
		-1,
		54,
		48,
		56,
		46,
		34,
		-1,
		-1,
		-1,
		161,
		140,
		133,
		153,
		94,
		146,
		-1,
		-1,
		97,
		90,
		-1,
		77,
		59,
		61,
		56,
		55,
		54,
		51,
		40,
		53,
		46,
		40,
		34,
		47,
		51,
		47,
		36,
		32,
		29,
		43,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		94,
		114,
		-1,
		106,
		98,
		88,
		82,
		76,
		72,
		70,
		83,
		67,
		66,
		63,
		54,
		62,
		35,
		28,
		39,
		24,
		42,
		42,
		34,
		28,
		27,
		39,
		-1,
		181,
		167,
		138,
		-1,
		-1,
		127,
		-1,
		91,
		105,
		121,
		-1,
		114,
		93,
		108,
		86,
		82,
		73,
		90,
		91,
		69,
		63,
		61,
		52,
		40,
		29,
		32,
		24,
		46,
		38,
		22,
		23,
		32,
		-1,
		187,
		174,
		132,
		128,
		117,
		137,
		88,
		76,
		108,
		-1,
		-1,
		150,
		-1,
		84,
		101,
		87,
		85,
		80,
		71,
		77,
		72,
		49,
		44,
		34,
		23,
		23,
		18,
		32,
		18,
		16,
		35,
		51,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		103,
		90,
		84,
		-1,
		125,
		-1,
		128,
		118,
		102,
		87,
		120,
		-1,
		88,
		72,
		77,
		-1,
		69,
		-1,
		42,
		39,
		30,
		15,
		12,
		23,
		13,
		22,
		41,
		-1,
		137,
		122,
		115,
		105,
		119,
		90,
		-1,
		145,
		-1,
		-1,
		115,
		109,
		109,
		93,
		96,
		104,
		84,
		78,
		77,
		64,
		56,
		50,
		28,
		21,
		18,
		0,
		13,
		36,
		29,
		42,
		-1,
		-1,
		-1,
		142,
		128,
		132,
		92,
		111,
		-1,
		-1,
		177,
		132,
		118,
		-1,
		102,
		111,
		99,
		89,
		79,
		82,
		72,
		47,
		40,
		26,
		28,
		25,
		13,
		14,
		35,
		36,
		54,
		-1,
		-1,
		125,
		130,
		118,
		104,
		123,
		-1,
		-1,
		-1,
		124,
		140,
		132,
		103,
		100,
		-1,
		-1,
		83,
		74,
		64,
		43,
		30,
		44,
		39,
		24,
		8,
		23,
		35,
		49,
		48,
		-1,
		128,
		115,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		-1,
		-1,
		151,
		96,
		85,
		80,
		84,
		82,
		-1,
		56,
		54,
		34,
		48,
		55,
		26,
		21,
		15,
		18,
		36,
		53,
		-1,
		-1,
		140,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		73,
		66,
		70,
		-1,
		58,
		50,
		36,
		53,
		39,
		36,
		27,
		19,
		24,
		21,
		34,
		48,
		52,
		163,
		-1,
		146,
		-1,
		-1,
		-1,
		126,
		141,
		112,
		89,
		62,
		57,
		50,
		44,
		44,
		60,
		47,
		58,
		26,
		22,
		23,
		27,
		26,
		43,
		53,
		-1,
		-1,
		146,
		152,
		152,
		134,
		138,
		139,
		-1,
		-1,
		66,
		57,
		48,
		51,
		54,
		57,
		32,
		29,
		34,
		39,
		27,
		36,
		54,
		58,
		-1,
		-1,
		-1,
		166,
		-1,
		170,
		-1,
		-1,
		153,
		137,
		84,
		66,
		62,
		60,
		53,
		56,
		44,
		37,
		47,
		57,
		49,
		29,
		49,
		64,
		61,
		90,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		147,
		139,
		134,
		140,
		142,
		133,
		99,
		96,
		-1,
		66,
		85,
		50,
		57,
		49,
		55,
		55,
		53,
		34,
		46,
		62,
		61,
		56,
		82,
		77,
		86,
		-1,
		-1,
		233,
		222,
		211,
		217,
		-1,
		140,
		136,
		126,
		116,
		119,
		-1,
		-1,
		113,
		110,
		82,
		59,
		65,
		58,
		53,
		68,
		48,
		35,
		39,
		43,
		49,
		54,
		59,
		65,
		80,
		92,
		-1,
		173,
		224,
		217,
		185,
		193,
		224,
		-1,
		130,
		122,
		133,
		108,
		110,
		-1,
		-1,
		86,
		77,
		78,
		66,
		63,
		76,
		73,
		64,
		49,
		55,
		42,
		41,
		59,
		63,
		72,
		79,
		69,
		82,
		86,
		-1,
		180,
		200,
		179,
		182,
		206,
		220,
		-1,
		127,
		-1,
		-1,
		139,
		111,
		95,
		85,
		82,
		125,
		80,
		75,
		72,
		70,
		61,
		52,
		59,
		50,
		50,
		53,
		68,
		73,
		65,
		79,
		79,
		80,
		-1,
		169,
		180,
		173,
		-1,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		155,
		-1,
		122,
		-1,
		105,
		109,
		88,
		91,
		86,
		73,
		65,
		57,
		73,
		48,
		58,
		54,
		55,
		64,
		75,
		87,
		86,
		87,
		194,
		150,
		153,
		164,
		175,
		190,
		194,
		-1,
		139,
		178,
		185,
		-1,
		164,
		-1,
		-1,
		-1,
		119,
		101,
		93,
		106,
		85,
		85,
		59,
		63,
		53,
		60,
		70,
		72,
		64,
		68,
		81,
		92,
		95,
		190,
		181,
		194,
		139,
		139,
		160,
		169,
		190,
		154,
		145,
		172,
		192,
		181,
		176,
		163,
		-1,
		-1,
		142,
		111,
		-1,
		-1,
		92,
		80,
		63,
		64,
		60,
		63,
		78,
		81,
		71,
		69,
		63,
		95,
		-1,
		183,
		182,
		171,
		168,
		144,
		135,
		130,
		157,
		-1,
		-1,
		152,
		173,
		163,
		167,
		183,
		208,
		-1,
		152,
		-1,
		-1,
		137,
		-1,
		-1,
		122,
		85,
		74,
		65,
		71,
		68,
		79,
		89,
		77,
		78,
		68,
		78,
		91,
		167,
		164,
		152,
		150,
		173,
		138,
		126,
		-1,
		139,
		137,
		143,
		150,
		167,
		197,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		120,
		118,
		107,
		-1,
		97,
		70,
		75,
		95,
		97,
		86,
		80,
		74,
		81,
		80,
		88,
		96,
		176,
		190,
		179,
		175,
		174,
		182,
		131,
		124,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		115,
		108,
		96,
		84,
		74,
		84,
		88,
		92,
		84,
		77,
		72,
		83,
		75,
		79,
		96,
		-1,
		210,
		-1,
		162,
		138,
		152,
		167,
		175,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		149,
		133,
		114,
		-1,
		84,
		97,
		128,
		96,
		101,
		96,
		78,
		89,
		78,
		81,
		95,
		90,
		-1,
		-1,
		150,
		153,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		121,
		117,
		-1,
		-1,
		85,
		110,
		99,
		107,
		102,
		82,
		88,
		91,
		80,
		84,
		96,
		-1,
		-1,
		157,
		158,
		163,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		123,
		86,
		107,
		117,
		111,
		109,
		100,
		86,
		93,
		91,
		87,
		98,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		87,
		113,
		116,
		122,
		116,
		89,
		104,
		94,
		85,
		94,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		107,
		138,
		123,
		104,
		91,
		98,
		98,
		91,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		96,
		128,
		124,
		111,
		111,
		103,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		104,
		139,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		110,
		108,
		111,
		112,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		119,
		115,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		171,
		160,
		171,
		179,
		152,
		159,
		-1,
		178,
		182,
		148,
		142,
		181,
		150,
		156,
		167,
		-1,
		-1,
		-1,
		171,
		170,
		138,
		136,
		145,
		150,
		157,
		-1,
		156,
		-1,
		192,
		171,
		182,
		187,
		131,
		128,
		148,
		167,
		149,
		141,
		207,
		161,
		132,
		126,
		144,
		134,
		143,
		135,
		-1,
		132,
		122,
		144,
		123,
		134,
		126,
		-1,
		-1,
		126,
		127,
		133,
		119,
		125,
		121,
		-1,
		131,
		115,
		-1,
		-1,
		116,
		117,
		101,
		104,
		112,
		110,
		123,
		115,
		110,
		-1,
		-1,
		107,
		103,
		110,
		97,
		93,
		110,
		123,
		105,
		119,
		118,
		-1,
		113,
		131,
		136,
		104,
		102,
		86,
		84,
		102,
		104,
		110,
		110,
		-1,
		122,
		123,
		118,
		126,
		126,
		102,
		89,
		89,
		99,
		92,
		111,
		99,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		122,
		105,
		122,
		114,
		104,
		119,
		112,
		92,
		89,
		87,
		84,
		100,
		98,
		108,
		-1,
		-1,
		213,
		182,
		213,
		171,
		152,
		-1,
		118,
		98,
		104,
		108,
		102,
		95,
		109,
		105,
		-1,
		78,
		77,
		105,
		91,
		102,
		173,
		-1,
		-1,
		171,
		163,
		148,
		151,
		128,
		124,
		113,
		112,
		104,
		90,
		86,
		92,
		95,
		95,
		101,
		72,
		82,
		86,
		84,
		109,
		-1,
		-1,
		144,
		-1,
		-1,
		170,
		153,
		-1,
		136,
		143,
		134,
		140,
		126,
		147,
		123,
		114,
		106,
		100,
		88,
		90,
		87,
		100,
		88,
		69,
		94,
		98,
		79,
		100,
		95,
		-1,
		143,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		129,
		132,
		138,
		162,
		163,
		-1,
		135,
		123,
		124,
		109,
		106,
		93,
		81,
		94,
		79,
		86,
		85,
		73,
		71,
		101,
		76,
		98,
		95,
		114,
		119,
		113,
		122,
		-1,
		178,
		174,
		170,
		177,
		126,
		-1,
		-1,
		166,
		-1,
		171,
		172,
		147,
		120,
		123,
		110,
		101,
		88,
		77,
		88,
		77,
		74,
		82,
		65,
		80,
		71,
		70,
		88,
		98,
		106,
		110,
		116,
		-1,
		228,
		-1,
		170,
		154,
		156,
		128,
		149,
		-1,
		186,
		172,
		164,
		149,
		147,
		-1,
		119,
		116,
		106,
		84,
		69,
		86,
		78,
		76,
		78,
		60,
		74,
		65,
		83,
		90,
		88,
		92,
		112,
		124,
		188,
		178,
		-1,
		160,
		165,
		124,
		132,
		151,
		189,
		153,
		-1,
		148,
		-1,
		121,
		134,
		-1,
		90,
		86,
		68,
		69,
		64,
		79,
		71,
		56,
		53,
		71,
		74,
		81,
		85,
		101,
		-1,
		-1,
		173,
		177,
		166,
		117,
		136,
		160,
		197,
		146,
		135,
		134,
		-1,
		125,
		104,
		101,
		89,
		76,
		61,
		62,
		70,
		82,
		61,
		55,
		52,
		72,
		98,
		76,
		88,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		143,
		114,
		138,
		180,
		164,
		157,
		145,
		110,
		110,
		104,
		-1,
		100,
		79,
		70,
		59,
		57,
		70,
		62,
		70,
		50,
		48,
		67,
		79,
		70,
		80,
		-1,
		-1,
		-1,
		173,
		162,
		163,
		109,
		132,
		169,
		143,
		129,
		134,
		109,
		102,
		96,
		113,
		96,
		77,
		66,
		58,
		47,
		58,
		66,
		64,
		46,
		55,
		61,
		85,
		68,
		74,
		-1,
		-1,
		180,
		170,
		154,
		156,
		153,
		123,
		130,
		162,
		134,
		147,
		-1,
		101,
		-1,
		90,
		86,
		71,
		66,
		63,
		50,
		49,
		63,
		63,
		53,
		48,
		55,
		90,
		90,
		58,
		78,
		81,
		-1,
		-1,
		-1,
		173,
		168,
		143,
		120,
		104,
		140,
		-1,
		117,
		118,
		-1,
		95,
		89,
		86,
		73,
		69,
		54,
		58,
		60,
		63,
		51,
		57,
		58,
		40,
		64,
		-1,
		66,
		60,
		68,
		58,
		46,
		-1,
		-1,
		-1,
		166,
		145,
		138,
		158,
		99,
		151,
		-1,
		-1,
		102,
		95,
		-1,
		82,
		64,
		66,
		61,
		60,
		59,
		56,
		45,
		58,
		51,
		45,
		39,
		52,
		56,
		59,
		48,
		44,
		41,
		55,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		119,
		-1,
		111,
		103,
		93,
		87,
		81,
		77,
		75,
		88,
		72,
		71,
		68,
		59,
		67,
		40,
		33,
		44,
		29,
		47,
		54,
		46,
		40,
		39,
		51,
		-1,
		186,
		172,
		143,
		-1,
		-1,
		132,
		-1,
		96,
		110,
		126,
		-1,
		119,
		98,
		113,
		91,
		87,
		78,
		95,
		96,
		74,
		68,
		66,
		57,
		45,
		34,
		37,
		29,
		49,
		50,
		34,
		35,
		44,
		-1,
		192,
		179,
		137,
		133,
		122,
		142,
		93,
		81,
		113,
		-1,
		-1,
		155,
		-1,
		89,
		106,
		92,
		90,
		85,
		76,
		82,
		77,
		54,
		49,
		39,
		28,
		28,
		23,
		44,
		30,
		28,
		47,
		63,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		108,
		95,
		89,
		-1,
		130,
		-1,
		133,
		123,
		107,
		92,
		125,
		-1,
		93,
		77,
		82,
		-1,
		74,
		-1,
		47,
		44,
		35,
		20,
		17,
		21,
		25,
		34,
		50,
		-1,
		142,
		127,
		120,
		110,
		124,
		95,
		-1,
		150,
		-1,
		-1,
		120,
		114,
		114,
		98,
		101,
		109,
		89,
		83,
		82,
		69,
		61,
		55,
		33,
		26,
		23,
		12,
		0,
		28,
		41,
		48,
		-1,
		-1,
		-1,
		147,
		133,
		137,
		97,
		116,
		-1,
		-1,
		182,
		137,
		123,
		-1,
		107,
		116,
		104,
		94,
		84,
		87,
		77,
		52,
		45,
		31,
		33,
		31,
		14,
		19,
		36,
		42,
		57,
		-1,
		-1,
		130,
		135,
		123,
		109,
		128,
		-1,
		-1,
		-1,
		129,
		145,
		137,
		108,
		105,
		-1,
		-1,
		88,
		79,
		69,
		48,
		35,
		55,
		51,
		36,
		20,
		25,
		36,
		52,
		57,
		-1,
		133,
		120,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		-1,
		-1,
		156,
		101,
		90,
		85,
		89,
		87,
		-1,
		61,
		59,
		39,
		53,
		60,
		38,
		33,
		27,
		30,
		43,
		59,
		-1,
		-1,
		145,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		113,
		107,
		78,
		71,
		75,
		-1,
		63,
		55,
		41,
		58,
		51,
		48,
		39,
		31,
		36,
		33,
		46,
		60,
		61,
		168,
		-1,
		151,
		-1,
		-1,
		-1,
		131,
		146,
		117,
		94,
		67,
		62,
		55,
		49,
		49,
		65,
		59,
		70,
		38,
		34,
		35,
		39,
		38,
		55,
		65,
		-1,
		-1,
		151,
		164,
		157,
		139,
		143,
		144,
		-1,
		-1,
		71,
		62,
		53,
		56,
		59,
		62,
		44,
		41,
		46,
		51,
		39,
		48,
		66,
		70,
		-1,
		-1,
		-1,
		171,
		-1,
		182,
		-1,
		-1,
		158,
		142,
		89,
		71,
		67,
		65,
		58,
		67,
		56,
		49,
		59,
		69,
		61,
		41,
		61,
		76,
		73,
		102,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		159,
		151,
		146,
		152,
		154,
		145,
		104,
		101,
		-1,
		71,
		96,
		62,
		69,
		61,
		67,
		67,
		65,
		46,
		58,
		74,
		73,
		68,
		94,
		89,
		98,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		152,
		148,
		138,
		128,
		131,
		-1,
		-1,
		120,
		117,
		93,
		71,
		77,
		70,
		65,
		80,
		60,
		47,
		51,
		55,
		61,
		66,
		71,
		77,
		92,
		104,
		-1,
		178,
		236,
		229,
		197,
		205,
		236,
		-1,
		142,
		134,
		145,
		120,
		122,
		-1,
		-1,
		93,
		89,
		90,
		78,
		75,
		88,
		85,
		76,
		61,
		67,
		54,
		53,
		71,
		75,
		84,
		91,
		81,
		94,
		98,
		-1,
		192,
		212,
		191,
		194,
		218,
		232,
		-1,
		139,
		-1,
		-1,
		151,
		123,
		107,
		97,
		92,
		137,
		92,
		87,
		84,
		82,
		73,
		64,
		71,
		62,
		62,
		65,
		80,
		85,
		77,
		91,
		91,
		92,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		167,
		-1,
		134,
		-1,
		110,
		114,
		100,
		103,
		98,
		85,
		77,
		69,
		85,
		60,
		70,
		66,
		67,
		76,
		87,
		99,
		98,
		99,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		151,
		190,
		197,
		-1,
		176,
		-1,
		-1,
		-1,
		124,
		113,
		105,
		118,
		97,
		97,
		71,
		75,
		65,
		72,
		82,
		84,
		76,
		80,
		93,
		104,
		107,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		166,
		157,
		184,
		204,
		193,
		188,
		175,
		-1,
		-1,
		147,
		123,
		-1,
		-1,
		104,
		92,
		75,
		76,
		72,
		75,
		90,
		93,
		83,
		81,
		75,
		107,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		185,
		175,
		179,
		195,
		220,
		-1,
		164,
		-1,
		-1,
		149,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		80,
		91,
		101,
		89,
		90,
		80,
		90,
		103,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		151,
		149,
		155,
		162,
		179,
		209,
		-1,
		-1,
		180,
		160,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		107,
		109,
		98,
		92,
		86,
		93,
		92,
		100,
		108,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		166,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		100,
		104,
		96,
		89,
		84,
		95,
		87,
		91,
		108,
		-1,
		222,
		-1,
		174,
		150,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		90,
		101,
		90,
		93,
		107,
		102,
		-1,
		-1,
		162,
		165,
		-1,
		-1,
		177,
		179,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		94,
		100,
		103,
		92,
		96,
		108,
		-1,
		-1,
		169,
		170,
		175,
		-1,
		162,
		-1,
		180,
		-1,
		147,
		153,
		141,
		-1,
		-1,
		-1,
		135,
		98,
		119,
		129,
		123,
		121,
		112,
		98,
		105,
		103,
		99,
		110,
		-1,
		-1,
		-1,
		180,
		154,
		187,
		178,
		161,
		141,
		133,
		152,
		-1,
		122,
		-1,
		97,
		99,
		125,
		128,
		134,
		128,
		101,
		116,
		106,
		97,
		106,
		186,
		-1,
		156,
		189,
		153,
		147,
		123,
		127,
		143,
		-1,
		119,
		101,
		-1,
		129,
		119,
		150,
		135,
		116,
		103,
		110,
		110,
		103,
		-1,
		-1,
		-1,
		158,
		157,
		149,
		143,
		143,
		128,
		119,
		-1,
		131,
		113,
		92,
		109,
		109,
		100,
		108,
		140,
		136,
		123,
		123,
		115,
		-1,
		259,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		152,
		147,
		120,
		108,
		114,
		110,
		96,
		102,
		104,
		112,
		110,
		107,
		119,
		115,
		135,
		116,
		151,
		-1,
		254,
		-1,
		188,
		-1,
		-1,
		170,
		150,
		142,
		131,
		120,
		118,
		109,
		100,
		122,
		138,
		122,
		120,
		123,
		124,
		-1,
		243,
		242,
		-1,
		189,
		181,
		167,
		-1,
		160,
		-1,
		166,
		127,
		-1,
		129,
		109,
		-1,
		131,
		127,
		-1,
		-1,
		230,
		205,
		-1,
		-1,
		-1,
		190,
		170,
		161,
		145,
		-1,
		120,
		120,
		-1,
		-1,
		-1,
		215,
		214,
		-1,
		183,
		186,
		-1,
		176,
		167,
		175,
		122,
		126,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		198,
		196,
		191,
		188,
		174,
		158,
		136,
		125,
		146,
		-1,
		-1,
		-1,
		196,
		188,
		181,
		-1,
		-1,
		183,
		166,
		147,
		145,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		173,
		-1,
		-1,
		179,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		207,
		-1,
		-1,
		-1,
		169,
		165,
		166,
		-1,
		-1,
		-1,
		-1,
		229,
		230,
		253,
		217,
		-1,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		232,
		230,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		194,
		-1,
		194,
		169,
		176,
		-1,
		-1,
		-1,
		-1,
		207,
		199,
		207,
		-1,
		179,
		181,
		-1,
		229,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		184,
		191,
		213,
		216,
		252,
		-1,
		203
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		130,
		148,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		127,
		-1,
		139,
		140,
		135,
		143,
		143,
		119,
		106,
		106,
		116,
		109,
		128,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		122,
		139,
		131,
		121,
		136,
		129,
		109,
		106,
		104,
		101,
		117,
		115,
		125,
		-1,
		-1,
		230,
		199,
		230,
		188,
		169,
		-1,
		135,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		95,
		94,
		122,
		108,
		119,
		190,
		-1,
		-1,
		188,
		180,
		165,
		168,
		145,
		141,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		89,
		99,
		103,
		101,
		126,
		-1,
		-1,
		153,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		151,
		157,
		143,
		164,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		86,
		111,
		115,
		96,
		117,
		112,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		180,
		-1,
		152,
		140,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		90,
		88,
		118,
		93,
		115,
		112,
		123,
		128,
		122,
		131,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		188,
		189,
		164,
		137,
		140,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		82,
		97,
		88,
		87,
		105,
		107,
		115,
		119,
		125,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		189,
		181,
		166,
		164,
		-1,
		136,
		133,
		123,
		101,
		86,
		103,
		95,
		93,
		95,
		77,
		91,
		82,
		100,
		107,
		97,
		101,
		121,
		133,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		138,
		151,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		88,
		73,
		70,
		88,
		91,
		90,
		94,
		110,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		121,
		118,
		106,
		93,
		78,
		79,
		87,
		99,
		78,
		72,
		69,
		89,
		107,
		85,
		96,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		117,
		96,
		87,
		76,
		74,
		87,
		79,
		87,
		67,
		65,
		84,
		88,
		79,
		87,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		130,
		113,
		94,
		83,
		75,
		64,
		75,
		83,
		81,
		63,
		72,
		78,
		94,
		75,
		81,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		103,
		88,
		83,
		80,
		67,
		66,
		80,
		80,
		70,
		65,
		72,
		99,
		99,
		65,
		85,
		88,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		90,
		86,
		71,
		75,
		77,
		80,
		68,
		74,
		75,
		57,
		81,
		-1,
		73,
		67,
		75,
		65,
		53,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		83,
		78,
		77,
		76,
		73,
		62,
		75,
		68,
		62,
		56,
		69,
		73,
		66,
		55,
		51,
		48,
		62,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		105,
		89,
		88,
		85,
		76,
		84,
		57,
		50,
		61,
		46,
		64,
		61,
		53,
		47,
		46,
		58,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		95,
		112,
		113,
		91,
		85,
		83,
		74,
		62,
		51,
		54,
		46,
		65,
		57,
		41,
		42,
		51,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		109,
		107,
		102,
		93,
		99,
		94,
		71,
		66,
		56,
		45,
		45,
		40,
		47,
		37,
		35,
		49,
		65,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		110,
		94,
		99,
		-1,
		91,
		-1,
		64,
		61,
		52,
		37,
		34,
		45,
		32,
		25,
		44,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		126,
		106,
		100,
		99,
		86,
		78,
		72,
		50,
		43,
		40,
		30,
		31,
		0,
		31,
		42,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		133,
		121,
		111,
		101,
		104,
		94,
		69,
		62,
		48,
		50,
		42,
		25,
		18,
		30,
		36,
		51,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		122,
		-1,
		-1,
		105,
		96,
		86,
		65,
		52,
		57,
		52,
		39,
		25,
		19,
		30,
		46,
		51,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		173,
		118,
		107,
		102,
		106,
		104,
		-1,
		78,
		76,
		56,
		66,
		73,
		41,
		38,
		32,
		35,
		37,
		53,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		130,
		124,
		95,
		88,
		92,
		-1,
		80,
		72,
		58,
		72,
		56,
		53,
		44,
		36,
		41,
		38,
		50,
		65,
		55,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		148,
		163,
		134,
		111,
		84,
		79,
		72,
		66,
		66,
		78,
		64,
		75,
		43,
		39,
		40,
		44,
		43,
		60,
		70,
		-1,
		-1,
		168,
		169,
		174,
		156,
		160,
		161,
		-1,
		-1,
		88,
		79,
		70,
		70,
		76,
		79,
		49,
		46,
		51,
		56,
		44,
		53,
		71,
		73,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		159,
		106,
		88,
		84,
		82,
		75,
		73,
		61,
		54,
		64,
		74,
		66,
		46,
		66,
		81,
		78,
		107,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		121,
		118,
		-1,
		88,
		102,
		67,
		74,
		66,
		72,
		72,
		70,
		51,
		63,
		79,
		78,
		73,
		99,
		94,
		103,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		99,
		76,
		82,
		75,
		70,
		85,
		65,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		109,
		-1,
		195,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		93,
		90,
		81,
		66,
		72,
		59,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		97,
		92,
		89,
		87,
		78,
		69,
		76,
		67,
		67,
		70,
		85,
		90,
		82,
		96,
		96,
		97,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		139,
		-1,
		122,
		126,
		105,
		108,
		103,
		90,
		82,
		74,
		90,
		65,
		75,
		71,
		72,
		81,
		92,
		104,
		103,
		104,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		202,
		-1,
		181,
		-1,
		-1,
		-1,
		136,
		118,
		110,
		123,
		102,
		102,
		76,
		80,
		70,
		77,
		87,
		89,
		81,
		85,
		98,
		109,
		112,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		209,
		198,
		193,
		180,
		-1,
		-1,
		159,
		128,
		-1,
		-1,
		109,
		97,
		80,
		81,
		77,
		80,
		95,
		98,
		88,
		86,
		80,
		112,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		200,
		225,
		-1,
		169,
		-1,
		-1,
		154,
		-1,
		-1,
		139,
		102,
		91,
		82,
		88,
		85,
		96,
		106,
		94,
		95,
		85,
		95,
		108,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		185,
		165,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		87,
		92,
		112,
		114,
		103,
		97,
		91,
		98,
		97,
		105,
		113,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		171,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		101,
		105,
		109,
		101,
		94,
		89,
		100,
		92,
		96,
		113,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		145,
		113,
		118,
		113,
		95,
		106,
		95,
		98,
		112,
		107,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		182,
		184,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		102,
		127,
		116,
		124,
		119,
		99,
		105,
		108,
		97,
		101,
		113,
		-1,
		-1,
		174,
		175,
		180,
		-1,
		167,
		-1,
		185,
		-1,
		152,
		158,
		146,
		-1,
		-1,
		-1,
		140,
		103,
		124,
		134,
		128,
		126,
		117,
		103,
		110,
		108,
		104,
		115,
		-1,
		-1,
		-1,
		185,
		159,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		127,
		-1,
		102,
		104,
		130,
		133,
		139,
		133,
		106,
		121,
		111,
		102,
		111,
		191,
		-1,
		161,
		194,
		158,
		152,
		128,
		132,
		148,
		-1,
		124,
		106,
		-1,
		134,
		124,
		155,
		140,
		121,
		108,
		115,
		115,
		108,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		136,
		118,
		97,
		114,
		114,
		105,
		113,
		145,
		141,
		128,
		128,
		120,
		-1,
		264,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		152,
		125,
		113,
		119,
		115,
		101,
		107,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		121,
		156,
		-1,
		259,
		-1,
		193,
		-1,
		-1,
		175,
		155,
		147,
		136,
		125,
		123,
		114,
		105,
		127,
		143,
		127,
		125,
		128,
		129,
		-1,
		248,
		247,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		171,
		132,
		-1,
		134,
		114,
		-1,
		136,
		132,
		-1,
		-1,
		235,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		166,
		150,
		-1,
		125,
		125,
		-1,
		-1,
		-1,
		220,
		219,
		-1,
		188,
		191,
		-1,
		181,
		172,
		180,
		127,
		131,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		203,
		201,
		196,
		193,
		179,
		163,
		141,
		130,
		151,
		-1,
		-1,
		-1,
		201,
		193,
		186,
		-1,
		-1,
		188,
		171,
		152,
		150,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		178,
		-1,
		-1,
		184,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		212,
		-1,
		-1,
		-1,
		174,
		170,
		171,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		258,
		222,
		-1,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		237,
		235,
		-1,
		-1,
		-1,
		194,
		178,
		-1,
		164,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		199,
		-1,
		199,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		212,
		204,
		212,
		-1,
		184,
		186,
		-1,
		234,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		189,
		196,
		218,
		221,
		257,
		-1,
		208
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		192,
		196,
		162,
		156,
		195,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		185,
		184,
		152,
		150,
		159,
		164,
		171,
		-1,
		170,
		-1,
		206,
		185,
		196,
		201,
		145,
		142,
		162,
		181,
		163,
		155,
		221,
		175,
		146,
		140,
		158,
		148,
		157,
		149,
		-1,
		146,
		136,
		158,
		137,
		148,
		140,
		-1,
		-1,
		140,
		141,
		147,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		130,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		127,
		145,
		150,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		124,
		-1,
		136,
		137,
		132,
		140,
		140,
		116,
		103,
		103,
		113,
		106,
		125,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		119,
		136,
		128,
		118,
		133,
		126,
		106,
		103,
		101,
		98,
		114,
		112,
		122,
		-1,
		-1,
		227,
		196,
		227,
		185,
		166,
		-1,
		132,
		112,
		118,
		122,
		116,
		109,
		123,
		119,
		-1,
		92,
		91,
		119,
		105,
		116,
		187,
		-1,
		-1,
		185,
		177,
		162,
		165,
		142,
		138,
		127,
		126,
		118,
		104,
		100,
		106,
		109,
		109,
		115,
		86,
		96,
		100,
		98,
		123,
		-1,
		-1,
		142,
		-1,
		-1,
		184,
		167,
		-1,
		150,
		157,
		148,
		154,
		140,
		161,
		137,
		128,
		120,
		114,
		102,
		104,
		101,
		114,
		102,
		83,
		108,
		112,
		93,
		114,
		109,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		146,
		152,
		176,
		177,
		-1,
		149,
		137,
		138,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		87,
		85,
		115,
		90,
		112,
		107,
		112,
		117,
		111,
		120,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		180,
		-1,
		185,
		186,
		161,
		134,
		137,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		79,
		94,
		85,
		84,
		96,
		96,
		104,
		108,
		114,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		200,
		186,
		178,
		163,
		161,
		-1,
		133,
		130,
		120,
		98,
		83,
		100,
		92,
		90,
		92,
		74,
		88,
		79,
		97,
		100,
		86,
		90,
		110,
		122,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		135,
		148,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		85,
		70,
		67,
		85,
		88,
		79,
		83,
		99,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		118,
		115,
		103,
		90,
		75,
		76,
		84,
		96,
		75,
		69,
		66,
		86,
		96,
		74,
		85,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		114,
		93,
		84,
		73,
		71,
		84,
		76,
		84,
		64,
		62,
		81,
		77,
		68,
		76,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		127,
		110,
		91,
		80,
		72,
		61,
		72,
		80,
		78,
		60,
		69,
		75,
		83,
		64,
		70,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		100,
		85,
		80,
		77,
		64,
		63,
		77,
		77,
		67,
		62,
		69,
		88,
		88,
		54,
		73,
		76,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		87,
		83,
		68,
		72,
		74,
		77,
		65,
		71,
		72,
		54,
		78,
		-1,
		62,
		56,
		63,
		53,
		42,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		80,
		75,
		74,
		73,
		70,
		59,
		72,
		65,
		59,
		53,
		66,
		70,
		55,
		44,
		40,
		37,
		51,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		102,
		86,
		85,
		82,
		73,
		81,
		54,
		47,
		58,
		43,
		61,
		50,
		42,
		36,
		30,
		47,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		92,
		109,
		110,
		88,
		82,
		80,
		71,
		59,
		48,
		51,
		43,
		54,
		46,
		30,
		31,
		26,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		106,
		104,
		99,
		90,
		96,
		91,
		68,
		63,
		53,
		42,
		42,
		37,
		36,
		26,
		24,
		24,
		40,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		107,
		91,
		96,
		-1,
		88,
		-1,
		61,
		58,
		49,
		34,
		31,
		34,
		21,
		8,
		18,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		123,
		103,
		97,
		96,
		83,
		75,
		69,
		47,
		40,
		37,
		34,
		47,
		33,
		0,
		20,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		130,
		118,
		108,
		98,
		101,
		91,
		66,
		59,
		45,
		47,
		45,
		43,
		45,
		34,
		26,
		25,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		119,
		-1,
		-1,
		102,
		93,
		83,
		62,
		49,
		69,
		72,
		58,
		42,
		46,
		40,
		27,
		36,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		115,
		104,
		99,
		103,
		101,
		-1,
		75,
		73,
		53,
		67,
		74,
		60,
		55,
		49,
		45,
		45,
		38,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		127,
		121,
		92,
		85,
		89,
		-1,
		77,
		69,
		55,
		72,
		73,
		70,
		61,
		53,
		56,
		42,
		55,
		50,
		40,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		145,
		160,
		131,
		108,
		81,
		76,
		69,
		63,
		63,
		79,
		81,
		92,
		60,
		56,
		55,
		48,
		47,
		54,
		55,
		-1,
		-1,
		165,
		179,
		171,
		153,
		157,
		158,
		-1,
		-1,
		85,
		76,
		67,
		70,
		73,
		76,
		66,
		63,
		68,
		65,
		58,
		57,
		73,
		58,
		-1,
		-1,
		-1,
		185,
		-1,
		197,
		-1,
		-1,
		172,
		156,
		103,
		85,
		81,
		79,
		72,
		81,
		76,
		71,
		81,
		83,
		75,
		55,
		73,
		85,
		66,
		92,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		169,
		160,
		118,
		115,
		-1,
		85,
		110,
		82,
		89,
		81,
		89,
		87,
		79,
		60,
		73,
		89,
		78,
		77,
		84,
		79,
		88,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		134,
		131,
		107,
		91,
		95,
		88,
		83,
		95,
		75,
		62,
		66,
		70,
		76,
		75,
		80,
		86,
		86,
		94,
		-1,
		192,
		256,
		249,
		217,
		225,
		256,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		107,
		104,
		109,
		98,
		95,
		105,
		100,
		91,
		76,
		82,
		69,
		68,
		86,
		90,
		93,
		100,
		89,
		102,
		106,
		-1,
		206,
		232,
		211,
		214,
		238,
		252,
		-1,
		154,
		-1,
		-1,
		166,
		138,
		122,
		112,
		106,
		156,
		112,
		107,
		99,
		97,
		88,
		79,
		86,
		77,
		77,
		80,
		95,
		100,
		92,
		99,
		99,
		100,
		-1,
		201,
		212,
		205,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		149,
		-1,
		124,
		128,
		120,
		123,
		113,
		100,
		92,
		84,
		100,
		75,
		85,
		81,
		82,
		91,
		102,
		114,
		106,
		107,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		166,
		205,
		212,
		-1,
		191,
		-1,
		-1,
		-1,
		138,
		133,
		125,
		133,
		112,
		112,
		86,
		90,
		80,
		87,
		97,
		99,
		91,
		95,
		108,
		116,
		115,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		181,
		172,
		199,
		219,
		208,
		203,
		190,
		-1,
		-1,
		161,
		143,
		-1,
		-1,
		119,
		107,
		90,
		91,
		87,
		90,
		105,
		108,
		98,
		96,
		90,
		121,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		200,
		195,
		199,
		215,
		240,
		-1,
		179,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		112,
		101,
		92,
		98,
		95,
		106,
		116,
		104,
		105,
		95,
		105,
		118,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		199,
		229,
		-1,
		-1,
		195,
		175,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		97,
		102,
		122,
		124,
		113,
		107,
		101,
		108,
		107,
		115,
		123,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		181,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		115,
		119,
		111,
		104,
		99,
		110,
		102,
		106,
		123,
		-1,
		242,
		-1,
		194,
		170,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		105,
		116,
		105,
		108,
		122,
		117,
		-1,
		-1,
		182,
		185,
		-1,
		-1,
		192,
		194,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		109,
		115,
		118,
		107,
		111,
		123,
		-1,
		-1,
		189,
		190,
		195,
		-1,
		177,
		-1,
		195,
		-1,
		162,
		168,
		156,
		-1,
		-1,
		-1,
		150,
		113,
		134,
		144,
		138,
		136,
		127,
		113,
		120,
		118,
		114,
		125,
		-1,
		-1,
		-1,
		195,
		169,
		202,
		193,
		176,
		156,
		148,
		167,
		-1,
		137,
		-1,
		112,
		114,
		140,
		143,
		149,
		143,
		116,
		131,
		121,
		112,
		121,
		201,
		-1,
		171,
		204,
		168,
		162,
		138,
		142,
		158,
		-1,
		134,
		116,
		-1,
		144,
		134,
		165,
		150,
		131,
		118,
		125,
		125,
		118,
		-1,
		-1,
		-1,
		173,
		172,
		164,
		158,
		158,
		143,
		134,
		-1,
		146,
		128,
		107,
		124,
		124,
		115,
		123,
		155,
		151,
		138,
		138,
		130,
		-1,
		274,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		167,
		162,
		135,
		123,
		129,
		125,
		111,
		117,
		119,
		127,
		125,
		122,
		134,
		130,
		150,
		131,
		166,
		-1,
		269,
		-1,
		203,
		-1,
		-1,
		185,
		165,
		157,
		146,
		135,
		133,
		124,
		115,
		137,
		153,
		137,
		135,
		138,
		139,
		-1,
		258,
		257,
		-1,
		204,
		196,
		182,
		-1,
		175,
		-1,
		181,
		142,
		-1,
		144,
		124,
		-1,
		146,
		142,
		-1,
		-1,
		245,
		220,
		-1,
		-1,
		-1,
		205,
		185,
		176,
		160,
		-1,
		135,
		135,
		-1,
		-1,
		-1,
		230,
		229,
		-1,
		198,
		201,
		-1,
		191,
		182,
		190,
		137,
		141,
		-1,
		-1,
		-1,
		239,
		220,
		214,
		213,
		211,
		206,
		203,
		189,
		173,
		151,
		140,
		161,
		-1,
		-1,
		-1,
		211,
		203,
		196,
		-1,
		-1,
		198,
		181,
		162,
		160,
		-1,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		188,
		-1,
		-1,
		194,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		222,
		-1,
		-1,
		-1,
		184,
		180,
		181,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		268,
		232,
		-1,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		247,
		245,
		-1,
		-1,
		-1,
		204,
		188,
		-1,
		174,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		209,
		-1,
		209,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		222,
		214,
		222,
		-1,
		194,
		196,
		-1,
		244,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		199,
		206,
		228,
		231,
		267,
		-1,
		218
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		199,
		203,
		169,
		163,
		202,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		192,
		191,
		159,
		157,
		166,
		171,
		178,
		-1,
		177,
		-1,
		213,
		192,
		203,
		208,
		152,
		149,
		169,
		188,
		170,
		162,
		228,
		182,
		153,
		147,
		165,
		155,
		164,
		156,
		-1,
		153,
		143,
		165,
		144,
		155,
		147,
		-1,
		-1,
		147,
		148,
		154,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		137,
		138,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		128,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		139,
		-1,
		128,
		146,
		155,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		131,
		-1,
		137,
		138,
		133,
		141,
		146,
		123,
		110,
		110,
		120,
		113,
		132,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		120,
		137,
		129,
		119,
		134,
		127,
		113,
		110,
		108,
		105,
		121,
		119,
		129,
		-1,
		-1,
		230,
		199,
		228,
		186,
		167,
		-1,
		133,
		113,
		119,
		123,
		117,
		110,
		124,
		120,
		-1,
		99,
		98,
		126,
		112,
		123,
		190,
		-1,
		-1,
		188,
		180,
		163,
		166,
		143,
		139,
		128,
		127,
		119,
		105,
		101,
		107,
		110,
		110,
		116,
		93,
		103,
		107,
		105,
		111,
		-1,
		-1,
		125,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		149,
		155,
		141,
		162,
		138,
		129,
		121,
		115,
		103,
		105,
		102,
		115,
		103,
		90,
		115,
		119,
		100,
		101,
		96,
		-1,
		124,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		178,
		-1,
		150,
		138,
		139,
		124,
		121,
		108,
		96,
		109,
		94,
		101,
		100,
		94,
		92,
		122,
		97,
		100,
		90,
		95,
		100,
		94,
		103,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		186,
		187,
		162,
		135,
		138,
		125,
		116,
		103,
		92,
		103,
		92,
		89,
		97,
		86,
		101,
		92,
		91,
		79,
		79,
		87,
		91,
		97,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		187,
		179,
		164,
		164,
		-1,
		134,
		131,
		121,
		99,
		84,
		101,
		93,
		91,
		96,
		81,
		95,
		86,
		85,
		83,
		69,
		73,
		93,
		105,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		136,
		149,
		-1,
		105,
		101,
		83,
		84,
		79,
		94,
		92,
		77,
		74,
		81,
		76,
		62,
		66,
		82,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		119,
		116,
		104,
		91,
		76,
		77,
		85,
		98,
		77,
		76,
		73,
		72,
		79,
		57,
		68,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		72,
		85,
		82,
		91,
		71,
		69,
		67,
		60,
		51,
		59,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		128,
		111,
		92,
		81,
		73,
		62,
		78,
		86,
		85,
		67,
		76,
		61,
		66,
		47,
		53,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		71,
		69,
		78,
		84,
		74,
		69,
		76,
		71,
		71,
		37,
		56,
		59,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		75,
		79,
		76,
		83,
		72,
		78,
		79,
		61,
		85,
		-1,
		45,
		39,
		46,
		36,
		25,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		87,
		82,
		80,
		80,
		77,
		66,
		79,
		72,
		66,
		60,
		73,
		60,
		44,
		27,
		23,
		20,
		34,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		108,
		92,
		92,
		89,
		80,
		88,
		61,
		54,
		65,
		50,
		68,
		41,
		31,
		21,
		13,
		30,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		99,
		115,
		116,
		94,
		89,
		87,
		78,
		66,
		55,
		58,
		50,
		43,
		35,
		19,
		16,
		9,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		113,
		111,
		105,
		96,
		102,
		98,
		75,
		70,
		60,
		49,
		49,
		44,
		41,
		27,
		25,
		7,
		23,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		113,
		97,
		102,
		-1,
		95,
		-1,
		68,
		65,
		56,
		41,
		38,
		37,
		28,
		24,
		2,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		129,
		109,
		103,
		102,
		90,
		82,
		76,
		54,
		47,
		44,
		39,
		52,
		49,
		16,
		0,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		137,
		125,
		115,
		105,
		108,
		98,
		73,
		66,
		52,
		54,
		51,
		41,
		29,
		14,
		6,
		16,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		126,
		-1,
		-1,
		109,
		100,
		90,
		69,
		56,
		68,
		63,
		50,
		34,
		30,
		20,
		7,
		16,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		177,
		122,
		111,
		106,
		110,
		108,
		-1,
		82,
		80,
		60,
		74,
		81,
		52,
		40,
		34,
		25,
		25,
		18,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		134,
		128,
		99,
		92,
		96,
		-1,
		84,
		76,
		62,
		79,
		58,
		55,
		46,
		36,
		36,
		22,
		35,
		30,
		20,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		152,
		167,
		138,
		115,
		88,
		83,
		76,
		70,
		70,
		80,
		66,
		77,
		43,
		39,
		35,
		28,
		27,
		34,
		35,
		-1,
		-1,
		168,
		169,
		178,
		160,
		164,
		165,
		-1,
		-1,
		92,
		83,
		74,
		70,
		80,
		83,
		49,
		46,
		51,
		45,
		38,
		37,
		53,
		38,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		163,
		110,
		92,
		88,
		86,
		79,
		73,
		61,
		54,
		64,
		63,
		55,
		35,
		53,
		65,
		46,
		72,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		125,
		122,
		-1,
		92,
		102,
		67,
		74,
		66,
		70,
		67,
		59,
		40,
		54,
		70,
		58,
		57,
		64,
		59,
		68,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		99,
		76,
		79,
		72,
		67,
		77,
		57,
		44,
		47,
		51,
		57,
		55,
		60,
		66,
		66,
		74,
		-1,
		195,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		87,
		82,
		73,
		58,
		64,
		51,
		49,
		67,
		71,
		73,
		80,
		69,
		82,
		86,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		97,
		92,
		81,
		79,
		70,
		61,
		68,
		59,
		58,
		61,
		77,
		82,
		74,
		79,
		79,
		80,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		139,
		-1,
		122,
		126,
		105,
		108,
		95,
		82,
		74,
		66,
		82,
		57,
		66,
		62,
		64,
		73,
		84,
		96,
		86,
		87,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		194,
		-1,
		178,
		-1,
		-1,
		-1,
		136,
		118,
		110,
		115,
		94,
		94,
		68,
		72,
		62,
		69,
		78,
		80,
		73,
		77,
		90,
		96,
		95,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		201,
		190,
		185,
		172,
		-1,
		-1,
		159,
		128,
		-1,
		-1,
		101,
		89,
		72,
		73,
		69,
		72,
		87,
		89,
		80,
		78,
		72,
		101,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		200,
		225,
		-1,
		161,
		-1,
		-1,
		146,
		-1,
		-1,
		131,
		94,
		83,
		74,
		80,
		77,
		88,
		98,
		86,
		87,
		77,
		87,
		100,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		177,
		157,
		-1,
		-1,
		129,
		127,
		116,
		-1,
		106,
		79,
		84,
		104,
		106,
		95,
		89,
		83,
		90,
		89,
		97,
		105,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		167,
		163,
		-1,
		-1,
		124,
		117,
		105,
		93,
		83,
		93,
		97,
		101,
		93,
		86,
		81,
		92,
		84,
		88,
		105,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		184,
		170,
		163,
		151,
		149,
		-1,
		158,
		142,
		123,
		-1,
		93,
		106,
		137,
		105,
		110,
		105,
		87,
		98,
		87,
		90,
		104,
		99,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		174,
		176,
		-1,
		175,
		164,
		149,
		141,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		94,
		119,
		108,
		116,
		111,
		91,
		97,
		100,
		89,
		93,
		105,
		-1,
		-1,
		174,
		175,
		180,
		-1,
		159,
		-1,
		177,
		-1,
		144,
		150,
		138,
		-1,
		-1,
		-1,
		132,
		95,
		116,
		126,
		120,
		118,
		109,
		95,
		102,
		100,
		96,
		107,
		-1,
		-1,
		-1,
		177,
		151,
		184,
		175,
		158,
		138,
		130,
		149,
		-1,
		119,
		-1,
		94,
		96,
		122,
		125,
		131,
		125,
		98,
		113,
		103,
		94,
		103,
		183,
		-1,
		153,
		186,
		150,
		144,
		120,
		124,
		140,
		-1,
		116,
		98,
		-1,
		126,
		116,
		147,
		132,
		113,
		100,
		107,
		107,
		100,
		-1,
		-1,
		-1,
		155,
		154,
		146,
		140,
		140,
		125,
		116,
		-1,
		128,
		110,
		89,
		106,
		106,
		97,
		105,
		137,
		133,
		120,
		120,
		112,
		-1,
		256,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		149,
		144,
		117,
		105,
		111,
		107,
		93,
		99,
		101,
		109,
		107,
		104,
		116,
		112,
		132,
		113,
		148,
		-1,
		251,
		-1,
		185,
		-1,
		-1,
		167,
		147,
		139,
		128,
		117,
		115,
		106,
		97,
		119,
		135,
		119,
		117,
		120,
		121,
		-1,
		240,
		239,
		-1,
		186,
		178,
		164,
		-1,
		157,
		-1,
		163,
		124,
		-1,
		126,
		106,
		-1,
		128,
		124,
		-1,
		-1,
		227,
		202,
		-1,
		-1,
		-1,
		187,
		167,
		158,
		142,
		-1,
		117,
		117,
		-1,
		-1,
		-1,
		212,
		211,
		-1,
		180,
		183,
		-1,
		173,
		164,
		172,
		119,
		123,
		-1,
		-1,
		-1,
		221,
		202,
		196,
		195,
		193,
		188,
		185,
		171,
		155,
		133,
		122,
		143,
		-1,
		-1,
		-1,
		193,
		185,
		178,
		-1,
		-1,
		180,
		163,
		144,
		142,
		-1,
		-1,
		-1,
		215,
		196,
		-1,
		-1,
		170,
		-1,
		-1,
		176,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		204,
		-1,
		-1,
		-1,
		166,
		162,
		163,
		-1,
		-1,
		-1,
		-1,
		226,
		227,
		250,
		214,
		-1,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		229,
		227,
		-1,
		-1,
		-1,
		186,
		170,
		-1,
		156,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		189,
		-1,
		-1,
		-1,
		191,
		-1,
		191,
		166,
		173,
		-1,
		-1,
		-1,
		-1,
		204,
		196,
		204,
		-1,
		176,
		178,
		-1,
		226,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		181,
		188,
		210,
		213,
		249,
		-1,
		200
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		210,
		199,
		210,
		218,
		191,
		198,
		-1,
		219,
		221,
		187,
		181,
		220,
		191,
		197,
		208,
		-1,
		-1,
		-1,
		210,
		209,
		179,
		177,
		186,
		191,
		198,
		-1,
		221,
		-1,
		231,
		210,
		221,
		226,
		172,
		169,
		189,
		208,
		214,
		206,
		246,
		202,
		173,
		167,
		185,
		190,
		208,
		200,
		-1,
		173,
		163,
		185,
		189,
		201,
		184,
		-1,
		-1,
		167,
		168,
		174,
		186,
		191,
		196,
		-1,
		219,
		203,
		-1,
		-1,
		157,
		170,
		166,
		169,
		177,
		193,
		211,
		203,
		198,
		-1,
		-1,
		158,
		162,
		175,
		176,
		174,
		198,
		211,
		193,
		207,
		206,
		-1,
		146,
		164,
		173,
		182,
		188,
		174,
		172,
		190,
		192,
		198,
		201,
		-1,
		138,
		140,
		169,
		175,
		187,
		190,
		177,
		177,
		187,
		180,
		199,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		135,
		143,
		169,
		168,
		164,
		182,
		187,
		180,
		177,
		175,
		172,
		188,
		189,
		199,
		-1,
		-1,
		191,
		160,
		195,
		152,
		137,
		-1,
		131,
		150,
		156,
		160,
		165,
		170,
		184,
		180,
		-1,
		166,
		165,
		196,
		182,
		193,
		151,
		-1,
		-1,
		149,
		141,
		126,
		129,
		126,
		126,
		156,
		155,
		160,
		162,
		161,
		167,
		170,
		170,
		176,
		160,
		170,
		174,
		185,
		200,
		-1,
		-1,
		255,
		-1,
		-1,
		148,
		131,
		-1,
		114,
		121,
		121,
		138,
		128,
		149,
		164,
		168,
		176,
		175,
		163,
		165,
		162,
		175,
		163,
		157,
		182,
		186,
		180,
		201,
		196,
		-1,
		254,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		107,
		110,
		116,
		140,
		150,
		-1,
		171,
		169,
		193,
		184,
		181,
		168,
		156,
		169,
		154,
		161,
		160,
		164,
		166,
		199,
		177,
		199,
		196,
		225,
		230,
		224,
		233,
		-1,
		156,
		152,
		148,
		155,
		104,
		-1,
		-1,
		144,
		-1,
		158,
		171,
		175,
		173,
		176,
		185,
		176,
		163,
		152,
		163,
		152,
		149,
		157,
		166,
		177,
		172,
		171,
		189,
		204,
		217,
		221,
		227,
		-1,
		206,
		-1,
		148,
		132,
		134,
		106,
		127,
		-1,
		164,
		159,
		179,
		177,
		168,
		-1,
		171,
		174,
		181,
		159,
		144,
		161,
		153,
		151,
		156,
		161,
		175,
		166,
		184,
		191,
		199,
		203,
		223,
		235,
		166,
		156,
		-1,
		138,
		143,
		102,
		110,
		129,
		202,
		174,
		-1,
		169,
		-1,
		161,
		186,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		160,
		157,
		154,
		172,
		175,
		192,
		196,
		212,
		-1,
		-1,
		151,
		155,
		144,
		95,
		114,
		138,
		175,
		167,
		156,
		155,
		-1,
		146,
		176,
		173,
		159,
		146,
		136,
		137,
		145,
		158,
		137,
		156,
		159,
		181,
		209,
		187,
		199,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		121,
		92,
		116,
		158,
		185,
		178,
		166,
		131,
		131,
		125,
		-1,
		166,
		149,
		145,
		134,
		132,
		145,
		140,
		156,
		160,
		159,
		178,
		190,
		181,
		201,
		-1,
		-1,
		-1,
		151,
		140,
		141,
		87,
		110,
		147,
		164,
		150,
		155,
		130,
		123,
		117,
		169,
		166,
		133,
		141,
		133,
		122,
		136,
		144,
		148,
		157,
		166,
		172,
		196,
		196,
		202,
		-1,
		-1,
		158,
		148,
		132,
		134,
		131,
		101,
		108,
		140,
		155,
		152,
		-1,
		122,
		-1,
		111,
		119,
		118,
		124,
		136,
		122,
		127,
		138,
		150,
		163,
		159,
		166,
		201,
		201,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		151,
		146,
		121,
		98,
		82,
		118,
		-1,
		122,
		123,
		-1,
		116,
		110,
		116,
		115,
		122,
		119,
		119,
		133,
		141,
		137,
		153,
		159,
		151,
		187,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		144,
		123,
		116,
		136,
		77,
		129,
		-1,
		-1,
		107,
		100,
		-1,
		103,
		103,
		110,
		119,
		124,
		129,
		137,
		132,
		145,
		150,
		156,
		161,
		179,
		183,
		187,
		176,
		172,
		169,
		183,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		97,
		-1,
		116,
		108,
		98,
		92,
		98,
		116,
		114,
		134,
		126,
		140,
		140,
		146,
		154,
		139,
		142,
		158,
		156,
		174,
		182,
		174,
		168,
		167,
		179,
		-1,
		143,
		129,
		100,
		-1,
		-1,
		110,
		-1,
		74,
		98,
		114,
		-1,
		132,
		111,
		134,
		112,
		126,
		122,
		160,
		161,
		139,
		144,
		152,
		162,
		164,
		153,
		164,
		156,
		178,
		178,
		162,
		163,
		172,
		-1,
		149,
		136,
		94,
		89,
		78,
		91,
		71,
		80,
		101,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		136,
		134,
		150,
		141,
		147,
		163,
		166,
		168,
		158,
		147,
		153,
		150,
		172,
		158,
		156,
		175,
		191,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		57,
		67,
		67,
		-1,
		118,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		158,
		142,
		147,
		-1,
		193,
		-1,
		166,
		168,
		162,
		147,
		144,
		155,
		153,
		164,
		181,
		-1,
		53,
		38,
		31,
		38,
		96,
		67,
		-1,
		123,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		174,
		154,
		148,
		147,
		188,
		188,
		174,
		160,
		153,
		150,
		147,
		160,
		180,
		171,
		183,
		-1,
		-1,
		-1,
		0,
		111,
		110,
		75,
		89,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		191,
		179,
		169,
		159,
		193,
		194,
		179,
		172,
		158,
		160,
		158,
		156,
		161,
		182,
		183,
		196,
		-1,
		-1,
		108,
		108,
		96,
		82,
		101,
		-1,
		-1,
		-1,
		150,
		166,
		158,
		129,
		180,
		-1,
		-1,
		171,
		169,
		179,
		175,
		162,
		182,
		185,
		171,
		155,
		170,
		182,
		190,
		195,
		-1,
		111,
		98,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		161,
		182,
		207,
		174,
		-1,
		179,
		180,
		166,
		180,
		187,
		173,
		168,
		162,
		165,
		183,
		200,
		-1,
		-1,
		118,
		-1,
		113,
		-1,
		-1,
		-1,
		-1,
		140,
		154,
		175,
		181,
		193,
		-1,
		188,
		182,
		168,
		185,
		186,
		183,
		174,
		166,
		171,
		168,
		181,
		195,
		199,
		141,
		-1,
		124,
		-1,
		-1,
		-1,
		158,
		173,
		235,
		212,
		185,
		189,
		182,
		176,
		176,
		192,
		194,
		205,
		173,
		169,
		170,
		174,
		173,
		190,
		200,
		-1,
		-1,
		124,
		141,
		176,
		166,
		170,
		262,
		-1,
		-1,
		198,
		189,
		180,
		183,
		186,
		189,
		179,
		176,
		181,
		186,
		174,
		183,
		201,
		205,
		-1,
		-1,
		-1,
		144,
		-1,
		159,
		-1,
		-1,
		185,
		269,
		216,
		198,
		194,
		192,
		185,
		194,
		189,
		184,
		194,
		203,
		195,
		176,
		187,
		210,
		199,
		237,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		173,
		148,
		163,
		209,
		205,
		205,
		231,
		228,
		-1,
		198,
		223,
		195,
		202,
		194,
		202,
		202,
		199,
		177,
		184,
		200,
		199,
		194,
		229,
		221,
		227,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		179,
		165,
		195,
		185,
		191,
		-1,
		-1,
		238,
		235,
		220,
		204,
		208,
		201,
		196,
		206,
		186,
		173,
		177,
		181,
		187,
		192,
		197,
		203,
		218,
		233,
		-1,
		156,
		237,
		230,
		213,
		221,
		252,
		-1,
		182,
		191,
		172,
		177,
		185,
		-1,
		-1,
		211,
		207,
		212,
		211,
		208,
		216,
		211,
		202,
		187,
		193,
		180,
		179,
		197,
		201,
		210,
		217,
		207,
		220,
		224,
		-1,
		170,
		213,
		207,
		210,
		234,
		248,
		-1,
		195,
		-1,
		-1,
		180,
		198,
		206,
		202,
		206,
		259,
		225,
		220,
		210,
		208,
		199,
		190,
		197,
		188,
		188,
		191,
		206,
		211,
		203,
		217,
		217,
		218,
		-1,
		205,
		193,
		201,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		196,
		-1,
		232,
		-1,
		225,
		229,
		233,
		236,
		224,
		211,
		203,
		195,
		211,
		186,
		196,
		192,
		193,
		202,
		213,
		225,
		224,
		225,
		279,
		234,
		201,
		192,
		239,
		254,
		258,
		-1,
		208,
		247,
		234,
		-1,
		205,
		-1,
		-1,
		-1,
		239,
		246,
		238,
		244,
		223,
		223,
		197,
		201,
		191,
		198,
		208,
		210,
		202,
		206,
		219,
		230,
		233,
		275,
		273,
		278,
		223,
		206,
		224,
		233,
		254,
		223,
		214,
		241,
		241,
		230,
		225,
		212,
		-1,
		-1,
		262,
		256,
		-1,
		-1,
		230,
		218,
		201,
		202,
		198,
		201,
		216,
		219,
		209,
		207,
		201,
		233,
		-1,
		275,
		274,
		263,
		260,
		236,
		227,
		214,
		225,
		-1,
		-1,
		226,
		242,
		255,
		259,
		272,
		297,
		-1,
		215,
		-1,
		-1,
		275,
		-1,
		-1,
		260,
		223,
		212,
		203,
		209,
		206,
		217,
		227,
		215,
		216,
		206,
		216,
		229,
		259,
		256,
		244,
		242,
		265,
		222,
		218,
		-1,
		241,
		229,
		235,
		242,
		259,
		286,
		-1,
		-1,
		231,
		222,
		-1,
		-1,
		258,
		256,
		245,
		-1,
		235,
		208,
		213,
		233,
		235,
		224,
		218,
		212,
		219,
		218,
		226,
		234,
		268,
		282,
		271,
		267,
		266,
		274,
		223,
		240,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		-1,
		266,
		241,
		-1,
		-1,
		253,
		246,
		234,
		222,
		212,
		222,
		226,
		230,
		222,
		215,
		210,
		221,
		213,
		217,
		234,
		-1,
		302,
		-1,
		254,
		247,
		262,
		277,
		285,
		-1,
		-1,
		-1,
		283,
		269,
		262,
		250,
		248,
		-1,
		287,
		271,
		252,
		-1,
		222,
		235,
		266,
		234,
		239,
		234,
		216,
		227,
		216,
		219,
		233,
		228,
		-1,
		-1,
		260,
		263,
		-1,
		-1,
		285,
		304,
		-1,
		274,
		263,
		248,
		240,
		-1,
		-1,
		259,
		255,
		-1,
		-1,
		223,
		248,
		237,
		245,
		240,
		220,
		226,
		229,
		218,
		222,
		234,
		-1,
		-1,
		267,
		268,
		273,
		-1,
		288,
		-1,
		298,
		-1,
		243,
		259,
		261,
		-1,
		-1,
		-1,
		261,
		224,
		245,
		255,
		249,
		247,
		238,
		224,
		231,
		229,
		225,
		236,
		-1,
		-1,
		-1,
		306,
		280,
		305,
		296,
		279,
		259,
		251,
		276,
		-1,
		248,
		-1,
		223,
		225,
		251,
		254,
		260,
		254,
		227,
		242,
		232,
		223,
		232,
		312,
		-1,
		282,
		315,
		279,
		265,
		249,
		253,
		269,
		-1,
		245,
		227,
		-1,
		255,
		245,
		276,
		261,
		242,
		229,
		236,
		236,
		229,
		-1,
		-1,
		-1,
		284,
		283,
		275,
		269,
		269,
		254,
		245,
		-1,
		257,
		239,
		218,
		235,
		235,
		226,
		234,
		266,
		262,
		249,
		249,
		241,
		-1,
		374,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		278,
		273,
		246,
		234,
		240,
		236,
		222,
		228,
		230,
		238,
		236,
		233,
		245,
		241,
		261,
		242,
		277,
		-1,
		380,
		-1,
		314,
		-1,
		-1,
		296,
		276,
		268,
		257,
		246,
		244,
		235,
		226,
		248,
		264,
		248,
		246,
		249,
		250,
		-1,
		369,
		368,
		-1,
		315,
		307,
		293,
		-1,
		286,
		-1,
		292,
		253,
		-1,
		255,
		235,
		-1,
		257,
		253,
		-1,
		-1,
		356,
		331,
		-1,
		-1,
		-1,
		316,
		296,
		287,
		271,
		-1,
		246,
		246,
		-1,
		-1,
		-1,
		341,
		340,
		-1,
		309,
		312,
		-1,
		302,
		293,
		301,
		248,
		252,
		-1,
		-1,
		-1,
		350,
		331,
		325,
		324,
		322,
		317,
		314,
		300,
		284,
		262,
		251,
		272,
		-1,
		-1,
		-1,
		322,
		314,
		307,
		-1,
		-1,
		309,
		292,
		273,
		271,
		-1,
		-1,
		-1,
		344,
		325,
		-1,
		-1,
		299,
		-1,
		-1,
		305,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		361,
		333,
		-1,
		-1,
		-1,
		295,
		291,
		292,
		-1,
		-1,
		-1,
		-1,
		355,
		356,
		379,
		343,
		-1,
		-1,
		-1,
		287,
		281,
		-1,
		-1,
		358,
		356,
		-1,
		-1,
		-1,
		315,
		299,
		-1,
		285,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		318,
		-1,
		-1,
		-1,
		320,
		-1,
		320,
		295,
		302,
		-1,
		-1,
		-1,
		-1,
		333,
		325,
		333,
		-1,
		305,
		307,
		-1,
		355,
		-1,
		-1,
		348,
		339,
		-1,
		-1,
		310,
		317,
		339,
		342,
		378,
		-1,
		329
	],
	[
		-1,
		197,
		186,
		197,
		205,
		178,
		185,
		-1,
		206,
		208,
		174,
		168,
		207,
		178,
		184,
		195,
		-1,
		-1,
		-1,
		197,
		196,
		166,
		164,
		173,
		178,
		185,
		-1,
		208,
		-1,
		218,
		197,
		208,
		213,
		159,
		156,
		176,
		195,
		201,
		193,
		233,
		189,
		160,
		154,
		172,
		177,
		195,
		187,
		-1,
		160,
		150,
		172,
		176,
		188,
		171,
		-1,
		-1,
		154,
		155,
		161,
		173,
		178,
		183,
		-1,
		209,
		193,
		-1,
		-1,
		144,
		157,
		153,
		156,
		164,
		180,
		201,
		193,
		188,
		-1,
		-1,
		145,
		149,
		162,
		163,
		161,
		188,
		201,
		183,
		197,
		196,
		-1,
		133,
		151,
		160,
		169,
		175,
		164,
		162,
		180,
		182,
		188,
		191,
		-1,
		125,
		127,
		156,
		162,
		174,
		180,
		167,
		167,
		177,
		170,
		189,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		130,
		156,
		155,
		151,
		169,
		177,
		170,
		167,
		165,
		162,
		178,
		179,
		189,
		-1,
		-1,
		178,
		147,
		182,
		139,
		124,
		-1,
		118,
		137,
		143,
		147,
		152,
		160,
		174,
		170,
		-1,
		156,
		155,
		186,
		172,
		183,
		138,
		-1,
		-1,
		136,
		128,
		113,
		116,
		113,
		113,
		143,
		142,
		147,
		149,
		151,
		157,
		160,
		160,
		166,
		150,
		160,
		164,
		175,
		190,
		-1,
		-1,
		245,
		-1,
		-1,
		135,
		118,
		-1,
		101,
		108,
		108,
		125,
		115,
		136,
		151,
		155,
		163,
		165,
		153,
		155,
		152,
		165,
		153,
		147,
		172,
		176,
		170,
		191,
		186,
		-1,
		244,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		94,
		97,
		103,
		127,
		137,
		-1,
		158,
		156,
		180,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		154,
		156,
		189,
		167,
		189,
		186,
		215,
		220,
		214,
		223,
		-1,
		143,
		139,
		135,
		142,
		91,
		-1,
		-1,
		131,
		-1,
		145,
		158,
		165,
		160,
		163,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		156,
		167,
		162,
		161,
		179,
		194,
		207,
		211,
		217,
		-1,
		193,
		-1,
		135,
		119,
		121,
		93,
		114,
		-1,
		151,
		146,
		166,
		167,
		158,
		-1,
		161,
		164,
		171,
		149,
		134,
		151,
		143,
		141,
		146,
		151,
		165,
		156,
		174,
		181,
		189,
		193,
		213,
		225,
		153,
		143,
		-1,
		125,
		130,
		89,
		97,
		116,
		189,
		164,
		-1,
		159,
		-1,
		151,
		176,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		150,
		147,
		144,
		162,
		165,
		182,
		186,
		202,
		-1,
		-1,
		138,
		142,
		131,
		82,
		101,
		125,
		162,
		157,
		146,
		145,
		-1,
		136,
		166,
		163,
		149,
		136,
		126,
		127,
		135,
		148,
		127,
		146,
		149,
		171,
		199,
		177,
		189,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		108,
		79,
		103,
		145,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		156,
		139,
		135,
		124,
		122,
		135,
		130,
		146,
		150,
		149,
		168,
		180,
		171,
		191,
		-1,
		-1,
		-1,
		138,
		127,
		128,
		77,
		100,
		134,
		154,
		140,
		145,
		120,
		113,
		107,
		159,
		156,
		123,
		131,
		123,
		112,
		126,
		134,
		138,
		147,
		156,
		162,
		186,
		186,
		192,
		-1,
		-1,
		145,
		135,
		119,
		121,
		118,
		91,
		98,
		130,
		145,
		142,
		-1,
		112,
		-1,
		101,
		109,
		108,
		114,
		126,
		112,
		117,
		128,
		140,
		153,
		149,
		156,
		191,
		191,
		176,
		196,
		199,
		-1,
		-1,
		-1,
		138,
		136,
		111,
		88,
		72,
		108,
		-1,
		112,
		113,
		-1,
		106,
		100,
		106,
		105,
		112,
		109,
		109,
		123,
		131,
		127,
		143,
		149,
		141,
		177,
		-1,
		184,
		178,
		186,
		176,
		164,
		-1,
		-1,
		-1,
		134,
		113,
		106,
		126,
		67,
		119,
		-1,
		-1,
		97,
		90,
		-1,
		93,
		93,
		100,
		109,
		114,
		119,
		127,
		122,
		135,
		140,
		146,
		151,
		169,
		173,
		177,
		166,
		162,
		159,
		173,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		87,
		-1,
		100,
		92,
		88,
		82,
		88,
		106,
		104,
		124,
		116,
		130,
		130,
		136,
		144,
		129,
		132,
		148,
		146,
		164,
		172,
		164,
		158,
		157,
		169,
		-1,
		154,
		140,
		111,
		-1,
		-1,
		100,
		-1,
		64,
		78,
		94,
		-1,
		122,
		101,
		124,
		102,
		116,
		112,
		150,
		151,
		129,
		134,
		142,
		152,
		154,
		143,
		154,
		146,
		168,
		168,
		152,
		153,
		162,
		-1,
		160,
		147,
		105,
		101,
		90,
		107,
		61,
		70,
		81,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		126,
		124,
		140,
		131,
		137,
		153,
		156,
		158,
		148,
		137,
		143,
		140,
		162,
		148,
		146,
		165,
		181,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		75,
		60,
		57,
		-1,
		98,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		148,
		132,
		137,
		-1,
		183,
		-1,
		156,
		158,
		152,
		137,
		134,
		145,
		143,
		154,
		171,
		-1,
		109,
		94,
		87,
		77,
		89,
		54,
		-1,
		97,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		164,
		144,
		138,
		137,
		178,
		178,
		164,
		150,
		143,
		140,
		137,
		150,
		170,
		161,
		173,
		-1,
		-1,
		-1,
		114,
		0,
		8,
		51,
		63,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		181,
		169,
		159,
		149,
		183,
		184,
		169,
		162,
		148,
		150,
		148,
		146,
		151,
		172,
		173,
		186,
		-1,
		-1,
		4,
		10,
		19,
		56,
		75,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		170,
		-1,
		-1,
		161,
		159,
		169,
		165,
		152,
		172,
		175,
		161,
		145,
		160,
		172,
		180,
		185,
		-1,
		39,
		26,
		-1,
		-1,
		78,
		72,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		151,
		172,
		197,
		164,
		-1,
		169,
		170,
		156,
		170,
		177,
		163,
		158,
		152,
		155,
		173,
		190,
		-1,
		-1,
		92,
		-1,
		87,
		-1,
		-1,
		-1,
		-1,
		130,
		144,
		165,
		171,
		183,
		-1,
		178,
		172,
		158,
		175,
		176,
		173,
		164,
		156,
		161,
		158,
		171,
		185,
		189,
		115,
		-1,
		98,
		-1,
		-1,
		-1,
		148,
		163,
		225,
		202,
		175,
		179,
		172,
		166,
		166,
		182,
		184,
		195,
		163,
		159,
		160,
		164,
		163,
		180,
		190,
		-1,
		-1,
		98,
		115,
		150,
		156,
		160,
		252,
		-1,
		-1,
		188,
		179,
		170,
		173,
		176,
		179,
		169,
		166,
		171,
		176,
		164,
		173,
		191,
		195,
		-1,
		-1,
		-1,
		118,
		-1,
		133,
		-1,
		-1,
		175,
		259,
		206,
		188,
		184,
		182,
		175,
		184,
		179,
		174,
		184,
		193,
		185,
		166,
		177,
		200,
		189,
		227,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		147,
		122,
		137,
		183,
		188,
		179,
		221,
		218,
		-1,
		188,
		213,
		185,
		192,
		184,
		192,
		192,
		189,
		167,
		174,
		190,
		189,
		184,
		219,
		211,
		217,
		-1,
		-1,
		219,
		208,
		197,
		203,
		-1,
		153,
		139,
		169,
		159,
		165,
		-1,
		-1,
		212,
		209,
		210,
		194,
		198,
		191,
		186,
		196,
		176,
		163,
		167,
		171,
		177,
		182,
		187,
		193,
		208,
		223,
		-1,
		114,
		195,
		188,
		171,
		179,
		210,
		-1,
		156,
		165,
		146,
		151,
		159,
		-1,
		-1,
		185,
		181,
		186,
		195,
		198,
		206,
		201,
		192,
		177,
		183,
		170,
		169,
		187,
		191,
		200,
		207,
		197,
		210,
		214,
		-1,
		128,
		171,
		165,
		168,
		192,
		206,
		-1,
		169,
		-1,
		-1,
		154,
		172,
		180,
		176,
		180,
		233,
		209,
		204,
		200,
		198,
		189,
		180,
		187,
		178,
		178,
		181,
		196,
		201,
		193,
		207,
		207,
		208,
		-1,
		163,
		151,
		159,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		170,
		-1,
		206,
		-1,
		199,
		203,
		217,
		220,
		214,
		201,
		193,
		185,
		201,
		176,
		186,
		182,
		183,
		192,
		203,
		215,
		214,
		215,
		237,
		192,
		159,
		150,
		197,
		212,
		216,
		-1,
		182,
		221,
		208,
		-1,
		179,
		-1,
		-1,
		-1,
		213,
		230,
		222,
		234,
		213,
		213,
		187,
		191,
		181,
		188,
		198,
		200,
		192,
		196,
		209,
		220,
		223,
		233,
		231,
		236,
		181,
		164,
		182,
		191,
		212,
		197,
		188,
		215,
		215,
		204,
		199,
		186,
		-1,
		-1,
		236,
		240,
		-1,
		-1,
		220,
		208,
		191,
		192,
		188,
		191,
		206,
		209,
		199,
		197,
		191,
		223,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		172,
		183,
		-1,
		-1,
		200,
		216,
		229,
		233,
		246,
		271,
		-1,
		189,
		-1,
		-1,
		257,
		-1,
		-1,
		250,
		213,
		202,
		193,
		199,
		196,
		207,
		217,
		205,
		206,
		196,
		206,
		219,
		217,
		214,
		202,
		200,
		223,
		180,
		176,
		-1,
		208,
		203,
		209,
		216,
		233,
		260,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		248,
		246,
		235,
		-1,
		225,
		198,
		203,
		223,
		225,
		214,
		208,
		202,
		209,
		208,
		216,
		224,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		198,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		215,
		-1,
		-1,
		243,
		236,
		224,
		212,
		202,
		212,
		216,
		220,
		212,
		205,
		200,
		211,
		203,
		207,
		224,
		-1,
		260,
		-1,
		212,
		205,
		220,
		235,
		243,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		277,
		261,
		242,
		-1,
		212,
		225,
		256,
		224,
		229,
		224,
		206,
		217,
		206,
		209,
		223,
		218,
		-1,
		-1,
		218,
		221,
		-1,
		-1,
		243,
		262,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		249,
		245,
		-1,
		-1,
		213,
		238,
		227,
		235,
		230,
		210,
		216,
		219,
		208,
		212,
		224,
		-1,
		-1,
		225,
		226,
		231,
		-1,
		252,
		-1,
		272,
		-1,
		217,
		233,
		235,
		-1,
		-1,
		-1,
		251,
		214,
		235,
		245,
		239,
		237,
		228,
		214,
		221,
		219,
		215,
		226,
		-1,
		-1,
		-1,
		282,
		259,
		279,
		270,
		253,
		233,
		225,
		250,
		-1,
		238,
		-1,
		213,
		215,
		241,
		244,
		250,
		244,
		217,
		232,
		222,
		213,
		222,
		288,
		-1,
		263,
		305,
		269,
		239,
		239,
		238,
		259,
		-1,
		235,
		217,
		-1,
		245,
		235,
		266,
		251,
		232,
		219,
		226,
		226,
		219,
		-1,
		-1,
		-1,
		274,
		273,
		265,
		259,
		259,
		244,
		235,
		-1,
		247,
		229,
		208,
		225,
		225,
		216,
		224,
		256,
		252,
		239,
		239,
		231,
		-1,
		332,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		268,
		263,
		236,
		224,
		230,
		226,
		212,
		218,
		220,
		228,
		226,
		223,
		235,
		231,
		251,
		232,
		267,
		-1,
		339,
		-1,
		304,
		-1,
		-1,
		286,
		266,
		258,
		247,
		236,
		234,
		225,
		216,
		238,
		254,
		238,
		236,
		239,
		240,
		-1,
		349,
		350,
		-1,
		305,
		297,
		283,
		-1,
		276,
		-1,
		282,
		243,
		-1,
		245,
		225,
		-1,
		247,
		243,
		-1,
		-1,
		346,
		321,
		-1,
		-1,
		-1,
		306,
		286,
		277,
		261,
		-1,
		236,
		236,
		-1,
		-1,
		-1,
		331,
		330,
		-1,
		299,
		302,
		-1,
		292,
		283,
		291,
		238,
		242,
		-1,
		-1,
		-1,
		340,
		321,
		315,
		314,
		312,
		307,
		304,
		290,
		274,
		252,
		241,
		262,
		-1,
		-1,
		-1,
		312,
		304,
		297,
		-1,
		-1,
		299,
		282,
		263,
		261,
		-1,
		-1,
		-1,
		334,
		315,
		-1,
		-1,
		289,
		-1,
		-1,
		295,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		351,
		323,
		-1,
		-1,
		-1,
		285,
		281,
		282,
		-1,
		-1,
		-1,
		-1,
		345,
		346,
		369,
		333,
		-1,
		-1,
		-1,
		277,
		271,
		-1,
		-1,
		348,
		346,
		-1,
		-1,
		-1,
		305,
		289,
		-1,
		275,
		-1,
		-1,
		-1,
		296,
		-1,
		-1,
		308,
		-1,
		-1,
		-1,
		310,
		-1,
		310,
		285,
		292,
		-1,
		-1,
		-1,
		-1,
		323,
		315,
		323,
		-1,
		295,
		297,
		-1,
		345,
		-1,
		-1,
		338,
		329,
		-1,
		-1,
		300,
		307,
		329,
		332,
		368,
		-1,
		319
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		203,
		205,
		171,
		165,
		204,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		194,
		193,
		163,
		161,
		170,
		175,
		182,
		-1,
		205,
		-1,
		215,
		194,
		205,
		210,
		156,
		153,
		173,
		192,
		198,
		190,
		230,
		186,
		157,
		151,
		169,
		174,
		192,
		184,
		-1,
		157,
		147,
		169,
		173,
		185,
		168,
		-1,
		-1,
		151,
		152,
		158,
		170,
		175,
		180,
		-1,
		203,
		187,
		-1,
		-1,
		141,
		154,
		150,
		153,
		161,
		177,
		195,
		187,
		182,
		-1,
		-1,
		142,
		146,
		159,
		160,
		158,
		182,
		195,
		177,
		191,
		190,
		-1,
		130,
		148,
		157,
		166,
		172,
		158,
		156,
		174,
		176,
		182,
		185,
		-1,
		122,
		124,
		153,
		159,
		171,
		174,
		161,
		161,
		171,
		164,
		183,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		119,
		127,
		153,
		152,
		148,
		166,
		171,
		164,
		161,
		159,
		156,
		172,
		173,
		183,
		-1,
		-1,
		175,
		144,
		179,
		136,
		121,
		-1,
		115,
		134,
		140,
		144,
		149,
		154,
		168,
		164,
		-1,
		150,
		149,
		180,
		166,
		177,
		135,
		-1,
		-1,
		133,
		125,
		110,
		113,
		110,
		110,
		140,
		139,
		144,
		146,
		145,
		151,
		154,
		154,
		160,
		144,
		154,
		158,
		169,
		184,
		-1,
		-1,
		239,
		-1,
		-1,
		132,
		115,
		-1,
		98,
		105,
		105,
		122,
		112,
		133,
		148,
		152,
		160,
		159,
		147,
		149,
		146,
		159,
		147,
		141,
		166,
		170,
		164,
		185,
		180,
		-1,
		238,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		91,
		94,
		100,
		124,
		134,
		-1,
		155,
		153,
		177,
		168,
		165,
		152,
		140,
		153,
		138,
		145,
		144,
		148,
		150,
		183,
		161,
		183,
		180,
		209,
		214,
		208,
		217,
		-1,
		140,
		136,
		132,
		139,
		88,
		-1,
		-1,
		128,
		-1,
		142,
		155,
		159,
		157,
		160,
		169,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		150,
		161,
		156,
		155,
		173,
		188,
		201,
		205,
		211,
		-1,
		190,
		-1,
		132,
		116,
		118,
		90,
		111,
		-1,
		148,
		143,
		163,
		161,
		152,
		-1,
		155,
		158,
		165,
		143,
		128,
		145,
		137,
		135,
		140,
		145,
		159,
		150,
		168,
		175,
		183,
		187,
		207,
		219,
		150,
		140,
		-1,
		122,
		127,
		86,
		94,
		113,
		186,
		158,
		-1,
		153,
		-1,
		145,
		170,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		144,
		141,
		138,
		156,
		159,
		176,
		180,
		196,
		-1,
		-1,
		135,
		139,
		128,
		79,
		98,
		122,
		159,
		151,
		140,
		139,
		-1,
		130,
		160,
		157,
		143,
		130,
		120,
		121,
		129,
		142,
		121,
		140,
		143,
		165,
		193,
		171,
		183,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		105,
		76,
		100,
		142,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		150,
		133,
		129,
		118,
		116,
		129,
		124,
		140,
		144,
		143,
		162,
		174,
		165,
		185,
		-1,
		-1,
		-1,
		135,
		124,
		125,
		71,
		94,
		131,
		148,
		134,
		139,
		114,
		107,
		101,
		153,
		150,
		117,
		125,
		117,
		106,
		120,
		128,
		132,
		141,
		150,
		156,
		180,
		180,
		186,
		-1,
		-1,
		142,
		132,
		116,
		118,
		115,
		85,
		92,
		124,
		139,
		136,
		-1,
		106,
		-1,
		95,
		103,
		102,
		108,
		120,
		106,
		111,
		122,
		134,
		147,
		143,
		150,
		185,
		185,
		170,
		190,
		193,
		-1,
		-1,
		-1,
		135,
		130,
		105,
		82,
		66,
		102,
		-1,
		106,
		107,
		-1,
		100,
		94,
		100,
		99,
		106,
		103,
		103,
		117,
		125,
		121,
		137,
		143,
		135,
		171,
		-1,
		178,
		172,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		128,
		107,
		100,
		120,
		61,
		113,
		-1,
		-1,
		91,
		84,
		-1,
		87,
		87,
		94,
		103,
		108,
		113,
		121,
		116,
		129,
		134,
		140,
		145,
		163,
		167,
		171,
		160,
		156,
		153,
		167,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		61,
		81,
		-1,
		97,
		89,
		82,
		76,
		82,
		100,
		98,
		118,
		110,
		124,
		124,
		130,
		138,
		123,
		126,
		142,
		140,
		158,
		166,
		158,
		152,
		151,
		163,
		-1,
		148,
		134,
		105,
		-1,
		-1,
		94,
		-1,
		58,
		75,
		91,
		-1,
		116,
		95,
		118,
		96,
		110,
		106,
		144,
		145,
		123,
		128,
		136,
		146,
		148,
		137,
		148,
		140,
		162,
		162,
		146,
		147,
		156,
		-1,
		154,
		141,
		99,
		94,
		83,
		99,
		55,
		64,
		78,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		120,
		118,
		134,
		125,
		131,
		147,
		150,
		152,
		142,
		131,
		137,
		134,
		156,
		142,
		140,
		159,
		175,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		67,
		52,
		51,
		-1,
		95,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		142,
		126,
		131,
		-1,
		177,
		-1,
		150,
		152,
		146,
		131,
		128,
		139,
		137,
		148,
		165,
		-1,
		101,
		86,
		79,
		69,
		81,
		46,
		-1,
		89,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		158,
		138,
		132,
		131,
		172,
		172,
		158,
		144,
		137,
		134,
		131,
		144,
		164,
		155,
		167,
		-1,
		-1,
		-1,
		106,
		6,
		0,
		48,
		55,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		175,
		163,
		153,
		143,
		177,
		178,
		163,
		156,
		142,
		144,
		142,
		140,
		145,
		166,
		167,
		180,
		-1,
		-1,
		10,
		2,
		11,
		48,
		67,
		-1,
		-1,
		-1,
		134,
		150,
		142,
		113,
		164,
		-1,
		-1,
		155,
		153,
		163,
		159,
		146,
		166,
		169,
		155,
		139,
		154,
		166,
		174,
		179,
		-1,
		45,
		32,
		-1,
		-1,
		70,
		64,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		145,
		166,
		191,
		158,
		-1,
		163,
		164,
		150,
		164,
		171,
		157,
		152,
		146,
		149,
		167,
		184,
		-1,
		-1,
		84,
		-1,
		79,
		-1,
		-1,
		-1,
		-1,
		124,
		138,
		159,
		165,
		177,
		-1,
		172,
		166,
		152,
		169,
		170,
		167,
		158,
		150,
		155,
		152,
		165,
		179,
		183,
		107,
		-1,
		90,
		-1,
		-1,
		-1,
		142,
		157,
		219,
		196,
		169,
		173,
		166,
		160,
		160,
		176,
		178,
		189,
		157,
		153,
		154,
		158,
		157,
		174,
		184,
		-1,
		-1,
		90,
		107,
		142,
		150,
		154,
		246,
		-1,
		-1,
		182,
		173,
		164,
		167,
		170,
		173,
		163,
		160,
		165,
		170,
		158,
		167,
		185,
		189,
		-1,
		-1,
		-1,
		110,
		-1,
		125,
		-1,
		-1,
		169,
		253,
		200,
		182,
		178,
		176,
		169,
		178,
		173,
		168,
		178,
		187,
		179,
		160,
		171,
		194,
		183,
		221,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		139,
		114,
		129,
		175,
		180,
		171,
		215,
		212,
		-1,
		182,
		207,
		179,
		186,
		178,
		186,
		186,
		183,
		161,
		168,
		184,
		183,
		178,
		213,
		205,
		211,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		145,
		131,
		161,
		151,
		157,
		-1,
		-1,
		204,
		201,
		204,
		188,
		192,
		185,
		180,
		190,
		170,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		120,
		201,
		194,
		177,
		185,
		216,
		-1,
		148,
		157,
		138,
		143,
		151,
		-1,
		-1,
		177,
		173,
		178,
		187,
		190,
		200,
		195,
		186,
		171,
		177,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		134,
		177,
		171,
		174,
		198,
		212,
		-1,
		161,
		-1,
		-1,
		146,
		164,
		172,
		168,
		172,
		225,
		201,
		196,
		194,
		192,
		183,
		174,
		181,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		169,
		157,
		165,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		162,
		-1,
		198,
		-1,
		191,
		195,
		209,
		212,
		208,
		195,
		187,
		179,
		195,
		170,
		180,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		243,
		198,
		165,
		156,
		203,
		218,
		222,
		-1,
		174,
		213,
		200,
		-1,
		171,
		-1,
		-1,
		-1,
		205,
		222,
		214,
		228,
		207,
		207,
		181,
		185,
		175,
		182,
		192,
		194,
		186,
		190,
		203,
		214,
		217,
		239,
		237,
		242,
		187,
		170,
		188,
		197,
		218,
		189,
		180,
		207,
		207,
		196,
		191,
		178,
		-1,
		-1,
		228,
		232,
		-1,
		-1,
		214,
		202,
		185,
		186,
		182,
		185,
		200,
		203,
		193,
		191,
		185,
		217,
		-1,
		239,
		238,
		227,
		224,
		200,
		191,
		178,
		189,
		-1,
		-1,
		192,
		208,
		221,
		225,
		238,
		263,
		-1,
		181,
		-1,
		-1,
		249,
		-1,
		-1,
		244,
		207,
		196,
		187,
		193,
		190,
		201,
		211,
		199,
		200,
		190,
		200,
		213,
		223,
		220,
		208,
		206,
		229,
		186,
		182,
		-1,
		207,
		195,
		201,
		208,
		225,
		252,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		242,
		240,
		229,
		-1,
		219,
		192,
		197,
		217,
		219,
		208,
		202,
		196,
		203,
		202,
		210,
		218,
		232,
		246,
		235,
		231,
		230,
		238,
		187,
		204,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		232,
		207,
		-1,
		-1,
		237,
		230,
		218,
		206,
		196,
		206,
		210,
		214,
		206,
		199,
		194,
		205,
		197,
		201,
		218,
		-1,
		266,
		-1,
		218,
		211,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		249,
		235,
		228,
		216,
		214,
		-1,
		271,
		255,
		236,
		-1,
		206,
		219,
		250,
		218,
		223,
		218,
		200,
		211,
		200,
		203,
		217,
		212,
		-1,
		-1,
		224,
		227,
		-1,
		-1,
		249,
		268,
		-1,
		240,
		229,
		214,
		206,
		-1,
		-1,
		243,
		239,
		-1,
		-1,
		207,
		232,
		221,
		229,
		224,
		204,
		210,
		213,
		202,
		206,
		218,
		-1,
		-1,
		231,
		232,
		237,
		-1,
		258,
		-1,
		264,
		-1,
		209,
		225,
		227,
		-1,
		-1,
		-1,
		245,
		208,
		229,
		239,
		233,
		231,
		222,
		208,
		215,
		213,
		209,
		220,
		-1,
		-1,
		-1,
		288,
		264,
		271,
		262,
		245,
		225,
		217,
		242,
		-1,
		232,
		-1,
		207,
		209,
		235,
		238,
		244,
		238,
		211,
		226,
		216,
		207,
		216,
		294,
		-1,
		266,
		299,
		263,
		231,
		231,
		230,
		253,
		-1,
		229,
		211,
		-1,
		239,
		229,
		260,
		245,
		226,
		213,
		220,
		220,
		213,
		-1,
		-1,
		-1,
		268,
		267,
		259,
		253,
		251,
		236,
		229,
		-1,
		241,
		223,
		202,
		219,
		219,
		210,
		218,
		250,
		246,
		233,
		233,
		225,
		-1,
		338,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		262,
		257,
		230,
		218,
		224,
		220,
		206,
		212,
		214,
		222,
		220,
		217,
		229,
		225,
		245,
		226,
		261,
		-1,
		345,
		-1,
		298,
		-1,
		-1,
		278,
		260,
		252,
		241,
		230,
		228,
		219,
		210,
		232,
		248,
		232,
		230,
		233,
		234,
		-1,
		353,
		352,
		-1,
		297,
		289,
		275,
		-1,
		268,
		-1,
		276,
		237,
		-1,
		239,
		219,
		-1,
		241,
		237,
		-1,
		-1,
		340,
		313,
		-1,
		-1,
		-1,
		298,
		278,
		271,
		255,
		-1,
		230,
		230,
		-1,
		-1,
		-1,
		325,
		322,
		-1,
		291,
		294,
		-1,
		285,
		277,
		285,
		232,
		236,
		-1,
		-1,
		-1,
		334,
		315,
		309,
		306,
		306,
		299,
		298,
		284,
		268,
		246,
		235,
		256,
		-1,
		-1,
		-1,
		306,
		298,
		291,
		-1,
		-1,
		293,
		276,
		257,
		255,
		-1,
		-1,
		-1,
		328,
		309,
		-1,
		-1,
		283,
		-1,
		-1,
		289,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		345,
		317,
		-1,
		-1,
		-1,
		279,
		275,
		276,
		-1,
		-1,
		-1,
		-1,
		339,
		340,
		363,
		327,
		-1,
		-1,
		-1,
		271,
		265,
		-1,
		-1,
		342,
		340,
		-1,
		-1,
		-1,
		299,
		283,
		-1,
		269,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		304,
		-1,
		304,
		279,
		286,
		-1,
		-1,
		-1,
		-1,
		317,
		309,
		317,
		-1,
		289,
		291,
		-1,
		339,
		-1,
		-1,
		332,
		323,
		-1,
		-1,
		294,
		301,
		323,
		326,
		362,
		-1,
		313
	],
	[
		-1,
		146,
		135,
		146,
		154,
		127,
		134,
		-1,
		155,
		157,
		123,
		117,
		156,
		127,
		133,
		144,
		-1,
		-1,
		-1,
		146,
		145,
		115,
		113,
		122,
		127,
		134,
		-1,
		157,
		-1,
		167,
		146,
		157,
		162,
		108,
		105,
		125,
		144,
		150,
		142,
		182,
		138,
		109,
		103,
		121,
		126,
		144,
		136,
		-1,
		109,
		99,
		121,
		125,
		137,
		120,
		-1,
		-1,
		103,
		104,
		110,
		122,
		127,
		132,
		-1,
		158,
		142,
		-1,
		-1,
		93,
		106,
		102,
		105,
		113,
		129,
		150,
		142,
		137,
		-1,
		-1,
		94,
		98,
		111,
		112,
		110,
		137,
		150,
		132,
		146,
		145,
		-1,
		82,
		100,
		109,
		118,
		124,
		113,
		111,
		129,
		131,
		137,
		140,
		-1,
		74,
		76,
		105,
		111,
		123,
		129,
		116,
		116,
		126,
		119,
		138,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		71,
		79,
		105,
		104,
		100,
		118,
		126,
		119,
		116,
		114,
		111,
		127,
		128,
		138,
		-1,
		-1,
		127,
		96,
		131,
		88,
		73,
		-1,
		67,
		86,
		92,
		96,
		101,
		109,
		123,
		119,
		-1,
		105,
		104,
		135,
		121,
		132,
		87,
		-1,
		-1,
		85,
		77,
		62,
		65,
		62,
		62,
		92,
		91,
		96,
		98,
		100,
		106,
		109,
		109,
		115,
		99,
		109,
		113,
		124,
		139,
		-1,
		-1,
		194,
		-1,
		-1,
		84,
		67,
		-1,
		50,
		57,
		57,
		74,
		64,
		85,
		100,
		104,
		112,
		114,
		102,
		104,
		101,
		114,
		102,
		96,
		121,
		125,
		119,
		140,
		135,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		43,
		46,
		52,
		76,
		86,
		-1,
		107,
		105,
		129,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		103,
		105,
		138,
		116,
		138,
		135,
		164,
		169,
		163,
		172,
		-1,
		92,
		88,
		84,
		91,
		40,
		-1,
		-1,
		80,
		-1,
		94,
		107,
		114,
		109,
		112,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		105,
		116,
		111,
		110,
		128,
		143,
		156,
		160,
		166,
		-1,
		142,
		-1,
		84,
		68,
		70,
		42,
		63,
		-1,
		100,
		95,
		115,
		116,
		107,
		-1,
		110,
		113,
		120,
		98,
		83,
		100,
		92,
		90,
		95,
		100,
		114,
		105,
		123,
		130,
		138,
		142,
		162,
		174,
		102,
		92,
		-1,
		74,
		79,
		38,
		46,
		65,
		138,
		113,
		-1,
		108,
		-1,
		100,
		125,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		99,
		96,
		93,
		111,
		114,
		131,
		135,
		151,
		-1,
		-1,
		87,
		91,
		80,
		31,
		50,
		74,
		111,
		106,
		95,
		94,
		-1,
		85,
		115,
		112,
		98,
		85,
		75,
		76,
		84,
		97,
		76,
		95,
		98,
		120,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		57,
		28,
		52,
		94,
		124,
		117,
		105,
		70,
		70,
		64,
		-1,
		105,
		88,
		84,
		73,
		71,
		84,
		79,
		95,
		99,
		98,
		117,
		129,
		120,
		140,
		-1,
		-1,
		-1,
		87,
		76,
		77,
		26,
		49,
		83,
		103,
		89,
		94,
		69,
		62,
		56,
		108,
		105,
		72,
		80,
		72,
		61,
		75,
		83,
		87,
		96,
		105,
		111,
		135,
		135,
		141,
		-1,
		-1,
		94,
		84,
		68,
		70,
		67,
		40,
		47,
		79,
		94,
		91,
		-1,
		61,
		-1,
		50,
		58,
		57,
		63,
		75,
		61,
		66,
		77,
		89,
		102,
		98,
		105,
		140,
		140,
		125,
		145,
		148,
		-1,
		-1,
		-1,
		87,
		85,
		60,
		37,
		21,
		57,
		-1,
		61,
		62,
		-1,
		55,
		49,
		55,
		54,
		61,
		58,
		58,
		72,
		80,
		76,
		92,
		98,
		90,
		126,
		-1,
		133,
		127,
		135,
		125,
		113,
		-1,
		-1,
		-1,
		83,
		62,
		55,
		75,
		16,
		68,
		-1,
		-1,
		46,
		39,
		-1,
		42,
		42,
		49,
		58,
		63,
		68,
		76,
		71,
		84,
		89,
		95,
		100,
		118,
		122,
		126,
		115,
		111,
		108,
		122,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		16,
		36,
		-1,
		49,
		41,
		37,
		31,
		37,
		55,
		53,
		73,
		65,
		79,
		79,
		85,
		93,
		78,
		81,
		97,
		95,
		113,
		121,
		113,
		107,
		106,
		118,
		-1,
		103,
		89,
		60,
		-1,
		-1,
		49,
		-1,
		13,
		27,
		43,
		-1,
		71,
		50,
		73,
		51,
		65,
		61,
		99,
		100,
		78,
		83,
		91,
		101,
		103,
		92,
		103,
		95,
		117,
		117,
		101,
		102,
		111,
		-1,
		109,
		96,
		54,
		50,
		39,
		59,
		10,
		19,
		30,
		-1,
		-1,
		115,
		-1,
		49,
		66,
		75,
		73,
		89,
		80,
		86,
		102,
		105,
		107,
		97,
		86,
		92,
		89,
		111,
		97,
		95,
		114,
		130,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		25,
		12,
		6,
		-1,
		47,
		-1,
		93,
		83,
		67,
		52,
		85,
		-1,
		97,
		81,
		86,
		-1,
		132,
		-1,
		105,
		107,
		101,
		86,
		83,
		94,
		92,
		103,
		120,
		-1,
		59,
		44,
		37,
		27,
		41,
		12,
		-1,
		55,
		-1,
		-1,
		80,
		74,
		74,
		58,
		61,
		113,
		93,
		87,
		86,
		127,
		127,
		113,
		99,
		92,
		89,
		86,
		99,
		119,
		110,
		122,
		-1,
		-1,
		-1,
		64,
		36,
		42,
		0,
		21,
		-1,
		-1,
		142,
		97,
		83,
		-1,
		67,
		130,
		118,
		108,
		98,
		132,
		133,
		118,
		111,
		97,
		99,
		97,
		95,
		100,
		121,
		122,
		135,
		-1,
		-1,
		33,
		40,
		28,
		14,
		33,
		-1,
		-1,
		-1,
		89,
		105,
		97,
		68,
		119,
		-1,
		-1,
		110,
		108,
		118,
		114,
		101,
		121,
		124,
		110,
		94,
		109,
		121,
		129,
		134,
		-1,
		36,
		23,
		-1,
		-1,
		36,
		30,
		-1,
		-1,
		-1,
		-1,
		122,
		88,
		100,
		121,
		146,
		113,
		-1,
		118,
		119,
		105,
		119,
		126,
		112,
		107,
		101,
		104,
		122,
		139,
		-1,
		-1,
		50,
		-1,
		45,
		-1,
		-1,
		-1,
		-1,
		79,
		93,
		114,
		120,
		132,
		-1,
		127,
		121,
		107,
		124,
		125,
		122,
		113,
		105,
		110,
		107,
		120,
		134,
		138,
		73,
		-1,
		56,
		-1,
		-1,
		-1,
		97,
		112,
		174,
		151,
		124,
		128,
		121,
		115,
		115,
		131,
		133,
		144,
		112,
		108,
		109,
		113,
		112,
		129,
		139,
		-1,
		-1,
		56,
		73,
		108,
		105,
		109,
		201,
		-1,
		-1,
		137,
		128,
		119,
		122,
		125,
		128,
		118,
		115,
		120,
		125,
		113,
		122,
		140,
		144,
		-1,
		-1,
		-1,
		76,
		-1,
		91,
		-1,
		-1,
		124,
		208,
		155,
		137,
		133,
		131,
		124,
		133,
		128,
		123,
		133,
		142,
		134,
		115,
		126,
		149,
		138,
		176,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		105,
		80,
		95,
		141,
		144,
		137,
		170,
		167,
		-1,
		137,
		162,
		134,
		141,
		133,
		141,
		141,
		138,
		116,
		123,
		139,
		138,
		133,
		168,
		160,
		166,
		-1,
		-1,
		186,
		175,
		164,
		170,
		-1,
		111,
		97,
		127,
		117,
		123,
		-1,
		-1,
		170,
		167,
		159,
		143,
		147,
		140,
		135,
		145,
		125,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		81,
		162,
		155,
		138,
		146,
		177,
		-1,
		114,
		123,
		104,
		109,
		117,
		-1,
		-1,
		143,
		139,
		144,
		150,
		147,
		155,
		150,
		141,
		126,
		132,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		95,
		138,
		132,
		135,
		159,
		173,
		-1,
		127,
		-1,
		-1,
		112,
		130,
		138,
		134,
		138,
		191,
		164,
		159,
		149,
		147,
		138,
		129,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		130,
		118,
		126,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		128,
		-1,
		164,
		-1,
		157,
		161,
		172,
		175,
		163,
		150,
		142,
		134,
		150,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		204,
		159,
		126,
		117,
		164,
		179,
		183,
		-1,
		140,
		179,
		166,
		-1,
		137,
		-1,
		-1,
		-1,
		171,
		185,
		177,
		183,
		162,
		162,
		136,
		140,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		200,
		198,
		203,
		148,
		131,
		149,
		158,
		179,
		155,
		146,
		173,
		173,
		162,
		157,
		144,
		-1,
		-1,
		194,
		195,
		-1,
		-1,
		169,
		157,
		140,
		141,
		137,
		140,
		155,
		158,
		148,
		146,
		140,
		172,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		139,
		150,
		-1,
		-1,
		158,
		174,
		187,
		191,
		204,
		229,
		-1,
		147,
		-1,
		-1,
		214,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		145,
		156,
		166,
		154,
		155,
		145,
		155,
		168,
		184,
		181,
		169,
		167,
		190,
		147,
		143,
		-1,
		173,
		161,
		167,
		174,
		191,
		218,
		-1,
		-1,
		163,
		154,
		-1,
		-1,
		197,
		195,
		184,
		-1,
		174,
		147,
		152,
		172,
		174,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		173,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		165,
		169,
		161,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		227,
		-1,
		179,
		172,
		187,
		202,
		210,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		185,
		188,
		-1,
		-1,
		210,
		229,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		192,
		193,
		198,
		-1,
		219,
		-1,
		230,
		-1,
		175,
		191,
		193,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		188,
		186,
		177,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		245,
		219,
		237,
		228,
		211,
		191,
		183,
		208,
		-1,
		187,
		-1,
		162,
		164,
		190,
		193,
		199,
		193,
		166,
		181,
		171,
		162,
		171,
		251,
		-1,
		221,
		254,
		218,
		197,
		188,
		192,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		215,
		200,
		181,
		168,
		175,
		175,
		168,
		-1,
		-1,
		-1,
		223,
		222,
		214,
		208,
		208,
		193,
		184,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		205,
		201,
		188,
		188,
		180,
		-1,
		299,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		217,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		181,
		216,
		-1,
		306,
		-1,
		253,
		-1,
		-1,
		235,
		215,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		188,
		189,
		-1,
		308,
		307,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		279,
		-1,
		248,
		251,
		-1,
		241,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		263,
		261,
		256,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		182,
		184,
		150,
		144,
		183,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		173,
		172,
		142,
		140,
		149,
		154,
		161,
		-1,
		184,
		-1,
		194,
		173,
		184,
		189,
		135,
		132,
		152,
		171,
		177,
		169,
		209,
		165,
		136,
		130,
		148,
		153,
		171,
		163,
		-1,
		136,
		126,
		148,
		152,
		164,
		147,
		-1,
		-1,
		130,
		131,
		137,
		149,
		154,
		159,
		-1,
		182,
		166,
		-1,
		-1,
		120,
		133,
		129,
		132,
		140,
		156,
		174,
		166,
		161,
		-1,
		-1,
		121,
		125,
		138,
		139,
		137,
		161,
		174,
		156,
		170,
		169,
		-1,
		109,
		127,
		136,
		145,
		151,
		137,
		135,
		153,
		155,
		161,
		164,
		-1,
		101,
		103,
		132,
		138,
		150,
		153,
		140,
		140,
		150,
		143,
		162,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		98,
		106,
		132,
		131,
		127,
		145,
		150,
		143,
		140,
		138,
		135,
		151,
		152,
		162,
		-1,
		-1,
		154,
		123,
		158,
		115,
		100,
		-1,
		94,
		113,
		119,
		123,
		128,
		133,
		147,
		143,
		-1,
		129,
		128,
		159,
		145,
		156,
		114,
		-1,
		-1,
		112,
		104,
		89,
		92,
		89,
		89,
		119,
		118,
		123,
		125,
		124,
		130,
		133,
		133,
		139,
		123,
		133,
		137,
		148,
		163,
		-1,
		-1,
		218,
		-1,
		-1,
		111,
		94,
		-1,
		77,
		84,
		84,
		101,
		91,
		112,
		127,
		131,
		139,
		138,
		126,
		128,
		125,
		138,
		126,
		120,
		145,
		149,
		143,
		164,
		159,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		70,
		73,
		79,
		103,
		113,
		-1,
		134,
		132,
		156,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		127,
		129,
		162,
		140,
		162,
		159,
		188,
		193,
		187,
		196,
		-1,
		119,
		115,
		111,
		118,
		67,
		-1,
		-1,
		107,
		-1,
		121,
		134,
		138,
		136,
		139,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		129,
		140,
		135,
		134,
		152,
		167,
		180,
		184,
		190,
		-1,
		169,
		-1,
		111,
		95,
		97,
		69,
		90,
		-1,
		127,
		122,
		142,
		140,
		131,
		-1,
		134,
		137,
		144,
		122,
		107,
		124,
		116,
		114,
		119,
		124,
		138,
		129,
		147,
		154,
		162,
		166,
		186,
		198,
		129,
		119,
		-1,
		101,
		106,
		65,
		73,
		92,
		165,
		137,
		-1,
		132,
		-1,
		124,
		149,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		123,
		120,
		117,
		135,
		138,
		155,
		159,
		175,
		-1,
		-1,
		114,
		118,
		107,
		58,
		77,
		101,
		138,
		130,
		119,
		118,
		-1,
		109,
		139,
		136,
		122,
		109,
		99,
		100,
		108,
		121,
		100,
		119,
		122,
		144,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		84,
		55,
		79,
		121,
		148,
		141,
		129,
		94,
		94,
		88,
		-1,
		129,
		112,
		108,
		97,
		95,
		108,
		103,
		119,
		123,
		122,
		141,
		153,
		144,
		164,
		-1,
		-1,
		-1,
		114,
		103,
		104,
		50,
		73,
		110,
		127,
		113,
		118,
		93,
		86,
		80,
		132,
		129,
		96,
		104,
		96,
		85,
		99,
		107,
		111,
		120,
		129,
		135,
		159,
		159,
		165,
		-1,
		-1,
		121,
		111,
		95,
		97,
		94,
		64,
		71,
		103,
		118,
		115,
		-1,
		85,
		-1,
		74,
		82,
		81,
		87,
		99,
		85,
		90,
		101,
		113,
		126,
		122,
		129,
		164,
		164,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		114,
		109,
		84,
		61,
		45,
		81,
		-1,
		85,
		86,
		-1,
		79,
		73,
		79,
		78,
		85,
		82,
		82,
		96,
		104,
		100,
		116,
		122,
		114,
		150,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		107,
		86,
		79,
		99,
		40,
		92,
		-1,
		-1,
		70,
		63,
		-1,
		66,
		66,
		73,
		82,
		87,
		92,
		100,
		95,
		108,
		113,
		119,
		124,
		142,
		146,
		150,
		139,
		135,
		132,
		146,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		40,
		60,
		-1,
		76,
		68,
		61,
		55,
		61,
		79,
		77,
		97,
		89,
		103,
		103,
		109,
		117,
		102,
		105,
		121,
		119,
		137,
		145,
		137,
		131,
		130,
		142,
		-1,
		127,
		113,
		84,
		-1,
		-1,
		73,
		-1,
		37,
		54,
		70,
		-1,
		95,
		74,
		97,
		75,
		89,
		85,
		123,
		124,
		102,
		107,
		115,
		125,
		127,
		116,
		127,
		119,
		141,
		141,
		125,
		126,
		135,
		-1,
		133,
		120,
		78,
		74,
		63,
		83,
		34,
		43,
		57,
		-1,
		-1,
		139,
		-1,
		73,
		90,
		99,
		97,
		113,
		104,
		110,
		126,
		129,
		131,
		121,
		110,
		116,
		113,
		135,
		121,
		119,
		138,
		154,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		49,
		36,
		30,
		-1,
		74,
		-1,
		117,
		107,
		91,
		76,
		109,
		-1,
		121,
		105,
		110,
		-1,
		156,
		-1,
		129,
		131,
		125,
		110,
		107,
		118,
		116,
		127,
		144,
		-1,
		83,
		68,
		61,
		51,
		65,
		31,
		-1,
		36,
		-1,
		-1,
		104,
		98,
		98,
		82,
		85,
		137,
		117,
		111,
		110,
		151,
		151,
		137,
		123,
		116,
		113,
		110,
		123,
		143,
		134,
		146,
		-1,
		-1,
		-1,
		88,
		61,
		55,
		27,
		0,
		-1,
		-1,
		166,
		121,
		107,
		-1,
		91,
		154,
		142,
		132,
		122,
		156,
		157,
		142,
		135,
		121,
		123,
		121,
		119,
		124,
		145,
		146,
		159,
		-1,
		-1,
		60,
		53,
		41,
		24,
		43,
		-1,
		-1,
		-1,
		113,
		129,
		121,
		92,
		143,
		-1,
		-1,
		134,
		132,
		142,
		138,
		125,
		145,
		148,
		134,
		118,
		133,
		145,
		153,
		158,
		-1,
		63,
		50,
		-1,
		-1,
		46,
		40,
		-1,
		-1,
		-1,
		-1,
		146,
		112,
		124,
		145,
		170,
		137,
		-1,
		142,
		143,
		129,
		143,
		150,
		136,
		131,
		125,
		128,
		146,
		163,
		-1,
		-1,
		60,
		-1,
		55,
		-1,
		-1,
		-1,
		-1,
		103,
		117,
		138,
		144,
		156,
		-1,
		151,
		145,
		131,
		148,
		149,
		146,
		137,
		129,
		134,
		131,
		144,
		158,
		162,
		83,
		-1,
		66,
		-1,
		-1,
		-1,
		121,
		136,
		198,
		175,
		148,
		152,
		145,
		139,
		139,
		155,
		157,
		168,
		136,
		132,
		133,
		137,
		136,
		153,
		163,
		-1,
		-1,
		66,
		83,
		118,
		129,
		133,
		225,
		-1,
		-1,
		161,
		152,
		143,
		146,
		149,
		152,
		142,
		139,
		144,
		149,
		137,
		146,
		164,
		168,
		-1,
		-1,
		-1,
		86,
		-1,
		101,
		-1,
		-1,
		148,
		232,
		179,
		161,
		157,
		155,
		148,
		157,
		152,
		147,
		157,
		166,
		158,
		139,
		150,
		173,
		162,
		200,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		115,
		90,
		105,
		151,
		156,
		147,
		194,
		191,
		-1,
		161,
		186,
		158,
		165,
		157,
		165,
		165,
		162,
		140,
		147,
		163,
		162,
		157,
		192,
		184,
		190,
		-1,
		-1,
		213,
		202,
		191,
		197,
		-1,
		121,
		107,
		137,
		127,
		133,
		-1,
		-1,
		180,
		177,
		180,
		167,
		171,
		164,
		159,
		169,
		149,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		108,
		189,
		182,
		165,
		173,
		204,
		-1,
		124,
		133,
		114,
		119,
		127,
		-1,
		-1,
		153,
		149,
		154,
		163,
		166,
		179,
		174,
		165,
		150,
		156,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		122,
		165,
		159,
		162,
		186,
		200,
		-1,
		137,
		-1,
		-1,
		122,
		140,
		148,
		144,
		148,
		201,
		177,
		172,
		173,
		171,
		162,
		153,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		157,
		145,
		153,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		138,
		-1,
		174,
		-1,
		167,
		171,
		185,
		188,
		187,
		174,
		166,
		158,
		174,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		231,
		186,
		153,
		144,
		191,
		206,
		210,
		-1,
		150,
		189,
		176,
		-1,
		147,
		-1,
		-1,
		-1,
		181,
		198,
		190,
		206,
		186,
		186,
		160,
		164,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		227,
		225,
		230,
		175,
		158,
		176,
		185,
		206,
		165,
		156,
		183,
		183,
		172,
		167,
		154,
		-1,
		-1,
		204,
		208,
		-1,
		-1,
		193,
		181,
		164,
		165,
		161,
		164,
		179,
		182,
		172,
		170,
		164,
		196,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		166,
		177,
		-1,
		-1,
		168,
		184,
		197,
		201,
		214,
		239,
		-1,
		157,
		-1,
		-1,
		225,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		169,
		180,
		190,
		178,
		179,
		169,
		179,
		192,
		211,
		208,
		196,
		194,
		217,
		174,
		170,
		-1,
		183,
		171,
		177,
		184,
		201,
		228,
		-1,
		-1,
		173,
		164,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		171,
		176,
		196,
		198,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		186,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		208,
		183,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		189,
		193,
		185,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		254,
		-1,
		206,
		192,
		212,
		227,
		235,
		-1,
		-1,
		-1,
		225,
		211,
		204,
		192,
		190,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		210,
		213,
		-1,
		-1,
		237,
		256,
		-1,
		216,
		205,
		190,
		182,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		217,
		220,
		225,
		-1,
		246,
		-1,
		240,
		-1,
		185,
		201,
		203,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		212,
		210,
		201,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		266,
		240,
		247,
		238,
		221,
		201,
		193,
		218,
		-1,
		211,
		-1,
		186,
		188,
		214,
		217,
		223,
		217,
		190,
		205,
		195,
		186,
		195,
		272,
		-1,
		242,
		275,
		239,
		207,
		207,
		206,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		239,
		224,
		205,
		192,
		199,
		199,
		192,
		-1,
		-1,
		-1,
		244,
		243,
		235,
		229,
		227,
		212,
		207,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		229,
		225,
		212,
		212,
		204,
		-1,
		326,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		238,
		236,
		209,
		197,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		205,
		240,
		-1,
		333,
		-1,
		274,
		-1,
		-1,
		254,
		239,
		231,
		220,
		209,
		207,
		198,
		189,
		211,
		227,
		211,
		209,
		212,
		213,
		-1,
		332,
		331,
		-1,
		273,
		265,
		251,
		-1,
		244,
		-1,
		255,
		216,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		319,
		289,
		-1,
		-1,
		-1,
		274,
		254,
		250,
		234,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		304,
		298,
		-1,
		267,
		270,
		-1,
		261,
		256,
		264,
		211,
		215,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		282,
		285,
		275,
		277,
		263,
		247,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		285,
		277,
		270,
		-1,
		-1,
		272,
		255,
		236,
		234,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		262,
		-1,
		-1,
		268,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		296,
		-1,
		-1,
		-1,
		258,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		318,
		319,
		342,
		306,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		321,
		319,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		275,
		264,
		275,
		283,
		256,
		263,
		-1,
		284,
		286,
		252,
		246,
		285,
		256,
		262,
		273,
		-1,
		-1,
		-1,
		275,
		274,
		244,
		242,
		251,
		256,
		263,
		-1,
		267,
		-1,
		296,
		275,
		286,
		291,
		237,
		234,
		254,
		273,
		260,
		252,
		311,
		267,
		238,
		232,
		250,
		245,
		254,
		246,
		-1,
		238,
		228,
		250,
		234,
		245,
		237,
		-1,
		-1,
		232,
		233,
		239,
		230,
		236,
		232,
		-1,
		242,
		226,
		-1,
		-1,
		222,
		228,
		212,
		215,
		223,
		221,
		234,
		226,
		221,
		-1,
		-1,
		218,
		214,
		221,
		208,
		204,
		221,
		234,
		216,
		230,
		229,
		-1,
		211,
		229,
		238,
		215,
		213,
		197,
		195,
		213,
		215,
		221,
		224,
		-1,
		204,
		206,
		216,
		224,
		229,
		213,
		200,
		200,
		210,
		203,
		222,
		213,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		203,
		220,
		212,
		202,
		217,
		210,
		203,
		200,
		198,
		195,
		211,
		212,
		222,
		-1,
		-1,
		257,
		226,
		261,
		218,
		203,
		-1,
		197,
		196,
		202,
		206,
		200,
		193,
		207,
		203,
		-1,
		189,
		188,
		219,
		205,
		216,
		217,
		-1,
		-1,
		215,
		207,
		192,
		195,
		192,
		192,
		211,
		210,
		202,
		188,
		184,
		190,
		193,
		193,
		199,
		183,
		193,
		197,
		208,
		223,
		-1,
		-1,
		278,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		187,
		204,
		194,
		215,
		221,
		212,
		204,
		198,
		186,
		188,
		185,
		198,
		186,
		180,
		205,
		209,
		203,
		224,
		219,
		-1,
		277,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		216,
		-1,
		206,
		212,
		222,
		207,
		204,
		191,
		179,
		192,
		177,
		184,
		183,
		187,
		189,
		222,
		200,
		222,
		219,
		248,
		253,
		247,
		256,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		224,
		223,
		198,
		216,
		219,
		208,
		199,
		186,
		175,
		186,
		175,
		172,
		180,
		189,
		200,
		195,
		194,
		212,
		227,
		240,
		244,
		250,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		225,
		215,
		200,
		191,
		-1,
		194,
		197,
		204,
		182,
		167,
		184,
		176,
		174,
		179,
		184,
		198,
		189,
		207,
		214,
		222,
		226,
		246,
		258,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		184,
		209,
		-1,
		188,
		184,
		166,
		167,
		162,
		177,
		183,
		180,
		177,
		195,
		198,
		215,
		219,
		235,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		199,
		196,
		182,
		169,
		159,
		160,
		168,
		181,
		160,
		179,
		182,
		204,
		232,
		210,
		222,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		189,
		172,
		168,
		157,
		155,
		168,
		163,
		179,
		183,
		182,
		201,
		213,
		204,
		224,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		192,
		189,
		156,
		164,
		156,
		145,
		159,
		167,
		171,
		180,
		189,
		195,
		219,
		219,
		225,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		142,
		141,
		147,
		159,
		145,
		150,
		161,
		173,
		186,
		182,
		189,
		224,
		224,
		209,
		229,
		232,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		139,
		138,
		145,
		142,
		142,
		156,
		164,
		160,
		176,
		182,
		174,
		210,
		-1,
		217,
		211,
		219,
		209,
		197,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		126,
		133,
		142,
		147,
		152,
		160,
		155,
		168,
		173,
		179,
		184,
		202,
		206,
		210,
		199,
		195,
		192,
		206,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		128,
		130,
		157,
		149,
		163,
		163,
		169,
		177,
		162,
		165,
		181,
		179,
		197,
		205,
		197,
		191,
		190,
		202,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		145,
		183,
		184,
		162,
		167,
		175,
		185,
		187,
		176,
		187,
		179,
		201,
		201,
		185,
		186,
		195,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		124,
		-1,
		109,
		111,
		159,
		157,
		173,
		164,
		170,
		186,
		189,
		191,
		181,
		170,
		176,
		173,
		195,
		181,
		179,
		198,
		214,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		102,
		90,
		87,
		98,
		130,
		-1,
		181,
		165,
		170,
		-1,
		216,
		-1,
		189,
		191,
		185,
		170,
		167,
		178,
		176,
		187,
		204,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		89,
		83,
		82,
		104,
		107,
		197,
		177,
		171,
		170,
		211,
		211,
		197,
		183,
		176,
		173,
		170,
		183,
		203,
		194,
		206,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		0,
		46,
		66,
		-1,
		113,
		214,
		202,
		192,
		182,
		216,
		217,
		202,
		195,
		181,
		183,
		181,
		179,
		184,
		205,
		206,
		219,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		75,
		91,
		143,
		114,
		203,
		-1,
		-1,
		194,
		192,
		202,
		198,
		185,
		205,
		208,
		194,
		178,
		193,
		205,
		213,
		218,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		114,
		134,
		146,
		167,
		192,
		197,
		-1,
		202,
		203,
		189,
		203,
		210,
		196,
		191,
		185,
		188,
		206,
		223,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		125,
		139,
		160,
		166,
		178,
		-1,
		204,
		205,
		191,
		208,
		209,
		206,
		197,
		189,
		194,
		191,
		204,
		218,
		222,
		212,
		-1,
		195,
		-1,
		-1,
		-1,
		143,
		158,
		220,
		197,
		170,
		175,
		185,
		190,
		195,
		215,
		217,
		228,
		196,
		192,
		193,
		197,
		196,
		213,
		223,
		-1,
		-1,
		195,
		204,
		169,
		151,
		155,
		247,
		-1,
		-1,
		185,
		191,
		187,
		197,
		205,
		208,
		202,
		199,
		204,
		209,
		197,
		206,
		224,
		228,
		-1,
		-1,
		-1,
		215,
		-1,
		202,
		-1,
		-1,
		170,
		271,
		218,
		200,
		196,
		194,
		199,
		208,
		203,
		207,
		217,
		226,
		218,
		199,
		210,
		233,
		222,
		260,
		-1,
		-1,
		334,
		-1,
		-1,
		-1,
		244,
		219,
		234,
		255,
		190,
		197,
		233,
		230,
		-1,
		200,
		237,
		209,
		216,
		208,
		221,
		225,
		222,
		200,
		207,
		223,
		222,
		217,
		252,
		244,
		250,
		-1,
		-1,
		327,
		316,
		305,
		311,
		-1,
		250,
		236,
		241,
		231,
		207,
		-1,
		-1,
		249,
		246,
		224,
		218,
		222,
		215,
		210,
		229,
		209,
		196,
		200,
		204,
		210,
		215,
		220,
		226,
		241,
		256,
		-1,
		222,
		303,
		296,
		279,
		287,
		318,
		-1,
		249,
		241,
		243,
		227,
		218,
		-1,
		-1,
		222,
		219,
		224,
		225,
		222,
		234,
		233,
		225,
		210,
		216,
		203,
		202,
		220,
		224,
		233,
		240,
		230,
		243,
		247,
		-1,
		236,
		279,
		273,
		276,
		300,
		314,
		-1,
		246,
		-1,
		-1,
		251,
		231,
		237,
		227,
		221,
		271,
		239,
		234,
		233,
		231,
		222,
		213,
		220,
		211,
		211,
		214,
		229,
		234,
		226,
		240,
		240,
		241,
		-1,
		271,
		259,
		267,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		267,
		-1,
		264,
		-1,
		239,
		243,
		247,
		250,
		247,
		234,
		226,
		218,
		234,
		209,
		219,
		215,
		216,
		225,
		236,
		248,
		247,
		248,
		341,
		297,
		267,
		258,
		305,
		320,
		324,
		-1,
		258,
		297,
		305,
		-1,
		276,
		-1,
		-1,
		-1,
		253,
		260,
		252,
		267,
		246,
		246,
		220,
		224,
		214,
		221,
		231,
		233,
		225,
		229,
		242,
		253,
		256,
		337,
		328,
		341,
		286,
		272,
		290,
		299,
		320,
		273,
		264,
		291,
		312,
		301,
		296,
		283,
		-1,
		-1,
		276,
		270,
		-1,
		-1,
		253,
		241,
		224,
		225,
		221,
		224,
		239,
		242,
		232,
		230,
		224,
		256,
		-1,
		330,
		329,
		318,
		315,
		291,
		282,
		277,
		291,
		-1,
		-1,
		276,
		292,
		305,
		309,
		325,
		350,
		-1,
		286,
		-1,
		-1,
		297,
		-1,
		-1,
		283,
		246,
		235,
		226,
		232,
		229,
		240,
		250,
		238,
		239,
		229,
		239,
		252,
		314,
		311,
		299,
		297,
		320,
		285,
		273,
		-1,
		286,
		279,
		285,
		292,
		309,
		339,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		281,
		279,
		268,
		-1,
		258,
		231,
		236,
		256,
		258,
		247,
		241,
		235,
		242,
		241,
		249,
		257,
		323,
		337,
		326,
		322,
		321,
		329,
		278,
		271,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		334,
		-1,
		319,
		312,
		-1,
		-1,
		276,
		269,
		257,
		245,
		235,
		245,
		249,
		253,
		245,
		238,
		233,
		244,
		236,
		240,
		257,
		-1,
		357,
		-1,
		309,
		285,
		299,
		314,
		322,
		-1,
		-1,
		-1,
		336,
		322,
		315,
		303,
		301,
		-1,
		310,
		294,
		275,
		-1,
		245,
		258,
		289,
		257,
		262,
		257,
		239,
		250,
		239,
		242,
		256,
		251,
		-1,
		-1,
		297,
		300,
		-1,
		-1,
		322,
		328,
		-1,
		327,
		316,
		301,
		293,
		-1,
		-1,
		282,
		278,
		-1,
		-1,
		246,
		271,
		260,
		268,
		263,
		243,
		249,
		252,
		241,
		245,
		257,
		-1,
		-1,
		304,
		305,
		310,
		-1,
		311,
		-1,
		329,
		-1,
		296,
		302,
		290,
		-1,
		-1,
		-1,
		284,
		247,
		268,
		278,
		272,
		270,
		261,
		247,
		254,
		252,
		248,
		259,
		-1,
		-1,
		-1,
		329,
		303,
		336,
		327,
		310,
		290,
		282,
		301,
		-1,
		271,
		-1,
		246,
		248,
		274,
		277,
		283,
		277,
		250,
		265,
		255,
		246,
		255,
		335,
		-1,
		305,
		338,
		302,
		296,
		272,
		276,
		292,
		-1,
		268,
		250,
		-1,
		278,
		268,
		299,
		284,
		265,
		252,
		259,
		259,
		252,
		-1,
		-1,
		-1,
		307,
		306,
		298,
		292,
		292,
		277,
		268,
		-1,
		280,
		262,
		241,
		258,
		258,
		249,
		257,
		289,
		285,
		272,
		272,
		264,
		-1,
		408,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		301,
		296,
		269,
		257,
		263,
		259,
		245,
		251,
		253,
		261,
		259,
		256,
		268,
		264,
		284,
		265,
		300,
		-1,
		403,
		-1,
		337,
		-1,
		-1,
		319,
		299,
		291,
		280,
		269,
		267,
		258,
		249,
		271,
		287,
		271,
		269,
		272,
		273,
		-1,
		392,
		391,
		-1,
		338,
		330,
		316,
		-1,
		309,
		-1,
		315,
		276,
		-1,
		278,
		258,
		-1,
		280,
		276,
		-1,
		-1,
		379,
		354,
		-1,
		-1,
		-1,
		339,
		319,
		310,
		294,
		-1,
		269,
		269,
		-1,
		-1,
		-1,
		364,
		363,
		-1,
		332,
		335,
		-1,
		325,
		316,
		324,
		271,
		275,
		-1,
		-1,
		-1,
		373,
		354,
		348,
		347,
		345,
		340,
		337,
		323,
		307,
		285,
		274,
		295,
		-1,
		-1,
		-1,
		345,
		337,
		330,
		-1,
		-1,
		332,
		315,
		296,
		294,
		-1,
		-1,
		-1,
		367,
		348,
		-1,
		-1,
		322,
		-1,
		-1,
		328,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		384,
		356,
		-1,
		-1,
		-1,
		318,
		314,
		315,
		-1,
		-1,
		-1,
		-1,
		378,
		379,
		402,
		366,
		-1,
		-1,
		-1,
		310,
		304,
		-1,
		-1,
		381,
		379,
		-1,
		-1,
		-1,
		338,
		322,
		-1,
		308,
		-1,
		-1,
		-1,
		329,
		-1,
		-1,
		341,
		-1,
		-1,
		-1,
		343,
		-1,
		343,
		318,
		325,
		-1,
		-1,
		-1,
		-1,
		356,
		348,
		356,
		-1,
		328,
		330,
		-1,
		378,
		-1,
		-1,
		371,
		362,
		-1,
		-1,
		333,
		340,
		362,
		365,
		401,
		-1,
		352
	],
	[
		-1,
		229,
		218,
		229,
		237,
		210,
		217,
		-1,
		238,
		240,
		206,
		200,
		239,
		210,
		216,
		227,
		-1,
		-1,
		-1,
		229,
		228,
		198,
		196,
		205,
		210,
		217,
		-1,
		221,
		-1,
		250,
		229,
		240,
		245,
		191,
		188,
		208,
		227,
		214,
		206,
		265,
		221,
		192,
		186,
		204,
		199,
		208,
		200,
		-1,
		192,
		182,
		204,
		188,
		199,
		191,
		-1,
		-1,
		186,
		187,
		193,
		184,
		190,
		186,
		-1,
		196,
		180,
		-1,
		-1,
		176,
		182,
		166,
		169,
		177,
		175,
		188,
		180,
		175,
		-1,
		-1,
		172,
		168,
		175,
		162,
		158,
		175,
		188,
		170,
		184,
		183,
		-1,
		165,
		183,
		192,
		169,
		167,
		151,
		149,
		167,
		169,
		175,
		178,
		-1,
		158,
		160,
		170,
		178,
		183,
		167,
		154,
		154,
		164,
		157,
		176,
		167,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		155,
		157,
		174,
		166,
		156,
		171,
		164,
		157,
		154,
		152,
		149,
		165,
		166,
		176,
		-1,
		-1,
		211,
		180,
		215,
		172,
		157,
		-1,
		151,
		150,
		156,
		160,
		154,
		147,
		161,
		157,
		-1,
		143,
		142,
		173,
		159,
		170,
		171,
		-1,
		-1,
		169,
		161,
		146,
		149,
		146,
		146,
		165,
		164,
		156,
		142,
		138,
		144,
		147,
		147,
		153,
		137,
		147,
		151,
		162,
		177,
		-1,
		-1,
		232,
		-1,
		-1,
		168,
		151,
		-1,
		134,
		141,
		141,
		158,
		148,
		169,
		175,
		166,
		158,
		152,
		140,
		142,
		139,
		152,
		140,
		134,
		159,
		163,
		157,
		178,
		173,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		136,
		160,
		170,
		-1,
		160,
		166,
		176,
		161,
		158,
		145,
		133,
		146,
		131,
		138,
		137,
		141,
		143,
		176,
		154,
		176,
		173,
		202,
		207,
		201,
		210,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		164,
		-1,
		178,
		177,
		152,
		170,
		173,
		162,
		153,
		140,
		129,
		140,
		129,
		126,
		134,
		143,
		154,
		149,
		148,
		166,
		181,
		194,
		198,
		204,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		184,
		179,
		169,
		154,
		145,
		-1,
		148,
		151,
		158,
		136,
		121,
		138,
		130,
		128,
		133,
		138,
		152,
		143,
		161,
		168,
		176,
		180,
		200,
		212,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		138,
		163,
		-1,
		142,
		138,
		120,
		121,
		116,
		131,
		137,
		134,
		131,
		149,
		152,
		169,
		173,
		189,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		153,
		150,
		136,
		123,
		113,
		114,
		122,
		135,
		114,
		133,
		136,
		158,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		143,
		126,
		122,
		111,
		109,
		122,
		117,
		133,
		137,
		136,
		155,
		167,
		158,
		178,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		146,
		143,
		110,
		118,
		110,
		99,
		113,
		121,
		125,
		134,
		143,
		149,
		173,
		173,
		179,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		96,
		95,
		101,
		113,
		99,
		104,
		115,
		127,
		140,
		136,
		143,
		178,
		178,
		163,
		183,
		186,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		93,
		92,
		99,
		96,
		96,
		110,
		118,
		114,
		130,
		136,
		128,
		164,
		-1,
		171,
		165,
		173,
		163,
		151,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		80,
		87,
		96,
		101,
		106,
		114,
		109,
		122,
		127,
		133,
		138,
		156,
		160,
		164,
		153,
		149,
		146,
		160,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		82,
		84,
		111,
		103,
		117,
		117,
		123,
		131,
		116,
		119,
		135,
		133,
		151,
		159,
		151,
		145,
		144,
		156,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		99,
		137,
		138,
		116,
		121,
		129,
		139,
		141,
		130,
		141,
		133,
		155,
		155,
		139,
		140,
		149,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		89,
		-1,
		63,
		65,
		113,
		111,
		127,
		118,
		124,
		140,
		143,
		145,
		135,
		124,
		130,
		127,
		149,
		135,
		133,
		152,
		168,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		67,
		56,
		41,
		52,
		84,
		-1,
		135,
		119,
		124,
		-1,
		170,
		-1,
		143,
		145,
		139,
		124,
		121,
		132,
		130,
		141,
		158,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		54,
		48,
		36,
		58,
		61,
		151,
		131,
		125,
		124,
		165,
		165,
		151,
		137,
		130,
		127,
		124,
		137,
		157,
		148,
		160,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		45,
		0,
		20,
		-1,
		67,
		168,
		156,
		146,
		136,
		170,
		171,
		156,
		149,
		135,
		137,
		135,
		133,
		138,
		159,
		160,
		173,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		29,
		45,
		97,
		68,
		157,
		-1,
		-1,
		148,
		146,
		156,
		152,
		139,
		159,
		162,
		148,
		132,
		147,
		159,
		167,
		172,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		68,
		88,
		100,
		121,
		146,
		151,
		-1,
		156,
		157,
		143,
		157,
		164,
		150,
		145,
		139,
		142,
		160,
		177,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		79,
		93,
		114,
		120,
		132,
		-1,
		158,
		159,
		145,
		162,
		163,
		160,
		151,
		143,
		148,
		145,
		158,
		172,
		176,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		97,
		112,
		174,
		151,
		124,
		129,
		139,
		144,
		149,
		169,
		171,
		182,
		150,
		146,
		147,
		151,
		150,
		167,
		177,
		-1,
		-1,
		149,
		158,
		123,
		105,
		109,
		201,
		-1,
		-1,
		139,
		145,
		141,
		151,
		159,
		162,
		156,
		153,
		158,
		163,
		151,
		160,
		178,
		182,
		-1,
		-1,
		-1,
		169,
		-1,
		156,
		-1,
		-1,
		124,
		225,
		172,
		154,
		150,
		148,
		153,
		162,
		157,
		161,
		171,
		180,
		172,
		153,
		164,
		187,
		176,
		214,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		198,
		173,
		188,
		209,
		144,
		151,
		187,
		184,
		-1,
		154,
		191,
		163,
		170,
		162,
		175,
		179,
		176,
		154,
		161,
		177,
		176,
		171,
		206,
		198,
		204,
		-1,
		-1,
		281,
		270,
		259,
		265,
		-1,
		204,
		190,
		195,
		185,
		161,
		-1,
		-1,
		203,
		200,
		178,
		172,
		176,
		169,
		164,
		183,
		163,
		150,
		154,
		158,
		164,
		169,
		174,
		180,
		195,
		210,
		-1,
		176,
		257,
		250,
		233,
		241,
		272,
		-1,
		203,
		195,
		197,
		181,
		172,
		-1,
		-1,
		176,
		173,
		178,
		179,
		176,
		188,
		187,
		179,
		164,
		170,
		157,
		156,
		174,
		178,
		187,
		194,
		184,
		197,
		201,
		-1,
		190,
		233,
		227,
		230,
		254,
		268,
		-1,
		200,
		-1,
		-1,
		205,
		185,
		191,
		181,
		175,
		225,
		193,
		188,
		187,
		185,
		176,
		167,
		174,
		165,
		165,
		168,
		183,
		188,
		180,
		194,
		194,
		195,
		-1,
		225,
		213,
		221,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		221,
		-1,
		218,
		-1,
		193,
		197,
		201,
		204,
		201,
		188,
		180,
		172,
		188,
		163,
		173,
		169,
		170,
		179,
		190,
		202,
		201,
		202,
		295,
		251,
		221,
		212,
		259,
		274,
		278,
		-1,
		212,
		251,
		259,
		-1,
		230,
		-1,
		-1,
		-1,
		207,
		214,
		206,
		221,
		200,
		200,
		174,
		178,
		168,
		175,
		185,
		187,
		179,
		183,
		196,
		207,
		210,
		291,
		282,
		295,
		240,
		226,
		244,
		253,
		274,
		227,
		218,
		245,
		266,
		255,
		250,
		237,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		207,
		195,
		178,
		179,
		175,
		178,
		193,
		196,
		186,
		184,
		178,
		210,
		-1,
		284,
		283,
		272,
		269,
		245,
		236,
		231,
		245,
		-1,
		-1,
		230,
		246,
		259,
		263,
		279,
		304,
		-1,
		240,
		-1,
		-1,
		251,
		-1,
		-1,
		237,
		200,
		189,
		180,
		186,
		183,
		194,
		204,
		192,
		193,
		183,
		193,
		206,
		268,
		265,
		253,
		251,
		274,
		239,
		227,
		-1,
		240,
		233,
		239,
		246,
		263,
		293,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		235,
		233,
		222,
		-1,
		212,
		185,
		190,
		210,
		212,
		201,
		195,
		189,
		196,
		195,
		203,
		211,
		277,
		291,
		280,
		276,
		275,
		283,
		232,
		225,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		-1,
		273,
		266,
		-1,
		-1,
		230,
		223,
		211,
		199,
		189,
		199,
		203,
		207,
		199,
		192,
		187,
		198,
		190,
		194,
		211,
		-1,
		311,
		-1,
		263,
		239,
		253,
		268,
		276,
		-1,
		-1,
		-1,
		290,
		276,
		269,
		257,
		255,
		-1,
		264,
		248,
		229,
		-1,
		199,
		212,
		243,
		211,
		216,
		211,
		193,
		204,
		193,
		196,
		210,
		205,
		-1,
		-1,
		251,
		254,
		-1,
		-1,
		276,
		282,
		-1,
		281,
		270,
		255,
		247,
		-1,
		-1,
		236,
		232,
		-1,
		-1,
		200,
		225,
		214,
		222,
		217,
		197,
		203,
		206,
		195,
		199,
		211,
		-1,
		-1,
		258,
		259,
		264,
		-1,
		265,
		-1,
		283,
		-1,
		250,
		256,
		244,
		-1,
		-1,
		-1,
		238,
		201,
		222,
		232,
		226,
		224,
		215,
		201,
		208,
		206,
		202,
		213,
		-1,
		-1,
		-1,
		283,
		257,
		290,
		281,
		264,
		244,
		236,
		255,
		-1,
		225,
		-1,
		200,
		202,
		228,
		231,
		237,
		231,
		204,
		219,
		209,
		200,
		209,
		289,
		-1,
		259,
		292,
		256,
		250,
		226,
		230,
		246,
		-1,
		222,
		204,
		-1,
		232,
		222,
		253,
		238,
		219,
		206,
		213,
		213,
		206,
		-1,
		-1,
		-1,
		261,
		260,
		252,
		246,
		246,
		231,
		222,
		-1,
		234,
		216,
		195,
		212,
		212,
		203,
		211,
		243,
		239,
		226,
		226,
		218,
		-1,
		362,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		255,
		250,
		223,
		211,
		217,
		213,
		199,
		205,
		207,
		215,
		213,
		210,
		222,
		218,
		238,
		219,
		254,
		-1,
		357,
		-1,
		291,
		-1,
		-1,
		273,
		253,
		245,
		234,
		223,
		221,
		212,
		203,
		225,
		241,
		225,
		223,
		226,
		227,
		-1,
		346,
		345,
		-1,
		292,
		284,
		270,
		-1,
		263,
		-1,
		269,
		230,
		-1,
		232,
		212,
		-1,
		234,
		230,
		-1,
		-1,
		333,
		308,
		-1,
		-1,
		-1,
		293,
		273,
		264,
		248,
		-1,
		223,
		223,
		-1,
		-1,
		-1,
		318,
		317,
		-1,
		286,
		289,
		-1,
		279,
		270,
		278,
		225,
		229,
		-1,
		-1,
		-1,
		327,
		308,
		302,
		301,
		299,
		294,
		291,
		277,
		261,
		239,
		228,
		249,
		-1,
		-1,
		-1,
		299,
		291,
		284,
		-1,
		-1,
		286,
		269,
		250,
		248,
		-1,
		-1,
		-1,
		321,
		302,
		-1,
		-1,
		276,
		-1,
		-1,
		282,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		338,
		310,
		-1,
		-1,
		-1,
		272,
		268,
		269,
		-1,
		-1,
		-1,
		-1,
		332,
		333,
		356,
		320,
		-1,
		-1,
		-1,
		264,
		258,
		-1,
		-1,
		335,
		333,
		-1,
		-1,
		-1,
		292,
		276,
		-1,
		262,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		297,
		-1,
		297,
		272,
		279,
		-1,
		-1,
		-1,
		-1,
		310,
		302,
		310,
		-1,
		282,
		284,
		-1,
		332,
		-1,
		-1,
		325,
		316,
		-1,
		-1,
		287,
		294,
		316,
		319,
		355,
		-1,
		306
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		224,
		226,
		192,
		186,
		225,
		196,
		202,
		213,
		-1,
		-1,
		-1,
		215,
		214,
		184,
		182,
		191,
		196,
		203,
		-1,
		207,
		-1,
		236,
		215,
		226,
		231,
		177,
		174,
		194,
		213,
		200,
		192,
		251,
		207,
		178,
		172,
		190,
		185,
		194,
		186,
		-1,
		178,
		168,
		190,
		174,
		185,
		177,
		-1,
		-1,
		172,
		173,
		179,
		170,
		176,
		172,
		-1,
		182,
		166,
		-1,
		-1,
		162,
		168,
		152,
		155,
		163,
		161,
		174,
		166,
		161,
		-1,
		-1,
		158,
		154,
		161,
		148,
		144,
		161,
		174,
		156,
		170,
		169,
		-1,
		151,
		169,
		178,
		155,
		153,
		137,
		135,
		153,
		155,
		161,
		164,
		-1,
		144,
		146,
		156,
		164,
		169,
		153,
		140,
		140,
		150,
		143,
		162,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		143,
		160,
		152,
		142,
		157,
		150,
		143,
		140,
		138,
		135,
		151,
		152,
		162,
		-1,
		-1,
		197,
		166,
		201,
		158,
		143,
		-1,
		137,
		136,
		142,
		146,
		140,
		133,
		147,
		143,
		-1,
		129,
		128,
		159,
		145,
		156,
		157,
		-1,
		-1,
		155,
		147,
		132,
		135,
		132,
		132,
		151,
		150,
		142,
		128,
		124,
		130,
		133,
		133,
		139,
		123,
		133,
		137,
		148,
		163,
		-1,
		-1,
		218,
		-1,
		-1,
		154,
		137,
		-1,
		120,
		127,
		127,
		144,
		134,
		155,
		161,
		152,
		144,
		138,
		126,
		128,
		125,
		138,
		126,
		120,
		145,
		149,
		143,
		164,
		159,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		113,
		116,
		122,
		146,
		156,
		-1,
		146,
		152,
		162,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		127,
		129,
		162,
		140,
		162,
		159,
		188,
		193,
		187,
		196,
		-1,
		162,
		158,
		154,
		161,
		110,
		-1,
		-1,
		150,
		-1,
		164,
		163,
		138,
		156,
		159,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		129,
		140,
		135,
		134,
		152,
		167,
		180,
		184,
		190,
		-1,
		212,
		-1,
		154,
		138,
		140,
		112,
		133,
		-1,
		170,
		165,
		155,
		140,
		131,
		-1,
		134,
		137,
		144,
		122,
		107,
		124,
		116,
		114,
		119,
		124,
		138,
		129,
		147,
		154,
		162,
		166,
		186,
		198,
		172,
		162,
		-1,
		144,
		149,
		108,
		116,
		135,
		173,
		137,
		-1,
		132,
		-1,
		124,
		149,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		123,
		120,
		117,
		135,
		138,
		155,
		159,
		175,
		-1,
		-1,
		157,
		161,
		150,
		101,
		120,
		144,
		181,
		130,
		119,
		118,
		-1,
		109,
		139,
		136,
		122,
		109,
		99,
		100,
		108,
		121,
		100,
		119,
		122,
		144,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		127,
		98,
		122,
		164,
		148,
		141,
		129,
		94,
		94,
		88,
		-1,
		129,
		112,
		108,
		97,
		95,
		108,
		103,
		119,
		123,
		122,
		141,
		153,
		144,
		164,
		-1,
		-1,
		-1,
		157,
		146,
		147,
		93,
		116,
		153,
		127,
		113,
		118,
		93,
		86,
		80,
		132,
		129,
		96,
		104,
		96,
		85,
		99,
		107,
		111,
		120,
		129,
		135,
		159,
		159,
		165,
		-1,
		-1,
		164,
		154,
		138,
		140,
		137,
		107,
		114,
		146,
		118,
		131,
		-1,
		85,
		-1,
		74,
		82,
		81,
		87,
		99,
		85,
		90,
		101,
		113,
		126,
		122,
		129,
		164,
		164,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		157,
		152,
		127,
		104,
		88,
		124,
		-1,
		101,
		102,
		-1,
		79,
		73,
		79,
		78,
		85,
		82,
		82,
		96,
		104,
		100,
		116,
		122,
		114,
		150,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		150,
		129,
		122,
		142,
		83,
		135,
		-1,
		-1,
		86,
		79,
		-1,
		66,
		66,
		73,
		82,
		87,
		92,
		100,
		95,
		108,
		113,
		119,
		124,
		142,
		146,
		150,
		139,
		135,
		132,
		146,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		83,
		103,
		-1,
		95,
		87,
		77,
		71,
		65,
		68,
		70,
		97,
		89,
		103,
		103,
		109,
		117,
		102,
		105,
		121,
		119,
		137,
		145,
		137,
		131,
		130,
		142,
		-1,
		170,
		156,
		127,
		-1,
		-1,
		116,
		-1,
		80,
		94,
		110,
		-1,
		103,
		82,
		97,
		75,
		71,
		85,
		123,
		124,
		102,
		107,
		115,
		125,
		127,
		116,
		127,
		119,
		141,
		141,
		125,
		126,
		135,
		-1,
		176,
		163,
		121,
		117,
		106,
		126,
		77,
		65,
		97,
		-1,
		-1,
		71,
		-1,
		49,
		51,
		99,
		97,
		113,
		104,
		110,
		126,
		129,
		131,
		121,
		110,
		116,
		113,
		135,
		121,
		119,
		138,
		154,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		92,
		79,
		73,
		-1,
		114,
		-1,
		49,
		39,
		23,
		38,
		70,
		-1,
		121,
		105,
		110,
		-1,
		156,
		-1,
		129,
		131,
		125,
		110,
		107,
		118,
		116,
		127,
		144,
		-1,
		126,
		111,
		104,
		94,
		108,
		79,
		-1,
		134,
		-1,
		-1,
		36,
		30,
		18,
		44,
		47,
		137,
		117,
		111,
		110,
		151,
		151,
		137,
		123,
		116,
		113,
		110,
		123,
		143,
		134,
		146,
		-1,
		-1,
		-1,
		131,
		117,
		121,
		81,
		100,
		-1,
		-1,
		61,
		16,
		0,
		-1,
		53,
		154,
		142,
		132,
		122,
		156,
		157,
		142,
		135,
		121,
		123,
		121,
		119,
		124,
		145,
		146,
		159,
		-1,
		-1,
		114,
		119,
		107,
		93,
		112,
		-1,
		-1,
		-1,
		14,
		30,
		83,
		54,
		143,
		-1,
		-1,
		134,
		132,
		142,
		138,
		125,
		145,
		148,
		134,
		118,
		133,
		145,
		153,
		158,
		-1,
		117,
		104,
		-1,
		-1,
		115,
		109,
		-1,
		-1,
		-1,
		-1,
		53,
		74,
		86,
		107,
		132,
		137,
		-1,
		142,
		143,
		129,
		143,
		150,
		136,
		131,
		125,
		128,
		146,
		163,
		-1,
		-1,
		129,
		-1,
		124,
		-1,
		-1,
		-1,
		-1,
		65,
		79,
		100,
		106,
		118,
		-1,
		144,
		145,
		131,
		148,
		149,
		146,
		137,
		129,
		134,
		131,
		144,
		158,
		162,
		152,
		-1,
		135,
		-1,
		-1,
		-1,
		83,
		98,
		160,
		137,
		110,
		115,
		125,
		130,
		135,
		155,
		157,
		168,
		136,
		132,
		133,
		137,
		136,
		153,
		163,
		-1,
		-1,
		135,
		144,
		109,
		91,
		95,
		187,
		-1,
		-1,
		125,
		131,
		127,
		137,
		145,
		148,
		142,
		139,
		144,
		149,
		137,
		146,
		164,
		168,
		-1,
		-1,
		-1,
		155,
		-1,
		142,
		-1,
		-1,
		110,
		211,
		158,
		140,
		136,
		134,
		139,
		148,
		143,
		147,
		157,
		166,
		158,
		139,
		150,
		173,
		162,
		200,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		184,
		159,
		174,
		195,
		130,
		137,
		173,
		170,
		-1,
		140,
		177,
		149,
		156,
		148,
		161,
		165,
		162,
		140,
		147,
		163,
		162,
		157,
		192,
		184,
		190,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		190,
		176,
		181,
		171,
		147,
		-1,
		-1,
		189,
		186,
		164,
		158,
		162,
		155,
		150,
		169,
		149,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		162,
		243,
		236,
		219,
		227,
		258,
		-1,
		189,
		181,
		183,
		167,
		158,
		-1,
		-1,
		162,
		159,
		164,
		165,
		162,
		174,
		173,
		165,
		150,
		156,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		176,
		219,
		213,
		216,
		240,
		254,
		-1,
		186,
		-1,
		-1,
		191,
		171,
		177,
		167,
		161,
		211,
		179,
		174,
		173,
		171,
		162,
		153,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		211,
		199,
		207,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		207,
		-1,
		204,
		-1,
		179,
		183,
		187,
		190,
		187,
		174,
		166,
		158,
		174,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		281,
		237,
		207,
		198,
		245,
		260,
		264,
		-1,
		198,
		237,
		245,
		-1,
		216,
		-1,
		-1,
		-1,
		193,
		200,
		192,
		207,
		186,
		186,
		160,
		164,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		277,
		268,
		281,
		226,
		212,
		230,
		239,
		260,
		213,
		204,
		231,
		252,
		241,
		236,
		223,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		193,
		181,
		164,
		165,
		161,
		164,
		179,
		182,
		172,
		170,
		164,
		196,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		217,
		231,
		-1,
		-1,
		216,
		232,
		245,
		249,
		265,
		290,
		-1,
		226,
		-1,
		-1,
		237,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		169,
		180,
		190,
		178,
		179,
		169,
		179,
		192,
		254,
		251,
		239,
		237,
		260,
		225,
		213,
		-1,
		226,
		219,
		225,
		232,
		249,
		279,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		171,
		176,
		196,
		198,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		211,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		-1,
		259,
		252,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		189,
		193,
		185,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		297,
		-1,
		249,
		225,
		239,
		254,
		262,
		-1,
		-1,
		-1,
		276,
		262,
		255,
		243,
		241,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		237,
		240,
		-1,
		-1,
		262,
		268,
		-1,
		267,
		256,
		241,
		233,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		244,
		245,
		250,
		-1,
		251,
		-1,
		269,
		-1,
		236,
		242,
		230,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		212,
		210,
		201,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		269,
		243,
		276,
		267,
		250,
		230,
		222,
		241,
		-1,
		211,
		-1,
		186,
		188,
		214,
		217,
		223,
		217,
		190,
		205,
		195,
		186,
		195,
		275,
		-1,
		245,
		278,
		242,
		236,
		212,
		216,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		239,
		224,
		205,
		192,
		199,
		199,
		192,
		-1,
		-1,
		-1,
		247,
		246,
		238,
		232,
		232,
		217,
		208,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		229,
		225,
		212,
		212,
		204,
		-1,
		348,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		241,
		236,
		209,
		197,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		205,
		240,
		-1,
		343,
		-1,
		277,
		-1,
		-1,
		259,
		239,
		231,
		220,
		209,
		207,
		198,
		189,
		211,
		227,
		211,
		209,
		212,
		213,
		-1,
		332,
		331,
		-1,
		278,
		270,
		256,
		-1,
		249,
		-1,
		255,
		216,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		319,
		294,
		-1,
		-1,
		-1,
		279,
		259,
		250,
		234,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		304,
		303,
		-1,
		272,
		275,
		-1,
		265,
		256,
		264,
		211,
		215,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		287,
		285,
		280,
		277,
		263,
		247,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		285,
		277,
		270,
		-1,
		-1,
		272,
		255,
		236,
		234,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		262,
		-1,
		-1,
		268,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		324,
		296,
		-1,
		-1,
		-1,
		258,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		318,
		319,
		342,
		306,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		321,
		319,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		195,
		184,
		195,
		203,
		176,
		183,
		-1,
		204,
		206,
		172,
		166,
		205,
		176,
		182,
		193,
		-1,
		-1,
		-1,
		195,
		194,
		164,
		162,
		171,
		176,
		183,
		-1,
		187,
		-1,
		216,
		195,
		206,
		211,
		157,
		154,
		174,
		193,
		180,
		172,
		231,
		187,
		158,
		152,
		170,
		165,
		174,
		166,
		-1,
		158,
		148,
		170,
		154,
		165,
		157,
		-1,
		-1,
		152,
		153,
		159,
		150,
		156,
		152,
		-1,
		162,
		146,
		-1,
		-1,
		142,
		148,
		132,
		135,
		143,
		141,
		154,
		146,
		141,
		-1,
		-1,
		138,
		134,
		141,
		128,
		124,
		141,
		154,
		136,
		150,
		149,
		-1,
		131,
		149,
		158,
		135,
		133,
		117,
		115,
		133,
		135,
		141,
		144,
		-1,
		124,
		126,
		136,
		144,
		149,
		133,
		120,
		120,
		130,
		123,
		142,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		121,
		123,
		140,
		132,
		122,
		137,
		130,
		123,
		120,
		118,
		115,
		131,
		132,
		142,
		-1,
		-1,
		177,
		146,
		181,
		138,
		123,
		-1,
		117,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		109,
		108,
		139,
		125,
		136,
		137,
		-1,
		-1,
		135,
		127,
		112,
		115,
		112,
		112,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		103,
		113,
		117,
		128,
		143,
		-1,
		-1,
		198,
		-1,
		-1,
		134,
		117,
		-1,
		100,
		107,
		107,
		124,
		114,
		135,
		141,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		100,
		125,
		129,
		123,
		144,
		139,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		93,
		96,
		102,
		126,
		136,
		-1,
		126,
		132,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		107,
		109,
		142,
		120,
		142,
		139,
		168,
		173,
		167,
		176,
		-1,
		142,
		138,
		134,
		141,
		90,
		-1,
		-1,
		130,
		-1,
		144,
		143,
		118,
		136,
		139,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		109,
		120,
		115,
		114,
		132,
		147,
		160,
		164,
		170,
		-1,
		192,
		-1,
		134,
		118,
		120,
		92,
		113,
		-1,
		150,
		145,
		135,
		120,
		111,
		-1,
		114,
		117,
		124,
		102,
		87,
		104,
		96,
		94,
		99,
		104,
		118,
		109,
		127,
		134,
		142,
		146,
		166,
		178,
		152,
		142,
		-1,
		124,
		129,
		88,
		96,
		115,
		153,
		117,
		-1,
		112,
		-1,
		104,
		129,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		103,
		100,
		97,
		115,
		118,
		135,
		139,
		155,
		-1,
		-1,
		137,
		141,
		130,
		81,
		100,
		124,
		161,
		110,
		99,
		98,
		-1,
		89,
		119,
		116,
		102,
		89,
		79,
		80,
		88,
		101,
		80,
		99,
		102,
		124,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		107,
		78,
		102,
		144,
		128,
		121,
		109,
		74,
		74,
		68,
		-1,
		109,
		92,
		88,
		77,
		75,
		88,
		83,
		99,
		103,
		102,
		121,
		133,
		124,
		144,
		-1,
		-1,
		-1,
		137,
		126,
		127,
		73,
		96,
		133,
		107,
		93,
		98,
		73,
		66,
		60,
		112,
		109,
		76,
		84,
		76,
		65,
		79,
		87,
		91,
		100,
		109,
		115,
		139,
		139,
		145,
		-1,
		-1,
		144,
		134,
		118,
		120,
		117,
		87,
		94,
		126,
		98,
		111,
		-1,
		65,
		-1,
		54,
		62,
		61,
		67,
		79,
		65,
		70,
		81,
		93,
		106,
		102,
		109,
		144,
		144,
		129,
		149,
		152,
		-1,
		-1,
		-1,
		137,
		132,
		107,
		84,
		68,
		104,
		-1,
		81,
		82,
		-1,
		59,
		53,
		59,
		58,
		65,
		62,
		62,
		76,
		84,
		80,
		96,
		102,
		94,
		130,
		-1,
		137,
		131,
		139,
		129,
		117,
		-1,
		-1,
		-1,
		130,
		109,
		102,
		122,
		63,
		115,
		-1,
		-1,
		66,
		59,
		-1,
		46,
		46,
		53,
		62,
		67,
		72,
		80,
		75,
		88,
		93,
		99,
		104,
		122,
		126,
		130,
		119,
		115,
		112,
		126,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		83,
		-1,
		75,
		67,
		57,
		51,
		45,
		56,
		57,
		77,
		69,
		83,
		83,
		89,
		97,
		82,
		85,
		101,
		99,
		117,
		125,
		117,
		111,
		110,
		122,
		-1,
		150,
		136,
		107,
		-1,
		-1,
		96,
		-1,
		60,
		74,
		90,
		-1,
		83,
		62,
		77,
		55,
		59,
		65,
		103,
		104,
		82,
		87,
		95,
		105,
		107,
		96,
		107,
		99,
		121,
		121,
		105,
		106,
		115,
		-1,
		156,
		143,
		101,
		97,
		86,
		106,
		57,
		45,
		77,
		-1,
		-1,
		83,
		-1,
		37,
		39,
		79,
		77,
		93,
		84,
		90,
		106,
		109,
		111,
		101,
		90,
		96,
		93,
		115,
		101,
		99,
		118,
		134,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		72,
		59,
		53,
		-1,
		94,
		-1,
		61,
		49,
		36,
		18,
		58,
		-1,
		101,
		85,
		90,
		-1,
		136,
		-1,
		109,
		111,
		105,
		90,
		87,
		98,
		96,
		107,
		124,
		-1,
		106,
		91,
		84,
		74,
		88,
		59,
		-1,
		114,
		-1,
		-1,
		48,
		42,
		42,
		11,
		8,
		117,
		97,
		91,
		90,
		131,
		119,
		117,
		103,
		96,
		93,
		90,
		103,
		123,
		114,
		126,
		-1,
		-1,
		-1,
		111,
		97,
		101,
		61,
		80,
		-1,
		-1,
		109,
		65,
		51,
		-1,
		0,
		114,
		104,
		112,
		102,
		119,
		120,
		110,
		108,
		101,
		103,
		101,
		99,
		104,
		125,
		126,
		139,
		-1,
		-1,
		94,
		99,
		87,
		73,
		92,
		-1,
		-1,
		-1,
		55,
		71,
		32,
		3,
		102,
		-1,
		-1,
		114,
		111,
		105,
		108,
		96,
		116,
		123,
		114,
		98,
		113,
		125,
		133,
		138,
		-1,
		97,
		84,
		-1,
		-1,
		95,
		89,
		-1,
		-1,
		-1,
		-1,
		57,
		23,
		35,
		56,
		81,
		117,
		-1,
		91,
		102,
		95,
		114,
		121,
		116,
		111,
		105,
		108,
		126,
		143,
		-1,
		-1,
		109,
		-1,
		104,
		-1,
		-1,
		-1,
		-1,
		14,
		28,
		49,
		55,
		67,
		-1,
		93,
		95,
		92,
		104,
		115,
		120,
		117,
		109,
		114,
		111,
		124,
		138,
		142,
		132,
		-1,
		105,
		-1,
		-1,
		-1,
		32,
		47,
		109,
		86,
		59,
		64,
		74,
		79,
		84,
		104,
		110,
		121,
		106,
		110,
		113,
		117,
		116,
		133,
		143,
		-1,
		-1,
		103,
		93,
		58,
		40,
		44,
		136,
		-1,
		-1,
		74,
		80,
		76,
		86,
		94,
		97,
		102,
		104,
		122,
		129,
		117,
		126,
		144,
		148,
		-1,
		-1,
		-1,
		119,
		-1,
		91,
		-1,
		-1,
		59,
		160,
		107,
		89,
		85,
		83,
		88,
		97,
		92,
		97,
		122,
		117,
		126,
		119,
		130,
		153,
		142,
		180,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		148,
		110,
		125,
		144,
		79,
		86,
		122,
		119,
		-1,
		89,
		126,
		98,
		105,
		97,
		110,
		115,
		121,
		120,
		127,
		143,
		142,
		137,
		172,
		164,
		170,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		148,
		127,
		130,
		120,
		96,
		-1,
		-1,
		138,
		135,
		113,
		107,
		111,
		104,
		99,
		137,
		113,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		142,
		223,
		216,
		199,
		207,
		238,
		-1,
		138,
		130,
		134,
		116,
		107,
		-1,
		-1,
		111,
		108,
		113,
		114,
		111,
		123,
		122,
		133,
		130,
		136,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		156,
		199,
		193,
		196,
		220,
		234,
		-1,
		135,
		-1,
		-1,
		147,
		120,
		126,
		116,
		110,
		160,
		128,
		123,
		125,
		127,
		131,
		122,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		191,
		179,
		187,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		163,
		-1,
		153,
		-1,
		128,
		132,
		136,
		139,
		150,
		137,
		135,
		138,
		151,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		230,
		186,
		187,
		178,
		211,
		226,
		230,
		-1,
		147,
		186,
		201,
		-1,
		172,
		-1,
		-1,
		-1,
		142,
		149,
		141,
		157,
		149,
		149,
		129,
		133,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		162,
		153,
		180,
		208,
		197,
		192,
		179,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		156,
		150,
		133,
		135,
		139,
		144,
		159,
		162,
		152,
		150,
		144,
		176,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		165,
		181,
		194,
		198,
		214,
		239,
		-1,
		182,
		-1,
		-1,
		186,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		147,
		158,
		170,
		158,
		159,
		149,
		159,
		172,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		190,
		188,
		177,
		-1,
		167,
		140,
		145,
		170,
		177,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		-1,
		223,
		208,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		162,
		162,
		165,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		240,
		226,
		219,
		207,
		205,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		211,
		230,
		-1,
		231,
		220,
		205,
		197,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		193,
		194,
		199,
		-1,
		215,
		-1,
		233,
		-1,
		200,
		206,
		194,
		-1,
		-1,
		-1,
		193,
		156,
		173,
		187,
		192,
		190,
		181,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		233,
		207,
		240,
		231,
		214,
		194,
		186,
		205,
		-1,
		175,
		-1,
		150,
		153,
		178,
		186,
		203,
		197,
		170,
		185,
		175,
		166,
		175,
		239,
		-1,
		209,
		242,
		206,
		200,
		176,
		180,
		196,
		-1,
		172,
		154,
		-1,
		182,
		172,
		219,
		195,
		185,
		172,
		179,
		179,
		172,
		-1,
		-1,
		-1,
		211,
		210,
		202,
		196,
		196,
		181,
		172,
		-1,
		184,
		166,
		145,
		162,
		162,
		153,
		161,
		209,
		205,
		192,
		192,
		184,
		-1,
		312,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		205,
		200,
		173,
		161,
		167,
		163,
		149,
		155,
		157,
		165,
		163,
		160,
		172,
		168,
		188,
		184,
		216,
		-1,
		307,
		-1,
		241,
		-1,
		-1,
		223,
		203,
		195,
		184,
		173,
		171,
		162,
		153,
		175,
		191,
		175,
		173,
		178,
		183,
		-1,
		296,
		295,
		-1,
		242,
		234,
		220,
		-1,
		213,
		-1,
		219,
		180,
		-1,
		182,
		162,
		-1,
		184,
		180,
		-1,
		-1,
		283,
		258,
		-1,
		-1,
		-1,
		243,
		223,
		214,
		198,
		-1,
		173,
		173,
		-1,
		-1,
		-1,
		268,
		267,
		-1,
		236,
		239,
		-1,
		229,
		220,
		228,
		175,
		179,
		-1,
		-1,
		-1,
		277,
		258,
		252,
		251,
		249,
		244,
		241,
		227,
		211,
		189,
		178,
		199,
		-1,
		-1,
		-1,
		249,
		241,
		234,
		-1,
		-1,
		236,
		219,
		200,
		198,
		-1,
		-1,
		-1,
		271,
		252,
		-1,
		-1,
		226,
		-1,
		-1,
		232,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		260,
		-1,
		-1,
		-1,
		222,
		218,
		219,
		-1,
		-1,
		-1,
		-1,
		282,
		283,
		306,
		270,
		-1,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		285,
		283,
		-1,
		-1,
		-1,
		242,
		226,
		-1,
		212,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		247,
		-1,
		247,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		260,
		252,
		260,
		-1,
		232,
		234,
		-1,
		282,
		-1,
		-1,
		275,
		266,
		-1,
		-1,
		237,
		244,
		266,
		269,
		305,
		-1,
		256
	],
	[
		-1,
		225,
		214,
		225,
		233,
		206,
		213,
		-1,
		234,
		236,
		202,
		196,
		235,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		225,
		224,
		194,
		192,
		201,
		206,
		213,
		-1,
		217,
		-1,
		246,
		225,
		236,
		241,
		187,
		184,
		204,
		223,
		210,
		202,
		261,
		217,
		188,
		182,
		200,
		195,
		204,
		196,
		-1,
		188,
		178,
		200,
		184,
		195,
		187,
		-1,
		-1,
		182,
		183,
		189,
		180,
		186,
		182,
		-1,
		192,
		176,
		-1,
		-1,
		172,
		178,
		162,
		165,
		173,
		171,
		184,
		176,
		171,
		-1,
		-1,
		168,
		164,
		171,
		158,
		154,
		171,
		184,
		166,
		180,
		179,
		-1,
		161,
		179,
		188,
		165,
		163,
		147,
		145,
		163,
		165,
		171,
		174,
		-1,
		170,
		171,
		166,
		174,
		179,
		163,
		150,
		150,
		160,
		153,
		172,
		163,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		170,
		153,
		170,
		162,
		152,
		167,
		160,
		153,
		150,
		148,
		145,
		161,
		162,
		172,
		-1,
		-1,
		249,
		218,
		253,
		210,
		195,
		-1,
		166,
		146,
		152,
		156,
		150,
		143,
		157,
		153,
		-1,
		139,
		138,
		169,
		155,
		166,
		209,
		-1,
		-1,
		207,
		199,
		184,
		187,
		176,
		172,
		161,
		160,
		152,
		138,
		134,
		140,
		143,
		143,
		149,
		133,
		143,
		147,
		157,
		173,
		-1,
		-1,
		219,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		179,
		188,
		174,
		195,
		171,
		162,
		154,
		148,
		136,
		138,
		135,
		148,
		136,
		130,
		155,
		159,
		152,
		173,
		168,
		-1,
		218,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		208,
		-1,
		183,
		171,
		172,
		157,
		154,
		141,
		129,
		142,
		127,
		134,
		133,
		137,
		139,
		172,
		149,
		171,
		168,
		189,
		194,
		188,
		197,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		216,
		215,
		190,
		168,
		171,
		158,
		149,
		136,
		125,
		136,
		125,
		122,
		130,
		138,
		150,
		144,
		143,
		161,
		173,
		181,
		185,
		191,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		217,
		207,
		192,
		183,
		-1,
		167,
		164,
		154,
		132,
		117,
		134,
		126,
		124,
		129,
		133,
		147,
		138,
		156,
		163,
		163,
		167,
		187,
		199,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		169,
		182,
		-1,
		138,
		134,
		116,
		117,
		112,
		127,
		132,
		129,
		126,
		144,
		147,
		156,
		160,
		176,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		152,
		149,
		137,
		124,
		109,
		110,
		118,
		130,
		109,
		128,
		127,
		147,
		173,
		151,
		163,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		148,
		127,
		118,
		107,
		105,
		118,
		110,
		128,
		125,
		123,
		142,
		154,
		145,
		165,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		158,
		144,
		122,
		114,
		106,
		95,
		106,
		114,
		118,
		121,
		130,
		136,
		160,
		154,
		160,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		117,
		115,
		108,
		111,
		92,
		97,
		111,
		120,
		128,
		123,
		130,
		165,
		165,
		144,
		164,
		167,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		120,
		112,
		113,
		96,
		96,
		97,
		111,
		95,
		114,
		116,
		115,
		149,
		-1,
		152,
		146,
		154,
		144,
		132,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		94,
		86,
		80,
		89,
		82,
		89,
		102,
		107,
		120,
		118,
		137,
		141,
		145,
		134,
		130,
		127,
		141,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		111,
		109,
		108,
		92,
		95,
		90,
		87,
		93,
		96,
		99,
		115,
		114,
		132,
		140,
		132,
		126,
		125,
		137,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		121,
		106,
		98,
		99,
		69,
		74,
		83,
		93,
		97,
		110,
		122,
		114,
		136,
		136,
		120,
		121,
		130,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		183,
		-1,
		125,
		139,
		120,
		118,
		88,
		62,
		69,
		94,
		91,
		86,
		109,
		104,
		106,
		108,
		130,
		116,
		114,
		133,
		149,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		161,
		149,
		136,
		118,
		158,
		-1,
		59,
		55,
		64,
		-1,
		111,
		-1,
		83,
		96,
		96,
		98,
		102,
		113,
		111,
		122,
		139,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		148,
		142,
		142,
		111,
		108,
		75,
		55,
		45,
		64,
		94,
		81,
		80,
		86,
		91,
		95,
		105,
		118,
		138,
		129,
		141,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		209,
		165,
		151,
		-1,
		103,
		0,
		12,
		21,
		33,
		81,
		82,
		72,
		77,
		86,
		98,
		103,
		114,
		119,
		140,
		140,
		154,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		155,
		156,
		122,
		101,
		11,
		-1,
		-1,
		57,
		57,
		67,
		73,
		88,
		102,
		109,
		124,
		113,
		128,
		140,
		148,
		152,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		134,
		79,
		68,
		57,
		88,
		61,
		-1,
		67,
		68,
		86,
		98,
		105,
		126,
		120,
		114,
		123,
		140,
		157,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		91,
		85,
		56,
		62,
		74,
		-1,
		76,
		76,
		88,
		99,
		111,
		116,
		124,
		108,
		122,
		125,
		138,
		152,
		156,
		204,
		-1,
		182,
		-1,
		-1,
		-1,
		109,
		124,
		116,
		93,
		66,
		71,
		81,
		75,
		80,
		100,
		106,
		117,
		102,
		106,
		121,
		131,
		130,
		147,
		157,
		-1,
		-1,
		180,
		170,
		135,
		117,
		121,
		143,
		-1,
		-1,
		81,
		87,
		79,
		82,
		90,
		93,
		98,
		100,
		118,
		137,
		125,
		140,
		155,
		151,
		-1,
		-1,
		-1,
		196,
		-1,
		168,
		-1,
		-1,
		136,
		167,
		114,
		96,
		92,
		90,
		84,
		93,
		88,
		93,
		118,
		113,
		122,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		156,
		163,
		129,
		126,
		-1,
		96,
		122,
		94,
		101,
		93,
		106,
		111,
		117,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		145,
		142,
		119,
		103,
		107,
		100,
		95,
		133,
		109,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		214,
		267,
		260,
		228,
		236,
		267,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		118,
		115,
		120,
		110,
		107,
		119,
		118,
		129,
		131,
		136,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		223,
		243,
		222,
		225,
		249,
		263,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		117,
		167,
		124,
		119,
		121,
		123,
		127,
		118,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		212,
		223,
		216,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		135,
		139,
		132,
		135,
		146,
		133,
		131,
		139,
		147,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		177,
		216,
		231,
		-1,
		202,
		-1,
		-1,
		-1,
		149,
		145,
		137,
		153,
		145,
		145,
		125,
		129,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		192,
		183,
		210,
		236,
		227,
		222,
		209,
		-1,
		-1,
		172,
		155,
		-1,
		-1,
		152,
		146,
		129,
		131,
		135,
		145,
		160,
		163,
		153,
		151,
		145,
		177,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		211,
		206,
		210,
		226,
		251,
		-1,
		212,
		-1,
		-1,
		193,
		-1,
		-1,
		188,
		151,
		140,
		131,
		137,
		143,
		154,
		171,
		159,
		160,
		150,
		160,
		173,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		228,
		209,
		-1,
		-1,
		186,
		184,
		173,
		-1,
		163,
		136,
		141,
		166,
		173,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		-1,
		219,
		215,
		-1,
		-1,
		181,
		174,
		162,
		150,
		140,
		150,
		158,
		158,
		161,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		236,
		222,
		215,
		203,
		201,
		-1,
		215,
		199,
		180,
		-1,
		150,
		163,
		194,
		162,
		167,
		162,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		218,
		228,
		-1,
		227,
		216,
		201,
		193,
		-1,
		-1,
		187,
		183,
		-1,
		-1,
		151,
		176,
		165,
		173,
		168,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		200,
		201,
		206,
		-1,
		211,
		-1,
		229,
		-1,
		196,
		202,
		190,
		-1,
		-1,
		-1,
		189,
		152,
		169,
		183,
		188,
		186,
		177,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		229,
		203,
		236,
		227,
		210,
		190,
		182,
		201,
		-1,
		171,
		-1,
		146,
		149,
		174,
		182,
		199,
		193,
		171,
		186,
		176,
		167,
		176,
		235,
		-1,
		205,
		238,
		202,
		196,
		172,
		176,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		216,
		191,
		186,
		173,
		180,
		180,
		173,
		-1,
		-1,
		-1,
		207,
		206,
		198,
		192,
		192,
		177,
		168,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		206,
		202,
		193,
		193,
		181,
		-1,
		308,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		201,
		196,
		169,
		157,
		163,
		159,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		180,
		212,
		-1,
		303,
		-1,
		237,
		-1,
		-1,
		219,
		199,
		191,
		180,
		169,
		167,
		158,
		149,
		171,
		187,
		171,
		169,
		174,
		179,
		-1,
		292,
		291,
		-1,
		238,
		230,
		216,
		-1,
		209,
		-1,
		215,
		176,
		-1,
		178,
		158,
		-1,
		180,
		176,
		-1,
		-1,
		279,
		254,
		-1,
		-1,
		-1,
		239,
		219,
		210,
		194,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		264,
		263,
		-1,
		232,
		235,
		-1,
		225,
		216,
		224,
		171,
		175,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		247,
		245,
		240,
		237,
		223,
		207,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		245,
		237,
		230,
		-1,
		-1,
		232,
		215,
		196,
		194,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		222,
		-1,
		-1,
		228,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		256,
		-1,
		-1,
		-1,
		218,
		214,
		215,
		-1,
		-1,
		-1,
		-1,
		278,
		279,
		302,
		266,
		-1,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		281,
		279,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		208,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		256,
		248,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		271,
		262,
		-1,
		-1,
		233,
		240,
		262,
		265,
		301,
		-1,
		252
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		222,
		224,
		190,
		184,
		223,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		213,
		212,
		182,
		180,
		189,
		194,
		201,
		-1,
		205,
		-1,
		234,
		213,
		224,
		229,
		175,
		172,
		192,
		211,
		198,
		190,
		249,
		205,
		176,
		170,
		188,
		183,
		192,
		184,
		-1,
		176,
		166,
		188,
		172,
		183,
		175,
		-1,
		-1,
		170,
		171,
		177,
		168,
		174,
		170,
		-1,
		180,
		164,
		-1,
		-1,
		160,
		166,
		150,
		153,
		161,
		159,
		172,
		164,
		159,
		-1,
		-1,
		156,
		152,
		159,
		146,
		142,
		159,
		172,
		154,
		168,
		167,
		-1,
		149,
		167,
		176,
		153,
		151,
		135,
		133,
		151,
		153,
		159,
		162,
		-1,
		158,
		159,
		154,
		162,
		167,
		151,
		138,
		138,
		148,
		141,
		160,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		158,
		141,
		158,
		150,
		140,
		155,
		148,
		141,
		138,
		136,
		133,
		149,
		150,
		160,
		-1,
		-1,
		237,
		206,
		241,
		198,
		183,
		-1,
		154,
		134,
		140,
		144,
		138,
		131,
		145,
		141,
		-1,
		127,
		126,
		157,
		143,
		154,
		197,
		-1,
		-1,
		195,
		187,
		172,
		175,
		164,
		160,
		149,
		148,
		140,
		126,
		122,
		128,
		131,
		131,
		137,
		121,
		131,
		135,
		145,
		161,
		-1,
		-1,
		207,
		-1,
		-1,
		194,
		177,
		-1,
		160,
		167,
		167,
		176,
		162,
		183,
		159,
		150,
		142,
		136,
		124,
		126,
		123,
		136,
		124,
		118,
		143,
		147,
		140,
		161,
		156,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		153,
		156,
		162,
		186,
		196,
		-1,
		171,
		159,
		160,
		145,
		142,
		129,
		117,
		130,
		115,
		122,
		121,
		125,
		127,
		160,
		137,
		159,
		156,
		177,
		182,
		176,
		185,
		-1,
		202,
		198,
		194,
		201,
		150,
		-1,
		-1,
		190,
		-1,
		204,
		203,
		178,
		156,
		159,
		146,
		137,
		124,
		113,
		124,
		113,
		110,
		118,
		126,
		138,
		132,
		131,
		149,
		161,
		169,
		173,
		179,
		-1,
		252,
		-1,
		194,
		178,
		180,
		152,
		173,
		-1,
		210,
		205,
		195,
		180,
		171,
		-1,
		155,
		152,
		142,
		120,
		105,
		122,
		114,
		112,
		117,
		121,
		135,
		126,
		144,
		151,
		151,
		155,
		175,
		187,
		212,
		202,
		-1,
		184,
		189,
		148,
		156,
		175,
		213,
		177,
		-1,
		172,
		-1,
		157,
		170,
		-1,
		126,
		122,
		104,
		105,
		100,
		115,
		120,
		117,
		114,
		132,
		135,
		144,
		148,
		164,
		-1,
		-1,
		197,
		201,
		190,
		141,
		160,
		184,
		221,
		170,
		159,
		158,
		-1,
		149,
		140,
		137,
		125,
		112,
		97,
		98,
		106,
		118,
		97,
		116,
		115,
		135,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		167,
		138,
		162,
		204,
		188,
		181,
		169,
		134,
		134,
		128,
		-1,
		136,
		115,
		106,
		95,
		93,
		106,
		98,
		116,
		113,
		111,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		197,
		186,
		187,
		133,
		156,
		193,
		167,
		153,
		158,
		133,
		126,
		120,
		146,
		132,
		110,
		102,
		94,
		83,
		94,
		102,
		106,
		109,
		118,
		124,
		148,
		142,
		148,
		-1,
		-1,
		204,
		194,
		178,
		180,
		177,
		147,
		154,
		186,
		158,
		171,
		-1,
		125,
		-1,
		114,
		105,
		103,
		96,
		99,
		80,
		85,
		99,
		108,
		116,
		111,
		118,
		153,
		153,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		197,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		119,
		113,
		108,
		100,
		101,
		84,
		84,
		85,
		99,
		83,
		102,
		104,
		103,
		137,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		82,
		74,
		68,
		77,
		70,
		77,
		90,
		95,
		108,
		106,
		125,
		129,
		133,
		122,
		118,
		115,
		129,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		99,
		97,
		96,
		80,
		83,
		78,
		75,
		81,
		84,
		87,
		103,
		102,
		120,
		128,
		120,
		114,
		113,
		125,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		109,
		94,
		86,
		87,
		57,
		62,
		71,
		81,
		85,
		98,
		110,
		102,
		124,
		124,
		108,
		109,
		118,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		173,
		-1,
		113,
		129,
		108,
		106,
		76,
		50,
		57,
		82,
		79,
		74,
		97,
		92,
		94,
		96,
		118,
		104,
		102,
		121,
		137,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		151,
		139,
		126,
		108,
		148,
		-1,
		47,
		43,
		52,
		-1,
		99,
		-1,
		71,
		84,
		84,
		86,
		90,
		101,
		99,
		110,
		127,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		138,
		132,
		132,
		101,
		98,
		63,
		43,
		33,
		52,
		82,
		69,
		68,
		74,
		79,
		83,
		93,
		106,
		126,
		117,
		129,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		199,
		155,
		141,
		-1,
		93,
		12,
		0,
		9,
		21,
		69,
		70,
		60,
		65,
		74,
		86,
		91,
		102,
		107,
		128,
		128,
		142,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		145,
		146,
		112,
		91,
		1,
		-1,
		-1,
		45,
		45,
		55,
		61,
		76,
		90,
		97,
		112,
		101,
		116,
		128,
		136,
		140,
		-1,
		157,
		144,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		124,
		69,
		58,
		47,
		78,
		49,
		-1,
		55,
		56,
		74,
		86,
		93,
		114,
		108,
		102,
		111,
		128,
		145,
		-1,
		-1,
		169,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		81,
		75,
		46,
		52,
		64,
		-1,
		64,
		64,
		76,
		87,
		99,
		104,
		112,
		96,
		110,
		113,
		126,
		140,
		144,
		192,
		-1,
		172,
		-1,
		-1,
		-1,
		99,
		114,
		106,
		83,
		56,
		61,
		69,
		63,
		68,
		88,
		94,
		105,
		90,
		94,
		109,
		119,
		118,
		135,
		145,
		-1,
		-1,
		170,
		160,
		125,
		107,
		111,
		133,
		-1,
		-1,
		71,
		76,
		67,
		70,
		78,
		81,
		86,
		88,
		106,
		125,
		113,
		128,
		143,
		139,
		-1,
		-1,
		-1,
		186,
		-1,
		158,
		-1,
		-1,
		126,
		156,
		103,
		85,
		81,
		79,
		72,
		81,
		76,
		81,
		106,
		101,
		110,
		115,
		119,
		142,
		131,
		170,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		146,
		153,
		118,
		115,
		-1,
		85,
		110,
		82,
		89,
		81,
		94,
		99,
		105,
		109,
		116,
		132,
		131,
		126,
		162,
		153,
		159,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		134,
		131,
		107,
		91,
		95,
		88,
		83,
		121,
		97,
		105,
		109,
		113,
		119,
		124,
		129,
		135,
		150,
		165,
		-1,
		202,
		256,
		249,
		217,
		225,
		256,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		107,
		104,
		109,
		98,
		95,
		107,
		106,
		117,
		119,
		124,
		112,
		111,
		129,
		133,
		142,
		149,
		139,
		152,
		156,
		-1,
		212,
		232,
		211,
		214,
		238,
		252,
		-1,
		154,
		-1,
		-1,
		166,
		138,
		122,
		112,
		106,
		156,
		112,
		107,
		109,
		111,
		115,
		106,
		129,
		120,
		120,
		123,
		138,
		143,
		135,
		149,
		149,
		150,
		-1,
		201,
		212,
		205,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		149,
		-1,
		124,
		128,
		120,
		123,
		134,
		121,
		119,
		127,
		135,
		118,
		128,
		124,
		125,
		134,
		145,
		157,
		156,
		157,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		166,
		205,
		220,
		-1,
		191,
		-1,
		-1,
		-1,
		138,
		133,
		125,
		141,
		133,
		133,
		113,
		117,
		123,
		130,
		140,
		142,
		134,
		138,
		151,
		162,
		165,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		181,
		172,
		199,
		225,
		216,
		211,
		198,
		-1,
		-1,
		161,
		143,
		-1,
		-1,
		140,
		134,
		117,
		119,
		123,
		133,
		148,
		151,
		141,
		139,
		133,
		165,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		200,
		195,
		199,
		215,
		240,
		-1,
		201,
		-1,
		-1,
		182,
		-1,
		-1,
		176,
		139,
		128,
		119,
		125,
		131,
		142,
		159,
		147,
		148,
		138,
		148,
		161,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		199,
		229,
		-1,
		-1,
		217,
		197,
		-1,
		-1,
		174,
		172,
		161,
		-1,
		151,
		124,
		129,
		154,
		161,
		156,
		150,
		144,
		151,
		150,
		158,
		166,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		-1,
		207,
		203,
		-1,
		-1,
		169,
		162,
		150,
		138,
		128,
		138,
		146,
		146,
		149,
		147,
		142,
		153,
		145,
		149,
		166,
		-1,
		242,
		-1,
		194,
		170,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		224,
		210,
		203,
		191,
		189,
		-1,
		203,
		187,
		168,
		-1,
		138,
		151,
		182,
		150,
		155,
		150,
		148,
		159,
		148,
		151,
		165,
		160,
		-1,
		-1,
		182,
		185,
		-1,
		-1,
		207,
		216,
		-1,
		215,
		204,
		189,
		181,
		-1,
		-1,
		175,
		171,
		-1,
		-1,
		139,
		164,
		153,
		161,
		156,
		152,
		158,
		161,
		150,
		154,
		166,
		-1,
		-1,
		189,
		190,
		195,
		-1,
		199,
		-1,
		217,
		-1,
		184,
		190,
		178,
		-1,
		-1,
		-1,
		177,
		140,
		157,
		171,
		176,
		174,
		165,
		156,
		163,
		161,
		157,
		168,
		-1,
		-1,
		-1,
		217,
		191,
		224,
		215,
		198,
		178,
		170,
		189,
		-1,
		159,
		-1,
		134,
		137,
		162,
		170,
		187,
		181,
		159,
		174,
		164,
		155,
		164,
		223,
		-1,
		193,
		226,
		190,
		184,
		160,
		164,
		180,
		-1,
		156,
		138,
		-1,
		166,
		156,
		204,
		179,
		174,
		161,
		168,
		168,
		161,
		-1,
		-1,
		-1,
		195,
		194,
		186,
		180,
		180,
		165,
		156,
		-1,
		168,
		150,
		129,
		146,
		146,
		137,
		145,
		194,
		190,
		181,
		181,
		169,
		-1,
		296,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		189,
		184,
		157,
		145,
		151,
		147,
		133,
		139,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		168,
		200,
		-1,
		291,
		-1,
		225,
		-1,
		-1,
		207,
		187,
		179,
		168,
		157,
		155,
		146,
		137,
		159,
		175,
		159,
		157,
		162,
		167,
		-1,
		280,
		279,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		203,
		164,
		-1,
		166,
		146,
		-1,
		168,
		164,
		-1,
		-1,
		267,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		198,
		182,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		252,
		251,
		-1,
		220,
		223,
		-1,
		213,
		204,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		261,
		242,
		236,
		235,
		233,
		228,
		225,
		211,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		233,
		225,
		218,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		255,
		236,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		244,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		290,
		254,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		204,
		193,
		204,
		212,
		185,
		192,
		-1,
		213,
		215,
		181,
		175,
		214,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		204,
		203,
		173,
		171,
		180,
		185,
		192,
		-1,
		196,
		-1,
		225,
		204,
		215,
		220,
		166,
		163,
		183,
		202,
		189,
		181,
		240,
		196,
		167,
		161,
		179,
		174,
		183,
		175,
		-1,
		167,
		157,
		179,
		163,
		174,
		166,
		-1,
		-1,
		161,
		162,
		168,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		151,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		140,
		158,
		167,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		153,
		-1,
		149,
		150,
		145,
		153,
		158,
		142,
		129,
		129,
		139,
		132,
		151,
		142,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		149,
		132,
		149,
		141,
		131,
		146,
		139,
		132,
		129,
		127,
		124,
		140,
		141,
		151,
		-1,
		-1,
		228,
		197,
		232,
		189,
		174,
		-1,
		145,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		118,
		117,
		148,
		134,
		145,
		188,
		-1,
		-1,
		186,
		178,
		163,
		166,
		155,
		151,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		112,
		122,
		126,
		136,
		152,
		-1,
		-1,
		198,
		-1,
		-1,
		185,
		168,
		-1,
		151,
		158,
		158,
		167,
		153,
		174,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		109,
		134,
		138,
		131,
		152,
		147,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		144,
		147,
		153,
		177,
		187,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		116,
		118,
		151,
		128,
		150,
		147,
		168,
		173,
		167,
		176,
		-1,
		193,
		189,
		185,
		192,
		141,
		-1,
		-1,
		181,
		-1,
		195,
		194,
		169,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		117,
		129,
		123,
		122,
		140,
		152,
		160,
		164,
		170,
		-1,
		243,
		-1,
		185,
		169,
		171,
		143,
		164,
		-1,
		201,
		196,
		186,
		171,
		162,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		105,
		103,
		108,
		112,
		126,
		117,
		135,
		142,
		142,
		146,
		166,
		178,
		203,
		193,
		-1,
		175,
		180,
		139,
		147,
		166,
		204,
		168,
		-1,
		163,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		111,
		108,
		105,
		123,
		126,
		135,
		139,
		155,
		-1,
		-1,
		188,
		192,
		181,
		132,
		151,
		175,
		212,
		161,
		150,
		149,
		-1,
		140,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		109,
		88,
		107,
		106,
		126,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		158,
		129,
		153,
		195,
		179,
		172,
		160,
		125,
		125,
		119,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		89,
		107,
		104,
		102,
		121,
		133,
		124,
		144,
		-1,
		-1,
		-1,
		188,
		177,
		178,
		124,
		147,
		184,
		158,
		144,
		149,
		124,
		117,
		111,
		137,
		123,
		101,
		93,
		85,
		74,
		85,
		93,
		97,
		100,
		109,
		115,
		139,
		133,
		139,
		-1,
		-1,
		195,
		185,
		169,
		171,
		168,
		138,
		145,
		177,
		149,
		162,
		-1,
		116,
		-1,
		105,
		96,
		94,
		87,
		90,
		71,
		76,
		90,
		99,
		107,
		102,
		109,
		144,
		144,
		123,
		143,
		146,
		-1,
		-1,
		-1,
		188,
		183,
		158,
		135,
		119,
		155,
		-1,
		132,
		133,
		-1,
		110,
		104,
		99,
		91,
		92,
		75,
		75,
		76,
		90,
		74,
		93,
		95,
		94,
		128,
		-1,
		131,
		125,
		133,
		123,
		111,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		114,
		166,
		-1,
		-1,
		117,
		110,
		-1,
		97,
		79,
		73,
		65,
		59,
		68,
		61,
		68,
		81,
		86,
		99,
		97,
		116,
		120,
		124,
		113,
		109,
		106,
		120,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		134,
		-1,
		126,
		118,
		108,
		102,
		96,
		90,
		88,
		87,
		71,
		74,
		69,
		66,
		72,
		75,
		78,
		94,
		93,
		111,
		119,
		111,
		105,
		104,
		116,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		147,
		-1,
		111,
		125,
		141,
		-1,
		134,
		113,
		128,
		106,
		100,
		85,
		77,
		78,
		48,
		53,
		62,
		72,
		76,
		89,
		101,
		93,
		115,
		115,
		99,
		100,
		109,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		108,
		96,
		128,
		-1,
		-1,
		170,
		-1,
		104,
		121,
		99,
		97,
		67,
		41,
		48,
		73,
		70,
		65,
		88,
		83,
		85,
		87,
		109,
		95,
		93,
		112,
		128,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		148,
		138,
		122,
		107,
		140,
		-1,
		38,
		34,
		43,
		-1,
		90,
		-1,
		62,
		75,
		75,
		77,
		81,
		92,
		90,
		101,
		118,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		165,
		-1,
		-1,
		135,
		129,
		129,
		111,
		108,
		54,
		34,
		24,
		43,
		73,
		60,
		59,
		65,
		70,
		74,
		84,
		97,
		117,
		108,
		120,
		-1,
		-1,
		-1,
		162,
		148,
		152,
		112,
		131,
		-1,
		-1,
		197,
		152,
		138,
		-1,
		103,
		22,
		10,
		0,
		12,
		60,
		61,
		51,
		56,
		65,
		77,
		82,
		93,
		98,
		119,
		119,
		133,
		-1,
		-1,
		145,
		150,
		138,
		124,
		143,
		-1,
		-1,
		-1,
		144,
		156,
		122,
		101,
		11,
		-1,
		-1,
		36,
		36,
		46,
		52,
		67,
		81,
		88,
		103,
		92,
		107,
		119,
		127,
		131,
		-1,
		148,
		135,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		-1,
		-1,
		134,
		79,
		68,
		57,
		88,
		40,
		-1,
		46,
		47,
		65,
		77,
		84,
		105,
		99,
		93,
		102,
		119,
		136,
		-1,
		-1,
		160,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		91,
		85,
		56,
		62,
		74,
		-1,
		55,
		55,
		67,
		78,
		90,
		95,
		103,
		87,
		101,
		104,
		117,
		131,
		135,
		183,
		-1,
		166,
		-1,
		-1,
		-1,
		109,
		124,
		116,
		93,
		66,
		67,
		60,
		54,
		59,
		79,
		85,
		96,
		81,
		85,
		100,
		110,
		109,
		126,
		136,
		-1,
		-1,
		166,
		170,
		135,
		117,
		121,
		143,
		-1,
		-1,
		76,
		67,
		58,
		61,
		69,
		72,
		77,
		79,
		97,
		116,
		104,
		119,
		134,
		130,
		-1,
		-1,
		-1,
		186,
		-1,
		168,
		-1,
		-1,
		136,
		147,
		94,
		76,
		72,
		70,
		63,
		72,
		67,
		72,
		97,
		92,
		101,
		106,
		110,
		133,
		122,
		161,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		165,
		157,
		152,
		158,
		156,
		151,
		109,
		106,
		-1,
		76,
		101,
		73,
		80,
		72,
		85,
		90,
		96,
		100,
		107,
		123,
		122,
		117,
		153,
		144,
		150,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		158,
		154,
		144,
		134,
		137,
		-1,
		-1,
		125,
		122,
		98,
		82,
		86,
		79,
		74,
		112,
		88,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		193,
		247,
		240,
		208,
		216,
		247,
		-1,
		148,
		140,
		151,
		126,
		128,
		-1,
		-1,
		98,
		95,
		100,
		89,
		86,
		98,
		97,
		108,
		110,
		115,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		145,
		-1,
		-1,
		157,
		129,
		113,
		103,
		97,
		147,
		103,
		98,
		100,
		102,
		106,
		97,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		173,
		-1,
		140,
		-1,
		115,
		119,
		111,
		114,
		125,
		112,
		110,
		118,
		126,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		157,
		196,
		211,
		-1,
		182,
		-1,
		-1,
		-1,
		129,
		124,
		116,
		132,
		124,
		124,
		104,
		108,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		172,
		163,
		190,
		216,
		207,
		202,
		189,
		-1,
		-1,
		152,
		134,
		-1,
		-1,
		131,
		125,
		108,
		110,
		114,
		124,
		139,
		142,
		132,
		130,
		124,
		156,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		191,
		186,
		190,
		206,
		231,
		-1,
		192,
		-1,
		-1,
		173,
		-1,
		-1,
		167,
		130,
		119,
		110,
		116,
		122,
		133,
		150,
		138,
		139,
		129,
		139,
		152,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		208,
		188,
		-1,
		-1,
		165,
		163,
		152,
		-1,
		142,
		115,
		120,
		145,
		152,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		194,
		-1,
		-1,
		160,
		153,
		141,
		129,
		119,
		129,
		137,
		137,
		140,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		194,
		178,
		159,
		-1,
		129,
		142,
		173,
		141,
		146,
		141,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		198,
		207,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		166,
		162,
		-1,
		-1,
		130,
		155,
		144,
		152,
		147,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		180,
		181,
		186,
		-1,
		190,
		-1,
		208,
		-1,
		175,
		181,
		169,
		-1,
		-1,
		-1,
		168,
		131,
		148,
		162,
		167,
		165,
		156,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		208,
		182,
		215,
		206,
		189,
		169,
		161,
		180,
		-1,
		150,
		-1,
		125,
		128,
		153,
		161,
		178,
		172,
		150,
		165,
		155,
		146,
		155,
		214,
		-1,
		184,
		217,
		181,
		175,
		151,
		155,
		171,
		-1,
		147,
		129,
		-1,
		157,
		147,
		195,
		170,
		165,
		152,
		159,
		159,
		152,
		-1,
		-1,
		-1,
		186,
		185,
		177,
		171,
		171,
		156,
		147,
		-1,
		159,
		141,
		120,
		137,
		137,
		128,
		136,
		185,
		181,
		172,
		172,
		160,
		-1,
		287,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		180,
		175,
		148,
		136,
		142,
		138,
		124,
		130,
		132,
		140,
		138,
		135,
		147,
		143,
		163,
		159,
		191,
		-1,
		282,
		-1,
		216,
		-1,
		-1,
		198,
		178,
		170,
		159,
		148,
		146,
		137,
		128,
		150,
		166,
		150,
		148,
		153,
		158,
		-1,
		271,
		270,
		-1,
		217,
		209,
		195,
		-1,
		188,
		-1,
		194,
		155,
		-1,
		157,
		137,
		-1,
		159,
		155,
		-1,
		-1,
		258,
		233,
		-1,
		-1,
		-1,
		218,
		198,
		189,
		173,
		-1,
		148,
		148,
		-1,
		-1,
		-1,
		243,
		242,
		-1,
		211,
		214,
		-1,
		204,
		195,
		203,
		150,
		154,
		-1,
		-1,
		-1,
		252,
		233,
		227,
		226,
		224,
		219,
		216,
		202,
		186,
		164,
		153,
		174,
		-1,
		-1,
		-1,
		224,
		216,
		209,
		-1,
		-1,
		211,
		194,
		175,
		173,
		-1,
		-1,
		-1,
		246,
		227,
		-1,
		-1,
		201,
		-1,
		-1,
		207,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		235,
		-1,
		-1,
		-1,
		197,
		193,
		194,
		-1,
		-1,
		-1,
		-1,
		257,
		258,
		281,
		245,
		-1,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		260,
		258,
		-1,
		-1,
		-1,
		217,
		201,
		-1,
		187,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		222,
		-1,
		222,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		235,
		227,
		235,
		-1,
		207,
		209,
		-1,
		257,
		-1,
		-1,
		250,
		241,
		-1,
		-1,
		212,
		219,
		241,
		244,
		280,
		-1,
		231
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		201,
		203,
		169,
		163,
		202,
		173,
		179,
		190,
		-1,
		-1,
		-1,
		192,
		191,
		161,
		159,
		168,
		173,
		180,
		-1,
		184,
		-1,
		213,
		192,
		203,
		208,
		154,
		151,
		171,
		190,
		177,
		169,
		228,
		184,
		155,
		149,
		167,
		162,
		171,
		163,
		-1,
		155,
		145,
		167,
		151,
		162,
		154,
		-1,
		-1,
		149,
		150,
		156,
		147,
		153,
		149,
		-1,
		159,
		143,
		-1,
		-1,
		139,
		145,
		129,
		132,
		140,
		138,
		151,
		143,
		138,
		-1,
		-1,
		135,
		131,
		138,
		125,
		121,
		138,
		151,
		133,
		147,
		146,
		-1,
		128,
		146,
		155,
		132,
		130,
		114,
		112,
		130,
		132,
		138,
		141,
		-1,
		137,
		138,
		133,
		141,
		146,
		130,
		117,
		117,
		127,
		120,
		139,
		130,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		137,
		120,
		137,
		129,
		119,
		134,
		127,
		120,
		117,
		115,
		112,
		128,
		129,
		139,
		-1,
		-1,
		216,
		185,
		220,
		177,
		162,
		-1,
		133,
		113,
		119,
		123,
		117,
		110,
		124,
		120,
		-1,
		106,
		105,
		136,
		122,
		133,
		176,
		-1,
		-1,
		174,
		166,
		151,
		154,
		143,
		139,
		128,
		127,
		119,
		105,
		101,
		107,
		110,
		110,
		116,
		100,
		110,
		114,
		124,
		140,
		-1,
		-1,
		186,
		-1,
		-1,
		173,
		156,
		-1,
		139,
		146,
		146,
		155,
		141,
		162,
		138,
		129,
		121,
		115,
		103,
		105,
		102,
		115,
		103,
		97,
		122,
		126,
		119,
		140,
		135,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		132,
		135,
		141,
		165,
		175,
		-1,
		150,
		138,
		139,
		124,
		121,
		108,
		96,
		109,
		94,
		101,
		100,
		104,
		106,
		139,
		116,
		138,
		135,
		156,
		161,
		155,
		164,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		169,
		-1,
		183,
		182,
		157,
		135,
		138,
		125,
		116,
		103,
		92,
		103,
		92,
		89,
		97,
		105,
		117,
		111,
		110,
		128,
		140,
		148,
		152,
		158,
		-1,
		231,
		-1,
		173,
		157,
		159,
		131,
		152,
		-1,
		189,
		184,
		174,
		159,
		150,
		-1,
		134,
		131,
		121,
		99,
		84,
		101,
		93,
		91,
		96,
		100,
		114,
		105,
		123,
		130,
		130,
		134,
		154,
		166,
		191,
		181,
		-1,
		163,
		168,
		127,
		135,
		154,
		192,
		156,
		-1,
		151,
		-1,
		136,
		149,
		-1,
		105,
		101,
		83,
		84,
		79,
		94,
		99,
		96,
		93,
		111,
		114,
		123,
		127,
		143,
		-1,
		-1,
		176,
		180,
		169,
		120,
		139,
		163,
		200,
		149,
		138,
		137,
		-1,
		128,
		119,
		116,
		104,
		91,
		76,
		77,
		85,
		97,
		76,
		95,
		94,
		114,
		140,
		118,
		130,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		146,
		117,
		141,
		183,
		167,
		160,
		148,
		113,
		113,
		107,
		-1,
		115,
		94,
		85,
		74,
		72,
		85,
		77,
		95,
		92,
		90,
		109,
		121,
		112,
		132,
		-1,
		-1,
		-1,
		176,
		165,
		166,
		112,
		135,
		172,
		146,
		132,
		137,
		112,
		105,
		99,
		125,
		111,
		89,
		81,
		73,
		62,
		73,
		81,
		85,
		88,
		97,
		103,
		127,
		121,
		127,
		-1,
		-1,
		183,
		173,
		157,
		159,
		156,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		84,
		82,
		75,
		78,
		59,
		64,
		78,
		87,
		95,
		90,
		97,
		132,
		132,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		176,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		87,
		79,
		80,
		63,
		63,
		64,
		78,
		62,
		81,
		83,
		82,
		116,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		61,
		53,
		47,
		56,
		49,
		56,
		69,
		74,
		87,
		85,
		104,
		108,
		112,
		101,
		97,
		94,
		108,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		78,
		76,
		75,
		59,
		62,
		57,
		54,
		60,
		63,
		66,
		82,
		81,
		99,
		107,
		99,
		93,
		92,
		104,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		88,
		73,
		65,
		66,
		36,
		41,
		50,
		60,
		64,
		77,
		89,
		81,
		103,
		103,
		87,
		88,
		97,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		87,
		85,
		55,
		29,
		36,
		61,
		58,
		53,
		76,
		71,
		73,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		26,
		22,
		31,
		-1,
		78,
		-1,
		50,
		63,
		63,
		65,
		69,
		80,
		78,
		89,
		106,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		42,
		22,
		12,
		31,
		61,
		48,
		47,
		53,
		58,
		62,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		32,
		20,
		10,
		0,
		48,
		49,
		39,
		44,
		53,
		65,
		70,
		81,
		86,
		107,
		107,
		121,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		132,
		111,
		21,
		-1,
		-1,
		24,
		24,
		34,
		40,
		55,
		69,
		76,
		91,
		80,
		95,
		107,
		115,
		119,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		144,
		89,
		78,
		67,
		82,
		28,
		-1,
		34,
		35,
		53,
		65,
		72,
		93,
		87,
		81,
		90,
		107,
		124,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		101,
		95,
		66,
		64,
		68,
		-1,
		43,
		43,
		55,
		66,
		78,
		83,
		91,
		75,
		89,
		92,
		105,
		119,
		123,
		171,
		-1,
		154,
		-1,
		-1,
		-1,
		119,
		134,
		110,
		87,
		60,
		55,
		48,
		42,
		47,
		67,
		73,
		84,
		69,
		73,
		88,
		98,
		97,
		114,
		124,
		-1,
		-1,
		154,
		158,
		145,
		127,
		131,
		137,
		-1,
		-1,
		64,
		55,
		46,
		49,
		57,
		60,
		65,
		67,
		85,
		104,
		92,
		107,
		122,
		118,
		-1,
		-1,
		-1,
		174,
		-1,
		176,
		-1,
		-1,
		146,
		135,
		82,
		64,
		60,
		58,
		51,
		60,
		55,
		60,
		85,
		80,
		89,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		153,
		145,
		140,
		146,
		148,
		139,
		97,
		94,
		-1,
		64,
		89,
		61,
		68,
		60,
		73,
		78,
		84,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		146,
		142,
		132,
		122,
		125,
		-1,
		-1,
		113,
		110,
		86,
		70,
		74,
		67,
		62,
		100,
		76,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		181,
		235,
		228,
		196,
		204,
		235,
		-1,
		136,
		128,
		139,
		114,
		116,
		-1,
		-1,
		86,
		83,
		88,
		77,
		74,
		86,
		85,
		96,
		98,
		103,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		191,
		211,
		190,
		193,
		217,
		231,
		-1,
		133,
		-1,
		-1,
		145,
		117,
		101,
		91,
		85,
		135,
		91,
		86,
		88,
		90,
		94,
		85,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		161,
		-1,
		128,
		-1,
		103,
		107,
		99,
		102,
		113,
		100,
		98,
		106,
		114,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		145,
		184,
		199,
		-1,
		170,
		-1,
		-1,
		-1,
		117,
		112,
		104,
		120,
		112,
		112,
		92,
		96,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		160,
		151,
		178,
		204,
		195,
		190,
		177,
		-1,
		-1,
		140,
		122,
		-1,
		-1,
		119,
		113,
		96,
		98,
		102,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		163,
		179,
		174,
		178,
		194,
		219,
		-1,
		180,
		-1,
		-1,
		161,
		-1,
		-1,
		155,
		118,
		107,
		98,
		104,
		110,
		121,
		138,
		126,
		127,
		117,
		127,
		140,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		150,
		148,
		154,
		161,
		178,
		208,
		-1,
		-1,
		196,
		176,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		108,
		133,
		140,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		186,
		182,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		125,
		125,
		128,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		221,
		-1,
		173,
		149,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		203,
		189,
		182,
		170,
		168,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		161,
		129,
		134,
		129,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		161,
		164,
		-1,
		-1,
		186,
		195,
		-1,
		194,
		183,
		168,
		160,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		143,
		132,
		140,
		135,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		168,
		169,
		174,
		-1,
		178,
		-1,
		196,
		-1,
		163,
		169,
		157,
		-1,
		-1,
		-1,
		156,
		119,
		136,
		150,
		155,
		153,
		144,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		196,
		170,
		203,
		194,
		177,
		157,
		149,
		168,
		-1,
		138,
		-1,
		113,
		116,
		141,
		149,
		166,
		160,
		138,
		153,
		143,
		134,
		143,
		202,
		-1,
		172,
		205,
		169,
		163,
		139,
		143,
		159,
		-1,
		135,
		117,
		-1,
		145,
		135,
		183,
		158,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		174,
		173,
		165,
		159,
		159,
		144,
		135,
		-1,
		147,
		129,
		108,
		125,
		125,
		116,
		124,
		173,
		169,
		160,
		160,
		148,
		-1,
		275,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		168,
		163,
		136,
		124,
		130,
		126,
		112,
		118,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		147,
		179,
		-1,
		270,
		-1,
		204,
		-1,
		-1,
		186,
		166,
		158,
		147,
		136,
		134,
		125,
		116,
		138,
		154,
		138,
		136,
		141,
		146,
		-1,
		259,
		258,
		-1,
		205,
		197,
		183,
		-1,
		176,
		-1,
		182,
		143,
		-1,
		145,
		125,
		-1,
		147,
		143,
		-1,
		-1,
		246,
		221,
		-1,
		-1,
		-1,
		206,
		186,
		177,
		161,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		231,
		230,
		-1,
		199,
		202,
		-1,
		192,
		183,
		191,
		138,
		142,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		214,
		212,
		207,
		204,
		190,
		174,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		212,
		204,
		197,
		-1,
		-1,
		199,
		182,
		163,
		161,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		189,
		-1,
		-1,
		195,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		223,
		-1,
		-1,
		-1,
		185,
		181,
		182,
		-1,
		-1,
		-1,
		-1,
		245,
		246,
		269,
		233,
		-1,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		248,
		246,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		175,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		210,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		223,
		215,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		200,
		207,
		229,
		232,
		268,
		-1,
		219
	],
	[
		-1,
		223,
		212,
		223,
		231,
		204,
		211,
		-1,
		231,
		234,
		200,
		194,
		233,
		203,
		209,
		220,
		-1,
		-1,
		-1,
		223,
		222,
		191,
		189,
		198,
		203,
		210,
		-1,
		209,
		-1,
		244,
		223,
		234,
		239,
		184,
		181,
		201,
		220,
		202,
		194,
		259,
		214,
		185,
		179,
		197,
		187,
		196,
		188,
		-1,
		185,
		175,
		197,
		176,
		187,
		179,
		-1,
		-1,
		179,
		180,
		186,
		172,
		178,
		174,
		-1,
		184,
		168,
		-1,
		-1,
		169,
		170,
		154,
		157,
		165,
		163,
		176,
		168,
		163,
		-1,
		-1,
		160,
		156,
		163,
		150,
		146,
		163,
		176,
		158,
		172,
		171,
		-1,
		159,
		177,
		186,
		157,
		155,
		139,
		137,
		155,
		157,
		163,
		163,
		-1,
		168,
		169,
		164,
		172,
		177,
		155,
		142,
		142,
		152,
		145,
		164,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		168,
		151,
		168,
		160,
		150,
		165,
		158,
		145,
		142,
		140,
		137,
		153,
		151,
		161,
		-1,
		-1,
		247,
		216,
		251,
		208,
		193,
		-1,
		164,
		144,
		150,
		154,
		148,
		141,
		155,
		151,
		-1,
		131,
		130,
		158,
		144,
		155,
		207,
		-1,
		-1,
		205,
		197,
		182,
		185,
		174,
		170,
		159,
		158,
		150,
		136,
		132,
		138,
		141,
		141,
		147,
		125,
		135,
		139,
		137,
		162,
		-1,
		-1,
		197,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		177,
		186,
		172,
		193,
		169,
		160,
		152,
		146,
		134,
		136,
		133,
		146,
		134,
		122,
		147,
		151,
		132,
		153,
		148,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		206,
		-1,
		181,
		169,
		170,
		155,
		152,
		139,
		127,
		140,
		125,
		132,
		131,
		126,
		124,
		154,
		129,
		151,
		148,
		167,
		172,
		166,
		175,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		214,
		213,
		188,
		166,
		169,
		156,
		147,
		134,
		123,
		134,
		123,
		120,
		128,
		118,
		133,
		124,
		123,
		141,
		151,
		159,
		163,
		169,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		215,
		205,
		190,
		181,
		-1,
		165,
		162,
		152,
		130,
		115,
		132,
		124,
		122,
		127,
		113,
		127,
		118,
		136,
		143,
		141,
		145,
		165,
		177,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		167,
		180,
		-1,
		136,
		132,
		114,
		115,
		110,
		125,
		124,
		109,
		106,
		124,
		127,
		134,
		138,
		154,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		150,
		147,
		135,
		122,
		107,
		108,
		116,
		128,
		107,
		108,
		105,
		125,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		146,
		125,
		116,
		105,
		103,
		116,
		108,
		123,
		103,
		101,
		120,
		132,
		123,
		135,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		156,
		142,
		120,
		112,
		104,
		93,
		104,
		112,
		116,
		99,
		108,
		114,
		138,
		123,
		129,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		115,
		113,
		106,
		109,
		90,
		95,
		109,
		116,
		106,
		101,
		108,
		143,
		143,
		113,
		133,
		136,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		118,
		110,
		111,
		94,
		94,
		95,
		109,
		93,
		110,
		106,
		93,
		118,
		-1,
		121,
		115,
		123,
		113,
		101,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		92,
		84,
		78,
		87,
		80,
		87,
		100,
		98,
		98,
		93,
		106,
		110,
		114,
		103,
		99,
		96,
		110,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		109,
		107,
		106,
		90,
		93,
		88,
		85,
		75,
		87,
		80,
		96,
		83,
		101,
		109,
		101,
		95,
		94,
		106,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		119,
		104,
		97,
		98,
		68,
		73,
		75,
		63,
		66,
		80,
		91,
		83,
		105,
		105,
		89,
		90,
		99,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		118,
		116,
		87,
		62,
		69,
		87,
		60,
		55,
		78,
		75,
		75,
		77,
		99,
		85,
		83,
		102,
		118,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		61,
		57,
		64,
		-1,
		80,
		-1,
		52,
		65,
		65,
		67,
		71,
		82,
		80,
		91,
		108,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		128,
		125,
		77,
		57,
		49,
		64,
		63,
		50,
		49,
		55,
		60,
		64,
		74,
		87,
		107,
		98,
		110,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		120,
		77,
		65,
		55,
		45,
		0,
		51,
		41,
		46,
		55,
		67,
		72,
		83,
		88,
		109,
		109,
		123,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		173,
		139,
		118,
		66,
		-1,
		-1,
		49,
		34,
		33,
		38,
		53,
		67,
		74,
		93,
		82,
		97,
		109,
		117,
		121,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		151,
		96,
		85,
		80,
		84,
		48,
		-1,
		36,
		33,
		51,
		63,
		70,
		95,
		89,
		83,
		92,
		109,
		126,
		-1,
		-1,
		179,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		73,
		66,
		70,
		-1,
		45,
		41,
		55,
		64,
		80,
		85,
		93,
		77,
		91,
		94,
		107,
		121,
		125,
		202,
		-1,
		166,
		-1,
		-1,
		-1,
		126,
		141,
		112,
		89,
		62,
		57,
		50,
		44,
		49,
		69,
		75,
		86,
		71,
		75,
		90,
		100,
		99,
		116,
		126,
		-1,
		-1,
		164,
		160,
		152,
		134,
		138,
		139,
		-1,
		-1,
		66,
		57,
		48,
		51,
		59,
		62,
		67,
		69,
		87,
		106,
		94,
		109,
		124,
		120,
		-1,
		-1,
		-1,
		176,
		-1,
		178,
		-1,
		-1,
		153,
		137,
		84,
		66,
		62,
		60,
		53,
		62,
		57,
		62,
		87,
		82,
		91,
		96,
		100,
		123,
		112,
		151,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		155,
		147,
		142,
		148,
		150,
		141,
		99,
		96,
		-1,
		66,
		91,
		63,
		70,
		62,
		75,
		80,
		86,
		90,
		97,
		113,
		112,
		107,
		143,
		134,
		140,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		148,
		144,
		134,
		124,
		127,
		-1,
		-1,
		115,
		112,
		88,
		72,
		76,
		69,
		64,
		102,
		78,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		138,
		130,
		141,
		116,
		118,
		-1,
		-1,
		88,
		85,
		90,
		79,
		76,
		88,
		87,
		98,
		100,
		105,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		135,
		-1,
		-1,
		147,
		119,
		103,
		93,
		87,
		137,
		93,
		88,
		90,
		92,
		96,
		87,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		163,
		-1,
		130,
		-1,
		105,
		109,
		101,
		104,
		115,
		102,
		100,
		108,
		116,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		147,
		186,
		201,
		-1,
		172,
		-1,
		-1,
		-1,
		119,
		114,
		106,
		122,
		114,
		114,
		94,
		98,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		162,
		153,
		180,
		206,
		197,
		192,
		179,
		-1,
		-1,
		142,
		124,
		-1,
		-1,
		121,
		115,
		98,
		100,
		104,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		181,
		176,
		180,
		196,
		221,
		-1,
		182,
		-1,
		-1,
		163,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		112,
		123,
		140,
		128,
		129,
		119,
		129,
		142,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		135,
		142,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		127,
		127,
		130,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		188,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		170,
		171,
		176,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		158,
		121,
		138,
		152,
		157,
		155,
		146,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		118,
		143,
		151,
		168,
		162,
		140,
		155,
		145,
		136,
		145,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		185,
		160,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		175,
		171,
		162,
		162,
		150,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		143,
		148,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		220,
		224,
		190,
		184,
		223,
		192,
		198,
		209,
		-1,
		-1,
		-1,
		213,
		212,
		180,
		178,
		187,
		192,
		199,
		-1,
		198,
		-1,
		234,
		213,
		224,
		229,
		173,
		170,
		190,
		209,
		191,
		183,
		249,
		203,
		174,
		168,
		186,
		176,
		185,
		177,
		-1,
		174,
		164,
		186,
		165,
		176,
		168,
		-1,
		-1,
		168,
		169,
		175,
		161,
		167,
		163,
		-1,
		173,
		157,
		-1,
		-1,
		158,
		159,
		143,
		146,
		154,
		152,
		165,
		157,
		152,
		-1,
		-1,
		149,
		145,
		152,
		139,
		135,
		152,
		165,
		147,
		161,
		160,
		-1,
		153,
		171,
		178,
		146,
		144,
		128,
		126,
		144,
		146,
		152,
		152,
		-1,
		162,
		163,
		158,
		166,
		168,
		144,
		131,
		131,
		141,
		134,
		153,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		134,
		131,
		129,
		126,
		142,
		140,
		150,
		-1,
		-1,
		249,
		218,
		253,
		210,
		192,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		120,
		119,
		147,
		133,
		144,
		209,
		-1,
		-1,
		207,
		199,
		184,
		187,
		168,
		164,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		114,
		124,
		128,
		126,
		151,
		-1,
		-1,
		186,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		174,
		180,
		166,
		187,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		111,
		136,
		140,
		121,
		142,
		137,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		203,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		115,
		113,
		143,
		118,
		140,
		137,
		156,
		161,
		155,
		164,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		211,
		212,
		187,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		107,
		122,
		113,
		112,
		130,
		140,
		148,
		152,
		158,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		212,
		204,
		189,
		183,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		120,
		102,
		116,
		107,
		125,
		132,
		130,
		134,
		154,
		166,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		161,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		113,
		98,
		95,
		113,
		116,
		123,
		127,
		143,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		122,
		101,
		97,
		94,
		114,
		140,
		118,
		130,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		102,
		112,
		92,
		90,
		109,
		121,
		112,
		124,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		153,
		136,
		117,
		106,
		98,
		87,
		98,
		106,
		106,
		88,
		97,
		103,
		127,
		112,
		118,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		117,
		111,
		106,
		103,
		92,
		89,
		103,
		105,
		95,
		90,
		97,
		132,
		132,
		102,
		122,
		125,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		120,
		112,
		109,
		96,
		96,
		97,
		103,
		87,
		99,
		95,
		82,
		107,
		-1,
		110,
		104,
		112,
		102,
		90,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		94,
		86,
		80,
		89,
		82,
		81,
		94,
		87,
		87,
		82,
		95,
		99,
		103,
		92,
		88,
		85,
		99,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		111,
		109,
		108,
		92,
		95,
		90,
		81,
		64,
		76,
		69,
		85,
		72,
		90,
		98,
		90,
		84,
		83,
		95,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		121,
		106,
		99,
		100,
		70,
		75,
		64,
		52,
		55,
		69,
		80,
		72,
		94,
		94,
		78,
		79,
		88,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		120,
		118,
		89,
		64,
		71,
		76,
		49,
		44,
		67,
		64,
		64,
		66,
		88,
		74,
		72,
		91,
		107,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		63,
		59,
		66,
		-1,
		69,
		-1,
		41,
		54,
		54,
		56,
		60,
		71,
		69,
		80,
		97,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		130,
		127,
		79,
		59,
		51,
		66,
		52,
		39,
		38,
		44,
		49,
		53,
		63,
		76,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		122,
		79,
		67,
		57,
		47,
		52,
		0,
		30,
		35,
		44,
		56,
		61,
		72,
		77,
		98,
		99,
		112,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		175,
		141,
		120,
		68,
		-1,
		-1,
		51,
		44,
		32,
		44,
		48,
		60,
		67,
		82,
		71,
		86,
		98,
		106,
		111,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		153,
		98,
		87,
		82,
		86,
		50,
		-1,
		38,
		39,
		52,
		58,
		65,
		84,
		79,
		73,
		81,
		99,
		116,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		110,
		104,
		75,
		68,
		72,
		-1,
		47,
		47,
		54,
		70,
		82,
		81,
		85,
		77,
		82,
		84,
		97,
		111,
		115,
		204,
		-1,
		168,
		-1,
		-1,
		-1,
		128,
		143,
		114,
		91,
		64,
		59,
		52,
		46,
		51,
		71,
		77,
		88,
		73,
		77,
		81,
		90,
		89,
		106,
		116,
		-1,
		-1,
		166,
		162,
		154,
		136,
		140,
		141,
		-1,
		-1,
		68,
		59,
		50,
		53,
		61,
		64,
		69,
		71,
		89,
		97,
		85,
		99,
		115,
		121,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		155,
		139,
		86,
		68,
		64,
		62,
		55,
		64,
		59,
		64,
		89,
		84,
		93,
		87,
		102,
		125,
		114,
		153,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		101,
		98,
		-1,
		68,
		93,
		65,
		72,
		64,
		77,
		82,
		88,
		92,
		99,
		115,
		114,
		109,
		145,
		136,
		142,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		117,
		114,
		90,
		74,
		78,
		71,
		66,
		104,
		80,
		88,
		92,
		96,
		102,
		107,
		112,
		118,
		133,
		148,
		-1,
		202,
		239,
		232,
		200,
		208,
		239,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		90,
		87,
		92,
		81,
		78,
		90,
		89,
		100,
		102,
		107,
		95,
		94,
		112,
		116,
		125,
		132,
		122,
		135,
		139,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		137,
		-1,
		-1,
		149,
		121,
		105,
		95,
		89,
		139,
		95,
		90,
		92,
		94,
		98,
		89,
		112,
		103,
		103,
		106,
		121,
		126,
		118,
		132,
		132,
		133,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		165,
		-1,
		132,
		-1,
		107,
		111,
		103,
		106,
		117,
		104,
		102,
		110,
		118,
		101,
		111,
		107,
		108,
		117,
		128,
		140,
		139,
		140,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		149,
		188,
		203,
		-1,
		174,
		-1,
		-1,
		-1,
		121,
		116,
		108,
		124,
		116,
		116,
		96,
		100,
		106,
		113,
		123,
		125,
		117,
		121,
		134,
		145,
		148,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		164,
		155,
		182,
		208,
		199,
		194,
		181,
		-1,
		-1,
		144,
		126,
		-1,
		-1,
		123,
		117,
		100,
		102,
		106,
		116,
		131,
		134,
		124,
		122,
		116,
		148,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		167,
		183,
		178,
		182,
		198,
		223,
		-1,
		184,
		-1,
		-1,
		165,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		114,
		125,
		142,
		130,
		131,
		121,
		131,
		144,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		154,
		152,
		158,
		165,
		182,
		212,
		-1,
		-1,
		200,
		180,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		137,
		144,
		139,
		133,
		127,
		134,
		133,
		141,
		149,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		129,
		129,
		132,
		130,
		125,
		136,
		128,
		132,
		149,
		-1,
		225,
		-1,
		177,
		153,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		131,
		142,
		131,
		134,
		148,
		143,
		-1,
		-1,
		165,
		168,
		-1,
		-1,
		190,
		199,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		135,
		141,
		144,
		133,
		137,
		149,
		-1,
		-1,
		172,
		173,
		178,
		-1,
		182,
		-1,
		200,
		-1,
		167,
		173,
		161,
		-1,
		-1,
		-1,
		160,
		123,
		140,
		154,
		159,
		157,
		148,
		139,
		146,
		144,
		140,
		151,
		-1,
		-1,
		-1,
		200,
		174,
		207,
		198,
		181,
		161,
		153,
		172,
		-1,
		142,
		-1,
		117,
		120,
		145,
		153,
		170,
		164,
		142,
		157,
		147,
		138,
		147,
		206,
		-1,
		176,
		209,
		173,
		167,
		143,
		147,
		163,
		-1,
		139,
		121,
		-1,
		149,
		139,
		187,
		162,
		157,
		144,
		151,
		151,
		144,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		163,
		148,
		139,
		-1,
		151,
		133,
		112,
		129,
		129,
		120,
		128,
		177,
		173,
		164,
		164,
		152,
		-1,
		279,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		167,
		140,
		128,
		134,
		130,
		116,
		122,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		151,
		183,
		-1,
		274,
		-1,
		208,
		-1,
		-1,
		190,
		170,
		162,
		151,
		140,
		138,
		129,
		120,
		142,
		158,
		142,
		140,
		145,
		150,
		-1,
		263,
		262,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		186,
		147,
		-1,
		149,
		129,
		-1,
		151,
		147,
		-1,
		-1,
		250,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		181,
		165,
		-1,
		140,
		140,
		-1,
		-1,
		-1,
		235,
		234,
		-1,
		203,
		206,
		-1,
		196,
		187,
		195,
		142,
		146,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		218,
		216,
		211,
		208,
		194,
		178,
		156,
		145,
		166,
		-1,
		-1,
		-1,
		216,
		208,
		201,
		-1,
		-1,
		203,
		186,
		167,
		165,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		193,
		-1,
		-1,
		199,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		227,
		-1,
		-1,
		-1,
		189,
		185,
		186,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		273,
		237,
		-1,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		179,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		214,
		-1,
		214,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		227,
		219,
		227,
		-1,
		199,
		201,
		-1,
		249,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		204,
		211,
		233,
		236,
		272,
		-1,
		223
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		128,
		146,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		127,
		-1,
		137,
		138,
		133,
		141,
		143,
		119,
		106,
		106,
		116,
		109,
		128,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		120,
		137,
		129,
		119,
		134,
		127,
		109,
		106,
		104,
		101,
		117,
		115,
		125,
		-1,
		-1,
		230,
		199,
		228,
		186,
		167,
		-1,
		133,
		113,
		119,
		123,
		117,
		110,
		124,
		120,
		-1,
		95,
		94,
		122,
		108,
		119,
		190,
		-1,
		-1,
		188,
		180,
		163,
		166,
		143,
		139,
		128,
		127,
		119,
		105,
		101,
		107,
		110,
		110,
		116,
		89,
		99,
		103,
		101,
		126,
		-1,
		-1,
		161,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		149,
		155,
		141,
		162,
		138,
		129,
		121,
		115,
		103,
		105,
		102,
		115,
		103,
		86,
		111,
		115,
		96,
		117,
		112,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		178,
		-1,
		150,
		138,
		139,
		124,
		121,
		108,
		96,
		109,
		94,
		101,
		100,
		90,
		88,
		118,
		93,
		115,
		112,
		131,
		136,
		130,
		139,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		186,
		187,
		162,
		135,
		138,
		125,
		116,
		103,
		92,
		103,
		92,
		89,
		97,
		82,
		97,
		88,
		87,
		105,
		115,
		123,
		127,
		133,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		187,
		179,
		164,
		164,
		-1,
		134,
		131,
		121,
		99,
		84,
		101,
		93,
		91,
		95,
		77,
		91,
		82,
		100,
		107,
		105,
		109,
		129,
		141,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		136,
		149,
		-1,
		105,
		101,
		83,
		84,
		79,
		94,
		88,
		73,
		70,
		88,
		91,
		98,
		102,
		118,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		119,
		116,
		104,
		91,
		76,
		77,
		85,
		97,
		76,
		72,
		69,
		89,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		72,
		85,
		77,
		87,
		67,
		65,
		84,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		128,
		111,
		92,
		81,
		73,
		62,
		73,
		81,
		81,
		63,
		72,
		78,
		102,
		87,
		93,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		68,
		64,
		78,
		80,
		70,
		65,
		72,
		107,
		107,
		77,
		97,
		100,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		72,
		76,
		76,
		78,
		66,
		74,
		74,
		57,
		82,
		-1,
		85,
		79,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		84,
		76,
		70,
		73,
		61,
		60,
		73,
		66,
		62,
		57,
		70,
		74,
		78,
		67,
		63,
		60,
		74,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		98,
		82,
		85,
		70,
		60,
		43,
		55,
		48,
		62,
		47,
		65,
		73,
		65,
		59,
		58,
		70,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		96,
		89,
		90,
		60,
		64,
		43,
		31,
		34,
		48,
		55,
		47,
		69,
		69,
		53,
		54,
		63,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		110,
		108,
		79,
		54,
		61,
		55,
		28,
		23,
		46,
		43,
		39,
		41,
		63,
		49,
		47,
		66,
		82,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		53,
		49,
		56,
		-1,
		48,
		-1,
		20,
		33,
		33,
		31,
		35,
		46,
		44,
		55,
		72,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		117,
		69,
		49,
		41,
		56,
		31,
		9,
		17,
		19,
		24,
		28,
		38,
		51,
		71,
		62,
		74,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		112,
		69,
		57,
		47,
		37,
		42,
		30,
		0,
		10,
		19,
		31,
		36,
		47,
		52,
		73,
		74,
		87,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		131,
		110,
		58,
		-1,
		-1,
		41,
		34,
		22,
		19,
		23,
		35,
		42,
		57,
		46,
		61,
		73,
		81,
		86,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		143,
		88,
		77,
		72,
		76,
		40,
		-1,
		28,
		26,
		27,
		33,
		40,
		59,
		54,
		48,
		56,
		74,
		91,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		65,
		58,
		62,
		-1,
		37,
		34,
		29,
		45,
		59,
		56,
		60,
		52,
		57,
		59,
		72,
		86,
		90,
		185,
		-1,
		158,
		-1,
		-1,
		-1,
		118,
		133,
		104,
		81,
		54,
		49,
		42,
		36,
		37,
		53,
		62,
		73,
		59,
		55,
		56,
		65,
		64,
		81,
		91,
		-1,
		-1,
		156,
		152,
		144,
		126,
		130,
		131,
		-1,
		-1,
		58,
		49,
		40,
		43,
		47,
		50,
		59,
		61,
		67,
		72,
		60,
		74,
		90,
		96,
		-1,
		-1,
		-1,
		168,
		-1,
		170,
		-1,
		-1,
		145,
		129,
		76,
		58,
		54,
		52,
		45,
		54,
		49,
		54,
		79,
		74,
		82,
		62,
		80,
		100,
		92,
		128,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		147,
		139,
		134,
		140,
		142,
		133,
		91,
		88,
		-1,
		58,
		83,
		55,
		62,
		54,
		67,
		72,
		78,
		67,
		77,
		93,
		92,
		87,
		120,
		114,
		120,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		140,
		136,
		126,
		116,
		119,
		-1,
		-1,
		107,
		104,
		80,
		64,
		68,
		61,
		56,
		94,
		70,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		130,
		122,
		133,
		108,
		110,
		-1,
		-1,
		80,
		77,
		82,
		71,
		68,
		80,
		79,
		90,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		127,
		-1,
		-1,
		139,
		111,
		95,
		85,
		79,
		129,
		85,
		80,
		82,
		84,
		88,
		79,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		155,
		-1,
		122,
		-1,
		97,
		101,
		93,
		96,
		107,
		94,
		92,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		139,
		178,
		193,
		-1,
		164,
		-1,
		-1,
		-1,
		111,
		106,
		98,
		114,
		106,
		106,
		86,
		90,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		154,
		145,
		172,
		198,
		189,
		184,
		171,
		-1,
		-1,
		134,
		116,
		-1,
		-1,
		113,
		107,
		90,
		92,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		173,
		168,
		172,
		188,
		213,
		-1,
		174,
		-1,
		-1,
		155,
		-1,
		-1,
		149,
		112,
		101,
		92,
		98,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		202,
		-1,
		-1,
		190,
		170,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		97,
		102,
		126,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		180,
		176,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		119,
		119,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		197,
		183,
		176,
		164,
		162,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		155,
		158,
		-1,
		-1,
		180,
		189,
		-1,
		188,
		177,
		162,
		154,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		162,
		163,
		168,
		-1,
		172,
		-1,
		190,
		-1,
		157,
		163,
		151,
		-1,
		-1,
		-1,
		150,
		113,
		130,
		144,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		190,
		164,
		197,
		188,
		171,
		151,
		143,
		162,
		-1,
		132,
		-1,
		107,
		110,
		135,
		143,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		196,
		-1,
		166,
		199,
		163,
		157,
		133,
		137,
		153,
		-1,
		129,
		111,
		-1,
		139,
		129,
		169,
		152,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		153,
		138,
		129,
		-1,
		141,
		123,
		102,
		119,
		119,
		110,
		118,
		159,
		155,
		142,
		142,
		134,
		-1,
		269,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		157,
		130,
		118,
		124,
		120,
		106,
		112,
		114,
		122,
		120,
		117,
		129,
		125,
		145,
		135,
		170,
		-1,
		264,
		-1,
		198,
		-1,
		-1,
		180,
		160,
		152,
		141,
		130,
		128,
		119,
		110,
		132,
		148,
		132,
		130,
		135,
		140,
		-1,
		253,
		252,
		-1,
		199,
		191,
		177,
		-1,
		170,
		-1,
		176,
		137,
		-1,
		139,
		119,
		-1,
		141,
		137,
		-1,
		-1,
		240,
		215,
		-1,
		-1,
		-1,
		200,
		180,
		171,
		155,
		-1,
		130,
		130,
		-1,
		-1,
		-1,
		225,
		224,
		-1,
		193,
		196,
		-1,
		186,
		177,
		185,
		132,
		136,
		-1,
		-1,
		-1,
		234,
		215,
		209,
		208,
		206,
		201,
		198,
		184,
		168,
		146,
		135,
		156,
		-1,
		-1,
		-1,
		206,
		198,
		191,
		-1,
		-1,
		193,
		176,
		157,
		155,
		-1,
		-1,
		-1,
		228,
		209,
		-1,
		-1,
		183,
		-1,
		-1,
		189,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		217,
		-1,
		-1,
		-1,
		179,
		175,
		176,
		-1,
		-1,
		-1,
		-1,
		239,
		240,
		263,
		227,
		-1,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		242,
		240,
		-1,
		-1,
		-1,
		199,
		183,
		-1,
		169,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		204,
		-1,
		204,
		179,
		186,
		-1,
		-1,
		-1,
		-1,
		217,
		209,
		217,
		-1,
		189,
		191,
		-1,
		239,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		194,
		201,
		223,
		226,
		262,
		-1,
		213
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		187,
		191,
		157,
		151,
		190,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		180,
		179,
		147,
		145,
		154,
		159,
		166,
		-1,
		165,
		-1,
		201,
		180,
		191,
		196,
		140,
		137,
		157,
		176,
		158,
		150,
		216,
		170,
		141,
		135,
		153,
		143,
		152,
		144,
		-1,
		141,
		131,
		153,
		132,
		143,
		135,
		-1,
		-1,
		135,
		136,
		142,
		128,
		134,
		130,
		-1,
		140,
		124,
		-1,
		-1,
		125,
		126,
		110,
		113,
		121,
		119,
		132,
		124,
		119,
		-1,
		-1,
		116,
		112,
		119,
		106,
		102,
		119,
		132,
		114,
		128,
		127,
		-1,
		120,
		138,
		145,
		113,
		111,
		95,
		93,
		111,
		113,
		119,
		119,
		-1,
		129,
		130,
		125,
		133,
		135,
		111,
		98,
		98,
		108,
		101,
		120,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		112,
		129,
		121,
		111,
		126,
		119,
		101,
		98,
		96,
		93,
		109,
		107,
		117,
		-1,
		-1,
		222,
		191,
		220,
		178,
		159,
		-1,
		125,
		105,
		111,
		115,
		109,
		102,
		116,
		112,
		-1,
		87,
		86,
		114,
		100,
		111,
		182,
		-1,
		-1,
		180,
		172,
		155,
		158,
		135,
		131,
		120,
		119,
		111,
		97,
		93,
		99,
		102,
		102,
		108,
		81,
		91,
		95,
		93,
		118,
		-1,
		-1,
		153,
		-1,
		-1,
		179,
		162,
		-1,
		145,
		152,
		141,
		147,
		133,
		154,
		130,
		121,
		113,
		107,
		95,
		97,
		94,
		107,
		95,
		78,
		103,
		107,
		88,
		109,
		104,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		138,
		141,
		147,
		171,
		170,
		-1,
		142,
		130,
		131,
		116,
		113,
		100,
		88,
		101,
		86,
		93,
		92,
		82,
		80,
		110,
		85,
		107,
		104,
		123,
		128,
		122,
		131,
		-1,
		187,
		183,
		179,
		186,
		135,
		-1,
		-1,
		175,
		-1,
		178,
		179,
		154,
		127,
		130,
		117,
		108,
		95,
		84,
		95,
		84,
		81,
		89,
		74,
		89,
		80,
		79,
		97,
		107,
		115,
		119,
		125,
		-1,
		237,
		-1,
		179,
		163,
		165,
		137,
		158,
		-1,
		195,
		179,
		171,
		156,
		156,
		-1,
		126,
		123,
		113,
		91,
		76,
		93,
		85,
		83,
		87,
		69,
		83,
		74,
		92,
		99,
		97,
		101,
		121,
		133,
		197,
		187,
		-1,
		169,
		174,
		133,
		141,
		160,
		198,
		162,
		-1,
		157,
		-1,
		128,
		141,
		-1,
		97,
		93,
		75,
		76,
		71,
		86,
		80,
		65,
		62,
		80,
		83,
		90,
		94,
		110,
		-1,
		-1,
		182,
		186,
		175,
		126,
		145,
		169,
		206,
		155,
		144,
		143,
		-1,
		134,
		111,
		108,
		96,
		83,
		68,
		69,
		77,
		89,
		68,
		64,
		61,
		81,
		107,
		85,
		97,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		152,
		123,
		147,
		189,
		173,
		166,
		154,
		119,
		119,
		113,
		-1,
		107,
		86,
		77,
		66,
		64,
		77,
		69,
		79,
		59,
		57,
		76,
		88,
		79,
		91,
		-1,
		-1,
		-1,
		182,
		171,
		172,
		118,
		141,
		178,
		152,
		138,
		143,
		118,
		111,
		105,
		120,
		103,
		84,
		73,
		65,
		54,
		65,
		73,
		73,
		55,
		64,
		70,
		94,
		79,
		85,
		-1,
		-1,
		189,
		179,
		163,
		165,
		162,
		132,
		139,
		171,
		143,
		156,
		-1,
		110,
		-1,
		99,
		94,
		78,
		73,
		70,
		60,
		56,
		70,
		72,
		62,
		57,
		64,
		99,
		99,
		69,
		89,
		92,
		-1,
		-1,
		-1,
		182,
		177,
		152,
		129,
		113,
		149,
		-1,
		126,
		127,
		-1,
		104,
		98,
		95,
		80,
		76,
		64,
		68,
		68,
		70,
		61,
		66,
		67,
		49,
		74,
		-1,
		77,
		71,
		79,
		69,
		57,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		108,
		160,
		-1,
		-1,
		111,
		104,
		-1,
		91,
		73,
		76,
		71,
		70,
		69,
		65,
		55,
		68,
		61,
		54,
		49,
		62,
		66,
		70,
		59,
		55,
		52,
		66,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		128,
		-1,
		120,
		112,
		102,
		96,
		90,
		86,
		84,
		98,
		82,
		81,
		74,
		64,
		47,
		50,
		43,
		54,
		39,
		57,
		65,
		57,
		51,
		50,
		62,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		141,
		-1,
		105,
		119,
		135,
		-1,
		128,
		107,
		122,
		100,
		96,
		88,
		93,
		94,
		64,
		68,
		47,
		35,
		38,
		44,
		47,
		39,
		61,
		61,
		45,
		46,
		55,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		102,
		90,
		122,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		102,
		100,
		83,
		58,
		65,
		59,
		32,
		27,
		49,
		38,
		31,
		33,
		55,
		41,
		39,
		58,
		74,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		57,
		53,
		60,
		-1,
		52,
		-1,
		24,
		34,
		25,
		23,
		27,
		38,
		36,
		47,
		64,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		159,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		73,
		53,
		45,
		60,
		35,
		18,
		21,
		11,
		16,
		20,
		30,
		43,
		63,
		54,
		66,
		-1,
		-1,
		-1,
		156,
		142,
		146,
		106,
		125,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		110,
		73,
		61,
		51,
		41,
		46,
		34,
		9,
		0,
		11,
		23,
		28,
		39,
		44,
		65,
		66,
		79,
		-1,
		-1,
		139,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		138,
		154,
		129,
		108,
		62,
		-1,
		-1,
		45,
		38,
		26,
		11,
		13,
		25,
		32,
		49,
		38,
		53,
		65,
		73,
		78,
		-1,
		142,
		129,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		141,
		86,
		75,
		70,
		74,
		44,
		-1,
		32,
		18,
		17,
		23,
		30,
		51,
		46,
		40,
		48,
		66,
		83,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		63,
		56,
		60,
		-1,
		41,
		26,
		19,
		35,
		49,
		46,
		52,
		44,
		49,
		51,
		64,
		78,
		82,
		177,
		-1,
		156,
		-1,
		-1,
		-1,
		116,
		131,
		102,
		79,
		52,
		47,
		40,
		34,
		27,
		43,
		52,
		63,
		51,
		47,
		48,
		57,
		56,
		73,
		83,
		-1,
		-1,
		154,
		150,
		142,
		124,
		128,
		129,
		-1,
		-1,
		56,
		47,
		38,
		41,
		37,
		40,
		56,
		54,
		59,
		64,
		52,
		66,
		82,
		88,
		-1,
		-1,
		-1,
		166,
		-1,
		168,
		-1,
		-1,
		143,
		127,
		74,
		56,
		52,
		50,
		43,
		52,
		46,
		51,
		72,
		72,
		74,
		54,
		72,
		92,
		84,
		120,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		145,
		137,
		132,
		138,
		139,
		130,
		89,
		86,
		-1,
		56,
		81,
		52,
		59,
		51,
		65,
		70,
		76,
		59,
		69,
		85,
		84,
		79,
		112,
		106,
		112,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		138,
		134,
		124,
		114,
		116,
		-1,
		-1,
		104,
		101,
		78,
		61,
		66,
		59,
		54,
		91,
		68,
		58,
		62,
		66,
		72,
		77,
		82,
		88,
		103,
		118,
		-1,
		187,
		226,
		219,
		187,
		195,
		226,
		-1,
		128,
		120,
		131,
		106,
		107,
		-1,
		-1,
		77,
		75,
		80,
		68,
		65,
		78,
		77,
		87,
		72,
		78,
		65,
		64,
		82,
		86,
		95,
		102,
		92,
		105,
		109,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		125,
		-1,
		-1,
		137,
		108,
		92,
		83,
		76,
		127,
		82,
		77,
		79,
		81,
		84,
		75,
		82,
		73,
		73,
		76,
		91,
		96,
		88,
		102,
		102,
		103,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		153,
		-1,
		119,
		-1,
		94,
		98,
		90,
		93,
		104,
		91,
		88,
		80,
		96,
		71,
		81,
		77,
		78,
		87,
		98,
		110,
		109,
		110,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		137,
		176,
		191,
		-1,
		162,
		-1,
		-1,
		-1,
		108,
		103,
		95,
		111,
		103,
		103,
		82,
		86,
		76,
		83,
		93,
		95,
		87,
		91,
		104,
		115,
		118,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		152,
		143,
		170,
		195,
		187,
		182,
		169,
		-1,
		-1,
		131,
		113,
		-1,
		-1,
		110,
		103,
		86,
		87,
		83,
		86,
		101,
		104,
		94,
		92,
		86,
		118,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		171,
		165,
		169,
		185,
		210,
		-1,
		172,
		-1,
		-1,
		152,
		-1,
		-1,
		145,
		108,
		97,
		88,
		94,
		91,
		102,
		112,
		100,
		101,
		91,
		101,
		114,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		141,
		139,
		145,
		152,
		169,
		199,
		-1,
		-1,
		188,
		168,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		93,
		98,
		118,
		120,
		109,
		103,
		97,
		104,
		103,
		111,
		119,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		178,
		174,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		111,
		115,
		107,
		100,
		95,
		106,
		98,
		102,
		119,
		-1,
		212,
		-1,
		164,
		140,
		154,
		169,
		177,
		-1,
		-1,
		-1,
		195,
		181,
		174,
		162,
		160,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		151,
		119,
		124,
		119,
		101,
		112,
		101,
		104,
		118,
		113,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		177,
		187,
		-1,
		186,
		175,
		160,
		152,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		108,
		133,
		122,
		130,
		125,
		105,
		111,
		114,
		103,
		107,
		119,
		-1,
		-1,
		159,
		160,
		165,
		-1,
		170,
		-1,
		188,
		-1,
		155,
		161,
		149,
		-1,
		-1,
		-1,
		146,
		109,
		128,
		140,
		134,
		132,
		123,
		109,
		116,
		114,
		110,
		121,
		-1,
		-1,
		-1,
		188,
		162,
		195,
		186,
		169,
		149,
		141,
		160,
		-1,
		130,
		-1,
		105,
		108,
		133,
		139,
		145,
		139,
		112,
		127,
		117,
		108,
		117,
		194,
		-1,
		164,
		197,
		161,
		155,
		131,
		135,
		151,
		-1,
		127,
		109,
		-1,
		137,
		127,
		161,
		146,
		127,
		114,
		121,
		121,
		114,
		-1,
		-1,
		-1,
		166,
		165,
		157,
		151,
		151,
		136,
		127,
		-1,
		139,
		121,
		100,
		117,
		117,
		108,
		116,
		151,
		147,
		134,
		134,
		126,
		-1,
		267,
		-1,
		-1,
		189,
		-1,
		-1,
		-1,
		160,
		155,
		128,
		116,
		122,
		118,
		104,
		110,
		112,
		120,
		118,
		115,
		127,
		123,
		143,
		127,
		162,
		-1,
		262,
		-1,
		196,
		-1,
		-1,
		178,
		158,
		150,
		139,
		128,
		126,
		117,
		108,
		130,
		146,
		130,
		128,
		133,
		135,
		-1,
		251,
		250,
		-1,
		197,
		189,
		175,
		-1,
		168,
		-1,
		174,
		135,
		-1,
		137,
		117,
		-1,
		139,
		135,
		-1,
		-1,
		238,
		213,
		-1,
		-1,
		-1,
		198,
		178,
		169,
		153,
		-1,
		128,
		128,
		-1,
		-1,
		-1,
		223,
		222,
		-1,
		191,
		194,
		-1,
		184,
		175,
		183,
		130,
		134,
		-1,
		-1,
		-1,
		232,
		213,
		207,
		206,
		204,
		199,
		196,
		182,
		166,
		144,
		133,
		154,
		-1,
		-1,
		-1,
		204,
		196,
		189,
		-1,
		-1,
		191,
		174,
		155,
		153,
		-1,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		181,
		-1,
		-1,
		187,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		215,
		-1,
		-1,
		-1,
		177,
		173,
		174,
		-1,
		-1,
		-1,
		-1,
		237,
		238,
		261,
		225,
		-1,
		-1,
		-1,
		169,
		163,
		-1,
		-1,
		240,
		238,
		-1,
		-1,
		-1,
		197,
		181,
		-1,
		167,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		202,
		-1,
		202,
		177,
		184,
		-1,
		-1,
		-1,
		-1,
		215,
		207,
		215,
		-1,
		187,
		189,
		-1,
		237,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		192,
		199,
		221,
		224,
		260,
		-1,
		211
	],
	[
		-1,
		169,
		158,
		169,
		177,
		150,
		157,
		-1,
		176,
		180,
		146,
		140,
		179,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		169,
		168,
		136,
		134,
		143,
		148,
		155,
		-1,
		154,
		-1,
		190,
		169,
		180,
		185,
		129,
		126,
		146,
		165,
		147,
		139,
		205,
		159,
		130,
		124,
		142,
		132,
		141,
		133,
		-1,
		130,
		120,
		142,
		121,
		132,
		124,
		-1,
		-1,
		124,
		125,
		131,
		117,
		123,
		119,
		-1,
		129,
		113,
		-1,
		-1,
		114,
		115,
		99,
		102,
		110,
		108,
		121,
		113,
		108,
		-1,
		-1,
		105,
		101,
		108,
		95,
		91,
		108,
		121,
		103,
		117,
		116,
		-1,
		109,
		127,
		134,
		102,
		100,
		84,
		82,
		100,
		102,
		108,
		108,
		-1,
		118,
		119,
		114,
		122,
		124,
		100,
		87,
		87,
		97,
		90,
		109,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		101,
		118,
		110,
		100,
		115,
		108,
		90,
		87,
		85,
		82,
		98,
		96,
		106,
		-1,
		-1,
		211,
		180,
		209,
		167,
		148,
		-1,
		114,
		94,
		100,
		104,
		98,
		91,
		105,
		101,
		-1,
		76,
		75,
		103,
		89,
		100,
		171,
		-1,
		-1,
		169,
		161,
		144,
		147,
		124,
		120,
		109,
		108,
		100,
		86,
		82,
		88,
		91,
		91,
		97,
		70,
		80,
		84,
		82,
		107,
		-1,
		-1,
		142,
		-1,
		-1,
		168,
		151,
		-1,
		134,
		141,
		130,
		136,
		122,
		143,
		119,
		110,
		102,
		96,
		84,
		86,
		83,
		96,
		84,
		67,
		92,
		96,
		77,
		98,
		93,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		136,
		160,
		159,
		-1,
		131,
		119,
		120,
		105,
		102,
		89,
		77,
		90,
		75,
		82,
		81,
		71,
		69,
		99,
		74,
		96,
		93,
		112,
		117,
		111,
		120,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		164,
		-1,
		167,
		168,
		143,
		116,
		119,
		106,
		97,
		84,
		73,
		84,
		73,
		70,
		78,
		63,
		78,
		69,
		68,
		86,
		96,
		104,
		108,
		114,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		184,
		168,
		160,
		145,
		145,
		-1,
		115,
		112,
		102,
		80,
		65,
		82,
		74,
		72,
		76,
		58,
		72,
		63,
		81,
		88,
		86,
		90,
		110,
		122,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		117,
		130,
		-1,
		86,
		82,
		64,
		65,
		60,
		75,
		69,
		54,
		51,
		69,
		72,
		79,
		83,
		99,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		100,
		97,
		85,
		72,
		57,
		58,
		66,
		78,
		57,
		53,
		50,
		70,
		96,
		74,
		86,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		96,
		75,
		66,
		55,
		53,
		66,
		58,
		68,
		48,
		46,
		65,
		77,
		68,
		80,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		109,
		92,
		73,
		62,
		54,
		43,
		54,
		62,
		62,
		44,
		53,
		59,
		83,
		68,
		74,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		83,
		67,
		62,
		59,
		49,
		45,
		59,
		61,
		51,
		46,
		53,
		88,
		88,
		58,
		78,
		81,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		69,
		65,
		53,
		57,
		57,
		59,
		50,
		55,
		56,
		38,
		63,
		-1,
		66,
		60,
		68,
		58,
		46,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		65,
		60,
		59,
		58,
		55,
		44,
		57,
		50,
		43,
		38,
		51,
		55,
		59,
		48,
		44,
		41,
		55,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		87,
		71,
		70,
		67,
		58,
		59,
		39,
		32,
		43,
		28,
		46,
		54,
		46,
		40,
		39,
		51,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		77,
		94,
		95,
		73,
		67,
		59,
		47,
		44,
		33,
		36,
		28,
		50,
		50,
		34,
		35,
		44,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		91,
		89,
		84,
		70,
		77,
		71,
		44,
		39,
		38,
		27,
		20,
		22,
		44,
		30,
		28,
		47,
		63,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		69,
		65,
		72,
		-1,
		64,
		-1,
		27,
		23,
		14,
		12,
		16,
		27,
		25,
		36,
		53,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		85,
		65,
		57,
		72,
		47,
		30,
		33,
		2,
		5,
		9,
		19,
		32,
		52,
		43,
		55,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		85,
		73,
		63,
		53,
		58,
		46,
		21,
		14,
		0,
		12,
		17,
		28,
		33,
		54,
		55,
		68,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		124,
		103,
		74,
		-1,
		-1,
		57,
		50,
		38,
		21,
		8,
		28,
		35,
		38,
		27,
		42,
		54,
		62,
		67,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		136,
		81,
		70,
		65,
		69,
		56,
		-1,
		41,
		30,
		12,
		26,
		33,
		40,
		35,
		29,
		37,
		55,
		72,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		93,
		87,
		58,
		51,
		55,
		-1,
		42,
		28,
		14,
		31,
		52,
		49,
		41,
		33,
		38,
		40,
		53,
		67,
		71,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		111,
		126,
		97,
		74,
		47,
		42,
		35,
		29,
		22,
		38,
		47,
		58,
		40,
		36,
		37,
		46,
		45,
		62,
		72,
		-1,
		-1,
		149,
		145,
		137,
		119,
		123,
		124,
		-1,
		-1,
		51,
		42,
		33,
		36,
		32,
		35,
		46,
		43,
		48,
		53,
		41,
		55,
		71,
		77,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		138,
		122,
		69,
		51,
		47,
		45,
		38,
		47,
		41,
		46,
		61,
		67,
		63,
		43,
		61,
		81,
		73,
		109,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		134,
		125,
		84,
		81,
		-1,
		51,
		76,
		47,
		54,
		46,
		60,
		65,
		67,
		48,
		58,
		74,
		73,
		68,
		101,
		95,
		101,
		-1,
		-1,
		230,
		219,
		208,
		214,
		-1,
		133,
		129,
		119,
		109,
		111,
		-1,
		-1,
		99,
		96,
		73,
		56,
		61,
		54,
		49,
		80,
		60,
		47,
		51,
		55,
		61,
		66,
		71,
		77,
		92,
		107,
		-1,
		176,
		221,
		214,
		182,
		190,
		221,
		-1,
		123,
		115,
		126,
		101,
		102,
		-1,
		-1,
		72,
		70,
		75,
		63,
		60,
		73,
		72,
		76,
		61,
		67,
		54,
		53,
		71,
		75,
		84,
		91,
		81,
		94,
		98,
		-1,
		177,
		197,
		176,
		179,
		203,
		217,
		-1,
		120,
		-1,
		-1,
		132,
		103,
		87,
		78,
		71,
		122,
		77,
		72,
		74,
		76,
		73,
		64,
		71,
		62,
		62,
		65,
		80,
		85,
		77,
		91,
		91,
		92,
		-1,
		166,
		177,
		170,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		114,
		-1,
		89,
		93,
		85,
		88,
		98,
		85,
		77,
		69,
		85,
		60,
		70,
		66,
		67,
		76,
		87,
		99,
		98,
		99,
		191,
		147,
		150,
		161,
		172,
		187,
		191,
		-1,
		132,
		171,
		186,
		-1,
		157,
		-1,
		-1,
		-1,
		103,
		98,
		90,
		106,
		97,
		97,
		71,
		75,
		65,
		72,
		82,
		84,
		76,
		80,
		93,
		104,
		107,
		187,
		178,
		191,
		136,
		136,
		157,
		166,
		187,
		147,
		138,
		165,
		190,
		182,
		177,
		164,
		-1,
		-1,
		126,
		108,
		-1,
		-1,
		104,
		92,
		75,
		76,
		72,
		75,
		90,
		93,
		83,
		81,
		75,
		107,
		-1,
		180,
		179,
		168,
		165,
		141,
		132,
		127,
		154,
		-1,
		-1,
		149,
		166,
		160,
		164,
		180,
		205,
		-1,
		164,
		-1,
		-1,
		147,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		80,
		91,
		101,
		89,
		90,
		80,
		90,
		103,
		164,
		161,
		149,
		147,
		170,
		135,
		123,
		-1,
		136,
		134,
		140,
		147,
		164,
		194,
		-1,
		-1,
		180,
		160,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		107,
		109,
		98,
		92,
		86,
		93,
		92,
		100,
		108,
		173,
		187,
		176,
		172,
		171,
		179,
		128,
		121,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		166,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		100,
		104,
		96,
		89,
		84,
		95,
		87,
		91,
		108,
		-1,
		207,
		-1,
		159,
		135,
		149,
		164,
		172,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		90,
		101,
		90,
		93,
		107,
		102,
		-1,
		-1,
		147,
		150,
		-1,
		-1,
		172,
		179,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		94,
		100,
		103,
		92,
		96,
		108,
		-1,
		-1,
		154,
		155,
		160,
		-1,
		162,
		-1,
		180,
		-1,
		147,
		153,
		141,
		-1,
		-1,
		-1,
		135,
		98,
		119,
		129,
		123,
		121,
		112,
		98,
		105,
		103,
		99,
		110,
		-1,
		-1,
		-1,
		180,
		154,
		187,
		178,
		161,
		141,
		133,
		152,
		-1,
		122,
		-1,
		97,
		99,
		125,
		128,
		134,
		128,
		101,
		116,
		106,
		97,
		106,
		186,
		-1,
		156,
		189,
		153,
		147,
		123,
		127,
		143,
		-1,
		119,
		101,
		-1,
		129,
		119,
		150,
		135,
		116,
		103,
		110,
		110,
		103,
		-1,
		-1,
		-1,
		158,
		157,
		149,
		143,
		143,
		128,
		119,
		-1,
		131,
		113,
		92,
		109,
		109,
		100,
		108,
		140,
		136,
		123,
		123,
		115,
		-1,
		259,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		152,
		147,
		120,
		108,
		114,
		110,
		96,
		102,
		104,
		112,
		110,
		107,
		119,
		115,
		135,
		116,
		151,
		-1,
		254,
		-1,
		188,
		-1,
		-1,
		170,
		150,
		142,
		131,
		120,
		118,
		109,
		100,
		122,
		138,
		122,
		120,
		123,
		124,
		-1,
		243,
		242,
		-1,
		189,
		181,
		167,
		-1,
		160,
		-1,
		166,
		127,
		-1,
		129,
		109,
		-1,
		131,
		127,
		-1,
		-1,
		230,
		205,
		-1,
		-1,
		-1,
		190,
		170,
		161,
		145,
		-1,
		120,
		120,
		-1,
		-1,
		-1,
		215,
		214,
		-1,
		183,
		186,
		-1,
		176,
		167,
		175,
		122,
		126,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		198,
		196,
		191,
		188,
		174,
		158,
		136,
		125,
		146,
		-1,
		-1,
		-1,
		196,
		188,
		181,
		-1,
		-1,
		183,
		166,
		147,
		145,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		173,
		-1,
		-1,
		179,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		207,
		-1,
		-1,
		-1,
		169,
		165,
		166,
		-1,
		-1,
		-1,
		-1,
		229,
		230,
		253,
		217,
		-1,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		232,
		230,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		194,
		-1,
		194,
		169,
		176,
		-1,
		-1,
		-1,
		-1,
		207,
		199,
		207,
		-1,
		179,
		181,
		-1,
		229,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		184,
		191,
		213,
		216,
		252,
		-1,
		203
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		177,
		181,
		147,
		141,
		180,
		149,
		155,
		166,
		-1,
		-1,
		-1,
		170,
		169,
		137,
		135,
		144,
		149,
		156,
		-1,
		155,
		-1,
		191,
		170,
		181,
		186,
		130,
		127,
		147,
		166,
		148,
		140,
		206,
		160,
		131,
		125,
		143,
		133,
		142,
		134,
		-1,
		131,
		121,
		143,
		122,
		133,
		125,
		-1,
		-1,
		125,
		126,
		132,
		118,
		124,
		120,
		-1,
		130,
		114,
		-1,
		-1,
		115,
		116,
		100,
		103,
		111,
		109,
		122,
		114,
		109,
		-1,
		-1,
		106,
		102,
		109,
		96,
		92,
		109,
		122,
		104,
		118,
		117,
		-1,
		110,
		128,
		135,
		103,
		101,
		85,
		83,
		101,
		103,
		109,
		109,
		-1,
		119,
		120,
		115,
		123,
		125,
		101,
		88,
		88,
		98,
		91,
		110,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		119,
		102,
		119,
		111,
		101,
		116,
		109,
		91,
		88,
		86,
		83,
		99,
		97,
		107,
		-1,
		-1,
		212,
		181,
		210,
		168,
		149,
		-1,
		115,
		95,
		101,
		105,
		99,
		92,
		106,
		102,
		-1,
		77,
		76,
		104,
		90,
		101,
		172,
		-1,
		-1,
		170,
		162,
		145,
		148,
		125,
		121,
		110,
		109,
		101,
		87,
		83,
		89,
		92,
		92,
		98,
		71,
		81,
		85,
		83,
		108,
		-1,
		-1,
		143,
		-1,
		-1,
		169,
		152,
		-1,
		135,
		142,
		131,
		137,
		123,
		144,
		120,
		111,
		103,
		97,
		85,
		87,
		84,
		97,
		85,
		68,
		93,
		97,
		78,
		99,
		94,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		128,
		131,
		137,
		161,
		160,
		-1,
		132,
		120,
		121,
		106,
		103,
		90,
		78,
		91,
		76,
		83,
		82,
		72,
		70,
		100,
		75,
		97,
		94,
		113,
		118,
		112,
		121,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		165,
		-1,
		168,
		169,
		144,
		117,
		120,
		107,
		98,
		85,
		74,
		85,
		74,
		71,
		79,
		64,
		79,
		70,
		69,
		87,
		97,
		105,
		109,
		115,
		-1,
		227,
		-1,
		169,
		153,
		155,
		127,
		148,
		-1,
		185,
		169,
		161,
		146,
		146,
		-1,
		116,
		113,
		103,
		81,
		66,
		83,
		75,
		73,
		77,
		59,
		73,
		64,
		82,
		89,
		87,
		91,
		111,
		123,
		187,
		177,
		-1,
		159,
		164,
		123,
		131,
		150,
		188,
		152,
		-1,
		147,
		-1,
		118,
		131,
		-1,
		87,
		83,
		65,
		66,
		61,
		76,
		70,
		55,
		52,
		70,
		73,
		80,
		84,
		100,
		-1,
		-1,
		172,
		176,
		165,
		116,
		135,
		159,
		196,
		145,
		134,
		133,
		-1,
		124,
		101,
		98,
		86,
		73,
		58,
		59,
		67,
		79,
		58,
		54,
		51,
		71,
		97,
		75,
		87,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		142,
		113,
		137,
		179,
		163,
		156,
		144,
		109,
		109,
		103,
		-1,
		97,
		76,
		67,
		56,
		54,
		67,
		59,
		69,
		49,
		47,
		66,
		78,
		69,
		81,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		108,
		131,
		168,
		142,
		128,
		133,
		108,
		101,
		95,
		110,
		93,
		74,
		63,
		55,
		44,
		55,
		63,
		63,
		45,
		54,
		60,
		84,
		69,
		75,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		122,
		129,
		161,
		133,
		146,
		-1,
		100,
		-1,
		89,
		84,
		68,
		63,
		60,
		50,
		46,
		60,
		62,
		52,
		47,
		54,
		89,
		89,
		59,
		79,
		82,
		-1,
		-1,
		-1,
		172,
		167,
		142,
		119,
		103,
		139,
		-1,
		116,
		117,
		-1,
		94,
		88,
		85,
		70,
		66,
		54,
		58,
		58,
		60,
		51,
		56,
		57,
		39,
		64,
		-1,
		67,
		61,
		69,
		59,
		47,
		-1,
		-1,
		-1,
		165,
		144,
		137,
		157,
		98,
		150,
		-1,
		-1,
		101,
		94,
		-1,
		81,
		63,
		66,
		61,
		60,
		59,
		56,
		45,
		58,
		51,
		44,
		39,
		52,
		56,
		60,
		49,
		45,
		42,
		56,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		118,
		-1,
		110,
		102,
		92,
		86,
		80,
		76,
		74,
		88,
		72,
		71,
		68,
		59,
		67,
		40,
		33,
		44,
		29,
		47,
		55,
		47,
		41,
		40,
		52,
		-1,
		185,
		171,
		142,
		-1,
		-1,
		131,
		-1,
		95,
		109,
		125,
		-1,
		118,
		97,
		112,
		90,
		86,
		78,
		95,
		96,
		74,
		68,
		66,
		56,
		45,
		34,
		37,
		29,
		51,
		51,
		35,
		36,
		45,
		-1,
		191,
		178,
		136,
		132,
		121,
		141,
		92,
		80,
		112,
		-1,
		-1,
		154,
		-1,
		88,
		105,
		92,
		90,
		85,
		76,
		82,
		77,
		53,
		48,
		39,
		28,
		21,
		23,
		45,
		31,
		29,
		48,
		64,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		107,
		94,
		88,
		-1,
		129,
		-1,
		132,
		122,
		106,
		91,
		124,
		-1,
		80,
		76,
		82,
		-1,
		73,
		-1,
		26,
		22,
		13,
		13,
		17,
		28,
		26,
		37,
		54,
		-1,
		141,
		126,
		119,
		109,
		123,
		94,
		-1,
		149,
		-1,
		-1,
		119,
		113,
		113,
		97,
		100,
		96,
		76,
		68,
		82,
		55,
		41,
		41,
		13,
		6,
		10,
		20,
		33,
		53,
		44,
		56,
		-1,
		-1,
		-1,
		146,
		132,
		136,
		96,
		115,
		-1,
		-1,
		181,
		136,
		122,
		-1,
		106,
		96,
		84,
		74,
		64,
		69,
		57,
		32,
		25,
		11,
		0,
		18,
		29,
		34,
		55,
		56,
		69,
		-1,
		-1,
		129,
		134,
		122,
		108,
		127,
		-1,
		-1,
		-1,
		128,
		144,
		135,
		107,
		85,
		-1,
		-1,
		68,
		61,
		49,
		32,
		19,
		39,
		45,
		39,
		28,
		43,
		55,
		63,
		68,
		-1,
		132,
		119,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		-1,
		-1,
		147,
		92,
		81,
		76,
		80,
		67,
		-1,
		52,
		41,
		23,
		37,
		44,
		41,
		36,
		30,
		38,
		56,
		73,
		-1,
		-1,
		144,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		104,
		98,
		69,
		62,
		66,
		-1,
		53,
		39,
		25,
		42,
		54,
		51,
		42,
		34,
		39,
		41,
		54,
		68,
		72,
		167,
		-1,
		150,
		-1,
		-1,
		-1,
		122,
		137,
		108,
		85,
		58,
		53,
		46,
		40,
		33,
		49,
		58,
		69,
		41,
		37,
		38,
		47,
		46,
		63,
		73,
		-1,
		-1,
		150,
		156,
		148,
		130,
		134,
		135,
		-1,
		-1,
		62,
		53,
		44,
		47,
		43,
		46,
		47,
		44,
		49,
		54,
		42,
		56,
		72,
		78,
		-1,
		-1,
		-1,
		170,
		-1,
		174,
		-1,
		-1,
		149,
		133,
		80,
		62,
		58,
		56,
		49,
		58,
		52,
		52,
		62,
		72,
		64,
		44,
		62,
		82,
		74,
		110,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		151,
		143,
		138,
		144,
		145,
		136,
		95,
		92,
		-1,
		62,
		87,
		58,
		65,
		57,
		70,
		70,
		68,
		49,
		59,
		75,
		74,
		69,
		102,
		96,
		102,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		144,
		140,
		130,
		120,
		122,
		-1,
		-1,
		110,
		107,
		84,
		67,
		72,
		65,
		60,
		81,
		61,
		48,
		52,
		56,
		62,
		67,
		72,
		78,
		93,
		108,
		-1,
		177,
		232,
		225,
		193,
		201,
		232,
		-1,
		134,
		126,
		137,
		112,
		113,
		-1,
		-1,
		83,
		81,
		86,
		74,
		71,
		84,
		83,
		77,
		62,
		68,
		55,
		54,
		72,
		76,
		85,
		92,
		82,
		95,
		99,
		-1,
		188,
		208,
		187,
		190,
		214,
		228,
		-1,
		131,
		-1,
		-1,
		143,
		114,
		98,
		89,
		82,
		133,
		88,
		83,
		85,
		83,
		74,
		65,
		72,
		63,
		63,
		66,
		81,
		86,
		78,
		92,
		92,
		93,
		-1,
		177,
		188,
		181,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		159,
		-1,
		125,
		-1,
		100,
		104,
		96,
		99,
		99,
		86,
		78,
		70,
		86,
		61,
		71,
		67,
		68,
		77,
		88,
		100,
		99,
		100,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		143,
		182,
		197,
		-1,
		168,
		-1,
		-1,
		-1,
		114,
		109,
		101,
		117,
		98,
		98,
		72,
		76,
		66,
		73,
		83,
		85,
		77,
		81,
		94,
		105,
		108,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		158,
		149,
		176,
		201,
		193,
		188,
		175,
		-1,
		-1,
		137,
		119,
		-1,
		-1,
		105,
		93,
		76,
		77,
		73,
		76,
		91,
		94,
		84,
		82,
		76,
		108,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		160,
		177,
		171,
		175,
		191,
		216,
		-1,
		165,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		98,
		87,
		78,
		84,
		81,
		92,
		102,
		90,
		91,
		81,
		91,
		104,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		147,
		145,
		151,
		158,
		175,
		205,
		-1,
		-1,
		181,
		161,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		83,
		88,
		108,
		110,
		99,
		93,
		87,
		94,
		93,
		101,
		109,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		171,
		167,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		101,
		105,
		97,
		90,
		85,
		96,
		88,
		92,
		109,
		-1,
		218,
		-1,
		170,
		146,
		160,
		175,
		183,
		-1,
		-1,
		-1,
		188,
		174,
		167,
		155,
		153,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		141,
		109,
		114,
		109,
		91,
		102,
		91,
		94,
		108,
		103,
		-1,
		-1,
		158,
		161,
		-1,
		-1,
		178,
		180,
		-1,
		179,
		168,
		153,
		145,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		98,
		123,
		112,
		120,
		115,
		95,
		101,
		104,
		93,
		97,
		109,
		-1,
		-1,
		165,
		166,
		171,
		-1,
		163,
		-1,
		181,
		-1,
		148,
		154,
		142,
		-1,
		-1,
		-1,
		136,
		99,
		120,
		130,
		124,
		122,
		113,
		99,
		106,
		104,
		100,
		111,
		-1,
		-1,
		-1,
		181,
		155,
		188,
		179,
		162,
		142,
		134,
		153,
		-1,
		123,
		-1,
		98,
		100,
		126,
		129,
		135,
		129,
		102,
		117,
		107,
		98,
		107,
		187,
		-1,
		157,
		190,
		154,
		148,
		124,
		128,
		144,
		-1,
		120,
		102,
		-1,
		130,
		120,
		151,
		136,
		117,
		104,
		111,
		111,
		104,
		-1,
		-1,
		-1,
		159,
		158,
		150,
		144,
		144,
		129,
		120,
		-1,
		132,
		114,
		93,
		110,
		110,
		101,
		109,
		141,
		137,
		124,
		124,
		116,
		-1,
		260,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		153,
		148,
		121,
		109,
		115,
		111,
		97,
		103,
		105,
		113,
		111,
		108,
		120,
		116,
		136,
		117,
		152,
		-1,
		255,
		-1,
		189,
		-1,
		-1,
		171,
		151,
		143,
		132,
		121,
		119,
		110,
		101,
		123,
		139,
		123,
		121,
		124,
		125,
		-1,
		244,
		243,
		-1,
		190,
		182,
		168,
		-1,
		161,
		-1,
		167,
		128,
		-1,
		130,
		110,
		-1,
		132,
		128,
		-1,
		-1,
		231,
		206,
		-1,
		-1,
		-1,
		191,
		171,
		162,
		146,
		-1,
		121,
		121,
		-1,
		-1,
		-1,
		216,
		215,
		-1,
		184,
		187,
		-1,
		177,
		168,
		176,
		123,
		127,
		-1,
		-1,
		-1,
		225,
		206,
		200,
		199,
		197,
		192,
		189,
		175,
		159,
		137,
		126,
		147,
		-1,
		-1,
		-1,
		197,
		189,
		182,
		-1,
		-1,
		184,
		167,
		148,
		146,
		-1,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		174,
		-1,
		-1,
		180,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		208,
		-1,
		-1,
		-1,
		170,
		166,
		167,
		-1,
		-1,
		-1,
		-1,
		230,
		231,
		254,
		218,
		-1,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		233,
		231,
		-1,
		-1,
		-1,
		190,
		174,
		-1,
		160,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		195,
		-1,
		195,
		170,
		177,
		-1,
		-1,
		-1,
		-1,
		208,
		200,
		208,
		-1,
		180,
		182,
		-1,
		230,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		185,
		192,
		214,
		217,
		253,
		-1,
		204
	],
	[
		-1,
		169,
		158,
		169,
		177,
		150,
		157,
		-1,
		176,
		180,
		146,
		140,
		179,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		169,
		168,
		136,
		134,
		143,
		148,
		155,
		-1,
		154,
		-1,
		190,
		169,
		180,
		185,
		129,
		126,
		146,
		165,
		147,
		139,
		205,
		159,
		130,
		124,
		142,
		132,
		141,
		133,
		-1,
		130,
		120,
		142,
		121,
		132,
		124,
		-1,
		-1,
		124,
		125,
		131,
		117,
		123,
		119,
		-1,
		129,
		113,
		-1,
		-1,
		114,
		115,
		99,
		102,
		110,
		108,
		121,
		113,
		108,
		-1,
		-1,
		105,
		101,
		108,
		95,
		91,
		108,
		121,
		103,
		117,
		116,
		-1,
		109,
		127,
		134,
		102,
		100,
		84,
		82,
		100,
		102,
		108,
		108,
		-1,
		118,
		119,
		114,
		122,
		124,
		100,
		87,
		87,
		97,
		90,
		109,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		101,
		118,
		110,
		100,
		115,
		108,
		90,
		87,
		85,
		82,
		98,
		96,
		106,
		-1,
		-1,
		211,
		180,
		209,
		167,
		148,
		-1,
		114,
		94,
		100,
		104,
		98,
		91,
		105,
		101,
		-1,
		76,
		75,
		103,
		89,
		100,
		171,
		-1,
		-1,
		169,
		161,
		144,
		147,
		124,
		120,
		109,
		108,
		100,
		86,
		82,
		88,
		91,
		91,
		97,
		70,
		80,
		84,
		82,
		107,
		-1,
		-1,
		142,
		-1,
		-1,
		168,
		151,
		-1,
		134,
		141,
		130,
		136,
		122,
		143,
		119,
		110,
		102,
		96,
		84,
		86,
		83,
		96,
		84,
		67,
		92,
		96,
		77,
		98,
		93,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		136,
		160,
		159,
		-1,
		131,
		119,
		120,
		105,
		102,
		89,
		77,
		90,
		75,
		82,
		81,
		71,
		69,
		99,
		74,
		96,
		93,
		112,
		117,
		111,
		120,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		164,
		-1,
		167,
		168,
		143,
		116,
		119,
		106,
		97,
		84,
		73,
		84,
		73,
		70,
		78,
		63,
		78,
		69,
		68,
		86,
		96,
		104,
		108,
		114,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		184,
		168,
		160,
		145,
		145,
		-1,
		115,
		112,
		102,
		80,
		65,
		82,
		74,
		72,
		76,
		58,
		72,
		63,
		81,
		88,
		86,
		90,
		110,
		122,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		117,
		130,
		-1,
		86,
		82,
		64,
		65,
		60,
		75,
		69,
		54,
		51,
		69,
		72,
		79,
		83,
		99,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		100,
		97,
		85,
		72,
		57,
		58,
		66,
		78,
		57,
		53,
		50,
		70,
		96,
		74,
		86,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		96,
		75,
		66,
		55,
		53,
		66,
		58,
		68,
		48,
		46,
		65,
		77,
		68,
		80,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		109,
		92,
		73,
		62,
		54,
		43,
		54,
		62,
		62,
		44,
		53,
		59,
		83,
		68,
		74,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		83,
		67,
		62,
		59,
		49,
		45,
		59,
		61,
		51,
		46,
		53,
		88,
		88,
		58,
		78,
		81,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		69,
		65,
		53,
		57,
		57,
		59,
		50,
		55,
		56,
		38,
		63,
		-1,
		66,
		60,
		68,
		58,
		46,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		65,
		60,
		59,
		58,
		55,
		44,
		57,
		50,
		43,
		38,
		51,
		55,
		59,
		48,
		44,
		41,
		55,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		87,
		71,
		70,
		67,
		58,
		66,
		39,
		32,
		43,
		28,
		46,
		54,
		46,
		40,
		39,
		51,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		77,
		94,
		95,
		73,
		67,
		65,
		56,
		44,
		33,
		36,
		28,
		50,
		50,
		34,
		35,
		44,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		91,
		89,
		84,
		75,
		81,
		76,
		53,
		48,
		38,
		27,
		20,
		22,
		44,
		30,
		28,
		47,
		63,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		86,
		76,
		81,
		-1,
		73,
		-1,
		34,
		30,
		21,
		12,
		16,
		27,
		25,
		36,
		50,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		102,
		82,
		74,
		81,
		63,
		47,
		49,
		19,
		12,
		9,
		19,
		32,
		38,
		43,
		48,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		102,
		90,
		80,
		70,
		73,
		63,
		38,
		31,
		17,
		19,
		0,
		21,
		16,
		37,
		42,
		58,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		91,
		-1,
		-1,
		74,
		65,
		55,
		34,
		21,
		32,
		27,
		21,
		14,
		25,
		37,
		53,
		54,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		149,
		94,
		83,
		78,
		82,
		73,
		-1,
		54,
		45,
		25,
		39,
		46,
		23,
		24,
		18,
		24,
		42,
		59,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		106,
		100,
		71,
		64,
		68,
		-1,
		55,
		41,
		27,
		44,
		42,
		39,
		30,
		22,
		27,
		27,
		40,
		54,
		58,
		166,
		-1,
		149,
		-1,
		-1,
		-1,
		124,
		139,
		110,
		87,
		60,
		55,
		48,
		42,
		35,
		51,
		50,
		61,
		29,
		25,
		26,
		33,
		32,
		49,
		59,
		-1,
		-1,
		149,
		155,
		150,
		132,
		136,
		137,
		-1,
		-1,
		64,
		55,
		46,
		49,
		45,
		48,
		35,
		32,
		37,
		42,
		30,
		42,
		60,
		64,
		-1,
		-1,
		-1,
		169,
		-1,
		173,
		-1,
		-1,
		151,
		135,
		82,
		64,
		60,
		58,
		51,
		59,
		47,
		40,
		50,
		60,
		52,
		32,
		53,
		70,
		65,
		96,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		150,
		142,
		137,
		143,
		145,
		136,
		97,
		94,
		-1,
		64,
		88,
		53,
		60,
		52,
		58,
		58,
		56,
		37,
		50,
		66,
		65,
		60,
		88,
		83,
		92,
		-1,
		-1,
		236,
		225,
		214,
		220,
		-1,
		143,
		139,
		129,
		119,
		122,
		-1,
		-1,
		112,
		109,
		85,
		62,
		68,
		61,
		56,
		72,
		52,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		98,
		-1,
		176,
		227,
		220,
		188,
		196,
		227,
		-1,
		133,
		125,
		136,
		111,
		113,
		-1,
		-1,
		85,
		80,
		81,
		69,
		66,
		79,
		77,
		68,
		53,
		59,
		46,
		45,
		63,
		67,
		76,
		83,
		73,
		86,
		90,
		-1,
		183,
		203,
		182,
		185,
		209,
		223,
		-1,
		130,
		-1,
		-1,
		142,
		114,
		98,
		88,
		84,
		128,
		83,
		78,
		76,
		74,
		65,
		56,
		63,
		54,
		54,
		57,
		72,
		77,
		69,
		83,
		83,
		84,
		-1,
		172,
		183,
		176,
		-1,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		158,
		-1,
		125,
		-1,
		102,
		106,
		91,
		94,
		90,
		77,
		69,
		61,
		77,
		52,
		62,
		58,
		59,
		68,
		79,
		91,
		90,
		91,
		197,
		153,
		156,
		167,
		178,
		193,
		197,
		-1,
		142,
		181,
		189,
		-1,
		167,
		-1,
		-1,
		-1,
		116,
		104,
		96,
		110,
		89,
		89,
		63,
		67,
		57,
		64,
		74,
		76,
		68,
		72,
		85,
		96,
		99,
		193,
		184,
		197,
		142,
		142,
		163,
		172,
		193,
		157,
		148,
		175,
		196,
		185,
		180,
		167,
		-1,
		-1,
		139,
		114,
		-1,
		-1,
		96,
		84,
		67,
		68,
		64,
		67,
		82,
		85,
		75,
		73,
		67,
		99,
		-1,
		186,
		185,
		174,
		171,
		147,
		138,
		133,
		160,
		-1,
		-1,
		155,
		176,
		166,
		170,
		186,
		211,
		-1,
		156,
		-1,
		-1,
		141,
		-1,
		-1,
		126,
		89,
		78,
		69,
		75,
		72,
		83,
		93,
		81,
		82,
		72,
		82,
		95,
		170,
		167,
		155,
		153,
		176,
		141,
		129,
		-1,
		142,
		140,
		146,
		153,
		170,
		200,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		124,
		122,
		111,
		-1,
		101,
		74,
		79,
		99,
		101,
		90,
		84,
		78,
		85,
		84,
		92,
		100,
		179,
		193,
		182,
		178,
		177,
		185,
		134,
		127,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		119,
		112,
		100,
		88,
		78,
		88,
		92,
		96,
		88,
		81,
		76,
		87,
		79,
		83,
		100,
		-1,
		213,
		-1,
		165,
		141,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		132,
		100,
		105,
		100,
		82,
		93,
		82,
		85,
		99,
		94,
		-1,
		-1,
		153,
		156,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		89,
		114,
		103,
		111,
		106,
		86,
		92,
		95,
		84,
		88,
		100,
		-1,
		-1,
		160,
		161,
		166,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		127,
		90,
		111,
		121,
		115,
		113,
		104,
		90,
		97,
		95,
		91,
		102,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		89,
		91,
		117,
		120,
		126,
		120,
		93,
		108,
		98,
		89,
		98,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		93,
		-1,
		121,
		111,
		142,
		127,
		108,
		95,
		102,
		102,
		95,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		100,
		132,
		128,
		115,
		115,
		107,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		104,
		102,
		99,
		111,
		107,
		127,
		108,
		143,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		114,
		112,
		115,
		116,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		123,
		119,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		167,
		156,
		167,
		175,
		148,
		155,
		-1,
		174,
		178,
		144,
		138,
		177,
		146,
		152,
		163,
		-1,
		-1,
		-1,
		167,
		166,
		134,
		132,
		141,
		146,
		153,
		-1,
		152,
		-1,
		188,
		167,
		178,
		183,
		127,
		124,
		144,
		163,
		145,
		137,
		203,
		157,
		128,
		122,
		140,
		130,
		139,
		131,
		-1,
		128,
		118,
		140,
		119,
		130,
		122,
		-1,
		-1,
		122,
		123,
		129,
		115,
		121,
		117,
		-1,
		127,
		111,
		-1,
		-1,
		112,
		113,
		97,
		100,
		108,
		106,
		119,
		111,
		106,
		-1,
		-1,
		103,
		99,
		106,
		93,
		89,
		106,
		119,
		101,
		115,
		114,
		-1,
		109,
		127,
		132,
		100,
		98,
		82,
		80,
		98,
		100,
		106,
		106,
		-1,
		118,
		119,
		114,
		122,
		122,
		98,
		85,
		85,
		95,
		88,
		107,
		95,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		118,
		101,
		118,
		110,
		100,
		115,
		108,
		88,
		85,
		83,
		80,
		96,
		94,
		104,
		-1,
		-1,
		209,
		178,
		209,
		167,
		148,
		-1,
		114,
		94,
		100,
		104,
		98,
		91,
		105,
		101,
		-1,
		74,
		73,
		101,
		87,
		98,
		169,
		-1,
		-1,
		167,
		159,
		144,
		147,
		124,
		120,
		109,
		108,
		100,
		86,
		82,
		88,
		91,
		91,
		97,
		68,
		78,
		82,
		80,
		105,
		-1,
		-1,
		140,
		-1,
		-1,
		166,
		149,
		-1,
		132,
		139,
		130,
		136,
		122,
		143,
		119,
		110,
		102,
		96,
		84,
		86,
		83,
		96,
		84,
		65,
		90,
		94,
		75,
		96,
		91,
		-1,
		139,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		134,
		158,
		159,
		-1,
		131,
		119,
		120,
		105,
		102,
		89,
		77,
		90,
		75,
		82,
		81,
		69,
		67,
		97,
		72,
		94,
		91,
		110,
		115,
		109,
		118,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		162,
		-1,
		167,
		168,
		143,
		116,
		119,
		106,
		97,
		84,
		73,
		84,
		73,
		70,
		78,
		61,
		76,
		67,
		66,
		84,
		94,
		102,
		106,
		112,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		182,
		168,
		160,
		145,
		143,
		-1,
		115,
		112,
		102,
		80,
		65,
		82,
		74,
		72,
		74,
		56,
		70,
		61,
		79,
		86,
		84,
		88,
		108,
		120,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		185,
		149,
		-1,
		144,
		-1,
		117,
		130,
		-1,
		86,
		82,
		64,
		65,
		60,
		75,
		67,
		52,
		49,
		67,
		70,
		77,
		81,
		97,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		100,
		97,
		85,
		72,
		57,
		58,
		66,
		78,
		57,
		51,
		48,
		68,
		94,
		72,
		84,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		96,
		75,
		66,
		55,
		53,
		66,
		58,
		66,
		46,
		44,
		63,
		75,
		66,
		77,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		109,
		92,
		73,
		62,
		54,
		43,
		54,
		62,
		60,
		42,
		51,
		57,
		81,
		65,
		71,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		82,
		67,
		62,
		59,
		46,
		45,
		59,
		59,
		49,
		44,
		51,
		86,
		86,
		55,
		75,
		78,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		82,
		69,
		65,
		50,
		54,
		56,
		59,
		47,
		53,
		54,
		36,
		60,
		-1,
		63,
		57,
		65,
		55,
		43,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		60,
		62,
		57,
		56,
		55,
		52,
		41,
		54,
		47,
		41,
		35,
		48,
		52,
		56,
		45,
		41,
		38,
		52,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		73,
		71,
		84,
		68,
		67,
		64,
		55,
		63,
		36,
		29,
		40,
		25,
		43,
		51,
		43,
		37,
		36,
		48,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		83,
		74,
		91,
		92,
		70,
		64,
		62,
		53,
		41,
		30,
		33,
		25,
		47,
		47,
		31,
		32,
		41,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		88,
		86,
		81,
		72,
		78,
		73,
		50,
		45,
		35,
		24,
		24,
		19,
		41,
		27,
		25,
		44,
		60,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		89,
		73,
		78,
		-1,
		70,
		-1,
		43,
		40,
		31,
		16,
		13,
		24,
		22,
		33,
		47,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		105,
		85,
		79,
		78,
		65,
		57,
		51,
		29,
		22,
		19,
		12,
		17,
		25,
		40,
		45,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		112,
		100,
		90,
		80,
		83,
		73,
		48,
		41,
		27,
		29,
		27,
		0,
		16,
		33,
		39,
		54,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		101,
		-1,
		-1,
		84,
		75,
		65,
		44,
		31,
		48,
		43,
		28,
		12,
		22,
		33,
		49,
		52,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		152,
		97,
		86,
		81,
		85,
		83,
		-1,
		57,
		55,
		35,
		49,
		56,
		30,
		25,
		19,
		22,
		40,
		56,
		-1,
		-1,
		141,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		74,
		67,
		71,
		-1,
		59,
		51,
		37,
		54,
		43,
		40,
		31,
		23,
		28,
		25,
		38,
		52,
		56,
		164,
		-1,
		147,
		-1,
		-1,
		-1,
		127,
		142,
		113,
		90,
		63,
		58,
		51,
		45,
		45,
		61,
		51,
		62,
		30,
		26,
		27,
		31,
		30,
		47,
		57,
		-1,
		-1,
		147,
		156,
		153,
		135,
		139,
		140,
		-1,
		-1,
		67,
		58,
		49,
		52,
		55,
		58,
		36,
		33,
		38,
		43,
		31,
		40,
		58,
		62,
		-1,
		-1,
		-1,
		167,
		-1,
		174,
		-1,
		-1,
		154,
		138,
		85,
		67,
		63,
		61,
		54,
		60,
		48,
		41,
		51,
		61,
		53,
		33,
		53,
		68,
		65,
		94,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		151,
		143,
		138,
		144,
		146,
		137,
		100,
		97,
		-1,
		67,
		89,
		54,
		61,
		53,
		59,
		59,
		57,
		38,
		50,
		66,
		65,
		60,
		86,
		81,
		90,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		144,
		140,
		130,
		120,
		123,
		-1,
		-1,
		116,
		113,
		86,
		63,
		69,
		62,
		57,
		72,
		52,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		96,
		-1,
		174,
		228,
		221,
		189,
		197,
		228,
		-1,
		134,
		126,
		137,
		112,
		114,
		-1,
		-1,
		89,
		81,
		82,
		70,
		67,
		80,
		77,
		68,
		53,
		59,
		46,
		45,
		63,
		67,
		76,
		83,
		73,
		86,
		90,
		-1,
		184,
		204,
		183,
		186,
		210,
		224,
		-1,
		131,
		-1,
		-1,
		143,
		115,
		99,
		89,
		86,
		129,
		84,
		79,
		76,
		74,
		65,
		56,
		63,
		54,
		54,
		57,
		72,
		77,
		69,
		83,
		83,
		84,
		-1,
		173,
		184,
		177,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		159,
		-1,
		126,
		-1,
		106,
		110,
		92,
		95,
		90,
		77,
		69,
		61,
		77,
		52,
		62,
		58,
		59,
		68,
		79,
		91,
		90,
		91,
		198,
		154,
		157,
		168,
		179,
		194,
		198,
		-1,
		143,
		182,
		189,
		-1,
		168,
		-1,
		-1,
		-1,
		120,
		105,
		97,
		110,
		89,
		89,
		63,
		67,
		57,
		64,
		74,
		76,
		68,
		72,
		85,
		96,
		99,
		194,
		185,
		198,
		143,
		143,
		164,
		173,
		194,
		158,
		149,
		176,
		196,
		185,
		180,
		167,
		-1,
		-1,
		143,
		115,
		-1,
		-1,
		96,
		84,
		67,
		68,
		64,
		67,
		82,
		85,
		75,
		73,
		67,
		99,
		-1,
		187,
		186,
		175,
		172,
		148,
		139,
		134,
		161,
		-1,
		-1,
		156,
		177,
		167,
		171,
		187,
		212,
		-1,
		156,
		-1,
		-1,
		141,
		-1,
		-1,
		126,
		89,
		78,
		69,
		75,
		72,
		83,
		93,
		81,
		82,
		72,
		82,
		95,
		171,
		168,
		156,
		154,
		177,
		142,
		130,
		-1,
		143,
		141,
		147,
		154,
		171,
		201,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		124,
		122,
		111,
		-1,
		101,
		74,
		79,
		99,
		101,
		90,
		84,
		78,
		85,
		84,
		92,
		100,
		180,
		194,
		183,
		179,
		178,
		186,
		135,
		128,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		119,
		112,
		100,
		88,
		78,
		88,
		92,
		96,
		88,
		81,
		76,
		87,
		79,
		83,
		100,
		-1,
		214,
		-1,
		166,
		142,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		132,
		100,
		105,
		100,
		82,
		93,
		82,
		85,
		99,
		94,
		-1,
		-1,
		154,
		157,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		89,
		114,
		103,
		111,
		106,
		86,
		92,
		95,
		84,
		88,
		100,
		-1,
		-1,
		161,
		162,
		167,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		127,
		90,
		111,
		121,
		115,
		113,
		104,
		90,
		97,
		95,
		91,
		102,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		89,
		91,
		117,
		120,
		126,
		120,
		93,
		108,
		98,
		89,
		98,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		93,
		-1,
		121,
		111,
		142,
		127,
		108,
		95,
		102,
		102,
		95,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		100,
		132,
		128,
		115,
		115,
		107,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		104,
		102,
		99,
		111,
		107,
		127,
		108,
		143,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		114,
		112,
		115,
		116,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		123,
		119,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		177,
		181,
		147,
		141,
		180,
		149,
		155,
		166,
		-1,
		-1,
		-1,
		170,
		169,
		137,
		135,
		144,
		149,
		156,
		-1,
		155,
		-1,
		191,
		170,
		181,
		186,
		130,
		127,
		147,
		166,
		148,
		140,
		206,
		160,
		131,
		125,
		143,
		133,
		142,
		134,
		-1,
		131,
		121,
		143,
		122,
		133,
		125,
		-1,
		-1,
		125,
		126,
		132,
		118,
		124,
		120,
		-1,
		130,
		114,
		-1,
		-1,
		115,
		116,
		100,
		103,
		111,
		109,
		122,
		114,
		109,
		-1,
		-1,
		106,
		102,
		109,
		96,
		92,
		109,
		122,
		104,
		118,
		117,
		-1,
		112,
		130,
		135,
		103,
		101,
		85,
		83,
		101,
		103,
		109,
		109,
		-1,
		121,
		122,
		117,
		125,
		125,
		101,
		88,
		88,
		98,
		91,
		110,
		98,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		121,
		104,
		121,
		113,
		103,
		118,
		111,
		91,
		88,
		86,
		83,
		99,
		97,
		107,
		-1,
		-1,
		212,
		181,
		212,
		170,
		151,
		-1,
		117,
		97,
		103,
		107,
		101,
		94,
		108,
		104,
		-1,
		77,
		76,
		104,
		90,
		101,
		172,
		-1,
		-1,
		170,
		162,
		147,
		150,
		127,
		123,
		112,
		111,
		103,
		89,
		85,
		91,
		94,
		94,
		100,
		71,
		81,
		85,
		83,
		108,
		-1,
		-1,
		143,
		-1,
		-1,
		169,
		152,
		-1,
		135,
		142,
		133,
		139,
		125,
		146,
		122,
		113,
		105,
		99,
		87,
		89,
		86,
		99,
		87,
		68,
		93,
		97,
		78,
		99,
		94,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		128,
		131,
		137,
		161,
		162,
		-1,
		134,
		122,
		123,
		108,
		105,
		92,
		80,
		93,
		78,
		85,
		84,
		72,
		70,
		100,
		75,
		97,
		94,
		113,
		118,
		112,
		121,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		165,
		-1,
		170,
		171,
		146,
		119,
		122,
		109,
		100,
		87,
		76,
		87,
		76,
		73,
		81,
		64,
		79,
		70,
		69,
		87,
		97,
		105,
		109,
		115,
		-1,
		227,
		-1,
		169,
		153,
		155,
		127,
		148,
		-1,
		185,
		171,
		163,
		148,
		146,
		-1,
		118,
		115,
		105,
		83,
		68,
		85,
		77,
		75,
		77,
		59,
		73,
		64,
		82,
		89,
		87,
		91,
		111,
		123,
		187,
		177,
		-1,
		159,
		164,
		123,
		131,
		150,
		188,
		152,
		-1,
		147,
		-1,
		120,
		133,
		-1,
		89,
		85,
		67,
		68,
		63,
		78,
		70,
		55,
		52,
		70,
		73,
		80,
		84,
		100,
		-1,
		-1,
		172,
		176,
		165,
		116,
		135,
		159,
		196,
		145,
		134,
		133,
		-1,
		124,
		103,
		100,
		88,
		75,
		60,
		61,
		69,
		81,
		60,
		54,
		51,
		71,
		97,
		75,
		86,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		142,
		113,
		137,
		179,
		163,
		156,
		144,
		109,
		109,
		103,
		-1,
		99,
		78,
		69,
		58,
		56,
		69,
		61,
		69,
		49,
		47,
		66,
		78,
		69,
		77,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		108,
		131,
		168,
		142,
		128,
		133,
		108,
		101,
		95,
		112,
		95,
		76,
		65,
		57,
		46,
		57,
		65,
		63,
		45,
		54,
		60,
		84,
		65,
		71,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		122,
		129,
		161,
		133,
		146,
		-1,
		100,
		-1,
		89,
		85,
		70,
		65,
		62,
		49,
		48,
		62,
		62,
		52,
		47,
		54,
		89,
		89,
		55,
		75,
		78,
		-1,
		-1,
		-1,
		172,
		167,
		142,
		119,
		103,
		139,
		-1,
		116,
		117,
		-1,
		94,
		88,
		85,
		72,
		68,
		53,
		57,
		59,
		62,
		50,
		56,
		57,
		39,
		63,
		-1,
		63,
		57,
		65,
		55,
		43,
		-1,
		-1,
		-1,
		165,
		144,
		137,
		157,
		98,
		150,
		-1,
		-1,
		101,
		94,
		-1,
		81,
		63,
		65,
		60,
		59,
		58,
		55,
		44,
		57,
		50,
		44,
		38,
		51,
		55,
		56,
		45,
		41,
		38,
		52,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		118,
		-1,
		110,
		102,
		92,
		86,
		80,
		76,
		74,
		87,
		71,
		70,
		67,
		58,
		66,
		39,
		32,
		43,
		28,
		46,
		52,
		43,
		38,
		37,
		48,
		-1,
		185,
		171,
		142,
		-1,
		-1,
		131,
		-1,
		95,
		109,
		125,
		-1,
		118,
		97,
		112,
		90,
		86,
		77,
		94,
		95,
		73,
		67,
		65,
		56,
		44,
		33,
		36,
		28,
		50,
		47,
		31,
		33,
		42,
		-1,
		191,
		178,
		136,
		132,
		121,
		141,
		92,
		80,
		112,
		-1,
		-1,
		154,
		-1,
		88,
		105,
		91,
		89,
		84,
		75,
		81,
		76,
		53,
		48,
		38,
		27,
		27,
		22,
		41,
		27,
		25,
		45,
		61,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		107,
		94,
		88,
		-1,
		129,
		-1,
		132,
		122,
		106,
		91,
		124,
		-1,
		92,
		76,
		81,
		-1,
		73,
		-1,
		46,
		43,
		34,
		19,
		16,
		27,
		25,
		34,
		41,
		-1,
		141,
		126,
		119,
		109,
		123,
		94,
		-1,
		149,
		-1,
		-1,
		119,
		113,
		113,
		97,
		100,
		108,
		88,
		82,
		81,
		68,
		60,
		54,
		32,
		25,
		22,
		12,
		25,
		28,
		41,
		39,
		-1,
		-1,
		-1,
		146,
		132,
		136,
		96,
		115,
		-1,
		-1,
		181,
		136,
		122,
		-1,
		106,
		115,
		103,
		93,
		83,
		86,
		76,
		51,
		44,
		30,
		32,
		24,
		14,
		0,
		27,
		33,
		48,
		-1,
		-1,
		129,
		134,
		122,
		108,
		127,
		-1,
		-1,
		-1,
		128,
		144,
		136,
		107,
		104,
		-1,
		-1,
		87,
		78,
		68,
		47,
		34,
		41,
		36,
		21,
		7,
		15,
		27,
		43,
		47,
		-1,
		132,
		119,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		-1,
		-1,
		155,
		100,
		89,
		84,
		88,
		86,
		-1,
		60,
		58,
		38,
		48,
		55,
		23,
		20,
		14,
		17,
		34,
		50,
		-1,
		-1,
		144,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		112,
		106,
		77,
		70,
		74,
		-1,
		62,
		54,
		40,
		54,
		38,
		35,
		26,
		18,
		23,
		20,
		33,
		47,
		51,
		167,
		-1,
		150,
		-1,
		-1,
		-1,
		130,
		145,
		116,
		93,
		66,
		61,
		54,
		48,
		48,
		60,
		46,
		57,
		25,
		21,
		22,
		26,
		25,
		42,
		52,
		-1,
		-1,
		150,
		151,
		156,
		138,
		142,
		143,
		-1,
		-1,
		70,
		61,
		52,
		52,
		58,
		61,
		31,
		28,
		33,
		38,
		26,
		35,
		53,
		57,
		-1,
		-1,
		-1,
		167,
		-1,
		169,
		-1,
		-1,
		157,
		141,
		88,
		70,
		66,
		64,
		57,
		55,
		43,
		36,
		46,
		56,
		48,
		28,
		48,
		63,
		60,
		89,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		146,
		138,
		133,
		139,
		141,
		132,
		103,
		100,
		-1,
		70,
		84,
		49,
		56,
		48,
		54,
		54,
		52,
		33,
		45,
		61,
		60,
		55,
		81,
		76,
		85,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		139,
		135,
		125,
		115,
		118,
		-1,
		-1,
		112,
		109,
		81,
		58,
		64,
		57,
		52,
		67,
		47,
		34,
		38,
		42,
		48,
		53,
		58,
		64,
		79,
		91,
		-1,
		177,
		223,
		216,
		184,
		192,
		223,
		-1,
		129,
		121,
		132,
		107,
		109,
		-1,
		-1,
		85,
		76,
		77,
		65,
		62,
		75,
		72,
		63,
		48,
		54,
		41,
		40,
		58,
		62,
		71,
		78,
		68,
		81,
		85,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		126,
		-1,
		-1,
		138,
		110,
		94,
		84,
		81,
		124,
		79,
		74,
		71,
		69,
		60,
		51,
		58,
		49,
		49,
		52,
		67,
		72,
		64,
		78,
		78,
		79,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		154,
		-1,
		121,
		-1,
		104,
		108,
		87,
		90,
		85,
		72,
		64,
		56,
		72,
		47,
		57,
		53,
		54,
		63,
		74,
		86,
		85,
		86,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		138,
		177,
		184,
		-1,
		163,
		-1,
		-1,
		-1,
		118,
		100,
		92,
		105,
		84,
		84,
		58,
		62,
		52,
		59,
		69,
		71,
		63,
		67,
		80,
		91,
		94,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		153,
		144,
		171,
		191,
		180,
		175,
		162,
		-1,
		-1,
		141,
		110,
		-1,
		-1,
		91,
		79,
		62,
		63,
		59,
		62,
		77,
		80,
		70,
		68,
		62,
		94,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		151,
		172,
		162,
		166,
		182,
		207,
		-1,
		151,
		-1,
		-1,
		136,
		-1,
		-1,
		121,
		84,
		73,
		64,
		70,
		67,
		78,
		88,
		76,
		77,
		67,
		77,
		90,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		138,
		136,
		142,
		149,
		166,
		196,
		-1,
		-1,
		167,
		147,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		69,
		74,
		94,
		96,
		85,
		79,
		73,
		80,
		79,
		87,
		95,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		157,
		153,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		83,
		87,
		91,
		83,
		76,
		71,
		82,
		74,
		78,
		95,
		-1,
		209,
		-1,
		161,
		137,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		174,
		160,
		153,
		141,
		139,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		127,
		95,
		100,
		95,
		77,
		88,
		77,
		80,
		94,
		89,
		-1,
		-1,
		149,
		152,
		-1,
		-1,
		164,
		166,
		-1,
		165,
		154,
		139,
		131,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		109,
		98,
		106,
		101,
		81,
		87,
		90,
		79,
		83,
		95,
		-1,
		-1,
		156,
		157,
		162,
		-1,
		149,
		-1,
		167,
		-1,
		134,
		140,
		128,
		-1,
		-1,
		-1,
		122,
		85,
		106,
		116,
		110,
		108,
		99,
		85,
		92,
		90,
		86,
		97,
		-1,
		-1,
		-1,
		167,
		141,
		174,
		165,
		148,
		128,
		120,
		139,
		-1,
		109,
		-1,
		84,
		86,
		112,
		115,
		121,
		115,
		88,
		103,
		93,
		84,
		93,
		173,
		-1,
		143,
		176,
		140,
		134,
		110,
		114,
		130,
		-1,
		106,
		88,
		-1,
		116,
		106,
		137,
		122,
		103,
		90,
		97,
		97,
		90,
		-1,
		-1,
		-1,
		145,
		144,
		136,
		130,
		130,
		115,
		106,
		-1,
		118,
		100,
		79,
		96,
		96,
		87,
		95,
		127,
		123,
		110,
		110,
		102,
		-1,
		246,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		139,
		134,
		107,
		95,
		101,
		97,
		83,
		89,
		91,
		99,
		97,
		94,
		106,
		102,
		122,
		103,
		138,
		-1,
		241,
		-1,
		175,
		-1,
		-1,
		157,
		137,
		129,
		118,
		107,
		105,
		96,
		87,
		109,
		125,
		109,
		107,
		110,
		111,
		-1,
		230,
		229,
		-1,
		176,
		168,
		154,
		-1,
		147,
		-1,
		153,
		114,
		-1,
		116,
		96,
		-1,
		118,
		114,
		-1,
		-1,
		217,
		192,
		-1,
		-1,
		-1,
		177,
		157,
		148,
		132,
		-1,
		107,
		107,
		-1,
		-1,
		-1,
		202,
		201,
		-1,
		170,
		173,
		-1,
		163,
		154,
		162,
		109,
		113,
		-1,
		-1,
		-1,
		211,
		192,
		186,
		185,
		183,
		178,
		175,
		161,
		145,
		123,
		112,
		133,
		-1,
		-1,
		-1,
		183,
		175,
		168,
		-1,
		-1,
		170,
		153,
		134,
		132,
		-1,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		160,
		-1,
		-1,
		166,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		194,
		-1,
		-1,
		-1,
		156,
		152,
		153,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		240,
		204,
		-1,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		219,
		217,
		-1,
		-1,
		-1,
		176,
		160,
		-1,
		146,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		181,
		-1,
		181,
		156,
		163,
		-1,
		-1,
		-1,
		-1,
		194,
		186,
		194,
		-1,
		166,
		168,
		-1,
		216,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		171,
		178,
		200,
		203,
		239,
		-1,
		190
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		130,
		148,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		127,
		-1,
		139,
		140,
		135,
		143,
		143,
		119,
		106,
		106,
		116,
		109,
		128,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		122,
		139,
		131,
		121,
		136,
		129,
		109,
		106,
		104,
		101,
		117,
		115,
		125,
		-1,
		-1,
		230,
		199,
		230,
		188,
		169,
		-1,
		135,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		95,
		94,
		122,
		108,
		119,
		190,
		-1,
		-1,
		188,
		180,
		165,
		168,
		145,
		141,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		89,
		99,
		103,
		101,
		126,
		-1,
		-1,
		142,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		151,
		157,
		143,
		164,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		86,
		111,
		115,
		96,
		117,
		112,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		180,
		-1,
		152,
		140,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		90,
		88,
		118,
		93,
		115,
		107,
		112,
		117,
		111,
		120,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		188,
		189,
		164,
		137,
		140,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		82,
		97,
		88,
		87,
		96,
		96,
		104,
		108,
		114,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		189,
		181,
		166,
		164,
		-1,
		136,
		133,
		123,
		101,
		86,
		103,
		95,
		93,
		95,
		77,
		91,
		82,
		100,
		100,
		86,
		90,
		110,
		122,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		138,
		151,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		88,
		73,
		70,
		88,
		91,
		79,
		83,
		99,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		121,
		118,
		106,
		93,
		78,
		79,
		87,
		99,
		78,
		72,
		69,
		89,
		96,
		74,
		85,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		117,
		96,
		87,
		76,
		74,
		87,
		79,
		87,
		67,
		65,
		84,
		77,
		68,
		76,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		130,
		113,
		94,
		83,
		75,
		64,
		75,
		83,
		81,
		63,
		72,
		78,
		83,
		64,
		70,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		103,
		88,
		83,
		80,
		67,
		66,
		80,
		80,
		70,
		65,
		72,
		88,
		88,
		54,
		73,
		76,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		90,
		86,
		71,
		75,
		77,
		80,
		68,
		74,
		75,
		57,
		81,
		-1,
		62,
		56,
		63,
		53,
		42,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		83,
		78,
		77,
		76,
		73,
		62,
		75,
		68,
		62,
		56,
		69,
		73,
		61,
		44,
		40,
		37,
		51,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		105,
		89,
		88,
		85,
		76,
		84,
		57,
		50,
		61,
		46,
		64,
		58,
		48,
		38,
		30,
		47,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		95,
		112,
		113,
		91,
		85,
		83,
		74,
		62,
		51,
		54,
		46,
		60,
		52,
		36,
		33,
		26,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		109,
		107,
		102,
		93,
		99,
		94,
		71,
		66,
		56,
		45,
		45,
		40,
		58,
		44,
		42,
		24,
		40,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		110,
		94,
		99,
		-1,
		91,
		-1,
		64,
		61,
		52,
		37,
		34,
		45,
		43,
		41,
		19,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		126,
		106,
		100,
		99,
		86,
		78,
		72,
		50,
		43,
		40,
		30,
		41,
		38,
		33,
		17,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		133,
		121,
		111,
		101,
		104,
		94,
		69,
		62,
		48,
		50,
		42,
		31,
		18,
		0,
		11,
		30,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		154,
		125,
		122,
		-1,
		-1,
		105,
		96,
		86,
		65,
		52,
		57,
		52,
		39,
		25,
		19,
		18,
		24,
		30,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		173,
		118,
		107,
		102,
		106,
		104,
		-1,
		78,
		76,
		56,
		66,
		73,
		41,
		38,
		32,
		30,
		21,
		32,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		130,
		124,
		95,
		88,
		92,
		-1,
		80,
		72,
		58,
		72,
		56,
		53,
		44,
		36,
		41,
		27,
		34,
		44,
		34,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		148,
		163,
		134,
		111,
		84,
		79,
		72,
		66,
		66,
		78,
		64,
		75,
		43,
		39,
		40,
		33,
		32,
		48,
		49,
		-1,
		-1,
		168,
		169,
		174,
		156,
		160,
		161,
		-1,
		-1,
		88,
		79,
		70,
		70,
		76,
		79,
		49,
		46,
		51,
		50,
		43,
		42,
		60,
		52,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		159,
		106,
		88,
		84,
		82,
		75,
		73,
		61,
		54,
		64,
		68,
		60,
		40,
		58,
		70,
		60,
		86,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		121,
		118,
		-1,
		88,
		102,
		67,
		74,
		66,
		72,
		72,
		64,
		45,
		59,
		75,
		72,
		69,
		78,
		73,
		82,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		99,
		76,
		82,
		75,
		70,
		82,
		62,
		49,
		52,
		56,
		62,
		67,
		72,
		78,
		80,
		88,
		-1,
		195,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		92,
		87,
		78,
		63,
		69,
		56,
		54,
		72,
		76,
		85,
		92,
		82,
		95,
		99,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		97,
		92,
		86,
		84,
		75,
		66,
		73,
		64,
		63,
		66,
		82,
		87,
		79,
		92,
		92,
		93,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		139,
		-1,
		122,
		126,
		105,
		108,
		100,
		87,
		79,
		71,
		87,
		62,
		71,
		67,
		69,
		78,
		89,
		101,
		99,
		100,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		199,
		-1,
		181,
		-1,
		-1,
		-1,
		136,
		118,
		110,
		120,
		99,
		99,
		73,
		77,
		67,
		74,
		83,
		85,
		78,
		82,
		95,
		106,
		108,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		206,
		195,
		190,
		177,
		-1,
		-1,
		159,
		128,
		-1,
		-1,
		106,
		94,
		77,
		78,
		74,
		77,
		92,
		94,
		85,
		83,
		77,
		109,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		200,
		225,
		-1,
		166,
		-1,
		-1,
		151,
		-1,
		-1,
		136,
		99,
		88,
		79,
		85,
		82,
		93,
		103,
		91,
		92,
		82,
		92,
		105,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		182,
		162,
		-1,
		-1,
		134,
		132,
		121,
		-1,
		111,
		84,
		89,
		109,
		111,
		100,
		94,
		88,
		95,
		94,
		102,
		110,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		172,
		168,
		-1,
		-1,
		129,
		122,
		110,
		98,
		88,
		98,
		102,
		106,
		98,
		91,
		86,
		97,
		89,
		93,
		110,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		189,
		175,
		168,
		156,
		154,
		-1,
		163,
		147,
		128,
		-1,
		98,
		111,
		142,
		110,
		115,
		110,
		92,
		103,
		92,
		95,
		109,
		104,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		179,
		181,
		-1,
		180,
		169,
		154,
		146,
		-1,
		-1,
		135,
		131,
		-1,
		-1,
		99,
		124,
		113,
		121,
		116,
		96,
		102,
		105,
		94,
		98,
		110,
		-1,
		-1,
		174,
		175,
		180,
		-1,
		164,
		-1,
		182,
		-1,
		149,
		155,
		143,
		-1,
		-1,
		-1,
		137,
		100,
		121,
		131,
		125,
		123,
		114,
		100,
		107,
		105,
		101,
		112,
		-1,
		-1,
		-1,
		182,
		156,
		189,
		180,
		163,
		143,
		135,
		154,
		-1,
		124,
		-1,
		99,
		101,
		127,
		130,
		136,
		130,
		103,
		118,
		108,
		99,
		108,
		188,
		-1,
		158,
		191,
		155,
		149,
		125,
		129,
		145,
		-1,
		121,
		103,
		-1,
		131,
		121,
		152,
		137,
		118,
		105,
		112,
		112,
		105,
		-1,
		-1,
		-1,
		160,
		159,
		151,
		145,
		145,
		130,
		121,
		-1,
		133,
		115,
		94,
		111,
		111,
		102,
		110,
		142,
		138,
		125,
		125,
		117,
		-1,
		261,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		154,
		149,
		122,
		110,
		116,
		112,
		98,
		104,
		106,
		114,
		112,
		109,
		121,
		117,
		137,
		118,
		153,
		-1,
		256,
		-1,
		190,
		-1,
		-1,
		172,
		152,
		144,
		133,
		122,
		120,
		111,
		102,
		124,
		140,
		124,
		122,
		125,
		126,
		-1,
		245,
		244,
		-1,
		191,
		183,
		169,
		-1,
		162,
		-1,
		168,
		129,
		-1,
		131,
		111,
		-1,
		133,
		129,
		-1,
		-1,
		232,
		207,
		-1,
		-1,
		-1,
		192,
		172,
		163,
		147,
		-1,
		122,
		122,
		-1,
		-1,
		-1,
		217,
		216,
		-1,
		185,
		188,
		-1,
		178,
		169,
		177,
		124,
		128,
		-1,
		-1,
		-1,
		226,
		207,
		201,
		200,
		198,
		193,
		190,
		176,
		160,
		138,
		127,
		148,
		-1,
		-1,
		-1,
		198,
		190,
		183,
		-1,
		-1,
		185,
		168,
		149,
		147,
		-1,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		175,
		-1,
		-1,
		181,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		209,
		-1,
		-1,
		-1,
		171,
		167,
		168,
		-1,
		-1,
		-1,
		-1,
		231,
		232,
		255,
		219,
		-1,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		234,
		232,
		-1,
		-1,
		-1,
		191,
		175,
		-1,
		161,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		196,
		-1,
		196,
		171,
		178,
		-1,
		-1,
		-1,
		-1,
		209,
		201,
		209,
		-1,
		181,
		183,
		-1,
		231,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		186,
		193,
		215,
		218,
		254,
		-1,
		205
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		198,
		202,
		168,
		162,
		201,
		170,
		176,
		187,
		-1,
		-1,
		-1,
		191,
		190,
		158,
		156,
		165,
		170,
		177,
		-1,
		176,
		-1,
		212,
		191,
		202,
		207,
		151,
		148,
		168,
		187,
		169,
		161,
		227,
		181,
		152,
		146,
		164,
		154,
		163,
		155,
		-1,
		152,
		142,
		164,
		143,
		154,
		146,
		-1,
		-1,
		146,
		147,
		153,
		139,
		145,
		141,
		-1,
		151,
		135,
		-1,
		-1,
		136,
		137,
		121,
		124,
		132,
		130,
		143,
		135,
		130,
		-1,
		-1,
		127,
		123,
		130,
		117,
		113,
		130,
		143,
		125,
		139,
		138,
		-1,
		133,
		151,
		156,
		124,
		122,
		106,
		104,
		122,
		124,
		130,
		130,
		-1,
		142,
		143,
		138,
		146,
		146,
		122,
		109,
		109,
		119,
		112,
		131,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		125,
		142,
		134,
		124,
		139,
		132,
		112,
		109,
		107,
		104,
		120,
		118,
		128,
		-1,
		-1,
		233,
		202,
		233,
		191,
		172,
		-1,
		138,
		118,
		124,
		128,
		122,
		115,
		129,
		125,
		-1,
		98,
		97,
		125,
		111,
		122,
		193,
		-1,
		-1,
		191,
		183,
		168,
		171,
		148,
		144,
		133,
		132,
		124,
		110,
		106,
		112,
		115,
		115,
		121,
		92,
		102,
		106,
		104,
		117,
		-1,
		-1,
		131,
		-1,
		-1,
		190,
		173,
		-1,
		156,
		163,
		154,
		160,
		146,
		167,
		143,
		134,
		126,
		120,
		108,
		110,
		107,
		120,
		108,
		89,
		114,
		118,
		99,
		107,
		102,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		149,
		152,
		158,
		182,
		183,
		-1,
		155,
		143,
		144,
		129,
		126,
		113,
		101,
		114,
		99,
		106,
		105,
		93,
		91,
		121,
		96,
		106,
		96,
		101,
		106,
		100,
		109,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		186,
		-1,
		191,
		192,
		167,
		140,
		143,
		130,
		121,
		108,
		97,
		108,
		97,
		94,
		102,
		85,
		100,
		91,
		90,
		85,
		85,
		93,
		97,
		103,
		-1,
		248,
		-1,
		190,
		174,
		176,
		148,
		169,
		-1,
		206,
		192,
		184,
		169,
		167,
		-1,
		139,
		136,
		126,
		104,
		89,
		106,
		98,
		96,
		98,
		80,
		94,
		85,
		91,
		89,
		75,
		79,
		99,
		111,
		208,
		198,
		-1,
		180,
		185,
		144,
		152,
		171,
		209,
		173,
		-1,
		168,
		-1,
		141,
		154,
		-1,
		110,
		106,
		88,
		89,
		84,
		99,
		91,
		76,
		73,
		87,
		82,
		68,
		72,
		88,
		-1,
		-1,
		193,
		197,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		124,
		121,
		109,
		96,
		81,
		82,
		90,
		102,
		81,
		75,
		72,
		78,
		85,
		63,
		74,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		120,
		99,
		90,
		79,
		77,
		90,
		82,
		90,
		70,
		68,
		73,
		66,
		57,
		65,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		133,
		116,
		97,
		86,
		78,
		67,
		78,
		86,
		84,
		66,
		75,
		67,
		72,
		53,
		59,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		106,
		91,
		86,
		83,
		70,
		69,
		83,
		83,
		73,
		68,
		75,
		77,
		77,
		43,
		62,
		65,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		93,
		89,
		74,
		78,
		80,
		83,
		71,
		77,
		78,
		60,
		84,
		-1,
		51,
		45,
		52,
		42,
		31,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		86,
		81,
		80,
		79,
		76,
		65,
		78,
		71,
		65,
		59,
		72,
		66,
		50,
		33,
		29,
		26,
		40,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		108,
		92,
		91,
		88,
		79,
		87,
		60,
		53,
		64,
		49,
		67,
		47,
		37,
		27,
		19,
		36,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		98,
		115,
		116,
		94,
		88,
		86,
		77,
		65,
		54,
		57,
		49,
		49,
		41,
		25,
		22,
		15,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		112,
		110,
		105,
		96,
		102,
		97,
		74,
		69,
		59,
		48,
		48,
		43,
		47,
		33,
		31,
		13,
		29,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		113,
		97,
		102,
		-1,
		94,
		-1,
		67,
		64,
		55,
		40,
		37,
		43,
		34,
		30,
		8,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		129,
		109,
		103,
		102,
		89,
		81,
		75,
		53,
		46,
		43,
		33,
		46,
		43,
		22,
		6,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		135,
		123,
		113,
		103,
		107,
		97,
		72,
		65,
		51,
		53,
		45,
		35,
		23,
		8,
		0,
		22,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		124,
		-1,
		-1,
		107,
		99,
		89,
		68,
		55,
		62,
		57,
		44,
		28,
		24,
		14,
		13,
		22,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		175,
		120,
		109,
		104,
		108,
		106,
		-1,
		80,
		79,
		59,
		71,
		78,
		46,
		34,
		28,
		19,
		19,
		24,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		97,
		90,
		94,
		-1,
		82,
		75,
		61,
		77,
		52,
		49,
		40,
		30,
		30,
		16,
		29,
		36,
		26,
		188,
		-1,
		169,
		-1,
		-1,
		-1,
		150,
		165,
		136,
		113,
		86,
		81,
		74,
		68,
		69,
		74,
		60,
		71,
		37,
		33,
		29,
		22,
		21,
		38,
		41,
		-1,
		-1,
		167,
		163,
		176,
		158,
		162,
		163,
		-1,
		-1,
		90,
		81,
		72,
		64,
		77,
		78,
		43,
		40,
		45,
		39,
		32,
		31,
		49,
		44,
		-1,
		-1,
		-1,
		179,
		-1,
		181,
		-1,
		-1,
		169,
		161,
		108,
		90,
		86,
		84,
		73,
		67,
		55,
		48,
		58,
		57,
		49,
		29,
		47,
		59,
		52,
		78,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		158,
		150,
		145,
		151,
		153,
		144,
		123,
		120,
		-1,
		90,
		96,
		61,
		68,
		60,
		64,
		61,
		53,
		34,
		48,
		64,
		63,
		58,
		70,
		65,
		74,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		151,
		147,
		137,
		127,
		130,
		-1,
		-1,
		124,
		121,
		93,
		70,
		73,
		66,
		61,
		71,
		51,
		38,
		41,
		45,
		51,
		56,
		61,
		67,
		72,
		80,
		-1,
		198,
		235,
		228,
		196,
		204,
		235,
		-1,
		141,
		133,
		144,
		119,
		121,
		-1,
		-1,
		97,
		88,
		89,
		77,
		74,
		81,
		76,
		67,
		52,
		58,
		45,
		43,
		61,
		65,
		74,
		81,
		71,
		84,
		88,
		-1,
		191,
		211,
		190,
		193,
		217,
		231,
		-1,
		138,
		-1,
		-1,
		150,
		122,
		106,
		96,
		93,
		136,
		91,
		86,
		75,
		73,
		64,
		55,
		62,
		53,
		52,
		55,
		71,
		76,
		68,
		81,
		81,
		82,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		166,
		-1,
		133,
		-1,
		116,
		120,
		99,
		102,
		89,
		76,
		68,
		60,
		76,
		51,
		60,
		56,
		58,
		67,
		78,
		90,
		88,
		89,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		150,
		189,
		188,
		-1,
		172,
		-1,
		-1,
		-1,
		130,
		112,
		104,
		109,
		88,
		88,
		62,
		66,
		56,
		63,
		72,
		74,
		67,
		71,
		84,
		95,
		97,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		165,
		156,
		183,
		195,
		184,
		179,
		166,
		-1,
		-1,
		153,
		122,
		-1,
		-1,
		95,
		83,
		66,
		67,
		63,
		66,
		81,
		83,
		74,
		72,
		66,
		98,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		163,
		184,
		174,
		178,
		194,
		219,
		-1,
		155,
		-1,
		-1,
		140,
		-1,
		-1,
		125,
		88,
		77,
		68,
		74,
		71,
		82,
		92,
		80,
		81,
		71,
		81,
		94,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		150,
		148,
		154,
		161,
		178,
		208,
		-1,
		-1,
		171,
		151,
		-1,
		-1,
		123,
		121,
		110,
		-1,
		100,
		73,
		78,
		98,
		100,
		89,
		83,
		77,
		84,
		83,
		91,
		99,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		161,
		157,
		-1,
		-1,
		118,
		111,
		99,
		87,
		77,
		87,
		91,
		95,
		87,
		80,
		75,
		86,
		78,
		82,
		99,
		-1,
		221,
		-1,
		173,
		149,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		178,
		164,
		157,
		145,
		143,
		-1,
		152,
		136,
		117,
		-1,
		87,
		100,
		131,
		99,
		104,
		99,
		81,
		92,
		81,
		84,
		98,
		93,
		-1,
		-1,
		161,
		164,
		-1,
		-1,
		168,
		170,
		-1,
		169,
		158,
		143,
		135,
		-1,
		-1,
		124,
		120,
		-1,
		-1,
		88,
		113,
		102,
		110,
		105,
		85,
		91,
		94,
		83,
		87,
		99,
		-1,
		-1,
		168,
		169,
		174,
		-1,
		153,
		-1,
		171,
		-1,
		138,
		144,
		132,
		-1,
		-1,
		-1,
		126,
		89,
		110,
		120,
		114,
		112,
		103,
		89,
		96,
		94,
		90,
		101,
		-1,
		-1,
		-1,
		171,
		145,
		178,
		169,
		152,
		132,
		124,
		143,
		-1,
		113,
		-1,
		88,
		90,
		116,
		119,
		125,
		119,
		92,
		107,
		97,
		88,
		97,
		177,
		-1,
		147,
		180,
		144,
		138,
		114,
		118,
		134,
		-1,
		110,
		92,
		-1,
		120,
		110,
		141,
		126,
		107,
		94,
		101,
		101,
		94,
		-1,
		-1,
		-1,
		149,
		148,
		140,
		134,
		134,
		119,
		110,
		-1,
		122,
		104,
		83,
		100,
		100,
		91,
		99,
		131,
		127,
		114,
		114,
		106,
		-1,
		250,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		143,
		138,
		111,
		99,
		105,
		101,
		87,
		93,
		95,
		103,
		101,
		98,
		110,
		106,
		126,
		107,
		142,
		-1,
		245,
		-1,
		179,
		-1,
		-1,
		161,
		141,
		133,
		122,
		111,
		109,
		100,
		91,
		113,
		129,
		113,
		111,
		114,
		115,
		-1,
		234,
		233,
		-1,
		180,
		172,
		158,
		-1,
		151,
		-1,
		157,
		118,
		-1,
		120,
		100,
		-1,
		122,
		118,
		-1,
		-1,
		221,
		196,
		-1,
		-1,
		-1,
		181,
		161,
		152,
		136,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		206,
		205,
		-1,
		174,
		177,
		-1,
		167,
		158,
		166,
		113,
		117,
		-1,
		-1,
		-1,
		215,
		196,
		190,
		189,
		187,
		182,
		179,
		165,
		149,
		127,
		116,
		137,
		-1,
		-1,
		-1,
		187,
		179,
		172,
		-1,
		-1,
		174,
		157,
		138,
		136,
		-1,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		164,
		-1,
		-1,
		170,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		198,
		-1,
		-1,
		-1,
		160,
		156,
		157,
		-1,
		-1,
		-1,
		-1,
		220,
		221,
		244,
		208,
		-1,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		223,
		221,
		-1,
		-1,
		-1,
		180,
		164,
		-1,
		150,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		185,
		-1,
		185,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		198,
		190,
		198,
		-1,
		170,
		172,
		-1,
		220,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		175,
		182,
		204,
		207,
		243,
		-1,
		194
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		142,
		160,
		169,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		151,
		152,
		147,
		155,
		160,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		244,
		213,
		242,
		200,
		181,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		113,
		112,
		140,
		126,
		137,
		204,
		-1,
		-1,
		202,
		194,
		177,
		180,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		107,
		117,
		121,
		119,
		125,
		-1,
		-1,
		139,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		163,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		104,
		129,
		133,
		114,
		115,
		110,
		-1,
		138,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		192,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		108,
		106,
		136,
		111,
		114,
		104,
		109,
		114,
		108,
		117,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		200,
		201,
		176,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		100,
		115,
		106,
		105,
		93,
		93,
		101,
		105,
		111,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		201,
		193,
		178,
		178,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		110,
		95,
		109,
		100,
		99,
		97,
		83,
		87,
		107,
		119,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		220,
		184,
		-1,
		179,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		106,
		91,
		88,
		95,
		90,
		76,
		80,
		96,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		177,
		166,
		165,
		-1,
		156,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		112,
		91,
		90,
		87,
		86,
		93,
		71,
		82,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		195,
		188,
		176,
		141,
		141,
		135,
		-1,
		129,
		108,
		99,
		88,
		86,
		99,
		96,
		105,
		85,
		83,
		81,
		74,
		65,
		73,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		140,
		163,
		200,
		174,
		160,
		165,
		140,
		133,
		127,
		142,
		125,
		106,
		95,
		87,
		76,
		92,
		100,
		99,
		81,
		90,
		75,
		80,
		61,
		67,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		154,
		161,
		193,
		165,
		178,
		-1,
		132,
		-1,
		121,
		116,
		100,
		95,
		92,
		85,
		83,
		92,
		98,
		88,
		83,
		90,
		85,
		85,
		51,
		70,
		73,
		-1,
		-1,
		-1,
		204,
		199,
		174,
		151,
		135,
		171,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		102,
		98,
		89,
		93,
		90,
		97,
		86,
		92,
		93,
		75,
		99,
		-1,
		59,
		53,
		60,
		50,
		39,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		130,
		182,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		101,
		96,
		94,
		94,
		91,
		80,
		93,
		86,
		80,
		74,
		87,
		74,
		58,
		41,
		37,
		34,
		48,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		150,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		122,
		106,
		106,
		103,
		94,
		102,
		75,
		68,
		79,
		64,
		82,
		55,
		45,
		35,
		27,
		44,
		-1,
		217,
		203,
		174,
		-1,
		-1,
		163,
		-1,
		127,
		141,
		157,
		-1,
		150,
		129,
		144,
		122,
		118,
		113,
		129,
		130,
		108,
		103,
		101,
		92,
		80,
		69,
		72,
		64,
		57,
		49,
		33,
		30,
		23,
		-1,
		223,
		210,
		168,
		164,
		153,
		173,
		124,
		112,
		144,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		127,
		125,
		119,
		110,
		116,
		112,
		89,
		84,
		74,
		63,
		63,
		58,
		55,
		41,
		39,
		21,
		37,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		139,
		126,
		120,
		-1,
		161,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		127,
		111,
		116,
		-1,
		109,
		-1,
		82,
		79,
		70,
		55,
		52,
		51,
		42,
		31,
		16,
		-1,
		173,
		158,
		151,
		141,
		155,
		126,
		-1,
		181,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		143,
		123,
		117,
		116,
		104,
		96,
		90,
		68,
		61,
		58,
		48,
		59,
		56,
		23,
		14,
		-1,
		-1,
		-1,
		178,
		164,
		168,
		128,
		147,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		151,
		139,
		129,
		119,
		122,
		112,
		87,
		80,
		66,
		68,
		60,
		49,
		36,
		24,
		16,
		0,
		-1,
		-1,
		161,
		166,
		154,
		140,
		159,
		-1,
		-1,
		-1,
		160,
		176,
		168,
		139,
		140,
		-1,
		-1,
		123,
		114,
		104,
		83,
		70,
		75,
		70,
		57,
		43,
		37,
		27,
		16,
		21,
		-1,
		164,
		151,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		-1,
		-1,
		191,
		136,
		125,
		120,
		124,
		122,
		-1,
		96,
		94,
		74,
		84,
		91,
		59,
		50,
		44,
		35,
		32,
		23,
		-1,
		-1,
		176,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		148,
		142,
		113,
		106,
		110,
		-1,
		98,
		90,
		76,
		90,
		68,
		65,
		56,
		46,
		46,
		32,
		45,
		35,
		25,
		199,
		-1,
		182,
		-1,
		-1,
		-1,
		166,
		181,
		152,
		129,
		102,
		97,
		90,
		84,
		84,
		90,
		76,
		87,
		53,
		49,
		45,
		38,
		37,
		39,
		40,
		-1,
		-1,
		182,
		179,
		192,
		174,
		178,
		179,
		-1,
		-1,
		106,
		97,
		88,
		80,
		93,
		94,
		59,
		56,
		61,
		55,
		48,
		47,
		58,
		43,
		-1,
		-1,
		-1,
		195,
		-1,
		197,
		-1,
		-1,
		185,
		177,
		124,
		106,
		102,
		100,
		89,
		83,
		71,
		64,
		74,
		73,
		65,
		45,
		63,
		75,
		51,
		77,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		169,
		160,
		139,
		136,
		-1,
		106,
		112,
		77,
		84,
		76,
		80,
		77,
		69,
		50,
		64,
		75,
		63,
		62,
		69,
		64,
		73,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		140,
		137,
		109,
		86,
		89,
		82,
		77,
		87,
		67,
		54,
		57,
		61,
		67,
		60,
		65,
		71,
		71,
		79,
		-1,
		209,
		251,
		244,
		212,
		220,
		251,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		113,
		104,
		105,
		93,
		90,
		97,
		92,
		83,
		68,
		74,
		61,
		59,
		77,
		81,
		78,
		85,
		74,
		87,
		91,
		-1,
		207,
		227,
		206,
		209,
		233,
		247,
		-1,
		154,
		-1,
		-1,
		166,
		138,
		122,
		112,
		109,
		152,
		107,
		102,
		91,
		89,
		80,
		71,
		78,
		69,
		68,
		71,
		87,
		92,
		84,
		84,
		84,
		85,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		149,
		-1,
		132,
		136,
		115,
		118,
		105,
		92,
		84,
		76,
		92,
		67,
		76,
		72,
		74,
		83,
		94,
		105,
		91,
		92,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		166,
		205,
		204,
		-1,
		188,
		-1,
		-1,
		-1,
		146,
		128,
		120,
		125,
		104,
		104,
		78,
		82,
		72,
		79,
		88,
		90,
		83,
		87,
		100,
		101,
		100,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		181,
		172,
		199,
		211,
		200,
		195,
		182,
		-1,
		-1,
		169,
		138,
		-1,
		-1,
		111,
		99,
		82,
		83,
		79,
		82,
		97,
		99,
		90,
		88,
		82,
		106,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		200,
		190,
		194,
		210,
		235,
		-1,
		171,
		-1,
		-1,
		156,
		-1,
		-1,
		141,
		104,
		93,
		84,
		90,
		87,
		98,
		108,
		96,
		97,
		87,
		97,
		110,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		166,
		164,
		170,
		177,
		194,
		224,
		-1,
		-1,
		187,
		167,
		-1,
		-1,
		139,
		137,
		126,
		-1,
		116,
		89,
		94,
		114,
		116,
		105,
		99,
		93,
		100,
		99,
		107,
		115,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		177,
		173,
		-1,
		-1,
		134,
		127,
		115,
		103,
		93,
		103,
		107,
		111,
		103,
		96,
		91,
		102,
		94,
		98,
		115,
		-1,
		237,
		-1,
		189,
		165,
		179,
		194,
		202,
		-1,
		-1,
		-1,
		194,
		180,
		173,
		161,
		159,
		-1,
		168,
		152,
		133,
		-1,
		103,
		116,
		147,
		115,
		120,
		115,
		97,
		108,
		97,
		100,
		114,
		109,
		-1,
		-1,
		177,
		180,
		-1,
		-1,
		184,
		186,
		-1,
		185,
		174,
		159,
		151,
		-1,
		-1,
		140,
		136,
		-1,
		-1,
		104,
		129,
		118,
		126,
		121,
		101,
		107,
		110,
		99,
		103,
		115,
		-1,
		-1,
		184,
		185,
		190,
		-1,
		169,
		-1,
		187,
		-1,
		154,
		160,
		148,
		-1,
		-1,
		-1,
		142,
		105,
		126,
		136,
		130,
		128,
		119,
		105,
		112,
		110,
		106,
		117,
		-1,
		-1,
		-1,
		187,
		161,
		194,
		185,
		168,
		148,
		140,
		159,
		-1,
		129,
		-1,
		104,
		106,
		132,
		135,
		141,
		135,
		108,
		123,
		113,
		104,
		113,
		193,
		-1,
		163,
		196,
		160,
		154,
		130,
		134,
		150,
		-1,
		126,
		108,
		-1,
		136,
		126,
		157,
		142,
		123,
		110,
		117,
		117,
		110,
		-1,
		-1,
		-1,
		165,
		164,
		156,
		150,
		150,
		135,
		126,
		-1,
		138,
		120,
		99,
		116,
		116,
		107,
		115,
		147,
		143,
		130,
		130,
		122,
		-1,
		266,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		159,
		154,
		127,
		115,
		121,
		117,
		103,
		109,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		123,
		158,
		-1,
		261,
		-1,
		195,
		-1,
		-1,
		177,
		157,
		149,
		138,
		127,
		125,
		116,
		107,
		129,
		145,
		129,
		127,
		130,
		131,
		-1,
		250,
		249,
		-1,
		196,
		188,
		174,
		-1,
		167,
		-1,
		173,
		134,
		-1,
		136,
		116,
		-1,
		138,
		134,
		-1,
		-1,
		237,
		212,
		-1,
		-1,
		-1,
		197,
		177,
		168,
		152,
		-1,
		127,
		127,
		-1,
		-1,
		-1,
		222,
		221,
		-1,
		190,
		193,
		-1,
		183,
		174,
		182,
		129,
		133,
		-1,
		-1,
		-1,
		231,
		212,
		206,
		205,
		203,
		198,
		195,
		181,
		165,
		143,
		132,
		153,
		-1,
		-1,
		-1,
		203,
		195,
		188,
		-1,
		-1,
		190,
		173,
		154,
		152,
		-1,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		180,
		-1,
		-1,
		186,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		214,
		-1,
		-1,
		-1,
		176,
		172,
		173,
		-1,
		-1,
		-1,
		-1,
		236,
		237,
		260,
		224,
		-1,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		239,
		237,
		-1,
		-1,
		-1,
		196,
		180,
		-1,
		166,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		201,
		-1,
		201,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		214,
		206,
		214,
		-1,
		186,
		188,
		-1,
		236,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		191,
		198,
		220,
		223,
		259,
		-1,
		210
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		202,
		204,
		170,
		164,
		203,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		193,
		192,
		162,
		160,
		169,
		174,
		181,
		-1,
		204,
		-1,
		214,
		193,
		204,
		209,
		155,
		152,
		172,
		191,
		197,
		189,
		229,
		185,
		156,
		150,
		168,
		173,
		191,
		183,
		-1,
		156,
		146,
		168,
		172,
		184,
		167,
		-1,
		-1,
		150,
		151,
		157,
		169,
		174,
		179,
		-1,
		205,
		189,
		-1,
		-1,
		140,
		153,
		149,
		152,
		160,
		176,
		197,
		189,
		184,
		-1,
		-1,
		141,
		145,
		158,
		159,
		157,
		184,
		197,
		179,
		193,
		192,
		-1,
		129,
		147,
		156,
		165,
		171,
		160,
		158,
		176,
		178,
		184,
		187,
		-1,
		121,
		123,
		152,
		158,
		170,
		176,
		163,
		163,
		173,
		166,
		185,
		176,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		118,
		126,
		152,
		151,
		147,
		165,
		173,
		166,
		163,
		161,
		158,
		174,
		175,
		185,
		-1,
		-1,
		174,
		143,
		178,
		135,
		120,
		-1,
		114,
		133,
		139,
		143,
		148,
		156,
		170,
		166,
		-1,
		152,
		151,
		182,
		168,
		179,
		134,
		-1,
		-1,
		132,
		124,
		109,
		112,
		109,
		109,
		139,
		138,
		143,
		145,
		147,
		153,
		156,
		156,
		162,
		146,
		156,
		160,
		171,
		186,
		-1,
		-1,
		241,
		-1,
		-1,
		131,
		114,
		-1,
		97,
		104,
		104,
		121,
		111,
		132,
		147,
		151,
		159,
		161,
		149,
		151,
		148,
		161,
		149,
		143,
		168,
		172,
		166,
		187,
		182,
		-1,
		240,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		90,
		93,
		99,
		123,
		133,
		-1,
		154,
		152,
		176,
		170,
		167,
		154,
		142,
		155,
		140,
		147,
		146,
		150,
		152,
		185,
		163,
		185,
		182,
		211,
		216,
		210,
		219,
		-1,
		139,
		135,
		131,
		138,
		87,
		-1,
		-1,
		127,
		-1,
		141,
		154,
		161,
		156,
		159,
		171,
		162,
		149,
		138,
		149,
		138,
		135,
		143,
		152,
		163,
		158,
		157,
		175,
		190,
		203,
		207,
		213,
		-1,
		189,
		-1,
		131,
		115,
		117,
		89,
		110,
		-1,
		147,
		142,
		162,
		163,
		154,
		-1,
		157,
		160,
		167,
		145,
		130,
		147,
		139,
		137,
		142,
		147,
		161,
		152,
		170,
		177,
		185,
		189,
		209,
		221,
		149,
		139,
		-1,
		121,
		126,
		85,
		93,
		112,
		185,
		160,
		-1,
		155,
		-1,
		147,
		172,
		-1,
		151,
		147,
		129,
		130,
		125,
		140,
		146,
		143,
		140,
		158,
		161,
		178,
		182,
		198,
		-1,
		-1,
		134,
		138,
		127,
		78,
		97,
		121,
		158,
		153,
		142,
		141,
		-1,
		132,
		162,
		159,
		145,
		132,
		122,
		123,
		131,
		144,
		123,
		142,
		145,
		167,
		195,
		173,
		185,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		104,
		75,
		99,
		141,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		152,
		135,
		131,
		120,
		118,
		131,
		126,
		142,
		146,
		145,
		164,
		176,
		167,
		187,
		-1,
		-1,
		-1,
		134,
		123,
		124,
		73,
		96,
		130,
		150,
		136,
		141,
		116,
		109,
		103,
		155,
		152,
		119,
		127,
		119,
		108,
		122,
		130,
		134,
		143,
		152,
		158,
		182,
		182,
		188,
		-1,
		-1,
		141,
		131,
		115,
		117,
		114,
		87,
		94,
		126,
		141,
		138,
		-1,
		108,
		-1,
		97,
		105,
		104,
		110,
		122,
		108,
		113,
		124,
		136,
		149,
		145,
		152,
		187,
		187,
		172,
		192,
		195,
		-1,
		-1,
		-1,
		134,
		132,
		107,
		84,
		68,
		104,
		-1,
		108,
		109,
		-1,
		102,
		96,
		102,
		101,
		108,
		105,
		105,
		119,
		127,
		123,
		139,
		145,
		137,
		173,
		-1,
		180,
		174,
		182,
		172,
		160,
		-1,
		-1,
		-1,
		130,
		109,
		102,
		122,
		63,
		115,
		-1,
		-1,
		93,
		86,
		-1,
		89,
		89,
		96,
		105,
		110,
		115,
		123,
		118,
		131,
		136,
		142,
		147,
		165,
		169,
		173,
		162,
		158,
		155,
		169,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		83,
		-1,
		96,
		88,
		84,
		78,
		84,
		102,
		100,
		120,
		112,
		126,
		126,
		132,
		140,
		125,
		128,
		144,
		142,
		160,
		168,
		160,
		154,
		153,
		165,
		-1,
		150,
		136,
		107,
		-1,
		-1,
		96,
		-1,
		60,
		74,
		90,
		-1,
		118,
		97,
		120,
		98,
		112,
		108,
		146,
		147,
		125,
		130,
		138,
		148,
		150,
		139,
		150,
		142,
		164,
		164,
		148,
		149,
		158,
		-1,
		156,
		143,
		101,
		97,
		86,
		106,
		57,
		66,
		77,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		122,
		120,
		136,
		127,
		133,
		149,
		152,
		154,
		144,
		133,
		139,
		136,
		158,
		144,
		142,
		161,
		177,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		72,
		59,
		53,
		-1,
		94,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		144,
		128,
		133,
		-1,
		179,
		-1,
		152,
		154,
		148,
		133,
		130,
		141,
		139,
		150,
		167,
		-1,
		106,
		91,
		84,
		74,
		88,
		57,
		-1,
		100,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		160,
		140,
		134,
		133,
		174,
		174,
		160,
		146,
		139,
		136,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		111,
		3,
		11,
		47,
		66,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		177,
		165,
		155,
		145,
		179,
		180,
		165,
		158,
		144,
		146,
		144,
		142,
		147,
		168,
		169,
		182,
		-1,
		-1,
		0,
		13,
		22,
		59,
		78,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		166,
		-1,
		-1,
		157,
		155,
		165,
		161,
		148,
		168,
		171,
		157,
		141,
		156,
		168,
		176,
		181,
		-1,
		35,
		22,
		-1,
		-1,
		81,
		75,
		-1,
		-1,
		-1,
		-1,
		169,
		135,
		147,
		168,
		193,
		160,
		-1,
		165,
		166,
		152,
		166,
		173,
		159,
		154,
		148,
		151,
		169,
		186,
		-1,
		-1,
		95,
		-1,
		90,
		-1,
		-1,
		-1,
		-1,
		126,
		140,
		161,
		167,
		179,
		-1,
		174,
		168,
		154,
		171,
		172,
		169,
		160,
		152,
		157,
		154,
		167,
		181,
		185,
		118,
		-1,
		101,
		-1,
		-1,
		-1,
		144,
		159,
		221,
		198,
		171,
		175,
		168,
		162,
		162,
		178,
		180,
		191,
		159,
		155,
		156,
		160,
		159,
		176,
		186,
		-1,
		-1,
		101,
		118,
		153,
		152,
		156,
		248,
		-1,
		-1,
		184,
		175,
		166,
		169,
		172,
		175,
		165,
		162,
		167,
		172,
		160,
		169,
		187,
		191,
		-1,
		-1,
		-1,
		121,
		-1,
		136,
		-1,
		-1,
		171,
		255,
		202,
		184,
		180,
		178,
		171,
		180,
		175,
		170,
		180,
		189,
		181,
		162,
		173,
		196,
		185,
		223,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		150,
		125,
		140,
		186,
		191,
		182,
		217,
		214,
		-1,
		184,
		209,
		181,
		188,
		180,
		188,
		188,
		185,
		163,
		170,
		186,
		185,
		180,
		215,
		207,
		213,
		-1,
		-1,
		215,
		204,
		193,
		199,
		-1,
		156,
		142,
		172,
		162,
		168,
		-1,
		-1,
		215,
		212,
		206,
		190,
		194,
		187,
		182,
		192,
		172,
		159,
		163,
		167,
		173,
		178,
		183,
		189,
		204,
		219,
		-1,
		110,
		191,
		184,
		167,
		175,
		206,
		-1,
		159,
		168,
		149,
		154,
		162,
		-1,
		-1,
		188,
		184,
		189,
		197,
		194,
		202,
		197,
		188,
		173,
		179,
		166,
		165,
		183,
		187,
		196,
		203,
		193,
		206,
		210,
		-1,
		124,
		167,
		161,
		164,
		188,
		202,
		-1,
		172,
		-1,
		-1,
		157,
		175,
		183,
		179,
		183,
		236,
		211,
		206,
		196,
		194,
		185,
		176,
		183,
		174,
		174,
		177,
		192,
		197,
		189,
		203,
		203,
		204,
		-1,
		159,
		147,
		155,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		173,
		-1,
		209,
		-1,
		202,
		206,
		219,
		222,
		210,
		197,
		189,
		181,
		197,
		172,
		182,
		178,
		179,
		188,
		199,
		211,
		210,
		211,
		233,
		188,
		155,
		146,
		193,
		208,
		212,
		-1,
		185,
		224,
		211,
		-1,
		182,
		-1,
		-1,
		-1,
		216,
		232,
		224,
		230,
		209,
		209,
		183,
		187,
		177,
		184,
		194,
		196,
		188,
		192,
		205,
		216,
		219,
		229,
		227,
		232,
		177,
		160,
		178,
		187,
		208,
		200,
		191,
		218,
		218,
		207,
		202,
		189,
		-1,
		-1,
		239,
		242,
		-1,
		-1,
		216,
		204,
		187,
		188,
		184,
		187,
		202,
		205,
		195,
		193,
		187,
		219,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		168,
		179,
		-1,
		-1,
		203,
		219,
		232,
		236,
		249,
		274,
		-1,
		192,
		-1,
		-1,
		260,
		-1,
		-1,
		246,
		209,
		198,
		189,
		195,
		192,
		203,
		213,
		201,
		202,
		192,
		202,
		215,
		213,
		210,
		198,
		196,
		219,
		176,
		172,
		-1,
		204,
		206,
		212,
		219,
		236,
		263,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		244,
		242,
		231,
		-1,
		221,
		194,
		199,
		219,
		221,
		210,
		204,
		198,
		205,
		204,
		212,
		220,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		194,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		-1,
		243,
		218,
		-1,
		-1,
		239,
		232,
		220,
		208,
		198,
		208,
		212,
		216,
		208,
		201,
		196,
		207,
		199,
		203,
		220,
		-1,
		256,
		-1,
		208,
		201,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		260,
		246,
		239,
		227,
		225,
		-1,
		273,
		257,
		238,
		-1,
		208,
		221,
		252,
		220,
		225,
		220,
		202,
		213,
		202,
		205,
		219,
		214,
		-1,
		-1,
		214,
		217,
		-1,
		-1,
		239,
		258,
		-1,
		251,
		240,
		225,
		217,
		-1,
		-1,
		245,
		241,
		-1,
		-1,
		209,
		234,
		223,
		231,
		226,
		206,
		212,
		215,
		204,
		208,
		220,
		-1,
		-1,
		221,
		222,
		227,
		-1,
		248,
		-1,
		275,
		-1,
		220,
		236,
		238,
		-1,
		-1,
		-1,
		247,
		210,
		231,
		241,
		235,
		233,
		224,
		210,
		217,
		215,
		211,
		222,
		-1,
		-1,
		-1,
		278,
		255,
		282,
		273,
		256,
		236,
		228,
		253,
		-1,
		234,
		-1,
		209,
		211,
		237,
		240,
		246,
		240,
		213,
		228,
		218,
		209,
		218,
		284,
		-1,
		259,
		301,
		265,
		242,
		235,
		239,
		255,
		-1,
		231,
		213,
		-1,
		241,
		231,
		262,
		247,
		228,
		215,
		222,
		222,
		215,
		-1,
		-1,
		-1,
		270,
		269,
		261,
		255,
		255,
		240,
		231,
		-1,
		243,
		225,
		204,
		221,
		221,
		212,
		220,
		252,
		248,
		235,
		235,
		227,
		-1,
		328,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		264,
		259,
		232,
		220,
		226,
		222,
		208,
		214,
		216,
		224,
		222,
		219,
		231,
		227,
		247,
		228,
		263,
		-1,
		335,
		-1,
		300,
		-1,
		-1,
		282,
		262,
		254,
		243,
		232,
		230,
		221,
		212,
		234,
		250,
		234,
		232,
		235,
		236,
		-1,
		345,
		346,
		-1,
		301,
		293,
		279,
		-1,
		272,
		-1,
		278,
		239,
		-1,
		241,
		221,
		-1,
		243,
		239,
		-1,
		-1,
		342,
		317,
		-1,
		-1,
		-1,
		302,
		282,
		273,
		257,
		-1,
		232,
		232,
		-1,
		-1,
		-1,
		327,
		326,
		-1,
		295,
		298,
		-1,
		288,
		279,
		287,
		234,
		238,
		-1,
		-1,
		-1,
		336,
		317,
		311,
		310,
		308,
		303,
		300,
		286,
		270,
		248,
		237,
		258,
		-1,
		-1,
		-1,
		308,
		300,
		293,
		-1,
		-1,
		295,
		278,
		259,
		257,
		-1,
		-1,
		-1,
		330,
		311,
		-1,
		-1,
		285,
		-1,
		-1,
		291,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		347,
		319,
		-1,
		-1,
		-1,
		281,
		277,
		278,
		-1,
		-1,
		-1,
		-1,
		341,
		342,
		365,
		329,
		-1,
		-1,
		-1,
		273,
		267,
		-1,
		-1,
		344,
		342,
		-1,
		-1,
		-1,
		301,
		285,
		-1,
		271,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		306,
		-1,
		306,
		281,
		288,
		-1,
		-1,
		-1,
		-1,
		319,
		311,
		319,
		-1,
		291,
		293,
		-1,
		341,
		-1,
		-1,
		334,
		325,
		-1,
		-1,
		296,
		303,
		325,
		328,
		364,
		-1,
		315
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		201,
		203,
		169,
		163,
		202,
		173,
		179,
		190,
		-1,
		-1,
		-1,
		192,
		191,
		161,
		159,
		168,
		173,
		180,
		-1,
		203,
		-1,
		213,
		192,
		203,
		208,
		154,
		151,
		171,
		190,
		196,
		188,
		228,
		184,
		155,
		149,
		167,
		172,
		190,
		182,
		-1,
		155,
		145,
		167,
		171,
		183,
		166,
		-1,
		-1,
		149,
		150,
		156,
		168,
		173,
		178,
		-1,
		201,
		185,
		-1,
		-1,
		139,
		152,
		148,
		151,
		159,
		175,
		193,
		185,
		180,
		-1,
		-1,
		140,
		144,
		157,
		158,
		156,
		180,
		193,
		175,
		189,
		188,
		-1,
		128,
		146,
		155,
		164,
		170,
		156,
		154,
		172,
		174,
		180,
		183,
		-1,
		120,
		122,
		151,
		157,
		169,
		172,
		159,
		159,
		169,
		162,
		181,
		172,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		125,
		151,
		150,
		146,
		164,
		169,
		162,
		159,
		157,
		154,
		170,
		171,
		181,
		-1,
		-1,
		173,
		142,
		177,
		134,
		119,
		-1,
		113,
		132,
		138,
		142,
		147,
		152,
		166,
		162,
		-1,
		148,
		147,
		178,
		164,
		175,
		133,
		-1,
		-1,
		131,
		123,
		108,
		111,
		108,
		108,
		138,
		137,
		142,
		144,
		143,
		149,
		152,
		152,
		158,
		142,
		152,
		156,
		167,
		182,
		-1,
		-1,
		237,
		-1,
		-1,
		130,
		113,
		-1,
		96,
		103,
		103,
		120,
		110,
		131,
		146,
		150,
		158,
		157,
		145,
		147,
		144,
		157,
		145,
		139,
		164,
		168,
		162,
		183,
		178,
		-1,
		236,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		89,
		92,
		98,
		122,
		132,
		-1,
		153,
		151,
		175,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		146,
		148,
		181,
		159,
		181,
		178,
		207,
		212,
		206,
		215,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		126,
		-1,
		140,
		153,
		157,
		155,
		158,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		148,
		159,
		154,
		153,
		171,
		186,
		199,
		203,
		209,
		-1,
		188,
		-1,
		130,
		114,
		116,
		88,
		109,
		-1,
		146,
		141,
		161,
		159,
		150,
		-1,
		153,
		156,
		163,
		141,
		126,
		143,
		135,
		133,
		138,
		143,
		157,
		148,
		166,
		173,
		181,
		185,
		205,
		217,
		148,
		138,
		-1,
		120,
		125,
		84,
		92,
		111,
		184,
		156,
		-1,
		151,
		-1,
		143,
		168,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		142,
		139,
		136,
		154,
		157,
		174,
		178,
		194,
		-1,
		-1,
		133,
		137,
		126,
		77,
		96,
		120,
		157,
		149,
		138,
		137,
		-1,
		128,
		158,
		155,
		141,
		128,
		118,
		119,
		127,
		140,
		119,
		138,
		141,
		163,
		191,
		169,
		181,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		103,
		74,
		98,
		140,
		167,
		160,
		148,
		113,
		113,
		107,
		-1,
		148,
		131,
		127,
		116,
		114,
		127,
		122,
		138,
		142,
		141,
		160,
		172,
		163,
		183,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		69,
		92,
		129,
		146,
		132,
		137,
		112,
		105,
		99,
		151,
		148,
		115,
		123,
		115,
		104,
		118,
		126,
		130,
		139,
		148,
		154,
		178,
		178,
		184,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		83,
		90,
		122,
		137,
		134,
		-1,
		104,
		-1,
		93,
		101,
		100,
		106,
		118,
		104,
		109,
		120,
		132,
		145,
		141,
		148,
		183,
		183,
		168,
		188,
		191,
		-1,
		-1,
		-1,
		133,
		128,
		103,
		80,
		64,
		100,
		-1,
		104,
		105,
		-1,
		98,
		92,
		98,
		97,
		104,
		101,
		101,
		115,
		123,
		119,
		135,
		141,
		133,
		169,
		-1,
		176,
		170,
		178,
		168,
		156,
		-1,
		-1,
		-1,
		126,
		105,
		98,
		118,
		59,
		111,
		-1,
		-1,
		89,
		82,
		-1,
		85,
		85,
		92,
		101,
		106,
		111,
		119,
		114,
		127,
		132,
		138,
		143,
		161,
		165,
		169,
		158,
		154,
		151,
		165,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		79,
		-1,
		95,
		87,
		80,
		74,
		80,
		98,
		96,
		116,
		108,
		122,
		122,
		128,
		136,
		121,
		124,
		140,
		138,
		156,
		164,
		156,
		150,
		149,
		161,
		-1,
		146,
		132,
		103,
		-1,
		-1,
		92,
		-1,
		56,
		73,
		89,
		-1,
		114,
		93,
		116,
		94,
		108,
		104,
		142,
		143,
		121,
		126,
		134,
		144,
		146,
		135,
		146,
		138,
		160,
		160,
		144,
		145,
		154,
		-1,
		152,
		139,
		97,
		92,
		81,
		97,
		53,
		62,
		76,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		118,
		116,
		132,
		123,
		129,
		145,
		148,
		150,
		140,
		129,
		135,
		132,
		154,
		140,
		138,
		157,
		173,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		65,
		50,
		49,
		-1,
		93,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		140,
		124,
		129,
		-1,
		175,
		-1,
		148,
		150,
		144,
		129,
		126,
		137,
		135,
		146,
		163,
		-1,
		99,
		84,
		77,
		67,
		79,
		44,
		-1,
		87,
		-1,
		-1,
		123,
		117,
		117,
		101,
		104,
		156,
		136,
		130,
		129,
		170,
		170,
		156,
		142,
		135,
		132,
		129,
		142,
		162,
		153,
		165,
		-1,
		-1,
		-1,
		104,
		8,
		2,
		46,
		53,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		110,
		173,
		161,
		151,
		141,
		175,
		176,
		161,
		154,
		140,
		142,
		140,
		138,
		143,
		164,
		165,
		178,
		-1,
		-1,
		12,
		0,
		9,
		46,
		65,
		-1,
		-1,
		-1,
		132,
		148,
		140,
		111,
		162,
		-1,
		-1,
		153,
		151,
		161,
		157,
		144,
		164,
		167,
		153,
		137,
		152,
		164,
		172,
		177,
		-1,
		47,
		34,
		-1,
		-1,
		68,
		62,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		143,
		164,
		189,
		156,
		-1,
		161,
		162,
		148,
		162,
		169,
		155,
		150,
		144,
		147,
		165,
		182,
		-1,
		-1,
		82,
		-1,
		77,
		-1,
		-1,
		-1,
		-1,
		122,
		136,
		157,
		163,
		175,
		-1,
		170,
		164,
		150,
		167,
		168,
		165,
		156,
		148,
		153,
		150,
		163,
		177,
		181,
		105,
		-1,
		88,
		-1,
		-1,
		-1,
		140,
		155,
		217,
		194,
		167,
		171,
		164,
		158,
		158,
		174,
		176,
		187,
		155,
		151,
		152,
		156,
		155,
		172,
		182,
		-1,
		-1,
		88,
		105,
		140,
		148,
		152,
		244,
		-1,
		-1,
		180,
		171,
		162,
		165,
		168,
		171,
		161,
		158,
		163,
		168,
		156,
		165,
		183,
		187,
		-1,
		-1,
		-1,
		108,
		-1,
		123,
		-1,
		-1,
		167,
		251,
		198,
		180,
		176,
		174,
		167,
		176,
		171,
		166,
		176,
		185,
		177,
		158,
		169,
		192,
		181,
		219,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		137,
		112,
		127,
		173,
		178,
		169,
		213,
		210,
		-1,
		180,
		205,
		177,
		184,
		176,
		184,
		184,
		181,
		159,
		166,
		182,
		181,
		176,
		211,
		203,
		209,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		143,
		129,
		159,
		149,
		155,
		-1,
		-1,
		202,
		199,
		202,
		186,
		190,
		183,
		178,
		188,
		168,
		155,
		159,
		163,
		169,
		174,
		179,
		185,
		200,
		215,
		-1,
		122,
		203,
		196,
		179,
		187,
		218,
		-1,
		146,
		155,
		136,
		141,
		149,
		-1,
		-1,
		175,
		171,
		176,
		185,
		188,
		198,
		193,
		184,
		169,
		175,
		162,
		161,
		179,
		183,
		192,
		199,
		189,
		202,
		206,
		-1,
		136,
		179,
		173,
		176,
		200,
		214,
		-1,
		159,
		-1,
		-1,
		144,
		162,
		170,
		166,
		170,
		223,
		199,
		194,
		192,
		190,
		181,
		172,
		179,
		170,
		170,
		173,
		188,
		193,
		185,
		199,
		199,
		200,
		-1,
		171,
		159,
		167,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		160,
		-1,
		196,
		-1,
		189,
		193,
		207,
		210,
		206,
		193,
		185,
		177,
		193,
		168,
		178,
		174,
		175,
		184,
		195,
		207,
		206,
		207,
		245,
		200,
		167,
		158,
		205,
		220,
		224,
		-1,
		172,
		211,
		198,
		-1,
		169,
		-1,
		-1,
		-1,
		203,
		220,
		212,
		226,
		205,
		205,
		179,
		183,
		173,
		180,
		190,
		192,
		184,
		188,
		201,
		212,
		215,
		241,
		239,
		244,
		189,
		172,
		190,
		199,
		220,
		187,
		178,
		205,
		205,
		194,
		189,
		176,
		-1,
		-1,
		226,
		230,
		-1,
		-1,
		212,
		200,
		183,
		184,
		180,
		183,
		198,
		201,
		191,
		189,
		183,
		215,
		-1,
		241,
		240,
		229,
		226,
		202,
		193,
		180,
		191,
		-1,
		-1,
		190,
		206,
		219,
		223,
		236,
		261,
		-1,
		179,
		-1,
		-1,
		247,
		-1,
		-1,
		242,
		205,
		194,
		185,
		191,
		188,
		199,
		209,
		197,
		198,
		188,
		198,
		211,
		225,
		222,
		210,
		208,
		231,
		188,
		184,
		-1,
		205,
		193,
		199,
		206,
		223,
		250,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		240,
		238,
		227,
		-1,
		217,
		190,
		195,
		215,
		217,
		206,
		200,
		194,
		201,
		200,
		208,
		216,
		234,
		248,
		237,
		233,
		232,
		240,
		189,
		206,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		205,
		-1,
		-1,
		235,
		228,
		216,
		204,
		194,
		204,
		208,
		212,
		204,
		197,
		192,
		203,
		195,
		199,
		216,
		-1,
		268,
		-1,
		220,
		213,
		228,
		243,
		251,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		269,
		253,
		234,
		-1,
		204,
		217,
		248,
		216,
		221,
		216,
		198,
		209,
		198,
		201,
		215,
		210,
		-1,
		-1,
		226,
		229,
		-1,
		-1,
		251,
		270,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		241,
		237,
		-1,
		-1,
		205,
		230,
		219,
		227,
		222,
		202,
		208,
		211,
		200,
		204,
		216,
		-1,
		-1,
		233,
		234,
		239,
		-1,
		260,
		-1,
		262,
		-1,
		207,
		223,
		225,
		-1,
		-1,
		-1,
		243,
		206,
		227,
		237,
		231,
		229,
		220,
		206,
		213,
		211,
		207,
		218,
		-1,
		-1,
		-1,
		288,
		262,
		269,
		260,
		243,
		223,
		215,
		240,
		-1,
		230,
		-1,
		205,
		207,
		233,
		236,
		242,
		236,
		209,
		224,
		214,
		205,
		214,
		294,
		-1,
		264,
		297,
		261,
		229,
		229,
		228,
		251,
		-1,
		227,
		209,
		-1,
		237,
		227,
		258,
		243,
		224,
		211,
		218,
		218,
		211,
		-1,
		-1,
		-1,
		266,
		265,
		257,
		251,
		249,
		234,
		227,
		-1,
		239,
		221,
		200,
		217,
		217,
		208,
		216,
		248,
		244,
		231,
		231,
		223,
		-1,
		340,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		260,
		255,
		228,
		216,
		222,
		218,
		204,
		210,
		212,
		220,
		218,
		215,
		227,
		223,
		243,
		224,
		259,
		-1,
		347,
		-1,
		296,
		-1,
		-1,
		276,
		258,
		250,
		239,
		228,
		226,
		217,
		208,
		230,
		246,
		230,
		228,
		231,
		232,
		-1,
		351,
		350,
		-1,
		295,
		287,
		273,
		-1,
		266,
		-1,
		274,
		235,
		-1,
		237,
		217,
		-1,
		239,
		235,
		-1,
		-1,
		338,
		311,
		-1,
		-1,
		-1,
		296,
		276,
		269,
		253,
		-1,
		228,
		228,
		-1,
		-1,
		-1,
		323,
		320,
		-1,
		289,
		292,
		-1,
		283,
		275,
		283,
		230,
		234,
		-1,
		-1,
		-1,
		332,
		313,
		307,
		304,
		304,
		297,
		296,
		282,
		266,
		244,
		233,
		254,
		-1,
		-1,
		-1,
		304,
		296,
		289,
		-1,
		-1,
		291,
		274,
		255,
		253,
		-1,
		-1,
		-1,
		326,
		307,
		-1,
		-1,
		281,
		-1,
		-1,
		287,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		343,
		315,
		-1,
		-1,
		-1,
		277,
		273,
		274,
		-1,
		-1,
		-1,
		-1,
		337,
		338,
		361,
		325,
		-1,
		-1,
		-1,
		269,
		263,
		-1,
		-1,
		340,
		338,
		-1,
		-1,
		-1,
		297,
		281,
		-1,
		267,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		302,
		-1,
		302,
		277,
		284,
		-1,
		-1,
		-1,
		-1,
		315,
		307,
		315,
		-1,
		287,
		289,
		-1,
		337,
		-1,
		-1,
		330,
		321,
		-1,
		-1,
		292,
		299,
		321,
		324,
		360,
		-1,
		311
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		192,
		194,
		160,
		154,
		193,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		183,
		182,
		152,
		150,
		159,
		164,
		171,
		-1,
		194,
		-1,
		204,
		183,
		194,
		199,
		145,
		142,
		162,
		181,
		187,
		179,
		219,
		175,
		146,
		140,
		158,
		163,
		181,
		173,
		-1,
		146,
		136,
		158,
		162,
		174,
		157,
		-1,
		-1,
		140,
		141,
		147,
		159,
		164,
		169,
		-1,
		192,
		176,
		-1,
		-1,
		130,
		143,
		139,
		142,
		150,
		166,
		184,
		176,
		171,
		-1,
		-1,
		131,
		135,
		148,
		149,
		147,
		171,
		184,
		166,
		180,
		179,
		-1,
		119,
		137,
		146,
		155,
		161,
		147,
		145,
		163,
		165,
		171,
		174,
		-1,
		111,
		113,
		142,
		148,
		160,
		163,
		150,
		150,
		160,
		153,
		172,
		163,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		116,
		142,
		141,
		137,
		155,
		160,
		153,
		150,
		148,
		145,
		161,
		162,
		172,
		-1,
		-1,
		164,
		133,
		168,
		125,
		110,
		-1,
		104,
		123,
		129,
		133,
		138,
		143,
		157,
		153,
		-1,
		139,
		138,
		169,
		155,
		166,
		124,
		-1,
		-1,
		122,
		114,
		99,
		102,
		99,
		99,
		129,
		128,
		133,
		135,
		134,
		140,
		143,
		143,
		149,
		133,
		143,
		147,
		158,
		173,
		-1,
		-1,
		228,
		-1,
		-1,
		121,
		104,
		-1,
		87,
		94,
		94,
		111,
		101,
		122,
		137,
		141,
		149,
		148,
		136,
		138,
		135,
		148,
		136,
		130,
		155,
		159,
		153,
		174,
		169,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		80,
		83,
		89,
		113,
		123,
		-1,
		144,
		142,
		166,
		157,
		154,
		141,
		129,
		142,
		127,
		134,
		133,
		137,
		139,
		172,
		150,
		172,
		169,
		198,
		203,
		197,
		206,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		117,
		-1,
		131,
		144,
		148,
		146,
		149,
		158,
		149,
		136,
		125,
		136,
		125,
		122,
		130,
		139,
		150,
		145,
		144,
		162,
		177,
		190,
		194,
		200,
		-1,
		179,
		-1,
		121,
		105,
		107,
		79,
		100,
		-1,
		137,
		132,
		152,
		150,
		141,
		-1,
		144,
		147,
		154,
		132,
		117,
		134,
		126,
		124,
		129,
		134,
		148,
		139,
		157,
		164,
		172,
		176,
		196,
		208,
		139,
		129,
		-1,
		111,
		116,
		75,
		83,
		102,
		175,
		147,
		-1,
		142,
		-1,
		134,
		159,
		-1,
		138,
		134,
		116,
		117,
		112,
		127,
		133,
		130,
		127,
		145,
		148,
		165,
		169,
		185,
		-1,
		-1,
		124,
		128,
		117,
		68,
		87,
		111,
		148,
		140,
		129,
		128,
		-1,
		119,
		149,
		146,
		132,
		119,
		109,
		110,
		118,
		131,
		110,
		129,
		132,
		154,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		94,
		65,
		89,
		131,
		158,
		151,
		139,
		104,
		104,
		98,
		-1,
		139,
		122,
		118,
		107,
		105,
		118,
		113,
		129,
		133,
		132,
		151,
		163,
		154,
		174,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		60,
		83,
		120,
		137,
		123,
		128,
		103,
		96,
		90,
		142,
		139,
		106,
		114,
		106,
		95,
		109,
		117,
		121,
		130,
		139,
		145,
		169,
		169,
		175,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		74,
		81,
		113,
		128,
		125,
		-1,
		95,
		-1,
		84,
		92,
		91,
		97,
		109,
		95,
		100,
		111,
		123,
		136,
		132,
		139,
		174,
		174,
		159,
		179,
		182,
		-1,
		-1,
		-1,
		124,
		119,
		94,
		71,
		55,
		91,
		-1,
		95,
		96,
		-1,
		89,
		83,
		89,
		88,
		95,
		92,
		92,
		106,
		114,
		110,
		126,
		132,
		124,
		160,
		-1,
		167,
		161,
		169,
		159,
		147,
		-1,
		-1,
		-1,
		117,
		96,
		89,
		109,
		50,
		102,
		-1,
		-1,
		80,
		73,
		-1,
		76,
		76,
		83,
		92,
		97,
		102,
		110,
		105,
		118,
		123,
		129,
		134,
		152,
		156,
		160,
		149,
		145,
		142,
		156,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		70,
		-1,
		86,
		78,
		71,
		65,
		71,
		89,
		87,
		107,
		99,
		113,
		113,
		119,
		127,
		112,
		115,
		131,
		129,
		147,
		155,
		147,
		141,
		140,
		152,
		-1,
		137,
		123,
		94,
		-1,
		-1,
		83,
		-1,
		47,
		64,
		80,
		-1,
		105,
		84,
		107,
		85,
		99,
		95,
		133,
		134,
		112,
		117,
		125,
		135,
		137,
		126,
		137,
		129,
		151,
		151,
		135,
		136,
		145,
		-1,
		143,
		130,
		88,
		83,
		72,
		88,
		44,
		53,
		67,
		-1,
		-1,
		149,
		-1,
		83,
		100,
		109,
		107,
		123,
		114,
		120,
		136,
		139,
		141,
		131,
		120,
		126,
		123,
		145,
		131,
		129,
		148,
		164,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		56,
		41,
		40,
		-1,
		84,
		-1,
		127,
		117,
		101,
		86,
		119,
		-1,
		131,
		115,
		120,
		-1,
		166,
		-1,
		139,
		141,
		135,
		120,
		117,
		128,
		126,
		137,
		154,
		-1,
		90,
		75,
		68,
		58,
		70,
		35,
		-1,
		78,
		-1,
		-1,
		114,
		108,
		108,
		92,
		95,
		147,
		127,
		121,
		120,
		161,
		161,
		147,
		133,
		126,
		123,
		120,
		133,
		153,
		144,
		156,
		-1,
		-1,
		-1,
		95,
		20,
		14,
		37,
		44,
		-1,
		-1,
		176,
		131,
		117,
		-1,
		101,
		164,
		152,
		142,
		132,
		166,
		167,
		152,
		145,
		131,
		133,
		131,
		129,
		134,
		155,
		156,
		169,
		-1,
		-1,
		24,
		12,
		0,
		37,
		56,
		-1,
		-1,
		-1,
		123,
		139,
		131,
		102,
		153,
		-1,
		-1,
		144,
		142,
		152,
		148,
		135,
		155,
		158,
		144,
		128,
		143,
		155,
		163,
		168,
		-1,
		59,
		46,
		-1,
		-1,
		59,
		53,
		-1,
		-1,
		-1,
		-1,
		156,
		122,
		134,
		155,
		180,
		147,
		-1,
		152,
		153,
		139,
		153,
		160,
		146,
		141,
		135,
		138,
		156,
		173,
		-1,
		-1,
		73,
		-1,
		68,
		-1,
		-1,
		-1,
		-1,
		113,
		127,
		148,
		154,
		166,
		-1,
		161,
		155,
		141,
		158,
		159,
		156,
		147,
		139,
		144,
		141,
		154,
		168,
		172,
		96,
		-1,
		79,
		-1,
		-1,
		-1,
		131,
		146,
		208,
		185,
		158,
		162,
		155,
		149,
		149,
		165,
		167,
		178,
		146,
		142,
		143,
		147,
		146,
		163,
		173,
		-1,
		-1,
		79,
		96,
		131,
		139,
		143,
		235,
		-1,
		-1,
		171,
		162,
		153,
		156,
		159,
		162,
		152,
		149,
		154,
		159,
		147,
		156,
		174,
		178,
		-1,
		-1,
		-1,
		99,
		-1,
		114,
		-1,
		-1,
		158,
		242,
		189,
		171,
		167,
		165,
		158,
		167,
		162,
		157,
		167,
		176,
		168,
		149,
		160,
		183,
		172,
		210,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		128,
		103,
		118,
		164,
		169,
		160,
		204,
		201,
		-1,
		171,
		196,
		168,
		175,
		167,
		175,
		175,
		172,
		150,
		157,
		173,
		172,
		167,
		202,
		194,
		200,
		-1,
		-1,
		223,
		212,
		201,
		207,
		-1,
		134,
		120,
		150,
		140,
		146,
		-1,
		-1,
		193,
		190,
		193,
		177,
		181,
		174,
		169,
		179,
		159,
		146,
		150,
		154,
		160,
		165,
		170,
		176,
		191,
		206,
		-1,
		118,
		199,
		192,
		175,
		183,
		214,
		-1,
		137,
		146,
		127,
		132,
		140,
		-1,
		-1,
		166,
		162,
		167,
		176,
		179,
		189,
		184,
		175,
		160,
		166,
		153,
		152,
		170,
		174,
		183,
		190,
		180,
		193,
		197,
		-1,
		132,
		175,
		169,
		172,
		196,
		210,
		-1,
		150,
		-1,
		-1,
		135,
		153,
		161,
		157,
		161,
		214,
		190,
		185,
		183,
		181,
		172,
		163,
		170,
		161,
		161,
		164,
		179,
		184,
		176,
		190,
		190,
		191,
		-1,
		167,
		155,
		163,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		151,
		-1,
		187,
		-1,
		180,
		184,
		198,
		201,
		197,
		184,
		176,
		168,
		184,
		159,
		169,
		165,
		166,
		175,
		186,
		198,
		197,
		198,
		241,
		196,
		163,
		154,
		201,
		216,
		220,
		-1,
		163,
		202,
		189,
		-1,
		160,
		-1,
		-1,
		-1,
		194,
		211,
		203,
		217,
		196,
		196,
		170,
		174,
		164,
		171,
		181,
		183,
		175,
		179,
		192,
		203,
		206,
		237,
		235,
		240,
		185,
		168,
		186,
		195,
		216,
		178,
		169,
		196,
		196,
		185,
		180,
		167,
		-1,
		-1,
		217,
		221,
		-1,
		-1,
		203,
		191,
		174,
		175,
		171,
		174,
		189,
		192,
		182,
		180,
		174,
		206,
		-1,
		237,
		236,
		225,
		222,
		198,
		189,
		176,
		187,
		-1,
		-1,
		181,
		197,
		210,
		214,
		227,
		252,
		-1,
		170,
		-1,
		-1,
		238,
		-1,
		-1,
		233,
		196,
		185,
		176,
		182,
		179,
		190,
		200,
		188,
		189,
		179,
		189,
		202,
		221,
		218,
		206,
		204,
		227,
		184,
		180,
		-1,
		196,
		184,
		190,
		197,
		214,
		241,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		231,
		229,
		218,
		-1,
		208,
		181,
		186,
		206,
		208,
		197,
		191,
		185,
		192,
		191,
		199,
		207,
		230,
		244,
		233,
		229,
		228,
		236,
		185,
		199,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		-1,
		221,
		196,
		-1,
		-1,
		226,
		219,
		207,
		195,
		185,
		195,
		199,
		203,
		195,
		188,
		183,
		194,
		186,
		190,
		207,
		-1,
		264,
		-1,
		216,
		205,
		224,
		239,
		247,
		-1,
		-1,
		-1,
		238,
		224,
		217,
		205,
		203,
		-1,
		260,
		244,
		225,
		-1,
		195,
		208,
		239,
		207,
		212,
		207,
		189,
		200,
		189,
		192,
		206,
		201,
		-1,
		-1,
		222,
		225,
		-1,
		-1,
		247,
		266,
		-1,
		229,
		218,
		203,
		195,
		-1,
		-1,
		232,
		228,
		-1,
		-1,
		196,
		221,
		210,
		218,
		213,
		193,
		199,
		202,
		191,
		195,
		207,
		-1,
		-1,
		229,
		230,
		235,
		-1,
		256,
		-1,
		253,
		-1,
		198,
		214,
		216,
		-1,
		-1,
		-1,
		234,
		197,
		218,
		228,
		222,
		220,
		211,
		197,
		204,
		202,
		198,
		209,
		-1,
		-1,
		-1,
		279,
		253,
		260,
		251,
		234,
		214,
		206,
		231,
		-1,
		221,
		-1,
		196,
		198,
		224,
		227,
		233,
		227,
		200,
		215,
		205,
		196,
		205,
		285,
		-1,
		255,
		288,
		252,
		220,
		220,
		219,
		242,
		-1,
		218,
		200,
		-1,
		228,
		218,
		249,
		234,
		215,
		202,
		209,
		209,
		202,
		-1,
		-1,
		-1,
		257,
		256,
		248,
		242,
		240,
		225,
		218,
		-1,
		230,
		212,
		191,
		208,
		208,
		199,
		207,
		239,
		235,
		222,
		222,
		214,
		-1,
		336,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		251,
		246,
		219,
		207,
		213,
		209,
		195,
		201,
		203,
		211,
		209,
		206,
		218,
		214,
		234,
		215,
		250,
		-1,
		343,
		-1,
		287,
		-1,
		-1,
		267,
		249,
		241,
		230,
		219,
		217,
		208,
		199,
		221,
		237,
		221,
		219,
		222,
		223,
		-1,
		342,
		341,
		-1,
		286,
		278,
		264,
		-1,
		257,
		-1,
		265,
		226,
		-1,
		228,
		208,
		-1,
		230,
		226,
		-1,
		-1,
		329,
		302,
		-1,
		-1,
		-1,
		287,
		267,
		260,
		244,
		-1,
		219,
		219,
		-1,
		-1,
		-1,
		314,
		311,
		-1,
		280,
		283,
		-1,
		274,
		266,
		274,
		221,
		225,
		-1,
		-1,
		-1,
		323,
		304,
		298,
		295,
		295,
		288,
		287,
		273,
		257,
		235,
		224,
		245,
		-1,
		-1,
		-1,
		295,
		287,
		280,
		-1,
		-1,
		282,
		265,
		246,
		244,
		-1,
		-1,
		-1,
		317,
		298,
		-1,
		-1,
		272,
		-1,
		-1,
		278,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		334,
		306,
		-1,
		-1,
		-1,
		268,
		264,
		265,
		-1,
		-1,
		-1,
		-1,
		328,
		329,
		352,
		316,
		-1,
		-1,
		-1,
		260,
		254,
		-1,
		-1,
		331,
		329,
		-1,
		-1,
		-1,
		288,
		272,
		-1,
		258,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		293,
		-1,
		293,
		268,
		275,
		-1,
		-1,
		-1,
		-1,
		306,
		298,
		306,
		-1,
		278,
		280,
		-1,
		328,
		-1,
		-1,
		321,
		312,
		-1,
		-1,
		283,
		290,
		312,
		315,
		351,
		-1,
		302
	],
	[
		-1,
		162,
		151,
		162,
		170,
		143,
		150,
		-1,
		171,
		173,
		139,
		133,
		172,
		143,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		161,
		131,
		129,
		138,
		143,
		150,
		-1,
		173,
		-1,
		183,
		162,
		173,
		178,
		124,
		121,
		141,
		160,
		166,
		158,
		198,
		154,
		125,
		119,
		137,
		142,
		160,
		152,
		-1,
		125,
		115,
		137,
		141,
		153,
		136,
		-1,
		-1,
		119,
		120,
		126,
		138,
		143,
		148,
		-1,
		171,
		155,
		-1,
		-1,
		109,
		122,
		118,
		121,
		129,
		145,
		163,
		155,
		150,
		-1,
		-1,
		110,
		114,
		127,
		128,
		126,
		150,
		163,
		145,
		159,
		158,
		-1,
		98,
		116,
		125,
		134,
		140,
		126,
		124,
		142,
		144,
		150,
		153,
		-1,
		90,
		92,
		121,
		127,
		139,
		142,
		129,
		129,
		139,
		132,
		151,
		142,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		87,
		95,
		121,
		120,
		116,
		134,
		139,
		132,
		129,
		127,
		124,
		140,
		141,
		151,
		-1,
		-1,
		143,
		112,
		147,
		104,
		89,
		-1,
		83,
		102,
		108,
		112,
		117,
		122,
		136,
		132,
		-1,
		118,
		117,
		148,
		134,
		145,
		103,
		-1,
		-1,
		101,
		93,
		78,
		81,
		78,
		78,
		108,
		107,
		112,
		114,
		113,
		119,
		122,
		122,
		128,
		112,
		122,
		126,
		137,
		152,
		-1,
		-1,
		207,
		-1,
		-1,
		100,
		83,
		-1,
		66,
		73,
		73,
		90,
		80,
		101,
		116,
		120,
		128,
		127,
		115,
		117,
		114,
		127,
		115,
		109,
		134,
		138,
		132,
		153,
		148,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		59,
		62,
		68,
		92,
		102,
		-1,
		123,
		121,
		145,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		116,
		118,
		151,
		129,
		151,
		148,
		177,
		182,
		176,
		185,
		-1,
		108,
		104,
		100,
		107,
		56,
		-1,
		-1,
		96,
		-1,
		110,
		123,
		127,
		125,
		128,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		118,
		129,
		124,
		123,
		141,
		156,
		169,
		173,
		179,
		-1,
		158,
		-1,
		100,
		84,
		86,
		58,
		79,
		-1,
		116,
		111,
		131,
		129,
		120,
		-1,
		123,
		126,
		133,
		111,
		96,
		113,
		105,
		103,
		108,
		113,
		127,
		118,
		136,
		143,
		151,
		155,
		175,
		187,
		118,
		108,
		-1,
		90,
		95,
		54,
		62,
		81,
		154,
		126,
		-1,
		121,
		-1,
		113,
		138,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		112,
		109,
		106,
		124,
		127,
		144,
		148,
		164,
		-1,
		-1,
		103,
		107,
		96,
		47,
		66,
		90,
		127,
		119,
		108,
		107,
		-1,
		98,
		128,
		125,
		111,
		98,
		88,
		89,
		97,
		110,
		89,
		108,
		111,
		133,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		73,
		44,
		68,
		110,
		137,
		130,
		118,
		83,
		83,
		77,
		-1,
		118,
		101,
		97,
		86,
		84,
		97,
		92,
		108,
		112,
		111,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		103,
		92,
		93,
		39,
		62,
		99,
		116,
		102,
		107,
		82,
		75,
		69,
		121,
		118,
		85,
		93,
		85,
		74,
		88,
		96,
		100,
		109,
		118,
		124,
		148,
		148,
		154,
		-1,
		-1,
		110,
		100,
		84,
		86,
		83,
		53,
		60,
		92,
		107,
		104,
		-1,
		74,
		-1,
		63,
		71,
		70,
		76,
		88,
		74,
		79,
		90,
		102,
		115,
		111,
		118,
		153,
		153,
		138,
		158,
		161,
		-1,
		-1,
		-1,
		103,
		98,
		73,
		50,
		34,
		70,
		-1,
		74,
		75,
		-1,
		68,
		62,
		68,
		67,
		74,
		71,
		71,
		85,
		93,
		89,
		105,
		111,
		103,
		139,
		-1,
		146,
		140,
		148,
		138,
		126,
		-1,
		-1,
		-1,
		96,
		75,
		68,
		88,
		29,
		81,
		-1,
		-1,
		59,
		52,
		-1,
		55,
		55,
		62,
		71,
		76,
		81,
		89,
		84,
		97,
		102,
		108,
		113,
		131,
		135,
		139,
		128,
		124,
		121,
		135,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		29,
		49,
		-1,
		67,
		59,
		50,
		44,
		50,
		68,
		66,
		86,
		78,
		92,
		92,
		98,
		106,
		91,
		94,
		110,
		108,
		126,
		134,
		126,
		120,
		119,
		131,
		-1,
		116,
		102,
		73,
		-1,
		-1,
		62,
		-1,
		26,
		45,
		61,
		-1,
		84,
		63,
		86,
		64,
		78,
		74,
		112,
		113,
		91,
		96,
		104,
		114,
		116,
		105,
		116,
		108,
		130,
		130,
		114,
		115,
		124,
		-1,
		122,
		109,
		67,
		63,
		52,
		72,
		23,
		32,
		48,
		-1,
		-1,
		128,
		-1,
		62,
		79,
		88,
		86,
		102,
		93,
		99,
		115,
		118,
		120,
		110,
		99,
		105,
		102,
		124,
		110,
		108,
		127,
		143,
		-1,
		-1,
		-1,
		89,
		-1,
		-1,
		38,
		25,
		19,
		-1,
		65,
		-1,
		106,
		96,
		80,
		65,
		98,
		-1,
		110,
		94,
		99,
		-1,
		145,
		-1,
		118,
		120,
		114,
		99,
		96,
		107,
		105,
		116,
		133,
		-1,
		72,
		57,
		50,
		40,
		54,
		22,
		-1,
		56,
		-1,
		-1,
		93,
		87,
		87,
		71,
		74,
		126,
		106,
		100,
		99,
		140,
		140,
		126,
		112,
		105,
		102,
		99,
		112,
		132,
		123,
		135,
		-1,
		-1,
		-1,
		77,
		52,
		46,
		18,
		22,
		-1,
		-1,
		155,
		110,
		96,
		-1,
		80,
		143,
		131,
		121,
		111,
		145,
		146,
		131,
		124,
		110,
		112,
		110,
		108,
		113,
		134,
		135,
		148,
		-1,
		-1,
		51,
		44,
		32,
		0,
		19,
		-1,
		-1,
		-1,
		102,
		118,
		110,
		81,
		132,
		-1,
		-1,
		123,
		121,
		131,
		127,
		114,
		134,
		137,
		123,
		107,
		122,
		134,
		142,
		147,
		-1,
		54,
		41,
		-1,
		-1,
		22,
		16,
		-1,
		-1,
		-1,
		-1,
		135,
		101,
		113,
		134,
		159,
		126,
		-1,
		131,
		132,
		118,
		132,
		139,
		125,
		120,
		114,
		117,
		135,
		152,
		-1,
		-1,
		36,
		-1,
		31,
		-1,
		-1,
		-1,
		-1,
		92,
		106,
		127,
		133,
		145,
		-1,
		140,
		134,
		120,
		137,
		138,
		135,
		126,
		118,
		123,
		120,
		133,
		147,
		151,
		59,
		-1,
		42,
		-1,
		-1,
		-1,
		110,
		125,
		187,
		164,
		137,
		141,
		134,
		128,
		128,
		144,
		146,
		157,
		125,
		121,
		122,
		126,
		125,
		142,
		152,
		-1,
		-1,
		42,
		59,
		94,
		106,
		122,
		214,
		-1,
		-1,
		150,
		141,
		132,
		135,
		138,
		141,
		131,
		128,
		133,
		138,
		126,
		135,
		153,
		157,
		-1,
		-1,
		-1,
		62,
		-1,
		77,
		-1,
		-1,
		137,
		221,
		168,
		150,
		146,
		144,
		137,
		146,
		141,
		136,
		146,
		155,
		147,
		128,
		139,
		162,
		151,
		189,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		91,
		66,
		81,
		127,
		132,
		123,
		183,
		180,
		-1,
		142,
		175,
		147,
		154,
		146,
		154,
		154,
		151,
		129,
		136,
		152,
		151,
		146,
		181,
		173,
		179,
		-1,
		-1,
		204,
		193,
		182,
		188,
		-1,
		97,
		83,
		113,
		103,
		109,
		-1,
		-1,
		156,
		153,
		156,
		143,
		149,
		153,
		148,
		158,
		138,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		99,
		180,
		173,
		156,
		164,
		195,
		-1,
		100,
		109,
		90,
		95,
		103,
		-1,
		-1,
		129,
		125,
		130,
		139,
		142,
		168,
		163,
		154,
		139,
		145,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		113,
		156,
		150,
		153,
		177,
		191,
		-1,
		113,
		-1,
		-1,
		98,
		116,
		124,
		120,
		124,
		177,
		153,
		148,
		161,
		160,
		151,
		142,
		149,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		148,
		136,
		144,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		114,
		-1,
		150,
		-1,
		143,
		147,
		161,
		164,
		176,
		163,
		155,
		147,
		163,
		138,
		148,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		222,
		177,
		144,
		135,
		182,
		197,
		201,
		-1,
		126,
		165,
		152,
		-1,
		123,
		-1,
		-1,
		-1,
		157,
		174,
		166,
		182,
		175,
		175,
		149,
		153,
		143,
		150,
		160,
		162,
		154,
		158,
		171,
		182,
		185,
		218,
		216,
		221,
		166,
		149,
		167,
		176,
		197,
		141,
		132,
		159,
		159,
		148,
		143,
		130,
		-1,
		-1,
		180,
		184,
		-1,
		-1,
		182,
		170,
		153,
		154,
		150,
		153,
		168,
		171,
		161,
		159,
		153,
		185,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		157,
		168,
		-1,
		-1,
		144,
		160,
		173,
		177,
		190,
		215,
		-1,
		133,
		-1,
		-1,
		201,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		158,
		169,
		179,
		167,
		168,
		158,
		168,
		181,
		202,
		199,
		187,
		185,
		208,
		165,
		161,
		-1,
		159,
		147,
		153,
		160,
		177,
		204,
		-1,
		-1,
		149,
		140,
		-1,
		-1,
		210,
		208,
		197,
		-1,
		187,
		160,
		165,
		185,
		187,
		176,
		170,
		164,
		171,
		170,
		178,
		186,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		162,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		159,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		178,
		182,
		174,
		167,
		162,
		173,
		165,
		169,
		186,
		-1,
		245,
		-1,
		197,
		168,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		168,
		179,
		168,
		171,
		185,
		180,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		213,
		232,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		172,
		178,
		181,
		170,
		174,
		186,
		-1,
		-1,
		193,
		196,
		201,
		-1,
		222,
		-1,
		216,
		-1,
		161,
		177,
		179,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		201,
		199,
		190,
		176,
		183,
		181,
		177,
		188,
		-1,
		-1,
		-1,
		242,
		216,
		223,
		214,
		197,
		177,
		169,
		194,
		-1,
		200,
		-1,
		175,
		177,
		203,
		206,
		212,
		206,
		179,
		194,
		184,
		175,
		184,
		248,
		-1,
		218,
		251,
		215,
		183,
		183,
		182,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		228,
		213,
		194,
		181,
		188,
		188,
		181,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		203,
		188,
		183,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		218,
		214,
		201,
		201,
		193,
		-1,
		317,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		223,
		196,
		184,
		192,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		194,
		229,
		-1,
		324,
		-1,
		250,
		-1,
		-1,
		230,
		216,
		218,
		207,
		196,
		194,
		187,
		178,
		200,
		216,
		200,
		198,
		201,
		202,
		-1,
		318,
		317,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		242,
		203,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		305,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		237,
		221,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		290,
		274,
		-1,
		243,
		246,
		-1,
		237,
		243,
		253,
		200,
		204,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		258,
		263,
		251,
		266,
		252,
		236,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		271,
		263,
		259,
		-1,
		-1,
		261,
		244,
		225,
		223,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		251,
		-1,
		-1,
		257,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		282,
		-1,
		-1,
		-1,
		247,
		243,
		244,
		-1,
		-1,
		-1,
		-1,
		303,
		304,
		328,
		295,
		-1,
		-1,
		-1,
		239,
		233,
		-1,
		-1,
		306,
		304,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		237,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		272,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		262,
		269,
		291,
		294,
		330,
		-1,
		281
	],
	[
		-1,
		170,
		159,
		170,
		178,
		151,
		158,
		-1,
		179,
		181,
		147,
		141,
		180,
		151,
		157,
		168,
		-1,
		-1,
		-1,
		170,
		169,
		139,
		137,
		146,
		151,
		158,
		-1,
		181,
		-1,
		191,
		170,
		181,
		186,
		132,
		129,
		149,
		168,
		174,
		166,
		206,
		162,
		133,
		127,
		145,
		150,
		168,
		160,
		-1,
		133,
		123,
		145,
		149,
		161,
		144,
		-1,
		-1,
		127,
		128,
		134,
		146,
		151,
		156,
		-1,
		179,
		163,
		-1,
		-1,
		117,
		130,
		126,
		129,
		137,
		153,
		171,
		163,
		158,
		-1,
		-1,
		118,
		122,
		135,
		136,
		134,
		158,
		171,
		153,
		167,
		166,
		-1,
		106,
		124,
		133,
		142,
		148,
		134,
		132,
		150,
		152,
		158,
		161,
		-1,
		98,
		100,
		129,
		135,
		147,
		150,
		137,
		137,
		147,
		140,
		159,
		150,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		95,
		103,
		129,
		128,
		124,
		142,
		147,
		140,
		137,
		135,
		132,
		148,
		149,
		159,
		-1,
		-1,
		151,
		120,
		155,
		112,
		97,
		-1,
		91,
		110,
		116,
		120,
		125,
		130,
		144,
		140,
		-1,
		126,
		125,
		156,
		142,
		153,
		111,
		-1,
		-1,
		109,
		101,
		86,
		89,
		86,
		86,
		116,
		115,
		120,
		122,
		121,
		127,
		130,
		130,
		136,
		120,
		130,
		134,
		145,
		160,
		-1,
		-1,
		215,
		-1,
		-1,
		108,
		91,
		-1,
		74,
		81,
		81,
		98,
		88,
		109,
		124,
		128,
		136,
		135,
		123,
		125,
		122,
		135,
		123,
		117,
		142,
		146,
		140,
		161,
		156,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		67,
		70,
		76,
		100,
		110,
		-1,
		131,
		129,
		153,
		144,
		141,
		128,
		116,
		129,
		114,
		121,
		120,
		124,
		126,
		159,
		137,
		159,
		156,
		185,
		190,
		184,
		193,
		-1,
		116,
		112,
		108,
		115,
		64,
		-1,
		-1,
		104,
		-1,
		118,
		131,
		135,
		133,
		136,
		145,
		136,
		123,
		112,
		123,
		112,
		109,
		117,
		126,
		137,
		132,
		131,
		149,
		164,
		177,
		181,
		187,
		-1,
		166,
		-1,
		108,
		92,
		94,
		66,
		87,
		-1,
		124,
		119,
		139,
		137,
		128,
		-1,
		131,
		134,
		141,
		119,
		104,
		121,
		113,
		111,
		116,
		121,
		135,
		126,
		144,
		151,
		159,
		163,
		183,
		195,
		126,
		116,
		-1,
		98,
		103,
		62,
		70,
		89,
		162,
		134,
		-1,
		129,
		-1,
		121,
		146,
		-1,
		125,
		121,
		103,
		104,
		99,
		114,
		120,
		117,
		114,
		132,
		135,
		152,
		156,
		172,
		-1,
		-1,
		111,
		115,
		104,
		55,
		74,
		98,
		135,
		127,
		116,
		115,
		-1,
		106,
		136,
		133,
		119,
		106,
		96,
		97,
		105,
		118,
		97,
		116,
		119,
		141,
		169,
		147,
		159,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		81,
		52,
		76,
		118,
		145,
		138,
		126,
		91,
		91,
		85,
		-1,
		126,
		109,
		105,
		94,
		92,
		105,
		100,
		116,
		120,
		119,
		138,
		150,
		141,
		161,
		-1,
		-1,
		-1,
		111,
		100,
		101,
		47,
		70,
		107,
		124,
		110,
		115,
		90,
		83,
		77,
		129,
		126,
		93,
		101,
		93,
		82,
		96,
		104,
		108,
		117,
		126,
		132,
		156,
		156,
		162,
		-1,
		-1,
		118,
		108,
		92,
		94,
		91,
		61,
		68,
		100,
		115,
		112,
		-1,
		82,
		-1,
		71,
		79,
		78,
		84,
		96,
		82,
		87,
		98,
		110,
		123,
		119,
		126,
		161,
		161,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		111,
		106,
		81,
		58,
		42,
		78,
		-1,
		82,
		83,
		-1,
		76,
		70,
		76,
		75,
		82,
		79,
		79,
		93,
		101,
		97,
		113,
		119,
		111,
		147,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		104,
		83,
		76,
		96,
		37,
		89,
		-1,
		-1,
		67,
		60,
		-1,
		63,
		63,
		70,
		79,
		84,
		89,
		97,
		92,
		105,
		110,
		116,
		121,
		139,
		143,
		147,
		136,
		132,
		129,
		143,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		37,
		57,
		-1,
		75,
		67,
		58,
		52,
		58,
		76,
		74,
		94,
		86,
		100,
		100,
		106,
		114,
		99,
		102,
		118,
		116,
		134,
		142,
		134,
		128,
		127,
		139,
		-1,
		124,
		110,
		81,
		-1,
		-1,
		70,
		-1,
		34,
		53,
		69,
		-1,
		92,
		71,
		94,
		72,
		86,
		82,
		120,
		121,
		99,
		104,
		112,
		122,
		124,
		113,
		124,
		116,
		138,
		138,
		122,
		123,
		132,
		-1,
		130,
		117,
		75,
		71,
		60,
		80,
		31,
		40,
		56,
		-1,
		-1,
		136,
		-1,
		70,
		87,
		96,
		94,
		110,
		101,
		107,
		123,
		126,
		128,
		118,
		107,
		113,
		110,
		132,
		118,
		116,
		135,
		151,
		-1,
		-1,
		-1,
		97,
		-1,
		-1,
		46,
		33,
		27,
		-1,
		73,
		-1,
		114,
		104,
		88,
		73,
		106,
		-1,
		118,
		102,
		107,
		-1,
		153,
		-1,
		126,
		128,
		122,
		107,
		104,
		115,
		113,
		124,
		141,
		-1,
		80,
		65,
		58,
		48,
		62,
		30,
		-1,
		64,
		-1,
		-1,
		101,
		95,
		95,
		79,
		82,
		134,
		114,
		108,
		107,
		148,
		148,
		134,
		120,
		113,
		110,
		107,
		120,
		140,
		131,
		143,
		-1,
		-1,
		-1,
		85,
		60,
		54,
		26,
		30,
		-1,
		-1,
		163,
		118,
		104,
		-1,
		88,
		151,
		139,
		129,
		119,
		153,
		154,
		139,
		132,
		118,
		120,
		118,
		116,
		121,
		142,
		143,
		156,
		-1,
		-1,
		59,
		52,
		40,
		8,
		0,
		-1,
		-1,
		-1,
		110,
		126,
		118,
		89,
		140,
		-1,
		-1,
		131,
		129,
		139,
		135,
		122,
		142,
		145,
		131,
		115,
		130,
		142,
		150,
		155,
		-1,
		62,
		49,
		-1,
		-1,
		22,
		16,
		-1,
		-1,
		-1,
		-1,
		143,
		109,
		121,
		142,
		167,
		134,
		-1,
		139,
		140,
		126,
		140,
		147,
		133,
		128,
		122,
		125,
		143,
		160,
		-1,
		-1,
		36,
		-1,
		31,
		-1,
		-1,
		-1,
		-1,
		100,
		114,
		135,
		141,
		153,
		-1,
		148,
		142,
		128,
		145,
		146,
		143,
		134,
		126,
		131,
		128,
		141,
		155,
		159,
		59,
		-1,
		42,
		-1,
		-1,
		-1,
		111,
		133,
		195,
		172,
		145,
		149,
		142,
		136,
		136,
		152,
		154,
		165,
		133,
		129,
		130,
		134,
		133,
		150,
		160,
		-1,
		-1,
		42,
		59,
		94,
		106,
		130,
		222,
		-1,
		-1,
		158,
		149,
		140,
		143,
		146,
		149,
		139,
		136,
		141,
		146,
		134,
		143,
		161,
		165,
		-1,
		-1,
		-1,
		62,
		-1,
		77,
		-1,
		-1,
		145,
		229,
		176,
		158,
		154,
		146,
		145,
		154,
		149,
		144,
		154,
		163,
		155,
		136,
		147,
		170,
		159,
		197,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		91,
		66,
		81,
		127,
		132,
		123,
		191,
		188,
		-1,
		142,
		183,
		151,
		162,
		154,
		162,
		162,
		159,
		137,
		144,
		160,
		159,
		154,
		189,
		181,
		187,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		97,
		83,
		113,
		103,
		109,
		-1,
		-1,
		156,
		153,
		156,
		143,
		149,
		154,
		156,
		166,
		146,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		107,
		188,
		181,
		164,
		172,
		203,
		-1,
		100,
		109,
		90,
		95,
		103,
		-1,
		-1,
		129,
		125,
		130,
		139,
		142,
		176,
		171,
		162,
		147,
		153,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		121,
		164,
		158,
		161,
		185,
		199,
		-1,
		113,
		-1,
		-1,
		98,
		116,
		124,
		120,
		124,
		177,
		153,
		148,
		161,
		163,
		159,
		150,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		156,
		144,
		152,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		114,
		-1,
		150,
		-1,
		143,
		147,
		161,
		164,
		184,
		171,
		163,
		155,
		171,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		230,
		185,
		152,
		143,
		190,
		205,
		209,
		-1,
		126,
		165,
		152,
		-1,
		123,
		-1,
		-1,
		-1,
		157,
		174,
		166,
		182,
		183,
		183,
		157,
		161,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		226,
		219,
		229,
		174,
		157,
		175,
		184,
		205,
		141,
		132,
		159,
		159,
		148,
		143,
		130,
		-1,
		-1,
		180,
		184,
		-1,
		-1,
		190,
		178,
		161,
		162,
		158,
		161,
		176,
		179,
		169,
		167,
		161,
		193,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		165,
		176,
		-1,
		-1,
		144,
		160,
		173,
		177,
		190,
		215,
		-1,
		133,
		-1,
		-1,
		201,
		-1,
		-1,
		220,
		183,
		172,
		163,
		169,
		166,
		177,
		187,
		175,
		176,
		166,
		176,
		189,
		205,
		202,
		190,
		188,
		211,
		173,
		164,
		-1,
		159,
		147,
		153,
		160,
		177,
		204,
		-1,
		-1,
		149,
		140,
		-1,
		-1,
		218,
		216,
		205,
		-1,
		195,
		168,
		173,
		193,
		195,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		159,
		-1,
		-1,
		213,
		206,
		194,
		182,
		172,
		182,
		186,
		190,
		182,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		248,
		-1,
		200,
		168,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		247,
		231,
		212,
		-1,
		182,
		195,
		226,
		194,
		199,
		194,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		213,
		232,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		219,
		215,
		-1,
		-1,
		183,
		208,
		197,
		205,
		200,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		193,
		196,
		201,
		-1,
		222,
		-1,
		216,
		-1,
		161,
		177,
		179,
		-1,
		-1,
		-1,
		221,
		184,
		205,
		215,
		209,
		207,
		198,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		242,
		216,
		223,
		214,
		197,
		177,
		169,
		194,
		-1,
		208,
		-1,
		183,
		185,
		211,
		214,
		220,
		214,
		187,
		202,
		192,
		183,
		192,
		248,
		-1,
		218,
		251,
		215,
		183,
		183,
		182,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		236,
		221,
		202,
		189,
		196,
		196,
		189,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		203,
		188,
		183,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		226,
		222,
		209,
		209,
		201,
		-1,
		320,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		223,
		196,
		184,
		198,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		202,
		237,
		-1,
		327,
		-1,
		250,
		-1,
		-1,
		230,
		216,
		218,
		207,
		196,
		194,
		195,
		186,
		208,
		224,
		208,
		206,
		209,
		210,
		-1,
		318,
		317,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		242,
		203,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		305,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		237,
		221,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		290,
		274,
		-1,
		243,
		246,
		-1,
		237,
		243,
		261,
		208,
		212,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		258,
		263,
		251,
		268,
		254,
		244,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		271,
		263,
		263,
		-1,
		-1,
		269,
		252,
		233,
		231,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		259,
		-1,
		-1,
		265,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		282,
		-1,
		-1,
		-1,
		255,
		251,
		252,
		-1,
		-1,
		-1,
		-1,
		303,
		304,
		328,
		303,
		-1,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		306,
		304,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		245,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		280,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		293,
		285,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		308,
		299,
		-1,
		-1,
		270,
		277,
		299,
		302,
		338,
		-1,
		289
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		214,
		203,
		214,
		222,
		195,
		202,
		-1,
		223,
		225,
		191,
		185,
		224,
		195,
		201,
		212,
		-1,
		-1,
		-1,
		214,
		213,
		183,
		181,
		190,
		195,
		202,
		-1,
		206,
		-1,
		235,
		214,
		225,
		230,
		176,
		173,
		193,
		212,
		199,
		191,
		250,
		206,
		177,
		171,
		189,
		184,
		193,
		185,
		-1,
		177,
		167,
		189,
		173,
		184,
		176,
		-1,
		-1,
		171,
		172,
		178,
		169,
		175,
		171,
		-1,
		181,
		165,
		-1,
		-1,
		161,
		167,
		151,
		154,
		162,
		160,
		173,
		165,
		160,
		-1,
		-1,
		157,
		153,
		160,
		147,
		143,
		160,
		173,
		155,
		169,
		168,
		-1,
		150,
		168,
		177,
		154,
		152,
		136,
		134,
		152,
		154,
		160,
		163,
		-1,
		143,
		145,
		155,
		163,
		168,
		152,
		139,
		139,
		149,
		142,
		161,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		140,
		142,
		159,
		151,
		141,
		156,
		149,
		142,
		139,
		137,
		134,
		150,
		151,
		161,
		-1,
		-1,
		196,
		165,
		200,
		157,
		142,
		-1,
		136,
		135,
		141,
		145,
		139,
		132,
		146,
		142,
		-1,
		128,
		127,
		158,
		144,
		155,
		156,
		-1,
		-1,
		154,
		146,
		131,
		134,
		131,
		131,
		150,
		149,
		141,
		127,
		123,
		129,
		132,
		132,
		138,
		122,
		132,
		136,
		147,
		162,
		-1,
		-1,
		217,
		-1,
		-1,
		153,
		136,
		-1,
		119,
		126,
		126,
		143,
		133,
		154,
		160,
		151,
		143,
		137,
		125,
		127,
		124,
		137,
		125,
		119,
		144,
		148,
		142,
		163,
		158,
		-1,
		216,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		112,
		115,
		121,
		145,
		155,
		-1,
		145,
		151,
		161,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		122,
		126,
		128,
		161,
		139,
		161,
		158,
		187,
		192,
		186,
		195,
		-1,
		161,
		157,
		153,
		160,
		109,
		-1,
		-1,
		149,
		-1,
		163,
		162,
		137,
		155,
		158,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		119,
		128,
		139,
		134,
		133,
		151,
		166,
		179,
		183,
		189,
		-1,
		211,
		-1,
		153,
		137,
		139,
		111,
		132,
		-1,
		169,
		164,
		154,
		139,
		130,
		-1,
		133,
		136,
		143,
		121,
		106,
		123,
		115,
		113,
		118,
		123,
		137,
		128,
		146,
		153,
		161,
		165,
		185,
		197,
		171,
		161,
		-1,
		143,
		148,
		107,
		115,
		134,
		172,
		136,
		-1,
		131,
		-1,
		123,
		148,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		122,
		119,
		116,
		134,
		137,
		154,
		158,
		174,
		-1,
		-1,
		156,
		160,
		149,
		100,
		119,
		143,
		180,
		129,
		118,
		117,
		-1,
		108,
		138,
		135,
		121,
		108,
		98,
		99,
		107,
		120,
		99,
		118,
		121,
		143,
		171,
		149,
		161,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		126,
		97,
		121,
		163,
		147,
		140,
		128,
		93,
		93,
		87,
		-1,
		128,
		111,
		107,
		96,
		94,
		107,
		102,
		118,
		122,
		121,
		140,
		152,
		143,
		163,
		-1,
		-1,
		-1,
		156,
		145,
		146,
		92,
		115,
		152,
		126,
		112,
		117,
		92,
		85,
		79,
		131,
		128,
		95,
		103,
		95,
		84,
		98,
		106,
		110,
		119,
		128,
		134,
		158,
		158,
		164,
		-1,
		-1,
		163,
		153,
		137,
		139,
		136,
		106,
		113,
		145,
		117,
		130,
		-1,
		84,
		-1,
		73,
		81,
		80,
		86,
		98,
		84,
		89,
		100,
		112,
		125,
		121,
		128,
		163,
		163,
		148,
		168,
		171,
		-1,
		-1,
		-1,
		156,
		151,
		126,
		103,
		87,
		123,
		-1,
		100,
		101,
		-1,
		78,
		72,
		78,
		77,
		84,
		81,
		81,
		95,
		103,
		99,
		115,
		121,
		113,
		149,
		-1,
		156,
		150,
		158,
		148,
		136,
		-1,
		-1,
		-1,
		149,
		128,
		121,
		141,
		82,
		134,
		-1,
		-1,
		85,
		78,
		-1,
		65,
		65,
		72,
		81,
		86,
		91,
		99,
		94,
		107,
		112,
		118,
		123,
		141,
		145,
		149,
		138,
		134,
		131,
		145,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		102,
		-1,
		94,
		86,
		76,
		70,
		64,
		67,
		69,
		96,
		88,
		102,
		102,
		108,
		116,
		101,
		104,
		120,
		118,
		136,
		144,
		136,
		130,
		129,
		141,
		-1,
		169,
		155,
		126,
		-1,
		-1,
		115,
		-1,
		79,
		93,
		109,
		-1,
		102,
		81,
		96,
		74,
		70,
		84,
		122,
		123,
		101,
		106,
		114,
		124,
		126,
		115,
		126,
		118,
		140,
		140,
		124,
		125,
		134,
		-1,
		175,
		162,
		120,
		116,
		105,
		125,
		76,
		64,
		96,
		-1,
		-1,
		71,
		-1,
		48,
		50,
		98,
		96,
		112,
		103,
		109,
		125,
		128,
		130,
		120,
		109,
		115,
		112,
		134,
		120,
		118,
		137,
		153,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		91,
		78,
		72,
		-1,
		113,
		-1,
		49,
		39,
		23,
		37,
		69,
		-1,
		120,
		104,
		109,
		-1,
		155,
		-1,
		128,
		130,
		124,
		109,
		106,
		117,
		115,
		126,
		143,
		-1,
		125,
		110,
		103,
		93,
		107,
		78,
		-1,
		133,
		-1,
		-1,
		36,
		30,
		18,
		43,
		46,
		136,
		116,
		110,
		109,
		150,
		150,
		136,
		122,
		115,
		112,
		109,
		122,
		142,
		133,
		145,
		-1,
		-1,
		-1,
		130,
		116,
		120,
		80,
		99,
		-1,
		-1,
		68,
		23,
		9,
		-1,
		52,
		153,
		141,
		131,
		121,
		155,
		156,
		141,
		134,
		120,
		122,
		120,
		118,
		123,
		144,
		145,
		158,
		-1,
		-1,
		113,
		118,
		106,
		92,
		111,
		-1,
		-1,
		-1,
		0,
		16,
		82,
		53,
		142,
		-1,
		-1,
		133,
		131,
		141,
		137,
		124,
		144,
		147,
		133,
		117,
		132,
		144,
		152,
		157,
		-1,
		116,
		103,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		-1,
		-1,
		39,
		73,
		85,
		106,
		131,
		136,
		-1,
		141,
		142,
		128,
		142,
		149,
		135,
		130,
		124,
		127,
		145,
		162,
		-1,
		-1,
		128,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		64,
		78,
		99,
		105,
		117,
		-1,
		143,
		144,
		130,
		147,
		148,
		145,
		136,
		128,
		133,
		130,
		143,
		157,
		161,
		151,
		-1,
		134,
		-1,
		-1,
		-1,
		82,
		97,
		159,
		136,
		109,
		114,
		124,
		129,
		134,
		154,
		156,
		167,
		135,
		131,
		132,
		136,
		135,
		152,
		162,
		-1,
		-1,
		134,
		143,
		108,
		90,
		94,
		186,
		-1,
		-1,
		124,
		130,
		126,
		136,
		144,
		147,
		141,
		138,
		143,
		148,
		136,
		145,
		163,
		167,
		-1,
		-1,
		-1,
		154,
		-1,
		141,
		-1,
		-1,
		109,
		210,
		157,
		139,
		135,
		133,
		138,
		147,
		142,
		146,
		156,
		165,
		157,
		138,
		149,
		172,
		161,
		199,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		183,
		158,
		173,
		194,
		129,
		136,
		172,
		169,
		-1,
		139,
		176,
		148,
		155,
		147,
		160,
		164,
		161,
		139,
		146,
		162,
		161,
		156,
		191,
		183,
		189,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		189,
		175,
		180,
		170,
		146,
		-1,
		-1,
		188,
		185,
		163,
		157,
		161,
		154,
		149,
		168,
		148,
		135,
		139,
		143,
		149,
		154,
		159,
		165,
		180,
		195,
		-1,
		161,
		242,
		235,
		218,
		226,
		257,
		-1,
		188,
		180,
		182,
		166,
		157,
		-1,
		-1,
		161,
		158,
		163,
		164,
		161,
		173,
		172,
		164,
		149,
		155,
		142,
		141,
		159,
		163,
		172,
		179,
		169,
		182,
		186,
		-1,
		175,
		218,
		212,
		215,
		239,
		253,
		-1,
		185,
		-1,
		-1,
		190,
		170,
		176,
		166,
		160,
		210,
		178,
		173,
		172,
		170,
		161,
		152,
		159,
		150,
		150,
		153,
		168,
		173,
		165,
		179,
		179,
		180,
		-1,
		210,
		198,
		206,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		206,
		-1,
		203,
		-1,
		178,
		182,
		186,
		189,
		186,
		173,
		165,
		157,
		173,
		148,
		158,
		154,
		155,
		164,
		175,
		187,
		186,
		187,
		280,
		236,
		206,
		197,
		244,
		259,
		263,
		-1,
		197,
		236,
		244,
		-1,
		215,
		-1,
		-1,
		-1,
		192,
		199,
		191,
		206,
		185,
		185,
		159,
		163,
		153,
		160,
		170,
		172,
		164,
		168,
		181,
		192,
		195,
		276,
		267,
		280,
		225,
		211,
		229,
		238,
		259,
		212,
		203,
		230,
		251,
		240,
		235,
		222,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		192,
		180,
		163,
		164,
		160,
		163,
		178,
		181,
		171,
		169,
		163,
		195,
		-1,
		269,
		268,
		257,
		254,
		230,
		221,
		216,
		230,
		-1,
		-1,
		215,
		231,
		244,
		248,
		264,
		289,
		-1,
		225,
		-1,
		-1,
		236,
		-1,
		-1,
		222,
		185,
		174,
		165,
		171,
		168,
		179,
		189,
		177,
		178,
		168,
		178,
		191,
		253,
		250,
		238,
		236,
		259,
		224,
		212,
		-1,
		225,
		218,
		224,
		231,
		248,
		278,
		-1,
		-1,
		241,
		232,
		-1,
		-1,
		220,
		218,
		207,
		-1,
		197,
		170,
		175,
		195,
		197,
		186,
		180,
		174,
		181,
		180,
		188,
		196,
		262,
		276,
		265,
		261,
		260,
		268,
		217,
		210,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		-1,
		258,
		251,
		-1,
		-1,
		215,
		208,
		196,
		184,
		174,
		184,
		188,
		192,
		184,
		177,
		172,
		183,
		175,
		179,
		196,
		-1,
		296,
		-1,
		248,
		224,
		238,
		253,
		261,
		-1,
		-1,
		-1,
		275,
		261,
		254,
		242,
		240,
		-1,
		249,
		233,
		214,
		-1,
		184,
		197,
		228,
		196,
		201,
		196,
		178,
		189,
		178,
		181,
		195,
		190,
		-1,
		-1,
		236,
		239,
		-1,
		-1,
		261,
		267,
		-1,
		266,
		255,
		240,
		232,
		-1,
		-1,
		221,
		217,
		-1,
		-1,
		185,
		210,
		199,
		207,
		202,
		182,
		188,
		191,
		180,
		184,
		196,
		-1,
		-1,
		243,
		244,
		249,
		-1,
		250,
		-1,
		268,
		-1,
		235,
		241,
		229,
		-1,
		-1,
		-1,
		223,
		186,
		207,
		217,
		211,
		209,
		200,
		186,
		193,
		191,
		187,
		198,
		-1,
		-1,
		-1,
		268,
		242,
		275,
		266,
		249,
		229,
		221,
		240,
		-1,
		210,
		-1,
		185,
		187,
		213,
		216,
		222,
		216,
		189,
		204,
		194,
		185,
		194,
		274,
		-1,
		244,
		277,
		241,
		235,
		211,
		215,
		231,
		-1,
		207,
		189,
		-1,
		217,
		207,
		238,
		223,
		204,
		191,
		198,
		198,
		191,
		-1,
		-1,
		-1,
		246,
		245,
		237,
		231,
		231,
		216,
		207,
		-1,
		219,
		201,
		180,
		197,
		197,
		188,
		196,
		228,
		224,
		211,
		211,
		203,
		-1,
		347,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		240,
		235,
		208,
		196,
		202,
		198,
		184,
		190,
		192,
		200,
		198,
		195,
		207,
		203,
		223,
		204,
		239,
		-1,
		342,
		-1,
		276,
		-1,
		-1,
		258,
		238,
		230,
		219,
		208,
		206,
		197,
		188,
		210,
		226,
		210,
		208,
		211,
		212,
		-1,
		331,
		330,
		-1,
		277,
		269,
		255,
		-1,
		248,
		-1,
		254,
		215,
		-1,
		217,
		197,
		-1,
		219,
		215,
		-1,
		-1,
		318,
		293,
		-1,
		-1,
		-1,
		278,
		258,
		249,
		233,
		-1,
		208,
		208,
		-1,
		-1,
		-1,
		303,
		302,
		-1,
		271,
		274,
		-1,
		264,
		255,
		263,
		210,
		214,
		-1,
		-1,
		-1,
		312,
		293,
		287,
		286,
		284,
		279,
		276,
		262,
		246,
		224,
		213,
		234,
		-1,
		-1,
		-1,
		284,
		276,
		269,
		-1,
		-1,
		271,
		254,
		235,
		233,
		-1,
		-1,
		-1,
		306,
		287,
		-1,
		-1,
		261,
		-1,
		-1,
		267,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		323,
		295,
		-1,
		-1,
		-1,
		257,
		253,
		254,
		-1,
		-1,
		-1,
		-1,
		317,
		318,
		341,
		305,
		-1,
		-1,
		-1,
		249,
		243,
		-1,
		-1,
		320,
		318,
		-1,
		-1,
		-1,
		277,
		261,
		-1,
		247,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		282,
		-1,
		282,
		257,
		264,
		-1,
		-1,
		-1,
		-1,
		295,
		287,
		295,
		-1,
		267,
		269,
		-1,
		317,
		-1,
		-1,
		310,
		301,
		-1,
		-1,
		272,
		279,
		301,
		304,
		340,
		-1,
		291
	],
	[
		-1,
		230,
		219,
		230,
		238,
		211,
		218,
		-1,
		239,
		241,
		207,
		201,
		240,
		211,
		217,
		228,
		-1,
		-1,
		-1,
		230,
		229,
		199,
		197,
		206,
		211,
		218,
		-1,
		222,
		-1,
		251,
		230,
		241,
		246,
		192,
		189,
		209,
		228,
		215,
		207,
		266,
		222,
		193,
		187,
		205,
		200,
		209,
		201,
		-1,
		193,
		183,
		205,
		189,
		200,
		192,
		-1,
		-1,
		187,
		188,
		194,
		185,
		191,
		187,
		-1,
		197,
		181,
		-1,
		-1,
		177,
		183,
		167,
		170,
		178,
		176,
		189,
		181,
		176,
		-1,
		-1,
		173,
		169,
		176,
		163,
		159,
		176,
		189,
		171,
		185,
		184,
		-1,
		166,
		184,
		193,
		170,
		168,
		152,
		150,
		168,
		170,
		176,
		179,
		-1,
		159,
		161,
		171,
		179,
		184,
		168,
		155,
		155,
		165,
		158,
		177,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		158,
		175,
		167,
		157,
		172,
		165,
		158,
		155,
		153,
		150,
		166,
		167,
		177,
		-1,
		-1,
		212,
		181,
		216,
		173,
		158,
		-1,
		152,
		151,
		157,
		161,
		155,
		148,
		162,
		158,
		-1,
		144,
		143,
		174,
		160,
		171,
		172,
		-1,
		-1,
		170,
		162,
		147,
		150,
		147,
		147,
		166,
		165,
		157,
		143,
		139,
		145,
		148,
		148,
		154,
		138,
		148,
		152,
		163,
		178,
		-1,
		-1,
		233,
		-1,
		-1,
		169,
		152,
		-1,
		135,
		142,
		142,
		159,
		149,
		170,
		176,
		167,
		159,
		153,
		141,
		143,
		140,
		153,
		141,
		135,
		160,
		164,
		158,
		179,
		174,
		-1,
		232,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		128,
		131,
		137,
		161,
		171,
		-1,
		161,
		167,
		177,
		162,
		159,
		146,
		134,
		147,
		132,
		139,
		138,
		142,
		144,
		177,
		155,
		177,
		174,
		203,
		208,
		202,
		211,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		165,
		-1,
		179,
		178,
		153,
		171,
		174,
		163,
		154,
		141,
		130,
		141,
		130,
		127,
		135,
		144,
		155,
		150,
		149,
		167,
		182,
		195,
		199,
		205,
		-1,
		227,
		-1,
		169,
		153,
		155,
		127,
		148,
		-1,
		185,
		180,
		170,
		155,
		146,
		-1,
		149,
		152,
		159,
		137,
		122,
		139,
		131,
		129,
		134,
		139,
		153,
		144,
		162,
		169,
		177,
		181,
		201,
		213,
		187,
		177,
		-1,
		159,
		164,
		123,
		131,
		150,
		188,
		152,
		-1,
		147,
		-1,
		139,
		164,
		-1,
		143,
		139,
		121,
		122,
		117,
		132,
		138,
		135,
		132,
		150,
		153,
		170,
		174,
		190,
		-1,
		-1,
		172,
		176,
		165,
		116,
		135,
		159,
		196,
		145,
		134,
		133,
		-1,
		124,
		154,
		151,
		137,
		124,
		114,
		115,
		123,
		136,
		115,
		134,
		137,
		159,
		187,
		165,
		177,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		142,
		113,
		137,
		179,
		163,
		156,
		144,
		109,
		109,
		103,
		-1,
		144,
		127,
		123,
		112,
		110,
		123,
		118,
		134,
		138,
		137,
		156,
		168,
		159,
		179,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		108,
		131,
		168,
		142,
		128,
		133,
		108,
		101,
		95,
		147,
		144,
		111,
		119,
		111,
		100,
		114,
		122,
		126,
		135,
		144,
		150,
		174,
		174,
		180,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		122,
		129,
		161,
		133,
		146,
		-1,
		100,
		-1,
		89,
		97,
		96,
		102,
		114,
		100,
		105,
		116,
		128,
		141,
		137,
		144,
		179,
		179,
		164,
		184,
		187,
		-1,
		-1,
		-1,
		172,
		167,
		142,
		119,
		103,
		139,
		-1,
		116,
		117,
		-1,
		94,
		88,
		94,
		93,
		100,
		97,
		97,
		111,
		119,
		115,
		131,
		137,
		129,
		165,
		-1,
		172,
		166,
		174,
		164,
		152,
		-1,
		-1,
		-1,
		165,
		144,
		137,
		157,
		98,
		150,
		-1,
		-1,
		101,
		94,
		-1,
		81,
		81,
		88,
		97,
		102,
		107,
		115,
		110,
		123,
		128,
		134,
		139,
		157,
		161,
		165,
		154,
		150,
		147,
		161,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		118,
		-1,
		110,
		102,
		92,
		86,
		80,
		83,
		85,
		112,
		104,
		118,
		118,
		124,
		132,
		117,
		120,
		136,
		134,
		152,
		160,
		152,
		146,
		145,
		157,
		-1,
		185,
		171,
		142,
		-1,
		-1,
		131,
		-1,
		95,
		109,
		125,
		-1,
		118,
		97,
		112,
		90,
		86,
		100,
		138,
		139,
		117,
		122,
		130,
		140,
		142,
		131,
		142,
		134,
		156,
		156,
		140,
		141,
		150,
		-1,
		191,
		178,
		136,
		132,
		121,
		141,
		92,
		80,
		112,
		-1,
		-1,
		87,
		-1,
		64,
		66,
		114,
		112,
		128,
		119,
		125,
		141,
		144,
		146,
		136,
		125,
		131,
		128,
		150,
		136,
		134,
		153,
		169,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		107,
		94,
		88,
		-1,
		129,
		-1,
		65,
		55,
		39,
		53,
		85,
		-1,
		136,
		120,
		125,
		-1,
		171,
		-1,
		144,
		146,
		140,
		125,
		122,
		133,
		131,
		142,
		159,
		-1,
		141,
		126,
		119,
		109,
		123,
		94,
		-1,
		149,
		-1,
		-1,
		52,
		46,
		34,
		59,
		62,
		152,
		132,
		126,
		125,
		166,
		166,
		152,
		138,
		131,
		128,
		125,
		138,
		158,
		149,
		161,
		-1,
		-1,
		-1,
		146,
		132,
		136,
		96,
		115,
		-1,
		-1,
		84,
		39,
		25,
		-1,
		68,
		169,
		157,
		147,
		137,
		171,
		172,
		157,
		150,
		136,
		138,
		136,
		134,
		139,
		160,
		161,
		174,
		-1,
		-1,
		129,
		134,
		122,
		108,
		127,
		-1,
		-1,
		-1,
		16,
		0,
		98,
		69,
		158,
		-1,
		-1,
		149,
		147,
		157,
		153,
		140,
		160,
		163,
		149,
		133,
		148,
		160,
		168,
		173,
		-1,
		132,
		119,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		-1,
		-1,
		23,
		80,
		92,
		113,
		138,
		152,
		-1,
		148,
		158,
		144,
		158,
		165,
		151,
		146,
		140,
		143,
		161,
		178,
		-1,
		-1,
		144,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		71,
		86,
		106,
		112,
		124,
		-1,
		150,
		152,
		146,
		161,
		164,
		161,
		152,
		144,
		149,
		146,
		159,
		173,
		177,
		167,
		-1,
		147,
		-1,
		-1,
		-1,
		74,
		89,
		166,
		143,
		116,
		121,
		131,
		136,
		141,
		161,
		167,
		178,
		151,
		147,
		148,
		152,
		151,
		168,
		178,
		-1,
		-1,
		145,
		135,
		100,
		82,
		86,
		193,
		-1,
		-1,
		131,
		137,
		133,
		143,
		151,
		154,
		157,
		154,
		159,
		164,
		152,
		161,
		179,
		183,
		-1,
		-1,
		-1,
		161,
		-1,
		133,
		-1,
		-1,
		101,
		217,
		164,
		146,
		142,
		140,
		145,
		154,
		149,
		154,
		172,
		174,
		173,
		154,
		165,
		188,
		177,
		215,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		190,
		152,
		167,
		186,
		121,
		128,
		179,
		176,
		-1,
		146,
		183,
		155,
		162,
		154,
		167,
		172,
		177,
		155,
		162,
		178,
		177,
		172,
		207,
		199,
		205,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		190,
		169,
		172,
		162,
		138,
		-1,
		-1,
		195,
		192,
		170,
		164,
		168,
		161,
		156,
		184,
		164,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		177,
		258,
		251,
		234,
		242,
		273,
		-1,
		180,
		172,
		176,
		158,
		149,
		-1,
		-1,
		168,
		165,
		170,
		171,
		168,
		180,
		179,
		180,
		165,
		171,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		191,
		234,
		228,
		231,
		255,
		269,
		-1,
		177,
		-1,
		-1,
		189,
		162,
		170,
		173,
		167,
		217,
		185,
		180,
		182,
		184,
		177,
		168,
		175,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		226,
		214,
		222,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		205,
		-1,
		196,
		-1,
		185,
		189,
		193,
		196,
		202,
		189,
		181,
		173,
		189,
		164,
		174,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		287,
		243,
		222,
		213,
		260,
		275,
		279,
		-1,
		189,
		228,
		243,
		-1,
		214,
		-1,
		-1,
		-1,
		199,
		206,
		198,
		214,
		201,
		201,
		175,
		179,
		169,
		176,
		186,
		188,
		180,
		184,
		197,
		208,
		211,
		283,
		274,
		287,
		232,
		227,
		245,
		254,
		275,
		204,
		195,
		222,
		250,
		239,
		234,
		221,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		208,
		196,
		179,
		180,
		176,
		179,
		194,
		197,
		187,
		185,
		179,
		211,
		-1,
		276,
		275,
		264,
		261,
		237,
		228,
		223,
		246,
		-1,
		-1,
		207,
		223,
		236,
		240,
		256,
		281,
		-1,
		224,
		-1,
		-1,
		243,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		184,
		195,
		205,
		193,
		194,
		184,
		194,
		207,
		260,
		257,
		245,
		243,
		266,
		231,
		219,
		-1,
		222,
		210,
		216,
		223,
		240,
		270,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		236,
		234,
		223,
		-1,
		213,
		186,
		191,
		211,
		213,
		202,
		196,
		190,
		197,
		196,
		204,
		212,
		269,
		283,
		272,
		268,
		267,
		275,
		224,
		217,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		-1,
		274,
		250,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		204,
		208,
		200,
		193,
		188,
		199,
		191,
		195,
		212,
		-1,
		303,
		-1,
		255,
		231,
		245,
		260,
		268,
		-1,
		-1,
		-1,
		291,
		277,
		270,
		258,
		256,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		194,
		205,
		194,
		197,
		211,
		206,
		-1,
		-1,
		243,
		246,
		-1,
		-1,
		268,
		283,
		-1,
		282,
		271,
		256,
		248,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		198,
		204,
		207,
		196,
		200,
		212,
		-1,
		-1,
		250,
		251,
		256,
		-1,
		266,
		-1,
		284,
		-1,
		251,
		257,
		245,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		227,
		225,
		216,
		202,
		209,
		207,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		258,
		291,
		282,
		265,
		245,
		237,
		256,
		-1,
		226,
		-1,
		201,
		203,
		229,
		232,
		238,
		232,
		205,
		220,
		210,
		201,
		210,
		290,
		-1,
		260,
		293,
		257,
		251,
		227,
		231,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		254,
		239,
		220,
		207,
		214,
		214,
		207,
		-1,
		-1,
		-1,
		262,
		261,
		253,
		247,
		247,
		232,
		223,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		244,
		240,
		227,
		227,
		219,
		-1,
		363,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		256,
		251,
		224,
		212,
		218,
		214,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		220,
		255,
		-1,
		358,
		-1,
		292,
		-1,
		-1,
		274,
		254,
		246,
		235,
		224,
		222,
		213,
		204,
		226,
		242,
		226,
		224,
		227,
		228,
		-1,
		347,
		346,
		-1,
		293,
		285,
		271,
		-1,
		264,
		-1,
		270,
		231,
		-1,
		233,
		213,
		-1,
		235,
		231,
		-1,
		-1,
		334,
		309,
		-1,
		-1,
		-1,
		294,
		274,
		265,
		249,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		319,
		318,
		-1,
		287,
		290,
		-1,
		280,
		271,
		279,
		226,
		230,
		-1,
		-1,
		-1,
		328,
		309,
		303,
		302,
		300,
		295,
		292,
		278,
		262,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		300,
		292,
		285,
		-1,
		-1,
		287,
		270,
		251,
		249,
		-1,
		-1,
		-1,
		322,
		303,
		-1,
		-1,
		277,
		-1,
		-1,
		283,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		311,
		-1,
		-1,
		-1,
		273,
		269,
		270,
		-1,
		-1,
		-1,
		-1,
		333,
		334,
		357,
		321,
		-1,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		336,
		334,
		-1,
		-1,
		-1,
		293,
		277,
		-1,
		263,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		298,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		311,
		303,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		326,
		317,
		-1,
		-1,
		288,
		295,
		317,
		320,
		356,
		-1,
		307
	],
	[
		-1,
		225,
		214,
		225,
		233,
		206,
		213,
		-1,
		234,
		236,
		202,
		196,
		235,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		225,
		224,
		194,
		192,
		201,
		206,
		213,
		-1,
		217,
		-1,
		246,
		225,
		236,
		241,
		187,
		184,
		204,
		223,
		210,
		202,
		261,
		217,
		188,
		182,
		200,
		195,
		204,
		196,
		-1,
		188,
		178,
		200,
		184,
		195,
		187,
		-1,
		-1,
		182,
		183,
		189,
		180,
		186,
		182,
		-1,
		192,
		176,
		-1,
		-1,
		172,
		178,
		162,
		165,
		173,
		171,
		184,
		176,
		171,
		-1,
		-1,
		168,
		164,
		171,
		158,
		154,
		171,
		184,
		166,
		180,
		179,
		-1,
		161,
		179,
		188,
		165,
		163,
		147,
		145,
		163,
		165,
		171,
		174,
		-1,
		154,
		156,
		166,
		174,
		179,
		163,
		150,
		150,
		160,
		153,
		172,
		163,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		151,
		153,
		170,
		162,
		152,
		167,
		160,
		153,
		150,
		148,
		145,
		161,
		162,
		172,
		-1,
		-1,
		207,
		176,
		211,
		168,
		153,
		-1,
		147,
		146,
		152,
		156,
		150,
		143,
		157,
		153,
		-1,
		139,
		138,
		169,
		155,
		166,
		167,
		-1,
		-1,
		165,
		157,
		142,
		145,
		142,
		142,
		161,
		160,
		152,
		138,
		134,
		140,
		143,
		143,
		149,
		133,
		143,
		147,
		158,
		173,
		-1,
		-1,
		228,
		-1,
		-1,
		164,
		147,
		-1,
		130,
		137,
		137,
		154,
		144,
		165,
		171,
		162,
		154,
		148,
		136,
		138,
		135,
		148,
		136,
		130,
		155,
		159,
		153,
		174,
		169,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		123,
		126,
		132,
		156,
		166,
		-1,
		156,
		162,
		172,
		157,
		154,
		141,
		129,
		142,
		127,
		134,
		133,
		137,
		139,
		172,
		150,
		172,
		169,
		198,
		203,
		197,
		206,
		-1,
		172,
		168,
		164,
		171,
		120,
		-1,
		-1,
		160,
		-1,
		174,
		173,
		148,
		166,
		169,
		158,
		149,
		136,
		125,
		136,
		125,
		122,
		130,
		139,
		150,
		145,
		144,
		162,
		177,
		190,
		194,
		200,
		-1,
		222,
		-1,
		164,
		148,
		150,
		122,
		143,
		-1,
		180,
		175,
		165,
		150,
		141,
		-1,
		144,
		147,
		154,
		132,
		117,
		134,
		126,
		124,
		129,
		134,
		148,
		139,
		157,
		164,
		172,
		176,
		196,
		208,
		182,
		172,
		-1,
		154,
		159,
		118,
		126,
		145,
		183,
		147,
		-1,
		142,
		-1,
		134,
		159,
		-1,
		138,
		134,
		116,
		117,
		112,
		127,
		133,
		130,
		127,
		145,
		148,
		165,
		169,
		185,
		-1,
		-1,
		167,
		171,
		160,
		111,
		130,
		154,
		191,
		140,
		129,
		128,
		-1,
		119,
		149,
		146,
		132,
		119,
		109,
		110,
		118,
		131,
		110,
		129,
		132,
		154,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		137,
		108,
		132,
		174,
		158,
		151,
		139,
		104,
		104,
		98,
		-1,
		139,
		122,
		118,
		107,
		105,
		118,
		113,
		129,
		133,
		132,
		151,
		163,
		154,
		174,
		-1,
		-1,
		-1,
		167,
		156,
		157,
		103,
		126,
		163,
		137,
		123,
		128,
		103,
		96,
		90,
		142,
		139,
		106,
		114,
		106,
		95,
		109,
		117,
		121,
		130,
		139,
		145,
		169,
		169,
		175,
		-1,
		-1,
		174,
		164,
		148,
		150,
		147,
		117,
		124,
		156,
		128,
		141,
		-1,
		95,
		-1,
		84,
		92,
		91,
		97,
		109,
		95,
		100,
		111,
		123,
		136,
		132,
		139,
		174,
		174,
		159,
		179,
		182,
		-1,
		-1,
		-1,
		167,
		162,
		137,
		114,
		98,
		134,
		-1,
		111,
		112,
		-1,
		89,
		83,
		89,
		88,
		95,
		92,
		92,
		106,
		114,
		110,
		126,
		132,
		124,
		160,
		-1,
		167,
		161,
		169,
		159,
		147,
		-1,
		-1,
		-1,
		160,
		139,
		132,
		152,
		93,
		145,
		-1,
		-1,
		96,
		89,
		-1,
		76,
		76,
		83,
		92,
		97,
		102,
		110,
		105,
		118,
		123,
		129,
		134,
		152,
		156,
		160,
		149,
		145,
		142,
		156,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		113,
		-1,
		105,
		97,
		87,
		81,
		75,
		84,
		86,
		107,
		99,
		113,
		113,
		119,
		127,
		112,
		115,
		131,
		129,
		147,
		155,
		147,
		141,
		140,
		152,
		-1,
		180,
		166,
		137,
		-1,
		-1,
		126,
		-1,
		90,
		104,
		120,
		-1,
		113,
		92,
		107,
		85,
		87,
		95,
		133,
		134,
		112,
		117,
		125,
		135,
		137,
		126,
		137,
		129,
		151,
		151,
		135,
		136,
		145,
		-1,
		186,
		173,
		131,
		127,
		116,
		136,
		87,
		75,
		107,
		-1,
		-1,
		113,
		-1,
		65,
		67,
		109,
		107,
		123,
		114,
		120,
		136,
		139,
		141,
		131,
		120,
		126,
		123,
		145,
		131,
		129,
		148,
		164,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		102,
		89,
		83,
		-1,
		124,
		-1,
		91,
		79,
		66,
		48,
		86,
		-1,
		131,
		115,
		120,
		-1,
		166,
		-1,
		139,
		141,
		135,
		120,
		117,
		128,
		126,
		137,
		154,
		-1,
		136,
		121,
		114,
		104,
		118,
		89,
		-1,
		144,
		-1,
		-1,
		78,
		72,
		72,
		41,
		38,
		147,
		127,
		121,
		120,
		153,
		140,
		139,
		127,
		126,
		123,
		120,
		133,
		153,
		144,
		156,
		-1,
		-1,
		-1,
		141,
		127,
		131,
		91,
		110,
		-1,
		-1,
		139,
		95,
		81,
		-1,
		33,
		135,
		125,
		134,
		132,
		140,
		141,
		131,
		129,
		125,
		133,
		131,
		129,
		134,
		155,
		156,
		169,
		-1,
		-1,
		124,
		129,
		117,
		103,
		122,
		-1,
		-1,
		-1,
		85,
		101,
		0,
		31,
		123,
		-1,
		-1,
		139,
		132,
		126,
		129,
		117,
		137,
		144,
		144,
		128,
		143,
		155,
		163,
		168,
		-1,
		127,
		114,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		-1,
		-1,
		85,
		44,
		56,
		77,
		102,
		138,
		-1,
		112,
		123,
		116,
		135,
		142,
		146,
		141,
		135,
		138,
		156,
		173,
		-1,
		-1,
		139,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		42,
		48,
		70,
		76,
		88,
		-1,
		114,
		116,
		113,
		125,
		136,
		141,
		147,
		133,
		144,
		141,
		154,
		168,
		172,
		162,
		-1,
		133,
		-1,
		-1,
		-1,
		60,
		75,
		130,
		107,
		80,
		85,
		95,
		100,
		105,
		125,
		131,
		142,
		127,
		131,
		143,
		147,
		146,
		163,
		173,
		-1,
		-1,
		131,
		121,
		86,
		68,
		72,
		157,
		-1,
		-1,
		95,
		101,
		97,
		107,
		115,
		118,
		123,
		125,
		143,
		159,
		147,
		156,
		174,
		176,
		-1,
		-1,
		-1,
		147,
		-1,
		119,
		-1,
		-1,
		87,
		181,
		128,
		110,
		106,
		104,
		109,
		118,
		113,
		118,
		143,
		138,
		147,
		149,
		156,
		179,
		168,
		207,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		176,
		138,
		153,
		172,
		107,
		114,
		143,
		140,
		-1,
		110,
		147,
		119,
		126,
		118,
		131,
		136,
		142,
		146,
		153,
		169,
		168,
		163,
		199,
		190,
		196,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		176,
		155,
		158,
		148,
		124,
		-1,
		-1,
		159,
		156,
		134,
		128,
		132,
		125,
		120,
		158,
		134,
		142,
		146,
		150,
		156,
		161,
		166,
		172,
		187,
		202,
		-1,
		172,
		253,
		246,
		229,
		237,
		268,
		-1,
		166,
		158,
		162,
		144,
		135,
		-1,
		-1,
		132,
		129,
		134,
		135,
		132,
		144,
		143,
		154,
		156,
		161,
		149,
		148,
		166,
		170,
		179,
		186,
		176,
		189,
		193,
		-1,
		186,
		229,
		223,
		226,
		250,
		264,
		-1,
		163,
		-1,
		-1,
		175,
		148,
		147,
		137,
		131,
		181,
		149,
		144,
		146,
		148,
		152,
		143,
		166,
		157,
		157,
		160,
		175,
		180,
		172,
		186,
		186,
		187,
		-1,
		221,
		209,
		217,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		191,
		-1,
		174,
		-1,
		149,
		153,
		157,
		160,
		171,
		158,
		156,
		164,
		172,
		155,
		165,
		161,
		162,
		171,
		182,
		194,
		193,
		194,
		251,
		207,
		210,
		208,
		232,
		247,
		251,
		-1,
		175,
		214,
		229,
		-1,
		200,
		-1,
		-1,
		-1,
		163,
		170,
		162,
		178,
		170,
		170,
		150,
		154,
		160,
		167,
		177,
		179,
		171,
		175,
		188,
		199,
		202,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		190,
		181,
		208,
		236,
		225,
		220,
		207,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		177,
		171,
		154,
		156,
		160,
		170,
		185,
		188,
		178,
		176,
		170,
		202,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		193,
		209,
		220,
		224,
		240,
		265,
		-1,
		210,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		176,
		165,
		156,
		162,
		168,
		179,
		196,
		184,
		185,
		175,
		185,
		198,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		211,
		209,
		198,
		-1,
		188,
		161,
		166,
		191,
		198,
		193,
		187,
		181,
		188,
		187,
		195,
		203,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		236,
		-1,
		-1,
		206,
		199,
		187,
		175,
		165,
		175,
		183,
		183,
		186,
		184,
		179,
		190,
		182,
		186,
		203,
		-1,
		267,
		-1,
		219,
		195,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		240,
		224,
		205,
		-1,
		175,
		188,
		219,
		187,
		192,
		187,
		185,
		196,
		185,
		188,
		202,
		197,
		-1,
		-1,
		207,
		210,
		-1,
		-1,
		232,
		251,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		212,
		208,
		-1,
		-1,
		176,
		201,
		190,
		198,
		193,
		189,
		195,
		198,
		187,
		191,
		203,
		-1,
		-1,
		214,
		215,
		220,
		-1,
		236,
		-1,
		254,
		-1,
		221,
		227,
		215,
		-1,
		-1,
		-1,
		214,
		177,
		194,
		208,
		213,
		211,
		202,
		193,
		200,
		198,
		194,
		205,
		-1,
		-1,
		-1,
		254,
		228,
		261,
		252,
		235,
		215,
		207,
		226,
		-1,
		196,
		-1,
		171,
		174,
		199,
		207,
		224,
		218,
		196,
		211,
		201,
		192,
		201,
		260,
		-1,
		230,
		263,
		227,
		221,
		197,
		201,
		217,
		-1,
		193,
		175,
		-1,
		203,
		193,
		241,
		216,
		211,
		198,
		205,
		205,
		198,
		-1,
		-1,
		-1,
		232,
		231,
		223,
		217,
		217,
		202,
		193,
		-1,
		205,
		187,
		166,
		183,
		183,
		174,
		182,
		231,
		227,
		218,
		218,
		206,
		-1,
		333,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		226,
		221,
		194,
		182,
		188,
		184,
		170,
		176,
		178,
		186,
		184,
		181,
		193,
		189,
		209,
		205,
		237,
		-1,
		328,
		-1,
		262,
		-1,
		-1,
		244,
		224,
		216,
		205,
		194,
		192,
		183,
		174,
		196,
		212,
		196,
		194,
		199,
		204,
		-1,
		317,
		316,
		-1,
		263,
		255,
		241,
		-1,
		234,
		-1,
		240,
		201,
		-1,
		203,
		183,
		-1,
		205,
		201,
		-1,
		-1,
		304,
		279,
		-1,
		-1,
		-1,
		264,
		244,
		235,
		219,
		-1,
		194,
		194,
		-1,
		-1,
		-1,
		289,
		288,
		-1,
		257,
		260,
		-1,
		250,
		241,
		249,
		196,
		200,
		-1,
		-1,
		-1,
		298,
		279,
		273,
		272,
		270,
		265,
		262,
		248,
		232,
		210,
		199,
		220,
		-1,
		-1,
		-1,
		270,
		262,
		255,
		-1,
		-1,
		257,
		240,
		221,
		219,
		-1,
		-1,
		-1,
		292,
		273,
		-1,
		-1,
		247,
		-1,
		-1,
		253,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		281,
		-1,
		-1,
		-1,
		243,
		239,
		240,
		-1,
		-1,
		-1,
		-1,
		303,
		304,
		327,
		291,
		-1,
		-1,
		-1,
		235,
		229,
		-1,
		-1,
		306,
		304,
		-1,
		-1,
		-1,
		263,
		247,
		-1,
		233,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		268,
		-1,
		268,
		243,
		250,
		-1,
		-1,
		-1,
		-1,
		281,
		273,
		281,
		-1,
		253,
		255,
		-1,
		303,
		-1,
		-1,
		296,
		287,
		-1,
		-1,
		258,
		265,
		287,
		290,
		326,
		-1,
		277
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		203,
		205,
		171,
		165,
		204,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		194,
		193,
		163,
		161,
		170,
		175,
		182,
		-1,
		186,
		-1,
		215,
		194,
		205,
		210,
		156,
		153,
		173,
		192,
		179,
		171,
		230,
		186,
		157,
		151,
		169,
		164,
		173,
		165,
		-1,
		157,
		147,
		169,
		153,
		164,
		156,
		-1,
		-1,
		151,
		152,
		158,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		141,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		130,
		148,
		157,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		143,
		-1,
		123,
		125,
		135,
		143,
		148,
		132,
		119,
		119,
		129,
		122,
		141,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		120,
		122,
		139,
		131,
		121,
		136,
		129,
		122,
		119,
		117,
		114,
		130,
		131,
		141,
		-1,
		-1,
		176,
		145,
		180,
		137,
		122,
		-1,
		116,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		108,
		107,
		138,
		124,
		135,
		136,
		-1,
		-1,
		134,
		126,
		111,
		114,
		111,
		111,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		102,
		112,
		116,
		127,
		142,
		-1,
		-1,
		197,
		-1,
		-1,
		133,
		116,
		-1,
		99,
		106,
		106,
		123,
		113,
		134,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		99,
		124,
		128,
		122,
		143,
		138,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		92,
		95,
		101,
		125,
		135,
		-1,
		125,
		131,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		106,
		108,
		141,
		119,
		141,
		138,
		167,
		172,
		166,
		175,
		-1,
		141,
		137,
		133,
		140,
		89,
		-1,
		-1,
		129,
		-1,
		143,
		142,
		117,
		135,
		138,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		108,
		119,
		114,
		113,
		131,
		146,
		159,
		163,
		169,
		-1,
		191,
		-1,
		133,
		117,
		119,
		91,
		112,
		-1,
		149,
		144,
		134,
		119,
		110,
		-1,
		113,
		116,
		123,
		101,
		86,
		103,
		95,
		93,
		98,
		103,
		117,
		108,
		126,
		133,
		141,
		145,
		165,
		177,
		151,
		141,
		-1,
		123,
		128,
		87,
		95,
		114,
		152,
		116,
		-1,
		111,
		-1,
		103,
		128,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		102,
		99,
		96,
		114,
		117,
		134,
		138,
		154,
		-1,
		-1,
		136,
		140,
		129,
		80,
		99,
		123,
		160,
		109,
		98,
		97,
		-1,
		88,
		118,
		115,
		101,
		88,
		78,
		79,
		87,
		100,
		79,
		98,
		101,
		123,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		106,
		77,
		101,
		143,
		127,
		120,
		108,
		73,
		73,
		67,
		-1,
		108,
		91,
		87,
		76,
		74,
		87,
		82,
		98,
		102,
		101,
		120,
		132,
		123,
		143,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		72,
		95,
		132,
		106,
		92,
		97,
		72,
		65,
		59,
		111,
		108,
		75,
		83,
		75,
		64,
		78,
		86,
		90,
		99,
		108,
		114,
		138,
		138,
		144,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		86,
		93,
		125,
		97,
		110,
		-1,
		64,
		-1,
		53,
		61,
		60,
		66,
		78,
		64,
		69,
		80,
		92,
		105,
		101,
		108,
		143,
		143,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		136,
		131,
		106,
		83,
		67,
		103,
		-1,
		80,
		81,
		-1,
		58,
		52,
		58,
		57,
		64,
		61,
		61,
		75,
		83,
		79,
		95,
		101,
		93,
		129,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		129,
		108,
		101,
		121,
		62,
		114,
		-1,
		-1,
		65,
		58,
		-1,
		45,
		45,
		52,
		61,
		66,
		71,
		79,
		74,
		87,
		92,
		98,
		103,
		121,
		125,
		129,
		118,
		114,
		111,
		125,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		82,
		-1,
		74,
		66,
		56,
		50,
		44,
		55,
		56,
		76,
		68,
		82,
		82,
		88,
		96,
		81,
		84,
		100,
		98,
		116,
		124,
		116,
		110,
		109,
		121,
		-1,
		149,
		135,
		106,
		-1,
		-1,
		95,
		-1,
		59,
		73,
		89,
		-1,
		82,
		61,
		76,
		54,
		58,
		64,
		102,
		103,
		81,
		86,
		94,
		104,
		106,
		95,
		106,
		98,
		120,
		120,
		104,
		105,
		114,
		-1,
		155,
		142,
		100,
		96,
		85,
		105,
		56,
		44,
		76,
		-1,
		-1,
		82,
		-1,
		36,
		38,
		78,
		76,
		92,
		83,
		89,
		105,
		108,
		110,
		100,
		89,
		95,
		92,
		114,
		100,
		98,
		117,
		133,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		71,
		58,
		52,
		-1,
		93,
		-1,
		60,
		48,
		35,
		17,
		57,
		-1,
		100,
		84,
		89,
		-1,
		135,
		-1,
		108,
		110,
		104,
		89,
		86,
		97,
		95,
		106,
		123,
		-1,
		105,
		90,
		83,
		73,
		87,
		58,
		-1,
		113,
		-1,
		-1,
		47,
		41,
		41,
		10,
		7,
		116,
		96,
		90,
		89,
		129,
		116,
		115,
		102,
		95,
		92,
		89,
		102,
		122,
		113,
		125,
		-1,
		-1,
		-1,
		110,
		96,
		100,
		60,
		79,
		-1,
		-1,
		108,
		64,
		50,
		-1,
		2,
		111,
		101,
		110,
		101,
		116,
		117,
		107,
		105,
		100,
		102,
		100,
		98,
		103,
		124,
		125,
		138,
		-1,
		-1,
		93,
		98,
		86,
		72,
		91,
		-1,
		-1,
		-1,
		54,
		70,
		29,
		0,
		99,
		-1,
		-1,
		113,
		108,
		102,
		105,
		93,
		113,
		120,
		113,
		97,
		112,
		124,
		132,
		137,
		-1,
		96,
		83,
		-1,
		-1,
		94,
		88,
		-1,
		-1,
		-1,
		-1,
		54,
		20,
		32,
		53,
		78,
		114,
		-1,
		88,
		99,
		92,
		111,
		118,
		115,
		110,
		104,
		107,
		125,
		142,
		-1,
		-1,
		108,
		-1,
		103,
		-1,
		-1,
		-1,
		-1,
		11,
		25,
		46,
		52,
		64,
		-1,
		90,
		92,
		89,
		101,
		112,
		117,
		116,
		108,
		113,
		110,
		123,
		137,
		141,
		131,
		-1,
		102,
		-1,
		-1,
		-1,
		29,
		44,
		106,
		83,
		56,
		61,
		71,
		76,
		81,
		101,
		107,
		118,
		103,
		107,
		112,
		116,
		115,
		132,
		142,
		-1,
		-1,
		100,
		90,
		55,
		37,
		41,
		133,
		-1,
		-1,
		71,
		77,
		73,
		83,
		91,
		94,
		99,
		101,
		119,
		128,
		116,
		125,
		143,
		147,
		-1,
		-1,
		-1,
		116,
		-1,
		88,
		-1,
		-1,
		56,
		157,
		104,
		86,
		82,
		80,
		85,
		94,
		89,
		94,
		119,
		114,
		123,
		118,
		129,
		152,
		141,
		179,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		145,
		107,
		122,
		141,
		76,
		83,
		119,
		116,
		-1,
		86,
		123,
		95,
		102,
		94,
		107,
		112,
		118,
		119,
		126,
		142,
		141,
		136,
		171,
		163,
		169,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		145,
		124,
		127,
		117,
		93,
		-1,
		-1,
		135,
		132,
		110,
		104,
		108,
		101,
		96,
		134,
		110,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		141,
		222,
		215,
		198,
		206,
		237,
		-1,
		135,
		127,
		131,
		113,
		104,
		-1,
		-1,
		108,
		105,
		110,
		111,
		108,
		120,
		119,
		130,
		129,
		135,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		155,
		198,
		192,
		195,
		219,
		233,
		-1,
		132,
		-1,
		-1,
		144,
		117,
		123,
		113,
		107,
		157,
		125,
		120,
		122,
		124,
		128,
		119,
		139,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		190,
		178,
		186,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		150,
		-1,
		125,
		129,
		133,
		136,
		147,
		134,
		132,
		137,
		148,
		128,
		138,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		227,
		183,
		186,
		177,
		208,
		223,
		227,
		-1,
		144,
		183,
		198,
		-1,
		169,
		-1,
		-1,
		-1,
		139,
		146,
		138,
		154,
		146,
		146,
		126,
		130,
		133,
		140,
		150,
		152,
		144,
		148,
		161,
		172,
		175,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		159,
		150,
		177,
		205,
		194,
		189,
		176,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		153,
		147,
		130,
		132,
		136,
		143,
		158,
		161,
		151,
		149,
		143,
		175,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		162,
		178,
		191,
		195,
		211,
		236,
		-1,
		179,
		-1,
		-1,
		183,
		-1,
		-1,
		189,
		152,
		141,
		132,
		138,
		144,
		155,
		169,
		157,
		158,
		148,
		158,
		171,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		165,
		171,
		178,
		195,
		225,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		137,
		142,
		167,
		174,
		166,
		160,
		154,
		161,
		160,
		168,
		176,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		205,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		159,
		159,
		162,
		157,
		152,
		163,
		155,
		159,
		176,
		-1,
		243,
		-1,
		195,
		171,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		195,
		163,
		168,
		163,
		158,
		169,
		158,
		161,
		175,
		170,
		-1,
		-1,
		183,
		186,
		-1,
		-1,
		208,
		227,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		152,
		177,
		166,
		174,
		169,
		162,
		168,
		171,
		160,
		164,
		176,
		-1,
		-1,
		190,
		191,
		196,
		-1,
		212,
		-1,
		230,
		-1,
		197,
		203,
		191,
		-1,
		-1,
		-1,
		190,
		153,
		170,
		184,
		189,
		187,
		178,
		166,
		173,
		171,
		167,
		178,
		-1,
		-1,
		-1,
		230,
		204,
		237,
		228,
		211,
		191,
		183,
		202,
		-1,
		172,
		-1,
		147,
		150,
		175,
		183,
		200,
		194,
		169,
		184,
		174,
		165,
		174,
		236,
		-1,
		206,
		239,
		203,
		197,
		173,
		177,
		193,
		-1,
		169,
		151,
		-1,
		179,
		169,
		217,
		192,
		184,
		171,
		178,
		178,
		171,
		-1,
		-1,
		-1,
		208,
		207,
		199,
		193,
		193,
		178,
		169,
		-1,
		181,
		163,
		142,
		159,
		159,
		150,
		158,
		207,
		203,
		191,
		191,
		182,
		-1,
		309,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		202,
		197,
		170,
		158,
		164,
		160,
		146,
		152,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		181,
		213,
		-1,
		304,
		-1,
		238,
		-1,
		-1,
		220,
		200,
		192,
		181,
		170,
		168,
		159,
		150,
		172,
		188,
		172,
		170,
		175,
		180,
		-1,
		293,
		292,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		216,
		177,
		-1,
		179,
		159,
		-1,
		181,
		177,
		-1,
		-1,
		280,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		211,
		195,
		-1,
		170,
		170,
		-1,
		-1,
		-1,
		265,
		264,
		-1,
		233,
		236,
		-1,
		226,
		217,
		225,
		172,
		176,
		-1,
		-1,
		-1,
		274,
		255,
		249,
		248,
		246,
		241,
		238,
		224,
		208,
		186,
		175,
		196,
		-1,
		-1,
		-1,
		246,
		238,
		231,
		-1,
		-1,
		233,
		216,
		197,
		195,
		-1,
		-1,
		-1,
		268,
		249,
		-1,
		-1,
		223,
		-1,
		-1,
		229,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		257,
		-1,
		-1,
		-1,
		219,
		215,
		216,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		303,
		267,
		-1,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		282,
		280,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		209,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		244,
		-1,
		244,
		219,
		226,
		-1,
		-1,
		-1,
		-1,
		257,
		249,
		257,
		-1,
		229,
		231,
		-1,
		279,
		-1,
		-1,
		272,
		263,
		-1,
		-1,
		234,
		241,
		263,
		266,
		302,
		-1,
		253
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		224,
		226,
		192,
		186,
		225,
		196,
		202,
		213,
		-1,
		-1,
		-1,
		215,
		214,
		184,
		182,
		191,
		196,
		203,
		-1,
		207,
		-1,
		236,
		215,
		226,
		231,
		177,
		174,
		194,
		213,
		200,
		192,
		251,
		207,
		178,
		172,
		190,
		185,
		194,
		186,
		-1,
		178,
		168,
		190,
		174,
		185,
		177,
		-1,
		-1,
		172,
		173,
		179,
		170,
		176,
		172,
		-1,
		182,
		166,
		-1,
		-1,
		162,
		168,
		152,
		155,
		163,
		161,
		174,
		166,
		161,
		-1,
		-1,
		158,
		154,
		161,
		148,
		144,
		161,
		174,
		156,
		170,
		169,
		-1,
		151,
		169,
		178,
		155,
		153,
		137,
		135,
		153,
		155,
		161,
		164,
		-1,
		160,
		161,
		156,
		164,
		169,
		153,
		140,
		140,
		150,
		143,
		162,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		160,
		143,
		160,
		152,
		142,
		157,
		150,
		143,
		140,
		138,
		135,
		151,
		152,
		162,
		-1,
		-1,
		239,
		208,
		243,
		200,
		185,
		-1,
		156,
		136,
		142,
		146,
		140,
		133,
		147,
		143,
		-1,
		129,
		128,
		159,
		145,
		156,
		199,
		-1,
		-1,
		197,
		189,
		174,
		177,
		166,
		162,
		151,
		150,
		142,
		128,
		124,
		130,
		133,
		133,
		139,
		123,
		133,
		137,
		147,
		163,
		-1,
		-1,
		209,
		-1,
		-1,
		196,
		179,
		-1,
		162,
		169,
		169,
		178,
		164,
		185,
		161,
		152,
		144,
		138,
		126,
		128,
		125,
		138,
		126,
		120,
		145,
		149,
		142,
		163,
		158,
		-1,
		208,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		155,
		158,
		164,
		188,
		198,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		127,
		129,
		162,
		139,
		161,
		158,
		179,
		184,
		178,
		187,
		-1,
		204,
		200,
		196,
		203,
		152,
		-1,
		-1,
		192,
		-1,
		206,
		205,
		180,
		158,
		161,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		128,
		140,
		134,
		133,
		151,
		163,
		171,
		175,
		181,
		-1,
		254,
		-1,
		196,
		180,
		182,
		154,
		175,
		-1,
		212,
		207,
		197,
		182,
		173,
		-1,
		157,
		154,
		144,
		122,
		107,
		124,
		116,
		114,
		119,
		123,
		137,
		128,
		146,
		153,
		153,
		157,
		177,
		189,
		214,
		204,
		-1,
		186,
		191,
		150,
		158,
		177,
		215,
		179,
		-1,
		174,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		122,
		119,
		116,
		134,
		137,
		146,
		150,
		166,
		-1,
		-1,
		199,
		203,
		192,
		143,
		162,
		186,
		223,
		172,
		161,
		160,
		-1,
		151,
		142,
		139,
		127,
		114,
		99,
		100,
		108,
		120,
		99,
		118,
		117,
		137,
		163,
		141,
		153,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		169,
		140,
		164,
		206,
		190,
		183,
		171,
		136,
		136,
		130,
		-1,
		138,
		117,
		108,
		97,
		95,
		108,
		100,
		118,
		115,
		113,
		132,
		144,
		135,
		155,
		-1,
		-1,
		-1,
		199,
		188,
		189,
		135,
		158,
		195,
		169,
		155,
		160,
		135,
		128,
		122,
		148,
		134,
		112,
		104,
		96,
		85,
		96,
		104,
		108,
		111,
		120,
		126,
		150,
		144,
		150,
		-1,
		-1,
		206,
		196,
		180,
		182,
		179,
		149,
		156,
		188,
		160,
		173,
		-1,
		127,
		-1,
		116,
		107,
		105,
		98,
		101,
		82,
		87,
		101,
		110,
		118,
		113,
		120,
		155,
		155,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		199,
		194,
		169,
		146,
		130,
		166,
		-1,
		143,
		144,
		-1,
		121,
		115,
		110,
		102,
		103,
		86,
		86,
		87,
		101,
		85,
		104,
		106,
		105,
		139,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		125,
		177,
		-1,
		-1,
		128,
		121,
		-1,
		108,
		90,
		84,
		76,
		70,
		79,
		72,
		79,
		92,
		97,
		110,
		108,
		127,
		131,
		135,
		124,
		120,
		117,
		131,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		145,
		-1,
		137,
		129,
		119,
		113,
		107,
		101,
		99,
		98,
		82,
		85,
		80,
		77,
		83,
		86,
		89,
		105,
		104,
		122,
		130,
		122,
		116,
		115,
		127,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		158,
		-1,
		122,
		136,
		152,
		-1,
		145,
		124,
		139,
		117,
		111,
		96,
		88,
		89,
		59,
		64,
		73,
		83,
		87,
		100,
		112,
		104,
		126,
		126,
		110,
		111,
		120,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		119,
		107,
		139,
		-1,
		-1,
		172,
		-1,
		115,
		128,
		110,
		108,
		78,
		52,
		59,
		84,
		81,
		76,
		99,
		94,
		96,
		98,
		120,
		106,
		104,
		123,
		139,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		150,
		138,
		125,
		107,
		147,
		-1,
		49,
		45,
		54,
		-1,
		101,
		-1,
		73,
		86,
		86,
		88,
		92,
		103,
		101,
		112,
		129,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		176,
		-1,
		-1,
		137,
		131,
		131,
		100,
		97,
		65,
		45,
		35,
		54,
		84,
		71,
		70,
		76,
		81,
		85,
		95,
		108,
		128,
		119,
		131,
		-1,
		-1,
		-1,
		173,
		159,
		163,
		123,
		142,
		-1,
		-1,
		198,
		154,
		140,
		-1,
		92,
		12,
		2,
		11,
		23,
		71,
		72,
		62,
		67,
		76,
		88,
		93,
		104,
		109,
		130,
		130,
		144,
		-1,
		-1,
		156,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		144,
		145,
		111,
		90,
		0,
		-1,
		-1,
		47,
		47,
		57,
		63,
		78,
		92,
		99,
		114,
		103,
		118,
		130,
		138,
		142,
		-1,
		159,
		146,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		-1,
		-1,
		123,
		68,
		57,
		46,
		77,
		51,
		-1,
		57,
		58,
		76,
		88,
		95,
		116,
		110,
		104,
		113,
		130,
		147,
		-1,
		-1,
		171,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		80,
		74,
		45,
		51,
		63,
		-1,
		66,
		66,
		78,
		89,
		101,
		106,
		114,
		98,
		112,
		115,
		128,
		142,
		146,
		194,
		-1,
		171,
		-1,
		-1,
		-1,
		98,
		113,
		105,
		82,
		55,
		60,
		70,
		65,
		70,
		90,
		96,
		107,
		92,
		96,
		111,
		121,
		120,
		137,
		147,
		-1,
		-1,
		169,
		159,
		124,
		106,
		110,
		132,
		-1,
		-1,
		70,
		76,
		69,
		72,
		80,
		83,
		88,
		90,
		108,
		127,
		115,
		130,
		145,
		141,
		-1,
		-1,
		-1,
		185,
		-1,
		157,
		-1,
		-1,
		125,
		156,
		103,
		85,
		81,
		79,
		74,
		83,
		78,
		83,
		108,
		103,
		112,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		145,
		152,
		118,
		115,
		-1,
		85,
		112,
		84,
		91,
		83,
		96,
		101,
		107,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		134,
		131,
		109,
		93,
		97,
		90,
		85,
		123,
		99,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		204,
		256,
		249,
		217,
		225,
		256,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		107,
		104,
		109,
		100,
		97,
		109,
		108,
		119,
		121,
		126,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		212,
		232,
		211,
		214,
		238,
		252,
		-1,
		154,
		-1,
		-1,
		166,
		138,
		122,
		112,
		106,
		156,
		114,
		109,
		111,
		113,
		117,
		108,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		201,
		212,
		205,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		149,
		-1,
		124,
		128,
		122,
		125,
		136,
		123,
		121,
		129,
		137,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		166,
		205,
		220,
		-1,
		191,
		-1,
		-1,
		-1,
		138,
		135,
		127,
		143,
		135,
		135,
		115,
		119,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		181,
		172,
		199,
		225,
		216,
		211,
		198,
		-1,
		-1,
		161,
		145,
		-1,
		-1,
		142,
		136,
		119,
		121,
		125,
		135,
		150,
		153,
		143,
		141,
		135,
		167,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		200,
		195,
		199,
		215,
		240,
		-1,
		201,
		-1,
		-1,
		182,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		133,
		144,
		161,
		149,
		150,
		140,
		150,
		163,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		199,
		229,
		-1,
		-1,
		217,
		199,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		156,
		163,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		205,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		148,
		148,
		151,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		242,
		-1,
		194,
		170,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		182,
		185,
		-1,
		-1,
		207,
		218,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		189,
		190,
		195,
		-1,
		201,
		-1,
		219,
		-1,
		186,
		192,
		180,
		-1,
		-1,
		-1,
		179,
		142,
		159,
		173,
		178,
		176,
		167,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		219,
		193,
		226,
		217,
		200,
		180,
		172,
		191,
		-1,
		161,
		-1,
		136,
		139,
		164,
		172,
		189,
		183,
		161,
		176,
		166,
		157,
		166,
		225,
		-1,
		195,
		228,
		192,
		186,
		162,
		166,
		182,
		-1,
		158,
		140,
		-1,
		168,
		158,
		206,
		181,
		176,
		163,
		170,
		170,
		163,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		182,
		167,
		158,
		-1,
		170,
		152,
		131,
		148,
		148,
		139,
		147,
		196,
		192,
		183,
		183,
		171,
		-1,
		298,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		186,
		159,
		147,
		153,
		149,
		135,
		141,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		170,
		202,
		-1,
		293,
		-1,
		227,
		-1,
		-1,
		209,
		189,
		181,
		170,
		159,
		157,
		148,
		139,
		161,
		177,
		161,
		159,
		164,
		169,
		-1,
		282,
		281,
		-1,
		228,
		220,
		206,
		-1,
		199,
		-1,
		205,
		166,
		-1,
		168,
		148,
		-1,
		170,
		166,
		-1,
		-1,
		269,
		244,
		-1,
		-1,
		-1,
		229,
		209,
		200,
		184,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		254,
		253,
		-1,
		222,
		225,
		-1,
		215,
		206,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		263,
		244,
		238,
		237,
		235,
		230,
		227,
		213,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		235,
		227,
		220,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		246,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		292,
		256,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		209,
		211,
		177,
		171,
		210,
		181,
		187,
		198,
		-1,
		-1,
		-1,
		200,
		199,
		169,
		167,
		176,
		181,
		188,
		-1,
		192,
		-1,
		221,
		200,
		211,
		216,
		162,
		159,
		179,
		198,
		185,
		177,
		236,
		192,
		163,
		157,
		175,
		170,
		179,
		171,
		-1,
		163,
		153,
		175,
		159,
		170,
		162,
		-1,
		-1,
		157,
		158,
		164,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		147,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		136,
		154,
		163,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		149,
		-1,
		145,
		146,
		141,
		149,
		154,
		138,
		125,
		125,
		135,
		128,
		147,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		145,
		128,
		145,
		137,
		127,
		142,
		135,
		128,
		125,
		123,
		120,
		136,
		137,
		147,
		-1,
		-1,
		224,
		193,
		228,
		185,
		170,
		-1,
		141,
		121,
		127,
		131,
		125,
		118,
		132,
		128,
		-1,
		114,
		113,
		144,
		130,
		141,
		184,
		-1,
		-1,
		182,
		174,
		159,
		162,
		151,
		147,
		136,
		135,
		127,
		113,
		109,
		115,
		118,
		118,
		124,
		108,
		118,
		122,
		132,
		148,
		-1,
		-1,
		194,
		-1,
		-1,
		181,
		164,
		-1,
		147,
		154,
		154,
		163,
		149,
		170,
		146,
		137,
		129,
		123,
		111,
		113,
		110,
		123,
		111,
		105,
		130,
		134,
		127,
		148,
		143,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		140,
		143,
		149,
		173,
		183,
		-1,
		158,
		146,
		147,
		132,
		129,
		116,
		104,
		117,
		102,
		109,
		108,
		112,
		114,
		147,
		124,
		146,
		143,
		164,
		169,
		163,
		172,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		177,
		-1,
		191,
		190,
		165,
		143,
		146,
		133,
		124,
		111,
		100,
		111,
		100,
		97,
		105,
		113,
		125,
		119,
		118,
		136,
		148,
		156,
		160,
		166,
		-1,
		239,
		-1,
		181,
		165,
		167,
		139,
		160,
		-1,
		197,
		192,
		182,
		167,
		158,
		-1,
		142,
		139,
		129,
		107,
		92,
		109,
		101,
		99,
		104,
		108,
		122,
		113,
		131,
		138,
		138,
		142,
		162,
		174,
		199,
		189,
		-1,
		171,
		176,
		135,
		143,
		162,
		200,
		164,
		-1,
		159,
		-1,
		144,
		157,
		-1,
		113,
		109,
		91,
		92,
		87,
		102,
		107,
		104,
		101,
		119,
		122,
		131,
		135,
		151,
		-1,
		-1,
		184,
		188,
		177,
		128,
		147,
		171,
		208,
		157,
		146,
		145,
		-1,
		136,
		127,
		124,
		112,
		99,
		84,
		85,
		93,
		105,
		84,
		103,
		102,
		122,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		154,
		125,
		149,
		191,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		123,
		102,
		93,
		82,
		80,
		93,
		85,
		103,
		100,
		98,
		117,
		129,
		120,
		133,
		-1,
		-1,
		-1,
		184,
		173,
		174,
		120,
		143,
		180,
		154,
		140,
		145,
		120,
		113,
		107,
		133,
		119,
		97,
		89,
		81,
		70,
		81,
		89,
		93,
		96,
		105,
		111,
		135,
		121,
		127,
		-1,
		-1,
		191,
		181,
		165,
		167,
		164,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		92,
		90,
		83,
		86,
		67,
		72,
		86,
		95,
		103,
		98,
		105,
		140,
		140,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		184,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		95,
		87,
		88,
		71,
		71,
		72,
		86,
		70,
		89,
		91,
		90,
		116,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		69,
		61,
		55,
		64,
		57,
		64,
		77,
		82,
		95,
		91,
		104,
		108,
		112,
		101,
		97,
		94,
		108,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		86,
		84,
		83,
		67,
		70,
		65,
		62,
		68,
		71,
		74,
		90,
		81,
		99,
		107,
		99,
		93,
		92,
		104,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		96,
		81,
		74,
		75,
		45,
		50,
		58,
		61,
		64,
		78,
		89,
		81,
		103,
		103,
		87,
		88,
		97,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		95,
		93,
		64,
		39,
		46,
		69,
		58,
		53,
		76,
		73,
		73,
		75,
		97,
		83,
		81,
		100,
		116,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		36,
		32,
		41,
		-1,
		78,
		-1,
		50,
		63,
		63,
		65,
		69,
		80,
		78,
		89,
		106,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		52,
		32,
		22,
		41,
		61,
		48,
		47,
		53,
		58,
		62,
		72,
		85,
		105,
		96,
		108,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		50,
		38,
		28,
		18,
		48,
		49,
		39,
		44,
		53,
		65,
		70,
		81,
		86,
		107,
		107,
		121,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		137,
		116,
		39,
		-1,
		-1,
		0,
		24,
		34,
		40,
		55,
		69,
		76,
		91,
		80,
		95,
		107,
		115,
		119,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		149,
		94,
		83,
		78,
		82,
		24,
		-1,
		34,
		35,
		53,
		65,
		72,
		93,
		87,
		81,
		90,
		107,
		124,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		106,
		100,
		71,
		64,
		68,
		-1,
		43,
		43,
		55,
		66,
		78,
		83,
		91,
		75,
		89,
		92,
		105,
		119,
		123,
		179,
		-1,
		162,
		-1,
		-1,
		-1,
		124,
		139,
		110,
		87,
		60,
		55,
		48,
		42,
		47,
		67,
		73,
		84,
		69,
		73,
		88,
		98,
		97,
		114,
		124,
		-1,
		-1,
		162,
		158,
		150,
		132,
		136,
		137,
		-1,
		-1,
		64,
		55,
		46,
		49,
		57,
		60,
		65,
		67,
		85,
		104,
		92,
		107,
		122,
		118,
		-1,
		-1,
		-1,
		174,
		-1,
		176,
		-1,
		-1,
		151,
		135,
		82,
		64,
		60,
		58,
		51,
		60,
		55,
		60,
		85,
		80,
		89,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		153,
		145,
		140,
		146,
		148,
		139,
		97,
		94,
		-1,
		64,
		89,
		61,
		68,
		60,
		73,
		78,
		84,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		146,
		142,
		132,
		122,
		125,
		-1,
		-1,
		113,
		110,
		86,
		70,
		74,
		67,
		62,
		100,
		76,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		189,
		235,
		228,
		196,
		204,
		235,
		-1,
		136,
		128,
		139,
		114,
		116,
		-1,
		-1,
		86,
		83,
		88,
		77,
		74,
		86,
		85,
		96,
		98,
		103,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		191,
		211,
		190,
		193,
		217,
		231,
		-1,
		133,
		-1,
		-1,
		145,
		117,
		101,
		91,
		85,
		135,
		91,
		86,
		88,
		90,
		94,
		85,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		161,
		-1,
		128,
		-1,
		103,
		107,
		99,
		102,
		113,
		100,
		98,
		106,
		114,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		145,
		184,
		199,
		-1,
		170,
		-1,
		-1,
		-1,
		117,
		112,
		104,
		120,
		112,
		112,
		92,
		96,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		160,
		151,
		178,
		204,
		195,
		190,
		177,
		-1,
		-1,
		140,
		122,
		-1,
		-1,
		119,
		113,
		96,
		98,
		102,
		112,
		127,
		130,
		120,
		118,
		112,
		144,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		163,
		179,
		174,
		178,
		194,
		219,
		-1,
		180,
		-1,
		-1,
		161,
		-1,
		-1,
		155,
		118,
		107,
		98,
		104,
		110,
		121,
		138,
		126,
		127,
		117,
		127,
		140,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		150,
		148,
		154,
		161,
		178,
		208,
		-1,
		-1,
		196,
		176,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		108,
		133,
		140,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		186,
		182,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		125,
		125,
		128,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		221,
		-1,
		173,
		149,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		203,
		189,
		182,
		170,
		168,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		161,
		129,
		134,
		129,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		161,
		164,
		-1,
		-1,
		186,
		195,
		-1,
		194,
		183,
		168,
		160,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		143,
		132,
		140,
		135,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		168,
		169,
		174,
		-1,
		178,
		-1,
		196,
		-1,
		163,
		169,
		157,
		-1,
		-1,
		-1,
		156,
		119,
		136,
		150,
		155,
		153,
		144,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		196,
		170,
		203,
		194,
		177,
		157,
		149,
		168,
		-1,
		138,
		-1,
		113,
		116,
		141,
		149,
		166,
		160,
		138,
		153,
		143,
		134,
		143,
		202,
		-1,
		172,
		205,
		169,
		163,
		139,
		143,
		159,
		-1,
		135,
		117,
		-1,
		145,
		135,
		183,
		158,
		153,
		140,
		147,
		147,
		140,
		-1,
		-1,
		-1,
		174,
		173,
		165,
		159,
		159,
		144,
		135,
		-1,
		147,
		129,
		108,
		125,
		125,
		116,
		124,
		173,
		169,
		160,
		160,
		148,
		-1,
		275,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		168,
		163,
		136,
		124,
		130,
		126,
		112,
		118,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		147,
		179,
		-1,
		270,
		-1,
		204,
		-1,
		-1,
		186,
		166,
		158,
		147,
		136,
		134,
		125,
		116,
		138,
		154,
		138,
		136,
		141,
		146,
		-1,
		259,
		258,
		-1,
		205,
		197,
		183,
		-1,
		176,
		-1,
		182,
		143,
		-1,
		145,
		125,
		-1,
		147,
		143,
		-1,
		-1,
		246,
		221,
		-1,
		-1,
		-1,
		206,
		186,
		177,
		161,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		231,
		230,
		-1,
		199,
		202,
		-1,
		192,
		183,
		191,
		138,
		142,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		214,
		212,
		207,
		204,
		190,
		174,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		212,
		204,
		197,
		-1,
		-1,
		199,
		182,
		163,
		161,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		189,
		-1,
		-1,
		195,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		223,
		-1,
		-1,
		-1,
		185,
		181,
		182,
		-1,
		-1,
		-1,
		-1,
		245,
		246,
		269,
		233,
		-1,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		248,
		246,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		175,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		210,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		223,
		215,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		200,
		207,
		229,
		232,
		268,
		-1,
		219
	],
	[
		-1,
		202,
		191,
		202,
		210,
		183,
		190,
		-1,
		211,
		213,
		179,
		173,
		212,
		183,
		189,
		200,
		-1,
		-1,
		-1,
		202,
		201,
		171,
		169,
		178,
		183,
		190,
		-1,
		194,
		-1,
		223,
		202,
		213,
		218,
		164,
		161,
		181,
		200,
		187,
		179,
		238,
		194,
		165,
		159,
		177,
		172,
		181,
		173,
		-1,
		165,
		155,
		177,
		161,
		172,
		164,
		-1,
		-1,
		159,
		160,
		166,
		157,
		163,
		159,
		-1,
		169,
		153,
		-1,
		-1,
		149,
		155,
		139,
		142,
		150,
		148,
		161,
		153,
		148,
		-1,
		-1,
		145,
		141,
		148,
		135,
		131,
		148,
		161,
		143,
		157,
		156,
		-1,
		138,
		156,
		165,
		142,
		140,
		124,
		122,
		140,
		142,
		148,
		149,
		-1,
		147,
		148,
		143,
		151,
		156,
		140,
		127,
		127,
		137,
		130,
		149,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		130,
		127,
		125,
		122,
		138,
		137,
		147,
		-1,
		-1,
		226,
		195,
		230,
		187,
		172,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		116,
		115,
		144,
		130,
		141,
		186,
		-1,
		-1,
		184,
		176,
		161,
		164,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		110,
		120,
		124,
		123,
		148,
		-1,
		-1,
		183,
		-1,
		-1,
		183,
		166,
		-1,
		149,
		156,
		156,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		107,
		132,
		136,
		118,
		139,
		134,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		142,
		145,
		151,
		175,
		185,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		112,
		110,
		140,
		115,
		137,
		134,
		153,
		158,
		152,
		161,
		-1,
		191,
		187,
		183,
		190,
		139,
		-1,
		-1,
		179,
		-1,
		193,
		192,
		167,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		104,
		119,
		110,
		109,
		127,
		137,
		145,
		149,
		155,
		-1,
		241,
		-1,
		183,
		167,
		169,
		141,
		162,
		-1,
		199,
		194,
		184,
		169,
		160,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		106,
		99,
		113,
		104,
		122,
		129,
		127,
		131,
		151,
		163,
		201,
		191,
		-1,
		173,
		178,
		137,
		145,
		164,
		202,
		166,
		-1,
		161,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		109,
		95,
		92,
		110,
		113,
		120,
		124,
		140,
		-1,
		-1,
		186,
		190,
		179,
		130,
		149,
		173,
		210,
		159,
		148,
		147,
		-1,
		138,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		107,
		86,
		94,
		91,
		111,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		156,
		127,
		151,
		193,
		177,
		170,
		158,
		123,
		123,
		117,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		87,
		105,
		89,
		87,
		106,
		118,
		109,
		121,
		-1,
		-1,
		-1,
		186,
		175,
		176,
		122,
		145,
		182,
		156,
		142,
		147,
		122,
		115,
		109,
		135,
		121,
		99,
		91,
		83,
		72,
		83,
		91,
		95,
		85,
		94,
		100,
		124,
		109,
		115,
		-1,
		-1,
		193,
		183,
		167,
		169,
		166,
		136,
		143,
		175,
		147,
		160,
		-1,
		114,
		-1,
		103,
		94,
		92,
		85,
		88,
		69,
		74,
		88,
		97,
		92,
		87,
		94,
		129,
		129,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		186,
		181,
		156,
		133,
		117,
		153,
		-1,
		130,
		131,
		-1,
		108,
		102,
		97,
		89,
		90,
		73,
		73,
		74,
		88,
		72,
		91,
		92,
		79,
		104,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		179,
		158,
		151,
		171,
		112,
		164,
		-1,
		-1,
		115,
		108,
		-1,
		95,
		77,
		71,
		63,
		57,
		66,
		59,
		66,
		79,
		84,
		84,
		79,
		92,
		96,
		100,
		89,
		85,
		82,
		96,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		132,
		-1,
		124,
		116,
		106,
		100,
		94,
		88,
		86,
		85,
		69,
		72,
		67,
		64,
		61,
		73,
		66,
		82,
		69,
		87,
		95,
		87,
		81,
		80,
		92,
		-1,
		199,
		185,
		156,
		-1,
		-1,
		145,
		-1,
		109,
		123,
		139,
		-1,
		132,
		111,
		126,
		104,
		98,
		83,
		76,
		77,
		47,
		52,
		60,
		49,
		52,
		66,
		77,
		69,
		91,
		91,
		75,
		76,
		85,
		-1,
		205,
		192,
		150,
		146,
		135,
		155,
		106,
		94,
		126,
		-1,
		-1,
		168,
		-1,
		102,
		119,
		97,
		95,
		66,
		41,
		48,
		71,
		46,
		41,
		64,
		61,
		61,
		63,
		85,
		71,
		69,
		88,
		104,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		121,
		108,
		102,
		-1,
		143,
		-1,
		146,
		136,
		120,
		105,
		138,
		-1,
		38,
		34,
		43,
		-1,
		66,
		-1,
		38,
		51,
		51,
		53,
		57,
		68,
		66,
		77,
		94,
		-1,
		155,
		140,
		133,
		123,
		137,
		108,
		-1,
		163,
		-1,
		-1,
		133,
		127,
		127,
		111,
		111,
		54,
		34,
		24,
		43,
		49,
		36,
		35,
		41,
		46,
		50,
		60,
		73,
		93,
		84,
		96,
		-1,
		-1,
		-1,
		160,
		146,
		150,
		110,
		129,
		-1,
		-1,
		195,
		150,
		136,
		-1,
		106,
		52,
		40,
		30,
		20,
		28,
		37,
		27,
		32,
		41,
		53,
		58,
		69,
		74,
		95,
		95,
		109,
		-1,
		-1,
		143,
		148,
		136,
		122,
		141,
		-1,
		-1,
		-1,
		142,
		158,
		125,
		104,
		41,
		-1,
		-1,
		22,
		0,
		19,
		24,
		39,
		53,
		60,
		79,
		68,
		83,
		95,
		103,
		107,
		-1,
		146,
		133,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		-1,
		-1,
		137,
		82,
		71,
		66,
		70,
		23,
		-1,
		22,
		19,
		37,
		49,
		56,
		81,
		75,
		69,
		78,
		95,
		112,
		-1,
		-1,
		158,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		94,
		88,
		59,
		52,
		56,
		-1,
		31,
		27,
		41,
		50,
		66,
		71,
		79,
		63,
		77,
		80,
		93,
		107,
		111,
		181,
		-1,
		152,
		-1,
		-1,
		-1,
		112,
		127,
		98,
		75,
		48,
		43,
		36,
		30,
		35,
		55,
		61,
		72,
		57,
		61,
		76,
		86,
		85,
		102,
		112,
		-1,
		-1,
		150,
		146,
		138,
		120,
		124,
		125,
		-1,
		-1,
		52,
		43,
		34,
		37,
		45,
		48,
		53,
		55,
		73,
		92,
		80,
		95,
		110,
		106,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		139,
		123,
		70,
		52,
		48,
		46,
		39,
		48,
		43,
		48,
		73,
		68,
		77,
		82,
		86,
		109,
		98,
		137,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		141,
		133,
		128,
		134,
		136,
		127,
		85,
		82,
		-1,
		52,
		77,
		49,
		56,
		48,
		61,
		66,
		72,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		134,
		130,
		120,
		110,
		113,
		-1,
		-1,
		101,
		98,
		74,
		58,
		62,
		55,
		50,
		88,
		64,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		186,
		223,
		216,
		184,
		192,
		223,
		-1,
		124,
		116,
		127,
		102,
		104,
		-1,
		-1,
		74,
		71,
		76,
		65,
		62,
		74,
		73,
		84,
		86,
		91,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		121,
		-1,
		-1,
		133,
		105,
		89,
		79,
		73,
		123,
		79,
		74,
		76,
		78,
		82,
		73,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		116,
		-1,
		91,
		95,
		87,
		90,
		101,
		88,
		86,
		94,
		102,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		133,
		172,
		187,
		-1,
		158,
		-1,
		-1,
		-1,
		105,
		100,
		92,
		108,
		100,
		100,
		80,
		84,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		148,
		139,
		166,
		192,
		183,
		178,
		165,
		-1,
		-1,
		128,
		110,
		-1,
		-1,
		107,
		101,
		84,
		86,
		90,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		151,
		167,
		162,
		166,
		182,
		207,
		-1,
		168,
		-1,
		-1,
		149,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		98,
		109,
		126,
		114,
		115,
		105,
		115,
		128,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		138,
		136,
		142,
		149,
		166,
		196,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		121,
		128,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		113,
		113,
		116,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		209,
		-1,
		161,
		137,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		149,
		152,
		-1,
		-1,
		174,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		156,
		157,
		162,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		144,
		107,
		124,
		138,
		143,
		141,
		132,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		104,
		129,
		137,
		154,
		148,
		126,
		141,
		131,
		122,
		131,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		133,
		123,
		171,
		146,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		113,
		104,
		112,
		161,
		157,
		148,
		148,
		136,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		135,
		167,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		126,
		124,
		129,
		134,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		135,
		131,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		145,
		163,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		154,
		155,
		150,
		158,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		154,
		137,
		154,
		146,
		136,
		151,
		144,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		233,
		202,
		237,
		194,
		179,
		-1,
		150,
		130,
		136,
		140,
		134,
		127,
		141,
		137,
		-1,
		113,
		112,
		140,
		126,
		137,
		193,
		-1,
		-1,
		191,
		183,
		168,
		171,
		160,
		156,
		145,
		144,
		136,
		122,
		118,
		124,
		127,
		127,
		133,
		107,
		117,
		121,
		119,
		144,
		-1,
		-1,
		179,
		-1,
		-1,
		190,
		173,
		-1,
		156,
		163,
		163,
		172,
		158,
		179,
		155,
		146,
		138,
		132,
		120,
		122,
		119,
		132,
		120,
		104,
		129,
		133,
		114,
		135,
		130,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		149,
		152,
		158,
		182,
		192,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		108,
		106,
		136,
		111,
		133,
		130,
		149,
		154,
		148,
		157,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		186,
		-1,
		200,
		199,
		174,
		152,
		155,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		100,
		115,
		106,
		105,
		123,
		133,
		141,
		145,
		151,
		-1,
		248,
		-1,
		190,
		174,
		176,
		148,
		169,
		-1,
		206,
		201,
		191,
		176,
		167,
		-1,
		151,
		148,
		138,
		116,
		101,
		118,
		110,
		108,
		113,
		95,
		109,
		100,
		118,
		125,
		123,
		127,
		147,
		159,
		208,
		198,
		-1,
		180,
		185,
		144,
		152,
		171,
		209,
		173,
		-1,
		168,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		106,
		91,
		88,
		106,
		109,
		116,
		120,
		136,
		-1,
		-1,
		193,
		197,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		136,
		133,
		121,
		108,
		93,
		94,
		102,
		114,
		93,
		90,
		87,
		107,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		132,
		111,
		102,
		91,
		89,
		102,
		94,
		105,
		85,
		83,
		102,
		114,
		105,
		117,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		142,
		128,
		106,
		98,
		90,
		79,
		90,
		98,
		99,
		81,
		90,
		96,
		120,
		105,
		111,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		101,
		99,
		92,
		95,
		76,
		81,
		95,
		98,
		88,
		83,
		90,
		125,
		125,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		104,
		96,
		97,
		80,
		80,
		81,
		95,
		79,
		92,
		88,
		75,
		100,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		78,
		70,
		64,
		73,
		66,
		73,
		86,
		80,
		80,
		75,
		88,
		92,
		96,
		85,
		81,
		78,
		92,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		95,
		93,
		92,
		76,
		79,
		74,
		71,
		57,
		69,
		62,
		78,
		65,
		83,
		91,
		83,
		77,
		76,
		88,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		105,
		90,
		83,
		84,
		54,
		59,
		57,
		45,
		48,
		62,
		73,
		65,
		87,
		87,
		71,
		72,
		81,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		104,
		102,
		73,
		48,
		55,
		69,
		42,
		37,
		60,
		57,
		57,
		59,
		81,
		67,
		65,
		84,
		100,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		47,
		43,
		50,
		-1,
		62,
		-1,
		34,
		47,
		47,
		49,
		53,
		64,
		62,
		73,
		90,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		114,
		111,
		63,
		43,
		35,
		50,
		45,
		32,
		31,
		37,
		42,
		46,
		56,
		69,
		89,
		80,
		92,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		106,
		63,
		51,
		41,
		31,
		32,
		33,
		23,
		28,
		37,
		49,
		54,
		65,
		70,
		91,
		92,
		105,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		159,
		125,
		104,
		52,
		-1,
		-1,
		35,
		24,
		0,
		24,
		39,
		53,
		60,
		75,
		64,
		79,
		91,
		99,
		104,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		137,
		82,
		71,
		66,
		70,
		34,
		-1,
		22,
		19,
		37,
		49,
		56,
		77,
		72,
		66,
		74,
		92,
		109,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		94,
		88,
		59,
		52,
		56,
		-1,
		31,
		27,
		41,
		50,
		66,
		71,
		78,
		63,
		75,
		77,
		90,
		104,
		108,
		188,
		-1,
		152,
		-1,
		-1,
		-1,
		112,
		127,
		98,
		75,
		48,
		43,
		36,
		30,
		35,
		55,
		61,
		72,
		57,
		61,
		74,
		83,
		82,
		99,
		109,
		-1,
		-1,
		150,
		146,
		138,
		120,
		124,
		125,
		-1,
		-1,
		52,
		43,
		34,
		37,
		45,
		48,
		53,
		55,
		73,
		90,
		78,
		92,
		108,
		106,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		139,
		123,
		70,
		52,
		48,
		46,
		39,
		48,
		43,
		48,
		73,
		68,
		77,
		80,
		86,
		109,
		98,
		137,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		141,
		133,
		128,
		134,
		136,
		127,
		85,
		82,
		-1,
		52,
		77,
		49,
		56,
		48,
		61,
		66,
		72,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		134,
		130,
		120,
		110,
		113,
		-1,
		-1,
		101,
		98,
		74,
		58,
		62,
		55,
		50,
		88,
		64,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		186,
		223,
		216,
		184,
		192,
		223,
		-1,
		124,
		116,
		127,
		102,
		104,
		-1,
		-1,
		74,
		71,
		76,
		65,
		62,
		74,
		73,
		84,
		86,
		91,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		121,
		-1,
		-1,
		133,
		105,
		89,
		79,
		73,
		123,
		79,
		74,
		76,
		78,
		82,
		73,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		116,
		-1,
		91,
		95,
		87,
		90,
		101,
		88,
		86,
		94,
		102,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		133,
		172,
		187,
		-1,
		158,
		-1,
		-1,
		-1,
		105,
		100,
		92,
		108,
		100,
		100,
		80,
		84,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		148,
		139,
		166,
		192,
		183,
		178,
		165,
		-1,
		-1,
		128,
		110,
		-1,
		-1,
		107,
		101,
		84,
		86,
		90,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		151,
		167,
		162,
		166,
		182,
		207,
		-1,
		168,
		-1,
		-1,
		149,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		98,
		109,
		126,
		114,
		115,
		105,
		115,
		128,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		138,
		136,
		142,
		149,
		166,
		196,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		121,
		128,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		113,
		113,
		116,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		209,
		-1,
		161,
		137,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		149,
		152,
		-1,
		-1,
		174,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		156,
		157,
		162,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		144,
		107,
		124,
		138,
		143,
		141,
		132,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		104,
		129,
		137,
		154,
		148,
		126,
		141,
		131,
		122,
		131,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		133,
		123,
		171,
		146,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		113,
		104,
		112,
		161,
		157,
		148,
		148,
		136,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		135,
		167,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		126,
		124,
		129,
		134,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		135,
		131,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		128,
		146,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		127,
		-1,
		137,
		138,
		133,
		141,
		143,
		119,
		106,
		106,
		116,
		109,
		128,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		120,
		137,
		129,
		119,
		134,
		127,
		109,
		106,
		104,
		101,
		117,
		115,
		125,
		-1,
		-1,
		230,
		199,
		228,
		186,
		167,
		-1,
		133,
		113,
		119,
		123,
		117,
		110,
		124,
		120,
		-1,
		95,
		94,
		122,
		108,
		119,
		190,
		-1,
		-1,
		188,
		180,
		163,
		166,
		143,
		139,
		128,
		127,
		119,
		105,
		101,
		107,
		110,
		110,
		116,
		89,
		99,
		103,
		101,
		126,
		-1,
		-1,
		161,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		149,
		155,
		141,
		162,
		138,
		129,
		121,
		115,
		103,
		105,
		102,
		115,
		103,
		86,
		111,
		115,
		96,
		117,
		112,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		178,
		-1,
		150,
		138,
		139,
		124,
		121,
		108,
		96,
		109,
		94,
		101,
		100,
		90,
		88,
		118,
		93,
		115,
		112,
		131,
		136,
		130,
		139,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		186,
		187,
		162,
		135,
		138,
		125,
		116,
		103,
		92,
		103,
		92,
		89,
		97,
		82,
		97,
		88,
		87,
		105,
		115,
		123,
		127,
		133,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		187,
		179,
		164,
		164,
		-1,
		134,
		131,
		121,
		99,
		84,
		101,
		93,
		91,
		95,
		77,
		91,
		82,
		100,
		107,
		105,
		109,
		129,
		141,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		136,
		149,
		-1,
		105,
		101,
		83,
		84,
		79,
		94,
		88,
		73,
		70,
		88,
		91,
		98,
		102,
		118,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		119,
		116,
		104,
		91,
		76,
		77,
		85,
		97,
		76,
		72,
		69,
		89,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		72,
		85,
		77,
		87,
		67,
		65,
		84,
		96,
		87,
		99,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		128,
		111,
		92,
		81,
		73,
		62,
		73,
		81,
		81,
		63,
		72,
		78,
		102,
		87,
		93,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		68,
		64,
		78,
		80,
		70,
		65,
		72,
		107,
		107,
		77,
		97,
		100,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		72,
		76,
		76,
		78,
		69,
		74,
		75,
		57,
		82,
		-1,
		85,
		79,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		84,
		77,
		71,
		77,
		73,
		63,
		76,
		69,
		62,
		57,
		70,
		74,
		78,
		67,
		63,
		60,
		74,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		99,
		83,
		86,
		81,
		77,
		62,
		58,
		51,
		62,
		47,
		65,
		73,
		65,
		59,
		58,
		70,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		96,
		90,
		91,
		61,
		66,
		62,
		50,
		53,
		52,
		55,
		47,
		69,
		69,
		53,
		54,
		63,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		110,
		108,
		80,
		55,
		62,
		74,
		47,
		42,
		57,
		46,
		39,
		41,
		63,
		49,
		47,
		66,
		82,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		54,
		50,
		57,
		-1,
		67,
		-1,
		39,
		43,
		34,
		31,
		35,
		46,
		44,
		55,
		72,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		117,
		70,
		50,
		42,
		57,
		50,
		33,
		36,
		25,
		25,
		28,
		38,
		51,
		71,
		62,
		74,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		112,
		70,
		58,
		48,
		38,
		39,
		44,
		24,
		17,
		23,
		32,
		36,
		47,
		52,
		73,
		74,
		87,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		131,
		110,
		59,
		-1,
		-1,
		42,
		31,
		26,
		0,
		15,
		29,
		36,
		55,
		46,
		61,
		73,
		81,
		86,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		143,
		88,
		77,
		72,
		76,
		41,
		-1,
		29,
		11,
		13,
		25,
		32,
		57,
		54,
		48,
		56,
		74,
		91,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		65,
		58,
		62,
		-1,
		38,
		19,
		17,
		34,
		51,
		48,
		56,
		52,
		57,
		59,
		72,
		86,
		90,
		185,
		-1,
		151,
		-1,
		-1,
		-1,
		118,
		133,
		104,
		81,
		54,
		48,
		41,
		36,
		25,
		41,
		50,
		61,
		58,
		55,
		56,
		65,
		64,
		81,
		91,
		-1,
		-1,
		149,
		145,
		144,
		126,
		130,
		131,
		-1,
		-1,
		56,
		49,
		38,
		39,
		35,
		38,
		54,
		56,
		67,
		72,
		60,
		74,
		90,
		96,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		145,
		129,
		76,
		58,
		54,
		52,
		41,
		50,
		44,
		49,
		74,
		71,
		80,
		62,
		80,
		100,
		92,
		128,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		132,
		133,
		124,
		91,
		88,
		-1,
		58,
		77,
		50,
		57,
		49,
		64,
		69,
		75,
		67,
		77,
		93,
		92,
		87,
		120,
		114,
		120,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		133,
		129,
		118,
		108,
		110,
		-1,
		-1,
		98,
		95,
		74,
		59,
		65,
		58,
		53,
		91,
		67,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		123,
		115,
		126,
		101,
		101,
		-1,
		-1,
		71,
		70,
		75,
		66,
		63,
		76,
		75,
		87,
		80,
		86,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		120,
		-1,
		-1,
		132,
		102,
		86,
		78,
		70,
		122,
		80,
		75,
		77,
		79,
		85,
		76,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		113,
		-1,
		88,
		92,
		88,
		91,
		102,
		89,
		89,
		88,
		104,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		132,
		171,
		186,
		-1,
		157,
		-1,
		-1,
		-1,
		102,
		101,
		93,
		109,
		101,
		101,
		83,
		87,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		147,
		138,
		165,
		191,
		182,
		177,
		164,
		-1,
		-1,
		125,
		111,
		-1,
		-1,
		108,
		104,
		87,
		89,
		91,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		150,
		166,
		161,
		165,
		181,
		206,
		-1,
		167,
		-1,
		-1,
		146,
		-1,
		-1,
		146,
		109,
		98,
		89,
		95,
		99,
		110,
		120,
		108,
		109,
		99,
		109,
		122,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		137,
		135,
		141,
		148,
		165,
		195,
		-1,
		-1,
		183,
		167,
		-1,
		-1,
		144,
		142,
		131,
		-1,
		121,
		94,
		99,
		124,
		128,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		177,
		173,
		-1,
		-1,
		139,
		132,
		120,
		108,
		98,
		108,
		116,
		116,
		115,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		208,
		-1,
		160,
		136,
		150,
		165,
		173,
		-1,
		-1,
		-1,
		194,
		180,
		173,
		161,
		159,
		-1,
		173,
		157,
		138,
		-1,
		108,
		121,
		152,
		120,
		125,
		120,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		148,
		151,
		-1,
		-1,
		173,
		186,
		-1,
		185,
		174,
		159,
		151,
		-1,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		134,
		123,
		131,
		126,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		155,
		156,
		161,
		-1,
		169,
		-1,
		187,
		-1,
		154,
		160,
		148,
		-1,
		-1,
		-1,
		147,
		110,
		127,
		141,
		142,
		140,
		131,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		187,
		161,
		194,
		185,
		168,
		148,
		140,
		159,
		-1,
		129,
		-1,
		104,
		107,
		132,
		140,
		153,
		147,
		120,
		135,
		125,
		116,
		125,
		193,
		-1,
		163,
		196,
		160,
		154,
		130,
		134,
		150,
		-1,
		126,
		108,
		-1,
		136,
		126,
		169,
		149,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		165,
		164,
		156,
		150,
		150,
		135,
		126,
		-1,
		138,
		120,
		99,
		116,
		116,
		107,
		115,
		159,
		155,
		142,
		142,
		134,
		-1,
		266,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		159,
		154,
		127,
		115,
		121,
		117,
		103,
		109,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		135,
		170,
		-1,
		261,
		-1,
		195,
		-1,
		-1,
		177,
		157,
		149,
		138,
		127,
		125,
		116,
		107,
		129,
		145,
		129,
		127,
		132,
		137,
		-1,
		250,
		249,
		-1,
		196,
		188,
		174,
		-1,
		167,
		-1,
		173,
		134,
		-1,
		136,
		116,
		-1,
		138,
		134,
		-1,
		-1,
		237,
		212,
		-1,
		-1,
		-1,
		197,
		177,
		168,
		152,
		-1,
		127,
		127,
		-1,
		-1,
		-1,
		222,
		221,
		-1,
		190,
		193,
		-1,
		183,
		174,
		182,
		129,
		133,
		-1,
		-1,
		-1,
		231,
		212,
		206,
		205,
		203,
		198,
		195,
		181,
		165,
		143,
		132,
		153,
		-1,
		-1,
		-1,
		203,
		195,
		188,
		-1,
		-1,
		190,
		173,
		154,
		152,
		-1,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		180,
		-1,
		-1,
		186,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		214,
		-1,
		-1,
		-1,
		176,
		172,
		173,
		-1,
		-1,
		-1,
		-1,
		236,
		237,
		260,
		224,
		-1,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		239,
		237,
		-1,
		-1,
		-1,
		196,
		180,
		-1,
		166,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		201,
		-1,
		201,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		214,
		206,
		214,
		-1,
		186,
		188,
		-1,
		236,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		191,
		198,
		220,
		223,
		259,
		-1,
		210
	],
	[
		-1,
		173,
		162,
		173,
		181,
		154,
		161,
		-1,
		180,
		184,
		150,
		144,
		183,
		152,
		158,
		169,
		-1,
		-1,
		-1,
		173,
		172,
		140,
		138,
		147,
		152,
		159,
		-1,
		158,
		-1,
		194,
		173,
		184,
		189,
		133,
		130,
		150,
		169,
		151,
		143,
		209,
		163,
		134,
		128,
		146,
		136,
		145,
		137,
		-1,
		134,
		124,
		146,
		125,
		136,
		128,
		-1,
		-1,
		128,
		129,
		135,
		121,
		127,
		123,
		-1,
		133,
		117,
		-1,
		-1,
		118,
		119,
		103,
		106,
		114,
		112,
		125,
		117,
		112,
		-1,
		-1,
		109,
		105,
		112,
		99,
		95,
		112,
		125,
		107,
		121,
		120,
		-1,
		113,
		131,
		138,
		106,
		104,
		88,
		86,
		104,
		106,
		112,
		112,
		-1,
		122,
		123,
		118,
		126,
		128,
		104,
		91,
		91,
		101,
		94,
		113,
		101,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		122,
		105,
		122,
		114,
		104,
		119,
		112,
		94,
		91,
		89,
		86,
		102,
		100,
		110,
		-1,
		-1,
		215,
		184,
		213,
		171,
		152,
		-1,
		118,
		98,
		104,
		108,
		102,
		95,
		109,
		105,
		-1,
		80,
		79,
		107,
		93,
		104,
		175,
		-1,
		-1,
		173,
		165,
		148,
		151,
		128,
		124,
		113,
		112,
		104,
		90,
		86,
		92,
		95,
		95,
		101,
		74,
		84,
		88,
		86,
		111,
		-1,
		-1,
		146,
		-1,
		-1,
		172,
		155,
		-1,
		138,
		145,
		134,
		140,
		126,
		147,
		123,
		114,
		106,
		100,
		88,
		90,
		87,
		100,
		88,
		71,
		96,
		100,
		81,
		102,
		97,
		-1,
		145,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		131,
		134,
		140,
		164,
		163,
		-1,
		135,
		123,
		124,
		109,
		106,
		93,
		81,
		94,
		79,
		86,
		85,
		75,
		73,
		103,
		78,
		100,
		97,
		116,
		121,
		115,
		124,
		-1,
		180,
		176,
		172,
		179,
		128,
		-1,
		-1,
		168,
		-1,
		171,
		172,
		147,
		120,
		123,
		110,
		101,
		88,
		77,
		88,
		77,
		74,
		82,
		67,
		82,
		73,
		72,
		90,
		100,
		108,
		112,
		118,
		-1,
		230,
		-1,
		172,
		156,
		158,
		130,
		151,
		-1,
		188,
		172,
		164,
		149,
		149,
		-1,
		119,
		116,
		106,
		84,
		69,
		86,
		78,
		76,
		80,
		62,
		76,
		67,
		85,
		92,
		90,
		94,
		114,
		126,
		190,
		180,
		-1,
		162,
		167,
		126,
		134,
		153,
		191,
		155,
		-1,
		150,
		-1,
		121,
		134,
		-1,
		90,
		86,
		68,
		69,
		64,
		79,
		73,
		58,
		55,
		73,
		76,
		83,
		87,
		103,
		-1,
		-1,
		175,
		179,
		168,
		119,
		138,
		162,
		199,
		148,
		137,
		136,
		-1,
		127,
		104,
		101,
		89,
		76,
		61,
		62,
		70,
		82,
		61,
		57,
		54,
		74,
		100,
		78,
		90,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		145,
		116,
		140,
		182,
		166,
		159,
		147,
		112,
		112,
		106,
		-1,
		100,
		79,
		70,
		59,
		57,
		70,
		62,
		72,
		52,
		50,
		69,
		81,
		72,
		84,
		-1,
		-1,
		-1,
		175,
		164,
		165,
		111,
		134,
		171,
		145,
		131,
		136,
		111,
		104,
		98,
		113,
		96,
		77,
		66,
		58,
		47,
		58,
		66,
		66,
		48,
		57,
		63,
		87,
		72,
		78,
		-1,
		-1,
		182,
		172,
		156,
		158,
		155,
		125,
		132,
		164,
		136,
		149,
		-1,
		103,
		-1,
		92,
		87,
		71,
		66,
		63,
		53,
		49,
		63,
		65,
		55,
		50,
		57,
		92,
		92,
		62,
		82,
		85,
		-1,
		-1,
		-1,
		175,
		170,
		145,
		122,
		106,
		142,
		-1,
		119,
		120,
		-1,
		97,
		91,
		88,
		73,
		69,
		57,
		61,
		61,
		63,
		54,
		59,
		60,
		42,
		67,
		-1,
		70,
		64,
		72,
		62,
		50,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		101,
		153,
		-1,
		-1,
		104,
		97,
		-1,
		84,
		66,
		69,
		64,
		63,
		62,
		59,
		48,
		61,
		54,
		47,
		42,
		55,
		59,
		63,
		52,
		48,
		45,
		59,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		121,
		-1,
		113,
		105,
		95,
		89,
		83,
		79,
		77,
		91,
		75,
		74,
		71,
		62,
		59,
		43,
		36,
		47,
		32,
		50,
		58,
		50,
		44,
		43,
		55,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		134,
		-1,
		98,
		112,
		128,
		-1,
		121,
		100,
		115,
		93,
		89,
		81,
		98,
		99,
		74,
		71,
		59,
		47,
		48,
		37,
		40,
		32,
		54,
		54,
		38,
		39,
		48,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		95,
		83,
		115,
		-1,
		-1,
		157,
		-1,
		91,
		108,
		95,
		93,
		88,
		68,
		75,
		71,
		44,
		39,
		42,
		31,
		24,
		26,
		48,
		34,
		32,
		51,
		67,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		135,
		125,
		109,
		94,
		127,
		-1,
		67,
		63,
		70,
		-1,
		64,
		-1,
		32,
		28,
		19,
		16,
		20,
		31,
		29,
		40,
		57,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		152,
		-1,
		-1,
		122,
		116,
		116,
		100,
		102,
		83,
		63,
		55,
		70,
		47,
		30,
		33,
		10,
		10,
		13,
		23,
		36,
		56,
		47,
		59,
		-1,
		-1,
		-1,
		149,
		135,
		139,
		99,
		118,
		-1,
		-1,
		184,
		139,
		125,
		-1,
		97,
		83,
		71,
		61,
		51,
		52,
		46,
		21,
		12,
		8,
		17,
		21,
		32,
		37,
		58,
		59,
		72,
		-1,
		-1,
		132,
		137,
		125,
		111,
		130,
		-1,
		-1,
		-1,
		131,
		147,
		116,
		95,
		72,
		-1,
		-1,
		55,
		44,
		38,
		13,
		0,
		20,
		27,
		42,
		31,
		46,
		58,
		66,
		71,
		-1,
		135,
		122,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		-1,
		-1,
		128,
		73,
		62,
		57,
		61,
		54,
		-1,
		33,
		24,
		4,
		18,
		25,
		44,
		39,
		33,
		41,
		59,
		76,
		-1,
		-1,
		147,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		85,
		79,
		50,
		43,
		47,
		-1,
		34,
		20,
		6,
		23,
		44,
		41,
		45,
		37,
		42,
		44,
		57,
		71,
		75,
		170,
		-1,
		143,
		-1,
		-1,
		-1,
		103,
		118,
		89,
		66,
		39,
		34,
		27,
		21,
		14,
		30,
		39,
		50,
		44,
		40,
		41,
		50,
		49,
		66,
		76,
		-1,
		-1,
		141,
		137,
		129,
		111,
		115,
		116,
		-1,
		-1,
		43,
		34,
		25,
		28,
		24,
		27,
		43,
		45,
		52,
		57,
		45,
		59,
		75,
		81,
		-1,
		-1,
		-1,
		153,
		-1,
		155,
		-1,
		-1,
		130,
		114,
		61,
		43,
		39,
		37,
		30,
		39,
		33,
		38,
		63,
		59,
		67,
		47,
		65,
		85,
		77,
		113,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		132,
		124,
		119,
		125,
		126,
		117,
		76,
		73,
		-1,
		43,
		68,
		39,
		46,
		38,
		52,
		57,
		63,
		52,
		62,
		78,
		77,
		72,
		105,
		99,
		105,
		-1,
		-1,
		222,
		211,
		200,
		206,
		-1,
		125,
		121,
		111,
		101,
		103,
		-1,
		-1,
		91,
		88,
		65,
		48,
		53,
		46,
		41,
		79,
		55,
		51,
		55,
		59,
		65,
		70,
		75,
		81,
		96,
		111,
		-1,
		176,
		213,
		206,
		174,
		182,
		213,
		-1,
		115,
		107,
		118,
		93,
		94,
		-1,
		-1,
		64,
		62,
		67,
		55,
		52,
		65,
		64,
		75,
		65,
		71,
		58,
		57,
		75,
		79,
		88,
		95,
		85,
		98,
		102,
		-1,
		169,
		189,
		168,
		171,
		195,
		209,
		-1,
		112,
		-1,
		-1,
		124,
		95,
		79,
		70,
		63,
		114,
		69,
		64,
		66,
		68,
		73,
		64,
		75,
		66,
		66,
		69,
		84,
		89,
		81,
		95,
		95,
		96,
		-1,
		158,
		169,
		162,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		140,
		-1,
		106,
		-1,
		81,
		85,
		77,
		80,
		91,
		78,
		77,
		73,
		89,
		64,
		74,
		70,
		71,
		80,
		91,
		103,
		102,
		103,
		183,
		139,
		142,
		153,
		164,
		179,
		183,
		-1,
		124,
		163,
		178,
		-1,
		149,
		-1,
		-1,
		-1,
		95,
		90,
		82,
		98,
		90,
		90,
		71,
		75,
		69,
		76,
		86,
		88,
		80,
		84,
		97,
		108,
		111,
		179,
		170,
		183,
		128,
		128,
		149,
		158,
		179,
		139,
		130,
		157,
		182,
		174,
		169,
		156,
		-1,
		-1,
		118,
		100,
		-1,
		-1,
		97,
		92,
		75,
		77,
		76,
		79,
		94,
		97,
		87,
		85,
		79,
		111,
		-1,
		172,
		171,
		160,
		157,
		133,
		124,
		119,
		146,
		-1,
		-1,
		141,
		158,
		152,
		156,
		172,
		197,
		-1,
		159,
		-1,
		-1,
		139,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		84,
		95,
		105,
		93,
		94,
		84,
		94,
		107,
		156,
		153,
		141,
		139,
		162,
		127,
		115,
		-1,
		128,
		126,
		132,
		139,
		156,
		186,
		-1,
		-1,
		175,
		155,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		111,
		113,
		102,
		96,
		90,
		97,
		96,
		104,
		112,
		165,
		179,
		168,
		164,
		163,
		171,
		120,
		113,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		165,
		161,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		104,
		104,
		100,
		93,
		88,
		99,
		91,
		95,
		112,
		-1,
		199,
		-1,
		151,
		127,
		141,
		156,
		164,
		-1,
		-1,
		-1,
		182,
		168,
		161,
		149,
		147,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		94,
		105,
		94,
		97,
		111,
		106,
		-1,
		-1,
		139,
		142,
		-1,
		-1,
		164,
		174,
		-1,
		173,
		162,
		147,
		139,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		98,
		104,
		107,
		96,
		100,
		112,
		-1,
		-1,
		146,
		147,
		152,
		-1,
		157,
		-1,
		175,
		-1,
		142,
		148,
		136,
		-1,
		-1,
		-1,
		135,
		98,
		115,
		129,
		127,
		125,
		116,
		102,
		109,
		107,
		103,
		114,
		-1,
		-1,
		-1,
		175,
		149,
		182,
		173,
		156,
		136,
		128,
		147,
		-1,
		117,
		-1,
		92,
		95,
		120,
		128,
		138,
		132,
		105,
		120,
		110,
		101,
		110,
		181,
		-1,
		151,
		184,
		148,
		142,
		118,
		122,
		138,
		-1,
		114,
		96,
		-1,
		124,
		114,
		154,
		137,
		120,
		107,
		114,
		114,
		107,
		-1,
		-1,
		-1,
		153,
		152,
		144,
		138,
		138,
		123,
		114,
		-1,
		126,
		108,
		87,
		104,
		104,
		95,
		103,
		144,
		140,
		127,
		127,
		119,
		-1,
		254,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		147,
		142,
		115,
		103,
		109,
		105,
		91,
		97,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		120,
		155,
		-1,
		249,
		-1,
		183,
		-1,
		-1,
		165,
		145,
		137,
		126,
		115,
		113,
		104,
		95,
		117,
		133,
		117,
		115,
		120,
		125,
		-1,
		238,
		237,
		-1,
		184,
		176,
		162,
		-1,
		155,
		-1,
		161,
		122,
		-1,
		124,
		104,
		-1,
		126,
		122,
		-1,
		-1,
		225,
		200,
		-1,
		-1,
		-1,
		185,
		165,
		156,
		140,
		-1,
		115,
		115,
		-1,
		-1,
		-1,
		210,
		209,
		-1,
		178,
		181,
		-1,
		171,
		162,
		170,
		117,
		121,
		-1,
		-1,
		-1,
		219,
		200,
		194,
		193,
		191,
		186,
		183,
		169,
		153,
		131,
		120,
		141,
		-1,
		-1,
		-1,
		191,
		183,
		176,
		-1,
		-1,
		178,
		161,
		142,
		140,
		-1,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		168,
		-1,
		-1,
		174,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		202,
		-1,
		-1,
		-1,
		164,
		160,
		161,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		248,
		212,
		-1,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		227,
		225,
		-1,
		-1,
		-1,
		184,
		168,
		-1,
		154,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		189,
		-1,
		189,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		202,
		194,
		202,
		-1,
		174,
		176,
		-1,
		224,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		179,
		186,
		208,
		211,
		247,
		-1,
		198
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		199,
		203,
		169,
		163,
		202,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		192,
		191,
		159,
		157,
		166,
		171,
		178,
		-1,
		177,
		-1,
		213,
		192,
		203,
		208,
		152,
		149,
		169,
		188,
		170,
		162,
		228,
		182,
		153,
		147,
		165,
		155,
		164,
		156,
		-1,
		153,
		143,
		165,
		144,
		155,
		147,
		-1,
		-1,
		147,
		148,
		154,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		137,
		138,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		128,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		139,
		-1,
		132,
		150,
		157,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		131,
		-1,
		141,
		142,
		137,
		145,
		147,
		123,
		110,
		110,
		120,
		113,
		132,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		124,
		141,
		133,
		123,
		138,
		131,
		113,
		110,
		108,
		105,
		121,
		119,
		129,
		-1,
		-1,
		234,
		203,
		232,
		190,
		171,
		-1,
		137,
		117,
		123,
		127,
		121,
		114,
		128,
		124,
		-1,
		99,
		98,
		126,
		112,
		123,
		194,
		-1,
		-1,
		192,
		184,
		167,
		170,
		147,
		143,
		132,
		131,
		123,
		109,
		105,
		111,
		114,
		114,
		120,
		93,
		103,
		107,
		105,
		130,
		-1,
		-1,
		165,
		-1,
		-1,
		191,
		174,
		-1,
		157,
		164,
		153,
		159,
		145,
		166,
		142,
		133,
		125,
		119,
		107,
		109,
		106,
		119,
		107,
		90,
		115,
		119,
		100,
		121,
		116,
		-1,
		164,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		150,
		153,
		159,
		183,
		182,
		-1,
		154,
		142,
		143,
		128,
		125,
		112,
		100,
		113,
		98,
		105,
		104,
		94,
		92,
		122,
		97,
		119,
		116,
		135,
		140,
		134,
		143,
		-1,
		199,
		195,
		191,
		198,
		147,
		-1,
		-1,
		187,
		-1,
		190,
		191,
		166,
		139,
		142,
		129,
		120,
		107,
		96,
		107,
		96,
		93,
		101,
		86,
		101,
		92,
		91,
		109,
		119,
		127,
		131,
		137,
		-1,
		249,
		-1,
		191,
		175,
		177,
		149,
		170,
		-1,
		207,
		191,
		183,
		168,
		168,
		-1,
		138,
		135,
		125,
		103,
		88,
		105,
		97,
		95,
		99,
		81,
		95,
		86,
		104,
		111,
		109,
		113,
		133,
		145,
		209,
		199,
		-1,
		181,
		186,
		145,
		153,
		172,
		210,
		174,
		-1,
		169,
		-1,
		140,
		153,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		92,
		77,
		74,
		92,
		95,
		102,
		106,
		122,
		-1,
		-1,
		194,
		198,
		187,
		138,
		157,
		181,
		218,
		167,
		156,
		155,
		-1,
		146,
		123,
		120,
		108,
		95,
		80,
		81,
		89,
		101,
		80,
		76,
		73,
		93,
		119,
		97,
		109,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		164,
		135,
		159,
		201,
		185,
		178,
		166,
		131,
		131,
		125,
		-1,
		119,
		98,
		89,
		78,
		76,
		89,
		81,
		91,
		71,
		69,
		88,
		100,
		91,
		101,
		-1,
		-1,
		-1,
		194,
		183,
		184,
		130,
		153,
		190,
		164,
		150,
		155,
		130,
		123,
		117,
		132,
		115,
		96,
		85,
		77,
		66,
		77,
		85,
		85,
		67,
		76,
		82,
		106,
		89,
		95,
		-1,
		-1,
		201,
		191,
		175,
		177,
		174,
		144,
		151,
		183,
		155,
		168,
		-1,
		122,
		-1,
		111,
		106,
		90,
		85,
		82,
		72,
		68,
		82,
		84,
		74,
		69,
		76,
		111,
		111,
		79,
		99,
		102,
		-1,
		-1,
		-1,
		194,
		189,
		164,
		141,
		125,
		161,
		-1,
		138,
		139,
		-1,
		116,
		110,
		107,
		92,
		88,
		76,
		80,
		80,
		82,
		73,
		78,
		79,
		61,
		86,
		-1,
		87,
		81,
		89,
		79,
		67,
		-1,
		-1,
		-1,
		187,
		166,
		159,
		179,
		120,
		172,
		-1,
		-1,
		123,
		116,
		-1,
		103,
		85,
		88,
		83,
		82,
		81,
		78,
		67,
		80,
		73,
		66,
		61,
		74,
		78,
		80,
		69,
		65,
		62,
		76,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		140,
		-1,
		132,
		124,
		114,
		108,
		102,
		98,
		96,
		110,
		94,
		93,
		90,
		81,
		69,
		62,
		55,
		66,
		51,
		69,
		76,
		67,
		62,
		61,
		72,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		153,
		-1,
		117,
		131,
		147,
		-1,
		140,
		119,
		134,
		112,
		108,
		100,
		115,
		116,
		86,
		90,
		69,
		57,
		60,
		56,
		59,
		51,
		73,
		71,
		55,
		57,
		66,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		114,
		102,
		134,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		114,
		112,
		105,
		80,
		87,
		81,
		54,
		49,
		61,
		50,
		43,
		45,
		65,
		51,
		49,
		69,
		85,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		79,
		75,
		82,
		-1,
		74,
		-1,
		46,
		47,
		38,
		35,
		39,
		50,
		48,
		58,
		67,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		171,
		-1,
		-1,
		141,
		135,
		135,
		119,
		121,
		95,
		75,
		67,
		82,
		57,
		40,
		43,
		26,
		29,
		32,
		36,
		49,
		55,
		65,
		65,
		-1,
		-1,
		-1,
		168,
		154,
		158,
		118,
		137,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		116,
		95,
		83,
		73,
		63,
		67,
		56,
		31,
		22,
		25,
		36,
		23,
		38,
		33,
		54,
		59,
		75,
		-1,
		-1,
		151,
		156,
		144,
		130,
		149,
		-1,
		-1,
		-1,
		150,
		166,
		135,
		114,
		84,
		-1,
		-1,
		67,
		59,
		48,
		28,
		19,
		0,
		7,
		38,
		31,
		42,
		54,
		70,
		71,
		-1,
		154,
		141,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		-1,
		-1,
		147,
		92,
		81,
		76,
		80,
		66,
		-1,
		52,
		39,
		23,
		27,
		34,
		40,
		41,
		35,
		41,
		59,
		76,
		-1,
		-1,
		166,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		104,
		98,
		69,
		62,
		66,
		-1,
		53,
		39,
		25,
		39,
		53,
		50,
		47,
		39,
		44,
		44,
		57,
		71,
		75,
		189,
		-1,
		162,
		-1,
		-1,
		-1,
		122,
		137,
		108,
		85,
		58,
		53,
		46,
		40,
		33,
		47,
		56,
		67,
		46,
		42,
		43,
		50,
		49,
		66,
		76,
		-1,
		-1,
		160,
		156,
		148,
		130,
		134,
		135,
		-1,
		-1,
		62,
		53,
		44,
		47,
		43,
		46,
		52,
		49,
		54,
		59,
		47,
		59,
		77,
		81,
		-1,
		-1,
		-1,
		172,
		-1,
		174,
		-1,
		-1,
		149,
		133,
		80,
		62,
		58,
		56,
		49,
		58,
		52,
		57,
		67,
		77,
		69,
		49,
		70,
		87,
		82,
		113,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		151,
		143,
		138,
		144,
		145,
		136,
		95,
		92,
		-1,
		62,
		87,
		58,
		65,
		57,
		71,
		75,
		73,
		54,
		67,
		83,
		82,
		77,
		105,
		100,
		109,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		144,
		140,
		130,
		120,
		122,
		-1,
		-1,
		110,
		107,
		84,
		67,
		72,
		65,
		60,
		89,
		69,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		115,
		-1,
		195,
		232,
		225,
		193,
		201,
		232,
		-1,
		134,
		126,
		137,
		112,
		113,
		-1,
		-1,
		83,
		81,
		86,
		74,
		71,
		84,
		83,
		85,
		70,
		76,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		188,
		208,
		187,
		190,
		214,
		228,
		-1,
		131,
		-1,
		-1,
		143,
		114,
		98,
		89,
		82,
		133,
		88,
		83,
		85,
		87,
		82,
		73,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		177,
		188,
		181,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		159,
		-1,
		125,
		-1,
		100,
		104,
		96,
		99,
		107,
		94,
		86,
		78,
		94,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		143,
		182,
		197,
		-1,
		168,
		-1,
		-1,
		-1,
		114,
		109,
		101,
		117,
		106,
		106,
		80,
		84,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		158,
		149,
		176,
		201,
		193,
		188,
		175,
		-1,
		-1,
		137,
		119,
		-1,
		-1,
		113,
		101,
		84,
		85,
		81,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		160,
		177,
		171,
		175,
		191,
		216,
		-1,
		173,
		-1,
		-1,
		158,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		89,
		100,
		110,
		98,
		99,
		89,
		99,
		112,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		147,
		145,
		151,
		158,
		175,
		205,
		-1,
		-1,
		189,
		169,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		116,
		118,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		179,
		175,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		109,
		113,
		105,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		218,
		-1,
		170,
		146,
		160,
		175,
		183,
		-1,
		-1,
		-1,
		196,
		182,
		175,
		163,
		161,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		158,
		161,
		-1,
		-1,
		183,
		188,
		-1,
		187,
		176,
		161,
		153,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		165,
		166,
		171,
		-1,
		171,
		-1,
		189,
		-1,
		156,
		162,
		150,
		-1,
		-1,
		-1,
		144,
		107,
		128,
		138,
		132,
		130,
		121,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		189,
		163,
		196,
		187,
		170,
		150,
		142,
		161,
		-1,
		131,
		-1,
		106,
		108,
		134,
		137,
		143,
		137,
		110,
		125,
		115,
		106,
		115,
		195,
		-1,
		165,
		198,
		162,
		156,
		132,
		136,
		152,
		-1,
		128,
		110,
		-1,
		138,
		128,
		159,
		144,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		167,
		166,
		158,
		152,
		152,
		137,
		128,
		-1,
		140,
		122,
		101,
		118,
		118,
		109,
		117,
		149,
		145,
		132,
		132,
		124,
		-1,
		268,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		161,
		156,
		129,
		117,
		123,
		119,
		105,
		111,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		125,
		160,
		-1,
		263,
		-1,
		197,
		-1,
		-1,
		179,
		159,
		151,
		140,
		129,
		127,
		118,
		109,
		131,
		147,
		131,
		129,
		132,
		133,
		-1,
		252,
		251,
		-1,
		198,
		190,
		176,
		-1,
		169,
		-1,
		175,
		136,
		-1,
		138,
		118,
		-1,
		140,
		136,
		-1,
		-1,
		239,
		214,
		-1,
		-1,
		-1,
		199,
		179,
		170,
		154,
		-1,
		129,
		129,
		-1,
		-1,
		-1,
		224,
		223,
		-1,
		192,
		195,
		-1,
		185,
		176,
		184,
		131,
		135,
		-1,
		-1,
		-1,
		233,
		214,
		208,
		207,
		205,
		200,
		197,
		183,
		167,
		145,
		134,
		155,
		-1,
		-1,
		-1,
		205,
		197,
		190,
		-1,
		-1,
		192,
		175,
		156,
		154,
		-1,
		-1,
		-1,
		227,
		208,
		-1,
		-1,
		182,
		-1,
		-1,
		188,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		216,
		-1,
		-1,
		-1,
		178,
		174,
		175,
		-1,
		-1,
		-1,
		-1,
		238,
		239,
		262,
		226,
		-1,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		241,
		239,
		-1,
		-1,
		-1,
		198,
		182,
		-1,
		168,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		203,
		-1,
		203,
		178,
		185,
		-1,
		-1,
		-1,
		-1,
		216,
		208,
		216,
		-1,
		188,
		190,
		-1,
		238,
		-1,
		-1,
		231,
		222,
		-1,
		-1,
		193,
		200,
		222,
		225,
		261,
		-1,
		212
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		128,
		146,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		127,
		-1,
		137,
		138,
		133,
		141,
		143,
		119,
		106,
		106,
		116,
		109,
		128,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		120,
		137,
		129,
		119,
		134,
		127,
		109,
		106,
		104,
		101,
		117,
		115,
		125,
		-1,
		-1,
		230,
		199,
		228,
		186,
		167,
		-1,
		133,
		113,
		119,
		123,
		117,
		110,
		124,
		120,
		-1,
		95,
		94,
		122,
		108,
		119,
		190,
		-1,
		-1,
		188,
		180,
		163,
		166,
		143,
		139,
		128,
		127,
		119,
		105,
		101,
		107,
		110,
		110,
		116,
		89,
		99,
		103,
		101,
		126,
		-1,
		-1,
		161,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		149,
		155,
		141,
		162,
		138,
		129,
		121,
		115,
		103,
		105,
		102,
		115,
		103,
		86,
		111,
		115,
		96,
		117,
		112,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		178,
		-1,
		150,
		138,
		139,
		124,
		121,
		108,
		96,
		109,
		94,
		101,
		100,
		90,
		88,
		118,
		93,
		115,
		112,
		131,
		136,
		130,
		139,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		186,
		187,
		162,
		135,
		138,
		125,
		116,
		103,
		92,
		103,
		92,
		89,
		97,
		82,
		97,
		88,
		87,
		105,
		115,
		123,
		127,
		133,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		187,
		179,
		164,
		164,
		-1,
		134,
		131,
		121,
		99,
		84,
		101,
		93,
		91,
		95,
		77,
		91,
		82,
		100,
		107,
		105,
		109,
		129,
		141,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		136,
		149,
		-1,
		105,
		101,
		83,
		84,
		79,
		94,
		88,
		73,
		70,
		88,
		91,
		98,
		102,
		118,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		119,
		116,
		104,
		91,
		76,
		77,
		85,
		97,
		76,
		72,
		69,
		89,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		72,
		85,
		77,
		87,
		67,
		65,
		84,
		96,
		87,
		97,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		128,
		111,
		92,
		81,
		73,
		62,
		73,
		81,
		81,
		63,
		72,
		78,
		102,
		85,
		91,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		68,
		64,
		78,
		80,
		70,
		65,
		72,
		107,
		107,
		75,
		95,
		98,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		72,
		76,
		76,
		78,
		69,
		74,
		75,
		57,
		82,
		-1,
		83,
		77,
		85,
		75,
		63,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		84,
		79,
		78,
		77,
		74,
		63,
		76,
		69,
		62,
		57,
		70,
		74,
		76,
		65,
		61,
		58,
		72,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		106,
		90,
		89,
		86,
		77,
		77,
		58,
		51,
		62,
		47,
		65,
		72,
		63,
		58,
		57,
		68,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		96,
		113,
		114,
		92,
		86,
		77,
		65,
		63,
		52,
		55,
		47,
		69,
		67,
		51,
		53,
		62,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		110,
		108,
		103,
		88,
		95,
		89,
		62,
		57,
		57,
		46,
		39,
		41,
		61,
		47,
		45,
		65,
		81,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		87,
		83,
		90,
		-1,
		82,
		-1,
		53,
		49,
		40,
		31,
		35,
		46,
		44,
		54,
		63,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		103,
		83,
		75,
		90,
		65,
		48,
		51,
		34,
		31,
		28,
		32,
		45,
		51,
		61,
		61,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		124,
		103,
		91,
		81,
		71,
		75,
		64,
		39,
		30,
		33,
		38,
		19,
		34,
		29,
		50,
		55,
		71,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		143,
		122,
		92,
		-1,
		-1,
		75,
		67,
		56,
		36,
		27,
		8,
		0,
		34,
		27,
		38,
		50,
		66,
		67,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		155,
		100,
		89,
		84,
		88,
		74,
		-1,
		60,
		47,
		31,
		35,
		42,
		36,
		37,
		31,
		37,
		55,
		72,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		112,
		106,
		77,
		70,
		74,
		-1,
		61,
		47,
		33,
		47,
		55,
		52,
		43,
		35,
		40,
		40,
		53,
		67,
		71,
		185,
		-1,
		168,
		-1,
		-1,
		-1,
		130,
		145,
		116,
		93,
		66,
		61,
		54,
		48,
		41,
		55,
		63,
		74,
		42,
		38,
		39,
		46,
		45,
		62,
		72,
		-1,
		-1,
		168,
		164,
		156,
		138,
		142,
		143,
		-1,
		-1,
		70,
		61,
		52,
		55,
		51,
		54,
		48,
		45,
		50,
		55,
		43,
		55,
		73,
		77,
		-1,
		-1,
		-1,
		180,
		-1,
		182,
		-1,
		-1,
		157,
		141,
		88,
		70,
		66,
		64,
		57,
		66,
		60,
		53,
		63,
		73,
		65,
		45,
		66,
		83,
		78,
		109,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		159,
		151,
		146,
		152,
		153,
		144,
		103,
		100,
		-1,
		70,
		95,
		66,
		73,
		65,
		71,
		71,
		69,
		50,
		63,
		79,
		78,
		73,
		101,
		96,
		105,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		152,
		148,
		138,
		128,
		130,
		-1,
		-1,
		118,
		115,
		92,
		75,
		80,
		73,
		68,
		85,
		65,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		111,
		-1,
		195,
		240,
		233,
		201,
		209,
		240,
		-1,
		142,
		134,
		145,
		120,
		121,
		-1,
		-1,
		91,
		89,
		94,
		82,
		79,
		92,
		90,
		81,
		66,
		72,
		59,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		196,
		216,
		195,
		198,
		222,
		236,
		-1,
		139,
		-1,
		-1,
		151,
		122,
		106,
		97,
		90,
		141,
		96,
		91,
		89,
		87,
		78,
		69,
		76,
		67,
		67,
		70,
		85,
		90,
		82,
		96,
		96,
		97,
		-1,
		185,
		196,
		189,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		167,
		-1,
		133,
		-1,
		108,
		112,
		104,
		107,
		103,
		90,
		82,
		74,
		90,
		65,
		75,
		71,
		72,
		81,
		92,
		104,
		103,
		104,
		210,
		166,
		169,
		180,
		191,
		206,
		210,
		-1,
		151,
		190,
		202,
		-1,
		176,
		-1,
		-1,
		-1,
		122,
		117,
		109,
		123,
		102,
		102,
		76,
		80,
		70,
		77,
		87,
		89,
		81,
		85,
		98,
		109,
		112,
		206,
		197,
		210,
		155,
		155,
		176,
		185,
		206,
		166,
		157,
		184,
		209,
		198,
		193,
		180,
		-1,
		-1,
		145,
		127,
		-1,
		-1,
		109,
		97,
		80,
		81,
		77,
		80,
		95,
		98,
		88,
		86,
		80,
		112,
		-1,
		199,
		198,
		187,
		184,
		160,
		151,
		146,
		173,
		-1,
		-1,
		168,
		185,
		179,
		183,
		199,
		224,
		-1,
		169,
		-1,
		-1,
		154,
		-1,
		-1,
		139,
		102,
		91,
		82,
		88,
		85,
		96,
		106,
		94,
		95,
		85,
		95,
		108,
		183,
		180,
		168,
		166,
		189,
		154,
		142,
		-1,
		155,
		153,
		159,
		166,
		183,
		213,
		-1,
		-1,
		185,
		165,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		87,
		92,
		112,
		114,
		103,
		97,
		91,
		98,
		97,
		105,
		113,
		192,
		206,
		195,
		191,
		190,
		198,
		147,
		140,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		171,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		101,
		105,
		109,
		101,
		94,
		89,
		100,
		92,
		96,
		113,
		-1,
		226,
		-1,
		178,
		154,
		168,
		183,
		191,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		145,
		113,
		118,
		113,
		95,
		106,
		95,
		98,
		112,
		107,
		-1,
		-1,
		166,
		169,
		-1,
		-1,
		182,
		184,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		102,
		127,
		116,
		124,
		119,
		99,
		105,
		108,
		97,
		101,
		113,
		-1,
		-1,
		173,
		174,
		179,
		-1,
		167,
		-1,
		185,
		-1,
		152,
		158,
		146,
		-1,
		-1,
		-1,
		140,
		103,
		124,
		134,
		128,
		126,
		117,
		103,
		110,
		108,
		104,
		115,
		-1,
		-1,
		-1,
		185,
		159,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		127,
		-1,
		102,
		104,
		130,
		133,
		139,
		133,
		106,
		121,
		111,
		102,
		111,
		191,
		-1,
		161,
		194,
		158,
		152,
		128,
		132,
		148,
		-1,
		124,
		106,
		-1,
		134,
		124,
		155,
		140,
		121,
		108,
		115,
		115,
		108,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		136,
		118,
		97,
		114,
		114,
		105,
		113,
		145,
		141,
		128,
		128,
		120,
		-1,
		264,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		152,
		125,
		113,
		119,
		115,
		101,
		107,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		121,
		156,
		-1,
		259,
		-1,
		193,
		-1,
		-1,
		175,
		155,
		147,
		136,
		125,
		123,
		114,
		105,
		127,
		143,
		127,
		125,
		128,
		129,
		-1,
		248,
		247,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		171,
		132,
		-1,
		134,
		114,
		-1,
		136,
		132,
		-1,
		-1,
		235,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		166,
		150,
		-1,
		125,
		125,
		-1,
		-1,
		-1,
		220,
		219,
		-1,
		188,
		191,
		-1,
		181,
		172,
		180,
		127,
		131,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		203,
		201,
		196,
		193,
		179,
		163,
		141,
		130,
		151,
		-1,
		-1,
		-1,
		201,
		193,
		186,
		-1,
		-1,
		188,
		171,
		152,
		150,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		178,
		-1,
		-1,
		184,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		212,
		-1,
		-1,
		-1,
		174,
		170,
		171,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		258,
		222,
		-1,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		237,
		235,
		-1,
		-1,
		-1,
		194,
		178,
		-1,
		164,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		199,
		-1,
		199,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		212,
		204,
		212,
		-1,
		184,
		186,
		-1,
		234,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		189,
		196,
		218,
		221,
		257,
		-1,
		208
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		187,
		191,
		157,
		151,
		190,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		180,
		179,
		147,
		145,
		154,
		159,
		166,
		-1,
		165,
		-1,
		201,
		180,
		191,
		196,
		140,
		137,
		157,
		176,
		158,
		150,
		216,
		170,
		141,
		135,
		153,
		143,
		152,
		144,
		-1,
		141,
		131,
		153,
		132,
		143,
		135,
		-1,
		-1,
		135,
		136,
		142,
		128,
		134,
		130,
		-1,
		140,
		124,
		-1,
		-1,
		125,
		126,
		110,
		113,
		121,
		119,
		132,
		124,
		119,
		-1,
		-1,
		116,
		112,
		119,
		106,
		102,
		119,
		132,
		114,
		128,
		127,
		-1,
		122,
		140,
		145,
		113,
		111,
		95,
		93,
		111,
		113,
		119,
		119,
		-1,
		131,
		132,
		127,
		135,
		135,
		111,
		98,
		98,
		108,
		101,
		120,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		114,
		131,
		123,
		113,
		128,
		121,
		101,
		98,
		96,
		93,
		109,
		107,
		117,
		-1,
		-1,
		222,
		191,
		222,
		180,
		161,
		-1,
		127,
		107,
		113,
		117,
		111,
		104,
		118,
		114,
		-1,
		87,
		86,
		114,
		100,
		111,
		182,
		-1,
		-1,
		180,
		172,
		157,
		160,
		137,
		133,
		122,
		121,
		113,
		99,
		95,
		101,
		104,
		104,
		110,
		81,
		91,
		95,
		93,
		118,
		-1,
		-1,
		153,
		-1,
		-1,
		179,
		162,
		-1,
		145,
		152,
		143,
		149,
		135,
		156,
		132,
		123,
		115,
		109,
		97,
		99,
		96,
		109,
		97,
		78,
		103,
		107,
		88,
		109,
		104,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		138,
		141,
		147,
		171,
		172,
		-1,
		144,
		132,
		133,
		118,
		115,
		102,
		90,
		103,
		88,
		95,
		94,
		82,
		80,
		110,
		85,
		107,
		104,
		123,
		128,
		122,
		131,
		-1,
		187,
		183,
		179,
		186,
		135,
		-1,
		-1,
		175,
		-1,
		180,
		181,
		156,
		129,
		132,
		119,
		110,
		97,
		86,
		97,
		86,
		83,
		91,
		74,
		89,
		80,
		79,
		97,
		107,
		115,
		119,
		125,
		-1,
		237,
		-1,
		179,
		163,
		165,
		137,
		158,
		-1,
		195,
		181,
		173,
		158,
		156,
		-1,
		128,
		125,
		115,
		93,
		78,
		95,
		87,
		85,
		87,
		69,
		83,
		74,
		92,
		99,
		97,
		101,
		121,
		133,
		197,
		187,
		-1,
		169,
		174,
		133,
		141,
		160,
		198,
		162,
		-1,
		157,
		-1,
		130,
		143,
		-1,
		99,
		95,
		77,
		78,
		73,
		88,
		80,
		65,
		62,
		80,
		83,
		90,
		94,
		110,
		-1,
		-1,
		182,
		186,
		175,
		126,
		145,
		169,
		206,
		155,
		144,
		143,
		-1,
		134,
		113,
		110,
		98,
		85,
		70,
		71,
		79,
		91,
		70,
		64,
		61,
		81,
		107,
		85,
		96,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		152,
		123,
		147,
		189,
		173,
		166,
		154,
		119,
		119,
		113,
		-1,
		109,
		88,
		79,
		68,
		66,
		79,
		71,
		79,
		59,
		57,
		76,
		88,
		79,
		87,
		-1,
		-1,
		-1,
		182,
		171,
		172,
		118,
		141,
		178,
		152,
		138,
		143,
		118,
		111,
		105,
		122,
		105,
		86,
		75,
		67,
		56,
		67,
		75,
		73,
		55,
		64,
		70,
		94,
		75,
		81,
		-1,
		-1,
		189,
		179,
		163,
		165,
		162,
		132,
		139,
		171,
		143,
		156,
		-1,
		110,
		-1,
		99,
		95,
		80,
		75,
		72,
		59,
		58,
		72,
		72,
		62,
		57,
		64,
		99,
		99,
		65,
		85,
		88,
		-1,
		-1,
		-1,
		182,
		177,
		152,
		129,
		113,
		149,
		-1,
		126,
		127,
		-1,
		104,
		98,
		95,
		82,
		78,
		63,
		67,
		69,
		72,
		60,
		66,
		67,
		49,
		73,
		-1,
		73,
		67,
		75,
		65,
		53,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		108,
		160,
		-1,
		-1,
		111,
		104,
		-1,
		91,
		73,
		75,
		70,
		69,
		68,
		65,
		54,
		67,
		60,
		54,
		48,
		61,
		65,
		66,
		55,
		51,
		48,
		62,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		128,
		-1,
		120,
		112,
		102,
		96,
		90,
		86,
		84,
		97,
		81,
		80,
		77,
		68,
		76,
		49,
		42,
		53,
		38,
		56,
		62,
		53,
		48,
		47,
		58,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		141,
		-1,
		105,
		119,
		135,
		-1,
		128,
		107,
		122,
		100,
		96,
		87,
		104,
		105,
		83,
		77,
		75,
		66,
		54,
		43,
		46,
		38,
		60,
		57,
		41,
		43,
		52,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		102,
		90,
		122,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		101,
		99,
		94,
		85,
		91,
		86,
		63,
		58,
		48,
		37,
		37,
		32,
		51,
		37,
		35,
		55,
		71,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		102,
		86,
		91,
		-1,
		83,
		-1,
		56,
		53,
		44,
		29,
		26,
		37,
		35,
		44,
		53,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		159,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		118,
		98,
		92,
		91,
		78,
		69,
		64,
		42,
		35,
		32,
		22,
		35,
		45,
		51,
		51,
		-1,
		-1,
		-1,
		156,
		142,
		146,
		106,
		125,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		124,
		112,
		102,
		92,
		93,
		85,
		60,
		51,
		40,
		42,
		24,
		24,
		23,
		44,
		45,
		65,
		-1,
		-1,
		139,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		138,
		154,
		146,
		117,
		113,
		-1,
		-1,
		96,
		85,
		77,
		54,
		44,
		46,
		41,
		0,
		17,
		32,
		44,
		58,
		57,
		-1,
		142,
		129,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		165,
		110,
		99,
		94,
		98,
		95,
		-1,
		70,
		65,
		48,
		31,
		38,
		2,
		24,
		20,
		27,
		45,
		62,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		122,
		116,
		87,
		80,
		84,
		-1,
		72,
		60,
		50,
		37,
		25,
		22,
		17,
		24,
		29,
		30,
		43,
		57,
		61,
		177,
		-1,
		160,
		-1,
		-1,
		-1,
		140,
		155,
		126,
		103,
		76,
		71,
		64,
		58,
		58,
		47,
		33,
		44,
		31,
		27,
		28,
		36,
		35,
		52,
		62,
		-1,
		-1,
		160,
		157,
		166,
		148,
		152,
		153,
		-1,
		-1,
		80,
		71,
		62,
		58,
		54,
		51,
		37,
		34,
		39,
		44,
		32,
		45,
		62,
		67,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		151,
		98,
		80,
		76,
		74,
		67,
		61,
		49,
		42,
		52,
		62,
		54,
		34,
		55,
		72,
		67,
		99,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		113,
		110,
		-1,
		80,
		90,
		55,
		62,
		54,
		60,
		60,
		58,
		39,
		52,
		68,
		67,
		62,
		91,
		86,
		95,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		87,
		64,
		70,
		63,
		58,
		74,
		54,
		41,
		45,
		49,
		55,
		60,
		65,
		71,
		86,
		101,
		-1,
		187,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		81,
		79,
		70,
		55,
		61,
		48,
		47,
		65,
		69,
		78,
		85,
		75,
		88,
		92,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		144,
		116,
		100,
		90,
		87,
		130,
		85,
		80,
		78,
		76,
		67,
		58,
		65,
		56,
		56,
		59,
		74,
		79,
		71,
		85,
		85,
		86,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		127,
		-1,
		110,
		114,
		93,
		96,
		92,
		79,
		71,
		63,
		79,
		54,
		64,
		60,
		61,
		70,
		81,
		93,
		92,
		93,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		191,
		-1,
		169,
		-1,
		-1,
		-1,
		124,
		106,
		98,
		112,
		91,
		91,
		65,
		69,
		59,
		66,
		76,
		78,
		70,
		74,
		87,
		98,
		101,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		198,
		187,
		182,
		169,
		-1,
		-1,
		147,
		116,
		-1,
		-1,
		98,
		86,
		69,
		70,
		66,
		69,
		84,
		87,
		77,
		75,
		69,
		101,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		188,
		213,
		-1,
		158,
		-1,
		-1,
		143,
		-1,
		-1,
		128,
		91,
		80,
		71,
		77,
		74,
		85,
		95,
		83,
		84,
		74,
		84,
		97,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		202,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		126,
		124,
		113,
		-1,
		103,
		76,
		81,
		101,
		103,
		92,
		86,
		80,
		87,
		86,
		94,
		102,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		121,
		114,
		102,
		90,
		80,
		90,
		94,
		98,
		90,
		83,
		78,
		89,
		81,
		85,
		102,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		155,
		139,
		120,
		-1,
		90,
		103,
		134,
		102,
		107,
		102,
		84,
		95,
		84,
		87,
		101,
		96,
		-1,
		-1,
		155,
		158,
		-1,
		-1,
		171,
		173,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		127,
		123,
		-1,
		-1,
		91,
		116,
		105,
		113,
		108,
		88,
		94,
		97,
		86,
		90,
		102,
		-1,
		-1,
		162,
		163,
		168,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		129,
		92,
		113,
		123,
		117,
		115,
		106,
		92,
		99,
		97,
		93,
		104,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		93,
		119,
		122,
		128,
		122,
		95,
		110,
		100,
		91,
		100,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		123,
		113,
		144,
		129,
		110,
		97,
		104,
		104,
		97,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		134,
		130,
		117,
		117,
		109,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		110,
		145,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		117,
		118,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		121,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		163,
		152,
		163,
		171,
		144,
		151,
		-1,
		170,
		174,
		140,
		134,
		173,
		142,
		148,
		159,
		-1,
		-1,
		-1,
		163,
		162,
		130,
		128,
		137,
		142,
		149,
		-1,
		148,
		-1,
		184,
		163,
		174,
		179,
		123,
		120,
		140,
		159,
		141,
		133,
		199,
		153,
		124,
		118,
		136,
		126,
		135,
		127,
		-1,
		124,
		114,
		136,
		115,
		126,
		118,
		-1,
		-1,
		118,
		119,
		125,
		111,
		117,
		113,
		-1,
		123,
		107,
		-1,
		-1,
		108,
		109,
		93,
		96,
		104,
		102,
		115,
		107,
		102,
		-1,
		-1,
		99,
		95,
		102,
		89,
		85,
		102,
		115,
		97,
		111,
		110,
		-1,
		105,
		123,
		128,
		96,
		94,
		78,
		76,
		94,
		96,
		102,
		102,
		-1,
		114,
		115,
		110,
		118,
		118,
		94,
		81,
		81,
		91,
		84,
		103,
		91,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		114,
		97,
		114,
		106,
		96,
		111,
		104,
		84,
		81,
		79,
		76,
		92,
		90,
		100,
		-1,
		-1,
		205,
		174,
		205,
		163,
		144,
		-1,
		110,
		90,
		96,
		100,
		94,
		87,
		101,
		97,
		-1,
		70,
		69,
		97,
		83,
		94,
		165,
		-1,
		-1,
		163,
		155,
		140,
		143,
		120,
		116,
		105,
		104,
		96,
		82,
		78,
		84,
		87,
		87,
		93,
		64,
		74,
		78,
		76,
		101,
		-1,
		-1,
		136,
		-1,
		-1,
		162,
		145,
		-1,
		128,
		135,
		126,
		132,
		118,
		139,
		115,
		106,
		98,
		92,
		80,
		82,
		79,
		92,
		80,
		61,
		86,
		90,
		71,
		92,
		87,
		-1,
		135,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		121,
		124,
		130,
		154,
		155,
		-1,
		127,
		115,
		116,
		101,
		98,
		85,
		73,
		86,
		71,
		78,
		77,
		65,
		63,
		93,
		68,
		90,
		87,
		106,
		111,
		105,
		114,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		158,
		-1,
		163,
		164,
		139,
		112,
		115,
		102,
		93,
		80,
		69,
		80,
		69,
		66,
		74,
		57,
		72,
		63,
		62,
		80,
		90,
		98,
		102,
		108,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		178,
		164,
		156,
		141,
		139,
		-1,
		111,
		108,
		98,
		76,
		61,
		78,
		70,
		68,
		70,
		52,
		66,
		57,
		75,
		82,
		80,
		84,
		104,
		116,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		181,
		145,
		-1,
		140,
		-1,
		113,
		126,
		-1,
		82,
		78,
		60,
		61,
		56,
		71,
		63,
		48,
		45,
		63,
		66,
		73,
		77,
		93,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		138,
		127,
		126,
		-1,
		117,
		96,
		93,
		81,
		68,
		53,
		54,
		62,
		74,
		53,
		47,
		44,
		64,
		90,
		68,
		79,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		156,
		149,
		137,
		102,
		102,
		96,
		-1,
		92,
		71,
		62,
		51,
		49,
		62,
		54,
		62,
		42,
		40,
		59,
		71,
		62,
		70,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		135,
		121,
		126,
		101,
		94,
		88,
		105,
		88,
		69,
		58,
		50,
		39,
		50,
		58,
		56,
		38,
		47,
		53,
		77,
		58,
		64,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		126,
		139,
		-1,
		93,
		-1,
		82,
		78,
		63,
		58,
		55,
		42,
		41,
		55,
		55,
		45,
		40,
		47,
		82,
		82,
		48,
		68,
		71,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		109,
		110,
		-1,
		87,
		81,
		78,
		65,
		61,
		46,
		50,
		52,
		55,
		43,
		49,
		50,
		32,
		56,
		-1,
		56,
		50,
		58,
		48,
		36,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		94,
		87,
		-1,
		74,
		56,
		58,
		53,
		52,
		51,
		48,
		37,
		50,
		43,
		37,
		31,
		44,
		48,
		49,
		38,
		34,
		31,
		45,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		103,
		95,
		85,
		79,
		73,
		69,
		67,
		80,
		64,
		63,
		60,
		51,
		59,
		32,
		25,
		36,
		21,
		39,
		45,
		36,
		31,
		30,
		41,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		102,
		118,
		-1,
		111,
		90,
		105,
		83,
		79,
		70,
		87,
		88,
		66,
		60,
		58,
		49,
		37,
		26,
		29,
		21,
		43,
		40,
		24,
		26,
		35,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		73,
		105,
		-1,
		-1,
		147,
		-1,
		81,
		98,
		84,
		82,
		77,
		68,
		74,
		69,
		46,
		41,
		31,
		20,
		20,
		15,
		34,
		20,
		18,
		38,
		54,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		122,
		-1,
		125,
		115,
		99,
		84,
		117,
		-1,
		85,
		69,
		74,
		-1,
		66,
		-1,
		39,
		36,
		27,
		12,
		9,
		20,
		18,
		27,
		36,
		-1,
		134,
		119,
		112,
		102,
		116,
		87,
		-1,
		142,
		-1,
		-1,
		112,
		106,
		106,
		90,
		93,
		101,
		81,
		75,
		74,
		61,
		53,
		47,
		25,
		18,
		15,
		5,
		18,
		28,
		34,
		34,
		-1,
		-1,
		-1,
		139,
		125,
		129,
		89,
		108,
		-1,
		-1,
		174,
		129,
		115,
		-1,
		99,
		108,
		96,
		86,
		76,
		79,
		69,
		44,
		37,
		23,
		25,
		17,
		7,
		6,
		27,
		28,
		48,
		-1,
		-1,
		122,
		127,
		115,
		101,
		120,
		-1,
		-1,
		-1,
		121,
		137,
		129,
		100,
		97,
		-1,
		-1,
		80,
		71,
		61,
		40,
		27,
		36,
		31,
		16,
		0,
		15,
		27,
		41,
		40,
		-1,
		125,
		112,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		148,
		93,
		82,
		77,
		81,
		79,
		-1,
		53,
		51,
		31,
		43,
		50,
		18,
		13,
		7,
		10,
		28,
		45,
		-1,
		-1,
		137,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		105,
		99,
		70,
		63,
		67,
		-1,
		55,
		47,
		33,
		49,
		31,
		28,
		19,
		11,
		16,
		13,
		26,
		40,
		44,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		123,
		138,
		109,
		86,
		59,
		54,
		47,
		41,
		41,
		53,
		39,
		50,
		18,
		14,
		15,
		19,
		18,
		35,
		45,
		-1,
		-1,
		143,
		144,
		149,
		131,
		135,
		136,
		-1,
		-1,
		63,
		54,
		45,
		45,
		51,
		54,
		24,
		21,
		26,
		31,
		19,
		28,
		46,
		50,
		-1,
		-1,
		-1,
		160,
		-1,
		162,
		-1,
		-1,
		150,
		134,
		81,
		63,
		59,
		57,
		50,
		48,
		36,
		29,
		39,
		49,
		41,
		21,
		41,
		56,
		53,
		82,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		139,
		131,
		126,
		132,
		134,
		125,
		96,
		93,
		-1,
		63,
		77,
		42,
		49,
		41,
		47,
		47,
		45,
		26,
		38,
		54,
		53,
		48,
		74,
		69,
		78,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		132,
		128,
		118,
		108,
		111,
		-1,
		-1,
		105,
		102,
		74,
		51,
		57,
		50,
		45,
		60,
		40,
		27,
		31,
		35,
		41,
		46,
		51,
		57,
		72,
		84,
		-1,
		170,
		216,
		209,
		177,
		185,
		216,
		-1,
		122,
		114,
		125,
		100,
		102,
		-1,
		-1,
		78,
		69,
		70,
		58,
		55,
		68,
		65,
		56,
		41,
		47,
		34,
		33,
		51,
		55,
		64,
		71,
		61,
		74,
		78,
		-1,
		172,
		192,
		171,
		174,
		198,
		212,
		-1,
		119,
		-1,
		-1,
		131,
		103,
		87,
		77,
		74,
		117,
		72,
		67,
		64,
		62,
		53,
		44,
		51,
		42,
		42,
		45,
		60,
		65,
		57,
		71,
		71,
		72,
		-1,
		161,
		172,
		165,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		147,
		-1,
		114,
		-1,
		97,
		101,
		80,
		83,
		78,
		65,
		57,
		49,
		65,
		40,
		50,
		46,
		47,
		56,
		67,
		79,
		78,
		79,
		186,
		142,
		145,
		156,
		167,
		182,
		186,
		-1,
		131,
		170,
		177,
		-1,
		156,
		-1,
		-1,
		-1,
		111,
		93,
		85,
		98,
		77,
		77,
		51,
		55,
		45,
		52,
		62,
		64,
		56,
		60,
		73,
		84,
		87,
		182,
		173,
		186,
		131,
		131,
		152,
		161,
		182,
		146,
		137,
		164,
		184,
		173,
		168,
		155,
		-1,
		-1,
		134,
		103,
		-1,
		-1,
		84,
		72,
		55,
		56,
		52,
		55,
		70,
		73,
		63,
		61,
		55,
		87,
		-1,
		175,
		174,
		163,
		160,
		136,
		127,
		122,
		149,
		-1,
		-1,
		144,
		165,
		155,
		159,
		175,
		200,
		-1,
		144,
		-1,
		-1,
		129,
		-1,
		-1,
		114,
		77,
		66,
		57,
		63,
		60,
		71,
		81,
		69,
		70,
		60,
		70,
		83,
		159,
		156,
		144,
		142,
		165,
		130,
		118,
		-1,
		131,
		129,
		135,
		142,
		159,
		189,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		62,
		67,
		87,
		89,
		78,
		72,
		66,
		73,
		72,
		80,
		88,
		168,
		182,
		171,
		167,
		166,
		174,
		123,
		116,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		76,
		80,
		84,
		76,
		69,
		64,
		75,
		67,
		71,
		88,
		-1,
		202,
		-1,
		154,
		130,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		120,
		88,
		93,
		88,
		70,
		81,
		70,
		73,
		87,
		82,
		-1,
		-1,
		142,
		145,
		-1,
		-1,
		157,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		102,
		91,
		99,
		94,
		74,
		80,
		83,
		72,
		76,
		88,
		-1,
		-1,
		149,
		150,
		155,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		115,
		78,
		99,
		109,
		103,
		101,
		92,
		78,
		85,
		83,
		79,
		90,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		102,
		-1,
		77,
		79,
		105,
		108,
		114,
		108,
		81,
		96,
		86,
		77,
		86,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		99,
		81,
		-1,
		109,
		99,
		130,
		115,
		96,
		83,
		90,
		90,
		83,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		89,
		89,
		80,
		88,
		120,
		116,
		103,
		103,
		95,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		84,
		92,
		90,
		87,
		99,
		95,
		115,
		96,
		131,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		118,
		102,
		100,
		103,
		104,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		111,
		107,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		175,
		164,
		175,
		183,
		156,
		163,
		-1,
		182,
		186,
		152,
		146,
		185,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		175,
		174,
		142,
		140,
		149,
		154,
		161,
		-1,
		160,
		-1,
		196,
		175,
		186,
		191,
		135,
		132,
		152,
		171,
		153,
		145,
		211,
		165,
		136,
		130,
		148,
		138,
		147,
		139,
		-1,
		136,
		126,
		148,
		127,
		138,
		130,
		-1,
		-1,
		130,
		131,
		137,
		123,
		129,
		125,
		-1,
		135,
		119,
		-1,
		-1,
		120,
		121,
		105,
		108,
		116,
		114,
		127,
		119,
		114,
		-1,
		-1,
		111,
		107,
		114,
		101,
		97,
		114,
		127,
		109,
		123,
		122,
		-1,
		117,
		135,
		140,
		108,
		106,
		90,
		88,
		106,
		108,
		114,
		114,
		-1,
		126,
		127,
		122,
		130,
		130,
		106,
		93,
		93,
		103,
		96,
		115,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		109,
		126,
		118,
		108,
		123,
		116,
		96,
		93,
		91,
		88,
		104,
		102,
		112,
		-1,
		-1,
		217,
		186,
		217,
		175,
		156,
		-1,
		122,
		102,
		108,
		112,
		106,
		99,
		113,
		109,
		-1,
		82,
		81,
		109,
		95,
		106,
		177,
		-1,
		-1,
		175,
		167,
		152,
		155,
		132,
		128,
		117,
		116,
		108,
		94,
		90,
		96,
		99,
		99,
		105,
		76,
		86,
		90,
		88,
		113,
		-1,
		-1,
		148,
		-1,
		-1,
		174,
		157,
		-1,
		140,
		147,
		138,
		144,
		130,
		151,
		127,
		118,
		110,
		104,
		92,
		94,
		91,
		104,
		92,
		73,
		98,
		102,
		83,
		104,
		99,
		-1,
		147,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		136,
		142,
		166,
		167,
		-1,
		139,
		127,
		128,
		113,
		110,
		97,
		85,
		98,
		83,
		90,
		89,
		77,
		75,
		105,
		80,
		102,
		99,
		118,
		123,
		117,
		126,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		170,
		-1,
		175,
		176,
		151,
		124,
		127,
		114,
		105,
		92,
		81,
		92,
		81,
		78,
		86,
		69,
		84,
		75,
		74,
		92,
		102,
		110,
		114,
		120,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		190,
		176,
		168,
		153,
		151,
		-1,
		123,
		120,
		110,
		88,
		73,
		90,
		82,
		80,
		82,
		64,
		78,
		69,
		87,
		94,
		92,
		96,
		116,
		128,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		125,
		138,
		-1,
		94,
		90,
		72,
		73,
		68,
		83,
		75,
		60,
		57,
		75,
		78,
		85,
		89,
		105,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		108,
		105,
		93,
		80,
		65,
		66,
		74,
		86,
		65,
		59,
		56,
		76,
		102,
		80,
		91,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		104,
		83,
		74,
		63,
		61,
		74,
		66,
		74,
		54,
		52,
		71,
		83,
		74,
		82,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		117,
		100,
		81,
		70,
		62,
		51,
		62,
		70,
		68,
		50,
		59,
		65,
		89,
		70,
		76,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		90,
		75,
		70,
		67,
		54,
		53,
		67,
		67,
		57,
		52,
		59,
		94,
		94,
		60,
		80,
		83,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		77,
		73,
		58,
		62,
		64,
		67,
		55,
		61,
		62,
		44,
		68,
		-1,
		68,
		62,
		70,
		60,
		48,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		70,
		65,
		64,
		63,
		60,
		49,
		62,
		55,
		49,
		43,
		56,
		60,
		61,
		50,
		46,
		43,
		57,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		92,
		76,
		75,
		72,
		63,
		71,
		44,
		37,
		48,
		33,
		51,
		57,
		48,
		43,
		42,
		53,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		82,
		99,
		100,
		78,
		72,
		70,
		61,
		49,
		38,
		41,
		33,
		55,
		52,
		36,
		38,
		47,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		96,
		94,
		89,
		80,
		86,
		81,
		58,
		53,
		43,
		32,
		32,
		27,
		46,
		32,
		30,
		50,
		66,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		97,
		81,
		86,
		-1,
		78,
		-1,
		51,
		48,
		39,
		24,
		21,
		32,
		30,
		39,
		45,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		113,
		93,
		87,
		86,
		73,
		65,
		59,
		37,
		30,
		27,
		17,
		30,
		32,
		46,
		43,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		120,
		108,
		98,
		88,
		91,
		81,
		56,
		49,
		35,
		37,
		29,
		19,
		12,
		31,
		37,
		52,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		109,
		-1,
		-1,
		92,
		83,
		73,
		52,
		39,
		46,
		41,
		26,
		12,
		0,
		31,
		47,
		52,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		160,
		105,
		94,
		89,
		93,
		91,
		-1,
		65,
		63,
		43,
		53,
		60,
		28,
		25,
		19,
		22,
		38,
		54,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		117,
		111,
		82,
		75,
		79,
		-1,
		67,
		59,
		45,
		59,
		43,
		40,
		31,
		23,
		28,
		25,
		38,
		52,
		56,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		135,
		150,
		121,
		98,
		71,
		66,
		59,
		53,
		53,
		65,
		51,
		62,
		30,
		26,
		27,
		31,
		30,
		47,
		57,
		-1,
		-1,
		155,
		156,
		161,
		143,
		147,
		148,
		-1,
		-1,
		75,
		66,
		57,
		57,
		63,
		66,
		36,
		33,
		38,
		43,
		31,
		40,
		58,
		62,
		-1,
		-1,
		-1,
		172,
		-1,
		174,
		-1,
		-1,
		162,
		146,
		93,
		75,
		71,
		69,
		62,
		60,
		48,
		41,
		51,
		61,
		53,
		33,
		53,
		68,
		65,
		94,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		151,
		143,
		138,
		144,
		146,
		137,
		108,
		105,
		-1,
		75,
		89,
		54,
		61,
		53,
		59,
		59,
		57,
		38,
		50,
		66,
		65,
		60,
		86,
		81,
		90,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		144,
		140,
		130,
		120,
		123,
		-1,
		-1,
		117,
		114,
		86,
		63,
		69,
		62,
		57,
		72,
		52,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		96,
		-1,
		182,
		228,
		221,
		189,
		197,
		228,
		-1,
		134,
		126,
		137,
		112,
		114,
		-1,
		-1,
		90,
		81,
		82,
		70,
		67,
		80,
		77,
		68,
		53,
		59,
		46,
		45,
		63,
		67,
		76,
		83,
		73,
		86,
		90,
		-1,
		184,
		204,
		183,
		186,
		210,
		224,
		-1,
		131,
		-1,
		-1,
		143,
		115,
		99,
		89,
		86,
		129,
		84,
		79,
		76,
		74,
		65,
		56,
		63,
		54,
		54,
		57,
		72,
		77,
		69,
		83,
		83,
		84,
		-1,
		173,
		184,
		177,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		159,
		-1,
		126,
		-1,
		109,
		113,
		92,
		95,
		90,
		77,
		69,
		61,
		77,
		52,
		62,
		58,
		59,
		68,
		79,
		91,
		90,
		91,
		198,
		154,
		157,
		168,
		179,
		194,
		198,
		-1,
		143,
		182,
		189,
		-1,
		168,
		-1,
		-1,
		-1,
		123,
		105,
		97,
		110,
		89,
		89,
		63,
		67,
		57,
		64,
		74,
		76,
		68,
		72,
		85,
		96,
		99,
		194,
		185,
		198,
		143,
		143,
		164,
		173,
		194,
		158,
		149,
		176,
		196,
		185,
		180,
		167,
		-1,
		-1,
		146,
		115,
		-1,
		-1,
		96,
		84,
		67,
		68,
		64,
		67,
		82,
		85,
		75,
		73,
		67,
		99,
		-1,
		187,
		186,
		175,
		172,
		148,
		139,
		134,
		161,
		-1,
		-1,
		156,
		177,
		167,
		171,
		187,
		212,
		-1,
		156,
		-1,
		-1,
		141,
		-1,
		-1,
		126,
		89,
		78,
		69,
		75,
		72,
		83,
		93,
		81,
		82,
		72,
		82,
		95,
		171,
		168,
		156,
		154,
		177,
		142,
		130,
		-1,
		143,
		141,
		147,
		154,
		171,
		201,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		124,
		122,
		111,
		-1,
		101,
		74,
		79,
		99,
		101,
		90,
		84,
		78,
		85,
		84,
		92,
		100,
		180,
		194,
		183,
		179,
		178,
		186,
		135,
		128,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		119,
		112,
		100,
		88,
		78,
		88,
		92,
		96,
		88,
		81,
		76,
		87,
		79,
		83,
		100,
		-1,
		214,
		-1,
		166,
		142,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		132,
		100,
		105,
		100,
		82,
		93,
		82,
		85,
		99,
		94,
		-1,
		-1,
		154,
		157,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		89,
		114,
		103,
		111,
		106,
		86,
		92,
		95,
		84,
		88,
		100,
		-1,
		-1,
		161,
		162,
		167,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		127,
		90,
		111,
		121,
		115,
		113,
		104,
		90,
		97,
		95,
		91,
		102,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		89,
		91,
		117,
		120,
		126,
		120,
		93,
		108,
		98,
		89,
		98,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		93,
		-1,
		121,
		111,
		142,
		127,
		108,
		95,
		102,
		102,
		95,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		100,
		132,
		128,
		115,
		115,
		107,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		104,
		102,
		99,
		111,
		107,
		127,
		108,
		143,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		114,
		112,
		115,
		116,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		123,
		119,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		189,
		178,
		189,
		197,
		170,
		177,
		-1,
		196,
		200,
		166,
		160,
		199,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		189,
		188,
		156,
		154,
		163,
		168,
		175,
		-1,
		174,
		-1,
		210,
		189,
		200,
		205,
		149,
		146,
		166,
		185,
		167,
		159,
		225,
		179,
		150,
		144,
		162,
		152,
		161,
		153,
		-1,
		150,
		140,
		162,
		141,
		152,
		144,
		-1,
		-1,
		144,
		145,
		151,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		134,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		131,
		149,
		154,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		128,
		-1,
		140,
		141,
		136,
		144,
		144,
		120,
		107,
		107,
		117,
		110,
		129,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		123,
		140,
		132,
		122,
		137,
		130,
		110,
		107,
		105,
		102,
		118,
		116,
		126,
		-1,
		-1,
		231,
		200,
		231,
		189,
		170,
		-1,
		136,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		96,
		95,
		123,
		109,
		120,
		191,
		-1,
		-1,
		189,
		181,
		166,
		169,
		146,
		142,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		90,
		100,
		104,
		102,
		127,
		-1,
		-1,
		145,
		-1,
		-1,
		188,
		171,
		-1,
		154,
		161,
		152,
		158,
		144,
		165,
		141,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		87,
		112,
		116,
		97,
		118,
		113,
		-1,
		144,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		156,
		180,
		181,
		-1,
		153,
		141,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		91,
		89,
		119,
		94,
		116,
		110,
		115,
		120,
		114,
		123,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		184,
		-1,
		189,
		190,
		165,
		138,
		141,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		83,
		98,
		89,
		88,
		99,
		99,
		107,
		111,
		117,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		204,
		190,
		182,
		167,
		165,
		-1,
		137,
		134,
		124,
		102,
		87,
		104,
		96,
		94,
		96,
		78,
		92,
		83,
		101,
		103,
		89,
		93,
		113,
		125,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		207,
		171,
		-1,
		166,
		-1,
		139,
		152,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		89,
		74,
		71,
		89,
		92,
		82,
		86,
		102,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		164,
		153,
		152,
		-1,
		143,
		122,
		119,
		107,
		94,
		79,
		80,
		88,
		100,
		79,
		73,
		70,
		90,
		99,
		77,
		88,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		118,
		97,
		88,
		77,
		75,
		88,
		80,
		88,
		68,
		66,
		85,
		80,
		71,
		79,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		161,
		147,
		152,
		127,
		120,
		114,
		131,
		114,
		95,
		84,
		76,
		65,
		76,
		84,
		82,
		64,
		73,
		79,
		86,
		67,
		73,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		152,
		165,
		-1,
		119,
		-1,
		108,
		104,
		89,
		84,
		81,
		68,
		67,
		81,
		81,
		71,
		66,
		73,
		91,
		91,
		57,
		76,
		79,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		135,
		136,
		-1,
		113,
		107,
		104,
		91,
		87,
		72,
		76,
		78,
		81,
		69,
		75,
		76,
		58,
		82,
		-1,
		65,
		59,
		66,
		56,
		45,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		120,
		113,
		-1,
		100,
		82,
		84,
		79,
		78,
		77,
		74,
		63,
		76,
		69,
		63,
		57,
		70,
		74,
		64,
		47,
		43,
		40,
		54,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		129,
		121,
		111,
		105,
		99,
		95,
		93,
		106,
		90,
		89,
		86,
		77,
		85,
		58,
		51,
		62,
		47,
		65,
		61,
		51,
		41,
		33,
		50,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		150,
		-1,
		114,
		128,
		144,
		-1,
		137,
		116,
		131,
		109,
		105,
		96,
		113,
		114,
		92,
		86,
		84,
		75,
		63,
		52,
		55,
		47,
		63,
		55,
		39,
		36,
		29,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		111,
		99,
		131,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		110,
		108,
		103,
		94,
		100,
		95,
		72,
		67,
		57,
		46,
		46,
		41,
		60,
		46,
		44,
		27,
		43,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		111,
		95,
		100,
		-1,
		92,
		-1,
		65,
		62,
		53,
		38,
		35,
		46,
		44,
		44,
		22,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		168,
		-1,
		-1,
		138,
		132,
		132,
		116,
		119,
		127,
		107,
		101,
		100,
		87,
		79,
		73,
		51,
		44,
		41,
		31,
		42,
		39,
		36,
		20,
		-1,
		-1,
		-1,
		165,
		151,
		155,
		115,
		134,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		125,
		134,
		122,
		112,
		102,
		105,
		95,
		70,
		63,
		49,
		51,
		43,
		32,
		19,
		14,
		14,
		31,
		-1,
		-1,
		148,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		147,
		163,
		155,
		126,
		123,
		-1,
		-1,
		106,
		97,
		87,
		66,
		53,
		58,
		53,
		40,
		26,
		20,
		0,
		26,
		30,
		-1,
		151,
		138,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		77,
		57,
		67,
		74,
		42,
		37,
		31,
		22,
		7,
		33,
		-1,
		-1,
		163,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		73,
		59,
		73,
		55,
		52,
		43,
		33,
		33,
		19,
		20,
		40,
		35,
		186,
		-1,
		169,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		67,
		77,
		63,
		74,
		40,
		36,
		32,
		25,
		24,
		37,
		45,
		-1,
		-1,
		169,
		166,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		67,
		77,
		80,
		46,
		43,
		48,
		42,
		35,
		33,
		47,
		48,
		-1,
		-1,
		-1,
		182,
		-1,
		184,
		-1,
		-1,
		172,
		160,
		107,
		89,
		85,
		83,
		76,
		70,
		58,
		51,
		61,
		60,
		52,
		32,
		50,
		57,
		56,
		82,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		161,
		153,
		148,
		154,
		156,
		147,
		122,
		119,
		-1,
		89,
		99,
		64,
		71,
		63,
		67,
		64,
		56,
		37,
		51,
		67,
		66,
		61,
		74,
		69,
		78,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		154,
		150,
		140,
		130,
		133,
		-1,
		-1,
		127,
		124,
		96,
		73,
		76,
		69,
		64,
		74,
		54,
		41,
		44,
		48,
		54,
		59,
		64,
		70,
		76,
		84,
		-1,
		196,
		238,
		231,
		199,
		207,
		238,
		-1,
		144,
		136,
		147,
		122,
		124,
		-1,
		-1,
		100,
		91,
		92,
		80,
		77,
		84,
		79,
		70,
		55,
		61,
		48,
		46,
		64,
		68,
		77,
		84,
		74,
		87,
		91,
		-1,
		194,
		214,
		193,
		196,
		220,
		234,
		-1,
		141,
		-1,
		-1,
		153,
		125,
		109,
		99,
		96,
		139,
		94,
		89,
		78,
		76,
		67,
		58,
		65,
		56,
		55,
		58,
		74,
		79,
		71,
		84,
		84,
		85,
		-1,
		183,
		194,
		187,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		169,
		-1,
		136,
		-1,
		119,
		123,
		102,
		105,
		92,
		79,
		71,
		63,
		79,
		54,
		63,
		59,
		61,
		70,
		81,
		93,
		91,
		92,
		208,
		164,
		167,
		178,
		189,
		204,
		208,
		-1,
		153,
		192,
		191,
		-1,
		175,
		-1,
		-1,
		-1,
		133,
		115,
		107,
		112,
		91,
		91,
		65,
		69,
		59,
		66,
		75,
		77,
		70,
		74,
		87,
		98,
		100,
		204,
		195,
		208,
		153,
		153,
		174,
		183,
		204,
		168,
		159,
		186,
		198,
		187,
		182,
		169,
		-1,
		-1,
		156,
		125,
		-1,
		-1,
		98,
		86,
		69,
		70,
		66,
		69,
		84,
		86,
		77,
		75,
		69,
		101,
		-1,
		197,
		196,
		185,
		182,
		158,
		149,
		144,
		171,
		-1,
		-1,
		166,
		187,
		177,
		181,
		197,
		222,
		-1,
		158,
		-1,
		-1,
		143,
		-1,
		-1,
		128,
		91,
		80,
		71,
		77,
		74,
		85,
		95,
		83,
		84,
		74,
		84,
		97,
		181,
		178,
		166,
		164,
		187,
		152,
		140,
		-1,
		153,
		151,
		157,
		164,
		181,
		211,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		126,
		124,
		113,
		-1,
		103,
		76,
		81,
		101,
		103,
		92,
		86,
		80,
		87,
		86,
		94,
		102,
		190,
		204,
		193,
		189,
		188,
		196,
		145,
		138,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		121,
		114,
		102,
		90,
		80,
		90,
		94,
		98,
		90,
		83,
		78,
		89,
		81,
		85,
		102,
		-1,
		224,
		-1,
		176,
		152,
		166,
		181,
		189,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		155,
		139,
		120,
		-1,
		90,
		103,
		134,
		102,
		107,
		102,
		84,
		95,
		84,
		87,
		101,
		96,
		-1,
		-1,
		164,
		167,
		-1,
		-1,
		171,
		173,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		127,
		123,
		-1,
		-1,
		91,
		116,
		105,
		113,
		108,
		88,
		94,
		97,
		86,
		90,
		102,
		-1,
		-1,
		171,
		172,
		177,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		129,
		92,
		113,
		123,
		117,
		115,
		106,
		92,
		99,
		97,
		93,
		104,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		93,
		119,
		122,
		128,
		122,
		95,
		110,
		100,
		91,
		100,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		123,
		113,
		144,
		129,
		110,
		97,
		104,
		104,
		97,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		134,
		130,
		117,
		117,
		109,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		110,
		145,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		117,
		118,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		121,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		134,
		152,
		161,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		143,
		144,
		139,
		147,
		152,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		126,
		143,
		135,
		125,
		140,
		133,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		236,
		205,
		234,
		192,
		173,
		-1,
		139,
		119,
		125,
		129,
		123,
		116,
		130,
		126,
		-1,
		105,
		104,
		132,
		118,
		129,
		196,
		-1,
		-1,
		194,
		186,
		169,
		172,
		149,
		145,
		134,
		133,
		125,
		111,
		107,
		113,
		116,
		116,
		122,
		99,
		109,
		113,
		111,
		117,
		-1,
		-1,
		131,
		-1,
		-1,
		193,
		176,
		-1,
		159,
		166,
		155,
		161,
		147,
		168,
		144,
		135,
		127,
		121,
		109,
		111,
		108,
		121,
		109,
		96,
		121,
		125,
		106,
		107,
		102,
		-1,
		130,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		152,
		155,
		161,
		185,
		184,
		-1,
		156,
		144,
		145,
		130,
		127,
		114,
		102,
		115,
		100,
		107,
		106,
		100,
		98,
		128,
		103,
		106,
		96,
		101,
		106,
		100,
		109,
		-1,
		201,
		197,
		193,
		200,
		149,
		-1,
		-1,
		189,
		-1,
		192,
		193,
		168,
		141,
		144,
		131,
		122,
		109,
		98,
		109,
		98,
		95,
		103,
		92,
		107,
		98,
		97,
		85,
		85,
		93,
		97,
		103,
		-1,
		251,
		-1,
		193,
		177,
		179,
		151,
		172,
		-1,
		209,
		193,
		185,
		170,
		170,
		-1,
		140,
		137,
		127,
		105,
		90,
		107,
		99,
		97,
		102,
		87,
		101,
		92,
		91,
		89,
		75,
		79,
		99,
		111,
		211,
		201,
		-1,
		183,
		188,
		147,
		155,
		174,
		212,
		176,
		-1,
		171,
		-1,
		142,
		155,
		-1,
		111,
		107,
		89,
		90,
		85,
		100,
		98,
		83,
		80,
		87,
		82,
		68,
		72,
		88,
		-1,
		-1,
		196,
		200,
		189,
		140,
		159,
		183,
		220,
		169,
		158,
		157,
		-1,
		148,
		125,
		122,
		110,
		97,
		82,
		83,
		91,
		104,
		83,
		82,
		79,
		78,
		85,
		63,
		74,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		166,
		137,
		161,
		203,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		121,
		100,
		91,
		80,
		78,
		91,
		88,
		97,
		77,
		75,
		73,
		66,
		57,
		65,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		166,
		152,
		157,
		132,
		125,
		119,
		134,
		117,
		98,
		87,
		79,
		68,
		84,
		92,
		91,
		73,
		82,
		67,
		72,
		53,
		59,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		77,
		75,
		84,
		90,
		80,
		75,
		82,
		77,
		77,
		43,
		62,
		65,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		81,
		85,
		82,
		89,
		78,
		84,
		85,
		67,
		91,
		-1,
		51,
		45,
		52,
		42,
		31,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		93,
		88,
		86,
		86,
		83,
		72,
		85,
		78,
		72,
		66,
		79,
		66,
		50,
		33,
		29,
		26,
		40,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		98,
		95,
		86,
		94,
		67,
		60,
		71,
		56,
		74,
		47,
		37,
		27,
		19,
		36,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		105,
		121,
		122,
		100,
		95,
		93,
		84,
		72,
		61,
		64,
		56,
		49,
		41,
		25,
		22,
		15,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		119,
		117,
		111,
		102,
		108,
		104,
		81,
		76,
		66,
		55,
		55,
		50,
		47,
		33,
		31,
		13,
		29,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		119,
		103,
		108,
		-1,
		101,
		-1,
		74,
		71,
		62,
		47,
		44,
		43,
		34,
		30,
		8,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		135,
		115,
		109,
		108,
		96,
		88,
		82,
		60,
		53,
		50,
		45,
		56,
		53,
		22,
		6,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		143,
		131,
		121,
		111,
		114,
		104,
		79,
		72,
		58,
		60,
		57,
		46,
		33,
		20,
		12,
		14,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		132,
		-1,
		-1,
		115,
		106,
		96,
		75,
		62,
		72,
		67,
		54,
		40,
		34,
		24,
		0,
		9,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		183,
		128,
		117,
		112,
		116,
		114,
		-1,
		88,
		86,
		66,
		80,
		87,
		56,
		46,
		40,
		31,
		29,
		11,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		140,
		134,
		105,
		98,
		102,
		-1,
		90,
		82,
		68,
		85,
		64,
		61,
		52,
		42,
		42,
		28,
		35,
		23,
		13,
		191,
		-1,
		174,
		-1,
		-1,
		-1,
		158,
		173,
		144,
		121,
		94,
		89,
		82,
		76,
		76,
		86,
		72,
		83,
		49,
		45,
		41,
		34,
		33,
		27,
		28,
		-1,
		-1,
		174,
		175,
		184,
		166,
		170,
		171,
		-1,
		-1,
		98,
		89,
		80,
		76,
		86,
		89,
		55,
		52,
		57,
		51,
		44,
		43,
		46,
		31,
		-1,
		-1,
		-1,
		191,
		-1,
		193,
		-1,
		-1,
		181,
		169,
		116,
		98,
		94,
		92,
		85,
		79,
		67,
		60,
		70,
		69,
		61,
		41,
		59,
		63,
		39,
		65,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		170,
		162,
		157,
		163,
		165,
		156,
		131,
		128,
		-1,
		98,
		108,
		73,
		80,
		72,
		76,
		73,
		65,
		46,
		60,
		63,
		51,
		50,
		57,
		52,
		61,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		163,
		159,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		105,
		82,
		85,
		78,
		73,
		83,
		63,
		50,
		53,
		57,
		55,
		48,
		53,
		59,
		59,
		67,
		-1,
		201,
		247,
		240,
		208,
		216,
		247,
		-1,
		153,
		145,
		156,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		93,
		88,
		79,
		64,
		70,
		57,
		55,
		73,
		69,
		66,
		73,
		62,
		75,
		79,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		150,
		-1,
		-1,
		162,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		87,
		85,
		76,
		67,
		74,
		65,
		64,
		67,
		77,
		81,
		75,
		72,
		72,
		73,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		178,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		101,
		88,
		80,
		72,
		88,
		63,
		72,
		68,
		70,
		79,
		85,
		93,
		79,
		80,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		162,
		201,
		200,
		-1,
		184,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		121,
		100,
		100,
		74,
		78,
		68,
		75,
		84,
		86,
		79,
		83,
		96,
		89,
		88,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		168,
		195,
		207,
		196,
		191,
		178,
		-1,
		-1,
		165,
		134,
		-1,
		-1,
		107,
		95,
		78,
		79,
		75,
		78,
		93,
		95,
		86,
		84,
		78,
		94,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		196,
		186,
		190,
		206,
		231,
		-1,
		167,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		100,
		89,
		80,
		86,
		83,
		94,
		104,
		92,
		93,
		83,
		93,
		106,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		90,
		110,
		112,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		99,
		103,
		107,
		99,
		92,
		87,
		98,
		90,
		94,
		110,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		143,
		111,
		116,
		111,
		93,
		104,
		93,
		96,
		103,
		105,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		180,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		125,
		114,
		122,
		117,
		97,
		103,
		106,
		95,
		99,
		103,
		-1,
		-1,
		180,
		181,
		186,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		138,
		101,
		122,
		132,
		126,
		124,
		115,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		102,
		128,
		131,
		137,
		131,
		104,
		119,
		109,
		100,
		109,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		132,
		122,
		153,
		138,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		111,
		143,
		139,
		126,
		126,
		118,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		113,
		110,
		122,
		118,
		138,
		119,
		154,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		125,
		123,
		126,
		127,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		134,
		130,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		210,
		199,
		210,
		218,
		191,
		198,
		-1,
		217,
		221,
		187,
		181,
		220,
		189,
		195,
		206,
		-1,
		-1,
		-1,
		210,
		209,
		177,
		175,
		184,
		189,
		196,
		-1,
		195,
		-1,
		231,
		210,
		221,
		226,
		170,
		167,
		187,
		206,
		188,
		180,
		246,
		200,
		171,
		165,
		183,
		173,
		182,
		174,
		-1,
		171,
		161,
		183,
		162,
		173,
		165,
		-1,
		-1,
		165,
		166,
		172,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		155,
		156,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		146,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		146,
		164,
		173,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		149,
		-1,
		155,
		156,
		151,
		159,
		164,
		141,
		128,
		128,
		138,
		131,
		150,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		138,
		155,
		147,
		137,
		152,
		145,
		131,
		128,
		126,
		123,
		139,
		137,
		147,
		-1,
		-1,
		248,
		217,
		246,
		204,
		185,
		-1,
		151,
		131,
		137,
		141,
		135,
		128,
		142,
		138,
		-1,
		117,
		116,
		144,
		130,
		141,
		208,
		-1,
		-1,
		206,
		198,
		181,
		184,
		161,
		157,
		146,
		145,
		137,
		123,
		119,
		125,
		128,
		128,
		134,
		111,
		121,
		125,
		123,
		129,
		-1,
		-1,
		143,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		167,
		173,
		159,
		180,
		156,
		147,
		139,
		133,
		121,
		123,
		120,
		133,
		121,
		108,
		133,
		137,
		118,
		119,
		114,
		-1,
		142,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		196,
		-1,
		168,
		156,
		157,
		142,
		139,
		126,
		114,
		127,
		112,
		119,
		118,
		112,
		110,
		140,
		115,
		118,
		108,
		113,
		118,
		112,
		121,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		204,
		205,
		180,
		153,
		156,
		143,
		134,
		121,
		110,
		121,
		110,
		107,
		115,
		104,
		119,
		110,
		109,
		97,
		97,
		105,
		109,
		115,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		205,
		197,
		182,
		182,
		-1,
		152,
		149,
		139,
		117,
		102,
		119,
		111,
		109,
		114,
		99,
		113,
		104,
		103,
		101,
		87,
		91,
		111,
		123,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		154,
		167,
		-1,
		123,
		119,
		101,
		102,
		97,
		112,
		110,
		95,
		92,
		99,
		94,
		80,
		84,
		100,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		137,
		134,
		122,
		109,
		94,
		95,
		103,
		116,
		95,
		94,
		91,
		90,
		97,
		75,
		86,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		90,
		103,
		100,
		109,
		89,
		87,
		85,
		78,
		69,
		77,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		146,
		129,
		110,
		99,
		91,
		80,
		96,
		104,
		103,
		85,
		94,
		79,
		84,
		65,
		71,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		89,
		87,
		96,
		102,
		92,
		87,
		94,
		89,
		89,
		55,
		74,
		77,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		93,
		97,
		94,
		101,
		90,
		96,
		97,
		79,
		103,
		-1,
		63,
		57,
		64,
		54,
		43,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		105,
		100,
		98,
		98,
		95,
		84,
		97,
		90,
		84,
		78,
		91,
		78,
		62,
		45,
		41,
		38,
		52,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		110,
		107,
		98,
		106,
		79,
		72,
		83,
		68,
		86,
		59,
		49,
		39,
		31,
		48,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		117,
		133,
		134,
		112,
		107,
		105,
		96,
		84,
		73,
		76,
		68,
		61,
		53,
		37,
		34,
		27,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		131,
		129,
		123,
		114,
		120,
		116,
		93,
		88,
		78,
		67,
		67,
		62,
		59,
		45,
		43,
		25,
		41,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		131,
		115,
		120,
		-1,
		113,
		-1,
		86,
		83,
		74,
		59,
		56,
		55,
		46,
		42,
		20,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		147,
		127,
		121,
		120,
		108,
		100,
		94,
		72,
		65,
		62,
		53,
		64,
		61,
		34,
		18,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		155,
		143,
		133,
		123,
		126,
		116,
		91,
		84,
		70,
		72,
		65,
		54,
		41,
		29,
		24,
		22,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		144,
		-1,
		-1,
		127,
		118,
		108,
		87,
		74,
		80,
		75,
		62,
		48,
		42,
		32,
		12,
		0,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		195,
		140,
		129,
		124,
		128,
		126,
		-1,
		100,
		98,
		78,
		89,
		96,
		64,
		55,
		49,
		40,
		33,
		6,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		152,
		146,
		117,
		110,
		114,
		-1,
		102,
		94,
		80,
		95,
		73,
		70,
		61,
		51,
		51,
		37,
		26,
		18,
		8,
		203,
		-1,
		186,
		-1,
		-1,
		-1,
		170,
		185,
		156,
		133,
		106,
		101,
		94,
		88,
		88,
		95,
		81,
		92,
		58,
		54,
		50,
		37,
		33,
		22,
		23,
		-1,
		-1,
		186,
		183,
		196,
		178,
		182,
		183,
		-1,
		-1,
		110,
		101,
		92,
		85,
		98,
		99,
		64,
		61,
		61,
		54,
		47,
		46,
		41,
		26,
		-1,
		-1,
		-1,
		199,
		-1,
		201,
		-1,
		-1,
		189,
		181,
		128,
		110,
		106,
		104,
		94,
		88,
		76,
		69,
		79,
		72,
		64,
		44,
		62,
		58,
		34,
		60,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		178,
		170,
		165,
		171,
		173,
		164,
		143,
		140,
		-1,
		110,
		117,
		82,
		89,
		80,
		79,
		76,
		68,
		49,
		63,
		58,
		46,
		45,
		52,
		47,
		56,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		144,
		141,
		114,
		90,
		88,
		81,
		76,
		86,
		66,
		53,
		56,
		60,
		50,
		43,
		48,
		54,
		54,
		62,
		-1,
		213,
		255,
		248,
		216,
		224,
		255,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		117,
		108,
		109,
		97,
		94,
		96,
		91,
		82,
		67,
		73,
		60,
		58,
		76,
		64,
		61,
		68,
		57,
		70,
		74,
		-1,
		211,
		231,
		210,
		213,
		237,
		251,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		113,
		156,
		111,
		106,
		90,
		88,
		79,
		70,
		77,
		68,
		67,
		70,
		72,
		76,
		70,
		67,
		67,
		68,
		-1,
		200,
		211,
		204,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		186,
		-1,
		153,
		-1,
		136,
		140,
		119,
		122,
		104,
		91,
		83,
		75,
		91,
		66,
		75,
		71,
		73,
		82,
		80,
		88,
		74,
		75,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		170,
		209,
		203,
		-1,
		187,
		-1,
		-1,
		-1,
		150,
		132,
		124,
		124,
		103,
		103,
		77,
		81,
		71,
		78,
		87,
		89,
		82,
		86,
		96,
		84,
		83,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		185,
		176,
		203,
		210,
		199,
		194,
		181,
		-1,
		-1,
		173,
		142,
		-1,
		-1,
		110,
		98,
		81,
		82,
		78,
		81,
		96,
		98,
		89,
		87,
		81,
		89,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		204,
		194,
		198,
		214,
		239,
		-1,
		170,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		103,
		92,
		83,
		89,
		86,
		97,
		107,
		95,
		96,
		86,
		96,
		103,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		186,
		166,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		88,
		93,
		113,
		115,
		104,
		98,
		92,
		99,
		98,
		106,
		108,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		172,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		102,
		106,
		110,
		102,
		95,
		90,
		101,
		93,
		97,
		105,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		146,
		114,
		119,
		114,
		96,
		107,
		96,
		99,
		98,
		101,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		183,
		185,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		103,
		128,
		117,
		125,
		120,
		100,
		106,
		109,
		98,
		102,
		98,
		-1,
		-1,
		188,
		189,
		190,
		-1,
		168,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		141,
		104,
		125,
		135,
		129,
		127,
		118,
		104,
		111,
		109,
		105,
		108,
		-1,
		-1,
		-1,
		186,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		103,
		105,
		131,
		134,
		140,
		134,
		107,
		122,
		112,
		103,
		112,
		192,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		156,
		141,
		122,
		109,
		116,
		116,
		109,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		146,
		142,
		129,
		129,
		121,
		-1,
		265,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		125,
		121,
		141,
		122,
		157,
		-1,
		260,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		128,
		126,
		129,
		130,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		137,
		133,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		201,
		203,
		169,
		163,
		202,
		173,
		179,
		190,
		-1,
		-1,
		-1,
		192,
		191,
		161,
		159,
		168,
		173,
		180,
		-1,
		203,
		-1,
		213,
		192,
		203,
		208,
		154,
		151,
		171,
		190,
		196,
		188,
		228,
		184,
		155,
		149,
		167,
		172,
		190,
		182,
		-1,
		155,
		145,
		167,
		171,
		183,
		166,
		-1,
		-1,
		149,
		150,
		156,
		168,
		173,
		178,
		-1,
		204,
		188,
		-1,
		-1,
		139,
		152,
		148,
		151,
		159,
		175,
		196,
		188,
		183,
		-1,
		-1,
		140,
		144,
		157,
		158,
		156,
		183,
		196,
		178,
		192,
		191,
		-1,
		128,
		146,
		155,
		164,
		170,
		159,
		157,
		175,
		177,
		183,
		186,
		-1,
		120,
		122,
		151,
		157,
		169,
		175,
		162,
		162,
		172,
		165,
		184,
		175,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		125,
		151,
		150,
		146,
		164,
		172,
		165,
		162,
		160,
		157,
		173,
		174,
		184,
		-1,
		-1,
		173,
		142,
		177,
		134,
		119,
		-1,
		113,
		132,
		138,
		142,
		147,
		155,
		169,
		165,
		-1,
		151,
		150,
		181,
		167,
		178,
		133,
		-1,
		-1,
		131,
		123,
		108,
		111,
		108,
		108,
		138,
		137,
		142,
		144,
		146,
		152,
		155,
		155,
		161,
		145,
		155,
		159,
		170,
		185,
		-1,
		-1,
		240,
		-1,
		-1,
		130,
		113,
		-1,
		96,
		103,
		103,
		120,
		110,
		131,
		146,
		150,
		158,
		160,
		148,
		150,
		147,
		160,
		148,
		142,
		167,
		171,
		165,
		186,
		181,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		89,
		92,
		98,
		122,
		132,
		-1,
		153,
		151,
		175,
		169,
		166,
		153,
		141,
		154,
		139,
		146,
		145,
		149,
		151,
		184,
		162,
		184,
		181,
		210,
		215,
		209,
		218,
		-1,
		138,
		134,
		130,
		137,
		86,
		-1,
		-1,
		126,
		-1,
		140,
		153,
		160,
		155,
		158,
		170,
		161,
		148,
		137,
		148,
		137,
		134,
		142,
		151,
		162,
		157,
		156,
		174,
		189,
		202,
		206,
		212,
		-1,
		188,
		-1,
		130,
		114,
		116,
		88,
		109,
		-1,
		146,
		141,
		161,
		162,
		153,
		-1,
		156,
		159,
		166,
		144,
		129,
		146,
		138,
		136,
		141,
		146,
		160,
		151,
		169,
		176,
		184,
		188,
		208,
		220,
		148,
		138,
		-1,
		120,
		125,
		84,
		92,
		111,
		184,
		159,
		-1,
		154,
		-1,
		146,
		171,
		-1,
		150,
		146,
		128,
		129,
		124,
		139,
		145,
		142,
		139,
		157,
		160,
		177,
		181,
		197,
		-1,
		-1,
		133,
		137,
		126,
		77,
		96,
		120,
		157,
		152,
		141,
		140,
		-1,
		131,
		161,
		158,
		144,
		131,
		121,
		122,
		130,
		143,
		122,
		141,
		144,
		166,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		103,
		74,
		98,
		140,
		170,
		163,
		151,
		116,
		116,
		110,
		-1,
		151,
		134,
		130,
		119,
		117,
		130,
		125,
		141,
		145,
		144,
		163,
		175,
		166,
		186,
		-1,
		-1,
		-1,
		133,
		122,
		123,
		72,
		95,
		129,
		149,
		135,
		140,
		115,
		108,
		102,
		154,
		151,
		118,
		126,
		118,
		107,
		121,
		129,
		133,
		142,
		151,
		157,
		181,
		181,
		187,
		-1,
		-1,
		140,
		130,
		114,
		116,
		113,
		86,
		93,
		125,
		140,
		137,
		-1,
		107,
		-1,
		96,
		104,
		103,
		109,
		121,
		107,
		112,
		123,
		135,
		148,
		144,
		151,
		186,
		186,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		133,
		131,
		106,
		83,
		67,
		103,
		-1,
		107,
		108,
		-1,
		101,
		95,
		101,
		100,
		107,
		104,
		104,
		118,
		126,
		122,
		138,
		144,
		136,
		172,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		129,
		108,
		101,
		121,
		62,
		114,
		-1,
		-1,
		92,
		85,
		-1,
		88,
		88,
		95,
		104,
		109,
		114,
		122,
		117,
		130,
		135,
		141,
		146,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		82,
		-1,
		95,
		87,
		83,
		77,
		83,
		101,
		99,
		119,
		111,
		125,
		125,
		131,
		139,
		124,
		127,
		143,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		149,
		135,
		106,
		-1,
		-1,
		95,
		-1,
		59,
		73,
		89,
		-1,
		117,
		96,
		119,
		97,
		111,
		107,
		145,
		146,
		124,
		129,
		137,
		147,
		149,
		138,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		155,
		142,
		100,
		96,
		85,
		105,
		56,
		65,
		76,
		-1,
		-1,
		161,
		-1,
		95,
		112,
		121,
		119,
		135,
		126,
		132,
		148,
		151,
		153,
		143,
		132,
		138,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		71,
		58,
		52,
		-1,
		93,
		-1,
		139,
		129,
		113,
		98,
		131,
		-1,
		143,
		127,
		132,
		-1,
		178,
		-1,
		151,
		153,
		147,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		105,
		90,
		83,
		73,
		87,
		58,
		-1,
		101,
		-1,
		-1,
		126,
		120,
		120,
		104,
		107,
		159,
		139,
		133,
		132,
		173,
		173,
		159,
		145,
		138,
		135,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		110,
		34,
		42,
		46,
		67,
		-1,
		-1,
		188,
		143,
		129,
		-1,
		113,
		176,
		164,
		154,
		144,
		178,
		179,
		164,
		157,
		143,
		145,
		143,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		31,
		44,
		53,
		60,
		79,
		-1,
		-1,
		-1,
		135,
		151,
		143,
		114,
		165,
		-1,
		-1,
		156,
		154,
		164,
		160,
		147,
		167,
		170,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		0,
		9,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		146,
		167,
		192,
		159,
		-1,
		164,
		165,
		151,
		165,
		172,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		96,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		125,
		139,
		160,
		166,
		178,
		-1,
		173,
		167,
		153,
		170,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		119,
		-1,
		102,
		-1,
		-1,
		-1,
		143,
		158,
		220,
		197,
		170,
		174,
		167,
		161,
		161,
		177,
		179,
		190,
		158,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		102,
		119,
		154,
		151,
		155,
		247,
		-1,
		-1,
		183,
		174,
		165,
		168,
		171,
		174,
		164,
		161,
		166,
		171,
		159,
		168,
		186,
		190,
		-1,
		-1,
		-1,
		122,
		-1,
		137,
		-1,
		-1,
		170,
		254,
		201,
		183,
		179,
		177,
		170,
		179,
		174,
		169,
		179,
		188,
		180,
		161,
		172,
		195,
		184,
		222,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		151,
		126,
		141,
		187,
		190,
		183,
		216,
		213,
		-1,
		183,
		208,
		180,
		187,
		179,
		187,
		187,
		184,
		162,
		169,
		185,
		184,
		179,
		214,
		206,
		212,
		-1,
		-1,
		214,
		203,
		192,
		198,
		-1,
		157,
		143,
		173,
		163,
		169,
		-1,
		-1,
		216,
		213,
		205,
		189,
		193,
		186,
		181,
		191,
		171,
		158,
		162,
		166,
		172,
		177,
		182,
		188,
		203,
		218,
		-1,
		109,
		190,
		183,
		166,
		174,
		205,
		-1,
		160,
		169,
		150,
		155,
		163,
		-1,
		-1,
		189,
		185,
		190,
		196,
		193,
		201,
		196,
		187,
		172,
		178,
		165,
		164,
		182,
		186,
		195,
		202,
		192,
		205,
		209,
		-1,
		123,
		166,
		160,
		163,
		187,
		201,
		-1,
		173,
		-1,
		-1,
		158,
		176,
		184,
		180,
		184,
		237,
		210,
		205,
		195,
		193,
		184,
		175,
		182,
		173,
		173,
		176,
		191,
		196,
		188,
		202,
		202,
		203,
		-1,
		158,
		146,
		154,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		174,
		-1,
		210,
		-1,
		203,
		207,
		218,
		221,
		209,
		196,
		188,
		180,
		196,
		171,
		181,
		177,
		178,
		187,
		198,
		210,
		209,
		210,
		232,
		187,
		154,
		145,
		192,
		207,
		211,
		-1,
		186,
		225,
		212,
		-1,
		183,
		-1,
		-1,
		-1,
		217,
		231,
		223,
		229,
		208,
		208,
		182,
		186,
		176,
		183,
		193,
		195,
		187,
		191,
		204,
		215,
		218,
		228,
		226,
		231,
		176,
		159,
		177,
		186,
		207,
		201,
		192,
		219,
		219,
		208,
		203,
		190,
		-1,
		-1,
		240,
		241,
		-1,
		-1,
		215,
		203,
		186,
		187,
		183,
		186,
		201,
		204,
		194,
		192,
		186,
		218,
		-1,
		228,
		227,
		216,
		213,
		189,
		180,
		167,
		178,
		-1,
		-1,
		204,
		220,
		232,
		236,
		250,
		275,
		-1,
		193,
		-1,
		-1,
		260,
		-1,
		-1,
		245,
		208,
		197,
		188,
		194,
		191,
		202,
		212,
		200,
		201,
		191,
		201,
		214,
		212,
		209,
		197,
		195,
		218,
		175,
		171,
		-1,
		203,
		206,
		212,
		219,
		236,
		264,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		243,
		241,
		230,
		-1,
		220,
		193,
		198,
		218,
		220,
		209,
		203,
		197,
		204,
		203,
		211,
		219,
		221,
		235,
		224,
		220,
		219,
		227,
		176,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		219,
		-1,
		-1,
		238,
		231,
		219,
		207,
		197,
		207,
		211,
		215,
		207,
		200,
		195,
		206,
		198,
		202,
		219,
		-1,
		255,
		-1,
		207,
		200,
		215,
		230,
		238,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		272,
		256,
		237,
		-1,
		207,
		220,
		251,
		219,
		224,
		219,
		201,
		212,
		201,
		204,
		218,
		213,
		-1,
		-1,
		213,
		216,
		-1,
		-1,
		238,
		257,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		244,
		240,
		-1,
		-1,
		208,
		233,
		222,
		230,
		225,
		205,
		211,
		214,
		203,
		207,
		219,
		-1,
		-1,
		220,
		221,
		226,
		-1,
		247,
		-1,
		276,
		-1,
		221,
		237,
		239,
		-1,
		-1,
		-1,
		246,
		209,
		230,
		240,
		234,
		232,
		223,
		209,
		216,
		214,
		210,
		221,
		-1,
		-1,
		-1,
		277,
		254,
		283,
		274,
		257,
		237,
		229,
		254,
		-1,
		233,
		-1,
		208,
		210,
		236,
		239,
		245,
		239,
		212,
		227,
		217,
		208,
		217,
		283,
		-1,
		258,
		300,
		264,
		243,
		234,
		238,
		254,
		-1,
		230,
		212,
		-1,
		240,
		230,
		261,
		246,
		227,
		214,
		221,
		221,
		214,
		-1,
		-1,
		-1,
		269,
		268,
		260,
		254,
		254,
		239,
		230,
		-1,
		242,
		224,
		203,
		220,
		220,
		211,
		219,
		251,
		247,
		234,
		234,
		226,
		-1,
		327,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		263,
		258,
		231,
		219,
		225,
		221,
		207,
		213,
		215,
		223,
		221,
		218,
		230,
		226,
		246,
		227,
		262,
		-1,
		334,
		-1,
		299,
		-1,
		-1,
		281,
		261,
		253,
		242,
		231,
		229,
		220,
		211,
		233,
		249,
		233,
		231,
		234,
		235,
		-1,
		344,
		345,
		-1,
		300,
		292,
		278,
		-1,
		271,
		-1,
		277,
		238,
		-1,
		240,
		220,
		-1,
		242,
		238,
		-1,
		-1,
		341,
		316,
		-1,
		-1,
		-1,
		301,
		281,
		272,
		256,
		-1,
		231,
		231,
		-1,
		-1,
		-1,
		326,
		325,
		-1,
		294,
		297,
		-1,
		287,
		278,
		286,
		233,
		237,
		-1,
		-1,
		-1,
		335,
		316,
		310,
		309,
		307,
		302,
		299,
		285,
		269,
		247,
		236,
		257,
		-1,
		-1,
		-1,
		307,
		299,
		292,
		-1,
		-1,
		294,
		277,
		258,
		256,
		-1,
		-1,
		-1,
		329,
		310,
		-1,
		-1,
		284,
		-1,
		-1,
		290,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		346,
		318,
		-1,
		-1,
		-1,
		280,
		276,
		277,
		-1,
		-1,
		-1,
		-1,
		340,
		341,
		364,
		328,
		-1,
		-1,
		-1,
		272,
		266,
		-1,
		-1,
		343,
		341,
		-1,
		-1,
		-1,
		300,
		284,
		-1,
		270,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		305,
		-1,
		305,
		280,
		287,
		-1,
		-1,
		-1,
		-1,
		318,
		310,
		318,
		-1,
		290,
		292,
		-1,
		340,
		-1,
		-1,
		333,
		324,
		-1,
		-1,
		295,
		302,
		324,
		327,
		363,
		-1,
		314
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		192,
		194,
		160,
		154,
		193,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		183,
		182,
		152,
		150,
		159,
		164,
		171,
		-1,
		194,
		-1,
		204,
		183,
		194,
		199,
		145,
		142,
		162,
		181,
		187,
		179,
		219,
		175,
		146,
		140,
		158,
		163,
		181,
		173,
		-1,
		146,
		136,
		158,
		162,
		174,
		157,
		-1,
		-1,
		140,
		141,
		147,
		159,
		164,
		169,
		-1,
		195,
		179,
		-1,
		-1,
		130,
		143,
		139,
		142,
		150,
		166,
		187,
		179,
		174,
		-1,
		-1,
		131,
		135,
		148,
		149,
		147,
		174,
		187,
		169,
		183,
		182,
		-1,
		119,
		137,
		146,
		155,
		161,
		150,
		148,
		166,
		168,
		174,
		177,
		-1,
		111,
		113,
		142,
		148,
		160,
		166,
		153,
		153,
		163,
		156,
		175,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		116,
		142,
		141,
		137,
		155,
		163,
		156,
		153,
		151,
		148,
		164,
		165,
		175,
		-1,
		-1,
		164,
		133,
		168,
		125,
		110,
		-1,
		104,
		123,
		129,
		133,
		138,
		146,
		160,
		156,
		-1,
		142,
		141,
		172,
		158,
		169,
		124,
		-1,
		-1,
		122,
		114,
		99,
		102,
		99,
		99,
		129,
		128,
		133,
		135,
		137,
		143,
		146,
		146,
		152,
		136,
		146,
		150,
		161,
		176,
		-1,
		-1,
		231,
		-1,
		-1,
		121,
		104,
		-1,
		87,
		94,
		94,
		111,
		101,
		122,
		137,
		141,
		149,
		151,
		139,
		141,
		138,
		151,
		139,
		133,
		158,
		162,
		156,
		177,
		172,
		-1,
		230,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		80,
		83,
		89,
		113,
		123,
		-1,
		144,
		142,
		166,
		160,
		157,
		144,
		132,
		145,
		130,
		137,
		136,
		140,
		142,
		175,
		153,
		175,
		172,
		201,
		206,
		200,
		209,
		-1,
		129,
		125,
		121,
		128,
		77,
		-1,
		-1,
		117,
		-1,
		131,
		144,
		151,
		146,
		149,
		161,
		152,
		139,
		128,
		139,
		128,
		125,
		133,
		142,
		153,
		148,
		147,
		165,
		180,
		193,
		197,
		203,
		-1,
		179,
		-1,
		121,
		105,
		107,
		79,
		100,
		-1,
		137,
		132,
		152,
		153,
		144,
		-1,
		147,
		150,
		157,
		135,
		120,
		137,
		129,
		127,
		132,
		137,
		151,
		142,
		160,
		167,
		175,
		179,
		199,
		211,
		139,
		129,
		-1,
		111,
		116,
		75,
		83,
		102,
		175,
		150,
		-1,
		145,
		-1,
		137,
		162,
		-1,
		141,
		137,
		119,
		120,
		115,
		130,
		136,
		133,
		130,
		148,
		151,
		168,
		172,
		188,
		-1,
		-1,
		124,
		128,
		117,
		68,
		87,
		111,
		148,
		143,
		132,
		131,
		-1,
		122,
		152,
		149,
		135,
		122,
		112,
		113,
		121,
		134,
		113,
		132,
		135,
		157,
		185,
		163,
		175,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		94,
		65,
		89,
		131,
		161,
		154,
		142,
		107,
		107,
		101,
		-1,
		142,
		125,
		121,
		110,
		108,
		121,
		116,
		132,
		136,
		135,
		154,
		166,
		157,
		177,
		-1,
		-1,
		-1,
		124,
		113,
		114,
		63,
		86,
		120,
		140,
		126,
		131,
		106,
		99,
		93,
		145,
		142,
		109,
		117,
		109,
		98,
		112,
		120,
		124,
		133,
		142,
		148,
		172,
		172,
		178,
		-1,
		-1,
		131,
		121,
		105,
		107,
		104,
		77,
		84,
		116,
		131,
		128,
		-1,
		98,
		-1,
		87,
		95,
		94,
		100,
		112,
		98,
		103,
		114,
		126,
		139,
		135,
		142,
		177,
		177,
		162,
		182,
		185,
		-1,
		-1,
		-1,
		124,
		122,
		97,
		74,
		58,
		94,
		-1,
		98,
		99,
		-1,
		92,
		86,
		92,
		91,
		98,
		95,
		95,
		109,
		117,
		113,
		129,
		135,
		127,
		163,
		-1,
		170,
		164,
		172,
		162,
		150,
		-1,
		-1,
		-1,
		120,
		99,
		92,
		112,
		53,
		105,
		-1,
		-1,
		83,
		76,
		-1,
		79,
		79,
		86,
		95,
		100,
		105,
		113,
		108,
		121,
		126,
		132,
		137,
		155,
		159,
		163,
		152,
		148,
		145,
		159,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		53,
		73,
		-1,
		86,
		78,
		74,
		68,
		74,
		92,
		90,
		110,
		102,
		116,
		116,
		122,
		130,
		115,
		118,
		134,
		132,
		150,
		158,
		150,
		144,
		143,
		155,
		-1,
		140,
		126,
		97,
		-1,
		-1,
		86,
		-1,
		50,
		64,
		80,
		-1,
		108,
		87,
		110,
		88,
		102,
		98,
		136,
		137,
		115,
		120,
		128,
		138,
		140,
		129,
		140,
		132,
		154,
		154,
		138,
		139,
		148,
		-1,
		146,
		133,
		91,
		87,
		76,
		96,
		47,
		56,
		67,
		-1,
		-1,
		152,
		-1,
		86,
		103,
		112,
		110,
		126,
		117,
		123,
		139,
		142,
		144,
		134,
		123,
		129,
		126,
		148,
		134,
		132,
		151,
		167,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		62,
		49,
		43,
		-1,
		84,
		-1,
		130,
		120,
		104,
		89,
		122,
		-1,
		134,
		118,
		123,
		-1,
		169,
		-1,
		142,
		144,
		138,
		123,
		120,
		131,
		129,
		140,
		157,
		-1,
		96,
		81,
		74,
		64,
		78,
		49,
		-1,
		92,
		-1,
		-1,
		117,
		111,
		111,
		95,
		98,
		150,
		130,
		124,
		123,
		164,
		164,
		150,
		136,
		129,
		126,
		123,
		136,
		156,
		147,
		159,
		-1,
		-1,
		-1,
		101,
		25,
		33,
		37,
		58,
		-1,
		-1,
		179,
		134,
		120,
		-1,
		104,
		167,
		155,
		145,
		135,
		169,
		170,
		155,
		148,
		134,
		136,
		134,
		132,
		137,
		158,
		159,
		172,
		-1,
		-1,
		22,
		35,
		44,
		51,
		70,
		-1,
		-1,
		-1,
		126,
		142,
		134,
		105,
		156,
		-1,
		-1,
		147,
		145,
		155,
		151,
		138,
		158,
		161,
		147,
		131,
		146,
		158,
		166,
		171,
		-1,
		13,
		0,
		-1,
		-1,
		73,
		67,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		137,
		158,
		183,
		150,
		-1,
		155,
		156,
		142,
		156,
		163,
		149,
		144,
		138,
		141,
		159,
		176,
		-1,
		-1,
		87,
		-1,
		82,
		-1,
		-1,
		-1,
		-1,
		116,
		130,
		151,
		157,
		169,
		-1,
		164,
		158,
		144,
		161,
		162,
		159,
		150,
		142,
		147,
		144,
		157,
		171,
		175,
		110,
		-1,
		93,
		-1,
		-1,
		-1,
		134,
		149,
		211,
		188,
		161,
		165,
		158,
		152,
		152,
		168,
		170,
		181,
		149,
		145,
		146,
		150,
		149,
		166,
		176,
		-1,
		-1,
		93,
		110,
		145,
		142,
		146,
		238,
		-1,
		-1,
		174,
		165,
		156,
		159,
		162,
		165,
		155,
		152,
		157,
		162,
		150,
		159,
		177,
		181,
		-1,
		-1,
		-1,
		113,
		-1,
		128,
		-1,
		-1,
		161,
		245,
		192,
		174,
		170,
		168,
		161,
		170,
		165,
		160,
		170,
		179,
		171,
		152,
		163,
		186,
		175,
		213,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		142,
		117,
		132,
		178,
		181,
		174,
		207,
		204,
		-1,
		174,
		199,
		171,
		178,
		170,
		178,
		178,
		175,
		153,
		160,
		176,
		175,
		170,
		205,
		197,
		203,
		-1,
		-1,
		205,
		194,
		183,
		189,
		-1,
		148,
		134,
		164,
		154,
		160,
		-1,
		-1,
		207,
		204,
		196,
		180,
		184,
		177,
		172,
		182,
		162,
		149,
		153,
		157,
		163,
		168,
		173,
		179,
		194,
		209,
		-1,
		100,
		181,
		174,
		157,
		165,
		196,
		-1,
		151,
		160,
		141,
		146,
		154,
		-1,
		-1,
		180,
		176,
		181,
		187,
		184,
		192,
		187,
		178,
		163,
		169,
		156,
		155,
		173,
		177,
		186,
		193,
		183,
		196,
		200,
		-1,
		114,
		157,
		151,
		154,
		178,
		192,
		-1,
		164,
		-1,
		-1,
		149,
		167,
		175,
		171,
		175,
		228,
		201,
		196,
		186,
		184,
		175,
		166,
		173,
		164,
		164,
		167,
		182,
		187,
		179,
		193,
		193,
		194,
		-1,
		149,
		137,
		145,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		165,
		-1,
		201,
		-1,
		194,
		198,
		209,
		212,
		200,
		187,
		179,
		171,
		187,
		162,
		172,
		168,
		169,
		178,
		189,
		201,
		200,
		201,
		223,
		178,
		145,
		136,
		183,
		198,
		202,
		-1,
		177,
		216,
		203,
		-1,
		174,
		-1,
		-1,
		-1,
		208,
		222,
		214,
		220,
		199,
		199,
		173,
		177,
		167,
		174,
		184,
		186,
		178,
		182,
		195,
		206,
		209,
		219,
		217,
		222,
		167,
		150,
		168,
		177,
		198,
		192,
		183,
		210,
		210,
		199,
		194,
		181,
		-1,
		-1,
		231,
		232,
		-1,
		-1,
		206,
		194,
		177,
		178,
		174,
		177,
		192,
		195,
		185,
		183,
		177,
		209,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		158,
		169,
		-1,
		-1,
		195,
		211,
		223,
		227,
		241,
		266,
		-1,
		184,
		-1,
		-1,
		251,
		-1,
		-1,
		236,
		199,
		188,
		179,
		185,
		182,
		193,
		203,
		191,
		192,
		182,
		192,
		205,
		203,
		200,
		188,
		186,
		209,
		166,
		162,
		-1,
		194,
		197,
		203,
		210,
		227,
		255,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		234,
		232,
		221,
		-1,
		211,
		184,
		189,
		209,
		211,
		200,
		194,
		188,
		195,
		194,
		202,
		210,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		210,
		-1,
		-1,
		229,
		222,
		210,
		198,
		188,
		198,
		202,
		206,
		198,
		191,
		186,
		197,
		189,
		193,
		210,
		-1,
		246,
		-1,
		198,
		191,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		263,
		247,
		228,
		-1,
		198,
		211,
		242,
		210,
		215,
		210,
		192,
		203,
		192,
		195,
		209,
		204,
		-1,
		-1,
		204,
		207,
		-1,
		-1,
		229,
		248,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		235,
		231,
		-1,
		-1,
		199,
		224,
		213,
		221,
		216,
		196,
		202,
		205,
		194,
		198,
		210,
		-1,
		-1,
		211,
		212,
		217,
		-1,
		238,
		-1,
		267,
		-1,
		212,
		228,
		230,
		-1,
		-1,
		-1,
		237,
		200,
		221,
		231,
		225,
		223,
		214,
		200,
		207,
		205,
		201,
		212,
		-1,
		-1,
		-1,
		268,
		245,
		274,
		265,
		248,
		228,
		220,
		245,
		-1,
		224,
		-1,
		199,
		201,
		227,
		230,
		236,
		230,
		203,
		218,
		208,
		199,
		208,
		274,
		-1,
		249,
		291,
		255,
		234,
		225,
		229,
		245,
		-1,
		221,
		203,
		-1,
		231,
		221,
		252,
		237,
		218,
		205,
		212,
		212,
		205,
		-1,
		-1,
		-1,
		260,
		259,
		251,
		245,
		245,
		230,
		221,
		-1,
		233,
		215,
		194,
		211,
		211,
		202,
		210,
		242,
		238,
		225,
		225,
		217,
		-1,
		318,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		254,
		249,
		222,
		210,
		216,
		212,
		198,
		204,
		206,
		214,
		212,
		209,
		221,
		217,
		237,
		218,
		253,
		-1,
		325,
		-1,
		290,
		-1,
		-1,
		272,
		252,
		244,
		233,
		222,
		220,
		211,
		202,
		224,
		240,
		224,
		222,
		225,
		226,
		-1,
		335,
		336,
		-1,
		291,
		283,
		269,
		-1,
		262,
		-1,
		268,
		229,
		-1,
		231,
		211,
		-1,
		233,
		229,
		-1,
		-1,
		332,
		307,
		-1,
		-1,
		-1,
		292,
		272,
		263,
		247,
		-1,
		222,
		222,
		-1,
		-1,
		-1,
		317,
		316,
		-1,
		285,
		288,
		-1,
		278,
		269,
		277,
		224,
		228,
		-1,
		-1,
		-1,
		326,
		307,
		301,
		300,
		298,
		293,
		290,
		276,
		260,
		238,
		227,
		248,
		-1,
		-1,
		-1,
		298,
		290,
		283,
		-1,
		-1,
		285,
		268,
		249,
		247,
		-1,
		-1,
		-1,
		320,
		301,
		-1,
		-1,
		275,
		-1,
		-1,
		281,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		337,
		309,
		-1,
		-1,
		-1,
		271,
		267,
		268,
		-1,
		-1,
		-1,
		-1,
		331,
		332,
		355,
		319,
		-1,
		-1,
		-1,
		263,
		257,
		-1,
		-1,
		334,
		332,
		-1,
		-1,
		-1,
		291,
		275,
		-1,
		261,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		296,
		-1,
		296,
		271,
		278,
		-1,
		-1,
		-1,
		-1,
		309,
		301,
		309,
		-1,
		281,
		283,
		-1,
		331,
		-1,
		-1,
		324,
		315,
		-1,
		-1,
		286,
		293,
		315,
		318,
		354,
		-1,
		305
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		199,
		201,
		167,
		161,
		200,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		190,
		189,
		159,
		157,
		166,
		171,
		178,
		-1,
		201,
		-1,
		211,
		190,
		201,
		206,
		152,
		149,
		169,
		188,
		194,
		186,
		226,
		182,
		153,
		147,
		165,
		170,
		188,
		180,
		-1,
		153,
		143,
		165,
		169,
		181,
		164,
		-1,
		-1,
		147,
		148,
		154,
		166,
		171,
		176,
		-1,
		199,
		183,
		-1,
		-1,
		137,
		150,
		146,
		149,
		157,
		173,
		191,
		183,
		178,
		-1,
		-1,
		138,
		142,
		155,
		156,
		154,
		178,
		191,
		173,
		187,
		186,
		-1,
		126,
		144,
		153,
		162,
		168,
		154,
		152,
		170,
		172,
		178,
		181,
		-1,
		118,
		120,
		149,
		155,
		167,
		170,
		157,
		157,
		167,
		160,
		179,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		123,
		149,
		148,
		144,
		162,
		167,
		160,
		157,
		155,
		152,
		168,
		169,
		179,
		-1,
		-1,
		171,
		140,
		175,
		132,
		117,
		-1,
		111,
		130,
		136,
		140,
		145,
		150,
		164,
		160,
		-1,
		146,
		145,
		176,
		162,
		173,
		131,
		-1,
		-1,
		129,
		121,
		106,
		109,
		106,
		106,
		136,
		135,
		140,
		142,
		141,
		147,
		150,
		150,
		156,
		140,
		150,
		154,
		165,
		180,
		-1,
		-1,
		235,
		-1,
		-1,
		128,
		111,
		-1,
		94,
		101,
		101,
		118,
		108,
		129,
		144,
		148,
		156,
		155,
		143,
		145,
		142,
		155,
		143,
		137,
		162,
		166,
		160,
		181,
		176,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		87,
		90,
		96,
		120,
		130,
		-1,
		151,
		149,
		173,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		144,
		146,
		179,
		157,
		179,
		176,
		205,
		210,
		204,
		213,
		-1,
		136,
		132,
		128,
		135,
		84,
		-1,
		-1,
		124,
		-1,
		138,
		151,
		155,
		153,
		156,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		146,
		157,
		152,
		151,
		169,
		184,
		197,
		201,
		207,
		-1,
		186,
		-1,
		128,
		112,
		114,
		86,
		107,
		-1,
		144,
		139,
		159,
		157,
		148,
		-1,
		151,
		154,
		161,
		139,
		124,
		141,
		133,
		131,
		136,
		141,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		146,
		136,
		-1,
		118,
		123,
		82,
		90,
		109,
		182,
		154,
		-1,
		149,
		-1,
		141,
		166,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		140,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		131,
		135,
		124,
		75,
		94,
		118,
		155,
		147,
		136,
		135,
		-1,
		126,
		156,
		153,
		139,
		126,
		116,
		117,
		125,
		138,
		117,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		101,
		72,
		96,
		138,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		146,
		129,
		125,
		114,
		112,
		125,
		120,
		136,
		140,
		139,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		131,
		120,
		121,
		67,
		90,
		127,
		144,
		130,
		135,
		110,
		103,
		97,
		149,
		146,
		113,
		121,
		113,
		102,
		116,
		124,
		128,
		137,
		146,
		152,
		176,
		176,
		182,
		-1,
		-1,
		138,
		128,
		112,
		114,
		111,
		81,
		88,
		120,
		135,
		132,
		-1,
		102,
		-1,
		91,
		99,
		98,
		104,
		116,
		102,
		107,
		118,
		130,
		143,
		139,
		146,
		181,
		181,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		131,
		126,
		101,
		78,
		62,
		98,
		-1,
		102,
		103,
		-1,
		96,
		90,
		96,
		95,
		102,
		99,
		99,
		113,
		121,
		117,
		133,
		139,
		131,
		167,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		124,
		103,
		96,
		116,
		57,
		109,
		-1,
		-1,
		87,
		80,
		-1,
		83,
		83,
		90,
		99,
		104,
		109,
		117,
		112,
		125,
		130,
		136,
		141,
		159,
		163,
		167,
		156,
		152,
		149,
		163,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		77,
		-1,
		95,
		87,
		78,
		72,
		78,
		96,
		94,
		114,
		106,
		120,
		120,
		126,
		134,
		119,
		122,
		138,
		136,
		154,
		162,
		154,
		148,
		147,
		159,
		-1,
		144,
		130,
		101,
		-1,
		-1,
		90,
		-1,
		54,
		73,
		89,
		-1,
		112,
		91,
		114,
		92,
		106,
		102,
		140,
		141,
		119,
		124,
		132,
		142,
		144,
		133,
		144,
		136,
		158,
		158,
		142,
		143,
		152,
		-1,
		150,
		137,
		95,
		91,
		80,
		100,
		51,
		60,
		76,
		-1,
		-1,
		156,
		-1,
		90,
		107,
		116,
		114,
		130,
		121,
		127,
		143,
		146,
		148,
		138,
		127,
		133,
		130,
		152,
		138,
		136,
		155,
		171,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		66,
		53,
		47,
		-1,
		93,
		-1,
		134,
		124,
		108,
		93,
		126,
		-1,
		138,
		122,
		127,
		-1,
		173,
		-1,
		146,
		148,
		142,
		127,
		124,
		135,
		133,
		144,
		161,
		-1,
		100,
		85,
		78,
		68,
		82,
		50,
		-1,
		84,
		-1,
		-1,
		121,
		115,
		115,
		99,
		102,
		154,
		134,
		128,
		127,
		168,
		168,
		154,
		140,
		133,
		130,
		127,
		140,
		160,
		151,
		163,
		-1,
		-1,
		-1,
		105,
		80,
		74,
		46,
		50,
		-1,
		-1,
		183,
		138,
		124,
		-1,
		108,
		171,
		159,
		149,
		139,
		173,
		174,
		159,
		152,
		138,
		140,
		138,
		136,
		141,
		162,
		163,
		176,
		-1,
		-1,
		79,
		72,
		60,
		28,
		23,
		-1,
		-1,
		-1,
		130,
		146,
		138,
		109,
		160,
		-1,
		-1,
		151,
		149,
		159,
		155,
		142,
		162,
		165,
		151,
		135,
		150,
		162,
		170,
		175,
		-1,
		82,
		69,
		-1,
		-1,
		0,
		18,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		141,
		162,
		187,
		154,
		-1,
		159,
		160,
		146,
		160,
		167,
		153,
		148,
		142,
		145,
		163,
		180,
		-1,
		-1,
		14,
		-1,
		35,
		-1,
		-1,
		-1,
		-1,
		120,
		134,
		155,
		161,
		173,
		-1,
		168,
		162,
		148,
		165,
		166,
		163,
		154,
		146,
		151,
		148,
		161,
		175,
		179,
		37,
		-1,
		46,
		-1,
		-1,
		-1,
		115,
		145,
		215,
		192,
		165,
		169,
		162,
		156,
		156,
		172,
		174,
		185,
		153,
		149,
		150,
		154,
		153,
		170,
		180,
		-1,
		-1,
		46,
		63,
		98,
		110,
		142,
		242,
		-1,
		-1,
		166,
		159,
		160,
		163,
		166,
		169,
		159,
		156,
		161,
		166,
		154,
		163,
		181,
		185,
		-1,
		-1,
		-1,
		66,
		-1,
		81,
		-1,
		-1,
		152,
		239,
		186,
		168,
		164,
		150,
		164,
		158,
		160,
		164,
		174,
		179,
		175,
		156,
		167,
		190,
		179,
		217,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		95,
		70,
		85,
		131,
		136,
		127,
		201,
		198,
		-1,
		146,
		187,
		155,
		169,
		165,
		172,
		177,
		179,
		157,
		164,
		180,
		179,
		174,
		209,
		201,
		207,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		101,
		87,
		117,
		107,
		113,
		-1,
		-1,
		160,
		157,
		160,
		147,
		153,
		158,
		161,
		186,
		166,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		127,
		208,
		201,
		184,
		192,
		223,
		-1,
		104,
		113,
		94,
		99,
		107,
		-1,
		-1,
		133,
		129,
		134,
		143,
		146,
		182,
		181,
		182,
		167,
		173,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		141,
		184,
		178,
		181,
		205,
		219,
		-1,
		117,
		-1,
		-1,
		102,
		120,
		128,
		124,
		128,
		181,
		157,
		152,
		165,
		167,
		179,
		170,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		176,
		164,
		172,
		-1,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		118,
		-1,
		154,
		-1,
		147,
		151,
		165,
		168,
		190,
		177,
		183,
		175,
		191,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		236,
		192,
		172,
		163,
		210,
		225,
		229,
		-1,
		130,
		169,
		156,
		-1,
		127,
		-1,
		-1,
		-1,
		161,
		178,
		170,
		186,
		189,
		189,
		177,
		181,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		232,
		223,
		236,
		181,
		177,
		195,
		204,
		225,
		145,
		136,
		163,
		163,
		152,
		147,
		134,
		-1,
		-1,
		184,
		188,
		-1,
		-1,
		196,
		198,
		181,
		182,
		178,
		181,
		196,
		199,
		189,
		187,
		181,
		213,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		196,
		-1,
		-1,
		148,
		164,
		177,
		181,
		194,
		219,
		-1,
		137,
		-1,
		-1,
		205,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		186,
		197,
		207,
		195,
		196,
		186,
		196,
		209,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		163,
		151,
		157,
		164,
		181,
		208,
		-1,
		-1,
		153,
		144,
		-1,
		-1,
		224,
		231,
		225,
		-1,
		215,
		188,
		193,
		213,
		215,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		163,
		-1,
		-1,
		231,
		226,
		214,
		202,
		192,
		202,
		206,
		210,
		202,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		252,
		-1,
		204,
		172,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		217,
		236,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		197,
		200,
		205,
		-1,
		226,
		-1,
		220,
		-1,
		165,
		181,
		183,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		229,
		227,
		218,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		246,
		220,
		227,
		218,
		201,
		181,
		173,
		198,
		-1,
		228,
		-1,
		203,
		205,
		231,
		234,
		240,
		234,
		207,
		222,
		212,
		203,
		212,
		252,
		-1,
		222,
		255,
		219,
		187,
		187,
		186,
		249,
		-1,
		225,
		207,
		-1,
		235,
		225,
		256,
		241,
		222,
		209,
		216,
		216,
		209,
		-1,
		-1,
		-1,
		224,
		223,
		215,
		209,
		207,
		192,
		187,
		-1,
		237,
		219,
		198,
		215,
		215,
		206,
		214,
		246,
		242,
		229,
		229,
		221,
		-1,
		324,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		218,
		227,
		200,
		188,
		202,
		209,
		202,
		206,
		210,
		218,
		216,
		213,
		225,
		221,
		241,
		222,
		257,
		-1,
		331,
		-1,
		254,
		-1,
		-1,
		234,
		220,
		222,
		211,
		200,
		198,
		201,
		199,
		221,
		244,
		228,
		226,
		229,
		230,
		-1,
		322,
		321,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		246,
		207,
		-1,
		228,
		208,
		-1,
		237,
		233,
		-1,
		-1,
		309,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		241,
		225,
		-1,
		219,
		219,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		247,
		250,
		-1,
		241,
		247,
		274,
		221,
		225,
		-1,
		-1,
		-1,
		303,
		284,
		278,
		262,
		267,
		255,
		272,
		258,
		257,
		235,
		224,
		245,
		-1,
		-1,
		-1,
		275,
		267,
		267,
		-1,
		-1,
		282,
		265,
		246,
		244,
		-1,
		-1,
		-1,
		297,
		278,
		-1,
		-1,
		272,
		-1,
		-1,
		278,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		286,
		-1,
		-1,
		-1,
		268,
		264,
		265,
		-1,
		-1,
		-1,
		-1,
		307,
		308,
		332,
		307,
		-1,
		-1,
		-1,
		260,
		254,
		-1,
		-1,
		310,
		308,
		-1,
		-1,
		-1,
		288,
		272,
		-1,
		258,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		293,
		-1,
		293,
		268,
		275,
		-1,
		-1,
		-1,
		-1,
		306,
		298,
		306,
		-1,
		278,
		280,
		-1,
		328,
		-1,
		-1,
		321,
		312,
		-1,
		-1,
		283,
		290,
		312,
		315,
		351,
		-1,
		302
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		194,
		196,
		162,
		156,
		195,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		185,
		184,
		154,
		152,
		161,
		166,
		173,
		-1,
		196,
		-1,
		206,
		185,
		196,
		201,
		147,
		144,
		164,
		183,
		189,
		181,
		221,
		177,
		148,
		142,
		160,
		165,
		183,
		175,
		-1,
		148,
		138,
		160,
		164,
		176,
		159,
		-1,
		-1,
		142,
		143,
		149,
		161,
		166,
		171,
		-1,
		194,
		178,
		-1,
		-1,
		132,
		145,
		141,
		144,
		152,
		168,
		186,
		178,
		173,
		-1,
		-1,
		133,
		137,
		150,
		151,
		149,
		173,
		186,
		168,
		182,
		181,
		-1,
		121,
		139,
		148,
		157,
		163,
		149,
		147,
		165,
		167,
		173,
		176,
		-1,
		113,
		115,
		144,
		150,
		162,
		165,
		152,
		152,
		162,
		155,
		174,
		165,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		118,
		144,
		143,
		139,
		157,
		162,
		155,
		152,
		150,
		147,
		163,
		164,
		174,
		-1,
		-1,
		166,
		135,
		170,
		127,
		112,
		-1,
		106,
		125,
		131,
		135,
		140,
		145,
		159,
		155,
		-1,
		141,
		140,
		171,
		157,
		168,
		126,
		-1,
		-1,
		124,
		116,
		101,
		104,
		101,
		101,
		131,
		130,
		135,
		137,
		136,
		142,
		145,
		145,
		151,
		135,
		145,
		149,
		160,
		175,
		-1,
		-1,
		230,
		-1,
		-1,
		123,
		106,
		-1,
		89,
		96,
		96,
		113,
		103,
		124,
		139,
		143,
		151,
		150,
		138,
		140,
		137,
		150,
		138,
		132,
		157,
		161,
		155,
		176,
		171,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		82,
		85,
		91,
		115,
		125,
		-1,
		146,
		144,
		168,
		159,
		156,
		143,
		131,
		144,
		129,
		136,
		135,
		139,
		141,
		174,
		152,
		174,
		171,
		200,
		205,
		199,
		208,
		-1,
		131,
		127,
		123,
		130,
		79,
		-1,
		-1,
		119,
		-1,
		133,
		146,
		150,
		148,
		151,
		160,
		151,
		138,
		127,
		138,
		127,
		124,
		132,
		141,
		152,
		147,
		146,
		164,
		179,
		192,
		196,
		202,
		-1,
		181,
		-1,
		123,
		107,
		109,
		81,
		102,
		-1,
		139,
		134,
		154,
		152,
		143,
		-1,
		146,
		149,
		156,
		134,
		119,
		136,
		128,
		126,
		131,
		136,
		150,
		141,
		159,
		166,
		174,
		178,
		198,
		210,
		141,
		131,
		-1,
		113,
		118,
		77,
		85,
		104,
		177,
		149,
		-1,
		144,
		-1,
		136,
		161,
		-1,
		140,
		136,
		118,
		119,
		114,
		129,
		135,
		132,
		129,
		147,
		150,
		167,
		171,
		187,
		-1,
		-1,
		126,
		130,
		119,
		70,
		89,
		113,
		150,
		142,
		131,
		130,
		-1,
		121,
		151,
		148,
		134,
		121,
		111,
		112,
		120,
		133,
		112,
		131,
		134,
		156,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		96,
		67,
		91,
		133,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		141,
		124,
		120,
		109,
		107,
		120,
		115,
		131,
		135,
		134,
		153,
		165,
		156,
		176,
		-1,
		-1,
		-1,
		126,
		115,
		116,
		62,
		85,
		122,
		139,
		125,
		130,
		105,
		98,
		92,
		144,
		141,
		108,
		116,
		108,
		97,
		111,
		119,
		123,
		132,
		141,
		147,
		171,
		171,
		177,
		-1,
		-1,
		133,
		123,
		107,
		109,
		106,
		76,
		83,
		115,
		130,
		127,
		-1,
		97,
		-1,
		86,
		94,
		93,
		99,
		111,
		97,
		102,
		113,
		125,
		138,
		134,
		141,
		176,
		176,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		126,
		121,
		96,
		73,
		57,
		93,
		-1,
		97,
		98,
		-1,
		91,
		85,
		91,
		90,
		97,
		94,
		94,
		108,
		116,
		112,
		128,
		134,
		126,
		162,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		119,
		98,
		91,
		111,
		52,
		104,
		-1,
		-1,
		82,
		75,
		-1,
		78,
		78,
		85,
		94,
		99,
		104,
		112,
		107,
		120,
		125,
		131,
		136,
		154,
		158,
		162,
		151,
		147,
		144,
		158,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		52,
		72,
		-1,
		90,
		82,
		73,
		67,
		73,
		91,
		89,
		109,
		101,
		115,
		115,
		121,
		129,
		114,
		117,
		133,
		131,
		149,
		157,
		149,
		143,
		142,
		154,
		-1,
		139,
		125,
		96,
		-1,
		-1,
		85,
		-1,
		49,
		68,
		84,
		-1,
		107,
		86,
		109,
		87,
		101,
		97,
		135,
		136,
		114,
		119,
		127,
		137,
		139,
		128,
		139,
		131,
		153,
		153,
		137,
		138,
		147,
		-1,
		145,
		132,
		90,
		86,
		75,
		95,
		46,
		55,
		71,
		-1,
		-1,
		151,
		-1,
		85,
		102,
		111,
		109,
		125,
		116,
		122,
		138,
		141,
		143,
		133,
		122,
		128,
		125,
		147,
		133,
		131,
		150,
		166,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		61,
		48,
		42,
		-1,
		88,
		-1,
		129,
		119,
		103,
		88,
		121,
		-1,
		133,
		117,
		122,
		-1,
		168,
		-1,
		141,
		143,
		137,
		122,
		119,
		130,
		128,
		139,
		156,
		-1,
		95,
		80,
		73,
		63,
		77,
		45,
		-1,
		79,
		-1,
		-1,
		116,
		110,
		110,
		94,
		97,
		149,
		129,
		123,
		122,
		163,
		163,
		149,
		135,
		128,
		125,
		122,
		135,
		155,
		146,
		158,
		-1,
		-1,
		-1,
		100,
		75,
		69,
		41,
		45,
		-1,
		-1,
		178,
		133,
		119,
		-1,
		103,
		166,
		154,
		144,
		134,
		168,
		169,
		154,
		147,
		133,
		135,
		133,
		131,
		136,
		157,
		158,
		171,
		-1,
		-1,
		74,
		67,
		55,
		23,
		18,
		-1,
		-1,
		-1,
		125,
		141,
		133,
		104,
		155,
		-1,
		-1,
		146,
		144,
		154,
		150,
		137,
		157,
		160,
		146,
		130,
		145,
		157,
		165,
		170,
		-1,
		77,
		64,
		-1,
		-1,
		17,
		0,
		-1,
		-1,
		-1,
		-1,
		151,
		124,
		136,
		157,
		182,
		149,
		-1,
		154,
		155,
		141,
		155,
		162,
		148,
		143,
		137,
		140,
		158,
		175,
		-1,
		-1,
		31,
		-1,
		20,
		-1,
		-1,
		-1,
		-1,
		115,
		129,
		150,
		156,
		168,
		-1,
		163,
		157,
		143,
		160,
		161,
		158,
		149,
		141,
		146,
		143,
		156,
		170,
		174,
		54,
		-1,
		31,
		-1,
		-1,
		-1,
		100,
		130,
		208,
		185,
		160,
		157,
		154,
		151,
		151,
		167,
		169,
		180,
		148,
		144,
		145,
		149,
		148,
		165,
		175,
		-1,
		-1,
		31,
		48,
		83,
		95,
		127,
		235,
		-1,
		-1,
		153,
		146,
		155,
		156,
		161,
		164,
		154,
		151,
		156,
		161,
		149,
		158,
		176,
		180,
		-1,
		-1,
		-1,
		51,
		-1,
		66,
		-1,
		-1,
		139,
		226,
		173,
		155,
		151,
		137,
		151,
		145,
		147,
		152,
		169,
		166,
		170,
		151,
		162,
		185,
		174,
		212,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		80,
		55,
		70,
		118,
		123,
		114,
		188,
		185,
		-1,
		133,
		174,
		142,
		156,
		152,
		159,
		164,
		170,
		152,
		159,
		175,
		174,
		169,
		204,
		196,
		202,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		86,
		72,
		104,
		94,
		100,
		-1,
		-1,
		147,
		144,
		147,
		134,
		140,
		145,
		148,
		181,
		161,
		148,
		152,
		156,
		162,
		167,
		172,
		178,
		193,
		208,
		-1,
		122,
		203,
		196,
		179,
		187,
		218,
		-1,
		89,
		100,
		79,
		86,
		94,
		-1,
		-1,
		120,
		116,
		121,
		130,
		133,
		169,
		168,
		177,
		162,
		168,
		155,
		154,
		172,
		176,
		185,
		192,
		182,
		195,
		199,
		-1,
		136,
		179,
		173,
		176,
		200,
		214,
		-1,
		102,
		-1,
		-1,
		89,
		107,
		115,
		111,
		115,
		168,
		144,
		139,
		152,
		154,
		174,
		165,
		172,
		163,
		163,
		166,
		181,
		186,
		178,
		192,
		192,
		193,
		-1,
		171,
		159,
		167,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		105,
		-1,
		141,
		-1,
		134,
		138,
		152,
		155,
		177,
		164,
		171,
		170,
		186,
		161,
		171,
		167,
		168,
		177,
		188,
		200,
		199,
		200,
		223,
		179,
		167,
		158,
		204,
		219,
		223,
		-1,
		117,
		156,
		143,
		-1,
		114,
		-1,
		-1,
		-1,
		148,
		165,
		157,
		173,
		176,
		176,
		172,
		176,
		166,
		173,
		183,
		185,
		177,
		181,
		194,
		205,
		208,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		132,
		123,
		150,
		150,
		139,
		134,
		121,
		-1,
		-1,
		171,
		175,
		-1,
		-1,
		183,
		193,
		176,
		177,
		173,
		176,
		191,
		194,
		184,
		182,
		176,
		208,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		135,
		151,
		164,
		168,
		181,
		206,
		-1,
		124,
		-1,
		-1,
		192,
		-1,
		-1,
		235,
		198,
		187,
		178,
		184,
		181,
		192,
		202,
		190,
		191,
		181,
		191,
		204,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		150,
		138,
		144,
		151,
		168,
		195,
		-1,
		-1,
		140,
		131,
		-1,
		-1,
		211,
		218,
		220,
		-1,
		210,
		183,
		188,
		208,
		210,
		199,
		193,
		187,
		194,
		193,
		201,
		209,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		150,
		-1,
		-1,
		218,
		221,
		209,
		197,
		187,
		197,
		201,
		205,
		197,
		190,
		185,
		196,
		188,
		192,
		209,
		-1,
		239,
		-1,
		191,
		159,
		179,
		194,
		202,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		262,
		246,
		227,
		-1,
		197,
		210,
		241,
		209,
		214,
		209,
		191,
		202,
		191,
		194,
		208,
		203,
		-1,
		-1,
		177,
		180,
		-1,
		-1,
		204,
		223,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		234,
		230,
		-1,
		-1,
		198,
		223,
		212,
		220,
		215,
		195,
		201,
		204,
		193,
		197,
		209,
		-1,
		-1,
		184,
		187,
		192,
		-1,
		213,
		-1,
		207,
		-1,
		152,
		168,
		170,
		-1,
		-1,
		-1,
		236,
		199,
		220,
		230,
		224,
		222,
		213,
		199,
		206,
		204,
		200,
		211,
		-1,
		-1,
		-1,
		233,
		207,
		214,
		205,
		188,
		168,
		160,
		185,
		-1,
		223,
		-1,
		198,
		200,
		226,
		229,
		235,
		229,
		202,
		217,
		207,
		198,
		207,
		239,
		-1,
		209,
		242,
		206,
		174,
		174,
		173,
		238,
		-1,
		220,
		202,
		-1,
		230,
		220,
		251,
		236,
		217,
		204,
		211,
		211,
		204,
		-1,
		-1,
		-1,
		211,
		210,
		202,
		196,
		194,
		179,
		174,
		-1,
		226,
		208,
		193,
		210,
		210,
		201,
		209,
		241,
		237,
		224,
		224,
		216,
		-1,
		311,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		205,
		214,
		187,
		175,
		189,
		196,
		191,
		193,
		205,
		213,
		211,
		208,
		220,
		216,
		236,
		217,
		252,
		-1,
		318,
		-1,
		241,
		-1,
		-1,
		221,
		207,
		209,
		198,
		187,
		185,
		188,
		186,
		208,
		238,
		223,
		221,
		224,
		225,
		-1,
		309,
		308,
		-1,
		240,
		232,
		218,
		-1,
		211,
		-1,
		233,
		194,
		-1,
		215,
		195,
		-1,
		232,
		228,
		-1,
		-1,
		296,
		256,
		-1,
		-1,
		-1,
		241,
		221,
		228,
		212,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		281,
		265,
		-1,
		234,
		237,
		-1,
		228,
		234,
		261,
		208,
		212,
		-1,
		-1,
		-1,
		290,
		271,
		265,
		249,
		254,
		242,
		259,
		245,
		244,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		262,
		254,
		254,
		-1,
		-1,
		269,
		252,
		233,
		231,
		-1,
		-1,
		-1,
		284,
		265,
		-1,
		-1,
		259,
		-1,
		-1,
		265,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		273,
		-1,
		-1,
		-1,
		255,
		251,
		252,
		-1,
		-1,
		-1,
		-1,
		294,
		295,
		319,
		294,
		-1,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		297,
		295,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		245,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		280,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		293,
		285,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		308,
		299,
		-1,
		-1,
		270,
		277,
		299,
		302,
		338,
		-1,
		289
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		261,
		263,
		229,
		223,
		262,
		233,
		239,
		250,
		-1,
		-1,
		-1,
		252,
		251,
		221,
		219,
		228,
		233,
		240,
		-1,
		244,
		-1,
		273,
		252,
		263,
		268,
		214,
		211,
		231,
		250,
		237,
		229,
		288,
		244,
		215,
		209,
		227,
		222,
		231,
		223,
		-1,
		215,
		205,
		227,
		211,
		222,
		214,
		-1,
		-1,
		209,
		210,
		216,
		207,
		213,
		209,
		-1,
		219,
		203,
		-1,
		-1,
		199,
		205,
		189,
		192,
		200,
		198,
		211,
		203,
		198,
		-1,
		-1,
		195,
		191,
		198,
		185,
		181,
		198,
		211,
		193,
		207,
		206,
		-1,
		188,
		206,
		215,
		192,
		190,
		174,
		172,
		190,
		192,
		198,
		201,
		-1,
		181,
		183,
		193,
		201,
		206,
		190,
		177,
		177,
		187,
		180,
		199,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		178,
		180,
		197,
		189,
		179,
		194,
		187,
		180,
		177,
		175,
		172,
		188,
		189,
		199,
		-1,
		-1,
		234,
		203,
		238,
		195,
		180,
		-1,
		174,
		173,
		179,
		183,
		177,
		170,
		184,
		180,
		-1,
		166,
		165,
		196,
		182,
		193,
		194,
		-1,
		-1,
		192,
		184,
		169,
		172,
		169,
		169,
		188,
		187,
		179,
		165,
		161,
		167,
		170,
		170,
		176,
		160,
		170,
		174,
		185,
		200,
		-1,
		-1,
		255,
		-1,
		-1,
		191,
		174,
		-1,
		157,
		164,
		164,
		181,
		171,
		192,
		198,
		189,
		181,
		175,
		163,
		165,
		162,
		175,
		163,
		157,
		182,
		186,
		180,
		201,
		196,
		-1,
		254,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		150,
		153,
		159,
		183,
		193,
		-1,
		183,
		189,
		199,
		184,
		181,
		168,
		156,
		169,
		154,
		161,
		160,
		164,
		166,
		199,
		177,
		199,
		196,
		225,
		230,
		224,
		233,
		-1,
		199,
		195,
		191,
		198,
		147,
		-1,
		-1,
		187,
		-1,
		201,
		200,
		175,
		193,
		196,
		185,
		176,
		163,
		152,
		163,
		152,
		149,
		157,
		166,
		177,
		172,
		171,
		189,
		204,
		217,
		221,
		227,
		-1,
		249,
		-1,
		191,
		175,
		177,
		149,
		170,
		-1,
		207,
		202,
		192,
		177,
		168,
		-1,
		171,
		174,
		181,
		159,
		144,
		161,
		153,
		151,
		156,
		161,
		175,
		166,
		184,
		191,
		199,
		203,
		223,
		235,
		209,
		199,
		-1,
		181,
		186,
		145,
		153,
		172,
		210,
		174,
		-1,
		169,
		-1,
		161,
		186,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		160,
		157,
		154,
		172,
		175,
		192,
		196,
		212,
		-1,
		-1,
		194,
		198,
		187,
		138,
		157,
		181,
		218,
		167,
		156,
		155,
		-1,
		146,
		176,
		173,
		159,
		146,
		136,
		137,
		145,
		158,
		137,
		156,
		159,
		181,
		209,
		187,
		199,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		164,
		135,
		159,
		201,
		185,
		178,
		166,
		131,
		131,
		125,
		-1,
		166,
		149,
		145,
		134,
		132,
		145,
		140,
		156,
		160,
		159,
		178,
		190,
		181,
		201,
		-1,
		-1,
		-1,
		194,
		183,
		184,
		130,
		153,
		190,
		164,
		150,
		155,
		130,
		123,
		117,
		169,
		166,
		133,
		141,
		133,
		122,
		136,
		144,
		148,
		157,
		166,
		172,
		196,
		196,
		202,
		-1,
		-1,
		201,
		191,
		175,
		177,
		174,
		144,
		151,
		183,
		155,
		168,
		-1,
		122,
		-1,
		111,
		119,
		118,
		124,
		136,
		122,
		127,
		138,
		150,
		163,
		159,
		166,
		201,
		201,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		194,
		189,
		164,
		141,
		125,
		161,
		-1,
		138,
		139,
		-1,
		116,
		110,
		116,
		115,
		122,
		119,
		119,
		133,
		141,
		137,
		153,
		159,
		151,
		187,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		187,
		166,
		159,
		179,
		120,
		172,
		-1,
		-1,
		123,
		116,
		-1,
		103,
		103,
		110,
		119,
		124,
		129,
		137,
		132,
		145,
		150,
		156,
		161,
		179,
		183,
		187,
		176,
		172,
		169,
		183,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		140,
		-1,
		132,
		124,
		114,
		108,
		102,
		105,
		107,
		134,
		126,
		140,
		140,
		146,
		154,
		139,
		142,
		158,
		156,
		174,
		182,
		174,
		168,
		167,
		179,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		153,
		-1,
		117,
		131,
		147,
		-1,
		140,
		119,
		134,
		112,
		108,
		122,
		160,
		161,
		139,
		144,
		152,
		162,
		164,
		153,
		164,
		156,
		178,
		178,
		162,
		163,
		172,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		114,
		102,
		134,
		-1,
		-1,
		109,
		-1,
		86,
		88,
		136,
		134,
		150,
		141,
		147,
		163,
		163,
		158,
		158,
		147,
		153,
		150,
		172,
		158,
		156,
		175,
		191,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		87,
		77,
		61,
		75,
		107,
		-1,
		158,
		142,
		147,
		-1,
		183,
		-1,
		155,
		158,
		149,
		146,
		144,
		155,
		153,
		164,
		181,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		171,
		-1,
		-1,
		74,
		68,
		56,
		68,
		65,
		174,
		154,
		148,
		147,
		166,
		153,
		152,
		140,
		140,
		143,
		147,
		160,
		180,
		171,
		183,
		-1,
		-1,
		-1,
		168,
		154,
		158,
		118,
		137,
		-1,
		-1,
		106,
		61,
		47,
		-1,
		60,
		148,
		138,
		147,
		148,
		153,
		154,
		144,
		142,
		138,
		147,
		151,
		156,
		161,
		182,
		178,
		196,
		-1,
		-1,
		151,
		156,
		144,
		130,
		149,
		-1,
		-1,
		-1,
		38,
		22,
		86,
		58,
		136,
		-1,
		-1,
		152,
		145,
		139,
		142,
		130,
		150,
		157,
		171,
		155,
		170,
		182,
		190,
		190,
		-1,
		154,
		141,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		-1,
		-1,
		0,
		57,
		69,
		90,
		115,
		151,
		-1,
		125,
		136,
		129,
		148,
		155,
		173,
		158,
		152,
		163,
		178,
		195,
		-1,
		-1,
		166,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		48,
		63,
		83,
		89,
		101,
		-1,
		127,
		129,
		126,
		138,
		149,
		154,
		162,
		146,
		160,
		163,
		176,
		190,
		194,
		189,
		-1,
		124,
		-1,
		-1,
		-1,
		51,
		66,
		143,
		120,
		93,
		98,
		108,
		113,
		118,
		138,
		144,
		155,
		140,
		144,
		159,
		169,
		168,
		185,
		195,
		-1,
		-1,
		122,
		112,
		77,
		59,
		63,
		170,
		-1,
		-1,
		108,
		114,
		110,
		120,
		128,
		131,
		136,
		138,
		156,
		175,
		163,
		178,
		193,
		189,
		-1,
		-1,
		-1,
		138,
		-1,
		110,
		-1,
		-1,
		78,
		194,
		141,
		123,
		119,
		117,
		122,
		131,
		126,
		131,
		156,
		151,
		160,
		165,
		169,
		192,
		181,
		220,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		167,
		129,
		144,
		163,
		98,
		105,
		156,
		153,
		-1,
		123,
		160,
		132,
		139,
		131,
		144,
		149,
		155,
		159,
		166,
		182,
		181,
		176,
		212,
		203,
		209,
		-1,
		-1,
		303,
		292,
		281,
		287,
		-1,
		167,
		146,
		149,
		139,
		115,
		-1,
		-1,
		172,
		169,
		147,
		141,
		145,
		138,
		133,
		171,
		147,
		155,
		159,
		163,
		169,
		174,
		179,
		185,
		200,
		215,
		-1,
		199,
		280,
		273,
		255,
		263,
		294,
		-1,
		157,
		149,
		153,
		135,
		126,
		-1,
		-1,
		145,
		142,
		147,
		148,
		145,
		157,
		156,
		167,
		169,
		174,
		162,
		161,
		179,
		183,
		192,
		199,
		189,
		202,
		206,
		-1,
		213,
		256,
		249,
		252,
		276,
		290,
		-1,
		154,
		-1,
		-1,
		166,
		139,
		147,
		150,
		144,
		194,
		162,
		157,
		159,
		161,
		165,
		156,
		179,
		170,
		170,
		173,
		188,
		193,
		185,
		199,
		199,
		200,
		-1,
		239,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		182,
		-1,
		173,
		-1,
		162,
		166,
		170,
		173,
		184,
		171,
		169,
		177,
		185,
		168,
		178,
		174,
		175,
		184,
		195,
		207,
		206,
		207,
		264,
		220,
		223,
		234,
		245,
		260,
		264,
		-1,
		166,
		205,
		220,
		-1,
		191,
		-1,
		-1,
		-1,
		176,
		183,
		175,
		191,
		183,
		183,
		163,
		167,
		173,
		180,
		190,
		192,
		184,
		188,
		201,
		212,
		215,
		260,
		251,
		264,
		209,
		209,
		230,
		239,
		260,
		181,
		172,
		199,
		227,
		216,
		211,
		198,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		190,
		184,
		167,
		169,
		173,
		183,
		198,
		201,
		191,
		189,
		183,
		215,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		200,
		227,
		-1,
		-1,
		184,
		200,
		213,
		217,
		233,
		258,
		-1,
		201,
		-1,
		-1,
		220,
		-1,
		-1,
		226,
		189,
		178,
		169,
		175,
		181,
		192,
		209,
		197,
		198,
		188,
		198,
		211,
		237,
		234,
		222,
		220,
		243,
		208,
		196,
		-1,
		199,
		187,
		193,
		200,
		217,
		247,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		224,
		222,
		211,
		-1,
		201,
		174,
		179,
		204,
		211,
		206,
		200,
		194,
		201,
		200,
		208,
		216,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		194,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		-1,
		252,
		227,
		-1,
		-1,
		219,
		212,
		200,
		188,
		178,
		188,
		196,
		196,
		199,
		197,
		192,
		203,
		195,
		199,
		216,
		-1,
		280,
		-1,
		232,
		208,
		222,
		237,
		245,
		-1,
		-1,
		-1,
		269,
		255,
		248,
		236,
		234,
		-1,
		253,
		237,
		218,
		-1,
		188,
		201,
		232,
		200,
		205,
		200,
		198,
		209,
		198,
		201,
		215,
		210,
		-1,
		-1,
		220,
		223,
		-1,
		-1,
		245,
		264,
		-1,
		260,
		249,
		234,
		226,
		-1,
		-1,
		225,
		221,
		-1,
		-1,
		189,
		214,
		203,
		211,
		206,
		202,
		208,
		211,
		200,
		204,
		216,
		-1,
		-1,
		227,
		228,
		233,
		-1,
		249,
		-1,
		267,
		-1,
		229,
		240,
		228,
		-1,
		-1,
		-1,
		227,
		190,
		207,
		221,
		226,
		224,
		215,
		206,
		213,
		211,
		207,
		218,
		-1,
		-1,
		-1,
		267,
		241,
		274,
		265,
		248,
		228,
		220,
		239,
		-1,
		209,
		-1,
		184,
		187,
		212,
		220,
		237,
		231,
		209,
		224,
		214,
		205,
		214,
		273,
		-1,
		243,
		276,
		240,
		234,
		210,
		214,
		230,
		-1,
		206,
		188,
		-1,
		216,
		206,
		254,
		229,
		224,
		211,
		218,
		218,
		211,
		-1,
		-1,
		-1,
		245,
		244,
		236,
		230,
		230,
		215,
		206,
		-1,
		218,
		200,
		179,
		196,
		196,
		187,
		195,
		244,
		240,
		231,
		231,
		219,
		-1,
		346,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		239,
		234,
		207,
		195,
		201,
		197,
		183,
		189,
		191,
		199,
		197,
		194,
		206,
		202,
		222,
		218,
		250,
		-1,
		341,
		-1,
		275,
		-1,
		-1,
		257,
		237,
		229,
		218,
		207,
		205,
		196,
		187,
		209,
		225,
		209,
		207,
		212,
		217,
		-1,
		330,
		329,
		-1,
		276,
		268,
		254,
		-1,
		247,
		-1,
		253,
		214,
		-1,
		216,
		196,
		-1,
		218,
		214,
		-1,
		-1,
		317,
		292,
		-1,
		-1,
		-1,
		277,
		257,
		248,
		232,
		-1,
		207,
		207,
		-1,
		-1,
		-1,
		302,
		301,
		-1,
		270,
		273,
		-1,
		263,
		254,
		262,
		209,
		213,
		-1,
		-1,
		-1,
		311,
		292,
		286,
		285,
		283,
		278,
		275,
		261,
		245,
		223,
		212,
		233,
		-1,
		-1,
		-1,
		283,
		275,
		268,
		-1,
		-1,
		270,
		253,
		234,
		232,
		-1,
		-1,
		-1,
		305,
		286,
		-1,
		-1,
		260,
		-1,
		-1,
		266,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		322,
		294,
		-1,
		-1,
		-1,
		256,
		252,
		253,
		-1,
		-1,
		-1,
		-1,
		316,
		317,
		340,
		304,
		-1,
		-1,
		-1,
		248,
		242,
		-1,
		-1,
		319,
		317,
		-1,
		-1,
		-1,
		276,
		260,
		-1,
		246,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		281,
		-1,
		281,
		256,
		263,
		-1,
		-1,
		-1,
		-1,
		294,
		286,
		294,
		-1,
		266,
		268,
		-1,
		316,
		-1,
		-1,
		309,
		300,
		-1,
		-1,
		271,
		278,
		300,
		303,
		339,
		-1,
		290
	],
	[
		-1,
		216,
		205,
		216,
		224,
		197,
		204,
		-1,
		225,
		227,
		193,
		187,
		226,
		197,
		203,
		214,
		-1,
		-1,
		-1,
		216,
		215,
		185,
		183,
		192,
		197,
		204,
		-1,
		208,
		-1,
		237,
		216,
		227,
		232,
		178,
		175,
		195,
		214,
		201,
		193,
		252,
		208,
		179,
		173,
		191,
		186,
		195,
		187,
		-1,
		179,
		169,
		191,
		175,
		186,
		178,
		-1,
		-1,
		173,
		174,
		180,
		171,
		177,
		173,
		-1,
		183,
		167,
		-1,
		-1,
		163,
		169,
		153,
		156,
		164,
		162,
		175,
		167,
		162,
		-1,
		-1,
		159,
		155,
		162,
		149,
		145,
		162,
		175,
		157,
		171,
		170,
		-1,
		152,
		170,
		179,
		156,
		154,
		138,
		136,
		154,
		156,
		162,
		165,
		-1,
		145,
		147,
		157,
		165,
		170,
		154,
		141,
		141,
		151,
		144,
		163,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		142,
		144,
		161,
		153,
		143,
		158,
		151,
		144,
		141,
		139,
		136,
		152,
		153,
		163,
		-1,
		-1,
		198,
		167,
		202,
		159,
		144,
		-1,
		138,
		137,
		143,
		147,
		141,
		134,
		148,
		144,
		-1,
		130,
		129,
		160,
		146,
		157,
		158,
		-1,
		-1,
		156,
		148,
		133,
		136,
		133,
		133,
		152,
		151,
		143,
		129,
		125,
		131,
		134,
		134,
		140,
		124,
		134,
		138,
		149,
		164,
		-1,
		-1,
		216,
		-1,
		-1,
		155,
		138,
		-1,
		121,
		128,
		128,
		145,
		135,
		156,
		162,
		153,
		145,
		139,
		127,
		129,
		126,
		139,
		127,
		121,
		146,
		150,
		144,
		165,
		160,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		114,
		117,
		123,
		147,
		157,
		-1,
		147,
		153,
		163,
		148,
		145,
		132,
		120,
		133,
		118,
		125,
		124,
		128,
		130,
		163,
		141,
		163,
		160,
		186,
		191,
		185,
		194,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		151,
		-1,
		165,
		164,
		139,
		157,
		160,
		149,
		140,
		127,
		116,
		127,
		116,
		113,
		121,
		130,
		141,
		136,
		135,
		153,
		168,
		178,
		182,
		188,
		-1,
		213,
		-1,
		155,
		139,
		141,
		113,
		134,
		-1,
		171,
		166,
		156,
		141,
		132,
		-1,
		135,
		138,
		145,
		123,
		108,
		125,
		117,
		115,
		120,
		125,
		139,
		130,
		148,
		155,
		160,
		164,
		184,
		196,
		173,
		163,
		-1,
		145,
		150,
		109,
		117,
		136,
		174,
		138,
		-1,
		133,
		-1,
		125,
		150,
		-1,
		129,
		125,
		107,
		108,
		103,
		118,
		124,
		121,
		118,
		136,
		139,
		153,
		157,
		173,
		-1,
		-1,
		158,
		162,
		151,
		102,
		121,
		145,
		182,
		131,
		120,
		119,
		-1,
		110,
		140,
		137,
		123,
		110,
		100,
		101,
		109,
		122,
		101,
		120,
		123,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		128,
		99,
		123,
		165,
		149,
		142,
		130,
		95,
		95,
		89,
		-1,
		130,
		113,
		109,
		98,
		96,
		109,
		104,
		120,
		122,
		120,
		139,
		151,
		142,
		153,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		94,
		117,
		154,
		128,
		114,
		119,
		94,
		87,
		81,
		133,
		130,
		97,
		105,
		97,
		86,
		100,
		108,
		112,
		118,
		127,
		133,
		157,
		141,
		147,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		108,
		115,
		147,
		119,
		132,
		-1,
		86,
		-1,
		75,
		83,
		82,
		88,
		100,
		86,
		91,
		102,
		114,
		125,
		120,
		127,
		162,
		162,
		131,
		151,
		154,
		-1,
		-1,
		-1,
		158,
		153,
		128,
		105,
		89,
		125,
		-1,
		102,
		103,
		-1,
		80,
		74,
		80,
		79,
		86,
		83,
		83,
		97,
		105,
		101,
		117,
		123,
		112,
		136,
		-1,
		139,
		133,
		141,
		131,
		119,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		84,
		136,
		-1,
		-1,
		87,
		80,
		-1,
		67,
		67,
		74,
		83,
		88,
		93,
		101,
		96,
		109,
		114,
		117,
		111,
		124,
		128,
		132,
		121,
		117,
		114,
		128,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		104,
		-1,
		96,
		88,
		78,
		72,
		66,
		77,
		78,
		98,
		90,
		104,
		104,
		110,
		118,
		103,
		105,
		116,
		101,
		119,
		127,
		119,
		113,
		112,
		124,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		117,
		-1,
		81,
		95,
		111,
		-1,
		104,
		83,
		98,
		76,
		80,
		86,
		124,
		125,
		103,
		108,
		116,
		109,
		112,
		106,
		109,
		101,
		123,
		123,
		107,
		108,
		117,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		78,
		66,
		98,
		-1,
		-1,
		104,
		-1,
		58,
		60,
		100,
		98,
		114,
		105,
		111,
		127,
		106,
		101,
		111,
		100,
		97,
		95,
		117,
		103,
		101,
		120,
		136,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		115,
		-1,
		82,
		70,
		57,
		39,
		79,
		-1,
		107,
		103,
		110,
		-1,
		126,
		-1,
		98,
		101,
		92,
		89,
		89,
		100,
		98,
		109,
		126,
		-1,
		127,
		112,
		105,
		95,
		109,
		80,
		-1,
		135,
		-1,
		-1,
		69,
		63,
		63,
		32,
		29,
		123,
		103,
		95,
		110,
		109,
		96,
		95,
		83,
		83,
		86,
		92,
		105,
		125,
		116,
		127,
		-1,
		-1,
		-1,
		132,
		118,
		122,
		82,
		101,
		-1,
		-1,
		130,
		86,
		72,
		-1,
		24,
		91,
		81,
		90,
		91,
		96,
		97,
		87,
		85,
		81,
		90,
		94,
		101,
		106,
		127,
		121,
		141,
		-1,
		-1,
		115,
		120,
		108,
		94,
		113,
		-1,
		-1,
		-1,
		76,
		77,
		43,
		22,
		79,
		-1,
		-1,
		95,
		88,
		82,
		85,
		73,
		93,
		100,
		114,
		100,
		115,
		126,
		134,
		133,
		-1,
		118,
		105,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		-1,
		-1,
		55,
		0,
		12,
		33,
		58,
		94,
		-1,
		68,
		79,
		72,
		91,
		98,
		116,
		101,
		95,
		106,
		121,
		138,
		-1,
		-1,
		130,
		-1,
		113,
		-1,
		-1,
		-1,
		-1,
		12,
		6,
		26,
		32,
		44,
		-1,
		70,
		72,
		69,
		81,
		92,
		97,
		105,
		89,
		103,
		106,
		119,
		133,
		137,
		153,
		-1,
		103,
		-1,
		-1,
		-1,
		30,
		45,
		86,
		63,
		36,
		41,
		51,
		56,
		61,
		81,
		87,
		98,
		83,
		87,
		102,
		112,
		111,
		128,
		138,
		-1,
		-1,
		101,
		91,
		56,
		38,
		42,
		113,
		-1,
		-1,
		51,
		57,
		53,
		63,
		71,
		74,
		79,
		81,
		99,
		118,
		106,
		121,
		136,
		132,
		-1,
		-1,
		-1,
		117,
		-1,
		89,
		-1,
		-1,
		57,
		137,
		84,
		66,
		62,
		60,
		65,
		74,
		69,
		74,
		99,
		94,
		103,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		146,
		108,
		123,
		142,
		77,
		84,
		99,
		96,
		-1,
		66,
		103,
		75,
		82,
		74,
		87,
		92,
		98,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		146,
		125,
		128,
		118,
		94,
		-1,
		-1,
		115,
		112,
		90,
		84,
		88,
		81,
		76,
		114,
		90,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		163,
		237,
		230,
		198,
		206,
		237,
		-1,
		136,
		128,
		132,
		114,
		105,
		-1,
		-1,
		88,
		85,
		90,
		91,
		88,
		100,
		99,
		110,
		112,
		117,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		177,
		213,
		192,
		195,
		219,
		233,
		-1,
		133,
		-1,
		-1,
		145,
		118,
		103,
		93,
		87,
		137,
		105,
		100,
		102,
		104,
		108,
		99,
		122,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		161,
		-1,
		130,
		-1,
		105,
		109,
		113,
		116,
		127,
		114,
		112,
		120,
		128,
		111,
		121,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		145,
		184,
		199,
		-1,
		170,
		-1,
		-1,
		-1,
		119,
		126,
		118,
		134,
		126,
		126,
		106,
		110,
		116,
		123,
		133,
		135,
		127,
		131,
		144,
		155,
		158,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		160,
		151,
		178,
		206,
		195,
		190,
		177,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		133,
		127,
		110,
		112,
		116,
		126,
		141,
		144,
		134,
		132,
		126,
		158,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		163,
		179,
		176,
		180,
		196,
		221,
		-1,
		180,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		124,
		135,
		152,
		140,
		141,
		131,
		141,
		154,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		117,
		122,
		147,
		154,
		149,
		143,
		137,
		144,
		143,
		151,
		159,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		200,
		196,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		139,
		139,
		142,
		140,
		135,
		146,
		138,
		142,
		159,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		217,
		203,
		196,
		184,
		182,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		141,
		152,
		141,
		144,
		158,
		153,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		188,
		207,
		-1,
		208,
		197,
		182,
		174,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		145,
		151,
		154,
		143,
		147,
		159,
		-1,
		-1,
		170,
		171,
		176,
		-1,
		192,
		-1,
		210,
		-1,
		177,
		183,
		171,
		-1,
		-1,
		-1,
		170,
		133,
		150,
		164,
		169,
		167,
		158,
		149,
		156,
		154,
		150,
		161,
		-1,
		-1,
		-1,
		210,
		184,
		217,
		208,
		191,
		171,
		163,
		182,
		-1,
		152,
		-1,
		127,
		130,
		155,
		163,
		180,
		174,
		152,
		167,
		157,
		148,
		157,
		216,
		-1,
		186,
		219,
		183,
		177,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		197,
		172,
		167,
		154,
		161,
		161,
		154,
		-1,
		-1,
		-1,
		188,
		187,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		187,
		183,
		174,
		174,
		162,
		-1,
		289,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		161,
		193,
		-1,
		284,
		-1,
		218,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		155,
		160,
		-1,
		273,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		236,
		238,
		204,
		198,
		237,
		208,
		214,
		225,
		-1,
		-1,
		-1,
		227,
		226,
		196,
		194,
		203,
		208,
		215,
		-1,
		216,
		-1,
		248,
		227,
		238,
		243,
		189,
		186,
		206,
		225,
		209,
		201,
		263,
		219,
		190,
		184,
		202,
		194,
		203,
		195,
		-1,
		190,
		180,
		202,
		183,
		194,
		186,
		-1,
		-1,
		184,
		185,
		191,
		179,
		185,
		181,
		-1,
		191,
		175,
		-1,
		-1,
		174,
		177,
		161,
		164,
		172,
		170,
		183,
		175,
		170,
		-1,
		-1,
		167,
		163,
		170,
		157,
		153,
		170,
		183,
		165,
		179,
		178,
		-1,
		163,
		181,
		190,
		164,
		162,
		146,
		144,
		162,
		164,
		170,
		170,
		-1,
		156,
		158,
		168,
		176,
		181,
		162,
		149,
		149,
		159,
		152,
		171,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		155,
		172,
		164,
		154,
		169,
		162,
		152,
		149,
		147,
		144,
		160,
		158,
		168,
		-1,
		-1,
		209,
		178,
		213,
		170,
		155,
		-1,
		149,
		148,
		154,
		158,
		152,
		145,
		159,
		155,
		-1,
		138,
		137,
		165,
		151,
		162,
		169,
		-1,
		-1,
		167,
		159,
		144,
		147,
		144,
		144,
		163,
		162,
		154,
		140,
		136,
		142,
		145,
		145,
		151,
		132,
		142,
		146,
		144,
		169,
		-1,
		-1,
		204,
		-1,
		-1,
		166,
		149,
		-1,
		132,
		139,
		139,
		156,
		146,
		167,
		173,
		164,
		156,
		150,
		138,
		140,
		137,
		150,
		138,
		129,
		154,
		158,
		139,
		160,
		155,
		-1,
		203,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		134,
		158,
		168,
		-1,
		158,
		164,
		174,
		159,
		156,
		143,
		131,
		144,
		129,
		136,
		135,
		133,
		131,
		161,
		136,
		158,
		155,
		174,
		179,
		173,
		182,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		162,
		-1,
		176,
		175,
		150,
		168,
		171,
		160,
		151,
		138,
		127,
		138,
		127,
		124,
		132,
		125,
		140,
		131,
		130,
		148,
		158,
		166,
		170,
		176,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		182,
		177,
		167,
		152,
		143,
		-1,
		146,
		149,
		156,
		134,
		119,
		136,
		128,
		126,
		131,
		120,
		134,
		125,
		143,
		150,
		148,
		152,
		172,
		184,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		185,
		149,
		-1,
		144,
		-1,
		136,
		161,
		-1,
		140,
		136,
		118,
		119,
		114,
		129,
		131,
		116,
		113,
		131,
		134,
		141,
		145,
		161,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		151,
		148,
		134,
		121,
		111,
		112,
		120,
		133,
		112,
		115,
		112,
		132,
		158,
		136,
		148,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		141,
		124,
		120,
		109,
		107,
		120,
		115,
		130,
		110,
		108,
		127,
		139,
		130,
		141,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		144,
		141,
		108,
		116,
		108,
		97,
		111,
		119,
		123,
		106,
		115,
		121,
		145,
		129,
		135,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		94,
		93,
		99,
		111,
		97,
		102,
		113,
		123,
		113,
		108,
		115,
		150,
		150,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		91,
		90,
		97,
		94,
		94,
		108,
		116,
		111,
		117,
		118,
		100,
		124,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		78,
		85,
		94,
		99,
		104,
		112,
		105,
		118,
		111,
		105,
		99,
		112,
		116,
		120,
		109,
		105,
		102,
		116,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		88,
		89,
		109,
		101,
		115,
		115,
		119,
		109,
		100,
		93,
		104,
		89,
		107,
		115,
		107,
		101,
		100,
		112,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		91,
		97,
		131,
		132,
		102,
		107,
		109,
		97,
		100,
		94,
		97,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		115,
		-1,
		69,
		71,
		111,
		109,
		121,
		96,
		103,
		121,
		94,
		89,
		99,
		88,
		85,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		93,
		81,
		68,
		50,
		90,
		-1,
		95,
		91,
		98,
		-1,
		114,
		-1,
		86,
		89,
		80,
		77,
		77,
		88,
		86,
		97,
		114,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		80,
		74,
		74,
		43,
		40,
		111,
		91,
		83,
		98,
		97,
		84,
		83,
		71,
		71,
		74,
		80,
		93,
		113,
		104,
		115,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		141,
		97,
		83,
		-1,
		35,
		79,
		69,
		78,
		79,
		84,
		85,
		75,
		73,
		69,
		78,
		82,
		89,
		94,
		115,
		109,
		129,
		-1,
		-1,
		126,
		131,
		119,
		105,
		124,
		-1,
		-1,
		-1,
		87,
		88,
		54,
		33,
		67,
		-1,
		-1,
		83,
		76,
		70,
		73,
		61,
		81,
		88,
		102,
		88,
		103,
		114,
		122,
		121,
		-1,
		129,
		116,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		-1,
		-1,
		66,
		11,
		0,
		21,
		46,
		82,
		-1,
		56,
		67,
		60,
		79,
		86,
		104,
		89,
		83,
		94,
		109,
		126,
		-1,
		-1,
		141,
		-1,
		124,
		-1,
		-1,
		-1,
		-1,
		23,
		17,
		14,
		20,
		32,
		-1,
		58,
		60,
		57,
		69,
		80,
		85,
		93,
		77,
		91,
		94,
		107,
		121,
		125,
		164,
		-1,
		114,
		-1,
		-1,
		-1,
		41,
		56,
		74,
		51,
		24,
		29,
		39,
		44,
		49,
		69,
		75,
		86,
		71,
		75,
		90,
		100,
		99,
		116,
		126,
		-1,
		-1,
		112,
		102,
		67,
		49,
		53,
		101,
		-1,
		-1,
		39,
		45,
		41,
		51,
		59,
		62,
		67,
		69,
		87,
		106,
		94,
		109,
		124,
		120,
		-1,
		-1,
		-1,
		128,
		-1,
		100,
		-1,
		-1,
		68,
		125,
		72,
		54,
		50,
		48,
		53,
		62,
		57,
		62,
		87,
		82,
		91,
		96,
		100,
		123,
		112,
		151,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		143,
		119,
		130,
		136,
		88,
		95,
		87,
		84,
		-1,
		54,
		91,
		63,
		70,
		62,
		75,
		80,
		86,
		90,
		97,
		113,
		112,
		107,
		143,
		134,
		140,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		136,
		132,
		122,
		112,
		105,
		-1,
		-1,
		103,
		100,
		78,
		72,
		76,
		69,
		64,
		102,
		78,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		174,
		225,
		218,
		186,
		194,
		225,
		-1,
		126,
		118,
		129,
		104,
		106,
		-1,
		-1,
		76,
		73,
		78,
		79,
		76,
		88,
		87,
		98,
		100,
		105,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		123,
		-1,
		-1,
		135,
		107,
		91,
		81,
		75,
		125,
		93,
		88,
		90,
		92,
		96,
		87,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		151,
		-1,
		118,
		-1,
		93,
		97,
		101,
		104,
		115,
		102,
		100,
		108,
		116,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		135,
		174,
		189,
		-1,
		160,
		-1,
		-1,
		-1,
		107,
		114,
		106,
		122,
		114,
		114,
		94,
		98,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		150,
		141,
		168,
		194,
		185,
		180,
		167,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		121,
		115,
		98,
		100,
		104,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		169,
		164,
		168,
		184,
		209,
		-1,
		170,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		112,
		123,
		140,
		128,
		129,
		119,
		129,
		142,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		135,
		142,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		127,
		127,
		130,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		176,
		195,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		158,
		159,
		164,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		158,
		121,
		138,
		152,
		157,
		155,
		146,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		118,
		143,
		151,
		168,
		162,
		140,
		155,
		145,
		136,
		145,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		185,
		160,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		175,
		171,
		162,
		162,
		150,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		143,
		148,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		170,
		188,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		176,
		178,
		175,
		183,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		173,
		162,
		179,
		171,
		161,
		176,
		169,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		229,
		198,
		233,
		190,
		175,
		-1,
		169,
		155,
		161,
		165,
		159,
		152,
		166,
		162,
		-1,
		135,
		134,
		162,
		148,
		159,
		189,
		-1,
		-1,
		187,
		179,
		164,
		167,
		164,
		164,
		170,
		169,
		161,
		147,
		143,
		149,
		152,
		152,
		158,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		169,
		-1,
		152,
		159,
		159,
		176,
		166,
		187,
		180,
		171,
		163,
		157,
		145,
		147,
		144,
		157,
		145,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		145,
		148,
		154,
		178,
		188,
		-1,
		178,
		180,
		181,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		182,
		-1,
		196,
		195,
		170,
		177,
		180,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		244,
		-1,
		186,
		170,
		172,
		144,
		165,
		-1,
		202,
		197,
		187,
		172,
		163,
		-1,
		166,
		169,
		163,
		141,
		126,
		143,
		135,
		133,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		204,
		194,
		-1,
		176,
		181,
		140,
		148,
		167,
		205,
		169,
		-1,
		164,
		-1,
		156,
		181,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		189,
		193,
		182,
		133,
		152,
		176,
		213,
		162,
		151,
		150,
		-1,
		141,
		161,
		158,
		146,
		133,
		118,
		119,
		127,
		139,
		118,
		112,
		109,
		129,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		159,
		130,
		154,
		196,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		157,
		136,
		127,
		116,
		114,
		127,
		119,
		127,
		107,
		105,
		124,
		136,
		127,
		138,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		125,
		148,
		185,
		159,
		145,
		150,
		125,
		118,
		112,
		164,
		153,
		128,
		123,
		115,
		104,
		115,
		123,
		121,
		103,
		112,
		118,
		142,
		126,
		132,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		114,
		113,
		119,
		120,
		107,
		106,
		120,
		120,
		110,
		105,
		112,
		147,
		147,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		189,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		111,
		110,
		117,
		111,
		114,
		117,
		120,
		108,
		114,
		115,
		97,
		121,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		98,
		105,
		114,
		109,
		116,
		111,
		102,
		115,
		108,
		102,
		96,
		109,
		113,
		117,
		106,
		102,
		99,
		113,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		108,
		109,
		129,
		121,
		124,
		119,
		116,
		106,
		97,
		90,
		101,
		86,
		104,
		112,
		104,
		98,
		97,
		109,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		111,
		117,
		128,
		129,
		99,
		104,
		106,
		94,
		97,
		91,
		94,
		86,
		108,
		108,
		92,
		93,
		102,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		135,
		-1,
		89,
		91,
		131,
		129,
		118,
		93,
		100,
		118,
		91,
		86,
		96,
		85,
		82,
		80,
		102,
		88,
		86,
		105,
		121,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		113,
		101,
		88,
		70,
		110,
		-1,
		92,
		88,
		95,
		-1,
		111,
		-1,
		83,
		86,
		77,
		74,
		74,
		85,
		83,
		94,
		111,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		100,
		94,
		94,
		63,
		60,
		108,
		88,
		80,
		95,
		94,
		81,
		80,
		68,
		68,
		71,
		77,
		90,
		110,
		101,
		112,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		161,
		117,
		103,
		-1,
		55,
		70,
		60,
		69,
		76,
		81,
		82,
		72,
		70,
		66,
		75,
		79,
		86,
		91,
		112,
		106,
		126,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		107,
		108,
		74,
		53,
		58,
		-1,
		-1,
		80,
		73,
		67,
		70,
		58,
		78,
		85,
		99,
		85,
		100,
		111,
		119,
		118,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		86,
		31,
		20,
		0,
		43,
		79,
		-1,
		53,
		64,
		57,
		76,
		83,
		101,
		86,
		80,
		91,
		106,
		123,
		-1,
		-1,
		161,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		43,
		37,
		11,
		17,
		29,
		-1,
		55,
		57,
		54,
		66,
		77,
		82,
		90,
		74,
		88,
		91,
		104,
		118,
		122,
		184,
		-1,
		134,
		-1,
		-1,
		-1,
		61,
		76,
		71,
		48,
		21,
		26,
		36,
		41,
		46,
		66,
		72,
		83,
		68,
		72,
		87,
		97,
		96,
		113,
		123,
		-1,
		-1,
		132,
		122,
		87,
		69,
		73,
		98,
		-1,
		-1,
		36,
		42,
		38,
		48,
		56,
		59,
		64,
		66,
		84,
		103,
		91,
		106,
		121,
		117,
		-1,
		-1,
		-1,
		148,
		-1,
		120,
		-1,
		-1,
		88,
		122,
		69,
		51,
		47,
		45,
		50,
		59,
		54,
		59,
		84,
		79,
		88,
		93,
		97,
		120,
		109,
		148,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		108,
		115,
		84,
		81,
		-1,
		51,
		88,
		60,
		67,
		59,
		72,
		77,
		83,
		87,
		94,
		110,
		109,
		104,
		140,
		131,
		137,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		133,
		129,
		119,
		109,
		112,
		-1,
		-1,
		100,
		97,
		75,
		69,
		73,
		66,
		61,
		99,
		75,
		83,
		87,
		91,
		97,
		102,
		107,
		113,
		128,
		143,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		123,
		115,
		126,
		101,
		103,
		-1,
		-1,
		73,
		70,
		75,
		76,
		73,
		85,
		84,
		95,
		97,
		102,
		90,
		89,
		107,
		111,
		120,
		127,
		117,
		130,
		134,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		120,
		-1,
		-1,
		132,
		104,
		88,
		78,
		72,
		122,
		90,
		85,
		87,
		89,
		93,
		84,
		107,
		98,
		98,
		101,
		116,
		121,
		113,
		127,
		127,
		128,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		115,
		-1,
		90,
		94,
		98,
		101,
		112,
		99,
		97,
		105,
		113,
		96,
		106,
		102,
		103,
		112,
		123,
		135,
		134,
		135,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		132,
		171,
		186,
		-1,
		157,
		-1,
		-1,
		-1,
		104,
		111,
		103,
		119,
		111,
		111,
		91,
		95,
		101,
		108,
		118,
		120,
		112,
		116,
		129,
		140,
		143,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		147,
		138,
		165,
		191,
		182,
		177,
		164,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		118,
		112,
		95,
		97,
		101,
		111,
		126,
		129,
		119,
		117,
		111,
		143,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		150,
		166,
		161,
		165,
		181,
		206,
		-1,
		167,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		117,
		106,
		97,
		103,
		109,
		120,
		137,
		125,
		126,
		116,
		126,
		139,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		137,
		135,
		141,
		148,
		165,
		195,
		-1,
		-1,
		183,
		174,
		-1,
		-1,
		152,
		150,
		139,
		-1,
		129,
		102,
		107,
		132,
		139,
		134,
		128,
		122,
		129,
		128,
		136,
		144,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		181,
		-1,
		-1,
		147,
		140,
		128,
		116,
		106,
		116,
		124,
		124,
		127,
		125,
		120,
		131,
		123,
		127,
		144,
		-1,
		208,
		-1,
		160,
		136,
		150,
		165,
		173,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		181,
		165,
		146,
		-1,
		116,
		129,
		160,
		128,
		133,
		128,
		126,
		137,
		126,
		129,
		143,
		138,
		-1,
		-1,
		148,
		151,
		-1,
		-1,
		173,
		192,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		153,
		149,
		-1,
		-1,
		117,
		142,
		131,
		139,
		134,
		130,
		136,
		139,
		128,
		132,
		144,
		-1,
		-1,
		155,
		156,
		161,
		-1,
		177,
		-1,
		195,
		-1,
		162,
		168,
		156,
		-1,
		-1,
		-1,
		155,
		118,
		135,
		149,
		154,
		152,
		143,
		134,
		141,
		139,
		135,
		146,
		-1,
		-1,
		-1,
		195,
		169,
		202,
		193,
		176,
		156,
		148,
		167,
		-1,
		137,
		-1,
		112,
		115,
		140,
		148,
		165,
		159,
		137,
		152,
		142,
		133,
		142,
		201,
		-1,
		171,
		204,
		168,
		162,
		138,
		142,
		158,
		-1,
		134,
		116,
		-1,
		144,
		134,
		182,
		157,
		152,
		139,
		146,
		146,
		139,
		-1,
		-1,
		-1,
		173,
		172,
		164,
		158,
		158,
		143,
		134,
		-1,
		146,
		128,
		107,
		124,
		124,
		115,
		123,
		172,
		168,
		159,
		159,
		147,
		-1,
		274,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		167,
		162,
		135,
		123,
		129,
		125,
		111,
		117,
		119,
		127,
		125,
		122,
		134,
		130,
		150,
		146,
		178,
		-1,
		269,
		-1,
		203,
		-1,
		-1,
		185,
		165,
		157,
		146,
		135,
		133,
		124,
		115,
		137,
		153,
		137,
		135,
		140,
		145,
		-1,
		258,
		257,
		-1,
		204,
		196,
		182,
		-1,
		175,
		-1,
		181,
		142,
		-1,
		144,
		124,
		-1,
		146,
		142,
		-1,
		-1,
		245,
		220,
		-1,
		-1,
		-1,
		205,
		185,
		176,
		160,
		-1,
		135,
		135,
		-1,
		-1,
		-1,
		230,
		229,
		-1,
		198,
		201,
		-1,
		191,
		182,
		190,
		137,
		141,
		-1,
		-1,
		-1,
		239,
		220,
		214,
		213,
		211,
		206,
		203,
		189,
		173,
		151,
		140,
		161,
		-1,
		-1,
		-1,
		211,
		203,
		196,
		-1,
		-1,
		198,
		181,
		162,
		160,
		-1,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		188,
		-1,
		-1,
		194,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		222,
		-1,
		-1,
		-1,
		184,
		180,
		181,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		268,
		232,
		-1,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		247,
		245,
		-1,
		-1,
		-1,
		204,
		188,
		-1,
		174,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		209,
		-1,
		209,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		222,
		214,
		222,
		-1,
		194,
		196,
		-1,
		244,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		199,
		206,
		228,
		231,
		267,
		-1,
		218
	],
	[
		-1,
		233,
		222,
		233,
		241,
		214,
		221,
		-1,
		240,
		244,
		210,
		204,
		243,
		212,
		218,
		229,
		-1,
		-1,
		-1,
		233,
		232,
		200,
		198,
		207,
		212,
		219,
		-1,
		218,
		-1,
		254,
		233,
		244,
		249,
		193,
		190,
		210,
		229,
		211,
		203,
		269,
		223,
		194,
		188,
		206,
		196,
		205,
		197,
		-1,
		194,
		184,
		206,
		185,
		196,
		188,
		-1,
		-1,
		188,
		189,
		195,
		181,
		187,
		183,
		-1,
		193,
		177,
		-1,
		-1,
		178,
		179,
		163,
		166,
		174,
		172,
		185,
		177,
		172,
		-1,
		-1,
		169,
		165,
		172,
		159,
		155,
		172,
		185,
		167,
		181,
		180,
		-1,
		175,
		193,
		198,
		166,
		164,
		148,
		146,
		164,
		166,
		172,
		172,
		-1,
		184,
		185,
		180,
		188,
		188,
		164,
		151,
		151,
		161,
		154,
		173,
		161,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		184,
		167,
		184,
		176,
		166,
		181,
		174,
		154,
		151,
		149,
		146,
		162,
		160,
		170,
		-1,
		-1,
		258,
		227,
		262,
		219,
		204,
		-1,
		180,
		160,
		166,
		170,
		164,
		157,
		171,
		167,
		-1,
		140,
		139,
		167,
		153,
		164,
		218,
		-1,
		-1,
		216,
		208,
		193,
		196,
		190,
		186,
		175,
		174,
		166,
		152,
		148,
		154,
		157,
		157,
		163,
		134,
		144,
		148,
		146,
		171,
		-1,
		-1,
		206,
		-1,
		-1,
		215,
		198,
		-1,
		181,
		188,
		188,
		202,
		188,
		209,
		185,
		176,
		168,
		162,
		150,
		152,
		149,
		162,
		150,
		131,
		156,
		160,
		141,
		162,
		157,
		-1,
		205,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		174,
		177,
		183,
		207,
		217,
		-1,
		197,
		185,
		186,
		171,
		168,
		155,
		143,
		156,
		141,
		148,
		147,
		135,
		133,
		163,
		138,
		160,
		157,
		176,
		181,
		175,
		184,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		211,
		-1,
		225,
		224,
		199,
		182,
		185,
		172,
		163,
		150,
		139,
		150,
		139,
		136,
		144,
		127,
		142,
		133,
		132,
		150,
		160,
		168,
		172,
		178,
		-1,
		273,
		-1,
		215,
		199,
		201,
		173,
		194,
		-1,
		231,
		226,
		216,
		201,
		192,
		-1,
		181,
		178,
		168,
		146,
		131,
		148,
		140,
		138,
		140,
		122,
		136,
		127,
		145,
		152,
		150,
		154,
		174,
		186,
		233,
		223,
		-1,
		205,
		210,
		169,
		177,
		196,
		234,
		198,
		-1,
		193,
		-1,
		183,
		196,
		-1,
		152,
		148,
		130,
		131,
		126,
		141,
		133,
		118,
		115,
		133,
		136,
		143,
		147,
		163,
		-1,
		-1,
		218,
		222,
		211,
		162,
		181,
		205,
		242,
		191,
		180,
		179,
		-1,
		170,
		166,
		163,
		151,
		138,
		123,
		124,
		132,
		144,
		123,
		117,
		114,
		134,
		160,
		138,
		150,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		188,
		159,
		183,
		225,
		209,
		202,
		190,
		155,
		155,
		149,
		-1,
		162,
		141,
		132,
		121,
		119,
		132,
		124,
		132,
		112,
		110,
		129,
		141,
		132,
		143,
		-1,
		-1,
		-1,
		218,
		207,
		208,
		154,
		177,
		214,
		188,
		174,
		179,
		154,
		147,
		141,
		175,
		158,
		139,
		128,
		120,
		109,
		120,
		128,
		126,
		108,
		117,
		123,
		147,
		131,
		137,
		-1,
		-1,
		225,
		215,
		199,
		201,
		198,
		168,
		175,
		207,
		179,
		192,
		-1,
		146,
		-1,
		135,
		143,
		133,
		128,
		125,
		112,
		111,
		125,
		125,
		115,
		110,
		117,
		152,
		152,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		218,
		213,
		188,
		165,
		149,
		185,
		-1,
		162,
		163,
		-1,
		140,
		134,
		140,
		135,
		131,
		116,
		120,
		122,
		125,
		113,
		119,
		120,
		102,
		126,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		211,
		190,
		183,
		203,
		144,
		196,
		-1,
		-1,
		147,
		140,
		-1,
		127,
		126,
		128,
		120,
		114,
		121,
		116,
		107,
		120,
		113,
		107,
		101,
		114,
		118,
		122,
		111,
		107,
		104,
		118,
		-1,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		164,
		-1,
		156,
		148,
		138,
		132,
		126,
		137,
		137,
		142,
		126,
		129,
		124,
		121,
		111,
		102,
		95,
		106,
		91,
		109,
		117,
		109,
		103,
		102,
		114,
		-1,
		231,
		217,
		188,
		-1,
		-1,
		177,
		-1,
		141,
		155,
		171,
		-1,
		164,
		143,
		158,
		136,
		140,
		140,
		133,
		134,
		104,
		109,
		111,
		99,
		102,
		96,
		99,
		91,
		113,
		113,
		97,
		98,
		107,
		-1,
		237,
		224,
		182,
		178,
		167,
		187,
		138,
		126,
		158,
		-1,
		-1,
		164,
		-1,
		118,
		120,
		154,
		152,
		123,
		98,
		105,
		123,
		96,
		91,
		101,
		90,
		87,
		85,
		107,
		93,
		91,
		110,
		126,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		153,
		140,
		134,
		-1,
		175,
		-1,
		142,
		130,
		117,
		99,
		139,
		-1,
		97,
		93,
		100,
		-1,
		116,
		-1,
		88,
		91,
		82,
		79,
		79,
		90,
		88,
		99,
		116,
		-1,
		187,
		172,
		165,
		155,
		169,
		140,
		-1,
		195,
		-1,
		-1,
		129,
		123,
		123,
		92,
		89,
		113,
		93,
		85,
		100,
		99,
		86,
		85,
		73,
		73,
		76,
		82,
		95,
		115,
		106,
		117,
		-1,
		-1,
		-1,
		192,
		178,
		182,
		142,
		161,
		-1,
		-1,
		190,
		146,
		132,
		-1,
		84,
		102,
		92,
		91,
		81,
		86,
		87,
		77,
		75,
		71,
		80,
		84,
		91,
		96,
		117,
		111,
		131,
		-1,
		-1,
		175,
		180,
		168,
		154,
		173,
		-1,
		-1,
		-1,
		136,
		137,
		103,
		82,
		90,
		-1,
		-1,
		85,
		78,
		72,
		75,
		63,
		83,
		90,
		104,
		90,
		105,
		116,
		124,
		123,
		-1,
		178,
		165,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		-1,
		-1,
		115,
		60,
		49,
		44,
		0,
		84,
		-1,
		58,
		69,
		62,
		81,
		88,
		106,
		91,
		85,
		96,
		111,
		128,
		-1,
		-1,
		190,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		72,
		66,
		37,
		30,
		14,
		-1,
		60,
		62,
		59,
		71,
		82,
		87,
		95,
		79,
		93,
		96,
		109,
		123,
		127,
		213,
		-1,
		154,
		-1,
		-1,
		-1,
		90,
		105,
		72,
		49,
		26,
		31,
		41,
		46,
		51,
		71,
		77,
		88,
		73,
		77,
		92,
		102,
		101,
		118,
		128,
		-1,
		-1,
		152,
		148,
		116,
		98,
		102,
		99,
		-1,
		-1,
		37,
		47,
		43,
		53,
		61,
		64,
		69,
		71,
		89,
		108,
		96,
		111,
		126,
		122,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		-1,
		-1,
		117,
		127,
		74,
		56,
		52,
		48,
		55,
		64,
		59,
		64,
		89,
		84,
		93,
		98,
		102,
		125,
		114,
		153,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		143,
		135,
		130,
		136,
		137,
		129,
		89,
		86,
		-1,
		54,
		93,
		65,
		72,
		64,
		77,
		82,
		88,
		92,
		99,
		115,
		114,
		109,
		145,
		136,
		142,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		136,
		132,
		122,
		112,
		115,
		-1,
		-1,
		103,
		100,
		78,
		74,
		78,
		71,
		66,
		104,
		80,
		88,
		92,
		96,
		102,
		107,
		112,
		118,
		133,
		148,
		-1,
		188,
		225,
		218,
		186,
		194,
		225,
		-1,
		126,
		118,
		129,
		104,
		106,
		-1,
		-1,
		76,
		73,
		78,
		81,
		78,
		90,
		89,
		100,
		102,
		107,
		95,
		94,
		112,
		116,
		125,
		132,
		122,
		135,
		139,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		123,
		-1,
		-1,
		135,
		107,
		91,
		81,
		75,
		125,
		95,
		90,
		92,
		94,
		98,
		89,
		112,
		103,
		103,
		106,
		121,
		126,
		118,
		132,
		132,
		133,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		151,
		-1,
		118,
		-1,
		93,
		97,
		103,
		106,
		117,
		104,
		102,
		110,
		118,
		101,
		111,
		107,
		108,
		117,
		128,
		140,
		139,
		140,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		135,
		174,
		189,
		-1,
		160,
		-1,
		-1,
		-1,
		107,
		116,
		108,
		124,
		116,
		116,
		96,
		100,
		106,
		113,
		123,
		125,
		117,
		121,
		134,
		145,
		148,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		150,
		141,
		168,
		194,
		185,
		180,
		167,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		123,
		117,
		100,
		102,
		106,
		116,
		131,
		134,
		124,
		122,
		116,
		148,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		169,
		164,
		168,
		184,
		209,
		-1,
		170,
		-1,
		-1,
		151,
		-1,
		-1,
		159,
		122,
		111,
		102,
		108,
		114,
		125,
		142,
		130,
		131,
		121,
		131,
		144,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		157,
		155,
		144,
		-1,
		134,
		107,
		112,
		137,
		144,
		139,
		133,
		127,
		134,
		133,
		141,
		149,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		152,
		145,
		133,
		121,
		111,
		121,
		129,
		129,
		132,
		130,
		125,
		136,
		128,
		132,
		149,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		186,
		170,
		151,
		-1,
		121,
		134,
		165,
		133,
		138,
		133,
		131,
		142,
		131,
		134,
		148,
		143,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		176,
		195,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		158,
		154,
		-1,
		-1,
		122,
		147,
		136,
		144,
		139,
		135,
		141,
		144,
		133,
		137,
		149,
		-1,
		-1,
		158,
		159,
		164,
		-1,
		182,
		-1,
		200,
		-1,
		167,
		173,
		161,
		-1,
		-1,
		-1,
		160,
		123,
		140,
		154,
		159,
		157,
		148,
		139,
		146,
		144,
		140,
		151,
		-1,
		-1,
		-1,
		200,
		174,
		207,
		198,
		181,
		161,
		153,
		172,
		-1,
		142,
		-1,
		117,
		120,
		145,
		153,
		170,
		164,
		142,
		157,
		147,
		138,
		147,
		206,
		-1,
		176,
		209,
		173,
		167,
		143,
		147,
		163,
		-1,
		139,
		121,
		-1,
		149,
		139,
		187,
		162,
		157,
		144,
		151,
		151,
		144,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		163,
		148,
		139,
		-1,
		151,
		133,
		112,
		129,
		129,
		120,
		128,
		177,
		173,
		164,
		164,
		152,
		-1,
		279,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		167,
		140,
		128,
		134,
		130,
		116,
		122,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		151,
		183,
		-1,
		274,
		-1,
		208,
		-1,
		-1,
		190,
		170,
		162,
		151,
		140,
		138,
		129,
		120,
		142,
		158,
		142,
		140,
		145,
		150,
		-1,
		263,
		262,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		186,
		147,
		-1,
		149,
		129,
		-1,
		151,
		147,
		-1,
		-1,
		250,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		181,
		165,
		-1,
		140,
		140,
		-1,
		-1,
		-1,
		235,
		234,
		-1,
		203,
		206,
		-1,
		196,
		187,
		195,
		142,
		146,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		218,
		216,
		211,
		208,
		194,
		178,
		156,
		145,
		166,
		-1,
		-1,
		-1,
		216,
		208,
		201,
		-1,
		-1,
		203,
		186,
		167,
		165,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		193,
		-1,
		-1,
		199,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		227,
		-1,
		-1,
		-1,
		189,
		185,
		186,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		273,
		237,
		-1,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		179,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		214,
		-1,
		214,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		227,
		219,
		227,
		-1,
		199,
		201,
		-1,
		249,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		204,
		211,
		233,
		236,
		272,
		-1,
		223
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		215,
		217,
		183,
		177,
		216,
		187,
		193,
		204,
		-1,
		-1,
		-1,
		206,
		205,
		175,
		173,
		182,
		187,
		194,
		-1,
		198,
		-1,
		227,
		206,
		217,
		222,
		168,
		165,
		185,
		204,
		191,
		183,
		242,
		198,
		169,
		163,
		181,
		176,
		185,
		177,
		-1,
		169,
		159,
		181,
		165,
		176,
		168,
		-1,
		-1,
		163,
		164,
		170,
		161,
		167,
		163,
		-1,
		173,
		157,
		-1,
		-1,
		153,
		159,
		143,
		146,
		154,
		152,
		165,
		157,
		152,
		-1,
		-1,
		149,
		145,
		152,
		139,
		135,
		152,
		165,
		147,
		161,
		160,
		-1,
		142,
		160,
		169,
		146,
		144,
		128,
		126,
		144,
		146,
		152,
		155,
		-1,
		151,
		152,
		147,
		155,
		160,
		144,
		131,
		131,
		141,
		134,
		153,
		144,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		134,
		131,
		129,
		126,
		142,
		143,
		153,
		-1,
		-1,
		230,
		199,
		234,
		191,
		176,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		120,
		119,
		150,
		136,
		147,
		190,
		-1,
		-1,
		188,
		180,
		165,
		168,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		114,
		124,
		128,
		137,
		154,
		-1,
		-1,
		197,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		160,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		111,
		136,
		140,
		132,
		153,
		148,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		189,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		118,
		120,
		153,
		129,
		151,
		148,
		167,
		172,
		166,
		175,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		197,
		196,
		171,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		118,
		131,
		124,
		123,
		141,
		151,
		159,
		163,
		169,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		198,
		188,
		173,
		164,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		110,
		113,
		127,
		118,
		136,
		143,
		141,
		145,
		165,
		177,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		113,
		109,
		106,
		124,
		127,
		134,
		138,
		154,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		111,
		90,
		108,
		105,
		125,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		129,
		108,
		99,
		88,
		86,
		99,
		91,
		109,
		103,
		101,
		120,
		132,
		123,
		135,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		139,
		125,
		103,
		95,
		87,
		76,
		87,
		95,
		99,
		99,
		108,
		114,
		138,
		123,
		129,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		98,
		96,
		89,
		92,
		73,
		78,
		92,
		101,
		106,
		101,
		108,
		143,
		143,
		113,
		133,
		136,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		101,
		93,
		94,
		77,
		77,
		78,
		92,
		76,
		95,
		97,
		93,
		118,
		-1,
		121,
		115,
		123,
		113,
		101,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		75,
		67,
		61,
		70,
		63,
		70,
		83,
		88,
		98,
		93,
		106,
		110,
		114,
		103,
		99,
		96,
		110,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		92,
		90,
		89,
		73,
		76,
		71,
		68,
		74,
		77,
		80,
		96,
		83,
		101,
		109,
		101,
		95,
		94,
		106,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		102,
		87,
		80,
		81,
		51,
		56,
		64,
		63,
		66,
		80,
		91,
		83,
		105,
		105,
		89,
		90,
		99,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		101,
		99,
		70,
		45,
		52,
		75,
		60,
		55,
		78,
		75,
		75,
		77,
		99,
		85,
		83,
		102,
		118,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		42,
		38,
		47,
		-1,
		80,
		-1,
		52,
		65,
		65,
		67,
		71,
		82,
		80,
		91,
		108,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		118,
		58,
		38,
		28,
		47,
		63,
		50,
		49,
		55,
		60,
		64,
		74,
		87,
		107,
		98,
		110,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		120,
		56,
		44,
		34,
		24,
		44,
		51,
		41,
		46,
		55,
		67,
		72,
		83,
		88,
		109,
		109,
		123,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		139,
		118,
		45,
		-1,
		-1,
		26,
		20,
		35,
		40,
		55,
		69,
		76,
		93,
		82,
		97,
		109,
		117,
		121,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		151,
		96,
		85,
		80,
		84,
		0,
		-1,
		36,
		35,
		53,
		65,
		72,
		95,
		89,
		83,
		92,
		109,
		126,
		-1,
		-1,
		162,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		73,
		66,
		70,
		-1,
		45,
		43,
		57,
		66,
		80,
		85,
		93,
		77,
		91,
		94,
		107,
		121,
		125,
		185,
		-1,
		166,
		-1,
		-1,
		-1,
		126,
		141,
		112,
		89,
		62,
		57,
		50,
		44,
		49,
		69,
		75,
		86,
		71,
		75,
		90,
		100,
		99,
		116,
		126,
		-1,
		-1,
		164,
		160,
		152,
		134,
		138,
		139,
		-1,
		-1,
		66,
		57,
		48,
		51,
		59,
		62,
		67,
		69,
		87,
		106,
		94,
		109,
		124,
		120,
		-1,
		-1,
		-1,
		176,
		-1,
		178,
		-1,
		-1,
		153,
		137,
		84,
		66,
		62,
		60,
		53,
		62,
		57,
		62,
		87,
		82,
		91,
		96,
		100,
		123,
		112,
		151,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		155,
		147,
		142,
		148,
		150,
		141,
		99,
		96,
		-1,
		66,
		91,
		63,
		70,
		62,
		75,
		80,
		86,
		90,
		97,
		113,
		112,
		107,
		143,
		134,
		140,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		148,
		144,
		134,
		124,
		127,
		-1,
		-1,
		115,
		112,
		88,
		72,
		76,
		69,
		64,
		102,
		78,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		195,
		237,
		230,
		198,
		206,
		237,
		-1,
		138,
		130,
		141,
		116,
		118,
		-1,
		-1,
		88,
		85,
		90,
		79,
		76,
		88,
		87,
		98,
		100,
		105,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		135,
		-1,
		-1,
		147,
		119,
		103,
		93,
		87,
		137,
		93,
		88,
		90,
		92,
		96,
		87,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		163,
		-1,
		130,
		-1,
		105,
		109,
		101,
		104,
		115,
		102,
		100,
		108,
		116,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		147,
		186,
		201,
		-1,
		172,
		-1,
		-1,
		-1,
		119,
		114,
		106,
		122,
		114,
		114,
		94,
		98,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		162,
		153,
		180,
		206,
		197,
		192,
		179,
		-1,
		-1,
		142,
		124,
		-1,
		-1,
		121,
		115,
		98,
		100,
		104,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		181,
		176,
		180,
		196,
		221,
		-1,
		182,
		-1,
		-1,
		163,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		112,
		123,
		140,
		128,
		129,
		119,
		129,
		142,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		135,
		142,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		127,
		127,
		130,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		188,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		170,
		171,
		176,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		158,
		121,
		138,
		152,
		157,
		155,
		146,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		118,
		143,
		151,
		168,
		162,
		140,
		155,
		145,
		136,
		145,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		185,
		160,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		175,
		171,
		162,
		162,
		150,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		143,
		148,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		208,
		197,
		208,
		216,
		189,
		196,
		-1,
		215,
		219,
		185,
		179,
		218,
		187,
		193,
		204,
		-1,
		-1,
		-1,
		208,
		207,
		175,
		173,
		182,
		187,
		194,
		-1,
		193,
		-1,
		229,
		208,
		219,
		224,
		168,
		165,
		185,
		204,
		186,
		178,
		244,
		198,
		169,
		163,
		181,
		171,
		180,
		172,
		-1,
		169,
		159,
		181,
		160,
		171,
		163,
		-1,
		-1,
		163,
		164,
		170,
		156,
		162,
		158,
		-1,
		168,
		152,
		-1,
		-1,
		153,
		154,
		138,
		141,
		149,
		147,
		160,
		152,
		147,
		-1,
		-1,
		144,
		140,
		147,
		134,
		130,
		147,
		160,
		142,
		156,
		155,
		-1,
		147,
		165,
		173,
		141,
		139,
		123,
		121,
		139,
		141,
		147,
		147,
		-1,
		156,
		157,
		152,
		160,
		163,
		139,
		126,
		126,
		136,
		129,
		148,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		129,
		126,
		124,
		121,
		137,
		135,
		145,
		-1,
		-1,
		235,
		204,
		239,
		196,
		181,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		115,
		114,
		142,
		128,
		139,
		195,
		-1,
		-1,
		193,
		185,
		170,
		173,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		109,
		119,
		123,
		121,
		146,
		-1,
		-1,
		181,
		-1,
		-1,
		192,
		175,
		-1,
		158,
		165,
		165,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		106,
		131,
		135,
		116,
		137,
		132,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		151,
		154,
		160,
		184,
		194,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		110,
		108,
		138,
		113,
		135,
		132,
		151,
		156,
		150,
		159,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		188,
		-1,
		202,
		201,
		176,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		102,
		117,
		108,
		107,
		125,
		135,
		143,
		147,
		153,
		-1,
		250,
		-1,
		192,
		176,
		178,
		150,
		171,
		-1,
		208,
		203,
		193,
		178,
		169,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		115,
		97,
		111,
		102,
		120,
		127,
		125,
		129,
		149,
		161,
		210,
		200,
		-1,
		182,
		187,
		146,
		154,
		173,
		211,
		175,
		-1,
		170,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		108,
		93,
		90,
		108,
		111,
		118,
		122,
		138,
		-1,
		-1,
		195,
		199,
		188,
		139,
		158,
		182,
		219,
		168,
		157,
		156,
		-1,
		147,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		116,
		95,
		92,
		89,
		109,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		165,
		136,
		160,
		202,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		96,
		107,
		87,
		85,
		104,
		116,
		107,
		118,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		131,
		154,
		191,
		165,
		151,
		156,
		131,
		124,
		118,
		144,
		130,
		108,
		100,
		92,
		81,
		92,
		100,
		101,
		83,
		92,
		98,
		122,
		106,
		112,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		145,
		152,
		184,
		156,
		169,
		-1,
		123,
		-1,
		112,
		103,
		101,
		94,
		97,
		78,
		83,
		97,
		100,
		90,
		85,
		92,
		127,
		127,
		96,
		116,
		119,
		-1,
		-1,
		-1,
		195,
		190,
		165,
		142,
		126,
		162,
		-1,
		139,
		140,
		-1,
		117,
		111,
		106,
		98,
		99,
		82,
		82,
		83,
		97,
		81,
		94,
		94,
		77,
		101,
		-1,
		104,
		98,
		106,
		96,
		84,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		121,
		173,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		80,
		72,
		66,
		75,
		68,
		75,
		88,
		86,
		82,
		76,
		89,
		93,
		97,
		86,
		82,
		79,
		93,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		141,
		-1,
		133,
		125,
		115,
		109,
		103,
		97,
		95,
		94,
		78,
		81,
		76,
		73,
		63,
		75,
		68,
		81,
		66,
		84,
		92,
		84,
		78,
		77,
		89,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		107,
		92,
		85,
		86,
		56,
		61,
		63,
		51,
		54,
		68,
		74,
		66,
		88,
		88,
		72,
		73,
		82,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		106,
		104,
		75,
		50,
		57,
		75,
		48,
		43,
		66,
		63,
		62,
		60,
		82,
		68,
		66,
		85,
		101,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		143,
		129,
		112,
		147,
		-1,
		49,
		45,
		52,
		-1,
		68,
		-1,
		40,
		53,
		53,
		54,
		54,
		65,
		63,
		74,
		91,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		105,
		102,
		65,
		45,
		37,
		52,
		51,
		38,
		37,
		43,
		48,
		51,
		57,
		70,
		90,
		81,
		92,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		203,
		159,
		145,
		-1,
		97,
		65,
		53,
		43,
		33,
		34,
		39,
		29,
		34,
		43,
		55,
		59,
		66,
		71,
		92,
		86,
		106,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		149,
		150,
		116,
		95,
		54,
		-1,
		-1,
		37,
		26,
		21,
		26,
		38,
		55,
		62,
		79,
		65,
		80,
		91,
		99,
		98,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		128,
		73,
		62,
		57,
		61,
		36,
		-1,
		0,
		21,
		37,
		51,
		58,
		81,
		66,
		60,
		71,
		86,
		103,
		-1,
		-1,
		167,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		85,
		79,
		50,
		43,
		47,
		-1,
		22,
		29,
		34,
		46,
		57,
		62,
		70,
		54,
		68,
		71,
		84,
		98,
		102,
		190,
		-1,
		143,
		-1,
		-1,
		-1,
		103,
		118,
		89,
		66,
		39,
		34,
		27,
		21,
		26,
		46,
		52,
		63,
		48,
		52,
		67,
		77,
		76,
		93,
		103,
		-1,
		-1,
		141,
		137,
		129,
		111,
		115,
		116,
		-1,
		-1,
		43,
		34,
		25,
		28,
		36,
		39,
		44,
		46,
		64,
		83,
		71,
		86,
		101,
		97,
		-1,
		-1,
		-1,
		153,
		-1,
		155,
		-1,
		-1,
		130,
		114,
		61,
		43,
		39,
		37,
		30,
		39,
		34,
		39,
		64,
		59,
		68,
		73,
		77,
		100,
		89,
		128,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		132,
		124,
		119,
		125,
		127,
		118,
		76,
		73,
		-1,
		43,
		68,
		40,
		47,
		39,
		52,
		57,
		63,
		67,
		74,
		90,
		89,
		84,
		120,
		111,
		117,
		-1,
		-1,
		223,
		212,
		201,
		207,
		-1,
		125,
		121,
		111,
		101,
		104,
		-1,
		-1,
		92,
		89,
		65,
		49,
		53,
		46,
		41,
		79,
		55,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		177,
		214,
		207,
		175,
		183,
		214,
		-1,
		115,
		107,
		118,
		93,
		95,
		-1,
		-1,
		65,
		62,
		67,
		56,
		53,
		65,
		64,
		75,
		77,
		82,
		70,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		170,
		190,
		169,
		172,
		196,
		210,
		-1,
		112,
		-1,
		-1,
		124,
		96,
		80,
		70,
		64,
		114,
		70,
		65,
		67,
		69,
		73,
		64,
		87,
		78,
		78,
		81,
		96,
		101,
		93,
		107,
		107,
		108,
		-1,
		159,
		170,
		163,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		140,
		-1,
		107,
		-1,
		82,
		86,
		78,
		81,
		92,
		79,
		77,
		85,
		93,
		76,
		86,
		82,
		83,
		92,
		103,
		115,
		114,
		115,
		184,
		140,
		143,
		154,
		165,
		180,
		184,
		-1,
		124,
		163,
		178,
		-1,
		149,
		-1,
		-1,
		-1,
		96,
		91,
		83,
		99,
		91,
		91,
		71,
		75,
		81,
		88,
		98,
		100,
		92,
		96,
		109,
		120,
		123,
		180,
		171,
		184,
		129,
		129,
		150,
		159,
		180,
		139,
		130,
		157,
		183,
		174,
		169,
		156,
		-1,
		-1,
		119,
		101,
		-1,
		-1,
		98,
		92,
		75,
		77,
		81,
		91,
		106,
		109,
		99,
		97,
		91,
		123,
		-1,
		173,
		172,
		161,
		158,
		134,
		125,
		120,
		147,
		-1,
		-1,
		142,
		158,
		153,
		157,
		173,
		198,
		-1,
		159,
		-1,
		-1,
		140,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		89,
		100,
		117,
		105,
		106,
		96,
		106,
		119,
		157,
		154,
		142,
		140,
		163,
		128,
		116,
		-1,
		129,
		127,
		133,
		140,
		157,
		187,
		-1,
		-1,
		175,
		155,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		112,
		119,
		114,
		108,
		102,
		109,
		108,
		116,
		124,
		166,
		180,
		169,
		165,
		164,
		172,
		121,
		114,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		165,
		161,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		104,
		104,
		107,
		105,
		100,
		111,
		103,
		107,
		124,
		-1,
		200,
		-1,
		152,
		128,
		142,
		157,
		165,
		-1,
		-1,
		-1,
		182,
		168,
		161,
		149,
		147,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		106,
		117,
		106,
		109,
		123,
		118,
		-1,
		-1,
		140,
		143,
		-1,
		-1,
		165,
		174,
		-1,
		173,
		162,
		147,
		139,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		110,
		116,
		119,
		108,
		112,
		124,
		-1,
		-1,
		147,
		148,
		153,
		-1,
		157,
		-1,
		175,
		-1,
		142,
		148,
		136,
		-1,
		-1,
		-1,
		135,
		98,
		115,
		129,
		134,
		132,
		123,
		114,
		121,
		119,
		115,
		126,
		-1,
		-1,
		-1,
		175,
		149,
		182,
		173,
		156,
		136,
		128,
		147,
		-1,
		117,
		-1,
		92,
		95,
		120,
		128,
		145,
		139,
		117,
		132,
		122,
		113,
		122,
		181,
		-1,
		151,
		184,
		148,
		142,
		118,
		122,
		138,
		-1,
		114,
		96,
		-1,
		124,
		114,
		162,
		137,
		132,
		119,
		126,
		126,
		119,
		-1,
		-1,
		-1,
		153,
		152,
		144,
		138,
		138,
		123,
		114,
		-1,
		126,
		108,
		87,
		104,
		104,
		95,
		103,
		152,
		148,
		139,
		139,
		127,
		-1,
		254,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		147,
		142,
		115,
		103,
		109,
		105,
		91,
		97,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		126,
		158,
		-1,
		249,
		-1,
		183,
		-1,
		-1,
		165,
		145,
		137,
		126,
		115,
		113,
		104,
		95,
		117,
		133,
		117,
		115,
		120,
		125,
		-1,
		238,
		237,
		-1,
		184,
		176,
		162,
		-1,
		155,
		-1,
		161,
		122,
		-1,
		124,
		104,
		-1,
		126,
		122,
		-1,
		-1,
		225,
		200,
		-1,
		-1,
		-1,
		185,
		165,
		156,
		140,
		-1,
		115,
		115,
		-1,
		-1,
		-1,
		210,
		209,
		-1,
		178,
		181,
		-1,
		171,
		162,
		170,
		117,
		121,
		-1,
		-1,
		-1,
		219,
		200,
		194,
		193,
		191,
		186,
		183,
		169,
		153,
		131,
		120,
		141,
		-1,
		-1,
		-1,
		191,
		183,
		176,
		-1,
		-1,
		178,
		161,
		142,
		140,
		-1,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		168,
		-1,
		-1,
		174,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		202,
		-1,
		-1,
		-1,
		164,
		160,
		161,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		248,
		212,
		-1,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		227,
		225,
		-1,
		-1,
		-1,
		184,
		168,
		-1,
		154,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		189,
		-1,
		189,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		202,
		194,
		202,
		-1,
		174,
		176,
		-1,
		224,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		179,
		186,
		208,
		211,
		247,
		-1,
		198
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		138,
		156,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		147,
		148,
		143,
		151,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		232,
		201,
		236,
		193,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		105,
		104,
		132,
		118,
		129,
		192,
		-1,
		-1,
		190,
		182,
		167,
		170,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		99,
		109,
		113,
		111,
		136,
		-1,
		-1,
		171,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		96,
		121,
		125,
		106,
		127,
		122,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		100,
		98,
		128,
		103,
		125,
		122,
		141,
		146,
		140,
		149,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		92,
		107,
		98,
		97,
		115,
		125,
		133,
		137,
		143,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		197,
		189,
		174,
		166,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		105,
		87,
		101,
		92,
		110,
		117,
		115,
		119,
		139,
		151,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		98,
		83,
		80,
		98,
		101,
		108,
		112,
		128,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		107,
		86,
		82,
		79,
		99,
		125,
		103,
		115,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		87,
		97,
		77,
		75,
		94,
		106,
		97,
		109,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		138,
		121,
		102,
		91,
		83,
		72,
		83,
		91,
		91,
		73,
		82,
		88,
		112,
		97,
		103,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		100,
		96,
		91,
		88,
		75,
		74,
		88,
		90,
		80,
		75,
		82,
		117,
		117,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		103,
		95,
		94,
		79,
		79,
		80,
		88,
		78,
		84,
		85,
		67,
		92,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		77,
		69,
		63,
		72,
		65,
		72,
		85,
		79,
		72,
		67,
		80,
		84,
		88,
		77,
		73,
		70,
		84,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		94,
		92,
		91,
		75,
		78,
		73,
		70,
		60,
		68,
		61,
		72,
		57,
		75,
		83,
		75,
		69,
		68,
		80,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		104,
		89,
		82,
		83,
		53,
		58,
		60,
		48,
		51,
		62,
		65,
		57,
		79,
		79,
		63,
		64,
		73,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		103,
		101,
		72,
		47,
		54,
		72,
		45,
		40,
		63,
		56,
		49,
		51,
		73,
		59,
		57,
		76,
		92,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		46,
		42,
		49,
		-1,
		65,
		-1,
		37,
		50,
		44,
		41,
		45,
		56,
		54,
		65,
		82,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		113,
		110,
		62,
		42,
		34,
		49,
		48,
		35,
		34,
		32,
		35,
		38,
		48,
		61,
		81,
		72,
		84,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		105,
		62,
		50,
		40,
		30,
		31,
		36,
		26,
		23,
		32,
		42,
		46,
		57,
		62,
		83,
		84,
		97,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		158,
		124,
		103,
		51,
		-1,
		-1,
		34,
		23,
		18,
		10,
		25,
		39,
		46,
		65,
		56,
		71,
		83,
		91,
		96,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		136,
		81,
		70,
		65,
		69,
		33,
		-1,
		21,
		0,
		23,
		35,
		42,
		67,
		64,
		58,
		66,
		84,
		101,
		-1,
		-1,
		164,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		93,
		87,
		58,
		51,
		55,
		-1,
		30,
		13,
		27,
		36,
		52,
		57,
		65,
		60,
		67,
		69,
		82,
		96,
		100,
		187,
		-1,
		145,
		-1,
		-1,
		-1,
		111,
		126,
		97,
		74,
		47,
		42,
		35,
		29,
		21,
		41,
		47,
		58,
		54,
		58,
		66,
		75,
		74,
		91,
		101,
		-1,
		-1,
		143,
		139,
		137,
		119,
		123,
		124,
		-1,
		-1,
		50,
		42,
		32,
		33,
		31,
		34,
		50,
		52,
		70,
		82,
		70,
		84,
		100,
		105,
		-1,
		-1,
		-1,
		155,
		-1,
		157,
		-1,
		-1,
		138,
		122,
		69,
		51,
		47,
		45,
		35,
		44,
		40,
		45,
		70,
		67,
		76,
		72,
		85,
		108,
		97,
		136,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		134,
		126,
		121,
		126,
		127,
		118,
		84,
		81,
		-1,
		51,
		71,
		46,
		53,
		45,
		60,
		65,
		71,
		75,
		82,
		98,
		97,
		92,
		128,
		119,
		125,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		127,
		123,
		112,
		102,
		104,
		-1,
		-1,
		92,
		89,
		68,
		55,
		61,
		54,
		49,
		87,
		63,
		71,
		75,
		79,
		85,
		90,
		95,
		101,
		116,
		131,
		-1,
		179,
		216,
		209,
		177,
		185,
		216,
		-1,
		117,
		109,
		120,
		95,
		95,
		-1,
		-1,
		65,
		64,
		69,
		62,
		59,
		72,
		71,
		83,
		85,
		90,
		78,
		77,
		95,
		99,
		108,
		115,
		105,
		118,
		122,
		-1,
		172,
		192,
		171,
		174,
		198,
		212,
		-1,
		114,
		-1,
		-1,
		126,
		96,
		80,
		72,
		64,
		116,
		76,
		71,
		73,
		75,
		81,
		72,
		95,
		86,
		86,
		89,
		104,
		109,
		101,
		115,
		115,
		116,
		-1,
		161,
		172,
		165,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		142,
		-1,
		107,
		-1,
		82,
		86,
		84,
		87,
		98,
		85,
		85,
		93,
		101,
		84,
		94,
		90,
		91,
		100,
		111,
		123,
		122,
		123,
		186,
		142,
		145,
		156,
		167,
		182,
		186,
		-1,
		126,
		165,
		180,
		-1,
		151,
		-1,
		-1,
		-1,
		96,
		97,
		89,
		105,
		97,
		97,
		79,
		83,
		89,
		96,
		106,
		108,
		100,
		104,
		117,
		128,
		131,
		182,
		173,
		186,
		131,
		131,
		152,
		161,
		182,
		141,
		132,
		159,
		185,
		176,
		171,
		158,
		-1,
		-1,
		119,
		107,
		-1,
		-1,
		104,
		100,
		83,
		85,
		89,
		99,
		114,
		117,
		107,
		105,
		99,
		131,
		-1,
		175,
		174,
		163,
		160,
		136,
		127,
		122,
		149,
		-1,
		-1,
		144,
		160,
		155,
		159,
		175,
		200,
		-1,
		161,
		-1,
		-1,
		140,
		-1,
		-1,
		142,
		105,
		94,
		85,
		91,
		97,
		108,
		125,
		113,
		114,
		104,
		114,
		127,
		159,
		156,
		144,
		142,
		165,
		130,
		118,
		-1,
		131,
		129,
		135,
		142,
		159,
		189,
		-1,
		-1,
		177,
		163,
		-1,
		-1,
		140,
		138,
		127,
		-1,
		117,
		90,
		95,
		120,
		127,
		122,
		116,
		110,
		117,
		116,
		124,
		132,
		168,
		182,
		171,
		167,
		166,
		174,
		123,
		116,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		135,
		128,
		116,
		104,
		94,
		104,
		112,
		112,
		115,
		113,
		108,
		119,
		111,
		115,
		132,
		-1,
		202,
		-1,
		154,
		130,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		169,
		153,
		134,
		-1,
		104,
		117,
		148,
		116,
		121,
		116,
		114,
		125,
		114,
		117,
		131,
		126,
		-1,
		-1,
		142,
		145,
		-1,
		-1,
		167,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		141,
		137,
		-1,
		-1,
		105,
		130,
		119,
		127,
		122,
		118,
		124,
		127,
		116,
		120,
		132,
		-1,
		-1,
		149,
		150,
		155,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		143,
		106,
		123,
		137,
		142,
		140,
		131,
		122,
		129,
		127,
		123,
		134,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		103,
		128,
		136,
		153,
		147,
		125,
		140,
		130,
		121,
		130,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		132,
		122,
		170,
		145,
		140,
		127,
		134,
		134,
		127,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		111,
		160,
		156,
		147,
		147,
		135,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		113,
		110,
		122,
		118,
		138,
		134,
		166,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		125,
		123,
		128,
		133,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		134,
		130,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		185,
		189,
		155,
		149,
		188,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		178,
		177,
		145,
		143,
		152,
		157,
		164,
		-1,
		163,
		-1,
		199,
		178,
		189,
		194,
		138,
		135,
		155,
		174,
		156,
		148,
		214,
		168,
		139,
		133,
		151,
		141,
		150,
		142,
		-1,
		139,
		129,
		151,
		130,
		141,
		133,
		-1,
		-1,
		133,
		134,
		140,
		126,
		132,
		128,
		-1,
		138,
		122,
		-1,
		-1,
		123,
		124,
		108,
		111,
		119,
		117,
		130,
		122,
		117,
		-1,
		-1,
		114,
		110,
		117,
		104,
		100,
		117,
		130,
		112,
		126,
		125,
		-1,
		119,
		137,
		143,
		111,
		109,
		93,
		91,
		109,
		111,
		117,
		117,
		-1,
		128,
		129,
		124,
		132,
		133,
		109,
		96,
		96,
		106,
		99,
		118,
		106,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		111,
		128,
		120,
		110,
		125,
		118,
		99,
		96,
		94,
		91,
		107,
		105,
		115,
		-1,
		-1,
		220,
		189,
		219,
		177,
		158,
		-1,
		124,
		104,
		110,
		114,
		108,
		101,
		115,
		111,
		-1,
		85,
		84,
		112,
		98,
		109,
		180,
		-1,
		-1,
		178,
		170,
		154,
		157,
		134,
		130,
		119,
		118,
		110,
		96,
		92,
		98,
		101,
		101,
		107,
		79,
		89,
		93,
		91,
		116,
		-1,
		-1,
		151,
		-1,
		-1,
		177,
		160,
		-1,
		143,
		150,
		140,
		146,
		132,
		153,
		129,
		120,
		112,
		106,
		94,
		96,
		93,
		106,
		94,
		76,
		101,
		105,
		86,
		107,
		102,
		-1,
		150,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		139,
		145,
		169,
		169,
		-1,
		141,
		129,
		130,
		115,
		112,
		99,
		87,
		100,
		85,
		92,
		91,
		80,
		78,
		108,
		83,
		105,
		102,
		121,
		126,
		120,
		129,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		173,
		-1,
		177,
		178,
		153,
		126,
		129,
		116,
		107,
		94,
		83,
		94,
		83,
		80,
		88,
		72,
		87,
		78,
		77,
		95,
		105,
		113,
		117,
		123,
		-1,
		235,
		-1,
		177,
		161,
		163,
		135,
		156,
		-1,
		193,
		178,
		170,
		155,
		154,
		-1,
		125,
		122,
		112,
		90,
		75,
		92,
		84,
		82,
		85,
		67,
		81,
		72,
		90,
		97,
		95,
		99,
		119,
		131,
		195,
		185,
		-1,
		167,
		172,
		131,
		139,
		158,
		196,
		160,
		-1,
		155,
		-1,
		127,
		140,
		-1,
		96,
		92,
		74,
		75,
		70,
		85,
		78,
		63,
		60,
		78,
		81,
		88,
		92,
		108,
		-1,
		-1,
		180,
		184,
		173,
		124,
		143,
		167,
		204,
		153,
		142,
		141,
		-1,
		132,
		110,
		107,
		95,
		82,
		67,
		68,
		76,
		88,
		67,
		62,
		59,
		79,
		105,
		83,
		95,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		150,
		121,
		145,
		187,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		106,
		85,
		76,
		65,
		63,
		76,
		68,
		77,
		57,
		55,
		74,
		86,
		77,
		88,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		150,
		136,
		141,
		116,
		109,
		103,
		119,
		102,
		83,
		72,
		64,
		53,
		64,
		72,
		71,
		53,
		62,
		68,
		92,
		76,
		82,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		141,
		154,
		-1,
		108,
		-1,
		97,
		93,
		77,
		72,
		69,
		57,
		55,
		69,
		70,
		60,
		55,
		62,
		97,
		97,
		66,
		86,
		89,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		102,
		96,
		93,
		79,
		75,
		61,
		65,
		67,
		69,
		58,
		64,
		65,
		47,
		71,
		-1,
		74,
		68,
		76,
		66,
		54,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		89,
		71,
		73,
		68,
		67,
		66,
		63,
		52,
		65,
		58,
		52,
		46,
		59,
		63,
		67,
		56,
		52,
		49,
		63,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		84,
		82,
		95,
		79,
		78,
		75,
		66,
		65,
		47,
		40,
		51,
		36,
		54,
		62,
		54,
		48,
		47,
		59,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		94,
		85,
		102,
		103,
		74,
		75,
		65,
		53,
		52,
		41,
		44,
		36,
		58,
		58,
		42,
		43,
		52,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		99,
		97,
		92,
		68,
		75,
		77,
		50,
		45,
		46,
		35,
		30,
		30,
		52,
		38,
		36,
		55,
		71,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		67,
		63,
		70,
		-1,
		70,
		-1,
		38,
		34,
		25,
		22,
		24,
		35,
		33,
		44,
		61,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		105,
		83,
		63,
		55,
		70,
		53,
		36,
		39,
		16,
		16,
		19,
		27,
		40,
		60,
		51,
		63,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		100,
		83,
		71,
		61,
		51,
		52,
		52,
		27,
		18,
		14,
		23,
		27,
		36,
		41,
		62,
		63,
		76,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		119,
		98,
		72,
		-1,
		-1,
		55,
		44,
		39,
		13,
		6,
		24,
		31,
		48,
		35,
		50,
		62,
		70,
		75,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		131,
		76,
		65,
		60,
		64,
		54,
		-1,
		34,
		24,
		0,
		20,
		27,
		50,
		45,
		39,
		45,
		63,
		80,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		88,
		82,
		53,
		46,
		50,
		-1,
		32,
		18,
		4,
		21,
		42,
		43,
		51,
		43,
		48,
		48,
		61,
		75,
		79,
		175,
		-1,
		142,
		-1,
		-1,
		-1,
		106,
		121,
		92,
		69,
		42,
		37,
		30,
		24,
		12,
		28,
		37,
		48,
		45,
		46,
		47,
		54,
		53,
		70,
		80,
		-1,
		-1,
		140,
		136,
		132,
		114,
		118,
		119,
		-1,
		-1,
		46,
		37,
		28,
		27,
		22,
		25,
		41,
		43,
		58,
		63,
		51,
		63,
		81,
		85,
		-1,
		-1,
		-1,
		152,
		-1,
		154,
		-1,
		-1,
		133,
		117,
		64,
		46,
		42,
		40,
		32,
		41,
		31,
		36,
		61,
		58,
		67,
		53,
		69,
		91,
		81,
		117,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		131,
		123,
		118,
		123,
		124,
		115,
		79,
		76,
		-1,
		46,
		68,
		37,
		44,
		36,
		51,
		56,
		62,
		58,
		66,
		82,
		81,
		76,
		109,
		103,
		109,
		-1,
		-1,
		220,
		209,
		198,
		204,
		-1,
		124,
		120,
		109,
		99,
		101,
		-1,
		-1,
		89,
		86,
		65,
		46,
		52,
		45,
		40,
		78,
		54,
		55,
		59,
		63,
		69,
		74,
		79,
		85,
		100,
		115,
		-1,
		174,
		211,
		204,
		172,
		180,
		211,
		-1,
		114,
		106,
		117,
		92,
		92,
		-1,
		-1,
		62,
		61,
		65,
		53,
		50,
		63,
		62,
		74,
		69,
		75,
		62,
		61,
		79,
		83,
		92,
		99,
		89,
		102,
		106,
		-1,
		167,
		187,
		166,
		169,
		193,
		207,
		-1,
		111,
		-1,
		-1,
		123,
		93,
		77,
		69,
		61,
		112,
		67,
		62,
		64,
		66,
		72,
		63,
		79,
		70,
		70,
		73,
		88,
		93,
		85,
		99,
		99,
		100,
		-1,
		156,
		167,
		160,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		139,
		-1,
		104,
		-1,
		79,
		83,
		75,
		78,
		89,
		76,
		76,
		77,
		92,
		68,
		78,
		74,
		75,
		84,
		95,
		107,
		106,
		107,
		181,
		137,
		140,
		151,
		162,
		177,
		181,
		-1,
		123,
		162,
		177,
		-1,
		148,
		-1,
		-1,
		-1,
		93,
		88,
		80,
		96,
		88,
		88,
		70,
		74,
		73,
		80,
		90,
		92,
		84,
		88,
		101,
		112,
		115,
		177,
		168,
		181,
		126,
		126,
		147,
		156,
		177,
		138,
		129,
		156,
		180,
		173,
		168,
		155,
		-1,
		-1,
		116,
		98,
		-1,
		-1,
		95,
		91,
		74,
		76,
		80,
		83,
		98,
		101,
		91,
		89,
		83,
		115,
		-1,
		170,
		169,
		158,
		155,
		131,
		122,
		117,
		144,
		-1,
		-1,
		139,
		157,
		150,
		154,
		170,
		195,
		-1,
		158,
		-1,
		-1,
		137,
		-1,
		-1,
		133,
		96,
		85,
		76,
		82,
		88,
		99,
		109,
		97,
		98,
		88,
		98,
		111,
		154,
		151,
		139,
		137,
		160,
		125,
		113,
		-1,
		126,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		81,
		86,
		111,
		117,
		106,
		100,
		94,
		101,
		100,
		108,
		116,
		163,
		177,
		166,
		162,
		161,
		169,
		118,
		111,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		95,
		103,
		103,
		104,
		97,
		92,
		103,
		95,
		99,
		116,
		-1,
		197,
		-1,
		149,
		125,
		139,
		154,
		162,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		139,
		107,
		112,
		107,
		98,
		109,
		98,
		101,
		115,
		110,
		-1,
		-1,
		137,
		140,
		-1,
		-1,
		162,
		173,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		96,
		121,
		110,
		118,
		113,
		102,
		108,
		111,
		100,
		104,
		116,
		-1,
		-1,
		144,
		145,
		150,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		134,
		97,
		114,
		128,
		131,
		129,
		120,
		106,
		113,
		111,
		107,
		118,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		94,
		119,
		127,
		142,
		136,
		109,
		124,
		114,
		105,
		114,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		123,
		113,
		158,
		136,
		124,
		111,
		118,
		118,
		111,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		148,
		144,
		131,
		131,
		123,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		124,
		157,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		119,
		124,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		121,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		196,
		185,
		196,
		204,
		177,
		184,
		-1,
		203,
		207,
		173,
		167,
		206,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		196,
		195,
		163,
		161,
		170,
		175,
		182,
		-1,
		181,
		-1,
		217,
		196,
		207,
		212,
		156,
		153,
		173,
		192,
		174,
		166,
		232,
		186,
		157,
		151,
		169,
		159,
		168,
		160,
		-1,
		157,
		147,
		169,
		148,
		159,
		151,
		-1,
		-1,
		151,
		152,
		158,
		144,
		150,
		146,
		-1,
		156,
		140,
		-1,
		-1,
		141,
		142,
		126,
		129,
		137,
		135,
		148,
		140,
		135,
		-1,
		-1,
		132,
		128,
		135,
		122,
		118,
		135,
		148,
		130,
		144,
		143,
		-1,
		136,
		154,
		161,
		129,
		127,
		111,
		109,
		127,
		129,
		135,
		135,
		-1,
		145,
		146,
		141,
		149,
		151,
		127,
		114,
		114,
		124,
		117,
		136,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		128,
		145,
		137,
		127,
		142,
		135,
		117,
		114,
		112,
		109,
		125,
		123,
		133,
		-1,
		-1,
		238,
		207,
		236,
		194,
		175,
		-1,
		141,
		121,
		127,
		131,
		125,
		118,
		132,
		128,
		-1,
		103,
		102,
		130,
		116,
		127,
		198,
		-1,
		-1,
		196,
		188,
		171,
		174,
		151,
		147,
		136,
		135,
		127,
		113,
		109,
		115,
		118,
		118,
		124,
		97,
		107,
		111,
		109,
		134,
		-1,
		-1,
		169,
		-1,
		-1,
		195,
		178,
		-1,
		161,
		168,
		157,
		163,
		149,
		170,
		146,
		137,
		129,
		123,
		111,
		113,
		110,
		123,
		111,
		94,
		119,
		123,
		104,
		125,
		120,
		-1,
		168,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		154,
		157,
		163,
		187,
		186,
		-1,
		158,
		146,
		147,
		132,
		129,
		116,
		104,
		117,
		102,
		109,
		108,
		98,
		96,
		126,
		101,
		123,
		120,
		139,
		144,
		138,
		147,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		191,
		-1,
		194,
		195,
		170,
		143,
		146,
		133,
		124,
		111,
		100,
		111,
		100,
		97,
		105,
		90,
		105,
		96,
		95,
		113,
		123,
		131,
		135,
		141,
		-1,
		253,
		-1,
		195,
		179,
		181,
		153,
		174,
		-1,
		211,
		195,
		187,
		172,
		172,
		-1,
		142,
		139,
		129,
		107,
		92,
		109,
		101,
		99,
		103,
		85,
		99,
		90,
		108,
		115,
		113,
		117,
		137,
		149,
		213,
		203,
		-1,
		185,
		190,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		144,
		157,
		-1,
		113,
		109,
		91,
		92,
		87,
		102,
		96,
		81,
		78,
		96,
		99,
		106,
		110,
		126,
		-1,
		-1,
		198,
		202,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		127,
		124,
		112,
		99,
		84,
		85,
		93,
		105,
		84,
		80,
		77,
		97,
		123,
		101,
		113,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		123,
		102,
		93,
		82,
		80,
		93,
		85,
		95,
		75,
		73,
		92,
		104,
		95,
		107,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		136,
		119,
		100,
		89,
		81,
		70,
		81,
		89,
		89,
		71,
		80,
		86,
		110,
		95,
		101,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		110,
		94,
		89,
		86,
		76,
		72,
		86,
		88,
		78,
		73,
		80,
		115,
		115,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		96,
		92,
		80,
		84,
		84,
		86,
		77,
		82,
		83,
		65,
		90,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		92,
		87,
		86,
		85,
		82,
		71,
		84,
		77,
		70,
		65,
		78,
		82,
		86,
		75,
		71,
		68,
		82,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		114,
		98,
		97,
		94,
		85,
		73,
		66,
		59,
		70,
		55,
		73,
		81,
		73,
		67,
		66,
		78,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		104,
		119,
		120,
		90,
		94,
		73,
		61,
		64,
		60,
		63,
		55,
		77,
		77,
		61,
		62,
		71,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		118,
		116,
		109,
		84,
		91,
		85,
		58,
		53,
		65,
		54,
		47,
		49,
		71,
		57,
		55,
		74,
		90,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		83,
		79,
		86,
		-1,
		78,
		-1,
		50,
		51,
		42,
		39,
		43,
		54,
		52,
		63,
		80,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		145,
		139,
		139,
		123,
		125,
		99,
		79,
		71,
		86,
		61,
		44,
		47,
		33,
		33,
		36,
		46,
		59,
		76,
		70,
		82,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		120,
		99,
		87,
		77,
		67,
		68,
		60,
		35,
		26,
		31,
		40,
		44,
		55,
		54,
		75,
		76,
		95,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		154,
		170,
		139,
		118,
		88,
		-1,
		-1,
		71,
		60,
		52,
		29,
		23,
		32,
		39,
		35,
		48,
		63,
		75,
		89,
		88,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		151,
		96,
		85,
		80,
		84,
		70,
		-1,
		52,
		40,
		24,
		0,
		7,
		37,
		43,
		51,
		58,
		76,
		93,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		73,
		66,
		70,
		-1,
		50,
		36,
		26,
		20,
		31,
		28,
		36,
		55,
		60,
		61,
		74,
		88,
		92,
		193,
		-1,
		160,
		-1,
		-1,
		-1,
		126,
		141,
		112,
		89,
		62,
		57,
		50,
		44,
		34,
		32,
		39,
		50,
		62,
		58,
		59,
		67,
		66,
		83,
		93,
		-1,
		-1,
		158,
		154,
		152,
		134,
		138,
		139,
		-1,
		-1,
		65,
		57,
		47,
		47,
		39,
		36,
		61,
		63,
		70,
		75,
		63,
		76,
		93,
		98,
		-1,
		-1,
		-1,
		170,
		-1,
		172,
		-1,
		-1,
		153,
		137,
		84,
		66,
		62,
		60,
		50,
		59,
		51,
		56,
		81,
		78,
		85,
		65,
		86,
		103,
		98,
		130,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		149,
		141,
		136,
		141,
		142,
		133,
		99,
		96,
		-1,
		66,
		86,
		57,
		64,
		56,
		71,
		76,
		82,
		70,
		83,
		99,
		98,
		93,
		122,
		117,
		126,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		142,
		138,
		127,
		117,
		119,
		-1,
		-1,
		107,
		104,
		83,
		66,
		72,
		65,
		60,
		98,
		74,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		194,
		231,
		224,
		192,
		200,
		231,
		-1,
		132,
		124,
		135,
		110,
		110,
		-1,
		-1,
		80,
		79,
		84,
		73,
		70,
		83,
		82,
		94,
		86,
		92,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		187,
		207,
		186,
		189,
		213,
		227,
		-1,
		129,
		-1,
		-1,
		141,
		111,
		95,
		87,
		79,
		131,
		87,
		82,
		84,
		86,
		92,
		83,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		176,
		187,
		180,
		-1,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		157,
		-1,
		122,
		-1,
		97,
		101,
		95,
		98,
		109,
		96,
		96,
		94,
		110,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		201,
		157,
		160,
		171,
		182,
		197,
		201,
		-1,
		141,
		180,
		195,
		-1,
		166,
		-1,
		-1,
		-1,
		111,
		108,
		100,
		116,
		108,
		108,
		90,
		94,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		197,
		188,
		201,
		146,
		146,
		167,
		176,
		197,
		156,
		147,
		174,
		200,
		191,
		186,
		173,
		-1,
		-1,
		134,
		118,
		-1,
		-1,
		115,
		111,
		94,
		96,
		97,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		190,
		189,
		178,
		175,
		151,
		142,
		137,
		164,
		-1,
		-1,
		159,
		175,
		170,
		174,
		190,
		215,
		-1,
		176,
		-1,
		-1,
		155,
		-1,
		-1,
		153,
		116,
		105,
		96,
		102,
		105,
		116,
		126,
		114,
		115,
		105,
		115,
		128,
		174,
		171,
		159,
		157,
		180,
		145,
		133,
		-1,
		146,
		144,
		150,
		157,
		174,
		204,
		-1,
		-1,
		192,
		174,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		101,
		106,
		131,
		134,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		183,
		197,
		186,
		182,
		181,
		189,
		138,
		131,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		180,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		123,
		123,
		121,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		217,
		-1,
		169,
		145,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		159,
		127,
		132,
		127,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		157,
		160,
		-1,
		-1,
		182,
		193,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		116,
		141,
		130,
		138,
		133,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		164,
		165,
		170,
		-1,
		176,
		-1,
		194,
		-1,
		161,
		167,
		155,
		-1,
		-1,
		-1,
		154,
		117,
		134,
		148,
		148,
		146,
		137,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		194,
		168,
		201,
		192,
		175,
		155,
		147,
		166,
		-1,
		136,
		-1,
		111,
		114,
		139,
		147,
		159,
		153,
		126,
		141,
		131,
		122,
		131,
		200,
		-1,
		170,
		203,
		167,
		161,
		137,
		141,
		157,
		-1,
		133,
		115,
		-1,
		143,
		133,
		175,
		156,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		172,
		171,
		163,
		157,
		157,
		142,
		133,
		-1,
		145,
		127,
		106,
		123,
		123,
		114,
		122,
		165,
		161,
		148,
		148,
		140,
		-1,
		273,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		166,
		161,
		134,
		122,
		128,
		124,
		110,
		116,
		118,
		126,
		124,
		121,
		133,
		129,
		149,
		141,
		176,
		-1,
		268,
		-1,
		202,
		-1,
		-1,
		184,
		164,
		156,
		145,
		134,
		132,
		123,
		114,
		136,
		152,
		136,
		134,
		139,
		144,
		-1,
		257,
		256,
		-1,
		203,
		195,
		181,
		-1,
		174,
		-1,
		180,
		141,
		-1,
		143,
		123,
		-1,
		145,
		141,
		-1,
		-1,
		244,
		219,
		-1,
		-1,
		-1,
		204,
		184,
		175,
		159,
		-1,
		134,
		134,
		-1,
		-1,
		-1,
		229,
		228,
		-1,
		197,
		200,
		-1,
		190,
		181,
		189,
		136,
		140,
		-1,
		-1,
		-1,
		238,
		219,
		213,
		212,
		210,
		205,
		202,
		188,
		172,
		150,
		139,
		160,
		-1,
		-1,
		-1,
		210,
		202,
		195,
		-1,
		-1,
		197,
		180,
		161,
		159,
		-1,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		187,
		-1,
		-1,
		193,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		221,
		-1,
		-1,
		-1,
		183,
		179,
		180,
		-1,
		-1,
		-1,
		-1,
		243,
		244,
		267,
		231,
		-1,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		246,
		244,
		-1,
		-1,
		-1,
		203,
		187,
		-1,
		173,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		208,
		-1,
		208,
		183,
		190,
		-1,
		-1,
		-1,
		-1,
		221,
		213,
		221,
		-1,
		193,
		195,
		-1,
		243,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		198,
		205,
		227,
		230,
		266,
		-1,
		217
	],
	[
		-1,
		199,
		188,
		199,
		207,
		180,
		187,
		-1,
		206,
		210,
		176,
		170,
		209,
		178,
		184,
		195,
		-1,
		-1,
		-1,
		199,
		198,
		166,
		164,
		173,
		178,
		185,
		-1,
		184,
		-1,
		220,
		199,
		210,
		215,
		159,
		156,
		176,
		195,
		177,
		169,
		235,
		189,
		160,
		154,
		172,
		162,
		171,
		163,
		-1,
		160,
		150,
		172,
		151,
		162,
		154,
		-1,
		-1,
		154,
		155,
		161,
		147,
		153,
		149,
		-1,
		159,
		143,
		-1,
		-1,
		144,
		145,
		129,
		132,
		140,
		138,
		151,
		143,
		138,
		-1,
		-1,
		135,
		131,
		138,
		125,
		121,
		138,
		151,
		133,
		147,
		146,
		-1,
		139,
		157,
		164,
		132,
		130,
		114,
		112,
		130,
		132,
		138,
		138,
		-1,
		148,
		149,
		144,
		152,
		154,
		130,
		117,
		117,
		127,
		120,
		139,
		127,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		131,
		148,
		140,
		130,
		145,
		138,
		120,
		117,
		115,
		112,
		128,
		126,
		136,
		-1,
		-1,
		241,
		210,
		239,
		197,
		178,
		-1,
		144,
		124,
		130,
		134,
		128,
		121,
		135,
		131,
		-1,
		106,
		105,
		133,
		119,
		130,
		201,
		-1,
		-1,
		199,
		191,
		174,
		177,
		154,
		150,
		139,
		138,
		130,
		116,
		112,
		118,
		121,
		121,
		127,
		100,
		110,
		114,
		112,
		137,
		-1,
		-1,
		172,
		-1,
		-1,
		198,
		181,
		-1,
		164,
		171,
		160,
		166,
		152,
		173,
		149,
		140,
		132,
		126,
		114,
		116,
		113,
		126,
		114,
		97,
		122,
		126,
		107,
		128,
		123,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		157,
		160,
		166,
		190,
		189,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		120,
		105,
		112,
		111,
		101,
		99,
		129,
		104,
		126,
		123,
		142,
		147,
		141,
		150,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		194,
		-1,
		197,
		198,
		173,
		146,
		149,
		136,
		127,
		114,
		103,
		114,
		103,
		100,
		108,
		93,
		108,
		99,
		98,
		116,
		126,
		134,
		138,
		144,
		-1,
		256,
		-1,
		198,
		182,
		184,
		156,
		177,
		-1,
		214,
		198,
		190,
		175,
		175,
		-1,
		145,
		142,
		132,
		110,
		95,
		112,
		104,
		102,
		106,
		88,
		102,
		93,
		111,
		118,
		116,
		120,
		140,
		152,
		216,
		206,
		-1,
		188,
		193,
		152,
		160,
		179,
		217,
		181,
		-1,
		176,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		95,
		90,
		105,
		99,
		84,
		81,
		99,
		102,
		109,
		113,
		129,
		-1,
		-1,
		201,
		205,
		194,
		145,
		164,
		188,
		225,
		174,
		163,
		162,
		-1,
		153,
		130,
		127,
		115,
		102,
		87,
		88,
		96,
		108,
		87,
		83,
		80,
		100,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		171,
		142,
		166,
		208,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		126,
		105,
		96,
		85,
		83,
		96,
		88,
		98,
		78,
		76,
		95,
		107,
		98,
		110,
		-1,
		-1,
		-1,
		201,
		190,
		191,
		137,
		160,
		197,
		171,
		157,
		162,
		137,
		130,
		124,
		139,
		122,
		103,
		92,
		84,
		73,
		84,
		92,
		92,
		74,
		83,
		89,
		113,
		98,
		104,
		-1,
		-1,
		208,
		198,
		182,
		184,
		181,
		151,
		158,
		190,
		162,
		175,
		-1,
		129,
		-1,
		118,
		113,
		97,
		92,
		89,
		79,
		75,
		89,
		91,
		81,
		76,
		83,
		118,
		118,
		88,
		108,
		111,
		-1,
		-1,
		-1,
		201,
		196,
		171,
		148,
		132,
		168,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		99,
		95,
		83,
		87,
		87,
		89,
		80,
		85,
		86,
		68,
		93,
		-1,
		96,
		90,
		98,
		88,
		76,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		127,
		179,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		95,
		90,
		89,
		88,
		85,
		74,
		87,
		80,
		73,
		68,
		81,
		85,
		89,
		78,
		74,
		71,
		85,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		147,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		117,
		101,
		100,
		97,
		88,
		76,
		69,
		62,
		73,
		58,
		76,
		84,
		76,
		70,
		69,
		81,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		107,
		122,
		123,
		93,
		97,
		76,
		64,
		67,
		63,
		66,
		58,
		80,
		80,
		64,
		65,
		74,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		121,
		119,
		112,
		87,
		94,
		88,
		61,
		56,
		68,
		57,
		50,
		52,
		74,
		60,
		58,
		77,
		93,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		86,
		82,
		89,
		-1,
		81,
		-1,
		53,
		54,
		45,
		42,
		46,
		57,
		55,
		66,
		83,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		128,
		102,
		82,
		74,
		89,
		64,
		47,
		50,
		36,
		36,
		39,
		49,
		62,
		79,
		73,
		85,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		123,
		102,
		90,
		80,
		70,
		71,
		63,
		38,
		29,
		34,
		43,
		47,
		58,
		57,
		78,
		79,
		98,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		142,
		121,
		91,
		-1,
		-1,
		74,
		63,
		55,
		32,
		26,
		35,
		42,
		38,
		51,
		66,
		78,
		92,
		91,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		154,
		99,
		88,
		83,
		87,
		73,
		-1,
		55,
		43,
		27,
		3,
		0,
		40,
		46,
		54,
		61,
		79,
		96,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		111,
		105,
		76,
		69,
		73,
		-1,
		53,
		39,
		29,
		23,
		34,
		31,
		39,
		58,
		63,
		64,
		77,
		91,
		95,
		196,
		-1,
		163,
		-1,
		-1,
		-1,
		129,
		144,
		115,
		92,
		65,
		60,
		53,
		47,
		37,
		35,
		42,
		53,
		65,
		61,
		62,
		70,
		69,
		86,
		96,
		-1,
		-1,
		161,
		157,
		155,
		137,
		141,
		142,
		-1,
		-1,
		68,
		60,
		50,
		50,
		42,
		39,
		64,
		66,
		73,
		78,
		66,
		79,
		96,
		101,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		156,
		140,
		87,
		69,
		65,
		63,
		53,
		62,
		54,
		59,
		84,
		81,
		88,
		68,
		89,
		106,
		101,
		133,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		144,
		145,
		136,
		102,
		99,
		-1,
		69,
		89,
		60,
		67,
		59,
		74,
		79,
		85,
		73,
		86,
		102,
		101,
		96,
		125,
		120,
		129,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		145,
		141,
		130,
		120,
		122,
		-1,
		-1,
		110,
		107,
		86,
		69,
		75,
		68,
		63,
		101,
		77,
		75,
		79,
		83,
		89,
		94,
		99,
		105,
		120,
		135,
		-1,
		197,
		234,
		227,
		195,
		203,
		234,
		-1,
		135,
		127,
		138,
		113,
		113,
		-1,
		-1,
		83,
		82,
		87,
		76,
		73,
		86,
		85,
		97,
		89,
		95,
		82,
		81,
		99,
		103,
		112,
		119,
		109,
		122,
		126,
		-1,
		190,
		210,
		189,
		192,
		216,
		230,
		-1,
		132,
		-1,
		-1,
		144,
		114,
		98,
		90,
		82,
		134,
		90,
		85,
		87,
		89,
		95,
		86,
		99,
		90,
		90,
		93,
		108,
		113,
		105,
		119,
		119,
		120,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		125,
		-1,
		100,
		104,
		98,
		101,
		112,
		99,
		99,
		97,
		113,
		88,
		98,
		94,
		95,
		104,
		115,
		127,
		126,
		127,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		144,
		183,
		198,
		-1,
		169,
		-1,
		-1,
		-1,
		114,
		111,
		103,
		119,
		111,
		111,
		93,
		97,
		93,
		100,
		110,
		112,
		104,
		108,
		121,
		132,
		135,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		159,
		150,
		177,
		203,
		194,
		189,
		176,
		-1,
		-1,
		137,
		121,
		-1,
		-1,
		118,
		114,
		97,
		99,
		100,
		103,
		118,
		121,
		111,
		109,
		103,
		135,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		178,
		173,
		177,
		193,
		218,
		-1,
		179,
		-1,
		-1,
		158,
		-1,
		-1,
		156,
		119,
		108,
		99,
		105,
		108,
		119,
		129,
		117,
		118,
		108,
		118,
		131,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		149,
		147,
		153,
		160,
		177,
		207,
		-1,
		-1,
		195,
		177,
		-1,
		-1,
		154,
		152,
		141,
		-1,
		131,
		104,
		109,
		134,
		137,
		126,
		120,
		114,
		121,
		120,
		128,
		136,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		187,
		183,
		-1,
		-1,
		149,
		142,
		130,
		118,
		108,
		118,
		126,
		126,
		124,
		117,
		112,
		123,
		115,
		119,
		136,
		-1,
		220,
		-1,
		172,
		148,
		162,
		177,
		185,
		-1,
		-1,
		-1,
		204,
		190,
		183,
		171,
		169,
		-1,
		183,
		167,
		148,
		-1,
		118,
		131,
		162,
		130,
		135,
		130,
		118,
		129,
		118,
		121,
		135,
		130,
		-1,
		-1,
		160,
		163,
		-1,
		-1,
		185,
		196,
		-1,
		195,
		184,
		169,
		161,
		-1,
		-1,
		155,
		151,
		-1,
		-1,
		119,
		144,
		133,
		141,
		136,
		122,
		128,
		131,
		120,
		124,
		136,
		-1,
		-1,
		167,
		168,
		173,
		-1,
		179,
		-1,
		197,
		-1,
		164,
		170,
		158,
		-1,
		-1,
		-1,
		157,
		120,
		137,
		151,
		151,
		149,
		140,
		126,
		133,
		131,
		127,
		138,
		-1,
		-1,
		-1,
		197,
		171,
		204,
		195,
		178,
		158,
		150,
		169,
		-1,
		139,
		-1,
		114,
		117,
		142,
		150,
		162,
		156,
		129,
		144,
		134,
		125,
		134,
		203,
		-1,
		173,
		206,
		170,
		164,
		140,
		144,
		160,
		-1,
		136,
		118,
		-1,
		146,
		136,
		178,
		159,
		144,
		131,
		138,
		138,
		131,
		-1,
		-1,
		-1,
		175,
		174,
		166,
		160,
		160,
		145,
		136,
		-1,
		148,
		130,
		109,
		126,
		126,
		117,
		125,
		168,
		164,
		151,
		151,
		143,
		-1,
		276,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		169,
		164,
		137,
		125,
		131,
		127,
		113,
		119,
		121,
		129,
		127,
		124,
		136,
		132,
		152,
		144,
		179,
		-1,
		271,
		-1,
		205,
		-1,
		-1,
		187,
		167,
		159,
		148,
		137,
		135,
		126,
		117,
		139,
		155,
		139,
		137,
		142,
		147,
		-1,
		260,
		259,
		-1,
		206,
		198,
		184,
		-1,
		177,
		-1,
		183,
		144,
		-1,
		146,
		126,
		-1,
		148,
		144,
		-1,
		-1,
		247,
		222,
		-1,
		-1,
		-1,
		207,
		187,
		178,
		162,
		-1,
		137,
		137,
		-1,
		-1,
		-1,
		232,
		231,
		-1,
		200,
		203,
		-1,
		193,
		184,
		192,
		139,
		143,
		-1,
		-1,
		-1,
		241,
		222,
		216,
		215,
		213,
		208,
		205,
		191,
		175,
		153,
		142,
		163,
		-1,
		-1,
		-1,
		213,
		205,
		198,
		-1,
		-1,
		200,
		183,
		164,
		162,
		-1,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		190,
		-1,
		-1,
		196,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		224,
		-1,
		-1,
		-1,
		186,
		182,
		183,
		-1,
		-1,
		-1,
		-1,
		246,
		247,
		270,
		234,
		-1,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		249,
		247,
		-1,
		-1,
		-1,
		206,
		190,
		-1,
		176,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		211,
		-1,
		211,
		186,
		193,
		-1,
		-1,
		-1,
		-1,
		224,
		216,
		224,
		-1,
		196,
		198,
		-1,
		246,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		201,
		208,
		230,
		233,
		269,
		-1,
		220
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		192,
		196,
		162,
		156,
		195,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		185,
		184,
		152,
		150,
		159,
		164,
		171,
		-1,
		170,
		-1,
		206,
		185,
		196,
		201,
		145,
		142,
		162,
		181,
		163,
		155,
		221,
		175,
		146,
		140,
		158,
		148,
		157,
		149,
		-1,
		146,
		136,
		158,
		137,
		148,
		140,
		-1,
		-1,
		140,
		141,
		147,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		130,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		127,
		145,
		150,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		124,
		-1,
		136,
		137,
		132,
		140,
		140,
		116,
		103,
		103,
		113,
		106,
		125,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		119,
		136,
		128,
		118,
		133,
		126,
		106,
		103,
		101,
		98,
		114,
		112,
		122,
		-1,
		-1,
		227,
		196,
		227,
		185,
		166,
		-1,
		132,
		112,
		118,
		122,
		116,
		109,
		123,
		119,
		-1,
		92,
		91,
		119,
		105,
		116,
		187,
		-1,
		-1,
		185,
		177,
		162,
		165,
		142,
		138,
		127,
		126,
		118,
		104,
		100,
		106,
		109,
		109,
		115,
		86,
		96,
		100,
		98,
		123,
		-1,
		-1,
		158,
		-1,
		-1,
		184,
		167,
		-1,
		150,
		157,
		148,
		154,
		140,
		161,
		137,
		128,
		120,
		114,
		102,
		104,
		101,
		114,
		102,
		83,
		108,
		112,
		93,
		114,
		109,
		-1,
		157,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		146,
		152,
		176,
		177,
		-1,
		149,
		137,
		138,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		87,
		85,
		115,
		90,
		112,
		109,
		128,
		133,
		127,
		136,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		180,
		-1,
		185,
		186,
		161,
		134,
		137,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		79,
		94,
		85,
		84,
		102,
		112,
		120,
		124,
		130,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		200,
		186,
		178,
		163,
		161,
		-1,
		133,
		130,
		120,
		98,
		83,
		100,
		92,
		90,
		92,
		74,
		88,
		79,
		97,
		104,
		102,
		106,
		126,
		138,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		135,
		148,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		85,
		70,
		67,
		85,
		88,
		95,
		99,
		115,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		118,
		115,
		103,
		90,
		75,
		76,
		84,
		96,
		75,
		69,
		66,
		86,
		112,
		90,
		101,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		114,
		93,
		84,
		73,
		71,
		84,
		76,
		84,
		64,
		62,
		81,
		93,
		84,
		92,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		127,
		110,
		91,
		80,
		72,
		61,
		72,
		80,
		78,
		60,
		69,
		75,
		99,
		80,
		86,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		100,
		85,
		80,
		77,
		64,
		63,
		77,
		77,
		67,
		62,
		69,
		104,
		104,
		70,
		90,
		93,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		87,
		83,
		68,
		72,
		74,
		77,
		65,
		71,
		72,
		54,
		78,
		-1,
		78,
		72,
		80,
		70,
		58,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		80,
		75,
		74,
		73,
		70,
		59,
		72,
		65,
		59,
		53,
		66,
		70,
		71,
		60,
		56,
		53,
		67,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		102,
		86,
		85,
		82,
		73,
		81,
		54,
		47,
		58,
		43,
		61,
		67,
		58,
		53,
		52,
		63,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		92,
		109,
		110,
		88,
		82,
		80,
		71,
		59,
		48,
		51,
		43,
		65,
		62,
		46,
		48,
		57,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		106,
		104,
		99,
		90,
		96,
		91,
		68,
		63,
		53,
		42,
		42,
		37,
		56,
		42,
		40,
		60,
		76,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		107,
		91,
		96,
		-1,
		88,
		-1,
		61,
		58,
		49,
		34,
		31,
		42,
		40,
		49,
		58,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		123,
		103,
		97,
		96,
		83,
		74,
		69,
		47,
		40,
		37,
		27,
		40,
		50,
		56,
		56,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		129,
		117,
		107,
		97,
		98,
		90,
		65,
		56,
		45,
		47,
		29,
		29,
		28,
		49,
		50,
		70,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		118,
		-1,
		-1,
		101,
		90,
		82,
		59,
		49,
		51,
		46,
		5,
		22,
		37,
		49,
		63,
		62,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		115,
		104,
		99,
		103,
		100,
		-1,
		75,
		70,
		53,
		36,
		43,
		0,
		22,
		25,
		32,
		50,
		67,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		127,
		121,
		92,
		85,
		89,
		-1,
		77,
		65,
		55,
		42,
		27,
		24,
		15,
		29,
		34,
		35,
		48,
		62,
		66,
		182,
		-1,
		165,
		-1,
		-1,
		-1,
		145,
		160,
		131,
		108,
		81,
		76,
		69,
		63,
		63,
		49,
		35,
		46,
		36,
		32,
		33,
		41,
		40,
		57,
		67,
		-1,
		-1,
		165,
		162,
		171,
		153,
		157,
		158,
		-1,
		-1,
		85,
		76,
		67,
		63,
		56,
		53,
		42,
		39,
		44,
		49,
		37,
		50,
		67,
		72,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		168,
		156,
		103,
		85,
		81,
		79,
		72,
		66,
		54,
		47,
		57,
		67,
		59,
		39,
		60,
		77,
		72,
		104,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		118,
		115,
		-1,
		85,
		95,
		60,
		67,
		59,
		65,
		65,
		63,
		44,
		57,
		73,
		72,
		67,
		96,
		91,
		100,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		123,
		120,
		92,
		69,
		75,
		68,
		63,
		79,
		59,
		46,
		50,
		54,
		60,
		65,
		70,
		76,
		91,
		106,
		-1,
		192,
		234,
		227,
		195,
		203,
		234,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		96,
		87,
		88,
		76,
		73,
		86,
		84,
		75,
		60,
		66,
		53,
		52,
		70,
		74,
		83,
		90,
		80,
		93,
		97,
		-1,
		190,
		210,
		189,
		192,
		216,
		230,
		-1,
		137,
		-1,
		-1,
		149,
		121,
		105,
		95,
		92,
		135,
		90,
		85,
		83,
		81,
		72,
		63,
		70,
		61,
		61,
		64,
		79,
		84,
		76,
		90,
		90,
		91,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		165,
		-1,
		132,
		-1,
		115,
		119,
		98,
		101,
		97,
		84,
		76,
		68,
		84,
		59,
		69,
		65,
		66,
		75,
		86,
		98,
		97,
		98,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		149,
		188,
		196,
		-1,
		174,
		-1,
		-1,
		-1,
		129,
		111,
		103,
		117,
		96,
		96,
		70,
		74,
		64,
		71,
		81,
		83,
		75,
		79,
		92,
		103,
		106,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		164,
		155,
		182,
		203,
		192,
		187,
		174,
		-1,
		-1,
		152,
		121,
		-1,
		-1,
		103,
		91,
		74,
		75,
		71,
		74,
		89,
		92,
		82,
		80,
		74,
		106,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		183,
		173,
		177,
		193,
		218,
		-1,
		163,
		-1,
		-1,
		148,
		-1,
		-1,
		133,
		96,
		85,
		76,
		82,
		79,
		90,
		100,
		88,
		89,
		79,
		89,
		102,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		149,
		147,
		153,
		160,
		177,
		207,
		-1,
		-1,
		179,
		159,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		81,
		86,
		106,
		108,
		97,
		91,
		85,
		92,
		91,
		99,
		107,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		169,
		165,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		95,
		99,
		103,
		95,
		88,
		83,
		94,
		86,
		90,
		107,
		-1,
		220,
		-1,
		172,
		148,
		162,
		177,
		185,
		-1,
		-1,
		-1,
		186,
		172,
		165,
		153,
		151,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		139,
		107,
		112,
		107,
		89,
		100,
		89,
		92,
		106,
		101,
		-1,
		-1,
		160,
		163,
		-1,
		-1,
		176,
		178,
		-1,
		177,
		166,
		151,
		143,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		96,
		121,
		110,
		118,
		113,
		93,
		99,
		102,
		91,
		95,
		107,
		-1,
		-1,
		167,
		168,
		173,
		-1,
		161,
		-1,
		179,
		-1,
		146,
		152,
		140,
		-1,
		-1,
		-1,
		134,
		97,
		118,
		128,
		122,
		120,
		111,
		97,
		104,
		102,
		98,
		109,
		-1,
		-1,
		-1,
		179,
		153,
		186,
		177,
		160,
		140,
		132,
		151,
		-1,
		121,
		-1,
		96,
		98,
		124,
		127,
		133,
		127,
		100,
		115,
		105,
		96,
		105,
		185,
		-1,
		155,
		188,
		152,
		146,
		122,
		126,
		142,
		-1,
		118,
		100,
		-1,
		128,
		118,
		149,
		134,
		115,
		102,
		109,
		109,
		102,
		-1,
		-1,
		-1,
		157,
		156,
		148,
		142,
		142,
		127,
		118,
		-1,
		130,
		112,
		91,
		108,
		108,
		99,
		107,
		139,
		135,
		122,
		122,
		114,
		-1,
		258,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		151,
		146,
		119,
		107,
		113,
		109,
		95,
		101,
		103,
		111,
		109,
		106,
		118,
		114,
		134,
		115,
		150,
		-1,
		253,
		-1,
		187,
		-1,
		-1,
		169,
		149,
		141,
		130,
		119,
		117,
		108,
		99,
		121,
		137,
		121,
		119,
		122,
		123,
		-1,
		242,
		241,
		-1,
		188,
		180,
		166,
		-1,
		159,
		-1,
		165,
		126,
		-1,
		128,
		108,
		-1,
		130,
		126,
		-1,
		-1,
		229,
		204,
		-1,
		-1,
		-1,
		189,
		169,
		160,
		144,
		-1,
		119,
		119,
		-1,
		-1,
		-1,
		214,
		213,
		-1,
		182,
		185,
		-1,
		175,
		166,
		174,
		121,
		125,
		-1,
		-1,
		-1,
		223,
		204,
		198,
		197,
		195,
		190,
		187,
		173,
		157,
		135,
		124,
		145,
		-1,
		-1,
		-1,
		195,
		187,
		180,
		-1,
		-1,
		182,
		165,
		146,
		144,
		-1,
		-1,
		-1,
		217,
		198,
		-1,
		-1,
		172,
		-1,
		-1,
		178,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		206,
		-1,
		-1,
		-1,
		168,
		164,
		165,
		-1,
		-1,
		-1,
		-1,
		228,
		229,
		252,
		216,
		-1,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		231,
		229,
		-1,
		-1,
		-1,
		188,
		172,
		-1,
		158,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		193,
		-1,
		193,
		168,
		175,
		-1,
		-1,
		-1,
		-1,
		206,
		198,
		206,
		-1,
		178,
		180,
		-1,
		228,
		-1,
		-1,
		221,
		212,
		-1,
		-1,
		183,
		190,
		212,
		215,
		251,
		-1,
		202
	],
	[
		-1,
		178,
		167,
		178,
		186,
		159,
		166,
		-1,
		185,
		189,
		155,
		149,
		188,
		157,
		163,
		174,
		-1,
		-1,
		-1,
		178,
		177,
		145,
		143,
		152,
		157,
		164,
		-1,
		163,
		-1,
		199,
		178,
		189,
		194,
		138,
		135,
		155,
		174,
		156,
		148,
		214,
		168,
		139,
		133,
		151,
		141,
		150,
		142,
		-1,
		139,
		129,
		151,
		130,
		141,
		133,
		-1,
		-1,
		133,
		134,
		140,
		126,
		132,
		128,
		-1,
		138,
		122,
		-1,
		-1,
		123,
		124,
		108,
		111,
		119,
		117,
		130,
		122,
		117,
		-1,
		-1,
		114,
		110,
		117,
		104,
		100,
		117,
		130,
		112,
		126,
		125,
		-1,
		120,
		138,
		143,
		111,
		109,
		93,
		91,
		109,
		111,
		117,
		117,
		-1,
		129,
		130,
		125,
		133,
		133,
		109,
		96,
		96,
		106,
		99,
		118,
		106,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		129,
		112,
		129,
		121,
		111,
		126,
		119,
		99,
		96,
		94,
		91,
		107,
		105,
		115,
		-1,
		-1,
		220,
		189,
		220,
		178,
		159,
		-1,
		125,
		105,
		111,
		115,
		109,
		102,
		116,
		112,
		-1,
		85,
		84,
		112,
		98,
		109,
		180,
		-1,
		-1,
		178,
		170,
		155,
		158,
		135,
		131,
		120,
		119,
		111,
		97,
		93,
		99,
		102,
		102,
		108,
		79,
		89,
		93,
		91,
		116,
		-1,
		-1,
		151,
		-1,
		-1,
		177,
		160,
		-1,
		143,
		150,
		141,
		147,
		133,
		154,
		130,
		121,
		113,
		107,
		95,
		97,
		94,
		107,
		95,
		76,
		101,
		105,
		86,
		107,
		102,
		-1,
		150,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		139,
		145,
		169,
		170,
		-1,
		142,
		130,
		131,
		116,
		113,
		100,
		88,
		101,
		86,
		93,
		92,
		80,
		78,
		108,
		83,
		105,
		102,
		121,
		126,
		120,
		129,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		173,
		-1,
		178,
		179,
		154,
		127,
		130,
		117,
		108,
		95,
		84,
		95,
		84,
		81,
		89,
		72,
		87,
		78,
		77,
		95,
		105,
		113,
		117,
		123,
		-1,
		235,
		-1,
		177,
		161,
		163,
		135,
		156,
		-1,
		193,
		179,
		171,
		156,
		154,
		-1,
		126,
		123,
		113,
		91,
		76,
		93,
		85,
		83,
		85,
		67,
		81,
		72,
		90,
		97,
		95,
		99,
		119,
		131,
		195,
		185,
		-1,
		167,
		172,
		131,
		139,
		158,
		196,
		160,
		-1,
		155,
		-1,
		128,
		141,
		-1,
		97,
		93,
		75,
		76,
		71,
		86,
		78,
		63,
		60,
		78,
		81,
		88,
		92,
		108,
		-1,
		-1,
		180,
		184,
		173,
		124,
		143,
		167,
		204,
		153,
		142,
		141,
		-1,
		132,
		111,
		108,
		96,
		83,
		68,
		69,
		77,
		89,
		68,
		62,
		59,
		79,
		105,
		83,
		94,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		150,
		121,
		145,
		187,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		107,
		86,
		77,
		66,
		64,
		77,
		69,
		77,
		57,
		55,
		74,
		86,
		77,
		85,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		150,
		136,
		141,
		116,
		109,
		103,
		120,
		103,
		84,
		73,
		65,
		54,
		65,
		73,
		71,
		53,
		62,
		68,
		92,
		73,
		79,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		141,
		154,
		-1,
		108,
		-1,
		97,
		93,
		78,
		73,
		70,
		57,
		56,
		70,
		70,
		60,
		55,
		62,
		97,
		97,
		63,
		83,
		86,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		102,
		96,
		93,
		80,
		76,
		61,
		65,
		67,
		70,
		58,
		64,
		65,
		47,
		71,
		-1,
		71,
		65,
		73,
		63,
		51,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		89,
		71,
		73,
		68,
		67,
		66,
		63,
		52,
		65,
		58,
		52,
		46,
		59,
		63,
		64,
		53,
		49,
		46,
		60,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		84,
		82,
		95,
		79,
		78,
		75,
		66,
		74,
		47,
		40,
		51,
		36,
		54,
		60,
		51,
		46,
		45,
		56,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		94,
		85,
		102,
		103,
		81,
		75,
		73,
		64,
		52,
		41,
		44,
		36,
		58,
		55,
		39,
		41,
		50,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		162,
		-1,
		96,
		113,
		99,
		97,
		92,
		83,
		89,
		84,
		61,
		56,
		46,
		35,
		35,
		30,
		49,
		35,
		33,
		49,
		65,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		140,
		130,
		114,
		99,
		132,
		-1,
		100,
		84,
		89,
		-1,
		81,
		-1,
		54,
		51,
		42,
		27,
		24,
		35,
		33,
		42,
		44,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		127,
		121,
		121,
		105,
		108,
		116,
		96,
		90,
		89,
		76,
		68,
		62,
		40,
		33,
		30,
		20,
		33,
		43,
		49,
		42,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		189,
		144,
		130,
		-1,
		114,
		118,
		106,
		96,
		86,
		91,
		84,
		59,
		52,
		38,
		40,
		29,
		22,
		21,
		42,
		36,
		58,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		136,
		152,
		144,
		115,
		107,
		-1,
		-1,
		90,
		83,
		76,
		55,
		42,
		51,
		46,
		24,
		15,
		30,
		41,
		49,
		48,
		-1,
		140,
		127,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		-1,
		-1,
		158,
		103,
		92,
		87,
		91,
		89,
		-1,
		63,
		66,
		46,
		38,
		45,
		19,
		0,
		9,
		20,
		36,
		53,
		-1,
		-1,
		152,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		80,
		73,
		77,
		-1,
		65,
		62,
		48,
		44,
		18,
		15,
		6,
		13,
		18,
		21,
		34,
		48,
		52,
		175,
		-1,
		152,
		-1,
		-1,
		-1,
		133,
		148,
		119,
		96,
		69,
		64,
		57,
		51,
		56,
		40,
		26,
		37,
		20,
		16,
		17,
		27,
		26,
		43,
		53,
		-1,
		-1,
		150,
		146,
		159,
		141,
		145,
		146,
		-1,
		-1,
		73,
		64,
		55,
		47,
		47,
		44,
		26,
		23,
		28,
		33,
		21,
		36,
		51,
		58,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		152,
		144,
		91,
		73,
		69,
		67,
		56,
		50,
		38,
		31,
		41,
		51,
		43,
		23,
		44,
		61,
		56,
		90,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		141,
		133,
		128,
		134,
		136,
		127,
		106,
		103,
		-1,
		73,
		79,
		44,
		51,
		43,
		49,
		49,
		47,
		28,
		41,
		57,
		56,
		51,
		82,
		77,
		84,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		134,
		130,
		120,
		110,
		113,
		-1,
		-1,
		107,
		104,
		76,
		53,
		59,
		52,
		47,
		63,
		43,
		30,
		34,
		38,
		44,
		49,
		54,
		60,
		75,
		90,
		-1,
		181,
		218,
		211,
		179,
		187,
		218,
		-1,
		124,
		116,
		127,
		102,
		104,
		-1,
		-1,
		80,
		71,
		72,
		60,
		57,
		70,
		68,
		59,
		44,
		50,
		37,
		36,
		54,
		58,
		67,
		74,
		64,
		77,
		81,
		-1,
		174,
		194,
		173,
		176,
		200,
		214,
		-1,
		121,
		-1,
		-1,
		133,
		105,
		89,
		79,
		76,
		119,
		74,
		69,
		67,
		65,
		56,
		47,
		54,
		45,
		45,
		48,
		63,
		68,
		60,
		74,
		74,
		75,
		-1,
		163,
		174,
		167,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		116,
		-1,
		99,
		103,
		82,
		85,
		81,
		68,
		60,
		52,
		68,
		43,
		53,
		49,
		50,
		59,
		70,
		82,
		81,
		82,
		188,
		144,
		147,
		158,
		169,
		184,
		188,
		-1,
		133,
		172,
		180,
		-1,
		158,
		-1,
		-1,
		-1,
		113,
		95,
		87,
		101,
		80,
		80,
		54,
		58,
		48,
		55,
		65,
		67,
		59,
		63,
		76,
		87,
		90,
		184,
		175,
		188,
		133,
		133,
		154,
		163,
		184,
		148,
		139,
		166,
		187,
		176,
		171,
		158,
		-1,
		-1,
		136,
		105,
		-1,
		-1,
		87,
		75,
		58,
		59,
		55,
		58,
		73,
		76,
		66,
		64,
		58,
		90,
		-1,
		177,
		176,
		165,
		162,
		138,
		129,
		124,
		151,
		-1,
		-1,
		146,
		167,
		157,
		161,
		177,
		202,
		-1,
		147,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		80,
		69,
		60,
		66,
		63,
		74,
		84,
		72,
		73,
		63,
		73,
		86,
		161,
		158,
		146,
		144,
		167,
		132,
		120,
		-1,
		133,
		131,
		137,
		144,
		161,
		191,
		-1,
		-1,
		163,
		143,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		65,
		70,
		90,
		92,
		81,
		75,
		69,
		76,
		75,
		83,
		91,
		170,
		184,
		173,
		169,
		168,
		176,
		125,
		118,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		153,
		149,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		79,
		83,
		87,
		79,
		72,
		67,
		78,
		70,
		74,
		91,
		-1,
		204,
		-1,
		156,
		132,
		146,
		161,
		169,
		-1,
		-1,
		-1,
		170,
		156,
		149,
		137,
		135,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		123,
		91,
		96,
		91,
		73,
		84,
		73,
		76,
		90,
		85,
		-1,
		-1,
		144,
		147,
		-1,
		-1,
		160,
		162,
		-1,
		161,
		150,
		135,
		127,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		105,
		94,
		102,
		97,
		77,
		83,
		86,
		75,
		79,
		91,
		-1,
		-1,
		151,
		152,
		157,
		-1,
		145,
		-1,
		163,
		-1,
		130,
		136,
		124,
		-1,
		-1,
		-1,
		118,
		81,
		102,
		112,
		106,
		104,
		95,
		81,
		88,
		86,
		82,
		93,
		-1,
		-1,
		-1,
		163,
		137,
		170,
		161,
		144,
		124,
		116,
		135,
		-1,
		105,
		-1,
		80,
		82,
		108,
		111,
		117,
		111,
		84,
		99,
		89,
		80,
		89,
		169,
		-1,
		139,
		172,
		136,
		130,
		106,
		110,
		126,
		-1,
		102,
		84,
		-1,
		112,
		102,
		133,
		118,
		99,
		86,
		93,
		93,
		86,
		-1,
		-1,
		-1,
		141,
		140,
		132,
		126,
		126,
		111,
		102,
		-1,
		114,
		96,
		75,
		92,
		92,
		83,
		91,
		123,
		119,
		106,
		106,
		98,
		-1,
		242,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		135,
		130,
		103,
		91,
		97,
		93,
		79,
		85,
		87,
		95,
		93,
		90,
		102,
		98,
		118,
		99,
		134,
		-1,
		237,
		-1,
		171,
		-1,
		-1,
		153,
		133,
		125,
		114,
		103,
		101,
		92,
		83,
		105,
		121,
		105,
		103,
		106,
		107,
		-1,
		226,
		225,
		-1,
		172,
		164,
		150,
		-1,
		143,
		-1,
		149,
		110,
		-1,
		112,
		92,
		-1,
		114,
		110,
		-1,
		-1,
		213,
		188,
		-1,
		-1,
		-1,
		173,
		153,
		144,
		128,
		-1,
		103,
		103,
		-1,
		-1,
		-1,
		198,
		197,
		-1,
		166,
		169,
		-1,
		159,
		150,
		158,
		105,
		109,
		-1,
		-1,
		-1,
		207,
		188,
		182,
		181,
		179,
		174,
		171,
		157,
		141,
		119,
		108,
		129,
		-1,
		-1,
		-1,
		179,
		171,
		164,
		-1,
		-1,
		166,
		149,
		130,
		128,
		-1,
		-1,
		-1,
		201,
		182,
		-1,
		-1,
		156,
		-1,
		-1,
		162,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		190,
		-1,
		-1,
		-1,
		152,
		148,
		149,
		-1,
		-1,
		-1,
		-1,
		212,
		213,
		236,
		200,
		-1,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		215,
		213,
		-1,
		-1,
		-1,
		172,
		156,
		-1,
		142,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		177,
		-1,
		177,
		152,
		159,
		-1,
		-1,
		-1,
		-1,
		190,
		182,
		190,
		-1,
		162,
		164,
		-1,
		212,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		167,
		174,
		196,
		199,
		235,
		-1,
		186
	],
	[
		-1,
		169,
		158,
		169,
		177,
		150,
		157,
		-1,
		176,
		180,
		146,
		140,
		179,
		148,
		154,
		165,
		-1,
		-1,
		-1,
		169,
		168,
		136,
		134,
		143,
		148,
		155,
		-1,
		154,
		-1,
		190,
		169,
		180,
		185,
		129,
		126,
		146,
		165,
		147,
		139,
		205,
		159,
		130,
		124,
		142,
		132,
		141,
		133,
		-1,
		130,
		120,
		142,
		121,
		132,
		124,
		-1,
		-1,
		124,
		125,
		131,
		117,
		123,
		119,
		-1,
		129,
		113,
		-1,
		-1,
		114,
		115,
		99,
		102,
		110,
		108,
		121,
		113,
		108,
		-1,
		-1,
		105,
		101,
		108,
		95,
		91,
		108,
		121,
		103,
		117,
		116,
		-1,
		111,
		129,
		134,
		102,
		100,
		84,
		82,
		100,
		102,
		108,
		108,
		-1,
		120,
		121,
		116,
		124,
		124,
		100,
		87,
		87,
		97,
		90,
		109,
		97,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		120,
		103,
		120,
		112,
		102,
		117,
		110,
		90,
		87,
		85,
		82,
		98,
		96,
		106,
		-1,
		-1,
		211,
		180,
		211,
		169,
		150,
		-1,
		116,
		96,
		102,
		106,
		100,
		93,
		107,
		103,
		-1,
		76,
		75,
		103,
		89,
		100,
		171,
		-1,
		-1,
		169,
		161,
		146,
		149,
		126,
		122,
		111,
		110,
		102,
		88,
		84,
		90,
		93,
		93,
		99,
		70,
		80,
		84,
		82,
		107,
		-1,
		-1,
		142,
		-1,
		-1,
		168,
		151,
		-1,
		134,
		141,
		132,
		138,
		124,
		145,
		121,
		112,
		104,
		98,
		86,
		88,
		85,
		98,
		86,
		67,
		92,
		96,
		77,
		98,
		93,
		-1,
		141,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		130,
		136,
		160,
		161,
		-1,
		133,
		121,
		122,
		107,
		104,
		91,
		79,
		92,
		77,
		84,
		83,
		71,
		69,
		99,
		74,
		96,
		93,
		112,
		117,
		111,
		120,
		-1,
		176,
		172,
		168,
		175,
		124,
		-1,
		-1,
		164,
		-1,
		169,
		170,
		145,
		118,
		121,
		108,
		99,
		86,
		75,
		86,
		75,
		72,
		80,
		63,
		78,
		69,
		68,
		86,
		96,
		104,
		108,
		114,
		-1,
		226,
		-1,
		168,
		152,
		154,
		126,
		147,
		-1,
		184,
		170,
		162,
		147,
		145,
		-1,
		117,
		114,
		104,
		82,
		67,
		84,
		76,
		74,
		76,
		58,
		72,
		63,
		81,
		88,
		86,
		90,
		110,
		122,
		186,
		176,
		-1,
		158,
		163,
		122,
		130,
		149,
		187,
		151,
		-1,
		146,
		-1,
		119,
		132,
		-1,
		88,
		84,
		66,
		67,
		62,
		77,
		69,
		54,
		51,
		69,
		72,
		79,
		83,
		99,
		-1,
		-1,
		171,
		175,
		164,
		115,
		134,
		158,
		195,
		144,
		133,
		132,
		-1,
		123,
		102,
		99,
		87,
		74,
		59,
		60,
		68,
		80,
		59,
		53,
		50,
		70,
		96,
		74,
		85,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		141,
		112,
		136,
		178,
		162,
		155,
		143,
		108,
		108,
		102,
		-1,
		98,
		77,
		68,
		57,
		55,
		68,
		60,
		68,
		48,
		46,
		65,
		77,
		68,
		76,
		-1,
		-1,
		-1,
		171,
		160,
		161,
		107,
		130,
		167,
		141,
		127,
		132,
		107,
		100,
		94,
		111,
		94,
		75,
		64,
		56,
		45,
		56,
		64,
		62,
		44,
		53,
		59,
		83,
		64,
		70,
		-1,
		-1,
		178,
		168,
		152,
		154,
		151,
		121,
		128,
		160,
		132,
		145,
		-1,
		99,
		-1,
		88,
		84,
		69,
		64,
		61,
		48,
		47,
		61,
		61,
		51,
		46,
		53,
		88,
		88,
		54,
		74,
		77,
		-1,
		-1,
		-1,
		171,
		166,
		141,
		118,
		102,
		138,
		-1,
		115,
		116,
		-1,
		93,
		87,
		84,
		71,
		67,
		52,
		56,
		58,
		61,
		49,
		55,
		56,
		38,
		62,
		-1,
		62,
		56,
		64,
		54,
		42,
		-1,
		-1,
		-1,
		164,
		143,
		136,
		156,
		97,
		149,
		-1,
		-1,
		100,
		93,
		-1,
		80,
		62,
		64,
		59,
		58,
		57,
		54,
		43,
		56,
		49,
		43,
		37,
		50,
		54,
		55,
		44,
		40,
		37,
		51,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		117,
		-1,
		109,
		101,
		91,
		85,
		79,
		75,
		73,
		86,
		70,
		69,
		66,
		57,
		65,
		38,
		31,
		42,
		27,
		45,
		51,
		42,
		37,
		36,
		47,
		-1,
		184,
		170,
		141,
		-1,
		-1,
		130,
		-1,
		94,
		108,
		124,
		-1,
		117,
		96,
		111,
		89,
		85,
		76,
		93,
		94,
		72,
		66,
		64,
		55,
		43,
		32,
		35,
		27,
		49,
		46,
		30,
		32,
		41,
		-1,
		190,
		177,
		135,
		131,
		120,
		140,
		91,
		79,
		111,
		-1,
		-1,
		153,
		-1,
		87,
		104,
		90,
		88,
		83,
		74,
		80,
		75,
		52,
		47,
		37,
		26,
		26,
		21,
		40,
		26,
		24,
		40,
		56,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		106,
		93,
		87,
		-1,
		128,
		-1,
		131,
		121,
		105,
		90,
		123,
		-1,
		91,
		75,
		80,
		-1,
		72,
		-1,
		45,
		42,
		33,
		18,
		15,
		26,
		24,
		33,
		35,
		-1,
		140,
		125,
		118,
		108,
		122,
		93,
		-1,
		148,
		-1,
		-1,
		118,
		112,
		112,
		96,
		99,
		107,
		87,
		81,
		80,
		67,
		59,
		53,
		31,
		24,
		21,
		11,
		24,
		34,
		40,
		33,
		-1,
		-1,
		-1,
		145,
		131,
		135,
		95,
		114,
		-1,
		-1,
		180,
		135,
		121,
		-1,
		105,
		109,
		97,
		87,
		77,
		82,
		75,
		50,
		43,
		29,
		31,
		20,
		13,
		12,
		33,
		27,
		49,
		-1,
		-1,
		128,
		133,
		121,
		107,
		126,
		-1,
		-1,
		-1,
		127,
		143,
		135,
		106,
		98,
		-1,
		-1,
		81,
		74,
		67,
		46,
		33,
		42,
		37,
		19,
		6,
		21,
		32,
		40,
		39,
		-1,
		131,
		118,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		-1,
		-1,
		149,
		94,
		83,
		78,
		82,
		80,
		-1,
		54,
		57,
		37,
		44,
		51,
		21,
		6,
		0,
		11,
		27,
		44,
		-1,
		-1,
		143,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		106,
		100,
		71,
		64,
		68,
		-1,
		56,
		53,
		39,
		50,
		24,
		21,
		12,
		4,
		9,
		12,
		25,
		39,
		43,
		166,
		-1,
		143,
		-1,
		-1,
		-1,
		124,
		139,
		110,
		87,
		60,
		55,
		48,
		42,
		47,
		46,
		32,
		43,
		11,
		7,
		8,
		18,
		17,
		34,
		44,
		-1,
		-1,
		141,
		137,
		150,
		132,
		136,
		137,
		-1,
		-1,
		64,
		55,
		46,
		38,
		51,
		50,
		17,
		14,
		19,
		24,
		12,
		27,
		42,
		49,
		-1,
		-1,
		-1,
		153,
		-1,
		155,
		-1,
		-1,
		143,
		135,
		82,
		64,
		60,
		58,
		47,
		41,
		29,
		22,
		32,
		42,
		34,
		14,
		35,
		52,
		47,
		81,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		132,
		124,
		119,
		125,
		127,
		118,
		97,
		94,
		-1,
		64,
		70,
		35,
		42,
		34,
		40,
		40,
		38,
		19,
		32,
		48,
		47,
		42,
		73,
		68,
		75,
		-1,
		-1,
		218,
		207,
		196,
		202,
		-1,
		125,
		121,
		111,
		101,
		104,
		-1,
		-1,
		98,
		95,
		67,
		44,
		50,
		43,
		38,
		54,
		34,
		21,
		25,
		29,
		35,
		40,
		45,
		51,
		66,
		81,
		-1,
		172,
		209,
		202,
		170,
		178,
		209,
		-1,
		115,
		107,
		118,
		93,
		95,
		-1,
		-1,
		71,
		62,
		63,
		51,
		48,
		61,
		59,
		50,
		35,
		41,
		28,
		27,
		45,
		49,
		58,
		65,
		55,
		68,
		72,
		-1,
		165,
		185,
		164,
		167,
		191,
		205,
		-1,
		112,
		-1,
		-1,
		124,
		96,
		80,
		70,
		67,
		110,
		65,
		60,
		58,
		56,
		47,
		38,
		45,
		36,
		36,
		39,
		54,
		59,
		51,
		65,
		65,
		66,
		-1,
		154,
		165,
		158,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		140,
		-1,
		107,
		-1,
		90,
		94,
		73,
		76,
		72,
		59,
		51,
		43,
		59,
		34,
		44,
		40,
		41,
		50,
		61,
		73,
		72,
		73,
		179,
		135,
		138,
		149,
		160,
		175,
		179,
		-1,
		124,
		163,
		171,
		-1,
		149,
		-1,
		-1,
		-1,
		104,
		86,
		78,
		92,
		71,
		71,
		45,
		49,
		39,
		46,
		56,
		58,
		50,
		54,
		67,
		78,
		81,
		175,
		166,
		179,
		124,
		124,
		145,
		154,
		175,
		139,
		130,
		157,
		178,
		167,
		162,
		149,
		-1,
		-1,
		127,
		96,
		-1,
		-1,
		78,
		66,
		49,
		50,
		46,
		49,
		64,
		67,
		57,
		55,
		49,
		81,
		-1,
		168,
		167,
		156,
		153,
		129,
		120,
		115,
		142,
		-1,
		-1,
		137,
		158,
		148,
		152,
		168,
		193,
		-1,
		138,
		-1,
		-1,
		123,
		-1,
		-1,
		108,
		71,
		60,
		51,
		57,
		54,
		65,
		75,
		63,
		64,
		54,
		64,
		77,
		152,
		149,
		137,
		135,
		158,
		123,
		111,
		-1,
		124,
		122,
		128,
		135,
		152,
		182,
		-1,
		-1,
		154,
		134,
		-1,
		-1,
		106,
		104,
		93,
		-1,
		83,
		56,
		61,
		81,
		83,
		72,
		66,
		60,
		67,
		66,
		74,
		82,
		161,
		175,
		164,
		160,
		159,
		167,
		116,
		109,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		140,
		-1,
		-1,
		101,
		94,
		82,
		70,
		60,
		70,
		74,
		78,
		70,
		63,
		58,
		69,
		61,
		65,
		82,
		-1,
		195,
		-1,
		147,
		123,
		137,
		152,
		160,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		135,
		119,
		100,
		-1,
		70,
		83,
		114,
		82,
		87,
		82,
		64,
		75,
		64,
		67,
		81,
		76,
		-1,
		-1,
		135,
		138,
		-1,
		-1,
		151,
		153,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		107,
		103,
		-1,
		-1,
		71,
		96,
		85,
		93,
		88,
		68,
		74,
		77,
		66,
		70,
		82,
		-1,
		-1,
		142,
		143,
		148,
		-1,
		136,
		-1,
		154,
		-1,
		121,
		127,
		115,
		-1,
		-1,
		-1,
		109,
		72,
		93,
		103,
		97,
		95,
		86,
		72,
		79,
		77,
		73,
		84,
		-1,
		-1,
		-1,
		154,
		128,
		161,
		152,
		135,
		115,
		107,
		126,
		-1,
		96,
		-1,
		71,
		73,
		99,
		102,
		108,
		102,
		75,
		90,
		80,
		71,
		80,
		160,
		-1,
		130,
		163,
		127,
		121,
		97,
		101,
		117,
		-1,
		93,
		75,
		-1,
		103,
		93,
		124,
		109,
		90,
		77,
		84,
		84,
		77,
		-1,
		-1,
		-1,
		132,
		131,
		123,
		117,
		117,
		102,
		93,
		-1,
		105,
		87,
		66,
		83,
		83,
		74,
		82,
		114,
		110,
		97,
		97,
		89,
		-1,
		233,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		126,
		121,
		94,
		82,
		88,
		84,
		70,
		76,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		90,
		125,
		-1,
		228,
		-1,
		162,
		-1,
		-1,
		144,
		124,
		116,
		105,
		94,
		92,
		83,
		74,
		96,
		112,
		96,
		94,
		97,
		98,
		-1,
		217,
		216,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		140,
		101,
		-1,
		103,
		83,
		-1,
		105,
		101,
		-1,
		-1,
		204,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		135,
		119,
		-1,
		94,
		94,
		-1,
		-1,
		-1,
		189,
		188,
		-1,
		157,
		160,
		-1,
		150,
		141,
		149,
		96,
		100,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		172,
		170,
		165,
		162,
		148,
		132,
		110,
		99,
		120,
		-1,
		-1,
		-1,
		170,
		162,
		155,
		-1,
		-1,
		157,
		140,
		121,
		119,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		147,
		-1,
		-1,
		153,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		181,
		-1,
		-1,
		-1,
		143,
		139,
		140,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		227,
		191,
		-1,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		133,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		168,
		-1,
		168,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		173,
		181,
		-1,
		153,
		155,
		-1,
		203,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		158,
		165,
		187,
		190,
		226,
		-1,
		177
	],
	[
		-1,
		175,
		164,
		175,
		183,
		156,
		163,
		-1,
		182,
		186,
		152,
		146,
		185,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		175,
		174,
		142,
		140,
		149,
		154,
		161,
		-1,
		160,
		-1,
		196,
		175,
		186,
		191,
		135,
		132,
		152,
		171,
		153,
		145,
		211,
		165,
		136,
		130,
		148,
		138,
		147,
		139,
		-1,
		136,
		126,
		148,
		127,
		138,
		130,
		-1,
		-1,
		130,
		131,
		137,
		123,
		129,
		125,
		-1,
		135,
		119,
		-1,
		-1,
		120,
		121,
		105,
		108,
		116,
		114,
		127,
		119,
		114,
		-1,
		-1,
		111,
		107,
		114,
		101,
		97,
		114,
		127,
		109,
		123,
		122,
		-1,
		117,
		135,
		140,
		108,
		106,
		90,
		88,
		106,
		108,
		114,
		114,
		-1,
		126,
		127,
		122,
		130,
		130,
		106,
		93,
		93,
		103,
		96,
		115,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		109,
		126,
		118,
		108,
		123,
		116,
		96,
		93,
		91,
		88,
		104,
		102,
		112,
		-1,
		-1,
		217,
		186,
		217,
		175,
		156,
		-1,
		122,
		102,
		108,
		112,
		106,
		99,
		113,
		109,
		-1,
		82,
		81,
		109,
		95,
		106,
		177,
		-1,
		-1,
		175,
		167,
		152,
		155,
		132,
		128,
		117,
		116,
		108,
		94,
		90,
		96,
		99,
		99,
		105,
		76,
		86,
		90,
		88,
		113,
		-1,
		-1,
		148,
		-1,
		-1,
		174,
		157,
		-1,
		140,
		147,
		138,
		144,
		130,
		151,
		127,
		118,
		110,
		104,
		92,
		94,
		91,
		104,
		92,
		73,
		98,
		102,
		83,
		104,
		99,
		-1,
		147,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		136,
		142,
		166,
		167,
		-1,
		139,
		127,
		128,
		113,
		110,
		97,
		85,
		98,
		83,
		90,
		89,
		77,
		75,
		105,
		80,
		102,
		99,
		118,
		123,
		117,
		126,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		170,
		-1,
		175,
		176,
		151,
		124,
		127,
		114,
		105,
		92,
		81,
		92,
		81,
		78,
		86,
		69,
		84,
		75,
		74,
		92,
		102,
		110,
		114,
		120,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		190,
		176,
		168,
		153,
		151,
		-1,
		123,
		120,
		110,
		88,
		73,
		90,
		82,
		80,
		82,
		64,
		78,
		69,
		87,
		94,
		92,
		96,
		116,
		128,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		125,
		138,
		-1,
		94,
		90,
		72,
		73,
		68,
		83,
		75,
		60,
		57,
		75,
		78,
		85,
		89,
		105,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		108,
		105,
		93,
		80,
		65,
		66,
		74,
		86,
		65,
		59,
		56,
		76,
		102,
		80,
		91,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		104,
		83,
		74,
		63,
		61,
		74,
		66,
		74,
		54,
		52,
		71,
		83,
		74,
		82,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		117,
		100,
		81,
		70,
		62,
		51,
		62,
		70,
		68,
		50,
		59,
		65,
		89,
		70,
		76,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		90,
		75,
		70,
		67,
		54,
		53,
		67,
		67,
		57,
		52,
		59,
		94,
		94,
		60,
		80,
		83,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		77,
		73,
		58,
		62,
		64,
		67,
		55,
		61,
		62,
		44,
		68,
		-1,
		68,
		62,
		70,
		60,
		48,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		70,
		65,
		64,
		63,
		60,
		49,
		62,
		55,
		49,
		43,
		56,
		60,
		61,
		50,
		46,
		43,
		57,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		92,
		76,
		75,
		72,
		63,
		71,
		44,
		37,
		48,
		33,
		51,
		57,
		48,
		43,
		40,
		53,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		82,
		99,
		100,
		78,
		72,
		70,
		61,
		49,
		38,
		41,
		33,
		55,
		52,
		36,
		38,
		36,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		96,
		94,
		89,
		80,
		86,
		81,
		58,
		53,
		43,
		32,
		32,
		27,
		46,
		32,
		30,
		34,
		50,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		97,
		81,
		86,
		-1,
		78,
		-1,
		51,
		48,
		39,
		24,
		21,
		32,
		30,
		39,
		29,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		113,
		93,
		87,
		86,
		73,
		65,
		59,
		37,
		30,
		27,
		17,
		30,
		40,
		43,
		27,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		120,
		108,
		98,
		88,
		91,
		81,
		56,
		49,
		35,
		37,
		29,
		19,
		18,
		29,
		21,
		43,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		109,
		-1,
		-1,
		92,
		83,
		73,
		52,
		39,
		48,
		43,
		28,
		12,
		27,
		26,
		34,
		33,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		160,
		105,
		94,
		89,
		93,
		91,
		-1,
		65,
		63,
		43,
		55,
		62,
		30,
		18,
		12,
		0,
		21,
		38,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		117,
		111,
		82,
		75,
		79,
		-1,
		67,
		59,
		45,
		61,
		36,
		33,
		24,
		16,
		20,
		6,
		19,
		33,
		37,
		172,
		-1,
		155,
		-1,
		-1,
		-1,
		135,
		150,
		121,
		98,
		71,
		66,
		59,
		53,
		53,
		58,
		44,
		55,
		23,
		19,
		19,
		12,
		11,
		28,
		38,
		-1,
		-1,
		153,
		149,
		161,
		143,
		147,
		148,
		-1,
		-1,
		75,
		66,
		57,
		50,
		63,
		62,
		29,
		26,
		31,
		29,
		22,
		21,
		39,
		43,
		-1,
		-1,
		-1,
		165,
		-1,
		167,
		-1,
		-1,
		155,
		146,
		93,
		75,
		71,
		69,
		59,
		53,
		41,
		34,
		44,
		47,
		39,
		19,
		37,
		49,
		51,
		75,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		144,
		136,
		131,
		137,
		139,
		130,
		108,
		105,
		-1,
		75,
		82,
		47,
		54,
		46,
		52,
		51,
		43,
		24,
		38,
		54,
		53,
		48,
		67,
		62,
		71,
		-1,
		-1,
		230,
		219,
		208,
		214,
		-1,
		137,
		133,
		123,
		113,
		116,
		-1,
		-1,
		110,
		107,
		79,
		56,
		62,
		55,
		50,
		61,
		41,
		28,
		31,
		35,
		41,
		46,
		51,
		57,
		69,
		77,
		-1,
		182,
		221,
		214,
		182,
		190,
		221,
		-1,
		127,
		119,
		130,
		105,
		107,
		-1,
		-1,
		83,
		74,
		75,
		63,
		60,
		71,
		66,
		57,
		42,
		48,
		35,
		33,
		51,
		55,
		64,
		71,
		61,
		74,
		78,
		-1,
		177,
		197,
		176,
		179,
		203,
		217,
		-1,
		124,
		-1,
		-1,
		136,
		108,
		92,
		82,
		79,
		122,
		77,
		72,
		65,
		63,
		54,
		45,
		52,
		43,
		42,
		45,
		61,
		66,
		58,
		71,
		71,
		72,
		-1,
		166,
		177,
		170,
		-1,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		152,
		-1,
		119,
		-1,
		102,
		106,
		85,
		88,
		79,
		66,
		58,
		50,
		66,
		41,
		50,
		46,
		48,
		57,
		68,
		80,
		78,
		79,
		191,
		147,
		150,
		161,
		172,
		187,
		191,
		-1,
		136,
		175,
		178,
		-1,
		161,
		-1,
		-1,
		-1,
		116,
		98,
		90,
		99,
		78,
		78,
		52,
		56,
		46,
		53,
		62,
		64,
		57,
		61,
		74,
		85,
		87,
		187,
		178,
		191,
		136,
		136,
		157,
		166,
		187,
		151,
		142,
		169,
		185,
		174,
		169,
		156,
		-1,
		-1,
		139,
		108,
		-1,
		-1,
		85,
		73,
		56,
		57,
		53,
		56,
		71,
		73,
		64,
		62,
		56,
		88,
		-1,
		180,
		179,
		168,
		165,
		141,
		132,
		127,
		154,
		-1,
		-1,
		149,
		170,
		160,
		164,
		180,
		205,
		-1,
		145,
		-1,
		-1,
		130,
		-1,
		-1,
		115,
		78,
		67,
		58,
		64,
		61,
		72,
		82,
		70,
		71,
		61,
		71,
		84,
		164,
		161,
		149,
		147,
		170,
		135,
		123,
		-1,
		136,
		134,
		140,
		147,
		164,
		194,
		-1,
		-1,
		161,
		141,
		-1,
		-1,
		113,
		111,
		100,
		-1,
		90,
		63,
		68,
		88,
		90,
		79,
		73,
		67,
		74,
		73,
		81,
		89,
		173,
		187,
		176,
		172,
		171,
		179,
		128,
		121,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		108,
		101,
		89,
		77,
		67,
		77,
		81,
		85,
		77,
		70,
		65,
		76,
		68,
		72,
		89,
		-1,
		207,
		-1,
		159,
		135,
		149,
		164,
		172,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		142,
		126,
		107,
		-1,
		77,
		90,
		121,
		89,
		94,
		89,
		71,
		82,
		71,
		74,
		88,
		83,
		-1,
		-1,
		147,
		150,
		-1,
		-1,
		158,
		160,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		114,
		110,
		-1,
		-1,
		78,
		103,
		92,
		100,
		95,
		75,
		81,
		84,
		73,
		77,
		89,
		-1,
		-1,
		154,
		155,
		160,
		-1,
		143,
		-1,
		161,
		-1,
		128,
		134,
		122,
		-1,
		-1,
		-1,
		116,
		79,
		100,
		110,
		104,
		102,
		93,
		79,
		86,
		84,
		80,
		91,
		-1,
		-1,
		-1,
		161,
		135,
		168,
		159,
		142,
		122,
		114,
		133,
		-1,
		103,
		-1,
		78,
		80,
		106,
		109,
		115,
		109,
		82,
		97,
		87,
		78,
		87,
		167,
		-1,
		137,
		170,
		134,
		128,
		104,
		108,
		124,
		-1,
		100,
		82,
		-1,
		110,
		100,
		131,
		116,
		97,
		84,
		91,
		91,
		84,
		-1,
		-1,
		-1,
		139,
		138,
		130,
		124,
		124,
		109,
		100,
		-1,
		112,
		94,
		73,
		90,
		90,
		81,
		89,
		121,
		117,
		104,
		104,
		96,
		-1,
		240,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		133,
		128,
		101,
		89,
		95,
		91,
		77,
		83,
		85,
		93,
		91,
		88,
		100,
		96,
		116,
		97,
		132,
		-1,
		235,
		-1,
		169,
		-1,
		-1,
		151,
		131,
		123,
		112,
		101,
		99,
		90,
		81,
		103,
		119,
		103,
		101,
		104,
		105,
		-1,
		224,
		223,
		-1,
		170,
		162,
		148,
		-1,
		141,
		-1,
		147,
		108,
		-1,
		110,
		90,
		-1,
		112,
		108,
		-1,
		-1,
		211,
		186,
		-1,
		-1,
		-1,
		171,
		151,
		142,
		126,
		-1,
		101,
		101,
		-1,
		-1,
		-1,
		196,
		195,
		-1,
		164,
		167,
		-1,
		157,
		148,
		156,
		103,
		107,
		-1,
		-1,
		-1,
		205,
		186,
		180,
		179,
		177,
		172,
		169,
		155,
		139,
		117,
		106,
		127,
		-1,
		-1,
		-1,
		177,
		169,
		162,
		-1,
		-1,
		164,
		147,
		128,
		126,
		-1,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		154,
		-1,
		-1,
		160,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		188,
		-1,
		-1,
		-1,
		150,
		146,
		147,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		234,
		198,
		-1,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		213,
		211,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		140,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		175,
		-1,
		175,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		188,
		180,
		188,
		-1,
		160,
		162,
		-1,
		210,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		165,
		172,
		194,
		197,
		233,
		-1,
		184
	],
	[
		-1,
		196,
		185,
		196,
		204,
		177,
		184,
		-1,
		203,
		207,
		173,
		167,
		206,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		196,
		195,
		163,
		161,
		170,
		175,
		182,
		-1,
		181,
		-1,
		217,
		196,
		207,
		212,
		156,
		153,
		173,
		192,
		174,
		166,
		232,
		186,
		157,
		151,
		169,
		159,
		168,
		160,
		-1,
		157,
		147,
		169,
		148,
		159,
		151,
		-1,
		-1,
		151,
		152,
		158,
		144,
		150,
		146,
		-1,
		156,
		140,
		-1,
		-1,
		141,
		142,
		126,
		129,
		137,
		135,
		148,
		140,
		135,
		-1,
		-1,
		132,
		128,
		135,
		122,
		118,
		135,
		148,
		130,
		144,
		143,
		-1,
		138,
		156,
		161,
		129,
		127,
		111,
		109,
		127,
		129,
		135,
		135,
		-1,
		147,
		148,
		143,
		151,
		151,
		127,
		114,
		114,
		124,
		117,
		136,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		117,
		114,
		112,
		109,
		125,
		123,
		133,
		-1,
		-1,
		238,
		207,
		238,
		196,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		103,
		102,
		130,
		116,
		127,
		198,
		-1,
		-1,
		196,
		188,
		173,
		176,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		97,
		107,
		111,
		109,
		134,
		-1,
		-1,
		153,
		-1,
		-1,
		195,
		178,
		-1,
		161,
		168,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		94,
		119,
		123,
		104,
		125,
		120,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		154,
		157,
		163,
		187,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		98,
		96,
		126,
		101,
		123,
		118,
		123,
		128,
		122,
		131,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		191,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		90,
		105,
		96,
		95,
		107,
		107,
		115,
		119,
		125,
		-1,
		253,
		-1,
		195,
		179,
		181,
		153,
		174,
		-1,
		211,
		197,
		189,
		174,
		172,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		103,
		85,
		99,
		90,
		108,
		111,
		97,
		101,
		121,
		133,
		213,
		203,
		-1,
		185,
		190,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		96,
		81,
		78,
		96,
		99,
		90,
		94,
		110,
		-1,
		-1,
		198,
		202,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		107,
		86,
		80,
		77,
		97,
		107,
		85,
		96,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		87,
		95,
		75,
		73,
		92,
		88,
		79,
		87,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		138,
		121,
		102,
		91,
		83,
		72,
		83,
		91,
		89,
		71,
		80,
		86,
		94,
		75,
		81,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		111,
		96,
		91,
		88,
		75,
		74,
		88,
		88,
		78,
		73,
		80,
		99,
		99,
		65,
		84,
		87,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		98,
		94,
		79,
		83,
		85,
		88,
		76,
		82,
		83,
		65,
		89,
		-1,
		73,
		67,
		74,
		64,
		53,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		91,
		86,
		85,
		84,
		81,
		70,
		83,
		76,
		70,
		64,
		77,
		81,
		72,
		55,
		51,
		48,
		62,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		113,
		97,
		96,
		93,
		84,
		92,
		65,
		58,
		69,
		54,
		72,
		69,
		59,
		49,
		41,
		58,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		103,
		120,
		121,
		99,
		93,
		91,
		82,
		70,
		59,
		62,
		54,
		71,
		63,
		47,
		44,
		37,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		117,
		115,
		110,
		101,
		107,
		102,
		79,
		74,
		64,
		53,
		53,
		48,
		67,
		53,
		51,
		35,
		51,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		118,
		102,
		107,
		-1,
		99,
		-1,
		72,
		69,
		60,
		45,
		42,
		53,
		51,
		52,
		30,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		134,
		114,
		108,
		107,
		94,
		86,
		80,
		58,
		51,
		48,
		38,
		51,
		53,
		44,
		28,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		140,
		128,
		118,
		108,
		112,
		102,
		77,
		70,
		56,
		58,
		50,
		40,
		33,
		22,
		22,
		39,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		129,
		-1,
		-1,
		112,
		104,
		94,
		73,
		60,
		69,
		64,
		49,
		33,
		34,
		14,
		34,
		32,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		84,
		64,
		76,
		83,
		51,
		39,
		33,
		24,
		0,
		37,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		80,
		66,
		82,
		57,
		54,
		45,
		35,
		35,
		21,
		22,
		42,
		39,
		193,
		-1,
		174,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		74,
		79,
		65,
		76,
		42,
		38,
		34,
		27,
		26,
		39,
		47,
		-1,
		-1,
		172,
		168,
		181,
		163,
		167,
		168,
		-1,
		-1,
		95,
		86,
		77,
		69,
		82,
		83,
		48,
		45,
		50,
		44,
		37,
		35,
		49,
		50,
		-1,
		-1,
		-1,
		184,
		-1,
		186,
		-1,
		-1,
		174,
		166,
		113,
		95,
		91,
		89,
		78,
		72,
		60,
		53,
		63,
		62,
		54,
		34,
		52,
		59,
		58,
		84,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		163,
		155,
		150,
		156,
		158,
		149,
		128,
		125,
		-1,
		95,
		101,
		66,
		73,
		65,
		69,
		66,
		58,
		39,
		53,
		69,
		68,
		63,
		76,
		71,
		80,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		156,
		152,
		142,
		132,
		135,
		-1,
		-1,
		129,
		126,
		98,
		75,
		78,
		71,
		66,
		76,
		56,
		43,
		46,
		50,
		56,
		61,
		66,
		72,
		78,
		86,
		-1,
		203,
		240,
		233,
		201,
		209,
		240,
		-1,
		146,
		138,
		149,
		124,
		126,
		-1,
		-1,
		102,
		93,
		94,
		82,
		79,
		86,
		81,
		72,
		57,
		63,
		50,
		48,
		66,
		70,
		79,
		86,
		76,
		89,
		93,
		-1,
		196,
		216,
		195,
		198,
		222,
		236,
		-1,
		143,
		-1,
		-1,
		155,
		127,
		111,
		101,
		98,
		141,
		96,
		91,
		80,
		78,
		69,
		60,
		67,
		58,
		57,
		60,
		76,
		81,
		73,
		86,
		86,
		87,
		-1,
		185,
		196,
		189,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		171,
		-1,
		138,
		-1,
		121,
		125,
		104,
		107,
		94,
		81,
		73,
		65,
		81,
		56,
		65,
		61,
		63,
		72,
		83,
		95,
		93,
		94,
		210,
		166,
		169,
		180,
		191,
		206,
		210,
		-1,
		155,
		194,
		193,
		-1,
		177,
		-1,
		-1,
		-1,
		135,
		117,
		109,
		114,
		93,
		93,
		67,
		71,
		61,
		68,
		77,
		79,
		72,
		76,
		89,
		100,
		102,
		206,
		197,
		210,
		155,
		155,
		176,
		185,
		206,
		170,
		161,
		188,
		200,
		189,
		184,
		171,
		-1,
		-1,
		158,
		127,
		-1,
		-1,
		100,
		88,
		71,
		72,
		68,
		71,
		86,
		88,
		79,
		77,
		71,
		103,
		-1,
		199,
		198,
		187,
		184,
		160,
		151,
		146,
		173,
		-1,
		-1,
		168,
		189,
		179,
		183,
		199,
		224,
		-1,
		160,
		-1,
		-1,
		145,
		-1,
		-1,
		130,
		93,
		82,
		73,
		79,
		76,
		87,
		97,
		85,
		86,
		76,
		86,
		99,
		183,
		180,
		168,
		166,
		189,
		154,
		142,
		-1,
		155,
		153,
		159,
		166,
		183,
		213,
		-1,
		-1,
		176,
		156,
		-1,
		-1,
		128,
		126,
		115,
		-1,
		105,
		78,
		83,
		103,
		105,
		94,
		88,
		82,
		89,
		88,
		96,
		104,
		192,
		206,
		195,
		191,
		190,
		198,
		147,
		140,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		166,
		162,
		-1,
		-1,
		123,
		116,
		104,
		92,
		82,
		92,
		96,
		100,
		92,
		85,
		80,
		91,
		83,
		87,
		104,
		-1,
		226,
		-1,
		178,
		154,
		168,
		183,
		191,
		-1,
		-1,
		-1,
		183,
		169,
		162,
		150,
		148,
		-1,
		157,
		141,
		122,
		-1,
		92,
		105,
		136,
		104,
		109,
		104,
		86,
		97,
		86,
		89,
		103,
		98,
		-1,
		-1,
		166,
		169,
		-1,
		-1,
		173,
		175,
		-1,
		174,
		163,
		148,
		140,
		-1,
		-1,
		129,
		125,
		-1,
		-1,
		93,
		118,
		107,
		115,
		110,
		90,
		96,
		99,
		88,
		92,
		104,
		-1,
		-1,
		173,
		174,
		179,
		-1,
		158,
		-1,
		176,
		-1,
		143,
		149,
		137,
		-1,
		-1,
		-1,
		131,
		94,
		115,
		125,
		119,
		117,
		108,
		94,
		101,
		99,
		95,
		106,
		-1,
		-1,
		-1,
		176,
		150,
		183,
		174,
		157,
		137,
		129,
		148,
		-1,
		118,
		-1,
		93,
		95,
		121,
		124,
		130,
		124,
		97,
		112,
		102,
		93,
		102,
		182,
		-1,
		152,
		185,
		149,
		143,
		119,
		123,
		139,
		-1,
		115,
		97,
		-1,
		125,
		115,
		146,
		131,
		112,
		99,
		106,
		106,
		99,
		-1,
		-1,
		-1,
		154,
		153,
		145,
		139,
		139,
		124,
		115,
		-1,
		127,
		109,
		88,
		105,
		105,
		96,
		104,
		136,
		132,
		119,
		119,
		111,
		-1,
		255,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		148,
		143,
		116,
		104,
		110,
		106,
		92,
		98,
		100,
		108,
		106,
		103,
		115,
		111,
		131,
		112,
		147,
		-1,
		250,
		-1,
		184,
		-1,
		-1,
		166,
		146,
		138,
		127,
		116,
		114,
		105,
		96,
		118,
		134,
		118,
		116,
		119,
		120,
		-1,
		239,
		238,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		162,
		123,
		-1,
		125,
		105,
		-1,
		127,
		123,
		-1,
		-1,
		226,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		157,
		141,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		211,
		210,
		-1,
		179,
		182,
		-1,
		172,
		163,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		220,
		201,
		195,
		194,
		192,
		187,
		184,
		170,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		192,
		184,
		177,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		203,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		226,
		249,
		213,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		228,
		226,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		148,
		166,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		157,
		158,
		153,
		161,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		140,
		157,
		149,
		139,
		154,
		147,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		248,
		217,
		248,
		206,
		187,
		-1,
		153,
		133,
		139,
		143,
		137,
		130,
		144,
		140,
		-1,
		113,
		112,
		140,
		126,
		137,
		208,
		-1,
		-1,
		206,
		198,
		183,
		186,
		163,
		159,
		148,
		147,
		139,
		125,
		121,
		127,
		130,
		130,
		136,
		107,
		117,
		121,
		119,
		131,
		-1,
		-1,
		145,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		169,
		175,
		161,
		182,
		158,
		149,
		141,
		135,
		123,
		125,
		122,
		135,
		123,
		104,
		129,
		133,
		114,
		121,
		116,
		-1,
		144,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		198,
		-1,
		170,
		158,
		159,
		144,
		141,
		128,
		116,
		129,
		114,
		121,
		120,
		108,
		106,
		136,
		111,
		120,
		110,
		115,
		120,
		114,
		123,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		206,
		207,
		182,
		155,
		158,
		145,
		136,
		123,
		112,
		123,
		112,
		109,
		117,
		100,
		115,
		106,
		105,
		99,
		99,
		107,
		111,
		117,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		207,
		199,
		184,
		182,
		-1,
		154,
		151,
		141,
		119,
		104,
		121,
		113,
		111,
		113,
		95,
		109,
		100,
		105,
		103,
		89,
		93,
		113,
		125,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		156,
		169,
		-1,
		125,
		121,
		103,
		104,
		99,
		114,
		106,
		91,
		88,
		101,
		96,
		82,
		86,
		102,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		139,
		136,
		124,
		111,
		96,
		97,
		105,
		117,
		96,
		90,
		87,
		92,
		99,
		77,
		88,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		135,
		114,
		105,
		94,
		92,
		105,
		97,
		105,
		85,
		83,
		87,
		80,
		71,
		79,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		148,
		131,
		112,
		101,
		93,
		82,
		93,
		101,
		99,
		81,
		90,
		81,
		86,
		67,
		73,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		121,
		106,
		101,
		98,
		85,
		84,
		98,
		98,
		88,
		83,
		90,
		91,
		91,
		57,
		76,
		79,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		108,
		104,
		89,
		93,
		95,
		98,
		86,
		92,
		93,
		75,
		99,
		-1,
		65,
		59,
		66,
		56,
		45,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		101,
		96,
		95,
		94,
		91,
		80,
		93,
		86,
		80,
		74,
		87,
		80,
		64,
		47,
		43,
		40,
		54,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		123,
		107,
		106,
		103,
		94,
		102,
		75,
		68,
		79,
		64,
		82,
		61,
		51,
		41,
		33,
		50,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		113,
		130,
		131,
		109,
		103,
		101,
		92,
		80,
		69,
		72,
		64,
		63,
		55,
		39,
		36,
		29,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		127,
		125,
		120,
		111,
		117,
		112,
		89,
		84,
		74,
		63,
		63,
		58,
		61,
		47,
		45,
		27,
		43,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		128,
		112,
		117,
		-1,
		109,
		-1,
		82,
		79,
		70,
		55,
		52,
		57,
		48,
		44,
		22,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		144,
		124,
		118,
		117,
		104,
		96,
		90,
		68,
		61,
		58,
		48,
		61,
		63,
		36,
		20,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		150,
		138,
		128,
		118,
		122,
		112,
		87,
		80,
		66,
		68,
		60,
		50,
		43,
		31,
		26,
		24,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		139,
		-1,
		-1,
		122,
		114,
		104,
		83,
		70,
		79,
		74,
		59,
		43,
		44,
		34,
		14,
		6,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		190,
		135,
		124,
		119,
		123,
		121,
		-1,
		95,
		94,
		74,
		86,
		93,
		61,
		49,
		43,
		34,
		39,
		0,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		112,
		105,
		109,
		-1,
		97,
		90,
		76,
		92,
		67,
		64,
		55,
		45,
		45,
		31,
		25,
		12,
		2,
		203,
		-1,
		183,
		-1,
		-1,
		-1,
		165,
		180,
		151,
		128,
		101,
		96,
		89,
		83,
		84,
		89,
		75,
		86,
		52,
		48,
		44,
		31,
		27,
		16,
		17,
		-1,
		-1,
		181,
		177,
		191,
		173,
		177,
		178,
		-1,
		-1,
		105,
		96,
		87,
		79,
		92,
		93,
		58,
		55,
		55,
		48,
		41,
		40,
		35,
		20,
		-1,
		-1,
		-1,
		193,
		-1,
		195,
		-1,
		-1,
		183,
		176,
		123,
		105,
		101,
		99,
		88,
		82,
		70,
		63,
		73,
		66,
		58,
		38,
		56,
		52,
		28,
		54,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		172,
		164,
		159,
		165,
		167,
		158,
		138,
		135,
		-1,
		105,
		111,
		76,
		83,
		74,
		73,
		70,
		62,
		43,
		57,
		52,
		40,
		39,
		46,
		41,
		50,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		165,
		161,
		151,
		141,
		144,
		-1,
		-1,
		138,
		135,
		108,
		84,
		82,
		75,
		70,
		80,
		60,
		47,
		50,
		54,
		44,
		37,
		42,
		48,
		48,
		56,
		-1,
		212,
		249,
		242,
		210,
		218,
		249,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		111,
		102,
		103,
		91,
		88,
		90,
		85,
		76,
		61,
		67,
		54,
		52,
		70,
		58,
		55,
		62,
		51,
		64,
		68,
		-1,
		205,
		225,
		204,
		207,
		231,
		245,
		-1,
		152,
		-1,
		-1,
		164,
		136,
		120,
		110,
		107,
		150,
		105,
		100,
		84,
		82,
		73,
		64,
		71,
		62,
		61,
		64,
		66,
		70,
		64,
		61,
		61,
		62,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		180,
		-1,
		147,
		-1,
		130,
		134,
		113,
		116,
		98,
		85,
		77,
		69,
		85,
		60,
		69,
		65,
		67,
		76,
		74,
		82,
		68,
		69,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		164,
		203,
		197,
		-1,
		181,
		-1,
		-1,
		-1,
		144,
		126,
		118,
		118,
		97,
		97,
		71,
		75,
		65,
		72,
		81,
		83,
		76,
		80,
		90,
		78,
		77,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		179,
		170,
		197,
		204,
		193,
		188,
		175,
		-1,
		-1,
		167,
		136,
		-1,
		-1,
		104,
		92,
		75,
		76,
		72,
		75,
		90,
		92,
		83,
		81,
		75,
		83,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		198,
		188,
		192,
		208,
		233,
		-1,
		164,
		-1,
		-1,
		149,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		80,
		91,
		101,
		89,
		90,
		80,
		90,
		97,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		192,
		222,
		-1,
		-1,
		180,
		160,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		107,
		109,
		98,
		92,
		86,
		93,
		92,
		100,
		102,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		166,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		100,
		104,
		96,
		89,
		84,
		95,
		87,
		91,
		99,
		-1,
		235,
		-1,
		187,
		163,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		90,
		101,
		90,
		93,
		92,
		95,
		-1,
		-1,
		175,
		178,
		-1,
		-1,
		177,
		179,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		94,
		100,
		103,
		92,
		96,
		92,
		-1,
		-1,
		182,
		183,
		184,
		-1,
		162,
		-1,
		180,
		-1,
		147,
		153,
		141,
		-1,
		-1,
		-1,
		135,
		98,
		119,
		129,
		123,
		121,
		112,
		98,
		105,
		103,
		99,
		102,
		-1,
		-1,
		-1,
		180,
		154,
		187,
		178,
		161,
		141,
		133,
		152,
		-1,
		122,
		-1,
		97,
		99,
		125,
		128,
		134,
		128,
		101,
		116,
		106,
		97,
		106,
		186,
		-1,
		156,
		189,
		153,
		147,
		123,
		127,
		143,
		-1,
		119,
		101,
		-1,
		129,
		119,
		150,
		135,
		116,
		103,
		110,
		110,
		103,
		-1,
		-1,
		-1,
		158,
		157,
		149,
		143,
		143,
		128,
		119,
		-1,
		131,
		113,
		92,
		109,
		109,
		100,
		108,
		140,
		136,
		123,
		123,
		115,
		-1,
		259,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		152,
		147,
		120,
		108,
		114,
		110,
		96,
		102,
		104,
		112,
		110,
		107,
		119,
		115,
		135,
		116,
		151,
		-1,
		254,
		-1,
		188,
		-1,
		-1,
		170,
		150,
		142,
		131,
		120,
		118,
		109,
		100,
		122,
		138,
		122,
		120,
		123,
		124,
		-1,
		243,
		242,
		-1,
		189,
		181,
		167,
		-1,
		160,
		-1,
		166,
		127,
		-1,
		129,
		109,
		-1,
		131,
		127,
		-1,
		-1,
		230,
		205,
		-1,
		-1,
		-1,
		190,
		170,
		161,
		145,
		-1,
		120,
		120,
		-1,
		-1,
		-1,
		215,
		214,
		-1,
		183,
		186,
		-1,
		176,
		167,
		175,
		122,
		126,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		198,
		196,
		191,
		188,
		174,
		158,
		136,
		125,
		146,
		-1,
		-1,
		-1,
		196,
		188,
		181,
		-1,
		-1,
		183,
		166,
		147,
		145,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		173,
		-1,
		-1,
		179,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		207,
		-1,
		-1,
		-1,
		169,
		165,
		166,
		-1,
		-1,
		-1,
		-1,
		229,
		230,
		253,
		217,
		-1,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		232,
		230,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		194,
		-1,
		194,
		169,
		176,
		-1,
		-1,
		-1,
		-1,
		207,
		199,
		207,
		-1,
		179,
		181,
		-1,
		229,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		184,
		191,
		213,
		216,
		252,
		-1,
		203
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		209,
		211,
		177,
		171,
		210,
		181,
		187,
		198,
		-1,
		-1,
		-1,
		200,
		199,
		169,
		167,
		176,
		181,
		188,
		-1,
		211,
		-1,
		221,
		200,
		211,
		216,
		162,
		159,
		179,
		198,
		204,
		196,
		236,
		192,
		163,
		157,
		175,
		180,
		198,
		190,
		-1,
		163,
		153,
		175,
		179,
		191,
		174,
		-1,
		-1,
		157,
		158,
		164,
		176,
		181,
		186,
		-1,
		209,
		193,
		-1,
		-1,
		147,
		160,
		156,
		159,
		167,
		183,
		201,
		193,
		188,
		-1,
		-1,
		148,
		152,
		165,
		166,
		164,
		188,
		201,
		183,
		197,
		196,
		-1,
		136,
		154,
		163,
		172,
		178,
		164,
		162,
		180,
		182,
		188,
		191,
		-1,
		128,
		130,
		159,
		165,
		177,
		180,
		167,
		167,
		177,
		170,
		189,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		133,
		159,
		158,
		154,
		172,
		177,
		170,
		167,
		165,
		162,
		178,
		179,
		189,
		-1,
		-1,
		181,
		150,
		185,
		142,
		127,
		-1,
		121,
		140,
		146,
		150,
		155,
		160,
		174,
		170,
		-1,
		156,
		155,
		186,
		172,
		183,
		141,
		-1,
		-1,
		139,
		131,
		116,
		119,
		116,
		116,
		146,
		145,
		150,
		152,
		151,
		157,
		160,
		160,
		166,
		150,
		160,
		164,
		175,
		190,
		-1,
		-1,
		245,
		-1,
		-1,
		138,
		121,
		-1,
		104,
		111,
		111,
		128,
		118,
		139,
		154,
		158,
		166,
		165,
		153,
		155,
		152,
		165,
		153,
		147,
		172,
		176,
		170,
		191,
		186,
		-1,
		244,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		97,
		100,
		106,
		130,
		140,
		-1,
		161,
		159,
		183,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		154,
		156,
		189,
		167,
		189,
		186,
		215,
		220,
		214,
		223,
		-1,
		146,
		142,
		138,
		145,
		94,
		-1,
		-1,
		134,
		-1,
		148,
		161,
		165,
		163,
		166,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		156,
		167,
		162,
		161,
		179,
		194,
		207,
		211,
		217,
		-1,
		196,
		-1,
		138,
		122,
		124,
		96,
		117,
		-1,
		154,
		149,
		169,
		167,
		158,
		-1,
		161,
		164,
		171,
		149,
		134,
		151,
		143,
		141,
		146,
		151,
		165,
		156,
		174,
		181,
		189,
		193,
		213,
		225,
		156,
		146,
		-1,
		128,
		133,
		92,
		100,
		119,
		192,
		164,
		-1,
		159,
		-1,
		151,
		176,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		150,
		147,
		144,
		162,
		165,
		182,
		186,
		202,
		-1,
		-1,
		141,
		145,
		134,
		85,
		104,
		128,
		165,
		157,
		146,
		145,
		-1,
		136,
		166,
		163,
		149,
		136,
		126,
		127,
		135,
		148,
		127,
		146,
		149,
		171,
		199,
		177,
		189,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		111,
		82,
		106,
		148,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		156,
		139,
		135,
		124,
		122,
		135,
		130,
		146,
		150,
		149,
		168,
		180,
		171,
		191,
		-1,
		-1,
		-1,
		141,
		130,
		131,
		77,
		100,
		137,
		154,
		140,
		145,
		120,
		113,
		107,
		159,
		156,
		123,
		131,
		123,
		112,
		126,
		134,
		138,
		147,
		156,
		162,
		186,
		186,
		192,
		-1,
		-1,
		148,
		138,
		122,
		124,
		121,
		91,
		98,
		130,
		145,
		142,
		-1,
		112,
		-1,
		101,
		109,
		108,
		114,
		126,
		112,
		117,
		128,
		140,
		153,
		149,
		156,
		191,
		191,
		176,
		196,
		199,
		-1,
		-1,
		-1,
		141,
		136,
		111,
		88,
		72,
		108,
		-1,
		112,
		113,
		-1,
		106,
		100,
		106,
		105,
		112,
		109,
		109,
		123,
		131,
		127,
		143,
		149,
		141,
		177,
		-1,
		184,
		178,
		186,
		176,
		164,
		-1,
		-1,
		-1,
		134,
		113,
		106,
		126,
		67,
		119,
		-1,
		-1,
		97,
		90,
		-1,
		93,
		93,
		100,
		109,
		114,
		119,
		127,
		122,
		135,
		140,
		146,
		151,
		169,
		173,
		177,
		166,
		162,
		159,
		173,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		67,
		87,
		-1,
		105,
		97,
		88,
		82,
		88,
		106,
		104,
		124,
		116,
		130,
		130,
		136,
		144,
		129,
		132,
		148,
		146,
		164,
		172,
		164,
		158,
		157,
		169,
		-1,
		154,
		140,
		111,
		-1,
		-1,
		100,
		-1,
		64,
		83,
		99,
		-1,
		122,
		101,
		124,
		102,
		116,
		112,
		150,
		151,
		129,
		134,
		142,
		152,
		154,
		143,
		154,
		146,
		168,
		168,
		152,
		153,
		162,
		-1,
		160,
		147,
		105,
		101,
		90,
		110,
		61,
		70,
		86,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		126,
		124,
		140,
		131,
		137,
		153,
		156,
		158,
		148,
		137,
		143,
		140,
		162,
		148,
		146,
		165,
		181,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		76,
		63,
		57,
		-1,
		103,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		148,
		132,
		137,
		-1,
		183,
		-1,
		156,
		158,
		152,
		137,
		134,
		145,
		143,
		154,
		171,
		-1,
		110,
		95,
		88,
		78,
		92,
		60,
		-1,
		94,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		164,
		144,
		138,
		137,
		178,
		178,
		164,
		150,
		143,
		140,
		137,
		150,
		170,
		161,
		173,
		-1,
		-1,
		-1,
		115,
		90,
		84,
		56,
		60,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		181,
		169,
		159,
		149,
		183,
		184,
		169,
		162,
		148,
		150,
		148,
		146,
		151,
		172,
		173,
		186,
		-1,
		-1,
		89,
		82,
		70,
		38,
		33,
		-1,
		-1,
		-1,
		140,
		156,
		148,
		119,
		170,
		-1,
		-1,
		161,
		159,
		169,
		165,
		152,
		172,
		175,
		161,
		145,
		160,
		172,
		180,
		185,
		-1,
		92,
		79,
		-1,
		-1,
		10,
		28,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		151,
		172,
		197,
		164,
		-1,
		169,
		170,
		156,
		170,
		177,
		163,
		158,
		152,
		155,
		173,
		190,
		-1,
		-1,
		0,
		-1,
		45,
		-1,
		-1,
		-1,
		-1,
		130,
		144,
		165,
		171,
		183,
		-1,
		178,
		172,
		158,
		175,
		176,
		173,
		164,
		156,
		161,
		158,
		171,
		185,
		189,
		23,
		-1,
		56,
		-1,
		-1,
		-1,
		125,
		155,
		225,
		202,
		175,
		179,
		172,
		166,
		166,
		182,
		184,
		195,
		163,
		159,
		160,
		164,
		163,
		180,
		190,
		-1,
		-1,
		56,
		73,
		108,
		120,
		152,
		252,
		-1,
		-1,
		176,
		169,
		170,
		173,
		176,
		179,
		169,
		166,
		171,
		176,
		164,
		173,
		191,
		195,
		-1,
		-1,
		-1,
		76,
		-1,
		91,
		-1,
		-1,
		162,
		249,
		196,
		178,
		174,
		160,
		174,
		168,
		170,
		174,
		184,
		189,
		185,
		166,
		177,
		200,
		189,
		227,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		105,
		80,
		95,
		141,
		146,
		137,
		211,
		208,
		-1,
		156,
		197,
		165,
		179,
		175,
		182,
		187,
		189,
		167,
		174,
		190,
		189,
		184,
		219,
		211,
		217,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		111,
		97,
		127,
		117,
		123,
		-1,
		-1,
		170,
		167,
		170,
		157,
		163,
		168,
		171,
		196,
		176,
		163,
		167,
		171,
		177,
		182,
		187,
		193,
		208,
		223,
		-1,
		137,
		218,
		211,
		194,
		202,
		233,
		-1,
		114,
		123,
		104,
		109,
		117,
		-1,
		-1,
		143,
		139,
		144,
		153,
		156,
		192,
		191,
		192,
		177,
		183,
		170,
		169,
		187,
		191,
		200,
		207,
		197,
		210,
		214,
		-1,
		151,
		194,
		188,
		191,
		215,
		229,
		-1,
		127,
		-1,
		-1,
		112,
		130,
		138,
		134,
		138,
		191,
		167,
		162,
		175,
		177,
		189,
		180,
		187,
		178,
		178,
		181,
		196,
		201,
		193,
		207,
		207,
		208,
		-1,
		186,
		174,
		182,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		128,
		-1,
		164,
		-1,
		157,
		161,
		175,
		178,
		200,
		187,
		193,
		185,
		201,
		176,
		186,
		182,
		183,
		192,
		203,
		215,
		214,
		215,
		246,
		202,
		182,
		173,
		220,
		235,
		239,
		-1,
		140,
		179,
		166,
		-1,
		137,
		-1,
		-1,
		-1,
		171,
		188,
		180,
		196,
		199,
		199,
		187,
		191,
		181,
		188,
		198,
		200,
		192,
		196,
		209,
		220,
		223,
		242,
		233,
		246,
		191,
		187,
		205,
		214,
		235,
		155,
		146,
		173,
		173,
		162,
		157,
		144,
		-1,
		-1,
		194,
		198,
		-1,
		-1,
		206,
		208,
		191,
		192,
		188,
		191,
		206,
		209,
		199,
		197,
		191,
		223,
		-1,
		235,
		234,
		223,
		220,
		196,
		187,
		182,
		206,
		-1,
		-1,
		158,
		174,
		187,
		191,
		204,
		229,
		-1,
		147,
		-1,
		-1,
		215,
		-1,
		-1,
		250,
		213,
		202,
		193,
		199,
		196,
		207,
		217,
		205,
		206,
		196,
		206,
		219,
		219,
		216,
		204,
		202,
		225,
		190,
		178,
		-1,
		173,
		161,
		167,
		174,
		191,
		218,
		-1,
		-1,
		163,
		154,
		-1,
		-1,
		234,
		241,
		235,
		-1,
		225,
		198,
		203,
		223,
		225,
		214,
		208,
		202,
		209,
		208,
		216,
		224,
		228,
		242,
		231,
		227,
		226,
		234,
		183,
		176,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		173,
		-1,
		-1,
		241,
		236,
		224,
		212,
		202,
		212,
		216,
		220,
		212,
		205,
		200,
		211,
		203,
		207,
		224,
		-1,
		262,
		-1,
		214,
		182,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		277,
		261,
		242,
		-1,
		212,
		225,
		256,
		224,
		229,
		224,
		206,
		217,
		206,
		209,
		223,
		218,
		-1,
		-1,
		200,
		203,
		-1,
		-1,
		227,
		246,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		249,
		245,
		-1,
		-1,
		213,
		238,
		227,
		235,
		230,
		210,
		216,
		219,
		208,
		212,
		224,
		-1,
		-1,
		207,
		210,
		215,
		-1,
		236,
		-1,
		230,
		-1,
		175,
		191,
		193,
		-1,
		-1,
		-1,
		251,
		214,
		235,
		245,
		239,
		237,
		228,
		214,
		221,
		219,
		215,
		226,
		-1,
		-1,
		-1,
		256,
		230,
		237,
		228,
		211,
		191,
		183,
		208,
		-1,
		238,
		-1,
		213,
		215,
		241,
		244,
		250,
		244,
		217,
		232,
		222,
		213,
		222,
		262,
		-1,
		232,
		265,
		229,
		197,
		197,
		196,
		259,
		-1,
		235,
		217,
		-1,
		245,
		235,
		266,
		251,
		232,
		219,
		226,
		226,
		219,
		-1,
		-1,
		-1,
		234,
		233,
		225,
		219,
		217,
		202,
		197,
		-1,
		247,
		229,
		208,
		225,
		225,
		216,
		224,
		256,
		252,
		239,
		239,
		231,
		-1,
		334,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		228,
		237,
		210,
		198,
		212,
		219,
		212,
		216,
		220,
		228,
		226,
		223,
		235,
		231,
		251,
		232,
		267,
		-1,
		341,
		-1,
		264,
		-1,
		-1,
		244,
		230,
		232,
		221,
		210,
		208,
		211,
		209,
		231,
		254,
		238,
		236,
		239,
		240,
		-1,
		332,
		331,
		-1,
		263,
		255,
		241,
		-1,
		234,
		-1,
		256,
		217,
		-1,
		238,
		218,
		-1,
		247,
		243,
		-1,
		-1,
		319,
		279,
		-1,
		-1,
		-1,
		264,
		244,
		251,
		235,
		-1,
		229,
		229,
		-1,
		-1,
		-1,
		304,
		288,
		-1,
		257,
		260,
		-1,
		251,
		257,
		284,
		231,
		235,
		-1,
		-1,
		-1,
		313,
		294,
		288,
		272,
		277,
		265,
		282,
		268,
		267,
		245,
		234,
		255,
		-1,
		-1,
		-1,
		285,
		277,
		277,
		-1,
		-1,
		292,
		275,
		256,
		254,
		-1,
		-1,
		-1,
		307,
		288,
		-1,
		-1,
		282,
		-1,
		-1,
		288,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		323,
		296,
		-1,
		-1,
		-1,
		278,
		274,
		275,
		-1,
		-1,
		-1,
		-1,
		317,
		318,
		342,
		317,
		-1,
		-1,
		-1,
		270,
		264,
		-1,
		-1,
		320,
		318,
		-1,
		-1,
		-1,
		298,
		282,
		-1,
		268,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		301,
		-1,
		-1,
		-1,
		303,
		-1,
		303,
		278,
		285,
		-1,
		-1,
		-1,
		-1,
		316,
		308,
		316,
		-1,
		288,
		290,
		-1,
		338,
		-1,
		-1,
		331,
		322,
		-1,
		-1,
		293,
		300,
		322,
		325,
		361,
		-1,
		312
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		195,
		184,
		195,
		203,
		176,
		183,
		-1,
		204,
		206,
		172,
		166,
		205,
		176,
		182,
		193,
		-1,
		-1,
		-1,
		195,
		194,
		164,
		162,
		171,
		176,
		183,
		-1,
		206,
		-1,
		216,
		195,
		206,
		211,
		157,
		154,
		174,
		193,
		199,
		191,
		231,
		187,
		158,
		152,
		170,
		175,
		193,
		185,
		-1,
		158,
		148,
		170,
		174,
		186,
		169,
		-1,
		-1,
		152,
		153,
		159,
		171,
		176,
		181,
		-1,
		204,
		188,
		-1,
		-1,
		142,
		155,
		151,
		154,
		162,
		178,
		196,
		188,
		183,
		-1,
		-1,
		143,
		147,
		160,
		161,
		159,
		183,
		196,
		178,
		192,
		191,
		-1,
		131,
		149,
		158,
		167,
		173,
		159,
		157,
		175,
		177,
		183,
		186,
		-1,
		123,
		125,
		154,
		160,
		172,
		175,
		162,
		162,
		172,
		165,
		184,
		175,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		120,
		128,
		154,
		153,
		149,
		167,
		172,
		165,
		162,
		160,
		157,
		173,
		174,
		184,
		-1,
		-1,
		176,
		145,
		180,
		137,
		122,
		-1,
		116,
		135,
		141,
		145,
		150,
		155,
		169,
		165,
		-1,
		151,
		150,
		181,
		167,
		178,
		136,
		-1,
		-1,
		134,
		126,
		111,
		114,
		111,
		111,
		141,
		140,
		145,
		147,
		146,
		152,
		155,
		155,
		161,
		145,
		155,
		159,
		170,
		185,
		-1,
		-1,
		240,
		-1,
		-1,
		133,
		116,
		-1,
		99,
		106,
		106,
		123,
		113,
		134,
		149,
		153,
		161,
		160,
		148,
		150,
		147,
		160,
		148,
		142,
		167,
		171,
		165,
		186,
		181,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		92,
		95,
		101,
		125,
		135,
		-1,
		156,
		154,
		178,
		169,
		166,
		153,
		141,
		154,
		139,
		146,
		145,
		149,
		151,
		184,
		162,
		184,
		181,
		210,
		215,
		209,
		218,
		-1,
		141,
		137,
		133,
		140,
		89,
		-1,
		-1,
		129,
		-1,
		143,
		156,
		160,
		158,
		161,
		170,
		161,
		148,
		137,
		148,
		137,
		134,
		142,
		151,
		162,
		157,
		156,
		174,
		189,
		202,
		206,
		212,
		-1,
		191,
		-1,
		133,
		117,
		119,
		91,
		112,
		-1,
		149,
		144,
		164,
		162,
		153,
		-1,
		156,
		159,
		166,
		144,
		129,
		146,
		138,
		136,
		141,
		146,
		160,
		151,
		169,
		176,
		184,
		188,
		208,
		220,
		151,
		141,
		-1,
		123,
		128,
		87,
		95,
		114,
		187,
		159,
		-1,
		154,
		-1,
		146,
		171,
		-1,
		150,
		146,
		128,
		129,
		124,
		139,
		145,
		142,
		139,
		157,
		160,
		177,
		181,
		197,
		-1,
		-1,
		136,
		140,
		129,
		80,
		99,
		123,
		160,
		152,
		141,
		140,
		-1,
		131,
		161,
		158,
		144,
		131,
		121,
		122,
		130,
		143,
		122,
		141,
		144,
		166,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		106,
		77,
		101,
		143,
		170,
		163,
		151,
		116,
		116,
		110,
		-1,
		151,
		134,
		130,
		119,
		117,
		130,
		125,
		141,
		145,
		144,
		163,
		175,
		166,
		186,
		-1,
		-1,
		-1,
		136,
		125,
		126,
		72,
		95,
		132,
		149,
		135,
		140,
		115,
		108,
		102,
		154,
		151,
		118,
		126,
		118,
		107,
		121,
		129,
		133,
		142,
		151,
		157,
		181,
		181,
		187,
		-1,
		-1,
		143,
		133,
		117,
		119,
		116,
		86,
		93,
		125,
		140,
		137,
		-1,
		107,
		-1,
		96,
		104,
		103,
		109,
		121,
		107,
		112,
		123,
		135,
		148,
		144,
		151,
		186,
		186,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		136,
		131,
		106,
		83,
		67,
		103,
		-1,
		107,
		108,
		-1,
		101,
		95,
		101,
		100,
		107,
		104,
		104,
		118,
		126,
		122,
		138,
		144,
		136,
		172,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		129,
		108,
		101,
		121,
		62,
		114,
		-1,
		-1,
		92,
		85,
		-1,
		88,
		88,
		95,
		104,
		109,
		114,
		122,
		117,
		130,
		135,
		141,
		146,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		82,
		-1,
		100,
		92,
		83,
		77,
		83,
		101,
		99,
		119,
		111,
		125,
		125,
		131,
		139,
		124,
		127,
		143,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		149,
		135,
		106,
		-1,
		-1,
		95,
		-1,
		59,
		78,
		94,
		-1,
		117,
		96,
		119,
		97,
		111,
		107,
		145,
		146,
		124,
		129,
		137,
		147,
		149,
		138,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		155,
		142,
		100,
		96,
		85,
		105,
		56,
		65,
		81,
		-1,
		-1,
		161,
		-1,
		95,
		112,
		121,
		119,
		135,
		126,
		132,
		148,
		151,
		153,
		143,
		132,
		138,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		71,
		58,
		52,
		-1,
		98,
		-1,
		139,
		129,
		113,
		98,
		131,
		-1,
		143,
		127,
		132,
		-1,
		178,
		-1,
		151,
		153,
		147,
		132,
		129,
		140,
		138,
		149,
		166,
		-1,
		105,
		90,
		83,
		73,
		87,
		55,
		-1,
		89,
		-1,
		-1,
		126,
		120,
		120,
		104,
		107,
		159,
		139,
		133,
		132,
		173,
		173,
		159,
		145,
		138,
		135,
		132,
		145,
		165,
		156,
		168,
		-1,
		-1,
		-1,
		110,
		85,
		79,
		51,
		55,
		-1,
		-1,
		188,
		143,
		129,
		-1,
		113,
		176,
		164,
		154,
		144,
		178,
		179,
		164,
		157,
		143,
		145,
		143,
		141,
		146,
		167,
		168,
		181,
		-1,
		-1,
		84,
		77,
		65,
		33,
		28,
		-1,
		-1,
		-1,
		135,
		151,
		142,
		114,
		165,
		-1,
		-1,
		156,
		154,
		164,
		160,
		147,
		167,
		170,
		156,
		140,
		155,
		167,
		175,
		180,
		-1,
		87,
		74,
		-1,
		-1,
		27,
		17,
		-1,
		-1,
		-1,
		-1,
		132,
		113,
		125,
		146,
		171,
		159,
		-1,
		164,
		165,
		151,
		165,
		172,
		158,
		153,
		147,
		150,
		168,
		185,
		-1,
		-1,
		41,
		-1,
		0,
		-1,
		-1,
		-1,
		-1,
		104,
		119,
		139,
		145,
		157,
		-1,
		164,
		163,
		153,
		170,
		171,
		168,
		159,
		151,
		156,
		153,
		166,
		180,
		184,
		64,
		-1,
		11,
		-1,
		-1,
		-1,
		81,
		111,
		199,
		176,
		149,
		152,
		149,
		155,
		159,
		171,
		179,
		190,
		156,
		154,
		155,
		159,
		158,
		175,
		185,
		-1,
		-1,
		11,
		29,
		64,
		76,
		108,
		226,
		-1,
		-1,
		148,
		141,
		151,
		151,
		164,
		167,
		152,
		154,
		166,
		171,
		159,
		168,
		186,
		190,
		-1,
		-1,
		-1,
		34,
		-1,
		47,
		-1,
		-1,
		123,
		221,
		168,
		150,
		146,
		132,
		146,
		140,
		142,
		147,
		166,
		161,
		170,
		161,
		172,
		195,
		184,
		222,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		63,
		38,
		53,
		113,
		118,
		109,
		183,
		180,
		-1,
		128,
		169,
		137,
		151,
		147,
		154,
		159,
		165,
		162,
		169,
		185,
		184,
		179,
		214,
		206,
		212,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		69,
		55,
		99,
		89,
		95,
		-1,
		-1,
		142,
		139,
		142,
		129,
		135,
		140,
		143,
		181,
		157,
		158,
		162,
		166,
		172,
		177,
		182,
		188,
		203,
		218,
		-1,
		132,
		213,
		206,
		189,
		197,
		228,
		-1,
		72,
		86,
		62,
		81,
		89,
		-1,
		-1,
		115,
		111,
		116,
		125,
		128,
		164,
		163,
		176,
		172,
		178,
		165,
		164,
		182,
		186,
		195,
		202,
		192,
		205,
		209,
		-1,
		146,
		189,
		183,
		186,
		210,
		224,
		-1,
		85,
		-1,
		-1,
		84,
		102,
		110,
		106,
		110,
		163,
		139,
		134,
		147,
		149,
		173,
		164,
		182,
		173,
		173,
		176,
		191,
		196,
		188,
		202,
		202,
		203,
		-1,
		181,
		169,
		177,
		-1,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		100,
		-1,
		136,
		-1,
		129,
		133,
		147,
		150,
		172,
		159,
		166,
		180,
		189,
		171,
		181,
		177,
		178,
		187,
		198,
		210,
		209,
		210,
		209,
		165,
		168,
		168,
		190,
		205,
		209,
		-1,
		103,
		142,
		138,
		-1,
		109,
		-1,
		-1,
		-1,
		143,
		160,
		152,
		168,
		171,
		171,
		167,
		171,
		176,
		183,
		193,
		195,
		187,
		191,
		204,
		215,
		218,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		118,
		109,
		136,
		145,
		134,
		129,
		116,
		-1,
		-1,
		166,
		170,
		-1,
		-1,
		178,
		188,
		171,
		173,
		177,
		186,
		201,
		204,
		194,
		192,
		186,
		218,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		121,
		137,
		150,
		154,
		170,
		195,
		-1,
		119,
		-1,
		-1,
		187,
		-1,
		-1,
		230,
		193,
		182,
		173,
		179,
		185,
		196,
		212,
		200,
		201,
		191,
		201,
		214,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		136,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		135,
		126,
		-1,
		-1,
		206,
		213,
		215,
		-1,
		205,
		178,
		183,
		208,
		215,
		209,
		203,
		197,
		204,
		203,
		211,
		219,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		145,
		-1,
		-1,
		213,
		216,
		204,
		192,
		182,
		192,
		200,
		200,
		203,
		200,
		195,
		206,
		198,
		202,
		219,
		-1,
		225,
		-1,
		177,
		145,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		236,
		204,
		209,
		204,
		201,
		212,
		201,
		204,
		218,
		213,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		190,
		209,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		193,
		218,
		207,
		215,
		210,
		205,
		211,
		214,
		203,
		207,
		219,
		-1,
		-1,
		170,
		173,
		178,
		-1,
		199,
		-1,
		202,
		-1,
		147,
		163,
		165,
		-1,
		-1,
		-1,
		231,
		194,
		215,
		225,
		230,
		228,
		219,
		209,
		216,
		214,
		210,
		221,
		-1,
		-1,
		-1,
		228,
		202,
		209,
		200,
		183,
		163,
		155,
		180,
		-1,
		219,
		-1,
		194,
		195,
		222,
		224,
		241,
		235,
		212,
		227,
		217,
		208,
		217,
		234,
		-1,
		204,
		237,
		201,
		169,
		169,
		168,
		233,
		-1,
		216,
		198,
		-1,
		226,
		216,
		258,
		239,
		227,
		214,
		221,
		221,
		214,
		-1,
		-1,
		-1,
		206,
		205,
		197,
		191,
		189,
		174,
		169,
		-1,
		221,
		203,
		189,
		206,
		206,
		197,
		205,
		248,
		244,
		234,
		234,
		226,
		-1,
		297,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		200,
		209,
		182,
		170,
		184,
		191,
		186,
		188,
		201,
		209,
		207,
		204,
		216,
		212,
		232,
		227,
		260,
		-1,
		304,
		-1,
		236,
		-1,
		-1,
		216,
		202,
		204,
		193,
		182,
		180,
		183,
		181,
		203,
		233,
		219,
		217,
		222,
		227,
		-1,
		304,
		303,
		-1,
		235,
		227,
		213,
		-1,
		206,
		-1,
		228,
		189,
		-1,
		210,
		190,
		-1,
		228,
		224,
		-1,
		-1,
		291,
		251,
		-1,
		-1,
		-1,
		236,
		216,
		223,
		207,
		-1,
		201,
		201,
		-1,
		-1,
		-1,
		276,
		260,
		-1,
		229,
		232,
		-1,
		223,
		229,
		256,
		203,
		207,
		-1,
		-1,
		-1,
		285,
		266,
		260,
		244,
		249,
		237,
		254,
		240,
		239,
		217,
		206,
		227,
		-1,
		-1,
		-1,
		257,
		249,
		249,
		-1,
		-1,
		264,
		247,
		228,
		226,
		-1,
		-1,
		-1,
		279,
		260,
		-1,
		-1,
		254,
		-1,
		-1,
		260,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		268,
		-1,
		-1,
		-1,
		250,
		246,
		247,
		-1,
		-1,
		-1,
		-1,
		289,
		290,
		314,
		289,
		-1,
		-1,
		-1,
		242,
		236,
		-1,
		-1,
		292,
		290,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		240,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		275,
		-1,
		275,
		250,
		257,
		-1,
		-1,
		-1,
		-1,
		288,
		280,
		288,
		-1,
		260,
		262,
		-1,
		310,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		265,
		272,
		294,
		297,
		333,
		-1,
		284
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		204,
		193,
		204,
		212,
		185,
		192,
		-1,
		213,
		215,
		181,
		175,
		214,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		204,
		203,
		173,
		171,
		180,
		185,
		192,
		-1,
		196,
		-1,
		225,
		204,
		215,
		220,
		166,
		163,
		183,
		202,
		189,
		181,
		240,
		196,
		167,
		161,
		179,
		174,
		183,
		175,
		-1,
		167,
		157,
		179,
		163,
		174,
		166,
		-1,
		-1,
		161,
		162,
		168,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		151,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		140,
		158,
		167,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		153,
		-1,
		133,
		135,
		145,
		153,
		158,
		142,
		129,
		129,
		139,
		132,
		151,
		142,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		130,
		132,
		149,
		141,
		131,
		146,
		139,
		132,
		129,
		127,
		124,
		140,
		141,
		151,
		-1,
		-1,
		186,
		155,
		190,
		147,
		132,
		-1,
		126,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		118,
		117,
		148,
		134,
		145,
		146,
		-1,
		-1,
		144,
		136,
		121,
		124,
		121,
		121,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		112,
		122,
		126,
		137,
		152,
		-1,
		-1,
		207,
		-1,
		-1,
		143,
		126,
		-1,
		109,
		116,
		116,
		133,
		123,
		144,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		109,
		134,
		138,
		132,
		153,
		148,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		105,
		111,
		135,
		145,
		-1,
		135,
		141,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		116,
		118,
		151,
		129,
		151,
		148,
		177,
		182,
		176,
		185,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		139,
		-1,
		153,
		152,
		127,
		145,
		148,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		118,
		129,
		124,
		123,
		141,
		156,
		169,
		173,
		179,
		-1,
		201,
		-1,
		143,
		127,
		129,
		101,
		122,
		-1,
		159,
		154,
		144,
		129,
		120,
		-1,
		123,
		126,
		133,
		111,
		96,
		113,
		105,
		103,
		108,
		113,
		127,
		118,
		136,
		143,
		151,
		155,
		175,
		187,
		161,
		151,
		-1,
		133,
		138,
		97,
		105,
		124,
		162,
		126,
		-1,
		121,
		-1,
		113,
		138,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		112,
		109,
		106,
		124,
		127,
		144,
		148,
		164,
		-1,
		-1,
		146,
		150,
		139,
		90,
		109,
		133,
		170,
		119,
		108,
		107,
		-1,
		98,
		128,
		125,
		111,
		98,
		88,
		89,
		97,
		110,
		89,
		108,
		111,
		133,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		116,
		87,
		111,
		153,
		137,
		130,
		118,
		83,
		83,
		77,
		-1,
		118,
		101,
		97,
		86,
		84,
		97,
		92,
		108,
		112,
		111,
		130,
		142,
		133,
		153,
		-1,
		-1,
		-1,
		146,
		135,
		136,
		82,
		105,
		142,
		116,
		102,
		107,
		82,
		75,
		69,
		121,
		118,
		85,
		93,
		85,
		74,
		88,
		96,
		100,
		109,
		118,
		124,
		148,
		148,
		154,
		-1,
		-1,
		153,
		143,
		127,
		129,
		126,
		96,
		103,
		135,
		107,
		120,
		-1,
		74,
		-1,
		63,
		71,
		70,
		76,
		88,
		74,
		79,
		90,
		102,
		115,
		111,
		118,
		153,
		153,
		138,
		158,
		161,
		-1,
		-1,
		-1,
		146,
		141,
		116,
		93,
		77,
		113,
		-1,
		90,
		91,
		-1,
		68,
		62,
		68,
		67,
		74,
		71,
		71,
		85,
		93,
		89,
		105,
		111,
		103,
		139,
		-1,
		146,
		140,
		148,
		138,
		126,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		72,
		124,
		-1,
		-1,
		75,
		68,
		-1,
		55,
		55,
		62,
		71,
		76,
		81,
		89,
		84,
		97,
		102,
		108,
		113,
		131,
		135,
		139,
		128,
		124,
		121,
		135,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		92,
		-1,
		84,
		76,
		66,
		60,
		54,
		65,
		66,
		86,
		78,
		92,
		92,
		98,
		106,
		91,
		94,
		110,
		108,
		126,
		134,
		126,
		120,
		119,
		131,
		-1,
		159,
		145,
		116,
		-1,
		-1,
		105,
		-1,
		69,
		83,
		99,
		-1,
		92,
		71,
		86,
		64,
		68,
		74,
		112,
		113,
		91,
		96,
		104,
		114,
		116,
		105,
		116,
		108,
		130,
		130,
		114,
		115,
		124,
		-1,
		165,
		152,
		110,
		106,
		95,
		115,
		66,
		54,
		86,
		-1,
		-1,
		92,
		-1,
		46,
		48,
		88,
		86,
		102,
		93,
		99,
		115,
		115,
		110,
		110,
		99,
		105,
		102,
		124,
		110,
		108,
		127,
		143,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		68,
		62,
		-1,
		103,
		-1,
		70,
		58,
		45,
		27,
		67,
		-1,
		110,
		94,
		99,
		-1,
		135,
		-1,
		107,
		110,
		101,
		98,
		96,
		107,
		105,
		116,
		133,
		-1,
		115,
		100,
		93,
		83,
		97,
		68,
		-1,
		123,
		-1,
		-1,
		57,
		51,
		51,
		20,
		17,
		126,
		106,
		100,
		99,
		118,
		105,
		104,
		92,
		92,
		95,
		99,
		112,
		132,
		123,
		135,
		-1,
		-1,
		-1,
		120,
		106,
		110,
		70,
		89,
		-1,
		-1,
		118,
		74,
		60,
		-1,
		12,
		100,
		90,
		99,
		100,
		105,
		106,
		96,
		94,
		90,
		99,
		103,
		108,
		113,
		134,
		130,
		148,
		-1,
		-1,
		103,
		108,
		96,
		82,
		101,
		-1,
		-1,
		-1,
		64,
		65,
		39,
		10,
		88,
		-1,
		-1,
		104,
		97,
		91,
		94,
		82,
		102,
		109,
		123,
		107,
		122,
		134,
		142,
		142,
		-1,
		106,
		93,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		-1,
		-1,
		43,
		9,
		21,
		42,
		67,
		103,
		-1,
		77,
		88,
		81,
		100,
		107,
		125,
		110,
		104,
		115,
		130,
		147,
		-1,
		-1,
		118,
		-1,
		101,
		-1,
		-1,
		-1,
		-1,
		0,
		15,
		35,
		41,
		53,
		-1,
		79,
		81,
		78,
		90,
		101,
		106,
		114,
		98,
		112,
		115,
		128,
		142,
		146,
		141,
		-1,
		91,
		-1,
		-1,
		-1,
		18,
		33,
		95,
		72,
		45,
		50,
		60,
		65,
		70,
		90,
		96,
		107,
		92,
		96,
		111,
		121,
		120,
		137,
		147,
		-1,
		-1,
		89,
		79,
		44,
		26,
		30,
		122,
		-1,
		-1,
		60,
		66,
		62,
		72,
		80,
		83,
		88,
		90,
		108,
		127,
		115,
		130,
		145,
		141,
		-1,
		-1,
		-1,
		105,
		-1,
		77,
		-1,
		-1,
		45,
		146,
		93,
		75,
		71,
		69,
		74,
		83,
		78,
		83,
		108,
		103,
		112,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		134,
		96,
		111,
		130,
		65,
		72,
		108,
		105,
		-1,
		75,
		112,
		84,
		91,
		83,
		96,
		101,
		107,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		134,
		113,
		116,
		106,
		82,
		-1,
		-1,
		124,
		121,
		99,
		93,
		97,
		90,
		85,
		123,
		99,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		151,
		232,
		225,
		207,
		215,
		246,
		-1,
		124,
		116,
		120,
		102,
		93,
		-1,
		-1,
		97,
		94,
		99,
		100,
		97,
		109,
		108,
		119,
		121,
		126,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		165,
		208,
		201,
		204,
		228,
		242,
		-1,
		121,
		-1,
		-1,
		133,
		106,
		112,
		102,
		96,
		146,
		114,
		109,
		111,
		113,
		117,
		108,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		191,
		188,
		195,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		139,
		-1,
		114,
		118,
		122,
		125,
		136,
		123,
		121,
		129,
		137,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		216,
		172,
		175,
		186,
		197,
		212,
		216,
		-1,
		133,
		172,
		187,
		-1,
		158,
		-1,
		-1,
		-1,
		128,
		135,
		127,
		143,
		135,
		135,
		115,
		119,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		212,
		203,
		216,
		161,
		161,
		182,
		191,
		212,
		148,
		139,
		166,
		194,
		183,
		178,
		165,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		142,
		136,
		119,
		121,
		125,
		135,
		150,
		153,
		143,
		141,
		135,
		167,
		-1,
		205,
		204,
		193,
		190,
		166,
		157,
		152,
		179,
		-1,
		-1,
		151,
		167,
		180,
		184,
		200,
		225,
		-1,
		168,
		-1,
		-1,
		172,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		133,
		144,
		161,
		149,
		150,
		140,
		150,
		163,
		189,
		186,
		174,
		172,
		195,
		160,
		148,
		-1,
		161,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		184,
		175,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		126,
		131,
		156,
		163,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		198,
		212,
		201,
		197,
		196,
		204,
		153,
		146,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		194,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		148,
		148,
		151,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		232,
		-1,
		184,
		160,
		174,
		189,
		197,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		172,
		175,
		-1,
		-1,
		197,
		216,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		179,
		180,
		185,
		-1,
		201,
		-1,
		219,
		-1,
		186,
		192,
		180,
		-1,
		-1,
		-1,
		179,
		142,
		159,
		173,
		178,
		176,
		167,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		219,
		193,
		226,
		217,
		200,
		180,
		172,
		191,
		-1,
		161,
		-1,
		136,
		139,
		164,
		172,
		189,
		183,
		161,
		176,
		166,
		157,
		166,
		225,
		-1,
		195,
		228,
		192,
		186,
		162,
		166,
		182,
		-1,
		158,
		140,
		-1,
		168,
		158,
		206,
		181,
		176,
		163,
		170,
		170,
		163,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		182,
		167,
		158,
		-1,
		170,
		152,
		131,
		148,
		148,
		139,
		147,
		196,
		192,
		183,
		183,
		171,
		-1,
		298,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		186,
		159,
		147,
		153,
		149,
		135,
		141,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		170,
		202,
		-1,
		293,
		-1,
		227,
		-1,
		-1,
		209,
		189,
		181,
		170,
		159,
		157,
		148,
		139,
		161,
		177,
		161,
		159,
		164,
		169,
		-1,
		282,
		281,
		-1,
		228,
		220,
		206,
		-1,
		199,
		-1,
		205,
		166,
		-1,
		168,
		148,
		-1,
		170,
		166,
		-1,
		-1,
		269,
		244,
		-1,
		-1,
		-1,
		229,
		209,
		200,
		184,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		254,
		253,
		-1,
		222,
		225,
		-1,
		215,
		206,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		263,
		244,
		238,
		237,
		235,
		230,
		227,
		213,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		235,
		227,
		220,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		257,
		238,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		246,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		292,
		256,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		220,
		209,
		220,
		228,
		201,
		208,
		-1,
		229,
		231,
		197,
		191,
		230,
		201,
		207,
		218,
		-1,
		-1,
		-1,
		220,
		219,
		189,
		187,
		196,
		201,
		208,
		-1,
		212,
		-1,
		241,
		220,
		231,
		236,
		182,
		179,
		199,
		218,
		205,
		197,
		256,
		212,
		183,
		177,
		195,
		190,
		199,
		191,
		-1,
		183,
		173,
		195,
		179,
		190,
		182,
		-1,
		-1,
		177,
		178,
		184,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		167,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		156,
		174,
		183,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		169,
		-1,
		149,
		151,
		161,
		169,
		174,
		158,
		145,
		145,
		155,
		148,
		167,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		146,
		148,
		165,
		157,
		147,
		162,
		155,
		148,
		145,
		143,
		140,
		156,
		157,
		167,
		-1,
		-1,
		202,
		171,
		206,
		163,
		148,
		-1,
		142,
		141,
		147,
		151,
		145,
		138,
		152,
		148,
		-1,
		134,
		133,
		164,
		150,
		161,
		162,
		-1,
		-1,
		160,
		152,
		137,
		140,
		137,
		137,
		156,
		155,
		147,
		133,
		129,
		135,
		138,
		138,
		144,
		128,
		138,
		142,
		153,
		168,
		-1,
		-1,
		223,
		-1,
		-1,
		159,
		142,
		-1,
		125,
		132,
		132,
		149,
		139,
		160,
		166,
		157,
		149,
		143,
		131,
		133,
		130,
		143,
		131,
		125,
		150,
		154,
		148,
		169,
		164,
		-1,
		222,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		118,
		121,
		127,
		151,
		161,
		-1,
		151,
		157,
		167,
		152,
		149,
		136,
		124,
		137,
		122,
		129,
		128,
		132,
		134,
		167,
		145,
		167,
		164,
		193,
		198,
		192,
		201,
		-1,
		167,
		163,
		159,
		166,
		115,
		-1,
		-1,
		155,
		-1,
		169,
		168,
		143,
		161,
		164,
		153,
		144,
		131,
		120,
		131,
		120,
		117,
		125,
		134,
		145,
		140,
		139,
		157,
		172,
		185,
		189,
		195,
		-1,
		217,
		-1,
		159,
		143,
		145,
		117,
		138,
		-1,
		175,
		170,
		160,
		145,
		136,
		-1,
		139,
		142,
		149,
		127,
		112,
		129,
		121,
		119,
		124,
		129,
		143,
		134,
		152,
		159,
		167,
		171,
		191,
		203,
		177,
		167,
		-1,
		149,
		154,
		113,
		121,
		140,
		178,
		142,
		-1,
		137,
		-1,
		129,
		154,
		-1,
		133,
		129,
		111,
		112,
		107,
		122,
		128,
		125,
		122,
		140,
		143,
		160,
		164,
		180,
		-1,
		-1,
		162,
		166,
		155,
		106,
		125,
		149,
		186,
		135,
		124,
		123,
		-1,
		114,
		144,
		141,
		127,
		114,
		104,
		105,
		113,
		126,
		105,
		124,
		127,
		149,
		177,
		155,
		167,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		132,
		103,
		127,
		169,
		153,
		146,
		134,
		99,
		99,
		93,
		-1,
		134,
		117,
		113,
		102,
		100,
		113,
		108,
		124,
		128,
		127,
		146,
		158,
		149,
		161,
		-1,
		-1,
		-1,
		162,
		151,
		152,
		98,
		121,
		158,
		132,
		118,
		123,
		98,
		91,
		85,
		137,
		134,
		101,
		109,
		101,
		90,
		104,
		112,
		116,
		125,
		134,
		140,
		164,
		149,
		155,
		-1,
		-1,
		169,
		159,
		143,
		145,
		142,
		112,
		119,
		151,
		123,
		136,
		-1,
		90,
		-1,
		79,
		87,
		86,
		92,
		104,
		90,
		95,
		106,
		118,
		131,
		127,
		134,
		169,
		169,
		139,
		159,
		162,
		-1,
		-1,
		-1,
		162,
		157,
		132,
		109,
		93,
		129,
		-1,
		106,
		107,
		-1,
		84,
		78,
		84,
		83,
		90,
		87,
		87,
		101,
		109,
		105,
		121,
		127,
		119,
		144,
		-1,
		147,
		141,
		149,
		139,
		127,
		-1,
		-1,
		-1,
		155,
		134,
		127,
		147,
		88,
		140,
		-1,
		-1,
		91,
		84,
		-1,
		71,
		71,
		78,
		87,
		92,
		97,
		105,
		100,
		113,
		118,
		124,
		119,
		132,
		136,
		140,
		129,
		125,
		122,
		136,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		108,
		-1,
		100,
		92,
		82,
		76,
		70,
		81,
		82,
		102,
		94,
		108,
		108,
		114,
		122,
		107,
		110,
		124,
		109,
		127,
		135,
		127,
		121,
		120,
		132,
		-1,
		175,
		161,
		132,
		-1,
		-1,
		121,
		-1,
		85,
		99,
		115,
		-1,
		108,
		87,
		102,
		80,
		84,
		90,
		128,
		129,
		107,
		112,
		120,
		117,
		120,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		125,
		-1,
		181,
		168,
		126,
		122,
		111,
		131,
		82,
		70,
		102,
		-1,
		-1,
		108,
		-1,
		62,
		64,
		104,
		102,
		118,
		109,
		115,
		131,
		114,
		109,
		119,
		108,
		105,
		103,
		125,
		111,
		109,
		128,
		144,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		97,
		84,
		78,
		-1,
		119,
		-1,
		86,
		74,
		61,
		43,
		83,
		-1,
		115,
		110,
		115,
		-1,
		134,
		-1,
		106,
		109,
		100,
		97,
		97,
		108,
		106,
		117,
		134,
		-1,
		131,
		116,
		109,
		99,
		113,
		84,
		-1,
		139,
		-1,
		-1,
		73,
		67,
		67,
		36,
		33,
		131,
		111,
		103,
		115,
		117,
		104,
		103,
		91,
		91,
		94,
		100,
		113,
		133,
		124,
		135,
		-1,
		-1,
		-1,
		136,
		122,
		126,
		86,
		105,
		-1,
		-1,
		134,
		90,
		76,
		-1,
		28,
		99,
		89,
		98,
		99,
		104,
		105,
		95,
		93,
		89,
		98,
		102,
		109,
		114,
		135,
		129,
		149,
		-1,
		-1,
		119,
		124,
		112,
		98,
		117,
		-1,
		-1,
		-1,
		80,
		85,
		46,
		26,
		87,
		-1,
		-1,
		103,
		96,
		90,
		93,
		81,
		101,
		108,
		122,
		108,
		123,
		134,
		142,
		141,
		-1,
		122,
		109,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		-1,
		-1,
		63,
		8,
		20,
		41,
		66,
		102,
		-1,
		76,
		87,
		80,
		99,
		106,
		124,
		109,
		103,
		114,
		129,
		146,
		-1,
		-1,
		134,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		20,
		0,
		34,
		40,
		52,
		-1,
		78,
		80,
		77,
		89,
		100,
		105,
		113,
		97,
		111,
		114,
		127,
		141,
		145,
		157,
		-1,
		111,
		-1,
		-1,
		-1,
		38,
		53,
		94,
		71,
		44,
		49,
		59,
		64,
		69,
		89,
		95,
		106,
		91,
		95,
		110,
		120,
		119,
		136,
		146,
		-1,
		-1,
		109,
		99,
		64,
		46,
		50,
		121,
		-1,
		-1,
		59,
		65,
		61,
		71,
		79,
		82,
		87,
		89,
		107,
		126,
		114,
		129,
		144,
		140,
		-1,
		-1,
		-1,
		125,
		-1,
		97,
		-1,
		-1,
		65,
		145,
		92,
		74,
		70,
		68,
		73,
		82,
		77,
		82,
		107,
		102,
		111,
		116,
		120,
		143,
		132,
		171,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		154,
		116,
		131,
		150,
		85,
		92,
		107,
		104,
		-1,
		74,
		111,
		83,
		90,
		82,
		95,
		100,
		106,
		110,
		117,
		133,
		132,
		127,
		163,
		154,
		160,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		154,
		133,
		136,
		126,
		102,
		-1,
		-1,
		123,
		120,
		98,
		92,
		96,
		89,
		84,
		122,
		98,
		106,
		110,
		114,
		120,
		125,
		130,
		136,
		151,
		166,
		-1,
		167,
		245,
		238,
		206,
		214,
		245,
		-1,
		144,
		136,
		140,
		122,
		113,
		-1,
		-1,
		96,
		93,
		98,
		99,
		96,
		108,
		107,
		118,
		120,
		125,
		113,
		112,
		130,
		134,
		143,
		150,
		140,
		153,
		157,
		-1,
		181,
		221,
		200,
		203,
		227,
		241,
		-1,
		141,
		-1,
		-1,
		153,
		126,
		111,
		101,
		95,
		145,
		113,
		108,
		110,
		112,
		116,
		107,
		130,
		121,
		121,
		124,
		139,
		144,
		136,
		150,
		150,
		151,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		169,
		-1,
		138,
		-1,
		113,
		117,
		121,
		124,
		135,
		122,
		120,
		128,
		136,
		119,
		129,
		125,
		126,
		135,
		146,
		158,
		157,
		158,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		153,
		192,
		207,
		-1,
		178,
		-1,
		-1,
		-1,
		127,
		134,
		126,
		142,
		134,
		134,
		114,
		118,
		124,
		131,
		141,
		143,
		135,
		139,
		152,
		163,
		166,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		168,
		159,
		186,
		214,
		203,
		198,
		185,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		141,
		135,
		118,
		120,
		124,
		134,
		149,
		152,
		142,
		140,
		134,
		166,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		171,
		187,
		184,
		188,
		204,
		229,
		-1,
		188,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		132,
		143,
		160,
		148,
		149,
		139,
		149,
		162,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		188,
		218,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		125,
		130,
		155,
		162,
		157,
		151,
		145,
		152,
		151,
		159,
		167,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		208,
		204,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		147,
		147,
		150,
		148,
		143,
		154,
		146,
		150,
		167,
		-1,
		231,
		-1,
		183,
		159,
		173,
		188,
		196,
		-1,
		-1,
		-1,
		225,
		211,
		204,
		192,
		190,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		149,
		160,
		149,
		152,
		166,
		161,
		-1,
		-1,
		171,
		174,
		-1,
		-1,
		196,
		215,
		-1,
		216,
		205,
		190,
		182,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		153,
		159,
		162,
		151,
		155,
		167,
		-1,
		-1,
		178,
		179,
		184,
		-1,
		200,
		-1,
		218,
		-1,
		185,
		191,
		179,
		-1,
		-1,
		-1,
		178,
		141,
		158,
		172,
		177,
		175,
		166,
		157,
		164,
		162,
		158,
		169,
		-1,
		-1,
		-1,
		218,
		192,
		225,
		216,
		199,
		179,
		171,
		190,
		-1,
		160,
		-1,
		135,
		138,
		163,
		171,
		188,
		182,
		160,
		175,
		165,
		156,
		165,
		224,
		-1,
		194,
		227,
		191,
		185,
		161,
		165,
		181,
		-1,
		157,
		139,
		-1,
		167,
		157,
		205,
		180,
		175,
		162,
		169,
		169,
		162,
		-1,
		-1,
		-1,
		196,
		195,
		187,
		181,
		181,
		166,
		157,
		-1,
		169,
		151,
		130,
		147,
		147,
		138,
		146,
		195,
		191,
		182,
		182,
		170,
		-1,
		297,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		190,
		185,
		158,
		146,
		152,
		148,
		134,
		140,
		142,
		150,
		148,
		145,
		157,
		153,
		173,
		169,
		201,
		-1,
		292,
		-1,
		226,
		-1,
		-1,
		208,
		188,
		180,
		169,
		158,
		156,
		147,
		138,
		160,
		176,
		160,
		158,
		163,
		168,
		-1,
		281,
		280,
		-1,
		227,
		219,
		205,
		-1,
		198,
		-1,
		204,
		165,
		-1,
		167,
		147,
		-1,
		169,
		165,
		-1,
		-1,
		268,
		243,
		-1,
		-1,
		-1,
		228,
		208,
		199,
		183,
		-1,
		158,
		158,
		-1,
		-1,
		-1,
		253,
		252,
		-1,
		221,
		224,
		-1,
		214,
		205,
		213,
		160,
		164,
		-1,
		-1,
		-1,
		262,
		243,
		237,
		236,
		234,
		229,
		226,
		212,
		196,
		174,
		163,
		184,
		-1,
		-1,
		-1,
		234,
		226,
		219,
		-1,
		-1,
		221,
		204,
		185,
		183,
		-1,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		211,
		-1,
		-1,
		217,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		245,
		-1,
		-1,
		-1,
		207,
		203,
		204,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		291,
		255,
		-1,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		270,
		268,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		197,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		232,
		-1,
		232,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		245,
		237,
		245,
		-1,
		217,
		219,
		-1,
		267,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		222,
		229,
		251,
		254,
		290,
		-1,
		241
	],
	[
		-1,
		217,
		206,
		217,
		225,
		198,
		205,
		-1,
		224,
		228,
		194,
		188,
		227,
		196,
		202,
		213,
		-1,
		-1,
		-1,
		217,
		216,
		184,
		182,
		191,
		196,
		203,
		-1,
		202,
		-1,
		238,
		217,
		228,
		233,
		177,
		174,
		194,
		213,
		195,
		187,
		253,
		207,
		178,
		172,
		190,
		180,
		189,
		181,
		-1,
		178,
		168,
		190,
		169,
		180,
		172,
		-1,
		-1,
		172,
		173,
		179,
		165,
		171,
		167,
		-1,
		177,
		161,
		-1,
		-1,
		162,
		163,
		147,
		150,
		158,
		156,
		169,
		161,
		156,
		-1,
		-1,
		153,
		149,
		156,
		143,
		139,
		156,
		169,
		151,
		165,
		164,
		-1,
		159,
		177,
		182,
		150,
		148,
		132,
		130,
		148,
		150,
		156,
		156,
		-1,
		168,
		169,
		164,
		172,
		172,
		148,
		135,
		135,
		145,
		138,
		157,
		145,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		165,
		151,
		168,
		160,
		150,
		165,
		158,
		138,
		135,
		133,
		130,
		146,
		144,
		154,
		-1,
		-1,
		221,
		190,
		225,
		182,
		167,
		-1,
		161,
		144,
		150,
		154,
		148,
		141,
		155,
		151,
		-1,
		124,
		123,
		151,
		137,
		148,
		181,
		-1,
		-1,
		179,
		171,
		156,
		159,
		156,
		156,
		159,
		158,
		150,
		136,
		132,
		138,
		141,
		141,
		147,
		118,
		128,
		132,
		130,
		155,
		-1,
		-1,
		190,
		-1,
		-1,
		178,
		161,
		-1,
		144,
		151,
		151,
		168,
		158,
		179,
		169,
		160,
		152,
		146,
		134,
		136,
		133,
		146,
		134,
		115,
		140,
		144,
		125,
		146,
		141,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		137,
		140,
		146,
		170,
		180,
		-1,
		170,
		169,
		170,
		155,
		152,
		139,
		127,
		140,
		125,
		132,
		131,
		119,
		117,
		147,
		122,
		144,
		141,
		160,
		165,
		159,
		168,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		174,
		-1,
		188,
		187,
		162,
		166,
		169,
		156,
		147,
		134,
		123,
		134,
		123,
		120,
		128,
		111,
		126,
		117,
		116,
		134,
		144,
		152,
		156,
		162,
		-1,
		236,
		-1,
		178,
		162,
		164,
		136,
		157,
		-1,
		194,
		189,
		179,
		164,
		155,
		-1,
		158,
		161,
		152,
		130,
		115,
		132,
		124,
		122,
		124,
		106,
		120,
		111,
		129,
		136,
		134,
		138,
		158,
		170,
		196,
		186,
		-1,
		168,
		173,
		132,
		140,
		159,
		197,
		161,
		-1,
		156,
		-1,
		148,
		173,
		-1,
		136,
		132,
		114,
		115,
		110,
		125,
		117,
		102,
		99,
		117,
		120,
		127,
		131,
		147,
		-1,
		-1,
		181,
		185,
		174,
		125,
		144,
		168,
		205,
		154,
		143,
		142,
		-1,
		133,
		150,
		147,
		135,
		122,
		107,
		108,
		116,
		128,
		107,
		101,
		98,
		118,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		151,
		122,
		146,
		188,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		146,
		125,
		116,
		105,
		103,
		116,
		108,
		116,
		96,
		94,
		113,
		125,
		116,
		127,
		-1,
		-1,
		-1,
		181,
		170,
		171,
		117,
		140,
		177,
		151,
		137,
		142,
		117,
		110,
		104,
		156,
		142,
		120,
		112,
		104,
		93,
		104,
		112,
		110,
		92,
		101,
		107,
		131,
		115,
		121,
		-1,
		-1,
		188,
		178,
		162,
		164,
		161,
		131,
		138,
		170,
		142,
		155,
		-1,
		109,
		-1,
		98,
		106,
		105,
		111,
		109,
		96,
		95,
		109,
		109,
		99,
		94,
		101,
		136,
		136,
		105,
		125,
		128,
		-1,
		-1,
		-1,
		181,
		176,
		151,
		128,
		112,
		148,
		-1,
		125,
		126,
		-1,
		103,
		97,
		103,
		102,
		109,
		100,
		104,
		106,
		109,
		97,
		103,
		104,
		86,
		110,
		-1,
		113,
		107,
		115,
		105,
		93,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		90,
		97,
		104,
		98,
		105,
		100,
		91,
		104,
		97,
		91,
		85,
		98,
		102,
		106,
		95,
		91,
		88,
		102,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		100,
		101,
		121,
		110,
		113,
		108,
		105,
		95,
		86,
		79,
		90,
		75,
		93,
		101,
		93,
		87,
		86,
		98,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		103,
		109,
		117,
		118,
		88,
		93,
		95,
		83,
		86,
		80,
		83,
		75,
		97,
		97,
		81,
		82,
		91,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		127,
		-1,
		81,
		83,
		123,
		121,
		107,
		82,
		89,
		107,
		80,
		75,
		85,
		74,
		71,
		69,
		91,
		77,
		75,
		94,
		110,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		105,
		93,
		80,
		62,
		102,
		-1,
		81,
		77,
		84,
		-1,
		100,
		-1,
		72,
		75,
		66,
		63,
		63,
		74,
		72,
		83,
		100,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		92,
		86,
		86,
		55,
		52,
		97,
		77,
		69,
		84,
		83,
		70,
		69,
		57,
		57,
		60,
		66,
		79,
		99,
		90,
		101,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		153,
		109,
		95,
		-1,
		47,
		65,
		55,
		64,
		65,
		70,
		71,
		61,
		59,
		55,
		64,
		68,
		75,
		80,
		101,
		95,
		115,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		99,
		100,
		66,
		45,
		53,
		-1,
		-1,
		69,
		62,
		56,
		59,
		47,
		67,
		74,
		88,
		74,
		89,
		100,
		108,
		107,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		78,
		23,
		12,
		7,
		32,
		68,
		-1,
		42,
		53,
		46,
		65,
		72,
		90,
		75,
		69,
		80,
		95,
		112,
		-1,
		-1,
		153,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		35,
		29,
		0,
		6,
		18,
		-1,
		44,
		46,
		43,
		55,
		66,
		71,
		79,
		63,
		77,
		80,
		93,
		107,
		111,
		176,
		-1,
		126,
		-1,
		-1,
		-1,
		53,
		68,
		60,
		37,
		10,
		15,
		25,
		30,
		35,
		55,
		61,
		72,
		57,
		61,
		76,
		86,
		85,
		102,
		112,
		-1,
		-1,
		124,
		114,
		79,
		61,
		65,
		87,
		-1,
		-1,
		25,
		31,
		27,
		37,
		45,
		48,
		53,
		55,
		73,
		92,
		80,
		95,
		110,
		106,
		-1,
		-1,
		-1,
		140,
		-1,
		112,
		-1,
		-1,
		80,
		111,
		58,
		40,
		36,
		34,
		39,
		48,
		43,
		48,
		73,
		68,
		77,
		82,
		86,
		109,
		98,
		137,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		129,
		121,
		116,
		122,
		100,
		107,
		73,
		70,
		-1,
		40,
		77,
		49,
		56,
		48,
		61,
		66,
		72,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		220,
		209,
		198,
		204,
		-1,
		122,
		118,
		108,
		98,
		101,
		-1,
		-1,
		89,
		86,
		64,
		58,
		62,
		55,
		50,
		88,
		64,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		174,
		211,
		204,
		172,
		180,
		211,
		-1,
		112,
		104,
		115,
		90,
		92,
		-1,
		-1,
		62,
		59,
		64,
		65,
		62,
		74,
		73,
		84,
		86,
		91,
		79,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		167,
		187,
		166,
		169,
		193,
		207,
		-1,
		109,
		-1,
		-1,
		121,
		93,
		77,
		67,
		61,
		111,
		79,
		74,
		76,
		78,
		82,
		73,
		96,
		87,
		87,
		90,
		105,
		110,
		102,
		116,
		116,
		117,
		-1,
		156,
		167,
		160,
		-1,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		137,
		-1,
		104,
		-1,
		79,
		83,
		87,
		90,
		101,
		88,
		86,
		94,
		102,
		85,
		95,
		91,
		92,
		101,
		112,
		124,
		123,
		124,
		181,
		137,
		140,
		151,
		162,
		177,
		181,
		-1,
		121,
		160,
		175,
		-1,
		146,
		-1,
		-1,
		-1,
		93,
		100,
		92,
		108,
		100,
		100,
		80,
		84,
		90,
		97,
		107,
		109,
		101,
		105,
		118,
		129,
		132,
		177,
		168,
		181,
		126,
		126,
		147,
		156,
		177,
		136,
		127,
		154,
		180,
		171,
		166,
		153,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		107,
		101,
		84,
		86,
		90,
		100,
		115,
		118,
		108,
		106,
		100,
		132,
		-1,
		170,
		169,
		158,
		155,
		131,
		122,
		117,
		144,
		-1,
		-1,
		139,
		155,
		150,
		154,
		170,
		195,
		-1,
		156,
		-1,
		-1,
		137,
		-1,
		-1,
		143,
		106,
		95,
		86,
		92,
		98,
		109,
		126,
		114,
		115,
		105,
		115,
		128,
		154,
		151,
		139,
		137,
		160,
		125,
		113,
		-1,
		126,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		172,
		163,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		91,
		96,
		121,
		128,
		123,
		117,
		111,
		118,
		117,
		125,
		133,
		163,
		177,
		166,
		162,
		161,
		169,
		118,
		111,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		105,
		113,
		113,
		116,
		114,
		109,
		120,
		112,
		116,
		133,
		-1,
		197,
		-1,
		149,
		125,
		139,
		154,
		162,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		149,
		117,
		122,
		117,
		115,
		126,
		115,
		118,
		132,
		127,
		-1,
		-1,
		137,
		140,
		-1,
		-1,
		162,
		181,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		131,
		120,
		128,
		123,
		119,
		125,
		128,
		117,
		121,
		133,
		-1,
		-1,
		144,
		145,
		150,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		144,
		107,
		124,
		138,
		143,
		141,
		132,
		123,
		130,
		128,
		124,
		135,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		104,
		129,
		137,
		154,
		148,
		126,
		141,
		131,
		122,
		131,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		133,
		123,
		171,
		146,
		141,
		128,
		135,
		135,
		128,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		113,
		104,
		112,
		161,
		157,
		148,
		148,
		136,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		135,
		167,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		126,
		124,
		129,
		134,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		135,
		131,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		218,
		222,
		188,
		182,
		221,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		211,
		210,
		178,
		176,
		185,
		190,
		197,
		-1,
		196,
		-1,
		232,
		211,
		222,
		227,
		171,
		168,
		188,
		207,
		189,
		181,
		247,
		201,
		172,
		166,
		184,
		174,
		183,
		175,
		-1,
		172,
		162,
		184,
		163,
		174,
		166,
		-1,
		-1,
		166,
		167,
		173,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		156,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		153,
		171,
		176,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		150,
		-1,
		162,
		163,
		158,
		166,
		166,
		142,
		129,
		129,
		139,
		132,
		151,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		132,
		129,
		127,
		124,
		140,
		138,
		148,
		-1,
		-1,
		228,
		197,
		232,
		189,
		174,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		118,
		117,
		145,
		131,
		142,
		188,
		-1,
		-1,
		186,
		178,
		163,
		166,
		163,
		163,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		112,
		122,
		126,
		124,
		149,
		-1,
		-1,
		184,
		-1,
		-1,
		185,
		168,
		-1,
		151,
		158,
		158,
		175,
		165,
		186,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		109,
		134,
		138,
		119,
		140,
		135,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		144,
		147,
		153,
		177,
		187,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		113,
		111,
		141,
		116,
		138,
		135,
		154,
		159,
		153,
		162,
		-1,
		193,
		189,
		185,
		192,
		141,
		-1,
		-1,
		181,
		-1,
		195,
		194,
		169,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		105,
		120,
		111,
		110,
		128,
		138,
		146,
		150,
		156,
		-1,
		243,
		-1,
		185,
		169,
		171,
		143,
		164,
		-1,
		201,
		196,
		186,
		171,
		162,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		118,
		100,
		114,
		105,
		123,
		130,
		128,
		132,
		152,
		164,
		203,
		193,
		-1,
		175,
		180,
		139,
		147,
		166,
		204,
		168,
		-1,
		163,
		-1,
		155,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		111,
		96,
		93,
		111,
		114,
		121,
		125,
		141,
		-1,
		-1,
		188,
		192,
		181,
		132,
		151,
		175,
		212,
		161,
		150,
		149,
		-1,
		140,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		122,
		101,
		95,
		92,
		112,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		158,
		129,
		153,
		195,
		179,
		172,
		160,
		125,
		125,
		119,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		102,
		110,
		90,
		88,
		107,
		119,
		110,
		121,
		-1,
		-1,
		-1,
		188,
		177,
		178,
		124,
		147,
		184,
		158,
		144,
		149,
		124,
		117,
		111,
		153,
		136,
		117,
		106,
		98,
		87,
		98,
		106,
		104,
		86,
		95,
		101,
		125,
		109,
		115,
		-1,
		-1,
		195,
		185,
		169,
		171,
		168,
		138,
		145,
		177,
		149,
		162,
		-1,
		116,
		-1,
		105,
		113,
		111,
		106,
		103,
		90,
		89,
		103,
		103,
		93,
		88,
		95,
		130,
		130,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		188,
		183,
		158,
		135,
		119,
		155,
		-1,
		132,
		133,
		-1,
		110,
		104,
		110,
		109,
		109,
		94,
		98,
		100,
		103,
		91,
		97,
		98,
		80,
		104,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		181,
		160,
		153,
		173,
		114,
		166,
		-1,
		-1,
		117,
		110,
		-1,
		97,
		97,
		104,
		98,
		92,
		99,
		94,
		85,
		98,
		91,
		85,
		79,
		92,
		96,
		100,
		89,
		85,
		82,
		96,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		134,
		-1,
		126,
		118,
		108,
		102,
		96,
		107,
		108,
		120,
		104,
		107,
		102,
		99,
		89,
		80,
		73,
		84,
		69,
		87,
		95,
		87,
		81,
		80,
		92,
		-1,
		201,
		187,
		158,
		-1,
		-1,
		147,
		-1,
		111,
		125,
		141,
		-1,
		134,
		113,
		128,
		106,
		110,
		116,
		111,
		112,
		82,
		87,
		89,
		77,
		80,
		74,
		77,
		69,
		91,
		91,
		75,
		76,
		85,
		-1,
		207,
		194,
		152,
		148,
		137,
		157,
		108,
		96,
		128,
		-1,
		-1,
		134,
		-1,
		88,
		90,
		130,
		128,
		101,
		76,
		83,
		101,
		74,
		69,
		79,
		68,
		65,
		63,
		85,
		71,
		69,
		88,
		104,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		123,
		110,
		104,
		-1,
		145,
		-1,
		112,
		100,
		87,
		69,
		109,
		-1,
		75,
		71,
		78,
		-1,
		94,
		-1,
		66,
		69,
		60,
		57,
		57,
		68,
		66,
		77,
		94,
		-1,
		157,
		142,
		135,
		125,
		139,
		110,
		-1,
		165,
		-1,
		-1,
		99,
		93,
		93,
		62,
		59,
		91,
		71,
		63,
		78,
		77,
		64,
		63,
		51,
		51,
		54,
		60,
		73,
		93,
		84,
		95,
		-1,
		-1,
		-1,
		162,
		148,
		152,
		112,
		131,
		-1,
		-1,
		160,
		116,
		102,
		-1,
		54,
		72,
		62,
		69,
		59,
		64,
		65,
		55,
		53,
		49,
		58,
		62,
		69,
		74,
		95,
		89,
		109,
		-1,
		-1,
		145,
		150,
		138,
		124,
		143,
		-1,
		-1,
		-1,
		106,
		107,
		73,
		52,
		60,
		-1,
		-1,
		63,
		56,
		50,
		53,
		41,
		61,
		68,
		82,
		68,
		83,
		94,
		102,
		101,
		-1,
		148,
		135,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		-1,
		-1,
		85,
		30,
		19,
		14,
		26,
		62,
		-1,
		36,
		47,
		40,
		59,
		66,
		84,
		69,
		63,
		74,
		89,
		106,
		-1,
		-1,
		160,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		42,
		36,
		7,
		0,
		12,
		-1,
		38,
		40,
		37,
		49,
		60,
		65,
		73,
		57,
		71,
		74,
		87,
		101,
		105,
		183,
		-1,
		133,
		-1,
		-1,
		-1,
		60,
		75,
		54,
		31,
		4,
		9,
		19,
		24,
		29,
		49,
		55,
		66,
		51,
		55,
		70,
		80,
		79,
		96,
		106,
		-1,
		-1,
		131,
		121,
		86,
		68,
		72,
		81,
		-1,
		-1,
		19,
		25,
		21,
		31,
		39,
		42,
		47,
		49,
		67,
		86,
		74,
		89,
		104,
		100,
		-1,
		-1,
		-1,
		144,
		-1,
		119,
		-1,
		-1,
		87,
		105,
		52,
		34,
		30,
		28,
		33,
		42,
		37,
		42,
		67,
		62,
		71,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		123,
		115,
		110,
		116,
		107,
		109,
		67,
		64,
		-1,
		34,
		71,
		43,
		50,
		42,
		55,
		60,
		66,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		214,
		203,
		192,
		198,
		-1,
		116,
		112,
		102,
		92,
		95,
		-1,
		-1,
		83,
		80,
		58,
		52,
		56,
		49,
		44,
		82,
		58,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		168,
		205,
		198,
		166,
		174,
		205,
		-1,
		106,
		98,
		109,
		84,
		86,
		-1,
		-1,
		56,
		53,
		58,
		59,
		56,
		68,
		67,
		78,
		80,
		85,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		161,
		181,
		160,
		163,
		187,
		201,
		-1,
		103,
		-1,
		-1,
		115,
		87,
		71,
		61,
		55,
		105,
		73,
		68,
		70,
		72,
		76,
		67,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		150,
		161,
		154,
		-1,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		131,
		-1,
		98,
		-1,
		73,
		77,
		81,
		84,
		95,
		82,
		80,
		88,
		96,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		175,
		131,
		134,
		145,
		156,
		171,
		175,
		-1,
		115,
		154,
		169,
		-1,
		140,
		-1,
		-1,
		-1,
		87,
		94,
		86,
		102,
		94,
		94,
		74,
		78,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		171,
		162,
		175,
		120,
		120,
		141,
		150,
		171,
		130,
		121,
		148,
		174,
		165,
		160,
		147,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		101,
		95,
		78,
		80,
		84,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		164,
		163,
		152,
		149,
		125,
		116,
		111,
		138,
		-1,
		-1,
		133,
		149,
		144,
		148,
		164,
		189,
		-1,
		150,
		-1,
		-1,
		131,
		-1,
		-1,
		137,
		100,
		89,
		80,
		86,
		92,
		103,
		120,
		108,
		109,
		99,
		109,
		122,
		148,
		145,
		133,
		131,
		154,
		119,
		107,
		-1,
		120,
		118,
		124,
		131,
		148,
		178,
		-1,
		-1,
		166,
		157,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		90,
		115,
		122,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		157,
		171,
		160,
		156,
		155,
		163,
		112,
		105,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		164,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		99,
		107,
		107,
		110,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		191,
		-1,
		143,
		119,
		133,
		148,
		156,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		143,
		111,
		116,
		111,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		156,
		175,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		125,
		114,
		122,
		117,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		138,
		139,
		144,
		-1,
		160,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		138,
		101,
		118,
		132,
		137,
		135,
		126,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		98,
		123,
		131,
		148,
		142,
		120,
		135,
		125,
		116,
		125,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		117,
		165,
		140,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		155,
		151,
		142,
		142,
		130,
		-1,
		257,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		117,
		113,
		133,
		129,
		161,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		120,
		118,
		123,
		128,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		129,
		125,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		219,
		208,
		219,
		227,
		200,
		207,
		-1,
		226,
		230,
		196,
		190,
		229,
		198,
		204,
		215,
		-1,
		-1,
		-1,
		219,
		218,
		186,
		184,
		193,
		198,
		205,
		-1,
		204,
		-1,
		240,
		219,
		230,
		235,
		179,
		176,
		196,
		215,
		197,
		189,
		255,
		209,
		180,
		174,
		192,
		182,
		191,
		183,
		-1,
		180,
		170,
		192,
		171,
		182,
		174,
		-1,
		-1,
		174,
		175,
		181,
		167,
		173,
		169,
		-1,
		179,
		163,
		-1,
		-1,
		164,
		165,
		149,
		152,
		160,
		158,
		171,
		163,
		158,
		-1,
		-1,
		155,
		151,
		158,
		145,
		141,
		158,
		171,
		153,
		167,
		166,
		-1,
		161,
		179,
		184,
		152,
		150,
		134,
		132,
		150,
		152,
		158,
		158,
		-1,
		170,
		171,
		166,
		174,
		174,
		150,
		137,
		137,
		147,
		140,
		159,
		147,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		170,
		153,
		170,
		162,
		152,
		167,
		160,
		140,
		137,
		135,
		132,
		148,
		146,
		156,
		-1,
		-1,
		244,
		213,
		248,
		205,
		190,
		-1,
		166,
		146,
		152,
		156,
		150,
		143,
		157,
		153,
		-1,
		126,
		125,
		153,
		139,
		150,
		204,
		-1,
		-1,
		202,
		194,
		179,
		182,
		176,
		172,
		161,
		160,
		152,
		138,
		134,
		140,
		143,
		143,
		149,
		120,
		130,
		134,
		132,
		157,
		-1,
		-1,
		192,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		174,
		188,
		174,
		195,
		171,
		162,
		154,
		148,
		136,
		138,
		135,
		148,
		136,
		117,
		142,
		146,
		127,
		148,
		143,
		-1,
		191,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		203,
		-1,
		183,
		171,
		172,
		157,
		154,
		141,
		129,
		142,
		127,
		134,
		133,
		121,
		119,
		149,
		124,
		146,
		143,
		162,
		167,
		161,
		170,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		211,
		210,
		185,
		168,
		171,
		158,
		149,
		136,
		125,
		136,
		125,
		122,
		130,
		113,
		128,
		119,
		118,
		136,
		146,
		154,
		158,
		164,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		212,
		202,
		187,
		178,
		-1,
		167,
		164,
		154,
		132,
		117,
		134,
		126,
		124,
		126,
		108,
		122,
		113,
		131,
		138,
		136,
		140,
		160,
		172,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		220,
		184,
		-1,
		179,
		-1,
		169,
		182,
		-1,
		138,
		134,
		116,
		117,
		112,
		127,
		119,
		104,
		101,
		119,
		122,
		129,
		133,
		149,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		177,
		166,
		165,
		-1,
		156,
		152,
		149,
		137,
		124,
		109,
		110,
		118,
		130,
		109,
		103,
		100,
		120,
		146,
		124,
		136,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		195,
		188,
		176,
		141,
		141,
		135,
		-1,
		148,
		127,
		118,
		107,
		105,
		118,
		110,
		118,
		98,
		96,
		115,
		127,
		118,
		129,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		140,
		163,
		200,
		174,
		160,
		165,
		140,
		133,
		127,
		161,
		144,
		125,
		114,
		106,
		95,
		106,
		114,
		112,
		94,
		103,
		109,
		133,
		117,
		123,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		154,
		161,
		193,
		165,
		178,
		-1,
		132,
		-1,
		121,
		129,
		119,
		114,
		111,
		98,
		97,
		111,
		111,
		101,
		96,
		103,
		138,
		138,
		107,
		127,
		130,
		-1,
		-1,
		-1,
		204,
		199,
		174,
		151,
		135,
		171,
		-1,
		148,
		149,
		-1,
		126,
		120,
		126,
		121,
		117,
		102,
		106,
		108,
		111,
		99,
		105,
		106,
		88,
		112,
		-1,
		115,
		109,
		117,
		107,
		95,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		130,
		182,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		112,
		114,
		106,
		100,
		107,
		102,
		93,
		106,
		99,
		93,
		87,
		100,
		104,
		108,
		97,
		93,
		90,
		104,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		150,
		-1,
		142,
		134,
		124,
		118,
		112,
		123,
		123,
		128,
		112,
		115,
		110,
		107,
		97,
		88,
		81,
		92,
		77,
		95,
		103,
		95,
		89,
		88,
		100,
		-1,
		217,
		203,
		174,
		-1,
		-1,
		163,
		-1,
		127,
		141,
		157,
		-1,
		150,
		129,
		144,
		122,
		126,
		126,
		119,
		120,
		90,
		95,
		97,
		85,
		88,
		82,
		85,
		77,
		99,
		99,
		83,
		84,
		93,
		-1,
		223,
		210,
		168,
		164,
		153,
		173,
		124,
		112,
		144,
		-1,
		-1,
		150,
		-1,
		104,
		106,
		140,
		138,
		109,
		84,
		91,
		109,
		82,
		77,
		87,
		76,
		73,
		71,
		93,
		79,
		77,
		96,
		112,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		139,
		126,
		120,
		-1,
		161,
		-1,
		128,
		116,
		103,
		85,
		125,
		-1,
		83,
		79,
		86,
		-1,
		102,
		-1,
		74,
		77,
		68,
		65,
		65,
		76,
		74,
		85,
		102,
		-1,
		173,
		158,
		151,
		141,
		155,
		126,
		-1,
		181,
		-1,
		-1,
		115,
		109,
		109,
		78,
		75,
		99,
		79,
		71,
		86,
		85,
		72,
		71,
		59,
		59,
		62,
		68,
		81,
		101,
		92,
		103,
		-1,
		-1,
		-1,
		178,
		164,
		168,
		128,
		147,
		-1,
		-1,
		176,
		132,
		118,
		-1,
		70,
		88,
		78,
		77,
		67,
		72,
		73,
		63,
		61,
		57,
		66,
		70,
		77,
		82,
		103,
		97,
		117,
		-1,
		-1,
		161,
		166,
		154,
		140,
		159,
		-1,
		-1,
		-1,
		122,
		123,
		89,
		68,
		76,
		-1,
		-1,
		71,
		64,
		58,
		61,
		49,
		69,
		76,
		90,
		76,
		91,
		102,
		110,
		109,
		-1,
		164,
		151,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		-1,
		-1,
		101,
		46,
		35,
		30,
		14,
		70,
		-1,
		44,
		55,
		48,
		67,
		74,
		92,
		77,
		71,
		82,
		97,
		114,
		-1,
		-1,
		176,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		58,
		52,
		23,
		16,
		0,
		-1,
		46,
		48,
		45,
		57,
		68,
		73,
		81,
		65,
		79,
		82,
		95,
		109,
		113,
		199,
		-1,
		140,
		-1,
		-1,
		-1,
		76,
		91,
		58,
		35,
		12,
		17,
		27,
		32,
		37,
		57,
		63,
		74,
		59,
		63,
		78,
		88,
		87,
		104,
		114,
		-1,
		-1,
		138,
		134,
		102,
		84,
		88,
		85,
		-1,
		-1,
		23,
		33,
		29,
		39,
		47,
		50,
		55,
		57,
		75,
		94,
		82,
		97,
		112,
		108,
		-1,
		-1,
		-1,
		150,
		-1,
		135,
		-1,
		-1,
		103,
		113,
		60,
		42,
		38,
		34,
		41,
		50,
		45,
		50,
		75,
		70,
		79,
		84,
		88,
		111,
		100,
		139,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		129,
		121,
		116,
		122,
		123,
		115,
		75,
		72,
		-1,
		40,
		79,
		51,
		58,
		50,
		63,
		68,
		74,
		78,
		85,
		101,
		100,
		95,
		131,
		122,
		128,
		-1,
		-1,
		220,
		209,
		198,
		204,
		-1,
		122,
		118,
		108,
		98,
		101,
		-1,
		-1,
		89,
		86,
		64,
		60,
		64,
		57,
		52,
		90,
		66,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		174,
		211,
		204,
		172,
		180,
		211,
		-1,
		112,
		104,
		115,
		90,
		92,
		-1,
		-1,
		62,
		59,
		64,
		67,
		64,
		76,
		75,
		86,
		88,
		93,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		167,
		187,
		166,
		169,
		193,
		207,
		-1,
		109,
		-1,
		-1,
		121,
		93,
		77,
		67,
		61,
		111,
		81,
		76,
		78,
		80,
		84,
		75,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		156,
		167,
		160,
		-1,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		137,
		-1,
		104,
		-1,
		79,
		83,
		89,
		92,
		103,
		90,
		88,
		96,
		104,
		87,
		97,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		181,
		137,
		140,
		151,
		162,
		177,
		181,
		-1,
		121,
		160,
		175,
		-1,
		146,
		-1,
		-1,
		-1,
		93,
		102,
		94,
		110,
		102,
		102,
		82,
		86,
		92,
		99,
		109,
		111,
		103,
		107,
		120,
		131,
		134,
		177,
		168,
		181,
		126,
		126,
		147,
		156,
		177,
		136,
		127,
		154,
		180,
		171,
		166,
		153,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		109,
		103,
		86,
		88,
		92,
		102,
		117,
		120,
		110,
		108,
		102,
		134,
		-1,
		170,
		169,
		158,
		155,
		131,
		122,
		117,
		144,
		-1,
		-1,
		139,
		155,
		150,
		154,
		170,
		195,
		-1,
		156,
		-1,
		-1,
		137,
		-1,
		-1,
		145,
		108,
		97,
		88,
		94,
		100,
		111,
		128,
		116,
		117,
		107,
		117,
		130,
		154,
		151,
		139,
		137,
		160,
		125,
		113,
		-1,
		126,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		172,
		163,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		93,
		98,
		123,
		130,
		125,
		119,
		113,
		120,
		119,
		127,
		135,
		163,
		177,
		166,
		162,
		161,
		169,
		118,
		111,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		172,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		115,
		115,
		118,
		116,
		111,
		122,
		114,
		118,
		135,
		-1,
		197,
		-1,
		149,
		125,
		139,
		154,
		162,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		151,
		119,
		124,
		119,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		137,
		140,
		-1,
		-1,
		162,
		181,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		108,
		133,
		122,
		130,
		125,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		144,
		145,
		150,
		-1,
		168,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		146,
		109,
		126,
		140,
		145,
		143,
		134,
		125,
		132,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		186,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		103,
		106,
		131,
		139,
		156,
		150,
		128,
		143,
		133,
		124,
		133,
		192,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		173,
		148,
		143,
		130,
		137,
		137,
		130,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		163,
		159,
		150,
		150,
		138,
		-1,
		265,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		125,
		121,
		141,
		137,
		169,
		-1,
		260,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		128,
		126,
		131,
		136,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		137,
		133,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		201,
		190,
		201,
		209,
		182,
		189,
		-1,
		208,
		212,
		178,
		172,
		211,
		180,
		186,
		197,
		-1,
		-1,
		-1,
		201,
		200,
		168,
		166,
		175,
		180,
		187,
		-1,
		186,
		-1,
		222,
		201,
		212,
		217,
		161,
		158,
		178,
		197,
		179,
		171,
		237,
		191,
		162,
		156,
		174,
		164,
		173,
		165,
		-1,
		162,
		152,
		174,
		153,
		164,
		156,
		-1,
		-1,
		156,
		157,
		163,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		146,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		143,
		161,
		166,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		140,
		-1,
		152,
		153,
		148,
		156,
		156,
		132,
		119,
		119,
		129,
		122,
		141,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		122,
		119,
		117,
		114,
		130,
		128,
		138,
		-1,
		-1,
		231,
		200,
		235,
		192,
		177,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		108,
		107,
		135,
		121,
		132,
		191,
		-1,
		-1,
		189,
		181,
		166,
		169,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		102,
		112,
		116,
		114,
		139,
		-1,
		-1,
		174,
		-1,
		-1,
		188,
		171,
		-1,
		154,
		161,
		161,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		99,
		124,
		128,
		109,
		130,
		125,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		156,
		180,
		190,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		103,
		101,
		131,
		106,
		128,
		125,
		144,
		149,
		143,
		152,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		184,
		-1,
		198,
		197,
		172,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		95,
		110,
		101,
		100,
		118,
		128,
		136,
		140,
		146,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		204,
		199,
		189,
		174,
		165,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		108,
		90,
		104,
		95,
		113,
		120,
		118,
		122,
		142,
		154,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		207,
		171,
		-1,
		166,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		101,
		86,
		83,
		101,
		104,
		111,
		115,
		131,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		164,
		153,
		152,
		-1,
		143,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		112,
		91,
		85,
		82,
		102,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		92,
		100,
		80,
		78,
		97,
		109,
		100,
		111,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		161,
		147,
		152,
		127,
		120,
		114,
		140,
		126,
		104,
		96,
		88,
		77,
		88,
		96,
		94,
		76,
		85,
		91,
		115,
		99,
		105,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		152,
		165,
		-1,
		119,
		-1,
		108,
		99,
		97,
		90,
		93,
		74,
		79,
		93,
		93,
		83,
		78,
		85,
		120,
		120,
		89,
		109,
		112,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		135,
		136,
		-1,
		113,
		107,
		102,
		94,
		95,
		78,
		78,
		79,
		93,
		77,
		87,
		88,
		70,
		94,
		-1,
		97,
		91,
		99,
		89,
		77,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		120,
		113,
		-1,
		100,
		82,
		76,
		68,
		62,
		71,
		64,
		71,
		84,
		81,
		75,
		69,
		82,
		86,
		90,
		79,
		75,
		72,
		86,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		129,
		121,
		111,
		105,
		99,
		93,
		91,
		90,
		74,
		77,
		72,
		69,
		59,
		70,
		63,
		74,
		59,
		77,
		85,
		77,
		71,
		70,
		82,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		150,
		-1,
		114,
		128,
		144,
		-1,
		137,
		116,
		131,
		109,
		103,
		88,
		81,
		82,
		52,
		57,
		59,
		47,
		50,
		64,
		67,
		59,
		81,
		81,
		65,
		66,
		75,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		111,
		99,
		131,
		-1,
		-1,
		170,
		-1,
		107,
		124,
		102,
		100,
		71,
		46,
		53,
		71,
		44,
		39,
		62,
		58,
		55,
		53,
		75,
		61,
		59,
		78,
		94,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		148,
		136,
		123,
		105,
		143,
		-1,
		45,
		41,
		48,
		-1,
		64,
		-1,
		36,
		49,
		49,
		47,
		47,
		58,
		56,
		67,
		84,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		168,
		-1,
		-1,
		135,
		129,
		129,
		98,
		95,
		61,
		41,
		33,
		48,
		47,
		34,
		33,
		39,
		41,
		44,
		50,
		63,
		83,
		74,
		85,
		-1,
		-1,
		-1,
		165,
		151,
		155,
		115,
		134,
		-1,
		-1,
		196,
		152,
		138,
		-1,
		90,
		61,
		49,
		39,
		29,
		34,
		35,
		25,
		30,
		39,
		48,
		52,
		59,
		64,
		85,
		79,
		99,
		-1,
		-1,
		148,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		142,
		143,
		109,
		88,
		50,
		-1,
		-1,
		33,
		26,
		20,
		26,
		31,
		51,
		58,
		72,
		58,
		73,
		84,
		92,
		91,
		-1,
		151,
		138,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		121,
		66,
		55,
		50,
		54,
		32,
		-1,
		2,
		21,
		30,
		49,
		56,
		74,
		59,
		53,
		64,
		79,
		96,
		-1,
		-1,
		163,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		78,
		72,
		43,
		36,
		40,
		-1,
		0,
		29,
		27,
		39,
		50,
		55,
		63,
		47,
		61,
		64,
		77,
		91,
		95,
		186,
		-1,
		136,
		-1,
		-1,
		-1,
		96,
		111,
		82,
		59,
		32,
		27,
		20,
		14,
		19,
		39,
		45,
		56,
		41,
		45,
		60,
		70,
		69,
		86,
		96,
		-1,
		-1,
		134,
		130,
		122,
		104,
		108,
		109,
		-1,
		-1,
		36,
		27,
		18,
		21,
		29,
		32,
		37,
		39,
		57,
		76,
		64,
		79,
		94,
		90,
		-1,
		-1,
		-1,
		146,
		-1,
		148,
		-1,
		-1,
		123,
		107,
		54,
		36,
		32,
		30,
		23,
		32,
		27,
		32,
		57,
		52,
		61,
		66,
		70,
		93,
		82,
		121,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		125,
		117,
		112,
		118,
		120,
		111,
		69,
		66,
		-1,
		36,
		61,
		33,
		40,
		32,
		45,
		50,
		56,
		60,
		67,
		83,
		82,
		77,
		113,
		104,
		110,
		-1,
		-1,
		216,
		205,
		194,
		200,
		-1,
		118,
		114,
		104,
		94,
		97,
		-1,
		-1,
		85,
		82,
		58,
		42,
		46,
		39,
		34,
		72,
		48,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		116,
		-1,
		170,
		207,
		200,
		168,
		176,
		207,
		-1,
		108,
		100,
		111,
		86,
		88,
		-1,
		-1,
		58,
		55,
		60,
		49,
		46,
		58,
		57,
		68,
		70,
		75,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		163,
		183,
		162,
		165,
		189,
		203,
		-1,
		105,
		-1,
		-1,
		117,
		89,
		73,
		63,
		57,
		107,
		63,
		58,
		60,
		62,
		66,
		57,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		152,
		163,
		156,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		133,
		-1,
		100,
		-1,
		75,
		79,
		71,
		74,
		85,
		72,
		70,
		78,
		86,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		177,
		133,
		136,
		147,
		158,
		173,
		177,
		-1,
		117,
		156,
		171,
		-1,
		142,
		-1,
		-1,
		-1,
		89,
		84,
		76,
		92,
		84,
		84,
		64,
		68,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		173,
		164,
		177,
		122,
		122,
		143,
		152,
		173,
		132,
		123,
		150,
		176,
		167,
		162,
		149,
		-1,
		-1,
		112,
		94,
		-1,
		-1,
		91,
		85,
		68,
		70,
		74,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		166,
		165,
		154,
		151,
		127,
		118,
		113,
		140,
		-1,
		-1,
		135,
		151,
		146,
		150,
		166,
		191,
		-1,
		152,
		-1,
		-1,
		133,
		-1,
		-1,
		127,
		90,
		79,
		70,
		76,
		82,
		93,
		110,
		98,
		99,
		89,
		99,
		112,
		150,
		147,
		135,
		133,
		156,
		121,
		109,
		-1,
		122,
		120,
		126,
		133,
		150,
		180,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		125,
		123,
		112,
		-1,
		102,
		75,
		80,
		105,
		112,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		159,
		173,
		162,
		158,
		157,
		165,
		114,
		107,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		120,
		113,
		101,
		89,
		79,
		89,
		97,
		97,
		100,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		193,
		-1,
		145,
		121,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		154,
		138,
		119,
		-1,
		89,
		102,
		133,
		101,
		106,
		101,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		133,
		136,
		-1,
		-1,
		158,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		126,
		122,
		-1,
		-1,
		90,
		115,
		104,
		112,
		107,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		140,
		141,
		146,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		128,
		91,
		108,
		122,
		127,
		125,
		116,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		88,
		113,
		121,
		138,
		132,
		110,
		125,
		115,
		106,
		115,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		107,
		155,
		130,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		96,
		145,
		141,
		132,
		132,
		120,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		110,
		108,
		113,
		118,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		119,
		115,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		189,
		178,
		189,
		197,
		170,
		177,
		-1,
		196,
		200,
		166,
		160,
		199,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		189,
		188,
		156,
		154,
		163,
		168,
		175,
		-1,
		174,
		-1,
		210,
		189,
		200,
		205,
		149,
		146,
		166,
		185,
		167,
		159,
		225,
		179,
		150,
		144,
		162,
		152,
		161,
		153,
		-1,
		150,
		140,
		162,
		141,
		152,
		144,
		-1,
		-1,
		144,
		145,
		151,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		134,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		131,
		149,
		154,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		128,
		-1,
		140,
		141,
		136,
		144,
		144,
		120,
		107,
		107,
		117,
		110,
		129,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		123,
		140,
		132,
		122,
		137,
		130,
		110,
		107,
		105,
		102,
		118,
		116,
		126,
		-1,
		-1,
		231,
		200,
		231,
		189,
		170,
		-1,
		136,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		96,
		95,
		123,
		109,
		120,
		191,
		-1,
		-1,
		189,
		181,
		166,
		169,
		146,
		142,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		90,
		100,
		104,
		102,
		127,
		-1,
		-1,
		162,
		-1,
		-1,
		188,
		171,
		-1,
		154,
		161,
		152,
		158,
		144,
		165,
		141,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		87,
		112,
		116,
		97,
		118,
		113,
		-1,
		161,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		156,
		180,
		181,
		-1,
		153,
		141,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		91,
		89,
		119,
		94,
		116,
		113,
		132,
		137,
		131,
		140,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		184,
		-1,
		189,
		190,
		165,
		138,
		141,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		83,
		98,
		89,
		88,
		106,
		116,
		124,
		128,
		134,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		204,
		190,
		182,
		167,
		165,
		-1,
		137,
		134,
		124,
		102,
		87,
		104,
		96,
		94,
		96,
		78,
		92,
		83,
		101,
		108,
		106,
		110,
		130,
		142,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		207,
		171,
		-1,
		166,
		-1,
		139,
		152,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		89,
		74,
		71,
		89,
		92,
		99,
		103,
		119,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		164,
		153,
		152,
		-1,
		143,
		122,
		119,
		107,
		94,
		79,
		80,
		88,
		100,
		79,
		73,
		70,
		90,
		116,
		94,
		106,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		118,
		97,
		88,
		77,
		75,
		88,
		80,
		88,
		68,
		66,
		85,
		97,
		88,
		99,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		161,
		147,
		152,
		127,
		120,
		114,
		131,
		114,
		95,
		84,
		76,
		65,
		76,
		84,
		82,
		64,
		73,
		79,
		103,
		87,
		93,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		152,
		165,
		-1,
		119,
		-1,
		108,
		104,
		89,
		84,
		81,
		68,
		67,
		81,
		81,
		71,
		66,
		73,
		108,
		108,
		77,
		97,
		100,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		135,
		136,
		-1,
		113,
		107,
		104,
		91,
		87,
		72,
		76,
		78,
		81,
		69,
		75,
		76,
		58,
		82,
		-1,
		85,
		79,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		120,
		113,
		-1,
		100,
		82,
		84,
		76,
		70,
		77,
		72,
		63,
		76,
		69,
		63,
		57,
		70,
		74,
		78,
		67,
		63,
		60,
		74,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		129,
		121,
		111,
		105,
		99,
		95,
		93,
		98,
		82,
		85,
		80,
		77,
		67,
		58,
		51,
		62,
		47,
		65,
		73,
		65,
		59,
		58,
		70,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		150,
		-1,
		114,
		128,
		144,
		-1,
		137,
		116,
		131,
		109,
		105,
		96,
		89,
		90,
		60,
		65,
		67,
		55,
		58,
		52,
		55,
		47,
		69,
		69,
		53,
		54,
		63,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		111,
		99,
		131,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		110,
		108,
		79,
		54,
		61,
		79,
		52,
		47,
		57,
		46,
		46,
		41,
		63,
		49,
		47,
		66,
		82,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		151,
		139,
		125,
		108,
		143,
		-1,
		53,
		49,
		56,
		-1,
		72,
		-1,
		44,
		50,
		41,
		38,
		35,
		46,
		44,
		55,
		72,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		168,
		-1,
		-1,
		138,
		132,
		132,
		101,
		98,
		69,
		49,
		41,
		56,
		55,
		42,
		41,
		32,
		32,
		35,
		38,
		51,
		71,
		62,
		74,
		-1,
		-1,
		-1,
		165,
		151,
		155,
		115,
		134,
		-1,
		-1,
		199,
		155,
		141,
		-1,
		93,
		69,
		57,
		47,
		37,
		38,
		43,
		33,
		29,
		30,
		39,
		43,
		47,
		52,
		73,
		74,
		87,
		-1,
		-1,
		148,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		145,
		146,
		112,
		91,
		58,
		-1,
		-1,
		41,
		30,
		25,
		16,
		22,
		42,
		49,
		62,
		46,
		61,
		73,
		81,
		86,
		-1,
		151,
		138,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		124,
		69,
		58,
		53,
		57,
		40,
		-1,
		24,
		7,
		18,
		37,
		44,
		64,
		59,
		53,
		56,
		74,
		91,
		-1,
		-1,
		163,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		81,
		75,
		46,
		39,
		43,
		-1,
		22,
		0,
		15,
		23,
		39,
		44,
		52,
		47,
		61,
		59,
		72,
		86,
		90,
		186,
		-1,
		132,
		-1,
		-1,
		-1,
		99,
		114,
		85,
		62,
		35,
		29,
		22,
		17,
		8,
		28,
		34,
		45,
		41,
		45,
		60,
		65,
		64,
		81,
		91,
		-1,
		-1,
		130,
		126,
		125,
		107,
		111,
		112,
		-1,
		-1,
		37,
		30,
		19,
		20,
		18,
		21,
		37,
		39,
		57,
		76,
		64,
		74,
		92,
		92,
		-1,
		-1,
		-1,
		142,
		-1,
		144,
		-1,
		-1,
		126,
		110,
		57,
		39,
		35,
		33,
		22,
		31,
		27,
		32,
		57,
		54,
		63,
		66,
		72,
		95,
		84,
		123,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		121,
		113,
		108,
		113,
		114,
		105,
		72,
		69,
		-1,
		39,
		58,
		33,
		40,
		32,
		47,
		52,
		58,
		62,
		69,
		85,
		84,
		79,
		115,
		106,
		112,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		114,
		110,
		99,
		89,
		91,
		-1,
		-1,
		79,
		76,
		55,
		42,
		48,
		41,
		36,
		74,
		50,
		58,
		62,
		66,
		72,
		77,
		82,
		88,
		103,
		118,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		104,
		96,
		107,
		82,
		82,
		-1,
		-1,
		52,
		51,
		56,
		49,
		46,
		59,
		58,
		70,
		72,
		77,
		65,
		64,
		82,
		86,
		95,
		102,
		92,
		105,
		109,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		101,
		-1,
		-1,
		113,
		83,
		67,
		59,
		51,
		103,
		63,
		58,
		60,
		62,
		68,
		59,
		82,
		73,
		73,
		76,
		91,
		96,
		88,
		102,
		102,
		103,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		129,
		-1,
		94,
		-1,
		69,
		73,
		71,
		74,
		85,
		72,
		72,
		80,
		88,
		71,
		81,
		77,
		78,
		87,
		98,
		110,
		109,
		110,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		113,
		152,
		167,
		-1,
		138,
		-1,
		-1,
		-1,
		83,
		84,
		76,
		92,
		84,
		84,
		66,
		70,
		76,
		83,
		93,
		95,
		87,
		91,
		104,
		115,
		118,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		128,
		119,
		146,
		172,
		163,
		158,
		145,
		-1,
		-1,
		106,
		94,
		-1,
		-1,
		91,
		87,
		70,
		72,
		76,
		86,
		101,
		104,
		94,
		92,
		86,
		118,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		147,
		142,
		146,
		162,
		187,
		-1,
		148,
		-1,
		-1,
		127,
		-1,
		-1,
		129,
		92,
		81,
		72,
		78,
		84,
		95,
		112,
		100,
		101,
		91,
		101,
		114,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		118,
		116,
		122,
		129,
		146,
		176,
		-1,
		-1,
		164,
		150,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		77,
		82,
		107,
		114,
		109,
		103,
		97,
		104,
		103,
		111,
		119,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		99,
		99,
		102,
		100,
		95,
		106,
		98,
		102,
		119,
		-1,
		189,
		-1,
		141,
		117,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		135,
		103,
		108,
		103,
		101,
		112,
		101,
		104,
		118,
		113,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		154,
		169,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		117,
		106,
		114,
		109,
		105,
		111,
		114,
		103,
		107,
		119,
		-1,
		-1,
		136,
		137,
		142,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		130,
		93,
		110,
		124,
		129,
		127,
		118,
		109,
		116,
		114,
		110,
		121,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		87,
		90,
		115,
		123,
		140,
		134,
		112,
		127,
		117,
		108,
		117,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		91,
		-1,
		119,
		109,
		157,
		132,
		127,
		114,
		121,
		121,
		114,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		99,
		90,
		98,
		147,
		143,
		134,
		134,
		122,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		102,
		100,
		97,
		109,
		105,
		125,
		121,
		153,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		128,
		112,
		110,
		115,
		120,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		121,
		117,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		174,
		163,
		174,
		182,
		155,
		162,
		-1,
		181,
		185,
		151,
		145,
		184,
		153,
		159,
		170,
		-1,
		-1,
		-1,
		174,
		173,
		141,
		139,
		148,
		153,
		160,
		-1,
		159,
		-1,
		195,
		174,
		185,
		190,
		134,
		131,
		151,
		170,
		152,
		144,
		210,
		164,
		135,
		129,
		147,
		137,
		146,
		138,
		-1,
		135,
		125,
		147,
		126,
		137,
		129,
		-1,
		-1,
		129,
		130,
		136,
		122,
		128,
		124,
		-1,
		134,
		118,
		-1,
		-1,
		119,
		120,
		104,
		107,
		115,
		113,
		126,
		118,
		113,
		-1,
		-1,
		110,
		106,
		113,
		100,
		96,
		113,
		126,
		108,
		122,
		121,
		-1,
		116,
		134,
		139,
		107,
		105,
		89,
		87,
		105,
		107,
		113,
		113,
		-1,
		125,
		126,
		121,
		129,
		129,
		105,
		92,
		92,
		102,
		95,
		114,
		102,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		108,
		125,
		117,
		107,
		122,
		115,
		95,
		92,
		90,
		87,
		103,
		101,
		111,
		-1,
		-1,
		216,
		185,
		216,
		174,
		155,
		-1,
		121,
		101,
		107,
		111,
		105,
		98,
		112,
		108,
		-1,
		81,
		80,
		108,
		94,
		105,
		176,
		-1,
		-1,
		174,
		166,
		151,
		154,
		131,
		127,
		116,
		115,
		107,
		93,
		89,
		95,
		98,
		98,
		104,
		75,
		85,
		89,
		87,
		112,
		-1,
		-1,
		147,
		-1,
		-1,
		173,
		156,
		-1,
		139,
		146,
		137,
		143,
		129,
		150,
		126,
		117,
		109,
		103,
		91,
		93,
		90,
		103,
		91,
		72,
		97,
		101,
		82,
		103,
		98,
		-1,
		146,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		132,
		135,
		141,
		165,
		166,
		-1,
		138,
		126,
		127,
		112,
		109,
		96,
		84,
		97,
		82,
		89,
		88,
		76,
		74,
		104,
		79,
		101,
		98,
		117,
		122,
		116,
		125,
		-1,
		181,
		177,
		173,
		180,
		129,
		-1,
		-1,
		169,
		-1,
		174,
		175,
		150,
		123,
		126,
		113,
		104,
		91,
		80,
		91,
		80,
		77,
		85,
		68,
		83,
		74,
		73,
		91,
		101,
		109,
		113,
		119,
		-1,
		231,
		-1,
		173,
		157,
		159,
		131,
		152,
		-1,
		189,
		175,
		167,
		152,
		150,
		-1,
		122,
		119,
		109,
		87,
		72,
		89,
		81,
		79,
		81,
		63,
		77,
		68,
		86,
		93,
		91,
		95,
		115,
		127,
		191,
		181,
		-1,
		163,
		168,
		127,
		135,
		154,
		192,
		156,
		-1,
		151,
		-1,
		124,
		137,
		-1,
		93,
		89,
		71,
		72,
		67,
		82,
		74,
		59,
		56,
		74,
		77,
		84,
		88,
		104,
		-1,
		-1,
		176,
		180,
		169,
		120,
		139,
		163,
		200,
		149,
		138,
		137,
		-1,
		128,
		107,
		104,
		92,
		79,
		64,
		65,
		73,
		85,
		64,
		58,
		55,
		75,
		101,
		79,
		91,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		146,
		117,
		141,
		183,
		167,
		160,
		148,
		113,
		113,
		107,
		-1,
		103,
		82,
		73,
		62,
		60,
		73,
		65,
		73,
		53,
		51,
		70,
		82,
		73,
		84,
		-1,
		-1,
		-1,
		176,
		165,
		166,
		112,
		135,
		172,
		146,
		132,
		137,
		112,
		105,
		99,
		116,
		99,
		80,
		69,
		61,
		50,
		61,
		69,
		67,
		49,
		58,
		64,
		88,
		72,
		78,
		-1,
		-1,
		183,
		173,
		157,
		159,
		156,
		126,
		133,
		165,
		137,
		150,
		-1,
		104,
		-1,
		93,
		89,
		74,
		69,
		66,
		53,
		52,
		66,
		66,
		56,
		51,
		58,
		93,
		93,
		62,
		82,
		85,
		-1,
		-1,
		-1,
		176,
		171,
		146,
		123,
		107,
		143,
		-1,
		120,
		121,
		-1,
		98,
		92,
		89,
		76,
		72,
		57,
		61,
		63,
		66,
		54,
		60,
		61,
		43,
		67,
		-1,
		70,
		64,
		72,
		62,
		50,
		-1,
		-1,
		-1,
		169,
		148,
		141,
		161,
		102,
		154,
		-1,
		-1,
		105,
		98,
		-1,
		85,
		67,
		69,
		64,
		63,
		62,
		59,
		48,
		61,
		54,
		48,
		42,
		55,
		59,
		63,
		52,
		48,
		45,
		59,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		122,
		-1,
		114,
		106,
		96,
		90,
		84,
		80,
		78,
		91,
		75,
		74,
		71,
		62,
		66,
		43,
		36,
		47,
		32,
		50,
		58,
		50,
		44,
		43,
		55,
		-1,
		189,
		175,
		146,
		-1,
		-1,
		135,
		-1,
		99,
		113,
		129,
		-1,
		122,
		101,
		116,
		94,
		90,
		81,
		98,
		99,
		74,
		71,
		66,
		54,
		48,
		37,
		40,
		32,
		54,
		54,
		38,
		39,
		48,
		-1,
		195,
		182,
		140,
		136,
		125,
		145,
		96,
		84,
		116,
		-1,
		-1,
		158,
		-1,
		92,
		109,
		95,
		93,
		88,
		68,
		75,
		78,
		51,
		46,
		42,
		31,
		31,
		26,
		48,
		34,
		32,
		51,
		67,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		111,
		98,
		92,
		-1,
		133,
		-1,
		136,
		126,
		110,
		95,
		128,
		-1,
		67,
		63,
		70,
		-1,
		71,
		-1,
		39,
		35,
		26,
		23,
		20,
		31,
		29,
		40,
		57,
		-1,
		145,
		130,
		123,
		113,
		127,
		98,
		-1,
		153,
		-1,
		-1,
		123,
		117,
		117,
		101,
		101,
		83,
		63,
		55,
		70,
		54,
		37,
		40,
		17,
		17,
		20,
		23,
		36,
		56,
		47,
		59,
		-1,
		-1,
		-1,
		150,
		136,
		140,
		100,
		119,
		-1,
		-1,
		185,
		140,
		126,
		-1,
		96,
		83,
		71,
		61,
		51,
		52,
		53,
		28,
		19,
		15,
		24,
		28,
		32,
		37,
		58,
		59,
		72,
		-1,
		-1,
		133,
		138,
		126,
		112,
		131,
		-1,
		-1,
		-1,
		132,
		148,
		115,
		94,
		72,
		-1,
		-1,
		55,
		44,
		39,
		16,
		7,
		27,
		34,
		47,
		31,
		46,
		58,
		66,
		71,
		-1,
		136,
		123,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		-1,
		-1,
		127,
		72,
		61,
		56,
		60,
		54,
		-1,
		30,
		21,
		3,
		23,
		30,
		49,
		44,
		38,
		41,
		59,
		76,
		-1,
		-1,
		148,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		84,
		78,
		49,
		42,
		46,
		-1,
		28,
		14,
		0,
		17,
		38,
		43,
		50,
		42,
		47,
		44,
		57,
		71,
		75,
		171,
		-1,
		138,
		-1,
		-1,
		-1,
		102,
		117,
		88,
		65,
		38,
		33,
		26,
		20,
		8,
		24,
		33,
		44,
		41,
		45,
		46,
		50,
		49,
		66,
		76,
		-1,
		-1,
		136,
		132,
		128,
		110,
		114,
		115,
		-1,
		-1,
		42,
		33,
		24,
		23,
		18,
		21,
		37,
		39,
		57,
		62,
		50,
		59,
		77,
		81,
		-1,
		-1,
		-1,
		148,
		-1,
		150,
		-1,
		-1,
		129,
		113,
		60,
		42,
		38,
		36,
		28,
		37,
		27,
		32,
		57,
		54,
		63,
		52,
		65,
		87,
		77,
		113,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		127,
		119,
		114,
		119,
		120,
		111,
		75,
		72,
		-1,
		42,
		64,
		33,
		40,
		32,
		47,
		52,
		58,
		55,
		62,
		78,
		77,
		72,
		105,
		99,
		105,
		-1,
		-1,
		216,
		205,
		194,
		200,
		-1,
		120,
		116,
		105,
		95,
		97,
		-1,
		-1,
		85,
		82,
		61,
		42,
		48,
		41,
		36,
		74,
		50,
		51,
		55,
		59,
		65,
		70,
		75,
		81,
		96,
		111,
		-1,
		170,
		207,
		200,
		168,
		176,
		207,
		-1,
		110,
		102,
		113,
		88,
		88,
		-1,
		-1,
		58,
		57,
		61,
		49,
		46,
		59,
		58,
		70,
		65,
		71,
		58,
		57,
		75,
		79,
		88,
		95,
		85,
		98,
		102,
		-1,
		163,
		183,
		162,
		165,
		189,
		203,
		-1,
		107,
		-1,
		-1,
		119,
		89,
		73,
		65,
		57,
		108,
		63,
		58,
		60,
		62,
		68,
		59,
		75,
		66,
		66,
		69,
		84,
		89,
		81,
		95,
		95,
		96,
		-1,
		152,
		163,
		156,
		-1,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		135,
		-1,
		100,
		-1,
		75,
		79,
		71,
		74,
		85,
		72,
		72,
		73,
		88,
		64,
		74,
		70,
		71,
		80,
		91,
		103,
		102,
		103,
		177,
		133,
		136,
		147,
		158,
		173,
		177,
		-1,
		119,
		158,
		173,
		-1,
		144,
		-1,
		-1,
		-1,
		89,
		84,
		76,
		92,
		84,
		84,
		66,
		70,
		69,
		76,
		86,
		88,
		80,
		84,
		97,
		108,
		111,
		173,
		164,
		177,
		122,
		122,
		143,
		152,
		173,
		134,
		125,
		152,
		176,
		169,
		164,
		151,
		-1,
		-1,
		112,
		94,
		-1,
		-1,
		91,
		87,
		70,
		72,
		76,
		79,
		94,
		97,
		87,
		85,
		79,
		111,
		-1,
		166,
		165,
		154,
		151,
		127,
		118,
		113,
		140,
		-1,
		-1,
		135,
		153,
		146,
		150,
		166,
		191,
		-1,
		154,
		-1,
		-1,
		133,
		-1,
		-1,
		129,
		92,
		81,
		72,
		78,
		84,
		95,
		105,
		93,
		94,
		84,
		94,
		107,
		150,
		147,
		135,
		133,
		156,
		121,
		109,
		-1,
		122,
		120,
		126,
		133,
		150,
		180,
		-1,
		-1,
		170,
		150,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		77,
		82,
		107,
		113,
		102,
		96,
		90,
		97,
		96,
		104,
		112,
		159,
		173,
		162,
		158,
		157,
		165,
		114,
		107,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		99,
		99,
		100,
		93,
		88,
		99,
		91,
		95,
		112,
		-1,
		193,
		-1,
		145,
		121,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		135,
		103,
		108,
		103,
		94,
		105,
		94,
		97,
		111,
		106,
		-1,
		-1,
		133,
		136,
		-1,
		-1,
		158,
		169,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		117,
		106,
		114,
		109,
		98,
		104,
		107,
		96,
		100,
		112,
		-1,
		-1,
		140,
		141,
		146,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		130,
		93,
		110,
		124,
		127,
		125,
		116,
		102,
		109,
		107,
		103,
		114,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		87,
		90,
		115,
		123,
		138,
		132,
		105,
		120,
		110,
		101,
		110,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		91,
		-1,
		119,
		109,
		154,
		132,
		120,
		107,
		114,
		114,
		107,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		99,
		90,
		98,
		144,
		140,
		127,
		127,
		119,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		102,
		100,
		97,
		109,
		105,
		125,
		120,
		153,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		128,
		112,
		110,
		115,
		120,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		121,
		117,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		189,
		178,
		189,
		197,
		170,
		177,
		-1,
		196,
		200,
		166,
		160,
		199,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		189,
		188,
		156,
		154,
		163,
		168,
		175,
		-1,
		174,
		-1,
		210,
		189,
		200,
		205,
		149,
		146,
		166,
		185,
		167,
		159,
		225,
		179,
		150,
		144,
		162,
		152,
		161,
		153,
		-1,
		150,
		140,
		162,
		141,
		152,
		144,
		-1,
		-1,
		144,
		145,
		151,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		134,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		131,
		149,
		154,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		128,
		-1,
		140,
		141,
		136,
		144,
		144,
		120,
		107,
		107,
		117,
		110,
		129,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		123,
		140,
		132,
		122,
		137,
		130,
		110,
		107,
		105,
		102,
		118,
		116,
		126,
		-1,
		-1,
		231,
		200,
		231,
		189,
		170,
		-1,
		136,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		96,
		95,
		123,
		109,
		120,
		191,
		-1,
		-1,
		189,
		181,
		166,
		169,
		146,
		142,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		90,
		100,
		104,
		102,
		127,
		-1,
		-1,
		162,
		-1,
		-1,
		188,
		171,
		-1,
		154,
		161,
		152,
		158,
		144,
		165,
		141,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		87,
		112,
		116,
		97,
		118,
		113,
		-1,
		161,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		156,
		180,
		181,
		-1,
		153,
		141,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		91,
		89,
		119,
		94,
		116,
		113,
		132,
		137,
		131,
		140,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		184,
		-1,
		189,
		190,
		165,
		138,
		141,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		83,
		98,
		89,
		88,
		106,
		116,
		124,
		128,
		134,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		204,
		190,
		182,
		167,
		165,
		-1,
		137,
		134,
		124,
		102,
		87,
		104,
		96,
		94,
		96,
		78,
		92,
		83,
		101,
		108,
		106,
		110,
		130,
		142,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		207,
		171,
		-1,
		166,
		-1,
		139,
		152,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		89,
		74,
		71,
		89,
		92,
		99,
		103,
		119,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		164,
		153,
		152,
		-1,
		143,
		122,
		119,
		107,
		94,
		79,
		80,
		88,
		100,
		79,
		73,
		70,
		90,
		116,
		94,
		106,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		118,
		97,
		88,
		77,
		75,
		88,
		80,
		88,
		68,
		66,
		85,
		97,
		88,
		99,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		161,
		147,
		152,
		127,
		120,
		114,
		131,
		114,
		95,
		84,
		76,
		65,
		76,
		84,
		82,
		64,
		73,
		79,
		103,
		87,
		93,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		152,
		165,
		-1,
		119,
		-1,
		108,
		104,
		89,
		84,
		81,
		68,
		67,
		81,
		81,
		71,
		66,
		73,
		108,
		108,
		77,
		97,
		100,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		135,
		136,
		-1,
		113,
		107,
		104,
		91,
		87,
		72,
		76,
		78,
		81,
		69,
		75,
		76,
		58,
		82,
		-1,
		85,
		79,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		120,
		113,
		-1,
		100,
		82,
		84,
		79,
		78,
		77,
		74,
		63,
		76,
		69,
		63,
		57,
		70,
		74,
		78,
		67,
		63,
		60,
		74,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		129,
		121,
		111,
		105,
		99,
		95,
		93,
		106,
		90,
		89,
		86,
		77,
		81,
		58,
		51,
		62,
		47,
		65,
		73,
		65,
		59,
		58,
		70,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		150,
		-1,
		114,
		128,
		144,
		-1,
		137,
		116,
		131,
		109,
		105,
		96,
		112,
		113,
		83,
		86,
		81,
		69,
		63,
		52,
		55,
		47,
		69,
		69,
		53,
		54,
		63,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		111,
		99,
		131,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		110,
		108,
		102,
		77,
		84,
		93,
		66,
		61,
		57,
		46,
		46,
		41,
		63,
		49,
		47,
		66,
		82,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		76,
		72,
		79,
		-1,
		86,
		-1,
		54,
		50,
		41,
		38,
		35,
		46,
		44,
		55,
		72,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		168,
		-1,
		-1,
		138,
		132,
		132,
		114,
		111,
		92,
		72,
		64,
		79,
		69,
		52,
		55,
		32,
		32,
		35,
		38,
		51,
		71,
		62,
		74,
		-1,
		-1,
		-1,
		165,
		151,
		155,
		115,
		134,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		106,
		92,
		80,
		70,
		60,
		61,
		66,
		43,
		34,
		30,
		39,
		43,
		47,
		52,
		73,
		74,
		87,
		-1,
		-1,
		148,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		147,
		159,
		125,
		104,
		81,
		-1,
		-1,
		64,
		53,
		48,
		31,
		22,
		41,
		48,
		47,
		46,
		61,
		73,
		81,
		86,
		-1,
		151,
		138,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		137,
		82,
		71,
		66,
		70,
		63,
		-1,
		37,
		30,
		18,
		26,
		33,
		49,
		48,
		53,
		56,
		74,
		91,
		-1,
		-1,
		163,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		94,
		88,
		59,
		52,
		56,
		-1,
		35,
		23,
		15,
		0,
		28,
		33,
		41,
		53,
		62,
		59,
		72,
		86,
		90,
		186,
		-1,
		145,
		-1,
		-1,
		-1,
		112,
		127,
		98,
		75,
		48,
		42,
		35,
		30,
		21,
		14,
		23,
		34,
		47,
		51,
		61,
		65,
		64,
		81,
		91,
		-1,
		-1,
		143,
		139,
		138,
		120,
		124,
		125,
		-1,
		-1,
		50,
		43,
		32,
		29,
		21,
		18,
		43,
		45,
		63,
		77,
		65,
		74,
		92,
		96,
		-1,
		-1,
		-1,
		155,
		-1,
		157,
		-1,
		-1,
		139,
		123,
		70,
		52,
		48,
		46,
		35,
		44,
		33,
		38,
		63,
		60,
		69,
		67,
		78,
		101,
		90,
		128,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		134,
		126,
		121,
		126,
		127,
		118,
		85,
		82,
		-1,
		52,
		71,
		39,
		46,
		38,
		53,
		58,
		64,
		68,
		75,
		91,
		90,
		85,
		120,
		112,
		118,
		-1,
		-1,
		222,
		211,
		200,
		206,
		-1,
		127,
		123,
		112,
		102,
		104,
		-1,
		-1,
		92,
		89,
		68,
		48,
		54,
		47,
		42,
		80,
		56,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		176,
		213,
		206,
		174,
		182,
		213,
		-1,
		117,
		109,
		120,
		95,
		95,
		-1,
		-1,
		65,
		64,
		67,
		55,
		52,
		65,
		64,
		76,
		78,
		83,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		169,
		189,
		168,
		171,
		195,
		209,
		-1,
		114,
		-1,
		-1,
		126,
		96,
		80,
		72,
		64,
		114,
		69,
		64,
		66,
		68,
		74,
		65,
		88,
		79,
		79,
		82,
		97,
		102,
		94,
		108,
		108,
		109,
		-1,
		158,
		169,
		162,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		142,
		-1,
		107,
		-1,
		82,
		86,
		77,
		80,
		91,
		78,
		78,
		86,
		94,
		77,
		87,
		83,
		84,
		93,
		104,
		116,
		115,
		116,
		183,
		139,
		142,
		153,
		164,
		179,
		183,
		-1,
		126,
		165,
		180,
		-1,
		151,
		-1,
		-1,
		-1,
		96,
		90,
		82,
		98,
		90,
		90,
		72,
		76,
		82,
		89,
		99,
		101,
		93,
		97,
		110,
		121,
		124,
		179,
		170,
		183,
		128,
		128,
		149,
		158,
		179,
		141,
		132,
		159,
		182,
		176,
		171,
		158,
		-1,
		-1,
		119,
		100,
		-1,
		-1,
		97,
		93,
		76,
		78,
		82,
		92,
		107,
		110,
		100,
		98,
		92,
		124,
		-1,
		172,
		171,
		160,
		157,
		133,
		124,
		119,
		146,
		-1,
		-1,
		141,
		160,
		152,
		156,
		172,
		197,
		-1,
		160,
		-1,
		-1,
		140,
		-1,
		-1,
		135,
		98,
		87,
		78,
		84,
		90,
		101,
		118,
		106,
		107,
		97,
		107,
		120,
		156,
		153,
		141,
		139,
		162,
		127,
		115,
		-1,
		128,
		126,
		132,
		139,
		156,
		186,
		-1,
		-1,
		176,
		156,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		83,
		88,
		113,
		120,
		115,
		109,
		103,
		110,
		109,
		117,
		125,
		165,
		179,
		168,
		164,
		163,
		171,
		120,
		113,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		166,
		162,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		105,
		105,
		108,
		106,
		101,
		112,
		104,
		108,
		125,
		-1,
		199,
		-1,
		151,
		127,
		141,
		156,
		164,
		-1,
		-1,
		-1,
		183,
		169,
		162,
		150,
		148,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		141,
		109,
		114,
		109,
		107,
		118,
		107,
		110,
		124,
		119,
		-1,
		-1,
		139,
		142,
		-1,
		-1,
		164,
		175,
		-1,
		174,
		163,
		148,
		140,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		98,
		123,
		112,
		120,
		115,
		111,
		117,
		120,
		109,
		113,
		125,
		-1,
		-1,
		146,
		147,
		152,
		-1,
		158,
		-1,
		176,
		-1,
		143,
		149,
		137,
		-1,
		-1,
		-1,
		136,
		99,
		116,
		130,
		135,
		133,
		124,
		115,
		122,
		120,
		116,
		127,
		-1,
		-1,
		-1,
		176,
		150,
		183,
		174,
		157,
		137,
		129,
		148,
		-1,
		118,
		-1,
		93,
		96,
		121,
		129,
		146,
		140,
		118,
		133,
		123,
		114,
		123,
		182,
		-1,
		152,
		185,
		149,
		143,
		119,
		123,
		139,
		-1,
		115,
		97,
		-1,
		125,
		115,
		163,
		138,
		133,
		120,
		127,
		127,
		120,
		-1,
		-1,
		-1,
		154,
		153,
		145,
		139,
		139,
		124,
		115,
		-1,
		127,
		109,
		88,
		105,
		105,
		96,
		104,
		153,
		149,
		140,
		140,
		128,
		-1,
		255,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		148,
		143,
		116,
		104,
		110,
		106,
		92,
		98,
		100,
		108,
		106,
		103,
		115,
		111,
		131,
		127,
		159,
		-1,
		250,
		-1,
		184,
		-1,
		-1,
		166,
		146,
		138,
		127,
		116,
		114,
		105,
		96,
		118,
		134,
		118,
		116,
		121,
		126,
		-1,
		239,
		238,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		162,
		123,
		-1,
		125,
		105,
		-1,
		127,
		123,
		-1,
		-1,
		226,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		157,
		141,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		211,
		210,
		-1,
		179,
		182,
		-1,
		172,
		163,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		220,
		201,
		195,
		194,
		192,
		187,
		184,
		170,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		192,
		184,
		177,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		203,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		226,
		249,
		213,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		228,
		226,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		140,
		158,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		149,
		150,
		145,
		153,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		132,
		149,
		141,
		131,
		146,
		139,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		240,
		209,
		240,
		198,
		179,
		-1,
		145,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		105,
		104,
		132,
		118,
		129,
		200,
		-1,
		-1,
		198,
		190,
		175,
		178,
		155,
		151,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		99,
		109,
		113,
		111,
		136,
		-1,
		-1,
		171,
		-1,
		-1,
		197,
		180,
		-1,
		163,
		170,
		161,
		167,
		153,
		174,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		96,
		121,
		125,
		106,
		127,
		122,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		156,
		159,
		165,
		189,
		190,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		100,
		98,
		128,
		103,
		125,
		122,
		141,
		146,
		140,
		149,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		193,
		-1,
		198,
		199,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		92,
		107,
		98,
		97,
		115,
		125,
		133,
		137,
		143,
		-1,
		255,
		-1,
		197,
		181,
		183,
		155,
		176,
		-1,
		213,
		199,
		191,
		176,
		174,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		105,
		103,
		105,
		87,
		101,
		92,
		110,
		117,
		115,
		119,
		139,
		151,
		215,
		205,
		-1,
		187,
		192,
		151,
		159,
		178,
		216,
		180,
		-1,
		175,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		98,
		83,
		80,
		98,
		101,
		108,
		112,
		128,
		-1,
		-1,
		200,
		204,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		109,
		88,
		82,
		79,
		99,
		125,
		103,
		114,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		89,
		97,
		77,
		75,
		94,
		106,
		97,
		105,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		140,
		123,
		104,
		93,
		85,
		74,
		85,
		93,
		91,
		73,
		82,
		88,
		112,
		93,
		99,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		113,
		98,
		93,
		90,
		77,
		76,
		90,
		90,
		80,
		75,
		82,
		117,
		117,
		83,
		103,
		106,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		100,
		96,
		81,
		85,
		87,
		90,
		78,
		84,
		85,
		67,
		91,
		-1,
		91,
		85,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		93,
		88,
		87,
		86,
		83,
		72,
		85,
		78,
		72,
		66,
		79,
		83,
		84,
		73,
		69,
		66,
		80,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		115,
		99,
		98,
		95,
		86,
		94,
		67,
		60,
		71,
		56,
		74,
		80,
		71,
		66,
		65,
		76,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		105,
		122,
		123,
		101,
		95,
		93,
		83,
		72,
		61,
		64,
		56,
		78,
		75,
		59,
		61,
		70,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		119,
		117,
		112,
		96,
		103,
		104,
		80,
		75,
		66,
		55,
		55,
		50,
		69,
		55,
		53,
		69,
		85,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		95,
		91,
		98,
		-1,
		100,
		-1,
		72,
		71,
		62,
		47,
		44,
		55,
		53,
		62,
		64,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		125,
		111,
		91,
		83,
		98,
		83,
		66,
		69,
		55,
		53,
		50,
		40,
		53,
		63,
		69,
		62,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		120,
		111,
		99,
		89,
		79,
		84,
		82,
		57,
		48,
		53,
		60,
		46,
		42,
		41,
		62,
		56,
		78,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		139,
		118,
		100,
		-1,
		-1,
		83,
		76,
		70,
		51,
		45,
		54,
		61,
		26,
		35,
		50,
		61,
		69,
		68,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		151,
		96,
		85,
		80,
		84,
		82,
		-1,
		56,
		57,
		45,
		28,
		35,
		26,
		20,
		29,
		40,
		56,
		73,
		-1,
		-1,
		172,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		73,
		66,
		70,
		-1,
		56,
		50,
		42,
		34,
		0,
		5,
		13,
		33,
		38,
		41,
		54,
		68,
		72,
		195,
		-1,
		157,
		-1,
		-1,
		-1,
		126,
		141,
		112,
		89,
		62,
		57,
		50,
		44,
		40,
		22,
		8,
		19,
		40,
		36,
		37,
		47,
		46,
		63,
		73,
		-1,
		-1,
		155,
		151,
		152,
		134,
		138,
		139,
		-1,
		-1,
		66,
		57,
		48,
		39,
		29,
		26,
		46,
		43,
		48,
		53,
		41,
		56,
		71,
		78,
		-1,
		-1,
		-1,
		167,
		-1,
		169,
		-1,
		-1,
		153,
		137,
		84,
		66,
		62,
		60,
		53,
		55,
		43,
		48,
		61,
		70,
		63,
		43,
		64,
		81,
		76,
		110,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		146,
		138,
		133,
		139,
		141,
		132,
		99,
		96,
		-1,
		66,
		84,
		49,
		56,
		48,
		63,
		68,
		67,
		48,
		61,
		77,
		76,
		71,
		102,
		97,
		104,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		139,
		135,
		125,
		115,
		118,
		-1,
		-1,
		112,
		109,
		81,
		58,
		64,
		57,
		52,
		83,
		63,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		95,
		110,
		-1,
		186,
		223,
		216,
		184,
		192,
		223,
		-1,
		129,
		121,
		132,
		107,
		109,
		-1,
		-1,
		85,
		76,
		77,
		65,
		62,
		75,
		74,
		79,
		64,
		70,
		57,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		126,
		-1,
		-1,
		138,
		110,
		94,
		84,
		81,
		124,
		79,
		74,
		76,
		78,
		76,
		67,
		74,
		65,
		65,
		68,
		83,
		88,
		80,
		94,
		94,
		95,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		154,
		-1,
		121,
		-1,
		104,
		108,
		87,
		90,
		101,
		88,
		80,
		72,
		88,
		63,
		73,
		69,
		70,
		79,
		90,
		102,
		101,
		102,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		138,
		177,
		192,
		-1,
		163,
		-1,
		-1,
		-1,
		118,
		100,
		92,
		108,
		100,
		100,
		74,
		78,
		68,
		75,
		85,
		87,
		79,
		83,
		96,
		107,
		110,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		153,
		144,
		171,
		192,
		188,
		183,
		170,
		-1,
		-1,
		141,
		110,
		-1,
		-1,
		107,
		95,
		78,
		79,
		75,
		78,
		93,
		96,
		86,
		84,
		78,
		110,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		151,
		172,
		162,
		166,
		182,
		207,
		-1,
		167,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		100,
		89,
		80,
		86,
		83,
		94,
		104,
		92,
		93,
		83,
		93,
		106,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		138,
		136,
		142,
		149,
		166,
		196,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		90,
		110,
		112,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		99,
		103,
		107,
		99,
		92,
		87,
		98,
		90,
		94,
		111,
		-1,
		209,
		-1,
		161,
		137,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		143,
		111,
		116,
		111,
		93,
		104,
		93,
		96,
		110,
		105,
		-1,
		-1,
		149,
		152,
		-1,
		-1,
		174,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		125,
		114,
		122,
		117,
		97,
		103,
		106,
		95,
		99,
		111,
		-1,
		-1,
		156,
		157,
		162,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		138,
		101,
		122,
		132,
		126,
		124,
		115,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		102,
		128,
		131,
		137,
		131,
		104,
		119,
		109,
		100,
		109,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		132,
		122,
		153,
		138,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		111,
		143,
		139,
		126,
		126,
		118,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		113,
		110,
		122,
		118,
		138,
		119,
		154,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		125,
		123,
		126,
		127,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		134,
		130,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		200,
		204,
		170,
		164,
		203,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		193,
		192,
		160,
		158,
		167,
		172,
		179,
		-1,
		178,
		-1,
		214,
		193,
		204,
		209,
		153,
		150,
		170,
		189,
		171,
		163,
		229,
		183,
		154,
		148,
		166,
		156,
		165,
		157,
		-1,
		154,
		144,
		166,
		145,
		156,
		148,
		-1,
		-1,
		148,
		149,
		155,
		141,
		147,
		143,
		-1,
		153,
		137,
		-1,
		-1,
		138,
		139,
		123,
		126,
		134,
		132,
		145,
		137,
		132,
		-1,
		-1,
		129,
		125,
		132,
		119,
		115,
		132,
		145,
		127,
		141,
		140,
		-1,
		135,
		153,
		158,
		126,
		124,
		108,
		106,
		124,
		126,
		132,
		132,
		-1,
		144,
		145,
		140,
		148,
		148,
		124,
		111,
		111,
		121,
		114,
		133,
		121,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		127,
		144,
		136,
		126,
		141,
		134,
		114,
		111,
		109,
		106,
		122,
		120,
		130,
		-1,
		-1,
		235,
		204,
		235,
		193,
		174,
		-1,
		140,
		120,
		126,
		130,
		124,
		117,
		131,
		127,
		-1,
		100,
		99,
		127,
		113,
		124,
		195,
		-1,
		-1,
		193,
		185,
		170,
		173,
		150,
		146,
		135,
		134,
		126,
		112,
		108,
		114,
		117,
		117,
		123,
		94,
		104,
		108,
		106,
		131,
		-1,
		-1,
		166,
		-1,
		-1,
		192,
		175,
		-1,
		158,
		165,
		156,
		162,
		148,
		169,
		145,
		136,
		128,
		122,
		110,
		112,
		109,
		122,
		110,
		91,
		116,
		120,
		101,
		122,
		117,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		151,
		154,
		160,
		184,
		185,
		-1,
		157,
		145,
		146,
		131,
		128,
		115,
		103,
		116,
		101,
		108,
		107,
		95,
		93,
		123,
		98,
		120,
		117,
		136,
		141,
		135,
		144,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		188,
		-1,
		193,
		194,
		169,
		142,
		145,
		132,
		123,
		110,
		99,
		110,
		99,
		96,
		104,
		87,
		102,
		93,
		92,
		110,
		120,
		128,
		132,
		138,
		-1,
		250,
		-1,
		192,
		176,
		178,
		150,
		171,
		-1,
		208,
		194,
		186,
		171,
		169,
		-1,
		141,
		138,
		128,
		106,
		91,
		108,
		100,
		98,
		100,
		82,
		96,
		87,
		105,
		112,
		110,
		114,
		134,
		146,
		210,
		200,
		-1,
		182,
		187,
		146,
		154,
		173,
		211,
		175,
		-1,
		170,
		-1,
		143,
		156,
		-1,
		112,
		108,
		90,
		91,
		86,
		101,
		93,
		78,
		75,
		93,
		96,
		103,
		107,
		123,
		-1,
		-1,
		195,
		199,
		188,
		139,
		158,
		182,
		219,
		168,
		157,
		156,
		-1,
		147,
		126,
		123,
		111,
		98,
		83,
		84,
		92,
		104,
		83,
		77,
		74,
		94,
		120,
		98,
		109,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		165,
		136,
		160,
		202,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		122,
		101,
		92,
		81,
		79,
		92,
		84,
		92,
		72,
		70,
		89,
		101,
		92,
		100,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		131,
		154,
		191,
		165,
		151,
		156,
		131,
		124,
		118,
		135,
		118,
		99,
		88,
		80,
		69,
		80,
		88,
		86,
		68,
		77,
		83,
		107,
		88,
		94,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		145,
		152,
		184,
		156,
		169,
		-1,
		123,
		-1,
		112,
		108,
		93,
		88,
		85,
		72,
		71,
		85,
		85,
		75,
		70,
		77,
		112,
		112,
		78,
		98,
		101,
		-1,
		-1,
		-1,
		195,
		190,
		165,
		142,
		126,
		162,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		95,
		91,
		76,
		80,
		82,
		85,
		73,
		79,
		80,
		62,
		86,
		-1,
		86,
		80,
		88,
		78,
		66,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		121,
		173,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		88,
		83,
		82,
		81,
		78,
		67,
		80,
		73,
		67,
		61,
		74,
		78,
		79,
		68,
		64,
		61,
		75,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		141,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		110,
		94,
		93,
		90,
		81,
		89,
		62,
		55,
		66,
		51,
		69,
		75,
		66,
		61,
		60,
		71,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		100,
		117,
		118,
		96,
		90,
		88,
		78,
		67,
		56,
		59,
		51,
		73,
		70,
		54,
		56,
		65,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		114,
		112,
		107,
		98,
		104,
		99,
		75,
		70,
		61,
		50,
		50,
		45,
		64,
		50,
		48,
		64,
		80,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		98,
		94,
		101,
		-1,
		95,
		-1,
		67,
		66,
		57,
		42,
		39,
		50,
		48,
		57,
		59,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		114,
		94,
		86,
		101,
		78,
		61,
		64,
		50,
		48,
		45,
		35,
		48,
		58,
		64,
		57,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		123,
		114,
		102,
		92,
		82,
		85,
		77,
		52,
		43,
		48,
		55,
		41,
		37,
		36,
		57,
		51,
		73,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		142,
		121,
		103,
		-1,
		-1,
		86,
		77,
		69,
		46,
		40,
		49,
		56,
		21,
		30,
		45,
		56,
		64,
		63,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		154,
		99,
		88,
		83,
		87,
		85,
		-1,
		59,
		57,
		41,
		23,
		30,
		21,
		15,
		24,
		35,
		51,
		68,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		111,
		105,
		76,
		69,
		73,
		-1,
		59,
		52,
		43,
		29,
		3,
		0,
		8,
		28,
		33,
		36,
		49,
		63,
		67,
		190,
		-1,
		160,
		-1,
		-1,
		-1,
		129,
		144,
		115,
		92,
		65,
		60,
		53,
		47,
		43,
		25,
		11,
		22,
		35,
		31,
		32,
		42,
		41,
		58,
		68,
		-1,
		-1,
		158,
		154,
		155,
		137,
		141,
		142,
		-1,
		-1,
		69,
		60,
		51,
		42,
		32,
		29,
		41,
		38,
		43,
		48,
		36,
		51,
		66,
		73,
		-1,
		-1,
		-1,
		170,
		-1,
		172,
		-1,
		-1,
		156,
		140,
		87,
		69,
		65,
		63,
		56,
		58,
		46,
		46,
		56,
		66,
		58,
		38,
		59,
		76,
		71,
		105,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		149,
		141,
		136,
		142,
		144,
		135,
		102,
		99,
		-1,
		69,
		87,
		52,
		59,
		51,
		64,
		64,
		62,
		43,
		56,
		72,
		71,
		66,
		97,
		92,
		99,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		142,
		138,
		128,
		118,
		121,
		-1,
		-1,
		115,
		112,
		84,
		61,
		67,
		60,
		55,
		78,
		58,
		45,
		49,
		53,
		59,
		64,
		69,
		75,
		90,
		105,
		-1,
		189,
		226,
		219,
		187,
		195,
		226,
		-1,
		132,
		124,
		135,
		110,
		112,
		-1,
		-1,
		88,
		79,
		80,
		68,
		65,
		78,
		77,
		74,
		59,
		65,
		52,
		51,
		69,
		73,
		82,
		89,
		79,
		92,
		96,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		129,
		-1,
		-1,
		141,
		113,
		97,
		87,
		84,
		127,
		82,
		77,
		79,
		80,
		71,
		62,
		69,
		60,
		60,
		63,
		78,
		83,
		75,
		89,
		89,
		90,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		157,
		-1,
		124,
		-1,
		107,
		111,
		90,
		93,
		96,
		83,
		75,
		67,
		83,
		58,
		68,
		64,
		65,
		74,
		85,
		97,
		96,
		97,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		141,
		180,
		195,
		-1,
		166,
		-1,
		-1,
		-1,
		121,
		103,
		95,
		111,
		95,
		95,
		69,
		73,
		63,
		70,
		80,
		82,
		74,
		78,
		91,
		102,
		105,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		156,
		147,
		174,
		195,
		191,
		186,
		173,
		-1,
		-1,
		144,
		113,
		-1,
		-1,
		102,
		90,
		73,
		74,
		70,
		73,
		88,
		91,
		81,
		79,
		73,
		105,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		175,
		165,
		169,
		185,
		210,
		-1,
		162,
		-1,
		-1,
		147,
		-1,
		-1,
		132,
		95,
		84,
		75,
		81,
		78,
		89,
		99,
		87,
		88,
		78,
		88,
		101,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		141,
		139,
		145,
		152,
		169,
		199,
		-1,
		-1,
		178,
		158,
		-1,
		-1,
		130,
		128,
		117,
		-1,
		107,
		80,
		85,
		105,
		107,
		96,
		90,
		84,
		91,
		90,
		98,
		106,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		164,
		-1,
		-1,
		125,
		118,
		106,
		94,
		84,
		94,
		98,
		102,
		94,
		87,
		82,
		93,
		85,
		89,
		106,
		-1,
		212,
		-1,
		164,
		140,
		154,
		169,
		177,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		159,
		143,
		124,
		-1,
		94,
		107,
		138,
		106,
		111,
		106,
		88,
		99,
		88,
		91,
		105,
		100,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		175,
		177,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		131,
		127,
		-1,
		-1,
		95,
		120,
		109,
		117,
		112,
		92,
		98,
		101,
		90,
		94,
		106,
		-1,
		-1,
		159,
		160,
		165,
		-1,
		160,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		133,
		96,
		117,
		127,
		121,
		119,
		110,
		96,
		103,
		101,
		97,
		108,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		97,
		123,
		126,
		132,
		126,
		99,
		114,
		104,
		95,
		104,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		117,
		148,
		133,
		114,
		101,
		108,
		108,
		101,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		138,
		134,
		121,
		121,
		113,
		-1,
		257,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		117,
		113,
		133,
		114,
		149,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		120,
		118,
		121,
		122,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		129,
		125,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		192,
		196,
		162,
		156,
		195,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		185,
		184,
		152,
		150,
		159,
		164,
		171,
		-1,
		170,
		-1,
		206,
		185,
		196,
		201,
		145,
		142,
		162,
		181,
		163,
		155,
		221,
		175,
		146,
		140,
		158,
		148,
		157,
		149,
		-1,
		146,
		136,
		158,
		137,
		148,
		140,
		-1,
		-1,
		140,
		141,
		147,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		130,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		127,
		145,
		150,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		124,
		-1,
		136,
		137,
		132,
		140,
		140,
		116,
		103,
		103,
		113,
		106,
		125,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		119,
		136,
		128,
		118,
		133,
		126,
		106,
		103,
		101,
		98,
		114,
		112,
		122,
		-1,
		-1,
		227,
		196,
		227,
		185,
		166,
		-1,
		132,
		112,
		118,
		122,
		116,
		109,
		123,
		119,
		-1,
		92,
		91,
		119,
		105,
		116,
		187,
		-1,
		-1,
		185,
		177,
		162,
		165,
		142,
		138,
		127,
		126,
		118,
		104,
		100,
		106,
		109,
		109,
		115,
		86,
		96,
		100,
		98,
		123,
		-1,
		-1,
		158,
		-1,
		-1,
		184,
		167,
		-1,
		150,
		157,
		148,
		154,
		140,
		161,
		137,
		128,
		120,
		114,
		102,
		104,
		101,
		114,
		102,
		83,
		108,
		112,
		93,
		114,
		109,
		-1,
		157,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		146,
		152,
		176,
		177,
		-1,
		149,
		137,
		138,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		87,
		85,
		115,
		90,
		112,
		109,
		128,
		133,
		127,
		136,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		180,
		-1,
		185,
		186,
		161,
		134,
		137,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		79,
		94,
		85,
		84,
		102,
		112,
		120,
		124,
		130,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		200,
		186,
		178,
		163,
		161,
		-1,
		133,
		130,
		120,
		98,
		83,
		100,
		92,
		90,
		92,
		74,
		88,
		79,
		97,
		104,
		102,
		106,
		126,
		138,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		135,
		148,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		85,
		70,
		67,
		85,
		88,
		95,
		99,
		115,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		118,
		115,
		103,
		90,
		75,
		76,
		84,
		96,
		75,
		69,
		66,
		86,
		112,
		90,
		101,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		114,
		93,
		84,
		73,
		71,
		84,
		76,
		84,
		64,
		62,
		81,
		93,
		84,
		92,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		127,
		110,
		91,
		80,
		72,
		61,
		72,
		80,
		78,
		60,
		69,
		75,
		99,
		80,
		86,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		100,
		85,
		80,
		77,
		64,
		63,
		77,
		77,
		67,
		62,
		69,
		104,
		104,
		70,
		90,
		93,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		87,
		83,
		68,
		72,
		74,
		77,
		65,
		71,
		72,
		54,
		78,
		-1,
		78,
		72,
		80,
		70,
		58,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		80,
		75,
		74,
		73,
		70,
		59,
		72,
		65,
		59,
		53,
		66,
		70,
		71,
		60,
		56,
		53,
		67,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		102,
		86,
		85,
		82,
		73,
		81,
		54,
		47,
		58,
		43,
		61,
		67,
		58,
		53,
		52,
		63,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		92,
		109,
		110,
		88,
		82,
		80,
		71,
		59,
		48,
		51,
		43,
		65,
		62,
		46,
		48,
		57,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		106,
		104,
		99,
		90,
		96,
		91,
		68,
		63,
		53,
		42,
		42,
		37,
		56,
		42,
		40,
		56,
		72,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		107,
		91,
		96,
		-1,
		88,
		-1,
		61,
		58,
		49,
		34,
		31,
		42,
		40,
		49,
		51,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		123,
		103,
		95,
		96,
		83,
		70,
		69,
		47,
		40,
		37,
		27,
		40,
		50,
		56,
		49,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		123,
		111,
		101,
		91,
		94,
		86,
		61,
		52,
		45,
		47,
		36,
		29,
		28,
		49,
		43,
		65,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		151,
		122,
		112,
		-1,
		-1,
		95,
		86,
		78,
		55,
		49,
		58,
		53,
		18,
		22,
		37,
		48,
		56,
		55,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		163,
		108,
		97,
		92,
		96,
		94,
		-1,
		68,
		66,
		50,
		32,
		39,
		13,
		7,
		16,
		27,
		43,
		60,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		120,
		114,
		85,
		78,
		82,
		-1,
		68,
		61,
		52,
		38,
		12,
		9,
		0,
		20,
		25,
		28,
		41,
		55,
		59,
		182,
		-1,
		159,
		-1,
		-1,
		-1,
		138,
		153,
		124,
		101,
		74,
		69,
		62,
		56,
		52,
		34,
		20,
		31,
		27,
		23,
		24,
		34,
		33,
		50,
		60,
		-1,
		-1,
		157,
		153,
		164,
		146,
		150,
		151,
		-1,
		-1,
		78,
		69,
		60,
		51,
		41,
		38,
		33,
		30,
		35,
		40,
		28,
		43,
		58,
		65,
		-1,
		-1,
		-1,
		169,
		-1,
		171,
		-1,
		-1,
		159,
		149,
		96,
		78,
		74,
		72,
		63,
		57,
		45,
		38,
		48,
		58,
		50,
		30,
		51,
		68,
		63,
		97,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		148,
		140,
		135,
		141,
		143,
		134,
		111,
		108,
		-1,
		78,
		86,
		51,
		58,
		50,
		56,
		56,
		54,
		35,
		48,
		64,
		63,
		58,
		89,
		84,
		91,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		141,
		137,
		127,
		117,
		120,
		-1,
		-1,
		114,
		111,
		83,
		60,
		66,
		59,
		54,
		70,
		50,
		37,
		41,
		45,
		51,
		56,
		61,
		67,
		82,
		97,
		-1,
		188,
		225,
		218,
		186,
		194,
		225,
		-1,
		131,
		123,
		134,
		109,
		111,
		-1,
		-1,
		87,
		78,
		79,
		67,
		64,
		77,
		75,
		66,
		51,
		57,
		44,
		43,
		61,
		65,
		74,
		81,
		71,
		84,
		88,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		128,
		-1,
		-1,
		140,
		112,
		96,
		86,
		83,
		126,
		81,
		76,
		74,
		72,
		63,
		54,
		61,
		52,
		52,
		55,
		70,
		75,
		67,
		81,
		81,
		82,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		156,
		-1,
		123,
		-1,
		106,
		110,
		89,
		92,
		88,
		75,
		67,
		59,
		75,
		50,
		60,
		56,
		57,
		66,
		77,
		89,
		88,
		89,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		140,
		179,
		187,
		-1,
		165,
		-1,
		-1,
		-1,
		120,
		102,
		94,
		108,
		87,
		87,
		61,
		65,
		55,
		62,
		72,
		74,
		66,
		70,
		83,
		94,
		97,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		155,
		146,
		173,
		194,
		183,
		178,
		165,
		-1,
		-1,
		143,
		112,
		-1,
		-1,
		94,
		82,
		65,
		66,
		62,
		65,
		80,
		83,
		73,
		71,
		65,
		97,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		174,
		164,
		168,
		184,
		209,
		-1,
		154,
		-1,
		-1,
		139,
		-1,
		-1,
		124,
		87,
		76,
		67,
		73,
		70,
		81,
		91,
		79,
		80,
		70,
		80,
		93,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		170,
		150,
		-1,
		-1,
		122,
		120,
		109,
		-1,
		99,
		72,
		77,
		97,
		99,
		88,
		82,
		76,
		83,
		82,
		90,
		98,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		117,
		110,
		98,
		86,
		76,
		86,
		90,
		94,
		86,
		79,
		74,
		85,
		77,
		81,
		98,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		151,
		135,
		116,
		-1,
		86,
		99,
		130,
		98,
		103,
		98,
		80,
		91,
		80,
		83,
		97,
		92,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		167,
		169,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		123,
		119,
		-1,
		-1,
		87,
		112,
		101,
		109,
		104,
		84,
		90,
		93,
		82,
		86,
		98,
		-1,
		-1,
		158,
		159,
		164,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		125,
		88,
		109,
		119,
		113,
		111,
		102,
		88,
		95,
		93,
		89,
		100,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		87,
		89,
		115,
		118,
		124,
		118,
		91,
		106,
		96,
		87,
		96,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		91,
		-1,
		119,
		109,
		140,
		125,
		106,
		93,
		100,
		100,
		93,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		99,
		90,
		98,
		130,
		126,
		113,
		113,
		105,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		102,
		100,
		97,
		109,
		105,
		125,
		106,
		141,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		128,
		112,
		110,
		113,
		114,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		121,
		117,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		175,
		164,
		175,
		183,
		156,
		163,
		-1,
		182,
		186,
		152,
		146,
		185,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		175,
		174,
		142,
		140,
		149,
		154,
		161,
		-1,
		160,
		-1,
		196,
		175,
		186,
		191,
		135,
		132,
		152,
		171,
		153,
		145,
		211,
		165,
		136,
		130,
		148,
		138,
		147,
		139,
		-1,
		136,
		126,
		148,
		127,
		138,
		130,
		-1,
		-1,
		130,
		131,
		137,
		123,
		129,
		125,
		-1,
		135,
		119,
		-1,
		-1,
		120,
		121,
		105,
		108,
		116,
		114,
		127,
		119,
		114,
		-1,
		-1,
		111,
		107,
		114,
		101,
		97,
		114,
		127,
		109,
		123,
		122,
		-1,
		117,
		135,
		140,
		108,
		106,
		90,
		88,
		106,
		108,
		114,
		114,
		-1,
		126,
		127,
		122,
		130,
		130,
		106,
		93,
		93,
		103,
		96,
		115,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		109,
		126,
		118,
		108,
		123,
		116,
		96,
		93,
		91,
		88,
		104,
		102,
		112,
		-1,
		-1,
		217,
		186,
		217,
		175,
		156,
		-1,
		122,
		102,
		108,
		112,
		106,
		99,
		113,
		109,
		-1,
		82,
		81,
		109,
		95,
		106,
		177,
		-1,
		-1,
		175,
		167,
		152,
		155,
		132,
		128,
		117,
		116,
		108,
		94,
		90,
		96,
		99,
		99,
		105,
		76,
		86,
		90,
		88,
		113,
		-1,
		-1,
		148,
		-1,
		-1,
		174,
		157,
		-1,
		140,
		147,
		138,
		144,
		130,
		151,
		127,
		118,
		110,
		104,
		92,
		94,
		91,
		104,
		92,
		73,
		98,
		102,
		83,
		104,
		99,
		-1,
		147,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		136,
		142,
		166,
		167,
		-1,
		139,
		127,
		128,
		113,
		110,
		97,
		85,
		98,
		83,
		90,
		89,
		77,
		75,
		105,
		80,
		102,
		99,
		118,
		123,
		117,
		126,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		170,
		-1,
		175,
		176,
		151,
		124,
		127,
		114,
		105,
		92,
		81,
		92,
		81,
		78,
		86,
		69,
		84,
		75,
		74,
		92,
		102,
		110,
		114,
		120,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		190,
		176,
		168,
		153,
		151,
		-1,
		123,
		120,
		110,
		88,
		73,
		90,
		82,
		80,
		82,
		64,
		78,
		69,
		87,
		94,
		92,
		96,
		116,
		128,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		125,
		138,
		-1,
		94,
		90,
		72,
		73,
		68,
		83,
		75,
		60,
		57,
		75,
		78,
		85,
		89,
		105,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		108,
		105,
		93,
		80,
		65,
		66,
		74,
		86,
		65,
		59,
		56,
		76,
		102,
		80,
		91,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		104,
		83,
		74,
		63,
		61,
		74,
		66,
		74,
		54,
		52,
		71,
		83,
		74,
		82,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		117,
		100,
		81,
		70,
		62,
		51,
		62,
		70,
		68,
		50,
		59,
		65,
		89,
		70,
		76,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		90,
		75,
		70,
		67,
		54,
		53,
		67,
		67,
		57,
		52,
		59,
		94,
		94,
		60,
		80,
		83,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		77,
		73,
		58,
		62,
		64,
		67,
		55,
		61,
		62,
		44,
		68,
		-1,
		68,
		62,
		70,
		60,
		48,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		70,
		65,
		64,
		63,
		60,
		49,
		62,
		55,
		49,
		43,
		56,
		60,
		61,
		50,
		46,
		43,
		57,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		92,
		76,
		75,
		72,
		63,
		71,
		44,
		37,
		48,
		33,
		51,
		57,
		48,
		43,
		42,
		53,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		82,
		99,
		100,
		78,
		72,
		70,
		61,
		49,
		38,
		41,
		33,
		55,
		52,
		36,
		38,
		47,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		96,
		94,
		89,
		80,
		86,
		81,
		58,
		53,
		43,
		32,
		32,
		27,
		46,
		32,
		30,
		45,
		61,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		89,
		81,
		86,
		-1,
		78,
		-1,
		51,
		48,
		39,
		24,
		21,
		32,
		30,
		39,
		40,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		105,
		85,
		77,
		86,
		73,
		65,
		59,
		37,
		30,
		27,
		17,
		30,
		40,
		46,
		38,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		105,
		93,
		83,
		73,
		78,
		79,
		56,
		49,
		35,
		37,
		26,
		19,
		18,
		39,
		32,
		54,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		133,
		112,
		94,
		-1,
		-1,
		77,
		70,
		64,
		52,
		39,
		48,
		43,
		25,
		12,
		27,
		37,
		45,
		44,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		145,
		90,
		79,
		74,
		78,
		76,
		-1,
		50,
		61,
		43,
		50,
		57,
		27,
		12,
		6,
		17,
		32,
		49,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		102,
		96,
		67,
		60,
		64,
		-1,
		52,
		54,
		45,
		56,
		30,
		27,
		18,
		0,
		14,
		17,
		30,
		44,
		48,
		172,
		-1,
		139,
		-1,
		-1,
		-1,
		120,
		135,
		106,
		83,
		56,
		51,
		44,
		38,
		43,
		52,
		38,
		49,
		7,
		3,
		13,
		23,
		22,
		39,
		49,
		-1,
		-1,
		137,
		133,
		146,
		128,
		132,
		133,
		-1,
		-1,
		60,
		51,
		42,
		34,
		47,
		50,
		13,
		10,
		15,
		29,
		17,
		32,
		47,
		54,
		-1,
		-1,
		-1,
		149,
		-1,
		151,
		-1,
		-1,
		139,
		131,
		78,
		60,
		56,
		54,
		43,
		37,
		25,
		18,
		28,
		38,
		32,
		19,
		41,
		57,
		53,
		86,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		128,
		120,
		115,
		121,
		123,
		114,
		93,
		90,
		-1,
		60,
		66,
		31,
		38,
		30,
		36,
		36,
		36,
		24,
		38,
		54,
		53,
		48,
		78,
		73,
		81,
		-1,
		-1,
		214,
		203,
		192,
		198,
		-1,
		121,
		117,
		107,
		97,
		100,
		-1,
		-1,
		94,
		91,
		63,
		40,
		46,
		39,
		34,
		60,
		40,
		27,
		31,
		35,
		41,
		46,
		51,
		57,
		72,
		87,
		-1,
		168,
		205,
		198,
		166,
		174,
		205,
		-1,
		111,
		103,
		114,
		89,
		91,
		-1,
		-1,
		67,
		58,
		59,
		47,
		44,
		57,
		56,
		56,
		41,
		47,
		34,
		33,
		51,
		55,
		64,
		71,
		61,
		74,
		78,
		-1,
		161,
		181,
		160,
		163,
		187,
		201,
		-1,
		108,
		-1,
		-1,
		120,
		92,
		76,
		66,
		63,
		106,
		61,
		56,
		58,
		60,
		53,
		44,
		51,
		42,
		42,
		45,
		60,
		65,
		57,
		71,
		71,
		72,
		-1,
		150,
		161,
		154,
		-1,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		136,
		-1,
		103,
		-1,
		86,
		90,
		69,
		72,
		78,
		65,
		57,
		49,
		65,
		40,
		50,
		46,
		47,
		56,
		67,
		79,
		78,
		79,
		175,
		131,
		134,
		145,
		156,
		171,
		175,
		-1,
		120,
		159,
		174,
		-1,
		145,
		-1,
		-1,
		-1,
		100,
		82,
		74,
		90,
		77,
		77,
		51,
		55,
		45,
		52,
		62,
		64,
		56,
		60,
		73,
		84,
		87,
		171,
		162,
		175,
		120,
		120,
		141,
		150,
		171,
		135,
		126,
		153,
		174,
		170,
		165,
		152,
		-1,
		-1,
		123,
		92,
		-1,
		-1,
		84,
		72,
		55,
		56,
		52,
		55,
		70,
		73,
		63,
		61,
		55,
		87,
		-1,
		164,
		163,
		152,
		149,
		125,
		116,
		111,
		138,
		-1,
		-1,
		133,
		154,
		144,
		148,
		164,
		189,
		-1,
		144,
		-1,
		-1,
		129,
		-1,
		-1,
		114,
		77,
		66,
		57,
		63,
		60,
		71,
		81,
		69,
		70,
		60,
		70,
		83,
		148,
		145,
		133,
		131,
		154,
		119,
		107,
		-1,
		120,
		118,
		124,
		131,
		148,
		178,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		62,
		67,
		87,
		89,
		78,
		72,
		66,
		73,
		72,
		80,
		88,
		157,
		171,
		160,
		156,
		155,
		163,
		112,
		105,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		76,
		80,
		84,
		76,
		69,
		64,
		75,
		67,
		71,
		88,
		-1,
		191,
		-1,
		143,
		119,
		133,
		148,
		156,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		120,
		88,
		93,
		88,
		70,
		81,
		70,
		73,
		87,
		82,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		156,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		102,
		91,
		99,
		94,
		74,
		80,
		83,
		72,
		76,
		88,
		-1,
		-1,
		138,
		139,
		144,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		115,
		78,
		99,
		109,
		103,
		101,
		92,
		78,
		85,
		83,
		79,
		90,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		102,
		-1,
		77,
		79,
		105,
		108,
		114,
		108,
		81,
		96,
		86,
		77,
		86,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		99,
		81,
		-1,
		109,
		99,
		130,
		115,
		96,
		83,
		90,
		90,
		83,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		89,
		89,
		80,
		88,
		120,
		116,
		103,
		103,
		95,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		84,
		92,
		90,
		87,
		99,
		95,
		115,
		96,
		131,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		118,
		102,
		100,
		103,
		104,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		111,
		107,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		188,
		192,
		158,
		152,
		191,
		160,
		166,
		177,
		-1,
		-1,
		-1,
		181,
		180,
		148,
		146,
		155,
		160,
		167,
		-1,
		166,
		-1,
		202,
		181,
		192,
		197,
		141,
		138,
		158,
		177,
		159,
		151,
		217,
		171,
		142,
		136,
		154,
		144,
		153,
		145,
		-1,
		142,
		132,
		154,
		133,
		144,
		136,
		-1,
		-1,
		136,
		137,
		143,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		126,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		128,
		-1,
		123,
		141,
		146,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		120,
		-1,
		132,
		133,
		128,
		136,
		136,
		112,
		99,
		99,
		109,
		102,
		121,
		109,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		115,
		132,
		124,
		114,
		129,
		122,
		102,
		99,
		97,
		94,
		110,
		108,
		118,
		-1,
		-1,
		223,
		192,
		223,
		181,
		162,
		-1,
		128,
		108,
		114,
		118,
		112,
		105,
		119,
		115,
		-1,
		88,
		87,
		115,
		101,
		112,
		183,
		-1,
		-1,
		181,
		173,
		158,
		161,
		138,
		134,
		123,
		122,
		114,
		100,
		96,
		102,
		105,
		105,
		111,
		82,
		92,
		96,
		94,
		119,
		-1,
		-1,
		154,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		144,
		150,
		136,
		157,
		133,
		124,
		116,
		110,
		98,
		100,
		97,
		110,
		98,
		79,
		104,
		108,
		89,
		110,
		105,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		173,
		-1,
		145,
		133,
		134,
		119,
		116,
		103,
		91,
		104,
		89,
		96,
		95,
		83,
		81,
		111,
		86,
		108,
		105,
		124,
		129,
		123,
		132,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		181,
		182,
		157,
		130,
		133,
		120,
		111,
		98,
		87,
		98,
		87,
		84,
		92,
		75,
		90,
		81,
		80,
		98,
		108,
		116,
		120,
		126,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		182,
		174,
		159,
		157,
		-1,
		129,
		126,
		116,
		94,
		79,
		96,
		88,
		86,
		88,
		70,
		84,
		75,
		93,
		100,
		98,
		102,
		122,
		134,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		131,
		144,
		-1,
		100,
		96,
		78,
		79,
		74,
		89,
		81,
		66,
		63,
		81,
		84,
		91,
		95,
		111,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		114,
		111,
		99,
		86,
		71,
		72,
		80,
		92,
		71,
		65,
		62,
		82,
		108,
		86,
		97,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		110,
		89,
		80,
		69,
		67,
		80,
		72,
		80,
		60,
		58,
		77,
		89,
		80,
		88,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		123,
		106,
		87,
		76,
		68,
		57,
		68,
		76,
		74,
		56,
		65,
		71,
		95,
		76,
		82,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		96,
		81,
		76,
		73,
		60,
		59,
		73,
		73,
		63,
		58,
		65,
		100,
		100,
		66,
		86,
		89,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		83,
		79,
		64,
		68,
		70,
		73,
		61,
		67,
		68,
		50,
		74,
		-1,
		74,
		68,
		76,
		66,
		54,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		76,
		71,
		70,
		69,
		66,
		55,
		68,
		61,
		55,
		49,
		62,
		66,
		67,
		56,
		52,
		49,
		63,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		98,
		82,
		81,
		78,
		69,
		77,
		50,
		43,
		54,
		39,
		57,
		63,
		54,
		49,
		48,
		59,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		88,
		105,
		106,
		84,
		78,
		76,
		67,
		55,
		44,
		47,
		39,
		61,
		58,
		42,
		44,
		45,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		102,
		100,
		95,
		86,
		92,
		87,
		64,
		59,
		49,
		38,
		38,
		33,
		52,
		38,
		36,
		43,
		59,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		101,
		87,
		92,
		-1,
		84,
		-1,
		57,
		54,
		45,
		30,
		27,
		38,
		36,
		45,
		38,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		117,
		97,
		89,
		92,
		79,
		71,
		65,
		43,
		36,
		33,
		23,
		36,
		46,
		52,
		36,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		117,
		105,
		95,
		85,
		90,
		87,
		62,
		55,
		41,
		43,
		32,
		25,
		24,
		38,
		30,
		52,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		145,
		118,
		106,
		-1,
		-1,
		89,
		82,
		76,
		58,
		45,
		54,
		49,
		31,
		18,
		33,
		35,
		43,
		42,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		157,
		102,
		91,
		86,
		90,
		88,
		-1,
		62,
		69,
		49,
		56,
		63,
		33,
		18,
		12,
		18,
		30,
		47,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		79,
		72,
		76,
		-1,
		64,
		65,
		51,
		62,
		36,
		33,
		24,
		12,
		0,
		15,
		28,
		42,
		46,
		178,
		-1,
		151,
		-1,
		-1,
		-1,
		132,
		147,
		118,
		95,
		68,
		63,
		56,
		50,
		55,
		58,
		44,
		55,
		19,
		15,
		4,
		17,
		20,
		37,
		47,
		-1,
		-1,
		149,
		145,
		158,
		140,
		144,
		145,
		-1,
		-1,
		72,
		63,
		54,
		46,
		59,
		62,
		25,
		22,
		26,
		20,
		8,
		23,
		38,
		52,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		151,
		143,
		90,
		72,
		68,
		66,
		55,
		49,
		37,
		30,
		40,
		38,
		30,
		10,
		32,
		48,
		44,
		83,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		135,
		126,
		105,
		102,
		-1,
		72,
		78,
		43,
		50,
		42,
		45,
		42,
		34,
		15,
		29,
		45,
		44,
		39,
		75,
		66,
		72,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		133,
		129,
		119,
		109,
		112,
		-1,
		-1,
		106,
		103,
		75,
		52,
		55,
		48,
		43,
		53,
		33,
		20,
		22,
		26,
		32,
		37,
		42,
		48,
		63,
		78,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		123,
		115,
		126,
		101,
		103,
		-1,
		-1,
		79,
		70,
		71,
		59,
		56,
		63,
		58,
		49,
		34,
		40,
		27,
		24,
		42,
		46,
		55,
		62,
		52,
		65,
		69,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		120,
		-1,
		-1,
		132,
		104,
		88,
		78,
		75,
		118,
		73,
		68,
		57,
		55,
		46,
		37,
		44,
		35,
		33,
		36,
		53,
		58,
		50,
		62,
		62,
		63,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		115,
		-1,
		98,
		102,
		81,
		84,
		71,
		58,
		50,
		42,
		58,
		33,
		41,
		37,
		40,
		49,
		60,
		72,
		69,
		70,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		132,
		171,
		170,
		-1,
		154,
		-1,
		-1,
		-1,
		112,
		94,
		86,
		91,
		70,
		70,
		44,
		48,
		38,
		45,
		53,
		55,
		49,
		53,
		66,
		77,
		78,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		147,
		138,
		165,
		177,
		166,
		161,
		148,
		-1,
		-1,
		135,
		104,
		-1,
		-1,
		77,
		65,
		48,
		49,
		45,
		48,
		63,
		64,
		56,
		54,
		48,
		80,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		166,
		156,
		160,
		176,
		201,
		-1,
		137,
		-1,
		-1,
		122,
		-1,
		-1,
		107,
		70,
		59,
		50,
		56,
		53,
		64,
		74,
		62,
		63,
		53,
		63,
		76,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		132,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		153,
		133,
		-1,
		-1,
		105,
		103,
		92,
		-1,
		82,
		55,
		60,
		80,
		82,
		71,
		65,
		59,
		66,
		65,
		73,
		81,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		143,
		139,
		-1,
		-1,
		100,
		93,
		81,
		69,
		59,
		69,
		73,
		77,
		69,
		62,
		57,
		68,
		60,
		64,
		81,
		-1,
		203,
		-1,
		155,
		131,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		160,
		146,
		139,
		127,
		125,
		-1,
		134,
		118,
		99,
		-1,
		69,
		82,
		113,
		81,
		86,
		81,
		63,
		74,
		63,
		66,
		80,
		75,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		150,
		152,
		-1,
		151,
		140,
		125,
		117,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		70,
		95,
		84,
		92,
		87,
		67,
		73,
		76,
		65,
		69,
		81,
		-1,
		-1,
		150,
		151,
		156,
		-1,
		135,
		-1,
		153,
		-1,
		120,
		126,
		114,
		-1,
		-1,
		-1,
		108,
		71,
		92,
		102,
		96,
		94,
		85,
		71,
		78,
		76,
		72,
		83,
		-1,
		-1,
		-1,
		153,
		127,
		160,
		151,
		134,
		114,
		106,
		125,
		-1,
		95,
		-1,
		70,
		72,
		98,
		101,
		107,
		101,
		74,
		89,
		79,
		70,
		79,
		159,
		-1,
		129,
		162,
		126,
		120,
		96,
		100,
		116,
		-1,
		92,
		74,
		-1,
		102,
		92,
		123,
		108,
		89,
		76,
		83,
		83,
		76,
		-1,
		-1,
		-1,
		131,
		130,
		122,
		116,
		116,
		101,
		92,
		-1,
		104,
		86,
		65,
		82,
		82,
		73,
		81,
		113,
		109,
		96,
		96,
		88,
		-1,
		232,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		125,
		120,
		93,
		81,
		87,
		83,
		69,
		75,
		77,
		85,
		83,
		80,
		92,
		88,
		108,
		89,
		124,
		-1,
		227,
		-1,
		161,
		-1,
		-1,
		143,
		123,
		115,
		104,
		93,
		91,
		82,
		73,
		95,
		111,
		95,
		93,
		96,
		97,
		-1,
		216,
		215,
		-1,
		162,
		154,
		140,
		-1,
		133,
		-1,
		139,
		100,
		-1,
		102,
		82,
		-1,
		104,
		100,
		-1,
		-1,
		203,
		178,
		-1,
		-1,
		-1,
		163,
		143,
		134,
		118,
		-1,
		93,
		93,
		-1,
		-1,
		-1,
		188,
		187,
		-1,
		156,
		159,
		-1,
		149,
		140,
		148,
		95,
		99,
		-1,
		-1,
		-1,
		197,
		178,
		172,
		171,
		169,
		164,
		161,
		147,
		131,
		109,
		98,
		119,
		-1,
		-1,
		-1,
		169,
		161,
		154,
		-1,
		-1,
		156,
		139,
		120,
		118,
		-1,
		-1,
		-1,
		191,
		172,
		-1,
		-1,
		146,
		-1,
		-1,
		152,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		180,
		-1,
		-1,
		-1,
		142,
		138,
		139,
		-1,
		-1,
		-1,
		-1,
		202,
		203,
		226,
		190,
		-1,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		205,
		203,
		-1,
		-1,
		-1,
		162,
		146,
		-1,
		132,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		167,
		-1,
		167,
		142,
		149,
		-1,
		-1,
		-1,
		-1,
		180,
		172,
		180,
		-1,
		152,
		154,
		-1,
		202,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		157,
		164,
		186,
		189,
		225,
		-1,
		176
	],
	[
		-1,
		175,
		164,
		175,
		183,
		156,
		163,
		-1,
		182,
		186,
		152,
		146,
		185,
		154,
		160,
		171,
		-1,
		-1,
		-1,
		175,
		174,
		142,
		140,
		149,
		154,
		161,
		-1,
		160,
		-1,
		196,
		175,
		186,
		191,
		135,
		132,
		152,
		171,
		153,
		145,
		211,
		165,
		136,
		130,
		148,
		138,
		147,
		139,
		-1,
		136,
		126,
		148,
		127,
		138,
		130,
		-1,
		-1,
		130,
		131,
		137,
		123,
		129,
		125,
		-1,
		135,
		119,
		-1,
		-1,
		120,
		121,
		105,
		108,
		116,
		114,
		127,
		119,
		114,
		-1,
		-1,
		111,
		107,
		114,
		101,
		97,
		114,
		127,
		109,
		123,
		122,
		-1,
		117,
		135,
		140,
		108,
		106,
		90,
		88,
		106,
		108,
		114,
		114,
		-1,
		126,
		127,
		122,
		130,
		130,
		106,
		93,
		93,
		103,
		96,
		115,
		103,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		126,
		109,
		126,
		118,
		108,
		123,
		116,
		96,
		93,
		91,
		88,
		104,
		102,
		112,
		-1,
		-1,
		217,
		186,
		217,
		175,
		156,
		-1,
		122,
		102,
		108,
		112,
		106,
		99,
		113,
		109,
		-1,
		82,
		81,
		109,
		95,
		106,
		177,
		-1,
		-1,
		175,
		167,
		152,
		155,
		132,
		128,
		117,
		116,
		108,
		94,
		90,
		96,
		99,
		99,
		105,
		76,
		86,
		90,
		88,
		113,
		-1,
		-1,
		146,
		-1,
		-1,
		174,
		157,
		-1,
		140,
		147,
		138,
		144,
		130,
		151,
		127,
		118,
		110,
		104,
		92,
		94,
		91,
		104,
		92,
		73,
		98,
		102,
		83,
		104,
		99,
		-1,
		145,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		136,
		142,
		166,
		167,
		-1,
		139,
		127,
		128,
		113,
		110,
		97,
		85,
		98,
		83,
		90,
		89,
		77,
		75,
		105,
		80,
		102,
		99,
		116,
		121,
		115,
		124,
		-1,
		182,
		178,
		174,
		181,
		130,
		-1,
		-1,
		170,
		-1,
		175,
		176,
		151,
		124,
		127,
		114,
		105,
		92,
		81,
		92,
		81,
		78,
		86,
		69,
		84,
		75,
		74,
		92,
		100,
		108,
		112,
		118,
		-1,
		232,
		-1,
		174,
		158,
		160,
		132,
		153,
		-1,
		190,
		176,
		168,
		153,
		151,
		-1,
		123,
		120,
		110,
		88,
		73,
		90,
		82,
		80,
		82,
		64,
		78,
		69,
		87,
		94,
		90,
		94,
		114,
		126,
		192,
		182,
		-1,
		164,
		169,
		128,
		136,
		155,
		193,
		157,
		-1,
		152,
		-1,
		125,
		138,
		-1,
		94,
		90,
		72,
		73,
		68,
		83,
		75,
		60,
		57,
		75,
		78,
		83,
		87,
		103,
		-1,
		-1,
		177,
		181,
		170,
		121,
		140,
		164,
		201,
		150,
		139,
		138,
		-1,
		129,
		108,
		105,
		93,
		80,
		65,
		66,
		74,
		86,
		65,
		59,
		56,
		76,
		100,
		78,
		89,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		147,
		118,
		142,
		184,
		168,
		161,
		149,
		114,
		114,
		108,
		-1,
		104,
		83,
		74,
		63,
		61,
		74,
		66,
		74,
		54,
		52,
		71,
		81,
		72,
		80,
		-1,
		-1,
		-1,
		177,
		166,
		167,
		113,
		136,
		173,
		147,
		133,
		138,
		113,
		106,
		100,
		117,
		100,
		81,
		70,
		62,
		51,
		62,
		70,
		68,
		50,
		59,
		65,
		87,
		68,
		74,
		-1,
		-1,
		184,
		174,
		158,
		160,
		157,
		127,
		134,
		166,
		138,
		151,
		-1,
		105,
		-1,
		94,
		90,
		75,
		70,
		67,
		54,
		53,
		67,
		67,
		57,
		52,
		59,
		92,
		92,
		58,
		77,
		80,
		-1,
		-1,
		-1,
		177,
		172,
		147,
		124,
		108,
		144,
		-1,
		121,
		122,
		-1,
		99,
		93,
		90,
		77,
		73,
		58,
		62,
		64,
		67,
		55,
		61,
		62,
		44,
		68,
		-1,
		66,
		60,
		67,
		57,
		46,
		-1,
		-1,
		-1,
		170,
		149,
		142,
		162,
		103,
		155,
		-1,
		-1,
		106,
		99,
		-1,
		86,
		68,
		70,
		65,
		64,
		63,
		60,
		49,
		62,
		55,
		49,
		43,
		56,
		60,
		61,
		48,
		44,
		41,
		55,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		123,
		-1,
		115,
		107,
		97,
		91,
		85,
		81,
		79,
		92,
		76,
		75,
		72,
		63,
		71,
		44,
		37,
		48,
		33,
		51,
		57,
		48,
		42,
		34,
		51,
		-1,
		190,
		176,
		147,
		-1,
		-1,
		136,
		-1,
		100,
		114,
		130,
		-1,
		123,
		102,
		117,
		95,
		91,
		82,
		99,
		100,
		78,
		72,
		70,
		61,
		49,
		38,
		41,
		33,
		55,
		52,
		36,
		37,
		30,
		-1,
		196,
		183,
		141,
		137,
		126,
		146,
		97,
		85,
		117,
		-1,
		-1,
		159,
		-1,
		93,
		110,
		96,
		94,
		89,
		80,
		86,
		81,
		58,
		53,
		43,
		32,
		32,
		27,
		46,
		32,
		30,
		28,
		44,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		112,
		99,
		93,
		-1,
		134,
		-1,
		137,
		127,
		111,
		96,
		129,
		-1,
		97,
		81,
		86,
		-1,
		78,
		-1,
		51,
		48,
		39,
		24,
		21,
		32,
		30,
		39,
		23,
		-1,
		146,
		131,
		124,
		114,
		128,
		99,
		-1,
		154,
		-1,
		-1,
		124,
		118,
		118,
		102,
		105,
		113,
		93,
		87,
		86,
		73,
		65,
		59,
		37,
		30,
		27,
		17,
		30,
		40,
		37,
		21,
		-1,
		-1,
		-1,
		151,
		137,
		141,
		101,
		120,
		-1,
		-1,
		186,
		141,
		127,
		-1,
		111,
		119,
		107,
		97,
		87,
		91,
		81,
		56,
		49,
		35,
		37,
		29,
		19,
		18,
		23,
		15,
		37,
		-1,
		-1,
		134,
		139,
		127,
		113,
		132,
		-1,
		-1,
		-1,
		133,
		149,
		141,
		112,
		108,
		-1,
		-1,
		91,
		83,
		73,
		52,
		39,
		48,
		43,
		28,
		12,
		27,
		20,
		28,
		27,
		-1,
		137,
		124,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		159,
		104,
		93,
		88,
		92,
		90,
		-1,
		64,
		63,
		43,
		55,
		62,
		30,
		18,
		12,
		3,
		15,
		32,
		-1,
		-1,
		149,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		81,
		74,
		78,
		-1,
		66,
		59,
		45,
		61,
		36,
		33,
		24,
		14,
		14,
		0,
		13,
		27,
		31,
		172,
		-1,
		153,
		-1,
		-1,
		-1,
		134,
		149,
		120,
		97,
		70,
		65,
		58,
		52,
		53,
		58,
		44,
		55,
		21,
		17,
		13,
		6,
		5,
		22,
		32,
		-1,
		-1,
		151,
		147,
		160,
		142,
		146,
		147,
		-1,
		-1,
		74,
		65,
		56,
		48,
		61,
		62,
		27,
		24,
		29,
		23,
		16,
		15,
		33,
		37,
		-1,
		-1,
		-1,
		163,
		-1,
		165,
		-1,
		-1,
		153,
		145,
		92,
		74,
		70,
		68,
		57,
		51,
		39,
		32,
		42,
		41,
		33,
		13,
		31,
		43,
		45,
		69,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		142,
		134,
		129,
		135,
		137,
		128,
		107,
		104,
		-1,
		74,
		80,
		45,
		52,
		44,
		48,
		45,
		37,
		18,
		32,
		48,
		47,
		42,
		61,
		56,
		65,
		-1,
		-1,
		228,
		217,
		206,
		212,
		-1,
		135,
		131,
		121,
		111,
		114,
		-1,
		-1,
		108,
		105,
		77,
		54,
		57,
		50,
		45,
		55,
		35,
		22,
		25,
		29,
		35,
		40,
		45,
		51,
		63,
		71,
		-1,
		182,
		219,
		212,
		180,
		188,
		219,
		-1,
		125,
		117,
		128,
		103,
		105,
		-1,
		-1,
		81,
		72,
		73,
		61,
		58,
		65,
		60,
		51,
		36,
		42,
		29,
		27,
		45,
		49,
		58,
		65,
		55,
		68,
		72,
		-1,
		175,
		195,
		174,
		177,
		201,
		215,
		-1,
		122,
		-1,
		-1,
		134,
		106,
		90,
		80,
		77,
		120,
		75,
		70,
		59,
		57,
		48,
		39,
		46,
		37,
		36,
		39,
		55,
		60,
		52,
		65,
		65,
		66,
		-1,
		164,
		175,
		168,
		-1,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		150,
		-1,
		117,
		-1,
		100,
		104,
		83,
		86,
		73,
		60,
		52,
		44,
		60,
		35,
		44,
		40,
		42,
		51,
		62,
		74,
		72,
		73,
		189,
		145,
		148,
		159,
		170,
		185,
		189,
		-1,
		134,
		173,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		114,
		96,
		88,
		93,
		72,
		72,
		46,
		50,
		40,
		47,
		56,
		58,
		51,
		55,
		68,
		79,
		81,
		185,
		176,
		189,
		134,
		134,
		155,
		164,
		185,
		149,
		140,
		167,
		179,
		168,
		163,
		150,
		-1,
		-1,
		137,
		106,
		-1,
		-1,
		79,
		67,
		50,
		51,
		47,
		50,
		65,
		67,
		58,
		56,
		50,
		82,
		-1,
		178,
		177,
		166,
		163,
		139,
		130,
		125,
		152,
		-1,
		-1,
		147,
		168,
		158,
		162,
		178,
		203,
		-1,
		139,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		72,
		61,
		52,
		58,
		55,
		66,
		76,
		64,
		65,
		55,
		65,
		78,
		162,
		159,
		147,
		145,
		168,
		133,
		121,
		-1,
		134,
		132,
		138,
		145,
		162,
		192,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		57,
		62,
		82,
		84,
		73,
		67,
		61,
		68,
		67,
		75,
		83,
		171,
		185,
		174,
		170,
		169,
		177,
		126,
		119,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		71,
		75,
		79,
		71,
		64,
		59,
		70,
		62,
		66,
		83,
		-1,
		205,
		-1,
		157,
		133,
		147,
		162,
		170,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		115,
		83,
		88,
		83,
		65,
		76,
		65,
		68,
		82,
		77,
		-1,
		-1,
		145,
		148,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		97,
		86,
		94,
		89,
		69,
		75,
		78,
		67,
		71,
		83,
		-1,
		-1,
		152,
		153,
		158,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		110,
		73,
		94,
		104,
		98,
		96,
		87,
		73,
		80,
		78,
		74,
		85,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		97,
		-1,
		72,
		74,
		100,
		103,
		109,
		103,
		76,
		91,
		81,
		72,
		81,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		94,
		76,
		-1,
		104,
		94,
		125,
		110,
		91,
		78,
		85,
		85,
		78,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		84,
		84,
		75,
		83,
		115,
		111,
		98,
		98,
		90,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		79,
		87,
		85,
		82,
		94,
		90,
		110,
		91,
		126,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		113,
		97,
		95,
		98,
		99,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		106,
		102,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		198,
		202,
		168,
		162,
		201,
		170,
		176,
		187,
		-1,
		-1,
		-1,
		191,
		190,
		158,
		156,
		165,
		170,
		177,
		-1,
		176,
		-1,
		212,
		191,
		202,
		207,
		151,
		148,
		168,
		187,
		169,
		161,
		227,
		181,
		152,
		146,
		164,
		154,
		163,
		155,
		-1,
		152,
		142,
		164,
		143,
		154,
		146,
		-1,
		-1,
		146,
		147,
		153,
		139,
		145,
		141,
		-1,
		151,
		135,
		-1,
		-1,
		136,
		137,
		121,
		124,
		132,
		130,
		143,
		135,
		130,
		-1,
		-1,
		127,
		123,
		130,
		117,
		113,
		130,
		143,
		125,
		139,
		138,
		-1,
		133,
		151,
		156,
		124,
		122,
		106,
		104,
		122,
		124,
		130,
		130,
		-1,
		142,
		143,
		138,
		146,
		146,
		122,
		109,
		109,
		119,
		112,
		131,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		125,
		142,
		134,
		124,
		139,
		132,
		112,
		109,
		107,
		104,
		120,
		118,
		128,
		-1,
		-1,
		233,
		202,
		233,
		191,
		172,
		-1,
		138,
		118,
		124,
		128,
		122,
		115,
		129,
		125,
		-1,
		98,
		97,
		125,
		111,
		122,
		193,
		-1,
		-1,
		191,
		183,
		168,
		171,
		148,
		144,
		133,
		132,
		124,
		110,
		106,
		112,
		115,
		115,
		121,
		92,
		102,
		106,
		104,
		129,
		-1,
		-1,
		160,
		-1,
		-1,
		190,
		173,
		-1,
		156,
		163,
		154,
		160,
		146,
		167,
		143,
		134,
		126,
		120,
		108,
		110,
		107,
		120,
		108,
		89,
		114,
		118,
		99,
		120,
		115,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		149,
		152,
		158,
		182,
		183,
		-1,
		155,
		143,
		144,
		129,
		126,
		113,
		101,
		114,
		99,
		106,
		105,
		93,
		91,
		121,
		96,
		118,
		115,
		130,
		135,
		129,
		138,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		186,
		-1,
		191,
		192,
		167,
		140,
		143,
		130,
		121,
		108,
		97,
		108,
		97,
		94,
		102,
		85,
		100,
		91,
		90,
		108,
		114,
		122,
		126,
		132,
		-1,
		248,
		-1,
		190,
		174,
		176,
		148,
		169,
		-1,
		206,
		192,
		184,
		169,
		167,
		-1,
		139,
		136,
		126,
		104,
		89,
		106,
		98,
		96,
		98,
		80,
		94,
		85,
		103,
		110,
		104,
		108,
		128,
		140,
		208,
		198,
		-1,
		180,
		185,
		144,
		152,
		171,
		209,
		173,
		-1,
		168,
		-1,
		141,
		154,
		-1,
		110,
		106,
		88,
		89,
		84,
		99,
		91,
		76,
		73,
		91,
		94,
		97,
		101,
		117,
		-1,
		-1,
		193,
		197,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		124,
		121,
		109,
		96,
		81,
		82,
		90,
		102,
		81,
		75,
		72,
		92,
		114,
		92,
		103,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		120,
		99,
		90,
		79,
		77,
		90,
		82,
		90,
		70,
		68,
		87,
		95,
		86,
		94,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		133,
		116,
		97,
		86,
		78,
		67,
		78,
		86,
		84,
		66,
		75,
		81,
		101,
		82,
		88,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		106,
		91,
		86,
		83,
		70,
		69,
		83,
		83,
		73,
		68,
		75,
		106,
		106,
		72,
		91,
		94,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		93,
		89,
		74,
		78,
		80,
		83,
		71,
		77,
		78,
		60,
		84,
		-1,
		80,
		74,
		81,
		71,
		60,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		86,
		81,
		80,
		79,
		76,
		65,
		78,
		71,
		65,
		59,
		72,
		76,
		77,
		62,
		58,
		55,
		69,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		108,
		92,
		91,
		88,
		79,
		87,
		60,
		53,
		64,
		49,
		67,
		73,
		64,
		56,
		48,
		65,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		98,
		115,
		116,
		94,
		88,
		86,
		77,
		65,
		54,
		57,
		49,
		71,
		68,
		52,
		51,
		44,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		112,
		110,
		105,
		96,
		102,
		97,
		74,
		69,
		59,
		48,
		48,
		43,
		62,
		48,
		46,
		42,
		58,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		113,
		97,
		102,
		-1,
		94,
		-1,
		67,
		64,
		55,
		40,
		37,
		48,
		46,
		55,
		37,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		129,
		109,
		103,
		102,
		89,
		81,
		75,
		53,
		46,
		43,
		33,
		46,
		56,
		51,
		35,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		135,
		123,
		113,
		103,
		107,
		97,
		72,
		65,
		51,
		53,
		45,
		35,
		34,
		29,
		29,
		40,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		157,
		128,
		124,
		-1,
		-1,
		107,
		99,
		89,
		68,
		55,
		64,
		59,
		44,
		28,
		41,
		21,
		30,
		19,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		175,
		120,
		109,
		104,
		108,
		106,
		-1,
		80,
		79,
		59,
		71,
		78,
		46,
		34,
		28,
		19,
		16,
		24,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		97,
		90,
		94,
		-1,
		82,
		75,
		61,
		77,
		52,
		49,
		40,
		30,
		30,
		16,
		0,
		22,
		24,
		188,
		-1,
		168,
		-1,
		-1,
		-1,
		150,
		165,
		136,
		113,
		86,
		81,
		74,
		68,
		69,
		74,
		60,
		71,
		37,
		33,
		29,
		16,
		12,
		19,
		27,
		-1,
		-1,
		166,
		162,
		176,
		158,
		162,
		163,
		-1,
		-1,
		90,
		81,
		72,
		64,
		77,
		78,
		43,
		40,
		40,
		33,
		26,
		21,
		34,
		30,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		168,
		161,
		108,
		90,
		86,
		84,
		73,
		67,
		55,
		48,
		58,
		51,
		43,
		23,
		41,
		44,
		38,
		64,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		123,
		120,
		-1,
		90,
		96,
		61,
		68,
		59,
		58,
		55,
		47,
		28,
		42,
		57,
		50,
		49,
		56,
		51,
		60,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		123,
		120,
		93,
		69,
		67,
		60,
		55,
		65,
		45,
		32,
		35,
		39,
		45,
		47,
		52,
		58,
		58,
		66,
		-1,
		197,
		234,
		227,
		195,
		203,
		234,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		96,
		87,
		88,
		76,
		73,
		75,
		70,
		61,
		46,
		52,
		39,
		37,
		55,
		59,
		65,
		72,
		61,
		74,
		78,
		-1,
		190,
		210,
		189,
		192,
		216,
		230,
		-1,
		137,
		-1,
		-1,
		149,
		121,
		105,
		95,
		92,
		135,
		90,
		85,
		69,
		67,
		58,
		49,
		56,
		47,
		46,
		49,
		65,
		70,
		62,
		71,
		71,
		72,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		165,
		-1,
		132,
		-1,
		115,
		119,
		98,
		101,
		83,
		70,
		62,
		54,
		70,
		45,
		54,
		50,
		52,
		61,
		72,
		84,
		78,
		79,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		149,
		188,
		182,
		-1,
		166,
		-1,
		-1,
		-1,
		129,
		111,
		103,
		103,
		82,
		82,
		56,
		60,
		50,
		57,
		66,
		68,
		61,
		65,
		78,
		88,
		87,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		164,
		155,
		182,
		189,
		178,
		173,
		160,
		-1,
		-1,
		152,
		121,
		-1,
		-1,
		89,
		77,
		60,
		61,
		57,
		60,
		75,
		77,
		68,
		66,
		60,
		92,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		183,
		173,
		177,
		193,
		218,
		-1,
		149,
		-1,
		-1,
		134,
		-1,
		-1,
		119,
		82,
		71,
		62,
		68,
		65,
		76,
		86,
		74,
		75,
		65,
		75,
		88,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		149,
		147,
		153,
		160,
		177,
		207,
		-1,
		-1,
		165,
		145,
		-1,
		-1,
		117,
		115,
		104,
		-1,
		94,
		67,
		72,
		92,
		94,
		83,
		77,
		71,
		78,
		77,
		85,
		93,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		155,
		151,
		-1,
		-1,
		112,
		105,
		93,
		81,
		71,
		81,
		85,
		89,
		81,
		74,
		69,
		80,
		72,
		76,
		93,
		-1,
		220,
		-1,
		172,
		148,
		162,
		177,
		185,
		-1,
		-1,
		-1,
		172,
		158,
		151,
		139,
		137,
		-1,
		146,
		130,
		111,
		-1,
		81,
		94,
		125,
		93,
		98,
		93,
		75,
		86,
		75,
		78,
		92,
		87,
		-1,
		-1,
		160,
		163,
		-1,
		-1,
		162,
		164,
		-1,
		163,
		152,
		137,
		129,
		-1,
		-1,
		118,
		114,
		-1,
		-1,
		82,
		107,
		96,
		104,
		99,
		79,
		85,
		88,
		77,
		81,
		93,
		-1,
		-1,
		167,
		168,
		169,
		-1,
		147,
		-1,
		165,
		-1,
		132,
		138,
		126,
		-1,
		-1,
		-1,
		120,
		83,
		104,
		114,
		108,
		106,
		97,
		83,
		90,
		88,
		84,
		95,
		-1,
		-1,
		-1,
		165,
		139,
		172,
		163,
		146,
		126,
		118,
		137,
		-1,
		107,
		-1,
		82,
		84,
		110,
		113,
		119,
		113,
		86,
		101,
		91,
		82,
		91,
		171,
		-1,
		141,
		174,
		138,
		132,
		108,
		112,
		128,
		-1,
		104,
		86,
		-1,
		114,
		104,
		135,
		120,
		101,
		88,
		95,
		95,
		88,
		-1,
		-1,
		-1,
		143,
		142,
		134,
		128,
		128,
		113,
		104,
		-1,
		116,
		98,
		77,
		94,
		94,
		85,
		93,
		125,
		121,
		108,
		108,
		100,
		-1,
		244,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		137,
		132,
		105,
		93,
		99,
		95,
		81,
		87,
		89,
		97,
		95,
		92,
		104,
		100,
		120,
		101,
		136,
		-1,
		239,
		-1,
		173,
		-1,
		-1,
		155,
		135,
		127,
		116,
		105,
		103,
		94,
		85,
		107,
		123,
		107,
		105,
		108,
		109,
		-1,
		228,
		227,
		-1,
		174,
		166,
		152,
		-1,
		145,
		-1,
		151,
		112,
		-1,
		114,
		94,
		-1,
		116,
		112,
		-1,
		-1,
		215,
		190,
		-1,
		-1,
		-1,
		175,
		155,
		146,
		130,
		-1,
		105,
		105,
		-1,
		-1,
		-1,
		200,
		199,
		-1,
		168,
		171,
		-1,
		161,
		152,
		160,
		107,
		111,
		-1,
		-1,
		-1,
		209,
		190,
		184,
		183,
		181,
		176,
		173,
		159,
		143,
		121,
		110,
		131,
		-1,
		-1,
		-1,
		181,
		173,
		166,
		-1,
		-1,
		168,
		151,
		132,
		130,
		-1,
		-1,
		-1,
		203,
		184,
		-1,
		-1,
		158,
		-1,
		-1,
		164,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		192,
		-1,
		-1,
		-1,
		154,
		150,
		151,
		-1,
		-1,
		-1,
		-1,
		214,
		215,
		238,
		202,
		-1,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		217,
		215,
		-1,
		-1,
		-1,
		174,
		158,
		-1,
		144,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		179,
		-1,
		179,
		154,
		161,
		-1,
		-1,
		-1,
		-1,
		192,
		184,
		192,
		-1,
		164,
		166,
		-1,
		214,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		169,
		176,
		198,
		201,
		237,
		-1,
		188
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		201,
		205,
		171,
		165,
		204,
		173,
		179,
		190,
		-1,
		-1,
		-1,
		194,
		193,
		161,
		159,
		168,
		173,
		180,
		-1,
		179,
		-1,
		215,
		194,
		205,
		210,
		154,
		151,
		171,
		190,
		172,
		164,
		230,
		184,
		155,
		149,
		167,
		157,
		166,
		158,
		-1,
		155,
		145,
		167,
		146,
		157,
		149,
		-1,
		-1,
		149,
		150,
		156,
		142,
		148,
		144,
		-1,
		154,
		138,
		-1,
		-1,
		139,
		140,
		124,
		127,
		135,
		133,
		146,
		138,
		133,
		-1,
		-1,
		130,
		126,
		133,
		120,
		116,
		133,
		146,
		128,
		142,
		141,
		-1,
		136,
		154,
		159,
		127,
		125,
		109,
		107,
		125,
		127,
		133,
		133,
		-1,
		145,
		146,
		141,
		149,
		149,
		125,
		112,
		112,
		122,
		115,
		134,
		122,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		128,
		145,
		137,
		127,
		142,
		135,
		115,
		112,
		110,
		107,
		123,
		121,
		131,
		-1,
		-1,
		236,
		205,
		236,
		194,
		175,
		-1,
		141,
		121,
		127,
		131,
		125,
		118,
		132,
		128,
		-1,
		101,
		100,
		128,
		114,
		125,
		196,
		-1,
		-1,
		194,
		186,
		171,
		174,
		151,
		147,
		136,
		135,
		127,
		113,
		109,
		115,
		118,
		118,
		124,
		95,
		105,
		109,
		107,
		132,
		-1,
		-1,
		160,
		-1,
		-1,
		193,
		176,
		-1,
		159,
		166,
		157,
		163,
		149,
		170,
		146,
		137,
		129,
		123,
		111,
		113,
		110,
		123,
		111,
		92,
		117,
		121,
		102,
		123,
		118,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		152,
		155,
		161,
		185,
		186,
		-1,
		158,
		146,
		147,
		132,
		129,
		116,
		104,
		117,
		102,
		109,
		108,
		96,
		94,
		124,
		99,
		121,
		118,
		130,
		135,
		129,
		138,
		-1,
		201,
		197,
		193,
		200,
		149,
		-1,
		-1,
		189,
		-1,
		194,
		195,
		170,
		143,
		146,
		133,
		124,
		111,
		100,
		111,
		100,
		97,
		105,
		88,
		103,
		94,
		93,
		111,
		114,
		122,
		126,
		132,
		-1,
		251,
		-1,
		193,
		177,
		179,
		151,
		172,
		-1,
		209,
		195,
		187,
		172,
		170,
		-1,
		142,
		139,
		129,
		107,
		92,
		109,
		101,
		99,
		101,
		83,
		97,
		88,
		106,
		113,
		104,
		108,
		128,
		140,
		211,
		201,
		-1,
		183,
		188,
		147,
		155,
		174,
		212,
		176,
		-1,
		171,
		-1,
		144,
		157,
		-1,
		113,
		109,
		91,
		92,
		87,
		102,
		94,
		79,
		76,
		94,
		97,
		97,
		101,
		117,
		-1,
		-1,
		196,
		200,
		189,
		140,
		159,
		183,
		220,
		169,
		158,
		157,
		-1,
		148,
		127,
		124,
		112,
		99,
		84,
		85,
		93,
		105,
		84,
		78,
		75,
		95,
		114,
		92,
		103,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		166,
		137,
		161,
		203,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		123,
		102,
		93,
		82,
		80,
		93,
		85,
		93,
		73,
		71,
		90,
		95,
		86,
		94,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		166,
		152,
		157,
		132,
		125,
		119,
		136,
		119,
		100,
		89,
		81,
		70,
		81,
		89,
		87,
		69,
		78,
		84,
		101,
		82,
		88,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		157,
		170,
		-1,
		124,
		-1,
		113,
		109,
		94,
		89,
		86,
		73,
		72,
		86,
		86,
		76,
		71,
		78,
		106,
		106,
		72,
		91,
		94,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		96,
		92,
		77,
		81,
		83,
		86,
		74,
		80,
		81,
		63,
		87,
		-1,
		80,
		74,
		81,
		71,
		60,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		89,
		84,
		83,
		82,
		79,
		68,
		81,
		74,
		68,
		62,
		75,
		79,
		79,
		62,
		58,
		55,
		59,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		111,
		95,
		94,
		91,
		82,
		90,
		63,
		56,
		67,
		52,
		70,
		76,
		66,
		56,
		48,
		55,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		101,
		118,
		119,
		97,
		91,
		89,
		80,
		68,
		57,
		60,
		52,
		74,
		70,
		54,
		51,
		44,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		115,
		113,
		108,
		99,
		105,
		100,
		77,
		72,
		62,
		51,
		51,
		46,
		65,
		51,
		49,
		42,
		40,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		116,
		100,
		105,
		-1,
		97,
		-1,
		70,
		67,
		58,
		43,
		40,
		51,
		49,
		58,
		37,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		132,
		112,
		106,
		105,
		92,
		84,
		78,
		56,
		49,
		46,
		36,
		49,
		59,
		51,
		35,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		138,
		126,
		116,
		106,
		110,
		100,
		75,
		68,
		54,
		56,
		48,
		38,
		37,
		42,
		34,
		39,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		160,
		131,
		127,
		-1,
		-1,
		110,
		102,
		92,
		71,
		58,
		67,
		62,
		47,
		31,
		46,
		37,
		29,
		21,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		178,
		123,
		112,
		107,
		111,
		109,
		-1,
		83,
		82,
		62,
		74,
		81,
		49,
		37,
		31,
		22,
		32,
		15,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		135,
		129,
		100,
		93,
		97,
		-1,
		85,
		78,
		64,
		80,
		55,
		52,
		43,
		33,
		33,
		19,
		19,
		0,
		6,
		191,
		-1,
		171,
		-1,
		-1,
		-1,
		153,
		168,
		139,
		116,
		89,
		84,
		77,
		71,
		72,
		77,
		63,
		74,
		40,
		36,
		32,
		19,
		15,
		4,
		5,
		-1,
		-1,
		169,
		165,
		179,
		161,
		165,
		166,
		-1,
		-1,
		93,
		84,
		75,
		67,
		80,
		81,
		46,
		43,
		43,
		36,
		29,
		28,
		26,
		11,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		164,
		111,
		93,
		89,
		87,
		76,
		70,
		58,
		51,
		61,
		54,
		46,
		26,
		44,
		40,
		19,
		42,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		126,
		123,
		-1,
		93,
		99,
		64,
		71,
		62,
		61,
		58,
		50,
		31,
		45,
		43,
		31,
		30,
		34,
		29,
		38,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		96,
		72,
		70,
		63,
		58,
		68,
		48,
		35,
		38,
		42,
		35,
		28,
		33,
		39,
		36,
		44,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		78,
		73,
		64,
		49,
		55,
		42,
		40,
		58,
		49,
		46,
		50,
		39,
		52,
		56,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		95,
		138,
		93,
		88,
		72,
		70,
		61,
		52,
		59,
		50,
		49,
		52,
		57,
		61,
		52,
		49,
		49,
		50,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		168,
		-1,
		135,
		-1,
		118,
		122,
		101,
		104,
		86,
		73,
		65,
		57,
		73,
		48,
		57,
		53,
		55,
		64,
		62,
		70,
		56,
		57,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		152,
		191,
		185,
		-1,
		169,
		-1,
		-1,
		-1,
		132,
		114,
		106,
		106,
		85,
		85,
		59,
		63,
		53,
		60,
		69,
		71,
		64,
		68,
		78,
		66,
		65,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		167,
		158,
		185,
		192,
		181,
		176,
		163,
		-1,
		-1,
		155,
		124,
		-1,
		-1,
		92,
		80,
		63,
		64,
		60,
		63,
		78,
		80,
		71,
		69,
		63,
		71,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		186,
		176,
		180,
		196,
		221,
		-1,
		152,
		-1,
		-1,
		137,
		-1,
		-1,
		122,
		85,
		74,
		65,
		71,
		68,
		79,
		89,
		77,
		78,
		68,
		78,
		85,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		120,
		118,
		107,
		-1,
		97,
		70,
		75,
		95,
		97,
		86,
		80,
		74,
		81,
		80,
		88,
		90,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		115,
		108,
		96,
		84,
		74,
		84,
		88,
		92,
		84,
		77,
		72,
		83,
		75,
		79,
		87,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		149,
		133,
		114,
		-1,
		84,
		97,
		128,
		96,
		101,
		96,
		78,
		89,
		78,
		81,
		80,
		83,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		121,
		117,
		-1,
		-1,
		85,
		110,
		99,
		107,
		102,
		82,
		88,
		91,
		80,
		84,
		80,
		-1,
		-1,
		170,
		171,
		172,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		123,
		86,
		107,
		117,
		111,
		109,
		100,
		86,
		93,
		91,
		87,
		90,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		87,
		113,
		116,
		122,
		116,
		89,
		104,
		94,
		85,
		94,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		107,
		138,
		123,
		104,
		91,
		98,
		98,
		91,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		96,
		128,
		124,
		111,
		111,
		103,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		104,
		139,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		110,
		108,
		111,
		112,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		119,
		115,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		204,
		193,
		204,
		212,
		185,
		192,
		-1,
		211,
		215,
		181,
		175,
		214,
		183,
		189,
		200,
		-1,
		-1,
		-1,
		204,
		203,
		171,
		169,
		178,
		183,
		190,
		-1,
		189,
		-1,
		225,
		204,
		215,
		220,
		164,
		161,
		181,
		200,
		182,
		174,
		240,
		194,
		165,
		159,
		177,
		167,
		176,
		168,
		-1,
		165,
		155,
		177,
		156,
		167,
		159,
		-1,
		-1,
		159,
		160,
		166,
		152,
		158,
		154,
		-1,
		164,
		148,
		-1,
		-1,
		149,
		150,
		134,
		137,
		145,
		143,
		156,
		148,
		143,
		-1,
		-1,
		140,
		136,
		143,
		130,
		126,
		143,
		156,
		138,
		152,
		151,
		-1,
		146,
		164,
		169,
		137,
		135,
		119,
		117,
		135,
		137,
		143,
		143,
		-1,
		155,
		156,
		151,
		159,
		159,
		135,
		122,
		122,
		132,
		125,
		144,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		138,
		155,
		147,
		137,
		152,
		145,
		125,
		122,
		120,
		117,
		133,
		131,
		141,
		-1,
		-1,
		246,
		215,
		246,
		204,
		185,
		-1,
		151,
		131,
		137,
		141,
		135,
		128,
		142,
		138,
		-1,
		111,
		110,
		138,
		124,
		135,
		206,
		-1,
		-1,
		204,
		196,
		181,
		184,
		161,
		157,
		146,
		145,
		137,
		123,
		119,
		125,
		128,
		128,
		134,
		105,
		115,
		119,
		117,
		140,
		-1,
		-1,
		154,
		-1,
		-1,
		203,
		186,
		-1,
		169,
		176,
		167,
		173,
		159,
		180,
		156,
		147,
		139,
		133,
		121,
		123,
		120,
		133,
		121,
		102,
		127,
		131,
		112,
		130,
		125,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		162,
		165,
		171,
		195,
		196,
		-1,
		168,
		156,
		157,
		142,
		139,
		126,
		114,
		127,
		112,
		119,
		118,
		106,
		104,
		134,
		109,
		129,
		119,
		124,
		129,
		123,
		132,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		199,
		-1,
		204,
		205,
		180,
		153,
		156,
		143,
		134,
		121,
		110,
		121,
		110,
		107,
		115,
		98,
		113,
		104,
		103,
		108,
		108,
		116,
		120,
		126,
		-1,
		261,
		-1,
		203,
		187,
		189,
		161,
		182,
		-1,
		219,
		205,
		197,
		182,
		180,
		-1,
		152,
		149,
		139,
		117,
		102,
		119,
		111,
		109,
		111,
		93,
		107,
		98,
		114,
		112,
		98,
		102,
		122,
		134,
		221,
		211,
		-1,
		193,
		198,
		157,
		165,
		184,
		222,
		186,
		-1,
		181,
		-1,
		154,
		167,
		-1,
		123,
		119,
		101,
		102,
		97,
		112,
		104,
		89,
		86,
		104,
		105,
		91,
		95,
		111,
		-1,
		-1,
		206,
		210,
		199,
		150,
		169,
		193,
		230,
		179,
		168,
		167,
		-1,
		158,
		137,
		134,
		122,
		109,
		94,
		95,
		103,
		115,
		94,
		88,
		85,
		101,
		108,
		86,
		97,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		176,
		147,
		171,
		213,
		197,
		190,
		178,
		143,
		143,
		137,
		-1,
		133,
		112,
		103,
		92,
		90,
		103,
		95,
		103,
		83,
		81,
		96,
		89,
		80,
		88,
		-1,
		-1,
		-1,
		206,
		195,
		196,
		142,
		165,
		202,
		176,
		162,
		167,
		142,
		135,
		129,
		146,
		129,
		110,
		99,
		91,
		80,
		91,
		99,
		97,
		79,
		88,
		90,
		95,
		76,
		82,
		-1,
		-1,
		213,
		203,
		187,
		189,
		186,
		156,
		163,
		195,
		167,
		180,
		-1,
		134,
		-1,
		123,
		119,
		104,
		99,
		96,
		83,
		82,
		96,
		96,
		86,
		81,
		88,
		100,
		100,
		66,
		85,
		88,
		-1,
		-1,
		-1,
		206,
		201,
		176,
		153,
		137,
		173,
		-1,
		150,
		151,
		-1,
		128,
		122,
		119,
		106,
		102,
		87,
		91,
		93,
		96,
		84,
		90,
		91,
		73,
		97,
		-1,
		74,
		68,
		75,
		65,
		54,
		-1,
		-1,
		-1,
		199,
		178,
		171,
		191,
		132,
		184,
		-1,
		-1,
		135,
		128,
		-1,
		115,
		97,
		99,
		94,
		93,
		92,
		89,
		78,
		91,
		84,
		78,
		72,
		85,
		89,
		73,
		56,
		52,
		49,
		63,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		152,
		-1,
		144,
		136,
		126,
		120,
		114,
		110,
		108,
		121,
		105,
		104,
		101,
		92,
		100,
		73,
		66,
		77,
		62,
		80,
		70,
		60,
		50,
		42,
		59,
		-1,
		219,
		205,
		176,
		-1,
		-1,
		165,
		-1,
		129,
		143,
		159,
		-1,
		152,
		131,
		146,
		124,
		120,
		111,
		128,
		129,
		107,
		101,
		99,
		90,
		78,
		67,
		70,
		62,
		72,
		64,
		48,
		45,
		38,
		-1,
		225,
		212,
		170,
		166,
		155,
		175,
		126,
		114,
		146,
		-1,
		-1,
		188,
		-1,
		122,
		139,
		125,
		123,
		118,
		109,
		115,
		110,
		87,
		82,
		72,
		61,
		61,
		56,
		70,
		56,
		54,
		36,
		50,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		141,
		128,
		122,
		-1,
		163,
		-1,
		166,
		156,
		140,
		125,
		158,
		-1,
		126,
		110,
		115,
		-1,
		107,
		-1,
		80,
		77,
		68,
		53,
		50,
		61,
		57,
		53,
		31,
		-1,
		175,
		160,
		153,
		143,
		157,
		128,
		-1,
		183,
		-1,
		-1,
		153,
		147,
		147,
		131,
		134,
		142,
		122,
		116,
		115,
		102,
		94,
		88,
		66,
		59,
		56,
		46,
		59,
		69,
		45,
		29,
		-1,
		-1,
		-1,
		180,
		166,
		170,
		130,
		149,
		-1,
		-1,
		215,
		170,
		156,
		-1,
		140,
		148,
		136,
		126,
		116,
		120,
		110,
		85,
		78,
		64,
		66,
		58,
		48,
		47,
		40,
		35,
		33,
		-1,
		-1,
		163,
		168,
		156,
		142,
		161,
		-1,
		-1,
		-1,
		162,
		178,
		170,
		141,
		137,
		-1,
		-1,
		120,
		112,
		102,
		81,
		68,
		77,
		72,
		57,
		41,
		53,
		43,
		23,
		15,
		-1,
		166,
		153,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		-1,
		-1,
		188,
		133,
		122,
		117,
		121,
		119,
		-1,
		93,
		92,
		72,
		84,
		91,
		59,
		47,
		41,
		32,
		40,
		9,
		-1,
		-1,
		178,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		145,
		139,
		110,
		103,
		107,
		-1,
		95,
		88,
		74,
		90,
		65,
		62,
		53,
		43,
		43,
		29,
		24,
		10,
		0,
		201,
		-1,
		181,
		-1,
		-1,
		-1,
		163,
		178,
		149,
		126,
		99,
		94,
		87,
		81,
		82,
		87,
		73,
		84,
		50,
		46,
		42,
		29,
		25,
		14,
		15,
		-1,
		-1,
		179,
		175,
		189,
		171,
		175,
		176,
		-1,
		-1,
		103,
		94,
		85,
		77,
		90,
		91,
		56,
		53,
		53,
		46,
		39,
		38,
		33,
		18,
		-1,
		-1,
		-1,
		191,
		-1,
		193,
		-1,
		-1,
		181,
		174,
		121,
		103,
		99,
		97,
		86,
		80,
		68,
		61,
		71,
		64,
		56,
		36,
		54,
		50,
		26,
		52,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		170,
		162,
		157,
		163,
		165,
		156,
		136,
		133,
		-1,
		103,
		109,
		74,
		81,
		72,
		71,
		68,
		60,
		41,
		55,
		50,
		38,
		37,
		44,
		39,
		48,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		163,
		159,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		106,
		82,
		80,
		73,
		68,
		78,
		58,
		45,
		48,
		52,
		42,
		35,
		40,
		46,
		46,
		54,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		153,
		145,
		156,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		88,
		83,
		74,
		59,
		65,
		52,
		50,
		68,
		56,
		53,
		60,
		49,
		62,
		66,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		150,
		-1,
		-1,
		162,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		82,
		80,
		71,
		62,
		69,
		60,
		59,
		62,
		64,
		68,
		62,
		59,
		59,
		60,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		178,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		96,
		83,
		75,
		67,
		83,
		58,
		67,
		63,
		65,
		74,
		72,
		80,
		66,
		67,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		162,
		201,
		195,
		-1,
		179,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		116,
		95,
		95,
		69,
		73,
		63,
		70,
		79,
		81,
		74,
		78,
		88,
		76,
		75,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		168,
		195,
		202,
		191,
		186,
		173,
		-1,
		-1,
		165,
		134,
		-1,
		-1,
		102,
		90,
		73,
		74,
		70,
		73,
		88,
		90,
		81,
		79,
		73,
		81,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		196,
		186,
		190,
		206,
		231,
		-1,
		162,
		-1,
		-1,
		147,
		-1,
		-1,
		132,
		95,
		84,
		75,
		81,
		78,
		89,
		99,
		87,
		88,
		78,
		88,
		95,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		178,
		158,
		-1,
		-1,
		130,
		128,
		117,
		-1,
		107,
		80,
		85,
		105,
		107,
		96,
		90,
		84,
		91,
		90,
		98,
		100,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		164,
		-1,
		-1,
		125,
		118,
		106,
		94,
		84,
		94,
		98,
		102,
		94,
		87,
		82,
		93,
		85,
		89,
		97,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		159,
		143,
		124,
		-1,
		94,
		107,
		138,
		106,
		111,
		106,
		88,
		99,
		88,
		91,
		90,
		93,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		175,
		177,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		131,
		127,
		-1,
		-1,
		95,
		120,
		109,
		117,
		112,
		92,
		98,
		101,
		90,
		94,
		90,
		-1,
		-1,
		180,
		181,
		182,
		-1,
		160,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		133,
		96,
		117,
		127,
		121,
		119,
		110,
		96,
		103,
		101,
		97,
		100,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		97,
		123,
		126,
		132,
		126,
		99,
		114,
		104,
		95,
		104,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		117,
		148,
		133,
		114,
		101,
		108,
		108,
		101,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		138,
		134,
		121,
		121,
		113,
		-1,
		257,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		117,
		113,
		133,
		114,
		149,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		120,
		118,
		121,
		122,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		129,
		125,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		219,
		208,
		219,
		227,
		200,
		207,
		-1,
		228,
		230,
		196,
		190,
		229,
		200,
		206,
		217,
		-1,
		-1,
		-1,
		219,
		218,
		188,
		186,
		195,
		200,
		207,
		-1,
		230,
		-1,
		240,
		219,
		230,
		235,
		181,
		178,
		198,
		217,
		223,
		215,
		255,
		211,
		182,
		176,
		194,
		199,
		217,
		209,
		-1,
		182,
		172,
		194,
		198,
		210,
		193,
		-1,
		-1,
		176,
		177,
		183,
		195,
		200,
		205,
		-1,
		228,
		212,
		-1,
		-1,
		166,
		179,
		175,
		178,
		186,
		202,
		220,
		212,
		207,
		-1,
		-1,
		167,
		171,
		184,
		185,
		183,
		207,
		220,
		202,
		216,
		215,
		-1,
		155,
		173,
		182,
		191,
		197,
		183,
		181,
		199,
		201,
		207,
		210,
		-1,
		147,
		149,
		178,
		184,
		196,
		199,
		186,
		186,
		196,
		189,
		208,
		199,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		144,
		152,
		178,
		177,
		173,
		191,
		196,
		189,
		186,
		184,
		181,
		197,
		198,
		208,
		-1,
		-1,
		200,
		169,
		204,
		161,
		146,
		-1,
		140,
		159,
		165,
		169,
		174,
		179,
		193,
		189,
		-1,
		175,
		174,
		205,
		191,
		202,
		160,
		-1,
		-1,
		158,
		150,
		135,
		138,
		135,
		135,
		165,
		164,
		169,
		171,
		170,
		176,
		179,
		179,
		185,
		169,
		179,
		183,
		194,
		209,
		-1,
		-1,
		264,
		-1,
		-1,
		157,
		140,
		-1,
		123,
		130,
		130,
		147,
		137,
		158,
		173,
		177,
		185,
		184,
		172,
		174,
		171,
		184,
		172,
		166,
		191,
		195,
		189,
		210,
		205,
		-1,
		263,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		116,
		119,
		125,
		149,
		159,
		-1,
		180,
		178,
		202,
		193,
		190,
		177,
		165,
		178,
		163,
		170,
		169,
		173,
		175,
		208,
		186,
		208,
		205,
		234,
		239,
		233,
		242,
		-1,
		165,
		161,
		157,
		164,
		113,
		-1,
		-1,
		153,
		-1,
		167,
		180,
		184,
		182,
		185,
		194,
		185,
		172,
		161,
		172,
		161,
		158,
		166,
		175,
		186,
		181,
		180,
		198,
		213,
		226,
		230,
		236,
		-1,
		215,
		-1,
		157,
		141,
		143,
		115,
		136,
		-1,
		173,
		168,
		188,
		186,
		177,
		-1,
		180,
		183,
		190,
		168,
		153,
		170,
		162,
		160,
		165,
		170,
		184,
		175,
		193,
		200,
		208,
		212,
		232,
		244,
		175,
		165,
		-1,
		147,
		152,
		111,
		119,
		138,
		211,
		183,
		-1,
		178,
		-1,
		170,
		195,
		-1,
		174,
		170,
		152,
		153,
		148,
		163,
		169,
		166,
		163,
		181,
		184,
		201,
		205,
		221,
		-1,
		-1,
		160,
		164,
		153,
		104,
		123,
		147,
		184,
		176,
		165,
		164,
		-1,
		155,
		185,
		182,
		168,
		155,
		145,
		146,
		154,
		167,
		146,
		165,
		168,
		190,
		218,
		196,
		208,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		130,
		101,
		125,
		167,
		194,
		187,
		175,
		140,
		140,
		134,
		-1,
		175,
		158,
		154,
		143,
		141,
		154,
		149,
		165,
		169,
		168,
		187,
		199,
		190,
		210,
		-1,
		-1,
		-1,
		160,
		149,
		150,
		96,
		119,
		156,
		173,
		159,
		164,
		139,
		132,
		126,
		178,
		175,
		142,
		150,
		142,
		131,
		145,
		153,
		157,
		166,
		175,
		181,
		205,
		205,
		211,
		-1,
		-1,
		167,
		157,
		141,
		143,
		140,
		110,
		117,
		149,
		164,
		161,
		-1,
		131,
		-1,
		120,
		128,
		127,
		133,
		145,
		131,
		136,
		147,
		159,
		172,
		168,
		175,
		210,
		210,
		195,
		215,
		218,
		-1,
		-1,
		-1,
		160,
		155,
		130,
		107,
		91,
		127,
		-1,
		131,
		132,
		-1,
		125,
		119,
		125,
		124,
		131,
		128,
		128,
		142,
		150,
		146,
		162,
		168,
		160,
		196,
		-1,
		203,
		197,
		205,
		195,
		183,
		-1,
		-1,
		-1,
		153,
		132,
		125,
		145,
		86,
		138,
		-1,
		-1,
		116,
		109,
		-1,
		112,
		112,
		119,
		128,
		133,
		138,
		146,
		141,
		154,
		159,
		165,
		170,
		188,
		192,
		196,
		185,
		181,
		178,
		192,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		86,
		106,
		-1,
		124,
		116,
		107,
		101,
		107,
		125,
		123,
		143,
		135,
		149,
		149,
		155,
		163,
		148,
		151,
		167,
		165,
		183,
		191,
		183,
		177,
		176,
		188,
		-1,
		173,
		159,
		130,
		-1,
		-1,
		119,
		-1,
		83,
		102,
		118,
		-1,
		141,
		120,
		143,
		121,
		135,
		131,
		169,
		170,
		148,
		153,
		161,
		171,
		173,
		162,
		173,
		165,
		187,
		187,
		171,
		172,
		181,
		-1,
		179,
		166,
		124,
		120,
		109,
		129,
		80,
		89,
		105,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		145,
		143,
		159,
		150,
		156,
		172,
		175,
		177,
		167,
		156,
		162,
		159,
		181,
		167,
		165,
		184,
		200,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		95,
		82,
		76,
		-1,
		122,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		167,
		151,
		156,
		-1,
		202,
		-1,
		175,
		177,
		171,
		156,
		153,
		164,
		162,
		173,
		190,
		-1,
		129,
		114,
		107,
		97,
		111,
		79,
		-1,
		113,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		183,
		163,
		157,
		156,
		197,
		197,
		183,
		169,
		162,
		159,
		156,
		169,
		189,
		180,
		192,
		-1,
		-1,
		-1,
		134,
		109,
		103,
		75,
		79,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		137,
		200,
		188,
		178,
		168,
		202,
		203,
		188,
		181,
		167,
		169,
		167,
		165,
		170,
		191,
		192,
		205,
		-1,
		-1,
		108,
		101,
		89,
		57,
		52,
		-1,
		-1,
		-1,
		159,
		175,
		167,
		138,
		189,
		-1,
		-1,
		180,
		178,
		188,
		184,
		171,
		191,
		194,
		180,
		164,
		179,
		191,
		199,
		204,
		-1,
		111,
		98,
		-1,
		-1,
		29,
		47,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		170,
		191,
		216,
		183,
		-1,
		188,
		189,
		175,
		189,
		196,
		182,
		177,
		171,
		174,
		192,
		209,
		-1,
		-1,
		19,
		-1,
		64,
		-1,
		-1,
		-1,
		-1,
		149,
		163,
		184,
		190,
		202,
		-1,
		197,
		191,
		177,
		194,
		195,
		192,
		183,
		175,
		180,
		177,
		190,
		204,
		208,
		0,
		-1,
		75,
		-1,
		-1,
		-1,
		144,
		174,
		244,
		221,
		194,
		198,
		191,
		185,
		185,
		201,
		203,
		214,
		182,
		178,
		179,
		183,
		182,
		199,
		209,
		-1,
		-1,
		75,
		92,
		127,
		139,
		171,
		271,
		-1,
		-1,
		195,
		188,
		189,
		192,
		195,
		198,
		188,
		185,
		190,
		195,
		183,
		192,
		210,
		214,
		-1,
		-1,
		-1,
		95,
		-1,
		110,
		-1,
		-1,
		181,
		268,
		215,
		197,
		193,
		179,
		193,
		187,
		189,
		193,
		203,
		208,
		204,
		185,
		196,
		219,
		208,
		246,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		124,
		99,
		114,
		160,
		165,
		156,
		230,
		227,
		-1,
		175,
		216,
		184,
		198,
		194,
		201,
		206,
		208,
		186,
		193,
		209,
		208,
		203,
		238,
		230,
		236,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		130,
		116,
		146,
		136,
		142,
		-1,
		-1,
		189,
		186,
		189,
		176,
		182,
		187,
		190,
		215,
		195,
		182,
		186,
		190,
		196,
		201,
		206,
		212,
		227,
		242,
		-1,
		156,
		237,
		230,
		213,
		221,
		252,
		-1,
		133,
		142,
		123,
		128,
		136,
		-1,
		-1,
		162,
		158,
		163,
		172,
		175,
		211,
		210,
		211,
		196,
		202,
		189,
		188,
		206,
		210,
		219,
		226,
		216,
		229,
		233,
		-1,
		170,
		213,
		207,
		210,
		234,
		248,
		-1,
		146,
		-1,
		-1,
		131,
		149,
		157,
		153,
		157,
		210,
		186,
		181,
		194,
		196,
		208,
		199,
		206,
		197,
		197,
		200,
		215,
		220,
		212,
		226,
		226,
		227,
		-1,
		205,
		193,
		201,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		147,
		-1,
		183,
		-1,
		176,
		180,
		194,
		197,
		219,
		206,
		212,
		204,
		220,
		195,
		205,
		201,
		202,
		211,
		222,
		234,
		233,
		234,
		265,
		221,
		201,
		192,
		239,
		254,
		258,
		-1,
		159,
		198,
		185,
		-1,
		156,
		-1,
		-1,
		-1,
		190,
		207,
		199,
		215,
		218,
		218,
		206,
		210,
		200,
		207,
		217,
		219,
		211,
		215,
		228,
		239,
		242,
		261,
		252,
		265,
		210,
		206,
		224,
		233,
		254,
		174,
		165,
		192,
		192,
		181,
		176,
		163,
		-1,
		-1,
		213,
		217,
		-1,
		-1,
		225,
		227,
		210,
		211,
		207,
		210,
		225,
		228,
		218,
		216,
		210,
		242,
		-1,
		254,
		253,
		242,
		239,
		215,
		206,
		201,
		225,
		-1,
		-1,
		177,
		193,
		206,
		210,
		223,
		248,
		-1,
		166,
		-1,
		-1,
		234,
		-1,
		-1,
		269,
		232,
		221,
		212,
		218,
		215,
		226,
		236,
		224,
		225,
		215,
		225,
		238,
		238,
		235,
		223,
		221,
		244,
		209,
		197,
		-1,
		192,
		180,
		186,
		193,
		210,
		237,
		-1,
		-1,
		182,
		173,
		-1,
		-1,
		253,
		260,
		254,
		-1,
		244,
		217,
		222,
		242,
		244,
		233,
		227,
		221,
		228,
		227,
		235,
		243,
		247,
		261,
		250,
		246,
		245,
		253,
		202,
		195,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		217,
		192,
		-1,
		-1,
		260,
		255,
		243,
		231,
		221,
		231,
		235,
		239,
		231,
		224,
		219,
		230,
		222,
		226,
		243,
		-1,
		281,
		-1,
		233,
		201,
		221,
		236,
		244,
		-1,
		-1,
		-1,
		234,
		220,
		213,
		201,
		199,
		-1,
		296,
		280,
		261,
		-1,
		231,
		244,
		275,
		243,
		248,
		243,
		225,
		236,
		225,
		228,
		242,
		237,
		-1,
		-1,
		219,
		222,
		-1,
		-1,
		246,
		265,
		-1,
		225,
		214,
		199,
		191,
		-1,
		-1,
		268,
		264,
		-1,
		-1,
		232,
		257,
		246,
		254,
		249,
		229,
		235,
		238,
		227,
		231,
		243,
		-1,
		-1,
		226,
		229,
		234,
		-1,
		255,
		-1,
		249,
		-1,
		194,
		210,
		212,
		-1,
		-1,
		-1,
		270,
		233,
		254,
		264,
		258,
		256,
		247,
		233,
		240,
		238,
		234,
		245,
		-1,
		-1,
		-1,
		275,
		249,
		256,
		247,
		230,
		210,
		202,
		227,
		-1,
		257,
		-1,
		232,
		234,
		260,
		263,
		269,
		263,
		236,
		251,
		241,
		232,
		241,
		281,
		-1,
		251,
		284,
		248,
		216,
		216,
		215,
		278,
		-1,
		254,
		236,
		-1,
		264,
		254,
		285,
		270,
		251,
		238,
		245,
		245,
		238,
		-1,
		-1,
		-1,
		253,
		252,
		244,
		238,
		236,
		221,
		216,
		-1,
		266,
		248,
		227,
		244,
		244,
		235,
		243,
		275,
		271,
		258,
		258,
		250,
		-1,
		353,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		247,
		256,
		229,
		217,
		231,
		238,
		231,
		235,
		239,
		247,
		245,
		242,
		254,
		250,
		270,
		251,
		286,
		-1,
		360,
		-1,
		283,
		-1,
		-1,
		263,
		249,
		251,
		240,
		229,
		227,
		230,
		228,
		250,
		273,
		257,
		255,
		258,
		259,
		-1,
		351,
		350,
		-1,
		282,
		274,
		260,
		-1,
		253,
		-1,
		275,
		236,
		-1,
		257,
		237,
		-1,
		266,
		262,
		-1,
		-1,
		338,
		298,
		-1,
		-1,
		-1,
		283,
		263,
		270,
		254,
		-1,
		248,
		248,
		-1,
		-1,
		-1,
		323,
		307,
		-1,
		276,
		279,
		-1,
		270,
		276,
		303,
		250,
		254,
		-1,
		-1,
		-1,
		332,
		313,
		307,
		291,
		296,
		284,
		301,
		287,
		286,
		264,
		253,
		274,
		-1,
		-1,
		-1,
		304,
		296,
		296,
		-1,
		-1,
		311,
		294,
		275,
		273,
		-1,
		-1,
		-1,
		326,
		307,
		-1,
		-1,
		301,
		-1,
		-1,
		307,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		342,
		315,
		-1,
		-1,
		-1,
		297,
		293,
		294,
		-1,
		-1,
		-1,
		-1,
		336,
		337,
		361,
		336,
		-1,
		-1,
		-1,
		289,
		283,
		-1,
		-1,
		339,
		337,
		-1,
		-1,
		-1,
		317,
		301,
		-1,
		287,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		320,
		-1,
		-1,
		-1,
		322,
		-1,
		322,
		297,
		304,
		-1,
		-1,
		-1,
		-1,
		335,
		327,
		335,
		-1,
		307,
		309,
		-1,
		357,
		-1,
		-1,
		350,
		341,
		-1,
		-1,
		312,
		319,
		341,
		344,
		380,
		-1,
		331
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		205,
		194,
		205,
		213,
		186,
		193,
		-1,
		214,
		216,
		182,
		176,
		215,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		205,
		204,
		174,
		172,
		181,
		186,
		193,
		-1,
		216,
		-1,
		226,
		205,
		216,
		221,
		167,
		164,
		184,
		203,
		209,
		201,
		241,
		197,
		168,
		162,
		180,
		185,
		203,
		195,
		-1,
		168,
		158,
		180,
		184,
		196,
		179,
		-1,
		-1,
		162,
		163,
		169,
		181,
		186,
		191,
		-1,
		214,
		198,
		-1,
		-1,
		152,
		165,
		161,
		164,
		172,
		188,
		206,
		198,
		193,
		-1,
		-1,
		153,
		157,
		170,
		171,
		169,
		193,
		206,
		188,
		202,
		201,
		-1,
		141,
		159,
		168,
		177,
		183,
		169,
		167,
		185,
		187,
		193,
		196,
		-1,
		133,
		135,
		164,
		170,
		182,
		185,
		172,
		172,
		182,
		175,
		194,
		185,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		130,
		138,
		164,
		163,
		159,
		177,
		182,
		175,
		172,
		170,
		167,
		183,
		184,
		194,
		-1,
		-1,
		186,
		155,
		190,
		147,
		132,
		-1,
		126,
		145,
		151,
		155,
		160,
		165,
		179,
		175,
		-1,
		161,
		160,
		191,
		177,
		188,
		146,
		-1,
		-1,
		144,
		136,
		121,
		124,
		121,
		121,
		151,
		150,
		155,
		157,
		156,
		162,
		165,
		165,
		171,
		155,
		165,
		169,
		180,
		195,
		-1,
		-1,
		250,
		-1,
		-1,
		143,
		126,
		-1,
		109,
		116,
		116,
		133,
		123,
		144,
		159,
		163,
		171,
		170,
		158,
		160,
		157,
		170,
		158,
		152,
		177,
		181,
		175,
		196,
		191,
		-1,
		249,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		105,
		111,
		135,
		145,
		-1,
		166,
		164,
		188,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		159,
		161,
		194,
		172,
		194,
		191,
		220,
		225,
		219,
		228,
		-1,
		151,
		147,
		143,
		150,
		99,
		-1,
		-1,
		139,
		-1,
		153,
		166,
		170,
		168,
		171,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		161,
		172,
		167,
		166,
		184,
		199,
		212,
		216,
		222,
		-1,
		201,
		-1,
		143,
		127,
		129,
		101,
		122,
		-1,
		159,
		154,
		174,
		172,
		163,
		-1,
		166,
		169,
		176,
		154,
		139,
		156,
		148,
		146,
		151,
		156,
		170,
		161,
		179,
		186,
		194,
		198,
		218,
		230,
		161,
		151,
		-1,
		133,
		138,
		97,
		105,
		124,
		197,
		169,
		-1,
		164,
		-1,
		156,
		181,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		155,
		152,
		149,
		167,
		170,
		187,
		191,
		207,
		-1,
		-1,
		146,
		150,
		139,
		90,
		109,
		133,
		170,
		162,
		151,
		150,
		-1,
		141,
		171,
		168,
		154,
		141,
		131,
		132,
		140,
		153,
		132,
		151,
		154,
		176,
		204,
		182,
		194,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		116,
		87,
		111,
		153,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		161,
		144,
		140,
		129,
		127,
		140,
		135,
		151,
		155,
		154,
		173,
		185,
		176,
		196,
		-1,
		-1,
		-1,
		146,
		135,
		136,
		82,
		105,
		142,
		159,
		145,
		150,
		125,
		118,
		112,
		164,
		161,
		128,
		136,
		128,
		117,
		131,
		139,
		143,
		152,
		161,
		167,
		191,
		191,
		197,
		-1,
		-1,
		153,
		143,
		127,
		129,
		126,
		96,
		103,
		135,
		150,
		147,
		-1,
		117,
		-1,
		106,
		114,
		113,
		119,
		131,
		117,
		122,
		133,
		145,
		158,
		154,
		161,
		196,
		196,
		181,
		201,
		204,
		-1,
		-1,
		-1,
		146,
		141,
		116,
		93,
		77,
		113,
		-1,
		117,
		118,
		-1,
		111,
		105,
		111,
		110,
		117,
		114,
		114,
		128,
		136,
		132,
		148,
		154,
		146,
		182,
		-1,
		189,
		183,
		191,
		181,
		169,
		-1,
		-1,
		-1,
		139,
		118,
		111,
		131,
		72,
		124,
		-1,
		-1,
		102,
		95,
		-1,
		98,
		98,
		105,
		114,
		119,
		124,
		132,
		127,
		140,
		145,
		151,
		156,
		174,
		178,
		182,
		171,
		167,
		164,
		178,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		92,
		-1,
		110,
		102,
		93,
		87,
		93,
		111,
		109,
		129,
		121,
		135,
		135,
		141,
		149,
		134,
		137,
		153,
		151,
		169,
		177,
		169,
		163,
		162,
		174,
		-1,
		159,
		145,
		116,
		-1,
		-1,
		105,
		-1,
		69,
		88,
		104,
		-1,
		127,
		106,
		129,
		107,
		121,
		117,
		155,
		156,
		134,
		139,
		147,
		157,
		159,
		148,
		159,
		151,
		173,
		173,
		157,
		158,
		167,
		-1,
		165,
		152,
		110,
		106,
		95,
		115,
		66,
		75,
		91,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		131,
		129,
		145,
		136,
		142,
		158,
		161,
		163,
		153,
		142,
		148,
		145,
		167,
		153,
		151,
		170,
		186,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		81,
		68,
		62,
		-1,
		108,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		153,
		137,
		142,
		-1,
		188,
		-1,
		161,
		163,
		157,
		142,
		139,
		150,
		148,
		159,
		176,
		-1,
		115,
		100,
		93,
		83,
		97,
		65,
		-1,
		99,
		-1,
		-1,
		136,
		130,
		130,
		113,
		110,
		169,
		149,
		143,
		142,
		183,
		183,
		169,
		155,
		148,
		145,
		142,
		155,
		175,
		166,
		178,
		-1,
		-1,
		-1,
		120,
		95,
		89,
		61,
		65,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		105,
		186,
		174,
		164,
		154,
		186,
		187,
		174,
		167,
		153,
		155,
		153,
		151,
		156,
		177,
		178,
		191,
		-1,
		-1,
		94,
		87,
		75,
		43,
		38,
		-1,
		-1,
		-1,
		145,
		143,
		131,
		103,
		175,
		-1,
		-1,
		166,
		164,
		172,
		170,
		157,
		177,
		180,
		166,
		150,
		165,
		177,
		185,
		190,
		-1,
		97,
		84,
		-1,
		-1,
		37,
		27,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		114,
		135,
		160,
		169,
		-1,
		157,
		161,
		161,
		175,
		182,
		168,
		163,
		157,
		160,
		178,
		195,
		-1,
		-1,
		51,
		-1,
		10,
		-1,
		-1,
		-1,
		-1,
		93,
		108,
		128,
		134,
		146,
		-1,
		155,
		154,
		158,
		164,
		176,
		178,
		169,
		153,
		166,
		163,
		176,
		190,
		194,
		74,
		-1,
		0,
		-1,
		-1,
		-1,
		70,
		100,
		188,
		165,
		138,
		143,
		140,
		146,
		150,
		162,
		171,
		182,
		147,
		151,
		165,
		169,
		168,
		185,
		195,
		-1,
		-1,
		0,
		18,
		53,
		65,
		97,
		215,
		-1,
		-1,
		139,
		132,
		142,
		142,
		155,
		158,
		143,
		145,
		163,
		176,
		169,
		178,
		195,
		190,
		-1,
		-1,
		-1,
		27,
		-1,
		36,
		-1,
		-1,
		112,
		212,
		159,
		141,
		137,
		123,
		137,
		131,
		133,
		138,
		157,
		152,
		161,
		166,
		170,
		193,
		182,
		221,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		56,
		29,
		44,
		104,
		109,
		100,
		174,
		171,
		-1,
		119,
		160,
		128,
		142,
		138,
		145,
		150,
		156,
		160,
		167,
		183,
		182,
		177,
		213,
		204,
		210,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		62,
		46,
		90,
		80,
		86,
		-1,
		-1,
		133,
		130,
		133,
		120,
		126,
		131,
		134,
		172,
		148,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		142,
		223,
		216,
		193,
		201,
		232,
		-1,
		65,
		79,
		53,
		72,
		80,
		-1,
		-1,
		106,
		102,
		107,
		116,
		119,
		155,
		154,
		167,
		170,
		175,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		156,
		199,
		187,
		190,
		214,
		228,
		-1,
		78,
		-1,
		-1,
		75,
		93,
		101,
		97,
		101,
		154,
		130,
		125,
		138,
		140,
		164,
		155,
		180,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		177,
		179,
		181,
		-1,
		-1,
		-1,
		-1,
		85,
		-1,
		-1,
		91,
		-1,
		127,
		-1,
		120,
		124,
		138,
		141,
		163,
		150,
		157,
		174,
		180,
		169,
		179,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		96,
		135,
		129,
		-1,
		100,
		-1,
		-1,
		-1,
		134,
		151,
		143,
		159,
		162,
		162,
		158,
		162,
		174,
		181,
		191,
		193,
		185,
		189,
		202,
		213,
		216,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		111,
		102,
		129,
		136,
		125,
		120,
		107,
		-1,
		-1,
		157,
		161,
		-1,
		-1,
		169,
		179,
		162,
		164,
		168,
		182,
		194,
		202,
		192,
		190,
		184,
		216,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		114,
		130,
		143,
		147,
		163,
		188,
		-1,
		110,
		-1,
		-1,
		178,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		176,
		187,
		209,
		198,
		199,
		189,
		199,
		212,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		129,
		117,
		123,
		130,
		147,
		177,
		-1,
		-1,
		126,
		117,
		-1,
		-1,
		197,
		204,
		206,
		-1,
		196,
		169,
		174,
		199,
		206,
		207,
		201,
		195,
		202,
		201,
		209,
		217,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		161,
		136,
		-1,
		-1,
		204,
		207,
		195,
		183,
		173,
		183,
		191,
		191,
		194,
		198,
		193,
		204,
		196,
		200,
		217,
		-1,
		218,
		-1,
		170,
		138,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		178,
		164,
		157,
		145,
		143,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		199,
		210,
		199,
		202,
		216,
		211,
		-1,
		-1,
		156,
		159,
		-1,
		-1,
		183,
		202,
		-1,
		169,
		158,
		143,
		135,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		184,
		209,
		198,
		206,
		201,
		203,
		209,
		212,
		201,
		205,
		217,
		-1,
		-1,
		163,
		166,
		171,
		-1,
		192,
		-1,
		193,
		-1,
		138,
		154,
		156,
		-1,
		-1,
		-1,
		222,
		185,
		206,
		216,
		221,
		219,
		210,
		207,
		214,
		212,
		208,
		219,
		-1,
		-1,
		-1,
		219,
		193,
		200,
		191,
		174,
		154,
		146,
		171,
		-1,
		210,
		-1,
		185,
		186,
		213,
		215,
		232,
		226,
		210,
		225,
		215,
		206,
		215,
		225,
		-1,
		195,
		228,
		192,
		160,
		160,
		159,
		224,
		-1,
		207,
		189,
		-1,
		217,
		207,
		249,
		230,
		223,
		210,
		217,
		219,
		212,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		180,
		165,
		160,
		-1,
		212,
		194,
		180,
		197,
		197,
		188,
		196,
		239,
		235,
		228,
		230,
		220,
		-1,
		290,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		200,
		173,
		161,
		175,
		182,
		177,
		179,
		192,
		200,
		198,
		195,
		207,
		203,
		223,
		219,
		251,
		-1,
		297,
		-1,
		227,
		-1,
		-1,
		207,
		193,
		195,
		184,
		173,
		171,
		174,
		172,
		194,
		224,
		210,
		208,
		213,
		218,
		-1,
		295,
		294,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		219,
		180,
		-1,
		201,
		181,
		-1,
		219,
		215,
		-1,
		-1,
		282,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		214,
		198,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		220,
		223,
		-1,
		214,
		220,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		235,
		240,
		228,
		245,
		231,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		248,
		240,
		240,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		259,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		280,
		281,
		305,
		280,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		283,
		281,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		236,
		238,
		204,
		198,
		237,
		208,
		214,
		225,
		-1,
		-1,
		-1,
		227,
		226,
		196,
		194,
		203,
		208,
		215,
		-1,
		219,
		-1,
		248,
		227,
		238,
		243,
		189,
		186,
		206,
		225,
		212,
		204,
		263,
		219,
		190,
		184,
		202,
		197,
		206,
		198,
		-1,
		190,
		180,
		202,
		186,
		197,
		189,
		-1,
		-1,
		184,
		185,
		191,
		182,
		188,
		184,
		-1,
		194,
		178,
		-1,
		-1,
		174,
		180,
		164,
		167,
		175,
		173,
		186,
		178,
		173,
		-1,
		-1,
		170,
		166,
		173,
		160,
		156,
		173,
		186,
		168,
		182,
		181,
		-1,
		163,
		181,
		190,
		167,
		165,
		149,
		147,
		165,
		167,
		173,
		176,
		-1,
		156,
		158,
		168,
		176,
		181,
		165,
		152,
		152,
		162,
		155,
		174,
		165,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		155,
		172,
		164,
		154,
		169,
		162,
		155,
		152,
		150,
		147,
		163,
		164,
		174,
		-1,
		-1,
		209,
		178,
		213,
		170,
		155,
		-1,
		149,
		148,
		154,
		158,
		152,
		145,
		159,
		155,
		-1,
		141,
		140,
		171,
		157,
		168,
		169,
		-1,
		-1,
		167,
		159,
		144,
		147,
		144,
		144,
		163,
		162,
		154,
		140,
		136,
		142,
		145,
		145,
		151,
		135,
		145,
		149,
		160,
		175,
		-1,
		-1,
		230,
		-1,
		-1,
		166,
		149,
		-1,
		132,
		139,
		139,
		156,
		146,
		167,
		173,
		164,
		156,
		150,
		138,
		140,
		137,
		150,
		138,
		132,
		157,
		161,
		155,
		176,
		171,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		125,
		128,
		134,
		158,
		168,
		-1,
		158,
		164,
		174,
		159,
		156,
		143,
		131,
		144,
		129,
		136,
		135,
		139,
		141,
		174,
		152,
		174,
		171,
		200,
		205,
		199,
		208,
		-1,
		174,
		170,
		166,
		173,
		122,
		-1,
		-1,
		162,
		-1,
		176,
		175,
		150,
		168,
		171,
		160,
		151,
		138,
		127,
		138,
		127,
		124,
		132,
		141,
		152,
		147,
		146,
		164,
		179,
		192,
		196,
		202,
		-1,
		224,
		-1,
		166,
		150,
		152,
		124,
		145,
		-1,
		182,
		177,
		167,
		152,
		143,
		-1,
		146,
		149,
		156,
		134,
		119,
		136,
		128,
		126,
		131,
		136,
		150,
		141,
		159,
		166,
		174,
		178,
		198,
		210,
		184,
		174,
		-1,
		156,
		161,
		120,
		128,
		147,
		185,
		149,
		-1,
		144,
		-1,
		136,
		161,
		-1,
		140,
		136,
		118,
		119,
		114,
		129,
		135,
		132,
		129,
		147,
		150,
		167,
		171,
		187,
		-1,
		-1,
		169,
		173,
		162,
		113,
		132,
		156,
		193,
		142,
		131,
		130,
		-1,
		121,
		151,
		148,
		134,
		121,
		111,
		112,
		120,
		133,
		112,
		131,
		134,
		156,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		139,
		110,
		134,
		176,
		160,
		153,
		141,
		106,
		106,
		100,
		-1,
		141,
		124,
		120,
		109,
		107,
		120,
		115,
		131,
		135,
		134,
		153,
		165,
		156,
		176,
		-1,
		-1,
		-1,
		169,
		158,
		159,
		105,
		128,
		165,
		139,
		125,
		130,
		105,
		98,
		92,
		144,
		141,
		108,
		116,
		108,
		97,
		111,
		119,
		123,
		132,
		141,
		147,
		171,
		171,
		177,
		-1,
		-1,
		176,
		166,
		150,
		152,
		149,
		119,
		126,
		158,
		130,
		143,
		-1,
		97,
		-1,
		86,
		94,
		93,
		99,
		111,
		97,
		102,
		113,
		125,
		138,
		134,
		141,
		176,
		176,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		169,
		164,
		139,
		116,
		100,
		136,
		-1,
		113,
		114,
		-1,
		91,
		85,
		91,
		90,
		97,
		94,
		94,
		108,
		116,
		112,
		128,
		134,
		126,
		162,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		162,
		141,
		134,
		154,
		95,
		147,
		-1,
		-1,
		98,
		91,
		-1,
		78,
		78,
		85,
		94,
		99,
		104,
		112,
		107,
		120,
		125,
		131,
		136,
		154,
		158,
		162,
		151,
		147,
		144,
		158,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		115,
		-1,
		107,
		99,
		89,
		83,
		77,
		88,
		89,
		109,
		101,
		115,
		115,
		121,
		129,
		114,
		117,
		133,
		131,
		149,
		157,
		149,
		143,
		142,
		154,
		-1,
		182,
		168,
		139,
		-1,
		-1,
		128,
		-1,
		92,
		106,
		122,
		-1,
		115,
		94,
		109,
		87,
		91,
		97,
		135,
		136,
		114,
		119,
		127,
		137,
		139,
		128,
		139,
		131,
		153,
		153,
		137,
		138,
		147,
		-1,
		188,
		175,
		133,
		129,
		118,
		138,
		89,
		77,
		109,
		-1,
		-1,
		115,
		-1,
		69,
		71,
		111,
		109,
		125,
		116,
		122,
		138,
		138,
		133,
		133,
		122,
		128,
		125,
		147,
		133,
		131,
		150,
		166,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		104,
		91,
		85,
		-1,
		126,
		-1,
		93,
		81,
		68,
		50,
		90,
		-1,
		133,
		117,
		122,
		-1,
		158,
		-1,
		130,
		133,
		124,
		121,
		119,
		130,
		128,
		139,
		156,
		-1,
		138,
		123,
		116,
		106,
		120,
		91,
		-1,
		146,
		-1,
		-1,
		80,
		74,
		74,
		43,
		40,
		149,
		129,
		123,
		122,
		141,
		128,
		127,
		115,
		115,
		118,
		122,
		135,
		155,
		146,
		158,
		-1,
		-1,
		-1,
		143,
		129,
		133,
		93,
		112,
		-1,
		-1,
		141,
		97,
		83,
		-1,
		35,
		123,
		113,
		122,
		123,
		128,
		129,
		119,
		117,
		113,
		122,
		126,
		131,
		136,
		157,
		153,
		171,
		-1,
		-1,
		126,
		131,
		119,
		105,
		111,
		-1,
		-1,
		-1,
		87,
		73,
		61,
		33,
		111,
		-1,
		-1,
		127,
		120,
		114,
		117,
		105,
		125,
		132,
		146,
		130,
		145,
		157,
		165,
		165,
		-1,
		129,
		116,
		-1,
		-1,
		110,
		100,
		-1,
		-1,
		-1,
		-1,
		51,
		32,
		44,
		65,
		90,
		126,
		-1,
		100,
		111,
		104,
		123,
		130,
		148,
		133,
		127,
		138,
		153,
		170,
		-1,
		-1,
		124,
		-1,
		83,
		-1,
		-1,
		-1,
		-1,
		23,
		38,
		58,
		64,
		76,
		-1,
		102,
		104,
		101,
		113,
		124,
		129,
		137,
		121,
		135,
		138,
		151,
		165,
		169,
		147,
		-1,
		73,
		-1,
		-1,
		-1,
		0,
		30,
		118,
		95,
		68,
		73,
		83,
		88,
		93,
		113,
		119,
		130,
		115,
		119,
		134,
		144,
		143,
		160,
		170,
		-1,
		-1,
		71,
		61,
		26,
		8,
		27,
		145,
		-1,
		-1,
		83,
		89,
		85,
		95,
		103,
		106,
		111,
		113,
		131,
		150,
		138,
		153,
		168,
		164,
		-1,
		-1,
		-1,
		87,
		-1,
		59,
		-1,
		-1,
		42,
		169,
		116,
		98,
		94,
		92,
		97,
		106,
		101,
		106,
		131,
		126,
		135,
		140,
		144,
		167,
		156,
		195,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		116,
		78,
		93,
		127,
		62,
		69,
		131,
		128,
		-1,
		98,
		135,
		107,
		114,
		106,
		119,
		124,
		130,
		134,
		141,
		157,
		156,
		151,
		187,
		178,
		184,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		122,
		95,
		113,
		103,
		79,
		-1,
		-1,
		146,
		143,
		122,
		116,
		120,
		113,
		108,
		146,
		122,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		174,
		255,
		248,
		227,
		235,
		266,
		-1,
		121,
		113,
		102,
		99,
		90,
		-1,
		-1,
		119,
		117,
		122,
		123,
		120,
		132,
		131,
		142,
		144,
		149,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		188,
		231,
		221,
		224,
		248,
		262,
		-1,
		118,
		-1,
		-1,
		124,
		103,
		111,
		114,
		118,
		169,
		137,
		132,
		134,
		136,
		140,
		131,
		154,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		211,
		211,
		215,
		-1,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		140,
		-1,
		137,
		-1,
		130,
		134,
		145,
		148,
		159,
		146,
		144,
		152,
		160,
		143,
		153,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		130,
		169,
		178,
		-1,
		149,
		-1,
		-1,
		-1,
		144,
		158,
		150,
		166,
		158,
		158,
		138,
		142,
		148,
		155,
		165,
		167,
		159,
		163,
		176,
		187,
		190,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		145,
		136,
		163,
		185,
		174,
		169,
		156,
		-1,
		-1,
		167,
		168,
		-1,
		-1,
		165,
		159,
		142,
		144,
		148,
		158,
		173,
		176,
		166,
		164,
		158,
		190,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		148,
		164,
		177,
		181,
		197,
		222,
		-1,
		159,
		-1,
		-1,
		188,
		-1,
		-1,
		201,
		164,
		153,
		144,
		150,
		156,
		167,
		184,
		172,
		173,
		163,
		173,
		186,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		163,
		151,
		157,
		164,
		181,
		211,
		-1,
		-1,
		175,
		166,
		-1,
		-1,
		199,
		197,
		186,
		-1,
		176,
		149,
		154,
		179,
		186,
		181,
		175,
		169,
		176,
		175,
		183,
		191,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		210,
		185,
		-1,
		-1,
		194,
		187,
		175,
		163,
		153,
		163,
		171,
		171,
		174,
		172,
		167,
		178,
		170,
		174,
		191,
		-1,
		252,
		-1,
		204,
		172,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		227,
		213,
		206,
		194,
		192,
		-1,
		228,
		212,
		193,
		-1,
		163,
		176,
		207,
		175,
		180,
		175,
		173,
		184,
		173,
		176,
		190,
		185,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		217,
		236,
		-1,
		218,
		207,
		192,
		184,
		-1,
		-1,
		200,
		196,
		-1,
		-1,
		164,
		189,
		178,
		186,
		181,
		177,
		183,
		186,
		175,
		179,
		191,
		-1,
		-1,
		197,
		200,
		205,
		-1,
		224,
		-1,
		242,
		-1,
		187,
		203,
		203,
		-1,
		-1,
		-1,
		202,
		165,
		182,
		196,
		201,
		199,
		190,
		181,
		188,
		186,
		182,
		193,
		-1,
		-1,
		-1,
		242,
		216,
		249,
		240,
		223,
		203,
		195,
		214,
		-1,
		184,
		-1,
		159,
		162,
		187,
		195,
		212,
		206,
		184,
		199,
		189,
		180,
		189,
		248,
		-1,
		218,
		251,
		215,
		209,
		185,
		189,
		205,
		-1,
		181,
		163,
		-1,
		191,
		181,
		229,
		204,
		199,
		186,
		193,
		193,
		186,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		205,
		190,
		181,
		-1,
		193,
		175,
		154,
		171,
		171,
		162,
		170,
		219,
		215,
		206,
		206,
		194,
		-1,
		321,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		209,
		182,
		170,
		176,
		172,
		158,
		164,
		166,
		174,
		172,
		169,
		181,
		177,
		197,
		193,
		225,
		-1,
		316,
		-1,
		250,
		-1,
		-1,
		232,
		212,
		204,
		193,
		182,
		180,
		171,
		162,
		184,
		200,
		184,
		182,
		187,
		192,
		-1,
		305,
		304,
		-1,
		251,
		243,
		229,
		-1,
		222,
		-1,
		228,
		189,
		-1,
		191,
		171,
		-1,
		193,
		189,
		-1,
		-1,
		292,
		267,
		-1,
		-1,
		-1,
		252,
		232,
		223,
		207,
		-1,
		182,
		182,
		-1,
		-1,
		-1,
		277,
		276,
		-1,
		245,
		248,
		-1,
		238,
		229,
		237,
		184,
		188,
		-1,
		-1,
		-1,
		286,
		267,
		261,
		260,
		258,
		253,
		250,
		236,
		220,
		198,
		187,
		208,
		-1,
		-1,
		-1,
		258,
		250,
		243,
		-1,
		-1,
		245,
		228,
		209,
		207,
		-1,
		-1,
		-1,
		280,
		261,
		-1,
		-1,
		235,
		-1,
		-1,
		241,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		269,
		-1,
		-1,
		-1,
		231,
		227,
		228,
		-1,
		-1,
		-1,
		-1,
		291,
		292,
		315,
		279,
		-1,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		294,
		292,
		-1,
		-1,
		-1,
		251,
		235,
		-1,
		221,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		256,
		-1,
		256,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		269,
		261,
		269,
		-1,
		241,
		243,
		-1,
		291,
		-1,
		-1,
		284,
		275,
		-1,
		-1,
		246,
		253,
		275,
		278,
		314,
		-1,
		265
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		250,
		252,
		218,
		212,
		251,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		241,
		240,
		210,
		208,
		217,
		222,
		229,
		-1,
		233,
		-1,
		262,
		241,
		252,
		257,
		203,
		200,
		220,
		239,
		226,
		218,
		277,
		233,
		204,
		198,
		216,
		211,
		220,
		212,
		-1,
		204,
		194,
		216,
		200,
		211,
		203,
		-1,
		-1,
		198,
		199,
		205,
		196,
		202,
		198,
		-1,
		208,
		192,
		-1,
		-1,
		188,
		194,
		178,
		181,
		189,
		187,
		200,
		192,
		187,
		-1,
		-1,
		184,
		180,
		187,
		174,
		170,
		187,
		200,
		182,
		196,
		195,
		-1,
		177,
		195,
		204,
		181,
		179,
		163,
		161,
		179,
		181,
		187,
		190,
		-1,
		170,
		172,
		182,
		190,
		195,
		179,
		166,
		166,
		176,
		169,
		188,
		179,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		167,
		169,
		186,
		178,
		168,
		183,
		176,
		169,
		166,
		164,
		161,
		177,
		178,
		188,
		-1,
		-1,
		223,
		192,
		227,
		184,
		169,
		-1,
		163,
		162,
		168,
		172,
		166,
		159,
		173,
		169,
		-1,
		155,
		154,
		185,
		171,
		182,
		183,
		-1,
		-1,
		181,
		173,
		158,
		161,
		158,
		158,
		177,
		176,
		168,
		154,
		150,
		156,
		159,
		159,
		165,
		149,
		159,
		163,
		174,
		189,
		-1,
		-1,
		244,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		153,
		170,
		160,
		181,
		187,
		178,
		170,
		164,
		152,
		154,
		151,
		164,
		152,
		146,
		171,
		175,
		169,
		190,
		185,
		-1,
		243,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		182,
		-1,
		172,
		178,
		188,
		173,
		170,
		157,
		145,
		158,
		143,
		150,
		149,
		153,
		155,
		188,
		166,
		188,
		185,
		214,
		219,
		213,
		222,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		190,
		189,
		164,
		182,
		185,
		174,
		165,
		152,
		141,
		152,
		141,
		138,
		146,
		155,
		166,
		161,
		160,
		178,
		193,
		206,
		210,
		216,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		191,
		181,
		166,
		157,
		-1,
		160,
		163,
		170,
		148,
		133,
		150,
		142,
		140,
		145,
		150,
		164,
		155,
		173,
		180,
		188,
		192,
		212,
		224,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		150,
		175,
		-1,
		154,
		150,
		132,
		133,
		128,
		143,
		149,
		146,
		143,
		161,
		164,
		181,
		185,
		201,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		165,
		162,
		148,
		135,
		125,
		126,
		134,
		147,
		126,
		145,
		148,
		170,
		198,
		176,
		188,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		155,
		138,
		134,
		123,
		121,
		134,
		129,
		145,
		149,
		148,
		167,
		179,
		170,
		190,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		158,
		155,
		122,
		130,
		122,
		111,
		125,
		133,
		137,
		146,
		155,
		161,
		185,
		185,
		191,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		108,
		107,
		113,
		125,
		111,
		116,
		127,
		139,
		152,
		148,
		155,
		190,
		190,
		175,
		195,
		198,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		105,
		104,
		111,
		108,
		108,
		122,
		130,
		126,
		142,
		148,
		140,
		176,
		-1,
		183,
		177,
		185,
		175,
		163,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		92,
		99,
		108,
		113,
		118,
		126,
		121,
		134,
		139,
		145,
		150,
		168,
		172,
		176,
		165,
		161,
		158,
		172,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		102,
		103,
		123,
		115,
		129,
		129,
		135,
		143,
		128,
		131,
		147,
		145,
		163,
		171,
		163,
		157,
		156,
		168,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		105,
		111,
		149,
		150,
		128,
		133,
		141,
		151,
		153,
		142,
		153,
		145,
		167,
		167,
		151,
		152,
		161,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		129,
		-1,
		83,
		85,
		125,
		123,
		139,
		130,
		136,
		152,
		152,
		147,
		147,
		136,
		142,
		139,
		161,
		147,
		145,
		164,
		180,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		107,
		95,
		82,
		64,
		104,
		-1,
		147,
		131,
		136,
		-1,
		172,
		-1,
		144,
		147,
		138,
		135,
		133,
		144,
		142,
		153,
		170,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		94,
		88,
		88,
		57,
		54,
		163,
		143,
		137,
		136,
		155,
		142,
		141,
		129,
		129,
		132,
		136,
		149,
		169,
		160,
		172,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		155,
		111,
		97,
		-1,
		49,
		137,
		127,
		136,
		137,
		142,
		143,
		133,
		131,
		127,
		136,
		140,
		145,
		150,
		171,
		167,
		185,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		101,
		87,
		75,
		47,
		125,
		-1,
		-1,
		141,
		134,
		128,
		131,
		119,
		139,
		146,
		160,
		144,
		159,
		171,
		179,
		179,
		-1,
		143,
		130,
		-1,
		-1,
		139,
		129,
		-1,
		-1,
		-1,
		-1,
		65,
		46,
		58,
		79,
		104,
		140,
		-1,
		114,
		125,
		118,
		137,
		144,
		162,
		147,
		141,
		152,
		167,
		184,
		-1,
		-1,
		153,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		37,
		52,
		72,
		78,
		90,
		-1,
		116,
		118,
		115,
		127,
		138,
		143,
		151,
		135,
		149,
		152,
		165,
		179,
		183,
		176,
		-1,
		102,
		-1,
		-1,
		-1,
		29,
		0,
		132,
		109,
		82,
		87,
		97,
		102,
		107,
		127,
		133,
		144,
		129,
		133,
		148,
		158,
		157,
		174,
		184,
		-1,
		-1,
		100,
		90,
		55,
		37,
		27,
		159,
		-1,
		-1,
		97,
		103,
		99,
		109,
		117,
		120,
		125,
		127,
		145,
		164,
		152,
		167,
		182,
		178,
		-1,
		-1,
		-1,
		116,
		-1,
		88,
		-1,
		-1,
		42,
		183,
		130,
		112,
		108,
		106,
		111,
		120,
		115,
		120,
		145,
		140,
		149,
		154,
		158,
		181,
		170,
		209,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		138,
		107,
		122,
		127,
		62,
		69,
		145,
		142,
		-1,
		112,
		149,
		121,
		128,
		120,
		133,
		138,
		144,
		148,
		155,
		171,
		170,
		165,
		201,
		192,
		198,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		131,
		124,
		113,
		103,
		79,
		-1,
		-1,
		146,
		143,
		136,
		130,
		134,
		127,
		122,
		160,
		136,
		144,
		148,
		152,
		158,
		163,
		168,
		174,
		189,
		204,
		-1,
		188,
		266,
		259,
		227,
		235,
		266,
		-1,
		121,
		113,
		123,
		99,
		90,
		-1,
		-1,
		119,
		121,
		126,
		135,
		134,
		146,
		145,
		156,
		158,
		163,
		151,
		150,
		168,
		172,
		181,
		188,
		178,
		191,
		195,
		-1,
		202,
		242,
		221,
		224,
		248,
		262,
		-1,
		118,
		-1,
		-1,
		130,
		103,
		111,
		114,
		118,
		173,
		149,
		144,
		148,
		150,
		154,
		145,
		168,
		159,
		159,
		162,
		177,
		182,
		174,
		188,
		188,
		189,
		-1,
		211,
		222,
		215,
		-1,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		146,
		-1,
		137,
		-1,
		130,
		134,
		157,
		160,
		173,
		160,
		158,
		166,
		174,
		157,
		167,
		163,
		164,
		173,
		184,
		196,
		195,
		196,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		130,
		169,
		184,
		-1,
		155,
		-1,
		-1,
		-1,
		144,
		170,
		162,
		178,
		172,
		172,
		152,
		156,
		162,
		169,
		179,
		181,
		173,
		177,
		190,
		201,
		204,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		145,
		136,
		163,
		191,
		180,
		175,
		162,
		-1,
		-1,
		167,
		180,
		-1,
		-1,
		179,
		173,
		156,
		158,
		162,
		172,
		187,
		190,
		180,
		178,
		172,
		204,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		148,
		164,
		177,
		181,
		197,
		222,
		-1,
		165,
		-1,
		-1,
		188,
		-1,
		-1,
		215,
		178,
		167,
		158,
		164,
		170,
		181,
		198,
		186,
		187,
		177,
		187,
		200,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		163,
		151,
		157,
		164,
		181,
		211,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		207,
		211,
		200,
		-1,
		190,
		163,
		168,
		193,
		200,
		195,
		189,
		183,
		190,
		189,
		197,
		205,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		216,
		191,
		-1,
		-1,
		208,
		201,
		189,
		177,
		167,
		177,
		185,
		185,
		188,
		186,
		181,
		192,
		184,
		188,
		205,
		-1,
		252,
		-1,
		204,
		172,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		233,
		219,
		212,
		200,
		198,
		-1,
		242,
		226,
		207,
		-1,
		177,
		190,
		221,
		189,
		194,
		189,
		187,
		198,
		187,
		190,
		204,
		199,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		217,
		236,
		-1,
		224,
		213,
		198,
		190,
		-1,
		-1,
		214,
		210,
		-1,
		-1,
		178,
		203,
		192,
		200,
		195,
		191,
		197,
		200,
		189,
		193,
		205,
		-1,
		-1,
		197,
		200,
		205,
		-1,
		226,
		-1,
		248,
		-1,
		193,
		209,
		211,
		-1,
		-1,
		-1,
		216,
		179,
		196,
		210,
		215,
		213,
		204,
		195,
		202,
		200,
		196,
		207,
		-1,
		-1,
		-1,
		256,
		230,
		255,
		246,
		229,
		209,
		201,
		226,
		-1,
		198,
		-1,
		173,
		176,
		201,
		209,
		226,
		220,
		198,
		213,
		203,
		194,
		203,
		262,
		-1,
		232,
		265,
		229,
		215,
		199,
		203,
		219,
		-1,
		195,
		177,
		-1,
		205,
		195,
		243,
		218,
		213,
		200,
		207,
		207,
		200,
		-1,
		-1,
		-1,
		234,
		233,
		225,
		219,
		219,
		204,
		195,
		-1,
		207,
		189,
		168,
		185,
		185,
		176,
		184,
		233,
		229,
		220,
		220,
		208,
		-1,
		324,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		228,
		223,
		196,
		184,
		190,
		186,
		172,
		178,
		180,
		188,
		186,
		183,
		195,
		191,
		211,
		207,
		239,
		-1,
		330,
		-1,
		264,
		-1,
		-1,
		246,
		226,
		218,
		207,
		196,
		194,
		185,
		176,
		198,
		214,
		198,
		196,
		201,
		206,
		-1,
		319,
		318,
		-1,
		265,
		257,
		243,
		-1,
		236,
		-1,
		242,
		203,
		-1,
		205,
		185,
		-1,
		207,
		203,
		-1,
		-1,
		306,
		281,
		-1,
		-1,
		-1,
		266,
		246,
		237,
		221,
		-1,
		196,
		196,
		-1,
		-1,
		-1,
		291,
		290,
		-1,
		259,
		262,
		-1,
		252,
		243,
		251,
		198,
		202,
		-1,
		-1,
		-1,
		300,
		281,
		275,
		274,
		272,
		267,
		264,
		250,
		234,
		212,
		201,
		222,
		-1,
		-1,
		-1,
		272,
		264,
		257,
		-1,
		-1,
		259,
		242,
		223,
		221,
		-1,
		-1,
		-1,
		294,
		275,
		-1,
		-1,
		249,
		-1,
		-1,
		255,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		283,
		-1,
		-1,
		-1,
		245,
		241,
		242,
		-1,
		-1,
		-1,
		-1,
		305,
		306,
		329,
		293,
		-1,
		-1,
		-1,
		237,
		231,
		-1,
		-1,
		308,
		306,
		-1,
		-1,
		-1,
		265,
		249,
		-1,
		235,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		270,
		-1,
		270,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		283,
		275,
		283,
		-1,
		255,
		257,
		-1,
		305,
		-1,
		-1,
		298,
		289,
		-1,
		-1,
		260,
		267,
		289,
		292,
		328,
		-1,
		279
	],
	[
		-1,
		256,
		245,
		256,
		264,
		237,
		244,
		-1,
		263,
		267,
		233,
		227,
		266,
		235,
		241,
		252,
		-1,
		-1,
		-1,
		256,
		255,
		223,
		221,
		230,
		235,
		242,
		-1,
		241,
		-1,
		277,
		256,
		267,
		272,
		216,
		213,
		233,
		252,
		234,
		226,
		292,
		246,
		217,
		211,
		229,
		219,
		228,
		220,
		-1,
		217,
		207,
		229,
		208,
		219,
		211,
		-1,
		-1,
		211,
		212,
		218,
		204,
		210,
		206,
		-1,
		216,
		200,
		-1,
		-1,
		201,
		202,
		186,
		189,
		197,
		195,
		208,
		200,
		195,
		-1,
		-1,
		192,
		188,
		195,
		182,
		178,
		195,
		208,
		190,
		204,
		203,
		-1,
		198,
		216,
		221,
		189,
		187,
		171,
		169,
		187,
		189,
		195,
		195,
		-1,
		207,
		208,
		203,
		211,
		211,
		187,
		174,
		174,
		184,
		177,
		196,
		184,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		207,
		190,
		207,
		199,
		189,
		204,
		197,
		177,
		174,
		172,
		169,
		185,
		183,
		193,
		-1,
		-1,
		279,
		248,
		283,
		240,
		225,
		-1,
		203,
		183,
		189,
		193,
		187,
		180,
		194,
		190,
		-1,
		163,
		162,
		190,
		176,
		187,
		239,
		-1,
		-1,
		237,
		229,
		214,
		217,
		213,
		209,
		198,
		197,
		189,
		175,
		171,
		177,
		180,
		180,
		186,
		157,
		167,
		171,
		169,
		194,
		-1,
		-1,
		229,
		-1,
		-1,
		236,
		219,
		-1,
		202,
		209,
		209,
		225,
		211,
		232,
		208,
		199,
		191,
		185,
		173,
		175,
		172,
		185,
		173,
		154,
		179,
		183,
		164,
		185,
		180,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		195,
		198,
		204,
		228,
		238,
		-1,
		220,
		208,
		209,
		194,
		191,
		178,
		166,
		179,
		164,
		171,
		170,
		158,
		156,
		186,
		161,
		183,
		180,
		199,
		204,
		198,
		207,
		-1,
		244,
		240,
		236,
		243,
		192,
		-1,
		-1,
		232,
		-1,
		246,
		245,
		220,
		205,
		208,
		195,
		186,
		173,
		162,
		173,
		162,
		159,
		167,
		150,
		165,
		156,
		155,
		173,
		183,
		191,
		195,
		201,
		-1,
		294,
		-1,
		236,
		220,
		222,
		194,
		215,
		-1,
		252,
		247,
		237,
		222,
		213,
		-1,
		204,
		201,
		191,
		169,
		154,
		171,
		163,
		161,
		163,
		145,
		159,
		150,
		168,
		175,
		173,
		177,
		197,
		209,
		254,
		244,
		-1,
		226,
		231,
		190,
		198,
		217,
		255,
		219,
		-1,
		214,
		-1,
		206,
		219,
		-1,
		175,
		171,
		153,
		154,
		149,
		164,
		156,
		141,
		138,
		156,
		159,
		166,
		170,
		186,
		-1,
		-1,
		239,
		243,
		232,
		183,
		202,
		226,
		263,
		212,
		201,
		200,
		-1,
		191,
		189,
		186,
		174,
		161,
		146,
		147,
		155,
		167,
		146,
		140,
		137,
		157,
		183,
		161,
		173,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		209,
		180,
		204,
		246,
		230,
		223,
		211,
		176,
		176,
		170,
		-1,
		185,
		164,
		155,
		144,
		142,
		155,
		147,
		155,
		135,
		133,
		152,
		164,
		155,
		166,
		-1,
		-1,
		-1,
		239,
		228,
		229,
		175,
		198,
		235,
		209,
		195,
		200,
		175,
		168,
		162,
		198,
		181,
		162,
		151,
		143,
		132,
		143,
		151,
		149,
		131,
		140,
		146,
		170,
		154,
		160,
		-1,
		-1,
		246,
		236,
		220,
		222,
		219,
		189,
		196,
		228,
		200,
		213,
		-1,
		167,
		-1,
		156,
		164,
		156,
		151,
		148,
		135,
		134,
		148,
		148,
		138,
		133,
		140,
		175,
		175,
		144,
		164,
		167,
		-1,
		-1,
		-1,
		239,
		234,
		209,
		186,
		170,
		206,
		-1,
		183,
		184,
		-1,
		161,
		155,
		161,
		158,
		154,
		139,
		143,
		145,
		148,
		136,
		142,
		143,
		125,
		149,
		-1,
		152,
		146,
		154,
		144,
		132,
		-1,
		-1,
		-1,
		232,
		211,
		204,
		224,
		165,
		217,
		-1,
		-1,
		168,
		161,
		-1,
		148,
		148,
		151,
		143,
		137,
		144,
		139,
		130,
		143,
		136,
		130,
		124,
		137,
		141,
		145,
		134,
		130,
		127,
		141,
		-1,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		185,
		-1,
		177,
		169,
		159,
		153,
		147,
		158,
		159,
		165,
		149,
		152,
		147,
		144,
		134,
		125,
		118,
		129,
		114,
		132,
		140,
		132,
		126,
		125,
		137,
		-1,
		252,
		238,
		209,
		-1,
		-1,
		198,
		-1,
		162,
		176,
		192,
		-1,
		185,
		164,
		179,
		157,
		161,
		163,
		156,
		157,
		127,
		132,
		134,
		122,
		125,
		119,
		122,
		114,
		136,
		136,
		120,
		121,
		130,
		-1,
		258,
		245,
		203,
		199,
		188,
		208,
		159,
		147,
		179,
		-1,
		-1,
		185,
		-1,
		139,
		141,
		177,
		175,
		146,
		121,
		128,
		146,
		119,
		114,
		124,
		113,
		110,
		108,
		130,
		116,
		114,
		133,
		149,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		174,
		161,
		155,
		-1,
		196,
		-1,
		163,
		151,
		138,
		120,
		160,
		-1,
		120,
		116,
		123,
		-1,
		139,
		-1,
		111,
		114,
		105,
		102,
		102,
		113,
		111,
		122,
		139,
		-1,
		208,
		193,
		186,
		176,
		190,
		161,
		-1,
		216,
		-1,
		-1,
		150,
		144,
		144,
		113,
		110,
		136,
		116,
		108,
		123,
		122,
		109,
		108,
		96,
		96,
		99,
		105,
		118,
		138,
		129,
		140,
		-1,
		-1,
		-1,
		213,
		199,
		203,
		163,
		182,
		-1,
		-1,
		211,
		167,
		153,
		-1,
		105,
		123,
		113,
		114,
		104,
		109,
		110,
		100,
		98,
		94,
		103,
		107,
		114,
		119,
		140,
		134,
		154,
		-1,
		-1,
		196,
		201,
		189,
		175,
		194,
		-1,
		-1,
		-1,
		157,
		158,
		124,
		103,
		111,
		-1,
		-1,
		108,
		101,
		95,
		98,
		86,
		106,
		113,
		127,
		113,
		128,
		139,
		147,
		146,
		-1,
		199,
		186,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		-1,
		-1,
		136,
		81,
		70,
		65,
		67,
		107,
		-1,
		81,
		92,
		85,
		104,
		111,
		129,
		114,
		108,
		119,
		134,
		151,
		-1,
		-1,
		211,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		93,
		87,
		58,
		51,
		53,
		-1,
		83,
		85,
		82,
		94,
		105,
		110,
		118,
		102,
		116,
		119,
		132,
		146,
		150,
		234,
		-1,
		165,
		-1,
		-1,
		-1,
		111,
		126,
		0,
		25,
		49,
		54,
		64,
		69,
		74,
		94,
		100,
		111,
		96,
		100,
		115,
		125,
		124,
		141,
		151,
		-1,
		-1,
		163,
		159,
		137,
		119,
		123,
		27,
		-1,
		-1,
		48,
		58,
		66,
		76,
		84,
		87,
		92,
		94,
		112,
		131,
		119,
		134,
		149,
		145,
		-1,
		-1,
		-1,
		175,
		-1,
		170,
		-1,
		-1,
		138,
		138,
		85,
		67,
		63,
		59,
		78,
		87,
		82,
		87,
		112,
		107,
		116,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		100,
		97,
		-1,
		65,
		108,
		88,
		95,
		87,
		100,
		105,
		111,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		114,
		111,
		89,
		97,
		101,
		94,
		89,
		127,
		103,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		199,
		236,
		229,
		197,
		205,
		236,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		87,
		84,
		89,
		98,
		101,
		113,
		112,
		123,
		125,
		130,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		192,
		212,
		191,
		194,
		218,
		232,
		-1,
		134,
		-1,
		-1,
		146,
		118,
		102,
		92,
		86,
		136,
		111,
		106,
		115,
		117,
		121,
		112,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		162,
		-1,
		129,
		-1,
		104,
		108,
		118,
		122,
		140,
		127,
		125,
		133,
		141,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		146,
		185,
		200,
		-1,
		171,
		-1,
		-1,
		-1,
		118,
		131,
		123,
		140,
		139,
		139,
		119,
		123,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		161,
		152,
		179,
		205,
		196,
		191,
		178,
		-1,
		-1,
		141,
		141,
		-1,
		-1,
		146,
		140,
		123,
		125,
		129,
		139,
		154,
		157,
		147,
		145,
		139,
		171,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		180,
		175,
		179,
		195,
		220,
		-1,
		181,
		-1,
		-1,
		162,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		137,
		148,
		165,
		153,
		154,
		144,
		154,
		167,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		151,
		149,
		155,
		162,
		179,
		209,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		130,
		135,
		160,
		167,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		-1,
		213,
		207,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		152,
		152,
		155,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		222,
		-1,
		174,
		150,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		230,
		216,
		209,
		197,
		195,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		162,
		165,
		-1,
		-1,
		187,
		206,
		-1,
		221,
		210,
		195,
		187,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		169,
		170,
		175,
		-1,
		196,
		-1,
		223,
		-1,
		190,
		196,
		184,
		-1,
		-1,
		-1,
		183,
		146,
		163,
		177,
		182,
		180,
		171,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		223,
		197,
		230,
		221,
		204,
		184,
		176,
		195,
		-1,
		165,
		-1,
		140,
		143,
		168,
		176,
		193,
		187,
		165,
		180,
		170,
		161,
		170,
		229,
		-1,
		199,
		232,
		196,
		190,
		166,
		170,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		210,
		185,
		180,
		167,
		174,
		174,
		167,
		-1,
		-1,
		-1,
		201,
		200,
		192,
		186,
		186,
		171,
		162,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		200,
		196,
		187,
		187,
		175,
		-1,
		294,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		195,
		190,
		163,
		151,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		174,
		206,
		-1,
		297,
		-1,
		231,
		-1,
		-1,
		213,
		193,
		185,
		174,
		163,
		161,
		152,
		143,
		165,
		181,
		165,
		163,
		168,
		173,
		-1,
		286,
		285,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		209,
		170,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		273,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		204,
		188,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		258,
		257,
		-1,
		226,
		229,
		-1,
		219,
		210,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		241,
		239,
		234,
		231,
		217,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		239,
		231,
		224,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		250,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		296,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		180,
		198,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		189,
		190,
		185,
		193,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		261,
		230,
		265,
		222,
		207,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		145,
		144,
		172,
		158,
		169,
		221,
		-1,
		-1,
		219,
		211,
		196,
		199,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		211,
		-1,
		-1,
		218,
		201,
		-1,
		184,
		191,
		191,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		177,
		180,
		186,
		210,
		220,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		140,
		138,
		168,
		143,
		165,
		162,
		181,
		186,
		180,
		189,
		-1,
		226,
		222,
		218,
		225,
		174,
		-1,
		-1,
		214,
		-1,
		228,
		227,
		202,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		132,
		147,
		138,
		137,
		155,
		165,
		173,
		177,
		183,
		-1,
		276,
		-1,
		218,
		202,
		204,
		176,
		197,
		-1,
		234,
		229,
		219,
		204,
		195,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		145,
		127,
		141,
		132,
		150,
		157,
		155,
		159,
		179,
		191,
		236,
		226,
		-1,
		208,
		213,
		172,
		180,
		199,
		237,
		201,
		-1,
		196,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		138,
		123,
		120,
		138,
		141,
		148,
		152,
		168,
		-1,
		-1,
		221,
		225,
		214,
		165,
		184,
		208,
		245,
		194,
		183,
		182,
		-1,
		173,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		149,
		128,
		122,
		119,
		139,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		191,
		162,
		186,
		228,
		212,
		205,
		193,
		158,
		158,
		152,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		129,
		137,
		117,
		115,
		134,
		146,
		137,
		148,
		-1,
		-1,
		-1,
		221,
		210,
		211,
		157,
		180,
		217,
		191,
		177,
		182,
		157,
		150,
		144,
		180,
		163,
		144,
		133,
		125,
		114,
		125,
		133,
		131,
		113,
		122,
		128,
		152,
		136,
		142,
		-1,
		-1,
		228,
		218,
		202,
		204,
		201,
		171,
		178,
		210,
		182,
		195,
		-1,
		149,
		-1,
		138,
		146,
		138,
		133,
		130,
		117,
		116,
		130,
		130,
		120,
		115,
		122,
		157,
		157,
		126,
		146,
		149,
		-1,
		-1,
		-1,
		221,
		216,
		191,
		168,
		152,
		188,
		-1,
		165,
		166,
		-1,
		143,
		137,
		143,
		140,
		136,
		121,
		125,
		127,
		130,
		118,
		124,
		125,
		107,
		131,
		-1,
		134,
		128,
		136,
		126,
		114,
		-1,
		-1,
		-1,
		214,
		193,
		186,
		206,
		147,
		199,
		-1,
		-1,
		150,
		143,
		-1,
		130,
		130,
		133,
		125,
		119,
		126,
		121,
		112,
		125,
		118,
		112,
		106,
		119,
		123,
		127,
		116,
		112,
		109,
		123,
		-1,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		167,
		-1,
		159,
		151,
		141,
		135,
		129,
		140,
		141,
		147,
		131,
		134,
		129,
		126,
		116,
		107,
		100,
		111,
		96,
		114,
		122,
		114,
		108,
		107,
		119,
		-1,
		234,
		220,
		191,
		-1,
		-1,
		180,
		-1,
		144,
		158,
		174,
		-1,
		167,
		146,
		161,
		139,
		143,
		145,
		138,
		139,
		109,
		114,
		116,
		104,
		107,
		101,
		104,
		96,
		118,
		118,
		102,
		103,
		112,
		-1,
		240,
		227,
		185,
		181,
		170,
		190,
		141,
		129,
		161,
		-1,
		-1,
		167,
		-1,
		121,
		123,
		159,
		157,
		128,
		103,
		110,
		128,
		101,
		96,
		106,
		95,
		92,
		90,
		112,
		98,
		96,
		115,
		131,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		156,
		143,
		137,
		-1,
		178,
		-1,
		145,
		133,
		120,
		102,
		142,
		-1,
		102,
		98,
		105,
		-1,
		121,
		-1,
		93,
		96,
		87,
		84,
		84,
		95,
		93,
		104,
		121,
		-1,
		190,
		175,
		168,
		158,
		172,
		143,
		-1,
		198,
		-1,
		-1,
		132,
		126,
		126,
		95,
		92,
		118,
		98,
		90,
		105,
		104,
		91,
		90,
		78,
		78,
		81,
		87,
		100,
		120,
		111,
		122,
		-1,
		-1,
		-1,
		195,
		181,
		185,
		145,
		164,
		-1,
		-1,
		193,
		149,
		135,
		-1,
		87,
		105,
		95,
		96,
		86,
		91,
		92,
		82,
		80,
		76,
		85,
		89,
		96,
		101,
		122,
		116,
		136,
		-1,
		-1,
		178,
		183,
		171,
		157,
		176,
		-1,
		-1,
		-1,
		139,
		140,
		106,
		85,
		93,
		-1,
		-1,
		90,
		83,
		77,
		80,
		68,
		88,
		95,
		109,
		95,
		110,
		121,
		129,
		128,
		-1,
		181,
		168,
		-1,
		-1,
		179,
		170,
		-1,
		-1,
		-1,
		-1,
		118,
		63,
		52,
		47,
		49,
		89,
		-1,
		63,
		74,
		67,
		86,
		93,
		111,
		96,
		90,
		101,
		116,
		133,
		-1,
		-1,
		193,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		75,
		69,
		40,
		33,
		35,
		-1,
		65,
		67,
		64,
		76,
		87,
		92,
		100,
		84,
		98,
		101,
		114,
		128,
		132,
		216,
		-1,
		147,
		-1,
		-1,
		-1,
		93,
		108,
		30,
		0,
		31,
		36,
		46,
		51,
		56,
		76,
		82,
		93,
		78,
		82,
		97,
		107,
		106,
		123,
		133,
		-1,
		-1,
		145,
		141,
		119,
		101,
		105,
		57,
		-1,
		-1,
		30,
		40,
		48,
		58,
		66,
		69,
		74,
		76,
		94,
		113,
		101,
		116,
		131,
		127,
		-1,
		-1,
		-1,
		157,
		-1,
		152,
		-1,
		-1,
		120,
		120,
		67,
		49,
		45,
		41,
		60,
		69,
		64,
		69,
		94,
		89,
		98,
		103,
		107,
		130,
		119,
		158,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		136,
		128,
		123,
		129,
		131,
		122,
		82,
		79,
		-1,
		47,
		90,
		70,
		77,
		69,
		82,
		87,
		93,
		97,
		104,
		120,
		119,
		114,
		150,
		141,
		147,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		129,
		125,
		115,
		105,
		108,
		-1,
		-1,
		96,
		93,
		71,
		79,
		83,
		76,
		71,
		109,
		85,
		93,
		97,
		101,
		107,
		112,
		117,
		123,
		138,
		153,
		-1,
		181,
		218,
		211,
		179,
		187,
		218,
		-1,
		119,
		111,
		122,
		97,
		99,
		-1,
		-1,
		69,
		66,
		71,
		80,
		83,
		95,
		94,
		105,
		107,
		112,
		100,
		99,
		117,
		121,
		130,
		137,
		127,
		140,
		144,
		-1,
		174,
		194,
		173,
		176,
		200,
		214,
		-1,
		116,
		-1,
		-1,
		128,
		100,
		84,
		74,
		68,
		118,
		93,
		88,
		97,
		99,
		103,
		94,
		117,
		108,
		108,
		111,
		126,
		131,
		123,
		137,
		137,
		138,
		-1,
		163,
		174,
		167,
		-1,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		144,
		-1,
		111,
		-1,
		86,
		90,
		100,
		104,
		122,
		109,
		107,
		115,
		123,
		106,
		116,
		112,
		113,
		122,
		133,
		145,
		144,
		145,
		188,
		144,
		147,
		158,
		169,
		184,
		188,
		-1,
		128,
		167,
		182,
		-1,
		153,
		-1,
		-1,
		-1,
		100,
		113,
		105,
		122,
		121,
		121,
		101,
		105,
		111,
		118,
		128,
		130,
		122,
		126,
		139,
		150,
		153,
		184,
		175,
		188,
		133,
		133,
		154,
		163,
		184,
		143,
		134,
		161,
		187,
		178,
		173,
		160,
		-1,
		-1,
		123,
		123,
		-1,
		-1,
		128,
		122,
		105,
		107,
		111,
		121,
		136,
		139,
		129,
		127,
		121,
		153,
		-1,
		177,
		176,
		165,
		162,
		138,
		129,
		124,
		151,
		-1,
		-1,
		146,
		162,
		157,
		161,
		177,
		202,
		-1,
		163,
		-1,
		-1,
		144,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		119,
		130,
		147,
		135,
		136,
		126,
		136,
		149,
		161,
		158,
		146,
		144,
		167,
		132,
		120,
		-1,
		133,
		131,
		137,
		144,
		161,
		191,
		-1,
		-1,
		179,
		170,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		112,
		117,
		142,
		149,
		144,
		138,
		132,
		139,
		138,
		146,
		154,
		170,
		184,
		173,
		169,
		168,
		176,
		125,
		118,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		189,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		134,
		134,
		137,
		135,
		130,
		141,
		133,
		137,
		154,
		-1,
		204,
		-1,
		156,
		132,
		146,
		161,
		169,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		136,
		147,
		136,
		139,
		153,
		148,
		-1,
		-1,
		144,
		147,
		-1,
		-1,
		169,
		188,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		140,
		146,
		149,
		138,
		142,
		154,
		-1,
		-1,
		151,
		152,
		157,
		-1,
		178,
		-1,
		205,
		-1,
		172,
		178,
		166,
		-1,
		-1,
		-1,
		165,
		128,
		145,
		159,
		164,
		162,
		153,
		144,
		151,
		149,
		145,
		156,
		-1,
		-1,
		-1,
		205,
		179,
		212,
		203,
		186,
		166,
		158,
		177,
		-1,
		147,
		-1,
		122,
		125,
		150,
		158,
		175,
		169,
		147,
		162,
		152,
		143,
		152,
		211,
		-1,
		181,
		214,
		178,
		172,
		148,
		152,
		168,
		-1,
		144,
		126,
		-1,
		154,
		144,
		192,
		167,
		162,
		149,
		156,
		156,
		149,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		168,
		153,
		144,
		-1,
		156,
		138,
		117,
		134,
		134,
		125,
		133,
		182,
		178,
		169,
		169,
		157,
		-1,
		276,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		172,
		145,
		133,
		139,
		135,
		121,
		127,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		156,
		188,
		-1,
		279,
		-1,
		213,
		-1,
		-1,
		195,
		175,
		167,
		156,
		145,
		143,
		134,
		125,
		147,
		163,
		147,
		145,
		150,
		155,
		-1,
		268,
		267,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		191,
		152,
		-1,
		154,
		134,
		-1,
		156,
		152,
		-1,
		-1,
		255,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		186,
		170,
		-1,
		145,
		145,
		-1,
		-1,
		-1,
		240,
		239,
		-1,
		208,
		211,
		-1,
		201,
		192,
		200,
		147,
		151,
		-1,
		-1,
		-1,
		249,
		230,
		224,
		223,
		221,
		216,
		213,
		199,
		183,
		161,
		150,
		171,
		-1,
		-1,
		-1,
		221,
		213,
		206,
		-1,
		-1,
		208,
		191,
		172,
		170,
		-1,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		198,
		-1,
		-1,
		204,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		232,
		-1,
		-1,
		-1,
		194,
		190,
		191,
		-1,
		-1,
		-1,
		-1,
		254,
		255,
		278,
		242,
		-1,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		257,
		255,
		-1,
		-1,
		-1,
		214,
		198,
		-1,
		184,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		219,
		-1,
		219,
		194,
		201,
		-1,
		-1,
		-1,
		-1,
		232,
		224,
		232,
		-1,
		204,
		206,
		-1,
		254,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		209,
		216,
		238,
		241,
		277,
		-1,
		228
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		149,
		167,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		158,
		159,
		154,
		162,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		158,
		141,
		158,
		150,
		140,
		155,
		148,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		232,
		201,
		236,
		193,
		178,
		-1,
		154,
		134,
		140,
		144,
		138,
		131,
		145,
		141,
		-1,
		114,
		113,
		141,
		127,
		138,
		192,
		-1,
		-1,
		190,
		182,
		167,
		170,
		164,
		160,
		149,
		148,
		140,
		126,
		122,
		128,
		131,
		131,
		137,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		162,
		176,
		162,
		183,
		159,
		150,
		142,
		136,
		124,
		126,
		123,
		136,
		124,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		191,
		-1,
		171,
		159,
		160,
		145,
		142,
		129,
		117,
		130,
		115,
		122,
		121,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		199,
		198,
		173,
		156,
		159,
		146,
		137,
		124,
		113,
		124,
		113,
		110,
		118,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		200,
		190,
		175,
		166,
		-1,
		155,
		152,
		142,
		120,
		105,
		122,
		114,
		112,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		157,
		170,
		-1,
		126,
		122,
		104,
		105,
		100,
		115,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		140,
		137,
		125,
		112,
		97,
		98,
		106,
		118,
		97,
		91,
		88,
		108,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		136,
		115,
		106,
		95,
		93,
		106,
		98,
		106,
		86,
		84,
		103,
		115,
		106,
		117,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		149,
		132,
		113,
		102,
		94,
		83,
		94,
		102,
		100,
		82,
		91,
		97,
		121,
		105,
		111,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		117,
		107,
		102,
		99,
		86,
		85,
		99,
		99,
		89,
		84,
		91,
		126,
		126,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		114,
		109,
		105,
		90,
		94,
		96,
		99,
		87,
		93,
		94,
		76,
		100,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		100,
		102,
		94,
		88,
		95,
		90,
		81,
		94,
		87,
		81,
		75,
		88,
		92,
		96,
		85,
		81,
		78,
		92,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		111,
		111,
		116,
		100,
		103,
		98,
		95,
		85,
		76,
		69,
		80,
		65,
		83,
		91,
		83,
		77,
		76,
		88,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		114,
		114,
		107,
		108,
		78,
		83,
		85,
		73,
		76,
		70,
		73,
		65,
		87,
		87,
		71,
		72,
		81,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		138,
		-1,
		92,
		94,
		128,
		126,
		97,
		72,
		79,
		97,
		70,
		65,
		75,
		64,
		61,
		59,
		81,
		67,
		65,
		84,
		100,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		116,
		104,
		91,
		73,
		113,
		-1,
		71,
		67,
		74,
		-1,
		90,
		-1,
		62,
		65,
		56,
		53,
		53,
		64,
		62,
		73,
		90,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		103,
		97,
		97,
		66,
		63,
		87,
		67,
		59,
		74,
		73,
		60,
		59,
		47,
		47,
		50,
		56,
		69,
		89,
		80,
		91,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		164,
		120,
		106,
		-1,
		58,
		76,
		66,
		65,
		55,
		60,
		61,
		51,
		49,
		45,
		54,
		58,
		65,
		70,
		91,
		85,
		105,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		110,
		111,
		77,
		56,
		64,
		-1,
		-1,
		59,
		52,
		46,
		49,
		37,
		57,
		64,
		78,
		64,
		79,
		90,
		98,
		97,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		89,
		34,
		23,
		18,
		22,
		58,
		-1,
		32,
		43,
		36,
		55,
		62,
		80,
		65,
		59,
		70,
		85,
		102,
		-1,
		-1,
		164,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		46,
		40,
		11,
		4,
		8,
		-1,
		34,
		36,
		33,
		45,
		56,
		61,
		69,
		53,
		67,
		70,
		83,
		97,
		101,
		187,
		-1,
		130,
		-1,
		-1,
		-1,
		64,
		79,
		50,
		27,
		0,
		5,
		15,
		20,
		25,
		45,
		51,
		62,
		47,
		51,
		66,
		76,
		75,
		92,
		102,
		-1,
		-1,
		128,
		124,
		90,
		72,
		76,
		77,
		-1,
		-1,
		15,
		21,
		17,
		27,
		35,
		38,
		43,
		45,
		63,
		82,
		70,
		85,
		100,
		96,
		-1,
		-1,
		-1,
		140,
		-1,
		123,
		-1,
		-1,
		91,
		101,
		48,
		30,
		26,
		24,
		29,
		38,
		33,
		38,
		63,
		58,
		67,
		72,
		76,
		99,
		88,
		127,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		119,
		111,
		106,
		112,
		111,
		105,
		63,
		60,
		-1,
		30,
		67,
		39,
		46,
		38,
		51,
		56,
		62,
		66,
		73,
		89,
		88,
		83,
		119,
		110,
		116,
		-1,
		-1,
		210,
		199,
		188,
		194,
		-1,
		112,
		108,
		98,
		88,
		91,
		-1,
		-1,
		79,
		76,
		54,
		48,
		52,
		45,
		40,
		78,
		54,
		62,
		66,
		70,
		76,
		81,
		86,
		92,
		107,
		122,
		-1,
		164,
		201,
		194,
		162,
		170,
		201,
		-1,
		102,
		94,
		105,
		80,
		82,
		-1,
		-1,
		52,
		49,
		54,
		55,
		52,
		64,
		63,
		74,
		76,
		81,
		69,
		68,
		86,
		90,
		99,
		106,
		96,
		109,
		113,
		-1,
		157,
		177,
		156,
		159,
		183,
		197,
		-1,
		99,
		-1,
		-1,
		111,
		83,
		67,
		57,
		51,
		101,
		69,
		64,
		66,
		68,
		72,
		63,
		86,
		77,
		77,
		80,
		95,
		100,
		92,
		106,
		106,
		107,
		-1,
		146,
		157,
		150,
		-1,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		127,
		-1,
		94,
		-1,
		69,
		73,
		77,
		80,
		91,
		78,
		76,
		84,
		92,
		75,
		85,
		81,
		82,
		91,
		102,
		114,
		113,
		114,
		171,
		127,
		130,
		141,
		152,
		167,
		171,
		-1,
		111,
		150,
		165,
		-1,
		136,
		-1,
		-1,
		-1,
		83,
		90,
		82,
		98,
		90,
		90,
		70,
		74,
		80,
		87,
		97,
		99,
		91,
		95,
		108,
		119,
		122,
		167,
		158,
		171,
		116,
		116,
		137,
		146,
		167,
		126,
		117,
		144,
		170,
		161,
		156,
		143,
		-1,
		-1,
		106,
		100,
		-1,
		-1,
		97,
		91,
		74,
		76,
		80,
		90,
		105,
		108,
		98,
		96,
		90,
		122,
		-1,
		160,
		159,
		148,
		145,
		121,
		112,
		107,
		134,
		-1,
		-1,
		129,
		145,
		140,
		144,
		160,
		185,
		-1,
		146,
		-1,
		-1,
		127,
		-1,
		-1,
		133,
		96,
		85,
		76,
		82,
		88,
		99,
		116,
		104,
		105,
		95,
		105,
		118,
		144,
		141,
		129,
		127,
		150,
		115,
		103,
		-1,
		116,
		114,
		120,
		127,
		144,
		174,
		-1,
		-1,
		162,
		153,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		81,
		86,
		111,
		118,
		113,
		107,
		101,
		108,
		107,
		115,
		123,
		153,
		167,
		156,
		152,
		151,
		159,
		108,
		101,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		95,
		103,
		103,
		106,
		104,
		99,
		110,
		102,
		106,
		123,
		-1,
		187,
		-1,
		139,
		115,
		129,
		144,
		152,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		139,
		107,
		112,
		107,
		105,
		116,
		105,
		108,
		122,
		117,
		-1,
		-1,
		127,
		130,
		-1,
		-1,
		152,
		171,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		96,
		121,
		110,
		118,
		113,
		109,
		115,
		118,
		107,
		111,
		123,
		-1,
		-1,
		134,
		135,
		140,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		134,
		97,
		114,
		128,
		133,
		131,
		122,
		113,
		120,
		118,
		114,
		125,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		94,
		119,
		127,
		144,
		138,
		116,
		131,
		121,
		112,
		121,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		123,
		113,
		161,
		136,
		131,
		118,
		125,
		125,
		118,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		151,
		147,
		138,
		138,
		126,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		125,
		157,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		119,
		124,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		121,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		145,
		163,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		154,
		155,
		150,
		158,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		137,
		154,
		146,
		136,
		151,
		144,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		239,
		208,
		243,
		200,
		184,
		-1,
		150,
		130,
		136,
		140,
		134,
		127,
		141,
		137,
		-1,
		110,
		109,
		137,
		123,
		134,
		199,
		-1,
		-1,
		197,
		189,
		174,
		177,
		160,
		156,
		145,
		144,
		136,
		122,
		118,
		124,
		127,
		127,
		133,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		196,
		179,
		-1,
		162,
		169,
		166,
		172,
		158,
		179,
		155,
		146,
		138,
		132,
		120,
		122,
		119,
		132,
		120,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		155,
		158,
		164,
		188,
		195,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		204,
		200,
		196,
		203,
		152,
		-1,
		-1,
		192,
		-1,
		203,
		204,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		254,
		-1,
		196,
		180,
		182,
		154,
		175,
		-1,
		212,
		204,
		196,
		181,
		173,
		-1,
		151,
		148,
		138,
		116,
		101,
		118,
		110,
		108,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		214,
		204,
		-1,
		186,
		191,
		150,
		158,
		177,
		215,
		179,
		-1,
		174,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		199,
		203,
		192,
		143,
		162,
		186,
		223,
		172,
		161,
		160,
		-1,
		151,
		136,
		133,
		121,
		108,
		93,
		94,
		102,
		114,
		93,
		87,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		169,
		140,
		164,
		206,
		190,
		183,
		171,
		136,
		136,
		130,
		-1,
		132,
		111,
		102,
		91,
		89,
		102,
		94,
		102,
		82,
		80,
		99,
		111,
		102,
		113,
		-1,
		-1,
		-1,
		199,
		188,
		189,
		135,
		158,
		195,
		169,
		155,
		160,
		135,
		128,
		122,
		145,
		128,
		109,
		98,
		90,
		79,
		90,
		98,
		96,
		78,
		87,
		93,
		117,
		101,
		107,
		-1,
		-1,
		206,
		196,
		180,
		182,
		179,
		149,
		156,
		188,
		160,
		173,
		-1,
		127,
		-1,
		116,
		118,
		103,
		98,
		95,
		82,
		81,
		95,
		95,
		85,
		80,
		87,
		122,
		122,
		91,
		111,
		114,
		-1,
		-1,
		-1,
		199,
		194,
		169,
		146,
		130,
		166,
		-1,
		143,
		144,
		-1,
		121,
		115,
		118,
		105,
		101,
		86,
		90,
		92,
		95,
		83,
		89,
		90,
		72,
		96,
		-1,
		99,
		93,
		101,
		91,
		79,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		125,
		177,
		-1,
		-1,
		128,
		121,
		-1,
		108,
		96,
		98,
		90,
		84,
		91,
		86,
		77,
		90,
		83,
		77,
		71,
		84,
		88,
		92,
		81,
		77,
		74,
		88,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		145,
		-1,
		137,
		129,
		119,
		113,
		107,
		109,
		107,
		112,
		96,
		99,
		94,
		91,
		81,
		72,
		65,
		76,
		61,
		79,
		87,
		79,
		73,
		72,
		84,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		158,
		-1,
		122,
		136,
		152,
		-1,
		145,
		124,
		139,
		117,
		119,
		110,
		103,
		104,
		74,
		79,
		81,
		69,
		72,
		66,
		69,
		61,
		83,
		83,
		67,
		68,
		77,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		119,
		107,
		139,
		-1,
		-1,
		145,
		-1,
		99,
		101,
		124,
		122,
		93,
		68,
		75,
		93,
		66,
		61,
		71,
		60,
		57,
		55,
		77,
		63,
		61,
		80,
		96,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		123,
		111,
		98,
		80,
		120,
		-1,
		67,
		63,
		70,
		-1,
		86,
		-1,
		58,
		61,
		52,
		49,
		49,
		60,
		58,
		69,
		86,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		176,
		-1,
		-1,
		110,
		104,
		104,
		73,
		70,
		83,
		63,
		55,
		70,
		69,
		56,
		55,
		43,
		43,
		46,
		52,
		65,
		85,
		76,
		87,
		-1,
		-1,
		-1,
		173,
		159,
		163,
		123,
		142,
		-1,
		-1,
		171,
		127,
		113,
		-1,
		65,
		83,
		71,
		61,
		51,
		56,
		57,
		47,
		45,
		41,
		50,
		54,
		61,
		66,
		87,
		81,
		101,
		-1,
		-1,
		156,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		117,
		118,
		84,
		63,
		71,
		-1,
		-1,
		55,
		48,
		42,
		45,
		33,
		53,
		60,
		74,
		60,
		75,
		86,
		94,
		93,
		-1,
		159,
		146,
		-1,
		-1,
		157,
		148,
		-1,
		-1,
		-1,
		-1,
		96,
		41,
		30,
		25,
		29,
		54,
		-1,
		28,
		39,
		32,
		51,
		58,
		76,
		61,
		55,
		66,
		81,
		98,
		-1,
		-1,
		171,
		-1,
		134,
		-1,
		-1,
		-1,
		-1,
		53,
		47,
		18,
		11,
		15,
		-1,
		30,
		32,
		29,
		41,
		52,
		57,
		65,
		49,
		63,
		66,
		79,
		93,
		97,
		194,
		-1,
		125,
		-1,
		-1,
		-1,
		71,
		86,
		57,
		34,
		7,
		0,
		10,
		16,
		21,
		41,
		47,
		58,
		43,
		47,
		62,
		72,
		71,
		88,
		98,
		-1,
		-1,
		123,
		119,
		97,
		79,
		83,
		84,
		-1,
		-1,
		22,
		16,
		12,
		23,
		31,
		34,
		39,
		41,
		59,
		78,
		66,
		81,
		96,
		92,
		-1,
		-1,
		-1,
		135,
		-1,
		130,
		-1,
		-1,
		98,
		96,
		43,
		25,
		21,
		19,
		25,
		34,
		29,
		34,
		59,
		54,
		63,
		68,
		72,
		95,
		84,
		123,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		114,
		106,
		101,
		107,
		109,
		100,
		58,
		55,
		-1,
		25,
		63,
		35,
		42,
		34,
		47,
		52,
		58,
		62,
		69,
		85,
		84,
		79,
		115,
		106,
		112,
		-1,
		-1,
		205,
		194,
		183,
		189,
		-1,
		107,
		103,
		93,
		83,
		86,
		-1,
		-1,
		74,
		71,
		49,
		44,
		48,
		41,
		36,
		74,
		50,
		58,
		62,
		66,
		72,
		77,
		82,
		88,
		103,
		118,
		-1,
		159,
		196,
		189,
		157,
		165,
		196,
		-1,
		97,
		89,
		100,
		75,
		77,
		-1,
		-1,
		47,
		44,
		49,
		51,
		48,
		60,
		59,
		70,
		72,
		77,
		65,
		64,
		82,
		86,
		95,
		102,
		92,
		105,
		109,
		-1,
		152,
		172,
		151,
		154,
		178,
		192,
		-1,
		94,
		-1,
		-1,
		106,
		78,
		62,
		52,
		46,
		96,
		65,
		60,
		62,
		64,
		68,
		59,
		82,
		73,
		73,
		76,
		91,
		96,
		88,
		102,
		102,
		103,
		-1,
		141,
		152,
		145,
		-1,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		122,
		-1,
		89,
		-1,
		64,
		68,
		73,
		76,
		87,
		74,
		72,
		80,
		88,
		71,
		81,
		77,
		78,
		87,
		98,
		110,
		109,
		110,
		166,
		122,
		125,
		136,
		147,
		162,
		166,
		-1,
		106,
		145,
		160,
		-1,
		131,
		-1,
		-1,
		-1,
		78,
		86,
		78,
		94,
		86,
		86,
		66,
		70,
		76,
		83,
		93,
		95,
		87,
		91,
		104,
		115,
		118,
		162,
		153,
		166,
		111,
		111,
		132,
		141,
		162,
		121,
		112,
		139,
		165,
		156,
		151,
		138,
		-1,
		-1,
		101,
		96,
		-1,
		-1,
		93,
		87,
		70,
		72,
		76,
		86,
		101,
		104,
		94,
		92,
		86,
		118,
		-1,
		155,
		154,
		143,
		140,
		116,
		107,
		102,
		129,
		-1,
		-1,
		124,
		140,
		135,
		139,
		155,
		180,
		-1,
		141,
		-1,
		-1,
		122,
		-1,
		-1,
		129,
		92,
		81,
		72,
		78,
		84,
		95,
		112,
		100,
		101,
		91,
		101,
		114,
		139,
		136,
		124,
		122,
		145,
		110,
		98,
		-1,
		111,
		109,
		115,
		122,
		139,
		169,
		-1,
		-1,
		157,
		148,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		77,
		82,
		107,
		114,
		109,
		103,
		97,
		104,
		103,
		111,
		119,
		148,
		162,
		151,
		147,
		146,
		154,
		103,
		96,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		99,
		99,
		102,
		100,
		95,
		106,
		98,
		102,
		119,
		-1,
		182,
		-1,
		134,
		110,
		124,
		139,
		147,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		135,
		103,
		108,
		103,
		101,
		112,
		101,
		104,
		118,
		113,
		-1,
		-1,
		122,
		125,
		-1,
		-1,
		147,
		166,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		117,
		106,
		114,
		109,
		105,
		111,
		114,
		103,
		107,
		119,
		-1,
		-1,
		129,
		130,
		135,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		130,
		93,
		110,
		124,
		129,
		127,
		118,
		109,
		116,
		114,
		110,
		121,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		87,
		90,
		115,
		123,
		140,
		134,
		112,
		127,
		117,
		108,
		117,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		91,
		-1,
		119,
		109,
		157,
		132,
		127,
		114,
		121,
		121,
		114,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		99,
		90,
		98,
		147,
		143,
		134,
		134,
		122,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		102,
		100,
		97,
		109,
		105,
		125,
		121,
		153,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		128,
		112,
		110,
		115,
		120,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		121,
		117,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		195,
		184,
		195,
		203,
		176,
		183,
		-1,
		202,
		206,
		172,
		166,
		205,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		195,
		194,
		162,
		160,
		169,
		174,
		181,
		-1,
		180,
		-1,
		216,
		195,
		206,
		211,
		155,
		152,
		172,
		191,
		173,
		165,
		231,
		185,
		156,
		150,
		168,
		158,
		167,
		159,
		-1,
		156,
		146,
		168,
		147,
		158,
		150,
		-1,
		-1,
		150,
		151,
		157,
		143,
		149,
		145,
		-1,
		155,
		139,
		-1,
		-1,
		140,
		141,
		125,
		128,
		136,
		134,
		147,
		139,
		134,
		-1,
		-1,
		131,
		127,
		134,
		121,
		117,
		134,
		147,
		129,
		143,
		142,
		-1,
		137,
		155,
		160,
		128,
		126,
		110,
		108,
		126,
		128,
		134,
		134,
		-1,
		146,
		147,
		142,
		150,
		150,
		126,
		113,
		113,
		123,
		116,
		135,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		146,
		129,
		146,
		138,
		128,
		143,
		136,
		116,
		113,
		111,
		108,
		124,
		122,
		132,
		-1,
		-1,
		237,
		206,
		237,
		195,
		176,
		-1,
		142,
		122,
		128,
		132,
		126,
		119,
		133,
		129,
		-1,
		102,
		101,
		129,
		115,
		126,
		197,
		-1,
		-1,
		195,
		187,
		172,
		175,
		152,
		148,
		137,
		136,
		128,
		114,
		110,
		116,
		119,
		119,
		125,
		96,
		106,
		110,
		108,
		133,
		-1,
		-1,
		168,
		-1,
		-1,
		194,
		177,
		-1,
		160,
		167,
		158,
		164,
		150,
		171,
		147,
		138,
		130,
		124,
		112,
		114,
		111,
		124,
		112,
		93,
		118,
		122,
		103,
		124,
		119,
		-1,
		167,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		153,
		156,
		162,
		186,
		187,
		-1,
		159,
		147,
		148,
		133,
		130,
		117,
		105,
		118,
		103,
		110,
		109,
		97,
		95,
		125,
		100,
		122,
		119,
		138,
		143,
		137,
		146,
		-1,
		202,
		198,
		194,
		201,
		150,
		-1,
		-1,
		190,
		-1,
		195,
		196,
		171,
		144,
		147,
		134,
		125,
		112,
		101,
		112,
		101,
		98,
		106,
		89,
		104,
		95,
		94,
		112,
		122,
		130,
		134,
		140,
		-1,
		252,
		-1,
		194,
		178,
		180,
		152,
		173,
		-1,
		210,
		196,
		188,
		173,
		171,
		-1,
		143,
		140,
		130,
		108,
		93,
		110,
		102,
		100,
		102,
		84,
		98,
		89,
		107,
		114,
		112,
		116,
		136,
		148,
		212,
		202,
		-1,
		184,
		189,
		148,
		156,
		175,
		213,
		177,
		-1,
		172,
		-1,
		145,
		158,
		-1,
		114,
		110,
		92,
		93,
		88,
		103,
		95,
		80,
		77,
		95,
		98,
		105,
		109,
		125,
		-1,
		-1,
		197,
		201,
		190,
		141,
		160,
		184,
		221,
		170,
		159,
		158,
		-1,
		149,
		128,
		125,
		113,
		100,
		85,
		86,
		94,
		106,
		85,
		79,
		76,
		96,
		122,
		100,
		112,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		167,
		138,
		162,
		204,
		188,
		181,
		169,
		134,
		134,
		128,
		-1,
		124,
		103,
		94,
		83,
		81,
		94,
		86,
		94,
		74,
		72,
		91,
		103,
		94,
		105,
		-1,
		-1,
		-1,
		197,
		186,
		187,
		133,
		156,
		193,
		167,
		153,
		158,
		133,
		126,
		120,
		137,
		120,
		101,
		90,
		82,
		71,
		82,
		90,
		88,
		70,
		79,
		85,
		109,
		93,
		99,
		-1,
		-1,
		204,
		194,
		178,
		180,
		177,
		147,
		154,
		186,
		158,
		171,
		-1,
		125,
		-1,
		114,
		110,
		95,
		90,
		87,
		74,
		73,
		87,
		87,
		77,
		72,
		79,
		114,
		114,
		83,
		103,
		106,
		-1,
		-1,
		-1,
		197,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		119,
		113,
		110,
		97,
		93,
		78,
		82,
		84,
		87,
		75,
		81,
		82,
		64,
		88,
		-1,
		91,
		85,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		90,
		82,
		76,
		83,
		78,
		69,
		82,
		75,
		69,
		63,
		76,
		80,
		84,
		73,
		69,
		66,
		80,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		101,
		99,
		104,
		88,
		91,
		86,
		83,
		73,
		64,
		57,
		68,
		53,
		71,
		79,
		71,
		65,
		64,
		76,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		111,
		102,
		95,
		96,
		66,
		71,
		73,
		61,
		64,
		58,
		61,
		53,
		75,
		75,
		59,
		60,
		69,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		152,
		-1,
		106,
		108,
		116,
		114,
		85,
		60,
		67,
		85,
		58,
		53,
		63,
		52,
		49,
		47,
		69,
		55,
		53,
		72,
		88,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		130,
		118,
		105,
		87,
		127,
		-1,
		59,
		55,
		62,
		-1,
		78,
		-1,
		50,
		53,
		44,
		41,
		41,
		52,
		50,
		61,
		78,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		117,
		111,
		111,
		80,
		77,
		75,
		55,
		47,
		62,
		61,
		48,
		47,
		35,
		35,
		38,
		44,
		57,
		77,
		68,
		79,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		178,
		134,
		120,
		-1,
		72,
		75,
		63,
		53,
		43,
		48,
		49,
		39,
		37,
		33,
		42,
		46,
		53,
		58,
		79,
		73,
		93,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		124,
		125,
		91,
		70,
		64,
		-1,
		-1,
		47,
		40,
		34,
		37,
		25,
		45,
		52,
		66,
		52,
		67,
		78,
		86,
		85,
		-1,
		157,
		144,
		-1,
		-1,
		152,
		142,
		-1,
		-1,
		-1,
		-1,
		103,
		48,
		37,
		32,
		36,
		46,
		-1,
		20,
		31,
		24,
		43,
		50,
		68,
		53,
		47,
		58,
		73,
		90,
		-1,
		-1,
		166,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		60,
		54,
		25,
		18,
		22,
		-1,
		22,
		24,
		21,
		33,
		44,
		49,
		57,
		41,
		55,
		58,
		71,
		85,
		89,
		189,
		-1,
		119,
		-1,
		-1,
		-1,
		78,
		93,
		64,
		41,
		14,
		7,
		0,
		8,
		13,
		33,
		39,
		50,
		35,
		39,
		54,
		64,
		63,
		80,
		90,
		-1,
		-1,
		117,
		113,
		104,
		86,
		90,
		91,
		-1,
		-1,
		18,
		10,
		4,
		15,
		23,
		26,
		31,
		33,
		51,
		70,
		58,
		73,
		88,
		84,
		-1,
		-1,
		-1,
		129,
		-1,
		131,
		-1,
		-1,
		105,
		90,
		37,
		19,
		15,
		13,
		17,
		26,
		21,
		26,
		51,
		46,
		55,
		60,
		64,
		87,
		76,
		115,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		108,
		100,
		95,
		101,
		103,
		94,
		52,
		49,
		-1,
		19,
		54,
		27,
		34,
		26,
		39,
		44,
		50,
		54,
		61,
		77,
		76,
		71,
		107,
		98,
		104,
		-1,
		-1,
		199,
		188,
		177,
		183,
		-1,
		101,
		97,
		87,
		77,
		80,
		-1,
		-1,
		68,
		65,
		43,
		36,
		40,
		33,
		28,
		66,
		42,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		95,
		110,
		-1,
		153,
		190,
		183,
		151,
		159,
		190,
		-1,
		91,
		83,
		94,
		69,
		71,
		-1,
		-1,
		41,
		38,
		43,
		43,
		40,
		52,
		51,
		62,
		64,
		69,
		57,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		146,
		166,
		145,
		148,
		172,
		186,
		-1,
		88,
		-1,
		-1,
		100,
		72,
		56,
		46,
		40,
		90,
		57,
		52,
		54,
		56,
		60,
		51,
		74,
		65,
		65,
		68,
		83,
		88,
		80,
		94,
		94,
		95,
		-1,
		135,
		146,
		139,
		-1,
		-1,
		-1,
		-1,
		89,
		-1,
		-1,
		116,
		-1,
		83,
		-1,
		58,
		62,
		65,
		68,
		79,
		66,
		64,
		72,
		80,
		63,
		73,
		69,
		70,
		79,
		90,
		102,
		101,
		102,
		160,
		116,
		119,
		130,
		141,
		156,
		160,
		-1,
		100,
		139,
		154,
		-1,
		125,
		-1,
		-1,
		-1,
		72,
		78,
		70,
		86,
		78,
		78,
		58,
		62,
		68,
		75,
		85,
		87,
		79,
		83,
		96,
		107,
		110,
		156,
		147,
		160,
		105,
		105,
		126,
		135,
		156,
		115,
		106,
		133,
		159,
		150,
		145,
		132,
		-1,
		-1,
		95,
		88,
		-1,
		-1,
		85,
		79,
		62,
		64,
		68,
		78,
		93,
		96,
		86,
		84,
		78,
		110,
		-1,
		149,
		148,
		137,
		134,
		110,
		101,
		96,
		123,
		-1,
		-1,
		118,
		134,
		129,
		133,
		149,
		174,
		-1,
		135,
		-1,
		-1,
		116,
		-1,
		-1,
		121,
		84,
		73,
		64,
		70,
		76,
		87,
		104,
		92,
		93,
		83,
		93,
		106,
		133,
		130,
		118,
		116,
		139,
		104,
		92,
		-1,
		105,
		103,
		109,
		116,
		133,
		163,
		-1,
		-1,
		151,
		142,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		69,
		74,
		99,
		106,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		142,
		156,
		145,
		141,
		140,
		148,
		97,
		90,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		83,
		91,
		91,
		94,
		92,
		87,
		98,
		90,
		94,
		111,
		-1,
		176,
		-1,
		128,
		104,
		118,
		133,
		141,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		127,
		95,
		100,
		95,
		93,
		104,
		93,
		96,
		110,
		105,
		-1,
		-1,
		116,
		119,
		-1,
		-1,
		141,
		160,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		109,
		98,
		106,
		101,
		97,
		103,
		106,
		95,
		99,
		111,
		-1,
		-1,
		123,
		124,
		129,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		122,
		85,
		102,
		116,
		121,
		119,
		110,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		82,
		107,
		115,
		132,
		126,
		104,
		119,
		109,
		100,
		109,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		111,
		101,
		149,
		124,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		91,
		82,
		90,
		139,
		135,
		126,
		126,
		114,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		94,
		92,
		89,
		101,
		97,
		117,
		113,
		145,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		120,
		104,
		102,
		107,
		112,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		113,
		109,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		187,
		176,
		187,
		195,
		168,
		175,
		-1,
		194,
		198,
		164,
		158,
		197,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		187,
		186,
		154,
		152,
		161,
		166,
		173,
		-1,
		172,
		-1,
		208,
		187,
		198,
		203,
		147,
		144,
		164,
		183,
		165,
		157,
		223,
		177,
		148,
		142,
		160,
		150,
		159,
		151,
		-1,
		148,
		138,
		160,
		139,
		150,
		142,
		-1,
		-1,
		142,
		143,
		149,
		135,
		141,
		137,
		-1,
		147,
		131,
		-1,
		-1,
		132,
		133,
		117,
		120,
		128,
		126,
		139,
		131,
		126,
		-1,
		-1,
		123,
		119,
		126,
		113,
		109,
		126,
		139,
		121,
		135,
		134,
		-1,
		129,
		147,
		152,
		120,
		118,
		102,
		100,
		118,
		120,
		126,
		126,
		-1,
		138,
		139,
		134,
		142,
		142,
		118,
		105,
		105,
		115,
		108,
		127,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		121,
		138,
		130,
		120,
		135,
		128,
		108,
		105,
		103,
		100,
		116,
		114,
		124,
		-1,
		-1,
		229,
		198,
		229,
		187,
		168,
		-1,
		134,
		114,
		120,
		124,
		118,
		111,
		125,
		121,
		-1,
		94,
		93,
		121,
		107,
		118,
		189,
		-1,
		-1,
		187,
		179,
		164,
		167,
		144,
		140,
		129,
		128,
		120,
		106,
		102,
		108,
		111,
		111,
		117,
		88,
		98,
		102,
		100,
		125,
		-1,
		-1,
		160,
		-1,
		-1,
		186,
		169,
		-1,
		152,
		159,
		150,
		156,
		142,
		163,
		139,
		130,
		122,
		116,
		104,
		106,
		103,
		116,
		104,
		85,
		110,
		114,
		95,
		116,
		111,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		145,
		148,
		154,
		178,
		179,
		-1,
		151,
		139,
		140,
		125,
		122,
		109,
		97,
		110,
		95,
		102,
		101,
		89,
		87,
		117,
		92,
		114,
		111,
		130,
		135,
		129,
		138,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		182,
		-1,
		187,
		188,
		163,
		136,
		139,
		126,
		117,
		104,
		93,
		104,
		93,
		90,
		98,
		81,
		96,
		87,
		86,
		104,
		114,
		122,
		126,
		132,
		-1,
		244,
		-1,
		186,
		170,
		172,
		144,
		165,
		-1,
		202,
		188,
		180,
		165,
		163,
		-1,
		135,
		132,
		122,
		100,
		85,
		102,
		94,
		92,
		94,
		76,
		90,
		81,
		99,
		106,
		104,
		108,
		128,
		140,
		204,
		194,
		-1,
		176,
		181,
		140,
		148,
		167,
		205,
		169,
		-1,
		164,
		-1,
		137,
		150,
		-1,
		106,
		102,
		84,
		85,
		80,
		95,
		87,
		72,
		69,
		87,
		90,
		97,
		101,
		117,
		-1,
		-1,
		189,
		193,
		182,
		133,
		152,
		176,
		213,
		162,
		151,
		150,
		-1,
		141,
		120,
		117,
		105,
		92,
		77,
		78,
		86,
		98,
		77,
		71,
		68,
		88,
		114,
		92,
		104,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		159,
		130,
		154,
		196,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		116,
		95,
		86,
		75,
		73,
		86,
		78,
		86,
		66,
		64,
		83,
		95,
		86,
		97,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		125,
		148,
		185,
		159,
		145,
		150,
		125,
		118,
		112,
		129,
		112,
		93,
		82,
		74,
		63,
		74,
		82,
		80,
		62,
		71,
		77,
		101,
		85,
		91,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		102,
		87,
		82,
		79,
		66,
		65,
		79,
		79,
		69,
		64,
		71,
		106,
		106,
		75,
		95,
		98,
		-1,
		-1,
		-1,
		189,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		89,
		85,
		70,
		74,
		76,
		79,
		67,
		73,
		74,
		56,
		80,
		-1,
		83,
		77,
		85,
		75,
		63,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		82,
		74,
		68,
		75,
		70,
		61,
		74,
		67,
		61,
		55,
		68,
		72,
		76,
		65,
		61,
		58,
		72,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		96,
		80,
		83,
		78,
		75,
		65,
		56,
		49,
		60,
		45,
		63,
		71,
		63,
		57,
		56,
		68,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		94,
		87,
		88,
		58,
		63,
		65,
		53,
		56,
		50,
		53,
		45,
		67,
		67,
		51,
		52,
		61,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		156,
		-1,
		105,
		112,
		108,
		106,
		77,
		52,
		59,
		77,
		50,
		45,
		55,
		44,
		41,
		39,
		61,
		47,
		45,
		64,
		80,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		134,
		122,
		109,
		91,
		131,
		-1,
		51,
		47,
		54,
		-1,
		70,
		-1,
		42,
		45,
		36,
		33,
		33,
		44,
		42,
		53,
		70,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		121,
		115,
		115,
		84,
		81,
		67,
		47,
		39,
		54,
		53,
		40,
		39,
		27,
		27,
		30,
		36,
		49,
		69,
		60,
		71,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		182,
		138,
		124,
		-1,
		76,
		67,
		55,
		45,
		35,
		40,
		41,
		31,
		29,
		25,
		34,
		38,
		45,
		50,
		71,
		65,
		85,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		128,
		129,
		95,
		74,
		56,
		-1,
		-1,
		39,
		32,
		26,
		29,
		17,
		37,
		44,
		58,
		44,
		59,
		70,
		78,
		77,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		107,
		52,
		41,
		36,
		40,
		38,
		-1,
		12,
		23,
		16,
		35,
		42,
		60,
		45,
		39,
		50,
		65,
		82,
		-1,
		-1,
		161,
		-1,
		131,
		-1,
		-1,
		-1,
		-1,
		64,
		58,
		29,
		22,
		26,
		-1,
		14,
		16,
		13,
		25,
		36,
		41,
		49,
		33,
		47,
		50,
		63,
		77,
		81,
		184,
		-1,
		122,
		-1,
		-1,
		-1,
		82,
		97,
		68,
		45,
		18,
		13,
		6,
		0,
		5,
		25,
		31,
		42,
		27,
		31,
		46,
		56,
		55,
		72,
		82,
		-1,
		-1,
		120,
		116,
		108,
		90,
		94,
		95,
		-1,
		-1,
		22,
		13,
		4,
		7,
		15,
		18,
		23,
		25,
		43,
		62,
		50,
		65,
		80,
		76,
		-1,
		-1,
		-1,
		132,
		-1,
		134,
		-1,
		-1,
		109,
		93,
		40,
		22,
		18,
		16,
		9,
		18,
		13,
		18,
		43,
		38,
		47,
		52,
		56,
		79,
		68,
		107,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		111,
		103,
		98,
		104,
		106,
		97,
		55,
		52,
		-1,
		22,
		47,
		19,
		26,
		18,
		31,
		36,
		42,
		46,
		53,
		69,
		68,
		63,
		99,
		90,
		96,
		-1,
		-1,
		202,
		191,
		180,
		186,
		-1,
		104,
		100,
		90,
		80,
		83,
		-1,
		-1,
		71,
		68,
		44,
		28,
		32,
		25,
		20,
		58,
		34,
		42,
		46,
		50,
		56,
		61,
		66,
		72,
		87,
		102,
		-1,
		156,
		193,
		186,
		154,
		162,
		193,
		-1,
		94,
		86,
		97,
		72,
		74,
		-1,
		-1,
		44,
		41,
		46,
		35,
		32,
		44,
		43,
		54,
		56,
		61,
		49,
		48,
		66,
		70,
		79,
		86,
		76,
		89,
		93,
		-1,
		149,
		169,
		148,
		151,
		175,
		189,
		-1,
		91,
		-1,
		-1,
		103,
		75,
		59,
		49,
		43,
		93,
		49,
		44,
		46,
		48,
		52,
		43,
		66,
		57,
		57,
		60,
		75,
		80,
		72,
		86,
		86,
		87,
		-1,
		138,
		149,
		142,
		-1,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		119,
		-1,
		86,
		-1,
		61,
		65,
		57,
		60,
		71,
		58,
		56,
		64,
		72,
		55,
		65,
		61,
		62,
		71,
		82,
		94,
		93,
		94,
		163,
		119,
		122,
		133,
		144,
		159,
		163,
		-1,
		103,
		142,
		157,
		-1,
		128,
		-1,
		-1,
		-1,
		75,
		70,
		62,
		78,
		70,
		70,
		50,
		54,
		60,
		67,
		77,
		79,
		71,
		75,
		88,
		99,
		102,
		159,
		150,
		163,
		108,
		108,
		129,
		138,
		159,
		118,
		109,
		136,
		162,
		153,
		148,
		135,
		-1,
		-1,
		98,
		80,
		-1,
		-1,
		77,
		71,
		54,
		56,
		60,
		70,
		85,
		88,
		78,
		76,
		70,
		102,
		-1,
		152,
		151,
		140,
		137,
		113,
		104,
		99,
		126,
		-1,
		-1,
		121,
		137,
		132,
		136,
		152,
		177,
		-1,
		138,
		-1,
		-1,
		119,
		-1,
		-1,
		113,
		76,
		65,
		56,
		62,
		68,
		79,
		96,
		84,
		85,
		75,
		85,
		98,
		136,
		133,
		121,
		119,
		142,
		107,
		95,
		-1,
		108,
		106,
		112,
		119,
		136,
		166,
		-1,
		-1,
		154,
		134,
		-1,
		-1,
		111,
		109,
		98,
		-1,
		88,
		61,
		66,
		91,
		98,
		93,
		87,
		81,
		88,
		87,
		95,
		103,
		145,
		159,
		148,
		144,
		143,
		151,
		100,
		93,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		140,
		-1,
		-1,
		106,
		99,
		87,
		75,
		65,
		75,
		83,
		83,
		86,
		84,
		79,
		90,
		82,
		86,
		103,
		-1,
		179,
		-1,
		131,
		107,
		121,
		136,
		144,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		140,
		124,
		105,
		-1,
		75,
		88,
		119,
		87,
		92,
		87,
		85,
		96,
		85,
		88,
		102,
		97,
		-1,
		-1,
		119,
		122,
		-1,
		-1,
		144,
		153,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		112,
		108,
		-1,
		-1,
		76,
		101,
		90,
		98,
		93,
		89,
		95,
		98,
		87,
		91,
		103,
		-1,
		-1,
		126,
		127,
		132,
		-1,
		136,
		-1,
		154,
		-1,
		121,
		127,
		115,
		-1,
		-1,
		-1,
		114,
		77,
		94,
		108,
		113,
		111,
		102,
		93,
		100,
		98,
		94,
		105,
		-1,
		-1,
		-1,
		154,
		128,
		161,
		152,
		135,
		115,
		107,
		126,
		-1,
		96,
		-1,
		71,
		74,
		99,
		107,
		124,
		118,
		96,
		111,
		101,
		92,
		101,
		160,
		-1,
		130,
		163,
		127,
		121,
		97,
		101,
		117,
		-1,
		93,
		75,
		-1,
		103,
		93,
		141,
		116,
		111,
		98,
		105,
		105,
		98,
		-1,
		-1,
		-1,
		132,
		131,
		123,
		117,
		117,
		102,
		93,
		-1,
		105,
		87,
		66,
		83,
		83,
		74,
		82,
		131,
		127,
		118,
		118,
		106,
		-1,
		233,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		126,
		121,
		94,
		82,
		88,
		84,
		70,
		76,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		105,
		137,
		-1,
		228,
		-1,
		162,
		-1,
		-1,
		144,
		124,
		116,
		105,
		94,
		92,
		83,
		74,
		96,
		112,
		96,
		94,
		99,
		104,
		-1,
		217,
		216,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		140,
		101,
		-1,
		103,
		83,
		-1,
		105,
		101,
		-1,
		-1,
		204,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		135,
		119,
		-1,
		94,
		94,
		-1,
		-1,
		-1,
		189,
		188,
		-1,
		157,
		160,
		-1,
		150,
		141,
		149,
		96,
		100,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		172,
		170,
		165,
		162,
		148,
		132,
		110,
		99,
		120,
		-1,
		-1,
		-1,
		170,
		162,
		155,
		-1,
		-1,
		157,
		140,
		121,
		119,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		147,
		-1,
		-1,
		153,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		181,
		-1,
		-1,
		-1,
		143,
		139,
		140,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		227,
		191,
		-1,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		133,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		168,
		-1,
		168,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		173,
		181,
		-1,
		153,
		155,
		-1,
		203,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		158,
		165,
		187,
		190,
		226,
		-1,
		177
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		189,
		193,
		159,
		153,
		192,
		161,
		167,
		178,
		-1,
		-1,
		-1,
		182,
		181,
		149,
		147,
		156,
		161,
		168,
		-1,
		167,
		-1,
		203,
		182,
		193,
		198,
		142,
		139,
		159,
		178,
		160,
		152,
		218,
		172,
		143,
		137,
		155,
		145,
		154,
		146,
		-1,
		143,
		133,
		155,
		134,
		145,
		137,
		-1,
		-1,
		137,
		138,
		144,
		130,
		136,
		132,
		-1,
		142,
		126,
		-1,
		-1,
		127,
		128,
		112,
		115,
		123,
		121,
		134,
		126,
		121,
		-1,
		-1,
		118,
		114,
		121,
		108,
		104,
		121,
		134,
		116,
		130,
		129,
		-1,
		124,
		142,
		147,
		115,
		113,
		97,
		95,
		113,
		115,
		121,
		121,
		-1,
		133,
		134,
		129,
		137,
		137,
		113,
		100,
		100,
		110,
		103,
		122,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		116,
		133,
		125,
		115,
		130,
		123,
		103,
		100,
		98,
		95,
		111,
		109,
		119,
		-1,
		-1,
		224,
		193,
		224,
		182,
		163,
		-1,
		129,
		109,
		115,
		119,
		113,
		106,
		120,
		116,
		-1,
		89,
		88,
		116,
		102,
		113,
		184,
		-1,
		-1,
		182,
		174,
		159,
		162,
		139,
		135,
		124,
		123,
		115,
		101,
		97,
		103,
		106,
		106,
		112,
		83,
		93,
		97,
		95,
		120,
		-1,
		-1,
		155,
		-1,
		-1,
		181,
		164,
		-1,
		147,
		154,
		145,
		151,
		137,
		158,
		134,
		125,
		117,
		111,
		99,
		101,
		98,
		111,
		99,
		80,
		105,
		109,
		90,
		111,
		106,
		-1,
		154,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		140,
		143,
		149,
		173,
		174,
		-1,
		146,
		134,
		135,
		120,
		117,
		104,
		92,
		105,
		90,
		97,
		96,
		84,
		82,
		112,
		87,
		109,
		106,
		125,
		130,
		124,
		133,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		177,
		-1,
		182,
		183,
		158,
		131,
		134,
		121,
		112,
		99,
		88,
		99,
		88,
		85,
		93,
		76,
		91,
		82,
		81,
		99,
		109,
		117,
		121,
		127,
		-1,
		239,
		-1,
		181,
		165,
		167,
		139,
		160,
		-1,
		197,
		183,
		175,
		160,
		158,
		-1,
		130,
		127,
		117,
		95,
		80,
		97,
		89,
		87,
		89,
		71,
		85,
		76,
		94,
		101,
		99,
		103,
		123,
		135,
		199,
		189,
		-1,
		171,
		176,
		135,
		143,
		162,
		200,
		164,
		-1,
		159,
		-1,
		132,
		145,
		-1,
		101,
		97,
		79,
		80,
		75,
		90,
		82,
		67,
		64,
		82,
		85,
		92,
		96,
		112,
		-1,
		-1,
		184,
		188,
		177,
		128,
		147,
		171,
		208,
		157,
		146,
		145,
		-1,
		136,
		115,
		112,
		100,
		87,
		72,
		73,
		81,
		93,
		72,
		66,
		63,
		83,
		109,
		87,
		99,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		154,
		125,
		149,
		191,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		111,
		90,
		81,
		70,
		68,
		81,
		73,
		81,
		61,
		59,
		78,
		90,
		81,
		92,
		-1,
		-1,
		-1,
		184,
		173,
		174,
		120,
		143,
		180,
		154,
		140,
		145,
		120,
		113,
		107,
		124,
		107,
		88,
		77,
		69,
		58,
		69,
		77,
		75,
		57,
		66,
		72,
		96,
		80,
		86,
		-1,
		-1,
		191,
		181,
		165,
		167,
		164,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		97,
		82,
		77,
		74,
		61,
		60,
		74,
		74,
		64,
		59,
		66,
		101,
		101,
		70,
		90,
		93,
		-1,
		-1,
		-1,
		184,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		84,
		80,
		65,
		69,
		71,
		74,
		62,
		68,
		69,
		51,
		75,
		-1,
		78,
		72,
		80,
		70,
		58,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		77,
		72,
		71,
		70,
		67,
		56,
		69,
		62,
		56,
		50,
		63,
		67,
		71,
		60,
		56,
		53,
		67,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		99,
		83,
		82,
		79,
		70,
		74,
		51,
		44,
		55,
		40,
		58,
		66,
		58,
		52,
		51,
		63,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		89,
		99,
		100,
		70,
		75,
		74,
		62,
		56,
		45,
		48,
		40,
		62,
		62,
		46,
		47,
		56,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		103,
		101,
		89,
		64,
		71,
		86,
		59,
		54,
		50,
		39,
		39,
		34,
		56,
		42,
		40,
		59,
		75,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		63,
		59,
		66,
		-1,
		79,
		-1,
		47,
		43,
		34,
		31,
		28,
		39,
		37,
		48,
		65,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		96,
		93,
		79,
		59,
		51,
		66,
		62,
		45,
		48,
		25,
		25,
		28,
		31,
		44,
		64,
		55,
		67,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		88,
		79,
		67,
		57,
		47,
		50,
		53,
		36,
		27,
		23,
		32,
		36,
		40,
		45,
		66,
		67,
		80,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		141,
		107,
		86,
		68,
		-1,
		-1,
		51,
		42,
		37,
		24,
		15,
		35,
		42,
		55,
		39,
		54,
		66,
		74,
		79,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		119,
		64,
		53,
		48,
		52,
		50,
		-1,
		22,
		19,
		11,
		31,
		38,
		57,
		51,
		45,
		49,
		67,
		84,
		-1,
		-1,
		156,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		76,
		70,
		41,
		34,
		38,
		-1,
		20,
		12,
		8,
		20,
		31,
		36,
		44,
		39,
		53,
		52,
		65,
		79,
		83,
		179,
		-1,
		133,
		-1,
		-1,
		-1,
		94,
		109,
		80,
		57,
		30,
		25,
		18,
		12,
		0,
		20,
		26,
		37,
		33,
		37,
		52,
		58,
		57,
		74,
		84,
		-1,
		-1,
		131,
		127,
		120,
		102,
		106,
		107,
		-1,
		-1,
		34,
		25,
		16,
		15,
		10,
		13,
		29,
		31,
		49,
		68,
		56,
		67,
		85,
		84,
		-1,
		-1,
		-1,
		143,
		-1,
		145,
		-1,
		-1,
		121,
		105,
		52,
		34,
		30,
		28,
		20,
		29,
		19,
		24,
		49,
		46,
		55,
		58,
		64,
		87,
		76,
		115,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		122,
		114,
		109,
		114,
		115,
		106,
		67,
		64,
		-1,
		34,
		56,
		25,
		32,
		24,
		39,
		44,
		50,
		54,
		61,
		77,
		76,
		71,
		107,
		98,
		104,
		-1,
		-1,
		208,
		197,
		186,
		192,
		-1,
		115,
		111,
		100,
		90,
		92,
		-1,
		-1,
		80,
		77,
		53,
		34,
		40,
		33,
		28,
		66,
		42,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		95,
		110,
		-1,
		162,
		199,
		192,
		160,
		168,
		199,
		-1,
		105,
		97,
		108,
		83,
		83,
		-1,
		-1,
		53,
		52,
		53,
		41,
		38,
		51,
		50,
		62,
		64,
		69,
		57,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		155,
		175,
		154,
		157,
		181,
		195,
		-1,
		102,
		-1,
		-1,
		114,
		84,
		68,
		60,
		52,
		100,
		55,
		50,
		52,
		54,
		60,
		51,
		74,
		65,
		65,
		68,
		83,
		88,
		80,
		94,
		94,
		95,
		-1,
		144,
		155,
		148,
		-1,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		130,
		-1,
		95,
		-1,
		70,
		74,
		63,
		66,
		77,
		64,
		64,
		72,
		80,
		63,
		73,
		69,
		70,
		79,
		90,
		102,
		101,
		102,
		169,
		125,
		128,
		139,
		150,
		165,
		169,
		-1,
		114,
		153,
		168,
		-1,
		139,
		-1,
		-1,
		-1,
		84,
		76,
		68,
		84,
		76,
		76,
		58,
		62,
		68,
		75,
		85,
		87,
		79,
		83,
		96,
		107,
		110,
		165,
		156,
		169,
		114,
		114,
		135,
		144,
		165,
		129,
		120,
		147,
		168,
		164,
		159,
		146,
		-1,
		-1,
		107,
		86,
		-1,
		-1,
		83,
		79,
		62,
		64,
		68,
		78,
		93,
		96,
		86,
		84,
		78,
		110,
		-1,
		158,
		157,
		146,
		143,
		119,
		110,
		105,
		132,
		-1,
		-1,
		127,
		148,
		138,
		142,
		158,
		183,
		-1,
		146,
		-1,
		-1,
		128,
		-1,
		-1,
		121,
		84,
		73,
		64,
		70,
		76,
		87,
		104,
		92,
		93,
		83,
		93,
		106,
		142,
		139,
		127,
		125,
		148,
		113,
		101,
		-1,
		114,
		112,
		118,
		125,
		142,
		172,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		69,
		74,
		99,
		106,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		151,
		165,
		154,
		150,
		149,
		157,
		106,
		99,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		83,
		91,
		91,
		94,
		92,
		87,
		98,
		90,
		94,
		111,
		-1,
		185,
		-1,
		137,
		113,
		127,
		142,
		150,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		127,
		95,
		100,
		95,
		93,
		104,
		93,
		96,
		110,
		105,
		-1,
		-1,
		125,
		128,
		-1,
		-1,
		150,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		109,
		98,
		106,
		101,
		97,
		103,
		106,
		95,
		99,
		111,
		-1,
		-1,
		132,
		133,
		138,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		122,
		85,
		102,
		116,
		121,
		119,
		110,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		82,
		107,
		115,
		132,
		126,
		104,
		119,
		109,
		100,
		109,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		111,
		101,
		149,
		124,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		91,
		82,
		90,
		139,
		135,
		126,
		126,
		114,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		94,
		92,
		89,
		101,
		97,
		117,
		113,
		145,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		120,
		104,
		102,
		107,
		112,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		113,
		109,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		197,
		186,
		197,
		205,
		178,
		185,
		-1,
		204,
		208,
		174,
		168,
		207,
		176,
		182,
		193,
		-1,
		-1,
		-1,
		197,
		196,
		164,
		162,
		171,
		176,
		183,
		-1,
		182,
		-1,
		218,
		197,
		208,
		213,
		157,
		154,
		174,
		193,
		175,
		167,
		233,
		187,
		158,
		152,
		170,
		160,
		169,
		161,
		-1,
		158,
		148,
		170,
		149,
		160,
		152,
		-1,
		-1,
		152,
		153,
		159,
		145,
		151,
		147,
		-1,
		157,
		141,
		-1,
		-1,
		142,
		143,
		127,
		130,
		138,
		136,
		149,
		141,
		136,
		-1,
		-1,
		133,
		129,
		136,
		123,
		119,
		136,
		149,
		131,
		145,
		144,
		-1,
		139,
		157,
		162,
		130,
		128,
		112,
		110,
		128,
		130,
		136,
		136,
		-1,
		148,
		149,
		144,
		152,
		152,
		128,
		115,
		115,
		125,
		118,
		137,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		131,
		148,
		140,
		130,
		145,
		138,
		118,
		115,
		113,
		110,
		126,
		124,
		134,
		-1,
		-1,
		239,
		208,
		239,
		197,
		178,
		-1,
		144,
		124,
		130,
		134,
		128,
		121,
		135,
		131,
		-1,
		104,
		103,
		131,
		117,
		128,
		199,
		-1,
		-1,
		197,
		189,
		174,
		177,
		154,
		150,
		139,
		138,
		130,
		116,
		112,
		118,
		121,
		121,
		127,
		98,
		108,
		112,
		110,
		135,
		-1,
		-1,
		170,
		-1,
		-1,
		196,
		179,
		-1,
		162,
		169,
		160,
		166,
		152,
		173,
		149,
		140,
		132,
		126,
		114,
		116,
		113,
		126,
		114,
		95,
		120,
		124,
		105,
		126,
		121,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		155,
		158,
		164,
		188,
		189,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		120,
		105,
		112,
		111,
		99,
		97,
		127,
		102,
		124,
		121,
		140,
		145,
		139,
		148,
		-1,
		204,
		200,
		196,
		203,
		152,
		-1,
		-1,
		192,
		-1,
		197,
		198,
		173,
		146,
		149,
		136,
		127,
		114,
		103,
		114,
		103,
		100,
		108,
		91,
		106,
		97,
		96,
		114,
		124,
		132,
		136,
		142,
		-1,
		254,
		-1,
		196,
		180,
		182,
		154,
		175,
		-1,
		212,
		198,
		190,
		175,
		173,
		-1,
		145,
		142,
		132,
		110,
		95,
		112,
		104,
		102,
		104,
		86,
		100,
		91,
		109,
		116,
		114,
		118,
		138,
		150,
		214,
		204,
		-1,
		186,
		191,
		150,
		158,
		177,
		215,
		179,
		-1,
		174,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		95,
		90,
		105,
		97,
		82,
		79,
		97,
		100,
		107,
		111,
		127,
		-1,
		-1,
		199,
		203,
		192,
		143,
		162,
		186,
		223,
		172,
		161,
		160,
		-1,
		151,
		130,
		127,
		115,
		102,
		87,
		88,
		96,
		108,
		87,
		81,
		78,
		98,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		169,
		140,
		164,
		206,
		190,
		183,
		171,
		136,
		136,
		130,
		-1,
		126,
		105,
		96,
		85,
		83,
		96,
		88,
		96,
		76,
		74,
		93,
		105,
		96,
		107,
		-1,
		-1,
		-1,
		199,
		188,
		189,
		135,
		158,
		195,
		169,
		155,
		160,
		135,
		128,
		122,
		139,
		122,
		103,
		92,
		84,
		73,
		84,
		92,
		90,
		72,
		81,
		87,
		111,
		95,
		101,
		-1,
		-1,
		206,
		196,
		180,
		182,
		179,
		149,
		156,
		188,
		160,
		173,
		-1,
		127,
		-1,
		116,
		112,
		97,
		92,
		89,
		76,
		75,
		89,
		89,
		79,
		74,
		81,
		116,
		116,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		199,
		194,
		169,
		146,
		130,
		166,
		-1,
		143,
		144,
		-1,
		121,
		115,
		112,
		99,
		95,
		80,
		84,
		86,
		89,
		77,
		83,
		84,
		66,
		90,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		125,
		177,
		-1,
		-1,
		128,
		121,
		-1,
		108,
		90,
		92,
		87,
		86,
		85,
		82,
		71,
		84,
		77,
		71,
		65,
		78,
		82,
		86,
		75,
		71,
		68,
		82,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		145,
		-1,
		137,
		129,
		119,
		113,
		107,
		103,
		101,
		114,
		98,
		97,
		94,
		85,
		87,
		66,
		59,
		70,
		55,
		73,
		81,
		73,
		67,
		66,
		78,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		158,
		-1,
		122,
		136,
		152,
		-1,
		145,
		124,
		139,
		117,
		113,
		104,
		109,
		110,
		80,
		85,
		87,
		75,
		71,
		60,
		63,
		55,
		77,
		77,
		61,
		62,
		71,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		119,
		107,
		139,
		-1,
		-1,
		178,
		-1,
		115,
		132,
		118,
		116,
		99,
		74,
		81,
		99,
		72,
		67,
		65,
		54,
		54,
		49,
		71,
		57,
		55,
		74,
		90,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		156,
		144,
		131,
		113,
		151,
		-1,
		73,
		69,
		76,
		-1,
		92,
		-1,
		62,
		58,
		49,
		46,
		43,
		54,
		52,
		63,
		78,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		176,
		-1,
		-1,
		143,
		137,
		137,
		106,
		103,
		89,
		69,
		61,
		76,
		75,
		60,
		61,
		40,
		40,
		43,
		46,
		59,
		77,
		70,
		76,
		-1,
		-1,
		-1,
		173,
		159,
		163,
		123,
		142,
		-1,
		-1,
		204,
		160,
		146,
		-1,
		98,
		89,
		77,
		67,
		57,
		62,
		63,
		51,
		42,
		38,
		47,
		51,
		55,
		55,
		76,
		70,
		92,
		-1,
		-1,
		156,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		150,
		151,
		117,
		96,
		78,
		-1,
		-1,
		61,
		54,
		48,
		39,
		30,
		49,
		56,
		40,
		49,
		64,
		75,
		83,
		82,
		-1,
		159,
		146,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		-1,
		-1,
		129,
		74,
		63,
		58,
		62,
		60,
		-1,
		34,
		36,
		26,
		33,
		40,
		40,
		34,
		43,
		54,
		70,
		87,
		-1,
		-1,
		171,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		86,
		80,
		51,
		44,
		48,
		-1,
		36,
		29,
		23,
		15,
		14,
		19,
		27,
		43,
		52,
		55,
		68,
		82,
		86,
		194,
		-1,
		137,
		-1,
		-1,
		-1,
		104,
		119,
		90,
		67,
		40,
		35,
		28,
		22,
		18,
		0,
		9,
		20,
		37,
		41,
		51,
		61,
		60,
		77,
		87,
		-1,
		-1,
		135,
		131,
		130,
		112,
		116,
		117,
		-1,
		-1,
		44,
		35,
		26,
		19,
		7,
		4,
		33,
		35,
		53,
		67,
		55,
		70,
		85,
		88,
		-1,
		-1,
		-1,
		147,
		-1,
		149,
		-1,
		-1,
		131,
		115,
		62,
		44,
		40,
		38,
		31,
		35,
		23,
		28,
		53,
		50,
		59,
		57,
		68,
		91,
		80,
		119,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		126,
		118,
		113,
		119,
		121,
		112,
		77,
		74,
		-1,
		44,
		64,
		29,
		36,
		28,
		43,
		48,
		54,
		58,
		65,
		81,
		80,
		75,
		111,
		102,
		108,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		119,
		115,
		105,
		95,
		98,
		-1,
		-1,
		92,
		89,
		61,
		38,
		44,
		37,
		32,
		70,
		46,
		54,
		58,
		62,
		68,
		73,
		78,
		84,
		99,
		114,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		109,
		101,
		112,
		87,
		89,
		-1,
		-1,
		65,
		56,
		57,
		45,
		42,
		55,
		54,
		66,
		68,
		73,
		61,
		60,
		78,
		82,
		91,
		98,
		88,
		101,
		105,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		106,
		-1,
		-1,
		118,
		90,
		74,
		64,
		61,
		104,
		59,
		54,
		56,
		58,
		64,
		55,
		78,
		69,
		69,
		72,
		87,
		92,
		84,
		98,
		98,
		99,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		134,
		-1,
		101,
		-1,
		83,
		87,
		67,
		70,
		81,
		68,
		68,
		76,
		84,
		67,
		77,
		73,
		74,
		83,
		94,
		106,
		105,
		106,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		118,
		157,
		172,
		-1,
		143,
		-1,
		-1,
		-1,
		97,
		80,
		72,
		88,
		80,
		80,
		62,
		66,
		72,
		79,
		89,
		91,
		83,
		87,
		100,
		111,
		114,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		133,
		124,
		151,
		172,
		168,
		163,
		150,
		-1,
		-1,
		120,
		90,
		-1,
		-1,
		87,
		83,
		66,
		68,
		72,
		82,
		97,
		100,
		90,
		88,
		82,
		114,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		152,
		142,
		146,
		162,
		187,
		-1,
		150,
		-1,
		-1,
		140,
		-1,
		-1,
		125,
		88,
		77,
		68,
		74,
		80,
		91,
		108,
		96,
		97,
		87,
		97,
		110,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		118,
		116,
		122,
		129,
		146,
		176,
		-1,
		-1,
		166,
		146,
		-1,
		-1,
		123,
		121,
		110,
		-1,
		100,
		73,
		78,
		103,
		110,
		105,
		99,
		93,
		100,
		99,
		107,
		115,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		156,
		152,
		-1,
		-1,
		118,
		111,
		99,
		87,
		77,
		87,
		95,
		95,
		98,
		96,
		91,
		102,
		94,
		98,
		115,
		-1,
		189,
		-1,
		141,
		117,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		173,
		159,
		152,
		140,
		138,
		-1,
		152,
		136,
		117,
		-1,
		87,
		100,
		131,
		99,
		104,
		99,
		97,
		108,
		97,
		100,
		114,
		109,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		154,
		165,
		-1,
		164,
		153,
		138,
		130,
		-1,
		-1,
		124,
		120,
		-1,
		-1,
		88,
		113,
		102,
		110,
		105,
		101,
		107,
		110,
		99,
		103,
		115,
		-1,
		-1,
		136,
		137,
		142,
		-1,
		148,
		-1,
		166,
		-1,
		133,
		139,
		127,
		-1,
		-1,
		-1,
		126,
		89,
		106,
		120,
		125,
		123,
		114,
		105,
		112,
		110,
		106,
		117,
		-1,
		-1,
		-1,
		166,
		140,
		173,
		164,
		147,
		127,
		119,
		138,
		-1,
		108,
		-1,
		83,
		86,
		111,
		119,
		136,
		130,
		108,
		123,
		113,
		104,
		113,
		172,
		-1,
		142,
		175,
		139,
		133,
		109,
		113,
		129,
		-1,
		105,
		87,
		-1,
		115,
		105,
		153,
		128,
		123,
		110,
		117,
		117,
		110,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		114,
		105,
		-1,
		117,
		99,
		78,
		95,
		95,
		86,
		94,
		143,
		139,
		130,
		130,
		118,
		-1,
		245,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		133,
		106,
		94,
		100,
		96,
		82,
		88,
		90,
		98,
		96,
		93,
		105,
		101,
		121,
		117,
		149,
		-1,
		240,
		-1,
		174,
		-1,
		-1,
		156,
		136,
		128,
		117,
		106,
		104,
		95,
		86,
		108,
		124,
		108,
		106,
		111,
		116,
		-1,
		229,
		228,
		-1,
		175,
		167,
		153,
		-1,
		146,
		-1,
		152,
		113,
		-1,
		115,
		95,
		-1,
		117,
		113,
		-1,
		-1,
		216,
		191,
		-1,
		-1,
		-1,
		176,
		156,
		147,
		131,
		-1,
		106,
		106,
		-1,
		-1,
		-1,
		201,
		200,
		-1,
		169,
		172,
		-1,
		162,
		153,
		161,
		108,
		112,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		184,
		182,
		177,
		174,
		160,
		144,
		122,
		111,
		132,
		-1,
		-1,
		-1,
		182,
		174,
		167,
		-1,
		-1,
		169,
		152,
		133,
		131,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		159,
		-1,
		-1,
		165,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		193,
		-1,
		-1,
		-1,
		155,
		151,
		152,
		-1,
		-1,
		-1,
		-1,
		215,
		216,
		239,
		203,
		-1,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		218,
		216,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		145,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		180,
		-1,
		180,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		193,
		-1,
		165,
		167,
		-1,
		215,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		170,
		177,
		199,
		202,
		238,
		-1,
		189
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		145,
		163,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		154,
		155,
		150,
		158,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		137,
		154,
		146,
		136,
		151,
		144,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		245,
		214,
		245,
		203,
		184,
		-1,
		150,
		130,
		136,
		140,
		134,
		127,
		141,
		137,
		-1,
		110,
		109,
		137,
		123,
		134,
		205,
		-1,
		-1,
		203,
		195,
		180,
		183,
		160,
		156,
		145,
		144,
		136,
		122,
		118,
		124,
		127,
		127,
		133,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		166,
		172,
		158,
		179,
		155,
		146,
		138,
		132,
		120,
		122,
		119,
		132,
		120,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		195,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		203,
		204,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		204,
		196,
		181,
		179,
		-1,
		151,
		148,
		138,
		116,
		101,
		118,
		110,
		108,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		221,
		185,
		-1,
		180,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		136,
		133,
		121,
		108,
		93,
		94,
		102,
		114,
		93,
		87,
		84,
		104,
		130,
		108,
		119,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		132,
		111,
		102,
		91,
		89,
		102,
		94,
		102,
		82,
		80,
		99,
		111,
		102,
		110,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		145,
		128,
		109,
		98,
		90,
		79,
		90,
		98,
		96,
		78,
		87,
		93,
		117,
		98,
		104,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		118,
		103,
		98,
		95,
		82,
		81,
		95,
		95,
		85,
		80,
		87,
		122,
		122,
		88,
		108,
		111,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		105,
		101,
		86,
		90,
		92,
		95,
		83,
		89,
		90,
		72,
		96,
		-1,
		96,
		90,
		98,
		88,
		76,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		98,
		93,
		92,
		91,
		88,
		77,
		90,
		83,
		77,
		71,
		84,
		88,
		89,
		78,
		74,
		71,
		85,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		120,
		104,
		103,
		100,
		91,
		99,
		72,
		65,
		76,
		61,
		79,
		85,
		76,
		71,
		70,
		81,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		110,
		123,
		124,
		94,
		99,
		98,
		88,
		77,
		66,
		69,
		61,
		83,
		80,
		64,
		66,
		75,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		124,
		122,
		113,
		88,
		95,
		109,
		85,
		80,
		71,
		60,
		60,
		55,
		74,
		60,
		58,
		74,
		90,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		87,
		83,
		90,
		-1,
		105,
		-1,
		73,
		69,
		60,
		52,
		49,
		60,
		58,
		67,
		69,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		120,
		117,
		103,
		83,
		75,
		90,
		88,
		71,
		74,
		51,
		51,
		54,
		45,
		58,
		68,
		74,
		67,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		112,
		103,
		91,
		81,
		71,
		76,
		77,
		62,
		53,
		49,
		58,
		51,
		47,
		46,
		67,
		61,
		83,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		165,
		131,
		110,
		92,
		-1,
		-1,
		75,
		68,
		62,
		50,
		41,
		59,
		66,
		31,
		40,
		55,
		66,
		74,
		73,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		143,
		88,
		77,
		72,
		76,
		74,
		-1,
		48,
		49,
		37,
		33,
		40,
		31,
		25,
		34,
		45,
		61,
		78,
		-1,
		-1,
		177,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		65,
		58,
		62,
		-1,
		48,
		42,
		34,
		26,
		5,
		10,
		18,
		38,
		43,
		46,
		59,
		73,
		77,
		200,
		-1,
		149,
		-1,
		-1,
		-1,
		118,
		133,
		104,
		81,
		54,
		49,
		42,
		36,
		32,
		14,
		0,
		11,
		45,
		41,
		42,
		52,
		51,
		68,
		78,
		-1,
		-1,
		147,
		143,
		144,
		126,
		130,
		131,
		-1,
		-1,
		58,
		49,
		40,
		31,
		21,
		18,
		45,
		47,
		53,
		58,
		46,
		61,
		76,
		83,
		-1,
		-1,
		-1,
		159,
		-1,
		161,
		-1,
		-1,
		145,
		129,
		76,
		58,
		54,
		52,
		45,
		47,
		35,
		40,
		65,
		62,
		68,
		48,
		69,
		86,
		81,
		115,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		138,
		130,
		125,
		131,
		133,
		124,
		91,
		88,
		-1,
		58,
		76,
		41,
		48,
		40,
		55,
		60,
		66,
		53,
		66,
		82,
		81,
		76,
		107,
		102,
		109,
		-1,
		-1,
		224,
		213,
		202,
		208,
		-1,
		131,
		127,
		117,
		107,
		110,
		-1,
		-1,
		104,
		101,
		73,
		50,
		56,
		49,
		44,
		82,
		58,
		55,
		59,
		63,
		69,
		74,
		79,
		85,
		100,
		115,
		-1,
		178,
		215,
		208,
		176,
		184,
		215,
		-1,
		121,
		113,
		124,
		99,
		101,
		-1,
		-1,
		77,
		68,
		69,
		57,
		54,
		67,
		66,
		78,
		69,
		75,
		62,
		61,
		79,
		83,
		92,
		99,
		89,
		102,
		106,
		-1,
		171,
		191,
		170,
		173,
		197,
		211,
		-1,
		118,
		-1,
		-1,
		130,
		102,
		86,
		76,
		73,
		116,
		71,
		66,
		68,
		70,
		76,
		67,
		79,
		70,
		70,
		73,
		88,
		93,
		85,
		99,
		99,
		100,
		-1,
		160,
		171,
		164,
		-1,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		146,
		-1,
		113,
		-1,
		96,
		100,
		79,
		82,
		93,
		80,
		80,
		77,
		93,
		68,
		78,
		74,
		75,
		84,
		95,
		107,
		106,
		107,
		185,
		141,
		144,
		155,
		166,
		181,
		185,
		-1,
		130,
		169,
		184,
		-1,
		155,
		-1,
		-1,
		-1,
		110,
		92,
		84,
		100,
		92,
		92,
		74,
		78,
		73,
		80,
		90,
		92,
		84,
		88,
		101,
		112,
		115,
		181,
		172,
		185,
		130,
		130,
		151,
		160,
		181,
		145,
		136,
		163,
		184,
		180,
		175,
		162,
		-1,
		-1,
		133,
		102,
		-1,
		-1,
		99,
		95,
		78,
		80,
		80,
		83,
		98,
		101,
		91,
		89,
		83,
		115,
		-1,
		174,
		173,
		162,
		159,
		135,
		126,
		121,
		148,
		-1,
		-1,
		143,
		164,
		154,
		158,
		174,
		199,
		-1,
		162,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		100,
		89,
		80,
		86,
		88,
		99,
		109,
		97,
		98,
		88,
		98,
		111,
		158,
		155,
		143,
		141,
		164,
		129,
		117,
		-1,
		130,
		128,
		134,
		141,
		158,
		188,
		-1,
		-1,
		178,
		158,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		90,
		115,
		117,
		106,
		100,
		94,
		101,
		100,
		108,
		116,
		167,
		181,
		170,
		166,
		165,
		173,
		122,
		115,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		164,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		99,
		107,
		107,
		104,
		97,
		92,
		103,
		95,
		99,
		116,
		-1,
		201,
		-1,
		153,
		129,
		143,
		158,
		166,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		143,
		111,
		116,
		111,
		98,
		109,
		98,
		101,
		115,
		110,
		-1,
		-1,
		141,
		144,
		-1,
		-1,
		166,
		177,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		125,
		114,
		122,
		117,
		102,
		108,
		111,
		100,
		104,
		116,
		-1,
		-1,
		148,
		149,
		154,
		-1,
		160,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		138,
		101,
		118,
		132,
		131,
		129,
		120,
		106,
		113,
		111,
		107,
		118,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		98,
		123,
		131,
		142,
		136,
		109,
		124,
		114,
		105,
		114,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		117,
		158,
		140,
		124,
		111,
		118,
		118,
		111,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		148,
		144,
		131,
		131,
		123,
		-1,
		257,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		117,
		113,
		133,
		124,
		159,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		120,
		118,
		123,
		128,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		129,
		125,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		205,
		194,
		205,
		213,
		186,
		193,
		-1,
		212,
		216,
		182,
		176,
		215,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		205,
		204,
		172,
		170,
		179,
		184,
		191,
		-1,
		190,
		-1,
		226,
		205,
		216,
		221,
		165,
		162,
		182,
		201,
		183,
		175,
		241,
		195,
		166,
		160,
		178,
		168,
		177,
		169,
		-1,
		166,
		156,
		178,
		157,
		168,
		160,
		-1,
		-1,
		160,
		161,
		167,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		150,
		151,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		141,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		147,
		165,
		170,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		144,
		-1,
		156,
		157,
		152,
		160,
		160,
		136,
		123,
		123,
		133,
		126,
		145,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		126,
		123,
		121,
		118,
		134,
		132,
		142,
		-1,
		-1,
		247,
		216,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		112,
		111,
		139,
		125,
		136,
		207,
		-1,
		-1,
		205,
		197,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		106,
		116,
		120,
		118,
		143,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		103,
		128,
		132,
		113,
		134,
		129,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		107,
		105,
		135,
		110,
		132,
		129,
		148,
		153,
		147,
		156,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		99,
		114,
		105,
		104,
		122,
		132,
		140,
		144,
		150,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		206,
		198,
		183,
		181,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		112,
		94,
		108,
		99,
		117,
		124,
		122,
		126,
		146,
		158,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		105,
		90,
		87,
		105,
		108,
		115,
		119,
		135,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		116,
		95,
		89,
		86,
		106,
		132,
		110,
		121,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		96,
		104,
		84,
		82,
		101,
		113,
		104,
		112,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		147,
		130,
		111,
		100,
		92,
		81,
		92,
		100,
		98,
		80,
		89,
		95,
		119,
		100,
		106,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		120,
		105,
		100,
		97,
		84,
		83,
		97,
		97,
		87,
		82,
		89,
		124,
		124,
		90,
		110,
		113,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		107,
		103,
		88,
		92,
		94,
		97,
		85,
		91,
		92,
		74,
		98,
		-1,
		98,
		92,
		100,
		90,
		78,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		100,
		95,
		94,
		93,
		90,
		79,
		92,
		85,
		79,
		73,
		86,
		90,
		91,
		80,
		76,
		73,
		87,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		122,
		106,
		105,
		102,
		93,
		101,
		74,
		67,
		78,
		63,
		81,
		87,
		78,
		73,
		72,
		83,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		112,
		129,
		130,
		108,
		102,
		100,
		90,
		79,
		68,
		71,
		63,
		85,
		82,
		66,
		68,
		77,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		126,
		124,
		119,
		103,
		110,
		111,
		87,
		82,
		73,
		62,
		62,
		57,
		76,
		62,
		60,
		76,
		92,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		102,
		98,
		105,
		-1,
		107,
		-1,
		79,
		78,
		69,
		54,
		51,
		62,
		60,
		69,
		71,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		132,
		118,
		98,
		90,
		105,
		90,
		73,
		76,
		62,
		60,
		57,
		47,
		60,
		70,
		76,
		69,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		127,
		118,
		106,
		96,
		86,
		91,
		89,
		64,
		55,
		60,
		67,
		53,
		49,
		48,
		69,
		63,
		85,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		146,
		125,
		107,
		-1,
		-1,
		90,
		83,
		77,
		58,
		52,
		61,
		68,
		33,
		42,
		57,
		68,
		76,
		75,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		158,
		103,
		92,
		87,
		91,
		89,
		-1,
		63,
		64,
		52,
		35,
		42,
		33,
		27,
		36,
		47,
		63,
		80,
		-1,
		-1,
		179,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		80,
		73,
		77,
		-1,
		63,
		57,
		49,
		41,
		7,
		12,
		20,
		40,
		45,
		48,
		61,
		75,
		79,
		202,
		-1,
		164,
		-1,
		-1,
		-1,
		133,
		148,
		119,
		96,
		69,
		64,
		57,
		51,
		47,
		29,
		15,
		0,
		47,
		43,
		44,
		54,
		53,
		70,
		80,
		-1,
		-1,
		162,
		158,
		159,
		141,
		145,
		146,
		-1,
		-1,
		73,
		64,
		55,
		46,
		36,
		33,
		53,
		50,
		55,
		60,
		48,
		63,
		78,
		85,
		-1,
		-1,
		-1,
		174,
		-1,
		176,
		-1,
		-1,
		160,
		144,
		91,
		73,
		69,
		67,
		60,
		62,
		50,
		55,
		68,
		77,
		70,
		50,
		71,
		88,
		83,
		117,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		153,
		145,
		140,
		146,
		148,
		139,
		106,
		103,
		-1,
		73,
		91,
		56,
		63,
		55,
		70,
		75,
		74,
		55,
		68,
		84,
		83,
		78,
		109,
		104,
		111,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		146,
		142,
		132,
		122,
		125,
		-1,
		-1,
		119,
		116,
		88,
		65,
		71,
		64,
		59,
		90,
		70,
		57,
		61,
		65,
		71,
		76,
		81,
		87,
		102,
		117,
		-1,
		193,
		230,
		223,
		191,
		199,
		230,
		-1,
		136,
		128,
		139,
		114,
		116,
		-1,
		-1,
		92,
		83,
		84,
		72,
		69,
		82,
		81,
		86,
		71,
		77,
		64,
		63,
		81,
		85,
		94,
		101,
		91,
		104,
		108,
		-1,
		186,
		206,
		185,
		188,
		212,
		226,
		-1,
		133,
		-1,
		-1,
		145,
		117,
		101,
		91,
		88,
		131,
		86,
		81,
		83,
		85,
		83,
		74,
		81,
		72,
		72,
		75,
		90,
		95,
		87,
		101,
		101,
		102,
		-1,
		175,
		186,
		179,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		161,
		-1,
		128,
		-1,
		111,
		115,
		94,
		97,
		108,
		95,
		87,
		79,
		95,
		70,
		80,
		76,
		77,
		86,
		97,
		109,
		108,
		109,
		200,
		156,
		159,
		170,
		181,
		196,
		200,
		-1,
		145,
		184,
		199,
		-1,
		170,
		-1,
		-1,
		-1,
		125,
		107,
		99,
		115,
		107,
		107,
		81,
		85,
		75,
		82,
		92,
		94,
		86,
		90,
		103,
		114,
		117,
		196,
		187,
		200,
		145,
		145,
		166,
		175,
		196,
		160,
		151,
		178,
		199,
		195,
		190,
		177,
		-1,
		-1,
		148,
		117,
		-1,
		-1,
		114,
		102,
		85,
		86,
		82,
		85,
		100,
		103,
		93,
		91,
		85,
		117,
		-1,
		189,
		188,
		177,
		174,
		150,
		141,
		136,
		163,
		-1,
		-1,
		158,
		179,
		169,
		173,
		189,
		214,
		-1,
		174,
		-1,
		-1,
		159,
		-1,
		-1,
		144,
		107,
		96,
		87,
		93,
		90,
		101,
		111,
		99,
		100,
		90,
		100,
		113,
		173,
		170,
		158,
		156,
		179,
		144,
		132,
		-1,
		145,
		143,
		149,
		156,
		173,
		203,
		-1,
		-1,
		190,
		170,
		-1,
		-1,
		142,
		140,
		129,
		-1,
		119,
		92,
		97,
		117,
		119,
		108,
		102,
		96,
		103,
		102,
		110,
		118,
		182,
		196,
		185,
		181,
		180,
		188,
		137,
		130,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		180,
		176,
		-1,
		-1,
		137,
		130,
		118,
		106,
		96,
		106,
		110,
		114,
		106,
		99,
		94,
		105,
		97,
		101,
		118,
		-1,
		216,
		-1,
		168,
		144,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		197,
		183,
		176,
		164,
		162,
		-1,
		171,
		155,
		136,
		-1,
		106,
		119,
		150,
		118,
		123,
		118,
		100,
		111,
		100,
		103,
		117,
		112,
		-1,
		-1,
		156,
		159,
		-1,
		-1,
		181,
		189,
		-1,
		188,
		177,
		162,
		154,
		-1,
		-1,
		143,
		139,
		-1,
		-1,
		107,
		132,
		121,
		129,
		124,
		104,
		110,
		113,
		102,
		106,
		118,
		-1,
		-1,
		163,
		164,
		169,
		-1,
		172,
		-1,
		190,
		-1,
		157,
		163,
		151,
		-1,
		-1,
		-1,
		145,
		108,
		129,
		139,
		133,
		131,
		122,
		108,
		115,
		113,
		109,
		120,
		-1,
		-1,
		-1,
		190,
		164,
		197,
		188,
		171,
		151,
		143,
		162,
		-1,
		132,
		-1,
		107,
		109,
		135,
		138,
		144,
		138,
		111,
		126,
		116,
		107,
		116,
		196,
		-1,
		166,
		199,
		163,
		157,
		133,
		137,
		153,
		-1,
		129,
		111,
		-1,
		139,
		129,
		160,
		145,
		126,
		113,
		120,
		120,
		113,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		153,
		138,
		129,
		-1,
		141,
		123,
		102,
		119,
		119,
		110,
		118,
		150,
		146,
		133,
		133,
		125,
		-1,
		269,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		157,
		130,
		118,
		124,
		120,
		106,
		112,
		114,
		122,
		120,
		117,
		129,
		125,
		145,
		126,
		161,
		-1,
		264,
		-1,
		198,
		-1,
		-1,
		180,
		160,
		152,
		141,
		130,
		128,
		119,
		110,
		132,
		148,
		132,
		130,
		133,
		134,
		-1,
		253,
		252,
		-1,
		199,
		191,
		177,
		-1,
		170,
		-1,
		176,
		137,
		-1,
		139,
		119,
		-1,
		141,
		137,
		-1,
		-1,
		240,
		215,
		-1,
		-1,
		-1,
		200,
		180,
		171,
		155,
		-1,
		130,
		130,
		-1,
		-1,
		-1,
		225,
		224,
		-1,
		193,
		196,
		-1,
		186,
		177,
		185,
		132,
		136,
		-1,
		-1,
		-1,
		234,
		215,
		209,
		208,
		206,
		201,
		198,
		184,
		168,
		146,
		135,
		156,
		-1,
		-1,
		-1,
		206,
		198,
		191,
		-1,
		-1,
		193,
		176,
		157,
		155,
		-1,
		-1,
		-1,
		228,
		209,
		-1,
		-1,
		183,
		-1,
		-1,
		189,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		217,
		-1,
		-1,
		-1,
		179,
		175,
		176,
		-1,
		-1,
		-1,
		-1,
		239,
		240,
		263,
		227,
		-1,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		242,
		240,
		-1,
		-1,
		-1,
		199,
		183,
		-1,
		169,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		204,
		-1,
		204,
		179,
		186,
		-1,
		-1,
		-1,
		-1,
		217,
		209,
		217,
		-1,
		189,
		191,
		-1,
		239,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		194,
		201,
		223,
		226,
		262,
		-1,
		213
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		189,
		193,
		159,
		153,
		192,
		161,
		167,
		178,
		-1,
		-1,
		-1,
		182,
		181,
		149,
		147,
		156,
		161,
		168,
		-1,
		167,
		-1,
		203,
		182,
		193,
		198,
		142,
		139,
		159,
		178,
		160,
		152,
		218,
		172,
		143,
		137,
		155,
		145,
		154,
		146,
		-1,
		143,
		133,
		155,
		134,
		145,
		137,
		-1,
		-1,
		137,
		138,
		144,
		130,
		136,
		132,
		-1,
		142,
		126,
		-1,
		-1,
		127,
		128,
		112,
		115,
		123,
		121,
		134,
		126,
		121,
		-1,
		-1,
		118,
		114,
		121,
		108,
		104,
		121,
		134,
		116,
		130,
		129,
		-1,
		124,
		142,
		147,
		115,
		113,
		97,
		95,
		113,
		115,
		121,
		121,
		-1,
		133,
		134,
		129,
		137,
		137,
		113,
		100,
		100,
		110,
		103,
		122,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		133,
		116,
		133,
		125,
		115,
		130,
		123,
		103,
		100,
		98,
		95,
		111,
		109,
		119,
		-1,
		-1,
		224,
		193,
		224,
		182,
		163,
		-1,
		129,
		109,
		115,
		119,
		113,
		106,
		120,
		116,
		-1,
		89,
		88,
		116,
		102,
		113,
		184,
		-1,
		-1,
		182,
		174,
		159,
		162,
		139,
		135,
		124,
		123,
		115,
		101,
		97,
		103,
		106,
		106,
		112,
		83,
		93,
		97,
		95,
		120,
		-1,
		-1,
		155,
		-1,
		-1,
		181,
		164,
		-1,
		147,
		154,
		145,
		151,
		137,
		158,
		134,
		125,
		117,
		111,
		99,
		101,
		98,
		111,
		99,
		80,
		105,
		109,
		90,
		111,
		106,
		-1,
		154,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		140,
		143,
		149,
		173,
		174,
		-1,
		146,
		134,
		135,
		120,
		117,
		104,
		92,
		105,
		90,
		97,
		96,
		84,
		82,
		112,
		87,
		109,
		106,
		125,
		130,
		124,
		133,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		177,
		-1,
		182,
		183,
		158,
		131,
		134,
		121,
		112,
		99,
		88,
		99,
		88,
		85,
		93,
		76,
		91,
		82,
		81,
		99,
		109,
		117,
		121,
		127,
		-1,
		239,
		-1,
		181,
		165,
		167,
		139,
		160,
		-1,
		197,
		183,
		175,
		160,
		158,
		-1,
		130,
		127,
		117,
		95,
		80,
		97,
		89,
		87,
		89,
		71,
		85,
		76,
		94,
		101,
		99,
		103,
		123,
		135,
		199,
		189,
		-1,
		171,
		176,
		135,
		143,
		162,
		200,
		164,
		-1,
		159,
		-1,
		132,
		145,
		-1,
		101,
		97,
		79,
		80,
		75,
		90,
		82,
		67,
		64,
		82,
		85,
		92,
		96,
		112,
		-1,
		-1,
		184,
		188,
		177,
		128,
		147,
		171,
		208,
		157,
		146,
		145,
		-1,
		136,
		115,
		112,
		100,
		87,
		72,
		73,
		81,
		93,
		72,
		66,
		63,
		83,
		109,
		87,
		98,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		154,
		125,
		149,
		191,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		111,
		90,
		81,
		70,
		68,
		81,
		73,
		81,
		61,
		59,
		78,
		90,
		81,
		89,
		-1,
		-1,
		-1,
		184,
		173,
		174,
		120,
		143,
		180,
		154,
		140,
		145,
		120,
		113,
		107,
		124,
		107,
		88,
		77,
		69,
		58,
		69,
		77,
		75,
		57,
		66,
		72,
		96,
		77,
		83,
		-1,
		-1,
		191,
		181,
		165,
		167,
		164,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		97,
		82,
		77,
		74,
		61,
		60,
		74,
		74,
		64,
		59,
		66,
		101,
		101,
		67,
		87,
		90,
		-1,
		-1,
		-1,
		184,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		84,
		80,
		65,
		69,
		71,
		74,
		62,
		68,
		69,
		51,
		75,
		-1,
		75,
		69,
		77,
		67,
		55,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		77,
		72,
		71,
		70,
		67,
		56,
		69,
		62,
		56,
		50,
		63,
		67,
		68,
		57,
		53,
		50,
		64,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		99,
		83,
		82,
		79,
		70,
		78,
		51,
		44,
		55,
		40,
		58,
		64,
		55,
		50,
		49,
		60,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		89,
		106,
		107,
		85,
		79,
		77,
		68,
		56,
		45,
		48,
		40,
		62,
		59,
		43,
		45,
		54,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		103,
		101,
		96,
		83,
		90,
		88,
		65,
		60,
		50,
		39,
		39,
		34,
		53,
		39,
		37,
		52,
		68,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		82,
		78,
		85,
		-1,
		85,
		-1,
		58,
		55,
		46,
		31,
		28,
		39,
		37,
		46,
		47,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		98,
		78,
		70,
		85,
		80,
		71,
		66,
		44,
		37,
		34,
		24,
		37,
		47,
		53,
		45,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		107,
		98,
		86,
		76,
		66,
		71,
		72,
		62,
		56,
		42,
		44,
		33,
		26,
		25,
		46,
		39,
		61,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		126,
		105,
		87,
		-1,
		-1,
		70,
		63,
		57,
		59,
		46,
		55,
		50,
		32,
		19,
		34,
		44,
		52,
		51,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		138,
		83,
		72,
		67,
		71,
		69,
		-1,
		43,
		54,
		47,
		57,
		64,
		34,
		19,
		13,
		24,
		39,
		56,
		-1,
		-1,
		156,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		95,
		89,
		60,
		53,
		57,
		-1,
		45,
		47,
		44,
		56,
		37,
		34,
		25,
		7,
		21,
		24,
		37,
		51,
		55,
		179,
		-1,
		132,
		-1,
		-1,
		-1,
		113,
		128,
		99,
		76,
		49,
		44,
		37,
		31,
		36,
		47,
		45,
		56,
		0,
		5,
		20,
		30,
		29,
		46,
		56,
		-1,
		-1,
		130,
		126,
		139,
		121,
		125,
		126,
		-1,
		-1,
		53,
		44,
		35,
		27,
		40,
		43,
		6,
		3,
		17,
		36,
		24,
		39,
		54,
		61,
		-1,
		-1,
		-1,
		142,
		-1,
		144,
		-1,
		-1,
		132,
		124,
		71,
		53,
		49,
		47,
		36,
		30,
		18,
		11,
		21,
		31,
		34,
		26,
		48,
		64,
		60,
		93,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		121,
		113,
		108,
		114,
		116,
		107,
		86,
		83,
		-1,
		53,
		59,
		24,
		31,
		23,
		29,
		29,
		35,
		31,
		45,
		61,
		60,
		55,
		85,
		80,
		88,
		-1,
		-1,
		207,
		196,
		185,
		191,
		-1,
		114,
		110,
		100,
		90,
		93,
		-1,
		-1,
		87,
		84,
		56,
		33,
		39,
		32,
		27,
		62,
		41,
		34,
		38,
		42,
		48,
		53,
		58,
		64,
		79,
		94,
		-1,
		161,
		198,
		191,
		159,
		167,
		198,
		-1,
		104,
		96,
		107,
		82,
		84,
		-1,
		-1,
		60,
		51,
		52,
		40,
		37,
		50,
		49,
		61,
		48,
		54,
		41,
		40,
		58,
		62,
		71,
		78,
		68,
		81,
		85,
		-1,
		154,
		174,
		153,
		156,
		180,
		194,
		-1,
		101,
		-1,
		-1,
		113,
		85,
		69,
		59,
		56,
		99,
		54,
		49,
		51,
		53,
		59,
		50,
		58,
		49,
		49,
		52,
		67,
		72,
		64,
		78,
		78,
		79,
		-1,
		143,
		154,
		147,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		129,
		-1,
		96,
		-1,
		79,
		83,
		62,
		65,
		76,
		63,
		63,
		56,
		72,
		47,
		57,
		53,
		54,
		63,
		74,
		86,
		85,
		86,
		168,
		124,
		127,
		138,
		149,
		164,
		168,
		-1,
		113,
		152,
		167,
		-1,
		138,
		-1,
		-1,
		-1,
		93,
		75,
		67,
		83,
		75,
		75,
		57,
		61,
		52,
		59,
		69,
		71,
		63,
		67,
		80,
		91,
		94,
		164,
		155,
		168,
		113,
		113,
		134,
		143,
		164,
		128,
		119,
		146,
		167,
		163,
		158,
		145,
		-1,
		-1,
		116,
		85,
		-1,
		-1,
		82,
		78,
		61,
		63,
		59,
		62,
		77,
		80,
		70,
		68,
		62,
		94,
		-1,
		157,
		156,
		145,
		142,
		118,
		109,
		104,
		131,
		-1,
		-1,
		126,
		147,
		137,
		141,
		157,
		182,
		-1,
		145,
		-1,
		-1,
		135,
		-1,
		-1,
		120,
		83,
		72,
		63,
		69,
		67,
		78,
		88,
		76,
		77,
		67,
		77,
		90,
		141,
		138,
		126,
		124,
		147,
		112,
		100,
		-1,
		113,
		111,
		117,
		124,
		141,
		171,
		-1,
		-1,
		161,
		141,
		-1,
		-1,
		118,
		116,
		105,
		-1,
		95,
		68,
		73,
		94,
		96,
		85,
		79,
		73,
		80,
		79,
		87,
		95,
		150,
		164,
		153,
		149,
		148,
		156,
		105,
		98,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		113,
		106,
		94,
		82,
		72,
		82,
		87,
		90,
		83,
		76,
		71,
		82,
		74,
		78,
		95,
		-1,
		184,
		-1,
		136,
		112,
		126,
		141,
		149,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		147,
		131,
		112,
		-1,
		82,
		95,
		126,
		94,
		99,
		94,
		77,
		88,
		77,
		80,
		94,
		89,
		-1,
		-1,
		124,
		127,
		-1,
		-1,
		149,
		160,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		119,
		115,
		-1,
		-1,
		83,
		108,
		97,
		105,
		100,
		81,
		87,
		90,
		79,
		83,
		95,
		-1,
		-1,
		131,
		132,
		137,
		-1,
		143,
		-1,
		161,
		-1,
		128,
		134,
		122,
		-1,
		-1,
		-1,
		121,
		84,
		101,
		115,
		110,
		108,
		99,
		85,
		92,
		90,
		86,
		97,
		-1,
		-1,
		-1,
		161,
		135,
		168,
		159,
		142,
		122,
		114,
		133,
		-1,
		103,
		-1,
		78,
		81,
		106,
		114,
		121,
		115,
		88,
		103,
		93,
		84,
		93,
		167,
		-1,
		137,
		170,
		134,
		128,
		104,
		108,
		124,
		-1,
		100,
		82,
		-1,
		110,
		100,
		137,
		122,
		103,
		90,
		97,
		97,
		90,
		-1,
		-1,
		-1,
		139,
		138,
		130,
		124,
		124,
		109,
		100,
		-1,
		112,
		94,
		73,
		90,
		90,
		81,
		89,
		127,
		123,
		110,
		110,
		102,
		-1,
		240,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		133,
		128,
		101,
		89,
		95,
		91,
		77,
		83,
		85,
		93,
		91,
		88,
		100,
		96,
		116,
		103,
		138,
		-1,
		235,
		-1,
		169,
		-1,
		-1,
		151,
		131,
		123,
		112,
		101,
		99,
		90,
		81,
		103,
		119,
		103,
		101,
		106,
		111,
		-1,
		224,
		223,
		-1,
		170,
		162,
		148,
		-1,
		141,
		-1,
		147,
		108,
		-1,
		110,
		90,
		-1,
		112,
		108,
		-1,
		-1,
		211,
		186,
		-1,
		-1,
		-1,
		171,
		151,
		142,
		126,
		-1,
		101,
		101,
		-1,
		-1,
		-1,
		196,
		195,
		-1,
		164,
		167,
		-1,
		157,
		148,
		156,
		103,
		107,
		-1,
		-1,
		-1,
		205,
		186,
		180,
		179,
		177,
		172,
		169,
		155,
		139,
		117,
		106,
		127,
		-1,
		-1,
		-1,
		177,
		169,
		162,
		-1,
		-1,
		164,
		147,
		128,
		126,
		-1,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		154,
		-1,
		-1,
		160,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		188,
		-1,
		-1,
		-1,
		150,
		146,
		147,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		234,
		198,
		-1,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		213,
		211,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		140,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		175,
		-1,
		175,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		188,
		180,
		188,
		-1,
		160,
		162,
		-1,
		210,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		165,
		172,
		194,
		197,
		233,
		-1,
		184
	],
	[
		-1,
		177,
		166,
		177,
		185,
		158,
		165,
		-1,
		184,
		188,
		154,
		148,
		187,
		156,
		162,
		173,
		-1,
		-1,
		-1,
		177,
		176,
		144,
		142,
		151,
		156,
		163,
		-1,
		162,
		-1,
		198,
		177,
		188,
		193,
		137,
		134,
		154,
		173,
		155,
		147,
		213,
		167,
		138,
		132,
		150,
		140,
		149,
		141,
		-1,
		138,
		128,
		150,
		129,
		140,
		132,
		-1,
		-1,
		132,
		133,
		139,
		125,
		131,
		127,
		-1,
		137,
		121,
		-1,
		-1,
		122,
		123,
		107,
		110,
		118,
		116,
		129,
		121,
		116,
		-1,
		-1,
		113,
		109,
		116,
		103,
		99,
		116,
		129,
		111,
		125,
		124,
		-1,
		119,
		137,
		142,
		110,
		108,
		92,
		90,
		108,
		110,
		116,
		116,
		-1,
		128,
		129,
		124,
		132,
		132,
		108,
		95,
		95,
		105,
		98,
		117,
		105,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		128,
		111,
		128,
		120,
		110,
		125,
		118,
		98,
		95,
		93,
		90,
		106,
		104,
		114,
		-1,
		-1,
		219,
		188,
		219,
		177,
		158,
		-1,
		124,
		104,
		110,
		114,
		108,
		101,
		115,
		111,
		-1,
		84,
		83,
		111,
		97,
		108,
		179,
		-1,
		-1,
		177,
		169,
		154,
		157,
		134,
		130,
		119,
		118,
		110,
		96,
		92,
		98,
		101,
		101,
		107,
		78,
		88,
		92,
		90,
		115,
		-1,
		-1,
		150,
		-1,
		-1,
		176,
		159,
		-1,
		142,
		149,
		140,
		146,
		132,
		153,
		129,
		120,
		112,
		106,
		94,
		96,
		93,
		106,
		94,
		75,
		100,
		104,
		85,
		106,
		101,
		-1,
		149,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		135,
		138,
		144,
		168,
		169,
		-1,
		141,
		129,
		130,
		115,
		112,
		99,
		87,
		100,
		85,
		92,
		91,
		79,
		77,
		107,
		82,
		104,
		101,
		120,
		125,
		119,
		128,
		-1,
		184,
		180,
		176,
		183,
		132,
		-1,
		-1,
		172,
		-1,
		177,
		178,
		153,
		126,
		129,
		116,
		107,
		94,
		83,
		94,
		83,
		80,
		88,
		71,
		86,
		77,
		76,
		94,
		104,
		112,
		116,
		122,
		-1,
		234,
		-1,
		176,
		160,
		162,
		134,
		155,
		-1,
		192,
		178,
		170,
		155,
		153,
		-1,
		125,
		122,
		112,
		90,
		75,
		92,
		84,
		82,
		84,
		66,
		80,
		71,
		89,
		96,
		94,
		98,
		118,
		130,
		194,
		184,
		-1,
		166,
		171,
		130,
		138,
		157,
		195,
		159,
		-1,
		154,
		-1,
		127,
		140,
		-1,
		96,
		92,
		74,
		75,
		70,
		85,
		77,
		62,
		59,
		77,
		80,
		87,
		91,
		107,
		-1,
		-1,
		179,
		183,
		172,
		123,
		142,
		166,
		203,
		152,
		141,
		140,
		-1,
		131,
		110,
		107,
		95,
		82,
		67,
		68,
		76,
		88,
		67,
		61,
		58,
		78,
		104,
		82,
		93,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		149,
		120,
		144,
		186,
		170,
		163,
		151,
		116,
		116,
		110,
		-1,
		106,
		85,
		76,
		65,
		63,
		76,
		68,
		76,
		56,
		54,
		73,
		85,
		76,
		84,
		-1,
		-1,
		-1,
		179,
		168,
		169,
		115,
		138,
		175,
		149,
		135,
		140,
		115,
		108,
		102,
		119,
		102,
		83,
		72,
		64,
		53,
		64,
		72,
		70,
		52,
		61,
		67,
		91,
		72,
		78,
		-1,
		-1,
		186,
		176,
		160,
		162,
		159,
		129,
		136,
		168,
		140,
		153,
		-1,
		107,
		-1,
		96,
		92,
		77,
		72,
		69,
		56,
		55,
		69,
		69,
		59,
		54,
		61,
		96,
		96,
		62,
		82,
		85,
		-1,
		-1,
		-1,
		179,
		174,
		149,
		126,
		110,
		146,
		-1,
		123,
		124,
		-1,
		101,
		95,
		92,
		79,
		75,
		60,
		64,
		66,
		69,
		57,
		63,
		64,
		46,
		70,
		-1,
		70,
		64,
		72,
		62,
		50,
		-1,
		-1,
		-1,
		172,
		151,
		144,
		164,
		105,
		157,
		-1,
		-1,
		108,
		101,
		-1,
		88,
		70,
		72,
		67,
		66,
		65,
		62,
		51,
		64,
		57,
		51,
		45,
		58,
		62,
		63,
		52,
		48,
		45,
		59,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		125,
		-1,
		117,
		109,
		99,
		93,
		87,
		83,
		81,
		94,
		78,
		77,
		74,
		65,
		73,
		46,
		39,
		50,
		35,
		53,
		59,
		50,
		45,
		44,
		55,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		138,
		-1,
		102,
		116,
		132,
		-1,
		125,
		104,
		119,
		97,
		93,
		84,
		101,
		102,
		80,
		74,
		72,
		63,
		51,
		40,
		43,
		35,
		57,
		54,
		38,
		40,
		49,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		99,
		87,
		119,
		-1,
		-1,
		161,
		-1,
		95,
		112,
		98,
		96,
		91,
		82,
		88,
		83,
		60,
		55,
		45,
		34,
		34,
		29,
		48,
		34,
		32,
		47,
		63,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		136,
		-1,
		139,
		129,
		113,
		98,
		131,
		-1,
		86,
		82,
		88,
		-1,
		80,
		-1,
		53,
		50,
		41,
		26,
		23,
		34,
		32,
		41,
		42,
		-1,
		148,
		133,
		126,
		116,
		130,
		101,
		-1,
		156,
		-1,
		-1,
		126,
		120,
		120,
		104,
		107,
		102,
		82,
		74,
		88,
		75,
		67,
		61,
		39,
		32,
		29,
		19,
		32,
		42,
		48,
		40,
		-1,
		-1,
		-1,
		153,
		139,
		143,
		103,
		122,
		-1,
		-1,
		188,
		143,
		129,
		-1,
		111,
		102,
		90,
		80,
		70,
		75,
		76,
		58,
		51,
		37,
		39,
		28,
		21,
		20,
		41,
		34,
		56,
		-1,
		-1,
		136,
		141,
		129,
		115,
		134,
		-1,
		-1,
		-1,
		135,
		151,
		130,
		109,
		91,
		-1,
		-1,
		74,
		67,
		61,
		54,
		41,
		50,
		45,
		27,
		14,
		29,
		39,
		47,
		46,
		-1,
		139,
		126,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		-1,
		-1,
		142,
		87,
		76,
		71,
		75,
		73,
		-1,
		47,
		58,
		45,
		52,
		59,
		29,
		14,
		8,
		19,
		34,
		51,
		-1,
		-1,
		151,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		99,
		93,
		64,
		57,
		61,
		-1,
		49,
		51,
		47,
		58,
		32,
		29,
		20,
		2,
		16,
		19,
		32,
		46,
		50,
		174,
		-1,
		136,
		-1,
		-1,
		-1,
		117,
		132,
		103,
		80,
		53,
		48,
		41,
		35,
		40,
		51,
		40,
		51,
		4,
		0,
		15,
		25,
		24,
		41,
		51,
		-1,
		-1,
		134,
		130,
		143,
		125,
		129,
		130,
		-1,
		-1,
		57,
		48,
		39,
		31,
		44,
		47,
		10,
		7,
		12,
		31,
		19,
		34,
		49,
		56,
		-1,
		-1,
		-1,
		146,
		-1,
		148,
		-1,
		-1,
		136,
		128,
		75,
		57,
		53,
		51,
		40,
		34,
		22,
		15,
		25,
		35,
		29,
		21,
		43,
		59,
		55,
		88,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		125,
		117,
		112,
		118,
		120,
		111,
		90,
		87,
		-1,
		57,
		63,
		28,
		35,
		27,
		33,
		33,
		33,
		26,
		40,
		56,
		55,
		50,
		80,
		75,
		83,
		-1,
		-1,
		211,
		200,
		189,
		195,
		-1,
		118,
		114,
		104,
		94,
		97,
		-1,
		-1,
		91,
		88,
		60,
		37,
		43,
		36,
		31,
		62,
		42,
		29,
		33,
		37,
		43,
		48,
		53,
		59,
		74,
		89,
		-1,
		165,
		202,
		195,
		163,
		171,
		202,
		-1,
		108,
		100,
		111,
		86,
		88,
		-1,
		-1,
		64,
		55,
		56,
		44,
		41,
		54,
		53,
		58,
		43,
		49,
		36,
		35,
		53,
		57,
		66,
		73,
		63,
		76,
		80,
		-1,
		158,
		178,
		157,
		160,
		184,
		198,
		-1,
		105,
		-1,
		-1,
		117,
		89,
		73,
		63,
		60,
		103,
		58,
		53,
		55,
		57,
		55,
		46,
		53,
		44,
		44,
		47,
		62,
		67,
		59,
		73,
		73,
		74,
		-1,
		147,
		158,
		151,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		133,
		-1,
		100,
		-1,
		83,
		87,
		66,
		69,
		80,
		67,
		59,
		51,
		67,
		42,
		52,
		48,
		49,
		58,
		69,
		81,
		80,
		81,
		172,
		128,
		131,
		142,
		153,
		168,
		172,
		-1,
		117,
		156,
		171,
		-1,
		142,
		-1,
		-1,
		-1,
		97,
		79,
		71,
		87,
		79,
		79,
		53,
		57,
		47,
		54,
		64,
		66,
		58,
		62,
		75,
		86,
		89,
		168,
		159,
		172,
		117,
		117,
		138,
		147,
		168,
		132,
		123,
		150,
		171,
		167,
		162,
		149,
		-1,
		-1,
		120,
		89,
		-1,
		-1,
		86,
		74,
		57,
		58,
		54,
		57,
		72,
		75,
		65,
		63,
		57,
		89,
		-1,
		161,
		160,
		149,
		146,
		122,
		113,
		108,
		135,
		-1,
		-1,
		130,
		151,
		141,
		145,
		161,
		186,
		-1,
		146,
		-1,
		-1,
		131,
		-1,
		-1,
		116,
		79,
		68,
		59,
		65,
		62,
		73,
		83,
		71,
		72,
		62,
		72,
		85,
		145,
		142,
		130,
		128,
		151,
		116,
		104,
		-1,
		117,
		115,
		121,
		128,
		145,
		175,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		114,
		112,
		101,
		-1,
		91,
		64,
		69,
		89,
		91,
		80,
		74,
		68,
		75,
		74,
		82,
		90,
		154,
		168,
		157,
		153,
		152,
		160,
		109,
		102,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		109,
		102,
		90,
		78,
		68,
		78,
		82,
		86,
		78,
		71,
		66,
		77,
		69,
		73,
		90,
		-1,
		188,
		-1,
		140,
		116,
		130,
		145,
		153,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		143,
		127,
		108,
		-1,
		78,
		91,
		122,
		90,
		95,
		90,
		72,
		83,
		72,
		75,
		89,
		84,
		-1,
		-1,
		128,
		131,
		-1,
		-1,
		153,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		115,
		111,
		-1,
		-1,
		79,
		104,
		93,
		101,
		96,
		76,
		82,
		85,
		74,
		78,
		90,
		-1,
		-1,
		135,
		136,
		141,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		117,
		80,
		101,
		111,
		105,
		103,
		94,
		80,
		87,
		85,
		81,
		92,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		81,
		107,
		110,
		116,
		110,
		83,
		98,
		88,
		79,
		88,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		111,
		101,
		132,
		117,
		98,
		85,
		92,
		92,
		85,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		91,
		82,
		90,
		122,
		118,
		105,
		105,
		97,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		94,
		92,
		89,
		101,
		97,
		117,
		98,
		133,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		120,
		104,
		102,
		105,
		106,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		113,
		109,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		180,
		169,
		180,
		188,
		161,
		168,
		-1,
		187,
		191,
		157,
		151,
		190,
		159,
		165,
		176,
		-1,
		-1,
		-1,
		180,
		179,
		147,
		145,
		154,
		159,
		166,
		-1,
		165,
		-1,
		201,
		180,
		191,
		196,
		140,
		137,
		157,
		176,
		158,
		150,
		216,
		170,
		141,
		135,
		153,
		143,
		152,
		144,
		-1,
		141,
		131,
		153,
		132,
		143,
		135,
		-1,
		-1,
		135,
		136,
		142,
		128,
		134,
		130,
		-1,
		140,
		124,
		-1,
		-1,
		125,
		126,
		110,
		113,
		121,
		119,
		132,
		124,
		119,
		-1,
		-1,
		116,
		112,
		119,
		106,
		102,
		119,
		132,
		114,
		128,
		127,
		-1,
		122,
		140,
		145,
		113,
		111,
		95,
		93,
		111,
		113,
		119,
		119,
		-1,
		131,
		132,
		127,
		135,
		135,
		111,
		98,
		98,
		108,
		101,
		120,
		108,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		114,
		131,
		123,
		113,
		128,
		121,
		101,
		98,
		96,
		93,
		109,
		107,
		117,
		-1,
		-1,
		222,
		191,
		222,
		180,
		161,
		-1,
		127,
		107,
		113,
		117,
		111,
		104,
		118,
		114,
		-1,
		87,
		86,
		114,
		100,
		111,
		182,
		-1,
		-1,
		180,
		172,
		157,
		160,
		137,
		133,
		122,
		121,
		113,
		99,
		95,
		101,
		104,
		104,
		110,
		81,
		91,
		95,
		93,
		118,
		-1,
		-1,
		153,
		-1,
		-1,
		179,
		162,
		-1,
		145,
		152,
		143,
		149,
		135,
		156,
		132,
		123,
		115,
		109,
		97,
		99,
		96,
		109,
		97,
		78,
		103,
		107,
		88,
		109,
		104,
		-1,
		152,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		138,
		141,
		147,
		171,
		172,
		-1,
		144,
		132,
		133,
		118,
		115,
		102,
		90,
		103,
		88,
		95,
		94,
		82,
		80,
		110,
		85,
		107,
		104,
		123,
		128,
		122,
		131,
		-1,
		187,
		183,
		179,
		186,
		135,
		-1,
		-1,
		175,
		-1,
		180,
		181,
		156,
		129,
		132,
		119,
		110,
		97,
		86,
		97,
		86,
		83,
		91,
		74,
		89,
		80,
		79,
		97,
		107,
		115,
		119,
		125,
		-1,
		237,
		-1,
		179,
		163,
		165,
		137,
		158,
		-1,
		195,
		181,
		173,
		158,
		156,
		-1,
		128,
		125,
		115,
		93,
		78,
		95,
		87,
		85,
		87,
		69,
		83,
		74,
		92,
		99,
		97,
		101,
		121,
		133,
		197,
		187,
		-1,
		169,
		174,
		133,
		141,
		160,
		198,
		162,
		-1,
		157,
		-1,
		130,
		143,
		-1,
		99,
		95,
		77,
		78,
		73,
		88,
		80,
		65,
		62,
		80,
		83,
		90,
		94,
		110,
		-1,
		-1,
		182,
		186,
		175,
		126,
		145,
		169,
		206,
		155,
		144,
		143,
		-1,
		134,
		113,
		110,
		98,
		85,
		70,
		71,
		79,
		91,
		70,
		64,
		61,
		81,
		107,
		85,
		96,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		152,
		123,
		147,
		189,
		173,
		166,
		154,
		119,
		119,
		113,
		-1,
		109,
		88,
		79,
		68,
		66,
		79,
		71,
		79,
		59,
		57,
		76,
		88,
		79,
		87,
		-1,
		-1,
		-1,
		182,
		171,
		172,
		118,
		141,
		178,
		152,
		138,
		143,
		118,
		111,
		105,
		122,
		105,
		86,
		75,
		67,
		56,
		67,
		75,
		73,
		55,
		64,
		70,
		94,
		75,
		81,
		-1,
		-1,
		189,
		179,
		163,
		165,
		162,
		132,
		139,
		171,
		143,
		156,
		-1,
		110,
		-1,
		99,
		95,
		80,
		75,
		72,
		59,
		58,
		72,
		72,
		62,
		57,
		64,
		99,
		99,
		65,
		85,
		88,
		-1,
		-1,
		-1,
		182,
		177,
		152,
		129,
		113,
		149,
		-1,
		126,
		127,
		-1,
		104,
		98,
		95,
		82,
		78,
		63,
		67,
		69,
		72,
		60,
		66,
		67,
		49,
		73,
		-1,
		73,
		67,
		75,
		65,
		53,
		-1,
		-1,
		-1,
		175,
		154,
		147,
		167,
		108,
		160,
		-1,
		-1,
		111,
		104,
		-1,
		91,
		73,
		75,
		70,
		69,
		68,
		65,
		54,
		67,
		60,
		54,
		48,
		61,
		65,
		66,
		55,
		51,
		48,
		62,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		128,
		-1,
		120,
		112,
		102,
		96,
		90,
		86,
		84,
		97,
		81,
		80,
		77,
		68,
		76,
		49,
		42,
		53,
		38,
		56,
		62,
		53,
		48,
		47,
		58,
		-1,
		195,
		181,
		152,
		-1,
		-1,
		141,
		-1,
		105,
		119,
		135,
		-1,
		128,
		107,
		122,
		100,
		96,
		87,
		104,
		105,
		83,
		77,
		75,
		66,
		54,
		43,
		46,
		38,
		60,
		57,
		41,
		43,
		44,
		-1,
		201,
		188,
		146,
		142,
		131,
		151,
		102,
		90,
		122,
		-1,
		-1,
		164,
		-1,
		98,
		115,
		101,
		99,
		94,
		85,
		91,
		86,
		63,
		58,
		48,
		37,
		37,
		32,
		51,
		37,
		35,
		42,
		58,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		117,
		104,
		98,
		-1,
		139,
		-1,
		142,
		132,
		116,
		101,
		134,
		-1,
		100,
		86,
		91,
		-1,
		83,
		-1,
		56,
		53,
		44,
		29,
		26,
		37,
		35,
		44,
		37,
		-1,
		151,
		136,
		129,
		119,
		133,
		104,
		-1,
		159,
		-1,
		-1,
		129,
		123,
		123,
		107,
		110,
		116,
		96,
		88,
		91,
		78,
		70,
		64,
		42,
		35,
		32,
		22,
		35,
		45,
		51,
		35,
		-1,
		-1,
		-1,
		156,
		142,
		146,
		106,
		125,
		-1,
		-1,
		191,
		146,
		132,
		-1,
		116,
		116,
		104,
		94,
		84,
		89,
		86,
		61,
		54,
		40,
		42,
		31,
		24,
		23,
		37,
		29,
		51,
		-1,
		-1,
		139,
		144,
		132,
		118,
		137,
		-1,
		-1,
		-1,
		138,
		154,
		144,
		117,
		105,
		-1,
		-1,
		88,
		81,
		75,
		57,
		44,
		53,
		48,
		30,
		17,
		32,
		34,
		42,
		40,
		-1,
		142,
		129,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		-1,
		-1,
		156,
		101,
		90,
		85,
		89,
		87,
		-1,
		61,
		68,
		48,
		55,
		62,
		32,
		17,
		11,
		17,
		29,
		45,
		-1,
		-1,
		154,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		113,
		107,
		78,
		71,
		75,
		-1,
		63,
		64,
		50,
		61,
		35,
		32,
		23,
		11,
		3,
		14,
		25,
		39,
		43,
		177,
		-1,
		150,
		-1,
		-1,
		-1,
		131,
		146,
		117,
		94,
		67,
		62,
		55,
		49,
		54,
		57,
		43,
		54,
		18,
		14,
		0,
		13,
		17,
		34,
		44,
		-1,
		-1,
		148,
		144,
		157,
		139,
		143,
		144,
		-1,
		-1,
		71,
		62,
		53,
		45,
		58,
		61,
		24,
		21,
		23,
		16,
		4,
		19,
		34,
		48,
		-1,
		-1,
		-1,
		160,
		-1,
		162,
		-1,
		-1,
		150,
		142,
		89,
		71,
		67,
		65,
		54,
		48,
		36,
		29,
		39,
		34,
		26,
		6,
		28,
		44,
		40,
		79,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		139,
		131,
		126,
		132,
		134,
		125,
		104,
		101,
		-1,
		71,
		77,
		42,
		49,
		41,
		41,
		38,
		30,
		11,
		25,
		41,
		40,
		35,
		71,
		62,
		68,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		132,
		128,
		118,
		108,
		111,
		-1,
		-1,
		105,
		102,
		74,
		51,
		51,
		44,
		39,
		49,
		29,
		16,
		18,
		22,
		28,
		33,
		38,
		44,
		59,
		74,
		-1,
		179,
		216,
		209,
		177,
		185,
		216,
		-1,
		122,
		114,
		125,
		100,
		102,
		-1,
		-1,
		78,
		69,
		70,
		58,
		55,
		59,
		54,
		45,
		30,
		36,
		23,
		20,
		38,
		42,
		51,
		58,
		48,
		61,
		65,
		-1,
		172,
		192,
		171,
		174,
		198,
		212,
		-1,
		119,
		-1,
		-1,
		131,
		103,
		87,
		77,
		74,
		117,
		72,
		67,
		53,
		51,
		42,
		33,
		40,
		31,
		29,
		32,
		49,
		54,
		46,
		58,
		58,
		59,
		-1,
		161,
		172,
		165,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		147,
		-1,
		114,
		-1,
		97,
		101,
		80,
		83,
		67,
		54,
		46,
		38,
		54,
		29,
		37,
		33,
		36,
		45,
		56,
		68,
		65,
		66,
		186,
		142,
		145,
		156,
		167,
		182,
		186,
		-1,
		131,
		170,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		111,
		93,
		85,
		87,
		66,
		66,
		40,
		44,
		34,
		41,
		49,
		51,
		45,
		49,
		62,
		73,
		74,
		182,
		173,
		186,
		131,
		131,
		152,
		161,
		182,
		146,
		137,
		164,
		173,
		162,
		157,
		144,
		-1,
		-1,
		134,
		103,
		-1,
		-1,
		73,
		61,
		44,
		45,
		41,
		44,
		59,
		60,
		52,
		50,
		44,
		76,
		-1,
		175,
		174,
		163,
		160,
		136,
		127,
		122,
		149,
		-1,
		-1,
		144,
		165,
		155,
		159,
		175,
		200,
		-1,
		133,
		-1,
		-1,
		118,
		-1,
		-1,
		103,
		66,
		55,
		46,
		52,
		49,
		60,
		70,
		58,
		59,
		49,
		59,
		72,
		159,
		156,
		144,
		142,
		165,
		130,
		118,
		-1,
		131,
		129,
		135,
		142,
		159,
		189,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		101,
		99,
		88,
		-1,
		78,
		51,
		56,
		76,
		78,
		67,
		61,
		55,
		62,
		61,
		69,
		77,
		168,
		182,
		171,
		167,
		166,
		174,
		123,
		116,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		96,
		89,
		77,
		65,
		55,
		65,
		69,
		73,
		65,
		58,
		53,
		64,
		56,
		60,
		77,
		-1,
		202,
		-1,
		154,
		130,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		130,
		114,
		95,
		-1,
		65,
		78,
		109,
		77,
		82,
		77,
		59,
		70,
		59,
		62,
		76,
		71,
		-1,
		-1,
		142,
		145,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		102,
		98,
		-1,
		-1,
		66,
		91,
		80,
		88,
		83,
		63,
		69,
		72,
		61,
		65,
		77,
		-1,
		-1,
		149,
		150,
		153,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		104,
		67,
		88,
		98,
		92,
		90,
		81,
		67,
		74,
		72,
		68,
		79,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		91,
		-1,
		66,
		68,
		94,
		97,
		103,
		97,
		70,
		85,
		75,
		66,
		75,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		88,
		70,
		-1,
		98,
		88,
		119,
		104,
		85,
		72,
		79,
		79,
		72,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		78,
		78,
		69,
		77,
		109,
		105,
		92,
		92,
		84,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		73,
		81,
		79,
		76,
		88,
		84,
		104,
		85,
		120,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		107,
		91,
		89,
		92,
		93,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		100,
		96,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		190,
		194,
		160,
		154,
		193,
		162,
		168,
		179,
		-1,
		-1,
		-1,
		183,
		182,
		150,
		148,
		157,
		162,
		169,
		-1,
		168,
		-1,
		204,
		183,
		194,
		199,
		143,
		140,
		160,
		179,
		161,
		153,
		219,
		173,
		144,
		138,
		156,
		146,
		155,
		147,
		-1,
		144,
		134,
		156,
		135,
		146,
		138,
		-1,
		-1,
		138,
		139,
		145,
		131,
		137,
		133,
		-1,
		143,
		127,
		-1,
		-1,
		128,
		129,
		113,
		116,
		124,
		122,
		135,
		127,
		122,
		-1,
		-1,
		119,
		115,
		122,
		109,
		105,
		122,
		135,
		117,
		131,
		130,
		-1,
		125,
		143,
		148,
		116,
		114,
		98,
		96,
		114,
		116,
		122,
		122,
		-1,
		134,
		135,
		130,
		138,
		138,
		114,
		101,
		101,
		111,
		104,
		123,
		111,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		117,
		134,
		126,
		116,
		131,
		124,
		104,
		101,
		99,
		96,
		112,
		110,
		120,
		-1,
		-1,
		225,
		194,
		225,
		183,
		164,
		-1,
		130,
		110,
		116,
		120,
		114,
		107,
		121,
		117,
		-1,
		90,
		89,
		117,
		103,
		114,
		185,
		-1,
		-1,
		183,
		175,
		160,
		163,
		140,
		136,
		125,
		124,
		116,
		102,
		98,
		104,
		107,
		107,
		113,
		84,
		94,
		98,
		96,
		121,
		-1,
		-1,
		154,
		-1,
		-1,
		182,
		165,
		-1,
		148,
		155,
		146,
		152,
		138,
		159,
		135,
		126,
		118,
		112,
		100,
		102,
		99,
		112,
		100,
		81,
		106,
		110,
		91,
		112,
		107,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		141,
		144,
		150,
		174,
		175,
		-1,
		147,
		135,
		136,
		121,
		118,
		105,
		93,
		106,
		91,
		98,
		97,
		85,
		83,
		113,
		88,
		110,
		107,
		124,
		129,
		123,
		132,
		-1,
		190,
		186,
		182,
		189,
		138,
		-1,
		-1,
		178,
		-1,
		183,
		184,
		159,
		132,
		135,
		122,
		113,
		100,
		89,
		100,
		89,
		86,
		94,
		77,
		92,
		83,
		82,
		100,
		108,
		116,
		120,
		126,
		-1,
		240,
		-1,
		182,
		166,
		168,
		140,
		161,
		-1,
		198,
		184,
		176,
		161,
		159,
		-1,
		131,
		128,
		118,
		96,
		81,
		98,
		90,
		88,
		90,
		72,
		86,
		77,
		95,
		102,
		98,
		102,
		122,
		134,
		200,
		190,
		-1,
		172,
		177,
		136,
		144,
		163,
		201,
		165,
		-1,
		160,
		-1,
		133,
		146,
		-1,
		102,
		98,
		80,
		81,
		76,
		91,
		83,
		68,
		65,
		83,
		86,
		91,
		95,
		111,
		-1,
		-1,
		185,
		189,
		178,
		129,
		148,
		172,
		209,
		158,
		147,
		146,
		-1,
		137,
		116,
		113,
		101,
		88,
		73,
		74,
		82,
		94,
		73,
		67,
		64,
		84,
		108,
		86,
		97,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		155,
		126,
		150,
		192,
		176,
		169,
		157,
		122,
		122,
		116,
		-1,
		112,
		91,
		82,
		71,
		69,
		82,
		74,
		82,
		62,
		60,
		79,
		89,
		80,
		88,
		-1,
		-1,
		-1,
		185,
		174,
		175,
		121,
		144,
		181,
		155,
		141,
		146,
		121,
		114,
		108,
		125,
		108,
		89,
		78,
		70,
		59,
		70,
		78,
		76,
		58,
		67,
		73,
		95,
		76,
		82,
		-1,
		-1,
		192,
		182,
		166,
		168,
		165,
		135,
		142,
		174,
		146,
		159,
		-1,
		113,
		-1,
		102,
		98,
		83,
		78,
		75,
		62,
		61,
		75,
		75,
		65,
		60,
		67,
		100,
		100,
		66,
		85,
		88,
		-1,
		-1,
		-1,
		185,
		180,
		155,
		132,
		116,
		152,
		-1,
		129,
		130,
		-1,
		107,
		101,
		98,
		85,
		81,
		66,
		70,
		72,
		75,
		63,
		69,
		70,
		52,
		76,
		-1,
		74,
		68,
		75,
		65,
		54,
		-1,
		-1,
		-1,
		178,
		157,
		150,
		170,
		111,
		163,
		-1,
		-1,
		114,
		107,
		-1,
		94,
		76,
		78,
		73,
		72,
		71,
		68,
		57,
		70,
		63,
		57,
		51,
		64,
		68,
		69,
		56,
		52,
		49,
		63,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		131,
		-1,
		123,
		115,
		105,
		99,
		93,
		89,
		87,
		100,
		84,
		83,
		80,
		71,
		79,
		52,
		45,
		56,
		41,
		59,
		65,
		56,
		50,
		42,
		59,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		144,
		-1,
		108,
		122,
		138,
		-1,
		131,
		110,
		125,
		103,
		99,
		90,
		107,
		108,
		86,
		80,
		78,
		69,
		57,
		46,
		49,
		41,
		63,
		60,
		44,
		45,
		38,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		93,
		125,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		104,
		102,
		97,
		88,
		94,
		89,
		66,
		61,
		51,
		40,
		40,
		35,
		54,
		40,
		38,
		36,
		52,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		105,
		89,
		94,
		-1,
		86,
		-1,
		59,
		56,
		47,
		32,
		29,
		40,
		38,
		47,
		31,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		162,
		-1,
		-1,
		132,
		126,
		126,
		110,
		113,
		121,
		101,
		95,
		94,
		81,
		73,
		67,
		45,
		38,
		35,
		25,
		38,
		48,
		45,
		29,
		-1,
		-1,
		-1,
		159,
		145,
		149,
		109,
		128,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		119,
		127,
		115,
		105,
		95,
		99,
		89,
		64,
		57,
		43,
		45,
		37,
		27,
		26,
		31,
		23,
		45,
		-1,
		-1,
		142,
		147,
		135,
		121,
		140,
		-1,
		-1,
		-1,
		141,
		157,
		149,
		120,
		116,
		-1,
		-1,
		99,
		91,
		81,
		60,
		47,
		56,
		51,
		36,
		20,
		35,
		28,
		36,
		27,
		-1,
		145,
		132,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		-1,
		-1,
		167,
		112,
		101,
		96,
		100,
		98,
		-1,
		72,
		71,
		51,
		63,
		70,
		38,
		25,
		19,
		11,
		23,
		32,
		-1,
		-1,
		157,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		124,
		118,
		89,
		82,
		86,
		-1,
		74,
		67,
		53,
		69,
		43,
		40,
		31,
		22,
		16,
		8,
		12,
		26,
		30,
		180,
		-1,
		152,
		-1,
		-1,
		-1,
		142,
		157,
		128,
		105,
		78,
		73,
		66,
		60,
		61,
		65,
		51,
		62,
		29,
		25,
		13,
		0,
		4,
		21,
		31,
		-1,
		-1,
		150,
		146,
		168,
		150,
		154,
		155,
		-1,
		-1,
		82,
		73,
		64,
		56,
		69,
		69,
		35,
		32,
		24,
		17,
		10,
		9,
		27,
		36,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		152,
		153,
		100,
		82,
		78,
		76,
		65,
		59,
		47,
		40,
		45,
		35,
		27,
		7,
		25,
		37,
		41,
		68,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		141,
		133,
		128,
		134,
		136,
		127,
		115,
		112,
		-1,
		82,
		88,
		53,
		60,
		43,
		42,
		39,
		31,
		12,
		26,
		42,
		41,
		36,
		60,
		55,
		64,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		134,
		130,
		120,
		110,
		113,
		-1,
		-1,
		107,
		104,
		84,
		53,
		51,
		44,
		39,
		49,
		29,
		16,
		19,
		23,
		29,
		34,
		39,
		45,
		60,
		70,
		-1,
		181,
		218,
		211,
		179,
		187,
		218,
		-1,
		124,
		116,
		127,
		102,
		104,
		-1,
		-1,
		80,
		71,
		72,
		60,
		57,
		59,
		54,
		45,
		30,
		36,
		23,
		21,
		39,
		43,
		52,
		59,
		49,
		62,
		66,
		-1,
		174,
		194,
		173,
		176,
		200,
		214,
		-1,
		121,
		-1,
		-1,
		133,
		105,
		89,
		79,
		76,
		119,
		74,
		69,
		53,
		51,
		42,
		33,
		40,
		31,
		30,
		33,
		49,
		54,
		46,
		59,
		59,
		60,
		-1,
		163,
		174,
		167,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		116,
		-1,
		99,
		103,
		82,
		85,
		67,
		54,
		46,
		38,
		54,
		29,
		38,
		34,
		36,
		45,
		56,
		68,
		66,
		67,
		188,
		144,
		147,
		158,
		169,
		184,
		188,
		-1,
		133,
		172,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		113,
		95,
		87,
		87,
		66,
		66,
		40,
		44,
		34,
		41,
		50,
		52,
		45,
		49,
		62,
		73,
		75,
		184,
		175,
		188,
		133,
		133,
		154,
		163,
		184,
		148,
		139,
		166,
		173,
		162,
		157,
		144,
		-1,
		-1,
		136,
		105,
		-1,
		-1,
		73,
		61,
		44,
		45,
		41,
		44,
		59,
		61,
		52,
		50,
		44,
		76,
		-1,
		177,
		176,
		165,
		162,
		138,
		129,
		124,
		151,
		-1,
		-1,
		146,
		167,
		157,
		161,
		177,
		202,
		-1,
		133,
		-1,
		-1,
		118,
		-1,
		-1,
		103,
		66,
		55,
		46,
		52,
		49,
		60,
		70,
		58,
		59,
		49,
		59,
		72,
		161,
		158,
		146,
		144,
		167,
		132,
		120,
		-1,
		133,
		131,
		137,
		144,
		161,
		191,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		101,
		99,
		88,
		-1,
		78,
		51,
		56,
		76,
		78,
		67,
		61,
		55,
		62,
		61,
		69,
		77,
		170,
		184,
		173,
		169,
		168,
		176,
		125,
		118,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		96,
		89,
		77,
		65,
		55,
		65,
		69,
		73,
		65,
		58,
		53,
		64,
		56,
		60,
		77,
		-1,
		204,
		-1,
		156,
		132,
		146,
		161,
		169,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		130,
		114,
		95,
		-1,
		65,
		78,
		109,
		77,
		82,
		77,
		59,
		70,
		59,
		62,
		76,
		71,
		-1,
		-1,
		144,
		147,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		102,
		98,
		-1,
		-1,
		66,
		91,
		80,
		88,
		83,
		63,
		69,
		72,
		61,
		65,
		77,
		-1,
		-1,
		151,
		152,
		153,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		104,
		67,
		88,
		98,
		92,
		90,
		81,
		67,
		74,
		72,
		68,
		79,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		91,
		-1,
		66,
		68,
		94,
		97,
		103,
		97,
		70,
		85,
		75,
		66,
		75,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		88,
		70,
		-1,
		98,
		88,
		119,
		104,
		85,
		72,
		79,
		79,
		72,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		78,
		78,
		69,
		77,
		109,
		105,
		92,
		92,
		84,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		73,
		81,
		79,
		76,
		88,
		84,
		104,
		85,
		120,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		107,
		91,
		89,
		92,
		93,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		100,
		96,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		179,
		168,
		179,
		187,
		160,
		167,
		-1,
		186,
		190,
		156,
		150,
		189,
		158,
		164,
		175,
		-1,
		-1,
		-1,
		179,
		178,
		146,
		144,
		153,
		158,
		165,
		-1,
		164,
		-1,
		200,
		179,
		190,
		195,
		139,
		136,
		156,
		175,
		157,
		149,
		215,
		169,
		140,
		134,
		152,
		142,
		151,
		143,
		-1,
		140,
		130,
		152,
		131,
		142,
		134,
		-1,
		-1,
		134,
		135,
		141,
		127,
		133,
		129,
		-1,
		139,
		123,
		-1,
		-1,
		124,
		125,
		109,
		112,
		120,
		118,
		131,
		123,
		118,
		-1,
		-1,
		115,
		111,
		118,
		105,
		101,
		118,
		131,
		113,
		127,
		126,
		-1,
		121,
		139,
		144,
		112,
		110,
		94,
		92,
		110,
		112,
		118,
		118,
		-1,
		130,
		131,
		126,
		134,
		134,
		110,
		97,
		97,
		107,
		100,
		119,
		107,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		113,
		130,
		122,
		112,
		127,
		120,
		100,
		97,
		95,
		92,
		108,
		106,
		116,
		-1,
		-1,
		221,
		190,
		221,
		179,
		160,
		-1,
		126,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		86,
		85,
		113,
		99,
		110,
		181,
		-1,
		-1,
		179,
		171,
		156,
		159,
		136,
		132,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		80,
		90,
		94,
		92,
		117,
		-1,
		-1,
		150,
		-1,
		-1,
		178,
		161,
		-1,
		144,
		151,
		142,
		148,
		134,
		155,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		77,
		102,
		106,
		87,
		108,
		103,
		-1,
		149,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		137,
		140,
		146,
		170,
		171,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		81,
		79,
		109,
		84,
		106,
		103,
		120,
		125,
		119,
		128,
		-1,
		186,
		182,
		178,
		185,
		134,
		-1,
		-1,
		174,
		-1,
		179,
		180,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		73,
		88,
		79,
		78,
		96,
		104,
		112,
		116,
		122,
		-1,
		236,
		-1,
		178,
		162,
		164,
		136,
		157,
		-1,
		194,
		180,
		172,
		157,
		155,
		-1,
		127,
		124,
		114,
		92,
		77,
		94,
		86,
		84,
		86,
		68,
		82,
		73,
		91,
		98,
		94,
		98,
		118,
		130,
		196,
		186,
		-1,
		168,
		173,
		132,
		140,
		159,
		197,
		161,
		-1,
		156,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		79,
		64,
		61,
		79,
		82,
		87,
		91,
		107,
		-1,
		-1,
		181,
		185,
		174,
		125,
		144,
		168,
		205,
		154,
		143,
		142,
		-1,
		133,
		112,
		109,
		97,
		84,
		69,
		70,
		78,
		90,
		69,
		63,
		60,
		80,
		104,
		82,
		93,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		151,
		122,
		146,
		188,
		172,
		165,
		153,
		118,
		118,
		112,
		-1,
		108,
		87,
		78,
		67,
		65,
		78,
		70,
		78,
		58,
		56,
		75,
		85,
		76,
		84,
		-1,
		-1,
		-1,
		181,
		170,
		171,
		117,
		140,
		177,
		151,
		137,
		142,
		117,
		110,
		104,
		121,
		104,
		85,
		74,
		66,
		55,
		66,
		74,
		72,
		54,
		63,
		69,
		91,
		72,
		78,
		-1,
		-1,
		188,
		178,
		162,
		164,
		161,
		131,
		138,
		170,
		142,
		155,
		-1,
		109,
		-1,
		98,
		94,
		79,
		74,
		71,
		58,
		57,
		71,
		71,
		61,
		56,
		63,
		96,
		96,
		62,
		81,
		84,
		-1,
		-1,
		-1,
		181,
		176,
		151,
		128,
		112,
		148,
		-1,
		125,
		126,
		-1,
		103,
		97,
		94,
		81,
		77,
		62,
		66,
		68,
		71,
		59,
		65,
		66,
		48,
		72,
		-1,
		70,
		64,
		71,
		61,
		50,
		-1,
		-1,
		-1,
		174,
		153,
		146,
		166,
		107,
		159,
		-1,
		-1,
		110,
		103,
		-1,
		90,
		72,
		74,
		69,
		68,
		67,
		64,
		53,
		66,
		59,
		53,
		47,
		60,
		64,
		65,
		52,
		48,
		45,
		59,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		127,
		-1,
		119,
		111,
		101,
		95,
		89,
		85,
		83,
		96,
		80,
		79,
		76,
		67,
		75,
		48,
		41,
		52,
		37,
		55,
		61,
		52,
		46,
		38,
		55,
		-1,
		194,
		180,
		151,
		-1,
		-1,
		140,
		-1,
		104,
		118,
		134,
		-1,
		127,
		106,
		121,
		99,
		95,
		86,
		103,
		104,
		82,
		76,
		74,
		65,
		53,
		42,
		45,
		37,
		59,
		56,
		40,
		41,
		34,
		-1,
		200,
		187,
		145,
		141,
		130,
		150,
		101,
		89,
		121,
		-1,
		-1,
		163,
		-1,
		97,
		114,
		100,
		98,
		93,
		84,
		90,
		85,
		62,
		57,
		47,
		36,
		36,
		31,
		50,
		36,
		34,
		32,
		48,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		116,
		103,
		97,
		-1,
		138,
		-1,
		141,
		131,
		115,
		100,
		133,
		-1,
		101,
		85,
		90,
		-1,
		82,
		-1,
		55,
		52,
		43,
		28,
		25,
		36,
		34,
		43,
		27,
		-1,
		150,
		135,
		128,
		118,
		132,
		103,
		-1,
		158,
		-1,
		-1,
		128,
		122,
		122,
		106,
		109,
		117,
		97,
		91,
		90,
		77,
		69,
		63,
		41,
		34,
		31,
		21,
		34,
		44,
		41,
		25,
		-1,
		-1,
		-1,
		155,
		141,
		145,
		105,
		124,
		-1,
		-1,
		190,
		145,
		131,
		-1,
		115,
		123,
		111,
		101,
		91,
		95,
		85,
		60,
		53,
		39,
		41,
		33,
		23,
		22,
		27,
		19,
		41,
		-1,
		-1,
		138,
		143,
		131,
		117,
		136,
		-1,
		-1,
		-1,
		137,
		153,
		145,
		116,
		112,
		-1,
		-1,
		95,
		87,
		77,
		56,
		43,
		52,
		47,
		32,
		16,
		31,
		24,
		32,
		23,
		-1,
		141,
		128,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		-1,
		-1,
		163,
		108,
		97,
		92,
		96,
		94,
		-1,
		68,
		67,
		47,
		59,
		66,
		34,
		22,
		16,
		7,
		19,
		28,
		-1,
		-1,
		153,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		120,
		114,
		85,
		78,
		82,
		-1,
		70,
		63,
		49,
		65,
		40,
		37,
		28,
		18,
		18,
		4,
		8,
		22,
		26,
		176,
		-1,
		156,
		-1,
		-1,
		-1,
		138,
		153,
		124,
		101,
		74,
		69,
		62,
		56,
		57,
		62,
		48,
		59,
		25,
		21,
		17,
		4,
		0,
		17,
		27,
		-1,
		-1,
		154,
		150,
		164,
		146,
		150,
		151,
		-1,
		-1,
		78,
		69,
		60,
		52,
		65,
		66,
		31,
		28,
		28,
		21,
		14,
		13,
		30,
		32,
		-1,
		-1,
		-1,
		166,
		-1,
		168,
		-1,
		-1,
		156,
		149,
		96,
		78,
		74,
		72,
		61,
		55,
		43,
		36,
		46,
		39,
		31,
		11,
		29,
		40,
		40,
		64,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		145,
		137,
		132,
		138,
		140,
		131,
		111,
		108,
		-1,
		78,
		84,
		49,
		56,
		47,
		46,
		43,
		35,
		16,
		30,
		46,
		45,
		40,
		56,
		51,
		60,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		138,
		134,
		124,
		114,
		117,
		-1,
		-1,
		111,
		108,
		81,
		57,
		55,
		48,
		43,
		53,
		33,
		20,
		23,
		27,
		33,
		38,
		43,
		49,
		58,
		66,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		128,
		120,
		131,
		106,
		108,
		-1,
		-1,
		84,
		75,
		76,
		64,
		61,
		63,
		58,
		49,
		34,
		40,
		27,
		25,
		43,
		47,
		56,
		63,
		53,
		66,
		70,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		125,
		-1,
		-1,
		137,
		109,
		93,
		83,
		80,
		123,
		78,
		73,
		57,
		55,
		46,
		37,
		44,
		35,
		34,
		37,
		53,
		58,
		50,
		63,
		63,
		64,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		153,
		-1,
		120,
		-1,
		103,
		107,
		86,
		89,
		71,
		58,
		50,
		42,
		58,
		33,
		42,
		38,
		40,
		49,
		60,
		72,
		70,
		71,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		137,
		176,
		170,
		-1,
		154,
		-1,
		-1,
		-1,
		117,
		99,
		91,
		91,
		70,
		70,
		44,
		48,
		38,
		45,
		54,
		56,
		49,
		53,
		66,
		77,
		79,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		152,
		143,
		170,
		177,
		166,
		161,
		148,
		-1,
		-1,
		140,
		109,
		-1,
		-1,
		77,
		65,
		48,
		49,
		45,
		48,
		63,
		65,
		56,
		54,
		48,
		80,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		150,
		171,
		161,
		165,
		181,
		206,
		-1,
		137,
		-1,
		-1,
		122,
		-1,
		-1,
		107,
		70,
		59,
		50,
		56,
		53,
		64,
		74,
		62,
		63,
		53,
		63,
		76,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		137,
		135,
		141,
		148,
		165,
		195,
		-1,
		-1,
		153,
		133,
		-1,
		-1,
		105,
		103,
		92,
		-1,
		82,
		55,
		60,
		80,
		82,
		71,
		65,
		59,
		66,
		65,
		73,
		81,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		143,
		139,
		-1,
		-1,
		100,
		93,
		81,
		69,
		59,
		69,
		73,
		77,
		69,
		62,
		57,
		68,
		60,
		64,
		81,
		-1,
		208,
		-1,
		160,
		136,
		150,
		165,
		173,
		-1,
		-1,
		-1,
		160,
		146,
		139,
		127,
		125,
		-1,
		134,
		118,
		99,
		-1,
		69,
		82,
		113,
		81,
		86,
		81,
		63,
		74,
		63,
		66,
		80,
		75,
		-1,
		-1,
		148,
		151,
		-1,
		-1,
		150,
		152,
		-1,
		151,
		140,
		125,
		117,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		70,
		95,
		84,
		92,
		87,
		67,
		73,
		76,
		65,
		69,
		81,
		-1,
		-1,
		155,
		156,
		157,
		-1,
		135,
		-1,
		153,
		-1,
		120,
		126,
		114,
		-1,
		-1,
		-1,
		108,
		71,
		92,
		102,
		96,
		94,
		85,
		71,
		78,
		76,
		72,
		83,
		-1,
		-1,
		-1,
		153,
		127,
		160,
		151,
		134,
		114,
		106,
		125,
		-1,
		95,
		-1,
		70,
		72,
		98,
		101,
		107,
		101,
		74,
		89,
		79,
		70,
		79,
		159,
		-1,
		129,
		162,
		126,
		120,
		96,
		100,
		116,
		-1,
		92,
		74,
		-1,
		102,
		92,
		123,
		108,
		89,
		76,
		83,
		83,
		76,
		-1,
		-1,
		-1,
		131,
		130,
		122,
		116,
		116,
		101,
		92,
		-1,
		104,
		86,
		65,
		82,
		82,
		73,
		81,
		113,
		109,
		96,
		96,
		88,
		-1,
		232,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		125,
		120,
		93,
		81,
		87,
		83,
		69,
		75,
		77,
		85,
		83,
		80,
		92,
		88,
		108,
		89,
		124,
		-1,
		227,
		-1,
		161,
		-1,
		-1,
		143,
		123,
		115,
		104,
		93,
		91,
		82,
		73,
		95,
		111,
		95,
		93,
		96,
		97,
		-1,
		216,
		215,
		-1,
		162,
		154,
		140,
		-1,
		133,
		-1,
		139,
		100,
		-1,
		102,
		82,
		-1,
		104,
		100,
		-1,
		-1,
		203,
		178,
		-1,
		-1,
		-1,
		163,
		143,
		134,
		118,
		-1,
		93,
		93,
		-1,
		-1,
		-1,
		188,
		187,
		-1,
		156,
		159,
		-1,
		149,
		140,
		148,
		95,
		99,
		-1,
		-1,
		-1,
		197,
		178,
		172,
		171,
		169,
		164,
		161,
		147,
		131,
		109,
		98,
		119,
		-1,
		-1,
		-1,
		169,
		161,
		154,
		-1,
		-1,
		156,
		139,
		120,
		118,
		-1,
		-1,
		-1,
		191,
		172,
		-1,
		-1,
		146,
		-1,
		-1,
		152,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		180,
		-1,
		-1,
		-1,
		142,
		138,
		139,
		-1,
		-1,
		-1,
		-1,
		202,
		203,
		226,
		190,
		-1,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		205,
		203,
		-1,
		-1,
		-1,
		162,
		146,
		-1,
		132,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		167,
		-1,
		167,
		142,
		149,
		-1,
		-1,
		-1,
		-1,
		180,
		172,
		180,
		-1,
		152,
		154,
		-1,
		202,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		157,
		164,
		186,
		189,
		225,
		-1,
		176
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		197,
		201,
		167,
		161,
		200,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		190,
		189,
		157,
		155,
		164,
		169,
		176,
		-1,
		175,
		-1,
		211,
		190,
		201,
		206,
		150,
		147,
		167,
		186,
		168,
		160,
		226,
		180,
		151,
		145,
		163,
		153,
		162,
		154,
		-1,
		151,
		141,
		163,
		142,
		153,
		145,
		-1,
		-1,
		145,
		146,
		152,
		138,
		144,
		140,
		-1,
		150,
		134,
		-1,
		-1,
		135,
		136,
		120,
		123,
		131,
		129,
		142,
		134,
		129,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		124,
		138,
		137,
		-1,
		132,
		150,
		155,
		123,
		121,
		105,
		103,
		121,
		123,
		129,
		129,
		-1,
		141,
		142,
		137,
		145,
		145,
		121,
		108,
		108,
		118,
		111,
		130,
		118,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		124,
		141,
		133,
		123,
		138,
		131,
		111,
		108,
		106,
		103,
		119,
		117,
		127,
		-1,
		-1,
		232,
		201,
		232,
		190,
		171,
		-1,
		137,
		117,
		123,
		127,
		121,
		114,
		128,
		124,
		-1,
		97,
		96,
		124,
		110,
		121,
		192,
		-1,
		-1,
		190,
		182,
		167,
		170,
		147,
		143,
		132,
		131,
		123,
		109,
		105,
		111,
		114,
		114,
		120,
		91,
		101,
		105,
		103,
		128,
		-1,
		-1,
		161,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		153,
		159,
		145,
		166,
		142,
		133,
		125,
		119,
		107,
		109,
		106,
		119,
		107,
		88,
		113,
		117,
		98,
		119,
		114,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		182,
		-1,
		154,
		142,
		143,
		128,
		125,
		112,
		100,
		113,
		98,
		105,
		104,
		92,
		90,
		120,
		95,
		117,
		114,
		131,
		136,
		130,
		139,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		190,
		191,
		166,
		139,
		142,
		129,
		120,
		107,
		96,
		107,
		96,
		93,
		101,
		84,
		99,
		90,
		89,
		107,
		115,
		123,
		127,
		133,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		191,
		183,
		168,
		166,
		-1,
		138,
		135,
		125,
		103,
		88,
		105,
		97,
		95,
		97,
		79,
		93,
		84,
		102,
		109,
		105,
		109,
		129,
		141,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		140,
		153,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		90,
		75,
		72,
		90,
		93,
		98,
		102,
		118,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		123,
		120,
		108,
		95,
		80,
		81,
		89,
		101,
		80,
		74,
		71,
		91,
		115,
		93,
		104,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		119,
		98,
		89,
		78,
		76,
		89,
		81,
		89,
		69,
		67,
		86,
		96,
		87,
		95,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		132,
		115,
		96,
		85,
		77,
		66,
		77,
		85,
		83,
		65,
		74,
		80,
		102,
		83,
		89,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		105,
		90,
		85,
		82,
		69,
		68,
		82,
		82,
		72,
		67,
		74,
		107,
		107,
		73,
		92,
		95,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		92,
		88,
		73,
		77,
		79,
		82,
		70,
		76,
		77,
		59,
		83,
		-1,
		81,
		75,
		82,
		72,
		61,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		85,
		80,
		79,
		78,
		75,
		64,
		77,
		70,
		64,
		58,
		71,
		75,
		76,
		63,
		59,
		56,
		64,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		107,
		91,
		90,
		87,
		78,
		86,
		59,
		52,
		63,
		48,
		66,
		72,
		63,
		57,
		49,
		60,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		97,
		114,
		115,
		93,
		87,
		85,
		76,
		64,
		53,
		56,
		48,
		70,
		67,
		51,
		52,
		45,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		111,
		109,
		104,
		95,
		101,
		96,
		73,
		68,
		58,
		47,
		47,
		42,
		61,
		47,
		45,
		43,
		45,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		112,
		96,
		101,
		-1,
		93,
		-1,
		66,
		63,
		54,
		39,
		36,
		47,
		45,
		54,
		38,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		128,
		108,
		102,
		101,
		88,
		80,
		74,
		52,
		45,
		42,
		32,
		45,
		55,
		52,
		36,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		134,
		122,
		112,
		102,
		106,
		96,
		71,
		64,
		50,
		52,
		44,
		34,
		33,
		38,
		30,
		40,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		156,
		127,
		123,
		-1,
		-1,
		106,
		98,
		88,
		67,
		54,
		63,
		58,
		43,
		27,
		42,
		33,
		30,
		22,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		78,
		58,
		70,
		77,
		45,
		33,
		27,
		18,
		28,
		16,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		74,
		60,
		76,
		51,
		48,
		39,
		29,
		29,
		15,
		15,
		5,
		9,
		187,
		-1,
		167,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		68,
		73,
		59,
		70,
		36,
		32,
		28,
		15,
		11,
		0,
		10,
		-1,
		-1,
		165,
		161,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		63,
		76,
		77,
		42,
		39,
		39,
		32,
		25,
		24,
		26,
		15,
		-1,
		-1,
		-1,
		177,
		-1,
		179,
		-1,
		-1,
		167,
		160,
		107,
		89,
		85,
		83,
		72,
		66,
		54,
		47,
		57,
		50,
		42,
		22,
		40,
		36,
		23,
		47,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		122,
		119,
		-1,
		89,
		95,
		60,
		67,
		58,
		57,
		54,
		46,
		27,
		41,
		47,
		35,
		34,
		39,
		34,
		43,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		122,
		119,
		92,
		68,
		66,
		59,
		54,
		64,
		44,
		31,
		34,
		38,
		39,
		32,
		37,
		43,
		41,
		49,
		-1,
		196,
		233,
		226,
		194,
		202,
		233,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		95,
		86,
		87,
		75,
		72,
		74,
		69,
		60,
		45,
		51,
		38,
		36,
		54,
		53,
		50,
		55,
		44,
		57,
		61,
		-1,
		189,
		209,
		188,
		191,
		215,
		229,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		91,
		134,
		89,
		84,
		68,
		66,
		57,
		48,
		55,
		46,
		45,
		48,
		61,
		65,
		57,
		54,
		54,
		55,
		-1,
		178,
		189,
		182,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		164,
		-1,
		131,
		-1,
		114,
		118,
		97,
		100,
		82,
		69,
		61,
		53,
		69,
		44,
		53,
		49,
		51,
		60,
		67,
		75,
		61,
		62,
		203,
		159,
		162,
		173,
		184,
		199,
		203,
		-1,
		148,
		187,
		181,
		-1,
		165,
		-1,
		-1,
		-1,
		128,
		110,
		102,
		102,
		81,
		81,
		55,
		59,
		49,
		56,
		65,
		67,
		60,
		64,
		77,
		71,
		70,
		199,
		190,
		203,
		148,
		148,
		169,
		178,
		199,
		163,
		154,
		181,
		188,
		177,
		172,
		159,
		-1,
		-1,
		151,
		120,
		-1,
		-1,
		88,
		76,
		59,
		60,
		56,
		59,
		74,
		76,
		67,
		65,
		59,
		76,
		-1,
		192,
		191,
		180,
		177,
		153,
		144,
		139,
		166,
		-1,
		-1,
		161,
		182,
		172,
		176,
		192,
		217,
		-1,
		148,
		-1,
		-1,
		133,
		-1,
		-1,
		118,
		81,
		70,
		61,
		67,
		64,
		75,
		85,
		73,
		74,
		64,
		74,
		87,
		176,
		173,
		161,
		159,
		182,
		147,
		135,
		-1,
		148,
		146,
		152,
		159,
		176,
		206,
		-1,
		-1,
		164,
		144,
		-1,
		-1,
		116,
		114,
		103,
		-1,
		93,
		66,
		71,
		91,
		93,
		82,
		76,
		70,
		77,
		76,
		84,
		92,
		185,
		199,
		188,
		184,
		183,
		191,
		140,
		133,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		150,
		-1,
		-1,
		111,
		104,
		92,
		80,
		70,
		80,
		84,
		88,
		80,
		73,
		68,
		79,
		71,
		75,
		92,
		-1,
		219,
		-1,
		171,
		147,
		161,
		176,
		184,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		145,
		129,
		110,
		-1,
		80,
		93,
		124,
		92,
		97,
		92,
		74,
		85,
		74,
		77,
		85,
		86,
		-1,
		-1,
		159,
		162,
		-1,
		-1,
		161,
		163,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		117,
		113,
		-1,
		-1,
		81,
		106,
		95,
		103,
		98,
		78,
		84,
		87,
		76,
		80,
		85,
		-1,
		-1,
		166,
		167,
		168,
		-1,
		146,
		-1,
		164,
		-1,
		131,
		137,
		125,
		-1,
		-1,
		-1,
		119,
		82,
		103,
		113,
		107,
		105,
		96,
		82,
		89,
		87,
		83,
		94,
		-1,
		-1,
		-1,
		164,
		138,
		171,
		162,
		145,
		125,
		117,
		136,
		-1,
		106,
		-1,
		81,
		83,
		109,
		112,
		118,
		112,
		85,
		100,
		90,
		81,
		90,
		170,
		-1,
		140,
		173,
		137,
		131,
		107,
		111,
		127,
		-1,
		103,
		85,
		-1,
		113,
		103,
		134,
		119,
		100,
		87,
		94,
		94,
		87,
		-1,
		-1,
		-1,
		142,
		141,
		133,
		127,
		127,
		112,
		103,
		-1,
		115,
		97,
		76,
		93,
		93,
		84,
		92,
		124,
		120,
		107,
		107,
		99,
		-1,
		243,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		136,
		131,
		104,
		92,
		98,
		94,
		80,
		86,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		100,
		135,
		-1,
		238,
		-1,
		172,
		-1,
		-1,
		154,
		134,
		126,
		115,
		104,
		102,
		93,
		84,
		106,
		122,
		106,
		104,
		107,
		108,
		-1,
		227,
		226,
		-1,
		173,
		165,
		151,
		-1,
		144,
		-1,
		150,
		111,
		-1,
		113,
		93,
		-1,
		115,
		111,
		-1,
		-1,
		214,
		189,
		-1,
		-1,
		-1,
		174,
		154,
		145,
		129,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		199,
		198,
		-1,
		167,
		170,
		-1,
		160,
		151,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		208,
		189,
		183,
		182,
		180,
		175,
		172,
		158,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		180,
		172,
		165,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		191,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		213,
		214,
		237,
		201,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		216,
		214,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		207,
		211,
		177,
		171,
		210,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		200,
		199,
		167,
		165,
		174,
		179,
		186,
		-1,
		185,
		-1,
		221,
		200,
		211,
		216,
		160,
		157,
		177,
		196,
		178,
		170,
		236,
		190,
		161,
		155,
		173,
		163,
		172,
		164,
		-1,
		161,
		151,
		173,
		152,
		163,
		155,
		-1,
		-1,
		155,
		156,
		162,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		145,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		142,
		160,
		165,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		139,
		-1,
		151,
		152,
		147,
		155,
		155,
		131,
		118,
		118,
		128,
		121,
		140,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		121,
		118,
		116,
		113,
		129,
		127,
		137,
		-1,
		-1,
		242,
		211,
		242,
		200,
		181,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		107,
		106,
		134,
		120,
		131,
		202,
		-1,
		-1,
		200,
		192,
		177,
		180,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		101,
		111,
		115,
		113,
		138,
		-1,
		-1,
		166,
		-1,
		-1,
		199,
		182,
		-1,
		165,
		172,
		163,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		98,
		123,
		127,
		108,
		129,
		124,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		158,
		161,
		167,
		191,
		192,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		102,
		100,
		130,
		105,
		127,
		124,
		136,
		141,
		135,
		144,
		-1,
		207,
		203,
		199,
		206,
		155,
		-1,
		-1,
		195,
		-1,
		200,
		201,
		176,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		94,
		109,
		100,
		99,
		117,
		120,
		128,
		132,
		138,
		-1,
		257,
		-1,
		199,
		183,
		185,
		157,
		178,
		-1,
		215,
		201,
		193,
		178,
		176,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		107,
		89,
		103,
		94,
		112,
		119,
		110,
		114,
		134,
		146,
		217,
		207,
		-1,
		189,
		194,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		100,
		85,
		82,
		100,
		103,
		103,
		107,
		123,
		-1,
		-1,
		202,
		206,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		111,
		90,
		84,
		81,
		101,
		120,
		98,
		109,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		129,
		108,
		99,
		88,
		86,
		99,
		91,
		99,
		79,
		77,
		96,
		101,
		92,
		100,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		142,
		125,
		106,
		95,
		87,
		76,
		87,
		95,
		93,
		75,
		84,
		90,
		107,
		88,
		94,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		115,
		100,
		95,
		92,
		79,
		78,
		92,
		92,
		82,
		77,
		84,
		112,
		112,
		78,
		97,
		100,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		102,
		98,
		83,
		87,
		89,
		92,
		80,
		86,
		87,
		69,
		93,
		-1,
		86,
		80,
		87,
		77,
		66,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		95,
		90,
		89,
		88,
		85,
		74,
		87,
		80,
		74,
		68,
		81,
		85,
		85,
		68,
		64,
		61,
		65,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		117,
		101,
		100,
		97,
		88,
		96,
		69,
		62,
		73,
		58,
		76,
		82,
		72,
		62,
		54,
		61,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		107,
		124,
		125,
		103,
		97,
		95,
		86,
		74,
		63,
		66,
		58,
		80,
		76,
		60,
		57,
		50,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		121,
		119,
		114,
		105,
		111,
		106,
		83,
		78,
		68,
		57,
		57,
		52,
		71,
		57,
		55,
		48,
		46,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		122,
		106,
		111,
		-1,
		103,
		-1,
		76,
		73,
		64,
		49,
		46,
		57,
		55,
		64,
		43,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		138,
		118,
		112,
		111,
		98,
		90,
		84,
		62,
		55,
		52,
		42,
		55,
		65,
		57,
		41,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		144,
		132,
		122,
		112,
		116,
		106,
		81,
		74,
		60,
		62,
		54,
		44,
		43,
		48,
		40,
		45,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		174,
		166,
		137,
		133,
		-1,
		-1,
		116,
		108,
		98,
		77,
		64,
		73,
		68,
		53,
		37,
		52,
		43,
		35,
		27,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		184,
		129,
		118,
		113,
		117,
		115,
		-1,
		89,
		88,
		68,
		80,
		87,
		55,
		43,
		37,
		28,
		38,
		21,
		-1,
		-1,
		174,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		141,
		135,
		106,
		99,
		103,
		-1,
		91,
		84,
		70,
		86,
		61,
		58,
		49,
		39,
		39,
		25,
		25,
		6,
		12,
		197,
		-1,
		177,
		-1,
		-1,
		-1,
		159,
		174,
		145,
		122,
		95,
		90,
		83,
		77,
		78,
		83,
		69,
		80,
		46,
		42,
		38,
		25,
		21,
		10,
		0,
		-1,
		-1,
		175,
		171,
		185,
		167,
		171,
		172,
		-1,
		-1,
		99,
		90,
		81,
		73,
		86,
		87,
		52,
		49,
		49,
		42,
		35,
		34,
		21,
		6,
		-1,
		-1,
		-1,
		187,
		-1,
		189,
		-1,
		-1,
		177,
		170,
		117,
		99,
		95,
		93,
		82,
		76,
		64,
		57,
		67,
		60,
		52,
		32,
		50,
		41,
		14,
		48,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		166,
		158,
		153,
		159,
		161,
		152,
		132,
		129,
		-1,
		99,
		105,
		70,
		77,
		68,
		67,
		64,
		56,
		37,
		47,
		38,
		26,
		25,
		40,
		35,
		44,
		-1,
		-1,
		252,
		241,
		230,
		236,
		-1,
		159,
		155,
		145,
		135,
		138,
		-1,
		-1,
		132,
		129,
		102,
		78,
		76,
		69,
		64,
		74,
		54,
		41,
		40,
		44,
		30,
		23,
		28,
		34,
		42,
		50,
		-1,
		206,
		243,
		236,
		204,
		212,
		243,
		-1,
		149,
		141,
		152,
		127,
		129,
		-1,
		-1,
		105,
		96,
		97,
		85,
		82,
		84,
		79,
		70,
		55,
		61,
		48,
		42,
		58,
		44,
		41,
		48,
		45,
		58,
		62,
		-1,
		199,
		219,
		198,
		201,
		225,
		239,
		-1,
		146,
		-1,
		-1,
		158,
		130,
		114,
		104,
		101,
		144,
		99,
		94,
		78,
		76,
		67,
		58,
		65,
		56,
		51,
		54,
		52,
		56,
		50,
		55,
		52,
		56,
		-1,
		188,
		199,
		192,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		174,
		-1,
		141,
		-1,
		124,
		128,
		107,
		110,
		92,
		79,
		71,
		63,
		79,
		54,
		59,
		55,
		59,
		68,
		60,
		73,
		62,
		58,
		213,
		169,
		172,
		183,
		194,
		209,
		213,
		-1,
		158,
		197,
		191,
		-1,
		175,
		-1,
		-1,
		-1,
		138,
		120,
		112,
		112,
		91,
		91,
		65,
		69,
		59,
		64,
		71,
		73,
		68,
		72,
		83,
		72,
		66,
		209,
		200,
		213,
		158,
		158,
		179,
		188,
		209,
		173,
		164,
		191,
		198,
		187,
		182,
		169,
		-1,
		-1,
		161,
		130,
		-1,
		-1,
		98,
		86,
		69,
		70,
		66,
		69,
		84,
		82,
		75,
		73,
		67,
		77,
		-1,
		202,
		201,
		190,
		187,
		163,
		154,
		149,
		176,
		-1,
		-1,
		171,
		192,
		182,
		186,
		202,
		227,
		-1,
		158,
		-1,
		-1,
		143,
		-1,
		-1,
		128,
		91,
		80,
		71,
		77,
		74,
		85,
		95,
		81,
		82,
		72,
		82,
		91,
		186,
		183,
		171,
		169,
		192,
		157,
		145,
		-1,
		158,
		156,
		162,
		169,
		186,
		216,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		126,
		124,
		113,
		-1,
		103,
		76,
		81,
		101,
		101,
		90,
		84,
		78,
		85,
		84,
		92,
		96,
		195,
		209,
		198,
		194,
		193,
		201,
		150,
		143,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		121,
		114,
		102,
		90,
		80,
		90,
		94,
		98,
		88,
		81,
		76,
		87,
		79,
		83,
		93,
		-1,
		229,
		-1,
		181,
		157,
		171,
		186,
		194,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		155,
		139,
		120,
		-1,
		90,
		103,
		134,
		102,
		106,
		100,
		82,
		93,
		82,
		85,
		86,
		89,
		-1,
		-1,
		169,
		172,
		-1,
		-1,
		171,
		173,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		127,
		123,
		-1,
		-1,
		91,
		116,
		105,
		112,
		107,
		86,
		92,
		95,
		84,
		88,
		86,
		-1,
		-1,
		176,
		177,
		178,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		129,
		92,
		113,
		123,
		115,
		113,
		104,
		90,
		97,
		95,
		91,
		96,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		93,
		119,
		122,
		126,
		120,
		93,
		108,
		98,
		89,
		98,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		123,
		113,
		142,
		127,
		108,
		95,
		102,
		102,
		95,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		132,
		128,
		115,
		115,
		107,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		108,
		143,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		115,
		116,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		120,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		216,
		218,
		184,
		178,
		217,
		188,
		194,
		205,
		-1,
		-1,
		-1,
		207,
		206,
		176,
		174,
		183,
		188,
		195,
		-1,
		218,
		-1,
		228,
		207,
		218,
		223,
		169,
		166,
		186,
		205,
		211,
		203,
		243,
		199,
		170,
		164,
		182,
		187,
		205,
		197,
		-1,
		170,
		160,
		182,
		186,
		198,
		181,
		-1,
		-1,
		164,
		165,
		171,
		183,
		188,
		193,
		-1,
		216,
		200,
		-1,
		-1,
		154,
		167,
		163,
		166,
		174,
		190,
		208,
		200,
		195,
		-1,
		-1,
		155,
		159,
		172,
		173,
		171,
		195,
		208,
		190,
		204,
		203,
		-1,
		143,
		161,
		170,
		179,
		185,
		171,
		169,
		187,
		189,
		195,
		198,
		-1,
		135,
		137,
		166,
		172,
		184,
		187,
		174,
		174,
		184,
		177,
		196,
		187,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		140,
		166,
		165,
		161,
		179,
		184,
		177,
		174,
		172,
		169,
		185,
		186,
		196,
		-1,
		-1,
		188,
		157,
		192,
		149,
		134,
		-1,
		128,
		147,
		153,
		157,
		162,
		167,
		181,
		177,
		-1,
		163,
		162,
		193,
		179,
		190,
		148,
		-1,
		-1,
		146,
		138,
		123,
		126,
		123,
		123,
		153,
		152,
		157,
		159,
		158,
		164,
		167,
		167,
		173,
		157,
		167,
		171,
		182,
		197,
		-1,
		-1,
		252,
		-1,
		-1,
		145,
		128,
		-1,
		111,
		118,
		118,
		135,
		125,
		146,
		161,
		165,
		173,
		172,
		160,
		162,
		159,
		172,
		160,
		154,
		179,
		183,
		177,
		198,
		193,
		-1,
		251,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		104,
		107,
		113,
		137,
		147,
		-1,
		168,
		166,
		190,
		181,
		178,
		165,
		153,
		166,
		151,
		158,
		157,
		161,
		163,
		196,
		174,
		196,
		193,
		222,
		227,
		221,
		230,
		-1,
		153,
		149,
		145,
		152,
		101,
		-1,
		-1,
		141,
		-1,
		155,
		168,
		172,
		170,
		173,
		182,
		173,
		160,
		149,
		160,
		149,
		146,
		154,
		163,
		174,
		169,
		168,
		186,
		201,
		214,
		218,
		224,
		-1,
		203,
		-1,
		145,
		129,
		131,
		103,
		124,
		-1,
		161,
		156,
		176,
		174,
		165,
		-1,
		168,
		171,
		178,
		156,
		141,
		158,
		150,
		148,
		153,
		158,
		172,
		163,
		181,
		188,
		196,
		200,
		220,
		232,
		163,
		153,
		-1,
		135,
		140,
		99,
		107,
		126,
		199,
		171,
		-1,
		166,
		-1,
		158,
		183,
		-1,
		162,
		158,
		140,
		141,
		136,
		151,
		157,
		154,
		151,
		169,
		172,
		189,
		193,
		209,
		-1,
		-1,
		148,
		152,
		141,
		92,
		111,
		135,
		172,
		164,
		153,
		152,
		-1,
		143,
		173,
		170,
		156,
		143,
		133,
		134,
		142,
		155,
		134,
		153,
		156,
		178,
		206,
		184,
		196,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		118,
		89,
		113,
		155,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		163,
		146,
		142,
		131,
		129,
		142,
		137,
		153,
		157,
		156,
		175,
		187,
		178,
		198,
		-1,
		-1,
		-1,
		148,
		137,
		138,
		84,
		107,
		144,
		161,
		147,
		152,
		127,
		120,
		114,
		166,
		163,
		130,
		138,
		130,
		119,
		133,
		141,
		145,
		154,
		163,
		169,
		193,
		193,
		199,
		-1,
		-1,
		155,
		145,
		129,
		131,
		128,
		98,
		105,
		137,
		152,
		149,
		-1,
		119,
		-1,
		108,
		116,
		115,
		121,
		133,
		119,
		124,
		135,
		147,
		160,
		156,
		163,
		198,
		198,
		183,
		203,
		206,
		-1,
		-1,
		-1,
		148,
		143,
		118,
		95,
		79,
		115,
		-1,
		119,
		120,
		-1,
		113,
		107,
		113,
		112,
		119,
		116,
		116,
		130,
		138,
		134,
		150,
		156,
		148,
		184,
		-1,
		191,
		185,
		193,
		183,
		171,
		-1,
		-1,
		-1,
		141,
		120,
		113,
		133,
		74,
		126,
		-1,
		-1,
		104,
		97,
		-1,
		100,
		100,
		107,
		116,
		121,
		126,
		134,
		129,
		142,
		147,
		153,
		158,
		176,
		180,
		184,
		173,
		169,
		166,
		180,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		94,
		-1,
		112,
		104,
		95,
		89,
		95,
		113,
		111,
		131,
		123,
		137,
		137,
		143,
		151,
		136,
		139,
		155,
		153,
		171,
		179,
		171,
		165,
		164,
		176,
		-1,
		161,
		147,
		118,
		-1,
		-1,
		107,
		-1,
		71,
		90,
		106,
		-1,
		129,
		108,
		131,
		109,
		123,
		119,
		157,
		158,
		136,
		141,
		149,
		159,
		161,
		150,
		161,
		153,
		175,
		175,
		159,
		160,
		169,
		-1,
		167,
		154,
		112,
		108,
		97,
		117,
		68,
		77,
		93,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		133,
		131,
		147,
		138,
		144,
		160,
		163,
		165,
		155,
		144,
		150,
		147,
		169,
		155,
		153,
		172,
		188,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		83,
		70,
		64,
		-1,
		110,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		155,
		139,
		144,
		-1,
		190,
		-1,
		163,
		165,
		159,
		144,
		141,
		152,
		150,
		161,
		178,
		-1,
		117,
		102,
		95,
		85,
		99,
		67,
		-1,
		101,
		-1,
		-1,
		138,
		132,
		132,
		113,
		110,
		171,
		151,
		145,
		144,
		185,
		185,
		171,
		157,
		150,
		147,
		144,
		157,
		177,
		168,
		180,
		-1,
		-1,
		-1,
		122,
		97,
		91,
		63,
		67,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		105,
		188,
		176,
		166,
		156,
		186,
		187,
		176,
		169,
		155,
		157,
		155,
		153,
		158,
		179,
		180,
		193,
		-1,
		-1,
		96,
		89,
		77,
		45,
		40,
		-1,
		-1,
		-1,
		147,
		143,
		131,
		103,
		177,
		-1,
		-1,
		168,
		166,
		172,
		170,
		159,
		179,
		182,
		168,
		152,
		167,
		179,
		187,
		192,
		-1,
		99,
		86,
		-1,
		-1,
		39,
		29,
		-1,
		-1,
		-1,
		-1,
		121,
		102,
		114,
		135,
		160,
		171,
		-1,
		157,
		161,
		161,
		177,
		184,
		170,
		165,
		159,
		162,
		180,
		197,
		-1,
		-1,
		53,
		-1,
		12,
		-1,
		-1,
		-1,
		-1,
		93,
		108,
		128,
		134,
		146,
		-1,
		155,
		154,
		158,
		164,
		176,
		180,
		171,
		153,
		167,
		165,
		178,
		192,
		196,
		76,
		-1,
		2,
		-1,
		-1,
		-1,
		70,
		100,
		188,
		165,
		138,
		143,
		140,
		146,
		150,
		162,
		171,
		182,
		147,
		151,
		166,
		171,
		170,
		187,
		196,
		-1,
		-1,
		0,
		18,
		53,
		65,
		97,
		215,
		-1,
		-1,
		139,
		132,
		142,
		142,
		155,
		158,
		143,
		145,
		163,
		176,
		170,
		180,
		195,
		190,
		-1,
		-1,
		-1,
		27,
		-1,
		36,
		-1,
		-1,
		112,
		212,
		159,
		141,
		137,
		123,
		137,
		131,
		133,
		138,
		157,
		152,
		161,
		166,
		170,
		193,
		182,
		221,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		56,
		29,
		44,
		104,
		109,
		100,
		174,
		171,
		-1,
		119,
		160,
		128,
		142,
		138,
		145,
		150,
		156,
		160,
		167,
		183,
		182,
		177,
		213,
		204,
		210,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		62,
		46,
		90,
		80,
		86,
		-1,
		-1,
		133,
		130,
		133,
		120,
		126,
		131,
		134,
		172,
		148,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		144,
		225,
		218,
		193,
		201,
		232,
		-1,
		65,
		79,
		53,
		72,
		80,
		-1,
		-1,
		106,
		102,
		107,
		116,
		119,
		155,
		154,
		167,
		170,
		175,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		158,
		201,
		187,
		190,
		214,
		228,
		-1,
		78,
		-1,
		-1,
		75,
		93,
		101,
		97,
		101,
		154,
		130,
		125,
		138,
		140,
		164,
		155,
		180,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		177,
		181,
		181,
		-1,
		-1,
		-1,
		-1,
		85,
		-1,
		-1,
		91,
		-1,
		127,
		-1,
		120,
		124,
		138,
		141,
		163,
		150,
		157,
		174,
		180,
		169,
		179,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		96,
		135,
		129,
		-1,
		100,
		-1,
		-1,
		-1,
		134,
		151,
		143,
		159,
		162,
		162,
		158,
		162,
		174,
		181,
		191,
		193,
		185,
		189,
		202,
		213,
		216,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		111,
		102,
		129,
		136,
		125,
		120,
		107,
		-1,
		-1,
		157,
		161,
		-1,
		-1,
		169,
		179,
		162,
		164,
		168,
		182,
		194,
		202,
		192,
		190,
		184,
		216,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		114,
		130,
		143,
		147,
		163,
		188,
		-1,
		110,
		-1,
		-1,
		178,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		176,
		187,
		209,
		198,
		199,
		189,
		199,
		212,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		129,
		117,
		123,
		130,
		147,
		177,
		-1,
		-1,
		126,
		117,
		-1,
		-1,
		197,
		204,
		206,
		-1,
		196,
		169,
		174,
		199,
		206,
		207,
		201,
		195,
		202,
		201,
		209,
		217,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		161,
		136,
		-1,
		-1,
		204,
		207,
		195,
		183,
		173,
		183,
		191,
		191,
		194,
		198,
		193,
		204,
		196,
		200,
		217,
		-1,
		218,
		-1,
		170,
		138,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		178,
		164,
		157,
		145,
		143,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		199,
		210,
		199,
		202,
		216,
		211,
		-1,
		-1,
		156,
		159,
		-1,
		-1,
		183,
		202,
		-1,
		169,
		158,
		143,
		135,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		184,
		209,
		198,
		206,
		201,
		203,
		209,
		212,
		201,
		205,
		217,
		-1,
		-1,
		163,
		166,
		171,
		-1,
		192,
		-1,
		193,
		-1,
		138,
		154,
		156,
		-1,
		-1,
		-1,
		222,
		185,
		206,
		216,
		221,
		219,
		210,
		207,
		214,
		212,
		208,
		219,
		-1,
		-1,
		-1,
		219,
		193,
		200,
		191,
		174,
		154,
		146,
		171,
		-1,
		210,
		-1,
		185,
		186,
		213,
		215,
		232,
		226,
		210,
		225,
		215,
		206,
		215,
		225,
		-1,
		195,
		228,
		192,
		160,
		160,
		159,
		224,
		-1,
		207,
		189,
		-1,
		217,
		207,
		249,
		230,
		223,
		210,
		217,
		219,
		212,
		-1,
		-1,
		-1,
		197,
		196,
		188,
		182,
		180,
		165,
		160,
		-1,
		212,
		194,
		180,
		197,
		197,
		188,
		196,
		239,
		235,
		228,
		230,
		220,
		-1,
		290,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		191,
		200,
		173,
		161,
		175,
		182,
		177,
		179,
		192,
		200,
		198,
		195,
		207,
		203,
		223,
		219,
		251,
		-1,
		297,
		-1,
		227,
		-1,
		-1,
		207,
		193,
		195,
		184,
		173,
		171,
		174,
		172,
		194,
		224,
		210,
		208,
		213,
		218,
		-1,
		295,
		294,
		-1,
		226,
		218,
		204,
		-1,
		197,
		-1,
		219,
		180,
		-1,
		201,
		181,
		-1,
		219,
		215,
		-1,
		-1,
		282,
		242,
		-1,
		-1,
		-1,
		227,
		207,
		214,
		198,
		-1,
		192,
		192,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		220,
		223,
		-1,
		214,
		220,
		247,
		194,
		198,
		-1,
		-1,
		-1,
		276,
		257,
		251,
		235,
		240,
		228,
		245,
		231,
		230,
		208,
		197,
		218,
		-1,
		-1,
		-1,
		248,
		240,
		240,
		-1,
		-1,
		255,
		238,
		219,
		217,
		-1,
		-1,
		-1,
		270,
		251,
		-1,
		-1,
		245,
		-1,
		-1,
		251,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		259,
		-1,
		-1,
		-1,
		241,
		237,
		238,
		-1,
		-1,
		-1,
		-1,
		280,
		281,
		305,
		280,
		-1,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		283,
		281,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		231,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		266,
		-1,
		266,
		241,
		248,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		279,
		-1,
		251,
		253,
		-1,
		301,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		256,
		263,
		285,
		288,
		324,
		-1,
		275
	],
	[
		-1,
		217,
		206,
		217,
		225,
		198,
		205,
		-1,
		226,
		228,
		194,
		188,
		227,
		198,
		204,
		215,
		-1,
		-1,
		-1,
		217,
		216,
		186,
		184,
		193,
		198,
		205,
		-1,
		228,
		-1,
		238,
		217,
		228,
		233,
		179,
		176,
		196,
		215,
		221,
		213,
		253,
		209,
		180,
		174,
		192,
		197,
		215,
		207,
		-1,
		180,
		170,
		192,
		196,
		208,
		191,
		-1,
		-1,
		174,
		175,
		181,
		193,
		198,
		203,
		-1,
		226,
		210,
		-1,
		-1,
		164,
		177,
		173,
		176,
		184,
		200,
		218,
		210,
		205,
		-1,
		-1,
		165,
		169,
		182,
		183,
		181,
		205,
		218,
		200,
		214,
		213,
		-1,
		153,
		171,
		180,
		189,
		195,
		181,
		179,
		197,
		199,
		205,
		208,
		-1,
		145,
		147,
		176,
		182,
		194,
		197,
		184,
		184,
		194,
		187,
		206,
		197,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		142,
		150,
		176,
		175,
		171,
		189,
		194,
		187,
		184,
		182,
		179,
		195,
		196,
		206,
		-1,
		-1,
		198,
		167,
		202,
		159,
		144,
		-1,
		138,
		157,
		163,
		167,
		172,
		177,
		191,
		187,
		-1,
		173,
		172,
		203,
		189,
		200,
		158,
		-1,
		-1,
		156,
		148,
		133,
		136,
		133,
		133,
		163,
		162,
		167,
		169,
		168,
		174,
		177,
		177,
		183,
		167,
		177,
		181,
		192,
		207,
		-1,
		-1,
		262,
		-1,
		-1,
		155,
		138,
		-1,
		121,
		128,
		128,
		145,
		135,
		156,
		171,
		175,
		183,
		182,
		170,
		172,
		169,
		182,
		170,
		164,
		189,
		193,
		187,
		208,
		203,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		114,
		117,
		123,
		147,
		157,
		-1,
		178,
		176,
		200,
		191,
		188,
		175,
		163,
		176,
		161,
		168,
		167,
		171,
		173,
		206,
		184,
		206,
		203,
		232,
		237,
		231,
		240,
		-1,
		163,
		159,
		155,
		162,
		111,
		-1,
		-1,
		151,
		-1,
		165,
		178,
		182,
		180,
		183,
		192,
		183,
		170,
		159,
		170,
		159,
		156,
		164,
		173,
		184,
		179,
		178,
		196,
		211,
		224,
		228,
		234,
		-1,
		213,
		-1,
		155,
		139,
		141,
		113,
		134,
		-1,
		171,
		166,
		186,
		184,
		175,
		-1,
		178,
		181,
		188,
		166,
		151,
		168,
		160,
		158,
		163,
		168,
		182,
		173,
		191,
		198,
		206,
		210,
		230,
		242,
		173,
		163,
		-1,
		145,
		150,
		109,
		117,
		136,
		209,
		181,
		-1,
		176,
		-1,
		168,
		193,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		167,
		164,
		161,
		179,
		182,
		199,
		203,
		219,
		-1,
		-1,
		158,
		162,
		151,
		102,
		121,
		145,
		182,
		174,
		163,
		162,
		-1,
		153,
		183,
		180,
		166,
		153,
		143,
		144,
		152,
		165,
		144,
		163,
		166,
		188,
		216,
		194,
		206,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		128,
		99,
		123,
		165,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		173,
		156,
		152,
		141,
		139,
		152,
		147,
		163,
		167,
		166,
		185,
		197,
		188,
		208,
		-1,
		-1,
		-1,
		158,
		147,
		148,
		94,
		117,
		154,
		171,
		157,
		162,
		137,
		130,
		124,
		176,
		173,
		140,
		148,
		140,
		129,
		143,
		151,
		155,
		164,
		173,
		179,
		203,
		203,
		209,
		-1,
		-1,
		165,
		155,
		139,
		141,
		138,
		108,
		115,
		147,
		162,
		159,
		-1,
		129,
		-1,
		118,
		126,
		125,
		131,
		143,
		129,
		134,
		145,
		157,
		170,
		166,
		173,
		208,
		208,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		158,
		153,
		128,
		105,
		89,
		125,
		-1,
		129,
		130,
		-1,
		123,
		117,
		123,
		122,
		129,
		126,
		126,
		140,
		148,
		144,
		160,
		166,
		158,
		194,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		151,
		130,
		123,
		143,
		84,
		136,
		-1,
		-1,
		114,
		107,
		-1,
		110,
		110,
		117,
		126,
		131,
		136,
		144,
		139,
		152,
		157,
		163,
		168,
		186,
		190,
		194,
		183,
		179,
		176,
		190,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		104,
		-1,
		122,
		114,
		105,
		99,
		105,
		123,
		121,
		141,
		133,
		147,
		147,
		153,
		161,
		146,
		149,
		165,
		163,
		181,
		189,
		181,
		175,
		174,
		186,
		-1,
		171,
		157,
		128,
		-1,
		-1,
		117,
		-1,
		81,
		100,
		116,
		-1,
		139,
		118,
		141,
		119,
		133,
		129,
		167,
		168,
		146,
		151,
		159,
		169,
		171,
		160,
		171,
		163,
		185,
		185,
		169,
		170,
		179,
		-1,
		177,
		164,
		122,
		118,
		107,
		127,
		78,
		87,
		103,
		-1,
		-1,
		167,
		-1,
		117,
		123,
		143,
		141,
		157,
		148,
		154,
		170,
		173,
		175,
		165,
		154,
		160,
		157,
		179,
		165,
		163,
		182,
		198,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		93,
		80,
		74,
		-1,
		120,
		-1,
		145,
		133,
		120,
		102,
		142,
		-1,
		165,
		149,
		154,
		-1,
		200,
		-1,
		173,
		175,
		169,
		154,
		151,
		162,
		160,
		171,
		181,
		-1,
		127,
		112,
		105,
		95,
		109,
		77,
		-1,
		111,
		-1,
		-1,
		132,
		126,
		126,
		95,
		92,
		181,
		161,
		155,
		154,
		187,
		174,
		173,
		161,
		160,
		157,
		154,
		167,
		181,
		178,
		179,
		-1,
		-1,
		-1,
		132,
		107,
		101,
		73,
		77,
		-1,
		-1,
		193,
		149,
		135,
		-1,
		87,
		175,
		165,
		174,
		166,
		174,
		175,
		165,
		163,
		159,
		167,
		165,
		160,
		159,
		180,
		173,
		195,
		-1,
		-1,
		106,
		99,
		87,
		55,
		50,
		-1,
		-1,
		-1,
		139,
		125,
		113,
		85,
		163,
		-1,
		-1,
		173,
		166,
		160,
		158,
		151,
		171,
		178,
		166,
		153,
		168,
		178,
		186,
		185,
		-1,
		109,
		96,
		-1,
		-1,
		49,
		39,
		-1,
		-1,
		-1,
		-1,
		103,
		84,
		96,
		117,
		142,
		172,
		-1,
		145,
		149,
		149,
		169,
		176,
		168,
		153,
		147,
		158,
		173,
		190,
		-1,
		-1,
		63,
		-1,
		22,
		-1,
		-1,
		-1,
		-1,
		75,
		90,
		110,
		116,
		128,
		-1,
		143,
		142,
		146,
		152,
		164,
		168,
		159,
		141,
		155,
		158,
		171,
		185,
		189,
		86,
		-1,
		12,
		-1,
		-1,
		-1,
		52,
		82,
		170,
		147,
		120,
		125,
		128,
		134,
		138,
		150,
		159,
		170,
		135,
		139,
		154,
		159,
		163,
		180,
		184,
		-1,
		-1,
		10,
		0,
		35,
		47,
		79,
		197,
		-1,
		-1,
		127,
		120,
		130,
		130,
		143,
		146,
		131,
		133,
		151,
		164,
		158,
		168,
		183,
		178,
		-1,
		-1,
		-1,
		26,
		-1,
		18,
		-1,
		-1,
		94,
		200,
		147,
		129,
		125,
		111,
		125,
		119,
		121,
		126,
		145,
		140,
		149,
		154,
		158,
		181,
		170,
		209,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		55,
		17,
		32,
		92,
		97,
		88,
		162,
		159,
		-1,
		107,
		148,
		116,
		130,
		126,
		133,
		138,
		144,
		148,
		155,
		171,
		170,
		165,
		201,
		192,
		198,
		-1,
		-1,
		236,
		225,
		214,
		220,
		-1,
		61,
		34,
		78,
		68,
		74,
		-1,
		-1,
		121,
		118,
		121,
		108,
		114,
		119,
		122,
		160,
		136,
		144,
		148,
		152,
		158,
		163,
		168,
		174,
		189,
		204,
		-1,
		154,
		227,
		220,
		188,
		196,
		227,
		-1,
		64,
		74,
		41,
		60,
		68,
		-1,
		-1,
		94,
		90,
		95,
		104,
		107,
		143,
		142,
		155,
		158,
		163,
		151,
		150,
		168,
		172,
		181,
		188,
		178,
		191,
		195,
		-1,
		168,
		203,
		182,
		185,
		209,
		223,
		-1,
		77,
		-1,
		-1,
		63,
		81,
		89,
		85,
		89,
		142,
		118,
		113,
		126,
		128,
		152,
		143,
		168,
		159,
		159,
		162,
		177,
		182,
		174,
		188,
		188,
		189,
		-1,
		172,
		183,
		176,
		-1,
		-1,
		-1,
		-1,
		80,
		-1,
		-1,
		79,
		-1,
		115,
		-1,
		108,
		112,
		126,
		129,
		151,
		138,
		145,
		162,
		168,
		157,
		167,
		163,
		164,
		173,
		184,
		196,
		195,
		196,
		197,
		153,
		156,
		167,
		178,
		193,
		197,
		-1,
		91,
		130,
		117,
		-1,
		88,
		-1,
		-1,
		-1,
		122,
		139,
		131,
		147,
		150,
		150,
		146,
		150,
		162,
		169,
		179,
		181,
		173,
		177,
		190,
		201,
		204,
		193,
		184,
		197,
		142,
		142,
		163,
		172,
		193,
		106,
		97,
		124,
		124,
		113,
		108,
		95,
		-1,
		-1,
		145,
		149,
		-1,
		-1,
		157,
		167,
		150,
		152,
		156,
		170,
		182,
		190,
		180,
		178,
		172,
		204,
		-1,
		186,
		185,
		174,
		171,
		147,
		138,
		133,
		160,
		-1,
		-1,
		109,
		125,
		138,
		142,
		155,
		180,
		-1,
		98,
		-1,
		-1,
		166,
		-1,
		-1,
		209,
		172,
		161,
		152,
		158,
		164,
		175,
		197,
		186,
		187,
		177,
		187,
		200,
		170,
		167,
		155,
		153,
		176,
		141,
		129,
		-1,
		124,
		112,
		118,
		125,
		142,
		169,
		-1,
		-1,
		114,
		105,
		-1,
		-1,
		185,
		192,
		194,
		-1,
		184,
		157,
		162,
		187,
		194,
		195,
		189,
		183,
		190,
		189,
		197,
		205,
		179,
		193,
		182,
		178,
		177,
		185,
		134,
		127,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		124,
		-1,
		-1,
		192,
		195,
		183,
		171,
		161,
		171,
		179,
		179,
		182,
		186,
		181,
		192,
		184,
		188,
		205,
		-1,
		213,
		-1,
		165,
		133,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		236,
		220,
		201,
		-1,
		171,
		184,
		215,
		183,
		188,
		183,
		187,
		198,
		187,
		190,
		204,
		199,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		178,
		197,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		208,
		204,
		-1,
		-1,
		172,
		197,
		186,
		194,
		189,
		191,
		197,
		200,
		189,
		193,
		205,
		-1,
		-1,
		158,
		161,
		166,
		-1,
		187,
		-1,
		181,
		-1,
		126,
		142,
		144,
		-1,
		-1,
		-1,
		210,
		173,
		194,
		204,
		209,
		207,
		198,
		195,
		202,
		200,
		196,
		207,
		-1,
		-1,
		-1,
		207,
		181,
		188,
		179,
		162,
		142,
		134,
		159,
		-1,
		198,
		-1,
		173,
		174,
		201,
		203,
		220,
		214,
		198,
		213,
		203,
		194,
		203,
		213,
		-1,
		183,
		216,
		180,
		148,
		148,
		147,
		212,
		-1,
		195,
		177,
		-1,
		205,
		195,
		237,
		218,
		211,
		198,
		205,
		207,
		200,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		168,
		153,
		148,
		-1,
		200,
		182,
		168,
		185,
		185,
		176,
		184,
		227,
		223,
		216,
		218,
		208,
		-1,
		285,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		188,
		161,
		149,
		163,
		170,
		165,
		167,
		180,
		188,
		186,
		183,
		195,
		191,
		211,
		207,
		239,
		-1,
		292,
		-1,
		215,
		-1,
		-1,
		195,
		181,
		183,
		172,
		161,
		159,
		162,
		160,
		182,
		212,
		198,
		196,
		201,
		206,
		-1,
		283,
		282,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		207,
		168,
		-1,
		189,
		169,
		-1,
		207,
		203,
		-1,
		-1,
		270,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		202,
		186,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		255,
		239,
		-1,
		208,
		211,
		-1,
		202,
		208,
		235,
		182,
		186,
		-1,
		-1,
		-1,
		264,
		245,
		239,
		223,
		228,
		216,
		233,
		219,
		218,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		236,
		228,
		228,
		-1,
		-1,
		243,
		226,
		207,
		205,
		-1,
		-1,
		-1,
		258,
		239,
		-1,
		-1,
		233,
		-1,
		-1,
		239,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		247,
		-1,
		-1,
		-1,
		229,
		225,
		226,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		293,
		268,
		-1,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		249,
		233,
		-1,
		219,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		254,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		267,
		259,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		282,
		273,
		-1,
		-1,
		244,
		251,
		273,
		276,
		312,
		-1,
		263
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		261,
		263,
		229,
		223,
		262,
		233,
		239,
		250,
		-1,
		-1,
		-1,
		252,
		251,
		221,
		219,
		228,
		233,
		240,
		-1,
		245,
		-1,
		273,
		252,
		263,
		268,
		214,
		211,
		231,
		250,
		238,
		230,
		288,
		244,
		215,
		209,
		227,
		223,
		232,
		224,
		-1,
		215,
		205,
		227,
		212,
		223,
		215,
		-1,
		-1,
		209,
		210,
		216,
		208,
		214,
		210,
		-1,
		220,
		204,
		-1,
		-1,
		199,
		206,
		190,
		193,
		201,
		199,
		212,
		204,
		199,
		-1,
		-1,
		196,
		192,
		199,
		186,
		182,
		199,
		212,
		194,
		208,
		207,
		-1,
		188,
		206,
		215,
		193,
		191,
		175,
		173,
		191,
		193,
		199,
		202,
		-1,
		180,
		182,
		194,
		202,
		207,
		191,
		178,
		178,
		188,
		181,
		200,
		191,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		177,
		181,
		198,
		190,
		180,
		195,
		188,
		181,
		178,
		176,
		173,
		189,
		190,
		200,
		-1,
		-1,
		233,
		202,
		237,
		194,
		179,
		-1,
		173,
		174,
		180,
		184,
		178,
		171,
		185,
		181,
		-1,
		167,
		166,
		197,
		183,
		194,
		193,
		-1,
		-1,
		191,
		183,
		168,
		171,
		168,
		168,
		189,
		188,
		180,
		166,
		162,
		168,
		171,
		171,
		177,
		161,
		171,
		175,
		186,
		201,
		-1,
		-1,
		256,
		-1,
		-1,
		190,
		173,
		-1,
		156,
		163,
		163,
		180,
		170,
		191,
		199,
		190,
		182,
		176,
		164,
		166,
		163,
		176,
		164,
		158,
		183,
		187,
		181,
		202,
		197,
		-1,
		255,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		149,
		152,
		158,
		182,
		192,
		-1,
		184,
		190,
		200,
		185,
		182,
		169,
		157,
		170,
		155,
		162,
		161,
		165,
		167,
		200,
		178,
		200,
		197,
		226,
		231,
		225,
		234,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		186,
		-1,
		200,
		201,
		176,
		194,
		197,
		186,
		177,
		164,
		153,
		164,
		153,
		150,
		158,
		167,
		178,
		173,
		172,
		190,
		205,
		218,
		222,
		228,
		-1,
		248,
		-1,
		190,
		174,
		176,
		148,
		169,
		-1,
		206,
		201,
		193,
		178,
		169,
		-1,
		172,
		175,
		182,
		160,
		145,
		162,
		154,
		152,
		157,
		162,
		176,
		167,
		185,
		192,
		200,
		204,
		224,
		236,
		208,
		198,
		-1,
		180,
		185,
		144,
		152,
		171,
		211,
		175,
		-1,
		170,
		-1,
		162,
		187,
		-1,
		166,
		162,
		144,
		145,
		140,
		155,
		161,
		158,
		155,
		173,
		176,
		193,
		197,
		213,
		-1,
		-1,
		193,
		197,
		186,
		137,
		156,
		180,
		217,
		168,
		157,
		156,
		-1,
		147,
		177,
		174,
		160,
		147,
		137,
		138,
		146,
		159,
		138,
		157,
		160,
		182,
		210,
		188,
		200,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		163,
		134,
		158,
		200,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		167,
		150,
		146,
		135,
		133,
		146,
		141,
		157,
		161,
		160,
		179,
		191,
		182,
		202,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		165,
		151,
		156,
		131,
		124,
		118,
		170,
		167,
		134,
		142,
		134,
		123,
		137,
		145,
		149,
		158,
		167,
		173,
		197,
		197,
		203,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		156,
		169,
		-1,
		123,
		-1,
		112,
		120,
		119,
		125,
		137,
		123,
		128,
		139,
		151,
		164,
		160,
		167,
		202,
		202,
		187,
		207,
		210,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		139,
		140,
		-1,
		117,
		111,
		117,
		116,
		123,
		120,
		120,
		134,
		142,
		138,
		154,
		160,
		152,
		188,
		-1,
		195,
		189,
		197,
		187,
		175,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		104,
		111,
		120,
		125,
		130,
		138,
		133,
		146,
		151,
		157,
		162,
		180,
		184,
		188,
		177,
		173,
		170,
		184,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		133,
		125,
		115,
		109,
		103,
		114,
		115,
		135,
		127,
		141,
		141,
		147,
		155,
		140,
		143,
		159,
		157,
		175,
		183,
		175,
		169,
		168,
		180,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		117,
		123,
		161,
		162,
		140,
		145,
		153,
		163,
		165,
		154,
		165,
		157,
		179,
		179,
		163,
		164,
		173,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		103,
		135,
		-1,
		-1,
		141,
		-1,
		95,
		97,
		137,
		135,
		151,
		142,
		148,
		164,
		164,
		159,
		159,
		148,
		154,
		151,
		173,
		159,
		157,
		176,
		192,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		152,
		-1,
		119,
		107,
		94,
		76,
		116,
		-1,
		159,
		143,
		148,
		-1,
		184,
		-1,
		156,
		159,
		150,
		147,
		145,
		156,
		154,
		165,
		182,
		-1,
		162,
		147,
		140,
		130,
		144,
		112,
		-1,
		146,
		-1,
		-1,
		106,
		100,
		100,
		69,
		66,
		175,
		155,
		149,
		148,
		167,
		154,
		153,
		141,
		141,
		144,
		148,
		161,
		181,
		172,
		184,
		-1,
		-1,
		-1,
		167,
		142,
		136,
		108,
		112,
		-1,
		-1,
		167,
		123,
		109,
		-1,
		61,
		149,
		139,
		148,
		149,
		154,
		155,
		145,
		143,
		139,
		148,
		152,
		157,
		162,
		183,
		179,
		197,
		-1,
		-1,
		141,
		134,
		122,
		90,
		85,
		-1,
		-1,
		-1,
		113,
		99,
		87,
		59,
		137,
		-1,
		-1,
		153,
		146,
		140,
		143,
		131,
		151,
		158,
		172,
		156,
		171,
		183,
		191,
		191,
		-1,
		144,
		131,
		-1,
		-1,
		84,
		74,
		-1,
		-1,
		-1,
		-1,
		77,
		58,
		70,
		91,
		116,
		152,
		-1,
		126,
		137,
		130,
		149,
		156,
		174,
		159,
		153,
		164,
		179,
		196,
		-1,
		-1,
		98,
		-1,
		57,
		-1,
		-1,
		-1,
		-1,
		49,
		64,
		84,
		90,
		102,
		-1,
		128,
		130,
		127,
		139,
		150,
		155,
		163,
		147,
		161,
		164,
		177,
		191,
		195,
		121,
		-1,
		47,
		-1,
		-1,
		-1,
		26,
		56,
		144,
		121,
		94,
		99,
		109,
		114,
		119,
		139,
		145,
		156,
		141,
		145,
		160,
		170,
		169,
		186,
		196,
		-1,
		-1,
		45,
		35,
		0,
		21,
		53,
		171,
		-1,
		-1,
		109,
		115,
		111,
		121,
		129,
		132,
		137,
		139,
		157,
		176,
		164,
		179,
		194,
		190,
		-1,
		-1,
		-1,
		61,
		-1,
		33,
		-1,
		-1,
		68,
		195,
		142,
		124,
		120,
		118,
		123,
		132,
		127,
		132,
		157,
		152,
		161,
		166,
		170,
		193,
		182,
		221,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		90,
		52,
		67,
		127,
		88,
		95,
		157,
		154,
		-1,
		124,
		161,
		133,
		140,
		132,
		145,
		150,
		156,
		160,
		167,
		183,
		182,
		177,
		213,
		204,
		210,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		96,
		69,
		113,
		103,
		105,
		-1,
		-1,
		156,
		153,
		148,
		142,
		146,
		139,
		134,
		172,
		148,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		189,
		262,
		255,
		223,
		231,
		262,
		-1,
		99,
		109,
		76,
		95,
		103,
		-1,
		-1,
		129,
		125,
		130,
		139,
		142,
		158,
		157,
		168,
		170,
		175,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		203,
		238,
		217,
		220,
		244,
		258,
		-1,
		112,
		-1,
		-1,
		98,
		116,
		124,
		120,
		124,
		177,
		153,
		148,
		160,
		162,
		166,
		157,
		180,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		114,
		-1,
		150,
		-1,
		143,
		147,
		161,
		164,
		185,
		172,
		170,
		178,
		186,
		169,
		179,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		126,
		165,
		152,
		-1,
		123,
		-1,
		-1,
		-1,
		157,
		174,
		166,
		182,
		184,
		184,
		164,
		168,
		174,
		181,
		191,
		193,
		185,
		189,
		202,
		213,
		216,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		141,
		132,
		159,
		159,
		148,
		143,
		130,
		-1,
		-1,
		180,
		184,
		-1,
		-1,
		191,
		185,
		168,
		170,
		174,
		184,
		199,
		202,
		192,
		190,
		184,
		216,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		144,
		160,
		173,
		177,
		190,
		215,
		-1,
		133,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		190,
		179,
		170,
		176,
		182,
		193,
		210,
		198,
		199,
		189,
		199,
		212,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		159,
		147,
		153,
		160,
		177,
		204,
		-1,
		-1,
		149,
		140,
		-1,
		-1,
		220,
		223,
		212,
		-1,
		202,
		175,
		180,
		205,
		212,
		207,
		201,
		195,
		202,
		201,
		209,
		217,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		159,
		-1,
		-1,
		220,
		213,
		201,
		189,
		179,
		189,
		197,
		197,
		200,
		198,
		193,
		204,
		196,
		200,
		217,
		-1,
		248,
		-1,
		200,
		168,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		254,
		238,
		219,
		-1,
		189,
		202,
		233,
		201,
		206,
		201,
		199,
		210,
		199,
		202,
		216,
		211,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		213,
		232,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		226,
		222,
		-1,
		-1,
		190,
		215,
		204,
		212,
		207,
		203,
		209,
		212,
		201,
		205,
		217,
		-1,
		-1,
		193,
		196,
		201,
		-1,
		222,
		-1,
		216,
		-1,
		161,
		177,
		179,
		-1,
		-1,
		-1,
		228,
		191,
		208,
		222,
		227,
		225,
		216,
		207,
		214,
		212,
		208,
		219,
		-1,
		-1,
		-1,
		242,
		216,
		223,
		214,
		197,
		177,
		169,
		194,
		-1,
		210,
		-1,
		185,
		188,
		213,
		221,
		238,
		232,
		210,
		225,
		215,
		206,
		215,
		248,
		-1,
		218,
		251,
		215,
		183,
		183,
		182,
		231,
		-1,
		207,
		189,
		-1,
		217,
		207,
		255,
		230,
		225,
		212,
		219,
		219,
		212,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		203,
		188,
		183,
		-1,
		219,
		201,
		180,
		197,
		197,
		188,
		196,
		245,
		241,
		232,
		232,
		220,
		-1,
		320,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		223,
		196,
		184,
		198,
		198,
		184,
		190,
		192,
		200,
		198,
		195,
		207,
		203,
		223,
		219,
		251,
		-1,
		327,
		-1,
		250,
		-1,
		-1,
		230,
		216,
		218,
		207,
		196,
		194,
		197,
		188,
		210,
		226,
		210,
		208,
		213,
		218,
		-1,
		318,
		317,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		242,
		203,
		-1,
		217,
		197,
		-1,
		219,
		215,
		-1,
		-1,
		305,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		237,
		221,
		-1,
		208,
		208,
		-1,
		-1,
		-1,
		290,
		274,
		-1,
		243,
		246,
		-1,
		237,
		243,
		263,
		210,
		214,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		258,
		263,
		251,
		268,
		254,
		246,
		224,
		213,
		234,
		-1,
		-1,
		-1,
		271,
		263,
		263,
		-1,
		-1,
		271,
		254,
		235,
		233,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		261,
		-1,
		-1,
		267,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		282,
		-1,
		-1,
		-1,
		257,
		253,
		254,
		-1,
		-1,
		-1,
		-1,
		303,
		304,
		328,
		303,
		-1,
		-1,
		-1,
		249,
		243,
		-1,
		-1,
		306,
		304,
		-1,
		-1,
		-1,
		277,
		261,
		-1,
		247,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		282,
		-1,
		282,
		257,
		264,
		-1,
		-1,
		-1,
		-1,
		295,
		287,
		295,
		-1,
		267,
		269,
		-1,
		317,
		-1,
		-1,
		310,
		301,
		-1,
		-1,
		272,
		279,
		301,
		304,
		340,
		-1,
		291
	],
	[
		-1,
		232,
		221,
		232,
		240,
		213,
		220,
		-1,
		241,
		243,
		209,
		203,
		242,
		213,
		219,
		230,
		-1,
		-1,
		-1,
		232,
		231,
		201,
		199,
		208,
		213,
		220,
		-1,
		224,
		-1,
		253,
		232,
		243,
		248,
		194,
		191,
		211,
		230,
		217,
		209,
		268,
		224,
		195,
		189,
		207,
		202,
		211,
		203,
		-1,
		195,
		185,
		207,
		191,
		202,
		194,
		-1,
		-1,
		189,
		190,
		196,
		187,
		193,
		189,
		-1,
		199,
		183,
		-1,
		-1,
		179,
		185,
		169,
		172,
		180,
		178,
		191,
		183,
		178,
		-1,
		-1,
		175,
		171,
		178,
		165,
		161,
		178,
		191,
		173,
		187,
		186,
		-1,
		168,
		186,
		195,
		172,
		170,
		154,
		152,
		170,
		172,
		178,
		181,
		-1,
		161,
		163,
		173,
		181,
		186,
		170,
		157,
		157,
		167,
		160,
		179,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		160,
		177,
		169,
		159,
		174,
		167,
		160,
		157,
		155,
		152,
		168,
		169,
		179,
		-1,
		-1,
		214,
		183,
		218,
		175,
		160,
		-1,
		154,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		146,
		145,
		176,
		162,
		173,
		174,
		-1,
		-1,
		172,
		164,
		149,
		152,
		149,
		149,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		140,
		150,
		154,
		165,
		180,
		-1,
		-1,
		235,
		-1,
		-1,
		171,
		154,
		-1,
		137,
		144,
		144,
		161,
		151,
		172,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		137,
		162,
		166,
		160,
		181,
		176,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		130,
		133,
		139,
		163,
		173,
		-1,
		163,
		169,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		144,
		146,
		179,
		157,
		179,
		176,
		205,
		210,
		204,
		213,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		167,
		-1,
		181,
		180,
		155,
		173,
		176,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		146,
		157,
		152,
		151,
		169,
		184,
		197,
		201,
		207,
		-1,
		229,
		-1,
		171,
		155,
		157,
		129,
		150,
		-1,
		187,
		182,
		172,
		157,
		148,
		-1,
		151,
		154,
		161,
		139,
		124,
		141,
		133,
		131,
		136,
		141,
		155,
		146,
		164,
		171,
		179,
		183,
		203,
		215,
		189,
		179,
		-1,
		161,
		166,
		125,
		133,
		152,
		190,
		154,
		-1,
		149,
		-1,
		141,
		166,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		140,
		137,
		134,
		152,
		155,
		172,
		176,
		192,
		-1,
		-1,
		174,
		178,
		167,
		118,
		137,
		161,
		198,
		147,
		136,
		135,
		-1,
		126,
		156,
		153,
		139,
		126,
		116,
		117,
		125,
		138,
		117,
		136,
		139,
		161,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		144,
		115,
		139,
		181,
		165,
		158,
		146,
		111,
		111,
		105,
		-1,
		146,
		129,
		125,
		114,
		112,
		125,
		120,
		136,
		140,
		139,
		158,
		170,
		161,
		181,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		144,
		130,
		135,
		110,
		103,
		97,
		149,
		146,
		113,
		121,
		113,
		102,
		116,
		124,
		128,
		137,
		146,
		152,
		176,
		176,
		182,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		135,
		148,
		-1,
		102,
		-1,
		91,
		99,
		98,
		104,
		116,
		102,
		107,
		118,
		130,
		143,
		139,
		146,
		181,
		181,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		118,
		119,
		-1,
		96,
		90,
		96,
		95,
		102,
		99,
		99,
		113,
		121,
		117,
		133,
		139,
		131,
		167,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		103,
		96,
		-1,
		83,
		83,
		90,
		99,
		104,
		109,
		117,
		112,
		125,
		130,
		136,
		141,
		159,
		163,
		167,
		156,
		152,
		149,
		163,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		112,
		104,
		94,
		88,
		82,
		93,
		94,
		114,
		106,
		120,
		120,
		126,
		134,
		119,
		122,
		138,
		136,
		154,
		162,
		154,
		148,
		147,
		159,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		111,
		127,
		-1,
		120,
		99,
		114,
		92,
		96,
		102,
		140,
		141,
		119,
		124,
		132,
		142,
		144,
		133,
		144,
		136,
		158,
		158,
		142,
		143,
		152,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		82,
		114,
		-1,
		-1,
		120,
		-1,
		74,
		76,
		116,
		114,
		130,
		121,
		127,
		143,
		143,
		138,
		138,
		127,
		133,
		130,
		152,
		138,
		136,
		155,
		171,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		131,
		-1,
		98,
		86,
		73,
		55,
		95,
		-1,
		138,
		122,
		127,
		-1,
		163,
		-1,
		135,
		138,
		129,
		126,
		124,
		135,
		133,
		144,
		161,
		-1,
		143,
		128,
		121,
		111,
		125,
		96,
		-1,
		151,
		-1,
		-1,
		85,
		79,
		79,
		48,
		45,
		154,
		134,
		128,
		127,
		146,
		133,
		132,
		120,
		120,
		123,
		127,
		140,
		160,
		151,
		163,
		-1,
		-1,
		-1,
		148,
		134,
		138,
		98,
		117,
		-1,
		-1,
		146,
		102,
		88,
		-1,
		40,
		128,
		118,
		127,
		128,
		133,
		134,
		124,
		122,
		118,
		127,
		131,
		136,
		141,
		162,
		158,
		176,
		-1,
		-1,
		131,
		136,
		124,
		108,
		103,
		-1,
		-1,
		-1,
		92,
		78,
		66,
		38,
		116,
		-1,
		-1,
		132,
		125,
		119,
		122,
		110,
		130,
		137,
		151,
		135,
		150,
		162,
		170,
		170,
		-1,
		134,
		121,
		-1,
		-1,
		102,
		92,
		-1,
		-1,
		-1,
		-1,
		56,
		37,
		49,
		70,
		95,
		131,
		-1,
		105,
		116,
		109,
		128,
		135,
		153,
		138,
		132,
		143,
		158,
		175,
		-1,
		-1,
		116,
		-1,
		75,
		-1,
		-1,
		-1,
		-1,
		28,
		43,
		63,
		69,
		81,
		-1,
		107,
		109,
		106,
		118,
		129,
		134,
		142,
		126,
		140,
		143,
		156,
		170,
		174,
		139,
		-1,
		65,
		-1,
		-1,
		-1,
		5,
		35,
		123,
		100,
		73,
		78,
		88,
		93,
		98,
		118,
		124,
		135,
		120,
		124,
		139,
		149,
		148,
		165,
		175,
		-1,
		-1,
		63,
		53,
		18,
		0,
		32,
		150,
		-1,
		-1,
		88,
		94,
		90,
		100,
		108,
		111,
		116,
		118,
		136,
		155,
		143,
		158,
		173,
		169,
		-1,
		-1,
		-1,
		79,
		-1,
		51,
		-1,
		-1,
		47,
		174,
		121,
		103,
		99,
		97,
		102,
		111,
		106,
		111,
		136,
		131,
		140,
		145,
		149,
		172,
		161,
		200,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		108,
		70,
		85,
		132,
		67,
		74,
		136,
		133,
		-1,
		103,
		140,
		112,
		119,
		111,
		124,
		129,
		135,
		139,
		146,
		162,
		161,
		156,
		192,
		183,
		189,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		114,
		87,
		118,
		108,
		84,
		-1,
		-1,
		151,
		148,
		127,
		121,
		125,
		118,
		113,
		151,
		127,
		135,
		139,
		143,
		149,
		154,
		159,
		165,
		180,
		195,
		-1,
		179,
		260,
		253,
		232,
		240,
		271,
		-1,
		117,
		118,
		94,
		104,
		95,
		-1,
		-1,
		124,
		122,
		127,
		128,
		125,
		137,
		136,
		147,
		149,
		154,
		142,
		141,
		159,
		163,
		172,
		179,
		169,
		182,
		186,
		-1,
		193,
		236,
		226,
		229,
		253,
		267,
		-1,
		123,
		-1,
		-1,
		116,
		108,
		116,
		119,
		123,
		174,
		142,
		137,
		139,
		141,
		145,
		136,
		159,
		150,
		150,
		153,
		168,
		173,
		165,
		179,
		179,
		180,
		-1,
		216,
		216,
		220,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		132,
		-1,
		142,
		-1,
		135,
		139,
		150,
		153,
		164,
		151,
		149,
		157,
		165,
		148,
		158,
		154,
		155,
		164,
		175,
		187,
		186,
		187,
		241,
		197,
		200,
		211,
		222,
		237,
		241,
		-1,
		135,
		174,
		170,
		-1,
		141,
		-1,
		-1,
		-1,
		149,
		163,
		155,
		171,
		163,
		163,
		143,
		147,
		153,
		160,
		170,
		172,
		164,
		168,
		181,
		192,
		195,
		237,
		228,
		241,
		186,
		186,
		207,
		216,
		237,
		150,
		141,
		168,
		177,
		166,
		161,
		148,
		-1,
		-1,
		172,
		173,
		-1,
		-1,
		170,
		164,
		147,
		149,
		153,
		163,
		178,
		181,
		171,
		169,
		163,
		195,
		-1,
		230,
		229,
		218,
		215,
		191,
		182,
		177,
		204,
		-1,
		-1,
		153,
		169,
		182,
		186,
		202,
		227,
		-1,
		151,
		-1,
		-1,
		193,
		-1,
		-1,
		206,
		169,
		158,
		149,
		155,
		161,
		172,
		189,
		177,
		178,
		168,
		178,
		191,
		214,
		211,
		199,
		197,
		220,
		185,
		173,
		-1,
		168,
		156,
		162,
		169,
		186,
		216,
		-1,
		-1,
		167,
		158,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		154,
		159,
		184,
		191,
		186,
		180,
		174,
		181,
		180,
		188,
		196,
		223,
		237,
		226,
		222,
		221,
		229,
		178,
		171,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		177,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		176,
		176,
		179,
		177,
		172,
		183,
		175,
		179,
		196,
		-1,
		257,
		-1,
		209,
		177,
		197,
		212,
		220,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		212,
		180,
		185,
		180,
		178,
		189,
		178,
		181,
		195,
		190,
		-1,
		-1,
		195,
		198,
		-1,
		-1,
		222,
		241,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		169,
		194,
		183,
		191,
		186,
		182,
		188,
		191,
		180,
		184,
		196,
		-1,
		-1,
		202,
		205,
		210,
		-1,
		229,
		-1,
		234,
		-1,
		179,
		195,
		197,
		-1,
		-1,
		-1,
		207,
		170,
		187,
		201,
		206,
		204,
		195,
		186,
		193,
		191,
		187,
		198,
		-1,
		-1,
		-1,
		247,
		221,
		241,
		232,
		215,
		195,
		187,
		212,
		-1,
		189,
		-1,
		164,
		167,
		192,
		200,
		217,
		211,
		189,
		204,
		194,
		185,
		194,
		253,
		-1,
		223,
		256,
		220,
		201,
		190,
		194,
		210,
		-1,
		186,
		168,
		-1,
		196,
		186,
		234,
		209,
		204,
		191,
		198,
		198,
		191,
		-1,
		-1,
		-1,
		225,
		224,
		216,
		210,
		210,
		195,
		186,
		-1,
		198,
		180,
		159,
		176,
		176,
		167,
		175,
		224,
		220,
		211,
		211,
		199,
		-1,
		326,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		219,
		214,
		187,
		175,
		181,
		177,
		163,
		169,
		171,
		179,
		177,
		174,
		186,
		182,
		202,
		198,
		230,
		-1,
		321,
		-1,
		255,
		-1,
		-1,
		237,
		217,
		209,
		198,
		187,
		185,
		176,
		167,
		189,
		205,
		189,
		187,
		192,
		197,
		-1,
		310,
		309,
		-1,
		256,
		248,
		234,
		-1,
		227,
		-1,
		233,
		194,
		-1,
		196,
		176,
		-1,
		198,
		194,
		-1,
		-1,
		297,
		272,
		-1,
		-1,
		-1,
		257,
		237,
		228,
		212,
		-1,
		187,
		187,
		-1,
		-1,
		-1,
		282,
		281,
		-1,
		250,
		253,
		-1,
		243,
		234,
		242,
		189,
		193,
		-1,
		-1,
		-1,
		291,
		272,
		266,
		265,
		263,
		258,
		255,
		241,
		225,
		203,
		192,
		213,
		-1,
		-1,
		-1,
		263,
		255,
		248,
		-1,
		-1,
		250,
		233,
		214,
		212,
		-1,
		-1,
		-1,
		285,
		266,
		-1,
		-1,
		240,
		-1,
		-1,
		246,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		274,
		-1,
		-1,
		-1,
		236,
		232,
		233,
		-1,
		-1,
		-1,
		-1,
		296,
		297,
		320,
		284,
		-1,
		-1,
		-1,
		228,
		222,
		-1,
		-1,
		299,
		297,
		-1,
		-1,
		-1,
		256,
		240,
		-1,
		226,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		261,
		-1,
		261,
		236,
		243,
		-1,
		-1,
		-1,
		-1,
		274,
		266,
		274,
		-1,
		246,
		248,
		-1,
		296,
		-1,
		-1,
		289,
		280,
		-1,
		-1,
		251,
		258,
		280,
		283,
		319,
		-1,
		270
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		247,
		249,
		215,
		209,
		248,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		238,
		237,
		207,
		205,
		214,
		219,
		226,
		-1,
		230,
		-1,
		259,
		238,
		249,
		254,
		200,
		197,
		217,
		236,
		223,
		215,
		274,
		230,
		201,
		195,
		213,
		208,
		217,
		209,
		-1,
		201,
		191,
		213,
		197,
		208,
		200,
		-1,
		-1,
		195,
		196,
		202,
		193,
		199,
		195,
		-1,
		205,
		189,
		-1,
		-1,
		185,
		191,
		175,
		178,
		186,
		184,
		197,
		189,
		184,
		-1,
		-1,
		181,
		177,
		184,
		171,
		167,
		184,
		197,
		179,
		193,
		192,
		-1,
		174,
		192,
		201,
		178,
		176,
		160,
		158,
		176,
		178,
		184,
		187,
		-1,
		167,
		169,
		179,
		187,
		192,
		176,
		163,
		163,
		173,
		166,
		185,
		176,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		164,
		166,
		183,
		175,
		165,
		180,
		173,
		166,
		163,
		161,
		158,
		174,
		175,
		185,
		-1,
		-1,
		220,
		189,
		224,
		181,
		166,
		-1,
		160,
		159,
		165,
		169,
		163,
		156,
		170,
		166,
		-1,
		152,
		151,
		182,
		168,
		179,
		180,
		-1,
		-1,
		178,
		170,
		155,
		158,
		155,
		155,
		174,
		173,
		165,
		151,
		147,
		153,
		156,
		156,
		162,
		146,
		156,
		160,
		171,
		186,
		-1,
		-1,
		241,
		-1,
		-1,
		177,
		160,
		-1,
		143,
		150,
		150,
		167,
		157,
		178,
		184,
		175,
		167,
		161,
		149,
		151,
		148,
		161,
		149,
		143,
		168,
		172,
		166,
		187,
		182,
		-1,
		240,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		139,
		145,
		169,
		179,
		-1,
		169,
		175,
		185,
		170,
		167,
		154,
		142,
		155,
		140,
		147,
		146,
		150,
		152,
		185,
		163,
		185,
		182,
		211,
		216,
		210,
		219,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		173,
		-1,
		187,
		186,
		161,
		179,
		182,
		171,
		162,
		149,
		138,
		149,
		138,
		135,
		143,
		152,
		163,
		158,
		157,
		175,
		190,
		203,
		207,
		213,
		-1,
		235,
		-1,
		177,
		161,
		163,
		135,
		156,
		-1,
		193,
		188,
		178,
		163,
		154,
		-1,
		157,
		160,
		167,
		145,
		130,
		147,
		139,
		137,
		142,
		147,
		161,
		152,
		170,
		177,
		185,
		189,
		209,
		221,
		195,
		185,
		-1,
		167,
		172,
		131,
		139,
		158,
		196,
		160,
		-1,
		155,
		-1,
		147,
		172,
		-1,
		151,
		147,
		129,
		130,
		125,
		140,
		146,
		143,
		140,
		158,
		161,
		178,
		182,
		198,
		-1,
		-1,
		180,
		184,
		173,
		124,
		143,
		167,
		204,
		153,
		142,
		141,
		-1,
		132,
		162,
		159,
		145,
		132,
		122,
		123,
		131,
		144,
		123,
		142,
		145,
		167,
		195,
		173,
		185,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		150,
		121,
		145,
		187,
		171,
		164,
		152,
		117,
		117,
		111,
		-1,
		152,
		135,
		131,
		120,
		118,
		131,
		126,
		142,
		146,
		145,
		164,
		176,
		167,
		187,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		150,
		136,
		141,
		116,
		109,
		103,
		155,
		152,
		119,
		127,
		119,
		108,
		122,
		130,
		134,
		143,
		152,
		158,
		182,
		182,
		188,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		141,
		154,
		-1,
		108,
		-1,
		97,
		105,
		104,
		110,
		122,
		108,
		113,
		124,
		136,
		149,
		145,
		152,
		187,
		187,
		172,
		192,
		195,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		124,
		125,
		-1,
		102,
		96,
		102,
		101,
		108,
		105,
		105,
		119,
		127,
		123,
		139,
		145,
		137,
		173,
		-1,
		180,
		174,
		182,
		172,
		160,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		109,
		102,
		-1,
		89,
		89,
		96,
		105,
		110,
		115,
		123,
		118,
		131,
		136,
		142,
		147,
		165,
		169,
		173,
		162,
		158,
		155,
		169,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		118,
		110,
		100,
		94,
		88,
		99,
		100,
		120,
		112,
		126,
		126,
		132,
		140,
		125,
		128,
		144,
		142,
		160,
		168,
		160,
		154,
		153,
		165,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		117,
		133,
		-1,
		126,
		105,
		120,
		98,
		102,
		108,
		146,
		147,
		125,
		130,
		138,
		148,
		150,
		139,
		150,
		142,
		164,
		164,
		148,
		149,
		158,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		88,
		120,
		-1,
		-1,
		126,
		-1,
		80,
		82,
		122,
		120,
		136,
		127,
		133,
		149,
		149,
		144,
		144,
		133,
		139,
		136,
		158,
		144,
		142,
		161,
		177,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		137,
		-1,
		104,
		92,
		79,
		61,
		101,
		-1,
		144,
		128,
		133,
		-1,
		169,
		-1,
		141,
		144,
		135,
		132,
		130,
		141,
		139,
		150,
		167,
		-1,
		149,
		134,
		127,
		117,
		131,
		102,
		-1,
		157,
		-1,
		-1,
		91,
		85,
		85,
		54,
		51,
		160,
		140,
		134,
		133,
		152,
		139,
		138,
		126,
		126,
		129,
		133,
		146,
		166,
		157,
		169,
		-1,
		-1,
		-1,
		154,
		140,
		144,
		104,
		123,
		-1,
		-1,
		152,
		108,
		94,
		-1,
		46,
		134,
		124,
		133,
		134,
		139,
		140,
		130,
		128,
		124,
		133,
		137,
		142,
		147,
		168,
		164,
		182,
		-1,
		-1,
		137,
		142,
		130,
		116,
		135,
		-1,
		-1,
		-1,
		98,
		84,
		72,
		44,
		122,
		-1,
		-1,
		138,
		131,
		125,
		128,
		116,
		136,
		143,
		157,
		141,
		156,
		168,
		176,
		176,
		-1,
		140,
		127,
		-1,
		-1,
		136,
		126,
		-1,
		-1,
		-1,
		-1,
		62,
		43,
		55,
		76,
		101,
		137,
		-1,
		111,
		122,
		115,
		134,
		141,
		159,
		144,
		138,
		149,
		164,
		181,
		-1,
		-1,
		150,
		-1,
		109,
		-1,
		-1,
		-1,
		-1,
		34,
		49,
		69,
		75,
		87,
		-1,
		113,
		115,
		112,
		124,
		135,
		140,
		148,
		132,
		146,
		149,
		162,
		176,
		180,
		173,
		-1,
		99,
		-1,
		-1,
		-1,
		26,
		27,
		129,
		106,
		79,
		84,
		94,
		99,
		104,
		124,
		130,
		141,
		126,
		130,
		145,
		155,
		154,
		171,
		181,
		-1,
		-1,
		97,
		87,
		52,
		34,
		0,
		156,
		-1,
		-1,
		94,
		100,
		96,
		106,
		114,
		117,
		122,
		124,
		142,
		161,
		149,
		164,
		179,
		175,
		-1,
		-1,
		-1,
		113,
		-1,
		85,
		-1,
		-1,
		15,
		180,
		127,
		109,
		105,
		103,
		108,
		117,
		112,
		117,
		142,
		137,
		146,
		151,
		155,
		178,
		167,
		206,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		111,
		103,
		97,
		100,
		35,
		42,
		142,
		139,
		-1,
		102,
		145,
		118,
		125,
		117,
		130,
		135,
		141,
		145,
		152,
		168,
		167,
		162,
		198,
		189,
		195,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		104,
		100,
		86,
		76,
		52,
		-1,
		-1,
		119,
		116,
		125,
		112,
		118,
		123,
		119,
		157,
		133,
		141,
		145,
		149,
		155,
		160,
		165,
		171,
		186,
		201,
		-1,
		185,
		239,
		232,
		200,
		208,
		239,
		-1,
		94,
		86,
		96,
		72,
		63,
		-1,
		-1,
		92,
		94,
		99,
		108,
		111,
		143,
		142,
		153,
		155,
		160,
		148,
		147,
		165,
		169,
		178,
		185,
		175,
		188,
		192,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		91,
		-1,
		-1,
		103,
		76,
		84,
		87,
		91,
		146,
		122,
		117,
		130,
		132,
		151,
		142,
		165,
		156,
		156,
		159,
		174,
		179,
		171,
		185,
		185,
		186,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		119,
		-1,
		110,
		-1,
		103,
		107,
		130,
		133,
		155,
		142,
		149,
		163,
		171,
		154,
		164,
		160,
		161,
		170,
		181,
		193,
		192,
		193,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		103,
		142,
		157,
		-1,
		128,
		-1,
		-1,
		-1,
		117,
		143,
		135,
		151,
		154,
		154,
		149,
		153,
		159,
		166,
		176,
		178,
		170,
		174,
		187,
		198,
		201,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		118,
		109,
		136,
		164,
		153,
		148,
		135,
		-1,
		-1,
		140,
		153,
		-1,
		-1,
		161,
		170,
		153,
		155,
		159,
		169,
		184,
		187,
		177,
		175,
		169,
		201,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		121,
		137,
		150,
		154,
		170,
		195,
		-1,
		138,
		-1,
		-1,
		161,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		167,
		178,
		195,
		183,
		184,
		174,
		184,
		197,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		136,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		154,
		145,
		-1,
		-1,
		180,
		187,
		197,
		-1,
		187,
		160,
		165,
		190,
		197,
		192,
		186,
		180,
		187,
		186,
		194,
		202,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		164,
		-1,
		-1,
		187,
		194,
		186,
		174,
		164,
		174,
		182,
		182,
		185,
		183,
		178,
		189,
		181,
		185,
		202,
		-1,
		225,
		-1,
		177,
		145,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		237,
		221,
		202,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		184,
		195,
		184,
		187,
		201,
		196,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		190,
		209,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		188,
		194,
		197,
		186,
		190,
		202,
		-1,
		-1,
		170,
		173,
		178,
		-1,
		199,
		-1,
		221,
		-1,
		166,
		182,
		184,
		-1,
		-1,
		-1,
		213,
		176,
		193,
		207,
		212,
		210,
		201,
		192,
		199,
		197,
		193,
		204,
		-1,
		-1,
		-1,
		229,
		206,
		228,
		219,
		202,
		182,
		174,
		199,
		-1,
		195,
		-1,
		170,
		173,
		198,
		206,
		223,
		217,
		195,
		210,
		200,
		191,
		200,
		235,
		-1,
		210,
		256,
		220,
		188,
		188,
		187,
		216,
		-1,
		192,
		174,
		-1,
		202,
		192,
		240,
		215,
		210,
		197,
		204,
		204,
		197,
		-1,
		-1,
		-1,
		225,
		224,
		216,
		210,
		208,
		193,
		188,
		-1,
		204,
		186,
		165,
		182,
		182,
		173,
		181,
		230,
		226,
		217,
		217,
		205,
		-1,
		297,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		219,
		220,
		193,
		181,
		187,
		183,
		169,
		175,
		177,
		185,
		183,
		180,
		192,
		188,
		208,
		204,
		236,
		-1,
		304,
		-1,
		255,
		-1,
		-1,
		235,
		221,
		215,
		204,
		193,
		191,
		182,
		173,
		195,
		211,
		195,
		193,
		198,
		203,
		-1,
		314,
		315,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		239,
		200,
		-1,
		202,
		182,
		-1,
		204,
		200,
		-1,
		-1,
		303,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		234,
		218,
		-1,
		193,
		193,
		-1,
		-1,
		-1,
		288,
		279,
		-1,
		248,
		251,
		-1,
		242,
		240,
		248,
		195,
		199,
		-1,
		-1,
		-1,
		297,
		278,
		272,
		263,
		268,
		256,
		261,
		247,
		231,
		209,
		198,
		219,
		-1,
		-1,
		-1,
		269,
		261,
		254,
		-1,
		-1,
		256,
		239,
		220,
		218,
		-1,
		-1,
		-1,
		291,
		272,
		-1,
		-1,
		246,
		-1,
		-1,
		252,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		308,
		280,
		-1,
		-1,
		-1,
		242,
		238,
		239,
		-1,
		-1,
		-1,
		-1,
		302,
		303,
		326,
		290,
		-1,
		-1,
		-1,
		234,
		228,
		-1,
		-1,
		305,
		303,
		-1,
		-1,
		-1,
		262,
		246,
		-1,
		232,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		267,
		-1,
		267,
		242,
		249,
		-1,
		-1,
		-1,
		-1,
		280,
		272,
		280,
		-1,
		252,
		254,
		-1,
		302,
		-1,
		-1,
		295,
		286,
		-1,
		-1,
		257,
		264,
		286,
		289,
		325,
		-1,
		276
	],
	[
		-1,
		283,
		272,
		283,
		291,
		264,
		271,
		-1,
		290,
		294,
		260,
		254,
		293,
		262,
		268,
		279,
		-1,
		-1,
		-1,
		283,
		282,
		250,
		248,
		257,
		262,
		269,
		-1,
		268,
		-1,
		304,
		283,
		294,
		299,
		243,
		240,
		260,
		279,
		261,
		253,
		319,
		273,
		244,
		238,
		256,
		246,
		255,
		247,
		-1,
		244,
		234,
		256,
		235,
		246,
		238,
		-1,
		-1,
		238,
		239,
		245,
		231,
		237,
		233,
		-1,
		243,
		227,
		-1,
		-1,
		228,
		229,
		213,
		216,
		224,
		222,
		235,
		227,
		222,
		-1,
		-1,
		219,
		215,
		222,
		209,
		205,
		222,
		235,
		217,
		231,
		230,
		-1,
		225,
		243,
		248,
		216,
		214,
		198,
		196,
		214,
		216,
		222,
		222,
		-1,
		234,
		235,
		230,
		238,
		238,
		214,
		201,
		201,
		211,
		204,
		223,
		211,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		234,
		217,
		234,
		226,
		216,
		231,
		224,
		204,
		201,
		199,
		196,
		212,
		210,
		220,
		-1,
		-1,
		306,
		275,
		310,
		267,
		252,
		-1,
		230,
		210,
		216,
		220,
		214,
		207,
		221,
		217,
		-1,
		190,
		189,
		217,
		203,
		214,
		266,
		-1,
		-1,
		264,
		256,
		241,
		244,
		240,
		236,
		225,
		224,
		216,
		202,
		198,
		204,
		207,
		207,
		213,
		184,
		194,
		198,
		196,
		221,
		-1,
		-1,
		256,
		-1,
		-1,
		263,
		246,
		-1,
		229,
		236,
		236,
		252,
		238,
		259,
		235,
		226,
		218,
		212,
		200,
		202,
		199,
		212,
		200,
		181,
		206,
		210,
		191,
		212,
		207,
		-1,
		255,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		222,
		225,
		231,
		255,
		265,
		-1,
		247,
		235,
		236,
		221,
		218,
		205,
		193,
		206,
		191,
		198,
		197,
		185,
		183,
		213,
		188,
		210,
		207,
		226,
		231,
		225,
		234,
		-1,
		271,
		267,
		263,
		270,
		219,
		-1,
		-1,
		259,
		-1,
		273,
		272,
		247,
		232,
		235,
		222,
		213,
		200,
		189,
		200,
		189,
		186,
		194,
		177,
		192,
		183,
		182,
		200,
		210,
		218,
		222,
		228,
		-1,
		321,
		-1,
		263,
		247,
		249,
		221,
		242,
		-1,
		279,
		274,
		264,
		249,
		240,
		-1,
		231,
		228,
		218,
		196,
		181,
		198,
		190,
		188,
		190,
		172,
		186,
		177,
		195,
		202,
		200,
		204,
		224,
		236,
		281,
		271,
		-1,
		253,
		258,
		217,
		225,
		244,
		282,
		246,
		-1,
		241,
		-1,
		233,
		246,
		-1,
		202,
		198,
		180,
		181,
		176,
		191,
		183,
		168,
		165,
		183,
		186,
		193,
		197,
		213,
		-1,
		-1,
		266,
		270,
		259,
		210,
		229,
		253,
		290,
		239,
		228,
		227,
		-1,
		218,
		216,
		213,
		201,
		188,
		173,
		174,
		182,
		194,
		173,
		167,
		164,
		184,
		210,
		188,
		200,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		236,
		207,
		231,
		273,
		257,
		250,
		238,
		203,
		203,
		197,
		-1,
		212,
		191,
		182,
		171,
		169,
		182,
		174,
		182,
		162,
		160,
		179,
		191,
		182,
		193,
		-1,
		-1,
		-1,
		266,
		255,
		256,
		202,
		225,
		262,
		236,
		222,
		227,
		202,
		195,
		189,
		225,
		208,
		189,
		178,
		170,
		159,
		170,
		178,
		176,
		158,
		167,
		173,
		197,
		181,
		187,
		-1,
		-1,
		273,
		263,
		247,
		249,
		246,
		216,
		223,
		255,
		227,
		240,
		-1,
		194,
		-1,
		183,
		191,
		183,
		178,
		175,
		162,
		161,
		175,
		175,
		165,
		160,
		167,
		202,
		202,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		266,
		261,
		236,
		213,
		197,
		233,
		-1,
		210,
		211,
		-1,
		188,
		182,
		188,
		185,
		181,
		166,
		170,
		172,
		175,
		163,
		169,
		170,
		152,
		176,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		259,
		238,
		231,
		251,
		192,
		244,
		-1,
		-1,
		195,
		188,
		-1,
		175,
		175,
		178,
		170,
		164,
		171,
		166,
		157,
		170,
		163,
		157,
		151,
		164,
		168,
		172,
		161,
		157,
		154,
		168,
		-1,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		212,
		-1,
		204,
		196,
		186,
		180,
		174,
		185,
		186,
		192,
		176,
		179,
		174,
		171,
		161,
		152,
		145,
		156,
		141,
		159,
		167,
		159,
		153,
		152,
		164,
		-1,
		279,
		265,
		236,
		-1,
		-1,
		225,
		-1,
		189,
		203,
		219,
		-1,
		212,
		191,
		206,
		184,
		188,
		190,
		183,
		184,
		154,
		159,
		161,
		149,
		152,
		146,
		149,
		141,
		163,
		163,
		147,
		148,
		157,
		-1,
		285,
		272,
		230,
		226,
		215,
		235,
		186,
		174,
		206,
		-1,
		-1,
		212,
		-1,
		166,
		168,
		204,
		202,
		173,
		148,
		155,
		173,
		146,
		141,
		151,
		140,
		137,
		135,
		157,
		143,
		141,
		160,
		176,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		201,
		188,
		182,
		-1,
		223,
		-1,
		190,
		178,
		165,
		147,
		187,
		-1,
		147,
		143,
		150,
		-1,
		166,
		-1,
		138,
		141,
		132,
		129,
		129,
		140,
		138,
		149,
		166,
		-1,
		235,
		220,
		213,
		203,
		217,
		188,
		-1,
		243,
		-1,
		-1,
		177,
		171,
		171,
		140,
		137,
		163,
		143,
		135,
		150,
		149,
		136,
		135,
		123,
		123,
		126,
		132,
		145,
		165,
		156,
		167,
		-1,
		-1,
		-1,
		240,
		226,
		230,
		190,
		209,
		-1,
		-1,
		238,
		194,
		180,
		-1,
		132,
		150,
		140,
		141,
		131,
		136,
		137,
		127,
		125,
		121,
		130,
		134,
		141,
		146,
		167,
		161,
		181,
		-1,
		-1,
		223,
		228,
		216,
		202,
		221,
		-1,
		-1,
		-1,
		184,
		185,
		151,
		130,
		138,
		-1,
		-1,
		135,
		128,
		122,
		125,
		113,
		133,
		140,
		154,
		140,
		155,
		166,
		174,
		173,
		-1,
		226,
		213,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		-1,
		-1,
		163,
		108,
		97,
		92,
		94,
		134,
		-1,
		108,
		119,
		112,
		131,
		138,
		156,
		141,
		135,
		146,
		161,
		178,
		-1,
		-1,
		238,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		120,
		114,
		85,
		78,
		80,
		-1,
		110,
		112,
		109,
		121,
		132,
		137,
		145,
		129,
		143,
		146,
		159,
		173,
		177,
		261,
		-1,
		192,
		-1,
		-1,
		-1,
		138,
		153,
		27,
		52,
		76,
		81,
		91,
		96,
		101,
		121,
		127,
		138,
		123,
		127,
		142,
		152,
		151,
		168,
		178,
		-1,
		-1,
		190,
		186,
		164,
		146,
		150,
		0,
		-1,
		-1,
		75,
		85,
		93,
		103,
		111,
		114,
		119,
		121,
		139,
		158,
		146,
		161,
		176,
		172,
		-1,
		-1,
		-1,
		202,
		-1,
		197,
		-1,
		-1,
		165,
		165,
		112,
		94,
		90,
		86,
		105,
		114,
		109,
		114,
		139,
		134,
		143,
		148,
		152,
		175,
		164,
		203,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		127,
		124,
		-1,
		92,
		135,
		115,
		122,
		114,
		127,
		132,
		138,
		142,
		149,
		165,
		164,
		159,
		195,
		186,
		192,
		-1,
		-1,
		272,
		261,
		250,
		256,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		141,
		138,
		116,
		124,
		128,
		121,
		116,
		154,
		130,
		138,
		142,
		146,
		152,
		157,
		162,
		168,
		183,
		198,
		-1,
		226,
		263,
		256,
		224,
		232,
		263,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		114,
		111,
		116,
		125,
		128,
		140,
		139,
		150,
		152,
		157,
		145,
		144,
		162,
		166,
		175,
		182,
		172,
		185,
		189,
		-1,
		219,
		239,
		218,
		221,
		245,
		259,
		-1,
		161,
		-1,
		-1,
		173,
		145,
		129,
		119,
		113,
		163,
		138,
		133,
		142,
		144,
		148,
		139,
		162,
		153,
		153,
		156,
		171,
		176,
		168,
		182,
		182,
		183,
		-1,
		208,
		219,
		212,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		189,
		-1,
		156,
		-1,
		131,
		135,
		145,
		149,
		167,
		154,
		152,
		160,
		168,
		151,
		161,
		157,
		158,
		167,
		178,
		190,
		189,
		190,
		233,
		189,
		192,
		203,
		214,
		229,
		233,
		-1,
		173,
		212,
		227,
		-1,
		198,
		-1,
		-1,
		-1,
		145,
		158,
		150,
		167,
		166,
		166,
		146,
		150,
		156,
		163,
		173,
		175,
		167,
		171,
		184,
		195,
		198,
		229,
		220,
		233,
		178,
		178,
		199,
		208,
		229,
		188,
		179,
		206,
		232,
		223,
		218,
		205,
		-1,
		-1,
		168,
		168,
		-1,
		-1,
		173,
		167,
		150,
		152,
		156,
		166,
		181,
		184,
		174,
		172,
		166,
		198,
		-1,
		222,
		221,
		210,
		207,
		183,
		174,
		169,
		196,
		-1,
		-1,
		191,
		207,
		202,
		206,
		222,
		247,
		-1,
		208,
		-1,
		-1,
		189,
		-1,
		-1,
		209,
		172,
		161,
		152,
		158,
		164,
		175,
		192,
		180,
		181,
		171,
		181,
		194,
		206,
		203,
		191,
		189,
		212,
		177,
		165,
		-1,
		178,
		176,
		182,
		189,
		206,
		236,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		207,
		205,
		194,
		-1,
		184,
		157,
		162,
		187,
		194,
		189,
		183,
		177,
		184,
		183,
		191,
		199,
		215,
		229,
		218,
		214,
		213,
		221,
		170,
		163,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		-1,
		240,
		234,
		-1,
		-1,
		202,
		195,
		183,
		171,
		161,
		171,
		179,
		179,
		182,
		180,
		175,
		186,
		178,
		182,
		199,
		-1,
		249,
		-1,
		201,
		177,
		191,
		206,
		214,
		-1,
		-1,
		-1,
		257,
		243,
		236,
		224,
		222,
		-1,
		236,
		220,
		201,
		-1,
		171,
		184,
		215,
		183,
		188,
		183,
		181,
		192,
		181,
		184,
		198,
		193,
		-1,
		-1,
		189,
		192,
		-1,
		-1,
		214,
		233,
		-1,
		248,
		237,
		222,
		214,
		-1,
		-1,
		208,
		204,
		-1,
		-1,
		172,
		197,
		186,
		194,
		189,
		185,
		191,
		194,
		183,
		187,
		199,
		-1,
		-1,
		196,
		197,
		202,
		-1,
		223,
		-1,
		250,
		-1,
		217,
		223,
		211,
		-1,
		-1,
		-1,
		210,
		173,
		190,
		204,
		209,
		207,
		198,
		189,
		196,
		194,
		190,
		201,
		-1,
		-1,
		-1,
		250,
		224,
		257,
		248,
		231,
		211,
		203,
		222,
		-1,
		192,
		-1,
		167,
		170,
		195,
		203,
		220,
		214,
		192,
		207,
		197,
		188,
		197,
		256,
		-1,
		226,
		259,
		223,
		217,
		193,
		197,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		237,
		212,
		207,
		194,
		201,
		201,
		194,
		-1,
		-1,
		-1,
		228,
		227,
		219,
		213,
		213,
		198,
		189,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		227,
		223,
		214,
		214,
		202,
		-1,
		321,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		222,
		217,
		190,
		178,
		184,
		180,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		201,
		233,
		-1,
		324,
		-1,
		258,
		-1,
		-1,
		240,
		220,
		212,
		201,
		190,
		188,
		179,
		170,
		192,
		208,
		192,
		190,
		195,
		200,
		-1,
		313,
		312,
		-1,
		259,
		251,
		237,
		-1,
		230,
		-1,
		236,
		197,
		-1,
		199,
		179,
		-1,
		201,
		197,
		-1,
		-1,
		300,
		275,
		-1,
		-1,
		-1,
		260,
		240,
		231,
		215,
		-1,
		190,
		190,
		-1,
		-1,
		-1,
		285,
		284,
		-1,
		253,
		256,
		-1,
		246,
		237,
		245,
		192,
		196,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		268,
		266,
		261,
		258,
		244,
		228,
		206,
		195,
		216,
		-1,
		-1,
		-1,
		266,
		258,
		251,
		-1,
		-1,
		253,
		236,
		217,
		215,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		243,
		-1,
		-1,
		249,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		277,
		-1,
		-1,
		-1,
		239,
		235,
		236,
		-1,
		-1,
		-1,
		-1,
		299,
		300,
		323,
		287,
		-1,
		-1,
		-1,
		231,
		225,
		-1,
		-1,
		302,
		300,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		229,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		264,
		-1,
		264,
		239,
		246,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		277,
		-1,
		249,
		251,
		-1,
		299,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		254,
		261,
		283,
		286,
		322,
		-1,
		273
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		218,
		222,
		188,
		182,
		221,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		211,
		210,
		178,
		176,
		185,
		190,
		197,
		-1,
		196,
		-1,
		232,
		211,
		222,
		227,
		171,
		168,
		188,
		207,
		189,
		181,
		247,
		201,
		172,
		166,
		184,
		174,
		183,
		175,
		-1,
		172,
		162,
		184,
		163,
		174,
		166,
		-1,
		-1,
		166,
		167,
		173,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		156,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		153,
		171,
		176,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		150,
		-1,
		162,
		163,
		158,
		166,
		166,
		142,
		129,
		129,
		139,
		132,
		151,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		132,
		129,
		127,
		124,
		140,
		138,
		148,
		-1,
		-1,
		251,
		220,
		253,
		211,
		192,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		118,
		117,
		145,
		131,
		142,
		211,
		-1,
		-1,
		209,
		201,
		186,
		189,
		168,
		164,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		112,
		122,
		126,
		124,
		149,
		-1,
		-1,
		184,
		-1,
		-1,
		208,
		191,
		-1,
		174,
		181,
		174,
		180,
		166,
		187,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		109,
		134,
		138,
		119,
		140,
		135,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		167,
		170,
		176,
		200,
		203,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		113,
		111,
		141,
		116,
		138,
		135,
		154,
		159,
		153,
		162,
		-1,
		216,
		212,
		208,
		215,
		164,
		-1,
		-1,
		204,
		-1,
		211,
		212,
		187,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		105,
		120,
		111,
		110,
		128,
		138,
		146,
		150,
		156,
		-1,
		266,
		-1,
		208,
		192,
		194,
		166,
		187,
		-1,
		224,
		212,
		204,
		189,
		185,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		118,
		100,
		114,
		105,
		123,
		130,
		128,
		132,
		152,
		164,
		226,
		216,
		-1,
		198,
		203,
		162,
		170,
		189,
		227,
		191,
		-1,
		186,
		-1,
		161,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		111,
		96,
		93,
		111,
		114,
		121,
		125,
		141,
		-1,
		-1,
		211,
		215,
		204,
		155,
		174,
		198,
		235,
		184,
		173,
		172,
		-1,
		163,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		122,
		101,
		95,
		92,
		112,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		181,
		152,
		176,
		218,
		202,
		195,
		183,
		148,
		148,
		142,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		102,
		110,
		90,
		88,
		107,
		119,
		110,
		121,
		-1,
		-1,
		-1,
		211,
		200,
		201,
		147,
		170,
		207,
		181,
		167,
		172,
		147,
		140,
		134,
		153,
		136,
		117,
		106,
		98,
		87,
		98,
		106,
		104,
		86,
		95,
		101,
		125,
		109,
		115,
		-1,
		-1,
		218,
		208,
		192,
		194,
		191,
		161,
		168,
		200,
		172,
		185,
		-1,
		139,
		-1,
		128,
		126,
		111,
		106,
		103,
		90,
		89,
		103,
		103,
		93,
		88,
		95,
		130,
		130,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		211,
		206,
		181,
		158,
		142,
		178,
		-1,
		155,
		156,
		-1,
		133,
		127,
		126,
		113,
		109,
		94,
		98,
		100,
		103,
		91,
		97,
		98,
		80,
		104,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		204,
		183,
		176,
		196,
		137,
		189,
		-1,
		-1,
		140,
		133,
		-1,
		120,
		104,
		106,
		98,
		92,
		99,
		94,
		85,
		98,
		91,
		85,
		79,
		92,
		96,
		100,
		89,
		85,
		82,
		96,
		-1,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		157,
		-1,
		149,
		141,
		131,
		125,
		119,
		117,
		115,
		120,
		104,
		107,
		102,
		99,
		89,
		80,
		73,
		84,
		69,
		87,
		95,
		87,
		81,
		80,
		92,
		-1,
		224,
		210,
		181,
		-1,
		-1,
		170,
		-1,
		134,
		148,
		164,
		-1,
		157,
		136,
		151,
		129,
		127,
		118,
		111,
		112,
		82,
		87,
		89,
		77,
		80,
		74,
		77,
		69,
		91,
		91,
		75,
		76,
		85,
		-1,
		230,
		217,
		175,
		171,
		160,
		180,
		131,
		119,
		151,
		-1,
		-1,
		157,
		-1,
		111,
		113,
		132,
		130,
		101,
		76,
		83,
		101,
		74,
		69,
		79,
		68,
		65,
		63,
		85,
		71,
		69,
		88,
		104,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		146,
		133,
		127,
		-1,
		168,
		-1,
		135,
		123,
		110,
		92,
		132,
		-1,
		75,
		71,
		78,
		-1,
		94,
		-1,
		66,
		69,
		60,
		57,
		57,
		68,
		66,
		77,
		94,
		-1,
		180,
		165,
		158,
		148,
		162,
		133,
		-1,
		188,
		-1,
		-1,
		122,
		116,
		116,
		85,
		82,
		91,
		71,
		63,
		78,
		77,
		64,
		63,
		51,
		51,
		54,
		60,
		73,
		93,
		84,
		95,
		-1,
		-1,
		-1,
		185,
		171,
		175,
		135,
		154,
		-1,
		-1,
		183,
		139,
		125,
		-1,
		77,
		91,
		79,
		69,
		59,
		64,
		65,
		55,
		53,
		49,
		58,
		62,
		69,
		74,
		95,
		89,
		109,
		-1,
		-1,
		168,
		173,
		161,
		147,
		151,
		-1,
		-1,
		-1,
		129,
		130,
		96,
		75,
		80,
		-1,
		-1,
		63,
		56,
		50,
		53,
		41,
		61,
		68,
		82,
		68,
		83,
		94,
		102,
		101,
		-1,
		171,
		158,
		-1,
		-1,
		150,
		140,
		-1,
		-1,
		-1,
		-1,
		108,
		53,
		42,
		37,
		39,
		62,
		-1,
		36,
		47,
		40,
		59,
		66,
		84,
		69,
		63,
		74,
		89,
		106,
		-1,
		-1,
		164,
		-1,
		126,
		-1,
		-1,
		-1,
		-1,
		65,
		59,
		30,
		23,
		25,
		-1,
		38,
		40,
		37,
		49,
		60,
		65,
		73,
		57,
		71,
		74,
		87,
		101,
		105,
		187,
		-1,
		117,
		-1,
		-1,
		-1,
		83,
		98,
		55,
		32,
		21,
		21,
		18,
		24,
		29,
		49,
		55,
		66,
		51,
		55,
		70,
		80,
		79,
		96,
		106,
		-1,
		-1,
		115,
		111,
		109,
		91,
		95,
		82,
		-1,
		-1,
		0,
		10,
		20,
		31,
		39,
		42,
		47,
		49,
		67,
		86,
		74,
		89,
		104,
		100,
		-1,
		-1,
		-1,
		127,
		-1,
		129,
		-1,
		-1,
		110,
		90,
		37,
		19,
		15,
		11,
		33,
		42,
		37,
		42,
		67,
		62,
		71,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		106,
		98,
		93,
		99,
		101,
		92,
		52,
		49,
		-1,
		17,
		60,
		43,
		50,
		42,
		55,
		60,
		66,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		197,
		186,
		175,
		181,
		-1,
		99,
		95,
		85,
		75,
		78,
		-1,
		-1,
		66,
		63,
		41,
		52,
		56,
		49,
		44,
		82,
		58,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		151,
		188,
		181,
		149,
		157,
		188,
		-1,
		89,
		81,
		92,
		67,
		69,
		-1,
		-1,
		39,
		36,
		41,
		50,
		53,
		68,
		67,
		78,
		80,
		85,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		144,
		164,
		143,
		146,
		170,
		184,
		-1,
		86,
		-1,
		-1,
		98,
		70,
		54,
		44,
		38,
		88,
		63,
		58,
		70,
		72,
		76,
		67,
		90,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		133,
		144,
		137,
		-1,
		-1,
		-1,
		-1,
		87,
		-1,
		-1,
		114,
		-1,
		81,
		-1,
		56,
		60,
		70,
		74,
		95,
		82,
		80,
		88,
		96,
		79,
		89,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		158,
		114,
		117,
		128,
		139,
		154,
		158,
		-1,
		98,
		137,
		152,
		-1,
		123,
		-1,
		-1,
		-1,
		70,
		83,
		75,
		92,
		94,
		94,
		74,
		78,
		84,
		91,
		101,
		103,
		95,
		99,
		112,
		123,
		126,
		154,
		145,
		158,
		103,
		103,
		124,
		133,
		154,
		113,
		104,
		131,
		157,
		148,
		143,
		130,
		-1,
		-1,
		93,
		93,
		-1,
		-1,
		101,
		95,
		78,
		80,
		84,
		94,
		109,
		112,
		102,
		100,
		94,
		126,
		-1,
		147,
		146,
		135,
		132,
		108,
		99,
		94,
		121,
		-1,
		-1,
		116,
		132,
		127,
		131,
		147,
		172,
		-1,
		133,
		-1,
		-1,
		114,
		-1,
		-1,
		137,
		100,
		89,
		80,
		86,
		92,
		103,
		120,
		108,
		109,
		99,
		109,
		122,
		131,
		128,
		116,
		114,
		137,
		102,
		90,
		-1,
		103,
		101,
		107,
		114,
		131,
		161,
		-1,
		-1,
		149,
		140,
		-1,
		-1,
		133,
		133,
		122,
		-1,
		112,
		85,
		90,
		115,
		122,
		117,
		111,
		105,
		112,
		111,
		119,
		127,
		140,
		154,
		143,
		139,
		138,
		146,
		95,
		88,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		159,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		99,
		107,
		107,
		110,
		108,
		103,
		114,
		106,
		110,
		127,
		-1,
		174,
		-1,
		126,
		102,
		116,
		131,
		139,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		143,
		111,
		116,
		111,
		109,
		120,
		109,
		112,
		126,
		121,
		-1,
		-1,
		114,
		117,
		-1,
		-1,
		139,
		158,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		125,
		114,
		122,
		117,
		113,
		119,
		122,
		111,
		115,
		127,
		-1,
		-1,
		121,
		122,
		127,
		-1,
		148,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		138,
		101,
		118,
		132,
		137,
		135,
		126,
		117,
		124,
		122,
		118,
		129,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		98,
		123,
		131,
		148,
		142,
		120,
		135,
		125,
		116,
		125,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		117,
		165,
		140,
		135,
		122,
		129,
		129,
		122,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		155,
		151,
		142,
		142,
		130,
		-1,
		246,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		117,
		113,
		133,
		129,
		161,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		120,
		118,
		123,
		128,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		129,
		125,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		201,
		190,
		201,
		209,
		182,
		189,
		-1,
		208,
		212,
		178,
		172,
		211,
		180,
		186,
		197,
		-1,
		-1,
		-1,
		201,
		200,
		168,
		166,
		175,
		180,
		187,
		-1,
		186,
		-1,
		222,
		201,
		212,
		217,
		161,
		158,
		178,
		197,
		179,
		171,
		237,
		191,
		162,
		156,
		174,
		164,
		173,
		165,
		-1,
		162,
		152,
		174,
		153,
		164,
		156,
		-1,
		-1,
		156,
		157,
		163,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		146,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		143,
		161,
		166,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		140,
		-1,
		152,
		153,
		148,
		156,
		156,
		132,
		119,
		119,
		129,
		122,
		141,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		122,
		119,
		117,
		114,
		130,
		128,
		138,
		-1,
		-1,
		243,
		212,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		108,
		107,
		135,
		121,
		132,
		203,
		-1,
		-1,
		201,
		193,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		102,
		112,
		116,
		114,
		139,
		-1,
		-1,
		174,
		-1,
		-1,
		200,
		183,
		-1,
		166,
		173,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		99,
		124,
		128,
		109,
		130,
		125,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		159,
		162,
		168,
		192,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		103,
		101,
		131,
		106,
		128,
		125,
		144,
		149,
		143,
		152,
		-1,
		208,
		204,
		200,
		207,
		156,
		-1,
		-1,
		196,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		95,
		110,
		101,
		100,
		118,
		128,
		136,
		140,
		146,
		-1,
		258,
		-1,
		200,
		184,
		186,
		158,
		179,
		-1,
		216,
		202,
		194,
		179,
		177,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		108,
		90,
		104,
		95,
		113,
		120,
		118,
		122,
		142,
		154,
		218,
		208,
		-1,
		190,
		195,
		154,
		162,
		181,
		219,
		183,
		-1,
		178,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		101,
		86,
		83,
		101,
		104,
		111,
		115,
		131,
		-1,
		-1,
		203,
		207,
		196,
		147,
		166,
		190,
		227,
		176,
		165,
		164,
		-1,
		155,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		112,
		91,
		85,
		82,
		102,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		173,
		144,
		168,
		210,
		194,
		187,
		175,
		140,
		140,
		134,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		92,
		100,
		80,
		78,
		97,
		109,
		100,
		111,
		-1,
		-1,
		-1,
		203,
		192,
		193,
		139,
		162,
		199,
		173,
		159,
		164,
		139,
		132,
		126,
		143,
		126,
		107,
		96,
		88,
		77,
		88,
		96,
		94,
		76,
		85,
		91,
		115,
		99,
		105,
		-1,
		-1,
		210,
		200,
		184,
		186,
		183,
		153,
		160,
		192,
		164,
		177,
		-1,
		131,
		-1,
		120,
		116,
		101,
		96,
		93,
		80,
		79,
		93,
		93,
		83,
		78,
		85,
		120,
		120,
		89,
		109,
		112,
		-1,
		-1,
		-1,
		203,
		198,
		173,
		150,
		134,
		170,
		-1,
		147,
		148,
		-1,
		125,
		119,
		116,
		103,
		99,
		84,
		88,
		90,
		93,
		81,
		87,
		88,
		70,
		94,
		-1,
		97,
		91,
		99,
		89,
		77,
		-1,
		-1,
		-1,
		196,
		175,
		168,
		188,
		129,
		181,
		-1,
		-1,
		132,
		125,
		-1,
		112,
		94,
		96,
		88,
		82,
		89,
		84,
		75,
		88,
		81,
		75,
		69,
		82,
		86,
		90,
		79,
		75,
		72,
		86,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		149,
		-1,
		141,
		133,
		123,
		117,
		111,
		107,
		105,
		110,
		94,
		97,
		92,
		89,
		79,
		70,
		63,
		74,
		59,
		77,
		85,
		77,
		71,
		70,
		82,
		-1,
		216,
		202,
		173,
		-1,
		-1,
		162,
		-1,
		126,
		140,
		156,
		-1,
		149,
		128,
		143,
		121,
		117,
		108,
		101,
		102,
		72,
		77,
		79,
		67,
		70,
		64,
		67,
		59,
		81,
		81,
		65,
		66,
		75,
		-1,
		222,
		209,
		167,
		163,
		152,
		172,
		123,
		111,
		143,
		-1,
		-1,
		156,
		-1,
		110,
		112,
		122,
		120,
		91,
		66,
		73,
		91,
		64,
		59,
		69,
		58,
		55,
		53,
		75,
		61,
		59,
		78,
		94,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		138,
		125,
		119,
		-1,
		160,
		-1,
		134,
		122,
		109,
		91,
		131,
		-1,
		65,
		61,
		68,
		-1,
		84,
		-1,
		56,
		59,
		50,
		47,
		47,
		58,
		56,
		67,
		84,
		-1,
		172,
		157,
		150,
		140,
		154,
		125,
		-1,
		180,
		-1,
		-1,
		121,
		115,
		115,
		84,
		81,
		81,
		61,
		53,
		68,
		67,
		54,
		53,
		41,
		41,
		44,
		50,
		63,
		83,
		74,
		85,
		-1,
		-1,
		-1,
		177,
		163,
		167,
		127,
		146,
		-1,
		-1,
		182,
		138,
		124,
		-1,
		76,
		81,
		69,
		59,
		49,
		54,
		55,
		45,
		43,
		39,
		48,
		52,
		59,
		64,
		85,
		79,
		99,
		-1,
		-1,
		160,
		165,
		153,
		139,
		143,
		-1,
		-1,
		-1,
		128,
		129,
		95,
		74,
		70,
		-1,
		-1,
		53,
		46,
		40,
		43,
		31,
		51,
		58,
		72,
		58,
		73,
		84,
		92,
		91,
		-1,
		163,
		150,
		-1,
		-1,
		142,
		132,
		-1,
		-1,
		-1,
		-1,
		107,
		52,
		41,
		36,
		40,
		52,
		-1,
		26,
		37,
		30,
		49,
		56,
		74,
		59,
		53,
		64,
		79,
		96,
		-1,
		-1,
		156,
		-1,
		118,
		-1,
		-1,
		-1,
		-1,
		64,
		58,
		29,
		22,
		26,
		-1,
		28,
		30,
		27,
		39,
		50,
		55,
		63,
		47,
		61,
		64,
		77,
		91,
		95,
		179,
		-1,
		109,
		-1,
		-1,
		-1,
		82,
		97,
		64,
		41,
		18,
		11,
		8,
		14,
		19,
		39,
		45,
		56,
		41,
		45,
		60,
		70,
		69,
		86,
		96,
		-1,
		-1,
		107,
		103,
		108,
		90,
		94,
		91,
		-1,
		-1,
		9,
		0,
		10,
		21,
		29,
		32,
		37,
		39,
		57,
		76,
		64,
		79,
		94,
		90,
		-1,
		-1,
		-1,
		119,
		-1,
		121,
		-1,
		-1,
		109,
		80,
		27,
		9,
		5,
		3,
		23,
		32,
		27,
		32,
		57,
		52,
		61,
		66,
		70,
		93,
		82,
		121,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		98,
		90,
		85,
		91,
		93,
		84,
		42,
		39,
		-1,
		9,
		52,
		33,
		40,
		32,
		45,
		50,
		56,
		60,
		67,
		83,
		82,
		77,
		113,
		104,
		110,
		-1,
		-1,
		189,
		178,
		167,
		173,
		-1,
		91,
		87,
		77,
		67,
		70,
		-1,
		-1,
		58,
		55,
		33,
		42,
		46,
		39,
		34,
		72,
		48,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		116,
		-1,
		143,
		180,
		173,
		141,
		149,
		180,
		-1,
		81,
		73,
		84,
		59,
		61,
		-1,
		-1,
		31,
		28,
		33,
		42,
		45,
		58,
		57,
		68,
		70,
		75,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		136,
		156,
		135,
		138,
		162,
		176,
		-1,
		78,
		-1,
		-1,
		90,
		62,
		46,
		36,
		30,
		80,
		55,
		50,
		60,
		62,
		66,
		57,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		125,
		136,
		129,
		-1,
		-1,
		-1,
		-1,
		79,
		-1,
		-1,
		106,
		-1,
		73,
		-1,
		48,
		52,
		62,
		66,
		85,
		72,
		70,
		78,
		86,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		150,
		106,
		109,
		120,
		131,
		146,
		150,
		-1,
		90,
		129,
		144,
		-1,
		115,
		-1,
		-1,
		-1,
		62,
		75,
		67,
		84,
		84,
		84,
		64,
		68,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		146,
		137,
		150,
		95,
		95,
		116,
		125,
		146,
		105,
		96,
		123,
		149,
		140,
		135,
		122,
		-1,
		-1,
		85,
		85,
		-1,
		-1,
		91,
		85,
		68,
		70,
		74,
		84,
		99,
		102,
		92,
		90,
		84,
		116,
		-1,
		139,
		138,
		127,
		124,
		100,
		91,
		86,
		113,
		-1,
		-1,
		108,
		124,
		119,
		123,
		139,
		164,
		-1,
		125,
		-1,
		-1,
		106,
		-1,
		-1,
		127,
		90,
		79,
		70,
		76,
		82,
		93,
		110,
		98,
		99,
		89,
		99,
		112,
		123,
		120,
		108,
		106,
		129,
		94,
		82,
		-1,
		95,
		93,
		99,
		106,
		123,
		153,
		-1,
		-1,
		141,
		132,
		-1,
		-1,
		125,
		123,
		112,
		-1,
		102,
		75,
		80,
		105,
		112,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		132,
		146,
		135,
		131,
		130,
		138,
		87,
		80,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		151,
		-1,
		-1,
		120,
		113,
		101,
		89,
		79,
		89,
		97,
		97,
		100,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		166,
		-1,
		118,
		94,
		108,
		123,
		131,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		154,
		138,
		119,
		-1,
		89,
		102,
		133,
		101,
		106,
		101,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		106,
		109,
		-1,
		-1,
		131,
		150,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		126,
		122,
		-1,
		-1,
		90,
		115,
		104,
		112,
		107,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		113,
		114,
		119,
		-1,
		140,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		128,
		91,
		108,
		122,
		127,
		125,
		116,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		88,
		113,
		121,
		138,
		132,
		110,
		125,
		115,
		106,
		115,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		107,
		155,
		130,
		125,
		112,
		119,
		119,
		112,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		96,
		145,
		141,
		132,
		132,
		120,
		-1,
		238,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		110,
		108,
		113,
		118,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		119,
		115,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		195,
		184,
		195,
		203,
		176,
		183,
		-1,
		202,
		206,
		172,
		166,
		205,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		195,
		194,
		162,
		160,
		169,
		174,
		181,
		-1,
		180,
		-1,
		216,
		195,
		206,
		211,
		155,
		152,
		172,
		191,
		173,
		165,
		231,
		185,
		156,
		150,
		168,
		158,
		167,
		159,
		-1,
		156,
		146,
		168,
		147,
		158,
		150,
		-1,
		-1,
		150,
		151,
		157,
		143,
		149,
		145,
		-1,
		155,
		139,
		-1,
		-1,
		140,
		141,
		125,
		128,
		136,
		134,
		147,
		139,
		134,
		-1,
		-1,
		131,
		127,
		134,
		121,
		117,
		134,
		147,
		129,
		143,
		142,
		-1,
		137,
		155,
		160,
		128,
		126,
		110,
		108,
		126,
		128,
		134,
		134,
		-1,
		146,
		147,
		142,
		150,
		150,
		126,
		113,
		113,
		123,
		116,
		135,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		146,
		129,
		146,
		138,
		128,
		143,
		136,
		116,
		113,
		111,
		108,
		124,
		122,
		132,
		-1,
		-1,
		237,
		206,
		237,
		195,
		176,
		-1,
		142,
		122,
		128,
		132,
		126,
		119,
		133,
		129,
		-1,
		102,
		101,
		129,
		115,
		126,
		197,
		-1,
		-1,
		195,
		187,
		172,
		175,
		152,
		148,
		137,
		136,
		128,
		114,
		110,
		116,
		119,
		119,
		125,
		96,
		106,
		110,
		108,
		133,
		-1,
		-1,
		168,
		-1,
		-1,
		194,
		177,
		-1,
		160,
		167,
		158,
		164,
		150,
		171,
		147,
		138,
		130,
		124,
		112,
		114,
		111,
		124,
		112,
		93,
		118,
		122,
		103,
		124,
		119,
		-1,
		167,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		153,
		156,
		162,
		186,
		187,
		-1,
		159,
		147,
		148,
		133,
		130,
		117,
		105,
		118,
		103,
		110,
		109,
		97,
		95,
		125,
		100,
		122,
		119,
		138,
		143,
		137,
		146,
		-1,
		202,
		198,
		194,
		201,
		150,
		-1,
		-1,
		190,
		-1,
		195,
		196,
		171,
		144,
		147,
		134,
		125,
		112,
		101,
		112,
		101,
		98,
		106,
		89,
		104,
		95,
		94,
		112,
		122,
		130,
		134,
		140,
		-1,
		252,
		-1,
		194,
		178,
		180,
		152,
		173,
		-1,
		210,
		196,
		188,
		173,
		171,
		-1,
		143,
		140,
		130,
		108,
		93,
		110,
		102,
		100,
		102,
		84,
		98,
		89,
		107,
		114,
		112,
		116,
		136,
		148,
		212,
		202,
		-1,
		184,
		189,
		148,
		156,
		175,
		213,
		177,
		-1,
		172,
		-1,
		145,
		158,
		-1,
		114,
		110,
		92,
		93,
		88,
		103,
		95,
		80,
		77,
		95,
		98,
		105,
		109,
		125,
		-1,
		-1,
		197,
		201,
		190,
		141,
		160,
		184,
		221,
		170,
		159,
		158,
		-1,
		149,
		128,
		125,
		113,
		100,
		85,
		86,
		94,
		106,
		85,
		79,
		76,
		96,
		122,
		100,
		112,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		167,
		138,
		162,
		204,
		188,
		181,
		169,
		134,
		134,
		128,
		-1,
		124,
		103,
		94,
		83,
		81,
		94,
		86,
		94,
		74,
		72,
		91,
		103,
		94,
		105,
		-1,
		-1,
		-1,
		197,
		186,
		187,
		133,
		156,
		193,
		167,
		153,
		158,
		133,
		126,
		120,
		137,
		120,
		101,
		90,
		82,
		71,
		82,
		90,
		88,
		70,
		79,
		85,
		109,
		93,
		99,
		-1,
		-1,
		204,
		194,
		178,
		180,
		177,
		147,
		154,
		186,
		158,
		171,
		-1,
		125,
		-1,
		114,
		110,
		95,
		90,
		87,
		74,
		73,
		87,
		87,
		77,
		72,
		79,
		114,
		114,
		83,
		103,
		106,
		-1,
		-1,
		-1,
		197,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		119,
		113,
		110,
		97,
		93,
		78,
		82,
		84,
		87,
		75,
		81,
		82,
		64,
		88,
		-1,
		91,
		85,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		90,
		82,
		76,
		83,
		78,
		69,
		82,
		75,
		69,
		63,
		76,
		80,
		84,
		73,
		69,
		66,
		80,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		101,
		99,
		104,
		88,
		91,
		86,
		83,
		73,
		64,
		57,
		68,
		53,
		71,
		79,
		71,
		65,
		64,
		76,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		111,
		102,
		95,
		96,
		66,
		71,
		73,
		61,
		64,
		58,
		61,
		53,
		75,
		75,
		59,
		60,
		69,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		156,
		-1,
		110,
		112,
		116,
		114,
		85,
		60,
		67,
		85,
		58,
		53,
		63,
		52,
		49,
		47,
		69,
		55,
		53,
		72,
		88,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		134,
		122,
		109,
		91,
		131,
		-1,
		59,
		55,
		62,
		-1,
		78,
		-1,
		50,
		53,
		44,
		41,
		41,
		52,
		50,
		61,
		78,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		121,
		115,
		115,
		84,
		81,
		75,
		55,
		47,
		62,
		61,
		48,
		47,
		35,
		35,
		38,
		44,
		57,
		77,
		68,
		79,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		182,
		138,
		124,
		-1,
		76,
		75,
		63,
		53,
		43,
		48,
		49,
		39,
		37,
		33,
		42,
		46,
		53,
		58,
		79,
		73,
		93,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		128,
		129,
		95,
		74,
		64,
		-1,
		-1,
		47,
		40,
		34,
		37,
		25,
		45,
		52,
		66,
		52,
		67,
		78,
		86,
		85,
		-1,
		157,
		144,
		-1,
		-1,
		155,
		146,
		-1,
		-1,
		-1,
		-1,
		107,
		52,
		41,
		36,
		40,
		46,
		-1,
		20,
		31,
		24,
		43,
		50,
		68,
		53,
		47,
		58,
		73,
		90,
		-1,
		-1,
		169,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		64,
		58,
		29,
		22,
		26,
		-1,
		22,
		24,
		21,
		33,
		44,
		49,
		57,
		41,
		55,
		58,
		71,
		85,
		89,
		192,
		-1,
		123,
		-1,
		-1,
		-1,
		82,
		97,
		68,
		45,
		18,
		11,
		8,
		8,
		13,
		33,
		39,
		50,
		35,
		39,
		54,
		64,
		63,
		80,
		90,
		-1,
		-1,
		121,
		117,
		108,
		90,
		94,
		95,
		-1,
		-1,
		22,
		14,
		0,
		15,
		23,
		26,
		31,
		33,
		51,
		70,
		58,
		73,
		88,
		84,
		-1,
		-1,
		-1,
		133,
		-1,
		135,
		-1,
		-1,
		109,
		94,
		41,
		23,
		19,
		17,
		17,
		26,
		21,
		26,
		51,
		46,
		55,
		60,
		64,
		87,
		76,
		115,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		112,
		104,
		99,
		105,
		107,
		98,
		56,
		53,
		-1,
		23,
		55,
		27,
		34,
		26,
		39,
		44,
		50,
		54,
		61,
		77,
		76,
		71,
		107,
		98,
		104,
		-1,
		-1,
		203,
		192,
		181,
		187,
		-1,
		105,
		101,
		91,
		81,
		84,
		-1,
		-1,
		72,
		69,
		47,
		36,
		40,
		33,
		28,
		66,
		42,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		95,
		110,
		-1,
		157,
		194,
		187,
		155,
		163,
		194,
		-1,
		95,
		87,
		98,
		73,
		75,
		-1,
		-1,
		45,
		42,
		47,
		43,
		40,
		52,
		51,
		62,
		64,
		69,
		57,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		150,
		170,
		149,
		152,
		176,
		190,
		-1,
		92,
		-1,
		-1,
		104,
		76,
		60,
		50,
		44,
		94,
		57,
		52,
		54,
		56,
		60,
		51,
		74,
		65,
		65,
		68,
		83,
		88,
		80,
		94,
		94,
		95,
		-1,
		139,
		150,
		143,
		-1,
		-1,
		-1,
		-1,
		93,
		-1,
		-1,
		120,
		-1,
		87,
		-1,
		62,
		66,
		65,
		68,
		79,
		66,
		64,
		72,
		80,
		63,
		73,
		69,
		70,
		79,
		90,
		102,
		101,
		102,
		164,
		120,
		123,
		134,
		145,
		160,
		164,
		-1,
		104,
		143,
		158,
		-1,
		129,
		-1,
		-1,
		-1,
		76,
		78,
		70,
		86,
		78,
		78,
		58,
		62,
		68,
		75,
		85,
		87,
		79,
		83,
		96,
		107,
		110,
		160,
		151,
		164,
		109,
		109,
		130,
		139,
		160,
		119,
		110,
		137,
		163,
		154,
		149,
		136,
		-1,
		-1,
		99,
		88,
		-1,
		-1,
		85,
		79,
		62,
		64,
		68,
		78,
		93,
		96,
		86,
		84,
		78,
		110,
		-1,
		153,
		152,
		141,
		138,
		114,
		105,
		100,
		127,
		-1,
		-1,
		122,
		138,
		133,
		137,
		153,
		178,
		-1,
		139,
		-1,
		-1,
		120,
		-1,
		-1,
		121,
		84,
		73,
		64,
		70,
		76,
		87,
		104,
		92,
		93,
		83,
		93,
		106,
		137,
		134,
		122,
		120,
		143,
		108,
		96,
		-1,
		109,
		107,
		113,
		120,
		137,
		167,
		-1,
		-1,
		155,
		142,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		69,
		74,
		99,
		106,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		146,
		160,
		149,
		145,
		144,
		152,
		101,
		94,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		83,
		91,
		91,
		94,
		92,
		87,
		98,
		90,
		94,
		111,
		-1,
		180,
		-1,
		132,
		108,
		122,
		137,
		145,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		127,
		95,
		100,
		95,
		93,
		104,
		93,
		96,
		110,
		105,
		-1,
		-1,
		120,
		123,
		-1,
		-1,
		145,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		109,
		98,
		106,
		101,
		97,
		103,
		106,
		95,
		99,
		111,
		-1,
		-1,
		127,
		128,
		133,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		122,
		85,
		102,
		116,
		121,
		119,
		110,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		82,
		107,
		115,
		132,
		126,
		104,
		119,
		109,
		100,
		109,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		111,
		101,
		149,
		124,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		91,
		82,
		90,
		139,
		135,
		126,
		126,
		114,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		94,
		92,
		89,
		101,
		97,
		117,
		113,
		145,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		120,
		104,
		102,
		107,
		112,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		113,
		109,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		140,
		158,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		149,
		150,
		145,
		153,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		132,
		149,
		141,
		131,
		146,
		139,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		240,
		209,
		240,
		198,
		179,
		-1,
		145,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		105,
		104,
		132,
		118,
		129,
		200,
		-1,
		-1,
		198,
		190,
		175,
		178,
		155,
		151,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		99,
		109,
		113,
		111,
		136,
		-1,
		-1,
		171,
		-1,
		-1,
		197,
		180,
		-1,
		163,
		170,
		161,
		167,
		153,
		174,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		96,
		121,
		125,
		106,
		127,
		122,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		156,
		159,
		165,
		189,
		190,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		100,
		98,
		128,
		103,
		125,
		122,
		141,
		146,
		140,
		149,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		193,
		-1,
		198,
		199,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		92,
		107,
		98,
		97,
		115,
		125,
		133,
		137,
		143,
		-1,
		255,
		-1,
		197,
		181,
		183,
		155,
		176,
		-1,
		213,
		199,
		191,
		176,
		174,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		105,
		103,
		105,
		87,
		101,
		92,
		110,
		117,
		115,
		119,
		139,
		151,
		215,
		205,
		-1,
		187,
		192,
		151,
		159,
		178,
		216,
		180,
		-1,
		175,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		98,
		83,
		80,
		98,
		101,
		108,
		112,
		128,
		-1,
		-1,
		200,
		204,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		109,
		88,
		82,
		79,
		99,
		125,
		103,
		115,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		89,
		97,
		77,
		75,
		94,
		106,
		97,
		108,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		140,
		123,
		104,
		93,
		85,
		74,
		85,
		93,
		91,
		73,
		82,
		88,
		112,
		96,
		102,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		113,
		98,
		93,
		90,
		77,
		76,
		90,
		90,
		80,
		75,
		82,
		117,
		117,
		86,
		106,
		109,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		100,
		96,
		81,
		85,
		87,
		90,
		78,
		84,
		85,
		67,
		91,
		-1,
		94,
		88,
		96,
		86,
		74,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		93,
		85,
		79,
		86,
		81,
		72,
		85,
		78,
		72,
		66,
		79,
		83,
		87,
		76,
		72,
		69,
		83,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		107,
		91,
		94,
		89,
		86,
		76,
		67,
		60,
		71,
		56,
		74,
		82,
		74,
		68,
		67,
		79,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		105,
		98,
		99,
		69,
		74,
		76,
		64,
		67,
		61,
		64,
		56,
		78,
		78,
		62,
		63,
		72,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		167,
		-1,
		116,
		123,
		119,
		117,
		88,
		63,
		70,
		88,
		61,
		56,
		66,
		55,
		52,
		50,
		72,
		58,
		56,
		74,
		90,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		145,
		133,
		120,
		102,
		142,
		-1,
		62,
		58,
		65,
		-1,
		81,
		-1,
		53,
		56,
		47,
		44,
		44,
		55,
		53,
		64,
		69,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		132,
		126,
		126,
		95,
		92,
		78,
		58,
		50,
		65,
		64,
		51,
		50,
		38,
		38,
		41,
		46,
		59,
		69,
		71,
		67,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		193,
		149,
		135,
		-1,
		87,
		78,
		66,
		56,
		46,
		51,
		52,
		42,
		40,
		36,
		45,
		49,
		48,
		47,
		68,
		61,
		83,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		139,
		140,
		106,
		85,
		67,
		-1,
		-1,
		50,
		43,
		37,
		39,
		28,
		48,
		55,
		54,
		41,
		56,
		66,
		74,
		73,
		-1,
		160,
		147,
		-1,
		-1,
		156,
		146,
		-1,
		-1,
		-1,
		-1,
		118,
		63,
		52,
		47,
		51,
		49,
		-1,
		23,
		30,
		27,
		46,
		53,
		56,
		41,
		35,
		46,
		61,
		78,
		-1,
		-1,
		170,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		75,
		69,
		40,
		33,
		37,
		-1,
		21,
		23,
		24,
		33,
		40,
		45,
		47,
		29,
		43,
		46,
		59,
		73,
		77,
		193,
		-1,
		123,
		-1,
		-1,
		-1,
		93,
		108,
		79,
		56,
		29,
		24,
		17,
		11,
		16,
		27,
		35,
		46,
		23,
		27,
		42,
		52,
		51,
		68,
		78,
		-1,
		-1,
		121,
		117,
		119,
		101,
		105,
		106,
		-1,
		-1,
		33,
		24,
		15,
		0,
		19,
		22,
		19,
		21,
		39,
		58,
		46,
		61,
		76,
		74,
		-1,
		-1,
		-1,
		133,
		-1,
		135,
		-1,
		-1,
		120,
		104,
		51,
		33,
		29,
		27,
		18,
		21,
		9,
		14,
		39,
		36,
		45,
		48,
		54,
		77,
		66,
		105,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		112,
		104,
		99,
		105,
		107,
		98,
		66,
		63,
		-1,
		33,
		50,
		15,
		22,
		14,
		29,
		34,
		40,
		44,
		51,
		67,
		66,
		61,
		97,
		88,
		94,
		-1,
		-1,
		198,
		187,
		176,
		182,
		-1,
		105,
		101,
		91,
		81,
		84,
		-1,
		-1,
		78,
		75,
		47,
		24,
		30,
		23,
		18,
		56,
		32,
		40,
		44,
		48,
		54,
		59,
		64,
		70,
		85,
		100,
		-1,
		152,
		189,
		182,
		150,
		158,
		189,
		-1,
		95,
		87,
		98,
		73,
		75,
		-1,
		-1,
		51,
		42,
		43,
		31,
		28,
		41,
		40,
		52,
		54,
		59,
		47,
		46,
		64,
		68,
		77,
		84,
		74,
		87,
		91,
		-1,
		145,
		165,
		144,
		147,
		171,
		185,
		-1,
		92,
		-1,
		-1,
		104,
		76,
		60,
		50,
		47,
		90,
		45,
		40,
		42,
		44,
		50,
		41,
		64,
		55,
		55,
		58,
		73,
		78,
		70,
		84,
		84,
		85,
		-1,
		134,
		145,
		138,
		-1,
		-1,
		-1,
		-1,
		93,
		-1,
		-1,
		120,
		-1,
		87,
		-1,
		69,
		73,
		53,
		56,
		67,
		54,
		54,
		62,
		70,
		53,
		63,
		59,
		60,
		69,
		80,
		92,
		91,
		92,
		159,
		115,
		118,
		129,
		140,
		155,
		159,
		-1,
		104,
		143,
		158,
		-1,
		129,
		-1,
		-1,
		-1,
		83,
		66,
		58,
		74,
		66,
		66,
		48,
		52,
		58,
		65,
		75,
		77,
		69,
		73,
		86,
		97,
		100,
		155,
		146,
		159,
		104,
		104,
		125,
		134,
		155,
		119,
		110,
		137,
		158,
		154,
		149,
		136,
		-1,
		-1,
		106,
		76,
		-1,
		-1,
		73,
		69,
		52,
		54,
		58,
		68,
		83,
		86,
		76,
		74,
		68,
		100,
		-1,
		148,
		147,
		136,
		133,
		109,
		100,
		95,
		122,
		-1,
		-1,
		117,
		138,
		128,
		132,
		148,
		173,
		-1,
		136,
		-1,
		-1,
		126,
		-1,
		-1,
		111,
		74,
		63,
		54,
		60,
		66,
		77,
		94,
		82,
		83,
		73,
		83,
		96,
		132,
		129,
		117,
		115,
		138,
		103,
		91,
		-1,
		104,
		102,
		108,
		115,
		132,
		162,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		59,
		64,
		89,
		96,
		91,
		85,
		79,
		86,
		85,
		93,
		101,
		141,
		155,
		144,
		140,
		139,
		147,
		96,
		89,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		73,
		81,
		81,
		84,
		82,
		77,
		88,
		80,
		84,
		101,
		-1,
		175,
		-1,
		127,
		103,
		117,
		132,
		140,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		117,
		85,
		90,
		85,
		83,
		94,
		83,
		86,
		100,
		95,
		-1,
		-1,
		115,
		118,
		-1,
		-1,
		140,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		74,
		99,
		88,
		96,
		91,
		87,
		93,
		96,
		85,
		89,
		101,
		-1,
		-1,
		122,
		123,
		128,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		112,
		75,
		92,
		106,
		111,
		109,
		100,
		91,
		98,
		96,
		92,
		103,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		94,
		-1,
		69,
		72,
		97,
		105,
		122,
		116,
		94,
		109,
		99,
		90,
		99,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		91,
		73,
		-1,
		101,
		91,
		139,
		114,
		109,
		96,
		103,
		103,
		96,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		81,
		81,
		72,
		80,
		129,
		125,
		116,
		116,
		104,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		76,
		84,
		82,
		79,
		91,
		87,
		107,
		103,
		135,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		110,
		94,
		92,
		97,
		102,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		103,
		99,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		200,
		204,
		170,
		164,
		203,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		193,
		192,
		160,
		158,
		167,
		172,
		179,
		-1,
		178,
		-1,
		214,
		193,
		204,
		209,
		153,
		150,
		170,
		189,
		171,
		163,
		229,
		183,
		154,
		148,
		166,
		156,
		165,
		157,
		-1,
		154,
		144,
		166,
		145,
		156,
		148,
		-1,
		-1,
		148,
		149,
		155,
		141,
		147,
		143,
		-1,
		153,
		137,
		-1,
		-1,
		138,
		139,
		123,
		126,
		134,
		132,
		145,
		137,
		132,
		-1,
		-1,
		129,
		125,
		132,
		119,
		115,
		132,
		145,
		127,
		141,
		140,
		-1,
		135,
		153,
		158,
		126,
		124,
		108,
		106,
		124,
		126,
		132,
		132,
		-1,
		144,
		145,
		140,
		148,
		148,
		124,
		111,
		111,
		121,
		114,
		133,
		121,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		127,
		144,
		136,
		126,
		141,
		134,
		114,
		111,
		109,
		106,
		122,
		120,
		130,
		-1,
		-1,
		235,
		204,
		235,
		193,
		174,
		-1,
		140,
		120,
		126,
		130,
		124,
		117,
		131,
		127,
		-1,
		100,
		99,
		127,
		113,
		124,
		195,
		-1,
		-1,
		193,
		185,
		170,
		173,
		150,
		146,
		135,
		134,
		126,
		112,
		108,
		114,
		117,
		117,
		123,
		94,
		104,
		108,
		106,
		131,
		-1,
		-1,
		166,
		-1,
		-1,
		192,
		175,
		-1,
		158,
		165,
		156,
		162,
		148,
		169,
		145,
		136,
		128,
		122,
		110,
		112,
		109,
		122,
		110,
		91,
		116,
		120,
		101,
		122,
		117,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		151,
		154,
		160,
		184,
		185,
		-1,
		157,
		145,
		146,
		131,
		128,
		115,
		103,
		116,
		101,
		108,
		107,
		95,
		93,
		123,
		98,
		120,
		117,
		136,
		141,
		135,
		144,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		188,
		-1,
		193,
		194,
		169,
		142,
		145,
		132,
		123,
		110,
		99,
		110,
		99,
		96,
		104,
		87,
		102,
		93,
		92,
		110,
		120,
		128,
		132,
		138,
		-1,
		250,
		-1,
		192,
		176,
		178,
		150,
		171,
		-1,
		208,
		194,
		186,
		171,
		169,
		-1,
		141,
		138,
		128,
		106,
		91,
		108,
		100,
		98,
		100,
		82,
		96,
		87,
		105,
		112,
		110,
		114,
		134,
		146,
		210,
		200,
		-1,
		182,
		187,
		146,
		154,
		173,
		211,
		175,
		-1,
		170,
		-1,
		143,
		156,
		-1,
		112,
		108,
		90,
		91,
		86,
		101,
		93,
		78,
		75,
		93,
		96,
		103,
		107,
		123,
		-1,
		-1,
		195,
		199,
		188,
		139,
		158,
		182,
		219,
		168,
		157,
		156,
		-1,
		147,
		126,
		123,
		111,
		98,
		83,
		84,
		92,
		104,
		83,
		77,
		74,
		94,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		165,
		136,
		160,
		202,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		122,
		101,
		92,
		81,
		79,
		92,
		84,
		92,
		72,
		70,
		89,
		101,
		92,
		103,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		131,
		154,
		191,
		165,
		151,
		156,
		131,
		124,
		118,
		135,
		118,
		99,
		88,
		80,
		69,
		80,
		88,
		86,
		68,
		77,
		83,
		107,
		91,
		97,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		145,
		152,
		184,
		156,
		169,
		-1,
		123,
		-1,
		112,
		108,
		93,
		88,
		85,
		72,
		71,
		85,
		85,
		75,
		70,
		77,
		112,
		112,
		81,
		101,
		104,
		-1,
		-1,
		-1,
		195,
		190,
		165,
		142,
		126,
		162,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		95,
		91,
		76,
		80,
		82,
		85,
		73,
		79,
		80,
		62,
		86,
		-1,
		89,
		83,
		91,
		81,
		69,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		121,
		173,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		88,
		83,
		82,
		81,
		78,
		67,
		80,
		73,
		67,
		61,
		74,
		78,
		82,
		71,
		67,
		64,
		78,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		141,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		110,
		94,
		93,
		90,
		81,
		83,
		62,
		55,
		66,
		51,
		69,
		77,
		69,
		63,
		62,
		74,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		100,
		105,
		106,
		76,
		81,
		83,
		71,
		67,
		56,
		59,
		51,
		73,
		73,
		57,
		58,
		67,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		174,
		-1,
		111,
		128,
		114,
		112,
		95,
		70,
		77,
		95,
		68,
		63,
		61,
		50,
		50,
		45,
		67,
		53,
		51,
		70,
		86,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		152,
		140,
		127,
		109,
		147,
		-1,
		69,
		65,
		72,
		-1,
		88,
		-1,
		58,
		54,
		45,
		42,
		39,
		50,
		48,
		59,
		76,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		139,
		133,
		133,
		102,
		99,
		85,
		65,
		57,
		72,
		71,
		56,
		57,
		36,
		36,
		39,
		42,
		55,
		75,
		66,
		78,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		200,
		156,
		142,
		-1,
		94,
		85,
		73,
		63,
		53,
		58,
		59,
		47,
		38,
		34,
		43,
		47,
		51,
		56,
		77,
		73,
		91,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		146,
		147,
		113,
		92,
		74,
		-1,
		-1,
		57,
		50,
		44,
		35,
		26,
		46,
		53,
		47,
		50,
		65,
		77,
		85,
		85,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		125,
		70,
		59,
		54,
		58,
		56,
		-1,
		30,
		29,
		22,
		41,
		48,
		47,
		41,
		47,
		58,
		73,
		90,
		-1,
		-1,
		167,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		82,
		76,
		47,
		40,
		44,
		-1,
		31,
		22,
		19,
		23,
		21,
		26,
		34,
		41,
		55,
		58,
		71,
		85,
		89,
		190,
		-1,
		135,
		-1,
		-1,
		-1,
		100,
		115,
		86,
		63,
		36,
		31,
		24,
		18,
		11,
		10,
		16,
		27,
		35,
		39,
		54,
		64,
		63,
		80,
		90,
		-1,
		-1,
		133,
		129,
		126,
		108,
		112,
		113,
		-1,
		-1,
		40,
		31,
		22,
		17,
		0,
		3,
		31,
		33,
		51,
		70,
		58,
		73,
		88,
		86,
		-1,
		-1,
		-1,
		145,
		-1,
		147,
		-1,
		-1,
		127,
		111,
		58,
		40,
		36,
		34,
		27,
		33,
		21,
		26,
		51,
		48,
		57,
		60,
		66,
		89,
		78,
		117,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		124,
		116,
		111,
		117,
		119,
		110,
		73,
		70,
		-1,
		40,
		62,
		27,
		34,
		26,
		41,
		46,
		52,
		56,
		63,
		79,
		78,
		73,
		109,
		100,
		106,
		-1,
		-1,
		210,
		199,
		188,
		194,
		-1,
		117,
		113,
		103,
		93,
		96,
		-1,
		-1,
		89,
		86,
		59,
		36,
		42,
		35,
		30,
		68,
		44,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		164,
		201,
		194,
		162,
		170,
		201,
		-1,
		107,
		99,
		110,
		85,
		87,
		-1,
		-1,
		62,
		54,
		55,
		43,
		40,
		53,
		52,
		64,
		66,
		71,
		59,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		157,
		177,
		156,
		159,
		183,
		197,
		-1,
		104,
		-1,
		-1,
		116,
		88,
		72,
		62,
		59,
		102,
		57,
		52,
		54,
		56,
		62,
		53,
		76,
		67,
		67,
		70,
		85,
		90,
		82,
		96,
		96,
		97,
		-1,
		146,
		157,
		150,
		-1,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		132,
		-1,
		99,
		-1,
		79,
		83,
		65,
		68,
		79,
		66,
		66,
		74,
		82,
		65,
		75,
		71,
		72,
		81,
		92,
		104,
		103,
		104,
		171,
		127,
		130,
		141,
		152,
		167,
		171,
		-1,
		116,
		155,
		170,
		-1,
		141,
		-1,
		-1,
		-1,
		93,
		78,
		70,
		86,
		78,
		78,
		60,
		64,
		70,
		77,
		87,
		89,
		81,
		85,
		98,
		109,
		112,
		167,
		158,
		171,
		116,
		116,
		137,
		146,
		167,
		131,
		122,
		149,
		170,
		166,
		161,
		148,
		-1,
		-1,
		116,
		88,
		-1,
		-1,
		85,
		81,
		64,
		66,
		70,
		80,
		95,
		98,
		88,
		86,
		80,
		112,
		-1,
		160,
		159,
		148,
		145,
		121,
		112,
		107,
		134,
		-1,
		-1,
		129,
		150,
		140,
		144,
		160,
		185,
		-1,
		148,
		-1,
		-1,
		137,
		-1,
		-1,
		123,
		86,
		75,
		66,
		72,
		78,
		89,
		106,
		94,
		95,
		85,
		95,
		108,
		144,
		141,
		129,
		127,
		150,
		115,
		103,
		-1,
		116,
		114,
		120,
		127,
		144,
		174,
		-1,
		-1,
		164,
		144,
		-1,
		-1,
		121,
		119,
		108,
		-1,
		98,
		71,
		76,
		101,
		108,
		103,
		97,
		91,
		98,
		97,
		105,
		113,
		153,
		167,
		156,
		152,
		151,
		159,
		108,
		101,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		150,
		-1,
		-1,
		116,
		109,
		97,
		85,
		75,
		85,
		93,
		93,
		96,
		94,
		89,
		100,
		92,
		96,
		113,
		-1,
		187,
		-1,
		139,
		115,
		129,
		144,
		152,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		150,
		134,
		115,
		-1,
		85,
		98,
		129,
		97,
		102,
		97,
		95,
		106,
		95,
		98,
		112,
		107,
		-1,
		-1,
		127,
		130,
		-1,
		-1,
		152,
		163,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		122,
		118,
		-1,
		-1,
		86,
		111,
		100,
		108,
		103,
		99,
		105,
		108,
		97,
		101,
		113,
		-1,
		-1,
		134,
		135,
		140,
		-1,
		146,
		-1,
		164,
		-1,
		131,
		137,
		125,
		-1,
		-1,
		-1,
		124,
		87,
		104,
		118,
		123,
		121,
		112,
		103,
		110,
		108,
		104,
		115,
		-1,
		-1,
		-1,
		164,
		138,
		171,
		162,
		145,
		125,
		117,
		136,
		-1,
		106,
		-1,
		81,
		84,
		109,
		117,
		134,
		128,
		106,
		121,
		111,
		102,
		111,
		170,
		-1,
		140,
		173,
		137,
		131,
		107,
		111,
		127,
		-1,
		103,
		85,
		-1,
		113,
		103,
		151,
		126,
		121,
		108,
		115,
		115,
		108,
		-1,
		-1,
		-1,
		142,
		141,
		133,
		127,
		127,
		112,
		103,
		-1,
		115,
		97,
		76,
		93,
		93,
		84,
		92,
		141,
		137,
		128,
		128,
		116,
		-1,
		243,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		136,
		131,
		104,
		92,
		98,
		94,
		80,
		86,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		115,
		147,
		-1,
		238,
		-1,
		172,
		-1,
		-1,
		154,
		134,
		126,
		115,
		104,
		102,
		93,
		84,
		106,
		122,
		106,
		104,
		109,
		114,
		-1,
		227,
		226,
		-1,
		173,
		165,
		151,
		-1,
		144,
		-1,
		150,
		111,
		-1,
		113,
		93,
		-1,
		115,
		111,
		-1,
		-1,
		214,
		189,
		-1,
		-1,
		-1,
		174,
		154,
		145,
		129,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		199,
		198,
		-1,
		167,
		170,
		-1,
		160,
		151,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		208,
		189,
		183,
		182,
		180,
		175,
		172,
		158,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		180,
		172,
		165,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		191,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		213,
		214,
		237,
		201,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		216,
		214,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		196,
		185,
		196,
		204,
		177,
		184,
		-1,
		203,
		207,
		173,
		167,
		206,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		196,
		195,
		163,
		161,
		170,
		175,
		182,
		-1,
		181,
		-1,
		217,
		196,
		207,
		212,
		156,
		153,
		173,
		192,
		174,
		166,
		232,
		186,
		157,
		151,
		169,
		159,
		168,
		160,
		-1,
		157,
		147,
		169,
		148,
		159,
		151,
		-1,
		-1,
		151,
		152,
		158,
		144,
		150,
		146,
		-1,
		156,
		140,
		-1,
		-1,
		141,
		142,
		126,
		129,
		137,
		135,
		148,
		140,
		135,
		-1,
		-1,
		132,
		128,
		135,
		122,
		118,
		135,
		148,
		130,
		144,
		143,
		-1,
		138,
		156,
		161,
		129,
		127,
		111,
		109,
		127,
		129,
		135,
		135,
		-1,
		147,
		148,
		143,
		151,
		151,
		127,
		114,
		114,
		124,
		117,
		136,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		117,
		114,
		112,
		109,
		125,
		123,
		133,
		-1,
		-1,
		238,
		207,
		238,
		196,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		103,
		102,
		130,
		116,
		127,
		198,
		-1,
		-1,
		196,
		188,
		173,
		176,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		97,
		107,
		111,
		109,
		134,
		-1,
		-1,
		169,
		-1,
		-1,
		195,
		178,
		-1,
		161,
		168,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		94,
		119,
		123,
		104,
		125,
		120,
		-1,
		168,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		154,
		157,
		163,
		187,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		98,
		96,
		126,
		101,
		123,
		120,
		139,
		144,
		138,
		147,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		191,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		90,
		105,
		96,
		95,
		113,
		123,
		131,
		135,
		141,
		-1,
		253,
		-1,
		195,
		179,
		181,
		153,
		174,
		-1,
		211,
		197,
		189,
		174,
		172,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		103,
		85,
		99,
		90,
		108,
		115,
		113,
		117,
		137,
		149,
		213,
		203,
		-1,
		185,
		190,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		96,
		81,
		78,
		96,
		99,
		106,
		110,
		126,
		-1,
		-1,
		198,
		202,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		107,
		86,
		80,
		77,
		97,
		123,
		101,
		113,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		87,
		95,
		75,
		73,
		92,
		104,
		95,
		106,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		138,
		121,
		102,
		91,
		83,
		72,
		83,
		91,
		89,
		71,
		80,
		86,
		110,
		94,
		100,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		111,
		96,
		91,
		88,
		75,
		74,
		88,
		88,
		78,
		73,
		80,
		115,
		115,
		84,
		104,
		107,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		98,
		94,
		79,
		83,
		85,
		88,
		76,
		82,
		83,
		65,
		89,
		-1,
		92,
		86,
		94,
		84,
		72,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		91,
		86,
		85,
		84,
		81,
		70,
		83,
		76,
		70,
		64,
		77,
		81,
		85,
		74,
		70,
		67,
		81,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		113,
		97,
		96,
		93,
		84,
		83,
		65,
		58,
		69,
		54,
		72,
		80,
		72,
		66,
		65,
		77,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		103,
		105,
		106,
		76,
		81,
		83,
		71,
		70,
		59,
		62,
		54,
		76,
		76,
		60,
		61,
		70,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		174,
		-1,
		114,
		130,
		117,
		115,
		95,
		70,
		77,
		95,
		68,
		63,
		64,
		53,
		53,
		48,
		70,
		56,
		54,
		73,
		89,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		152,
		140,
		127,
		109,
		149,
		-1,
		69,
		65,
		72,
		-1,
		88,
		-1,
		60,
		57,
		48,
		45,
		42,
		53,
		51,
		62,
		79,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		139,
		133,
		133,
		102,
		99,
		85,
		65,
		57,
		72,
		71,
		58,
		57,
		39,
		39,
		42,
		45,
		58,
		78,
		69,
		80,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		200,
		156,
		142,
		-1,
		94,
		85,
		73,
		63,
		53,
		58,
		59,
		49,
		41,
		37,
		46,
		50,
		54,
		59,
		80,
		74,
		94,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		146,
		147,
		113,
		92,
		74,
		-1,
		-1,
		57,
		50,
		44,
		38,
		29,
		49,
		56,
		44,
		53,
		68,
		79,
		87,
		86,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		125,
		70,
		59,
		54,
		58,
		56,
		-1,
		30,
		32,
		25,
		38,
		45,
		44,
		38,
		47,
		58,
		74,
		91,
		-1,
		-1,
		170,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		82,
		76,
		47,
		40,
		44,
		-1,
		32,
		25,
		22,
		20,
		18,
		23,
		31,
		44,
		56,
		59,
		72,
		86,
		90,
		193,
		-1,
		138,
		-1,
		-1,
		-1,
		100,
		115,
		86,
		63,
		36,
		31,
		24,
		18,
		14,
		7,
		13,
		24,
		38,
		42,
		55,
		65,
		64,
		81,
		91,
		-1,
		-1,
		136,
		132,
		126,
		108,
		112,
		113,
		-1,
		-1,
		40,
		31,
		22,
		20,
		3,
		0,
		34,
		36,
		54,
		71,
		59,
		74,
		89,
		89,
		-1,
		-1,
		-1,
		148,
		-1,
		150,
		-1,
		-1,
		127,
		111,
		58,
		40,
		36,
		34,
		27,
		36,
		24,
		29,
		54,
		51,
		60,
		61,
		69,
		92,
		81,
		120,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		127,
		119,
		114,
		120,
		122,
		113,
		73,
		70,
		-1,
		40,
		65,
		30,
		37,
		29,
		44,
		49,
		55,
		59,
		66,
		82,
		81,
		76,
		112,
		103,
		109,
		-1,
		-1,
		213,
		202,
		191,
		197,
		-1,
		120,
		116,
		106,
		96,
		99,
		-1,
		-1,
		89,
		86,
		62,
		39,
		45,
		38,
		33,
		71,
		47,
		55,
		59,
		63,
		69,
		74,
		79,
		85,
		100,
		115,
		-1,
		167,
		204,
		197,
		165,
		173,
		204,
		-1,
		110,
		102,
		113,
		88,
		90,
		-1,
		-1,
		62,
		57,
		58,
		46,
		43,
		56,
		55,
		67,
		69,
		74,
		62,
		61,
		79,
		83,
		92,
		99,
		89,
		102,
		106,
		-1,
		160,
		180,
		159,
		162,
		186,
		200,
		-1,
		107,
		-1,
		-1,
		119,
		91,
		75,
		65,
		61,
		105,
		60,
		55,
		57,
		59,
		65,
		56,
		79,
		70,
		70,
		73,
		88,
		93,
		85,
		99,
		99,
		100,
		-1,
		149,
		160,
		153,
		-1,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		135,
		-1,
		102,
		-1,
		79,
		83,
		68,
		71,
		82,
		69,
		69,
		77,
		85,
		68,
		78,
		74,
		75,
		84,
		95,
		107,
		106,
		107,
		174,
		130,
		133,
		144,
		155,
		170,
		174,
		-1,
		119,
		158,
		173,
		-1,
		144,
		-1,
		-1,
		-1,
		93,
		81,
		73,
		89,
		81,
		81,
		63,
		67,
		73,
		80,
		90,
		92,
		84,
		88,
		101,
		112,
		115,
		170,
		161,
		174,
		119,
		119,
		140,
		149,
		170,
		134,
		125,
		152,
		173,
		169,
		164,
		151,
		-1,
		-1,
		116,
		91,
		-1,
		-1,
		88,
		84,
		67,
		69,
		73,
		83,
		98,
		101,
		91,
		89,
		83,
		115,
		-1,
		163,
		162,
		151,
		148,
		124,
		115,
		110,
		137,
		-1,
		-1,
		132,
		153,
		143,
		147,
		163,
		188,
		-1,
		151,
		-1,
		-1,
		137,
		-1,
		-1,
		126,
		89,
		78,
		69,
		75,
		81,
		92,
		109,
		97,
		98,
		88,
		98,
		111,
		147,
		144,
		132,
		130,
		153,
		118,
		106,
		-1,
		119,
		117,
		123,
		130,
		147,
		177,
		-1,
		-1,
		167,
		147,
		-1,
		-1,
		124,
		122,
		111,
		-1,
		101,
		74,
		79,
		104,
		111,
		106,
		100,
		94,
		101,
		100,
		108,
		116,
		156,
		170,
		159,
		155,
		154,
		162,
		111,
		104,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		157,
		153,
		-1,
		-1,
		119,
		112,
		100,
		88,
		78,
		88,
		96,
		96,
		99,
		97,
		92,
		103,
		95,
		99,
		116,
		-1,
		190,
		-1,
		142,
		118,
		132,
		147,
		155,
		-1,
		-1,
		-1,
		174,
		160,
		153,
		141,
		139,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		132,
		100,
		105,
		100,
		98,
		109,
		98,
		101,
		115,
		110,
		-1,
		-1,
		130,
		133,
		-1,
		-1,
		155,
		166,
		-1,
		165,
		154,
		139,
		131,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		89,
		114,
		103,
		111,
		106,
		102,
		108,
		111,
		100,
		104,
		116,
		-1,
		-1,
		137,
		138,
		143,
		-1,
		149,
		-1,
		167,
		-1,
		134,
		140,
		128,
		-1,
		-1,
		-1,
		127,
		90,
		107,
		121,
		126,
		124,
		115,
		106,
		113,
		111,
		107,
		118,
		-1,
		-1,
		-1,
		167,
		141,
		174,
		165,
		148,
		128,
		120,
		139,
		-1,
		109,
		-1,
		84,
		87,
		112,
		120,
		137,
		131,
		109,
		124,
		114,
		105,
		114,
		173,
		-1,
		143,
		176,
		140,
		134,
		110,
		114,
		130,
		-1,
		106,
		88,
		-1,
		116,
		106,
		154,
		129,
		124,
		111,
		118,
		118,
		111,
		-1,
		-1,
		-1,
		145,
		144,
		136,
		130,
		130,
		115,
		106,
		-1,
		118,
		100,
		79,
		96,
		96,
		87,
		95,
		144,
		140,
		131,
		131,
		119,
		-1,
		246,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		139,
		134,
		107,
		95,
		101,
		97,
		83,
		89,
		91,
		99,
		97,
		94,
		106,
		102,
		122,
		118,
		150,
		-1,
		241,
		-1,
		175,
		-1,
		-1,
		157,
		137,
		129,
		118,
		107,
		105,
		96,
		87,
		109,
		125,
		109,
		107,
		112,
		117,
		-1,
		230,
		229,
		-1,
		176,
		168,
		154,
		-1,
		147,
		-1,
		153,
		114,
		-1,
		116,
		96,
		-1,
		118,
		114,
		-1,
		-1,
		217,
		192,
		-1,
		-1,
		-1,
		177,
		157,
		148,
		132,
		-1,
		107,
		107,
		-1,
		-1,
		-1,
		202,
		201,
		-1,
		170,
		173,
		-1,
		163,
		154,
		162,
		109,
		113,
		-1,
		-1,
		-1,
		211,
		192,
		186,
		185,
		183,
		178,
		175,
		161,
		145,
		123,
		112,
		133,
		-1,
		-1,
		-1,
		183,
		175,
		168,
		-1,
		-1,
		170,
		153,
		134,
		132,
		-1,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		160,
		-1,
		-1,
		166,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		194,
		-1,
		-1,
		-1,
		156,
		152,
		153,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		240,
		204,
		-1,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		219,
		217,
		-1,
		-1,
		-1,
		176,
		160,
		-1,
		146,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		181,
		-1,
		181,
		156,
		163,
		-1,
		-1,
		-1,
		-1,
		194,
		186,
		194,
		-1,
		166,
		168,
		-1,
		216,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		171,
		178,
		200,
		203,
		239,
		-1,
		190
	],
	[
		-1,
		187,
		176,
		187,
		195,
		168,
		175,
		-1,
		194,
		198,
		164,
		158,
		197,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		187,
		186,
		154,
		152,
		161,
		166,
		173,
		-1,
		172,
		-1,
		208,
		187,
		198,
		203,
		147,
		144,
		164,
		183,
		165,
		157,
		223,
		177,
		148,
		142,
		160,
		150,
		159,
		151,
		-1,
		148,
		138,
		160,
		139,
		150,
		142,
		-1,
		-1,
		142,
		143,
		149,
		135,
		141,
		137,
		-1,
		147,
		131,
		-1,
		-1,
		132,
		133,
		117,
		120,
		128,
		126,
		139,
		131,
		126,
		-1,
		-1,
		123,
		119,
		126,
		113,
		109,
		126,
		139,
		121,
		135,
		134,
		-1,
		129,
		147,
		152,
		120,
		118,
		102,
		100,
		118,
		120,
		126,
		126,
		-1,
		138,
		139,
		134,
		142,
		142,
		118,
		105,
		105,
		115,
		108,
		127,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		121,
		138,
		130,
		120,
		135,
		128,
		108,
		105,
		103,
		100,
		116,
		114,
		124,
		-1,
		-1,
		229,
		198,
		229,
		187,
		168,
		-1,
		134,
		114,
		120,
		124,
		118,
		111,
		125,
		121,
		-1,
		94,
		93,
		121,
		107,
		118,
		189,
		-1,
		-1,
		187,
		179,
		164,
		167,
		144,
		140,
		129,
		128,
		120,
		106,
		102,
		108,
		111,
		111,
		117,
		88,
		98,
		102,
		100,
		125,
		-1,
		-1,
		160,
		-1,
		-1,
		186,
		169,
		-1,
		152,
		159,
		150,
		156,
		142,
		163,
		139,
		130,
		122,
		116,
		104,
		106,
		103,
		116,
		104,
		85,
		110,
		114,
		95,
		116,
		111,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		145,
		148,
		154,
		178,
		179,
		-1,
		151,
		139,
		140,
		125,
		122,
		109,
		97,
		110,
		95,
		102,
		101,
		89,
		87,
		117,
		92,
		114,
		111,
		130,
		135,
		129,
		138,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		182,
		-1,
		187,
		188,
		163,
		136,
		139,
		126,
		117,
		104,
		93,
		104,
		93,
		90,
		98,
		81,
		96,
		87,
		86,
		104,
		114,
		122,
		126,
		132,
		-1,
		244,
		-1,
		186,
		170,
		172,
		144,
		165,
		-1,
		202,
		188,
		180,
		165,
		163,
		-1,
		135,
		132,
		122,
		100,
		85,
		102,
		94,
		92,
		94,
		76,
		90,
		81,
		99,
		106,
		104,
		108,
		128,
		140,
		204,
		194,
		-1,
		176,
		181,
		140,
		148,
		167,
		205,
		169,
		-1,
		164,
		-1,
		137,
		150,
		-1,
		106,
		102,
		84,
		85,
		80,
		95,
		87,
		72,
		69,
		87,
		90,
		97,
		101,
		117,
		-1,
		-1,
		189,
		193,
		182,
		133,
		152,
		176,
		213,
		162,
		151,
		150,
		-1,
		141,
		120,
		117,
		105,
		92,
		77,
		78,
		86,
		98,
		77,
		71,
		68,
		88,
		114,
		92,
		103,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		159,
		130,
		154,
		196,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		116,
		95,
		86,
		75,
		73,
		86,
		78,
		86,
		66,
		64,
		83,
		95,
		86,
		94,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		125,
		148,
		185,
		159,
		145,
		150,
		125,
		118,
		112,
		129,
		112,
		93,
		82,
		74,
		63,
		74,
		82,
		80,
		62,
		71,
		77,
		101,
		82,
		88,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		102,
		87,
		82,
		79,
		66,
		65,
		79,
		79,
		69,
		64,
		71,
		106,
		106,
		72,
		92,
		95,
		-1,
		-1,
		-1,
		189,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		89,
		85,
		70,
		74,
		76,
		79,
		67,
		73,
		74,
		56,
		80,
		-1,
		80,
		74,
		82,
		72,
		60,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		82,
		77,
		76,
		75,
		72,
		61,
		74,
		67,
		61,
		55,
		68,
		72,
		73,
		62,
		58,
		55,
		69,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		104,
		88,
		87,
		84,
		75,
		83,
		56,
		49,
		60,
		45,
		63,
		69,
		60,
		55,
		54,
		65,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		94,
		111,
		112,
		85,
		84,
		82,
		73,
		61,
		50,
		53,
		45,
		67,
		64,
		48,
		50,
		59,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		108,
		106,
		101,
		79,
		86,
		93,
		70,
		65,
		55,
		44,
		44,
		39,
		58,
		44,
		42,
		57,
		73,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		78,
		74,
		81,
		-1,
		90,
		-1,
		63,
		60,
		51,
		36,
		33,
		44,
		42,
		51,
		52,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		111,
		108,
		94,
		74,
		66,
		81,
		80,
		67,
		66,
		49,
		42,
		39,
		29,
		42,
		52,
		58,
		50,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		103,
		94,
		82,
		72,
		62,
		67,
		68,
		58,
		56,
		47,
		49,
		38,
		31,
		30,
		51,
		44,
		66,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		156,
		122,
		101,
		83,
		-1,
		-1,
		66,
		59,
		53,
		56,
		44,
		60,
		55,
		37,
		24,
		39,
		49,
		57,
		56,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		134,
		79,
		68,
		63,
		67,
		65,
		-1,
		39,
		50,
		43,
		62,
		69,
		39,
		24,
		18,
		29,
		44,
		61,
		-1,
		-1,
		161,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		91,
		85,
		56,
		49,
		53,
		-1,
		41,
		43,
		40,
		52,
		42,
		39,
		30,
		12,
		26,
		29,
		42,
		56,
		60,
		184,
		-1,
		128,
		-1,
		-1,
		-1,
		109,
		124,
		95,
		72,
		45,
		40,
		33,
		27,
		32,
		43,
		50,
		61,
		6,
		10,
		25,
		35,
		34,
		51,
		61,
		-1,
		-1,
		126,
		122,
		135,
		117,
		121,
		122,
		-1,
		-1,
		49,
		40,
		31,
		23,
		36,
		39,
		0,
		4,
		22,
		41,
		29,
		44,
		59,
		66,
		-1,
		-1,
		-1,
		138,
		-1,
		140,
		-1,
		-1,
		128,
		120,
		67,
		49,
		45,
		43,
		32,
		26,
		14,
		7,
		22,
		32,
		39,
		31,
		53,
		69,
		65,
		98,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		117,
		109,
		104,
		110,
		112,
		103,
		82,
		79,
		-1,
		49,
		55,
		20,
		27,
		19,
		30,
		30,
		36,
		36,
		50,
		66,
		65,
		60,
		90,
		85,
		93,
		-1,
		-1,
		203,
		192,
		181,
		187,
		-1,
		110,
		106,
		96,
		86,
		89,
		-1,
		-1,
		83,
		80,
		52,
		29,
		35,
		28,
		23,
		61,
		37,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		99,
		-1,
		157,
		194,
		187,
		155,
		163,
		194,
		-1,
		100,
		92,
		103,
		78,
		80,
		-1,
		-1,
		56,
		47,
		48,
		36,
		33,
		46,
		45,
		57,
		53,
		59,
		46,
		45,
		63,
		67,
		76,
		83,
		73,
		86,
		90,
		-1,
		150,
		170,
		149,
		152,
		176,
		190,
		-1,
		97,
		-1,
		-1,
		109,
		81,
		65,
		55,
		52,
		95,
		50,
		45,
		47,
		49,
		55,
		46,
		63,
		54,
		54,
		57,
		72,
		77,
		69,
		83,
		83,
		84,
		-1,
		139,
		150,
		143,
		-1,
		-1,
		-1,
		-1,
		98,
		-1,
		-1,
		125,
		-1,
		92,
		-1,
		75,
		79,
		58,
		61,
		72,
		59,
		59,
		61,
		75,
		52,
		62,
		58,
		59,
		68,
		79,
		91,
		90,
		91,
		164,
		120,
		123,
		134,
		145,
		160,
		164,
		-1,
		109,
		148,
		163,
		-1,
		134,
		-1,
		-1,
		-1,
		89,
		71,
		63,
		79,
		71,
		71,
		53,
		57,
		57,
		64,
		74,
		76,
		68,
		72,
		85,
		96,
		99,
		160,
		151,
		164,
		109,
		109,
		130,
		139,
		160,
		124,
		115,
		142,
		163,
		159,
		154,
		141,
		-1,
		-1,
		112,
		81,
		-1,
		-1,
		78,
		74,
		57,
		59,
		63,
		67,
		82,
		85,
		75,
		73,
		67,
		99,
		-1,
		153,
		152,
		141,
		138,
		114,
		105,
		100,
		127,
		-1,
		-1,
		122,
		143,
		133,
		137,
		153,
		178,
		-1,
		141,
		-1,
		-1,
		131,
		-1,
		-1,
		116,
		79,
		68,
		59,
		65,
		71,
		82,
		93,
		81,
		82,
		72,
		82,
		95,
		137,
		134,
		122,
		120,
		143,
		108,
		96,
		-1,
		109,
		107,
		113,
		120,
		137,
		167,
		-1,
		-1,
		157,
		137,
		-1,
		-1,
		114,
		112,
		101,
		-1,
		91,
		64,
		69,
		94,
		101,
		90,
		84,
		78,
		85,
		84,
		92,
		100,
		146,
		160,
		149,
		145,
		144,
		152,
		101,
		94,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		143,
		-1,
		-1,
		109,
		102,
		90,
		78,
		68,
		78,
		86,
		86,
		88,
		81,
		76,
		87,
		79,
		83,
		100,
		-1,
		180,
		-1,
		132,
		108,
		122,
		137,
		145,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		143,
		127,
		108,
		-1,
		78,
		91,
		122,
		90,
		95,
		90,
		82,
		93,
		82,
		85,
		99,
		94,
		-1,
		-1,
		120,
		123,
		-1,
		-1,
		145,
		156,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		115,
		111,
		-1,
		-1,
		79,
		104,
		93,
		101,
		96,
		86,
		92,
		95,
		84,
		88,
		100,
		-1,
		-1,
		127,
		128,
		133,
		-1,
		139,
		-1,
		157,
		-1,
		124,
		130,
		118,
		-1,
		-1,
		-1,
		117,
		80,
		97,
		111,
		115,
		113,
		104,
		90,
		97,
		95,
		91,
		102,
		-1,
		-1,
		-1,
		157,
		131,
		164,
		155,
		138,
		118,
		110,
		129,
		-1,
		99,
		-1,
		74,
		77,
		102,
		110,
		126,
		120,
		93,
		108,
		98,
		89,
		98,
		163,
		-1,
		133,
		166,
		130,
		124,
		100,
		104,
		120,
		-1,
		96,
		78,
		-1,
		106,
		96,
		142,
		119,
		108,
		95,
		102,
		102,
		95,
		-1,
		-1,
		-1,
		135,
		134,
		126,
		120,
		120,
		105,
		96,
		-1,
		108,
		90,
		69,
		86,
		86,
		77,
		85,
		132,
		128,
		115,
		115,
		107,
		-1,
		236,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		129,
		124,
		97,
		85,
		91,
		87,
		73,
		79,
		81,
		89,
		87,
		84,
		96,
		92,
		112,
		108,
		140,
		-1,
		231,
		-1,
		165,
		-1,
		-1,
		147,
		127,
		119,
		108,
		97,
		95,
		86,
		77,
		99,
		115,
		99,
		97,
		102,
		107,
		-1,
		220,
		219,
		-1,
		166,
		158,
		144,
		-1,
		137,
		-1,
		143,
		104,
		-1,
		106,
		86,
		-1,
		108,
		104,
		-1,
		-1,
		207,
		182,
		-1,
		-1,
		-1,
		167,
		147,
		138,
		122,
		-1,
		97,
		97,
		-1,
		-1,
		-1,
		192,
		191,
		-1,
		160,
		163,
		-1,
		153,
		144,
		152,
		99,
		103,
		-1,
		-1,
		-1,
		201,
		182,
		176,
		175,
		173,
		168,
		165,
		151,
		135,
		113,
		102,
		123,
		-1,
		-1,
		-1,
		173,
		165,
		158,
		-1,
		-1,
		160,
		143,
		124,
		122,
		-1,
		-1,
		-1,
		195,
		176,
		-1,
		-1,
		150,
		-1,
		-1,
		156,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		184,
		-1,
		-1,
		-1,
		146,
		142,
		143,
		-1,
		-1,
		-1,
		-1,
		206,
		207,
		230,
		194,
		-1,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		209,
		207,
		-1,
		-1,
		-1,
		166,
		150,
		-1,
		136,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		171,
		-1,
		171,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		184,
		176,
		184,
		-1,
		156,
		158,
		-1,
		206,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		161,
		168,
		190,
		193,
		229,
		-1,
		180
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		190,
		194,
		160,
		154,
		193,
		162,
		168,
		179,
		-1,
		-1,
		-1,
		183,
		182,
		150,
		148,
		157,
		162,
		169,
		-1,
		168,
		-1,
		204,
		183,
		194,
		199,
		143,
		140,
		160,
		179,
		161,
		153,
		219,
		173,
		144,
		138,
		156,
		146,
		155,
		147,
		-1,
		144,
		134,
		156,
		135,
		146,
		138,
		-1,
		-1,
		138,
		139,
		145,
		131,
		137,
		133,
		-1,
		143,
		127,
		-1,
		-1,
		128,
		129,
		113,
		116,
		124,
		122,
		135,
		127,
		122,
		-1,
		-1,
		119,
		115,
		122,
		109,
		105,
		122,
		135,
		117,
		131,
		130,
		-1,
		125,
		143,
		148,
		116,
		114,
		98,
		96,
		114,
		116,
		122,
		122,
		-1,
		134,
		135,
		130,
		138,
		138,
		114,
		101,
		101,
		111,
		104,
		123,
		111,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		117,
		134,
		126,
		116,
		131,
		124,
		104,
		101,
		99,
		96,
		112,
		110,
		120,
		-1,
		-1,
		225,
		194,
		225,
		183,
		164,
		-1,
		130,
		110,
		116,
		120,
		114,
		107,
		121,
		117,
		-1,
		90,
		89,
		117,
		103,
		114,
		185,
		-1,
		-1,
		183,
		175,
		160,
		163,
		140,
		136,
		125,
		124,
		116,
		102,
		98,
		104,
		107,
		107,
		113,
		84,
		94,
		98,
		96,
		121,
		-1,
		-1,
		156,
		-1,
		-1,
		182,
		165,
		-1,
		148,
		155,
		146,
		152,
		138,
		159,
		135,
		126,
		118,
		112,
		100,
		102,
		99,
		112,
		100,
		81,
		106,
		110,
		91,
		112,
		107,
		-1,
		155,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		141,
		144,
		150,
		174,
		175,
		-1,
		147,
		135,
		136,
		121,
		118,
		105,
		93,
		106,
		91,
		98,
		97,
		85,
		83,
		113,
		88,
		110,
		107,
		126,
		131,
		125,
		134,
		-1,
		190,
		186,
		182,
		189,
		138,
		-1,
		-1,
		178,
		-1,
		183,
		184,
		159,
		132,
		135,
		122,
		113,
		100,
		89,
		100,
		89,
		86,
		94,
		77,
		92,
		83,
		82,
		100,
		110,
		118,
		122,
		128,
		-1,
		240,
		-1,
		182,
		166,
		168,
		140,
		161,
		-1,
		198,
		184,
		176,
		161,
		159,
		-1,
		131,
		128,
		118,
		96,
		81,
		98,
		90,
		88,
		90,
		72,
		86,
		77,
		95,
		102,
		100,
		104,
		124,
		136,
		200,
		190,
		-1,
		172,
		177,
		136,
		144,
		163,
		201,
		165,
		-1,
		160,
		-1,
		133,
		146,
		-1,
		102,
		98,
		80,
		81,
		76,
		91,
		83,
		68,
		65,
		83,
		86,
		93,
		97,
		113,
		-1,
		-1,
		185,
		189,
		178,
		129,
		148,
		172,
		209,
		158,
		147,
		146,
		-1,
		137,
		116,
		113,
		101,
		88,
		73,
		74,
		82,
		94,
		73,
		67,
		64,
		84,
		110,
		88,
		99,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		155,
		126,
		150,
		192,
		176,
		169,
		157,
		122,
		122,
		116,
		-1,
		112,
		91,
		82,
		71,
		69,
		82,
		74,
		82,
		62,
		60,
		79,
		91,
		82,
		90,
		-1,
		-1,
		-1,
		185,
		174,
		175,
		121,
		144,
		181,
		155,
		141,
		146,
		121,
		114,
		108,
		125,
		108,
		89,
		78,
		70,
		59,
		70,
		78,
		76,
		58,
		67,
		73,
		97,
		78,
		84,
		-1,
		-1,
		192,
		182,
		166,
		168,
		165,
		135,
		142,
		174,
		146,
		159,
		-1,
		113,
		-1,
		102,
		98,
		83,
		78,
		75,
		62,
		61,
		75,
		75,
		65,
		60,
		67,
		102,
		102,
		68,
		88,
		91,
		-1,
		-1,
		-1,
		185,
		180,
		155,
		132,
		116,
		152,
		-1,
		129,
		130,
		-1,
		107,
		101,
		98,
		85,
		81,
		66,
		70,
		72,
		75,
		63,
		69,
		70,
		52,
		76,
		-1,
		76,
		70,
		78,
		68,
		56,
		-1,
		-1,
		-1,
		178,
		157,
		150,
		170,
		111,
		163,
		-1,
		-1,
		114,
		107,
		-1,
		94,
		76,
		78,
		73,
		72,
		71,
		68,
		57,
		70,
		63,
		57,
		51,
		64,
		68,
		69,
		58,
		54,
		51,
		65,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		131,
		-1,
		123,
		115,
		105,
		99,
		93,
		89,
		87,
		100,
		84,
		83,
		80,
		71,
		79,
		52,
		45,
		56,
		41,
		59,
		65,
		56,
		51,
		50,
		61,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		144,
		-1,
		108,
		122,
		138,
		-1,
		131,
		110,
		125,
		103,
		99,
		90,
		107,
		108,
		86,
		80,
		78,
		69,
		57,
		46,
		49,
		41,
		63,
		60,
		44,
		46,
		55,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		93,
		125,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		104,
		102,
		97,
		80,
		87,
		89,
		66,
		61,
		51,
		40,
		40,
		35,
		54,
		40,
		38,
		53,
		69,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		79,
		75,
		82,
		-1,
		86,
		-1,
		59,
		56,
		47,
		32,
		29,
		40,
		38,
		47,
		48,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		162,
		-1,
		-1,
		132,
		126,
		126,
		110,
		109,
		95,
		75,
		67,
		82,
		81,
		68,
		67,
		45,
		38,
		35,
		25,
		38,
		48,
		54,
		46,
		-1,
		-1,
		-1,
		159,
		145,
		149,
		109,
		128,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		104,
		95,
		83,
		73,
		63,
		68,
		69,
		59,
		57,
		43,
		45,
		34,
		27,
		26,
		47,
		40,
		62,
		-1,
		-1,
		142,
		147,
		135,
		121,
		140,
		-1,
		-1,
		-1,
		141,
		157,
		123,
		102,
		84,
		-1,
		-1,
		67,
		60,
		54,
		57,
		45,
		56,
		51,
		33,
		20,
		35,
		45,
		53,
		52,
		-1,
		145,
		132,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		-1,
		-1,
		135,
		80,
		69,
		64,
		68,
		66,
		-1,
		40,
		51,
		44,
		58,
		65,
		35,
		20,
		14,
		25,
		40,
		57,
		-1,
		-1,
		157,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		92,
		86,
		57,
		50,
		54,
		-1,
		42,
		44,
		41,
		53,
		38,
		35,
		26,
		8,
		22,
		25,
		38,
		52,
		56,
		180,
		-1,
		129,
		-1,
		-1,
		-1,
		110,
		125,
		96,
		73,
		46,
		41,
		34,
		28,
		33,
		44,
		46,
		57,
		2,
		6,
		21,
		31,
		30,
		47,
		57,
		-1,
		-1,
		127,
		123,
		136,
		118,
		122,
		123,
		-1,
		-1,
		50,
		41,
		32,
		24,
		37,
		40,
		3,
		0,
		18,
		37,
		25,
		40,
		55,
		62,
		-1,
		-1,
		-1,
		139,
		-1,
		141,
		-1,
		-1,
		129,
		121,
		68,
		50,
		46,
		44,
		33,
		27,
		15,
		8,
		18,
		28,
		35,
		27,
		49,
		65,
		61,
		94,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		118,
		110,
		105,
		111,
		113,
		104,
		83,
		80,
		-1,
		50,
		56,
		21,
		28,
		20,
		26,
		26,
		32,
		32,
		46,
		62,
		61,
		56,
		86,
		81,
		89,
		-1,
		-1,
		204,
		193,
		182,
		188,
		-1,
		111,
		107,
		97,
		87,
		90,
		-1,
		-1,
		84,
		81,
		53,
		30,
		36,
		29,
		24,
		59,
		38,
		35,
		39,
		43,
		49,
		54,
		59,
		65,
		80,
		95,
		-1,
		158,
		195,
		188,
		156,
		164,
		195,
		-1,
		101,
		93,
		104,
		79,
		81,
		-1,
		-1,
		57,
		48,
		49,
		37,
		34,
		47,
		46,
		58,
		49,
		55,
		42,
		41,
		59,
		63,
		72,
		79,
		69,
		82,
		86,
		-1,
		151,
		171,
		150,
		153,
		177,
		191,
		-1,
		98,
		-1,
		-1,
		110,
		82,
		66,
		56,
		53,
		96,
		51,
		46,
		48,
		50,
		56,
		47,
		59,
		50,
		50,
		53,
		68,
		73,
		65,
		79,
		79,
		80,
		-1,
		140,
		151,
		144,
		-1,
		-1,
		-1,
		-1,
		99,
		-1,
		-1,
		126,
		-1,
		93,
		-1,
		76,
		80,
		59,
		62,
		73,
		60,
		60,
		57,
		73,
		48,
		58,
		54,
		55,
		64,
		75,
		87,
		86,
		87,
		165,
		121,
		124,
		135,
		146,
		161,
		165,
		-1,
		110,
		149,
		164,
		-1,
		135,
		-1,
		-1,
		-1,
		90,
		72,
		64,
		80,
		72,
		72,
		54,
		58,
		53,
		60,
		70,
		72,
		64,
		68,
		81,
		92,
		95,
		161,
		152,
		165,
		110,
		110,
		131,
		140,
		161,
		125,
		116,
		143,
		164,
		160,
		155,
		142,
		-1,
		-1,
		113,
		82,
		-1,
		-1,
		79,
		75,
		58,
		60,
		60,
		63,
		78,
		81,
		71,
		69,
		63,
		95,
		-1,
		154,
		153,
		142,
		139,
		115,
		106,
		101,
		128,
		-1,
		-1,
		123,
		144,
		134,
		138,
		154,
		179,
		-1,
		142,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		80,
		69,
		60,
		66,
		68,
		79,
		89,
		77,
		78,
		68,
		78,
		91,
		138,
		135,
		123,
		121,
		144,
		109,
		97,
		-1,
		110,
		108,
		114,
		121,
		138,
		168,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		65,
		70,
		95,
		97,
		86,
		80,
		74,
		81,
		80,
		88,
		96,
		147,
		161,
		150,
		146,
		145,
		153,
		102,
		95,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		79,
		87,
		87,
		84,
		77,
		72,
		83,
		75,
		79,
		96,
		-1,
		181,
		-1,
		133,
		109,
		123,
		138,
		146,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		123,
		91,
		96,
		91,
		78,
		89,
		78,
		81,
		95,
		90,
		-1,
		-1,
		121,
		124,
		-1,
		-1,
		146,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		105,
		94,
		102,
		97,
		82,
		88,
		91,
		80,
		84,
		96,
		-1,
		-1,
		128,
		129,
		134,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		118,
		81,
		98,
		112,
		111,
		109,
		100,
		86,
		93,
		91,
		87,
		98,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		78,
		103,
		111,
		122,
		116,
		89,
		104,
		94,
		85,
		94,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		107,
		97,
		138,
		120,
		104,
		91,
		98,
		98,
		91,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		87,
		87,
		78,
		86,
		128,
		124,
		111,
		111,
		103,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		82,
		90,
		88,
		85,
		97,
		93,
		113,
		104,
		139,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		116,
		100,
		98,
		103,
		108,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		109,
		105,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		140,
		158,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		149,
		150,
		145,
		153,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		132,
		149,
		141,
		131,
		146,
		139,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		240,
		209,
		240,
		198,
		179,
		-1,
		145,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		105,
		104,
		132,
		118,
		129,
		200,
		-1,
		-1,
		198,
		190,
		175,
		178,
		155,
		151,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		99,
		109,
		113,
		111,
		136,
		-1,
		-1,
		171,
		-1,
		-1,
		197,
		180,
		-1,
		163,
		170,
		161,
		167,
		153,
		174,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		96,
		121,
		125,
		106,
		127,
		122,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		156,
		159,
		165,
		189,
		190,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		100,
		98,
		128,
		103,
		125,
		122,
		141,
		146,
		140,
		149,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		193,
		-1,
		198,
		199,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		92,
		107,
		98,
		97,
		115,
		125,
		133,
		137,
		143,
		-1,
		255,
		-1,
		197,
		181,
		183,
		155,
		176,
		-1,
		213,
		199,
		191,
		176,
		174,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		105,
		103,
		105,
		87,
		101,
		92,
		110,
		117,
		115,
		119,
		139,
		151,
		215,
		205,
		-1,
		187,
		192,
		151,
		159,
		178,
		216,
		180,
		-1,
		175,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		98,
		83,
		80,
		98,
		101,
		108,
		112,
		128,
		-1,
		-1,
		200,
		204,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		109,
		88,
		82,
		79,
		99,
		125,
		103,
		114,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		89,
		97,
		77,
		75,
		94,
		106,
		97,
		105,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		140,
		123,
		104,
		93,
		85,
		74,
		85,
		93,
		91,
		73,
		82,
		88,
		112,
		93,
		99,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		113,
		98,
		93,
		90,
		77,
		76,
		90,
		90,
		80,
		75,
		82,
		117,
		117,
		83,
		103,
		106,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		100,
		96,
		81,
		85,
		87,
		90,
		78,
		84,
		85,
		67,
		91,
		-1,
		91,
		85,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		93,
		88,
		87,
		86,
		83,
		72,
		85,
		78,
		72,
		66,
		79,
		83,
		84,
		73,
		69,
		66,
		80,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		115,
		99,
		98,
		95,
		86,
		94,
		67,
		60,
		71,
		56,
		74,
		80,
		71,
		66,
		65,
		76,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		105,
		122,
		123,
		101,
		95,
		93,
		84,
		72,
		61,
		64,
		56,
		78,
		75,
		59,
		61,
		70,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		119,
		117,
		112,
		102,
		109,
		104,
		81,
		76,
		66,
		55,
		55,
		50,
		69,
		55,
		53,
		68,
		84,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		101,
		97,
		104,
		-1,
		101,
		-1,
		74,
		71,
		62,
		47,
		44,
		55,
		53,
		62,
		63,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		117,
		97,
		89,
		104,
		96,
		88,
		82,
		60,
		53,
		50,
		40,
		53,
		63,
		69,
		61,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		126,
		117,
		105,
		95,
		85,
		90,
		91,
		79,
		72,
		58,
		60,
		49,
		42,
		41,
		62,
		55,
		77,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		145,
		124,
		106,
		-1,
		-1,
		89,
		82,
		76,
		75,
		62,
		71,
		66,
		48,
		35,
		50,
		60,
		68,
		59,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		157,
		102,
		91,
		86,
		90,
		88,
		-1,
		62,
		73,
		66,
		73,
		80,
		50,
		35,
		29,
		40,
		55,
		64,
		-1,
		-1,
		172,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		79,
		72,
		76,
		-1,
		64,
		66,
		63,
		75,
		53,
		50,
		41,
		23,
		34,
		40,
		44,
		58,
		62,
		195,
		-1,
		151,
		-1,
		-1,
		-1,
		132,
		147,
		118,
		95,
		68,
		63,
		56,
		50,
		55,
		66,
		61,
		72,
		25,
		21,
		31,
		32,
		36,
		53,
		63,
		-1,
		-1,
		149,
		145,
		158,
		140,
		144,
		145,
		-1,
		-1,
		72,
		63,
		54,
		46,
		59,
		62,
		27,
		25,
		0,
		34,
		29,
		39,
		54,
		67,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		151,
		143,
		90,
		72,
		68,
		66,
		55,
		49,
		37,
		30,
		22,
		28,
		25,
		25,
		47,
		64,
		59,
		98,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		135,
		126,
		105,
		102,
		-1,
		72,
		78,
		43,
		50,
		42,
		29,
		26,
		29,
		30,
		44,
		60,
		59,
		54,
		90,
		81,
		87,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		133,
		129,
		119,
		109,
		112,
		-1,
		-1,
		106,
		103,
		75,
		52,
		54,
		47,
		42,
		59,
		46,
		35,
		37,
		41,
		47,
		52,
		57,
		63,
		78,
		93,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		123,
		115,
		126,
		101,
		103,
		-1,
		-1,
		79,
		70,
		71,
		59,
		56,
		66,
		63,
		64,
		49,
		55,
		42,
		39,
		57,
		61,
		70,
		77,
		67,
		80,
		84,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		120,
		-1,
		-1,
		132,
		104,
		88,
		78,
		75,
		118,
		73,
		68,
		70,
		70,
		61,
		52,
		59,
		50,
		48,
		51,
		68,
		73,
		65,
		77,
		77,
		78,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		115,
		-1,
		98,
		102,
		81,
		84,
		86,
		73,
		65,
		57,
		73,
		48,
		56,
		52,
		55,
		64,
		75,
		87,
		84,
		85,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		132,
		171,
		183,
		-1,
		157,
		-1,
		-1,
		-1,
		112,
		94,
		86,
		102,
		85,
		85,
		59,
		63,
		53,
		60,
		68,
		70,
		64,
		68,
		81,
		92,
		93,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		147,
		138,
		165,
		186,
		179,
		174,
		161,
		-1,
		-1,
		135,
		104,
		-1,
		-1,
		92,
		80,
		63,
		64,
		60,
		63,
		78,
		79,
		71,
		69,
		63,
		95,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		166,
		156,
		160,
		176,
		201,
		-1,
		150,
		-1,
		-1,
		137,
		-1,
		-1,
		122,
		85,
		74,
		65,
		71,
		68,
		79,
		89,
		77,
		78,
		68,
		78,
		91,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		132,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		166,
		146,
		-1,
		-1,
		120,
		118,
		107,
		-1,
		97,
		70,
		75,
		95,
		97,
		86,
		80,
		74,
		81,
		80,
		88,
		96,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		156,
		152,
		-1,
		-1,
		115,
		108,
		96,
		84,
		74,
		84,
		88,
		92,
		84,
		77,
		72,
		83,
		75,
		79,
		96,
		-1,
		203,
		-1,
		155,
		131,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		173,
		159,
		152,
		140,
		138,
		-1,
		149,
		133,
		114,
		-1,
		84,
		97,
		128,
		96,
		101,
		96,
		78,
		89,
		78,
		81,
		95,
		90,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		163,
		165,
		-1,
		164,
		153,
		138,
		130,
		-1,
		-1,
		121,
		117,
		-1,
		-1,
		85,
		110,
		99,
		107,
		102,
		82,
		88,
		91,
		80,
		84,
		96,
		-1,
		-1,
		150,
		151,
		156,
		-1,
		148,
		-1,
		166,
		-1,
		133,
		139,
		127,
		-1,
		-1,
		-1,
		123,
		86,
		106,
		117,
		111,
		109,
		100,
		86,
		93,
		91,
		87,
		98,
		-1,
		-1,
		-1,
		166,
		140,
		173,
		164,
		147,
		127,
		119,
		138,
		-1,
		108,
		-1,
		83,
		86,
		111,
		116,
		122,
		116,
		89,
		104,
		94,
		85,
		94,
		172,
		-1,
		142,
		175,
		139,
		133,
		109,
		113,
		129,
		-1,
		105,
		87,
		-1,
		115,
		105,
		138,
		123,
		104,
		91,
		98,
		98,
		91,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		114,
		105,
		-1,
		117,
		99,
		78,
		95,
		95,
		86,
		94,
		128,
		124,
		111,
		111,
		103,
		-1,
		245,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		133,
		106,
		94,
		100,
		96,
		82,
		88,
		90,
		98,
		96,
		93,
		105,
		101,
		121,
		104,
		139,
		-1,
		240,
		-1,
		174,
		-1,
		-1,
		156,
		136,
		128,
		117,
		106,
		104,
		95,
		86,
		108,
		124,
		108,
		106,
		111,
		112,
		-1,
		229,
		228,
		-1,
		175,
		167,
		153,
		-1,
		146,
		-1,
		152,
		113,
		-1,
		115,
		95,
		-1,
		117,
		113,
		-1,
		-1,
		216,
		191,
		-1,
		-1,
		-1,
		176,
		156,
		147,
		131,
		-1,
		106,
		106,
		-1,
		-1,
		-1,
		201,
		200,
		-1,
		169,
		172,
		-1,
		162,
		153,
		161,
		108,
		112,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		184,
		182,
		177,
		174,
		160,
		144,
		122,
		111,
		132,
		-1,
		-1,
		-1,
		182,
		174,
		167,
		-1,
		-1,
		169,
		152,
		133,
		131,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		159,
		-1,
		-1,
		165,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		193,
		-1,
		-1,
		-1,
		155,
		151,
		152,
		-1,
		-1,
		-1,
		-1,
		215,
		216,
		239,
		203,
		-1,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		218,
		216,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		145,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		180,
		-1,
		180,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		193,
		-1,
		165,
		167,
		-1,
		215,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		170,
		177,
		199,
		202,
		238,
		-1,
		189
	],
	[
		-1,
		196,
		185,
		196,
		204,
		177,
		184,
		-1,
		203,
		207,
		173,
		167,
		206,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		196,
		195,
		163,
		161,
		170,
		175,
		182,
		-1,
		181,
		-1,
		217,
		196,
		207,
		212,
		156,
		153,
		173,
		192,
		174,
		166,
		232,
		186,
		157,
		151,
		169,
		159,
		168,
		160,
		-1,
		157,
		147,
		169,
		148,
		159,
		151,
		-1,
		-1,
		151,
		152,
		158,
		144,
		150,
		146,
		-1,
		156,
		140,
		-1,
		-1,
		141,
		142,
		126,
		129,
		137,
		135,
		148,
		140,
		135,
		-1,
		-1,
		132,
		128,
		135,
		122,
		118,
		135,
		148,
		130,
		144,
		143,
		-1,
		138,
		156,
		161,
		129,
		127,
		111,
		109,
		127,
		129,
		135,
		135,
		-1,
		147,
		148,
		143,
		151,
		151,
		127,
		114,
		114,
		124,
		117,
		136,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		117,
		114,
		112,
		109,
		125,
		123,
		133,
		-1,
		-1,
		238,
		207,
		238,
		196,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		103,
		102,
		130,
		116,
		127,
		198,
		-1,
		-1,
		196,
		188,
		173,
		176,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		97,
		107,
		111,
		109,
		134,
		-1,
		-1,
		169,
		-1,
		-1,
		195,
		178,
		-1,
		161,
		168,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		94,
		119,
		123,
		104,
		125,
		120,
		-1,
		168,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		154,
		157,
		163,
		187,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		98,
		96,
		126,
		101,
		123,
		120,
		139,
		144,
		138,
		147,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		191,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		90,
		105,
		96,
		95,
		113,
		123,
		131,
		135,
		141,
		-1,
		253,
		-1,
		195,
		179,
		181,
		153,
		174,
		-1,
		211,
		197,
		189,
		174,
		172,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		103,
		85,
		99,
		90,
		108,
		115,
		113,
		117,
		137,
		149,
		213,
		203,
		-1,
		185,
		190,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		96,
		81,
		78,
		96,
		99,
		106,
		110,
		126,
		-1,
		-1,
		198,
		202,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		107,
		86,
		80,
		77,
		97,
		123,
		101,
		112,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		87,
		95,
		75,
		73,
		92,
		104,
		95,
		103,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		138,
		121,
		102,
		91,
		83,
		72,
		83,
		91,
		89,
		71,
		80,
		86,
		110,
		91,
		97,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		111,
		96,
		91,
		88,
		75,
		74,
		88,
		88,
		78,
		73,
		80,
		115,
		115,
		81,
		101,
		104,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		98,
		94,
		79,
		83,
		85,
		88,
		76,
		82,
		83,
		65,
		89,
		-1,
		89,
		83,
		91,
		81,
		69,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		91,
		86,
		85,
		84,
		81,
		70,
		83,
		76,
		70,
		64,
		77,
		81,
		82,
		71,
		67,
		64,
		78,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		113,
		97,
		96,
		93,
		84,
		92,
		65,
		58,
		69,
		54,
		72,
		78,
		69,
		64,
		63,
		74,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		103,
		120,
		121,
		99,
		93,
		91,
		82,
		70,
		59,
		62,
		54,
		76,
		73,
		57,
		59,
		60,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		117,
		115,
		110,
		101,
		107,
		102,
		79,
		74,
		64,
		53,
		53,
		48,
		67,
		53,
		51,
		58,
		74,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		118,
		102,
		107,
		-1,
		99,
		-1,
		72,
		69,
		60,
		45,
		42,
		53,
		51,
		60,
		53,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		134,
		114,
		107,
		107,
		94,
		86,
		80,
		58,
		51,
		48,
		38,
		51,
		61,
		67,
		51,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		135,
		123,
		113,
		103,
		108,
		102,
		77,
		70,
		56,
		58,
		47,
		40,
		39,
		53,
		45,
		67,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		154,
		170,
		162,
		133,
		124,
		-1,
		-1,
		107,
		100,
		94,
		73,
		60,
		69,
		64,
		46,
		33,
		48,
		50,
		58,
		49,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		175,
		120,
		109,
		104,
		108,
		106,
		-1,
		80,
		84,
		64,
		71,
		78,
		48,
		33,
		27,
		33,
		45,
		54,
		-1,
		-1,
		170,
		-1,
		165,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		97,
		90,
		94,
		-1,
		82,
		80,
		66,
		77,
		51,
		48,
		39,
		31,
		24,
		30,
		34,
		48,
		52,
		193,
		-1,
		161,
		-1,
		-1,
		-1,
		150,
		165,
		136,
		113,
		86,
		81,
		74,
		68,
		73,
		73,
		59,
		70,
		37,
		33,
		21,
		22,
		26,
		43,
		53,
		-1,
		-1,
		159,
		155,
		176,
		158,
		162,
		163,
		-1,
		-1,
		90,
		81,
		72,
		64,
		77,
		77,
		43,
		40,
		20,
		0,
		19,
		31,
		45,
		57,
		-1,
		-1,
		-1,
		171,
		-1,
		173,
		-1,
		-1,
		161,
		161,
		108,
		90,
		86,
		84,
		73,
		67,
		55,
		48,
		41,
		37,
		29,
		15,
		37,
		55,
		49,
		88,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		150,
		142,
		137,
		143,
		145,
		136,
		123,
		120,
		-1,
		90,
		96,
		61,
		68,
		52,
		44,
		41,
		33,
		20,
		34,
		50,
		49,
		44,
		80,
		71,
		77,
		-1,
		-1,
		236,
		225,
		214,
		220,
		-1,
		143,
		139,
		129,
		119,
		122,
		-1,
		-1,
		116,
		113,
		93,
		62,
		60,
		53,
		48,
		58,
		38,
		25,
		27,
		31,
		37,
		42,
		47,
		53,
		68,
		83,
		-1,
		190,
		227,
		220,
		188,
		196,
		227,
		-1,
		133,
		125,
		136,
		111,
		113,
		-1,
		-1,
		89,
		80,
		81,
		69,
		66,
		68,
		63,
		54,
		39,
		45,
		32,
		29,
		47,
		51,
		60,
		67,
		57,
		70,
		74,
		-1,
		183,
		203,
		182,
		185,
		209,
		223,
		-1,
		130,
		-1,
		-1,
		142,
		114,
		98,
		88,
		85,
		128,
		83,
		78,
		62,
		60,
		51,
		42,
		49,
		40,
		38,
		41,
		58,
		63,
		55,
		67,
		67,
		68,
		-1,
		172,
		183,
		176,
		-1,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		158,
		-1,
		125,
		-1,
		108,
		112,
		91,
		94,
		76,
		63,
		55,
		47,
		63,
		38,
		46,
		42,
		45,
		54,
		65,
		77,
		74,
		75,
		197,
		153,
		156,
		167,
		178,
		193,
		197,
		-1,
		142,
		181,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		122,
		104,
		96,
		96,
		75,
		75,
		49,
		53,
		43,
		50,
		58,
		60,
		54,
		58,
		71,
		82,
		83,
		193,
		184,
		197,
		142,
		142,
		163,
		172,
		193,
		157,
		148,
		175,
		182,
		171,
		166,
		153,
		-1,
		-1,
		145,
		114,
		-1,
		-1,
		82,
		70,
		53,
		54,
		50,
		53,
		68,
		69,
		61,
		59,
		53,
		85,
		-1,
		186,
		185,
		174,
		171,
		147,
		138,
		133,
		160,
		-1,
		-1,
		155,
		176,
		166,
		170,
		186,
		211,
		-1,
		142,
		-1,
		-1,
		127,
		-1,
		-1,
		112,
		75,
		64,
		55,
		61,
		58,
		69,
		79,
		67,
		68,
		58,
		68,
		81,
		170,
		167,
		155,
		153,
		176,
		141,
		129,
		-1,
		142,
		140,
		146,
		153,
		170,
		200,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		110,
		108,
		97,
		-1,
		87,
		60,
		65,
		85,
		87,
		76,
		70,
		64,
		71,
		70,
		78,
		86,
		179,
		193,
		182,
		178,
		177,
		185,
		134,
		127,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		105,
		98,
		86,
		74,
		64,
		74,
		78,
		82,
		74,
		67,
		62,
		73,
		65,
		69,
		86,
		-1,
		213,
		-1,
		165,
		141,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		139,
		123,
		104,
		-1,
		74,
		87,
		118,
		86,
		91,
		86,
		68,
		79,
		68,
		71,
		85,
		80,
		-1,
		-1,
		153,
		156,
		-1,
		-1,
		155,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		111,
		107,
		-1,
		-1,
		75,
		100,
		89,
		97,
		92,
		72,
		78,
		81,
		70,
		74,
		86,
		-1,
		-1,
		160,
		161,
		162,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		113,
		76,
		97,
		107,
		101,
		99,
		90,
		76,
		83,
		81,
		77,
		88,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		77,
		103,
		106,
		112,
		106,
		79,
		94,
		84,
		75,
		84,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		107,
		97,
		128,
		113,
		94,
		81,
		88,
		88,
		81,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		87,
		87,
		78,
		86,
		118,
		114,
		101,
		101,
		93,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		82,
		90,
		88,
		85,
		97,
		93,
		113,
		94,
		129,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		116,
		100,
		98,
		101,
		102,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		109,
		105,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		192,
		196,
		162,
		156,
		195,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		185,
		184,
		152,
		150,
		159,
		164,
		171,
		-1,
		170,
		-1,
		206,
		185,
		196,
		201,
		145,
		142,
		162,
		181,
		163,
		155,
		221,
		175,
		146,
		140,
		158,
		148,
		157,
		149,
		-1,
		146,
		136,
		158,
		137,
		148,
		140,
		-1,
		-1,
		140,
		141,
		147,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		130,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		127,
		145,
		150,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		124,
		-1,
		136,
		137,
		132,
		140,
		140,
		116,
		103,
		103,
		113,
		106,
		125,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		119,
		136,
		128,
		118,
		133,
		126,
		106,
		103,
		101,
		98,
		114,
		112,
		122,
		-1,
		-1,
		227,
		196,
		227,
		185,
		166,
		-1,
		132,
		112,
		118,
		122,
		116,
		109,
		123,
		119,
		-1,
		92,
		91,
		119,
		105,
		116,
		187,
		-1,
		-1,
		185,
		177,
		162,
		165,
		142,
		138,
		127,
		126,
		118,
		104,
		100,
		106,
		109,
		109,
		115,
		86,
		96,
		100,
		98,
		123,
		-1,
		-1,
		158,
		-1,
		-1,
		184,
		167,
		-1,
		150,
		157,
		148,
		154,
		140,
		161,
		137,
		128,
		120,
		114,
		102,
		104,
		101,
		114,
		102,
		83,
		108,
		112,
		93,
		114,
		109,
		-1,
		157,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		146,
		152,
		176,
		177,
		-1,
		149,
		137,
		138,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		87,
		85,
		115,
		90,
		112,
		109,
		128,
		133,
		127,
		136,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		180,
		-1,
		185,
		186,
		161,
		134,
		137,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		79,
		94,
		85,
		84,
		102,
		112,
		120,
		124,
		130,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		200,
		186,
		178,
		163,
		161,
		-1,
		133,
		130,
		120,
		98,
		83,
		100,
		92,
		90,
		92,
		74,
		88,
		79,
		97,
		104,
		102,
		106,
		126,
		138,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		135,
		148,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		85,
		70,
		67,
		85,
		88,
		95,
		99,
		115,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		118,
		115,
		103,
		90,
		75,
		76,
		84,
		96,
		75,
		69,
		66,
		86,
		112,
		90,
		101,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		114,
		93,
		84,
		73,
		71,
		84,
		76,
		84,
		64,
		62,
		81,
		93,
		84,
		92,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		127,
		110,
		91,
		80,
		72,
		61,
		72,
		80,
		78,
		60,
		69,
		75,
		99,
		80,
		86,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		100,
		85,
		80,
		77,
		64,
		63,
		77,
		77,
		67,
		62,
		69,
		104,
		104,
		70,
		90,
		93,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		87,
		83,
		68,
		72,
		74,
		77,
		65,
		71,
		72,
		54,
		78,
		-1,
		78,
		72,
		80,
		70,
		58,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		80,
		75,
		74,
		73,
		70,
		59,
		72,
		65,
		59,
		53,
		66,
		70,
		71,
		60,
		56,
		53,
		67,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		102,
		86,
		85,
		82,
		73,
		81,
		54,
		47,
		58,
		43,
		61,
		67,
		58,
		53,
		52,
		63,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		92,
		109,
		110,
		88,
		82,
		80,
		71,
		59,
		48,
		51,
		43,
		65,
		62,
		46,
		48,
		49,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		106,
		104,
		99,
		90,
		96,
		91,
		68,
		63,
		53,
		42,
		42,
		37,
		56,
		42,
		40,
		47,
		63,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		105,
		91,
		96,
		-1,
		88,
		-1,
		61,
		58,
		49,
		34,
		31,
		42,
		40,
		49,
		42,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		121,
		101,
		93,
		96,
		83,
		75,
		69,
		47,
		40,
		37,
		27,
		40,
		50,
		56,
		40,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		121,
		109,
		99,
		89,
		94,
		91,
		66,
		59,
		45,
		47,
		36,
		29,
		28,
		42,
		34,
		56,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		149,
		122,
		110,
		-1,
		-1,
		93,
		86,
		80,
		62,
		49,
		58,
		53,
		35,
		22,
		37,
		39,
		47,
		40,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		161,
		106,
		95,
		90,
		94,
		92,
		-1,
		66,
		73,
		53,
		60,
		67,
		37,
		22,
		16,
		22,
		34,
		45,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		118,
		112,
		83,
		76,
		80,
		-1,
		68,
		69,
		55,
		66,
		40,
		37,
		28,
		16,
		8,
		19,
		25,
		39,
		43,
		182,
		-1,
		152,
		-1,
		-1,
		-1,
		136,
		151,
		122,
		99,
		72,
		67,
		60,
		54,
		59,
		62,
		48,
		59,
		23,
		19,
		5,
		13,
		17,
		34,
		44,
		-1,
		-1,
		150,
		146,
		162,
		144,
		148,
		149,
		-1,
		-1,
		76,
		67,
		58,
		50,
		63,
		66,
		29,
		26,
		23,
		16,
		0,
		22,
		33,
		48,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		152,
		147,
		94,
		76,
		72,
		70,
		59,
		53,
		41,
		34,
		44,
		34,
		26,
		6,
		24,
		43,
		40,
		79,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		141,
		133,
		128,
		134,
		136,
		127,
		109,
		106,
		-1,
		76,
		82,
		47,
		54,
		43,
		41,
		38,
		30,
		11,
		25,
		41,
		40,
		35,
		71,
		62,
		68,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		134,
		130,
		120,
		110,
		113,
		-1,
		-1,
		107,
		104,
		79,
		53,
		51,
		44,
		39,
		49,
		29,
		16,
		18,
		22,
		28,
		33,
		38,
		44,
		59,
		74,
		-1,
		181,
		218,
		211,
		179,
		187,
		218,
		-1,
		124,
		116,
		127,
		102,
		104,
		-1,
		-1,
		80,
		71,
		72,
		60,
		57,
		59,
		54,
		45,
		30,
		36,
		23,
		20,
		38,
		42,
		51,
		58,
		48,
		61,
		65,
		-1,
		174,
		194,
		173,
		176,
		200,
		214,
		-1,
		121,
		-1,
		-1,
		133,
		105,
		89,
		79,
		76,
		119,
		74,
		69,
		53,
		51,
		42,
		33,
		40,
		31,
		29,
		32,
		49,
		54,
		46,
		58,
		58,
		59,
		-1,
		163,
		174,
		167,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		116,
		-1,
		99,
		103,
		82,
		85,
		67,
		54,
		46,
		38,
		54,
		29,
		37,
		33,
		36,
		45,
		56,
		68,
		65,
		66,
		188,
		144,
		147,
		158,
		169,
		184,
		188,
		-1,
		133,
		172,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		113,
		95,
		87,
		87,
		66,
		66,
		40,
		44,
		34,
		41,
		49,
		51,
		45,
		49,
		62,
		73,
		74,
		184,
		175,
		188,
		133,
		133,
		154,
		163,
		184,
		148,
		139,
		166,
		173,
		162,
		157,
		144,
		-1,
		-1,
		136,
		105,
		-1,
		-1,
		73,
		61,
		44,
		45,
		41,
		44,
		59,
		60,
		52,
		50,
		44,
		76,
		-1,
		177,
		176,
		165,
		162,
		138,
		129,
		124,
		151,
		-1,
		-1,
		146,
		167,
		157,
		161,
		177,
		202,
		-1,
		133,
		-1,
		-1,
		118,
		-1,
		-1,
		103,
		66,
		55,
		46,
		52,
		49,
		60,
		70,
		58,
		59,
		49,
		59,
		72,
		161,
		158,
		146,
		144,
		167,
		132,
		120,
		-1,
		133,
		131,
		137,
		144,
		161,
		191,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		101,
		99,
		88,
		-1,
		78,
		51,
		56,
		76,
		78,
		67,
		61,
		55,
		62,
		61,
		69,
		77,
		170,
		184,
		173,
		169,
		168,
		176,
		125,
		118,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		96,
		89,
		77,
		65,
		55,
		65,
		69,
		73,
		65,
		58,
		53,
		64,
		56,
		60,
		77,
		-1,
		204,
		-1,
		156,
		132,
		146,
		161,
		169,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		130,
		114,
		95,
		-1,
		65,
		78,
		109,
		77,
		82,
		77,
		59,
		70,
		59,
		62,
		76,
		71,
		-1,
		-1,
		144,
		147,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		102,
		98,
		-1,
		-1,
		66,
		91,
		80,
		88,
		83,
		63,
		69,
		72,
		61,
		65,
		77,
		-1,
		-1,
		151,
		152,
		153,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		104,
		67,
		88,
		98,
		92,
		90,
		81,
		67,
		74,
		72,
		68,
		79,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		91,
		-1,
		66,
		68,
		94,
		97,
		103,
		97,
		70,
		85,
		75,
		66,
		75,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		88,
		70,
		-1,
		98,
		88,
		119,
		104,
		85,
		72,
		79,
		79,
		72,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		78,
		78,
		69,
		77,
		109,
		105,
		92,
		92,
		84,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		73,
		81,
		79,
		76,
		88,
		84,
		104,
		85,
		120,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		107,
		91,
		89,
		92,
		93,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		100,
		96,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		200,
		204,
		170,
		164,
		203,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		193,
		192,
		160,
		158,
		167,
		172,
		179,
		-1,
		178,
		-1,
		214,
		193,
		204,
		209,
		153,
		150,
		170,
		189,
		171,
		163,
		229,
		183,
		154,
		148,
		166,
		156,
		165,
		157,
		-1,
		154,
		144,
		166,
		145,
		156,
		148,
		-1,
		-1,
		148,
		149,
		155,
		141,
		147,
		143,
		-1,
		153,
		137,
		-1,
		-1,
		138,
		139,
		123,
		126,
		134,
		132,
		145,
		137,
		132,
		-1,
		-1,
		129,
		125,
		132,
		119,
		115,
		132,
		145,
		127,
		141,
		140,
		-1,
		135,
		153,
		158,
		126,
		124,
		108,
		106,
		124,
		126,
		132,
		132,
		-1,
		144,
		145,
		140,
		148,
		148,
		124,
		111,
		111,
		121,
		114,
		133,
		121,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		127,
		144,
		136,
		126,
		141,
		134,
		114,
		111,
		109,
		106,
		122,
		120,
		130,
		-1,
		-1,
		235,
		204,
		235,
		193,
		174,
		-1,
		140,
		120,
		126,
		130,
		124,
		117,
		131,
		127,
		-1,
		100,
		99,
		127,
		113,
		124,
		195,
		-1,
		-1,
		193,
		185,
		170,
		173,
		150,
		146,
		135,
		134,
		126,
		112,
		108,
		114,
		117,
		117,
		123,
		94,
		104,
		108,
		106,
		131,
		-1,
		-1,
		164,
		-1,
		-1,
		192,
		175,
		-1,
		158,
		165,
		156,
		162,
		148,
		169,
		145,
		136,
		128,
		122,
		110,
		112,
		109,
		122,
		110,
		91,
		116,
		120,
		101,
		122,
		117,
		-1,
		163,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		151,
		154,
		160,
		184,
		185,
		-1,
		157,
		145,
		146,
		131,
		128,
		115,
		103,
		116,
		101,
		108,
		107,
		95,
		93,
		123,
		98,
		120,
		117,
		134,
		139,
		133,
		142,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		188,
		-1,
		193,
		194,
		169,
		142,
		145,
		132,
		123,
		110,
		99,
		110,
		99,
		96,
		104,
		87,
		102,
		93,
		92,
		110,
		118,
		126,
		130,
		136,
		-1,
		250,
		-1,
		192,
		176,
		178,
		150,
		171,
		-1,
		208,
		194,
		186,
		171,
		169,
		-1,
		141,
		138,
		128,
		106,
		91,
		108,
		100,
		98,
		100,
		82,
		96,
		87,
		105,
		112,
		108,
		112,
		132,
		144,
		210,
		200,
		-1,
		182,
		187,
		146,
		154,
		173,
		211,
		175,
		-1,
		170,
		-1,
		143,
		156,
		-1,
		112,
		108,
		90,
		91,
		86,
		101,
		93,
		78,
		75,
		93,
		96,
		101,
		105,
		121,
		-1,
		-1,
		195,
		199,
		188,
		139,
		158,
		182,
		219,
		168,
		157,
		156,
		-1,
		147,
		126,
		123,
		111,
		98,
		83,
		84,
		92,
		104,
		83,
		77,
		74,
		94,
		118,
		96,
		107,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		165,
		136,
		160,
		202,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		122,
		101,
		92,
		81,
		79,
		92,
		84,
		92,
		72,
		70,
		89,
		99,
		90,
		98,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		131,
		154,
		191,
		165,
		151,
		156,
		131,
		124,
		118,
		135,
		118,
		99,
		88,
		80,
		69,
		80,
		88,
		86,
		68,
		77,
		83,
		105,
		86,
		92,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		145,
		152,
		184,
		156,
		169,
		-1,
		123,
		-1,
		112,
		108,
		93,
		88,
		85,
		72,
		71,
		85,
		85,
		75,
		70,
		77,
		110,
		110,
		76,
		95,
		98,
		-1,
		-1,
		-1,
		195,
		190,
		165,
		142,
		126,
		162,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		95,
		91,
		76,
		80,
		82,
		85,
		73,
		79,
		80,
		62,
		86,
		-1,
		84,
		78,
		85,
		75,
		64,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		121,
		173,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		88,
		83,
		82,
		81,
		78,
		67,
		80,
		73,
		67,
		61,
		74,
		78,
		79,
		66,
		62,
		59,
		73,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		141,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		110,
		94,
		93,
		90,
		81,
		89,
		62,
		55,
		66,
		51,
		69,
		75,
		66,
		60,
		52,
		69,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		100,
		117,
		118,
		96,
		90,
		88,
		79,
		67,
		56,
		59,
		51,
		73,
		70,
		54,
		55,
		48,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		114,
		112,
		107,
		98,
		104,
		99,
		76,
		71,
		61,
		50,
		50,
		45,
		64,
		50,
		48,
		46,
		62,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		115,
		99,
		104,
		-1,
		96,
		-1,
		69,
		66,
		57,
		42,
		39,
		50,
		48,
		57,
		41,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		131,
		111,
		105,
		104,
		91,
		83,
		77,
		55,
		48,
		45,
		35,
		48,
		58,
		55,
		39,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		129,
		137,
		125,
		115,
		105,
		109,
		99,
		74,
		67,
		53,
		55,
		47,
		37,
		36,
		41,
		33,
		52,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		159,
		130,
		126,
		-1,
		-1,
		109,
		101,
		91,
		70,
		57,
		66,
		61,
		46,
		30,
		45,
		33,
		42,
		31,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		177,
		122,
		111,
		106,
		110,
		108,
		-1,
		82,
		81,
		61,
		73,
		80,
		48,
		35,
		29,
		21,
		28,
		36,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		134,
		128,
		99,
		92,
		96,
		-1,
		84,
		77,
		63,
		79,
		53,
		50,
		41,
		32,
		26,
		18,
		16,
		34,
		38,
		190,
		-1,
		162,
		-1,
		-1,
		-1,
		152,
		167,
		138,
		115,
		88,
		83,
		76,
		70,
		71,
		75,
		61,
		72,
		39,
		35,
		23,
		10,
		14,
		29,
		39,
		-1,
		-1,
		160,
		156,
		178,
		160,
		164,
		165,
		-1,
		-1,
		92,
		83,
		74,
		66,
		79,
		79,
		45,
		42,
		34,
		27,
		19,
		0,
		29,
		41,
		-1,
		-1,
		-1,
		172,
		-1,
		174,
		-1,
		-1,
		162,
		163,
		110,
		92,
		88,
		86,
		75,
		69,
		57,
		50,
		55,
		45,
		37,
		17,
		32,
		39,
		49,
		76,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		151,
		143,
		138,
		144,
		146,
		137,
		125,
		122,
		-1,
		92,
		98,
		63,
		70,
		53,
		52,
		49,
		41,
		22,
		34,
		50,
		51,
		46,
		68,
		63,
		72,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		144,
		140,
		130,
		120,
		123,
		-1,
		-1,
		117,
		114,
		94,
		63,
		61,
		54,
		49,
		59,
		39,
		26,
		29,
		33,
		39,
		44,
		49,
		55,
		70,
		78,
		-1,
		191,
		228,
		221,
		189,
		197,
		228,
		-1,
		134,
		126,
		137,
		112,
		114,
		-1,
		-1,
		90,
		81,
		82,
		70,
		67,
		69,
		64,
		55,
		40,
		46,
		33,
		31,
		49,
		53,
		62,
		69,
		59,
		72,
		76,
		-1,
		184,
		204,
		183,
		186,
		210,
		224,
		-1,
		131,
		-1,
		-1,
		143,
		115,
		99,
		89,
		86,
		129,
		84,
		79,
		63,
		61,
		52,
		43,
		50,
		41,
		40,
		43,
		59,
		64,
		56,
		69,
		69,
		70,
		-1,
		173,
		184,
		177,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		159,
		-1,
		126,
		-1,
		109,
		113,
		92,
		95,
		77,
		64,
		56,
		48,
		64,
		39,
		48,
		44,
		46,
		55,
		66,
		78,
		76,
		77,
		198,
		154,
		157,
		168,
		179,
		194,
		198,
		-1,
		143,
		182,
		176,
		-1,
		160,
		-1,
		-1,
		-1,
		123,
		105,
		97,
		97,
		76,
		76,
		50,
		54,
		44,
		51,
		60,
		62,
		55,
		59,
		72,
		83,
		85,
		194,
		185,
		198,
		143,
		143,
		164,
		173,
		194,
		158,
		149,
		176,
		183,
		172,
		167,
		154,
		-1,
		-1,
		146,
		115,
		-1,
		-1,
		83,
		71,
		54,
		55,
		51,
		54,
		69,
		71,
		62,
		60,
		54,
		86,
		-1,
		187,
		186,
		175,
		172,
		148,
		139,
		134,
		161,
		-1,
		-1,
		156,
		177,
		167,
		171,
		187,
		212,
		-1,
		143,
		-1,
		-1,
		128,
		-1,
		-1,
		113,
		76,
		65,
		56,
		62,
		59,
		70,
		80,
		68,
		69,
		59,
		69,
		82,
		171,
		168,
		156,
		154,
		177,
		142,
		130,
		-1,
		143,
		141,
		147,
		154,
		171,
		201,
		-1,
		-1,
		159,
		139,
		-1,
		-1,
		111,
		109,
		98,
		-1,
		88,
		61,
		66,
		86,
		88,
		77,
		71,
		65,
		72,
		71,
		79,
		87,
		180,
		194,
		183,
		179,
		178,
		186,
		135,
		128,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		145,
		-1,
		-1,
		106,
		99,
		87,
		75,
		65,
		75,
		79,
		83,
		75,
		68,
		63,
		74,
		66,
		70,
		87,
		-1,
		214,
		-1,
		166,
		142,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		140,
		124,
		105,
		-1,
		75,
		88,
		119,
		87,
		92,
		87,
		69,
		80,
		69,
		72,
		86,
		81,
		-1,
		-1,
		154,
		157,
		-1,
		-1,
		156,
		158,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		112,
		108,
		-1,
		-1,
		76,
		101,
		90,
		98,
		93,
		73,
		79,
		82,
		71,
		75,
		87,
		-1,
		-1,
		161,
		162,
		163,
		-1,
		141,
		-1,
		159,
		-1,
		126,
		132,
		120,
		-1,
		-1,
		-1,
		114,
		77,
		98,
		108,
		102,
		100,
		91,
		77,
		84,
		82,
		78,
		89,
		-1,
		-1,
		-1,
		159,
		133,
		166,
		157,
		140,
		120,
		112,
		131,
		-1,
		101,
		-1,
		76,
		78,
		104,
		107,
		113,
		107,
		80,
		95,
		85,
		76,
		85,
		165,
		-1,
		135,
		168,
		132,
		126,
		102,
		106,
		122,
		-1,
		98,
		80,
		-1,
		108,
		98,
		129,
		114,
		95,
		82,
		89,
		89,
		82,
		-1,
		-1,
		-1,
		137,
		136,
		128,
		122,
		122,
		107,
		98,
		-1,
		110,
		92,
		71,
		88,
		88,
		79,
		87,
		119,
		115,
		102,
		102,
		94,
		-1,
		238,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		131,
		126,
		99,
		87,
		93,
		89,
		75,
		81,
		83,
		91,
		89,
		86,
		98,
		94,
		114,
		95,
		130,
		-1,
		233,
		-1,
		167,
		-1,
		-1,
		149,
		129,
		121,
		110,
		99,
		97,
		88,
		79,
		101,
		117,
		101,
		99,
		102,
		103,
		-1,
		222,
		221,
		-1,
		168,
		160,
		146,
		-1,
		139,
		-1,
		145,
		106,
		-1,
		108,
		88,
		-1,
		110,
		106,
		-1,
		-1,
		209,
		184,
		-1,
		-1,
		-1,
		169,
		149,
		140,
		124,
		-1,
		99,
		99,
		-1,
		-1,
		-1,
		194,
		193,
		-1,
		162,
		165,
		-1,
		155,
		146,
		154,
		101,
		105,
		-1,
		-1,
		-1,
		203,
		184,
		178,
		177,
		175,
		170,
		167,
		153,
		137,
		115,
		104,
		125,
		-1,
		-1,
		-1,
		175,
		167,
		160,
		-1,
		-1,
		162,
		145,
		126,
		124,
		-1,
		-1,
		-1,
		197,
		178,
		-1,
		-1,
		152,
		-1,
		-1,
		158,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		186,
		-1,
		-1,
		-1,
		148,
		144,
		145,
		-1,
		-1,
		-1,
		-1,
		208,
		209,
		232,
		196,
		-1,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		211,
		209,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		138,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		173,
		-1,
		173,
		148,
		155,
		-1,
		-1,
		-1,
		-1,
		186,
		178,
		186,
		-1,
		158,
		160,
		-1,
		208,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		163,
		170,
		192,
		195,
		231,
		-1,
		182
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		218,
		222,
		188,
		182,
		221,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		211,
		210,
		178,
		176,
		185,
		190,
		197,
		-1,
		196,
		-1,
		232,
		211,
		222,
		227,
		171,
		168,
		188,
		207,
		189,
		181,
		247,
		201,
		172,
		166,
		184,
		174,
		183,
		175,
		-1,
		172,
		162,
		184,
		163,
		174,
		166,
		-1,
		-1,
		166,
		167,
		173,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		156,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		153,
		171,
		176,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		150,
		-1,
		162,
		163,
		158,
		166,
		166,
		142,
		129,
		129,
		139,
		132,
		151,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		132,
		129,
		127,
		124,
		140,
		138,
		148,
		-1,
		-1,
		253,
		222,
		253,
		211,
		192,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		118,
		117,
		145,
		131,
		142,
		213,
		-1,
		-1,
		211,
		203,
		188,
		191,
		168,
		164,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		112,
		122,
		126,
		124,
		149,
		-1,
		-1,
		182,
		-1,
		-1,
		210,
		193,
		-1,
		176,
		183,
		174,
		180,
		166,
		187,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		109,
		134,
		138,
		119,
		140,
		135,
		-1,
		181,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		169,
		172,
		178,
		202,
		203,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		113,
		111,
		141,
		116,
		138,
		135,
		152,
		157,
		151,
		160,
		-1,
		218,
		214,
		210,
		217,
		166,
		-1,
		-1,
		206,
		-1,
		211,
		212,
		187,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		105,
		120,
		111,
		110,
		128,
		136,
		144,
		148,
		154,
		-1,
		268,
		-1,
		210,
		194,
		196,
		168,
		189,
		-1,
		226,
		212,
		204,
		189,
		187,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		118,
		100,
		114,
		105,
		123,
		130,
		126,
		130,
		150,
		162,
		228,
		218,
		-1,
		200,
		205,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		161,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		111,
		96,
		93,
		111,
		114,
		119,
		123,
		139,
		-1,
		-1,
		213,
		217,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		122,
		101,
		95,
		92,
		112,
		136,
		114,
		125,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		102,
		110,
		90,
		88,
		107,
		117,
		108,
		116,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		153,
		136,
		117,
		106,
		98,
		87,
		98,
		106,
		104,
		86,
		95,
		101,
		123,
		104,
		110,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		126,
		111,
		106,
		103,
		90,
		89,
		103,
		103,
		93,
		88,
		95,
		128,
		128,
		94,
		113,
		116,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		113,
		109,
		94,
		98,
		100,
		103,
		91,
		97,
		98,
		80,
		104,
		-1,
		102,
		96,
		103,
		93,
		82,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		106,
		101,
		100,
		99,
		96,
		85,
		98,
		91,
		85,
		79,
		92,
		96,
		97,
		84,
		80,
		77,
		91,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		128,
		112,
		111,
		108,
		99,
		107,
		80,
		73,
		84,
		69,
		87,
		93,
		84,
		78,
		70,
		87,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		118,
		135,
		136,
		114,
		108,
		106,
		97,
		85,
		74,
		77,
		69,
		91,
		88,
		72,
		73,
		66,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		132,
		130,
		125,
		116,
		122,
		117,
		94,
		89,
		79,
		68,
		68,
		63,
		82,
		68,
		66,
		64,
		74,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		133,
		117,
		122,
		-1,
		114,
		-1,
		87,
		84,
		75,
		60,
		57,
		68,
		66,
		75,
		59,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		149,
		129,
		123,
		122,
		109,
		101,
		95,
		73,
		66,
		63,
		53,
		66,
		76,
		73,
		57,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		154,
		142,
		132,
		122,
		127,
		117,
		92,
		85,
		71,
		73,
		65,
		55,
		54,
		58,
		51,
		69,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		177,
		148,
		143,
		-1,
		-1,
		126,
		119,
		109,
		88,
		75,
		84,
		79,
		64,
		48,
		63,
		50,
		59,
		48,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		194,
		139,
		128,
		123,
		127,
		125,
		-1,
		99,
		99,
		79,
		91,
		98,
		66,
		53,
		47,
		39,
		45,
		45,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		116,
		109,
		113,
		-1,
		101,
		95,
		81,
		97,
		71,
		68,
		59,
		49,
		41,
		36,
		33,
		34,
		38,
		208,
		-1,
		181,
		-1,
		-1,
		-1,
		169,
		184,
		155,
		132,
		105,
		100,
		93,
		87,
		89,
		93,
		79,
		90,
		56,
		52,
		38,
		31,
		32,
		33,
		28,
		-1,
		-1,
		179,
		175,
		195,
		177,
		181,
		182,
		-1,
		-1,
		109,
		100,
		91,
		83,
		96,
		97,
		62,
		59,
		52,
		45,
		33,
		32,
		0,
		22,
		-1,
		-1,
		-1,
		191,
		-1,
		193,
		-1,
		-1,
		181,
		180,
		127,
		109,
		105,
		103,
		92,
		86,
		74,
		67,
		73,
		63,
		55,
		35,
		46,
		22,
		20,
		76,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		170,
		162,
		157,
		163,
		165,
		156,
		142,
		139,
		-1,
		109,
		115,
		80,
		87,
		72,
		70,
		67,
		59,
		40,
		48,
		35,
		32,
		31,
		68,
		60,
		64,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		163,
		159,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		112,
		82,
		80,
		73,
		68,
		78,
		58,
		45,
		46,
		50,
		36,
		29,
		34,
		40,
		55,
		70,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		153,
		145,
		156,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		88,
		83,
		74,
		59,
		65,
		52,
		48,
		64,
		50,
		47,
		54,
		53,
		64,
		68,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		150,
		-1,
		-1,
		162,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		82,
		80,
		71,
		62,
		69,
		60,
		57,
		60,
		58,
		62,
		56,
		63,
		58,
		64,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		178,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		96,
		83,
		75,
		67,
		83,
		58,
		65,
		61,
		65,
		74,
		66,
		79,
		70,
		64,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		162,
		201,
		195,
		-1,
		179,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		116,
		95,
		95,
		69,
		73,
		63,
		70,
		77,
		79,
		74,
		78,
		89,
		80,
		72,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		168,
		195,
		202,
		191,
		186,
		173,
		-1,
		-1,
		165,
		134,
		-1,
		-1,
		102,
		90,
		73,
		74,
		70,
		73,
		88,
		88,
		81,
		79,
		73,
		85,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		196,
		186,
		190,
		206,
		231,
		-1,
		162,
		-1,
		-1,
		147,
		-1,
		-1,
		132,
		95,
		84,
		75,
		81,
		78,
		89,
		99,
		87,
		88,
		78,
		88,
		99,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		178,
		158,
		-1,
		-1,
		130,
		128,
		117,
		-1,
		107,
		80,
		85,
		105,
		107,
		96,
		90,
		84,
		91,
		90,
		98,
		104,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		164,
		-1,
		-1,
		125,
		118,
		106,
		94,
		84,
		94,
		98,
		102,
		94,
		87,
		82,
		93,
		85,
		89,
		101,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		159,
		143,
		124,
		-1,
		94,
		107,
		138,
		106,
		111,
		106,
		88,
		99,
		88,
		91,
		94,
		97,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		175,
		177,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		131,
		127,
		-1,
		-1,
		95,
		120,
		109,
		117,
		112,
		92,
		98,
		101,
		90,
		94,
		94,
		-1,
		-1,
		180,
		181,
		182,
		-1,
		160,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		133,
		96,
		117,
		127,
		121,
		119,
		110,
		96,
		103,
		101,
		97,
		104,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		97,
		123,
		126,
		132,
		126,
		99,
		114,
		104,
		95,
		104,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		117,
		148,
		133,
		114,
		101,
		108,
		108,
		101,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		138,
		134,
		121,
		121,
		113,
		-1,
		257,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		117,
		113,
		133,
		114,
		149,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		120,
		118,
		121,
		122,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		129,
		125,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		148,
		166,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		157,
		158,
		153,
		161,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		140,
		157,
		149,
		139,
		154,
		147,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		248,
		217,
		248,
		206,
		187,
		-1,
		153,
		133,
		139,
		143,
		137,
		130,
		144,
		140,
		-1,
		113,
		112,
		140,
		126,
		137,
		208,
		-1,
		-1,
		206,
		198,
		183,
		186,
		163,
		159,
		148,
		147,
		139,
		125,
		121,
		127,
		130,
		130,
		136,
		107,
		117,
		121,
		119,
		144,
		-1,
		-1,
		172,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		169,
		175,
		161,
		182,
		158,
		149,
		141,
		135,
		123,
		125,
		122,
		135,
		123,
		104,
		129,
		133,
		114,
		135,
		130,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		198,
		-1,
		170,
		158,
		159,
		144,
		141,
		128,
		116,
		129,
		114,
		121,
		120,
		108,
		106,
		136,
		111,
		133,
		130,
		142,
		147,
		141,
		150,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		206,
		207,
		182,
		155,
		158,
		145,
		136,
		123,
		112,
		123,
		112,
		109,
		117,
		100,
		115,
		106,
		105,
		123,
		126,
		134,
		138,
		144,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		207,
		199,
		184,
		182,
		-1,
		154,
		151,
		141,
		119,
		104,
		121,
		113,
		111,
		113,
		95,
		109,
		100,
		118,
		125,
		116,
		120,
		140,
		152,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		156,
		169,
		-1,
		125,
		121,
		103,
		104,
		99,
		114,
		106,
		91,
		88,
		106,
		109,
		109,
		113,
		129,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		139,
		136,
		124,
		111,
		96,
		97,
		105,
		117,
		96,
		90,
		87,
		107,
		126,
		104,
		115,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		135,
		114,
		105,
		94,
		92,
		105,
		97,
		105,
		85,
		83,
		102,
		107,
		98,
		106,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		148,
		131,
		112,
		101,
		93,
		82,
		93,
		101,
		99,
		81,
		90,
		96,
		113,
		94,
		100,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		121,
		106,
		101,
		98,
		85,
		84,
		98,
		98,
		88,
		83,
		90,
		118,
		118,
		84,
		103,
		106,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		108,
		104,
		89,
		93,
		95,
		98,
		86,
		92,
		93,
		75,
		99,
		-1,
		92,
		86,
		93,
		83,
		72,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		101,
		96,
		95,
		94,
		91,
		80,
		93,
		86,
		80,
		74,
		87,
		91,
		91,
		74,
		70,
		67,
		71,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		123,
		107,
		106,
		103,
		94,
		102,
		75,
		68,
		79,
		64,
		82,
		88,
		78,
		68,
		60,
		67,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		113,
		130,
		131,
		109,
		103,
		101,
		92,
		80,
		69,
		72,
		64,
		86,
		82,
		66,
		63,
		56,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		127,
		125,
		120,
		111,
		117,
		112,
		89,
		84,
		74,
		63,
		63,
		58,
		77,
		63,
		61,
		54,
		52,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		128,
		112,
		117,
		-1,
		109,
		-1,
		82,
		79,
		70,
		55,
		52,
		63,
		61,
		70,
		49,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		144,
		124,
		118,
		117,
		104,
		96,
		90,
		68,
		61,
		58,
		48,
		61,
		71,
		63,
		47,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		150,
		138,
		128,
		118,
		122,
		112,
		87,
		80,
		66,
		68,
		60,
		50,
		49,
		54,
		46,
		51,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		172,
		143,
		139,
		-1,
		-1,
		122,
		114,
		104,
		83,
		70,
		79,
		74,
		59,
		43,
		58,
		49,
		41,
		33,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		190,
		135,
		124,
		119,
		123,
		121,
		-1,
		95,
		94,
		74,
		86,
		93,
		61,
		49,
		43,
		34,
		44,
		27,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		112,
		105,
		109,
		-1,
		97,
		90,
		76,
		92,
		67,
		64,
		55,
		45,
		45,
		31,
		31,
		12,
		18,
		203,
		-1,
		176,
		-1,
		-1,
		-1,
		165,
		180,
		151,
		128,
		101,
		96,
		89,
		83,
		84,
		89,
		75,
		86,
		52,
		48,
		44,
		31,
		27,
		16,
		6,
		-1,
		-1,
		174,
		170,
		191,
		173,
		177,
		178,
		-1,
		-1,
		105,
		96,
		87,
		79,
		92,
		93,
		58,
		55,
		55,
		48,
		41,
		40,
		15,
		0,
		-1,
		-1,
		-1,
		186,
		-1,
		188,
		-1,
		-1,
		176,
		176,
		123,
		105,
		101,
		99,
		88,
		82,
		70,
		63,
		73,
		66,
		58,
		38,
		44,
		35,
		8,
		54,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		165,
		157,
		152,
		158,
		160,
		151,
		138,
		135,
		-1,
		105,
		111,
		76,
		83,
		67,
		73,
		70,
		62,
		43,
		41,
		32,
		20,
		19,
		46,
		41,
		50,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		158,
		154,
		144,
		134,
		137,
		-1,
		-1,
		131,
		128,
		108,
		77,
		75,
		68,
		63,
		73,
		53,
		40,
		34,
		38,
		24,
		17,
		22,
		28,
		43,
		56,
		-1,
		205,
		242,
		235,
		203,
		211,
		242,
		-1,
		148,
		140,
		151,
		126,
		128,
		-1,
		-1,
		104,
		95,
		96,
		84,
		81,
		83,
		78,
		69,
		54,
		60,
		47,
		36,
		52,
		38,
		35,
		42,
		41,
		52,
		56,
		-1,
		198,
		218,
		197,
		200,
		224,
		238,
		-1,
		145,
		-1,
		-1,
		157,
		129,
		113,
		103,
		100,
		143,
		98,
		93,
		77,
		75,
		66,
		57,
		64,
		51,
		45,
		48,
		46,
		50,
		44,
		51,
		46,
		52,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		173,
		-1,
		140,
		-1,
		123,
		127,
		106,
		109,
		91,
		78,
		70,
		62,
		78,
		53,
		53,
		49,
		53,
		62,
		54,
		67,
		58,
		52,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		157,
		196,
		190,
		-1,
		174,
		-1,
		-1,
		-1,
		137,
		119,
		111,
		111,
		90,
		90,
		64,
		68,
		58,
		58,
		65,
		67,
		62,
		66,
		77,
		68,
		60,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		172,
		163,
		190,
		197,
		186,
		181,
		168,
		-1,
		-1,
		160,
		129,
		-1,
		-1,
		97,
		85,
		68,
		69,
		65,
		68,
		83,
		76,
		69,
		67,
		61,
		73,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		170,
		191,
		181,
		185,
		201,
		226,
		-1,
		157,
		-1,
		-1,
		142,
		-1,
		-1,
		127,
		90,
		79,
		70,
		76,
		73,
		84,
		94,
		75,
		76,
		66,
		76,
		87,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		157,
		155,
		161,
		168,
		185,
		215,
		-1,
		-1,
		173,
		153,
		-1,
		-1,
		125,
		123,
		112,
		-1,
		102,
		75,
		80,
		100,
		95,
		84,
		78,
		72,
		79,
		78,
		86,
		92,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		163,
		159,
		-1,
		-1,
		120,
		113,
		101,
		89,
		79,
		89,
		93,
		96,
		82,
		75,
		70,
		81,
		73,
		77,
		89,
		-1,
		228,
		-1,
		180,
		156,
		170,
		185,
		193,
		-1,
		-1,
		-1,
		180,
		166,
		159,
		147,
		145,
		-1,
		154,
		138,
		119,
		-1,
		89,
		102,
		132,
		100,
		100,
		94,
		76,
		87,
		76,
		79,
		82,
		85,
		-1,
		-1,
		168,
		171,
		-1,
		-1,
		170,
		172,
		-1,
		171,
		160,
		145,
		137,
		-1,
		-1,
		126,
		122,
		-1,
		-1,
		90,
		114,
		103,
		106,
		101,
		80,
		86,
		89,
		78,
		82,
		82,
		-1,
		-1,
		175,
		176,
		177,
		-1,
		155,
		-1,
		173,
		-1,
		140,
		146,
		134,
		-1,
		-1,
		-1,
		128,
		91,
		112,
		121,
		109,
		107,
		98,
		84,
		91,
		89,
		85,
		92,
		-1,
		-1,
		-1,
		173,
		147,
		180,
		171,
		154,
		134,
		126,
		145,
		-1,
		115,
		-1,
		90,
		92,
		118,
		117,
		120,
		114,
		87,
		102,
		92,
		83,
		92,
		179,
		-1,
		149,
		182,
		146,
		140,
		116,
		120,
		136,
		-1,
		112,
		94,
		-1,
		122,
		112,
		136,
		121,
		102,
		89,
		96,
		96,
		89,
		-1,
		-1,
		-1,
		151,
		150,
		142,
		136,
		136,
		121,
		112,
		-1,
		124,
		106,
		85,
		102,
		102,
		93,
		101,
		126,
		122,
		109,
		109,
		101,
		-1,
		252,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		145,
		140,
		113,
		101,
		107,
		103,
		89,
		95,
		97,
		105,
		103,
		100,
		112,
		108,
		125,
		102,
		137,
		-1,
		247,
		-1,
		181,
		-1,
		-1,
		163,
		143,
		135,
		124,
		113,
		111,
		102,
		93,
		115,
		131,
		115,
		113,
		109,
		110,
		-1,
		236,
		235,
		-1,
		182,
		174,
		160,
		-1,
		153,
		-1,
		159,
		120,
		-1,
		122,
		102,
		-1,
		124,
		114,
		-1,
		-1,
		223,
		198,
		-1,
		-1,
		-1,
		183,
		163,
		154,
		138,
		-1,
		113,
		113,
		-1,
		-1,
		-1,
		208,
		207,
		-1,
		176,
		179,
		-1,
		169,
		160,
		168,
		115,
		119,
		-1,
		-1,
		-1,
		217,
		198,
		192,
		191,
		189,
		184,
		181,
		167,
		151,
		129,
		118,
		139,
		-1,
		-1,
		-1,
		189,
		181,
		174,
		-1,
		-1,
		176,
		159,
		140,
		138,
		-1,
		-1,
		-1,
		211,
		192,
		-1,
		-1,
		166,
		-1,
		-1,
		172,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		200,
		-1,
		-1,
		-1,
		162,
		158,
		159,
		-1,
		-1,
		-1,
		-1,
		222,
		223,
		246,
		210,
		-1,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		225,
		223,
		-1,
		-1,
		-1,
		182,
		166,
		-1,
		152,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		187,
		-1,
		187,
		162,
		169,
		-1,
		-1,
		-1,
		-1,
		200,
		192,
		200,
		-1,
		172,
		174,
		-1,
		222,
		-1,
		-1,
		215,
		206,
		-1,
		-1,
		177,
		184,
		206,
		209,
		245,
		-1,
		196
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		224,
		213,
		224,
		232,
		205,
		212,
		-1,
		233,
		235,
		201,
		195,
		234,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		224,
		223,
		193,
		191,
		200,
		205,
		212,
		-1,
		235,
		-1,
		245,
		224,
		235,
		240,
		186,
		183,
		203,
		222,
		228,
		220,
		260,
		216,
		187,
		181,
		199,
		204,
		222,
		214,
		-1,
		187,
		177,
		199,
		203,
		215,
		198,
		-1,
		-1,
		181,
		182,
		188,
		200,
		205,
		210,
		-1,
		233,
		217,
		-1,
		-1,
		171,
		184,
		180,
		183,
		191,
		207,
		225,
		217,
		212,
		-1,
		-1,
		172,
		176,
		189,
		190,
		188,
		212,
		225,
		207,
		221,
		220,
		-1,
		160,
		178,
		187,
		196,
		202,
		188,
		186,
		204,
		206,
		212,
		215,
		-1,
		152,
		154,
		183,
		189,
		201,
		204,
		191,
		191,
		201,
		194,
		213,
		204,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		149,
		157,
		183,
		182,
		178,
		196,
		201,
		194,
		191,
		189,
		186,
		202,
		203,
		213,
		-1,
		-1,
		205,
		174,
		209,
		166,
		151,
		-1,
		145,
		164,
		170,
		174,
		179,
		184,
		198,
		194,
		-1,
		180,
		179,
		210,
		196,
		207,
		165,
		-1,
		-1,
		163,
		155,
		140,
		143,
		140,
		140,
		170,
		169,
		174,
		176,
		175,
		181,
		184,
		184,
		190,
		174,
		184,
		188,
		199,
		214,
		-1,
		-1,
		269,
		-1,
		-1,
		162,
		145,
		-1,
		128,
		135,
		135,
		152,
		142,
		163,
		178,
		182,
		190,
		189,
		177,
		179,
		176,
		189,
		177,
		171,
		196,
		200,
		194,
		215,
		210,
		-1,
		268,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		121,
		124,
		130,
		154,
		164,
		-1,
		185,
		183,
		207,
		198,
		195,
		182,
		170,
		183,
		168,
		175,
		174,
		178,
		180,
		213,
		191,
		213,
		210,
		239,
		244,
		238,
		247,
		-1,
		170,
		166,
		162,
		169,
		118,
		-1,
		-1,
		158,
		-1,
		172,
		185,
		189,
		187,
		190,
		199,
		190,
		177,
		166,
		177,
		166,
		163,
		171,
		180,
		191,
		186,
		185,
		203,
		218,
		231,
		235,
		241,
		-1,
		220,
		-1,
		162,
		146,
		148,
		120,
		141,
		-1,
		178,
		173,
		193,
		191,
		182,
		-1,
		185,
		188,
		195,
		173,
		158,
		175,
		167,
		165,
		170,
		175,
		189,
		180,
		198,
		205,
		213,
		217,
		237,
		249,
		180,
		170,
		-1,
		152,
		157,
		116,
		124,
		143,
		216,
		188,
		-1,
		183,
		-1,
		175,
		200,
		-1,
		179,
		175,
		157,
		158,
		153,
		168,
		174,
		171,
		168,
		186,
		189,
		206,
		210,
		226,
		-1,
		-1,
		165,
		169,
		158,
		109,
		128,
		152,
		189,
		181,
		170,
		169,
		-1,
		160,
		190,
		187,
		173,
		160,
		150,
		151,
		159,
		172,
		151,
		170,
		173,
		195,
		223,
		201,
		213,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		135,
		106,
		130,
		172,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		180,
		163,
		159,
		148,
		146,
		159,
		154,
		170,
		174,
		173,
		192,
		204,
		195,
		215,
		-1,
		-1,
		-1,
		165,
		154,
		155,
		101,
		124,
		161,
		178,
		164,
		169,
		144,
		137,
		131,
		183,
		180,
		147,
		155,
		147,
		136,
		150,
		158,
		162,
		171,
		180,
		186,
		210,
		210,
		216,
		-1,
		-1,
		172,
		162,
		146,
		148,
		145,
		115,
		122,
		154,
		169,
		166,
		-1,
		136,
		-1,
		125,
		133,
		132,
		138,
		150,
		136,
		141,
		152,
		164,
		177,
		173,
		180,
		215,
		215,
		200,
		220,
		223,
		-1,
		-1,
		-1,
		165,
		160,
		135,
		112,
		96,
		132,
		-1,
		136,
		137,
		-1,
		130,
		124,
		130,
		129,
		136,
		133,
		133,
		147,
		155,
		151,
		167,
		173,
		165,
		201,
		-1,
		208,
		202,
		210,
		200,
		188,
		-1,
		-1,
		-1,
		158,
		137,
		130,
		150,
		91,
		143,
		-1,
		-1,
		121,
		114,
		-1,
		117,
		117,
		124,
		133,
		138,
		143,
		151,
		146,
		159,
		164,
		170,
		175,
		193,
		197,
		201,
		190,
		186,
		183,
		197,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		111,
		-1,
		129,
		121,
		112,
		106,
		112,
		130,
		128,
		148,
		140,
		154,
		154,
		160,
		168,
		153,
		156,
		172,
		170,
		188,
		196,
		188,
		182,
		181,
		193,
		-1,
		178,
		164,
		135,
		-1,
		-1,
		124,
		-1,
		88,
		107,
		123,
		-1,
		146,
		125,
		148,
		126,
		140,
		136,
		174,
		175,
		153,
		158,
		166,
		176,
		178,
		167,
		178,
		170,
		192,
		192,
		176,
		177,
		186,
		-1,
		184,
		171,
		129,
		125,
		114,
		134,
		85,
		94,
		110,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		150,
		148,
		164,
		155,
		161,
		177,
		180,
		182,
		172,
		161,
		167,
		164,
		186,
		172,
		170,
		189,
		205,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		100,
		87,
		81,
		-1,
		127,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		172,
		156,
		161,
		-1,
		207,
		-1,
		180,
		182,
		175,
		161,
		158,
		169,
		167,
		178,
		186,
		-1,
		134,
		119,
		112,
		102,
		116,
		84,
		-1,
		118,
		-1,
		-1,
		155,
		149,
		149,
		125,
		122,
		188,
		168,
		162,
		161,
		192,
		179,
		178,
		166,
		166,
		164,
		161,
		174,
		186,
		185,
		184,
		-1,
		-1,
		-1,
		139,
		114,
		108,
		80,
		84,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		117,
		205,
		193,
		183,
		173,
		179,
		180,
		170,
		168,
		164,
		173,
		172,
		165,
		164,
		185,
		178,
		200,
		-1,
		-1,
		113,
		106,
		94,
		62,
		57,
		-1,
		-1,
		-1,
		164,
		155,
		143,
		115,
		193,
		-1,
		-1,
		178,
		171,
		165,
		163,
		156,
		176,
		183,
		171,
		158,
		173,
		183,
		191,
		190,
		-1,
		116,
		103,
		-1,
		-1,
		56,
		46,
		-1,
		-1,
		-1,
		-1,
		133,
		114,
		126,
		147,
		165,
		177,
		-1,
		150,
		154,
		154,
		174,
		181,
		173,
		158,
		152,
		163,
		178,
		195,
		-1,
		-1,
		70,
		-1,
		32,
		-1,
		-1,
		-1,
		-1,
		105,
		120,
		140,
		146,
		151,
		-1,
		148,
		147,
		151,
		157,
		169,
		173,
		164,
		146,
		160,
		163,
		176,
		190,
		194,
		93,
		-1,
		25,
		-1,
		-1,
		-1,
		82,
		112,
		187,
		164,
		143,
		136,
		133,
		139,
		143,
		155,
		164,
		175,
		140,
		144,
		159,
		164,
		168,
		185,
		189,
		-1,
		-1,
		23,
		30,
		65,
		77,
		109,
		214,
		-1,
		-1,
		132,
		125,
		135,
		135,
		148,
		151,
		136,
		138,
		156,
		169,
		163,
		173,
		188,
		183,
		-1,
		-1,
		-1,
		0,
		-1,
		48,
		-1,
		-1,
		118,
		205,
		152,
		134,
		130,
		116,
		130,
		124,
		126,
		131,
		150,
		145,
		154,
		159,
		163,
		186,
		175,
		214,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		29,
		37,
		52,
		97,
		102,
		93,
		167,
		164,
		-1,
		112,
		153,
		121,
		135,
		131,
		138,
		143,
		149,
		153,
		160,
		176,
		175,
		170,
		206,
		197,
		203,
		-1,
		-1,
		214,
		203,
		192,
		198,
		-1,
		35,
		54,
		83,
		73,
		79,
		-1,
		-1,
		126,
		123,
		126,
		113,
		119,
		124,
		127,
		165,
		141,
		149,
		153,
		157,
		163,
		168,
		173,
		179,
		194,
		209,
		-1,
		161,
		205,
		198,
		166,
		174,
		205,
		-1,
		38,
		52,
		61,
		65,
		73,
		-1,
		-1,
		99,
		95,
		100,
		109,
		112,
		148,
		147,
		160,
		163,
		168,
		156,
		155,
		173,
		177,
		186,
		193,
		183,
		196,
		200,
		-1,
		161,
		181,
		160,
		163,
		187,
		201,
		-1,
		51,
		-1,
		-1,
		83,
		86,
		94,
		90,
		94,
		147,
		123,
		118,
		131,
		133,
		157,
		148,
		173,
		164,
		164,
		167,
		182,
		187,
		179,
		193,
		193,
		194,
		-1,
		150,
		161,
		154,
		-1,
		-1,
		-1,
		-1,
		58,
		-1,
		-1,
		99,
		-1,
		120,
		-1,
		113,
		117,
		131,
		134,
		156,
		143,
		150,
		167,
		173,
		162,
		172,
		168,
		169,
		178,
		189,
		201,
		200,
		201,
		175,
		131,
		134,
		145,
		156,
		171,
		175,
		-1,
		69,
		108,
		137,
		-1,
		108,
		-1,
		-1,
		-1,
		127,
		144,
		136,
		152,
		155,
		155,
		151,
		155,
		167,
		174,
		184,
		186,
		178,
		182,
		195,
		206,
		209,
		171,
		162,
		175,
		120,
		120,
		141,
		150,
		171,
		84,
		75,
		102,
		144,
		133,
		128,
		115,
		-1,
		-1,
		150,
		154,
		-1,
		-1,
		162,
		172,
		155,
		157,
		161,
		175,
		187,
		195,
		185,
		183,
		177,
		209,
		-1,
		164,
		163,
		152,
		149,
		125,
		116,
		111,
		138,
		-1,
		-1,
		87,
		103,
		116,
		120,
		136,
		161,
		-1,
		118,
		-1,
		-1,
		171,
		-1,
		-1,
		214,
		177,
		166,
		157,
		163,
		169,
		180,
		202,
		191,
		192,
		182,
		192,
		205,
		148,
		145,
		133,
		131,
		154,
		119,
		107,
		-1,
		102,
		90,
		96,
		103,
		120,
		150,
		-1,
		-1,
		134,
		125,
		-1,
		-1,
		190,
		197,
		199,
		-1,
		189,
		162,
		167,
		192,
		199,
		200,
		194,
		188,
		195,
		194,
		202,
		210,
		157,
		171,
		160,
		156,
		155,
		163,
		112,
		105,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		169,
		144,
		-1,
		-1,
		197,
		200,
		188,
		176,
		166,
		176,
		184,
		184,
		187,
		191,
		186,
		197,
		189,
		193,
		210,
		-1,
		191,
		-1,
		143,
		111,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		186,
		172,
		165,
		153,
		151,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		220,
		188,
		193,
		188,
		192,
		203,
		192,
		195,
		209,
		204,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		156,
		175,
		-1,
		177,
		166,
		151,
		143,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		177,
		202,
		191,
		199,
		194,
		196,
		202,
		205,
		194,
		198,
		210,
		-1,
		-1,
		136,
		139,
		144,
		-1,
		165,
		-1,
		201,
		-1,
		146,
		162,
		164,
		-1,
		-1,
		-1,
		215,
		178,
		199,
		209,
		214,
		212,
		203,
		200,
		207,
		205,
		201,
		212,
		-1,
		-1,
		-1,
		195,
		172,
		208,
		199,
		182,
		162,
		154,
		179,
		-1,
		203,
		-1,
		178,
		179,
		206,
		208,
		225,
		219,
		203,
		218,
		208,
		199,
		208,
		201,
		-1,
		176,
		235,
		200,
		168,
		168,
		167,
		224,
		-1,
		200,
		182,
		-1,
		210,
		200,
		242,
		223,
		216,
		203,
		210,
		212,
		205,
		-1,
		-1,
		-1,
		191,
		190,
		189,
		190,
		188,
		173,
		168,
		-1,
		212,
		194,
		173,
		190,
		190,
		181,
		189,
		232,
		228,
		221,
		223,
		213,
		-1,
		263,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		199,
		208,
		181,
		169,
		183,
		190,
		177,
		183,
		185,
		193,
		191,
		188,
		200,
		196,
		216,
		212,
		244,
		-1,
		270,
		-1,
		221,
		-1,
		-1,
		215,
		201,
		203,
		192,
		181,
		179,
		182,
		180,
		202,
		219,
		203,
		201,
		206,
		211,
		-1,
		280,
		281,
		-1,
		234,
		226,
		212,
		-1,
		205,
		-1,
		227,
		188,
		-1,
		209,
		189,
		-1,
		212,
		208,
		-1,
		-1,
		290,
		250,
		-1,
		-1,
		-1,
		235,
		215,
		222,
		206,
		-1,
		200,
		200,
		-1,
		-1,
		-1,
		275,
		259,
		-1,
		228,
		231,
		-1,
		222,
		228,
		255,
		202,
		206,
		-1,
		-1,
		-1,
		284,
		265,
		259,
		243,
		248,
		236,
		253,
		239,
		238,
		216,
		205,
		226,
		-1,
		-1,
		-1,
		256,
		248,
		248,
		-1,
		-1,
		263,
		246,
		227,
		225,
		-1,
		-1,
		-1,
		278,
		259,
		-1,
		-1,
		253,
		-1,
		-1,
		259,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		267,
		-1,
		-1,
		-1,
		249,
		245,
		246,
		-1,
		-1,
		-1,
		-1,
		288,
		289,
		313,
		288,
		-1,
		-1,
		-1,
		241,
		235,
		-1,
		-1,
		291,
		289,
		-1,
		-1,
		-1,
		269,
		253,
		-1,
		239,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		274,
		-1,
		274,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		287,
		279,
		287,
		-1,
		259,
		261,
		-1,
		309,
		-1,
		-1,
		302,
		293,
		-1,
		-1,
		264,
		271,
		293,
		296,
		332,
		-1,
		283
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		247,
		249,
		215,
		209,
		248,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		238,
		237,
		207,
		205,
		214,
		219,
		226,
		-1,
		249,
		-1,
		259,
		238,
		249,
		254,
		200,
		197,
		217,
		236,
		242,
		234,
		274,
		230,
		201,
		195,
		213,
		218,
		236,
		228,
		-1,
		201,
		191,
		213,
		217,
		229,
		212,
		-1,
		-1,
		195,
		196,
		202,
		214,
		219,
		224,
		-1,
		247,
		231,
		-1,
		-1,
		185,
		198,
		194,
		197,
		205,
		221,
		239,
		231,
		226,
		-1,
		-1,
		186,
		190,
		203,
		204,
		202,
		226,
		239,
		221,
		235,
		234,
		-1,
		174,
		192,
		201,
		210,
		216,
		202,
		200,
		218,
		220,
		226,
		229,
		-1,
		166,
		168,
		197,
		203,
		215,
		218,
		205,
		205,
		215,
		208,
		227,
		218,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		163,
		171,
		197,
		196,
		192,
		210,
		215,
		208,
		205,
		203,
		200,
		216,
		217,
		227,
		-1,
		-1,
		219,
		188,
		223,
		180,
		165,
		-1,
		159,
		178,
		184,
		188,
		193,
		198,
		212,
		208,
		-1,
		194,
		193,
		224,
		210,
		221,
		179,
		-1,
		-1,
		177,
		169,
		154,
		157,
		154,
		154,
		184,
		183,
		188,
		190,
		189,
		195,
		198,
		198,
		204,
		188,
		198,
		202,
		213,
		228,
		-1,
		-1,
		283,
		-1,
		-1,
		176,
		159,
		-1,
		142,
		149,
		149,
		166,
		156,
		177,
		192,
		196,
		204,
		203,
		191,
		193,
		190,
		203,
		191,
		185,
		210,
		214,
		208,
		229,
		224,
		-1,
		282,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		135,
		138,
		144,
		168,
		178,
		-1,
		199,
		197,
		221,
		212,
		209,
		196,
		184,
		197,
		182,
		189,
		188,
		192,
		194,
		227,
		205,
		227,
		224,
		253,
		258,
		252,
		261,
		-1,
		184,
		180,
		176,
		183,
		132,
		-1,
		-1,
		172,
		-1,
		186,
		199,
		203,
		201,
		204,
		213,
		204,
		191,
		180,
		191,
		180,
		177,
		185,
		194,
		205,
		200,
		199,
		217,
		232,
		245,
		249,
		255,
		-1,
		234,
		-1,
		176,
		160,
		162,
		134,
		155,
		-1,
		192,
		187,
		207,
		205,
		196,
		-1,
		199,
		202,
		209,
		187,
		172,
		189,
		181,
		179,
		184,
		189,
		203,
		194,
		212,
		219,
		227,
		231,
		251,
		263,
		194,
		184,
		-1,
		166,
		171,
		130,
		138,
		157,
		230,
		202,
		-1,
		197,
		-1,
		189,
		214,
		-1,
		193,
		189,
		171,
		172,
		167,
		182,
		188,
		185,
		182,
		200,
		203,
		220,
		224,
		240,
		-1,
		-1,
		179,
		183,
		172,
		123,
		142,
		166,
		203,
		195,
		184,
		183,
		-1,
		174,
		204,
		201,
		187,
		174,
		164,
		165,
		173,
		186,
		165,
		184,
		187,
		209,
		237,
		215,
		227,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		149,
		120,
		144,
		186,
		213,
		206,
		194,
		159,
		159,
		153,
		-1,
		194,
		177,
		173,
		162,
		160,
		173,
		168,
		184,
		188,
		187,
		206,
		218,
		209,
		229,
		-1,
		-1,
		-1,
		179,
		168,
		169,
		115,
		138,
		175,
		192,
		178,
		183,
		158,
		151,
		145,
		197,
		194,
		161,
		169,
		161,
		150,
		164,
		172,
		176,
		185,
		194,
		200,
		224,
		224,
		230,
		-1,
		-1,
		186,
		176,
		160,
		162,
		159,
		129,
		136,
		168,
		183,
		180,
		-1,
		150,
		-1,
		139,
		147,
		146,
		152,
		164,
		150,
		155,
		166,
		178,
		191,
		187,
		194,
		229,
		229,
		214,
		234,
		237,
		-1,
		-1,
		-1,
		179,
		174,
		149,
		126,
		110,
		146,
		-1,
		150,
		151,
		-1,
		144,
		138,
		144,
		143,
		150,
		147,
		147,
		161,
		169,
		165,
		181,
		187,
		179,
		215,
		-1,
		222,
		216,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		172,
		151,
		144,
		164,
		105,
		157,
		-1,
		-1,
		135,
		128,
		-1,
		131,
		131,
		138,
		147,
		152,
		157,
		165,
		160,
		173,
		178,
		184,
		189,
		207,
		211,
		215,
		204,
		200,
		197,
		211,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		125,
		-1,
		143,
		135,
		126,
		120,
		126,
		141,
		142,
		162,
		154,
		168,
		168,
		174,
		182,
		167,
		170,
		186,
		184,
		202,
		210,
		202,
		196,
		195,
		207,
		-1,
		192,
		178,
		149,
		-1,
		-1,
		138,
		-1,
		102,
		121,
		137,
		-1,
		160,
		139,
		162,
		140,
		144,
		150,
		188,
		189,
		167,
		172,
		180,
		190,
		192,
		181,
		192,
		184,
		206,
		206,
		190,
		191,
		200,
		-1,
		198,
		185,
		143,
		139,
		128,
		148,
		99,
		108,
		124,
		-1,
		-1,
		168,
		-1,
		122,
		124,
		164,
		162,
		178,
		169,
		175,
		191,
		191,
		186,
		186,
		175,
		181,
		178,
		200,
		186,
		184,
		201,
		217,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		114,
		101,
		95,
		-1,
		141,
		-1,
		146,
		134,
		121,
		103,
		143,
		-1,
		186,
		170,
		175,
		-1,
		211,
		-1,
		183,
		186,
		177,
		174,
		172,
		183,
		181,
		192,
		196,
		-1,
		148,
		133,
		126,
		116,
		130,
		98,
		-1,
		132,
		-1,
		-1,
		133,
		127,
		127,
		96,
		93,
		202,
		182,
		176,
		175,
		194,
		181,
		180,
		168,
		168,
		171,
		173,
		186,
		196,
		199,
		194,
		-1,
		-1,
		-1,
		153,
		128,
		122,
		94,
		98,
		-1,
		-1,
		194,
		150,
		136,
		-1,
		88,
		176,
		166,
		175,
		176,
		181,
		182,
		172,
		170,
		166,
		175,
		179,
		175,
		174,
		195,
		188,
		210,
		-1,
		-1,
		127,
		120,
		108,
		76,
		71,
		-1,
		-1,
		-1,
		140,
		126,
		114,
		86,
		164,
		-1,
		-1,
		180,
		173,
		167,
		170,
		158,
		178,
		185,
		181,
		168,
		183,
		193,
		201,
		200,
		-1,
		130,
		117,
		-1,
		-1,
		70,
		60,
		-1,
		-1,
		-1,
		-1,
		104,
		85,
		97,
		118,
		143,
		179,
		-1,
		153,
		164,
		157,
		176,
		183,
		183,
		168,
		162,
		173,
		188,
		205,
		-1,
		-1,
		84,
		-1,
		43,
		-1,
		-1,
		-1,
		-1,
		76,
		91,
		111,
		117,
		129,
		-1,
		155,
		157,
		154,
		166,
		177,
		182,
		174,
		156,
		170,
		173,
		186,
		200,
		204,
		107,
		-1,
		33,
		-1,
		-1,
		-1,
		53,
		83,
		171,
		148,
		121,
		126,
		136,
		141,
		146,
		165,
		172,
		183,
		150,
		154,
		169,
		174,
		178,
		195,
		199,
		-1,
		-1,
		31,
		21,
		36,
		48,
		80,
		198,
		-1,
		-1,
		136,
		135,
		138,
		145,
		156,
		159,
		146,
		148,
		166,
		179,
		173,
		183,
		198,
		193,
		-1,
		-1,
		-1,
		47,
		-1,
		0,
		-1,
		-1,
		95,
		215,
		162,
		144,
		140,
		126,
		140,
		134,
		136,
		141,
		160,
		155,
		164,
		169,
		173,
		196,
		185,
		224,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		76,
		38,
		41,
		107,
		112,
		103,
		177,
		174,
		-1,
		122,
		163,
		131,
		145,
		141,
		148,
		153,
		159,
		163,
		170,
		186,
		185,
		180,
		216,
		207,
		213,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		82,
		46,
		93,
		83,
		89,
		-1,
		-1,
		136,
		133,
		136,
		123,
		129,
		134,
		137,
		175,
		151,
		159,
		163,
		167,
		173,
		178,
		183,
		189,
		204,
		219,
		-1,
		175,
		242,
		235,
		203,
		211,
		242,
		-1,
		85,
		89,
		55,
		75,
		83,
		-1,
		-1,
		109,
		105,
		110,
		119,
		122,
		158,
		157,
		170,
		173,
		178,
		166,
		165,
		183,
		187,
		196,
		203,
		193,
		206,
		210,
		-1,
		189,
		218,
		197,
		200,
		224,
		238,
		-1,
		94,
		-1,
		-1,
		78,
		96,
		104,
		100,
		104,
		157,
		133,
		128,
		141,
		143,
		167,
		158,
		183,
		174,
		174,
		177,
		192,
		197,
		189,
		203,
		203,
		204,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		94,
		-1,
		130,
		-1,
		123,
		127,
		141,
		144,
		166,
		153,
		160,
		177,
		183,
		172,
		182,
		178,
		179,
		188,
		199,
		211,
		210,
		211,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		106,
		145,
		132,
		-1,
		103,
		-1,
		-1,
		-1,
		137,
		154,
		146,
		162,
		165,
		165,
		161,
		165,
		177,
		184,
		194,
		196,
		188,
		192,
		205,
		216,
		219,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		121,
		112,
		139,
		139,
		128,
		123,
		110,
		-1,
		-1,
		160,
		164,
		-1,
		-1,
		172,
		182,
		165,
		167,
		171,
		185,
		197,
		205,
		195,
		193,
		187,
		219,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		124,
		140,
		153,
		157,
		170,
		195,
		-1,
		113,
		-1,
		-1,
		181,
		-1,
		-1,
		224,
		187,
		176,
		167,
		173,
		179,
		190,
		212,
		201,
		202,
		192,
		202,
		215,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		139,
		127,
		133,
		140,
		157,
		184,
		-1,
		-1,
		129,
		120,
		-1,
		-1,
		200,
		207,
		209,
		-1,
		199,
		172,
		177,
		202,
		209,
		210,
		204,
		198,
		205,
		204,
		212,
		220,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		139,
		-1,
		-1,
		207,
		210,
		198,
		186,
		176,
		186,
		194,
		194,
		197,
		201,
		196,
		207,
		199,
		203,
		220,
		-1,
		228,
		-1,
		180,
		148,
		168,
		183,
		191,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		251,
		235,
		216,
		-1,
		186,
		199,
		230,
		198,
		203,
		198,
		202,
		213,
		202,
		205,
		219,
		214,
		-1,
		-1,
		166,
		169,
		-1,
		-1,
		193,
		212,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		223,
		219,
		-1,
		-1,
		187,
		212,
		201,
		209,
		204,
		206,
		212,
		215,
		204,
		208,
		220,
		-1,
		-1,
		173,
		176,
		181,
		-1,
		202,
		-1,
		196,
		-1,
		141,
		157,
		159,
		-1,
		-1,
		-1,
		225,
		188,
		209,
		219,
		224,
		222,
		213,
		210,
		217,
		215,
		211,
		222,
		-1,
		-1,
		-1,
		222,
		196,
		203,
		194,
		177,
		157,
		149,
		174,
		-1,
		213,
		-1,
		188,
		189,
		216,
		218,
		235,
		229,
		213,
		228,
		218,
		209,
		218,
		228,
		-1,
		198,
		231,
		195,
		163,
		163,
		162,
		227,
		-1,
		210,
		192,
		-1,
		220,
		210,
		252,
		233,
		226,
		213,
		220,
		222,
		215,
		-1,
		-1,
		-1,
		200,
		199,
		191,
		185,
		183,
		168,
		163,
		-1,
		215,
		197,
		183,
		200,
		200,
		191,
		199,
		242,
		238,
		231,
		233,
		223,
		-1,
		300,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		194,
		203,
		176,
		164,
		178,
		185,
		180,
		182,
		195,
		203,
		201,
		198,
		210,
		206,
		226,
		222,
		254,
		-1,
		307,
		-1,
		230,
		-1,
		-1,
		210,
		196,
		198,
		187,
		176,
		174,
		177,
		175,
		197,
		227,
		213,
		211,
		216,
		221,
		-1,
		298,
		297,
		-1,
		229,
		221,
		207,
		-1,
		200,
		-1,
		222,
		183,
		-1,
		204,
		184,
		-1,
		222,
		218,
		-1,
		-1,
		285,
		245,
		-1,
		-1,
		-1,
		230,
		210,
		217,
		201,
		-1,
		195,
		195,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		223,
		226,
		-1,
		217,
		223,
		250,
		197,
		201,
		-1,
		-1,
		-1,
		279,
		260,
		254,
		238,
		243,
		231,
		248,
		234,
		233,
		211,
		200,
		221,
		-1,
		-1,
		-1,
		251,
		243,
		243,
		-1,
		-1,
		258,
		241,
		222,
		220,
		-1,
		-1,
		-1,
		273,
		254,
		-1,
		-1,
		248,
		-1,
		-1,
		254,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		262,
		-1,
		-1,
		-1,
		244,
		240,
		241,
		-1,
		-1,
		-1,
		-1,
		283,
		284,
		308,
		283,
		-1,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		286,
		284,
		-1,
		-1,
		-1,
		264,
		248,
		-1,
		234,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		269,
		-1,
		269,
		244,
		251,
		-1,
		-1,
		-1,
		-1,
		282,
		274,
		282,
		-1,
		254,
		256,
		-1,
		304,
		-1,
		-1,
		297,
		288,
		-1,
		-1,
		259,
		266,
		288,
		291,
		327,
		-1,
		278
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		248,
		237,
		248,
		256,
		229,
		236,
		-1,
		257,
		259,
		225,
		219,
		258,
		229,
		235,
		246,
		-1,
		-1,
		-1,
		248,
		247,
		217,
		215,
		224,
		229,
		236,
		-1,
		240,
		-1,
		269,
		248,
		259,
		264,
		210,
		207,
		227,
		246,
		233,
		225,
		284,
		240,
		211,
		205,
		223,
		218,
		227,
		219,
		-1,
		211,
		201,
		223,
		207,
		218,
		210,
		-1,
		-1,
		205,
		206,
		212,
		203,
		209,
		205,
		-1,
		215,
		199,
		-1,
		-1,
		195,
		201,
		185,
		188,
		196,
		194,
		207,
		199,
		194,
		-1,
		-1,
		191,
		187,
		194,
		181,
		177,
		194,
		207,
		189,
		203,
		202,
		-1,
		184,
		202,
		211,
		188,
		186,
		170,
		168,
		186,
		188,
		194,
		197,
		-1,
		177,
		179,
		189,
		197,
		202,
		186,
		173,
		173,
		183,
		176,
		195,
		186,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		174,
		176,
		193,
		185,
		175,
		190,
		183,
		176,
		173,
		171,
		168,
		184,
		185,
		195,
		-1,
		-1,
		230,
		199,
		234,
		191,
		176,
		-1,
		170,
		169,
		175,
		179,
		173,
		166,
		180,
		176,
		-1,
		162,
		161,
		192,
		178,
		189,
		190,
		-1,
		-1,
		188,
		180,
		165,
		168,
		165,
		165,
		184,
		183,
		175,
		161,
		157,
		163,
		166,
		166,
		172,
		156,
		166,
		170,
		181,
		196,
		-1,
		-1,
		251,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		160,
		177,
		167,
		188,
		194,
		185,
		177,
		171,
		159,
		161,
		158,
		171,
		159,
		153,
		178,
		182,
		176,
		197,
		192,
		-1,
		250,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		189,
		-1,
		179,
		185,
		195,
		180,
		177,
		164,
		152,
		165,
		150,
		157,
		156,
		160,
		162,
		195,
		173,
		195,
		192,
		221,
		226,
		220,
		229,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		197,
		196,
		171,
		189,
		192,
		181,
		172,
		159,
		148,
		159,
		148,
		145,
		153,
		162,
		173,
		168,
		167,
		185,
		200,
		213,
		217,
		223,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		198,
		188,
		173,
		164,
		-1,
		167,
		170,
		177,
		155,
		140,
		157,
		149,
		147,
		152,
		157,
		171,
		162,
		180,
		187,
		195,
		199,
		219,
		231,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		157,
		182,
		-1,
		161,
		157,
		139,
		140,
		135,
		150,
		156,
		153,
		150,
		168,
		171,
		188,
		192,
		208,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		172,
		169,
		155,
		142,
		132,
		133,
		141,
		154,
		133,
		152,
		155,
		177,
		205,
		183,
		195,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		162,
		145,
		141,
		130,
		128,
		141,
		136,
		152,
		156,
		155,
		174,
		186,
		177,
		197,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		165,
		162,
		129,
		137,
		129,
		118,
		132,
		140,
		144,
		153,
		162,
		168,
		192,
		192,
		198,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		115,
		114,
		120,
		132,
		118,
		123,
		134,
		146,
		159,
		155,
		162,
		197,
		197,
		182,
		202,
		205,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		112,
		111,
		118,
		115,
		115,
		129,
		137,
		133,
		149,
		155,
		147,
		183,
		-1,
		190,
		184,
		192,
		182,
		170,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		99,
		106,
		115,
		120,
		125,
		133,
		128,
		141,
		146,
		152,
		157,
		175,
		179,
		183,
		172,
		168,
		165,
		179,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		109,
		110,
		130,
		122,
		136,
		136,
		142,
		150,
		135,
		138,
		154,
		152,
		170,
		178,
		170,
		164,
		163,
		175,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		112,
		118,
		156,
		157,
		135,
		140,
		148,
		158,
		160,
		149,
		160,
		152,
		174,
		174,
		158,
		159,
		168,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		136,
		-1,
		90,
		92,
		132,
		130,
		146,
		137,
		143,
		159,
		159,
		154,
		154,
		143,
		149,
		146,
		168,
		154,
		152,
		171,
		187,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		114,
		102,
		89,
		71,
		111,
		-1,
		154,
		138,
		143,
		-1,
		179,
		-1,
		151,
		154,
		145,
		142,
		140,
		151,
		149,
		160,
		170,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		101,
		95,
		95,
		64,
		61,
		170,
		150,
		144,
		143,
		162,
		149,
		148,
		136,
		136,
		139,
		143,
		156,
		170,
		167,
		168,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		162,
		118,
		104,
		-1,
		56,
		144,
		134,
		143,
		144,
		149,
		150,
		140,
		138,
		134,
		143,
		147,
		149,
		148,
		169,
		162,
		184,
		-1,
		-1,
		147,
		152,
		140,
		126,
		141,
		-1,
		-1,
		-1,
		108,
		94,
		82,
		54,
		132,
		-1,
		-1,
		148,
		141,
		135,
		138,
		126,
		146,
		153,
		155,
		142,
		157,
		167,
		175,
		174,
		-1,
		150,
		137,
		-1,
		-1,
		140,
		130,
		-1,
		-1,
		-1,
		-1,
		72,
		53,
		65,
		86,
		111,
		147,
		-1,
		121,
		129,
		125,
		144,
		151,
		157,
		142,
		136,
		147,
		162,
		179,
		-1,
		-1,
		154,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		44,
		59,
		79,
		85,
		97,
		-1,
		123,
		122,
		122,
		132,
		145,
		150,
		148,
		130,
		144,
		147,
		160,
		174,
		178,
		177,
		-1,
		107,
		-1,
		-1,
		-1,
		36,
		37,
		139,
		116,
		89,
		94,
		104,
		109,
		114,
		134,
		140,
		151,
		124,
		128,
		143,
		148,
		152,
		169,
		173,
		-1,
		-1,
		105,
		97,
		62,
		44,
		10,
		166,
		-1,
		-1,
		104,
		100,
		106,
		116,
		124,
		127,
		120,
		122,
		140,
		153,
		147,
		157,
		172,
		167,
		-1,
		-1,
		-1,
		117,
		-1,
		95,
		-1,
		-1,
		0,
		180,
		127,
		109,
		105,
		91,
		114,
		108,
		110,
		115,
		134,
		129,
		138,
		143,
		147,
		170,
		159,
		198,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		96,
		88,
		82,
		85,
		20,
		27,
		142,
		139,
		-1,
		87,
		130,
		105,
		119,
		115,
		122,
		127,
		133,
		137,
		144,
		160,
		159,
		154,
		190,
		181,
		187,
		-1,
		-1,
		233,
		222,
		211,
		217,
		-1,
		89,
		85,
		71,
		61,
		37,
		-1,
		-1,
		104,
		101,
		110,
		97,
		103,
		108,
		111,
		149,
		125,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		187,
		224,
		217,
		185,
		193,
		224,
		-1,
		79,
		71,
		81,
		57,
		48,
		-1,
		-1,
		77,
		79,
		84,
		93,
		96,
		132,
		131,
		144,
		147,
		152,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		180,
		200,
		179,
		182,
		206,
		220,
		-1,
		76,
		-1,
		-1,
		88,
		61,
		69,
		72,
		76,
		131,
		107,
		102,
		115,
		117,
		141,
		132,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		169,
		180,
		173,
		-1,
		-1,
		-1,
		-1,
		77,
		-1,
		-1,
		104,
		-1,
		95,
		-1,
		88,
		92,
		115,
		118,
		140,
		127,
		134,
		151,
		157,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		194,
		150,
		153,
		164,
		175,
		190,
		194,
		-1,
		88,
		127,
		142,
		-1,
		113,
		-1,
		-1,
		-1,
		102,
		128,
		120,
		136,
		139,
		139,
		135,
		139,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		190,
		181,
		194,
		139,
		139,
		160,
		169,
		190,
		103,
		94,
		121,
		149,
		138,
		133,
		120,
		-1,
		-1,
		125,
		138,
		-1,
		-1,
		146,
		156,
		139,
		141,
		145,
		159,
		171,
		179,
		169,
		167,
		161,
		193,
		-1,
		183,
		182,
		171,
		168,
		144,
		135,
		130,
		157,
		-1,
		-1,
		106,
		122,
		135,
		139,
		155,
		180,
		-1,
		123,
		-1,
		-1,
		146,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		153,
		164,
		186,
		175,
		176,
		166,
		176,
		189,
		167,
		164,
		152,
		150,
		173,
		138,
		126,
		-1,
		121,
		109,
		115,
		122,
		139,
		169,
		-1,
		-1,
		139,
		130,
		-1,
		-1,
		165,
		172,
		183,
		-1,
		173,
		146,
		151,
		176,
		183,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		176,
		190,
		179,
		175,
		174,
		182,
		131,
		124,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		149,
		-1,
		-1,
		172,
		179,
		172,
		160,
		150,
		160,
		168,
		168,
		171,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		210,
		-1,
		162,
		130,
		150,
		165,
		173,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		222,
		206,
		187,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		148,
		151,
		-1,
		-1,
		175,
		194,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		161,
		186,
		175,
		183,
		178,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		155,
		158,
		163,
		-1,
		184,
		-1,
		206,
		-1,
		151,
		167,
		169,
		-1,
		-1,
		-1,
		199,
		162,
		183,
		193,
		198,
		196,
		187,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		214,
		191,
		213,
		204,
		187,
		167,
		159,
		184,
		-1,
		187,
		-1,
		162,
		163,
		190,
		192,
		209,
		203,
		187,
		202,
		192,
		183,
		192,
		220,
		-1,
		195,
		241,
		205,
		173,
		173,
		172,
		208,
		-1,
		184,
		166,
		-1,
		194,
		184,
		226,
		207,
		200,
		187,
		194,
		196,
		189,
		-1,
		-1,
		-1,
		210,
		209,
		201,
		195,
		193,
		178,
		173,
		-1,
		196,
		178,
		157,
		174,
		174,
		165,
		173,
		216,
		212,
		205,
		207,
		197,
		-1,
		282,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		204,
		212,
		185,
		173,
		179,
		175,
		161,
		167,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		196,
		228,
		-1,
		289,
		-1,
		240,
		-1,
		-1,
		220,
		206,
		207,
		196,
		185,
		183,
		174,
		165,
		187,
		203,
		187,
		185,
		190,
		195,
		-1,
		299,
		300,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		231,
		192,
		-1,
		194,
		174,
		-1,
		196,
		192,
		-1,
		-1,
		295,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		226,
		210,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		280,
		264,
		-1,
		233,
		236,
		-1,
		227,
		232,
		240,
		187,
		191,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		248,
		253,
		241,
		253,
		239,
		223,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		261,
		253,
		246,
		-1,
		-1,
		248,
		231,
		212,
		210,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		238,
		-1,
		-1,
		244,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		272,
		-1,
		-1,
		-1,
		234,
		230,
		231,
		-1,
		-1,
		-1,
		-1,
		293,
		294,
		318,
		282,
		-1,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		296,
		294,
		-1,
		-1,
		-1,
		254,
		238,
		-1,
		224,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		259,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		272,
		264,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		287,
		278,
		-1,
		-1,
		249,
		256,
		278,
		281,
		317,
		-1,
		268
	],
	[
		-1,
		279,
		268,
		279,
		287,
		260,
		267,
		-1,
		286,
		290,
		256,
		250,
		289,
		258,
		264,
		275,
		-1,
		-1,
		-1,
		279,
		278,
		246,
		244,
		253,
		258,
		265,
		-1,
		264,
		-1,
		300,
		279,
		290,
		295,
		239,
		236,
		256,
		275,
		257,
		249,
		315,
		269,
		240,
		234,
		252,
		242,
		251,
		243,
		-1,
		240,
		230,
		252,
		231,
		242,
		234,
		-1,
		-1,
		234,
		235,
		241,
		227,
		233,
		229,
		-1,
		239,
		223,
		-1,
		-1,
		224,
		225,
		209,
		212,
		220,
		218,
		231,
		223,
		218,
		-1,
		-1,
		215,
		211,
		218,
		205,
		201,
		218,
		231,
		213,
		227,
		226,
		-1,
		221,
		239,
		244,
		212,
		210,
		194,
		192,
		210,
		212,
		218,
		218,
		-1,
		230,
		231,
		226,
		234,
		234,
		210,
		197,
		197,
		207,
		200,
		219,
		207,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		230,
		213,
		230,
		222,
		212,
		227,
		220,
		200,
		197,
		195,
		192,
		208,
		206,
		216,
		-1,
		-1,
		321,
		290,
		321,
		279,
		260,
		-1,
		226,
		206,
		212,
		216,
		210,
		203,
		217,
		213,
		-1,
		186,
		185,
		213,
		199,
		210,
		281,
		-1,
		-1,
		279,
		271,
		256,
		259,
		236,
		232,
		221,
		220,
		212,
		198,
		194,
		200,
		203,
		203,
		209,
		180,
		190,
		194,
		192,
		217,
		-1,
		-1,
		252,
		-1,
		-1,
		278,
		261,
		-1,
		244,
		251,
		242,
		248,
		234,
		255,
		231,
		222,
		214,
		208,
		196,
		198,
		195,
		208,
		196,
		177,
		202,
		206,
		187,
		208,
		203,
		-1,
		251,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		237,
		240,
		246,
		270,
		271,
		-1,
		243,
		231,
		232,
		217,
		214,
		201,
		189,
		202,
		187,
		194,
		193,
		181,
		179,
		209,
		184,
		206,
		203,
		222,
		227,
		221,
		230,
		-1,
		286,
		282,
		278,
		285,
		234,
		-1,
		-1,
		274,
		-1,
		279,
		280,
		255,
		228,
		231,
		218,
		209,
		196,
		185,
		196,
		185,
		182,
		190,
		173,
		188,
		179,
		178,
		196,
		206,
		214,
		218,
		224,
		-1,
		336,
		-1,
		278,
		262,
		264,
		236,
		257,
		-1,
		294,
		280,
		272,
		257,
		255,
		-1,
		227,
		224,
		214,
		192,
		177,
		194,
		186,
		184,
		186,
		168,
		182,
		173,
		191,
		198,
		196,
		200,
		220,
		232,
		296,
		286,
		-1,
		268,
		273,
		232,
		240,
		259,
		297,
		261,
		-1,
		256,
		-1,
		229,
		242,
		-1,
		198,
		194,
		176,
		177,
		172,
		187,
		179,
		164,
		161,
		179,
		182,
		189,
		193,
		209,
		-1,
		-1,
		281,
		285,
		274,
		225,
		244,
		268,
		305,
		254,
		243,
		242,
		-1,
		233,
		212,
		209,
		197,
		184,
		169,
		170,
		178,
		190,
		169,
		163,
		160,
		180,
		206,
		184,
		196,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		251,
		222,
		246,
		288,
		272,
		265,
		253,
		218,
		218,
		212,
		-1,
		208,
		187,
		178,
		167,
		165,
		178,
		170,
		178,
		158,
		156,
		175,
		187,
		178,
		189,
		-1,
		-1,
		-1,
		281,
		270,
		271,
		217,
		240,
		277,
		251,
		237,
		242,
		217,
		210,
		204,
		221,
		204,
		185,
		174,
		166,
		155,
		166,
		174,
		172,
		154,
		163,
		169,
		193,
		177,
		183,
		-1,
		-1,
		288,
		278,
		262,
		264,
		261,
		231,
		238,
		270,
		242,
		255,
		-1,
		209,
		-1,
		198,
		194,
		179,
		174,
		171,
		158,
		157,
		171,
		171,
		161,
		156,
		163,
		198,
		198,
		167,
		187,
		190,
		-1,
		-1,
		-1,
		281,
		276,
		251,
		228,
		212,
		248,
		-1,
		225,
		226,
		-1,
		203,
		197,
		194,
		181,
		177,
		162,
		166,
		168,
		171,
		159,
		165,
		166,
		148,
		172,
		-1,
		175,
		169,
		177,
		167,
		155,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		210,
		203,
		-1,
		190,
		172,
		174,
		166,
		160,
		167,
		162,
		153,
		166,
		159,
		153,
		147,
		160,
		164,
		168,
		157,
		153,
		150,
		164,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		219,
		211,
		201,
		195,
		189,
		185,
		183,
		188,
		172,
		175,
		170,
		167,
		157,
		148,
		141,
		152,
		137,
		155,
		163,
		155,
		149,
		148,
		160,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		218,
		234,
		-1,
		227,
		206,
		221,
		199,
		195,
		186,
		179,
		180,
		150,
		155,
		157,
		145,
		148,
		142,
		145,
		137,
		159,
		159,
		143,
		144,
		153,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		189,
		221,
		-1,
		-1,
		234,
		-1,
		188,
		190,
		200,
		198,
		169,
		144,
		151,
		169,
		142,
		137,
		147,
		136,
		133,
		131,
		153,
		139,
		137,
		156,
		172,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		238,
		-1,
		212,
		200,
		187,
		169,
		209,
		-1,
		143,
		139,
		146,
		-1,
		162,
		-1,
		134,
		137,
		128,
		125,
		125,
		136,
		134,
		145,
		162,
		-1,
		250,
		235,
		228,
		218,
		232,
		203,
		-1,
		258,
		-1,
		-1,
		199,
		193,
		193,
		162,
		159,
		159,
		139,
		131,
		146,
		145,
		132,
		131,
		119,
		119,
		122,
		128,
		141,
		161,
		152,
		163,
		-1,
		-1,
		-1,
		255,
		241,
		245,
		205,
		224,
		-1,
		-1,
		260,
		216,
		202,
		-1,
		154,
		159,
		147,
		137,
		127,
		132,
		133,
		123,
		121,
		117,
		126,
		130,
		137,
		142,
		163,
		157,
		177,
		-1,
		-1,
		238,
		243,
		231,
		217,
		221,
		-1,
		-1,
		-1,
		206,
		207,
		173,
		152,
		148,
		-1,
		-1,
		131,
		124,
		118,
		121,
		109,
		129,
		136,
		150,
		136,
		151,
		162,
		170,
		169,
		-1,
		241,
		228,
		-1,
		-1,
		220,
		210,
		-1,
		-1,
		-1,
		-1,
		185,
		130,
		119,
		114,
		118,
		130,
		-1,
		104,
		115,
		108,
		127,
		134,
		152,
		137,
		131,
		142,
		157,
		174,
		-1,
		-1,
		234,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		142,
		136,
		107,
		100,
		104,
		-1,
		106,
		108,
		105,
		117,
		128,
		133,
		141,
		125,
		139,
		142,
		155,
		169,
		173,
		257,
		-1,
		187,
		-1,
		-1,
		-1,
		160,
		175,
		142,
		119,
		96,
		89,
		86,
		92,
		97,
		117,
		123,
		134,
		119,
		123,
		138,
		148,
		147,
		164,
		174,
		-1,
		-1,
		185,
		181,
		186,
		168,
		172,
		169,
		-1,
		-1,
		87,
		78,
		88,
		99,
		107,
		110,
		115,
		117,
		135,
		154,
		142,
		157,
		172,
		168,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		0,
		48,
		71,
		74,
		81,
		101,
		110,
		105,
		110,
		135,
		130,
		139,
		144,
		148,
		171,
		160,
		199,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		52,
		101,
		-1,
		87,
		130,
		111,
		118,
		110,
		123,
		128,
		134,
		138,
		145,
		161,
		160,
		155,
		191,
		182,
		188,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		136,
		133,
		111,
		120,
		124,
		117,
		112,
		150,
		126,
		134,
		138,
		142,
		148,
		153,
		158,
		164,
		179,
		194,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		109,
		106,
		111,
		120,
		123,
		136,
		135,
		146,
		148,
		153,
		141,
		140,
		158,
		162,
		171,
		178,
		168,
		181,
		185,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		108,
		158,
		133,
		128,
		138,
		140,
		144,
		135,
		158,
		149,
		149,
		152,
		167,
		172,
		164,
		178,
		178,
		179,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		126,
		130,
		140,
		144,
		163,
		150,
		148,
		156,
		164,
		147,
		157,
		153,
		154,
		163,
		174,
		186,
		185,
		186,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		168,
		207,
		222,
		-1,
		193,
		-1,
		-1,
		-1,
		140,
		153,
		145,
		162,
		162,
		162,
		142,
		146,
		152,
		159,
		169,
		171,
		163,
		167,
		180,
		191,
		194,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		183,
		174,
		201,
		227,
		218,
		213,
		200,
		-1,
		-1,
		163,
		163,
		-1,
		-1,
		169,
		163,
		146,
		148,
		152,
		162,
		177,
		180,
		170,
		168,
		162,
		194,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		202,
		197,
		201,
		217,
		242,
		-1,
		203,
		-1,
		-1,
		184,
		-1,
		-1,
		205,
		168,
		157,
		148,
		154,
		160,
		171,
		188,
		176,
		177,
		167,
		177,
		190,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		231,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		203,
		201,
		190,
		-1,
		180,
		153,
		158,
		183,
		190,
		185,
		179,
		173,
		180,
		179,
		187,
		195,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		236,
		229,
		-1,
		-1,
		198,
		191,
		179,
		167,
		157,
		167,
		175,
		175,
		178,
		176,
		171,
		182,
		174,
		178,
		195,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		253,
		239,
		232,
		220,
		218,
		-1,
		232,
		216,
		197,
		-1,
		167,
		180,
		211,
		179,
		184,
		179,
		177,
		188,
		177,
		180,
		194,
		189,
		-1,
		-1,
		184,
		187,
		-1,
		-1,
		209,
		228,
		-1,
		244,
		233,
		218,
		210,
		-1,
		-1,
		204,
		200,
		-1,
		-1,
		168,
		193,
		182,
		190,
		185,
		181,
		187,
		190,
		179,
		183,
		195,
		-1,
		-1,
		191,
		192,
		197,
		-1,
		218,
		-1,
		246,
		-1,
		213,
		219,
		207,
		-1,
		-1,
		-1,
		206,
		169,
		186,
		200,
		205,
		203,
		194,
		185,
		192,
		190,
		186,
		197,
		-1,
		-1,
		-1,
		246,
		220,
		253,
		244,
		227,
		207,
		199,
		218,
		-1,
		188,
		-1,
		163,
		166,
		191,
		199,
		216,
		210,
		188,
		203,
		193,
		184,
		193,
		252,
		-1,
		222,
		255,
		219,
		213,
		189,
		193,
		209,
		-1,
		185,
		167,
		-1,
		195,
		185,
		233,
		208,
		203,
		190,
		197,
		197,
		190,
		-1,
		-1,
		-1,
		224,
		223,
		215,
		209,
		209,
		194,
		185,
		-1,
		197,
		179,
		158,
		175,
		175,
		166,
		174,
		223,
		219,
		210,
		210,
		198,
		-1,
		316,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		218,
		213,
		186,
		174,
		180,
		176,
		162,
		168,
		170,
		178,
		176,
		173,
		185,
		181,
		201,
		197,
		229,
		-1,
		320,
		-1,
		254,
		-1,
		-1,
		236,
		216,
		208,
		197,
		186,
		184,
		175,
		166,
		188,
		204,
		188,
		186,
		191,
		196,
		-1,
		309,
		308,
		-1,
		255,
		247,
		233,
		-1,
		226,
		-1,
		232,
		193,
		-1,
		195,
		175,
		-1,
		197,
		193,
		-1,
		-1,
		296,
		271,
		-1,
		-1,
		-1,
		256,
		236,
		227,
		211,
		-1,
		186,
		186,
		-1,
		-1,
		-1,
		281,
		280,
		-1,
		249,
		252,
		-1,
		242,
		233,
		241,
		188,
		192,
		-1,
		-1,
		-1,
		290,
		271,
		265,
		264,
		262,
		257,
		254,
		240,
		224,
		202,
		191,
		212,
		-1,
		-1,
		-1,
		262,
		254,
		247,
		-1,
		-1,
		249,
		232,
		213,
		211,
		-1,
		-1,
		-1,
		284,
		265,
		-1,
		-1,
		239,
		-1,
		-1,
		245,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		273,
		-1,
		-1,
		-1,
		235,
		231,
		232,
		-1,
		-1,
		-1,
		-1,
		295,
		296,
		319,
		283,
		-1,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		298,
		296,
		-1,
		-1,
		-1,
		255,
		239,
		-1,
		225,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		260,
		-1,
		260,
		235,
		242,
		-1,
		-1,
		-1,
		-1,
		273,
		265,
		273,
		-1,
		245,
		247,
		-1,
		295,
		-1,
		-1,
		288,
		279,
		-1,
		-1,
		250,
		257,
		279,
		282,
		318,
		-1,
		269
	],
	[
		-1,
		231,
		220,
		231,
		239,
		212,
		219,
		-1,
		238,
		242,
		208,
		202,
		241,
		210,
		216,
		227,
		-1,
		-1,
		-1,
		231,
		230,
		198,
		196,
		205,
		210,
		217,
		-1,
		216,
		-1,
		252,
		231,
		242,
		247,
		191,
		188,
		208,
		227,
		209,
		201,
		267,
		221,
		192,
		186,
		204,
		194,
		203,
		195,
		-1,
		192,
		182,
		204,
		183,
		194,
		186,
		-1,
		-1,
		186,
		187,
		193,
		179,
		185,
		181,
		-1,
		191,
		175,
		-1,
		-1,
		176,
		177,
		161,
		164,
		172,
		170,
		183,
		175,
		170,
		-1,
		-1,
		167,
		163,
		170,
		157,
		153,
		170,
		183,
		165,
		179,
		178,
		-1,
		173,
		191,
		196,
		164,
		162,
		146,
		144,
		162,
		164,
		170,
		170,
		-1,
		182,
		183,
		178,
		186,
		186,
		162,
		149,
		149,
		159,
		152,
		171,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		182,
		165,
		182,
		174,
		164,
		179,
		172,
		152,
		149,
		147,
		144,
		160,
		158,
		168,
		-1,
		-1,
		273,
		242,
		273,
		231,
		212,
		-1,
		178,
		158,
		164,
		168,
		162,
		155,
		169,
		165,
		-1,
		138,
		137,
		165,
		151,
		162,
		233,
		-1,
		-1,
		231,
		223,
		208,
		211,
		188,
		184,
		173,
		172,
		164,
		150,
		146,
		152,
		155,
		155,
		161,
		132,
		142,
		146,
		144,
		169,
		-1,
		-1,
		204,
		-1,
		-1,
		230,
		213,
		-1,
		196,
		203,
		194,
		200,
		186,
		207,
		183,
		174,
		166,
		160,
		148,
		150,
		147,
		160,
		148,
		129,
		154,
		158,
		139,
		160,
		155,
		-1,
		203,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		189,
		192,
		198,
		222,
		223,
		-1,
		195,
		183,
		184,
		169,
		166,
		153,
		141,
		154,
		139,
		146,
		145,
		133,
		131,
		161,
		136,
		158,
		155,
		174,
		179,
		173,
		182,
		-1,
		238,
		234,
		230,
		237,
		186,
		-1,
		-1,
		226,
		-1,
		231,
		232,
		207,
		180,
		183,
		170,
		161,
		148,
		137,
		148,
		137,
		134,
		142,
		125,
		140,
		131,
		130,
		148,
		158,
		166,
		170,
		176,
		-1,
		288,
		-1,
		230,
		214,
		216,
		188,
		209,
		-1,
		246,
		232,
		224,
		209,
		207,
		-1,
		179,
		176,
		166,
		144,
		129,
		146,
		138,
		136,
		138,
		120,
		134,
		125,
		143,
		150,
		148,
		152,
		172,
		184,
		248,
		238,
		-1,
		220,
		225,
		184,
		192,
		211,
		249,
		213,
		-1,
		208,
		-1,
		181,
		194,
		-1,
		150,
		146,
		128,
		129,
		124,
		139,
		131,
		116,
		113,
		131,
		134,
		141,
		145,
		161,
		-1,
		-1,
		233,
		237,
		226,
		177,
		196,
		220,
		257,
		206,
		195,
		194,
		-1,
		185,
		164,
		161,
		149,
		136,
		121,
		122,
		130,
		142,
		121,
		115,
		112,
		132,
		158,
		136,
		148,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		203,
		174,
		198,
		240,
		224,
		217,
		205,
		170,
		170,
		164,
		-1,
		160,
		139,
		130,
		119,
		117,
		130,
		122,
		130,
		110,
		108,
		127,
		139,
		130,
		141,
		-1,
		-1,
		-1,
		233,
		222,
		223,
		169,
		192,
		229,
		203,
		189,
		194,
		169,
		162,
		156,
		173,
		156,
		137,
		126,
		118,
		107,
		118,
		126,
		124,
		106,
		115,
		121,
		145,
		129,
		135,
		-1,
		-1,
		240,
		230,
		214,
		216,
		213,
		183,
		190,
		222,
		194,
		207,
		-1,
		161,
		-1,
		150,
		146,
		131,
		126,
		123,
		110,
		109,
		123,
		123,
		113,
		108,
		115,
		150,
		150,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		233,
		228,
		203,
		180,
		164,
		200,
		-1,
		177,
		178,
		-1,
		155,
		149,
		146,
		133,
		129,
		114,
		118,
		120,
		123,
		111,
		117,
		118,
		100,
		124,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		226,
		205,
		198,
		218,
		159,
		211,
		-1,
		-1,
		162,
		155,
		-1,
		142,
		124,
		126,
		118,
		112,
		119,
		114,
		105,
		118,
		111,
		105,
		99,
		112,
		116,
		120,
		109,
		105,
		102,
		116,
		-1,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		179,
		-1,
		171,
		163,
		153,
		147,
		141,
		137,
		135,
		140,
		124,
		127,
		122,
		119,
		109,
		100,
		93,
		104,
		89,
		107,
		115,
		107,
		101,
		100,
		112,
		-1,
		246,
		232,
		203,
		-1,
		-1,
		192,
		-1,
		156,
		170,
		186,
		-1,
		179,
		158,
		173,
		151,
		147,
		138,
		131,
		132,
		102,
		107,
		109,
		97,
		100,
		94,
		97,
		89,
		111,
		111,
		95,
		96,
		105,
		-1,
		252,
		239,
		197,
		193,
		182,
		202,
		153,
		141,
		173,
		-1,
		-1,
		186,
		-1,
		140,
		142,
		152,
		150,
		121,
		96,
		103,
		121,
		94,
		89,
		99,
		88,
		85,
		83,
		105,
		91,
		89,
		108,
		124,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		168,
		155,
		149,
		-1,
		190,
		-1,
		164,
		152,
		139,
		121,
		161,
		-1,
		95,
		91,
		98,
		-1,
		114,
		-1,
		86,
		89,
		80,
		77,
		77,
		88,
		86,
		97,
		114,
		-1,
		202,
		187,
		180,
		170,
		184,
		155,
		-1,
		210,
		-1,
		-1,
		151,
		145,
		145,
		114,
		111,
		111,
		91,
		83,
		98,
		97,
		84,
		83,
		71,
		71,
		74,
		80,
		93,
		113,
		104,
		115,
		-1,
		-1,
		-1,
		207,
		193,
		197,
		157,
		176,
		-1,
		-1,
		212,
		168,
		154,
		-1,
		106,
		111,
		99,
		89,
		79,
		84,
		85,
		75,
		73,
		69,
		78,
		82,
		89,
		94,
		115,
		109,
		129,
		-1,
		-1,
		190,
		195,
		183,
		169,
		173,
		-1,
		-1,
		-1,
		158,
		159,
		125,
		104,
		100,
		-1,
		-1,
		83,
		76,
		70,
		73,
		61,
		81,
		88,
		102,
		88,
		103,
		114,
		122,
		121,
		-1,
		193,
		180,
		-1,
		-1,
		172,
		162,
		-1,
		-1,
		-1,
		-1,
		137,
		82,
		71,
		66,
		70,
		82,
		-1,
		56,
		67,
		60,
		79,
		86,
		104,
		89,
		83,
		94,
		109,
		126,
		-1,
		-1,
		186,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		94,
		88,
		59,
		52,
		56,
		-1,
		58,
		60,
		57,
		69,
		80,
		85,
		93,
		77,
		91,
		94,
		107,
		121,
		125,
		209,
		-1,
		139,
		-1,
		-1,
		-1,
		112,
		127,
		94,
		71,
		48,
		41,
		38,
		44,
		49,
		69,
		75,
		86,
		71,
		75,
		90,
		100,
		99,
		116,
		126,
		-1,
		-1,
		137,
		133,
		138,
		120,
		124,
		121,
		-1,
		-1,
		39,
		30,
		40,
		51,
		59,
		62,
		67,
		69,
		87,
		106,
		94,
		109,
		124,
		120,
		-1,
		-1,
		-1,
		149,
		-1,
		151,
		-1,
		-1,
		139,
		53,
		0,
		23,
		26,
		33,
		53,
		62,
		57,
		62,
		87,
		82,
		91,
		96,
		100,
		123,
		112,
		151,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		128,
		120,
		115,
		121,
		123,
		114,
		15,
		53,
		-1,
		39,
		82,
		63,
		70,
		62,
		75,
		80,
		86,
		90,
		97,
		113,
		112,
		107,
		143,
		134,
		140,
		-1,
		-1,
		219,
		208,
		197,
		203,
		-1,
		121,
		117,
		107,
		97,
		100,
		-1,
		-1,
		88,
		85,
		63,
		72,
		76,
		69,
		64,
		102,
		78,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		173,
		210,
		203,
		171,
		179,
		210,
		-1,
		111,
		103,
		114,
		89,
		91,
		-1,
		-1,
		61,
		58,
		63,
		72,
		75,
		88,
		87,
		98,
		100,
		105,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		166,
		186,
		165,
		168,
		192,
		206,
		-1,
		108,
		-1,
		-1,
		120,
		92,
		76,
		66,
		60,
		110,
		85,
		80,
		90,
		92,
		96,
		87,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		155,
		166,
		159,
		-1,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		136,
		-1,
		103,
		-1,
		78,
		82,
		92,
		96,
		115,
		102,
		100,
		108,
		116,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		180,
		136,
		139,
		150,
		161,
		176,
		180,
		-1,
		120,
		159,
		174,
		-1,
		145,
		-1,
		-1,
		-1,
		92,
		105,
		97,
		114,
		114,
		114,
		94,
		98,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		176,
		167,
		180,
		125,
		125,
		146,
		155,
		176,
		135,
		126,
		153,
		179,
		170,
		165,
		152,
		-1,
		-1,
		115,
		115,
		-1,
		-1,
		121,
		115,
		98,
		100,
		104,
		114,
		129,
		132,
		122,
		120,
		114,
		146,
		-1,
		169,
		168,
		157,
		154,
		130,
		121,
		116,
		143,
		-1,
		-1,
		138,
		154,
		149,
		153,
		169,
		194,
		-1,
		155,
		-1,
		-1,
		136,
		-1,
		-1,
		157,
		120,
		109,
		100,
		106,
		112,
		123,
		140,
		128,
		129,
		119,
		129,
		142,
		153,
		150,
		138,
		136,
		159,
		124,
		112,
		-1,
		125,
		123,
		129,
		136,
		153,
		183,
		-1,
		-1,
		171,
		162,
		-1,
		-1,
		155,
		153,
		142,
		-1,
		132,
		105,
		110,
		135,
		142,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		162,
		176,
		165,
		161,
		160,
		168,
		117,
		110,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		181,
		-1,
		-1,
		150,
		143,
		131,
		119,
		109,
		119,
		127,
		127,
		130,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		196,
		-1,
		148,
		124,
		138,
		153,
		161,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		184,
		168,
		149,
		-1,
		119,
		132,
		163,
		131,
		136,
		131,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		136,
		139,
		-1,
		-1,
		161,
		180,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		156,
		152,
		-1,
		-1,
		120,
		145,
		134,
		142,
		137,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		143,
		144,
		149,
		-1,
		170,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		158,
		121,
		138,
		152,
		157,
		155,
		146,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		118,
		143,
		151,
		168,
		162,
		140,
		155,
		145,
		136,
		145,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		185,
		160,
		155,
		142,
		149,
		149,
		142,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		175,
		171,
		162,
		162,
		150,
		-1,
		268,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		143,
		148,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		208,
		197,
		208,
		216,
		189,
		196,
		-1,
		215,
		219,
		185,
		179,
		218,
		187,
		193,
		204,
		-1,
		-1,
		-1,
		208,
		207,
		175,
		173,
		182,
		187,
		194,
		-1,
		193,
		-1,
		229,
		208,
		219,
		224,
		168,
		165,
		185,
		204,
		186,
		178,
		244,
		198,
		169,
		163,
		181,
		171,
		180,
		172,
		-1,
		169,
		159,
		181,
		160,
		171,
		163,
		-1,
		-1,
		163,
		164,
		170,
		156,
		162,
		158,
		-1,
		168,
		152,
		-1,
		-1,
		153,
		154,
		138,
		141,
		149,
		147,
		160,
		152,
		147,
		-1,
		-1,
		144,
		140,
		147,
		134,
		130,
		147,
		160,
		142,
		156,
		155,
		-1,
		150,
		168,
		173,
		141,
		139,
		123,
		121,
		139,
		141,
		147,
		147,
		-1,
		159,
		160,
		155,
		163,
		163,
		139,
		126,
		126,
		136,
		129,
		148,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		142,
		159,
		151,
		141,
		156,
		149,
		129,
		126,
		124,
		121,
		137,
		135,
		145,
		-1,
		-1,
		250,
		219,
		250,
		208,
		189,
		-1,
		155,
		135,
		141,
		145,
		139,
		132,
		146,
		142,
		-1,
		115,
		114,
		142,
		128,
		139,
		210,
		-1,
		-1,
		208,
		200,
		185,
		188,
		165,
		161,
		150,
		149,
		141,
		127,
		123,
		129,
		132,
		132,
		138,
		109,
		119,
		123,
		121,
		146,
		-1,
		-1,
		181,
		-1,
		-1,
		207,
		190,
		-1,
		173,
		180,
		171,
		177,
		163,
		184,
		160,
		151,
		143,
		137,
		125,
		127,
		124,
		137,
		125,
		106,
		131,
		135,
		116,
		137,
		132,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		166,
		169,
		175,
		199,
		200,
		-1,
		172,
		160,
		161,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		122,
		110,
		108,
		138,
		113,
		135,
		132,
		151,
		156,
		150,
		159,
		-1,
		215,
		211,
		207,
		214,
		163,
		-1,
		-1,
		203,
		-1,
		208,
		209,
		184,
		157,
		160,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		119,
		102,
		117,
		108,
		107,
		125,
		135,
		143,
		147,
		153,
		-1,
		265,
		-1,
		207,
		191,
		193,
		165,
		186,
		-1,
		223,
		209,
		201,
		186,
		184,
		-1,
		156,
		153,
		143,
		121,
		106,
		123,
		115,
		113,
		115,
		97,
		111,
		102,
		120,
		127,
		125,
		129,
		149,
		161,
		225,
		215,
		-1,
		197,
		202,
		161,
		169,
		188,
		226,
		190,
		-1,
		185,
		-1,
		158,
		171,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		108,
		93,
		90,
		108,
		111,
		118,
		122,
		138,
		-1,
		-1,
		210,
		214,
		203,
		154,
		173,
		197,
		234,
		183,
		172,
		171,
		-1,
		162,
		141,
		138,
		126,
		113,
		98,
		99,
		107,
		119,
		98,
		92,
		89,
		109,
		135,
		113,
		125,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		180,
		151,
		175,
		217,
		201,
		194,
		182,
		147,
		147,
		141,
		-1,
		137,
		116,
		107,
		96,
		94,
		107,
		99,
		107,
		87,
		85,
		104,
		116,
		107,
		118,
		-1,
		-1,
		-1,
		210,
		199,
		200,
		146,
		169,
		206,
		180,
		166,
		171,
		146,
		139,
		133,
		150,
		133,
		114,
		103,
		95,
		84,
		95,
		103,
		101,
		83,
		92,
		98,
		122,
		106,
		112,
		-1,
		-1,
		217,
		207,
		191,
		193,
		190,
		160,
		167,
		199,
		171,
		184,
		-1,
		138,
		-1,
		127,
		123,
		108,
		103,
		100,
		87,
		86,
		100,
		100,
		90,
		85,
		92,
		127,
		127,
		96,
		116,
		119,
		-1,
		-1,
		-1,
		210,
		205,
		180,
		157,
		141,
		177,
		-1,
		154,
		155,
		-1,
		132,
		126,
		123,
		110,
		106,
		91,
		95,
		97,
		100,
		88,
		94,
		95,
		77,
		101,
		-1,
		104,
		98,
		106,
		96,
		84,
		-1,
		-1,
		-1,
		203,
		182,
		175,
		195,
		136,
		188,
		-1,
		-1,
		139,
		132,
		-1,
		119,
		101,
		103,
		95,
		89,
		96,
		91,
		82,
		95,
		88,
		82,
		76,
		89,
		93,
		97,
		86,
		82,
		79,
		93,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		156,
		-1,
		148,
		140,
		130,
		124,
		118,
		114,
		112,
		117,
		101,
		104,
		99,
		96,
		86,
		77,
		70,
		81,
		66,
		84,
		92,
		84,
		78,
		77,
		89,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		169,
		-1,
		133,
		147,
		163,
		-1,
		156,
		135,
		150,
		128,
		124,
		115,
		108,
		109,
		79,
		84,
		86,
		74,
		77,
		71,
		74,
		66,
		88,
		88,
		72,
		73,
		82,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		130,
		118,
		150,
		-1,
		-1,
		163,
		-1,
		117,
		119,
		129,
		127,
		98,
		73,
		80,
		98,
		71,
		66,
		76,
		65,
		62,
		60,
		82,
		68,
		66,
		85,
		101,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		167,
		-1,
		141,
		129,
		116,
		98,
		138,
		-1,
		72,
		68,
		75,
		-1,
		91,
		-1,
		63,
		66,
		57,
		54,
		54,
		65,
		63,
		74,
		91,
		-1,
		179,
		164,
		157,
		147,
		161,
		132,
		-1,
		187,
		-1,
		-1,
		128,
		122,
		122,
		91,
		88,
		88,
		68,
		60,
		75,
		74,
		61,
		60,
		48,
		48,
		51,
		57,
		70,
		90,
		81,
		92,
		-1,
		-1,
		-1,
		184,
		170,
		174,
		134,
		153,
		-1,
		-1,
		189,
		145,
		131,
		-1,
		83,
		88,
		76,
		66,
		56,
		61,
		62,
		52,
		50,
		46,
		55,
		59,
		66,
		71,
		92,
		86,
		106,
		-1,
		-1,
		167,
		172,
		160,
		146,
		150,
		-1,
		-1,
		-1,
		135,
		136,
		102,
		81,
		77,
		-1,
		-1,
		60,
		53,
		47,
		50,
		38,
		58,
		65,
		79,
		65,
		80,
		91,
		99,
		98,
		-1,
		170,
		157,
		-1,
		-1,
		149,
		139,
		-1,
		-1,
		-1,
		-1,
		114,
		59,
		48,
		43,
		47,
		59,
		-1,
		33,
		44,
		37,
		56,
		63,
		81,
		66,
		60,
		71,
		86,
		103,
		-1,
		-1,
		163,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		71,
		65,
		36,
		29,
		33,
		-1,
		35,
		37,
		34,
		46,
		57,
		62,
		70,
		54,
		68,
		71,
		84,
		98,
		102,
		186,
		-1,
		116,
		-1,
		-1,
		-1,
		89,
		104,
		71,
		48,
		25,
		18,
		15,
		21,
		26,
		46,
		52,
		63,
		48,
		52,
		67,
		77,
		76,
		93,
		103,
		-1,
		-1,
		114,
		110,
		115,
		97,
		101,
		98,
		-1,
		-1,
		16,
		7,
		17,
		28,
		36,
		39,
		44,
		46,
		64,
		83,
		71,
		86,
		101,
		97,
		-1,
		-1,
		-1,
		126,
		-1,
		128,
		-1,
		-1,
		116,
		73,
		20,
		0,
		3,
		10,
		30,
		39,
		34,
		39,
		64,
		59,
		68,
		73,
		77,
		100,
		89,
		128,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		105,
		97,
		92,
		98,
		100,
		91,
		35,
		30,
		-1,
		16,
		59,
		40,
		47,
		39,
		52,
		57,
		63,
		67,
		74,
		90,
		89,
		84,
		120,
		111,
		117,
		-1,
		-1,
		196,
		185,
		174,
		180,
		-1,
		98,
		94,
		84,
		74,
		77,
		-1,
		-1,
		65,
		62,
		40,
		49,
		53,
		46,
		41,
		79,
		55,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		150,
		187,
		180,
		148,
		156,
		187,
		-1,
		88,
		80,
		91,
		66,
		68,
		-1,
		-1,
		38,
		35,
		40,
		49,
		52,
		65,
		64,
		75,
		77,
		82,
		70,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		143,
		163,
		142,
		145,
		169,
		183,
		-1,
		85,
		-1,
		-1,
		97,
		69,
		53,
		43,
		37,
		87,
		62,
		57,
		67,
		69,
		73,
		64,
		87,
		78,
		78,
		81,
		96,
		101,
		93,
		107,
		107,
		108,
		-1,
		132,
		143,
		136,
		-1,
		-1,
		-1,
		-1,
		86,
		-1,
		-1,
		113,
		-1,
		80,
		-1,
		55,
		59,
		69,
		73,
		92,
		79,
		77,
		85,
		93,
		76,
		86,
		82,
		83,
		92,
		103,
		115,
		114,
		115,
		157,
		113,
		116,
		127,
		138,
		153,
		157,
		-1,
		97,
		136,
		151,
		-1,
		122,
		-1,
		-1,
		-1,
		69,
		82,
		74,
		91,
		91,
		91,
		71,
		75,
		81,
		88,
		98,
		100,
		92,
		96,
		109,
		120,
		123,
		153,
		144,
		157,
		102,
		102,
		123,
		132,
		153,
		112,
		103,
		130,
		156,
		147,
		142,
		129,
		-1,
		-1,
		92,
		92,
		-1,
		-1,
		98,
		92,
		75,
		77,
		81,
		91,
		106,
		109,
		99,
		97,
		91,
		123,
		-1,
		146,
		145,
		134,
		131,
		107,
		98,
		93,
		120,
		-1,
		-1,
		115,
		131,
		126,
		130,
		146,
		171,
		-1,
		132,
		-1,
		-1,
		113,
		-1,
		-1,
		134,
		97,
		86,
		77,
		83,
		89,
		100,
		117,
		105,
		106,
		96,
		106,
		119,
		130,
		127,
		115,
		113,
		136,
		101,
		89,
		-1,
		102,
		100,
		106,
		113,
		130,
		160,
		-1,
		-1,
		148,
		139,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		82,
		87,
		112,
		119,
		114,
		108,
		102,
		109,
		108,
		116,
		124,
		139,
		153,
		142,
		138,
		137,
		145,
		94,
		87,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		165,
		158,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		96,
		104,
		104,
		107,
		105,
		100,
		111,
		103,
		107,
		124,
		-1,
		173,
		-1,
		125,
		101,
		115,
		130,
		138,
		-1,
		-1,
		-1,
		182,
		168,
		161,
		149,
		147,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		140,
		108,
		113,
		108,
		106,
		117,
		106,
		109,
		123,
		118,
		-1,
		-1,
		113,
		116,
		-1,
		-1,
		138,
		157,
		-1,
		173,
		162,
		147,
		139,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		97,
		122,
		111,
		119,
		114,
		110,
		116,
		119,
		108,
		112,
		124,
		-1,
		-1,
		120,
		121,
		126,
		-1,
		147,
		-1,
		175,
		-1,
		142,
		148,
		136,
		-1,
		-1,
		-1,
		135,
		98,
		115,
		129,
		134,
		132,
		123,
		114,
		121,
		119,
		115,
		126,
		-1,
		-1,
		-1,
		175,
		149,
		182,
		173,
		156,
		136,
		128,
		147,
		-1,
		117,
		-1,
		92,
		95,
		120,
		128,
		145,
		139,
		117,
		132,
		122,
		113,
		122,
		181,
		-1,
		151,
		184,
		148,
		142,
		118,
		122,
		138,
		-1,
		114,
		96,
		-1,
		124,
		114,
		162,
		137,
		132,
		119,
		126,
		126,
		119,
		-1,
		-1,
		-1,
		153,
		152,
		144,
		138,
		138,
		123,
		114,
		-1,
		126,
		108,
		87,
		104,
		104,
		95,
		103,
		152,
		148,
		139,
		139,
		127,
		-1,
		245,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		147,
		142,
		115,
		103,
		109,
		105,
		91,
		97,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		126,
		158,
		-1,
		249,
		-1,
		183,
		-1,
		-1,
		165,
		145,
		137,
		126,
		115,
		113,
		104,
		95,
		117,
		133,
		117,
		115,
		120,
		125,
		-1,
		238,
		237,
		-1,
		184,
		176,
		162,
		-1,
		155,
		-1,
		161,
		122,
		-1,
		124,
		104,
		-1,
		126,
		122,
		-1,
		-1,
		225,
		200,
		-1,
		-1,
		-1,
		185,
		165,
		156,
		140,
		-1,
		115,
		115,
		-1,
		-1,
		-1,
		210,
		209,
		-1,
		178,
		181,
		-1,
		171,
		162,
		170,
		117,
		121,
		-1,
		-1,
		-1,
		219,
		200,
		194,
		193,
		191,
		186,
		183,
		169,
		153,
		131,
		120,
		141,
		-1,
		-1,
		-1,
		191,
		183,
		176,
		-1,
		-1,
		178,
		161,
		142,
		140,
		-1,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		168,
		-1,
		-1,
		174,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		202,
		-1,
		-1,
		-1,
		164,
		160,
		161,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		248,
		212,
		-1,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		227,
		225,
		-1,
		-1,
		-1,
		184,
		168,
		-1,
		154,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		189,
		-1,
		189,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		202,
		194,
		202,
		-1,
		174,
		176,
		-1,
		224,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		179,
		186,
		208,
		211,
		247,
		-1,
		198
	],
	[
		-1,
		205,
		194,
		205,
		213,
		186,
		193,
		-1,
		212,
		216,
		182,
		176,
		215,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		205,
		204,
		172,
		170,
		179,
		184,
		191,
		-1,
		190,
		-1,
		226,
		205,
		216,
		221,
		165,
		162,
		182,
		201,
		183,
		175,
		241,
		195,
		166,
		160,
		178,
		168,
		177,
		169,
		-1,
		166,
		156,
		178,
		157,
		168,
		160,
		-1,
		-1,
		160,
		161,
		167,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		150,
		151,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		141,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		147,
		165,
		170,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		144,
		-1,
		156,
		157,
		152,
		160,
		160,
		136,
		123,
		123,
		133,
		126,
		145,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		126,
		123,
		121,
		118,
		134,
		132,
		142,
		-1,
		-1,
		247,
		216,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		112,
		111,
		139,
		125,
		136,
		207,
		-1,
		-1,
		205,
		197,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		106,
		116,
		120,
		118,
		143,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		103,
		128,
		132,
		113,
		134,
		129,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		107,
		105,
		135,
		110,
		132,
		129,
		148,
		153,
		147,
		156,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		99,
		114,
		105,
		104,
		122,
		132,
		140,
		144,
		150,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		206,
		198,
		183,
		181,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		112,
		94,
		108,
		99,
		117,
		124,
		122,
		126,
		146,
		158,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		105,
		90,
		87,
		105,
		108,
		115,
		119,
		135,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		116,
		95,
		89,
		86,
		106,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		96,
		104,
		84,
		82,
		101,
		113,
		104,
		115,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		147,
		130,
		111,
		100,
		92,
		81,
		92,
		100,
		98,
		80,
		89,
		95,
		119,
		103,
		109,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		120,
		105,
		100,
		97,
		84,
		83,
		97,
		97,
		87,
		82,
		89,
		124,
		124,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		107,
		103,
		88,
		92,
		94,
		97,
		85,
		91,
		92,
		74,
		98,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		100,
		92,
		86,
		93,
		88,
		79,
		92,
		85,
		79,
		73,
		86,
		90,
		94,
		83,
		79,
		76,
		90,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		114,
		98,
		101,
		96,
		93,
		83,
		74,
		67,
		78,
		63,
		81,
		89,
		81,
		75,
		74,
		86,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		112,
		105,
		106,
		76,
		81,
		83,
		71,
		74,
		68,
		71,
		63,
		85,
		85,
		69,
		70,
		79,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		160,
		-1,
		114,
		116,
		126,
		124,
		95,
		70,
		77,
		95,
		68,
		63,
		73,
		62,
		59,
		57,
		79,
		65,
		63,
		82,
		98,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		138,
		126,
		113,
		95,
		135,
		-1,
		69,
		65,
		72,
		-1,
		88,
		-1,
		60,
		63,
		54,
		51,
		51,
		62,
		60,
		71,
		88,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		125,
		119,
		119,
		88,
		85,
		85,
		65,
		57,
		72,
		71,
		58,
		57,
		45,
		45,
		48,
		54,
		67,
		87,
		78,
		89,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		186,
		142,
		128,
		-1,
		80,
		85,
		73,
		63,
		53,
		58,
		59,
		49,
		47,
		43,
		52,
		56,
		63,
		68,
		89,
		83,
		103,
		-1,
		-1,
		164,
		169,
		157,
		143,
		147,
		-1,
		-1,
		-1,
		132,
		133,
		99,
		78,
		74,
		-1,
		-1,
		57,
		50,
		44,
		47,
		35,
		55,
		62,
		76,
		62,
		77,
		88,
		96,
		95,
		-1,
		167,
		154,
		-1,
		-1,
		146,
		136,
		-1,
		-1,
		-1,
		-1,
		111,
		56,
		45,
		40,
		44,
		56,
		-1,
		30,
		41,
		34,
		53,
		60,
		78,
		63,
		57,
		68,
		83,
		100,
		-1,
		-1,
		160,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		68,
		62,
		33,
		26,
		30,
		-1,
		32,
		34,
		31,
		43,
		54,
		59,
		67,
		51,
		65,
		68,
		81,
		95,
		99,
		183,
		-1,
		113,
		-1,
		-1,
		-1,
		86,
		101,
		68,
		45,
		22,
		15,
		12,
		18,
		23,
		43,
		49,
		60,
		45,
		49,
		64,
		74,
		73,
		90,
		100,
		-1,
		-1,
		111,
		107,
		112,
		94,
		98,
		95,
		-1,
		-1,
		13,
		4,
		14,
		25,
		33,
		36,
		41,
		43,
		61,
		80,
		68,
		83,
		98,
		94,
		-1,
		-1,
		-1,
		123,
		-1,
		125,
		-1,
		-1,
		113,
		77,
		24,
		4,
		0,
		7,
		27,
		36,
		31,
		36,
		61,
		56,
		65,
		70,
		74,
		97,
		86,
		125,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		102,
		94,
		89,
		95,
		97,
		88,
		39,
		34,
		-1,
		13,
		56,
		37,
		44,
		36,
		49,
		54,
		60,
		64,
		71,
		87,
		86,
		81,
		117,
		108,
		114,
		-1,
		-1,
		193,
		182,
		171,
		177,
		-1,
		95,
		91,
		81,
		71,
		74,
		-1,
		-1,
		62,
		59,
		37,
		46,
		50,
		43,
		38,
		76,
		52,
		60,
		64,
		68,
		74,
		79,
		84,
		90,
		105,
		120,
		-1,
		147,
		184,
		177,
		145,
		153,
		184,
		-1,
		85,
		77,
		88,
		63,
		65,
		-1,
		-1,
		35,
		32,
		37,
		46,
		49,
		62,
		61,
		72,
		74,
		79,
		67,
		66,
		84,
		88,
		97,
		104,
		94,
		107,
		111,
		-1,
		140,
		160,
		139,
		142,
		166,
		180,
		-1,
		82,
		-1,
		-1,
		94,
		66,
		50,
		40,
		34,
		84,
		59,
		54,
		64,
		66,
		70,
		61,
		84,
		75,
		75,
		78,
		93,
		98,
		90,
		104,
		104,
		105,
		-1,
		129,
		140,
		133,
		-1,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		110,
		-1,
		77,
		-1,
		52,
		56,
		66,
		70,
		89,
		76,
		74,
		82,
		90,
		73,
		83,
		79,
		80,
		89,
		100,
		112,
		111,
		112,
		154,
		110,
		113,
		124,
		135,
		150,
		154,
		-1,
		94,
		133,
		148,
		-1,
		119,
		-1,
		-1,
		-1,
		66,
		79,
		71,
		88,
		88,
		88,
		68,
		72,
		78,
		85,
		95,
		97,
		89,
		93,
		106,
		117,
		120,
		150,
		141,
		154,
		99,
		99,
		120,
		129,
		150,
		109,
		100,
		127,
		153,
		144,
		139,
		126,
		-1,
		-1,
		89,
		89,
		-1,
		-1,
		95,
		89,
		72,
		74,
		78,
		88,
		103,
		106,
		96,
		94,
		88,
		120,
		-1,
		143,
		142,
		131,
		128,
		104,
		95,
		90,
		117,
		-1,
		-1,
		112,
		128,
		123,
		127,
		143,
		168,
		-1,
		129,
		-1,
		-1,
		110,
		-1,
		-1,
		131,
		94,
		83,
		74,
		80,
		86,
		97,
		114,
		102,
		103,
		93,
		103,
		116,
		127,
		124,
		112,
		110,
		133,
		98,
		86,
		-1,
		99,
		97,
		103,
		110,
		127,
		157,
		-1,
		-1,
		145,
		136,
		-1,
		-1,
		129,
		127,
		116,
		-1,
		106,
		79,
		84,
		109,
		116,
		111,
		105,
		99,
		106,
		105,
		113,
		121,
		136,
		150,
		139,
		135,
		134,
		142,
		91,
		84,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		155,
		-1,
		-1,
		124,
		117,
		105,
		93,
		83,
		93,
		101,
		101,
		104,
		102,
		97,
		108,
		100,
		104,
		121,
		-1,
		170,
		-1,
		122,
		98,
		112,
		127,
		135,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		158,
		142,
		123,
		-1,
		93,
		106,
		137,
		105,
		110,
		105,
		103,
		114,
		103,
		106,
		120,
		115,
		-1,
		-1,
		110,
		113,
		-1,
		-1,
		135,
		154,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		94,
		119,
		108,
		116,
		111,
		107,
		113,
		116,
		105,
		109,
		121,
		-1,
		-1,
		117,
		118,
		123,
		-1,
		144,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		132,
		95,
		112,
		126,
		131,
		129,
		120,
		111,
		118,
		116,
		112,
		123,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		89,
		92,
		117,
		125,
		142,
		136,
		114,
		129,
		119,
		110,
		119,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		93,
		-1,
		121,
		111,
		159,
		134,
		129,
		116,
		123,
		123,
		116,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		100,
		149,
		145,
		136,
		136,
		124,
		-1,
		242,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		104,
		102,
		99,
		111,
		107,
		127,
		123,
		155,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		114,
		112,
		117,
		122,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		123,
		119,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		210,
		199,
		210,
		218,
		191,
		198,
		-1,
		217,
		221,
		187,
		181,
		220,
		189,
		195,
		206,
		-1,
		-1,
		-1,
		210,
		209,
		177,
		175,
		184,
		189,
		196,
		-1,
		195,
		-1,
		231,
		210,
		221,
		226,
		170,
		167,
		187,
		206,
		188,
		180,
		246,
		200,
		171,
		165,
		183,
		173,
		182,
		174,
		-1,
		171,
		161,
		183,
		162,
		173,
		165,
		-1,
		-1,
		165,
		166,
		172,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		155,
		156,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		146,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		152,
		170,
		175,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		149,
		-1,
		161,
		162,
		157,
		165,
		165,
		141,
		128,
		128,
		138,
		131,
		150,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		161,
		144,
		161,
		153,
		143,
		158,
		151,
		131,
		128,
		126,
		123,
		139,
		137,
		147,
		-1,
		-1,
		252,
		221,
		252,
		210,
		191,
		-1,
		157,
		137,
		143,
		147,
		141,
		134,
		148,
		144,
		-1,
		117,
		116,
		144,
		130,
		141,
		212,
		-1,
		-1,
		210,
		202,
		187,
		190,
		167,
		163,
		152,
		151,
		143,
		129,
		125,
		131,
		134,
		134,
		140,
		111,
		121,
		125,
		123,
		148,
		-1,
		-1,
		183,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		173,
		179,
		165,
		186,
		162,
		153,
		145,
		139,
		127,
		129,
		126,
		139,
		127,
		108,
		133,
		137,
		118,
		139,
		134,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		202,
		-1,
		174,
		162,
		163,
		148,
		145,
		132,
		120,
		133,
		118,
		125,
		124,
		112,
		110,
		140,
		115,
		137,
		134,
		153,
		158,
		152,
		161,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		210,
		211,
		186,
		159,
		162,
		149,
		140,
		127,
		116,
		127,
		116,
		113,
		121,
		104,
		119,
		110,
		109,
		127,
		137,
		145,
		149,
		155,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		211,
		203,
		188,
		186,
		-1,
		158,
		155,
		145,
		123,
		108,
		125,
		117,
		115,
		117,
		99,
		113,
		104,
		122,
		129,
		127,
		131,
		151,
		163,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		228,
		192,
		-1,
		187,
		-1,
		160,
		173,
		-1,
		129,
		125,
		107,
		108,
		103,
		118,
		110,
		95,
		92,
		110,
		113,
		120,
		124,
		140,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		185,
		174,
		173,
		-1,
		164,
		143,
		140,
		128,
		115,
		100,
		101,
		109,
		121,
		100,
		94,
		91,
		111,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		203,
		196,
		184,
		149,
		149,
		143,
		-1,
		139,
		118,
		109,
		98,
		96,
		109,
		101,
		109,
		89,
		87,
		106,
		118,
		109,
		120,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		182,
		168,
		173,
		148,
		141,
		135,
		152,
		135,
		116,
		105,
		97,
		86,
		97,
		105,
		103,
		85,
		94,
		100,
		124,
		108,
		114,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		173,
		186,
		-1,
		140,
		-1,
		129,
		125,
		110,
		105,
		102,
		89,
		88,
		102,
		102,
		92,
		87,
		94,
		129,
		129,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		112,
		108,
		93,
		97,
		99,
		102,
		90,
		96,
		97,
		79,
		103,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		105,
		97,
		91,
		98,
		93,
		84,
		97,
		90,
		84,
		78,
		91,
		95,
		99,
		88,
		84,
		81,
		95,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		119,
		103,
		106,
		101,
		98,
		88,
		79,
		72,
		83,
		68,
		86,
		94,
		86,
		80,
		79,
		91,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		149,
		165,
		-1,
		158,
		137,
		152,
		130,
		126,
		117,
		110,
		111,
		81,
		86,
		88,
		76,
		79,
		73,
		76,
		68,
		90,
		90,
		74,
		75,
		84,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		120,
		152,
		-1,
		-1,
		165,
		-1,
		119,
		121,
		131,
		129,
		100,
		75,
		82,
		100,
		73,
		68,
		78,
		67,
		64,
		62,
		84,
		70,
		68,
		87,
		103,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		143,
		131,
		118,
		100,
		140,
		-1,
		74,
		70,
		77,
		-1,
		93,
		-1,
		65,
		68,
		59,
		56,
		56,
		67,
		65,
		76,
		93,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		189,
		-1,
		-1,
		130,
		124,
		124,
		93,
		90,
		90,
		70,
		62,
		77,
		76,
		63,
		62,
		50,
		50,
		53,
		59,
		72,
		92,
		83,
		94,
		-1,
		-1,
		-1,
		186,
		172,
		176,
		136,
		155,
		-1,
		-1,
		191,
		147,
		133,
		-1,
		85,
		90,
		78,
		68,
		58,
		63,
		64,
		54,
		52,
		48,
		57,
		61,
		68,
		73,
		94,
		88,
		108,
		-1,
		-1,
		169,
		174,
		162,
		145,
		140,
		-1,
		-1,
		-1,
		137,
		138,
		104,
		83,
		79,
		-1,
		-1,
		62,
		55,
		49,
		52,
		40,
		60,
		67,
		81,
		67,
		82,
		93,
		101,
		100,
		-1,
		172,
		159,
		-1,
		-1,
		139,
		129,
		-1,
		-1,
		-1,
		-1,
		116,
		61,
		50,
		45,
		49,
		61,
		-1,
		35,
		46,
		39,
		58,
		65,
		83,
		68,
		62,
		73,
		88,
		105,
		-1,
		-1,
		153,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		73,
		67,
		38,
		31,
		35,
		-1,
		37,
		39,
		36,
		48,
		59,
		64,
		72,
		56,
		70,
		73,
		86,
		100,
		104,
		176,
		-1,
		106,
		-1,
		-1,
		-1,
		91,
		106,
		71,
		48,
		27,
		20,
		17,
		23,
		28,
		48,
		54,
		65,
		50,
		54,
		69,
		79,
		78,
		95,
		105,
		-1,
		-1,
		104,
		100,
		117,
		99,
		103,
		98,
		-1,
		-1,
		16,
		9,
		19,
		30,
		38,
		41,
		46,
		48,
		66,
		85,
		73,
		88,
		103,
		99,
		-1,
		-1,
		-1,
		116,
		-1,
		118,
		-1,
		-1,
		106,
		89,
		36,
		18,
		14,
		0,
		32,
		41,
		36,
		41,
		66,
		61,
		70,
		75,
		79,
		102,
		91,
		130,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		95,
		87,
		82,
		88,
		90,
		81,
		51,
		48,
		-1,
		6,
		49,
		42,
		49,
		41,
		54,
		59,
		65,
		69,
		76,
		92,
		91,
		86,
		122,
		113,
		119,
		-1,
		-1,
		186,
		175,
		164,
		170,
		-1,
		88,
		84,
		74,
		64,
		67,
		-1,
		-1,
		55,
		52,
		30,
		43,
		49,
		48,
		43,
		81,
		57,
		65,
		69,
		73,
		79,
		84,
		89,
		95,
		110,
		125,
		-1,
		140,
		177,
		170,
		138,
		146,
		177,
		-1,
		78,
		70,
		81,
		56,
		58,
		-1,
		-1,
		28,
		25,
		30,
		39,
		42,
		67,
		66,
		77,
		79,
		84,
		72,
		71,
		89,
		93,
		102,
		109,
		99,
		112,
		116,
		-1,
		133,
		153,
		132,
		135,
		159,
		173,
		-1,
		75,
		-1,
		-1,
		87,
		59,
		43,
		33,
		27,
		77,
		52,
		47,
		61,
		63,
		75,
		66,
		89,
		80,
		80,
		83,
		98,
		103,
		95,
		109,
		109,
		110,
		-1,
		122,
		133,
		126,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		103,
		-1,
		70,
		-1,
		45,
		49,
		59,
		63,
		86,
		73,
		79,
		87,
		95,
		78,
		88,
		84,
		85,
		94,
		105,
		117,
		116,
		117,
		147,
		103,
		106,
		117,
		128,
		143,
		147,
		-1,
		87,
		126,
		141,
		-1,
		112,
		-1,
		-1,
		-1,
		59,
		72,
		64,
		81,
		85,
		85,
		73,
		77,
		83,
		90,
		100,
		102,
		94,
		98,
		111,
		122,
		125,
		143,
		134,
		147,
		92,
		92,
		113,
		122,
		143,
		102,
		93,
		120,
		146,
		137,
		132,
		119,
		-1,
		-1,
		82,
		82,
		-1,
		-1,
		92,
		94,
		77,
		79,
		83,
		93,
		108,
		111,
		101,
		99,
		93,
		125,
		-1,
		136,
		135,
		124,
		121,
		97,
		88,
		83,
		110,
		-1,
		-1,
		105,
		121,
		116,
		120,
		136,
		161,
		-1,
		122,
		-1,
		-1,
		103,
		-1,
		-1,
		136,
		99,
		88,
		79,
		85,
		91,
		102,
		119,
		107,
		108,
		98,
		108,
		121,
		120,
		117,
		105,
		103,
		126,
		91,
		79,
		-1,
		92,
		90,
		96,
		103,
		120,
		150,
		-1,
		-1,
		138,
		129,
		-1,
		-1,
		122,
		129,
		121,
		-1,
		111,
		84,
		89,
		114,
		121,
		116,
		110,
		104,
		111,
		110,
		118,
		126,
		129,
		143,
		132,
		128,
		127,
		135,
		84,
		77,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		167,
		148,
		-1,
		-1,
		129,
		122,
		110,
		98,
		88,
		98,
		106,
		106,
		109,
		107,
		102,
		113,
		105,
		109,
		126,
		-1,
		163,
		-1,
		115,
		91,
		105,
		120,
		128,
		-1,
		-1,
		-1,
		184,
		170,
		163,
		151,
		149,
		-1,
		163,
		147,
		128,
		-1,
		98,
		111,
		142,
		110,
		115,
		110,
		108,
		119,
		108,
		111,
		125,
		120,
		-1,
		-1,
		103,
		106,
		-1,
		-1,
		128,
		147,
		-1,
		175,
		164,
		149,
		141,
		-1,
		-1,
		135,
		131,
		-1,
		-1,
		99,
		124,
		113,
		121,
		116,
		112,
		118,
		121,
		110,
		114,
		126,
		-1,
		-1,
		110,
		111,
		116,
		-1,
		137,
		-1,
		177,
		-1,
		144,
		150,
		138,
		-1,
		-1,
		-1,
		137,
		100,
		117,
		131,
		136,
		134,
		125,
		116,
		123,
		121,
		117,
		128,
		-1,
		-1,
		-1,
		167,
		144,
		184,
		175,
		158,
		138,
		130,
		149,
		-1,
		119,
		-1,
		94,
		97,
		122,
		130,
		147,
		141,
		119,
		134,
		124,
		115,
		124,
		173,
		-1,
		148,
		186,
		150,
		144,
		120,
		124,
		140,
		-1,
		116,
		98,
		-1,
		126,
		116,
		164,
		139,
		134,
		121,
		128,
		128,
		121,
		-1,
		-1,
		-1,
		155,
		154,
		146,
		140,
		140,
		125,
		116,
		-1,
		128,
		110,
		89,
		106,
		106,
		97,
		105,
		154,
		150,
		141,
		141,
		129,
		-1,
		235,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		149,
		144,
		117,
		105,
		111,
		107,
		93,
		99,
		101,
		109,
		107,
		104,
		116,
		112,
		132,
		128,
		160,
		-1,
		242,
		-1,
		185,
		-1,
		-1,
		167,
		147,
		139,
		128,
		117,
		115,
		106,
		97,
		119,
		135,
		119,
		117,
		122,
		127,
		-1,
		240,
		239,
		-1,
		186,
		178,
		164,
		-1,
		157,
		-1,
		163,
		124,
		-1,
		126,
		106,
		-1,
		128,
		124,
		-1,
		-1,
		227,
		202,
		-1,
		-1,
		-1,
		187,
		167,
		158,
		142,
		-1,
		117,
		117,
		-1,
		-1,
		-1,
		212,
		211,
		-1,
		180,
		183,
		-1,
		173,
		164,
		172,
		119,
		123,
		-1,
		-1,
		-1,
		221,
		202,
		196,
		195,
		193,
		188,
		185,
		171,
		155,
		133,
		122,
		143,
		-1,
		-1,
		-1,
		193,
		185,
		178,
		-1,
		-1,
		180,
		163,
		144,
		142,
		-1,
		-1,
		-1,
		215,
		196,
		-1,
		-1,
		170,
		-1,
		-1,
		176,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		204,
		-1,
		-1,
		-1,
		166,
		162,
		163,
		-1,
		-1,
		-1,
		-1,
		226,
		227,
		250,
		214,
		-1,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		229,
		227,
		-1,
		-1,
		-1,
		186,
		170,
		-1,
		156,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		189,
		-1,
		-1,
		-1,
		191,
		-1,
		191,
		166,
		173,
		-1,
		-1,
		-1,
		-1,
		204,
		196,
		204,
		-1,
		176,
		178,
		-1,
		226,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		181,
		188,
		210,
		213,
		249,
		-1,
		200
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		207,
		211,
		177,
		171,
		210,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		200,
		199,
		167,
		165,
		174,
		179,
		186,
		-1,
		185,
		-1,
		221,
		200,
		211,
		216,
		160,
		157,
		177,
		196,
		178,
		170,
		236,
		190,
		161,
		155,
		173,
		163,
		172,
		164,
		-1,
		161,
		151,
		173,
		152,
		163,
		155,
		-1,
		-1,
		155,
		156,
		162,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		145,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		142,
		160,
		165,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		139,
		-1,
		151,
		152,
		147,
		155,
		155,
		131,
		118,
		118,
		128,
		121,
		140,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		121,
		118,
		116,
		113,
		129,
		127,
		137,
		-1,
		-1,
		242,
		211,
		242,
		200,
		181,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		107,
		106,
		134,
		120,
		131,
		202,
		-1,
		-1,
		200,
		192,
		177,
		180,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		101,
		111,
		115,
		113,
		138,
		-1,
		-1,
		173,
		-1,
		-1,
		199,
		182,
		-1,
		165,
		172,
		163,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		98,
		123,
		127,
		108,
		129,
		124,
		-1,
		172,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		158,
		161,
		167,
		191,
		192,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		102,
		100,
		130,
		105,
		127,
		124,
		143,
		148,
		142,
		151,
		-1,
		207,
		203,
		199,
		206,
		155,
		-1,
		-1,
		195,
		-1,
		200,
		201,
		176,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		94,
		109,
		100,
		99,
		117,
		127,
		135,
		139,
		145,
		-1,
		257,
		-1,
		199,
		183,
		185,
		157,
		178,
		-1,
		215,
		201,
		193,
		178,
		176,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		107,
		89,
		103,
		94,
		112,
		119,
		117,
		121,
		141,
		153,
		217,
		207,
		-1,
		189,
		194,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		100,
		85,
		82,
		100,
		103,
		110,
		114,
		130,
		-1,
		-1,
		202,
		206,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		111,
		90,
		84,
		81,
		101,
		127,
		105,
		117,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		129,
		108,
		99,
		88,
		86,
		99,
		91,
		99,
		79,
		77,
		96,
		108,
		99,
		110,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		142,
		125,
		106,
		95,
		87,
		76,
		87,
		95,
		93,
		75,
		84,
		90,
		114,
		98,
		104,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		115,
		100,
		95,
		92,
		79,
		78,
		92,
		92,
		82,
		77,
		84,
		119,
		119,
		88,
		108,
		111,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		102,
		98,
		83,
		87,
		89,
		92,
		80,
		86,
		87,
		69,
		93,
		-1,
		96,
		90,
		98,
		88,
		76,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		95,
		87,
		81,
		88,
		83,
		74,
		87,
		80,
		74,
		68,
		81,
		85,
		89,
		78,
		74,
		71,
		85,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		109,
		93,
		96,
		91,
		88,
		78,
		69,
		62,
		73,
		58,
		76,
		84,
		76,
		70,
		69,
		81,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		107,
		100,
		101,
		71,
		76,
		78,
		66,
		69,
		63,
		66,
		58,
		80,
		80,
		64,
		65,
		74,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		169,
		-1,
		118,
		125,
		121,
		119,
		90,
		65,
		72,
		90,
		63,
		58,
		68,
		57,
		54,
		52,
		74,
		60,
		58,
		77,
		93,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		147,
		135,
		122,
		104,
		144,
		-1,
		64,
		60,
		67,
		-1,
		83,
		-1,
		55,
		58,
		49,
		46,
		46,
		57,
		55,
		66,
		81,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		134,
		128,
		128,
		97,
		94,
		80,
		60,
		52,
		67,
		66,
		53,
		52,
		40,
		40,
		43,
		49,
		62,
		81,
		73,
		79,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		195,
		151,
		137,
		-1,
		89,
		80,
		68,
		58,
		48,
		53,
		54,
		44,
		42,
		38,
		47,
		51,
		58,
		59,
		80,
		73,
		95,
		-1,
		-1,
		159,
		164,
		152,
		138,
		155,
		-1,
		-1,
		-1,
		141,
		142,
		108,
		87,
		69,
		-1,
		-1,
		52,
		45,
		39,
		42,
		30,
		50,
		57,
		66,
		53,
		68,
		78,
		86,
		85,
		-1,
		162,
		149,
		-1,
		-1,
		154,
		144,
		-1,
		-1,
		-1,
		-1,
		120,
		65,
		54,
		49,
		53,
		51,
		-1,
		25,
		35,
		29,
		48,
		55,
		68,
		53,
		47,
		58,
		73,
		90,
		-1,
		-1,
		168,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		77,
		71,
		42,
		35,
		39,
		-1,
		27,
		28,
		26,
		38,
		49,
		54,
		59,
		41,
		55,
		58,
		71,
		85,
		89,
		191,
		-1,
		121,
		-1,
		-1,
		-1,
		95,
		110,
		81,
		58,
		31,
		26,
		19,
		13,
		18,
		38,
		44,
		55,
		35,
		39,
		54,
		64,
		63,
		80,
		90,
		-1,
		-1,
		119,
		115,
		121,
		103,
		107,
		108,
		-1,
		-1,
		35,
		26,
		17,
		20,
		28,
		31,
		31,
		33,
		51,
		70,
		58,
		73,
		88,
		86,
		-1,
		-1,
		-1,
		131,
		-1,
		133,
		-1,
		-1,
		121,
		106,
		53,
		35,
		31,
		29,
		0,
		9,
		21,
		26,
		51,
		48,
		57,
		60,
		66,
		89,
		78,
		117,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		110,
		102,
		97,
		103,
		105,
		96,
		68,
		65,
		-1,
		35,
		38,
		14,
		20,
		26,
		41,
		46,
		52,
		56,
		63,
		79,
		78,
		73,
		109,
		100,
		106,
		-1,
		-1,
		196,
		185,
		174,
		180,
		-1,
		103,
		99,
		89,
		79,
		82,
		-1,
		-1,
		76,
		73,
		35,
		22,
		28,
		33,
		30,
		68,
		44,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		150,
		187,
		180,
		148,
		156,
		187,
		-1,
		93,
		85,
		96,
		71,
		73,
		-1,
		-1,
		49,
		40,
		41,
		29,
		26,
		53,
		52,
		64,
		66,
		71,
		59,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		143,
		163,
		142,
		145,
		169,
		183,
		-1,
		90,
		-1,
		-1,
		102,
		74,
		58,
		48,
		45,
		88,
		43,
		38,
		40,
		42,
		62,
		53,
		76,
		67,
		67,
		70,
		85,
		90,
		82,
		96,
		96,
		97,
		-1,
		132,
		143,
		136,
		-1,
		-1,
		-1,
		-1,
		91,
		-1,
		-1,
		118,
		-1,
		85,
		-1,
		68,
		72,
		51,
		54,
		65,
		52,
		59,
		74,
		82,
		65,
		75,
		71,
		72,
		81,
		92,
		104,
		103,
		104,
		157,
		113,
		116,
		127,
		138,
		153,
		157,
		-1,
		102,
		141,
		156,
		-1,
		127,
		-1,
		-1,
		-1,
		82,
		64,
		56,
		72,
		64,
		64,
		60,
		64,
		70,
		77,
		87,
		89,
		81,
		85,
		98,
		109,
		112,
		153,
		144,
		157,
		102,
		102,
		123,
		132,
		153,
		117,
		108,
		135,
		156,
		152,
		147,
		134,
		-1,
		-1,
		105,
		74,
		-1,
		-1,
		71,
		81,
		64,
		66,
		70,
		80,
		95,
		98,
		88,
		86,
		80,
		112,
		-1,
		146,
		145,
		134,
		131,
		107,
		98,
		93,
		120,
		-1,
		-1,
		115,
		136,
		126,
		130,
		146,
		171,
		-1,
		137,
		-1,
		-1,
		126,
		-1,
		-1,
		123,
		86,
		75,
		66,
		72,
		78,
		89,
		106,
		94,
		95,
		85,
		95,
		108,
		130,
		127,
		115,
		113,
		136,
		101,
		89,
		-1,
		102,
		100,
		106,
		113,
		130,
		160,
		-1,
		-1,
		153,
		144,
		-1,
		-1,
		121,
		119,
		108,
		-1,
		98,
		71,
		76,
		101,
		108,
		103,
		97,
		91,
		98,
		97,
		105,
		113,
		139,
		153,
		142,
		138,
		137,
		145,
		94,
		87,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		150,
		-1,
		-1,
		116,
		109,
		97,
		85,
		75,
		85,
		93,
		93,
		96,
		94,
		89,
		100,
		92,
		96,
		113,
		-1,
		173,
		-1,
		125,
		101,
		115,
		130,
		138,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		150,
		134,
		115,
		-1,
		85,
		98,
		129,
		97,
		102,
		97,
		95,
		106,
		95,
		98,
		112,
		107,
		-1,
		-1,
		113,
		116,
		-1,
		-1,
		138,
		157,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		122,
		118,
		-1,
		-1,
		86,
		111,
		100,
		108,
		103,
		99,
		105,
		108,
		97,
		101,
		113,
		-1,
		-1,
		120,
		121,
		126,
		-1,
		146,
		-1,
		164,
		-1,
		131,
		137,
		125,
		-1,
		-1,
		-1,
		124,
		87,
		104,
		118,
		123,
		121,
		112,
		103,
		110,
		108,
		104,
		115,
		-1,
		-1,
		-1,
		164,
		138,
		171,
		162,
		145,
		125,
		117,
		136,
		-1,
		106,
		-1,
		81,
		84,
		109,
		117,
		134,
		128,
		106,
		121,
		111,
		102,
		111,
		170,
		-1,
		140,
		173,
		137,
		131,
		107,
		111,
		127,
		-1,
		103,
		85,
		-1,
		113,
		103,
		151,
		126,
		121,
		108,
		115,
		115,
		108,
		-1,
		-1,
		-1,
		142,
		141,
		133,
		127,
		127,
		112,
		103,
		-1,
		115,
		97,
		76,
		93,
		93,
		84,
		92,
		141,
		137,
		128,
		128,
		116,
		-1,
		243,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		136,
		131,
		104,
		92,
		98,
		94,
		80,
		86,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		115,
		147,
		-1,
		238,
		-1,
		172,
		-1,
		-1,
		154,
		134,
		126,
		115,
		104,
		102,
		93,
		84,
		106,
		122,
		106,
		104,
		109,
		114,
		-1,
		227,
		226,
		-1,
		173,
		165,
		151,
		-1,
		144,
		-1,
		150,
		111,
		-1,
		113,
		93,
		-1,
		115,
		111,
		-1,
		-1,
		214,
		189,
		-1,
		-1,
		-1,
		174,
		154,
		145,
		129,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		199,
		198,
		-1,
		167,
		170,
		-1,
		160,
		151,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		208,
		189,
		183,
		182,
		180,
		175,
		172,
		158,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		180,
		172,
		165,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		191,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		213,
		214,
		237,
		201,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		216,
		214,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		148,
		166,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		157,
		158,
		153,
		161,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		140,
		157,
		149,
		139,
		154,
		147,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		248,
		217,
		248,
		206,
		187,
		-1,
		153,
		133,
		139,
		143,
		137,
		130,
		144,
		140,
		-1,
		113,
		112,
		140,
		126,
		137,
		208,
		-1,
		-1,
		206,
		198,
		183,
		186,
		163,
		159,
		148,
		147,
		139,
		125,
		121,
		127,
		130,
		130,
		136,
		107,
		117,
		121,
		119,
		144,
		-1,
		-1,
		179,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		169,
		175,
		161,
		182,
		158,
		149,
		141,
		135,
		123,
		125,
		122,
		135,
		123,
		104,
		129,
		133,
		114,
		135,
		130,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		198,
		-1,
		170,
		158,
		159,
		144,
		141,
		128,
		116,
		129,
		114,
		121,
		120,
		108,
		106,
		136,
		111,
		133,
		130,
		149,
		154,
		148,
		157,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		206,
		207,
		182,
		155,
		158,
		145,
		136,
		123,
		112,
		123,
		112,
		109,
		117,
		100,
		115,
		106,
		105,
		123,
		133,
		141,
		145,
		151,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		207,
		199,
		184,
		182,
		-1,
		154,
		151,
		141,
		119,
		104,
		121,
		113,
		111,
		113,
		95,
		109,
		100,
		118,
		125,
		123,
		127,
		147,
		159,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		156,
		169,
		-1,
		125,
		121,
		103,
		104,
		99,
		114,
		106,
		91,
		88,
		106,
		109,
		116,
		120,
		136,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		139,
		136,
		124,
		111,
		96,
		97,
		105,
		117,
		96,
		90,
		87,
		107,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		135,
		114,
		105,
		94,
		92,
		105,
		97,
		105,
		85,
		83,
		102,
		114,
		105,
		114,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		148,
		131,
		112,
		101,
		93,
		82,
		93,
		101,
		99,
		81,
		90,
		96,
		120,
		102,
		108,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		121,
		106,
		101,
		98,
		85,
		84,
		98,
		98,
		88,
		83,
		90,
		125,
		125,
		92,
		112,
		115,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		108,
		104,
		89,
		93,
		95,
		98,
		86,
		92,
		93,
		75,
		99,
		-1,
		100,
		94,
		102,
		92,
		80,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		101,
		93,
		87,
		94,
		89,
		80,
		93,
		86,
		80,
		74,
		87,
		91,
		93,
		82,
		78,
		75,
		89,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		115,
		99,
		102,
		97,
		94,
		84,
		75,
		68,
		79,
		64,
		82,
		89,
		80,
		75,
		74,
		85,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		113,
		106,
		107,
		77,
		82,
		84,
		72,
		75,
		69,
		72,
		64,
		86,
		84,
		68,
		70,
		79,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		175,
		-1,
		124,
		131,
		127,
		125,
		96,
		71,
		78,
		96,
		69,
		64,
		74,
		63,
		60,
		58,
		78,
		64,
		62,
		77,
		93,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		153,
		141,
		128,
		110,
		150,
		-1,
		70,
		66,
		73,
		-1,
		89,
		-1,
		61,
		64,
		55,
		52,
		52,
		63,
		61,
		71,
		72,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		140,
		134,
		134,
		103,
		100,
		86,
		66,
		58,
		73,
		72,
		59,
		58,
		46,
		46,
		49,
		49,
		62,
		72,
		78,
		70,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		201,
		157,
		143,
		-1,
		95,
		86,
		74,
		64,
		54,
		59,
		60,
		50,
		48,
		44,
		53,
		57,
		51,
		50,
		71,
		64,
		86,
		-1,
		-1,
		165,
		170,
		158,
		144,
		146,
		-1,
		-1,
		-1,
		147,
		148,
		114,
		93,
		75,
		-1,
		-1,
		58,
		51,
		45,
		48,
		36,
		56,
		63,
		57,
		44,
		59,
		69,
		77,
		76,
		-1,
		168,
		155,
		-1,
		-1,
		145,
		135,
		-1,
		-1,
		-1,
		-1,
		126,
		71,
		60,
		55,
		59,
		57,
		-1,
		31,
		41,
		35,
		54,
		61,
		59,
		44,
		38,
		49,
		64,
		81,
		-1,
		-1,
		159,
		-1,
		121,
		-1,
		-1,
		-1,
		-1,
		83,
		77,
		48,
		41,
		45,
		-1,
		33,
		34,
		32,
		44,
		54,
		59,
		50,
		32,
		46,
		49,
		62,
		76,
		80,
		182,
		-1,
		112,
		-1,
		-1,
		-1,
		101,
		116,
		87,
		64,
		37,
		32,
		25,
		19,
		24,
		40,
		49,
		60,
		26,
		30,
		45,
		55,
		54,
		71,
		81,
		-1,
		-1,
		110,
		106,
		127,
		109,
		113,
		114,
		-1,
		-1,
		41,
		32,
		23,
		19,
		33,
		36,
		22,
		24,
		42,
		61,
		49,
		64,
		79,
		77,
		-1,
		-1,
		-1,
		122,
		-1,
		124,
		-1,
		-1,
		112,
		112,
		59,
		41,
		37,
		35,
		6,
		0,
		12,
		17,
		42,
		39,
		48,
		51,
		57,
		80,
		69,
		108,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		101,
		93,
		88,
		94,
		96,
		87,
		74,
		71,
		-1,
		41,
		29,
		5,
		11,
		17,
		32,
		37,
		43,
		47,
		54,
		70,
		69,
		64,
		100,
		91,
		97,
		-1,
		-1,
		187,
		176,
		165,
		171,
		-1,
		94,
		90,
		80,
		70,
		73,
		-1,
		-1,
		67,
		64,
		26,
		13,
		19,
		24,
		21,
		59,
		35,
		43,
		47,
		51,
		57,
		62,
		67,
		73,
		88,
		103,
		-1,
		141,
		178,
		171,
		139,
		147,
		178,
		-1,
		84,
		76,
		87,
		62,
		64,
		-1,
		-1,
		40,
		31,
		32,
		20,
		17,
		44,
		43,
		55,
		57,
		62,
		50,
		49,
		67,
		71,
		80,
		87,
		77,
		90,
		94,
		-1,
		134,
		154,
		133,
		136,
		160,
		174,
		-1,
		81,
		-1,
		-1,
		93,
		65,
		49,
		39,
		36,
		79,
		34,
		29,
		31,
		33,
		53,
		44,
		67,
		58,
		58,
		61,
		76,
		81,
		73,
		87,
		87,
		88,
		-1,
		123,
		134,
		127,
		-1,
		-1,
		-1,
		-1,
		82,
		-1,
		-1,
		109,
		-1,
		76,
		-1,
		59,
		63,
		42,
		45,
		56,
		43,
		50,
		65,
		73,
		56,
		66,
		62,
		63,
		72,
		83,
		95,
		94,
		95,
		148,
		104,
		107,
		118,
		129,
		144,
		148,
		-1,
		93,
		132,
		147,
		-1,
		118,
		-1,
		-1,
		-1,
		73,
		55,
		47,
		63,
		55,
		55,
		51,
		55,
		61,
		68,
		78,
		80,
		72,
		76,
		89,
		100,
		103,
		144,
		135,
		148,
		93,
		93,
		114,
		123,
		144,
		108,
		99,
		126,
		147,
		143,
		138,
		125,
		-1,
		-1,
		96,
		65,
		-1,
		-1,
		62,
		72,
		55,
		57,
		61,
		71,
		86,
		89,
		79,
		77,
		71,
		103,
		-1,
		137,
		136,
		125,
		122,
		98,
		89,
		84,
		111,
		-1,
		-1,
		106,
		127,
		117,
		121,
		137,
		162,
		-1,
		128,
		-1,
		-1,
		117,
		-1,
		-1,
		114,
		77,
		66,
		57,
		63,
		69,
		80,
		97,
		85,
		86,
		76,
		86,
		99,
		121,
		118,
		106,
		104,
		127,
		92,
		80,
		-1,
		93,
		91,
		97,
		104,
		121,
		151,
		-1,
		-1,
		144,
		135,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		62,
		67,
		92,
		99,
		94,
		88,
		82,
		89,
		88,
		96,
		104,
		130,
		144,
		133,
		129,
		128,
		136,
		85,
		78,
		90,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		76,
		84,
		84,
		87,
		85,
		80,
		91,
		83,
		87,
		104,
		-1,
		164,
		-1,
		116,
		92,
		106,
		121,
		129,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		120,
		88,
		93,
		88,
		86,
		97,
		86,
		89,
		103,
		98,
		-1,
		-1,
		104,
		107,
		-1,
		-1,
		129,
		148,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		102,
		91,
		99,
		94,
		90,
		96,
		99,
		88,
		92,
		104,
		-1,
		-1,
		111,
		112,
		117,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		115,
		78,
		95,
		109,
		114,
		112,
		103,
		94,
		101,
		99,
		95,
		106,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		97,
		-1,
		72,
		75,
		100,
		108,
		125,
		119,
		97,
		112,
		102,
		93,
		102,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		94,
		76,
		-1,
		104,
		94,
		142,
		117,
		112,
		99,
		106,
		106,
		99,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		84,
		84,
		75,
		83,
		132,
		128,
		119,
		119,
		107,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		79,
		87,
		85,
		82,
		94,
		90,
		110,
		106,
		138,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		113,
		97,
		95,
		100,
		105,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		106,
		102,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		195,
		184,
		195,
		203,
		176,
		183,
		-1,
		202,
		206,
		172,
		166,
		205,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		195,
		194,
		162,
		160,
		169,
		174,
		181,
		-1,
		180,
		-1,
		216,
		195,
		206,
		211,
		155,
		152,
		172,
		191,
		173,
		165,
		231,
		185,
		156,
		150,
		168,
		158,
		167,
		159,
		-1,
		156,
		146,
		168,
		147,
		158,
		150,
		-1,
		-1,
		150,
		151,
		157,
		143,
		149,
		145,
		-1,
		155,
		139,
		-1,
		-1,
		140,
		141,
		125,
		128,
		136,
		134,
		147,
		139,
		134,
		-1,
		-1,
		131,
		127,
		134,
		121,
		117,
		134,
		147,
		129,
		143,
		142,
		-1,
		137,
		155,
		160,
		128,
		126,
		110,
		108,
		126,
		128,
		134,
		134,
		-1,
		146,
		147,
		142,
		150,
		150,
		126,
		113,
		113,
		123,
		116,
		135,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		146,
		129,
		146,
		138,
		128,
		143,
		136,
		116,
		113,
		111,
		108,
		124,
		122,
		132,
		-1,
		-1,
		237,
		206,
		237,
		195,
		176,
		-1,
		142,
		122,
		128,
		132,
		126,
		119,
		133,
		129,
		-1,
		102,
		101,
		129,
		115,
		126,
		197,
		-1,
		-1,
		195,
		187,
		172,
		175,
		152,
		148,
		137,
		136,
		128,
		114,
		110,
		116,
		119,
		119,
		125,
		96,
		106,
		110,
		108,
		133,
		-1,
		-1,
		168,
		-1,
		-1,
		194,
		177,
		-1,
		160,
		167,
		158,
		164,
		150,
		171,
		147,
		138,
		130,
		124,
		112,
		114,
		111,
		124,
		112,
		93,
		118,
		122,
		103,
		124,
		119,
		-1,
		167,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		153,
		156,
		162,
		186,
		187,
		-1,
		159,
		147,
		148,
		133,
		130,
		117,
		105,
		118,
		103,
		110,
		109,
		97,
		95,
		125,
		100,
		122,
		119,
		138,
		143,
		137,
		146,
		-1,
		202,
		198,
		194,
		201,
		150,
		-1,
		-1,
		190,
		-1,
		195,
		196,
		171,
		144,
		147,
		134,
		125,
		112,
		101,
		112,
		101,
		98,
		106,
		89,
		104,
		95,
		94,
		112,
		122,
		130,
		134,
		140,
		-1,
		252,
		-1,
		194,
		178,
		180,
		152,
		173,
		-1,
		210,
		196,
		188,
		173,
		171,
		-1,
		143,
		140,
		130,
		108,
		93,
		110,
		102,
		100,
		102,
		84,
		98,
		89,
		107,
		114,
		112,
		116,
		136,
		148,
		212,
		202,
		-1,
		184,
		189,
		148,
		156,
		175,
		213,
		177,
		-1,
		172,
		-1,
		145,
		158,
		-1,
		114,
		110,
		92,
		93,
		88,
		103,
		95,
		80,
		77,
		95,
		98,
		105,
		109,
		125,
		-1,
		-1,
		197,
		201,
		190,
		141,
		160,
		184,
		221,
		170,
		159,
		158,
		-1,
		149,
		128,
		125,
		113,
		100,
		85,
		86,
		94,
		106,
		85,
		79,
		76,
		96,
		122,
		100,
		111,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		167,
		138,
		162,
		204,
		188,
		181,
		169,
		134,
		134,
		128,
		-1,
		124,
		103,
		94,
		83,
		81,
		94,
		86,
		94,
		74,
		72,
		91,
		103,
		94,
		102,
		-1,
		-1,
		-1,
		197,
		186,
		187,
		133,
		156,
		193,
		167,
		153,
		158,
		133,
		126,
		120,
		137,
		120,
		101,
		90,
		82,
		71,
		82,
		90,
		88,
		70,
		79,
		85,
		109,
		90,
		96,
		-1,
		-1,
		204,
		194,
		178,
		180,
		177,
		147,
		154,
		186,
		158,
		171,
		-1,
		125,
		-1,
		114,
		110,
		95,
		90,
		87,
		74,
		73,
		87,
		87,
		77,
		72,
		79,
		114,
		114,
		80,
		100,
		103,
		-1,
		-1,
		-1,
		197,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		119,
		113,
		110,
		97,
		93,
		78,
		82,
		84,
		87,
		75,
		81,
		82,
		64,
		88,
		-1,
		88,
		82,
		90,
		80,
		68,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		90,
		85,
		81,
		83,
		80,
		69,
		82,
		75,
		69,
		63,
		76,
		80,
		81,
		70,
		66,
		63,
		77,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		101,
		99,
		109,
		93,
		95,
		91,
		83,
		78,
		64,
		57,
		68,
		53,
		71,
		77,
		68,
		63,
		62,
		73,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		111,
		102,
		100,
		101,
		71,
		76,
		78,
		66,
		69,
		58,
		61,
		53,
		75,
		72,
		56,
		58,
		67,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		169,
		-1,
		113,
		125,
		116,
		114,
		90,
		65,
		72,
		90,
		63,
		58,
		63,
		52,
		52,
		47,
		66,
		52,
		50,
		65,
		81,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		147,
		135,
		122,
		104,
		144,
		-1,
		64,
		60,
		67,
		-1,
		83,
		-1,
		55,
		58,
		49,
		44,
		41,
		52,
		50,
		59,
		60,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		134,
		128,
		128,
		97,
		94,
		80,
		60,
		52,
		67,
		66,
		53,
		52,
		40,
		40,
		43,
		37,
		50,
		60,
		66,
		58,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		195,
		151,
		137,
		-1,
		89,
		80,
		68,
		58,
		48,
		53,
		54,
		44,
		42,
		38,
		47,
		46,
		39,
		38,
		59,
		52,
		74,
		-1,
		-1,
		154,
		159,
		147,
		133,
		148,
		-1,
		-1,
		-1,
		141,
		142,
		108,
		87,
		69,
		-1,
		-1,
		52,
		45,
		39,
		42,
		30,
		50,
		57,
		45,
		32,
		47,
		57,
		65,
		64,
		-1,
		157,
		144,
		-1,
		-1,
		147,
		137,
		-1,
		-1,
		-1,
		-1,
		120,
		65,
		54,
		49,
		53,
		51,
		-1,
		25,
		36,
		29,
		48,
		55,
		47,
		32,
		26,
		37,
		52,
		69,
		-1,
		-1,
		161,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		77,
		71,
		42,
		35,
		39,
		-1,
		27,
		29,
		26,
		38,
		43,
		47,
		38,
		20,
		34,
		37,
		50,
		64,
		68,
		184,
		-1,
		114,
		-1,
		-1,
		-1,
		95,
		110,
		81,
		58,
		31,
		26,
		19,
		13,
		18,
		29,
		38,
		49,
		14,
		18,
		33,
		43,
		42,
		59,
		69,
		-1,
		-1,
		112,
		108,
		121,
		103,
		107,
		108,
		-1,
		-1,
		35,
		26,
		17,
		9,
		22,
		25,
		10,
		12,
		30,
		49,
		37,
		52,
		67,
		65,
		-1,
		-1,
		-1,
		124,
		-1,
		126,
		-1,
		-1,
		114,
		106,
		53,
		35,
		31,
		29,
		18,
		12,
		0,
		5,
		30,
		27,
		36,
		39,
		45,
		68,
		57,
		96,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		103,
		95,
		90,
		96,
		98,
		89,
		68,
		65,
		-1,
		35,
		41,
		6,
		13,
		5,
		20,
		25,
		31,
		35,
		42,
		58,
		57,
		52,
		88,
		79,
		85,
		-1,
		-1,
		189,
		178,
		167,
		173,
		-1,
		96,
		92,
		82,
		72,
		75,
		-1,
		-1,
		69,
		66,
		38,
		15,
		21,
		14,
		9,
		47,
		23,
		31,
		35,
		39,
		45,
		50,
		55,
		61,
		76,
		91,
		-1,
		143,
		180,
		173,
		141,
		149,
		180,
		-1,
		86,
		78,
		89,
		64,
		66,
		-1,
		-1,
		42,
		33,
		34,
		22,
		19,
		32,
		31,
		43,
		45,
		50,
		38,
		37,
		55,
		59,
		68,
		75,
		65,
		78,
		82,
		-1,
		136,
		156,
		135,
		138,
		162,
		176,
		-1,
		83,
		-1,
		-1,
		95,
		67,
		51,
		41,
		38,
		81,
		36,
		31,
		33,
		35,
		41,
		32,
		55,
		46,
		46,
		49,
		64,
		69,
		61,
		75,
		75,
		76,
		-1,
		125,
		136,
		129,
		-1,
		-1,
		-1,
		-1,
		84,
		-1,
		-1,
		111,
		-1,
		78,
		-1,
		61,
		65,
		44,
		47,
		58,
		45,
		45,
		53,
		61,
		44,
		54,
		50,
		51,
		60,
		71,
		83,
		82,
		83,
		150,
		106,
		109,
		120,
		131,
		146,
		150,
		-1,
		95,
		134,
		149,
		-1,
		120,
		-1,
		-1,
		-1,
		75,
		57,
		49,
		65,
		57,
		57,
		39,
		43,
		49,
		56,
		66,
		68,
		60,
		64,
		77,
		88,
		91,
		146,
		137,
		150,
		95,
		95,
		116,
		125,
		146,
		110,
		101,
		128,
		149,
		145,
		140,
		127,
		-1,
		-1,
		98,
		67,
		-1,
		-1,
		64,
		60,
		43,
		45,
		49,
		59,
		74,
		77,
		67,
		65,
		59,
		91,
		-1,
		139,
		138,
		127,
		124,
		100,
		91,
		86,
		113,
		-1,
		-1,
		108,
		129,
		119,
		123,
		139,
		164,
		-1,
		127,
		-1,
		-1,
		117,
		-1,
		-1,
		102,
		65,
		54,
		45,
		51,
		57,
		68,
		85,
		73,
		74,
		64,
		74,
		87,
		123,
		120,
		108,
		106,
		129,
		94,
		82,
		-1,
		95,
		93,
		99,
		106,
		123,
		153,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		50,
		55,
		80,
		87,
		82,
		76,
		70,
		77,
		76,
		84,
		92,
		132,
		146,
		135,
		131,
		130,
		138,
		87,
		80,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		64,
		72,
		72,
		75,
		73,
		68,
		79,
		71,
		75,
		92,
		-1,
		166,
		-1,
		118,
		94,
		108,
		123,
		131,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		108,
		76,
		81,
		76,
		74,
		85,
		74,
		77,
		91,
		86,
		-1,
		-1,
		106,
		109,
		-1,
		-1,
		131,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		65,
		90,
		79,
		87,
		82,
		78,
		84,
		87,
		76,
		80,
		92,
		-1,
		-1,
		113,
		114,
		119,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		103,
		66,
		83,
		97,
		102,
		100,
		91,
		82,
		89,
		87,
		83,
		94,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		85,
		-1,
		60,
		63,
		88,
		96,
		113,
		107,
		85,
		100,
		90,
		81,
		90,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		82,
		64,
		-1,
		92,
		82,
		130,
		105,
		100,
		87,
		94,
		94,
		87,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		72,
		63,
		71,
		120,
		116,
		107,
		107,
		95,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		75,
		73,
		70,
		82,
		78,
		98,
		94,
		126,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		101,
		85,
		83,
		88,
		93,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		94,
		90,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		197,
		201,
		167,
		161,
		200,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		190,
		189,
		157,
		155,
		164,
		169,
		176,
		-1,
		175,
		-1,
		211,
		190,
		201,
		206,
		150,
		147,
		167,
		186,
		168,
		160,
		226,
		180,
		151,
		145,
		163,
		153,
		162,
		154,
		-1,
		151,
		141,
		163,
		142,
		153,
		145,
		-1,
		-1,
		145,
		146,
		152,
		138,
		144,
		140,
		-1,
		150,
		134,
		-1,
		-1,
		135,
		136,
		120,
		123,
		131,
		129,
		142,
		134,
		129,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		124,
		138,
		137,
		-1,
		132,
		150,
		155,
		123,
		121,
		105,
		103,
		121,
		123,
		129,
		129,
		-1,
		141,
		142,
		137,
		145,
		145,
		121,
		108,
		108,
		118,
		111,
		130,
		118,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		124,
		141,
		133,
		123,
		138,
		131,
		111,
		108,
		106,
		103,
		119,
		117,
		127,
		-1,
		-1,
		232,
		201,
		232,
		190,
		171,
		-1,
		137,
		117,
		123,
		127,
		121,
		114,
		128,
		124,
		-1,
		97,
		96,
		124,
		110,
		121,
		192,
		-1,
		-1,
		190,
		182,
		167,
		170,
		147,
		143,
		132,
		131,
		123,
		109,
		105,
		111,
		114,
		114,
		120,
		91,
		101,
		105,
		103,
		128,
		-1,
		-1,
		163,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		153,
		159,
		145,
		166,
		142,
		133,
		125,
		119,
		107,
		109,
		106,
		119,
		107,
		88,
		113,
		117,
		98,
		119,
		114,
		-1,
		162,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		182,
		-1,
		154,
		142,
		143,
		128,
		125,
		112,
		100,
		113,
		98,
		105,
		104,
		92,
		90,
		120,
		95,
		117,
		114,
		133,
		138,
		132,
		141,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		190,
		191,
		166,
		139,
		142,
		129,
		120,
		107,
		96,
		107,
		96,
		93,
		101,
		84,
		99,
		90,
		89,
		107,
		117,
		125,
		129,
		135,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		191,
		183,
		168,
		166,
		-1,
		138,
		135,
		125,
		103,
		88,
		105,
		97,
		95,
		97,
		79,
		93,
		84,
		102,
		109,
		107,
		111,
		131,
		143,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		140,
		153,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		90,
		75,
		72,
		90,
		93,
		100,
		104,
		120,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		123,
		120,
		108,
		95,
		80,
		81,
		89,
		101,
		80,
		74,
		71,
		91,
		117,
		95,
		106,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		119,
		98,
		89,
		78,
		76,
		89,
		81,
		89,
		69,
		67,
		86,
		98,
		89,
		97,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		132,
		115,
		96,
		85,
		77,
		66,
		77,
		85,
		83,
		65,
		74,
		80,
		104,
		85,
		91,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		105,
		90,
		85,
		82,
		69,
		68,
		82,
		82,
		72,
		67,
		74,
		109,
		109,
		75,
		95,
		98,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		92,
		88,
		73,
		77,
		79,
		82,
		70,
		76,
		77,
		59,
		83,
		-1,
		83,
		77,
		85,
		75,
		63,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		85,
		80,
		79,
		78,
		75,
		64,
		77,
		70,
		64,
		58,
		71,
		75,
		76,
		65,
		61,
		58,
		72,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		107,
		91,
		90,
		87,
		78,
		85,
		59,
		52,
		63,
		48,
		66,
		72,
		63,
		58,
		57,
		68,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		97,
		107,
		108,
		78,
		83,
		85,
		73,
		64,
		53,
		56,
		48,
		70,
		67,
		51,
		53,
		62,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		111,
		109,
		97,
		72,
		79,
		96,
		70,
		65,
		58,
		47,
		47,
		42,
		61,
		47,
		45,
		60,
		76,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		71,
		67,
		74,
		-1,
		90,
		-1,
		62,
		63,
		54,
		39,
		36,
		47,
		45,
		54,
		55,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		104,
		101,
		87,
		67,
		59,
		74,
		73,
		60,
		59,
		47,
		45,
		42,
		32,
		45,
		55,
		61,
		53,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		96,
		87,
		75,
		65,
		55,
		60,
		61,
		51,
		49,
		45,
		52,
		41,
		34,
		33,
		54,
		47,
		69,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		149,
		115,
		94,
		76,
		-1,
		-1,
		59,
		52,
		46,
		49,
		37,
		57,
		58,
		40,
		27,
		42,
		52,
		60,
		59,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		127,
		72,
		61,
		56,
		60,
		58,
		-1,
		32,
		43,
		36,
		55,
		62,
		42,
		27,
		21,
		32,
		47,
		64,
		-1,
		-1,
		164,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		84,
		78,
		49,
		42,
		46,
		-1,
		34,
		36,
		33,
		45,
		45,
		42,
		33,
		15,
		29,
		32,
		45,
		59,
		63,
		187,
		-1,
		121,
		-1,
		-1,
		-1,
		102,
		117,
		88,
		65,
		38,
		33,
		26,
		20,
		25,
		36,
		45,
		56,
		9,
		13,
		28,
		38,
		37,
		54,
		64,
		-1,
		-1,
		119,
		115,
		128,
		110,
		114,
		115,
		-1,
		-1,
		42,
		33,
		24,
		16,
		29,
		32,
		5,
		7,
		25,
		44,
		32,
		47,
		62,
		69,
		-1,
		-1,
		-1,
		131,
		-1,
		133,
		-1,
		-1,
		121,
		113,
		60,
		42,
		38,
		36,
		25,
		19,
		7,
		0,
		25,
		34,
		42,
		34,
		52,
		72,
		64,
		101,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		110,
		102,
		97,
		103,
		105,
		96,
		75,
		72,
		-1,
		42,
		48,
		13,
		20,
		12,
		27,
		32,
		38,
		39,
		49,
		65,
		64,
		59,
		93,
		86,
		92,
		-1,
		-1,
		196,
		185,
		174,
		180,
		-1,
		103,
		99,
		89,
		79,
		82,
		-1,
		-1,
		76,
		73,
		45,
		22,
		28,
		21,
		16,
		54,
		30,
		38,
		42,
		46,
		52,
		57,
		62,
		68,
		83,
		98,
		-1,
		150,
		187,
		180,
		148,
		156,
		187,
		-1,
		93,
		85,
		96,
		71,
		73,
		-1,
		-1,
		49,
		40,
		41,
		29,
		26,
		39,
		38,
		50,
		52,
		57,
		45,
		44,
		62,
		66,
		75,
		82,
		72,
		85,
		89,
		-1,
		143,
		163,
		142,
		145,
		169,
		183,
		-1,
		90,
		-1,
		-1,
		102,
		74,
		58,
		48,
		45,
		88,
		43,
		38,
		40,
		42,
		48,
		39,
		62,
		53,
		53,
		56,
		71,
		76,
		68,
		82,
		82,
		83,
		-1,
		132,
		143,
		136,
		-1,
		-1,
		-1,
		-1,
		91,
		-1,
		-1,
		118,
		-1,
		85,
		-1,
		68,
		72,
		51,
		54,
		65,
		52,
		52,
		60,
		68,
		51,
		61,
		57,
		58,
		67,
		78,
		90,
		89,
		90,
		157,
		113,
		116,
		127,
		138,
		153,
		157,
		-1,
		102,
		141,
		156,
		-1,
		127,
		-1,
		-1,
		-1,
		82,
		64,
		56,
		72,
		64,
		64,
		46,
		50,
		56,
		63,
		73,
		75,
		67,
		71,
		84,
		95,
		98,
		153,
		144,
		157,
		102,
		102,
		123,
		132,
		153,
		117,
		108,
		135,
		156,
		152,
		147,
		134,
		-1,
		-1,
		105,
		74,
		-1,
		-1,
		71,
		67,
		50,
		52,
		56,
		66,
		81,
		84,
		74,
		72,
		66,
		98,
		-1,
		146,
		145,
		134,
		131,
		107,
		98,
		93,
		120,
		-1,
		-1,
		115,
		136,
		126,
		130,
		146,
		171,
		-1,
		134,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		72,
		61,
		52,
		58,
		64,
		75,
		92,
		80,
		81,
		71,
		81,
		94,
		130,
		127,
		115,
		113,
		136,
		101,
		89,
		-1,
		102,
		100,
		106,
		113,
		130,
		160,
		-1,
		-1,
		150,
		130,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		57,
		62,
		87,
		94,
		89,
		83,
		77,
		84,
		83,
		91,
		99,
		139,
		153,
		142,
		138,
		137,
		145,
		94,
		87,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		140,
		136,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		71,
		79,
		79,
		82,
		80,
		75,
		86,
		78,
		82,
		99,
		-1,
		173,
		-1,
		125,
		101,
		115,
		130,
		138,
		-1,
		-1,
		-1,
		157,
		143,
		136,
		124,
		122,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		115,
		83,
		88,
		83,
		81,
		92,
		81,
		84,
		98,
		93,
		-1,
		-1,
		113,
		116,
		-1,
		-1,
		138,
		149,
		-1,
		148,
		137,
		122,
		114,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		97,
		86,
		94,
		89,
		85,
		91,
		94,
		83,
		87,
		99,
		-1,
		-1,
		120,
		121,
		126,
		-1,
		132,
		-1,
		150,
		-1,
		117,
		123,
		111,
		-1,
		-1,
		-1,
		110,
		73,
		90,
		104,
		109,
		107,
		98,
		89,
		96,
		94,
		90,
		101,
		-1,
		-1,
		-1,
		150,
		124,
		157,
		148,
		131,
		111,
		103,
		122,
		-1,
		92,
		-1,
		67,
		70,
		95,
		103,
		120,
		114,
		92,
		107,
		97,
		88,
		97,
		156,
		-1,
		126,
		159,
		123,
		117,
		93,
		97,
		113,
		-1,
		89,
		71,
		-1,
		99,
		89,
		137,
		112,
		107,
		94,
		101,
		101,
		94,
		-1,
		-1,
		-1,
		128,
		127,
		119,
		113,
		113,
		98,
		89,
		-1,
		101,
		83,
		62,
		79,
		79,
		70,
		78,
		127,
		123,
		114,
		114,
		102,
		-1,
		229,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		122,
		117,
		90,
		78,
		84,
		80,
		66,
		72,
		74,
		82,
		80,
		77,
		89,
		85,
		105,
		101,
		133,
		-1,
		224,
		-1,
		158,
		-1,
		-1,
		140,
		120,
		112,
		101,
		90,
		88,
		79,
		70,
		92,
		108,
		92,
		90,
		95,
		100,
		-1,
		213,
		212,
		-1,
		159,
		151,
		137,
		-1,
		130,
		-1,
		136,
		97,
		-1,
		99,
		79,
		-1,
		101,
		97,
		-1,
		-1,
		200,
		175,
		-1,
		-1,
		-1,
		160,
		140,
		131,
		115,
		-1,
		90,
		90,
		-1,
		-1,
		-1,
		185,
		184,
		-1,
		153,
		156,
		-1,
		146,
		137,
		145,
		92,
		96,
		-1,
		-1,
		-1,
		194,
		175,
		169,
		168,
		166,
		161,
		158,
		144,
		128,
		106,
		95,
		116,
		-1,
		-1,
		-1,
		166,
		158,
		151,
		-1,
		-1,
		153,
		136,
		117,
		115,
		-1,
		-1,
		-1,
		188,
		169,
		-1,
		-1,
		143,
		-1,
		-1,
		149,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		177,
		-1,
		-1,
		-1,
		139,
		135,
		136,
		-1,
		-1,
		-1,
		-1,
		199,
		200,
		223,
		187,
		-1,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		202,
		200,
		-1,
		-1,
		-1,
		159,
		143,
		-1,
		129,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		164,
		-1,
		164,
		139,
		146,
		-1,
		-1,
		-1,
		-1,
		177,
		169,
		177,
		-1,
		149,
		151,
		-1,
		199,
		-1,
		-1,
		192,
		183,
		-1,
		-1,
		154,
		161,
		183,
		186,
		222,
		-1,
		173
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		207,
		211,
		177,
		171,
		210,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		200,
		199,
		167,
		165,
		174,
		179,
		186,
		-1,
		185,
		-1,
		221,
		200,
		211,
		216,
		160,
		157,
		177,
		196,
		178,
		170,
		236,
		190,
		161,
		155,
		173,
		163,
		172,
		164,
		-1,
		161,
		151,
		173,
		152,
		163,
		155,
		-1,
		-1,
		155,
		156,
		162,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		145,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		142,
		160,
		165,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		139,
		-1,
		151,
		152,
		147,
		155,
		155,
		131,
		118,
		118,
		128,
		121,
		140,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		121,
		118,
		116,
		113,
		129,
		127,
		137,
		-1,
		-1,
		242,
		211,
		242,
		200,
		181,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		107,
		106,
		134,
		120,
		131,
		202,
		-1,
		-1,
		200,
		192,
		177,
		180,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		101,
		111,
		115,
		113,
		138,
		-1,
		-1,
		173,
		-1,
		-1,
		199,
		182,
		-1,
		165,
		172,
		163,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		98,
		123,
		127,
		108,
		129,
		124,
		-1,
		172,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		158,
		161,
		167,
		191,
		192,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		102,
		100,
		130,
		105,
		127,
		124,
		143,
		148,
		142,
		151,
		-1,
		207,
		203,
		199,
		206,
		155,
		-1,
		-1,
		195,
		-1,
		200,
		201,
		176,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		94,
		109,
		100,
		99,
		117,
		127,
		135,
		139,
		145,
		-1,
		257,
		-1,
		199,
		183,
		185,
		157,
		178,
		-1,
		215,
		201,
		193,
		178,
		176,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		107,
		89,
		103,
		94,
		112,
		119,
		117,
		121,
		141,
		153,
		217,
		207,
		-1,
		189,
		194,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		100,
		85,
		82,
		100,
		103,
		110,
		114,
		130,
		-1,
		-1,
		202,
		206,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		111,
		90,
		84,
		81,
		101,
		127,
		105,
		116,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		129,
		108,
		99,
		88,
		86,
		99,
		91,
		99,
		79,
		77,
		96,
		108,
		99,
		107,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		142,
		125,
		106,
		95,
		87,
		76,
		87,
		95,
		93,
		75,
		84,
		90,
		114,
		95,
		101,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		115,
		100,
		95,
		92,
		79,
		78,
		92,
		92,
		82,
		77,
		84,
		119,
		119,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		102,
		98,
		83,
		87,
		89,
		92,
		80,
		86,
		87,
		69,
		93,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		95,
		90,
		89,
		88,
		85,
		74,
		87,
		80,
		74,
		68,
		81,
		85,
		86,
		75,
		71,
		68,
		82,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		117,
		101,
		100,
		97,
		88,
		96,
		69,
		62,
		73,
		58,
		76,
		82,
		73,
		68,
		67,
		78,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		107,
		123,
		124,
		94,
		97,
		95,
		86,
		74,
		63,
		66,
		58,
		80,
		77,
		61,
		63,
		72,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		121,
		119,
		113,
		88,
		95,
		106,
		83,
		78,
		68,
		57,
		57,
		52,
		71,
		57,
		55,
		70,
		86,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		87,
		83,
		90,
		-1,
		103,
		-1,
		76,
		73,
		64,
		49,
		46,
		57,
		55,
		64,
		65,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		120,
		117,
		103,
		83,
		75,
		90,
		89,
		76,
		75,
		62,
		55,
		52,
		42,
		55,
		65,
		71,
		63,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		112,
		103,
		91,
		81,
		71,
		76,
		77,
		67,
		65,
		60,
		62,
		51,
		44,
		43,
		64,
		57,
		79,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		165,
		131,
		110,
		92,
		-1,
		-1,
		75,
		68,
		62,
		65,
		53,
		73,
		68,
		50,
		37,
		52,
		62,
		70,
		69,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		143,
		88,
		77,
		72,
		76,
		74,
		-1,
		48,
		59,
		52,
		71,
		78,
		52,
		37,
		31,
		42,
		57,
		74,
		-1,
		-1,
		174,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		65,
		58,
		62,
		-1,
		50,
		52,
		49,
		61,
		55,
		52,
		43,
		25,
		39,
		42,
		55,
		69,
		73,
		197,
		-1,
		137,
		-1,
		-1,
		-1,
		118,
		133,
		104,
		81,
		54,
		49,
		42,
		36,
		41,
		52,
		61,
		72,
		19,
		23,
		38,
		47,
		47,
		64,
		74,
		-1,
		-1,
		135,
		131,
		144,
		126,
		130,
		131,
		-1,
		-1,
		58,
		49,
		40,
		32,
		45,
		48,
		13,
		17,
		25,
		47,
		42,
		56,
		70,
		75,
		-1,
		-1,
		-1,
		147,
		-1,
		149,
		-1,
		-1,
		137,
		129,
		76,
		58,
		54,
		52,
		41,
		35,
		23,
		16,
		0,
		10,
		19,
		40,
		55,
		78,
		67,
		106,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		126,
		118,
		113,
		119,
		121,
		112,
		91,
		88,
		-1,
		58,
		64,
		29,
		36,
		28,
		11,
		8,
		14,
		38,
		52,
		68,
		67,
		62,
		98,
		89,
		95,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		119,
		115,
		105,
		95,
		98,
		-1,
		-1,
		92,
		89,
		61,
		38,
		36,
		29,
		24,
		42,
		38,
		41,
		45,
		49,
		55,
		60,
		65,
		71,
		86,
		101,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		109,
		101,
		112,
		87,
		89,
		-1,
		-1,
		65,
		56,
		57,
		45,
		42,
		48,
		45,
		58,
		55,
		56,
		48,
		47,
		65,
		69,
		78,
		85,
		75,
		88,
		92,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		106,
		-1,
		-1,
		118,
		90,
		74,
		64,
		61,
		104,
		59,
		54,
		56,
		58,
		56,
		47,
		57,
		56,
		56,
		59,
		74,
		79,
		71,
		85,
		85,
		86,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		134,
		-1,
		101,
		-1,
		84,
		88,
		67,
		70,
		81,
		68,
		60,
		63,
		76,
		54,
		64,
		60,
		61,
		70,
		81,
		93,
		92,
		93,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		118,
		157,
		172,
		-1,
		143,
		-1,
		-1,
		-1,
		98,
		80,
		72,
		88,
		80,
		80,
		54,
		58,
		59,
		66,
		76,
		78,
		70,
		74,
		87,
		98,
		101,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		133,
		124,
		151,
		172,
		168,
		163,
		150,
		-1,
		-1,
		121,
		90,
		-1,
		-1,
		87,
		75,
		58,
		60,
		64,
		69,
		84,
		87,
		77,
		75,
		69,
		101,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		152,
		142,
		146,
		162,
		187,
		-1,
		142,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		80,
		69,
		60,
		66,
		72,
		83,
		95,
		83,
		84,
		74,
		84,
		97,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		118,
		116,
		122,
		129,
		146,
		176,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		65,
		70,
		95,
		102,
		92,
		86,
		80,
		87,
		86,
		94,
		102,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		79,
		87,
		87,
		90,
		83,
		78,
		89,
		81,
		85,
		102,
		-1,
		189,
		-1,
		141,
		117,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		123,
		91,
		96,
		91,
		84,
		95,
		84,
		87,
		101,
		96,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		154,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		105,
		94,
		102,
		97,
		88,
		94,
		97,
		86,
		90,
		102,
		-1,
		-1,
		136,
		137,
		142,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		118,
		81,
		98,
		112,
		117,
		115,
		106,
		92,
		99,
		97,
		93,
		104,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		78,
		103,
		111,
		128,
		122,
		95,
		110,
		100,
		91,
		100,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		107,
		97,
		144,
		120,
		110,
		97,
		104,
		104,
		97,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		87,
		87,
		78,
		86,
		134,
		130,
		117,
		117,
		109,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		82,
		90,
		88,
		85,
		97,
		93,
		113,
		109,
		141,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		116,
		100,
		98,
		103,
		108,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		109,
		105,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		147,
		165,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		156,
		157,
		152,
		160,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		114,
		113,
		141,
		127,
		138,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		117,
		96,
		91,
		88,
		108,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		101,
		106,
		86,
		84,
		103,
		115,
		106,
		118,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		97,
		105,
		100,
		82,
		91,
		97,
		121,
		106,
		112,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		90,
		88,
		97,
		99,
		89,
		84,
		91,
		126,
		126,
		96,
		116,
		119,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		94,
		98,
		95,
		102,
		91,
		93,
		94,
		76,
		104,
		-1,
		104,
		98,
		106,
		96,
		84,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		106,
		101,
		99,
		99,
		96,
		85,
		98,
		91,
		81,
		79,
		92,
		96,
		97,
		86,
		82,
		79,
		93,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		111,
		108,
		99,
		106,
		80,
		73,
		84,
		69,
		87,
		93,
		84,
		79,
		78,
		89,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		118,
		128,
		129,
		99,
		104,
		106,
		94,
		85,
		74,
		77,
		69,
		91,
		88,
		72,
		74,
		75,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		132,
		130,
		118,
		93,
		100,
		117,
		91,
		86,
		79,
		68,
		68,
		63,
		82,
		68,
		66,
		73,
		89,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		92,
		88,
		95,
		-1,
		111,
		-1,
		83,
		84,
		75,
		60,
		57,
		68,
		66,
		75,
		68,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		125,
		122,
		108,
		88,
		80,
		95,
		94,
		81,
		80,
		68,
		66,
		63,
		53,
		66,
		76,
		82,
		66,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		117,
		108,
		96,
		86,
		76,
		81,
		82,
		72,
		70,
		66,
		73,
		62,
		55,
		54,
		68,
		60,
		82,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		170,
		136,
		115,
		97,
		-1,
		-1,
		80,
		73,
		67,
		70,
		58,
		78,
		79,
		61,
		48,
		63,
		65,
		73,
		64,
		-1,
		169,
		156,
		-1,
		-1,
		166,
		156,
		-1,
		-1,
		-1,
		-1,
		148,
		93,
		82,
		77,
		81,
		79,
		-1,
		53,
		64,
		57,
		76,
		83,
		63,
		48,
		42,
		48,
		60,
		69,
		-1,
		-1,
		180,
		-1,
		142,
		-1,
		-1,
		-1,
		-1,
		105,
		99,
		70,
		63,
		67,
		-1,
		55,
		57,
		54,
		66,
		66,
		63,
		54,
		36,
		39,
		45,
		49,
		63,
		67,
		203,
		-1,
		133,
		-1,
		-1,
		-1,
		123,
		138,
		109,
		86,
		59,
		54,
		47,
		41,
		46,
		57,
		66,
		77,
		30,
		34,
		36,
		37,
		41,
		58,
		68,
		-1,
		-1,
		131,
		127,
		149,
		131,
		135,
		136,
		-1,
		-1,
		63,
		54,
		45,
		37,
		50,
		53,
		24,
		28,
		27,
		37,
		34,
		46,
		60,
		65,
		-1,
		-1,
		-1,
		143,
		-1,
		145,
		-1,
		-1,
		133,
		134,
		81,
		63,
		59,
		57,
		46,
		40,
		28,
		27,
		11,
		0,
		9,
		30,
		45,
		68,
		57,
		96,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		122,
		114,
		109,
		115,
		117,
		108,
		96,
		93,
		-1,
		63,
		69,
		34,
		41,
		24,
		7,
		4,
		4,
		28,
		42,
		58,
		57,
		52,
		88,
		79,
		85,
		-1,
		-1,
		208,
		197,
		186,
		192,
		-1,
		115,
		111,
		101,
		91,
		94,
		-1,
		-1,
		88,
		85,
		65,
		34,
		32,
		25,
		20,
		43,
		33,
		31,
		35,
		39,
		45,
		50,
		55,
		61,
		76,
		91,
		-1,
		162,
		199,
		192,
		160,
		168,
		199,
		-1,
		105,
		97,
		108,
		83,
		85,
		-1,
		-1,
		61,
		52,
		53,
		41,
		38,
		44,
		43,
		53,
		45,
		46,
		38,
		37,
		55,
		59,
		68,
		75,
		65,
		78,
		82,
		-1,
		155,
		175,
		154,
		157,
		181,
		195,
		-1,
		102,
		-1,
		-1,
		114,
		86,
		70,
		60,
		57,
		100,
		55,
		50,
		52,
		54,
		51,
		42,
		47,
		46,
		46,
		49,
		64,
		69,
		61,
		75,
		75,
		76,
		-1,
		144,
		155,
		148,
		-1,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		130,
		-1,
		97,
		-1,
		80,
		84,
		63,
		66,
		76,
		63,
		55,
		53,
		69,
		44,
		54,
		50,
		51,
		60,
		71,
		83,
		82,
		83,
		169,
		125,
		128,
		139,
		150,
		165,
		169,
		-1,
		114,
		153,
		168,
		-1,
		139,
		-1,
		-1,
		-1,
		94,
		76,
		68,
		84,
		75,
		75,
		49,
		53,
		49,
		56,
		66,
		68,
		60,
		64,
		77,
		88,
		91,
		165,
		156,
		169,
		114,
		114,
		135,
		144,
		165,
		129,
		120,
		147,
		168,
		164,
		159,
		146,
		-1,
		-1,
		117,
		86,
		-1,
		-1,
		82,
		70,
		53,
		55,
		56,
		59,
		74,
		77,
		67,
		65,
		59,
		91,
		-1,
		158,
		157,
		146,
		143,
		119,
		110,
		105,
		132,
		-1,
		-1,
		127,
		148,
		138,
		142,
		158,
		183,
		-1,
		137,
		-1,
		-1,
		127,
		-1,
		-1,
		112,
		75,
		64,
		55,
		61,
		64,
		75,
		85,
		73,
		74,
		64,
		74,
		87,
		142,
		139,
		127,
		125,
		148,
		113,
		101,
		-1,
		114,
		112,
		118,
		125,
		142,
		172,
		-1,
		-1,
		153,
		133,
		-1,
		-1,
		110,
		108,
		97,
		-1,
		87,
		60,
		65,
		90,
		93,
		82,
		76,
		70,
		77,
		76,
		84,
		92,
		151,
		165,
		154,
		150,
		149,
		157,
		106,
		99,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		143,
		139,
		-1,
		-1,
		105,
		98,
		86,
		74,
		64,
		74,
		82,
		82,
		80,
		73,
		68,
		79,
		71,
		75,
		92,
		-1,
		185,
		-1,
		137,
		113,
		127,
		142,
		150,
		-1,
		-1,
		-1,
		160,
		146,
		139,
		127,
		125,
		-1,
		139,
		123,
		104,
		-1,
		74,
		87,
		118,
		86,
		91,
		86,
		74,
		85,
		74,
		77,
		91,
		86,
		-1,
		-1,
		125,
		128,
		-1,
		-1,
		150,
		152,
		-1,
		151,
		140,
		125,
		117,
		-1,
		-1,
		111,
		107,
		-1,
		-1,
		75,
		100,
		89,
		97,
		92,
		78,
		84,
		87,
		76,
		80,
		92,
		-1,
		-1,
		132,
		133,
		138,
		-1,
		135,
		-1,
		153,
		-1,
		120,
		126,
		114,
		-1,
		-1,
		-1,
		113,
		76,
		93,
		107,
		107,
		105,
		96,
		82,
		89,
		87,
		83,
		94,
		-1,
		-1,
		-1,
		153,
		127,
		160,
		151,
		134,
		114,
		106,
		125,
		-1,
		95,
		-1,
		70,
		73,
		98,
		106,
		118,
		112,
		85,
		100,
		90,
		81,
		90,
		159,
		-1,
		129,
		162,
		126,
		120,
		96,
		100,
		116,
		-1,
		92,
		74,
		-1,
		102,
		92,
		134,
		115,
		100,
		87,
		94,
		94,
		87,
		-1,
		-1,
		-1,
		131,
		130,
		122,
		116,
		116,
		101,
		92,
		-1,
		104,
		86,
		65,
		82,
		82,
		73,
		81,
		124,
		120,
		107,
		107,
		99,
		-1,
		232,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		125,
		120,
		93,
		81,
		87,
		83,
		69,
		75,
		77,
		85,
		83,
		80,
		92,
		88,
		108,
		100,
		135,
		-1,
		227,
		-1,
		161,
		-1,
		-1,
		143,
		123,
		115,
		104,
		93,
		91,
		82,
		73,
		95,
		111,
		95,
		93,
		98,
		103,
		-1,
		216,
		215,
		-1,
		162,
		154,
		140,
		-1,
		133,
		-1,
		139,
		100,
		-1,
		102,
		82,
		-1,
		104,
		100,
		-1,
		-1,
		203,
		178,
		-1,
		-1,
		-1,
		163,
		143,
		134,
		118,
		-1,
		93,
		93,
		-1,
		-1,
		-1,
		188,
		187,
		-1,
		156,
		159,
		-1,
		149,
		140,
		148,
		95,
		99,
		-1,
		-1,
		-1,
		197,
		178,
		172,
		171,
		169,
		164,
		161,
		147,
		131,
		109,
		98,
		119,
		-1,
		-1,
		-1,
		169,
		161,
		154,
		-1,
		-1,
		156,
		139,
		120,
		118,
		-1,
		-1,
		-1,
		191,
		172,
		-1,
		-1,
		146,
		-1,
		-1,
		152,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		180,
		-1,
		-1,
		-1,
		142,
		138,
		139,
		-1,
		-1,
		-1,
		-1,
		202,
		203,
		226,
		190,
		-1,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		205,
		203,
		-1,
		-1,
		-1,
		162,
		146,
		-1,
		132,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		167,
		-1,
		167,
		142,
		149,
		-1,
		-1,
		-1,
		-1,
		180,
		172,
		180,
		-1,
		152,
		154,
		-1,
		202,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		157,
		164,
		186,
		189,
		225,
		-1,
		176
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		207,
		211,
		177,
		171,
		210,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		200,
		199,
		167,
		165,
		174,
		179,
		186,
		-1,
		185,
		-1,
		221,
		200,
		211,
		216,
		160,
		157,
		177,
		196,
		178,
		170,
		236,
		190,
		161,
		155,
		173,
		163,
		172,
		164,
		-1,
		161,
		151,
		173,
		152,
		163,
		155,
		-1,
		-1,
		155,
		156,
		162,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		145,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		140,
		158,
		165,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		139,
		-1,
		149,
		150,
		145,
		153,
		155,
		131,
		118,
		118,
		128,
		121,
		140,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		132,
		149,
		141,
		131,
		146,
		139,
		121,
		118,
		116,
		113,
		129,
		127,
		137,
		-1,
		-1,
		242,
		211,
		240,
		198,
		179,
		-1,
		145,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		107,
		106,
		134,
		120,
		131,
		202,
		-1,
		-1,
		200,
		192,
		175,
		178,
		155,
		151,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		101,
		111,
		115,
		113,
		138,
		-1,
		-1,
		173,
		-1,
		-1,
		199,
		182,
		-1,
		165,
		172,
		161,
		167,
		153,
		174,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		98,
		123,
		127,
		108,
		129,
		124,
		-1,
		172,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		158,
		161,
		167,
		191,
		190,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		102,
		100,
		130,
		105,
		127,
		124,
		143,
		148,
		142,
		151,
		-1,
		207,
		203,
		199,
		206,
		155,
		-1,
		-1,
		195,
		-1,
		198,
		199,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		94,
		109,
		100,
		99,
		117,
		127,
		135,
		139,
		145,
		-1,
		257,
		-1,
		199,
		183,
		185,
		157,
		178,
		-1,
		215,
		199,
		191,
		176,
		176,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		105,
		103,
		107,
		89,
		103,
		94,
		112,
		119,
		117,
		121,
		141,
		153,
		217,
		207,
		-1,
		189,
		194,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		100,
		85,
		82,
		100,
		103,
		110,
		114,
		130,
		-1,
		-1,
		202,
		206,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		110,
		89,
		84,
		81,
		101,
		127,
		105,
		117,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		93,
		99,
		79,
		77,
		96,
		108,
		99,
		109,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		140,
		123,
		104,
		93,
		85,
		74,
		89,
		97,
		93,
		75,
		84,
		90,
		114,
		97,
		103,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		81,
		80,
		90,
		92,
		82,
		77,
		84,
		119,
		119,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		85,
		89,
		88,
		94,
		82,
		86,
		87,
		69,
		95,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		97,
		92,
		91,
		90,
		87,
		76,
		89,
		82,
		74,
		70,
		83,
		87,
		88,
		77,
		73,
		70,
		84,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		119,
		103,
		102,
		99,
		90,
		98,
		71,
		64,
		75,
		60,
		78,
		84,
		75,
		70,
		69,
		80,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		109,
		126,
		127,
		105,
		99,
		97,
		88,
		76,
		65,
		68,
		60,
		82,
		79,
		63,
		65,
		66,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		123,
		121,
		116,
		101,
		108,
		108,
		85,
		80,
		70,
		59,
		59,
		54,
		73,
		59,
		57,
		64,
		80,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		100,
		96,
		103,
		-1,
		105,
		-1,
		78,
		75,
		66,
		51,
		48,
		59,
		57,
		66,
		59,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		116,
		96,
		88,
		103,
		100,
		89,
		86,
		64,
		57,
		54,
		44,
		57,
		67,
		73,
		57,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		125,
		116,
		104,
		94,
		84,
		89,
		90,
		80,
		76,
		62,
		64,
		53,
		46,
		45,
		59,
		51,
		73,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		174,
		144,
		123,
		105,
		-1,
		-1,
		88,
		81,
		75,
		78,
		66,
		75,
		70,
		52,
		39,
		54,
		56,
		64,
		55,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		156,
		101,
		90,
		85,
		89,
		87,
		-1,
		61,
		72,
		65,
		77,
		84,
		54,
		39,
		33,
		39,
		51,
		60,
		-1,
		-1,
		174,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		113,
		107,
		78,
		71,
		75,
		-1,
		63,
		65,
		62,
		74,
		57,
		54,
		45,
		33,
		30,
		36,
		40,
		54,
		58,
		197,
		-1,
		141,
		-1,
		-1,
		-1,
		131,
		146,
		117,
		94,
		67,
		62,
		55,
		49,
		54,
		65,
		65,
		76,
		35,
		31,
		27,
		28,
		32,
		49,
		59,
		-1,
		-1,
		139,
		135,
		157,
		139,
		143,
		144,
		-1,
		-1,
		71,
		62,
		53,
		45,
		58,
		61,
		32,
		34,
		18,
		28,
		25,
		37,
		51,
		56,
		-1,
		-1,
		-1,
		151,
		-1,
		153,
		-1,
		-1,
		141,
		142,
		89,
		71,
		67,
		65,
		54,
		48,
		36,
		35,
		19,
		8,
		0,
		21,
		36,
		59,
		48,
		87,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		130,
		122,
		117,
		123,
		125,
		116,
		104,
		101,
		-1,
		71,
		77,
		42,
		49,
		32,
		15,
		12,
		4,
		19,
		33,
		49,
		48,
		43,
		79,
		70,
		76,
		-1,
		-1,
		216,
		205,
		194,
		200,
		-1,
		123,
		119,
		109,
		99,
		102,
		-1,
		-1,
		96,
		93,
		73,
		42,
		40,
		33,
		28,
		43,
		32,
		24,
		26,
		30,
		36,
		41,
		46,
		52,
		67,
		82,
		-1,
		170,
		207,
		200,
		168,
		176,
		207,
		-1,
		113,
		105,
		116,
		91,
		93,
		-1,
		-1,
		69,
		60,
		61,
		49,
		46,
		52,
		51,
		52,
		38,
		44,
		31,
		28,
		46,
		50,
		59,
		66,
		56,
		69,
		73,
		-1,
		163,
		183,
		162,
		165,
		189,
		203,
		-1,
		110,
		-1,
		-1,
		122,
		94,
		78,
		68,
		65,
		108,
		63,
		58,
		60,
		59,
		50,
		41,
		46,
		39,
		37,
		40,
		57,
		62,
		54,
		66,
		66,
		67,
		-1,
		152,
		163,
		156,
		-1,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		138,
		-1,
		105,
		-1,
		88,
		92,
		71,
		74,
		75,
		62,
		54,
		46,
		62,
		37,
		45,
		41,
		44,
		53,
		64,
		76,
		73,
		74,
		177,
		133,
		136,
		147,
		158,
		173,
		177,
		-1,
		122,
		161,
		169,
		-1,
		147,
		-1,
		-1,
		-1,
		102,
		84,
		76,
		92,
		74,
		74,
		48,
		52,
		42,
		49,
		57,
		59,
		53,
		57,
		70,
		81,
		82,
		173,
		164,
		177,
		122,
		122,
		143,
		152,
		173,
		137,
		128,
		155,
		176,
		165,
		160,
		147,
		-1,
		-1,
		125,
		94,
		-1,
		-1,
		81,
		69,
		52,
		53,
		49,
		52,
		67,
		68,
		60,
		58,
		52,
		84,
		-1,
		166,
		165,
		154,
		151,
		127,
		118,
		113,
		140,
		-1,
		-1,
		135,
		156,
		146,
		150,
		166,
		191,
		-1,
		136,
		-1,
		-1,
		126,
		-1,
		-1,
		111,
		74,
		63,
		54,
		60,
		57,
		68,
		78,
		66,
		67,
		57,
		67,
		80,
		150,
		147,
		135,
		133,
		156,
		121,
		109,
		-1,
		122,
		120,
		126,
		133,
		150,
		180,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		59,
		64,
		84,
		86,
		75,
		69,
		63,
		70,
		69,
		77,
		85,
		159,
		173,
		162,
		158,
		157,
		165,
		114,
		107,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		73,
		77,
		81,
		73,
		66,
		61,
		72,
		64,
		68,
		85,
		-1,
		193,
		-1,
		145,
		121,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		117,
		85,
		90,
		85,
		67,
		78,
		67,
		70,
		84,
		79,
		-1,
		-1,
		133,
		136,
		-1,
		-1,
		149,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		74,
		99,
		88,
		96,
		91,
		71,
		77,
		80,
		69,
		73,
		85,
		-1,
		-1,
		140,
		141,
		146,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		112,
		75,
		92,
		106,
		100,
		98,
		89,
		75,
		82,
		80,
		76,
		87,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		94,
		-1,
		69,
		72,
		97,
		105,
		111,
		105,
		78,
		93,
		83,
		74,
		83,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		91,
		73,
		-1,
		101,
		91,
		127,
		112,
		93,
		80,
		87,
		87,
		80,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		81,
		81,
		72,
		80,
		117,
		113,
		100,
		100,
		92,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		76,
		84,
		82,
		79,
		91,
		87,
		107,
		93,
		128,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		110,
		94,
		92,
		97,
		101,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		103,
		99,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		188,
		192,
		158,
		152,
		191,
		160,
		166,
		177,
		-1,
		-1,
		-1,
		181,
		180,
		148,
		146,
		155,
		160,
		167,
		-1,
		166,
		-1,
		202,
		181,
		192,
		197,
		141,
		138,
		158,
		177,
		159,
		151,
		217,
		171,
		142,
		136,
		154,
		144,
		153,
		145,
		-1,
		142,
		132,
		154,
		133,
		144,
		136,
		-1,
		-1,
		136,
		137,
		143,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		126,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		128,
		-1,
		123,
		141,
		146,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		120,
		-1,
		132,
		133,
		128,
		136,
		136,
		112,
		99,
		99,
		109,
		102,
		121,
		109,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		115,
		132,
		124,
		114,
		129,
		122,
		102,
		99,
		97,
		94,
		110,
		108,
		118,
		-1,
		-1,
		223,
		192,
		223,
		181,
		162,
		-1,
		128,
		108,
		114,
		118,
		112,
		105,
		119,
		115,
		-1,
		88,
		87,
		115,
		101,
		112,
		183,
		-1,
		-1,
		181,
		173,
		158,
		161,
		138,
		134,
		123,
		122,
		114,
		100,
		96,
		102,
		105,
		105,
		111,
		82,
		92,
		96,
		94,
		119,
		-1,
		-1,
		154,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		144,
		150,
		136,
		157,
		133,
		124,
		116,
		110,
		98,
		100,
		97,
		110,
		98,
		79,
		104,
		108,
		89,
		110,
		105,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		173,
		-1,
		145,
		133,
		134,
		119,
		116,
		103,
		91,
		104,
		89,
		96,
		95,
		83,
		81,
		111,
		86,
		108,
		105,
		124,
		129,
		123,
		132,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		181,
		182,
		157,
		130,
		133,
		120,
		111,
		98,
		87,
		98,
		87,
		84,
		92,
		75,
		90,
		81,
		80,
		98,
		108,
		116,
		120,
		126,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		182,
		174,
		159,
		157,
		-1,
		129,
		126,
		116,
		94,
		79,
		96,
		88,
		86,
		88,
		70,
		84,
		75,
		93,
		100,
		98,
		102,
		122,
		134,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		131,
		144,
		-1,
		100,
		96,
		78,
		79,
		74,
		89,
		81,
		66,
		63,
		81,
		84,
		91,
		95,
		111,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		114,
		111,
		99,
		86,
		71,
		72,
		80,
		92,
		71,
		65,
		62,
		82,
		108,
		86,
		97,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		110,
		89,
		80,
		69,
		67,
		80,
		72,
		80,
		60,
		58,
		77,
		89,
		80,
		88,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		123,
		106,
		87,
		76,
		68,
		57,
		68,
		76,
		74,
		56,
		65,
		71,
		95,
		76,
		82,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		96,
		81,
		76,
		73,
		60,
		59,
		73,
		73,
		63,
		58,
		65,
		100,
		100,
		66,
		86,
		89,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		83,
		79,
		64,
		68,
		70,
		73,
		61,
		67,
		68,
		50,
		74,
		-1,
		74,
		68,
		76,
		66,
		54,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		76,
		71,
		70,
		69,
		66,
		55,
		68,
		61,
		55,
		49,
		62,
		66,
		67,
		56,
		52,
		49,
		63,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		98,
		82,
		81,
		78,
		69,
		77,
		50,
		43,
		54,
		39,
		57,
		63,
		54,
		49,
		48,
		59,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		88,
		105,
		106,
		84,
		78,
		76,
		67,
		55,
		44,
		47,
		39,
		61,
		58,
		42,
		44,
		45,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		102,
		100,
		95,
		86,
		92,
		87,
		64,
		59,
		49,
		38,
		38,
		33,
		52,
		38,
		36,
		43,
		59,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		103,
		87,
		92,
		-1,
		84,
		-1,
		57,
		54,
		45,
		30,
		27,
		38,
		36,
		45,
		38,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		119,
		99,
		93,
		92,
		79,
		71,
		65,
		43,
		36,
		33,
		23,
		36,
		46,
		52,
		36,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		121,
		109,
		99,
		89,
		94,
		87,
		62,
		55,
		41,
		43,
		32,
		25,
		24,
		38,
		30,
		52,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		147,
		118,
		110,
		-1,
		-1,
		93,
		86,
		79,
		58,
		45,
		54,
		49,
		31,
		18,
		33,
		35,
		43,
		34,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		161,
		106,
		95,
		90,
		94,
		92,
		-1,
		66,
		69,
		49,
		56,
		63,
		33,
		18,
		12,
		18,
		30,
		39,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		118,
		112,
		83,
		76,
		80,
		-1,
		68,
		65,
		51,
		62,
		36,
		33,
		24,
		16,
		9,
		15,
		19,
		33,
		37,
		178,
		-1,
		146,
		-1,
		-1,
		-1,
		136,
		151,
		122,
		99,
		72,
		67,
		60,
		54,
		59,
		58,
		44,
		55,
		23,
		19,
		6,
		7,
		11,
		28,
		38,
		-1,
		-1,
		144,
		140,
		162,
		144,
		148,
		149,
		-1,
		-1,
		76,
		67,
		58,
		50,
		63,
		62,
		29,
		26,
		17,
		10,
		4,
		16,
		30,
		42,
		-1,
		-1,
		-1,
		156,
		-1,
		158,
		-1,
		-1,
		146,
		147,
		94,
		76,
		72,
		70,
		59,
		53,
		41,
		34,
		38,
		28,
		20,
		0,
		22,
		40,
		34,
		73,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		135,
		127,
		122,
		128,
		130,
		121,
		109,
		106,
		-1,
		76,
		82,
		47,
		54,
		37,
		35,
		32,
		24,
		5,
		19,
		35,
		34,
		29,
		65,
		56,
		62,
		-1,
		-1,
		221,
		210,
		199,
		205,
		-1,
		128,
		124,
		114,
		104,
		107,
		-1,
		-1,
		101,
		98,
		78,
		47,
		45,
		38,
		33,
		43,
		23,
		10,
		12,
		16,
		22,
		27,
		32,
		38,
		53,
		68,
		-1,
		175,
		212,
		205,
		173,
		181,
		212,
		-1,
		118,
		110,
		121,
		96,
		98,
		-1,
		-1,
		74,
		65,
		66,
		54,
		51,
		53,
		48,
		39,
		24,
		30,
		17,
		14,
		32,
		36,
		45,
		52,
		42,
		55,
		59,
		-1,
		168,
		188,
		167,
		170,
		194,
		208,
		-1,
		115,
		-1,
		-1,
		127,
		99,
		83,
		73,
		70,
		113,
		68,
		63,
		47,
		45,
		36,
		27,
		34,
		25,
		23,
		26,
		43,
		48,
		40,
		52,
		52,
		53,
		-1,
		157,
		168,
		161,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		143,
		-1,
		110,
		-1,
		93,
		97,
		76,
		79,
		61,
		48,
		40,
		32,
		48,
		23,
		31,
		27,
		30,
		39,
		50,
		62,
		59,
		60,
		182,
		138,
		141,
		152,
		163,
		178,
		182,
		-1,
		127,
		166,
		160,
		-1,
		144,
		-1,
		-1,
		-1,
		107,
		89,
		81,
		81,
		60,
		60,
		34,
		38,
		28,
		35,
		43,
		45,
		39,
		43,
		56,
		67,
		68,
		178,
		169,
		182,
		127,
		127,
		148,
		157,
		178,
		142,
		133,
		160,
		167,
		156,
		151,
		138,
		-1,
		-1,
		130,
		99,
		-1,
		-1,
		67,
		55,
		38,
		39,
		35,
		38,
		53,
		54,
		46,
		44,
		38,
		70,
		-1,
		171,
		170,
		159,
		156,
		132,
		123,
		118,
		145,
		-1,
		-1,
		140,
		161,
		151,
		155,
		171,
		196,
		-1,
		127,
		-1,
		-1,
		112,
		-1,
		-1,
		97,
		60,
		49,
		40,
		46,
		43,
		54,
		64,
		52,
		53,
		43,
		53,
		66,
		155,
		152,
		140,
		138,
		161,
		126,
		114,
		-1,
		127,
		125,
		131,
		138,
		155,
		185,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		95,
		93,
		82,
		-1,
		72,
		45,
		50,
		70,
		72,
		61,
		55,
		49,
		56,
		55,
		63,
		71,
		164,
		178,
		167,
		163,
		162,
		170,
		119,
		112,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		90,
		83,
		71,
		59,
		49,
		59,
		63,
		67,
		59,
		52,
		47,
		58,
		50,
		54,
		71,
		-1,
		198,
		-1,
		150,
		126,
		140,
		155,
		163,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		124,
		108,
		89,
		-1,
		59,
		72,
		103,
		71,
		76,
		71,
		53,
		64,
		53,
		56,
		70,
		65,
		-1,
		-1,
		138,
		141,
		-1,
		-1,
		140,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		96,
		92,
		-1,
		-1,
		60,
		85,
		74,
		82,
		77,
		57,
		63,
		66,
		55,
		59,
		71,
		-1,
		-1,
		145,
		146,
		147,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		98,
		61,
		82,
		92,
		86,
		84,
		75,
		61,
		68,
		66,
		62,
		73,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		85,
		-1,
		60,
		62,
		88,
		91,
		97,
		91,
		64,
		79,
		69,
		60,
		69,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		82,
		64,
		-1,
		92,
		82,
		113,
		98,
		79,
		66,
		73,
		73,
		66,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		72,
		63,
		71,
		103,
		99,
		86,
		86,
		78,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		75,
		73,
		70,
		82,
		78,
		98,
		79,
		114,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		101,
		85,
		83,
		86,
		87,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		94,
		90,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		198,
		202,
		168,
		162,
		201,
		170,
		176,
		187,
		-1,
		-1,
		-1,
		191,
		190,
		158,
		156,
		165,
		170,
		177,
		-1,
		176,
		-1,
		212,
		191,
		202,
		207,
		151,
		148,
		168,
		187,
		169,
		161,
		227,
		181,
		152,
		146,
		164,
		154,
		163,
		155,
		-1,
		152,
		142,
		164,
		143,
		154,
		146,
		-1,
		-1,
		146,
		147,
		153,
		139,
		145,
		141,
		-1,
		151,
		135,
		-1,
		-1,
		136,
		137,
		121,
		124,
		132,
		130,
		143,
		135,
		130,
		-1,
		-1,
		127,
		123,
		130,
		117,
		113,
		130,
		143,
		125,
		139,
		138,
		-1,
		131,
		149,
		156,
		124,
		122,
		106,
		104,
		122,
		124,
		130,
		130,
		-1,
		140,
		141,
		136,
		144,
		146,
		122,
		109,
		109,
		119,
		112,
		131,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		123,
		140,
		132,
		122,
		137,
		130,
		112,
		109,
		107,
		104,
		120,
		118,
		128,
		-1,
		-1,
		233,
		202,
		231,
		189,
		170,
		-1,
		136,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		98,
		97,
		125,
		111,
		122,
		193,
		-1,
		-1,
		191,
		183,
		166,
		169,
		146,
		142,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		92,
		102,
		106,
		104,
		129,
		-1,
		-1,
		164,
		-1,
		-1,
		190,
		173,
		-1,
		156,
		163,
		152,
		158,
		144,
		165,
		141,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		89,
		114,
		118,
		99,
		120,
		115,
		-1,
		163,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		149,
		152,
		158,
		182,
		181,
		-1,
		153,
		141,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		93,
		91,
		121,
		96,
		118,
		115,
		134,
		139,
		133,
		142,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		186,
		-1,
		189,
		190,
		165,
		138,
		141,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		85,
		100,
		91,
		90,
		108,
		118,
		126,
		130,
		136,
		-1,
		248,
		-1,
		190,
		174,
		176,
		148,
		169,
		-1,
		206,
		190,
		182,
		167,
		167,
		-1,
		137,
		134,
		124,
		102,
		87,
		104,
		96,
		94,
		98,
		80,
		94,
		85,
		103,
		110,
		108,
		112,
		132,
		144,
		208,
		198,
		-1,
		180,
		185,
		144,
		152,
		171,
		209,
		173,
		-1,
		168,
		-1,
		139,
		152,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		91,
		76,
		73,
		91,
		94,
		101,
		105,
		121,
		-1,
		-1,
		193,
		197,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		122,
		119,
		107,
		94,
		79,
		80,
		88,
		101,
		80,
		75,
		72,
		92,
		118,
		96,
		108,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		118,
		97,
		88,
		77,
		75,
		88,
		85,
		90,
		70,
		68,
		87,
		99,
		90,
		107,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		131,
		114,
		95,
		84,
		76,
		65,
		81,
		89,
		84,
		66,
		75,
		81,
		105,
		95,
		101,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		83,
		73,
		68,
		75,
		110,
		110,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		79,
		77,
		78,
		60,
		92,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		84,
		73,
		86,
		79,
		65,
		67,
		80,
		84,
		86,
		75,
		71,
		68,
		82,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		96,
		87,
		95,
		68,
		61,
		68,
		57,
		75,
		82,
		73,
		68,
		66,
		78,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		96,
		94,
		85,
		73,
		62,
		65,
		57,
		79,
		77,
		61,
		63,
		62,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		105,
		82,
		77,
		67,
		56,
		56,
		51,
		71,
		57,
		55,
		60,
		76,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		110,
		100,
		105,
		-1,
		102,
		-1,
		75,
		72,
		63,
		48,
		45,
		56,
		54,
		64,
		55,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		126,
		106,
		98,
		105,
		97,
		89,
		83,
		61,
		54,
		51,
		42,
		55,
		65,
		69,
		53,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		126,
		114,
		104,
		94,
		99,
		100,
		80,
		73,
		59,
		61,
		51,
		44,
		43,
		55,
		47,
		69,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		154,
		128,
		115,
		-1,
		-1,
		98,
		91,
		85,
		76,
		63,
		73,
		68,
		50,
		37,
		52,
		52,
		60,
		51,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		166,
		111,
		100,
		95,
		99,
		97,
		-1,
		71,
		82,
		67,
		75,
		82,
		52,
		37,
		31,
		35,
		47,
		56,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		88,
		81,
		85,
		-1,
		73,
		75,
		69,
		81,
		55,
		52,
		43,
		33,
		25,
		32,
		36,
		50,
		54,
		188,
		-1,
		151,
		-1,
		-1,
		-1,
		141,
		156,
		127,
		104,
		77,
		72,
		65,
		59,
		64,
		75,
		63,
		74,
		40,
		36,
		22,
		24,
		28,
		45,
		45,
		-1,
		-1,
		149,
		145,
		167,
		149,
		153,
		154,
		-1,
		-1,
		81,
		72,
		63,
		55,
		68,
		71,
		46,
		43,
		36,
		29,
		17,
		25,
		33,
		39,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		151,
		152,
		99,
		81,
		77,
		75,
		64,
		58,
		46,
		51,
		54,
		44,
		36,
		19,
		0,
		28,
		31,
		70,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		135,
		126,
		114,
		111,
		-1,
		81,
		87,
		52,
		59,
		42,
		49,
		48,
		40,
		19,
		2,
		18,
		31,
		26,
		62,
		53,
		59,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		133,
		129,
		119,
		109,
		112,
		-1,
		-1,
		106,
		103,
		83,
		52,
		50,
		43,
		38,
		48,
		28,
		15,
		9,
		13,
		19,
		24,
		29,
		35,
		50,
		65,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		123,
		115,
		126,
		101,
		103,
		-1,
		-1,
		79,
		70,
		71,
		59,
		56,
		58,
		53,
		44,
		29,
		35,
		22,
		11,
		29,
		33,
		42,
		49,
		39,
		52,
		56,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		120,
		-1,
		-1,
		132,
		104,
		88,
		78,
		75,
		118,
		73,
		68,
		52,
		50,
		41,
		32,
		39,
		26,
		20,
		23,
		41,
		46,
		38,
		49,
		49,
		50,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		115,
		-1,
		98,
		102,
		81,
		84,
		66,
		53,
		45,
		37,
		53,
		28,
		28,
		24,
		28,
		37,
		48,
		60,
		56,
		57,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		132,
		171,
		165,
		-1,
		149,
		-1,
		-1,
		-1,
		112,
		94,
		86,
		86,
		65,
		65,
		39,
		43,
		33,
		33,
		40,
		42,
		37,
		41,
		54,
		65,
		65,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		147,
		138,
		165,
		172,
		161,
		156,
		143,
		-1,
		-1,
		135,
		104,
		-1,
		-1,
		72,
		60,
		43,
		44,
		40,
		43,
		58,
		51,
		44,
		42,
		36,
		68,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		166,
		156,
		160,
		176,
		201,
		-1,
		132,
		-1,
		-1,
		117,
		-1,
		-1,
		102,
		65,
		54,
		45,
		51,
		48,
		59,
		69,
		50,
		51,
		41,
		51,
		64,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		132,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		148,
		128,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		50,
		55,
		75,
		70,
		59,
		53,
		47,
		54,
		53,
		61,
		69,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		138,
		134,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		64,
		68,
		71,
		57,
		50,
		45,
		56,
		48,
		52,
		69,
		-1,
		203,
		-1,
		155,
		131,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		155,
		141,
		134,
		122,
		120,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		107,
		75,
		75,
		69,
		51,
		62,
		51,
		54,
		68,
		63,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		145,
		147,
		-1,
		146,
		135,
		120,
		112,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		65,
		89,
		78,
		81,
		76,
		55,
		61,
		64,
		53,
		57,
		69,
		-1,
		-1,
		150,
		151,
		152,
		-1,
		130,
		-1,
		148,
		-1,
		115,
		121,
		109,
		-1,
		-1,
		-1,
		103,
		66,
		87,
		96,
		84,
		82,
		73,
		59,
		66,
		64,
		60,
		71,
		-1,
		-1,
		-1,
		148,
		122,
		155,
		146,
		129,
		109,
		101,
		120,
		-1,
		90,
		-1,
		65,
		67,
		93,
		92,
		95,
		89,
		62,
		77,
		67,
		58,
		67,
		154,
		-1,
		124,
		157,
		121,
		115,
		91,
		95,
		111,
		-1,
		87,
		69,
		-1,
		97,
		87,
		111,
		96,
		77,
		64,
		71,
		71,
		64,
		-1,
		-1,
		-1,
		126,
		125,
		117,
		111,
		111,
		96,
		87,
		-1,
		99,
		81,
		60,
		77,
		77,
		68,
		76,
		101,
		97,
		84,
		84,
		76,
		-1,
		227,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		120,
		115,
		88,
		76,
		82,
		78,
		64,
		70,
		72,
		80,
		78,
		75,
		87,
		83,
		100,
		77,
		112,
		-1,
		222,
		-1,
		156,
		-1,
		-1,
		138,
		118,
		110,
		99,
		88,
		86,
		77,
		68,
		90,
		106,
		90,
		88,
		84,
		85,
		-1,
		211,
		210,
		-1,
		157,
		149,
		135,
		-1,
		128,
		-1,
		134,
		95,
		-1,
		97,
		77,
		-1,
		99,
		89,
		-1,
		-1,
		198,
		173,
		-1,
		-1,
		-1,
		158,
		138,
		129,
		113,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		183,
		182,
		-1,
		151,
		154,
		-1,
		144,
		135,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		192,
		173,
		167,
		166,
		164,
		159,
		156,
		142,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		164,
		156,
		149,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		175,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		197,
		198,
		221,
		185,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		200,
		198,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		212,
		201,
		212,
		220,
		193,
		200,
		-1,
		219,
		223,
		189,
		183,
		222,
		191,
		197,
		208,
		-1,
		-1,
		-1,
		212,
		211,
		179,
		177,
		186,
		191,
		198,
		-1,
		197,
		-1,
		233,
		212,
		223,
		228,
		172,
		169,
		189,
		208,
		190,
		182,
		248,
		202,
		173,
		167,
		185,
		175,
		184,
		176,
		-1,
		173,
		163,
		185,
		164,
		175,
		167,
		-1,
		-1,
		167,
		168,
		174,
		160,
		166,
		162,
		-1,
		172,
		156,
		-1,
		-1,
		157,
		158,
		142,
		145,
		153,
		151,
		164,
		156,
		151,
		-1,
		-1,
		148,
		144,
		151,
		138,
		134,
		151,
		164,
		146,
		160,
		159,
		-1,
		154,
		172,
		177,
		145,
		143,
		127,
		125,
		143,
		145,
		151,
		151,
		-1,
		163,
		164,
		159,
		167,
		167,
		143,
		130,
		130,
		140,
		133,
		152,
		140,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		146,
		163,
		155,
		145,
		160,
		153,
		133,
		130,
		128,
		125,
		141,
		139,
		149,
		-1,
		-1,
		254,
		223,
		254,
		212,
		193,
		-1,
		159,
		139,
		145,
		149,
		143,
		136,
		150,
		146,
		-1,
		119,
		118,
		146,
		132,
		143,
		214,
		-1,
		-1,
		212,
		204,
		189,
		192,
		169,
		165,
		154,
		153,
		145,
		131,
		127,
		133,
		136,
		136,
		142,
		113,
		123,
		127,
		125,
		150,
		-1,
		-1,
		183,
		-1,
		-1,
		211,
		194,
		-1,
		177,
		184,
		175,
		181,
		167,
		188,
		164,
		155,
		147,
		141,
		129,
		131,
		128,
		141,
		129,
		110,
		135,
		139,
		120,
		141,
		136,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		170,
		173,
		179,
		203,
		204,
		-1,
		176,
		164,
		165,
		150,
		147,
		134,
		122,
		135,
		120,
		127,
		126,
		114,
		112,
		142,
		117,
		139,
		136,
		153,
		158,
		152,
		161,
		-1,
		219,
		215,
		211,
		218,
		167,
		-1,
		-1,
		207,
		-1,
		212,
		213,
		188,
		161,
		164,
		151,
		142,
		129,
		118,
		129,
		118,
		115,
		123,
		106,
		121,
		112,
		111,
		129,
		137,
		145,
		149,
		155,
		-1,
		269,
		-1,
		211,
		195,
		197,
		169,
		190,
		-1,
		227,
		213,
		205,
		190,
		188,
		-1,
		160,
		157,
		147,
		125,
		110,
		127,
		119,
		117,
		119,
		101,
		115,
		106,
		124,
		131,
		127,
		131,
		151,
		163,
		229,
		219,
		-1,
		201,
		206,
		165,
		173,
		192,
		230,
		194,
		-1,
		189,
		-1,
		162,
		175,
		-1,
		131,
		127,
		109,
		110,
		105,
		120,
		112,
		97,
		94,
		112,
		115,
		120,
		124,
		140,
		-1,
		-1,
		214,
		218,
		207,
		158,
		177,
		201,
		238,
		187,
		176,
		175,
		-1,
		166,
		145,
		142,
		130,
		117,
		102,
		103,
		111,
		123,
		102,
		96,
		93,
		113,
		137,
		115,
		126,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		184,
		155,
		179,
		221,
		205,
		198,
		186,
		151,
		151,
		145,
		-1,
		141,
		120,
		111,
		100,
		98,
		111,
		103,
		111,
		91,
		89,
		108,
		118,
		109,
		117,
		-1,
		-1,
		-1,
		214,
		203,
		204,
		150,
		173,
		210,
		184,
		170,
		175,
		150,
		143,
		137,
		154,
		137,
		118,
		107,
		99,
		88,
		99,
		107,
		105,
		87,
		96,
		102,
		124,
		105,
		111,
		-1,
		-1,
		221,
		211,
		195,
		197,
		194,
		164,
		171,
		203,
		175,
		188,
		-1,
		142,
		-1,
		131,
		127,
		112,
		107,
		104,
		91,
		90,
		104,
		104,
		94,
		89,
		96,
		129,
		129,
		95,
		114,
		117,
		-1,
		-1,
		-1,
		214,
		209,
		184,
		161,
		145,
		181,
		-1,
		158,
		159,
		-1,
		136,
		130,
		127,
		114,
		110,
		95,
		99,
		101,
		104,
		92,
		98,
		99,
		81,
		105,
		-1,
		103,
		97,
		104,
		94,
		83,
		-1,
		-1,
		-1,
		207,
		186,
		179,
		199,
		140,
		192,
		-1,
		-1,
		143,
		136,
		-1,
		123,
		105,
		107,
		102,
		101,
		100,
		97,
		86,
		99,
		92,
		86,
		80,
		93,
		97,
		98,
		85,
		81,
		78,
		92,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		160,
		-1,
		152,
		144,
		134,
		128,
		122,
		118,
		116,
		129,
		113,
		112,
		109,
		100,
		108,
		81,
		74,
		85,
		70,
		88,
		94,
		85,
		79,
		71,
		88,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		173,
		-1,
		137,
		151,
		167,
		-1,
		160,
		139,
		154,
		132,
		128,
		119,
		136,
		137,
		115,
		109,
		107,
		98,
		86,
		75,
		78,
		70,
		92,
		89,
		73,
		74,
		67,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		134,
		122,
		154,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		133,
		131,
		126,
		117,
		123,
		118,
		95,
		90,
		80,
		69,
		69,
		64,
		83,
		69,
		67,
		65,
		77,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		134,
		118,
		123,
		-1,
		115,
		-1,
		88,
		85,
		76,
		61,
		58,
		69,
		67,
		76,
		60,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		191,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		150,
		130,
		124,
		123,
		110,
		102,
		96,
		74,
		67,
		64,
		54,
		67,
		77,
		74,
		58,
		-1,
		-1,
		-1,
		188,
		174,
		178,
		138,
		157,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		148,
		154,
		142,
		132,
		122,
		127,
		118,
		93,
		86,
		72,
		74,
		66,
		56,
		55,
		59,
		52,
		70,
		-1,
		-1,
		171,
		176,
		164,
		150,
		169,
		-1,
		-1,
		-1,
		170,
		186,
		178,
		149,
		143,
		-1,
		-1,
		126,
		119,
		110,
		89,
		76,
		85,
		80,
		65,
		49,
		64,
		51,
		60,
		49,
		-1,
		174,
		161,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		-1,
		-1,
		194,
		139,
		128,
		123,
		127,
		125,
		-1,
		99,
		100,
		80,
		92,
		99,
		67,
		54,
		48,
		40,
		46,
		46,
		-1,
		-1,
		186,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		116,
		109,
		113,
		-1,
		101,
		96,
		82,
		98,
		72,
		69,
		60,
		50,
		42,
		37,
		34,
		37,
		39,
		209,
		-1,
		179,
		-1,
		-1,
		-1,
		169,
		184,
		155,
		132,
		105,
		100,
		93,
		87,
		90,
		94,
		80,
		91,
		57,
		53,
		39,
		32,
		33,
		34,
		38,
		-1,
		-1,
		177,
		173,
		195,
		177,
		181,
		182,
		-1,
		-1,
		109,
		100,
		91,
		83,
		96,
		98,
		63,
		60,
		53,
		46,
		34,
		33,
		15,
		37,
		-1,
		-1,
		-1,
		189,
		-1,
		191,
		-1,
		-1,
		179,
		180,
		127,
		109,
		105,
		103,
		92,
		86,
		74,
		68,
		74,
		64,
		56,
		36,
		31,
		0,
		34,
		79,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		142,
		139,
		-1,
		109,
		115,
		80,
		87,
		70,
		71,
		68,
		60,
		41,
		30,
		13,
		30,
		36,
		71,
		65,
		69,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		134,
		131,
		111,
		80,
		78,
		71,
		66,
		76,
		56,
		43,
		37,
		41,
		31,
		34,
		39,
		45,
		60,
		75,
		-1,
		208,
		245,
		238,
		206,
		214,
		245,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		107,
		98,
		99,
		87,
		84,
		86,
		81,
		72,
		57,
		63,
		50,
		39,
		49,
		45,
		52,
		59,
		51,
		64,
		68,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		148,
		-1,
		-1,
		160,
		132,
		116,
		106,
		103,
		146,
		101,
		96,
		80,
		78,
		69,
		60,
		67,
		54,
		48,
		51,
		53,
		67,
		61,
		61,
		61,
		62,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		176,
		-1,
		143,
		-1,
		126,
		130,
		109,
		112,
		94,
		81,
		73,
		65,
		81,
		56,
		56,
		52,
		56,
		65,
		71,
		82,
		68,
		69,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		160,
		199,
		193,
		-1,
		177,
		-1,
		-1,
		-1,
		140,
		122,
		114,
		114,
		93,
		93,
		67,
		71,
		61,
		61,
		68,
		70,
		65,
		69,
		82,
		78,
		77,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		175,
		166,
		193,
		200,
		189,
		184,
		171,
		-1,
		-1,
		163,
		132,
		-1,
		-1,
		100,
		88,
		71,
		72,
		68,
		71,
		86,
		79,
		72,
		70,
		64,
		83,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		194,
		184,
		188,
		204,
		229,
		-1,
		160,
		-1,
		-1,
		145,
		-1,
		-1,
		130,
		93,
		82,
		73,
		79,
		76,
		87,
		97,
		78,
		79,
		69,
		79,
		92,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		188,
		218,
		-1,
		-1,
		176,
		156,
		-1,
		-1,
		128,
		126,
		115,
		-1,
		105,
		78,
		83,
		103,
		98,
		87,
		81,
		75,
		82,
		81,
		89,
		97,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		166,
		162,
		-1,
		-1,
		123,
		116,
		104,
		92,
		82,
		92,
		96,
		99,
		85,
		78,
		73,
		84,
		76,
		80,
		97,
		-1,
		231,
		-1,
		183,
		159,
		173,
		188,
		196,
		-1,
		-1,
		-1,
		183,
		169,
		162,
		150,
		148,
		-1,
		157,
		141,
		122,
		-1,
		92,
		105,
		135,
		103,
		103,
		97,
		79,
		90,
		79,
		82,
		92,
		91,
		-1,
		-1,
		171,
		174,
		-1,
		-1,
		173,
		175,
		-1,
		174,
		163,
		148,
		140,
		-1,
		-1,
		129,
		125,
		-1,
		-1,
		93,
		117,
		106,
		109,
		104,
		83,
		89,
		92,
		81,
		85,
		92,
		-1,
		-1,
		178,
		179,
		180,
		-1,
		158,
		-1,
		176,
		-1,
		143,
		149,
		137,
		-1,
		-1,
		-1,
		131,
		94,
		115,
		124,
		112,
		110,
		101,
		87,
		94,
		92,
		88,
		99,
		-1,
		-1,
		-1,
		176,
		150,
		183,
		174,
		157,
		137,
		129,
		148,
		-1,
		118,
		-1,
		93,
		95,
		121,
		120,
		123,
		117,
		90,
		105,
		95,
		86,
		95,
		182,
		-1,
		152,
		185,
		149,
		143,
		119,
		123,
		139,
		-1,
		115,
		97,
		-1,
		125,
		115,
		139,
		124,
		105,
		92,
		99,
		99,
		92,
		-1,
		-1,
		-1,
		154,
		153,
		145,
		139,
		139,
		124,
		115,
		-1,
		127,
		109,
		88,
		105,
		105,
		96,
		104,
		129,
		125,
		112,
		112,
		104,
		-1,
		255,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		148,
		143,
		116,
		104,
		110,
		106,
		92,
		98,
		100,
		108,
		106,
		103,
		115,
		111,
		128,
		105,
		140,
		-1,
		250,
		-1,
		184,
		-1,
		-1,
		166,
		146,
		138,
		127,
		116,
		114,
		105,
		96,
		118,
		134,
		118,
		116,
		112,
		113,
		-1,
		239,
		238,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		162,
		123,
		-1,
		125,
		105,
		-1,
		127,
		117,
		-1,
		-1,
		226,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		157,
		141,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		211,
		210,
		-1,
		179,
		182,
		-1,
		172,
		163,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		220,
		201,
		195,
		194,
		192,
		187,
		184,
		170,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		192,
		184,
		177,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		203,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		226,
		249,
		213,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		228,
		226,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		208,
		197,
		208,
		216,
		189,
		196,
		-1,
		215,
		219,
		185,
		179,
		218,
		187,
		193,
		204,
		-1,
		-1,
		-1,
		208,
		207,
		175,
		173,
		182,
		187,
		194,
		-1,
		193,
		-1,
		229,
		208,
		219,
		224,
		168,
		165,
		185,
		204,
		186,
		178,
		244,
		198,
		169,
		163,
		181,
		171,
		180,
		172,
		-1,
		169,
		159,
		181,
		160,
		171,
		163,
		-1,
		-1,
		163,
		164,
		170,
		156,
		162,
		158,
		-1,
		168,
		152,
		-1,
		-1,
		153,
		154,
		138,
		141,
		149,
		147,
		160,
		152,
		147,
		-1,
		-1,
		144,
		140,
		147,
		134,
		130,
		147,
		160,
		142,
		156,
		155,
		-1,
		148,
		166,
		173,
		141,
		139,
		123,
		121,
		139,
		141,
		147,
		147,
		-1,
		157,
		158,
		153,
		161,
		163,
		139,
		126,
		126,
		136,
		129,
		148,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		157,
		140,
		157,
		149,
		139,
		154,
		147,
		129,
		126,
		124,
		121,
		137,
		135,
		145,
		-1,
		-1,
		250,
		219,
		248,
		206,
		187,
		-1,
		153,
		133,
		139,
		143,
		137,
		130,
		144,
		140,
		-1,
		115,
		114,
		142,
		128,
		139,
		210,
		-1,
		-1,
		208,
		200,
		183,
		186,
		163,
		159,
		148,
		147,
		139,
		125,
		121,
		127,
		130,
		130,
		136,
		109,
		119,
		123,
		121,
		146,
		-1,
		-1,
		180,
		-1,
		-1,
		207,
		190,
		-1,
		173,
		180,
		169,
		175,
		161,
		182,
		158,
		149,
		141,
		135,
		123,
		125,
		122,
		135,
		123,
		106,
		131,
		135,
		116,
		137,
		132,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		166,
		169,
		175,
		199,
		198,
		-1,
		170,
		158,
		159,
		144,
		141,
		128,
		116,
		129,
		114,
		121,
		120,
		110,
		108,
		138,
		113,
		135,
		132,
		150,
		155,
		149,
		158,
		-1,
		215,
		211,
		207,
		214,
		163,
		-1,
		-1,
		203,
		-1,
		206,
		207,
		182,
		155,
		158,
		145,
		136,
		123,
		112,
		123,
		112,
		109,
		117,
		102,
		117,
		108,
		107,
		125,
		134,
		142,
		146,
		152,
		-1,
		265,
		-1,
		207,
		191,
		193,
		165,
		186,
		-1,
		223,
		207,
		199,
		184,
		184,
		-1,
		154,
		151,
		141,
		119,
		104,
		121,
		113,
		111,
		115,
		97,
		111,
		102,
		120,
		127,
		124,
		128,
		148,
		160,
		225,
		215,
		-1,
		197,
		202,
		161,
		169,
		188,
		226,
		190,
		-1,
		185,
		-1,
		156,
		169,
		-1,
		125,
		121,
		103,
		104,
		99,
		114,
		108,
		93,
		90,
		108,
		111,
		117,
		121,
		137,
		-1,
		-1,
		210,
		214,
		203,
		154,
		173,
		197,
		234,
		183,
		172,
		171,
		-1,
		162,
		139,
		136,
		124,
		111,
		96,
		97,
		105,
		118,
		97,
		92,
		89,
		109,
		134,
		112,
		123,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		180,
		151,
		175,
		217,
		201,
		194,
		182,
		147,
		147,
		141,
		-1,
		135,
		114,
		105,
		94,
		92,
		105,
		102,
		107,
		87,
		85,
		104,
		115,
		106,
		114,
		-1,
		-1,
		-1,
		210,
		199,
		200,
		146,
		169,
		206,
		180,
		166,
		171,
		146,
		139,
		133,
		148,
		131,
		112,
		101,
		93,
		82,
		98,
		106,
		101,
		83,
		92,
		98,
		121,
		102,
		108,
		-1,
		-1,
		217,
		207,
		191,
		193,
		190,
		160,
		167,
		199,
		171,
		184,
		-1,
		138,
		-1,
		127,
		122,
		106,
		101,
		98,
		93,
		89,
		98,
		100,
		90,
		85,
		92,
		126,
		126,
		92,
		111,
		114,
		-1,
		-1,
		-1,
		210,
		205,
		180,
		157,
		141,
		177,
		-1,
		154,
		155,
		-1,
		132,
		126,
		123,
		108,
		104,
		97,
		101,
		96,
		103,
		94,
		94,
		95,
		77,
		107,
		-1,
		100,
		94,
		101,
		91,
		80,
		-1,
		-1,
		-1,
		203,
		182,
		175,
		195,
		136,
		188,
		-1,
		-1,
		139,
		132,
		-1,
		119,
		101,
		108,
		104,
		100,
		102,
		99,
		88,
		101,
		94,
		82,
		82,
		95,
		99,
		99,
		82,
		78,
		75,
		79,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		156,
		-1,
		148,
		140,
		130,
		124,
		118,
		114,
		112,
		128,
		112,
		114,
		111,
		102,
		110,
		83,
		76,
		85,
		72,
		90,
		96,
		86,
		76,
		68,
		75,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		169,
		-1,
		133,
		147,
		163,
		-1,
		156,
		135,
		150,
		128,
		124,
		120,
		135,
		136,
		114,
		111,
		109,
		100,
		88,
		77,
		80,
		72,
		94,
		90,
		74,
		71,
		64,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		130,
		118,
		150,
		-1,
		-1,
		192,
		-1,
		126,
		143,
		134,
		132,
		125,
		116,
		122,
		120,
		97,
		92,
		82,
		71,
		71,
		66,
		85,
		71,
		69,
		62,
		60,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		167,
		-1,
		170,
		160,
		144,
		129,
		162,
		-1,
		127,
		117,
		122,
		-1,
		117,
		-1,
		90,
		87,
		78,
		63,
		60,
		71,
		69,
		78,
		57,
		-1,
		179,
		164,
		157,
		147,
		161,
		132,
		-1,
		187,
		-1,
		-1,
		157,
		151,
		151,
		135,
		138,
		143,
		123,
		115,
		122,
		112,
		104,
		98,
		76,
		69,
		66,
		56,
		69,
		79,
		71,
		55,
		-1,
		-1,
		-1,
		184,
		170,
		174,
		134,
		153,
		-1,
		-1,
		219,
		174,
		160,
		-1,
		144,
		143,
		131,
		121,
		111,
		116,
		117,
		95,
		88,
		74,
		76,
		68,
		58,
		57,
		62,
		54,
		59,
		-1,
		-1,
		167,
		172,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		166,
		182,
		171,
		145,
		132,
		-1,
		-1,
		115,
		108,
		102,
		91,
		78,
		87,
		82,
		67,
		51,
		66,
		57,
		49,
		41,
		-1,
		170,
		157,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		183,
		128,
		117,
		112,
		116,
		114,
		-1,
		88,
		99,
		82,
		94,
		101,
		69,
		57,
		51,
		42,
		52,
		35,
		-1,
		-1,
		182,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		140,
		134,
		105,
		98,
		102,
		-1,
		90,
		92,
		84,
		100,
		75,
		72,
		63,
		53,
		51,
		39,
		39,
		20,
		26,
		205,
		-1,
		168,
		-1,
		-1,
		-1,
		158,
		173,
		144,
		121,
		94,
		89,
		82,
		76,
		81,
		92,
		83,
		94,
		60,
		56,
		48,
		39,
		35,
		24,
		14,
		-1,
		-1,
		166,
		162,
		184,
		166,
		170,
		171,
		-1,
		-1,
		98,
		89,
		80,
		72,
		85,
		88,
		66,
		63,
		59,
		52,
		46,
		45,
		13,
		8,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		168,
		169,
		116,
		98,
		94,
		92,
		81,
		75,
		63,
		68,
		71,
		61,
		53,
		42,
		36,
		27,
		0,
		57,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		131,
		128,
		-1,
		98,
		104,
		69,
		76,
		59,
		66,
		65,
		57,
		36,
		33,
		24,
		12,
		11,
		49,
		40,
		44,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		123,
		120,
		100,
		69,
		67,
		60,
		55,
		65,
		45,
		32,
		26,
		30,
		16,
		9,
		14,
		20,
		35,
		50,
		-1,
		197,
		234,
		227,
		195,
		203,
		234,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		96,
		87,
		88,
		76,
		73,
		75,
		70,
		61,
		46,
		52,
		39,
		28,
		44,
		30,
		27,
		34,
		33,
		44,
		48,
		-1,
		190,
		210,
		189,
		192,
		216,
		230,
		-1,
		137,
		-1,
		-1,
		149,
		121,
		105,
		95,
		92,
		135,
		90,
		85,
		69,
		67,
		58,
		49,
		56,
		43,
		37,
		40,
		38,
		42,
		36,
		43,
		38,
		44,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		165,
		-1,
		132,
		-1,
		115,
		119,
		98,
		101,
		83,
		70,
		62,
		54,
		70,
		45,
		45,
		41,
		45,
		54,
		46,
		59,
		50,
		44,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		149,
		188,
		182,
		-1,
		166,
		-1,
		-1,
		-1,
		129,
		111,
		103,
		103,
		82,
		82,
		56,
		60,
		50,
		50,
		57,
		59,
		54,
		58,
		69,
		60,
		52,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		164,
		155,
		182,
		189,
		178,
		173,
		160,
		-1,
		-1,
		152,
		121,
		-1,
		-1,
		89,
		77,
		60,
		61,
		57,
		60,
		75,
		68,
		61,
		59,
		53,
		65,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		183,
		173,
		177,
		193,
		218,
		-1,
		149,
		-1,
		-1,
		134,
		-1,
		-1,
		119,
		82,
		71,
		62,
		68,
		65,
		76,
		86,
		67,
		68,
		58,
		68,
		79,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		149,
		147,
		153,
		160,
		177,
		207,
		-1,
		-1,
		165,
		145,
		-1,
		-1,
		117,
		115,
		104,
		-1,
		94,
		67,
		72,
		92,
		87,
		76,
		70,
		64,
		71,
		70,
		78,
		84,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		155,
		151,
		-1,
		-1,
		112,
		105,
		93,
		81,
		71,
		81,
		85,
		88,
		74,
		67,
		62,
		73,
		65,
		69,
		81,
		-1,
		220,
		-1,
		172,
		148,
		162,
		177,
		185,
		-1,
		-1,
		-1,
		172,
		158,
		151,
		139,
		137,
		-1,
		146,
		130,
		111,
		-1,
		81,
		94,
		124,
		92,
		92,
		86,
		68,
		79,
		68,
		71,
		74,
		77,
		-1,
		-1,
		160,
		163,
		-1,
		-1,
		162,
		164,
		-1,
		163,
		152,
		137,
		129,
		-1,
		-1,
		118,
		114,
		-1,
		-1,
		82,
		106,
		95,
		98,
		93,
		72,
		78,
		81,
		70,
		74,
		74,
		-1,
		-1,
		167,
		168,
		169,
		-1,
		147,
		-1,
		165,
		-1,
		132,
		138,
		126,
		-1,
		-1,
		-1,
		120,
		83,
		104,
		113,
		101,
		99,
		90,
		76,
		83,
		81,
		77,
		84,
		-1,
		-1,
		-1,
		165,
		139,
		172,
		163,
		146,
		126,
		118,
		137,
		-1,
		107,
		-1,
		82,
		84,
		110,
		109,
		112,
		106,
		79,
		94,
		84,
		75,
		84,
		171,
		-1,
		141,
		174,
		138,
		132,
		108,
		112,
		128,
		-1,
		104,
		86,
		-1,
		114,
		104,
		128,
		113,
		94,
		81,
		88,
		88,
		81,
		-1,
		-1,
		-1,
		143,
		142,
		134,
		128,
		128,
		113,
		104,
		-1,
		116,
		98,
		77,
		94,
		94,
		85,
		93,
		118,
		114,
		101,
		101,
		93,
		-1,
		244,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		137,
		132,
		105,
		93,
		99,
		95,
		81,
		87,
		89,
		97,
		95,
		92,
		104,
		100,
		117,
		94,
		129,
		-1,
		239,
		-1,
		173,
		-1,
		-1,
		155,
		135,
		127,
		116,
		105,
		103,
		94,
		85,
		107,
		123,
		107,
		105,
		101,
		102,
		-1,
		228,
		227,
		-1,
		174,
		166,
		152,
		-1,
		145,
		-1,
		151,
		112,
		-1,
		114,
		94,
		-1,
		116,
		106,
		-1,
		-1,
		215,
		190,
		-1,
		-1,
		-1,
		175,
		155,
		146,
		130,
		-1,
		105,
		105,
		-1,
		-1,
		-1,
		200,
		199,
		-1,
		168,
		171,
		-1,
		161,
		152,
		160,
		107,
		111,
		-1,
		-1,
		-1,
		209,
		190,
		184,
		183,
		181,
		176,
		173,
		159,
		143,
		121,
		110,
		131,
		-1,
		-1,
		-1,
		181,
		173,
		166,
		-1,
		-1,
		168,
		151,
		132,
		130,
		-1,
		-1,
		-1,
		203,
		184,
		-1,
		-1,
		158,
		-1,
		-1,
		164,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		192,
		-1,
		-1,
		-1,
		154,
		150,
		151,
		-1,
		-1,
		-1,
		-1,
		214,
		215,
		238,
		202,
		-1,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		217,
		215,
		-1,
		-1,
		-1,
		174,
		158,
		-1,
		144,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		179,
		-1,
		179,
		154,
		161,
		-1,
		-1,
		-1,
		-1,
		192,
		184,
		192,
		-1,
		164,
		166,
		-1,
		214,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		169,
		176,
		198,
		201,
		237,
		-1,
		188
	],
	[
		-1,
		223,
		212,
		223,
		231,
		204,
		211,
		-1,
		230,
		234,
		200,
		194,
		233,
		202,
		208,
		219,
		-1,
		-1,
		-1,
		223,
		222,
		190,
		188,
		197,
		202,
		209,
		-1,
		208,
		-1,
		244,
		223,
		234,
		239,
		183,
		180,
		200,
		219,
		201,
		193,
		259,
		213,
		184,
		178,
		196,
		186,
		195,
		187,
		-1,
		184,
		174,
		196,
		175,
		186,
		178,
		-1,
		-1,
		178,
		179,
		185,
		171,
		177,
		173,
		-1,
		183,
		167,
		-1,
		-1,
		168,
		169,
		153,
		156,
		164,
		162,
		175,
		167,
		162,
		-1,
		-1,
		159,
		155,
		162,
		149,
		145,
		162,
		175,
		157,
		171,
		170,
		-1,
		165,
		183,
		188,
		156,
		154,
		138,
		136,
		154,
		156,
		162,
		162,
		-1,
		174,
		175,
		170,
		178,
		178,
		154,
		141,
		141,
		151,
		144,
		163,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		174,
		157,
		174,
		166,
		156,
		171,
		164,
		144,
		141,
		139,
		136,
		152,
		150,
		160,
		-1,
		-1,
		265,
		234,
		265,
		223,
		204,
		-1,
		170,
		150,
		156,
		160,
		154,
		147,
		161,
		157,
		-1,
		130,
		129,
		157,
		143,
		154,
		225,
		-1,
		-1,
		223,
		215,
		200,
		203,
		180,
		176,
		165,
		164,
		156,
		142,
		138,
		144,
		147,
		147,
		153,
		124,
		134,
		138,
		136,
		161,
		-1,
		-1,
		178,
		-1,
		-1,
		222,
		205,
		-1,
		188,
		195,
		186,
		192,
		178,
		199,
		175,
		166,
		158,
		152,
		140,
		142,
		139,
		152,
		140,
		121,
		146,
		150,
		131,
		152,
		147,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		181,
		184,
		190,
		214,
		215,
		-1,
		187,
		175,
		176,
		161,
		158,
		145,
		133,
		146,
		131,
		138,
		137,
		125,
		123,
		153,
		128,
		150,
		143,
		148,
		153,
		147,
		156,
		-1,
		230,
		226,
		222,
		229,
		178,
		-1,
		-1,
		218,
		-1,
		223,
		224,
		199,
		172,
		175,
		162,
		153,
		140,
		129,
		140,
		129,
		126,
		134,
		117,
		132,
		123,
		122,
		132,
		132,
		140,
		144,
		150,
		-1,
		280,
		-1,
		222,
		206,
		208,
		180,
		201,
		-1,
		238,
		224,
		216,
		201,
		199,
		-1,
		171,
		168,
		158,
		136,
		121,
		138,
		130,
		128,
		130,
		112,
		126,
		117,
		135,
		136,
		122,
		126,
		146,
		158,
		240,
		230,
		-1,
		212,
		217,
		176,
		184,
		203,
		241,
		205,
		-1,
		200,
		-1,
		173,
		186,
		-1,
		142,
		138,
		120,
		121,
		116,
		131,
		123,
		108,
		105,
		123,
		126,
		115,
		119,
		135,
		-1,
		-1,
		225,
		229,
		218,
		169,
		188,
		212,
		249,
		198,
		187,
		186,
		-1,
		177,
		156,
		153,
		141,
		128,
		113,
		114,
		122,
		134,
		113,
		107,
		104,
		124,
		132,
		110,
		121,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		195,
		166,
		190,
		232,
		216,
		209,
		197,
		162,
		162,
		156,
		-1,
		152,
		131,
		122,
		111,
		109,
		122,
		114,
		122,
		102,
		100,
		119,
		113,
		104,
		112,
		-1,
		-1,
		-1,
		225,
		214,
		215,
		161,
		184,
		221,
		195,
		181,
		186,
		161,
		154,
		148,
		165,
		148,
		129,
		118,
		110,
		99,
		110,
		118,
		116,
		98,
		107,
		113,
		119,
		100,
		106,
		-1,
		-1,
		232,
		222,
		206,
		208,
		205,
		175,
		182,
		214,
		186,
		199,
		-1,
		153,
		-1,
		142,
		138,
		123,
		118,
		115,
		102,
		101,
		115,
		115,
		105,
		100,
		107,
		124,
		124,
		90,
		110,
		113,
		-1,
		-1,
		-1,
		225,
		220,
		195,
		172,
		156,
		192,
		-1,
		169,
		170,
		-1,
		147,
		141,
		138,
		125,
		121,
		106,
		110,
		112,
		115,
		103,
		109,
		110,
		92,
		116,
		-1,
		98,
		92,
		100,
		90,
		78,
		-1,
		-1,
		-1,
		218,
		197,
		190,
		210,
		151,
		203,
		-1,
		-1,
		154,
		147,
		-1,
		134,
		116,
		118,
		113,
		112,
		111,
		108,
		97,
		110,
		103,
		97,
		91,
		104,
		108,
		102,
		80,
		76,
		73,
		76,
		-1,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		171,
		-1,
		163,
		155,
		145,
		139,
		133,
		129,
		127,
		140,
		124,
		123,
		120,
		111,
		119,
		92,
		85,
		96,
		81,
		99,
		99,
		89,
		79,
		71,
		72,
		-1,
		238,
		224,
		195,
		-1,
		-1,
		184,
		-1,
		148,
		162,
		178,
		-1,
		171,
		150,
		165,
		143,
		139,
		130,
		147,
		148,
		126,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		101,
		93,
		77,
		74,
		67,
		-1,
		244,
		231,
		189,
		185,
		174,
		194,
		145,
		133,
		165,
		-1,
		-1,
		207,
		-1,
		141,
		158,
		144,
		142,
		137,
		128,
		134,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		94,
		80,
		78,
		65,
		57,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		160,
		147,
		141,
		-1,
		182,
		-1,
		185,
		175,
		159,
		144,
		177,
		-1,
		145,
		129,
		134,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		87,
		66,
		-1,
		194,
		179,
		172,
		162,
		176,
		147,
		-1,
		202,
		-1,
		-1,
		172,
		166,
		166,
		150,
		153,
		161,
		141,
		135,
		134,
		121,
		113,
		107,
		85,
		78,
		75,
		65,
		78,
		88,
		80,
		64,
		-1,
		-1,
		-1,
		199,
		185,
		189,
		149,
		168,
		-1,
		-1,
		234,
		189,
		175,
		-1,
		159,
		167,
		155,
		145,
		135,
		139,
		129,
		104,
		97,
		83,
		85,
		77,
		67,
		66,
		71,
		63,
		68,
		-1,
		-1,
		182,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		181,
		197,
		189,
		160,
		156,
		-1,
		-1,
		139,
		131,
		121,
		100,
		87,
		96,
		91,
		76,
		60,
		75,
		66,
		58,
		50,
		-1,
		185,
		172,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		207,
		152,
		141,
		136,
		140,
		138,
		-1,
		112,
		111,
		91,
		103,
		110,
		78,
		66,
		60,
		51,
		61,
		44,
		-1,
		-1,
		197,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		129,
		122,
		126,
		-1,
		114,
		107,
		93,
		109,
		84,
		81,
		72,
		62,
		62,
		48,
		48,
		29,
		35,
		220,
		-1,
		197,
		-1,
		-1,
		-1,
		182,
		197,
		168,
		145,
		118,
		113,
		106,
		100,
		101,
		106,
		92,
		103,
		69,
		65,
		61,
		48,
		44,
		33,
		34,
		-1,
		-1,
		195,
		191,
		208,
		190,
		194,
		195,
		-1,
		-1,
		122,
		113,
		104,
		96,
		109,
		110,
		75,
		72,
		72,
		65,
		58,
		57,
		55,
		40,
		-1,
		-1,
		-1,
		207,
		-1,
		209,
		-1,
		-1,
		197,
		193,
		140,
		122,
		118,
		116,
		105,
		99,
		87,
		80,
		90,
		83,
		75,
		55,
		65,
		69,
		48,
		0,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		186,
		178,
		173,
		179,
		181,
		172,
		155,
		152,
		-1,
		122,
		128,
		93,
		100,
		88,
		90,
		87,
		79,
		60,
		62,
		68,
		54,
		42,
		19,
		14,
		23,
		-1,
		-1,
		272,
		261,
		250,
		256,
		-1,
		179,
		175,
		165,
		155,
		158,
		-1,
		-1,
		152,
		149,
		125,
		98,
		96,
		89,
		84,
		94,
		74,
		61,
		55,
		59,
		45,
		44,
		39,
		32,
		21,
		29,
		-1,
		226,
		263,
		256,
		224,
		232,
		263,
		-1,
		169,
		161,
		172,
		147,
		149,
		-1,
		-1,
		125,
		116,
		117,
		105,
		102,
		104,
		99,
		90,
		75,
		81,
		59,
		57,
		74,
		59,
		52,
		35,
		24,
		37,
		41,
		-1,
		219,
		239,
		218,
		221,
		245,
		259,
		-1,
		166,
		-1,
		-1,
		178,
		150,
		134,
		124,
		121,
		164,
		119,
		114,
		98,
		96,
		87,
		78,
		83,
		67,
		55,
		52,
		61,
		47,
		37,
		34,
		34,
		35,
		-1,
		208,
		219,
		212,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		194,
		-1,
		161,
		-1,
		144,
		148,
		127,
		130,
		112,
		99,
		91,
		83,
		92,
		67,
		63,
		59,
		48,
		57,
		47,
		55,
		41,
		42,
		233,
		189,
		192,
		203,
		214,
		229,
		233,
		-1,
		178,
		217,
		211,
		-1,
		195,
		-1,
		-1,
		-1,
		158,
		140,
		132,
		132,
		111,
		111,
		85,
		86,
		72,
		68,
		75,
		65,
		57,
		61,
		63,
		51,
		50,
		229,
		220,
		233,
		178,
		178,
		199,
		208,
		229,
		193,
		184,
		211,
		218,
		207,
		202,
		189,
		-1,
		-1,
		181,
		150,
		-1,
		-1,
		118,
		106,
		89,
		83,
		79,
		82,
		90,
		74,
		64,
		62,
		56,
		56,
		-1,
		222,
		221,
		210,
		207,
		183,
		174,
		169,
		196,
		-1,
		-1,
		191,
		212,
		202,
		206,
		222,
		247,
		-1,
		178,
		-1,
		-1,
		163,
		-1,
		-1,
		148,
		111,
		100,
		91,
		94,
		87,
		94,
		105,
		70,
		71,
		61,
		71,
		70,
		206,
		203,
		191,
		189,
		212,
		177,
		165,
		-1,
		178,
		176,
		182,
		189,
		206,
		236,
		-1,
		-1,
		194,
		174,
		-1,
		-1,
		146,
		144,
		133,
		-1,
		123,
		96,
		95,
		114,
		90,
		79,
		73,
		67,
		74,
		73,
		81,
		75,
		215,
		229,
		218,
		214,
		213,
		221,
		170,
		163,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		180,
		-1,
		-1,
		141,
		134,
		122,
		110,
		100,
		109,
		95,
		91,
		77,
		70,
		65,
		76,
		68,
		72,
		72,
		-1,
		249,
		-1,
		201,
		177,
		191,
		206,
		214,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		175,
		159,
		140,
		-1,
		110,
		123,
		127,
		95,
		95,
		89,
		71,
		82,
		71,
		74,
		65,
		68,
		-1,
		-1,
		189,
		192,
		-1,
		-1,
		191,
		193,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		147,
		143,
		-1,
		-1,
		111,
		109,
		98,
		101,
		96,
		75,
		81,
		84,
		73,
		71,
		65,
		-1,
		-1,
		196,
		197,
		198,
		-1,
		176,
		-1,
		194,
		-1,
		161,
		167,
		155,
		-1,
		-1,
		-1,
		149,
		112,
		133,
		116,
		104,
		102,
		93,
		79,
		86,
		84,
		80,
		75,
		-1,
		-1,
		-1,
		194,
		168,
		201,
		192,
		175,
		155,
		147,
		166,
		-1,
		136,
		-1,
		111,
		113,
		130,
		112,
		115,
		109,
		82,
		97,
		87,
		78,
		81,
		200,
		-1,
		170,
		203,
		167,
		161,
		137,
		141,
		157,
		-1,
		133,
		115,
		-1,
		143,
		133,
		131,
		116,
		97,
		84,
		91,
		85,
		78,
		-1,
		-1,
		-1,
		172,
		171,
		163,
		157,
		157,
		142,
		133,
		-1,
		145,
		127,
		106,
		123,
		123,
		114,
		122,
		121,
		117,
		104,
		104,
		94,
		-1,
		273,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		166,
		161,
		134,
		122,
		128,
		124,
		110,
		116,
		118,
		126,
		124,
		121,
		119,
		110,
		116,
		93,
		126,
		-1,
		268,
		-1,
		202,
		-1,
		-1,
		184,
		164,
		156,
		145,
		134,
		132,
		123,
		114,
		136,
		152,
		117,
		105,
		100,
		101,
		-1,
		257,
		256,
		-1,
		203,
		195,
		181,
		-1,
		174,
		-1,
		180,
		141,
		-1,
		143,
		123,
		-1,
		116,
		105,
		-1,
		-1,
		244,
		219,
		-1,
		-1,
		-1,
		204,
		184,
		175,
		159,
		-1,
		134,
		134,
		-1,
		-1,
		-1,
		229,
		228,
		-1,
		197,
		200,
		-1,
		190,
		181,
		189,
		136,
		140,
		-1,
		-1,
		-1,
		238,
		219,
		213,
		212,
		210,
		205,
		202,
		188,
		172,
		150,
		139,
		160,
		-1,
		-1,
		-1,
		210,
		202,
		195,
		-1,
		-1,
		197,
		180,
		161,
		159,
		-1,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		187,
		-1,
		-1,
		193,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		221,
		-1,
		-1,
		-1,
		183,
		179,
		180,
		-1,
		-1,
		-1,
		-1,
		243,
		244,
		267,
		231,
		-1,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		246,
		244,
		-1,
		-1,
		-1,
		203,
		187,
		-1,
		173,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		208,
		-1,
		208,
		183,
		190,
		-1,
		-1,
		-1,
		-1,
		221,
		213,
		221,
		-1,
		193,
		195,
		-1,
		243,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		198,
		205,
		227,
		230,
		266,
		-1,
		217
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		336,
		325,
		336,
		344,
		317,
		324,
		-1,
		345,
		347,
		313,
		307,
		346,
		317,
		323,
		334,
		-1,
		-1,
		-1,
		336,
		335,
		305,
		303,
		312,
		317,
		324,
		-1,
		347,
		-1,
		357,
		336,
		347,
		352,
		298,
		295,
		315,
		334,
		340,
		332,
		372,
		328,
		299,
		293,
		311,
		316,
		334,
		326,
		-1,
		299,
		289,
		311,
		315,
		327,
		310,
		-1,
		-1,
		293,
		294,
		300,
		312,
		317,
		322,
		-1,
		348,
		332,
		-1,
		-1,
		283,
		296,
		292,
		295,
		303,
		319,
		340,
		332,
		327,
		-1,
		-1,
		284,
		288,
		301,
		302,
		300,
		327,
		340,
		322,
		336,
		335,
		-1,
		272,
		290,
		299,
		308,
		314,
		303,
		301,
		319,
		321,
		327,
		330,
		-1,
		264,
		266,
		295,
		301,
		313,
		319,
		306,
		306,
		316,
		309,
		328,
		319,
		365,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		261,
		269,
		295,
		294,
		290,
		308,
		316,
		309,
		306,
		304,
		301,
		317,
		318,
		328,
		-1,
		-1,
		317,
		286,
		321,
		278,
		263,
		-1,
		257,
		276,
		282,
		286,
		291,
		299,
		313,
		309,
		-1,
		295,
		294,
		325,
		311,
		322,
		277,
		-1,
		-1,
		275,
		267,
		252,
		255,
		252,
		252,
		282,
		281,
		286,
		288,
		290,
		296,
		299,
		299,
		305,
		289,
		299,
		303,
		311,
		329,
		-1,
		-1,
		371,
		-1,
		-1,
		274,
		257,
		-1,
		240,
		247,
		247,
		264,
		254,
		275,
		290,
		294,
		302,
		304,
		292,
		294,
		291,
		304,
		292,
		286,
		311,
		315,
		306,
		327,
		322,
		-1,
		370,
		354,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		233,
		236,
		242,
		266,
		276,
		-1,
		297,
		295,
		319,
		313,
		310,
		297,
		285,
		298,
		283,
		290,
		289,
		293,
		295,
		328,
		303,
		325,
		322,
		341,
		346,
		340,
		349,
		-1,
		282,
		278,
		274,
		281,
		230,
		-1,
		-1,
		270,
		-1,
		284,
		297,
		304,
		299,
		302,
		314,
		305,
		292,
		281,
		292,
		281,
		278,
		286,
		292,
		306,
		298,
		297,
		315,
		325,
		333,
		337,
		343,
		-1,
		332,
		-1,
		274,
		258,
		260,
		232,
		253,
		-1,
		290,
		285,
		305,
		306,
		297,
		-1,
		300,
		303,
		310,
		288,
		273,
		290,
		282,
		280,
		285,
		287,
		301,
		292,
		310,
		317,
		315,
		319,
		339,
		351,
		292,
		282,
		-1,
		264,
		269,
		228,
		236,
		255,
		328,
		303,
		-1,
		298,
		-1,
		290,
		315,
		-1,
		294,
		290,
		272,
		273,
		268,
		283,
		289,
		283,
		280,
		298,
		301,
		308,
		312,
		328,
		-1,
		-1,
		277,
		281,
		270,
		221,
		240,
		264,
		301,
		296,
		285,
		284,
		-1,
		275,
		305,
		302,
		288,
		275,
		265,
		266,
		274,
		287,
		266,
		282,
		279,
		299,
		325,
		303,
		314,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		247,
		218,
		242,
		284,
		314,
		307,
		295,
		260,
		260,
		254,
		-1,
		295,
		278,
		274,
		263,
		261,
		274,
		269,
		285,
		277,
		275,
		294,
		306,
		297,
		305,
		-1,
		-1,
		-1,
		277,
		266,
		267,
		216,
		239,
		273,
		293,
		279,
		284,
		259,
		252,
		246,
		298,
		295,
		262,
		270,
		262,
		251,
		265,
		273,
		277,
		273,
		282,
		288,
		312,
		293,
		299,
		-1,
		-1,
		284,
		274,
		258,
		260,
		257,
		230,
		237,
		269,
		284,
		281,
		-1,
		251,
		-1,
		240,
		248,
		247,
		253,
		265,
		251,
		256,
		267,
		279,
		280,
		275,
		282,
		317,
		317,
		283,
		303,
		306,
		-1,
		-1,
		-1,
		277,
		275,
		250,
		227,
		211,
		247,
		-1,
		251,
		252,
		-1,
		245,
		239,
		245,
		244,
		251,
		248,
		248,
		262,
		270,
		266,
		282,
		285,
		267,
		291,
		-1,
		291,
		285,
		293,
		283,
		271,
		-1,
		-1,
		-1,
		273,
		252,
		245,
		265,
		206,
		258,
		-1,
		-1,
		236,
		229,
		-1,
		232,
		232,
		239,
		248,
		253,
		258,
		266,
		261,
		274,
		278,
		272,
		266,
		279,
		283,
		284,
		273,
		269,
		266,
		280,
		-1,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		226,
		-1,
		239,
		231,
		227,
		221,
		227,
		245,
		243,
		263,
		255,
		269,
		269,
		275,
		281,
		267,
		260,
		271,
		256,
		274,
		280,
		271,
		266,
		265,
		276,
		-1,
		293,
		279,
		250,
		-1,
		-1,
		239,
		-1,
		203,
		217,
		233,
		-1,
		261,
		240,
		263,
		241,
		255,
		251,
		289,
		290,
		268,
		273,
		281,
		269,
		272,
		261,
		264,
		256,
		278,
		275,
		259,
		261,
		270,
		-1,
		299,
		286,
		244,
		240,
		229,
		249,
		200,
		209,
		220,
		-1,
		-1,
		305,
		-1,
		239,
		256,
		265,
		263,
		279,
		268,
		275,
		292,
		266,
		261,
		266,
		255,
		255,
		250,
		269,
		255,
		253,
		268,
		284,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		215,
		202,
		196,
		-1,
		237,
		-1,
		283,
		273,
		257,
		242,
		275,
		-1,
		267,
		263,
		270,
		-1,
		286,
		-1,
		258,
		261,
		252,
		247,
		244,
		255,
		253,
		262,
		263,
		-1,
		249,
		234,
		227,
		217,
		231,
		202,
		-1,
		245,
		-1,
		-1,
		270,
		264,
		264,
		248,
		251,
		283,
		263,
		255,
		270,
		269,
		256,
		255,
		243,
		243,
		246,
		240,
		253,
		263,
		269,
		261,
		-1,
		-1,
		-1,
		254,
		206,
		214,
		190,
		211,
		-1,
		-1,
		332,
		287,
		273,
		-1,
		257,
		283,
		271,
		261,
		251,
		256,
		257,
		247,
		245,
		241,
		250,
		249,
		242,
		241,
		262,
		255,
		277,
		-1,
		-1,
		203,
		216,
		218,
		204,
		223,
		-1,
		-1,
		-1,
		279,
		295,
		287,
		258,
		272,
		-1,
		-1,
		255,
		248,
		242,
		245,
		233,
		253,
		260,
		248,
		235,
		250,
		260,
		268,
		267,
		-1,
		206,
		193,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		-1,
		-1,
		312,
		261,
		250,
		245,
		249,
		254,
		-1,
		228,
		239,
		232,
		251,
		258,
		250,
		235,
		229,
		240,
		255,
		272,
		-1,
		-1,
		240,
		-1,
		235,
		-1,
		-1,
		-1,
		-1,
		269,
		267,
		238,
		231,
		235,
		-1,
		230,
		232,
		229,
		241,
		246,
		250,
		241,
		223,
		237,
		240,
		253,
		267,
		271,
		263,
		-1,
		245,
		-1,
		-1,
		-1,
		284,
		285,
		271,
		248,
		227,
		220,
		217,
		216,
		221,
		232,
		241,
		252,
		217,
		221,
		236,
		241,
		245,
		262,
		266,
		-1,
		-1,
		243,
		239,
		274,
		286,
		258,
		298,
		-1,
		-1,
		216,
		209,
		219,
		212,
		225,
		228,
		213,
		215,
		233,
		246,
		240,
		250,
		265,
		260,
		-1,
		-1,
		-1,
		241,
		-1,
		257,
		-1,
		-1,
		248,
		289,
		236,
		218,
		214,
		200,
		207,
		201,
		203,
		208,
		227,
		222,
		231,
		236,
		240,
		263,
		252,
		291,
		-1,
		-1,
		0,
		-1,
		-1,
		-1,
		207,
		226,
		221,
		227,
		232,
		223,
		251,
		248,
		-1,
		197,
		230,
		198,
		212,
		208,
		215,
		220,
		226,
		230,
		237,
		253,
		252,
		247,
		283,
		274,
		280,
		-1,
		-1,
		4,
		22,
		73,
		79,
		-1,
		200,
		223,
		213,
		203,
		209,
		-1,
		-1,
		215,
		212,
		210,
		190,
		196,
		201,
		204,
		242,
		218,
		226,
		230,
		234,
		240,
		245,
		250,
		256,
		271,
		286,
		-1,
		106,
		147,
		140,
		51,
		55,
		86,
		-1,
		190,
		182,
		210,
		195,
		203,
		-1,
		-1,
		188,
		179,
		184,
		193,
		194,
		225,
		224,
		237,
		240,
		245,
		233,
		232,
		250,
		254,
		263,
		270,
		260,
		273,
		277,
		-1,
		99,
		123,
		59,
		54,
		68,
		82,
		-1,
		181,
		-1,
		-1,
		226,
		213,
		197,
		187,
		184,
		231,
		207,
		202,
		208,
		210,
		234,
		225,
		250,
		241,
		241,
		244,
		259,
		264,
		256,
		270,
		270,
		271,
		-1,
		98,
		103,
		65,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		242,
		-1,
		224,
		-1,
		207,
		211,
		215,
		218,
		233,
		220,
		227,
		244,
		250,
		239,
		249,
		245,
		246,
		255,
		266,
		278,
		277,
		278,
		171,
		126,
		93,
		72,
		130,
		145,
		149,
		-1,
		165,
		201,
		211,
		-1,
		251,
		-1,
		-1,
		-1,
		221,
		228,
		220,
		236,
		232,
		232,
		228,
		232,
		244,
		251,
		261,
		263,
		255,
		259,
		272,
		283,
		286,
		167,
		165,
		170,
		115,
		98,
		115,
		124,
		145,
		161,
		158,
		195,
		200,
		215,
		220,
		244,
		-1,
		-1,
		244,
		238,
		-1,
		-1,
		239,
		249,
		232,
		234,
		238,
		252,
		264,
		272,
		262,
		260,
		254,
		286,
		-1,
		167,
		166,
		155,
		152,
		128,
		119,
		106,
		116,
		-1,
		-1,
		159,
		186,
		170,
		174,
		190,
		215,
		-1,
		251,
		-1,
		-1,
		265,
		-1,
		-1,
		291,
		254,
		243,
		234,
		240,
		246,
		257,
		279,
		268,
		269,
		259,
		269,
		282,
		151,
		148,
		136,
		134,
		157,
		114,
		110,
		-1,
		141,
		144,
		150,
		157,
		174,
		204,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		284,
		287,
		276,
		-1,
		266,
		239,
		244,
		269,
		276,
		277,
		271,
		265,
		272,
		271,
		279,
		287,
		160,
		174,
		163,
		159,
		158,
		166,
		115,
		131,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		-1,
		290,
		277,
		-1,
		-1,
		284,
		277,
		265,
		253,
		243,
		253,
		261,
		261,
		264,
		268,
		263,
		274,
		266,
		270,
		287,
		-1,
		194,
		-1,
		146,
		138,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		307,
		293,
		286,
		274,
		272,
		-1,
		318,
		302,
		283,
		-1,
		253,
		266,
		297,
		265,
		270,
		265,
		269,
		280,
		269,
		272,
		286,
		281,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		176,
		195,
		-1,
		298,
		287,
		272,
		264,
		-1,
		-1,
		290,
		286,
		-1,
		-1,
		254,
		279,
		268,
		276,
		271,
		273,
		279,
		282,
		271,
		275,
		287,
		-1,
		-1,
		158,
		159,
		164,
		-1,
		185,
		-1,
		300,
		-1,
		267,
		274,
		262,
		-1,
		-1,
		-1,
		292,
		255,
		276,
		286,
		291,
		289,
		280,
		277,
		284,
		282,
		278,
		289,
		-1,
		-1,
		-1,
		215,
		192,
		307,
		298,
		281,
		261,
		253,
		273,
		-1,
		280,
		-1,
		255,
		256,
		283,
		285,
		302,
		296,
		280,
		295,
		285,
		276,
		285,
		221,
		-1,
		196,
		255,
		238,
		267,
		233,
		245,
		301,
		-1,
		277,
		259,
		-1,
		287,
		277,
		319,
		300,
		293,
		280,
		287,
		289,
		282,
		-1,
		-1,
		-1,
		211,
		210,
		209,
		220,
		228,
		226,
		244,
		-1,
		289,
		271,
		250,
		267,
		267,
		258,
		266,
		309,
		305,
		298,
		300,
		290,
		-1,
		266,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		237,
		259,
		254,
		246,
		258,
		267,
		254,
		260,
		262,
		270,
		268,
		265,
		277,
		273,
		293,
		289,
		321,
		-1,
		273,
		-1,
		241,
		-1,
		-1,
		255,
		241,
		253,
		264,
		254,
		254,
		259,
		257,
		279,
		296,
		280,
		278,
		283,
		288,
		-1,
		283,
		284,
		-1,
		274,
		266,
		252,
		-1,
		245,
		-1,
		300,
		261,
		-1,
		286,
		266,
		-1,
		289,
		285,
		-1,
		-1,
		295,
		290,
		-1,
		-1,
		-1,
		275,
		255,
		295,
		279,
		-1,
		277,
		277,
		-1,
		-1,
		-1,
		309,
		299,
		-1,
		268,
		271,
		-1,
		262,
		268,
		297,
		279,
		283,
		-1,
		-1,
		-1,
		324,
		305,
		299,
		283,
		288,
		276,
		293,
		279,
		281,
		293,
		282,
		303,
		-1,
		-1,
		-1,
		296,
		288,
		288,
		-1,
		-1,
		306,
		289,
		289,
		302,
		-1,
		-1,
		-1,
		318,
		299,
		-1,
		-1,
		297,
		-1,
		-1,
		302,
		301,
		-1,
		-1,
		-1,
		-1,
		-1,
		334,
		307,
		-1,
		-1,
		-1,
		298,
		305,
		313,
		-1,
		-1,
		-1,
		-1,
		326,
		327,
		353,
		328,
		-1,
		-1,
		-1,
		312,
		312,
		-1,
		-1,
		324,
		325,
		-1,
		-1,
		-1,
		340,
		324,
		-1,
		316,
		-1,
		-1,
		-1,
		331,
		-1,
		-1,
		349,
		-1,
		-1,
		-1,
		345,
		-1,
		351,
		326,
		333,
		-1,
		-1,
		-1,
		-1,
		358,
		350,
		364,
		-1,
		336,
		338,
		-1,
		386,
		-1,
		-1,
		373,
		364,
		-1,
		-1,
		341,
		348,
		370,
		373,
		403,
		-1,
		360
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		258,
		247,
		258,
		266,
		239,
		246,
		-1,
		267,
		269,
		235,
		229,
		268,
		239,
		245,
		256,
		-1,
		-1,
		-1,
		258,
		257,
		227,
		225,
		234,
		239,
		246,
		-1,
		269,
		-1,
		279,
		258,
		269,
		274,
		220,
		217,
		237,
		256,
		262,
		254,
		294,
		250,
		221,
		215,
		233,
		238,
		256,
		248,
		-1,
		221,
		211,
		233,
		237,
		249,
		232,
		-1,
		-1,
		215,
		216,
		222,
		234,
		239,
		242,
		-1,
		252,
		236,
		-1,
		-1,
		205,
		218,
		214,
		217,
		225,
		231,
		244,
		236,
		231,
		-1,
		-1,
		206,
		210,
		223,
		218,
		214,
		231,
		244,
		226,
		240,
		239,
		-1,
		194,
		212,
		221,
		225,
		223,
		207,
		205,
		223,
		225,
		231,
		231,
		-1,
		186,
		188,
		217,
		223,
		235,
		223,
		210,
		210,
		220,
		213,
		232,
		220,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		183,
		191,
		217,
		216,
		212,
		230,
		233,
		213,
		210,
		208,
		205,
		221,
		219,
		229,
		-1,
		-1,
		239,
		208,
		243,
		200,
		185,
		-1,
		179,
		198,
		204,
		208,
		213,
		216,
		230,
		226,
		-1,
		199,
		198,
		226,
		212,
		223,
		199,
		-1,
		-1,
		197,
		189,
		174,
		177,
		174,
		174,
		204,
		203,
		208,
		210,
		207,
		213,
		216,
		216,
		222,
		193,
		203,
		207,
		205,
		230,
		-1,
		-1,
		265,
		-1,
		-1,
		196,
		179,
		-1,
		162,
		169,
		169,
		186,
		176,
		197,
		212,
		216,
		224,
		221,
		209,
		211,
		208,
		221,
		209,
		190,
		215,
		219,
		200,
		221,
		216,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		155,
		158,
		164,
		188,
		198,
		-1,
		219,
		217,
		241,
		230,
		227,
		214,
		202,
		215,
		200,
		207,
		206,
		194,
		192,
		222,
		197,
		219,
		216,
		235,
		240,
		234,
		243,
		-1,
		204,
		200,
		196,
		203,
		152,
		-1,
		-1,
		192,
		-1,
		206,
		219,
		223,
		221,
		224,
		231,
		222,
		209,
		198,
		209,
		198,
		195,
		203,
		186,
		201,
		192,
		191,
		209,
		219,
		227,
		231,
		237,
		-1,
		254,
		-1,
		196,
		180,
		182,
		154,
		175,
		-1,
		212,
		207,
		227,
		225,
		216,
		-1,
		219,
		222,
		227,
		205,
		190,
		207,
		199,
		197,
		199,
		181,
		195,
		186,
		204,
		211,
		209,
		213,
		233,
		245,
		214,
		204,
		-1,
		186,
		191,
		150,
		158,
		177,
		250,
		222,
		-1,
		217,
		-1,
		209,
		234,
		-1,
		211,
		207,
		189,
		190,
		185,
		200,
		192,
		177,
		174,
		192,
		195,
		202,
		206,
		222,
		-1,
		-1,
		199,
		203,
		192,
		143,
		162,
		186,
		223,
		215,
		204,
		203,
		-1,
		194,
		224,
		221,
		207,
		194,
		182,
		183,
		191,
		203,
		182,
		176,
		173,
		193,
		219,
		197,
		208,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		169,
		140,
		164,
		206,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		214,
		197,
		191,
		180,
		178,
		191,
		183,
		191,
		171,
		169,
		188,
		200,
		191,
		199,
		-1,
		-1,
		-1,
		199,
		188,
		189,
		135,
		158,
		195,
		212,
		198,
		203,
		178,
		171,
		165,
		217,
		214,
		181,
		187,
		179,
		168,
		179,
		187,
		185,
		167,
		176,
		182,
		206,
		187,
		193,
		-1,
		-1,
		206,
		196,
		180,
		182,
		179,
		149,
		156,
		188,
		203,
		200,
		-1,
		170,
		-1,
		159,
		167,
		166,
		172,
		184,
		170,
		170,
		184,
		184,
		174,
		169,
		176,
		211,
		211,
		177,
		197,
		200,
		-1,
		-1,
		-1,
		199,
		194,
		169,
		146,
		130,
		166,
		-1,
		170,
		171,
		-1,
		164,
		158,
		164,
		163,
		170,
		167,
		167,
		181,
		184,
		172,
		178,
		179,
		161,
		185,
		-1,
		185,
		179,
		187,
		177,
		165,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		125,
		177,
		-1,
		-1,
		155,
		148,
		-1,
		151,
		151,
		158,
		167,
		172,
		177,
		177,
		166,
		179,
		172,
		166,
		160,
		173,
		177,
		178,
		167,
		163,
		160,
		174,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		145,
		-1,
		163,
		155,
		146,
		140,
		146,
		164,
		162,
		182,
		174,
		188,
		188,
		180,
		175,
		161,
		154,
		165,
		150,
		168,
		174,
		165,
		160,
		159,
		170,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		158,
		-1,
		122,
		141,
		157,
		-1,
		180,
		159,
		182,
		160,
		174,
		170,
		197,
		198,
		168,
		173,
		175,
		163,
		166,
		155,
		158,
		150,
		172,
		169,
		153,
		155,
		164,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		119,
		128,
		144,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		184,
		182,
		187,
		162,
		169,
		187,
		160,
		155,
		160,
		149,
		149,
		144,
		163,
		149,
		147,
		162,
		178,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		161,
		-1,
		202,
		191,
		176,
		160,
		194,
		-1,
		161,
		157,
		164,
		-1,
		180,
		-1,
		152,
		155,
		146,
		141,
		138,
		149,
		147,
		156,
		157,
		-1,
		168,
		153,
		146,
		136,
		150,
		118,
		-1,
		152,
		-1,
		-1,
		189,
		183,
		183,
		153,
		150,
		177,
		157,
		149,
		164,
		163,
		150,
		149,
		137,
		137,
		140,
		134,
		147,
		157,
		163,
		155,
		-1,
		-1,
		-1,
		173,
		148,
		142,
		114,
		118,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		145,
		177,
		165,
		155,
		145,
		150,
		151,
		141,
		139,
		135,
		144,
		143,
		136,
		135,
		156,
		149,
		171,
		-1,
		-1,
		147,
		140,
		128,
		96,
		91,
		-1,
		-1,
		-1,
		197,
		183,
		171,
		143,
		166,
		-1,
		-1,
		149,
		142,
		136,
		134,
		127,
		147,
		154,
		142,
		129,
		144,
		154,
		162,
		161,
		-1,
		150,
		137,
		-1,
		-1,
		90,
		80,
		-1,
		-1,
		-1,
		-1,
		161,
		142,
		137,
		132,
		136,
		148,
		-1,
		121,
		125,
		125,
		145,
		152,
		144,
		129,
		123,
		134,
		149,
		166,
		-1,
		-1,
		104,
		-1,
		66,
		-1,
		-1,
		-1,
		-1,
		133,
		148,
		125,
		118,
		122,
		-1,
		119,
		118,
		122,
		128,
		140,
		144,
		135,
		117,
		131,
		134,
		147,
		161,
		165,
		127,
		-1,
		59,
		-1,
		-1,
		-1,
		116,
		126,
		158,
		135,
		114,
		107,
		104,
		110,
		114,
		126,
		135,
		146,
		111,
		115,
		130,
		135,
		139,
		156,
		160,
		-1,
		-1,
		57,
		64,
		99,
		111,
		99,
		185,
		-1,
		-1,
		103,
		96,
		106,
		106,
		119,
		122,
		107,
		109,
		127,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		34,
		-1,
		82,
		-1,
		-1,
		89,
		176,
		123,
		105,
		101,
		87,
		101,
		95,
		97,
		102,
		121,
		116,
		125,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		0,
		64,
		58,
		68,
		73,
		64,
		138,
		135,
		-1,
		83,
		124,
		92,
		106,
		102,
		109,
		114,
		120,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		185,
		174,
		163,
		169,
		-1,
		6,
		61,
		54,
		44,
		50,
		-1,
		-1,
		97,
		94,
		97,
		84,
		90,
		95,
		98,
		136,
		112,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		139,
		176,
		169,
		137,
		145,
		176,
		-1,
		9,
		23,
		45,
		36,
		44,
		-1,
		-1,
		70,
		66,
		71,
		80,
		83,
		119,
		118,
		131,
		134,
		139,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		132,
		152,
		131,
		134,
		158,
		172,
		-1,
		22,
		-1,
		-1,
		67,
		57,
		65,
		61,
		65,
		118,
		94,
		89,
		102,
		104,
		128,
		119,
		144,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		121,
		132,
		125,
		-1,
		-1,
		-1,
		-1,
		29,
		-1,
		-1,
		83,
		-1,
		91,
		-1,
		84,
		88,
		102,
		105,
		127,
		114,
		121,
		138,
		144,
		133,
		143,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		146,
		102,
		105,
		116,
		127,
		142,
		146,
		-1,
		40,
		79,
		121,
		-1,
		92,
		-1,
		-1,
		-1,
		98,
		115,
		107,
		123,
		126,
		126,
		122,
		126,
		138,
		145,
		155,
		157,
		149,
		153,
		166,
		177,
		180,
		142,
		133,
		146,
		91,
		91,
		112,
		121,
		142,
		55,
		46,
		73,
		117,
		117,
		112,
		99,
		-1,
		-1,
		121,
		125,
		-1,
		-1,
		133,
		143,
		126,
		128,
		132,
		146,
		158,
		166,
		156,
		154,
		148,
		180,
		-1,
		135,
		134,
		123,
		120,
		96,
		87,
		82,
		109,
		-1,
		-1,
		58,
		74,
		87,
		91,
		107,
		132,
		-1,
		102,
		-1,
		-1,
		142,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		140,
		151,
		173,
		162,
		163,
		153,
		163,
		176,
		119,
		116,
		104,
		102,
		125,
		90,
		78,
		-1,
		73,
		61,
		67,
		74,
		91,
		121,
		-1,
		-1,
		118,
		109,
		-1,
		-1,
		161,
		168,
		170,
		-1,
		160,
		133,
		138,
		163,
		170,
		171,
		165,
		159,
		166,
		165,
		173,
		181,
		128,
		142,
		131,
		127,
		126,
		134,
		83,
		76,
		76,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		153,
		128,
		-1,
		-1,
		168,
		171,
		159,
		147,
		137,
		147,
		155,
		155,
		158,
		162,
		157,
		168,
		160,
		164,
		181,
		-1,
		162,
		-1,
		114,
		82,
		102,
		117,
		125,
		-1,
		-1,
		-1,
		170,
		156,
		149,
		137,
		135,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		163,
		174,
		163,
		166,
		180,
		175,
		-1,
		-1,
		100,
		103,
		-1,
		-1,
		127,
		146,
		-1,
		161,
		150,
		135,
		127,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		167,
		173,
		176,
		165,
		169,
		181,
		-1,
		-1,
		107,
		110,
		115,
		-1,
		136,
		-1,
		185,
		-1,
		130,
		146,
		148,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		185,
		183,
		174,
		171,
		178,
		176,
		172,
		183,
		-1,
		-1,
		-1,
		166,
		143,
		192,
		183,
		166,
		146,
		138,
		163,
		-1,
		174,
		-1,
		149,
		150,
		177,
		179,
		196,
		190,
		174,
		189,
		179,
		170,
		179,
		172,
		-1,
		147,
		206,
		184,
		152,
		152,
		151,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		213,
		194,
		187,
		174,
		181,
		183,
		176,
		-1,
		-1,
		-1,
		162,
		161,
		160,
		171,
		172,
		157,
		152,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		203,
		199,
		192,
		194,
		184,
		-1,
		234,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		183,
		192,
		165,
		153,
		166,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		183,
		215,
		-1,
		241,
		-1,
		192,
		-1,
		-1,
		199,
		185,
		187,
		176,
		165,
		163,
		161,
		152,
		174,
		190,
		174,
		172,
		177,
		182,
		-1,
		251,
		252,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		211,
		172,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		263,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		206,
		190,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		212,
		215,
		-1,
		206,
		212,
		227,
		174,
		178,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		227,
		232,
		220,
		237,
		223,
		210,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		240,
		232,
		232,
		-1,
		-1,
		235,
		218,
		199,
		197,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		225,
		-1,
		-1,
		231,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		251,
		-1,
		-1,
		-1,
		221,
		217,
		218,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		297,
		269,
		-1,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		211,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		246,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		236,
		243,
		265,
		268,
		304,
		-1,
		255
	],
	[
		-1,
		220,
		209,
		220,
		228,
		201,
		208,
		-1,
		229,
		231,
		197,
		191,
		230,
		201,
		207,
		218,
		-1,
		-1,
		-1,
		220,
		219,
		189,
		187,
		196,
		201,
		208,
		-1,
		231,
		-1,
		241,
		220,
		231,
		236,
		182,
		179,
		199,
		218,
		224,
		216,
		256,
		212,
		183,
		177,
		195,
		200,
		218,
		210,
		-1,
		183,
		173,
		195,
		199,
		211,
		194,
		-1,
		-1,
		177,
		178,
		184,
		196,
		201,
		206,
		-1,
		229,
		213,
		-1,
		-1,
		167,
		180,
		176,
		179,
		187,
		203,
		221,
		213,
		208,
		-1,
		-1,
		168,
		172,
		185,
		186,
		184,
		208,
		221,
		203,
		217,
		216,
		-1,
		156,
		174,
		183,
		192,
		198,
		184,
		182,
		200,
		202,
		208,
		211,
		-1,
		148,
		150,
		179,
		185,
		197,
		200,
		187,
		187,
		197,
		190,
		209,
		200,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		153,
		179,
		178,
		174,
		192,
		197,
		190,
		187,
		185,
		182,
		198,
		199,
		209,
		-1,
		-1,
		201,
		170,
		205,
		162,
		147,
		-1,
		141,
		160,
		166,
		170,
		175,
		180,
		194,
		190,
		-1,
		176,
		175,
		206,
		192,
		203,
		161,
		-1,
		-1,
		159,
		151,
		136,
		139,
		136,
		136,
		166,
		165,
		170,
		172,
		171,
		177,
		180,
		180,
		186,
		170,
		180,
		184,
		195,
		210,
		-1,
		-1,
		265,
		-1,
		-1,
		158,
		141,
		-1,
		124,
		131,
		131,
		148,
		138,
		159,
		174,
		178,
		186,
		185,
		173,
		175,
		172,
		185,
		173,
		167,
		192,
		196,
		190,
		211,
		206,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		117,
		120,
		126,
		150,
		160,
		-1,
		181,
		179,
		203,
		194,
		191,
		178,
		166,
		179,
		164,
		171,
		170,
		174,
		176,
		209,
		187,
		209,
		206,
		235,
		240,
		234,
		243,
		-1,
		166,
		162,
		158,
		165,
		114,
		-1,
		-1,
		154,
		-1,
		168,
		181,
		185,
		183,
		186,
		195,
		186,
		173,
		162,
		173,
		162,
		159,
		167,
		176,
		187,
		182,
		181,
		199,
		214,
		227,
		231,
		237,
		-1,
		216,
		-1,
		158,
		142,
		144,
		116,
		137,
		-1,
		174,
		169,
		189,
		187,
		178,
		-1,
		181,
		184,
		191,
		169,
		154,
		171,
		163,
		161,
		166,
		171,
		185,
		176,
		194,
		201,
		209,
		213,
		233,
		245,
		176,
		166,
		-1,
		148,
		153,
		112,
		120,
		139,
		212,
		184,
		-1,
		179,
		-1,
		171,
		196,
		-1,
		175,
		171,
		153,
		154,
		149,
		164,
		170,
		167,
		164,
		182,
		185,
		202,
		206,
		222,
		-1,
		-1,
		161,
		165,
		154,
		105,
		124,
		148,
		185,
		177,
		166,
		165,
		-1,
		156,
		186,
		183,
		169,
		156,
		146,
		147,
		155,
		168,
		147,
		166,
		169,
		191,
		219,
		197,
		209,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		131,
		102,
		126,
		168,
		195,
		188,
		176,
		141,
		141,
		135,
		-1,
		176,
		159,
		155,
		144,
		142,
		155,
		150,
		166,
		170,
		169,
		188,
		200,
		191,
		206,
		-1,
		-1,
		-1,
		161,
		150,
		151,
		97,
		120,
		157,
		174,
		160,
		165,
		140,
		133,
		127,
		179,
		176,
		143,
		151,
		143,
		132,
		146,
		154,
		158,
		167,
		176,
		182,
		206,
		194,
		200,
		-1,
		-1,
		168,
		158,
		142,
		144,
		141,
		111,
		118,
		150,
		165,
		162,
		-1,
		132,
		-1,
		121,
		129,
		128,
		134,
		146,
		132,
		137,
		148,
		160,
		173,
		169,
		176,
		211,
		211,
		184,
		204,
		207,
		-1,
		-1,
		-1,
		161,
		156,
		131,
		108,
		92,
		128,
		-1,
		132,
		133,
		-1,
		126,
		120,
		126,
		125,
		132,
		129,
		129,
		143,
		151,
		147,
		163,
		169,
		161,
		192,
		-1,
		192,
		186,
		194,
		184,
		172,
		-1,
		-1,
		-1,
		154,
		133,
		126,
		146,
		87,
		139,
		-1,
		-1,
		117,
		110,
		-1,
		113,
		113,
		120,
		129,
		134,
		139,
		147,
		142,
		155,
		160,
		166,
		167,
		180,
		184,
		185,
		174,
		170,
		167,
		181,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		107,
		-1,
		125,
		117,
		108,
		102,
		108,
		126,
		124,
		144,
		136,
		150,
		150,
		156,
		164,
		149,
		152,
		168,
		157,
		175,
		181,
		172,
		167,
		166,
		177,
		-1,
		174,
		160,
		131,
		-1,
		-1,
		120,
		-1,
		84,
		103,
		119,
		-1,
		142,
		121,
		144,
		122,
		136,
		132,
		170,
		171,
		149,
		154,
		162,
		170,
		173,
		162,
		165,
		157,
		179,
		176,
		160,
		162,
		171,
		-1,
		180,
		167,
		125,
		121,
		110,
		130,
		81,
		90,
		106,
		-1,
		-1,
		180,
		-1,
		120,
		136,
		146,
		144,
		160,
		151,
		157,
		173,
		167,
		162,
		167,
		156,
		156,
		151,
		170,
		156,
		154,
		169,
		185,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		96,
		83,
		77,
		-1,
		123,
		-1,
		158,
		146,
		133,
		115,
		155,
		-1,
		168,
		152,
		157,
		-1,
		187,
		-1,
		159,
		162,
		153,
		148,
		145,
		156,
		154,
		163,
		164,
		-1,
		130,
		115,
		108,
		98,
		112,
		80,
		-1,
		114,
		-1,
		-1,
		145,
		139,
		139,
		108,
		105,
		184,
		164,
		156,
		157,
		170,
		157,
		156,
		144,
		144,
		147,
		141,
		154,
		164,
		170,
		162,
		-1,
		-1,
		-1,
		135,
		110,
		104,
		76,
		80,
		-1,
		-1,
		206,
		162,
		148,
		-1,
		100,
		184,
		172,
		162,
		152,
		157,
		158,
		148,
		146,
		142,
		151,
		150,
		143,
		142,
		163,
		156,
		178,
		-1,
		-1,
		109,
		102,
		90,
		58,
		53,
		-1,
		-1,
		-1,
		152,
		138,
		126,
		98,
		173,
		-1,
		-1,
		156,
		149,
		143,
		141,
		134,
		154,
		161,
		149,
		136,
		151,
		161,
		169,
		168,
		-1,
		112,
		99,
		-1,
		-1,
		52,
		42,
		-1,
		-1,
		-1,
		-1,
		116,
		97,
		109,
		130,
		143,
		155,
		-1,
		128,
		132,
		132,
		152,
		159,
		151,
		136,
		130,
		141,
		156,
		173,
		-1,
		-1,
		66,
		-1,
		28,
		-1,
		-1,
		-1,
		-1,
		88,
		103,
		123,
		125,
		129,
		-1,
		126,
		125,
		129,
		135,
		147,
		151,
		142,
		124,
		138,
		141,
		154,
		168,
		172,
		89,
		-1,
		19,
		-1,
		-1,
		-1,
		65,
		95,
		165,
		142,
		121,
		114,
		111,
		117,
		121,
		133,
		142,
		153,
		118,
		122,
		137,
		142,
		146,
		163,
		167,
		-1,
		-1,
		17,
		13,
		48,
		60,
		92,
		192,
		-1,
		-1,
		110,
		103,
		113,
		113,
		126,
		129,
		114,
		116,
		134,
		147,
		141,
		151,
		166,
		161,
		-1,
		-1,
		-1,
		29,
		-1,
		31,
		-1,
		-1,
		96,
		183,
		130,
		112,
		108,
		94,
		108,
		102,
		104,
		109,
		128,
		123,
		132,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		58,
		0,
		15,
		75,
		80,
		71,
		145,
		142,
		-1,
		90,
		131,
		99,
		113,
		109,
		116,
		121,
		127,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		219,
		208,
		197,
		203,
		-1,
		64,
		17,
		61,
		51,
		57,
		-1,
		-1,
		104,
		101,
		104,
		91,
		97,
		102,
		105,
		143,
		119,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		157,
		210,
		203,
		171,
		179,
		210,
		-1,
		65,
		57,
		24,
		43,
		51,
		-1,
		-1,
		77,
		73,
		78,
		87,
		90,
		126,
		125,
		138,
		141,
		146,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		166,
		186,
		165,
		168,
		192,
		206,
		-1,
		62,
		-1,
		-1,
		46,
		64,
		72,
		68,
		72,
		125,
		101,
		96,
		109,
		111,
		135,
		126,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		155,
		166,
		159,
		-1,
		-1,
		-1,
		-1,
		63,
		-1,
		-1,
		62,
		-1,
		98,
		-1,
		91,
		95,
		109,
		112,
		134,
		121,
		128,
		145,
		151,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		180,
		136,
		139,
		150,
		161,
		176,
		180,
		-1,
		74,
		113,
		100,
		-1,
		71,
		-1,
		-1,
		-1,
		105,
		122,
		114,
		130,
		133,
		133,
		129,
		133,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		176,
		167,
		180,
		125,
		125,
		146,
		155,
		176,
		89,
		80,
		107,
		107,
		96,
		91,
		78,
		-1,
		-1,
		128,
		132,
		-1,
		-1,
		140,
		150,
		133,
		135,
		139,
		153,
		165,
		173,
		163,
		161,
		155,
		187,
		-1,
		169,
		168,
		157,
		154,
		130,
		121,
		116,
		143,
		-1,
		-1,
		92,
		108,
		121,
		125,
		138,
		163,
		-1,
		81,
		-1,
		-1,
		149,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		147,
		158,
		180,
		169,
		170,
		160,
		170,
		183,
		153,
		150,
		138,
		136,
		159,
		124,
		112,
		-1,
		107,
		95,
		101,
		108,
		125,
		152,
		-1,
		-1,
		97,
		88,
		-1,
		-1,
		168,
		175,
		177,
		-1,
		167,
		140,
		145,
		170,
		177,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		162,
		176,
		165,
		161,
		160,
		168,
		117,
		110,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		132,
		107,
		-1,
		-1,
		175,
		178,
		166,
		154,
		144,
		154,
		162,
		162,
		165,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		196,
		-1,
		148,
		116,
		136,
		151,
		159,
		-1,
		-1,
		-1,
		149,
		135,
		128,
		116,
		114,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		134,
		137,
		-1,
		-1,
		161,
		180,
		-1,
		140,
		129,
		114,
		106,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		141,
		144,
		149,
		-1,
		170,
		-1,
		164,
		-1,
		109,
		125,
		127,
		-1,
		-1,
		-1,
		193,
		156,
		177,
		187,
		192,
		190,
		181,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		190,
		164,
		171,
		162,
		145,
		125,
		117,
		142,
		-1,
		181,
		-1,
		156,
		157,
		184,
		186,
		203,
		197,
		181,
		196,
		186,
		177,
		186,
		196,
		-1,
		166,
		199,
		163,
		131,
		131,
		130,
		195,
		-1,
		178,
		160,
		-1,
		188,
		178,
		220,
		201,
		194,
		181,
		188,
		190,
		183,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		151,
		136,
		131,
		-1,
		183,
		165,
		151,
		168,
		168,
		159,
		167,
		210,
		206,
		199,
		201,
		191,
		-1,
		268,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		171,
		144,
		132,
		146,
		153,
		148,
		150,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		190,
		222,
		-1,
		275,
		-1,
		198,
		-1,
		-1,
		178,
		164,
		166,
		155,
		144,
		142,
		145,
		143,
		165,
		195,
		181,
		179,
		184,
		189,
		-1,
		266,
		265,
		-1,
		197,
		189,
		175,
		-1,
		168,
		-1,
		190,
		151,
		-1,
		172,
		152,
		-1,
		190,
		186,
		-1,
		-1,
		253,
		213,
		-1,
		-1,
		-1,
		198,
		178,
		185,
		169,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		191,
		194,
		-1,
		185,
		191,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		206,
		211,
		199,
		216,
		202,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		219,
		211,
		211,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		230,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		251,
		252,
		276,
		251,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		254,
		252,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		231,
		220,
		231,
		239,
		212,
		219,
		-1,
		240,
		242,
		208,
		202,
		241,
		212,
		218,
		229,
		-1,
		-1,
		-1,
		231,
		230,
		200,
		198,
		207,
		212,
		219,
		-1,
		242,
		-1,
		252,
		231,
		242,
		247,
		193,
		190,
		210,
		229,
		235,
		227,
		267,
		223,
		194,
		188,
		206,
		211,
		229,
		221,
		-1,
		194,
		184,
		206,
		210,
		222,
		205,
		-1,
		-1,
		188,
		189,
		195,
		207,
		212,
		217,
		-1,
		240,
		224,
		-1,
		-1,
		178,
		191,
		187,
		190,
		198,
		214,
		232,
		224,
		219,
		-1,
		-1,
		179,
		183,
		196,
		197,
		195,
		219,
		232,
		214,
		228,
		227,
		-1,
		167,
		185,
		194,
		203,
		209,
		195,
		193,
		211,
		213,
		219,
		222,
		-1,
		159,
		161,
		190,
		196,
		208,
		211,
		198,
		198,
		208,
		201,
		220,
		211,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		164,
		190,
		189,
		185,
		203,
		208,
		201,
		198,
		196,
		193,
		209,
		210,
		220,
		-1,
		-1,
		212,
		181,
		216,
		173,
		158,
		-1,
		152,
		171,
		177,
		181,
		186,
		191,
		205,
		201,
		-1,
		187,
		186,
		217,
		203,
		214,
		172,
		-1,
		-1,
		170,
		162,
		147,
		150,
		147,
		147,
		177,
		176,
		181,
		183,
		182,
		188,
		191,
		191,
		197,
		181,
		191,
		195,
		203,
		221,
		-1,
		-1,
		263,
		-1,
		-1,
		169,
		152,
		-1,
		135,
		142,
		142,
		159,
		149,
		170,
		185,
		189,
		197,
		196,
		184,
		186,
		183,
		196,
		184,
		178,
		203,
		207,
		198,
		219,
		214,
		-1,
		262,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		128,
		131,
		137,
		161,
		171,
		-1,
		192,
		190,
		214,
		205,
		202,
		189,
		177,
		190,
		175,
		182,
		181,
		185,
		187,
		220,
		195,
		217,
		214,
		233,
		238,
		232,
		241,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		165,
		-1,
		179,
		192,
		196,
		194,
		197,
		206,
		197,
		184,
		173,
		184,
		173,
		170,
		178,
		184,
		198,
		190,
		189,
		207,
		217,
		225,
		229,
		235,
		-1,
		227,
		-1,
		169,
		153,
		155,
		127,
		148,
		-1,
		185,
		180,
		200,
		198,
		189,
		-1,
		192,
		195,
		202,
		180,
		165,
		182,
		174,
		172,
		177,
		179,
		193,
		184,
		202,
		209,
		207,
		211,
		231,
		243,
		187,
		177,
		-1,
		159,
		164,
		123,
		131,
		150,
		223,
		195,
		-1,
		190,
		-1,
		182,
		207,
		-1,
		186,
		182,
		164,
		165,
		160,
		175,
		181,
		175,
		172,
		190,
		193,
		200,
		204,
		220,
		-1,
		-1,
		172,
		176,
		165,
		116,
		135,
		159,
		196,
		188,
		177,
		176,
		-1,
		167,
		197,
		194,
		180,
		167,
		157,
		158,
		166,
		179,
		158,
		174,
		171,
		191,
		217,
		195,
		206,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		142,
		113,
		137,
		179,
		206,
		199,
		187,
		152,
		152,
		146,
		-1,
		187,
		170,
		166,
		155,
		153,
		166,
		161,
		177,
		169,
		167,
		186,
		198,
		189,
		197,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		108,
		131,
		168,
		185,
		171,
		176,
		151,
		144,
		138,
		190,
		187,
		154,
		162,
		154,
		143,
		157,
		165,
		169,
		165,
		174,
		180,
		204,
		185,
		191,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		122,
		129,
		161,
		176,
		173,
		-1,
		143,
		-1,
		132,
		140,
		139,
		145,
		157,
		143,
		148,
		159,
		171,
		172,
		167,
		174,
		209,
		209,
		175,
		195,
		198,
		-1,
		-1,
		-1,
		172,
		167,
		142,
		119,
		103,
		139,
		-1,
		143,
		144,
		-1,
		137,
		131,
		137,
		136,
		143,
		140,
		140,
		154,
		162,
		158,
		174,
		177,
		159,
		183,
		-1,
		183,
		177,
		185,
		175,
		163,
		-1,
		-1,
		-1,
		165,
		144,
		137,
		157,
		98,
		150,
		-1,
		-1,
		128,
		121,
		-1,
		124,
		124,
		131,
		140,
		145,
		150,
		158,
		153,
		166,
		170,
		164,
		158,
		171,
		175,
		176,
		165,
		161,
		158,
		172,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		118,
		-1,
		136,
		128,
		119,
		113,
		119,
		137,
		135,
		155,
		147,
		161,
		161,
		167,
		173,
		159,
		152,
		163,
		148,
		166,
		172,
		163,
		158,
		157,
		168,
		-1,
		185,
		171,
		142,
		-1,
		-1,
		131,
		-1,
		95,
		114,
		130,
		-1,
		153,
		132,
		155,
		133,
		147,
		143,
		181,
		182,
		160,
		165,
		173,
		161,
		164,
		153,
		156,
		148,
		170,
		167,
		151,
		153,
		162,
		-1,
		191,
		178,
		136,
		132,
		121,
		141,
		92,
		101,
		117,
		-1,
		-1,
		191,
		-1,
		131,
		147,
		157,
		155,
		171,
		160,
		167,
		184,
		158,
		153,
		158,
		147,
		147,
		142,
		161,
		147,
		145,
		160,
		176,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		107,
		94,
		88,
		-1,
		134,
		-1,
		169,
		157,
		144,
		126,
		166,
		-1,
		159,
		155,
		162,
		-1,
		178,
		-1,
		150,
		153,
		144,
		139,
		136,
		147,
		145,
		154,
		155,
		-1,
		141,
		126,
		119,
		109,
		123,
		91,
		-1,
		125,
		-1,
		-1,
		156,
		150,
		150,
		119,
		116,
		175,
		155,
		147,
		162,
		161,
		148,
		147,
		135,
		135,
		138,
		132,
		145,
		155,
		161,
		153,
		-1,
		-1,
		-1,
		146,
		121,
		115,
		87,
		91,
		-1,
		-1,
		217,
		173,
		159,
		-1,
		111,
		175,
		163,
		153,
		143,
		148,
		149,
		139,
		137,
		133,
		142,
		141,
		134,
		133,
		154,
		147,
		169,
		-1,
		-1,
		120,
		113,
		101,
		69,
		64,
		-1,
		-1,
		-1,
		163,
		149,
		137,
		109,
		164,
		-1,
		-1,
		147,
		140,
		134,
		132,
		125,
		145,
		152,
		140,
		127,
		142,
		152,
		160,
		159,
		-1,
		123,
		110,
		-1,
		-1,
		63,
		53,
		-1,
		-1,
		-1,
		-1,
		127,
		108,
		120,
		130,
		134,
		146,
		-1,
		119,
		123,
		123,
		143,
		150,
		142,
		127,
		121,
		132,
		147,
		164,
		-1,
		-1,
		77,
		-1,
		39,
		-1,
		-1,
		-1,
		-1,
		99,
		114,
		123,
		116,
		120,
		-1,
		117,
		116,
		120,
		126,
		138,
		142,
		133,
		115,
		129,
		132,
		145,
		159,
		163,
		100,
		-1,
		30,
		-1,
		-1,
		-1,
		76,
		106,
		156,
		133,
		112,
		105,
		102,
		108,
		112,
		124,
		133,
		144,
		109,
		113,
		128,
		133,
		137,
		154,
		158,
		-1,
		-1,
		28,
		24,
		59,
		71,
		97,
		183,
		-1,
		-1,
		101,
		94,
		104,
		104,
		117,
		120,
		105,
		107,
		125,
		138,
		132,
		142,
		157,
		152,
		-1,
		-1,
		-1,
		40,
		-1,
		41,
		-1,
		-1,
		87,
		174,
		121,
		103,
		99,
		85,
		99,
		93,
		95,
		100,
		119,
		114,
		123,
		128,
		132,
		155,
		144,
		183,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		69,
		11,
		0,
		66,
		71,
		62,
		136,
		133,
		-1,
		81,
		122,
		90,
		104,
		100,
		107,
		112,
		118,
		122,
		129,
		145,
		144,
		139,
		175,
		166,
		172,
		-1,
		-1,
		210,
		199,
		188,
		194,
		-1,
		66,
		5,
		52,
		42,
		48,
		-1,
		-1,
		95,
		92,
		95,
		82,
		88,
		93,
		96,
		134,
		110,
		118,
		122,
		126,
		132,
		137,
		142,
		148,
		163,
		178,
		-1,
		164,
		201,
		194,
		162,
		170,
		201,
		-1,
		56,
		48,
		14,
		34,
		42,
		-1,
		-1,
		68,
		64,
		69,
		78,
		81,
		117,
		116,
		129,
		132,
		137,
		125,
		124,
		142,
		146,
		155,
		162,
		152,
		165,
		169,
		-1,
		157,
		177,
		156,
		159,
		183,
		197,
		-1,
		53,
		-1,
		-1,
		37,
		55,
		63,
		59,
		63,
		116,
		92,
		87,
		100,
		102,
		126,
		117,
		142,
		133,
		133,
		136,
		151,
		156,
		148,
		162,
		162,
		163,
		-1,
		146,
		157,
		150,
		-1,
		-1,
		-1,
		-1,
		54,
		-1,
		-1,
		53,
		-1,
		89,
		-1,
		82,
		86,
		100,
		103,
		125,
		112,
		119,
		136,
		142,
		131,
		141,
		137,
		138,
		147,
		158,
		170,
		169,
		170,
		171,
		127,
		130,
		141,
		152,
		167,
		171,
		-1,
		65,
		104,
		91,
		-1,
		62,
		-1,
		-1,
		-1,
		96,
		113,
		105,
		121,
		124,
		124,
		120,
		124,
		136,
		143,
		153,
		155,
		147,
		151,
		164,
		175,
		178,
		167,
		158,
		171,
		116,
		116,
		137,
		146,
		167,
		80,
		71,
		98,
		98,
		87,
		82,
		69,
		-1,
		-1,
		119,
		123,
		-1,
		-1,
		131,
		141,
		124,
		126,
		130,
		144,
		156,
		164,
		154,
		152,
		146,
		178,
		-1,
		160,
		159,
		148,
		145,
		121,
		112,
		107,
		134,
		-1,
		-1,
		83,
		99,
		112,
		116,
		129,
		154,
		-1,
		72,
		-1,
		-1,
		140,
		-1,
		-1,
		183,
		146,
		135,
		126,
		132,
		138,
		149,
		171,
		160,
		161,
		151,
		161,
		174,
		144,
		141,
		129,
		127,
		150,
		115,
		103,
		-1,
		98,
		86,
		92,
		99,
		116,
		143,
		-1,
		-1,
		88,
		79,
		-1,
		-1,
		159,
		166,
		168,
		-1,
		158,
		131,
		136,
		161,
		168,
		169,
		163,
		157,
		164,
		163,
		171,
		179,
		153,
		167,
		156,
		152,
		151,
		159,
		108,
		101,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		123,
		98,
		-1,
		-1,
		166,
		169,
		157,
		145,
		135,
		145,
		153,
		153,
		156,
		160,
		155,
		166,
		158,
		162,
		179,
		-1,
		187,
		-1,
		139,
		107,
		127,
		142,
		150,
		-1,
		-1,
		-1,
		140,
		126,
		119,
		107,
		105,
		-1,
		210,
		194,
		175,
		-1,
		145,
		158,
		189,
		157,
		162,
		157,
		161,
		172,
		161,
		164,
		178,
		173,
		-1,
		-1,
		125,
		128,
		-1,
		-1,
		152,
		171,
		-1,
		131,
		120,
		105,
		97,
		-1,
		-1,
		182,
		178,
		-1,
		-1,
		146,
		171,
		160,
		168,
		163,
		165,
		171,
		174,
		163,
		167,
		179,
		-1,
		-1,
		132,
		135,
		140,
		-1,
		161,
		-1,
		155,
		-1,
		100,
		116,
		118,
		-1,
		-1,
		-1,
		184,
		147,
		168,
		178,
		183,
		181,
		172,
		169,
		176,
		174,
		170,
		181,
		-1,
		-1,
		-1,
		181,
		155,
		162,
		153,
		136,
		116,
		108,
		133,
		-1,
		172,
		-1,
		147,
		148,
		175,
		177,
		194,
		188,
		172,
		187,
		177,
		168,
		177,
		187,
		-1,
		157,
		190,
		154,
		122,
		122,
		121,
		186,
		-1,
		169,
		151,
		-1,
		179,
		169,
		211,
		192,
		185,
		172,
		179,
		181,
		174,
		-1,
		-1,
		-1,
		159,
		158,
		150,
		144,
		142,
		127,
		122,
		-1,
		174,
		156,
		142,
		159,
		159,
		150,
		158,
		201,
		197,
		190,
		192,
		182,
		-1,
		259,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		153,
		162,
		135,
		123,
		137,
		144,
		139,
		141,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		181,
		213,
		-1,
		266,
		-1,
		189,
		-1,
		-1,
		169,
		155,
		157,
		146,
		135,
		133,
		136,
		134,
		156,
		186,
		172,
		170,
		175,
		180,
		-1,
		257,
		256,
		-1,
		188,
		180,
		166,
		-1,
		159,
		-1,
		181,
		142,
		-1,
		163,
		143,
		-1,
		181,
		177,
		-1,
		-1,
		244,
		204,
		-1,
		-1,
		-1,
		189,
		169,
		176,
		160,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		229,
		213,
		-1,
		182,
		185,
		-1,
		176,
		182,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		238,
		219,
		213,
		197,
		202,
		190,
		207,
		193,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		210,
		202,
		202,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		221,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		242,
		243,
		267,
		242,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		245,
		243,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		283,
		272,
		283,
		291,
		264,
		271,
		-1,
		292,
		294,
		260,
		254,
		293,
		264,
		270,
		281,
		-1,
		-1,
		-1,
		283,
		282,
		252,
		250,
		259,
		264,
		271,
		-1,
		273,
		-1,
		304,
		283,
		294,
		299,
		245,
		242,
		262,
		281,
		266,
		258,
		319,
		275,
		246,
		240,
		258,
		251,
		260,
		252,
		-1,
		246,
		236,
		258,
		240,
		251,
		243,
		-1,
		-1,
		240,
		241,
		247,
		236,
		242,
		238,
		-1,
		248,
		232,
		-1,
		-1,
		230,
		234,
		218,
		221,
		229,
		227,
		240,
		232,
		227,
		-1,
		-1,
		224,
		220,
		227,
		214,
		210,
		227,
		240,
		222,
		236,
		235,
		-1,
		219,
		237,
		246,
		221,
		219,
		203,
		201,
		219,
		221,
		227,
		227,
		-1,
		211,
		213,
		235,
		243,
		243,
		219,
		206,
		206,
		216,
		209,
		228,
		216,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		208,
		216,
		239,
		231,
		221,
		236,
		229,
		209,
		206,
		204,
		201,
		217,
		215,
		225,
		-1,
		-1,
		264,
		233,
		268,
		225,
		210,
		-1,
		204,
		215,
		221,
		225,
		219,
		212,
		226,
		222,
		-1,
		195,
		194,
		222,
		208,
		219,
		224,
		-1,
		-1,
		222,
		214,
		199,
		202,
		199,
		199,
		229,
		228,
		221,
		207,
		203,
		209,
		212,
		212,
		218,
		189,
		199,
		203,
		201,
		226,
		-1,
		-1,
		261,
		-1,
		-1,
		221,
		204,
		-1,
		187,
		194,
		194,
		211,
		201,
		222,
		237,
		231,
		223,
		217,
		205,
		207,
		204,
		217,
		205,
		186,
		211,
		215,
		196,
		217,
		212,
		-1,
		260,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		180,
		183,
		189,
		213,
		223,
		-1,
		244,
		240,
		241,
		226,
		223,
		210,
		198,
		211,
		196,
		203,
		202,
		190,
		188,
		218,
		193,
		215,
		212,
		231,
		236,
		230,
		239,
		-1,
		229,
		225,
		221,
		228,
		177,
		-1,
		-1,
		217,
		-1,
		231,
		244,
		248,
		237,
		240,
		227,
		218,
		205,
		194,
		205,
		194,
		191,
		199,
		182,
		197,
		188,
		187,
		205,
		215,
		223,
		227,
		233,
		-1,
		279,
		-1,
		221,
		205,
		207,
		179,
		200,
		-1,
		237,
		232,
		252,
		250,
		241,
		-1,
		236,
		233,
		223,
		201,
		186,
		203,
		195,
		193,
		195,
		177,
		191,
		182,
		200,
		207,
		205,
		209,
		229,
		241,
		239,
		229,
		-1,
		211,
		216,
		175,
		183,
		202,
		275,
		247,
		-1,
		242,
		-1,
		234,
		251,
		-1,
		207,
		203,
		185,
		186,
		181,
		196,
		188,
		173,
		170,
		188,
		191,
		198,
		202,
		218,
		-1,
		-1,
		224,
		228,
		217,
		168,
		187,
		211,
		248,
		240,
		229,
		228,
		-1,
		219,
		221,
		218,
		206,
		193,
		178,
		179,
		187,
		199,
		178,
		172,
		169,
		189,
		215,
		193,
		204,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		194,
		165,
		189,
		231,
		258,
		251,
		239,
		204,
		204,
		198,
		-1,
		217,
		196,
		187,
		176,
		174,
		187,
		179,
		187,
		167,
		165,
		184,
		196,
		187,
		195,
		-1,
		-1,
		-1,
		224,
		213,
		214,
		160,
		183,
		220,
		237,
		223,
		228,
		203,
		196,
		190,
		230,
		213,
		194,
		183,
		175,
		164,
		175,
		183,
		181,
		163,
		172,
		178,
		202,
		183,
		189,
		-1,
		-1,
		231,
		221,
		205,
		207,
		204,
		174,
		181,
		213,
		228,
		225,
		-1,
		195,
		-1,
		184,
		192,
		188,
		183,
		180,
		167,
		166,
		180,
		180,
		170,
		165,
		172,
		207,
		207,
		173,
		193,
		196,
		-1,
		-1,
		-1,
		224,
		219,
		194,
		171,
		155,
		191,
		-1,
		195,
		196,
		-1,
		189,
		183,
		189,
		188,
		186,
		171,
		175,
		177,
		180,
		168,
		174,
		175,
		157,
		181,
		-1,
		181,
		175,
		183,
		173,
		161,
		-1,
		-1,
		-1,
		217,
		196,
		189,
		209,
		150,
		202,
		-1,
		-1,
		180,
		173,
		-1,
		176,
		176,
		183,
		176,
		170,
		176,
		172,
		162,
		175,
		168,
		162,
		156,
		169,
		173,
		174,
		163,
		159,
		156,
		170,
		-1,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		170,
		-1,
		188,
		180,
		171,
		165,
		171,
		189,
		187,
		198,
		182,
		185,
		180,
		176,
		167,
		157,
		150,
		161,
		146,
		164,
		170,
		161,
		156,
		155,
		166,
		-1,
		237,
		223,
		194,
		-1,
		-1,
		183,
		-1,
		147,
		166,
		182,
		-1,
		205,
		184,
		207,
		185,
		193,
		195,
		189,
		190,
		160,
		165,
		167,
		155,
		158,
		151,
		154,
		146,
		168,
		165,
		149,
		151,
		160,
		-1,
		243,
		230,
		188,
		184,
		173,
		193,
		144,
		153,
		169,
		-1,
		-1,
		217,
		-1,
		171,
		173,
		209,
		207,
		179,
		154,
		161,
		179,
		152,
		147,
		156,
		145,
		143,
		140,
		159,
		145,
		143,
		158,
		174,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		159,
		146,
		140,
		-1,
		186,
		-1,
		195,
		183,
		170,
		152,
		192,
		-1,
		153,
		149,
		156,
		-1,
		172,
		-1,
		144,
		147,
		138,
		135,
		134,
		145,
		143,
		152,
		153,
		-1,
		193,
		178,
		171,
		161,
		175,
		143,
		-1,
		177,
		-1,
		-1,
		182,
		176,
		176,
		145,
		142,
		169,
		149,
		141,
		156,
		155,
		142,
		141,
		129,
		129,
		132,
		130,
		143,
		153,
		159,
		151,
		-1,
		-1,
		-1,
		198,
		173,
		167,
		139,
		143,
		-1,
		-1,
		243,
		199,
		185,
		-1,
		137,
		169,
		157,
		147,
		137,
		142,
		143,
		133,
		131,
		127,
		136,
		139,
		132,
		131,
		152,
		145,
		167,
		-1,
		-1,
		172,
		165,
		153,
		121,
		116,
		-1,
		-1,
		-1,
		189,
		175,
		163,
		135,
		158,
		-1,
		-1,
		141,
		134,
		128,
		126,
		119,
		139,
		146,
		138,
		125,
		140,
		150,
		158,
		157,
		-1,
		175,
		162,
		-1,
		-1,
		115,
		105,
		-1,
		-1,
		-1,
		-1,
		153,
		134,
		129,
		124,
		128,
		140,
		-1,
		113,
		117,
		117,
		137,
		144,
		140,
		125,
		119,
		130,
		145,
		162,
		-1,
		-1,
		129,
		-1,
		91,
		-1,
		-1,
		-1,
		-1,
		125,
		140,
		117,
		110,
		114,
		-1,
		111,
		110,
		114,
		120,
		133,
		138,
		131,
		113,
		127,
		130,
		143,
		157,
		161,
		152,
		-1,
		82,
		-1,
		-1,
		-1,
		117,
		118,
		150,
		127,
		106,
		99,
		96,
		102,
		106,
		122,
		128,
		139,
		107,
		111,
		126,
		131,
		135,
		152,
		156,
		-1,
		-1,
		80,
		76,
		111,
		123,
		91,
		177,
		-1,
		-1,
		95,
		88,
		98,
		102,
		112,
		115,
		103,
		105,
		123,
		136,
		130,
		140,
		155,
		150,
		-1,
		-1,
		-1,
		92,
		-1,
		94,
		-1,
		-1,
		81,
		168,
		115,
		97,
		93,
		79,
		97,
		91,
		93,
		98,
		117,
		112,
		121,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		215,
		-1,
		-1,
		-1,
		71,
		63,
		57,
		0,
		65,
		56,
		130,
		127,
		-1,
		75,
		118,
		88,
		102,
		98,
		105,
		110,
		116,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		208,
		197,
		186,
		192,
		-1,
		64,
		60,
		7,
		17,
		42,
		-1,
		-1,
		92,
		89,
		93,
		80,
		86,
		91,
		94,
		132,
		108,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		162,
		199,
		192,
		160,
		168,
		199,
		-1,
		54,
		46,
		56,
		32,
		36,
		-1,
		-1,
		65,
		62,
		67,
		76,
		79,
		115,
		114,
		127,
		130,
		135,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		155,
		175,
		154,
		157,
		181,
		195,
		-1,
		51,
		-1,
		-1,
		63,
		49,
		57,
		57,
		61,
		114,
		90,
		85,
		98,
		100,
		124,
		115,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		144,
		155,
		148,
		-1,
		-1,
		-1,
		-1,
		52,
		-1,
		-1,
		79,
		-1,
		83,
		-1,
		76,
		80,
		98,
		101,
		123,
		110,
		117,
		134,
		140,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		169,
		125,
		128,
		139,
		150,
		165,
		169,
		-1,
		63,
		102,
		117,
		-1,
		88,
		-1,
		-1,
		-1,
		90,
		111,
		103,
		119,
		122,
		122,
		118,
		122,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		165,
		156,
		169,
		114,
		114,
		135,
		144,
		165,
		78,
		69,
		96,
		124,
		113,
		108,
		95,
		-1,
		-1,
		113,
		121,
		-1,
		-1,
		129,
		139,
		122,
		124,
		128,
		142,
		154,
		162,
		152,
		150,
		144,
		176,
		-1,
		158,
		157,
		146,
		143,
		119,
		110,
		105,
		132,
		-1,
		-1,
		81,
		97,
		110,
		114,
		130,
		155,
		-1,
		98,
		-1,
		-1,
		134,
		-1,
		-1,
		181,
		144,
		133,
		124,
		130,
		136,
		147,
		169,
		158,
		159,
		149,
		159,
		172,
		142,
		139,
		127,
		125,
		148,
		113,
		101,
		-1,
		96,
		84,
		90,
		97,
		114,
		144,
		-1,
		-1,
		114,
		105,
		-1,
		-1,
		153,
		160,
		166,
		-1,
		156,
		129,
		134,
		159,
		166,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		151,
		165,
		154,
		150,
		149,
		157,
		106,
		99,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		124,
		-1,
		-1,
		160,
		167,
		155,
		143,
		133,
		143,
		151,
		151,
		154,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		185,
		-1,
		137,
		105,
		125,
		140,
		148,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		208,
		192,
		173,
		-1,
		143,
		156,
		187,
		155,
		160,
		155,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		123,
		126,
		-1,
		-1,
		150,
		169,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		180,
		176,
		-1,
		-1,
		144,
		169,
		158,
		166,
		161,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		130,
		133,
		138,
		-1,
		159,
		-1,
		181,
		-1,
		126,
		142,
		144,
		-1,
		-1,
		-1,
		182,
		145,
		166,
		176,
		181,
		179,
		170,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		189,
		166,
		188,
		179,
		162,
		142,
		134,
		159,
		-1,
		170,
		-1,
		145,
		146,
		173,
		175,
		192,
		186,
		170,
		185,
		175,
		166,
		175,
		195,
		-1,
		170,
		216,
		180,
		148,
		148,
		147,
		191,
		-1,
		167,
		149,
		-1,
		177,
		167,
		209,
		190,
		183,
		170,
		177,
		179,
		172,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		168,
		153,
		148,
		-1,
		179,
		161,
		140,
		157,
		157,
		148,
		156,
		199,
		195,
		188,
		190,
		180,
		-1,
		257,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		188,
		161,
		149,
		162,
		158,
		144,
		150,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		179,
		211,
		-1,
		264,
		-1,
		215,
		-1,
		-1,
		195,
		181,
		183,
		172,
		161,
		159,
		157,
		148,
		170,
		186,
		170,
		168,
		173,
		178,
		-1,
		274,
		275,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		207,
		168,
		-1,
		177,
		157,
		-1,
		179,
		175,
		-1,
		-1,
		270,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		202,
		186,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		255,
		239,
		-1,
		208,
		211,
		-1,
		202,
		208,
		223,
		170,
		174,
		-1,
		-1,
		-1,
		264,
		245,
		239,
		223,
		228,
		216,
		233,
		219,
		206,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		236,
		228,
		228,
		-1,
		-1,
		231,
		214,
		195,
		193,
		-1,
		-1,
		-1,
		258,
		239,
		-1,
		-1,
		221,
		-1,
		-1,
		227,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		247,
		-1,
		-1,
		-1,
		217,
		213,
		214,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		293,
		265,
		-1,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		271,
		269,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		207,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		242,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		255,
		247,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		270,
		261,
		-1,
		-1,
		232,
		239,
		261,
		264,
		300,
		-1,
		251
	],
	[
		-1,
		264,
		253,
		264,
		272,
		245,
		252,
		-1,
		273,
		275,
		241,
		235,
		274,
		245,
		251,
		262,
		-1,
		-1,
		-1,
		264,
		263,
		233,
		231,
		240,
		245,
		252,
		-1,
		256,
		-1,
		285,
		264,
		275,
		280,
		226,
		223,
		243,
		262,
		249,
		241,
		300,
		256,
		227,
		221,
		239,
		234,
		243,
		235,
		-1,
		227,
		217,
		239,
		223,
		234,
		226,
		-1,
		-1,
		221,
		222,
		228,
		219,
		225,
		221,
		-1,
		231,
		215,
		-1,
		-1,
		211,
		217,
		201,
		204,
		212,
		210,
		223,
		215,
		210,
		-1,
		-1,
		207,
		203,
		210,
		197,
		193,
		210,
		223,
		205,
		219,
		218,
		-1,
		200,
		218,
		227,
		204,
		202,
		186,
		184,
		202,
		204,
		210,
		213,
		-1,
		193,
		195,
		205,
		213,
		218,
		202,
		189,
		189,
		199,
		192,
		211,
		202,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		190,
		192,
		209,
		201,
		191,
		206,
		199,
		192,
		189,
		187,
		184,
		200,
		201,
		211,
		-1,
		-1,
		246,
		215,
		250,
		207,
		192,
		-1,
		186,
		185,
		191,
		195,
		189,
		182,
		196,
		192,
		-1,
		178,
		177,
		208,
		194,
		205,
		206,
		-1,
		-1,
		204,
		196,
		181,
		184,
		181,
		181,
		200,
		199,
		191,
		177,
		173,
		179,
		182,
		182,
		188,
		172,
		182,
		186,
		193,
		212,
		-1,
		-1,
		253,
		-1,
		-1,
		203,
		186,
		-1,
		169,
		176,
		176,
		193,
		183,
		204,
		210,
		201,
		193,
		187,
		175,
		177,
		174,
		187,
		175,
		169,
		194,
		198,
		188,
		209,
		204,
		-1,
		252,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		162,
		165,
		171,
		195,
		205,
		-1,
		195,
		201,
		211,
		196,
		193,
		180,
		168,
		181,
		166,
		173,
		172,
		176,
		178,
		210,
		185,
		207,
		204,
		223,
		228,
		222,
		231,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		199,
		-1,
		213,
		212,
		187,
		205,
		208,
		197,
		188,
		175,
		164,
		175,
		164,
		161,
		169,
		174,
		189,
		180,
		179,
		197,
		207,
		215,
		219,
		225,
		-1,
		261,
		-1,
		203,
		187,
		189,
		161,
		182,
		-1,
		219,
		214,
		204,
		189,
		180,
		-1,
		183,
		186,
		193,
		171,
		156,
		173,
		165,
		163,
		168,
		169,
		183,
		174,
		192,
		199,
		197,
		201,
		221,
		233,
		221,
		211,
		-1,
		193,
		198,
		157,
		165,
		184,
		222,
		186,
		-1,
		181,
		-1,
		173,
		198,
		-1,
		177,
		173,
		155,
		156,
		151,
		166,
		172,
		165,
		162,
		180,
		183,
		190,
		194,
		210,
		-1,
		-1,
		206,
		210,
		199,
		150,
		169,
		193,
		230,
		179,
		168,
		167,
		-1,
		158,
		188,
		185,
		171,
		158,
		148,
		149,
		157,
		170,
		149,
		164,
		161,
		181,
		207,
		185,
		197,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		176,
		147,
		171,
		213,
		197,
		190,
		178,
		143,
		143,
		137,
		-1,
		178,
		161,
		157,
		146,
		144,
		157,
		152,
		168,
		159,
		157,
		176,
		188,
		179,
		190,
		-1,
		-1,
		-1,
		206,
		195,
		196,
		142,
		165,
		202,
		176,
		162,
		167,
		142,
		135,
		129,
		181,
		178,
		145,
		153,
		145,
		134,
		148,
		156,
		160,
		155,
		164,
		170,
		194,
		178,
		184,
		-1,
		-1,
		213,
		203,
		187,
		189,
		186,
		156,
		163,
		195,
		167,
		180,
		-1,
		134,
		-1,
		123,
		131,
		130,
		136,
		148,
		134,
		139,
		150,
		162,
		162,
		157,
		164,
		199,
		199,
		168,
		188,
		191,
		-1,
		-1,
		-1,
		206,
		201,
		176,
		153,
		137,
		173,
		-1,
		150,
		151,
		-1,
		128,
		122,
		128,
		127,
		134,
		131,
		131,
		145,
		153,
		149,
		165,
		167,
		149,
		173,
		-1,
		176,
		170,
		178,
		168,
		156,
		-1,
		-1,
		-1,
		199,
		178,
		171,
		191,
		132,
		184,
		-1,
		-1,
		135,
		128,
		-1,
		115,
		115,
		122,
		131,
		136,
		141,
		149,
		144,
		157,
		160,
		154,
		148,
		161,
		165,
		169,
		158,
		154,
		151,
		165,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		152,
		-1,
		144,
		136,
		126,
		120,
		114,
		125,
		126,
		146,
		138,
		152,
		152,
		158,
		159,
		149,
		142,
		153,
		138,
		156,
		164,
		156,
		150,
		149,
		161,
		-1,
		219,
		205,
		176,
		-1,
		-1,
		165,
		-1,
		129,
		143,
		159,
		-1,
		152,
		131,
		146,
		124,
		128,
		134,
		172,
		173,
		151,
		156,
		159,
		147,
		150,
		143,
		146,
		138,
		160,
		160,
		144,
		145,
		154,
		-1,
		225,
		212,
		170,
		166,
		155,
		175,
		126,
		114,
		146,
		-1,
		-1,
		152,
		-1,
		106,
		108,
		148,
		146,
		162,
		146,
		153,
		171,
		144,
		139,
		148,
		137,
		135,
		132,
		154,
		140,
		138,
		155,
		171,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		141,
		128,
		122,
		-1,
		163,
		-1,
		130,
		118,
		105,
		87,
		127,
		-1,
		145,
		141,
		148,
		-1,
		164,
		-1,
		136,
		139,
		130,
		127,
		126,
		137,
		135,
		146,
		150,
		-1,
		175,
		160,
		153,
		143,
		157,
		128,
		-1,
		182,
		-1,
		-1,
		117,
		111,
		111,
		80,
		77,
		161,
		141,
		133,
		148,
		147,
		134,
		133,
		121,
		121,
		124,
		127,
		140,
		150,
		153,
		148,
		-1,
		-1,
		-1,
		180,
		166,
		170,
		130,
		148,
		-1,
		-1,
		178,
		134,
		120,
		-1,
		72,
		160,
		149,
		139,
		129,
		134,
		135,
		125,
		123,
		119,
		128,
		132,
		129,
		128,
		149,
		142,
		164,
		-1,
		-1,
		163,
		168,
		156,
		126,
		121,
		-1,
		-1,
		-1,
		124,
		110,
		98,
		70,
		148,
		-1,
		-1,
		133,
		126,
		120,
		118,
		111,
		131,
		138,
		135,
		122,
		137,
		147,
		155,
		154,
		-1,
		166,
		153,
		-1,
		-1,
		120,
		110,
		-1,
		-1,
		-1,
		-1,
		88,
		69,
		81,
		102,
		120,
		132,
		-1,
		105,
		109,
		109,
		129,
		136,
		137,
		122,
		116,
		127,
		142,
		159,
		-1,
		-1,
		134,
		-1,
		96,
		-1,
		-1,
		-1,
		-1,
		60,
		75,
		95,
		101,
		106,
		-1,
		103,
		102,
		106,
		112,
		125,
		130,
		128,
		110,
		124,
		127,
		140,
		154,
		158,
		157,
		-1,
		87,
		-1,
		-1,
		-1,
		52,
		53,
		142,
		119,
		98,
		91,
		88,
		94,
		98,
		114,
		120,
		131,
		104,
		108,
		123,
		128,
		132,
		149,
		153,
		-1,
		-1,
		85,
		81,
		78,
		60,
		26,
		169,
		-1,
		-1,
		87,
		80,
		90,
		99,
		104,
		107,
		100,
		102,
		120,
		133,
		127,
		137,
		152,
		147,
		-1,
		-1,
		-1,
		97,
		-1,
		99,
		-1,
		-1,
		16,
		160,
		107,
		89,
		85,
		71,
		94,
		88,
		90,
		95,
		114,
		109,
		118,
		123,
		127,
		150,
		139,
		178,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		76,
		68,
		62,
		65,
		0,
		7,
		122,
		119,
		-1,
		67,
		110,
		85,
		99,
		95,
		102,
		107,
		113,
		117,
		124,
		140,
		139,
		134,
		170,
		161,
		167,
		-1,
		-1,
		213,
		202,
		191,
		197,
		-1,
		69,
		65,
		51,
		41,
		17,
		-1,
		-1,
		84,
		81,
		90,
		77,
		83,
		88,
		91,
		129,
		105,
		113,
		117,
		121,
		127,
		132,
		137,
		143,
		158,
		173,
		-1,
		167,
		204,
		197,
		165,
		173,
		204,
		-1,
		59,
		51,
		61,
		37,
		28,
		-1,
		-1,
		57,
		59,
		64,
		73,
		76,
		112,
		111,
		124,
		127,
		132,
		120,
		119,
		137,
		141,
		150,
		157,
		147,
		160,
		164,
		-1,
		160,
		180,
		159,
		162,
		186,
		200,
		-1,
		56,
		-1,
		-1,
		68,
		41,
		49,
		52,
		56,
		111,
		87,
		82,
		95,
		97,
		121,
		112,
		137,
		128,
		128,
		131,
		146,
		151,
		143,
		157,
		157,
		158,
		-1,
		149,
		160,
		153,
		-1,
		-1,
		-1,
		-1,
		57,
		-1,
		-1,
		84,
		-1,
		75,
		-1,
		68,
		72,
		95,
		98,
		120,
		107,
		114,
		131,
		137,
		126,
		136,
		132,
		133,
		142,
		153,
		165,
		164,
		165,
		174,
		130,
		133,
		144,
		155,
		170,
		174,
		-1,
		68,
		107,
		122,
		-1,
		93,
		-1,
		-1,
		-1,
		82,
		108,
		100,
		116,
		119,
		119,
		115,
		119,
		131,
		138,
		148,
		150,
		142,
		146,
		159,
		170,
		173,
		170,
		161,
		174,
		119,
		119,
		140,
		149,
		170,
		83,
		74,
		101,
		129,
		118,
		113,
		100,
		-1,
		-1,
		105,
		118,
		-1,
		-1,
		126,
		136,
		119,
		121,
		125,
		139,
		151,
		159,
		149,
		147,
		141,
		173,
		-1,
		163,
		162,
		151,
		148,
		124,
		115,
		110,
		137,
		-1,
		-1,
		86,
		102,
		115,
		119,
		135,
		160,
		-1,
		103,
		-1,
		-1,
		126,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		133,
		144,
		166,
		155,
		156,
		146,
		156,
		169,
		147,
		144,
		132,
		130,
		153,
		118,
		106,
		-1,
		101,
		89,
		95,
		102,
		119,
		149,
		-1,
		-1,
		119,
		110,
		-1,
		-1,
		145,
		152,
		163,
		-1,
		153,
		126,
		131,
		156,
		163,
		164,
		158,
		152,
		159,
		158,
		166,
		174,
		156,
		170,
		159,
		155,
		154,
		162,
		111,
		104,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		129,
		-1,
		-1,
		152,
		159,
		152,
		140,
		130,
		140,
		148,
		148,
		151,
		155,
		150,
		161,
		153,
		157,
		174,
		-1,
		190,
		-1,
		142,
		110,
		130,
		145,
		153,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		202,
		186,
		167,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		156,
		167,
		156,
		159,
		173,
		168,
		-1,
		-1,
		128,
		131,
		-1,
		-1,
		155,
		174,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		160,
		166,
		169,
		158,
		162,
		174,
		-1,
		-1,
		135,
		138,
		143,
		-1,
		164,
		-1,
		186,
		-1,
		131,
		147,
		149,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		178,
		176,
		167,
		164,
		171,
		169,
		165,
		176,
		-1,
		-1,
		-1,
		194,
		171,
		193,
		184,
		167,
		147,
		139,
		164,
		-1,
		167,
		-1,
		142,
		143,
		170,
		172,
		189,
		183,
		167,
		182,
		172,
		163,
		172,
		200,
		-1,
		175,
		221,
		185,
		153,
		153,
		152,
		188,
		-1,
		164,
		146,
		-1,
		174,
		164,
		206,
		187,
		180,
		167,
		174,
		176,
		169,
		-1,
		-1,
		-1,
		190,
		189,
		181,
		175,
		173,
		158,
		153,
		-1,
		176,
		158,
		137,
		154,
		154,
		145,
		153,
		196,
		192,
		185,
		187,
		177,
		-1,
		262,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		184,
		192,
		165,
		153,
		159,
		155,
		141,
		147,
		149,
		157,
		155,
		152,
		164,
		160,
		180,
		176,
		208,
		-1,
		269,
		-1,
		220,
		-1,
		-1,
		200,
		186,
		187,
		176,
		165,
		163,
		154,
		145,
		167,
		183,
		167,
		165,
		170,
		175,
		-1,
		279,
		280,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		211,
		172,
		-1,
		174,
		154,
		-1,
		176,
		172,
		-1,
		-1,
		275,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		206,
		190,
		-1,
		165,
		165,
		-1,
		-1,
		-1,
		260,
		244,
		-1,
		213,
		216,
		-1,
		207,
		212,
		220,
		167,
		171,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		228,
		233,
		221,
		233,
		219,
		203,
		181,
		170,
		191,
		-1,
		-1,
		-1,
		241,
		233,
		226,
		-1,
		-1,
		228,
		211,
		192,
		190,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		218,
		-1,
		-1,
		224,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		252,
		-1,
		-1,
		-1,
		214,
		210,
		211,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		298,
		262,
		-1,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		204,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		239,
		-1,
		239,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		252,
		244,
		252,
		-1,
		224,
		226,
		-1,
		274,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		229,
		236,
		258,
		261,
		297,
		-1,
		248
	],
	[
		-1,
		273,
		262,
		273,
		281,
		254,
		261,
		-1,
		280,
		284,
		250,
		244,
		283,
		252,
		258,
		269,
		-1,
		-1,
		-1,
		273,
		272,
		240,
		238,
		247,
		252,
		259,
		-1,
		258,
		-1,
		294,
		273,
		284,
		289,
		233,
		230,
		250,
		269,
		251,
		243,
		309,
		263,
		234,
		228,
		246,
		236,
		245,
		237,
		-1,
		234,
		224,
		246,
		225,
		236,
		228,
		-1,
		-1,
		228,
		229,
		235,
		221,
		227,
		223,
		-1,
		233,
		217,
		-1,
		-1,
		218,
		219,
		203,
		206,
		214,
		212,
		225,
		217,
		212,
		-1,
		-1,
		209,
		205,
		212,
		199,
		195,
		212,
		225,
		207,
		221,
		220,
		-1,
		209,
		227,
		236,
		206,
		204,
		188,
		186,
		204,
		206,
		212,
		212,
		-1,
		202,
		204,
		214,
		222,
		227,
		204,
		191,
		191,
		201,
		194,
		213,
		201,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		199,
		201,
		218,
		210,
		200,
		215,
		208,
		194,
		191,
		189,
		186,
		202,
		200,
		210,
		-1,
		-1,
		255,
		224,
		259,
		216,
		201,
		-1,
		195,
		194,
		200,
		204,
		198,
		191,
		205,
		201,
		-1,
		180,
		179,
		207,
		193,
		204,
		215,
		-1,
		-1,
		213,
		205,
		190,
		193,
		190,
		190,
		209,
		208,
		200,
		186,
		182,
		188,
		191,
		191,
		197,
		174,
		184,
		188,
		186,
		211,
		-1,
		-1,
		246,
		-1,
		-1,
		212,
		195,
		-1,
		178,
		185,
		185,
		202,
		192,
		213,
		219,
		210,
		202,
		196,
		184,
		186,
		183,
		196,
		184,
		171,
		196,
		200,
		181,
		202,
		197,
		-1,
		245,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		171,
		174,
		180,
		204,
		214,
		-1,
		204,
		210,
		220,
		205,
		202,
		189,
		177,
		190,
		175,
		182,
		181,
		175,
		173,
		203,
		178,
		200,
		197,
		216,
		221,
		215,
		224,
		-1,
		220,
		216,
		212,
		219,
		168,
		-1,
		-1,
		208,
		-1,
		222,
		221,
		196,
		214,
		217,
		206,
		197,
		184,
		173,
		184,
		173,
		170,
		178,
		167,
		182,
		173,
		172,
		190,
		200,
		208,
		212,
		218,
		-1,
		270,
		-1,
		212,
		196,
		198,
		170,
		191,
		-1,
		228,
		223,
		213,
		198,
		189,
		-1,
		192,
		195,
		202,
		180,
		165,
		182,
		174,
		172,
		177,
		162,
		176,
		167,
		185,
		192,
		190,
		194,
		214,
		226,
		230,
		220,
		-1,
		202,
		207,
		166,
		174,
		193,
		231,
		195,
		-1,
		190,
		-1,
		182,
		207,
		-1,
		186,
		182,
		164,
		165,
		160,
		175,
		173,
		158,
		155,
		173,
		176,
		183,
		187,
		203,
		-1,
		-1,
		215,
		219,
		208,
		159,
		178,
		202,
		239,
		188,
		177,
		176,
		-1,
		167,
		197,
		194,
		180,
		167,
		157,
		158,
		166,
		179,
		158,
		157,
		154,
		174,
		200,
		178,
		190,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		185,
		156,
		180,
		222,
		206,
		199,
		187,
		152,
		152,
		146,
		-1,
		187,
		170,
		166,
		155,
		153,
		166,
		161,
		172,
		152,
		150,
		169,
		181,
		172,
		183,
		-1,
		-1,
		-1,
		215,
		204,
		205,
		151,
		174,
		211,
		185,
		171,
		176,
		151,
		144,
		138,
		190,
		187,
		154,
		162,
		154,
		143,
		157,
		165,
		166,
		148,
		157,
		163,
		187,
		171,
		177,
		-1,
		-1,
		222,
		212,
		196,
		198,
		195,
		165,
		172,
		204,
		176,
		189,
		-1,
		143,
		-1,
		132,
		140,
		139,
		145,
		157,
		143,
		148,
		159,
		165,
		155,
		150,
		157,
		192,
		192,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		215,
		210,
		185,
		162,
		146,
		182,
		-1,
		159,
		160,
		-1,
		137,
		131,
		137,
		136,
		143,
		140,
		140,
		154,
		162,
		153,
		159,
		160,
		142,
		166,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		208,
		187,
		180,
		200,
		141,
		193,
		-1,
		-1,
		144,
		137,
		-1,
		124,
		124,
		131,
		140,
		145,
		150,
		157,
		147,
		160,
		153,
		147,
		141,
		154,
		158,
		162,
		151,
		147,
		144,
		158,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		161,
		-1,
		153,
		145,
		135,
		129,
		123,
		134,
		135,
		155,
		147,
		161,
		161,
		161,
		152,
		142,
		135,
		146,
		131,
		149,
		157,
		149,
		143,
		142,
		154,
		-1,
		228,
		214,
		185,
		-1,
		-1,
		174,
		-1,
		138,
		152,
		168,
		-1,
		161,
		140,
		155,
		133,
		137,
		143,
		174,
		175,
		145,
		150,
		152,
		140,
		143,
		136,
		139,
		131,
		153,
		153,
		137,
		138,
		147,
		-1,
		234,
		221,
		179,
		175,
		164,
		184,
		135,
		123,
		155,
		-1,
		-1,
		161,
		-1,
		115,
		117,
		157,
		155,
		164,
		139,
		146,
		164,
		137,
		132,
		141,
		130,
		128,
		125,
		147,
		133,
		131,
		148,
		164,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		150,
		137,
		131,
		-1,
		172,
		-1,
		139,
		127,
		114,
		96,
		136,
		-1,
		138,
		134,
		141,
		-1,
		157,
		-1,
		129,
		132,
		123,
		120,
		119,
		130,
		128,
		139,
		143,
		-1,
		184,
		169,
		162,
		152,
		166,
		137,
		-1,
		175,
		-1,
		-1,
		126,
		120,
		120,
		89,
		86,
		154,
		134,
		126,
		141,
		140,
		127,
		126,
		114,
		114,
		117,
		120,
		133,
		143,
		146,
		141,
		-1,
		-1,
		-1,
		189,
		171,
		165,
		137,
		141,
		-1,
		-1,
		187,
		143,
		129,
		-1,
		81,
		154,
		142,
		132,
		122,
		127,
		128,
		118,
		116,
		112,
		121,
		125,
		122,
		121,
		142,
		135,
		157,
		-1,
		-1,
		170,
		163,
		151,
		119,
		114,
		-1,
		-1,
		-1,
		133,
		119,
		107,
		79,
		143,
		-1,
		-1,
		126,
		119,
		113,
		111,
		104,
		124,
		131,
		128,
		115,
		130,
		140,
		148,
		147,
		-1,
		173,
		160,
		-1,
		-1,
		113,
		103,
		-1,
		-1,
		-1,
		-1,
		97,
		78,
		90,
		109,
		113,
		125,
		-1,
		98,
		102,
		102,
		122,
		129,
		130,
		115,
		109,
		120,
		135,
		152,
		-1,
		-1,
		127,
		-1,
		89,
		-1,
		-1,
		-1,
		-1,
		69,
		84,
		102,
		95,
		99,
		-1,
		96,
		95,
		99,
		105,
		118,
		123,
		121,
		103,
		117,
		120,
		133,
		147,
		151,
		150,
		-1,
		80,
		-1,
		-1,
		-1,
		61,
		62,
		135,
		112,
		91,
		84,
		81,
		87,
		91,
		107,
		113,
		124,
		97,
		101,
		116,
		121,
		125,
		142,
		146,
		-1,
		-1,
		78,
		74,
		87,
		69,
		35,
		162,
		-1,
		-1,
		80,
		73,
		83,
		92,
		97,
		100,
		93,
		95,
		113,
		126,
		120,
		130,
		145,
		140,
		-1,
		-1,
		-1,
		90,
		-1,
		92,
		-1,
		-1,
		25,
		153,
		100,
		82,
		78,
		64,
		87,
		81,
		83,
		88,
		107,
		102,
		111,
		116,
		120,
		143,
		132,
		171,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		69,
		61,
		55,
		58,
		9,
		0,
		115,
		112,
		-1,
		60,
		103,
		78,
		92,
		88,
		95,
		100,
		106,
		110,
		117,
		133,
		132,
		127,
		163,
		154,
		160,
		-1,
		-1,
		206,
		195,
		184,
		190,
		-1,
		62,
		58,
		44,
		34,
		10,
		-1,
		-1,
		77,
		74,
		83,
		70,
		76,
		81,
		84,
		122,
		98,
		106,
		110,
		114,
		120,
		125,
		130,
		136,
		151,
		166,
		-1,
		160,
		197,
		190,
		158,
		166,
		197,
		-1,
		52,
		44,
		54,
		30,
		21,
		-1,
		-1,
		50,
		52,
		57,
		66,
		69,
		105,
		104,
		117,
		120,
		125,
		113,
		112,
		130,
		134,
		143,
		150,
		140,
		153,
		157,
		-1,
		153,
		173,
		152,
		155,
		179,
		193,
		-1,
		49,
		-1,
		-1,
		61,
		34,
		42,
		45,
		49,
		104,
		80,
		75,
		88,
		90,
		114,
		105,
		130,
		121,
		121,
		124,
		139,
		144,
		136,
		150,
		150,
		151,
		-1,
		142,
		153,
		146,
		-1,
		-1,
		-1,
		-1,
		50,
		-1,
		-1,
		77,
		-1,
		68,
		-1,
		61,
		65,
		88,
		91,
		113,
		100,
		107,
		124,
		130,
		119,
		129,
		125,
		126,
		135,
		146,
		158,
		157,
		158,
		167,
		123,
		126,
		137,
		148,
		163,
		167,
		-1,
		61,
		100,
		115,
		-1,
		86,
		-1,
		-1,
		-1,
		75,
		101,
		93,
		109,
		112,
		112,
		108,
		112,
		124,
		131,
		141,
		143,
		135,
		139,
		152,
		163,
		166,
		163,
		154,
		167,
		112,
		112,
		133,
		142,
		163,
		76,
		67,
		94,
		122,
		111,
		106,
		93,
		-1,
		-1,
		98,
		111,
		-1,
		-1,
		119,
		129,
		112,
		114,
		118,
		132,
		144,
		152,
		142,
		140,
		134,
		166,
		-1,
		156,
		155,
		144,
		141,
		117,
		108,
		103,
		130,
		-1,
		-1,
		79,
		95,
		108,
		112,
		128,
		153,
		-1,
		96,
		-1,
		-1,
		119,
		-1,
		-1,
		171,
		134,
		123,
		114,
		120,
		126,
		137,
		159,
		148,
		149,
		139,
		149,
		162,
		140,
		137,
		125,
		123,
		146,
		111,
		99,
		-1,
		94,
		82,
		88,
		95,
		112,
		142,
		-1,
		-1,
		112,
		103,
		-1,
		-1,
		138,
		145,
		156,
		-1,
		146,
		119,
		124,
		149,
		156,
		157,
		151,
		145,
		152,
		151,
		159,
		167,
		149,
		163,
		152,
		148,
		147,
		155,
		104,
		97,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		122,
		-1,
		-1,
		145,
		152,
		145,
		133,
		123,
		133,
		141,
		141,
		144,
		148,
		143,
		154,
		146,
		150,
		167,
		-1,
		183,
		-1,
		135,
		103,
		123,
		138,
		146,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		195,
		179,
		160,
		-1,
		133,
		146,
		177,
		145,
		150,
		145,
		149,
		160,
		149,
		152,
		166,
		161,
		-1,
		-1,
		121,
		124,
		-1,
		-1,
		148,
		167,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		134,
		159,
		148,
		156,
		151,
		153,
		159,
		162,
		151,
		155,
		167,
		-1,
		-1,
		128,
		131,
		136,
		-1,
		157,
		-1,
		179,
		-1,
		124,
		140,
		142,
		-1,
		-1,
		-1,
		172,
		135,
		156,
		166,
		171,
		169,
		160,
		157,
		164,
		162,
		158,
		169,
		-1,
		-1,
		-1,
		187,
		164,
		186,
		177,
		160,
		140,
		132,
		157,
		-1,
		160,
		-1,
		135,
		136,
		163,
		165,
		182,
		176,
		160,
		175,
		165,
		156,
		165,
		193,
		-1,
		168,
		214,
		178,
		146,
		146,
		145,
		181,
		-1,
		157,
		139,
		-1,
		167,
		157,
		199,
		180,
		173,
		160,
		167,
		169,
		162,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		166,
		151,
		146,
		-1,
		169,
		151,
		130,
		147,
		147,
		138,
		146,
		189,
		185,
		178,
		180,
		170,
		-1,
		255,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		185,
		158,
		146,
		152,
		148,
		134,
		140,
		142,
		150,
		148,
		145,
		157,
		153,
		173,
		169,
		201,
		-1,
		262,
		-1,
		213,
		-1,
		-1,
		193,
		179,
		180,
		169,
		158,
		156,
		147,
		138,
		160,
		176,
		160,
		158,
		163,
		168,
		-1,
		272,
		273,
		-1,
		212,
		204,
		190,
		-1,
		183,
		-1,
		204,
		165,
		-1,
		167,
		147,
		-1,
		169,
		165,
		-1,
		-1,
		268,
		228,
		-1,
		-1,
		-1,
		213,
		193,
		199,
		183,
		-1,
		158,
		158,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		206,
		209,
		-1,
		200,
		205,
		213,
		160,
		164,
		-1,
		-1,
		-1,
		262,
		243,
		237,
		221,
		226,
		214,
		226,
		212,
		196,
		174,
		163,
		184,
		-1,
		-1,
		-1,
		234,
		226,
		219,
		-1,
		-1,
		221,
		204,
		185,
		183,
		-1,
		-1,
		-1,
		256,
		237,
		-1,
		-1,
		211,
		-1,
		-1,
		217,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		245,
		-1,
		-1,
		-1,
		207,
		203,
		204,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		291,
		255,
		-1,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		269,
		267,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		197,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		232,
		-1,
		232,
		207,
		214,
		-1,
		-1,
		-1,
		-1,
		245,
		237,
		245,
		-1,
		217,
		219,
		-1,
		267,
		-1,
		-1,
		260,
		251,
		-1,
		-1,
		222,
		229,
		251,
		254,
		290,
		-1,
		241
	],
	[
		-1,
		244,
		233,
		244,
		252,
		225,
		232,
		-1,
		251,
		255,
		221,
		215,
		254,
		223,
		229,
		240,
		-1,
		-1,
		-1,
		244,
		243,
		211,
		209,
		218,
		223,
		230,
		-1,
		229,
		-1,
		265,
		244,
		255,
		260,
		204,
		201,
		221,
		240,
		222,
		214,
		280,
		234,
		205,
		199,
		217,
		207,
		216,
		208,
		-1,
		205,
		195,
		217,
		196,
		207,
		199,
		-1,
		-1,
		199,
		200,
		206,
		192,
		198,
		194,
		-1,
		204,
		188,
		-1,
		-1,
		189,
		190,
		174,
		177,
		185,
		183,
		196,
		188,
		183,
		-1,
		-1,
		180,
		176,
		183,
		170,
		166,
		183,
		196,
		178,
		192,
		191,
		-1,
		186,
		204,
		209,
		177,
		175,
		159,
		157,
		175,
		177,
		183,
		183,
		-1,
		195,
		196,
		191,
		199,
		199,
		175,
		162,
		162,
		172,
		165,
		184,
		172,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		195,
		178,
		195,
		187,
		177,
		192,
		185,
		165,
		162,
		160,
		157,
		173,
		171,
		181,
		-1,
		-1,
		286,
		255,
		286,
		244,
		225,
		-1,
		191,
		171,
		177,
		181,
		175,
		168,
		182,
		178,
		-1,
		151,
		150,
		178,
		164,
		175,
		246,
		-1,
		-1,
		244,
		236,
		221,
		224,
		201,
		197,
		186,
		185,
		177,
		163,
		159,
		165,
		168,
		168,
		174,
		145,
		155,
		159,
		157,
		182,
		-1,
		-1,
		217,
		-1,
		-1,
		243,
		226,
		-1,
		209,
		216,
		207,
		213,
		199,
		220,
		196,
		187,
		179,
		173,
		161,
		163,
		160,
		173,
		161,
		142,
		167,
		171,
		152,
		173,
		168,
		-1,
		216,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		202,
		205,
		211,
		235,
		236,
		-1,
		208,
		196,
		197,
		182,
		179,
		166,
		154,
		167,
		152,
		159,
		158,
		146,
		144,
		174,
		149,
		171,
		168,
		187,
		192,
		186,
		195,
		-1,
		251,
		247,
		243,
		250,
		199,
		-1,
		-1,
		239,
		-1,
		244,
		245,
		220,
		193,
		196,
		183,
		174,
		161,
		150,
		161,
		150,
		147,
		155,
		138,
		153,
		144,
		143,
		161,
		171,
		179,
		183,
		189,
		-1,
		301,
		-1,
		243,
		227,
		229,
		201,
		222,
		-1,
		259,
		245,
		237,
		222,
		220,
		-1,
		192,
		189,
		179,
		157,
		142,
		159,
		151,
		149,
		151,
		133,
		147,
		138,
		156,
		163,
		161,
		165,
		185,
		197,
		261,
		251,
		-1,
		233,
		238,
		197,
		205,
		224,
		262,
		226,
		-1,
		221,
		-1,
		194,
		207,
		-1,
		163,
		159,
		141,
		142,
		137,
		152,
		144,
		129,
		126,
		144,
		147,
		154,
		158,
		174,
		-1,
		-1,
		246,
		250,
		239,
		190,
		209,
		233,
		270,
		219,
		208,
		207,
		-1,
		198,
		177,
		174,
		162,
		149,
		134,
		135,
		143,
		155,
		134,
		128,
		125,
		145,
		171,
		149,
		161,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		216,
		187,
		211,
		253,
		237,
		230,
		218,
		183,
		183,
		177,
		-1,
		173,
		152,
		143,
		132,
		130,
		143,
		135,
		143,
		123,
		121,
		140,
		152,
		143,
		154,
		-1,
		-1,
		-1,
		246,
		235,
		236,
		182,
		205,
		242,
		216,
		202,
		207,
		182,
		175,
		169,
		186,
		169,
		150,
		139,
		131,
		120,
		131,
		139,
		137,
		119,
		128,
		134,
		158,
		142,
		148,
		-1,
		-1,
		253,
		243,
		227,
		229,
		226,
		196,
		203,
		235,
		207,
		220,
		-1,
		174,
		-1,
		163,
		159,
		144,
		139,
		136,
		123,
		122,
		136,
		136,
		126,
		121,
		128,
		163,
		163,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		246,
		241,
		216,
		193,
		177,
		213,
		-1,
		190,
		191,
		-1,
		168,
		162,
		159,
		146,
		142,
		127,
		131,
		133,
		136,
		124,
		130,
		131,
		113,
		137,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		239,
		218,
		211,
		231,
		172,
		224,
		-1,
		-1,
		175,
		168,
		-1,
		155,
		137,
		139,
		131,
		125,
		132,
		127,
		118,
		131,
		124,
		118,
		112,
		125,
		129,
		133,
		122,
		118,
		115,
		129,
		-1,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		192,
		-1,
		184,
		176,
		166,
		160,
		154,
		150,
		148,
		153,
		137,
		140,
		135,
		132,
		122,
		113,
		106,
		117,
		102,
		120,
		128,
		120,
		114,
		113,
		125,
		-1,
		259,
		245,
		216,
		-1,
		-1,
		205,
		-1,
		169,
		183,
		199,
		-1,
		192,
		171,
		186,
		164,
		160,
		151,
		144,
		145,
		115,
		120,
		122,
		110,
		113,
		107,
		110,
		102,
		124,
		124,
		108,
		109,
		118,
		-1,
		265,
		252,
		210,
		206,
		195,
		215,
		166,
		154,
		186,
		-1,
		-1,
		199,
		-1,
		153,
		155,
		165,
		163,
		134,
		109,
		116,
		134,
		107,
		102,
		112,
		101,
		98,
		96,
		118,
		104,
		102,
		121,
		137,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		181,
		168,
		162,
		-1,
		203,
		-1,
		177,
		165,
		152,
		134,
		174,
		-1,
		108,
		104,
		111,
		-1,
		127,
		-1,
		99,
		102,
		93,
		90,
		90,
		101,
		99,
		110,
		127,
		-1,
		215,
		200,
		193,
		183,
		197,
		168,
		-1,
		223,
		-1,
		-1,
		164,
		158,
		158,
		127,
		124,
		124,
		104,
		96,
		111,
		110,
		97,
		96,
		84,
		84,
		87,
		93,
		106,
		126,
		117,
		128,
		-1,
		-1,
		-1,
		220,
		206,
		210,
		170,
		189,
		-1,
		-1,
		225,
		181,
		167,
		-1,
		119,
		124,
		112,
		102,
		92,
		97,
		98,
		88,
		86,
		82,
		91,
		95,
		102,
		107,
		128,
		122,
		142,
		-1,
		-1,
		203,
		208,
		196,
		182,
		186,
		-1,
		-1,
		-1,
		171,
		172,
		138,
		117,
		113,
		-1,
		-1,
		96,
		89,
		83,
		86,
		74,
		94,
		101,
		115,
		101,
		116,
		127,
		135,
		134,
		-1,
		206,
		193,
		-1,
		-1,
		185,
		175,
		-1,
		-1,
		-1,
		-1,
		150,
		95,
		84,
		79,
		83,
		95,
		-1,
		69,
		80,
		73,
		92,
		99,
		117,
		102,
		96,
		107,
		122,
		139,
		-1,
		-1,
		199,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		107,
		101,
		72,
		65,
		69,
		-1,
		71,
		73,
		70,
		82,
		93,
		98,
		106,
		90,
		104,
		107,
		120,
		134,
		138,
		222,
		-1,
		152,
		-1,
		-1,
		-1,
		125,
		140,
		107,
		84,
		61,
		54,
		51,
		57,
		62,
		82,
		88,
		99,
		84,
		88,
		103,
		113,
		112,
		129,
		139,
		-1,
		-1,
		150,
		146,
		151,
		133,
		137,
		134,
		-1,
		-1,
		52,
		43,
		53,
		64,
		72,
		75,
		80,
		82,
		100,
		119,
		107,
		122,
		137,
		133,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		152,
		62,
		13,
		36,
		39,
		46,
		66,
		75,
		70,
		75,
		100,
		95,
		104,
		109,
		113,
		136,
		125,
		164,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		141,
		133,
		128,
		134,
		136,
		127,
		0,
		66,
		-1,
		52,
		95,
		76,
		83,
		75,
		88,
		93,
		99,
		103,
		110,
		126,
		125,
		120,
		156,
		147,
		153,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		134,
		130,
		120,
		110,
		113,
		-1,
		-1,
		101,
		98,
		76,
		85,
		89,
		82,
		77,
		115,
		91,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		186,
		223,
		216,
		184,
		192,
		223,
		-1,
		124,
		116,
		127,
		102,
		104,
		-1,
		-1,
		74,
		71,
		76,
		85,
		88,
		101,
		100,
		111,
		113,
		118,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		121,
		-1,
		-1,
		133,
		105,
		89,
		79,
		73,
		123,
		98,
		93,
		103,
		105,
		109,
		100,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		116,
		-1,
		91,
		95,
		105,
		109,
		128,
		115,
		113,
		121,
		129,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		133,
		172,
		187,
		-1,
		158,
		-1,
		-1,
		-1,
		105,
		118,
		110,
		127,
		127,
		127,
		107,
		111,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		148,
		139,
		166,
		192,
		183,
		178,
		165,
		-1,
		-1,
		128,
		128,
		-1,
		-1,
		134,
		128,
		111,
		113,
		117,
		127,
		142,
		145,
		135,
		133,
		127,
		159,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		151,
		167,
		162,
		166,
		182,
		207,
		-1,
		168,
		-1,
		-1,
		149,
		-1,
		-1,
		170,
		133,
		122,
		113,
		119,
		125,
		136,
		153,
		141,
		142,
		132,
		142,
		155,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		138,
		136,
		142,
		149,
		166,
		196,
		-1,
		-1,
		184,
		175,
		-1,
		-1,
		168,
		166,
		155,
		-1,
		145,
		118,
		123,
		148,
		155,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		194,
		-1,
		-1,
		163,
		156,
		144,
		132,
		122,
		132,
		140,
		140,
		143,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		209,
		-1,
		161,
		137,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		197,
		181,
		162,
		-1,
		132,
		145,
		176,
		144,
		149,
		144,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		149,
		152,
		-1,
		-1,
		174,
		193,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		169,
		165,
		-1,
		-1,
		133,
		158,
		147,
		155,
		150,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		156,
		157,
		162,
		-1,
		183,
		-1,
		211,
		-1,
		178,
		184,
		172,
		-1,
		-1,
		-1,
		171,
		134,
		151,
		165,
		170,
		168,
		159,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		211,
		185,
		218,
		209,
		192,
		172,
		164,
		183,
		-1,
		153,
		-1,
		128,
		131,
		156,
		164,
		181,
		175,
		153,
		168,
		158,
		149,
		158,
		217,
		-1,
		187,
		220,
		184,
		178,
		154,
		158,
		174,
		-1,
		150,
		132,
		-1,
		160,
		150,
		198,
		173,
		168,
		155,
		162,
		162,
		155,
		-1,
		-1,
		-1,
		189,
		188,
		180,
		174,
		174,
		159,
		150,
		-1,
		162,
		144,
		123,
		140,
		140,
		131,
		139,
		188,
		184,
		175,
		175,
		163,
		-1,
		281,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		183,
		178,
		151,
		139,
		145,
		141,
		127,
		133,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		162,
		194,
		-1,
		285,
		-1,
		219,
		-1,
		-1,
		201,
		181,
		173,
		162,
		151,
		149,
		140,
		131,
		153,
		169,
		153,
		151,
		156,
		161,
		-1,
		274,
		273,
		-1,
		220,
		212,
		198,
		-1,
		191,
		-1,
		197,
		158,
		-1,
		160,
		140,
		-1,
		162,
		158,
		-1,
		-1,
		261,
		236,
		-1,
		-1,
		-1,
		221,
		201,
		192,
		176,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		246,
		245,
		-1,
		214,
		217,
		-1,
		207,
		198,
		206,
		153,
		157,
		-1,
		-1,
		-1,
		255,
		236,
		230,
		229,
		227,
		222,
		219,
		205,
		189,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		227,
		219,
		212,
		-1,
		-1,
		214,
		197,
		178,
		176,
		-1,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		204,
		-1,
		-1,
		210,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		238,
		-1,
		-1,
		-1,
		200,
		196,
		197,
		-1,
		-1,
		-1,
		-1,
		260,
		261,
		284,
		248,
		-1,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		263,
		261,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		190,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		225,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		238,
		230,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		215,
		222,
		244,
		247,
		283,
		-1,
		234
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		180,
		198,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		189,
		190,
		185,
		193,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		280,
		249,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		145,
		144,
		172,
		158,
		169,
		240,
		-1,
		-1,
		238,
		230,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		211,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		140,
		138,
		168,
		143,
		165,
		162,
		181,
		186,
		180,
		189,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		132,
		147,
		138,
		137,
		155,
		165,
		173,
		177,
		183,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		239,
		231,
		216,
		214,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		145,
		127,
		141,
		132,
		150,
		157,
		155,
		159,
		179,
		191,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		138,
		123,
		120,
		138,
		141,
		148,
		152,
		168,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		149,
		128,
		122,
		119,
		139,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		129,
		137,
		117,
		115,
		134,
		146,
		137,
		148,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		180,
		163,
		144,
		133,
		125,
		114,
		125,
		133,
		131,
		113,
		122,
		128,
		152,
		136,
		142,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		153,
		138,
		133,
		130,
		117,
		116,
		130,
		130,
		120,
		115,
		122,
		157,
		157,
		126,
		146,
		149,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		140,
		136,
		121,
		125,
		127,
		130,
		118,
		124,
		125,
		107,
		131,
		-1,
		134,
		128,
		136,
		126,
		114,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		133,
		125,
		119,
		126,
		121,
		112,
		125,
		118,
		112,
		106,
		119,
		123,
		127,
		116,
		112,
		109,
		123,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		147,
		131,
		134,
		129,
		126,
		116,
		107,
		100,
		111,
		96,
		114,
		122,
		114,
		108,
		107,
		119,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		145,
		138,
		139,
		109,
		114,
		116,
		104,
		107,
		101,
		104,
		96,
		118,
		118,
		102,
		103,
		112,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		193,
		-1,
		147,
		149,
		159,
		157,
		128,
		103,
		110,
		128,
		101,
		96,
		106,
		95,
		92,
		90,
		112,
		98,
		96,
		115,
		131,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		171,
		159,
		146,
		128,
		168,
		-1,
		102,
		98,
		105,
		-1,
		121,
		-1,
		93,
		96,
		87,
		84,
		84,
		95,
		93,
		104,
		121,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		158,
		152,
		152,
		121,
		118,
		118,
		98,
		90,
		105,
		104,
		91,
		90,
		78,
		78,
		81,
		87,
		100,
		120,
		111,
		122,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		219,
		175,
		161,
		-1,
		113,
		118,
		106,
		96,
		86,
		91,
		92,
		82,
		80,
		76,
		85,
		89,
		96,
		101,
		122,
		116,
		136,
		-1,
		-1,
		197,
		202,
		190,
		176,
		180,
		-1,
		-1,
		-1,
		165,
		166,
		132,
		111,
		107,
		-1,
		-1,
		90,
		83,
		77,
		80,
		68,
		88,
		95,
		109,
		95,
		110,
		121,
		129,
		128,
		-1,
		200,
		187,
		-1,
		-1,
		179,
		169,
		-1,
		-1,
		-1,
		-1,
		144,
		89,
		78,
		73,
		77,
		89,
		-1,
		63,
		74,
		67,
		86,
		93,
		111,
		96,
		90,
		101,
		116,
		133,
		-1,
		-1,
		193,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		101,
		95,
		66,
		59,
		63,
		-1,
		65,
		67,
		64,
		76,
		87,
		92,
		100,
		84,
		98,
		101,
		114,
		128,
		132,
		216,
		-1,
		146,
		-1,
		-1,
		-1,
		119,
		134,
		101,
		78,
		55,
		48,
		45,
		51,
		56,
		76,
		82,
		93,
		78,
		82,
		97,
		107,
		106,
		123,
		133,
		-1,
		-1,
		144,
		140,
		145,
		127,
		131,
		128,
		-1,
		-1,
		46,
		37,
		47,
		58,
		66,
		69,
		74,
		76,
		94,
		113,
		101,
		116,
		131,
		127,
		-1,
		-1,
		-1,
		156,
		-1,
		158,
		-1,
		-1,
		146,
		103,
		50,
		30,
		33,
		40,
		60,
		69,
		64,
		69,
		94,
		89,
		98,
		103,
		107,
		130,
		119,
		158,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		135,
		127,
		122,
		128,
		130,
		121,
		65,
		0,
		-1,
		46,
		89,
		70,
		77,
		69,
		82,
		87,
		93,
		97,
		104,
		120,
		119,
		114,
		150,
		141,
		147,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		128,
		124,
		114,
		104,
		107,
		-1,
		-1,
		95,
		92,
		70,
		79,
		83,
		76,
		71,
		109,
		85,
		93,
		97,
		101,
		107,
		112,
		117,
		123,
		138,
		153,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		118,
		110,
		121,
		96,
		98,
		-1,
		-1,
		68,
		65,
		70,
		79,
		82,
		95,
		94,
		105,
		107,
		112,
		100,
		99,
		117,
		121,
		130,
		137,
		127,
		140,
		144,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		115,
		-1,
		-1,
		127,
		99,
		83,
		73,
		67,
		117,
		92,
		87,
		97,
		99,
		103,
		94,
		117,
		108,
		108,
		111,
		126,
		131,
		123,
		137,
		137,
		138,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		143,
		-1,
		110,
		-1,
		85,
		89,
		99,
		103,
		122,
		109,
		107,
		115,
		123,
		106,
		116,
		112,
		113,
		122,
		133,
		145,
		144,
		145,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		127,
		166,
		181,
		-1,
		152,
		-1,
		-1,
		-1,
		99,
		112,
		104,
		121,
		121,
		121,
		101,
		105,
		111,
		118,
		128,
		130,
		122,
		126,
		139,
		150,
		153,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		142,
		133,
		160,
		186,
		177,
		172,
		159,
		-1,
		-1,
		122,
		122,
		-1,
		-1,
		128,
		122,
		105,
		107,
		111,
		121,
		136,
		139,
		129,
		127,
		121,
		153,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		161,
		156,
		160,
		176,
		201,
		-1,
		162,
		-1,
		-1,
		143,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		119,
		130,
		147,
		135,
		136,
		126,
		136,
		149,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		132,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		178,
		169,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		112,
		117,
		142,
		149,
		144,
		138,
		132,
		139,
		138,
		146,
		154,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		188,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		134,
		134,
		137,
		135,
		130,
		141,
		133,
		137,
		154,
		-1,
		203,
		-1,
		155,
		131,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		136,
		147,
		136,
		139,
		153,
		148,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		168,
		187,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		140,
		146,
		149,
		138,
		142,
		154,
		-1,
		-1,
		150,
		151,
		156,
		-1,
		177,
		-1,
		205,
		-1,
		172,
		178,
		166,
		-1,
		-1,
		-1,
		165,
		128,
		145,
		159,
		164,
		162,
		153,
		144,
		151,
		149,
		145,
		156,
		-1,
		-1,
		-1,
		205,
		179,
		212,
		203,
		186,
		166,
		158,
		177,
		-1,
		147,
		-1,
		122,
		125,
		150,
		158,
		175,
		169,
		147,
		162,
		152,
		143,
		152,
		211,
		-1,
		181,
		214,
		178,
		172,
		148,
		152,
		168,
		-1,
		144,
		126,
		-1,
		154,
		144,
		192,
		167,
		162,
		149,
		156,
		156,
		149,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		168,
		153,
		144,
		-1,
		156,
		138,
		117,
		134,
		134,
		125,
		133,
		182,
		178,
		169,
		169,
		157,
		-1,
		275,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		172,
		145,
		133,
		139,
		135,
		121,
		127,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		156,
		188,
		-1,
		279,
		-1,
		213,
		-1,
		-1,
		195,
		175,
		167,
		156,
		145,
		143,
		134,
		125,
		147,
		163,
		147,
		145,
		150,
		155,
		-1,
		268,
		267,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		191,
		152,
		-1,
		154,
		134,
		-1,
		156,
		152,
		-1,
		-1,
		255,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		186,
		170,
		-1,
		145,
		145,
		-1,
		-1,
		-1,
		240,
		239,
		-1,
		208,
		211,
		-1,
		201,
		192,
		200,
		147,
		151,
		-1,
		-1,
		-1,
		249,
		230,
		224,
		223,
		221,
		216,
		213,
		199,
		183,
		161,
		150,
		171,
		-1,
		-1,
		-1,
		221,
		213,
		206,
		-1,
		-1,
		208,
		191,
		172,
		170,
		-1,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		198,
		-1,
		-1,
		204,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		232,
		-1,
		-1,
		-1,
		194,
		190,
		191,
		-1,
		-1,
		-1,
		-1,
		254,
		255,
		278,
		242,
		-1,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		257,
		255,
		-1,
		-1,
		-1,
		214,
		198,
		-1,
		184,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		219,
		-1,
		219,
		194,
		201,
		-1,
		-1,
		-1,
		-1,
		232,
		224,
		232,
		-1,
		204,
		206,
		-1,
		254,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		209,
		216,
		238,
		241,
		277,
		-1,
		228
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		218,
		207,
		218,
		226,
		199,
		206,
		-1,
		225,
		229,
		195,
		189,
		228,
		197,
		203,
		214,
		-1,
		-1,
		-1,
		218,
		217,
		185,
		183,
		192,
		197,
		204,
		-1,
		203,
		-1,
		239,
		218,
		229,
		234,
		178,
		175,
		195,
		214,
		196,
		188,
		254,
		208,
		179,
		173,
		191,
		181,
		190,
		182,
		-1,
		179,
		169,
		191,
		170,
		181,
		173,
		-1,
		-1,
		173,
		174,
		180,
		166,
		172,
		168,
		-1,
		178,
		162,
		-1,
		-1,
		163,
		164,
		148,
		151,
		159,
		157,
		170,
		162,
		157,
		-1,
		-1,
		154,
		150,
		157,
		144,
		140,
		157,
		170,
		152,
		166,
		165,
		-1,
		160,
		178,
		183,
		151,
		149,
		133,
		131,
		149,
		151,
		157,
		157,
		-1,
		169,
		170,
		165,
		173,
		173,
		149,
		136,
		136,
		146,
		139,
		158,
		146,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		152,
		169,
		161,
		151,
		166,
		159,
		139,
		136,
		134,
		131,
		147,
		145,
		155,
		-1,
		-1,
		260,
		229,
		260,
		218,
		199,
		-1,
		165,
		145,
		151,
		155,
		149,
		142,
		156,
		152,
		-1,
		125,
		124,
		152,
		138,
		149,
		220,
		-1,
		-1,
		218,
		210,
		195,
		198,
		175,
		171,
		160,
		159,
		151,
		137,
		133,
		139,
		142,
		142,
		148,
		119,
		129,
		133,
		131,
		156,
		-1,
		-1,
		191,
		-1,
		-1,
		217,
		200,
		-1,
		183,
		190,
		181,
		187,
		173,
		194,
		170,
		161,
		153,
		147,
		135,
		137,
		134,
		147,
		135,
		116,
		141,
		145,
		126,
		147,
		142,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		176,
		179,
		185,
		209,
		210,
		-1,
		182,
		170,
		171,
		156,
		153,
		140,
		128,
		141,
		126,
		133,
		132,
		120,
		118,
		148,
		123,
		145,
		142,
		161,
		166,
		160,
		169,
		-1,
		225,
		221,
		217,
		224,
		173,
		-1,
		-1,
		213,
		-1,
		218,
		219,
		194,
		167,
		170,
		157,
		148,
		135,
		124,
		135,
		124,
		121,
		129,
		112,
		127,
		118,
		117,
		135,
		145,
		153,
		157,
		163,
		-1,
		275,
		-1,
		217,
		201,
		203,
		175,
		196,
		-1,
		233,
		219,
		211,
		196,
		194,
		-1,
		166,
		163,
		153,
		131,
		116,
		133,
		125,
		123,
		125,
		107,
		121,
		112,
		130,
		137,
		135,
		139,
		159,
		171,
		235,
		225,
		-1,
		207,
		212,
		171,
		179,
		198,
		236,
		200,
		-1,
		195,
		-1,
		168,
		181,
		-1,
		137,
		133,
		115,
		116,
		111,
		126,
		118,
		103,
		100,
		118,
		121,
		128,
		132,
		148,
		-1,
		-1,
		220,
		224,
		213,
		164,
		183,
		207,
		244,
		193,
		182,
		181,
		-1,
		172,
		151,
		148,
		136,
		123,
		108,
		109,
		117,
		129,
		108,
		102,
		99,
		119,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		190,
		161,
		185,
		227,
		211,
		204,
		192,
		157,
		157,
		151,
		-1,
		147,
		126,
		117,
		106,
		104,
		117,
		109,
		117,
		97,
		95,
		114,
		126,
		117,
		128,
		-1,
		-1,
		-1,
		220,
		209,
		210,
		156,
		179,
		216,
		190,
		176,
		181,
		156,
		149,
		143,
		160,
		143,
		124,
		113,
		105,
		94,
		105,
		113,
		111,
		93,
		102,
		108,
		132,
		116,
		122,
		-1,
		-1,
		227,
		217,
		201,
		203,
		200,
		170,
		177,
		209,
		181,
		194,
		-1,
		148,
		-1,
		137,
		133,
		118,
		113,
		110,
		97,
		96,
		110,
		110,
		100,
		95,
		102,
		137,
		137,
		106,
		126,
		129,
		-1,
		-1,
		-1,
		220,
		215,
		190,
		167,
		151,
		187,
		-1,
		164,
		165,
		-1,
		142,
		136,
		133,
		120,
		116,
		101,
		105,
		107,
		110,
		98,
		104,
		105,
		87,
		111,
		-1,
		114,
		108,
		116,
		106,
		94,
		-1,
		-1,
		-1,
		213,
		192,
		185,
		205,
		146,
		198,
		-1,
		-1,
		149,
		142,
		-1,
		129,
		111,
		113,
		105,
		99,
		106,
		101,
		92,
		105,
		98,
		92,
		86,
		99,
		103,
		107,
		96,
		92,
		89,
		103,
		-1,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		166,
		-1,
		158,
		150,
		140,
		134,
		128,
		124,
		122,
		127,
		111,
		114,
		109,
		106,
		96,
		87,
		80,
		91,
		76,
		94,
		102,
		94,
		88,
		87,
		99,
		-1,
		233,
		219,
		190,
		-1,
		-1,
		179,
		-1,
		143,
		157,
		173,
		-1,
		166,
		145,
		160,
		138,
		134,
		125,
		118,
		119,
		89,
		94,
		96,
		84,
		87,
		81,
		84,
		76,
		98,
		98,
		82,
		83,
		92,
		-1,
		239,
		226,
		184,
		180,
		169,
		189,
		140,
		128,
		160,
		-1,
		-1,
		173,
		-1,
		127,
		129,
		139,
		137,
		108,
		83,
		90,
		108,
		81,
		76,
		86,
		75,
		72,
		70,
		92,
		78,
		76,
		95,
		111,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		155,
		142,
		136,
		-1,
		177,
		-1,
		151,
		139,
		126,
		108,
		148,
		-1,
		82,
		78,
		85,
		-1,
		101,
		-1,
		73,
		76,
		67,
		64,
		64,
		75,
		73,
		84,
		101,
		-1,
		189,
		174,
		167,
		157,
		171,
		142,
		-1,
		197,
		-1,
		-1,
		138,
		132,
		132,
		101,
		98,
		98,
		78,
		70,
		85,
		84,
		71,
		70,
		58,
		58,
		61,
		67,
		80,
		100,
		91,
		102,
		-1,
		-1,
		-1,
		194,
		180,
		184,
		144,
		163,
		-1,
		-1,
		199,
		155,
		141,
		-1,
		93,
		98,
		86,
		76,
		66,
		71,
		72,
		62,
		60,
		56,
		65,
		69,
		76,
		81,
		102,
		96,
		116,
		-1,
		-1,
		177,
		182,
		170,
		145,
		140,
		-1,
		-1,
		-1,
		145,
		146,
		112,
		91,
		87,
		-1,
		-1,
		70,
		63,
		57,
		58,
		48,
		68,
		75,
		89,
		75,
		90,
		101,
		109,
		108,
		-1,
		180,
		167,
		-1,
		-1,
		139,
		129,
		-1,
		-1,
		-1,
		-1,
		124,
		69,
		58,
		53,
		57,
		69,
		-1,
		43,
		49,
		47,
		66,
		73,
		91,
		76,
		70,
		81,
		96,
		113,
		-1,
		-1,
		153,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		81,
		75,
		46,
		39,
		43,
		-1,
		43,
		42,
		44,
		52,
		65,
		70,
		78,
		64,
		78,
		81,
		94,
		108,
		112,
		176,
		-1,
		106,
		-1,
		-1,
		-1,
		99,
		114,
		79,
		56,
		35,
		28,
		25,
		31,
		36,
		54,
		60,
		71,
		58,
		62,
		77,
		87,
		86,
		103,
		113,
		-1,
		-1,
		104,
		100,
		125,
		107,
		111,
		106,
		-1,
		-1,
		24,
		17,
		27,
		38,
		44,
		47,
		54,
		56,
		74,
		93,
		81,
		96,
		111,
		107,
		-1,
		-1,
		-1,
		116,
		-1,
		118,
		-1,
		-1,
		104,
		97,
		44,
		26,
		22,
		8,
		37,
		42,
		44,
		49,
		74,
		69,
		78,
		83,
		87,
		110,
		99,
		138,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		95,
		87,
		82,
		87,
		88,
		79,
		59,
		56,
		-1,
		0,
		43,
		46,
		47,
		49,
		62,
		67,
		73,
		77,
		84,
		100,
		99,
		94,
		130,
		121,
		127,
		-1,
		-1,
		186,
		175,
		164,
		170,
		-1,
		88,
		84,
		73,
		63,
		65,
		-1,
		-1,
		53,
		50,
		24,
		43,
		49,
		54,
		51,
		89,
		65,
		73,
		77,
		81,
		87,
		92,
		97,
		103,
		118,
		133,
		-1,
		140,
		177,
		170,
		138,
		146,
		177,
		-1,
		78,
		70,
		81,
		56,
		56,
		-1,
		-1,
		26,
		25,
		30,
		36,
		39,
		75,
		74,
		85,
		87,
		92,
		80,
		79,
		97,
		101,
		110,
		117,
		107,
		120,
		124,
		-1,
		133,
		153,
		132,
		135,
		159,
		173,
		-1,
		75,
		-1,
		-1,
		87,
		57,
		41,
		33,
		25,
		77,
		46,
		41,
		61,
		63,
		83,
		74,
		97,
		88,
		88,
		91,
		106,
		111,
		103,
		117,
		117,
		118,
		-1,
		122,
		133,
		126,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		103,
		-1,
		68,
		-1,
		43,
		47,
		53,
		57,
		86,
		73,
		80,
		95,
		103,
		86,
		96,
		92,
		93,
		102,
		113,
		125,
		124,
		125,
		147,
		103,
		106,
		117,
		128,
		143,
		147,
		-1,
		87,
		126,
		141,
		-1,
		112,
		-1,
		-1,
		-1,
		57,
		66,
		58,
		75,
		85,
		85,
		81,
		85,
		91,
		98,
		108,
		110,
		102,
		106,
		119,
		130,
		133,
		143,
		134,
		147,
		92,
		92,
		113,
		122,
		143,
		102,
		93,
		120,
		146,
		137,
		132,
		119,
		-1,
		-1,
		80,
		76,
		-1,
		-1,
		91,
		102,
		85,
		87,
		91,
		101,
		116,
		119,
		109,
		107,
		101,
		133,
		-1,
		136,
		135,
		124,
		121,
		97,
		88,
		83,
		110,
		-1,
		-1,
		105,
		121,
		116,
		120,
		136,
		161,
		-1,
		122,
		-1,
		-1,
		101,
		-1,
		-1,
		144,
		107,
		96,
		87,
		93,
		99,
		110,
		127,
		115,
		116,
		106,
		116,
		129,
		120,
		117,
		105,
		103,
		126,
		91,
		79,
		-1,
		92,
		90,
		96,
		103,
		120,
		150,
		-1,
		-1,
		138,
		129,
		-1,
		-1,
		120,
		127,
		129,
		-1,
		119,
		92,
		97,
		122,
		129,
		124,
		118,
		112,
		119,
		118,
		126,
		134,
		129,
		143,
		132,
		128,
		127,
		135,
		84,
		77,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		148,
		-1,
		-1,
		127,
		130,
		118,
		106,
		96,
		106,
		114,
		114,
		117,
		115,
		110,
		121,
		113,
		117,
		134,
		-1,
		163,
		-1,
		115,
		91,
		105,
		120,
		128,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		171,
		155,
		136,
		-1,
		106,
		119,
		150,
		118,
		123,
		118,
		116,
		127,
		116,
		119,
		133,
		128,
		-1,
		-1,
		103,
		106,
		-1,
		-1,
		128,
		147,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		143,
		139,
		-1,
		-1,
		107,
		132,
		121,
		129,
		124,
		120,
		126,
		129,
		118,
		122,
		134,
		-1,
		-1,
		110,
		111,
		116,
		-1,
		137,
		-1,
		185,
		-1,
		150,
		158,
		146,
		-1,
		-1,
		-1,
		145,
		108,
		125,
		139,
		144,
		142,
		133,
		124,
		131,
		129,
		125,
		136,
		-1,
		-1,
		-1,
		167,
		144,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		127,
		-1,
		102,
		105,
		130,
		138,
		155,
		149,
		127,
		142,
		132,
		123,
		132,
		173,
		-1,
		148,
		194,
		158,
		152,
		128,
		132,
		148,
		-1,
		124,
		106,
		-1,
		134,
		124,
		172,
		147,
		142,
		129,
		136,
		136,
		129,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		136,
		118,
		97,
		114,
		114,
		105,
		113,
		162,
		158,
		149,
		149,
		137,
		-1,
		235,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		152,
		125,
		113,
		119,
		115,
		101,
		107,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		136,
		168,
		-1,
		242,
		-1,
		193,
		-1,
		-1,
		175,
		155,
		147,
		136,
		125,
		123,
		114,
		105,
		127,
		143,
		127,
		125,
		130,
		135,
		-1,
		248,
		247,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		171,
		132,
		-1,
		134,
		114,
		-1,
		136,
		132,
		-1,
		-1,
		235,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		166,
		150,
		-1,
		125,
		125,
		-1,
		-1,
		-1,
		220,
		219,
		-1,
		188,
		191,
		-1,
		181,
		172,
		180,
		127,
		131,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		203,
		201,
		196,
		193,
		179,
		163,
		141,
		130,
		151,
		-1,
		-1,
		-1,
		201,
		193,
		186,
		-1,
		-1,
		188,
		171,
		152,
		150,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		178,
		-1,
		-1,
		184,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		212,
		-1,
		-1,
		-1,
		174,
		170,
		171,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		258,
		222,
		-1,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		237,
		235,
		-1,
		-1,
		-1,
		194,
		178,
		-1,
		164,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		199,
		-1,
		199,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		212,
		204,
		212,
		-1,
		184,
		186,
		-1,
		234,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		189,
		196,
		218,
		221,
		257,
		-1,
		208
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		168,
		186,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		177,
		178,
		173,
		181,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		268,
		237,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		133,
		132,
		160,
		146,
		157,
		228,
		-1,
		-1,
		226,
		218,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		199,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		128,
		126,
		156,
		131,
		153,
		150,
		169,
		174,
		168,
		177,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		120,
		135,
		126,
		125,
		143,
		153,
		161,
		165,
		171,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		227,
		219,
		204,
		202,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		133,
		115,
		129,
		120,
		138,
		145,
		143,
		147,
		167,
		179,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		244,
		208,
		-1,
		203,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		126,
		111,
		108,
		126,
		129,
		136,
		140,
		156,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		201,
		190,
		189,
		-1,
		180,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		137,
		116,
		110,
		107,
		127,
		153,
		131,
		142,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		117,
		125,
		105,
		103,
		122,
		134,
		125,
		133,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		164,
		187,
		224,
		198,
		184,
		189,
		164,
		157,
		151,
		168,
		151,
		132,
		121,
		113,
		102,
		113,
		121,
		119,
		101,
		110,
		116,
		140,
		121,
		127,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		178,
		185,
		217,
		189,
		202,
		-1,
		156,
		-1,
		145,
		141,
		126,
		121,
		118,
		105,
		104,
		118,
		118,
		108,
		103,
		110,
		145,
		145,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		228,
		223,
		198,
		175,
		159,
		195,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		128,
		124,
		109,
		113,
		115,
		118,
		106,
		112,
		113,
		95,
		119,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		221,
		200,
		193,
		213,
		154,
		206,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		121,
		113,
		107,
		114,
		109,
		100,
		113,
		106,
		100,
		94,
		107,
		111,
		112,
		101,
		97,
		94,
		108,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		174,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		135,
		119,
		122,
		117,
		114,
		104,
		95,
		88,
		99,
		84,
		102,
		108,
		99,
		94,
		93,
		104,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		187,
		-1,
		151,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		133,
		126,
		127,
		97,
		102,
		104,
		92,
		95,
		89,
		92,
		84,
		106,
		103,
		87,
		89,
		98,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		148,
		136,
		168,
		-1,
		-1,
		195,
		-1,
		144,
		151,
		147,
		145,
		116,
		91,
		98,
		116,
		89,
		84,
		94,
		83,
		80,
		78,
		97,
		83,
		81,
		96,
		112,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		173,
		161,
		148,
		130,
		170,
		-1,
		90,
		86,
		93,
		-1,
		109,
		-1,
		81,
		84,
		75,
		72,
		72,
		83,
		81,
		90,
		91,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		205,
		-1,
		-1,
		160,
		154,
		154,
		123,
		120,
		106,
		86,
		78,
		93,
		92,
		79,
		78,
		66,
		66,
		69,
		68,
		81,
		91,
		97,
		89,
		-1,
		-1,
		-1,
		202,
		188,
		192,
		152,
		171,
		-1,
		-1,
		221,
		177,
		163,
		-1,
		115,
		106,
		94,
		84,
		74,
		79,
		80,
		70,
		68,
		64,
		73,
		77,
		70,
		69,
		90,
		83,
		105,
		-1,
		-1,
		185,
		190,
		178,
		164,
		160,
		-1,
		-1,
		-1,
		167,
		168,
		134,
		113,
		95,
		-1,
		-1,
		78,
		71,
		65,
		67,
		56,
		76,
		83,
		76,
		63,
		78,
		88,
		96,
		95,
		-1,
		188,
		175,
		-1,
		-1,
		159,
		149,
		-1,
		-1,
		-1,
		-1,
		146,
		91,
		80,
		75,
		79,
		77,
		-1,
		51,
		58,
		55,
		74,
		81,
		78,
		63,
		57,
		68,
		83,
		100,
		-1,
		-1,
		173,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		103,
		97,
		68,
		61,
		65,
		-1,
		50,
		51,
		52,
		61,
		72,
		77,
		69,
		51,
		65,
		68,
		81,
		95,
		99,
		196,
		-1,
		126,
		-1,
		-1,
		-1,
		121,
		136,
		107,
		84,
		57,
		52,
		45,
		39,
		44,
		58,
		67,
		78,
		45,
		49,
		64,
		74,
		73,
		90,
		100,
		-1,
		-1,
		124,
		120,
		147,
		129,
		133,
		134,
		-1,
		-1,
		61,
		52,
		43,
		37,
		51,
		54,
		41,
		43,
		61,
		80,
		68,
		83,
		98,
		96,
		-1,
		-1,
		-1,
		136,
		-1,
		138,
		-1,
		-1,
		126,
		132,
		79,
		61,
		57,
		46,
		26,
		20,
		31,
		36,
		61,
		58,
		67,
		70,
		76,
		99,
		88,
		127,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		115,
		107,
		102,
		108,
		110,
		101,
		94,
		91,
		-1,
		38,
		0,
		24,
		25,
		36,
		51,
		56,
		62,
		66,
		73,
		89,
		88,
		83,
		119,
		110,
		116,
		-1,
		-1,
		206,
		195,
		184,
		190,
		-1,
		108,
		104,
		94,
		84,
		87,
		-1,
		-1,
		81,
		78,
		20,
		33,
		39,
		44,
		40,
		78,
		54,
		62,
		66,
		70,
		76,
		81,
		86,
		92,
		107,
		122,
		-1,
		160,
		197,
		190,
		158,
		166,
		197,
		-1,
		98,
		90,
		101,
		76,
		78,
		-1,
		-1,
		54,
		45,
		45,
		40,
		37,
		63,
		62,
		74,
		76,
		81,
		69,
		68,
		86,
		90,
		99,
		106,
		96,
		109,
		113,
		-1,
		153,
		173,
		152,
		155,
		179,
		193,
		-1,
		95,
		-1,
		-1,
		107,
		79,
		63,
		53,
		50,
		92,
		50,
		45,
		51,
		53,
		72,
		63,
		86,
		77,
		77,
		80,
		95,
		100,
		92,
		106,
		106,
		107,
		-1,
		142,
		153,
		146,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		123,
		-1,
		90,
		-1,
		73,
		77,
		57,
		61,
		76,
		63,
		70,
		84,
		92,
		75,
		85,
		81,
		82,
		91,
		102,
		114,
		113,
		114,
		167,
		123,
		126,
		137,
		148,
		163,
		167,
		-1,
		107,
		146,
		161,
		-1,
		132,
		-1,
		-1,
		-1,
		87,
		70,
		62,
		79,
		75,
		75,
		70,
		74,
		80,
		87,
		97,
		99,
		91,
		95,
		108,
		119,
		122,
		163,
		154,
		167,
		112,
		112,
		133,
		142,
		163,
		122,
		113,
		140,
		166,
		157,
		152,
		139,
		-1,
		-1,
		110,
		80,
		-1,
		-1,
		82,
		91,
		74,
		76,
		80,
		90,
		105,
		108,
		98,
		96,
		90,
		122,
		-1,
		156,
		155,
		144,
		141,
		117,
		108,
		103,
		130,
		-1,
		-1,
		125,
		141,
		136,
		140,
		156,
		181,
		-1,
		142,
		-1,
		-1,
		131,
		-1,
		-1,
		133,
		96,
		85,
		76,
		82,
		88,
		99,
		116,
		104,
		105,
		95,
		105,
		118,
		140,
		137,
		125,
		123,
		146,
		111,
		99,
		-1,
		112,
		110,
		116,
		123,
		140,
		170,
		-1,
		-1,
		158,
		149,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		81,
		86,
		111,
		118,
		113,
		107,
		101,
		108,
		107,
		115,
		123,
		149,
		163,
		152,
		148,
		147,
		155,
		104,
		97,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		95,
		103,
		103,
		106,
		104,
		99,
		110,
		102,
		106,
		123,
		-1,
		183,
		-1,
		135,
		111,
		125,
		140,
		148,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		139,
		107,
		112,
		107,
		105,
		116,
		105,
		108,
		122,
		117,
		-1,
		-1,
		123,
		126,
		-1,
		-1,
		148,
		167,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		96,
		121,
		110,
		118,
		113,
		109,
		115,
		118,
		107,
		111,
		123,
		-1,
		-1,
		130,
		131,
		136,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		134,
		97,
		114,
		128,
		133,
		131,
		122,
		113,
		120,
		118,
		114,
		125,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		94,
		119,
		127,
		144,
		138,
		116,
		131,
		121,
		112,
		121,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		123,
		113,
		161,
		136,
		131,
		118,
		125,
		125,
		118,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		151,
		147,
		138,
		138,
		126,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		125,
		157,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		119,
		124,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		121,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		202,
		191,
		202,
		210,
		183,
		190,
		-1,
		209,
		213,
		179,
		173,
		212,
		181,
		187,
		198,
		-1,
		-1,
		-1,
		202,
		201,
		169,
		167,
		176,
		181,
		188,
		-1,
		187,
		-1,
		223,
		202,
		213,
		218,
		162,
		159,
		179,
		198,
		180,
		172,
		238,
		192,
		163,
		157,
		175,
		165,
		174,
		166,
		-1,
		163,
		153,
		175,
		154,
		165,
		157,
		-1,
		-1,
		157,
		158,
		164,
		150,
		156,
		152,
		-1,
		162,
		146,
		-1,
		-1,
		147,
		148,
		132,
		135,
		143,
		141,
		154,
		146,
		141,
		-1,
		-1,
		138,
		134,
		141,
		128,
		124,
		141,
		154,
		136,
		150,
		149,
		-1,
		144,
		162,
		167,
		135,
		133,
		117,
		115,
		133,
		135,
		141,
		141,
		-1,
		153,
		154,
		149,
		157,
		157,
		133,
		120,
		120,
		130,
		123,
		142,
		130,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		153,
		136,
		153,
		145,
		135,
		150,
		143,
		123,
		120,
		118,
		115,
		131,
		129,
		139,
		-1,
		-1,
		244,
		213,
		244,
		202,
		183,
		-1,
		149,
		129,
		135,
		139,
		133,
		126,
		140,
		136,
		-1,
		109,
		108,
		136,
		122,
		133,
		204,
		-1,
		-1,
		202,
		194,
		179,
		182,
		159,
		155,
		144,
		143,
		135,
		121,
		117,
		123,
		126,
		126,
		132,
		103,
		113,
		117,
		115,
		140,
		-1,
		-1,
		175,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		165,
		171,
		157,
		178,
		154,
		145,
		137,
		131,
		119,
		121,
		118,
		131,
		119,
		100,
		125,
		129,
		110,
		131,
		126,
		-1,
		174,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		194,
		-1,
		166,
		154,
		155,
		140,
		137,
		124,
		112,
		125,
		110,
		117,
		116,
		104,
		102,
		132,
		107,
		129,
		126,
		145,
		150,
		144,
		153,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		202,
		203,
		178,
		151,
		154,
		141,
		132,
		119,
		108,
		119,
		108,
		105,
		113,
		96,
		111,
		102,
		101,
		119,
		129,
		137,
		141,
		147,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		203,
		195,
		180,
		178,
		-1,
		150,
		147,
		137,
		115,
		100,
		117,
		109,
		107,
		109,
		91,
		105,
		96,
		114,
		121,
		119,
		123,
		143,
		155,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		220,
		184,
		-1,
		179,
		-1,
		152,
		165,
		-1,
		121,
		117,
		99,
		100,
		95,
		110,
		102,
		87,
		84,
		102,
		105,
		112,
		116,
		132,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		177,
		166,
		165,
		-1,
		156,
		135,
		132,
		120,
		107,
		92,
		93,
		101,
		113,
		92,
		86,
		83,
		103,
		129,
		107,
		118,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		195,
		188,
		176,
		141,
		141,
		135,
		-1,
		131,
		110,
		101,
		90,
		88,
		101,
		93,
		101,
		81,
		79,
		98,
		110,
		101,
		109,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		140,
		163,
		200,
		174,
		160,
		165,
		140,
		133,
		127,
		144,
		127,
		108,
		97,
		89,
		78,
		89,
		97,
		95,
		77,
		86,
		92,
		116,
		97,
		103,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		154,
		161,
		193,
		165,
		178,
		-1,
		132,
		-1,
		121,
		117,
		102,
		97,
		94,
		81,
		80,
		94,
		94,
		84,
		79,
		86,
		121,
		121,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		204,
		199,
		174,
		151,
		135,
		171,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		104,
		100,
		85,
		89,
		91,
		94,
		82,
		88,
		89,
		71,
		95,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		130,
		182,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		97,
		92,
		88,
		90,
		87,
		76,
		89,
		82,
		76,
		70,
		83,
		87,
		88,
		77,
		73,
		70,
		84,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		150,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		116,
		100,
		102,
		98,
		90,
		85,
		71,
		64,
		75,
		60,
		78,
		84,
		75,
		70,
		69,
		80,
		-1,
		217,
		203,
		174,
		-1,
		-1,
		163,
		-1,
		127,
		141,
		157,
		-1,
		150,
		129,
		144,
		122,
		118,
		109,
		107,
		108,
		78,
		83,
		85,
		73,
		76,
		65,
		68,
		60,
		82,
		79,
		63,
		65,
		74,
		-1,
		223,
		210,
		168,
		164,
		153,
		173,
		124,
		112,
		144,
		-1,
		-1,
		176,
		-1,
		120,
		132,
		123,
		121,
		97,
		72,
		79,
		97,
		70,
		65,
		70,
		59,
		59,
		54,
		73,
		59,
		57,
		72,
		88,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		139,
		126,
		120,
		-1,
		161,
		-1,
		154,
		142,
		129,
		111,
		151,
		-1,
		71,
		67,
		74,
		-1,
		90,
		-1,
		62,
		65,
		56,
		51,
		48,
		59,
		57,
		66,
		67,
		-1,
		173,
		158,
		151,
		141,
		155,
		126,
		-1,
		181,
		-1,
		-1,
		141,
		135,
		135,
		104,
		101,
		87,
		67,
		59,
		74,
		73,
		60,
		59,
		47,
		47,
		50,
		44,
		57,
		67,
		73,
		65,
		-1,
		-1,
		-1,
		178,
		164,
		168,
		128,
		147,
		-1,
		-1,
		202,
		158,
		144,
		-1,
		96,
		87,
		75,
		65,
		55,
		60,
		61,
		51,
		49,
		45,
		54,
		53,
		46,
		45,
		66,
		59,
		81,
		-1,
		-1,
		161,
		166,
		154,
		140,
		142,
		-1,
		-1,
		-1,
		148,
		149,
		115,
		94,
		76,
		-1,
		-1,
		59,
		52,
		46,
		49,
		37,
		57,
		64,
		52,
		39,
		54,
		64,
		72,
		71,
		-1,
		164,
		151,
		-1,
		-1,
		141,
		131,
		-1,
		-1,
		-1,
		-1,
		127,
		72,
		61,
		56,
		60,
		58,
		-1,
		32,
		43,
		36,
		55,
		62,
		54,
		39,
		33,
		44,
		59,
		76,
		-1,
		-1,
		155,
		-1,
		117,
		-1,
		-1,
		-1,
		-1,
		84,
		78,
		49,
		42,
		46,
		-1,
		34,
		36,
		33,
		45,
		50,
		54,
		45,
		27,
		41,
		44,
		57,
		71,
		75,
		178,
		-1,
		108,
		-1,
		-1,
		-1,
		102,
		117,
		88,
		65,
		38,
		33,
		26,
		20,
		25,
		36,
		45,
		56,
		21,
		25,
		40,
		50,
		49,
		66,
		76,
		-1,
		-1,
		106,
		102,
		128,
		110,
		114,
		115,
		-1,
		-1,
		42,
		33,
		24,
		16,
		29,
		32,
		17,
		19,
		37,
		56,
		44,
		59,
		74,
		72,
		-1,
		-1,
		-1,
		118,
		-1,
		120,
		-1,
		-1,
		108,
		113,
		60,
		42,
		38,
		36,
		12,
		6,
		7,
		12,
		37,
		34,
		43,
		46,
		52,
		75,
		64,
		103,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		97,
		89,
		84,
		90,
		92,
		83,
		75,
		72,
		-1,
		42,
		35,
		0,
		15,
		12,
		27,
		32,
		38,
		42,
		49,
		65,
		64,
		59,
		95,
		86,
		92,
		-1,
		-1,
		183,
		172,
		161,
		167,
		-1,
		90,
		86,
		76,
		66,
		69,
		-1,
		-1,
		63,
		60,
		32,
		9,
		15,
		20,
		16,
		54,
		30,
		38,
		42,
		46,
		52,
		57,
		62,
		68,
		83,
		98,
		-1,
		137,
		174,
		167,
		135,
		143,
		174,
		-1,
		80,
		72,
		83,
		58,
		60,
		-1,
		-1,
		36,
		27,
		28,
		16,
		13,
		39,
		38,
		50,
		52,
		57,
		45,
		44,
		62,
		66,
		75,
		82,
		72,
		85,
		89,
		-1,
		130,
		150,
		129,
		132,
		156,
		170,
		-1,
		77,
		-1,
		-1,
		89,
		61,
		45,
		35,
		32,
		75,
		30,
		25,
		27,
		29,
		48,
		39,
		62,
		53,
		53,
		56,
		71,
		76,
		68,
		82,
		82,
		83,
		-1,
		119,
		130,
		123,
		-1,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		105,
		-1,
		72,
		-1,
		55,
		59,
		38,
		41,
		52,
		39,
		46,
		60,
		68,
		51,
		61,
		57,
		58,
		67,
		78,
		90,
		89,
		90,
		144,
		100,
		103,
		114,
		125,
		140,
		144,
		-1,
		89,
		128,
		143,
		-1,
		114,
		-1,
		-1,
		-1,
		69,
		51,
		43,
		59,
		51,
		51,
		46,
		50,
		56,
		63,
		73,
		75,
		67,
		71,
		84,
		95,
		98,
		140,
		131,
		144,
		89,
		89,
		110,
		119,
		140,
		104,
		95,
		122,
		143,
		139,
		134,
		121,
		-1,
		-1,
		92,
		61,
		-1,
		-1,
		58,
		67,
		50,
		52,
		56,
		66,
		81,
		84,
		74,
		72,
		66,
		98,
		-1,
		133,
		132,
		121,
		118,
		94,
		85,
		80,
		107,
		-1,
		-1,
		102,
		123,
		113,
		117,
		133,
		158,
		-1,
		124,
		-1,
		-1,
		113,
		-1,
		-1,
		109,
		72,
		61,
		52,
		58,
		64,
		75,
		92,
		80,
		81,
		71,
		81,
		94,
		117,
		114,
		102,
		100,
		123,
		88,
		76,
		-1,
		89,
		87,
		93,
		100,
		117,
		147,
		-1,
		-1,
		140,
		130,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		57,
		62,
		87,
		94,
		89,
		83,
		77,
		84,
		83,
		91,
		99,
		126,
		140,
		129,
		125,
		124,
		132,
		81,
		74,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		140,
		136,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		71,
		79,
		79,
		82,
		80,
		75,
		86,
		78,
		82,
		99,
		-1,
		160,
		-1,
		112,
		88,
		102,
		117,
		125,
		-1,
		-1,
		-1,
		157,
		143,
		136,
		124,
		122,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		115,
		83,
		88,
		83,
		81,
		92,
		81,
		84,
		98,
		93,
		-1,
		-1,
		100,
		103,
		-1,
		-1,
		125,
		144,
		-1,
		148,
		137,
		122,
		114,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		97,
		86,
		94,
		89,
		85,
		91,
		94,
		83,
		87,
		99,
		-1,
		-1,
		107,
		108,
		113,
		-1,
		132,
		-1,
		150,
		-1,
		117,
		123,
		111,
		-1,
		-1,
		-1,
		110,
		73,
		90,
		104,
		109,
		107,
		98,
		89,
		96,
		94,
		90,
		101,
		-1,
		-1,
		-1,
		150,
		124,
		157,
		148,
		131,
		111,
		103,
		122,
		-1,
		92,
		-1,
		67,
		70,
		95,
		103,
		120,
		114,
		92,
		107,
		97,
		88,
		97,
		156,
		-1,
		126,
		159,
		123,
		117,
		93,
		97,
		113,
		-1,
		89,
		71,
		-1,
		99,
		89,
		137,
		112,
		107,
		94,
		101,
		101,
		94,
		-1,
		-1,
		-1,
		128,
		127,
		119,
		113,
		113,
		98,
		89,
		-1,
		101,
		83,
		62,
		79,
		79,
		70,
		78,
		127,
		123,
		114,
		114,
		102,
		-1,
		229,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		122,
		117,
		90,
		78,
		84,
		80,
		66,
		72,
		74,
		82,
		80,
		77,
		89,
		85,
		105,
		101,
		133,
		-1,
		224,
		-1,
		158,
		-1,
		-1,
		140,
		120,
		112,
		101,
		90,
		88,
		79,
		70,
		92,
		108,
		92,
		90,
		95,
		100,
		-1,
		213,
		212,
		-1,
		159,
		151,
		137,
		-1,
		130,
		-1,
		136,
		97,
		-1,
		99,
		79,
		-1,
		101,
		97,
		-1,
		-1,
		200,
		175,
		-1,
		-1,
		-1,
		160,
		140,
		131,
		115,
		-1,
		90,
		90,
		-1,
		-1,
		-1,
		185,
		184,
		-1,
		153,
		156,
		-1,
		146,
		137,
		145,
		92,
		96,
		-1,
		-1,
		-1,
		194,
		175,
		169,
		168,
		166,
		161,
		158,
		144,
		128,
		106,
		95,
		116,
		-1,
		-1,
		-1,
		166,
		158,
		151,
		-1,
		-1,
		153,
		136,
		117,
		115,
		-1,
		-1,
		-1,
		188,
		169,
		-1,
		-1,
		143,
		-1,
		-1,
		149,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		177,
		-1,
		-1,
		-1,
		139,
		135,
		136,
		-1,
		-1,
		-1,
		-1,
		199,
		200,
		223,
		187,
		-1,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		202,
		200,
		-1,
		-1,
		-1,
		159,
		143,
		-1,
		129,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		164,
		-1,
		164,
		139,
		146,
		-1,
		-1,
		-1,
		-1,
		177,
		169,
		177,
		-1,
		149,
		151,
		-1,
		199,
		-1,
		-1,
		192,
		183,
		-1,
		-1,
		154,
		161,
		183,
		186,
		222,
		-1,
		173
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		220,
		224,
		190,
		184,
		223,
		192,
		198,
		209,
		-1,
		-1,
		-1,
		213,
		212,
		180,
		178,
		187,
		192,
		199,
		-1,
		198,
		-1,
		234,
		213,
		224,
		229,
		173,
		170,
		190,
		209,
		191,
		183,
		249,
		203,
		174,
		168,
		186,
		176,
		185,
		177,
		-1,
		174,
		164,
		186,
		165,
		176,
		168,
		-1,
		-1,
		168,
		169,
		175,
		161,
		167,
		163,
		-1,
		173,
		157,
		-1,
		-1,
		158,
		159,
		143,
		146,
		154,
		152,
		165,
		157,
		152,
		-1,
		-1,
		149,
		145,
		152,
		139,
		135,
		152,
		165,
		147,
		161,
		160,
		-1,
		155,
		173,
		178,
		146,
		144,
		128,
		126,
		144,
		146,
		152,
		152,
		-1,
		164,
		165,
		160,
		168,
		168,
		144,
		131,
		131,
		141,
		134,
		153,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		134,
		131,
		129,
		126,
		142,
		140,
		150,
		-1,
		-1,
		255,
		224,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		120,
		119,
		147,
		133,
		144,
		215,
		-1,
		-1,
		213,
		205,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		114,
		124,
		128,
		126,
		151,
		-1,
		-1,
		186,
		-1,
		-1,
		212,
		195,
		-1,
		178,
		185,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		111,
		136,
		140,
		121,
		142,
		137,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		171,
		174,
		180,
		204,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		115,
		113,
		143,
		118,
		140,
		137,
		156,
		161,
		155,
		164,
		-1,
		220,
		216,
		212,
		219,
		168,
		-1,
		-1,
		208,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		107,
		122,
		113,
		112,
		130,
		140,
		148,
		152,
		158,
		-1,
		270,
		-1,
		212,
		196,
		198,
		170,
		191,
		-1,
		228,
		214,
		206,
		191,
		189,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		120,
		102,
		116,
		107,
		125,
		132,
		130,
		134,
		154,
		166,
		230,
		220,
		-1,
		202,
		207,
		166,
		174,
		193,
		231,
		195,
		-1,
		190,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		113,
		98,
		95,
		113,
		116,
		123,
		127,
		143,
		-1,
		-1,
		215,
		219,
		208,
		159,
		178,
		202,
		239,
		188,
		177,
		176,
		-1,
		167,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		124,
		103,
		97,
		94,
		114,
		140,
		118,
		129,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		185,
		156,
		180,
		222,
		206,
		199,
		187,
		152,
		152,
		146,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		104,
		112,
		92,
		90,
		109,
		121,
		112,
		120,
		-1,
		-1,
		-1,
		215,
		204,
		205,
		151,
		174,
		211,
		185,
		171,
		176,
		151,
		144,
		138,
		155,
		138,
		119,
		108,
		100,
		89,
		100,
		108,
		106,
		88,
		97,
		103,
		127,
		108,
		114,
		-1,
		-1,
		222,
		212,
		196,
		198,
		195,
		165,
		172,
		204,
		176,
		189,
		-1,
		143,
		-1,
		132,
		128,
		113,
		108,
		105,
		92,
		91,
		105,
		105,
		95,
		90,
		97,
		132,
		132,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		215,
		210,
		185,
		162,
		146,
		182,
		-1,
		159,
		160,
		-1,
		137,
		131,
		128,
		115,
		111,
		96,
		100,
		102,
		105,
		93,
		99,
		100,
		82,
		106,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		208,
		187,
		180,
		200,
		141,
		193,
		-1,
		-1,
		144,
		137,
		-1,
		124,
		106,
		108,
		103,
		97,
		101,
		98,
		87,
		100,
		93,
		87,
		81,
		94,
		98,
		99,
		88,
		84,
		81,
		95,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		161,
		-1,
		153,
		145,
		135,
		129,
		123,
		119,
		117,
		125,
		109,
		112,
		107,
		101,
		94,
		82,
		75,
		86,
		71,
		89,
		95,
		86,
		81,
		80,
		91,
		-1,
		228,
		214,
		185,
		-1,
		-1,
		174,
		-1,
		138,
		152,
		168,
		-1,
		161,
		140,
		155,
		133,
		129,
		120,
		116,
		117,
		87,
		92,
		94,
		82,
		85,
		76,
		79,
		71,
		93,
		90,
		74,
		76,
		85,
		-1,
		234,
		221,
		179,
		175,
		164,
		184,
		135,
		123,
		155,
		-1,
		-1,
		185,
		-1,
		131,
		141,
		134,
		132,
		106,
		81,
		88,
		106,
		79,
		74,
		81,
		70,
		70,
		65,
		84,
		70,
		68,
		83,
		99,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		150,
		137,
		131,
		-1,
		172,
		-1,
		163,
		151,
		138,
		120,
		160,
		-1,
		80,
		76,
		83,
		-1,
		99,
		-1,
		71,
		74,
		65,
		62,
		59,
		70,
		68,
		77,
		78,
		-1,
		184,
		169,
		162,
		152,
		166,
		137,
		-1,
		192,
		-1,
		-1,
		150,
		144,
		144,
		113,
		110,
		96,
		76,
		68,
		83,
		82,
		69,
		68,
		56,
		56,
		59,
		55,
		68,
		78,
		84,
		76,
		-1,
		-1,
		-1,
		189,
		175,
		179,
		139,
		158,
		-1,
		-1,
		211,
		167,
		153,
		-1,
		105,
		96,
		84,
		74,
		64,
		69,
		70,
		60,
		58,
		54,
		63,
		64,
		57,
		56,
		77,
		70,
		92,
		-1,
		-1,
		172,
		177,
		165,
		151,
		153,
		-1,
		-1,
		-1,
		157,
		158,
		124,
		103,
		85,
		-1,
		-1,
		68,
		61,
		55,
		58,
		46,
		66,
		73,
		63,
		50,
		65,
		75,
		83,
		82,
		-1,
		175,
		162,
		-1,
		-1,
		152,
		142,
		-1,
		-1,
		-1,
		-1,
		136,
		81,
		70,
		65,
		69,
		67,
		-1,
		41,
		51,
		45,
		64,
		71,
		65,
		50,
		44,
		55,
		70,
		87,
		-1,
		-1,
		166,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		93,
		87,
		58,
		51,
		55,
		-1,
		43,
		44,
		42,
		54,
		57,
		62,
		56,
		38,
		52,
		55,
		68,
		82,
		86,
		189,
		-1,
		119,
		-1,
		-1,
		-1,
		111,
		126,
		97,
		74,
		47,
		42,
		35,
		29,
		34,
		43,
		52,
		63,
		32,
		36,
		51,
		61,
		60,
		77,
		87,
		-1,
		-1,
		117,
		113,
		137,
		119,
		123,
		124,
		-1,
		-1,
		51,
		42,
		33,
		27,
		36,
		39,
		28,
		30,
		48,
		67,
		55,
		70,
		85,
		83,
		-1,
		-1,
		-1,
		129,
		-1,
		131,
		-1,
		-1,
		119,
		122,
		69,
		51,
		47,
		45,
		16,
		10,
		18,
		23,
		48,
		45,
		54,
		57,
		63,
		86,
		75,
		114,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		108,
		100,
		95,
		101,
		103,
		94,
		84,
		81,
		-1,
		48,
		33,
		11,
		0,
		23,
		38,
		43,
		49,
		53,
		60,
		76,
		75,
		70,
		106,
		97,
		103,
		-1,
		-1,
		194,
		183,
		172,
		178,
		-1,
		101,
		97,
		87,
		77,
		80,
		-1,
		-1,
		74,
		71,
		30,
		20,
		26,
		31,
		27,
		65,
		41,
		49,
		53,
		57,
		63,
		68,
		73,
		79,
		94,
		109,
		-1,
		148,
		185,
		178,
		146,
		154,
		185,
		-1,
		91,
		83,
		94,
		69,
		71,
		-1,
		-1,
		47,
		38,
		39,
		27,
		24,
		50,
		49,
		61,
		63,
		68,
		56,
		55,
		73,
		77,
		86,
		93,
		83,
		96,
		100,
		-1,
		141,
		161,
		140,
		143,
		167,
		181,
		-1,
		88,
		-1,
		-1,
		100,
		72,
		56,
		46,
		43,
		86,
		41,
		36,
		38,
		40,
		59,
		50,
		73,
		64,
		64,
		67,
		82,
		87,
		79,
		93,
		93,
		94,
		-1,
		130,
		141,
		134,
		-1,
		-1,
		-1,
		-1,
		89,
		-1,
		-1,
		116,
		-1,
		83,
		-1,
		66,
		70,
		49,
		52,
		63,
		50,
		57,
		71,
		79,
		62,
		72,
		68,
		69,
		78,
		89,
		101,
		100,
		101,
		155,
		111,
		114,
		125,
		136,
		151,
		155,
		-1,
		100,
		139,
		154,
		-1,
		125,
		-1,
		-1,
		-1,
		80,
		62,
		54,
		70,
		62,
		62,
		57,
		61,
		67,
		74,
		84,
		86,
		78,
		82,
		95,
		106,
		109,
		151,
		142,
		155,
		100,
		100,
		121,
		130,
		151,
		115,
		106,
		133,
		154,
		150,
		145,
		132,
		-1,
		-1,
		103,
		72,
		-1,
		-1,
		69,
		78,
		61,
		63,
		67,
		77,
		92,
		95,
		85,
		83,
		77,
		109,
		-1,
		144,
		143,
		132,
		129,
		105,
		96,
		91,
		118,
		-1,
		-1,
		113,
		134,
		124,
		128,
		144,
		169,
		-1,
		135,
		-1,
		-1,
		124,
		-1,
		-1,
		120,
		83,
		72,
		63,
		69,
		75,
		86,
		103,
		91,
		92,
		82,
		92,
		105,
		128,
		125,
		113,
		111,
		134,
		99,
		87,
		-1,
		100,
		98,
		104,
		111,
		128,
		158,
		-1,
		-1,
		151,
		141,
		-1,
		-1,
		118,
		116,
		105,
		-1,
		95,
		68,
		73,
		98,
		105,
		100,
		94,
		88,
		95,
		94,
		102,
		110,
		137,
		151,
		140,
		136,
		135,
		143,
		92,
		85,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		113,
		106,
		94,
		82,
		72,
		82,
		90,
		90,
		93,
		91,
		86,
		97,
		89,
		93,
		110,
		-1,
		171,
		-1,
		123,
		99,
		113,
		128,
		136,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		147,
		131,
		112,
		-1,
		82,
		95,
		126,
		94,
		99,
		94,
		92,
		103,
		92,
		95,
		109,
		104,
		-1,
		-1,
		111,
		114,
		-1,
		-1,
		136,
		155,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		119,
		115,
		-1,
		-1,
		83,
		108,
		97,
		105,
		100,
		96,
		102,
		105,
		94,
		98,
		110,
		-1,
		-1,
		118,
		119,
		124,
		-1,
		143,
		-1,
		161,
		-1,
		128,
		134,
		122,
		-1,
		-1,
		-1,
		121,
		84,
		101,
		115,
		120,
		118,
		109,
		100,
		107,
		105,
		101,
		112,
		-1,
		-1,
		-1,
		161,
		135,
		168,
		159,
		142,
		122,
		114,
		133,
		-1,
		103,
		-1,
		78,
		81,
		106,
		114,
		131,
		125,
		103,
		118,
		108,
		99,
		108,
		167,
		-1,
		137,
		170,
		134,
		128,
		104,
		108,
		124,
		-1,
		100,
		82,
		-1,
		110,
		100,
		148,
		123,
		118,
		105,
		112,
		112,
		105,
		-1,
		-1,
		-1,
		139,
		138,
		130,
		124,
		124,
		109,
		100,
		-1,
		112,
		94,
		73,
		90,
		90,
		81,
		89,
		138,
		134,
		125,
		125,
		113,
		-1,
		240,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		133,
		128,
		101,
		89,
		95,
		91,
		77,
		83,
		85,
		93,
		91,
		88,
		100,
		96,
		116,
		112,
		144,
		-1,
		235,
		-1,
		169,
		-1,
		-1,
		151,
		131,
		123,
		112,
		101,
		99,
		90,
		81,
		103,
		119,
		103,
		101,
		106,
		111,
		-1,
		224,
		223,
		-1,
		170,
		162,
		148,
		-1,
		141,
		-1,
		147,
		108,
		-1,
		110,
		90,
		-1,
		112,
		108,
		-1,
		-1,
		211,
		186,
		-1,
		-1,
		-1,
		171,
		151,
		142,
		126,
		-1,
		101,
		101,
		-1,
		-1,
		-1,
		196,
		195,
		-1,
		164,
		167,
		-1,
		157,
		148,
		156,
		103,
		107,
		-1,
		-1,
		-1,
		205,
		186,
		180,
		179,
		177,
		172,
		169,
		155,
		139,
		117,
		106,
		127,
		-1,
		-1,
		-1,
		177,
		169,
		162,
		-1,
		-1,
		164,
		147,
		128,
		126,
		-1,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		154,
		-1,
		-1,
		160,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		188,
		-1,
		-1,
		-1,
		150,
		146,
		147,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		234,
		198,
		-1,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		213,
		211,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		140,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		175,
		-1,
		175,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		188,
		180,
		188,
		-1,
		160,
		162,
		-1,
		210,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		165,
		172,
		194,
		197,
		233,
		-1,
		184
	],
	[
		-1,
		201,
		190,
		201,
		209,
		182,
		189,
		-1,
		208,
		212,
		178,
		172,
		211,
		180,
		186,
		197,
		-1,
		-1,
		-1,
		201,
		200,
		168,
		166,
		175,
		180,
		187,
		-1,
		186,
		-1,
		222,
		201,
		212,
		217,
		161,
		158,
		178,
		197,
		179,
		171,
		237,
		191,
		162,
		156,
		174,
		164,
		173,
		165,
		-1,
		162,
		152,
		174,
		153,
		164,
		156,
		-1,
		-1,
		156,
		157,
		163,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		146,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		143,
		161,
		166,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		140,
		-1,
		152,
		153,
		148,
		156,
		156,
		132,
		119,
		119,
		129,
		122,
		141,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		122,
		119,
		117,
		114,
		130,
		128,
		138,
		-1,
		-1,
		243,
		212,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		108,
		107,
		135,
		121,
		132,
		203,
		-1,
		-1,
		201,
		193,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		102,
		112,
		116,
		114,
		139,
		-1,
		-1,
		174,
		-1,
		-1,
		200,
		183,
		-1,
		166,
		173,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		99,
		124,
		128,
		109,
		130,
		125,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		159,
		162,
		168,
		192,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		103,
		101,
		131,
		106,
		128,
		125,
		144,
		149,
		143,
		152,
		-1,
		208,
		204,
		200,
		207,
		156,
		-1,
		-1,
		196,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		95,
		110,
		101,
		100,
		118,
		128,
		136,
		140,
		146,
		-1,
		258,
		-1,
		200,
		184,
		186,
		158,
		179,
		-1,
		216,
		202,
		194,
		179,
		177,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		108,
		90,
		104,
		95,
		113,
		120,
		118,
		122,
		142,
		154,
		218,
		208,
		-1,
		190,
		195,
		154,
		162,
		181,
		219,
		183,
		-1,
		178,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		101,
		86,
		83,
		101,
		104,
		111,
		115,
		131,
		-1,
		-1,
		203,
		207,
		196,
		147,
		166,
		190,
		227,
		176,
		165,
		164,
		-1,
		155,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		112,
		91,
		85,
		82,
		102,
		128,
		106,
		117,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		173,
		144,
		168,
		210,
		194,
		187,
		175,
		140,
		140,
		134,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		92,
		100,
		80,
		78,
		97,
		109,
		100,
		108,
		-1,
		-1,
		-1,
		203,
		192,
		193,
		139,
		162,
		199,
		173,
		159,
		164,
		139,
		132,
		126,
		143,
		126,
		107,
		96,
		88,
		77,
		88,
		96,
		94,
		76,
		85,
		91,
		115,
		96,
		102,
		-1,
		-1,
		210,
		200,
		184,
		186,
		183,
		153,
		160,
		192,
		164,
		177,
		-1,
		131,
		-1,
		120,
		116,
		101,
		96,
		93,
		80,
		79,
		93,
		93,
		83,
		78,
		85,
		120,
		120,
		86,
		106,
		109,
		-1,
		-1,
		-1,
		203,
		198,
		173,
		150,
		134,
		170,
		-1,
		147,
		148,
		-1,
		125,
		119,
		116,
		103,
		99,
		84,
		88,
		90,
		93,
		81,
		87,
		88,
		70,
		94,
		-1,
		94,
		88,
		96,
		86,
		74,
		-1,
		-1,
		-1,
		196,
		175,
		168,
		188,
		129,
		181,
		-1,
		-1,
		132,
		125,
		-1,
		112,
		94,
		96,
		91,
		87,
		89,
		86,
		75,
		88,
		81,
		75,
		69,
		82,
		86,
		87,
		76,
		72,
		69,
		83,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		149,
		-1,
		141,
		133,
		123,
		117,
		111,
		107,
		105,
		115,
		99,
		101,
		97,
		89,
		84,
		70,
		63,
		74,
		59,
		77,
		83,
		74,
		69,
		68,
		79,
		-1,
		216,
		202,
		173,
		-1,
		-1,
		162,
		-1,
		126,
		140,
		156,
		-1,
		149,
		128,
		143,
		121,
		117,
		108,
		106,
		107,
		77,
		82,
		84,
		72,
		75,
		64,
		67,
		59,
		81,
		78,
		62,
		64,
		73,
		-1,
		222,
		209,
		167,
		163,
		152,
		172,
		123,
		111,
		143,
		-1,
		-1,
		175,
		-1,
		119,
		131,
		122,
		120,
		96,
		71,
		78,
		96,
		69,
		64,
		69,
		58,
		58,
		53,
		72,
		58,
		56,
		71,
		87,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		138,
		125,
		119,
		-1,
		160,
		-1,
		153,
		141,
		128,
		110,
		150,
		-1,
		70,
		66,
		73,
		-1,
		89,
		-1,
		61,
		64,
		55,
		50,
		47,
		58,
		56,
		65,
		66,
		-1,
		172,
		157,
		150,
		140,
		154,
		125,
		-1,
		180,
		-1,
		-1,
		140,
		134,
		134,
		103,
		100,
		86,
		66,
		58,
		73,
		72,
		59,
		58,
		46,
		46,
		49,
		43,
		56,
		66,
		72,
		64,
		-1,
		-1,
		-1,
		177,
		163,
		167,
		127,
		146,
		-1,
		-1,
		201,
		157,
		143,
		-1,
		95,
		86,
		74,
		64,
		54,
		59,
		60,
		50,
		48,
		44,
		53,
		52,
		45,
		44,
		65,
		58,
		80,
		-1,
		-1,
		160,
		165,
		153,
		139,
		154,
		-1,
		-1,
		-1,
		147,
		148,
		114,
		93,
		75,
		-1,
		-1,
		58,
		51,
		45,
		48,
		36,
		56,
		63,
		51,
		38,
		53,
		63,
		71,
		70,
		-1,
		163,
		150,
		-1,
		-1,
		153,
		143,
		-1,
		-1,
		-1,
		-1,
		126,
		71,
		60,
		55,
		59,
		57,
		-1,
		31,
		42,
		35,
		54,
		61,
		53,
		38,
		32,
		43,
		58,
		75,
		-1,
		-1,
		167,
		-1,
		129,
		-1,
		-1,
		-1,
		-1,
		83,
		77,
		48,
		41,
		45,
		-1,
		33,
		35,
		32,
		44,
		49,
		53,
		44,
		26,
		40,
		43,
		56,
		70,
		74,
		190,
		-1,
		120,
		-1,
		-1,
		-1,
		101,
		116,
		87,
		64,
		37,
		32,
		25,
		19,
		24,
		35,
		44,
		55,
		20,
		24,
		39,
		44,
		48,
		65,
		69,
		-1,
		-1,
		118,
		114,
		127,
		109,
		113,
		114,
		-1,
		-1,
		41,
		32,
		23,
		15,
		28,
		31,
		16,
		18,
		36,
		49,
		43,
		53,
		68,
		63,
		-1,
		-1,
		-1,
		130,
		-1,
		132,
		-1,
		-1,
		120,
		112,
		59,
		41,
		37,
		35,
		24,
		18,
		6,
		11,
		30,
		25,
		34,
		39,
		43,
		66,
		55,
		94,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		109,
		101,
		96,
		102,
		104,
		95,
		74,
		71,
		-1,
		41,
		47,
		12,
		19,
		0,
		18,
		23,
		29,
		33,
		40,
		56,
		55,
		50,
		86,
		77,
		83,
		-1,
		-1,
		195,
		184,
		173,
		179,
		-1,
		102,
		98,
		88,
		78,
		81,
		-1,
		-1,
		75,
		72,
		44,
		21,
		19,
		12,
		7,
		45,
		21,
		29,
		33,
		37,
		43,
		48,
		53,
		59,
		74,
		89,
		-1,
		149,
		186,
		179,
		147,
		155,
		186,
		-1,
		92,
		84,
		95,
		70,
		72,
		-1,
		-1,
		48,
		39,
		40,
		28,
		25,
		27,
		26,
		41,
		43,
		48,
		36,
		35,
		53,
		57,
		66,
		73,
		63,
		76,
		80,
		-1,
		142,
		162,
		141,
		144,
		168,
		182,
		-1,
		89,
		-1,
		-1,
		101,
		73,
		57,
		47,
		44,
		87,
		42,
		37,
		39,
		41,
		39,
		30,
		53,
		44,
		44,
		47,
		62,
		67,
		59,
		73,
		73,
		74,
		-1,
		131,
		142,
		135,
		-1,
		-1,
		-1,
		-1,
		90,
		-1,
		-1,
		117,
		-1,
		84,
		-1,
		67,
		71,
		50,
		53,
		64,
		51,
		43,
		51,
		59,
		42,
		52,
		48,
		49,
		58,
		69,
		81,
		80,
		81,
		156,
		112,
		115,
		126,
		137,
		152,
		156,
		-1,
		101,
		140,
		155,
		-1,
		126,
		-1,
		-1,
		-1,
		81,
		63,
		55,
		71,
		63,
		63,
		37,
		41,
		47,
		54,
		64,
		66,
		58,
		62,
		75,
		86,
		89,
		152,
		143,
		156,
		101,
		101,
		122,
		131,
		152,
		116,
		107,
		134,
		155,
		151,
		146,
		133,
		-1,
		-1,
		104,
		73,
		-1,
		-1,
		70,
		58,
		41,
		43,
		47,
		57,
		72,
		75,
		65,
		63,
		57,
		89,
		-1,
		145,
		144,
		133,
		130,
		106,
		97,
		92,
		119,
		-1,
		-1,
		114,
		135,
		125,
		129,
		145,
		170,
		-1,
		125,
		-1,
		-1,
		115,
		-1,
		-1,
		100,
		63,
		52,
		43,
		49,
		55,
		66,
		83,
		71,
		72,
		62,
		72,
		85,
		129,
		126,
		114,
		112,
		135,
		100,
		88,
		-1,
		101,
		99,
		105,
		112,
		129,
		159,
		-1,
		-1,
		141,
		121,
		-1,
		-1,
		98,
		96,
		85,
		-1,
		75,
		48,
		53,
		78,
		85,
		80,
		74,
		68,
		75,
		74,
		82,
		90,
		138,
		152,
		141,
		137,
		136,
		144,
		93,
		86,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		131,
		127,
		-1,
		-1,
		93,
		86,
		74,
		62,
		52,
		62,
		70,
		70,
		73,
		71,
		66,
		77,
		69,
		73,
		90,
		-1,
		172,
		-1,
		124,
		100,
		114,
		129,
		137,
		-1,
		-1,
		-1,
		148,
		134,
		127,
		115,
		113,
		-1,
		127,
		111,
		92,
		-1,
		62,
		75,
		106,
		74,
		79,
		74,
		72,
		83,
		72,
		75,
		89,
		84,
		-1,
		-1,
		112,
		115,
		-1,
		-1,
		137,
		140,
		-1,
		139,
		128,
		113,
		105,
		-1,
		-1,
		99,
		95,
		-1,
		-1,
		63,
		88,
		77,
		85,
		80,
		76,
		82,
		85,
		74,
		78,
		90,
		-1,
		-1,
		119,
		120,
		125,
		-1,
		123,
		-1,
		141,
		-1,
		108,
		114,
		102,
		-1,
		-1,
		-1,
		101,
		64,
		81,
		95,
		100,
		98,
		89,
		80,
		87,
		85,
		81,
		92,
		-1,
		-1,
		-1,
		141,
		115,
		148,
		139,
		122,
		102,
		94,
		113,
		-1,
		83,
		-1,
		58,
		61,
		86,
		94,
		111,
		105,
		83,
		98,
		88,
		79,
		88,
		147,
		-1,
		117,
		150,
		114,
		108,
		84,
		88,
		104,
		-1,
		80,
		62,
		-1,
		90,
		80,
		128,
		103,
		98,
		85,
		92,
		92,
		85,
		-1,
		-1,
		-1,
		119,
		118,
		110,
		104,
		104,
		89,
		80,
		-1,
		92,
		74,
		53,
		70,
		70,
		61,
		69,
		118,
		114,
		105,
		105,
		93,
		-1,
		220,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		113,
		108,
		81,
		69,
		75,
		71,
		57,
		63,
		65,
		73,
		71,
		68,
		80,
		76,
		96,
		92,
		124,
		-1,
		215,
		-1,
		149,
		-1,
		-1,
		131,
		111,
		103,
		92,
		81,
		79,
		70,
		61,
		83,
		99,
		83,
		81,
		86,
		91,
		-1,
		204,
		203,
		-1,
		150,
		142,
		128,
		-1,
		121,
		-1,
		127,
		88,
		-1,
		90,
		70,
		-1,
		92,
		88,
		-1,
		-1,
		191,
		166,
		-1,
		-1,
		-1,
		151,
		131,
		122,
		106,
		-1,
		81,
		81,
		-1,
		-1,
		-1,
		176,
		175,
		-1,
		144,
		147,
		-1,
		137,
		128,
		136,
		83,
		87,
		-1,
		-1,
		-1,
		185,
		166,
		160,
		159,
		157,
		152,
		149,
		135,
		119,
		97,
		86,
		107,
		-1,
		-1,
		-1,
		157,
		149,
		142,
		-1,
		-1,
		144,
		127,
		108,
		106,
		-1,
		-1,
		-1,
		179,
		160,
		-1,
		-1,
		134,
		-1,
		-1,
		140,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		168,
		-1,
		-1,
		-1,
		130,
		126,
		127,
		-1,
		-1,
		-1,
		-1,
		190,
		191,
		214,
		178,
		-1,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		193,
		191,
		-1,
		-1,
		-1,
		150,
		134,
		-1,
		120,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		155,
		-1,
		155,
		130,
		137,
		-1,
		-1,
		-1,
		-1,
		168,
		160,
		168,
		-1,
		140,
		142,
		-1,
		190,
		-1,
		-1,
		183,
		174,
		-1,
		-1,
		145,
		152,
		174,
		177,
		213,
		-1,
		164
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		218,
		222,
		188,
		182,
		221,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		211,
		210,
		178,
		176,
		185,
		190,
		197,
		-1,
		196,
		-1,
		232,
		211,
		222,
		227,
		171,
		168,
		188,
		207,
		189,
		181,
		247,
		201,
		172,
		166,
		184,
		174,
		183,
		175,
		-1,
		172,
		162,
		184,
		163,
		174,
		166,
		-1,
		-1,
		166,
		167,
		173,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		156,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		151,
		169,
		176,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		150,
		-1,
		160,
		161,
		156,
		164,
		166,
		142,
		129,
		129,
		139,
		132,
		151,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		143,
		160,
		152,
		142,
		157,
		150,
		132,
		129,
		127,
		124,
		140,
		138,
		148,
		-1,
		-1,
		253,
		222,
		251,
		209,
		190,
		-1,
		156,
		136,
		142,
		146,
		140,
		133,
		147,
		143,
		-1,
		118,
		117,
		145,
		131,
		142,
		213,
		-1,
		-1,
		211,
		203,
		186,
		189,
		166,
		162,
		151,
		150,
		142,
		128,
		124,
		130,
		133,
		133,
		139,
		112,
		122,
		126,
		124,
		149,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		193,
		-1,
		176,
		183,
		172,
		178,
		164,
		185,
		161,
		152,
		144,
		138,
		126,
		128,
		125,
		138,
		126,
		109,
		134,
		138,
		119,
		140,
		135,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		169,
		172,
		178,
		202,
		201,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		113,
		111,
		141,
		116,
		138,
		135,
		154,
		159,
		153,
		162,
		-1,
		218,
		214,
		210,
		217,
		166,
		-1,
		-1,
		206,
		-1,
		209,
		210,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		105,
		120,
		111,
		110,
		128,
		138,
		146,
		150,
		156,
		-1,
		268,
		-1,
		210,
		194,
		196,
		168,
		189,
		-1,
		226,
		210,
		202,
		187,
		187,
		-1,
		157,
		154,
		144,
		122,
		107,
		124,
		116,
		114,
		118,
		100,
		114,
		105,
		123,
		130,
		128,
		132,
		152,
		164,
		228,
		218,
		-1,
		200,
		205,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		111,
		96,
		93,
		111,
		114,
		121,
		125,
		141,
		-1,
		-1,
		213,
		217,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		142,
		139,
		127,
		114,
		99,
		100,
		108,
		121,
		100,
		95,
		92,
		112,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		108,
		103,
		110,
		90,
		88,
		107,
		119,
		110,
		119,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		151,
		134,
		115,
		104,
		96,
		85,
		99,
		107,
		104,
		86,
		95,
		101,
		125,
		107,
		113,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		91,
		90,
		101,
		103,
		93,
		88,
		95,
		130,
		130,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		95,
		99,
		99,
		104,
		92,
		97,
		98,
		80,
		105,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		107,
		102,
		101,
		100,
		97,
		86,
		99,
		92,
		85,
		80,
		93,
		97,
		98,
		87,
		83,
		80,
		94,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		129,
		113,
		112,
		109,
		100,
		99,
		81,
		74,
		85,
		70,
		88,
		94,
		85,
		80,
		79,
		90,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		119,
		121,
		122,
		92,
		97,
		99,
		87,
		86,
		75,
		78,
		70,
		92,
		89,
		73,
		75,
		82,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		190,
		-1,
		129,
		146,
		133,
		131,
		111,
		86,
		93,
		111,
		84,
		79,
		80,
		69,
		69,
		64,
		83,
		69,
		67,
		80,
		96,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		168,
		156,
		143,
		125,
		165,
		-1,
		85,
		81,
		88,
		-1,
		104,
		-1,
		76,
		79,
		70,
		61,
		58,
		69,
		67,
		76,
		75,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		155,
		149,
		149,
		118,
		115,
		101,
		81,
		73,
		88,
		87,
		74,
		73,
		61,
		61,
		64,
		54,
		67,
		77,
		83,
		73,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		216,
		172,
		158,
		-1,
		110,
		101,
		89,
		79,
		69,
		74,
		75,
		65,
		63,
		59,
		68,
		63,
		56,
		55,
		75,
		67,
		89,
		-1,
		-1,
		170,
		175,
		163,
		149,
		160,
		-1,
		-1,
		-1,
		162,
		163,
		129,
		108,
		90,
		-1,
		-1,
		73,
		66,
		60,
		63,
		51,
		71,
		78,
		62,
		49,
		64,
		72,
		80,
		71,
		-1,
		173,
		160,
		-1,
		-1,
		159,
		149,
		-1,
		-1,
		-1,
		-1,
		141,
		86,
		75,
		70,
		74,
		72,
		-1,
		46,
		57,
		50,
		69,
		76,
		64,
		49,
		43,
		54,
		67,
		76,
		-1,
		-1,
		173,
		-1,
		135,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		63,
		56,
		60,
		-1,
		48,
		50,
		47,
		59,
		64,
		64,
		55,
		37,
		46,
		52,
		56,
		70,
		74,
		196,
		-1,
		126,
		-1,
		-1,
		-1,
		116,
		131,
		102,
		79,
		52,
		47,
		40,
		34,
		39,
		50,
		59,
		70,
		31,
		35,
		43,
		44,
		48,
		65,
		75,
		-1,
		-1,
		124,
		120,
		142,
		124,
		128,
		129,
		-1,
		-1,
		56,
		47,
		38,
		30,
		43,
		46,
		25,
		29,
		32,
		44,
		41,
		53,
		67,
		69,
		-1,
		-1,
		-1,
		136,
		-1,
		138,
		-1,
		-1,
		126,
		127,
		74,
		56,
		52,
		50,
		39,
		33,
		21,
		26,
		12,
		7,
		16,
		37,
		49,
		72,
		61,
		100,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		115,
		107,
		102,
		108,
		110,
		101,
		89,
		86,
		-1,
		56,
		62,
		27,
		34,
		17,
		0,
		5,
		11,
		35,
		46,
		62,
		61,
		56,
		92,
		83,
		89,
		-1,
		-1,
		201,
		190,
		179,
		185,
		-1,
		108,
		104,
		94,
		84,
		87,
		-1,
		-1,
		81,
		78,
		58,
		27,
		25,
		18,
		13,
		39,
		27,
		35,
		39,
		43,
		49,
		54,
		59,
		65,
		80,
		95,
		-1,
		155,
		192,
		185,
		153,
		161,
		192,
		-1,
		98,
		90,
		101,
		76,
		78,
		-1,
		-1,
		54,
		45,
		46,
		34,
		31,
		37,
		36,
		47,
		49,
		53,
		42,
		41,
		59,
		63,
		72,
		79,
		69,
		82,
		86,
		-1,
		148,
		168,
		147,
		150,
		174,
		188,
		-1,
		95,
		-1,
		-1,
		107,
		79,
		63,
		53,
		50,
		93,
		48,
		43,
		45,
		47,
		45,
		36,
		54,
		50,
		50,
		53,
		68,
		73,
		65,
		79,
		79,
		80,
		-1,
		137,
		148,
		141,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		123,
		-1,
		90,
		-1,
		73,
		77,
		56,
		59,
		70,
		57,
		49,
		57,
		65,
		48,
		58,
		54,
		55,
		64,
		75,
		87,
		86,
		87,
		162,
		118,
		121,
		132,
		143,
		158,
		162,
		-1,
		107,
		146,
		161,
		-1,
		132,
		-1,
		-1,
		-1,
		87,
		69,
		61,
		77,
		69,
		69,
		43,
		47,
		53,
		60,
		70,
		72,
		64,
		68,
		81,
		92,
		95,
		158,
		149,
		162,
		107,
		107,
		128,
		137,
		158,
		122,
		113,
		140,
		161,
		157,
		152,
		139,
		-1,
		-1,
		110,
		79,
		-1,
		-1,
		76,
		64,
		47,
		49,
		53,
		63,
		78,
		81,
		71,
		69,
		63,
		95,
		-1,
		151,
		150,
		139,
		136,
		112,
		103,
		98,
		125,
		-1,
		-1,
		120,
		141,
		131,
		135,
		151,
		176,
		-1,
		131,
		-1,
		-1,
		121,
		-1,
		-1,
		106,
		69,
		58,
		49,
		55,
		61,
		72,
		89,
		77,
		78,
		68,
		78,
		91,
		135,
		132,
		120,
		118,
		141,
		106,
		94,
		-1,
		107,
		105,
		111,
		118,
		135,
		165,
		-1,
		-1,
		147,
		127,
		-1,
		-1,
		104,
		102,
		91,
		-1,
		81,
		54,
		59,
		84,
		91,
		86,
		80,
		74,
		81,
		80,
		88,
		96,
		144,
		158,
		147,
		143,
		142,
		150,
		99,
		92,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		137,
		133,
		-1,
		-1,
		99,
		92,
		80,
		68,
		58,
		68,
		76,
		76,
		79,
		77,
		72,
		83,
		75,
		79,
		96,
		-1,
		178,
		-1,
		130,
		106,
		120,
		135,
		143,
		-1,
		-1,
		-1,
		154,
		140,
		133,
		121,
		119,
		-1,
		133,
		117,
		98,
		-1,
		68,
		81,
		112,
		80,
		85,
		80,
		78,
		89,
		78,
		81,
		95,
		90,
		-1,
		-1,
		118,
		121,
		-1,
		-1,
		143,
		146,
		-1,
		145,
		134,
		119,
		111,
		-1,
		-1,
		105,
		101,
		-1,
		-1,
		69,
		94,
		83,
		91,
		86,
		82,
		88,
		91,
		80,
		84,
		96,
		-1,
		-1,
		125,
		126,
		131,
		-1,
		129,
		-1,
		147,
		-1,
		114,
		120,
		108,
		-1,
		-1,
		-1,
		107,
		70,
		87,
		101,
		106,
		104,
		95,
		86,
		93,
		91,
		87,
		98,
		-1,
		-1,
		-1,
		147,
		121,
		154,
		145,
		128,
		108,
		100,
		119,
		-1,
		89,
		-1,
		64,
		67,
		92,
		100,
		117,
		111,
		89,
		104,
		94,
		85,
		94,
		153,
		-1,
		123,
		156,
		120,
		114,
		90,
		94,
		110,
		-1,
		86,
		68,
		-1,
		96,
		86,
		134,
		109,
		104,
		91,
		98,
		98,
		91,
		-1,
		-1,
		-1,
		125,
		124,
		116,
		110,
		110,
		95,
		86,
		-1,
		98,
		80,
		59,
		76,
		76,
		67,
		75,
		124,
		120,
		111,
		111,
		99,
		-1,
		226,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		119,
		114,
		87,
		75,
		81,
		77,
		63,
		69,
		71,
		79,
		77,
		74,
		86,
		82,
		102,
		98,
		130,
		-1,
		221,
		-1,
		155,
		-1,
		-1,
		137,
		117,
		109,
		98,
		87,
		85,
		76,
		67,
		89,
		105,
		89,
		87,
		92,
		97,
		-1,
		210,
		209,
		-1,
		156,
		148,
		134,
		-1,
		127,
		-1,
		133,
		94,
		-1,
		96,
		76,
		-1,
		98,
		94,
		-1,
		-1,
		197,
		172,
		-1,
		-1,
		-1,
		157,
		137,
		128,
		112,
		-1,
		87,
		87,
		-1,
		-1,
		-1,
		182,
		181,
		-1,
		150,
		153,
		-1,
		143,
		134,
		142,
		89,
		93,
		-1,
		-1,
		-1,
		191,
		172,
		166,
		165,
		163,
		158,
		155,
		141,
		125,
		103,
		92,
		113,
		-1,
		-1,
		-1,
		163,
		155,
		148,
		-1,
		-1,
		150,
		133,
		114,
		112,
		-1,
		-1,
		-1,
		185,
		166,
		-1,
		-1,
		140,
		-1,
		-1,
		146,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		174,
		-1,
		-1,
		-1,
		136,
		132,
		133,
		-1,
		-1,
		-1,
		-1,
		196,
		197,
		220,
		184,
		-1,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		199,
		197,
		-1,
		-1,
		-1,
		156,
		140,
		-1,
		126,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		161,
		-1,
		161,
		136,
		143,
		-1,
		-1,
		-1,
		-1,
		174,
		166,
		174,
		-1,
		146,
		148,
		-1,
		196,
		-1,
		-1,
		189,
		180,
		-1,
		-1,
		151,
		158,
		180,
		183,
		219,
		-1,
		170
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		149,
		167,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		158,
		159,
		154,
		162,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		141,
		158,
		150,
		140,
		155,
		148,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		249,
		218,
		249,
		207,
		188,
		-1,
		154,
		134,
		140,
		144,
		138,
		131,
		145,
		141,
		-1,
		114,
		113,
		141,
		127,
		138,
		209,
		-1,
		-1,
		207,
		199,
		184,
		187,
		164,
		160,
		149,
		148,
		140,
		126,
		122,
		128,
		131,
		131,
		137,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		170,
		176,
		162,
		183,
		159,
		150,
		142,
		136,
		124,
		126,
		123,
		136,
		124,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		199,
		-1,
		171,
		159,
		160,
		145,
		142,
		129,
		117,
		130,
		115,
		122,
		121,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		207,
		208,
		183,
		156,
		159,
		146,
		137,
		124,
		113,
		124,
		113,
		110,
		118,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		208,
		200,
		185,
		183,
		-1,
		155,
		152,
		142,
		120,
		105,
		122,
		114,
		112,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		157,
		170,
		-1,
		126,
		122,
		104,
		105,
		100,
		115,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		140,
		137,
		125,
		112,
		97,
		98,
		106,
		118,
		97,
		91,
		88,
		108,
		134,
		112,
		123,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		136,
		115,
		106,
		95,
		93,
		106,
		98,
		106,
		86,
		84,
		103,
		115,
		106,
		114,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		149,
		132,
		113,
		102,
		94,
		83,
		94,
		102,
		100,
		82,
		91,
		97,
		121,
		102,
		108,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		122,
		107,
		102,
		99,
		86,
		85,
		99,
		99,
		89,
		84,
		91,
		126,
		126,
		92,
		112,
		115,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		109,
		105,
		90,
		94,
		96,
		99,
		87,
		93,
		94,
		76,
		100,
		-1,
		100,
		94,
		102,
		92,
		80,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		102,
		97,
		96,
		95,
		92,
		81,
		94,
		87,
		81,
		75,
		88,
		92,
		93,
		82,
		78,
		75,
		89,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		124,
		108,
		107,
		104,
		95,
		102,
		76,
		69,
		80,
		65,
		83,
		89,
		80,
		75,
		74,
		85,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		114,
		124,
		125,
		95,
		100,
		102,
		90,
		81,
		70,
		73,
		65,
		87,
		84,
		68,
		70,
		77,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		128,
		126,
		114,
		89,
		96,
		113,
		87,
		82,
		75,
		64,
		64,
		59,
		78,
		64,
		62,
		75,
		91,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		88,
		84,
		91,
		-1,
		107,
		-1,
		79,
		80,
		71,
		56,
		53,
		64,
		62,
		71,
		70,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		121,
		118,
		104,
		84,
		76,
		91,
		90,
		77,
		76,
		64,
		62,
		59,
		49,
		62,
		72,
		78,
		68,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		113,
		104,
		92,
		82,
		72,
		77,
		78,
		68,
		66,
		62,
		69,
		58,
		51,
		50,
		70,
		62,
		84,
		-1,
		-1,
		166,
		171,
		159,
		145,
		163,
		-1,
		-1,
		-1,
		165,
		166,
		132,
		111,
		93,
		-1,
		-1,
		76,
		69,
		63,
		66,
		54,
		74,
		75,
		57,
		44,
		59,
		67,
		75,
		66,
		-1,
		169,
		156,
		-1,
		-1,
		162,
		152,
		-1,
		-1,
		-1,
		-1,
		144,
		89,
		78,
		73,
		77,
		75,
		-1,
		49,
		60,
		53,
		72,
		79,
		59,
		44,
		38,
		49,
		62,
		71,
		-1,
		-1,
		176,
		-1,
		138,
		-1,
		-1,
		-1,
		-1,
		101,
		95,
		66,
		59,
		63,
		-1,
		51,
		53,
		50,
		62,
		62,
		59,
		50,
		32,
		41,
		47,
		51,
		65,
		69,
		199,
		-1,
		129,
		-1,
		-1,
		-1,
		119,
		134,
		105,
		82,
		55,
		50,
		43,
		37,
		42,
		53,
		62,
		73,
		26,
		30,
		38,
		39,
		43,
		60,
		70,
		-1,
		-1,
		127,
		123,
		145,
		127,
		131,
		132,
		-1,
		-1,
		59,
		50,
		41,
		33,
		46,
		49,
		20,
		24,
		27,
		39,
		36,
		48,
		62,
		67,
		-1,
		-1,
		-1,
		139,
		-1,
		141,
		-1,
		-1,
		129,
		130,
		77,
		59,
		55,
		53,
		42,
		36,
		24,
		23,
		7,
		2,
		11,
		32,
		47,
		70,
		59,
		98,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		118,
		110,
		105,
		111,
		113,
		104,
		92,
		89,
		-1,
		59,
		65,
		30,
		37,
		20,
		3,
		0,
		6,
		30,
		44,
		60,
		59,
		54,
		90,
		81,
		87,
		-1,
		-1,
		204,
		193,
		182,
		188,
		-1,
		111,
		107,
		97,
		87,
		90,
		-1,
		-1,
		84,
		81,
		61,
		30,
		28,
		21,
		16,
		40,
		30,
		33,
		37,
		41,
		47,
		52,
		57,
		63,
		78,
		93,
		-1,
		158,
		195,
		188,
		156,
		164,
		195,
		-1,
		101,
		93,
		104,
		79,
		81,
		-1,
		-1,
		57,
		48,
		49,
		37,
		34,
		40,
		39,
		50,
		47,
		48,
		40,
		39,
		57,
		61,
		70,
		77,
		67,
		80,
		84,
		-1,
		151,
		171,
		150,
		153,
		177,
		191,
		-1,
		98,
		-1,
		-1,
		110,
		82,
		66,
		56,
		53,
		96,
		51,
		46,
		48,
		50,
		48,
		39,
		49,
		48,
		48,
		51,
		66,
		71,
		63,
		77,
		77,
		78,
		-1,
		140,
		151,
		144,
		-1,
		-1,
		-1,
		-1,
		99,
		-1,
		-1,
		126,
		-1,
		93,
		-1,
		76,
		80,
		59,
		62,
		73,
		60,
		52,
		55,
		68,
		46,
		56,
		52,
		53,
		62,
		73,
		85,
		84,
		85,
		165,
		121,
		124,
		135,
		146,
		161,
		165,
		-1,
		110,
		149,
		164,
		-1,
		135,
		-1,
		-1,
		-1,
		90,
		72,
		64,
		80,
		72,
		72,
		46,
		50,
		51,
		58,
		68,
		70,
		62,
		66,
		79,
		90,
		93,
		161,
		152,
		165,
		110,
		110,
		131,
		140,
		161,
		125,
		116,
		143,
		164,
		160,
		155,
		142,
		-1,
		-1,
		113,
		82,
		-1,
		-1,
		79,
		67,
		50,
		52,
		56,
		61,
		76,
		79,
		69,
		67,
		61,
		93,
		-1,
		154,
		153,
		142,
		139,
		115,
		106,
		101,
		128,
		-1,
		-1,
		123,
		144,
		134,
		138,
		154,
		179,
		-1,
		134,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		72,
		61,
		52,
		58,
		64,
		75,
		87,
		75,
		76,
		66,
		76,
		89,
		138,
		135,
		123,
		121,
		144,
		109,
		97,
		-1,
		110,
		108,
		114,
		121,
		138,
		168,
		-1,
		-1,
		150,
		130,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		57,
		62,
		87,
		94,
		84,
		78,
		72,
		79,
		78,
		86,
		94,
		147,
		161,
		150,
		146,
		145,
		153,
		102,
		95,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		140,
		136,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		71,
		79,
		79,
		82,
		75,
		70,
		81,
		73,
		77,
		94,
		-1,
		181,
		-1,
		133,
		109,
		123,
		138,
		146,
		-1,
		-1,
		-1,
		157,
		143,
		136,
		124,
		122,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		115,
		83,
		88,
		83,
		76,
		87,
		76,
		79,
		93,
		88,
		-1,
		-1,
		121,
		124,
		-1,
		-1,
		146,
		149,
		-1,
		148,
		137,
		122,
		114,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		97,
		86,
		94,
		89,
		80,
		86,
		89,
		78,
		82,
		94,
		-1,
		-1,
		128,
		129,
		134,
		-1,
		132,
		-1,
		150,
		-1,
		117,
		123,
		111,
		-1,
		-1,
		-1,
		110,
		73,
		90,
		104,
		109,
		107,
		98,
		84,
		91,
		89,
		85,
		96,
		-1,
		-1,
		-1,
		150,
		124,
		157,
		148,
		131,
		111,
		103,
		122,
		-1,
		92,
		-1,
		67,
		70,
		95,
		103,
		120,
		114,
		87,
		102,
		92,
		83,
		92,
		156,
		-1,
		126,
		159,
		123,
		117,
		93,
		97,
		113,
		-1,
		89,
		71,
		-1,
		99,
		89,
		136,
		112,
		102,
		89,
		96,
		96,
		89,
		-1,
		-1,
		-1,
		128,
		127,
		119,
		113,
		113,
		98,
		89,
		-1,
		101,
		83,
		62,
		79,
		79,
		70,
		78,
		126,
		122,
		109,
		109,
		101,
		-1,
		229,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		122,
		117,
		90,
		78,
		84,
		80,
		66,
		72,
		74,
		82,
		80,
		77,
		89,
		85,
		105,
		101,
		133,
		-1,
		224,
		-1,
		158,
		-1,
		-1,
		140,
		120,
		112,
		101,
		90,
		88,
		79,
		70,
		92,
		108,
		92,
		90,
		95,
		100,
		-1,
		213,
		212,
		-1,
		159,
		151,
		137,
		-1,
		130,
		-1,
		136,
		97,
		-1,
		99,
		79,
		-1,
		101,
		97,
		-1,
		-1,
		200,
		175,
		-1,
		-1,
		-1,
		160,
		140,
		131,
		115,
		-1,
		90,
		90,
		-1,
		-1,
		-1,
		185,
		184,
		-1,
		153,
		156,
		-1,
		146,
		137,
		145,
		92,
		96,
		-1,
		-1,
		-1,
		194,
		175,
		169,
		168,
		166,
		161,
		158,
		144,
		128,
		106,
		95,
		116,
		-1,
		-1,
		-1,
		166,
		158,
		151,
		-1,
		-1,
		153,
		136,
		117,
		115,
		-1,
		-1,
		-1,
		188,
		169,
		-1,
		-1,
		143,
		-1,
		-1,
		149,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		177,
		-1,
		-1,
		-1,
		139,
		135,
		136,
		-1,
		-1,
		-1,
		-1,
		199,
		200,
		223,
		187,
		-1,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		202,
		200,
		-1,
		-1,
		-1,
		159,
		143,
		-1,
		129,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		164,
		-1,
		164,
		139,
		146,
		-1,
		-1,
		-1,
		-1,
		177,
		169,
		177,
		-1,
		149,
		151,
		-1,
		199,
		-1,
		-1,
		192,
		183,
		-1,
		-1,
		154,
		161,
		183,
		186,
		222,
		-1,
		173
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		143,
		161,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		152,
		153,
		148,
		156,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		245,
		214,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		110,
		109,
		137,
		123,
		134,
		205,
		-1,
		-1,
		203,
		195,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		202,
		194,
		179,
		179,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		221,
		185,
		-1,
		180,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		113,
		92,
		87,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		97,
		102,
		82,
		80,
		99,
		111,
		102,
		114,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		143,
		126,
		107,
		96,
		88,
		77,
		93,
		101,
		96,
		78,
		87,
		93,
		117,
		102,
		108,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		86,
		84,
		93,
		95,
		85,
		80,
		87,
		122,
		122,
		92,
		112,
		115,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		90,
		94,
		91,
		98,
		87,
		89,
		90,
		72,
		100,
		-1,
		100,
		94,
		102,
		92,
		80,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		102,
		97,
		95,
		95,
		92,
		81,
		94,
		87,
		77,
		75,
		88,
		92,
		93,
		82,
		78,
		75,
		89,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		107,
		104,
		95,
		103,
		76,
		69,
		80,
		65,
		83,
		89,
		80,
		75,
		74,
		85,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		114,
		130,
		131,
		103,
		104,
		102,
		93,
		81,
		70,
		73,
		65,
		87,
		84,
		68,
		70,
		71,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		128,
		126,
		120,
		97,
		104,
		113,
		90,
		85,
		75,
		64,
		64,
		59,
		78,
		64,
		62,
		69,
		85,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		96,
		92,
		99,
		-1,
		110,
		-1,
		83,
		80,
		71,
		56,
		53,
		64,
		62,
		71,
		64,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		129,
		126,
		112,
		92,
		84,
		99,
		98,
		85,
		84,
		69,
		62,
		59,
		49,
		62,
		72,
		78,
		62,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		121,
		112,
		100,
		90,
		80,
		85,
		86,
		76,
		74,
		67,
		69,
		58,
		51,
		50,
		64,
		56,
		78,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		174,
		140,
		119,
		101,
		-1,
		-1,
		84,
		77,
		71,
		74,
		62,
		80,
		75,
		57,
		44,
		59,
		61,
		69,
		60,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		152,
		97,
		86,
		81,
		85,
		83,
		-1,
		57,
		68,
		61,
		80,
		87,
		59,
		44,
		38,
		44,
		56,
		65,
		-1,
		-1,
		177,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		74,
		67,
		71,
		-1,
		59,
		61,
		58,
		70,
		62,
		59,
		50,
		38,
		35,
		41,
		45,
		59,
		63,
		200,
		-1,
		137,
		-1,
		-1,
		-1,
		127,
		142,
		113,
		90,
		63,
		58,
		51,
		45,
		50,
		61,
		70,
		81,
		34,
		36,
		32,
		33,
		37,
		54,
		64,
		-1,
		-1,
		135,
		131,
		153,
		135,
		139,
		140,
		-1,
		-1,
		67,
		58,
		49,
		41,
		54,
		57,
		28,
		32,
		23,
		33,
		30,
		42,
		56,
		61,
		-1,
		-1,
		-1,
		147,
		-1,
		149,
		-1,
		-1,
		137,
		138,
		85,
		67,
		63,
		61,
		50,
		44,
		32,
		31,
		15,
		4,
		5,
		26,
		41,
		64,
		53,
		92,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		126,
		118,
		113,
		119,
		121,
		112,
		100,
		97,
		-1,
		67,
		73,
		38,
		45,
		28,
		11,
		8,
		0,
		24,
		38,
		54,
		53,
		48,
		84,
		75,
		81,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		119,
		115,
		105,
		95,
		98,
		-1,
		-1,
		92,
		89,
		69,
		38,
		36,
		29,
		24,
		39,
		29,
		27,
		31,
		35,
		41,
		46,
		51,
		57,
		72,
		87,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		109,
		101,
		112,
		87,
		89,
		-1,
		-1,
		65,
		56,
		57,
		45,
		42,
		48,
		47,
		49,
		41,
		42,
		34,
		33,
		51,
		55,
		64,
		71,
		61,
		74,
		78,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		106,
		-1,
		-1,
		118,
		90,
		74,
		64,
		61,
		104,
		59,
		54,
		56,
		56,
		47,
		38,
		43,
		42,
		42,
		45,
		60,
		65,
		57,
		71,
		71,
		72,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		134,
		-1,
		101,
		-1,
		84,
		88,
		67,
		70,
		72,
		59,
		51,
		49,
		65,
		40,
		50,
		46,
		47,
		56,
		67,
		79,
		78,
		79,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		118,
		157,
		166,
		-1,
		143,
		-1,
		-1,
		-1,
		98,
		80,
		72,
		88,
		71,
		71,
		45,
		49,
		45,
		52,
		62,
		64,
		56,
		60,
		73,
		84,
		87,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		133,
		124,
		151,
		172,
		162,
		157,
		144,
		-1,
		-1,
		121,
		90,
		-1,
		-1,
		78,
		66,
		49,
		51,
		52,
		55,
		70,
		73,
		63,
		61,
		55,
		87,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		152,
		142,
		146,
		162,
		187,
		-1,
		133,
		-1,
		-1,
		123,
		-1,
		-1,
		108,
		71,
		60,
		51,
		57,
		60,
		71,
		81,
		69,
		70,
		60,
		70,
		83,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		118,
		116,
		122,
		129,
		146,
		176,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		106,
		104,
		93,
		-1,
		83,
		56,
		61,
		86,
		89,
		78,
		72,
		66,
		73,
		72,
		80,
		88,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		101,
		94,
		82,
		70,
		60,
		70,
		78,
		78,
		76,
		69,
		64,
		75,
		67,
		71,
		88,
		-1,
		189,
		-1,
		141,
		117,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		135,
		119,
		100,
		-1,
		70,
		83,
		114,
		82,
		87,
		82,
		70,
		81,
		70,
		73,
		87,
		82,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		107,
		103,
		-1,
		-1,
		71,
		96,
		85,
		93,
		88,
		74,
		80,
		83,
		72,
		76,
		88,
		-1,
		-1,
		136,
		137,
		142,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		109,
		72,
		89,
		103,
		103,
		101,
		92,
		78,
		85,
		83,
		79,
		90,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		91,
		-1,
		66,
		69,
		94,
		102,
		114,
		108,
		81,
		96,
		86,
		77,
		86,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		88,
		70,
		-1,
		98,
		88,
		130,
		111,
		96,
		83,
		90,
		90,
		83,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		78,
		78,
		69,
		77,
		120,
		116,
		103,
		103,
		95,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		73,
		81,
		79,
		76,
		88,
		84,
		104,
		96,
		131,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		107,
		91,
		89,
		94,
		99,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		100,
		96,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		181,
		170,
		181,
		189,
		162,
		169,
		-1,
		188,
		192,
		158,
		152,
		191,
		160,
		166,
		177,
		-1,
		-1,
		-1,
		181,
		180,
		148,
		146,
		155,
		160,
		167,
		-1,
		166,
		-1,
		202,
		181,
		192,
		197,
		141,
		138,
		158,
		177,
		159,
		151,
		217,
		171,
		142,
		136,
		154,
		144,
		153,
		145,
		-1,
		142,
		132,
		154,
		133,
		144,
		136,
		-1,
		-1,
		136,
		137,
		143,
		129,
		135,
		131,
		-1,
		141,
		125,
		-1,
		-1,
		126,
		127,
		111,
		114,
		122,
		120,
		133,
		125,
		120,
		-1,
		-1,
		117,
		113,
		120,
		107,
		103,
		120,
		133,
		115,
		129,
		128,
		-1,
		121,
		139,
		146,
		114,
		112,
		96,
		94,
		112,
		114,
		120,
		120,
		-1,
		130,
		131,
		126,
		134,
		136,
		112,
		99,
		99,
		109,
		102,
		121,
		109,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		130,
		113,
		130,
		122,
		112,
		127,
		120,
		102,
		99,
		97,
		94,
		110,
		108,
		118,
		-1,
		-1,
		223,
		192,
		221,
		179,
		160,
		-1,
		126,
		106,
		112,
		116,
		110,
		103,
		117,
		113,
		-1,
		88,
		87,
		115,
		101,
		112,
		183,
		-1,
		-1,
		181,
		173,
		156,
		159,
		136,
		132,
		121,
		120,
		112,
		98,
		94,
		100,
		103,
		103,
		109,
		82,
		92,
		96,
		94,
		119,
		-1,
		-1,
		154,
		-1,
		-1,
		180,
		163,
		-1,
		146,
		153,
		142,
		148,
		134,
		155,
		131,
		122,
		114,
		108,
		96,
		98,
		95,
		108,
		96,
		79,
		104,
		108,
		89,
		110,
		105,
		-1,
		153,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		139,
		142,
		148,
		172,
		171,
		-1,
		143,
		131,
		132,
		117,
		114,
		101,
		89,
		102,
		87,
		94,
		93,
		83,
		81,
		111,
		86,
		108,
		105,
		124,
		129,
		123,
		132,
		-1,
		188,
		184,
		180,
		187,
		136,
		-1,
		-1,
		176,
		-1,
		179,
		180,
		155,
		128,
		131,
		118,
		109,
		96,
		85,
		96,
		85,
		82,
		90,
		75,
		90,
		81,
		80,
		98,
		108,
		116,
		120,
		126,
		-1,
		238,
		-1,
		180,
		164,
		166,
		138,
		159,
		-1,
		196,
		180,
		172,
		157,
		157,
		-1,
		127,
		124,
		114,
		92,
		77,
		94,
		86,
		84,
		88,
		70,
		84,
		75,
		93,
		100,
		98,
		102,
		122,
		134,
		198,
		188,
		-1,
		170,
		175,
		134,
		142,
		161,
		199,
		163,
		-1,
		158,
		-1,
		129,
		142,
		-1,
		98,
		94,
		76,
		77,
		72,
		87,
		81,
		66,
		63,
		81,
		84,
		91,
		95,
		111,
		-1,
		-1,
		183,
		187,
		176,
		127,
		146,
		170,
		207,
		156,
		145,
		144,
		-1,
		135,
		112,
		109,
		97,
		84,
		69,
		70,
		78,
		91,
		70,
		65,
		62,
		82,
		108,
		86,
		98,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		153,
		124,
		148,
		190,
		174,
		167,
		155,
		120,
		120,
		114,
		-1,
		108,
		87,
		78,
		67,
		65,
		78,
		75,
		80,
		60,
		58,
		77,
		89,
		80,
		94,
		-1,
		-1,
		-1,
		183,
		172,
		173,
		119,
		142,
		179,
		153,
		139,
		144,
		119,
		112,
		106,
		121,
		104,
		85,
		74,
		66,
		55,
		71,
		79,
		74,
		56,
		65,
		71,
		95,
		82,
		88,
		-1,
		-1,
		190,
		180,
		164,
		166,
		163,
		133,
		140,
		172,
		144,
		157,
		-1,
		111,
		-1,
		100,
		95,
		79,
		74,
		71,
		66,
		62,
		71,
		73,
		63,
		58,
		65,
		100,
		100,
		72,
		92,
		95,
		-1,
		-1,
		-1,
		183,
		178,
		153,
		130,
		114,
		150,
		-1,
		127,
		128,
		-1,
		105,
		99,
		96,
		81,
		77,
		70,
		74,
		69,
		76,
		67,
		67,
		68,
		50,
		80,
		-1,
		80,
		74,
		82,
		72,
		60,
		-1,
		-1,
		-1,
		176,
		155,
		148,
		168,
		109,
		161,
		-1,
		-1,
		112,
		105,
		-1,
		92,
		74,
		81,
		77,
		73,
		75,
		72,
		61,
		74,
		67,
		55,
		55,
		68,
		72,
		73,
		62,
		58,
		55,
		69,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		109,
		129,
		-1,
		121,
		113,
		103,
		97,
		91,
		87,
		85,
		101,
		85,
		87,
		84,
		75,
		83,
		56,
		49,
		58,
		45,
		63,
		69,
		60,
		55,
		54,
		65,
		-1,
		196,
		182,
		153,
		-1,
		-1,
		142,
		-1,
		106,
		120,
		136,
		-1,
		129,
		108,
		123,
		101,
		97,
		93,
		108,
		109,
		87,
		84,
		82,
		73,
		61,
		50,
		53,
		45,
		67,
		64,
		48,
		50,
		51,
		-1,
		202,
		189,
		147,
		143,
		132,
		152,
		103,
		91,
		123,
		-1,
		-1,
		165,
		-1,
		99,
		116,
		107,
		105,
		98,
		89,
		95,
		93,
		70,
		65,
		55,
		44,
		44,
		39,
		58,
		44,
		42,
		49,
		65,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		118,
		105,
		99,
		-1,
		140,
		-1,
		143,
		133,
		117,
		102,
		135,
		-1,
		100,
		90,
		95,
		-1,
		90,
		-1,
		63,
		60,
		51,
		36,
		33,
		44,
		42,
		51,
		44,
		-1,
		152,
		137,
		130,
		120,
		134,
		105,
		-1,
		160,
		-1,
		-1,
		130,
		124,
		124,
		108,
		111,
		116,
		96,
		88,
		95,
		85,
		77,
		71,
		49,
		42,
		39,
		29,
		42,
		52,
		58,
		42,
		-1,
		-1,
		-1,
		157,
		143,
		147,
		107,
		126,
		-1,
		-1,
		192,
		147,
		133,
		-1,
		117,
		116,
		104,
		94,
		84,
		89,
		90,
		68,
		61,
		47,
		49,
		38,
		31,
		30,
		44,
		36,
		58,
		-1,
		-1,
		140,
		145,
		133,
		119,
		138,
		-1,
		-1,
		-1,
		139,
		155,
		144,
		118,
		105,
		-1,
		-1,
		88,
		81,
		75,
		64,
		51,
		60,
		55,
		37,
		24,
		39,
		41,
		49,
		40,
		-1,
		143,
		130,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		-1,
		-1,
		156,
		101,
		90,
		85,
		89,
		87,
		-1,
		61,
		72,
		55,
		62,
		69,
		39,
		24,
		18,
		24,
		36,
		45,
		-1,
		-1,
		155,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		113,
		107,
		78,
		71,
		75,
		-1,
		63,
		65,
		57,
		68,
		42,
		39,
		30,
		19,
		15,
		21,
		25,
		39,
		43,
		178,
		-1,
		141,
		-1,
		-1,
		-1,
		131,
		146,
		117,
		94,
		67,
		62,
		55,
		49,
		54,
		64,
		50,
		61,
		26,
		22,
		12,
		13,
		17,
		34,
		43,
		-1,
		-1,
		139,
		135,
		157,
		139,
		143,
		144,
		-1,
		-1,
		71,
		62,
		53,
		45,
		58,
		61,
		32,
		29,
		23,
		16,
		10,
		22,
		36,
		37,
		-1,
		-1,
		-1,
		151,
		-1,
		153,
		-1,
		-1,
		141,
		142,
		89,
		71,
		67,
		65,
		54,
		48,
		36,
		37,
		37,
		26,
		18,
		6,
		17,
		40,
		29,
		68,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		130,
		122,
		117,
		123,
		125,
		116,
		104,
		101,
		-1,
		71,
		77,
		42,
		49,
		32,
		33,
		30,
		22,
		0,
		14,
		30,
		29,
		24,
		60,
		51,
		57,
		-1,
		-1,
		216,
		205,
		194,
		200,
		-1,
		123,
		119,
		109,
		99,
		102,
		-1,
		-1,
		96,
		93,
		73,
		42,
		40,
		33,
		28,
		38,
		18,
		5,
		7,
		11,
		17,
		22,
		27,
		33,
		48,
		63,
		-1,
		170,
		207,
		200,
		168,
		176,
		207,
		-1,
		113,
		105,
		116,
		91,
		93,
		-1,
		-1,
		69,
		60,
		61,
		49,
		46,
		48,
		43,
		34,
		19,
		25,
		12,
		9,
		27,
		31,
		40,
		47,
		37,
		50,
		54,
		-1,
		163,
		183,
		162,
		165,
		189,
		203,
		-1,
		110,
		-1,
		-1,
		122,
		94,
		78,
		68,
		65,
		108,
		63,
		58,
		42,
		40,
		31,
		22,
		29,
		20,
		18,
		21,
		38,
		43,
		35,
		47,
		47,
		48,
		-1,
		152,
		163,
		156,
		-1,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		138,
		-1,
		105,
		-1,
		88,
		92,
		71,
		74,
		56,
		43,
		35,
		27,
		43,
		18,
		26,
		22,
		25,
		34,
		45,
		57,
		54,
		55,
		177,
		133,
		136,
		147,
		158,
		173,
		177,
		-1,
		122,
		161,
		155,
		-1,
		139,
		-1,
		-1,
		-1,
		102,
		84,
		76,
		76,
		55,
		55,
		29,
		33,
		23,
		30,
		38,
		40,
		34,
		38,
		51,
		62,
		63,
		173,
		164,
		177,
		122,
		122,
		143,
		152,
		173,
		137,
		128,
		155,
		162,
		151,
		146,
		133,
		-1,
		-1,
		125,
		94,
		-1,
		-1,
		62,
		50,
		33,
		34,
		30,
		33,
		48,
		49,
		41,
		39,
		33,
		65,
		-1,
		166,
		165,
		154,
		151,
		127,
		118,
		113,
		140,
		-1,
		-1,
		135,
		156,
		146,
		150,
		166,
		191,
		-1,
		122,
		-1,
		-1,
		107,
		-1,
		-1,
		92,
		55,
		44,
		35,
		41,
		38,
		49,
		59,
		47,
		48,
		38,
		48,
		61,
		150,
		147,
		135,
		133,
		156,
		121,
		109,
		-1,
		122,
		120,
		126,
		133,
		150,
		180,
		-1,
		-1,
		138,
		118,
		-1,
		-1,
		90,
		88,
		77,
		-1,
		67,
		40,
		45,
		65,
		67,
		56,
		50,
		44,
		51,
		50,
		58,
		66,
		159,
		173,
		162,
		158,
		157,
		165,
		114,
		107,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		128,
		124,
		-1,
		-1,
		85,
		78,
		66,
		54,
		44,
		54,
		58,
		62,
		54,
		47,
		42,
		53,
		45,
		49,
		66,
		-1,
		193,
		-1,
		145,
		121,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		145,
		131,
		124,
		112,
		110,
		-1,
		119,
		103,
		84,
		-1,
		54,
		67,
		98,
		66,
		71,
		66,
		48,
		59,
		48,
		51,
		65,
		60,
		-1,
		-1,
		133,
		136,
		-1,
		-1,
		135,
		137,
		-1,
		136,
		125,
		110,
		102,
		-1,
		-1,
		91,
		87,
		-1,
		-1,
		55,
		80,
		69,
		77,
		72,
		52,
		58,
		61,
		50,
		54,
		66,
		-1,
		-1,
		140,
		141,
		142,
		-1,
		120,
		-1,
		138,
		-1,
		105,
		111,
		99,
		-1,
		-1,
		-1,
		93,
		56,
		77,
		87,
		81,
		79,
		70,
		56,
		63,
		61,
		57,
		68,
		-1,
		-1,
		-1,
		138,
		112,
		145,
		136,
		119,
		99,
		91,
		110,
		-1,
		80,
		-1,
		55,
		57,
		83,
		86,
		92,
		86,
		59,
		74,
		64,
		55,
		64,
		144,
		-1,
		114,
		147,
		111,
		105,
		81,
		85,
		101,
		-1,
		77,
		59,
		-1,
		87,
		77,
		108,
		93,
		74,
		61,
		68,
		68,
		61,
		-1,
		-1,
		-1,
		116,
		115,
		107,
		101,
		101,
		86,
		77,
		-1,
		89,
		71,
		50,
		67,
		67,
		58,
		66,
		98,
		94,
		81,
		81,
		73,
		-1,
		217,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		110,
		105,
		78,
		66,
		72,
		68,
		54,
		60,
		62,
		70,
		68,
		65,
		77,
		73,
		93,
		74,
		109,
		-1,
		212,
		-1,
		146,
		-1,
		-1,
		128,
		108,
		100,
		89,
		78,
		76,
		67,
		58,
		80,
		96,
		80,
		78,
		81,
		82,
		-1,
		201,
		200,
		-1,
		147,
		139,
		125,
		-1,
		118,
		-1,
		124,
		85,
		-1,
		87,
		67,
		-1,
		89,
		85,
		-1,
		-1,
		188,
		163,
		-1,
		-1,
		-1,
		148,
		128,
		119,
		103,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		173,
		172,
		-1,
		141,
		144,
		-1,
		134,
		125,
		133,
		80,
		84,
		-1,
		-1,
		-1,
		182,
		163,
		157,
		156,
		154,
		149,
		146,
		132,
		116,
		94,
		83,
		104,
		-1,
		-1,
		-1,
		154,
		146,
		139,
		-1,
		-1,
		141,
		124,
		105,
		103,
		-1,
		-1,
		-1,
		176,
		157,
		-1,
		-1,
		131,
		-1,
		-1,
		137,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		165,
		-1,
		-1,
		-1,
		127,
		123,
		124,
		-1,
		-1,
		-1,
		-1,
		187,
		188,
		211,
		175,
		-1,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		190,
		188,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		117,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		152,
		-1,
		152,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		165,
		-1,
		137,
		139,
		-1,
		187,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		142,
		149,
		171,
		174,
		210,
		-1,
		161
	],
	[
		-1,
		189,
		178,
		189,
		197,
		170,
		177,
		-1,
		196,
		200,
		166,
		160,
		199,
		168,
		174,
		185,
		-1,
		-1,
		-1,
		189,
		188,
		156,
		154,
		163,
		168,
		175,
		-1,
		174,
		-1,
		210,
		189,
		200,
		205,
		149,
		146,
		166,
		185,
		167,
		159,
		225,
		179,
		150,
		144,
		162,
		152,
		161,
		153,
		-1,
		150,
		140,
		162,
		141,
		152,
		144,
		-1,
		-1,
		144,
		145,
		151,
		137,
		143,
		139,
		-1,
		149,
		133,
		-1,
		-1,
		134,
		135,
		119,
		122,
		130,
		128,
		141,
		133,
		128,
		-1,
		-1,
		125,
		121,
		128,
		115,
		111,
		128,
		141,
		123,
		137,
		136,
		-1,
		129,
		147,
		154,
		122,
		120,
		104,
		102,
		120,
		122,
		128,
		128,
		-1,
		138,
		139,
		134,
		142,
		144,
		120,
		107,
		107,
		117,
		110,
		129,
		117,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		138,
		121,
		138,
		130,
		120,
		135,
		128,
		110,
		107,
		105,
		102,
		118,
		116,
		126,
		-1,
		-1,
		231,
		200,
		229,
		187,
		168,
		-1,
		134,
		114,
		120,
		124,
		118,
		111,
		125,
		121,
		-1,
		96,
		95,
		123,
		109,
		120,
		191,
		-1,
		-1,
		189,
		181,
		164,
		167,
		144,
		140,
		129,
		128,
		120,
		106,
		102,
		108,
		111,
		111,
		117,
		90,
		100,
		104,
		102,
		127,
		-1,
		-1,
		162,
		-1,
		-1,
		188,
		171,
		-1,
		154,
		161,
		150,
		156,
		142,
		163,
		139,
		130,
		122,
		116,
		104,
		106,
		103,
		116,
		104,
		87,
		112,
		116,
		97,
		118,
		113,
		-1,
		161,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		147,
		150,
		156,
		180,
		179,
		-1,
		151,
		139,
		140,
		125,
		122,
		109,
		97,
		110,
		95,
		102,
		101,
		91,
		89,
		119,
		94,
		116,
		113,
		132,
		137,
		131,
		140,
		-1,
		196,
		192,
		188,
		195,
		144,
		-1,
		-1,
		184,
		-1,
		187,
		188,
		163,
		136,
		139,
		126,
		117,
		104,
		93,
		104,
		93,
		90,
		98,
		83,
		98,
		89,
		88,
		106,
		116,
		124,
		128,
		134,
		-1,
		246,
		-1,
		188,
		172,
		174,
		146,
		167,
		-1,
		204,
		188,
		180,
		165,
		165,
		-1,
		135,
		132,
		122,
		100,
		85,
		102,
		94,
		92,
		96,
		78,
		92,
		83,
		101,
		108,
		106,
		110,
		130,
		142,
		206,
		196,
		-1,
		178,
		183,
		142,
		150,
		169,
		207,
		171,
		-1,
		166,
		-1,
		137,
		150,
		-1,
		106,
		102,
		84,
		85,
		80,
		95,
		89,
		74,
		71,
		89,
		92,
		99,
		103,
		119,
		-1,
		-1,
		191,
		195,
		184,
		135,
		154,
		178,
		215,
		164,
		153,
		152,
		-1,
		143,
		120,
		117,
		105,
		92,
		77,
		78,
		86,
		99,
		78,
		73,
		70,
		90,
		116,
		94,
		106,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		161,
		132,
		156,
		198,
		182,
		175,
		163,
		128,
		128,
		122,
		-1,
		116,
		95,
		86,
		75,
		73,
		86,
		83,
		88,
		68,
		66,
		85,
		97,
		88,
		105,
		-1,
		-1,
		-1,
		191,
		180,
		181,
		127,
		150,
		187,
		161,
		147,
		152,
		127,
		120,
		114,
		129,
		112,
		93,
		82,
		74,
		63,
		79,
		87,
		82,
		64,
		73,
		79,
		103,
		93,
		99,
		-1,
		-1,
		198,
		188,
		172,
		174,
		171,
		141,
		148,
		180,
		152,
		165,
		-1,
		119,
		-1,
		108,
		103,
		87,
		82,
		79,
		76,
		70,
		79,
		81,
		71,
		66,
		73,
		108,
		108,
		83,
		103,
		106,
		-1,
		-1,
		-1,
		191,
		186,
		161,
		138,
		122,
		158,
		-1,
		135,
		136,
		-1,
		113,
		107,
		104,
		89,
		85,
		80,
		84,
		77,
		84,
		77,
		75,
		76,
		58,
		90,
		-1,
		91,
		85,
		93,
		83,
		71,
		-1,
		-1,
		-1,
		184,
		163,
		156,
		176,
		117,
		169,
		-1,
		-1,
		120,
		113,
		-1,
		100,
		82,
		89,
		87,
		81,
		85,
		82,
		71,
		84,
		77,
		63,
		65,
		78,
		82,
		86,
		73,
		69,
		66,
		80,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		137,
		-1,
		129,
		121,
		111,
		105,
		99,
		95,
		93,
		109,
		93,
		96,
		94,
		85,
		93,
		66,
		59,
		66,
		55,
		73,
		81,
		73,
		67,
		66,
		76,
		-1,
		204,
		190,
		161,
		-1,
		-1,
		150,
		-1,
		114,
		128,
		144,
		-1,
		137,
		116,
		131,
		109,
		105,
		101,
		116,
		117,
		95,
		94,
		92,
		83,
		71,
		60,
		63,
		55,
		77,
		77,
		61,
		62,
		65,
		-1,
		210,
		197,
		155,
		151,
		140,
		160,
		111,
		99,
		131,
		-1,
		-1,
		173,
		-1,
		107,
		124,
		115,
		113,
		106,
		97,
		103,
		103,
		80,
		75,
		65,
		54,
		54,
		49,
		71,
		57,
		55,
		63,
		79,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		126,
		113,
		107,
		-1,
		148,
		-1,
		151,
		141,
		125,
		110,
		143,
		-1,
		108,
		98,
		103,
		-1,
		100,
		-1,
		73,
		70,
		61,
		46,
		43,
		54,
		52,
		63,
		58,
		-1,
		160,
		145,
		138,
		128,
		142,
		113,
		-1,
		168,
		-1,
		-1,
		138,
		132,
		132,
		116,
		119,
		124,
		104,
		96,
		103,
		95,
		87,
		81,
		59,
		52,
		49,
		42,
		55,
		65,
		70,
		56,
		-1,
		-1,
		-1,
		165,
		151,
		155,
		115,
		134,
		-1,
		-1,
		200,
		155,
		141,
		-1,
		125,
		124,
		112,
		102,
		92,
		97,
		98,
		78,
		71,
		57,
		59,
		53,
		44,
		43,
		58,
		50,
		72,
		-1,
		-1,
		148,
		153,
		141,
		127,
		146,
		-1,
		-1,
		-1,
		147,
		163,
		152,
		126,
		113,
		-1,
		-1,
		96,
		89,
		83,
		74,
		61,
		73,
		68,
		52,
		37,
		52,
		55,
		63,
		54,
		-1,
		151,
		138,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		-1,
		-1,
		164,
		109,
		98,
		93,
		97,
		95,
		-1,
		69,
		80,
		65,
		77,
		84,
		54,
		39,
		33,
		38,
		50,
		59,
		-1,
		-1,
		163,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		86,
		79,
		83,
		-1,
		71,
		73,
		67,
		82,
		57,
		54,
		45,
		36,
		28,
		35,
		39,
		49,
		55,
		186,
		-1,
		149,
		-1,
		-1,
		-1,
		139,
		154,
		125,
		102,
		75,
		70,
		63,
		57,
		62,
		73,
		65,
		76,
		43,
		39,
		25,
		27,
		31,
		48,
		43,
		-1,
		-1,
		147,
		143,
		165,
		147,
		151,
		152,
		-1,
		-1,
		79,
		70,
		61,
		53,
		66,
		69,
		49,
		46,
		39,
		32,
		20,
		28,
		31,
		37,
		-1,
		-1,
		-1,
		159,
		-1,
		161,
		-1,
		-1,
		149,
		150,
		97,
		79,
		75,
		73,
		62,
		56,
		44,
		49,
		52,
		42,
		34,
		22,
		3,
		26,
		29,
		68,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		138,
		130,
		125,
		131,
		133,
		124,
		112,
		109,
		-1,
		79,
		85,
		50,
		57,
		40,
		47,
		46,
		38,
		17,
		0,
		16,
		29,
		24,
		60,
		51,
		57,
		-1,
		-1,
		224,
		213,
		202,
		208,
		-1,
		131,
		127,
		117,
		107,
		110,
		-1,
		-1,
		104,
		101,
		81,
		50,
		48,
		41,
		36,
		46,
		26,
		13,
		7,
		11,
		17,
		22,
		27,
		33,
		48,
		63,
		-1,
		178,
		215,
		208,
		176,
		184,
		215,
		-1,
		121,
		113,
		124,
		99,
		101,
		-1,
		-1,
		77,
		68,
		69,
		57,
		54,
		56,
		51,
		42,
		27,
		33,
		20,
		9,
		27,
		31,
		40,
		47,
		37,
		50,
		54,
		-1,
		171,
		191,
		170,
		173,
		197,
		211,
		-1,
		118,
		-1,
		-1,
		130,
		102,
		86,
		76,
		73,
		116,
		71,
		66,
		50,
		48,
		39,
		30,
		37,
		24,
		18,
		21,
		39,
		44,
		36,
		47,
		47,
		48,
		-1,
		160,
		171,
		164,
		-1,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		146,
		-1,
		113,
		-1,
		96,
		100,
		79,
		82,
		64,
		51,
		43,
		35,
		51,
		26,
		26,
		22,
		26,
		35,
		46,
		58,
		54,
		55,
		185,
		141,
		144,
		155,
		166,
		181,
		185,
		-1,
		130,
		169,
		163,
		-1,
		147,
		-1,
		-1,
		-1,
		110,
		92,
		84,
		84,
		63,
		63,
		37,
		41,
		31,
		31,
		38,
		40,
		35,
		39,
		52,
		63,
		63,
		181,
		172,
		185,
		130,
		130,
		151,
		160,
		181,
		145,
		136,
		163,
		170,
		159,
		154,
		141,
		-1,
		-1,
		133,
		102,
		-1,
		-1,
		70,
		58,
		41,
		42,
		38,
		41,
		56,
		49,
		42,
		40,
		34,
		66,
		-1,
		174,
		173,
		162,
		159,
		135,
		126,
		121,
		148,
		-1,
		-1,
		143,
		164,
		154,
		158,
		174,
		199,
		-1,
		130,
		-1,
		-1,
		115,
		-1,
		-1,
		100,
		63,
		52,
		43,
		49,
		46,
		57,
		67,
		48,
		49,
		39,
		49,
		62,
		158,
		155,
		143,
		141,
		164,
		129,
		117,
		-1,
		130,
		128,
		134,
		141,
		158,
		188,
		-1,
		-1,
		146,
		126,
		-1,
		-1,
		98,
		96,
		85,
		-1,
		75,
		48,
		53,
		73,
		68,
		57,
		51,
		45,
		52,
		51,
		59,
		67,
		167,
		181,
		170,
		166,
		165,
		173,
		122,
		115,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		136,
		132,
		-1,
		-1,
		93,
		86,
		74,
		62,
		52,
		62,
		66,
		69,
		55,
		48,
		43,
		54,
		46,
		50,
		67,
		-1,
		201,
		-1,
		153,
		129,
		143,
		158,
		166,
		-1,
		-1,
		-1,
		153,
		139,
		132,
		120,
		118,
		-1,
		127,
		111,
		92,
		-1,
		62,
		75,
		105,
		73,
		73,
		67,
		49,
		60,
		49,
		52,
		66,
		61,
		-1,
		-1,
		141,
		144,
		-1,
		-1,
		143,
		145,
		-1,
		144,
		133,
		118,
		110,
		-1,
		-1,
		99,
		95,
		-1,
		-1,
		63,
		87,
		76,
		79,
		74,
		53,
		59,
		62,
		51,
		55,
		67,
		-1,
		-1,
		148,
		149,
		150,
		-1,
		128,
		-1,
		146,
		-1,
		113,
		119,
		107,
		-1,
		-1,
		-1,
		101,
		64,
		85,
		94,
		82,
		80,
		71,
		57,
		64,
		62,
		58,
		69,
		-1,
		-1,
		-1,
		146,
		120,
		153,
		144,
		127,
		107,
		99,
		118,
		-1,
		88,
		-1,
		63,
		65,
		91,
		90,
		93,
		87,
		60,
		75,
		65,
		56,
		65,
		152,
		-1,
		122,
		155,
		119,
		113,
		89,
		93,
		109,
		-1,
		85,
		67,
		-1,
		95,
		85,
		109,
		94,
		75,
		62,
		69,
		69,
		62,
		-1,
		-1,
		-1,
		124,
		123,
		115,
		109,
		109,
		94,
		85,
		-1,
		97,
		79,
		58,
		75,
		75,
		66,
		74,
		99,
		95,
		82,
		82,
		74,
		-1,
		225,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		118,
		113,
		86,
		74,
		80,
		76,
		62,
		68,
		70,
		78,
		76,
		73,
		85,
		81,
		98,
		75,
		110,
		-1,
		220,
		-1,
		154,
		-1,
		-1,
		136,
		116,
		108,
		97,
		86,
		84,
		75,
		66,
		88,
		104,
		88,
		86,
		82,
		83,
		-1,
		209,
		208,
		-1,
		155,
		147,
		133,
		-1,
		126,
		-1,
		132,
		93,
		-1,
		95,
		75,
		-1,
		97,
		87,
		-1,
		-1,
		196,
		171,
		-1,
		-1,
		-1,
		156,
		136,
		127,
		111,
		-1,
		86,
		86,
		-1,
		-1,
		-1,
		181,
		180,
		-1,
		149,
		152,
		-1,
		142,
		133,
		141,
		88,
		92,
		-1,
		-1,
		-1,
		190,
		171,
		165,
		164,
		162,
		157,
		154,
		140,
		124,
		102,
		91,
		112,
		-1,
		-1,
		-1,
		162,
		154,
		147,
		-1,
		-1,
		149,
		132,
		113,
		111,
		-1,
		-1,
		-1,
		184,
		165,
		-1,
		-1,
		139,
		-1,
		-1,
		145,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		173,
		-1,
		-1,
		-1,
		135,
		131,
		132,
		-1,
		-1,
		-1,
		-1,
		195,
		196,
		219,
		183,
		-1,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		198,
		196,
		-1,
		-1,
		-1,
		155,
		139,
		-1,
		125,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		160,
		-1,
		160,
		135,
		142,
		-1,
		-1,
		-1,
		-1,
		173,
		165,
		173,
		-1,
		145,
		147,
		-1,
		195,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		150,
		157,
		179,
		182,
		218,
		-1,
		169
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		146,
		164,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		155,
		156,
		151,
		159,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		138,
		155,
		147,
		137,
		152,
		145,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		248,
		217,
		246,
		204,
		185,
		-1,
		151,
		131,
		137,
		141,
		135,
		128,
		142,
		138,
		-1,
		113,
		112,
		140,
		126,
		137,
		208,
		-1,
		-1,
		206,
		198,
		181,
		184,
		161,
		157,
		146,
		145,
		137,
		123,
		119,
		125,
		128,
		128,
		134,
		107,
		117,
		121,
		119,
		144,
		-1,
		-1,
		179,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		167,
		173,
		159,
		180,
		156,
		147,
		139,
		133,
		121,
		123,
		120,
		133,
		121,
		104,
		129,
		133,
		114,
		135,
		130,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		196,
		-1,
		168,
		156,
		157,
		142,
		139,
		126,
		114,
		127,
		112,
		119,
		118,
		108,
		106,
		136,
		111,
		133,
		130,
		149,
		154,
		148,
		157,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		204,
		205,
		180,
		153,
		156,
		143,
		134,
		121,
		110,
		121,
		110,
		107,
		115,
		100,
		115,
		106,
		105,
		123,
		133,
		141,
		145,
		151,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		205,
		197,
		182,
		182,
		-1,
		152,
		149,
		139,
		117,
		102,
		119,
		111,
		109,
		113,
		95,
		109,
		100,
		118,
		125,
		123,
		127,
		147,
		159,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		154,
		167,
		-1,
		123,
		119,
		101,
		102,
		97,
		112,
		106,
		91,
		88,
		106,
		109,
		116,
		120,
		136,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		137,
		134,
		122,
		109,
		94,
		95,
		103,
		116,
		95,
		90,
		87,
		107,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		90,
		103,
		100,
		105,
		85,
		83,
		102,
		114,
		105,
		122,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		146,
		129,
		110,
		99,
		91,
		80,
		96,
		104,
		99,
		81,
		90,
		96,
		120,
		110,
		116,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		98,
		88,
		83,
		90,
		125,
		125,
		100,
		120,
		123,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		94,
		92,
		93,
		75,
		107,
		-1,
		108,
		102,
		110,
		100,
		88,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		106,
		104,
		98,
		102,
		99,
		88,
		101,
		94,
		80,
		82,
		95,
		99,
		103,
		90,
		86,
		83,
		97,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		113,
		111,
		102,
		110,
		83,
		76,
		83,
		72,
		90,
		98,
		90,
		84,
		78,
		93,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		118,
		133,
		134,
		112,
		111,
		109,
		100,
		88,
		77,
		80,
		72,
		94,
		94,
		78,
		79,
		74,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		132,
		130,
		123,
		114,
		120,
		120,
		97,
		92,
		82,
		71,
		71,
		66,
		88,
		74,
		72,
		72,
		84,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		125,
		115,
		120,
		-1,
		117,
		-1,
		90,
		87,
		78,
		63,
		60,
		71,
		69,
		80,
		67,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		141,
		121,
		113,
		120,
		112,
		104,
		98,
		76,
		69,
		66,
		59,
		72,
		82,
		81,
		65,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		141,
		129,
		119,
		109,
		114,
		115,
		95,
		88,
		74,
		76,
		68,
		61,
		60,
		66,
		59,
		77,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		169,
		143,
		130,
		-1,
		-1,
		113,
		106,
		100,
		91,
		78,
		90,
		85,
		67,
		54,
		69,
		58,
		67,
		56,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		181,
		126,
		115,
		110,
		114,
		112,
		-1,
		86,
		97,
		82,
		92,
		99,
		69,
		54,
		48,
		47,
		53,
		53,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		103,
		96,
		100,
		-1,
		88,
		90,
		84,
		98,
		72,
		69,
		60,
		49,
		43,
		44,
		41,
		44,
		46,
		203,
		-1,
		166,
		-1,
		-1,
		-1,
		156,
		171,
		142,
		119,
		92,
		87,
		80,
		74,
		79,
		90,
		80,
		91,
		56,
		52,
		40,
		39,
		40,
		41,
		43,
		-1,
		-1,
		164,
		160,
		182,
		164,
		168,
		169,
		-1,
		-1,
		96,
		87,
		78,
		70,
		83,
		86,
		62,
		59,
		53,
		46,
		35,
		40,
		22,
		37,
		-1,
		-1,
		-1,
		176,
		-1,
		178,
		-1,
		-1,
		166,
		167,
		114,
		96,
		92,
		90,
		79,
		73,
		61,
		66,
		67,
		56,
		48,
		36,
		18,
		13,
		29,
		76,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		155,
		147,
		142,
		148,
		150,
		141,
		129,
		126,
		-1,
		96,
		102,
		67,
		74,
		57,
		63,
		60,
		52,
		30,
		17,
		0,
		25,
		31,
		68,
		59,
		64,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		148,
		144,
		134,
		124,
		127,
		-1,
		-1,
		121,
		118,
		98,
		67,
		65,
		58,
		53,
		63,
		43,
		30,
		24,
		28,
		25,
		29,
		34,
		40,
		55,
		70,
		-1,
		195,
		232,
		225,
		193,
		201,
		232,
		-1,
		138,
		130,
		141,
		116,
		118,
		-1,
		-1,
		94,
		85,
		86,
		74,
		71,
		73,
		68,
		59,
		44,
		50,
		37,
		26,
		43,
		39,
		47,
		54,
		45,
		58,
		62,
		-1,
		188,
		208,
		187,
		190,
		214,
		228,
		-1,
		135,
		-1,
		-1,
		147,
		119,
		103,
		93,
		90,
		133,
		88,
		83,
		67,
		65,
		56,
		47,
		54,
		41,
		35,
		38,
		47,
		61,
		53,
		55,
		55,
		56,
		-1,
		177,
		188,
		181,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		163,
		-1,
		130,
		-1,
		113,
		117,
		96,
		99,
		81,
		68,
		60,
		52,
		68,
		43,
		43,
		39,
		43,
		52,
		63,
		75,
		62,
		63,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		147,
		186,
		180,
		-1,
		164,
		-1,
		-1,
		-1,
		127,
		109,
		101,
		101,
		80,
		80,
		54,
		58,
		48,
		48,
		55,
		57,
		52,
		56,
		69,
		72,
		71,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		162,
		153,
		180,
		187,
		176,
		171,
		158,
		-1,
		-1,
		150,
		119,
		-1,
		-1,
		87,
		75,
		58,
		59,
		55,
		58,
		73,
		66,
		59,
		57,
		51,
		77,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		160,
		181,
		171,
		175,
		191,
		216,
		-1,
		147,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		80,
		69,
		60,
		66,
		63,
		74,
		84,
		65,
		66,
		56,
		66,
		79,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		147,
		145,
		151,
		158,
		175,
		205,
		-1,
		-1,
		163,
		143,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		65,
		70,
		90,
		85,
		74,
		68,
		62,
		69,
		68,
		76,
		84,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		153,
		149,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		79,
		83,
		86,
		72,
		65,
		60,
		71,
		63,
		67,
		84,
		-1,
		218,
		-1,
		170,
		146,
		160,
		175,
		183,
		-1,
		-1,
		-1,
		170,
		156,
		149,
		137,
		135,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		122,
		90,
		90,
		84,
		66,
		77,
		66,
		69,
		83,
		78,
		-1,
		-1,
		158,
		161,
		-1,
		-1,
		160,
		162,
		-1,
		161,
		150,
		135,
		127,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		104,
		93,
		96,
		91,
		70,
		76,
		79,
		68,
		72,
		84,
		-1,
		-1,
		165,
		166,
		167,
		-1,
		145,
		-1,
		163,
		-1,
		130,
		136,
		124,
		-1,
		-1,
		-1,
		118,
		81,
		102,
		111,
		99,
		97,
		88,
		74,
		81,
		79,
		75,
		86,
		-1,
		-1,
		-1,
		163,
		137,
		170,
		161,
		144,
		124,
		116,
		135,
		-1,
		105,
		-1,
		80,
		82,
		108,
		107,
		110,
		104,
		77,
		92,
		82,
		73,
		82,
		169,
		-1,
		139,
		172,
		136,
		130,
		106,
		110,
		126,
		-1,
		102,
		84,
		-1,
		112,
		102,
		126,
		111,
		92,
		79,
		86,
		86,
		79,
		-1,
		-1,
		-1,
		141,
		140,
		132,
		126,
		126,
		111,
		102,
		-1,
		114,
		96,
		75,
		92,
		92,
		83,
		91,
		116,
		112,
		99,
		99,
		91,
		-1,
		242,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		135,
		130,
		103,
		91,
		97,
		93,
		79,
		85,
		87,
		95,
		93,
		90,
		102,
		98,
		115,
		92,
		127,
		-1,
		237,
		-1,
		171,
		-1,
		-1,
		153,
		133,
		125,
		114,
		103,
		101,
		92,
		83,
		105,
		121,
		105,
		103,
		99,
		100,
		-1,
		226,
		225,
		-1,
		172,
		164,
		150,
		-1,
		143,
		-1,
		149,
		110,
		-1,
		112,
		92,
		-1,
		114,
		104,
		-1,
		-1,
		213,
		188,
		-1,
		-1,
		-1,
		173,
		153,
		144,
		128,
		-1,
		103,
		103,
		-1,
		-1,
		-1,
		198,
		197,
		-1,
		166,
		169,
		-1,
		159,
		150,
		158,
		105,
		109,
		-1,
		-1,
		-1,
		207,
		188,
		182,
		181,
		179,
		174,
		171,
		157,
		141,
		119,
		108,
		129,
		-1,
		-1,
		-1,
		179,
		171,
		164,
		-1,
		-1,
		166,
		149,
		130,
		128,
		-1,
		-1,
		-1,
		201,
		182,
		-1,
		-1,
		156,
		-1,
		-1,
		162,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		190,
		-1,
		-1,
		-1,
		152,
		148,
		149,
		-1,
		-1,
		-1,
		-1,
		212,
		213,
		236,
		200,
		-1,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		215,
		213,
		-1,
		-1,
		-1,
		172,
		156,
		-1,
		142,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		177,
		-1,
		177,
		152,
		159,
		-1,
		-1,
		-1,
		-1,
		190,
		182,
		190,
		-1,
		162,
		164,
		-1,
		212,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		167,
		174,
		196,
		199,
		235,
		-1,
		186
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		147,
		165,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		156,
		157,
		152,
		160,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		114,
		113,
		141,
		127,
		138,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		117,
		96,
		91,
		88,
		108,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		101,
		106,
		86,
		84,
		103,
		115,
		106,
		123,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		97,
		105,
		100,
		82,
		91,
		97,
		121,
		111,
		117,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		88,
		97,
		99,
		89,
		84,
		91,
		126,
		126,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		102,
		95,
		93,
		94,
		76,
		108,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		100,
		89,
		102,
		95,
		81,
		83,
		96,
		100,
		104,
		91,
		87,
		84,
		92,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		112,
		103,
		111,
		84,
		77,
		84,
		73,
		91,
		99,
		91,
		85,
		81,
		88,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		112,
		110,
		101,
		89,
		78,
		81,
		73,
		95,
		95,
		79,
		80,
		77,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		115,
		121,
		121,
		98,
		93,
		83,
		72,
		72,
		67,
		89,
		75,
		73,
		75,
		73,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		126,
		116,
		121,
		-1,
		118,
		-1,
		91,
		88,
		79,
		64,
		61,
		72,
		70,
		81,
		70,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		142,
		122,
		114,
		121,
		113,
		105,
		99,
		77,
		70,
		67,
		60,
		73,
		83,
		84,
		68,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		142,
		130,
		120,
		110,
		115,
		116,
		96,
		89,
		75,
		77,
		71,
		62,
		61,
		75,
		67,
		72,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		170,
		144,
		131,
		-1,
		-1,
		114,
		107,
		101,
		92,
		79,
		91,
		86,
		70,
		55,
		70,
		70,
		62,
		54,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		113,
		-1,
		87,
		98,
		83,
		95,
		102,
		72,
		57,
		51,
		55,
		65,
		48,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		89,
		91,
		85,
		100,
		75,
		72,
		63,
		54,
		50,
		52,
		52,
		33,
		39,
		204,
		-1,
		167,
		-1,
		-1,
		-1,
		157,
		172,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		91,
		83,
		94,
		61,
		57,
		47,
		46,
		48,
		37,
		27,
		-1,
		-1,
		165,
		161,
		183,
		165,
		169,
		170,
		-1,
		-1,
		97,
		88,
		79,
		71,
		84,
		87,
		67,
		64,
		58,
		51,
		45,
		55,
		26,
		21,
		-1,
		-1,
		-1,
		177,
		-1,
		179,
		-1,
		-1,
		167,
		168,
		115,
		97,
		93,
		91,
		80,
		74,
		62,
		67,
		70,
		60,
		52,
		41,
		35,
		40,
		13,
		61,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		130,
		127,
		-1,
		97,
		103,
		68,
		75,
		58,
		65,
		64,
		56,
		35,
		32,
		37,
		0,
		15,
		53,
		44,
		48,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		122,
		119,
		99,
		68,
		66,
		59,
		54,
		64,
		44,
		31,
		25,
		29,
		15,
		13,
		18,
		24,
		39,
		54,
		-1,
		196,
		233,
		226,
		194,
		202,
		233,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		95,
		86,
		87,
		75,
		72,
		74,
		69,
		60,
		45,
		51,
		38,
		27,
		44,
		29,
		31,
		38,
		35,
		48,
		52,
		-1,
		189,
		209,
		188,
		191,
		215,
		229,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		91,
		134,
		89,
		84,
		68,
		66,
		57,
		48,
		55,
		42,
		36,
		39,
		37,
		46,
		40,
		45,
		42,
		46,
		-1,
		178,
		189,
		182,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		164,
		-1,
		131,
		-1,
		114,
		118,
		97,
		100,
		82,
		69,
		61,
		53,
		69,
		44,
		44,
		40,
		44,
		53,
		50,
		63,
		52,
		48,
		203,
		159,
		162,
		173,
		184,
		199,
		203,
		-1,
		148,
		187,
		181,
		-1,
		165,
		-1,
		-1,
		-1,
		128,
		110,
		102,
		102,
		81,
		81,
		55,
		59,
		49,
		49,
		56,
		58,
		53,
		57,
		70,
		62,
		56,
		199,
		190,
		203,
		148,
		148,
		169,
		178,
		199,
		163,
		154,
		181,
		188,
		177,
		172,
		159,
		-1,
		-1,
		151,
		120,
		-1,
		-1,
		88,
		76,
		59,
		60,
		56,
		59,
		74,
		67,
		60,
		58,
		52,
		67,
		-1,
		192,
		191,
		180,
		177,
		153,
		144,
		139,
		166,
		-1,
		-1,
		161,
		182,
		172,
		176,
		192,
		217,
		-1,
		148,
		-1,
		-1,
		133,
		-1,
		-1,
		118,
		81,
		70,
		61,
		67,
		64,
		75,
		85,
		66,
		67,
		57,
		67,
		80,
		176,
		173,
		161,
		159,
		182,
		147,
		135,
		-1,
		148,
		146,
		152,
		159,
		176,
		206,
		-1,
		-1,
		164,
		144,
		-1,
		-1,
		116,
		114,
		103,
		-1,
		93,
		66,
		71,
		91,
		86,
		75,
		69,
		63,
		70,
		69,
		77,
		85,
		185,
		199,
		188,
		184,
		183,
		191,
		140,
		133,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		150,
		-1,
		-1,
		111,
		104,
		92,
		80,
		70,
		80,
		84,
		87,
		73,
		66,
		61,
		72,
		64,
		68,
		83,
		-1,
		219,
		-1,
		171,
		147,
		161,
		176,
		184,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		145,
		129,
		110,
		-1,
		80,
		93,
		123,
		91,
		91,
		85,
		67,
		78,
		67,
		70,
		76,
		79,
		-1,
		-1,
		159,
		162,
		-1,
		-1,
		161,
		163,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		117,
		113,
		-1,
		-1,
		81,
		105,
		94,
		97,
		92,
		71,
		77,
		80,
		69,
		73,
		76,
		-1,
		-1,
		166,
		167,
		168,
		-1,
		146,
		-1,
		164,
		-1,
		131,
		137,
		125,
		-1,
		-1,
		-1,
		119,
		82,
		103,
		112,
		100,
		98,
		89,
		75,
		82,
		80,
		76,
		86,
		-1,
		-1,
		-1,
		164,
		138,
		171,
		162,
		145,
		125,
		117,
		136,
		-1,
		106,
		-1,
		81,
		83,
		109,
		108,
		111,
		105,
		78,
		93,
		83,
		74,
		83,
		170,
		-1,
		140,
		173,
		137,
		131,
		107,
		111,
		127,
		-1,
		103,
		85,
		-1,
		113,
		103,
		127,
		112,
		93,
		80,
		87,
		87,
		80,
		-1,
		-1,
		-1,
		142,
		141,
		133,
		127,
		127,
		112,
		103,
		-1,
		115,
		97,
		76,
		93,
		93,
		84,
		92,
		117,
		113,
		100,
		100,
		92,
		-1,
		243,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		136,
		131,
		104,
		92,
		98,
		94,
		80,
		86,
		88,
		96,
		94,
		91,
		103,
		99,
		116,
		93,
		128,
		-1,
		238,
		-1,
		172,
		-1,
		-1,
		154,
		134,
		126,
		115,
		104,
		102,
		93,
		84,
		106,
		122,
		106,
		104,
		100,
		101,
		-1,
		227,
		226,
		-1,
		173,
		165,
		151,
		-1,
		144,
		-1,
		150,
		111,
		-1,
		113,
		93,
		-1,
		115,
		105,
		-1,
		-1,
		214,
		189,
		-1,
		-1,
		-1,
		174,
		154,
		145,
		129,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		199,
		198,
		-1,
		167,
		170,
		-1,
		160,
		151,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		208,
		189,
		183,
		182,
		180,
		175,
		172,
		158,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		180,
		172,
		165,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		191,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		213,
		214,
		237,
		201,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		216,
		214,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		201,
		190,
		201,
		209,
		182,
		189,
		-1,
		208,
		212,
		178,
		172,
		211,
		180,
		186,
		197,
		-1,
		-1,
		-1,
		201,
		200,
		168,
		166,
		175,
		180,
		187,
		-1,
		186,
		-1,
		222,
		201,
		212,
		217,
		161,
		158,
		178,
		197,
		179,
		171,
		237,
		191,
		162,
		156,
		174,
		164,
		173,
		165,
		-1,
		162,
		152,
		174,
		153,
		164,
		156,
		-1,
		-1,
		156,
		157,
		163,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		146,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		141,
		159,
		166,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		140,
		-1,
		150,
		151,
		146,
		154,
		156,
		132,
		119,
		119,
		129,
		122,
		141,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		133,
		150,
		142,
		132,
		147,
		140,
		122,
		119,
		117,
		114,
		130,
		128,
		138,
		-1,
		-1,
		243,
		212,
		241,
		199,
		180,
		-1,
		146,
		126,
		132,
		136,
		130,
		123,
		137,
		133,
		-1,
		108,
		107,
		135,
		121,
		132,
		203,
		-1,
		-1,
		201,
		193,
		176,
		179,
		156,
		152,
		141,
		140,
		132,
		118,
		114,
		120,
		123,
		123,
		129,
		102,
		112,
		116,
		114,
		139,
		-1,
		-1,
		174,
		-1,
		-1,
		200,
		183,
		-1,
		166,
		173,
		162,
		168,
		154,
		175,
		151,
		142,
		134,
		128,
		116,
		118,
		115,
		128,
		116,
		99,
		124,
		128,
		109,
		130,
		125,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		159,
		162,
		168,
		192,
		191,
		-1,
		163,
		151,
		152,
		137,
		134,
		121,
		109,
		122,
		107,
		114,
		113,
		103,
		101,
		131,
		106,
		128,
		125,
		144,
		149,
		143,
		152,
		-1,
		208,
		204,
		200,
		207,
		156,
		-1,
		-1,
		196,
		-1,
		199,
		200,
		175,
		148,
		151,
		138,
		129,
		116,
		105,
		116,
		105,
		102,
		110,
		95,
		110,
		101,
		100,
		118,
		128,
		136,
		140,
		146,
		-1,
		258,
		-1,
		200,
		184,
		186,
		158,
		179,
		-1,
		216,
		200,
		192,
		177,
		177,
		-1,
		147,
		144,
		134,
		112,
		97,
		114,
		106,
		104,
		108,
		90,
		104,
		95,
		113,
		120,
		118,
		122,
		142,
		154,
		218,
		208,
		-1,
		190,
		195,
		154,
		162,
		181,
		219,
		183,
		-1,
		178,
		-1,
		149,
		162,
		-1,
		118,
		114,
		96,
		97,
		92,
		107,
		101,
		86,
		83,
		101,
		104,
		111,
		115,
		131,
		-1,
		-1,
		203,
		207,
		196,
		147,
		166,
		190,
		227,
		176,
		165,
		164,
		-1,
		155,
		132,
		129,
		117,
		104,
		89,
		90,
		98,
		111,
		90,
		85,
		82,
		102,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		173,
		144,
		168,
		210,
		194,
		187,
		175,
		140,
		140,
		134,
		-1,
		128,
		107,
		98,
		87,
		85,
		98,
		95,
		100,
		80,
		78,
		97,
		109,
		100,
		117,
		-1,
		-1,
		-1,
		203,
		192,
		193,
		139,
		162,
		199,
		173,
		159,
		164,
		139,
		132,
		126,
		141,
		124,
		105,
		94,
		86,
		75,
		91,
		99,
		94,
		76,
		85,
		91,
		115,
		105,
		111,
		-1,
		-1,
		210,
		200,
		184,
		186,
		183,
		153,
		160,
		192,
		164,
		177,
		-1,
		131,
		-1,
		120,
		115,
		99,
		94,
		91,
		88,
		82,
		91,
		93,
		83,
		78,
		85,
		120,
		120,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		203,
		198,
		173,
		150,
		134,
		170,
		-1,
		147,
		148,
		-1,
		125,
		119,
		116,
		101,
		97,
		92,
		96,
		89,
		96,
		89,
		87,
		88,
		70,
		102,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		196,
		175,
		168,
		188,
		129,
		181,
		-1,
		-1,
		132,
		125,
		-1,
		112,
		94,
		101,
		99,
		93,
		97,
		94,
		83,
		96,
		89,
		75,
		77,
		90,
		94,
		98,
		85,
		81,
		78,
		88,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		149,
		-1,
		141,
		133,
		123,
		117,
		111,
		107,
		105,
		121,
		105,
		108,
		106,
		97,
		105,
		78,
		71,
		78,
		67,
		85,
		93,
		85,
		79,
		77,
		84,
		-1,
		216,
		202,
		173,
		-1,
		-1,
		162,
		-1,
		126,
		140,
		156,
		-1,
		149,
		128,
		143,
		121,
		117,
		113,
		128,
		129,
		107,
		106,
		104,
		95,
		83,
		72,
		75,
		67,
		89,
		89,
		73,
		74,
		73,
		-1,
		222,
		209,
		167,
		163,
		152,
		172,
		123,
		111,
		143,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		127,
		125,
		118,
		109,
		115,
		115,
		92,
		87,
		77,
		66,
		66,
		61,
		83,
		69,
		67,
		71,
		69,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		138,
		125,
		119,
		-1,
		160,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		120,
		110,
		115,
		-1,
		112,
		-1,
		85,
		82,
		73,
		58,
		55,
		66,
		64,
		75,
		66,
		-1,
		172,
		157,
		150,
		140,
		154,
		125,
		-1,
		180,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		136,
		116,
		108,
		115,
		107,
		99,
		93,
		71,
		64,
		61,
		54,
		67,
		77,
		80,
		64,
		-1,
		-1,
		-1,
		177,
		163,
		167,
		127,
		146,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		137,
		136,
		124,
		114,
		104,
		109,
		110,
		90,
		83,
		69,
		71,
		65,
		56,
		55,
		71,
		63,
		68,
		-1,
		-1,
		160,
		165,
		153,
		139,
		158,
		-1,
		-1,
		-1,
		159,
		175,
		164,
		138,
		125,
		-1,
		-1,
		108,
		101,
		95,
		86,
		73,
		85,
		80,
		64,
		49,
		64,
		66,
		58,
		50,
		-1,
		163,
		150,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		-1,
		-1,
		176,
		121,
		110,
		105,
		109,
		107,
		-1,
		81,
		92,
		77,
		89,
		96,
		66,
		51,
		45,
		51,
		61,
		44,
		-1,
		-1,
		175,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		133,
		127,
		98,
		91,
		95,
		-1,
		83,
		85,
		79,
		94,
		69,
		66,
		57,
		48,
		44,
		48,
		48,
		29,
		35,
		198,
		-1,
		161,
		-1,
		-1,
		-1,
		151,
		166,
		137,
		114,
		87,
		82,
		75,
		69,
		74,
		85,
		77,
		88,
		55,
		51,
		41,
		40,
		44,
		33,
		23,
		-1,
		-1,
		159,
		155,
		177,
		159,
		163,
		164,
		-1,
		-1,
		91,
		82,
		73,
		65,
		78,
		81,
		61,
		58,
		52,
		45,
		39,
		49,
		22,
		17,
		-1,
		-1,
		-1,
		171,
		-1,
		173,
		-1,
		-1,
		161,
		162,
		109,
		91,
		87,
		85,
		74,
		68,
		56,
		61,
		64,
		54,
		46,
		35,
		29,
		36,
		9,
		46,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		150,
		142,
		137,
		143,
		145,
		136,
		124,
		121,
		-1,
		91,
		97,
		62,
		69,
		52,
		59,
		58,
		50,
		29,
		26,
		32,
		12,
		0,
		38,
		29,
		33,
		-1,
		-1,
		236,
		225,
		214,
		220,
		-1,
		143,
		139,
		129,
		119,
		122,
		-1,
		-1,
		116,
		113,
		93,
		62,
		60,
		53,
		48,
		58,
		38,
		25,
		19,
		23,
		9,
		2,
		3,
		9,
		24,
		39,
		-1,
		190,
		227,
		220,
		188,
		196,
		227,
		-1,
		133,
		125,
		136,
		111,
		113,
		-1,
		-1,
		89,
		80,
		81,
		69,
		66,
		68,
		63,
		54,
		39,
		45,
		32,
		21,
		38,
		23,
		16,
		23,
		22,
		33,
		37,
		-1,
		183,
		203,
		182,
		185,
		209,
		223,
		-1,
		130,
		-1,
		-1,
		142,
		114,
		98,
		88,
		85,
		128,
		83,
		78,
		62,
		60,
		51,
		42,
		49,
		36,
		30,
		33,
		31,
		31,
		25,
		32,
		27,
		33,
		-1,
		172,
		183,
		176,
		-1,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		158,
		-1,
		125,
		-1,
		108,
		112,
		91,
		94,
		76,
		63,
		55,
		47,
		63,
		38,
		38,
		34,
		36,
		45,
		35,
		48,
		39,
		33,
		197,
		153,
		156,
		167,
		178,
		193,
		197,
		-1,
		142,
		181,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		122,
		104,
		96,
		96,
		75,
		75,
		49,
		53,
		43,
		43,
		50,
		52,
		45,
		49,
		58,
		49,
		41,
		193,
		184,
		197,
		142,
		142,
		163,
		172,
		193,
		157,
		148,
		175,
		182,
		171,
		166,
		153,
		-1,
		-1,
		145,
		114,
		-1,
		-1,
		82,
		70,
		53,
		54,
		50,
		53,
		68,
		61,
		52,
		50,
		44,
		54,
		-1,
		186,
		185,
		174,
		171,
		147,
		138,
		133,
		160,
		-1,
		-1,
		155,
		176,
		166,
		170,
		186,
		211,
		-1,
		142,
		-1,
		-1,
		127,
		-1,
		-1,
		112,
		75,
		64,
		55,
		61,
		58,
		69,
		79,
		58,
		59,
		49,
		59,
		68,
		170,
		167,
		155,
		153,
		176,
		141,
		129,
		-1,
		142,
		140,
		146,
		153,
		170,
		200,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		110,
		108,
		97,
		-1,
		87,
		60,
		65,
		85,
		78,
		67,
		61,
		55,
		62,
		61,
		69,
		73,
		179,
		193,
		182,
		178,
		177,
		185,
		134,
		127,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		105,
		98,
		86,
		74,
		64,
		74,
		78,
		79,
		65,
		58,
		53,
		64,
		56,
		60,
		70,
		-1,
		213,
		-1,
		165,
		141,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		139,
		123,
		104,
		-1,
		74,
		87,
		115,
		83,
		83,
		77,
		59,
		70,
		59,
		62,
		63,
		66,
		-1,
		-1,
		153,
		156,
		-1,
		-1,
		155,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		111,
		107,
		-1,
		-1,
		75,
		97,
		86,
		89,
		84,
		63,
		69,
		72,
		61,
		65,
		63,
		-1,
		-1,
		160,
		161,
		162,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		113,
		76,
		97,
		104,
		92,
		90,
		81,
		67,
		74,
		72,
		68,
		73,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		77,
		103,
		100,
		103,
		97,
		70,
		85,
		75,
		66,
		75,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		107,
		97,
		119,
		104,
		85,
		72,
		79,
		79,
		72,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		87,
		87,
		78,
		86,
		109,
		105,
		92,
		92,
		84,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		82,
		90,
		88,
		85,
		97,
		93,
		108,
		85,
		120,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		116,
		100,
		97,
		92,
		93,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		108,
		97,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		168,
		186,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		177,
		178,
		173,
		181,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		268,
		237,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		133,
		132,
		160,
		146,
		157,
		228,
		-1,
		-1,
		226,
		218,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		181,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		128,
		126,
		156,
		131,
		153,
		146,
		151,
		156,
		150,
		159,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		120,
		135,
		126,
		125,
		135,
		135,
		143,
		147,
		153,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		227,
		219,
		204,
		202,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		133,
		115,
		129,
		120,
		138,
		139,
		125,
		129,
		149,
		161,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		244,
		208,
		-1,
		203,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		126,
		111,
		108,
		126,
		129,
		118,
		122,
		138,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		201,
		190,
		189,
		-1,
		180,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		137,
		116,
		110,
		107,
		127,
		135,
		113,
		124,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		117,
		125,
		105,
		103,
		122,
		116,
		107,
		115,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		164,
		187,
		224,
		198,
		184,
		189,
		164,
		157,
		151,
		168,
		151,
		132,
		121,
		113,
		102,
		113,
		121,
		119,
		101,
		110,
		116,
		122,
		103,
		109,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		178,
		185,
		217,
		189,
		202,
		-1,
		156,
		-1,
		145,
		141,
		126,
		121,
		118,
		105,
		104,
		118,
		118,
		108,
		103,
		110,
		127,
		127,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		228,
		223,
		198,
		175,
		159,
		195,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		128,
		124,
		109,
		113,
		115,
		118,
		106,
		112,
		113,
		95,
		119,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		221,
		200,
		193,
		213,
		154,
		206,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		121,
		116,
		115,
		114,
		111,
		100,
		113,
		106,
		100,
		94,
		107,
		111,
		105,
		83,
		79,
		76,
		79,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		174,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		143,
		127,
		126,
		123,
		114,
		122,
		95,
		88,
		99,
		84,
		102,
		102,
		92,
		82,
		74,
		75,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		187,
		-1,
		151,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		133,
		150,
		151,
		129,
		123,
		121,
		112,
		100,
		89,
		92,
		84,
		104,
		96,
		80,
		77,
		70,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		148,
		136,
		168,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		147,
		145,
		140,
		131,
		137,
		132,
		109,
		104,
		94,
		83,
		83,
		78,
		97,
		83,
		81,
		68,
		60,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		148,
		132,
		137,
		-1,
		129,
		-1,
		102,
		99,
		90,
		75,
		72,
		83,
		81,
		90,
		69,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		205,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		164,
		144,
		138,
		137,
		124,
		116,
		110,
		88,
		81,
		78,
		68,
		81,
		91,
		83,
		67,
		-1,
		-1,
		-1,
		202,
		188,
		192,
		152,
		171,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		162,
		170,
		158,
		148,
		138,
		142,
		132,
		107,
		100,
		86,
		88,
		80,
		70,
		69,
		74,
		66,
		71,
		-1,
		-1,
		185,
		190,
		178,
		164,
		183,
		-1,
		-1,
		-1,
		184,
		200,
		192,
		163,
		159,
		-1,
		-1,
		142,
		134,
		124,
		103,
		90,
		99,
		94,
		79,
		63,
		78,
		69,
		61,
		53,
		-1,
		188,
		175,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		-1,
		-1,
		210,
		155,
		144,
		139,
		143,
		141,
		-1,
		115,
		114,
		94,
		106,
		113,
		81,
		69,
		63,
		54,
		64,
		47,
		-1,
		-1,
		200,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		167,
		161,
		132,
		125,
		129,
		-1,
		117,
		110,
		96,
		112,
		87,
		84,
		75,
		65,
		65,
		51,
		51,
		32,
		38,
		223,
		-1,
		196,
		-1,
		-1,
		-1,
		185,
		200,
		171,
		148,
		121,
		116,
		109,
		103,
		104,
		109,
		95,
		106,
		72,
		68,
		64,
		51,
		47,
		36,
		37,
		-1,
		-1,
		194,
		190,
		211,
		193,
		197,
		198,
		-1,
		-1,
		125,
		116,
		107,
		99,
		112,
		113,
		78,
		75,
		75,
		68,
		61,
		60,
		58,
		43,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		196,
		196,
		143,
		125,
		121,
		119,
		108,
		102,
		90,
		83,
		93,
		86,
		78,
		58,
		64,
		72,
		50,
		8,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		158,
		155,
		-1,
		125,
		131,
		96,
		103,
		87,
		93,
		90,
		82,
		63,
		61,
		67,
		53,
		41,
		0,
		13,
		22,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		151,
		148,
		128,
		97,
		95,
		88,
		83,
		93,
		73,
		60,
		54,
		58,
		44,
		43,
		38,
		31,
		20,
		28,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		124,
		115,
		116,
		104,
		101,
		103,
		98,
		89,
		74,
		80,
		58,
		56,
		73,
		58,
		51,
		34,
		23,
		36,
		40,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		120,
		163,
		118,
		113,
		97,
		95,
		86,
		77,
		82,
		66,
		54,
		51,
		60,
		46,
		36,
		33,
		33,
		34,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		193,
		-1,
		160,
		-1,
		143,
		147,
		126,
		129,
		111,
		98,
		90,
		82,
		91,
		66,
		62,
		58,
		47,
		56,
		46,
		54,
		40,
		41,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		177,
		216,
		210,
		-1,
		194,
		-1,
		-1,
		-1,
		157,
		139,
		131,
		131,
		110,
		110,
		84,
		85,
		71,
		67,
		74,
		64,
		56,
		60,
		62,
		50,
		49,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		192,
		183,
		210,
		217,
		206,
		201,
		188,
		-1,
		-1,
		180,
		149,
		-1,
		-1,
		117,
		105,
		88,
		82,
		78,
		81,
		89,
		73,
		63,
		61,
		55,
		55,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		211,
		201,
		205,
		221,
		246,
		-1,
		177,
		-1,
		-1,
		162,
		-1,
		-1,
		147,
		110,
		99,
		90,
		93,
		86,
		93,
		104,
		69,
		70,
		60,
		70,
		69,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		235,
		-1,
		-1,
		193,
		173,
		-1,
		-1,
		145,
		143,
		132,
		-1,
		122,
		95,
		94,
		113,
		89,
		78,
		72,
		66,
		73,
		72,
		80,
		74,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		183,
		179,
		-1,
		-1,
		140,
		133,
		121,
		109,
		99,
		108,
		94,
		90,
		76,
		69,
		64,
		75,
		67,
		71,
		71,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		200,
		186,
		179,
		167,
		165,
		-1,
		174,
		158,
		139,
		-1,
		109,
		122,
		126,
		94,
		94,
		88,
		70,
		81,
		70,
		73,
		64,
		67,
		-1,
		-1,
		188,
		191,
		-1,
		-1,
		190,
		192,
		-1,
		191,
		180,
		165,
		157,
		-1,
		-1,
		146,
		142,
		-1,
		-1,
		110,
		108,
		97,
		100,
		95,
		74,
		80,
		83,
		72,
		70,
		64,
		-1,
		-1,
		195,
		196,
		197,
		-1,
		175,
		-1,
		193,
		-1,
		160,
		166,
		154,
		-1,
		-1,
		-1,
		148,
		111,
		132,
		115,
		103,
		101,
		92,
		78,
		85,
		83,
		79,
		74,
		-1,
		-1,
		-1,
		193,
		167,
		200,
		191,
		174,
		154,
		146,
		165,
		-1,
		135,
		-1,
		110,
		112,
		129,
		111,
		114,
		108,
		81,
		96,
		86,
		77,
		80,
		199,
		-1,
		169,
		202,
		166,
		160,
		136,
		140,
		156,
		-1,
		132,
		114,
		-1,
		142,
		132,
		130,
		115,
		96,
		83,
		90,
		84,
		77,
		-1,
		-1,
		-1,
		171,
		170,
		162,
		156,
		156,
		141,
		132,
		-1,
		144,
		126,
		105,
		122,
		122,
		113,
		121,
		120,
		116,
		103,
		103,
		93,
		-1,
		272,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		165,
		160,
		133,
		121,
		127,
		123,
		109,
		115,
		117,
		125,
		123,
		120,
		118,
		109,
		115,
		92,
		125,
		-1,
		267,
		-1,
		201,
		-1,
		-1,
		183,
		163,
		155,
		144,
		133,
		131,
		122,
		113,
		135,
		151,
		116,
		104,
		99,
		100,
		-1,
		256,
		255,
		-1,
		202,
		194,
		180,
		-1,
		173,
		-1,
		179,
		140,
		-1,
		142,
		122,
		-1,
		115,
		104,
		-1,
		-1,
		243,
		218,
		-1,
		-1,
		-1,
		203,
		183,
		174,
		158,
		-1,
		133,
		133,
		-1,
		-1,
		-1,
		228,
		227,
		-1,
		196,
		199,
		-1,
		189,
		180,
		188,
		135,
		139,
		-1,
		-1,
		-1,
		237,
		218,
		212,
		211,
		209,
		204,
		201,
		187,
		171,
		149,
		138,
		159,
		-1,
		-1,
		-1,
		209,
		201,
		194,
		-1,
		-1,
		196,
		179,
		160,
		158,
		-1,
		-1,
		-1,
		231,
		212,
		-1,
		-1,
		186,
		-1,
		-1,
		192,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		220,
		-1,
		-1,
		-1,
		182,
		178,
		179,
		-1,
		-1,
		-1,
		-1,
		242,
		243,
		266,
		230,
		-1,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		245,
		243,
		-1,
		-1,
		-1,
		202,
		186,
		-1,
		172,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		207,
		-1,
		207,
		182,
		189,
		-1,
		-1,
		-1,
		-1,
		220,
		212,
		220,
		-1,
		192,
		194,
		-1,
		242,
		-1,
		-1,
		235,
		226,
		-1,
		-1,
		197,
		204,
		226,
		229,
		265,
		-1,
		216
	],
	[
		-1,
		223,
		212,
		223,
		231,
		204,
		211,
		-1,
		230,
		234,
		200,
		194,
		233,
		202,
		208,
		219,
		-1,
		-1,
		-1,
		223,
		222,
		190,
		188,
		197,
		202,
		209,
		-1,
		208,
		-1,
		244,
		223,
		234,
		239,
		183,
		180,
		200,
		219,
		201,
		193,
		259,
		213,
		184,
		178,
		196,
		186,
		195,
		187,
		-1,
		184,
		174,
		196,
		175,
		186,
		178,
		-1,
		-1,
		178,
		179,
		185,
		171,
		177,
		173,
		-1,
		183,
		167,
		-1,
		-1,
		168,
		169,
		153,
		156,
		164,
		162,
		175,
		167,
		162,
		-1,
		-1,
		159,
		155,
		162,
		149,
		145,
		162,
		175,
		157,
		171,
		170,
		-1,
		165,
		183,
		188,
		156,
		154,
		138,
		136,
		154,
		156,
		162,
		162,
		-1,
		174,
		175,
		170,
		178,
		178,
		154,
		141,
		141,
		151,
		144,
		163,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		174,
		157,
		174,
		166,
		156,
		171,
		164,
		144,
		141,
		139,
		136,
		152,
		150,
		160,
		-1,
		-1,
		265,
		234,
		265,
		223,
		204,
		-1,
		170,
		150,
		156,
		160,
		154,
		147,
		161,
		157,
		-1,
		130,
		129,
		157,
		143,
		154,
		225,
		-1,
		-1,
		223,
		215,
		200,
		203,
		180,
		176,
		165,
		164,
		156,
		142,
		138,
		144,
		147,
		147,
		153,
		124,
		134,
		138,
		136,
		161,
		-1,
		-1,
		178,
		-1,
		-1,
		222,
		205,
		-1,
		188,
		195,
		186,
		192,
		178,
		199,
		175,
		166,
		158,
		152,
		140,
		142,
		139,
		152,
		140,
		121,
		146,
		150,
		131,
		152,
		147,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		181,
		184,
		190,
		214,
		215,
		-1,
		187,
		175,
		176,
		161,
		158,
		145,
		133,
		146,
		131,
		138,
		137,
		125,
		123,
		153,
		128,
		150,
		143,
		148,
		153,
		147,
		156,
		-1,
		230,
		226,
		222,
		229,
		178,
		-1,
		-1,
		218,
		-1,
		223,
		224,
		199,
		172,
		175,
		162,
		153,
		140,
		129,
		140,
		129,
		126,
		134,
		117,
		132,
		123,
		122,
		132,
		132,
		140,
		144,
		150,
		-1,
		280,
		-1,
		222,
		206,
		208,
		180,
		201,
		-1,
		238,
		224,
		216,
		201,
		199,
		-1,
		171,
		168,
		158,
		136,
		121,
		138,
		130,
		128,
		130,
		112,
		126,
		117,
		135,
		136,
		122,
		126,
		146,
		158,
		240,
		230,
		-1,
		212,
		217,
		176,
		184,
		203,
		241,
		205,
		-1,
		200,
		-1,
		173,
		186,
		-1,
		142,
		138,
		120,
		121,
		116,
		131,
		123,
		108,
		105,
		123,
		126,
		115,
		119,
		135,
		-1,
		-1,
		225,
		229,
		218,
		169,
		188,
		212,
		249,
		198,
		187,
		186,
		-1,
		177,
		156,
		153,
		141,
		128,
		113,
		114,
		122,
		134,
		113,
		107,
		104,
		124,
		132,
		110,
		121,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		195,
		166,
		190,
		232,
		216,
		209,
		197,
		162,
		162,
		156,
		-1,
		152,
		131,
		122,
		111,
		109,
		122,
		114,
		122,
		102,
		100,
		119,
		113,
		104,
		112,
		-1,
		-1,
		-1,
		225,
		214,
		215,
		161,
		184,
		221,
		195,
		181,
		186,
		161,
		154,
		148,
		165,
		148,
		129,
		118,
		110,
		99,
		110,
		118,
		116,
		98,
		107,
		113,
		119,
		100,
		106,
		-1,
		-1,
		232,
		222,
		206,
		208,
		205,
		175,
		182,
		214,
		186,
		199,
		-1,
		153,
		-1,
		142,
		138,
		123,
		118,
		115,
		102,
		101,
		115,
		115,
		105,
		100,
		107,
		124,
		124,
		90,
		110,
		113,
		-1,
		-1,
		-1,
		225,
		220,
		195,
		172,
		156,
		192,
		-1,
		169,
		170,
		-1,
		147,
		141,
		138,
		125,
		121,
		106,
		110,
		112,
		115,
		103,
		109,
		110,
		92,
		116,
		-1,
		98,
		92,
		100,
		90,
		78,
		-1,
		-1,
		-1,
		218,
		197,
		190,
		210,
		151,
		203,
		-1,
		-1,
		154,
		147,
		-1,
		134,
		116,
		118,
		113,
		112,
		111,
		108,
		97,
		110,
		103,
		97,
		91,
		104,
		108,
		102,
		80,
		76,
		73,
		76,
		-1,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		171,
		-1,
		163,
		155,
		145,
		139,
		133,
		129,
		127,
		140,
		124,
		123,
		120,
		111,
		119,
		92,
		85,
		96,
		81,
		99,
		99,
		89,
		79,
		71,
		72,
		-1,
		238,
		224,
		195,
		-1,
		-1,
		184,
		-1,
		148,
		162,
		178,
		-1,
		171,
		150,
		165,
		143,
		139,
		130,
		147,
		148,
		126,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		101,
		93,
		77,
		74,
		67,
		-1,
		244,
		231,
		189,
		185,
		174,
		194,
		145,
		133,
		165,
		-1,
		-1,
		207,
		-1,
		141,
		158,
		144,
		142,
		137,
		128,
		134,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		94,
		80,
		78,
		65,
		57,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		160,
		147,
		141,
		-1,
		182,
		-1,
		185,
		175,
		159,
		144,
		177,
		-1,
		145,
		129,
		134,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		87,
		66,
		-1,
		194,
		179,
		172,
		162,
		176,
		147,
		-1,
		202,
		-1,
		-1,
		172,
		166,
		166,
		150,
		153,
		161,
		141,
		135,
		134,
		121,
		113,
		107,
		85,
		78,
		75,
		65,
		78,
		88,
		80,
		64,
		-1,
		-1,
		-1,
		199,
		185,
		189,
		149,
		168,
		-1,
		-1,
		234,
		189,
		175,
		-1,
		159,
		164,
		152,
		142,
		132,
		137,
		129,
		104,
		97,
		83,
		85,
		77,
		67,
		66,
		71,
		63,
		68,
		-1,
		-1,
		182,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		181,
		197,
		189,
		160,
		153,
		-1,
		-1,
		136,
		129,
		121,
		100,
		87,
		96,
		91,
		76,
		60,
		75,
		66,
		58,
		50,
		-1,
		185,
		172,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		204,
		149,
		138,
		133,
		137,
		135,
		-1,
		109,
		111,
		91,
		103,
		110,
		78,
		66,
		60,
		51,
		61,
		44,
		-1,
		-1,
		197,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		161,
		155,
		126,
		119,
		123,
		-1,
		111,
		107,
		93,
		109,
		84,
		81,
		72,
		62,
		62,
		48,
		48,
		29,
		35,
		220,
		-1,
		189,
		-1,
		-1,
		-1,
		179,
		194,
		165,
		142,
		115,
		110,
		103,
		97,
		101,
		106,
		92,
		103,
		69,
		65,
		61,
		48,
		44,
		33,
		34,
		-1,
		-1,
		187,
		183,
		205,
		187,
		191,
		192,
		-1,
		-1,
		119,
		110,
		101,
		93,
		106,
		109,
		75,
		72,
		72,
		65,
		58,
		57,
		55,
		40,
		-1,
		-1,
		-1,
		199,
		-1,
		201,
		-1,
		-1,
		189,
		190,
		137,
		119,
		115,
		113,
		102,
		96,
		84,
		80,
		90,
		82,
		74,
		55,
		57,
		67,
		43,
		23,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		178,
		170,
		165,
		171,
		173,
		164,
		152,
		149,
		-1,
		119,
		125,
		90,
		97,
		80,
		87,
		86,
		78,
		57,
		54,
		60,
		46,
		34,
		15,
		0,
		9,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		144,
		141,
		121,
		90,
		88,
		81,
		76,
		86,
		66,
		53,
		47,
		51,
		37,
		36,
		31,
		24,
		13,
		15,
		-1,
		218,
		255,
		248,
		216,
		224,
		255,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		117,
		108,
		109,
		97,
		94,
		96,
		91,
		82,
		67,
		73,
		51,
		49,
		66,
		51,
		44,
		27,
		16,
		29,
		33,
		-1,
		211,
		231,
		210,
		213,
		237,
		251,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		113,
		156,
		111,
		106,
		90,
		88,
		79,
		70,
		75,
		59,
		47,
		44,
		53,
		39,
		29,
		26,
		26,
		27,
		-1,
		200,
		211,
		204,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		186,
		-1,
		153,
		-1,
		136,
		140,
		119,
		122,
		104,
		91,
		83,
		75,
		84,
		59,
		55,
		51,
		40,
		49,
		39,
		47,
		33,
		34,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		170,
		209,
		203,
		-1,
		187,
		-1,
		-1,
		-1,
		150,
		132,
		124,
		124,
		103,
		103,
		77,
		78,
		64,
		60,
		67,
		57,
		49,
		53,
		55,
		43,
		42,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		185,
		176,
		203,
		210,
		199,
		194,
		181,
		-1,
		-1,
		173,
		142,
		-1,
		-1,
		110,
		98,
		81,
		75,
		71,
		74,
		82,
		66,
		56,
		54,
		48,
		48,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		204,
		194,
		198,
		214,
		239,
		-1,
		170,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		103,
		92,
		83,
		86,
		79,
		86,
		97,
		62,
		63,
		53,
		63,
		62,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		186,
		166,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		88,
		87,
		106,
		82,
		71,
		65,
		59,
		66,
		65,
		73,
		67,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		172,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		101,
		87,
		83,
		69,
		62,
		57,
		68,
		60,
		64,
		64,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		119,
		87,
		87,
		81,
		63,
		74,
		63,
		66,
		57,
		60,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		183,
		185,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		103,
		101,
		90,
		93,
		88,
		67,
		73,
		76,
		65,
		63,
		57,
		-1,
		-1,
		188,
		189,
		190,
		-1,
		168,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		141,
		104,
		125,
		108,
		96,
		94,
		85,
		71,
		78,
		76,
		72,
		67,
		-1,
		-1,
		-1,
		186,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		103,
		105,
		122,
		104,
		107,
		101,
		74,
		89,
		79,
		70,
		73,
		192,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		123,
		108,
		89,
		76,
		83,
		77,
		70,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		113,
		109,
		96,
		96,
		86,
		-1,
		265,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		111,
		102,
		108,
		85,
		118,
		-1,
		260,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		109,
		97,
		92,
		93,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		108,
		97,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		180,
		198,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		189,
		190,
		185,
		193,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		280,
		249,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		145,
		144,
		172,
		158,
		169,
		240,
		-1,
		-1,
		238,
		230,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		193,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		192,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		140,
		138,
		168,
		143,
		165,
		158,
		163,
		168,
		162,
		171,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		132,
		147,
		138,
		137,
		147,
		147,
		155,
		159,
		165,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		239,
		231,
		216,
		214,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		145,
		127,
		141,
		132,
		150,
		151,
		137,
		141,
		161,
		173,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		138,
		123,
		120,
		138,
		141,
		130,
		134,
		150,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		149,
		128,
		122,
		119,
		139,
		147,
		125,
		136,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		129,
		137,
		117,
		115,
		134,
		128,
		119,
		127,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		180,
		163,
		144,
		133,
		125,
		114,
		125,
		133,
		131,
		113,
		122,
		128,
		134,
		115,
		121,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		153,
		138,
		133,
		130,
		117,
		116,
		130,
		130,
		120,
		115,
		122,
		139,
		139,
		105,
		125,
		128,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		140,
		136,
		121,
		125,
		127,
		130,
		118,
		124,
		125,
		107,
		131,
		-1,
		113,
		107,
		115,
		105,
		93,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		133,
		128,
		127,
		126,
		123,
		112,
		125,
		118,
		112,
		106,
		119,
		123,
		117,
		95,
		91,
		88,
		91,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		155,
		139,
		138,
		135,
		126,
		134,
		107,
		100,
		111,
		96,
		114,
		114,
		104,
		94,
		86,
		87,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		145,
		162,
		163,
		141,
		135,
		133,
		124,
		112,
		101,
		104,
		96,
		116,
		108,
		92,
		89,
		82,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		159,
		157,
		152,
		143,
		149,
		144,
		121,
		116,
		106,
		95,
		95,
		90,
		109,
		95,
		93,
		80,
		72,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		160,
		144,
		149,
		-1,
		141,
		-1,
		114,
		111,
		102,
		87,
		84,
		95,
		93,
		102,
		81,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		176,
		156,
		150,
		149,
		136,
		128,
		122,
		100,
		93,
		90,
		80,
		93,
		103,
		95,
		79,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		174,
		179,
		167,
		157,
		147,
		152,
		144,
		119,
		112,
		98,
		100,
		92,
		82,
		81,
		86,
		78,
		83,
		-1,
		-1,
		197,
		202,
		190,
		176,
		195,
		-1,
		-1,
		-1,
		196,
		212,
		204,
		175,
		168,
		-1,
		-1,
		151,
		144,
		136,
		115,
		102,
		111,
		106,
		91,
		75,
		90,
		81,
		73,
		65,
		-1,
		200,
		187,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		-1,
		-1,
		219,
		164,
		153,
		148,
		152,
		150,
		-1,
		124,
		126,
		106,
		118,
		125,
		93,
		81,
		75,
		66,
		76,
		59,
		-1,
		-1,
		212,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		176,
		170,
		141,
		134,
		138,
		-1,
		126,
		122,
		108,
		124,
		99,
		96,
		87,
		77,
		77,
		63,
		63,
		44,
		50,
		235,
		-1,
		204,
		-1,
		-1,
		-1,
		194,
		209,
		180,
		157,
		130,
		125,
		118,
		112,
		116,
		121,
		107,
		118,
		84,
		80,
		76,
		63,
		59,
		48,
		49,
		-1,
		-1,
		202,
		198,
		220,
		202,
		206,
		207,
		-1,
		-1,
		134,
		125,
		116,
		108,
		121,
		124,
		90,
		87,
		87,
		80,
		73,
		72,
		69,
		55,
		-1,
		-1,
		-1,
		214,
		-1,
		216,
		-1,
		-1,
		204,
		205,
		152,
		134,
		130,
		128,
		117,
		111,
		99,
		95,
		105,
		97,
		89,
		70,
		72,
		82,
		56,
		38,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		193,
		185,
		180,
		186,
		188,
		179,
		167,
		164,
		-1,
		134,
		140,
		105,
		112,
		95,
		102,
		101,
		93,
		72,
		69,
		75,
		59,
		47,
		30,
		15,
		0,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		186,
		182,
		172,
		162,
		165,
		-1,
		-1,
		159,
		156,
		136,
		105,
		103,
		96,
		91,
		101,
		81,
		68,
		62,
		66,
		52,
		49,
		44,
		37,
		24,
		6,
		-1,
		233,
		270,
		263,
		231,
		239,
		270,
		-1,
		176,
		168,
		179,
		154,
		156,
		-1,
		-1,
		132,
		123,
		124,
		112,
		109,
		111,
		106,
		97,
		82,
		88,
		66,
		64,
		81,
		66,
		57,
		42,
		31,
		44,
		48,
		-1,
		226,
		246,
		225,
		228,
		252,
		266,
		-1,
		173,
		-1,
		-1,
		185,
		157,
		141,
		131,
		128,
		171,
		126,
		121,
		105,
		103,
		94,
		85,
		90,
		74,
		62,
		59,
		68,
		54,
		44,
		41,
		39,
		42,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		201,
		-1,
		168,
		-1,
		151,
		155,
		134,
		137,
		119,
		106,
		98,
		90,
		99,
		74,
		70,
		66,
		55,
		64,
		54,
		62,
		48,
		45,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		185,
		224,
		218,
		-1,
		202,
		-1,
		-1,
		-1,
		165,
		147,
		139,
		139,
		118,
		118,
		92,
		93,
		79,
		75,
		82,
		72,
		64,
		68,
		70,
		58,
		53,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		200,
		191,
		218,
		225,
		214,
		209,
		196,
		-1,
		-1,
		188,
		157,
		-1,
		-1,
		125,
		113,
		96,
		90,
		86,
		89,
		97,
		81,
		71,
		69,
		63,
		63,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		219,
		209,
		213,
		229,
		254,
		-1,
		185,
		-1,
		-1,
		170,
		-1,
		-1,
		155,
		118,
		107,
		98,
		101,
		94,
		101,
		112,
		77,
		78,
		68,
		78,
		77,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		185,
		183,
		189,
		196,
		213,
		243,
		-1,
		-1,
		201,
		181,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		103,
		102,
		121,
		97,
		86,
		80,
		74,
		81,
		80,
		88,
		82,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		187,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		116,
		102,
		98,
		84,
		77,
		72,
		83,
		75,
		79,
		79,
		-1,
		256,
		-1,
		208,
		184,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		134,
		102,
		102,
		96,
		78,
		89,
		78,
		81,
		72,
		75,
		-1,
		-1,
		196,
		199,
		-1,
		-1,
		198,
		200,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		118,
		116,
		105,
		108,
		103,
		82,
		88,
		91,
		80,
		78,
		72,
		-1,
		-1,
		203,
		204,
		205,
		-1,
		183,
		-1,
		201,
		-1,
		168,
		174,
		162,
		-1,
		-1,
		-1,
		156,
		119,
		140,
		123,
		111,
		109,
		100,
		86,
		93,
		91,
		87,
		82,
		-1,
		-1,
		-1,
		201,
		175,
		208,
		199,
		182,
		162,
		154,
		173,
		-1,
		143,
		-1,
		118,
		120,
		137,
		119,
		122,
		116,
		89,
		104,
		94,
		85,
		88,
		207,
		-1,
		177,
		210,
		174,
		168,
		144,
		148,
		164,
		-1,
		140,
		122,
		-1,
		150,
		140,
		138,
		123,
		104,
		91,
		98,
		92,
		85,
		-1,
		-1,
		-1,
		179,
		178,
		170,
		164,
		164,
		149,
		140,
		-1,
		152,
		134,
		113,
		130,
		130,
		121,
		129,
		128,
		124,
		111,
		111,
		101,
		-1,
		280,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		173,
		168,
		141,
		129,
		135,
		131,
		117,
		123,
		125,
		133,
		131,
		128,
		126,
		117,
		123,
		100,
		133,
		-1,
		275,
		-1,
		209,
		-1,
		-1,
		191,
		171,
		163,
		152,
		141,
		139,
		130,
		121,
		143,
		159,
		124,
		112,
		107,
		108,
		-1,
		264,
		263,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		187,
		148,
		-1,
		150,
		130,
		-1,
		123,
		112,
		-1,
		-1,
		251,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		182,
		166,
		-1,
		141,
		141,
		-1,
		-1,
		-1,
		236,
		235,
		-1,
		204,
		207,
		-1,
		197,
		188,
		196,
		143,
		147,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		219,
		217,
		212,
		209,
		195,
		179,
		157,
		146,
		167,
		-1,
		-1,
		-1,
		217,
		209,
		202,
		-1,
		-1,
		204,
		187,
		168,
		166,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		194,
		-1,
		-1,
		200,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		228,
		-1,
		-1,
		-1,
		190,
		186,
		187,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		274,
		238,
		-1,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		210,
		194,
		-1,
		180,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		215,
		-1,
		215,
		190,
		197,
		-1,
		-1,
		-1,
		-1,
		228,
		220,
		228,
		-1,
		200,
		202,
		-1,
		250,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		205,
		212,
		234,
		237,
		273,
		-1,
		224
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		332,
		321,
		332,
		340,
		313,
		320,
		-1,
		341,
		343,
		309,
		303,
		342,
		313,
		319,
		330,
		-1,
		-1,
		-1,
		332,
		331,
		301,
		299,
		308,
		313,
		320,
		-1,
		343,
		-1,
		353,
		332,
		343,
		348,
		294,
		291,
		311,
		330,
		336,
		328,
		368,
		324,
		295,
		289,
		307,
		312,
		330,
		322,
		-1,
		295,
		285,
		307,
		311,
		323,
		306,
		-1,
		-1,
		289,
		290,
		296,
		308,
		313,
		318,
		-1,
		344,
		328,
		-1,
		-1,
		279,
		292,
		288,
		291,
		299,
		315,
		336,
		328,
		323,
		-1,
		-1,
		280,
		284,
		297,
		298,
		296,
		323,
		336,
		318,
		332,
		331,
		-1,
		268,
		286,
		295,
		304,
		310,
		299,
		297,
		315,
		317,
		323,
		326,
		-1,
		260,
		262,
		291,
		297,
		309,
		315,
		302,
		302,
		312,
		305,
		324,
		315,
		361,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		257,
		265,
		291,
		290,
		286,
		304,
		312,
		305,
		302,
		300,
		297,
		313,
		314,
		324,
		-1,
		-1,
		313,
		282,
		317,
		274,
		259,
		-1,
		253,
		272,
		278,
		282,
		287,
		295,
		309,
		305,
		-1,
		291,
		290,
		321,
		307,
		318,
		273,
		-1,
		-1,
		271,
		263,
		248,
		251,
		248,
		248,
		278,
		277,
		282,
		284,
		286,
		292,
		295,
		295,
		301,
		285,
		295,
		299,
		307,
		325,
		-1,
		-1,
		367,
		-1,
		-1,
		270,
		253,
		-1,
		236,
		243,
		243,
		260,
		250,
		271,
		286,
		290,
		298,
		300,
		288,
		290,
		287,
		300,
		288,
		282,
		307,
		311,
		302,
		323,
		318,
		-1,
		366,
		350,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		229,
		232,
		238,
		262,
		272,
		-1,
		293,
		291,
		315,
		309,
		306,
		293,
		281,
		294,
		279,
		286,
		285,
		289,
		291,
		324,
		299,
		321,
		318,
		337,
		342,
		336,
		345,
		-1,
		278,
		274,
		270,
		277,
		226,
		-1,
		-1,
		266,
		-1,
		280,
		293,
		300,
		295,
		298,
		310,
		301,
		288,
		277,
		288,
		277,
		274,
		282,
		288,
		302,
		294,
		293,
		311,
		321,
		329,
		333,
		339,
		-1,
		328,
		-1,
		270,
		254,
		256,
		228,
		249,
		-1,
		286,
		281,
		301,
		302,
		293,
		-1,
		296,
		299,
		306,
		284,
		269,
		286,
		278,
		276,
		281,
		283,
		297,
		288,
		306,
		313,
		311,
		315,
		335,
		347,
		288,
		278,
		-1,
		260,
		265,
		224,
		232,
		251,
		324,
		299,
		-1,
		294,
		-1,
		286,
		311,
		-1,
		290,
		286,
		268,
		269,
		264,
		279,
		285,
		279,
		276,
		294,
		297,
		304,
		308,
		324,
		-1,
		-1,
		273,
		277,
		266,
		217,
		236,
		260,
		297,
		292,
		281,
		280,
		-1,
		271,
		301,
		298,
		284,
		271,
		261,
		262,
		270,
		283,
		262,
		278,
		275,
		295,
		321,
		299,
		310,
		-1,
		-1,
		-1,
		298,
		-1,
		-1,
		243,
		214,
		238,
		280,
		310,
		303,
		291,
		256,
		256,
		250,
		-1,
		291,
		274,
		270,
		259,
		257,
		270,
		265,
		281,
		273,
		271,
		290,
		302,
		293,
		301,
		-1,
		-1,
		-1,
		273,
		262,
		263,
		212,
		235,
		269,
		289,
		275,
		280,
		255,
		248,
		242,
		294,
		291,
		258,
		266,
		258,
		247,
		261,
		269,
		273,
		269,
		278,
		284,
		308,
		289,
		295,
		-1,
		-1,
		280,
		270,
		254,
		256,
		253,
		226,
		233,
		265,
		280,
		277,
		-1,
		247,
		-1,
		236,
		244,
		243,
		249,
		261,
		247,
		252,
		263,
		275,
		276,
		271,
		278,
		313,
		313,
		279,
		299,
		302,
		-1,
		-1,
		-1,
		273,
		271,
		246,
		223,
		207,
		243,
		-1,
		247,
		248,
		-1,
		241,
		235,
		241,
		240,
		247,
		244,
		244,
		258,
		266,
		262,
		278,
		281,
		263,
		287,
		-1,
		287,
		281,
		289,
		279,
		267,
		-1,
		-1,
		-1,
		269,
		248,
		241,
		261,
		202,
		254,
		-1,
		-1,
		232,
		225,
		-1,
		228,
		228,
		235,
		244,
		249,
		254,
		262,
		257,
		270,
		274,
		268,
		262,
		275,
		279,
		280,
		269,
		265,
		262,
		276,
		-1,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		222,
		-1,
		235,
		227,
		223,
		217,
		223,
		241,
		239,
		259,
		251,
		265,
		265,
		271,
		277,
		263,
		256,
		267,
		252,
		270,
		276,
		267,
		262,
		261,
		272,
		-1,
		289,
		275,
		246,
		-1,
		-1,
		235,
		-1,
		199,
		213,
		229,
		-1,
		257,
		236,
		259,
		237,
		251,
		247,
		285,
		286,
		264,
		269,
		277,
		265,
		268,
		257,
		260,
		252,
		274,
		271,
		255,
		257,
		266,
		-1,
		295,
		282,
		240,
		236,
		225,
		245,
		196,
		205,
		216,
		-1,
		-1,
		301,
		-1,
		235,
		252,
		261,
		259,
		275,
		264,
		271,
		288,
		262,
		257,
		262,
		251,
		251,
		246,
		265,
		251,
		249,
		264,
		280,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		211,
		198,
		192,
		-1,
		233,
		-1,
		279,
		269,
		253,
		238,
		271,
		-1,
		263,
		259,
		266,
		-1,
		282,
		-1,
		254,
		257,
		248,
		243,
		240,
		251,
		249,
		258,
		259,
		-1,
		245,
		230,
		223,
		213,
		227,
		198,
		-1,
		241,
		-1,
		-1,
		266,
		260,
		260,
		244,
		247,
		279,
		259,
		251,
		266,
		265,
		252,
		251,
		239,
		239,
		242,
		236,
		249,
		259,
		265,
		257,
		-1,
		-1,
		-1,
		250,
		202,
		210,
		186,
		207,
		-1,
		-1,
		328,
		283,
		269,
		-1,
		253,
		279,
		267,
		257,
		247,
		252,
		253,
		243,
		241,
		237,
		246,
		245,
		238,
		237,
		258,
		251,
		273,
		-1,
		-1,
		199,
		212,
		214,
		200,
		219,
		-1,
		-1,
		-1,
		275,
		291,
		283,
		254,
		268,
		-1,
		-1,
		251,
		244,
		238,
		241,
		229,
		249,
		256,
		244,
		231,
		246,
		256,
		264,
		263,
		-1,
		202,
		189,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		-1,
		-1,
		308,
		257,
		246,
		241,
		245,
		250,
		-1,
		224,
		235,
		228,
		247,
		254,
		246,
		231,
		225,
		236,
		251,
		268,
		-1,
		-1,
		236,
		-1,
		231,
		-1,
		-1,
		-1,
		-1,
		265,
		263,
		234,
		227,
		231,
		-1,
		226,
		228,
		225,
		237,
		242,
		246,
		237,
		219,
		233,
		236,
		249,
		263,
		267,
		259,
		-1,
		241,
		-1,
		-1,
		-1,
		280,
		281,
		267,
		244,
		223,
		216,
		213,
		212,
		217,
		228,
		237,
		248,
		213,
		217,
		232,
		237,
		241,
		258,
		262,
		-1,
		-1,
		239,
		235,
		270,
		282,
		254,
		294,
		-1,
		-1,
		212,
		205,
		215,
		208,
		221,
		224,
		209,
		211,
		229,
		242,
		236,
		246,
		261,
		256,
		-1,
		-1,
		-1,
		237,
		-1,
		253,
		-1,
		-1,
		244,
		285,
		232,
		214,
		210,
		196,
		203,
		197,
		199,
		204,
		223,
		218,
		227,
		232,
		236,
		259,
		248,
		287,
		-1,
		-1,
		7,
		-1,
		-1,
		-1,
		203,
		222,
		217,
		223,
		228,
		219,
		247,
		244,
		-1,
		193,
		226,
		194,
		208,
		204,
		211,
		216,
		222,
		226,
		233,
		249,
		248,
		243,
		279,
		270,
		276,
		-1,
		-1,
		0,
		18,
		69,
		75,
		-1,
		196,
		219,
		209,
		199,
		205,
		-1,
		-1,
		211,
		208,
		206,
		186,
		192,
		197,
		200,
		238,
		214,
		222,
		226,
		230,
		236,
		241,
		246,
		252,
		267,
		282,
		-1,
		102,
		143,
		136,
		47,
		51,
		82,
		-1,
		186,
		178,
		206,
		191,
		199,
		-1,
		-1,
		184,
		175,
		180,
		189,
		190,
		221,
		220,
		233,
		236,
		241,
		229,
		228,
		246,
		250,
		259,
		266,
		256,
		269,
		273,
		-1,
		95,
		119,
		55,
		50,
		64,
		78,
		-1,
		177,
		-1,
		-1,
		222,
		209,
		193,
		183,
		180,
		227,
		203,
		198,
		204,
		206,
		230,
		221,
		246,
		237,
		237,
		240,
		255,
		260,
		252,
		266,
		266,
		267,
		-1,
		94,
		99,
		61,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		238,
		-1,
		220,
		-1,
		203,
		207,
		211,
		214,
		229,
		216,
		223,
		240,
		246,
		235,
		245,
		241,
		242,
		251,
		262,
		274,
		273,
		274,
		167,
		122,
		89,
		68,
		126,
		141,
		145,
		-1,
		161,
		197,
		207,
		-1,
		247,
		-1,
		-1,
		-1,
		217,
		224,
		216,
		232,
		228,
		228,
		224,
		228,
		240,
		247,
		257,
		259,
		251,
		255,
		268,
		279,
		282,
		163,
		161,
		166,
		111,
		94,
		111,
		120,
		141,
		157,
		154,
		191,
		196,
		211,
		216,
		240,
		-1,
		-1,
		240,
		234,
		-1,
		-1,
		235,
		245,
		228,
		230,
		234,
		248,
		260,
		268,
		258,
		256,
		250,
		282,
		-1,
		163,
		162,
		151,
		148,
		124,
		115,
		102,
		112,
		-1,
		-1,
		155,
		182,
		166,
		170,
		186,
		211,
		-1,
		247,
		-1,
		-1,
		261,
		-1,
		-1,
		287,
		250,
		239,
		230,
		236,
		242,
		253,
		275,
		264,
		265,
		255,
		265,
		278,
		147,
		144,
		132,
		130,
		153,
		110,
		106,
		-1,
		137,
		140,
		146,
		153,
		170,
		200,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		280,
		283,
		272,
		-1,
		262,
		235,
		240,
		265,
		272,
		273,
		267,
		261,
		268,
		267,
		275,
		283,
		156,
		170,
		159,
		155,
		154,
		162,
		111,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		301,
		-1,
		286,
		273,
		-1,
		-1,
		280,
		273,
		261,
		249,
		239,
		249,
		257,
		257,
		260,
		264,
		259,
		270,
		262,
		266,
		283,
		-1,
		190,
		-1,
		142,
		134,
		149,
		164,
		172,
		-1,
		-1,
		-1,
		303,
		289,
		282,
		270,
		268,
		-1,
		314,
		298,
		279,
		-1,
		249,
		262,
		293,
		261,
		266,
		261,
		265,
		276,
		265,
		268,
		282,
		277,
		-1,
		-1,
		147,
		150,
		-1,
		-1,
		172,
		191,
		-1,
		294,
		283,
		268,
		260,
		-1,
		-1,
		286,
		282,
		-1,
		-1,
		250,
		275,
		264,
		272,
		267,
		269,
		275,
		278,
		267,
		271,
		283,
		-1,
		-1,
		154,
		155,
		160,
		-1,
		181,
		-1,
		296,
		-1,
		263,
		270,
		258,
		-1,
		-1,
		-1,
		288,
		251,
		272,
		282,
		287,
		285,
		276,
		273,
		280,
		278,
		274,
		285,
		-1,
		-1,
		-1,
		211,
		188,
		303,
		294,
		277,
		257,
		249,
		269,
		-1,
		276,
		-1,
		251,
		252,
		279,
		281,
		298,
		292,
		276,
		291,
		281,
		272,
		281,
		217,
		-1,
		192,
		251,
		234,
		263,
		229,
		241,
		297,
		-1,
		273,
		255,
		-1,
		283,
		273,
		315,
		296,
		289,
		276,
		283,
		285,
		278,
		-1,
		-1,
		-1,
		207,
		206,
		205,
		216,
		224,
		222,
		240,
		-1,
		285,
		267,
		246,
		263,
		263,
		254,
		262,
		305,
		301,
		294,
		296,
		286,
		-1,
		262,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		233,
		255,
		250,
		242,
		254,
		263,
		250,
		256,
		258,
		266,
		264,
		261,
		273,
		269,
		289,
		285,
		317,
		-1,
		269,
		-1,
		237,
		-1,
		-1,
		251,
		237,
		249,
		260,
		250,
		250,
		255,
		253,
		275,
		292,
		276,
		274,
		279,
		284,
		-1,
		279,
		280,
		-1,
		270,
		262,
		248,
		-1,
		241,
		-1,
		296,
		257,
		-1,
		282,
		262,
		-1,
		285,
		281,
		-1,
		-1,
		291,
		286,
		-1,
		-1,
		-1,
		271,
		251,
		291,
		275,
		-1,
		273,
		273,
		-1,
		-1,
		-1,
		305,
		295,
		-1,
		264,
		267,
		-1,
		258,
		264,
		293,
		275,
		279,
		-1,
		-1,
		-1,
		320,
		301,
		295,
		279,
		284,
		272,
		289,
		275,
		277,
		289,
		278,
		299,
		-1,
		-1,
		-1,
		292,
		284,
		284,
		-1,
		-1,
		302,
		285,
		285,
		298,
		-1,
		-1,
		-1,
		314,
		295,
		-1,
		-1,
		293,
		-1,
		-1,
		298,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		330,
		303,
		-1,
		-1,
		-1,
		294,
		301,
		309,
		-1,
		-1,
		-1,
		-1,
		322,
		323,
		349,
		324,
		-1,
		-1,
		-1,
		308,
		308,
		-1,
		-1,
		320,
		321,
		-1,
		-1,
		-1,
		336,
		320,
		-1,
		312,
		-1,
		-1,
		-1,
		327,
		-1,
		-1,
		345,
		-1,
		-1,
		-1,
		341,
		-1,
		347,
		322,
		329,
		-1,
		-1,
		-1,
		-1,
		354,
		346,
		360,
		-1,
		332,
		334,
		-1,
		382,
		-1,
		-1,
		369,
		360,
		-1,
		-1,
		337,
		344,
		366,
		369,
		399,
		-1,
		356
	],
	[
		-1,
		322,
		311,
		322,
		330,
		303,
		310,
		-1,
		331,
		333,
		299,
		293,
		332,
		303,
		309,
		320,
		-1,
		-1,
		-1,
		322,
		321,
		291,
		289,
		298,
		303,
		310,
		-1,
		333,
		-1,
		343,
		322,
		333,
		338,
		284,
		281,
		301,
		320,
		326,
		318,
		358,
		314,
		285,
		279,
		297,
		302,
		320,
		312,
		-1,
		285,
		275,
		297,
		301,
		313,
		296,
		-1,
		-1,
		279,
		280,
		286,
		298,
		303,
		308,
		-1,
		334,
		318,
		-1,
		-1,
		269,
		282,
		278,
		281,
		289,
		305,
		326,
		318,
		313,
		-1,
		-1,
		270,
		274,
		287,
		288,
		286,
		313,
		326,
		308,
		322,
		321,
		-1,
		258,
		276,
		285,
		294,
		300,
		289,
		287,
		305,
		307,
		313,
		316,
		-1,
		250,
		252,
		281,
		287,
		299,
		305,
		292,
		292,
		302,
		295,
		314,
		305,
		351,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		247,
		255,
		281,
		280,
		276,
		294,
		302,
		295,
		292,
		290,
		287,
		303,
		304,
		314,
		-1,
		-1,
		303,
		272,
		307,
		264,
		249,
		-1,
		243,
		262,
		268,
		272,
		277,
		285,
		299,
		295,
		-1,
		281,
		280,
		311,
		297,
		308,
		263,
		-1,
		-1,
		261,
		253,
		238,
		241,
		238,
		238,
		268,
		267,
		272,
		274,
		276,
		282,
		285,
		285,
		291,
		275,
		285,
		289,
		297,
		315,
		-1,
		-1,
		357,
		-1,
		-1,
		260,
		243,
		-1,
		226,
		233,
		233,
		250,
		240,
		261,
		276,
		280,
		288,
		290,
		278,
		280,
		277,
		290,
		278,
		272,
		297,
		301,
		292,
		313,
		308,
		-1,
		356,
		340,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		219,
		222,
		228,
		252,
		262,
		-1,
		283,
		281,
		305,
		299,
		296,
		283,
		271,
		284,
		269,
		276,
		275,
		279,
		281,
		314,
		289,
		311,
		308,
		327,
		332,
		326,
		335,
		-1,
		268,
		264,
		260,
		267,
		216,
		-1,
		-1,
		256,
		-1,
		270,
		283,
		290,
		285,
		288,
		300,
		291,
		278,
		267,
		278,
		267,
		264,
		272,
		278,
		292,
		284,
		283,
		301,
		311,
		319,
		323,
		329,
		-1,
		318,
		-1,
		260,
		244,
		246,
		218,
		239,
		-1,
		276,
		271,
		291,
		292,
		283,
		-1,
		286,
		289,
		296,
		274,
		259,
		276,
		268,
		266,
		271,
		273,
		287,
		278,
		296,
		303,
		301,
		305,
		325,
		337,
		278,
		268,
		-1,
		250,
		255,
		214,
		222,
		241,
		314,
		289,
		-1,
		284,
		-1,
		276,
		301,
		-1,
		280,
		276,
		258,
		259,
		254,
		269,
		275,
		269,
		266,
		284,
		287,
		294,
		298,
		314,
		-1,
		-1,
		263,
		267,
		256,
		207,
		226,
		250,
		287,
		282,
		271,
		270,
		-1,
		261,
		291,
		288,
		274,
		261,
		251,
		252,
		260,
		273,
		252,
		268,
		265,
		285,
		311,
		289,
		300,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		233,
		204,
		228,
		270,
		300,
		293,
		281,
		246,
		246,
		240,
		-1,
		281,
		264,
		260,
		249,
		247,
		260,
		255,
		271,
		263,
		261,
		280,
		292,
		283,
		291,
		-1,
		-1,
		-1,
		263,
		252,
		253,
		202,
		225,
		259,
		279,
		265,
		270,
		245,
		238,
		232,
		284,
		281,
		248,
		256,
		248,
		237,
		251,
		259,
		263,
		259,
		268,
		274,
		298,
		279,
		285,
		-1,
		-1,
		270,
		260,
		244,
		246,
		243,
		216,
		223,
		255,
		270,
		267,
		-1,
		237,
		-1,
		226,
		234,
		233,
		239,
		251,
		237,
		242,
		253,
		265,
		266,
		261,
		268,
		303,
		303,
		269,
		289,
		292,
		-1,
		-1,
		-1,
		263,
		261,
		236,
		213,
		197,
		233,
		-1,
		237,
		238,
		-1,
		231,
		225,
		231,
		230,
		237,
		234,
		234,
		248,
		256,
		252,
		268,
		271,
		253,
		277,
		-1,
		277,
		271,
		279,
		269,
		257,
		-1,
		-1,
		-1,
		259,
		238,
		231,
		251,
		192,
		244,
		-1,
		-1,
		222,
		215,
		-1,
		218,
		218,
		225,
		234,
		239,
		244,
		252,
		247,
		260,
		264,
		258,
		252,
		265,
		269,
		270,
		259,
		255,
		252,
		266,
		-1,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		212,
		-1,
		225,
		217,
		213,
		207,
		213,
		231,
		229,
		249,
		241,
		255,
		255,
		261,
		267,
		253,
		246,
		257,
		242,
		260,
		266,
		257,
		252,
		251,
		262,
		-1,
		279,
		265,
		236,
		-1,
		-1,
		225,
		-1,
		189,
		203,
		219,
		-1,
		247,
		226,
		249,
		227,
		241,
		237,
		275,
		276,
		254,
		259,
		267,
		255,
		258,
		247,
		250,
		242,
		264,
		261,
		245,
		247,
		256,
		-1,
		285,
		272,
		230,
		226,
		215,
		235,
		186,
		195,
		206,
		-1,
		-1,
		291,
		-1,
		225,
		242,
		251,
		249,
		265,
		254,
		261,
		278,
		252,
		247,
		252,
		241,
		241,
		236,
		255,
		241,
		239,
		254,
		270,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		201,
		188,
		182,
		-1,
		223,
		-1,
		269,
		259,
		243,
		228,
		261,
		-1,
		253,
		249,
		256,
		-1,
		272,
		-1,
		244,
		247,
		238,
		233,
		230,
		241,
		239,
		248,
		249,
		-1,
		235,
		220,
		213,
		203,
		217,
		188,
		-1,
		231,
		-1,
		-1,
		256,
		250,
		250,
		234,
		237,
		269,
		249,
		241,
		256,
		255,
		242,
		241,
		229,
		229,
		232,
		226,
		239,
		249,
		255,
		247,
		-1,
		-1,
		-1,
		240,
		192,
		200,
		176,
		197,
		-1,
		-1,
		318,
		273,
		259,
		-1,
		243,
		269,
		257,
		247,
		237,
		242,
		243,
		233,
		231,
		227,
		236,
		235,
		228,
		227,
		248,
		241,
		263,
		-1,
		-1,
		189,
		202,
		204,
		190,
		209,
		-1,
		-1,
		-1,
		265,
		281,
		273,
		244,
		258,
		-1,
		-1,
		241,
		234,
		228,
		231,
		219,
		239,
		246,
		234,
		221,
		236,
		246,
		254,
		253,
		-1,
		192,
		179,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		-1,
		-1,
		298,
		247,
		236,
		231,
		235,
		240,
		-1,
		214,
		225,
		218,
		237,
		244,
		236,
		221,
		215,
		226,
		241,
		258,
		-1,
		-1,
		226,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		255,
		253,
		224,
		217,
		221,
		-1,
		216,
		218,
		215,
		227,
		232,
		236,
		227,
		209,
		223,
		226,
		239,
		253,
		257,
		249,
		-1,
		231,
		-1,
		-1,
		-1,
		270,
		271,
		257,
		234,
		213,
		206,
		203,
		202,
		207,
		218,
		227,
		238,
		203,
		207,
		222,
		227,
		231,
		248,
		252,
		-1,
		-1,
		229,
		225,
		260,
		272,
		244,
		284,
		-1,
		-1,
		202,
		195,
		205,
		198,
		211,
		214,
		199,
		201,
		219,
		232,
		226,
		236,
		251,
		246,
		-1,
		-1,
		-1,
		227,
		-1,
		243,
		-1,
		-1,
		234,
		275,
		222,
		204,
		200,
		186,
		193,
		187,
		189,
		194,
		213,
		208,
		217,
		222,
		226,
		249,
		238,
		277,
		-1,
		-1,
		26,
		-1,
		-1,
		-1,
		193,
		212,
		207,
		213,
		218,
		209,
		237,
		234,
		-1,
		183,
		216,
		184,
		198,
		194,
		201,
		206,
		212,
		216,
		223,
		239,
		238,
		233,
		269,
		260,
		266,
		-1,
		-1,
		19,
		0,
		59,
		65,
		-1,
		186,
		209,
		199,
		189,
		195,
		-1,
		-1,
		201,
		198,
		196,
		176,
		182,
		187,
		190,
		228,
		204,
		212,
		216,
		220,
		226,
		231,
		236,
		242,
		257,
		272,
		-1,
		92,
		133,
		126,
		37,
		41,
		72,
		-1,
		176,
		168,
		196,
		181,
		189,
		-1,
		-1,
		174,
		165,
		170,
		179,
		180,
		211,
		210,
		223,
		226,
		231,
		219,
		218,
		236,
		240,
		249,
		256,
		246,
		259,
		263,
		-1,
		85,
		109,
		45,
		40,
		54,
		68,
		-1,
		167,
		-1,
		-1,
		212,
		199,
		183,
		173,
		170,
		217,
		193,
		188,
		194,
		196,
		220,
		211,
		236,
		227,
		227,
		230,
		245,
		250,
		242,
		256,
		256,
		257,
		-1,
		84,
		89,
		51,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		228,
		-1,
		210,
		-1,
		193,
		197,
		201,
		204,
		219,
		206,
		213,
		230,
		236,
		225,
		235,
		231,
		232,
		241,
		252,
		264,
		263,
		264,
		157,
		112,
		79,
		58,
		116,
		131,
		135,
		-1,
		151,
		187,
		197,
		-1,
		237,
		-1,
		-1,
		-1,
		207,
		214,
		206,
		222,
		218,
		218,
		214,
		218,
		230,
		237,
		247,
		249,
		241,
		245,
		258,
		269,
		272,
		153,
		151,
		156,
		101,
		84,
		101,
		110,
		131,
		147,
		144,
		181,
		186,
		201,
		206,
		230,
		-1,
		-1,
		230,
		224,
		-1,
		-1,
		225,
		235,
		218,
		220,
		224,
		238,
		250,
		258,
		248,
		246,
		240,
		272,
		-1,
		153,
		152,
		141,
		138,
		114,
		105,
		92,
		102,
		-1,
		-1,
		145,
		172,
		156,
		160,
		176,
		201,
		-1,
		237,
		-1,
		-1,
		251,
		-1,
		-1,
		277,
		240,
		229,
		220,
		226,
		232,
		243,
		265,
		254,
		255,
		245,
		255,
		268,
		137,
		134,
		122,
		120,
		143,
		100,
		96,
		-1,
		127,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		270,
		273,
		262,
		-1,
		252,
		225,
		230,
		255,
		262,
		263,
		257,
		251,
		258,
		257,
		265,
		273,
		146,
		160,
		149,
		145,
		144,
		152,
		101,
		117,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		-1,
		276,
		263,
		-1,
		-1,
		270,
		263,
		251,
		239,
		229,
		239,
		247,
		247,
		250,
		254,
		249,
		260,
		252,
		256,
		273,
		-1,
		180,
		-1,
		132,
		124,
		139,
		154,
		162,
		-1,
		-1,
		-1,
		293,
		279,
		272,
		260,
		258,
		-1,
		304,
		288,
		269,
		-1,
		239,
		252,
		283,
		251,
		256,
		251,
		255,
		266,
		255,
		258,
		272,
		267,
		-1,
		-1,
		137,
		140,
		-1,
		-1,
		162,
		181,
		-1,
		284,
		273,
		258,
		250,
		-1,
		-1,
		276,
		272,
		-1,
		-1,
		240,
		265,
		254,
		262,
		257,
		259,
		265,
		268,
		257,
		261,
		273,
		-1,
		-1,
		144,
		145,
		150,
		-1,
		171,
		-1,
		286,
		-1,
		253,
		260,
		248,
		-1,
		-1,
		-1,
		278,
		241,
		262,
		272,
		277,
		275,
		266,
		263,
		270,
		268,
		264,
		275,
		-1,
		-1,
		-1,
		201,
		178,
		293,
		284,
		267,
		247,
		239,
		259,
		-1,
		266,
		-1,
		241,
		242,
		269,
		271,
		288,
		282,
		266,
		281,
		271,
		262,
		271,
		207,
		-1,
		182,
		241,
		224,
		253,
		219,
		231,
		287,
		-1,
		263,
		245,
		-1,
		273,
		263,
		305,
		286,
		279,
		266,
		273,
		275,
		268,
		-1,
		-1,
		-1,
		197,
		196,
		195,
		206,
		214,
		212,
		230,
		-1,
		275,
		257,
		236,
		253,
		253,
		244,
		252,
		295,
		291,
		284,
		286,
		276,
		-1,
		252,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		223,
		245,
		240,
		232,
		244,
		253,
		240,
		246,
		248,
		256,
		254,
		251,
		263,
		259,
		279,
		275,
		307,
		-1,
		259,
		-1,
		227,
		-1,
		-1,
		241,
		227,
		239,
		250,
		240,
		240,
		245,
		243,
		265,
		282,
		266,
		264,
		269,
		274,
		-1,
		269,
		270,
		-1,
		260,
		252,
		238,
		-1,
		231,
		-1,
		286,
		247,
		-1,
		272,
		252,
		-1,
		275,
		271,
		-1,
		-1,
		281,
		276,
		-1,
		-1,
		-1,
		261,
		241,
		281,
		265,
		-1,
		263,
		263,
		-1,
		-1,
		-1,
		295,
		285,
		-1,
		254,
		257,
		-1,
		248,
		254,
		283,
		265,
		269,
		-1,
		-1,
		-1,
		310,
		291,
		285,
		269,
		274,
		262,
		279,
		265,
		267,
		279,
		268,
		289,
		-1,
		-1,
		-1,
		282,
		274,
		274,
		-1,
		-1,
		292,
		275,
		275,
		288,
		-1,
		-1,
		-1,
		304,
		285,
		-1,
		-1,
		283,
		-1,
		-1,
		288,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		293,
		-1,
		-1,
		-1,
		284,
		291,
		299,
		-1,
		-1,
		-1,
		-1,
		312,
		313,
		339,
		314,
		-1,
		-1,
		-1,
		298,
		298,
		-1,
		-1,
		310,
		311,
		-1,
		-1,
		-1,
		326,
		310,
		-1,
		302,
		-1,
		-1,
		-1,
		317,
		-1,
		-1,
		335,
		-1,
		-1,
		-1,
		331,
		-1,
		337,
		312,
		319,
		-1,
		-1,
		-1,
		-1,
		344,
		336,
		350,
		-1,
		322,
		324,
		-1,
		372,
		-1,
		-1,
		359,
		350,
		-1,
		-1,
		327,
		334,
		356,
		359,
		389,
		-1,
		346
	],
	[
		-1,
		306,
		295,
		306,
		314,
		287,
		294,
		-1,
		315,
		317,
		283,
		277,
		316,
		287,
		293,
		304,
		-1,
		-1,
		-1,
		306,
		305,
		275,
		273,
		282,
		287,
		294,
		-1,
		317,
		-1,
		327,
		306,
		317,
		322,
		268,
		265,
		285,
		304,
		310,
		302,
		342,
		298,
		269,
		263,
		281,
		286,
		304,
		296,
		-1,
		269,
		259,
		281,
		285,
		297,
		280,
		-1,
		-1,
		263,
		264,
		270,
		282,
		287,
		292,
		-1,
		318,
		302,
		-1,
		-1,
		253,
		266,
		262,
		265,
		273,
		289,
		310,
		302,
		297,
		-1,
		-1,
		254,
		258,
		271,
		272,
		270,
		297,
		310,
		292,
		306,
		305,
		-1,
		242,
		260,
		269,
		278,
		284,
		273,
		271,
		289,
		291,
		297,
		300,
		-1,
		234,
		236,
		265,
		271,
		283,
		289,
		276,
		276,
		286,
		279,
		298,
		289,
		335,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		231,
		239,
		265,
		264,
		260,
		278,
		286,
		279,
		276,
		274,
		271,
		287,
		288,
		298,
		-1,
		-1,
		287,
		256,
		291,
		248,
		233,
		-1,
		227,
		246,
		252,
		256,
		261,
		269,
		283,
		279,
		-1,
		265,
		264,
		295,
		281,
		292,
		247,
		-1,
		-1,
		245,
		237,
		222,
		225,
		222,
		222,
		252,
		251,
		256,
		258,
		260,
		266,
		269,
		269,
		275,
		259,
		269,
		273,
		281,
		299,
		-1,
		-1,
		341,
		-1,
		-1,
		244,
		227,
		-1,
		210,
		217,
		217,
		234,
		224,
		245,
		260,
		264,
		272,
		274,
		262,
		264,
		261,
		274,
		262,
		256,
		281,
		285,
		276,
		297,
		292,
		-1,
		340,
		324,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		203,
		206,
		212,
		236,
		246,
		-1,
		267,
		265,
		289,
		283,
		280,
		267,
		255,
		268,
		253,
		260,
		259,
		263,
		265,
		298,
		273,
		295,
		292,
		311,
		316,
		310,
		319,
		-1,
		252,
		248,
		244,
		251,
		200,
		-1,
		-1,
		240,
		-1,
		254,
		267,
		274,
		269,
		272,
		284,
		275,
		262,
		251,
		262,
		251,
		248,
		256,
		262,
		276,
		268,
		267,
		285,
		295,
		303,
		307,
		313,
		-1,
		302,
		-1,
		244,
		228,
		230,
		202,
		223,
		-1,
		260,
		255,
		275,
		276,
		267,
		-1,
		270,
		273,
		280,
		258,
		243,
		260,
		252,
		250,
		255,
		257,
		271,
		262,
		280,
		287,
		285,
		289,
		309,
		321,
		262,
		252,
		-1,
		234,
		239,
		198,
		206,
		225,
		298,
		273,
		-1,
		268,
		-1,
		260,
		285,
		-1,
		264,
		260,
		242,
		243,
		238,
		253,
		259,
		253,
		250,
		268,
		271,
		278,
		282,
		298,
		-1,
		-1,
		247,
		251,
		240,
		191,
		210,
		234,
		271,
		266,
		255,
		254,
		-1,
		245,
		275,
		272,
		258,
		245,
		235,
		236,
		244,
		257,
		236,
		252,
		249,
		269,
		295,
		273,
		284,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		217,
		188,
		212,
		254,
		284,
		277,
		265,
		230,
		230,
		224,
		-1,
		265,
		248,
		244,
		233,
		231,
		244,
		239,
		255,
		247,
		245,
		264,
		276,
		267,
		275,
		-1,
		-1,
		-1,
		247,
		236,
		237,
		186,
		209,
		243,
		263,
		249,
		254,
		229,
		222,
		216,
		268,
		265,
		232,
		240,
		232,
		221,
		235,
		243,
		247,
		243,
		252,
		258,
		282,
		263,
		269,
		-1,
		-1,
		254,
		244,
		228,
		230,
		227,
		200,
		207,
		239,
		254,
		251,
		-1,
		221,
		-1,
		210,
		218,
		217,
		223,
		235,
		221,
		226,
		237,
		249,
		250,
		245,
		252,
		287,
		287,
		253,
		273,
		276,
		-1,
		-1,
		-1,
		247,
		245,
		220,
		197,
		181,
		217,
		-1,
		221,
		222,
		-1,
		215,
		209,
		215,
		214,
		221,
		218,
		218,
		232,
		240,
		236,
		252,
		255,
		237,
		261,
		-1,
		261,
		255,
		263,
		253,
		241,
		-1,
		-1,
		-1,
		243,
		222,
		215,
		235,
		176,
		228,
		-1,
		-1,
		206,
		199,
		-1,
		202,
		202,
		209,
		218,
		223,
		228,
		236,
		231,
		244,
		248,
		242,
		236,
		249,
		253,
		254,
		243,
		239,
		236,
		250,
		-1,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		196,
		-1,
		209,
		201,
		197,
		191,
		197,
		215,
		213,
		233,
		225,
		239,
		239,
		245,
		251,
		237,
		230,
		241,
		226,
		244,
		250,
		241,
		236,
		235,
		246,
		-1,
		263,
		249,
		220,
		-1,
		-1,
		209,
		-1,
		173,
		187,
		203,
		-1,
		231,
		210,
		233,
		211,
		225,
		221,
		259,
		260,
		238,
		243,
		251,
		239,
		242,
		231,
		234,
		226,
		248,
		245,
		229,
		231,
		240,
		-1,
		269,
		256,
		214,
		210,
		199,
		219,
		170,
		179,
		190,
		-1,
		-1,
		275,
		-1,
		209,
		226,
		235,
		233,
		249,
		238,
		245,
		262,
		236,
		231,
		236,
		225,
		225,
		220,
		239,
		225,
		223,
		238,
		254,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		185,
		172,
		166,
		-1,
		207,
		-1,
		253,
		243,
		227,
		212,
		245,
		-1,
		237,
		233,
		240,
		-1,
		256,
		-1,
		228,
		231,
		222,
		217,
		214,
		225,
		223,
		232,
		233,
		-1,
		219,
		204,
		197,
		187,
		201,
		172,
		-1,
		215,
		-1,
		-1,
		240,
		234,
		234,
		218,
		221,
		253,
		233,
		225,
		240,
		239,
		226,
		225,
		213,
		213,
		216,
		210,
		223,
		233,
		239,
		231,
		-1,
		-1,
		-1,
		224,
		176,
		184,
		160,
		181,
		-1,
		-1,
		302,
		257,
		243,
		-1,
		227,
		253,
		241,
		231,
		221,
		226,
		227,
		217,
		215,
		211,
		220,
		219,
		212,
		211,
		232,
		225,
		247,
		-1,
		-1,
		173,
		186,
		188,
		174,
		193,
		-1,
		-1,
		-1,
		249,
		265,
		257,
		228,
		242,
		-1,
		-1,
		225,
		218,
		212,
		215,
		203,
		223,
		230,
		218,
		205,
		220,
		230,
		238,
		237,
		-1,
		176,
		163,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		-1,
		-1,
		282,
		231,
		220,
		215,
		219,
		224,
		-1,
		198,
		209,
		202,
		221,
		228,
		220,
		205,
		199,
		210,
		225,
		242,
		-1,
		-1,
		210,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		239,
		237,
		208,
		201,
		205,
		-1,
		200,
		202,
		199,
		211,
		216,
		220,
		211,
		193,
		207,
		210,
		223,
		237,
		241,
		233,
		-1,
		215,
		-1,
		-1,
		-1,
		254,
		255,
		241,
		218,
		197,
		190,
		187,
		186,
		191,
		202,
		211,
		222,
		187,
		191,
		206,
		211,
		215,
		232,
		236,
		-1,
		-1,
		213,
		209,
		244,
		256,
		228,
		268,
		-1,
		-1,
		186,
		179,
		189,
		182,
		195,
		198,
		183,
		185,
		203,
		216,
		210,
		220,
		235,
		230,
		-1,
		-1,
		-1,
		211,
		-1,
		227,
		-1,
		-1,
		218,
		259,
		206,
		188,
		184,
		170,
		177,
		171,
		173,
		178,
		197,
		192,
		201,
		206,
		210,
		233,
		222,
		261,
		-1,
		-1,
		72,
		-1,
		-1,
		-1,
		177,
		196,
		191,
		197,
		202,
		193,
		221,
		218,
		-1,
		167,
		200,
		168,
		182,
		178,
		185,
		190,
		196,
		200,
		207,
		223,
		222,
		217,
		253,
		244,
		250,
		-1,
		-1,
		65,
		54,
		0,
		6,
		-1,
		170,
		193,
		183,
		173,
		179,
		-1,
		-1,
		185,
		182,
		180,
		160,
		166,
		171,
		174,
		212,
		188,
		196,
		200,
		204,
		210,
		215,
		220,
		226,
		241,
		256,
		-1,
		76,
		117,
		110,
		21,
		17,
		44,
		-1,
		160,
		152,
		180,
		165,
		173,
		-1,
		-1,
		158,
		149,
		154,
		163,
		164,
		195,
		194,
		207,
		210,
		215,
		203,
		202,
		220,
		224,
		233,
		240,
		230,
		243,
		247,
		-1,
		69,
		93,
		29,
		24,
		26,
		40,
		-1,
		151,
		-1,
		-1,
		196,
		183,
		167,
		157,
		154,
		201,
		177,
		172,
		178,
		180,
		204,
		195,
		220,
		211,
		211,
		214,
		229,
		234,
		226,
		240,
		240,
		241,
		-1,
		68,
		73,
		35,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		212,
		-1,
		194,
		-1,
		177,
		181,
		185,
		188,
		203,
		190,
		197,
		214,
		220,
		209,
		219,
		215,
		216,
		225,
		236,
		248,
		247,
		248,
		141,
		96,
		63,
		42,
		100,
		115,
		119,
		-1,
		135,
		171,
		181,
		-1,
		221,
		-1,
		-1,
		-1,
		191,
		198,
		190,
		206,
		202,
		202,
		198,
		202,
		214,
		221,
		231,
		233,
		225,
		229,
		242,
		253,
		256,
		137,
		135,
		140,
		85,
		68,
		85,
		94,
		115,
		131,
		128,
		165,
		170,
		185,
		190,
		214,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		209,
		219,
		202,
		204,
		208,
		222,
		234,
		242,
		232,
		230,
		224,
		256,
		-1,
		137,
		136,
		125,
		122,
		98,
		89,
		76,
		86,
		-1,
		-1,
		129,
		156,
		140,
		144,
		160,
		185,
		-1,
		221,
		-1,
		-1,
		235,
		-1,
		-1,
		261,
		224,
		213,
		204,
		210,
		216,
		227,
		249,
		238,
		239,
		229,
		239,
		252,
		121,
		118,
		106,
		104,
		127,
		84,
		80,
		-1,
		111,
		114,
		120,
		127,
		144,
		174,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		254,
		257,
		246,
		-1,
		236,
		209,
		214,
		239,
		246,
		247,
		241,
		235,
		242,
		241,
		249,
		257,
		130,
		144,
		133,
		129,
		128,
		136,
		85,
		101,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		-1,
		260,
		247,
		-1,
		-1,
		254,
		247,
		235,
		223,
		213,
		223,
		231,
		231,
		234,
		238,
		233,
		244,
		236,
		240,
		257,
		-1,
		164,
		-1,
		116,
		108,
		123,
		138,
		146,
		-1,
		-1,
		-1,
		277,
		263,
		256,
		244,
		242,
		-1,
		288,
		272,
		253,
		-1,
		223,
		236,
		267,
		235,
		240,
		235,
		239,
		250,
		239,
		242,
		256,
		251,
		-1,
		-1,
		121,
		124,
		-1,
		-1,
		146,
		165,
		-1,
		268,
		257,
		242,
		234,
		-1,
		-1,
		260,
		256,
		-1,
		-1,
		224,
		249,
		238,
		246,
		241,
		243,
		249,
		252,
		241,
		245,
		257,
		-1,
		-1,
		128,
		129,
		134,
		-1,
		155,
		-1,
		270,
		-1,
		237,
		244,
		232,
		-1,
		-1,
		-1,
		262,
		225,
		246,
		256,
		261,
		259,
		250,
		247,
		254,
		252,
		248,
		259,
		-1,
		-1,
		-1,
		185,
		162,
		277,
		268,
		251,
		231,
		223,
		243,
		-1,
		250,
		-1,
		225,
		226,
		253,
		255,
		272,
		266,
		250,
		265,
		255,
		246,
		255,
		191,
		-1,
		166,
		225,
		208,
		237,
		203,
		215,
		271,
		-1,
		247,
		229,
		-1,
		257,
		247,
		289,
		270,
		263,
		250,
		257,
		259,
		252,
		-1,
		-1,
		-1,
		181,
		180,
		179,
		190,
		198,
		196,
		214,
		-1,
		259,
		241,
		220,
		237,
		237,
		228,
		236,
		279,
		275,
		268,
		270,
		260,
		-1,
		236,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		207,
		229,
		224,
		216,
		228,
		237,
		224,
		230,
		232,
		240,
		238,
		235,
		247,
		243,
		263,
		259,
		291,
		-1,
		243,
		-1,
		211,
		-1,
		-1,
		225,
		211,
		223,
		234,
		224,
		224,
		229,
		227,
		249,
		266,
		250,
		248,
		253,
		258,
		-1,
		253,
		254,
		-1,
		244,
		236,
		222,
		-1,
		215,
		-1,
		270,
		231,
		-1,
		256,
		236,
		-1,
		259,
		255,
		-1,
		-1,
		265,
		260,
		-1,
		-1,
		-1,
		245,
		225,
		265,
		249,
		-1,
		247,
		247,
		-1,
		-1,
		-1,
		279,
		269,
		-1,
		238,
		241,
		-1,
		232,
		238,
		267,
		249,
		253,
		-1,
		-1,
		-1,
		294,
		275,
		269,
		253,
		258,
		246,
		263,
		249,
		251,
		263,
		252,
		273,
		-1,
		-1,
		-1,
		266,
		258,
		258,
		-1,
		-1,
		276,
		259,
		259,
		272,
		-1,
		-1,
		-1,
		288,
		269,
		-1,
		-1,
		267,
		-1,
		-1,
		272,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		277,
		-1,
		-1,
		-1,
		268,
		275,
		283,
		-1,
		-1,
		-1,
		-1,
		296,
		297,
		323,
		298,
		-1,
		-1,
		-1,
		282,
		282,
		-1,
		-1,
		294,
		295,
		-1,
		-1,
		-1,
		310,
		294,
		-1,
		286,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		319,
		-1,
		-1,
		-1,
		315,
		-1,
		321,
		296,
		303,
		-1,
		-1,
		-1,
		-1,
		328,
		320,
		334,
		-1,
		306,
		308,
		-1,
		356,
		-1,
		-1,
		343,
		334,
		-1,
		-1,
		311,
		318,
		340,
		343,
		373,
		-1,
		330
	],
	[
		-1,
		311,
		300,
		311,
		319,
		292,
		299,
		-1,
		320,
		322,
		288,
		282,
		321,
		292,
		298,
		309,
		-1,
		-1,
		-1,
		311,
		310,
		280,
		278,
		287,
		292,
		299,
		-1,
		322,
		-1,
		332,
		311,
		322,
		327,
		273,
		270,
		290,
		309,
		315,
		307,
		347,
		303,
		274,
		268,
		286,
		291,
		309,
		301,
		-1,
		274,
		264,
		286,
		290,
		302,
		285,
		-1,
		-1,
		268,
		269,
		275,
		287,
		292,
		297,
		-1,
		323,
		307,
		-1,
		-1,
		258,
		271,
		267,
		270,
		278,
		294,
		315,
		307,
		302,
		-1,
		-1,
		259,
		263,
		276,
		277,
		275,
		302,
		315,
		297,
		311,
		310,
		-1,
		247,
		265,
		274,
		283,
		289,
		278,
		276,
		294,
		296,
		302,
		305,
		-1,
		239,
		241,
		270,
		276,
		288,
		294,
		281,
		281,
		291,
		284,
		303,
		294,
		340,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		236,
		244,
		270,
		269,
		265,
		283,
		291,
		284,
		281,
		279,
		276,
		292,
		293,
		303,
		-1,
		-1,
		292,
		261,
		296,
		253,
		238,
		-1,
		232,
		251,
		257,
		261,
		266,
		274,
		288,
		284,
		-1,
		270,
		269,
		300,
		286,
		297,
		252,
		-1,
		-1,
		250,
		242,
		227,
		230,
		227,
		227,
		257,
		256,
		261,
		263,
		265,
		271,
		274,
		274,
		280,
		264,
		274,
		278,
		286,
		304,
		-1,
		-1,
		346,
		-1,
		-1,
		249,
		232,
		-1,
		215,
		222,
		222,
		239,
		229,
		250,
		265,
		269,
		277,
		279,
		267,
		269,
		266,
		279,
		267,
		261,
		286,
		290,
		281,
		302,
		297,
		-1,
		345,
		329,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		208,
		211,
		217,
		241,
		251,
		-1,
		272,
		270,
		294,
		288,
		285,
		272,
		260,
		273,
		258,
		265,
		264,
		268,
		270,
		303,
		278,
		300,
		297,
		316,
		321,
		315,
		324,
		-1,
		257,
		253,
		249,
		256,
		205,
		-1,
		-1,
		245,
		-1,
		259,
		272,
		279,
		274,
		277,
		289,
		280,
		267,
		256,
		267,
		256,
		253,
		261,
		267,
		281,
		273,
		272,
		290,
		300,
		308,
		312,
		318,
		-1,
		307,
		-1,
		249,
		233,
		235,
		207,
		228,
		-1,
		265,
		260,
		280,
		281,
		272,
		-1,
		275,
		278,
		285,
		263,
		248,
		265,
		257,
		255,
		260,
		262,
		276,
		267,
		285,
		292,
		290,
		294,
		314,
		326,
		267,
		257,
		-1,
		239,
		244,
		203,
		211,
		230,
		303,
		278,
		-1,
		273,
		-1,
		265,
		290,
		-1,
		269,
		265,
		247,
		248,
		243,
		258,
		264,
		258,
		255,
		273,
		276,
		283,
		287,
		303,
		-1,
		-1,
		252,
		256,
		245,
		196,
		215,
		239,
		276,
		271,
		260,
		259,
		-1,
		250,
		280,
		277,
		263,
		250,
		240,
		241,
		249,
		262,
		241,
		257,
		254,
		274,
		300,
		278,
		289,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		222,
		193,
		217,
		259,
		289,
		282,
		270,
		235,
		235,
		229,
		-1,
		270,
		253,
		249,
		238,
		236,
		249,
		244,
		260,
		252,
		250,
		269,
		281,
		272,
		280,
		-1,
		-1,
		-1,
		252,
		241,
		242,
		191,
		214,
		248,
		268,
		254,
		259,
		234,
		227,
		221,
		273,
		270,
		237,
		245,
		237,
		226,
		240,
		248,
		252,
		248,
		257,
		263,
		287,
		268,
		274,
		-1,
		-1,
		259,
		249,
		233,
		235,
		232,
		205,
		212,
		244,
		259,
		256,
		-1,
		226,
		-1,
		215,
		223,
		222,
		228,
		240,
		226,
		231,
		242,
		254,
		255,
		250,
		257,
		292,
		292,
		258,
		278,
		281,
		-1,
		-1,
		-1,
		252,
		250,
		225,
		202,
		186,
		222,
		-1,
		226,
		227,
		-1,
		220,
		214,
		220,
		219,
		226,
		223,
		223,
		237,
		245,
		241,
		257,
		260,
		242,
		266,
		-1,
		266,
		260,
		268,
		258,
		246,
		-1,
		-1,
		-1,
		248,
		227,
		220,
		240,
		181,
		233,
		-1,
		-1,
		211,
		204,
		-1,
		207,
		207,
		214,
		223,
		228,
		233,
		241,
		236,
		249,
		253,
		247,
		241,
		254,
		258,
		259,
		248,
		244,
		241,
		255,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		201,
		-1,
		214,
		206,
		202,
		196,
		202,
		220,
		218,
		238,
		230,
		244,
		244,
		250,
		256,
		242,
		235,
		246,
		231,
		249,
		255,
		246,
		241,
		240,
		251,
		-1,
		268,
		254,
		225,
		-1,
		-1,
		214,
		-1,
		178,
		192,
		208,
		-1,
		236,
		215,
		238,
		216,
		230,
		226,
		264,
		265,
		243,
		248,
		256,
		244,
		247,
		236,
		239,
		231,
		253,
		250,
		234,
		236,
		245,
		-1,
		274,
		261,
		219,
		215,
		204,
		224,
		175,
		184,
		195,
		-1,
		-1,
		280,
		-1,
		214,
		231,
		240,
		238,
		254,
		243,
		250,
		267,
		241,
		236,
		241,
		230,
		230,
		225,
		244,
		230,
		228,
		243,
		259,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		190,
		177,
		171,
		-1,
		212,
		-1,
		258,
		248,
		232,
		217,
		250,
		-1,
		242,
		238,
		245,
		-1,
		261,
		-1,
		233,
		236,
		227,
		222,
		219,
		230,
		228,
		237,
		238,
		-1,
		224,
		209,
		202,
		192,
		206,
		177,
		-1,
		220,
		-1,
		-1,
		245,
		239,
		239,
		223,
		226,
		258,
		238,
		230,
		245,
		244,
		231,
		230,
		218,
		218,
		221,
		215,
		228,
		238,
		244,
		236,
		-1,
		-1,
		-1,
		229,
		181,
		189,
		165,
		186,
		-1,
		-1,
		307,
		262,
		248,
		-1,
		232,
		258,
		246,
		236,
		226,
		231,
		232,
		222,
		220,
		216,
		225,
		224,
		217,
		216,
		237,
		230,
		252,
		-1,
		-1,
		178,
		191,
		193,
		179,
		198,
		-1,
		-1,
		-1,
		254,
		270,
		262,
		233,
		247,
		-1,
		-1,
		230,
		223,
		217,
		220,
		208,
		228,
		235,
		223,
		210,
		225,
		235,
		243,
		242,
		-1,
		181,
		168,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		-1,
		-1,
		287,
		236,
		225,
		220,
		224,
		229,
		-1,
		203,
		214,
		207,
		226,
		233,
		225,
		210,
		204,
		215,
		230,
		247,
		-1,
		-1,
		215,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		244,
		242,
		213,
		206,
		210,
		-1,
		205,
		207,
		204,
		216,
		221,
		225,
		216,
		198,
		212,
		215,
		228,
		242,
		246,
		238,
		-1,
		220,
		-1,
		-1,
		-1,
		259,
		260,
		246,
		223,
		202,
		195,
		192,
		191,
		196,
		207,
		216,
		227,
		192,
		196,
		211,
		216,
		220,
		237,
		241,
		-1,
		-1,
		218,
		214,
		249,
		261,
		233,
		273,
		-1,
		-1,
		191,
		184,
		194,
		187,
		200,
		203,
		188,
		190,
		208,
		221,
		215,
		225,
		240,
		235,
		-1,
		-1,
		-1,
		216,
		-1,
		232,
		-1,
		-1,
		223,
		264,
		211,
		193,
		189,
		175,
		182,
		176,
		178,
		183,
		202,
		197,
		206,
		211,
		215,
		238,
		227,
		266,
		-1,
		-1,
		77,
		-1,
		-1,
		-1,
		182,
		201,
		196,
		202,
		207,
		198,
		226,
		223,
		-1,
		172,
		205,
		173,
		187,
		183,
		190,
		195,
		201,
		205,
		212,
		228,
		227,
		222,
		258,
		249,
		255,
		-1,
		-1,
		70,
		59,
		5,
		0,
		-1,
		175,
		198,
		188,
		178,
		184,
		-1,
		-1,
		190,
		187,
		185,
		165,
		171,
		176,
		179,
		217,
		193,
		201,
		205,
		209,
		215,
		220,
		225,
		231,
		246,
		261,
		-1,
		81,
		122,
		115,
		26,
		22,
		49,
		-1,
		165,
		157,
		185,
		170,
		178,
		-1,
		-1,
		163,
		154,
		159,
		168,
		169,
		200,
		199,
		212,
		215,
		220,
		208,
		207,
		225,
		229,
		238,
		245,
		235,
		248,
		252,
		-1,
		74,
		98,
		34,
		29,
		31,
		45,
		-1,
		156,
		-1,
		-1,
		201,
		188,
		172,
		162,
		159,
		206,
		182,
		177,
		183,
		185,
		209,
		200,
		225,
		216,
		216,
		219,
		234,
		239,
		231,
		245,
		245,
		246,
		-1,
		73,
		78,
		40,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		217,
		-1,
		199,
		-1,
		182,
		186,
		190,
		193,
		208,
		195,
		202,
		219,
		225,
		214,
		224,
		220,
		221,
		230,
		241,
		253,
		252,
		253,
		146,
		101,
		68,
		47,
		105,
		120,
		124,
		-1,
		140,
		176,
		186,
		-1,
		226,
		-1,
		-1,
		-1,
		196,
		203,
		195,
		211,
		207,
		207,
		203,
		207,
		219,
		226,
		236,
		238,
		230,
		234,
		247,
		258,
		261,
		142,
		140,
		145,
		90,
		73,
		90,
		99,
		120,
		136,
		133,
		170,
		175,
		190,
		195,
		219,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		214,
		224,
		207,
		209,
		213,
		227,
		239,
		247,
		237,
		235,
		229,
		261,
		-1,
		142,
		141,
		130,
		127,
		103,
		94,
		81,
		91,
		-1,
		-1,
		134,
		161,
		145,
		149,
		165,
		190,
		-1,
		226,
		-1,
		-1,
		240,
		-1,
		-1,
		266,
		229,
		218,
		209,
		215,
		221,
		232,
		254,
		243,
		244,
		234,
		244,
		257,
		126,
		123,
		111,
		109,
		132,
		89,
		85,
		-1,
		116,
		119,
		125,
		132,
		149,
		179,
		-1,
		-1,
		242,
		233,
		-1,
		-1,
		259,
		262,
		251,
		-1,
		241,
		214,
		219,
		244,
		251,
		252,
		246,
		240,
		247,
		246,
		254,
		262,
		135,
		149,
		138,
		134,
		133,
		141,
		90,
		106,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		-1,
		265,
		252,
		-1,
		-1,
		259,
		252,
		240,
		228,
		218,
		228,
		236,
		236,
		239,
		243,
		238,
		249,
		241,
		245,
		262,
		-1,
		169,
		-1,
		121,
		113,
		128,
		143,
		151,
		-1,
		-1,
		-1,
		282,
		268,
		261,
		249,
		247,
		-1,
		293,
		277,
		258,
		-1,
		228,
		241,
		272,
		240,
		245,
		240,
		244,
		255,
		244,
		247,
		261,
		256,
		-1,
		-1,
		126,
		129,
		-1,
		-1,
		151,
		170,
		-1,
		273,
		262,
		247,
		239,
		-1,
		-1,
		265,
		261,
		-1,
		-1,
		229,
		254,
		243,
		251,
		246,
		248,
		254,
		257,
		246,
		250,
		262,
		-1,
		-1,
		133,
		134,
		139,
		-1,
		160,
		-1,
		275,
		-1,
		242,
		249,
		237,
		-1,
		-1,
		-1,
		267,
		230,
		251,
		261,
		266,
		264,
		255,
		252,
		259,
		257,
		253,
		264,
		-1,
		-1,
		-1,
		190,
		167,
		282,
		273,
		256,
		236,
		228,
		248,
		-1,
		255,
		-1,
		230,
		231,
		258,
		260,
		277,
		271,
		255,
		270,
		260,
		251,
		260,
		196,
		-1,
		171,
		230,
		213,
		242,
		208,
		220,
		276,
		-1,
		252,
		234,
		-1,
		262,
		252,
		294,
		275,
		268,
		255,
		262,
		264,
		257,
		-1,
		-1,
		-1,
		186,
		185,
		184,
		195,
		203,
		201,
		219,
		-1,
		264,
		246,
		225,
		242,
		242,
		233,
		241,
		284,
		280,
		273,
		275,
		265,
		-1,
		241,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		212,
		234,
		229,
		221,
		233,
		242,
		229,
		235,
		237,
		245,
		243,
		240,
		252,
		248,
		268,
		264,
		296,
		-1,
		248,
		-1,
		216,
		-1,
		-1,
		230,
		216,
		228,
		239,
		229,
		229,
		234,
		232,
		254,
		271,
		255,
		253,
		258,
		263,
		-1,
		258,
		259,
		-1,
		249,
		241,
		227,
		-1,
		220,
		-1,
		275,
		236,
		-1,
		261,
		241,
		-1,
		264,
		260,
		-1,
		-1,
		270,
		265,
		-1,
		-1,
		-1,
		250,
		230,
		270,
		254,
		-1,
		252,
		252,
		-1,
		-1,
		-1,
		284,
		274,
		-1,
		243,
		246,
		-1,
		237,
		243,
		272,
		254,
		258,
		-1,
		-1,
		-1,
		299,
		280,
		274,
		258,
		263,
		251,
		268,
		254,
		256,
		268,
		257,
		278,
		-1,
		-1,
		-1,
		271,
		263,
		263,
		-1,
		-1,
		281,
		264,
		264,
		277,
		-1,
		-1,
		-1,
		293,
		274,
		-1,
		-1,
		272,
		-1,
		-1,
		277,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		282,
		-1,
		-1,
		-1,
		273,
		280,
		288,
		-1,
		-1,
		-1,
		-1,
		301,
		302,
		328,
		303,
		-1,
		-1,
		-1,
		287,
		287,
		-1,
		-1,
		299,
		300,
		-1,
		-1,
		-1,
		315,
		299,
		-1,
		291,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		320,
		-1,
		326,
		301,
		308,
		-1,
		-1,
		-1,
		-1,
		333,
		325,
		339,
		-1,
		311,
		313,
		-1,
		361,
		-1,
		-1,
		348,
		339,
		-1,
		-1,
		316,
		323,
		345,
		348,
		378,
		-1,
		335
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		265,
		254,
		265,
		273,
		246,
		253,
		-1,
		274,
		276,
		242,
		236,
		275,
		246,
		252,
		263,
		-1,
		-1,
		-1,
		265,
		264,
		234,
		232,
		241,
		246,
		253,
		-1,
		276,
		-1,
		286,
		265,
		276,
		281,
		227,
		224,
		244,
		263,
		269,
		261,
		301,
		257,
		228,
		222,
		240,
		245,
		263,
		255,
		-1,
		228,
		218,
		240,
		244,
		256,
		239,
		-1,
		-1,
		222,
		223,
		229,
		241,
		246,
		243,
		-1,
		253,
		237,
		-1,
		-1,
		212,
		225,
		221,
		224,
		232,
		232,
		245,
		237,
		232,
		-1,
		-1,
		213,
		217,
		230,
		219,
		215,
		232,
		245,
		227,
		241,
		240,
		-1,
		201,
		219,
		228,
		226,
		224,
		208,
		206,
		224,
		226,
		232,
		232,
		-1,
		193,
		195,
		224,
		230,
		242,
		224,
		211,
		211,
		221,
		214,
		233,
		221,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		190,
		198,
		224,
		223,
		219,
		237,
		234,
		214,
		211,
		209,
		206,
		222,
		220,
		230,
		-1,
		-1,
		246,
		215,
		250,
		207,
		192,
		-1,
		186,
		205,
		211,
		215,
		220,
		217,
		231,
		227,
		-1,
		200,
		199,
		227,
		213,
		224,
		206,
		-1,
		-1,
		204,
		196,
		181,
		184,
		181,
		181,
		211,
		210,
		215,
		212,
		208,
		214,
		217,
		217,
		223,
		194,
		204,
		208,
		206,
		231,
		-1,
		-1,
		266,
		-1,
		-1,
		203,
		186,
		-1,
		169,
		176,
		176,
		193,
		183,
		204,
		219,
		223,
		228,
		222,
		210,
		212,
		209,
		222,
		210,
		191,
		216,
		220,
		201,
		222,
		217,
		-1,
		265,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		162,
		165,
		171,
		195,
		205,
		-1,
		226,
		224,
		246,
		231,
		228,
		215,
		203,
		216,
		201,
		208,
		207,
		195,
		193,
		223,
		198,
		220,
		217,
		236,
		241,
		235,
		244,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		199,
		-1,
		213,
		226,
		230,
		228,
		231,
		232,
		223,
		210,
		199,
		210,
		199,
		196,
		204,
		187,
		202,
		193,
		192,
		210,
		220,
		228,
		232,
		238,
		-1,
		261,
		-1,
		203,
		187,
		189,
		161,
		182,
		-1,
		219,
		214,
		234,
		232,
		223,
		-1,
		226,
		229,
		228,
		206,
		191,
		208,
		200,
		198,
		200,
		182,
		196,
		187,
		205,
		212,
		210,
		214,
		234,
		246,
		221,
		211,
		-1,
		193,
		198,
		157,
		165,
		184,
		257,
		229,
		-1,
		224,
		-1,
		216,
		241,
		-1,
		212,
		208,
		190,
		191,
		186,
		201,
		193,
		178,
		175,
		193,
		196,
		203,
		207,
		223,
		-1,
		-1,
		206,
		210,
		199,
		150,
		169,
		193,
		230,
		222,
		211,
		210,
		-1,
		201,
		226,
		223,
		211,
		198,
		183,
		184,
		192,
		204,
		183,
		177,
		174,
		194,
		220,
		198,
		209,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		176,
		147,
		171,
		213,
		240,
		233,
		221,
		186,
		186,
		180,
		-1,
		221,
		201,
		192,
		181,
		179,
		192,
		184,
		192,
		172,
		170,
		189,
		201,
		192,
		200,
		-1,
		-1,
		-1,
		206,
		195,
		196,
		142,
		165,
		202,
		219,
		205,
		210,
		185,
		178,
		172,
		224,
		218,
		188,
		188,
		180,
		169,
		180,
		188,
		186,
		168,
		177,
		183,
		207,
		188,
		194,
		-1,
		-1,
		213,
		203,
		187,
		189,
		186,
		156,
		163,
		195,
		210,
		207,
		-1,
		177,
		-1,
		166,
		174,
		173,
		179,
		185,
		172,
		171,
		185,
		185,
		175,
		170,
		177,
		212,
		212,
		178,
		198,
		201,
		-1,
		-1,
		-1,
		206,
		201,
		176,
		153,
		137,
		173,
		-1,
		177,
		178,
		-1,
		171,
		165,
		171,
		170,
		177,
		174,
		174,
		182,
		185,
		173,
		179,
		180,
		162,
		186,
		-1,
		186,
		180,
		188,
		178,
		166,
		-1,
		-1,
		-1,
		199,
		178,
		171,
		191,
		132,
		184,
		-1,
		-1,
		162,
		155,
		-1,
		158,
		158,
		165,
		174,
		179,
		181,
		178,
		167,
		180,
		173,
		167,
		161,
		174,
		178,
		179,
		168,
		164,
		161,
		175,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		152,
		-1,
		170,
		162,
		153,
		147,
		153,
		171,
		169,
		189,
		181,
		193,
		189,
		181,
		176,
		162,
		155,
		166,
		151,
		169,
		175,
		166,
		161,
		160,
		171,
		-1,
		219,
		205,
		176,
		-1,
		-1,
		165,
		-1,
		129,
		148,
		164,
		-1,
		187,
		166,
		189,
		167,
		181,
		177,
		198,
		199,
		169,
		174,
		176,
		164,
		167,
		156,
		159,
		151,
		173,
		170,
		154,
		156,
		165,
		-1,
		225,
		212,
		170,
		166,
		155,
		175,
		126,
		135,
		151,
		-1,
		-1,
		226,
		-1,
		165,
		182,
		191,
		189,
		188,
		163,
		170,
		188,
		161,
		156,
		161,
		150,
		150,
		145,
		164,
		150,
		148,
		163,
		179,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		141,
		128,
		122,
		-1,
		168,
		-1,
		204,
		192,
		179,
		161,
		201,
		-1,
		162,
		158,
		165,
		-1,
		181,
		-1,
		153,
		156,
		147,
		142,
		139,
		150,
		148,
		157,
		158,
		-1,
		175,
		160,
		153,
		143,
		157,
		125,
		-1,
		159,
		-1,
		-1,
		191,
		185,
		185,
		154,
		151,
		178,
		158,
		150,
		165,
		164,
		151,
		150,
		138,
		138,
		141,
		135,
		148,
		158,
		164,
		156,
		-1,
		-1,
		-1,
		180,
		155,
		149,
		121,
		125,
		-1,
		-1,
		252,
		208,
		194,
		-1,
		146,
		178,
		166,
		156,
		146,
		151,
		152,
		142,
		140,
		136,
		145,
		144,
		137,
		136,
		157,
		150,
		172,
		-1,
		-1,
		154,
		147,
		135,
		103,
		98,
		-1,
		-1,
		-1,
		198,
		184,
		172,
		144,
		167,
		-1,
		-1,
		150,
		143,
		137,
		135,
		128,
		148,
		155,
		143,
		130,
		145,
		155,
		163,
		162,
		-1,
		157,
		144,
		-1,
		-1,
		97,
		87,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		138,
		133,
		137,
		149,
		-1,
		122,
		126,
		126,
		146,
		153,
		145,
		130,
		124,
		135,
		150,
		167,
		-1,
		-1,
		111,
		-1,
		73,
		-1,
		-1,
		-1,
		-1,
		134,
		149,
		126,
		119,
		123,
		-1,
		120,
		119,
		123,
		129,
		141,
		145,
		136,
		118,
		132,
		135,
		148,
		162,
		166,
		134,
		-1,
		66,
		-1,
		-1,
		-1,
		123,
		127,
		159,
		136,
		115,
		108,
		105,
		111,
		115,
		127,
		136,
		147,
		112,
		116,
		131,
		136,
		140,
		157,
		161,
		-1,
		-1,
		64,
		71,
		106,
		118,
		100,
		186,
		-1,
		-1,
		104,
		97,
		107,
		107,
		120,
		123,
		108,
		110,
		128,
		141,
		135,
		145,
		160,
		155,
		-1,
		-1,
		-1,
		41,
		-1,
		89,
		-1,
		-1,
		90,
		177,
		124,
		106,
		102,
		88,
		102,
		96,
		98,
		103,
		122,
		117,
		126,
		131,
		135,
		158,
		147,
		186,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		7,
		65,
		59,
		69,
		74,
		65,
		139,
		136,
		-1,
		84,
		125,
		93,
		107,
		103,
		110,
		115,
		121,
		125,
		132,
		148,
		147,
		142,
		178,
		169,
		175,
		-1,
		-1,
		186,
		175,
		164,
		170,
		-1,
		0,
		62,
		55,
		45,
		51,
		-1,
		-1,
		98,
		95,
		98,
		85,
		91,
		96,
		99,
		137,
		113,
		121,
		125,
		129,
		135,
		140,
		145,
		151,
		166,
		181,
		-1,
		140,
		177,
		170,
		138,
		146,
		177,
		-1,
		10,
		24,
		46,
		37,
		45,
		-1,
		-1,
		71,
		67,
		72,
		81,
		84,
		120,
		119,
		132,
		135,
		140,
		128,
		127,
		145,
		149,
		158,
		165,
		155,
		168,
		172,
		-1,
		133,
		153,
		132,
		135,
		159,
		173,
		-1,
		23,
		-1,
		-1,
		68,
		58,
		66,
		62,
		66,
		119,
		95,
		90,
		103,
		105,
		129,
		120,
		145,
		136,
		136,
		139,
		154,
		159,
		151,
		165,
		165,
		166,
		-1,
		122,
		133,
		126,
		-1,
		-1,
		-1,
		-1,
		30,
		-1,
		-1,
		84,
		-1,
		92,
		-1,
		85,
		89,
		103,
		106,
		128,
		115,
		122,
		139,
		145,
		134,
		144,
		140,
		141,
		150,
		161,
		173,
		172,
		173,
		147,
		103,
		106,
		117,
		128,
		143,
		147,
		-1,
		41,
		80,
		122,
		-1,
		93,
		-1,
		-1,
		-1,
		99,
		116,
		108,
		124,
		127,
		127,
		123,
		127,
		139,
		146,
		156,
		158,
		150,
		154,
		167,
		178,
		181,
		143,
		134,
		147,
		92,
		92,
		113,
		122,
		143,
		56,
		47,
		74,
		118,
		118,
		113,
		100,
		-1,
		-1,
		122,
		126,
		-1,
		-1,
		134,
		144,
		127,
		129,
		133,
		147,
		159,
		167,
		157,
		155,
		149,
		181,
		-1,
		136,
		135,
		124,
		121,
		97,
		88,
		83,
		110,
		-1,
		-1,
		59,
		75,
		88,
		92,
		108,
		133,
		-1,
		103,
		-1,
		-1,
		143,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		141,
		152,
		174,
		163,
		164,
		154,
		164,
		177,
		120,
		117,
		105,
		103,
		126,
		91,
		79,
		-1,
		74,
		62,
		68,
		75,
		92,
		122,
		-1,
		-1,
		119,
		110,
		-1,
		-1,
		162,
		169,
		171,
		-1,
		161,
		134,
		139,
		164,
		171,
		172,
		166,
		160,
		167,
		166,
		174,
		182,
		129,
		143,
		132,
		128,
		127,
		135,
		84,
		77,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		129,
		-1,
		-1,
		169,
		172,
		160,
		148,
		138,
		148,
		156,
		156,
		159,
		163,
		158,
		169,
		161,
		165,
		182,
		-1,
		163,
		-1,
		115,
		83,
		103,
		118,
		126,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		164,
		175,
		164,
		167,
		181,
		176,
		-1,
		-1,
		101,
		104,
		-1,
		-1,
		128,
		147,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		168,
		174,
		177,
		166,
		170,
		182,
		-1,
		-1,
		108,
		111,
		116,
		-1,
		137,
		-1,
		186,
		-1,
		131,
		147,
		149,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		186,
		184,
		175,
		172,
		179,
		177,
		173,
		184,
		-1,
		-1,
		-1,
		167,
		144,
		193,
		184,
		167,
		147,
		139,
		164,
		-1,
		175,
		-1,
		150,
		151,
		178,
		180,
		197,
		191,
		175,
		190,
		180,
		171,
		180,
		173,
		-1,
		148,
		207,
		185,
		153,
		153,
		152,
		196,
		-1,
		172,
		154,
		-1,
		182,
		172,
		214,
		195,
		188,
		175,
		182,
		184,
		177,
		-1,
		-1,
		-1,
		163,
		162,
		161,
		172,
		173,
		158,
		153,
		-1,
		184,
		166,
		145,
		162,
		162,
		153,
		161,
		204,
		200,
		193,
		195,
		185,
		-1,
		235,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		184,
		193,
		166,
		154,
		167,
		163,
		149,
		155,
		157,
		165,
		163,
		160,
		172,
		168,
		188,
		184,
		216,
		-1,
		242,
		-1,
		193,
		-1,
		-1,
		200,
		186,
		188,
		177,
		166,
		164,
		162,
		153,
		175,
		191,
		175,
		173,
		178,
		183,
		-1,
		252,
		253,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		212,
		173,
		-1,
		182,
		162,
		-1,
		184,
		180,
		-1,
		-1,
		264,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		207,
		191,
		-1,
		173,
		173,
		-1,
		-1,
		-1,
		260,
		244,
		-1,
		213,
		216,
		-1,
		207,
		213,
		228,
		175,
		179,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		228,
		233,
		221,
		238,
		224,
		211,
		189,
		178,
		199,
		-1,
		-1,
		-1,
		241,
		233,
		233,
		-1,
		-1,
		236,
		219,
		200,
		198,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		226,
		-1,
		-1,
		232,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		252,
		-1,
		-1,
		-1,
		222,
		218,
		219,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		298,
		270,
		-1,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		242,
		226,
		-1,
		212,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		247,
		-1,
		247,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		260,
		252,
		260,
		-1,
		232,
		234,
		-1,
		282,
		-1,
		-1,
		275,
		266,
		-1,
		-1,
		237,
		244,
		266,
		269,
		305,
		-1,
		256
	],
	[
		-1,
		233,
		222,
		233,
		241,
		214,
		221,
		-1,
		242,
		244,
		210,
		204,
		243,
		214,
		220,
		231,
		-1,
		-1,
		-1,
		233,
		232,
		202,
		200,
		209,
		214,
		221,
		-1,
		244,
		-1,
		254,
		233,
		244,
		249,
		195,
		192,
		212,
		231,
		237,
		229,
		269,
		225,
		196,
		190,
		208,
		213,
		231,
		223,
		-1,
		196,
		186,
		208,
		212,
		224,
		207,
		-1,
		-1,
		190,
		191,
		197,
		209,
		214,
		219,
		-1,
		242,
		226,
		-1,
		-1,
		180,
		193,
		189,
		192,
		200,
		216,
		234,
		226,
		221,
		-1,
		-1,
		181,
		185,
		198,
		199,
		197,
		221,
		234,
		216,
		230,
		229,
		-1,
		169,
		187,
		196,
		205,
		211,
		197,
		195,
		213,
		215,
		221,
		224,
		-1,
		161,
		163,
		192,
		198,
		210,
		213,
		200,
		200,
		210,
		203,
		222,
		213,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		166,
		192,
		191,
		187,
		205,
		210,
		203,
		200,
		198,
		195,
		211,
		212,
		222,
		-1,
		-1,
		214,
		183,
		218,
		175,
		160,
		-1,
		154,
		173,
		179,
		183,
		188,
		193,
		207,
		203,
		-1,
		189,
		188,
		219,
		205,
		216,
		174,
		-1,
		-1,
		172,
		164,
		149,
		152,
		149,
		149,
		179,
		178,
		183,
		185,
		184,
		190,
		193,
		193,
		199,
		183,
		193,
		197,
		205,
		223,
		-1,
		-1,
		265,
		-1,
		-1,
		171,
		154,
		-1,
		137,
		144,
		144,
		161,
		151,
		172,
		187,
		191,
		199,
		198,
		186,
		188,
		185,
		198,
		186,
		180,
		205,
		209,
		200,
		221,
		216,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		130,
		133,
		139,
		163,
		173,
		-1,
		194,
		192,
		216,
		207,
		204,
		191,
		179,
		192,
		177,
		184,
		183,
		187,
		189,
		222,
		197,
		219,
		216,
		235,
		240,
		234,
		243,
		-1,
		179,
		175,
		171,
		178,
		127,
		-1,
		-1,
		167,
		-1,
		181,
		194,
		198,
		196,
		199,
		208,
		199,
		186,
		175,
		186,
		175,
		172,
		180,
		186,
		200,
		192,
		191,
		209,
		219,
		227,
		231,
		237,
		-1,
		229,
		-1,
		171,
		155,
		157,
		129,
		150,
		-1,
		187,
		182,
		202,
		200,
		191,
		-1,
		194,
		197,
		204,
		182,
		167,
		184,
		176,
		174,
		179,
		181,
		195,
		186,
		204,
		211,
		209,
		213,
		233,
		245,
		189,
		179,
		-1,
		161,
		166,
		125,
		133,
		152,
		225,
		197,
		-1,
		192,
		-1,
		184,
		209,
		-1,
		188,
		184,
		166,
		167,
		162,
		177,
		183,
		177,
		174,
		192,
		195,
		202,
		206,
		222,
		-1,
		-1,
		174,
		178,
		167,
		118,
		137,
		161,
		198,
		190,
		179,
		178,
		-1,
		169,
		199,
		196,
		182,
		169,
		159,
		160,
		168,
		181,
		160,
		176,
		173,
		193,
		219,
		197,
		208,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		144,
		115,
		139,
		181,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		189,
		172,
		168,
		157,
		155,
		168,
		163,
		179,
		171,
		169,
		188,
		200,
		191,
		199,
		-1,
		-1,
		-1,
		174,
		163,
		164,
		110,
		133,
		170,
		187,
		173,
		178,
		153,
		146,
		140,
		192,
		189,
		156,
		164,
		156,
		145,
		159,
		167,
		171,
		167,
		176,
		182,
		206,
		187,
		193,
		-1,
		-1,
		181,
		171,
		155,
		157,
		154,
		124,
		131,
		163,
		178,
		175,
		-1,
		145,
		-1,
		134,
		142,
		141,
		147,
		159,
		145,
		150,
		161,
		173,
		174,
		169,
		176,
		211,
		211,
		177,
		197,
		200,
		-1,
		-1,
		-1,
		174,
		169,
		144,
		121,
		105,
		141,
		-1,
		145,
		146,
		-1,
		139,
		133,
		139,
		138,
		145,
		142,
		142,
		156,
		164,
		160,
		176,
		179,
		161,
		185,
		-1,
		185,
		179,
		187,
		177,
		165,
		-1,
		-1,
		-1,
		167,
		146,
		139,
		159,
		100,
		152,
		-1,
		-1,
		130,
		123,
		-1,
		126,
		126,
		133,
		142,
		147,
		152,
		160,
		155,
		168,
		172,
		166,
		160,
		173,
		177,
		178,
		167,
		163,
		160,
		174,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		120,
		-1,
		138,
		130,
		121,
		115,
		121,
		139,
		137,
		157,
		149,
		163,
		163,
		169,
		175,
		161,
		154,
		165,
		150,
		168,
		174,
		165,
		160,
		159,
		170,
		-1,
		187,
		173,
		144,
		-1,
		-1,
		133,
		-1,
		97,
		116,
		132,
		-1,
		155,
		134,
		157,
		135,
		149,
		145,
		183,
		184,
		162,
		167,
		175,
		163,
		166,
		155,
		158,
		150,
		172,
		169,
		153,
		155,
		164,
		-1,
		193,
		180,
		138,
		134,
		123,
		143,
		94,
		103,
		119,
		-1,
		-1,
		193,
		-1,
		133,
		149,
		159,
		157,
		173,
		162,
		169,
		186,
		160,
		155,
		160,
		149,
		149,
		144,
		163,
		149,
		147,
		162,
		178,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		109,
		96,
		90,
		-1,
		136,
		-1,
		171,
		159,
		146,
		128,
		168,
		-1,
		161,
		157,
		164,
		-1,
		180,
		-1,
		152,
		155,
		146,
		141,
		138,
		149,
		147,
		156,
		157,
		-1,
		143,
		128,
		121,
		111,
		125,
		93,
		-1,
		127,
		-1,
		-1,
		158,
		152,
		152,
		121,
		118,
		177,
		157,
		149,
		164,
		163,
		150,
		149,
		137,
		137,
		140,
		134,
		147,
		157,
		163,
		155,
		-1,
		-1,
		-1,
		148,
		123,
		117,
		89,
		93,
		-1,
		-1,
		219,
		175,
		161,
		-1,
		113,
		177,
		165,
		155,
		145,
		150,
		151,
		141,
		139,
		135,
		144,
		143,
		136,
		135,
		156,
		149,
		171,
		-1,
		-1,
		122,
		115,
		103,
		71,
		66,
		-1,
		-1,
		-1,
		165,
		151,
		139,
		111,
		166,
		-1,
		-1,
		149,
		142,
		136,
		134,
		127,
		147,
		154,
		142,
		129,
		144,
		154,
		162,
		161,
		-1,
		125,
		112,
		-1,
		-1,
		65,
		55,
		-1,
		-1,
		-1,
		-1,
		129,
		110,
		122,
		132,
		136,
		148,
		-1,
		121,
		125,
		125,
		145,
		152,
		144,
		129,
		123,
		134,
		149,
		166,
		-1,
		-1,
		79,
		-1,
		41,
		-1,
		-1,
		-1,
		-1,
		101,
		116,
		125,
		118,
		122,
		-1,
		119,
		118,
		122,
		128,
		140,
		144,
		135,
		117,
		131,
		134,
		147,
		161,
		165,
		102,
		-1,
		32,
		-1,
		-1,
		-1,
		78,
		108,
		158,
		135,
		114,
		107,
		104,
		110,
		114,
		126,
		135,
		146,
		111,
		115,
		130,
		135,
		139,
		156,
		160,
		-1,
		-1,
		30,
		26,
		61,
		73,
		99,
		185,
		-1,
		-1,
		103,
		96,
		106,
		106,
		119,
		122,
		107,
		109,
		127,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		42,
		-1,
		44,
		-1,
		-1,
		89,
		176,
		123,
		105,
		101,
		87,
		101,
		95,
		97,
		102,
		121,
		116,
		125,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		71,
		13,
		5,
		68,
		73,
		64,
		138,
		135,
		-1,
		83,
		124,
		92,
		106,
		102,
		109,
		114,
		120,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		68,
		0,
		54,
		44,
		50,
		-1,
		-1,
		97,
		94,
		97,
		84,
		90,
		95,
		98,
		136,
		112,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		58,
		50,
		17,
		36,
		44,
		-1,
		-1,
		70,
		66,
		71,
		80,
		83,
		119,
		118,
		131,
		134,
		139,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		55,
		-1,
		-1,
		39,
		57,
		65,
		61,
		65,
		118,
		94,
		89,
		102,
		104,
		128,
		119,
		144,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		56,
		-1,
		-1,
		55,
		-1,
		91,
		-1,
		84,
		88,
		102,
		105,
		127,
		114,
		121,
		138,
		144,
		133,
		143,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		67,
		106,
		93,
		-1,
		64,
		-1,
		-1,
		-1,
		98,
		115,
		107,
		123,
		126,
		126,
		122,
		126,
		138,
		145,
		155,
		157,
		149,
		153,
		166,
		177,
		180,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		82,
		73,
		100,
		100,
		89,
		84,
		71,
		-1,
		-1,
		121,
		125,
		-1,
		-1,
		133,
		143,
		126,
		128,
		132,
		146,
		158,
		166,
		156,
		154,
		148,
		180,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		85,
		101,
		114,
		118,
		131,
		156,
		-1,
		74,
		-1,
		-1,
		142,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		140,
		151,
		173,
		162,
		163,
		153,
		163,
		176,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		100,
		88,
		94,
		101,
		118,
		145,
		-1,
		-1,
		90,
		81,
		-1,
		-1,
		161,
		168,
		170,
		-1,
		160,
		133,
		138,
		163,
		170,
		171,
		165,
		159,
		166,
		165,
		173,
		181,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		125,
		100,
		-1,
		-1,
		168,
		171,
		159,
		147,
		137,
		147,
		155,
		155,
		158,
		162,
		157,
		168,
		160,
		164,
		181,
		-1,
		189,
		-1,
		141,
		109,
		129,
		144,
		152,
		-1,
		-1,
		-1,
		142,
		128,
		121,
		109,
		107,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		163,
		174,
		163,
		166,
		180,
		175,
		-1,
		-1,
		127,
		130,
		-1,
		-1,
		154,
		173,
		-1,
		133,
		122,
		107,
		99,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		167,
		173,
		176,
		165,
		169,
		181,
		-1,
		-1,
		134,
		137,
		142,
		-1,
		163,
		-1,
		157,
		-1,
		102,
		118,
		120,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		185,
		183,
		174,
		171,
		178,
		176,
		172,
		183,
		-1,
		-1,
		-1,
		183,
		157,
		164,
		155,
		138,
		118,
		110,
		135,
		-1,
		174,
		-1,
		149,
		150,
		177,
		179,
		196,
		190,
		174,
		189,
		179,
		170,
		179,
		189,
		-1,
		159,
		192,
		156,
		124,
		124,
		123,
		188,
		-1,
		171,
		153,
		-1,
		181,
		171,
		213,
		194,
		187,
		174,
		181,
		183,
		176,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		144,
		129,
		124,
		-1,
		176,
		158,
		144,
		161,
		161,
		152,
		160,
		203,
		199,
		192,
		194,
		184,
		-1,
		261,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		164,
		137,
		125,
		139,
		146,
		141,
		143,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		183,
		215,
		-1,
		268,
		-1,
		191,
		-1,
		-1,
		171,
		157,
		159,
		148,
		137,
		135,
		138,
		136,
		158,
		188,
		174,
		172,
		177,
		182,
		-1,
		259,
		258,
		-1,
		190,
		182,
		168,
		-1,
		161,
		-1,
		183,
		144,
		-1,
		165,
		145,
		-1,
		183,
		179,
		-1,
		-1,
		246,
		206,
		-1,
		-1,
		-1,
		191,
		171,
		178,
		162,
		-1,
		156,
		156,
		-1,
		-1,
		-1,
		231,
		215,
		-1,
		184,
		187,
		-1,
		178,
		184,
		211,
		158,
		162,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		199,
		204,
		192,
		209,
		195,
		194,
		172,
		161,
		182,
		-1,
		-1,
		-1,
		212,
		204,
		204,
		-1,
		-1,
		219,
		202,
		183,
		181,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		209,
		-1,
		-1,
		215,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		223,
		-1,
		-1,
		-1,
		205,
		201,
		202,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		269,
		244,
		-1,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		247,
		245,
		-1,
		-1,
		-1,
		225,
		209,
		-1,
		195,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		230,
		-1,
		230,
		205,
		212,
		-1,
		-1,
		-1,
		-1,
		243,
		235,
		243,
		-1,
		215,
		217,
		-1,
		265,
		-1,
		-1,
		258,
		249,
		-1,
		-1,
		220,
		227,
		249,
		252,
		288,
		-1,
		239
	],
	[
		-1,
		276,
		265,
		276,
		284,
		257,
		264,
		-1,
		285,
		287,
		253,
		247,
		286,
		257,
		263,
		274,
		-1,
		-1,
		-1,
		276,
		275,
		245,
		243,
		252,
		257,
		264,
		-1,
		266,
		-1,
		297,
		276,
		287,
		292,
		238,
		235,
		255,
		274,
		259,
		251,
		312,
		268,
		239,
		233,
		251,
		244,
		253,
		245,
		-1,
		239,
		229,
		251,
		233,
		244,
		236,
		-1,
		-1,
		233,
		234,
		240,
		229,
		235,
		231,
		-1,
		241,
		225,
		-1,
		-1,
		223,
		227,
		211,
		214,
		222,
		220,
		233,
		225,
		220,
		-1,
		-1,
		217,
		213,
		220,
		207,
		203,
		220,
		233,
		215,
		229,
		228,
		-1,
		212,
		230,
		239,
		214,
		212,
		196,
		194,
		212,
		214,
		220,
		220,
		-1,
		204,
		206,
		228,
		236,
		236,
		212,
		199,
		199,
		209,
		202,
		221,
		209,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		209,
		232,
		224,
		214,
		229,
		222,
		202,
		199,
		197,
		194,
		210,
		208,
		218,
		-1,
		-1,
		257,
		226,
		261,
		218,
		203,
		-1,
		197,
		208,
		214,
		218,
		212,
		205,
		219,
		215,
		-1,
		188,
		187,
		215,
		201,
		212,
		217,
		-1,
		-1,
		215,
		207,
		192,
		195,
		192,
		192,
		222,
		221,
		214,
		200,
		196,
		202,
		205,
		205,
		211,
		182,
		192,
		196,
		194,
		219,
		-1,
		-1,
		254,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		187,
		204,
		194,
		215,
		230,
		224,
		216,
		210,
		198,
		200,
		197,
		210,
		198,
		179,
		204,
		208,
		189,
		210,
		205,
		-1,
		253,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		216,
		-1,
		237,
		233,
		234,
		219,
		216,
		203,
		191,
		204,
		189,
		196,
		195,
		183,
		181,
		211,
		186,
		208,
		205,
		224,
		229,
		223,
		232,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		224,
		237,
		241,
		230,
		233,
		220,
		211,
		198,
		187,
		198,
		187,
		184,
		192,
		175,
		190,
		181,
		180,
		198,
		208,
		216,
		220,
		226,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		225,
		245,
		243,
		234,
		-1,
		229,
		226,
		216,
		194,
		179,
		196,
		188,
		186,
		188,
		170,
		184,
		175,
		193,
		200,
		198,
		202,
		222,
		234,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		268,
		240,
		-1,
		235,
		-1,
		227,
		244,
		-1,
		200,
		196,
		178,
		179,
		174,
		189,
		181,
		166,
		163,
		181,
		184,
		191,
		195,
		211,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		233,
		222,
		221,
		-1,
		212,
		214,
		211,
		199,
		186,
		171,
		172,
		180,
		192,
		171,
		165,
		162,
		182,
		208,
		186,
		197,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		251,
		244,
		232,
		197,
		197,
		191,
		-1,
		210,
		189,
		180,
		169,
		167,
		180,
		172,
		180,
		160,
		158,
		177,
		189,
		180,
		188,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		230,
		216,
		221,
		196,
		189,
		183,
		223,
		206,
		187,
		176,
		168,
		157,
		168,
		176,
		174,
		156,
		165,
		171,
		195,
		176,
		182,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		221,
		218,
		-1,
		188,
		-1,
		177,
		185,
		181,
		176,
		173,
		160,
		159,
		173,
		173,
		163,
		158,
		165,
		200,
		200,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		188,
		189,
		-1,
		182,
		176,
		182,
		181,
		179,
		164,
		168,
		170,
		173,
		161,
		167,
		168,
		150,
		174,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		173,
		166,
		-1,
		169,
		169,
		176,
		169,
		163,
		169,
		165,
		155,
		168,
		161,
		155,
		149,
		162,
		166,
		167,
		156,
		152,
		149,
		163,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		181,
		173,
		164,
		158,
		164,
		182,
		180,
		191,
		175,
		178,
		173,
		169,
		160,
		150,
		143,
		154,
		139,
		157,
		163,
		154,
		149,
		148,
		159,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		159,
		175,
		-1,
		198,
		177,
		200,
		178,
		186,
		188,
		182,
		183,
		153,
		158,
		160,
		148,
		151,
		144,
		147,
		139,
		161,
		158,
		142,
		144,
		153,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		146,
		162,
		-1,
		-1,
		210,
		-1,
		164,
		166,
		202,
		200,
		172,
		147,
		154,
		172,
		145,
		140,
		149,
		138,
		136,
		133,
		152,
		138,
		136,
		151,
		167,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		179,
		-1,
		188,
		176,
		163,
		145,
		185,
		-1,
		146,
		142,
		149,
		-1,
		165,
		-1,
		137,
		140,
		131,
		128,
		127,
		138,
		136,
		145,
		146,
		-1,
		186,
		171,
		164,
		154,
		168,
		136,
		-1,
		170,
		-1,
		-1,
		175,
		169,
		169,
		138,
		135,
		162,
		142,
		134,
		149,
		148,
		135,
		134,
		122,
		122,
		125,
		123,
		136,
		146,
		152,
		144,
		-1,
		-1,
		-1,
		191,
		166,
		160,
		132,
		136,
		-1,
		-1,
		236,
		192,
		178,
		-1,
		130,
		162,
		150,
		140,
		130,
		135,
		136,
		126,
		124,
		120,
		129,
		132,
		125,
		124,
		145,
		138,
		160,
		-1,
		-1,
		165,
		158,
		146,
		114,
		109,
		-1,
		-1,
		-1,
		182,
		168,
		156,
		128,
		151,
		-1,
		-1,
		134,
		127,
		121,
		119,
		112,
		132,
		139,
		131,
		118,
		133,
		143,
		151,
		150,
		-1,
		168,
		155,
		-1,
		-1,
		108,
		98,
		-1,
		-1,
		-1,
		-1,
		146,
		127,
		122,
		117,
		121,
		133,
		-1,
		106,
		110,
		110,
		130,
		137,
		133,
		118,
		112,
		123,
		138,
		155,
		-1,
		-1,
		122,
		-1,
		84,
		-1,
		-1,
		-1,
		-1,
		118,
		133,
		110,
		103,
		107,
		-1,
		104,
		103,
		107,
		113,
		126,
		131,
		124,
		106,
		120,
		123,
		136,
		150,
		154,
		145,
		-1,
		75,
		-1,
		-1,
		-1,
		110,
		111,
		143,
		120,
		99,
		92,
		89,
		95,
		99,
		115,
		121,
		132,
		100,
		104,
		119,
		124,
		128,
		145,
		149,
		-1,
		-1,
		73,
		69,
		104,
		116,
		84,
		170,
		-1,
		-1,
		88,
		81,
		91,
		95,
		105,
		108,
		96,
		98,
		116,
		129,
		123,
		133,
		148,
		143,
		-1,
		-1,
		-1,
		85,
		-1,
		87,
		-1,
		-1,
		74,
		161,
		108,
		90,
		86,
		72,
		90,
		84,
		86,
		91,
		110,
		105,
		114,
		119,
		123,
		146,
		135,
		174,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		64,
		56,
		50,
		14,
		58,
		49,
		123,
		120,
		-1,
		68,
		111,
		81,
		95,
		91,
		98,
		103,
		109,
		113,
		120,
		136,
		135,
		130,
		166,
		157,
		163,
		-1,
		-1,
		201,
		190,
		179,
		185,
		-1,
		57,
		53,
		0,
		10,
		35,
		-1,
		-1,
		85,
		82,
		86,
		73,
		79,
		84,
		87,
		125,
		101,
		109,
		113,
		117,
		123,
		128,
		133,
		139,
		154,
		169,
		-1,
		155,
		192,
		185,
		153,
		161,
		192,
		-1,
		47,
		39,
		49,
		25,
		29,
		-1,
		-1,
		58,
		55,
		60,
		69,
		72,
		108,
		107,
		120,
		123,
		128,
		116,
		115,
		133,
		137,
		146,
		153,
		143,
		156,
		160,
		-1,
		148,
		168,
		147,
		150,
		174,
		188,
		-1,
		44,
		-1,
		-1,
		56,
		42,
		50,
		50,
		54,
		107,
		83,
		78,
		91,
		93,
		117,
		108,
		133,
		124,
		124,
		127,
		142,
		147,
		139,
		153,
		153,
		154,
		-1,
		137,
		148,
		141,
		-1,
		-1,
		-1,
		-1,
		45,
		-1,
		-1,
		72,
		-1,
		76,
		-1,
		69,
		73,
		91,
		94,
		116,
		103,
		110,
		127,
		133,
		122,
		132,
		128,
		129,
		138,
		149,
		161,
		160,
		161,
		162,
		118,
		121,
		132,
		143,
		158,
		162,
		-1,
		56,
		95,
		110,
		-1,
		81,
		-1,
		-1,
		-1,
		83,
		104,
		96,
		112,
		115,
		115,
		111,
		115,
		127,
		134,
		144,
		146,
		138,
		142,
		155,
		166,
		169,
		158,
		149,
		162,
		107,
		107,
		128,
		137,
		158,
		71,
		62,
		89,
		117,
		106,
		101,
		88,
		-1,
		-1,
		106,
		114,
		-1,
		-1,
		122,
		132,
		115,
		117,
		121,
		135,
		147,
		155,
		145,
		143,
		137,
		169,
		-1,
		151,
		150,
		139,
		136,
		112,
		103,
		98,
		125,
		-1,
		-1,
		74,
		90,
		103,
		107,
		123,
		148,
		-1,
		91,
		-1,
		-1,
		127,
		-1,
		-1,
		174,
		137,
		126,
		117,
		123,
		129,
		140,
		162,
		151,
		152,
		142,
		152,
		165,
		135,
		132,
		120,
		118,
		141,
		106,
		94,
		-1,
		89,
		77,
		83,
		90,
		107,
		137,
		-1,
		-1,
		107,
		98,
		-1,
		-1,
		146,
		153,
		159,
		-1,
		149,
		122,
		127,
		152,
		159,
		160,
		154,
		148,
		155,
		154,
		162,
		170,
		144,
		158,
		147,
		143,
		142,
		150,
		99,
		92,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		117,
		-1,
		-1,
		153,
		160,
		148,
		136,
		126,
		136,
		144,
		144,
		147,
		151,
		146,
		157,
		149,
		153,
		170,
		-1,
		178,
		-1,
		130,
		98,
		118,
		133,
		141,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		201,
		185,
		166,
		-1,
		136,
		149,
		180,
		148,
		153,
		148,
		152,
		163,
		152,
		155,
		169,
		164,
		-1,
		-1,
		116,
		119,
		-1,
		-1,
		143,
		162,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		173,
		169,
		-1,
		-1,
		137,
		162,
		151,
		159,
		154,
		156,
		162,
		165,
		154,
		158,
		170,
		-1,
		-1,
		123,
		126,
		131,
		-1,
		152,
		-1,
		174,
		-1,
		119,
		135,
		137,
		-1,
		-1,
		-1,
		175,
		138,
		159,
		169,
		174,
		172,
		163,
		160,
		167,
		165,
		161,
		172,
		-1,
		-1,
		-1,
		182,
		159,
		181,
		172,
		155,
		135,
		127,
		152,
		-1,
		163,
		-1,
		138,
		139,
		166,
		168,
		185,
		179,
		163,
		178,
		168,
		159,
		168,
		188,
		-1,
		163,
		209,
		173,
		141,
		141,
		140,
		184,
		-1,
		160,
		142,
		-1,
		170,
		160,
		202,
		183,
		176,
		163,
		170,
		172,
		165,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		161,
		146,
		141,
		-1,
		172,
		154,
		133,
		150,
		150,
		141,
		149,
		192,
		188,
		181,
		183,
		173,
		-1,
		250,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		181,
		154,
		142,
		155,
		151,
		137,
		143,
		145,
		153,
		151,
		148,
		160,
		156,
		176,
		172,
		204,
		-1,
		257,
		-1,
		208,
		-1,
		-1,
		188,
		174,
		176,
		165,
		154,
		152,
		150,
		141,
		163,
		179,
		163,
		161,
		166,
		171,
		-1,
		267,
		268,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		200,
		161,
		-1,
		170,
		150,
		-1,
		172,
		168,
		-1,
		-1,
		263,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		195,
		179,
		-1,
		161,
		161,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		201,
		204,
		-1,
		195,
		201,
		216,
		163,
		167,
		-1,
		-1,
		-1,
		257,
		238,
		232,
		216,
		221,
		209,
		226,
		212,
		199,
		177,
		166,
		187,
		-1,
		-1,
		-1,
		229,
		221,
		221,
		-1,
		-1,
		224,
		207,
		188,
		186,
		-1,
		-1,
		-1,
		251,
		232,
		-1,
		-1,
		214,
		-1,
		-1,
		220,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		240,
		-1,
		-1,
		-1,
		210,
		206,
		207,
		-1,
		-1,
		-1,
		-1,
		261,
		262,
		286,
		258,
		-1,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		264,
		262,
		-1,
		-1,
		-1,
		230,
		214,
		-1,
		200,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		235,
		-1,
		235,
		210,
		217,
		-1,
		-1,
		-1,
		-1,
		248,
		240,
		248,
		-1,
		220,
		222,
		-1,
		270,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		225,
		232,
		254,
		257,
		293,
		-1,
		244
	],
	[
		-1,
		266,
		255,
		266,
		274,
		247,
		254,
		-1,
		275,
		277,
		243,
		237,
		276,
		247,
		253,
		264,
		-1,
		-1,
		-1,
		266,
		265,
		235,
		233,
		242,
		247,
		254,
		-1,
		256,
		-1,
		287,
		266,
		277,
		282,
		228,
		225,
		245,
		264,
		249,
		241,
		302,
		258,
		229,
		223,
		241,
		234,
		243,
		235,
		-1,
		229,
		219,
		241,
		223,
		234,
		226,
		-1,
		-1,
		223,
		224,
		230,
		219,
		225,
		221,
		-1,
		231,
		215,
		-1,
		-1,
		213,
		217,
		201,
		204,
		212,
		210,
		223,
		215,
		210,
		-1,
		-1,
		207,
		203,
		210,
		197,
		193,
		210,
		223,
		205,
		219,
		218,
		-1,
		202,
		220,
		229,
		204,
		202,
		186,
		184,
		202,
		204,
		210,
		210,
		-1,
		194,
		196,
		218,
		226,
		226,
		202,
		189,
		189,
		199,
		192,
		211,
		199,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		191,
		199,
		222,
		214,
		204,
		219,
		212,
		192,
		189,
		187,
		184,
		200,
		198,
		208,
		-1,
		-1,
		247,
		216,
		251,
		208,
		193,
		-1,
		187,
		198,
		204,
		208,
		202,
		195,
		209,
		205,
		-1,
		178,
		177,
		205,
		191,
		202,
		207,
		-1,
		-1,
		205,
		197,
		182,
		185,
		182,
		182,
		212,
		211,
		204,
		190,
		186,
		192,
		195,
		195,
		201,
		172,
		182,
		186,
		184,
		209,
		-1,
		-1,
		244,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		177,
		194,
		184,
		205,
		220,
		214,
		206,
		200,
		188,
		190,
		187,
		200,
		188,
		169,
		194,
		198,
		179,
		200,
		195,
		-1,
		243,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		206,
		-1,
		227,
		223,
		224,
		209,
		206,
		193,
		181,
		194,
		179,
		186,
		185,
		173,
		171,
		201,
		176,
		198,
		195,
		214,
		219,
		213,
		222,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		214,
		227,
		231,
		220,
		223,
		210,
		201,
		188,
		177,
		188,
		177,
		174,
		182,
		165,
		180,
		171,
		170,
		188,
		198,
		206,
		210,
		216,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		215,
		235,
		233,
		224,
		-1,
		219,
		216,
		206,
		184,
		169,
		186,
		178,
		176,
		178,
		160,
		174,
		165,
		183,
		190,
		188,
		192,
		212,
		224,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		258,
		230,
		-1,
		225,
		-1,
		217,
		234,
		-1,
		190,
		186,
		168,
		169,
		164,
		179,
		171,
		156,
		153,
		171,
		174,
		181,
		185,
		201,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		223,
		212,
		211,
		-1,
		202,
		204,
		201,
		189,
		176,
		161,
		162,
		170,
		182,
		161,
		155,
		152,
		172,
		198,
		176,
		187,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		241,
		234,
		222,
		187,
		187,
		181,
		-1,
		200,
		179,
		170,
		159,
		157,
		170,
		162,
		170,
		150,
		148,
		167,
		179,
		170,
		178,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		220,
		206,
		211,
		186,
		179,
		173,
		213,
		196,
		177,
		166,
		158,
		147,
		158,
		166,
		164,
		146,
		155,
		161,
		185,
		166,
		172,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		211,
		208,
		-1,
		178,
		-1,
		167,
		175,
		171,
		166,
		163,
		150,
		149,
		163,
		163,
		153,
		148,
		155,
		190,
		190,
		156,
		176,
		179,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		178,
		179,
		-1,
		172,
		166,
		172,
		171,
		169,
		154,
		158,
		160,
		163,
		151,
		157,
		158,
		140,
		164,
		-1,
		164,
		158,
		166,
		156,
		144,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		163,
		156,
		-1,
		159,
		159,
		166,
		159,
		153,
		159,
		155,
		145,
		158,
		151,
		145,
		139,
		152,
		156,
		157,
		146,
		142,
		139,
		153,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		171,
		163,
		154,
		148,
		154,
		172,
		170,
		181,
		165,
		168,
		163,
		159,
		150,
		140,
		133,
		144,
		129,
		147,
		153,
		144,
		139,
		138,
		149,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		149,
		165,
		-1,
		188,
		167,
		190,
		168,
		176,
		178,
		172,
		173,
		143,
		148,
		150,
		138,
		141,
		134,
		137,
		129,
		151,
		148,
		132,
		134,
		143,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		136,
		152,
		-1,
		-1,
		200,
		-1,
		154,
		156,
		192,
		190,
		162,
		137,
		144,
		162,
		135,
		130,
		139,
		128,
		126,
		123,
		142,
		128,
		126,
		141,
		157,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		169,
		-1,
		178,
		166,
		153,
		135,
		175,
		-1,
		136,
		132,
		139,
		-1,
		155,
		-1,
		127,
		130,
		121,
		118,
		117,
		128,
		126,
		135,
		136,
		-1,
		176,
		161,
		154,
		144,
		158,
		126,
		-1,
		160,
		-1,
		-1,
		165,
		159,
		159,
		128,
		125,
		152,
		132,
		124,
		139,
		138,
		125,
		124,
		112,
		112,
		115,
		113,
		126,
		136,
		142,
		134,
		-1,
		-1,
		-1,
		181,
		156,
		150,
		122,
		126,
		-1,
		-1,
		226,
		182,
		168,
		-1,
		120,
		152,
		140,
		130,
		120,
		125,
		126,
		116,
		114,
		110,
		119,
		122,
		115,
		114,
		135,
		128,
		150,
		-1,
		-1,
		155,
		148,
		136,
		104,
		99,
		-1,
		-1,
		-1,
		172,
		158,
		146,
		118,
		141,
		-1,
		-1,
		124,
		117,
		111,
		109,
		102,
		122,
		129,
		121,
		108,
		123,
		133,
		141,
		140,
		-1,
		158,
		145,
		-1,
		-1,
		98,
		88,
		-1,
		-1,
		-1,
		-1,
		136,
		117,
		112,
		107,
		111,
		123,
		-1,
		96,
		100,
		100,
		120,
		127,
		123,
		108,
		102,
		113,
		128,
		145,
		-1,
		-1,
		112,
		-1,
		74,
		-1,
		-1,
		-1,
		-1,
		108,
		123,
		100,
		93,
		97,
		-1,
		94,
		93,
		97,
		103,
		116,
		121,
		114,
		96,
		110,
		113,
		126,
		140,
		144,
		135,
		-1,
		65,
		-1,
		-1,
		-1,
		100,
		101,
		133,
		110,
		89,
		82,
		79,
		85,
		89,
		105,
		111,
		122,
		90,
		94,
		109,
		114,
		118,
		135,
		139,
		-1,
		-1,
		63,
		59,
		94,
		106,
		74,
		160,
		-1,
		-1,
		78,
		71,
		81,
		85,
		95,
		98,
		86,
		88,
		106,
		119,
		113,
		123,
		138,
		133,
		-1,
		-1,
		-1,
		75,
		-1,
		77,
		-1,
		-1,
		64,
		151,
		98,
		80,
		76,
		62,
		80,
		74,
		76,
		81,
		100,
		95,
		104,
		109,
		113,
		136,
		125,
		164,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		54,
		46,
		40,
		24,
		48,
		39,
		113,
		110,
		-1,
		58,
		101,
		71,
		85,
		81,
		88,
		93,
		99,
		103,
		110,
		126,
		125,
		120,
		156,
		147,
		153,
		-1,
		-1,
		191,
		180,
		169,
		175,
		-1,
		47,
		43,
		10,
		0,
		25,
		-1,
		-1,
		75,
		72,
		76,
		63,
		69,
		74,
		77,
		115,
		91,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		145,
		182,
		175,
		143,
		151,
		182,
		-1,
		37,
		29,
		39,
		15,
		19,
		-1,
		-1,
		48,
		45,
		50,
		59,
		62,
		98,
		97,
		110,
		113,
		118,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		138,
		158,
		137,
		140,
		164,
		178,
		-1,
		34,
		-1,
		-1,
		46,
		32,
		40,
		40,
		44,
		97,
		73,
		68,
		81,
		83,
		107,
		98,
		123,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		127,
		138,
		131,
		-1,
		-1,
		-1,
		-1,
		35,
		-1,
		-1,
		62,
		-1,
		66,
		-1,
		59,
		63,
		81,
		84,
		106,
		93,
		100,
		117,
		123,
		112,
		122,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		152,
		108,
		111,
		122,
		133,
		148,
		152,
		-1,
		46,
		85,
		100,
		-1,
		71,
		-1,
		-1,
		-1,
		73,
		94,
		86,
		102,
		105,
		105,
		101,
		105,
		117,
		124,
		134,
		136,
		128,
		132,
		145,
		156,
		159,
		148,
		139,
		152,
		97,
		97,
		118,
		127,
		148,
		61,
		52,
		79,
		107,
		96,
		91,
		78,
		-1,
		-1,
		96,
		104,
		-1,
		-1,
		112,
		122,
		105,
		107,
		111,
		125,
		137,
		145,
		135,
		133,
		127,
		159,
		-1,
		141,
		140,
		129,
		126,
		102,
		93,
		88,
		115,
		-1,
		-1,
		64,
		80,
		93,
		97,
		113,
		138,
		-1,
		81,
		-1,
		-1,
		117,
		-1,
		-1,
		164,
		127,
		116,
		107,
		113,
		119,
		130,
		152,
		141,
		142,
		132,
		142,
		155,
		125,
		122,
		110,
		108,
		131,
		96,
		84,
		-1,
		79,
		67,
		73,
		80,
		97,
		127,
		-1,
		-1,
		97,
		88,
		-1,
		-1,
		136,
		143,
		149,
		-1,
		139,
		112,
		117,
		142,
		149,
		150,
		144,
		138,
		145,
		144,
		152,
		160,
		134,
		148,
		137,
		133,
		132,
		140,
		89,
		82,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		132,
		107,
		-1,
		-1,
		143,
		150,
		138,
		126,
		116,
		126,
		134,
		134,
		137,
		141,
		136,
		147,
		139,
		143,
		160,
		-1,
		168,
		-1,
		120,
		88,
		108,
		123,
		131,
		-1,
		-1,
		-1,
		149,
		135,
		128,
		116,
		114,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		170,
		138,
		143,
		138,
		142,
		153,
		142,
		145,
		159,
		154,
		-1,
		-1,
		106,
		109,
		-1,
		-1,
		133,
		152,
		-1,
		140,
		129,
		114,
		106,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		127,
		152,
		141,
		149,
		144,
		146,
		152,
		155,
		144,
		148,
		160,
		-1,
		-1,
		113,
		116,
		121,
		-1,
		142,
		-1,
		164,
		-1,
		109,
		125,
		127,
		-1,
		-1,
		-1,
		165,
		128,
		149,
		159,
		164,
		162,
		153,
		150,
		157,
		155,
		151,
		162,
		-1,
		-1,
		-1,
		172,
		149,
		171,
		162,
		145,
		125,
		117,
		142,
		-1,
		153,
		-1,
		128,
		129,
		156,
		158,
		175,
		169,
		153,
		168,
		158,
		149,
		158,
		178,
		-1,
		153,
		199,
		163,
		131,
		131,
		130,
		174,
		-1,
		150,
		132,
		-1,
		160,
		150,
		192,
		173,
		166,
		153,
		160,
		162,
		155,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		151,
		136,
		131,
		-1,
		162,
		144,
		123,
		140,
		140,
		131,
		139,
		182,
		178,
		171,
		173,
		163,
		-1,
		240,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		171,
		144,
		132,
		145,
		141,
		127,
		133,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		162,
		194,
		-1,
		247,
		-1,
		198,
		-1,
		-1,
		178,
		164,
		166,
		155,
		144,
		142,
		140,
		131,
		153,
		169,
		153,
		151,
		156,
		161,
		-1,
		257,
		258,
		-1,
		197,
		189,
		175,
		-1,
		168,
		-1,
		190,
		151,
		-1,
		160,
		140,
		-1,
		162,
		158,
		-1,
		-1,
		253,
		213,
		-1,
		-1,
		-1,
		198,
		178,
		185,
		169,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		238,
		222,
		-1,
		191,
		194,
		-1,
		185,
		191,
		206,
		153,
		157,
		-1,
		-1,
		-1,
		247,
		228,
		222,
		206,
		211,
		199,
		216,
		202,
		189,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		219,
		211,
		211,
		-1,
		-1,
		214,
		197,
		178,
		176,
		-1,
		-1,
		-1,
		241,
		222,
		-1,
		-1,
		204,
		-1,
		-1,
		210,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		230,
		-1,
		-1,
		-1,
		200,
		196,
		197,
		-1,
		-1,
		-1,
		-1,
		251,
		252,
		276,
		248,
		-1,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		254,
		252,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		190,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		225,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		238,
		230,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		253,
		244,
		-1,
		-1,
		215,
		222,
		244,
		247,
		283,
		-1,
		234
	],
	[
		-1,
		263,
		252,
		263,
		271,
		244,
		251,
		-1,
		270,
		274,
		240,
		234,
		273,
		242,
		248,
		259,
		-1,
		-1,
		-1,
		263,
		262,
		230,
		228,
		237,
		242,
		249,
		-1,
		248,
		-1,
		284,
		263,
		274,
		279,
		223,
		220,
		240,
		259,
		241,
		233,
		299,
		253,
		224,
		218,
		236,
		226,
		235,
		227,
		-1,
		224,
		214,
		236,
		215,
		226,
		218,
		-1,
		-1,
		218,
		219,
		225,
		211,
		217,
		213,
		-1,
		223,
		207,
		-1,
		-1,
		208,
		209,
		193,
		196,
		204,
		202,
		215,
		207,
		202,
		-1,
		-1,
		199,
		195,
		202,
		189,
		185,
		202,
		215,
		197,
		211,
		210,
		-1,
		205,
		223,
		228,
		196,
		194,
		178,
		176,
		194,
		196,
		202,
		202,
		-1,
		199,
		201,
		210,
		218,
		218,
		194,
		181,
		181,
		191,
		184,
		203,
		191,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		196,
		197,
		214,
		206,
		196,
		211,
		204,
		184,
		181,
		179,
		176,
		192,
		190,
		200,
		-1,
		-1,
		252,
		221,
		256,
		213,
		198,
		-1,
		192,
		190,
		196,
		200,
		194,
		187,
		201,
		197,
		-1,
		170,
		169,
		197,
		183,
		194,
		212,
		-1,
		-1,
		210,
		202,
		187,
		190,
		187,
		187,
		205,
		204,
		196,
		182,
		178,
		184,
		187,
		187,
		193,
		164,
		174,
		178,
		176,
		201,
		-1,
		-1,
		236,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		182,
		199,
		189,
		210,
		215,
		206,
		198,
		192,
		180,
		182,
		179,
		192,
		180,
		161,
		186,
		190,
		171,
		192,
		187,
		-1,
		235,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		211,
		-1,
		218,
		215,
		216,
		201,
		198,
		185,
		173,
		186,
		171,
		178,
		177,
		165,
		163,
		193,
		168,
		190,
		187,
		206,
		211,
		205,
		214,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		219,
		232,
		210,
		212,
		215,
		202,
		193,
		180,
		169,
		180,
		169,
		166,
		174,
		157,
		172,
		163,
		162,
		180,
		190,
		198,
		202,
		208,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		220,
		227,
		212,
		203,
		-1,
		206,
		208,
		198,
		176,
		161,
		178,
		170,
		168,
		170,
		152,
		166,
		157,
		175,
		182,
		180,
		184,
		204,
		216,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		245,
		209,
		-1,
		204,
		-1,
		196,
		221,
		-1,
		182,
		178,
		160,
		161,
		156,
		171,
		163,
		148,
		145,
		163,
		166,
		173,
		177,
		193,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		202,
		191,
		190,
		-1,
		181,
		196,
		193,
		181,
		168,
		153,
		154,
		162,
		174,
		153,
		147,
		144,
		164,
		190,
		168,
		180,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		192,
		171,
		162,
		151,
		149,
		162,
		154,
		162,
		142,
		140,
		159,
		171,
		162,
		173,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		199,
		185,
		190,
		165,
		158,
		152,
		204,
		188,
		168,
		158,
		150,
		139,
		150,
		158,
		156,
		138,
		147,
		153,
		177,
		161,
		167,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		190,
		203,
		-1,
		157,
		-1,
		146,
		154,
		153,
		158,
		155,
		142,
		141,
		155,
		155,
		145,
		140,
		147,
		182,
		182,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		173,
		174,
		-1,
		151,
		145,
		151,
		150,
		157,
		146,
		150,
		152,
		155,
		143,
		149,
		150,
		132,
		156,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		138,
		145,
		151,
		145,
		151,
		147,
		137,
		150,
		143,
		137,
		131,
		144,
		148,
		152,
		141,
		137,
		134,
		148,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		167,
		159,
		149,
		143,
		137,
		148,
		149,
		169,
		157,
		160,
		155,
		151,
		142,
		132,
		125,
		136,
		121,
		139,
		147,
		139,
		133,
		132,
		144,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		154,
		170,
		-1,
		175,
		154,
		169,
		147,
		151,
		157,
		164,
		165,
		135,
		140,
		142,
		130,
		133,
		126,
		129,
		121,
		143,
		143,
		127,
		128,
		137,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		137,
		157,
		-1,
		-1,
		175,
		-1,
		129,
		131,
		171,
		169,
		154,
		129,
		136,
		154,
		127,
		122,
		131,
		120,
		118,
		115,
		137,
		123,
		121,
		138,
		154,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		174,
		-1,
		153,
		141,
		128,
		110,
		150,
		-1,
		128,
		124,
		131,
		-1,
		147,
		-1,
		119,
		122,
		113,
		110,
		109,
		120,
		118,
		129,
		133,
		-1,
		181,
		166,
		159,
		149,
		163,
		131,
		-1,
		165,
		-1,
		-1,
		140,
		134,
		134,
		103,
		100,
		144,
		124,
		116,
		131,
		130,
		117,
		116,
		104,
		104,
		107,
		110,
		123,
		133,
		136,
		131,
		-1,
		-1,
		-1,
		186,
		161,
		155,
		127,
		131,
		-1,
		-1,
		201,
		157,
		143,
		-1,
		95,
		144,
		132,
		122,
		112,
		117,
		118,
		108,
		106,
		102,
		111,
		115,
		112,
		111,
		132,
		125,
		147,
		-1,
		-1,
		160,
		153,
		141,
		109,
		104,
		-1,
		-1,
		-1,
		147,
		133,
		121,
		93,
		133,
		-1,
		-1,
		116,
		109,
		103,
		101,
		94,
		114,
		121,
		118,
		105,
		120,
		130,
		138,
		137,
		-1,
		163,
		150,
		-1,
		-1,
		103,
		93,
		-1,
		-1,
		-1,
		-1,
		111,
		92,
		104,
		99,
		103,
		115,
		-1,
		88,
		92,
		92,
		112,
		119,
		120,
		105,
		99,
		110,
		125,
		142,
		-1,
		-1,
		117,
		-1,
		79,
		-1,
		-1,
		-1,
		-1,
		83,
		98,
		92,
		85,
		89,
		-1,
		86,
		85,
		89,
		95,
		108,
		113,
		111,
		93,
		107,
		110,
		123,
		137,
		141,
		140,
		-1,
		70,
		-1,
		-1,
		-1,
		75,
		76,
		125,
		102,
		81,
		74,
		71,
		77,
		81,
		97,
		103,
		114,
		87,
		91,
		106,
		111,
		115,
		132,
		136,
		-1,
		-1,
		68,
		64,
		99,
		83,
		49,
		152,
		-1,
		-1,
		70,
		63,
		73,
		82,
		87,
		90,
		83,
		85,
		103,
		116,
		110,
		120,
		135,
		130,
		-1,
		-1,
		-1,
		80,
		-1,
		82,
		-1,
		-1,
		39,
		143,
		90,
		72,
		68,
		54,
		77,
		71,
		73,
		78,
		97,
		92,
		101,
		106,
		110,
		133,
		122,
		161,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		59,
		51,
		45,
		48,
		23,
		14,
		105,
		102,
		-1,
		50,
		93,
		68,
		82,
		78,
		85,
		90,
		96,
		100,
		107,
		123,
		122,
		117,
		153,
		144,
		150,
		-1,
		-1,
		196,
		185,
		174,
		180,
		-1,
		52,
		48,
		34,
		24,
		0,
		-1,
		-1,
		67,
		64,
		73,
		60,
		66,
		71,
		74,
		112,
		88,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		150,
		187,
		180,
		148,
		156,
		187,
		-1,
		42,
		34,
		44,
		20,
		11,
		-1,
		-1,
		40,
		42,
		47,
		56,
		59,
		95,
		94,
		107,
		110,
		115,
		103,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		143,
		163,
		142,
		145,
		169,
		183,
		-1,
		39,
		-1,
		-1,
		51,
		24,
		32,
		35,
		39,
		94,
		70,
		65,
		78,
		80,
		104,
		95,
		120,
		111,
		111,
		114,
		129,
		134,
		126,
		140,
		140,
		141,
		-1,
		132,
		143,
		136,
		-1,
		-1,
		-1,
		-1,
		40,
		-1,
		-1,
		67,
		-1,
		58,
		-1,
		51,
		55,
		78,
		81,
		103,
		90,
		97,
		114,
		120,
		109,
		119,
		115,
		116,
		125,
		136,
		148,
		147,
		148,
		157,
		113,
		116,
		127,
		138,
		153,
		157,
		-1,
		51,
		90,
		105,
		-1,
		76,
		-1,
		-1,
		-1,
		65,
		91,
		83,
		99,
		102,
		102,
		98,
		102,
		114,
		121,
		131,
		133,
		125,
		129,
		142,
		153,
		156,
		153,
		144,
		157,
		102,
		102,
		123,
		132,
		153,
		66,
		57,
		84,
		112,
		101,
		96,
		83,
		-1,
		-1,
		88,
		101,
		-1,
		-1,
		109,
		119,
		102,
		104,
		108,
		122,
		134,
		142,
		132,
		130,
		124,
		156,
		-1,
		146,
		145,
		134,
		131,
		107,
		98,
		93,
		120,
		-1,
		-1,
		69,
		85,
		98,
		102,
		118,
		143,
		-1,
		86,
		-1,
		-1,
		109,
		-1,
		-1,
		161,
		124,
		113,
		104,
		110,
		116,
		127,
		149,
		138,
		139,
		129,
		139,
		152,
		130,
		127,
		115,
		113,
		136,
		101,
		89,
		-1,
		84,
		72,
		78,
		85,
		102,
		132,
		-1,
		-1,
		102,
		93,
		-1,
		-1,
		128,
		135,
		146,
		-1,
		136,
		109,
		114,
		139,
		146,
		147,
		141,
		135,
		142,
		141,
		149,
		157,
		139,
		153,
		142,
		138,
		137,
		145,
		94,
		87,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		137,
		112,
		-1,
		-1,
		135,
		142,
		135,
		123,
		113,
		123,
		131,
		131,
		134,
		138,
		133,
		144,
		136,
		140,
		157,
		-1,
		173,
		-1,
		125,
		93,
		113,
		128,
		136,
		-1,
		-1,
		-1,
		154,
		140,
		133,
		121,
		119,
		-1,
		185,
		169,
		150,
		-1,
		123,
		136,
		167,
		135,
		140,
		135,
		139,
		150,
		139,
		142,
		156,
		151,
		-1,
		-1,
		111,
		114,
		-1,
		-1,
		138,
		157,
		-1,
		145,
		134,
		119,
		111,
		-1,
		-1,
		157,
		153,
		-1,
		-1,
		124,
		149,
		138,
		146,
		141,
		143,
		149,
		152,
		141,
		145,
		157,
		-1,
		-1,
		118,
		121,
		126,
		-1,
		147,
		-1,
		169,
		-1,
		114,
		130,
		132,
		-1,
		-1,
		-1,
		162,
		125,
		146,
		156,
		161,
		159,
		150,
		147,
		154,
		152,
		148,
		159,
		-1,
		-1,
		-1,
		177,
		154,
		176,
		167,
		150,
		130,
		122,
		147,
		-1,
		150,
		-1,
		125,
		126,
		153,
		155,
		172,
		166,
		150,
		165,
		155,
		146,
		155,
		183,
		-1,
		158,
		204,
		168,
		136,
		136,
		135,
		171,
		-1,
		147,
		129,
		-1,
		157,
		147,
		189,
		170,
		163,
		150,
		157,
		159,
		152,
		-1,
		-1,
		-1,
		173,
		172,
		164,
		158,
		156,
		141,
		136,
		-1,
		159,
		141,
		120,
		137,
		137,
		128,
		136,
		179,
		175,
		168,
		170,
		160,
		-1,
		245,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		167,
		175,
		148,
		136,
		142,
		138,
		124,
		130,
		132,
		140,
		138,
		135,
		147,
		143,
		163,
		159,
		191,
		-1,
		252,
		-1,
		203,
		-1,
		-1,
		183,
		169,
		170,
		159,
		148,
		146,
		137,
		128,
		150,
		166,
		150,
		148,
		153,
		158,
		-1,
		262,
		263,
		-1,
		202,
		194,
		180,
		-1,
		173,
		-1,
		194,
		155,
		-1,
		157,
		137,
		-1,
		159,
		155,
		-1,
		-1,
		258,
		218,
		-1,
		-1,
		-1,
		203,
		183,
		189,
		173,
		-1,
		148,
		148,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		196,
		199,
		-1,
		190,
		195,
		203,
		150,
		154,
		-1,
		-1,
		-1,
		252,
		233,
		227,
		211,
		216,
		204,
		216,
		202,
		186,
		164,
		153,
		174,
		-1,
		-1,
		-1,
		224,
		216,
		209,
		-1,
		-1,
		211,
		194,
		175,
		173,
		-1,
		-1,
		-1,
		246,
		227,
		-1,
		-1,
		201,
		-1,
		-1,
		207,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		235,
		-1,
		-1,
		-1,
		197,
		193,
		194,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		281,
		245,
		-1,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		217,
		201,
		-1,
		187,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		222,
		-1,
		222,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		235,
		227,
		235,
		-1,
		207,
		209,
		-1,
		257,
		-1,
		-1,
		250,
		241,
		-1,
		-1,
		212,
		219,
		241,
		244,
		280,
		-1,
		231
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		259,
		248,
		259,
		267,
		240,
		247,
		-1,
		266,
		270,
		236,
		230,
		269,
		238,
		244,
		255,
		-1,
		-1,
		-1,
		259,
		258,
		226,
		224,
		233,
		238,
		245,
		-1,
		244,
		-1,
		280,
		259,
		270,
		275,
		219,
		216,
		236,
		255,
		237,
		229,
		295,
		249,
		220,
		214,
		232,
		222,
		231,
		223,
		-1,
		220,
		210,
		232,
		211,
		222,
		214,
		-1,
		-1,
		214,
		215,
		221,
		207,
		213,
		209,
		-1,
		219,
		203,
		-1,
		-1,
		204,
		205,
		189,
		192,
		200,
		198,
		211,
		203,
		198,
		-1,
		-1,
		195,
		191,
		198,
		185,
		181,
		198,
		211,
		193,
		207,
		206,
		-1,
		201,
		219,
		224,
		192,
		190,
		174,
		172,
		190,
		192,
		198,
		198,
		-1,
		210,
		211,
		206,
		214,
		214,
		190,
		177,
		177,
		187,
		180,
		199,
		187,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		210,
		193,
		210,
		202,
		192,
		207,
		200,
		180,
		177,
		175,
		172,
		188,
		186,
		196,
		-1,
		-1,
		292,
		261,
		296,
		253,
		238,
		-1,
		206,
		186,
		192,
		196,
		190,
		183,
		197,
		193,
		-1,
		166,
		165,
		193,
		179,
		190,
		252,
		-1,
		-1,
		250,
		242,
		227,
		230,
		216,
		212,
		201,
		200,
		192,
		178,
		174,
		180,
		183,
		183,
		189,
		160,
		170,
		174,
		172,
		197,
		-1,
		-1,
		232,
		-1,
		-1,
		249,
		232,
		-1,
		215,
		222,
		222,
		228,
		214,
		235,
		211,
		202,
		194,
		188,
		176,
		178,
		175,
		188,
		176,
		157,
		182,
		186,
		167,
		188,
		183,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		208,
		211,
		217,
		241,
		251,
		-1,
		223,
		211,
		212,
		197,
		194,
		181,
		169,
		182,
		167,
		174,
		173,
		161,
		159,
		189,
		164,
		186,
		183,
		202,
		207,
		201,
		210,
		-1,
		257,
		253,
		249,
		256,
		205,
		-1,
		-1,
		245,
		-1,
		259,
		260,
		235,
		208,
		211,
		198,
		189,
		176,
		165,
		176,
		165,
		162,
		170,
		153,
		168,
		159,
		158,
		176,
		186,
		194,
		198,
		204,
		-1,
		307,
		-1,
		249,
		233,
		235,
		207,
		228,
		-1,
		265,
		260,
		252,
		237,
		235,
		-1,
		207,
		204,
		194,
		172,
		157,
		174,
		166,
		164,
		166,
		148,
		162,
		153,
		171,
		178,
		176,
		180,
		200,
		212,
		267,
		257,
		-1,
		239,
		244,
		203,
		211,
		230,
		277,
		241,
		-1,
		236,
		-1,
		209,
		222,
		-1,
		178,
		174,
		156,
		157,
		152,
		167,
		159,
		144,
		141,
		159,
		162,
		169,
		173,
		189,
		-1,
		-1,
		252,
		256,
		245,
		196,
		215,
		239,
		276,
		234,
		223,
		222,
		-1,
		213,
		192,
		189,
		177,
		164,
		149,
		150,
		158,
		170,
		149,
		143,
		140,
		160,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		222,
		193,
		217,
		259,
		252,
		245,
		233,
		198,
		198,
		192,
		-1,
		188,
		167,
		158,
		147,
		145,
		158,
		150,
		158,
		138,
		136,
		155,
		167,
		158,
		168,
		-1,
		-1,
		-1,
		252,
		241,
		242,
		188,
		211,
		248,
		231,
		217,
		222,
		197,
		190,
		184,
		201,
		184,
		165,
		154,
		146,
		135,
		146,
		154,
		152,
		134,
		143,
		149,
		173,
		156,
		162,
		-1,
		-1,
		259,
		249,
		233,
		235,
		232,
		202,
		209,
		241,
		222,
		235,
		-1,
		189,
		-1,
		178,
		174,
		159,
		154,
		151,
		138,
		137,
		151,
		151,
		141,
		136,
		143,
		178,
		178,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		252,
		247,
		222,
		199,
		183,
		219,
		-1,
		205,
		206,
		-1,
		183,
		177,
		174,
		161,
		157,
		142,
		146,
		148,
		151,
		139,
		145,
		146,
		128,
		152,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		245,
		224,
		217,
		237,
		178,
		230,
		-1,
		-1,
		190,
		183,
		-1,
		170,
		152,
		154,
		147,
		141,
		147,
		143,
		133,
		146,
		139,
		133,
		127,
		140,
		144,
		147,
		136,
		132,
		129,
		143,
		-1,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		198,
		-1,
		199,
		191,
		181,
		175,
		169,
		165,
		163,
		169,
		153,
		156,
		151,
		147,
		138,
		128,
		121,
		132,
		117,
		135,
		143,
		134,
		129,
		128,
		139,
		-1,
		265,
		251,
		222,
		-1,
		-1,
		211,
		-1,
		175,
		194,
		210,
		-1,
		207,
		186,
		201,
		179,
		175,
		166,
		160,
		161,
		131,
		136,
		138,
		126,
		129,
		122,
		125,
		117,
		139,
		138,
		122,
		124,
		133,
		-1,
		271,
		258,
		216,
		212,
		201,
		221,
		172,
		169,
		197,
		-1,
		-1,
		215,
		-1,
		169,
		171,
		180,
		178,
		150,
		125,
		132,
		150,
		123,
		118,
		127,
		116,
		114,
		111,
		132,
		118,
		116,
		131,
		147,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		187,
		174,
		168,
		-1,
		214,
		-1,
		193,
		181,
		168,
		150,
		190,
		-1,
		124,
		120,
		127,
		-1,
		143,
		-1,
		115,
		118,
		109,
		106,
		105,
		116,
		114,
		125,
		126,
		-1,
		221,
		206,
		199,
		189,
		203,
		171,
		-1,
		205,
		-1,
		-1,
		180,
		174,
		174,
		143,
		140,
		140,
		120,
		112,
		127,
		126,
		113,
		112,
		100,
		100,
		103,
		103,
		116,
		126,
		132,
		124,
		-1,
		-1,
		-1,
		226,
		201,
		195,
		167,
		171,
		-1,
		-1,
		241,
		197,
		183,
		-1,
		135,
		140,
		128,
		118,
		108,
		113,
		114,
		104,
		102,
		98,
		107,
		111,
		105,
		104,
		125,
		118,
		140,
		-1,
		-1,
		200,
		193,
		181,
		149,
		144,
		-1,
		-1,
		-1,
		187,
		188,
		154,
		133,
		129,
		-1,
		-1,
		112,
		105,
		99,
		97,
		90,
		110,
		117,
		111,
		98,
		113,
		123,
		131,
		130,
		-1,
		203,
		190,
		-1,
		-1,
		143,
		133,
		-1,
		-1,
		-1,
		-1,
		166,
		111,
		100,
		95,
		99,
		111,
		-1,
		84,
		88,
		88,
		108,
		115,
		113,
		98,
		92,
		103,
		118,
		135,
		-1,
		-1,
		157,
		-1,
		119,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		88,
		81,
		85,
		-1,
		82,
		81,
		85,
		91,
		104,
		109,
		104,
		86,
		100,
		103,
		116,
		130,
		134,
		180,
		-1,
		110,
		-1,
		-1,
		-1,
		141,
		142,
		121,
		98,
		77,
		70,
		67,
		73,
		77,
		93,
		99,
		110,
		80,
		84,
		99,
		104,
		108,
		125,
		129,
		-1,
		-1,
		108,
		104,
		139,
		149,
		115,
		148,
		-1,
		-1,
		66,
		59,
		69,
		75,
		83,
		86,
		76,
		78,
		96,
		109,
		103,
		113,
		128,
		123,
		-1,
		-1,
		-1,
		120,
		-1,
		122,
		-1,
		-1,
		105,
		139,
		86,
		68,
		64,
		50,
		70,
		64,
		66,
		71,
		90,
		85,
		94,
		99,
		103,
		126,
		115,
		154,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		99,
		91,
		85,
		88,
		89,
		80,
		101,
		98,
		-1,
		46,
		89,
		61,
		75,
		71,
		78,
		83,
		89,
		93,
		100,
		116,
		115,
		110,
		146,
		137,
		143,
		-1,
		-1,
		196,
		185,
		174,
		180,
		-1,
		92,
		88,
		74,
		64,
		66,
		-1,
		-1,
		0,
		3,
		66,
		53,
		59,
		64,
		67,
		105,
		81,
		89,
		93,
		97,
		103,
		108,
		113,
		119,
		134,
		149,
		-1,
		150,
		187,
		180,
		148,
		156,
		187,
		-1,
		82,
		74,
		84,
		60,
		57,
		-1,
		-1,
		25,
		35,
		40,
		49,
		52,
		88,
		87,
		100,
		103,
		108,
		96,
		95,
		113,
		117,
		126,
		133,
		123,
		136,
		140,
		-1,
		143,
		163,
		142,
		145,
		169,
		183,
		-1,
		79,
		-1,
		-1,
		91,
		58,
		42,
		36,
		32,
		87,
		63,
		58,
		71,
		73,
		97,
		88,
		113,
		104,
		104,
		107,
		122,
		127,
		119,
		133,
		133,
		134,
		-1,
		132,
		143,
		136,
		-1,
		-1,
		-1,
		-1,
		80,
		-1,
		-1,
		107,
		-1,
		69,
		-1,
		53,
		57,
		71,
		74,
		96,
		83,
		90,
		107,
		113,
		102,
		112,
		108,
		109,
		118,
		129,
		141,
		140,
		141,
		157,
		113,
		116,
		127,
		138,
		153,
		157,
		-1,
		91,
		130,
		145,
		-1,
		116,
		-1,
		-1,
		-1,
		67,
		84,
		76,
		92,
		95,
		95,
		91,
		95,
		107,
		114,
		124,
		126,
		118,
		122,
		135,
		146,
		149,
		153,
		144,
		157,
		102,
		102,
		123,
		132,
		153,
		106,
		97,
		124,
		152,
		141,
		136,
		123,
		-1,
		-1,
		90,
		94,
		-1,
		-1,
		102,
		112,
		95,
		97,
		101,
		115,
		127,
		135,
		125,
		123,
		117,
		149,
		-1,
		146,
		145,
		134,
		131,
		107,
		98,
		93,
		120,
		-1,
		-1,
		109,
		125,
		126,
		130,
		146,
		171,
		-1,
		126,
		-1,
		-1,
		111,
		-1,
		-1,
		154,
		117,
		106,
		97,
		103,
		109,
		120,
		142,
		131,
		132,
		122,
		132,
		145,
		130,
		127,
		115,
		113,
		136,
		101,
		89,
		-1,
		102,
		100,
		106,
		113,
		130,
		160,
		-1,
		-1,
		142,
		133,
		-1,
		-1,
		130,
		137,
		139,
		-1,
		129,
		102,
		107,
		132,
		139,
		140,
		134,
		128,
		135,
		134,
		142,
		150,
		139,
		153,
		142,
		138,
		137,
		145,
		94,
		87,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		177,
		152,
		-1,
		-1,
		137,
		140,
		128,
		116,
		106,
		116,
		124,
		124,
		127,
		131,
		126,
		137,
		129,
		133,
		150,
		-1,
		173,
		-1,
		125,
		101,
		115,
		130,
		138,
		-1,
		-1,
		-1,
		194,
		180,
		173,
		161,
		159,
		-1,
		181,
		165,
		146,
		-1,
		116,
		129,
		160,
		128,
		133,
		128,
		132,
		143,
		132,
		135,
		149,
		144,
		-1,
		-1,
		113,
		116,
		-1,
		-1,
		138,
		157,
		-1,
		185,
		174,
		159,
		151,
		-1,
		-1,
		153,
		149,
		-1,
		-1,
		117,
		142,
		131,
		139,
		134,
		136,
		142,
		145,
		134,
		138,
		150,
		-1,
		-1,
		120,
		121,
		126,
		-1,
		147,
		-1,
		201,
		-1,
		154,
		170,
		162,
		-1,
		-1,
		-1,
		155,
		118,
		139,
		149,
		154,
		152,
		143,
		140,
		147,
		145,
		141,
		152,
		-1,
		-1,
		-1,
		177,
		154,
		208,
		199,
		182,
		162,
		154,
		173,
		-1,
		143,
		-1,
		118,
		119,
		146,
		148,
		165,
		159,
		143,
		158,
		148,
		139,
		148,
		183,
		-1,
		158,
		210,
		174,
		168,
		144,
		148,
		164,
		-1,
		140,
		122,
		-1,
		150,
		140,
		182,
		163,
		156,
		143,
		150,
		152,
		145,
		-1,
		-1,
		-1,
		173,
		172,
		170,
		164,
		164,
		149,
		140,
		-1,
		152,
		134,
		113,
		130,
		130,
		121,
		129,
		172,
		168,
		161,
		163,
		153,
		-1,
		245,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		173,
		168,
		141,
		129,
		135,
		131,
		117,
		123,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		152,
		184,
		-1,
		252,
		-1,
		203,
		-1,
		-1,
		191,
		171,
		163,
		152,
		141,
		139,
		130,
		121,
		143,
		159,
		143,
		141,
		146,
		151,
		-1,
		262,
		263,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		187,
		148,
		-1,
		150,
		130,
		-1,
		152,
		148,
		-1,
		-1,
		251,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		182,
		166,
		-1,
		141,
		141,
		-1,
		-1,
		-1,
		236,
		235,
		-1,
		204,
		207,
		-1,
		197,
		188,
		196,
		143,
		147,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		219,
		217,
		212,
		209,
		195,
		179,
		157,
		146,
		167,
		-1,
		-1,
		-1,
		217,
		209,
		202,
		-1,
		-1,
		204,
		187,
		168,
		166,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		194,
		-1,
		-1,
		200,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		228,
		-1,
		-1,
		-1,
		190,
		186,
		187,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		274,
		238,
		-1,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		210,
		194,
		-1,
		180,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		215,
		-1,
		215,
		190,
		197,
		-1,
		-1,
		-1,
		-1,
		228,
		220,
		228,
		-1,
		200,
		202,
		-1,
		250,
		-1,
		-1,
		243,
		234,
		-1,
		-1,
		205,
		212,
		234,
		237,
		273,
		-1,
		224
	],
	[
		-1,
		256,
		245,
		256,
		264,
		237,
		244,
		-1,
		263,
		267,
		233,
		227,
		266,
		235,
		241,
		252,
		-1,
		-1,
		-1,
		256,
		255,
		223,
		221,
		230,
		235,
		242,
		-1,
		241,
		-1,
		277,
		256,
		267,
		272,
		216,
		213,
		233,
		252,
		234,
		226,
		292,
		246,
		217,
		211,
		229,
		219,
		228,
		220,
		-1,
		217,
		207,
		229,
		208,
		219,
		211,
		-1,
		-1,
		211,
		212,
		218,
		204,
		210,
		206,
		-1,
		216,
		200,
		-1,
		-1,
		201,
		202,
		186,
		189,
		197,
		195,
		208,
		200,
		195,
		-1,
		-1,
		192,
		188,
		195,
		182,
		178,
		195,
		208,
		190,
		204,
		203,
		-1,
		198,
		216,
		221,
		189,
		187,
		171,
		169,
		187,
		189,
		195,
		195,
		-1,
		207,
		208,
		203,
		211,
		211,
		187,
		174,
		174,
		184,
		177,
		196,
		184,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		207,
		190,
		207,
		199,
		189,
		204,
		197,
		177,
		174,
		172,
		169,
		185,
		183,
		193,
		-1,
		-1,
		289,
		258,
		293,
		250,
		235,
		-1,
		203,
		183,
		189,
		193,
		187,
		180,
		194,
		190,
		-1,
		163,
		162,
		190,
		176,
		187,
		249,
		-1,
		-1,
		247,
		239,
		224,
		227,
		213,
		209,
		198,
		197,
		189,
		175,
		171,
		177,
		180,
		180,
		186,
		157,
		167,
		171,
		169,
		194,
		-1,
		-1,
		229,
		-1,
		-1,
		246,
		229,
		-1,
		212,
		219,
		219,
		225,
		211,
		232,
		208,
		199,
		191,
		185,
		173,
		175,
		172,
		185,
		173,
		154,
		179,
		183,
		164,
		185,
		180,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		205,
		208,
		214,
		238,
		248,
		-1,
		220,
		208,
		209,
		194,
		191,
		178,
		166,
		179,
		164,
		171,
		170,
		158,
		156,
		186,
		161,
		183,
		180,
		199,
		204,
		198,
		207,
		-1,
		254,
		250,
		246,
		253,
		202,
		-1,
		-1,
		242,
		-1,
		256,
		257,
		232,
		205,
		208,
		195,
		186,
		173,
		162,
		173,
		162,
		159,
		167,
		150,
		165,
		156,
		155,
		173,
		183,
		191,
		195,
		201,
		-1,
		304,
		-1,
		246,
		230,
		232,
		204,
		225,
		-1,
		262,
		257,
		249,
		234,
		232,
		-1,
		204,
		201,
		191,
		169,
		154,
		171,
		163,
		161,
		163,
		145,
		159,
		150,
		168,
		175,
		173,
		177,
		197,
		209,
		264,
		254,
		-1,
		236,
		241,
		200,
		208,
		227,
		274,
		238,
		-1,
		233,
		-1,
		206,
		219,
		-1,
		175,
		171,
		153,
		154,
		149,
		164,
		156,
		141,
		138,
		156,
		159,
		166,
		170,
		186,
		-1,
		-1,
		249,
		253,
		242,
		193,
		212,
		236,
		273,
		231,
		220,
		219,
		-1,
		210,
		189,
		186,
		174,
		161,
		146,
		147,
		155,
		167,
		146,
		140,
		137,
		157,
		183,
		161,
		173,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		219,
		190,
		214,
		256,
		249,
		242,
		230,
		195,
		195,
		189,
		-1,
		185,
		164,
		155,
		144,
		142,
		155,
		147,
		155,
		135,
		133,
		152,
		164,
		155,
		165,
		-1,
		-1,
		-1,
		249,
		238,
		239,
		185,
		208,
		245,
		228,
		214,
		219,
		194,
		187,
		181,
		198,
		181,
		162,
		151,
		143,
		132,
		143,
		151,
		149,
		131,
		140,
		146,
		170,
		153,
		159,
		-1,
		-1,
		256,
		246,
		230,
		232,
		229,
		199,
		206,
		238,
		219,
		232,
		-1,
		186,
		-1,
		175,
		171,
		156,
		151,
		148,
		135,
		134,
		148,
		148,
		138,
		133,
		140,
		175,
		175,
		143,
		163,
		166,
		-1,
		-1,
		-1,
		249,
		244,
		219,
		196,
		180,
		216,
		-1,
		202,
		203,
		-1,
		180,
		174,
		171,
		158,
		154,
		139,
		143,
		145,
		148,
		136,
		142,
		143,
		125,
		149,
		-1,
		151,
		145,
		153,
		143,
		131,
		-1,
		-1,
		-1,
		242,
		221,
		214,
		234,
		175,
		227,
		-1,
		-1,
		187,
		180,
		-1,
		167,
		149,
		151,
		144,
		138,
		144,
		140,
		130,
		143,
		136,
		130,
		124,
		137,
		141,
		144,
		133,
		129,
		126,
		140,
		-1,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		195,
		-1,
		196,
		188,
		178,
		172,
		166,
		162,
		160,
		166,
		150,
		153,
		148,
		144,
		135,
		125,
		118,
		129,
		114,
		132,
		140,
		131,
		126,
		125,
		136,
		-1,
		262,
		248,
		219,
		-1,
		-1,
		208,
		-1,
		172,
		191,
		207,
		-1,
		204,
		183,
		198,
		176,
		172,
		163,
		157,
		158,
		128,
		133,
		135,
		123,
		126,
		119,
		122,
		114,
		136,
		135,
		119,
		121,
		130,
		-1,
		268,
		255,
		213,
		209,
		198,
		218,
		169,
		166,
		194,
		-1,
		-1,
		212,
		-1,
		166,
		168,
		177,
		175,
		147,
		122,
		129,
		147,
		120,
		115,
		124,
		113,
		111,
		108,
		129,
		115,
		113,
		128,
		144,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		184,
		171,
		165,
		-1,
		211,
		-1,
		190,
		178,
		165,
		147,
		187,
		-1,
		121,
		117,
		124,
		-1,
		140,
		-1,
		112,
		115,
		106,
		103,
		102,
		113,
		111,
		122,
		123,
		-1,
		218,
		203,
		196,
		186,
		200,
		168,
		-1,
		202,
		-1,
		-1,
		177,
		171,
		171,
		140,
		137,
		137,
		117,
		109,
		124,
		123,
		110,
		109,
		97,
		97,
		100,
		100,
		113,
		123,
		129,
		121,
		-1,
		-1,
		-1,
		223,
		198,
		192,
		164,
		168,
		-1,
		-1,
		238,
		194,
		180,
		-1,
		132,
		137,
		125,
		115,
		105,
		110,
		111,
		101,
		99,
		95,
		104,
		108,
		102,
		101,
		122,
		115,
		137,
		-1,
		-1,
		197,
		190,
		178,
		146,
		141,
		-1,
		-1,
		-1,
		184,
		185,
		151,
		130,
		126,
		-1,
		-1,
		109,
		102,
		96,
		94,
		87,
		107,
		114,
		108,
		95,
		110,
		120,
		128,
		127,
		-1,
		200,
		187,
		-1,
		-1,
		140,
		130,
		-1,
		-1,
		-1,
		-1,
		163,
		108,
		97,
		92,
		96,
		108,
		-1,
		81,
		85,
		85,
		105,
		112,
		110,
		95,
		89,
		100,
		115,
		132,
		-1,
		-1,
		154,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		120,
		114,
		85,
		78,
		82,
		-1,
		79,
		78,
		82,
		88,
		101,
		106,
		101,
		83,
		97,
		100,
		113,
		127,
		131,
		177,
		-1,
		107,
		-1,
		-1,
		-1,
		138,
		139,
		118,
		95,
		74,
		67,
		64,
		70,
		74,
		90,
		96,
		107,
		77,
		81,
		96,
		101,
		105,
		122,
		126,
		-1,
		-1,
		105,
		101,
		136,
		146,
		112,
		145,
		-1,
		-1,
		63,
		56,
		66,
		72,
		80,
		83,
		73,
		75,
		93,
		106,
		100,
		110,
		125,
		120,
		-1,
		-1,
		-1,
		117,
		-1,
		119,
		-1,
		-1,
		102,
		136,
		83,
		65,
		61,
		47,
		67,
		61,
		63,
		68,
		87,
		82,
		91,
		96,
		100,
		123,
		112,
		151,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		96,
		88,
		82,
		85,
		86,
		77,
		98,
		95,
		-1,
		43,
		86,
		58,
		72,
		68,
		75,
		80,
		86,
		90,
		97,
		113,
		112,
		107,
		143,
		134,
		140,
		-1,
		-1,
		193,
		182,
		171,
		177,
		-1,
		89,
		85,
		71,
		61,
		63,
		-1,
		-1,
		3,
		0,
		63,
		50,
		56,
		61,
		64,
		102,
		78,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		131,
		146,
		-1,
		147,
		184,
		177,
		145,
		153,
		184,
		-1,
		79,
		71,
		81,
		57,
		54,
		-1,
		-1,
		22,
		32,
		37,
		46,
		49,
		85,
		84,
		97,
		100,
		105,
		93,
		92,
		110,
		114,
		123,
		130,
		120,
		133,
		137,
		-1,
		140,
		160,
		139,
		142,
		166,
		180,
		-1,
		76,
		-1,
		-1,
		88,
		55,
		39,
		33,
		29,
		84,
		60,
		55,
		68,
		70,
		94,
		85,
		110,
		101,
		101,
		104,
		119,
		124,
		116,
		130,
		130,
		131,
		-1,
		129,
		140,
		133,
		-1,
		-1,
		-1,
		-1,
		77,
		-1,
		-1,
		104,
		-1,
		66,
		-1,
		50,
		54,
		68,
		71,
		93,
		80,
		87,
		104,
		110,
		99,
		109,
		105,
		106,
		115,
		126,
		138,
		137,
		138,
		154,
		110,
		113,
		124,
		135,
		150,
		154,
		-1,
		88,
		127,
		142,
		-1,
		113,
		-1,
		-1,
		-1,
		64,
		81,
		73,
		89,
		92,
		92,
		88,
		92,
		104,
		111,
		121,
		123,
		115,
		119,
		132,
		143,
		146,
		150,
		141,
		154,
		99,
		99,
		120,
		129,
		150,
		103,
		94,
		121,
		149,
		138,
		133,
		120,
		-1,
		-1,
		87,
		91,
		-1,
		-1,
		99,
		109,
		92,
		94,
		98,
		112,
		124,
		132,
		122,
		120,
		114,
		146,
		-1,
		143,
		142,
		131,
		128,
		104,
		95,
		90,
		117,
		-1,
		-1,
		106,
		122,
		123,
		127,
		143,
		168,
		-1,
		123,
		-1,
		-1,
		108,
		-1,
		-1,
		151,
		114,
		103,
		94,
		100,
		106,
		117,
		139,
		128,
		129,
		119,
		129,
		142,
		127,
		124,
		112,
		110,
		133,
		98,
		86,
		-1,
		99,
		97,
		103,
		110,
		127,
		157,
		-1,
		-1,
		139,
		130,
		-1,
		-1,
		127,
		134,
		136,
		-1,
		126,
		99,
		104,
		129,
		136,
		137,
		131,
		125,
		132,
		131,
		139,
		147,
		136,
		150,
		139,
		135,
		134,
		142,
		91,
		84,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		149,
		-1,
		-1,
		134,
		137,
		125,
		113,
		103,
		113,
		121,
		121,
		124,
		128,
		123,
		134,
		126,
		130,
		147,
		-1,
		170,
		-1,
		122,
		98,
		112,
		127,
		135,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		178,
		162,
		143,
		-1,
		113,
		126,
		157,
		125,
		130,
		125,
		129,
		140,
		129,
		132,
		146,
		141,
		-1,
		-1,
		110,
		113,
		-1,
		-1,
		135,
		154,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		150,
		146,
		-1,
		-1,
		114,
		139,
		128,
		136,
		131,
		133,
		139,
		142,
		131,
		135,
		147,
		-1,
		-1,
		117,
		118,
		123,
		-1,
		144,
		-1,
		198,
		-1,
		151,
		167,
		159,
		-1,
		-1,
		-1,
		152,
		115,
		136,
		146,
		151,
		149,
		140,
		137,
		144,
		142,
		138,
		149,
		-1,
		-1,
		-1,
		174,
		151,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		116,
		143,
		145,
		162,
		156,
		140,
		155,
		145,
		136,
		145,
		180,
		-1,
		155,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		147,
		137,
		179,
		160,
		153,
		140,
		147,
		149,
		142,
		-1,
		-1,
		-1,
		170,
		169,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		127,
		118,
		126,
		169,
		165,
		158,
		160,
		150,
		-1,
		242,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		249,
		-1,
		200,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		140,
		138,
		143,
		148,
		-1,
		259,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		149,
		145,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		236,
		225,
		236,
		244,
		217,
		224,
		-1,
		243,
		247,
		213,
		207,
		246,
		215,
		221,
		232,
		-1,
		-1,
		-1,
		236,
		235,
		203,
		201,
		210,
		215,
		222,
		-1,
		221,
		-1,
		257,
		236,
		247,
		252,
		196,
		193,
		213,
		232,
		214,
		206,
		272,
		226,
		197,
		191,
		209,
		199,
		208,
		200,
		-1,
		197,
		187,
		209,
		188,
		199,
		191,
		-1,
		-1,
		191,
		192,
		198,
		184,
		190,
		186,
		-1,
		196,
		180,
		-1,
		-1,
		181,
		182,
		166,
		169,
		177,
		175,
		188,
		180,
		175,
		-1,
		-1,
		172,
		168,
		175,
		162,
		158,
		175,
		188,
		170,
		184,
		183,
		-1,
		178,
		196,
		201,
		169,
		167,
		151,
		149,
		167,
		169,
		175,
		175,
		-1,
		187,
		188,
		183,
		191,
		191,
		167,
		154,
		154,
		164,
		157,
		176,
		164,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		170,
		187,
		179,
		169,
		184,
		177,
		157,
		154,
		152,
		149,
		165,
		163,
		173,
		-1,
		-1,
		278,
		247,
		278,
		236,
		217,
		-1,
		183,
		163,
		169,
		173,
		167,
		160,
		174,
		170,
		-1,
		143,
		142,
		170,
		156,
		167,
		238,
		-1,
		-1,
		236,
		228,
		213,
		216,
		193,
		189,
		178,
		177,
		169,
		155,
		151,
		157,
		160,
		160,
		166,
		137,
		147,
		151,
		149,
		174,
		-1,
		-1,
		209,
		-1,
		-1,
		235,
		218,
		-1,
		201,
		208,
		199,
		205,
		191,
		212,
		188,
		179,
		171,
		165,
		153,
		155,
		152,
		165,
		153,
		134,
		159,
		163,
		144,
		165,
		160,
		-1,
		208,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		194,
		197,
		203,
		227,
		228,
		-1,
		200,
		188,
		189,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		138,
		136,
		166,
		141,
		163,
		160,
		179,
		184,
		178,
		187,
		-1,
		243,
		239,
		235,
		242,
		191,
		-1,
		-1,
		231,
		-1,
		236,
		237,
		212,
		185,
		188,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		130,
		145,
		136,
		135,
		153,
		163,
		171,
		175,
		181,
		-1,
		293,
		-1,
		235,
		219,
		221,
		193,
		214,
		-1,
		251,
		237,
		229,
		214,
		212,
		-1,
		184,
		181,
		171,
		149,
		134,
		151,
		143,
		141,
		143,
		125,
		139,
		130,
		148,
		155,
		153,
		157,
		177,
		189,
		253,
		243,
		-1,
		225,
		230,
		189,
		197,
		216,
		254,
		218,
		-1,
		213,
		-1,
		186,
		199,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		136,
		121,
		118,
		136,
		139,
		146,
		150,
		166,
		-1,
		-1,
		238,
		242,
		231,
		182,
		201,
		225,
		262,
		211,
		200,
		199,
		-1,
		190,
		169,
		166,
		154,
		141,
		126,
		127,
		135,
		147,
		126,
		120,
		117,
		137,
		163,
		141,
		152,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		208,
		179,
		203,
		245,
		229,
		222,
		210,
		175,
		175,
		169,
		-1,
		165,
		144,
		135,
		124,
		122,
		135,
		127,
		135,
		115,
		113,
		132,
		144,
		135,
		143,
		-1,
		-1,
		-1,
		238,
		227,
		228,
		174,
		197,
		234,
		208,
		194,
		199,
		174,
		167,
		161,
		178,
		161,
		142,
		131,
		123,
		112,
		123,
		131,
		129,
		111,
		120,
		126,
		150,
		131,
		137,
		-1,
		-1,
		245,
		235,
		219,
		221,
		218,
		188,
		195,
		227,
		199,
		212,
		-1,
		166,
		-1,
		155,
		151,
		136,
		131,
		128,
		115,
		114,
		128,
		128,
		118,
		113,
		120,
		155,
		155,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		238,
		233,
		208,
		185,
		169,
		205,
		-1,
		182,
		183,
		-1,
		160,
		154,
		151,
		138,
		134,
		119,
		123,
		125,
		128,
		116,
		122,
		123,
		105,
		129,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		231,
		210,
		203,
		223,
		164,
		216,
		-1,
		-1,
		167,
		160,
		-1,
		147,
		129,
		131,
		124,
		118,
		124,
		120,
		110,
		123,
		116,
		110,
		104,
		117,
		121,
		122,
		111,
		107,
		104,
		118,
		-1,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		184,
		-1,
		176,
		168,
		158,
		152,
		146,
		142,
		140,
		146,
		130,
		133,
		128,
		124,
		115,
		105,
		98,
		109,
		94,
		112,
		118,
		109,
		104,
		103,
		114,
		-1,
		251,
		237,
		208,
		-1,
		-1,
		197,
		-1,
		161,
		175,
		191,
		-1,
		184,
		163,
		178,
		156,
		152,
		143,
		137,
		138,
		108,
		113,
		115,
		103,
		106,
		99,
		102,
		94,
		116,
		113,
		97,
		99,
		108,
		-1,
		257,
		244,
		202,
		198,
		187,
		207,
		158,
		146,
		178,
		-1,
		-1,
		198,
		-1,
		152,
		154,
		157,
		155,
		127,
		102,
		109,
		127,
		100,
		95,
		104,
		93,
		91,
		88,
		107,
		93,
		91,
		106,
		122,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		173,
		160,
		154,
		-1,
		195,
		-1,
		176,
		164,
		151,
		133,
		173,
		-1,
		101,
		97,
		104,
		-1,
		120,
		-1,
		92,
		95,
		86,
		83,
		82,
		93,
		91,
		100,
		101,
		-1,
		207,
		192,
		185,
		175,
		189,
		160,
		-1,
		201,
		-1,
		-1,
		163,
		157,
		157,
		126,
		123,
		117,
		97,
		89,
		104,
		103,
		90,
		89,
		77,
		77,
		80,
		78,
		91,
		101,
		107,
		99,
		-1,
		-1,
		-1,
		212,
		197,
		191,
		162,
		167,
		-1,
		-1,
		224,
		180,
		166,
		-1,
		118,
		117,
		105,
		95,
		85,
		90,
		91,
		81,
		79,
		75,
		84,
		87,
		80,
		79,
		100,
		93,
		115,
		-1,
		-1,
		195,
		189,
		177,
		145,
		140,
		-1,
		-1,
		-1,
		170,
		171,
		137,
		116,
		106,
		-1,
		-1,
		89,
		82,
		76,
		78,
		67,
		87,
		94,
		86,
		73,
		88,
		98,
		106,
		105,
		-1,
		198,
		185,
		-1,
		-1,
		139,
		129,
		-1,
		-1,
		-1,
		-1,
		149,
		94,
		83,
		78,
		82,
		88,
		-1,
		62,
		69,
		66,
		85,
		92,
		88,
		73,
		67,
		78,
		93,
		110,
		-1,
		-1,
		153,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		106,
		100,
		71,
		64,
		68,
		-1,
		61,
		62,
		63,
		72,
		83,
		88,
		79,
		61,
		75,
		78,
		91,
		105,
		109,
		176,
		-1,
		106,
		-1,
		-1,
		-1,
		124,
		139,
		104,
		81,
		60,
		53,
		50,
		50,
		55,
		69,
		78,
		89,
		55,
		59,
		74,
		79,
		83,
		100,
		104,
		-1,
		-1,
		104,
		100,
		135,
		132,
		116,
		131,
		-1,
		-1,
		49,
		42,
		52,
		48,
		62,
		65,
		51,
		53,
		71,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		116,
		-1,
		118,
		-1,
		-1,
		106,
		122,
		69,
		51,
		47,
		33,
		37,
		31,
		41,
		46,
		65,
		60,
		69,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		95,
		87,
		82,
		88,
		90,
		81,
		84,
		81,
		-1,
		25,
		34,
		35,
		36,
		46,
		53,
		58,
		64,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		186,
		175,
		164,
		170,
		-1,
		88,
		84,
		74,
		64,
		67,
		-1,
		-1,
		61,
		58,
		0,
		28,
		34,
		39,
		42,
		80,
		56,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		140,
		177,
		170,
		138,
		146,
		177,
		-1,
		78,
		70,
		81,
		56,
		58,
		-1,
		-1,
		34,
		25,
		25,
		20,
		23,
		61,
		62,
		75,
		78,
		83,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		133,
		153,
		132,
		135,
		159,
		173,
		-1,
		75,
		-1,
		-1,
		87,
		59,
		43,
		33,
		30,
		72,
		30,
		25,
		46,
		48,
		72,
		63,
		88,
		79,
		79,
		82,
		97,
		102,
		94,
		108,
		108,
		109,
		-1,
		122,
		133,
		126,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		103,
		-1,
		70,
		-1,
		53,
		57,
		37,
		41,
		71,
		58,
		65,
		82,
		88,
		77,
		87,
		83,
		84,
		93,
		104,
		116,
		115,
		116,
		147,
		103,
		106,
		117,
		128,
		143,
		147,
		-1,
		87,
		126,
		141,
		-1,
		112,
		-1,
		-1,
		-1,
		67,
		50,
		42,
		59,
		70,
		70,
		66,
		70,
		82,
		89,
		99,
		101,
		93,
		97,
		110,
		121,
		124,
		143,
		134,
		147,
		92,
		92,
		113,
		122,
		143,
		102,
		93,
		120,
		146,
		137,
		132,
		119,
		-1,
		-1,
		90,
		60,
		-1,
		-1,
		75,
		87,
		70,
		72,
		76,
		90,
		102,
		110,
		100,
		98,
		92,
		124,
		-1,
		136,
		135,
		124,
		121,
		97,
		88,
		83,
		110,
		-1,
		-1,
		105,
		121,
		116,
		120,
		136,
		161,
		-1,
		122,
		-1,
		-1,
		111,
		-1,
		-1,
		129,
		92,
		81,
		72,
		78,
		84,
		95,
		117,
		106,
		107,
		97,
		107,
		120,
		120,
		117,
		105,
		103,
		126,
		91,
		79,
		-1,
		92,
		90,
		96,
		103,
		120,
		150,
		-1,
		-1,
		138,
		129,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		77,
		82,
		107,
		114,
		115,
		109,
		103,
		110,
		109,
		117,
		125,
		129,
		143,
		132,
		128,
		127,
		135,
		84,
		77,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		166,
		148,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		99,
		99,
		102,
		106,
		101,
		112,
		104,
		108,
		125,
		-1,
		163,
		-1,
		115,
		91,
		105,
		120,
		128,
		-1,
		-1,
		-1,
		183,
		169,
		162,
		150,
		148,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		135,
		103,
		108,
		103,
		107,
		118,
		107,
		110,
		124,
		119,
		-1,
		-1,
		103,
		106,
		-1,
		-1,
		128,
		147,
		-1,
		174,
		163,
		148,
		140,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		117,
		106,
		114,
		109,
		111,
		117,
		120,
		109,
		113,
		125,
		-1,
		-1,
		110,
		111,
		116,
		-1,
		137,
		-1,
		176,
		-1,
		143,
		149,
		137,
		-1,
		-1,
		-1,
		130,
		93,
		114,
		124,
		129,
		127,
		118,
		115,
		122,
		120,
		116,
		127,
		-1,
		-1,
		-1,
		167,
		144,
		183,
		174,
		157,
		137,
		129,
		148,
		-1,
		118,
		-1,
		93,
		94,
		121,
		123,
		140,
		134,
		118,
		133,
		123,
		114,
		123,
		173,
		-1,
		148,
		185,
		149,
		143,
		119,
		123,
		139,
		-1,
		115,
		97,
		-1,
		125,
		115,
		157,
		138,
		131,
		118,
		125,
		127,
		120,
		-1,
		-1,
		-1,
		154,
		153,
		145,
		139,
		139,
		124,
		115,
		-1,
		127,
		109,
		88,
		105,
		105,
		96,
		104,
		147,
		143,
		136,
		138,
		128,
		-1,
		235,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		148,
		143,
		116,
		104,
		110,
		106,
		92,
		98,
		100,
		108,
		106,
		103,
		115,
		111,
		131,
		127,
		159,
		-1,
		242,
		-1,
		184,
		-1,
		-1,
		166,
		146,
		138,
		127,
		116,
		114,
		105,
		96,
		118,
		134,
		118,
		116,
		121,
		126,
		-1,
		239,
		238,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		162,
		123,
		-1,
		125,
		105,
		-1,
		127,
		123,
		-1,
		-1,
		226,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		157,
		141,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		211,
		210,
		-1,
		179,
		182,
		-1,
		172,
		163,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		220,
		201,
		195,
		194,
		192,
		187,
		184,
		170,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		192,
		184,
		177,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		203,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		226,
		249,
		213,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		228,
		226,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		208,
		197,
		208,
		216,
		189,
		196,
		-1,
		215,
		219,
		185,
		179,
		218,
		187,
		193,
		204,
		-1,
		-1,
		-1,
		208,
		207,
		175,
		173,
		182,
		187,
		194,
		-1,
		193,
		-1,
		229,
		208,
		219,
		224,
		168,
		165,
		185,
		204,
		186,
		178,
		244,
		198,
		169,
		163,
		181,
		171,
		180,
		172,
		-1,
		169,
		159,
		181,
		160,
		171,
		163,
		-1,
		-1,
		163,
		164,
		170,
		156,
		162,
		158,
		-1,
		168,
		152,
		-1,
		-1,
		153,
		154,
		138,
		141,
		149,
		147,
		160,
		152,
		147,
		-1,
		-1,
		144,
		140,
		147,
		134,
		130,
		147,
		160,
		142,
		156,
		155,
		-1,
		150,
		168,
		173,
		141,
		139,
		123,
		121,
		139,
		141,
		147,
		147,
		-1,
		159,
		160,
		155,
		163,
		163,
		139,
		126,
		126,
		136,
		129,
		148,
		136,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		142,
		159,
		151,
		141,
		156,
		149,
		129,
		126,
		124,
		121,
		137,
		135,
		145,
		-1,
		-1,
		250,
		219,
		250,
		208,
		189,
		-1,
		155,
		135,
		141,
		145,
		139,
		132,
		146,
		142,
		-1,
		115,
		114,
		142,
		128,
		139,
		210,
		-1,
		-1,
		208,
		200,
		185,
		188,
		165,
		161,
		150,
		149,
		141,
		127,
		123,
		129,
		132,
		132,
		138,
		109,
		119,
		123,
		121,
		146,
		-1,
		-1,
		181,
		-1,
		-1,
		207,
		190,
		-1,
		173,
		180,
		171,
		177,
		163,
		184,
		160,
		151,
		143,
		137,
		125,
		127,
		124,
		137,
		125,
		106,
		131,
		135,
		116,
		137,
		132,
		-1,
		180,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		166,
		169,
		175,
		199,
		200,
		-1,
		172,
		160,
		161,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		122,
		110,
		108,
		138,
		113,
		135,
		132,
		151,
		156,
		150,
		159,
		-1,
		215,
		211,
		207,
		214,
		163,
		-1,
		-1,
		203,
		-1,
		208,
		209,
		184,
		157,
		160,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		119,
		102,
		117,
		108,
		107,
		125,
		135,
		143,
		147,
		153,
		-1,
		265,
		-1,
		207,
		191,
		193,
		165,
		186,
		-1,
		223,
		209,
		201,
		186,
		184,
		-1,
		156,
		153,
		143,
		121,
		106,
		123,
		115,
		113,
		115,
		97,
		111,
		102,
		120,
		127,
		125,
		129,
		149,
		161,
		225,
		215,
		-1,
		197,
		202,
		161,
		169,
		188,
		226,
		190,
		-1,
		185,
		-1,
		158,
		171,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		108,
		93,
		90,
		108,
		111,
		118,
		122,
		138,
		-1,
		-1,
		210,
		214,
		203,
		154,
		173,
		197,
		234,
		183,
		172,
		171,
		-1,
		162,
		141,
		138,
		126,
		113,
		98,
		99,
		107,
		119,
		98,
		92,
		89,
		109,
		135,
		113,
		124,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		180,
		151,
		175,
		217,
		201,
		194,
		182,
		147,
		147,
		141,
		-1,
		137,
		116,
		107,
		96,
		94,
		107,
		99,
		107,
		87,
		85,
		104,
		116,
		107,
		115,
		-1,
		-1,
		-1,
		210,
		199,
		200,
		146,
		169,
		206,
		180,
		166,
		171,
		146,
		139,
		133,
		150,
		133,
		114,
		103,
		95,
		84,
		95,
		103,
		101,
		83,
		92,
		98,
		122,
		103,
		109,
		-1,
		-1,
		217,
		207,
		191,
		193,
		190,
		160,
		167,
		199,
		171,
		184,
		-1,
		138,
		-1,
		127,
		123,
		108,
		103,
		100,
		87,
		86,
		100,
		100,
		90,
		85,
		92,
		127,
		127,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		210,
		205,
		180,
		157,
		141,
		177,
		-1,
		154,
		155,
		-1,
		132,
		126,
		123,
		110,
		106,
		91,
		95,
		97,
		100,
		88,
		94,
		95,
		77,
		101,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		203,
		182,
		175,
		195,
		136,
		188,
		-1,
		-1,
		139,
		132,
		-1,
		119,
		101,
		103,
		98,
		94,
		96,
		93,
		82,
		95,
		88,
		82,
		76,
		89,
		93,
		94,
		83,
		79,
		76,
		90,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		156,
		-1,
		148,
		140,
		130,
		124,
		118,
		114,
		112,
		122,
		106,
		108,
		104,
		96,
		91,
		77,
		70,
		81,
		66,
		84,
		90,
		81,
		76,
		75,
		86,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		169,
		-1,
		133,
		147,
		163,
		-1,
		156,
		135,
		150,
		128,
		124,
		115,
		113,
		114,
		84,
		89,
		91,
		79,
		82,
		71,
		74,
		66,
		88,
		85,
		69,
		71,
		80,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		130,
		118,
		150,
		-1,
		-1,
		182,
		-1,
		126,
		138,
		129,
		127,
		103,
		78,
		85,
		103,
		76,
		71,
		76,
		65,
		65,
		60,
		79,
		65,
		63,
		78,
		94,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		167,
		-1,
		160,
		148,
		135,
		117,
		157,
		-1,
		77,
		73,
		80,
		-1,
		96,
		-1,
		68,
		71,
		62,
		57,
		54,
		65,
		63,
		72,
		73,
		-1,
		179,
		164,
		157,
		147,
		161,
		132,
		-1,
		187,
		-1,
		-1,
		147,
		141,
		141,
		110,
		107,
		93,
		73,
		65,
		80,
		79,
		66,
		65,
		53,
		53,
		56,
		50,
		63,
		73,
		79,
		71,
		-1,
		-1,
		-1,
		184,
		170,
		174,
		134,
		153,
		-1,
		-1,
		208,
		164,
		150,
		-1,
		102,
		93,
		81,
		71,
		61,
		66,
		67,
		57,
		55,
		51,
		60,
		59,
		52,
		51,
		72,
		65,
		87,
		-1,
		-1,
		167,
		172,
		160,
		138,
		133,
		-1,
		-1,
		-1,
		154,
		155,
		121,
		100,
		82,
		-1,
		-1,
		65,
		58,
		52,
		55,
		43,
		63,
		70,
		58,
		45,
		60,
		70,
		78,
		77,
		-1,
		170,
		157,
		-1,
		-1,
		132,
		122,
		-1,
		-1,
		-1,
		-1,
		133,
		78,
		67,
		62,
		66,
		64,
		-1,
		38,
		49,
		42,
		61,
		68,
		60,
		45,
		39,
		50,
		65,
		82,
		-1,
		-1,
		146,
		-1,
		108,
		-1,
		-1,
		-1,
		-1,
		90,
		84,
		55,
		48,
		52,
		-1,
		40,
		42,
		39,
		51,
		56,
		60,
		51,
		33,
		47,
		50,
		63,
		77,
		81,
		169,
		-1,
		99,
		-1,
		-1,
		-1,
		108,
		123,
		94,
		71,
		44,
		39,
		32,
		26,
		31,
		42,
		51,
		62,
		27,
		31,
		46,
		51,
		55,
		72,
		76,
		-1,
		-1,
		97,
		93,
		128,
		116,
		109,
		121,
		-1,
		-1,
		48,
		39,
		30,
		22,
		35,
		38,
		23,
		25,
		43,
		56,
		50,
		60,
		75,
		70,
		-1,
		-1,
		-1,
		109,
		-1,
		111,
		-1,
		-1,
		99,
		119,
		66,
		48,
		44,
		39,
		17,
		11,
		13,
		18,
		37,
		32,
		41,
		46,
		50,
		73,
		62,
		101,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		88,
		80,
		75,
		81,
		83,
		74,
		81,
		78,
		-1,
		36,
		40,
		8,
		22,
		18,
		25,
		30,
		36,
		40,
		47,
		63,
		62,
		57,
		93,
		84,
		90,
		-1,
		-1,
		174,
		163,
		152,
		158,
		-1,
		81,
		77,
		67,
		57,
		60,
		-1,
		-1,
		54,
		51,
		31,
		0,
		6,
		11,
		14,
		52,
		28,
		36,
		40,
		44,
		50,
		55,
		60,
		66,
		81,
		96,
		-1,
		128,
		165,
		158,
		126,
		134,
		165,
		-1,
		71,
		63,
		74,
		49,
		51,
		-1,
		-1,
		27,
		18,
		19,
		7,
		4,
		35,
		34,
		47,
		50,
		55,
		43,
		42,
		60,
		64,
		73,
		80,
		70,
		83,
		87,
		-1,
		121,
		141,
		120,
		123,
		147,
		161,
		-1,
		68,
		-1,
		-1,
		80,
		52,
		36,
		26,
		23,
		66,
		21,
		16,
		18,
		20,
		44,
		35,
		60,
		51,
		51,
		54,
		69,
		74,
		66,
		80,
		80,
		81,
		-1,
		110,
		121,
		114,
		-1,
		-1,
		-1,
		-1,
		69,
		-1,
		-1,
		96,
		-1,
		63,
		-1,
		46,
		50,
		29,
		32,
		43,
		30,
		37,
		54,
		60,
		49,
		59,
		55,
		56,
		65,
		76,
		88,
		87,
		88,
		135,
		91,
		94,
		105,
		116,
		131,
		135,
		-1,
		80,
		119,
		134,
		-1,
		105,
		-1,
		-1,
		-1,
		60,
		42,
		34,
		50,
		42,
		42,
		38,
		42,
		54,
		61,
		71,
		73,
		65,
		69,
		82,
		93,
		96,
		131,
		122,
		135,
		80,
		80,
		101,
		110,
		131,
		95,
		86,
		113,
		134,
		130,
		125,
		112,
		-1,
		-1,
		83,
		52,
		-1,
		-1,
		49,
		59,
		42,
		44,
		48,
		62,
		74,
		82,
		72,
		70,
		64,
		96,
		-1,
		124,
		123,
		112,
		109,
		85,
		76,
		71,
		98,
		-1,
		-1,
		93,
		114,
		104,
		108,
		124,
		149,
		-1,
		115,
		-1,
		-1,
		104,
		-1,
		-1,
		101,
		64,
		53,
		44,
		50,
		56,
		67,
		89,
		78,
		79,
		69,
		79,
		92,
		108,
		105,
		93,
		91,
		114,
		79,
		67,
		-1,
		80,
		78,
		84,
		91,
		108,
		138,
		-1,
		-1,
		131,
		122,
		-1,
		-1,
		99,
		97,
		86,
		-1,
		76,
		49,
		54,
		79,
		86,
		87,
		81,
		75,
		82,
		81,
		89,
		97,
		117,
		131,
		120,
		116,
		115,
		123,
		72,
		65,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		138,
		134,
		-1,
		-1,
		94,
		87,
		75,
		63,
		53,
		63,
		71,
		71,
		74,
		78,
		73,
		84,
		76,
		80,
		97,
		-1,
		151,
		-1,
		103,
		79,
		93,
		108,
		116,
		-1,
		-1,
		-1,
		155,
		141,
		134,
		122,
		120,
		-1,
		128,
		112,
		93,
		-1,
		63,
		76,
		107,
		75,
		80,
		75,
		79,
		90,
		79,
		82,
		96,
		91,
		-1,
		-1,
		91,
		94,
		-1,
		-1,
		116,
		135,
		-1,
		146,
		135,
		120,
		112,
		-1,
		-1,
		100,
		96,
		-1,
		-1,
		64,
		89,
		78,
		86,
		81,
		83,
		89,
		92,
		81,
		85,
		97,
		-1,
		-1,
		98,
		99,
		104,
		-1,
		125,
		-1,
		148,
		-1,
		115,
		121,
		109,
		-1,
		-1,
		-1,
		102,
		65,
		86,
		96,
		101,
		99,
		90,
		87,
		94,
		92,
		88,
		99,
		-1,
		-1,
		-1,
		148,
		122,
		155,
		146,
		129,
		109,
		101,
		120,
		-1,
		90,
		-1,
		65,
		66,
		93,
		95,
		112,
		106,
		90,
		105,
		95,
		86,
		95,
		154,
		-1,
		124,
		157,
		121,
		115,
		91,
		95,
		111,
		-1,
		87,
		69,
		-1,
		97,
		87,
		129,
		110,
		103,
		90,
		97,
		99,
		92,
		-1,
		-1,
		-1,
		126,
		125,
		117,
		111,
		111,
		96,
		87,
		-1,
		99,
		81,
		60,
		77,
		77,
		68,
		76,
		119,
		115,
		108,
		110,
		100,
		-1,
		223,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		120,
		115,
		88,
		76,
		82,
		78,
		64,
		70,
		72,
		80,
		78,
		75,
		87,
		83,
		103,
		99,
		131,
		-1,
		222,
		-1,
		156,
		-1,
		-1,
		138,
		118,
		110,
		99,
		88,
		86,
		77,
		68,
		90,
		106,
		90,
		88,
		93,
		98,
		-1,
		211,
		210,
		-1,
		157,
		149,
		135,
		-1,
		128,
		-1,
		134,
		95,
		-1,
		97,
		77,
		-1,
		99,
		95,
		-1,
		-1,
		198,
		173,
		-1,
		-1,
		-1,
		158,
		138,
		129,
		113,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		183,
		182,
		-1,
		151,
		154,
		-1,
		144,
		135,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		192,
		173,
		167,
		166,
		164,
		159,
		156,
		142,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		164,
		156,
		149,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		175,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		197,
		198,
		221,
		185,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		200,
		198,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		147,
		165,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		156,
		157,
		152,
		160,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		114,
		113,
		141,
		127,
		138,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		117,
		96,
		91,
		88,
		108,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		101,
		106,
		86,
		84,
		103,
		115,
		106,
		119,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		97,
		105,
		100,
		82,
		91,
		97,
		121,
		107,
		113,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		91,
		88,
		97,
		99,
		89,
		84,
		91,
		126,
		126,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		95,
		99,
		95,
		102,
		92,
		93,
		94,
		76,
		105,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		102,
		98,
		100,
		97,
		86,
		99,
		92,
		81,
		80,
		93,
		97,
		98,
		87,
		83,
		80,
		94,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		126,
		110,
		112,
		108,
		100,
		95,
		81,
		74,
		84,
		70,
		88,
		94,
		85,
		80,
		79,
		90,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		117,
		118,
		88,
		93,
		95,
		83,
		86,
		75,
		78,
		70,
		92,
		89,
		73,
		75,
		84,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		186,
		-1,
		125,
		142,
		133,
		131,
		107,
		82,
		89,
		107,
		80,
		75,
		80,
		69,
		69,
		64,
		83,
		69,
		67,
		82,
		98,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		164,
		152,
		139,
		121,
		161,
		-1,
		81,
		77,
		84,
		-1,
		100,
		-1,
		72,
		75,
		66,
		61,
		58,
		69,
		67,
		76,
		77,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		151,
		145,
		145,
		114,
		111,
		97,
		77,
		69,
		84,
		83,
		70,
		69,
		57,
		57,
		60,
		54,
		67,
		77,
		83,
		75,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		212,
		168,
		154,
		-1,
		106,
		97,
		85,
		75,
		65,
		70,
		71,
		61,
		59,
		55,
		64,
		63,
		56,
		55,
		76,
		69,
		91,
		-1,
		-1,
		166,
		171,
		159,
		145,
		140,
		-1,
		-1,
		-1,
		158,
		159,
		125,
		104,
		86,
		-1,
		-1,
		69,
		62,
		56,
		59,
		47,
		67,
		74,
		62,
		49,
		64,
		74,
		82,
		73,
		-1,
		169,
		156,
		-1,
		-1,
		139,
		129,
		-1,
		-1,
		-1,
		-1,
		137,
		82,
		71,
		66,
		70,
		68,
		-1,
		42,
		53,
		46,
		65,
		72,
		64,
		49,
		43,
		54,
		69,
		78,
		-1,
		-1,
		153,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		94,
		88,
		59,
		52,
		56,
		-1,
		44,
		46,
		43,
		55,
		60,
		64,
		55,
		37,
		50,
		54,
		58,
		72,
		76,
		176,
		-1,
		106,
		-1,
		-1,
		-1,
		112,
		127,
		98,
		75,
		48,
		43,
		36,
		30,
		35,
		46,
		55,
		66,
		31,
		35,
		47,
		46,
		50,
		67,
		71,
		-1,
		-1,
		104,
		100,
		135,
		120,
		116,
		125,
		-1,
		-1,
		52,
		43,
		34,
		26,
		39,
		42,
		27,
		29,
		47,
		51,
		45,
		55,
		70,
		65,
		-1,
		-1,
		-1,
		116,
		-1,
		118,
		-1,
		-1,
		106,
		123,
		70,
		52,
		48,
		46,
		24,
		18,
		17,
		22,
		32,
		27,
		36,
		41,
		45,
		68,
		57,
		96,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		95,
		87,
		82,
		88,
		90,
		81,
		85,
		82,
		-1,
		43,
		47,
		15,
		29,
		13,
		20,
		25,
		31,
		35,
		42,
		58,
		57,
		52,
		88,
		79,
		85,
		-1,
		-1,
		181,
		170,
		159,
		165,
		-1,
		88,
		84,
		74,
		64,
		67,
		-1,
		-1,
		61,
		58,
		38,
		7,
		0,
		5,
		9,
		47,
		23,
		31,
		35,
		39,
		45,
		50,
		55,
		61,
		76,
		91,
		-1,
		135,
		172,
		165,
		133,
		141,
		172,
		-1,
		78,
		70,
		81,
		56,
		58,
		-1,
		-1,
		34,
		25,
		26,
		14,
		11,
		29,
		28,
		43,
		45,
		50,
		38,
		37,
		55,
		59,
		68,
		75,
		65,
		78,
		82,
		-1,
		128,
		148,
		127,
		130,
		154,
		168,
		-1,
		75,
		-1,
		-1,
		87,
		59,
		43,
		33,
		30,
		73,
		28,
		23,
		25,
		27,
		41,
		32,
		55,
		46,
		46,
		49,
		64,
		69,
		61,
		75,
		75,
		76,
		-1,
		117,
		128,
		121,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		103,
		-1,
		70,
		-1,
		53,
		57,
		36,
		39,
		50,
		37,
		44,
		53,
		61,
		44,
		54,
		50,
		51,
		60,
		71,
		83,
		82,
		83,
		142,
		98,
		101,
		112,
		123,
		138,
		142,
		-1,
		87,
		126,
		141,
		-1,
		112,
		-1,
		-1,
		-1,
		67,
		49,
		41,
		57,
		49,
		49,
		39,
		43,
		49,
		56,
		66,
		68,
		60,
		64,
		77,
		88,
		91,
		138,
		129,
		142,
		87,
		87,
		108,
		117,
		138,
		102,
		93,
		120,
		141,
		137,
		132,
		119,
		-1,
		-1,
		90,
		59,
		-1,
		-1,
		56,
		60,
		43,
		45,
		49,
		59,
		74,
		77,
		67,
		65,
		59,
		91,
		-1,
		131,
		130,
		119,
		116,
		92,
		83,
		78,
		105,
		-1,
		-1,
		100,
		121,
		111,
		115,
		131,
		156,
		-1,
		122,
		-1,
		-1,
		111,
		-1,
		-1,
		102,
		65,
		54,
		45,
		51,
		57,
		68,
		85,
		73,
		74,
		64,
		74,
		87,
		115,
		112,
		100,
		98,
		121,
		86,
		74,
		-1,
		87,
		85,
		91,
		98,
		115,
		145,
		-1,
		-1,
		138,
		123,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		50,
		55,
		80,
		87,
		82,
		76,
		70,
		77,
		76,
		84,
		92,
		124,
		138,
		127,
		123,
		122,
		130,
		79,
		72,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		64,
		72,
		72,
		75,
		73,
		68,
		79,
		71,
		75,
		92,
		-1,
		158,
		-1,
		110,
		86,
		100,
		115,
		123,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		108,
		76,
		81,
		76,
		74,
		85,
		74,
		77,
		91,
		86,
		-1,
		-1,
		98,
		101,
		-1,
		-1,
		123,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		65,
		90,
		79,
		87,
		82,
		78,
		84,
		87,
		76,
		80,
		92,
		-1,
		-1,
		105,
		106,
		111,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		103,
		66,
		83,
		97,
		102,
		100,
		91,
		82,
		89,
		87,
		83,
		94,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		85,
		-1,
		60,
		63,
		88,
		96,
		113,
		107,
		85,
		100,
		90,
		81,
		90,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		82,
		64,
		-1,
		92,
		82,
		130,
		105,
		100,
		87,
		94,
		94,
		87,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		72,
		63,
		71,
		120,
		116,
		107,
		107,
		95,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		75,
		73,
		70,
		82,
		78,
		98,
		94,
		126,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		101,
		85,
		83,
		88,
		93,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		94,
		90,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		143,
		161,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		152,
		153,
		148,
		156,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		245,
		214,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		110,
		109,
		137,
		123,
		134,
		205,
		-1,
		-1,
		203,
		195,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		202,
		194,
		179,
		179,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		221,
		185,
		-1,
		180,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		113,
		92,
		87,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		97,
		102,
		82,
		80,
		99,
		111,
		102,
		115,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		143,
		126,
		107,
		96,
		88,
		77,
		93,
		101,
		96,
		78,
		87,
		93,
		117,
		103,
		109,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		87,
		84,
		93,
		95,
		85,
		80,
		87,
		122,
		122,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		91,
		95,
		91,
		98,
		88,
		89,
		90,
		72,
		101,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		98,
		94,
		96,
		93,
		82,
		95,
		88,
		77,
		76,
		89,
		93,
		94,
		83,
		79,
		76,
		90,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		122,
		106,
		108,
		104,
		96,
		91,
		77,
		70,
		80,
		66,
		84,
		90,
		81,
		76,
		75,
		86,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		113,
		114,
		84,
		89,
		91,
		79,
		82,
		71,
		74,
		66,
		88,
		85,
		69,
		71,
		80,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		182,
		-1,
		121,
		138,
		129,
		127,
		103,
		78,
		85,
		103,
		76,
		71,
		76,
		65,
		65,
		60,
		79,
		65,
		63,
		78,
		94,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		160,
		148,
		135,
		117,
		157,
		-1,
		77,
		73,
		80,
		-1,
		96,
		-1,
		68,
		71,
		62,
		57,
		54,
		65,
		63,
		72,
		73,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		147,
		141,
		141,
		110,
		107,
		93,
		73,
		65,
		80,
		79,
		66,
		65,
		53,
		53,
		56,
		50,
		63,
		73,
		79,
		71,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		208,
		164,
		150,
		-1,
		102,
		93,
		81,
		71,
		61,
		66,
		67,
		57,
		55,
		51,
		60,
		59,
		52,
		51,
		72,
		65,
		87,
		-1,
		-1,
		162,
		167,
		155,
		141,
		147,
		-1,
		-1,
		-1,
		154,
		155,
		121,
		100,
		82,
		-1,
		-1,
		65,
		58,
		52,
		55,
		43,
		63,
		70,
		58,
		45,
		60,
		70,
		78,
		69,
		-1,
		165,
		152,
		-1,
		-1,
		146,
		136,
		-1,
		-1,
		-1,
		-1,
		133,
		78,
		67,
		62,
		66,
		64,
		-1,
		38,
		49,
		42,
		61,
		68,
		60,
		45,
		39,
		50,
		65,
		74,
		-1,
		-1,
		160,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		90,
		84,
		55,
		48,
		52,
		-1,
		40,
		42,
		39,
		51,
		56,
		60,
		51,
		33,
		46,
		50,
		54,
		68,
		72,
		183,
		-1,
		113,
		-1,
		-1,
		-1,
		108,
		123,
		94,
		71,
		44,
		39,
		32,
		26,
		31,
		42,
		51,
		62,
		27,
		31,
		43,
		42,
		46,
		63,
		67,
		-1,
		-1,
		111,
		107,
		134,
		116,
		120,
		121,
		-1,
		-1,
		48,
		39,
		30,
		22,
		35,
		38,
		23,
		25,
		43,
		47,
		41,
		51,
		66,
		61,
		-1,
		-1,
		-1,
		123,
		-1,
		125,
		-1,
		-1,
		113,
		119,
		66,
		48,
		44,
		42,
		31,
		25,
		13,
		18,
		28,
		23,
		32,
		37,
		41,
		64,
		53,
		92,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		102,
		94,
		89,
		95,
		97,
		88,
		81,
		78,
		-1,
		48,
		54,
		19,
		26,
		9,
		16,
		21,
		27,
		31,
		38,
		54,
		53,
		48,
		84,
		75,
		81,
		-1,
		-1,
		188,
		177,
		166,
		172,
		-1,
		95,
		91,
		81,
		71,
		74,
		-1,
		-1,
		68,
		65,
		45,
		14,
		7,
		0,
		5,
		43,
		19,
		27,
		31,
		35,
		41,
		46,
		51,
		57,
		72,
		87,
		-1,
		142,
		179,
		172,
		140,
		148,
		179,
		-1,
		85,
		77,
		88,
		63,
		65,
		-1,
		-1,
		41,
		32,
		33,
		21,
		18,
		24,
		23,
		39,
		41,
		46,
		34,
		33,
		51,
		55,
		64,
		71,
		61,
		74,
		78,
		-1,
		135,
		155,
		134,
		137,
		161,
		175,
		-1,
		82,
		-1,
		-1,
		94,
		66,
		50,
		40,
		37,
		80,
		35,
		30,
		32,
		34,
		37,
		28,
		51,
		42,
		42,
		45,
		60,
		65,
		57,
		71,
		71,
		72,
		-1,
		124,
		135,
		128,
		-1,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		110,
		-1,
		77,
		-1,
		60,
		64,
		43,
		46,
		57,
		44,
		41,
		49,
		57,
		40,
		50,
		46,
		47,
		56,
		67,
		79,
		78,
		79,
		149,
		105,
		108,
		119,
		130,
		145,
		149,
		-1,
		94,
		133,
		148,
		-1,
		119,
		-1,
		-1,
		-1,
		74,
		56,
		48,
		64,
		56,
		56,
		35,
		39,
		45,
		52,
		62,
		64,
		56,
		60,
		73,
		84,
		87,
		145,
		136,
		149,
		94,
		94,
		115,
		124,
		145,
		109,
		100,
		127,
		148,
		144,
		139,
		126,
		-1,
		-1,
		97,
		66,
		-1,
		-1,
		63,
		56,
		39,
		41,
		45,
		55,
		70,
		73,
		63,
		61,
		55,
		87,
		-1,
		138,
		137,
		126,
		123,
		99,
		90,
		85,
		112,
		-1,
		-1,
		107,
		128,
		118,
		122,
		138,
		163,
		-1,
		123,
		-1,
		-1,
		113,
		-1,
		-1,
		98,
		61,
		50,
		41,
		47,
		53,
		64,
		81,
		69,
		70,
		60,
		70,
		83,
		122,
		119,
		107,
		105,
		128,
		93,
		81,
		-1,
		94,
		92,
		98,
		105,
		122,
		152,
		-1,
		-1,
		139,
		119,
		-1,
		-1,
		96,
		94,
		83,
		-1,
		73,
		46,
		51,
		76,
		83,
		78,
		72,
		66,
		73,
		72,
		80,
		88,
		131,
		145,
		134,
		130,
		129,
		137,
		86,
		79,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		125,
		-1,
		-1,
		91,
		84,
		72,
		60,
		50,
		60,
		68,
		68,
		71,
		69,
		64,
		75,
		67,
		71,
		88,
		-1,
		165,
		-1,
		117,
		93,
		107,
		122,
		130,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		125,
		109,
		90,
		-1,
		60,
		73,
		104,
		72,
		77,
		72,
		70,
		81,
		70,
		73,
		87,
		82,
		-1,
		-1,
		105,
		108,
		-1,
		-1,
		130,
		138,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		97,
		93,
		-1,
		-1,
		61,
		86,
		75,
		83,
		78,
		74,
		80,
		83,
		72,
		76,
		88,
		-1,
		-1,
		112,
		113,
		118,
		-1,
		121,
		-1,
		139,
		-1,
		106,
		112,
		100,
		-1,
		-1,
		-1,
		99,
		62,
		79,
		93,
		98,
		96,
		87,
		78,
		85,
		83,
		79,
		90,
		-1,
		-1,
		-1,
		139,
		113,
		146,
		137,
		120,
		100,
		92,
		111,
		-1,
		81,
		-1,
		56,
		59,
		84,
		92,
		109,
		103,
		81,
		96,
		86,
		77,
		86,
		145,
		-1,
		115,
		148,
		112,
		106,
		82,
		86,
		102,
		-1,
		78,
		60,
		-1,
		88,
		78,
		126,
		101,
		96,
		83,
		90,
		90,
		83,
		-1,
		-1,
		-1,
		117,
		116,
		108,
		102,
		102,
		87,
		78,
		-1,
		90,
		72,
		51,
		68,
		68,
		59,
		67,
		116,
		112,
		103,
		103,
		91,
		-1,
		218,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		111,
		106,
		79,
		67,
		73,
		69,
		55,
		61,
		63,
		71,
		69,
		66,
		78,
		74,
		94,
		90,
		122,
		-1,
		213,
		-1,
		147,
		-1,
		-1,
		129,
		109,
		101,
		90,
		79,
		77,
		68,
		59,
		81,
		97,
		81,
		79,
		84,
		89,
		-1,
		202,
		201,
		-1,
		148,
		140,
		126,
		-1,
		119,
		-1,
		125,
		86,
		-1,
		88,
		68,
		-1,
		90,
		86,
		-1,
		-1,
		189,
		164,
		-1,
		-1,
		-1,
		149,
		129,
		120,
		104,
		-1,
		79,
		79,
		-1,
		-1,
		-1,
		174,
		173,
		-1,
		142,
		145,
		-1,
		135,
		126,
		134,
		81,
		85,
		-1,
		-1,
		-1,
		183,
		164,
		158,
		157,
		155,
		150,
		147,
		133,
		117,
		95,
		84,
		105,
		-1,
		-1,
		-1,
		155,
		147,
		140,
		-1,
		-1,
		142,
		125,
		106,
		104,
		-1,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		132,
		-1,
		-1,
		138,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		166,
		-1,
		-1,
		-1,
		128,
		124,
		125,
		-1,
		-1,
		-1,
		-1,
		188,
		189,
		212,
		176,
		-1,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		191,
		189,
		-1,
		-1,
		-1,
		148,
		132,
		-1,
		118,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		153,
		-1,
		153,
		128,
		135,
		-1,
		-1,
		-1,
		-1,
		166,
		158,
		166,
		-1,
		138,
		140,
		-1,
		188,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		143,
		150,
		172,
		175,
		211,
		-1,
		162
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		138,
		156,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		147,
		148,
		143,
		151,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		240,
		209,
		238,
		196,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		105,
		104,
		132,
		118,
		129,
		200,
		-1,
		-1,
		198,
		190,
		173,
		176,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		99,
		109,
		113,
		111,
		136,
		-1,
		-1,
		171,
		-1,
		-1,
		197,
		180,
		-1,
		163,
		170,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		96,
		121,
		125,
		106,
		127,
		122,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		156,
		159,
		165,
		189,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		100,
		98,
		128,
		103,
		125,
		122,
		141,
		146,
		140,
		149,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		193,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		92,
		107,
		98,
		97,
		115,
		125,
		133,
		137,
		143,
		-1,
		255,
		-1,
		197,
		181,
		183,
		155,
		176,
		-1,
		213,
		197,
		189,
		174,
		174,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		105,
		87,
		101,
		92,
		110,
		117,
		115,
		119,
		139,
		151,
		215,
		205,
		-1,
		187,
		192,
		151,
		159,
		178,
		216,
		180,
		-1,
		175,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		98,
		83,
		80,
		98,
		101,
		108,
		112,
		128,
		-1,
		-1,
		200,
		204,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		108,
		87,
		82,
		79,
		99,
		125,
		103,
		115,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		92,
		97,
		77,
		75,
		94,
		106,
		97,
		110,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		138,
		121,
		102,
		91,
		83,
		72,
		88,
		96,
		91,
		73,
		82,
		88,
		112,
		98,
		104,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		112,
		96,
		91,
		88,
		82,
		79,
		88,
		90,
		80,
		75,
		82,
		117,
		117,
		88,
		108,
		111,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		98,
		94,
		86,
		90,
		86,
		93,
		83,
		84,
		85,
		67,
		96,
		-1,
		96,
		90,
		98,
		88,
		76,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		98,
		93,
		89,
		91,
		88,
		77,
		90,
		83,
		72,
		71,
		84,
		88,
		89,
		78,
		74,
		71,
		85,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		117,
		101,
		103,
		99,
		91,
		86,
		72,
		65,
		75,
		61,
		79,
		85,
		76,
		71,
		70,
		81,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		110,
		108,
		109,
		79,
		84,
		86,
		74,
		77,
		66,
		69,
		61,
		83,
		80,
		64,
		66,
		75,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		177,
		-1,
		116,
		133,
		124,
		122,
		98,
		73,
		80,
		98,
		71,
		66,
		71,
		60,
		60,
		55,
		74,
		60,
		58,
		73,
		89,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		155,
		143,
		130,
		112,
		152,
		-1,
		72,
		68,
		75,
		-1,
		91,
		-1,
		63,
		66,
		57,
		52,
		49,
		60,
		58,
		67,
		68,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		142,
		136,
		136,
		105,
		102,
		88,
		68,
		60,
		75,
		74,
		61,
		60,
		48,
		48,
		51,
		45,
		58,
		68,
		74,
		66,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		203,
		159,
		145,
		-1,
		97,
		88,
		76,
		66,
		56,
		61,
		62,
		52,
		50,
		46,
		55,
		54,
		47,
		46,
		67,
		60,
		82,
		-1,
		-1,
		157,
		162,
		150,
		136,
		147,
		-1,
		-1,
		-1,
		149,
		150,
		116,
		95,
		77,
		-1,
		-1,
		60,
		53,
		47,
		50,
		38,
		58,
		65,
		53,
		40,
		55,
		65,
		73,
		64,
		-1,
		160,
		147,
		-1,
		-1,
		146,
		136,
		-1,
		-1,
		-1,
		-1,
		128,
		73,
		62,
		57,
		61,
		59,
		-1,
		33,
		44,
		37,
		56,
		63,
		55,
		40,
		34,
		45,
		60,
		69,
		-1,
		-1,
		160,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		85,
		79,
		50,
		43,
		47,
		-1,
		35,
		37,
		34,
		46,
		51,
		55,
		46,
		28,
		41,
		45,
		49,
		63,
		67,
		183,
		-1,
		113,
		-1,
		-1,
		-1,
		103,
		118,
		89,
		66,
		39,
		34,
		27,
		21,
		26,
		37,
		46,
		57,
		22,
		26,
		38,
		37,
		41,
		58,
		62,
		-1,
		-1,
		111,
		107,
		129,
		111,
		115,
		116,
		-1,
		-1,
		43,
		34,
		25,
		17,
		30,
		33,
		18,
		20,
		38,
		42,
		36,
		46,
		61,
		56,
		-1,
		-1,
		-1,
		123,
		-1,
		125,
		-1,
		-1,
		113,
		114,
		61,
		43,
		39,
		37,
		26,
		20,
		8,
		13,
		23,
		18,
		27,
		32,
		36,
		59,
		48,
		87,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		102,
		94,
		89,
		95,
		97,
		88,
		76,
		73,
		-1,
		43,
		49,
		14,
		21,
		4,
		11,
		16,
		22,
		26,
		33,
		49,
		48,
		43,
		79,
		70,
		76,
		-1,
		-1,
		188,
		177,
		166,
		172,
		-1,
		95,
		91,
		81,
		71,
		74,
		-1,
		-1,
		68,
		65,
		45,
		14,
		12,
		5,
		0,
		38,
		14,
		22,
		26,
		30,
		36,
		41,
		46,
		52,
		67,
		82,
		-1,
		142,
		179,
		172,
		140,
		148,
		179,
		-1,
		85,
		77,
		88,
		63,
		65,
		-1,
		-1,
		41,
		32,
		33,
		21,
		18,
		24,
		23,
		34,
		36,
		41,
		29,
		28,
		46,
		50,
		59,
		66,
		56,
		69,
		73,
		-1,
		135,
		155,
		134,
		137,
		161,
		175,
		-1,
		82,
		-1,
		-1,
		94,
		66,
		50,
		40,
		37,
		80,
		35,
		30,
		32,
		34,
		32,
		23,
		46,
		37,
		37,
		40,
		55,
		60,
		52,
		66,
		66,
		67,
		-1,
		124,
		135,
		128,
		-1,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		110,
		-1,
		77,
		-1,
		60,
		64,
		43,
		46,
		57,
		44,
		36,
		44,
		52,
		35,
		45,
		41,
		42,
		51,
		62,
		74,
		73,
		74,
		149,
		105,
		108,
		119,
		130,
		145,
		149,
		-1,
		94,
		133,
		148,
		-1,
		119,
		-1,
		-1,
		-1,
		74,
		56,
		48,
		64,
		56,
		56,
		30,
		34,
		40,
		47,
		57,
		59,
		51,
		55,
		68,
		79,
		82,
		145,
		136,
		149,
		94,
		94,
		115,
		124,
		145,
		109,
		100,
		127,
		148,
		144,
		139,
		126,
		-1,
		-1,
		97,
		66,
		-1,
		-1,
		63,
		51,
		34,
		36,
		40,
		50,
		65,
		68,
		58,
		56,
		50,
		82,
		-1,
		138,
		137,
		126,
		123,
		99,
		90,
		85,
		112,
		-1,
		-1,
		107,
		128,
		118,
		122,
		138,
		163,
		-1,
		118,
		-1,
		-1,
		108,
		-1,
		-1,
		93,
		56,
		45,
		36,
		42,
		48,
		59,
		76,
		64,
		65,
		55,
		65,
		78,
		122,
		119,
		107,
		105,
		128,
		93,
		81,
		-1,
		94,
		92,
		98,
		105,
		122,
		152,
		-1,
		-1,
		134,
		114,
		-1,
		-1,
		91,
		89,
		78,
		-1,
		68,
		41,
		46,
		71,
		78,
		73,
		67,
		61,
		68,
		67,
		75,
		83,
		131,
		145,
		134,
		130,
		129,
		137,
		86,
		79,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		124,
		120,
		-1,
		-1,
		86,
		79,
		67,
		55,
		45,
		55,
		63,
		63,
		66,
		64,
		59,
		70,
		62,
		66,
		83,
		-1,
		165,
		-1,
		117,
		93,
		107,
		122,
		130,
		-1,
		-1,
		-1,
		141,
		127,
		120,
		108,
		106,
		-1,
		120,
		104,
		85,
		-1,
		55,
		68,
		99,
		67,
		72,
		67,
		65,
		76,
		65,
		68,
		82,
		77,
		-1,
		-1,
		105,
		108,
		-1,
		-1,
		130,
		133,
		-1,
		132,
		121,
		106,
		98,
		-1,
		-1,
		92,
		88,
		-1,
		-1,
		56,
		81,
		70,
		78,
		73,
		69,
		75,
		78,
		67,
		71,
		83,
		-1,
		-1,
		112,
		113,
		118,
		-1,
		116,
		-1,
		134,
		-1,
		101,
		107,
		95,
		-1,
		-1,
		-1,
		94,
		57,
		74,
		88,
		93,
		91,
		82,
		73,
		80,
		78,
		74,
		85,
		-1,
		-1,
		-1,
		134,
		108,
		141,
		132,
		115,
		95,
		87,
		106,
		-1,
		76,
		-1,
		51,
		54,
		79,
		87,
		104,
		98,
		76,
		91,
		81,
		72,
		81,
		140,
		-1,
		110,
		143,
		107,
		101,
		77,
		81,
		97,
		-1,
		73,
		55,
		-1,
		83,
		73,
		121,
		96,
		91,
		78,
		85,
		85,
		78,
		-1,
		-1,
		-1,
		112,
		111,
		103,
		97,
		97,
		82,
		73,
		-1,
		85,
		67,
		46,
		63,
		63,
		54,
		62,
		111,
		107,
		98,
		98,
		86,
		-1,
		213,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		106,
		101,
		74,
		62,
		68,
		64,
		50,
		56,
		58,
		66,
		64,
		61,
		73,
		69,
		89,
		85,
		117,
		-1,
		208,
		-1,
		142,
		-1,
		-1,
		124,
		104,
		96,
		85,
		74,
		72,
		63,
		54,
		76,
		92,
		76,
		74,
		79,
		84,
		-1,
		197,
		196,
		-1,
		143,
		135,
		121,
		-1,
		114,
		-1,
		120,
		81,
		-1,
		83,
		63,
		-1,
		85,
		81,
		-1,
		-1,
		184,
		159,
		-1,
		-1,
		-1,
		144,
		124,
		115,
		99,
		-1,
		74,
		74,
		-1,
		-1,
		-1,
		169,
		168,
		-1,
		137,
		140,
		-1,
		130,
		121,
		129,
		76,
		80,
		-1,
		-1,
		-1,
		178,
		159,
		153,
		152,
		150,
		145,
		142,
		128,
		112,
		90,
		79,
		100,
		-1,
		-1,
		-1,
		150,
		142,
		135,
		-1,
		-1,
		137,
		120,
		101,
		99,
		-1,
		-1,
		-1,
		172,
		153,
		-1,
		-1,
		127,
		-1,
		-1,
		133,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		161,
		-1,
		-1,
		-1,
		123,
		119,
		120,
		-1,
		-1,
		-1,
		-1,
		183,
		184,
		207,
		171,
		-1,
		-1,
		-1,
		115,
		109,
		-1,
		-1,
		186,
		184,
		-1,
		-1,
		-1,
		143,
		127,
		-1,
		113,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		148,
		-1,
		148,
		123,
		130,
		-1,
		-1,
		-1,
		-1,
		161,
		153,
		161,
		-1,
		133,
		135,
		-1,
		183,
		-1,
		-1,
		176,
		167,
		-1,
		-1,
		138,
		145,
		167,
		170,
		206,
		-1,
		157
	],
	[
		-1,
		210,
		199,
		210,
		218,
		191,
		198,
		-1,
		217,
		221,
		187,
		181,
		220,
		189,
		195,
		206,
		-1,
		-1,
		-1,
		210,
		209,
		177,
		175,
		184,
		189,
		196,
		-1,
		195,
		-1,
		231,
		210,
		221,
		226,
		170,
		167,
		187,
		206,
		188,
		180,
		246,
		200,
		171,
		165,
		183,
		173,
		182,
		174,
		-1,
		171,
		161,
		183,
		162,
		173,
		165,
		-1,
		-1,
		165,
		166,
		172,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		155,
		156,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		146,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		150,
		168,
		175,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		149,
		-1,
		159,
		160,
		155,
		163,
		165,
		141,
		128,
		128,
		138,
		131,
		150,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		142,
		159,
		151,
		141,
		156,
		149,
		131,
		128,
		126,
		123,
		139,
		137,
		147,
		-1,
		-1,
		252,
		221,
		250,
		208,
		189,
		-1,
		155,
		135,
		141,
		145,
		139,
		132,
		146,
		142,
		-1,
		117,
		116,
		144,
		130,
		141,
		212,
		-1,
		-1,
		210,
		202,
		185,
		188,
		165,
		161,
		150,
		149,
		141,
		127,
		123,
		129,
		132,
		132,
		138,
		111,
		121,
		125,
		123,
		148,
		-1,
		-1,
		183,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		171,
		177,
		163,
		184,
		160,
		151,
		143,
		137,
		125,
		127,
		124,
		137,
		125,
		108,
		133,
		137,
		118,
		139,
		134,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		200,
		-1,
		172,
		160,
		161,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		122,
		112,
		110,
		140,
		115,
		137,
		134,
		153,
		158,
		152,
		161,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		208,
		209,
		184,
		157,
		160,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		119,
		104,
		119,
		110,
		109,
		127,
		137,
		145,
		149,
		155,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		209,
		201,
		186,
		186,
		-1,
		156,
		153,
		143,
		121,
		106,
		123,
		115,
		113,
		117,
		99,
		113,
		104,
		122,
		129,
		127,
		131,
		151,
		163,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		228,
		192,
		-1,
		187,
		-1,
		158,
		171,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		110,
		95,
		92,
		110,
		113,
		120,
		124,
		140,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		185,
		174,
		173,
		-1,
		164,
		141,
		138,
		126,
		113,
		98,
		99,
		107,
		120,
		99,
		94,
		91,
		111,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		203,
		196,
		184,
		149,
		149,
		143,
		-1,
		137,
		116,
		107,
		96,
		94,
		107,
		104,
		109,
		89,
		87,
		106,
		118,
		109,
		126,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		182,
		168,
		173,
		148,
		141,
		135,
		150,
		133,
		114,
		103,
		95,
		84,
		100,
		108,
		103,
		85,
		94,
		100,
		124,
		114,
		120,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		173,
		186,
		-1,
		140,
		-1,
		129,
		124,
		108,
		103,
		100,
		97,
		91,
		100,
		102,
		92,
		87,
		94,
		129,
		129,
		104,
		124,
		127,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		110,
		106,
		101,
		105,
		98,
		105,
		98,
		96,
		97,
		79,
		111,
		-1,
		112,
		106,
		114,
		104,
		92,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		110,
		108,
		102,
		106,
		103,
		92,
		105,
		98,
		84,
		86,
		99,
		103,
		107,
		94,
		90,
		87,
		101,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		130,
		114,
		117,
		115,
		106,
		114,
		87,
		80,
		87,
		76,
		94,
		102,
		94,
		88,
		87,
		97,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		149,
		165,
		-1,
		158,
		137,
		152,
		130,
		126,
		122,
		137,
		138,
		116,
		115,
		113,
		104,
		92,
		81,
		84,
		76,
		98,
		98,
		82,
		83,
		87,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		120,
		152,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		136,
		134,
		127,
		111,
		118,
		124,
		101,
		96,
		86,
		75,
		75,
		70,
		92,
		78,
		76,
		85,
		101,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		110,
		106,
		113,
		-1,
		121,
		-1,
		94,
		91,
		82,
		67,
		64,
		75,
		73,
		84,
		80,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		189,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		126,
		106,
		98,
		113,
		112,
		99,
		98,
		80,
		73,
		70,
		63,
		76,
		86,
		91,
		78,
		-1,
		-1,
		-1,
		186,
		172,
		176,
		136,
		155,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		135,
		126,
		114,
		104,
		94,
		99,
		100,
		90,
		88,
		78,
		80,
		74,
		65,
		64,
		80,
		72,
		94,
		-1,
		-1,
		169,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		168,
		184,
		154,
		133,
		115,
		-1,
		-1,
		98,
		91,
		85,
		88,
		76,
		94,
		89,
		73,
		58,
		73,
		77,
		85,
		76,
		-1,
		172,
		159,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		166,
		111,
		100,
		95,
		99,
		97,
		-1,
		71,
		82,
		75,
		94,
		101,
		75,
		60,
		54,
		60,
		72,
		81,
		-1,
		-1,
		184,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		88,
		81,
		85,
		-1,
		73,
		75,
		72,
		84,
		78,
		75,
		66,
		57,
		53,
		57,
		61,
		75,
		79,
		207,
		-1,
		151,
		-1,
		-1,
		-1,
		141,
		156,
		127,
		104,
		77,
		72,
		65,
		59,
		64,
		75,
		84,
		95,
		60,
		60,
		50,
		49,
		53,
		70,
		74,
		-1,
		-1,
		149,
		145,
		167,
		149,
		153,
		154,
		-1,
		-1,
		81,
		72,
		63,
		55,
		68,
		71,
		56,
		58,
		48,
		54,
		48,
		58,
		73,
		68,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		151,
		152,
		99,
		81,
		77,
		75,
		64,
		58,
		46,
		51,
		44,
		45,
		46,
		44,
		48,
		71,
		60,
		99,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		135,
		126,
		114,
		111,
		-1,
		81,
		87,
		52,
		59,
		42,
		41,
		43,
		41,
		38,
		45,
		61,
		60,
		55,
		91,
		82,
		88,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		133,
		129,
		119,
		109,
		112,
		-1,
		-1,
		106,
		103,
		83,
		52,
		50,
		43,
		38,
		0,
		24,
		34,
		38,
		42,
		48,
		53,
		58,
		64,
		79,
		94,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		123,
		115,
		126,
		101,
		103,
		-1,
		-1,
		79,
		70,
		71,
		59,
		56,
		62,
		61,
		38,
		45,
		51,
		41,
		40,
		58,
		62,
		71,
		78,
		68,
		81,
		85,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		120,
		-1,
		-1,
		132,
		104,
		88,
		78,
		75,
		118,
		73,
		68,
		48,
		46,
		37,
		28,
		54,
		49,
		49,
		52,
		67,
		72,
		64,
		78,
		78,
		79,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		115,
		-1,
		98,
		102,
		81,
		84,
		62,
		49,
		41,
		51,
		57,
		47,
		57,
		53,
		54,
		63,
		74,
		86,
		85,
		86,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		132,
		171,
		161,
		-1,
		145,
		-1,
		-1,
		-1,
		112,
		94,
		86,
		82,
		61,
		61,
		35,
		39,
		52,
		59,
		69,
		71,
		63,
		67,
		80,
		91,
		94,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		147,
		138,
		165,
		168,
		157,
		152,
		139,
		-1,
		-1,
		133,
		104,
		-1,
		-1,
		68,
		56,
		39,
		41,
		45,
		59,
		71,
		80,
		70,
		68,
		62,
		94,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		166,
		156,
		160,
		176,
		201,
		-1,
		128,
		-1,
		-1,
		113,
		-1,
		-1,
		98,
		61,
		50,
		41,
		47,
		53,
		64,
		86,
		76,
		77,
		67,
		77,
		90,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		132,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		144,
		124,
		-1,
		-1,
		96,
		94,
		83,
		-1,
		73,
		46,
		51,
		76,
		83,
		85,
		79,
		73,
		80,
		79,
		87,
		95,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		134,
		130,
		-1,
		-1,
		91,
		84,
		72,
		60,
		50,
		60,
		68,
		68,
		71,
		76,
		71,
		82,
		74,
		78,
		95,
		-1,
		203,
		-1,
		155,
		131,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		151,
		137,
		130,
		118,
		116,
		-1,
		125,
		109,
		90,
		-1,
		60,
		73,
		104,
		72,
		77,
		72,
		77,
		88,
		77,
		80,
		94,
		89,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		141,
		143,
		-1,
		142,
		131,
		116,
		108,
		-1,
		-1,
		97,
		93,
		-1,
		-1,
		61,
		86,
		75,
		83,
		78,
		81,
		87,
		90,
		79,
		83,
		95,
		-1,
		-1,
		150,
		151,
		148,
		-1,
		126,
		-1,
		144,
		-1,
		111,
		117,
		105,
		-1,
		-1,
		-1,
		99,
		62,
		83,
		93,
		98,
		96,
		87,
		85,
		92,
		90,
		86,
		97,
		-1,
		-1,
		-1,
		144,
		118,
		151,
		142,
		125,
		105,
		97,
		116,
		-1,
		86,
		-1,
		61,
		63,
		89,
		92,
		109,
		103,
		88,
		103,
		93,
		84,
		93,
		150,
		-1,
		120,
		153,
		117,
		111,
		87,
		91,
		107,
		-1,
		83,
		65,
		-1,
		93,
		83,
		126,
		106,
		100,
		87,
		94,
		97,
		90,
		-1,
		-1,
		-1,
		122,
		121,
		113,
		107,
		107,
		92,
		83,
		-1,
		95,
		77,
		56,
		73,
		73,
		64,
		72,
		116,
		112,
		105,
		107,
		96,
		-1,
		223,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		116,
		111,
		84,
		72,
		78,
		74,
		60,
		66,
		68,
		76,
		74,
		71,
		83,
		79,
		99,
		95,
		127,
		-1,
		218,
		-1,
		152,
		-1,
		-1,
		134,
		114,
		106,
		95,
		84,
		82,
		73,
		64,
		86,
		102,
		86,
		84,
		89,
		94,
		-1,
		207,
		206,
		-1,
		153,
		145,
		131,
		-1,
		124,
		-1,
		130,
		91,
		-1,
		93,
		73,
		-1,
		95,
		91,
		-1,
		-1,
		194,
		169,
		-1,
		-1,
		-1,
		154,
		134,
		125,
		109,
		-1,
		84,
		84,
		-1,
		-1,
		-1,
		179,
		178,
		-1,
		147,
		150,
		-1,
		140,
		131,
		139,
		86,
		90,
		-1,
		-1,
		-1,
		188,
		169,
		163,
		162,
		160,
		155,
		152,
		138,
		122,
		100,
		89,
		110,
		-1,
		-1,
		-1,
		160,
		152,
		145,
		-1,
		-1,
		147,
		130,
		111,
		109,
		-1,
		-1,
		-1,
		182,
		163,
		-1,
		-1,
		137,
		-1,
		-1,
		143,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		171,
		-1,
		-1,
		-1,
		133,
		129,
		130,
		-1,
		-1,
		-1,
		-1,
		193,
		194,
		217,
		181,
		-1,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		196,
		194,
		-1,
		-1,
		-1,
		153,
		137,
		-1,
		123,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		158,
		-1,
		158,
		133,
		140,
		-1,
		-1,
		-1,
		-1,
		171,
		163,
		171,
		-1,
		143,
		145,
		-1,
		193,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		148,
		155,
		177,
		180,
		216,
		-1,
		167
	],
	[
		-1,
		188,
		177,
		188,
		196,
		169,
		176,
		-1,
		195,
		199,
		165,
		159,
		198,
		167,
		173,
		184,
		-1,
		-1,
		-1,
		188,
		187,
		155,
		153,
		162,
		167,
		174,
		-1,
		173,
		-1,
		209,
		188,
		199,
		204,
		148,
		145,
		165,
		184,
		166,
		158,
		224,
		178,
		149,
		143,
		161,
		151,
		160,
		152,
		-1,
		149,
		139,
		161,
		140,
		151,
		143,
		-1,
		-1,
		143,
		144,
		150,
		136,
		142,
		138,
		-1,
		148,
		132,
		-1,
		-1,
		133,
		134,
		118,
		121,
		129,
		127,
		140,
		132,
		127,
		-1,
		-1,
		124,
		120,
		127,
		114,
		110,
		127,
		140,
		122,
		136,
		135,
		-1,
		128,
		146,
		153,
		121,
		119,
		103,
		101,
		119,
		121,
		127,
		127,
		-1,
		137,
		138,
		133,
		141,
		143,
		119,
		106,
		106,
		116,
		109,
		128,
		116,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		137,
		120,
		137,
		129,
		119,
		134,
		127,
		109,
		106,
		104,
		101,
		117,
		115,
		125,
		-1,
		-1,
		230,
		199,
		228,
		186,
		167,
		-1,
		133,
		113,
		119,
		123,
		117,
		110,
		124,
		120,
		-1,
		95,
		94,
		122,
		108,
		119,
		190,
		-1,
		-1,
		188,
		180,
		163,
		166,
		143,
		139,
		128,
		127,
		119,
		105,
		101,
		107,
		110,
		110,
		116,
		89,
		99,
		103,
		101,
		126,
		-1,
		-1,
		161,
		-1,
		-1,
		187,
		170,
		-1,
		153,
		160,
		149,
		155,
		141,
		162,
		138,
		129,
		121,
		115,
		103,
		105,
		102,
		115,
		103,
		86,
		111,
		115,
		96,
		117,
		112,
		-1,
		160,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		146,
		149,
		155,
		179,
		178,
		-1,
		150,
		138,
		139,
		124,
		121,
		108,
		96,
		109,
		94,
		101,
		100,
		90,
		88,
		118,
		93,
		115,
		112,
		131,
		136,
		130,
		139,
		-1,
		195,
		191,
		187,
		194,
		143,
		-1,
		-1,
		183,
		-1,
		186,
		187,
		162,
		135,
		138,
		125,
		116,
		103,
		92,
		103,
		92,
		89,
		97,
		82,
		97,
		88,
		87,
		105,
		115,
		123,
		127,
		133,
		-1,
		245,
		-1,
		187,
		171,
		173,
		145,
		166,
		-1,
		203,
		187,
		179,
		164,
		164,
		-1,
		134,
		131,
		121,
		99,
		84,
		101,
		93,
		91,
		95,
		77,
		91,
		82,
		100,
		107,
		105,
		109,
		129,
		141,
		205,
		195,
		-1,
		177,
		182,
		141,
		149,
		168,
		206,
		170,
		-1,
		165,
		-1,
		136,
		149,
		-1,
		105,
		101,
		83,
		84,
		79,
		94,
		88,
		73,
		70,
		88,
		91,
		98,
		102,
		118,
		-1,
		-1,
		190,
		194,
		183,
		134,
		153,
		177,
		214,
		163,
		152,
		151,
		-1,
		142,
		119,
		116,
		104,
		91,
		76,
		77,
		85,
		98,
		77,
		72,
		69,
		89,
		115,
		93,
		105,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		160,
		131,
		155,
		197,
		181,
		174,
		162,
		127,
		127,
		121,
		-1,
		115,
		94,
		85,
		74,
		72,
		85,
		82,
		87,
		67,
		65,
		84,
		96,
		87,
		104,
		-1,
		-1,
		-1,
		190,
		179,
		180,
		126,
		149,
		186,
		160,
		146,
		151,
		126,
		119,
		113,
		128,
		111,
		92,
		81,
		73,
		62,
		78,
		86,
		81,
		63,
		72,
		78,
		102,
		92,
		98,
		-1,
		-1,
		197,
		187,
		171,
		173,
		170,
		140,
		147,
		179,
		151,
		164,
		-1,
		118,
		-1,
		107,
		102,
		86,
		81,
		78,
		75,
		69,
		78,
		80,
		70,
		65,
		72,
		107,
		107,
		82,
		102,
		105,
		-1,
		-1,
		-1,
		190,
		185,
		160,
		137,
		121,
		157,
		-1,
		134,
		135,
		-1,
		112,
		106,
		103,
		88,
		84,
		79,
		83,
		76,
		83,
		76,
		74,
		75,
		57,
		89,
		-1,
		90,
		84,
		92,
		82,
		70,
		-1,
		-1,
		-1,
		183,
		162,
		155,
		175,
		116,
		168,
		-1,
		-1,
		119,
		112,
		-1,
		99,
		81,
		88,
		86,
		80,
		84,
		81,
		70,
		83,
		76,
		62,
		64,
		77,
		81,
		85,
		72,
		68,
		65,
		79,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		136,
		-1,
		128,
		120,
		110,
		104,
		98,
		94,
		92,
		108,
		92,
		95,
		93,
		84,
		92,
		65,
		58,
		65,
		54,
		72,
		80,
		72,
		66,
		65,
		75,
		-1,
		203,
		189,
		160,
		-1,
		-1,
		149,
		-1,
		113,
		127,
		143,
		-1,
		136,
		115,
		130,
		108,
		104,
		100,
		115,
		116,
		93,
		93,
		91,
		82,
		70,
		59,
		62,
		54,
		76,
		76,
		60,
		61,
		65,
		-1,
		209,
		196,
		154,
		150,
		139,
		159,
		110,
		98,
		130,
		-1,
		-1,
		172,
		-1,
		106,
		123,
		114,
		112,
		105,
		87,
		94,
		102,
		79,
		74,
		64,
		53,
		53,
		48,
		70,
		56,
		54,
		63,
		79,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		125,
		112,
		106,
		-1,
		147,
		-1,
		150,
		140,
		124,
		109,
		142,
		-1,
		86,
		82,
		89,
		-1,
		99,
		-1,
		72,
		69,
		60,
		45,
		42,
		53,
		51,
		62,
		58,
		-1,
		159,
		144,
		137,
		127,
		141,
		112,
		-1,
		167,
		-1,
		-1,
		137,
		131,
		131,
		115,
		116,
		102,
		82,
		74,
		89,
		88,
		75,
		74,
		58,
		51,
		48,
		41,
		54,
		64,
		69,
		56,
		-1,
		-1,
		-1,
		164,
		150,
		154,
		114,
		133,
		-1,
		-1,
		199,
		154,
		140,
		-1,
		111,
		102,
		90,
		80,
		70,
		75,
		76,
		66,
		64,
		56,
		58,
		52,
		43,
		42,
		58,
		50,
		72,
		-1,
		-1,
		147,
		152,
		140,
		126,
		145,
		-1,
		-1,
		-1,
		146,
		162,
		130,
		109,
		91,
		-1,
		-1,
		74,
		67,
		61,
		64,
		52,
		72,
		67,
		51,
		36,
		51,
		55,
		63,
		54,
		-1,
		150,
		137,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		-1,
		-1,
		142,
		87,
		76,
		71,
		75,
		73,
		-1,
		47,
		58,
		51,
		70,
		77,
		53,
		38,
		32,
		38,
		50,
		59,
		-1,
		-1,
		162,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		99,
		93,
		64,
		57,
		61,
		-1,
		49,
		51,
		48,
		60,
		56,
		53,
		44,
		35,
		31,
		35,
		39,
		53,
		57,
		185,
		-1,
		127,
		-1,
		-1,
		-1,
		117,
		132,
		103,
		80,
		53,
		48,
		41,
		35,
		40,
		51,
		60,
		71,
		36,
		38,
		28,
		27,
		31,
		48,
		52,
		-1,
		-1,
		125,
		121,
		143,
		125,
		129,
		130,
		-1,
		-1,
		57,
		48,
		39,
		31,
		44,
		47,
		32,
		34,
		34,
		32,
		26,
		36,
		51,
		46,
		-1,
		-1,
		-1,
		137,
		-1,
		139,
		-1,
		-1,
		127,
		128,
		75,
		57,
		53,
		51,
		40,
		34,
		22,
		27,
		37,
		31,
		28,
		22,
		26,
		49,
		38,
		77,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		116,
		108,
		103,
		109,
		111,
		102,
		90,
		87,
		-1,
		57,
		63,
		28,
		35,
		18,
		25,
		30,
		27,
		16,
		23,
		39,
		38,
		33,
		69,
		60,
		66,
		-1,
		-1,
		202,
		191,
		180,
		186,
		-1,
		109,
		105,
		95,
		85,
		88,
		-1,
		-1,
		82,
		79,
		59,
		28,
		26,
		19,
		14,
		24,
		0,
		12,
		16,
		20,
		26,
		31,
		36,
		42,
		57,
		72,
		-1,
		156,
		193,
		186,
		154,
		162,
		193,
		-1,
		99,
		91,
		102,
		77,
		79,
		-1,
		-1,
		55,
		46,
		47,
		35,
		32,
		38,
		37,
		20,
		26,
		27,
		19,
		18,
		36,
		40,
		49,
		56,
		46,
		59,
		63,
		-1,
		149,
		169,
		148,
		151,
		175,
		189,
		-1,
		96,
		-1,
		-1,
		108,
		80,
		64,
		54,
		51,
		94,
		49,
		44,
		29,
		27,
		18,
		9,
		34,
		27,
		27,
		30,
		45,
		50,
		42,
		56,
		56,
		57,
		-1,
		138,
		149,
		142,
		-1,
		-1,
		-1,
		-1,
		97,
		-1,
		-1,
		124,
		-1,
		91,
		-1,
		74,
		78,
		57,
		60,
		43,
		30,
		22,
		32,
		38,
		25,
		35,
		31,
		32,
		41,
		52,
		64,
		63,
		64,
		163,
		119,
		122,
		133,
		144,
		159,
		163,
		-1,
		108,
		147,
		137,
		-1,
		121,
		-1,
		-1,
		-1,
		88,
		70,
		62,
		63,
		42,
		42,
		16,
		20,
		30,
		37,
		47,
		49,
		41,
		45,
		58,
		69,
		72,
		159,
		150,
		163,
		108,
		108,
		129,
		138,
		159,
		123,
		114,
		141,
		144,
		133,
		128,
		115,
		-1,
		-1,
		111,
		80,
		-1,
		-1,
		49,
		37,
		20,
		22,
		26,
		40,
		52,
		58,
		48,
		46,
		40,
		72,
		-1,
		152,
		151,
		140,
		137,
		113,
		104,
		99,
		126,
		-1,
		-1,
		121,
		142,
		132,
		136,
		152,
		177,
		-1,
		104,
		-1,
		-1,
		94,
		-1,
		-1,
		79,
		42,
		31,
		22,
		28,
		34,
		45,
		66,
		54,
		55,
		45,
		55,
		68,
		136,
		133,
		121,
		119,
		142,
		107,
		95,
		-1,
		108,
		106,
		112,
		119,
		136,
		166,
		-1,
		-1,
		120,
		100,
		-1,
		-1,
		77,
		75,
		64,
		-1,
		54,
		27,
		32,
		57,
		64,
		63,
		57,
		51,
		58,
		57,
		65,
		73,
		145,
		159,
		148,
		144,
		143,
		151,
		100,
		93,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		-1,
		110,
		106,
		-1,
		-1,
		72,
		65,
		53,
		41,
		31,
		41,
		49,
		49,
		52,
		54,
		49,
		60,
		52,
		56,
		73,
		-1,
		179,
		-1,
		131,
		107,
		121,
		136,
		144,
		-1,
		-1,
		-1,
		127,
		113,
		106,
		94,
		92,
		-1,
		106,
		90,
		71,
		-1,
		41,
		54,
		85,
		53,
		58,
		53,
		55,
		66,
		55,
		58,
		72,
		67,
		-1,
		-1,
		119,
		122,
		-1,
		-1,
		117,
		119,
		-1,
		118,
		107,
		92,
		84,
		-1,
		-1,
		78,
		74,
		-1,
		-1,
		42,
		67,
		56,
		64,
		59,
		59,
		65,
		68,
		57,
		61,
		73,
		-1,
		-1,
		126,
		127,
		124,
		-1,
		102,
		-1,
		120,
		-1,
		87,
		93,
		81,
		-1,
		-1,
		-1,
		80,
		43,
		60,
		74,
		79,
		77,
		68,
		63,
		70,
		68,
		64,
		75,
		-1,
		-1,
		-1,
		120,
		94,
		127,
		118,
		101,
		81,
		73,
		92,
		-1,
		62,
		-1,
		37,
		40,
		65,
		73,
		90,
		84,
		66,
		81,
		71,
		62,
		71,
		126,
		-1,
		96,
		129,
		93,
		87,
		63,
		67,
		83,
		-1,
		59,
		41,
		-1,
		69,
		59,
		107,
		82,
		81,
		68,
		75,
		75,
		68,
		-1,
		-1,
		-1,
		98,
		97,
		89,
		83,
		83,
		68,
		59,
		-1,
		71,
		53,
		32,
		49,
		49,
		40,
		48,
		97,
		93,
		86,
		88,
		72,
		-1,
		199,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		92,
		87,
		60,
		48,
		54,
		50,
		36,
		42,
		44,
		52,
		50,
		47,
		59,
		55,
		75,
		71,
		103,
		-1,
		194,
		-1,
		128,
		-1,
		-1,
		110,
		90,
		82,
		71,
		60,
		58,
		49,
		40,
		62,
		78,
		62,
		60,
		65,
		70,
		-1,
		183,
		182,
		-1,
		129,
		121,
		107,
		-1,
		100,
		-1,
		106,
		67,
		-1,
		69,
		49,
		-1,
		71,
		67,
		-1,
		-1,
		170,
		145,
		-1,
		-1,
		-1,
		130,
		110,
		101,
		85,
		-1,
		60,
		60,
		-1,
		-1,
		-1,
		155,
		154,
		-1,
		123,
		126,
		-1,
		116,
		107,
		115,
		62,
		66,
		-1,
		-1,
		-1,
		164,
		145,
		139,
		138,
		136,
		131,
		128,
		114,
		98,
		76,
		65,
		86,
		-1,
		-1,
		-1,
		136,
		128,
		121,
		-1,
		-1,
		123,
		106,
		87,
		85,
		-1,
		-1,
		-1,
		158,
		139,
		-1,
		-1,
		113,
		-1,
		-1,
		119,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		147,
		-1,
		-1,
		-1,
		109,
		105,
		106,
		-1,
		-1,
		-1,
		-1,
		169,
		170,
		193,
		157,
		-1,
		-1,
		-1,
		101,
		95,
		-1,
		-1,
		172,
		170,
		-1,
		-1,
		-1,
		129,
		113,
		-1,
		99,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		134,
		-1,
		134,
		109,
		116,
		-1,
		-1,
		-1,
		-1,
		147,
		139,
		147,
		-1,
		119,
		121,
		-1,
		169,
		-1,
		-1,
		162,
		153,
		-1,
		-1,
		124,
		131,
		153,
		156,
		192,
		-1,
		143
	],
	[
		-1,
		176,
		165,
		176,
		184,
		157,
		164,
		-1,
		183,
		187,
		153,
		147,
		186,
		155,
		161,
		172,
		-1,
		-1,
		-1,
		176,
		175,
		143,
		141,
		150,
		155,
		162,
		-1,
		161,
		-1,
		197,
		176,
		187,
		192,
		136,
		133,
		153,
		172,
		154,
		146,
		212,
		166,
		137,
		131,
		149,
		139,
		148,
		140,
		-1,
		137,
		127,
		149,
		128,
		139,
		131,
		-1,
		-1,
		131,
		132,
		138,
		124,
		130,
		126,
		-1,
		136,
		120,
		-1,
		-1,
		121,
		122,
		106,
		109,
		117,
		115,
		128,
		120,
		115,
		-1,
		-1,
		112,
		108,
		115,
		102,
		98,
		115,
		128,
		110,
		124,
		123,
		-1,
		116,
		134,
		141,
		109,
		107,
		91,
		89,
		107,
		109,
		115,
		115,
		-1,
		125,
		126,
		121,
		129,
		131,
		107,
		94,
		94,
		104,
		97,
		116,
		104,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		125,
		108,
		125,
		117,
		107,
		122,
		115,
		97,
		94,
		92,
		89,
		105,
		103,
		113,
		-1,
		-1,
		218,
		187,
		216,
		174,
		155,
		-1,
		121,
		101,
		107,
		111,
		105,
		98,
		112,
		108,
		-1,
		83,
		82,
		110,
		96,
		107,
		178,
		-1,
		-1,
		176,
		168,
		151,
		154,
		131,
		127,
		116,
		115,
		107,
		93,
		89,
		95,
		98,
		98,
		104,
		77,
		87,
		91,
		89,
		114,
		-1,
		-1,
		149,
		-1,
		-1,
		175,
		158,
		-1,
		141,
		148,
		137,
		143,
		129,
		150,
		126,
		117,
		109,
		103,
		91,
		93,
		90,
		103,
		91,
		74,
		99,
		103,
		84,
		105,
		100,
		-1,
		148,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		134,
		137,
		143,
		167,
		166,
		-1,
		138,
		126,
		127,
		112,
		109,
		96,
		84,
		97,
		82,
		89,
		88,
		78,
		76,
		106,
		81,
		103,
		100,
		119,
		124,
		118,
		127,
		-1,
		183,
		179,
		175,
		182,
		131,
		-1,
		-1,
		171,
		-1,
		174,
		175,
		150,
		123,
		126,
		113,
		104,
		91,
		80,
		91,
		80,
		77,
		85,
		70,
		85,
		76,
		75,
		93,
		103,
		111,
		115,
		121,
		-1,
		233,
		-1,
		175,
		159,
		161,
		133,
		154,
		-1,
		191,
		175,
		167,
		152,
		152,
		-1,
		122,
		119,
		109,
		87,
		72,
		89,
		81,
		79,
		83,
		65,
		79,
		70,
		88,
		95,
		93,
		97,
		117,
		129,
		193,
		183,
		-1,
		165,
		170,
		129,
		137,
		156,
		194,
		158,
		-1,
		153,
		-1,
		124,
		137,
		-1,
		93,
		89,
		71,
		72,
		67,
		82,
		76,
		61,
		58,
		76,
		79,
		86,
		90,
		106,
		-1,
		-1,
		178,
		182,
		171,
		122,
		141,
		165,
		202,
		151,
		140,
		139,
		-1,
		130,
		107,
		104,
		92,
		79,
		64,
		65,
		73,
		86,
		65,
		60,
		57,
		77,
		103,
		81,
		93,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		148,
		119,
		143,
		185,
		169,
		162,
		150,
		115,
		115,
		109,
		-1,
		103,
		82,
		73,
		62,
		60,
		73,
		70,
		75,
		55,
		53,
		72,
		84,
		75,
		92,
		-1,
		-1,
		-1,
		178,
		167,
		168,
		114,
		137,
		174,
		148,
		134,
		139,
		114,
		107,
		101,
		116,
		99,
		80,
		69,
		61,
		50,
		66,
		74,
		69,
		51,
		60,
		66,
		90,
		80,
		86,
		-1,
		-1,
		185,
		175,
		159,
		161,
		158,
		128,
		135,
		167,
		139,
		152,
		-1,
		106,
		-1,
		95,
		90,
		74,
		69,
		66,
		63,
		57,
		66,
		68,
		58,
		53,
		60,
		95,
		95,
		70,
		90,
		93,
		-1,
		-1,
		-1,
		178,
		173,
		148,
		125,
		109,
		145,
		-1,
		122,
		123,
		-1,
		100,
		94,
		91,
		76,
		72,
		67,
		71,
		64,
		71,
		64,
		62,
		63,
		45,
		77,
		-1,
		78,
		72,
		80,
		70,
		58,
		-1,
		-1,
		-1,
		171,
		150,
		143,
		163,
		104,
		156,
		-1,
		-1,
		107,
		100,
		-1,
		87,
		69,
		76,
		74,
		68,
		72,
		69,
		58,
		71,
		64,
		50,
		52,
		65,
		69,
		73,
		60,
		56,
		53,
		67,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		124,
		-1,
		116,
		108,
		98,
		92,
		86,
		82,
		80,
		96,
		80,
		83,
		81,
		72,
		80,
		53,
		46,
		53,
		42,
		60,
		68,
		60,
		54,
		53,
		63,
		-1,
		191,
		177,
		148,
		-1,
		-1,
		137,
		-1,
		101,
		115,
		131,
		-1,
		124,
		103,
		118,
		96,
		92,
		88,
		103,
		104,
		82,
		81,
		79,
		70,
		58,
		47,
		50,
		42,
		64,
		64,
		48,
		49,
		53,
		-1,
		197,
		184,
		142,
		138,
		127,
		147,
		98,
		86,
		118,
		-1,
		-1,
		160,
		-1,
		94,
		111,
		102,
		100,
		93,
		84,
		90,
		90,
		67,
		62,
		52,
		41,
		41,
		36,
		58,
		44,
		42,
		51,
		67,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		113,
		100,
		94,
		-1,
		135,
		-1,
		138,
		128,
		112,
		97,
		130,
		-1,
		95,
		85,
		90,
		-1,
		87,
		-1,
		60,
		57,
		48,
		33,
		30,
		41,
		39,
		50,
		46,
		-1,
		147,
		132,
		125,
		115,
		129,
		100,
		-1,
		155,
		-1,
		-1,
		125,
		119,
		119,
		103,
		106,
		111,
		91,
		83,
		90,
		82,
		74,
		68,
		46,
		39,
		36,
		29,
		42,
		52,
		57,
		44,
		-1,
		-1,
		-1,
		152,
		138,
		142,
		102,
		121,
		-1,
		-1,
		187,
		142,
		128,
		-1,
		112,
		111,
		99,
		89,
		79,
		84,
		85,
		65,
		58,
		44,
		46,
		40,
		31,
		30,
		46,
		38,
		60,
		-1,
		-1,
		135,
		140,
		128,
		114,
		133,
		-1,
		-1,
		-1,
		134,
		150,
		139,
		113,
		100,
		-1,
		-1,
		83,
		76,
		70,
		61,
		48,
		60,
		55,
		39,
		24,
		39,
		43,
		51,
		42,
		-1,
		138,
		125,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		-1,
		-1,
		151,
		96,
		85,
		80,
		84,
		82,
		-1,
		56,
		67,
		52,
		64,
		71,
		41,
		26,
		20,
		26,
		38,
		47,
		-1,
		-1,
		150,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		108,
		102,
		73,
		66,
		70,
		-1,
		58,
		60,
		54,
		69,
		44,
		41,
		32,
		23,
		19,
		23,
		27,
		41,
		45,
		173,
		-1,
		136,
		-1,
		-1,
		-1,
		126,
		141,
		112,
		89,
		62,
		57,
		50,
		44,
		49,
		60,
		52,
		63,
		30,
		26,
		16,
		15,
		19,
		36,
		40,
		-1,
		-1,
		134,
		130,
		152,
		134,
		138,
		139,
		-1,
		-1,
		66,
		57,
		48,
		40,
		53,
		56,
		36,
		33,
		27,
		20,
		14,
		24,
		39,
		34,
		-1,
		-1,
		-1,
		146,
		-1,
		148,
		-1,
		-1,
		136,
		137,
		84,
		66,
		62,
		60,
		49,
		43,
		31,
		36,
		39,
		30,
		22,
		10,
		14,
		37,
		26,
		65,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		125,
		117,
		112,
		118,
		120,
		111,
		99,
		96,
		-1,
		66,
		72,
		37,
		44,
		27,
		34,
		34,
		26,
		4,
		11,
		27,
		26,
		21,
		57,
		48,
		54,
		-1,
		-1,
		211,
		200,
		189,
		195,
		-1,
		118,
		114,
		104,
		94,
		97,
		-1,
		-1,
		91,
		88,
		68,
		37,
		35,
		28,
		23,
		33,
		13,
		0,
		4,
		8,
		14,
		19,
		24,
		30,
		45,
		60,
		-1,
		165,
		202,
		195,
		163,
		171,
		202,
		-1,
		108,
		100,
		111,
		86,
		88,
		-1,
		-1,
		64,
		55,
		56,
		44,
		41,
		43,
		38,
		29,
		14,
		20,
		7,
		6,
		24,
		28,
		37,
		44,
		34,
		47,
		51,
		-1,
		158,
		178,
		157,
		160,
		184,
		198,
		-1,
		105,
		-1,
		-1,
		117,
		89,
		73,
		63,
		60,
		103,
		58,
		53,
		37,
		35,
		26,
		17,
		24,
		15,
		15,
		18,
		33,
		38,
		30,
		44,
		44,
		45,
		-1,
		147,
		158,
		151,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		133,
		-1,
		100,
		-1,
		83,
		87,
		66,
		69,
		51,
		38,
		30,
		22,
		38,
		13,
		23,
		19,
		20,
		29,
		40,
		52,
		51,
		52,
		172,
		128,
		131,
		142,
		153,
		168,
		172,
		-1,
		117,
		156,
		150,
		-1,
		134,
		-1,
		-1,
		-1,
		97,
		79,
		71,
		71,
		50,
		50,
		24,
		28,
		18,
		25,
		35,
		37,
		29,
		33,
		46,
		57,
		60,
		168,
		159,
		172,
		117,
		117,
		138,
		147,
		168,
		132,
		123,
		150,
		157,
		146,
		141,
		128,
		-1,
		-1,
		120,
		89,
		-1,
		-1,
		57,
		45,
		28,
		29,
		25,
		28,
		43,
		46,
		36,
		34,
		28,
		60,
		-1,
		161,
		160,
		149,
		146,
		122,
		113,
		108,
		135,
		-1,
		-1,
		130,
		151,
		141,
		145,
		161,
		186,
		-1,
		117,
		-1,
		-1,
		102,
		-1,
		-1,
		87,
		50,
		39,
		30,
		36,
		33,
		44,
		54,
		42,
		43,
		33,
		43,
		56,
		145,
		142,
		130,
		128,
		151,
		116,
		104,
		-1,
		117,
		115,
		121,
		128,
		145,
		175,
		-1,
		-1,
		133,
		113,
		-1,
		-1,
		85,
		83,
		72,
		-1,
		62,
		35,
		40,
		60,
		62,
		51,
		45,
		39,
		46,
		45,
		53,
		61,
		154,
		168,
		157,
		153,
		152,
		160,
		109,
		102,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		123,
		119,
		-1,
		-1,
		80,
		73,
		61,
		49,
		39,
		49,
		53,
		57,
		49,
		42,
		37,
		48,
		40,
		44,
		61,
		-1,
		188,
		-1,
		140,
		116,
		130,
		145,
		153,
		-1,
		-1,
		-1,
		140,
		126,
		119,
		107,
		105,
		-1,
		114,
		98,
		79,
		-1,
		49,
		62,
		93,
		61,
		66,
		61,
		43,
		54,
		43,
		46,
		60,
		55,
		-1,
		-1,
		128,
		131,
		-1,
		-1,
		130,
		132,
		-1,
		131,
		120,
		105,
		97,
		-1,
		-1,
		86,
		82,
		-1,
		-1,
		50,
		75,
		64,
		72,
		67,
		47,
		53,
		56,
		45,
		49,
		61,
		-1,
		-1,
		135,
		136,
		137,
		-1,
		115,
		-1,
		133,
		-1,
		100,
		106,
		94,
		-1,
		-1,
		-1,
		88,
		51,
		72,
		82,
		76,
		74,
		65,
		51,
		58,
		56,
		52,
		63,
		-1,
		-1,
		-1,
		133,
		107,
		140,
		131,
		114,
		94,
		86,
		105,
		-1,
		75,
		-1,
		50,
		52,
		78,
		81,
		87,
		81,
		54,
		69,
		59,
		50,
		59,
		139,
		-1,
		109,
		142,
		106,
		100,
		76,
		80,
		96,
		-1,
		72,
		54,
		-1,
		82,
		72,
		103,
		88,
		69,
		56,
		63,
		63,
		56,
		-1,
		-1,
		-1,
		111,
		110,
		102,
		96,
		96,
		81,
		72,
		-1,
		84,
		66,
		45,
		62,
		62,
		53,
		61,
		93,
		89,
		76,
		76,
		68,
		-1,
		212,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		105,
		100,
		73,
		61,
		67,
		63,
		49,
		55,
		57,
		65,
		63,
		60,
		72,
		68,
		88,
		69,
		104,
		-1,
		207,
		-1,
		141,
		-1,
		-1,
		123,
		103,
		95,
		84,
		73,
		71,
		62,
		53,
		75,
		91,
		75,
		73,
		76,
		77,
		-1,
		196,
		195,
		-1,
		142,
		134,
		120,
		-1,
		113,
		-1,
		119,
		80,
		-1,
		82,
		62,
		-1,
		84,
		80,
		-1,
		-1,
		183,
		158,
		-1,
		-1,
		-1,
		143,
		123,
		114,
		98,
		-1,
		73,
		73,
		-1,
		-1,
		-1,
		168,
		167,
		-1,
		136,
		139,
		-1,
		129,
		120,
		128,
		75,
		79,
		-1,
		-1,
		-1,
		177,
		158,
		152,
		151,
		149,
		144,
		141,
		127,
		111,
		89,
		78,
		99,
		-1,
		-1,
		-1,
		149,
		141,
		134,
		-1,
		-1,
		136,
		119,
		100,
		98,
		-1,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		126,
		-1,
		-1,
		132,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		160,
		-1,
		-1,
		-1,
		122,
		118,
		119,
		-1,
		-1,
		-1,
		-1,
		182,
		183,
		206,
		170,
		-1,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		185,
		183,
		-1,
		-1,
		-1,
		142,
		126,
		-1,
		112,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		147,
		-1,
		147,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		160,
		152,
		160,
		-1,
		132,
		134,
		-1,
		182,
		-1,
		-1,
		175,
		166,
		-1,
		-1,
		137,
		144,
		166,
		169,
		205,
		-1,
		156
	],
	[
		-1,
		182,
		171,
		182,
		190,
		163,
		170,
		-1,
		189,
		193,
		159,
		153,
		192,
		161,
		167,
		178,
		-1,
		-1,
		-1,
		182,
		181,
		149,
		147,
		156,
		161,
		168,
		-1,
		167,
		-1,
		203,
		182,
		193,
		198,
		142,
		139,
		159,
		178,
		160,
		152,
		218,
		172,
		143,
		137,
		155,
		145,
		154,
		146,
		-1,
		143,
		133,
		155,
		134,
		145,
		137,
		-1,
		-1,
		137,
		138,
		144,
		130,
		136,
		132,
		-1,
		142,
		126,
		-1,
		-1,
		127,
		128,
		112,
		115,
		123,
		121,
		134,
		126,
		121,
		-1,
		-1,
		118,
		114,
		121,
		108,
		104,
		121,
		134,
		116,
		130,
		129,
		-1,
		122,
		140,
		147,
		115,
		113,
		97,
		95,
		113,
		115,
		121,
		121,
		-1,
		131,
		132,
		127,
		135,
		137,
		113,
		100,
		100,
		110,
		103,
		122,
		110,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		131,
		114,
		131,
		123,
		113,
		128,
		121,
		103,
		100,
		98,
		95,
		111,
		109,
		119,
		-1,
		-1,
		224,
		193,
		222,
		180,
		161,
		-1,
		127,
		107,
		113,
		117,
		111,
		104,
		118,
		114,
		-1,
		89,
		88,
		116,
		102,
		113,
		184,
		-1,
		-1,
		182,
		174,
		157,
		160,
		137,
		133,
		122,
		121,
		113,
		99,
		95,
		101,
		104,
		104,
		110,
		83,
		93,
		97,
		95,
		120,
		-1,
		-1,
		155,
		-1,
		-1,
		181,
		164,
		-1,
		147,
		154,
		143,
		149,
		135,
		156,
		132,
		123,
		115,
		109,
		97,
		99,
		96,
		109,
		97,
		80,
		105,
		109,
		90,
		111,
		106,
		-1,
		154,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		140,
		143,
		149,
		173,
		172,
		-1,
		144,
		132,
		133,
		118,
		115,
		102,
		90,
		103,
		88,
		95,
		94,
		84,
		82,
		112,
		87,
		109,
		106,
		125,
		130,
		124,
		133,
		-1,
		189,
		185,
		181,
		188,
		137,
		-1,
		-1,
		177,
		-1,
		180,
		181,
		156,
		129,
		132,
		119,
		110,
		97,
		86,
		97,
		86,
		83,
		91,
		76,
		91,
		82,
		81,
		99,
		109,
		117,
		121,
		127,
		-1,
		239,
		-1,
		181,
		165,
		167,
		139,
		160,
		-1,
		197,
		181,
		173,
		158,
		158,
		-1,
		128,
		125,
		115,
		93,
		78,
		95,
		87,
		85,
		89,
		71,
		85,
		76,
		94,
		101,
		99,
		103,
		123,
		135,
		199,
		189,
		-1,
		171,
		176,
		135,
		143,
		162,
		200,
		164,
		-1,
		159,
		-1,
		130,
		143,
		-1,
		99,
		95,
		77,
		78,
		73,
		88,
		82,
		67,
		64,
		82,
		85,
		92,
		96,
		112,
		-1,
		-1,
		184,
		188,
		177,
		128,
		147,
		171,
		208,
		157,
		146,
		145,
		-1,
		136,
		113,
		110,
		98,
		85,
		70,
		71,
		79,
		92,
		71,
		66,
		63,
		83,
		109,
		87,
		99,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		154,
		125,
		149,
		191,
		175,
		168,
		156,
		121,
		121,
		115,
		-1,
		109,
		88,
		79,
		68,
		66,
		79,
		76,
		81,
		61,
		59,
		78,
		90,
		81,
		98,
		-1,
		-1,
		-1,
		184,
		173,
		174,
		120,
		143,
		180,
		154,
		140,
		145,
		120,
		113,
		107,
		122,
		105,
		86,
		75,
		67,
		56,
		72,
		80,
		75,
		57,
		66,
		72,
		96,
		86,
		92,
		-1,
		-1,
		191,
		181,
		165,
		167,
		164,
		134,
		141,
		173,
		145,
		158,
		-1,
		112,
		-1,
		101,
		96,
		80,
		75,
		72,
		69,
		63,
		72,
		74,
		64,
		59,
		66,
		101,
		101,
		76,
		96,
		99,
		-1,
		-1,
		-1,
		184,
		179,
		154,
		131,
		115,
		151,
		-1,
		128,
		129,
		-1,
		106,
		100,
		97,
		82,
		78,
		73,
		77,
		70,
		77,
		70,
		68,
		69,
		51,
		83,
		-1,
		84,
		78,
		86,
		76,
		64,
		-1,
		-1,
		-1,
		177,
		156,
		149,
		169,
		110,
		162,
		-1,
		-1,
		113,
		106,
		-1,
		93,
		75,
		82,
		80,
		74,
		78,
		75,
		64,
		77,
		70,
		56,
		58,
		71,
		75,
		79,
		66,
		62,
		59,
		73,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		130,
		-1,
		122,
		114,
		104,
		98,
		92,
		88,
		86,
		102,
		86,
		89,
		87,
		78,
		86,
		59,
		52,
		59,
		48,
		66,
		74,
		66,
		60,
		59,
		69,
		-1,
		197,
		183,
		154,
		-1,
		-1,
		143,
		-1,
		107,
		121,
		137,
		-1,
		130,
		109,
		124,
		102,
		98,
		94,
		109,
		110,
		88,
		87,
		85,
		76,
		64,
		53,
		56,
		48,
		70,
		70,
		54,
		55,
		59,
		-1,
		203,
		190,
		148,
		144,
		133,
		153,
		104,
		92,
		124,
		-1,
		-1,
		166,
		-1,
		100,
		117,
		108,
		106,
		99,
		90,
		96,
		96,
		73,
		68,
		58,
		47,
		47,
		42,
		64,
		50,
		48,
		57,
		73,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		119,
		106,
		100,
		-1,
		141,
		-1,
		144,
		134,
		118,
		103,
		136,
		-1,
		101,
		91,
		96,
		-1,
		93,
		-1,
		66,
		63,
		54,
		39,
		36,
		47,
		45,
		56,
		52,
		-1,
		153,
		138,
		131,
		121,
		135,
		106,
		-1,
		161,
		-1,
		-1,
		131,
		125,
		125,
		109,
		112,
		117,
		97,
		89,
		96,
		88,
		80,
		74,
		52,
		45,
		42,
		35,
		48,
		58,
		63,
		50,
		-1,
		-1,
		-1,
		158,
		144,
		148,
		108,
		127,
		-1,
		-1,
		193,
		148,
		134,
		-1,
		118,
		117,
		105,
		95,
		85,
		90,
		91,
		71,
		64,
		50,
		52,
		46,
		37,
		36,
		52,
		44,
		66,
		-1,
		-1,
		141,
		146,
		134,
		120,
		139,
		-1,
		-1,
		-1,
		140,
		156,
		145,
		119,
		106,
		-1,
		-1,
		89,
		82,
		76,
		67,
		54,
		66,
		61,
		45,
		30,
		45,
		49,
		57,
		48,
		-1,
		144,
		131,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		157,
		102,
		91,
		86,
		90,
		88,
		-1,
		62,
		73,
		58,
		70,
		77,
		47,
		32,
		26,
		32,
		44,
		53,
		-1,
		-1,
		156,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		79,
		72,
		76,
		-1,
		64,
		66,
		60,
		75,
		50,
		47,
		38,
		29,
		25,
		29,
		33,
		42,
		48,
		179,
		-1,
		142,
		-1,
		-1,
		-1,
		132,
		147,
		118,
		95,
		68,
		63,
		56,
		50,
		55,
		66,
		58,
		69,
		36,
		32,
		22,
		21,
		25,
		42,
		36,
		-1,
		-1,
		140,
		136,
		158,
		140,
		144,
		145,
		-1,
		-1,
		72,
		63,
		54,
		46,
		59,
		62,
		42,
		39,
		33,
		26,
		20,
		30,
		35,
		30,
		-1,
		-1,
		-1,
		152,
		-1,
		154,
		-1,
		-1,
		142,
		143,
		90,
		72,
		68,
		66,
		55,
		49,
		37,
		42,
		45,
		35,
		27,
		16,
		10,
		33,
		22,
		61,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		131,
		123,
		118,
		124,
		126,
		117,
		105,
		102,
		-1,
		72,
		78,
		43,
		50,
		33,
		40,
		39,
		31,
		10,
		7,
		23,
		22,
		17,
		53,
		44,
		50,
		-1,
		-1,
		217,
		206,
		195,
		201,
		-1,
		124,
		120,
		110,
		100,
		103,
		-1,
		-1,
		97,
		94,
		74,
		43,
		41,
		34,
		29,
		39,
		19,
		6,
		0,
		4,
		10,
		15,
		20,
		26,
		41,
		56,
		-1,
		171,
		208,
		201,
		169,
		177,
		208,
		-1,
		114,
		106,
		117,
		92,
		94,
		-1,
		-1,
		70,
		61,
		62,
		50,
		47,
		49,
		44,
		35,
		20,
		26,
		13,
		2,
		20,
		24,
		33,
		40,
		30,
		43,
		47,
		-1,
		164,
		184,
		163,
		166,
		190,
		204,
		-1,
		111,
		-1,
		-1,
		123,
		95,
		79,
		69,
		66,
		109,
		64,
		59,
		43,
		41,
		32,
		23,
		30,
		17,
		11,
		14,
		32,
		37,
		29,
		40,
		40,
		41,
		-1,
		153,
		164,
		157,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		139,
		-1,
		106,
		-1,
		89,
		93,
		72,
		75,
		57,
		44,
		36,
		28,
		44,
		19,
		19,
		15,
		19,
		28,
		39,
		51,
		47,
		48,
		178,
		134,
		137,
		148,
		159,
		174,
		178,
		-1,
		123,
		162,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		103,
		85,
		77,
		77,
		56,
		56,
		30,
		34,
		24,
		24,
		31,
		33,
		28,
		32,
		45,
		56,
		56,
		174,
		165,
		178,
		123,
		123,
		144,
		153,
		174,
		138,
		129,
		156,
		163,
		152,
		147,
		134,
		-1,
		-1,
		126,
		95,
		-1,
		-1,
		63,
		51,
		34,
		35,
		31,
		34,
		49,
		42,
		35,
		33,
		27,
		59,
		-1,
		167,
		166,
		155,
		152,
		128,
		119,
		114,
		141,
		-1,
		-1,
		136,
		157,
		147,
		151,
		167,
		192,
		-1,
		123,
		-1,
		-1,
		108,
		-1,
		-1,
		93,
		56,
		45,
		36,
		42,
		39,
		50,
		60,
		41,
		42,
		32,
		42,
		55,
		151,
		148,
		136,
		134,
		157,
		122,
		110,
		-1,
		123,
		121,
		127,
		134,
		151,
		181,
		-1,
		-1,
		139,
		119,
		-1,
		-1,
		91,
		89,
		78,
		-1,
		68,
		41,
		46,
		66,
		61,
		50,
		44,
		38,
		45,
		44,
		52,
		60,
		160,
		174,
		163,
		159,
		158,
		166,
		115,
		108,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		125,
		-1,
		-1,
		86,
		79,
		67,
		55,
		45,
		55,
		59,
		62,
		48,
		41,
		36,
		47,
		39,
		43,
		60,
		-1,
		194,
		-1,
		146,
		122,
		136,
		151,
		159,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		120,
		104,
		85,
		-1,
		55,
		68,
		98,
		66,
		66,
		60,
		42,
		53,
		42,
		45,
		59,
		54,
		-1,
		-1,
		134,
		137,
		-1,
		-1,
		136,
		138,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		92,
		88,
		-1,
		-1,
		56,
		80,
		69,
		72,
		67,
		46,
		52,
		55,
		44,
		48,
		60,
		-1,
		-1,
		141,
		142,
		143,
		-1,
		121,
		-1,
		139,
		-1,
		106,
		112,
		100,
		-1,
		-1,
		-1,
		94,
		57,
		78,
		87,
		75,
		73,
		64,
		50,
		57,
		55,
		51,
		62,
		-1,
		-1,
		-1,
		139,
		113,
		146,
		137,
		120,
		100,
		92,
		111,
		-1,
		81,
		-1,
		56,
		58,
		84,
		83,
		86,
		80,
		53,
		68,
		58,
		49,
		58,
		145,
		-1,
		115,
		148,
		112,
		106,
		82,
		86,
		102,
		-1,
		78,
		60,
		-1,
		88,
		78,
		102,
		87,
		68,
		55,
		62,
		62,
		55,
		-1,
		-1,
		-1,
		117,
		116,
		108,
		102,
		102,
		87,
		78,
		-1,
		90,
		72,
		51,
		68,
		68,
		59,
		67,
		92,
		88,
		75,
		75,
		67,
		-1,
		218,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		111,
		106,
		79,
		67,
		73,
		69,
		55,
		61,
		63,
		71,
		69,
		66,
		78,
		74,
		91,
		68,
		103,
		-1,
		213,
		-1,
		147,
		-1,
		-1,
		129,
		109,
		101,
		90,
		79,
		77,
		68,
		59,
		81,
		97,
		81,
		79,
		75,
		76,
		-1,
		202,
		201,
		-1,
		148,
		140,
		126,
		-1,
		119,
		-1,
		125,
		86,
		-1,
		88,
		68,
		-1,
		90,
		80,
		-1,
		-1,
		189,
		164,
		-1,
		-1,
		-1,
		149,
		129,
		120,
		104,
		-1,
		79,
		79,
		-1,
		-1,
		-1,
		174,
		173,
		-1,
		142,
		145,
		-1,
		135,
		126,
		134,
		81,
		85,
		-1,
		-1,
		-1,
		183,
		164,
		158,
		157,
		155,
		150,
		147,
		133,
		117,
		95,
		84,
		105,
		-1,
		-1,
		-1,
		155,
		147,
		140,
		-1,
		-1,
		142,
		125,
		106,
		104,
		-1,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		132,
		-1,
		-1,
		138,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		166,
		-1,
		-1,
		-1,
		128,
		124,
		125,
		-1,
		-1,
		-1,
		-1,
		188,
		189,
		212,
		176,
		-1,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		191,
		189,
		-1,
		-1,
		-1,
		148,
		132,
		-1,
		118,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		153,
		-1,
		153,
		128,
		135,
		-1,
		-1,
		-1,
		-1,
		166,
		158,
		166,
		-1,
		138,
		140,
		-1,
		188,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		143,
		150,
		172,
		175,
		211,
		-1,
		162
	],
	[
		-1,
		187,
		176,
		187,
		195,
		168,
		175,
		-1,
		194,
		198,
		164,
		158,
		197,
		166,
		172,
		183,
		-1,
		-1,
		-1,
		187,
		186,
		154,
		152,
		161,
		166,
		173,
		-1,
		172,
		-1,
		208,
		187,
		198,
		203,
		147,
		144,
		164,
		183,
		165,
		157,
		223,
		177,
		148,
		142,
		160,
		150,
		159,
		151,
		-1,
		148,
		138,
		160,
		139,
		150,
		142,
		-1,
		-1,
		142,
		143,
		149,
		135,
		141,
		137,
		-1,
		147,
		131,
		-1,
		-1,
		132,
		133,
		117,
		120,
		128,
		126,
		139,
		131,
		126,
		-1,
		-1,
		123,
		119,
		126,
		113,
		109,
		126,
		139,
		121,
		135,
		134,
		-1,
		127,
		145,
		152,
		120,
		118,
		102,
		100,
		118,
		120,
		126,
		126,
		-1,
		136,
		137,
		132,
		140,
		142,
		118,
		105,
		105,
		115,
		108,
		127,
		115,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		136,
		119,
		136,
		128,
		118,
		133,
		126,
		108,
		105,
		103,
		100,
		116,
		114,
		124,
		-1,
		-1,
		229,
		198,
		227,
		185,
		166,
		-1,
		132,
		112,
		118,
		122,
		116,
		109,
		123,
		119,
		-1,
		94,
		93,
		121,
		107,
		118,
		189,
		-1,
		-1,
		187,
		179,
		162,
		165,
		142,
		138,
		127,
		126,
		118,
		104,
		100,
		106,
		109,
		109,
		115,
		88,
		98,
		102,
		100,
		125,
		-1,
		-1,
		160,
		-1,
		-1,
		186,
		169,
		-1,
		152,
		159,
		148,
		154,
		140,
		161,
		137,
		128,
		120,
		114,
		102,
		104,
		101,
		114,
		102,
		85,
		110,
		114,
		95,
		116,
		111,
		-1,
		159,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		145,
		148,
		154,
		178,
		177,
		-1,
		149,
		137,
		138,
		123,
		120,
		107,
		95,
		108,
		93,
		100,
		99,
		89,
		87,
		117,
		92,
		114,
		111,
		130,
		135,
		129,
		138,
		-1,
		194,
		190,
		186,
		193,
		142,
		-1,
		-1,
		182,
		-1,
		185,
		186,
		161,
		134,
		137,
		124,
		115,
		102,
		91,
		102,
		91,
		88,
		96,
		81,
		96,
		87,
		86,
		104,
		114,
		122,
		126,
		132,
		-1,
		244,
		-1,
		186,
		170,
		172,
		144,
		165,
		-1,
		202,
		186,
		178,
		163,
		163,
		-1,
		133,
		130,
		120,
		98,
		83,
		100,
		92,
		90,
		94,
		76,
		90,
		81,
		99,
		106,
		104,
		108,
		128,
		140,
		204,
		194,
		-1,
		176,
		181,
		140,
		148,
		167,
		205,
		169,
		-1,
		164,
		-1,
		135,
		148,
		-1,
		104,
		100,
		82,
		83,
		78,
		93,
		87,
		72,
		69,
		87,
		90,
		97,
		101,
		117,
		-1,
		-1,
		189,
		193,
		182,
		133,
		152,
		176,
		213,
		162,
		151,
		150,
		-1,
		141,
		118,
		115,
		103,
		90,
		75,
		76,
		84,
		97,
		76,
		71,
		68,
		88,
		114,
		92,
		104,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		159,
		130,
		154,
		196,
		180,
		173,
		161,
		126,
		126,
		120,
		-1,
		114,
		93,
		84,
		73,
		71,
		84,
		81,
		86,
		66,
		64,
		83,
		95,
		86,
		103,
		-1,
		-1,
		-1,
		189,
		178,
		179,
		125,
		148,
		185,
		159,
		145,
		150,
		125,
		118,
		112,
		127,
		110,
		91,
		80,
		72,
		61,
		77,
		85,
		80,
		62,
		71,
		77,
		101,
		91,
		97,
		-1,
		-1,
		196,
		186,
		170,
		172,
		169,
		139,
		146,
		178,
		150,
		163,
		-1,
		117,
		-1,
		106,
		101,
		85,
		80,
		77,
		74,
		68,
		77,
		79,
		69,
		64,
		71,
		106,
		106,
		81,
		101,
		104,
		-1,
		-1,
		-1,
		189,
		184,
		159,
		136,
		120,
		156,
		-1,
		133,
		134,
		-1,
		111,
		105,
		102,
		87,
		83,
		78,
		82,
		75,
		82,
		75,
		73,
		74,
		56,
		88,
		-1,
		89,
		83,
		91,
		81,
		69,
		-1,
		-1,
		-1,
		182,
		161,
		154,
		174,
		115,
		167,
		-1,
		-1,
		118,
		111,
		-1,
		98,
		80,
		87,
		85,
		79,
		83,
		80,
		69,
		82,
		75,
		61,
		63,
		76,
		80,
		84,
		71,
		67,
		64,
		78,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		135,
		-1,
		127,
		119,
		109,
		103,
		97,
		93,
		91,
		107,
		91,
		94,
		92,
		83,
		91,
		64,
		57,
		64,
		53,
		71,
		79,
		71,
		65,
		64,
		74,
		-1,
		202,
		188,
		159,
		-1,
		-1,
		148,
		-1,
		112,
		126,
		142,
		-1,
		135,
		114,
		129,
		107,
		103,
		99,
		114,
		115,
		93,
		92,
		90,
		81,
		69,
		58,
		61,
		53,
		75,
		75,
		59,
		60,
		64,
		-1,
		208,
		195,
		153,
		149,
		138,
		158,
		109,
		97,
		129,
		-1,
		-1,
		171,
		-1,
		105,
		122,
		113,
		111,
		104,
		95,
		101,
		101,
		78,
		73,
		63,
		52,
		52,
		47,
		69,
		55,
		53,
		62,
		78,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		124,
		111,
		105,
		-1,
		146,
		-1,
		149,
		139,
		123,
		108,
		141,
		-1,
		106,
		96,
		101,
		-1,
		98,
		-1,
		71,
		68,
		59,
		44,
		41,
		52,
		50,
		61,
		57,
		-1,
		158,
		143,
		136,
		126,
		140,
		111,
		-1,
		166,
		-1,
		-1,
		136,
		130,
		130,
		114,
		117,
		122,
		102,
		94,
		101,
		93,
		85,
		79,
		57,
		50,
		47,
		40,
		53,
		63,
		68,
		55,
		-1,
		-1,
		-1,
		163,
		149,
		153,
		113,
		132,
		-1,
		-1,
		198,
		153,
		139,
		-1,
		123,
		122,
		110,
		100,
		90,
		95,
		96,
		76,
		69,
		55,
		57,
		51,
		42,
		41,
		57,
		49,
		71,
		-1,
		-1,
		146,
		151,
		139,
		125,
		144,
		-1,
		-1,
		-1,
		145,
		161,
		150,
		124,
		111,
		-1,
		-1,
		94,
		87,
		81,
		72,
		59,
		71,
		66,
		50,
		35,
		50,
		54,
		62,
		53,
		-1,
		149,
		136,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		-1,
		-1,
		162,
		107,
		96,
		91,
		95,
		93,
		-1,
		67,
		78,
		63,
		75,
		82,
		52,
		37,
		31,
		37,
		49,
		58,
		-1,
		-1,
		161,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		119,
		113,
		84,
		77,
		81,
		-1,
		69,
		71,
		65,
		80,
		55,
		52,
		43,
		34,
		30,
		34,
		38,
		47,
		53,
		184,
		-1,
		147,
		-1,
		-1,
		-1,
		137,
		152,
		123,
		100,
		73,
		68,
		61,
		55,
		60,
		71,
		63,
		74,
		41,
		37,
		27,
		26,
		30,
		47,
		41,
		-1,
		-1,
		145,
		141,
		163,
		145,
		149,
		150,
		-1,
		-1,
		77,
		68,
		59,
		51,
		64,
		67,
		47,
		44,
		38,
		31,
		25,
		35,
		40,
		35,
		-1,
		-1,
		-1,
		157,
		-1,
		159,
		-1,
		-1,
		147,
		148,
		95,
		77,
		73,
		71,
		60,
		54,
		42,
		47,
		50,
		40,
		32,
		21,
		15,
		38,
		27,
		66,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		136,
		128,
		123,
		129,
		131,
		122,
		110,
		107,
		-1,
		77,
		83,
		48,
		55,
		38,
		45,
		44,
		36,
		15,
		12,
		28,
		27,
		22,
		58,
		49,
		55,
		-1,
		-1,
		222,
		211,
		200,
		206,
		-1,
		129,
		125,
		115,
		105,
		108,
		-1,
		-1,
		102,
		99,
		79,
		48,
		46,
		39,
		34,
		44,
		24,
		11,
		5,
		0,
		15,
		20,
		25,
		31,
		46,
		61,
		-1,
		176,
		213,
		206,
		174,
		182,
		213,
		-1,
		119,
		111,
		122,
		97,
		99,
		-1,
		-1,
		75,
		66,
		67,
		55,
		52,
		54,
		49,
		40,
		25,
		31,
		18,
		7,
		16,
		29,
		38,
		41,
		35,
		48,
		52,
		-1,
		169,
		189,
		168,
		171,
		195,
		209,
		-1,
		116,
		-1,
		-1,
		128,
		100,
		84,
		74,
		71,
		114,
		69,
		64,
		48,
		46,
		37,
		28,
		35,
		22,
		7,
		10,
		28,
		33,
		25,
		45,
		45,
		46,
		-1,
		158,
		169,
		162,
		-1,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		144,
		-1,
		111,
		-1,
		94,
		98,
		77,
		80,
		62,
		49,
		41,
		33,
		47,
		24,
		15,
		11,
		15,
		24,
		35,
		47,
		52,
		53,
		183,
		139,
		142,
		153,
		164,
		179,
		183,
		-1,
		128,
		167,
		161,
		-1,
		145,
		-1,
		-1,
		-1,
		108,
		90,
		82,
		82,
		61,
		61,
		35,
		39,
		27,
		20,
		27,
		29,
		24,
		28,
		41,
		52,
		61,
		179,
		170,
		183,
		128,
		128,
		149,
		158,
		179,
		143,
		134,
		161,
		168,
		157,
		152,
		139,
		-1,
		-1,
		131,
		100,
		-1,
		-1,
		68,
		56,
		39,
		38,
		34,
		37,
		47,
		38,
		31,
		29,
		23,
		55,
		-1,
		172,
		171,
		160,
		157,
		133,
		124,
		119,
		146,
		-1,
		-1,
		141,
		162,
		152,
		156,
		172,
		197,
		-1,
		128,
		-1,
		-1,
		113,
		-1,
		-1,
		98,
		61,
		50,
		41,
		47,
		42,
		51,
		58,
		37,
		38,
		28,
		38,
		51,
		156,
		153,
		141,
		139,
		162,
		127,
		115,
		-1,
		128,
		126,
		132,
		139,
		156,
		186,
		-1,
		-1,
		144,
		124,
		-1,
		-1,
		96,
		94,
		83,
		-1,
		73,
		46,
		51,
		69,
		57,
		46,
		40,
		34,
		41,
		40,
		48,
		56,
		165,
		179,
		168,
		164,
		163,
		171,
		120,
		113,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		134,
		130,
		-1,
		-1,
		91,
		84,
		72,
		60,
		50,
		60,
		62,
		58,
		44,
		37,
		32,
		43,
		35,
		39,
		56,
		-1,
		199,
		-1,
		151,
		127,
		141,
		156,
		164,
		-1,
		-1,
		-1,
		151,
		137,
		130,
		118,
		116,
		-1,
		125,
		109,
		90,
		-1,
		60,
		73,
		94,
		62,
		62,
		56,
		38,
		49,
		38,
		41,
		55,
		50,
		-1,
		-1,
		139,
		142,
		-1,
		-1,
		141,
		143,
		-1,
		142,
		131,
		116,
		108,
		-1,
		-1,
		97,
		93,
		-1,
		-1,
		61,
		76,
		65,
		68,
		63,
		42,
		48,
		51,
		40,
		44,
		56,
		-1,
		-1,
		146,
		147,
		148,
		-1,
		126,
		-1,
		144,
		-1,
		111,
		117,
		105,
		-1,
		-1,
		-1,
		99,
		62,
		83,
		83,
		71,
		69,
		60,
		46,
		53,
		51,
		47,
		58,
		-1,
		-1,
		-1,
		144,
		118,
		151,
		142,
		125,
		105,
		97,
		116,
		-1,
		86,
		-1,
		61,
		63,
		89,
		79,
		82,
		76,
		49,
		64,
		54,
		45,
		54,
		150,
		-1,
		120,
		153,
		117,
		111,
		87,
		91,
		107,
		-1,
		83,
		65,
		-1,
		93,
		83,
		98,
		83,
		64,
		51,
		58,
		58,
		51,
		-1,
		-1,
		-1,
		122,
		121,
		113,
		107,
		107,
		92,
		83,
		-1,
		95,
		77,
		56,
		73,
		73,
		64,
		72,
		88,
		84,
		71,
		71,
		63,
		-1,
		223,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		116,
		111,
		84,
		72,
		78,
		74,
		60,
		66,
		68,
		76,
		74,
		71,
		83,
		79,
		87,
		64,
		99,
		-1,
		218,
		-1,
		152,
		-1,
		-1,
		134,
		114,
		106,
		95,
		84,
		82,
		73,
		64,
		86,
		102,
		86,
		76,
		71,
		72,
		-1,
		207,
		206,
		-1,
		153,
		145,
		131,
		-1,
		124,
		-1,
		130,
		91,
		-1,
		93,
		73,
		-1,
		87,
		76,
		-1,
		-1,
		194,
		169,
		-1,
		-1,
		-1,
		154,
		134,
		125,
		109,
		-1,
		84,
		84,
		-1,
		-1,
		-1,
		179,
		178,
		-1,
		147,
		150,
		-1,
		140,
		131,
		139,
		86,
		90,
		-1,
		-1,
		-1,
		188,
		169,
		163,
		162,
		160,
		155,
		152,
		138,
		122,
		100,
		89,
		110,
		-1,
		-1,
		-1,
		160,
		152,
		145,
		-1,
		-1,
		147,
		130,
		111,
		109,
		-1,
		-1,
		-1,
		182,
		163,
		-1,
		-1,
		137,
		-1,
		-1,
		143,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		171,
		-1,
		-1,
		-1,
		133,
		129,
		130,
		-1,
		-1,
		-1,
		-1,
		193,
		194,
		217,
		181,
		-1,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		196,
		194,
		-1,
		-1,
		-1,
		153,
		137,
		-1,
		123,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		158,
		-1,
		158,
		133,
		140,
		-1,
		-1,
		-1,
		-1,
		171,
		163,
		171,
		-1,
		143,
		145,
		-1,
		193,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		148,
		155,
		177,
		180,
		216,
		-1,
		167
	],
	[
		-1,
		192,
		181,
		192,
		200,
		173,
		180,
		-1,
		199,
		203,
		169,
		163,
		202,
		171,
		177,
		188,
		-1,
		-1,
		-1,
		192,
		191,
		159,
		157,
		166,
		171,
		178,
		-1,
		177,
		-1,
		213,
		192,
		203,
		208,
		152,
		149,
		169,
		188,
		170,
		162,
		228,
		182,
		153,
		147,
		165,
		155,
		164,
		156,
		-1,
		153,
		143,
		165,
		144,
		155,
		147,
		-1,
		-1,
		147,
		148,
		154,
		140,
		146,
		142,
		-1,
		152,
		136,
		-1,
		-1,
		137,
		138,
		122,
		125,
		133,
		131,
		144,
		136,
		131,
		-1,
		-1,
		128,
		124,
		131,
		118,
		114,
		131,
		144,
		126,
		140,
		139,
		-1,
		132,
		150,
		157,
		125,
		123,
		107,
		105,
		123,
		125,
		131,
		131,
		-1,
		141,
		142,
		137,
		145,
		147,
		123,
		110,
		110,
		120,
		113,
		132,
		120,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		141,
		124,
		141,
		133,
		123,
		138,
		131,
		113,
		110,
		108,
		105,
		121,
		119,
		129,
		-1,
		-1,
		234,
		203,
		232,
		190,
		171,
		-1,
		137,
		117,
		123,
		127,
		121,
		114,
		128,
		124,
		-1,
		99,
		98,
		126,
		112,
		123,
		194,
		-1,
		-1,
		192,
		184,
		167,
		170,
		147,
		143,
		132,
		131,
		123,
		109,
		105,
		111,
		114,
		114,
		120,
		93,
		103,
		107,
		105,
		130,
		-1,
		-1,
		165,
		-1,
		-1,
		191,
		174,
		-1,
		157,
		164,
		153,
		159,
		145,
		166,
		142,
		133,
		125,
		119,
		107,
		109,
		106,
		119,
		107,
		90,
		115,
		119,
		100,
		121,
		116,
		-1,
		164,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		150,
		153,
		159,
		183,
		182,
		-1,
		154,
		142,
		143,
		128,
		125,
		112,
		100,
		113,
		98,
		105,
		104,
		94,
		92,
		122,
		97,
		119,
		116,
		135,
		140,
		134,
		143,
		-1,
		199,
		195,
		191,
		198,
		147,
		-1,
		-1,
		187,
		-1,
		190,
		191,
		166,
		139,
		142,
		129,
		120,
		107,
		96,
		107,
		96,
		93,
		101,
		86,
		101,
		92,
		91,
		109,
		119,
		127,
		131,
		137,
		-1,
		249,
		-1,
		191,
		175,
		177,
		149,
		170,
		-1,
		207,
		191,
		183,
		168,
		168,
		-1,
		138,
		135,
		125,
		103,
		88,
		105,
		97,
		95,
		99,
		81,
		95,
		86,
		104,
		111,
		109,
		113,
		133,
		145,
		209,
		199,
		-1,
		181,
		186,
		145,
		153,
		172,
		210,
		174,
		-1,
		169,
		-1,
		140,
		153,
		-1,
		109,
		105,
		87,
		88,
		83,
		98,
		92,
		77,
		74,
		92,
		95,
		102,
		106,
		122,
		-1,
		-1,
		194,
		198,
		187,
		138,
		157,
		181,
		218,
		167,
		156,
		155,
		-1,
		146,
		123,
		120,
		108,
		95,
		80,
		81,
		89,
		102,
		81,
		76,
		73,
		93,
		119,
		97,
		109,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		164,
		135,
		159,
		201,
		185,
		178,
		166,
		131,
		131,
		125,
		-1,
		119,
		98,
		89,
		78,
		76,
		89,
		86,
		91,
		71,
		69,
		88,
		100,
		91,
		108,
		-1,
		-1,
		-1,
		194,
		183,
		184,
		130,
		153,
		190,
		164,
		150,
		155,
		130,
		123,
		117,
		132,
		115,
		96,
		85,
		77,
		66,
		82,
		90,
		85,
		67,
		76,
		82,
		106,
		96,
		102,
		-1,
		-1,
		201,
		191,
		175,
		177,
		174,
		144,
		151,
		183,
		155,
		168,
		-1,
		122,
		-1,
		111,
		106,
		90,
		85,
		82,
		79,
		73,
		82,
		84,
		74,
		69,
		76,
		111,
		111,
		86,
		106,
		109,
		-1,
		-1,
		-1,
		194,
		189,
		164,
		141,
		125,
		161,
		-1,
		138,
		139,
		-1,
		116,
		110,
		107,
		92,
		88,
		83,
		87,
		80,
		87,
		80,
		78,
		79,
		61,
		93,
		-1,
		94,
		88,
		96,
		86,
		74,
		-1,
		-1,
		-1,
		187,
		166,
		159,
		179,
		120,
		172,
		-1,
		-1,
		123,
		116,
		-1,
		103,
		85,
		92,
		90,
		84,
		88,
		85,
		74,
		87,
		80,
		66,
		68,
		81,
		85,
		89,
		76,
		72,
		69,
		83,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		140,
		-1,
		132,
		124,
		114,
		108,
		102,
		98,
		96,
		112,
		96,
		99,
		97,
		88,
		96,
		69,
		62,
		69,
		58,
		76,
		84,
		76,
		70,
		69,
		79,
		-1,
		207,
		193,
		164,
		-1,
		-1,
		153,
		-1,
		117,
		131,
		147,
		-1,
		140,
		119,
		134,
		112,
		108,
		104,
		119,
		120,
		98,
		97,
		95,
		86,
		74,
		63,
		66,
		58,
		80,
		80,
		64,
		65,
		69,
		-1,
		213,
		200,
		158,
		154,
		143,
		163,
		114,
		102,
		134,
		-1,
		-1,
		176,
		-1,
		110,
		127,
		118,
		116,
		109,
		100,
		106,
		106,
		83,
		78,
		68,
		57,
		57,
		52,
		74,
		60,
		58,
		67,
		72,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		129,
		116,
		110,
		-1,
		151,
		-1,
		154,
		144,
		128,
		113,
		146,
		-1,
		111,
		101,
		106,
		-1,
		103,
		-1,
		76,
		73,
		64,
		49,
		46,
		57,
		55,
		66,
		62,
		-1,
		163,
		148,
		141,
		131,
		145,
		116,
		-1,
		171,
		-1,
		-1,
		141,
		135,
		135,
		119,
		122,
		127,
		107,
		99,
		106,
		98,
		90,
		84,
		62,
		55,
		52,
		45,
		58,
		68,
		73,
		60,
		-1,
		-1,
		-1,
		168,
		154,
		158,
		118,
		137,
		-1,
		-1,
		203,
		158,
		144,
		-1,
		128,
		127,
		115,
		105,
		95,
		100,
		101,
		81,
		74,
		60,
		62,
		56,
		47,
		46,
		62,
		54,
		71,
		-1,
		-1,
		151,
		156,
		144,
		130,
		149,
		-1,
		-1,
		-1,
		150,
		166,
		155,
		129,
		116,
		-1,
		-1,
		99,
		92,
		86,
		77,
		64,
		76,
		71,
		55,
		40,
		55,
		59,
		61,
		53,
		-1,
		154,
		141,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		-1,
		-1,
		167,
		112,
		101,
		96,
		100,
		98,
		-1,
		72,
		83,
		68,
		80,
		87,
		57,
		42,
		36,
		42,
		54,
		47,
		-1,
		-1,
		166,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		124,
		118,
		89,
		82,
		86,
		-1,
		74,
		76,
		70,
		85,
		60,
		57,
		48,
		39,
		35,
		39,
		43,
		32,
		38,
		189,
		-1,
		152,
		-1,
		-1,
		-1,
		142,
		157,
		128,
		105,
		78,
		73,
		66,
		60,
		65,
		76,
		68,
		79,
		46,
		42,
		32,
		31,
		35,
		36,
		26,
		-1,
		-1,
		150,
		146,
		168,
		150,
		154,
		155,
		-1,
		-1,
		82,
		73,
		64,
		56,
		69,
		72,
		52,
		49,
		43,
		36,
		30,
		40,
		25,
		20,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		152,
		153,
		100,
		82,
		78,
		76,
		65,
		59,
		47,
		52,
		55,
		45,
		37,
		26,
		20,
		30,
		12,
		51,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		141,
		133,
		128,
		134,
		136,
		127,
		115,
		112,
		-1,
		82,
		88,
		53,
		60,
		43,
		50,
		49,
		41,
		20,
		17,
		23,
		12,
		7,
		43,
		34,
		40,
		-1,
		-1,
		227,
		216,
		205,
		211,
		-1,
		134,
		130,
		120,
		110,
		113,
		-1,
		-1,
		107,
		104,
		84,
		53,
		51,
		44,
		39,
		49,
		29,
		16,
		10,
		14,
		0,
		5,
		10,
		16,
		31,
		46,
		-1,
		181,
		218,
		211,
		179,
		187,
		218,
		-1,
		124,
		116,
		127,
		102,
		104,
		-1,
		-1,
		80,
		71,
		72,
		60,
		57,
		59,
		54,
		45,
		30,
		36,
		23,
		12,
		29,
		14,
		23,
		30,
		20,
		33,
		37,
		-1,
		174,
		194,
		173,
		176,
		200,
		214,
		-1,
		121,
		-1,
		-1,
		133,
		105,
		89,
		79,
		76,
		119,
		74,
		69,
		53,
		51,
		42,
		33,
		40,
		27,
		21,
		24,
		22,
		38,
		32,
		30,
		30,
		31,
		-1,
		163,
		174,
		167,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		149,
		-1,
		116,
		-1,
		99,
		103,
		82,
		85,
		67,
		54,
		46,
		38,
		54,
		29,
		29,
		25,
		29,
		38,
		42,
		51,
		37,
		38,
		188,
		144,
		147,
		158,
		169,
		184,
		188,
		-1,
		133,
		172,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		113,
		95,
		87,
		87,
		66,
		66,
		40,
		44,
		34,
		34,
		41,
		43,
		38,
		42,
		55,
		47,
		46,
		184,
		175,
		188,
		133,
		133,
		154,
		163,
		184,
		148,
		139,
		166,
		173,
		162,
		157,
		144,
		-1,
		-1,
		136,
		105,
		-1,
		-1,
		73,
		61,
		44,
		45,
		41,
		44,
		59,
		52,
		45,
		43,
		37,
		52,
		-1,
		177,
		176,
		165,
		162,
		138,
		129,
		124,
		151,
		-1,
		-1,
		146,
		167,
		157,
		161,
		177,
		202,
		-1,
		133,
		-1,
		-1,
		118,
		-1,
		-1,
		103,
		66,
		55,
		46,
		52,
		49,
		60,
		70,
		51,
		52,
		42,
		52,
		65,
		161,
		158,
		146,
		144,
		167,
		132,
		120,
		-1,
		133,
		131,
		137,
		144,
		161,
		191,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		101,
		99,
		88,
		-1,
		78,
		51,
		56,
		76,
		71,
		60,
		54,
		48,
		55,
		54,
		62,
		70,
		170,
		184,
		173,
		169,
		168,
		176,
		125,
		118,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		96,
		89,
		77,
		65,
		55,
		65,
		69,
		72,
		58,
		51,
		46,
		57,
		49,
		53,
		68,
		-1,
		204,
		-1,
		156,
		132,
		146,
		161,
		169,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		130,
		114,
		95,
		-1,
		65,
		78,
		108,
		76,
		76,
		70,
		52,
		63,
		52,
		55,
		61,
		64,
		-1,
		-1,
		144,
		147,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		102,
		98,
		-1,
		-1,
		66,
		90,
		79,
		82,
		77,
		56,
		62,
		65,
		54,
		58,
		61,
		-1,
		-1,
		151,
		152,
		153,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		104,
		67,
		88,
		97,
		85,
		83,
		74,
		60,
		67,
		65,
		61,
		71,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		91,
		-1,
		66,
		68,
		94,
		93,
		96,
		90,
		63,
		78,
		68,
		59,
		68,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		88,
		70,
		-1,
		98,
		88,
		112,
		97,
		78,
		65,
		72,
		72,
		65,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		78,
		78,
		69,
		77,
		102,
		98,
		85,
		85,
		77,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		73,
		81,
		79,
		76,
		88,
		84,
		101,
		78,
		113,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		107,
		91,
		89,
		85,
		86,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		100,
		90,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		199,
		188,
		199,
		207,
		180,
		187,
		-1,
		206,
		210,
		176,
		170,
		209,
		178,
		184,
		195,
		-1,
		-1,
		-1,
		199,
		198,
		166,
		164,
		173,
		178,
		185,
		-1,
		184,
		-1,
		220,
		199,
		210,
		215,
		159,
		156,
		176,
		195,
		177,
		169,
		235,
		189,
		160,
		154,
		172,
		162,
		171,
		163,
		-1,
		160,
		150,
		172,
		151,
		162,
		154,
		-1,
		-1,
		154,
		155,
		161,
		147,
		153,
		149,
		-1,
		159,
		143,
		-1,
		-1,
		144,
		145,
		129,
		132,
		140,
		138,
		151,
		143,
		138,
		-1,
		-1,
		135,
		131,
		138,
		125,
		121,
		138,
		151,
		133,
		147,
		146,
		-1,
		139,
		157,
		164,
		132,
		130,
		114,
		112,
		130,
		132,
		138,
		138,
		-1,
		148,
		149,
		144,
		152,
		154,
		130,
		117,
		117,
		127,
		120,
		139,
		127,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		131,
		148,
		140,
		130,
		145,
		138,
		120,
		117,
		115,
		112,
		128,
		126,
		136,
		-1,
		-1,
		241,
		210,
		239,
		197,
		178,
		-1,
		144,
		124,
		130,
		134,
		128,
		121,
		135,
		131,
		-1,
		106,
		105,
		133,
		119,
		130,
		201,
		-1,
		-1,
		199,
		191,
		174,
		177,
		154,
		150,
		139,
		138,
		130,
		116,
		112,
		118,
		121,
		121,
		127,
		100,
		110,
		114,
		112,
		137,
		-1,
		-1,
		172,
		-1,
		-1,
		198,
		181,
		-1,
		164,
		171,
		160,
		166,
		152,
		173,
		149,
		140,
		132,
		126,
		114,
		116,
		113,
		126,
		114,
		97,
		122,
		126,
		107,
		128,
		123,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		157,
		160,
		166,
		190,
		189,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		120,
		105,
		112,
		111,
		101,
		99,
		129,
		104,
		126,
		123,
		142,
		147,
		141,
		150,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		194,
		-1,
		197,
		198,
		173,
		146,
		149,
		136,
		127,
		114,
		103,
		114,
		103,
		100,
		108,
		93,
		108,
		99,
		98,
		116,
		126,
		134,
		138,
		144,
		-1,
		256,
		-1,
		198,
		182,
		184,
		156,
		177,
		-1,
		214,
		198,
		190,
		175,
		175,
		-1,
		145,
		142,
		132,
		110,
		95,
		112,
		104,
		102,
		106,
		88,
		102,
		93,
		111,
		118,
		116,
		120,
		140,
		152,
		216,
		206,
		-1,
		188,
		193,
		152,
		160,
		179,
		217,
		181,
		-1,
		176,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		95,
		90,
		105,
		99,
		84,
		81,
		99,
		102,
		109,
		113,
		129,
		-1,
		-1,
		201,
		205,
		194,
		145,
		164,
		188,
		225,
		174,
		163,
		162,
		-1,
		153,
		130,
		127,
		115,
		102,
		87,
		88,
		96,
		109,
		88,
		83,
		80,
		100,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		171,
		142,
		166,
		208,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		126,
		105,
		96,
		85,
		83,
		96,
		93,
		98,
		78,
		76,
		95,
		107,
		98,
		115,
		-1,
		-1,
		-1,
		201,
		190,
		191,
		137,
		160,
		197,
		171,
		157,
		162,
		137,
		130,
		124,
		139,
		122,
		103,
		92,
		84,
		73,
		89,
		97,
		92,
		74,
		83,
		89,
		113,
		103,
		109,
		-1,
		-1,
		208,
		198,
		182,
		184,
		181,
		151,
		158,
		190,
		162,
		175,
		-1,
		129,
		-1,
		118,
		113,
		97,
		92,
		89,
		86,
		80,
		89,
		91,
		81,
		76,
		83,
		118,
		118,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		201,
		196,
		171,
		148,
		132,
		168,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		99,
		95,
		90,
		94,
		87,
		94,
		87,
		85,
		86,
		68,
		100,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		127,
		179,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		99,
		97,
		91,
		95,
		92,
		81,
		94,
		87,
		73,
		75,
		88,
		92,
		96,
		83,
		79,
		76,
		86,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		147,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		119,
		103,
		106,
		104,
		95,
		103,
		76,
		69,
		76,
		65,
		83,
		91,
		83,
		77,
		75,
		82,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		111,
		126,
		127,
		105,
		104,
		102,
		93,
		81,
		70,
		73,
		65,
		87,
		87,
		71,
		72,
		71,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		125,
		123,
		116,
		107,
		113,
		113,
		90,
		85,
		75,
		64,
		64,
		59,
		81,
		67,
		65,
		69,
		67,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		118,
		108,
		113,
		-1,
		110,
		-1,
		83,
		80,
		71,
		56,
		53,
		64,
		62,
		73,
		64,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		134,
		114,
		106,
		113,
		105,
		97,
		91,
		69,
		62,
		59,
		52,
		65,
		75,
		78,
		62,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		134,
		122,
		112,
		102,
		107,
		108,
		88,
		81,
		67,
		69,
		63,
		54,
		53,
		69,
		61,
		66,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		162,
		136,
		123,
		-1,
		-1,
		106,
		99,
		93,
		84,
		71,
		83,
		78,
		62,
		47,
		62,
		64,
		56,
		48,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		90,
		75,
		87,
		94,
		64,
		49,
		43,
		49,
		59,
		42,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		83,
		77,
		92,
		67,
		64,
		55,
		46,
		42,
		46,
		46,
		27,
		33,
		196,
		-1,
		159,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		72,
		83,
		75,
		86,
		53,
		49,
		39,
		38,
		42,
		31,
		21,
		-1,
		-1,
		157,
		153,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		63,
		76,
		79,
		59,
		56,
		50,
		43,
		37,
		47,
		20,
		15,
		-1,
		-1,
		-1,
		169,
		-1,
		171,
		-1,
		-1,
		159,
		160,
		107,
		89,
		85,
		83,
		72,
		66,
		54,
		59,
		62,
		52,
		44,
		33,
		27,
		34,
		7,
		48,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		148,
		140,
		135,
		141,
		143,
		134,
		122,
		119,
		-1,
		89,
		95,
		60,
		67,
		50,
		57,
		56,
		48,
		27,
		24,
		30,
		10,
		2,
		40,
		31,
		35,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		141,
		137,
		127,
		117,
		120,
		-1,
		-1,
		114,
		111,
		91,
		60,
		58,
		51,
		46,
		56,
		36,
		23,
		17,
		21,
		7,
		0,
		5,
		11,
		26,
		41,
		-1,
		188,
		225,
		218,
		186,
		194,
		225,
		-1,
		131,
		123,
		134,
		109,
		111,
		-1,
		-1,
		87,
		78,
		79,
		67,
		64,
		66,
		61,
		52,
		37,
		43,
		30,
		19,
		36,
		21,
		18,
		25,
		24,
		35,
		39,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		128,
		-1,
		-1,
		140,
		112,
		96,
		86,
		83,
		126,
		81,
		76,
		60,
		58,
		49,
		40,
		47,
		34,
		28,
		31,
		29,
		33,
		27,
		34,
		29,
		35,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		156,
		-1,
		123,
		-1,
		106,
		110,
		89,
		92,
		74,
		61,
		53,
		45,
		61,
		36,
		36,
		32,
		36,
		45,
		37,
		50,
		41,
		35,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		140,
		179,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		120,
		102,
		94,
		94,
		73,
		73,
		47,
		51,
		41,
		41,
		48,
		50,
		45,
		49,
		60,
		51,
		43,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		155,
		146,
		173,
		180,
		169,
		164,
		151,
		-1,
		-1,
		143,
		112,
		-1,
		-1,
		80,
		68,
		51,
		52,
		48,
		51,
		66,
		59,
		52,
		50,
		44,
		56,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		174,
		164,
		168,
		184,
		209,
		-1,
		140,
		-1,
		-1,
		125,
		-1,
		-1,
		110,
		73,
		62,
		53,
		59,
		56,
		67,
		77,
		58,
		59,
		49,
		59,
		70,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		108,
		106,
		95,
		-1,
		85,
		58,
		63,
		83,
		78,
		67,
		61,
		55,
		62,
		61,
		69,
		75,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		103,
		96,
		84,
		72,
		62,
		72,
		76,
		79,
		65,
		58,
		53,
		64,
		56,
		60,
		72,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		137,
		121,
		102,
		-1,
		72,
		85,
		115,
		83,
		83,
		77,
		59,
		70,
		59,
		62,
		65,
		68,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		109,
		105,
		-1,
		-1,
		73,
		97,
		86,
		89,
		84,
		63,
		69,
		72,
		61,
		65,
		65,
		-1,
		-1,
		158,
		159,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		111,
		74,
		95,
		104,
		92,
		90,
		81,
		67,
		74,
		72,
		68,
		75,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		73,
		75,
		101,
		100,
		103,
		97,
		70,
		85,
		75,
		66,
		75,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		77,
		-1,
		105,
		95,
		119,
		104,
		85,
		72,
		79,
		79,
		72,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		84,
		109,
		105,
		92,
		92,
		84,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		86,
		83,
		95,
		91,
		108,
		85,
		120,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		98,
		96,
		92,
		93,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		107,
		97,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		204,
		193,
		204,
		212,
		185,
		192,
		-1,
		211,
		215,
		181,
		175,
		214,
		183,
		189,
		200,
		-1,
		-1,
		-1,
		204,
		203,
		171,
		169,
		178,
		183,
		190,
		-1,
		189,
		-1,
		225,
		204,
		215,
		220,
		164,
		161,
		181,
		200,
		182,
		174,
		240,
		194,
		165,
		159,
		177,
		167,
		176,
		168,
		-1,
		165,
		155,
		177,
		156,
		167,
		159,
		-1,
		-1,
		159,
		160,
		166,
		152,
		158,
		154,
		-1,
		164,
		148,
		-1,
		-1,
		149,
		150,
		134,
		137,
		145,
		143,
		156,
		148,
		143,
		-1,
		-1,
		140,
		136,
		143,
		130,
		126,
		143,
		156,
		138,
		152,
		151,
		-1,
		144,
		162,
		169,
		137,
		135,
		119,
		117,
		135,
		137,
		143,
		143,
		-1,
		153,
		154,
		149,
		157,
		159,
		135,
		122,
		122,
		132,
		125,
		144,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		153,
		136,
		153,
		145,
		135,
		150,
		143,
		125,
		122,
		120,
		117,
		133,
		131,
		141,
		-1,
		-1,
		246,
		215,
		244,
		202,
		183,
		-1,
		149,
		129,
		135,
		139,
		133,
		126,
		140,
		136,
		-1,
		111,
		110,
		138,
		124,
		135,
		206,
		-1,
		-1,
		204,
		196,
		179,
		182,
		159,
		155,
		144,
		143,
		135,
		121,
		117,
		123,
		126,
		126,
		132,
		105,
		115,
		119,
		117,
		142,
		-1,
		-1,
		177,
		-1,
		-1,
		203,
		186,
		-1,
		169,
		176,
		165,
		171,
		157,
		178,
		154,
		145,
		137,
		131,
		119,
		121,
		118,
		131,
		119,
		102,
		127,
		131,
		112,
		133,
		128,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		162,
		165,
		171,
		195,
		194,
		-1,
		166,
		154,
		155,
		140,
		137,
		124,
		112,
		125,
		110,
		117,
		116,
		106,
		104,
		134,
		109,
		131,
		128,
		147,
		152,
		146,
		155,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		199,
		-1,
		202,
		203,
		178,
		151,
		154,
		141,
		132,
		119,
		108,
		119,
		108,
		105,
		113,
		98,
		113,
		104,
		103,
		121,
		131,
		139,
		143,
		149,
		-1,
		261,
		-1,
		203,
		187,
		189,
		161,
		182,
		-1,
		219,
		203,
		195,
		180,
		180,
		-1,
		150,
		147,
		137,
		115,
		100,
		117,
		109,
		107,
		111,
		93,
		107,
		98,
		116,
		123,
		121,
		125,
		145,
		157,
		221,
		211,
		-1,
		193,
		198,
		157,
		165,
		184,
		222,
		186,
		-1,
		181,
		-1,
		152,
		165,
		-1,
		121,
		117,
		99,
		100,
		95,
		110,
		104,
		89,
		86,
		104,
		107,
		114,
		118,
		134,
		-1,
		-1,
		206,
		210,
		199,
		150,
		169,
		193,
		230,
		179,
		168,
		167,
		-1,
		158,
		135,
		132,
		120,
		107,
		92,
		93,
		101,
		114,
		93,
		88,
		85,
		105,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		176,
		147,
		171,
		213,
		197,
		190,
		178,
		143,
		143,
		137,
		-1,
		131,
		110,
		101,
		90,
		88,
		101,
		98,
		103,
		83,
		81,
		100,
		112,
		103,
		120,
		-1,
		-1,
		-1,
		206,
		195,
		196,
		142,
		165,
		202,
		176,
		162,
		167,
		142,
		135,
		129,
		144,
		127,
		108,
		97,
		89,
		78,
		94,
		102,
		97,
		79,
		88,
		94,
		118,
		108,
		114,
		-1,
		-1,
		213,
		203,
		187,
		189,
		186,
		156,
		163,
		195,
		167,
		180,
		-1,
		134,
		-1,
		123,
		118,
		102,
		97,
		94,
		91,
		85,
		94,
		96,
		86,
		81,
		88,
		123,
		123,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		206,
		201,
		176,
		153,
		137,
		173,
		-1,
		150,
		151,
		-1,
		128,
		122,
		119,
		104,
		100,
		95,
		99,
		92,
		99,
		92,
		90,
		91,
		73,
		105,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		199,
		178,
		171,
		191,
		132,
		184,
		-1,
		-1,
		135,
		128,
		-1,
		115,
		97,
		104,
		102,
		96,
		100,
		97,
		86,
		99,
		92,
		78,
		80,
		93,
		97,
		101,
		88,
		84,
		81,
		91,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		152,
		-1,
		144,
		136,
		126,
		120,
		114,
		110,
		108,
		124,
		108,
		111,
		109,
		100,
		108,
		81,
		74,
		81,
		70,
		88,
		96,
		88,
		82,
		80,
		87,
		-1,
		219,
		205,
		176,
		-1,
		-1,
		165,
		-1,
		129,
		143,
		159,
		-1,
		152,
		131,
		146,
		124,
		120,
		116,
		131,
		132,
		110,
		109,
		107,
		98,
		86,
		75,
		78,
		70,
		92,
		92,
		76,
		77,
		76,
		-1,
		225,
		212,
		170,
		166,
		155,
		175,
		126,
		114,
		146,
		-1,
		-1,
		188,
		-1,
		122,
		139,
		130,
		128,
		121,
		112,
		118,
		118,
		95,
		90,
		80,
		69,
		69,
		64,
		86,
		72,
		70,
		74,
		72,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		141,
		128,
		122,
		-1,
		163,
		-1,
		166,
		156,
		140,
		125,
		158,
		-1,
		123,
		113,
		118,
		-1,
		115,
		-1,
		88,
		85,
		76,
		61,
		58,
		69,
		67,
		78,
		69,
		-1,
		175,
		160,
		153,
		143,
		157,
		128,
		-1,
		183,
		-1,
		-1,
		153,
		147,
		147,
		131,
		134,
		139,
		119,
		111,
		118,
		110,
		102,
		96,
		74,
		67,
		64,
		57,
		70,
		80,
		83,
		67,
		-1,
		-1,
		-1,
		180,
		166,
		170,
		130,
		149,
		-1,
		-1,
		215,
		170,
		156,
		-1,
		140,
		139,
		127,
		117,
		107,
		112,
		113,
		93,
		86,
		72,
		74,
		68,
		59,
		58,
		74,
		66,
		71,
		-1,
		-1,
		163,
		168,
		156,
		142,
		161,
		-1,
		-1,
		-1,
		162,
		178,
		167,
		141,
		128,
		-1,
		-1,
		111,
		104,
		98,
		89,
		76,
		88,
		83,
		67,
		52,
		67,
		69,
		61,
		53,
		-1,
		166,
		153,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		-1,
		-1,
		179,
		124,
		113,
		108,
		112,
		110,
		-1,
		84,
		95,
		80,
		92,
		99,
		69,
		54,
		48,
		54,
		64,
		47,
		-1,
		-1,
		178,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		136,
		130,
		101,
		94,
		98,
		-1,
		86,
		88,
		82,
		97,
		72,
		69,
		60,
		51,
		47,
		51,
		51,
		32,
		38,
		201,
		-1,
		164,
		-1,
		-1,
		-1,
		154,
		169,
		140,
		117,
		90,
		85,
		78,
		72,
		77,
		88,
		80,
		91,
		58,
		54,
		44,
		43,
		47,
		36,
		26,
		-1,
		-1,
		162,
		158,
		180,
		162,
		166,
		167,
		-1,
		-1,
		94,
		85,
		76,
		68,
		81,
		84,
		64,
		61,
		55,
		48,
		42,
		52,
		25,
		20,
		-1,
		-1,
		-1,
		174,
		-1,
		176,
		-1,
		-1,
		164,
		165,
		112,
		94,
		90,
		88,
		77,
		71,
		59,
		64,
		67,
		57,
		49,
		38,
		32,
		39,
		12,
		43,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		153,
		145,
		140,
		146,
		148,
		139,
		127,
		124,
		-1,
		94,
		100,
		65,
		72,
		55,
		62,
		61,
		53,
		32,
		29,
		35,
		15,
		3,
		35,
		26,
		30,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		146,
		142,
		132,
		122,
		125,
		-1,
		-1,
		119,
		116,
		96,
		65,
		63,
		56,
		51,
		61,
		41,
		28,
		22,
		26,
		12,
		5,
		0,
		6,
		21,
		36,
		-1,
		193,
		230,
		223,
		191,
		199,
		230,
		-1,
		136,
		128,
		139,
		114,
		116,
		-1,
		-1,
		92,
		83,
		84,
		72,
		69,
		71,
		66,
		57,
		42,
		48,
		35,
		24,
		41,
		26,
		13,
		20,
		19,
		30,
		34,
		-1,
		186,
		206,
		185,
		188,
		212,
		226,
		-1,
		133,
		-1,
		-1,
		145,
		117,
		101,
		91,
		88,
		131,
		86,
		81,
		65,
		63,
		54,
		45,
		52,
		39,
		33,
		36,
		34,
		28,
		22,
		29,
		24,
		30,
		-1,
		175,
		186,
		179,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		161,
		-1,
		128,
		-1,
		111,
		115,
		94,
		97,
		79,
		66,
		58,
		50,
		66,
		41,
		41,
		37,
		33,
		42,
		32,
		45,
		36,
		30,
		200,
		156,
		159,
		170,
		181,
		196,
		200,
		-1,
		145,
		184,
		178,
		-1,
		162,
		-1,
		-1,
		-1,
		125,
		107,
		99,
		99,
		78,
		78,
		52,
		56,
		46,
		46,
		53,
		50,
		42,
		46,
		55,
		46,
		38,
		196,
		187,
		200,
		145,
		145,
		166,
		175,
		196,
		160,
		151,
		178,
		185,
		174,
		169,
		156,
		-1,
		-1,
		148,
		117,
		-1,
		-1,
		85,
		73,
		56,
		57,
		53,
		56,
		71,
		59,
		49,
		47,
		41,
		51,
		-1,
		189,
		188,
		177,
		174,
		150,
		141,
		136,
		163,
		-1,
		-1,
		158,
		179,
		169,
		173,
		189,
		214,
		-1,
		145,
		-1,
		-1,
		130,
		-1,
		-1,
		115,
		78,
		67,
		58,
		64,
		61,
		72,
		82,
		55,
		56,
		46,
		56,
		65,
		173,
		170,
		158,
		156,
		179,
		144,
		132,
		-1,
		145,
		143,
		149,
		156,
		173,
		203,
		-1,
		-1,
		161,
		141,
		-1,
		-1,
		113,
		111,
		100,
		-1,
		90,
		63,
		68,
		88,
		75,
		64,
		58,
		52,
		59,
		58,
		66,
		70,
		182,
		196,
		185,
		181,
		180,
		188,
		137,
		130,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		108,
		101,
		89,
		77,
		67,
		77,
		80,
		76,
		62,
		55,
		50,
		61,
		53,
		57,
		67,
		-1,
		216,
		-1,
		168,
		144,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		142,
		126,
		107,
		-1,
		77,
		90,
		112,
		80,
		80,
		74,
		56,
		67,
		56,
		59,
		60,
		63,
		-1,
		-1,
		156,
		159,
		-1,
		-1,
		158,
		160,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		114,
		110,
		-1,
		-1,
		78,
		94,
		83,
		86,
		81,
		60,
		66,
		69,
		58,
		62,
		60,
		-1,
		-1,
		163,
		164,
		165,
		-1,
		143,
		-1,
		161,
		-1,
		128,
		134,
		122,
		-1,
		-1,
		-1,
		116,
		79,
		100,
		101,
		89,
		87,
		78,
		64,
		71,
		69,
		65,
		70,
		-1,
		-1,
		-1,
		161,
		135,
		168,
		159,
		142,
		122,
		114,
		133,
		-1,
		103,
		-1,
		78,
		80,
		106,
		97,
		100,
		94,
		67,
		82,
		72,
		63,
		72,
		167,
		-1,
		137,
		170,
		134,
		128,
		104,
		108,
		124,
		-1,
		100,
		82,
		-1,
		110,
		100,
		116,
		101,
		82,
		69,
		76,
		76,
		69,
		-1,
		-1,
		-1,
		139,
		138,
		130,
		124,
		124,
		109,
		100,
		-1,
		112,
		94,
		73,
		90,
		90,
		81,
		89,
		106,
		102,
		89,
		89,
		81,
		-1,
		240,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		133,
		128,
		101,
		89,
		95,
		91,
		77,
		83,
		85,
		93,
		91,
		88,
		100,
		96,
		105,
		82,
		117,
		-1,
		235,
		-1,
		169,
		-1,
		-1,
		151,
		131,
		123,
		112,
		101,
		99,
		90,
		81,
		103,
		119,
		103,
		94,
		89,
		90,
		-1,
		224,
		223,
		-1,
		170,
		162,
		148,
		-1,
		141,
		-1,
		147,
		108,
		-1,
		110,
		90,
		-1,
		105,
		94,
		-1,
		-1,
		211,
		186,
		-1,
		-1,
		-1,
		171,
		151,
		142,
		126,
		-1,
		101,
		101,
		-1,
		-1,
		-1,
		196,
		195,
		-1,
		164,
		167,
		-1,
		157,
		148,
		156,
		103,
		107,
		-1,
		-1,
		-1,
		205,
		186,
		180,
		179,
		177,
		172,
		169,
		155,
		139,
		117,
		106,
		127,
		-1,
		-1,
		-1,
		177,
		169,
		162,
		-1,
		-1,
		164,
		147,
		128,
		126,
		-1,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		154,
		-1,
		-1,
		160,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		188,
		-1,
		-1,
		-1,
		150,
		146,
		147,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		234,
		198,
		-1,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		213,
		211,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		140,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		175,
		-1,
		175,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		188,
		180,
		188,
		-1,
		160,
		162,
		-1,
		210,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		165,
		172,
		194,
		197,
		233,
		-1,
		184
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		218,
		222,
		188,
		182,
		221,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		211,
		210,
		178,
		176,
		185,
		190,
		197,
		-1,
		196,
		-1,
		232,
		211,
		222,
		227,
		171,
		168,
		188,
		207,
		189,
		181,
		247,
		201,
		172,
		166,
		184,
		174,
		183,
		175,
		-1,
		172,
		162,
		184,
		163,
		174,
		166,
		-1,
		-1,
		166,
		167,
		173,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		156,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		151,
		169,
		176,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		150,
		-1,
		160,
		161,
		156,
		164,
		166,
		142,
		129,
		129,
		139,
		132,
		151,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		143,
		160,
		152,
		142,
		157,
		150,
		132,
		129,
		127,
		124,
		140,
		138,
		148,
		-1,
		-1,
		253,
		222,
		251,
		209,
		190,
		-1,
		156,
		136,
		142,
		146,
		140,
		133,
		147,
		143,
		-1,
		118,
		117,
		145,
		131,
		142,
		213,
		-1,
		-1,
		211,
		203,
		186,
		189,
		166,
		162,
		151,
		150,
		142,
		128,
		124,
		130,
		133,
		133,
		139,
		112,
		122,
		126,
		124,
		149,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		193,
		-1,
		176,
		183,
		172,
		178,
		164,
		185,
		161,
		152,
		144,
		138,
		126,
		128,
		125,
		138,
		126,
		109,
		134,
		138,
		119,
		140,
		135,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		169,
		172,
		178,
		202,
		201,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		113,
		111,
		141,
		116,
		138,
		135,
		154,
		159,
		153,
		162,
		-1,
		218,
		214,
		210,
		217,
		166,
		-1,
		-1,
		206,
		-1,
		209,
		210,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		105,
		120,
		111,
		110,
		128,
		138,
		146,
		150,
		156,
		-1,
		268,
		-1,
		210,
		194,
		196,
		168,
		189,
		-1,
		226,
		210,
		202,
		187,
		187,
		-1,
		157,
		154,
		144,
		122,
		107,
		124,
		116,
		114,
		118,
		100,
		114,
		105,
		123,
		130,
		128,
		132,
		152,
		164,
		228,
		218,
		-1,
		200,
		205,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		111,
		96,
		93,
		111,
		114,
		121,
		125,
		141,
		-1,
		-1,
		213,
		217,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		142,
		139,
		127,
		114,
		99,
		100,
		108,
		121,
		100,
		95,
		92,
		112,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		108,
		105,
		110,
		90,
		88,
		107,
		119,
		110,
		126,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		151,
		134,
		115,
		104,
		96,
		85,
		101,
		109,
		104,
		86,
		95,
		101,
		125,
		114,
		120,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		98,
		92,
		101,
		103,
		93,
		88,
		95,
		130,
		130,
		104,
		124,
		127,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		102,
		106,
		99,
		106,
		99,
		97,
		98,
		80,
		112,
		-1,
		112,
		106,
		114,
		104,
		92,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		111,
		109,
		103,
		107,
		104,
		93,
		106,
		99,
		85,
		87,
		100,
		104,
		108,
		94,
		90,
		87,
		90,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		118,
		116,
		107,
		115,
		88,
		81,
		88,
		77,
		95,
		103,
		95,
		89,
		85,
		86,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		116,
		114,
		105,
		93,
		82,
		85,
		77,
		99,
		99,
		83,
		84,
		81,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		125,
		102,
		97,
		87,
		76,
		76,
		71,
		93,
		79,
		77,
		79,
		71,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		130,
		120,
		125,
		-1,
		122,
		-1,
		95,
		92,
		83,
		68,
		65,
		76,
		74,
		85,
		76,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		146,
		126,
		118,
		125,
		117,
		109,
		103,
		81,
		74,
		71,
		64,
		77,
		87,
		90,
		74,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		146,
		134,
		124,
		114,
		119,
		120,
		100,
		93,
		79,
		81,
		75,
		66,
		65,
		81,
		73,
		78,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		174,
		148,
		135,
		-1,
		-1,
		118,
		111,
		105,
		96,
		83,
		95,
		90,
		74,
		59,
		74,
		76,
		68,
		60,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		186,
		131,
		120,
		115,
		119,
		117,
		-1,
		91,
		102,
		87,
		99,
		106,
		76,
		61,
		55,
		61,
		71,
		54,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		143,
		137,
		108,
		101,
		105,
		-1,
		93,
		95,
		89,
		104,
		79,
		76,
		67,
		58,
		54,
		58,
		58,
		39,
		45,
		208,
		-1,
		171,
		-1,
		-1,
		-1,
		161,
		176,
		147,
		124,
		97,
		92,
		85,
		79,
		84,
		95,
		87,
		98,
		65,
		61,
		51,
		50,
		54,
		43,
		33,
		-1,
		-1,
		169,
		165,
		187,
		169,
		173,
		174,
		-1,
		-1,
		101,
		92,
		83,
		75,
		88,
		91,
		71,
		68,
		62,
		55,
		49,
		59,
		32,
		27,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		172,
		119,
		101,
		97,
		95,
		84,
		78,
		66,
		71,
		74,
		64,
		56,
		45,
		39,
		46,
		19,
		37,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		134,
		131,
		-1,
		101,
		107,
		72,
		79,
		62,
		69,
		68,
		60,
		39,
		36,
		42,
		22,
		10,
		29,
		20,
		24,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		103,
		72,
		70,
		63,
		58,
		68,
		48,
		35,
		29,
		33,
		19,
		12,
		7,
		0,
		15,
		30,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		78,
		73,
		64,
		49,
		55,
		38,
		31,
		48,
		33,
		20,
		14,
		13,
		24,
		28,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		95,
		138,
		93,
		88,
		72,
		70,
		61,
		52,
		59,
		46,
		34,
		31,
		40,
		26,
		16,
		23,
		18,
		24,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		168,
		-1,
		135,
		-1,
		118,
		122,
		101,
		104,
		86,
		73,
		65,
		57,
		71,
		46,
		42,
		38,
		27,
		36,
		26,
		39,
		30,
		24,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		152,
		191,
		185,
		-1,
		169,
		-1,
		-1,
		-1,
		132,
		114,
		106,
		106,
		85,
		85,
		59,
		63,
		51,
		47,
		54,
		44,
		36,
		40,
		49,
		40,
		32,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		167,
		158,
		185,
		192,
		181,
		176,
		163,
		-1,
		-1,
		155,
		124,
		-1,
		-1,
		92,
		80,
		63,
		62,
		58,
		61,
		69,
		53,
		43,
		41,
		35,
		45,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		186,
		176,
		180,
		196,
		221,
		-1,
		152,
		-1,
		-1,
		137,
		-1,
		-1,
		122,
		85,
		74,
		65,
		71,
		66,
		73,
		84,
		49,
		50,
		40,
		50,
		59,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		120,
		118,
		107,
		-1,
		97,
		70,
		74,
		93,
		69,
		58,
		52,
		46,
		53,
		52,
		60,
		64,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		115,
		108,
		96,
		84,
		74,
		84,
		74,
		70,
		56,
		49,
		44,
		55,
		47,
		51,
		61,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		149,
		133,
		114,
		-1,
		84,
		97,
		106,
		74,
		74,
		68,
		50,
		61,
		50,
		53,
		54,
		57,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		121,
		117,
		-1,
		-1,
		85,
		88,
		77,
		80,
		75,
		54,
		60,
		63,
		52,
		56,
		54,
		-1,
		-1,
		170,
		171,
		172,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		123,
		86,
		107,
		95,
		83,
		81,
		72,
		58,
		65,
		63,
		59,
		64,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		87,
		109,
		91,
		94,
		88,
		61,
		76,
		66,
		57,
		66,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		107,
		110,
		95,
		76,
		63,
		70,
		70,
		63,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		96,
		100,
		96,
		83,
		83,
		75,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		98,
		95,
		102,
		93,
		99,
		76,
		111,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		100,
		88,
		83,
		84,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		99,
		88,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		166,
		184,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		175,
		176,
		171,
		179,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		158,
		175,
		167,
		157,
		172,
		165,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		268,
		237,
		266,
		224,
		205,
		-1,
		171,
		151,
		157,
		161,
		155,
		148,
		162,
		158,
		-1,
		133,
		132,
		160,
		146,
		157,
		228,
		-1,
		-1,
		226,
		218,
		201,
		204,
		181,
		177,
		166,
		165,
		157,
		143,
		139,
		145,
		148,
		148,
		154,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		183,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		187,
		193,
		179,
		200,
		176,
		167,
		159,
		153,
		141,
		143,
		140,
		153,
		141,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		216,
		-1,
		188,
		176,
		177,
		162,
		159,
		146,
		134,
		147,
		132,
		139,
		138,
		128,
		126,
		156,
		131,
		153,
		148,
		153,
		158,
		152,
		161,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		224,
		225,
		200,
		173,
		176,
		163,
		154,
		141,
		130,
		141,
		130,
		127,
		135,
		120,
		135,
		126,
		125,
		137,
		137,
		145,
		149,
		155,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		225,
		217,
		202,
		202,
		-1,
		172,
		169,
		159,
		137,
		122,
		139,
		131,
		129,
		133,
		115,
		129,
		120,
		138,
		141,
		127,
		131,
		151,
		163,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		244,
		208,
		-1,
		203,
		-1,
		174,
		187,
		-1,
		143,
		139,
		121,
		122,
		117,
		132,
		126,
		111,
		108,
		126,
		129,
		120,
		124,
		140,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		201,
		190,
		189,
		-1,
		180,
		157,
		154,
		142,
		129,
		114,
		115,
		123,
		136,
		115,
		110,
		107,
		127,
		137,
		115,
		126,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		153,
		132,
		123,
		112,
		110,
		123,
		119,
		125,
		105,
		103,
		122,
		118,
		109,
		117,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		164,
		187,
		224,
		198,
		184,
		189,
		164,
		157,
		151,
		166,
		149,
		130,
		119,
		111,
		100,
		115,
		123,
		119,
		101,
		110,
		116,
		124,
		105,
		111,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		178,
		185,
		217,
		189,
		202,
		-1,
		156,
		-1,
		145,
		140,
		124,
		119,
		116,
		107,
		106,
		116,
		118,
		108,
		103,
		110,
		129,
		129,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		228,
		223,
		198,
		175,
		159,
		195,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		126,
		122,
		111,
		115,
		114,
		120,
		108,
		112,
		113,
		95,
		121,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		221,
		200,
		193,
		213,
		154,
		206,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		123,
		118,
		117,
		116,
		113,
		102,
		115,
		108,
		100,
		96,
		109,
		113,
		107,
		85,
		81,
		78,
		81,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		174,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		145,
		129,
		128,
		125,
		116,
		124,
		97,
		90,
		101,
		86,
		104,
		104,
		94,
		84,
		76,
		77,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		187,
		-1,
		151,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		135,
		152,
		153,
		131,
		125,
		123,
		114,
		102,
		91,
		94,
		86,
		106,
		98,
		82,
		79,
		72,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		148,
		136,
		168,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		149,
		147,
		142,
		133,
		139,
		134,
		111,
		106,
		96,
		85,
		85,
		80,
		99,
		85,
		83,
		70,
		62,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		145,
		134,
		139,
		-1,
		131,
		-1,
		104,
		101,
		92,
		77,
		74,
		85,
		83,
		92,
		71,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		205,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		161,
		141,
		133,
		139,
		126,
		118,
		112,
		90,
		83,
		80,
		70,
		83,
		93,
		85,
		69,
		-1,
		-1,
		-1,
		202,
		188,
		192,
		152,
		171,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		162,
		161,
		149,
		139,
		129,
		134,
		134,
		109,
		102,
		88,
		90,
		82,
		72,
		71,
		76,
		68,
		73,
		-1,
		-1,
		185,
		190,
		178,
		164,
		183,
		-1,
		-1,
		-1,
		184,
		200,
		189,
		163,
		150,
		-1,
		-1,
		133,
		126,
		120,
		105,
		92,
		101,
		96,
		81,
		65,
		80,
		71,
		63,
		55,
		-1,
		188,
		175,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		-1,
		-1,
		201,
		146,
		135,
		130,
		134,
		132,
		-1,
		106,
		116,
		96,
		108,
		115,
		83,
		71,
		65,
		56,
		66,
		49,
		-1,
		-1,
		200,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		158,
		152,
		123,
		116,
		120,
		-1,
		108,
		110,
		98,
		114,
		89,
		86,
		77,
		67,
		67,
		53,
		53,
		34,
		40,
		223,
		-1,
		186,
		-1,
		-1,
		-1,
		176,
		191,
		162,
		139,
		112,
		107,
		100,
		94,
		99,
		110,
		97,
		108,
		74,
		70,
		66,
		53,
		49,
		38,
		39,
		-1,
		-1,
		184,
		180,
		202,
		184,
		188,
		189,
		-1,
		-1,
		116,
		107,
		98,
		90,
		103,
		106,
		80,
		77,
		77,
		70,
		63,
		62,
		51,
		45,
		-1,
		-1,
		-1,
		196,
		-1,
		198,
		-1,
		-1,
		186,
		187,
		134,
		116,
		112,
		110,
		99,
		93,
		81,
		85,
		89,
		79,
		71,
		60,
		54,
		64,
		38,
		28,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		175,
		167,
		162,
		168,
		170,
		161,
		149,
		146,
		-1,
		116,
		122,
		87,
		94,
		77,
		84,
		83,
		75,
		54,
		51,
		57,
		41,
		29,
		20,
		11,
		15,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		141,
		138,
		118,
		87,
		85,
		78,
		73,
		83,
		63,
		50,
		44,
		48,
		34,
		31,
		26,
		19,
		0,
		21,
		-1,
		215,
		252,
		245,
		213,
		221,
		252,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		114,
		105,
		106,
		94,
		91,
		93,
		88,
		79,
		64,
		70,
		48,
		46,
		63,
		48,
		39,
		24,
		13,
		26,
		30,
		-1,
		208,
		228,
		207,
		210,
		234,
		248,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		110,
		153,
		108,
		103,
		87,
		85,
		76,
		67,
		72,
		56,
		44,
		41,
		50,
		36,
		26,
		23,
		21,
		24,
		-1,
		197,
		208,
		201,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		133,
		137,
		116,
		119,
		101,
		88,
		80,
		72,
		81,
		56,
		52,
		48,
		37,
		46,
		36,
		44,
		30,
		27,
		222,
		178,
		181,
		192,
		203,
		218,
		222,
		-1,
		167,
		206,
		200,
		-1,
		184,
		-1,
		-1,
		-1,
		147,
		129,
		121,
		121,
		100,
		100,
		74,
		75,
		61,
		57,
		64,
		54,
		46,
		50,
		52,
		40,
		35,
		218,
		209,
		222,
		167,
		167,
		188,
		197,
		218,
		182,
		173,
		200,
		207,
		196,
		191,
		178,
		-1,
		-1,
		170,
		139,
		-1,
		-1,
		107,
		95,
		78,
		72,
		68,
		71,
		79,
		63,
		53,
		51,
		45,
		45,
		-1,
		211,
		210,
		199,
		196,
		172,
		163,
		158,
		185,
		-1,
		-1,
		180,
		201,
		191,
		195,
		211,
		236,
		-1,
		167,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		100,
		89,
		80,
		83,
		76,
		83,
		94,
		59,
		60,
		50,
		60,
		59,
		195,
		192,
		180,
		178,
		201,
		166,
		154,
		-1,
		167,
		165,
		171,
		178,
		195,
		225,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		84,
		103,
		79,
		68,
		62,
		56,
		63,
		62,
		70,
		64,
		204,
		218,
		207,
		203,
		202,
		210,
		159,
		152,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		98,
		84,
		80,
		66,
		59,
		54,
		65,
		57,
		61,
		61,
		-1,
		238,
		-1,
		190,
		166,
		180,
		195,
		203,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		116,
		84,
		84,
		78,
		60,
		71,
		60,
		63,
		54,
		57,
		-1,
		-1,
		178,
		181,
		-1,
		-1,
		180,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		98,
		87,
		90,
		85,
		64,
		70,
		73,
		62,
		60,
		54,
		-1,
		-1,
		185,
		186,
		187,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		138,
		101,
		122,
		105,
		93,
		91,
		82,
		68,
		75,
		73,
		69,
		64,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		102,
		119,
		101,
		104,
		98,
		71,
		86,
		76,
		67,
		70,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		132,
		122,
		120,
		105,
		86,
		73,
		80,
		74,
		67,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		111,
		110,
		106,
		93,
		93,
		83,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		113,
		110,
		108,
		99,
		105,
		82,
		115,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		106,
		94,
		89,
		90,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		105,
		94,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		248,
		252,
		218,
		212,
		251,
		220,
		226,
		237,
		-1,
		-1,
		-1,
		241,
		240,
		208,
		206,
		215,
		220,
		227,
		-1,
		226,
		-1,
		262,
		241,
		252,
		257,
		201,
		198,
		218,
		237,
		219,
		211,
		277,
		231,
		202,
		196,
		214,
		204,
		213,
		205,
		-1,
		202,
		192,
		214,
		193,
		204,
		196,
		-1,
		-1,
		196,
		197,
		203,
		189,
		195,
		191,
		-1,
		201,
		185,
		-1,
		-1,
		186,
		187,
		171,
		174,
		182,
		180,
		193,
		185,
		180,
		-1,
		-1,
		177,
		173,
		180,
		167,
		163,
		180,
		193,
		175,
		189,
		188,
		-1,
		183,
		201,
		206,
		174,
		172,
		156,
		154,
		172,
		174,
		180,
		180,
		-1,
		192,
		193,
		188,
		196,
		196,
		172,
		159,
		159,
		169,
		162,
		181,
		169,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		162,
		159,
		157,
		154,
		170,
		168,
		178,
		-1,
		-1,
		283,
		252,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		148,
		147,
		175,
		161,
		172,
		243,
		-1,
		-1,
		241,
		233,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		142,
		152,
		156,
		154,
		179,
		-1,
		-1,
		196,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		139,
		164,
		168,
		149,
		170,
		165,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		143,
		141,
		171,
		146,
		168,
		161,
		166,
		171,
		165,
		174,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		135,
		150,
		141,
		140,
		150,
		150,
		158,
		162,
		168,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		242,
		234,
		219,
		217,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		148,
		130,
		144,
		135,
		153,
		154,
		140,
		144,
		164,
		176,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		259,
		223,
		-1,
		218,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		141,
		126,
		123,
		141,
		144,
		133,
		137,
		153,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		216,
		205,
		204,
		-1,
		195,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		152,
		131,
		125,
		122,
		142,
		150,
		128,
		139,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		234,
		227,
		215,
		180,
		180,
		174,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		132,
		140,
		120,
		118,
		137,
		131,
		122,
		130,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		179,
		202,
		239,
		213,
		199,
		204,
		179,
		172,
		166,
		183,
		166,
		147,
		136,
		128,
		117,
		128,
		136,
		134,
		116,
		125,
		131,
		137,
		118,
		124,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		193,
		200,
		232,
		204,
		217,
		-1,
		171,
		-1,
		160,
		156,
		141,
		136,
		133,
		120,
		119,
		133,
		133,
		123,
		118,
		125,
		142,
		142,
		108,
		128,
		131,
		-1,
		-1,
		-1,
		243,
		238,
		213,
		190,
		174,
		210,
		-1,
		187,
		188,
		-1,
		165,
		159,
		156,
		143,
		139,
		124,
		128,
		130,
		133,
		121,
		127,
		128,
		110,
		134,
		-1,
		116,
		110,
		118,
		108,
		96,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		172,
		165,
		-1,
		152,
		134,
		136,
		131,
		130,
		129,
		126,
		115,
		128,
		121,
		115,
		109,
		122,
		126,
		120,
		98,
		94,
		91,
		94,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		181,
		173,
		163,
		157,
		151,
		147,
		145,
		158,
		142,
		141,
		138,
		129,
		137,
		110,
		103,
		114,
		99,
		117,
		117,
		107,
		97,
		89,
		90,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		180,
		196,
		-1,
		189,
		168,
		183,
		161,
		157,
		148,
		165,
		166,
		144,
		138,
		136,
		127,
		115,
		104,
		107,
		99,
		119,
		111,
		95,
		92,
		85,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		151,
		183,
		-1,
		-1,
		225,
		-1,
		159,
		176,
		162,
		160,
		155,
		146,
		152,
		147,
		124,
		119,
		109,
		98,
		98,
		93,
		112,
		98,
		96,
		83,
		75,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		203,
		193,
		177,
		162,
		195,
		-1,
		163,
		147,
		152,
		-1,
		144,
		-1,
		117,
		114,
		105,
		90,
		87,
		98,
		96,
		105,
		84,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		220,
		-1,
		-1,
		190,
		184,
		184,
		168,
		171,
		179,
		159,
		153,
		152,
		139,
		131,
		125,
		103,
		96,
		93,
		83,
		96,
		106,
		98,
		82,
		-1,
		-1,
		-1,
		217,
		203,
		207,
		167,
		186,
		-1,
		-1,
		252,
		207,
		193,
		-1,
		177,
		182,
		170,
		160,
		150,
		155,
		147,
		122,
		115,
		101,
		103,
		95,
		85,
		84,
		89,
		81,
		86,
		-1,
		-1,
		200,
		205,
		193,
		179,
		198,
		-1,
		-1,
		-1,
		199,
		215,
		207,
		178,
		171,
		-1,
		-1,
		154,
		147,
		139,
		118,
		105,
		114,
		109,
		94,
		78,
		93,
		84,
		76,
		68,
		-1,
		203,
		190,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		-1,
		-1,
		222,
		167,
		156,
		151,
		155,
		153,
		-1,
		127,
		129,
		109,
		121,
		128,
		96,
		84,
		78,
		69,
		79,
		62,
		-1,
		-1,
		215,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		179,
		173,
		144,
		137,
		141,
		-1,
		129,
		125,
		111,
		127,
		102,
		99,
		90,
		80,
		80,
		66,
		66,
		47,
		53,
		238,
		-1,
		207,
		-1,
		-1,
		-1,
		197,
		212,
		183,
		160,
		133,
		128,
		121,
		115,
		119,
		124,
		110,
		121,
		87,
		83,
		79,
		66,
		62,
		51,
		52,
		-1,
		-1,
		205,
		201,
		223,
		205,
		209,
		210,
		-1,
		-1,
		137,
		128,
		119,
		111,
		124,
		127,
		93,
		90,
		90,
		83,
		76,
		75,
		72,
		58,
		-1,
		-1,
		-1,
		217,
		-1,
		219,
		-1,
		-1,
		207,
		208,
		155,
		137,
		133,
		131,
		120,
		114,
		102,
		98,
		108,
		100,
		92,
		73,
		75,
		85,
		59,
		41,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		196,
		188,
		183,
		189,
		191,
		182,
		170,
		167,
		-1,
		137,
		143,
		108,
		115,
		98,
		105,
		104,
		96,
		75,
		72,
		78,
		62,
		50,
		33,
		18,
		9,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		189,
		185,
		175,
		165,
		168,
		-1,
		-1,
		162,
		159,
		139,
		108,
		106,
		99,
		94,
		104,
		84,
		71,
		65,
		69,
		55,
		52,
		47,
		40,
		27,
		0,
		-1,
		236,
		273,
		266,
		234,
		242,
		273,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		135,
		126,
		127,
		115,
		112,
		114,
		109,
		100,
		85,
		91,
		69,
		67,
		84,
		69,
		60,
		45,
		34,
		47,
		51,
		-1,
		229,
		249,
		228,
		231,
		255,
		269,
		-1,
		176,
		-1,
		-1,
		188,
		160,
		144,
		134,
		131,
		174,
		129,
		124,
		108,
		106,
		97,
		88,
		93,
		77,
		65,
		62,
		71,
		57,
		47,
		44,
		42,
		45,
		-1,
		218,
		229,
		222,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		204,
		-1,
		171,
		-1,
		154,
		158,
		137,
		140,
		122,
		109,
		101,
		93,
		102,
		77,
		73,
		69,
		58,
		67,
		57,
		65,
		51,
		48,
		243,
		199,
		202,
		213,
		224,
		239,
		243,
		-1,
		188,
		227,
		221,
		-1,
		205,
		-1,
		-1,
		-1,
		168,
		150,
		142,
		142,
		121,
		121,
		95,
		96,
		82,
		78,
		85,
		75,
		67,
		71,
		73,
		61,
		56,
		239,
		230,
		243,
		188,
		188,
		209,
		218,
		239,
		203,
		194,
		221,
		228,
		217,
		212,
		199,
		-1,
		-1,
		191,
		160,
		-1,
		-1,
		128,
		116,
		99,
		93,
		89,
		92,
		100,
		84,
		74,
		72,
		66,
		66,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		179,
		206,
		-1,
		-1,
		201,
		222,
		212,
		216,
		232,
		257,
		-1,
		188,
		-1,
		-1,
		173,
		-1,
		-1,
		158,
		121,
		110,
		101,
		104,
		97,
		104,
		115,
		80,
		81,
		71,
		81,
		80,
		216,
		213,
		201,
		199,
		222,
		187,
		175,
		-1,
		188,
		186,
		192,
		199,
		216,
		246,
		-1,
		-1,
		204,
		184,
		-1,
		-1,
		156,
		154,
		143,
		-1,
		133,
		106,
		105,
		124,
		100,
		89,
		83,
		77,
		84,
		83,
		91,
		85,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		173,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		194,
		190,
		-1,
		-1,
		151,
		144,
		132,
		120,
		110,
		119,
		105,
		101,
		87,
		80,
		75,
		86,
		78,
		82,
		82,
		-1,
		259,
		-1,
		211,
		187,
		201,
		216,
		224,
		-1,
		-1,
		-1,
		211,
		197,
		190,
		178,
		176,
		-1,
		185,
		169,
		150,
		-1,
		120,
		133,
		137,
		105,
		105,
		99,
		81,
		92,
		81,
		84,
		75,
		78,
		-1,
		-1,
		199,
		202,
		-1,
		-1,
		201,
		203,
		-1,
		202,
		191,
		176,
		168,
		-1,
		-1,
		157,
		153,
		-1,
		-1,
		121,
		119,
		108,
		111,
		106,
		85,
		91,
		94,
		83,
		81,
		75,
		-1,
		-1,
		206,
		207,
		208,
		-1,
		186,
		-1,
		204,
		-1,
		171,
		177,
		165,
		-1,
		-1,
		-1,
		159,
		122,
		143,
		126,
		114,
		112,
		103,
		89,
		96,
		94,
		90,
		85,
		-1,
		-1,
		-1,
		204,
		178,
		211,
		202,
		185,
		165,
		157,
		176,
		-1,
		146,
		-1,
		121,
		123,
		140,
		122,
		125,
		119,
		92,
		107,
		97,
		88,
		91,
		210,
		-1,
		180,
		213,
		177,
		171,
		147,
		151,
		167,
		-1,
		143,
		125,
		-1,
		153,
		143,
		141,
		126,
		107,
		94,
		101,
		95,
		88,
		-1,
		-1,
		-1,
		182,
		181,
		173,
		167,
		167,
		152,
		143,
		-1,
		155,
		137,
		116,
		133,
		133,
		124,
		132,
		131,
		127,
		114,
		114,
		104,
		-1,
		283,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		176,
		171,
		144,
		132,
		138,
		134,
		120,
		126,
		128,
		136,
		134,
		131,
		129,
		120,
		126,
		103,
		136,
		-1,
		278,
		-1,
		212,
		-1,
		-1,
		194,
		174,
		166,
		155,
		144,
		142,
		133,
		124,
		146,
		162,
		127,
		115,
		110,
		111,
		-1,
		267,
		266,
		-1,
		213,
		205,
		191,
		-1,
		184,
		-1,
		190,
		151,
		-1,
		153,
		133,
		-1,
		126,
		115,
		-1,
		-1,
		254,
		229,
		-1,
		-1,
		-1,
		214,
		194,
		185,
		169,
		-1,
		144,
		144,
		-1,
		-1,
		-1,
		239,
		238,
		-1,
		207,
		210,
		-1,
		200,
		191,
		199,
		146,
		150,
		-1,
		-1,
		-1,
		248,
		229,
		223,
		222,
		220,
		215,
		212,
		198,
		182,
		160,
		149,
		170,
		-1,
		-1,
		-1,
		220,
		212,
		205,
		-1,
		-1,
		207,
		190,
		171,
		169,
		-1,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		197,
		-1,
		-1,
		203,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		231,
		-1,
		-1,
		-1,
		193,
		189,
		190,
		-1,
		-1,
		-1,
		-1,
		253,
		254,
		277,
		241,
		-1,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		256,
		254,
		-1,
		-1,
		-1,
		213,
		197,
		-1,
		183,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		218,
		-1,
		218,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		231,
		223,
		231,
		-1,
		203,
		205,
		-1,
		253,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		208,
		215,
		237,
		240,
		276,
		-1,
		227
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		231,
		220,
		231,
		239,
		212,
		219,
		-1,
		240,
		242,
		208,
		202,
		241,
		212,
		218,
		229,
		-1,
		-1,
		-1,
		231,
		230,
		200,
		198,
		207,
		212,
		219,
		-1,
		242,
		-1,
		252,
		231,
		242,
		247,
		193,
		190,
		210,
		229,
		235,
		227,
		267,
		223,
		194,
		188,
		206,
		211,
		229,
		221,
		-1,
		194,
		184,
		206,
		210,
		222,
		205,
		-1,
		-1,
		188,
		189,
		195,
		207,
		212,
		217,
		-1,
		243,
		227,
		-1,
		-1,
		178,
		191,
		187,
		190,
		198,
		214,
		235,
		227,
		222,
		-1,
		-1,
		179,
		183,
		196,
		197,
		195,
		222,
		235,
		217,
		231,
		230,
		-1,
		167,
		185,
		194,
		203,
		209,
		198,
		196,
		214,
		216,
		222,
		225,
		-1,
		159,
		161,
		190,
		196,
		208,
		214,
		201,
		201,
		211,
		204,
		223,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		164,
		190,
		189,
		185,
		203,
		211,
		204,
		201,
		199,
		196,
		212,
		213,
		223,
		-1,
		-1,
		212,
		181,
		216,
		173,
		158,
		-1,
		152,
		171,
		177,
		181,
		186,
		194,
		208,
		204,
		-1,
		190,
		189,
		220,
		206,
		217,
		172,
		-1,
		-1,
		170,
		162,
		147,
		150,
		147,
		147,
		177,
		176,
		181,
		183,
		185,
		191,
		194,
		194,
		200,
		184,
		194,
		198,
		209,
		224,
		-1,
		-1,
		279,
		-1,
		-1,
		169,
		152,
		-1,
		135,
		142,
		142,
		159,
		149,
		170,
		185,
		189,
		197,
		199,
		187,
		189,
		186,
		199,
		187,
		181,
		206,
		210,
		204,
		225,
		220,
		-1,
		278,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		128,
		131,
		137,
		161,
		171,
		-1,
		192,
		190,
		214,
		208,
		205,
		192,
		180,
		193,
		178,
		185,
		184,
		188,
		190,
		223,
		201,
		223,
		220,
		249,
		254,
		248,
		257,
		-1,
		177,
		173,
		169,
		176,
		125,
		-1,
		-1,
		165,
		-1,
		179,
		192,
		199,
		194,
		197,
		209,
		200,
		187,
		176,
		187,
		176,
		173,
		181,
		190,
		201,
		196,
		195,
		213,
		228,
		241,
		245,
		251,
		-1,
		227,
		-1,
		169,
		153,
		155,
		127,
		148,
		-1,
		185,
		180,
		200,
		201,
		192,
		-1,
		195,
		198,
		205,
		183,
		168,
		185,
		177,
		175,
		180,
		185,
		199,
		190,
		208,
		215,
		223,
		227,
		247,
		259,
		187,
		177,
		-1,
		159,
		164,
		123,
		131,
		150,
		223,
		198,
		-1,
		193,
		-1,
		185,
		210,
		-1,
		189,
		185,
		167,
		168,
		163,
		178,
		184,
		181,
		178,
		196,
		199,
		216,
		220,
		236,
		-1,
		-1,
		172,
		176,
		165,
		116,
		135,
		159,
		196,
		191,
		180,
		179,
		-1,
		170,
		200,
		197,
		183,
		170,
		160,
		161,
		169,
		182,
		161,
		180,
		183,
		205,
		233,
		211,
		223,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		142,
		113,
		137,
		179,
		209,
		202,
		190,
		155,
		155,
		149,
		-1,
		190,
		173,
		169,
		158,
		156,
		169,
		164,
		180,
		184,
		183,
		202,
		214,
		205,
		225,
		-1,
		-1,
		-1,
		172,
		161,
		162,
		111,
		134,
		168,
		188,
		174,
		179,
		154,
		147,
		141,
		193,
		190,
		157,
		165,
		157,
		146,
		160,
		168,
		172,
		181,
		190,
		196,
		220,
		220,
		226,
		-1,
		-1,
		179,
		169,
		153,
		155,
		152,
		125,
		132,
		164,
		179,
		176,
		-1,
		146,
		-1,
		135,
		143,
		142,
		148,
		160,
		146,
		151,
		162,
		174,
		187,
		183,
		190,
		225,
		225,
		210,
		230,
		233,
		-1,
		-1,
		-1,
		172,
		170,
		145,
		122,
		106,
		142,
		-1,
		146,
		147,
		-1,
		140,
		134,
		140,
		139,
		146,
		143,
		143,
		157,
		165,
		161,
		177,
		183,
		175,
		211,
		-1,
		218,
		212,
		220,
		210,
		198,
		-1,
		-1,
		-1,
		168,
		147,
		140,
		160,
		101,
		153,
		-1,
		-1,
		131,
		124,
		-1,
		127,
		127,
		134,
		143,
		148,
		153,
		161,
		156,
		169,
		174,
		180,
		185,
		203,
		207,
		211,
		200,
		196,
		193,
		207,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		121,
		-1,
		134,
		126,
		122,
		116,
		122,
		140,
		138,
		158,
		150,
		164,
		164,
		170,
		178,
		163,
		166,
		182,
		180,
		198,
		206,
		198,
		192,
		191,
		203,
		-1,
		188,
		174,
		145,
		-1,
		-1,
		134,
		-1,
		98,
		112,
		128,
		-1,
		156,
		135,
		158,
		136,
		150,
		146,
		184,
		185,
		163,
		168,
		176,
		186,
		188,
		177,
		188,
		180,
		202,
		202,
		186,
		187,
		196,
		-1,
		194,
		181,
		139,
		135,
		124,
		144,
		95,
		104,
		115,
		-1,
		-1,
		200,
		-1,
		134,
		151,
		160,
		158,
		174,
		165,
		171,
		187,
		190,
		192,
		182,
		171,
		177,
		174,
		196,
		182,
		180,
		199,
		215,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		110,
		97,
		91,
		-1,
		132,
		-1,
		178,
		168,
		152,
		137,
		170,
		-1,
		182,
		166,
		171,
		-1,
		217,
		-1,
		190,
		192,
		186,
		171,
		168,
		179,
		177,
		188,
		205,
		-1,
		144,
		129,
		122,
		112,
		126,
		97,
		-1,
		140,
		-1,
		-1,
		165,
		159,
		159,
		143,
		146,
		198,
		178,
		172,
		171,
		212,
		210,
		198,
		184,
		177,
		174,
		171,
		184,
		204,
		195,
		207,
		-1,
		-1,
		-1,
		149,
		101,
		109,
		85,
		106,
		-1,
		-1,
		227,
		182,
		168,
		-1,
		152,
		215,
		203,
		193,
		183,
		210,
		211,
		201,
		196,
		182,
		184,
		182,
		180,
		185,
		206,
		207,
		220,
		-1,
		-1,
		98,
		111,
		113,
		99,
		118,
		-1,
		-1,
		-1,
		174,
		190,
		182,
		153,
		204,
		-1,
		-1,
		195,
		193,
		196,
		199,
		186,
		206,
		209,
		195,
		179,
		194,
		206,
		214,
		219,
		-1,
		101,
		88,
		-1,
		-1,
		121,
		115,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		185,
		199,
		203,
		198,
		-1,
		182,
		193,
		186,
		204,
		211,
		197,
		189,
		183,
		189,
		207,
		224,
		-1,
		-1,
		135,
		-1,
		130,
		-1,
		-1,
		-1,
		-1,
		164,
		178,
		192,
		185,
		189,
		-1,
		184,
		186,
		183,
		195,
		200,
		204,
		195,
		177,
		191,
		192,
		205,
		219,
		223,
		158,
		-1,
		141,
		-1,
		-1,
		-1,
		182,
		197,
		225,
		202,
		181,
		174,
		171,
		170,
		175,
		186,
		195,
		206,
		171,
		175,
		190,
		195,
		197,
		214,
		220,
		-1,
		-1,
		141,
		158,
		193,
		190,
		194,
		252,
		-1,
		-1,
		170,
		163,
		173,
		166,
		179,
		182,
		167,
		169,
		187,
		200,
		194,
		204,
		219,
		214,
		-1,
		-1,
		-1,
		161,
		-1,
		176,
		-1,
		-1,
		202,
		243,
		190,
		172,
		168,
		154,
		161,
		155,
		157,
		162,
		181,
		176,
		185,
		190,
		194,
		217,
		206,
		245,
		-1,
		-1,
		113,
		-1,
		-1,
		-1,
		161,
		165,
		175,
		181,
		186,
		177,
		205,
		202,
		-1,
		151,
		184,
		152,
		166,
		162,
		169,
		174,
		180,
		184,
		191,
		207,
		206,
		201,
		237,
		228,
		234,
		-1,
		-1,
		106,
		95,
		84,
		90,
		-1,
		154,
		177,
		167,
		157,
		163,
		-1,
		-1,
		169,
		166,
		164,
		144,
		150,
		155,
		158,
		196,
		172,
		180,
		184,
		188,
		194,
		199,
		204,
		210,
		225,
		240,
		-1,
		0,
		82,
		75,
		58,
		66,
		97,
		-1,
		144,
		136,
		164,
		149,
		157,
		-1,
		-1,
		142,
		133,
		138,
		147,
		148,
		179,
		178,
		191,
		194,
		199,
		187,
		186,
		204,
		208,
		217,
		224,
		214,
		227,
		231,
		-1,
		15,
		58,
		52,
		55,
		79,
		93,
		-1,
		135,
		-1,
		-1,
		180,
		167,
		151,
		141,
		138,
		185,
		161,
		156,
		162,
		164,
		188,
		179,
		204,
		195,
		195,
		198,
		213,
		218,
		210,
		224,
		224,
		225,
		-1,
		50,
		38,
		46,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		196,
		-1,
		178,
		-1,
		161,
		165,
		169,
		172,
		187,
		174,
		181,
		198,
		204,
		193,
		203,
		199,
		200,
		209,
		220,
		232,
		231,
		232,
		124,
		79,
		46,
		37,
		84,
		99,
		103,
		-1,
		119,
		155,
		165,
		-1,
		205,
		-1,
		-1,
		-1,
		175,
		182,
		174,
		190,
		186,
		186,
		182,
		186,
		198,
		205,
		215,
		217,
		209,
		213,
		226,
		237,
		240,
		120,
		118,
		123,
		68,
		51,
		69,
		78,
		99,
		115,
		112,
		149,
		154,
		169,
		174,
		198,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		193,
		203,
		186,
		188,
		192,
		206,
		218,
		226,
		216,
		214,
		208,
		240,
		-1,
		120,
		119,
		108,
		105,
		81,
		72,
		59,
		70,
		-1,
		-1,
		113,
		140,
		124,
		128,
		144,
		169,
		-1,
		205,
		-1,
		-1,
		219,
		-1,
		-1,
		245,
		208,
		197,
		188,
		194,
		200,
		211,
		233,
		222,
		223,
		213,
		223,
		236,
		104,
		101,
		89,
		87,
		110,
		67,
		63,
		-1,
		95,
		98,
		104,
		111,
		128,
		158,
		-1,
		-1,
		221,
		212,
		-1,
		-1,
		238,
		241,
		230,
		-1,
		220,
		193,
		198,
		223,
		230,
		231,
		225,
		219,
		226,
		225,
		233,
		241,
		113,
		127,
		116,
		112,
		111,
		119,
		68,
		85,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		-1,
		244,
		231,
		-1,
		-1,
		238,
		231,
		219,
		207,
		197,
		207,
		215,
		215,
		218,
		222,
		217,
		228,
		220,
		224,
		241,
		-1,
		147,
		-1,
		99,
		92,
		107,
		122,
		130,
		-1,
		-1,
		-1,
		261,
		247,
		240,
		228,
		226,
		-1,
		272,
		256,
		237,
		-1,
		207,
		220,
		251,
		219,
		224,
		219,
		223,
		234,
		223,
		226,
		240,
		235,
		-1,
		-1,
		105,
		108,
		-1,
		-1,
		130,
		149,
		-1,
		252,
		241,
		226,
		218,
		-1,
		-1,
		244,
		240,
		-1,
		-1,
		208,
		233,
		222,
		230,
		225,
		227,
		233,
		236,
		225,
		229,
		241,
		-1,
		-1,
		112,
		113,
		118,
		-1,
		139,
		-1,
		254,
		-1,
		221,
		228,
		216,
		-1,
		-1,
		-1,
		246,
		209,
		230,
		240,
		245,
		243,
		234,
		231,
		238,
		236,
		232,
		243,
		-1,
		-1,
		-1,
		169,
		146,
		261,
		252,
		235,
		215,
		207,
		227,
		-1,
		234,
		-1,
		209,
		210,
		237,
		239,
		256,
		250,
		234,
		249,
		239,
		230,
		239,
		175,
		-1,
		150,
		209,
		192,
		221,
		187,
		199,
		255,
		-1,
		231,
		213,
		-1,
		241,
		231,
		273,
		254,
		247,
		234,
		241,
		243,
		236,
		-1,
		-1,
		-1,
		165,
		164,
		163,
		174,
		182,
		180,
		198,
		-1,
		243,
		225,
		204,
		221,
		221,
		212,
		220,
		263,
		259,
		252,
		254,
		244,
		-1,
		219,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		191,
		213,
		208,
		200,
		212,
		221,
		208,
		214,
		216,
		224,
		222,
		219,
		231,
		227,
		247,
		243,
		275,
		-1,
		226,
		-1,
		195,
		-1,
		-1,
		209,
		195,
		207,
		218,
		208,
		208,
		213,
		211,
		233,
		250,
		234,
		232,
		237,
		242,
		-1,
		236,
		237,
		-1,
		228,
		220,
		206,
		-1,
		199,
		-1,
		254,
		215,
		-1,
		240,
		220,
		-1,
		243,
		239,
		-1,
		-1,
		248,
		244,
		-1,
		-1,
		-1,
		229,
		209,
		249,
		233,
		-1,
		231,
		231,
		-1,
		-1,
		-1,
		262,
		253,
		-1,
		222,
		225,
		-1,
		216,
		222,
		251,
		233,
		237,
		-1,
		-1,
		-1,
		278,
		259,
		253,
		237,
		242,
		230,
		247,
		233,
		235,
		247,
		236,
		257,
		-1,
		-1,
		-1,
		250,
		242,
		242,
		-1,
		-1,
		260,
		243,
		243,
		256,
		-1,
		-1,
		-1,
		272,
		253,
		-1,
		-1,
		251,
		-1,
		-1,
		256,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		261,
		-1,
		-1,
		-1,
		252,
		259,
		267,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		307,
		282,
		-1,
		-1,
		-1,
		266,
		266,
		-1,
		-1,
		277,
		278,
		-1,
		-1,
		-1,
		294,
		278,
		-1,
		270,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		299,
		-1,
		305,
		280,
		287,
		-1,
		-1,
		-1,
		-1,
		312,
		304,
		318,
		-1,
		290,
		292,
		-1,
		340,
		-1,
		-1,
		327,
		318,
		-1,
		-1,
		295,
		302,
		324,
		327,
		357,
		-1,
		314
	],
	[
		-1,
		302,
		291,
		302,
		310,
		283,
		290,
		-1,
		311,
		313,
		279,
		273,
		312,
		283,
		289,
		300,
		-1,
		-1,
		-1,
		302,
		301,
		271,
		269,
		278,
		283,
		290,
		-1,
		313,
		-1,
		323,
		302,
		313,
		318,
		264,
		261,
		281,
		300,
		306,
		298,
		338,
		294,
		265,
		259,
		277,
		282,
		300,
		292,
		-1,
		265,
		255,
		277,
		281,
		293,
		276,
		-1,
		-1,
		259,
		260,
		266,
		278,
		283,
		288,
		-1,
		314,
		298,
		-1,
		-1,
		249,
		262,
		258,
		261,
		269,
		285,
		306,
		298,
		293,
		-1,
		-1,
		250,
		254,
		267,
		268,
		266,
		293,
		306,
		288,
		302,
		301,
		-1,
		238,
		256,
		265,
		274,
		280,
		269,
		267,
		285,
		287,
		293,
		296,
		-1,
		230,
		232,
		261,
		267,
		279,
		285,
		272,
		272,
		282,
		275,
		294,
		285,
		331,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		227,
		235,
		261,
		260,
		256,
		274,
		282,
		275,
		272,
		270,
		267,
		283,
		284,
		294,
		-1,
		-1,
		283,
		252,
		287,
		244,
		229,
		-1,
		223,
		242,
		248,
		252,
		257,
		265,
		279,
		275,
		-1,
		261,
		260,
		291,
		277,
		288,
		243,
		-1,
		-1,
		241,
		233,
		218,
		221,
		218,
		218,
		248,
		247,
		252,
		254,
		256,
		262,
		265,
		265,
		271,
		255,
		265,
		269,
		280,
		295,
		-1,
		-1,
		350,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		213,
		230,
		220,
		241,
		256,
		260,
		268,
		270,
		258,
		260,
		257,
		270,
		258,
		252,
		277,
		281,
		275,
		296,
		291,
		-1,
		349,
		333,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		242,
		-1,
		263,
		261,
		285,
		279,
		276,
		263,
		251,
		264,
		249,
		256,
		255,
		259,
		261,
		294,
		272,
		294,
		291,
		320,
		325,
		319,
		328,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		250,
		263,
		270,
		265,
		268,
		280,
		271,
		258,
		247,
		258,
		247,
		244,
		252,
		261,
		272,
		267,
		266,
		284,
		299,
		312,
		316,
		322,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		251,
		271,
		272,
		263,
		-1,
		266,
		269,
		276,
		254,
		239,
		256,
		248,
		246,
		251,
		256,
		270,
		261,
		279,
		286,
		294,
		298,
		318,
		330,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		294,
		269,
		-1,
		264,
		-1,
		256,
		281,
		-1,
		260,
		256,
		238,
		239,
		234,
		249,
		255,
		252,
		249,
		267,
		270,
		287,
		291,
		307,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		262,
		251,
		250,
		-1,
		241,
		271,
		268,
		254,
		241,
		231,
		232,
		240,
		253,
		232,
		251,
		254,
		276,
		304,
		282,
		293,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		280,
		273,
		261,
		226,
		226,
		220,
		-1,
		261,
		244,
		240,
		229,
		227,
		240,
		235,
		251,
		255,
		254,
		273,
		285,
		276,
		284,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		182,
		205,
		239,
		259,
		245,
		250,
		225,
		218,
		212,
		264,
		261,
		228,
		236,
		228,
		217,
		231,
		239,
		243,
		252,
		261,
		267,
		291,
		272,
		278,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		196,
		203,
		235,
		250,
		247,
		-1,
		217,
		-1,
		206,
		214,
		213,
		219,
		231,
		217,
		222,
		233,
		245,
		258,
		254,
		261,
		296,
		296,
		262,
		282,
		285,
		-1,
		-1,
		-1,
		243,
		241,
		216,
		193,
		177,
		213,
		-1,
		217,
		218,
		-1,
		211,
		205,
		211,
		210,
		217,
		214,
		214,
		228,
		236,
		232,
		248,
		254,
		246,
		270,
		-1,
		270,
		264,
		272,
		262,
		250,
		-1,
		-1,
		-1,
		239,
		218,
		211,
		231,
		172,
		224,
		-1,
		-1,
		202,
		195,
		-1,
		198,
		198,
		205,
		214,
		219,
		224,
		232,
		227,
		240,
		245,
		251,
		245,
		258,
		262,
		263,
		252,
		248,
		245,
		259,
		-1,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		192,
		-1,
		205,
		197,
		193,
		187,
		193,
		211,
		209,
		229,
		221,
		235,
		235,
		241,
		249,
		234,
		237,
		250,
		235,
		253,
		259,
		250,
		245,
		244,
		255,
		-1,
		259,
		245,
		216,
		-1,
		-1,
		205,
		-1,
		169,
		183,
		199,
		-1,
		227,
		206,
		229,
		207,
		221,
		217,
		255,
		256,
		234,
		239,
		247,
		248,
		251,
		240,
		243,
		235,
		257,
		254,
		238,
		240,
		249,
		-1,
		265,
		252,
		210,
		206,
		195,
		215,
		166,
		175,
		186,
		-1,
		-1,
		271,
		-1,
		205,
		222,
		231,
		229,
		245,
		236,
		242,
		258,
		245,
		240,
		245,
		234,
		234,
		229,
		248,
		234,
		232,
		247,
		263,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		181,
		168,
		162,
		-1,
		203,
		-1,
		249,
		239,
		223,
		208,
		241,
		-1,
		246,
		237,
		242,
		-1,
		265,
		-1,
		237,
		240,
		231,
		226,
		223,
		234,
		232,
		241,
		242,
		-1,
		215,
		200,
		193,
		183,
		197,
		168,
		-1,
		211,
		-1,
		-1,
		236,
		230,
		230,
		214,
		217,
		262,
		242,
		234,
		242,
		248,
		235,
		234,
		222,
		222,
		225,
		219,
		232,
		242,
		248,
		240,
		-1,
		-1,
		-1,
		220,
		172,
		180,
		156,
		177,
		-1,
		-1,
		298,
		253,
		239,
		-1,
		223,
		262,
		250,
		240,
		230,
		235,
		236,
		226,
		224,
		220,
		229,
		228,
		221,
		220,
		241,
		234,
		256,
		-1,
		-1,
		169,
		182,
		184,
		170,
		189,
		-1,
		-1,
		-1,
		245,
		261,
		253,
		224,
		251,
		-1,
		-1,
		234,
		227,
		221,
		224,
		212,
		232,
		239,
		227,
		214,
		229,
		239,
		247,
		246,
		-1,
		172,
		159,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		-1,
		-1,
		278,
		240,
		229,
		224,
		228,
		233,
		-1,
		207,
		218,
		211,
		230,
		237,
		229,
		214,
		208,
		219,
		234,
		251,
		-1,
		-1,
		206,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		235,
		246,
		217,
		210,
		214,
		-1,
		209,
		211,
		208,
		220,
		225,
		229,
		220,
		202,
		216,
		219,
		232,
		246,
		250,
		229,
		-1,
		212,
		-1,
		-1,
		-1,
		253,
		264,
		250,
		227,
		206,
		199,
		196,
		195,
		200,
		211,
		220,
		231,
		196,
		200,
		215,
		220,
		224,
		241,
		245,
		-1,
		-1,
		212,
		218,
		253,
		261,
		237,
		277,
		-1,
		-1,
		195,
		188,
		198,
		191,
		204,
		207,
		192,
		194,
		212,
		225,
		219,
		229,
		244,
		239,
		-1,
		-1,
		-1,
		220,
		-1,
		236,
		-1,
		-1,
		227,
		268,
		215,
		197,
		193,
		179,
		186,
		180,
		182,
		187,
		206,
		201,
		210,
		215,
		219,
		242,
		231,
		270,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		186,
		205,
		200,
		206,
		211,
		202,
		230,
		227,
		-1,
		176,
		209,
		177,
		191,
		187,
		194,
		199,
		205,
		209,
		216,
		232,
		231,
		226,
		262,
		253,
		259,
		-1,
		-1,
		137,
		126,
		115,
		121,
		-1,
		179,
		202,
		192,
		182,
		188,
		-1,
		-1,
		194,
		191,
		189,
		169,
		175,
		180,
		183,
		221,
		197,
		205,
		209,
		213,
		219,
		224,
		229,
		235,
		250,
		265,
		-1,
		72,
		0,
		35,
		89,
		97,
		128,
		-1,
		169,
		161,
		189,
		174,
		182,
		-1,
		-1,
		167,
		158,
		163,
		172,
		173,
		204,
		203,
		216,
		219,
		224,
		212,
		211,
		229,
		233,
		242,
		249,
		239,
		252,
		256,
		-1,
		65,
		18,
		83,
		86,
		110,
		124,
		-1,
		160,
		-1,
		-1,
		205,
		192,
		176,
		166,
		163,
		210,
		186,
		181,
		187,
		189,
		213,
		204,
		229,
		220,
		220,
		223,
		238,
		243,
		235,
		249,
		249,
		250,
		-1,
		75,
		39,
		77,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		221,
		-1,
		203,
		-1,
		186,
		190,
		194,
		197,
		212,
		199,
		206,
		223,
		229,
		218,
		228,
		224,
		225,
		234,
		245,
		257,
		256,
		257,
		150,
		105,
		72,
		68,
		109,
		124,
		128,
		-1,
		144,
		180,
		190,
		-1,
		230,
		-1,
		-1,
		-1,
		200,
		207,
		199,
		215,
		211,
		211,
		207,
		211,
		223,
		230,
		240,
		242,
		234,
		238,
		251,
		262,
		265,
		146,
		144,
		149,
		94,
		77,
		94,
		103,
		124,
		140,
		137,
		174,
		179,
		194,
		199,
		223,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		218,
		228,
		211,
		213,
		217,
		231,
		243,
		251,
		241,
		239,
		233,
		265,
		-1,
		146,
		145,
		134,
		131,
		107,
		98,
		85,
		95,
		-1,
		-1,
		138,
		165,
		149,
		153,
		169,
		194,
		-1,
		230,
		-1,
		-1,
		244,
		-1,
		-1,
		270,
		233,
		222,
		213,
		219,
		225,
		236,
		258,
		247,
		248,
		238,
		248,
		261,
		130,
		127,
		115,
		113,
		136,
		93,
		89,
		-1,
		120,
		123,
		129,
		136,
		153,
		183,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		263,
		266,
		255,
		-1,
		245,
		218,
		223,
		248,
		255,
		256,
		250,
		244,
		251,
		250,
		258,
		266,
		139,
		153,
		142,
		138,
		137,
		145,
		94,
		110,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		-1,
		269,
		256,
		-1,
		-1,
		263,
		256,
		244,
		232,
		222,
		232,
		240,
		240,
		243,
		247,
		242,
		253,
		245,
		249,
		266,
		-1,
		173,
		-1,
		125,
		117,
		132,
		147,
		155,
		-1,
		-1,
		-1,
		286,
		272,
		265,
		253,
		251,
		-1,
		297,
		281,
		262,
		-1,
		232,
		245,
		276,
		244,
		249,
		244,
		248,
		259,
		248,
		251,
		265,
		260,
		-1,
		-1,
		130,
		133,
		-1,
		-1,
		155,
		174,
		-1,
		277,
		266,
		251,
		243,
		-1,
		-1,
		269,
		265,
		-1,
		-1,
		233,
		258,
		247,
		255,
		250,
		252,
		258,
		261,
		250,
		254,
		266,
		-1,
		-1,
		137,
		138,
		143,
		-1,
		164,
		-1,
		279,
		-1,
		246,
		253,
		241,
		-1,
		-1,
		-1,
		271,
		234,
		255,
		265,
		270,
		268,
		259,
		256,
		263,
		261,
		257,
		268,
		-1,
		-1,
		-1,
		194,
		171,
		286,
		277,
		260,
		240,
		232,
		252,
		-1,
		259,
		-1,
		234,
		235,
		262,
		264,
		281,
		275,
		259,
		274,
		264,
		255,
		264,
		200,
		-1,
		175,
		234,
		217,
		246,
		212,
		224,
		280,
		-1,
		256,
		238,
		-1,
		266,
		256,
		298,
		279,
		272,
		259,
		266,
		268,
		261,
		-1,
		-1,
		-1,
		190,
		189,
		188,
		199,
		207,
		205,
		223,
		-1,
		268,
		250,
		229,
		246,
		246,
		237,
		245,
		288,
		284,
		277,
		279,
		269,
		-1,
		245,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		216,
		238,
		233,
		225,
		237,
		246,
		233,
		239,
		241,
		249,
		247,
		244,
		256,
		252,
		272,
		268,
		300,
		-1,
		252,
		-1,
		220,
		-1,
		-1,
		234,
		220,
		232,
		243,
		233,
		233,
		238,
		236,
		258,
		275,
		259,
		257,
		262,
		267,
		-1,
		262,
		263,
		-1,
		253,
		245,
		231,
		-1,
		224,
		-1,
		279,
		240,
		-1,
		265,
		245,
		-1,
		268,
		264,
		-1,
		-1,
		274,
		269,
		-1,
		-1,
		-1,
		254,
		234,
		274,
		258,
		-1,
		256,
		256,
		-1,
		-1,
		-1,
		288,
		278,
		-1,
		247,
		250,
		-1,
		241,
		247,
		276,
		258,
		262,
		-1,
		-1,
		-1,
		303,
		284,
		278,
		262,
		267,
		255,
		272,
		258,
		260,
		272,
		261,
		282,
		-1,
		-1,
		-1,
		275,
		267,
		267,
		-1,
		-1,
		285,
		268,
		268,
		281,
		-1,
		-1,
		-1,
		297,
		278,
		-1,
		-1,
		276,
		-1,
		-1,
		281,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		286,
		-1,
		-1,
		-1,
		277,
		284,
		292,
		-1,
		-1,
		-1,
		-1,
		305,
		306,
		332,
		307,
		-1,
		-1,
		-1,
		291,
		291,
		-1,
		-1,
		303,
		304,
		-1,
		-1,
		-1,
		319,
		303,
		-1,
		295,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		328,
		-1,
		-1,
		-1,
		324,
		-1,
		330,
		305,
		312,
		-1,
		-1,
		-1,
		-1,
		337,
		329,
		343,
		-1,
		315,
		317,
		-1,
		365,
		-1,
		-1,
		352,
		343,
		-1,
		-1,
		320,
		327,
		349,
		352,
		382,
		-1,
		339
	],
	[
		-1,
		303,
		292,
		303,
		311,
		284,
		291,
		-1,
		312,
		314,
		280,
		274,
		313,
		284,
		290,
		301,
		-1,
		-1,
		-1,
		303,
		302,
		272,
		270,
		279,
		284,
		291,
		-1,
		314,
		-1,
		324,
		303,
		314,
		319,
		265,
		262,
		282,
		301,
		307,
		299,
		339,
		295,
		266,
		260,
		278,
		283,
		301,
		293,
		-1,
		266,
		256,
		278,
		282,
		294,
		277,
		-1,
		-1,
		260,
		261,
		267,
		279,
		284,
		289,
		-1,
		315,
		299,
		-1,
		-1,
		250,
		263,
		259,
		262,
		270,
		286,
		307,
		299,
		294,
		-1,
		-1,
		251,
		255,
		268,
		269,
		267,
		294,
		307,
		289,
		303,
		302,
		-1,
		239,
		257,
		266,
		275,
		281,
		270,
		268,
		286,
		288,
		294,
		297,
		-1,
		231,
		233,
		262,
		268,
		280,
		286,
		273,
		273,
		283,
		276,
		295,
		286,
		332,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		228,
		236,
		262,
		261,
		257,
		275,
		283,
		276,
		273,
		271,
		268,
		284,
		285,
		295,
		-1,
		-1,
		284,
		253,
		288,
		245,
		230,
		-1,
		224,
		243,
		249,
		253,
		258,
		266,
		280,
		276,
		-1,
		262,
		261,
		292,
		278,
		289,
		244,
		-1,
		-1,
		242,
		234,
		219,
		222,
		219,
		219,
		249,
		248,
		253,
		255,
		257,
		263,
		266,
		266,
		272,
		256,
		266,
		270,
		281,
		296,
		-1,
		-1,
		351,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		214,
		231,
		221,
		242,
		257,
		261,
		269,
		271,
		259,
		261,
		258,
		271,
		259,
		253,
		278,
		282,
		276,
		297,
		292,
		-1,
		350,
		334,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		243,
		-1,
		264,
		262,
		286,
		280,
		277,
		264,
		252,
		265,
		250,
		257,
		256,
		260,
		262,
		295,
		273,
		295,
		292,
		321,
		326,
		320,
		329,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		251,
		264,
		271,
		266,
		269,
		281,
		272,
		259,
		248,
		259,
		248,
		245,
		253,
		262,
		273,
		268,
		267,
		285,
		300,
		313,
		317,
		323,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		252,
		272,
		273,
		264,
		-1,
		267,
		270,
		277,
		255,
		240,
		257,
		249,
		247,
		252,
		257,
		271,
		262,
		280,
		287,
		295,
		299,
		319,
		331,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		295,
		270,
		-1,
		265,
		-1,
		257,
		282,
		-1,
		261,
		257,
		239,
		240,
		235,
		250,
		256,
		253,
		250,
		268,
		271,
		288,
		292,
		308,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		263,
		252,
		251,
		-1,
		242,
		272,
		269,
		255,
		242,
		232,
		233,
		241,
		254,
		233,
		252,
		255,
		277,
		305,
		283,
		294,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		281,
		274,
		262,
		227,
		227,
		221,
		-1,
		262,
		245,
		241,
		230,
		228,
		241,
		236,
		252,
		256,
		255,
		274,
		286,
		277,
		285,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		183,
		206,
		240,
		260,
		246,
		251,
		226,
		219,
		213,
		265,
		262,
		229,
		237,
		229,
		218,
		232,
		240,
		244,
		253,
		262,
		268,
		292,
		273,
		279,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		197,
		204,
		236,
		251,
		248,
		-1,
		218,
		-1,
		207,
		215,
		214,
		220,
		232,
		218,
		223,
		234,
		246,
		259,
		255,
		262,
		297,
		297,
		263,
		283,
		286,
		-1,
		-1,
		-1,
		244,
		242,
		217,
		194,
		178,
		214,
		-1,
		218,
		219,
		-1,
		212,
		206,
		212,
		211,
		218,
		215,
		215,
		229,
		237,
		233,
		249,
		255,
		247,
		271,
		-1,
		271,
		265,
		273,
		263,
		251,
		-1,
		-1,
		-1,
		240,
		219,
		212,
		232,
		173,
		225,
		-1,
		-1,
		203,
		196,
		-1,
		199,
		199,
		206,
		215,
		220,
		225,
		233,
		228,
		241,
		246,
		252,
		246,
		259,
		263,
		264,
		253,
		249,
		246,
		260,
		-1,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		193,
		-1,
		206,
		198,
		194,
		188,
		194,
		212,
		210,
		230,
		222,
		236,
		236,
		242,
		250,
		235,
		238,
		251,
		236,
		254,
		260,
		251,
		246,
		245,
		256,
		-1,
		260,
		246,
		217,
		-1,
		-1,
		206,
		-1,
		170,
		184,
		200,
		-1,
		228,
		207,
		230,
		208,
		222,
		218,
		256,
		257,
		235,
		240,
		248,
		249,
		252,
		241,
		244,
		236,
		258,
		255,
		239,
		241,
		250,
		-1,
		266,
		253,
		211,
		207,
		196,
		216,
		167,
		176,
		187,
		-1,
		-1,
		272,
		-1,
		206,
		223,
		232,
		230,
		246,
		237,
		243,
		259,
		246,
		241,
		246,
		235,
		235,
		230,
		249,
		235,
		233,
		248,
		264,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		182,
		169,
		163,
		-1,
		204,
		-1,
		250,
		240,
		224,
		209,
		242,
		-1,
		247,
		238,
		243,
		-1,
		266,
		-1,
		238,
		241,
		232,
		227,
		224,
		235,
		233,
		242,
		243,
		-1,
		216,
		201,
		194,
		184,
		198,
		169,
		-1,
		212,
		-1,
		-1,
		237,
		231,
		231,
		215,
		218,
		263,
		243,
		235,
		243,
		249,
		236,
		235,
		223,
		223,
		226,
		220,
		233,
		243,
		249,
		241,
		-1,
		-1,
		-1,
		221,
		173,
		181,
		157,
		178,
		-1,
		-1,
		299,
		254,
		240,
		-1,
		224,
		263,
		251,
		241,
		231,
		236,
		237,
		227,
		225,
		221,
		230,
		229,
		222,
		221,
		242,
		235,
		257,
		-1,
		-1,
		170,
		183,
		185,
		171,
		190,
		-1,
		-1,
		-1,
		246,
		262,
		254,
		225,
		252,
		-1,
		-1,
		235,
		228,
		222,
		225,
		213,
		233,
		240,
		228,
		215,
		230,
		240,
		248,
		247,
		-1,
		173,
		160,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		-1,
		-1,
		279,
		241,
		230,
		225,
		229,
		234,
		-1,
		208,
		219,
		212,
		231,
		238,
		230,
		215,
		209,
		220,
		235,
		252,
		-1,
		-1,
		207,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		236,
		247,
		218,
		211,
		215,
		-1,
		210,
		212,
		209,
		221,
		226,
		230,
		221,
		203,
		217,
		220,
		233,
		247,
		251,
		230,
		-1,
		213,
		-1,
		-1,
		-1,
		254,
		265,
		251,
		228,
		207,
		200,
		197,
		196,
		201,
		212,
		221,
		232,
		197,
		201,
		216,
		221,
		225,
		242,
		246,
		-1,
		-1,
		213,
		219,
		254,
		262,
		238,
		278,
		-1,
		-1,
		196,
		189,
		199,
		192,
		205,
		208,
		193,
		195,
		213,
		226,
		220,
		230,
		245,
		240,
		-1,
		-1,
		-1,
		221,
		-1,
		237,
		-1,
		-1,
		228,
		269,
		216,
		198,
		194,
		180,
		187,
		181,
		183,
		188,
		207,
		202,
		211,
		216,
		220,
		243,
		232,
		271,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		187,
		206,
		201,
		207,
		212,
		203,
		231,
		228,
		-1,
		177,
		210,
		178,
		192,
		188,
		195,
		200,
		206,
		210,
		217,
		233,
		232,
		227,
		263,
		254,
		260,
		-1,
		-1,
		138,
		127,
		116,
		122,
		-1,
		180,
		203,
		193,
		183,
		189,
		-1,
		-1,
		195,
		192,
		190,
		170,
		176,
		181,
		184,
		222,
		198,
		206,
		210,
		214,
		220,
		225,
		230,
		236,
		251,
		266,
		-1,
		73,
		43,
		0,
		90,
		98,
		129,
		-1,
		170,
		162,
		190,
		175,
		183,
		-1,
		-1,
		168,
		159,
		164,
		173,
		174,
		205,
		204,
		217,
		220,
		225,
		213,
		212,
		230,
		234,
		243,
		250,
		240,
		253,
		257,
		-1,
		66,
		15,
		84,
		87,
		111,
		125,
		-1,
		161,
		-1,
		-1,
		206,
		193,
		177,
		167,
		164,
		211,
		187,
		182,
		188,
		190,
		214,
		205,
		230,
		221,
		221,
		224,
		239,
		244,
		236,
		250,
		250,
		251,
		-1,
		76,
		40,
		78,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		222,
		-1,
		204,
		-1,
		187,
		191,
		195,
		198,
		213,
		200,
		207,
		224,
		230,
		219,
		229,
		225,
		226,
		235,
		246,
		258,
		257,
		258,
		151,
		106,
		73,
		69,
		110,
		125,
		129,
		-1,
		145,
		181,
		191,
		-1,
		231,
		-1,
		-1,
		-1,
		201,
		208,
		200,
		216,
		212,
		212,
		208,
		212,
		224,
		231,
		241,
		243,
		235,
		239,
		252,
		263,
		266,
		147,
		145,
		150,
		95,
		78,
		95,
		104,
		125,
		141,
		138,
		175,
		180,
		195,
		200,
		224,
		-1,
		-1,
		224,
		218,
		-1,
		-1,
		219,
		229,
		212,
		214,
		218,
		232,
		244,
		252,
		242,
		240,
		234,
		266,
		-1,
		147,
		146,
		135,
		132,
		108,
		99,
		86,
		96,
		-1,
		-1,
		139,
		166,
		150,
		154,
		170,
		195,
		-1,
		231,
		-1,
		-1,
		245,
		-1,
		-1,
		271,
		234,
		223,
		214,
		220,
		226,
		237,
		259,
		248,
		249,
		239,
		249,
		262,
		131,
		128,
		116,
		114,
		137,
		94,
		90,
		-1,
		121,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		264,
		267,
		256,
		-1,
		246,
		219,
		224,
		249,
		256,
		257,
		251,
		245,
		252,
		251,
		259,
		267,
		140,
		154,
		143,
		139,
		138,
		146,
		95,
		111,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		-1,
		270,
		257,
		-1,
		-1,
		264,
		257,
		245,
		233,
		223,
		233,
		241,
		241,
		244,
		248,
		243,
		254,
		246,
		250,
		267,
		-1,
		174,
		-1,
		126,
		118,
		133,
		148,
		156,
		-1,
		-1,
		-1,
		287,
		273,
		266,
		254,
		252,
		-1,
		298,
		282,
		263,
		-1,
		233,
		246,
		277,
		245,
		250,
		245,
		249,
		260,
		249,
		252,
		266,
		261,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		156,
		175,
		-1,
		278,
		267,
		252,
		244,
		-1,
		-1,
		270,
		266,
		-1,
		-1,
		234,
		259,
		248,
		256,
		251,
		253,
		259,
		262,
		251,
		255,
		267,
		-1,
		-1,
		138,
		139,
		144,
		-1,
		165,
		-1,
		280,
		-1,
		247,
		254,
		242,
		-1,
		-1,
		-1,
		272,
		235,
		256,
		266,
		271,
		269,
		260,
		257,
		264,
		262,
		258,
		269,
		-1,
		-1,
		-1,
		195,
		172,
		287,
		278,
		261,
		241,
		233,
		253,
		-1,
		260,
		-1,
		235,
		236,
		263,
		265,
		282,
		276,
		260,
		275,
		265,
		256,
		265,
		201,
		-1,
		176,
		235,
		218,
		247,
		213,
		225,
		281,
		-1,
		257,
		239,
		-1,
		267,
		257,
		299,
		280,
		273,
		260,
		267,
		269,
		262,
		-1,
		-1,
		-1,
		191,
		190,
		189,
		200,
		208,
		206,
		224,
		-1,
		269,
		251,
		230,
		247,
		247,
		238,
		246,
		289,
		285,
		278,
		280,
		270,
		-1,
		246,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		217,
		239,
		234,
		226,
		238,
		247,
		234,
		240,
		242,
		250,
		248,
		245,
		257,
		253,
		273,
		269,
		301,
		-1,
		253,
		-1,
		221,
		-1,
		-1,
		235,
		221,
		233,
		244,
		234,
		234,
		239,
		237,
		259,
		276,
		260,
		258,
		263,
		268,
		-1,
		263,
		264,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		280,
		241,
		-1,
		266,
		246,
		-1,
		269,
		265,
		-1,
		-1,
		275,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		275,
		259,
		-1,
		257,
		257,
		-1,
		-1,
		-1,
		289,
		279,
		-1,
		248,
		251,
		-1,
		242,
		248,
		277,
		259,
		263,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		263,
		268,
		256,
		273,
		259,
		261,
		273,
		262,
		283,
		-1,
		-1,
		-1,
		276,
		268,
		268,
		-1,
		-1,
		286,
		269,
		269,
		282,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		277,
		-1,
		-1,
		282,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		287,
		-1,
		-1,
		-1,
		278,
		285,
		293,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		333,
		308,
		-1,
		-1,
		-1,
		292,
		292,
		-1,
		-1,
		304,
		305,
		-1,
		-1,
		-1,
		320,
		304,
		-1,
		296,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		329,
		-1,
		-1,
		-1,
		325,
		-1,
		331,
		306,
		313,
		-1,
		-1,
		-1,
		-1,
		338,
		330,
		344,
		-1,
		316,
		318,
		-1,
		366,
		-1,
		-1,
		353,
		344,
		-1,
		-1,
		321,
		328,
		350,
		353,
		383,
		-1,
		340
	],
	[
		-1,
		285,
		274,
		285,
		293,
		266,
		273,
		-1,
		294,
		296,
		262,
		256,
		295,
		266,
		272,
		283,
		-1,
		-1,
		-1,
		285,
		284,
		254,
		252,
		261,
		266,
		273,
		-1,
		296,
		-1,
		306,
		285,
		296,
		301,
		247,
		244,
		264,
		283,
		289,
		281,
		321,
		277,
		248,
		242,
		260,
		265,
		283,
		275,
		-1,
		248,
		238,
		260,
		264,
		276,
		259,
		-1,
		-1,
		242,
		243,
		249,
		261,
		266,
		271,
		-1,
		297,
		281,
		-1,
		-1,
		232,
		245,
		241,
		244,
		252,
		268,
		289,
		281,
		276,
		-1,
		-1,
		233,
		237,
		250,
		251,
		249,
		276,
		289,
		271,
		285,
		284,
		-1,
		221,
		239,
		248,
		257,
		263,
		252,
		250,
		268,
		270,
		276,
		279,
		-1,
		213,
		215,
		244,
		250,
		262,
		268,
		255,
		255,
		265,
		258,
		277,
		268,
		314,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		210,
		218,
		244,
		243,
		239,
		257,
		265,
		258,
		255,
		253,
		250,
		266,
		267,
		277,
		-1,
		-1,
		266,
		235,
		270,
		227,
		212,
		-1,
		206,
		225,
		231,
		235,
		240,
		248,
		262,
		258,
		-1,
		244,
		243,
		274,
		260,
		271,
		226,
		-1,
		-1,
		224,
		216,
		201,
		204,
		201,
		201,
		231,
		230,
		235,
		237,
		239,
		245,
		248,
		248,
		254,
		238,
		248,
		252,
		260,
		278,
		-1,
		-1,
		320,
		-1,
		-1,
		223,
		206,
		-1,
		189,
		196,
		196,
		213,
		203,
		224,
		239,
		243,
		251,
		253,
		241,
		243,
		240,
		253,
		241,
		235,
		260,
		264,
		255,
		276,
		271,
		-1,
		319,
		303,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		182,
		185,
		191,
		215,
		225,
		-1,
		246,
		244,
		268,
		262,
		259,
		246,
		234,
		247,
		232,
		239,
		238,
		242,
		244,
		277,
		252,
		274,
		271,
		290,
		295,
		289,
		298,
		-1,
		231,
		227,
		223,
		230,
		179,
		-1,
		-1,
		219,
		-1,
		233,
		246,
		253,
		248,
		251,
		263,
		254,
		241,
		230,
		241,
		230,
		227,
		235,
		241,
		255,
		247,
		246,
		264,
		274,
		282,
		286,
		292,
		-1,
		281,
		-1,
		223,
		207,
		209,
		181,
		202,
		-1,
		239,
		234,
		254,
		255,
		246,
		-1,
		249,
		252,
		259,
		237,
		222,
		239,
		231,
		229,
		234,
		236,
		250,
		241,
		259,
		266,
		264,
		268,
		288,
		300,
		241,
		231,
		-1,
		213,
		218,
		177,
		185,
		204,
		277,
		252,
		-1,
		247,
		-1,
		239,
		264,
		-1,
		243,
		239,
		221,
		222,
		217,
		232,
		238,
		232,
		229,
		247,
		250,
		257,
		261,
		277,
		-1,
		-1,
		226,
		230,
		219,
		170,
		189,
		213,
		250,
		245,
		234,
		233,
		-1,
		224,
		254,
		251,
		237,
		224,
		214,
		215,
		223,
		236,
		215,
		231,
		228,
		248,
		274,
		252,
		263,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		196,
		167,
		191,
		233,
		263,
		256,
		244,
		209,
		209,
		203,
		-1,
		244,
		227,
		223,
		212,
		210,
		223,
		218,
		234,
		226,
		224,
		243,
		255,
		246,
		254,
		-1,
		-1,
		-1,
		226,
		215,
		216,
		165,
		188,
		222,
		242,
		228,
		233,
		208,
		201,
		195,
		247,
		244,
		211,
		219,
		211,
		200,
		214,
		222,
		226,
		222,
		231,
		237,
		261,
		242,
		248,
		-1,
		-1,
		233,
		223,
		207,
		209,
		206,
		179,
		186,
		218,
		233,
		230,
		-1,
		200,
		-1,
		189,
		197,
		196,
		202,
		214,
		200,
		205,
		216,
		228,
		229,
		224,
		231,
		266,
		266,
		232,
		252,
		255,
		-1,
		-1,
		-1,
		226,
		224,
		199,
		176,
		160,
		196,
		-1,
		200,
		201,
		-1,
		194,
		188,
		194,
		193,
		200,
		197,
		197,
		211,
		219,
		215,
		231,
		234,
		216,
		240,
		-1,
		240,
		234,
		242,
		232,
		220,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		185,
		178,
		-1,
		181,
		181,
		188,
		197,
		202,
		207,
		215,
		210,
		223,
		227,
		221,
		215,
		228,
		232,
		233,
		222,
		218,
		215,
		229,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		188,
		180,
		176,
		170,
		176,
		194,
		192,
		212,
		204,
		218,
		218,
		224,
		230,
		216,
		209,
		220,
		205,
		223,
		229,
		220,
		215,
		214,
		225,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		210,
		189,
		212,
		190,
		204,
		200,
		238,
		239,
		217,
		222,
		230,
		218,
		221,
		210,
		213,
		205,
		227,
		224,
		208,
		210,
		219,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		158,
		169,
		-1,
		-1,
		254,
		-1,
		188,
		205,
		214,
		212,
		228,
		217,
		224,
		241,
		215,
		210,
		215,
		204,
		204,
		199,
		218,
		204,
		202,
		217,
		233,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		232,
		222,
		206,
		191,
		224,
		-1,
		216,
		212,
		219,
		-1,
		235,
		-1,
		207,
		210,
		201,
		196,
		193,
		204,
		202,
		211,
		212,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		194,
		-1,
		-1,
		219,
		213,
		213,
		197,
		200,
		232,
		212,
		204,
		219,
		218,
		205,
		204,
		192,
		192,
		195,
		189,
		202,
		212,
		218,
		210,
		-1,
		-1,
		-1,
		203,
		155,
		163,
		139,
		160,
		-1,
		-1,
		281,
		236,
		222,
		-1,
		206,
		232,
		220,
		210,
		200,
		205,
		206,
		196,
		194,
		190,
		199,
		198,
		191,
		190,
		211,
		204,
		226,
		-1,
		-1,
		152,
		165,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		228,
		244,
		236,
		207,
		221,
		-1,
		-1,
		204,
		197,
		191,
		194,
		182,
		202,
		209,
		197,
		184,
		199,
		209,
		217,
		216,
		-1,
		155,
		142,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		261,
		210,
		199,
		194,
		198,
		203,
		-1,
		177,
		188,
		181,
		200,
		207,
		199,
		184,
		178,
		189,
		204,
		221,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		218,
		216,
		187,
		180,
		184,
		-1,
		179,
		181,
		178,
		190,
		195,
		199,
		190,
		172,
		186,
		189,
		202,
		216,
		220,
		212,
		-1,
		194,
		-1,
		-1,
		-1,
		233,
		234,
		220,
		197,
		176,
		169,
		166,
		165,
		170,
		181,
		190,
		201,
		166,
		170,
		185,
		190,
		194,
		211,
		215,
		-1,
		-1,
		192,
		188,
		223,
		235,
		207,
		247,
		-1,
		-1,
		165,
		158,
		168,
		161,
		174,
		177,
		162,
		164,
		182,
		195,
		189,
		199,
		214,
		209,
		-1,
		-1,
		-1,
		190,
		-1,
		206,
		-1,
		-1,
		197,
		238,
		185,
		167,
		163,
		149,
		156,
		150,
		152,
		157,
		176,
		171,
		180,
		185,
		189,
		212,
		201,
		240,
		-1,
		-1,
		55,
		-1,
		-1,
		-1,
		156,
		175,
		170,
		176,
		181,
		172,
		200,
		197,
		-1,
		146,
		179,
		147,
		161,
		157,
		164,
		169,
		175,
		179,
		186,
		202,
		201,
		196,
		232,
		223,
		229,
		-1,
		-1,
		48,
		37,
		26,
		32,
		-1,
		149,
		172,
		162,
		152,
		158,
		-1,
		-1,
		164,
		161,
		159,
		139,
		145,
		150,
		153,
		191,
		167,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		55,
		96,
		89,
		0,
		8,
		39,
		-1,
		139,
		131,
		159,
		144,
		152,
		-1,
		-1,
		137,
		128,
		133,
		142,
		143,
		174,
		173,
		186,
		189,
		194,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		48,
		72,
		8,
		3,
		21,
		35,
		-1,
		130,
		-1,
		-1,
		175,
		162,
		146,
		136,
		133,
		180,
		156,
		151,
		157,
		159,
		183,
		174,
		199,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		47,
		52,
		14,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		191,
		-1,
		173,
		-1,
		156,
		160,
		164,
		167,
		182,
		169,
		176,
		193,
		199,
		188,
		198,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		120,
		75,
		42,
		21,
		79,
		94,
		98,
		-1,
		114,
		150,
		160,
		-1,
		200,
		-1,
		-1,
		-1,
		170,
		177,
		169,
		185,
		181,
		181,
		177,
		181,
		193,
		200,
		210,
		212,
		204,
		208,
		221,
		232,
		235,
		116,
		114,
		119,
		64,
		47,
		64,
		73,
		94,
		110,
		107,
		144,
		149,
		164,
		169,
		193,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		188,
		198,
		181,
		183,
		187,
		201,
		213,
		221,
		211,
		209,
		203,
		235,
		-1,
		116,
		115,
		104,
		101,
		77,
		68,
		55,
		65,
		-1,
		-1,
		108,
		135,
		119,
		123,
		139,
		164,
		-1,
		200,
		-1,
		-1,
		214,
		-1,
		-1,
		240,
		203,
		192,
		183,
		189,
		195,
		206,
		228,
		217,
		218,
		208,
		218,
		231,
		100,
		97,
		85,
		83,
		106,
		63,
		59,
		-1,
		90,
		93,
		99,
		106,
		123,
		153,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		233,
		236,
		225,
		-1,
		215,
		188,
		193,
		218,
		225,
		226,
		220,
		214,
		221,
		220,
		228,
		236,
		109,
		123,
		112,
		108,
		107,
		115,
		64,
		80,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		226,
		-1,
		-1,
		233,
		226,
		214,
		202,
		192,
		202,
		210,
		210,
		213,
		217,
		212,
		223,
		215,
		219,
		236,
		-1,
		143,
		-1,
		95,
		87,
		102,
		117,
		125,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		267,
		251,
		232,
		-1,
		202,
		215,
		246,
		214,
		219,
		214,
		218,
		229,
		218,
		221,
		235,
		230,
		-1,
		-1,
		100,
		103,
		-1,
		-1,
		125,
		144,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		203,
		228,
		217,
		225,
		220,
		222,
		228,
		231,
		220,
		224,
		236,
		-1,
		-1,
		107,
		108,
		113,
		-1,
		134,
		-1,
		249,
		-1,
		216,
		223,
		211,
		-1,
		-1,
		-1,
		241,
		204,
		225,
		235,
		240,
		238,
		229,
		226,
		233,
		231,
		227,
		238,
		-1,
		-1,
		-1,
		164,
		141,
		256,
		247,
		230,
		210,
		202,
		222,
		-1,
		229,
		-1,
		204,
		205,
		232,
		234,
		251,
		245,
		229,
		244,
		234,
		225,
		234,
		170,
		-1,
		145,
		204,
		187,
		216,
		182,
		194,
		250,
		-1,
		226,
		208,
		-1,
		236,
		226,
		268,
		249,
		242,
		229,
		236,
		238,
		231,
		-1,
		-1,
		-1,
		160,
		159,
		158,
		169,
		177,
		175,
		193,
		-1,
		238,
		220,
		199,
		216,
		216,
		207,
		215,
		258,
		254,
		247,
		249,
		239,
		-1,
		215,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		186,
		208,
		203,
		195,
		207,
		216,
		203,
		209,
		211,
		219,
		217,
		214,
		226,
		222,
		242,
		238,
		270,
		-1,
		222,
		-1,
		190,
		-1,
		-1,
		204,
		190,
		202,
		213,
		203,
		203,
		208,
		206,
		228,
		245,
		229,
		227,
		232,
		237,
		-1,
		232,
		233,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		249,
		210,
		-1,
		235,
		215,
		-1,
		238,
		234,
		-1,
		-1,
		244,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		244,
		228,
		-1,
		226,
		226,
		-1,
		-1,
		-1,
		258,
		248,
		-1,
		217,
		220,
		-1,
		211,
		217,
		246,
		228,
		232,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		232,
		237,
		225,
		242,
		228,
		230,
		242,
		231,
		252,
		-1,
		-1,
		-1,
		245,
		237,
		237,
		-1,
		-1,
		255,
		238,
		238,
		251,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		246,
		-1,
		-1,
		251,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		256,
		-1,
		-1,
		-1,
		247,
		254,
		262,
		-1,
		-1,
		-1,
		-1,
		275,
		276,
		302,
		277,
		-1,
		-1,
		-1,
		261,
		261,
		-1,
		-1,
		273,
		274,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		265,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		298,
		-1,
		-1,
		-1,
		294,
		-1,
		300,
		275,
		282,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		313,
		-1,
		285,
		287,
		-1,
		335,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		290,
		297,
		319,
		322,
		352,
		-1,
		309
	],
	[
		-1,
		294,
		283,
		294,
		302,
		275,
		282,
		-1,
		303,
		305,
		271,
		265,
		304,
		275,
		281,
		292,
		-1,
		-1,
		-1,
		294,
		293,
		263,
		261,
		270,
		275,
		282,
		-1,
		305,
		-1,
		315,
		294,
		305,
		310,
		256,
		253,
		273,
		292,
		298,
		290,
		330,
		286,
		257,
		251,
		269,
		274,
		292,
		284,
		-1,
		257,
		247,
		269,
		273,
		285,
		268,
		-1,
		-1,
		251,
		252,
		258,
		270,
		275,
		280,
		-1,
		306,
		290,
		-1,
		-1,
		241,
		254,
		250,
		253,
		261,
		277,
		298,
		290,
		285,
		-1,
		-1,
		242,
		246,
		259,
		260,
		258,
		285,
		298,
		280,
		294,
		293,
		-1,
		230,
		248,
		257,
		266,
		272,
		261,
		259,
		277,
		279,
		285,
		288,
		-1,
		222,
		224,
		253,
		259,
		271,
		277,
		264,
		264,
		274,
		267,
		286,
		277,
		323,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		219,
		227,
		253,
		252,
		248,
		266,
		274,
		267,
		264,
		262,
		259,
		275,
		276,
		286,
		-1,
		-1,
		275,
		244,
		279,
		236,
		221,
		-1,
		215,
		234,
		240,
		244,
		249,
		257,
		271,
		267,
		-1,
		253,
		252,
		283,
		269,
		280,
		235,
		-1,
		-1,
		233,
		225,
		210,
		213,
		210,
		210,
		240,
		239,
		244,
		246,
		248,
		254,
		257,
		257,
		263,
		247,
		257,
		261,
		269,
		287,
		-1,
		-1,
		329,
		-1,
		-1,
		232,
		215,
		-1,
		198,
		205,
		205,
		222,
		212,
		233,
		248,
		252,
		260,
		262,
		250,
		252,
		249,
		262,
		250,
		244,
		269,
		273,
		264,
		285,
		280,
		-1,
		328,
		312,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		191,
		194,
		200,
		224,
		234,
		-1,
		255,
		253,
		277,
		271,
		268,
		255,
		243,
		256,
		241,
		248,
		247,
		251,
		253,
		286,
		261,
		283,
		280,
		299,
		304,
		298,
		307,
		-1,
		240,
		236,
		232,
		239,
		188,
		-1,
		-1,
		228,
		-1,
		242,
		255,
		262,
		257,
		260,
		272,
		263,
		250,
		239,
		250,
		239,
		236,
		244,
		250,
		264,
		256,
		255,
		273,
		283,
		291,
		295,
		301,
		-1,
		290,
		-1,
		232,
		216,
		218,
		190,
		211,
		-1,
		248,
		243,
		263,
		264,
		255,
		-1,
		258,
		261,
		268,
		246,
		231,
		248,
		240,
		238,
		243,
		245,
		259,
		250,
		268,
		275,
		273,
		277,
		297,
		309,
		250,
		240,
		-1,
		222,
		227,
		186,
		194,
		213,
		286,
		261,
		-1,
		256,
		-1,
		248,
		273,
		-1,
		252,
		248,
		230,
		231,
		226,
		241,
		247,
		241,
		238,
		256,
		259,
		266,
		270,
		286,
		-1,
		-1,
		235,
		239,
		228,
		179,
		198,
		222,
		259,
		254,
		243,
		242,
		-1,
		233,
		263,
		260,
		246,
		233,
		223,
		224,
		232,
		245,
		224,
		240,
		237,
		257,
		283,
		261,
		272,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		205,
		176,
		200,
		242,
		272,
		265,
		253,
		218,
		218,
		212,
		-1,
		253,
		236,
		232,
		221,
		219,
		232,
		227,
		243,
		235,
		233,
		252,
		264,
		255,
		263,
		-1,
		-1,
		-1,
		235,
		224,
		225,
		174,
		197,
		231,
		251,
		237,
		242,
		217,
		210,
		204,
		256,
		253,
		220,
		228,
		220,
		209,
		223,
		231,
		235,
		231,
		240,
		246,
		270,
		251,
		257,
		-1,
		-1,
		242,
		232,
		216,
		218,
		215,
		188,
		195,
		227,
		242,
		239,
		-1,
		209,
		-1,
		198,
		206,
		205,
		211,
		223,
		209,
		214,
		225,
		237,
		238,
		233,
		240,
		275,
		275,
		241,
		261,
		264,
		-1,
		-1,
		-1,
		235,
		233,
		208,
		185,
		169,
		205,
		-1,
		209,
		210,
		-1,
		203,
		197,
		203,
		202,
		209,
		206,
		206,
		220,
		228,
		224,
		240,
		243,
		225,
		249,
		-1,
		249,
		243,
		251,
		241,
		229,
		-1,
		-1,
		-1,
		231,
		210,
		203,
		223,
		164,
		216,
		-1,
		-1,
		194,
		187,
		-1,
		190,
		190,
		197,
		206,
		211,
		216,
		224,
		219,
		232,
		236,
		230,
		224,
		237,
		241,
		242,
		231,
		227,
		224,
		238,
		-1,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		184,
		-1,
		197,
		189,
		185,
		179,
		185,
		203,
		201,
		221,
		213,
		227,
		227,
		233,
		239,
		225,
		218,
		229,
		214,
		232,
		238,
		229,
		224,
		223,
		234,
		-1,
		251,
		237,
		208,
		-1,
		-1,
		197,
		-1,
		161,
		175,
		191,
		-1,
		219,
		198,
		221,
		199,
		213,
		209,
		247,
		248,
		226,
		231,
		239,
		227,
		230,
		219,
		222,
		214,
		236,
		233,
		217,
		219,
		228,
		-1,
		257,
		244,
		202,
		198,
		187,
		207,
		158,
		167,
		178,
		-1,
		-1,
		263,
		-1,
		197,
		214,
		223,
		221,
		237,
		226,
		233,
		250,
		224,
		219,
		224,
		213,
		213,
		208,
		227,
		213,
		211,
		226,
		242,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		173,
		160,
		154,
		-1,
		195,
		-1,
		241,
		231,
		215,
		200,
		233,
		-1,
		225,
		221,
		228,
		-1,
		244,
		-1,
		216,
		219,
		210,
		205,
		202,
		213,
		211,
		220,
		221,
		-1,
		207,
		192,
		185,
		175,
		189,
		160,
		-1,
		203,
		-1,
		-1,
		228,
		222,
		222,
		206,
		209,
		241,
		221,
		213,
		228,
		227,
		214,
		213,
		201,
		201,
		204,
		198,
		211,
		221,
		227,
		219,
		-1,
		-1,
		-1,
		212,
		164,
		172,
		148,
		169,
		-1,
		-1,
		290,
		245,
		231,
		-1,
		215,
		241,
		229,
		219,
		209,
		214,
		215,
		205,
		203,
		199,
		208,
		207,
		200,
		199,
		220,
		213,
		235,
		-1,
		-1,
		161,
		174,
		176,
		162,
		181,
		-1,
		-1,
		-1,
		237,
		253,
		245,
		216,
		230,
		-1,
		-1,
		213,
		206,
		200,
		203,
		191,
		211,
		218,
		206,
		193,
		208,
		218,
		226,
		225,
		-1,
		164,
		151,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		-1,
		-1,
		270,
		219,
		208,
		203,
		207,
		212,
		-1,
		186,
		197,
		190,
		209,
		216,
		208,
		193,
		187,
		198,
		213,
		230,
		-1,
		-1,
		198,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		227,
		225,
		196,
		189,
		193,
		-1,
		188,
		190,
		187,
		199,
		204,
		208,
		199,
		181,
		195,
		198,
		211,
		225,
		229,
		221,
		-1,
		203,
		-1,
		-1,
		-1,
		242,
		243,
		229,
		206,
		185,
		178,
		175,
		174,
		179,
		190,
		199,
		210,
		175,
		179,
		194,
		199,
		203,
		220,
		224,
		-1,
		-1,
		201,
		197,
		232,
		244,
		216,
		256,
		-1,
		-1,
		174,
		167,
		177,
		170,
		183,
		186,
		171,
		173,
		191,
		204,
		198,
		208,
		223,
		218,
		-1,
		-1,
		-1,
		199,
		-1,
		215,
		-1,
		-1,
		206,
		247,
		194,
		176,
		172,
		158,
		165,
		159,
		161,
		166,
		185,
		180,
		189,
		194,
		198,
		221,
		210,
		249,
		-1,
		-1,
		60,
		-1,
		-1,
		-1,
		165,
		184,
		179,
		185,
		190,
		181,
		209,
		206,
		-1,
		155,
		188,
		156,
		170,
		166,
		173,
		178,
		184,
		188,
		195,
		211,
		210,
		205,
		241,
		232,
		238,
		-1,
		-1,
		53,
		42,
		19,
		25,
		-1,
		158,
		181,
		171,
		161,
		167,
		-1,
		-1,
		173,
		170,
		168,
		148,
		154,
		159,
		162,
		200,
		176,
		184,
		188,
		192,
		198,
		203,
		208,
		214,
		229,
		244,
		-1,
		64,
		105,
		98,
		9,
		0,
		32,
		-1,
		148,
		140,
		168,
		153,
		161,
		-1,
		-1,
		146,
		137,
		142,
		151,
		152,
		183,
		182,
		195,
		198,
		203,
		191,
		190,
		208,
		212,
		221,
		228,
		218,
		231,
		235,
		-1,
		57,
		81,
		17,
		12,
		14,
		28,
		-1,
		139,
		-1,
		-1,
		184,
		171,
		155,
		145,
		142,
		189,
		165,
		160,
		166,
		168,
		192,
		183,
		208,
		199,
		199,
		202,
		217,
		222,
		214,
		228,
		228,
		229,
		-1,
		56,
		61,
		23,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		200,
		-1,
		182,
		-1,
		165,
		169,
		173,
		176,
		191,
		178,
		185,
		202,
		208,
		197,
		207,
		203,
		204,
		213,
		224,
		236,
		235,
		236,
		129,
		84,
		51,
		30,
		88,
		103,
		107,
		-1,
		123,
		159,
		169,
		-1,
		209,
		-1,
		-1,
		-1,
		179,
		186,
		178,
		194,
		190,
		190,
		186,
		190,
		202,
		209,
		219,
		221,
		213,
		217,
		230,
		241,
		244,
		125,
		123,
		128,
		73,
		56,
		73,
		82,
		103,
		119,
		116,
		153,
		158,
		173,
		178,
		202,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		197,
		207,
		190,
		192,
		196,
		210,
		222,
		230,
		220,
		218,
		212,
		244,
		-1,
		125,
		124,
		113,
		110,
		86,
		77,
		64,
		74,
		-1,
		-1,
		117,
		144,
		128,
		132,
		148,
		173,
		-1,
		209,
		-1,
		-1,
		223,
		-1,
		-1,
		249,
		212,
		201,
		192,
		198,
		204,
		215,
		237,
		226,
		227,
		217,
		227,
		240,
		109,
		106,
		94,
		92,
		115,
		72,
		68,
		-1,
		99,
		102,
		108,
		115,
		132,
		162,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		242,
		245,
		234,
		-1,
		224,
		197,
		202,
		227,
		234,
		235,
		229,
		223,
		230,
		229,
		237,
		245,
		118,
		132,
		121,
		117,
		116,
		124,
		73,
		89,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		235,
		-1,
		-1,
		242,
		235,
		223,
		211,
		201,
		211,
		219,
		219,
		222,
		226,
		221,
		232,
		224,
		228,
		245,
		-1,
		152,
		-1,
		104,
		96,
		111,
		126,
		134,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		276,
		260,
		241,
		-1,
		211,
		224,
		255,
		223,
		228,
		223,
		227,
		238,
		227,
		230,
		244,
		239,
		-1,
		-1,
		109,
		112,
		-1,
		-1,
		134,
		153,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		248,
		244,
		-1,
		-1,
		212,
		237,
		226,
		234,
		229,
		231,
		237,
		240,
		229,
		233,
		245,
		-1,
		-1,
		116,
		117,
		122,
		-1,
		143,
		-1,
		258,
		-1,
		225,
		232,
		220,
		-1,
		-1,
		-1,
		250,
		213,
		234,
		244,
		249,
		247,
		238,
		235,
		242,
		240,
		236,
		247,
		-1,
		-1,
		-1,
		173,
		150,
		265,
		256,
		239,
		219,
		211,
		231,
		-1,
		238,
		-1,
		213,
		214,
		241,
		243,
		260,
		254,
		238,
		253,
		243,
		234,
		243,
		179,
		-1,
		154,
		213,
		196,
		225,
		191,
		203,
		259,
		-1,
		235,
		217,
		-1,
		245,
		235,
		277,
		258,
		251,
		238,
		245,
		247,
		240,
		-1,
		-1,
		-1,
		169,
		168,
		167,
		178,
		186,
		184,
		202,
		-1,
		247,
		229,
		208,
		225,
		225,
		216,
		224,
		267,
		263,
		256,
		258,
		248,
		-1,
		224,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		195,
		217,
		212,
		204,
		216,
		225,
		212,
		218,
		220,
		228,
		226,
		223,
		235,
		231,
		251,
		247,
		279,
		-1,
		231,
		-1,
		199,
		-1,
		-1,
		213,
		199,
		211,
		222,
		212,
		212,
		217,
		215,
		237,
		254,
		238,
		236,
		241,
		246,
		-1,
		241,
		242,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		258,
		219,
		-1,
		244,
		224,
		-1,
		247,
		243,
		-1,
		-1,
		253,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		253,
		237,
		-1,
		235,
		235,
		-1,
		-1,
		-1,
		267,
		257,
		-1,
		226,
		229,
		-1,
		220,
		226,
		255,
		237,
		241,
		-1,
		-1,
		-1,
		282,
		263,
		257,
		241,
		246,
		234,
		251,
		237,
		239,
		251,
		240,
		261,
		-1,
		-1,
		-1,
		254,
		246,
		246,
		-1,
		-1,
		264,
		247,
		247,
		260,
		-1,
		-1,
		-1,
		276,
		257,
		-1,
		-1,
		255,
		-1,
		-1,
		260,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		265,
		-1,
		-1,
		-1,
		256,
		263,
		271,
		-1,
		-1,
		-1,
		-1,
		284,
		285,
		311,
		286,
		-1,
		-1,
		-1,
		270,
		270,
		-1,
		-1,
		282,
		283,
		-1,
		-1,
		-1,
		298,
		282,
		-1,
		274,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		307,
		-1,
		-1,
		-1,
		303,
		-1,
		309,
		284,
		291,
		-1,
		-1,
		-1,
		-1,
		316,
		308,
		322,
		-1,
		294,
		296,
		-1,
		344,
		-1,
		-1,
		331,
		322,
		-1,
		-1,
		299,
		306,
		328,
		331,
		361,
		-1,
		318
	],
	[
		-1,
		318,
		307,
		318,
		326,
		299,
		306,
		-1,
		327,
		329,
		295,
		289,
		328,
		299,
		305,
		316,
		-1,
		-1,
		-1,
		318,
		317,
		287,
		285,
		294,
		299,
		306,
		-1,
		329,
		-1,
		339,
		318,
		329,
		334,
		280,
		277,
		297,
		316,
		322,
		314,
		354,
		310,
		281,
		275,
		293,
		298,
		316,
		308,
		-1,
		281,
		271,
		293,
		297,
		309,
		292,
		-1,
		-1,
		275,
		276,
		282,
		294,
		299,
		304,
		-1,
		330,
		314,
		-1,
		-1,
		265,
		278,
		274,
		277,
		285,
		301,
		322,
		314,
		309,
		-1,
		-1,
		266,
		270,
		283,
		284,
		282,
		309,
		322,
		304,
		318,
		317,
		-1,
		254,
		272,
		281,
		290,
		296,
		285,
		283,
		301,
		303,
		309,
		312,
		-1,
		246,
		248,
		277,
		283,
		295,
		301,
		288,
		288,
		298,
		291,
		310,
		301,
		347,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		243,
		251,
		277,
		276,
		272,
		290,
		298,
		291,
		288,
		286,
		283,
		299,
		300,
		310,
		-1,
		-1,
		299,
		268,
		303,
		260,
		245,
		-1,
		239,
		258,
		264,
		268,
		273,
		281,
		295,
		291,
		-1,
		277,
		276,
		307,
		293,
		304,
		259,
		-1,
		-1,
		257,
		249,
		234,
		237,
		234,
		234,
		264,
		263,
		268,
		270,
		272,
		278,
		281,
		281,
		287,
		271,
		281,
		285,
		293,
		311,
		-1,
		-1,
		353,
		-1,
		-1,
		256,
		239,
		-1,
		222,
		229,
		229,
		246,
		236,
		257,
		272,
		276,
		284,
		286,
		274,
		276,
		273,
		286,
		274,
		268,
		293,
		297,
		288,
		309,
		304,
		-1,
		352,
		336,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		215,
		218,
		224,
		248,
		258,
		-1,
		279,
		277,
		301,
		295,
		292,
		279,
		267,
		280,
		265,
		272,
		271,
		275,
		277,
		310,
		285,
		307,
		304,
		323,
		328,
		322,
		331,
		-1,
		264,
		260,
		256,
		263,
		212,
		-1,
		-1,
		252,
		-1,
		266,
		279,
		286,
		281,
		284,
		296,
		287,
		274,
		263,
		274,
		263,
		260,
		268,
		274,
		288,
		280,
		279,
		297,
		307,
		315,
		319,
		325,
		-1,
		314,
		-1,
		256,
		240,
		242,
		214,
		235,
		-1,
		272,
		267,
		287,
		288,
		279,
		-1,
		282,
		285,
		292,
		270,
		255,
		272,
		264,
		262,
		267,
		269,
		283,
		274,
		292,
		299,
		297,
		301,
		321,
		333,
		274,
		264,
		-1,
		246,
		251,
		210,
		218,
		237,
		310,
		285,
		-1,
		280,
		-1,
		272,
		297,
		-1,
		276,
		272,
		254,
		255,
		250,
		265,
		271,
		265,
		262,
		280,
		283,
		290,
		294,
		310,
		-1,
		-1,
		259,
		263,
		252,
		203,
		222,
		246,
		283,
		278,
		267,
		266,
		-1,
		257,
		287,
		284,
		270,
		257,
		247,
		248,
		256,
		269,
		248,
		264,
		261,
		281,
		307,
		285,
		296,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		229,
		200,
		224,
		266,
		296,
		289,
		277,
		242,
		242,
		236,
		-1,
		277,
		260,
		256,
		245,
		243,
		256,
		251,
		267,
		259,
		257,
		276,
		288,
		279,
		287,
		-1,
		-1,
		-1,
		259,
		248,
		249,
		198,
		221,
		255,
		275,
		261,
		266,
		241,
		234,
		228,
		280,
		277,
		244,
		252,
		244,
		233,
		247,
		255,
		259,
		255,
		264,
		270,
		294,
		275,
		281,
		-1,
		-1,
		266,
		256,
		240,
		242,
		239,
		212,
		219,
		251,
		266,
		263,
		-1,
		233,
		-1,
		222,
		230,
		229,
		235,
		247,
		233,
		238,
		249,
		261,
		262,
		257,
		264,
		299,
		299,
		265,
		285,
		288,
		-1,
		-1,
		-1,
		259,
		257,
		232,
		209,
		193,
		229,
		-1,
		233,
		234,
		-1,
		227,
		221,
		227,
		226,
		233,
		230,
		230,
		244,
		252,
		248,
		264,
		267,
		249,
		273,
		-1,
		273,
		267,
		275,
		265,
		253,
		-1,
		-1,
		-1,
		255,
		234,
		227,
		247,
		188,
		240,
		-1,
		-1,
		218,
		211,
		-1,
		214,
		214,
		221,
		230,
		235,
		240,
		248,
		243,
		256,
		260,
		254,
		248,
		261,
		265,
		266,
		255,
		251,
		248,
		262,
		-1,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		208,
		-1,
		221,
		213,
		209,
		203,
		209,
		227,
		225,
		245,
		237,
		251,
		251,
		257,
		263,
		249,
		242,
		253,
		238,
		256,
		262,
		253,
		248,
		247,
		258,
		-1,
		275,
		261,
		232,
		-1,
		-1,
		221,
		-1,
		185,
		199,
		215,
		-1,
		243,
		222,
		245,
		223,
		237,
		233,
		271,
		272,
		250,
		255,
		263,
		251,
		254,
		243,
		246,
		238,
		260,
		257,
		241,
		243,
		252,
		-1,
		281,
		268,
		226,
		222,
		211,
		231,
		182,
		191,
		202,
		-1,
		-1,
		287,
		-1,
		221,
		238,
		247,
		245,
		261,
		250,
		257,
		274,
		248,
		243,
		248,
		237,
		237,
		232,
		251,
		237,
		235,
		250,
		266,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		197,
		184,
		178,
		-1,
		219,
		-1,
		265,
		255,
		239,
		224,
		257,
		-1,
		249,
		245,
		252,
		-1,
		268,
		-1,
		240,
		243,
		234,
		229,
		226,
		237,
		235,
		244,
		245,
		-1,
		231,
		216,
		209,
		199,
		213,
		184,
		-1,
		227,
		-1,
		-1,
		252,
		246,
		246,
		230,
		233,
		265,
		245,
		237,
		252,
		251,
		238,
		237,
		225,
		225,
		228,
		222,
		235,
		245,
		251,
		243,
		-1,
		-1,
		-1,
		236,
		188,
		196,
		172,
		193,
		-1,
		-1,
		314,
		269,
		255,
		-1,
		239,
		265,
		253,
		243,
		233,
		238,
		239,
		229,
		227,
		223,
		232,
		231,
		224,
		223,
		244,
		237,
		259,
		-1,
		-1,
		185,
		198,
		200,
		186,
		205,
		-1,
		-1,
		-1,
		261,
		277,
		269,
		240,
		254,
		-1,
		-1,
		237,
		230,
		224,
		227,
		215,
		235,
		242,
		230,
		217,
		232,
		242,
		250,
		249,
		-1,
		188,
		175,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		-1,
		-1,
		294,
		243,
		232,
		227,
		231,
		236,
		-1,
		210,
		221,
		214,
		233,
		240,
		232,
		217,
		211,
		222,
		237,
		254,
		-1,
		-1,
		222,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		251,
		249,
		220,
		213,
		217,
		-1,
		212,
		214,
		211,
		223,
		228,
		232,
		223,
		205,
		219,
		222,
		235,
		249,
		253,
		245,
		-1,
		227,
		-1,
		-1,
		-1,
		266,
		267,
		253,
		230,
		209,
		202,
		199,
		198,
		203,
		214,
		223,
		234,
		199,
		203,
		218,
		223,
		227,
		244,
		248,
		-1,
		-1,
		225,
		221,
		256,
		268,
		240,
		280,
		-1,
		-1,
		198,
		191,
		201,
		194,
		207,
		210,
		195,
		197,
		215,
		228,
		222,
		232,
		247,
		242,
		-1,
		-1,
		-1,
		223,
		-1,
		239,
		-1,
		-1,
		230,
		271,
		218,
		200,
		196,
		182,
		189,
		183,
		185,
		190,
		209,
		204,
		213,
		218,
		222,
		245,
		234,
		273,
		-1,
		-1,
		84,
		-1,
		-1,
		-1,
		189,
		208,
		203,
		209,
		214,
		205,
		233,
		230,
		-1,
		179,
		212,
		180,
		194,
		190,
		197,
		202,
		208,
		212,
		219,
		235,
		234,
		229,
		265,
		256,
		262,
		-1,
		-1,
		77,
		66,
		43,
		49,
		-1,
		182,
		205,
		195,
		185,
		191,
		-1,
		-1,
		197,
		194,
		192,
		172,
		178,
		183,
		186,
		224,
		200,
		208,
		212,
		216,
		222,
		227,
		232,
		238,
		253,
		268,
		-1,
		88,
		129,
		122,
		33,
		29,
		0,
		-1,
		172,
		164,
		192,
		177,
		185,
		-1,
		-1,
		170,
		161,
		166,
		175,
		176,
		207,
		206,
		219,
		222,
		227,
		215,
		214,
		232,
		236,
		245,
		252,
		242,
		255,
		259,
		-1,
		81,
		105,
		41,
		36,
		17,
		2,
		-1,
		163,
		-1,
		-1,
		208,
		195,
		179,
		169,
		166,
		213,
		189,
		184,
		190,
		192,
		216,
		207,
		232,
		223,
		223,
		226,
		241,
		246,
		238,
		252,
		252,
		253,
		-1,
		80,
		85,
		47,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		224,
		-1,
		206,
		-1,
		189,
		193,
		197,
		200,
		215,
		202,
		209,
		226,
		232,
		221,
		231,
		227,
		228,
		237,
		248,
		260,
		259,
		260,
		153,
		108,
		75,
		54,
		112,
		127,
		131,
		-1,
		147,
		183,
		193,
		-1,
		233,
		-1,
		-1,
		-1,
		203,
		210,
		202,
		218,
		214,
		214,
		210,
		214,
		226,
		233,
		243,
		245,
		237,
		241,
		254,
		265,
		268,
		149,
		147,
		152,
		97,
		80,
		97,
		106,
		127,
		143,
		140,
		177,
		182,
		197,
		202,
		226,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		221,
		231,
		214,
		216,
		220,
		234,
		246,
		254,
		244,
		242,
		236,
		268,
		-1,
		149,
		148,
		137,
		134,
		110,
		101,
		88,
		98,
		-1,
		-1,
		141,
		168,
		152,
		156,
		172,
		197,
		-1,
		233,
		-1,
		-1,
		247,
		-1,
		-1,
		273,
		236,
		225,
		216,
		222,
		228,
		239,
		261,
		250,
		251,
		241,
		251,
		264,
		133,
		130,
		118,
		116,
		139,
		96,
		92,
		-1,
		123,
		126,
		132,
		139,
		156,
		186,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		266,
		269,
		258,
		-1,
		248,
		221,
		226,
		251,
		258,
		259,
		253,
		247,
		254,
		253,
		261,
		269,
		142,
		156,
		145,
		141,
		140,
		148,
		97,
		113,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		-1,
		272,
		259,
		-1,
		-1,
		266,
		259,
		247,
		235,
		225,
		235,
		243,
		243,
		246,
		250,
		245,
		256,
		248,
		252,
		269,
		-1,
		176,
		-1,
		128,
		120,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		289,
		275,
		268,
		256,
		254,
		-1,
		300,
		284,
		265,
		-1,
		235,
		248,
		279,
		247,
		252,
		247,
		251,
		262,
		251,
		254,
		268,
		263,
		-1,
		-1,
		133,
		136,
		-1,
		-1,
		158,
		177,
		-1,
		280,
		269,
		254,
		246,
		-1,
		-1,
		272,
		268,
		-1,
		-1,
		236,
		261,
		250,
		258,
		253,
		255,
		261,
		264,
		253,
		257,
		269,
		-1,
		-1,
		140,
		141,
		146,
		-1,
		167,
		-1,
		282,
		-1,
		249,
		256,
		244,
		-1,
		-1,
		-1,
		274,
		237,
		258,
		268,
		273,
		271,
		262,
		259,
		266,
		264,
		260,
		271,
		-1,
		-1,
		-1,
		197,
		174,
		289,
		280,
		263,
		243,
		235,
		255,
		-1,
		262,
		-1,
		237,
		238,
		265,
		267,
		284,
		278,
		262,
		277,
		267,
		258,
		267,
		203,
		-1,
		178,
		237,
		220,
		249,
		215,
		227,
		283,
		-1,
		259,
		241,
		-1,
		269,
		259,
		301,
		282,
		275,
		262,
		269,
		271,
		264,
		-1,
		-1,
		-1,
		193,
		192,
		191,
		202,
		210,
		208,
		226,
		-1,
		271,
		253,
		232,
		249,
		249,
		240,
		248,
		291,
		287,
		280,
		282,
		272,
		-1,
		248,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		219,
		241,
		236,
		228,
		240,
		249,
		236,
		242,
		244,
		252,
		250,
		247,
		259,
		255,
		275,
		271,
		303,
		-1,
		255,
		-1,
		223,
		-1,
		-1,
		237,
		223,
		235,
		246,
		236,
		236,
		241,
		239,
		261,
		278,
		262,
		260,
		265,
		270,
		-1,
		265,
		266,
		-1,
		256,
		248,
		234,
		-1,
		227,
		-1,
		282,
		243,
		-1,
		268,
		248,
		-1,
		271,
		267,
		-1,
		-1,
		277,
		272,
		-1,
		-1,
		-1,
		257,
		237,
		277,
		261,
		-1,
		259,
		259,
		-1,
		-1,
		-1,
		291,
		281,
		-1,
		250,
		253,
		-1,
		244,
		250,
		279,
		261,
		265,
		-1,
		-1,
		-1,
		306,
		287,
		281,
		265,
		270,
		258,
		275,
		261,
		263,
		275,
		264,
		285,
		-1,
		-1,
		-1,
		278,
		270,
		270,
		-1,
		-1,
		288,
		271,
		271,
		284,
		-1,
		-1,
		-1,
		300,
		281,
		-1,
		-1,
		279,
		-1,
		-1,
		284,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		289,
		-1,
		-1,
		-1,
		280,
		287,
		295,
		-1,
		-1,
		-1,
		-1,
		308,
		309,
		335,
		310,
		-1,
		-1,
		-1,
		294,
		294,
		-1,
		-1,
		306,
		307,
		-1,
		-1,
		-1,
		322,
		306,
		-1,
		298,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		331,
		-1,
		-1,
		-1,
		327,
		-1,
		333,
		308,
		315,
		-1,
		-1,
		-1,
		-1,
		340,
		332,
		346,
		-1,
		318,
		320,
		-1,
		368,
		-1,
		-1,
		355,
		346,
		-1,
		-1,
		323,
		330,
		352,
		355,
		385,
		-1,
		342
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		275,
		264,
		275,
		283,
		256,
		263,
		-1,
		284,
		286,
		252,
		246,
		285,
		256,
		262,
		273,
		-1,
		-1,
		-1,
		275,
		274,
		244,
		242,
		251,
		256,
		263,
		-1,
		268,
		-1,
		296,
		275,
		286,
		291,
		237,
		234,
		254,
		273,
		261,
		253,
		311,
		267,
		238,
		232,
		250,
		246,
		255,
		247,
		-1,
		238,
		228,
		250,
		235,
		246,
		238,
		-1,
		-1,
		232,
		233,
		239,
		231,
		237,
		233,
		-1,
		243,
		227,
		-1,
		-1,
		222,
		229,
		213,
		216,
		224,
		222,
		235,
		227,
		222,
		-1,
		-1,
		219,
		215,
		222,
		209,
		205,
		222,
		235,
		217,
		231,
		230,
		-1,
		211,
		229,
		238,
		216,
		214,
		198,
		196,
		214,
		216,
		222,
		222,
		-1,
		203,
		205,
		230,
		238,
		238,
		214,
		201,
		201,
		211,
		204,
		223,
		211,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		200,
		208,
		234,
		226,
		216,
		231,
		224,
		204,
		201,
		199,
		196,
		212,
		210,
		220,
		-1,
		-1,
		256,
		225,
		260,
		217,
		202,
		-1,
		196,
		210,
		216,
		220,
		214,
		207,
		221,
		217,
		-1,
		190,
		189,
		217,
		203,
		214,
		216,
		-1,
		-1,
		214,
		206,
		191,
		194,
		191,
		191,
		221,
		220,
		216,
		202,
		198,
		204,
		207,
		207,
		213,
		184,
		194,
		198,
		196,
		221,
		-1,
		-1,
		256,
		-1,
		-1,
		213,
		196,
		-1,
		179,
		186,
		186,
		203,
		193,
		214,
		229,
		226,
		218,
		212,
		200,
		202,
		199,
		212,
		200,
		181,
		206,
		210,
		191,
		212,
		207,
		-1,
		255,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		172,
		175,
		181,
		205,
		215,
		-1,
		236,
		234,
		236,
		221,
		218,
		205,
		193,
		206,
		191,
		198,
		197,
		185,
		183,
		213,
		188,
		210,
		207,
		226,
		231,
		225,
		234,
		-1,
		221,
		217,
		213,
		220,
		169,
		-1,
		-1,
		209,
		-1,
		223,
		236,
		240,
		232,
		235,
		222,
		213,
		200,
		189,
		200,
		189,
		186,
		194,
		177,
		192,
		183,
		182,
		200,
		210,
		218,
		222,
		228,
		-1,
		271,
		-1,
		213,
		197,
		199,
		171,
		192,
		-1,
		229,
		224,
		244,
		242,
		233,
		-1,
		231,
		228,
		218,
		196,
		181,
		198,
		190,
		188,
		190,
		172,
		186,
		177,
		195,
		202,
		200,
		204,
		224,
		236,
		231,
		221,
		-1,
		203,
		208,
		167,
		175,
		194,
		267,
		239,
		-1,
		234,
		-1,
		226,
		246,
		-1,
		202,
		198,
		180,
		181,
		176,
		191,
		183,
		168,
		165,
		183,
		186,
		193,
		197,
		213,
		-1,
		-1,
		216,
		220,
		209,
		160,
		179,
		203,
		240,
		232,
		221,
		220,
		-1,
		211,
		216,
		213,
		201,
		188,
		173,
		174,
		182,
		194,
		173,
		167,
		164,
		184,
		210,
		188,
		199,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		186,
		157,
		181,
		223,
		250,
		243,
		231,
		196,
		196,
		190,
		-1,
		212,
		191,
		182,
		171,
		169,
		182,
		174,
		182,
		162,
		160,
		179,
		191,
		182,
		190,
		-1,
		-1,
		-1,
		216,
		205,
		206,
		152,
		175,
		212,
		229,
		215,
		220,
		195,
		188,
		182,
		225,
		208,
		189,
		178,
		170,
		159,
		170,
		178,
		176,
		158,
		167,
		173,
		197,
		178,
		184,
		-1,
		-1,
		223,
		213,
		197,
		199,
		196,
		166,
		173,
		205,
		220,
		217,
		-1,
		187,
		-1,
		176,
		184,
		183,
		178,
		175,
		162,
		161,
		175,
		175,
		165,
		160,
		167,
		202,
		202,
		168,
		188,
		191,
		-1,
		-1,
		-1,
		216,
		211,
		186,
		163,
		147,
		183,
		-1,
		187,
		188,
		-1,
		181,
		175,
		181,
		180,
		181,
		166,
		170,
		172,
		175,
		163,
		169,
		170,
		152,
		176,
		-1,
		176,
		170,
		178,
		168,
		156,
		-1,
		-1,
		-1,
		209,
		188,
		181,
		201,
		142,
		194,
		-1,
		-1,
		172,
		165,
		-1,
		168,
		168,
		175,
		173,
		169,
		171,
		168,
		157,
		170,
		163,
		157,
		151,
		164,
		168,
		169,
		158,
		154,
		151,
		165,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		162,
		-1,
		180,
		172,
		163,
		157,
		163,
		181,
		179,
		197,
		181,
		183,
		179,
		171,
		166,
		152,
		145,
		156,
		141,
		159,
		165,
		156,
		151,
		150,
		161,
		-1,
		229,
		215,
		186,
		-1,
		-1,
		175,
		-1,
		139,
		158,
		174,
		-1,
		197,
		176,
		199,
		177,
		191,
		187,
		188,
		189,
		159,
		164,
		166,
		154,
		157,
		146,
		149,
		141,
		163,
		160,
		144,
		146,
		155,
		-1,
		235,
		222,
		180,
		176,
		165,
		185,
		136,
		145,
		161,
		-1,
		-1,
		216,
		-1,
		170,
		172,
		201,
		199,
		178,
		153,
		160,
		178,
		151,
		146,
		151,
		140,
		140,
		135,
		154,
		140,
		138,
		153,
		169,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		151,
		138,
		132,
		-1,
		178,
		-1,
		194,
		182,
		169,
		151,
		191,
		-1,
		152,
		148,
		155,
		-1,
		171,
		-1,
		143,
		146,
		137,
		132,
		129,
		140,
		138,
		147,
		148,
		-1,
		185,
		170,
		163,
		153,
		167,
		135,
		-1,
		169,
		-1,
		-1,
		181,
		175,
		175,
		144,
		141,
		168,
		148,
		140,
		155,
		154,
		141,
		140,
		128,
		128,
		131,
		125,
		138,
		148,
		154,
		146,
		-1,
		-1,
		-1,
		190,
		165,
		159,
		131,
		135,
		-1,
		-1,
		242,
		198,
		184,
		-1,
		136,
		168,
		156,
		146,
		136,
		141,
		142,
		132,
		130,
		126,
		135,
		134,
		127,
		126,
		147,
		140,
		162,
		-1,
		-1,
		164,
		157,
		145,
		113,
		108,
		-1,
		-1,
		-1,
		188,
		174,
		162,
		134,
		157,
		-1,
		-1,
		140,
		133,
		127,
		125,
		118,
		138,
		145,
		133,
		120,
		135,
		145,
		153,
		152,
		-1,
		167,
		154,
		-1,
		-1,
		107,
		97,
		-1,
		-1,
		-1,
		-1,
		152,
		133,
		128,
		123,
		127,
		139,
		-1,
		112,
		116,
		116,
		136,
		143,
		135,
		120,
		114,
		125,
		140,
		157,
		-1,
		-1,
		121,
		-1,
		83,
		-1,
		-1,
		-1,
		-1,
		124,
		139,
		116,
		109,
		113,
		-1,
		110,
		109,
		113,
		119,
		131,
		135,
		126,
		108,
		122,
		125,
		138,
		152,
		156,
		144,
		-1,
		74,
		-1,
		-1,
		-1,
		116,
		117,
		149,
		126,
		105,
		98,
		95,
		101,
		105,
		117,
		126,
		137,
		102,
		106,
		121,
		126,
		130,
		147,
		151,
		-1,
		-1,
		72,
		68,
		103,
		115,
		90,
		176,
		-1,
		-1,
		94,
		87,
		97,
		97,
		110,
		113,
		98,
		100,
		118,
		131,
		125,
		135,
		150,
		145,
		-1,
		-1,
		-1,
		51,
		-1,
		86,
		-1,
		-1,
		80,
		167,
		114,
		96,
		92,
		78,
		92,
		86,
		88,
		93,
		112,
		107,
		116,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		17,
		55,
		49,
		59,
		64,
		55,
		129,
		126,
		-1,
		74,
		115,
		83,
		97,
		93,
		100,
		105,
		111,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		176,
		165,
		154,
		160,
		-1,
		10,
		52,
		45,
		35,
		41,
		-1,
		-1,
		88,
		85,
		88,
		75,
		81,
		86,
		89,
		127,
		103,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		130,
		167,
		160,
		128,
		136,
		167,
		-1,
		0,
		14,
		36,
		27,
		35,
		-1,
		-1,
		61,
		57,
		62,
		71,
		74,
		110,
		109,
		122,
		125,
		130,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		123,
		143,
		122,
		125,
		149,
		163,
		-1,
		13,
		-1,
		-1,
		58,
		48,
		56,
		52,
		56,
		109,
		85,
		80,
		93,
		95,
		119,
		110,
		135,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		112,
		123,
		116,
		-1,
		-1,
		-1,
		-1,
		20,
		-1,
		-1,
		74,
		-1,
		82,
		-1,
		75,
		79,
		93,
		96,
		118,
		105,
		112,
		129,
		135,
		124,
		134,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		137,
		93,
		96,
		107,
		118,
		133,
		137,
		-1,
		31,
		70,
		112,
		-1,
		83,
		-1,
		-1,
		-1,
		89,
		106,
		98,
		114,
		117,
		117,
		113,
		117,
		129,
		136,
		146,
		148,
		140,
		144,
		157,
		168,
		171,
		133,
		124,
		137,
		82,
		82,
		103,
		112,
		133,
		46,
		37,
		64,
		108,
		108,
		103,
		90,
		-1,
		-1,
		112,
		116,
		-1,
		-1,
		124,
		134,
		117,
		119,
		123,
		137,
		149,
		157,
		147,
		145,
		139,
		171,
		-1,
		126,
		125,
		114,
		111,
		87,
		78,
		73,
		100,
		-1,
		-1,
		49,
		65,
		78,
		82,
		98,
		123,
		-1,
		93,
		-1,
		-1,
		133,
		-1,
		-1,
		176,
		139,
		128,
		119,
		125,
		131,
		142,
		164,
		153,
		154,
		144,
		154,
		167,
		110,
		107,
		95,
		93,
		116,
		81,
		69,
		-1,
		64,
		52,
		58,
		65,
		82,
		112,
		-1,
		-1,
		109,
		100,
		-1,
		-1,
		152,
		159,
		161,
		-1,
		151,
		124,
		129,
		154,
		161,
		162,
		156,
		150,
		157,
		156,
		164,
		172,
		119,
		133,
		122,
		118,
		117,
		125,
		74,
		67,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		119,
		-1,
		-1,
		159,
		162,
		150,
		138,
		128,
		138,
		146,
		146,
		149,
		153,
		148,
		159,
		151,
		155,
		172,
		-1,
		153,
		-1,
		105,
		73,
		93,
		108,
		116,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		203,
		187,
		168,
		-1,
		138,
		151,
		182,
		150,
		155,
		150,
		154,
		165,
		154,
		157,
		171,
		166,
		-1,
		-1,
		91,
		94,
		-1,
		-1,
		118,
		137,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		175,
		171,
		-1,
		-1,
		139,
		164,
		153,
		161,
		156,
		158,
		164,
		167,
		156,
		160,
		172,
		-1,
		-1,
		98,
		101,
		106,
		-1,
		127,
		-1,
		176,
		-1,
		121,
		137,
		139,
		-1,
		-1,
		-1,
		177,
		140,
		161,
		171,
		176,
		174,
		165,
		162,
		169,
		167,
		163,
		174,
		-1,
		-1,
		-1,
		157,
		134,
		183,
		174,
		157,
		137,
		129,
		154,
		-1,
		165,
		-1,
		140,
		141,
		168,
		170,
		187,
		181,
		165,
		180,
		170,
		161,
		170,
		163,
		-1,
		138,
		197,
		175,
		143,
		143,
		142,
		186,
		-1,
		162,
		144,
		-1,
		172,
		162,
		204,
		185,
		178,
		165,
		172,
		174,
		167,
		-1,
		-1,
		-1,
		153,
		152,
		151,
		162,
		163,
		148,
		143,
		-1,
		174,
		156,
		135,
		152,
		152,
		143,
		151,
		194,
		190,
		183,
		185,
		175,
		-1,
		225,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		174,
		183,
		156,
		144,
		157,
		153,
		139,
		145,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		174,
		206,
		-1,
		232,
		-1,
		183,
		-1,
		-1,
		190,
		176,
		178,
		167,
		156,
		154,
		152,
		143,
		165,
		181,
		165,
		163,
		168,
		173,
		-1,
		242,
		243,
		-1,
		209,
		201,
		187,
		-1,
		180,
		-1,
		202,
		163,
		-1,
		172,
		152,
		-1,
		174,
		170,
		-1,
		-1,
		254,
		225,
		-1,
		-1,
		-1,
		210,
		190,
		197,
		181,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		250,
		234,
		-1,
		203,
		206,
		-1,
		197,
		203,
		218,
		165,
		169,
		-1,
		-1,
		-1,
		259,
		240,
		234,
		218,
		223,
		211,
		228,
		214,
		201,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		231,
		223,
		223,
		-1,
		-1,
		226,
		209,
		190,
		188,
		-1,
		-1,
		-1,
		253,
		234,
		-1,
		-1,
		216,
		-1,
		-1,
		222,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		242,
		-1,
		-1,
		-1,
		212,
		208,
		209,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		288,
		260,
		-1,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		202,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		237,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		227,
		234,
		256,
		259,
		295,
		-1,
		246
	],
	[
		-1,
		264,
		253,
		264,
		272,
		245,
		252,
		-1,
		273,
		275,
		241,
		235,
		274,
		245,
		251,
		262,
		-1,
		-1,
		-1,
		264,
		263,
		233,
		231,
		240,
		245,
		252,
		-1,
		254,
		-1,
		285,
		264,
		275,
		280,
		226,
		223,
		243,
		262,
		247,
		239,
		300,
		256,
		227,
		221,
		239,
		232,
		241,
		233,
		-1,
		227,
		217,
		239,
		221,
		232,
		224,
		-1,
		-1,
		221,
		222,
		228,
		217,
		223,
		219,
		-1,
		229,
		213,
		-1,
		-1,
		211,
		215,
		199,
		202,
		210,
		208,
		221,
		213,
		208,
		-1,
		-1,
		205,
		201,
		208,
		195,
		191,
		208,
		221,
		203,
		217,
		216,
		-1,
		200,
		218,
		227,
		202,
		200,
		184,
		182,
		200,
		202,
		208,
		208,
		-1,
		192,
		194,
		216,
		224,
		224,
		200,
		187,
		187,
		197,
		190,
		209,
		197,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		189,
		197,
		220,
		212,
		202,
		217,
		210,
		190,
		187,
		185,
		182,
		198,
		196,
		206,
		-1,
		-1,
		245,
		214,
		249,
		206,
		191,
		-1,
		185,
		196,
		202,
		206,
		200,
		193,
		207,
		203,
		-1,
		176,
		175,
		203,
		189,
		200,
		205,
		-1,
		-1,
		203,
		195,
		180,
		183,
		180,
		180,
		210,
		209,
		202,
		188,
		184,
		190,
		193,
		193,
		199,
		170,
		180,
		184,
		182,
		207,
		-1,
		-1,
		242,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		175,
		192,
		182,
		203,
		218,
		212,
		204,
		198,
		186,
		188,
		185,
		198,
		186,
		167,
		192,
		196,
		177,
		198,
		193,
		-1,
		241,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		204,
		-1,
		225,
		221,
		222,
		207,
		204,
		191,
		179,
		192,
		177,
		184,
		183,
		171,
		169,
		199,
		174,
		196,
		193,
		212,
		217,
		211,
		220,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		212,
		225,
		229,
		218,
		221,
		208,
		199,
		186,
		175,
		186,
		175,
		172,
		180,
		163,
		178,
		169,
		168,
		186,
		196,
		204,
		208,
		214,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		213,
		233,
		231,
		222,
		-1,
		217,
		214,
		204,
		182,
		167,
		184,
		176,
		174,
		176,
		158,
		172,
		163,
		181,
		188,
		186,
		190,
		210,
		222,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		256,
		228,
		-1,
		223,
		-1,
		215,
		232,
		-1,
		188,
		184,
		166,
		167,
		162,
		177,
		169,
		154,
		151,
		169,
		172,
		179,
		183,
		199,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		221,
		210,
		209,
		-1,
		200,
		202,
		199,
		187,
		174,
		159,
		160,
		168,
		180,
		159,
		153,
		150,
		170,
		196,
		174,
		185,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		239,
		232,
		220,
		185,
		185,
		179,
		-1,
		198,
		177,
		168,
		157,
		155,
		168,
		160,
		168,
		148,
		146,
		165,
		177,
		168,
		176,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		218,
		204,
		209,
		184,
		177,
		171,
		211,
		194,
		175,
		164,
		156,
		145,
		156,
		164,
		162,
		144,
		153,
		159,
		183,
		164,
		170,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		209,
		206,
		-1,
		176,
		-1,
		165,
		173,
		169,
		164,
		161,
		148,
		147,
		161,
		161,
		151,
		146,
		153,
		188,
		188,
		154,
		174,
		177,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		176,
		177,
		-1,
		170,
		164,
		170,
		169,
		167,
		152,
		156,
		158,
		161,
		149,
		155,
		156,
		138,
		162,
		-1,
		162,
		156,
		164,
		154,
		142,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		161,
		154,
		-1,
		157,
		157,
		164,
		159,
		155,
		157,
		154,
		143,
		156,
		149,
		143,
		137,
		150,
		154,
		155,
		144,
		140,
		137,
		151,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		169,
		161,
		152,
		146,
		152,
		170,
		168,
		183,
		167,
		169,
		165,
		157,
		152,
		138,
		131,
		142,
		127,
		145,
		151,
		142,
		137,
		136,
		147,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		147,
		163,
		-1,
		186,
		165,
		188,
		166,
		178,
		176,
		174,
		175,
		145,
		150,
		152,
		140,
		143,
		132,
		135,
		127,
		149,
		146,
		130,
		132,
		141,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		134,
		150,
		-1,
		-1,
		202,
		-1,
		156,
		158,
		190,
		188,
		164,
		139,
		146,
		164,
		137,
		132,
		137,
		126,
		126,
		121,
		140,
		126,
		124,
		139,
		155,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		167,
		-1,
		180,
		168,
		155,
		137,
		177,
		-1,
		138,
		134,
		141,
		-1,
		157,
		-1,
		129,
		132,
		123,
		118,
		115,
		126,
		124,
		133,
		134,
		-1,
		174,
		159,
		152,
		142,
		156,
		124,
		-1,
		158,
		-1,
		-1,
		167,
		161,
		161,
		130,
		127,
		154,
		134,
		126,
		141,
		140,
		127,
		126,
		114,
		114,
		117,
		111,
		124,
		134,
		140,
		132,
		-1,
		-1,
		-1,
		179,
		154,
		148,
		120,
		124,
		-1,
		-1,
		228,
		184,
		170,
		-1,
		122,
		154,
		142,
		132,
		122,
		127,
		128,
		118,
		116,
		112,
		121,
		120,
		113,
		112,
		133,
		126,
		148,
		-1,
		-1,
		153,
		146,
		134,
		102,
		97,
		-1,
		-1,
		-1,
		174,
		160,
		148,
		120,
		143,
		-1,
		-1,
		126,
		119,
		113,
		111,
		104,
		124,
		131,
		119,
		106,
		121,
		131,
		139,
		138,
		-1,
		156,
		143,
		-1,
		-1,
		96,
		86,
		-1,
		-1,
		-1,
		-1,
		138,
		119,
		114,
		109,
		113,
		125,
		-1,
		98,
		102,
		102,
		122,
		129,
		121,
		106,
		100,
		111,
		126,
		143,
		-1,
		-1,
		110,
		-1,
		72,
		-1,
		-1,
		-1,
		-1,
		110,
		125,
		102,
		95,
		99,
		-1,
		96,
		95,
		99,
		105,
		117,
		121,
		112,
		94,
		108,
		111,
		124,
		138,
		142,
		133,
		-1,
		63,
		-1,
		-1,
		-1,
		102,
		103,
		135,
		112,
		91,
		84,
		81,
		87,
		91,
		103,
		112,
		123,
		88,
		92,
		107,
		112,
		116,
		133,
		137,
		-1,
		-1,
		61,
		57,
		92,
		104,
		76,
		162,
		-1,
		-1,
		80,
		73,
		83,
		83,
		96,
		99,
		84,
		86,
		104,
		117,
		111,
		121,
		136,
		131,
		-1,
		-1,
		-1,
		59,
		-1,
		75,
		-1,
		-1,
		66,
		153,
		100,
		82,
		78,
		64,
		78,
		72,
		74,
		79,
		98,
		93,
		102,
		107,
		111,
		134,
		123,
		162,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		25,
		44,
		39,
		45,
		50,
		41,
		115,
		112,
		-1,
		60,
		101,
		69,
		83,
		79,
		86,
		91,
		97,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		162,
		151,
		140,
		146,
		-1,
		18,
		41,
		31,
		21,
		27,
		-1,
		-1,
		74,
		71,
		74,
		61,
		67,
		72,
		75,
		113,
		89,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		116,
		153,
		146,
		114,
		122,
		153,
		-1,
		8,
		0,
		28,
		13,
		21,
		-1,
		-1,
		47,
		43,
		48,
		57,
		60,
		96,
		95,
		108,
		111,
		116,
		104,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		109,
		129,
		108,
		111,
		135,
		149,
		-1,
		5,
		-1,
		-1,
		44,
		34,
		42,
		38,
		42,
		95,
		71,
		66,
		79,
		81,
		105,
		96,
		121,
		112,
		112,
		115,
		130,
		135,
		127,
		141,
		141,
		142,
		-1,
		98,
		109,
		102,
		-1,
		-1,
		-1,
		-1,
		6,
		-1,
		-1,
		60,
		-1,
		68,
		-1,
		61,
		65,
		79,
		82,
		104,
		91,
		98,
		115,
		121,
		110,
		120,
		116,
		117,
		126,
		137,
		149,
		148,
		149,
		123,
		79,
		82,
		93,
		104,
		119,
		123,
		-1,
		17,
		56,
		98,
		-1,
		69,
		-1,
		-1,
		-1,
		75,
		92,
		84,
		100,
		103,
		103,
		99,
		103,
		115,
		122,
		132,
		134,
		126,
		130,
		143,
		154,
		157,
		119,
		110,
		123,
		68,
		68,
		89,
		98,
		119,
		32,
		23,
		50,
		94,
		94,
		89,
		76,
		-1,
		-1,
		98,
		102,
		-1,
		-1,
		110,
		120,
		103,
		105,
		109,
		123,
		135,
		143,
		133,
		131,
		125,
		157,
		-1,
		112,
		111,
		100,
		97,
		73,
		64,
		59,
		86,
		-1,
		-1,
		35,
		51,
		64,
		68,
		84,
		109,
		-1,
		79,
		-1,
		-1,
		119,
		-1,
		-1,
		162,
		125,
		114,
		105,
		111,
		117,
		128,
		150,
		139,
		140,
		130,
		140,
		153,
		96,
		93,
		81,
		79,
		102,
		67,
		55,
		-1,
		50,
		38,
		44,
		51,
		68,
		98,
		-1,
		-1,
		95,
		86,
		-1,
		-1,
		138,
		145,
		147,
		-1,
		137,
		110,
		115,
		140,
		147,
		148,
		142,
		136,
		143,
		142,
		150,
		158,
		105,
		119,
		108,
		104,
		103,
		111,
		60,
		53,
		53,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		130,
		105,
		-1,
		-1,
		145,
		148,
		136,
		124,
		114,
		124,
		132,
		132,
		135,
		139,
		134,
		145,
		137,
		141,
		158,
		-1,
		139,
		-1,
		91,
		59,
		79,
		94,
		102,
		-1,
		-1,
		-1,
		147,
		133,
		126,
		114,
		112,
		-1,
		189,
		173,
		154,
		-1,
		124,
		137,
		168,
		136,
		141,
		136,
		140,
		151,
		140,
		143,
		157,
		152,
		-1,
		-1,
		77,
		80,
		-1,
		-1,
		104,
		123,
		-1,
		138,
		127,
		112,
		104,
		-1,
		-1,
		161,
		157,
		-1,
		-1,
		125,
		150,
		139,
		147,
		142,
		144,
		150,
		153,
		142,
		146,
		158,
		-1,
		-1,
		84,
		87,
		92,
		-1,
		113,
		-1,
		162,
		-1,
		107,
		123,
		125,
		-1,
		-1,
		-1,
		163,
		126,
		147,
		157,
		162,
		160,
		151,
		148,
		155,
		153,
		149,
		160,
		-1,
		-1,
		-1,
		143,
		120,
		169,
		160,
		143,
		123,
		115,
		140,
		-1,
		151,
		-1,
		126,
		127,
		154,
		156,
		173,
		167,
		151,
		166,
		156,
		147,
		156,
		149,
		-1,
		124,
		183,
		161,
		129,
		129,
		128,
		172,
		-1,
		148,
		130,
		-1,
		158,
		148,
		190,
		171,
		164,
		151,
		158,
		160,
		153,
		-1,
		-1,
		-1,
		139,
		138,
		137,
		148,
		149,
		134,
		129,
		-1,
		160,
		142,
		121,
		138,
		138,
		129,
		137,
		180,
		176,
		169,
		171,
		161,
		-1,
		211,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		160,
		169,
		142,
		130,
		143,
		139,
		125,
		131,
		133,
		141,
		139,
		136,
		148,
		144,
		164,
		160,
		192,
		-1,
		218,
		-1,
		169,
		-1,
		-1,
		176,
		162,
		164,
		153,
		142,
		140,
		138,
		129,
		151,
		167,
		151,
		149,
		154,
		159,
		-1,
		228,
		229,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		188,
		149,
		-1,
		158,
		138,
		-1,
		160,
		156,
		-1,
		-1,
		240,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		183,
		167,
		-1,
		149,
		149,
		-1,
		-1,
		-1,
		236,
		220,
		-1,
		189,
		192,
		-1,
		183,
		189,
		204,
		151,
		155,
		-1,
		-1,
		-1,
		245,
		226,
		220,
		204,
		209,
		197,
		214,
		200,
		187,
		165,
		154,
		175,
		-1,
		-1,
		-1,
		217,
		209,
		209,
		-1,
		-1,
		212,
		195,
		176,
		174,
		-1,
		-1,
		-1,
		239,
		220,
		-1,
		-1,
		202,
		-1,
		-1,
		208,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		228,
		-1,
		-1,
		-1,
		198,
		194,
		195,
		-1,
		-1,
		-1,
		-1,
		249,
		250,
		274,
		246,
		-1,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		252,
		250,
		-1,
		-1,
		-1,
		218,
		202,
		-1,
		188,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		223,
		-1,
		223,
		198,
		205,
		-1,
		-1,
		-1,
		-1,
		236,
		228,
		236,
		-1,
		208,
		210,
		-1,
		258,
		-1,
		-1,
		251,
		242,
		-1,
		-1,
		213,
		220,
		242,
		245,
		281,
		-1,
		232
	],
	[
		-1,
		239,
		228,
		239,
		247,
		220,
		227,
		-1,
		248,
		250,
		216,
		210,
		249,
		220,
		226,
		237,
		-1,
		-1,
		-1,
		239,
		238,
		208,
		206,
		215,
		220,
		227,
		-1,
		250,
		-1,
		260,
		239,
		250,
		255,
		201,
		198,
		218,
		237,
		243,
		235,
		275,
		231,
		202,
		196,
		214,
		219,
		237,
		229,
		-1,
		202,
		192,
		214,
		218,
		230,
		213,
		-1,
		-1,
		196,
		197,
		203,
		215,
		220,
		225,
		-1,
		248,
		232,
		-1,
		-1,
		186,
		199,
		195,
		198,
		206,
		222,
		240,
		232,
		227,
		-1,
		-1,
		187,
		191,
		204,
		205,
		203,
		227,
		240,
		222,
		236,
		235,
		-1,
		175,
		193,
		202,
		211,
		217,
		203,
		201,
		219,
		221,
		227,
		227,
		-1,
		167,
		169,
		198,
		204,
		216,
		219,
		206,
		206,
		216,
		209,
		228,
		216,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		164,
		172,
		198,
		197,
		193,
		211,
		216,
		209,
		206,
		204,
		201,
		217,
		215,
		225,
		-1,
		-1,
		220,
		189,
		224,
		181,
		166,
		-1,
		160,
		179,
		185,
		189,
		194,
		199,
		213,
		209,
		-1,
		195,
		194,
		222,
		208,
		219,
		180,
		-1,
		-1,
		178,
		170,
		155,
		158,
		155,
		155,
		185,
		184,
		189,
		191,
		190,
		196,
		199,
		199,
		205,
		189,
		199,
		203,
		201,
		226,
		-1,
		-1,
		261,
		-1,
		-1,
		177,
		160,
		-1,
		143,
		150,
		150,
		167,
		157,
		178,
		193,
		197,
		205,
		204,
		192,
		194,
		191,
		204,
		192,
		186,
		211,
		215,
		196,
		217,
		212,
		-1,
		260,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		139,
		145,
		169,
		179,
		-1,
		200,
		198,
		222,
		213,
		210,
		197,
		185,
		198,
		183,
		190,
		189,
		190,
		188,
		218,
		193,
		215,
		212,
		231,
		236,
		230,
		239,
		-1,
		185,
		181,
		177,
		184,
		133,
		-1,
		-1,
		173,
		-1,
		187,
		200,
		204,
		202,
		205,
		214,
		205,
		192,
		181,
		192,
		181,
		178,
		186,
		182,
		197,
		188,
		187,
		205,
		215,
		223,
		227,
		233,
		-1,
		235,
		-1,
		177,
		161,
		163,
		135,
		156,
		-1,
		193,
		188,
		208,
		206,
		197,
		-1,
		200,
		203,
		210,
		188,
		173,
		190,
		182,
		180,
		185,
		177,
		191,
		182,
		200,
		207,
		205,
		209,
		229,
		241,
		195,
		185,
		-1,
		167,
		172,
		131,
		139,
		158,
		231,
		203,
		-1,
		198,
		-1,
		190,
		215,
		-1,
		194,
		190,
		172,
		173,
		168,
		183,
		188,
		173,
		170,
		188,
		191,
		198,
		202,
		218,
		-1,
		-1,
		180,
		184,
		173,
		124,
		143,
		167,
		204,
		196,
		185,
		184,
		-1,
		175,
		205,
		202,
		188,
		175,
		165,
		166,
		174,
		187,
		166,
		172,
		169,
		189,
		215,
		193,
		204,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		150,
		121,
		145,
		187,
		214,
		207,
		195,
		160,
		160,
		154,
		-1,
		195,
		178,
		174,
		163,
		161,
		174,
		169,
		185,
		167,
		165,
		184,
		196,
		187,
		195,
		-1,
		-1,
		-1,
		180,
		169,
		170,
		116,
		139,
		176,
		193,
		179,
		184,
		159,
		152,
		146,
		198,
		195,
		162,
		170,
		162,
		151,
		165,
		173,
		177,
		163,
		172,
		178,
		202,
		183,
		189,
		-1,
		-1,
		187,
		177,
		161,
		163,
		160,
		130,
		137,
		169,
		184,
		181,
		-1,
		151,
		-1,
		140,
		148,
		147,
		153,
		165,
		151,
		156,
		167,
		179,
		170,
		165,
		172,
		207,
		207,
		173,
		193,
		196,
		-1,
		-1,
		-1,
		180,
		175,
		150,
		127,
		111,
		147,
		-1,
		151,
		152,
		-1,
		145,
		139,
		145,
		144,
		151,
		148,
		148,
		162,
		170,
		166,
		174,
		175,
		157,
		181,
		-1,
		181,
		175,
		183,
		173,
		161,
		-1,
		-1,
		-1,
		173,
		152,
		145,
		165,
		106,
		158,
		-1,
		-1,
		136,
		129,
		-1,
		132,
		132,
		139,
		148,
		153,
		158,
		166,
		161,
		174,
		168,
		162,
		156,
		169,
		173,
		174,
		163,
		159,
		156,
		170,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		126,
		-1,
		144,
		136,
		127,
		121,
		127,
		145,
		143,
		163,
		155,
		169,
		169,
		175,
		171,
		157,
		150,
		161,
		146,
		164,
		170,
		161,
		156,
		155,
		166,
		-1,
		193,
		179,
		150,
		-1,
		-1,
		139,
		-1,
		103,
		122,
		138,
		-1,
		161,
		140,
		163,
		141,
		155,
		151,
		189,
		190,
		164,
		169,
		171,
		159,
		162,
		151,
		154,
		146,
		168,
		165,
		149,
		151,
		160,
		-1,
		199,
		186,
		144,
		140,
		129,
		149,
		100,
		109,
		125,
		-1,
		-1,
		199,
		-1,
		139,
		155,
		165,
		163,
		179,
		158,
		165,
		183,
		156,
		151,
		156,
		145,
		145,
		140,
		159,
		145,
		143,
		158,
		174,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		115,
		102,
		96,
		-1,
		142,
		-1,
		177,
		165,
		152,
		134,
		174,
		-1,
		157,
		153,
		160,
		-1,
		176,
		-1,
		148,
		151,
		142,
		137,
		134,
		145,
		143,
		152,
		153,
		-1,
		149,
		134,
		127,
		117,
		131,
		99,
		-1,
		133,
		-1,
		-1,
		164,
		158,
		158,
		127,
		124,
		173,
		153,
		145,
		160,
		159,
		146,
		145,
		133,
		133,
		136,
		130,
		143,
		153,
		159,
		151,
		-1,
		-1,
		-1,
		154,
		129,
		123,
		95,
		99,
		-1,
		-1,
		225,
		181,
		167,
		-1,
		119,
		173,
		161,
		151,
		141,
		146,
		147,
		137,
		135,
		131,
		140,
		139,
		132,
		131,
		152,
		145,
		167,
		-1,
		-1,
		128,
		121,
		109,
		77,
		72,
		-1,
		-1,
		-1,
		171,
		157,
		145,
		117,
		162,
		-1,
		-1,
		145,
		138,
		132,
		130,
		123,
		143,
		150,
		138,
		125,
		140,
		150,
		158,
		157,
		-1,
		131,
		118,
		-1,
		-1,
		71,
		61,
		-1,
		-1,
		-1,
		-1,
		135,
		116,
		128,
		128,
		132,
		144,
		-1,
		117,
		121,
		121,
		141,
		148,
		140,
		125,
		119,
		130,
		145,
		162,
		-1,
		-1,
		85,
		-1,
		47,
		-1,
		-1,
		-1,
		-1,
		107,
		122,
		121,
		114,
		118,
		-1,
		115,
		114,
		118,
		124,
		136,
		140,
		131,
		113,
		127,
		130,
		143,
		157,
		161,
		108,
		-1,
		38,
		-1,
		-1,
		-1,
		84,
		114,
		154,
		131,
		110,
		103,
		100,
		106,
		110,
		122,
		131,
		142,
		107,
		111,
		126,
		131,
		135,
		152,
		156,
		-1,
		-1,
		36,
		32,
		67,
		79,
		95,
		181,
		-1,
		-1,
		99,
		92,
		102,
		102,
		115,
		118,
		103,
		105,
		123,
		136,
		130,
		140,
		155,
		150,
		-1,
		-1,
		-1,
		48,
		-1,
		50,
		-1,
		-1,
		85,
		172,
		119,
		101,
		97,
		83,
		97,
		91,
		93,
		98,
		117,
		112,
		121,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		61,
		19,
		13,
		64,
		69,
		60,
		134,
		131,
		-1,
		79,
		120,
		88,
		102,
		98,
		105,
		110,
		116,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		204,
		193,
		182,
		188,
		-1,
		54,
		16,
		50,
		40,
		46,
		-1,
		-1,
		93,
		90,
		93,
		80,
		86,
		91,
		94,
		132,
		108,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		158,
		195,
		188,
		156,
		164,
		195,
		-1,
		44,
		42,
		0,
		32,
		40,
		-1,
		-1,
		66,
		62,
		67,
		76,
		79,
		115,
		114,
		127,
		130,
		135,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		151,
		171,
		150,
		153,
		177,
		191,
		-1,
		41,
		-1,
		-1,
		35,
		53,
		61,
		57,
		61,
		114,
		90,
		85,
		98,
		100,
		124,
		115,
		140,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		140,
		151,
		144,
		-1,
		-1,
		-1,
		-1,
		48,
		-1,
		-1,
		51,
		-1,
		87,
		-1,
		80,
		84,
		98,
		101,
		123,
		110,
		117,
		134,
		140,
		129,
		139,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		165,
		121,
		124,
		135,
		146,
		161,
		165,
		-1,
		59,
		98,
		89,
		-1,
		60,
		-1,
		-1,
		-1,
		94,
		111,
		103,
		119,
		122,
		122,
		118,
		122,
		134,
		141,
		151,
		153,
		145,
		149,
		162,
		173,
		176,
		161,
		152,
		165,
		110,
		110,
		131,
		140,
		161,
		74,
		65,
		92,
		96,
		85,
		80,
		67,
		-1,
		-1,
		117,
		121,
		-1,
		-1,
		129,
		139,
		122,
		124,
		128,
		142,
		154,
		162,
		152,
		150,
		144,
		176,
		-1,
		154,
		153,
		142,
		139,
		115,
		106,
		101,
		128,
		-1,
		-1,
		77,
		93,
		106,
		110,
		126,
		151,
		-1,
		70,
		-1,
		-1,
		138,
		-1,
		-1,
		181,
		144,
		133,
		124,
		130,
		136,
		147,
		169,
		158,
		159,
		149,
		159,
		172,
		138,
		135,
		123,
		121,
		144,
		109,
		97,
		-1,
		92,
		80,
		86,
		93,
		110,
		140,
		-1,
		-1,
		86,
		77,
		-1,
		-1,
		157,
		164,
		166,
		-1,
		156,
		129,
		134,
		159,
		166,
		167,
		161,
		155,
		162,
		161,
		169,
		177,
		147,
		161,
		150,
		146,
		145,
		153,
		102,
		95,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		121,
		96,
		-1,
		-1,
		164,
		167,
		155,
		143,
		133,
		143,
		151,
		151,
		154,
		158,
		153,
		164,
		156,
		160,
		177,
		-1,
		181,
		-1,
		133,
		101,
		121,
		136,
		144,
		-1,
		-1,
		-1,
		138,
		124,
		117,
		105,
		103,
		-1,
		208,
		192,
		173,
		-1,
		143,
		156,
		187,
		155,
		160,
		155,
		159,
		170,
		159,
		162,
		176,
		171,
		-1,
		-1,
		119,
		122,
		-1,
		-1,
		146,
		165,
		-1,
		129,
		118,
		103,
		95,
		-1,
		-1,
		180,
		176,
		-1,
		-1,
		144,
		169,
		158,
		166,
		161,
		163,
		169,
		172,
		161,
		165,
		177,
		-1,
		-1,
		126,
		129,
		134,
		-1,
		155,
		-1,
		153,
		-1,
		98,
		114,
		116,
		-1,
		-1,
		-1,
		182,
		145,
		166,
		176,
		181,
		179,
		170,
		167,
		174,
		172,
		168,
		179,
		-1,
		-1,
		-1,
		179,
		153,
		160,
		151,
		134,
		114,
		106,
		131,
		-1,
		170,
		-1,
		145,
		146,
		173,
		175,
		192,
		186,
		170,
		185,
		175,
		166,
		175,
		185,
		-1,
		155,
		188,
		152,
		120,
		120,
		119,
		184,
		-1,
		167,
		149,
		-1,
		177,
		167,
		209,
		190,
		183,
		170,
		177,
		179,
		172,
		-1,
		-1,
		-1,
		157,
		156,
		148,
		142,
		140,
		125,
		120,
		-1,
		172,
		154,
		140,
		157,
		157,
		148,
		156,
		199,
		195,
		188,
		190,
		180,
		-1,
		253,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		151,
		160,
		133,
		121,
		135,
		142,
		137,
		139,
		152,
		160,
		158,
		155,
		167,
		163,
		183,
		179,
		211,
		-1,
		260,
		-1,
		187,
		-1,
		-1,
		167,
		153,
		155,
		144,
		133,
		131,
		134,
		132,
		154,
		184,
		170,
		168,
		173,
		178,
		-1,
		255,
		254,
		-1,
		186,
		178,
		164,
		-1,
		157,
		-1,
		179,
		140,
		-1,
		161,
		141,
		-1,
		179,
		175,
		-1,
		-1,
		242,
		202,
		-1,
		-1,
		-1,
		187,
		167,
		174,
		158,
		-1,
		152,
		152,
		-1,
		-1,
		-1,
		227,
		211,
		-1,
		180,
		183,
		-1,
		174,
		180,
		207,
		154,
		158,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		195,
		200,
		188,
		205,
		191,
		190,
		168,
		157,
		178,
		-1,
		-1,
		-1,
		208,
		200,
		200,
		-1,
		-1,
		215,
		198,
		179,
		177,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		205,
		-1,
		-1,
		211,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		219,
		-1,
		-1,
		-1,
		201,
		197,
		198,
		-1,
		-1,
		-1,
		-1,
		240,
		241,
		265,
		240,
		-1,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		243,
		241,
		-1,
		-1,
		-1,
		221,
		205,
		-1,
		191,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		226,
		-1,
		226,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		239,
		231,
		239,
		-1,
		211,
		213,
		-1,
		261,
		-1,
		-1,
		254,
		245,
		-1,
		-1,
		216,
		223,
		245,
		248,
		284,
		-1,
		235
	],
	[
		-1,
		251,
		240,
		251,
		259,
		232,
		239,
		-1,
		260,
		262,
		228,
		222,
		261,
		232,
		238,
		249,
		-1,
		-1,
		-1,
		251,
		250,
		220,
		218,
		227,
		232,
		239,
		-1,
		241,
		-1,
		272,
		251,
		262,
		267,
		213,
		210,
		230,
		249,
		234,
		226,
		287,
		243,
		214,
		208,
		226,
		219,
		228,
		220,
		-1,
		214,
		204,
		226,
		208,
		219,
		211,
		-1,
		-1,
		208,
		209,
		215,
		204,
		210,
		206,
		-1,
		216,
		200,
		-1,
		-1,
		198,
		202,
		186,
		189,
		197,
		195,
		208,
		200,
		195,
		-1,
		-1,
		192,
		188,
		195,
		182,
		178,
		195,
		208,
		190,
		204,
		203,
		-1,
		187,
		205,
		214,
		189,
		187,
		171,
		169,
		187,
		189,
		195,
		195,
		-1,
		179,
		181,
		203,
		211,
		211,
		187,
		174,
		174,
		184,
		177,
		196,
		184,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		176,
		184,
		207,
		199,
		189,
		204,
		197,
		177,
		174,
		172,
		169,
		185,
		183,
		193,
		-1,
		-1,
		232,
		201,
		236,
		193,
		178,
		-1,
		172,
		183,
		189,
		193,
		187,
		180,
		194,
		190,
		-1,
		163,
		162,
		190,
		176,
		187,
		192,
		-1,
		-1,
		190,
		182,
		167,
		170,
		167,
		167,
		197,
		196,
		189,
		175,
		171,
		177,
		180,
		180,
		186,
		157,
		167,
		171,
		169,
		194,
		-1,
		-1,
		229,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		162,
		179,
		169,
		190,
		205,
		199,
		191,
		185,
		173,
		175,
		172,
		185,
		173,
		154,
		179,
		183,
		164,
		185,
		180,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		191,
		-1,
		212,
		208,
		209,
		194,
		191,
		178,
		166,
		179,
		164,
		171,
		170,
		158,
		156,
		186,
		161,
		183,
		180,
		199,
		204,
		198,
		207,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		199,
		212,
		216,
		205,
		208,
		195,
		186,
		173,
		162,
		173,
		162,
		159,
		167,
		150,
		165,
		156,
		155,
		173,
		183,
		191,
		195,
		201,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		200,
		220,
		218,
		209,
		-1,
		204,
		201,
		191,
		169,
		154,
		171,
		163,
		161,
		163,
		145,
		159,
		150,
		168,
		175,
		173,
		177,
		197,
		209,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		243,
		215,
		-1,
		210,
		-1,
		202,
		219,
		-1,
		175,
		171,
		153,
		154,
		149,
		164,
		156,
		141,
		138,
		156,
		159,
		166,
		170,
		186,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		208,
		197,
		196,
		-1,
		187,
		189,
		186,
		174,
		161,
		146,
		147,
		155,
		167,
		146,
		140,
		137,
		157,
		183,
		161,
		172,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		226,
		219,
		207,
		172,
		172,
		166,
		-1,
		185,
		164,
		155,
		144,
		142,
		155,
		147,
		155,
		135,
		133,
		152,
		164,
		155,
		163,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		205,
		191,
		196,
		171,
		164,
		158,
		198,
		181,
		162,
		151,
		143,
		132,
		143,
		151,
		149,
		131,
		140,
		146,
		170,
		151,
		157,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		196,
		193,
		-1,
		163,
		-1,
		152,
		160,
		156,
		151,
		148,
		135,
		134,
		148,
		148,
		138,
		133,
		140,
		175,
		175,
		141,
		161,
		164,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		163,
		164,
		-1,
		157,
		151,
		157,
		156,
		154,
		139,
		143,
		145,
		148,
		136,
		142,
		143,
		125,
		149,
		-1,
		149,
		143,
		151,
		141,
		129,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		148,
		141,
		-1,
		144,
		144,
		151,
		146,
		142,
		144,
		141,
		130,
		143,
		136,
		130,
		124,
		137,
		141,
		142,
		131,
		127,
		124,
		138,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		156,
		148,
		139,
		133,
		139,
		157,
		155,
		170,
		154,
		156,
		152,
		144,
		139,
		125,
		118,
		129,
		114,
		132,
		138,
		129,
		124,
		123,
		134,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		134,
		150,
		-1,
		173,
		152,
		175,
		153,
		165,
		163,
		161,
		162,
		132,
		137,
		139,
		127,
		130,
		119,
		122,
		114,
		136,
		133,
		117,
		119,
		128,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		121,
		137,
		-1,
		-1,
		189,
		-1,
		143,
		145,
		177,
		175,
		151,
		126,
		133,
		151,
		124,
		119,
		124,
		113,
		113,
		108,
		127,
		113,
		111,
		126,
		142,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		154,
		-1,
		167,
		155,
		142,
		124,
		164,
		-1,
		125,
		121,
		128,
		-1,
		144,
		-1,
		116,
		119,
		110,
		105,
		102,
		113,
		111,
		120,
		121,
		-1,
		161,
		146,
		139,
		129,
		143,
		111,
		-1,
		145,
		-1,
		-1,
		154,
		148,
		148,
		117,
		114,
		141,
		121,
		113,
		128,
		127,
		114,
		113,
		101,
		101,
		104,
		98,
		111,
		121,
		127,
		119,
		-1,
		-1,
		-1,
		166,
		141,
		135,
		107,
		111,
		-1,
		-1,
		215,
		171,
		157,
		-1,
		109,
		141,
		129,
		119,
		109,
		114,
		115,
		105,
		103,
		99,
		108,
		107,
		100,
		99,
		120,
		113,
		135,
		-1,
		-1,
		140,
		133,
		121,
		89,
		84,
		-1,
		-1,
		-1,
		161,
		147,
		135,
		107,
		130,
		-1,
		-1,
		113,
		106,
		100,
		98,
		91,
		111,
		118,
		106,
		93,
		108,
		118,
		126,
		125,
		-1,
		143,
		130,
		-1,
		-1,
		83,
		73,
		-1,
		-1,
		-1,
		-1,
		125,
		106,
		101,
		96,
		100,
		112,
		-1,
		85,
		89,
		89,
		109,
		116,
		108,
		93,
		87,
		98,
		113,
		130,
		-1,
		-1,
		97,
		-1,
		59,
		-1,
		-1,
		-1,
		-1,
		97,
		112,
		89,
		82,
		86,
		-1,
		83,
		82,
		86,
		92,
		104,
		108,
		99,
		81,
		95,
		98,
		111,
		125,
		129,
		120,
		-1,
		50,
		-1,
		-1,
		-1,
		89,
		90,
		122,
		99,
		78,
		71,
		68,
		74,
		78,
		90,
		99,
		110,
		75,
		79,
		94,
		99,
		103,
		120,
		124,
		-1,
		-1,
		48,
		44,
		79,
		91,
		63,
		149,
		-1,
		-1,
		67,
		60,
		70,
		70,
		83,
		86,
		71,
		73,
		91,
		104,
		98,
		108,
		123,
		118,
		-1,
		-1,
		-1,
		60,
		-1,
		62,
		-1,
		-1,
		53,
		140,
		87,
		69,
		65,
		51,
		65,
		59,
		61,
		66,
		85,
		80,
		89,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		39,
		31,
		26,
		32,
		37,
		28,
		102,
		99,
		-1,
		47,
		88,
		56,
		70,
		66,
		73,
		78,
		84,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		176,
		165,
		154,
		160,
		-1,
		32,
		28,
		18,
		8,
		14,
		-1,
		-1,
		61,
		58,
		61,
		48,
		54,
		59,
		62,
		100,
		76,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		130,
		167,
		160,
		128,
		136,
		167,
		-1,
		22,
		14,
		25,
		0,
		8,
		-1,
		-1,
		34,
		30,
		35,
		44,
		47,
		83,
		82,
		95,
		98,
		103,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		123,
		143,
		122,
		125,
		149,
		163,
		-1,
		19,
		-1,
		-1,
		31,
		21,
		29,
		25,
		29,
		82,
		58,
		53,
		66,
		68,
		92,
		83,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		112,
		123,
		116,
		-1,
		-1,
		-1,
		-1,
		20,
		-1,
		-1,
		47,
		-1,
		55,
		-1,
		48,
		52,
		66,
		69,
		91,
		78,
		85,
		102,
		108,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		137,
		93,
		96,
		107,
		118,
		133,
		137,
		-1,
		31,
		70,
		85,
		-1,
		56,
		-1,
		-1,
		-1,
		62,
		79,
		71,
		87,
		90,
		90,
		86,
		90,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		133,
		124,
		137,
		82,
		82,
		103,
		112,
		133,
		46,
		37,
		64,
		92,
		81,
		76,
		63,
		-1,
		-1,
		85,
		89,
		-1,
		-1,
		97,
		107,
		90,
		92,
		96,
		110,
		122,
		130,
		120,
		118,
		112,
		144,
		-1,
		126,
		125,
		114,
		111,
		87,
		78,
		73,
		100,
		-1,
		-1,
		49,
		65,
		78,
		82,
		98,
		123,
		-1,
		66,
		-1,
		-1,
		106,
		-1,
		-1,
		149,
		112,
		101,
		92,
		98,
		104,
		115,
		137,
		126,
		127,
		117,
		127,
		140,
		110,
		107,
		95,
		93,
		116,
		81,
		69,
		-1,
		64,
		52,
		58,
		65,
		82,
		112,
		-1,
		-1,
		82,
		73,
		-1,
		-1,
		125,
		132,
		134,
		-1,
		124,
		97,
		102,
		127,
		134,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		119,
		133,
		122,
		118,
		117,
		125,
		74,
		67,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		117,
		92,
		-1,
		-1,
		132,
		135,
		123,
		111,
		101,
		111,
		119,
		119,
		122,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		153,
		-1,
		105,
		73,
		93,
		108,
		116,
		-1,
		-1,
		-1,
		134,
		120,
		113,
		101,
		99,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		91,
		94,
		-1,
		-1,
		118,
		137,
		-1,
		125,
		114,
		99,
		91,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		98,
		101,
		106,
		-1,
		127,
		-1,
		149,
		-1,
		94,
		110,
		112,
		-1,
		-1,
		-1,
		150,
		113,
		134,
		144,
		149,
		147,
		138,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		157,
		134,
		156,
		147,
		130,
		110,
		102,
		127,
		-1,
		138,
		-1,
		113,
		114,
		141,
		143,
		160,
		154,
		138,
		153,
		143,
		134,
		143,
		163,
		-1,
		138,
		184,
		148,
		116,
		116,
		115,
		159,
		-1,
		135,
		117,
		-1,
		145,
		135,
		177,
		158,
		151,
		138,
		145,
		147,
		140,
		-1,
		-1,
		-1,
		153,
		152,
		144,
		138,
		136,
		121,
		116,
		-1,
		147,
		129,
		108,
		125,
		125,
		116,
		124,
		167,
		163,
		156,
		158,
		148,
		-1,
		225,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		147,
		156,
		129,
		117,
		130,
		126,
		112,
		118,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		147,
		179,
		-1,
		232,
		-1,
		183,
		-1,
		-1,
		163,
		149,
		151,
		140,
		129,
		127,
		125,
		116,
		138,
		154,
		138,
		136,
		141,
		146,
		-1,
		242,
		243,
		-1,
		182,
		174,
		160,
		-1,
		153,
		-1,
		175,
		136,
		-1,
		145,
		125,
		-1,
		147,
		143,
		-1,
		-1,
		238,
		198,
		-1,
		-1,
		-1,
		183,
		163,
		170,
		154,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		176,
		179,
		-1,
		170,
		176,
		191,
		138,
		142,
		-1,
		-1,
		-1,
		232,
		213,
		207,
		191,
		196,
		184,
		201,
		187,
		174,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		204,
		196,
		196,
		-1,
		-1,
		199,
		182,
		163,
		161,
		-1,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		189,
		-1,
		-1,
		195,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		215,
		-1,
		-1,
		-1,
		185,
		181,
		182,
		-1,
		-1,
		-1,
		-1,
		236,
		237,
		261,
		233,
		-1,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		239,
		237,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		175,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		210,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		223,
		215,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		200,
		207,
		229,
		232,
		268,
		-1,
		219
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		259,
		263,
		229,
		223,
		262,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		252,
		251,
		219,
		217,
		226,
		231,
		238,
		-1,
		237,
		-1,
		273,
		252,
		263,
		268,
		212,
		209,
		229,
		248,
		230,
		222,
		288,
		242,
		213,
		207,
		225,
		215,
		224,
		216,
		-1,
		213,
		203,
		225,
		204,
		215,
		207,
		-1,
		-1,
		207,
		208,
		214,
		200,
		206,
		202,
		-1,
		212,
		196,
		-1,
		-1,
		197,
		198,
		182,
		185,
		193,
		191,
		204,
		196,
		191,
		-1,
		-1,
		188,
		184,
		191,
		178,
		174,
		191,
		204,
		186,
		200,
		199,
		-1,
		194,
		212,
		217,
		185,
		183,
		167,
		165,
		183,
		185,
		191,
		191,
		-1,
		191,
		193,
		199,
		207,
		207,
		183,
		170,
		170,
		180,
		173,
		192,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		188,
		186,
		203,
		195,
		185,
		200,
		193,
		173,
		170,
		168,
		165,
		181,
		179,
		189,
		-1,
		-1,
		244,
		213,
		248,
		205,
		190,
		-1,
		184,
		179,
		185,
		189,
		183,
		176,
		190,
		186,
		-1,
		159,
		158,
		186,
		172,
		183,
		204,
		-1,
		-1,
		202,
		194,
		179,
		182,
		179,
		179,
		194,
		193,
		185,
		171,
		167,
		173,
		176,
		176,
		182,
		153,
		163,
		167,
		165,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		174,
		191,
		181,
		202,
		204,
		195,
		187,
		181,
		169,
		171,
		168,
		181,
		169,
		150,
		175,
		179,
		160,
		181,
		176,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		203,
		-1,
		216,
		204,
		205,
		190,
		187,
		174,
		162,
		175,
		160,
		167,
		166,
		154,
		152,
		182,
		157,
		179,
		176,
		195,
		200,
		194,
		203,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		211,
		224,
		219,
		201,
		204,
		191,
		182,
		169,
		158,
		169,
		158,
		155,
		163,
		146,
		161,
		152,
		151,
		169,
		179,
		187,
		191,
		197,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		212,
		232,
		221,
		212,
		-1,
		200,
		197,
		187,
		165,
		150,
		167,
		159,
		157,
		159,
		141,
		155,
		146,
		164,
		171,
		169,
		173,
		193,
		205,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		254,
		218,
		-1,
		213,
		-1,
		202,
		215,
		-1,
		171,
		167,
		149,
		150,
		145,
		160,
		152,
		137,
		134,
		152,
		155,
		162,
		166,
		182,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		211,
		200,
		199,
		-1,
		190,
		185,
		182,
		170,
		157,
		142,
		143,
		151,
		163,
		142,
		136,
		133,
		153,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		229,
		222,
		210,
		175,
		175,
		169,
		-1,
		181,
		160,
		151,
		140,
		138,
		151,
		143,
		151,
		131,
		129,
		148,
		160,
		151,
		162,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		140,
		163,
		200,
		208,
		194,
		199,
		174,
		167,
		161,
		194,
		177,
		158,
		147,
		139,
		128,
		139,
		147,
		145,
		127,
		136,
		142,
		166,
		150,
		156,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		154,
		161,
		193,
		199,
		205,
		-1,
		166,
		-1,
		155,
		163,
		152,
		147,
		144,
		131,
		130,
		144,
		144,
		134,
		129,
		136,
		171,
		171,
		140,
		160,
		163,
		-1,
		-1,
		-1,
		204,
		199,
		174,
		151,
		135,
		171,
		-1,
		175,
		176,
		-1,
		160,
		154,
		160,
		154,
		150,
		135,
		139,
		141,
		144,
		132,
		138,
		139,
		121,
		145,
		-1,
		148,
		142,
		150,
		140,
		128,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		130,
		182,
		-1,
		-1,
		160,
		153,
		-1,
		147,
		145,
		147,
		140,
		134,
		140,
		136,
		126,
		139,
		132,
		126,
		120,
		133,
		137,
		141,
		130,
		126,
		123,
		137,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		150,
		-1,
		168,
		160,
		151,
		145,
		146,
		157,
		156,
		162,
		146,
		149,
		144,
		140,
		131,
		121,
		114,
		125,
		110,
		128,
		136,
		128,
		122,
		121,
		133,
		-1,
		217,
		203,
		174,
		-1,
		-1,
		163,
		-1,
		127,
		146,
		162,
		-1,
		184,
		163,
		178,
		156,
		160,
		159,
		153,
		154,
		124,
		129,
		131,
		119,
		122,
		115,
		118,
		110,
		132,
		132,
		116,
		117,
		126,
		-1,
		223,
		210,
		168,
		164,
		153,
		173,
		124,
		133,
		149,
		-1,
		-1,
		184,
		-1,
		138,
		140,
		173,
		171,
		143,
		118,
		125,
		143,
		116,
		111,
		120,
		109,
		107,
		104,
		126,
		112,
		110,
		127,
		143,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		139,
		126,
		120,
		-1,
		166,
		-1,
		162,
		150,
		137,
		119,
		159,
		-1,
		117,
		113,
		120,
		-1,
		136,
		-1,
		108,
		111,
		102,
		99,
		98,
		109,
		107,
		118,
		122,
		-1,
		173,
		158,
		151,
		141,
		155,
		123,
		-1,
		157,
		-1,
		-1,
		149,
		143,
		143,
		112,
		109,
		133,
		113,
		105,
		120,
		119,
		106,
		105,
		93,
		93,
		96,
		99,
		112,
		122,
		125,
		120,
		-1,
		-1,
		-1,
		178,
		153,
		147,
		119,
		123,
		-1,
		-1,
		210,
		166,
		152,
		-1,
		104,
		133,
		121,
		111,
		101,
		106,
		107,
		97,
		95,
		91,
		100,
		104,
		101,
		100,
		121,
		114,
		136,
		-1,
		-1,
		152,
		145,
		133,
		101,
		96,
		-1,
		-1,
		-1,
		156,
		142,
		130,
		102,
		122,
		-1,
		-1,
		105,
		98,
		92,
		90,
		83,
		103,
		110,
		107,
		94,
		109,
		119,
		127,
		126,
		-1,
		155,
		142,
		-1,
		-1,
		95,
		85,
		-1,
		-1,
		-1,
		-1,
		120,
		101,
		93,
		88,
		92,
		104,
		-1,
		77,
		81,
		81,
		101,
		108,
		109,
		94,
		88,
		99,
		114,
		131,
		-1,
		-1,
		109,
		-1,
		71,
		-1,
		-1,
		-1,
		-1,
		92,
		107,
		81,
		74,
		78,
		-1,
		75,
		74,
		78,
		84,
		97,
		102,
		100,
		82,
		96,
		99,
		112,
		126,
		130,
		132,
		-1,
		62,
		-1,
		-1,
		-1,
		84,
		85,
		114,
		91,
		70,
		63,
		60,
		66,
		70,
		86,
		92,
		103,
		76,
		80,
		95,
		100,
		104,
		121,
		125,
		-1,
		-1,
		60,
		56,
		91,
		92,
		58,
		141,
		-1,
		-1,
		59,
		52,
		62,
		71,
		76,
		79,
		72,
		74,
		92,
		105,
		99,
		109,
		124,
		119,
		-1,
		-1,
		-1,
		72,
		-1,
		74,
		-1,
		-1,
		48,
		132,
		79,
		61,
		57,
		43,
		66,
		60,
		62,
		67,
		86,
		81,
		90,
		95,
		99,
		122,
		111,
		150,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		51,
		43,
		37,
		40,
		32,
		23,
		94,
		91,
		-1,
		39,
		82,
		57,
		71,
		67,
		74,
		79,
		85,
		89,
		96,
		112,
		111,
		106,
		142,
		133,
		139,
		-1,
		-1,
		188,
		177,
		166,
		172,
		-1,
		44,
		40,
		26,
		16,
		9,
		-1,
		-1,
		56,
		53,
		62,
		49,
		55,
		60,
		63,
		101,
		77,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		130,
		145,
		-1,
		142,
		179,
		172,
		140,
		148,
		179,
		-1,
		34,
		26,
		36,
		12,
		0,
		-1,
		-1,
		29,
		31,
		36,
		45,
		48,
		84,
		83,
		96,
		99,
		104,
		92,
		91,
		109,
		113,
		122,
		129,
		119,
		132,
		136,
		-1,
		135,
		155,
		134,
		137,
		161,
		175,
		-1,
		31,
		-1,
		-1,
		43,
		13,
		21,
		24,
		28,
		83,
		59,
		54,
		67,
		69,
		93,
		84,
		109,
		100,
		100,
		103,
		118,
		123,
		115,
		129,
		129,
		130,
		-1,
		124,
		135,
		128,
		-1,
		-1,
		-1,
		-1,
		32,
		-1,
		-1,
		59,
		-1,
		47,
		-1,
		40,
		44,
		67,
		70,
		92,
		79,
		86,
		103,
		109,
		98,
		108,
		104,
		105,
		114,
		125,
		137,
		136,
		137,
		149,
		105,
		108,
		119,
		130,
		145,
		149,
		-1,
		43,
		82,
		97,
		-1,
		68,
		-1,
		-1,
		-1,
		54,
		80,
		72,
		88,
		91,
		91,
		87,
		91,
		103,
		110,
		120,
		122,
		114,
		118,
		131,
		142,
		145,
		145,
		136,
		149,
		94,
		94,
		115,
		124,
		145,
		58,
		49,
		76,
		104,
		93,
		88,
		75,
		-1,
		-1,
		77,
		90,
		-1,
		-1,
		98,
		108,
		91,
		93,
		97,
		111,
		123,
		131,
		121,
		119,
		113,
		145,
		-1,
		138,
		137,
		126,
		123,
		99,
		90,
		85,
		112,
		-1,
		-1,
		61,
		77,
		90,
		94,
		110,
		135,
		-1,
		78,
		-1,
		-1,
		98,
		-1,
		-1,
		150,
		113,
		102,
		93,
		99,
		105,
		116,
		138,
		127,
		128,
		118,
		128,
		141,
		122,
		119,
		107,
		105,
		128,
		93,
		81,
		-1,
		76,
		64,
		70,
		77,
		94,
		124,
		-1,
		-1,
		94,
		85,
		-1,
		-1,
		117,
		124,
		135,
		-1,
		125,
		98,
		103,
		128,
		135,
		136,
		130,
		124,
		131,
		130,
		138,
		146,
		131,
		145,
		134,
		130,
		129,
		137,
		86,
		79,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		104,
		-1,
		-1,
		124,
		131,
		124,
		112,
		102,
		112,
		120,
		120,
		123,
		127,
		122,
		133,
		125,
		129,
		146,
		-1,
		165,
		-1,
		117,
		85,
		105,
		120,
		128,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		174,
		158,
		139,
		-1,
		112,
		125,
		156,
		124,
		129,
		124,
		128,
		139,
		128,
		131,
		145,
		140,
		-1,
		-1,
		103,
		106,
		-1,
		-1,
		130,
		149,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		146,
		142,
		-1,
		-1,
		113,
		138,
		127,
		135,
		130,
		132,
		138,
		141,
		130,
		134,
		146,
		-1,
		-1,
		110,
		113,
		118,
		-1,
		139,
		-1,
		161,
		-1,
		106,
		122,
		124,
		-1,
		-1,
		-1,
		151,
		114,
		135,
		145,
		150,
		148,
		139,
		136,
		143,
		141,
		137,
		148,
		-1,
		-1,
		-1,
		169,
		146,
		168,
		159,
		142,
		122,
		114,
		139,
		-1,
		139,
		-1,
		114,
		115,
		142,
		144,
		161,
		155,
		139,
		154,
		144,
		135,
		144,
		175,
		-1,
		150,
		196,
		160,
		128,
		128,
		127,
		160,
		-1,
		136,
		118,
		-1,
		146,
		136,
		178,
		159,
		152,
		139,
		146,
		148,
		141,
		-1,
		-1,
		-1,
		165,
		164,
		156,
		150,
		148,
		133,
		128,
		-1,
		148,
		130,
		109,
		126,
		126,
		117,
		125,
		168,
		164,
		157,
		159,
		149,
		-1,
		237,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		159,
		164,
		137,
		125,
		131,
		127,
		113,
		119,
		121,
		129,
		127,
		124,
		136,
		132,
		152,
		148,
		180,
		-1,
		244,
		-1,
		195,
		-1,
		-1,
		175,
		161,
		159,
		148,
		137,
		135,
		126,
		117,
		139,
		155,
		139,
		137,
		142,
		147,
		-1,
		254,
		255,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		183,
		144,
		-1,
		146,
		126,
		-1,
		148,
		144,
		-1,
		-1,
		247,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		178,
		162,
		-1,
		137,
		137,
		-1,
		-1,
		-1,
		232,
		219,
		-1,
		188,
		191,
		-1,
		182,
		184,
		192,
		139,
		143,
		-1,
		-1,
		-1,
		241,
		222,
		216,
		203,
		208,
		196,
		205,
		191,
		175,
		153,
		142,
		163,
		-1,
		-1,
		-1,
		213,
		205,
		198,
		-1,
		-1,
		200,
		183,
		164,
		162,
		-1,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		190,
		-1,
		-1,
		196,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		224,
		-1,
		-1,
		-1,
		186,
		182,
		183,
		-1,
		-1,
		-1,
		-1,
		246,
		247,
		270,
		234,
		-1,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		249,
		247,
		-1,
		-1,
		-1,
		206,
		190,
		-1,
		176,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		211,
		-1,
		211,
		186,
		193,
		-1,
		-1,
		-1,
		-1,
		224,
		216,
		224,
		-1,
		196,
		198,
		-1,
		246,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		201,
		208,
		230,
		233,
		269,
		-1,
		220
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		234,
		223,
		234,
		242,
		215,
		222,
		-1,
		241,
		245,
		211,
		205,
		244,
		213,
		219,
		230,
		-1,
		-1,
		-1,
		234,
		233,
		201,
		199,
		208,
		213,
		220,
		-1,
		219,
		-1,
		255,
		234,
		245,
		250,
		194,
		191,
		211,
		230,
		212,
		204,
		270,
		224,
		195,
		189,
		207,
		197,
		206,
		198,
		-1,
		195,
		185,
		207,
		186,
		197,
		189,
		-1,
		-1,
		189,
		190,
		196,
		182,
		188,
		184,
		-1,
		194,
		178,
		-1,
		-1,
		179,
		180,
		164,
		167,
		175,
		173,
		186,
		178,
		173,
		-1,
		-1,
		170,
		166,
		173,
		160,
		156,
		173,
		186,
		168,
		182,
		181,
		-1,
		176,
		194,
		199,
		167,
		165,
		149,
		147,
		165,
		167,
		173,
		173,
		-1,
		185,
		186,
		181,
		189,
		189,
		165,
		152,
		152,
		162,
		155,
		174,
		162,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		185,
		168,
		185,
		177,
		167,
		182,
		175,
		155,
		152,
		150,
		147,
		163,
		161,
		171,
		-1,
		-1,
		267,
		236,
		271,
		228,
		213,
		-1,
		181,
		161,
		167,
		171,
		165,
		158,
		172,
		168,
		-1,
		141,
		140,
		168,
		154,
		165,
		227,
		-1,
		-1,
		225,
		217,
		202,
		205,
		191,
		187,
		176,
		175,
		167,
		153,
		149,
		155,
		158,
		158,
		164,
		135,
		145,
		149,
		147,
		172,
		-1,
		-1,
		207,
		-1,
		-1,
		224,
		207,
		-1,
		190,
		197,
		197,
		203,
		189,
		210,
		186,
		177,
		169,
		163,
		151,
		153,
		150,
		163,
		151,
		132,
		157,
		161,
		142,
		163,
		158,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		183,
		186,
		192,
		216,
		226,
		-1,
		198,
		186,
		187,
		172,
		169,
		156,
		144,
		157,
		142,
		149,
		148,
		136,
		134,
		164,
		139,
		161,
		158,
		177,
		182,
		176,
		185,
		-1,
		232,
		228,
		224,
		231,
		180,
		-1,
		-1,
		220,
		-1,
		234,
		235,
		210,
		183,
		186,
		173,
		164,
		151,
		140,
		151,
		140,
		137,
		145,
		128,
		143,
		134,
		133,
		151,
		161,
		169,
		173,
		179,
		-1,
		282,
		-1,
		224,
		208,
		210,
		182,
		203,
		-1,
		240,
		235,
		227,
		212,
		210,
		-1,
		182,
		179,
		169,
		147,
		132,
		149,
		141,
		139,
		141,
		123,
		137,
		128,
		146,
		153,
		151,
		155,
		175,
		187,
		242,
		232,
		-1,
		214,
		219,
		178,
		186,
		205,
		252,
		216,
		-1,
		211,
		-1,
		184,
		197,
		-1,
		153,
		149,
		131,
		132,
		127,
		142,
		134,
		119,
		116,
		134,
		137,
		144,
		148,
		164,
		-1,
		-1,
		227,
		231,
		220,
		171,
		190,
		214,
		251,
		209,
		198,
		197,
		-1,
		188,
		167,
		164,
		152,
		139,
		124,
		125,
		133,
		145,
		124,
		118,
		115,
		135,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		197,
		168,
		192,
		234,
		227,
		220,
		208,
		173,
		173,
		167,
		-1,
		163,
		142,
		133,
		122,
		120,
		133,
		125,
		133,
		113,
		111,
		130,
		142,
		133,
		143,
		-1,
		-1,
		-1,
		227,
		216,
		217,
		163,
		186,
		223,
		206,
		192,
		197,
		172,
		165,
		159,
		176,
		159,
		140,
		129,
		121,
		110,
		121,
		129,
		127,
		109,
		118,
		124,
		148,
		131,
		137,
		-1,
		-1,
		234,
		224,
		208,
		210,
		207,
		177,
		184,
		216,
		197,
		210,
		-1,
		164,
		-1,
		153,
		149,
		134,
		129,
		126,
		113,
		112,
		126,
		126,
		116,
		111,
		118,
		153,
		153,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		227,
		222,
		197,
		174,
		158,
		194,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		136,
		132,
		117,
		121,
		123,
		126,
		114,
		120,
		121,
		103,
		127,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		220,
		199,
		192,
		212,
		153,
		205,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		129,
		122,
		116,
		122,
		118,
		108,
		121,
		114,
		108,
		102,
		115,
		119,
		122,
		111,
		107,
		104,
		118,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		173,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		144,
		128,
		131,
		126,
		122,
		113,
		103,
		96,
		107,
		92,
		110,
		118,
		109,
		104,
		103,
		114,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		186,
		-1,
		150,
		169,
		185,
		-1,
		182,
		161,
		176,
		154,
		150,
		141,
		135,
		136,
		106,
		111,
		113,
		101,
		104,
		97,
		100,
		92,
		114,
		113,
		97,
		99,
		108,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		147,
		144,
		172,
		-1,
		-1,
		190,
		-1,
		144,
		146,
		155,
		153,
		125,
		100,
		107,
		125,
		98,
		93,
		102,
		91,
		89,
		86,
		107,
		93,
		91,
		106,
		122,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		189,
		-1,
		168,
		156,
		143,
		125,
		165,
		-1,
		99,
		95,
		102,
		-1,
		118,
		-1,
		90,
		93,
		84,
		81,
		80,
		91,
		89,
		100,
		101,
		-1,
		196,
		181,
		174,
		164,
		178,
		146,
		-1,
		180,
		-1,
		-1,
		155,
		149,
		149,
		118,
		115,
		115,
		95,
		87,
		102,
		101,
		88,
		87,
		75,
		75,
		78,
		78,
		91,
		101,
		107,
		99,
		-1,
		-1,
		-1,
		201,
		176,
		170,
		142,
		146,
		-1,
		-1,
		216,
		172,
		158,
		-1,
		110,
		115,
		103,
		93,
		83,
		88,
		89,
		79,
		77,
		73,
		82,
		86,
		80,
		79,
		100,
		93,
		115,
		-1,
		-1,
		175,
		168,
		156,
		124,
		119,
		-1,
		-1,
		-1,
		162,
		163,
		129,
		108,
		104,
		-1,
		-1,
		87,
		80,
		74,
		72,
		65,
		85,
		92,
		86,
		73,
		88,
		98,
		106,
		105,
		-1,
		178,
		165,
		-1,
		-1,
		118,
		108,
		-1,
		-1,
		-1,
		-1,
		141,
		86,
		75,
		70,
		74,
		86,
		-1,
		59,
		63,
		63,
		83,
		90,
		88,
		73,
		67,
		78,
		93,
		110,
		-1,
		-1,
		132,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		63,
		56,
		60,
		-1,
		57,
		56,
		60,
		66,
		79,
		84,
		79,
		61,
		75,
		78,
		91,
		105,
		109,
		155,
		-1,
		85,
		-1,
		-1,
		-1,
		116,
		117,
		96,
		73,
		52,
		45,
		42,
		48,
		52,
		68,
		74,
		85,
		55,
		59,
		74,
		79,
		83,
		100,
		104,
		-1,
		-1,
		83,
		79,
		114,
		124,
		90,
		123,
		-1,
		-1,
		41,
		34,
		44,
		50,
		58,
		61,
		51,
		53,
		71,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		95,
		-1,
		97,
		-1,
		-1,
		80,
		114,
		61,
		43,
		39,
		25,
		45,
		39,
		41,
		46,
		65,
		60,
		69,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		74,
		66,
		60,
		63,
		64,
		55,
		76,
		73,
		-1,
		21,
		64,
		36,
		50,
		46,
		53,
		58,
		64,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		171,
		160,
		149,
		155,
		-1,
		67,
		63,
		49,
		39,
		41,
		-1,
		-1,
		27,
		24,
		41,
		28,
		34,
		39,
		42,
		80,
		56,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		125,
		162,
		155,
		123,
		131,
		162,
		-1,
		57,
		49,
		59,
		35,
		32,
		-1,
		-1,
		0,
		10,
		15,
		24,
		27,
		63,
		62,
		75,
		78,
		83,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		118,
		138,
		117,
		120,
		144,
		158,
		-1,
		54,
		-1,
		-1,
		66,
		33,
		17,
		11,
		7,
		62,
		38,
		33,
		46,
		48,
		72,
		63,
		88,
		79,
		79,
		82,
		97,
		102,
		94,
		108,
		108,
		109,
		-1,
		107,
		118,
		111,
		-1,
		-1,
		-1,
		-1,
		55,
		-1,
		-1,
		82,
		-1,
		44,
		-1,
		28,
		32,
		46,
		49,
		71,
		58,
		65,
		82,
		88,
		77,
		87,
		83,
		84,
		93,
		104,
		116,
		115,
		116,
		132,
		88,
		91,
		102,
		113,
		128,
		132,
		-1,
		66,
		105,
		120,
		-1,
		91,
		-1,
		-1,
		-1,
		42,
		59,
		51,
		67,
		70,
		70,
		66,
		70,
		82,
		89,
		99,
		101,
		93,
		97,
		110,
		121,
		124,
		128,
		119,
		132,
		77,
		77,
		98,
		107,
		128,
		81,
		72,
		99,
		127,
		116,
		111,
		98,
		-1,
		-1,
		65,
		69,
		-1,
		-1,
		77,
		87,
		70,
		72,
		76,
		90,
		102,
		110,
		100,
		98,
		92,
		124,
		-1,
		121,
		120,
		109,
		106,
		82,
		73,
		68,
		95,
		-1,
		-1,
		84,
		100,
		101,
		105,
		121,
		146,
		-1,
		101,
		-1,
		-1,
		86,
		-1,
		-1,
		129,
		92,
		81,
		72,
		78,
		84,
		95,
		117,
		106,
		107,
		97,
		107,
		120,
		105,
		102,
		90,
		88,
		111,
		76,
		64,
		-1,
		77,
		75,
		81,
		88,
		105,
		135,
		-1,
		-1,
		117,
		108,
		-1,
		-1,
		105,
		112,
		114,
		-1,
		104,
		77,
		82,
		107,
		114,
		115,
		109,
		103,
		110,
		109,
		117,
		125,
		114,
		128,
		117,
		113,
		112,
		120,
		69,
		62,
		74,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		127,
		-1,
		-1,
		112,
		115,
		103,
		91,
		81,
		91,
		99,
		99,
		102,
		106,
		101,
		112,
		104,
		108,
		125,
		-1,
		148,
		-1,
		100,
		76,
		90,
		105,
		113,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		135,
		103,
		108,
		103,
		107,
		118,
		107,
		110,
		124,
		119,
		-1,
		-1,
		88,
		91,
		-1,
		-1,
		113,
		132,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		117,
		106,
		114,
		109,
		111,
		117,
		120,
		109,
		113,
		125,
		-1,
		-1,
		95,
		96,
		101,
		-1,
		122,
		-1,
		176,
		-1,
		129,
		145,
		137,
		-1,
		-1,
		-1,
		130,
		93,
		114,
		124,
		129,
		127,
		118,
		115,
		122,
		120,
		116,
		127,
		-1,
		-1,
		-1,
		152,
		129,
		183,
		174,
		157,
		137,
		129,
		148,
		-1,
		118,
		-1,
		93,
		94,
		121,
		123,
		140,
		134,
		118,
		133,
		123,
		114,
		123,
		158,
		-1,
		133,
		185,
		149,
		143,
		119,
		123,
		139,
		-1,
		115,
		97,
		-1,
		125,
		115,
		157,
		138,
		131,
		118,
		125,
		127,
		120,
		-1,
		-1,
		-1,
		148,
		147,
		145,
		139,
		139,
		124,
		115,
		-1,
		127,
		109,
		88,
		105,
		105,
		96,
		104,
		147,
		143,
		136,
		138,
		128,
		-1,
		220,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		148,
		143,
		116,
		104,
		110,
		106,
		92,
		98,
		100,
		108,
		106,
		103,
		115,
		111,
		131,
		127,
		159,
		-1,
		227,
		-1,
		178,
		-1,
		-1,
		166,
		146,
		138,
		127,
		116,
		114,
		105,
		96,
		118,
		134,
		118,
		116,
		121,
		126,
		-1,
		237,
		238,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		162,
		123,
		-1,
		125,
		105,
		-1,
		127,
		123,
		-1,
		-1,
		226,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		157,
		141,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		211,
		210,
		-1,
		179,
		182,
		-1,
		172,
		163,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		220,
		201,
		195,
		194,
		192,
		187,
		184,
		170,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		192,
		184,
		177,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		203,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		226,
		249,
		213,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		228,
		226,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		168,
		186,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		177,
		178,
		173,
		181,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		263,
		232,
		267,
		224,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		133,
		132,
		160,
		146,
		157,
		223,
		-1,
		-1,
		221,
		213,
		198,
		201,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		199,
		-1,
		-1,
		220,
		203,
		-1,
		186,
		193,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		179,
		182,
		188,
		212,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		128,
		126,
		156,
		131,
		153,
		150,
		169,
		174,
		168,
		177,
		-1,
		228,
		224,
		220,
		227,
		176,
		-1,
		-1,
		216,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		120,
		135,
		126,
		125,
		143,
		153,
		161,
		165,
		171,
		-1,
		278,
		-1,
		220,
		204,
		206,
		178,
		199,
		-1,
		236,
		227,
		219,
		204,
		202,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		133,
		115,
		129,
		120,
		138,
		145,
		143,
		147,
		167,
		179,
		238,
		228,
		-1,
		210,
		215,
		174,
		182,
		201,
		244,
		208,
		-1,
		203,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		126,
		111,
		108,
		126,
		129,
		136,
		140,
		156,
		-1,
		-1,
		223,
		227,
		216,
		167,
		186,
		210,
		247,
		201,
		190,
		189,
		-1,
		180,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		137,
		116,
		110,
		107,
		127,
		153,
		131,
		142,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		193,
		164,
		188,
		230,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		117,
		125,
		105,
		103,
		122,
		134,
		125,
		133,
		-1,
		-1,
		-1,
		223,
		212,
		213,
		159,
		182,
		219,
		198,
		184,
		189,
		164,
		157,
		151,
		168,
		151,
		132,
		121,
		113,
		102,
		113,
		121,
		119,
		101,
		110,
		116,
		140,
		121,
		127,
		-1,
		-1,
		230,
		220,
		204,
		206,
		203,
		173,
		180,
		212,
		189,
		202,
		-1,
		156,
		-1,
		145,
		141,
		126,
		121,
		118,
		105,
		104,
		118,
		118,
		108,
		103,
		110,
		145,
		145,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		223,
		218,
		193,
		170,
		154,
		190,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		128,
		124,
		109,
		113,
		115,
		118,
		106,
		112,
		113,
		95,
		119,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		216,
		195,
		188,
		208,
		149,
		201,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		121,
		116,
		112,
		114,
		111,
		100,
		113,
		106,
		100,
		94,
		107,
		111,
		112,
		101,
		97,
		94,
		108,
		-1,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		169,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		140,
		124,
		126,
		122,
		114,
		109,
		95,
		88,
		99,
		84,
		102,
		108,
		99,
		94,
		93,
		104,
		-1,
		236,
		222,
		193,
		-1,
		-1,
		182,
		-1,
		146,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		133,
		131,
		132,
		102,
		107,
		109,
		97,
		100,
		89,
		92,
		84,
		106,
		103,
		87,
		89,
		98,
		-1,
		242,
		229,
		187,
		183,
		172,
		192,
		143,
		136,
		168,
		-1,
		-1,
		186,
		-1,
		140,
		142,
		147,
		145,
		121,
		96,
		103,
		121,
		94,
		89,
		94,
		83,
		83,
		78,
		97,
		83,
		81,
		96,
		112,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		158,
		145,
		139,
		-1,
		185,
		-1,
		164,
		152,
		139,
		121,
		161,
		-1,
		95,
		91,
		98,
		-1,
		114,
		-1,
		86,
		89,
		80,
		75,
		72,
		83,
		81,
		90,
		91,
		-1,
		192,
		177,
		170,
		160,
		174,
		142,
		-1,
		176,
		-1,
		-1,
		151,
		145,
		145,
		114,
		111,
		111,
		91,
		83,
		98,
		97,
		84,
		83,
		71,
		71,
		74,
		68,
		81,
		91,
		97,
		89,
		-1,
		-1,
		-1,
		197,
		172,
		166,
		138,
		142,
		-1,
		-1,
		212,
		168,
		154,
		-1,
		106,
		111,
		99,
		89,
		79,
		84,
		85,
		75,
		73,
		69,
		78,
		77,
		70,
		69,
		90,
		83,
		105,
		-1,
		-1,
		171,
		164,
		152,
		120,
		115,
		-1,
		-1,
		-1,
		158,
		159,
		125,
		104,
		100,
		-1,
		-1,
		83,
		76,
		70,
		69,
		61,
		81,
		88,
		76,
		63,
		78,
		88,
		96,
		95,
		-1,
		174,
		161,
		-1,
		-1,
		114,
		104,
		-1,
		-1,
		-1,
		-1,
		137,
		82,
		71,
		66,
		70,
		82,
		-1,
		56,
		60,
		60,
		79,
		86,
		78,
		63,
		57,
		68,
		83,
		100,
		-1,
		-1,
		128,
		-1,
		90,
		-1,
		-1,
		-1,
		-1,
		94,
		88,
		59,
		52,
		56,
		-1,
		54,
		53,
		57,
		63,
		74,
		78,
		69,
		51,
		65,
		68,
		81,
		95,
		99,
		151,
		-1,
		81,
		-1,
		-1,
		-1,
		112,
		118,
		92,
		69,
		48,
		41,
		38,
		44,
		49,
		60,
		69,
		80,
		45,
		49,
		64,
		69,
		73,
		90,
		94,
		-1,
		-1,
		79,
		75,
		110,
		120,
		91,
		119,
		-1,
		-1,
		37,
		30,
		40,
		40,
		53,
		56,
		41,
		43,
		61,
		74,
		68,
		78,
		93,
		88,
		-1,
		-1,
		-1,
		91,
		-1,
		93,
		-1,
		-1,
		81,
		110,
		57,
		39,
		35,
		21,
		35,
		29,
		31,
		36,
		55,
		50,
		59,
		64,
		68,
		91,
		80,
		119,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		70,
		62,
		57,
		63,
		65,
		56,
		72,
		69,
		-1,
		18,
		58,
		26,
		40,
		36,
		43,
		48,
		54,
		58,
		65,
		81,
		80,
		75,
		111,
		102,
		108,
		-1,
		-1,
		161,
		150,
		139,
		145,
		-1,
		63,
		59,
		49,
		39,
		42,
		-1,
		-1,
		36,
		33,
		31,
		18,
		24,
		29,
		32,
		70,
		46,
		54,
		58,
		62,
		68,
		73,
		78,
		84,
		99,
		114,
		-1,
		115,
		152,
		145,
		113,
		121,
		152,
		-1,
		53,
		45,
		56,
		31,
		33,
		-1,
		-1,
		9,
		0,
		5,
		14,
		17,
		53,
		52,
		65,
		68,
		73,
		61,
		60,
		78,
		82,
		91,
		98,
		88,
		101,
		105,
		-1,
		108,
		128,
		107,
		110,
		134,
		148,
		-1,
		50,
		-1,
		-1,
		62,
		34,
		18,
		8,
		5,
		52,
		28,
		23,
		36,
		38,
		62,
		53,
		78,
		69,
		69,
		72,
		87,
		92,
		84,
		98,
		98,
		99,
		-1,
		97,
		108,
		101,
		-1,
		-1,
		-1,
		-1,
		51,
		-1,
		-1,
		78,
		-1,
		45,
		-1,
		28,
		32,
		36,
		39,
		61,
		48,
		55,
		72,
		78,
		67,
		77,
		73,
		74,
		83,
		94,
		106,
		105,
		106,
		122,
		78,
		81,
		92,
		103,
		118,
		122,
		-1,
		62,
		101,
		116,
		-1,
		87,
		-1,
		-1,
		-1,
		42,
		49,
		41,
		57,
		60,
		60,
		56,
		60,
		72,
		79,
		89,
		91,
		83,
		87,
		100,
		111,
		114,
		118,
		109,
		122,
		67,
		67,
		88,
		97,
		118,
		77,
		68,
		95,
		121,
		112,
		107,
		94,
		-1,
		-1,
		65,
		59,
		-1,
		-1,
		67,
		77,
		60,
		62,
		66,
		80,
		92,
		100,
		90,
		88,
		82,
		114,
		-1,
		111,
		110,
		99,
		96,
		72,
		63,
		58,
		85,
		-1,
		-1,
		80,
		96,
		91,
		95,
		111,
		136,
		-1,
		97,
		-1,
		-1,
		86,
		-1,
		-1,
		119,
		82,
		71,
		62,
		68,
		74,
		85,
		107,
		96,
		97,
		87,
		97,
		110,
		95,
		92,
		80,
		78,
		101,
		66,
		54,
		-1,
		67,
		65,
		71,
		78,
		95,
		125,
		-1,
		-1,
		113,
		104,
		-1,
		-1,
		105,
		112,
		104,
		-1,
		94,
		67,
		72,
		97,
		104,
		105,
		99,
		93,
		100,
		99,
		107,
		115,
		104,
		118,
		107,
		103,
		102,
		110,
		59,
		52,
		64,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		123,
		-1,
		-1,
		112,
		105,
		93,
		81,
		71,
		81,
		89,
		89,
		92,
		96,
		91,
		102,
		94,
		98,
		115,
		-1,
		138,
		-1,
		90,
		66,
		80,
		95,
		103,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		146,
		130,
		111,
		-1,
		81,
		94,
		125,
		93,
		98,
		93,
		97,
		108,
		97,
		100,
		114,
		109,
		-1,
		-1,
		78,
		81,
		-1,
		-1,
		103,
		122,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		118,
		114,
		-1,
		-1,
		82,
		107,
		96,
		104,
		99,
		101,
		107,
		110,
		99,
		103,
		115,
		-1,
		-1,
		85,
		86,
		91,
		-1,
		112,
		-1,
		166,
		-1,
		125,
		139,
		127,
		-1,
		-1,
		-1,
		120,
		83,
		104,
		114,
		119,
		117,
		108,
		105,
		112,
		110,
		106,
		117,
		-1,
		-1,
		-1,
		142,
		119,
		173,
		164,
		147,
		127,
		119,
		138,
		-1,
		108,
		-1,
		83,
		84,
		111,
		113,
		130,
		124,
		108,
		123,
		113,
		104,
		113,
		148,
		-1,
		123,
		175,
		139,
		133,
		109,
		113,
		129,
		-1,
		105,
		87,
		-1,
		115,
		105,
		147,
		128,
		121,
		108,
		115,
		117,
		110,
		-1,
		-1,
		-1,
		138,
		137,
		135,
		129,
		129,
		114,
		105,
		-1,
		117,
		99,
		78,
		95,
		95,
		86,
		94,
		137,
		133,
		126,
		128,
		118,
		-1,
		210,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		138,
		133,
		106,
		94,
		100,
		96,
		82,
		88,
		90,
		98,
		96,
		93,
		105,
		101,
		121,
		117,
		149,
		-1,
		217,
		-1,
		168,
		-1,
		-1,
		156,
		136,
		128,
		117,
		106,
		104,
		95,
		86,
		108,
		124,
		108,
		106,
		111,
		116,
		-1,
		227,
		228,
		-1,
		175,
		167,
		153,
		-1,
		146,
		-1,
		152,
		113,
		-1,
		115,
		95,
		-1,
		117,
		113,
		-1,
		-1,
		216,
		191,
		-1,
		-1,
		-1,
		176,
		156,
		147,
		131,
		-1,
		106,
		106,
		-1,
		-1,
		-1,
		201,
		200,
		-1,
		169,
		172,
		-1,
		162,
		153,
		161,
		108,
		112,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		184,
		182,
		177,
		174,
		160,
		144,
		122,
		111,
		132,
		-1,
		-1,
		-1,
		182,
		174,
		167,
		-1,
		-1,
		169,
		152,
		133,
		131,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		159,
		-1,
		-1,
		165,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		193,
		-1,
		-1,
		-1,
		155,
		151,
		152,
		-1,
		-1,
		-1,
		-1,
		215,
		216,
		239,
		203,
		-1,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		218,
		216,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		145,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		180,
		-1,
		180,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		193,
		-1,
		165,
		167,
		-1,
		215,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		170,
		177,
		199,
		202,
		238,
		-1,
		189
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		170,
		188,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		179,
		180,
		175,
		183,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		162,
		179,
		171,
		161,
		176,
		169,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		270,
		228,
		209,
		-1,
		175,
		155,
		161,
		165,
		159,
		152,
		166,
		162,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		205,
		208,
		185,
		181,
		170,
		169,
		161,
		147,
		143,
		149,
		152,
		152,
		158,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		191,
		197,
		183,
		204,
		180,
		171,
		163,
		157,
		145,
		147,
		144,
		157,
		145,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		220,
		-1,
		192,
		180,
		181,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		228,
		229,
		204,
		177,
		180,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		229,
		221,
		206,
		204,
		-1,
		176,
		173,
		163,
		141,
		126,
		143,
		135,
		133,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		178,
		191,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		161,
		158,
		146,
		133,
		118,
		119,
		127,
		139,
		118,
		112,
		109,
		129,
		155,
		133,
		144,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		157,
		136,
		127,
		116,
		114,
		127,
		119,
		127,
		107,
		105,
		124,
		136,
		127,
		135,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		170,
		153,
		134,
		123,
		115,
		104,
		115,
		123,
		121,
		103,
		112,
		118,
		142,
		123,
		129,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		143,
		128,
		123,
		120,
		107,
		106,
		120,
		120,
		110,
		105,
		112,
		147,
		147,
		113,
		133,
		136,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		130,
		126,
		111,
		115,
		117,
		120,
		108,
		114,
		115,
		97,
		121,
		-1,
		121,
		115,
		123,
		113,
		101,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		123,
		118,
		114,
		116,
		113,
		102,
		115,
		108,
		102,
		96,
		109,
		113,
		114,
		103,
		99,
		96,
		110,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		142,
		126,
		128,
		124,
		116,
		111,
		97,
		90,
		101,
		86,
		104,
		110,
		101,
		96,
		95,
		106,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		135,
		133,
		134,
		104,
		109,
		111,
		99,
		102,
		91,
		94,
		86,
		108,
		105,
		89,
		91,
		100,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		195,
		-1,
		146,
		151,
		149,
		147,
		123,
		98,
		105,
		123,
		96,
		91,
		96,
		85,
		85,
		80,
		99,
		85,
		83,
		98,
		114,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		173,
		161,
		148,
		130,
		170,
		-1,
		97,
		93,
		100,
		-1,
		116,
		-1,
		88,
		91,
		82,
		77,
		74,
		85,
		83,
		92,
		93,
		-1,
		199,
		184,
		177,
		167,
		181,
		151,
		-1,
		185,
		-1,
		-1,
		160,
		154,
		154,
		123,
		120,
		113,
		93,
		85,
		100,
		99,
		86,
		85,
		73,
		73,
		76,
		70,
		83,
		93,
		99,
		91,
		-1,
		-1,
		-1,
		204,
		181,
		175,
		147,
		151,
		-1,
		-1,
		221,
		177,
		163,
		-1,
		115,
		113,
		101,
		91,
		81,
		86,
		87,
		77,
		75,
		71,
		80,
		79,
		72,
		71,
		92,
		85,
		107,
		-1,
		-1,
		180,
		173,
		161,
		129,
		124,
		-1,
		-1,
		-1,
		167,
		168,
		134,
		113,
		102,
		-1,
		-1,
		85,
		78,
		72,
		75,
		63,
		83,
		90,
		78,
		65,
		80,
		90,
		98,
		97,
		-1,
		183,
		170,
		-1,
		-1,
		123,
		113,
		-1,
		-1,
		-1,
		-1,
		146,
		91,
		80,
		75,
		79,
		84,
		-1,
		58,
		69,
		62,
		81,
		88,
		80,
		65,
		59,
		70,
		85,
		102,
		-1,
		-1,
		137,
		-1,
		99,
		-1,
		-1,
		-1,
		-1,
		103,
		97,
		68,
		61,
		65,
		-1,
		60,
		62,
		59,
		71,
		76,
		80,
		71,
		53,
		67,
		70,
		83,
		97,
		101,
		160,
		-1,
		90,
		-1,
		-1,
		-1,
		121,
		127,
		101,
		78,
		57,
		50,
		47,
		46,
		51,
		62,
		71,
		82,
		47,
		51,
		66,
		71,
		75,
		92,
		96,
		-1,
		-1,
		88,
		84,
		119,
		129,
		100,
		128,
		-1,
		-1,
		46,
		39,
		49,
		42,
		55,
		58,
		43,
		45,
		63,
		76,
		70,
		80,
		95,
		90,
		-1,
		-1,
		-1,
		100,
		-1,
		102,
		-1,
		-1,
		90,
		119,
		66,
		48,
		44,
		30,
		37,
		31,
		33,
		38,
		57,
		52,
		61,
		66,
		70,
		93,
		82,
		121,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		79,
		71,
		66,
		72,
		74,
		65,
		81,
		78,
		-1,
		27,
		60,
		28,
		42,
		38,
		45,
		50,
		56,
		60,
		67,
		83,
		82,
		77,
		113,
		104,
		110,
		-1,
		-1,
		170,
		159,
		148,
		154,
		-1,
		72,
		68,
		58,
		48,
		51,
		-1,
		-1,
		45,
		42,
		29,
		20,
		26,
		31,
		34,
		72,
		48,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		116,
		-1,
		124,
		161,
		154,
		122,
		130,
		161,
		-1,
		62,
		54,
		65,
		40,
		42,
		-1,
		-1,
		18,
		9,
		0,
		12,
		15,
		55,
		54,
		67,
		70,
		75,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		117,
		137,
		116,
		119,
		143,
		157,
		-1,
		59,
		-1,
		-1,
		71,
		43,
		27,
		17,
		14,
		47,
		26,
		21,
		38,
		40,
		64,
		55,
		80,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		106,
		117,
		110,
		-1,
		-1,
		-1,
		-1,
		60,
		-1,
		-1,
		87,
		-1,
		54,
		-1,
		37,
		41,
		34,
		37,
		63,
		50,
		57,
		74,
		80,
		69,
		79,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		131,
		87,
		90,
		101,
		112,
		127,
		131,
		-1,
		71,
		110,
		125,
		-1,
		96,
		-1,
		-1,
		-1,
		51,
		47,
		39,
		55,
		62,
		62,
		58,
		62,
		74,
		81,
		91,
		93,
		85,
		89,
		102,
		113,
		116,
		127,
		118,
		131,
		76,
		76,
		97,
		106,
		127,
		86,
		77,
		104,
		130,
		121,
		116,
		103,
		-1,
		-1,
		74,
		57,
		-1,
		-1,
		69,
		79,
		62,
		64,
		68,
		82,
		94,
		102,
		92,
		90,
		84,
		116,
		-1,
		120,
		119,
		108,
		105,
		81,
		72,
		67,
		94,
		-1,
		-1,
		89,
		105,
		100,
		104,
		120,
		145,
		-1,
		106,
		-1,
		-1,
		95,
		-1,
		-1,
		121,
		84,
		73,
		64,
		70,
		76,
		87,
		109,
		98,
		99,
		89,
		99,
		112,
		104,
		101,
		89,
		87,
		110,
		75,
		63,
		-1,
		76,
		74,
		80,
		87,
		104,
		134,
		-1,
		-1,
		122,
		113,
		-1,
		-1,
		114,
		117,
		106,
		-1,
		96,
		69,
		74,
		99,
		106,
		107,
		101,
		95,
		102,
		101,
		109,
		117,
		113,
		127,
		116,
		112,
		111,
		119,
		68,
		61,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		157,
		132,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		83,
		91,
		91,
		94,
		98,
		93,
		104,
		96,
		100,
		117,
		-1,
		147,
		-1,
		99,
		75,
		89,
		104,
		112,
		-1,
		-1,
		-1,
		174,
		160,
		153,
		141,
		139,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		127,
		95,
		100,
		95,
		99,
		110,
		99,
		102,
		116,
		111,
		-1,
		-1,
		87,
		90,
		-1,
		-1,
		112,
		131,
		-1,
		165,
		154,
		139,
		131,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		109,
		98,
		106,
		101,
		103,
		109,
		112,
		101,
		105,
		117,
		-1,
		-1,
		94,
		95,
		100,
		-1,
		121,
		-1,
		168,
		-1,
		134,
		141,
		129,
		-1,
		-1,
		-1,
		122,
		85,
		106,
		116,
		121,
		119,
		110,
		107,
		114,
		112,
		108,
		119,
		-1,
		-1,
		-1,
		151,
		128,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		86,
		113,
		115,
		132,
		126,
		110,
		125,
		115,
		106,
		115,
		157,
		-1,
		132,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		107,
		149,
		130,
		123,
		110,
		117,
		119,
		112,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		96,
		139,
		135,
		128,
		130,
		120,
		-1,
		219,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		226,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		110,
		108,
		113,
		118,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		119,
		115,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		216,
		205,
		216,
		224,
		197,
		204,
		-1,
		223,
		227,
		193,
		187,
		226,
		195,
		201,
		212,
		-1,
		-1,
		-1,
		216,
		215,
		183,
		181,
		190,
		195,
		202,
		-1,
		201,
		-1,
		237,
		216,
		227,
		232,
		176,
		173,
		193,
		212,
		194,
		186,
		252,
		206,
		177,
		171,
		189,
		179,
		188,
		180,
		-1,
		177,
		167,
		189,
		168,
		179,
		171,
		-1,
		-1,
		171,
		172,
		178,
		164,
		170,
		166,
		-1,
		176,
		160,
		-1,
		-1,
		161,
		162,
		146,
		149,
		157,
		155,
		168,
		160,
		155,
		-1,
		-1,
		152,
		148,
		155,
		142,
		138,
		155,
		168,
		150,
		164,
		163,
		-1,
		158,
		176,
		181,
		149,
		147,
		131,
		129,
		147,
		149,
		155,
		155,
		-1,
		167,
		168,
		163,
		171,
		171,
		147,
		134,
		134,
		144,
		137,
		156,
		144,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		167,
		150,
		167,
		159,
		149,
		164,
		157,
		137,
		134,
		132,
		129,
		145,
		143,
		153,
		-1,
		-1,
		258,
		227,
		258,
		216,
		197,
		-1,
		163,
		143,
		149,
		153,
		147,
		140,
		154,
		150,
		-1,
		123,
		122,
		150,
		136,
		147,
		218,
		-1,
		-1,
		216,
		208,
		193,
		196,
		173,
		169,
		158,
		157,
		149,
		135,
		131,
		137,
		140,
		140,
		146,
		117,
		127,
		131,
		129,
		154,
		-1,
		-1,
		189,
		-1,
		-1,
		215,
		198,
		-1,
		181,
		188,
		179,
		185,
		171,
		192,
		168,
		159,
		151,
		145,
		133,
		135,
		132,
		145,
		133,
		114,
		139,
		143,
		124,
		145,
		140,
		-1,
		188,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		174,
		177,
		183,
		207,
		208,
		-1,
		180,
		168,
		169,
		154,
		151,
		138,
		126,
		139,
		124,
		131,
		130,
		118,
		116,
		146,
		121,
		143,
		140,
		159,
		164,
		158,
		167,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		211,
		-1,
		216,
		217,
		192,
		165,
		168,
		155,
		146,
		133,
		122,
		133,
		122,
		119,
		127,
		110,
		125,
		116,
		115,
		133,
		143,
		151,
		155,
		161,
		-1,
		273,
		-1,
		215,
		199,
		201,
		173,
		194,
		-1,
		231,
		217,
		209,
		194,
		192,
		-1,
		164,
		161,
		151,
		129,
		114,
		131,
		123,
		121,
		123,
		105,
		119,
		110,
		128,
		135,
		133,
		137,
		157,
		169,
		233,
		223,
		-1,
		205,
		210,
		169,
		177,
		196,
		234,
		198,
		-1,
		193,
		-1,
		166,
		179,
		-1,
		135,
		131,
		113,
		114,
		109,
		124,
		116,
		101,
		98,
		116,
		119,
		126,
		130,
		146,
		-1,
		-1,
		218,
		222,
		211,
		162,
		181,
		205,
		242,
		191,
		180,
		179,
		-1,
		170,
		149,
		146,
		134,
		121,
		106,
		107,
		115,
		127,
		106,
		100,
		97,
		117,
		143,
		121,
		132,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		188,
		159,
		183,
		225,
		209,
		202,
		190,
		155,
		155,
		149,
		-1,
		145,
		124,
		115,
		104,
		102,
		115,
		107,
		115,
		95,
		93,
		112,
		124,
		115,
		123,
		-1,
		-1,
		-1,
		218,
		207,
		208,
		154,
		177,
		214,
		188,
		174,
		179,
		154,
		147,
		141,
		158,
		141,
		122,
		111,
		103,
		92,
		103,
		111,
		109,
		91,
		100,
		106,
		130,
		111,
		117,
		-1,
		-1,
		225,
		215,
		199,
		201,
		198,
		168,
		175,
		207,
		179,
		192,
		-1,
		146,
		-1,
		135,
		131,
		116,
		111,
		108,
		95,
		94,
		108,
		108,
		98,
		93,
		100,
		135,
		135,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		218,
		213,
		188,
		165,
		149,
		185,
		-1,
		162,
		163,
		-1,
		140,
		134,
		131,
		118,
		114,
		99,
		103,
		105,
		108,
		96,
		102,
		103,
		85,
		109,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		211,
		190,
		183,
		203,
		144,
		196,
		-1,
		-1,
		147,
		140,
		-1,
		127,
		109,
		111,
		106,
		102,
		104,
		101,
		90,
		103,
		96,
		90,
		84,
		97,
		101,
		102,
		91,
		87,
		84,
		98,
		-1,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		164,
		-1,
		156,
		148,
		138,
		132,
		126,
		122,
		120,
		130,
		114,
		116,
		112,
		104,
		99,
		85,
		78,
		89,
		74,
		92,
		98,
		89,
		84,
		83,
		94,
		-1,
		231,
		217,
		188,
		-1,
		-1,
		177,
		-1,
		141,
		155,
		171,
		-1,
		164,
		143,
		158,
		136,
		132,
		123,
		121,
		122,
		92,
		97,
		99,
		87,
		90,
		79,
		82,
		74,
		96,
		93,
		77,
		79,
		88,
		-1,
		237,
		224,
		182,
		178,
		167,
		187,
		138,
		126,
		158,
		-1,
		-1,
		190,
		-1,
		134,
		146,
		137,
		135,
		111,
		86,
		93,
		111,
		84,
		79,
		84,
		73,
		73,
		68,
		87,
		73,
		71,
		86,
		102,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		153,
		140,
		134,
		-1,
		175,
		-1,
		168,
		156,
		143,
		125,
		165,
		-1,
		85,
		81,
		88,
		-1,
		104,
		-1,
		76,
		79,
		70,
		65,
		62,
		73,
		71,
		80,
		81,
		-1,
		187,
		172,
		165,
		155,
		169,
		140,
		-1,
		188,
		-1,
		-1,
		155,
		149,
		149,
		118,
		115,
		101,
		81,
		73,
		88,
		87,
		74,
		73,
		61,
		61,
		64,
		58,
		71,
		81,
		87,
		79,
		-1,
		-1,
		-1,
		192,
		178,
		178,
		142,
		154,
		-1,
		-1,
		216,
		172,
		158,
		-1,
		110,
		101,
		89,
		79,
		69,
		74,
		75,
		65,
		63,
		59,
		68,
		67,
		60,
		59,
		80,
		73,
		95,
		-1,
		-1,
		175,
		176,
		164,
		132,
		127,
		-1,
		-1,
		-1,
		162,
		163,
		129,
		108,
		90,
		-1,
		-1,
		73,
		66,
		60,
		63,
		51,
		71,
		78,
		66,
		53,
		68,
		78,
		86,
		85,
		-1,
		178,
		165,
		-1,
		-1,
		126,
		116,
		-1,
		-1,
		-1,
		-1,
		141,
		86,
		75,
		70,
		74,
		72,
		-1,
		46,
		57,
		50,
		69,
		76,
		68,
		53,
		47,
		58,
		73,
		90,
		-1,
		-1,
		140,
		-1,
		102,
		-1,
		-1,
		-1,
		-1,
		98,
		92,
		63,
		56,
		60,
		-1,
		48,
		50,
		47,
		59,
		64,
		68,
		59,
		41,
		55,
		58,
		71,
		85,
		89,
		163,
		-1,
		93,
		-1,
		-1,
		-1,
		116,
		130,
		102,
		79,
		52,
		47,
		40,
		34,
		39,
		50,
		59,
		70,
		35,
		39,
		54,
		59,
		63,
		80,
		84,
		-1,
		-1,
		91,
		87,
		122,
		124,
		103,
		129,
		-1,
		-1,
		49,
		42,
		38,
		30,
		43,
		46,
		31,
		33,
		51,
		64,
		58,
		68,
		83,
		78,
		-1,
		-1,
		-1,
		103,
		-1,
		105,
		-1,
		-1,
		93,
		122,
		69,
		51,
		47,
		33,
		25,
		19,
		21,
		26,
		45,
		40,
		49,
		54,
		58,
		81,
		70,
		109,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		82,
		74,
		69,
		75,
		77,
		68,
		84,
		81,
		-1,
		30,
		48,
		16,
		30,
		26,
		33,
		38,
		44,
		48,
		55,
		71,
		70,
		65,
		101,
		92,
		98,
		-1,
		-1,
		173,
		162,
		151,
		157,
		-1,
		75,
		71,
		61,
		51,
		54,
		-1,
		-1,
		48,
		45,
		24,
		8,
		14,
		19,
		22,
		60,
		36,
		44,
		48,
		52,
		58,
		63,
		68,
		74,
		89,
		104,
		-1,
		127,
		164,
		157,
		125,
		133,
		164,
		-1,
		65,
		57,
		68,
		43,
		45,
		-1,
		-1,
		21,
		12,
		12,
		0,
		3,
		43,
		42,
		55,
		58,
		63,
		51,
		50,
		68,
		72,
		81,
		88,
		78,
		91,
		95,
		-1,
		120,
		140,
		119,
		122,
		146,
		160,
		-1,
		62,
		-1,
		-1,
		74,
		46,
		30,
		20,
		17,
		59,
		14,
		9,
		26,
		28,
		52,
		43,
		68,
		59,
		59,
		62,
		77,
		82,
		74,
		88,
		88,
		89,
		-1,
		109,
		120,
		113,
		-1,
		-1,
		-1,
		-1,
		63,
		-1,
		-1,
		90,
		-1,
		57,
		-1,
		40,
		44,
		22,
		25,
		51,
		38,
		45,
		62,
		68,
		57,
		67,
		63,
		64,
		73,
		84,
		96,
		95,
		96,
		134,
		90,
		93,
		104,
		115,
		130,
		134,
		-1,
		74,
		113,
		128,
		-1,
		99,
		-1,
		-1,
		-1,
		54,
		35,
		27,
		43,
		50,
		50,
		46,
		50,
		62,
		69,
		79,
		81,
		73,
		77,
		90,
		101,
		104,
		130,
		121,
		134,
		79,
		79,
		100,
		109,
		130,
		89,
		80,
		107,
		133,
		124,
		119,
		106,
		-1,
		-1,
		77,
		45,
		-1,
		-1,
		57,
		67,
		50,
		52,
		56,
		70,
		82,
		90,
		80,
		78,
		72,
		104,
		-1,
		123,
		122,
		111,
		108,
		84,
		75,
		70,
		97,
		-1,
		-1,
		92,
		108,
		103,
		107,
		123,
		148,
		-1,
		109,
		-1,
		-1,
		98,
		-1,
		-1,
		109,
		72,
		61,
		52,
		58,
		64,
		75,
		97,
		86,
		87,
		77,
		87,
		100,
		107,
		104,
		92,
		90,
		113,
		78,
		66,
		-1,
		79,
		77,
		83,
		90,
		107,
		137,
		-1,
		-1,
		125,
		116,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		57,
		62,
		87,
		94,
		95,
		89,
		83,
		90,
		89,
		97,
		105,
		116,
		130,
		119,
		115,
		114,
		122,
		71,
		64,
		76,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		135,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		71,
		79,
		79,
		82,
		86,
		81,
		92,
		84,
		88,
		105,
		-1,
		150,
		-1,
		102,
		78,
		92,
		107,
		115,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		115,
		83,
		88,
		83,
		87,
		98,
		87,
		90,
		104,
		99,
		-1,
		-1,
		90,
		93,
		-1,
		-1,
		115,
		134,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		97,
		86,
		94,
		89,
		91,
		97,
		100,
		89,
		93,
		105,
		-1,
		-1,
		97,
		98,
		103,
		-1,
		124,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		110,
		73,
		94,
		104,
		109,
		107,
		98,
		95,
		102,
		100,
		96,
		107,
		-1,
		-1,
		-1,
		154,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		73,
		74,
		101,
		103,
		120,
		114,
		98,
		113,
		103,
		94,
		103,
		160,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		77,
		-1,
		105,
		95,
		137,
		118,
		111,
		98,
		105,
		107,
		100,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		84,
		127,
		123,
		116,
		118,
		108,
		-1,
		222,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		86,
		83,
		95,
		91,
		111,
		107,
		139,
		-1,
		229,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		98,
		96,
		101,
		106,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		107,
		103,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		218,
		207,
		218,
		226,
		199,
		206,
		-1,
		225,
		229,
		195,
		189,
		228,
		197,
		203,
		214,
		-1,
		-1,
		-1,
		218,
		217,
		185,
		183,
		192,
		197,
		204,
		-1,
		203,
		-1,
		239,
		218,
		229,
		234,
		178,
		175,
		195,
		214,
		196,
		188,
		254,
		208,
		179,
		173,
		191,
		181,
		190,
		182,
		-1,
		179,
		169,
		191,
		170,
		181,
		173,
		-1,
		-1,
		173,
		174,
		180,
		166,
		172,
		168,
		-1,
		178,
		162,
		-1,
		-1,
		163,
		164,
		148,
		151,
		159,
		157,
		170,
		162,
		157,
		-1,
		-1,
		154,
		150,
		157,
		144,
		140,
		157,
		170,
		152,
		166,
		165,
		-1,
		160,
		178,
		183,
		151,
		149,
		133,
		131,
		149,
		151,
		157,
		157,
		-1,
		169,
		170,
		165,
		173,
		173,
		149,
		136,
		136,
		146,
		139,
		158,
		146,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		152,
		169,
		161,
		151,
		166,
		159,
		139,
		136,
		134,
		131,
		147,
		145,
		155,
		-1,
		-1,
		260,
		229,
		260,
		218,
		199,
		-1,
		165,
		145,
		151,
		155,
		149,
		142,
		156,
		152,
		-1,
		125,
		124,
		152,
		138,
		149,
		220,
		-1,
		-1,
		218,
		210,
		195,
		198,
		175,
		171,
		160,
		159,
		151,
		137,
		133,
		139,
		142,
		142,
		148,
		119,
		129,
		133,
		131,
		156,
		-1,
		-1,
		191,
		-1,
		-1,
		217,
		200,
		-1,
		183,
		190,
		181,
		187,
		173,
		194,
		170,
		161,
		153,
		147,
		135,
		137,
		134,
		147,
		135,
		116,
		141,
		145,
		126,
		147,
		142,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		176,
		179,
		185,
		209,
		210,
		-1,
		182,
		170,
		171,
		156,
		153,
		140,
		128,
		141,
		126,
		133,
		132,
		120,
		118,
		148,
		123,
		145,
		142,
		161,
		166,
		160,
		169,
		-1,
		225,
		221,
		217,
		224,
		173,
		-1,
		-1,
		213,
		-1,
		218,
		219,
		194,
		167,
		170,
		157,
		148,
		135,
		124,
		135,
		124,
		121,
		129,
		112,
		127,
		118,
		117,
		135,
		145,
		153,
		157,
		163,
		-1,
		275,
		-1,
		217,
		201,
		203,
		175,
		196,
		-1,
		233,
		219,
		211,
		196,
		194,
		-1,
		166,
		163,
		153,
		131,
		116,
		133,
		125,
		123,
		125,
		107,
		121,
		112,
		130,
		137,
		135,
		139,
		159,
		171,
		235,
		225,
		-1,
		207,
		212,
		171,
		179,
		198,
		236,
		200,
		-1,
		195,
		-1,
		168,
		181,
		-1,
		137,
		133,
		115,
		116,
		111,
		126,
		118,
		103,
		100,
		118,
		121,
		128,
		132,
		148,
		-1,
		-1,
		220,
		224,
		213,
		164,
		183,
		207,
		244,
		193,
		182,
		181,
		-1,
		172,
		151,
		148,
		136,
		123,
		108,
		109,
		117,
		129,
		108,
		102,
		99,
		119,
		145,
		123,
		134,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		190,
		161,
		185,
		227,
		211,
		204,
		192,
		157,
		157,
		151,
		-1,
		147,
		126,
		117,
		106,
		104,
		117,
		109,
		117,
		97,
		95,
		114,
		126,
		117,
		125,
		-1,
		-1,
		-1,
		220,
		209,
		210,
		156,
		179,
		216,
		190,
		176,
		181,
		156,
		149,
		143,
		160,
		143,
		124,
		113,
		105,
		94,
		105,
		113,
		111,
		93,
		102,
		108,
		132,
		113,
		119,
		-1,
		-1,
		227,
		217,
		201,
		203,
		200,
		170,
		177,
		209,
		181,
		194,
		-1,
		148,
		-1,
		137,
		133,
		118,
		113,
		110,
		97,
		96,
		110,
		110,
		100,
		95,
		102,
		137,
		137,
		103,
		123,
		126,
		-1,
		-1,
		-1,
		220,
		215,
		190,
		167,
		151,
		187,
		-1,
		164,
		165,
		-1,
		142,
		136,
		133,
		120,
		116,
		101,
		105,
		107,
		110,
		98,
		104,
		105,
		87,
		111,
		-1,
		111,
		105,
		113,
		103,
		91,
		-1,
		-1,
		-1,
		213,
		192,
		185,
		205,
		146,
		198,
		-1,
		-1,
		149,
		142,
		-1,
		129,
		111,
		113,
		108,
		104,
		106,
		103,
		92,
		105,
		98,
		92,
		86,
		99,
		103,
		104,
		93,
		89,
		86,
		100,
		-1,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		166,
		-1,
		158,
		150,
		140,
		134,
		128,
		124,
		122,
		132,
		116,
		118,
		114,
		106,
		101,
		87,
		80,
		91,
		76,
		94,
		100,
		91,
		86,
		85,
		96,
		-1,
		233,
		219,
		190,
		-1,
		-1,
		179,
		-1,
		143,
		157,
		173,
		-1,
		166,
		145,
		160,
		138,
		134,
		125,
		123,
		124,
		94,
		99,
		101,
		89,
		92,
		81,
		84,
		76,
		98,
		95,
		79,
		81,
		90,
		-1,
		239,
		226,
		184,
		180,
		169,
		189,
		140,
		128,
		160,
		-1,
		-1,
		192,
		-1,
		136,
		148,
		139,
		137,
		113,
		88,
		95,
		113,
		86,
		81,
		86,
		75,
		75,
		70,
		89,
		75,
		73,
		88,
		104,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		155,
		142,
		136,
		-1,
		177,
		-1,
		170,
		158,
		145,
		127,
		167,
		-1,
		87,
		83,
		90,
		-1,
		106,
		-1,
		78,
		81,
		72,
		67,
		64,
		75,
		73,
		82,
		83,
		-1,
		189,
		174,
		167,
		157,
		171,
		142,
		-1,
		193,
		-1,
		-1,
		157,
		151,
		151,
		120,
		117,
		103,
		83,
		75,
		90,
		89,
		76,
		75,
		63,
		63,
		66,
		60,
		73,
		83,
		89,
		81,
		-1,
		-1,
		-1,
		194,
		180,
		183,
		144,
		159,
		-1,
		-1,
		218,
		174,
		160,
		-1,
		112,
		103,
		91,
		81,
		71,
		76,
		77,
		67,
		65,
		61,
		70,
		69,
		62,
		61,
		82,
		75,
		97,
		-1,
		-1,
		177,
		181,
		169,
		137,
		132,
		-1,
		-1,
		-1,
		164,
		165,
		131,
		110,
		92,
		-1,
		-1,
		75,
		68,
		62,
		65,
		53,
		73,
		80,
		68,
		55,
		70,
		80,
		88,
		87,
		-1,
		180,
		167,
		-1,
		-1,
		131,
		121,
		-1,
		-1,
		-1,
		-1,
		143,
		88,
		77,
		72,
		76,
		74,
		-1,
		48,
		59,
		52,
		71,
		78,
		70,
		55,
		49,
		60,
		75,
		92,
		-1,
		-1,
		145,
		-1,
		107,
		-1,
		-1,
		-1,
		-1,
		100,
		94,
		65,
		58,
		62,
		-1,
		50,
		52,
		49,
		61,
		66,
		70,
		61,
		43,
		57,
		60,
		73,
		87,
		91,
		168,
		-1,
		98,
		-1,
		-1,
		-1,
		118,
		133,
		104,
		81,
		54,
		49,
		42,
		36,
		41,
		52,
		61,
		72,
		37,
		41,
		56,
		61,
		65,
		82,
		86,
		-1,
		-1,
		96,
		92,
		127,
		126,
		108,
		131,
		-1,
		-1,
		54,
		47,
		40,
		32,
		45,
		48,
		33,
		35,
		53,
		66,
		60,
		70,
		85,
		80,
		-1,
		-1,
		-1,
		108,
		-1,
		110,
		-1,
		-1,
		98,
		127,
		74,
		56,
		52,
		38,
		27,
		21,
		23,
		28,
		47,
		42,
		51,
		56,
		60,
		83,
		72,
		111,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		87,
		79,
		74,
		80,
		82,
		73,
		89,
		86,
		-1,
		35,
		50,
		18,
		32,
		28,
		35,
		40,
		46,
		50,
		57,
		73,
		72,
		67,
		103,
		94,
		100,
		-1,
		-1,
		178,
		167,
		156,
		162,
		-1,
		80,
		76,
		66,
		56,
		59,
		-1,
		-1,
		53,
		50,
		29,
		10,
		16,
		21,
		24,
		62,
		38,
		46,
		50,
		54,
		60,
		65,
		70,
		76,
		91,
		106,
		-1,
		132,
		169,
		162,
		130,
		138,
		169,
		-1,
		70,
		62,
		73,
		48,
		50,
		-1,
		-1,
		26,
		17,
		17,
		5,
		0,
		45,
		44,
		57,
		60,
		65,
		53,
		52,
		70,
		74,
		83,
		90,
		80,
		93,
		97,
		-1,
		125,
		145,
		124,
		127,
		151,
		165,
		-1,
		67,
		-1,
		-1,
		79,
		51,
		35,
		25,
		22,
		64,
		18,
		13,
		28,
		30,
		54,
		45,
		70,
		61,
		61,
		64,
		79,
		84,
		76,
		90,
		90,
		91,
		-1,
		114,
		125,
		118,
		-1,
		-1,
		-1,
		-1,
		68,
		-1,
		-1,
		95,
		-1,
		62,
		-1,
		45,
		49,
		26,
		29,
		53,
		40,
		47,
		64,
		70,
		59,
		69,
		65,
		66,
		75,
		86,
		98,
		97,
		98,
		139,
		95,
		98,
		109,
		120,
		135,
		139,
		-1,
		79,
		118,
		133,
		-1,
		104,
		-1,
		-1,
		-1,
		59,
		39,
		31,
		47,
		52,
		52,
		48,
		52,
		64,
		71,
		81,
		83,
		75,
		79,
		92,
		103,
		106,
		135,
		126,
		139,
		84,
		84,
		105,
		114,
		135,
		94,
		85,
		112,
		138,
		129,
		124,
		111,
		-1,
		-1,
		82,
		49,
		-1,
		-1,
		59,
		69,
		52,
		54,
		58,
		72,
		84,
		92,
		82,
		80,
		74,
		106,
		-1,
		128,
		127,
		116,
		113,
		89,
		80,
		75,
		102,
		-1,
		-1,
		97,
		113,
		108,
		112,
		128,
		153,
		-1,
		114,
		-1,
		-1,
		103,
		-1,
		-1,
		111,
		74,
		63,
		54,
		60,
		66,
		77,
		99,
		88,
		89,
		79,
		89,
		102,
		112,
		109,
		97,
		95,
		118,
		83,
		71,
		-1,
		84,
		82,
		88,
		95,
		112,
		142,
		-1,
		-1,
		130,
		121,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		59,
		64,
		89,
		96,
		97,
		91,
		85,
		92,
		91,
		99,
		107,
		121,
		135,
		124,
		120,
		119,
		127,
		76,
		69,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		140,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		73,
		81,
		81,
		84,
		88,
		83,
		94,
		86,
		90,
		107,
		-1,
		155,
		-1,
		107,
		83,
		97,
		112,
		120,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		117,
		85,
		90,
		85,
		89,
		100,
		89,
		92,
		106,
		101,
		-1,
		-1,
		95,
		98,
		-1,
		-1,
		120,
		139,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		74,
		99,
		88,
		96,
		91,
		93,
		99,
		102,
		91,
		95,
		107,
		-1,
		-1,
		102,
		103,
		108,
		-1,
		129,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		112,
		75,
		96,
		106,
		111,
		109,
		100,
		97,
		104,
		102,
		98,
		109,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		76,
		103,
		105,
		122,
		116,
		100,
		115,
		105,
		96,
		105,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		107,
		97,
		139,
		120,
		113,
		100,
		107,
		109,
		102,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		87,
		87,
		78,
		86,
		129,
		125,
		118,
		120,
		110,
		-1,
		227,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		82,
		90,
		88,
		85,
		97,
		93,
		113,
		109,
		141,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		116,
		100,
		98,
		103,
		108,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		109,
		105,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		222,
		211,
		222,
		230,
		203,
		210,
		-1,
		229,
		233,
		199,
		193,
		232,
		201,
		207,
		218,
		-1,
		-1,
		-1,
		222,
		221,
		189,
		187,
		196,
		201,
		208,
		-1,
		207,
		-1,
		243,
		222,
		233,
		238,
		182,
		179,
		199,
		218,
		200,
		192,
		258,
		212,
		183,
		177,
		195,
		185,
		194,
		186,
		-1,
		183,
		173,
		195,
		174,
		185,
		177,
		-1,
		-1,
		177,
		178,
		184,
		170,
		176,
		172,
		-1,
		182,
		166,
		-1,
		-1,
		167,
		168,
		152,
		155,
		163,
		161,
		174,
		166,
		161,
		-1,
		-1,
		158,
		154,
		161,
		148,
		144,
		161,
		174,
		156,
		170,
		169,
		-1,
		162,
		180,
		187,
		155,
		153,
		137,
		135,
		153,
		155,
		161,
		161,
		-1,
		171,
		172,
		167,
		175,
		177,
		153,
		140,
		140,
		150,
		143,
		162,
		150,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		154,
		171,
		163,
		153,
		168,
		161,
		143,
		140,
		138,
		135,
		151,
		149,
		159,
		-1,
		-1,
		264,
		233,
		262,
		220,
		201,
		-1,
		167,
		147,
		153,
		157,
		151,
		144,
		158,
		154,
		-1,
		129,
		128,
		156,
		142,
		153,
		224,
		-1,
		-1,
		222,
		214,
		197,
		200,
		177,
		173,
		162,
		161,
		153,
		139,
		135,
		141,
		144,
		144,
		150,
		123,
		133,
		137,
		135,
		160,
		-1,
		-1,
		195,
		-1,
		-1,
		221,
		204,
		-1,
		187,
		194,
		183,
		189,
		175,
		196,
		172,
		163,
		155,
		149,
		137,
		139,
		136,
		149,
		137,
		120,
		145,
		149,
		130,
		151,
		146,
		-1,
		194,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		180,
		183,
		189,
		213,
		212,
		-1,
		184,
		172,
		173,
		158,
		155,
		142,
		130,
		143,
		128,
		135,
		134,
		124,
		122,
		152,
		127,
		149,
		146,
		165,
		170,
		164,
		173,
		-1,
		229,
		225,
		221,
		228,
		177,
		-1,
		-1,
		217,
		-1,
		220,
		221,
		196,
		169,
		172,
		159,
		150,
		137,
		126,
		137,
		126,
		123,
		131,
		116,
		131,
		122,
		121,
		139,
		149,
		157,
		161,
		167,
		-1,
		279,
		-1,
		221,
		205,
		207,
		179,
		200,
		-1,
		237,
		221,
		213,
		198,
		198,
		-1,
		168,
		165,
		155,
		133,
		118,
		135,
		127,
		125,
		129,
		111,
		125,
		116,
		134,
		141,
		139,
		143,
		163,
		175,
		239,
		229,
		-1,
		211,
		216,
		175,
		183,
		202,
		240,
		204,
		-1,
		199,
		-1,
		170,
		183,
		-1,
		139,
		135,
		117,
		118,
		113,
		128,
		122,
		107,
		104,
		122,
		125,
		132,
		136,
		152,
		-1,
		-1,
		224,
		228,
		217,
		168,
		187,
		211,
		248,
		197,
		186,
		185,
		-1,
		176,
		153,
		150,
		138,
		125,
		110,
		111,
		119,
		132,
		111,
		106,
		103,
		123,
		149,
		127,
		139,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		194,
		165,
		189,
		231,
		215,
		208,
		196,
		161,
		161,
		155,
		-1,
		149,
		128,
		119,
		108,
		106,
		119,
		116,
		121,
		101,
		99,
		118,
		130,
		121,
		134,
		-1,
		-1,
		-1,
		224,
		213,
		214,
		160,
		183,
		220,
		194,
		180,
		185,
		160,
		153,
		147,
		162,
		145,
		126,
		115,
		107,
		96,
		112,
		120,
		115,
		97,
		106,
		112,
		136,
		122,
		128,
		-1,
		-1,
		231,
		221,
		205,
		207,
		204,
		174,
		181,
		213,
		185,
		198,
		-1,
		152,
		-1,
		141,
		136,
		120,
		115,
		112,
		106,
		103,
		112,
		114,
		104,
		99,
		106,
		141,
		141,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		224,
		219,
		194,
		171,
		155,
		191,
		-1,
		168,
		169,
		-1,
		146,
		140,
		137,
		122,
		118,
		110,
		114,
		110,
		117,
		107,
		108,
		109,
		91,
		120,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		217,
		196,
		189,
		209,
		150,
		202,
		-1,
		-1,
		153,
		146,
		-1,
		133,
		115,
		122,
		117,
		113,
		115,
		112,
		101,
		114,
		107,
		96,
		95,
		108,
		112,
		113,
		102,
		98,
		95,
		109,
		-1,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		170,
		-1,
		162,
		154,
		144,
		138,
		132,
		128,
		126,
		141,
		125,
		127,
		123,
		115,
		110,
		96,
		89,
		99,
		85,
		103,
		109,
		100,
		95,
		94,
		105,
		-1,
		237,
		223,
		194,
		-1,
		-1,
		183,
		-1,
		147,
		161,
		177,
		-1,
		170,
		149,
		164,
		142,
		138,
		134,
		132,
		133,
		103,
		108,
		110,
		98,
		101,
		90,
		93,
		85,
		107,
		104,
		88,
		90,
		99,
		-1,
		243,
		230,
		188,
		184,
		173,
		193,
		144,
		132,
		164,
		-1,
		-1,
		201,
		-1,
		140,
		157,
		148,
		146,
		122,
		97,
		104,
		122,
		95,
		90,
		95,
		84,
		84,
		79,
		98,
		84,
		82,
		97,
		113,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		159,
		146,
		140,
		-1,
		181,
		-1,
		179,
		167,
		154,
		136,
		176,
		-1,
		96,
		92,
		99,
		-1,
		115,
		-1,
		87,
		90,
		81,
		76,
		73,
		84,
		82,
		91,
		92,
		-1,
		193,
		178,
		171,
		161,
		175,
		146,
		-1,
		201,
		-1,
		-1,
		166,
		160,
		160,
		129,
		126,
		112,
		92,
		84,
		99,
		98,
		85,
		84,
		72,
		72,
		75,
		69,
		82,
		92,
		98,
		90,
		-1,
		-1,
		-1,
		198,
		184,
		188,
		148,
		167,
		-1,
		-1,
		227,
		183,
		169,
		-1,
		121,
		112,
		100,
		90,
		80,
		85,
		86,
		76,
		74,
		70,
		79,
		78,
		71,
		70,
		91,
		84,
		106,
		-1,
		-1,
		181,
		186,
		174,
		160,
		171,
		-1,
		-1,
		-1,
		173,
		174,
		140,
		119,
		101,
		-1,
		-1,
		84,
		77,
		71,
		74,
		62,
		82,
		89,
		77,
		64,
		79,
		89,
		97,
		88,
		-1,
		184,
		171,
		-1,
		-1,
		170,
		160,
		-1,
		-1,
		-1,
		-1,
		152,
		97,
		86,
		81,
		85,
		83,
		-1,
		57,
		68,
		61,
		80,
		87,
		79,
		64,
		58,
		69,
		84,
		93,
		-1,
		-1,
		184,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		74,
		67,
		71,
		-1,
		59,
		61,
		58,
		70,
		75,
		79,
		70,
		52,
		65,
		69,
		73,
		87,
		91,
		207,
		-1,
		137,
		-1,
		-1,
		-1,
		127,
		142,
		113,
		90,
		63,
		58,
		51,
		45,
		50,
		61,
		70,
		81,
		46,
		50,
		62,
		61,
		65,
		82,
		86,
		-1,
		-1,
		135,
		131,
		153,
		135,
		139,
		140,
		-1,
		-1,
		67,
		58,
		49,
		41,
		54,
		57,
		42,
		44,
		62,
		66,
		60,
		70,
		85,
		80,
		-1,
		-1,
		-1,
		147,
		-1,
		149,
		-1,
		-1,
		137,
		138,
		85,
		67,
		63,
		61,
		50,
		44,
		32,
		37,
		47,
		42,
		51,
		56,
		60,
		83,
		72,
		111,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		126,
		118,
		113,
		119,
		121,
		112,
		100,
		97,
		-1,
		67,
		73,
		38,
		45,
		28,
		35,
		40,
		46,
		50,
		57,
		73,
		72,
		67,
		103,
		94,
		100,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		119,
		115,
		105,
		95,
		98,
		-1,
		-1,
		92,
		89,
		66,
		38,
		31,
		24,
		24,
		62,
		38,
		46,
		50,
		54,
		60,
		65,
		70,
		76,
		91,
		106,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		109,
		101,
		112,
		87,
		89,
		-1,
		-1,
		65,
		56,
		57,
		45,
		42,
		0,
		29,
		58,
		60,
		65,
		53,
		52,
		70,
		74,
		83,
		90,
		80,
		93,
		97,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		106,
		-1,
		-1,
		118,
		90,
		74,
		64,
		61,
		104,
		45,
		40,
		38,
		40,
		56,
		47,
		70,
		61,
		61,
		64,
		79,
		84,
		76,
		90,
		90,
		91,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		134,
		-1,
		101,
		-1,
		84,
		88,
		53,
		56,
		63,
		50,
		57,
		68,
		76,
		59,
		69,
		65,
		66,
		75,
		86,
		98,
		97,
		98,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		118,
		157,
		172,
		-1,
		143,
		-1,
		-1,
		-1,
		98,
		66,
		58,
		74,
		62,
		62,
		54,
		58,
		64,
		71,
		81,
		83,
		75,
		79,
		92,
		103,
		106,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		133,
		124,
		151,
		172,
		168,
		163,
		150,
		-1,
		-1,
		121,
		76,
		-1,
		-1,
		69,
		75,
		58,
		60,
		64,
		74,
		89,
		92,
		82,
		80,
		74,
		106,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		152,
		142,
		146,
		162,
		187,
		-1,
		142,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		80,
		69,
		60,
		66,
		72,
		83,
		100,
		88,
		89,
		79,
		89,
		102,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		118,
		116,
		122,
		129,
		146,
		176,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		65,
		70,
		95,
		102,
		97,
		91,
		85,
		92,
		91,
		99,
		107,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		79,
		87,
		87,
		90,
		88,
		83,
		94,
		86,
		90,
		107,
		-1,
		189,
		-1,
		141,
		117,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		123,
		91,
		96,
		91,
		89,
		100,
		89,
		92,
		106,
		101,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		154,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		105,
		94,
		102,
		97,
		93,
		99,
		102,
		91,
		95,
		107,
		-1,
		-1,
		136,
		137,
		142,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		118,
		81,
		98,
		112,
		117,
		115,
		106,
		97,
		104,
		102,
		98,
		109,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		78,
		103,
		111,
		128,
		122,
		100,
		115,
		105,
		96,
		105,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		107,
		97,
		145,
		120,
		115,
		102,
		109,
		109,
		102,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		87,
		87,
		78,
		86,
		135,
		131,
		122,
		122,
		110,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		82,
		90,
		88,
		85,
		97,
		93,
		113,
		109,
		141,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		116,
		100,
		98,
		103,
		108,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		109,
		105,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		166,
		184,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		175,
		176,
		171,
		179,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		158,
		175,
		167,
		157,
		172,
		165,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		268,
		237,
		266,
		224,
		205,
		-1,
		171,
		151,
		157,
		161,
		155,
		148,
		162,
		158,
		-1,
		133,
		132,
		160,
		146,
		157,
		228,
		-1,
		-1,
		226,
		218,
		201,
		204,
		181,
		177,
		166,
		165,
		157,
		143,
		139,
		145,
		148,
		148,
		154,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		199,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		187,
		193,
		179,
		200,
		176,
		167,
		159,
		153,
		141,
		143,
		140,
		153,
		141,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		216,
		-1,
		188,
		176,
		177,
		162,
		159,
		146,
		134,
		147,
		132,
		139,
		138,
		128,
		126,
		156,
		131,
		153,
		150,
		169,
		174,
		168,
		177,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		224,
		225,
		200,
		173,
		176,
		163,
		154,
		141,
		130,
		141,
		130,
		127,
		135,
		120,
		135,
		126,
		125,
		143,
		153,
		161,
		165,
		171,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		225,
		217,
		202,
		202,
		-1,
		172,
		169,
		159,
		137,
		122,
		139,
		131,
		129,
		133,
		115,
		129,
		120,
		138,
		145,
		143,
		147,
		167,
		179,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		244,
		208,
		-1,
		203,
		-1,
		174,
		187,
		-1,
		143,
		139,
		121,
		122,
		117,
		132,
		126,
		111,
		108,
		126,
		129,
		136,
		140,
		156,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		201,
		190,
		189,
		-1,
		180,
		157,
		154,
		142,
		129,
		114,
		115,
		123,
		136,
		115,
		110,
		107,
		127,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		153,
		132,
		123,
		112,
		110,
		123,
		120,
		125,
		105,
		103,
		122,
		134,
		125,
		138,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		164,
		187,
		224,
		198,
		184,
		189,
		164,
		157,
		151,
		166,
		149,
		130,
		119,
		111,
		100,
		116,
		124,
		119,
		101,
		110,
		116,
		140,
		126,
		132,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		178,
		185,
		217,
		189,
		202,
		-1,
		156,
		-1,
		145,
		140,
		124,
		119,
		116,
		110,
		107,
		116,
		118,
		108,
		103,
		110,
		145,
		145,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		228,
		223,
		198,
		175,
		159,
		195,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		126,
		122,
		114,
		118,
		114,
		121,
		111,
		112,
		113,
		95,
		124,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		221,
		200,
		193,
		213,
		154,
		206,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		126,
		121,
		117,
		119,
		116,
		105,
		118,
		111,
		100,
		99,
		112,
		116,
		117,
		106,
		102,
		99,
		113,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		174,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		145,
		129,
		131,
		127,
		119,
		114,
		100,
		93,
		103,
		89,
		107,
		113,
		104,
		99,
		98,
		109,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		187,
		-1,
		151,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		138,
		136,
		137,
		107,
		112,
		114,
		102,
		105,
		94,
		97,
		89,
		111,
		108,
		92,
		94,
		103,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		148,
		136,
		168,
		-1,
		-1,
		205,
		-1,
		144,
		161,
		152,
		150,
		126,
		101,
		108,
		126,
		99,
		94,
		99,
		88,
		88,
		83,
		102,
		88,
		86,
		101,
		117,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		183,
		171,
		158,
		140,
		180,
		-1,
		100,
		96,
		103,
		-1,
		119,
		-1,
		91,
		94,
		85,
		80,
		77,
		88,
		86,
		95,
		96,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		205,
		-1,
		-1,
		170,
		164,
		164,
		133,
		130,
		116,
		96,
		88,
		103,
		102,
		89,
		88,
		76,
		76,
		79,
		73,
		86,
		96,
		102,
		94,
		-1,
		-1,
		-1,
		202,
		188,
		192,
		152,
		171,
		-1,
		-1,
		231,
		187,
		173,
		-1,
		125,
		116,
		104,
		94,
		84,
		89,
		90,
		80,
		78,
		74,
		83,
		82,
		75,
		74,
		95,
		88,
		110,
		-1,
		-1,
		185,
		190,
		178,
		164,
		175,
		-1,
		-1,
		-1,
		177,
		178,
		144,
		123,
		105,
		-1,
		-1,
		88,
		81,
		75,
		78,
		66,
		86,
		93,
		81,
		68,
		83,
		93,
		101,
		92,
		-1,
		188,
		175,
		-1,
		-1,
		174,
		164,
		-1,
		-1,
		-1,
		-1,
		156,
		101,
		90,
		85,
		89,
		87,
		-1,
		61,
		72,
		65,
		84,
		91,
		83,
		68,
		62,
		73,
		88,
		97,
		-1,
		-1,
		188,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		113,
		107,
		78,
		71,
		75,
		-1,
		63,
		65,
		62,
		74,
		79,
		83,
		74,
		56,
		69,
		73,
		77,
		91,
		95,
		211,
		-1,
		141,
		-1,
		-1,
		-1,
		131,
		146,
		117,
		94,
		67,
		62,
		55,
		49,
		54,
		65,
		74,
		85,
		50,
		54,
		66,
		65,
		69,
		86,
		90,
		-1,
		-1,
		139,
		135,
		157,
		139,
		143,
		144,
		-1,
		-1,
		71,
		62,
		53,
		45,
		58,
		61,
		46,
		48,
		66,
		70,
		64,
		74,
		89,
		84,
		-1,
		-1,
		-1,
		151,
		-1,
		153,
		-1,
		-1,
		141,
		142,
		89,
		71,
		67,
		65,
		54,
		48,
		36,
		41,
		51,
		46,
		55,
		60,
		64,
		87,
		76,
		115,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		130,
		122,
		117,
		123,
		125,
		116,
		104,
		101,
		-1,
		71,
		77,
		42,
		49,
		32,
		39,
		44,
		50,
		54,
		61,
		77,
		76,
		71,
		107,
		98,
		104,
		-1,
		-1,
		216,
		205,
		194,
		200,
		-1,
		123,
		119,
		109,
		99,
		102,
		-1,
		-1,
		96,
		93,
		73,
		42,
		35,
		28,
		28,
		66,
		42,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		95,
		110,
		-1,
		170,
		207,
		200,
		168,
		176,
		207,
		-1,
		113,
		105,
		116,
		91,
		93,
		-1,
		-1,
		69,
		60,
		61,
		49,
		46,
		33,
		0,
		62,
		64,
		69,
		57,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		163,
		183,
		162,
		165,
		189,
		203,
		-1,
		110,
		-1,
		-1,
		122,
		94,
		78,
		68,
		65,
		108,
		63,
		58,
		60,
		62,
		60,
		51,
		74,
		65,
		65,
		68,
		83,
		88,
		80,
		94,
		94,
		95,
		-1,
		152,
		163,
		156,
		-1,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		138,
		-1,
		105,
		-1,
		88,
		92,
		71,
		74,
		85,
		72,
		64,
		72,
		80,
		63,
		73,
		69,
		70,
		79,
		90,
		102,
		101,
		102,
		177,
		133,
		136,
		147,
		158,
		173,
		177,
		-1,
		122,
		161,
		176,
		-1,
		147,
		-1,
		-1,
		-1,
		102,
		84,
		76,
		92,
		84,
		84,
		58,
		62,
		68,
		75,
		85,
		87,
		79,
		83,
		96,
		107,
		110,
		173,
		164,
		177,
		122,
		122,
		143,
		152,
		173,
		137,
		128,
		155,
		176,
		172,
		167,
		154,
		-1,
		-1,
		125,
		94,
		-1,
		-1,
		91,
		79,
		62,
		64,
		68,
		78,
		93,
		96,
		86,
		84,
		78,
		110,
		-1,
		166,
		165,
		154,
		151,
		127,
		118,
		113,
		140,
		-1,
		-1,
		135,
		156,
		146,
		150,
		166,
		191,
		-1,
		146,
		-1,
		-1,
		136,
		-1,
		-1,
		121,
		84,
		73,
		64,
		70,
		76,
		87,
		104,
		92,
		93,
		83,
		93,
		106,
		150,
		147,
		135,
		133,
		156,
		121,
		109,
		-1,
		122,
		120,
		126,
		133,
		150,
		180,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		69,
		74,
		99,
		106,
		101,
		95,
		89,
		96,
		95,
		103,
		111,
		159,
		173,
		162,
		158,
		157,
		165,
		114,
		107,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		83,
		91,
		91,
		94,
		92,
		87,
		98,
		90,
		94,
		111,
		-1,
		193,
		-1,
		145,
		121,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		127,
		95,
		100,
		95,
		93,
		104,
		93,
		96,
		110,
		105,
		-1,
		-1,
		133,
		136,
		-1,
		-1,
		158,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		109,
		98,
		106,
		101,
		97,
		103,
		106,
		95,
		99,
		111,
		-1,
		-1,
		140,
		141,
		146,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		122,
		85,
		102,
		116,
		121,
		119,
		110,
		101,
		108,
		106,
		102,
		113,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		82,
		107,
		115,
		132,
		126,
		104,
		119,
		109,
		100,
		109,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		111,
		101,
		149,
		124,
		119,
		106,
		113,
		113,
		106,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		91,
		82,
		90,
		139,
		135,
		126,
		126,
		114,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		94,
		92,
		89,
		101,
		97,
		117,
		113,
		145,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		120,
		104,
		102,
		107,
		112,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		113,
		109,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		204,
		193,
		204,
		212,
		185,
		192,
		-1,
		211,
		215,
		181,
		175,
		214,
		183,
		189,
		200,
		-1,
		-1,
		-1,
		204,
		203,
		171,
		169,
		178,
		183,
		190,
		-1,
		189,
		-1,
		225,
		204,
		215,
		220,
		164,
		161,
		181,
		200,
		182,
		174,
		240,
		194,
		165,
		159,
		177,
		167,
		176,
		168,
		-1,
		165,
		155,
		177,
		156,
		167,
		159,
		-1,
		-1,
		159,
		160,
		166,
		152,
		158,
		154,
		-1,
		164,
		148,
		-1,
		-1,
		149,
		150,
		134,
		137,
		145,
		143,
		156,
		148,
		143,
		-1,
		-1,
		140,
		136,
		143,
		130,
		126,
		143,
		156,
		138,
		152,
		151,
		-1,
		144,
		162,
		169,
		137,
		135,
		119,
		117,
		135,
		137,
		143,
		143,
		-1,
		153,
		154,
		149,
		157,
		159,
		135,
		122,
		122,
		132,
		125,
		144,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		153,
		136,
		153,
		145,
		135,
		150,
		143,
		125,
		122,
		120,
		117,
		133,
		131,
		141,
		-1,
		-1,
		246,
		215,
		244,
		202,
		183,
		-1,
		149,
		129,
		135,
		139,
		133,
		126,
		140,
		136,
		-1,
		111,
		110,
		138,
		124,
		135,
		206,
		-1,
		-1,
		204,
		196,
		179,
		182,
		159,
		155,
		144,
		143,
		135,
		121,
		117,
		123,
		126,
		126,
		132,
		105,
		115,
		119,
		117,
		142,
		-1,
		-1,
		177,
		-1,
		-1,
		203,
		186,
		-1,
		169,
		176,
		165,
		171,
		157,
		178,
		154,
		145,
		137,
		131,
		119,
		121,
		118,
		131,
		119,
		102,
		127,
		131,
		112,
		133,
		128,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		162,
		165,
		171,
		195,
		194,
		-1,
		166,
		154,
		155,
		140,
		137,
		124,
		112,
		125,
		110,
		117,
		116,
		106,
		104,
		134,
		109,
		131,
		128,
		147,
		152,
		146,
		155,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		199,
		-1,
		202,
		203,
		178,
		151,
		154,
		141,
		132,
		119,
		108,
		119,
		108,
		105,
		113,
		98,
		113,
		104,
		103,
		121,
		131,
		139,
		143,
		149,
		-1,
		261,
		-1,
		203,
		187,
		189,
		161,
		182,
		-1,
		219,
		203,
		195,
		180,
		180,
		-1,
		150,
		147,
		137,
		115,
		100,
		117,
		109,
		107,
		111,
		93,
		107,
		98,
		116,
		123,
		121,
		125,
		145,
		157,
		221,
		211,
		-1,
		193,
		198,
		157,
		165,
		184,
		222,
		186,
		-1,
		181,
		-1,
		152,
		165,
		-1,
		121,
		117,
		99,
		100,
		95,
		110,
		104,
		89,
		86,
		104,
		107,
		114,
		118,
		134,
		-1,
		-1,
		206,
		210,
		199,
		150,
		169,
		193,
		230,
		179,
		168,
		167,
		-1,
		158,
		135,
		132,
		120,
		107,
		92,
		93,
		101,
		114,
		93,
		88,
		85,
		105,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		176,
		147,
		171,
		213,
		197,
		190,
		178,
		143,
		143,
		137,
		-1,
		131,
		110,
		101,
		90,
		88,
		101,
		98,
		103,
		83,
		81,
		100,
		112,
		103,
		120,
		-1,
		-1,
		-1,
		206,
		195,
		196,
		142,
		165,
		202,
		176,
		162,
		167,
		142,
		135,
		129,
		144,
		127,
		108,
		97,
		89,
		78,
		94,
		102,
		97,
		79,
		88,
		94,
		118,
		108,
		114,
		-1,
		-1,
		213,
		203,
		187,
		189,
		186,
		156,
		163,
		195,
		167,
		180,
		-1,
		134,
		-1,
		123,
		118,
		102,
		97,
		94,
		91,
		85,
		94,
		96,
		86,
		81,
		88,
		123,
		123,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		206,
		201,
		176,
		153,
		137,
		173,
		-1,
		150,
		151,
		-1,
		128,
		122,
		119,
		104,
		100,
		95,
		99,
		92,
		99,
		92,
		90,
		91,
		73,
		105,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		199,
		178,
		171,
		191,
		132,
		184,
		-1,
		-1,
		135,
		128,
		-1,
		115,
		97,
		104,
		102,
		96,
		100,
		97,
		86,
		99,
		92,
		78,
		80,
		93,
		97,
		101,
		88,
		84,
		81,
		95,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		152,
		-1,
		144,
		136,
		126,
		120,
		114,
		110,
		108,
		124,
		108,
		111,
		109,
		100,
		108,
		81,
		74,
		81,
		70,
		88,
		96,
		88,
		82,
		81,
		91,
		-1,
		219,
		205,
		176,
		-1,
		-1,
		165,
		-1,
		129,
		143,
		159,
		-1,
		152,
		131,
		146,
		124,
		120,
		116,
		131,
		132,
		110,
		109,
		107,
		98,
		86,
		75,
		78,
		70,
		92,
		92,
		76,
		77,
		81,
		-1,
		225,
		212,
		170,
		166,
		155,
		175,
		126,
		114,
		146,
		-1,
		-1,
		188,
		-1,
		122,
		139,
		130,
		128,
		121,
		104,
		111,
		118,
		95,
		90,
		80,
		69,
		69,
		64,
		86,
		72,
		70,
		79,
		95,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		141,
		128,
		122,
		-1,
		163,
		-1,
		166,
		156,
		140,
		125,
		158,
		-1,
		103,
		99,
		106,
		-1,
		115,
		-1,
		88,
		85,
		76,
		61,
		58,
		69,
		67,
		78,
		74,
		-1,
		175,
		160,
		153,
		143,
		157,
		128,
		-1,
		183,
		-1,
		-1,
		153,
		147,
		147,
		131,
		133,
		119,
		99,
		91,
		106,
		105,
		92,
		91,
		74,
		67,
		64,
		57,
		70,
		80,
		85,
		72,
		-1,
		-1,
		-1,
		180,
		166,
		170,
		130,
		149,
		-1,
		-1,
		215,
		170,
		156,
		-1,
		128,
		119,
		107,
		97,
		87,
		92,
		93,
		83,
		81,
		72,
		74,
		68,
		59,
		58,
		74,
		66,
		88,
		-1,
		-1,
		163,
		168,
		156,
		142,
		161,
		-1,
		-1,
		-1,
		162,
		178,
		147,
		126,
		108,
		-1,
		-1,
		91,
		84,
		78,
		81,
		69,
		88,
		83,
		67,
		52,
		67,
		71,
		79,
		70,
		-1,
		166,
		153,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		-1,
		-1,
		159,
		104,
		93,
		88,
		92,
		90,
		-1,
		64,
		75,
		68,
		87,
		94,
		69,
		54,
		48,
		54,
		66,
		75,
		-1,
		-1,
		178,
		-1,
		153,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		81,
		74,
		78,
		-1,
		66,
		68,
		65,
		77,
		72,
		69,
		60,
		51,
		47,
		51,
		55,
		69,
		73,
		201,
		-1,
		144,
		-1,
		-1,
		-1,
		134,
		149,
		120,
		97,
		70,
		65,
		58,
		52,
		57,
		68,
		77,
		88,
		53,
		54,
		44,
		43,
		47,
		64,
		68,
		-1,
		-1,
		142,
		138,
		160,
		142,
		146,
		147,
		-1,
		-1,
		74,
		65,
		56,
		48,
		61,
		64,
		49,
		51,
		51,
		48,
		42,
		52,
		67,
		62,
		-1,
		-1,
		-1,
		154,
		-1,
		156,
		-1,
		-1,
		144,
		145,
		92,
		74,
		70,
		68,
		57,
		51,
		39,
		44,
		54,
		48,
		45,
		38,
		42,
		65,
		54,
		93,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		133,
		125,
		120,
		126,
		128,
		119,
		107,
		104,
		-1,
		74,
		80,
		45,
		52,
		35,
		42,
		47,
		44,
		32,
		39,
		55,
		54,
		49,
		85,
		76,
		82,
		-1,
		-1,
		219,
		208,
		197,
		203,
		-1,
		126,
		122,
		112,
		102,
		105,
		-1,
		-1,
		99,
		96,
		76,
		45,
		43,
		36,
		31,
		35,
		17,
		28,
		32,
		36,
		42,
		47,
		52,
		58,
		73,
		88,
		-1,
		173,
		210,
		203,
		171,
		179,
		210,
		-1,
		116,
		108,
		119,
		94,
		96,
		-1,
		-1,
		72,
		63,
		64,
		52,
		49,
		55,
		54,
		0,
		33,
		44,
		35,
		34,
		52,
		56,
		65,
		72,
		62,
		75,
		79,
		-1,
		166,
		186,
		165,
		168,
		192,
		206,
		-1,
		113,
		-1,
		-1,
		125,
		97,
		81,
		71,
		68,
		111,
		59,
		54,
		31,
		29,
		10,
		11,
		51,
		42,
		43,
		46,
		61,
		66,
		58,
		72,
		72,
		73,
		-1,
		155,
		166,
		159,
		-1,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		141,
		-1,
		108,
		-1,
		91,
		95,
		67,
		70,
		45,
		32,
		24,
		32,
		40,
		40,
		45,
		47,
		48,
		57,
		68,
		80,
		79,
		80,
		180,
		136,
		139,
		150,
		161,
		176,
		180,
		-1,
		125,
		164,
		154,
		-1,
		138,
		-1,
		-1,
		-1,
		105,
		80,
		72,
		65,
		44,
		44,
		18,
		22,
		35,
		42,
		52,
		65,
		57,
		61,
		74,
		85,
		88,
		176,
		167,
		180,
		125,
		125,
		146,
		155,
		176,
		140,
		131,
		158,
		161,
		150,
		145,
		132,
		-1,
		-1,
		116,
		90,
		-1,
		-1,
		51,
		39,
		22,
		24,
		28,
		42,
		54,
		67,
		64,
		62,
		56,
		88,
		-1,
		169,
		168,
		157,
		154,
		130,
		121,
		116,
		143,
		-1,
		-1,
		138,
		159,
		149,
		153,
		169,
		194,
		-1,
		121,
		-1,
		-1,
		96,
		-1,
		-1,
		81,
		44,
		33,
		24,
		30,
		36,
		47,
		69,
		70,
		71,
		61,
		71,
		84,
		153,
		150,
		138,
		136,
		159,
		124,
		112,
		-1,
		125,
		123,
		129,
		136,
		153,
		183,
		-1,
		-1,
		137,
		117,
		-1,
		-1,
		79,
		77,
		66,
		-1,
		56,
		29,
		34,
		59,
		66,
		68,
		73,
		67,
		74,
		73,
		81,
		89,
		162,
		176,
		165,
		161,
		160,
		168,
		117,
		110,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		127,
		123,
		-1,
		-1,
		74,
		67,
		55,
		43,
		33,
		43,
		51,
		51,
		54,
		59,
		65,
		76,
		68,
		72,
		89,
		-1,
		196,
		-1,
		148,
		124,
		138,
		153,
		161,
		-1,
		-1,
		-1,
		144,
		130,
		123,
		111,
		109,
		-1,
		108,
		92,
		73,
		-1,
		43,
		56,
		87,
		55,
		60,
		55,
		71,
		82,
		71,
		74,
		88,
		83,
		-1,
		-1,
		136,
		139,
		-1,
		-1,
		134,
		136,
		-1,
		135,
		124,
		109,
		101,
		-1,
		-1,
		80,
		76,
		-1,
		-1,
		44,
		69,
		58,
		66,
		61,
		73,
		81,
		81,
		73,
		77,
		89,
		-1,
		-1,
		143,
		144,
		141,
		-1,
		119,
		-1,
		137,
		-1,
		104,
		110,
		98,
		-1,
		-1,
		-1,
		82,
		45,
		66,
		76,
		81,
		79,
		70,
		69,
		76,
		84,
		80,
		91,
		-1,
		-1,
		-1,
		137,
		111,
		144,
		135,
		118,
		98,
		90,
		109,
		-1,
		79,
		-1,
		49,
		46,
		82,
		75,
		92,
		86,
		72,
		87,
		83,
		78,
		87,
		143,
		-1,
		113,
		146,
		110,
		104,
		80,
		84,
		100,
		-1,
		76,
		57,
		-1,
		86,
		76,
		109,
		95,
		83,
		70,
		77,
		91,
		84,
		-1,
		-1,
		-1,
		115,
		114,
		106,
		100,
		100,
		85,
		76,
		-1,
		88,
		70,
		49,
		66,
		66,
		57,
		65,
		99,
		95,
		88,
		90,
		82,
		-1,
		216,
		-1,
		-1,
		138,
		-1,
		-1,
		-1,
		109,
		104,
		77,
		65,
		71,
		67,
		53,
		59,
		61,
		69,
		67,
		64,
		76,
		72,
		92,
		83,
		119,
		-1,
		211,
		-1,
		145,
		-1,
		-1,
		127,
		107,
		99,
		88,
		77,
		75,
		66,
		57,
		79,
		95,
		79,
		77,
		82,
		87,
		-1,
		200,
		199,
		-1,
		146,
		138,
		124,
		-1,
		117,
		-1,
		123,
		84,
		-1,
		86,
		66,
		-1,
		88,
		84,
		-1,
		-1,
		187,
		162,
		-1,
		-1,
		-1,
		147,
		127,
		118,
		102,
		-1,
		77,
		77,
		-1,
		-1,
		-1,
		172,
		171,
		-1,
		140,
		143,
		-1,
		133,
		124,
		132,
		79,
		83,
		-1,
		-1,
		-1,
		181,
		162,
		156,
		155,
		153,
		148,
		145,
		131,
		115,
		93,
		82,
		103,
		-1,
		-1,
		-1,
		153,
		145,
		138,
		-1,
		-1,
		140,
		123,
		104,
		102,
		-1,
		-1,
		-1,
		175,
		156,
		-1,
		-1,
		130,
		-1,
		-1,
		136,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		164,
		-1,
		-1,
		-1,
		126,
		122,
		123,
		-1,
		-1,
		-1,
		-1,
		186,
		187,
		210,
		174,
		-1,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		189,
		187,
		-1,
		-1,
		-1,
		146,
		130,
		-1,
		116,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		151,
		-1,
		151,
		126,
		133,
		-1,
		-1,
		-1,
		-1,
		164,
		156,
		164,
		-1,
		136,
		138,
		-1,
		186,
		-1,
		-1,
		179,
		170,
		-1,
		-1,
		141,
		148,
		170,
		173,
		209,
		-1,
		160
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		197,
		201,
		167,
		161,
		200,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		190,
		189,
		157,
		155,
		164,
		169,
		176,
		-1,
		175,
		-1,
		211,
		190,
		201,
		206,
		150,
		147,
		167,
		186,
		168,
		160,
		226,
		180,
		151,
		145,
		163,
		153,
		162,
		154,
		-1,
		151,
		141,
		163,
		142,
		153,
		145,
		-1,
		-1,
		145,
		146,
		152,
		138,
		144,
		140,
		-1,
		150,
		134,
		-1,
		-1,
		135,
		136,
		120,
		123,
		131,
		129,
		142,
		134,
		129,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		124,
		138,
		137,
		-1,
		130,
		148,
		155,
		123,
		121,
		105,
		103,
		121,
		123,
		129,
		129,
		-1,
		139,
		140,
		135,
		143,
		145,
		121,
		108,
		108,
		118,
		111,
		130,
		118,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		122,
		139,
		131,
		121,
		136,
		129,
		111,
		108,
		106,
		103,
		119,
		117,
		127,
		-1,
		-1,
		232,
		201,
		230,
		188,
		169,
		-1,
		135,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		97,
		96,
		124,
		110,
		121,
		192,
		-1,
		-1,
		190,
		182,
		165,
		168,
		145,
		141,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		91,
		101,
		105,
		103,
		128,
		-1,
		-1,
		163,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		151,
		157,
		143,
		164,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		88,
		113,
		117,
		98,
		119,
		114,
		-1,
		162,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		180,
		-1,
		152,
		140,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		92,
		90,
		120,
		95,
		117,
		114,
		133,
		138,
		132,
		141,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		188,
		189,
		164,
		137,
		140,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		84,
		99,
		90,
		89,
		107,
		117,
		125,
		129,
		135,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		189,
		181,
		166,
		166,
		-1,
		136,
		133,
		123,
		101,
		86,
		103,
		95,
		93,
		97,
		79,
		93,
		84,
		102,
		109,
		107,
		111,
		131,
		143,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		138,
		151,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		90,
		75,
		72,
		90,
		93,
		100,
		104,
		120,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		121,
		118,
		106,
		93,
		78,
		79,
		87,
		100,
		79,
		74,
		71,
		91,
		117,
		95,
		107,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		117,
		96,
		87,
		76,
		74,
		87,
		84,
		89,
		69,
		67,
		86,
		98,
		89,
		106,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		130,
		113,
		94,
		83,
		75,
		64,
		80,
		88,
		83,
		65,
		74,
		80,
		104,
		94,
		100,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		104,
		88,
		83,
		80,
		77,
		71,
		80,
		82,
		72,
		67,
		74,
		109,
		109,
		84,
		104,
		107,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		90,
		86,
		81,
		85,
		78,
		85,
		78,
		76,
		77,
		59,
		91,
		-1,
		92,
		86,
		94,
		84,
		72,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		90,
		88,
		82,
		86,
		83,
		72,
		85,
		78,
		64,
		66,
		79,
		83,
		87,
		74,
		70,
		67,
		81,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		110,
		94,
		97,
		95,
		86,
		94,
		67,
		60,
		67,
		56,
		74,
		82,
		74,
		68,
		67,
		77,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		102,
		117,
		118,
		96,
		95,
		93,
		84,
		72,
		61,
		64,
		56,
		78,
		78,
		62,
		63,
		67,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		116,
		114,
		107,
		98,
		104,
		104,
		81,
		76,
		66,
		55,
		55,
		50,
		72,
		58,
		56,
		65,
		81,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		109,
		99,
		104,
		-1,
		101,
		-1,
		74,
		71,
		62,
		47,
		44,
		55,
		53,
		64,
		60,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		125,
		105,
		97,
		104,
		96,
		88,
		82,
		60,
		53,
		50,
		43,
		56,
		66,
		71,
		58,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		125,
		113,
		103,
		93,
		98,
		99,
		79,
		72,
		58,
		60,
		54,
		45,
		44,
		60,
		52,
		74,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		153,
		127,
		114,
		-1,
		-1,
		97,
		90,
		84,
		75,
		62,
		74,
		69,
		53,
		38,
		53,
		57,
		65,
		56,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		165,
		110,
		99,
		94,
		98,
		96,
		-1,
		70,
		81,
		66,
		78,
		85,
		55,
		40,
		34,
		40,
		52,
		61,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		122,
		116,
		87,
		80,
		84,
		-1,
		72,
		74,
		68,
		83,
		58,
		55,
		46,
		37,
		33,
		37,
		41,
		55,
		59,
		187,
		-1,
		150,
		-1,
		-1,
		-1,
		140,
		155,
		126,
		103,
		76,
		71,
		64,
		58,
		63,
		74,
		66,
		77,
		44,
		40,
		30,
		29,
		33,
		50,
		54,
		-1,
		-1,
		148,
		144,
		166,
		148,
		152,
		153,
		-1,
		-1,
		80,
		71,
		62,
		54,
		67,
		70,
		50,
		47,
		41,
		34,
		28,
		38,
		53,
		48,
		-1,
		-1,
		-1,
		160,
		-1,
		162,
		-1,
		-1,
		150,
		151,
		98,
		80,
		76,
		74,
		63,
		57,
		45,
		50,
		51,
		42,
		36,
		24,
		28,
		51,
		40,
		79,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		139,
		131,
		126,
		132,
		134,
		125,
		113,
		110,
		-1,
		80,
		86,
		51,
		58,
		41,
		48,
		46,
		38,
		18,
		25,
		41,
		40,
		35,
		71,
		62,
		68,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		132,
		128,
		118,
		108,
		111,
		-1,
		-1,
		105,
		102,
		82,
		51,
		49,
		42,
		37,
		44,
		27,
		14,
		18,
		22,
		28,
		33,
		38,
		44,
		59,
		74,
		-1,
		179,
		216,
		209,
		177,
		185,
		216,
		-1,
		122,
		114,
		125,
		100,
		102,
		-1,
		-1,
		78,
		69,
		70,
		58,
		55,
		57,
		52,
		35,
		0,
		22,
		16,
		20,
		38,
		42,
		51,
		55,
		48,
		61,
		65,
		-1,
		172,
		192,
		171,
		174,
		198,
		212,
		-1,
		119,
		-1,
		-1,
		131,
		103,
		87,
		77,
		74,
		117,
		72,
		67,
		45,
		43,
		32,
		26,
		30,
		24,
		29,
		32,
		42,
		47,
		39,
		58,
		58,
		59,
		-1,
		161,
		172,
		165,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		147,
		-1,
		114,
		-1,
		97,
		101,
		80,
		83,
		59,
		46,
		32,
		8,
		24,
		22,
		37,
		33,
		29,
		38,
		49,
		61,
		65,
		66,
		186,
		142,
		145,
		156,
		167,
		182,
		186,
		-1,
		131,
		170,
		161,
		-1,
		145,
		-1,
		-1,
		-1,
		111,
		93,
		85,
		79,
		58,
		58,
		24,
		20,
		27,
		34,
		44,
		46,
		38,
		42,
		55,
		66,
		74,
		182,
		173,
		186,
		131,
		131,
		152,
		161,
		182,
		146,
		137,
		164,
		168,
		157,
		152,
		139,
		-1,
		-1,
		122,
		103,
		-1,
		-1,
		65,
		45,
		28,
		22,
		26,
		37,
		52,
		55,
		45,
		43,
		37,
		69,
		-1,
		175,
		174,
		163,
		160,
		136,
		127,
		122,
		149,
		-1,
		-1,
		144,
		165,
		155,
		159,
		175,
		200,
		-1,
		128,
		-1,
		-1,
		102,
		-1,
		-1,
		87,
		50,
		39,
		30,
		28,
		34,
		45,
		63,
		51,
		52,
		42,
		52,
		65,
		159,
		156,
		144,
		142,
		165,
		130,
		118,
		-1,
		131,
		129,
		135,
		142,
		159,
		189,
		-1,
		-1,
		144,
		124,
		-1,
		-1,
		85,
		83,
		72,
		-1,
		62,
		35,
		32,
		57,
		64,
		60,
		54,
		48,
		55,
		54,
		62,
		70,
		168,
		182,
		171,
		167,
		166,
		174,
		123,
		116,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		134,
		130,
		-1,
		-1,
		80,
		73,
		61,
		49,
		39,
		46,
		49,
		49,
		52,
		51,
		46,
		57,
		49,
		53,
		70,
		-1,
		202,
		-1,
		154,
		130,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		151,
		137,
		130,
		118,
		116,
		-1,
		114,
		98,
		79,
		-1,
		49,
		62,
		85,
		53,
		58,
		53,
		52,
		63,
		52,
		55,
		69,
		64,
		-1,
		-1,
		142,
		145,
		-1,
		-1,
		141,
		143,
		-1,
		142,
		131,
		116,
		108,
		-1,
		-1,
		86,
		82,
		-1,
		-1,
		50,
		67,
		56,
		64,
		59,
		56,
		62,
		65,
		54,
		58,
		70,
		-1,
		-1,
		149,
		150,
		148,
		-1,
		126,
		-1,
		144,
		-1,
		111,
		117,
		105,
		-1,
		-1,
		-1,
		88,
		51,
		72,
		74,
		79,
		77,
		68,
		60,
		67,
		65,
		61,
		72,
		-1,
		-1,
		-1,
		144,
		118,
		151,
		142,
		125,
		105,
		97,
		116,
		-1,
		86,
		-1,
		55,
		52,
		88,
		73,
		90,
		84,
		63,
		78,
		68,
		59,
		68,
		150,
		-1,
		120,
		153,
		117,
		111,
		87,
		91,
		107,
		-1,
		83,
		63,
		-1,
		93,
		83,
		107,
		93,
		78,
		65,
		72,
		72,
		65,
		-1,
		-1,
		-1,
		122,
		121,
		113,
		107,
		107,
		92,
		83,
		-1,
		95,
		77,
		56,
		73,
		73,
		64,
		72,
		97,
		93,
		85,
		85,
		77,
		-1,
		223,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		116,
		111,
		84,
		72,
		78,
		74,
		60,
		66,
		68,
		76,
		74,
		71,
		83,
		79,
		99,
		78,
		113,
		-1,
		218,
		-1,
		152,
		-1,
		-1,
		134,
		114,
		106,
		95,
		84,
		82,
		73,
		64,
		86,
		102,
		86,
		84,
		85,
		86,
		-1,
		207,
		206,
		-1,
		153,
		145,
		131,
		-1,
		124,
		-1,
		130,
		91,
		-1,
		93,
		73,
		-1,
		95,
		90,
		-1,
		-1,
		194,
		169,
		-1,
		-1,
		-1,
		154,
		134,
		125,
		109,
		-1,
		84,
		84,
		-1,
		-1,
		-1,
		179,
		178,
		-1,
		147,
		150,
		-1,
		140,
		131,
		139,
		86,
		90,
		-1,
		-1,
		-1,
		188,
		169,
		163,
		162,
		160,
		155,
		152,
		138,
		122,
		100,
		89,
		110,
		-1,
		-1,
		-1,
		160,
		152,
		145,
		-1,
		-1,
		147,
		130,
		111,
		109,
		-1,
		-1,
		-1,
		182,
		163,
		-1,
		-1,
		137,
		-1,
		-1,
		143,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		171,
		-1,
		-1,
		-1,
		133,
		129,
		130,
		-1,
		-1,
		-1,
		-1,
		193,
		194,
		217,
		181,
		-1,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		196,
		194,
		-1,
		-1,
		-1,
		153,
		137,
		-1,
		123,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		158,
		-1,
		158,
		133,
		140,
		-1,
		-1,
		-1,
		-1,
		171,
		163,
		171,
		-1,
		143,
		145,
		-1,
		193,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		148,
		155,
		177,
		180,
		216,
		-1,
		167
	],
	[
		-1,
		196,
		185,
		196,
		204,
		177,
		184,
		-1,
		203,
		207,
		173,
		167,
		206,
		175,
		181,
		192,
		-1,
		-1,
		-1,
		196,
		195,
		163,
		161,
		170,
		175,
		182,
		-1,
		181,
		-1,
		217,
		196,
		207,
		212,
		156,
		153,
		173,
		192,
		174,
		166,
		232,
		186,
		157,
		151,
		169,
		159,
		168,
		160,
		-1,
		157,
		147,
		169,
		148,
		159,
		151,
		-1,
		-1,
		151,
		152,
		158,
		144,
		150,
		146,
		-1,
		156,
		140,
		-1,
		-1,
		141,
		142,
		126,
		129,
		137,
		135,
		148,
		140,
		135,
		-1,
		-1,
		132,
		128,
		135,
		122,
		118,
		135,
		148,
		130,
		144,
		143,
		-1,
		136,
		154,
		161,
		129,
		127,
		111,
		109,
		127,
		129,
		135,
		135,
		-1,
		145,
		146,
		141,
		149,
		151,
		127,
		114,
		114,
		124,
		117,
		136,
		124,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		145,
		128,
		145,
		137,
		127,
		142,
		135,
		117,
		114,
		112,
		109,
		125,
		123,
		133,
		-1,
		-1,
		238,
		207,
		236,
		194,
		175,
		-1,
		141,
		121,
		127,
		131,
		125,
		118,
		132,
		128,
		-1,
		103,
		102,
		130,
		116,
		127,
		198,
		-1,
		-1,
		196,
		188,
		171,
		174,
		151,
		147,
		136,
		135,
		127,
		113,
		109,
		115,
		118,
		118,
		124,
		97,
		107,
		111,
		109,
		134,
		-1,
		-1,
		169,
		-1,
		-1,
		195,
		178,
		-1,
		161,
		168,
		157,
		163,
		149,
		170,
		146,
		137,
		129,
		123,
		111,
		113,
		110,
		123,
		111,
		94,
		119,
		123,
		104,
		125,
		120,
		-1,
		168,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		154,
		157,
		163,
		187,
		186,
		-1,
		158,
		146,
		147,
		132,
		129,
		116,
		104,
		117,
		102,
		109,
		108,
		98,
		96,
		126,
		101,
		123,
		120,
		139,
		144,
		138,
		147,
		-1,
		203,
		199,
		195,
		202,
		151,
		-1,
		-1,
		191,
		-1,
		194,
		195,
		170,
		143,
		146,
		133,
		124,
		111,
		100,
		111,
		100,
		97,
		105,
		90,
		105,
		96,
		95,
		113,
		123,
		131,
		135,
		141,
		-1,
		253,
		-1,
		195,
		179,
		181,
		153,
		174,
		-1,
		211,
		195,
		187,
		172,
		172,
		-1,
		142,
		139,
		129,
		107,
		92,
		109,
		101,
		99,
		103,
		85,
		99,
		90,
		108,
		115,
		113,
		117,
		137,
		149,
		213,
		203,
		-1,
		185,
		190,
		149,
		157,
		176,
		214,
		178,
		-1,
		173,
		-1,
		144,
		157,
		-1,
		113,
		109,
		91,
		92,
		87,
		102,
		96,
		81,
		78,
		96,
		99,
		106,
		110,
		126,
		-1,
		-1,
		198,
		202,
		191,
		142,
		161,
		185,
		222,
		171,
		160,
		159,
		-1,
		150,
		127,
		124,
		112,
		99,
		84,
		85,
		93,
		106,
		85,
		80,
		77,
		97,
		123,
		101,
		113,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		168,
		139,
		163,
		205,
		189,
		182,
		170,
		135,
		135,
		129,
		-1,
		123,
		102,
		93,
		82,
		80,
		93,
		90,
		95,
		75,
		73,
		92,
		104,
		95,
		112,
		-1,
		-1,
		-1,
		198,
		187,
		188,
		134,
		157,
		194,
		168,
		154,
		159,
		134,
		127,
		121,
		136,
		119,
		100,
		89,
		81,
		70,
		86,
		94,
		89,
		71,
		80,
		86,
		110,
		100,
		106,
		-1,
		-1,
		205,
		195,
		179,
		181,
		178,
		148,
		155,
		187,
		159,
		172,
		-1,
		126,
		-1,
		115,
		110,
		94,
		89,
		86,
		83,
		77,
		86,
		88,
		78,
		73,
		80,
		115,
		115,
		90,
		110,
		113,
		-1,
		-1,
		-1,
		198,
		193,
		168,
		145,
		129,
		165,
		-1,
		142,
		143,
		-1,
		120,
		114,
		111,
		96,
		92,
		87,
		91,
		84,
		91,
		84,
		82,
		83,
		65,
		97,
		-1,
		98,
		92,
		100,
		90,
		78,
		-1,
		-1,
		-1,
		191,
		170,
		163,
		183,
		124,
		176,
		-1,
		-1,
		127,
		120,
		-1,
		107,
		89,
		96,
		94,
		88,
		92,
		89,
		78,
		91,
		84,
		70,
		72,
		85,
		89,
		93,
		80,
		76,
		73,
		87,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		144,
		-1,
		136,
		128,
		118,
		112,
		106,
		102,
		100,
		116,
		100,
		103,
		101,
		92,
		100,
		73,
		66,
		73,
		62,
		80,
		88,
		80,
		74,
		73,
		83,
		-1,
		211,
		197,
		168,
		-1,
		-1,
		157,
		-1,
		121,
		135,
		151,
		-1,
		144,
		123,
		138,
		116,
		112,
		108,
		123,
		124,
		102,
		101,
		99,
		90,
		78,
		67,
		70,
		62,
		84,
		84,
		68,
		69,
		73,
		-1,
		217,
		204,
		162,
		158,
		147,
		167,
		118,
		106,
		138,
		-1,
		-1,
		180,
		-1,
		114,
		131,
		122,
		120,
		113,
		104,
		110,
		110,
		87,
		82,
		72,
		61,
		61,
		56,
		78,
		64,
		62,
		71,
		87,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		133,
		120,
		114,
		-1,
		155,
		-1,
		158,
		148,
		132,
		117,
		150,
		-1,
		113,
		105,
		110,
		-1,
		107,
		-1,
		80,
		77,
		68,
		53,
		50,
		61,
		59,
		70,
		66,
		-1,
		167,
		152,
		145,
		135,
		149,
		120,
		-1,
		175,
		-1,
		-1,
		145,
		139,
		139,
		123,
		126,
		129,
		109,
		101,
		110,
		102,
		94,
		88,
		66,
		59,
		56,
		49,
		62,
		72,
		77,
		64,
		-1,
		-1,
		-1,
		172,
		158,
		162,
		122,
		141,
		-1,
		-1,
		207,
		162,
		148,
		-1,
		132,
		129,
		117,
		107,
		97,
		102,
		103,
		85,
		78,
		64,
		66,
		60,
		51,
		50,
		66,
		58,
		80,
		-1,
		-1,
		155,
		160,
		148,
		134,
		153,
		-1,
		-1,
		-1,
		154,
		170,
		157,
		133,
		118,
		-1,
		-1,
		101,
		94,
		88,
		81,
		68,
		80,
		75,
		59,
		44,
		59,
		63,
		71,
		62,
		-1,
		158,
		145,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		-1,
		-1,
		169,
		114,
		103,
		98,
		102,
		100,
		-1,
		74,
		85,
		72,
		84,
		91,
		61,
		46,
		40,
		46,
		58,
		67,
		-1,
		-1,
		170,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		126,
		120,
		91,
		84,
		88,
		-1,
		76,
		78,
		74,
		87,
		64,
		61,
		52,
		43,
		39,
		43,
		47,
		61,
		65,
		193,
		-1,
		154,
		-1,
		-1,
		-1,
		144,
		159,
		130,
		107,
		80,
		75,
		68,
		62,
		67,
		78,
		72,
		83,
		50,
		46,
		36,
		35,
		39,
		56,
		60,
		-1,
		-1,
		152,
		148,
		170,
		152,
		156,
		157,
		-1,
		-1,
		84,
		75,
		66,
		58,
		71,
		74,
		56,
		53,
		47,
		40,
		34,
		44,
		59,
		54,
		-1,
		-1,
		-1,
		164,
		-1,
		166,
		-1,
		-1,
		154,
		155,
		102,
		84,
		80,
		78,
		67,
		61,
		49,
		54,
		57,
		48,
		42,
		30,
		34,
		57,
		46,
		85,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		143,
		135,
		130,
		136,
		138,
		129,
		117,
		114,
		-1,
		84,
		90,
		55,
		62,
		45,
		52,
		52,
		44,
		24,
		31,
		47,
		46,
		41,
		77,
		68,
		74,
		-1,
		-1,
		229,
		218,
		207,
		213,
		-1,
		136,
		132,
		122,
		112,
		115,
		-1,
		-1,
		109,
		106,
		86,
		55,
		53,
		46,
		41,
		46,
		27,
		20,
		24,
		28,
		34,
		39,
		44,
		50,
		65,
		80,
		-1,
		183,
		220,
		213,
		181,
		189,
		220,
		-1,
		126,
		118,
		129,
		104,
		106,
		-1,
		-1,
		82,
		73,
		74,
		62,
		59,
		63,
		58,
		47,
		22,
		0,
		22,
		26,
		44,
		48,
		57,
		61,
		54,
		67,
		71,
		-1,
		176,
		196,
		175,
		178,
		202,
		216,
		-1,
		123,
		-1,
		-1,
		135,
		107,
		91,
		81,
		78,
		121,
		76,
		71,
		56,
		54,
		45,
		36,
		27,
		30,
		35,
		38,
		48,
		53,
		45,
		64,
		64,
		65,
		-1,
		165,
		176,
		169,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		151,
		-1,
		118,
		-1,
		101,
		105,
		84,
		87,
		70,
		57,
		49,
		30,
		46,
		28,
		43,
		39,
		35,
		44,
		55,
		67,
		71,
		72,
		190,
		146,
		149,
		160,
		171,
		186,
		190,
		-1,
		135,
		174,
		164,
		-1,
		148,
		-1,
		-1,
		-1,
		115,
		97,
		89,
		90,
		69,
		69,
		43,
		42,
		33,
		40,
		50,
		52,
		44,
		48,
		61,
		72,
		80,
		186,
		177,
		190,
		135,
		135,
		156,
		165,
		186,
		150,
		141,
		168,
		171,
		160,
		155,
		142,
		-1,
		-1,
		138,
		107,
		-1,
		-1,
		76,
		64,
		47,
		44,
		40,
		43,
		58,
		61,
		51,
		49,
		43,
		75,
		-1,
		179,
		178,
		167,
		164,
		140,
		131,
		126,
		153,
		-1,
		-1,
		148,
		169,
		159,
		163,
		179,
		204,
		-1,
		131,
		-1,
		-1,
		121,
		-1,
		-1,
		106,
		69,
		58,
		49,
		50,
		48,
		59,
		69,
		57,
		58,
		48,
		58,
		71,
		163,
		160,
		148,
		146,
		169,
		134,
		122,
		-1,
		135,
		133,
		139,
		146,
		163,
		193,
		-1,
		-1,
		147,
		127,
		-1,
		-1,
		104,
		102,
		91,
		-1,
		81,
		54,
		54,
		75,
		77,
		66,
		60,
		54,
		61,
		60,
		68,
		76,
		172,
		186,
		175,
		171,
		170,
		178,
		127,
		120,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		137,
		133,
		-1,
		-1,
		99,
		92,
		80,
		68,
		58,
		68,
		68,
		71,
		64,
		57,
		52,
		63,
		55,
		59,
		76,
		-1,
		206,
		-1,
		158,
		134,
		148,
		163,
		171,
		-1,
		-1,
		-1,
		154,
		140,
		133,
		121,
		119,
		-1,
		133,
		117,
		98,
		-1,
		68,
		81,
		107,
		75,
		80,
		75,
		58,
		69,
		58,
		61,
		75,
		70,
		-1,
		-1,
		146,
		149,
		-1,
		-1,
		144,
		146,
		-1,
		145,
		134,
		119,
		111,
		-1,
		-1,
		105,
		101,
		-1,
		-1,
		69,
		89,
		78,
		86,
		81,
		62,
		68,
		71,
		60,
		64,
		76,
		-1,
		-1,
		153,
		154,
		151,
		-1,
		129,
		-1,
		147,
		-1,
		114,
		120,
		108,
		-1,
		-1,
		-1,
		107,
		70,
		87,
		96,
		91,
		89,
		80,
		66,
		73,
		71,
		67,
		78,
		-1,
		-1,
		-1,
		147,
		121,
		154,
		145,
		128,
		108,
		100,
		119,
		-1,
		89,
		-1,
		64,
		67,
		92,
		95,
		102,
		96,
		69,
		84,
		74,
		65,
		74,
		153,
		-1,
		123,
		156,
		120,
		114,
		90,
		94,
		110,
		-1,
		86,
		68,
		-1,
		96,
		86,
		118,
		103,
		84,
		71,
		78,
		78,
		71,
		-1,
		-1,
		-1,
		125,
		124,
		116,
		110,
		110,
		95,
		86,
		-1,
		98,
		80,
		59,
		76,
		76,
		67,
		75,
		108,
		104,
		91,
		91,
		83,
		-1,
		226,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		119,
		114,
		87,
		75,
		81,
		77,
		63,
		69,
		71,
		79,
		77,
		74,
		86,
		82,
		102,
		84,
		119,
		-1,
		221,
		-1,
		155,
		-1,
		-1,
		137,
		117,
		109,
		98,
		87,
		85,
		76,
		67,
		89,
		105,
		89,
		87,
		91,
		92,
		-1,
		210,
		209,
		-1,
		156,
		148,
		134,
		-1,
		127,
		-1,
		133,
		94,
		-1,
		96,
		76,
		-1,
		98,
		94,
		-1,
		-1,
		197,
		172,
		-1,
		-1,
		-1,
		157,
		137,
		128,
		112,
		-1,
		87,
		87,
		-1,
		-1,
		-1,
		182,
		181,
		-1,
		150,
		153,
		-1,
		143,
		134,
		142,
		89,
		93,
		-1,
		-1,
		-1,
		191,
		172,
		166,
		165,
		163,
		158,
		155,
		141,
		125,
		103,
		92,
		113,
		-1,
		-1,
		-1,
		163,
		155,
		148,
		-1,
		-1,
		150,
		133,
		114,
		112,
		-1,
		-1,
		-1,
		185,
		166,
		-1,
		-1,
		140,
		-1,
		-1,
		146,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		174,
		-1,
		-1,
		-1,
		136,
		132,
		133,
		-1,
		-1,
		-1,
		-1,
		196,
		197,
		220,
		184,
		-1,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		199,
		197,
		-1,
		-1,
		-1,
		156,
		140,
		-1,
		126,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		161,
		-1,
		161,
		136,
		143,
		-1,
		-1,
		-1,
		-1,
		174,
		166,
		174,
		-1,
		146,
		148,
		-1,
		196,
		-1,
		-1,
		189,
		180,
		-1,
		-1,
		151,
		158,
		180,
		183,
		219,
		-1,
		170
	],
	[
		-1,
		183,
		172,
		183,
		191,
		164,
		171,
		-1,
		190,
		194,
		160,
		154,
		193,
		162,
		168,
		179,
		-1,
		-1,
		-1,
		183,
		182,
		150,
		148,
		157,
		162,
		169,
		-1,
		168,
		-1,
		204,
		183,
		194,
		199,
		143,
		140,
		160,
		179,
		161,
		153,
		219,
		173,
		144,
		138,
		156,
		146,
		155,
		147,
		-1,
		144,
		134,
		156,
		135,
		146,
		138,
		-1,
		-1,
		138,
		139,
		145,
		131,
		137,
		133,
		-1,
		143,
		127,
		-1,
		-1,
		128,
		129,
		113,
		116,
		124,
		122,
		135,
		127,
		122,
		-1,
		-1,
		119,
		115,
		122,
		109,
		105,
		122,
		135,
		117,
		131,
		130,
		-1,
		123,
		141,
		148,
		116,
		114,
		98,
		96,
		114,
		116,
		122,
		122,
		-1,
		132,
		133,
		128,
		136,
		138,
		114,
		101,
		101,
		111,
		104,
		123,
		111,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		132,
		115,
		132,
		124,
		114,
		129,
		122,
		104,
		101,
		99,
		96,
		112,
		110,
		120,
		-1,
		-1,
		225,
		194,
		223,
		181,
		162,
		-1,
		128,
		108,
		114,
		118,
		112,
		105,
		119,
		115,
		-1,
		90,
		89,
		117,
		103,
		114,
		185,
		-1,
		-1,
		183,
		175,
		158,
		161,
		138,
		134,
		123,
		122,
		114,
		100,
		96,
		102,
		105,
		105,
		111,
		84,
		94,
		98,
		96,
		121,
		-1,
		-1,
		156,
		-1,
		-1,
		182,
		165,
		-1,
		148,
		155,
		144,
		150,
		136,
		157,
		133,
		124,
		116,
		110,
		98,
		100,
		97,
		110,
		98,
		81,
		106,
		110,
		91,
		112,
		107,
		-1,
		155,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		141,
		144,
		150,
		174,
		173,
		-1,
		145,
		133,
		134,
		119,
		116,
		103,
		91,
		104,
		89,
		96,
		95,
		85,
		83,
		113,
		88,
		110,
		107,
		126,
		131,
		125,
		134,
		-1,
		190,
		186,
		182,
		189,
		138,
		-1,
		-1,
		178,
		-1,
		181,
		182,
		157,
		130,
		133,
		120,
		111,
		98,
		87,
		98,
		87,
		84,
		92,
		77,
		92,
		83,
		82,
		100,
		110,
		118,
		122,
		128,
		-1,
		240,
		-1,
		182,
		166,
		168,
		140,
		161,
		-1,
		198,
		182,
		174,
		159,
		159,
		-1,
		129,
		126,
		116,
		94,
		79,
		96,
		88,
		86,
		90,
		72,
		86,
		77,
		95,
		102,
		100,
		104,
		124,
		136,
		200,
		190,
		-1,
		172,
		177,
		136,
		144,
		163,
		201,
		165,
		-1,
		160,
		-1,
		131,
		144,
		-1,
		100,
		96,
		78,
		79,
		74,
		89,
		83,
		68,
		65,
		83,
		86,
		93,
		97,
		113,
		-1,
		-1,
		185,
		189,
		178,
		129,
		148,
		172,
		209,
		158,
		147,
		146,
		-1,
		137,
		114,
		111,
		99,
		86,
		71,
		72,
		80,
		93,
		72,
		67,
		64,
		84,
		110,
		88,
		100,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		155,
		126,
		150,
		192,
		176,
		169,
		157,
		122,
		122,
		116,
		-1,
		110,
		89,
		80,
		69,
		67,
		80,
		77,
		82,
		62,
		60,
		79,
		91,
		82,
		99,
		-1,
		-1,
		-1,
		185,
		174,
		175,
		121,
		144,
		181,
		155,
		141,
		146,
		121,
		114,
		108,
		123,
		106,
		87,
		76,
		68,
		57,
		73,
		81,
		76,
		58,
		67,
		73,
		97,
		87,
		93,
		-1,
		-1,
		192,
		182,
		166,
		168,
		165,
		135,
		142,
		174,
		146,
		159,
		-1,
		113,
		-1,
		102,
		97,
		81,
		76,
		73,
		70,
		64,
		73,
		75,
		65,
		60,
		67,
		102,
		102,
		77,
		97,
		100,
		-1,
		-1,
		-1,
		185,
		180,
		155,
		132,
		116,
		152,
		-1,
		129,
		130,
		-1,
		107,
		101,
		98,
		83,
		79,
		74,
		78,
		71,
		78,
		71,
		69,
		70,
		52,
		84,
		-1,
		85,
		79,
		87,
		77,
		65,
		-1,
		-1,
		-1,
		178,
		157,
		150,
		170,
		111,
		163,
		-1,
		-1,
		114,
		107,
		-1,
		94,
		76,
		83,
		81,
		75,
		79,
		76,
		65,
		78,
		71,
		57,
		59,
		72,
		76,
		80,
		67,
		63,
		60,
		74,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		131,
		-1,
		123,
		115,
		105,
		99,
		93,
		89,
		87,
		103,
		87,
		90,
		88,
		79,
		87,
		60,
		53,
		60,
		49,
		67,
		75,
		67,
		61,
		60,
		70,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		144,
		-1,
		108,
		122,
		138,
		-1,
		131,
		110,
		125,
		103,
		99,
		95,
		110,
		111,
		89,
		88,
		86,
		77,
		65,
		54,
		57,
		49,
		71,
		71,
		55,
		56,
		60,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		93,
		125,
		-1,
		-1,
		167,
		-1,
		101,
		118,
		109,
		107,
		100,
		91,
		97,
		97,
		74,
		69,
		59,
		48,
		48,
		43,
		65,
		51,
		49,
		58,
		74,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		145,
		135,
		119,
		104,
		137,
		-1,
		102,
		92,
		97,
		-1,
		94,
		-1,
		67,
		64,
		55,
		40,
		37,
		48,
		46,
		57,
		53,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		162,
		-1,
		-1,
		132,
		126,
		126,
		110,
		113,
		118,
		98,
		90,
		97,
		89,
		81,
		75,
		53,
		46,
		43,
		36,
		49,
		59,
		64,
		51,
		-1,
		-1,
		-1,
		159,
		145,
		149,
		109,
		128,
		-1,
		-1,
		194,
		149,
		135,
		-1,
		119,
		118,
		106,
		96,
		86,
		91,
		92,
		72,
		65,
		51,
		53,
		47,
		38,
		37,
		53,
		45,
		67,
		-1,
		-1,
		142,
		147,
		135,
		121,
		140,
		-1,
		-1,
		-1,
		141,
		157,
		146,
		120,
		107,
		-1,
		-1,
		90,
		83,
		77,
		68,
		55,
		67,
		62,
		46,
		31,
		46,
		50,
		58,
		49,
		-1,
		145,
		132,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		-1,
		-1,
		158,
		103,
		92,
		87,
		91,
		89,
		-1,
		63,
		74,
		59,
		71,
		78,
		48,
		33,
		27,
		33,
		45,
		54,
		-1,
		-1,
		157,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		80,
		73,
		77,
		-1,
		65,
		67,
		61,
		76,
		51,
		48,
		39,
		30,
		26,
		30,
		34,
		48,
		52,
		180,
		-1,
		143,
		-1,
		-1,
		-1,
		133,
		148,
		119,
		96,
		69,
		64,
		57,
		51,
		56,
		67,
		59,
		70,
		37,
		33,
		23,
		22,
		26,
		43,
		47,
		-1,
		-1,
		141,
		137,
		159,
		141,
		145,
		146,
		-1,
		-1,
		73,
		64,
		55,
		47,
		60,
		63,
		43,
		40,
		34,
		27,
		21,
		31,
		46,
		41,
		-1,
		-1,
		-1,
		153,
		-1,
		155,
		-1,
		-1,
		143,
		144,
		91,
		73,
		69,
		67,
		56,
		50,
		38,
		43,
		44,
		35,
		29,
		17,
		21,
		44,
		33,
		70,
		-1,
		-1,
		225,
		-1,
		-1,
		-1,
		132,
		124,
		119,
		125,
		127,
		118,
		106,
		103,
		-1,
		73,
		79,
		44,
		51,
		34,
		41,
		39,
		31,
		11,
		18,
		34,
		33,
		28,
		62,
		53,
		57,
		-1,
		-1,
		218,
		207,
		196,
		202,
		-1,
		125,
		121,
		111,
		101,
		104,
		-1,
		-1,
		98,
		95,
		75,
		44,
		42,
		35,
		30,
		40,
		20,
		7,
		11,
		15,
		21,
		26,
		31,
		37,
		48,
		63,
		-1,
		172,
		209,
		202,
		170,
		178,
		209,
		-1,
		115,
		107,
		118,
		93,
		95,
		-1,
		-1,
		71,
		62,
		63,
		51,
		48,
		50,
		45,
		36,
		16,
		22,
		0,
		12,
		31,
		34,
		38,
		39,
		41,
		54,
		58,
		-1,
		165,
		185,
		164,
		167,
		191,
		205,
		-1,
		112,
		-1,
		-1,
		124,
		96,
		80,
		70,
		67,
		110,
		65,
		60,
		44,
		42,
		33,
		24,
		24,
		8,
		13,
		16,
		26,
		31,
		23,
		49,
		51,
		52,
		-1,
		154,
		165,
		158,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		140,
		-1,
		107,
		-1,
		90,
		94,
		73,
		76,
		58,
		45,
		37,
		24,
		33,
		8,
		21,
		17,
		13,
		22,
		33,
		45,
		55,
		57,
		179,
		135,
		138,
		149,
		160,
		175,
		179,
		-1,
		124,
		163,
		157,
		-1,
		141,
		-1,
		-1,
		-1,
		104,
		86,
		78,
		78,
		57,
		57,
		31,
		27,
		13,
		20,
		30,
		30,
		22,
		26,
		39,
		50,
		65,
		175,
		166,
		179,
		124,
		124,
		145,
		154,
		175,
		139,
		130,
		157,
		164,
		153,
		148,
		135,
		-1,
		-1,
		127,
		96,
		-1,
		-1,
		64,
		52,
		35,
		24,
		20,
		23,
		38,
		39,
		29,
		27,
		21,
		53,
		-1,
		168,
		167,
		156,
		153,
		129,
		120,
		115,
		142,
		-1,
		-1,
		137,
		158,
		148,
		152,
		168,
		193,
		-1,
		124,
		-1,
		-1,
		109,
		-1,
		-1,
		94,
		57,
		46,
		37,
		35,
		28,
		39,
		49,
		35,
		36,
		26,
		36,
		49,
		152,
		149,
		137,
		135,
		158,
		123,
		111,
		-1,
		124,
		122,
		128,
		135,
		152,
		182,
		-1,
		-1,
		140,
		120,
		-1,
		-1,
		92,
		90,
		79,
		-1,
		69,
		42,
		39,
		55,
		55,
		44,
		38,
		32,
		39,
		38,
		46,
		54,
		161,
		175,
		164,
		160,
		159,
		167,
		116,
		109,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		130,
		126,
		-1,
		-1,
		87,
		80,
		68,
		56,
		46,
		53,
		48,
		56,
		42,
		35,
		30,
		41,
		33,
		37,
		54,
		-1,
		195,
		-1,
		147,
		123,
		137,
		152,
		160,
		-1,
		-1,
		-1,
		147,
		133,
		126,
		114,
		112,
		-1,
		121,
		105,
		86,
		-1,
		56,
		69,
		92,
		60,
		60,
		54,
		36,
		47,
		36,
		39,
		53,
		48,
		-1,
		-1,
		135,
		138,
		-1,
		-1,
		137,
		139,
		-1,
		138,
		127,
		112,
		104,
		-1,
		-1,
		93,
		89,
		-1,
		-1,
		57,
		74,
		63,
		66,
		61,
		40,
		46,
		49,
		38,
		42,
		54,
		-1,
		-1,
		142,
		143,
		144,
		-1,
		122,
		-1,
		140,
		-1,
		107,
		113,
		101,
		-1,
		-1,
		-1,
		95,
		58,
		79,
		81,
		69,
		67,
		58,
		44,
		51,
		49,
		45,
		56,
		-1,
		-1,
		-1,
		140,
		114,
		147,
		138,
		121,
		101,
		93,
		112,
		-1,
		82,
		-1,
		57,
		59,
		85,
		77,
		80,
		74,
		47,
		62,
		52,
		43,
		52,
		146,
		-1,
		116,
		149,
		113,
		107,
		83,
		87,
		103,
		-1,
		79,
		61,
		-1,
		89,
		79,
		96,
		81,
		62,
		49,
		56,
		56,
		49,
		-1,
		-1,
		-1,
		118,
		117,
		109,
		103,
		103,
		88,
		79,
		-1,
		91,
		73,
		52,
		69,
		69,
		60,
		68,
		86,
		82,
		69,
		69,
		61,
		-1,
		219,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		112,
		107,
		80,
		68,
		74,
		70,
		56,
		62,
		64,
		72,
		70,
		67,
		79,
		75,
		85,
		62,
		97,
		-1,
		214,
		-1,
		148,
		-1,
		-1,
		130,
		110,
		102,
		91,
		80,
		78,
		69,
		60,
		82,
		98,
		82,
		74,
		69,
		70,
		-1,
		203,
		202,
		-1,
		149,
		141,
		127,
		-1,
		120,
		-1,
		126,
		87,
		-1,
		89,
		69,
		-1,
		85,
		74,
		-1,
		-1,
		190,
		165,
		-1,
		-1,
		-1,
		150,
		130,
		121,
		105,
		-1,
		80,
		80,
		-1,
		-1,
		-1,
		175,
		174,
		-1,
		143,
		146,
		-1,
		136,
		127,
		135,
		82,
		86,
		-1,
		-1,
		-1,
		184,
		165,
		159,
		158,
		156,
		151,
		148,
		134,
		118,
		96,
		85,
		106,
		-1,
		-1,
		-1,
		156,
		148,
		141,
		-1,
		-1,
		143,
		126,
		107,
		105,
		-1,
		-1,
		-1,
		178,
		159,
		-1,
		-1,
		133,
		-1,
		-1,
		139,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		167,
		-1,
		-1,
		-1,
		129,
		125,
		126,
		-1,
		-1,
		-1,
		-1,
		189,
		190,
		213,
		177,
		-1,
		-1,
		-1,
		121,
		115,
		-1,
		-1,
		192,
		190,
		-1,
		-1,
		-1,
		149,
		133,
		-1,
		119,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		154,
		-1,
		154,
		129,
		136,
		-1,
		-1,
		-1,
		-1,
		167,
		159,
		167,
		-1,
		139,
		141,
		-1,
		189,
		-1,
		-1,
		182,
		173,
		-1,
		-1,
		144,
		151,
		173,
		176,
		212,
		-1,
		163
	],
	[
		-1,
		185,
		174,
		185,
		193,
		166,
		173,
		-1,
		192,
		196,
		162,
		156,
		195,
		164,
		170,
		181,
		-1,
		-1,
		-1,
		185,
		184,
		152,
		150,
		159,
		164,
		171,
		-1,
		170,
		-1,
		206,
		185,
		196,
		201,
		145,
		142,
		162,
		181,
		163,
		155,
		221,
		175,
		146,
		140,
		158,
		148,
		157,
		149,
		-1,
		146,
		136,
		158,
		137,
		148,
		140,
		-1,
		-1,
		140,
		141,
		147,
		133,
		139,
		135,
		-1,
		145,
		129,
		-1,
		-1,
		130,
		131,
		115,
		118,
		126,
		124,
		137,
		129,
		124,
		-1,
		-1,
		121,
		117,
		124,
		111,
		107,
		124,
		137,
		119,
		133,
		132,
		-1,
		125,
		143,
		150,
		118,
		116,
		100,
		98,
		116,
		118,
		124,
		124,
		-1,
		134,
		135,
		130,
		138,
		140,
		116,
		103,
		103,
		113,
		106,
		125,
		113,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		134,
		117,
		134,
		126,
		116,
		131,
		124,
		106,
		103,
		101,
		98,
		114,
		112,
		122,
		-1,
		-1,
		227,
		196,
		225,
		183,
		164,
		-1,
		130,
		110,
		116,
		120,
		114,
		107,
		121,
		117,
		-1,
		92,
		91,
		119,
		105,
		116,
		187,
		-1,
		-1,
		185,
		177,
		160,
		163,
		140,
		136,
		125,
		124,
		116,
		102,
		98,
		104,
		107,
		107,
		113,
		86,
		96,
		100,
		98,
		123,
		-1,
		-1,
		158,
		-1,
		-1,
		184,
		167,
		-1,
		150,
		157,
		146,
		152,
		138,
		159,
		135,
		126,
		118,
		112,
		100,
		102,
		99,
		112,
		100,
		83,
		108,
		112,
		93,
		114,
		109,
		-1,
		157,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		146,
		152,
		176,
		175,
		-1,
		147,
		135,
		136,
		121,
		118,
		105,
		93,
		106,
		91,
		98,
		97,
		87,
		85,
		115,
		90,
		112,
		109,
		128,
		133,
		127,
		136,
		-1,
		192,
		188,
		184,
		191,
		140,
		-1,
		-1,
		180,
		-1,
		183,
		184,
		159,
		132,
		135,
		122,
		113,
		100,
		89,
		100,
		89,
		86,
		94,
		79,
		94,
		85,
		84,
		102,
		112,
		120,
		124,
		130,
		-1,
		242,
		-1,
		184,
		168,
		170,
		142,
		163,
		-1,
		200,
		184,
		176,
		161,
		161,
		-1,
		131,
		128,
		118,
		96,
		81,
		98,
		90,
		88,
		92,
		74,
		88,
		79,
		97,
		104,
		102,
		106,
		126,
		138,
		202,
		192,
		-1,
		174,
		179,
		138,
		146,
		165,
		203,
		167,
		-1,
		162,
		-1,
		133,
		146,
		-1,
		102,
		98,
		80,
		81,
		76,
		91,
		85,
		70,
		67,
		85,
		88,
		95,
		99,
		115,
		-1,
		-1,
		187,
		191,
		180,
		131,
		150,
		174,
		211,
		160,
		149,
		148,
		-1,
		139,
		116,
		113,
		101,
		88,
		73,
		74,
		82,
		95,
		74,
		69,
		66,
		86,
		112,
		90,
		102,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		157,
		128,
		152,
		194,
		178,
		171,
		159,
		124,
		124,
		118,
		-1,
		112,
		91,
		82,
		71,
		69,
		82,
		79,
		84,
		64,
		62,
		81,
		93,
		84,
		101,
		-1,
		-1,
		-1,
		187,
		176,
		177,
		123,
		146,
		183,
		157,
		143,
		148,
		123,
		116,
		110,
		125,
		108,
		89,
		78,
		70,
		59,
		75,
		83,
		78,
		60,
		69,
		75,
		99,
		89,
		95,
		-1,
		-1,
		194,
		184,
		168,
		170,
		167,
		137,
		144,
		176,
		148,
		161,
		-1,
		115,
		-1,
		104,
		99,
		83,
		78,
		75,
		72,
		66,
		75,
		77,
		67,
		62,
		69,
		104,
		104,
		79,
		99,
		102,
		-1,
		-1,
		-1,
		187,
		182,
		157,
		134,
		118,
		154,
		-1,
		131,
		132,
		-1,
		109,
		103,
		100,
		85,
		81,
		76,
		80,
		73,
		80,
		73,
		71,
		72,
		54,
		86,
		-1,
		87,
		81,
		89,
		79,
		67,
		-1,
		-1,
		-1,
		180,
		159,
		152,
		172,
		113,
		165,
		-1,
		-1,
		116,
		109,
		-1,
		96,
		78,
		85,
		83,
		77,
		81,
		78,
		67,
		80,
		73,
		59,
		61,
		74,
		78,
		82,
		69,
		65,
		62,
		76,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		133,
		-1,
		125,
		117,
		107,
		101,
		95,
		91,
		89,
		105,
		89,
		92,
		90,
		81,
		89,
		62,
		55,
		62,
		51,
		69,
		77,
		69,
		63,
		62,
		72,
		-1,
		200,
		186,
		157,
		-1,
		-1,
		146,
		-1,
		110,
		124,
		140,
		-1,
		133,
		112,
		127,
		105,
		101,
		97,
		112,
		113,
		91,
		90,
		88,
		79,
		67,
		56,
		59,
		51,
		73,
		73,
		57,
		58,
		62,
		-1,
		206,
		193,
		151,
		147,
		136,
		156,
		107,
		95,
		127,
		-1,
		-1,
		169,
		-1,
		103,
		120,
		111,
		109,
		102,
		93,
		99,
		99,
		76,
		71,
		61,
		50,
		50,
		45,
		67,
		53,
		51,
		60,
		76,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		122,
		109,
		103,
		-1,
		144,
		-1,
		147,
		137,
		121,
		106,
		139,
		-1,
		104,
		94,
		99,
		-1,
		96,
		-1,
		69,
		66,
		57,
		42,
		39,
		50,
		48,
		59,
		55,
		-1,
		156,
		141,
		134,
		124,
		138,
		109,
		-1,
		164,
		-1,
		-1,
		134,
		128,
		128,
		112,
		115,
		120,
		100,
		92,
		99,
		91,
		83,
		77,
		55,
		48,
		45,
		38,
		51,
		61,
		66,
		53,
		-1,
		-1,
		-1,
		161,
		147,
		151,
		111,
		130,
		-1,
		-1,
		196,
		151,
		137,
		-1,
		121,
		120,
		108,
		98,
		88,
		93,
		94,
		74,
		67,
		53,
		55,
		49,
		40,
		39,
		55,
		47,
		69,
		-1,
		-1,
		144,
		149,
		137,
		123,
		142,
		-1,
		-1,
		-1,
		143,
		159,
		148,
		122,
		109,
		-1,
		-1,
		92,
		85,
		79,
		70,
		57,
		69,
		64,
		48,
		33,
		48,
		52,
		60,
		51,
		-1,
		147,
		134,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		-1,
		-1,
		160,
		105,
		94,
		89,
		93,
		91,
		-1,
		65,
		76,
		61,
		73,
		80,
		50,
		35,
		29,
		35,
		47,
		56,
		-1,
		-1,
		159,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		117,
		111,
		82,
		75,
		79,
		-1,
		67,
		69,
		63,
		78,
		53,
		50,
		41,
		32,
		28,
		32,
		36,
		45,
		51,
		182,
		-1,
		145,
		-1,
		-1,
		-1,
		135,
		150,
		121,
		98,
		71,
		66,
		59,
		53,
		58,
		69,
		61,
		72,
		39,
		35,
		25,
		24,
		28,
		45,
		39,
		-1,
		-1,
		143,
		139,
		161,
		143,
		147,
		148,
		-1,
		-1,
		75,
		66,
		57,
		49,
		62,
		65,
		45,
		42,
		36,
		29,
		23,
		33,
		38,
		33,
		-1,
		-1,
		-1,
		155,
		-1,
		157,
		-1,
		-1,
		145,
		146,
		93,
		75,
		71,
		69,
		58,
		52,
		40,
		45,
		48,
		38,
		30,
		19,
		13,
		36,
		25,
		64,
		-1,
		-1,
		227,
		-1,
		-1,
		-1,
		134,
		126,
		121,
		127,
		129,
		120,
		108,
		105,
		-1,
		75,
		81,
		46,
		53,
		36,
		43,
		42,
		34,
		13,
		10,
		26,
		25,
		20,
		56,
		47,
		53,
		-1,
		-1,
		220,
		209,
		198,
		204,
		-1,
		127,
		123,
		113,
		103,
		106,
		-1,
		-1,
		100,
		97,
		77,
		46,
		44,
		37,
		32,
		42,
		22,
		9,
		3,
		7,
		13,
		18,
		23,
		29,
		44,
		59,
		-1,
		174,
		211,
		204,
		172,
		180,
		211,
		-1,
		117,
		109,
		120,
		95,
		97,
		-1,
		-1,
		73,
		64,
		65,
		53,
		50,
		52,
		47,
		38,
		23,
		29,
		13,
		0,
		23,
		27,
		36,
		43,
		33,
		46,
		50,
		-1,
		167,
		187,
		166,
		169,
		193,
		207,
		-1,
		114,
		-1,
		-1,
		126,
		98,
		82,
		72,
		69,
		112,
		67,
		62,
		46,
		44,
		35,
		26,
		32,
		15,
		14,
		17,
		35,
		40,
		32,
		43,
		43,
		44,
		-1,
		156,
		167,
		160,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		142,
		-1,
		109,
		-1,
		92,
		96,
		75,
		78,
		60,
		47,
		39,
		31,
		45,
		20,
		22,
		18,
		22,
		31,
		42,
		54,
		50,
		51,
		181,
		137,
		140,
		151,
		162,
		177,
		181,
		-1,
		126,
		165,
		159,
		-1,
		143,
		-1,
		-1,
		-1,
		106,
		88,
		80,
		80,
		59,
		59,
		33,
		37,
		25,
		27,
		34,
		36,
		31,
		35,
		48,
		59,
		59,
		177,
		168,
		181,
		126,
		126,
		147,
		156,
		177,
		141,
		132,
		159,
		166,
		155,
		150,
		137,
		-1,
		-1,
		129,
		98,
		-1,
		-1,
		66,
		54,
		37,
		36,
		32,
		35,
		50,
		45,
		38,
		36,
		30,
		62,
		-1,
		170,
		169,
		158,
		155,
		131,
		122,
		117,
		144,
		-1,
		-1,
		139,
		160,
		150,
		154,
		170,
		195,
		-1,
		126,
		-1,
		-1,
		111,
		-1,
		-1,
		96,
		59,
		48,
		39,
		45,
		40,
		51,
		61,
		44,
		45,
		35,
		45,
		58,
		154,
		151,
		139,
		137,
		160,
		125,
		113,
		-1,
		126,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		142,
		122,
		-1,
		-1,
		94,
		92,
		81,
		-1,
		71,
		44,
		49,
		67,
		64,
		53,
		47,
		41,
		48,
		47,
		55,
		63,
		163,
		177,
		166,
		162,
		161,
		169,
		118,
		111,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		132,
		128,
		-1,
		-1,
		89,
		82,
		70,
		58,
		48,
		58,
		60,
		65,
		51,
		44,
		39,
		50,
		42,
		46,
		63,
		-1,
		197,
		-1,
		149,
		125,
		139,
		154,
		162,
		-1,
		-1,
		-1,
		149,
		135,
		128,
		116,
		114,
		-1,
		123,
		107,
		88,
		-1,
		58,
		71,
		101,
		69,
		69,
		63,
		45,
		56,
		45,
		48,
		62,
		57,
		-1,
		-1,
		137,
		140,
		-1,
		-1,
		139,
		141,
		-1,
		140,
		129,
		114,
		106,
		-1,
		-1,
		95,
		91,
		-1,
		-1,
		59,
		83,
		72,
		75,
		70,
		49,
		55,
		58,
		47,
		51,
		63,
		-1,
		-1,
		144,
		145,
		146,
		-1,
		124,
		-1,
		142,
		-1,
		109,
		115,
		103,
		-1,
		-1,
		-1,
		97,
		60,
		81,
		90,
		78,
		76,
		67,
		53,
		60,
		58,
		54,
		65,
		-1,
		-1,
		-1,
		142,
		116,
		149,
		140,
		123,
		103,
		95,
		114,
		-1,
		84,
		-1,
		59,
		61,
		87,
		86,
		89,
		83,
		56,
		71,
		61,
		52,
		61,
		148,
		-1,
		118,
		151,
		115,
		109,
		85,
		89,
		105,
		-1,
		81,
		63,
		-1,
		91,
		81,
		105,
		90,
		71,
		58,
		65,
		65,
		58,
		-1,
		-1,
		-1,
		120,
		119,
		111,
		105,
		105,
		90,
		81,
		-1,
		93,
		75,
		54,
		71,
		71,
		62,
		70,
		95,
		91,
		78,
		78,
		70,
		-1,
		221,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		114,
		109,
		82,
		70,
		76,
		72,
		58,
		64,
		66,
		74,
		72,
		69,
		81,
		77,
		94,
		71,
		106,
		-1,
		216,
		-1,
		150,
		-1,
		-1,
		132,
		112,
		104,
		93,
		82,
		80,
		71,
		62,
		84,
		100,
		84,
		82,
		78,
		79,
		-1,
		205,
		204,
		-1,
		151,
		143,
		129,
		-1,
		122,
		-1,
		128,
		89,
		-1,
		91,
		71,
		-1,
		93,
		83,
		-1,
		-1,
		192,
		167,
		-1,
		-1,
		-1,
		152,
		132,
		123,
		107,
		-1,
		82,
		82,
		-1,
		-1,
		-1,
		177,
		176,
		-1,
		145,
		148,
		-1,
		138,
		129,
		137,
		84,
		88,
		-1,
		-1,
		-1,
		186,
		167,
		161,
		160,
		158,
		153,
		150,
		136,
		120,
		98,
		87,
		108,
		-1,
		-1,
		-1,
		158,
		150,
		143,
		-1,
		-1,
		145,
		128,
		109,
		107,
		-1,
		-1,
		-1,
		180,
		161,
		-1,
		-1,
		135,
		-1,
		-1,
		141,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		169,
		-1,
		-1,
		-1,
		131,
		127,
		128,
		-1,
		-1,
		-1,
		-1,
		191,
		192,
		215,
		179,
		-1,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		194,
		192,
		-1,
		-1,
		-1,
		151,
		135,
		-1,
		121,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		156,
		-1,
		156,
		131,
		138,
		-1,
		-1,
		-1,
		-1,
		169,
		161,
		169,
		-1,
		141,
		143,
		-1,
		191,
		-1,
		-1,
		184,
		175,
		-1,
		-1,
		146,
		153,
		175,
		178,
		214,
		-1,
		165
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		143,
		161,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		152,
		153,
		148,
		156,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		245,
		214,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		110,
		109,
		137,
		123,
		134,
		205,
		-1,
		-1,
		203,
		195,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		202,
		194,
		179,
		179,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		221,
		185,
		-1,
		180,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		113,
		92,
		87,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		97,
		102,
		82,
		80,
		99,
		111,
		102,
		119,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		143,
		126,
		107,
		96,
		88,
		77,
		93,
		101,
		96,
		78,
		87,
		93,
		117,
		107,
		113,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		90,
		84,
		93,
		95,
		85,
		80,
		87,
		122,
		122,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		94,
		98,
		91,
		98,
		91,
		89,
		90,
		72,
		104,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		101,
		95,
		99,
		96,
		85,
		98,
		91,
		77,
		79,
		92,
		96,
		100,
		87,
		83,
		80,
		94,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		110,
		108,
		99,
		107,
		80,
		73,
		80,
		69,
		87,
		95,
		87,
		81,
		80,
		90,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		130,
		131,
		109,
		108,
		106,
		97,
		85,
		74,
		77,
		69,
		91,
		91,
		75,
		76,
		80,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		129,
		127,
		120,
		111,
		117,
		117,
		94,
		89,
		79,
		68,
		68,
		63,
		85,
		71,
		69,
		78,
		94,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		122,
		112,
		117,
		-1,
		114,
		-1,
		87,
		84,
		75,
		60,
		57,
		68,
		66,
		77,
		73,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		138,
		118,
		110,
		117,
		109,
		101,
		95,
		73,
		66,
		63,
		56,
		69,
		79,
		84,
		71,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		138,
		126,
		116,
		106,
		111,
		112,
		92,
		85,
		71,
		73,
		67,
		58,
		57,
		73,
		65,
		87,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		177,
		166,
		140,
		127,
		-1,
		-1,
		110,
		103,
		97,
		88,
		75,
		87,
		82,
		66,
		51,
		66,
		70,
		78,
		69,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		178,
		123,
		112,
		107,
		111,
		109,
		-1,
		83,
		94,
		79,
		91,
		98,
		68,
		53,
		47,
		53,
		65,
		74,
		-1,
		-1,
		177,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		135,
		129,
		100,
		93,
		97,
		-1,
		85,
		87,
		81,
		96,
		71,
		68,
		59,
		50,
		46,
		50,
		54,
		62,
		68,
		200,
		-1,
		163,
		-1,
		-1,
		-1,
		153,
		168,
		139,
		116,
		89,
		84,
		77,
		71,
		76,
		87,
		79,
		90,
		57,
		53,
		43,
		42,
		46,
		63,
		56,
		-1,
		-1,
		161,
		157,
		179,
		161,
		165,
		166,
		-1,
		-1,
		93,
		84,
		75,
		67,
		80,
		83,
		63,
		60,
		54,
		47,
		41,
		51,
		55,
		50,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		164,
		111,
		93,
		89,
		87,
		76,
		70,
		58,
		63,
		66,
		56,
		48,
		37,
		31,
		50,
		42,
		81,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		126,
		123,
		-1,
		93,
		99,
		64,
		71,
		54,
		61,
		60,
		52,
		31,
		28,
		44,
		39,
		37,
		73,
		64,
		70,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		62,
		55,
		50,
		60,
		40,
		27,
		21,
		16,
		30,
		35,
		40,
		46,
		61,
		76,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		70,
		65,
		56,
		41,
		47,
		33,
		23,
		0,
		19,
		53,
		57,
		50,
		63,
		67,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		144,
		116,
		100,
		90,
		87,
		130,
		85,
		80,
		64,
		62,
		53,
		44,
		51,
		38,
		23,
		26,
		27,
		49,
		41,
		60,
		60,
		61,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		127,
		-1,
		110,
		114,
		93,
		96,
		78,
		65,
		57,
		49,
		63,
		40,
		31,
		27,
		31,
		40,
		51,
		63,
		67,
		68,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		177,
		-1,
		161,
		-1,
		-1,
		-1,
		124,
		106,
		98,
		98,
		77,
		77,
		51,
		55,
		43,
		36,
		43,
		45,
		40,
		44,
		57,
		68,
		76,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		184,
		173,
		168,
		155,
		-1,
		-1,
		147,
		116,
		-1,
		-1,
		84,
		72,
		55,
		54,
		50,
		53,
		63,
		54,
		47,
		45,
		39,
		71,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		188,
		213,
		-1,
		144,
		-1,
		-1,
		129,
		-1,
		-1,
		114,
		77,
		66,
		57,
		63,
		58,
		67,
		74,
		53,
		54,
		44,
		54,
		67,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		202,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		62,
		67,
		85,
		73,
		62,
		56,
		50,
		57,
		56,
		64,
		72,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		76,
		78,
		74,
		60,
		53,
		48,
		59,
		51,
		55,
		72,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		110,
		78,
		78,
		72,
		54,
		65,
		54,
		57,
		71,
		66,
		-1,
		-1,
		155,
		158,
		-1,
		-1,
		157,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		92,
		81,
		84,
		79,
		58,
		64,
		67,
		56,
		60,
		72,
		-1,
		-1,
		162,
		163,
		164,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		115,
		78,
		99,
		99,
		87,
		85,
		76,
		62,
		69,
		67,
		63,
		74,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		102,
		-1,
		77,
		79,
		105,
		95,
		98,
		92,
		65,
		80,
		70,
		61,
		70,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		99,
		81,
		-1,
		109,
		99,
		114,
		99,
		80,
		67,
		74,
		74,
		67,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		89,
		89,
		80,
		88,
		104,
		100,
		87,
		87,
		79,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		84,
		92,
		90,
		87,
		99,
		95,
		103,
		80,
		115,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		118,
		102,
		92,
		87,
		88,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		103,
		92,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		146,
		164,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		155,
		156,
		151,
		159,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		138,
		155,
		147,
		137,
		152,
		145,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		248,
		217,
		246,
		204,
		185,
		-1,
		151,
		131,
		137,
		141,
		135,
		128,
		142,
		138,
		-1,
		113,
		112,
		140,
		126,
		137,
		208,
		-1,
		-1,
		206,
		198,
		181,
		184,
		161,
		157,
		146,
		145,
		137,
		123,
		119,
		125,
		128,
		128,
		134,
		107,
		117,
		121,
		119,
		144,
		-1,
		-1,
		179,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		167,
		173,
		159,
		180,
		156,
		147,
		139,
		133,
		121,
		123,
		120,
		133,
		121,
		104,
		129,
		133,
		114,
		135,
		130,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		196,
		-1,
		168,
		156,
		157,
		142,
		139,
		126,
		114,
		127,
		112,
		119,
		118,
		108,
		106,
		136,
		111,
		133,
		130,
		149,
		154,
		148,
		157,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		204,
		205,
		180,
		153,
		156,
		143,
		134,
		121,
		110,
		121,
		110,
		107,
		115,
		100,
		115,
		106,
		105,
		123,
		133,
		141,
		145,
		151,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		205,
		197,
		182,
		182,
		-1,
		152,
		149,
		139,
		117,
		102,
		119,
		111,
		109,
		113,
		95,
		109,
		100,
		118,
		125,
		123,
		127,
		147,
		159,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		154,
		167,
		-1,
		123,
		119,
		101,
		102,
		97,
		112,
		106,
		91,
		88,
		106,
		109,
		116,
		120,
		136,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		137,
		134,
		122,
		109,
		94,
		95,
		103,
		116,
		95,
		90,
		87,
		107,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		90,
		103,
		100,
		105,
		85,
		83,
		102,
		114,
		105,
		122,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		146,
		129,
		110,
		99,
		91,
		80,
		96,
		104,
		99,
		81,
		90,
		96,
		120,
		110,
		116,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		98,
		88,
		83,
		90,
		125,
		125,
		100,
		120,
		123,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		94,
		92,
		93,
		75,
		107,
		-1,
		108,
		102,
		110,
		100,
		88,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		106,
		104,
		98,
		102,
		99,
		88,
		101,
		94,
		80,
		82,
		95,
		99,
		103,
		90,
		86,
		83,
		97,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		113,
		111,
		102,
		110,
		83,
		76,
		83,
		72,
		90,
		98,
		90,
		84,
		83,
		93,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		118,
		133,
		134,
		112,
		111,
		109,
		100,
		88,
		77,
		80,
		72,
		94,
		94,
		78,
		79,
		83,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		132,
		130,
		123,
		114,
		120,
		120,
		97,
		92,
		82,
		71,
		71,
		66,
		88,
		74,
		72,
		81,
		86,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		125,
		115,
		120,
		-1,
		117,
		-1,
		90,
		87,
		78,
		63,
		60,
		71,
		69,
		80,
		76,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		141,
		121,
		113,
		120,
		112,
		104,
		98,
		76,
		69,
		66,
		59,
		72,
		82,
		87,
		74,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		141,
		129,
		119,
		109,
		114,
		115,
		95,
		88,
		74,
		76,
		70,
		61,
		60,
		76,
		68,
		85,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		169,
		143,
		130,
		-1,
		-1,
		113,
		106,
		100,
		91,
		78,
		90,
		85,
		69,
		54,
		69,
		73,
		75,
		67,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		181,
		126,
		115,
		110,
		114,
		112,
		-1,
		86,
		97,
		82,
		94,
		101,
		71,
		56,
		50,
		56,
		68,
		61,
		-1,
		-1,
		180,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		103,
		96,
		100,
		-1,
		88,
		90,
		84,
		99,
		74,
		71,
		62,
		53,
		49,
		53,
		57,
		46,
		52,
		203,
		-1,
		166,
		-1,
		-1,
		-1,
		156,
		171,
		142,
		119,
		92,
		87,
		80,
		74,
		79,
		90,
		82,
		93,
		60,
		56,
		46,
		45,
		49,
		50,
		40,
		-1,
		-1,
		164,
		160,
		182,
		164,
		168,
		169,
		-1,
		-1,
		96,
		87,
		78,
		70,
		83,
		86,
		66,
		63,
		57,
		50,
		44,
		54,
		39,
		34,
		-1,
		-1,
		-1,
		176,
		-1,
		178,
		-1,
		-1,
		166,
		167,
		114,
		96,
		92,
		90,
		79,
		73,
		61,
		66,
		69,
		59,
		51,
		40,
		34,
		44,
		26,
		65,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		155,
		147,
		142,
		148,
		150,
		141,
		129,
		126,
		-1,
		96,
		102,
		67,
		74,
		57,
		64,
		63,
		55,
		34,
		31,
		37,
		26,
		21,
		57,
		48,
		54,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		148,
		144,
		134,
		124,
		127,
		-1,
		-1,
		121,
		118,
		98,
		67,
		65,
		58,
		53,
		63,
		43,
		30,
		24,
		28,
		14,
		19,
		24,
		30,
		45,
		60,
		-1,
		195,
		232,
		225,
		193,
		201,
		232,
		-1,
		138,
		130,
		141,
		116,
		118,
		-1,
		-1,
		94,
		85,
		86,
		74,
		71,
		73,
		68,
		59,
		44,
		50,
		32,
		26,
		23,
		0,
		37,
		44,
		34,
		47,
		51,
		-1,
		188,
		208,
		187,
		190,
		214,
		228,
		-1,
		135,
		-1,
		-1,
		147,
		119,
		103,
		93,
		90,
		133,
		88,
		83,
		67,
		65,
		56,
		47,
		54,
		40,
		28,
		25,
		8,
		39,
		31,
		44,
		44,
		45,
		-1,
		177,
		188,
		181,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		163,
		-1,
		130,
		-1,
		113,
		117,
		96,
		99,
		81,
		68,
		60,
		52,
		65,
		40,
		36,
		32,
		21,
		30,
		41,
		53,
		51,
		52,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		147,
		186,
		180,
		-1,
		164,
		-1,
		-1,
		-1,
		127,
		109,
		101,
		101,
		80,
		80,
		54,
		58,
		45,
		41,
		48,
		38,
		30,
		34,
		47,
		58,
		60,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		162,
		153,
		180,
		187,
		176,
		171,
		158,
		-1,
		-1,
		150,
		119,
		-1,
		-1,
		87,
		75,
		58,
		56,
		52,
		55,
		63,
		47,
		37,
		35,
		29,
		61,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		160,
		181,
		171,
		175,
		191,
		216,
		-1,
		147,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		80,
		69,
		60,
		66,
		60,
		67,
		78,
		43,
		44,
		34,
		44,
		57,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		147,
		145,
		151,
		158,
		175,
		205,
		-1,
		-1,
		163,
		143,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		65,
		68,
		87,
		63,
		52,
		46,
		40,
		47,
		46,
		54,
		62,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		153,
		149,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		79,
		68,
		64,
		50,
		43,
		38,
		49,
		41,
		45,
		62,
		-1,
		218,
		-1,
		170,
		146,
		160,
		175,
		183,
		-1,
		-1,
		-1,
		170,
		156,
		149,
		137,
		135,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		100,
		68,
		68,
		62,
		44,
		55,
		44,
		47,
		61,
		56,
		-1,
		-1,
		158,
		161,
		-1,
		-1,
		160,
		162,
		-1,
		161,
		150,
		135,
		127,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		82,
		71,
		74,
		69,
		48,
		54,
		57,
		46,
		50,
		62,
		-1,
		-1,
		165,
		166,
		167,
		-1,
		145,
		-1,
		163,
		-1,
		130,
		136,
		124,
		-1,
		-1,
		-1,
		118,
		81,
		102,
		89,
		77,
		75,
		66,
		52,
		59,
		57,
		53,
		64,
		-1,
		-1,
		-1,
		163,
		137,
		170,
		161,
		144,
		124,
		116,
		135,
		-1,
		105,
		-1,
		80,
		82,
		103,
		85,
		88,
		82,
		55,
		70,
		60,
		51,
		60,
		169,
		-1,
		139,
		172,
		136,
		130,
		106,
		110,
		126,
		-1,
		102,
		84,
		-1,
		112,
		102,
		104,
		89,
		70,
		57,
		64,
		64,
		57,
		-1,
		-1,
		-1,
		141,
		140,
		132,
		126,
		126,
		111,
		102,
		-1,
		114,
		96,
		75,
		92,
		92,
		83,
		91,
		94,
		90,
		77,
		77,
		69,
		-1,
		242,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		135,
		130,
		103,
		91,
		97,
		93,
		79,
		85,
		87,
		95,
		93,
		90,
		96,
		87,
		93,
		70,
		105,
		-1,
		237,
		-1,
		171,
		-1,
		-1,
		153,
		133,
		125,
		114,
		103,
		101,
		92,
		83,
		105,
		121,
		94,
		82,
		77,
		78,
		-1,
		226,
		225,
		-1,
		172,
		164,
		150,
		-1,
		143,
		-1,
		149,
		110,
		-1,
		112,
		92,
		-1,
		93,
		82,
		-1,
		-1,
		213,
		188,
		-1,
		-1,
		-1,
		173,
		153,
		144,
		128,
		-1,
		103,
		103,
		-1,
		-1,
		-1,
		198,
		197,
		-1,
		166,
		169,
		-1,
		159,
		150,
		158,
		105,
		109,
		-1,
		-1,
		-1,
		207,
		188,
		182,
		181,
		179,
		174,
		171,
		157,
		141,
		119,
		108,
		129,
		-1,
		-1,
		-1,
		179,
		171,
		164,
		-1,
		-1,
		166,
		149,
		130,
		128,
		-1,
		-1,
		-1,
		201,
		182,
		-1,
		-1,
		156,
		-1,
		-1,
		162,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		190,
		-1,
		-1,
		-1,
		152,
		148,
		149,
		-1,
		-1,
		-1,
		-1,
		212,
		213,
		236,
		200,
		-1,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		215,
		213,
		-1,
		-1,
		-1,
		172,
		156,
		-1,
		142,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		177,
		-1,
		177,
		152,
		159,
		-1,
		-1,
		-1,
		-1,
		190,
		182,
		190,
		-1,
		162,
		164,
		-1,
		212,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		167,
		174,
		196,
		199,
		235,
		-1,
		186
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		222,
		226,
		192,
		186,
		225,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		215,
		214,
		182,
		180,
		189,
		194,
		201,
		-1,
		200,
		-1,
		236,
		215,
		226,
		231,
		175,
		172,
		192,
		211,
		193,
		185,
		251,
		205,
		176,
		170,
		188,
		178,
		187,
		179,
		-1,
		176,
		166,
		188,
		167,
		178,
		170,
		-1,
		-1,
		170,
		171,
		177,
		163,
		169,
		165,
		-1,
		175,
		159,
		-1,
		-1,
		160,
		161,
		145,
		148,
		156,
		154,
		167,
		159,
		154,
		-1,
		-1,
		151,
		147,
		154,
		141,
		137,
		154,
		167,
		149,
		163,
		162,
		-1,
		155,
		173,
		180,
		148,
		146,
		130,
		128,
		146,
		148,
		154,
		154,
		-1,
		164,
		165,
		160,
		168,
		170,
		146,
		133,
		133,
		143,
		136,
		155,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		136,
		133,
		131,
		128,
		144,
		142,
		152,
		-1,
		-1,
		257,
		226,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		122,
		121,
		149,
		135,
		146,
		217,
		-1,
		-1,
		215,
		207,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		116,
		126,
		130,
		128,
		153,
		-1,
		-1,
		188,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		113,
		138,
		142,
		123,
		144,
		139,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		117,
		115,
		145,
		120,
		142,
		139,
		158,
		163,
		157,
		166,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		109,
		124,
		115,
		114,
		132,
		142,
		150,
		154,
		160,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		214,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		122,
		104,
		118,
		109,
		127,
		134,
		132,
		136,
		156,
		168,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		115,
		100,
		97,
		115,
		118,
		125,
		129,
		145,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		125,
		104,
		99,
		96,
		116,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		109,
		114,
		94,
		92,
		111,
		123,
		114,
		131,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		105,
		113,
		108,
		90,
		99,
		105,
		129,
		119,
		125,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		107,
		97,
		92,
		99,
		134,
		134,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		103,
		101,
		102,
		84,
		116,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		108,
		97,
		110,
		103,
		89,
		91,
		104,
		108,
		112,
		99,
		95,
		92,
		106,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		120,
		111,
		119,
		92,
		85,
		92,
		81,
		99,
		107,
		99,
		93,
		92,
		102,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		121,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		103,
		103,
		87,
		88,
		91,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		123,
		129,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		97,
		83,
		81,
		89,
		87,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		134,
		124,
		129,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		89,
		84,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		150,
		130,
		122,
		129,
		121,
		113,
		107,
		85,
		78,
		75,
		68,
		81,
		91,
		96,
		82,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		150,
		138,
		128,
		118,
		123,
		124,
		104,
		97,
		83,
		85,
		79,
		70,
		69,
		85,
		77,
		86,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		178,
		152,
		139,
		-1,
		-1,
		122,
		115,
		109,
		100,
		87,
		99,
		94,
		78,
		63,
		78,
		82,
		76,
		68,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		190,
		135,
		124,
		119,
		123,
		121,
		-1,
		95,
		106,
		91,
		103,
		110,
		80,
		65,
		59,
		65,
		77,
		62,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		112,
		105,
		109,
		-1,
		97,
		99,
		93,
		108,
		83,
		80,
		71,
		62,
		58,
		62,
		66,
		47,
		53,
		212,
		-1,
		175,
		-1,
		-1,
		-1,
		165,
		180,
		151,
		128,
		101,
		96,
		89,
		83,
		88,
		99,
		91,
		102,
		69,
		65,
		55,
		54,
		58,
		51,
		41,
		-1,
		-1,
		173,
		169,
		191,
		173,
		177,
		178,
		-1,
		-1,
		105,
		96,
		87,
		79,
		92,
		95,
		75,
		72,
		66,
		59,
		53,
		63,
		40,
		35,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		176,
		123,
		105,
		101,
		99,
		88,
		82,
		70,
		75,
		76,
		67,
		61,
		49,
		47,
		54,
		27,
		58,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		138,
		135,
		-1,
		105,
		111,
		76,
		83,
		66,
		73,
		71,
		63,
		43,
		44,
		50,
		30,
		18,
		50,
		41,
		45,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		107,
		76,
		74,
		67,
		62,
		72,
		52,
		39,
		37,
		34,
		27,
		20,
		15,
		21,
		36,
		51,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		82,
		77,
		68,
		48,
		54,
		32,
		39,
		50,
		39,
		0,
		33,
		34,
		45,
		49,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		97,
		92,
		76,
		74,
		65,
		56,
		56,
		40,
		28,
		25,
		31,
		16,
		16,
		40,
		39,
		45,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		139,
		-1,
		122,
		126,
		105,
		108,
		90,
		77,
		69,
		56,
		65,
		40,
		36,
		32,
		21,
		30,
		26,
		33,
		47,
		45,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		136,
		118,
		110,
		110,
		89,
		89,
		63,
		59,
		45,
		41,
		48,
		38,
		30,
		34,
		43,
		38,
		53,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		196,
		185,
		180,
		167,
		-1,
		-1,
		159,
		128,
		-1,
		-1,
		96,
		84,
		67,
		56,
		52,
		55,
		63,
		47,
		37,
		35,
		29,
		43,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		200,
		225,
		-1,
		156,
		-1,
		-1,
		140,
		-1,
		-1,
		125,
		89,
		78,
		69,
		67,
		60,
		67,
		78,
		43,
		44,
		34,
		44,
		57,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		123,
		121,
		110,
		-1,
		100,
		74,
		68,
		87,
		63,
		52,
		46,
		40,
		47,
		46,
		54,
		62,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		118,
		111,
		99,
		87,
		77,
		82,
		68,
		64,
		50,
		43,
		38,
		49,
		41,
		45,
		62,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		152,
		136,
		117,
		-1,
		87,
		100,
		100,
		68,
		68,
		62,
		44,
		55,
		44,
		47,
		61,
		56,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		124,
		120,
		-1,
		-1,
		88,
		82,
		71,
		74,
		69,
		48,
		54,
		57,
		46,
		50,
		62,
		-1,
		-1,
		174,
		175,
		176,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		126,
		89,
		110,
		89,
		77,
		75,
		66,
		52,
		59,
		57,
		53,
		64,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		89,
		90,
		103,
		85,
		88,
		82,
		55,
		70,
		60,
		51,
		60,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		93,
		-1,
		121,
		110,
		104,
		89,
		70,
		57,
		64,
		64,
		57,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		100,
		94,
		90,
		77,
		77,
		69,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		104,
		102,
		99,
		96,
		87,
		93,
		70,
		105,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		94,
		82,
		77,
		78,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		93,
		82,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		221,
		210,
		221,
		229,
		202,
		209,
		-1,
		228,
		232,
		198,
		192,
		231,
		200,
		206,
		217,
		-1,
		-1,
		-1,
		221,
		220,
		188,
		186,
		195,
		200,
		207,
		-1,
		206,
		-1,
		242,
		221,
		232,
		237,
		181,
		178,
		198,
		217,
		199,
		191,
		257,
		211,
		182,
		176,
		194,
		184,
		193,
		185,
		-1,
		182,
		172,
		194,
		173,
		184,
		176,
		-1,
		-1,
		176,
		177,
		183,
		169,
		175,
		171,
		-1,
		181,
		165,
		-1,
		-1,
		166,
		167,
		151,
		154,
		162,
		160,
		173,
		165,
		160,
		-1,
		-1,
		157,
		153,
		160,
		147,
		143,
		160,
		173,
		155,
		169,
		168,
		-1,
		161,
		179,
		186,
		154,
		152,
		136,
		134,
		152,
		154,
		160,
		160,
		-1,
		170,
		171,
		166,
		174,
		176,
		152,
		139,
		139,
		149,
		142,
		161,
		149,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		170,
		153,
		170,
		162,
		152,
		167,
		160,
		142,
		139,
		137,
		134,
		150,
		148,
		158,
		-1,
		-1,
		263,
		232,
		261,
		219,
		200,
		-1,
		166,
		146,
		152,
		156,
		150,
		143,
		157,
		153,
		-1,
		128,
		127,
		155,
		141,
		152,
		223,
		-1,
		-1,
		221,
		213,
		196,
		199,
		176,
		172,
		161,
		160,
		152,
		138,
		134,
		140,
		143,
		143,
		149,
		122,
		132,
		136,
		134,
		159,
		-1,
		-1,
		194,
		-1,
		-1,
		220,
		203,
		-1,
		186,
		193,
		182,
		188,
		174,
		195,
		171,
		162,
		154,
		148,
		136,
		138,
		135,
		148,
		136,
		119,
		144,
		148,
		129,
		150,
		145,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		179,
		182,
		188,
		212,
		211,
		-1,
		183,
		171,
		172,
		157,
		154,
		141,
		129,
		142,
		127,
		134,
		133,
		123,
		121,
		151,
		126,
		148,
		145,
		164,
		169,
		163,
		172,
		-1,
		228,
		224,
		220,
		227,
		176,
		-1,
		-1,
		216,
		-1,
		219,
		220,
		195,
		168,
		171,
		158,
		149,
		136,
		125,
		136,
		125,
		122,
		130,
		115,
		130,
		121,
		120,
		138,
		148,
		156,
		160,
		166,
		-1,
		278,
		-1,
		220,
		204,
		206,
		178,
		199,
		-1,
		236,
		220,
		212,
		197,
		197,
		-1,
		167,
		164,
		154,
		132,
		117,
		134,
		126,
		124,
		128,
		110,
		124,
		115,
		133,
		140,
		138,
		142,
		162,
		174,
		238,
		228,
		-1,
		210,
		215,
		174,
		182,
		201,
		239,
		203,
		-1,
		198,
		-1,
		169,
		182,
		-1,
		138,
		134,
		116,
		117,
		112,
		127,
		121,
		106,
		103,
		121,
		124,
		131,
		135,
		151,
		-1,
		-1,
		223,
		227,
		216,
		167,
		186,
		210,
		247,
		196,
		185,
		184,
		-1,
		175,
		152,
		149,
		137,
		124,
		109,
		110,
		118,
		131,
		110,
		105,
		102,
		122,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		193,
		164,
		188,
		230,
		214,
		207,
		195,
		160,
		160,
		154,
		-1,
		148,
		127,
		118,
		107,
		105,
		118,
		115,
		120,
		100,
		98,
		117,
		129,
		120,
		133,
		-1,
		-1,
		-1,
		223,
		212,
		213,
		159,
		182,
		219,
		193,
		179,
		184,
		159,
		152,
		146,
		161,
		144,
		125,
		114,
		106,
		95,
		111,
		119,
		114,
		96,
		105,
		111,
		135,
		121,
		127,
		-1,
		-1,
		230,
		220,
		204,
		206,
		203,
		173,
		180,
		212,
		184,
		197,
		-1,
		151,
		-1,
		140,
		135,
		119,
		114,
		111,
		108,
		102,
		111,
		113,
		103,
		98,
		105,
		140,
		140,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		223,
		218,
		193,
		170,
		154,
		190,
		-1,
		167,
		168,
		-1,
		145,
		139,
		136,
		121,
		117,
		112,
		116,
		109,
		116,
		109,
		107,
		108,
		90,
		122,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		216,
		195,
		188,
		208,
		149,
		201,
		-1,
		-1,
		152,
		145,
		-1,
		132,
		114,
		121,
		119,
		113,
		117,
		114,
		103,
		116,
		109,
		95,
		97,
		110,
		114,
		118,
		101,
		97,
		94,
		97,
		-1,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		169,
		-1,
		161,
		153,
		143,
		137,
		131,
		127,
		125,
		141,
		125,
		128,
		126,
		117,
		125,
		98,
		91,
		98,
		87,
		105,
		113,
		105,
		99,
		92,
		93,
		-1,
		236,
		222,
		193,
		-1,
		-1,
		182,
		-1,
		146,
		160,
		176,
		-1,
		169,
		148,
		163,
		141,
		137,
		133,
		148,
		149,
		127,
		126,
		124,
		115,
		103,
		92,
		95,
		87,
		109,
		109,
		93,
		94,
		88,
		-1,
		242,
		229,
		187,
		183,
		172,
		192,
		143,
		131,
		163,
		-1,
		-1,
		205,
		-1,
		139,
		156,
		147,
		145,
		138,
		129,
		135,
		135,
		112,
		107,
		97,
		86,
		86,
		81,
		103,
		89,
		87,
		86,
		78,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		158,
		145,
		139,
		-1,
		180,
		-1,
		183,
		173,
		157,
		142,
		175,
		-1,
		140,
		130,
		135,
		-1,
		132,
		-1,
		105,
		102,
		93,
		78,
		75,
		86,
		84,
		95,
		87,
		-1,
		192,
		177,
		170,
		160,
		174,
		145,
		-1,
		200,
		-1,
		-1,
		170,
		164,
		164,
		148,
		151,
		156,
		136,
		128,
		135,
		127,
		119,
		113,
		91,
		84,
		81,
		74,
		87,
		97,
		101,
		85,
		-1,
		-1,
		-1,
		197,
		183,
		187,
		147,
		166,
		-1,
		-1,
		232,
		187,
		173,
		-1,
		157,
		156,
		144,
		134,
		124,
		129,
		130,
		110,
		103,
		89,
		91,
		85,
		76,
		75,
		91,
		83,
		89,
		-1,
		-1,
		180,
		185,
		173,
		159,
		178,
		-1,
		-1,
		-1,
		179,
		195,
		184,
		158,
		145,
		-1,
		-1,
		128,
		121,
		115,
		106,
		93,
		105,
		100,
		84,
		69,
		84,
		87,
		79,
		71,
		-1,
		183,
		170,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		97,
		109,
		116,
		86,
		71,
		65,
		71,
		82,
		65,
		-1,
		-1,
		195,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		99,
		114,
		89,
		86,
		77,
		68,
		64,
		68,
		69,
		50,
		56,
		218,
		-1,
		181,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		97,
		108,
		75,
		71,
		61,
		60,
		64,
		54,
		48,
		-1,
		-1,
		179,
		175,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		81,
		78,
		72,
		65,
		59,
		69,
		47,
		42,
		-1,
		-1,
		-1,
		191,
		-1,
		193,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		94,
		88,
		76,
		81,
		82,
		73,
		67,
		55,
		54,
		61,
		34,
		44,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		170,
		162,
		157,
		163,
		165,
		156,
		144,
		141,
		-1,
		111,
		117,
		82,
		89,
		72,
		79,
		77,
		69,
		49,
		51,
		57,
		37,
		25,
		36,
		27,
		31,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		163,
		159,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		80,
		73,
		68,
		78,
		58,
		45,
		44,
		40,
		34,
		27,
		22,
		15,
		22,
		37,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		153,
		145,
		156,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		88,
		83,
		74,
		54,
		60,
		38,
		45,
		56,
		48,
		34,
		0,
		20,
		31,
		35,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		150,
		-1,
		-1,
		162,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		82,
		80,
		71,
		62,
		62,
		46,
		34,
		31,
		40,
		30,
		20,
		20,
		25,
		31,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		178,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		96,
		83,
		75,
		62,
		71,
		46,
		42,
		38,
		27,
		36,
		30,
		29,
		27,
		31,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		162,
		201,
		195,
		-1,
		179,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		116,
		95,
		95,
		69,
		65,
		51,
		47,
		54,
		44,
		36,
		40,
		35,
		34,
		39,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		168,
		195,
		202,
		191,
		186,
		173,
		-1,
		-1,
		165,
		134,
		-1,
		-1,
		102,
		90,
		73,
		62,
		58,
		61,
		69,
		53,
		43,
		41,
		35,
		39,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		196,
		186,
		190,
		206,
		231,
		-1,
		162,
		-1,
		-1,
		146,
		-1,
		-1,
		131,
		95,
		84,
		75,
		73,
		66,
		73,
		84,
		49,
		50,
		40,
		50,
		53,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		178,
		158,
		-1,
		-1,
		129,
		127,
		116,
		-1,
		106,
		80,
		74,
		93,
		69,
		58,
		52,
		46,
		53,
		52,
		60,
		58,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		168,
		164,
		-1,
		-1,
		124,
		117,
		105,
		93,
		83,
		88,
		74,
		70,
		56,
		49,
		44,
		55,
		47,
		51,
		64,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		185,
		171,
		164,
		152,
		150,
		-1,
		158,
		142,
		123,
		-1,
		93,
		106,
		106,
		74,
		74,
		68,
		50,
		61,
		50,
		53,
		61,
		62,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		175,
		177,
		-1,
		176,
		165,
		150,
		142,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		94,
		88,
		77,
		80,
		75,
		54,
		60,
		63,
		52,
		56,
		61,
		-1,
		-1,
		180,
		181,
		182,
		-1,
		160,
		-1,
		178,
		-1,
		145,
		151,
		139,
		-1,
		-1,
		-1,
		132,
		95,
		116,
		95,
		83,
		81,
		72,
		58,
		65,
		63,
		59,
		70,
		-1,
		-1,
		-1,
		178,
		152,
		185,
		176,
		159,
		139,
		131,
		150,
		-1,
		120,
		-1,
		95,
		96,
		109,
		91,
		94,
		88,
		61,
		76,
		66,
		57,
		66,
		184,
		-1,
		154,
		187,
		151,
		145,
		121,
		125,
		141,
		-1,
		117,
		99,
		-1,
		127,
		116,
		110,
		95,
		76,
		63,
		70,
		70,
		63,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		126,
		117,
		-1,
		129,
		111,
		90,
		107,
		107,
		98,
		106,
		100,
		96,
		83,
		83,
		75,
		-1,
		257,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		145,
		118,
		106,
		112,
		108,
		94,
		100,
		102,
		110,
		108,
		105,
		102,
		93,
		99,
		76,
		111,
		-1,
		252,
		-1,
		186,
		-1,
		-1,
		168,
		148,
		140,
		129,
		118,
		116,
		107,
		98,
		120,
		136,
		100,
		88,
		83,
		84,
		-1,
		241,
		240,
		-1,
		187,
		179,
		165,
		-1,
		158,
		-1,
		164,
		125,
		-1,
		127,
		107,
		-1,
		99,
		88,
		-1,
		-1,
		228,
		203,
		-1,
		-1,
		-1,
		188,
		168,
		159,
		143,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		213,
		212,
		-1,
		181,
		184,
		-1,
		174,
		165,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		222,
		203,
		197,
		196,
		194,
		189,
		186,
		172,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		194,
		186,
		179,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		216,
		197,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		205,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		251,
		215,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		230,
		228,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		220,
		224,
		190,
		184,
		223,
		192,
		198,
		209,
		-1,
		-1,
		-1,
		213,
		212,
		180,
		178,
		187,
		192,
		199,
		-1,
		198,
		-1,
		234,
		213,
		224,
		229,
		173,
		170,
		190,
		209,
		191,
		183,
		249,
		203,
		174,
		168,
		186,
		176,
		185,
		177,
		-1,
		174,
		164,
		186,
		165,
		176,
		168,
		-1,
		-1,
		168,
		169,
		175,
		161,
		167,
		163,
		-1,
		173,
		157,
		-1,
		-1,
		158,
		159,
		143,
		146,
		154,
		152,
		165,
		157,
		152,
		-1,
		-1,
		149,
		145,
		152,
		139,
		135,
		152,
		165,
		147,
		161,
		160,
		-1,
		153,
		171,
		178,
		146,
		144,
		128,
		126,
		144,
		146,
		152,
		152,
		-1,
		162,
		163,
		158,
		166,
		168,
		144,
		131,
		131,
		141,
		134,
		153,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		134,
		131,
		129,
		126,
		142,
		140,
		150,
		-1,
		-1,
		255,
		224,
		253,
		211,
		192,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		120,
		119,
		147,
		133,
		144,
		215,
		-1,
		-1,
		213,
		205,
		188,
		191,
		168,
		164,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		114,
		124,
		128,
		126,
		151,
		-1,
		-1,
		186,
		-1,
		-1,
		212,
		195,
		-1,
		178,
		185,
		174,
		180,
		166,
		187,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		111,
		136,
		140,
		121,
		142,
		137,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		171,
		174,
		180,
		204,
		203,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		115,
		113,
		143,
		118,
		140,
		137,
		156,
		161,
		155,
		164,
		-1,
		220,
		216,
		212,
		219,
		168,
		-1,
		-1,
		208,
		-1,
		211,
		212,
		187,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		107,
		122,
		113,
		112,
		130,
		140,
		148,
		152,
		158,
		-1,
		270,
		-1,
		212,
		196,
		198,
		170,
		191,
		-1,
		228,
		212,
		204,
		189,
		189,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		120,
		102,
		116,
		107,
		125,
		132,
		130,
		134,
		154,
		166,
		230,
		220,
		-1,
		202,
		207,
		166,
		174,
		193,
		231,
		195,
		-1,
		190,
		-1,
		161,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		113,
		98,
		95,
		113,
		116,
		123,
		127,
		143,
		-1,
		-1,
		215,
		219,
		208,
		159,
		178,
		202,
		239,
		188,
		177,
		176,
		-1,
		167,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		123,
		102,
		97,
		94,
		114,
		140,
		118,
		129,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		185,
		156,
		180,
		222,
		206,
		199,
		187,
		152,
		152,
		146,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		107,
		112,
		92,
		90,
		109,
		121,
		112,
		120,
		-1,
		-1,
		-1,
		215,
		204,
		205,
		151,
		174,
		211,
		185,
		171,
		176,
		151,
		144,
		138,
		153,
		136,
		117,
		106,
		98,
		87,
		103,
		111,
		106,
		88,
		97,
		103,
		127,
		108,
		114,
		-1,
		-1,
		222,
		212,
		196,
		198,
		195,
		165,
		172,
		204,
		176,
		189,
		-1,
		143,
		-1,
		132,
		127,
		111,
		106,
		103,
		100,
		94,
		103,
		105,
		95,
		90,
		97,
		132,
		132,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		215,
		210,
		185,
		162,
		146,
		182,
		-1,
		159,
		160,
		-1,
		137,
		131,
		128,
		113,
		109,
		104,
		108,
		101,
		108,
		101,
		99,
		100,
		82,
		114,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		208,
		187,
		180,
		200,
		141,
		193,
		-1,
		-1,
		144,
		137,
		-1,
		124,
		106,
		113,
		111,
		105,
		109,
		106,
		95,
		108,
		101,
		87,
		89,
		102,
		106,
		110,
		88,
		84,
		81,
		84,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		161,
		-1,
		153,
		145,
		135,
		129,
		123,
		119,
		117,
		133,
		117,
		120,
		118,
		109,
		117,
		90,
		83,
		90,
		79,
		97,
		105,
		97,
		87,
		79,
		80,
		-1,
		228,
		214,
		185,
		-1,
		-1,
		174,
		-1,
		138,
		152,
		168,
		-1,
		161,
		140,
		155,
		133,
		129,
		125,
		140,
		141,
		119,
		118,
		116,
		107,
		95,
		84,
		87,
		79,
		101,
		101,
		85,
		82,
		75,
		-1,
		234,
		221,
		179,
		175,
		164,
		184,
		135,
		123,
		155,
		-1,
		-1,
		197,
		-1,
		131,
		148,
		139,
		137,
		130,
		121,
		127,
		127,
		104,
		99,
		89,
		78,
		78,
		73,
		95,
		81,
		79,
		73,
		65,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		150,
		137,
		131,
		-1,
		172,
		-1,
		175,
		165,
		149,
		134,
		167,
		-1,
		132,
		122,
		127,
		-1,
		124,
		-1,
		97,
		94,
		85,
		70,
		67,
		78,
		76,
		87,
		74,
		-1,
		184,
		169,
		162,
		152,
		166,
		137,
		-1,
		192,
		-1,
		-1,
		162,
		156,
		156,
		140,
		143,
		148,
		128,
		120,
		127,
		119,
		111,
		105,
		83,
		76,
		73,
		66,
		79,
		89,
		88,
		72,
		-1,
		-1,
		-1,
		189,
		175,
		179,
		139,
		158,
		-1,
		-1,
		224,
		179,
		165,
		-1,
		149,
		148,
		136,
		126,
		116,
		121,
		122,
		102,
		95,
		81,
		83,
		77,
		68,
		67,
		79,
		71,
		76,
		-1,
		-1,
		172,
		177,
		165,
		151,
		170,
		-1,
		-1,
		-1,
		171,
		187,
		176,
		150,
		137,
		-1,
		-1,
		120,
		113,
		107,
		98,
		85,
		97,
		92,
		76,
		61,
		76,
		74,
		66,
		58,
		-1,
		175,
		162,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		-1,
		-1,
		188,
		133,
		122,
		117,
		121,
		119,
		-1,
		93,
		104,
		89,
		101,
		108,
		78,
		63,
		57,
		59,
		69,
		52,
		-1,
		-1,
		187,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		145,
		139,
		110,
		103,
		107,
		-1,
		95,
		97,
		91,
		106,
		81,
		78,
		69,
		60,
		56,
		56,
		56,
		37,
		43,
		210,
		-1,
		173,
		-1,
		-1,
		-1,
		163,
		178,
		149,
		126,
		99,
		94,
		87,
		81,
		86,
		97,
		89,
		100,
		67,
		63,
		53,
		52,
		52,
		41,
		41,
		-1,
		-1,
		171,
		167,
		189,
		171,
		175,
		176,
		-1,
		-1,
		103,
		94,
		85,
		77,
		90,
		93,
		73,
		70,
		64,
		57,
		51,
		61,
		40,
		35,
		-1,
		-1,
		-1,
		183,
		-1,
		185,
		-1,
		-1,
		173,
		174,
		121,
		103,
		99,
		97,
		86,
		80,
		68,
		73,
		76,
		66,
		58,
		47,
		41,
		51,
		27,
		31,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		162,
		154,
		149,
		155,
		157,
		148,
		136,
		133,
		-1,
		103,
		109,
		74,
		81,
		64,
		71,
		70,
		62,
		41,
		38,
		44,
		30,
		18,
		23,
		14,
		22,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		155,
		151,
		141,
		131,
		134,
		-1,
		-1,
		128,
		125,
		105,
		74,
		72,
		65,
		60,
		70,
		50,
		37,
		31,
		35,
		21,
		20,
		15,
		8,
		13,
		28,
		-1,
		202,
		239,
		232,
		200,
		208,
		239,
		-1,
		145,
		137,
		148,
		123,
		125,
		-1,
		-1,
		101,
		92,
		93,
		81,
		78,
		80,
		75,
		66,
		51,
		57,
		35,
		33,
		50,
		35,
		28,
		11,
		0,
		13,
		17,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		142,
		-1,
		-1,
		154,
		126,
		110,
		100,
		97,
		140,
		95,
		90,
		74,
		72,
		63,
		54,
		59,
		43,
		31,
		28,
		37,
		23,
		13,
		10,
		10,
		11,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		170,
		-1,
		137,
		-1,
		120,
		124,
		103,
		106,
		88,
		75,
		67,
		59,
		68,
		43,
		39,
		35,
		24,
		33,
		23,
		31,
		17,
		18,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		154,
		193,
		187,
		-1,
		171,
		-1,
		-1,
		-1,
		134,
		116,
		108,
		108,
		87,
		87,
		61,
		62,
		48,
		44,
		51,
		41,
		33,
		37,
		39,
		27,
		26,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		169,
		160,
		187,
		194,
		183,
		178,
		165,
		-1,
		-1,
		157,
		126,
		-1,
		-1,
		94,
		82,
		65,
		59,
		55,
		58,
		66,
		50,
		40,
		38,
		32,
		32,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		167,
		188,
		178,
		182,
		198,
		223,
		-1,
		154,
		-1,
		-1,
		139,
		-1,
		-1,
		124,
		87,
		76,
		67,
		70,
		63,
		70,
		81,
		46,
		47,
		37,
		47,
		46,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		154,
		152,
		158,
		165,
		182,
		212,
		-1,
		-1,
		170,
		150,
		-1,
		-1,
		122,
		120,
		109,
		-1,
		99,
		72,
		71,
		90,
		66,
		55,
		49,
		43,
		50,
		49,
		57,
		51,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		117,
		110,
		98,
		86,
		76,
		85,
		71,
		67,
		53,
		46,
		41,
		52,
		44,
		48,
		48,
		-1,
		225,
		-1,
		177,
		153,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		151,
		135,
		116,
		-1,
		86,
		99,
		103,
		71,
		71,
		65,
		47,
		58,
		47,
		50,
		41,
		44,
		-1,
		-1,
		165,
		168,
		-1,
		-1,
		167,
		169,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		123,
		119,
		-1,
		-1,
		87,
		85,
		74,
		77,
		72,
		51,
		57,
		60,
		49,
		47,
		41,
		-1,
		-1,
		172,
		173,
		174,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		125,
		88,
		109,
		92,
		80,
		78,
		69,
		55,
		62,
		60,
		56,
		51,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		87,
		89,
		106,
		88,
		91,
		85,
		58,
		73,
		63,
		54,
		57,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		91,
		-1,
		119,
		109,
		107,
		92,
		73,
		60,
		67,
		61,
		54,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		99,
		90,
		98,
		97,
		93,
		80,
		80,
		70,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		102,
		100,
		97,
		95,
		86,
		92,
		69,
		102,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		128,
		93,
		81,
		76,
		77,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		92,
		81,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		144,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		135,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		123,
		129,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		113,
		133,
		136,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		121,
		115,
		123,
		113,
		101,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		103,
		99,
		96,
		99,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		102,
		94,
		95,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		134,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		97,
		90,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		136,
		142,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		88,
		80,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		147,
		137,
		142,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		89,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		158,
		163,
		143,
		135,
		142,
		134,
		126,
		120,
		98,
		91,
		88,
		81,
		94,
		104,
		103,
		87,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		164,
		163,
		151,
		141,
		131,
		136,
		137,
		117,
		110,
		96,
		98,
		92,
		83,
		82,
		94,
		86,
		91,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		191,
		165,
		152,
		-1,
		-1,
		135,
		128,
		122,
		113,
		100,
		112,
		107,
		91,
		76,
		91,
		89,
		81,
		73,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		203,
		148,
		137,
		132,
		136,
		134,
		-1,
		108,
		119,
		104,
		116,
		123,
		93,
		78,
		72,
		74,
		84,
		67,
		-1,
		-1,
		202,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		160,
		154,
		125,
		118,
		122,
		-1,
		110,
		112,
		106,
		121,
		96,
		93,
		84,
		75,
		71,
		71,
		71,
		52,
		58,
		225,
		-1,
		188,
		-1,
		-1,
		-1,
		178,
		193,
		164,
		141,
		114,
		109,
		102,
		96,
		101,
		112,
		104,
		115,
		82,
		78,
		68,
		67,
		67,
		56,
		56,
		-1,
		-1,
		186,
		182,
		204,
		186,
		190,
		191,
		-1,
		-1,
		118,
		109,
		100,
		92,
		105,
		108,
		88,
		85,
		79,
		72,
		66,
		76,
		55,
		50,
		-1,
		-1,
		-1,
		198,
		-1,
		200,
		-1,
		-1,
		188,
		189,
		136,
		118,
		114,
		112,
		101,
		95,
		83,
		88,
		91,
		81,
		73,
		62,
		56,
		66,
		42,
		46,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		177,
		169,
		164,
		170,
		172,
		163,
		151,
		148,
		-1,
		118,
		124,
		89,
		96,
		79,
		86,
		85,
		77,
		56,
		53,
		59,
		45,
		33,
		38,
		29,
		37,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		170,
		166,
		156,
		146,
		149,
		-1,
		-1,
		143,
		140,
		120,
		89,
		87,
		80,
		75,
		85,
		65,
		52,
		46,
		50,
		36,
		35,
		30,
		23,
		28,
		43,
		-1,
		217,
		254,
		247,
		215,
		223,
		254,
		-1,
		160,
		152,
		163,
		138,
		140,
		-1,
		-1,
		116,
		107,
		108,
		96,
		93,
		95,
		90,
		81,
		66,
		72,
		50,
		48,
		65,
		50,
		43,
		26,
		15,
		0,
		4,
		-1,
		210,
		230,
		209,
		212,
		236,
		250,
		-1,
		157,
		-1,
		-1,
		169,
		141,
		125,
		115,
		112,
		155,
		110,
		105,
		89,
		87,
		78,
		69,
		74,
		58,
		46,
		43,
		52,
		38,
		28,
		25,
		23,
		26,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		185,
		-1,
		152,
		-1,
		135,
		139,
		118,
		121,
		103,
		90,
		82,
		74,
		83,
		58,
		54,
		50,
		39,
		48,
		38,
		46,
		32,
		31,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		169,
		208,
		202,
		-1,
		186,
		-1,
		-1,
		-1,
		149,
		131,
		123,
		123,
		102,
		102,
		76,
		77,
		63,
		59,
		66,
		56,
		48,
		52,
		54,
		42,
		39,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		184,
		175,
		202,
		209,
		198,
		193,
		180,
		-1,
		-1,
		172,
		141,
		-1,
		-1,
		109,
		97,
		80,
		74,
		70,
		73,
		81,
		65,
		55,
		53,
		47,
		47,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		203,
		193,
		197,
		213,
		238,
		-1,
		169,
		-1,
		-1,
		154,
		-1,
		-1,
		139,
		102,
		91,
		82,
		85,
		78,
		85,
		96,
		61,
		62,
		52,
		62,
		61,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		197,
		227,
		-1,
		-1,
		185,
		165,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		87,
		86,
		105,
		81,
		70,
		64,
		58,
		65,
		64,
		72,
		66,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		171,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		100,
		86,
		82,
		68,
		61,
		56,
		67,
		59,
		63,
		63,
		-1,
		240,
		-1,
		192,
		168,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		118,
		86,
		86,
		80,
		62,
		73,
		62,
		65,
		56,
		59,
		-1,
		-1,
		180,
		183,
		-1,
		-1,
		182,
		184,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		102,
		100,
		89,
		92,
		87,
		66,
		72,
		75,
		64,
		62,
		56,
		-1,
		-1,
		187,
		188,
		189,
		-1,
		167,
		-1,
		185,
		-1,
		152,
		158,
		146,
		-1,
		-1,
		-1,
		140,
		103,
		124,
		107,
		95,
		93,
		84,
		70,
		77,
		75,
		71,
		66,
		-1,
		-1,
		-1,
		185,
		159,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		127,
		-1,
		102,
		104,
		121,
		103,
		106,
		100,
		73,
		88,
		78,
		69,
		72,
		191,
		-1,
		161,
		194,
		158,
		152,
		128,
		132,
		148,
		-1,
		124,
		106,
		-1,
		134,
		124,
		122,
		107,
		88,
		75,
		82,
		76,
		69,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		136,
		118,
		97,
		114,
		114,
		105,
		113,
		112,
		108,
		95,
		95,
		85,
		-1,
		264,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		152,
		125,
		113,
		119,
		115,
		101,
		107,
		109,
		117,
		115,
		112,
		110,
		101,
		107,
		84,
		117,
		-1,
		259,
		-1,
		193,
		-1,
		-1,
		175,
		155,
		147,
		136,
		125,
		123,
		114,
		105,
		127,
		143,
		108,
		96,
		91,
		92,
		-1,
		248,
		247,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		171,
		132,
		-1,
		134,
		114,
		-1,
		107,
		96,
		-1,
		-1,
		235,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		166,
		150,
		-1,
		125,
		125,
		-1,
		-1,
		-1,
		220,
		219,
		-1,
		188,
		191,
		-1,
		181,
		172,
		180,
		127,
		131,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		203,
		201,
		196,
		193,
		179,
		163,
		141,
		130,
		151,
		-1,
		-1,
		-1,
		201,
		193,
		186,
		-1,
		-1,
		188,
		171,
		152,
		150,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		178,
		-1,
		-1,
		184,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		212,
		-1,
		-1,
		-1,
		174,
		170,
		171,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		258,
		222,
		-1,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		237,
		235,
		-1,
		-1,
		-1,
		194,
		178,
		-1,
		164,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		199,
		-1,
		199,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		212,
		204,
		212,
		-1,
		184,
		186,
		-1,
		234,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		189,
		196,
		218,
		221,
		257,
		-1,
		208
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		144,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		135,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		123,
		129,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		113,
		133,
		136,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		121,
		115,
		123,
		113,
		101,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		103,
		99,
		96,
		99,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		102,
		94,
		95,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		134,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		97,
		90,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		136,
		142,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		88,
		80,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		147,
		137,
		142,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		89,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		158,
		163,
		143,
		135,
		142,
		134,
		126,
		120,
		98,
		91,
		88,
		81,
		94,
		104,
		103,
		87,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		164,
		163,
		151,
		141,
		131,
		136,
		137,
		117,
		110,
		96,
		98,
		92,
		83,
		82,
		94,
		86,
		91,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		191,
		165,
		152,
		-1,
		-1,
		135,
		128,
		122,
		113,
		100,
		112,
		107,
		91,
		76,
		91,
		89,
		81,
		73,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		203,
		148,
		137,
		132,
		136,
		134,
		-1,
		108,
		119,
		104,
		116,
		123,
		93,
		78,
		72,
		74,
		84,
		67,
		-1,
		-1,
		202,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		160,
		154,
		125,
		118,
		122,
		-1,
		110,
		112,
		106,
		121,
		96,
		93,
		84,
		75,
		71,
		71,
		71,
		52,
		58,
		225,
		-1,
		188,
		-1,
		-1,
		-1,
		178,
		193,
		164,
		141,
		114,
		109,
		102,
		96,
		101,
		112,
		104,
		115,
		82,
		78,
		68,
		67,
		67,
		56,
		56,
		-1,
		-1,
		186,
		182,
		204,
		186,
		190,
		191,
		-1,
		-1,
		118,
		109,
		100,
		92,
		105,
		108,
		88,
		85,
		79,
		72,
		66,
		76,
		55,
		50,
		-1,
		-1,
		-1,
		198,
		-1,
		200,
		-1,
		-1,
		188,
		189,
		136,
		118,
		114,
		112,
		101,
		95,
		83,
		88,
		91,
		81,
		73,
		62,
		56,
		66,
		42,
		46,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		177,
		169,
		164,
		170,
		172,
		163,
		151,
		148,
		-1,
		118,
		124,
		89,
		96,
		79,
		86,
		85,
		77,
		56,
		53,
		59,
		45,
		33,
		38,
		29,
		37,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		170,
		166,
		156,
		146,
		149,
		-1,
		-1,
		143,
		140,
		120,
		89,
		87,
		80,
		75,
		85,
		65,
		52,
		46,
		50,
		36,
		35,
		30,
		23,
		28,
		43,
		-1,
		217,
		254,
		247,
		215,
		223,
		254,
		-1,
		160,
		152,
		163,
		138,
		140,
		-1,
		-1,
		116,
		107,
		108,
		96,
		93,
		95,
		90,
		81,
		66,
		72,
		50,
		48,
		65,
		50,
		43,
		26,
		15,
		4,
		0,
		-1,
		210,
		230,
		209,
		212,
		236,
		250,
		-1,
		157,
		-1,
		-1,
		169,
		141,
		125,
		115,
		112,
		155,
		110,
		105,
		89,
		87,
		78,
		69,
		74,
		58,
		46,
		43,
		52,
		38,
		28,
		25,
		23,
		26,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		185,
		-1,
		152,
		-1,
		135,
		139,
		118,
		121,
		103,
		90,
		82,
		74,
		83,
		58,
		54,
		50,
		39,
		48,
		38,
		46,
		32,
		31,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		169,
		208,
		202,
		-1,
		186,
		-1,
		-1,
		-1,
		149,
		131,
		123,
		123,
		102,
		102,
		76,
		77,
		63,
		59,
		66,
		56,
		48,
		52,
		54,
		42,
		39,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		184,
		175,
		202,
		209,
		198,
		193,
		180,
		-1,
		-1,
		172,
		141,
		-1,
		-1,
		109,
		97,
		80,
		74,
		70,
		73,
		81,
		65,
		55,
		53,
		47,
		47,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		203,
		193,
		197,
		213,
		238,
		-1,
		169,
		-1,
		-1,
		154,
		-1,
		-1,
		139,
		102,
		91,
		82,
		85,
		78,
		85,
		96,
		61,
		62,
		52,
		62,
		61,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		197,
		227,
		-1,
		-1,
		185,
		165,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		87,
		86,
		105,
		81,
		70,
		64,
		58,
		65,
		64,
		72,
		66,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		171,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		100,
		86,
		82,
		68,
		61,
		56,
		67,
		59,
		63,
		63,
		-1,
		240,
		-1,
		192,
		168,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		118,
		86,
		86,
		80,
		62,
		73,
		62,
		65,
		56,
		59,
		-1,
		-1,
		180,
		183,
		-1,
		-1,
		182,
		184,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		102,
		100,
		89,
		92,
		87,
		66,
		72,
		75,
		64,
		62,
		56,
		-1,
		-1,
		187,
		188,
		189,
		-1,
		167,
		-1,
		185,
		-1,
		152,
		158,
		146,
		-1,
		-1,
		-1,
		140,
		103,
		124,
		107,
		95,
		93,
		84,
		70,
		77,
		75,
		71,
		66,
		-1,
		-1,
		-1,
		185,
		159,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		127,
		-1,
		102,
		104,
		121,
		103,
		106,
		100,
		73,
		88,
		78,
		69,
		72,
		191,
		-1,
		161,
		194,
		158,
		152,
		128,
		132,
		148,
		-1,
		124,
		106,
		-1,
		134,
		124,
		122,
		107,
		88,
		75,
		82,
		76,
		69,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		136,
		118,
		97,
		114,
		114,
		105,
		113,
		112,
		108,
		95,
		95,
		85,
		-1,
		264,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		152,
		125,
		113,
		119,
		115,
		101,
		107,
		109,
		117,
		115,
		112,
		110,
		101,
		107,
		84,
		117,
		-1,
		259,
		-1,
		193,
		-1,
		-1,
		175,
		155,
		147,
		136,
		125,
		123,
		114,
		105,
		127,
		143,
		108,
		96,
		91,
		92,
		-1,
		248,
		247,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		171,
		132,
		-1,
		134,
		114,
		-1,
		107,
		96,
		-1,
		-1,
		235,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		166,
		150,
		-1,
		125,
		125,
		-1,
		-1,
		-1,
		220,
		219,
		-1,
		188,
		191,
		-1,
		181,
		172,
		180,
		127,
		131,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		203,
		201,
		196,
		193,
		179,
		163,
		141,
		130,
		151,
		-1,
		-1,
		-1,
		201,
		193,
		186,
		-1,
		-1,
		188,
		171,
		152,
		150,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		178,
		-1,
		-1,
		184,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		212,
		-1,
		-1,
		-1,
		174,
		170,
		171,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		258,
		222,
		-1,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		237,
		235,
		-1,
		-1,
		-1,
		194,
		178,
		-1,
		164,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		199,
		-1,
		199,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		212,
		204,
		212,
		-1,
		184,
		186,
		-1,
		234,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		189,
		196,
		218,
		221,
		257,
		-1,
		208
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		250,
		252,
		218,
		212,
		251,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		241,
		240,
		210,
		208,
		217,
		222,
		229,
		-1,
		252,
		-1,
		262,
		241,
		252,
		257,
		203,
		200,
		220,
		239,
		245,
		237,
		277,
		233,
		204,
		198,
		216,
		221,
		239,
		231,
		-1,
		204,
		194,
		216,
		220,
		232,
		215,
		-1,
		-1,
		198,
		199,
		205,
		217,
		222,
		227,
		-1,
		253,
		237,
		-1,
		-1,
		188,
		201,
		197,
		200,
		208,
		224,
		245,
		237,
		232,
		-1,
		-1,
		189,
		193,
		206,
		207,
		205,
		232,
		245,
		227,
		241,
		240,
		-1,
		177,
		195,
		204,
		213,
		219,
		208,
		206,
		224,
		226,
		232,
		235,
		-1,
		169,
		171,
		200,
		206,
		218,
		224,
		211,
		211,
		221,
		214,
		233,
		224,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		166,
		174,
		200,
		199,
		195,
		213,
		221,
		214,
		211,
		209,
		206,
		222,
		223,
		233,
		-1,
		-1,
		222,
		191,
		226,
		183,
		168,
		-1,
		162,
		181,
		187,
		191,
		196,
		204,
		218,
		214,
		-1,
		200,
		199,
		230,
		216,
		227,
		182,
		-1,
		-1,
		180,
		172,
		157,
		160,
		157,
		157,
		187,
		186,
		191,
		193,
		195,
		201,
		204,
		204,
		210,
		194,
		204,
		208,
		219,
		234,
		-1,
		-1,
		289,
		-1,
		-1,
		179,
		162,
		-1,
		145,
		152,
		152,
		169,
		159,
		180,
		195,
		199,
		207,
		209,
		197,
		199,
		196,
		209,
		197,
		191,
		216,
		220,
		214,
		235,
		230,
		-1,
		288,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		138,
		141,
		147,
		171,
		181,
		-1,
		202,
		200,
		224,
		218,
		215,
		202,
		190,
		203,
		188,
		195,
		194,
		198,
		200,
		233,
		211,
		233,
		230,
		259,
		264,
		258,
		267,
		-1,
		187,
		183,
		179,
		186,
		135,
		-1,
		-1,
		175,
		-1,
		189,
		202,
		209,
		204,
		207,
		219,
		210,
		197,
		186,
		197,
		186,
		183,
		191,
		200,
		211,
		206,
		205,
		223,
		238,
		251,
		255,
		261,
		-1,
		237,
		-1,
		179,
		163,
		165,
		137,
		158,
		-1,
		195,
		190,
		210,
		211,
		202,
		-1,
		205,
		208,
		215,
		193,
		178,
		195,
		187,
		185,
		190,
		195,
		209,
		200,
		218,
		225,
		233,
		237,
		257,
		269,
		197,
		187,
		-1,
		169,
		174,
		133,
		141,
		160,
		233,
		208,
		-1,
		203,
		-1,
		195,
		220,
		-1,
		199,
		195,
		177,
		178,
		173,
		188,
		194,
		191,
		188,
		206,
		209,
		226,
		230,
		246,
		-1,
		-1,
		182,
		186,
		175,
		126,
		145,
		169,
		206,
		201,
		190,
		189,
		-1,
		180,
		210,
		207,
		193,
		180,
		170,
		171,
		179,
		192,
		171,
		190,
		193,
		215,
		243,
		221,
		233,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		152,
		123,
		147,
		189,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		200,
		183,
		179,
		168,
		166,
		179,
		174,
		190,
		194,
		193,
		212,
		224,
		215,
		235,
		-1,
		-1,
		-1,
		182,
		171,
		172,
		121,
		144,
		178,
		198,
		184,
		189,
		164,
		157,
		151,
		203,
		200,
		167,
		175,
		167,
		156,
		170,
		178,
		182,
		191,
		200,
		206,
		230,
		230,
		236,
		-1,
		-1,
		189,
		179,
		163,
		165,
		162,
		135,
		142,
		174,
		189,
		186,
		-1,
		156,
		-1,
		145,
		153,
		152,
		158,
		170,
		156,
		161,
		172,
		184,
		197,
		193,
		200,
		235,
		235,
		220,
		240,
		243,
		-1,
		-1,
		-1,
		182,
		180,
		155,
		132,
		116,
		152,
		-1,
		156,
		157,
		-1,
		150,
		144,
		150,
		149,
		156,
		153,
		153,
		167,
		175,
		171,
		187,
		193,
		185,
		221,
		-1,
		228,
		222,
		230,
		220,
		208,
		-1,
		-1,
		-1,
		178,
		157,
		150,
		170,
		111,
		163,
		-1,
		-1,
		141,
		134,
		-1,
		137,
		137,
		144,
		153,
		158,
		163,
		171,
		166,
		179,
		184,
		190,
		195,
		213,
		217,
		221,
		210,
		206,
		203,
		217,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		111,
		131,
		-1,
		144,
		136,
		132,
		126,
		132,
		150,
		148,
		168,
		160,
		174,
		174,
		180,
		188,
		173,
		176,
		192,
		190,
		208,
		216,
		208,
		202,
		201,
		213,
		-1,
		198,
		184,
		155,
		-1,
		-1,
		144,
		-1,
		108,
		122,
		138,
		-1,
		166,
		145,
		168,
		146,
		160,
		156,
		194,
		195,
		173,
		178,
		186,
		196,
		198,
		187,
		198,
		190,
		212,
		212,
		196,
		197,
		206,
		-1,
		204,
		191,
		149,
		145,
		134,
		154,
		105,
		114,
		125,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		170,
		168,
		184,
		175,
		181,
		197,
		200,
		202,
		192,
		181,
		187,
		184,
		206,
		192,
		190,
		209,
		225,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		120,
		107,
		101,
		-1,
		142,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		192,
		176,
		181,
		-1,
		227,
		-1,
		200,
		202,
		195,
		181,
		178,
		189,
		187,
		198,
		206,
		-1,
		154,
		139,
		132,
		122,
		136,
		107,
		-1,
		150,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		208,
		188,
		182,
		181,
		212,
		199,
		198,
		186,
		186,
		184,
		181,
		194,
		206,
		205,
		204,
		-1,
		-1,
		-1,
		159,
		111,
		119,
		95,
		116,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		162,
		225,
		213,
		203,
		193,
		199,
		200,
		190,
		188,
		184,
		193,
		192,
		185,
		184,
		205,
		198,
		220,
		-1,
		-1,
		108,
		121,
		123,
		109,
		128,
		-1,
		-1,
		-1,
		184,
		200,
		192,
		163,
		214,
		-1,
		-1,
		198,
		191,
		185,
		188,
		176,
		196,
		203,
		191,
		178,
		193,
		203,
		211,
		210,
		-1,
		111,
		98,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		-1,
		-1,
		217,
		183,
		193,
		188,
		192,
		197,
		-1,
		171,
		182,
		175,
		194,
		201,
		193,
		178,
		172,
		183,
		198,
		215,
		-1,
		-1,
		145,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		174,
		188,
		181,
		174,
		178,
		-1,
		173,
		175,
		172,
		184,
		189,
		193,
		184,
		166,
		180,
		183,
		196,
		210,
		214,
		168,
		-1,
		151,
		-1,
		-1,
		-1,
		192,
		207,
		214,
		191,
		170,
		163,
		160,
		159,
		164,
		175,
		184,
		195,
		160,
		164,
		179,
		184,
		188,
		205,
		209,
		-1,
		-1,
		151,
		168,
		203,
		200,
		201,
		241,
		-1,
		-1,
		159,
		152,
		162,
		155,
		168,
		171,
		156,
		158,
		176,
		189,
		183,
		193,
		208,
		203,
		-1,
		-1,
		-1,
		171,
		-1,
		186,
		-1,
		-1,
		191,
		232,
		179,
		161,
		157,
		143,
		150,
		144,
		146,
		151,
		170,
		165,
		174,
		179,
		183,
		206,
		195,
		234,
		-1,
		-1,
		102,
		-1,
		-1,
		-1,
		150,
		169,
		164,
		170,
		175,
		166,
		194,
		191,
		-1,
		140,
		173,
		141,
		155,
		151,
		158,
		163,
		169,
		173,
		180,
		196,
		195,
		190,
		226,
		217,
		223,
		-1,
		-1,
		95,
		84,
		73,
		79,
		-1,
		143,
		166,
		156,
		146,
		152,
		-1,
		-1,
		158,
		155,
		153,
		133,
		139,
		144,
		147,
		185,
		161,
		169,
		173,
		177,
		183,
		188,
		193,
		199,
		214,
		229,
		-1,
		11,
		71,
		64,
		47,
		55,
		86,
		-1,
		133,
		125,
		153,
		138,
		146,
		-1,
		-1,
		131,
		122,
		127,
		136,
		137,
		168,
		167,
		180,
		183,
		188,
		176,
		175,
		193,
		197,
		206,
		213,
		203,
		216,
		220,
		-1,
		0,
		47,
		41,
		44,
		68,
		82,
		-1,
		124,
		-1,
		-1,
		169,
		156,
		140,
		130,
		127,
		174,
		150,
		145,
		151,
		153,
		177,
		168,
		193,
		184,
		184,
		187,
		202,
		207,
		199,
		213,
		213,
		214,
		-1,
		39,
		27,
		35,
		-1,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		185,
		-1,
		167,
		-1,
		150,
		154,
		158,
		161,
		176,
		163,
		170,
		187,
		193,
		182,
		192,
		188,
		189,
		198,
		209,
		221,
		220,
		221,
		113,
		68,
		35,
		26,
		73,
		88,
		92,
		-1,
		108,
		144,
		154,
		-1,
		194,
		-1,
		-1,
		-1,
		164,
		171,
		163,
		179,
		175,
		175,
		171,
		175,
		187,
		194,
		204,
		206,
		198,
		202,
		215,
		226,
		229,
		109,
		107,
		112,
		57,
		40,
		58,
		67,
		88,
		104,
		101,
		138,
		143,
		158,
		163,
		187,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		182,
		192,
		175,
		177,
		181,
		195,
		207,
		215,
		205,
		203,
		197,
		229,
		-1,
		109,
		108,
		97,
		94,
		70,
		61,
		48,
		59,
		-1,
		-1,
		102,
		129,
		113,
		117,
		133,
		158,
		-1,
		194,
		-1,
		-1,
		208,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		189,
		200,
		222,
		211,
		212,
		202,
		212,
		225,
		93,
		90,
		78,
		76,
		99,
		56,
		52,
		-1,
		84,
		87,
		93,
		100,
		117,
		147,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		227,
		230,
		219,
		-1,
		209,
		182,
		187,
		212,
		219,
		220,
		214,
		208,
		215,
		214,
		222,
		230,
		102,
		116,
		105,
		101,
		100,
		108,
		57,
		74,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		-1,
		233,
		220,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		204,
		204,
		207,
		211,
		206,
		217,
		209,
		213,
		230,
		-1,
		136,
		-1,
		88,
		81,
		96,
		111,
		119,
		-1,
		-1,
		-1,
		250,
		236,
		229,
		217,
		215,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		212,
		223,
		212,
		215,
		229,
		224,
		-1,
		-1,
		94,
		97,
		-1,
		-1,
		119,
		138,
		-1,
		241,
		230,
		215,
		207,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		216,
		222,
		225,
		214,
		218,
		230,
		-1,
		-1,
		101,
		102,
		107,
		-1,
		128,
		-1,
		243,
		-1,
		210,
		217,
		205,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		234,
		232,
		223,
		220,
		227,
		225,
		221,
		232,
		-1,
		-1,
		-1,
		158,
		135,
		250,
		241,
		224,
		204,
		196,
		216,
		-1,
		223,
		-1,
		198,
		199,
		226,
		228,
		245,
		239,
		223,
		238,
		228,
		219,
		228,
		164,
		-1,
		139,
		198,
		181,
		210,
		176,
		188,
		244,
		-1,
		220,
		202,
		-1,
		230,
		220,
		262,
		243,
		236,
		223,
		230,
		232,
		225,
		-1,
		-1,
		-1,
		154,
		153,
		152,
		163,
		171,
		169,
		187,
		-1,
		232,
		214,
		193,
		210,
		210,
		201,
		209,
		252,
		248,
		241,
		243,
		233,
		-1,
		208,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		180,
		202,
		197,
		189,
		201,
		210,
		197,
		203,
		205,
		213,
		211,
		208,
		220,
		216,
		236,
		232,
		264,
		-1,
		215,
		-1,
		184,
		-1,
		-1,
		198,
		184,
		196,
		207,
		197,
		197,
		202,
		200,
		222,
		239,
		223,
		221,
		226,
		231,
		-1,
		225,
		226,
		-1,
		217,
		209,
		195,
		-1,
		188,
		-1,
		243,
		204,
		-1,
		229,
		209,
		-1,
		232,
		228,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		-1,
		218,
		198,
		238,
		222,
		-1,
		220,
		220,
		-1,
		-1,
		-1,
		251,
		242,
		-1,
		211,
		214,
		-1,
		205,
		211,
		240,
		222,
		226,
		-1,
		-1,
		-1,
		267,
		248,
		242,
		226,
		231,
		219,
		236,
		222,
		224,
		236,
		225,
		246,
		-1,
		-1,
		-1,
		239,
		231,
		231,
		-1,
		-1,
		249,
		232,
		232,
		245,
		-1,
		-1,
		-1,
		261,
		242,
		-1,
		-1,
		240,
		-1,
		-1,
		245,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		250,
		-1,
		-1,
		-1,
		241,
		248,
		256,
		-1,
		-1,
		-1,
		-1,
		268,
		269,
		296,
		271,
		-1,
		-1,
		-1,
		255,
		255,
		-1,
		-1,
		266,
		267,
		-1,
		-1,
		-1,
		283,
		267,
		-1,
		259,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		288,
		-1,
		294,
		269,
		276,
		-1,
		-1,
		-1,
		-1,
		301,
		293,
		307,
		-1,
		279,
		281,
		-1,
		329,
		-1,
		-1,
		316,
		307,
		-1,
		-1,
		284,
		291,
		313,
		316,
		346,
		-1,
		303
	],
	[
		-1,
		288,
		277,
		288,
		296,
		269,
		276,
		-1,
		297,
		299,
		265,
		259,
		298,
		269,
		275,
		286,
		-1,
		-1,
		-1,
		288,
		287,
		257,
		255,
		264,
		269,
		276,
		-1,
		299,
		-1,
		309,
		288,
		299,
		304,
		250,
		247,
		267,
		286,
		292,
		284,
		324,
		280,
		251,
		245,
		263,
		268,
		286,
		278,
		-1,
		251,
		241,
		263,
		267,
		279,
		262,
		-1,
		-1,
		245,
		246,
		252,
		264,
		269,
		274,
		-1,
		300,
		284,
		-1,
		-1,
		235,
		248,
		244,
		247,
		255,
		271,
		292,
		284,
		279,
		-1,
		-1,
		236,
		240,
		253,
		254,
		252,
		279,
		292,
		274,
		288,
		287,
		-1,
		224,
		242,
		251,
		260,
		266,
		255,
		253,
		271,
		273,
		279,
		282,
		-1,
		216,
		218,
		247,
		253,
		265,
		271,
		258,
		258,
		268,
		261,
		280,
		271,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		213,
		221,
		247,
		246,
		242,
		260,
		268,
		261,
		258,
		256,
		253,
		269,
		270,
		280,
		-1,
		-1,
		269,
		238,
		273,
		230,
		215,
		-1,
		209,
		228,
		234,
		238,
		243,
		251,
		265,
		261,
		-1,
		247,
		246,
		277,
		263,
		274,
		229,
		-1,
		-1,
		227,
		219,
		204,
		207,
		204,
		204,
		234,
		233,
		238,
		240,
		242,
		248,
		251,
		251,
		257,
		241,
		251,
		255,
		266,
		281,
		-1,
		-1,
		336,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		199,
		216,
		206,
		227,
		242,
		246,
		254,
		256,
		244,
		246,
		243,
		256,
		244,
		238,
		263,
		267,
		261,
		282,
		277,
		-1,
		335,
		319,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		228,
		-1,
		249,
		247,
		271,
		265,
		262,
		249,
		237,
		250,
		235,
		242,
		241,
		245,
		247,
		280,
		258,
		280,
		277,
		306,
		311,
		305,
		314,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		236,
		249,
		256,
		251,
		254,
		266,
		257,
		244,
		233,
		244,
		233,
		230,
		238,
		247,
		258,
		253,
		252,
		270,
		285,
		298,
		302,
		308,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		237,
		257,
		258,
		249,
		-1,
		252,
		255,
		262,
		240,
		225,
		242,
		234,
		232,
		237,
		242,
		256,
		247,
		265,
		272,
		280,
		284,
		304,
		316,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		280,
		255,
		-1,
		250,
		-1,
		242,
		267,
		-1,
		246,
		242,
		224,
		225,
		220,
		235,
		241,
		238,
		235,
		253,
		256,
		273,
		277,
		293,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		248,
		237,
		236,
		-1,
		227,
		257,
		254,
		240,
		227,
		217,
		218,
		226,
		239,
		218,
		237,
		240,
		262,
		290,
		268,
		279,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		266,
		259,
		247,
		212,
		212,
		206,
		-1,
		247,
		230,
		226,
		215,
		213,
		226,
		221,
		237,
		241,
		240,
		259,
		271,
		262,
		270,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		168,
		191,
		225,
		245,
		231,
		236,
		211,
		204,
		198,
		250,
		247,
		214,
		222,
		214,
		203,
		217,
		225,
		229,
		238,
		247,
		253,
		277,
		258,
		264,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		182,
		189,
		221,
		236,
		233,
		-1,
		203,
		-1,
		192,
		200,
		199,
		205,
		217,
		203,
		208,
		219,
		231,
		244,
		240,
		247,
		282,
		282,
		248,
		268,
		271,
		-1,
		-1,
		-1,
		229,
		227,
		202,
		179,
		163,
		199,
		-1,
		203,
		204,
		-1,
		197,
		191,
		197,
		196,
		203,
		200,
		200,
		214,
		222,
		218,
		234,
		240,
		232,
		256,
		-1,
		256,
		250,
		258,
		248,
		236,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		188,
		181,
		-1,
		184,
		184,
		191,
		200,
		205,
		210,
		218,
		213,
		226,
		231,
		237,
		231,
		244,
		248,
		249,
		238,
		234,
		231,
		245,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		191,
		183,
		179,
		173,
		179,
		197,
		195,
		215,
		207,
		221,
		221,
		227,
		235,
		220,
		223,
		236,
		221,
		239,
		245,
		236,
		231,
		230,
		241,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		213,
		192,
		215,
		193,
		207,
		203,
		241,
		242,
		220,
		225,
		233,
		234,
		237,
		226,
		229,
		221,
		243,
		240,
		224,
		226,
		235,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		161,
		172,
		-1,
		-1,
		257,
		-1,
		191,
		208,
		217,
		215,
		231,
		222,
		228,
		244,
		231,
		226,
		231,
		220,
		220,
		215,
		234,
		220,
		218,
		233,
		249,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		235,
		225,
		209,
		194,
		227,
		-1,
		232,
		223,
		228,
		-1,
		251,
		-1,
		223,
		226,
		217,
		212,
		209,
		220,
		218,
		227,
		228,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		197,
		-1,
		-1,
		222,
		216,
		216,
		200,
		203,
		248,
		228,
		220,
		228,
		234,
		221,
		220,
		208,
		208,
		211,
		205,
		218,
		228,
		234,
		226,
		-1,
		-1,
		-1,
		206,
		158,
		166,
		142,
		163,
		-1,
		-1,
		284,
		239,
		225,
		-1,
		209,
		248,
		236,
		226,
		216,
		221,
		222,
		212,
		210,
		206,
		215,
		214,
		207,
		206,
		227,
		220,
		242,
		-1,
		-1,
		155,
		168,
		170,
		156,
		175,
		-1,
		-1,
		-1,
		231,
		247,
		239,
		210,
		237,
		-1,
		-1,
		220,
		213,
		207,
		210,
		198,
		218,
		225,
		213,
		200,
		215,
		225,
		233,
		232,
		-1,
		158,
		145,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		-1,
		-1,
		264,
		226,
		215,
		210,
		214,
		219,
		-1,
		193,
		204,
		197,
		216,
		223,
		215,
		200,
		194,
		205,
		220,
		237,
		-1,
		-1,
		192,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		221,
		232,
		203,
		196,
		200,
		-1,
		195,
		197,
		194,
		206,
		211,
		215,
		206,
		188,
		202,
		205,
		218,
		232,
		236,
		215,
		-1,
		198,
		-1,
		-1,
		-1,
		239,
		250,
		236,
		213,
		192,
		185,
		182,
		181,
		186,
		197,
		206,
		217,
		182,
		186,
		201,
		206,
		210,
		227,
		231,
		-1,
		-1,
		198,
		204,
		239,
		247,
		223,
		263,
		-1,
		-1,
		181,
		174,
		184,
		177,
		190,
		193,
		178,
		180,
		198,
		211,
		205,
		215,
		230,
		225,
		-1,
		-1,
		-1,
		206,
		-1,
		222,
		-1,
		-1,
		213,
		254,
		201,
		183,
		179,
		165,
		172,
		166,
		168,
		173,
		192,
		187,
		196,
		201,
		205,
		228,
		217,
		256,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		172,
		191,
		186,
		192,
		197,
		188,
		216,
		213,
		-1,
		162,
		195,
		163,
		177,
		173,
		180,
		185,
		191,
		195,
		202,
		218,
		217,
		212,
		248,
		239,
		245,
		-1,
		-1,
		123,
		112,
		101,
		107,
		-1,
		165,
		188,
		178,
		168,
		174,
		-1,
		-1,
		180,
		177,
		175,
		155,
		161,
		166,
		169,
		207,
		183,
		191,
		195,
		199,
		205,
		210,
		215,
		221,
		236,
		251,
		-1,
		58,
		28,
		17,
		75,
		83,
		114,
		-1,
		155,
		147,
		175,
		160,
		168,
		-1,
		-1,
		153,
		144,
		149,
		158,
		159,
		190,
		189,
		202,
		205,
		210,
		198,
		197,
		215,
		219,
		228,
		235,
		225,
		238,
		242,
		-1,
		51,
		0,
		69,
		72,
		96,
		110,
		-1,
		146,
		-1,
		-1,
		191,
		178,
		162,
		152,
		149,
		196,
		172,
		167,
		173,
		175,
		199,
		190,
		215,
		206,
		206,
		209,
		224,
		229,
		221,
		235,
		235,
		236,
		-1,
		61,
		25,
		63,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		207,
		-1,
		189,
		-1,
		172,
		176,
		180,
		183,
		198,
		185,
		192,
		209,
		215,
		204,
		214,
		210,
		211,
		220,
		231,
		243,
		242,
		243,
		136,
		91,
		58,
		54,
		95,
		110,
		114,
		-1,
		130,
		166,
		176,
		-1,
		216,
		-1,
		-1,
		-1,
		186,
		193,
		185,
		201,
		197,
		197,
		193,
		197,
		209,
		216,
		226,
		228,
		220,
		224,
		237,
		248,
		251,
		132,
		130,
		135,
		80,
		63,
		80,
		89,
		110,
		126,
		123,
		160,
		165,
		180,
		185,
		209,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		204,
		214,
		197,
		199,
		203,
		217,
		229,
		237,
		227,
		225,
		219,
		251,
		-1,
		132,
		131,
		120,
		117,
		93,
		84,
		71,
		81,
		-1,
		-1,
		124,
		151,
		135,
		139,
		155,
		180,
		-1,
		216,
		-1,
		-1,
		230,
		-1,
		-1,
		256,
		219,
		208,
		199,
		205,
		211,
		222,
		244,
		233,
		234,
		224,
		234,
		247,
		116,
		113,
		101,
		99,
		122,
		79,
		75,
		-1,
		106,
		109,
		115,
		122,
		139,
		169,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		249,
		252,
		241,
		-1,
		231,
		204,
		209,
		234,
		241,
		242,
		236,
		230,
		237,
		236,
		244,
		252,
		125,
		139,
		128,
		124,
		123,
		131,
		80,
		96,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		255,
		242,
		-1,
		-1,
		249,
		242,
		230,
		218,
		208,
		218,
		226,
		226,
		229,
		233,
		228,
		239,
		231,
		235,
		252,
		-1,
		159,
		-1,
		111,
		103,
		118,
		133,
		141,
		-1,
		-1,
		-1,
		272,
		258,
		251,
		239,
		237,
		-1,
		283,
		267,
		248,
		-1,
		218,
		231,
		262,
		230,
		235,
		230,
		234,
		245,
		234,
		237,
		251,
		246,
		-1,
		-1,
		116,
		119,
		-1,
		-1,
		141,
		160,
		-1,
		263,
		252,
		237,
		229,
		-1,
		-1,
		255,
		251,
		-1,
		-1,
		219,
		244,
		233,
		241,
		236,
		238,
		244,
		247,
		236,
		240,
		252,
		-1,
		-1,
		123,
		124,
		129,
		-1,
		150,
		-1,
		265,
		-1,
		232,
		239,
		227,
		-1,
		-1,
		-1,
		257,
		220,
		241,
		251,
		256,
		254,
		245,
		242,
		249,
		247,
		243,
		254,
		-1,
		-1,
		-1,
		180,
		157,
		272,
		263,
		246,
		226,
		218,
		238,
		-1,
		245,
		-1,
		220,
		221,
		248,
		250,
		267,
		261,
		245,
		260,
		250,
		241,
		250,
		186,
		-1,
		161,
		220,
		203,
		232,
		198,
		210,
		266,
		-1,
		242,
		224,
		-1,
		252,
		242,
		284,
		265,
		258,
		245,
		252,
		254,
		247,
		-1,
		-1,
		-1,
		176,
		175,
		174,
		185,
		193,
		191,
		209,
		-1,
		254,
		236,
		215,
		232,
		232,
		223,
		231,
		274,
		270,
		263,
		265,
		255,
		-1,
		231,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		202,
		224,
		219,
		211,
		223,
		232,
		219,
		225,
		227,
		235,
		233,
		230,
		242,
		238,
		258,
		254,
		286,
		-1,
		238,
		-1,
		206,
		-1,
		-1,
		220,
		206,
		218,
		229,
		219,
		219,
		224,
		222,
		244,
		261,
		245,
		243,
		248,
		253,
		-1,
		248,
		249,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		265,
		226,
		-1,
		251,
		231,
		-1,
		254,
		250,
		-1,
		-1,
		260,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		260,
		244,
		-1,
		242,
		242,
		-1,
		-1,
		-1,
		274,
		264,
		-1,
		233,
		236,
		-1,
		227,
		233,
		262,
		244,
		248,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		248,
		253,
		241,
		258,
		244,
		246,
		258,
		247,
		268,
		-1,
		-1,
		-1,
		261,
		253,
		253,
		-1,
		-1,
		271,
		254,
		254,
		267,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		262,
		-1,
		-1,
		267,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		272,
		-1,
		-1,
		-1,
		263,
		270,
		278,
		-1,
		-1,
		-1,
		-1,
		291,
		292,
		318,
		293,
		-1,
		-1,
		-1,
		277,
		277,
		-1,
		-1,
		289,
		290,
		-1,
		-1,
		-1,
		305,
		289,
		-1,
		281,
		-1,
		-1,
		-1,
		296,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		310,
		-1,
		316,
		291,
		298,
		-1,
		-1,
		-1,
		-1,
		323,
		315,
		329,
		-1,
		301,
		303,
		-1,
		351,
		-1,
		-1,
		338,
		329,
		-1,
		-1,
		306,
		313,
		335,
		338,
		368,
		-1,
		325
	],
	[
		-1,
		277,
		266,
		277,
		285,
		258,
		265,
		-1,
		286,
		288,
		254,
		248,
		287,
		258,
		264,
		275,
		-1,
		-1,
		-1,
		277,
		276,
		246,
		244,
		253,
		258,
		265,
		-1,
		288,
		-1,
		298,
		277,
		288,
		293,
		239,
		236,
		256,
		275,
		281,
		273,
		313,
		269,
		240,
		234,
		252,
		257,
		275,
		267,
		-1,
		240,
		230,
		252,
		256,
		268,
		251,
		-1,
		-1,
		234,
		235,
		241,
		253,
		258,
		263,
		-1,
		289,
		273,
		-1,
		-1,
		224,
		237,
		233,
		236,
		244,
		260,
		281,
		273,
		268,
		-1,
		-1,
		225,
		229,
		242,
		243,
		241,
		268,
		281,
		263,
		277,
		276,
		-1,
		213,
		231,
		240,
		249,
		255,
		244,
		242,
		260,
		262,
		268,
		271,
		-1,
		205,
		207,
		236,
		242,
		254,
		260,
		247,
		247,
		257,
		250,
		269,
		260,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		202,
		210,
		236,
		235,
		231,
		249,
		257,
		250,
		247,
		245,
		242,
		258,
		259,
		269,
		-1,
		-1,
		258,
		227,
		262,
		219,
		204,
		-1,
		198,
		217,
		223,
		227,
		232,
		240,
		254,
		250,
		-1,
		236,
		235,
		266,
		252,
		263,
		218,
		-1,
		-1,
		216,
		208,
		193,
		196,
		193,
		193,
		223,
		222,
		227,
		229,
		231,
		237,
		240,
		240,
		246,
		230,
		240,
		244,
		252,
		270,
		-1,
		-1,
		312,
		-1,
		-1,
		215,
		198,
		-1,
		181,
		188,
		188,
		205,
		195,
		216,
		231,
		235,
		243,
		245,
		233,
		235,
		232,
		245,
		233,
		227,
		252,
		256,
		247,
		268,
		263,
		-1,
		311,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		174,
		177,
		183,
		207,
		217,
		-1,
		238,
		236,
		260,
		254,
		251,
		238,
		226,
		239,
		224,
		231,
		230,
		234,
		236,
		269,
		244,
		266,
		263,
		282,
		287,
		281,
		290,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		211,
		-1,
		225,
		238,
		245,
		240,
		243,
		255,
		246,
		233,
		222,
		233,
		222,
		219,
		227,
		233,
		247,
		239,
		238,
		256,
		266,
		274,
		278,
		284,
		-1,
		273,
		-1,
		215,
		199,
		201,
		173,
		194,
		-1,
		231,
		226,
		246,
		247,
		238,
		-1,
		241,
		244,
		251,
		229,
		214,
		231,
		223,
		221,
		226,
		228,
		242,
		233,
		251,
		258,
		256,
		260,
		280,
		292,
		233,
		223,
		-1,
		205,
		210,
		169,
		177,
		196,
		269,
		244,
		-1,
		239,
		-1,
		231,
		256,
		-1,
		235,
		231,
		213,
		214,
		209,
		224,
		230,
		224,
		221,
		239,
		242,
		249,
		253,
		269,
		-1,
		-1,
		218,
		222,
		211,
		162,
		181,
		205,
		242,
		237,
		226,
		225,
		-1,
		216,
		246,
		243,
		229,
		216,
		206,
		207,
		215,
		228,
		207,
		223,
		220,
		240,
		266,
		244,
		255,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		188,
		159,
		183,
		225,
		255,
		248,
		236,
		201,
		201,
		195,
		-1,
		236,
		219,
		215,
		204,
		202,
		215,
		210,
		226,
		218,
		216,
		235,
		247,
		238,
		246,
		-1,
		-1,
		-1,
		218,
		207,
		208,
		157,
		180,
		214,
		234,
		220,
		225,
		200,
		193,
		187,
		239,
		236,
		203,
		211,
		203,
		192,
		206,
		214,
		218,
		214,
		223,
		229,
		253,
		234,
		240,
		-1,
		-1,
		225,
		215,
		199,
		201,
		198,
		171,
		178,
		210,
		225,
		222,
		-1,
		192,
		-1,
		181,
		189,
		188,
		194,
		206,
		192,
		197,
		208,
		220,
		221,
		216,
		223,
		258,
		258,
		224,
		244,
		247,
		-1,
		-1,
		-1,
		218,
		216,
		191,
		168,
		152,
		188,
		-1,
		192,
		193,
		-1,
		186,
		180,
		186,
		185,
		192,
		189,
		189,
		203,
		211,
		207,
		223,
		226,
		208,
		232,
		-1,
		232,
		226,
		234,
		224,
		212,
		-1,
		-1,
		-1,
		214,
		193,
		186,
		206,
		147,
		199,
		-1,
		-1,
		177,
		170,
		-1,
		173,
		173,
		180,
		189,
		194,
		199,
		207,
		202,
		215,
		219,
		213,
		207,
		220,
		224,
		225,
		214,
		210,
		207,
		221,
		-1,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		167,
		-1,
		180,
		172,
		168,
		162,
		168,
		186,
		184,
		204,
		196,
		210,
		210,
		216,
		222,
		208,
		201,
		212,
		197,
		215,
		221,
		212,
		207,
		206,
		217,
		-1,
		234,
		220,
		191,
		-1,
		-1,
		180,
		-1,
		144,
		158,
		174,
		-1,
		202,
		181,
		204,
		182,
		196,
		192,
		230,
		231,
		209,
		214,
		222,
		210,
		213,
		202,
		205,
		197,
		219,
		216,
		200,
		202,
		211,
		-1,
		240,
		227,
		185,
		181,
		170,
		190,
		141,
		150,
		161,
		-1,
		-1,
		246,
		-1,
		180,
		197,
		206,
		204,
		220,
		209,
		216,
		233,
		207,
		202,
		207,
		196,
		196,
		191,
		210,
		196,
		194,
		209,
		225,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		156,
		143,
		137,
		-1,
		178,
		-1,
		224,
		214,
		198,
		183,
		216,
		-1,
		208,
		204,
		211,
		-1,
		227,
		-1,
		199,
		202,
		193,
		188,
		185,
		196,
		194,
		203,
		204,
		-1,
		190,
		175,
		168,
		158,
		172,
		143,
		-1,
		186,
		-1,
		-1,
		211,
		205,
		205,
		189,
		192,
		224,
		204,
		196,
		211,
		210,
		197,
		196,
		184,
		184,
		187,
		181,
		194,
		204,
		210,
		202,
		-1,
		-1,
		-1,
		195,
		147,
		155,
		131,
		152,
		-1,
		-1,
		273,
		228,
		214,
		-1,
		198,
		224,
		212,
		202,
		192,
		197,
		198,
		188,
		186,
		182,
		191,
		190,
		183,
		182,
		203,
		196,
		218,
		-1,
		-1,
		144,
		157,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		220,
		236,
		228,
		199,
		213,
		-1,
		-1,
		196,
		189,
		183,
		186,
		174,
		194,
		201,
		189,
		176,
		191,
		201,
		209,
		208,
		-1,
		147,
		134,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		253,
		202,
		191,
		186,
		190,
		195,
		-1,
		169,
		180,
		173,
		192,
		199,
		191,
		176,
		170,
		181,
		196,
		213,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		210,
		208,
		179,
		172,
		176,
		-1,
		171,
		173,
		170,
		182,
		187,
		191,
		182,
		164,
		178,
		181,
		194,
		208,
		212,
		204,
		-1,
		186,
		-1,
		-1,
		-1,
		225,
		226,
		212,
		189,
		168,
		161,
		158,
		157,
		162,
		173,
		182,
		193,
		158,
		162,
		177,
		182,
		186,
		203,
		207,
		-1,
		-1,
		184,
		180,
		215,
		227,
		199,
		239,
		-1,
		-1,
		157,
		150,
		160,
		153,
		166,
		169,
		154,
		156,
		174,
		187,
		181,
		191,
		206,
		201,
		-1,
		-1,
		-1,
		182,
		-1,
		198,
		-1,
		-1,
		189,
		230,
		177,
		159,
		155,
		141,
		148,
		142,
		144,
		149,
		168,
		163,
		172,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		61,
		-1,
		-1,
		-1,
		148,
		167,
		162,
		168,
		173,
		164,
		192,
		189,
		-1,
		138,
		171,
		139,
		153,
		149,
		156,
		161,
		167,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		54,
		43,
		32,
		38,
		-1,
		141,
		164,
		154,
		144,
		150,
		-1,
		-1,
		156,
		153,
		151,
		131,
		137,
		142,
		145,
		183,
		159,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		47,
		88,
		81,
		6,
		14,
		45,
		-1,
		131,
		123,
		151,
		136,
		144,
		-1,
		-1,
		129,
		120,
		125,
		134,
		135,
		166,
		165,
		178,
		181,
		186,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		40,
		64,
		0,
		3,
		27,
		41,
		-1,
		122,
		-1,
		-1,
		167,
		154,
		138,
		128,
		125,
		172,
		148,
		143,
		149,
		151,
		175,
		166,
		191,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		39,
		44,
		6,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		183,
		-1,
		165,
		-1,
		148,
		152,
		156,
		159,
		174,
		161,
		168,
		185,
		191,
		180,
		190,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		112,
		67,
		34,
		13,
		71,
		86,
		90,
		-1,
		106,
		142,
		152,
		-1,
		192,
		-1,
		-1,
		-1,
		162,
		169,
		161,
		177,
		173,
		173,
		169,
		173,
		185,
		192,
		202,
		204,
		196,
		200,
		213,
		224,
		227,
		108,
		106,
		111,
		56,
		39,
		56,
		65,
		86,
		102,
		99,
		136,
		141,
		156,
		161,
		185,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		180,
		190,
		173,
		175,
		179,
		193,
		205,
		213,
		203,
		201,
		195,
		227,
		-1,
		108,
		107,
		96,
		93,
		69,
		60,
		47,
		57,
		-1,
		-1,
		100,
		127,
		111,
		115,
		131,
		156,
		-1,
		192,
		-1,
		-1,
		206,
		-1,
		-1,
		232,
		195,
		184,
		175,
		181,
		187,
		198,
		220,
		209,
		210,
		200,
		210,
		223,
		92,
		89,
		77,
		75,
		98,
		55,
		51,
		-1,
		82,
		85,
		91,
		98,
		115,
		145,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		225,
		228,
		217,
		-1,
		207,
		180,
		185,
		210,
		217,
		218,
		212,
		206,
		213,
		212,
		220,
		228,
		101,
		115,
		104,
		100,
		99,
		107,
		56,
		72,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		218,
		-1,
		-1,
		225,
		218,
		206,
		194,
		184,
		194,
		202,
		202,
		205,
		209,
		204,
		215,
		207,
		211,
		228,
		-1,
		135,
		-1,
		87,
		79,
		94,
		109,
		117,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		259,
		243,
		224,
		-1,
		194,
		207,
		238,
		206,
		211,
		206,
		210,
		221,
		210,
		213,
		227,
		222,
		-1,
		-1,
		92,
		95,
		-1,
		-1,
		117,
		136,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		231,
		227,
		-1,
		-1,
		195,
		220,
		209,
		217,
		212,
		214,
		220,
		223,
		212,
		216,
		228,
		-1,
		-1,
		99,
		100,
		105,
		-1,
		126,
		-1,
		241,
		-1,
		208,
		215,
		203,
		-1,
		-1,
		-1,
		233,
		196,
		217,
		227,
		232,
		230,
		221,
		218,
		225,
		223,
		219,
		230,
		-1,
		-1,
		-1,
		156,
		133,
		248,
		239,
		222,
		202,
		194,
		214,
		-1,
		221,
		-1,
		196,
		197,
		224,
		226,
		243,
		237,
		221,
		236,
		226,
		217,
		226,
		162,
		-1,
		137,
		196,
		179,
		208,
		174,
		186,
		242,
		-1,
		218,
		200,
		-1,
		228,
		218,
		260,
		241,
		234,
		221,
		228,
		230,
		223,
		-1,
		-1,
		-1,
		152,
		151,
		150,
		161,
		169,
		167,
		185,
		-1,
		230,
		212,
		191,
		208,
		208,
		199,
		207,
		250,
		246,
		239,
		241,
		231,
		-1,
		207,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		178,
		200,
		195,
		187,
		199,
		208,
		195,
		201,
		203,
		211,
		209,
		206,
		218,
		214,
		234,
		230,
		262,
		-1,
		214,
		-1,
		182,
		-1,
		-1,
		196,
		182,
		194,
		205,
		195,
		195,
		200,
		198,
		220,
		237,
		221,
		219,
		224,
		229,
		-1,
		224,
		225,
		-1,
		215,
		207,
		193,
		-1,
		186,
		-1,
		241,
		202,
		-1,
		227,
		207,
		-1,
		230,
		226,
		-1,
		-1,
		236,
		231,
		-1,
		-1,
		-1,
		216,
		196,
		236,
		220,
		-1,
		218,
		218,
		-1,
		-1,
		-1,
		250,
		240,
		-1,
		209,
		212,
		-1,
		203,
		209,
		238,
		220,
		224,
		-1,
		-1,
		-1,
		265,
		246,
		240,
		224,
		229,
		217,
		234,
		220,
		222,
		234,
		223,
		244,
		-1,
		-1,
		-1,
		237,
		229,
		229,
		-1,
		-1,
		247,
		230,
		230,
		243,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		238,
		-1,
		-1,
		243,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		248,
		-1,
		-1,
		-1,
		239,
		246,
		254,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		294,
		269,
		-1,
		-1,
		-1,
		253,
		253,
		-1,
		-1,
		265,
		266,
		-1,
		-1,
		-1,
		281,
		265,
		-1,
		257,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		286,
		-1,
		292,
		267,
		274,
		-1,
		-1,
		-1,
		-1,
		299,
		291,
		305,
		-1,
		277,
		279,
		-1,
		327,
		-1,
		-1,
		314,
		305,
		-1,
		-1,
		282,
		289,
		311,
		314,
		344,
		-1,
		301
	],
	[
		-1,
		282,
		271,
		282,
		290,
		263,
		270,
		-1,
		291,
		293,
		259,
		253,
		292,
		263,
		269,
		280,
		-1,
		-1,
		-1,
		282,
		281,
		251,
		249,
		258,
		263,
		270,
		-1,
		293,
		-1,
		303,
		282,
		293,
		298,
		244,
		241,
		261,
		280,
		286,
		278,
		318,
		274,
		245,
		239,
		257,
		262,
		280,
		272,
		-1,
		245,
		235,
		257,
		261,
		273,
		256,
		-1,
		-1,
		239,
		240,
		246,
		258,
		263,
		268,
		-1,
		294,
		278,
		-1,
		-1,
		229,
		242,
		238,
		241,
		249,
		265,
		286,
		278,
		273,
		-1,
		-1,
		230,
		234,
		247,
		248,
		246,
		273,
		286,
		268,
		282,
		281,
		-1,
		218,
		236,
		245,
		254,
		260,
		249,
		247,
		265,
		267,
		273,
		276,
		-1,
		210,
		212,
		241,
		247,
		259,
		265,
		252,
		252,
		262,
		255,
		274,
		265,
		311,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		207,
		215,
		241,
		240,
		236,
		254,
		262,
		255,
		252,
		250,
		247,
		263,
		264,
		274,
		-1,
		-1,
		263,
		232,
		267,
		224,
		209,
		-1,
		203,
		222,
		228,
		232,
		237,
		245,
		259,
		255,
		-1,
		241,
		240,
		271,
		257,
		268,
		223,
		-1,
		-1,
		221,
		213,
		198,
		201,
		198,
		198,
		228,
		227,
		232,
		234,
		236,
		242,
		245,
		245,
		251,
		235,
		245,
		249,
		257,
		275,
		-1,
		-1,
		317,
		-1,
		-1,
		220,
		203,
		-1,
		186,
		193,
		193,
		210,
		200,
		221,
		236,
		240,
		248,
		250,
		238,
		240,
		237,
		250,
		238,
		232,
		257,
		261,
		252,
		273,
		268,
		-1,
		316,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		179,
		182,
		188,
		212,
		222,
		-1,
		243,
		241,
		265,
		259,
		256,
		243,
		231,
		244,
		229,
		236,
		235,
		239,
		241,
		274,
		249,
		271,
		268,
		287,
		292,
		286,
		295,
		-1,
		228,
		224,
		220,
		227,
		176,
		-1,
		-1,
		216,
		-1,
		230,
		243,
		250,
		245,
		248,
		260,
		251,
		238,
		227,
		238,
		227,
		224,
		232,
		238,
		252,
		244,
		243,
		261,
		271,
		279,
		283,
		289,
		-1,
		278,
		-1,
		220,
		204,
		206,
		178,
		199,
		-1,
		236,
		231,
		251,
		252,
		243,
		-1,
		246,
		249,
		256,
		234,
		219,
		236,
		228,
		226,
		231,
		233,
		247,
		238,
		256,
		263,
		261,
		265,
		285,
		297,
		238,
		228,
		-1,
		210,
		215,
		174,
		182,
		201,
		274,
		249,
		-1,
		244,
		-1,
		236,
		261,
		-1,
		240,
		236,
		218,
		219,
		214,
		229,
		235,
		229,
		226,
		244,
		247,
		254,
		258,
		274,
		-1,
		-1,
		223,
		227,
		216,
		167,
		186,
		210,
		247,
		242,
		231,
		230,
		-1,
		221,
		251,
		248,
		234,
		221,
		211,
		212,
		220,
		233,
		212,
		228,
		225,
		245,
		271,
		249,
		260,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		193,
		164,
		188,
		230,
		260,
		253,
		241,
		206,
		206,
		200,
		-1,
		241,
		224,
		220,
		209,
		207,
		220,
		215,
		231,
		223,
		221,
		240,
		252,
		243,
		251,
		-1,
		-1,
		-1,
		223,
		212,
		213,
		162,
		185,
		219,
		239,
		225,
		230,
		205,
		198,
		192,
		244,
		241,
		208,
		216,
		208,
		197,
		211,
		219,
		223,
		219,
		228,
		234,
		258,
		239,
		245,
		-1,
		-1,
		230,
		220,
		204,
		206,
		203,
		176,
		183,
		215,
		230,
		227,
		-1,
		197,
		-1,
		186,
		194,
		193,
		199,
		211,
		197,
		202,
		213,
		225,
		226,
		221,
		228,
		263,
		263,
		229,
		249,
		252,
		-1,
		-1,
		-1,
		223,
		221,
		196,
		173,
		157,
		193,
		-1,
		197,
		198,
		-1,
		191,
		185,
		191,
		190,
		197,
		194,
		194,
		208,
		216,
		212,
		228,
		231,
		213,
		237,
		-1,
		237,
		231,
		239,
		229,
		217,
		-1,
		-1,
		-1,
		219,
		198,
		191,
		211,
		152,
		204,
		-1,
		-1,
		182,
		175,
		-1,
		178,
		178,
		185,
		194,
		199,
		204,
		212,
		207,
		220,
		224,
		218,
		212,
		225,
		229,
		230,
		219,
		215,
		212,
		226,
		-1,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		172,
		-1,
		185,
		177,
		173,
		167,
		173,
		191,
		189,
		209,
		201,
		215,
		215,
		221,
		227,
		213,
		206,
		217,
		202,
		220,
		226,
		217,
		212,
		211,
		222,
		-1,
		239,
		225,
		196,
		-1,
		-1,
		185,
		-1,
		149,
		163,
		179,
		-1,
		207,
		186,
		209,
		187,
		201,
		197,
		235,
		236,
		214,
		219,
		227,
		215,
		218,
		207,
		210,
		202,
		224,
		221,
		205,
		207,
		216,
		-1,
		245,
		232,
		190,
		186,
		175,
		195,
		146,
		155,
		166,
		-1,
		-1,
		251,
		-1,
		185,
		202,
		211,
		209,
		225,
		214,
		221,
		238,
		212,
		207,
		212,
		201,
		201,
		196,
		215,
		201,
		199,
		214,
		230,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		161,
		148,
		142,
		-1,
		183,
		-1,
		229,
		219,
		203,
		188,
		221,
		-1,
		213,
		209,
		216,
		-1,
		232,
		-1,
		204,
		207,
		198,
		193,
		190,
		201,
		199,
		208,
		209,
		-1,
		195,
		180,
		173,
		163,
		177,
		148,
		-1,
		191,
		-1,
		-1,
		216,
		210,
		210,
		194,
		197,
		229,
		209,
		201,
		216,
		215,
		202,
		201,
		189,
		189,
		192,
		186,
		199,
		209,
		215,
		207,
		-1,
		-1,
		-1,
		200,
		152,
		160,
		136,
		157,
		-1,
		-1,
		278,
		233,
		219,
		-1,
		203,
		229,
		217,
		207,
		197,
		202,
		203,
		193,
		191,
		187,
		196,
		195,
		188,
		187,
		208,
		201,
		223,
		-1,
		-1,
		149,
		162,
		164,
		150,
		169,
		-1,
		-1,
		-1,
		225,
		241,
		233,
		204,
		218,
		-1,
		-1,
		201,
		194,
		188,
		191,
		179,
		199,
		206,
		194,
		181,
		196,
		206,
		214,
		213,
		-1,
		152,
		139,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		-1,
		-1,
		258,
		207,
		196,
		191,
		195,
		200,
		-1,
		174,
		185,
		178,
		197,
		204,
		196,
		181,
		175,
		186,
		201,
		218,
		-1,
		-1,
		186,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		215,
		213,
		184,
		177,
		181,
		-1,
		176,
		178,
		175,
		187,
		192,
		196,
		187,
		169,
		183,
		186,
		199,
		213,
		217,
		209,
		-1,
		191,
		-1,
		-1,
		-1,
		230,
		231,
		217,
		194,
		173,
		166,
		163,
		162,
		167,
		178,
		187,
		198,
		163,
		167,
		182,
		187,
		191,
		208,
		212,
		-1,
		-1,
		189,
		185,
		220,
		232,
		204,
		244,
		-1,
		-1,
		162,
		155,
		165,
		158,
		171,
		174,
		159,
		161,
		179,
		192,
		186,
		196,
		211,
		206,
		-1,
		-1,
		-1,
		187,
		-1,
		203,
		-1,
		-1,
		194,
		235,
		182,
		164,
		160,
		146,
		153,
		147,
		149,
		154,
		173,
		168,
		177,
		182,
		186,
		209,
		198,
		237,
		-1,
		-1,
		58,
		-1,
		-1,
		-1,
		153,
		172,
		167,
		173,
		178,
		169,
		197,
		194,
		-1,
		143,
		176,
		144,
		158,
		154,
		161,
		166,
		172,
		176,
		183,
		199,
		198,
		193,
		229,
		220,
		226,
		-1,
		-1,
		51,
		40,
		29,
		35,
		-1,
		146,
		169,
		159,
		149,
		155,
		-1,
		-1,
		161,
		158,
		156,
		136,
		142,
		147,
		150,
		188,
		164,
		172,
		176,
		180,
		186,
		191,
		196,
		202,
		217,
		232,
		-1,
		52,
		93,
		86,
		3,
		11,
		42,
		-1,
		136,
		128,
		156,
		141,
		149,
		-1,
		-1,
		134,
		125,
		130,
		139,
		140,
		171,
		170,
		183,
		186,
		191,
		179,
		178,
		196,
		200,
		209,
		216,
		206,
		219,
		223,
		-1,
		45,
		69,
		5,
		0,
		24,
		38,
		-1,
		127,
		-1,
		-1,
		172,
		159,
		143,
		133,
		130,
		177,
		153,
		148,
		154,
		156,
		180,
		171,
		196,
		187,
		187,
		190,
		205,
		210,
		202,
		216,
		216,
		217,
		-1,
		44,
		49,
		11,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		188,
		-1,
		170,
		-1,
		153,
		157,
		161,
		164,
		179,
		166,
		173,
		190,
		196,
		185,
		195,
		191,
		192,
		201,
		212,
		224,
		223,
		224,
		117,
		72,
		39,
		18,
		76,
		91,
		95,
		-1,
		111,
		147,
		157,
		-1,
		197,
		-1,
		-1,
		-1,
		167,
		174,
		166,
		182,
		178,
		178,
		174,
		178,
		190,
		197,
		207,
		209,
		201,
		205,
		218,
		229,
		232,
		113,
		111,
		116,
		61,
		44,
		61,
		70,
		91,
		107,
		104,
		141,
		146,
		161,
		166,
		190,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		185,
		195,
		178,
		180,
		184,
		198,
		210,
		218,
		208,
		206,
		200,
		232,
		-1,
		113,
		112,
		101,
		98,
		74,
		65,
		52,
		62,
		-1,
		-1,
		105,
		132,
		116,
		120,
		136,
		161,
		-1,
		197,
		-1,
		-1,
		211,
		-1,
		-1,
		237,
		200,
		189,
		180,
		186,
		192,
		203,
		225,
		214,
		215,
		205,
		215,
		228,
		97,
		94,
		82,
		80,
		103,
		60,
		56,
		-1,
		87,
		90,
		96,
		103,
		120,
		150,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		230,
		233,
		222,
		-1,
		212,
		185,
		190,
		215,
		222,
		223,
		217,
		211,
		218,
		217,
		225,
		233,
		106,
		120,
		109,
		105,
		104,
		112,
		61,
		77,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		-1,
		236,
		223,
		-1,
		-1,
		230,
		223,
		211,
		199,
		189,
		199,
		207,
		207,
		210,
		214,
		209,
		220,
		212,
		216,
		233,
		-1,
		140,
		-1,
		92,
		84,
		99,
		114,
		122,
		-1,
		-1,
		-1,
		253,
		239,
		232,
		220,
		218,
		-1,
		264,
		248,
		229,
		-1,
		199,
		212,
		243,
		211,
		216,
		211,
		215,
		226,
		215,
		218,
		232,
		227,
		-1,
		-1,
		97,
		100,
		-1,
		-1,
		122,
		141,
		-1,
		244,
		233,
		218,
		210,
		-1,
		-1,
		236,
		232,
		-1,
		-1,
		200,
		225,
		214,
		222,
		217,
		219,
		225,
		228,
		217,
		221,
		233,
		-1,
		-1,
		104,
		105,
		110,
		-1,
		131,
		-1,
		246,
		-1,
		213,
		220,
		208,
		-1,
		-1,
		-1,
		238,
		201,
		222,
		232,
		237,
		235,
		226,
		223,
		230,
		228,
		224,
		235,
		-1,
		-1,
		-1,
		161,
		138,
		253,
		244,
		227,
		207,
		199,
		219,
		-1,
		226,
		-1,
		201,
		202,
		229,
		231,
		248,
		242,
		226,
		241,
		231,
		222,
		231,
		167,
		-1,
		142,
		201,
		184,
		213,
		179,
		191,
		247,
		-1,
		223,
		205,
		-1,
		233,
		223,
		265,
		246,
		239,
		226,
		233,
		235,
		228,
		-1,
		-1,
		-1,
		157,
		156,
		155,
		166,
		174,
		172,
		190,
		-1,
		235,
		217,
		196,
		213,
		213,
		204,
		212,
		255,
		251,
		244,
		246,
		236,
		-1,
		212,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		183,
		205,
		200,
		192,
		204,
		213,
		200,
		206,
		208,
		216,
		214,
		211,
		223,
		219,
		239,
		235,
		267,
		-1,
		219,
		-1,
		187,
		-1,
		-1,
		201,
		187,
		199,
		210,
		200,
		200,
		205,
		203,
		225,
		242,
		226,
		224,
		229,
		234,
		-1,
		229,
		230,
		-1,
		220,
		212,
		198,
		-1,
		191,
		-1,
		246,
		207,
		-1,
		232,
		212,
		-1,
		235,
		231,
		-1,
		-1,
		241,
		236,
		-1,
		-1,
		-1,
		221,
		201,
		241,
		225,
		-1,
		223,
		223,
		-1,
		-1,
		-1,
		255,
		245,
		-1,
		214,
		217,
		-1,
		208,
		214,
		243,
		225,
		229,
		-1,
		-1,
		-1,
		270,
		251,
		245,
		229,
		234,
		222,
		239,
		225,
		227,
		239,
		228,
		249,
		-1,
		-1,
		-1,
		242,
		234,
		234,
		-1,
		-1,
		252,
		235,
		235,
		248,
		-1,
		-1,
		-1,
		264,
		245,
		-1,
		-1,
		243,
		-1,
		-1,
		248,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		253,
		-1,
		-1,
		-1,
		244,
		251,
		259,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		299,
		274,
		-1,
		-1,
		-1,
		258,
		258,
		-1,
		-1,
		270,
		271,
		-1,
		-1,
		-1,
		286,
		270,
		-1,
		262,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		295,
		-1,
		-1,
		-1,
		291,
		-1,
		297,
		272,
		279,
		-1,
		-1,
		-1,
		-1,
		304,
		296,
		310,
		-1,
		282,
		284,
		-1,
		332,
		-1,
		-1,
		319,
		310,
		-1,
		-1,
		287,
		294,
		316,
		319,
		349,
		-1,
		306
	],
	[
		-1,
		301,
		290,
		301,
		309,
		282,
		289,
		-1,
		310,
		312,
		278,
		272,
		311,
		282,
		288,
		299,
		-1,
		-1,
		-1,
		301,
		300,
		270,
		268,
		277,
		282,
		289,
		-1,
		312,
		-1,
		322,
		301,
		312,
		317,
		263,
		260,
		280,
		299,
		305,
		297,
		337,
		293,
		264,
		258,
		276,
		281,
		299,
		291,
		-1,
		264,
		254,
		276,
		280,
		292,
		275,
		-1,
		-1,
		258,
		259,
		265,
		277,
		282,
		287,
		-1,
		313,
		297,
		-1,
		-1,
		248,
		261,
		257,
		260,
		268,
		284,
		305,
		297,
		292,
		-1,
		-1,
		249,
		253,
		266,
		267,
		265,
		292,
		305,
		287,
		301,
		300,
		-1,
		237,
		255,
		264,
		273,
		279,
		268,
		266,
		284,
		286,
		292,
		295,
		-1,
		229,
		231,
		260,
		266,
		278,
		284,
		271,
		271,
		281,
		274,
		293,
		284,
		330,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		226,
		234,
		260,
		259,
		255,
		273,
		281,
		274,
		271,
		269,
		266,
		282,
		283,
		293,
		-1,
		-1,
		282,
		251,
		286,
		243,
		228,
		-1,
		222,
		241,
		247,
		251,
		256,
		264,
		278,
		274,
		-1,
		260,
		259,
		290,
		276,
		287,
		242,
		-1,
		-1,
		240,
		232,
		217,
		220,
		217,
		217,
		247,
		246,
		251,
		253,
		255,
		261,
		264,
		264,
		270,
		254,
		264,
		268,
		276,
		294,
		-1,
		-1,
		336,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		212,
		229,
		219,
		240,
		255,
		259,
		267,
		269,
		257,
		259,
		256,
		269,
		257,
		251,
		276,
		280,
		271,
		292,
		287,
		-1,
		335,
		319,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		241,
		-1,
		262,
		260,
		284,
		278,
		275,
		262,
		250,
		263,
		248,
		255,
		254,
		258,
		260,
		293,
		268,
		290,
		287,
		306,
		311,
		305,
		314,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		249,
		262,
		269,
		264,
		267,
		279,
		270,
		257,
		246,
		257,
		246,
		243,
		251,
		257,
		271,
		263,
		262,
		280,
		290,
		298,
		302,
		308,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		250,
		270,
		271,
		262,
		-1,
		265,
		268,
		275,
		253,
		238,
		255,
		247,
		245,
		250,
		252,
		266,
		257,
		275,
		282,
		280,
		284,
		304,
		316,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		293,
		268,
		-1,
		263,
		-1,
		255,
		280,
		-1,
		259,
		255,
		237,
		238,
		233,
		248,
		254,
		248,
		245,
		263,
		266,
		273,
		277,
		293,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		261,
		250,
		249,
		-1,
		240,
		270,
		267,
		253,
		240,
		230,
		231,
		239,
		252,
		231,
		247,
		244,
		264,
		290,
		268,
		279,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		260,
		243,
		239,
		228,
		226,
		239,
		234,
		250,
		242,
		240,
		259,
		271,
		262,
		270,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		181,
		204,
		238,
		258,
		244,
		249,
		224,
		217,
		211,
		263,
		260,
		227,
		235,
		227,
		216,
		230,
		238,
		242,
		238,
		247,
		253,
		277,
		258,
		264,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		195,
		202,
		234,
		249,
		246,
		-1,
		216,
		-1,
		205,
		213,
		212,
		218,
		230,
		216,
		221,
		232,
		244,
		245,
		240,
		247,
		282,
		282,
		248,
		268,
		271,
		-1,
		-1,
		-1,
		242,
		240,
		215,
		192,
		176,
		212,
		-1,
		216,
		217,
		-1,
		210,
		204,
		210,
		209,
		216,
		213,
		213,
		227,
		235,
		231,
		247,
		250,
		232,
		256,
		-1,
		256,
		250,
		258,
		248,
		236,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		201,
		194,
		-1,
		197,
		197,
		204,
		213,
		218,
		223,
		231,
		226,
		239,
		243,
		237,
		231,
		244,
		248,
		249,
		238,
		234,
		231,
		245,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		204,
		196,
		192,
		186,
		192,
		210,
		208,
		228,
		220,
		234,
		234,
		240,
		246,
		232,
		225,
		236,
		221,
		239,
		245,
		236,
		231,
		230,
		241,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		226,
		205,
		228,
		206,
		220,
		216,
		254,
		255,
		233,
		238,
		246,
		234,
		237,
		226,
		229,
		221,
		243,
		240,
		224,
		226,
		235,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		174,
		185,
		-1,
		-1,
		270,
		-1,
		204,
		221,
		230,
		228,
		244,
		233,
		240,
		257,
		231,
		226,
		231,
		220,
		220,
		215,
		234,
		220,
		218,
		233,
		249,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		248,
		238,
		222,
		207,
		240,
		-1,
		232,
		228,
		235,
		-1,
		251,
		-1,
		223,
		226,
		217,
		212,
		209,
		220,
		218,
		227,
		228,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		210,
		-1,
		-1,
		235,
		229,
		229,
		213,
		216,
		248,
		228,
		220,
		235,
		234,
		221,
		220,
		208,
		208,
		211,
		205,
		218,
		228,
		234,
		226,
		-1,
		-1,
		-1,
		219,
		171,
		179,
		155,
		176,
		-1,
		-1,
		297,
		252,
		238,
		-1,
		222,
		248,
		236,
		226,
		216,
		221,
		222,
		212,
		210,
		206,
		215,
		214,
		207,
		206,
		227,
		220,
		242,
		-1,
		-1,
		168,
		181,
		183,
		169,
		188,
		-1,
		-1,
		-1,
		244,
		260,
		252,
		223,
		237,
		-1,
		-1,
		220,
		213,
		207,
		210,
		198,
		218,
		225,
		213,
		200,
		215,
		225,
		233,
		232,
		-1,
		171,
		158,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		-1,
		-1,
		277,
		226,
		215,
		210,
		214,
		219,
		-1,
		193,
		204,
		197,
		216,
		223,
		215,
		200,
		194,
		205,
		220,
		237,
		-1,
		-1,
		205,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		234,
		232,
		203,
		196,
		200,
		-1,
		195,
		197,
		194,
		206,
		211,
		215,
		206,
		188,
		202,
		205,
		218,
		232,
		236,
		228,
		-1,
		210,
		-1,
		-1,
		-1,
		249,
		250,
		236,
		213,
		192,
		185,
		182,
		181,
		186,
		197,
		206,
		217,
		182,
		186,
		201,
		206,
		210,
		227,
		231,
		-1,
		-1,
		208,
		204,
		239,
		251,
		223,
		263,
		-1,
		-1,
		181,
		174,
		184,
		177,
		190,
		193,
		178,
		180,
		198,
		211,
		205,
		215,
		230,
		225,
		-1,
		-1,
		-1,
		206,
		-1,
		222,
		-1,
		-1,
		213,
		254,
		201,
		183,
		179,
		165,
		172,
		166,
		168,
		173,
		192,
		187,
		196,
		201,
		205,
		228,
		217,
		256,
		-1,
		-1,
		67,
		-1,
		-1,
		-1,
		172,
		191,
		186,
		192,
		197,
		188,
		216,
		213,
		-1,
		162,
		195,
		163,
		177,
		173,
		180,
		185,
		191,
		195,
		202,
		218,
		217,
		212,
		248,
		239,
		245,
		-1,
		-1,
		60,
		49,
		26,
		32,
		-1,
		165,
		188,
		178,
		168,
		174,
		-1,
		-1,
		180,
		177,
		175,
		155,
		161,
		166,
		169,
		207,
		183,
		191,
		195,
		199,
		205,
		210,
		215,
		221,
		236,
		251,
		-1,
		71,
		112,
		105,
		16,
		12,
		18,
		-1,
		155,
		147,
		175,
		160,
		168,
		-1,
		-1,
		153,
		144,
		149,
		158,
		159,
		190,
		189,
		202,
		205,
		210,
		198,
		197,
		215,
		219,
		228,
		235,
		225,
		238,
		242,
		-1,
		64,
		88,
		24,
		19,
		0,
		14,
		-1,
		146,
		-1,
		-1,
		191,
		178,
		162,
		152,
		149,
		196,
		172,
		167,
		173,
		175,
		199,
		190,
		215,
		206,
		206,
		209,
		224,
		229,
		221,
		235,
		235,
		236,
		-1,
		63,
		68,
		30,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		207,
		-1,
		189,
		-1,
		172,
		176,
		180,
		183,
		198,
		185,
		192,
		209,
		215,
		204,
		214,
		210,
		211,
		220,
		231,
		243,
		242,
		243,
		136,
		91,
		58,
		37,
		95,
		110,
		114,
		-1,
		130,
		166,
		176,
		-1,
		216,
		-1,
		-1,
		-1,
		186,
		193,
		185,
		201,
		197,
		197,
		193,
		197,
		209,
		216,
		226,
		228,
		220,
		224,
		237,
		248,
		251,
		132,
		130,
		135,
		80,
		63,
		80,
		89,
		110,
		126,
		123,
		160,
		165,
		180,
		185,
		209,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		204,
		214,
		197,
		199,
		203,
		217,
		229,
		237,
		227,
		225,
		219,
		251,
		-1,
		132,
		131,
		120,
		117,
		93,
		84,
		71,
		81,
		-1,
		-1,
		124,
		151,
		135,
		139,
		155,
		180,
		-1,
		216,
		-1,
		-1,
		230,
		-1,
		-1,
		256,
		219,
		208,
		199,
		205,
		211,
		222,
		244,
		233,
		234,
		224,
		234,
		247,
		116,
		113,
		101,
		99,
		122,
		79,
		75,
		-1,
		106,
		109,
		115,
		122,
		139,
		169,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		249,
		252,
		241,
		-1,
		231,
		204,
		209,
		234,
		241,
		242,
		236,
		230,
		237,
		236,
		244,
		252,
		125,
		139,
		128,
		124,
		123,
		131,
		80,
		96,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		-1,
		255,
		242,
		-1,
		-1,
		249,
		242,
		230,
		218,
		208,
		218,
		226,
		226,
		229,
		233,
		228,
		239,
		231,
		235,
		252,
		-1,
		159,
		-1,
		111,
		103,
		118,
		133,
		141,
		-1,
		-1,
		-1,
		272,
		258,
		251,
		239,
		237,
		-1,
		283,
		267,
		248,
		-1,
		218,
		231,
		262,
		230,
		235,
		230,
		234,
		245,
		234,
		237,
		251,
		246,
		-1,
		-1,
		116,
		119,
		-1,
		-1,
		141,
		160,
		-1,
		263,
		252,
		237,
		229,
		-1,
		-1,
		255,
		251,
		-1,
		-1,
		219,
		244,
		233,
		241,
		236,
		238,
		244,
		247,
		236,
		240,
		252,
		-1,
		-1,
		123,
		124,
		129,
		-1,
		150,
		-1,
		265,
		-1,
		232,
		239,
		227,
		-1,
		-1,
		-1,
		257,
		220,
		241,
		251,
		256,
		254,
		245,
		242,
		249,
		247,
		243,
		254,
		-1,
		-1,
		-1,
		180,
		157,
		272,
		263,
		246,
		226,
		218,
		238,
		-1,
		245,
		-1,
		220,
		221,
		248,
		250,
		267,
		261,
		245,
		260,
		250,
		241,
		250,
		186,
		-1,
		161,
		220,
		203,
		232,
		198,
		210,
		266,
		-1,
		242,
		224,
		-1,
		252,
		242,
		284,
		265,
		258,
		245,
		252,
		254,
		247,
		-1,
		-1,
		-1,
		176,
		175,
		174,
		185,
		193,
		191,
		209,
		-1,
		254,
		236,
		215,
		232,
		232,
		223,
		231,
		274,
		270,
		263,
		265,
		255,
		-1,
		231,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		202,
		224,
		219,
		211,
		223,
		232,
		219,
		225,
		227,
		235,
		233,
		230,
		242,
		238,
		258,
		254,
		286,
		-1,
		238,
		-1,
		206,
		-1,
		-1,
		220,
		206,
		218,
		229,
		219,
		219,
		224,
		222,
		244,
		261,
		245,
		243,
		248,
		253,
		-1,
		248,
		249,
		-1,
		239,
		231,
		217,
		-1,
		210,
		-1,
		265,
		226,
		-1,
		251,
		231,
		-1,
		254,
		250,
		-1,
		-1,
		260,
		255,
		-1,
		-1,
		-1,
		240,
		220,
		260,
		244,
		-1,
		242,
		242,
		-1,
		-1,
		-1,
		274,
		264,
		-1,
		233,
		236,
		-1,
		227,
		233,
		262,
		244,
		248,
		-1,
		-1,
		-1,
		289,
		270,
		264,
		248,
		253,
		241,
		258,
		244,
		246,
		258,
		247,
		268,
		-1,
		-1,
		-1,
		261,
		253,
		253,
		-1,
		-1,
		271,
		254,
		254,
		267,
		-1,
		-1,
		-1,
		283,
		264,
		-1,
		-1,
		262,
		-1,
		-1,
		267,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		272,
		-1,
		-1,
		-1,
		263,
		270,
		278,
		-1,
		-1,
		-1,
		-1,
		291,
		292,
		318,
		293,
		-1,
		-1,
		-1,
		277,
		277,
		-1,
		-1,
		289,
		290,
		-1,
		-1,
		-1,
		305,
		289,
		-1,
		281,
		-1,
		-1,
		-1,
		296,
		-1,
		-1,
		314,
		-1,
		-1,
		-1,
		310,
		-1,
		316,
		291,
		298,
		-1,
		-1,
		-1,
		-1,
		323,
		315,
		329,
		-1,
		301,
		303,
		-1,
		351,
		-1,
		-1,
		338,
		329,
		-1,
		-1,
		306,
		313,
		335,
		338,
		368,
		-1,
		325
	],
	[
		-1,
		316,
		305,
		316,
		324,
		297,
		304,
		-1,
		325,
		327,
		293,
		287,
		326,
		297,
		303,
		314,
		-1,
		-1,
		-1,
		316,
		315,
		285,
		283,
		292,
		297,
		304,
		-1,
		327,
		-1,
		337,
		316,
		327,
		332,
		278,
		275,
		295,
		314,
		320,
		312,
		352,
		308,
		279,
		273,
		291,
		296,
		314,
		306,
		-1,
		279,
		269,
		291,
		295,
		307,
		290,
		-1,
		-1,
		273,
		274,
		280,
		292,
		297,
		302,
		-1,
		328,
		312,
		-1,
		-1,
		263,
		276,
		272,
		275,
		283,
		299,
		320,
		312,
		307,
		-1,
		-1,
		264,
		268,
		281,
		282,
		280,
		307,
		320,
		302,
		316,
		315,
		-1,
		252,
		270,
		279,
		288,
		294,
		283,
		281,
		299,
		301,
		307,
		310,
		-1,
		244,
		246,
		275,
		281,
		293,
		299,
		286,
		286,
		296,
		289,
		308,
		299,
		345,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		241,
		249,
		275,
		274,
		270,
		288,
		296,
		289,
		286,
		284,
		281,
		297,
		298,
		308,
		-1,
		-1,
		297,
		266,
		301,
		258,
		243,
		-1,
		237,
		256,
		262,
		266,
		271,
		279,
		293,
		289,
		-1,
		275,
		274,
		305,
		291,
		302,
		257,
		-1,
		-1,
		255,
		247,
		232,
		235,
		232,
		232,
		262,
		261,
		266,
		268,
		270,
		276,
		279,
		279,
		285,
		269,
		279,
		283,
		291,
		309,
		-1,
		-1,
		351,
		-1,
		-1,
		254,
		237,
		-1,
		220,
		227,
		227,
		244,
		234,
		255,
		270,
		274,
		282,
		284,
		272,
		274,
		271,
		284,
		272,
		266,
		291,
		295,
		286,
		307,
		302,
		-1,
		350,
		334,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		213,
		216,
		222,
		246,
		256,
		-1,
		277,
		275,
		299,
		293,
		290,
		277,
		265,
		278,
		263,
		270,
		269,
		273,
		275,
		308,
		283,
		305,
		302,
		321,
		326,
		320,
		329,
		-1,
		262,
		258,
		254,
		261,
		210,
		-1,
		-1,
		250,
		-1,
		264,
		277,
		284,
		279,
		282,
		294,
		285,
		272,
		261,
		272,
		261,
		258,
		266,
		272,
		286,
		278,
		277,
		295,
		305,
		313,
		317,
		323,
		-1,
		312,
		-1,
		254,
		238,
		240,
		212,
		233,
		-1,
		270,
		265,
		285,
		286,
		277,
		-1,
		280,
		283,
		290,
		268,
		253,
		270,
		262,
		260,
		265,
		267,
		281,
		272,
		290,
		297,
		295,
		299,
		319,
		331,
		272,
		262,
		-1,
		244,
		249,
		208,
		216,
		235,
		308,
		283,
		-1,
		278,
		-1,
		270,
		295,
		-1,
		274,
		270,
		252,
		253,
		248,
		263,
		269,
		263,
		260,
		278,
		281,
		288,
		292,
		308,
		-1,
		-1,
		257,
		261,
		250,
		201,
		220,
		244,
		281,
		276,
		265,
		264,
		-1,
		255,
		285,
		282,
		268,
		255,
		245,
		246,
		254,
		267,
		246,
		262,
		259,
		279,
		305,
		283,
		294,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		227,
		198,
		222,
		264,
		294,
		287,
		275,
		240,
		240,
		234,
		-1,
		275,
		258,
		254,
		243,
		241,
		254,
		249,
		265,
		257,
		255,
		274,
		286,
		277,
		285,
		-1,
		-1,
		-1,
		257,
		246,
		247,
		196,
		219,
		253,
		273,
		259,
		264,
		239,
		232,
		226,
		278,
		275,
		242,
		250,
		242,
		231,
		245,
		253,
		257,
		253,
		262,
		268,
		292,
		273,
		279,
		-1,
		-1,
		264,
		254,
		238,
		240,
		237,
		210,
		217,
		249,
		264,
		261,
		-1,
		231,
		-1,
		220,
		228,
		227,
		233,
		245,
		231,
		236,
		247,
		259,
		260,
		255,
		262,
		297,
		297,
		263,
		283,
		286,
		-1,
		-1,
		-1,
		257,
		255,
		230,
		207,
		191,
		227,
		-1,
		231,
		232,
		-1,
		225,
		219,
		225,
		224,
		231,
		228,
		228,
		242,
		250,
		246,
		262,
		265,
		247,
		271,
		-1,
		271,
		265,
		273,
		263,
		251,
		-1,
		-1,
		-1,
		253,
		232,
		225,
		245,
		186,
		238,
		-1,
		-1,
		216,
		209,
		-1,
		212,
		212,
		219,
		228,
		233,
		238,
		246,
		241,
		254,
		258,
		252,
		246,
		259,
		263,
		264,
		253,
		249,
		246,
		260,
		-1,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		206,
		-1,
		219,
		211,
		207,
		201,
		207,
		225,
		223,
		243,
		235,
		249,
		249,
		255,
		261,
		247,
		240,
		251,
		236,
		254,
		260,
		251,
		246,
		245,
		256,
		-1,
		273,
		259,
		230,
		-1,
		-1,
		219,
		-1,
		183,
		197,
		213,
		-1,
		241,
		220,
		243,
		221,
		235,
		231,
		269,
		270,
		248,
		253,
		261,
		249,
		252,
		241,
		244,
		236,
		258,
		255,
		239,
		241,
		250,
		-1,
		279,
		266,
		224,
		220,
		209,
		229,
		180,
		189,
		200,
		-1,
		-1,
		285,
		-1,
		219,
		236,
		245,
		243,
		259,
		248,
		255,
		272,
		246,
		241,
		246,
		235,
		235,
		230,
		249,
		235,
		233,
		248,
		264,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		195,
		182,
		176,
		-1,
		217,
		-1,
		263,
		253,
		237,
		222,
		255,
		-1,
		247,
		243,
		250,
		-1,
		266,
		-1,
		238,
		241,
		232,
		227,
		224,
		235,
		233,
		242,
		243,
		-1,
		229,
		214,
		207,
		197,
		211,
		182,
		-1,
		225,
		-1,
		-1,
		250,
		244,
		244,
		228,
		231,
		263,
		243,
		235,
		250,
		249,
		236,
		235,
		223,
		223,
		226,
		220,
		233,
		243,
		249,
		241,
		-1,
		-1,
		-1,
		234,
		186,
		194,
		170,
		191,
		-1,
		-1,
		312,
		267,
		253,
		-1,
		237,
		263,
		251,
		241,
		231,
		236,
		237,
		227,
		225,
		221,
		230,
		229,
		222,
		221,
		242,
		235,
		257,
		-1,
		-1,
		183,
		196,
		198,
		184,
		203,
		-1,
		-1,
		-1,
		259,
		275,
		267,
		238,
		252,
		-1,
		-1,
		235,
		228,
		222,
		225,
		213,
		233,
		240,
		228,
		215,
		230,
		240,
		248,
		247,
		-1,
		186,
		173,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		-1,
		-1,
		292,
		241,
		230,
		225,
		229,
		234,
		-1,
		208,
		219,
		212,
		231,
		238,
		230,
		215,
		209,
		220,
		235,
		252,
		-1,
		-1,
		220,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		249,
		247,
		218,
		211,
		215,
		-1,
		210,
		212,
		209,
		221,
		226,
		230,
		221,
		203,
		217,
		220,
		233,
		247,
		251,
		243,
		-1,
		225,
		-1,
		-1,
		-1,
		264,
		265,
		251,
		228,
		207,
		200,
		197,
		196,
		201,
		212,
		221,
		232,
		197,
		201,
		216,
		221,
		225,
		242,
		246,
		-1,
		-1,
		223,
		219,
		254,
		266,
		238,
		278,
		-1,
		-1,
		196,
		189,
		199,
		192,
		205,
		208,
		193,
		195,
		213,
		226,
		220,
		230,
		245,
		240,
		-1,
		-1,
		-1,
		221,
		-1,
		237,
		-1,
		-1,
		228,
		269,
		216,
		198,
		194,
		180,
		187,
		181,
		183,
		188,
		207,
		202,
		211,
		216,
		220,
		243,
		232,
		271,
		-1,
		-1,
		82,
		-1,
		-1,
		-1,
		187,
		206,
		201,
		207,
		212,
		203,
		231,
		228,
		-1,
		177,
		210,
		178,
		192,
		188,
		195,
		200,
		206,
		210,
		217,
		233,
		232,
		227,
		263,
		254,
		260,
		-1,
		-1,
		75,
		64,
		41,
		47,
		-1,
		180,
		203,
		193,
		183,
		189,
		-1,
		-1,
		195,
		192,
		190,
		170,
		176,
		181,
		184,
		222,
		198,
		206,
		210,
		214,
		220,
		225,
		230,
		236,
		251,
		266,
		-1,
		86,
		127,
		120,
		31,
		27,
		4,
		-1,
		170,
		162,
		190,
		175,
		183,
		-1,
		-1,
		168,
		159,
		164,
		173,
		174,
		205,
		204,
		217,
		220,
		225,
		213,
		212,
		230,
		234,
		243,
		250,
		240,
		253,
		257,
		-1,
		79,
		103,
		39,
		34,
		15,
		0,
		-1,
		161,
		-1,
		-1,
		206,
		193,
		177,
		167,
		164,
		211,
		187,
		182,
		188,
		190,
		214,
		205,
		230,
		221,
		221,
		224,
		239,
		244,
		236,
		250,
		250,
		251,
		-1,
		78,
		83,
		45,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		222,
		-1,
		204,
		-1,
		187,
		191,
		195,
		198,
		213,
		200,
		207,
		224,
		230,
		219,
		229,
		225,
		226,
		235,
		246,
		258,
		257,
		258,
		151,
		106,
		73,
		52,
		110,
		125,
		129,
		-1,
		145,
		181,
		191,
		-1,
		231,
		-1,
		-1,
		-1,
		201,
		208,
		200,
		216,
		212,
		212,
		208,
		212,
		224,
		231,
		241,
		243,
		235,
		239,
		252,
		263,
		266,
		147,
		145,
		150,
		95,
		78,
		95,
		104,
		125,
		141,
		138,
		175,
		180,
		195,
		200,
		224,
		-1,
		-1,
		224,
		218,
		-1,
		-1,
		219,
		229,
		212,
		214,
		218,
		232,
		244,
		252,
		242,
		240,
		234,
		266,
		-1,
		147,
		146,
		135,
		132,
		108,
		99,
		86,
		96,
		-1,
		-1,
		139,
		166,
		150,
		154,
		170,
		195,
		-1,
		231,
		-1,
		-1,
		245,
		-1,
		-1,
		271,
		234,
		223,
		214,
		220,
		226,
		237,
		259,
		248,
		249,
		239,
		249,
		262,
		131,
		128,
		116,
		114,
		137,
		94,
		90,
		-1,
		121,
		124,
		130,
		137,
		154,
		184,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		264,
		267,
		256,
		-1,
		246,
		219,
		224,
		249,
		256,
		257,
		251,
		245,
		252,
		251,
		259,
		267,
		140,
		154,
		143,
		139,
		138,
		146,
		95,
		111,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		-1,
		270,
		257,
		-1,
		-1,
		264,
		257,
		245,
		233,
		223,
		233,
		241,
		241,
		244,
		248,
		243,
		254,
		246,
		250,
		267,
		-1,
		174,
		-1,
		126,
		118,
		133,
		148,
		156,
		-1,
		-1,
		-1,
		287,
		273,
		266,
		254,
		252,
		-1,
		298,
		282,
		263,
		-1,
		233,
		246,
		277,
		245,
		250,
		245,
		249,
		260,
		249,
		252,
		266,
		261,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		156,
		175,
		-1,
		278,
		267,
		252,
		244,
		-1,
		-1,
		270,
		266,
		-1,
		-1,
		234,
		259,
		248,
		256,
		251,
		253,
		259,
		262,
		251,
		255,
		267,
		-1,
		-1,
		138,
		139,
		144,
		-1,
		165,
		-1,
		280,
		-1,
		247,
		254,
		242,
		-1,
		-1,
		-1,
		272,
		235,
		256,
		266,
		271,
		269,
		260,
		257,
		264,
		262,
		258,
		269,
		-1,
		-1,
		-1,
		195,
		172,
		287,
		278,
		261,
		241,
		233,
		253,
		-1,
		260,
		-1,
		235,
		236,
		263,
		265,
		282,
		276,
		260,
		275,
		265,
		256,
		265,
		201,
		-1,
		176,
		235,
		218,
		247,
		213,
		225,
		281,
		-1,
		257,
		239,
		-1,
		267,
		257,
		299,
		280,
		273,
		260,
		267,
		269,
		262,
		-1,
		-1,
		-1,
		191,
		190,
		189,
		200,
		208,
		206,
		224,
		-1,
		269,
		251,
		230,
		247,
		247,
		238,
		246,
		289,
		285,
		278,
		280,
		270,
		-1,
		246,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		217,
		239,
		234,
		226,
		238,
		247,
		234,
		240,
		242,
		250,
		248,
		245,
		257,
		253,
		273,
		269,
		301,
		-1,
		253,
		-1,
		221,
		-1,
		-1,
		235,
		221,
		233,
		244,
		234,
		234,
		239,
		237,
		259,
		276,
		260,
		258,
		263,
		268,
		-1,
		263,
		264,
		-1,
		254,
		246,
		232,
		-1,
		225,
		-1,
		280,
		241,
		-1,
		266,
		246,
		-1,
		269,
		265,
		-1,
		-1,
		275,
		270,
		-1,
		-1,
		-1,
		255,
		235,
		275,
		259,
		-1,
		257,
		257,
		-1,
		-1,
		-1,
		289,
		279,
		-1,
		248,
		251,
		-1,
		242,
		248,
		277,
		259,
		263,
		-1,
		-1,
		-1,
		304,
		285,
		279,
		263,
		268,
		256,
		273,
		259,
		261,
		273,
		262,
		283,
		-1,
		-1,
		-1,
		276,
		268,
		268,
		-1,
		-1,
		286,
		269,
		269,
		282,
		-1,
		-1,
		-1,
		298,
		279,
		-1,
		-1,
		277,
		-1,
		-1,
		282,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		287,
		-1,
		-1,
		-1,
		278,
		285,
		293,
		-1,
		-1,
		-1,
		-1,
		306,
		307,
		333,
		308,
		-1,
		-1,
		-1,
		292,
		292,
		-1,
		-1,
		304,
		305,
		-1,
		-1,
		-1,
		320,
		304,
		-1,
		296,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		329,
		-1,
		-1,
		-1,
		325,
		-1,
		331,
		306,
		313,
		-1,
		-1,
		-1,
		-1,
		338,
		330,
		344,
		-1,
		316,
		318,
		-1,
		366,
		-1,
		-1,
		353,
		344,
		-1,
		-1,
		321,
		328,
		350,
		353,
		383,
		-1,
		340
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		271,
		260,
		271,
		279,
		252,
		259,
		-1,
		280,
		282,
		248,
		242,
		281,
		252,
		258,
		269,
		-1,
		-1,
		-1,
		271,
		270,
		240,
		238,
		247,
		252,
		259,
		-1,
		264,
		-1,
		292,
		271,
		282,
		287,
		233,
		230,
		250,
		269,
		257,
		249,
		307,
		263,
		234,
		228,
		246,
		242,
		251,
		243,
		-1,
		234,
		224,
		246,
		231,
		242,
		234,
		-1,
		-1,
		228,
		229,
		235,
		227,
		233,
		229,
		-1,
		239,
		223,
		-1,
		-1,
		218,
		225,
		209,
		212,
		220,
		218,
		231,
		223,
		218,
		-1,
		-1,
		215,
		211,
		218,
		205,
		201,
		218,
		231,
		213,
		227,
		226,
		-1,
		207,
		225,
		234,
		212,
		210,
		194,
		192,
		210,
		212,
		218,
		218,
		-1,
		199,
		201,
		226,
		234,
		234,
		210,
		197,
		197,
		207,
		200,
		219,
		207,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		196,
		204,
		230,
		222,
		212,
		227,
		220,
		200,
		197,
		195,
		192,
		208,
		206,
		216,
		-1,
		-1,
		252,
		221,
		256,
		213,
		198,
		-1,
		192,
		206,
		212,
		216,
		210,
		203,
		217,
		213,
		-1,
		186,
		185,
		213,
		199,
		210,
		212,
		-1,
		-1,
		210,
		202,
		187,
		190,
		187,
		187,
		217,
		216,
		212,
		198,
		194,
		200,
		203,
		203,
		209,
		180,
		190,
		194,
		192,
		217,
		-1,
		-1,
		252,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		182,
		199,
		189,
		210,
		225,
		222,
		214,
		208,
		196,
		198,
		195,
		208,
		196,
		177,
		202,
		206,
		187,
		208,
		203,
		-1,
		251,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		211,
		-1,
		232,
		230,
		232,
		217,
		214,
		201,
		189,
		202,
		187,
		194,
		193,
		181,
		179,
		209,
		184,
		206,
		203,
		222,
		227,
		221,
		230,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		219,
		232,
		236,
		228,
		231,
		218,
		209,
		196,
		185,
		196,
		185,
		182,
		190,
		173,
		188,
		179,
		178,
		196,
		206,
		214,
		218,
		224,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		220,
		240,
		238,
		229,
		-1,
		227,
		224,
		214,
		192,
		177,
		194,
		186,
		184,
		186,
		168,
		182,
		173,
		191,
		198,
		196,
		200,
		220,
		232,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		263,
		235,
		-1,
		230,
		-1,
		222,
		242,
		-1,
		198,
		194,
		176,
		177,
		172,
		187,
		179,
		164,
		161,
		179,
		182,
		189,
		193,
		209,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		228,
		217,
		216,
		-1,
		207,
		212,
		209,
		197,
		184,
		169,
		170,
		178,
		190,
		169,
		163,
		160,
		180,
		206,
		184,
		195,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		246,
		239,
		227,
		192,
		192,
		186,
		-1,
		208,
		187,
		178,
		167,
		165,
		178,
		170,
		178,
		158,
		156,
		175,
		187,
		178,
		186,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		225,
		211,
		216,
		191,
		184,
		178,
		221,
		204,
		185,
		174,
		166,
		155,
		166,
		174,
		172,
		154,
		163,
		169,
		193,
		174,
		180,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		216,
		213,
		-1,
		183,
		-1,
		172,
		180,
		179,
		174,
		171,
		158,
		157,
		171,
		171,
		161,
		156,
		163,
		198,
		198,
		164,
		184,
		187,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		183,
		184,
		-1,
		177,
		171,
		177,
		176,
		177,
		162,
		166,
		168,
		171,
		159,
		165,
		166,
		148,
		172,
		-1,
		172,
		166,
		174,
		164,
		152,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		168,
		161,
		-1,
		164,
		164,
		171,
		169,
		165,
		167,
		164,
		153,
		166,
		159,
		153,
		147,
		160,
		164,
		165,
		154,
		150,
		147,
		161,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		176,
		168,
		159,
		153,
		159,
		177,
		175,
		193,
		177,
		179,
		175,
		167,
		162,
		148,
		141,
		152,
		137,
		155,
		161,
		152,
		147,
		146,
		157,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		154,
		170,
		-1,
		193,
		172,
		195,
		173,
		187,
		183,
		184,
		185,
		155,
		160,
		162,
		150,
		153,
		142,
		145,
		137,
		159,
		156,
		140,
		142,
		151,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		141,
		157,
		-1,
		-1,
		212,
		-1,
		166,
		168,
		197,
		195,
		174,
		149,
		156,
		174,
		147,
		142,
		147,
		136,
		136,
		131,
		150,
		136,
		134,
		149,
		165,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		174,
		-1,
		190,
		178,
		165,
		147,
		187,
		-1,
		148,
		144,
		151,
		-1,
		167,
		-1,
		139,
		142,
		133,
		128,
		125,
		136,
		134,
		143,
		144,
		-1,
		181,
		166,
		159,
		149,
		163,
		131,
		-1,
		165,
		-1,
		-1,
		177,
		171,
		171,
		140,
		137,
		164,
		144,
		136,
		151,
		150,
		137,
		136,
		124,
		124,
		127,
		121,
		134,
		144,
		150,
		142,
		-1,
		-1,
		-1,
		186,
		161,
		155,
		127,
		131,
		-1,
		-1,
		238,
		194,
		180,
		-1,
		132,
		164,
		152,
		142,
		132,
		137,
		138,
		128,
		126,
		122,
		131,
		130,
		123,
		122,
		143,
		136,
		158,
		-1,
		-1,
		160,
		153,
		141,
		109,
		104,
		-1,
		-1,
		-1,
		184,
		170,
		158,
		130,
		153,
		-1,
		-1,
		136,
		129,
		123,
		121,
		114,
		134,
		141,
		129,
		116,
		131,
		141,
		149,
		148,
		-1,
		163,
		150,
		-1,
		-1,
		103,
		93,
		-1,
		-1,
		-1,
		-1,
		148,
		129,
		124,
		119,
		123,
		135,
		-1,
		108,
		112,
		112,
		132,
		139,
		131,
		116,
		110,
		121,
		136,
		153,
		-1,
		-1,
		117,
		-1,
		79,
		-1,
		-1,
		-1,
		-1,
		120,
		135,
		112,
		105,
		109,
		-1,
		106,
		105,
		109,
		115,
		127,
		131,
		122,
		104,
		118,
		121,
		134,
		148,
		152,
		140,
		-1,
		70,
		-1,
		-1,
		-1,
		112,
		113,
		145,
		122,
		101,
		94,
		91,
		97,
		101,
		113,
		122,
		133,
		98,
		102,
		117,
		122,
		126,
		143,
		147,
		-1,
		-1,
		68,
		64,
		99,
		111,
		86,
		172,
		-1,
		-1,
		90,
		83,
		93,
		93,
		106,
		109,
		94,
		96,
		114,
		127,
		121,
		131,
		146,
		141,
		-1,
		-1,
		-1,
		63,
		-1,
		82,
		-1,
		-1,
		76,
		163,
		110,
		92,
		88,
		74,
		88,
		82,
		84,
		89,
		108,
		103,
		112,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		29,
		51,
		45,
		55,
		60,
		51,
		125,
		122,
		-1,
		70,
		111,
		79,
		93,
		89,
		96,
		101,
		107,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		163,
		152,
		141,
		147,
		-1,
		22,
		48,
		41,
		31,
		37,
		-1,
		-1,
		84,
		81,
		84,
		71,
		77,
		82,
		85,
		123,
		99,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		117,
		154,
		147,
		115,
		123,
		154,
		-1,
		12,
		10,
		32,
		23,
		31,
		-1,
		-1,
		57,
		53,
		58,
		67,
		70,
		106,
		105,
		118,
		121,
		126,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		110,
		130,
		109,
		112,
		136,
		150,
		-1,
		0,
		-1,
		-1,
		54,
		44,
		52,
		48,
		52,
		105,
		81,
		76,
		89,
		91,
		115,
		106,
		131,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		99,
		110,
		103,
		-1,
		-1,
		-1,
		-1,
		7,
		-1,
		-1,
		70,
		-1,
		78,
		-1,
		71,
		75,
		89,
		92,
		114,
		101,
		108,
		125,
		131,
		120,
		130,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		124,
		80,
		83,
		94,
		105,
		120,
		124,
		-1,
		18,
		57,
		106,
		-1,
		79,
		-1,
		-1,
		-1,
		85,
		102,
		94,
		110,
		113,
		113,
		109,
		113,
		125,
		132,
		142,
		144,
		136,
		140,
		153,
		164,
		167,
		120,
		111,
		124,
		69,
		69,
		90,
		99,
		120,
		33,
		24,
		51,
		95,
		104,
		99,
		86,
		-1,
		-1,
		108,
		112,
		-1,
		-1,
		120,
		130,
		113,
		115,
		119,
		133,
		145,
		153,
		143,
		141,
		135,
		167,
		-1,
		113,
		112,
		101,
		98,
		74,
		65,
		60,
		87,
		-1,
		-1,
		36,
		52,
		65,
		69,
		85,
		110,
		-1,
		89,
		-1,
		-1,
		129,
		-1,
		-1,
		172,
		135,
		124,
		115,
		121,
		127,
		138,
		160,
		149,
		150,
		140,
		150,
		163,
		97,
		94,
		82,
		80,
		103,
		68,
		56,
		-1,
		51,
		39,
		45,
		52,
		69,
		99,
		-1,
		-1,
		105,
		96,
		-1,
		-1,
		148,
		155,
		157,
		-1,
		147,
		120,
		125,
		150,
		157,
		158,
		152,
		146,
		153,
		152,
		160,
		168,
		106,
		120,
		109,
		105,
		104,
		112,
		61,
		54,
		54,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		140,
		115,
		-1,
		-1,
		155,
		158,
		146,
		134,
		124,
		134,
		142,
		142,
		145,
		149,
		144,
		155,
		147,
		151,
		168,
		-1,
		140,
		-1,
		92,
		60,
		80,
		95,
		103,
		-1,
		-1,
		-1,
		157,
		143,
		136,
		124,
		122,
		-1,
		199,
		183,
		164,
		-1,
		134,
		147,
		178,
		146,
		151,
		146,
		150,
		161,
		150,
		153,
		167,
		162,
		-1,
		-1,
		78,
		81,
		-1,
		-1,
		105,
		124,
		-1,
		148,
		137,
		122,
		114,
		-1,
		-1,
		171,
		167,
		-1,
		-1,
		135,
		160,
		149,
		157,
		152,
		154,
		160,
		163,
		152,
		156,
		168,
		-1,
		-1,
		85,
		88,
		93,
		-1,
		114,
		-1,
		172,
		-1,
		117,
		133,
		135,
		-1,
		-1,
		-1,
		173,
		136,
		157,
		167,
		172,
		170,
		161,
		158,
		165,
		163,
		159,
		170,
		-1,
		-1,
		-1,
		144,
		121,
		179,
		170,
		153,
		133,
		125,
		150,
		-1,
		161,
		-1,
		136,
		137,
		164,
		166,
		183,
		177,
		161,
		176,
		166,
		157,
		166,
		150,
		-1,
		125,
		184,
		167,
		139,
		139,
		138,
		182,
		-1,
		158,
		140,
		-1,
		168,
		158,
		200,
		181,
		174,
		161,
		168,
		170,
		163,
		-1,
		-1,
		-1,
		140,
		139,
		138,
		149,
		157,
		144,
		139,
		-1,
		170,
		152,
		131,
		148,
		148,
		139,
		147,
		190,
		186,
		179,
		181,
		171,
		-1,
		212,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		166,
		179,
		152,
		140,
		153,
		149,
		135,
		141,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		170,
		202,
		-1,
		219,
		-1,
		170,
		-1,
		-1,
		184,
		170,
		174,
		163,
		152,
		150,
		148,
		139,
		161,
		177,
		161,
		159,
		164,
		169,
		-1,
		229,
		230,
		-1,
		203,
		195,
		181,
		-1,
		174,
		-1,
		198,
		159,
		-1,
		168,
		148,
		-1,
		170,
		166,
		-1,
		-1,
		241,
		219,
		-1,
		-1,
		-1,
		204,
		184,
		193,
		177,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		244,
		228,
		-1,
		197,
		200,
		-1,
		191,
		197,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		253,
		234,
		228,
		212,
		217,
		205,
		222,
		208,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		225,
		217,
		217,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		247,
		228,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		236,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		257,
		258,
		282,
		256,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		260,
		258,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		268,
		257,
		268,
		276,
		249,
		256,
		-1,
		277,
		279,
		245,
		239,
		278,
		249,
		255,
		266,
		-1,
		-1,
		-1,
		268,
		267,
		237,
		235,
		244,
		249,
		256,
		-1,
		279,
		-1,
		289,
		268,
		279,
		284,
		230,
		227,
		247,
		266,
		272,
		264,
		304,
		260,
		231,
		225,
		243,
		248,
		266,
		258,
		-1,
		231,
		221,
		243,
		247,
		259,
		242,
		-1,
		-1,
		225,
		226,
		232,
		244,
		249,
		251,
		-1,
		261,
		245,
		-1,
		-1,
		215,
		228,
		224,
		227,
		235,
		240,
		253,
		245,
		240,
		-1,
		-1,
		216,
		220,
		233,
		227,
		223,
		240,
		253,
		235,
		249,
		248,
		-1,
		204,
		222,
		231,
		234,
		232,
		216,
		214,
		232,
		234,
		240,
		240,
		-1,
		196,
		198,
		227,
		233,
		245,
		232,
		219,
		219,
		229,
		222,
		241,
		229,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		193,
		201,
		227,
		226,
		222,
		240,
		242,
		222,
		219,
		217,
		214,
		230,
		228,
		238,
		-1,
		-1,
		249,
		218,
		253,
		210,
		195,
		-1,
		189,
		208,
		214,
		218,
		223,
		225,
		239,
		235,
		-1,
		208,
		207,
		235,
		221,
		232,
		209,
		-1,
		-1,
		207,
		199,
		184,
		187,
		184,
		184,
		214,
		213,
		218,
		220,
		216,
		222,
		225,
		225,
		231,
		202,
		212,
		216,
		214,
		239,
		-1,
		-1,
		274,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		179,
		196,
		186,
		207,
		222,
		226,
		234,
		230,
		218,
		220,
		217,
		230,
		218,
		199,
		224,
		228,
		209,
		230,
		225,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		208,
		-1,
		229,
		227,
		251,
		239,
		236,
		223,
		211,
		224,
		209,
		216,
		215,
		203,
		201,
		231,
		206,
		228,
		225,
		244,
		249,
		243,
		252,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		216,
		229,
		233,
		231,
		234,
		240,
		231,
		218,
		207,
		218,
		207,
		204,
		212,
		195,
		210,
		201,
		200,
		218,
		228,
		236,
		240,
		246,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		217,
		237,
		235,
		226,
		-1,
		229,
		232,
		236,
		214,
		199,
		216,
		208,
		206,
		208,
		190,
		204,
		195,
		213,
		220,
		218,
		222,
		242,
		254,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		260,
		232,
		-1,
		227,
		-1,
		219,
		244,
		-1,
		220,
		216,
		198,
		199,
		194,
		209,
		201,
		186,
		183,
		201,
		204,
		211,
		215,
		231,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		225,
		214,
		213,
		-1,
		204,
		234,
		231,
		217,
		204,
		191,
		192,
		200,
		212,
		191,
		185,
		182,
		202,
		228,
		206,
		217,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		243,
		236,
		224,
		189,
		189,
		183,
		-1,
		224,
		207,
		200,
		189,
		187,
		200,
		192,
		200,
		180,
		178,
		197,
		209,
		200,
		208,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		222,
		208,
		213,
		188,
		181,
		175,
		227,
		224,
		191,
		196,
		188,
		177,
		188,
		196,
		194,
		176,
		185,
		191,
		215,
		196,
		202,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		213,
		210,
		-1,
		180,
		-1,
		169,
		177,
		176,
		182,
		193,
		180,
		179,
		193,
		193,
		183,
		178,
		185,
		220,
		220,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		180,
		181,
		-1,
		174,
		168,
		174,
		173,
		180,
		177,
		177,
		190,
		193,
		181,
		187,
		188,
		170,
		194,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		165,
		158,
		-1,
		161,
		161,
		168,
		177,
		182,
		187,
		186,
		175,
		188,
		181,
		175,
		169,
		182,
		186,
		187,
		176,
		172,
		169,
		183,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		173,
		165,
		156,
		150,
		156,
		174,
		172,
		192,
		184,
		198,
		197,
		189,
		184,
		170,
		163,
		174,
		159,
		177,
		183,
		174,
		169,
		168,
		179,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		151,
		167,
		-1,
		190,
		169,
		192,
		170,
		184,
		180,
		206,
		207,
		177,
		182,
		184,
		172,
		175,
		164,
		167,
		159,
		181,
		178,
		162,
		164,
		173,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		138,
		154,
		-1,
		-1,
		228,
		-1,
		168,
		184,
		194,
		192,
		196,
		171,
		178,
		196,
		169,
		164,
		169,
		158,
		158,
		153,
		172,
		158,
		156,
		171,
		187,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		171,
		-1,
		206,
		194,
		181,
		163,
		203,
		-1,
		170,
		166,
		173,
		-1,
		189,
		-1,
		161,
		164,
		155,
		150,
		147,
		158,
		156,
		165,
		166,
		-1,
		178,
		163,
		156,
		146,
		160,
		128,
		-1,
		162,
		-1,
		-1,
		193,
		187,
		187,
		156,
		153,
		186,
		166,
		158,
		173,
		172,
		159,
		158,
		146,
		146,
		149,
		143,
		156,
		166,
		172,
		164,
		-1,
		-1,
		-1,
		183,
		158,
		152,
		124,
		128,
		-1,
		-1,
		254,
		210,
		196,
		-1,
		148,
		186,
		174,
		164,
		154,
		159,
		160,
		150,
		148,
		144,
		153,
		152,
		145,
		144,
		165,
		158,
		180,
		-1,
		-1,
		157,
		150,
		138,
		106,
		101,
		-1,
		-1,
		-1,
		200,
		186,
		174,
		146,
		175,
		-1,
		-1,
		158,
		151,
		145,
		143,
		136,
		156,
		163,
		151,
		138,
		153,
		163,
		171,
		170,
		-1,
		160,
		147,
		-1,
		-1,
		100,
		90,
		-1,
		-1,
		-1,
		-1,
		164,
		145,
		146,
		141,
		145,
		157,
		-1,
		130,
		134,
		134,
		154,
		161,
		153,
		138,
		132,
		143,
		158,
		175,
		-1,
		-1,
		114,
		-1,
		76,
		-1,
		-1,
		-1,
		-1,
		136,
		151,
		134,
		127,
		131,
		-1,
		128,
		127,
		131,
		137,
		149,
		153,
		144,
		126,
		140,
		143,
		156,
		170,
		174,
		137,
		-1,
		67,
		-1,
		-1,
		-1,
		113,
		135,
		167,
		144,
		123,
		116,
		113,
		119,
		123,
		135,
		144,
		155,
		120,
		124,
		139,
		144,
		148,
		165,
		169,
		-1,
		-1,
		65,
		61,
		96,
		108,
		108,
		194,
		-1,
		-1,
		112,
		105,
		115,
		115,
		128,
		131,
		116,
		118,
		136,
		149,
		143,
		153,
		168,
		163,
		-1,
		-1,
		-1,
		77,
		-1,
		79,
		-1,
		-1,
		98,
		185,
		132,
		114,
		110,
		96,
		110,
		104,
		106,
		111,
		130,
		125,
		134,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		84,
		48,
		43,
		77,
		82,
		73,
		147,
		144,
		-1,
		92,
		133,
		101,
		115,
		111,
		118,
		123,
		129,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		221,
		210,
		199,
		205,
		-1,
		77,
		45,
		63,
		53,
		59,
		-1,
		-1,
		106,
		103,
		106,
		93,
		99,
		104,
		107,
		145,
		121,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		175,
		212,
		205,
		173,
		181,
		212,
		-1,
		67,
		59,
		42,
		45,
		53,
		-1,
		-1,
		79,
		75,
		80,
		89,
		92,
		128,
		127,
		140,
		143,
		148,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		168,
		188,
		167,
		170,
		194,
		208,
		-1,
		64,
		-1,
		-1,
		0,
		66,
		74,
		70,
		74,
		127,
		103,
		98,
		111,
		113,
		137,
		128,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		157,
		168,
		161,
		-1,
		-1,
		-1,
		-1,
		65,
		-1,
		-1,
		16,
		-1,
		100,
		-1,
		93,
		97,
		111,
		114,
		136,
		123,
		130,
		147,
		153,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		182,
		138,
		141,
		152,
		163,
		178,
		182,
		-1,
		76,
		115,
		65,
		-1,
		25,
		-1,
		-1,
		-1,
		107,
		124,
		116,
		132,
		135,
		135,
		131,
		135,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		178,
		169,
		182,
		127,
		127,
		148,
		157,
		178,
		91,
		82,
		109,
		72,
		61,
		56,
		35,
		-1,
		-1,
		130,
		134,
		-1,
		-1,
		142,
		152,
		135,
		137,
		141,
		155,
		167,
		175,
		165,
		163,
		157,
		189,
		-1,
		171,
		170,
		159,
		156,
		132,
		123,
		118,
		145,
		-1,
		-1,
		94,
		110,
		123,
		105,
		103,
		128,
		-1,
		46,
		-1,
		-1,
		151,
		-1,
		-1,
		185,
		157,
		146,
		137,
		143,
		149,
		160,
		182,
		171,
		172,
		162,
		172,
		185,
		155,
		152,
		140,
		138,
		161,
		126,
		114,
		-1,
		109,
		97,
		103,
		110,
		106,
		117,
		-1,
		-1,
		62,
		53,
		-1,
		-1,
		170,
		177,
		170,
		-1,
		160,
		142,
		147,
		172,
		179,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		164,
		178,
		167,
		163,
		162,
		170,
		119,
		112,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		97,
		72,
		-1,
		-1,
		177,
		171,
		159,
		147,
		137,
		147,
		164,
		164,
		167,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		198,
		-1,
		150,
		118,
		138,
		153,
		161,
		-1,
		-1,
		-1,
		114,
		100,
		93,
		81,
		79,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		200,
		168,
		173,
		168,
		172,
		183,
		172,
		175,
		187,
		184,
		-1,
		-1,
		136,
		139,
		-1,
		-1,
		152,
		154,
		-1,
		105,
		94,
		79,
		71,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		134,
		172,
		171,
		179,
		174,
		176,
		182,
		185,
		174,
		178,
		184,
		-1,
		-1,
		143,
		146,
		151,
		-1,
		137,
		-1,
		129,
		-1,
		74,
		90,
		92,
		-1,
		-1,
		-1,
		165,
		128,
		144,
		167,
		193,
		191,
		182,
		175,
		182,
		185,
		178,
		184,
		-1,
		-1,
		-1,
		155,
		129,
		136,
		127,
		110,
		90,
		82,
		107,
		-1,
		146,
		-1,
		121,
		124,
		149,
		188,
		190,
		176,
		172,
		185,
		179,
		176,
		174,
		161,
		-1,
		131,
		164,
		128,
		96,
		96,
		95,
		160,
		-1,
		143,
		125,
		-1,
		153,
		143,
		191,
		166,
		175,
		168,
		162,
		163,
		171,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		116,
		101,
		96,
		-1,
		148,
		130,
		116,
		133,
		133,
		124,
		132,
		181,
		177,
		180,
		178,
		156,
		-1,
		247,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		136,
		109,
		97,
		111,
		118,
		113,
		115,
		128,
		136,
		134,
		131,
		143,
		139,
		159,
		155,
		187,
		-1,
		242,
		-1,
		163,
		-1,
		-1,
		143,
		129,
		131,
		120,
		109,
		107,
		110,
		108,
		130,
		160,
		146,
		144,
		149,
		154,
		-1,
		231,
		230,
		-1,
		162,
		154,
		140,
		-1,
		133,
		-1,
		155,
		116,
		-1,
		137,
		117,
		-1,
		155,
		151,
		-1,
		-1,
		218,
		178,
		-1,
		-1,
		-1,
		163,
		143,
		150,
		134,
		-1,
		128,
		128,
		-1,
		-1,
		-1,
		203,
		187,
		-1,
		156,
		159,
		-1,
		150,
		156,
		183,
		130,
		134,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		171,
		176,
		164,
		181,
		167,
		166,
		144,
		133,
		154,
		-1,
		-1,
		-1,
		184,
		176,
		176,
		-1,
		-1,
		191,
		174,
		155,
		153,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		181,
		-1,
		-1,
		187,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		195,
		-1,
		-1,
		-1,
		177,
		173,
		174,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		241,
		216,
		-1,
		-1,
		-1,
		169,
		163,
		-1,
		-1,
		219,
		217,
		-1,
		-1,
		-1,
		197,
		181,
		-1,
		167,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		202,
		-1,
		202,
		177,
		184,
		-1,
		-1,
		-1,
		-1,
		215,
		207,
		215,
		-1,
		187,
		189,
		-1,
		237,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		192,
		199,
		221,
		224,
		260,
		-1,
		211
	],
	[
		-1,
		265,
		254,
		265,
		273,
		246,
		253,
		-1,
		272,
		276,
		242,
		236,
		275,
		244,
		250,
		261,
		-1,
		-1,
		-1,
		265,
		264,
		232,
		230,
		239,
		244,
		251,
		-1,
		250,
		-1,
		286,
		265,
		276,
		281,
		225,
		222,
		242,
		261,
		243,
		235,
		301,
		255,
		226,
		220,
		238,
		228,
		237,
		229,
		-1,
		226,
		216,
		238,
		217,
		228,
		220,
		-1,
		-1,
		220,
		221,
		227,
		213,
		219,
		215,
		-1,
		225,
		209,
		-1,
		-1,
		210,
		211,
		195,
		198,
		206,
		204,
		217,
		209,
		204,
		-1,
		-1,
		201,
		197,
		204,
		191,
		187,
		204,
		217,
		199,
		213,
		212,
		-1,
		207,
		225,
		230,
		198,
		196,
		180,
		178,
		196,
		198,
		204,
		204,
		-1,
		204,
		206,
		212,
		220,
		220,
		196,
		183,
		183,
		193,
		186,
		205,
		193,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		199,
		216,
		208,
		198,
		213,
		206,
		186,
		183,
		181,
		178,
		194,
		192,
		202,
		-1,
		-1,
		257,
		226,
		261,
		218,
		203,
		-1,
		197,
		192,
		198,
		202,
		196,
		189,
		203,
		199,
		-1,
		172,
		171,
		199,
		185,
		196,
		217,
		-1,
		-1,
		215,
		207,
		192,
		195,
		192,
		192,
		207,
		206,
		198,
		184,
		180,
		186,
		189,
		189,
		195,
		166,
		176,
		180,
		178,
		203,
		-1,
		-1,
		238,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		187,
		204,
		194,
		215,
		217,
		208,
		200,
		194,
		182,
		184,
		181,
		194,
		182,
		163,
		188,
		192,
		173,
		194,
		189,
		-1,
		237,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		216,
		-1,
		229,
		217,
		218,
		203,
		200,
		187,
		175,
		188,
		173,
		180,
		179,
		167,
		165,
		195,
		170,
		192,
		189,
		208,
		213,
		207,
		216,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		224,
		237,
		232,
		214,
		217,
		204,
		195,
		182,
		171,
		182,
		171,
		168,
		176,
		159,
		174,
		165,
		164,
		182,
		192,
		200,
		204,
		210,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		225,
		245,
		234,
		225,
		-1,
		213,
		210,
		200,
		178,
		163,
		180,
		172,
		170,
		172,
		154,
		168,
		159,
		177,
		184,
		182,
		186,
		206,
		218,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		267,
		231,
		-1,
		226,
		-1,
		215,
		228,
		-1,
		184,
		180,
		162,
		163,
		158,
		173,
		165,
		150,
		147,
		165,
		168,
		175,
		179,
		195,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		224,
		213,
		212,
		-1,
		203,
		198,
		195,
		183,
		170,
		155,
		156,
		164,
		176,
		155,
		149,
		146,
		166,
		192,
		170,
		182,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		242,
		235,
		223,
		188,
		188,
		182,
		-1,
		194,
		173,
		164,
		153,
		151,
		164,
		156,
		164,
		144,
		142,
		161,
		173,
		164,
		174,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		221,
		207,
		212,
		187,
		180,
		174,
		207,
		190,
		171,
		160,
		152,
		141,
		152,
		160,
		158,
		140,
		149,
		155,
		179,
		162,
		168,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		212,
		218,
		-1,
		179,
		-1,
		168,
		176,
		165,
		160,
		157,
		144,
		143,
		157,
		157,
		147,
		142,
		149,
		184,
		184,
		152,
		172,
		175,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		188,
		189,
		-1,
		173,
		167,
		173,
		167,
		163,
		148,
		152,
		154,
		157,
		145,
		151,
		152,
		134,
		158,
		-1,
		160,
		154,
		162,
		152,
		140,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		173,
		166,
		-1,
		160,
		158,
		160,
		153,
		147,
		153,
		149,
		139,
		152,
		145,
		139,
		133,
		146,
		150,
		153,
		142,
		138,
		135,
		149,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		181,
		173,
		164,
		158,
		159,
		170,
		169,
		175,
		159,
		162,
		157,
		153,
		144,
		134,
		127,
		138,
		123,
		141,
		149,
		140,
		135,
		134,
		145,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		159,
		175,
		-1,
		197,
		176,
		191,
		169,
		173,
		172,
		166,
		167,
		137,
		142,
		144,
		132,
		135,
		128,
		131,
		123,
		145,
		144,
		128,
		130,
		139,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		146,
		162,
		-1,
		-1,
		197,
		-1,
		151,
		153,
		186,
		184,
		156,
		131,
		138,
		156,
		129,
		124,
		133,
		122,
		120,
		117,
		138,
		124,
		122,
		137,
		153,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		179,
		-1,
		175,
		163,
		150,
		132,
		172,
		-1,
		130,
		126,
		133,
		-1,
		149,
		-1,
		121,
		124,
		115,
		112,
		111,
		122,
		120,
		131,
		132,
		-1,
		186,
		171,
		164,
		154,
		168,
		136,
		-1,
		170,
		-1,
		-1,
		162,
		156,
		156,
		125,
		122,
		146,
		126,
		118,
		133,
		132,
		119,
		118,
		106,
		106,
		109,
		109,
		122,
		132,
		138,
		130,
		-1,
		-1,
		-1,
		191,
		166,
		160,
		132,
		136,
		-1,
		-1,
		223,
		179,
		165,
		-1,
		117,
		146,
		134,
		124,
		114,
		119,
		120,
		110,
		108,
		104,
		113,
		117,
		111,
		110,
		131,
		124,
		146,
		-1,
		-1,
		165,
		158,
		146,
		114,
		109,
		-1,
		-1,
		-1,
		169,
		155,
		143,
		115,
		135,
		-1,
		-1,
		118,
		111,
		105,
		103,
		96,
		116,
		123,
		117,
		104,
		119,
		129,
		137,
		136,
		-1,
		168,
		155,
		-1,
		-1,
		108,
		98,
		-1,
		-1,
		-1,
		-1,
		133,
		114,
		106,
		101,
		105,
		117,
		-1,
		90,
		94,
		94,
		114,
		121,
		119,
		104,
		98,
		109,
		124,
		141,
		-1,
		-1,
		122,
		-1,
		84,
		-1,
		-1,
		-1,
		-1,
		105,
		120,
		94,
		87,
		91,
		-1,
		88,
		87,
		91,
		97,
		110,
		115,
		110,
		92,
		106,
		109,
		122,
		136,
		140,
		145,
		-1,
		75,
		-1,
		-1,
		-1,
		97,
		98,
		127,
		104,
		83,
		76,
		73,
		79,
		83,
		99,
		105,
		116,
		86,
		90,
		105,
		110,
		114,
		131,
		135,
		-1,
		-1,
		73,
		69,
		104,
		105,
		71,
		154,
		-1,
		-1,
		72,
		65,
		75,
		81,
		89,
		92,
		82,
		84,
		102,
		115,
		109,
		119,
		134,
		129,
		-1,
		-1,
		-1,
		85,
		-1,
		87,
		-1,
		-1,
		61,
		145,
		92,
		74,
		70,
		56,
		76,
		70,
		72,
		77,
		96,
		91,
		100,
		105,
		109,
		132,
		121,
		160,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		64,
		56,
		50,
		53,
		45,
		36,
		107,
		104,
		-1,
		52,
		95,
		67,
		81,
		77,
		84,
		89,
		95,
		99,
		106,
		122,
		121,
		116,
		152,
		143,
		149,
		-1,
		-1,
		201,
		190,
		179,
		185,
		-1,
		57,
		53,
		39,
		29,
		22,
		-1,
		-1,
		69,
		66,
		72,
		59,
		65,
		70,
		73,
		111,
		87,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		140,
		155,
		-1,
		155,
		192,
		185,
		153,
		161,
		192,
		-1,
		47,
		39,
		49,
		25,
		13,
		-1,
		-1,
		42,
		41,
		46,
		55,
		58,
		94,
		93,
		106,
		109,
		114,
		102,
		101,
		119,
		123,
		132,
		139,
		129,
		142,
		146,
		-1,
		148,
		168,
		147,
		150,
		174,
		188,
		-1,
		44,
		-1,
		-1,
		56,
		0,
		22,
		34,
		38,
		93,
		69,
		64,
		77,
		79,
		103,
		94,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		139,
		139,
		140,
		-1,
		137,
		148,
		141,
		-1,
		-1,
		-1,
		-1,
		45,
		-1,
		-1,
		72,
		-1,
		48,
		-1,
		53,
		57,
		77,
		80,
		102,
		89,
		96,
		113,
		119,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		146,
		147,
		162,
		118,
		121,
		132,
		143,
		158,
		162,
		-1,
		56,
		95,
		110,
		-1,
		81,
		-1,
		-1,
		-1,
		67,
		90,
		82,
		98,
		101,
		101,
		97,
		101,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		155,
		158,
		149,
		162,
		107,
		107,
		128,
		137,
		158,
		71,
		62,
		89,
		117,
		106,
		101,
		88,
		-1,
		-1,
		90,
		100,
		-1,
		-1,
		108,
		118,
		101,
		103,
		107,
		121,
		133,
		141,
		131,
		129,
		123,
		155,
		-1,
		151,
		150,
		139,
		136,
		112,
		103,
		98,
		125,
		-1,
		-1,
		74,
		90,
		103,
		107,
		123,
		148,
		-1,
		91,
		-1,
		-1,
		111,
		-1,
		-1,
		160,
		123,
		112,
		103,
		109,
		115,
		126,
		148,
		137,
		138,
		128,
		138,
		151,
		135,
		132,
		120,
		118,
		141,
		106,
		94,
		-1,
		89,
		77,
		83,
		90,
		107,
		137,
		-1,
		-1,
		107,
		98,
		-1,
		-1,
		130,
		137,
		145,
		-1,
		135,
		108,
		113,
		138,
		145,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		144,
		158,
		147,
		143,
		142,
		150,
		99,
		92,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		117,
		-1,
		-1,
		137,
		144,
		134,
		122,
		112,
		122,
		130,
		130,
		133,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		178,
		-1,
		130,
		98,
		118,
		133,
		141,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		187,
		171,
		152,
		-1,
		122,
		135,
		166,
		134,
		139,
		134,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		116,
		119,
		-1,
		-1,
		143,
		162,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		159,
		155,
		-1,
		-1,
		123,
		148,
		137,
		145,
		140,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		123,
		126,
		131,
		-1,
		152,
		-1,
		174,
		-1,
		119,
		135,
		137,
		-1,
		-1,
		-1,
		161,
		124,
		145,
		155,
		160,
		158,
		149,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		182,
		159,
		181,
		172,
		155,
		135,
		127,
		152,
		-1,
		149,
		-1,
		124,
		125,
		152,
		154,
		171,
		165,
		149,
		164,
		154,
		145,
		154,
		188,
		-1,
		163,
		209,
		173,
		141,
		141,
		140,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		188,
		169,
		162,
		149,
		156,
		158,
		151,
		-1,
		-1,
		-1,
		178,
		177,
		169,
		163,
		161,
		146,
		141,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		178,
		174,
		167,
		169,
		159,
		-1,
		250,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		172,
		174,
		147,
		135,
		141,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		158,
		190,
		-1,
		257,
		-1,
		208,
		-1,
		-1,
		188,
		174,
		169,
		158,
		147,
		145,
		136,
		127,
		149,
		165,
		149,
		147,
		152,
		157,
		-1,
		267,
		268,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		193,
		154,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		257,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		188,
		172,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		242,
		232,
		-1,
		201,
		204,
		-1,
		195,
		194,
		202,
		149,
		153,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		216,
		221,
		209,
		215,
		201,
		185,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		223,
		215,
		208,
		-1,
		-1,
		210,
		193,
		174,
		172,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		200,
		-1,
		-1,
		206,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		234,
		-1,
		-1,
		-1,
		196,
		192,
		193,
		-1,
		-1,
		-1,
		-1,
		256,
		257,
		280,
		244,
		-1,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		259,
		257,
		-1,
		-1,
		-1,
		216,
		200,
		-1,
		186,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		221,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		234,
		226,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		249,
		240,
		-1,
		-1,
		211,
		218,
		240,
		243,
		279,
		-1,
		230
	],
	[
		-1,
		245,
		234,
		245,
		253,
		226,
		233,
		-1,
		252,
		256,
		222,
		216,
		255,
		224,
		230,
		241,
		-1,
		-1,
		-1,
		245,
		244,
		212,
		210,
		219,
		224,
		231,
		-1,
		230,
		-1,
		266,
		245,
		256,
		261,
		205,
		202,
		222,
		241,
		223,
		215,
		281,
		235,
		206,
		200,
		218,
		208,
		217,
		209,
		-1,
		206,
		196,
		218,
		197,
		208,
		200,
		-1,
		-1,
		200,
		201,
		207,
		193,
		199,
		195,
		-1,
		205,
		189,
		-1,
		-1,
		190,
		191,
		175,
		178,
		186,
		184,
		197,
		189,
		184,
		-1,
		-1,
		181,
		177,
		184,
		171,
		167,
		184,
		197,
		179,
		193,
		192,
		-1,
		187,
		205,
		210,
		178,
		176,
		160,
		158,
		176,
		178,
		184,
		184,
		-1,
		196,
		197,
		192,
		200,
		200,
		176,
		163,
		163,
		173,
		166,
		185,
		173,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		194,
		179,
		196,
		188,
		178,
		193,
		186,
		166,
		163,
		161,
		158,
		174,
		172,
		182,
		-1,
		-1,
		250,
		219,
		254,
		211,
		196,
		-1,
		190,
		172,
		178,
		182,
		176,
		169,
		183,
		179,
		-1,
		152,
		151,
		179,
		165,
		176,
		210,
		-1,
		-1,
		208,
		200,
		185,
		188,
		185,
		185,
		187,
		186,
		178,
		164,
		160,
		166,
		169,
		169,
		175,
		146,
		156,
		160,
		158,
		183,
		-1,
		-1,
		218,
		-1,
		-1,
		207,
		190,
		-1,
		173,
		180,
		180,
		197,
		187,
		208,
		197,
		188,
		180,
		174,
		162,
		164,
		161,
		174,
		162,
		143,
		168,
		172,
		153,
		174,
		169,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		166,
		169,
		175,
		199,
		209,
		-1,
		209,
		197,
		198,
		183,
		180,
		167,
		155,
		168,
		153,
		160,
		159,
		147,
		145,
		175,
		150,
		172,
		169,
		188,
		193,
		187,
		196,
		-1,
		215,
		211,
		207,
		214,
		163,
		-1,
		-1,
		203,
		-1,
		217,
		230,
		221,
		194,
		197,
		184,
		175,
		162,
		151,
		162,
		151,
		148,
		156,
		139,
		154,
		145,
		144,
		162,
		172,
		180,
		184,
		190,
		-1,
		265,
		-1,
		207,
		191,
		193,
		165,
		186,
		-1,
		223,
		218,
		238,
		223,
		221,
		-1,
		193,
		190,
		180,
		158,
		143,
		160,
		152,
		150,
		152,
		134,
		148,
		139,
		157,
		164,
		162,
		166,
		186,
		198,
		225,
		215,
		-1,
		197,
		202,
		161,
		169,
		188,
		261,
		227,
		-1,
		222,
		-1,
		195,
		208,
		-1,
		164,
		160,
		142,
		143,
		138,
		153,
		145,
		130,
		127,
		145,
		148,
		155,
		159,
		175,
		-1,
		-1,
		210,
		214,
		203,
		154,
		173,
		197,
		234,
		220,
		209,
		208,
		-1,
		199,
		178,
		175,
		163,
		150,
		135,
		136,
		144,
		156,
		135,
		129,
		126,
		146,
		172,
		150,
		161,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		180,
		151,
		175,
		217,
		238,
		231,
		219,
		184,
		184,
		178,
		-1,
		174,
		153,
		144,
		133,
		131,
		144,
		136,
		144,
		124,
		122,
		141,
		153,
		144,
		152,
		-1,
		-1,
		-1,
		210,
		199,
		200,
		146,
		169,
		206,
		217,
		203,
		208,
		183,
		176,
		170,
		187,
		170,
		151,
		140,
		132,
		121,
		132,
		140,
		138,
		120,
		129,
		135,
		159,
		140,
		146,
		-1,
		-1,
		217,
		207,
		191,
		193,
		190,
		160,
		167,
		199,
		208,
		211,
		-1,
		175,
		-1,
		164,
		160,
		145,
		140,
		137,
		124,
		123,
		137,
		137,
		127,
		122,
		129,
		164,
		164,
		130,
		150,
		153,
		-1,
		-1,
		-1,
		210,
		205,
		180,
		157,
		141,
		177,
		-1,
		181,
		182,
		-1,
		169,
		163,
		160,
		147,
		143,
		128,
		132,
		134,
		137,
		125,
		131,
		132,
		114,
		138,
		-1,
		138,
		132,
		140,
		130,
		118,
		-1,
		-1,
		-1,
		203,
		182,
		175,
		195,
		136,
		188,
		-1,
		-1,
		166,
		159,
		-1,
		156,
		138,
		140,
		135,
		129,
		133,
		130,
		119,
		132,
		125,
		119,
		113,
		126,
		130,
		131,
		120,
		116,
		113,
		127,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		156,
		-1,
		174,
		166,
		157,
		151,
		155,
		151,
		149,
		157,
		141,
		144,
		139,
		133,
		126,
		114,
		107,
		118,
		103,
		121,
		127,
		118,
		113,
		112,
		123,
		-1,
		223,
		209,
		180,
		-1,
		-1,
		169,
		-1,
		133,
		152,
		168,
		-1,
		191,
		170,
		187,
		165,
		161,
		152,
		148,
		149,
		119,
		124,
		126,
		114,
		117,
		108,
		111,
		103,
		125,
		122,
		106,
		108,
		117,
		-1,
		229,
		216,
		174,
		170,
		159,
		179,
		130,
		139,
		155,
		-1,
		-1,
		199,
		-1,
		153,
		155,
		166,
		164,
		138,
		113,
		120,
		138,
		111,
		106,
		113,
		102,
		102,
		97,
		116,
		102,
		100,
		115,
		131,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		145,
		132,
		126,
		-1,
		172,
		-1,
		177,
		165,
		152,
		134,
		174,
		-1,
		112,
		108,
		115,
		-1,
		131,
		-1,
		103,
		106,
		97,
		94,
		91,
		102,
		100,
		109,
		110,
		-1,
		179,
		164,
		157,
		147,
		161,
		129,
		-1,
		163,
		-1,
		-1,
		164,
		158,
		158,
		127,
		124,
		128,
		108,
		100,
		115,
		114,
		101,
		100,
		88,
		88,
		91,
		87,
		100,
		110,
		116,
		108,
		-1,
		-1,
		-1,
		184,
		159,
		153,
		125,
		129,
		-1,
		-1,
		225,
		181,
		167,
		-1,
		119,
		128,
		116,
		106,
		96,
		101,
		102,
		92,
		90,
		86,
		95,
		96,
		89,
		88,
		109,
		102,
		124,
		-1,
		-1,
		158,
		151,
		139,
		107,
		102,
		-1,
		-1,
		-1,
		171,
		157,
		142,
		117,
		117,
		-1,
		-1,
		100,
		93,
		87,
		85,
		78,
		98,
		105,
		95,
		82,
		97,
		107,
		115,
		114,
		-1,
		161,
		148,
		-1,
		-1,
		101,
		91,
		-1,
		-1,
		-1,
		-1,
		135,
		99,
		88,
		83,
		87,
		99,
		-1,
		72,
		76,
		76,
		96,
		103,
		97,
		82,
		76,
		87,
		102,
		119,
		-1,
		-1,
		115,
		-1,
		77,
		-1,
		-1,
		-1,
		-1,
		107,
		105,
		76,
		69,
		73,
		-1,
		70,
		69,
		73,
		79,
		92,
		97,
		88,
		70,
		84,
		87,
		100,
		114,
		118,
		138,
		-1,
		68,
		-1,
		-1,
		-1,
		99,
		100,
		109,
		86,
		65,
		58,
		55,
		61,
		65,
		79,
		87,
		98,
		64,
		68,
		83,
		88,
		92,
		109,
		113,
		-1,
		-1,
		66,
		62,
		97,
		107,
		73,
		136,
		-1,
		-1,
		54,
		47,
		57,
		59,
		71,
		74,
		60,
		62,
		80,
		93,
		87,
		97,
		112,
		107,
		-1,
		-1,
		-1,
		78,
		-1,
		80,
		-1,
		-1,
		63,
		127,
		74,
		56,
		52,
		38,
		54,
		48,
		50,
		55,
		74,
		69,
		78,
		83,
		87,
		110,
		99,
		138,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		57,
		49,
		43,
		46,
		47,
		38,
		89,
		86,
		-1,
		34,
		77,
		45,
		59,
		55,
		62,
		67,
		73,
		77,
		84,
		100,
		99,
		94,
		130,
		121,
		127,
		-1,
		-1,
		180,
		169,
		158,
		164,
		-1,
		50,
		46,
		32,
		22,
		24,
		-1,
		-1,
		48,
		45,
		50,
		37,
		43,
		48,
		51,
		89,
		65,
		73,
		77,
		81,
		87,
		92,
		97,
		103,
		118,
		133,
		-1,
		134,
		171,
		164,
		132,
		140,
		171,
		-1,
		40,
		32,
		42,
		18,
		15,
		-1,
		-1,
		21,
		19,
		24,
		33,
		36,
		72,
		71,
		84,
		87,
		92,
		80,
		79,
		97,
		101,
		110,
		117,
		107,
		120,
		124,
		-1,
		127,
		147,
		126,
		129,
		153,
		167,
		-1,
		37,
		-1,
		-1,
		49,
		16,
		0,
		12,
		16,
		71,
		47,
		42,
		55,
		57,
		81,
		72,
		97,
		88,
		88,
		91,
		106,
		111,
		103,
		117,
		117,
		118,
		-1,
		116,
		127,
		120,
		-1,
		-1,
		-1,
		-1,
		38,
		-1,
		-1,
		65,
		-1,
		27,
		-1,
		37,
		41,
		55,
		58,
		80,
		67,
		74,
		91,
		97,
		86,
		96,
		92,
		93,
		102,
		113,
		125,
		124,
		125,
		141,
		97,
		100,
		111,
		122,
		137,
		141,
		-1,
		49,
		88,
		103,
		-1,
		74,
		-1,
		-1,
		-1,
		51,
		68,
		60,
		76,
		79,
		79,
		75,
		79,
		91,
		98,
		108,
		110,
		102,
		106,
		119,
		130,
		133,
		137,
		128,
		141,
		86,
		86,
		107,
		116,
		137,
		64,
		55,
		82,
		110,
		99,
		94,
		81,
		-1,
		-1,
		74,
		78,
		-1,
		-1,
		86,
		96,
		79,
		81,
		85,
		99,
		111,
		119,
		109,
		107,
		101,
		133,
		-1,
		130,
		129,
		118,
		115,
		91,
		82,
		77,
		104,
		-1,
		-1,
		67,
		83,
		96,
		100,
		116,
		141,
		-1,
		84,
		-1,
		-1,
		95,
		-1,
		-1,
		138,
		101,
		90,
		81,
		87,
		93,
		104,
		126,
		115,
		116,
		106,
		116,
		129,
		114,
		111,
		99,
		97,
		120,
		85,
		73,
		-1,
		82,
		70,
		76,
		83,
		100,
		130,
		-1,
		-1,
		100,
		91,
		-1,
		-1,
		114,
		121,
		123,
		-1,
		113,
		86,
		91,
		116,
		123,
		124,
		118,
		112,
		119,
		118,
		126,
		134,
		123,
		137,
		126,
		122,
		121,
		129,
		78,
		71,
		83,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		135,
		110,
		-1,
		-1,
		121,
		124,
		112,
		100,
		90,
		100,
		108,
		108,
		111,
		115,
		110,
		121,
		113,
		117,
		134,
		-1,
		157,
		-1,
		109,
		85,
		99,
		114,
		122,
		-1,
		-1,
		-1,
		152,
		138,
		131,
		119,
		117,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		144,
		112,
		117,
		112,
		116,
		127,
		116,
		119,
		133,
		128,
		-1,
		-1,
		97,
		100,
		-1,
		-1,
		122,
		141,
		-1,
		143,
		132,
		117,
		109,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		101,
		126,
		115,
		123,
		118,
		120,
		126,
		129,
		118,
		122,
		134,
		-1,
		-1,
		104,
		105,
		110,
		-1,
		131,
		-1,
		167,
		-1,
		112,
		128,
		130,
		-1,
		-1,
		-1,
		139,
		102,
		123,
		133,
		138,
		136,
		127,
		124,
		131,
		129,
		125,
		136,
		-1,
		-1,
		-1,
		161,
		138,
		174,
		165,
		148,
		128,
		120,
		145,
		-1,
		127,
		-1,
		102,
		103,
		130,
		132,
		149,
		143,
		127,
		142,
		132,
		123,
		132,
		167,
		-1,
		142,
		194,
		158,
		134,
		128,
		132,
		148,
		-1,
		124,
		106,
		-1,
		134,
		124,
		166,
		147,
		140,
		127,
		134,
		136,
		129,
		-1,
		-1,
		-1,
		157,
		156,
		154,
		148,
		148,
		133,
		124,
		-1,
		136,
		118,
		97,
		114,
		114,
		105,
		113,
		156,
		152,
		145,
		147,
		137,
		-1,
		229,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		157,
		152,
		125,
		113,
		119,
		115,
		101,
		107,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		136,
		168,
		-1,
		236,
		-1,
		187,
		-1,
		-1,
		175,
		155,
		147,
		136,
		125,
		123,
		114,
		105,
		127,
		143,
		127,
		125,
		130,
		135,
		-1,
		246,
		247,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		171,
		132,
		-1,
		134,
		114,
		-1,
		136,
		132,
		-1,
		-1,
		235,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		166,
		150,
		-1,
		125,
		125,
		-1,
		-1,
		-1,
		220,
		219,
		-1,
		188,
		191,
		-1,
		181,
		172,
		180,
		127,
		131,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		203,
		201,
		196,
		193,
		179,
		163,
		141,
		130,
		151,
		-1,
		-1,
		-1,
		201,
		193,
		186,
		-1,
		-1,
		188,
		171,
		152,
		150,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		178,
		-1,
		-1,
		184,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		212,
		-1,
		-1,
		-1,
		174,
		170,
		171,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		258,
		222,
		-1,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		237,
		235,
		-1,
		-1,
		-1,
		194,
		178,
		-1,
		164,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		199,
		-1,
		199,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		212,
		204,
		212,
		-1,
		184,
		186,
		-1,
		234,
		-1,
		-1,
		227,
		218,
		-1,
		-1,
		189,
		196,
		218,
		221,
		257,
		-1,
		208
	],
	[
		-1,
		233,
		222,
		233,
		241,
		214,
		221,
		-1,
		240,
		244,
		210,
		204,
		243,
		212,
		218,
		229,
		-1,
		-1,
		-1,
		233,
		232,
		200,
		198,
		207,
		212,
		219,
		-1,
		218,
		-1,
		254,
		233,
		244,
		249,
		193,
		190,
		210,
		229,
		211,
		203,
		269,
		223,
		194,
		188,
		206,
		196,
		205,
		197,
		-1,
		194,
		184,
		206,
		185,
		196,
		188,
		-1,
		-1,
		188,
		189,
		195,
		181,
		187,
		183,
		-1,
		193,
		177,
		-1,
		-1,
		178,
		179,
		163,
		166,
		174,
		172,
		185,
		177,
		172,
		-1,
		-1,
		169,
		165,
		172,
		159,
		155,
		172,
		185,
		167,
		181,
		180,
		-1,
		175,
		193,
		198,
		166,
		164,
		148,
		146,
		164,
		166,
		172,
		172,
		-1,
		184,
		185,
		180,
		188,
		188,
		164,
		151,
		151,
		161,
		154,
		173,
		161,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		184,
		167,
		184,
		176,
		166,
		181,
		174,
		154,
		151,
		149,
		146,
		162,
		160,
		170,
		-1,
		-1,
		257,
		226,
		261,
		218,
		203,
		-1,
		180,
		160,
		166,
		170,
		164,
		157,
		171,
		167,
		-1,
		140,
		139,
		167,
		153,
		164,
		217,
		-1,
		-1,
		215,
		207,
		192,
		195,
		190,
		186,
		175,
		174,
		166,
		152,
		148,
		154,
		157,
		157,
		163,
		134,
		144,
		148,
		146,
		171,
		-1,
		-1,
		206,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		187,
		202,
		188,
		209,
		185,
		176,
		168,
		162,
		150,
		152,
		149,
		162,
		150,
		131,
		156,
		160,
		141,
		162,
		157,
		-1,
		205,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		216,
		-1,
		197,
		185,
		186,
		171,
		168,
		155,
		143,
		156,
		141,
		148,
		147,
		135,
		133,
		163,
		138,
		160,
		157,
		176,
		181,
		175,
		184,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		224,
		234,
		209,
		182,
		185,
		172,
		163,
		150,
		139,
		150,
		139,
		136,
		144,
		127,
		142,
		133,
		132,
		150,
		160,
		168,
		172,
		178,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		225,
		226,
		211,
		209,
		-1,
		181,
		178,
		168,
		146,
		131,
		148,
		140,
		138,
		140,
		122,
		136,
		127,
		145,
		152,
		150,
		154,
		174,
		186,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		251,
		215,
		-1,
		210,
		-1,
		183,
		196,
		-1,
		152,
		148,
		130,
		131,
		126,
		141,
		133,
		118,
		115,
		133,
		136,
		143,
		147,
		163,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		208,
		197,
		196,
		-1,
		187,
		166,
		163,
		151,
		138,
		123,
		124,
		132,
		144,
		123,
		117,
		114,
		134,
		160,
		138,
		149,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		226,
		219,
		207,
		172,
		172,
		166,
		-1,
		162,
		141,
		132,
		121,
		119,
		132,
		124,
		132,
		112,
		110,
		129,
		141,
		132,
		140,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		205,
		191,
		196,
		171,
		164,
		158,
		175,
		158,
		139,
		128,
		120,
		109,
		120,
		128,
		126,
		108,
		117,
		123,
		147,
		128,
		134,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		196,
		209,
		-1,
		163,
		-1,
		152,
		148,
		133,
		128,
		125,
		112,
		111,
		125,
		125,
		115,
		110,
		117,
		152,
		152,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		179,
		180,
		-1,
		157,
		151,
		148,
		135,
		131,
		116,
		120,
		122,
		125,
		113,
		119,
		120,
		102,
		126,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		164,
		157,
		-1,
		144,
		126,
		128,
		123,
		117,
		121,
		118,
		107,
		120,
		113,
		107,
		101,
		114,
		118,
		119,
		108,
		104,
		101,
		115,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		173,
		165,
		155,
		149,
		143,
		139,
		137,
		145,
		129,
		132,
		127,
		121,
		114,
		102,
		95,
		106,
		91,
		109,
		115,
		106,
		101,
		100,
		111,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		159,
		175,
		-1,
		181,
		160,
		175,
		153,
		149,
		140,
		136,
		137,
		107,
		112,
		114,
		102,
		105,
		96,
		99,
		91,
		113,
		110,
		94,
		96,
		105,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		143,
		162,
		-1,
		-1,
		191,
		-1,
		145,
		147,
		154,
		152,
		126,
		101,
		108,
		126,
		99,
		94,
		101,
		90,
		90,
		85,
		104,
		90,
		88,
		103,
		119,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		179,
		-1,
		169,
		157,
		144,
		126,
		166,
		-1,
		100,
		96,
		103,
		-1,
		119,
		-1,
		91,
		94,
		85,
		82,
		79,
		90,
		88,
		97,
		98,
		-1,
		186,
		171,
		164,
		154,
		168,
		136,
		-1,
		170,
		-1,
		-1,
		156,
		150,
		150,
		119,
		116,
		116,
		96,
		88,
		103,
		102,
		89,
		88,
		76,
		76,
		79,
		75,
		88,
		98,
		104,
		96,
		-1,
		-1,
		-1,
		191,
		166,
		160,
		132,
		136,
		-1,
		-1,
		217,
		173,
		159,
		-1,
		111,
		116,
		104,
		94,
		84,
		89,
		90,
		80,
		78,
		74,
		83,
		84,
		77,
		76,
		97,
		90,
		112,
		-1,
		-1,
		165,
		158,
		146,
		114,
		109,
		-1,
		-1,
		-1,
		163,
		164,
		130,
		109,
		105,
		-1,
		-1,
		88,
		81,
		75,
		73,
		66,
		86,
		93,
		83,
		70,
		85,
		95,
		103,
		102,
		-1,
		168,
		155,
		-1,
		-1,
		108,
		98,
		-1,
		-1,
		-1,
		-1,
		142,
		87,
		76,
		71,
		75,
		87,
		-1,
		60,
		64,
		64,
		84,
		91,
		85,
		70,
		64,
		75,
		90,
		107,
		-1,
		-1,
		122,
		-1,
		84,
		-1,
		-1,
		-1,
		-1,
		99,
		93,
		64,
		57,
		61,
		-1,
		58,
		57,
		61,
		67,
		80,
		85,
		76,
		58,
		72,
		75,
		88,
		102,
		106,
		145,
		-1,
		75,
		-1,
		-1,
		-1,
		109,
		110,
		97,
		74,
		53,
		46,
		43,
		49,
		53,
		67,
		75,
		86,
		52,
		56,
		71,
		76,
		80,
		97,
		101,
		-1,
		-1,
		73,
		69,
		104,
		116,
		83,
		124,
		-1,
		-1,
		42,
		35,
		45,
		47,
		59,
		62,
		48,
		50,
		68,
		81,
		75,
		85,
		100,
		95,
		-1,
		-1,
		-1,
		85,
		-1,
		87,
		-1,
		-1,
		73,
		115,
		62,
		44,
		40,
		26,
		42,
		36,
		38,
		43,
		62,
		57,
		66,
		71,
		75,
		98,
		87,
		126,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		64,
		56,
		51,
		56,
		57,
		48,
		77,
		74,
		-1,
		22,
		65,
		33,
		47,
		43,
		50,
		55,
		61,
		65,
		72,
		88,
		87,
		82,
		118,
		109,
		115,
		-1,
		-1,
		168,
		157,
		146,
		152,
		-1,
		57,
		53,
		42,
		32,
		34,
		-1,
		-1,
		36,
		33,
		38,
		25,
		31,
		36,
		39,
		77,
		53,
		61,
		65,
		69,
		75,
		80,
		85,
		91,
		106,
		121,
		-1,
		122,
		159,
		152,
		120,
		128,
		159,
		-1,
		47,
		39,
		50,
		25,
		25,
		-1,
		-1,
		9,
		7,
		12,
		21,
		24,
		60,
		59,
		72,
		75,
		80,
		68,
		67,
		85,
		89,
		98,
		105,
		95,
		108,
		112,
		-1,
		115,
		135,
		114,
		117,
		141,
		155,
		-1,
		44,
		-1,
		-1,
		56,
		26,
		10,
		0,
		4,
		59,
		35,
		30,
		43,
		45,
		69,
		60,
		85,
		76,
		76,
		79,
		94,
		99,
		91,
		105,
		105,
		106,
		-1,
		104,
		115,
		108,
		-1,
		-1,
		-1,
		-1,
		45,
		-1,
		-1,
		72,
		-1,
		37,
		-1,
		29,
		33,
		43,
		46,
		68,
		55,
		62,
		79,
		85,
		74,
		84,
		80,
		81,
		90,
		101,
		113,
		112,
		113,
		129,
		85,
		88,
		99,
		110,
		125,
		129,
		-1,
		56,
		95,
		110,
		-1,
		81,
		-1,
		-1,
		-1,
		43,
		56,
		48,
		64,
		67,
		67,
		63,
		67,
		79,
		86,
		96,
		98,
		90,
		94,
		107,
		118,
		121,
		125,
		116,
		129,
		74,
		74,
		95,
		104,
		125,
		71,
		62,
		89,
		117,
		106,
		101,
		88,
		-1,
		-1,
		66,
		66,
		-1,
		-1,
		74,
		84,
		67,
		69,
		73,
		87,
		99,
		107,
		97,
		95,
		89,
		121,
		-1,
		118,
		117,
		106,
		103,
		79,
		70,
		65,
		92,
		-1,
		-1,
		74,
		90,
		98,
		102,
		118,
		143,
		-1,
		91,
		-1,
		-1,
		87,
		-1,
		-1,
		126,
		89,
		78,
		69,
		75,
		81,
		92,
		114,
		103,
		104,
		94,
		104,
		117,
		102,
		99,
		87,
		85,
		108,
		73,
		61,
		-1,
		74,
		72,
		78,
		85,
		102,
		132,
		-1,
		-1,
		107,
		98,
		-1,
		-1,
		106,
		113,
		111,
		-1,
		101,
		74,
		79,
		104,
		111,
		112,
		106,
		100,
		107,
		106,
		114,
		122,
		111,
		125,
		114,
		110,
		109,
		117,
		66,
		59,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		117,
		-1,
		-1,
		113,
		112,
		100,
		88,
		78,
		88,
		96,
		96,
		99,
		103,
		98,
		109,
		101,
		105,
		122,
		-1,
		145,
		-1,
		97,
		73,
		87,
		102,
		110,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		132,
		100,
		105,
		100,
		104,
		115,
		104,
		107,
		121,
		116,
		-1,
		-1,
		85,
		88,
		-1,
		-1,
		110,
		129,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		89,
		114,
		103,
		111,
		106,
		108,
		114,
		117,
		106,
		110,
		122,
		-1,
		-1,
		92,
		93,
		98,
		-1,
		119,
		-1,
		173,
		-1,
		119,
		135,
		134,
		-1,
		-1,
		-1,
		127,
		90,
		111,
		121,
		126,
		124,
		115,
		112,
		119,
		117,
		113,
		124,
		-1,
		-1,
		-1,
		149,
		126,
		180,
		171,
		154,
		134,
		126,
		145,
		-1,
		115,
		-1,
		90,
		91,
		118,
		120,
		137,
		131,
		115,
		130,
		120,
		111,
		120,
		155,
		-1,
		130,
		182,
		146,
		140,
		116,
		120,
		136,
		-1,
		112,
		94,
		-1,
		122,
		112,
		154,
		135,
		128,
		115,
		122,
		124,
		117,
		-1,
		-1,
		-1,
		145,
		144,
		142,
		136,
		136,
		121,
		112,
		-1,
		124,
		106,
		85,
		102,
		102,
		93,
		101,
		144,
		140,
		133,
		135,
		125,
		-1,
		217,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		145,
		140,
		113,
		101,
		107,
		103,
		89,
		95,
		97,
		105,
		103,
		100,
		112,
		108,
		128,
		124,
		156,
		-1,
		224,
		-1,
		175,
		-1,
		-1,
		163,
		143,
		135,
		124,
		113,
		111,
		102,
		93,
		115,
		131,
		115,
		113,
		118,
		123,
		-1,
		234,
		235,
		-1,
		182,
		174,
		160,
		-1,
		153,
		-1,
		159,
		120,
		-1,
		122,
		102,
		-1,
		124,
		120,
		-1,
		-1,
		223,
		198,
		-1,
		-1,
		-1,
		183,
		163,
		154,
		138,
		-1,
		113,
		113,
		-1,
		-1,
		-1,
		208,
		207,
		-1,
		176,
		179,
		-1,
		169,
		160,
		168,
		115,
		119,
		-1,
		-1,
		-1,
		217,
		198,
		192,
		191,
		189,
		184,
		181,
		167,
		151,
		129,
		118,
		139,
		-1,
		-1,
		-1,
		189,
		181,
		174,
		-1,
		-1,
		176,
		159,
		140,
		138,
		-1,
		-1,
		-1,
		211,
		192,
		-1,
		-1,
		166,
		-1,
		-1,
		172,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		200,
		-1,
		-1,
		-1,
		162,
		158,
		159,
		-1,
		-1,
		-1,
		-1,
		222,
		223,
		246,
		210,
		-1,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		225,
		223,
		-1,
		-1,
		-1,
		182,
		166,
		-1,
		152,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		187,
		-1,
		187,
		162,
		169,
		-1,
		-1,
		-1,
		-1,
		200,
		192,
		200,
		-1,
		172,
		174,
		-1,
		222,
		-1,
		-1,
		215,
		206,
		-1,
		-1,
		177,
		184,
		206,
		209,
		245,
		-1,
		196
	],
	[
		-1,
		231,
		220,
		231,
		239,
		212,
		219,
		-1,
		238,
		242,
		208,
		202,
		241,
		210,
		216,
		227,
		-1,
		-1,
		-1,
		231,
		230,
		198,
		196,
		205,
		210,
		217,
		-1,
		216,
		-1,
		252,
		231,
		242,
		247,
		191,
		188,
		208,
		227,
		209,
		201,
		267,
		221,
		192,
		186,
		204,
		194,
		203,
		195,
		-1,
		192,
		182,
		204,
		183,
		194,
		186,
		-1,
		-1,
		186,
		187,
		193,
		179,
		185,
		181,
		-1,
		191,
		175,
		-1,
		-1,
		176,
		177,
		161,
		164,
		172,
		170,
		183,
		175,
		170,
		-1,
		-1,
		167,
		163,
		170,
		157,
		153,
		170,
		183,
		165,
		179,
		178,
		-1,
		173,
		191,
		196,
		164,
		162,
		146,
		144,
		162,
		164,
		170,
		170,
		-1,
		182,
		183,
		178,
		186,
		186,
		162,
		149,
		149,
		159,
		152,
		171,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		182,
		165,
		182,
		174,
		164,
		179,
		172,
		152,
		149,
		147,
		144,
		160,
		158,
		168,
		-1,
		-1,
		267,
		236,
		271,
		228,
		212,
		-1,
		178,
		158,
		164,
		168,
		162,
		155,
		169,
		165,
		-1,
		138,
		137,
		165,
		151,
		162,
		227,
		-1,
		-1,
		225,
		217,
		202,
		205,
		188,
		184,
		173,
		172,
		164,
		150,
		146,
		152,
		155,
		155,
		161,
		132,
		142,
		146,
		144,
		169,
		-1,
		-1,
		204,
		-1,
		-1,
		224,
		207,
		-1,
		190,
		197,
		194,
		200,
		186,
		207,
		183,
		174,
		166,
		160,
		148,
		150,
		147,
		160,
		148,
		129,
		154,
		158,
		139,
		160,
		155,
		-1,
		203,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		183,
		186,
		192,
		216,
		223,
		-1,
		195,
		183,
		184,
		169,
		166,
		153,
		141,
		154,
		139,
		146,
		145,
		133,
		131,
		161,
		136,
		158,
		155,
		174,
		179,
		173,
		182,
		-1,
		232,
		228,
		224,
		231,
		180,
		-1,
		-1,
		220,
		-1,
		231,
		232,
		207,
		180,
		183,
		170,
		161,
		148,
		137,
		148,
		137,
		134,
		142,
		125,
		140,
		131,
		130,
		148,
		158,
		166,
		170,
		176,
		-1,
		282,
		-1,
		224,
		208,
		210,
		182,
		203,
		-1,
		240,
		232,
		224,
		209,
		207,
		-1,
		179,
		176,
		166,
		144,
		129,
		146,
		138,
		136,
		138,
		120,
		134,
		125,
		143,
		150,
		148,
		152,
		172,
		184,
		242,
		232,
		-1,
		214,
		219,
		178,
		186,
		205,
		249,
		213,
		-1,
		208,
		-1,
		181,
		194,
		-1,
		150,
		146,
		128,
		129,
		124,
		139,
		131,
		116,
		113,
		131,
		134,
		141,
		145,
		161,
		-1,
		-1,
		227,
		231,
		220,
		171,
		190,
		214,
		251,
		206,
		195,
		194,
		-1,
		185,
		164,
		161,
		149,
		136,
		121,
		122,
		130,
		142,
		121,
		115,
		112,
		132,
		158,
		136,
		147,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		197,
		168,
		192,
		234,
		224,
		217,
		205,
		170,
		170,
		164,
		-1,
		160,
		139,
		130,
		119,
		117,
		130,
		122,
		130,
		110,
		108,
		127,
		139,
		130,
		138,
		-1,
		-1,
		-1,
		227,
		216,
		217,
		163,
		186,
		223,
		203,
		189,
		194,
		169,
		162,
		156,
		173,
		156,
		137,
		126,
		118,
		107,
		118,
		126,
		124,
		106,
		115,
		121,
		145,
		126,
		132,
		-1,
		-1,
		234,
		224,
		208,
		210,
		207,
		177,
		184,
		216,
		194,
		207,
		-1,
		161,
		-1,
		150,
		146,
		131,
		126,
		123,
		110,
		109,
		123,
		123,
		113,
		108,
		115,
		150,
		150,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		227,
		222,
		197,
		174,
		158,
		194,
		-1,
		177,
		178,
		-1,
		155,
		149,
		146,
		133,
		129,
		114,
		118,
		120,
		123,
		111,
		117,
		118,
		100,
		124,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		220,
		199,
		192,
		212,
		153,
		205,
		-1,
		-1,
		162,
		155,
		-1,
		142,
		124,
		126,
		119,
		113,
		119,
		115,
		105,
		118,
		111,
		105,
		99,
		112,
		116,
		117,
		106,
		102,
		99,
		113,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		173,
		-1,
		171,
		163,
		153,
		147,
		141,
		137,
		135,
		141,
		125,
		128,
		123,
		119,
		110,
		100,
		93,
		104,
		89,
		107,
		113,
		104,
		99,
		98,
		109,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		186,
		-1,
		150,
		169,
		185,
		-1,
		179,
		158,
		173,
		151,
		147,
		138,
		132,
		133,
		103,
		108,
		110,
		98,
		101,
		94,
		97,
		89,
		111,
		108,
		92,
		94,
		103,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		147,
		141,
		172,
		-1,
		-1,
		187,
		-1,
		141,
		143,
		152,
		150,
		122,
		97,
		104,
		122,
		95,
		90,
		99,
		88,
		86,
		83,
		102,
		88,
		86,
		101,
		117,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		189,
		-1,
		165,
		153,
		140,
		122,
		162,
		-1,
		96,
		92,
		99,
		-1,
		115,
		-1,
		87,
		90,
		81,
		78,
		77,
		88,
		86,
		95,
		96,
		-1,
		196,
		181,
		174,
		164,
		178,
		146,
		-1,
		180,
		-1,
		-1,
		152,
		146,
		146,
		115,
		112,
		112,
		92,
		84,
		99,
		98,
		85,
		84,
		72,
		72,
		75,
		73,
		86,
		96,
		102,
		94,
		-1,
		-1,
		-1,
		201,
		176,
		170,
		142,
		146,
		-1,
		-1,
		213,
		169,
		155,
		-1,
		107,
		112,
		100,
		90,
		80,
		85,
		86,
		76,
		74,
		70,
		79,
		82,
		75,
		74,
		95,
		88,
		110,
		-1,
		-1,
		175,
		168,
		156,
		124,
		119,
		-1,
		-1,
		-1,
		159,
		160,
		126,
		105,
		101,
		-1,
		-1,
		84,
		77,
		71,
		69,
		62,
		82,
		89,
		81,
		68,
		83,
		93,
		101,
		100,
		-1,
		178,
		165,
		-1,
		-1,
		118,
		108,
		-1,
		-1,
		-1,
		-1,
		138,
		83,
		72,
		67,
		71,
		83,
		-1,
		56,
		60,
		60,
		80,
		87,
		83,
		68,
		62,
		73,
		88,
		105,
		-1,
		-1,
		132,
		-1,
		94,
		-1,
		-1,
		-1,
		-1,
		95,
		89,
		60,
		53,
		57,
		-1,
		54,
		53,
		57,
		63,
		76,
		81,
		74,
		56,
		70,
		73,
		86,
		100,
		104,
		155,
		-1,
		85,
		-1,
		-1,
		-1,
		113,
		120,
		93,
		70,
		49,
		42,
		39,
		45,
		49,
		65,
		71,
		82,
		50,
		54,
		69,
		74,
		78,
		95,
		99,
		-1,
		-1,
		83,
		79,
		114,
		121,
		93,
		120,
		-1,
		-1,
		38,
		31,
		41,
		45,
		55,
		58,
		46,
		48,
		66,
		79,
		73,
		83,
		98,
		93,
		-1,
		-1,
		-1,
		95,
		-1,
		97,
		-1,
		-1,
		83,
		111,
		58,
		40,
		36,
		22,
		40,
		34,
		36,
		41,
		60,
		55,
		64,
		69,
		73,
		96,
		85,
		124,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		74,
		66,
		61,
		66,
		67,
		58,
		73,
		70,
		-1,
		18,
		61,
		31,
		45,
		41,
		48,
		53,
		59,
		63,
		70,
		86,
		85,
		80,
		116,
		107,
		113,
		-1,
		-1,
		166,
		155,
		144,
		150,
		-1,
		67,
		63,
		52,
		42,
		44,
		-1,
		-1,
		32,
		29,
		36,
		23,
		29,
		34,
		37,
		75,
		51,
		59,
		63,
		67,
		73,
		78,
		83,
		89,
		104,
		119,
		-1,
		120,
		157,
		150,
		118,
		126,
		157,
		-1,
		57,
		49,
		60,
		35,
		35,
		-1,
		-1,
		5,
		5,
		10,
		19,
		22,
		58,
		57,
		70,
		73,
		78,
		66,
		65,
		83,
		87,
		96,
		103,
		93,
		106,
		110,
		-1,
		113,
		133,
		112,
		115,
		139,
		153,
		-1,
		54,
		-1,
		-1,
		66,
		36,
		20,
		10,
		0,
		57,
		33,
		28,
		41,
		43,
		67,
		58,
		83,
		74,
		74,
		77,
		92,
		97,
		89,
		103,
		103,
		104,
		-1,
		102,
		113,
		106,
		-1,
		-1,
		-1,
		-1,
		55,
		-1,
		-1,
		82,
		-1,
		47,
		-1,
		25,
		29,
		41,
		44,
		66,
		53,
		60,
		77,
		83,
		72,
		82,
		78,
		79,
		88,
		99,
		111,
		110,
		111,
		127,
		83,
		86,
		97,
		108,
		123,
		127,
		-1,
		66,
		105,
		120,
		-1,
		91,
		-1,
		-1,
		-1,
		39,
		54,
		46,
		62,
		65,
		65,
		61,
		65,
		77,
		84,
		94,
		96,
		88,
		92,
		105,
		116,
		119,
		123,
		114,
		127,
		72,
		72,
		93,
		102,
		123,
		81,
		72,
		99,
		126,
		116,
		111,
		98,
		-1,
		-1,
		62,
		64,
		-1,
		-1,
		72,
		82,
		65,
		67,
		71,
		85,
		97,
		105,
		95,
		93,
		87,
		119,
		-1,
		116,
		115,
		104,
		101,
		77,
		68,
		63,
		90,
		-1,
		-1,
		84,
		100,
		96,
		100,
		116,
		141,
		-1,
		101,
		-1,
		-1,
		83,
		-1,
		-1,
		124,
		87,
		76,
		67,
		73,
		79,
		90,
		112,
		101,
		102,
		92,
		102,
		115,
		100,
		97,
		85,
		83,
		106,
		71,
		59,
		-1,
		72,
		70,
		76,
		83,
		100,
		130,
		-1,
		-1,
		117,
		108,
		-1,
		-1,
		102,
		109,
		109,
		-1,
		99,
		72,
		77,
		102,
		109,
		110,
		104,
		98,
		105,
		104,
		112,
		120,
		109,
		123,
		112,
		108,
		107,
		115,
		64,
		57,
		69,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		127,
		-1,
		-1,
		109,
		110,
		98,
		86,
		76,
		86,
		94,
		94,
		97,
		101,
		96,
		107,
		99,
		103,
		120,
		-1,
		143,
		-1,
		95,
		71,
		85,
		100,
		108,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		151,
		135,
		116,
		-1,
		86,
		99,
		130,
		98,
		103,
		98,
		102,
		113,
		102,
		105,
		119,
		114,
		-1,
		-1,
		83,
		86,
		-1,
		-1,
		108,
		127,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		123,
		119,
		-1,
		-1,
		87,
		112,
		101,
		109,
		104,
		106,
		112,
		115,
		104,
		108,
		120,
		-1,
		-1,
		90,
		91,
		96,
		-1,
		117,
		-1,
		171,
		-1,
		129,
		144,
		132,
		-1,
		-1,
		-1,
		125,
		88,
		109,
		119,
		124,
		122,
		113,
		110,
		117,
		115,
		111,
		122,
		-1,
		-1,
		-1,
		147,
		124,
		178,
		169,
		152,
		132,
		124,
		143,
		-1,
		113,
		-1,
		88,
		89,
		116,
		118,
		135,
		129,
		113,
		128,
		118,
		109,
		118,
		153,
		-1,
		128,
		180,
		144,
		138,
		114,
		118,
		134,
		-1,
		110,
		92,
		-1,
		120,
		110,
		152,
		133,
		126,
		113,
		120,
		122,
		115,
		-1,
		-1,
		-1,
		143,
		142,
		140,
		134,
		134,
		119,
		110,
		-1,
		122,
		104,
		83,
		100,
		100,
		91,
		99,
		142,
		138,
		131,
		133,
		123,
		-1,
		215,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		143,
		138,
		111,
		99,
		105,
		101,
		87,
		93,
		95,
		103,
		101,
		98,
		110,
		106,
		126,
		122,
		154,
		-1,
		222,
		-1,
		173,
		-1,
		-1,
		161,
		141,
		133,
		122,
		111,
		109,
		100,
		91,
		113,
		129,
		113,
		111,
		116,
		121,
		-1,
		232,
		233,
		-1,
		180,
		172,
		158,
		-1,
		151,
		-1,
		157,
		118,
		-1,
		120,
		100,
		-1,
		122,
		118,
		-1,
		-1,
		221,
		196,
		-1,
		-1,
		-1,
		181,
		161,
		152,
		136,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		206,
		205,
		-1,
		174,
		177,
		-1,
		167,
		158,
		166,
		113,
		117,
		-1,
		-1,
		-1,
		215,
		196,
		190,
		189,
		187,
		182,
		179,
		165,
		149,
		127,
		116,
		137,
		-1,
		-1,
		-1,
		187,
		179,
		172,
		-1,
		-1,
		174,
		157,
		138,
		136,
		-1,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		164,
		-1,
		-1,
		170,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		198,
		-1,
		-1,
		-1,
		160,
		156,
		157,
		-1,
		-1,
		-1,
		-1,
		220,
		221,
		244,
		208,
		-1,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		223,
		221,
		-1,
		-1,
		-1,
		180,
		164,
		-1,
		150,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		185,
		-1,
		185,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		198,
		190,
		198,
		-1,
		170,
		172,
		-1,
		220,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		175,
		182,
		204,
		207,
		243,
		-1,
		194
	],
	[
		-1,
		270,
		259,
		270,
		278,
		251,
		258,
		-1,
		277,
		281,
		247,
		241,
		280,
		249,
		255,
		266,
		-1,
		-1,
		-1,
		270,
		269,
		237,
		235,
		244,
		249,
		256,
		-1,
		255,
		-1,
		291,
		270,
		281,
		286,
		230,
		227,
		247,
		266,
		248,
		240,
		306,
		260,
		231,
		225,
		243,
		233,
		242,
		234,
		-1,
		231,
		221,
		243,
		222,
		233,
		225,
		-1,
		-1,
		225,
		226,
		232,
		218,
		224,
		220,
		-1,
		230,
		214,
		-1,
		-1,
		215,
		216,
		200,
		203,
		211,
		209,
		222,
		214,
		209,
		-1,
		-1,
		206,
		202,
		209,
		196,
		192,
		209,
		222,
		204,
		218,
		217,
		-1,
		212,
		230,
		235,
		203,
		201,
		185,
		183,
		201,
		203,
		209,
		209,
		-1,
		221,
		222,
		217,
		225,
		225,
		201,
		188,
		188,
		198,
		191,
		210,
		198,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		221,
		204,
		221,
		213,
		203,
		218,
		211,
		191,
		188,
		186,
		183,
		199,
		197,
		207,
		-1,
		-1,
		312,
		281,
		312,
		270,
		251,
		-1,
		217,
		197,
		203,
		207,
		201,
		194,
		208,
		204,
		-1,
		177,
		176,
		204,
		190,
		201,
		272,
		-1,
		-1,
		270,
		262,
		247,
		250,
		227,
		223,
		212,
		211,
		203,
		189,
		185,
		191,
		194,
		194,
		200,
		171,
		181,
		185,
		183,
		208,
		-1,
		-1,
		243,
		-1,
		-1,
		269,
		252,
		-1,
		235,
		242,
		233,
		239,
		225,
		246,
		222,
		213,
		205,
		199,
		187,
		189,
		186,
		199,
		187,
		168,
		193,
		197,
		178,
		199,
		194,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		228,
		231,
		237,
		261,
		262,
		-1,
		234,
		222,
		223,
		208,
		205,
		192,
		180,
		193,
		178,
		185,
		184,
		172,
		170,
		200,
		175,
		197,
		194,
		213,
		218,
		212,
		221,
		-1,
		277,
		273,
		269,
		276,
		225,
		-1,
		-1,
		265,
		-1,
		270,
		271,
		246,
		219,
		222,
		209,
		200,
		187,
		176,
		187,
		176,
		173,
		181,
		164,
		179,
		170,
		169,
		187,
		197,
		205,
		209,
		215,
		-1,
		327,
		-1,
		269,
		253,
		255,
		227,
		248,
		-1,
		285,
		271,
		263,
		248,
		246,
		-1,
		218,
		215,
		205,
		183,
		168,
		185,
		177,
		175,
		177,
		159,
		173,
		164,
		182,
		189,
		187,
		191,
		211,
		223,
		287,
		277,
		-1,
		259,
		264,
		223,
		231,
		250,
		288,
		252,
		-1,
		247,
		-1,
		220,
		233,
		-1,
		189,
		185,
		167,
		168,
		163,
		178,
		170,
		155,
		152,
		170,
		173,
		180,
		184,
		200,
		-1,
		-1,
		272,
		276,
		265,
		216,
		235,
		259,
		296,
		245,
		234,
		233,
		-1,
		224,
		203,
		200,
		188,
		175,
		160,
		161,
		169,
		181,
		160,
		154,
		151,
		171,
		197,
		175,
		186,
		-1,
		-1,
		-1,
		297,
		-1,
		-1,
		242,
		213,
		237,
		279,
		263,
		256,
		244,
		209,
		209,
		203,
		-1,
		199,
		178,
		169,
		158,
		156,
		169,
		161,
		169,
		149,
		147,
		166,
		178,
		169,
		177,
		-1,
		-1,
		-1,
		272,
		261,
		262,
		208,
		231,
		268,
		242,
		228,
		233,
		208,
		201,
		195,
		212,
		195,
		176,
		165,
		157,
		146,
		157,
		165,
		163,
		145,
		154,
		160,
		184,
		165,
		171,
		-1,
		-1,
		279,
		269,
		253,
		255,
		252,
		222,
		229,
		261,
		233,
		246,
		-1,
		200,
		-1,
		189,
		185,
		170,
		165,
		162,
		149,
		148,
		162,
		162,
		152,
		147,
		154,
		189,
		189,
		155,
		175,
		178,
		-1,
		-1,
		-1,
		272,
		267,
		242,
		219,
		203,
		239,
		-1,
		216,
		217,
		-1,
		194,
		188,
		185,
		172,
		168,
		153,
		157,
		159,
		162,
		150,
		156,
		157,
		139,
		163,
		-1,
		163,
		157,
		165,
		155,
		143,
		-1,
		-1,
		-1,
		265,
		244,
		237,
		257,
		198,
		250,
		-1,
		-1,
		201,
		194,
		-1,
		181,
		163,
		165,
		160,
		156,
		158,
		155,
		144,
		157,
		150,
		144,
		138,
		151,
		155,
		156,
		145,
		141,
		138,
		152,
		-1,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		218,
		-1,
		210,
		202,
		192,
		186,
		180,
		176,
		174,
		184,
		168,
		170,
		166,
		158,
		153,
		139,
		132,
		143,
		128,
		146,
		152,
		143,
		138,
		137,
		148,
		-1,
		285,
		271,
		242,
		-1,
		-1,
		231,
		-1,
		195,
		209,
		225,
		-1,
		218,
		197,
		212,
		190,
		186,
		177,
		175,
		176,
		146,
		151,
		153,
		141,
		144,
		133,
		136,
		128,
		150,
		147,
		131,
		133,
		142,
		-1,
		291,
		278,
		236,
		232,
		221,
		241,
		192,
		180,
		212,
		-1,
		-1,
		237,
		-1,
		188,
		193,
		191,
		189,
		165,
		140,
		147,
		165,
		138,
		133,
		138,
		127,
		127,
		122,
		141,
		127,
		125,
		140,
		156,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		207,
		194,
		188,
		-1,
		229,
		-1,
		215,
		203,
		190,
		172,
		212,
		-1,
		139,
		135,
		142,
		-1,
		158,
		-1,
		130,
		133,
		124,
		119,
		116,
		127,
		125,
		134,
		135,
		-1,
		241,
		226,
		219,
		209,
		223,
		193,
		-1,
		227,
		-1,
		-1,
		202,
		196,
		196,
		165,
		162,
		155,
		135,
		127,
		142,
		141,
		128,
		127,
		115,
		115,
		118,
		112,
		125,
		135,
		141,
		133,
		-1,
		-1,
		-1,
		246,
		223,
		217,
		189,
		193,
		-1,
		-1,
		263,
		219,
		205,
		-1,
		157,
		155,
		143,
		133,
		123,
		128,
		129,
		119,
		117,
		113,
		122,
		121,
		114,
		113,
		134,
		127,
		149,
		-1,
		-1,
		222,
		215,
		203,
		171,
		166,
		-1,
		-1,
		-1,
		209,
		210,
		176,
		155,
		144,
		-1,
		-1,
		127,
		120,
		114,
		117,
		105,
		125,
		132,
		120,
		107,
		122,
		132,
		140,
		139,
		-1,
		225,
		212,
		-1,
		-1,
		165,
		155,
		-1,
		-1,
		-1,
		-1,
		188,
		133,
		122,
		117,
		121,
		126,
		-1,
		100,
		111,
		104,
		123,
		130,
		122,
		107,
		101,
		112,
		127,
		144,
		-1,
		-1,
		179,
		-1,
		141,
		-1,
		-1,
		-1,
		-1,
		145,
		139,
		110,
		103,
		107,
		-1,
		102,
		104,
		101,
		113,
		118,
		122,
		113,
		95,
		109,
		112,
		125,
		139,
		143,
		202,
		-1,
		132,
		-1,
		-1,
		-1,
		163,
		169,
		143,
		120,
		99,
		92,
		89,
		88,
		93,
		104,
		113,
		124,
		89,
		93,
		108,
		113,
		117,
		134,
		138,
		-1,
		-1,
		130,
		126,
		161,
		171,
		142,
		170,
		-1,
		-1,
		88,
		81,
		91,
		84,
		97,
		100,
		85,
		87,
		105,
		118,
		112,
		122,
		137,
		132,
		-1,
		-1,
		-1,
		142,
		-1,
		144,
		-1,
		-1,
		132,
		161,
		108,
		90,
		86,
		72,
		79,
		73,
		75,
		80,
		99,
		94,
		103,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		121,
		113,
		108,
		114,
		116,
		107,
		123,
		120,
		-1,
		69,
		102,
		70,
		84,
		80,
		87,
		92,
		98,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		114,
		110,
		100,
		90,
		93,
		-1,
		-1,
		87,
		84,
		71,
		62,
		68,
		73,
		76,
		114,
		90,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		104,
		96,
		107,
		82,
		84,
		-1,
		-1,
		60,
		51,
		42,
		54,
		57,
		97,
		96,
		109,
		112,
		117,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		101,
		-1,
		-1,
		113,
		85,
		69,
		59,
		56,
		0,
		68,
		63,
		80,
		82,
		106,
		97,
		122,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		129,
		-1,
		96,
		-1,
		79,
		83,
		76,
		79,
		105,
		92,
		99,
		116,
		122,
		111,
		121,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		113,
		152,
		167,
		-1,
		138,
		-1,
		-1,
		-1,
		93,
		89,
		81,
		97,
		104,
		104,
		100,
		104,
		116,
		123,
		133,
		135,
		127,
		131,
		144,
		155,
		158,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		128,
		119,
		146,
		172,
		163,
		158,
		145,
		-1,
		-1,
		116,
		99,
		-1,
		-1,
		111,
		121,
		104,
		106,
		110,
		124,
		136,
		144,
		134,
		132,
		126,
		158,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		147,
		142,
		146,
		162,
		187,
		-1,
		148,
		-1,
		-1,
		137,
		-1,
		-1,
		163,
		126,
		115,
		106,
		112,
		118,
		129,
		151,
		140,
		141,
		131,
		141,
		154,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		118,
		116,
		122,
		129,
		146,
		176,
		-1,
		-1,
		164,
		155,
		-1,
		-1,
		156,
		159,
		148,
		-1,
		138,
		111,
		116,
		141,
		148,
		149,
		143,
		137,
		144,
		143,
		151,
		159,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		-1,
		199,
		174,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		133,
		133,
		136,
		140,
		135,
		146,
		138,
		142,
		159,
		-1,
		189,
		-1,
		141,
		117,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		216,
		202,
		195,
		183,
		181,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		169,
		137,
		142,
		137,
		141,
		152,
		141,
		144,
		158,
		153,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		154,
		173,
		-1,
		207,
		196,
		181,
		173,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		126,
		151,
		140,
		148,
		143,
		145,
		151,
		154,
		143,
		147,
		159,
		-1,
		-1,
		136,
		137,
		142,
		-1,
		163,
		-1,
		210,
		-1,
		176,
		183,
		171,
		-1,
		-1,
		-1,
		164,
		127,
		148,
		158,
		163,
		161,
		152,
		149,
		156,
		154,
		150,
		161,
		-1,
		-1,
		-1,
		193,
		170,
		217,
		208,
		191,
		171,
		163,
		182,
		-1,
		152,
		-1,
		127,
		128,
		155,
		157,
		174,
		168,
		152,
		167,
		157,
		148,
		157,
		199,
		-1,
		174,
		219,
		183,
		177,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		191,
		172,
		165,
		152,
		159,
		161,
		154,
		-1,
		-1,
		-1,
		188,
		187,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		181,
		177,
		170,
		172,
		162,
		-1,
		261,
		-1,
		-1,
		211,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		161,
		193,
		-1,
		268,
		-1,
		218,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		155,
		160,
		-1,
		273,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		230,
		219,
		230,
		238,
		211,
		218,
		-1,
		237,
		241,
		207,
		201,
		240,
		209,
		215,
		226,
		-1,
		-1,
		-1,
		230,
		229,
		197,
		195,
		204,
		209,
		216,
		-1,
		215,
		-1,
		251,
		230,
		241,
		246,
		190,
		187,
		207,
		226,
		208,
		200,
		266,
		220,
		191,
		185,
		203,
		193,
		202,
		194,
		-1,
		191,
		181,
		203,
		182,
		193,
		185,
		-1,
		-1,
		185,
		186,
		192,
		178,
		184,
		180,
		-1,
		190,
		174,
		-1,
		-1,
		175,
		176,
		160,
		163,
		171,
		169,
		182,
		174,
		169,
		-1,
		-1,
		166,
		162,
		169,
		156,
		152,
		169,
		182,
		164,
		178,
		177,
		-1,
		172,
		190,
		195,
		163,
		161,
		145,
		143,
		161,
		163,
		169,
		169,
		-1,
		181,
		182,
		177,
		185,
		185,
		161,
		148,
		148,
		158,
		151,
		170,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		181,
		164,
		181,
		173,
		163,
		178,
		171,
		151,
		148,
		146,
		143,
		159,
		157,
		167,
		-1,
		-1,
		272,
		241,
		272,
		230,
		211,
		-1,
		177,
		157,
		163,
		167,
		161,
		154,
		168,
		164,
		-1,
		137,
		136,
		164,
		150,
		161,
		232,
		-1,
		-1,
		230,
		222,
		207,
		210,
		187,
		183,
		172,
		171,
		163,
		149,
		145,
		151,
		154,
		154,
		160,
		131,
		141,
		145,
		143,
		168,
		-1,
		-1,
		203,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		193,
		199,
		185,
		206,
		182,
		173,
		165,
		159,
		147,
		149,
		146,
		159,
		147,
		128,
		153,
		157,
		138,
		159,
		154,
		-1,
		202,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		222,
		-1,
		194,
		182,
		183,
		168,
		165,
		152,
		140,
		153,
		138,
		145,
		144,
		132,
		130,
		160,
		135,
		157,
		154,
		173,
		178,
		172,
		181,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		230,
		231,
		206,
		179,
		182,
		169,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		124,
		139,
		130,
		129,
		147,
		157,
		165,
		169,
		175,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		231,
		223,
		208,
		206,
		-1,
		178,
		175,
		165,
		143,
		128,
		145,
		137,
		135,
		137,
		119,
		133,
		124,
		142,
		149,
		147,
		151,
		171,
		183,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		248,
		212,
		-1,
		207,
		-1,
		180,
		193,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		130,
		115,
		112,
		130,
		133,
		140,
		144,
		160,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		205,
		194,
		193,
		-1,
		184,
		163,
		160,
		148,
		135,
		120,
		121,
		129,
		141,
		120,
		114,
		111,
		131,
		157,
		135,
		146,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		223,
		216,
		204,
		169,
		169,
		163,
		-1,
		159,
		138,
		129,
		118,
		116,
		129,
		121,
		129,
		109,
		107,
		126,
		138,
		129,
		137,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		168,
		191,
		228,
		202,
		188,
		193,
		168,
		161,
		155,
		172,
		155,
		136,
		125,
		117,
		106,
		117,
		125,
		123,
		105,
		114,
		120,
		144,
		125,
		131,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		182,
		189,
		221,
		193,
		206,
		-1,
		160,
		-1,
		149,
		145,
		130,
		125,
		122,
		109,
		108,
		122,
		122,
		112,
		107,
		114,
		149,
		149,
		115,
		135,
		138,
		-1,
		-1,
		-1,
		232,
		227,
		202,
		179,
		163,
		199,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		132,
		128,
		113,
		117,
		119,
		122,
		110,
		116,
		117,
		99,
		123,
		-1,
		123,
		117,
		125,
		115,
		103,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		125,
		120,
		116,
		118,
		115,
		104,
		117,
		110,
		104,
		98,
		111,
		115,
		116,
		105,
		101,
		98,
		112,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		144,
		128,
		130,
		126,
		118,
		113,
		99,
		92,
		103,
		88,
		106,
		112,
		103,
		98,
		97,
		108,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		178,
		157,
		172,
		150,
		146,
		137,
		135,
		136,
		106,
		111,
		113,
		101,
		104,
		93,
		96,
		88,
		110,
		107,
		91,
		93,
		102,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		140,
		172,
		-1,
		-1,
		204,
		-1,
		148,
		160,
		151,
		149,
		125,
		100,
		107,
		125,
		98,
		93,
		98,
		87,
		87,
		82,
		101,
		87,
		85,
		100,
		116,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		182,
		170,
		157,
		139,
		179,
		-1,
		99,
		95,
		102,
		-1,
		118,
		-1,
		90,
		93,
		84,
		79,
		76,
		87,
		85,
		94,
		95,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		202,
		-1,
		-1,
		169,
		163,
		163,
		132,
		129,
		115,
		95,
		87,
		102,
		101,
		88,
		87,
		75,
		75,
		78,
		72,
		85,
		95,
		101,
		93,
		-1,
		-1,
		-1,
		206,
		192,
		192,
		156,
		168,
		-1,
		-1,
		230,
		186,
		172,
		-1,
		124,
		115,
		103,
		93,
		83,
		88,
		89,
		79,
		77,
		73,
		82,
		81,
		74,
		73,
		94,
		87,
		109,
		-1,
		-1,
		189,
		190,
		178,
		146,
		141,
		-1,
		-1,
		-1,
		176,
		177,
		143,
		122,
		104,
		-1,
		-1,
		87,
		80,
		74,
		77,
		65,
		85,
		92,
		80,
		67,
		82,
		92,
		100,
		99,
		-1,
		192,
		179,
		-1,
		-1,
		140,
		130,
		-1,
		-1,
		-1,
		-1,
		155,
		100,
		89,
		84,
		88,
		86,
		-1,
		60,
		71,
		64,
		83,
		90,
		82,
		67,
		61,
		72,
		87,
		104,
		-1,
		-1,
		154,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		112,
		106,
		77,
		70,
		74,
		-1,
		62,
		64,
		61,
		73,
		78,
		82,
		73,
		55,
		69,
		72,
		85,
		99,
		103,
		177,
		-1,
		107,
		-1,
		-1,
		-1,
		130,
		144,
		116,
		93,
		66,
		61,
		54,
		48,
		53,
		64,
		73,
		84,
		49,
		53,
		68,
		73,
		77,
		94,
		98,
		-1,
		-1,
		105,
		101,
		136,
		138,
		117,
		143,
		-1,
		-1,
		63,
		56,
		52,
		44,
		57,
		60,
		45,
		47,
		65,
		78,
		72,
		82,
		97,
		92,
		-1,
		-1,
		-1,
		117,
		-1,
		119,
		-1,
		-1,
		107,
		136,
		83,
		65,
		61,
		47,
		39,
		33,
		35,
		40,
		59,
		54,
		63,
		68,
		72,
		95,
		84,
		123,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		96,
		88,
		83,
		89,
		91,
		82,
		98,
		95,
		-1,
		44,
		62,
		30,
		44,
		40,
		47,
		52,
		58,
		62,
		69,
		85,
		84,
		79,
		115,
		106,
		112,
		-1,
		-1,
		187,
		176,
		165,
		171,
		-1,
		89,
		85,
		75,
		65,
		68,
		-1,
		-1,
		62,
		59,
		35,
		22,
		28,
		33,
		36,
		74,
		50,
		58,
		62,
		66,
		72,
		77,
		82,
		88,
		103,
		118,
		-1,
		141,
		178,
		171,
		139,
		147,
		178,
		-1,
		79,
		71,
		82,
		57,
		59,
		-1,
		-1,
		35,
		26,
		26,
		14,
		17,
		45,
		56,
		61,
		72,
		77,
		65,
		64,
		82,
		86,
		95,
		102,
		92,
		105,
		109,
		-1,
		134,
		154,
		133,
		136,
		160,
		174,
		-1,
		76,
		-1,
		-1,
		88,
		60,
		44,
		34,
		31,
		73,
		0,
		5,
		30,
		32,
		58,
		49,
		82,
		73,
		73,
		76,
		91,
		96,
		88,
		102,
		102,
		103,
		-1,
		123,
		134,
		127,
		-1,
		-1,
		-1,
		-1,
		77,
		-1,
		-1,
		104,
		-1,
		71,
		-1,
		54,
		58,
		22,
		11,
		57,
		44,
		51,
		68,
		74,
		71,
		79,
		77,
		78,
		87,
		98,
		110,
		109,
		110,
		148,
		104,
		107,
		118,
		129,
		144,
		148,
		-1,
		88,
		127,
		142,
		-1,
		113,
		-1,
		-1,
		-1,
		68,
		35,
		27,
		33,
		48,
		56,
		52,
		56,
		69,
		76,
		86,
		95,
		87,
		91,
		104,
		115,
		118,
		144,
		135,
		148,
		93,
		93,
		114,
		123,
		144,
		103,
		94,
		121,
		147,
		138,
		133,
		120,
		-1,
		-1,
		91,
		45,
		-1,
		-1,
		49,
		73,
		56,
		58,
		62,
		76,
		88,
		101,
		94,
		92,
		86,
		118,
		-1,
		137,
		136,
		125,
		122,
		98,
		89,
		84,
		111,
		-1,
		-1,
		106,
		122,
		117,
		121,
		137,
		162,
		-1,
		123,
		-1,
		-1,
		112,
		-1,
		-1,
		115,
		78,
		67,
		58,
		64,
		70,
		81,
		103,
		100,
		101,
		91,
		101,
		114,
		121,
		118,
		106,
		104,
		127,
		92,
		80,
		-1,
		93,
		91,
		97,
		104,
		121,
		151,
		-1,
		-1,
		139,
		130,
		-1,
		-1,
		113,
		111,
		100,
		-1,
		90,
		63,
		68,
		93,
		100,
		102,
		103,
		97,
		104,
		103,
		111,
		119,
		130,
		144,
		133,
		129,
		128,
		136,
		85,
		78,
		90,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		149,
		-1,
		-1,
		108,
		101,
		89,
		77,
		67,
		77,
		85,
		85,
		88,
		93,
		95,
		106,
		98,
		102,
		119,
		-1,
		164,
		-1,
		116,
		92,
		106,
		121,
		129,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		142,
		126,
		107,
		-1,
		77,
		90,
		121,
		89,
		94,
		89,
		101,
		112,
		101,
		104,
		118,
		113,
		-1,
		-1,
		104,
		107,
		-1,
		-1,
		129,
		148,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		114,
		110,
		-1,
		-1,
		78,
		103,
		92,
		100,
		95,
		105,
		111,
		114,
		103,
		107,
		119,
		-1,
		-1,
		111,
		112,
		117,
		-1,
		138,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		116,
		79,
		100,
		110,
		115,
		113,
		104,
		103,
		110,
		114,
		110,
		121,
		-1,
		-1,
		-1,
		168,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		83,
		80,
		115,
		109,
		126,
		120,
		106,
		121,
		117,
		108,
		117,
		174,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		91,
		-1,
		119,
		109,
		143,
		129,
		117,
		104,
		111,
		121,
		114,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		99,
		90,
		98,
		133,
		129,
		122,
		124,
		116,
		-1,
		236,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		102,
		100,
		97,
		109,
		105,
		125,
		117,
		153,
		-1,
		243,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		128,
		112,
		110,
		115,
		120,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		121,
		117,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		229,
		218,
		229,
		237,
		210,
		217,
		-1,
		236,
		240,
		206,
		200,
		239,
		208,
		214,
		225,
		-1,
		-1,
		-1,
		229,
		228,
		196,
		194,
		203,
		208,
		215,
		-1,
		214,
		-1,
		250,
		229,
		240,
		245,
		189,
		186,
		206,
		225,
		207,
		199,
		265,
		219,
		190,
		184,
		202,
		192,
		201,
		193,
		-1,
		190,
		180,
		202,
		181,
		192,
		184,
		-1,
		-1,
		184,
		185,
		191,
		177,
		183,
		179,
		-1,
		189,
		173,
		-1,
		-1,
		174,
		175,
		159,
		162,
		170,
		168,
		181,
		173,
		168,
		-1,
		-1,
		165,
		161,
		168,
		155,
		151,
		168,
		181,
		163,
		177,
		176,
		-1,
		171,
		189,
		194,
		162,
		160,
		144,
		142,
		160,
		162,
		168,
		168,
		-1,
		180,
		181,
		176,
		184,
		184,
		160,
		147,
		147,
		157,
		150,
		169,
		157,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		180,
		163,
		180,
		172,
		162,
		177,
		170,
		150,
		147,
		145,
		142,
		158,
		156,
		166,
		-1,
		-1,
		271,
		240,
		271,
		229,
		210,
		-1,
		176,
		156,
		162,
		166,
		160,
		153,
		167,
		163,
		-1,
		136,
		135,
		163,
		149,
		160,
		231,
		-1,
		-1,
		229,
		221,
		206,
		209,
		186,
		182,
		171,
		170,
		162,
		148,
		144,
		150,
		153,
		153,
		159,
		130,
		140,
		144,
		142,
		167,
		-1,
		-1,
		202,
		-1,
		-1,
		228,
		211,
		-1,
		194,
		201,
		192,
		198,
		184,
		205,
		181,
		172,
		164,
		158,
		146,
		148,
		145,
		158,
		146,
		127,
		152,
		156,
		137,
		158,
		153,
		-1,
		201,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		187,
		190,
		196,
		220,
		221,
		-1,
		193,
		181,
		182,
		167,
		164,
		151,
		139,
		152,
		137,
		144,
		143,
		131,
		129,
		159,
		134,
		156,
		153,
		172,
		177,
		171,
		180,
		-1,
		236,
		232,
		228,
		235,
		184,
		-1,
		-1,
		224,
		-1,
		229,
		230,
		205,
		178,
		181,
		168,
		159,
		146,
		135,
		146,
		135,
		132,
		140,
		123,
		138,
		129,
		128,
		146,
		156,
		164,
		168,
		174,
		-1,
		286,
		-1,
		228,
		212,
		214,
		186,
		207,
		-1,
		244,
		230,
		222,
		207,
		205,
		-1,
		177,
		174,
		164,
		142,
		127,
		144,
		136,
		134,
		136,
		118,
		132,
		123,
		141,
		148,
		146,
		150,
		170,
		182,
		246,
		236,
		-1,
		218,
		223,
		182,
		190,
		209,
		247,
		211,
		-1,
		206,
		-1,
		179,
		192,
		-1,
		148,
		144,
		126,
		127,
		122,
		137,
		129,
		114,
		111,
		129,
		132,
		139,
		143,
		159,
		-1,
		-1,
		231,
		235,
		224,
		175,
		194,
		218,
		255,
		204,
		193,
		192,
		-1,
		183,
		162,
		159,
		147,
		134,
		119,
		120,
		128,
		140,
		119,
		113,
		110,
		130,
		156,
		134,
		145,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		201,
		172,
		196,
		238,
		222,
		215,
		203,
		168,
		168,
		162,
		-1,
		158,
		137,
		128,
		117,
		115,
		128,
		120,
		128,
		108,
		106,
		125,
		137,
		128,
		136,
		-1,
		-1,
		-1,
		231,
		220,
		221,
		167,
		190,
		227,
		201,
		187,
		192,
		167,
		160,
		154,
		171,
		154,
		135,
		124,
		116,
		105,
		116,
		124,
		122,
		104,
		113,
		119,
		143,
		124,
		130,
		-1,
		-1,
		238,
		228,
		212,
		214,
		211,
		181,
		188,
		220,
		192,
		205,
		-1,
		159,
		-1,
		148,
		144,
		129,
		124,
		121,
		108,
		107,
		121,
		121,
		111,
		106,
		113,
		148,
		148,
		114,
		134,
		137,
		-1,
		-1,
		-1,
		231,
		226,
		201,
		178,
		162,
		198,
		-1,
		175,
		176,
		-1,
		153,
		147,
		144,
		131,
		127,
		112,
		116,
		118,
		121,
		109,
		115,
		116,
		98,
		122,
		-1,
		122,
		116,
		124,
		114,
		102,
		-1,
		-1,
		-1,
		224,
		203,
		196,
		216,
		157,
		209,
		-1,
		-1,
		160,
		153,
		-1,
		140,
		122,
		124,
		119,
		115,
		117,
		114,
		103,
		116,
		109,
		103,
		97,
		110,
		114,
		115,
		104,
		100,
		97,
		111,
		-1,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		177,
		-1,
		169,
		161,
		151,
		145,
		139,
		135,
		133,
		143,
		127,
		129,
		125,
		117,
		112,
		98,
		91,
		102,
		87,
		105,
		111,
		102,
		97,
		96,
		107,
		-1,
		244,
		230,
		201,
		-1,
		-1,
		190,
		-1,
		154,
		168,
		184,
		-1,
		177,
		156,
		171,
		149,
		145,
		136,
		134,
		135,
		105,
		110,
		112,
		100,
		103,
		92,
		95,
		87,
		109,
		106,
		90,
		92,
		101,
		-1,
		250,
		237,
		195,
		191,
		180,
		200,
		151,
		139,
		171,
		-1,
		-1,
		203,
		-1,
		147,
		159,
		150,
		148,
		124,
		99,
		106,
		124,
		97,
		92,
		97,
		86,
		86,
		81,
		100,
		86,
		84,
		99,
		115,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		166,
		153,
		147,
		-1,
		188,
		-1,
		181,
		169,
		156,
		138,
		178,
		-1,
		98,
		94,
		101,
		-1,
		117,
		-1,
		89,
		92,
		83,
		78,
		75,
		86,
		84,
		93,
		94,
		-1,
		200,
		185,
		178,
		168,
		182,
		153,
		-1,
		201,
		-1,
		-1,
		168,
		162,
		162,
		131,
		128,
		114,
		94,
		86,
		101,
		100,
		87,
		86,
		74,
		74,
		77,
		71,
		84,
		94,
		100,
		92,
		-1,
		-1,
		-1,
		205,
		191,
		191,
		155,
		167,
		-1,
		-1,
		229,
		185,
		171,
		-1,
		123,
		114,
		102,
		92,
		82,
		87,
		88,
		78,
		76,
		72,
		81,
		80,
		73,
		72,
		93,
		86,
		108,
		-1,
		-1,
		188,
		189,
		177,
		145,
		140,
		-1,
		-1,
		-1,
		175,
		176,
		142,
		121,
		103,
		-1,
		-1,
		86,
		79,
		73,
		76,
		64,
		84,
		91,
		79,
		66,
		81,
		91,
		99,
		98,
		-1,
		191,
		178,
		-1,
		-1,
		139,
		129,
		-1,
		-1,
		-1,
		-1,
		154,
		99,
		88,
		83,
		87,
		85,
		-1,
		59,
		70,
		63,
		82,
		89,
		81,
		66,
		60,
		71,
		86,
		103,
		-1,
		-1,
		153,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		111,
		105,
		76,
		69,
		73,
		-1,
		61,
		63,
		60,
		72,
		77,
		81,
		72,
		54,
		68,
		71,
		84,
		98,
		102,
		176,
		-1,
		106,
		-1,
		-1,
		-1,
		129,
		143,
		115,
		92,
		65,
		60,
		53,
		47,
		52,
		63,
		72,
		83,
		48,
		52,
		67,
		72,
		76,
		93,
		97,
		-1,
		-1,
		104,
		100,
		135,
		137,
		116,
		142,
		-1,
		-1,
		62,
		55,
		51,
		43,
		56,
		59,
		44,
		46,
		64,
		77,
		71,
		81,
		96,
		91,
		-1,
		-1,
		-1,
		116,
		-1,
		118,
		-1,
		-1,
		106,
		135,
		82,
		64,
		60,
		46,
		38,
		32,
		34,
		39,
		58,
		53,
		62,
		67,
		71,
		94,
		83,
		122,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		95,
		87,
		82,
		88,
		90,
		81,
		97,
		94,
		-1,
		43,
		61,
		29,
		43,
		39,
		46,
		51,
		57,
		61,
		68,
		84,
		83,
		78,
		114,
		105,
		111,
		-1,
		-1,
		186,
		175,
		164,
		170,
		-1,
		88,
		84,
		74,
		64,
		67,
		-1,
		-1,
		61,
		58,
		34,
		21,
		27,
		32,
		35,
		73,
		49,
		57,
		61,
		65,
		71,
		76,
		81,
		87,
		102,
		117,
		-1,
		140,
		177,
		170,
		138,
		146,
		177,
		-1,
		78,
		70,
		81,
		56,
		58,
		-1,
		-1,
		34,
		25,
		25,
		13,
		16,
		44,
		55,
		60,
		71,
		76,
		64,
		63,
		81,
		85,
		94,
		101,
		91,
		104,
		108,
		-1,
		133,
		153,
		132,
		135,
		159,
		173,
		-1,
		75,
		-1,
		-1,
		87,
		59,
		43,
		33,
		30,
		72,
		7,
		0,
		29,
		31,
		57,
		48,
		81,
		72,
		72,
		75,
		90,
		95,
		87,
		101,
		101,
		102,
		-1,
		122,
		133,
		126,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		103,
		-1,
		70,
		-1,
		53,
		57,
		21,
		18,
		56,
		43,
		50,
		67,
		73,
		70,
		78,
		76,
		77,
		86,
		97,
		109,
		108,
		109,
		147,
		103,
		106,
		117,
		128,
		143,
		147,
		-1,
		87,
		126,
		141,
		-1,
		112,
		-1,
		-1,
		-1,
		67,
		34,
		26,
		36,
		51,
		55,
		51,
		55,
		68,
		75,
		85,
		94,
		86,
		90,
		103,
		114,
		117,
		143,
		134,
		147,
		92,
		92,
		113,
		122,
		143,
		102,
		93,
		120,
		146,
		137,
		132,
		119,
		-1,
		-1,
		90,
		44,
		-1,
		-1,
		52,
		72,
		55,
		57,
		61,
		75,
		87,
		100,
		93,
		91,
		85,
		117,
		-1,
		136,
		135,
		124,
		121,
		97,
		88,
		83,
		110,
		-1,
		-1,
		105,
		121,
		116,
		120,
		136,
		161,
		-1,
		122,
		-1,
		-1,
		111,
		-1,
		-1,
		114,
		77,
		66,
		57,
		63,
		69,
		80,
		102,
		99,
		100,
		90,
		100,
		113,
		120,
		117,
		105,
		103,
		126,
		91,
		79,
		-1,
		92,
		90,
		96,
		103,
		120,
		150,
		-1,
		-1,
		138,
		129,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		62,
		67,
		92,
		99,
		101,
		102,
		96,
		103,
		102,
		110,
		118,
		129,
		143,
		132,
		128,
		127,
		135,
		84,
		77,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		159,
		148,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		76,
		84,
		84,
		87,
		92,
		94,
		105,
		97,
		101,
		118,
		-1,
		163,
		-1,
		115,
		91,
		105,
		120,
		128,
		-1,
		-1,
		-1,
		176,
		162,
		155,
		143,
		141,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		120,
		88,
		93,
		88,
		100,
		111,
		100,
		103,
		117,
		112,
		-1,
		-1,
		103,
		106,
		-1,
		-1,
		128,
		147,
		-1,
		167,
		156,
		141,
		133,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		102,
		91,
		99,
		94,
		104,
		110,
		113,
		102,
		106,
		118,
		-1,
		-1,
		110,
		111,
		116,
		-1,
		137,
		-1,
		169,
		-1,
		136,
		142,
		130,
		-1,
		-1,
		-1,
		115,
		78,
		99,
		109,
		114,
		112,
		103,
		102,
		109,
		113,
		109,
		120,
		-1,
		-1,
		-1,
		167,
		143,
		176,
		167,
		150,
		130,
		122,
		141,
		-1,
		111,
		-1,
		82,
		79,
		114,
		108,
		125,
		119,
		105,
		120,
		116,
		107,
		116,
		173,
		-1,
		145,
		178,
		142,
		136,
		112,
		116,
		132,
		-1,
		108,
		90,
		-1,
		118,
		108,
		142,
		128,
		116,
		103,
		110,
		120,
		113,
		-1,
		-1,
		-1,
		147,
		146,
		138,
		132,
		132,
		117,
		108,
		-1,
		120,
		102,
		81,
		98,
		98,
		89,
		97,
		132,
		128,
		121,
		123,
		115,
		-1,
		235,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		141,
		136,
		109,
		97,
		103,
		99,
		85,
		91,
		93,
		101,
		99,
		96,
		108,
		104,
		124,
		116,
		152,
		-1,
		242,
		-1,
		177,
		-1,
		-1,
		159,
		139,
		131,
		120,
		109,
		107,
		98,
		89,
		111,
		127,
		111,
		109,
		114,
		119,
		-1,
		232,
		231,
		-1,
		178,
		170,
		156,
		-1,
		149,
		-1,
		155,
		116,
		-1,
		118,
		98,
		-1,
		120,
		116,
		-1,
		-1,
		219,
		194,
		-1,
		-1,
		-1,
		179,
		159,
		150,
		134,
		-1,
		109,
		109,
		-1,
		-1,
		-1,
		204,
		203,
		-1,
		172,
		175,
		-1,
		165,
		156,
		164,
		111,
		115,
		-1,
		-1,
		-1,
		213,
		194,
		188,
		187,
		185,
		180,
		177,
		163,
		147,
		125,
		114,
		135,
		-1,
		-1,
		-1,
		185,
		177,
		170,
		-1,
		-1,
		172,
		155,
		136,
		134,
		-1,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		162,
		-1,
		-1,
		168,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		196,
		-1,
		-1,
		-1,
		158,
		154,
		155,
		-1,
		-1,
		-1,
		-1,
		218,
		219,
		242,
		206,
		-1,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		221,
		219,
		-1,
		-1,
		-1,
		178,
		162,
		-1,
		148,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		183,
		-1,
		183,
		158,
		165,
		-1,
		-1,
		-1,
		-1,
		196,
		188,
		196,
		-1,
		168,
		170,
		-1,
		218,
		-1,
		-1,
		211,
		202,
		-1,
		-1,
		173,
		180,
		202,
		205,
		241,
		-1,
		192
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		222,
		226,
		192,
		186,
		225,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		215,
		214,
		182,
		180,
		189,
		194,
		201,
		-1,
		200,
		-1,
		236,
		215,
		226,
		231,
		175,
		172,
		192,
		211,
		193,
		185,
		251,
		205,
		176,
		170,
		188,
		178,
		187,
		179,
		-1,
		176,
		166,
		188,
		167,
		178,
		170,
		-1,
		-1,
		170,
		171,
		177,
		163,
		169,
		165,
		-1,
		175,
		159,
		-1,
		-1,
		160,
		161,
		145,
		148,
		156,
		154,
		167,
		159,
		154,
		-1,
		-1,
		151,
		147,
		154,
		141,
		137,
		154,
		167,
		149,
		163,
		162,
		-1,
		155,
		173,
		180,
		148,
		146,
		130,
		128,
		146,
		148,
		154,
		154,
		-1,
		164,
		165,
		160,
		168,
		170,
		146,
		133,
		133,
		143,
		136,
		155,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		136,
		133,
		131,
		128,
		144,
		142,
		152,
		-1,
		-1,
		257,
		226,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		122,
		121,
		149,
		135,
		146,
		217,
		-1,
		-1,
		215,
		207,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		116,
		126,
		130,
		128,
		153,
		-1,
		-1,
		188,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		113,
		138,
		142,
		123,
		144,
		139,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		117,
		115,
		145,
		120,
		142,
		139,
		158,
		163,
		157,
		166,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		109,
		124,
		115,
		114,
		132,
		142,
		150,
		154,
		160,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		214,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		122,
		104,
		118,
		109,
		127,
		134,
		132,
		136,
		156,
		168,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		115,
		100,
		97,
		115,
		118,
		125,
		129,
		145,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		125,
		104,
		99,
		96,
		116,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		109,
		114,
		94,
		92,
		111,
		123,
		114,
		131,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		105,
		113,
		108,
		90,
		99,
		105,
		129,
		119,
		125,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		107,
		97,
		92,
		99,
		134,
		134,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		103,
		101,
		102,
		84,
		116,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		108,
		97,
		110,
		103,
		89,
		91,
		104,
		108,
		112,
		99,
		95,
		92,
		106,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		120,
		111,
		110,
		92,
		85,
		92,
		81,
		99,
		107,
		99,
		93,
		92,
		102,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		132,
		133,
		103,
		108,
		110,
		98,
		97,
		86,
		89,
		81,
		103,
		103,
		87,
		88,
		92,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		122,
		97,
		104,
		122,
		95,
		90,
		91,
		80,
		80,
		75,
		97,
		83,
		81,
		90,
		106,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		96,
		92,
		99,
		-1,
		115,
		-1,
		87,
		90,
		81,
		72,
		69,
		80,
		78,
		89,
		85,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		129,
		126,
		112,
		92,
		84,
		99,
		98,
		85,
		84,
		72,
		72,
		75,
		68,
		81,
		91,
		96,
		83,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		121,
		112,
		100,
		90,
		80,
		85,
		86,
		76,
		74,
		70,
		79,
		78,
		70,
		69,
		85,
		77,
		99,
		-1,
		-1,
		174,
		179,
		167,
		153,
		152,
		-1,
		-1,
		-1,
		173,
		174,
		140,
		119,
		101,
		-1,
		-1,
		84,
		77,
		71,
		74,
		62,
		82,
		89,
		77,
		63,
		78,
		82,
		90,
		81,
		-1,
		177,
		164,
		-1,
		-1,
		151,
		141,
		-1,
		-1,
		-1,
		-1,
		152,
		97,
		86,
		81,
		85,
		83,
		-1,
		57,
		68,
		61,
		80,
		87,
		79,
		64,
		58,
		65,
		77,
		86,
		-1,
		-1,
		165,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		109,
		103,
		74,
		67,
		71,
		-1,
		59,
		61,
		58,
		70,
		75,
		79,
		70,
		52,
		58,
		62,
		66,
		80,
		84,
		188,
		-1,
		118,
		-1,
		-1,
		-1,
		127,
		142,
		113,
		90,
		63,
		58,
		51,
		45,
		50,
		61,
		70,
		81,
		46,
		50,
		55,
		54,
		58,
		75,
		79,
		-1,
		-1,
		116,
		112,
		147,
		135,
		128,
		140,
		-1,
		-1,
		67,
		58,
		49,
		41,
		54,
		57,
		42,
		44,
		62,
		59,
		53,
		63,
		78,
		73,
		-1,
		-1,
		-1,
		128,
		-1,
		130,
		-1,
		-1,
		118,
		138,
		85,
		67,
		63,
		58,
		36,
		30,
		32,
		37,
		56,
		51,
		58,
		49,
		53,
		76,
		65,
		104,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		107,
		99,
		94,
		100,
		102,
		93,
		100,
		97,
		-1,
		55,
		59,
		27,
		41,
		37,
		44,
		49,
		55,
		43,
		50,
		66,
		65,
		60,
		96,
		87,
		93,
		-1,
		-1,
		193,
		182,
		171,
		177,
		-1,
		100,
		96,
		86,
		76,
		79,
		-1,
		-1,
		73,
		70,
		50,
		19,
		25,
		30,
		33,
		49,
		30,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		99,
		-1,
		147,
		184,
		177,
		145,
		153,
		184,
		-1,
		90,
		82,
		93,
		68,
		70,
		-1,
		-1,
		46,
		37,
		38,
		26,
		23,
		38,
		53,
		34,
		47,
		57,
		46,
		45,
		63,
		67,
		76,
		83,
		73,
		86,
		90,
		-1,
		140,
		160,
		139,
		142,
		166,
		180,
		-1,
		87,
		-1,
		-1,
		99,
		71,
		55,
		45,
		42,
		85,
		31,
		26,
		0,
		2,
		31,
		22,
		63,
		49,
		54,
		57,
		72,
		77,
		69,
		83,
		83,
		84,
		-1,
		129,
		140,
		133,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		115,
		-1,
		82,
		-1,
		65,
		69,
		39,
		42,
		29,
		15,
		24,
		41,
		47,
		47,
		52,
		55,
		59,
		68,
		79,
		91,
		90,
		91,
		154,
		110,
		113,
		124,
		135,
		150,
		154,
		-1,
		99,
		138,
		153,
		-1,
		124,
		-1,
		-1,
		-1,
		79,
		52,
		44,
		49,
		28,
		28,
		25,
		29,
		42,
		49,
		59,
		73,
		68,
		72,
		85,
		96,
		99,
		150,
		141,
		154,
		99,
		99,
		120,
		129,
		150,
		114,
		105,
		132,
		153,
		149,
		144,
		131,
		-1,
		-1,
		102,
		62,
		-1,
		-1,
		35,
		46,
		29,
		31,
		35,
		49,
		61,
		74,
		75,
		73,
		67,
		99,
		-1,
		143,
		142,
		131,
		128,
		104,
		95,
		90,
		117,
		-1,
		-1,
		112,
		133,
		123,
		127,
		143,
		168,
		-1,
		129,
		-1,
		-1,
		103,
		-1,
		-1,
		88,
		51,
		40,
		31,
		37,
		43,
		54,
		76,
		79,
		82,
		72,
		82,
		95,
		127,
		124,
		112,
		110,
		133,
		98,
		86,
		-1,
		99,
		97,
		103,
		110,
		127,
		157,
		-1,
		-1,
		145,
		125,
		-1,
		-1,
		86,
		84,
		73,
		-1,
		63,
		36,
		41,
		66,
		73,
		75,
		82,
		76,
		83,
		84,
		92,
		100,
		136,
		150,
		139,
		135,
		134,
		142,
		91,
		84,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		135,
		131,
		-1,
		-1,
		81,
		74,
		62,
		50,
		40,
		50,
		58,
		58,
		61,
		66,
		74,
		85,
		79,
		83,
		100,
		-1,
		170,
		-1,
		122,
		98,
		112,
		127,
		135,
		-1,
		-1,
		-1,
		152,
		138,
		131,
		119,
		117,
		-1,
		115,
		99,
		80,
		-1,
		50,
		63,
		94,
		62,
		67,
		62,
		80,
		91,
		82,
		85,
		99,
		94,
		-1,
		-1,
		110,
		113,
		-1,
		-1,
		135,
		144,
		-1,
		143,
		132,
		117,
		109,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		51,
		76,
		65,
		73,
		68,
		80,
		90,
		88,
		84,
		88,
		100,
		-1,
		-1,
		117,
		118,
		123,
		-1,
		127,
		-1,
		145,
		-1,
		112,
		118,
		106,
		-1,
		-1,
		-1,
		89,
		52,
		73,
		83,
		88,
		86,
		77,
		76,
		83,
		93,
		91,
		102,
		-1,
		-1,
		-1,
		145,
		119,
		152,
		143,
		126,
		106,
		98,
		117,
		-1,
		87,
		-1,
		56,
		53,
		90,
		82,
		99,
		93,
		79,
		94,
		90,
		89,
		97,
		151,
		-1,
		121,
		154,
		118,
		112,
		88,
		92,
		108,
		-1,
		84,
		64,
		-1,
		94,
		84,
		116,
		102,
		90,
		77,
		84,
		98,
		94,
		-1,
		-1,
		-1,
		123,
		122,
		114,
		108,
		108,
		93,
		84,
		-1,
		96,
		78,
		57,
		74,
		74,
		65,
		73,
		106,
		102,
		95,
		97,
		89,
		-1,
		224,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		117,
		112,
		85,
		73,
		79,
		75,
		61,
		67,
		69,
		77,
		75,
		72,
		84,
		80,
		100,
		90,
		126,
		-1,
		219,
		-1,
		153,
		-1,
		-1,
		135,
		115,
		107,
		96,
		85,
		83,
		74,
		65,
		87,
		103,
		87,
		85,
		90,
		95,
		-1,
		208,
		207,
		-1,
		154,
		146,
		132,
		-1,
		125,
		-1,
		131,
		92,
		-1,
		94,
		74,
		-1,
		96,
		92,
		-1,
		-1,
		195,
		170,
		-1,
		-1,
		-1,
		155,
		135,
		126,
		110,
		-1,
		85,
		85,
		-1,
		-1,
		-1,
		180,
		179,
		-1,
		148,
		151,
		-1,
		141,
		132,
		140,
		87,
		91,
		-1,
		-1,
		-1,
		189,
		170,
		164,
		163,
		161,
		156,
		153,
		139,
		123,
		101,
		90,
		111,
		-1,
		-1,
		-1,
		161,
		153,
		146,
		-1,
		-1,
		148,
		131,
		112,
		110,
		-1,
		-1,
		-1,
		183,
		164,
		-1,
		-1,
		138,
		-1,
		-1,
		144,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		172,
		-1,
		-1,
		-1,
		134,
		130,
		131,
		-1,
		-1,
		-1,
		-1,
		194,
		195,
		218,
		182,
		-1,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		197,
		195,
		-1,
		-1,
		-1,
		154,
		138,
		-1,
		124,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		159,
		-1,
		159,
		134,
		141,
		-1,
		-1,
		-1,
		-1,
		172,
		164,
		172,
		-1,
		144,
		146,
		-1,
		194,
		-1,
		-1,
		187,
		178,
		-1,
		-1,
		149,
		156,
		178,
		181,
		217,
		-1,
		168
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		220,
		224,
		190,
		184,
		223,
		192,
		198,
		209,
		-1,
		-1,
		-1,
		213,
		212,
		180,
		178,
		187,
		192,
		199,
		-1,
		198,
		-1,
		234,
		213,
		224,
		229,
		173,
		170,
		190,
		209,
		191,
		183,
		249,
		203,
		174,
		168,
		186,
		176,
		185,
		177,
		-1,
		174,
		164,
		186,
		165,
		176,
		168,
		-1,
		-1,
		168,
		169,
		175,
		161,
		167,
		163,
		-1,
		173,
		157,
		-1,
		-1,
		158,
		159,
		143,
		146,
		154,
		152,
		165,
		157,
		152,
		-1,
		-1,
		149,
		145,
		152,
		139,
		135,
		152,
		165,
		147,
		161,
		160,
		-1,
		153,
		171,
		178,
		146,
		144,
		128,
		126,
		144,
		146,
		152,
		152,
		-1,
		162,
		163,
		158,
		166,
		168,
		144,
		131,
		131,
		141,
		134,
		153,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		134,
		131,
		129,
		126,
		142,
		140,
		150,
		-1,
		-1,
		255,
		224,
		253,
		211,
		192,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		120,
		119,
		147,
		133,
		144,
		215,
		-1,
		-1,
		213,
		205,
		188,
		191,
		168,
		164,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		114,
		124,
		128,
		126,
		151,
		-1,
		-1,
		186,
		-1,
		-1,
		212,
		195,
		-1,
		178,
		185,
		174,
		180,
		166,
		187,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		111,
		136,
		140,
		121,
		142,
		137,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		171,
		174,
		180,
		204,
		203,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		115,
		113,
		143,
		118,
		140,
		137,
		156,
		161,
		155,
		164,
		-1,
		220,
		216,
		212,
		219,
		168,
		-1,
		-1,
		208,
		-1,
		211,
		212,
		187,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		107,
		122,
		113,
		112,
		130,
		140,
		148,
		152,
		158,
		-1,
		270,
		-1,
		212,
		196,
		198,
		170,
		191,
		-1,
		228,
		212,
		204,
		189,
		189,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		120,
		102,
		116,
		107,
		125,
		132,
		130,
		134,
		154,
		166,
		230,
		220,
		-1,
		202,
		207,
		166,
		174,
		193,
		231,
		195,
		-1,
		190,
		-1,
		161,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		113,
		98,
		95,
		113,
		116,
		123,
		127,
		143,
		-1,
		-1,
		215,
		219,
		208,
		159,
		178,
		202,
		239,
		188,
		177,
		176,
		-1,
		167,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		123,
		102,
		97,
		94,
		114,
		140,
		118,
		130,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		185,
		156,
		180,
		222,
		206,
		199,
		187,
		152,
		152,
		146,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		107,
		112,
		92,
		90,
		109,
		121,
		112,
		129,
		-1,
		-1,
		-1,
		215,
		204,
		205,
		151,
		174,
		211,
		185,
		171,
		176,
		151,
		144,
		138,
		153,
		136,
		117,
		106,
		98,
		87,
		103,
		111,
		106,
		88,
		97,
		103,
		127,
		117,
		123,
		-1,
		-1,
		222,
		212,
		196,
		198,
		195,
		165,
		172,
		204,
		176,
		189,
		-1,
		143,
		-1,
		132,
		127,
		111,
		106,
		103,
		100,
		94,
		103,
		105,
		95,
		90,
		97,
		132,
		132,
		107,
		127,
		130,
		-1,
		-1,
		-1,
		215,
		210,
		185,
		162,
		146,
		182,
		-1,
		159,
		160,
		-1,
		137,
		131,
		128,
		113,
		109,
		104,
		108,
		101,
		108,
		101,
		99,
		100,
		82,
		114,
		-1,
		115,
		109,
		117,
		107,
		95,
		-1,
		-1,
		-1,
		208,
		187,
		180,
		200,
		141,
		193,
		-1,
		-1,
		144,
		137,
		-1,
		124,
		106,
		113,
		111,
		105,
		109,
		106,
		95,
		108,
		101,
		87,
		89,
		102,
		106,
		110,
		97,
		93,
		90,
		104,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		161,
		-1,
		153,
		145,
		135,
		129,
		123,
		119,
		117,
		133,
		117,
		120,
		118,
		109,
		112,
		90,
		83,
		90,
		79,
		97,
		105,
		97,
		91,
		90,
		100,
		-1,
		228,
		214,
		185,
		-1,
		-1,
		174,
		-1,
		138,
		152,
		168,
		-1,
		161,
		140,
		155,
		133,
		129,
		125,
		134,
		135,
		105,
		110,
		112,
		100,
		95,
		84,
		87,
		79,
		101,
		101,
		85,
		86,
		90,
		-1,
		234,
		221,
		179,
		175,
		164,
		184,
		135,
		123,
		155,
		-1,
		-1,
		197,
		-1,
		131,
		148,
		139,
		137,
		124,
		99,
		106,
		124,
		97,
		92,
		89,
		78,
		78,
		73,
		95,
		81,
		79,
		88,
		104,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		150,
		137,
		131,
		-1,
		172,
		-1,
		175,
		165,
		149,
		134,
		167,
		-1,
		98,
		94,
		101,
		-1,
		117,
		-1,
		89,
		92,
		83,
		70,
		67,
		78,
		76,
		87,
		83,
		-1,
		184,
		169,
		162,
		152,
		166,
		137,
		-1,
		192,
		-1,
		-1,
		162,
		156,
		156,
		131,
		128,
		114,
		94,
		86,
		101,
		100,
		87,
		86,
		74,
		74,
		73,
		66,
		79,
		89,
		94,
		81,
		-1,
		-1,
		-1,
		189,
		175,
		179,
		139,
		158,
		-1,
		-1,
		224,
		179,
		165,
		-1,
		123,
		114,
		102,
		92,
		82,
		87,
		88,
		78,
		76,
		72,
		81,
		77,
		68,
		67,
		83,
		75,
		97,
		-1,
		-1,
		172,
		177,
		165,
		151,
		154,
		-1,
		-1,
		-1,
		171,
		176,
		142,
		121,
		103,
		-1,
		-1,
		86,
		79,
		73,
		76,
		64,
		84,
		91,
		76,
		61,
		76,
		80,
		88,
		79,
		-1,
		175,
		162,
		-1,
		-1,
		153,
		143,
		-1,
		-1,
		-1,
		-1,
		154,
		99,
		88,
		83,
		87,
		85,
		-1,
		59,
		70,
		63,
		82,
		89,
		78,
		63,
		57,
		63,
		75,
		84,
		-1,
		-1,
		167,
		-1,
		129,
		-1,
		-1,
		-1,
		-1,
		111,
		105,
		76,
		69,
		73,
		-1,
		61,
		63,
		60,
		72,
		77,
		78,
		69,
		54,
		56,
		60,
		64,
		78,
		82,
		190,
		-1,
		120,
		-1,
		-1,
		-1,
		129,
		144,
		115,
		92,
		65,
		60,
		53,
		47,
		52,
		63,
		72,
		83,
		48,
		52,
		53,
		52,
		56,
		73,
		77,
		-1,
		-1,
		118,
		114,
		149,
		137,
		130,
		142,
		-1,
		-1,
		69,
		60,
		51,
		43,
		56,
		59,
		44,
		46,
		62,
		57,
		51,
		61,
		76,
		71,
		-1,
		-1,
		-1,
		130,
		-1,
		132,
		-1,
		-1,
		120,
		140,
		87,
		69,
		65,
		60,
		38,
		32,
		34,
		39,
		58,
		53,
		56,
		47,
		51,
		74,
		63,
		102,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		109,
		101,
		96,
		102,
		104,
		95,
		102,
		99,
		-1,
		57,
		61,
		29,
		43,
		39,
		46,
		51,
		55,
		41,
		48,
		64,
		63,
		58,
		94,
		85,
		91,
		-1,
		-1,
		195,
		184,
		173,
		179,
		-1,
		102,
		98,
		88,
		78,
		81,
		-1,
		-1,
		75,
		72,
		52,
		21,
		27,
		32,
		35,
		47,
		28,
		37,
		41,
		45,
		51,
		56,
		61,
		67,
		82,
		97,
		-1,
		149,
		186,
		179,
		147,
		155,
		186,
		-1,
		92,
		84,
		95,
		70,
		72,
		-1,
		-1,
		48,
		39,
		40,
		28,
		25,
		40,
		55,
		32,
		45,
		55,
		44,
		43,
		61,
		65,
		74,
		81,
		71,
		84,
		88,
		-1,
		142,
		162,
		141,
		144,
		168,
		182,
		-1,
		89,
		-1,
		-1,
		101,
		73,
		57,
		47,
		44,
		87,
		33,
		28,
		2,
		0,
		29,
		20,
		61,
		47,
		52,
		55,
		70,
		75,
		67,
		81,
		81,
		82,
		-1,
		131,
		142,
		135,
		-1,
		-1,
		-1,
		-1,
		90,
		-1,
		-1,
		117,
		-1,
		84,
		-1,
		67,
		71,
		41,
		44,
		27,
		13,
		22,
		39,
		45,
		45,
		50,
		53,
		57,
		66,
		77,
		89,
		88,
		89,
		156,
		112,
		115,
		126,
		137,
		152,
		156,
		-1,
		101,
		140,
		155,
		-1,
		126,
		-1,
		-1,
		-1,
		81,
		54,
		46,
		47,
		26,
		26,
		23,
		27,
		40,
		47,
		57,
		71,
		66,
		70,
		83,
		94,
		97,
		152,
		143,
		156,
		101,
		101,
		122,
		131,
		152,
		116,
		107,
		134,
		155,
		151,
		146,
		133,
		-1,
		-1,
		104,
		64,
		-1,
		-1,
		33,
		44,
		27,
		29,
		33,
		47,
		59,
		72,
		73,
		71,
		65,
		97,
		-1,
		145,
		144,
		133,
		130,
		106,
		97,
		92,
		119,
		-1,
		-1,
		114,
		135,
		125,
		129,
		145,
		170,
		-1,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		86,
		49,
		38,
		29,
		35,
		41,
		52,
		74,
		77,
		80,
		70,
		80,
		93,
		129,
		126,
		114,
		112,
		135,
		100,
		88,
		-1,
		101,
		99,
		105,
		112,
		129,
		159,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		84,
		82,
		71,
		-1,
		61,
		34,
		39,
		64,
		71,
		73,
		80,
		74,
		81,
		82,
		90,
		98,
		138,
		152,
		141,
		137,
		136,
		144,
		93,
		86,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		79,
		72,
		60,
		48,
		38,
		48,
		56,
		56,
		59,
		64,
		72,
		83,
		77,
		81,
		98,
		-1,
		172,
		-1,
		124,
		100,
		114,
		129,
		137,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		113,
		97,
		78,
		-1,
		48,
		61,
		92,
		60,
		65,
		60,
		78,
		89,
		80,
		83,
		97,
		92,
		-1,
		-1,
		112,
		115,
		-1,
		-1,
		137,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		85,
		81,
		-1,
		-1,
		49,
		74,
		63,
		71,
		66,
		78,
		88,
		86,
		82,
		86,
		98,
		-1,
		-1,
		119,
		120,
		125,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		87,
		50,
		71,
		81,
		86,
		84,
		75,
		74,
		81,
		91,
		89,
		100,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		85,
		-1,
		54,
		51,
		88,
		80,
		97,
		91,
		77,
		92,
		88,
		87,
		95,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		82,
		62,
		-1,
		92,
		82,
		114,
		100,
		88,
		75,
		82,
		96,
		92,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		72,
		63,
		71,
		104,
		100,
		93,
		95,
		87,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		75,
		73,
		70,
		82,
		78,
		98,
		88,
		124,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		101,
		85,
		83,
		88,
		93,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		94,
		90,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		201,
		190,
		201,
		209,
		182,
		189,
		-1,
		208,
		212,
		178,
		172,
		211,
		180,
		186,
		197,
		-1,
		-1,
		-1,
		201,
		200,
		168,
		166,
		175,
		180,
		187,
		-1,
		186,
		-1,
		222,
		201,
		212,
		217,
		161,
		158,
		178,
		197,
		179,
		171,
		237,
		191,
		162,
		156,
		174,
		164,
		173,
		165,
		-1,
		162,
		152,
		174,
		153,
		164,
		156,
		-1,
		-1,
		156,
		157,
		163,
		149,
		155,
		151,
		-1,
		161,
		145,
		-1,
		-1,
		146,
		147,
		131,
		134,
		142,
		140,
		153,
		145,
		140,
		-1,
		-1,
		137,
		133,
		140,
		127,
		123,
		140,
		153,
		135,
		149,
		148,
		-1,
		141,
		159,
		166,
		134,
		132,
		116,
		114,
		132,
		134,
		140,
		140,
		-1,
		150,
		151,
		146,
		154,
		156,
		132,
		119,
		119,
		129,
		122,
		141,
		129,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		150,
		133,
		150,
		142,
		132,
		147,
		140,
		122,
		119,
		117,
		114,
		130,
		128,
		138,
		-1,
		-1,
		243,
		212,
		241,
		199,
		180,
		-1,
		146,
		126,
		132,
		136,
		130,
		123,
		137,
		133,
		-1,
		108,
		107,
		135,
		121,
		132,
		203,
		-1,
		-1,
		201,
		193,
		176,
		179,
		156,
		152,
		141,
		140,
		132,
		118,
		114,
		120,
		123,
		123,
		129,
		102,
		112,
		116,
		114,
		139,
		-1,
		-1,
		174,
		-1,
		-1,
		200,
		183,
		-1,
		166,
		173,
		162,
		168,
		154,
		175,
		151,
		142,
		134,
		128,
		116,
		118,
		115,
		128,
		116,
		99,
		124,
		128,
		109,
		130,
		125,
		-1,
		173,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		159,
		162,
		168,
		192,
		191,
		-1,
		163,
		151,
		152,
		137,
		134,
		121,
		109,
		122,
		107,
		114,
		113,
		103,
		101,
		131,
		106,
		128,
		125,
		144,
		149,
		143,
		152,
		-1,
		208,
		204,
		200,
		207,
		156,
		-1,
		-1,
		196,
		-1,
		199,
		200,
		175,
		148,
		151,
		138,
		129,
		116,
		105,
		116,
		105,
		102,
		110,
		95,
		110,
		101,
		100,
		118,
		128,
		136,
		140,
		146,
		-1,
		258,
		-1,
		200,
		184,
		186,
		158,
		179,
		-1,
		216,
		200,
		192,
		177,
		177,
		-1,
		147,
		144,
		134,
		112,
		97,
		114,
		106,
		104,
		108,
		90,
		104,
		95,
		113,
		120,
		118,
		122,
		142,
		154,
		218,
		208,
		-1,
		190,
		195,
		154,
		162,
		181,
		219,
		183,
		-1,
		178,
		-1,
		149,
		162,
		-1,
		118,
		114,
		96,
		97,
		92,
		107,
		101,
		86,
		83,
		101,
		104,
		111,
		115,
		131,
		-1,
		-1,
		203,
		207,
		196,
		147,
		166,
		190,
		227,
		176,
		165,
		164,
		-1,
		155,
		132,
		129,
		117,
		104,
		89,
		90,
		98,
		111,
		90,
		85,
		82,
		102,
		128,
		106,
		118,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		173,
		144,
		168,
		210,
		194,
		187,
		175,
		140,
		140,
		134,
		-1,
		128,
		107,
		98,
		87,
		85,
		98,
		95,
		100,
		80,
		78,
		97,
		109,
		100,
		117,
		-1,
		-1,
		-1,
		203,
		192,
		193,
		139,
		162,
		199,
		173,
		159,
		164,
		139,
		132,
		126,
		141,
		124,
		105,
		94,
		86,
		75,
		91,
		99,
		94,
		76,
		85,
		91,
		115,
		105,
		111,
		-1,
		-1,
		210,
		200,
		184,
		186,
		183,
		153,
		160,
		192,
		164,
		177,
		-1,
		131,
		-1,
		120,
		115,
		99,
		94,
		91,
		88,
		82,
		91,
		93,
		83,
		78,
		85,
		120,
		120,
		95,
		115,
		118,
		-1,
		-1,
		-1,
		203,
		198,
		173,
		150,
		134,
		170,
		-1,
		147,
		148,
		-1,
		125,
		119,
		116,
		101,
		97,
		92,
		96,
		89,
		96,
		89,
		87,
		88,
		70,
		102,
		-1,
		103,
		97,
		105,
		95,
		83,
		-1,
		-1,
		-1,
		196,
		175,
		168,
		188,
		129,
		181,
		-1,
		-1,
		132,
		125,
		-1,
		112,
		94,
		101,
		99,
		93,
		97,
		94,
		83,
		96,
		89,
		75,
		77,
		90,
		94,
		98,
		85,
		81,
		78,
		92,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		149,
		-1,
		141,
		133,
		123,
		117,
		111,
		107,
		105,
		121,
		105,
		108,
		106,
		97,
		105,
		78,
		71,
		78,
		67,
		85,
		93,
		85,
		79,
		78,
		88,
		-1,
		216,
		202,
		173,
		-1,
		-1,
		162,
		-1,
		126,
		140,
		156,
		-1,
		149,
		128,
		143,
		121,
		117,
		113,
		128,
		129,
		107,
		106,
		104,
		95,
		83,
		72,
		75,
		67,
		89,
		89,
		73,
		74,
		78,
		-1,
		222,
		209,
		167,
		163,
		152,
		172,
		123,
		111,
		143,
		-1,
		-1,
		185,
		-1,
		119,
		136,
		127,
		125,
		118,
		103,
		110,
		115,
		92,
		87,
		77,
		66,
		66,
		61,
		83,
		69,
		67,
		76,
		92,
		-1,
		-1,
		-1,
		189,
		-1,
		-1,
		138,
		125,
		119,
		-1,
		160,
		-1,
		163,
		153,
		137,
		122,
		155,
		-1,
		102,
		98,
		105,
		-1,
		112,
		-1,
		85,
		82,
		73,
		58,
		55,
		66,
		64,
		75,
		71,
		-1,
		172,
		157,
		150,
		140,
		154,
		125,
		-1,
		180,
		-1,
		-1,
		150,
		144,
		144,
		128,
		131,
		118,
		98,
		90,
		105,
		104,
		91,
		90,
		71,
		64,
		61,
		54,
		67,
		77,
		82,
		69,
		-1,
		-1,
		-1,
		177,
		163,
		167,
		127,
		146,
		-1,
		-1,
		212,
		167,
		153,
		-1,
		127,
		118,
		106,
		96,
		86,
		91,
		92,
		82,
		80,
		69,
		71,
		65,
		56,
		55,
		71,
		63,
		85,
		-1,
		-1,
		160,
		165,
		153,
		139,
		158,
		-1,
		-1,
		-1,
		159,
		175,
		146,
		125,
		107,
		-1,
		-1,
		90,
		83,
		77,
		80,
		68,
		85,
		80,
		64,
		49,
		64,
		68,
		76,
		67,
		-1,
		163,
		150,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		-1,
		-1,
		158,
		103,
		92,
		87,
		91,
		89,
		-1,
		63,
		74,
		67,
		86,
		93,
		66,
		51,
		45,
		51,
		63,
		72,
		-1,
		-1,
		175,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		80,
		73,
		77,
		-1,
		65,
		67,
		64,
		76,
		69,
		66,
		57,
		48,
		44,
		48,
		52,
		66,
		70,
		198,
		-1,
		142,
		-1,
		-1,
		-1,
		133,
		148,
		119,
		96,
		69,
		64,
		57,
		51,
		56,
		67,
		76,
		87,
		52,
		51,
		41,
		40,
		44,
		61,
		65,
		-1,
		-1,
		140,
		136,
		159,
		141,
		145,
		146,
		-1,
		-1,
		73,
		64,
		55,
		47,
		60,
		63,
		48,
		50,
		50,
		45,
		39,
		49,
		64,
		59,
		-1,
		-1,
		-1,
		152,
		-1,
		154,
		-1,
		-1,
		142,
		144,
		91,
		73,
		69,
		67,
		56,
		50,
		38,
		43,
		53,
		47,
		44,
		35,
		39,
		62,
		51,
		90,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		131,
		123,
		118,
		124,
		126,
		117,
		106,
		103,
		-1,
		73,
		79,
		44,
		51,
		34,
		41,
		46,
		43,
		29,
		36,
		52,
		51,
		46,
		82,
		73,
		79,
		-1,
		-1,
		217,
		206,
		195,
		201,
		-1,
		124,
		120,
		110,
		100,
		103,
		-1,
		-1,
		97,
		94,
		74,
		43,
		42,
		35,
		30,
		35,
		16,
		25,
		29,
		33,
		39,
		44,
		49,
		55,
		70,
		85,
		-1,
		171,
		208,
		201,
		169,
		177,
		208,
		-1,
		114,
		106,
		117,
		92,
		94,
		-1,
		-1,
		70,
		61,
		62,
		50,
		47,
		54,
		53,
		11,
		30,
		43,
		32,
		31,
		49,
		53,
		62,
		69,
		59,
		72,
		76,
		-1,
		164,
		184,
		163,
		166,
		190,
		204,
		-1,
		111,
		-1,
		-1,
		123,
		95,
		79,
		69,
		66,
		109,
		56,
		51,
		28,
		26,
		0,
		8,
		49,
		39,
		40,
		43,
		58,
		63,
		55,
		69,
		69,
		70,
		-1,
		153,
		164,
		157,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		139,
		-1,
		106,
		-1,
		89,
		93,
		64,
		67,
		42,
		29,
		21,
		29,
		37,
		37,
		42,
		44,
		45,
		54,
		65,
		77,
		76,
		77,
		178,
		134,
		137,
		148,
		159,
		174,
		178,
		-1,
		123,
		162,
		152,
		-1,
		136,
		-1,
		-1,
		-1,
		103,
		77,
		69,
		62,
		41,
		41,
		15,
		19,
		32,
		39,
		49,
		62,
		54,
		58,
		71,
		82,
		85,
		174,
		165,
		178,
		123,
		123,
		144,
		153,
		174,
		138,
		129,
		156,
		159,
		148,
		143,
		130,
		-1,
		-1,
		113,
		87,
		-1,
		-1,
		48,
		36,
		19,
		21,
		25,
		39,
		51,
		64,
		61,
		59,
		53,
		85,
		-1,
		167,
		166,
		155,
		152,
		128,
		119,
		114,
		141,
		-1,
		-1,
		136,
		157,
		147,
		151,
		167,
		192,
		-1,
		119,
		-1,
		-1,
		93,
		-1,
		-1,
		78,
		41,
		30,
		21,
		27,
		33,
		44,
		66,
		67,
		68,
		58,
		68,
		81,
		151,
		148,
		136,
		134,
		157,
		122,
		110,
		-1,
		123,
		121,
		127,
		134,
		151,
		181,
		-1,
		-1,
		135,
		115,
		-1,
		-1,
		76,
		74,
		63,
		-1,
		53,
		26,
		31,
		56,
		63,
		65,
		70,
		64,
		71,
		70,
		78,
		86,
		160,
		174,
		163,
		159,
		158,
		166,
		115,
		108,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		125,
		121,
		-1,
		-1,
		71,
		64,
		52,
		40,
		30,
		40,
		48,
		48,
		51,
		56,
		62,
		73,
		65,
		69,
		86,
		-1,
		194,
		-1,
		146,
		122,
		136,
		151,
		159,
		-1,
		-1,
		-1,
		142,
		128,
		121,
		109,
		107,
		-1,
		105,
		89,
		70,
		-1,
		40,
		53,
		84,
		52,
		57,
		52,
		68,
		79,
		68,
		71,
		85,
		80,
		-1,
		-1,
		134,
		137,
		-1,
		-1,
		132,
		134,
		-1,
		133,
		122,
		107,
		99,
		-1,
		-1,
		77,
		73,
		-1,
		-1,
		41,
		66,
		55,
		63,
		58,
		70,
		78,
		78,
		70,
		74,
		86,
		-1,
		-1,
		141,
		142,
		139,
		-1,
		117,
		-1,
		135,
		-1,
		102,
		108,
		96,
		-1,
		-1,
		-1,
		79,
		42,
		63,
		73,
		78,
		76,
		67,
		66,
		73,
		81,
		77,
		88,
		-1,
		-1,
		-1,
		135,
		109,
		142,
		133,
		116,
		96,
		88,
		107,
		-1,
		77,
		-1,
		46,
		43,
		80,
		72,
		89,
		83,
		69,
		84,
		80,
		75,
		84,
		141,
		-1,
		111,
		144,
		108,
		102,
		78,
		82,
		98,
		-1,
		74,
		54,
		-1,
		84,
		74,
		106,
		92,
		80,
		67,
		74,
		88,
		81,
		-1,
		-1,
		-1,
		113,
		112,
		104,
		98,
		98,
		83,
		74,
		-1,
		86,
		68,
		47,
		64,
		64,
		55,
		63,
		96,
		92,
		85,
		87,
		79,
		-1,
		214,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		107,
		102,
		75,
		63,
		69,
		65,
		51,
		57,
		59,
		67,
		65,
		62,
		74,
		70,
		90,
		80,
		116,
		-1,
		209,
		-1,
		143,
		-1,
		-1,
		125,
		105,
		97,
		86,
		75,
		73,
		64,
		55,
		77,
		93,
		77,
		75,
		80,
		85,
		-1,
		198,
		197,
		-1,
		144,
		136,
		122,
		-1,
		115,
		-1,
		121,
		82,
		-1,
		84,
		64,
		-1,
		86,
		82,
		-1,
		-1,
		185,
		160,
		-1,
		-1,
		-1,
		145,
		125,
		116,
		100,
		-1,
		75,
		75,
		-1,
		-1,
		-1,
		170,
		169,
		-1,
		138,
		141,
		-1,
		131,
		122,
		130,
		77,
		81,
		-1,
		-1,
		-1,
		179,
		160,
		154,
		153,
		151,
		146,
		143,
		129,
		113,
		91,
		80,
		101,
		-1,
		-1,
		-1,
		151,
		143,
		136,
		-1,
		-1,
		138,
		121,
		102,
		100,
		-1,
		-1,
		-1,
		173,
		154,
		-1,
		-1,
		128,
		-1,
		-1,
		134,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		162,
		-1,
		-1,
		-1,
		124,
		120,
		121,
		-1,
		-1,
		-1,
		-1,
		184,
		185,
		208,
		172,
		-1,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		187,
		185,
		-1,
		-1,
		-1,
		144,
		128,
		-1,
		114,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		149,
		-1,
		149,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		162,
		154,
		162,
		-1,
		134,
		136,
		-1,
		184,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		139,
		146,
		168,
		171,
		207,
		-1,
		158
	],
	[
		-1,
		193,
		182,
		193,
		201,
		174,
		181,
		-1,
		200,
		204,
		170,
		164,
		203,
		172,
		178,
		189,
		-1,
		-1,
		-1,
		193,
		192,
		160,
		158,
		167,
		172,
		179,
		-1,
		178,
		-1,
		214,
		193,
		204,
		209,
		153,
		150,
		170,
		189,
		171,
		163,
		229,
		183,
		154,
		148,
		166,
		156,
		165,
		157,
		-1,
		154,
		144,
		166,
		145,
		156,
		148,
		-1,
		-1,
		148,
		149,
		155,
		141,
		147,
		143,
		-1,
		153,
		137,
		-1,
		-1,
		138,
		139,
		123,
		126,
		134,
		132,
		145,
		137,
		132,
		-1,
		-1,
		129,
		125,
		132,
		119,
		115,
		132,
		145,
		127,
		141,
		140,
		-1,
		133,
		151,
		158,
		126,
		124,
		108,
		106,
		124,
		126,
		132,
		132,
		-1,
		142,
		143,
		138,
		146,
		148,
		124,
		111,
		111,
		121,
		114,
		133,
		121,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		142,
		125,
		142,
		134,
		124,
		139,
		132,
		114,
		111,
		109,
		106,
		122,
		120,
		130,
		-1,
		-1,
		235,
		204,
		233,
		191,
		172,
		-1,
		138,
		118,
		124,
		128,
		122,
		115,
		129,
		125,
		-1,
		100,
		99,
		127,
		113,
		124,
		195,
		-1,
		-1,
		193,
		185,
		168,
		171,
		148,
		144,
		133,
		132,
		124,
		110,
		106,
		112,
		115,
		115,
		121,
		94,
		104,
		108,
		106,
		131,
		-1,
		-1,
		166,
		-1,
		-1,
		192,
		175,
		-1,
		158,
		165,
		154,
		160,
		146,
		167,
		143,
		134,
		126,
		120,
		108,
		110,
		107,
		120,
		108,
		91,
		116,
		120,
		101,
		122,
		117,
		-1,
		165,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		151,
		154,
		160,
		184,
		183,
		-1,
		155,
		143,
		144,
		129,
		126,
		113,
		101,
		114,
		99,
		106,
		105,
		95,
		93,
		123,
		98,
		120,
		117,
		136,
		141,
		135,
		144,
		-1,
		200,
		196,
		192,
		199,
		148,
		-1,
		-1,
		188,
		-1,
		191,
		192,
		167,
		140,
		143,
		130,
		121,
		108,
		97,
		108,
		97,
		94,
		102,
		87,
		102,
		93,
		92,
		110,
		120,
		128,
		132,
		138,
		-1,
		250,
		-1,
		192,
		176,
		178,
		150,
		171,
		-1,
		208,
		192,
		184,
		169,
		169,
		-1,
		139,
		136,
		126,
		104,
		89,
		106,
		98,
		96,
		100,
		82,
		96,
		87,
		105,
		112,
		110,
		114,
		134,
		146,
		210,
		200,
		-1,
		182,
		187,
		146,
		154,
		173,
		211,
		175,
		-1,
		170,
		-1,
		141,
		154,
		-1,
		110,
		106,
		88,
		89,
		84,
		99,
		93,
		78,
		75,
		93,
		96,
		103,
		107,
		123,
		-1,
		-1,
		195,
		199,
		188,
		139,
		158,
		182,
		219,
		168,
		157,
		156,
		-1,
		147,
		124,
		121,
		109,
		96,
		81,
		82,
		90,
		103,
		82,
		77,
		74,
		94,
		120,
		98,
		110,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		165,
		136,
		160,
		202,
		186,
		179,
		167,
		132,
		132,
		126,
		-1,
		120,
		99,
		90,
		79,
		77,
		90,
		87,
		92,
		72,
		70,
		89,
		101,
		92,
		109,
		-1,
		-1,
		-1,
		195,
		184,
		185,
		131,
		154,
		191,
		165,
		151,
		156,
		131,
		124,
		118,
		133,
		116,
		97,
		86,
		78,
		67,
		83,
		91,
		86,
		68,
		77,
		83,
		107,
		97,
		103,
		-1,
		-1,
		202,
		192,
		176,
		178,
		175,
		145,
		152,
		184,
		156,
		169,
		-1,
		123,
		-1,
		112,
		107,
		91,
		86,
		83,
		80,
		74,
		83,
		85,
		75,
		70,
		77,
		112,
		112,
		87,
		107,
		110,
		-1,
		-1,
		-1,
		195,
		190,
		165,
		142,
		126,
		162,
		-1,
		139,
		140,
		-1,
		117,
		111,
		108,
		93,
		89,
		84,
		88,
		81,
		88,
		81,
		79,
		80,
		62,
		94,
		-1,
		95,
		89,
		97,
		87,
		75,
		-1,
		-1,
		-1,
		188,
		167,
		160,
		180,
		121,
		173,
		-1,
		-1,
		124,
		117,
		-1,
		104,
		86,
		93,
		91,
		85,
		89,
		86,
		75,
		88,
		81,
		67,
		69,
		82,
		86,
		90,
		77,
		73,
		70,
		84,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		141,
		-1,
		133,
		125,
		115,
		109,
		103,
		99,
		97,
		113,
		97,
		100,
		98,
		89,
		97,
		70,
		63,
		70,
		59,
		77,
		85,
		77,
		71,
		70,
		80,
		-1,
		208,
		194,
		165,
		-1,
		-1,
		154,
		-1,
		118,
		132,
		148,
		-1,
		141,
		120,
		135,
		113,
		109,
		105,
		120,
		121,
		99,
		98,
		96,
		87,
		75,
		64,
		67,
		59,
		81,
		81,
		65,
		66,
		70,
		-1,
		214,
		201,
		159,
		155,
		144,
		164,
		115,
		103,
		135,
		-1,
		-1,
		177,
		-1,
		111,
		128,
		119,
		117,
		110,
		95,
		102,
		107,
		84,
		79,
		69,
		58,
		58,
		53,
		75,
		61,
		59,
		68,
		84,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		130,
		117,
		111,
		-1,
		152,
		-1,
		155,
		145,
		129,
		114,
		147,
		-1,
		94,
		90,
		97,
		-1,
		104,
		-1,
		77,
		74,
		65,
		50,
		47,
		58,
		56,
		67,
		63,
		-1,
		164,
		149,
		142,
		132,
		146,
		117,
		-1,
		172,
		-1,
		-1,
		142,
		136,
		136,
		120,
		123,
		110,
		90,
		82,
		97,
		96,
		83,
		82,
		63,
		56,
		53,
		46,
		59,
		69,
		74,
		61,
		-1,
		-1,
		-1,
		169,
		155,
		159,
		119,
		138,
		-1,
		-1,
		204,
		159,
		145,
		-1,
		119,
		110,
		98,
		88,
		78,
		83,
		84,
		74,
		72,
		61,
		63,
		57,
		48,
		47,
		63,
		55,
		77,
		-1,
		-1,
		152,
		157,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		151,
		167,
		138,
		117,
		99,
		-1,
		-1,
		82,
		75,
		69,
		72,
		60,
		77,
		72,
		56,
		41,
		56,
		60,
		68,
		59,
		-1,
		155,
		142,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		150,
		95,
		84,
		79,
		83,
		81,
		-1,
		55,
		66,
		59,
		78,
		85,
		58,
		43,
		37,
		43,
		55,
		64,
		-1,
		-1,
		167,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		107,
		101,
		72,
		65,
		69,
		-1,
		57,
		59,
		56,
		68,
		61,
		58,
		49,
		40,
		36,
		40,
		44,
		58,
		62,
		190,
		-1,
		134,
		-1,
		-1,
		-1,
		125,
		140,
		111,
		88,
		61,
		56,
		49,
		43,
		48,
		59,
		68,
		79,
		44,
		43,
		33,
		32,
		36,
		53,
		57,
		-1,
		-1,
		132,
		128,
		151,
		133,
		137,
		138,
		-1,
		-1,
		65,
		56,
		47,
		39,
		52,
		55,
		40,
		42,
		42,
		37,
		31,
		41,
		56,
		51,
		-1,
		-1,
		-1,
		144,
		-1,
		146,
		-1,
		-1,
		134,
		136,
		83,
		65,
		61,
		59,
		48,
		42,
		30,
		35,
		45,
		39,
		36,
		27,
		31,
		54,
		43,
		82,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		123,
		115,
		110,
		116,
		118,
		109,
		98,
		95,
		-1,
		65,
		71,
		36,
		43,
		26,
		33,
		38,
		35,
		21,
		28,
		44,
		43,
		38,
		74,
		65,
		71,
		-1,
		-1,
		209,
		198,
		187,
		193,
		-1,
		116,
		112,
		102,
		92,
		95,
		-1,
		-1,
		89,
		86,
		66,
		35,
		34,
		27,
		22,
		27,
		8,
		17,
		21,
		25,
		31,
		36,
		41,
		47,
		62,
		77,
		-1,
		163,
		200,
		193,
		161,
		169,
		200,
		-1,
		106,
		98,
		109,
		84,
		86,
		-1,
		-1,
		62,
		53,
		54,
		42,
		39,
		46,
		45,
		12,
		25,
		35,
		24,
		23,
		41,
		45,
		54,
		61,
		51,
		64,
		68,
		-1,
		156,
		176,
		155,
		158,
		182,
		196,
		-1,
		103,
		-1,
		-1,
		115,
		87,
		71,
		61,
		58,
		101,
		48,
		43,
		20,
		18,
		9,
		0,
		41,
		31,
		32,
		35,
		50,
		55,
		47,
		61,
		61,
		62,
		-1,
		145,
		156,
		149,
		-1,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		131,
		-1,
		98,
		-1,
		81,
		85,
		56,
		59,
		34,
		21,
		13,
		23,
		29,
		29,
		34,
		36,
		37,
		46,
		57,
		69,
		68,
		69,
		170,
		126,
		129,
		140,
		151,
		166,
		170,
		-1,
		115,
		154,
		144,
		-1,
		128,
		-1,
		-1,
		-1,
		95,
		69,
		61,
		54,
		33,
		33,
		7,
		11,
		24,
		31,
		41,
		54,
		46,
		50,
		63,
		74,
		77,
		166,
		157,
		170,
		115,
		115,
		136,
		145,
		166,
		130,
		121,
		148,
		151,
		140,
		135,
		122,
		-1,
		-1,
		105,
		79,
		-1,
		-1,
		40,
		28,
		11,
		13,
		17,
		31,
		43,
		56,
		53,
		51,
		45,
		77,
		-1,
		159,
		158,
		147,
		144,
		120,
		111,
		106,
		133,
		-1,
		-1,
		128,
		149,
		139,
		143,
		159,
		184,
		-1,
		111,
		-1,
		-1,
		85,
		-1,
		-1,
		70,
		33,
		22,
		13,
		19,
		25,
		36,
		58,
		59,
		60,
		50,
		60,
		73,
		143,
		140,
		128,
		126,
		149,
		114,
		102,
		-1,
		115,
		113,
		119,
		126,
		143,
		173,
		-1,
		-1,
		127,
		107,
		-1,
		-1,
		68,
		66,
		55,
		-1,
		45,
		18,
		23,
		48,
		55,
		57,
		62,
		56,
		63,
		62,
		70,
		78,
		152,
		166,
		155,
		151,
		150,
		158,
		107,
		100,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		117,
		113,
		-1,
		-1,
		63,
		56,
		44,
		32,
		22,
		32,
		40,
		40,
		43,
		48,
		54,
		65,
		57,
		61,
		78,
		-1,
		186,
		-1,
		138,
		114,
		128,
		143,
		151,
		-1,
		-1,
		-1,
		134,
		120,
		113,
		101,
		99,
		-1,
		97,
		81,
		62,
		-1,
		32,
		45,
		76,
		44,
		49,
		44,
		60,
		71,
		60,
		63,
		77,
		72,
		-1,
		-1,
		126,
		129,
		-1,
		-1,
		124,
		126,
		-1,
		125,
		114,
		99,
		91,
		-1,
		-1,
		69,
		65,
		-1,
		-1,
		33,
		58,
		47,
		55,
		50,
		62,
		70,
		70,
		62,
		66,
		78,
		-1,
		-1,
		133,
		134,
		131,
		-1,
		109,
		-1,
		127,
		-1,
		94,
		100,
		88,
		-1,
		-1,
		-1,
		71,
		34,
		55,
		65,
		70,
		68,
		59,
		58,
		65,
		73,
		69,
		80,
		-1,
		-1,
		-1,
		127,
		101,
		134,
		125,
		108,
		88,
		80,
		99,
		-1,
		69,
		-1,
		38,
		35,
		72,
		64,
		81,
		75,
		61,
		76,
		72,
		67,
		76,
		133,
		-1,
		103,
		136,
		100,
		94,
		70,
		74,
		90,
		-1,
		66,
		46,
		-1,
		76,
		66,
		98,
		84,
		72,
		59,
		66,
		80,
		73,
		-1,
		-1,
		-1,
		105,
		104,
		96,
		90,
		90,
		75,
		66,
		-1,
		78,
		60,
		39,
		56,
		56,
		47,
		55,
		88,
		84,
		77,
		79,
		71,
		-1,
		206,
		-1,
		-1,
		128,
		-1,
		-1,
		-1,
		99,
		94,
		67,
		55,
		61,
		57,
		43,
		49,
		51,
		59,
		57,
		54,
		66,
		62,
		82,
		72,
		108,
		-1,
		201,
		-1,
		135,
		-1,
		-1,
		117,
		97,
		89,
		78,
		67,
		65,
		56,
		47,
		69,
		85,
		69,
		67,
		72,
		77,
		-1,
		190,
		189,
		-1,
		136,
		128,
		114,
		-1,
		107,
		-1,
		113,
		74,
		-1,
		76,
		56,
		-1,
		78,
		74,
		-1,
		-1,
		177,
		152,
		-1,
		-1,
		-1,
		137,
		117,
		108,
		92,
		-1,
		67,
		67,
		-1,
		-1,
		-1,
		162,
		161,
		-1,
		130,
		133,
		-1,
		123,
		114,
		122,
		69,
		73,
		-1,
		-1,
		-1,
		171,
		152,
		146,
		145,
		143,
		138,
		135,
		121,
		105,
		83,
		72,
		93,
		-1,
		-1,
		-1,
		143,
		135,
		128,
		-1,
		-1,
		130,
		113,
		94,
		92,
		-1,
		-1,
		-1,
		165,
		146,
		-1,
		-1,
		120,
		-1,
		-1,
		126,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		154,
		-1,
		-1,
		-1,
		116,
		112,
		113,
		-1,
		-1,
		-1,
		-1,
		176,
		177,
		200,
		164,
		-1,
		-1,
		-1,
		108,
		102,
		-1,
		-1,
		179,
		177,
		-1,
		-1,
		-1,
		136,
		120,
		-1,
		106,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		141,
		-1,
		141,
		116,
		123,
		-1,
		-1,
		-1,
		-1,
		154,
		146,
		154,
		-1,
		126,
		128,
		-1,
		176,
		-1,
		-1,
		169,
		160,
		-1,
		-1,
		131,
		138,
		160,
		163,
		199,
		-1,
		150
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		143,
		161,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		152,
		153,
		148,
		156,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		245,
		214,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		110,
		109,
		137,
		123,
		134,
		205,
		-1,
		-1,
		203,
		195,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		202,
		194,
		179,
		179,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		221,
		185,
		-1,
		180,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		113,
		92,
		87,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		97,
		102,
		82,
		80,
		99,
		111,
		102,
		119,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		143,
		126,
		107,
		96,
		88,
		77,
		93,
		101,
		96,
		78,
		87,
		93,
		117,
		107,
		113,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		90,
		84,
		93,
		95,
		85,
		80,
		87,
		122,
		122,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		94,
		98,
		91,
		98,
		91,
		89,
		90,
		72,
		104,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		101,
		95,
		99,
		96,
		85,
		98,
		91,
		77,
		79,
		92,
		96,
		100,
		87,
		83,
		80,
		94,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		110,
		108,
		99,
		107,
		80,
		73,
		80,
		69,
		87,
		95,
		87,
		81,
		80,
		90,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		130,
		131,
		109,
		108,
		106,
		97,
		85,
		74,
		77,
		69,
		91,
		91,
		75,
		76,
		80,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		129,
		127,
		120,
		111,
		117,
		117,
		94,
		89,
		79,
		68,
		68,
		63,
		85,
		71,
		69,
		78,
		94,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		122,
		112,
		117,
		-1,
		114,
		-1,
		87,
		84,
		75,
		60,
		57,
		68,
		66,
		77,
		73,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		138,
		118,
		110,
		117,
		109,
		101,
		95,
		73,
		66,
		63,
		56,
		69,
		79,
		84,
		71,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		138,
		126,
		116,
		106,
		111,
		112,
		92,
		85,
		71,
		73,
		67,
		58,
		57,
		73,
		65,
		87,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		177,
		166,
		140,
		127,
		-1,
		-1,
		110,
		103,
		97,
		88,
		75,
		87,
		82,
		66,
		51,
		66,
		70,
		78,
		69,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		178,
		123,
		112,
		107,
		111,
		109,
		-1,
		83,
		94,
		79,
		91,
		98,
		68,
		53,
		47,
		53,
		65,
		74,
		-1,
		-1,
		177,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		135,
		129,
		100,
		93,
		97,
		-1,
		85,
		87,
		81,
		96,
		71,
		68,
		59,
		50,
		46,
		50,
		54,
		68,
		72,
		200,
		-1,
		163,
		-1,
		-1,
		-1,
		153,
		168,
		139,
		116,
		89,
		84,
		77,
		71,
		76,
		87,
		79,
		90,
		57,
		53,
		43,
		42,
		46,
		63,
		67,
		-1,
		-1,
		161,
		157,
		179,
		161,
		165,
		166,
		-1,
		-1,
		93,
		84,
		75,
		67,
		80,
		83,
		63,
		60,
		50,
		47,
		41,
		51,
		66,
		61,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		164,
		111,
		93,
		89,
		87,
		76,
		70,
		58,
		63,
		56,
		47,
		45,
		37,
		41,
		64,
		53,
		92,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		126,
		123,
		-1,
		93,
		99,
		64,
		71,
		54,
		54,
		51,
		43,
		31,
		38,
		54,
		53,
		48,
		84,
		75,
		81,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		62,
		55,
		50,
		57,
		36,
		27,
		31,
		35,
		41,
		46,
		51,
		57,
		72,
		87,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		70,
		65,
		56,
		35,
		24,
		29,
		33,
		51,
		55,
		64,
		68,
		61,
		74,
		78,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		144,
		116,
		100,
		90,
		87,
		130,
		85,
		80,
		64,
		62,
		53,
		44,
		0,
		26,
		42,
		45,
		55,
		60,
		52,
		71,
		71,
		72,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		127,
		-1,
		110,
		114,
		93,
		96,
		78,
		65,
		54,
		32,
		33,
		31,
		39,
		42,
		42,
		51,
		62,
		74,
		78,
		79,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		124,
		106,
		98,
		98,
		77,
		77,
		46,
		42,
		36,
		43,
		45,
		55,
		51,
		55,
		68,
		79,
		87,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		180,
		169,
		164,
		151,
		-1,
		-1,
		144,
		116,
		-1,
		-1,
		84,
		67,
		50,
		44,
		43,
		46,
		61,
		60,
		58,
		56,
		50,
		82,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		188,
		213,
		-1,
		140,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		72,
		61,
		52,
		50,
		51,
		62,
		72,
		64,
		65,
		55,
		65,
		78,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		202,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		57,
		54,
		75,
		84,
		73,
		67,
		61,
		68,
		67,
		75,
		83,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		68,
		68,
		71,
		71,
		64,
		59,
		70,
		62,
		66,
		83,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		107,
		75,
		80,
		75,
		65,
		76,
		65,
		68,
		82,
		77,
		-1,
		-1,
		155,
		158,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		89,
		78,
		86,
		81,
		69,
		75,
		78,
		67,
		71,
		83,
		-1,
		-1,
		162,
		163,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		110,
		73,
		94,
		96,
		98,
		96,
		87,
		73,
		80,
		78,
		74,
		85,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		73,
		74,
		101,
		95,
		109,
		103,
		76,
		91,
		81,
		72,
		81,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		77,
		-1,
		105,
		95,
		125,
		110,
		91,
		78,
		85,
		85,
		78,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		84,
		115,
		111,
		98,
		98,
		90,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		86,
		83,
		95,
		91,
		111,
		91,
		126,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		98,
		96,
		98,
		99,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		107,
		103,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		191,
		180,
		191,
		199,
		172,
		179,
		-1,
		198,
		202,
		168,
		162,
		201,
		170,
		176,
		187,
		-1,
		-1,
		-1,
		191,
		190,
		158,
		156,
		165,
		170,
		177,
		-1,
		176,
		-1,
		212,
		191,
		202,
		207,
		151,
		148,
		168,
		187,
		169,
		161,
		227,
		181,
		152,
		146,
		164,
		154,
		163,
		155,
		-1,
		152,
		142,
		164,
		143,
		154,
		146,
		-1,
		-1,
		146,
		147,
		153,
		139,
		145,
		141,
		-1,
		151,
		135,
		-1,
		-1,
		136,
		137,
		121,
		124,
		132,
		130,
		143,
		135,
		130,
		-1,
		-1,
		127,
		123,
		130,
		117,
		113,
		130,
		143,
		125,
		139,
		138,
		-1,
		131,
		149,
		156,
		124,
		122,
		106,
		104,
		122,
		124,
		130,
		130,
		-1,
		140,
		141,
		136,
		144,
		146,
		122,
		109,
		109,
		119,
		112,
		131,
		119,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		140,
		123,
		140,
		132,
		122,
		137,
		130,
		112,
		109,
		107,
		104,
		120,
		118,
		128,
		-1,
		-1,
		233,
		202,
		231,
		189,
		170,
		-1,
		136,
		116,
		122,
		126,
		120,
		113,
		127,
		123,
		-1,
		98,
		97,
		125,
		111,
		122,
		193,
		-1,
		-1,
		191,
		183,
		166,
		169,
		146,
		142,
		131,
		130,
		122,
		108,
		104,
		110,
		113,
		113,
		119,
		92,
		102,
		106,
		104,
		129,
		-1,
		-1,
		164,
		-1,
		-1,
		190,
		173,
		-1,
		156,
		163,
		152,
		158,
		144,
		165,
		141,
		132,
		124,
		118,
		106,
		108,
		105,
		118,
		106,
		89,
		114,
		118,
		99,
		120,
		115,
		-1,
		163,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		149,
		152,
		158,
		182,
		181,
		-1,
		153,
		141,
		142,
		127,
		124,
		111,
		99,
		112,
		97,
		104,
		103,
		93,
		91,
		121,
		96,
		118,
		115,
		134,
		139,
		133,
		142,
		-1,
		198,
		194,
		190,
		197,
		146,
		-1,
		-1,
		186,
		-1,
		189,
		190,
		165,
		138,
		141,
		128,
		119,
		106,
		95,
		106,
		95,
		92,
		100,
		85,
		100,
		91,
		90,
		108,
		118,
		126,
		130,
		136,
		-1,
		248,
		-1,
		190,
		174,
		176,
		148,
		169,
		-1,
		206,
		190,
		182,
		167,
		167,
		-1,
		137,
		134,
		124,
		102,
		87,
		104,
		96,
		94,
		98,
		80,
		94,
		85,
		103,
		110,
		108,
		112,
		132,
		144,
		208,
		198,
		-1,
		180,
		185,
		144,
		152,
		171,
		209,
		173,
		-1,
		168,
		-1,
		139,
		152,
		-1,
		108,
		104,
		86,
		87,
		82,
		97,
		91,
		76,
		73,
		91,
		94,
		101,
		105,
		121,
		-1,
		-1,
		193,
		197,
		186,
		137,
		156,
		180,
		217,
		166,
		155,
		154,
		-1,
		145,
		122,
		119,
		107,
		94,
		79,
		80,
		88,
		101,
		80,
		75,
		72,
		92,
		118,
		96,
		108,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		163,
		134,
		158,
		200,
		184,
		177,
		165,
		130,
		130,
		124,
		-1,
		118,
		97,
		88,
		77,
		75,
		88,
		85,
		90,
		70,
		68,
		87,
		99,
		90,
		107,
		-1,
		-1,
		-1,
		193,
		182,
		183,
		129,
		152,
		189,
		163,
		149,
		154,
		129,
		122,
		116,
		131,
		114,
		95,
		84,
		76,
		65,
		81,
		89,
		84,
		66,
		75,
		81,
		105,
		95,
		101,
		-1,
		-1,
		200,
		190,
		174,
		176,
		173,
		143,
		150,
		182,
		154,
		167,
		-1,
		121,
		-1,
		110,
		105,
		89,
		84,
		81,
		78,
		72,
		81,
		83,
		73,
		68,
		75,
		110,
		110,
		85,
		105,
		108,
		-1,
		-1,
		-1,
		193,
		188,
		163,
		140,
		124,
		160,
		-1,
		137,
		138,
		-1,
		115,
		109,
		106,
		91,
		87,
		82,
		86,
		79,
		86,
		79,
		77,
		78,
		60,
		92,
		-1,
		93,
		87,
		95,
		85,
		73,
		-1,
		-1,
		-1,
		186,
		165,
		158,
		178,
		119,
		171,
		-1,
		-1,
		122,
		115,
		-1,
		102,
		84,
		91,
		89,
		83,
		87,
		84,
		73,
		86,
		79,
		65,
		67,
		80,
		84,
		88,
		75,
		71,
		68,
		82,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		139,
		-1,
		131,
		123,
		113,
		107,
		101,
		97,
		95,
		111,
		95,
		98,
		96,
		87,
		95,
		68,
		61,
		68,
		57,
		75,
		83,
		75,
		69,
		68,
		78,
		-1,
		206,
		192,
		163,
		-1,
		-1,
		152,
		-1,
		116,
		130,
		146,
		-1,
		139,
		118,
		133,
		111,
		107,
		103,
		118,
		119,
		97,
		96,
		94,
		85,
		73,
		62,
		65,
		57,
		79,
		79,
		63,
		64,
		68,
		-1,
		212,
		199,
		157,
		153,
		142,
		162,
		113,
		101,
		133,
		-1,
		-1,
		175,
		-1,
		109,
		126,
		117,
		115,
		108,
		99,
		105,
		105,
		82,
		77,
		67,
		56,
		56,
		51,
		73,
		59,
		57,
		66,
		82,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		128,
		115,
		109,
		-1,
		150,
		-1,
		153,
		143,
		127,
		112,
		145,
		-1,
		110,
		100,
		105,
		-1,
		102,
		-1,
		75,
		72,
		63,
		48,
		45,
		56,
		54,
		65,
		61,
		-1,
		162,
		147,
		140,
		130,
		144,
		115,
		-1,
		170,
		-1,
		-1,
		140,
		134,
		134,
		118,
		121,
		126,
		106,
		98,
		105,
		97,
		89,
		83,
		61,
		54,
		51,
		44,
		57,
		67,
		72,
		59,
		-1,
		-1,
		-1,
		167,
		153,
		157,
		117,
		136,
		-1,
		-1,
		202,
		157,
		143,
		-1,
		127,
		126,
		114,
		104,
		94,
		99,
		100,
		80,
		73,
		59,
		61,
		55,
		46,
		45,
		61,
		53,
		75,
		-1,
		-1,
		150,
		155,
		143,
		129,
		148,
		-1,
		-1,
		-1,
		149,
		165,
		154,
		128,
		115,
		-1,
		-1,
		98,
		91,
		85,
		76,
		63,
		75,
		70,
		54,
		39,
		54,
		58,
		66,
		57,
		-1,
		153,
		140,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		166,
		111,
		100,
		95,
		99,
		97,
		-1,
		71,
		82,
		67,
		79,
		86,
		56,
		41,
		35,
		41,
		53,
		62,
		-1,
		-1,
		165,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		88,
		81,
		85,
		-1,
		73,
		75,
		69,
		84,
		59,
		56,
		47,
		38,
		34,
		38,
		42,
		56,
		60,
		188,
		-1,
		151,
		-1,
		-1,
		-1,
		141,
		156,
		127,
		104,
		77,
		72,
		65,
		59,
		64,
		75,
		67,
		78,
		45,
		41,
		31,
		30,
		34,
		51,
		54,
		-1,
		-1,
		149,
		145,
		167,
		149,
		153,
		154,
		-1,
		-1,
		81,
		72,
		63,
		55,
		68,
		71,
		51,
		48,
		42,
		35,
		29,
		39,
		53,
		48,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		151,
		152,
		99,
		81,
		77,
		75,
		64,
		58,
		46,
		51,
		52,
		43,
		37,
		25,
		28,
		51,
		40,
		78,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		135,
		126,
		114,
		111,
		-1,
		81,
		87,
		52,
		59,
		42,
		49,
		47,
		39,
		19,
		25,
		41,
		40,
		35,
		70,
		61,
		65,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		133,
		129,
		119,
		109,
		112,
		-1,
		-1,
		106,
		103,
		83,
		52,
		50,
		43,
		38,
		48,
		28,
		15,
		18,
		22,
		28,
		33,
		38,
		44,
		56,
		71,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		123,
		115,
		126,
		101,
		103,
		-1,
		-1,
		79,
		70,
		71,
		59,
		56,
		58,
		53,
		44,
		24,
		30,
		8,
		15,
		38,
		42,
		46,
		47,
		48,
		61,
		65,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		120,
		-1,
		-1,
		132,
		104,
		88,
		78,
		75,
		118,
		73,
		68,
		49,
		47,
		41,
		32,
		23,
		0,
		21,
		24,
		34,
		39,
		31,
		57,
		58,
		59,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		148,
		-1,
		115,
		-1,
		98,
		102,
		81,
		84,
		63,
		50,
		36,
		32,
		30,
		5,
		20,
		23,
		21,
		30,
		41,
		53,
		63,
		65,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		132,
		171,
		165,
		-1,
		149,
		-1,
		-1,
		-1,
		112,
		94,
		86,
		83,
		62,
		62,
		28,
		24,
		10,
		17,
		27,
		38,
		30,
		34,
		47,
		58,
		73,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		147,
		138,
		165,
		172,
		161,
		156,
		143,
		-1,
		-1,
		126,
		104,
		-1,
		-1,
		69,
		49,
		32,
		21,
		17,
		20,
		35,
		42,
		37,
		35,
		29,
		61,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		166,
		156,
		160,
		176,
		201,
		-1,
		132,
		-1,
		-1,
		106,
		-1,
		-1,
		91,
		54,
		43,
		34,
		32,
		25,
		36,
		46,
		43,
		44,
		34,
		44,
		57,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		132,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		148,
		128,
		-1,
		-1,
		89,
		87,
		76,
		-1,
		66,
		39,
		36,
		52,
		63,
		52,
		46,
		40,
		47,
		46,
		54,
		62,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		138,
		134,
		-1,
		-1,
		84,
		77,
		65,
		53,
		43,
		50,
		45,
		53,
		50,
		43,
		38,
		49,
		41,
		45,
		62,
		-1,
		203,
		-1,
		155,
		131,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		155,
		141,
		134,
		122,
		120,
		-1,
		118,
		102,
		83,
		-1,
		53,
		66,
		89,
		57,
		62,
		57,
		44,
		55,
		44,
		47,
		61,
		56,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		145,
		147,
		-1,
		146,
		135,
		120,
		112,
		-1,
		-1,
		90,
		86,
		-1,
		-1,
		54,
		71,
		60,
		68,
		63,
		48,
		54,
		57,
		46,
		50,
		62,
		-1,
		-1,
		150,
		151,
		152,
		-1,
		130,
		-1,
		148,
		-1,
		115,
		121,
		109,
		-1,
		-1,
		-1,
		92,
		55,
		76,
		78,
		77,
		75,
		66,
		52,
		59,
		57,
		53,
		64,
		-1,
		-1,
		-1,
		148,
		122,
		155,
		146,
		129,
		109,
		101,
		120,
		-1,
		90,
		-1,
		59,
		56,
		92,
		77,
		88,
		82,
		55,
		70,
		60,
		51,
		60,
		154,
		-1,
		124,
		157,
		121,
		115,
		91,
		95,
		111,
		-1,
		87,
		67,
		-1,
		97,
		87,
		104,
		89,
		70,
		57,
		64,
		64,
		57,
		-1,
		-1,
		-1,
		126,
		125,
		117,
		111,
		111,
		96,
		87,
		-1,
		99,
		81,
		60,
		77,
		77,
		68,
		76,
		94,
		90,
		77,
		77,
		69,
		-1,
		227,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		120,
		115,
		88,
		76,
		82,
		78,
		64,
		70,
		72,
		80,
		78,
		75,
		87,
		83,
		93,
		70,
		105,
		-1,
		222,
		-1,
		156,
		-1,
		-1,
		138,
		118,
		110,
		99,
		88,
		86,
		77,
		68,
		90,
		106,
		90,
		82,
		77,
		78,
		-1,
		211,
		210,
		-1,
		157,
		149,
		135,
		-1,
		128,
		-1,
		134,
		95,
		-1,
		97,
		77,
		-1,
		93,
		82,
		-1,
		-1,
		198,
		173,
		-1,
		-1,
		-1,
		158,
		138,
		129,
		113,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		183,
		182,
		-1,
		151,
		154,
		-1,
		144,
		135,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		192,
		173,
		167,
		166,
		164,
		159,
		156,
		142,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		164,
		156,
		149,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		175,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		197,
		198,
		221,
		185,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		200,
		198,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		197,
		186,
		197,
		205,
		178,
		185,
		-1,
		204,
		208,
		174,
		168,
		207,
		176,
		182,
		193,
		-1,
		-1,
		-1,
		197,
		196,
		164,
		162,
		171,
		176,
		183,
		-1,
		182,
		-1,
		218,
		197,
		208,
		213,
		157,
		154,
		174,
		193,
		175,
		167,
		233,
		187,
		158,
		152,
		170,
		160,
		169,
		161,
		-1,
		158,
		148,
		170,
		149,
		160,
		152,
		-1,
		-1,
		152,
		153,
		159,
		145,
		151,
		147,
		-1,
		157,
		141,
		-1,
		-1,
		142,
		143,
		127,
		130,
		138,
		136,
		149,
		141,
		136,
		-1,
		-1,
		133,
		129,
		136,
		123,
		119,
		136,
		149,
		131,
		145,
		144,
		-1,
		137,
		155,
		162,
		130,
		128,
		112,
		110,
		128,
		130,
		136,
		136,
		-1,
		146,
		147,
		142,
		150,
		152,
		128,
		115,
		115,
		125,
		118,
		137,
		125,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		146,
		129,
		146,
		138,
		128,
		143,
		136,
		118,
		115,
		113,
		110,
		126,
		124,
		134,
		-1,
		-1,
		239,
		208,
		237,
		195,
		176,
		-1,
		142,
		122,
		128,
		132,
		126,
		119,
		133,
		129,
		-1,
		104,
		103,
		131,
		117,
		128,
		199,
		-1,
		-1,
		197,
		189,
		172,
		175,
		152,
		148,
		137,
		136,
		128,
		114,
		110,
		116,
		119,
		119,
		125,
		98,
		108,
		112,
		110,
		135,
		-1,
		-1,
		170,
		-1,
		-1,
		196,
		179,
		-1,
		162,
		169,
		158,
		164,
		150,
		171,
		147,
		138,
		130,
		124,
		112,
		114,
		111,
		124,
		112,
		95,
		120,
		124,
		105,
		126,
		121,
		-1,
		169,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		155,
		158,
		164,
		188,
		187,
		-1,
		159,
		147,
		148,
		133,
		130,
		117,
		105,
		118,
		103,
		110,
		109,
		99,
		97,
		127,
		102,
		124,
		121,
		140,
		145,
		139,
		148,
		-1,
		204,
		200,
		196,
		203,
		152,
		-1,
		-1,
		192,
		-1,
		195,
		196,
		171,
		144,
		147,
		134,
		125,
		112,
		101,
		112,
		101,
		98,
		106,
		91,
		106,
		97,
		96,
		114,
		124,
		132,
		136,
		142,
		-1,
		254,
		-1,
		196,
		180,
		182,
		154,
		175,
		-1,
		212,
		196,
		188,
		173,
		173,
		-1,
		143,
		140,
		130,
		108,
		93,
		110,
		102,
		100,
		104,
		86,
		100,
		91,
		109,
		116,
		114,
		118,
		138,
		150,
		214,
		204,
		-1,
		186,
		191,
		150,
		158,
		177,
		215,
		179,
		-1,
		174,
		-1,
		145,
		158,
		-1,
		114,
		110,
		92,
		93,
		88,
		103,
		97,
		82,
		79,
		97,
		100,
		107,
		111,
		127,
		-1,
		-1,
		199,
		203,
		192,
		143,
		162,
		186,
		223,
		172,
		161,
		160,
		-1,
		151,
		128,
		125,
		113,
		100,
		85,
		86,
		94,
		107,
		86,
		81,
		78,
		98,
		124,
		102,
		114,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		169,
		140,
		164,
		206,
		190,
		183,
		171,
		136,
		136,
		130,
		-1,
		124,
		103,
		94,
		83,
		81,
		94,
		91,
		96,
		76,
		74,
		93,
		105,
		96,
		113,
		-1,
		-1,
		-1,
		199,
		188,
		189,
		135,
		158,
		195,
		169,
		155,
		160,
		135,
		128,
		122,
		137,
		120,
		101,
		90,
		82,
		71,
		87,
		95,
		90,
		72,
		81,
		87,
		111,
		101,
		107,
		-1,
		-1,
		206,
		196,
		180,
		182,
		179,
		149,
		156,
		188,
		160,
		173,
		-1,
		127,
		-1,
		116,
		111,
		95,
		90,
		87,
		84,
		78,
		87,
		89,
		79,
		74,
		81,
		116,
		116,
		91,
		111,
		114,
		-1,
		-1,
		-1,
		199,
		194,
		169,
		146,
		130,
		166,
		-1,
		143,
		144,
		-1,
		121,
		115,
		112,
		97,
		93,
		88,
		92,
		85,
		92,
		85,
		83,
		84,
		66,
		98,
		-1,
		99,
		93,
		101,
		91,
		79,
		-1,
		-1,
		-1,
		192,
		171,
		164,
		184,
		125,
		177,
		-1,
		-1,
		128,
		121,
		-1,
		108,
		90,
		97,
		95,
		89,
		93,
		90,
		79,
		92,
		85,
		71,
		73,
		86,
		90,
		94,
		81,
		77,
		74,
		88,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		145,
		-1,
		137,
		129,
		119,
		113,
		107,
		103,
		101,
		117,
		101,
		104,
		102,
		93,
		101,
		74,
		67,
		74,
		63,
		81,
		89,
		81,
		75,
		74,
		84,
		-1,
		212,
		198,
		169,
		-1,
		-1,
		158,
		-1,
		122,
		136,
		152,
		-1,
		145,
		124,
		139,
		117,
		113,
		109,
		124,
		125,
		103,
		102,
		100,
		91,
		79,
		68,
		71,
		63,
		85,
		85,
		69,
		70,
		74,
		-1,
		218,
		205,
		163,
		159,
		148,
		168,
		119,
		107,
		139,
		-1,
		-1,
		181,
		-1,
		115,
		132,
		123,
		121,
		114,
		105,
		111,
		111,
		88,
		83,
		73,
		62,
		62,
		57,
		79,
		65,
		63,
		72,
		88,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		134,
		121,
		115,
		-1,
		156,
		-1,
		159,
		149,
		133,
		118,
		151,
		-1,
		116,
		106,
		111,
		-1,
		108,
		-1,
		81,
		78,
		69,
		54,
		51,
		62,
		60,
		71,
		67,
		-1,
		168,
		153,
		146,
		136,
		150,
		121,
		-1,
		176,
		-1,
		-1,
		146,
		140,
		140,
		124,
		127,
		132,
		112,
		104,
		111,
		103,
		95,
		89,
		67,
		60,
		57,
		50,
		63,
		73,
		78,
		65,
		-1,
		-1,
		-1,
		173,
		159,
		163,
		123,
		142,
		-1,
		-1,
		208,
		163,
		149,
		-1,
		133,
		132,
		120,
		110,
		100,
		105,
		106,
		86,
		79,
		65,
		67,
		61,
		52,
		51,
		67,
		59,
		81,
		-1,
		-1,
		156,
		161,
		149,
		135,
		154,
		-1,
		-1,
		-1,
		155,
		171,
		160,
		134,
		121,
		-1,
		-1,
		104,
		97,
		91,
		82,
		69,
		81,
		76,
		60,
		45,
		60,
		64,
		72,
		63,
		-1,
		159,
		146,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		-1,
		-1,
		172,
		117,
		106,
		101,
		105,
		103,
		-1,
		77,
		88,
		73,
		85,
		92,
		62,
		47,
		41,
		47,
		59,
		68,
		-1,
		-1,
		171,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		129,
		123,
		94,
		87,
		91,
		-1,
		79,
		81,
		75,
		90,
		65,
		62,
		53,
		44,
		40,
		44,
		48,
		57,
		63,
		194,
		-1,
		157,
		-1,
		-1,
		-1,
		147,
		162,
		133,
		110,
		83,
		78,
		71,
		65,
		70,
		81,
		73,
		84,
		51,
		47,
		37,
		36,
		40,
		57,
		51,
		-1,
		-1,
		155,
		151,
		173,
		155,
		159,
		160,
		-1,
		-1,
		87,
		78,
		69,
		61,
		74,
		77,
		57,
		54,
		48,
		41,
		35,
		45,
		50,
		45,
		-1,
		-1,
		-1,
		167,
		-1,
		169,
		-1,
		-1,
		157,
		158,
		105,
		87,
		83,
		81,
		70,
		64,
		52,
		57,
		58,
		49,
		42,
		31,
		25,
		48,
		37,
		65,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		146,
		138,
		133,
		139,
		141,
		132,
		120,
		117,
		-1,
		87,
		93,
		58,
		65,
		48,
		55,
		53,
		45,
		25,
		22,
		38,
		37,
		32,
		57,
		48,
		52,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		139,
		135,
		125,
		115,
		118,
		-1,
		-1,
		112,
		109,
		89,
		58,
		56,
		49,
		44,
		54,
		34,
		21,
		15,
		10,
		25,
		30,
		35,
		36,
		43,
		58,
		-1,
		186,
		223,
		216,
		184,
		192,
		223,
		-1,
		129,
		121,
		132,
		107,
		109,
		-1,
		-1,
		85,
		76,
		77,
		65,
		62,
		64,
		59,
		50,
		30,
		36,
		14,
		17,
		24,
		29,
		33,
		34,
		41,
		52,
		56,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		126,
		-1,
		-1,
		138,
		110,
		94,
		84,
		81,
		124,
		79,
		74,
		58,
		56,
		47,
		38,
		38,
		22,
		0,
		3,
		21,
		26,
		18,
		44,
		46,
		52,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		154,
		-1,
		121,
		-1,
		104,
		108,
		87,
		90,
		72,
		59,
		46,
		38,
		40,
		22,
		8,
		4,
		8,
		17,
		28,
		40,
		50,
		52,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		138,
		177,
		171,
		-1,
		155,
		-1,
		-1,
		-1,
		118,
		100,
		92,
		92,
		71,
		71,
		38,
		34,
		20,
		13,
		20,
		22,
		17,
		21,
		34,
		45,
		60,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		153,
		144,
		171,
		178,
		167,
		162,
		149,
		-1,
		-1,
		136,
		110,
		-1,
		-1,
		78,
		59,
		42,
		31,
		27,
		30,
		40,
		31,
		24,
		22,
		16,
		48,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		151,
		172,
		162,
		166,
		182,
		207,
		-1,
		138,
		-1,
		-1,
		116,
		-1,
		-1,
		101,
		64,
		53,
		44,
		42,
		35,
		44,
		51,
		30,
		31,
		21,
		31,
		44,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		138,
		136,
		142,
		149,
		166,
		196,
		-1,
		-1,
		154,
		134,
		-1,
		-1,
		99,
		97,
		86,
		-1,
		76,
		49,
		46,
		62,
		50,
		39,
		33,
		27,
		34,
		33,
		41,
		49,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		140,
		-1,
		-1,
		94,
		87,
		75,
		63,
		53,
		60,
		55,
		51,
		37,
		30,
		25,
		36,
		28,
		32,
		49,
		-1,
		209,
		-1,
		161,
		137,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		128,
		112,
		93,
		-1,
		63,
		76,
		87,
		55,
		55,
		49,
		31,
		42,
		31,
		34,
		48,
		43,
		-1,
		-1,
		149,
		152,
		-1,
		-1,
		151,
		153,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		100,
		96,
		-1,
		-1,
		64,
		69,
		58,
		61,
		56,
		35,
		41,
		44,
		33,
		37,
		49,
		-1,
		-1,
		156,
		157,
		158,
		-1,
		136,
		-1,
		154,
		-1,
		121,
		127,
		115,
		-1,
		-1,
		-1,
		102,
		65,
		86,
		76,
		64,
		62,
		53,
		39,
		46,
		44,
		40,
		51,
		-1,
		-1,
		-1,
		154,
		128,
		161,
		152,
		135,
		115,
		107,
		126,
		-1,
		96,
		-1,
		69,
		66,
		90,
		72,
		75,
		69,
		42,
		57,
		47,
		38,
		47,
		160,
		-1,
		130,
		163,
		127,
		121,
		97,
		101,
		117,
		-1,
		93,
		75,
		-1,
		103,
		93,
		91,
		76,
		57,
		44,
		51,
		51,
		44,
		-1,
		-1,
		-1,
		132,
		131,
		123,
		117,
		117,
		102,
		93,
		-1,
		105,
		87,
		66,
		83,
		83,
		74,
		82,
		81,
		77,
		64,
		64,
		56,
		-1,
		233,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		126,
		121,
		94,
		82,
		88,
		84,
		70,
		76,
		78,
		86,
		84,
		81,
		83,
		74,
		80,
		57,
		92,
		-1,
		228,
		-1,
		162,
		-1,
		-1,
		144,
		124,
		116,
		105,
		94,
		92,
		83,
		74,
		96,
		112,
		81,
		69,
		64,
		65,
		-1,
		217,
		216,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		140,
		101,
		-1,
		103,
		83,
		-1,
		80,
		69,
		-1,
		-1,
		204,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		135,
		119,
		-1,
		94,
		94,
		-1,
		-1,
		-1,
		189,
		188,
		-1,
		157,
		160,
		-1,
		150,
		141,
		149,
		96,
		100,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		172,
		170,
		165,
		162,
		148,
		132,
		110,
		99,
		120,
		-1,
		-1,
		-1,
		170,
		162,
		155,
		-1,
		-1,
		157,
		140,
		121,
		119,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		147,
		-1,
		-1,
		153,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		181,
		-1,
		-1,
		-1,
		143,
		139,
		140,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		227,
		191,
		-1,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		133,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		168,
		-1,
		168,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		173,
		181,
		-1,
		153,
		155,
		-1,
		203,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		158,
		165,
		187,
		190,
		226,
		-1,
		177
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		207,
		211,
		177,
		171,
		210,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		200,
		199,
		167,
		165,
		174,
		179,
		186,
		-1,
		185,
		-1,
		221,
		200,
		211,
		216,
		160,
		157,
		177,
		196,
		178,
		170,
		236,
		190,
		161,
		155,
		173,
		163,
		172,
		164,
		-1,
		161,
		151,
		173,
		152,
		163,
		155,
		-1,
		-1,
		155,
		156,
		162,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		145,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		140,
		158,
		165,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		139,
		-1,
		149,
		150,
		145,
		153,
		155,
		131,
		118,
		118,
		128,
		121,
		140,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		132,
		149,
		141,
		131,
		146,
		139,
		121,
		118,
		116,
		113,
		129,
		127,
		137,
		-1,
		-1,
		242,
		211,
		240,
		198,
		179,
		-1,
		145,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		107,
		106,
		134,
		120,
		131,
		202,
		-1,
		-1,
		200,
		192,
		175,
		178,
		155,
		151,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		101,
		111,
		115,
		113,
		138,
		-1,
		-1,
		173,
		-1,
		-1,
		199,
		182,
		-1,
		165,
		172,
		161,
		167,
		153,
		174,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		98,
		123,
		127,
		108,
		129,
		124,
		-1,
		172,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		158,
		161,
		167,
		191,
		190,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		102,
		100,
		130,
		105,
		127,
		124,
		143,
		148,
		142,
		151,
		-1,
		207,
		203,
		199,
		206,
		155,
		-1,
		-1,
		195,
		-1,
		198,
		199,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		94,
		109,
		100,
		99,
		117,
		127,
		135,
		139,
		145,
		-1,
		257,
		-1,
		199,
		183,
		185,
		157,
		178,
		-1,
		215,
		199,
		191,
		176,
		176,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		105,
		103,
		107,
		89,
		103,
		94,
		112,
		119,
		117,
		121,
		141,
		153,
		217,
		207,
		-1,
		189,
		194,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		100,
		85,
		82,
		100,
		103,
		110,
		114,
		130,
		-1,
		-1,
		202,
		206,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		110,
		89,
		84,
		81,
		101,
		127,
		105,
		117,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		94,
		99,
		79,
		77,
		96,
		108,
		99,
		116,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		140,
		123,
		104,
		93,
		85,
		74,
		90,
		98,
		93,
		75,
		84,
		90,
		114,
		104,
		110,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		87,
		81,
		90,
		92,
		82,
		77,
		84,
		119,
		119,
		94,
		114,
		117,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		91,
		95,
		88,
		95,
		88,
		86,
		87,
		69,
		101,
		-1,
		102,
		96,
		104,
		94,
		82,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		100,
		98,
		92,
		96,
		93,
		82,
		95,
		88,
		74,
		76,
		89,
		93,
		97,
		84,
		80,
		77,
		91,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		120,
		104,
		107,
		105,
		96,
		104,
		77,
		70,
		77,
		66,
		84,
		92,
		84,
		78,
		77,
		87,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		112,
		127,
		128,
		106,
		105,
		103,
		94,
		82,
		71,
		74,
		66,
		88,
		88,
		72,
		73,
		77,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		126,
		124,
		117,
		108,
		114,
		114,
		91,
		86,
		76,
		65,
		65,
		60,
		82,
		68,
		66,
		75,
		91,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		119,
		109,
		114,
		-1,
		111,
		-1,
		84,
		81,
		72,
		57,
		54,
		65,
		63,
		74,
		70,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		135,
		115,
		107,
		114,
		106,
		98,
		92,
		70,
		63,
		60,
		53,
		66,
		76,
		81,
		68,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		136,
		135,
		123,
		113,
		103,
		108,
		109,
		89,
		82,
		68,
		70,
		64,
		55,
		54,
		70,
		62,
		84,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		174,
		163,
		137,
		124,
		-1,
		-1,
		107,
		100,
		94,
		85,
		72,
		84,
		79,
		63,
		48,
		63,
		67,
		75,
		66,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		175,
		120,
		109,
		104,
		108,
		106,
		-1,
		80,
		91,
		76,
		88,
		95,
		65,
		50,
		44,
		50,
		62,
		71,
		-1,
		-1,
		174,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		97,
		90,
		94,
		-1,
		82,
		84,
		78,
		93,
		68,
		65,
		56,
		47,
		43,
		47,
		51,
		61,
		67,
		197,
		-1,
		160,
		-1,
		-1,
		-1,
		150,
		165,
		136,
		113,
		86,
		81,
		74,
		68,
		73,
		84,
		76,
		87,
		54,
		50,
		40,
		39,
		43,
		60,
		55,
		-1,
		-1,
		158,
		154,
		176,
		158,
		162,
		163,
		-1,
		-1,
		90,
		81,
		72,
		64,
		77,
		80,
		60,
		57,
		51,
		44,
		38,
		48,
		54,
		49,
		-1,
		-1,
		-1,
		170,
		-1,
		172,
		-1,
		-1,
		160,
		161,
		108,
		90,
		86,
		84,
		73,
		67,
		55,
		60,
		61,
		52,
		46,
		34,
		29,
		52,
		41,
		63,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		149,
		141,
		136,
		142,
		144,
		135,
		123,
		120,
		-1,
		90,
		96,
		61,
		68,
		51,
		58,
		56,
		48,
		28,
		26,
		42,
		41,
		36,
		55,
		46,
		50,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		142,
		138,
		128,
		118,
		121,
		-1,
		-1,
		115,
		112,
		92,
		61,
		59,
		52,
		47,
		57,
		37,
		24,
		19,
		14,
		29,
		34,
		39,
		34,
		41,
		56,
		-1,
		189,
		226,
		219,
		187,
		195,
		226,
		-1,
		132,
		124,
		135,
		110,
		112,
		-1,
		-1,
		88,
		79,
		80,
		68,
		65,
		67,
		62,
		53,
		33,
		39,
		17,
		21,
		28,
		27,
		31,
		32,
		39,
		50,
		54,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		129,
		-1,
		-1,
		141,
		113,
		97,
		87,
		84,
		127,
		82,
		77,
		61,
		59,
		50,
		41,
		41,
		25,
		4,
		0,
		19,
		24,
		16,
		42,
		44,
		50,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		157,
		-1,
		124,
		-1,
		107,
		111,
		90,
		93,
		75,
		62,
		50,
		41,
		44,
		25,
		12,
		8,
		6,
		15,
		26,
		38,
		48,
		50,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		141,
		180,
		174,
		-1,
		158,
		-1,
		-1,
		-1,
		121,
		103,
		95,
		95,
		74,
		74,
		42,
		38,
		24,
		17,
		24,
		23,
		15,
		19,
		32,
		43,
		58,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		156,
		147,
		174,
		181,
		170,
		165,
		152,
		-1,
		-1,
		140,
		113,
		-1,
		-1,
		81,
		63,
		46,
		35,
		31,
		34,
		44,
		32,
		22,
		20,
		14,
		46,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		175,
		165,
		169,
		185,
		210,
		-1,
		141,
		-1,
		-1,
		120,
		-1,
		-1,
		105,
		68,
		57,
		48,
		46,
		39,
		48,
		55,
		28,
		29,
		19,
		29,
		42,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		141,
		139,
		145,
		152,
		169,
		199,
		-1,
		-1,
		157,
		137,
		-1,
		-1,
		103,
		101,
		90,
		-1,
		80,
		53,
		50,
		66,
		48,
		37,
		31,
		25,
		32,
		31,
		39,
		47,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		143,
		-1,
		-1,
		98,
		91,
		79,
		67,
		57,
		64,
		53,
		49,
		35,
		28,
		23,
		34,
		26,
		30,
		47,
		-1,
		212,
		-1,
		164,
		140,
		154,
		169,
		177,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		132,
		116,
		97,
		-1,
		67,
		80,
		85,
		53,
		53,
		47,
		29,
		40,
		29,
		32,
		46,
		41,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		154,
		156,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		104,
		100,
		-1,
		-1,
		68,
		67,
		56,
		59,
		54,
		33,
		39,
		42,
		31,
		35,
		47,
		-1,
		-1,
		159,
		160,
		161,
		-1,
		139,
		-1,
		157,
		-1,
		124,
		130,
		118,
		-1,
		-1,
		-1,
		106,
		69,
		90,
		74,
		62,
		60,
		51,
		37,
		44,
		42,
		38,
		49,
		-1,
		-1,
		-1,
		157,
		131,
		164,
		155,
		138,
		118,
		110,
		129,
		-1,
		99,
		-1,
		73,
		70,
		88,
		70,
		73,
		67,
		40,
		55,
		45,
		36,
		45,
		163,
		-1,
		133,
		166,
		130,
		124,
		100,
		104,
		120,
		-1,
		96,
		78,
		-1,
		106,
		95,
		89,
		74,
		55,
		42,
		49,
		49,
		42,
		-1,
		-1,
		-1,
		135,
		134,
		126,
		120,
		120,
		105,
		96,
		-1,
		108,
		90,
		69,
		86,
		86,
		77,
		85,
		79,
		75,
		62,
		62,
		54,
		-1,
		236,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		129,
		124,
		97,
		85,
		91,
		87,
		73,
		79,
		81,
		89,
		87,
		84,
		81,
		72,
		78,
		55,
		90,
		-1,
		231,
		-1,
		165,
		-1,
		-1,
		147,
		127,
		119,
		108,
		97,
		95,
		86,
		77,
		99,
		115,
		79,
		67,
		62,
		63,
		-1,
		220,
		219,
		-1,
		166,
		158,
		144,
		-1,
		137,
		-1,
		143,
		104,
		-1,
		106,
		86,
		-1,
		78,
		67,
		-1,
		-1,
		207,
		182,
		-1,
		-1,
		-1,
		167,
		147,
		138,
		122,
		-1,
		97,
		97,
		-1,
		-1,
		-1,
		192,
		191,
		-1,
		160,
		163,
		-1,
		153,
		144,
		152,
		99,
		103,
		-1,
		-1,
		-1,
		201,
		182,
		176,
		175,
		173,
		168,
		165,
		151,
		135,
		113,
		102,
		123,
		-1,
		-1,
		-1,
		173,
		165,
		158,
		-1,
		-1,
		160,
		143,
		124,
		122,
		-1,
		-1,
		-1,
		195,
		176,
		-1,
		-1,
		150,
		-1,
		-1,
		156,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		184,
		-1,
		-1,
		-1,
		146,
		142,
		143,
		-1,
		-1,
		-1,
		-1,
		206,
		207,
		230,
		194,
		-1,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		209,
		207,
		-1,
		-1,
		-1,
		166,
		150,
		-1,
		136,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		171,
		-1,
		171,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		184,
		176,
		184,
		-1,
		156,
		158,
		-1,
		206,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		161,
		168,
		190,
		193,
		229,
		-1,
		180
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		147,
		165,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		156,
		157,
		152,
		160,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		114,
		113,
		141,
		127,
		138,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		117,
		96,
		91,
		88,
		108,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		101,
		106,
		86,
		84,
		103,
		115,
		106,
		123,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		97,
		105,
		100,
		82,
		91,
		97,
		121,
		111,
		117,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		88,
		97,
		99,
		89,
		84,
		91,
		126,
		126,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		102,
		95,
		93,
		94,
		76,
		108,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		100,
		89,
		102,
		95,
		81,
		83,
		96,
		100,
		104,
		91,
		87,
		84,
		98,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		112,
		103,
		111,
		84,
		77,
		84,
		73,
		91,
		99,
		91,
		85,
		84,
		94,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		112,
		110,
		101,
		89,
		78,
		81,
		73,
		95,
		95,
		79,
		80,
		84,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		115,
		121,
		121,
		98,
		93,
		83,
		72,
		72,
		67,
		89,
		75,
		73,
		82,
		94,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		126,
		116,
		121,
		-1,
		118,
		-1,
		91,
		88,
		79,
		64,
		61,
		72,
		70,
		81,
		77,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		142,
		122,
		114,
		121,
		113,
		105,
		99,
		77,
		70,
		67,
		60,
		73,
		83,
		88,
		75,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		142,
		130,
		120,
		110,
		115,
		116,
		96,
		89,
		75,
		77,
		71,
		62,
		61,
		77,
		69,
		91,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		170,
		144,
		131,
		-1,
		-1,
		114,
		107,
		101,
		92,
		79,
		91,
		86,
		70,
		55,
		70,
		74,
		82,
		73,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		113,
		-1,
		87,
		98,
		83,
		95,
		102,
		72,
		57,
		51,
		57,
		69,
		69,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		89,
		91,
		85,
		100,
		75,
		72,
		63,
		54,
		50,
		54,
		58,
		54,
		60,
		204,
		-1,
		167,
		-1,
		-1,
		-1,
		157,
		172,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		91,
		83,
		94,
		61,
		57,
		47,
		46,
		50,
		58,
		48,
		-1,
		-1,
		165,
		161,
		183,
		165,
		169,
		170,
		-1,
		-1,
		97,
		88,
		79,
		71,
		84,
		87,
		67,
		64,
		58,
		51,
		45,
		55,
		47,
		42,
		-1,
		-1,
		-1,
		177,
		-1,
		179,
		-1,
		-1,
		167,
		168,
		115,
		97,
		93,
		91,
		80,
		74,
		62,
		67,
		68,
		59,
		53,
		41,
		41,
		52,
		34,
		70,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		130,
		127,
		-1,
		97,
		103,
		68,
		75,
		58,
		65,
		63,
		55,
		35,
		38,
		45,
		34,
		29,
		62,
		53,
		57,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		122,
		119,
		99,
		68,
		66,
		59,
		54,
		64,
		44,
		31,
		31,
		26,
		22,
		27,
		32,
		38,
		48,
		63,
		-1,
		196,
		233,
		226,
		194,
		202,
		233,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		95,
		86,
		87,
		75,
		72,
		74,
		69,
		60,
		40,
		46,
		24,
		31,
		31,
		8,
		29,
		39,
		42,
		55,
		59,
		-1,
		189,
		209,
		188,
		191,
		215,
		229,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		91,
		134,
		89,
		84,
		68,
		66,
		57,
		48,
		48,
		32,
		20,
		17,
		0,
		31,
		23,
		49,
		51,
		53,
		-1,
		178,
		189,
		182,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		164,
		-1,
		131,
		-1,
		114,
		118,
		97,
		100,
		82,
		69,
		61,
		48,
		57,
		32,
		28,
		24,
		13,
		22,
		33,
		45,
		55,
		57,
		203,
		159,
		162,
		173,
		184,
		199,
		203,
		-1,
		148,
		187,
		181,
		-1,
		165,
		-1,
		-1,
		-1,
		128,
		110,
		102,
		102,
		81,
		81,
		55,
		51,
		37,
		33,
		40,
		30,
		22,
		26,
		39,
		50,
		65,
		199,
		190,
		203,
		148,
		148,
		169,
		178,
		199,
		163,
		154,
		181,
		188,
		177,
		172,
		159,
		-1,
		-1,
		151,
		120,
		-1,
		-1,
		88,
		76,
		59,
		48,
		44,
		47,
		55,
		39,
		29,
		27,
		21,
		53,
		-1,
		192,
		191,
		180,
		177,
		153,
		144,
		139,
		166,
		-1,
		-1,
		161,
		182,
		172,
		176,
		192,
		217,
		-1,
		148,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		81,
		70,
		61,
		59,
		52,
		59,
		70,
		35,
		36,
		26,
		36,
		49,
		176,
		173,
		161,
		159,
		182,
		147,
		135,
		-1,
		148,
		146,
		152,
		159,
		176,
		206,
		-1,
		-1,
		164,
		144,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		66,
		60,
		79,
		55,
		44,
		38,
		32,
		39,
		38,
		46,
		54,
		185,
		199,
		188,
		184,
		183,
		191,
		140,
		133,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		150,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		74,
		60,
		56,
		42,
		35,
		30,
		41,
		33,
		37,
		54,
		-1,
		219,
		-1,
		171,
		147,
		161,
		176,
		184,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		92,
		60,
		60,
		54,
		36,
		47,
		36,
		39,
		53,
		48,
		-1,
		-1,
		159,
		162,
		-1,
		-1,
		161,
		163,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		74,
		63,
		66,
		61,
		40,
		46,
		49,
		38,
		42,
		54,
		-1,
		-1,
		166,
		167,
		168,
		-1,
		146,
		-1,
		164,
		-1,
		131,
		137,
		125,
		-1,
		-1,
		-1,
		118,
		81,
		102,
		81,
		69,
		67,
		58,
		44,
		51,
		49,
		45,
		56,
		-1,
		-1,
		-1,
		164,
		138,
		171,
		162,
		145,
		125,
		117,
		136,
		-1,
		106,
		-1,
		81,
		82,
		95,
		77,
		80,
		74,
		47,
		62,
		52,
		43,
		52,
		170,
		-1,
		140,
		173,
		137,
		131,
		107,
		111,
		127,
		-1,
		103,
		85,
		-1,
		113,
		102,
		96,
		81,
		62,
		49,
		56,
		56,
		49,
		-1,
		-1,
		-1,
		142,
		141,
		133,
		127,
		127,
		112,
		103,
		-1,
		115,
		97,
		76,
		93,
		93,
		84,
		92,
		86,
		82,
		69,
		69,
		61,
		-1,
		243,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		136,
		131,
		104,
		92,
		98,
		94,
		80,
		86,
		88,
		96,
		94,
		91,
		88,
		79,
		85,
		62,
		97,
		-1,
		238,
		-1,
		172,
		-1,
		-1,
		154,
		134,
		126,
		115,
		104,
		102,
		93,
		84,
		106,
		122,
		86,
		74,
		69,
		70,
		-1,
		227,
		226,
		-1,
		173,
		165,
		151,
		-1,
		144,
		-1,
		150,
		111,
		-1,
		113,
		93,
		-1,
		85,
		74,
		-1,
		-1,
		214,
		189,
		-1,
		-1,
		-1,
		174,
		154,
		145,
		129,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		199,
		198,
		-1,
		167,
		170,
		-1,
		160,
		151,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		208,
		189,
		183,
		182,
		180,
		175,
		172,
		158,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		180,
		172,
		165,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		202,
		183,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		191,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		213,
		214,
		237,
		201,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		216,
		214,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		199,
		188,
		199,
		207,
		180,
		187,
		-1,
		206,
		210,
		176,
		170,
		209,
		178,
		184,
		195,
		-1,
		-1,
		-1,
		199,
		198,
		166,
		164,
		173,
		178,
		185,
		-1,
		184,
		-1,
		220,
		199,
		210,
		215,
		159,
		156,
		176,
		195,
		177,
		169,
		235,
		189,
		160,
		154,
		172,
		162,
		171,
		163,
		-1,
		160,
		150,
		172,
		151,
		162,
		154,
		-1,
		-1,
		154,
		155,
		161,
		147,
		153,
		149,
		-1,
		159,
		143,
		-1,
		-1,
		144,
		145,
		129,
		132,
		140,
		138,
		151,
		143,
		138,
		-1,
		-1,
		135,
		131,
		138,
		125,
		121,
		138,
		151,
		133,
		147,
		146,
		-1,
		139,
		157,
		164,
		132,
		130,
		114,
		112,
		130,
		132,
		138,
		138,
		-1,
		148,
		149,
		144,
		152,
		154,
		130,
		117,
		117,
		127,
		120,
		139,
		127,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		131,
		148,
		140,
		130,
		145,
		138,
		120,
		117,
		115,
		112,
		128,
		126,
		136,
		-1,
		-1,
		241,
		210,
		239,
		197,
		178,
		-1,
		144,
		124,
		130,
		134,
		128,
		121,
		135,
		131,
		-1,
		106,
		105,
		133,
		119,
		130,
		201,
		-1,
		-1,
		199,
		191,
		174,
		177,
		154,
		150,
		139,
		138,
		130,
		116,
		112,
		118,
		121,
		121,
		127,
		100,
		110,
		114,
		112,
		137,
		-1,
		-1,
		172,
		-1,
		-1,
		198,
		181,
		-1,
		164,
		171,
		160,
		166,
		152,
		173,
		149,
		140,
		132,
		126,
		114,
		116,
		113,
		126,
		114,
		97,
		122,
		126,
		107,
		128,
		123,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		157,
		160,
		166,
		190,
		189,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		120,
		105,
		112,
		111,
		101,
		99,
		129,
		104,
		126,
		123,
		142,
		147,
		141,
		150,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		194,
		-1,
		197,
		198,
		173,
		146,
		149,
		136,
		127,
		114,
		103,
		114,
		103,
		100,
		108,
		93,
		108,
		99,
		98,
		116,
		126,
		134,
		138,
		144,
		-1,
		256,
		-1,
		198,
		182,
		184,
		156,
		177,
		-1,
		214,
		198,
		190,
		175,
		175,
		-1,
		145,
		142,
		132,
		110,
		95,
		112,
		104,
		102,
		106,
		88,
		102,
		93,
		111,
		118,
		116,
		120,
		140,
		152,
		216,
		206,
		-1,
		188,
		193,
		152,
		160,
		179,
		217,
		181,
		-1,
		176,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		95,
		90,
		105,
		99,
		84,
		81,
		99,
		102,
		109,
		113,
		129,
		-1,
		-1,
		201,
		205,
		194,
		145,
		164,
		188,
		225,
		174,
		163,
		162,
		-1,
		153,
		130,
		127,
		115,
		102,
		87,
		88,
		96,
		109,
		88,
		83,
		80,
		100,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		171,
		142,
		166,
		208,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		126,
		105,
		96,
		85,
		83,
		96,
		93,
		98,
		78,
		76,
		95,
		107,
		98,
		115,
		-1,
		-1,
		-1,
		201,
		190,
		191,
		137,
		160,
		197,
		171,
		157,
		162,
		137,
		130,
		124,
		139,
		122,
		103,
		92,
		84,
		73,
		89,
		97,
		92,
		74,
		83,
		89,
		113,
		103,
		109,
		-1,
		-1,
		208,
		198,
		182,
		184,
		181,
		151,
		158,
		190,
		162,
		175,
		-1,
		129,
		-1,
		118,
		113,
		97,
		92,
		89,
		86,
		80,
		89,
		91,
		81,
		76,
		83,
		118,
		118,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		201,
		196,
		171,
		148,
		132,
		168,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		99,
		95,
		90,
		94,
		87,
		94,
		87,
		85,
		86,
		68,
		100,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		127,
		179,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		99,
		97,
		91,
		95,
		92,
		81,
		94,
		87,
		73,
		75,
		88,
		92,
		96,
		83,
		79,
		76,
		90,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		147,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		119,
		103,
		106,
		104,
		95,
		103,
		76,
		69,
		76,
		65,
		83,
		91,
		83,
		77,
		76,
		86,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		111,
		126,
		127,
		105,
		104,
		102,
		93,
		81,
		70,
		73,
		65,
		87,
		87,
		71,
		72,
		76,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		125,
		123,
		116,
		107,
		113,
		113,
		90,
		85,
		75,
		64,
		64,
		59,
		81,
		67,
		65,
		74,
		85,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		118,
		108,
		113,
		-1,
		110,
		-1,
		83,
		80,
		71,
		56,
		53,
		64,
		62,
		73,
		69,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		134,
		114,
		106,
		113,
		105,
		97,
		91,
		69,
		62,
		59,
		52,
		65,
		75,
		80,
		67,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		134,
		122,
		112,
		102,
		107,
		108,
		88,
		81,
		67,
		69,
		63,
		54,
		53,
		69,
		61,
		83,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		162,
		136,
		123,
		-1,
		-1,
		106,
		99,
		93,
		84,
		71,
		83,
		78,
		62,
		47,
		62,
		66,
		74,
		65,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		90,
		75,
		87,
		94,
		64,
		49,
		43,
		49,
		61,
		70,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		83,
		77,
		92,
		67,
		64,
		55,
		46,
		42,
		46,
		50,
		57,
		63,
		196,
		-1,
		159,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		72,
		83,
		75,
		86,
		53,
		49,
		39,
		38,
		42,
		59,
		53,
		-1,
		-1,
		157,
		153,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		63,
		76,
		79,
		59,
		56,
		50,
		43,
		37,
		47,
		52,
		47,
		-1,
		-1,
		-1,
		169,
		-1,
		171,
		-1,
		-1,
		159,
		160,
		107,
		89,
		85,
		83,
		72,
		66,
		54,
		59,
		60,
		51,
		45,
		33,
		33,
		56,
		39,
		51,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		148,
		140,
		135,
		141,
		143,
		134,
		122,
		119,
		-1,
		89,
		95,
		60,
		67,
		50,
		57,
		55,
		47,
		27,
		30,
		46,
		42,
		30,
		43,
		34,
		38,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		141,
		137,
		127,
		117,
		120,
		-1,
		-1,
		114,
		111,
		91,
		60,
		58,
		51,
		46,
		56,
		36,
		23,
		23,
		18,
		33,
		32,
		27,
		22,
		29,
		44,
		-1,
		188,
		225,
		218,
		186,
		194,
		225,
		-1,
		131,
		123,
		134,
		109,
		111,
		-1,
		-1,
		87,
		78,
		79,
		67,
		64,
		66,
		61,
		52,
		32,
		38,
		16,
		23,
		34,
		26,
		14,
		23,
		27,
		38,
		42,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		128,
		-1,
		-1,
		140,
		112,
		96,
		86,
		83,
		126,
		81,
		76,
		60,
		58,
		49,
		40,
		40,
		24,
		12,
		9,
		18,
		0,
		4,
		33,
		32,
		38,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		156,
		-1,
		123,
		-1,
		106,
		110,
		89,
		92,
		74,
		61,
		53,
		40,
		49,
		24,
		20,
		16,
		5,
		14,
		14,
		27,
		40,
		38,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		140,
		179,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		120,
		102,
		94,
		94,
		73,
		73,
		47,
		43,
		29,
		25,
		32,
		22,
		14,
		18,
		31,
		32,
		46,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		155,
		146,
		173,
		180,
		169,
		164,
		151,
		-1,
		-1,
		143,
		112,
		-1,
		-1,
		80,
		68,
		51,
		40,
		36,
		39,
		47,
		31,
		21,
		19,
		13,
		37,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		174,
		164,
		168,
		184,
		209,
		-1,
		140,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		73,
		62,
		53,
		51,
		44,
		51,
		62,
		27,
		28,
		18,
		28,
		41,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		58,
		52,
		71,
		47,
		36,
		30,
		24,
		31,
		30,
		38,
		46,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		66,
		52,
		48,
		34,
		27,
		22,
		33,
		25,
		29,
		46,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		84,
		52,
		52,
		46,
		28,
		39,
		28,
		31,
		45,
		40,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		66,
		55,
		58,
		53,
		32,
		38,
		41,
		30,
		34,
		46,
		-1,
		-1,
		158,
		159,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		110,
		73,
		94,
		73,
		61,
		59,
		50,
		36,
		43,
		41,
		37,
		48,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		73,
		74,
		87,
		69,
		72,
		66,
		39,
		54,
		44,
		35,
		44,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		77,
		-1,
		105,
		94,
		88,
		73,
		54,
		41,
		48,
		48,
		41,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		84,
		78,
		74,
		61,
		61,
		53,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		86,
		83,
		80,
		71,
		77,
		54,
		89,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		78,
		66,
		61,
		62,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		77,
		66,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		205,
		194,
		205,
		213,
		186,
		193,
		-1,
		212,
		216,
		182,
		176,
		215,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		205,
		204,
		172,
		170,
		179,
		184,
		191,
		-1,
		190,
		-1,
		226,
		205,
		216,
		221,
		165,
		162,
		182,
		201,
		183,
		175,
		241,
		195,
		166,
		160,
		178,
		168,
		177,
		169,
		-1,
		166,
		156,
		178,
		157,
		168,
		160,
		-1,
		-1,
		160,
		161,
		167,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		150,
		151,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		141,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		145,
		163,
		170,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		144,
		-1,
		154,
		155,
		150,
		158,
		160,
		136,
		123,
		123,
		133,
		126,
		145,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		137,
		154,
		146,
		136,
		151,
		144,
		126,
		123,
		121,
		118,
		134,
		132,
		142,
		-1,
		-1,
		247,
		216,
		245,
		203,
		184,
		-1,
		150,
		130,
		136,
		140,
		134,
		127,
		141,
		137,
		-1,
		112,
		111,
		139,
		125,
		136,
		207,
		-1,
		-1,
		205,
		197,
		180,
		183,
		160,
		156,
		145,
		144,
		136,
		122,
		118,
		124,
		127,
		127,
		133,
		106,
		116,
		120,
		118,
		143,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		166,
		172,
		158,
		179,
		155,
		146,
		138,
		132,
		120,
		122,
		119,
		132,
		120,
		103,
		128,
		132,
		113,
		134,
		129,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		195,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		107,
		105,
		135,
		110,
		132,
		129,
		148,
		153,
		147,
		156,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		203,
		204,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		99,
		114,
		105,
		104,
		122,
		132,
		140,
		144,
		150,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		204,
		196,
		181,
		181,
		-1,
		151,
		148,
		138,
		116,
		101,
		118,
		110,
		108,
		112,
		94,
		108,
		99,
		117,
		124,
		122,
		126,
		146,
		158,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		105,
		90,
		87,
		105,
		108,
		115,
		119,
		135,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		136,
		133,
		121,
		108,
		93,
		94,
		102,
		115,
		94,
		89,
		86,
		106,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		89,
		102,
		99,
		104,
		84,
		82,
		101,
		113,
		104,
		121,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		145,
		128,
		109,
		98,
		90,
		79,
		95,
		103,
		98,
		80,
		89,
		95,
		119,
		109,
		115,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		92,
		86,
		95,
		97,
		87,
		82,
		89,
		124,
		124,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		96,
		100,
		93,
		100,
		93,
		91,
		92,
		74,
		106,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		103,
		97,
		101,
		98,
		87,
		100,
		93,
		79,
		81,
		94,
		98,
		102,
		89,
		85,
		82,
		96,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		112,
		110,
		101,
		109,
		82,
		75,
		82,
		71,
		89,
		97,
		89,
		83,
		82,
		92,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		110,
		108,
		99,
		87,
		76,
		79,
		71,
		93,
		93,
		77,
		78,
		82,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		119,
		96,
		91,
		81,
		70,
		70,
		65,
		87,
		73,
		71,
		80,
		81,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		124,
		114,
		119,
		-1,
		116,
		-1,
		89,
		86,
		77,
		62,
		59,
		70,
		68,
		79,
		75,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		140,
		120,
		112,
		119,
		111,
		103,
		97,
		75,
		68,
		65,
		58,
		71,
		81,
		86,
		73,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		140,
		128,
		118,
		108,
		113,
		114,
		94,
		87,
		73,
		75,
		69,
		60,
		59,
		75,
		67,
		89,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		168,
		142,
		129,
		-1,
		-1,
		112,
		105,
		99,
		90,
		77,
		89,
		84,
		68,
		53,
		68,
		72,
		80,
		71,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		96,
		81,
		93,
		100,
		70,
		55,
		49,
		55,
		67,
		68,
		-1,
		-1,
		179,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		89,
		83,
		98,
		73,
		70,
		61,
		52,
		48,
		52,
		56,
		53,
		59,
		202,
		-1,
		165,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		78,
		89,
		81,
		92,
		59,
		55,
		45,
		44,
		48,
		57,
		51,
		-1,
		-1,
		163,
		159,
		181,
		163,
		167,
		168,
		-1,
		-1,
		95,
		86,
		77,
		69,
		82,
		85,
		65,
		62,
		56,
		49,
		43,
		53,
		50,
		45,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		165,
		166,
		113,
		95,
		91,
		89,
		78,
		72,
		60,
		65,
		66,
		57,
		51,
		39,
		39,
		62,
		37,
		47,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		128,
		125,
		-1,
		95,
		101,
		66,
		73,
		56,
		63,
		61,
		53,
		33,
		36,
		52,
		40,
		28,
		39,
		30,
		34,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		120,
		117,
		97,
		66,
		64,
		57,
		52,
		62,
		42,
		29,
		29,
		24,
		37,
		30,
		25,
		18,
		25,
		40,
		-1,
		194,
		231,
		224,
		192,
		200,
		231,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		93,
		84,
		85,
		73,
		70,
		72,
		67,
		58,
		38,
		44,
		22,
		29,
		40,
		32,
		15,
		19,
		23,
		34,
		38,
		-1,
		187,
		207,
		186,
		189,
		213,
		227,
		-1,
		134,
		-1,
		-1,
		146,
		118,
		102,
		92,
		89,
		132,
		87,
		82,
		66,
		64,
		55,
		46,
		46,
		30,
		18,
		15,
		24,
		10,
		0,
		29,
		28,
		34,
		-1,
		176,
		187,
		180,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		162,
		-1,
		129,
		-1,
		112,
		116,
		95,
		98,
		80,
		67,
		59,
		46,
		55,
		30,
		26,
		22,
		11,
		20,
		10,
		23,
		36,
		34,
		201,
		157,
		160,
		171,
		182,
		197,
		201,
		-1,
		146,
		185,
		179,
		-1,
		163,
		-1,
		-1,
		-1,
		126,
		108,
		100,
		100,
		79,
		79,
		53,
		49,
		35,
		31,
		38,
		28,
		20,
		24,
		33,
		28,
		42,
		197,
		188,
		201,
		146,
		146,
		167,
		176,
		197,
		161,
		152,
		179,
		186,
		175,
		170,
		157,
		-1,
		-1,
		149,
		118,
		-1,
		-1,
		86,
		74,
		57,
		46,
		42,
		45,
		53,
		37,
		27,
		25,
		19,
		33,
		-1,
		190,
		189,
		178,
		175,
		151,
		142,
		137,
		164,
		-1,
		-1,
		159,
		180,
		170,
		174,
		190,
		215,
		-1,
		146,
		-1,
		-1,
		130,
		-1,
		-1,
		115,
		79,
		68,
		59,
		57,
		50,
		57,
		68,
		33,
		34,
		24,
		34,
		47,
		174,
		171,
		159,
		157,
		180,
		145,
		133,
		-1,
		146,
		144,
		150,
		157,
		174,
		204,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		113,
		111,
		100,
		-1,
		90,
		64,
		58,
		77,
		53,
		42,
		36,
		30,
		37,
		36,
		44,
		52,
		183,
		197,
		186,
		182,
		181,
		189,
		138,
		131,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		108,
		101,
		89,
		77,
		67,
		72,
		58,
		54,
		40,
		33,
		28,
		39,
		31,
		35,
		52,
		-1,
		217,
		-1,
		169,
		145,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		142,
		126,
		107,
		-1,
		77,
		90,
		90,
		58,
		58,
		52,
		34,
		45,
		34,
		37,
		51,
		46,
		-1,
		-1,
		157,
		160,
		-1,
		-1,
		159,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		114,
		110,
		-1,
		-1,
		78,
		72,
		61,
		64,
		59,
		38,
		44,
		47,
		36,
		40,
		52,
		-1,
		-1,
		164,
		165,
		166,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		116,
		79,
		100,
		79,
		67,
		65,
		56,
		42,
		49,
		47,
		43,
		54,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		80,
		93,
		75,
		78,
		72,
		45,
		60,
		50,
		41,
		50,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		111,
		100,
		94,
		79,
		60,
		47,
		54,
		54,
		47,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		91,
		82,
		90,
		84,
		80,
		67,
		67,
		59,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		94,
		92,
		89,
		86,
		77,
		83,
		60,
		95,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		120,
		84,
		72,
		67,
		68,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		83,
		72,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		143,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		134,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		122,
		128,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		102,
		98,
		95,
		98,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		101,
		93,
		94,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		96,
		89,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		87,
		79,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		88,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		102,
		86,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		93,
		85,
		90,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		88,
		80,
		72,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		73,
		83,
		66,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		70,
		70,
		51,
		57,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		66,
		55,
		55,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		54,
		49,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		90,
		80,
		72,
		61,
		55,
		65,
		41,
		45,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		84,
		76,
		55,
		52,
		58,
		44,
		32,
		37,
		28,
		36,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		45,
		49,
		35,
		34,
		29,
		22,
		27,
		42,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		80,
		64,
		70,
		48,
		47,
		64,
		49,
		42,
		21,
		14,
		27,
		31,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		72,
		56,
		44,
		41,
		50,
		37,
		27,
		0,
		24,
		25,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		102,
		89,
		81,
		72,
		81,
		56,
		52,
		48,
		37,
		46,
		37,
		21,
		7,
		28,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		122,
		101,
		101,
		75,
		75,
		61,
		57,
		64,
		54,
		46,
		50,
		29,
		17,
		36,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		208,
		197,
		192,
		179,
		-1,
		-1,
		171,
		140,
		-1,
		-1,
		108,
		96,
		79,
		72,
		68,
		71,
		79,
		63,
		53,
		47,
		45,
		22,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		212,
		237,
		-1,
		168,
		-1,
		-1,
		153,
		-1,
		-1,
		138,
		101,
		90,
		81,
		83,
		76,
		83,
		94,
		59,
		57,
		50,
		46,
		36,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		136,
		134,
		123,
		-1,
		113,
		86,
		84,
		103,
		79,
		68,
		62,
		56,
		63,
		59,
		59,
		41,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		131,
		124,
		112,
		100,
		90,
		98,
		84,
		80,
		66,
		59,
		54,
		65,
		57,
		61,
		47,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		116,
		84,
		84,
		78,
		60,
		71,
		60,
		63,
		55,
		53,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		101,
		98,
		87,
		90,
		85,
		64,
		70,
		73,
		62,
		56,
		55,
		-1,
		-1,
		186,
		187,
		188,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		139,
		102,
		123,
		105,
		93,
		91,
		82,
		68,
		75,
		73,
		69,
		65,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		103,
		119,
		101,
		104,
		98,
		71,
		86,
		76,
		67,
		71,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		133,
		123,
		120,
		105,
		86,
		73,
		80,
		75,
		68,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		113,
		104,
		112,
		110,
		106,
		93,
		93,
		84,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		116,
		114,
		111,
		109,
		100,
		106,
		83,
		116,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		107,
		95,
		90,
		91,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		106,
		95,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		166,
		184,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		175,
		176,
		171,
		179,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		158,
		175,
		167,
		157,
		172,
		165,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		268,
		237,
		266,
		224,
		205,
		-1,
		171,
		151,
		157,
		161,
		155,
		148,
		162,
		158,
		-1,
		133,
		132,
		160,
		146,
		157,
		228,
		-1,
		-1,
		226,
		218,
		201,
		204,
		181,
		177,
		166,
		165,
		157,
		143,
		139,
		145,
		148,
		148,
		154,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		199,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		187,
		193,
		179,
		200,
		176,
		167,
		159,
		153,
		141,
		143,
		140,
		153,
		141,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		216,
		-1,
		188,
		176,
		177,
		162,
		159,
		146,
		134,
		147,
		132,
		139,
		138,
		128,
		126,
		156,
		131,
		153,
		150,
		169,
		174,
		168,
		177,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		224,
		225,
		200,
		173,
		176,
		163,
		154,
		141,
		130,
		141,
		130,
		127,
		135,
		120,
		135,
		126,
		125,
		143,
		153,
		161,
		165,
		171,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		225,
		217,
		202,
		202,
		-1,
		172,
		169,
		159,
		137,
		122,
		139,
		131,
		129,
		133,
		115,
		129,
		120,
		138,
		145,
		143,
		147,
		167,
		179,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		244,
		208,
		-1,
		203,
		-1,
		174,
		187,
		-1,
		143,
		139,
		121,
		122,
		117,
		132,
		126,
		111,
		108,
		126,
		129,
		136,
		140,
		156,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		201,
		190,
		189,
		-1,
		180,
		157,
		154,
		142,
		129,
		114,
		115,
		123,
		136,
		115,
		110,
		107,
		127,
		153,
		131,
		142,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		153,
		132,
		123,
		112,
		110,
		123,
		120,
		125,
		105,
		103,
		122,
		134,
		125,
		133,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		164,
		187,
		224,
		198,
		184,
		189,
		164,
		157,
		151,
		166,
		149,
		130,
		119,
		111,
		100,
		116,
		124,
		119,
		101,
		110,
		116,
		140,
		121,
		127,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		178,
		185,
		217,
		189,
		202,
		-1,
		156,
		-1,
		145,
		140,
		124,
		119,
		116,
		113,
		107,
		116,
		118,
		108,
		103,
		110,
		145,
		145,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		228,
		223,
		198,
		175,
		159,
		195,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		126,
		122,
		117,
		121,
		114,
		121,
		114,
		112,
		113,
		95,
		127,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		221,
		200,
		193,
		213,
		154,
		206,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		126,
		124,
		118,
		122,
		119,
		108,
		121,
		114,
		100,
		102,
		115,
		119,
		123,
		101,
		97,
		94,
		97,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		174,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		146,
		130,
		133,
		131,
		122,
		130,
		103,
		96,
		103,
		92,
		110,
		118,
		110,
		100,
		92,
		93,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		187,
		-1,
		151,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		138,
		153,
		154,
		132,
		131,
		129,
		120,
		108,
		97,
		100,
		92,
		114,
		114,
		98,
		95,
		88,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		148,
		136,
		168,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		152,
		150,
		143,
		134,
		140,
		140,
		117,
		112,
		102,
		91,
		91,
		86,
		108,
		94,
		92,
		86,
		78,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		145,
		135,
		140,
		-1,
		137,
		-1,
		110,
		107,
		98,
		83,
		80,
		91,
		89,
		100,
		87,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		205,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		161,
		141,
		133,
		140,
		132,
		124,
		118,
		96,
		89,
		86,
		79,
		92,
		102,
		101,
		85,
		-1,
		-1,
		-1,
		202,
		188,
		192,
		152,
		171,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		162,
		161,
		149,
		139,
		129,
		134,
		135,
		115,
		108,
		94,
		96,
		90,
		81,
		80,
		92,
		84,
		89,
		-1,
		-1,
		185,
		190,
		178,
		164,
		183,
		-1,
		-1,
		-1,
		184,
		200,
		189,
		163,
		150,
		-1,
		-1,
		133,
		126,
		120,
		111,
		98,
		110,
		105,
		89,
		74,
		89,
		87,
		79,
		71,
		-1,
		188,
		175,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		-1,
		-1,
		201,
		146,
		135,
		130,
		134,
		132,
		-1,
		106,
		117,
		102,
		114,
		121,
		91,
		76,
		70,
		72,
		82,
		65,
		-1,
		-1,
		200,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		158,
		152,
		123,
		116,
		120,
		-1,
		108,
		110,
		104,
		119,
		94,
		91,
		82,
		73,
		69,
		69,
		69,
		50,
		56,
		223,
		-1,
		186,
		-1,
		-1,
		-1,
		176,
		191,
		162,
		139,
		112,
		107,
		100,
		94,
		99,
		110,
		102,
		113,
		80,
		76,
		66,
		65,
		65,
		54,
		54,
		-1,
		-1,
		184,
		180,
		202,
		184,
		188,
		189,
		-1,
		-1,
		116,
		107,
		98,
		90,
		103,
		106,
		86,
		83,
		77,
		70,
		64,
		74,
		53,
		48,
		-1,
		-1,
		-1,
		196,
		-1,
		198,
		-1,
		-1,
		186,
		187,
		134,
		116,
		112,
		110,
		99,
		93,
		81,
		86,
		89,
		79,
		71,
		60,
		54,
		64,
		40,
		44,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		175,
		167,
		162,
		168,
		170,
		161,
		149,
		146,
		-1,
		116,
		122,
		87,
		94,
		77,
		84,
		83,
		75,
		54,
		51,
		57,
		43,
		31,
		36,
		27,
		32,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		141,
		138,
		118,
		87,
		85,
		78,
		73,
		83,
		63,
		50,
		44,
		48,
		34,
		33,
		28,
		21,
		23,
		38,
		-1,
		215,
		252,
		245,
		213,
		221,
		252,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		114,
		105,
		106,
		94,
		91,
		93,
		88,
		79,
		64,
		70,
		48,
		46,
		63,
		48,
		41,
		24,
		13,
		23,
		27,
		-1,
		208,
		228,
		207,
		210,
		234,
		248,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		110,
		153,
		108,
		103,
		87,
		85,
		76,
		67,
		72,
		56,
		44,
		41,
		50,
		36,
		26,
		23,
		0,
		10,
		-1,
		197,
		208,
		201,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		133,
		137,
		116,
		119,
		101,
		88,
		80,
		72,
		81,
		56,
		52,
		48,
		37,
		46,
		36,
		44,
		30,
		25,
		222,
		178,
		181,
		192,
		203,
		218,
		222,
		-1,
		167,
		206,
		200,
		-1,
		184,
		-1,
		-1,
		-1,
		147,
		129,
		121,
		121,
		100,
		100,
		74,
		75,
		61,
		57,
		64,
		54,
		46,
		50,
		52,
		40,
		33,
		218,
		209,
		222,
		167,
		167,
		188,
		197,
		218,
		182,
		173,
		200,
		207,
		196,
		191,
		178,
		-1,
		-1,
		170,
		139,
		-1,
		-1,
		107,
		95,
		78,
		72,
		68,
		71,
		79,
		63,
		53,
		51,
		45,
		45,
		-1,
		211,
		210,
		199,
		196,
		172,
		163,
		158,
		185,
		-1,
		-1,
		180,
		201,
		191,
		195,
		211,
		236,
		-1,
		167,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		100,
		89,
		80,
		83,
		76,
		83,
		94,
		59,
		60,
		50,
		60,
		59,
		195,
		192,
		180,
		178,
		201,
		166,
		154,
		-1,
		167,
		165,
		171,
		178,
		195,
		225,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		85,
		84,
		103,
		79,
		68,
		62,
		56,
		63,
		62,
		69,
		61,
		204,
		218,
		207,
		203,
		202,
		210,
		159,
		152,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		98,
		84,
		80,
		66,
		59,
		54,
		65,
		57,
		61,
		55,
		-1,
		238,
		-1,
		190,
		166,
		180,
		195,
		203,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		116,
		84,
		84,
		78,
		60,
		71,
		60,
		61,
		48,
		51,
		-1,
		-1,
		178,
		181,
		-1,
		-1,
		180,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		98,
		87,
		90,
		85,
		64,
		70,
		73,
		62,
		54,
		48,
		-1,
		-1,
		185,
		186,
		187,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		138,
		101,
		122,
		105,
		93,
		91,
		82,
		68,
		75,
		73,
		68,
		58,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		102,
		119,
		101,
		104,
		98,
		71,
		86,
		70,
		66,
		64,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		132,
		122,
		120,
		105,
		86,
		73,
		80,
		68,
		61,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		107,
		110,
		106,
		93,
		93,
		77,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		109,
		106,
		102,
		93,
		99,
		76,
		109,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		100,
		88,
		83,
		84,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		99,
		88,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		143,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		134,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		122,
		128,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		102,
		98,
		95,
		98,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		101,
		93,
		94,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		96,
		89,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		87,
		79,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		88,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		102,
		86,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		93,
		85,
		90,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		88,
		80,
		72,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		73,
		83,
		66,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		70,
		70,
		51,
		57,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		66,
		55,
		55,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		54,
		49,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		90,
		80,
		72,
		61,
		55,
		65,
		41,
		45,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		84,
		76,
		55,
		52,
		58,
		44,
		32,
		37,
		28,
		36,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		45,
		49,
		35,
		34,
		29,
		22,
		27,
		42,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		80,
		65,
		71,
		49,
		47,
		64,
		49,
		42,
		25,
		14,
		27,
		31,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		73,
		57,
		45,
		42,
		51,
		37,
		27,
		24,
		12,
		0,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		102,
		89,
		81,
		73,
		82,
		57,
		53,
		49,
		38,
		47,
		37,
		45,
		31,
		32,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		122,
		101,
		101,
		75,
		76,
		62,
		58,
		65,
		55,
		47,
		51,
		53,
		41,
		36,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		208,
		197,
		192,
		179,
		-1,
		-1,
		171,
		140,
		-1,
		-1,
		108,
		96,
		79,
		73,
		69,
		72,
		80,
		64,
		54,
		52,
		46,
		46,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		212,
		237,
		-1,
		168,
		-1,
		-1,
		153,
		-1,
		-1,
		138,
		101,
		90,
		81,
		84,
		77,
		84,
		95,
		60,
		61,
		51,
		61,
		60,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		136,
		134,
		123,
		-1,
		113,
		86,
		85,
		104,
		80,
		69,
		63,
		57,
		64,
		63,
		64,
		56,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		131,
		124,
		112,
		100,
		90,
		99,
		85,
		81,
		67,
		60,
		55,
		66,
		58,
		62,
		50,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		117,
		85,
		85,
		79,
		61,
		72,
		61,
		56,
		43,
		46,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		101,
		99,
		88,
		91,
		86,
		65,
		71,
		74,
		63,
		49,
		43,
		-1,
		-1,
		186,
		187,
		188,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		139,
		102,
		123,
		106,
		94,
		92,
		83,
		69,
		76,
		70,
		63,
		53,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		103,
		120,
		102,
		105,
		99,
		72,
		87,
		65,
		61,
		59,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		131,
		118,
		121,
		106,
		87,
		74,
		78,
		63,
		56,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		111,
		102,
		102,
		111,
		107,
		94,
		93,
		72,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		114,
		104,
		101,
		97,
		88,
		94,
		71,
		104,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		142,
		95,
		83,
		78,
		79,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		94,
		83,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		277,
		266,
		277,
		285,
		258,
		265,
		-1,
		286,
		288,
		254,
		248,
		287,
		258,
		264,
		275,
		-1,
		-1,
		-1,
		277,
		276,
		246,
		244,
		253,
		258,
		265,
		-1,
		288,
		-1,
		298,
		277,
		288,
		293,
		239,
		236,
		256,
		275,
		281,
		273,
		313,
		269,
		240,
		234,
		252,
		257,
		275,
		267,
		-1,
		240,
		230,
		252,
		256,
		268,
		251,
		-1,
		-1,
		234,
		235,
		241,
		253,
		258,
		263,
		-1,
		285,
		269,
		-1,
		-1,
		224,
		237,
		233,
		236,
		244,
		260,
		277,
		269,
		264,
		-1,
		-1,
		225,
		229,
		242,
		243,
		241,
		264,
		277,
		259,
		273,
		272,
		-1,
		213,
		231,
		240,
		249,
		255,
		240,
		238,
		256,
		258,
		264,
		264,
		-1,
		205,
		207,
		236,
		242,
		254,
		256,
		243,
		243,
		253,
		246,
		265,
		253,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		202,
		210,
		236,
		235,
		231,
		249,
		257,
		246,
		243,
		241,
		238,
		254,
		252,
		262,
		-1,
		-1,
		258,
		227,
		262,
		219,
		204,
		-1,
		198,
		217,
		223,
		227,
		232,
		240,
		254,
		250,
		-1,
		232,
		231,
		259,
		245,
		256,
		218,
		-1,
		-1,
		216,
		208,
		193,
		196,
		193,
		193,
		223,
		222,
		227,
		229,
		231,
		237,
		240,
		240,
		246,
		226,
		236,
		240,
		238,
		263,
		-1,
		-1,
		298,
		-1,
		-1,
		215,
		198,
		-1,
		181,
		188,
		188,
		205,
		195,
		216,
		231,
		235,
		243,
		245,
		233,
		235,
		232,
		245,
		233,
		223,
		248,
		252,
		233,
		254,
		249,
		-1,
		297,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		174,
		177,
		183,
		207,
		217,
		-1,
		238,
		236,
		260,
		254,
		251,
		238,
		226,
		239,
		224,
		231,
		230,
		227,
		225,
		255,
		230,
		252,
		249,
		268,
		273,
		267,
		276,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		211,
		-1,
		225,
		238,
		245,
		240,
		243,
		255,
		246,
		233,
		222,
		233,
		222,
		219,
		227,
		219,
		234,
		225,
		224,
		242,
		252,
		260,
		264,
		270,
		-1,
		273,
		-1,
		215,
		199,
		201,
		173,
		194,
		-1,
		231,
		226,
		246,
		247,
		238,
		-1,
		241,
		244,
		251,
		229,
		214,
		231,
		223,
		221,
		226,
		214,
		228,
		219,
		237,
		244,
		242,
		246,
		266,
		278,
		233,
		223,
		-1,
		205,
		210,
		169,
		177,
		196,
		269,
		244,
		-1,
		239,
		-1,
		231,
		256,
		-1,
		235,
		231,
		213,
		214,
		209,
		224,
		225,
		210,
		207,
		225,
		228,
		235,
		239,
		255,
		-1,
		-1,
		218,
		222,
		211,
		162,
		181,
		205,
		242,
		237,
		226,
		225,
		-1,
		216,
		246,
		243,
		229,
		216,
		206,
		207,
		215,
		228,
		207,
		209,
		206,
		226,
		252,
		230,
		241,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		188,
		159,
		183,
		225,
		255,
		248,
		236,
		201,
		201,
		195,
		-1,
		236,
		219,
		215,
		204,
		202,
		215,
		210,
		224,
		204,
		202,
		221,
		233,
		224,
		232,
		-1,
		-1,
		-1,
		218,
		207,
		208,
		157,
		180,
		214,
		234,
		220,
		225,
		200,
		193,
		187,
		239,
		236,
		203,
		211,
		203,
		192,
		206,
		214,
		218,
		200,
		209,
		215,
		239,
		220,
		226,
		-1,
		-1,
		225,
		215,
		199,
		201,
		198,
		171,
		178,
		210,
		225,
		222,
		-1,
		192,
		-1,
		181,
		189,
		188,
		194,
		206,
		192,
		197,
		208,
		217,
		207,
		202,
		209,
		244,
		244,
		210,
		230,
		233,
		-1,
		-1,
		-1,
		218,
		216,
		191,
		168,
		152,
		188,
		-1,
		192,
		193,
		-1,
		186,
		180,
		186,
		185,
		192,
		189,
		189,
		203,
		211,
		205,
		211,
		212,
		194,
		218,
		-1,
		218,
		212,
		220,
		210,
		198,
		-1,
		-1,
		-1,
		214,
		193,
		186,
		206,
		147,
		199,
		-1,
		-1,
		177,
		170,
		-1,
		173,
		173,
		180,
		189,
		194,
		199,
		207,
		199,
		212,
		205,
		199,
		193,
		206,
		210,
		211,
		200,
		196,
		193,
		207,
		-1,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		167,
		-1,
		180,
		172,
		168,
		162,
		168,
		186,
		184,
		204,
		196,
		210,
		210,
		213,
		208,
		194,
		187,
		198,
		183,
		201,
		207,
		198,
		193,
		192,
		203,
		-1,
		234,
		220,
		191,
		-1,
		-1,
		180,
		-1,
		144,
		158,
		174,
		-1,
		202,
		181,
		204,
		182,
		196,
		192,
		230,
		231,
		201,
		206,
		208,
		196,
		199,
		188,
		191,
		183,
		205,
		202,
		186,
		188,
		197,
		-1,
		240,
		227,
		185,
		181,
		170,
		190,
		141,
		150,
		161,
		-1,
		-1,
		246,
		-1,
		180,
		197,
		206,
		204,
		220,
		195,
		202,
		220,
		193,
		188,
		193,
		182,
		182,
		177,
		196,
		182,
		180,
		195,
		211,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		156,
		143,
		137,
		-1,
		178,
		-1,
		224,
		214,
		198,
		183,
		216,
		-1,
		194,
		190,
		197,
		-1,
		213,
		-1,
		185,
		188,
		179,
		174,
		171,
		182,
		180,
		189,
		190,
		-1,
		190,
		175,
		168,
		158,
		172,
		143,
		-1,
		186,
		-1,
		-1,
		211,
		205,
		205,
		189,
		192,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		170,
		170,
		173,
		167,
		180,
		190,
		196,
		188,
		-1,
		-1,
		-1,
		195,
		147,
		155,
		131,
		152,
		-1,
		-1,
		273,
		228,
		214,
		-1,
		198,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		168,
		177,
		176,
		169,
		168,
		189,
		182,
		204,
		-1,
		-1,
		144,
		157,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		220,
		236,
		228,
		199,
		199,
		-1,
		-1,
		182,
		175,
		169,
		172,
		160,
		180,
		187,
		175,
		162,
		177,
		187,
		195,
		194,
		-1,
		147,
		134,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		243,
		188,
		177,
		172,
		176,
		181,
		-1,
		155,
		166,
		159,
		178,
		185,
		177,
		162,
		156,
		167,
		182,
		199,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		200,
		194,
		165,
		158,
		162,
		-1,
		157,
		159,
		156,
		168,
		173,
		177,
		168,
		150,
		164,
		167,
		180,
		194,
		198,
		204,
		-1,
		172,
		-1,
		-1,
		-1,
		211,
		212,
		198,
		175,
		154,
		147,
		144,
		143,
		148,
		159,
		168,
		179,
		144,
		148,
		163,
		168,
		172,
		189,
		193,
		-1,
		-1,
		170,
		166,
		201,
		213,
		185,
		225,
		-1,
		-1,
		143,
		136,
		146,
		139,
		152,
		155,
		140,
		142,
		160,
		173,
		167,
		177,
		192,
		187,
		-1,
		-1,
		-1,
		168,
		-1,
		184,
		-1,
		-1,
		175,
		216,
		163,
		145,
		141,
		127,
		134,
		128,
		130,
		135,
		154,
		149,
		158,
		163,
		167,
		190,
		179,
		218,
		-1,
		-1,
		99,
		-1,
		-1,
		-1,
		134,
		153,
		148,
		154,
		159,
		150,
		178,
		175,
		-1,
		124,
		157,
		125,
		139,
		135,
		142,
		147,
		153,
		157,
		164,
		180,
		179,
		174,
		210,
		201,
		207,
		-1,
		-1,
		92,
		81,
		70,
		76,
		-1,
		127,
		150,
		140,
		130,
		136,
		-1,
		-1,
		142,
		139,
		137,
		117,
		123,
		128,
		131,
		169,
		145,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		47,
		82,
		75,
		44,
		52,
		83,
		-1,
		117,
		109,
		137,
		122,
		130,
		-1,
		-1,
		115,
		106,
		111,
		120,
		121,
		152,
		151,
		164,
		167,
		172,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		40,
		58,
		38,
		41,
		65,
		79,
		-1,
		108,
		-1,
		-1,
		153,
		140,
		124,
		114,
		111,
		158,
		134,
		129,
		135,
		137,
		161,
		152,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		0,
		38,
		32,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		169,
		-1,
		151,
		-1,
		134,
		138,
		142,
		145,
		160,
		147,
		154,
		171,
		177,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		98,
		53,
		20,
		23,
		57,
		72,
		76,
		-1,
		92,
		128,
		138,
		-1,
		178,
		-1,
		-1,
		-1,
		148,
		155,
		147,
		163,
		159,
		159,
		155,
		159,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		94,
		92,
		97,
		42,
		25,
		42,
		51,
		72,
		88,
		85,
		122,
		127,
		142,
		147,
		171,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		166,
		176,
		159,
		161,
		165,
		179,
		191,
		199,
		189,
		187,
		181,
		213,
		-1,
		94,
		93,
		82,
		79,
		55,
		46,
		33,
		43,
		-1,
		-1,
		86,
		113,
		97,
		101,
		117,
		142,
		-1,
		178,
		-1,
		-1,
		192,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		173,
		184,
		206,
		195,
		196,
		186,
		196,
		209,
		78,
		75,
		63,
		61,
		84,
		41,
		37,
		-1,
		68,
		71,
		77,
		84,
		101,
		131,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		211,
		214,
		203,
		-1,
		193,
		166,
		171,
		196,
		203,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		87,
		101,
		90,
		86,
		85,
		93,
		42,
		58,
		65,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		217,
		204,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		188,
		188,
		191,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		121,
		-1,
		73,
		65,
		80,
		95,
		103,
		-1,
		-1,
		-1,
		234,
		220,
		213,
		201,
		199,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		78,
		81,
		-1,
		-1,
		103,
		122,
		-1,
		225,
		214,
		199,
		191,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		85,
		86,
		91,
		-1,
		112,
		-1,
		227,
		-1,
		194,
		201,
		189,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		218,
		216,
		207,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		142,
		119,
		234,
		225,
		208,
		188,
		180,
		200,
		-1,
		207,
		-1,
		182,
		183,
		210,
		212,
		229,
		223,
		207,
		222,
		212,
		203,
		212,
		148,
		-1,
		123,
		182,
		165,
		194,
		160,
		172,
		228,
		-1,
		204,
		186,
		-1,
		214,
		204,
		246,
		227,
		220,
		207,
		214,
		216,
		209,
		-1,
		-1,
		-1,
		138,
		137,
		136,
		147,
		155,
		153,
		171,
		-1,
		216,
		198,
		177,
		194,
		194,
		185,
		193,
		236,
		232,
		225,
		227,
		217,
		-1,
		193,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		164,
		186,
		181,
		173,
		185,
		194,
		181,
		187,
		189,
		197,
		195,
		192,
		204,
		200,
		220,
		216,
		248,
		-1,
		200,
		-1,
		168,
		-1,
		-1,
		182,
		168,
		180,
		191,
		181,
		181,
		186,
		184,
		206,
		223,
		207,
		205,
		210,
		215,
		-1,
		210,
		211,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		227,
		188,
		-1,
		213,
		193,
		-1,
		216,
		212,
		-1,
		-1,
		222,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		222,
		206,
		-1,
		204,
		204,
		-1,
		-1,
		-1,
		236,
		226,
		-1,
		195,
		198,
		-1,
		189,
		195,
		224,
		206,
		210,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		210,
		215,
		203,
		220,
		206,
		208,
		220,
		209,
		230,
		-1,
		-1,
		-1,
		223,
		215,
		215,
		-1,
		-1,
		233,
		216,
		216,
		229,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		224,
		-1,
		-1,
		229,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		234,
		-1,
		-1,
		-1,
		225,
		232,
		240,
		-1,
		-1,
		-1,
		-1,
		253,
		254,
		280,
		255,
		-1,
		-1,
		-1,
		239,
		239,
		-1,
		-1,
		251,
		252,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		243,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		272,
		-1,
		278,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		291,
		-1,
		263,
		265,
		-1,
		313,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		268,
		275,
		297,
		300,
		330,
		-1,
		287
	],
	[
		-1,
		263,
		252,
		263,
		271,
		244,
		251,
		-1,
		272,
		274,
		240,
		234,
		273,
		244,
		250,
		261,
		-1,
		-1,
		-1,
		263,
		262,
		232,
		230,
		239,
		244,
		251,
		-1,
		274,
		-1,
		284,
		263,
		274,
		279,
		225,
		222,
		242,
		261,
		267,
		259,
		299,
		255,
		226,
		220,
		238,
		243,
		261,
		253,
		-1,
		226,
		216,
		238,
		242,
		254,
		237,
		-1,
		-1,
		220,
		221,
		227,
		239,
		244,
		249,
		-1,
		275,
		259,
		-1,
		-1,
		210,
		223,
		219,
		222,
		230,
		246,
		267,
		259,
		254,
		-1,
		-1,
		211,
		215,
		228,
		229,
		227,
		254,
		267,
		249,
		263,
		262,
		-1,
		199,
		217,
		226,
		235,
		241,
		230,
		228,
		246,
		248,
		254,
		257,
		-1,
		191,
		193,
		222,
		228,
		240,
		246,
		233,
		233,
		243,
		236,
		255,
		246,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		188,
		196,
		222,
		221,
		217,
		235,
		243,
		236,
		233,
		231,
		228,
		244,
		245,
		255,
		-1,
		-1,
		244,
		213,
		248,
		205,
		190,
		-1,
		184,
		203,
		209,
		213,
		218,
		226,
		240,
		236,
		-1,
		222,
		221,
		252,
		238,
		249,
		204,
		-1,
		-1,
		202,
		194,
		179,
		182,
		179,
		179,
		209,
		208,
		213,
		215,
		217,
		223,
		226,
		226,
		232,
		216,
		226,
		230,
		241,
		256,
		-1,
		-1,
		311,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		174,
		191,
		181,
		202,
		217,
		221,
		229,
		231,
		219,
		221,
		218,
		231,
		219,
		213,
		238,
		242,
		236,
		257,
		252,
		-1,
		310,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		203,
		-1,
		224,
		222,
		246,
		240,
		237,
		224,
		212,
		225,
		210,
		217,
		216,
		220,
		222,
		255,
		233,
		255,
		252,
		281,
		286,
		280,
		289,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		211,
		224,
		231,
		226,
		229,
		241,
		232,
		219,
		208,
		219,
		208,
		205,
		213,
		222,
		233,
		228,
		227,
		245,
		260,
		273,
		277,
		283,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		212,
		232,
		233,
		224,
		-1,
		227,
		230,
		237,
		215,
		200,
		217,
		209,
		207,
		212,
		217,
		231,
		222,
		240,
		247,
		255,
		259,
		279,
		291,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		255,
		230,
		-1,
		225,
		-1,
		217,
		242,
		-1,
		221,
		217,
		199,
		200,
		195,
		210,
		216,
		213,
		210,
		228,
		231,
		248,
		252,
		268,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		223,
		212,
		211,
		-1,
		202,
		232,
		229,
		215,
		202,
		192,
		193,
		201,
		214,
		193,
		212,
		215,
		237,
		265,
		243,
		254,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		241,
		234,
		222,
		187,
		187,
		181,
		-1,
		222,
		205,
		201,
		190,
		188,
		201,
		196,
		212,
		216,
		215,
		234,
		246,
		237,
		245,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		143,
		166,
		200,
		220,
		206,
		211,
		186,
		179,
		173,
		225,
		222,
		189,
		197,
		189,
		178,
		192,
		200,
		204,
		213,
		222,
		228,
		252,
		233,
		239,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		157,
		164,
		196,
		211,
		208,
		-1,
		178,
		-1,
		167,
		175,
		174,
		180,
		192,
		178,
		183,
		194,
		206,
		219,
		215,
		222,
		257,
		257,
		223,
		243,
		246,
		-1,
		-1,
		-1,
		204,
		202,
		177,
		154,
		138,
		174,
		-1,
		178,
		179,
		-1,
		172,
		166,
		172,
		171,
		178,
		175,
		175,
		189,
		197,
		193,
		209,
		215,
		207,
		231,
		-1,
		231,
		225,
		233,
		223,
		211,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		163,
		156,
		-1,
		159,
		159,
		166,
		175,
		180,
		185,
		193,
		188,
		201,
		206,
		212,
		206,
		219,
		223,
		224,
		213,
		209,
		206,
		220,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		166,
		158,
		154,
		148,
		154,
		172,
		170,
		190,
		182,
		196,
		196,
		202,
		210,
		195,
		198,
		211,
		196,
		214,
		220,
		211,
		206,
		205,
		216,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		188,
		167,
		190,
		168,
		182,
		178,
		216,
		217,
		195,
		200,
		208,
		209,
		212,
		201,
		204,
		196,
		218,
		215,
		199,
		201,
		210,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		136,
		147,
		-1,
		-1,
		232,
		-1,
		166,
		183,
		192,
		190,
		206,
		197,
		203,
		219,
		206,
		201,
		206,
		195,
		195,
		190,
		209,
		195,
		193,
		208,
		224,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		210,
		200,
		184,
		169,
		202,
		-1,
		207,
		198,
		203,
		-1,
		226,
		-1,
		198,
		201,
		192,
		187,
		184,
		195,
		193,
		202,
		203,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		172,
		-1,
		-1,
		197,
		191,
		191,
		175,
		178,
		223,
		203,
		195,
		203,
		209,
		196,
		195,
		183,
		183,
		186,
		180,
		193,
		203,
		209,
		201,
		-1,
		-1,
		-1,
		181,
		133,
		141,
		117,
		138,
		-1,
		-1,
		259,
		214,
		200,
		-1,
		184,
		223,
		211,
		201,
		191,
		196,
		197,
		187,
		185,
		181,
		190,
		189,
		182,
		181,
		202,
		195,
		217,
		-1,
		-1,
		130,
		143,
		145,
		131,
		150,
		-1,
		-1,
		-1,
		206,
		222,
		214,
		185,
		212,
		-1,
		-1,
		195,
		188,
		182,
		185,
		173,
		193,
		200,
		188,
		175,
		190,
		200,
		208,
		207,
		-1,
		133,
		120,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		-1,
		-1,
		239,
		201,
		190,
		185,
		189,
		194,
		-1,
		168,
		179,
		172,
		191,
		198,
		190,
		175,
		169,
		180,
		195,
		212,
		-1,
		-1,
		167,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		196,
		207,
		178,
		171,
		175,
		-1,
		170,
		172,
		169,
		181,
		186,
		190,
		181,
		163,
		177,
		180,
		193,
		207,
		211,
		190,
		-1,
		173,
		-1,
		-1,
		-1,
		214,
		225,
		211,
		188,
		167,
		160,
		157,
		156,
		161,
		172,
		181,
		192,
		157,
		161,
		176,
		181,
		185,
		202,
		206,
		-1,
		-1,
		173,
		179,
		214,
		222,
		198,
		238,
		-1,
		-1,
		156,
		149,
		159,
		152,
		165,
		168,
		153,
		155,
		173,
		186,
		180,
		190,
		205,
		200,
		-1,
		-1,
		-1,
		181,
		-1,
		197,
		-1,
		-1,
		188,
		229,
		176,
		158,
		154,
		140,
		147,
		141,
		143,
		148,
		167,
		162,
		171,
		176,
		180,
		203,
		192,
		231,
		-1,
		-1,
		105,
		-1,
		-1,
		-1,
		147,
		166,
		161,
		167,
		172,
		163,
		191,
		188,
		-1,
		137,
		170,
		138,
		152,
		148,
		155,
		160,
		166,
		170,
		177,
		193,
		192,
		187,
		223,
		214,
		220,
		-1,
		-1,
		98,
		87,
		76,
		82,
		-1,
		140,
		163,
		153,
		143,
		149,
		-1,
		-1,
		155,
		152,
		150,
		130,
		136,
		141,
		144,
		182,
		158,
		166,
		170,
		174,
		180,
		185,
		190,
		196,
		211,
		226,
		-1,
		33,
		44,
		37,
		50,
		58,
		89,
		-1,
		130,
		122,
		150,
		135,
		143,
		-1,
		-1,
		128,
		119,
		124,
		133,
		134,
		165,
		164,
		177,
		180,
		185,
		173,
		172,
		190,
		194,
		203,
		210,
		200,
		213,
		217,
		-1,
		26,
		20,
		44,
		47,
		71,
		85,
		-1,
		121,
		-1,
		-1,
		166,
		153,
		137,
		127,
		124,
		171,
		147,
		142,
		148,
		150,
		174,
		165,
		190,
		181,
		181,
		184,
		199,
		204,
		196,
		210,
		210,
		211,
		-1,
		36,
		0,
		38,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		182,
		-1,
		164,
		-1,
		147,
		151,
		155,
		158,
		173,
		160,
		167,
		184,
		190,
		179,
		189,
		185,
		186,
		195,
		206,
		218,
		217,
		218,
		111,
		66,
		33,
		29,
		70,
		85,
		89,
		-1,
		105,
		141,
		151,
		-1,
		191,
		-1,
		-1,
		-1,
		161,
		168,
		160,
		176,
		172,
		172,
		168,
		172,
		184,
		191,
		201,
		203,
		195,
		199,
		212,
		223,
		226,
		107,
		105,
		110,
		55,
		38,
		55,
		64,
		85,
		101,
		98,
		135,
		140,
		155,
		160,
		184,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		179,
		189,
		172,
		174,
		178,
		192,
		204,
		212,
		202,
		200,
		194,
		226,
		-1,
		107,
		106,
		95,
		92,
		68,
		59,
		46,
		56,
		-1,
		-1,
		99,
		126,
		110,
		114,
		130,
		155,
		-1,
		191,
		-1,
		-1,
		205,
		-1,
		-1,
		231,
		194,
		183,
		174,
		180,
		186,
		197,
		219,
		208,
		209,
		199,
		209,
		222,
		91,
		88,
		76,
		74,
		97,
		54,
		50,
		-1,
		81,
		84,
		90,
		97,
		114,
		144,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		224,
		227,
		216,
		-1,
		206,
		179,
		184,
		209,
		216,
		217,
		211,
		205,
		212,
		211,
		219,
		227,
		100,
		114,
		103,
		99,
		98,
		106,
		55,
		71,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		217,
		-1,
		-1,
		224,
		217,
		205,
		193,
		183,
		193,
		201,
		201,
		204,
		208,
		203,
		214,
		206,
		210,
		227,
		-1,
		134,
		-1,
		86,
		78,
		93,
		108,
		116,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		258,
		242,
		223,
		-1,
		193,
		206,
		237,
		205,
		210,
		205,
		209,
		220,
		209,
		212,
		226,
		221,
		-1,
		-1,
		91,
		94,
		-1,
		-1,
		116,
		135,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		230,
		226,
		-1,
		-1,
		194,
		219,
		208,
		216,
		211,
		213,
		219,
		222,
		211,
		215,
		227,
		-1,
		-1,
		98,
		99,
		104,
		-1,
		125,
		-1,
		240,
		-1,
		207,
		214,
		202,
		-1,
		-1,
		-1,
		232,
		195,
		216,
		226,
		231,
		229,
		220,
		217,
		224,
		222,
		218,
		229,
		-1,
		-1,
		-1,
		155,
		132,
		247,
		238,
		221,
		201,
		193,
		213,
		-1,
		220,
		-1,
		195,
		196,
		223,
		225,
		242,
		236,
		220,
		235,
		225,
		216,
		225,
		161,
		-1,
		136,
		195,
		178,
		207,
		173,
		185,
		241,
		-1,
		217,
		199,
		-1,
		227,
		217,
		259,
		240,
		233,
		220,
		227,
		229,
		222,
		-1,
		-1,
		-1,
		151,
		150,
		149,
		160,
		168,
		166,
		184,
		-1,
		229,
		211,
		190,
		207,
		207,
		198,
		206,
		249,
		245,
		238,
		240,
		230,
		-1,
		206,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		177,
		199,
		194,
		186,
		198,
		207,
		194,
		200,
		202,
		210,
		208,
		205,
		217,
		213,
		233,
		229,
		261,
		-1,
		213,
		-1,
		181,
		-1,
		-1,
		195,
		181,
		193,
		204,
		194,
		194,
		199,
		197,
		219,
		236,
		220,
		218,
		223,
		228,
		-1,
		223,
		224,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		240,
		201,
		-1,
		226,
		206,
		-1,
		229,
		225,
		-1,
		-1,
		235,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		235,
		219,
		-1,
		217,
		217,
		-1,
		-1,
		-1,
		249,
		239,
		-1,
		208,
		211,
		-1,
		202,
		208,
		237,
		219,
		223,
		-1,
		-1,
		-1,
		264,
		245,
		239,
		223,
		228,
		216,
		233,
		219,
		221,
		233,
		222,
		243,
		-1,
		-1,
		-1,
		236,
		228,
		228,
		-1,
		-1,
		246,
		229,
		229,
		242,
		-1,
		-1,
		-1,
		258,
		239,
		-1,
		-1,
		237,
		-1,
		-1,
		242,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		247,
		-1,
		-1,
		-1,
		238,
		245,
		253,
		-1,
		-1,
		-1,
		-1,
		266,
		267,
		293,
		268,
		-1,
		-1,
		-1,
		252,
		252,
		-1,
		-1,
		264,
		265,
		-1,
		-1,
		-1,
		280,
		264,
		-1,
		256,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		285,
		-1,
		291,
		266,
		273,
		-1,
		-1,
		-1,
		-1,
		298,
		290,
		304,
		-1,
		276,
		278,
		-1,
		326,
		-1,
		-1,
		313,
		304,
		-1,
		-1,
		281,
		288,
		310,
		313,
		343,
		-1,
		300
	],
	[
		-1,
		277,
		266,
		277,
		285,
		258,
		265,
		-1,
		286,
		288,
		254,
		248,
		287,
		258,
		264,
		275,
		-1,
		-1,
		-1,
		277,
		276,
		246,
		244,
		253,
		258,
		265,
		-1,
		288,
		-1,
		298,
		277,
		288,
		293,
		239,
		236,
		256,
		275,
		281,
		273,
		313,
		269,
		240,
		234,
		252,
		257,
		275,
		267,
		-1,
		240,
		230,
		252,
		256,
		268,
		251,
		-1,
		-1,
		234,
		235,
		241,
		253,
		258,
		263,
		-1,
		289,
		273,
		-1,
		-1,
		224,
		237,
		233,
		236,
		244,
		260,
		281,
		273,
		268,
		-1,
		-1,
		225,
		229,
		242,
		243,
		241,
		268,
		281,
		263,
		277,
		276,
		-1,
		213,
		231,
		240,
		249,
		255,
		244,
		242,
		260,
		262,
		268,
		271,
		-1,
		205,
		207,
		236,
		242,
		254,
		260,
		247,
		247,
		257,
		250,
		269,
		260,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		202,
		210,
		236,
		235,
		231,
		249,
		257,
		250,
		247,
		245,
		242,
		258,
		259,
		269,
		-1,
		-1,
		258,
		227,
		262,
		219,
		204,
		-1,
		198,
		217,
		223,
		227,
		232,
		240,
		254,
		250,
		-1,
		236,
		235,
		266,
		252,
		263,
		218,
		-1,
		-1,
		216,
		208,
		193,
		196,
		193,
		193,
		223,
		222,
		227,
		229,
		231,
		237,
		240,
		240,
		246,
		230,
		240,
		244,
		252,
		270,
		-1,
		-1,
		312,
		-1,
		-1,
		215,
		198,
		-1,
		181,
		188,
		188,
		205,
		195,
		216,
		231,
		235,
		243,
		245,
		233,
		235,
		232,
		245,
		233,
		227,
		252,
		256,
		247,
		268,
		263,
		-1,
		311,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		174,
		177,
		183,
		207,
		217,
		-1,
		238,
		236,
		260,
		254,
		251,
		238,
		226,
		239,
		224,
		231,
		230,
		234,
		236,
		269,
		244,
		266,
		263,
		282,
		287,
		281,
		290,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		211,
		-1,
		225,
		238,
		245,
		240,
		243,
		255,
		246,
		233,
		222,
		233,
		222,
		219,
		227,
		233,
		247,
		239,
		238,
		256,
		266,
		274,
		278,
		284,
		-1,
		273,
		-1,
		215,
		199,
		201,
		173,
		194,
		-1,
		231,
		226,
		246,
		247,
		238,
		-1,
		241,
		244,
		251,
		229,
		214,
		231,
		223,
		221,
		226,
		228,
		242,
		233,
		251,
		258,
		256,
		260,
		280,
		292,
		233,
		223,
		-1,
		205,
		210,
		169,
		177,
		196,
		269,
		244,
		-1,
		239,
		-1,
		231,
		256,
		-1,
		235,
		231,
		213,
		214,
		209,
		224,
		230,
		224,
		221,
		239,
		242,
		249,
		253,
		269,
		-1,
		-1,
		218,
		222,
		211,
		162,
		181,
		205,
		242,
		237,
		226,
		225,
		-1,
		216,
		246,
		243,
		229,
		216,
		206,
		207,
		215,
		228,
		207,
		223,
		220,
		240,
		266,
		244,
		255,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		188,
		159,
		183,
		225,
		255,
		248,
		236,
		201,
		201,
		195,
		-1,
		236,
		219,
		215,
		204,
		202,
		215,
		210,
		226,
		218,
		216,
		235,
		247,
		238,
		246,
		-1,
		-1,
		-1,
		218,
		207,
		208,
		157,
		180,
		214,
		234,
		220,
		225,
		200,
		193,
		187,
		239,
		236,
		203,
		211,
		203,
		192,
		206,
		214,
		218,
		214,
		223,
		229,
		253,
		234,
		240,
		-1,
		-1,
		225,
		215,
		199,
		201,
		198,
		171,
		178,
		210,
		225,
		222,
		-1,
		192,
		-1,
		181,
		189,
		188,
		194,
		206,
		192,
		197,
		208,
		220,
		221,
		216,
		223,
		258,
		258,
		224,
		244,
		247,
		-1,
		-1,
		-1,
		218,
		216,
		191,
		168,
		152,
		188,
		-1,
		192,
		193,
		-1,
		186,
		180,
		186,
		185,
		192,
		189,
		189,
		203,
		211,
		207,
		223,
		226,
		208,
		232,
		-1,
		232,
		226,
		234,
		224,
		212,
		-1,
		-1,
		-1,
		214,
		193,
		186,
		206,
		147,
		199,
		-1,
		-1,
		177,
		170,
		-1,
		173,
		173,
		180,
		189,
		194,
		199,
		207,
		202,
		215,
		219,
		213,
		207,
		220,
		224,
		225,
		214,
		210,
		207,
		221,
		-1,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		167,
		-1,
		180,
		172,
		168,
		162,
		168,
		186,
		184,
		204,
		196,
		210,
		210,
		216,
		222,
		208,
		201,
		212,
		197,
		215,
		221,
		212,
		207,
		206,
		217,
		-1,
		234,
		220,
		191,
		-1,
		-1,
		180,
		-1,
		144,
		158,
		174,
		-1,
		202,
		181,
		204,
		182,
		196,
		192,
		230,
		231,
		209,
		214,
		222,
		210,
		213,
		202,
		205,
		197,
		219,
		216,
		200,
		202,
		211,
		-1,
		240,
		227,
		185,
		181,
		170,
		190,
		141,
		150,
		161,
		-1,
		-1,
		246,
		-1,
		180,
		197,
		206,
		204,
		220,
		209,
		216,
		233,
		207,
		202,
		207,
		196,
		196,
		191,
		210,
		196,
		194,
		209,
		225,
		-1,
		-1,
		-1,
		207,
		-1,
		-1,
		156,
		143,
		137,
		-1,
		178,
		-1,
		224,
		214,
		198,
		183,
		216,
		-1,
		208,
		204,
		211,
		-1,
		227,
		-1,
		199,
		202,
		193,
		188,
		185,
		196,
		194,
		203,
		204,
		-1,
		190,
		175,
		168,
		158,
		172,
		143,
		-1,
		186,
		-1,
		-1,
		211,
		205,
		205,
		189,
		192,
		224,
		204,
		196,
		211,
		210,
		197,
		196,
		184,
		184,
		187,
		181,
		194,
		204,
		210,
		202,
		-1,
		-1,
		-1,
		195,
		147,
		155,
		131,
		152,
		-1,
		-1,
		273,
		228,
		214,
		-1,
		198,
		224,
		212,
		202,
		192,
		197,
		198,
		188,
		186,
		182,
		191,
		190,
		183,
		182,
		203,
		196,
		218,
		-1,
		-1,
		144,
		157,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		220,
		236,
		228,
		199,
		213,
		-1,
		-1,
		196,
		189,
		183,
		186,
		174,
		194,
		201,
		189,
		176,
		191,
		201,
		209,
		208,
		-1,
		147,
		134,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		253,
		202,
		191,
		186,
		190,
		195,
		-1,
		169,
		180,
		173,
		192,
		199,
		191,
		176,
		170,
		181,
		196,
		213,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		210,
		208,
		179,
		172,
		176,
		-1,
		171,
		173,
		170,
		182,
		187,
		191,
		182,
		164,
		178,
		181,
		194,
		208,
		212,
		204,
		-1,
		186,
		-1,
		-1,
		-1,
		225,
		226,
		212,
		189,
		168,
		161,
		158,
		157,
		162,
		173,
		182,
		193,
		158,
		162,
		177,
		182,
		186,
		203,
		207,
		-1,
		-1,
		184,
		180,
		215,
		227,
		199,
		239,
		-1,
		-1,
		157,
		150,
		160,
		153,
		166,
		169,
		154,
		156,
		174,
		187,
		181,
		191,
		206,
		201,
		-1,
		-1,
		-1,
		182,
		-1,
		198,
		-1,
		-1,
		189,
		230,
		177,
		159,
		155,
		141,
		148,
		142,
		144,
		149,
		168,
		163,
		172,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		67,
		-1,
		-1,
		-1,
		148,
		167,
		162,
		168,
		173,
		164,
		192,
		189,
		-1,
		138,
		171,
		139,
		153,
		149,
		156,
		161,
		167,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		60,
		49,
		38,
		44,
		-1,
		141,
		164,
		154,
		144,
		150,
		-1,
		-1,
		156,
		153,
		151,
		131,
		137,
		142,
		145,
		183,
		159,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		47,
		88,
		81,
		12,
		20,
		51,
		-1,
		131,
		123,
		151,
		136,
		144,
		-1,
		-1,
		129,
		120,
		125,
		134,
		135,
		166,
		165,
		178,
		181,
		186,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		40,
		64,
		6,
		9,
		33,
		47,
		-1,
		122,
		-1,
		-1,
		167,
		154,
		138,
		128,
		125,
		172,
		148,
		143,
		149,
		151,
		175,
		166,
		191,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		39,
		44,
		0,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		183,
		-1,
		165,
		-1,
		148,
		152,
		156,
		159,
		174,
		161,
		168,
		185,
		191,
		180,
		190,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		112,
		67,
		34,
		13,
		71,
		86,
		90,
		-1,
		106,
		142,
		152,
		-1,
		192,
		-1,
		-1,
		-1,
		162,
		169,
		161,
		177,
		173,
		173,
		169,
		173,
		185,
		192,
		202,
		204,
		196,
		200,
		213,
		224,
		227,
		108,
		106,
		111,
		56,
		39,
		56,
		65,
		86,
		102,
		99,
		136,
		141,
		156,
		161,
		185,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		180,
		190,
		173,
		175,
		179,
		193,
		205,
		213,
		203,
		201,
		195,
		227,
		-1,
		108,
		107,
		96,
		93,
		69,
		60,
		47,
		57,
		-1,
		-1,
		100,
		127,
		111,
		115,
		131,
		156,
		-1,
		192,
		-1,
		-1,
		206,
		-1,
		-1,
		232,
		195,
		184,
		175,
		181,
		187,
		198,
		220,
		209,
		210,
		200,
		210,
		223,
		92,
		89,
		77,
		75,
		98,
		55,
		51,
		-1,
		82,
		85,
		91,
		98,
		115,
		145,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		225,
		228,
		217,
		-1,
		207,
		180,
		185,
		210,
		217,
		218,
		212,
		206,
		213,
		212,
		220,
		228,
		101,
		115,
		104,
		100,
		99,
		107,
		56,
		72,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		218,
		-1,
		-1,
		225,
		218,
		206,
		194,
		184,
		194,
		202,
		202,
		205,
		209,
		204,
		215,
		207,
		211,
		228,
		-1,
		135,
		-1,
		87,
		79,
		94,
		109,
		117,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		259,
		243,
		224,
		-1,
		194,
		207,
		238,
		206,
		211,
		206,
		210,
		221,
		210,
		213,
		227,
		222,
		-1,
		-1,
		92,
		95,
		-1,
		-1,
		117,
		136,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		231,
		227,
		-1,
		-1,
		195,
		220,
		209,
		217,
		212,
		214,
		220,
		223,
		212,
		216,
		228,
		-1,
		-1,
		99,
		100,
		105,
		-1,
		126,
		-1,
		241,
		-1,
		208,
		215,
		203,
		-1,
		-1,
		-1,
		233,
		196,
		217,
		227,
		232,
		230,
		221,
		218,
		225,
		223,
		219,
		230,
		-1,
		-1,
		-1,
		156,
		133,
		248,
		239,
		222,
		202,
		194,
		214,
		-1,
		221,
		-1,
		196,
		197,
		224,
		226,
		243,
		237,
		221,
		236,
		226,
		217,
		226,
		162,
		-1,
		137,
		196,
		179,
		208,
		174,
		186,
		242,
		-1,
		218,
		200,
		-1,
		228,
		218,
		260,
		241,
		234,
		221,
		228,
		230,
		223,
		-1,
		-1,
		-1,
		152,
		151,
		150,
		161,
		169,
		167,
		185,
		-1,
		230,
		212,
		191,
		208,
		208,
		199,
		207,
		250,
		246,
		239,
		241,
		231,
		-1,
		207,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		178,
		200,
		195,
		187,
		199,
		208,
		195,
		201,
		203,
		211,
		209,
		206,
		218,
		214,
		234,
		230,
		262,
		-1,
		214,
		-1,
		182,
		-1,
		-1,
		196,
		182,
		194,
		205,
		195,
		195,
		200,
		198,
		220,
		237,
		221,
		219,
		224,
		229,
		-1,
		224,
		225,
		-1,
		215,
		207,
		193,
		-1,
		186,
		-1,
		241,
		202,
		-1,
		227,
		207,
		-1,
		230,
		226,
		-1,
		-1,
		236,
		231,
		-1,
		-1,
		-1,
		216,
		196,
		236,
		220,
		-1,
		218,
		218,
		-1,
		-1,
		-1,
		250,
		240,
		-1,
		209,
		212,
		-1,
		203,
		209,
		238,
		220,
		224,
		-1,
		-1,
		-1,
		265,
		246,
		240,
		224,
		229,
		217,
		234,
		220,
		222,
		234,
		223,
		244,
		-1,
		-1,
		-1,
		237,
		229,
		229,
		-1,
		-1,
		247,
		230,
		230,
		243,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		238,
		-1,
		-1,
		243,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		248,
		-1,
		-1,
		-1,
		239,
		246,
		254,
		-1,
		-1,
		-1,
		-1,
		267,
		268,
		294,
		269,
		-1,
		-1,
		-1,
		253,
		253,
		-1,
		-1,
		265,
		266,
		-1,
		-1,
		-1,
		281,
		265,
		-1,
		257,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		286,
		-1,
		292,
		267,
		274,
		-1,
		-1,
		-1,
		-1,
		299,
		291,
		305,
		-1,
		277,
		279,
		-1,
		327,
		-1,
		-1,
		314,
		305,
		-1,
		-1,
		282,
		289,
		311,
		314,
		344,
		-1,
		301
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		271,
		260,
		271,
		279,
		252,
		259,
		-1,
		280,
		282,
		248,
		242,
		281,
		252,
		258,
		269,
		-1,
		-1,
		-1,
		271,
		270,
		240,
		238,
		247,
		252,
		259,
		-1,
		261,
		-1,
		292,
		271,
		282,
		287,
		233,
		230,
		250,
		269,
		254,
		246,
		307,
		263,
		234,
		228,
		246,
		239,
		248,
		240,
		-1,
		234,
		224,
		246,
		228,
		239,
		231,
		-1,
		-1,
		228,
		229,
		235,
		224,
		230,
		226,
		-1,
		236,
		220,
		-1,
		-1,
		218,
		222,
		206,
		209,
		217,
		215,
		228,
		220,
		215,
		-1,
		-1,
		212,
		208,
		215,
		202,
		198,
		215,
		228,
		210,
		224,
		223,
		-1,
		207,
		225,
		234,
		209,
		207,
		191,
		189,
		207,
		209,
		215,
		215,
		-1,
		199,
		201,
		223,
		231,
		231,
		207,
		194,
		194,
		204,
		197,
		216,
		204,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		196,
		204,
		227,
		219,
		209,
		224,
		217,
		197,
		194,
		192,
		189,
		205,
		203,
		213,
		-1,
		-1,
		252,
		221,
		256,
		213,
		198,
		-1,
		192,
		203,
		209,
		213,
		207,
		200,
		214,
		210,
		-1,
		183,
		182,
		210,
		196,
		207,
		212,
		-1,
		-1,
		210,
		202,
		187,
		190,
		187,
		187,
		217,
		216,
		209,
		195,
		191,
		197,
		200,
		200,
		206,
		177,
		187,
		191,
		189,
		214,
		-1,
		-1,
		249,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		182,
		199,
		189,
		210,
		225,
		219,
		211,
		205,
		193,
		195,
		192,
		205,
		193,
		174,
		199,
		203,
		184,
		205,
		200,
		-1,
		248,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		211,
		-1,
		232,
		228,
		229,
		214,
		211,
		198,
		186,
		199,
		184,
		191,
		190,
		178,
		176,
		206,
		181,
		203,
		200,
		219,
		224,
		218,
		227,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		219,
		232,
		236,
		225,
		228,
		215,
		206,
		193,
		182,
		193,
		182,
		179,
		187,
		170,
		185,
		176,
		175,
		193,
		203,
		211,
		215,
		221,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		220,
		240,
		238,
		229,
		-1,
		224,
		221,
		211,
		189,
		174,
		191,
		183,
		181,
		183,
		165,
		179,
		170,
		188,
		195,
		193,
		197,
		217,
		229,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		263,
		235,
		-1,
		230,
		-1,
		222,
		239,
		-1,
		195,
		191,
		173,
		174,
		169,
		184,
		176,
		161,
		158,
		176,
		179,
		186,
		190,
		206,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		228,
		217,
		216,
		-1,
		207,
		209,
		206,
		194,
		181,
		166,
		167,
		175,
		187,
		166,
		160,
		157,
		177,
		203,
		181,
		192,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		246,
		239,
		227,
		192,
		192,
		186,
		-1,
		205,
		184,
		175,
		164,
		162,
		175,
		167,
		175,
		155,
		153,
		172,
		184,
		175,
		183,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		225,
		211,
		216,
		191,
		184,
		178,
		218,
		201,
		182,
		171,
		163,
		152,
		163,
		171,
		169,
		151,
		160,
		166,
		190,
		171,
		177,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		216,
		213,
		-1,
		183,
		-1,
		172,
		180,
		176,
		171,
		168,
		155,
		154,
		168,
		168,
		158,
		153,
		160,
		195,
		195,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		183,
		184,
		-1,
		177,
		171,
		177,
		176,
		174,
		159,
		163,
		165,
		168,
		156,
		162,
		163,
		145,
		169,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		168,
		161,
		-1,
		164,
		164,
		171,
		166,
		162,
		164,
		161,
		150,
		163,
		156,
		150,
		144,
		157,
		161,
		162,
		151,
		147,
		144,
		158,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		176,
		168,
		159,
		153,
		159,
		177,
		175,
		190,
		174,
		176,
		172,
		164,
		159,
		145,
		138,
		149,
		134,
		152,
		158,
		149,
		144,
		143,
		154,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		154,
		170,
		-1,
		193,
		172,
		195,
		173,
		185,
		183,
		181,
		182,
		152,
		157,
		159,
		147,
		150,
		139,
		142,
		134,
		156,
		153,
		137,
		139,
		148,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		141,
		157,
		-1,
		-1,
		209,
		-1,
		163,
		165,
		197,
		195,
		171,
		146,
		153,
		171,
		144,
		139,
		144,
		133,
		133,
		128,
		147,
		133,
		131,
		146,
		162,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		174,
		-1,
		187,
		175,
		162,
		144,
		184,
		-1,
		145,
		141,
		148,
		-1,
		164,
		-1,
		136,
		139,
		130,
		125,
		122,
		133,
		131,
		140,
		141,
		-1,
		181,
		166,
		159,
		149,
		163,
		131,
		-1,
		165,
		-1,
		-1,
		174,
		168,
		168,
		137,
		134,
		161,
		141,
		133,
		148,
		147,
		134,
		133,
		121,
		121,
		124,
		118,
		131,
		141,
		147,
		139,
		-1,
		-1,
		-1,
		186,
		161,
		155,
		127,
		131,
		-1,
		-1,
		235,
		191,
		177,
		-1,
		129,
		161,
		149,
		139,
		129,
		134,
		135,
		125,
		123,
		119,
		128,
		127,
		120,
		119,
		140,
		133,
		155,
		-1,
		-1,
		160,
		153,
		141,
		109,
		104,
		-1,
		-1,
		-1,
		181,
		167,
		155,
		127,
		150,
		-1,
		-1,
		133,
		126,
		120,
		118,
		111,
		131,
		138,
		126,
		113,
		128,
		138,
		146,
		145,
		-1,
		163,
		150,
		-1,
		-1,
		103,
		93,
		-1,
		-1,
		-1,
		-1,
		145,
		126,
		121,
		116,
		120,
		132,
		-1,
		105,
		109,
		109,
		129,
		136,
		128,
		113,
		107,
		118,
		133,
		150,
		-1,
		-1,
		117,
		-1,
		79,
		-1,
		-1,
		-1,
		-1,
		117,
		132,
		109,
		102,
		106,
		-1,
		103,
		102,
		106,
		112,
		124,
		128,
		119,
		101,
		115,
		118,
		131,
		145,
		149,
		140,
		-1,
		70,
		-1,
		-1,
		-1,
		109,
		110,
		142,
		119,
		98,
		91,
		88,
		94,
		98,
		110,
		119,
		130,
		95,
		99,
		114,
		119,
		123,
		140,
		144,
		-1,
		-1,
		68,
		64,
		99,
		111,
		83,
		169,
		-1,
		-1,
		87,
		80,
		90,
		90,
		103,
		106,
		91,
		93,
		111,
		124,
		118,
		128,
		143,
		138,
		-1,
		-1,
		-1,
		66,
		-1,
		82,
		-1,
		-1,
		73,
		160,
		107,
		89,
		85,
		71,
		85,
		79,
		81,
		86,
		105,
		100,
		109,
		114,
		118,
		141,
		130,
		169,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		32,
		51,
		46,
		52,
		57,
		48,
		122,
		119,
		-1,
		67,
		108,
		76,
		90,
		86,
		93,
		98,
		104,
		108,
		115,
		131,
		130,
		125,
		161,
		152,
		158,
		-1,
		-1,
		156,
		145,
		134,
		140,
		-1,
		25,
		48,
		38,
		28,
		34,
		-1,
		-1,
		81,
		78,
		81,
		68,
		74,
		79,
		82,
		120,
		96,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		110,
		147,
		140,
		108,
		116,
		147,
		-1,
		15,
		7,
		35,
		20,
		28,
		-1,
		-1,
		54,
		50,
		55,
		64,
		67,
		103,
		102,
		115,
		118,
		123,
		111,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		103,
		123,
		102,
		105,
		129,
		143,
		-1,
		6,
		-1,
		-1,
		51,
		41,
		49,
		45,
		49,
		102,
		78,
		73,
		86,
		88,
		112,
		103,
		128,
		119,
		119,
		122,
		137,
		142,
		134,
		148,
		148,
		149,
		-1,
		92,
		103,
		96,
		-1,
		-1,
		-1,
		-1,
		0,
		-1,
		-1,
		67,
		-1,
		75,
		-1,
		68,
		72,
		86,
		89,
		111,
		98,
		105,
		122,
		128,
		117,
		127,
		123,
		124,
		133,
		144,
		156,
		155,
		156,
		117,
		73,
		76,
		87,
		98,
		113,
		117,
		-1,
		11,
		50,
		99,
		-1,
		76,
		-1,
		-1,
		-1,
		82,
		99,
		91,
		107,
		110,
		110,
		106,
		110,
		122,
		129,
		139,
		141,
		133,
		137,
		150,
		161,
		164,
		113,
		104,
		117,
		62,
		62,
		83,
		92,
		113,
		26,
		17,
		44,
		88,
		101,
		96,
		83,
		-1,
		-1,
		105,
		109,
		-1,
		-1,
		117,
		127,
		110,
		112,
		116,
		130,
		142,
		150,
		140,
		138,
		132,
		164,
		-1,
		106,
		105,
		94,
		91,
		67,
		58,
		53,
		80,
		-1,
		-1,
		29,
		45,
		58,
		62,
		78,
		103,
		-1,
		86,
		-1,
		-1,
		126,
		-1,
		-1,
		169,
		132,
		121,
		112,
		118,
		124,
		135,
		157,
		146,
		147,
		137,
		147,
		160,
		90,
		87,
		75,
		73,
		96,
		61,
		49,
		-1,
		44,
		32,
		38,
		45,
		62,
		92,
		-1,
		-1,
		102,
		93,
		-1,
		-1,
		145,
		152,
		154,
		-1,
		144,
		117,
		122,
		147,
		154,
		155,
		149,
		143,
		150,
		149,
		157,
		165,
		99,
		113,
		102,
		98,
		97,
		105,
		54,
		47,
		47,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		137,
		112,
		-1,
		-1,
		152,
		155,
		143,
		131,
		121,
		131,
		139,
		139,
		142,
		146,
		141,
		152,
		144,
		148,
		165,
		-1,
		133,
		-1,
		85,
		53,
		73,
		88,
		96,
		-1,
		-1,
		-1,
		154,
		140,
		133,
		121,
		119,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		175,
		143,
		148,
		143,
		147,
		158,
		147,
		150,
		164,
		159,
		-1,
		-1,
		71,
		74,
		-1,
		-1,
		98,
		117,
		-1,
		145,
		134,
		119,
		111,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		132,
		157,
		146,
		154,
		149,
		151,
		157,
		160,
		149,
		153,
		165,
		-1,
		-1,
		78,
		81,
		86,
		-1,
		107,
		-1,
		169,
		-1,
		114,
		130,
		132,
		-1,
		-1,
		-1,
		170,
		133,
		154,
		164,
		169,
		167,
		158,
		155,
		162,
		160,
		156,
		167,
		-1,
		-1,
		-1,
		137,
		114,
		176,
		167,
		150,
		130,
		122,
		147,
		-1,
		158,
		-1,
		133,
		134,
		161,
		163,
		180,
		174,
		158,
		173,
		163,
		154,
		163,
		143,
		-1,
		118,
		177,
		160,
		136,
		136,
		135,
		179,
		-1,
		155,
		137,
		-1,
		165,
		155,
		197,
		178,
		171,
		158,
		165,
		167,
		160,
		-1,
		-1,
		-1,
		133,
		132,
		131,
		142,
		150,
		141,
		136,
		-1,
		167,
		149,
		128,
		145,
		145,
		136,
		144,
		187,
		183,
		176,
		178,
		168,
		-1,
		205,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		159,
		176,
		149,
		137,
		150,
		146,
		132,
		138,
		140,
		148,
		146,
		143,
		155,
		151,
		171,
		167,
		199,
		-1,
		212,
		-1,
		163,
		-1,
		-1,
		177,
		163,
		171,
		160,
		149,
		147,
		145,
		136,
		158,
		174,
		158,
		156,
		161,
		166,
		-1,
		222,
		223,
		-1,
		196,
		188,
		174,
		-1,
		167,
		-1,
		195,
		156,
		-1,
		165,
		145,
		-1,
		167,
		163,
		-1,
		-1,
		234,
		212,
		-1,
		-1,
		-1,
		197,
		177,
		190,
		174,
		-1,
		156,
		156,
		-1,
		-1,
		-1,
		237,
		221,
		-1,
		190,
		193,
		-1,
		184,
		190,
		211,
		158,
		162,
		-1,
		-1,
		-1,
		246,
		227,
		221,
		205,
		210,
		198,
		215,
		201,
		194,
		172,
		161,
		182,
		-1,
		-1,
		-1,
		218,
		210,
		210,
		-1,
		-1,
		219,
		202,
		183,
		181,
		-1,
		-1,
		-1,
		240,
		221,
		-1,
		-1,
		209,
		-1,
		-1,
		215,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		229,
		-1,
		-1,
		-1,
		205,
		201,
		202,
		-1,
		-1,
		-1,
		-1,
		250,
		251,
		275,
		250,
		-1,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		253,
		251,
		-1,
		-1,
		-1,
		225,
		209,
		-1,
		195,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		230,
		-1,
		230,
		205,
		212,
		-1,
		-1,
		-1,
		-1,
		243,
		235,
		243,
		-1,
		215,
		217,
		-1,
		265,
		-1,
		-1,
		258,
		249,
		-1,
		-1,
		220,
		227,
		249,
		252,
		288,
		-1,
		239
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		278,
		267,
		278,
		286,
		259,
		266,
		-1,
		287,
		289,
		255,
		249,
		288,
		259,
		265,
		276,
		-1,
		-1,
		-1,
		278,
		277,
		247,
		245,
		254,
		259,
		266,
		-1,
		289,
		-1,
		299,
		278,
		289,
		294,
		240,
		237,
		257,
		276,
		282,
		274,
		314,
		270,
		241,
		235,
		253,
		258,
		276,
		268,
		-1,
		241,
		231,
		253,
		257,
		269,
		252,
		-1,
		-1,
		235,
		236,
		242,
		254,
		259,
		261,
		-1,
		271,
		255,
		-1,
		-1,
		225,
		238,
		234,
		237,
		245,
		250,
		263,
		255,
		250,
		-1,
		-1,
		226,
		230,
		243,
		237,
		233,
		250,
		263,
		245,
		259,
		258,
		-1,
		214,
		232,
		241,
		244,
		242,
		226,
		224,
		242,
		244,
		250,
		250,
		-1,
		206,
		208,
		237,
		243,
		255,
		242,
		229,
		229,
		239,
		232,
		251,
		239,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		203,
		211,
		237,
		236,
		232,
		250,
		252,
		232,
		229,
		227,
		224,
		240,
		238,
		248,
		-1,
		-1,
		259,
		228,
		263,
		220,
		205,
		-1,
		199,
		218,
		224,
		228,
		233,
		235,
		249,
		245,
		-1,
		218,
		217,
		245,
		231,
		242,
		219,
		-1,
		-1,
		217,
		209,
		194,
		197,
		194,
		194,
		224,
		223,
		228,
		230,
		226,
		232,
		235,
		235,
		241,
		212,
		222,
		226,
		224,
		249,
		-1,
		-1,
		284,
		-1,
		-1,
		216,
		199,
		-1,
		182,
		189,
		189,
		206,
		196,
		217,
		232,
		236,
		244,
		240,
		228,
		230,
		227,
		240,
		228,
		209,
		234,
		238,
		219,
		240,
		235,
		-1,
		283,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		175,
		178,
		184,
		208,
		218,
		-1,
		239,
		237,
		261,
		249,
		246,
		233,
		221,
		234,
		219,
		226,
		225,
		213,
		211,
		241,
		216,
		238,
		235,
		254,
		259,
		253,
		262,
		-1,
		224,
		220,
		216,
		223,
		172,
		-1,
		-1,
		212,
		-1,
		226,
		239,
		243,
		241,
		244,
		250,
		241,
		228,
		217,
		228,
		217,
		214,
		222,
		205,
		220,
		211,
		210,
		228,
		238,
		246,
		250,
		256,
		-1,
		274,
		-1,
		216,
		200,
		202,
		174,
		195,
		-1,
		232,
		227,
		247,
		245,
		236,
		-1,
		239,
		242,
		246,
		224,
		209,
		226,
		218,
		216,
		218,
		200,
		214,
		205,
		223,
		230,
		228,
		232,
		252,
		264,
		234,
		224,
		-1,
		206,
		211,
		170,
		178,
		197,
		270,
		242,
		-1,
		237,
		-1,
		229,
		254,
		-1,
		230,
		226,
		208,
		209,
		204,
		219,
		211,
		196,
		193,
		211,
		214,
		221,
		225,
		241,
		-1,
		-1,
		219,
		223,
		212,
		163,
		182,
		206,
		243,
		235,
		224,
		223,
		-1,
		214,
		244,
		241,
		227,
		214,
		201,
		202,
		210,
		222,
		201,
		195,
		192,
		212,
		238,
		216,
		227,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		189,
		160,
		184,
		226,
		253,
		246,
		234,
		199,
		199,
		193,
		-1,
		234,
		217,
		210,
		199,
		197,
		210,
		202,
		210,
		190,
		188,
		207,
		219,
		210,
		218,
		-1,
		-1,
		-1,
		219,
		208,
		209,
		155,
		178,
		215,
		232,
		218,
		223,
		198,
		191,
		185,
		237,
		234,
		201,
		206,
		198,
		187,
		198,
		206,
		204,
		186,
		195,
		201,
		225,
		206,
		212,
		-1,
		-1,
		226,
		216,
		200,
		202,
		199,
		169,
		176,
		208,
		223,
		220,
		-1,
		190,
		-1,
		179,
		187,
		186,
		192,
		203,
		190,
		189,
		203,
		203,
		193,
		188,
		195,
		230,
		230,
		196,
		216,
		219,
		-1,
		-1,
		-1,
		219,
		214,
		189,
		166,
		150,
		186,
		-1,
		190,
		191,
		-1,
		184,
		178,
		184,
		183,
		190,
		187,
		187,
		200,
		203,
		191,
		197,
		198,
		180,
		204,
		-1,
		204,
		198,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		212,
		191,
		184,
		204,
		145,
		197,
		-1,
		-1,
		175,
		168,
		-1,
		171,
		171,
		178,
		187,
		192,
		197,
		196,
		185,
		198,
		191,
		185,
		179,
		192,
		196,
		197,
		186,
		182,
		179,
		193,
		-1,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		165,
		-1,
		183,
		175,
		166,
		160,
		166,
		184,
		182,
		202,
		194,
		208,
		207,
		199,
		194,
		180,
		173,
		184,
		169,
		187,
		193,
		184,
		179,
		178,
		189,
		-1,
		232,
		218,
		189,
		-1,
		-1,
		178,
		-1,
		142,
		161,
		177,
		-1,
		200,
		179,
		202,
		180,
		194,
		190,
		216,
		217,
		187,
		192,
		194,
		182,
		185,
		174,
		177,
		169,
		191,
		188,
		172,
		174,
		183,
		-1,
		238,
		225,
		183,
		179,
		168,
		188,
		139,
		148,
		164,
		-1,
		-1,
		238,
		-1,
		178,
		194,
		204,
		202,
		206,
		181,
		188,
		206,
		179,
		174,
		179,
		168,
		168,
		163,
		182,
		168,
		166,
		181,
		197,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		154,
		141,
		135,
		-1,
		181,
		-1,
		216,
		204,
		191,
		173,
		213,
		-1,
		180,
		176,
		183,
		-1,
		199,
		-1,
		171,
		174,
		165,
		160,
		157,
		168,
		166,
		175,
		176,
		-1,
		188,
		173,
		166,
		156,
		170,
		138,
		-1,
		172,
		-1,
		-1,
		203,
		197,
		197,
		166,
		163,
		196,
		176,
		168,
		183,
		182,
		169,
		168,
		156,
		156,
		159,
		153,
		166,
		176,
		182,
		174,
		-1,
		-1,
		-1,
		193,
		168,
		162,
		134,
		138,
		-1,
		-1,
		264,
		220,
		206,
		-1,
		158,
		196,
		184,
		174,
		164,
		169,
		170,
		160,
		158,
		154,
		163,
		162,
		155,
		154,
		175,
		168,
		190,
		-1,
		-1,
		167,
		160,
		148,
		116,
		111,
		-1,
		-1,
		-1,
		210,
		196,
		184,
		156,
		185,
		-1,
		-1,
		168,
		161,
		155,
		153,
		146,
		166,
		173,
		161,
		148,
		163,
		173,
		181,
		180,
		-1,
		170,
		157,
		-1,
		-1,
		110,
		100,
		-1,
		-1,
		-1,
		-1,
		174,
		155,
		156,
		151,
		155,
		167,
		-1,
		140,
		144,
		144,
		164,
		171,
		163,
		148,
		142,
		153,
		168,
		185,
		-1,
		-1,
		124,
		-1,
		86,
		-1,
		-1,
		-1,
		-1,
		146,
		161,
		144,
		137,
		141,
		-1,
		138,
		137,
		141,
		147,
		159,
		163,
		154,
		136,
		150,
		153,
		166,
		180,
		184,
		147,
		-1,
		77,
		-1,
		-1,
		-1,
		123,
		145,
		177,
		154,
		133,
		126,
		123,
		129,
		133,
		145,
		154,
		165,
		130,
		134,
		149,
		154,
		158,
		175,
		179,
		-1,
		-1,
		75,
		71,
		106,
		118,
		118,
		204,
		-1,
		-1,
		122,
		115,
		125,
		125,
		138,
		141,
		126,
		128,
		146,
		159,
		153,
		163,
		178,
		173,
		-1,
		-1,
		-1,
		87,
		-1,
		89,
		-1,
		-1,
		108,
		195,
		142,
		124,
		120,
		106,
		120,
		114,
		116,
		121,
		140,
		135,
		144,
		149,
		153,
		176,
		165,
		204,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		94,
		58,
		53,
		87,
		92,
		83,
		157,
		154,
		-1,
		102,
		143,
		111,
		125,
		121,
		128,
		133,
		139,
		143,
		150,
		166,
		165,
		160,
		196,
		187,
		193,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		87,
		55,
		73,
		63,
		69,
		-1,
		-1,
		116,
		113,
		116,
		103,
		109,
		114,
		117,
		155,
		131,
		139,
		143,
		147,
		153,
		158,
		163,
		169,
		184,
		199,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		77,
		69,
		52,
		55,
		63,
		-1,
		-1,
		89,
		85,
		90,
		99,
		102,
		138,
		137,
		150,
		153,
		158,
		146,
		145,
		163,
		167,
		176,
		183,
		173,
		186,
		190,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		74,
		-1,
		-1,
		10,
		76,
		84,
		80,
		84,
		137,
		113,
		108,
		121,
		123,
		147,
		138,
		163,
		154,
		154,
		157,
		172,
		177,
		169,
		183,
		183,
		184,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		75,
		-1,
		-1,
		0,
		-1,
		110,
		-1,
		103,
		107,
		121,
		124,
		146,
		133,
		140,
		156,
		162,
		152,
		162,
		158,
		159,
		168,
		179,
		191,
		190,
		191,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		86,
		125,
		49,
		-1,
		9,
		-1,
		-1,
		-1,
		117,
		134,
		126,
		142,
		145,
		145,
		140,
		144,
		157,
		164,
		174,
		176,
		168,
		172,
		185,
		196,
		199,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		101,
		92,
		119,
		56,
		45,
		40,
		19,
		-1,
		-1,
		140,
		144,
		-1,
		-1,
		152,
		148,
		136,
		146,
		150,
		164,
		176,
		185,
		175,
		173,
		167,
		199,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		104,
		120,
		112,
		89,
		87,
		112,
		-1,
		34,
		-1,
		-1,
		161,
		-1,
		-1,
		173,
		153,
		142,
		133,
		138,
		158,
		169,
		191,
		173,
		182,
		172,
		182,
		195,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		119,
		107,
		113,
		110,
		90,
		101,
		-1,
		-1,
		50,
		41,
		-1,
		-1,
		171,
		169,
		158,
		-1,
		148,
		130,
		135,
		165,
		167,
		169,
		176,
		170,
		177,
		184,
		192,
		188,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		-1,
		85,
		60,
		-1,
		-1,
		166,
		159,
		147,
		135,
		125,
		135,
		152,
		152,
		155,
		160,
		168,
		179,
		175,
		179,
		182,
		-1,
		208,
		-1,
		160,
		128,
		148,
		163,
		171,
		-1,
		-1,
		-1,
		102,
		88,
		81,
		69,
		67,
		-1,
		200,
		184,
		165,
		-1,
		135,
		148,
		188,
		156,
		161,
		156,
		171,
		182,
		173,
		181,
		175,
		178,
		-1,
		-1,
		146,
		149,
		-1,
		-1,
		140,
		142,
		-1,
		93,
		82,
		67,
		59,
		-1,
		-1,
		172,
		168,
		-1,
		-1,
		122,
		160,
		159,
		167,
		162,
		167,
		179,
		175,
		171,
		181,
		172,
		-1,
		-1,
		153,
		153,
		147,
		-1,
		125,
		-1,
		117,
		-1,
		62,
		78,
		80,
		-1,
		-1,
		-1,
		153,
		116,
		132,
		155,
		181,
		179,
		170,
		163,
		170,
		173,
		166,
		172,
		-1,
		-1,
		-1,
		143,
		117,
		124,
		115,
		98,
		78,
		70,
		95,
		-1,
		134,
		-1,
		109,
		112,
		137,
		176,
		178,
		164,
		160,
		173,
		167,
		164,
		162,
		149,
		-1,
		119,
		152,
		116,
		84,
		84,
		83,
		148,
		-1,
		131,
		113,
		-1,
		141,
		131,
		179,
		154,
		163,
		156,
		150,
		151,
		159,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		104,
		89,
		84,
		-1,
		136,
		118,
		104,
		121,
		121,
		112,
		120,
		169,
		165,
		168,
		166,
		144,
		-1,
		235,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		124,
		97,
		85,
		99,
		106,
		101,
		103,
		116,
		124,
		122,
		119,
		131,
		127,
		147,
		143,
		175,
		-1,
		230,
		-1,
		151,
		-1,
		-1,
		131,
		117,
		119,
		108,
		97,
		95,
		98,
		96,
		118,
		148,
		134,
		132,
		137,
		142,
		-1,
		219,
		218,
		-1,
		150,
		142,
		128,
		-1,
		121,
		-1,
		143,
		104,
		-1,
		125,
		105,
		-1,
		143,
		139,
		-1,
		-1,
		206,
		166,
		-1,
		-1,
		-1,
		151,
		131,
		138,
		122,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		191,
		175,
		-1,
		144,
		147,
		-1,
		138,
		144,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		159,
		164,
		152,
		169,
		155,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		172,
		164,
		164,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		183,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		229,
		204,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		270,
		259,
		270,
		278,
		251,
		258,
		-1,
		277,
		281,
		247,
		241,
		280,
		249,
		255,
		266,
		-1,
		-1,
		-1,
		270,
		269,
		237,
		235,
		244,
		249,
		256,
		-1,
		255,
		-1,
		291,
		270,
		281,
		286,
		230,
		227,
		247,
		266,
		248,
		240,
		306,
		260,
		231,
		225,
		243,
		233,
		242,
		234,
		-1,
		231,
		221,
		243,
		222,
		233,
		225,
		-1,
		-1,
		225,
		226,
		232,
		218,
		224,
		220,
		-1,
		230,
		214,
		-1,
		-1,
		215,
		216,
		200,
		203,
		211,
		209,
		222,
		214,
		209,
		-1,
		-1,
		206,
		202,
		209,
		196,
		192,
		209,
		222,
		204,
		218,
		217,
		-1,
		212,
		230,
		235,
		203,
		201,
		185,
		183,
		201,
		203,
		209,
		209,
		-1,
		221,
		222,
		217,
		225,
		225,
		201,
		188,
		188,
		198,
		191,
		210,
		198,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		218,
		204,
		221,
		213,
		203,
		218,
		211,
		191,
		188,
		186,
		183,
		199,
		197,
		207,
		-1,
		-1,
		274,
		243,
		278,
		235,
		220,
		-1,
		214,
		197,
		203,
		207,
		201,
		194,
		208,
		204,
		-1,
		177,
		176,
		204,
		190,
		201,
		234,
		-1,
		-1,
		232,
		224,
		209,
		212,
		209,
		209,
		212,
		211,
		203,
		189,
		185,
		191,
		194,
		194,
		200,
		171,
		181,
		185,
		183,
		208,
		-1,
		-1,
		243,
		-1,
		-1,
		231,
		214,
		-1,
		197,
		204,
		204,
		221,
		211,
		232,
		222,
		213,
		205,
		199,
		187,
		189,
		186,
		199,
		187,
		168,
		193,
		197,
		178,
		199,
		194,
		-1,
		242,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		190,
		193,
		199,
		223,
		233,
		-1,
		234,
		222,
		223,
		208,
		205,
		192,
		180,
		193,
		178,
		185,
		184,
		172,
		170,
		200,
		175,
		197,
		194,
		213,
		218,
		212,
		221,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		227,
		-1,
		241,
		254,
		246,
		219,
		222,
		209,
		200,
		187,
		176,
		187,
		176,
		173,
		181,
		164,
		179,
		170,
		169,
		187,
		197,
		205,
		209,
		215,
		-1,
		289,
		-1,
		231,
		215,
		217,
		189,
		210,
		-1,
		247,
		242,
		262,
		248,
		246,
		-1,
		218,
		215,
		205,
		183,
		168,
		185,
		177,
		175,
		177,
		159,
		173,
		164,
		182,
		189,
		187,
		191,
		211,
		223,
		249,
		239,
		-1,
		221,
		226,
		185,
		193,
		212,
		285,
		252,
		-1,
		247,
		-1,
		220,
		233,
		-1,
		189,
		185,
		167,
		168,
		163,
		178,
		170,
		155,
		152,
		170,
		173,
		180,
		184,
		200,
		-1,
		-1,
		234,
		238,
		227,
		178,
		197,
		221,
		258,
		245,
		234,
		233,
		-1,
		224,
		203,
		200,
		188,
		175,
		160,
		161,
		169,
		181,
		160,
		154,
		151,
		171,
		197,
		175,
		186,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		204,
		175,
		199,
		241,
		263,
		256,
		244,
		209,
		209,
		203,
		-1,
		199,
		178,
		169,
		158,
		156,
		169,
		161,
		169,
		149,
		147,
		166,
		178,
		169,
		177,
		-1,
		-1,
		-1,
		234,
		223,
		224,
		170,
		193,
		230,
		242,
		228,
		233,
		208,
		201,
		195,
		212,
		195,
		176,
		165,
		157,
		146,
		157,
		165,
		163,
		145,
		154,
		160,
		184,
		165,
		171,
		-1,
		-1,
		241,
		231,
		215,
		217,
		214,
		184,
		191,
		223,
		233,
		235,
		-1,
		200,
		-1,
		189,
		185,
		170,
		165,
		162,
		149,
		148,
		162,
		162,
		152,
		147,
		154,
		189,
		189,
		155,
		175,
		178,
		-1,
		-1,
		-1,
		234,
		229,
		204,
		181,
		165,
		201,
		-1,
		205,
		206,
		-1,
		194,
		188,
		185,
		172,
		168,
		153,
		157,
		159,
		162,
		150,
		156,
		157,
		139,
		163,
		-1,
		163,
		157,
		165,
		155,
		143,
		-1,
		-1,
		-1,
		227,
		206,
		199,
		219,
		160,
		212,
		-1,
		-1,
		190,
		183,
		-1,
		181,
		163,
		165,
		160,
		154,
		158,
		155,
		144,
		157,
		150,
		144,
		138,
		151,
		155,
		156,
		145,
		141,
		138,
		152,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		180,
		-1,
		198,
		190,
		181,
		175,
		180,
		176,
		174,
		182,
		166,
		169,
		164,
		158,
		151,
		139,
		132,
		143,
		128,
		146,
		152,
		143,
		138,
		137,
		148,
		-1,
		247,
		233,
		204,
		-1,
		-1,
		193,
		-1,
		157,
		176,
		192,
		-1,
		215,
		194,
		212,
		190,
		186,
		177,
		173,
		174,
		144,
		149,
		151,
		139,
		142,
		133,
		136,
		128,
		150,
		147,
		131,
		133,
		142,
		-1,
		253,
		240,
		198,
		194,
		183,
		203,
		154,
		163,
		179,
		-1,
		-1,
		223,
		-1,
		177,
		179,
		191,
		189,
		163,
		138,
		145,
		163,
		136,
		131,
		138,
		127,
		127,
		122,
		141,
		127,
		125,
		140,
		156,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		169,
		156,
		150,
		-1,
		196,
		-1,
		201,
		189,
		176,
		158,
		198,
		-1,
		137,
		133,
		140,
		-1,
		156,
		-1,
		128,
		131,
		122,
		119,
		116,
		127,
		125,
		134,
		135,
		-1,
		203,
		188,
		181,
		171,
		185,
		153,
		-1,
		187,
		-1,
		-1,
		188,
		182,
		182,
		151,
		148,
		153,
		133,
		125,
		140,
		139,
		126,
		125,
		113,
		113,
		116,
		112,
		125,
		135,
		141,
		133,
		-1,
		-1,
		-1,
		208,
		183,
		177,
		149,
		153,
		-1,
		-1,
		249,
		205,
		191,
		-1,
		143,
		153,
		141,
		131,
		121,
		126,
		127,
		117,
		115,
		111,
		120,
		121,
		114,
		113,
		134,
		127,
		149,
		-1,
		-1,
		182,
		175,
		163,
		131,
		126,
		-1,
		-1,
		-1,
		195,
		181,
		167,
		141,
		142,
		-1,
		-1,
		125,
		118,
		112,
		110,
		103,
		123,
		130,
		120,
		107,
		122,
		132,
		140,
		139,
		-1,
		185,
		172,
		-1,
		-1,
		125,
		115,
		-1,
		-1,
		-1,
		-1,
		159,
		124,
		113,
		108,
		112,
		124,
		-1,
		97,
		101,
		101,
		121,
		128,
		122,
		107,
		101,
		112,
		127,
		144,
		-1,
		-1,
		139,
		-1,
		101,
		-1,
		-1,
		-1,
		-1,
		131,
		130,
		101,
		94,
		98,
		-1,
		95,
		94,
		98,
		104,
		117,
		122,
		113,
		95,
		109,
		112,
		125,
		139,
		143,
		162,
		-1,
		92,
		-1,
		-1,
		-1,
		123,
		124,
		134,
		111,
		90,
		83,
		80,
		86,
		90,
		104,
		112,
		123,
		89,
		93,
		108,
		113,
		117,
		134,
		138,
		-1,
		-1,
		90,
		86,
		121,
		131,
		97,
		161,
		-1,
		-1,
		79,
		72,
		82,
		84,
		96,
		99,
		85,
		87,
		105,
		118,
		112,
		122,
		137,
		132,
		-1,
		-1,
		-1,
		102,
		-1,
		104,
		-1,
		-1,
		87,
		152,
		99,
		81,
		77,
		63,
		79,
		73,
		75,
		80,
		99,
		94,
		103,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		81,
		73,
		67,
		70,
		71,
		62,
		114,
		111,
		-1,
		59,
		102,
		70,
		84,
		80,
		87,
		92,
		98,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		205,
		194,
		183,
		189,
		-1,
		74,
		70,
		56,
		46,
		48,
		-1,
		-1,
		73,
		70,
		75,
		62,
		68,
		73,
		76,
		114,
		90,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		159,
		196,
		189,
		157,
		165,
		196,
		-1,
		64,
		56,
		66,
		42,
		39,
		-1,
		-1,
		46,
		44,
		49,
		58,
		61,
		97,
		96,
		109,
		112,
		117,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		152,
		172,
		151,
		154,
		178,
		192,
		-1,
		61,
		-1,
		-1,
		73,
		40,
		25,
		37,
		41,
		96,
		72,
		67,
		80,
		82,
		106,
		97,
		122,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		141,
		152,
		145,
		-1,
		-1,
		-1,
		-1,
		62,
		-1,
		-1,
		89,
		-1,
		0,
		-1,
		62,
		66,
		80,
		83,
		105,
		92,
		99,
		116,
		122,
		111,
		121,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		166,
		122,
		125,
		136,
		147,
		162,
		166,
		-1,
		73,
		112,
		127,
		-1,
		98,
		-1,
		-1,
		-1,
		76,
		93,
		85,
		101,
		104,
		104,
		100,
		104,
		116,
		123,
		133,
		135,
		127,
		131,
		144,
		155,
		158,
		162,
		153,
		166,
		111,
		111,
		132,
		141,
		162,
		88,
		79,
		106,
		134,
		123,
		118,
		105,
		-1,
		-1,
		99,
		103,
		-1,
		-1,
		111,
		121,
		104,
		106,
		110,
		124,
		136,
		144,
		134,
		132,
		126,
		158,
		-1,
		155,
		154,
		143,
		140,
		116,
		107,
		102,
		129,
		-1,
		-1,
		91,
		107,
		120,
		124,
		140,
		165,
		-1,
		108,
		-1,
		-1,
		120,
		-1,
		-1,
		163,
		126,
		115,
		106,
		112,
		118,
		129,
		151,
		140,
		141,
		131,
		141,
		154,
		139,
		136,
		124,
		122,
		145,
		110,
		98,
		-1,
		106,
		94,
		100,
		107,
		124,
		154,
		-1,
		-1,
		124,
		115,
		-1,
		-1,
		139,
		146,
		148,
		-1,
		138,
		111,
		116,
		141,
		148,
		149,
		143,
		137,
		144,
		143,
		151,
		159,
		148,
		162,
		151,
		147,
		146,
		154,
		103,
		96,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		159,
		134,
		-1,
		-1,
		146,
		149,
		137,
		125,
		115,
		125,
		133,
		133,
		136,
		140,
		135,
		146,
		138,
		142,
		159,
		-1,
		182,
		-1,
		134,
		110,
		124,
		139,
		147,
		-1,
		-1,
		-1,
		176,
		162,
		155,
		143,
		141,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		169,
		137,
		142,
		137,
		141,
		152,
		141,
		144,
		158,
		153,
		-1,
		-1,
		122,
		125,
		-1,
		-1,
		147,
		166,
		-1,
		167,
		156,
		141,
		133,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		126,
		151,
		140,
		148,
		143,
		145,
		151,
		154,
		143,
		147,
		159,
		-1,
		-1,
		129,
		130,
		135,
		-1,
		156,
		-1,
		191,
		-1,
		136,
		152,
		154,
		-1,
		-1,
		-1,
		164,
		127,
		148,
		158,
		163,
		161,
		152,
		149,
		156,
		154,
		150,
		161,
		-1,
		-1,
		-1,
		186,
		163,
		198,
		189,
		172,
		152,
		144,
		169,
		-1,
		152,
		-1,
		127,
		128,
		155,
		157,
		174,
		168,
		152,
		167,
		157,
		148,
		157,
		192,
		-1,
		167,
		219,
		183,
		158,
		153,
		157,
		173,
		-1,
		149,
		131,
		-1,
		159,
		149,
		191,
		172,
		165,
		152,
		159,
		161,
		154,
		-1,
		-1,
		-1,
		182,
		181,
		179,
		173,
		173,
		158,
		149,
		-1,
		161,
		143,
		122,
		139,
		139,
		130,
		138,
		181,
		177,
		170,
		172,
		162,
		-1,
		254,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		182,
		177,
		150,
		138,
		144,
		140,
		126,
		132,
		134,
		142,
		140,
		137,
		149,
		145,
		165,
		161,
		193,
		-1,
		261,
		-1,
		212,
		-1,
		-1,
		200,
		180,
		172,
		161,
		150,
		148,
		139,
		130,
		152,
		168,
		152,
		150,
		155,
		160,
		-1,
		271,
		272,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		196,
		157,
		-1,
		159,
		139,
		-1,
		161,
		157,
		-1,
		-1,
		260,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		191,
		175,
		-1,
		150,
		150,
		-1,
		-1,
		-1,
		245,
		244,
		-1,
		213,
		216,
		-1,
		206,
		197,
		205,
		152,
		156,
		-1,
		-1,
		-1,
		254,
		235,
		229,
		228,
		226,
		221,
		218,
		204,
		188,
		166,
		155,
		176,
		-1,
		-1,
		-1,
		226,
		218,
		211,
		-1,
		-1,
		213,
		196,
		177,
		175,
		-1,
		-1,
		-1,
		248,
		229,
		-1,
		-1,
		203,
		-1,
		-1,
		209,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		237,
		-1,
		-1,
		-1,
		199,
		195,
		196,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		283,
		247,
		-1,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		219,
		203,
		-1,
		189,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		224,
		-1,
		224,
		199,
		206,
		-1,
		-1,
		-1,
		-1,
		237,
		229,
		237,
		-1,
		209,
		211,
		-1,
		259,
		-1,
		-1,
		252,
		243,
		-1,
		-1,
		214,
		221,
		243,
		246,
		282,
		-1,
		233
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		251,
		240,
		251,
		259,
		232,
		239,
		-1,
		258,
		262,
		228,
		222,
		261,
		230,
		236,
		247,
		-1,
		-1,
		-1,
		251,
		250,
		218,
		216,
		225,
		230,
		237,
		-1,
		236,
		-1,
		272,
		251,
		262,
		267,
		211,
		208,
		228,
		247,
		229,
		221,
		287,
		241,
		212,
		206,
		224,
		214,
		223,
		215,
		-1,
		212,
		202,
		224,
		203,
		214,
		206,
		-1,
		-1,
		206,
		207,
		213,
		199,
		205,
		201,
		-1,
		211,
		195,
		-1,
		-1,
		196,
		197,
		181,
		184,
		192,
		190,
		203,
		195,
		190,
		-1,
		-1,
		187,
		183,
		190,
		177,
		173,
		190,
		203,
		185,
		199,
		198,
		-1,
		193,
		211,
		216,
		184,
		182,
		166,
		164,
		182,
		184,
		190,
		190,
		-1,
		202,
		203,
		198,
		206,
		206,
		182,
		169,
		169,
		179,
		172,
		191,
		179,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		202,
		185,
		202,
		194,
		184,
		199,
		192,
		172,
		169,
		167,
		164,
		180,
		178,
		188,
		-1,
		-1,
		288,
		257,
		292,
		249,
		232,
		-1,
		198,
		178,
		184,
		188,
		182,
		175,
		189,
		185,
		-1,
		158,
		157,
		185,
		171,
		182,
		248,
		-1,
		-1,
		246,
		238,
		223,
		226,
		208,
		204,
		193,
		192,
		184,
		170,
		166,
		172,
		175,
		175,
		181,
		152,
		162,
		166,
		164,
		189,
		-1,
		-1,
		224,
		-1,
		-1,
		245,
		228,
		-1,
		211,
		218,
		214,
		220,
		206,
		227,
		203,
		194,
		186,
		180,
		168,
		170,
		167,
		180,
		168,
		149,
		174,
		178,
		159,
		180,
		175,
		-1,
		223,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		204,
		207,
		213,
		237,
		243,
		-1,
		215,
		203,
		204,
		189,
		186,
		173,
		161,
		174,
		159,
		166,
		165,
		153,
		151,
		181,
		156,
		178,
		175,
		194,
		199,
		193,
		202,
		-1,
		253,
		249,
		245,
		252,
		201,
		-1,
		-1,
		241,
		-1,
		251,
		252,
		227,
		200,
		203,
		190,
		181,
		168,
		157,
		168,
		157,
		154,
		162,
		145,
		160,
		151,
		150,
		168,
		178,
		186,
		190,
		196,
		-1,
		303,
		-1,
		245,
		229,
		231,
		203,
		224,
		-1,
		261,
		252,
		244,
		229,
		227,
		-1,
		199,
		196,
		186,
		164,
		149,
		166,
		158,
		156,
		158,
		140,
		154,
		145,
		163,
		170,
		168,
		172,
		192,
		204,
		263,
		253,
		-1,
		235,
		240,
		199,
		207,
		226,
		269,
		233,
		-1,
		228,
		-1,
		201,
		214,
		-1,
		170,
		166,
		148,
		149,
		144,
		159,
		151,
		136,
		133,
		151,
		154,
		161,
		165,
		181,
		-1,
		-1,
		248,
		252,
		241,
		192,
		211,
		235,
		272,
		226,
		215,
		214,
		-1,
		205,
		184,
		181,
		169,
		156,
		141,
		142,
		150,
		162,
		141,
		135,
		132,
		152,
		178,
		156,
		168,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		218,
		189,
		213,
		255,
		244,
		237,
		225,
		190,
		190,
		184,
		-1,
		180,
		159,
		150,
		139,
		137,
		150,
		142,
		150,
		130,
		128,
		147,
		159,
		150,
		161,
		-1,
		-1,
		-1,
		248,
		237,
		238,
		184,
		207,
		244,
		223,
		209,
		214,
		189,
		182,
		176,
		193,
		176,
		157,
		146,
		138,
		127,
		138,
		146,
		144,
		126,
		135,
		141,
		165,
		149,
		155,
		-1,
		-1,
		255,
		245,
		229,
		231,
		228,
		198,
		205,
		237,
		214,
		227,
		-1,
		181,
		-1,
		170,
		166,
		151,
		146,
		143,
		130,
		129,
		143,
		143,
		133,
		128,
		135,
		170,
		170,
		139,
		159,
		162,
		-1,
		-1,
		-1,
		248,
		243,
		218,
		195,
		179,
		215,
		-1,
		197,
		198,
		-1,
		175,
		169,
		166,
		153,
		149,
		134,
		138,
		140,
		143,
		131,
		137,
		138,
		120,
		144,
		-1,
		147,
		141,
		149,
		139,
		127,
		-1,
		-1,
		-1,
		241,
		220,
		213,
		233,
		174,
		226,
		-1,
		-1,
		182,
		175,
		-1,
		162,
		144,
		146,
		139,
		133,
		139,
		135,
		125,
		138,
		131,
		125,
		119,
		132,
		136,
		140,
		129,
		125,
		122,
		136,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		194,
		-1,
		191,
		183,
		173,
		167,
		161,
		157,
		155,
		161,
		145,
		148,
		143,
		139,
		130,
		120,
		113,
		124,
		109,
		127,
		135,
		127,
		121,
		120,
		132,
		-1,
		261,
		247,
		218,
		-1,
		-1,
		207,
		-1,
		171,
		190,
		206,
		-1,
		199,
		178,
		193,
		171,
		167,
		158,
		152,
		153,
		123,
		128,
		130,
		118,
		121,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		125,
		-1,
		267,
		254,
		212,
		208,
		197,
		217,
		168,
		161,
		193,
		-1,
		-1,
		207,
		-1,
		161,
		163,
		172,
		170,
		142,
		117,
		124,
		142,
		115,
		110,
		119,
		108,
		106,
		103,
		125,
		111,
		109,
		126,
		142,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		183,
		170,
		164,
		-1,
		210,
		-1,
		185,
		173,
		160,
		142,
		182,
		-1,
		116,
		112,
		119,
		-1,
		135,
		-1,
		107,
		110,
		101,
		98,
		97,
		108,
		106,
		117,
		121,
		-1,
		217,
		202,
		195,
		185,
		199,
		167,
		-1,
		201,
		-1,
		-1,
		172,
		166,
		166,
		135,
		132,
		132,
		112,
		104,
		119,
		118,
		105,
		104,
		92,
		92,
		95,
		98,
		111,
		121,
		124,
		119,
		-1,
		-1,
		-1,
		222,
		197,
		191,
		163,
		167,
		-1,
		-1,
		233,
		189,
		175,
		-1,
		127,
		132,
		120,
		110,
		100,
		105,
		106,
		96,
		94,
		90,
		99,
		103,
		100,
		99,
		120,
		113,
		135,
		-1,
		-1,
		196,
		189,
		177,
		145,
		140,
		-1,
		-1,
		-1,
		179,
		180,
		146,
		125,
		121,
		-1,
		-1,
		104,
		97,
		91,
		89,
		82,
		102,
		109,
		106,
		93,
		108,
		118,
		126,
		125,
		-1,
		199,
		186,
		-1,
		-1,
		139,
		129,
		-1,
		-1,
		-1,
		-1,
		158,
		103,
		92,
		87,
		91,
		103,
		-1,
		76,
		80,
		80,
		100,
		107,
		108,
		93,
		87,
		98,
		113,
		130,
		-1,
		-1,
		153,
		-1,
		115,
		-1,
		-1,
		-1,
		-1,
		115,
		109,
		80,
		73,
		77,
		-1,
		74,
		73,
		77,
		83,
		96,
		101,
		99,
		81,
		95,
		98,
		111,
		125,
		129,
		176,
		-1,
		106,
		-1,
		-1,
		-1,
		133,
		138,
		113,
		90,
		69,
		62,
		59,
		65,
		69,
		85,
		91,
		102,
		75,
		79,
		94,
		99,
		103,
		120,
		124,
		-1,
		-1,
		104,
		100,
		135,
		141,
		111,
		140,
		-1,
		-1,
		58,
		51,
		61,
		70,
		75,
		78,
		71,
		73,
		91,
		104,
		98,
		108,
		123,
		118,
		-1,
		-1,
		-1,
		116,
		-1,
		118,
		-1,
		-1,
		101,
		131,
		78,
		60,
		56,
		42,
		65,
		59,
		61,
		66,
		85,
		80,
		89,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		95,
		87,
		81,
		84,
		85,
		76,
		93,
		90,
		-1,
		38,
		81,
		56,
		70,
		66,
		73,
		78,
		84,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		191,
		180,
		169,
		175,
		-1,
		88,
		84,
		70,
		60,
		62,
		-1,
		-1,
		55,
		52,
		61,
		48,
		54,
		59,
		62,
		100,
		76,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		145,
		182,
		175,
		143,
		151,
		182,
		-1,
		78,
		70,
		80,
		56,
		53,
		-1,
		-1,
		28,
		30,
		35,
		44,
		47,
		83,
		82,
		95,
		98,
		103,
		91,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		138,
		158,
		137,
		140,
		164,
		178,
		-1,
		75,
		-1,
		-1,
		87,
		54,
		38,
		32,
		27,
		82,
		58,
		53,
		66,
		68,
		92,
		83,
		108,
		99,
		99,
		102,
		117,
		122,
		114,
		128,
		128,
		129,
		-1,
		127,
		138,
		131,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		103,
		-1,
		65,
		-1,
		0,
		29,
		66,
		69,
		91,
		78,
		85,
		102,
		108,
		97,
		107,
		103,
		104,
		113,
		124,
		136,
		135,
		136,
		152,
		108,
		111,
		122,
		133,
		148,
		152,
		-1,
		87,
		126,
		141,
		-1,
		112,
		-1,
		-1,
		-1,
		14,
		79,
		71,
		87,
		90,
		90,
		86,
		90,
		102,
		109,
		119,
		121,
		113,
		117,
		130,
		141,
		144,
		148,
		139,
		152,
		97,
		97,
		118,
		127,
		148,
		102,
		93,
		120,
		148,
		137,
		132,
		119,
		-1,
		-1,
		37,
		89,
		-1,
		-1,
		97,
		107,
		90,
		92,
		96,
		110,
		122,
		130,
		120,
		118,
		112,
		144,
		-1,
		141,
		140,
		129,
		126,
		102,
		93,
		88,
		115,
		-1,
		-1,
		105,
		121,
		121,
		125,
		141,
		166,
		-1,
		122,
		-1,
		-1,
		58,
		-1,
		-1,
		127,
		112,
		101,
		92,
		98,
		104,
		115,
		137,
		126,
		127,
		117,
		127,
		140,
		125,
		122,
		110,
		108,
		131,
		96,
		84,
		-1,
		97,
		95,
		101,
		108,
		125,
		155,
		-1,
		-1,
		138,
		129,
		-1,
		-1,
		77,
		84,
		112,
		-1,
		124,
		97,
		102,
		127,
		134,
		135,
		129,
		123,
		130,
		129,
		137,
		145,
		134,
		148,
		137,
		133,
		132,
		140,
		89,
		82,
		94,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		148,
		-1,
		-1,
		84,
		91,
		99,
		110,
		101,
		111,
		119,
		119,
		122,
		126,
		121,
		132,
		124,
		128,
		145,
		-1,
		168,
		-1,
		120,
		96,
		110,
		125,
		133,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		134,
		118,
		99,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		127,
		138,
		127,
		130,
		144,
		139,
		-1,
		-1,
		108,
		111,
		-1,
		-1,
		133,
		152,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		131,
		137,
		140,
		129,
		133,
		145,
		-1,
		-1,
		115,
		116,
		121,
		-1,
		142,
		-1,
		196,
		-1,
		150,
		166,
		157,
		-1,
		-1,
		-1,
		150,
		113,
		134,
		144,
		149,
		147,
		138,
		135,
		142,
		140,
		136,
		147,
		-1,
		-1,
		-1,
		172,
		149,
		203,
		194,
		177,
		157,
		149,
		168,
		-1,
		138,
		-1,
		113,
		114,
		141,
		143,
		160,
		154,
		138,
		153,
		143,
		134,
		143,
		178,
		-1,
		153,
		205,
		169,
		163,
		139,
		143,
		159,
		-1,
		135,
		117,
		-1,
		145,
		135,
		177,
		158,
		151,
		138,
		145,
		147,
		140,
		-1,
		-1,
		-1,
		168,
		167,
		165,
		159,
		159,
		144,
		135,
		-1,
		147,
		129,
		108,
		125,
		125,
		116,
		124,
		167,
		163,
		156,
		158,
		148,
		-1,
		240,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		168,
		163,
		136,
		124,
		130,
		126,
		112,
		118,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		147,
		179,
		-1,
		247,
		-1,
		198,
		-1,
		-1,
		186,
		166,
		158,
		147,
		136,
		134,
		125,
		116,
		138,
		154,
		138,
		136,
		141,
		146,
		-1,
		257,
		258,
		-1,
		205,
		197,
		183,
		-1,
		176,
		-1,
		182,
		143,
		-1,
		145,
		125,
		-1,
		147,
		143,
		-1,
		-1,
		246,
		221,
		-1,
		-1,
		-1,
		206,
		186,
		177,
		161,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		231,
		230,
		-1,
		199,
		202,
		-1,
		192,
		183,
		191,
		138,
		142,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		214,
		212,
		207,
		204,
		190,
		174,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		212,
		204,
		197,
		-1,
		-1,
		199,
		182,
		163,
		161,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		189,
		-1,
		-1,
		195,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		223,
		-1,
		-1,
		-1,
		185,
		181,
		182,
		-1,
		-1,
		-1,
		-1,
		245,
		246,
		269,
		233,
		-1,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		248,
		246,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		175,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		210,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		223,
		215,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		238,
		229,
		-1,
		-1,
		200,
		207,
		229,
		232,
		268,
		-1,
		219
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		259,
		263,
		229,
		223,
		262,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		252,
		251,
		219,
		217,
		226,
		231,
		238,
		-1,
		237,
		-1,
		273,
		252,
		263,
		268,
		212,
		209,
		229,
		248,
		230,
		222,
		288,
		242,
		213,
		207,
		225,
		215,
		224,
		216,
		-1,
		213,
		203,
		225,
		204,
		215,
		207,
		-1,
		-1,
		207,
		208,
		214,
		200,
		206,
		202,
		-1,
		212,
		196,
		-1,
		-1,
		197,
		198,
		182,
		185,
		193,
		191,
		204,
		196,
		191,
		-1,
		-1,
		188,
		184,
		191,
		178,
		174,
		191,
		204,
		186,
		200,
		199,
		-1,
		194,
		212,
		217,
		185,
		183,
		167,
		165,
		183,
		185,
		191,
		191,
		-1,
		203,
		204,
		199,
		207,
		207,
		183,
		170,
		170,
		180,
		173,
		192,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		203,
		186,
		203,
		195,
		185,
		200,
		193,
		173,
		170,
		168,
		165,
		181,
		179,
		189,
		-1,
		-1,
		289,
		258,
		293,
		250,
		233,
		-1,
		199,
		179,
		185,
		189,
		183,
		176,
		190,
		186,
		-1,
		159,
		158,
		186,
		172,
		183,
		249,
		-1,
		-1,
		247,
		239,
		224,
		227,
		209,
		205,
		194,
		193,
		185,
		171,
		167,
		173,
		176,
		176,
		182,
		153,
		163,
		167,
		165,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		246,
		229,
		-1,
		212,
		219,
		215,
		221,
		207,
		228,
		204,
		195,
		187,
		181,
		169,
		171,
		168,
		181,
		169,
		150,
		175,
		179,
		160,
		181,
		176,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		205,
		208,
		214,
		238,
		244,
		-1,
		216,
		204,
		205,
		190,
		187,
		174,
		162,
		175,
		160,
		167,
		166,
		154,
		152,
		182,
		157,
		179,
		176,
		195,
		200,
		194,
		203,
		-1,
		254,
		250,
		246,
		253,
		202,
		-1,
		-1,
		242,
		-1,
		252,
		253,
		228,
		201,
		204,
		191,
		182,
		169,
		158,
		169,
		158,
		155,
		163,
		146,
		161,
		152,
		151,
		169,
		179,
		187,
		191,
		197,
		-1,
		304,
		-1,
		246,
		230,
		232,
		204,
		225,
		-1,
		262,
		253,
		245,
		230,
		228,
		-1,
		200,
		197,
		187,
		165,
		150,
		167,
		159,
		157,
		159,
		141,
		155,
		146,
		164,
		171,
		169,
		173,
		193,
		205,
		264,
		254,
		-1,
		236,
		241,
		200,
		208,
		227,
		270,
		234,
		-1,
		229,
		-1,
		202,
		215,
		-1,
		171,
		167,
		149,
		150,
		145,
		160,
		152,
		137,
		134,
		152,
		155,
		162,
		166,
		182,
		-1,
		-1,
		249,
		253,
		242,
		193,
		212,
		236,
		273,
		227,
		216,
		215,
		-1,
		206,
		185,
		182,
		170,
		157,
		142,
		143,
		151,
		163,
		142,
		136,
		133,
		153,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		219,
		190,
		214,
		256,
		245,
		238,
		226,
		191,
		191,
		185,
		-1,
		181,
		160,
		151,
		140,
		138,
		151,
		143,
		151,
		131,
		129,
		148,
		160,
		151,
		162,
		-1,
		-1,
		-1,
		249,
		238,
		239,
		185,
		208,
		245,
		224,
		210,
		215,
		190,
		183,
		177,
		194,
		177,
		158,
		147,
		139,
		128,
		139,
		147,
		145,
		127,
		136,
		142,
		166,
		150,
		156,
		-1,
		-1,
		256,
		246,
		230,
		232,
		229,
		199,
		206,
		238,
		215,
		228,
		-1,
		182,
		-1,
		171,
		167,
		152,
		147,
		144,
		131,
		130,
		144,
		144,
		134,
		129,
		136,
		171,
		171,
		140,
		160,
		163,
		-1,
		-1,
		-1,
		249,
		244,
		219,
		196,
		180,
		216,
		-1,
		198,
		199,
		-1,
		176,
		170,
		167,
		154,
		150,
		135,
		139,
		141,
		144,
		132,
		138,
		139,
		121,
		145,
		-1,
		148,
		142,
		150,
		140,
		128,
		-1,
		-1,
		-1,
		242,
		221,
		214,
		234,
		175,
		227,
		-1,
		-1,
		183,
		176,
		-1,
		163,
		145,
		147,
		140,
		134,
		140,
		136,
		126,
		139,
		132,
		126,
		120,
		133,
		137,
		141,
		130,
		126,
		123,
		137,
		-1,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		195,
		-1,
		192,
		184,
		174,
		168,
		162,
		158,
		156,
		162,
		146,
		149,
		144,
		140,
		131,
		121,
		114,
		125,
		110,
		128,
		136,
		128,
		122,
		121,
		133,
		-1,
		262,
		248,
		219,
		-1,
		-1,
		208,
		-1,
		172,
		191,
		207,
		-1,
		200,
		179,
		194,
		172,
		168,
		159,
		153,
		154,
		124,
		129,
		131,
		119,
		122,
		115,
		118,
		110,
		132,
		132,
		116,
		117,
		126,
		-1,
		268,
		255,
		213,
		209,
		198,
		218,
		169,
		162,
		194,
		-1,
		-1,
		208,
		-1,
		162,
		164,
		173,
		171,
		143,
		118,
		125,
		143,
		116,
		111,
		120,
		109,
		107,
		104,
		126,
		112,
		110,
		127,
		143,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		184,
		171,
		165,
		-1,
		211,
		-1,
		186,
		174,
		161,
		143,
		183,
		-1,
		117,
		113,
		120,
		-1,
		136,
		-1,
		108,
		111,
		102,
		99,
		98,
		109,
		107,
		118,
		122,
		-1,
		218,
		203,
		196,
		186,
		200,
		168,
		-1,
		202,
		-1,
		-1,
		173,
		167,
		167,
		136,
		133,
		133,
		113,
		105,
		120,
		119,
		106,
		105,
		93,
		93,
		96,
		99,
		112,
		122,
		125,
		120,
		-1,
		-1,
		-1,
		223,
		198,
		192,
		164,
		168,
		-1,
		-1,
		234,
		190,
		176,
		-1,
		128,
		133,
		121,
		111,
		101,
		106,
		107,
		97,
		95,
		91,
		100,
		104,
		101,
		100,
		121,
		114,
		136,
		-1,
		-1,
		197,
		190,
		178,
		146,
		141,
		-1,
		-1,
		-1,
		180,
		181,
		147,
		126,
		122,
		-1,
		-1,
		105,
		98,
		92,
		90,
		83,
		103,
		110,
		107,
		94,
		109,
		119,
		127,
		126,
		-1,
		200,
		187,
		-1,
		-1,
		140,
		130,
		-1,
		-1,
		-1,
		-1,
		159,
		104,
		93,
		88,
		92,
		104,
		-1,
		77,
		81,
		81,
		101,
		108,
		109,
		94,
		88,
		99,
		114,
		131,
		-1,
		-1,
		154,
		-1,
		116,
		-1,
		-1,
		-1,
		-1,
		116,
		110,
		81,
		74,
		78,
		-1,
		75,
		74,
		78,
		84,
		97,
		102,
		100,
		82,
		96,
		99,
		112,
		126,
		130,
		177,
		-1,
		107,
		-1,
		-1,
		-1,
		134,
		139,
		114,
		91,
		70,
		63,
		60,
		66,
		70,
		86,
		92,
		103,
		76,
		80,
		95,
		100,
		104,
		121,
		125,
		-1,
		-1,
		105,
		101,
		136,
		142,
		112,
		141,
		-1,
		-1,
		59,
		52,
		62,
		71,
		76,
		79,
		72,
		74,
		92,
		105,
		99,
		109,
		124,
		119,
		-1,
		-1,
		-1,
		117,
		-1,
		119,
		-1,
		-1,
		102,
		132,
		79,
		61,
		57,
		43,
		66,
		60,
		62,
		67,
		86,
		81,
		90,
		95,
		99,
		122,
		111,
		150,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		96,
		88,
		82,
		85,
		86,
		77,
		94,
		91,
		-1,
		39,
		82,
		57,
		71,
		67,
		74,
		79,
		85,
		89,
		96,
		112,
		111,
		106,
		142,
		133,
		139,
		-1,
		-1,
		192,
		181,
		170,
		176,
		-1,
		89,
		85,
		71,
		61,
		63,
		-1,
		-1,
		56,
		53,
		62,
		49,
		55,
		60,
		63,
		101,
		77,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		130,
		145,
		-1,
		146,
		183,
		176,
		144,
		152,
		183,
		-1,
		79,
		71,
		81,
		57,
		54,
		-1,
		-1,
		29,
		31,
		36,
		45,
		48,
		84,
		83,
		96,
		99,
		104,
		92,
		91,
		109,
		113,
		122,
		129,
		119,
		132,
		136,
		-1,
		139,
		159,
		138,
		141,
		165,
		179,
		-1,
		76,
		-1,
		-1,
		88,
		55,
		39,
		33,
		28,
		83,
		59,
		54,
		67,
		69,
		93,
		84,
		109,
		100,
		100,
		103,
		118,
		123,
		115,
		129,
		129,
		130,
		-1,
		128,
		139,
		132,
		-1,
		-1,
		-1,
		-1,
		77,
		-1,
		-1,
		104,
		-1,
		66,
		-1,
		26,
		0,
		67,
		70,
		92,
		79,
		86,
		103,
		109,
		98,
		108,
		104,
		105,
		114,
		125,
		137,
		136,
		137,
		153,
		109,
		112,
		123,
		134,
		149,
		153,
		-1,
		88,
		127,
		142,
		-1,
		113,
		-1,
		-1,
		-1,
		40,
		80,
		72,
		88,
		91,
		91,
		87,
		91,
		103,
		110,
		120,
		122,
		114,
		118,
		131,
		142,
		145,
		149,
		140,
		153,
		98,
		98,
		119,
		128,
		149,
		103,
		94,
		121,
		149,
		138,
		133,
		120,
		-1,
		-1,
		63,
		90,
		-1,
		-1,
		98,
		108,
		91,
		93,
		97,
		111,
		123,
		131,
		121,
		119,
		113,
		145,
		-1,
		142,
		141,
		130,
		127,
		103,
		94,
		89,
		116,
		-1,
		-1,
		106,
		122,
		122,
		126,
		142,
		167,
		-1,
		123,
		-1,
		-1,
		84,
		-1,
		-1,
		150,
		113,
		102,
		93,
		99,
		105,
		116,
		138,
		127,
		128,
		118,
		128,
		141,
		126,
		123,
		111,
		109,
		132,
		97,
		85,
		-1,
		98,
		96,
		102,
		109,
		126,
		156,
		-1,
		-1,
		139,
		130,
		-1,
		-1,
		103,
		110,
		135,
		-1,
		125,
		98,
		103,
		128,
		135,
		136,
		130,
		124,
		131,
		130,
		138,
		146,
		135,
		149,
		138,
		134,
		133,
		141,
		90,
		83,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		149,
		-1,
		-1,
		110,
		117,
		124,
		112,
		102,
		112,
		120,
		120,
		123,
		127,
		122,
		133,
		125,
		129,
		146,
		-1,
		169,
		-1,
		121,
		97,
		111,
		126,
		134,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		160,
		144,
		125,
		-1,
		112,
		125,
		156,
		124,
		129,
		124,
		128,
		139,
		128,
		131,
		145,
		140,
		-1,
		-1,
		109,
		112,
		-1,
		-1,
		134,
		153,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		113,
		138,
		127,
		135,
		130,
		132,
		138,
		141,
		130,
		134,
		146,
		-1,
		-1,
		116,
		117,
		122,
		-1,
		143,
		-1,
		197,
		-1,
		151,
		167,
		158,
		-1,
		-1,
		-1,
		151,
		114,
		135,
		145,
		150,
		148,
		139,
		136,
		143,
		141,
		137,
		148,
		-1,
		-1,
		-1,
		173,
		150,
		204,
		195,
		178,
		158,
		150,
		169,
		-1,
		139,
		-1,
		114,
		115,
		142,
		144,
		161,
		155,
		139,
		154,
		144,
		135,
		144,
		179,
		-1,
		154,
		206,
		170,
		164,
		140,
		144,
		160,
		-1,
		136,
		118,
		-1,
		146,
		136,
		178,
		159,
		152,
		139,
		146,
		148,
		141,
		-1,
		-1,
		-1,
		169,
		168,
		166,
		160,
		160,
		145,
		136,
		-1,
		148,
		130,
		109,
		126,
		126,
		117,
		125,
		168,
		164,
		157,
		159,
		149,
		-1,
		241,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		169,
		164,
		137,
		125,
		131,
		127,
		113,
		119,
		121,
		129,
		127,
		124,
		136,
		132,
		152,
		148,
		180,
		-1,
		248,
		-1,
		199,
		-1,
		-1,
		187,
		167,
		159,
		148,
		137,
		135,
		126,
		117,
		139,
		155,
		139,
		137,
		142,
		147,
		-1,
		258,
		259,
		-1,
		206,
		198,
		184,
		-1,
		177,
		-1,
		183,
		144,
		-1,
		146,
		126,
		-1,
		148,
		144,
		-1,
		-1,
		247,
		222,
		-1,
		-1,
		-1,
		207,
		187,
		178,
		162,
		-1,
		137,
		137,
		-1,
		-1,
		-1,
		232,
		231,
		-1,
		200,
		203,
		-1,
		193,
		184,
		192,
		139,
		143,
		-1,
		-1,
		-1,
		241,
		222,
		216,
		215,
		213,
		208,
		205,
		191,
		175,
		153,
		142,
		163,
		-1,
		-1,
		-1,
		213,
		205,
		198,
		-1,
		-1,
		200,
		183,
		164,
		162,
		-1,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		190,
		-1,
		-1,
		196,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		224,
		-1,
		-1,
		-1,
		186,
		182,
		183,
		-1,
		-1,
		-1,
		-1,
		246,
		247,
		270,
		234,
		-1,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		249,
		247,
		-1,
		-1,
		-1,
		206,
		190,
		-1,
		176,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		211,
		-1,
		211,
		186,
		193,
		-1,
		-1,
		-1,
		-1,
		224,
		216,
		224,
		-1,
		196,
		198,
		-1,
		246,
		-1,
		-1,
		239,
		230,
		-1,
		-1,
		201,
		208,
		230,
		233,
		269,
		-1,
		220
	],
	[
		-1,
		242,
		231,
		242,
		250,
		223,
		230,
		-1,
		249,
		253,
		219,
		213,
		252,
		221,
		227,
		238,
		-1,
		-1,
		-1,
		242,
		241,
		209,
		207,
		216,
		221,
		228,
		-1,
		227,
		-1,
		263,
		242,
		253,
		258,
		202,
		199,
		219,
		238,
		220,
		212,
		278,
		232,
		203,
		197,
		215,
		205,
		214,
		206,
		-1,
		203,
		193,
		215,
		194,
		205,
		197,
		-1,
		-1,
		197,
		198,
		204,
		190,
		196,
		192,
		-1,
		202,
		186,
		-1,
		-1,
		187,
		188,
		172,
		175,
		183,
		181,
		194,
		186,
		181,
		-1,
		-1,
		178,
		174,
		181,
		168,
		164,
		181,
		194,
		176,
		190,
		189,
		-1,
		184,
		202,
		207,
		175,
		173,
		157,
		155,
		173,
		175,
		181,
		181,
		-1,
		193,
		194,
		189,
		197,
		197,
		173,
		160,
		160,
		170,
		163,
		182,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		193,
		176,
		193,
		185,
		175,
		190,
		183,
		163,
		160,
		158,
		155,
		171,
		169,
		179,
		-1,
		-1,
		284,
		253,
		284,
		242,
		223,
		-1,
		189,
		169,
		175,
		179,
		173,
		166,
		180,
		176,
		-1,
		149,
		148,
		176,
		162,
		173,
		244,
		-1,
		-1,
		242,
		234,
		219,
		222,
		199,
		195,
		184,
		183,
		175,
		161,
		157,
		163,
		166,
		166,
		172,
		143,
		153,
		157,
		155,
		180,
		-1,
		-1,
		215,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		205,
		211,
		197,
		218,
		194,
		185,
		177,
		171,
		159,
		161,
		158,
		171,
		159,
		140,
		165,
		169,
		150,
		171,
		166,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		234,
		-1,
		206,
		194,
		195,
		180,
		177,
		164,
		152,
		165,
		150,
		157,
		156,
		144,
		142,
		172,
		147,
		169,
		166,
		185,
		190,
		184,
		193,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		242,
		243,
		218,
		191,
		194,
		181,
		172,
		159,
		148,
		159,
		148,
		145,
		153,
		136,
		151,
		142,
		141,
		159,
		169,
		177,
		181,
		187,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		243,
		235,
		220,
		218,
		-1,
		190,
		187,
		177,
		155,
		140,
		157,
		149,
		147,
		149,
		131,
		145,
		136,
		154,
		161,
		159,
		163,
		183,
		195,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		260,
		224,
		-1,
		219,
		-1,
		192,
		205,
		-1,
		161,
		157,
		139,
		140,
		135,
		150,
		142,
		127,
		124,
		142,
		145,
		152,
		156,
		172,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		217,
		206,
		205,
		-1,
		196,
		175,
		172,
		160,
		147,
		132,
		133,
		141,
		153,
		132,
		126,
		123,
		143,
		169,
		147,
		158,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		235,
		228,
		216,
		181,
		181,
		175,
		-1,
		171,
		150,
		141,
		130,
		128,
		141,
		133,
		141,
		121,
		119,
		138,
		150,
		141,
		149,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		180,
		203,
		240,
		214,
		200,
		205,
		180,
		173,
		167,
		184,
		167,
		148,
		137,
		129,
		118,
		129,
		137,
		135,
		117,
		126,
		132,
		156,
		137,
		143,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		194,
		201,
		233,
		205,
		218,
		-1,
		172,
		-1,
		161,
		157,
		142,
		137,
		134,
		121,
		120,
		134,
		134,
		124,
		119,
		126,
		161,
		161,
		127,
		147,
		150,
		-1,
		-1,
		-1,
		244,
		239,
		214,
		191,
		175,
		211,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		144,
		140,
		125,
		129,
		131,
		134,
		122,
		128,
		129,
		111,
		135,
		-1,
		135,
		129,
		137,
		127,
		115,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		137,
		132,
		128,
		130,
		127,
		116,
		129,
		122,
		116,
		110,
		123,
		127,
		128,
		117,
		113,
		110,
		124,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		156,
		140,
		142,
		138,
		130,
		125,
		111,
		104,
		115,
		100,
		118,
		124,
		115,
		110,
		109,
		120,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		190,
		169,
		184,
		162,
		158,
		149,
		147,
		148,
		118,
		123,
		125,
		113,
		116,
		105,
		108,
		100,
		122,
		119,
		103,
		105,
		114,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		152,
		184,
		-1,
		-1,
		216,
		-1,
		160,
		172,
		163,
		161,
		137,
		112,
		119,
		137,
		110,
		105,
		110,
		99,
		99,
		94,
		113,
		99,
		97,
		112,
		128,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		194,
		182,
		169,
		151,
		191,
		-1,
		111,
		107,
		114,
		-1,
		130,
		-1,
		102,
		105,
		96,
		91,
		88,
		99,
		97,
		106,
		107,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		214,
		-1,
		-1,
		181,
		175,
		175,
		144,
		141,
		127,
		107,
		99,
		114,
		113,
		100,
		99,
		87,
		87,
		90,
		84,
		97,
		107,
		113,
		105,
		-1,
		-1,
		-1,
		218,
		204,
		204,
		168,
		180,
		-1,
		-1,
		242,
		198,
		184,
		-1,
		136,
		127,
		115,
		105,
		95,
		100,
		101,
		91,
		89,
		85,
		94,
		93,
		86,
		85,
		106,
		99,
		121,
		-1,
		-1,
		201,
		202,
		190,
		158,
		153,
		-1,
		-1,
		-1,
		188,
		189,
		155,
		134,
		116,
		-1,
		-1,
		99,
		92,
		86,
		89,
		77,
		97,
		104,
		92,
		79,
		94,
		104,
		112,
		111,
		-1,
		204,
		191,
		-1,
		-1,
		152,
		142,
		-1,
		-1,
		-1,
		-1,
		167,
		112,
		101,
		96,
		100,
		98,
		-1,
		72,
		83,
		76,
		95,
		102,
		94,
		79,
		73,
		84,
		99,
		116,
		-1,
		-1,
		166,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		124,
		118,
		89,
		82,
		86,
		-1,
		74,
		76,
		73,
		85,
		90,
		94,
		85,
		67,
		81,
		84,
		97,
		111,
		115,
		189,
		-1,
		119,
		-1,
		-1,
		-1,
		142,
		156,
		128,
		105,
		78,
		73,
		66,
		60,
		65,
		76,
		85,
		96,
		61,
		65,
		80,
		85,
		89,
		106,
		110,
		-1,
		-1,
		117,
		113,
		148,
		150,
		129,
		155,
		-1,
		-1,
		75,
		68,
		64,
		56,
		69,
		72,
		57,
		59,
		77,
		90,
		84,
		94,
		109,
		104,
		-1,
		-1,
		-1,
		129,
		-1,
		131,
		-1,
		-1,
		119,
		148,
		95,
		77,
		73,
		59,
		51,
		45,
		47,
		52,
		71,
		66,
		75,
		80,
		84,
		107,
		96,
		135,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		108,
		100,
		95,
		101,
		103,
		94,
		110,
		107,
		-1,
		56,
		74,
		42,
		56,
		52,
		59,
		64,
		70,
		74,
		81,
		97,
		96,
		91,
		127,
		118,
		124,
		-1,
		-1,
		199,
		188,
		177,
		183,
		-1,
		101,
		97,
		87,
		77,
		80,
		-1,
		-1,
		74,
		71,
		47,
		34,
		40,
		45,
		48,
		86,
		62,
		70,
		74,
		78,
		84,
		89,
		94,
		100,
		115,
		130,
		-1,
		153,
		190,
		183,
		151,
		159,
		190,
		-1,
		91,
		83,
		94,
		69,
		71,
		-1,
		-1,
		47,
		38,
		38,
		26,
		29,
		57,
		68,
		73,
		84,
		89,
		77,
		76,
		94,
		98,
		107,
		114,
		104,
		117,
		121,
		-1,
		146,
		166,
		145,
		148,
		172,
		186,
		-1,
		88,
		-1,
		-1,
		100,
		72,
		56,
		46,
		43,
		85,
		22,
		15,
		42,
		44,
		70,
		61,
		94,
		85,
		85,
		88,
		103,
		108,
		100,
		114,
		114,
		115,
		-1,
		135,
		146,
		139,
		-1,
		-1,
		-1,
		-1,
		89,
		-1,
		-1,
		116,
		-1,
		83,
		-1,
		66,
		70,
		0,
		33,
		69,
		56,
		63,
		80,
		86,
		83,
		91,
		89,
		90,
		99,
		110,
		122,
		121,
		122,
		160,
		116,
		119,
		130,
		141,
		156,
		160,
		-1,
		100,
		139,
		154,
		-1,
		125,
		-1,
		-1,
		-1,
		80,
		13,
		5,
		51,
		66,
		68,
		64,
		68,
		81,
		88,
		98,
		107,
		99,
		103,
		116,
		127,
		130,
		156,
		147,
		160,
		105,
		105,
		126,
		135,
		156,
		115,
		106,
		133,
		159,
		150,
		145,
		132,
		-1,
		-1,
		103,
		23,
		-1,
		-1,
		67,
		85,
		68,
		70,
		74,
		88,
		100,
		113,
		106,
		104,
		98,
		130,
		-1,
		149,
		148,
		137,
		134,
		110,
		101,
		96,
		123,
		-1,
		-1,
		118,
		134,
		129,
		133,
		149,
		174,
		-1,
		135,
		-1,
		-1,
		124,
		-1,
		-1,
		127,
		90,
		79,
		70,
		76,
		82,
		93,
		115,
		112,
		113,
		103,
		113,
		126,
		133,
		130,
		118,
		116,
		139,
		104,
		92,
		-1,
		105,
		103,
		109,
		116,
		133,
		163,
		-1,
		-1,
		151,
		142,
		-1,
		-1,
		125,
		123,
		112,
		-1,
		102,
		75,
		80,
		105,
		112,
		114,
		115,
		109,
		116,
		115,
		123,
		131,
		142,
		156,
		145,
		141,
		140,
		148,
		97,
		90,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		172,
		161,
		-1,
		-1,
		120,
		113,
		101,
		89,
		79,
		89,
		97,
		97,
		100,
		105,
		107,
		118,
		110,
		114,
		131,
		-1,
		176,
		-1,
		128,
		104,
		118,
		133,
		141,
		-1,
		-1,
		-1,
		189,
		175,
		168,
		156,
		154,
		-1,
		154,
		138,
		119,
		-1,
		89,
		102,
		133,
		101,
		106,
		101,
		113,
		124,
		113,
		116,
		130,
		125,
		-1,
		-1,
		116,
		119,
		-1,
		-1,
		141,
		160,
		-1,
		180,
		169,
		154,
		146,
		-1,
		-1,
		126,
		122,
		-1,
		-1,
		90,
		115,
		104,
		112,
		107,
		117,
		123,
		126,
		115,
		119,
		131,
		-1,
		-1,
		123,
		124,
		129,
		-1,
		150,
		-1,
		182,
		-1,
		149,
		155,
		143,
		-1,
		-1,
		-1,
		128,
		91,
		112,
		122,
		127,
		125,
		116,
		115,
		122,
		126,
		122,
		133,
		-1,
		-1,
		-1,
		180,
		156,
		189,
		180,
		163,
		143,
		135,
		154,
		-1,
		124,
		-1,
		95,
		92,
		127,
		121,
		138,
		132,
		118,
		133,
		129,
		120,
		129,
		186,
		-1,
		158,
		191,
		155,
		149,
		125,
		129,
		145,
		-1,
		121,
		103,
		-1,
		131,
		121,
		155,
		141,
		129,
		116,
		123,
		133,
		126,
		-1,
		-1,
		-1,
		160,
		159,
		151,
		145,
		145,
		130,
		121,
		-1,
		133,
		115,
		94,
		111,
		111,
		102,
		110,
		145,
		141,
		134,
		136,
		128,
		-1,
		248,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		154,
		149,
		122,
		110,
		116,
		112,
		98,
		104,
		106,
		114,
		112,
		109,
		121,
		117,
		137,
		129,
		165,
		-1,
		255,
		-1,
		190,
		-1,
		-1,
		172,
		152,
		144,
		133,
		122,
		120,
		111,
		102,
		124,
		140,
		124,
		122,
		127,
		132,
		-1,
		245,
		244,
		-1,
		191,
		183,
		169,
		-1,
		162,
		-1,
		168,
		129,
		-1,
		131,
		111,
		-1,
		133,
		129,
		-1,
		-1,
		232,
		207,
		-1,
		-1,
		-1,
		192,
		172,
		163,
		147,
		-1,
		122,
		122,
		-1,
		-1,
		-1,
		217,
		216,
		-1,
		185,
		188,
		-1,
		178,
		169,
		177,
		124,
		128,
		-1,
		-1,
		-1,
		226,
		207,
		201,
		200,
		198,
		193,
		190,
		176,
		160,
		138,
		127,
		148,
		-1,
		-1,
		-1,
		198,
		190,
		183,
		-1,
		-1,
		185,
		168,
		149,
		147,
		-1,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		175,
		-1,
		-1,
		181,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		209,
		-1,
		-1,
		-1,
		171,
		167,
		168,
		-1,
		-1,
		-1,
		-1,
		231,
		232,
		255,
		219,
		-1,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		234,
		232,
		-1,
		-1,
		-1,
		191,
		175,
		-1,
		161,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		196,
		-1,
		196,
		171,
		178,
		-1,
		-1,
		-1,
		-1,
		209,
		201,
		209,
		-1,
		181,
		183,
		-1,
		231,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		186,
		193,
		215,
		218,
		254,
		-1,
		205
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		248,
		252,
		218,
		212,
		251,
		220,
		226,
		237,
		-1,
		-1,
		-1,
		241,
		240,
		208,
		206,
		215,
		220,
		227,
		-1,
		226,
		-1,
		262,
		241,
		252,
		257,
		201,
		198,
		218,
		237,
		219,
		211,
		277,
		231,
		202,
		196,
		214,
		204,
		213,
		205,
		-1,
		202,
		192,
		214,
		193,
		204,
		196,
		-1,
		-1,
		196,
		197,
		203,
		189,
		195,
		191,
		-1,
		201,
		185,
		-1,
		-1,
		186,
		187,
		171,
		174,
		182,
		180,
		193,
		185,
		180,
		-1,
		-1,
		177,
		173,
		180,
		167,
		163,
		180,
		193,
		175,
		189,
		188,
		-1,
		183,
		201,
		206,
		174,
		172,
		156,
		154,
		172,
		174,
		180,
		180,
		-1,
		192,
		193,
		188,
		196,
		196,
		172,
		159,
		159,
		169,
		162,
		181,
		169,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		162,
		159,
		157,
		154,
		170,
		168,
		178,
		-1,
		-1,
		283,
		252,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		148,
		147,
		175,
		161,
		172,
		243,
		-1,
		-1,
		241,
		233,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		142,
		152,
		156,
		154,
		179,
		-1,
		-1,
		214,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		139,
		164,
		168,
		149,
		170,
		165,
		-1,
		213,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		143,
		141,
		171,
		146,
		168,
		165,
		184,
		189,
		183,
		192,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		135,
		150,
		141,
		140,
		158,
		168,
		176,
		180,
		186,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		242,
		234,
		219,
		217,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		148,
		130,
		144,
		135,
		153,
		160,
		158,
		162,
		182,
		194,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		259,
		223,
		-1,
		218,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		141,
		126,
		123,
		141,
		144,
		151,
		155,
		171,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		216,
		205,
		204,
		-1,
		195,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		152,
		131,
		125,
		122,
		142,
		168,
		146,
		157,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		234,
		227,
		215,
		180,
		180,
		174,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		132,
		140,
		120,
		118,
		137,
		149,
		140,
		148,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		179,
		202,
		239,
		213,
		199,
		204,
		179,
		172,
		166,
		183,
		166,
		147,
		136,
		128,
		117,
		128,
		136,
		134,
		116,
		125,
		131,
		155,
		136,
		142,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		193,
		200,
		232,
		204,
		217,
		-1,
		171,
		-1,
		160,
		156,
		141,
		136,
		133,
		120,
		119,
		133,
		133,
		123,
		118,
		125,
		160,
		160,
		126,
		146,
		149,
		-1,
		-1,
		-1,
		243,
		238,
		213,
		190,
		174,
		210,
		-1,
		187,
		188,
		-1,
		165,
		159,
		156,
		143,
		139,
		124,
		128,
		130,
		133,
		121,
		127,
		128,
		110,
		134,
		-1,
		134,
		128,
		136,
		126,
		114,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		172,
		165,
		-1,
		152,
		134,
		136,
		131,
		127,
		129,
		126,
		115,
		128,
		121,
		115,
		109,
		122,
		126,
		127,
		116,
		112,
		109,
		123,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		181,
		173,
		163,
		157,
		151,
		147,
		145,
		155,
		139,
		141,
		137,
		129,
		124,
		110,
		103,
		114,
		99,
		117,
		123,
		114,
		109,
		108,
		119,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		180,
		196,
		-1,
		189,
		168,
		183,
		161,
		157,
		148,
		146,
		147,
		117,
		122,
		124,
		112,
		115,
		104,
		107,
		99,
		121,
		118,
		102,
		104,
		113,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		151,
		183,
		-1,
		-1,
		215,
		-1,
		159,
		171,
		162,
		160,
		136,
		111,
		118,
		136,
		109,
		104,
		109,
		98,
		98,
		93,
		112,
		98,
		96,
		111,
		127,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		193,
		181,
		168,
		150,
		190,
		-1,
		110,
		106,
		113,
		-1,
		129,
		-1,
		101,
		104,
		95,
		90,
		87,
		98,
		96,
		105,
		106,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		213,
		-1,
		-1,
		180,
		174,
		174,
		143,
		140,
		126,
		106,
		98,
		113,
		112,
		99,
		98,
		86,
		86,
		89,
		83,
		96,
		106,
		112,
		104,
		-1,
		-1,
		-1,
		217,
		203,
		203,
		167,
		179,
		-1,
		-1,
		241,
		197,
		183,
		-1,
		135,
		126,
		114,
		104,
		94,
		99,
		100,
		90,
		88,
		84,
		93,
		92,
		85,
		84,
		105,
		98,
		120,
		-1,
		-1,
		200,
		201,
		189,
		157,
		152,
		-1,
		-1,
		-1,
		187,
		188,
		154,
		133,
		115,
		-1,
		-1,
		98,
		91,
		85,
		88,
		76,
		96,
		103,
		91,
		78,
		93,
		103,
		111,
		110,
		-1,
		203,
		190,
		-1,
		-1,
		151,
		141,
		-1,
		-1,
		-1,
		-1,
		166,
		111,
		100,
		95,
		99,
		97,
		-1,
		71,
		82,
		75,
		94,
		101,
		93,
		78,
		72,
		83,
		98,
		115,
		-1,
		-1,
		165,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		88,
		81,
		85,
		-1,
		73,
		75,
		72,
		84,
		89,
		93,
		84,
		66,
		80,
		83,
		96,
		110,
		114,
		188,
		-1,
		118,
		-1,
		-1,
		-1,
		141,
		155,
		127,
		104,
		77,
		72,
		65,
		59,
		64,
		75,
		84,
		95,
		60,
		64,
		79,
		84,
		88,
		105,
		109,
		-1,
		-1,
		116,
		112,
		147,
		149,
		128,
		154,
		-1,
		-1,
		74,
		67,
		63,
		55,
		68,
		71,
		56,
		58,
		76,
		89,
		83,
		93,
		108,
		103,
		-1,
		-1,
		-1,
		128,
		-1,
		130,
		-1,
		-1,
		118,
		147,
		94,
		76,
		72,
		58,
		50,
		44,
		46,
		51,
		70,
		65,
		74,
		79,
		83,
		106,
		95,
		134,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		107,
		99,
		94,
		100,
		102,
		93,
		109,
		106,
		-1,
		55,
		73,
		41,
		55,
		51,
		58,
		63,
		69,
		73,
		80,
		96,
		95,
		90,
		126,
		117,
		123,
		-1,
		-1,
		198,
		187,
		176,
		182,
		-1,
		100,
		96,
		86,
		76,
		79,
		-1,
		-1,
		73,
		70,
		46,
		33,
		39,
		44,
		47,
		85,
		61,
		69,
		73,
		77,
		83,
		88,
		93,
		99,
		114,
		129,
		-1,
		152,
		189,
		182,
		150,
		158,
		189,
		-1,
		90,
		82,
		93,
		68,
		70,
		-1,
		-1,
		46,
		37,
		37,
		25,
		28,
		56,
		67,
		72,
		83,
		88,
		76,
		75,
		93,
		97,
		106,
		113,
		103,
		116,
		120,
		-1,
		145,
		165,
		144,
		147,
		171,
		185,
		-1,
		87,
		-1,
		-1,
		99,
		71,
		55,
		45,
		42,
		84,
		11,
		16,
		41,
		43,
		69,
		60,
		93,
		84,
		84,
		87,
		102,
		107,
		99,
		113,
		113,
		114,
		-1,
		134,
		145,
		138,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		115,
		-1,
		82,
		-1,
		65,
		69,
		33,
		0,
		68,
		55,
		62,
		79,
		85,
		82,
		90,
		88,
		89,
		98,
		109,
		121,
		120,
		121,
		159,
		115,
		118,
		129,
		140,
		155,
		159,
		-1,
		99,
		138,
		153,
		-1,
		124,
		-1,
		-1,
		-1,
		79,
		46,
		38,
		44,
		59,
		67,
		63,
		67,
		80,
		87,
		97,
		106,
		98,
		102,
		115,
		126,
		129,
		155,
		146,
		159,
		104,
		104,
		125,
		134,
		155,
		114,
		105,
		132,
		158,
		149,
		144,
		131,
		-1,
		-1,
		102,
		56,
		-1,
		-1,
		60,
		84,
		67,
		69,
		73,
		87,
		99,
		112,
		105,
		103,
		97,
		129,
		-1,
		148,
		147,
		136,
		133,
		109,
		100,
		95,
		122,
		-1,
		-1,
		117,
		133,
		128,
		132,
		148,
		173,
		-1,
		134,
		-1,
		-1,
		123,
		-1,
		-1,
		126,
		89,
		78,
		69,
		75,
		81,
		92,
		114,
		111,
		112,
		102,
		112,
		125,
		132,
		129,
		117,
		115,
		138,
		103,
		91,
		-1,
		104,
		102,
		108,
		115,
		132,
		162,
		-1,
		-1,
		150,
		141,
		-1,
		-1,
		124,
		122,
		111,
		-1,
		101,
		74,
		79,
		104,
		111,
		113,
		114,
		108,
		115,
		114,
		122,
		130,
		141,
		155,
		144,
		140,
		139,
		147,
		96,
		89,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		171,
		160,
		-1,
		-1,
		119,
		112,
		100,
		88,
		78,
		88,
		96,
		96,
		99,
		104,
		106,
		117,
		109,
		113,
		130,
		-1,
		175,
		-1,
		127,
		103,
		117,
		132,
		140,
		-1,
		-1,
		-1,
		188,
		174,
		167,
		155,
		153,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		132,
		100,
		105,
		100,
		112,
		123,
		112,
		115,
		129,
		124,
		-1,
		-1,
		115,
		118,
		-1,
		-1,
		140,
		159,
		-1,
		179,
		168,
		153,
		145,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		89,
		114,
		103,
		111,
		106,
		116,
		122,
		125,
		114,
		118,
		130,
		-1,
		-1,
		122,
		123,
		128,
		-1,
		149,
		-1,
		181,
		-1,
		148,
		154,
		142,
		-1,
		-1,
		-1,
		127,
		90,
		111,
		121,
		126,
		124,
		115,
		114,
		121,
		125,
		121,
		132,
		-1,
		-1,
		-1,
		179,
		155,
		188,
		179,
		162,
		142,
		134,
		153,
		-1,
		123,
		-1,
		94,
		91,
		126,
		120,
		137,
		131,
		117,
		132,
		128,
		119,
		128,
		185,
		-1,
		157,
		190,
		154,
		148,
		124,
		128,
		144,
		-1,
		120,
		102,
		-1,
		130,
		120,
		154,
		140,
		128,
		115,
		122,
		132,
		125,
		-1,
		-1,
		-1,
		159,
		158,
		150,
		144,
		144,
		129,
		120,
		-1,
		132,
		114,
		93,
		110,
		110,
		101,
		109,
		144,
		140,
		133,
		135,
		127,
		-1,
		247,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		153,
		148,
		121,
		109,
		115,
		111,
		97,
		103,
		105,
		113,
		111,
		108,
		120,
		116,
		136,
		128,
		164,
		-1,
		254,
		-1,
		189,
		-1,
		-1,
		171,
		151,
		143,
		132,
		121,
		119,
		110,
		101,
		123,
		139,
		123,
		121,
		126,
		131,
		-1,
		244,
		243,
		-1,
		190,
		182,
		168,
		-1,
		161,
		-1,
		167,
		128,
		-1,
		130,
		110,
		-1,
		132,
		128,
		-1,
		-1,
		231,
		206,
		-1,
		-1,
		-1,
		191,
		171,
		162,
		146,
		-1,
		121,
		121,
		-1,
		-1,
		-1,
		216,
		215,
		-1,
		184,
		187,
		-1,
		177,
		168,
		176,
		123,
		127,
		-1,
		-1,
		-1,
		225,
		206,
		200,
		199,
		197,
		192,
		189,
		175,
		159,
		137,
		126,
		147,
		-1,
		-1,
		-1,
		197,
		189,
		182,
		-1,
		-1,
		184,
		167,
		148,
		146,
		-1,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		174,
		-1,
		-1,
		180,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		208,
		-1,
		-1,
		-1,
		170,
		166,
		167,
		-1,
		-1,
		-1,
		-1,
		230,
		231,
		254,
		218,
		-1,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		233,
		231,
		-1,
		-1,
		-1,
		190,
		174,
		-1,
		160,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		195,
		-1,
		195,
		170,
		177,
		-1,
		-1,
		-1,
		-1,
		208,
		200,
		208,
		-1,
		180,
		182,
		-1,
		230,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		185,
		192,
		214,
		217,
		253,
		-1,
		204
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		118,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		114,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		127,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		121,
		128,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		118,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		120,
		116,
		123,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		153,
		150,
		136,
		116,
		108,
		123,
		122,
		109,
		108,
		96,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		145,
		136,
		124,
		114,
		104,
		109,
		110,
		100,
		98,
		94,
		97,
		91,
		82,
		81,
		97,
		89,
		111,
		-1,
		-1,
		186,
		191,
		179,
		165,
		176,
		-1,
		-1,
		-1,
		185,
		198,
		164,
		143,
		125,
		-1,
		-1,
		108,
		101,
		95,
		98,
		86,
		106,
		106,
		90,
		75,
		90,
		94,
		102,
		93,
		-1,
		189,
		176,
		-1,
		-1,
		175,
		165,
		-1,
		-1,
		-1,
		-1,
		176,
		121,
		110,
		105,
		109,
		107,
		-1,
		81,
		92,
		85,
		104,
		111,
		92,
		77,
		71,
		77,
		89,
		98,
		-1,
		-1,
		189,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		133,
		127,
		98,
		91,
		95,
		-1,
		83,
		85,
		82,
		94,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		92,
		96,
		212,
		-1,
		142,
		-1,
		-1,
		-1,
		151,
		166,
		137,
		114,
		87,
		82,
		75,
		69,
		74,
		85,
		94,
		105,
		70,
		74,
		67,
		66,
		70,
		87,
		91,
		-1,
		-1,
		140,
		136,
		171,
		159,
		152,
		164,
		-1,
		-1,
		91,
		82,
		73,
		65,
		78,
		81,
		66,
		68,
		76,
		71,
		65,
		75,
		90,
		85,
		-1,
		-1,
		-1,
		152,
		-1,
		154,
		-1,
		-1,
		142,
		162,
		109,
		91,
		87,
		82,
		60,
		54,
		56,
		61,
		79,
		73,
		70,
		61,
		65,
		88,
		77,
		116,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		131,
		123,
		118,
		124,
		126,
		117,
		124,
		121,
		-1,
		79,
		83,
		51,
		65,
		60,
		67,
		72,
		69,
		55,
		62,
		78,
		77,
		72,
		108,
		99,
		105,
		-1,
		-1,
		217,
		206,
		195,
		201,
		-1,
		124,
		120,
		110,
		100,
		103,
		-1,
		-1,
		97,
		94,
		74,
		43,
		49,
		54,
		56,
		61,
		42,
		51,
		55,
		59,
		65,
		70,
		75,
		81,
		96,
		111,
		-1,
		171,
		208,
		201,
		169,
		177,
		208,
		-1,
		114,
		106,
		117,
		92,
		94,
		-1,
		-1,
		70,
		61,
		62,
		50,
		47,
		62,
		77,
		46,
		59,
		69,
		58,
		57,
		75,
		79,
		88,
		95,
		85,
		98,
		102,
		-1,
		164,
		184,
		163,
		166,
		190,
		204,
		-1,
		111,
		-1,
		-1,
		123,
		95,
		79,
		69,
		66,
		109,
		56,
		51,
		28,
		26,
		43,
		34,
		75,
		61,
		66,
		69,
		84,
		89,
		81,
		95,
		95,
		96,
		-1,
		153,
		164,
		157,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		139,
		-1,
		106,
		-1,
		89,
		93,
		64,
		67,
		0,
		15,
		36,
		53,
		59,
		59,
		64,
		67,
		71,
		80,
		91,
		103,
		102,
		103,
		178,
		134,
		137,
		148,
		159,
		174,
		178,
		-1,
		123,
		162,
		174,
		-1,
		148,
		-1,
		-1,
		-1,
		103,
		77,
		69,
		48,
		27,
		27,
		37,
		41,
		54,
		61,
		71,
		85,
		80,
		84,
		97,
		108,
		111,
		174,
		165,
		178,
		123,
		123,
		144,
		153,
		174,
		138,
		129,
		156,
		177,
		170,
		165,
		152,
		-1,
		-1,
		126,
		87,
		-1,
		-1,
		34,
		58,
		41,
		43,
		47,
		61,
		73,
		86,
		87,
		85,
		79,
		111,
		-1,
		167,
		166,
		155,
		152,
		128,
		119,
		114,
		141,
		-1,
		-1,
		136,
		157,
		147,
		151,
		167,
		192,
		-1,
		141,
		-1,
		-1,
		115,
		-1,
		-1,
		100,
		63,
		52,
		43,
		49,
		55,
		66,
		88,
		91,
		94,
		84,
		94,
		107,
		151,
		148,
		136,
		134,
		157,
		122,
		110,
		-1,
		123,
		121,
		127,
		134,
		151,
		181,
		-1,
		-1,
		157,
		137,
		-1,
		-1,
		98,
		96,
		85,
		-1,
		75,
		48,
		53,
		78,
		85,
		87,
		94,
		88,
		95,
		96,
		104,
		112,
		160,
		174,
		163,
		159,
		158,
		166,
		115,
		108,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		143,
		-1,
		-1,
		93,
		86,
		74,
		62,
		52,
		62,
		70,
		70,
		73,
		78,
		86,
		97,
		91,
		95,
		112,
		-1,
		194,
		-1,
		146,
		122,
		136,
		151,
		159,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		127,
		111,
		92,
		-1,
		62,
		75,
		106,
		74,
		79,
		74,
		92,
		103,
		94,
		97,
		111,
		106,
		-1,
		-1,
		134,
		137,
		-1,
		-1,
		154,
		156,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		99,
		95,
		-1,
		-1,
		63,
		88,
		77,
		85,
		80,
		92,
		102,
		100,
		96,
		100,
		112,
		-1,
		-1,
		141,
		142,
		147,
		-1,
		139,
		-1,
		157,
		-1,
		124,
		130,
		118,
		-1,
		-1,
		-1,
		101,
		64,
		85,
		95,
		100,
		98,
		89,
		88,
		95,
		105,
		103,
		114,
		-1,
		-1,
		-1,
		157,
		131,
		164,
		155,
		138,
		118,
		110,
		129,
		-1,
		99,
		-1,
		68,
		65,
		102,
		94,
		111,
		105,
		91,
		106,
		102,
		101,
		109,
		163,
		-1,
		133,
		166,
		130,
		124,
		100,
		104,
		120,
		-1,
		96,
		76,
		-1,
		106,
		96,
		128,
		114,
		102,
		89,
		96,
		110,
		106,
		-1,
		-1,
		-1,
		135,
		134,
		126,
		120,
		120,
		105,
		96,
		-1,
		108,
		90,
		69,
		86,
		86,
		77,
		85,
		118,
		114,
		107,
		109,
		101,
		-1,
		236,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		129,
		124,
		97,
		85,
		91,
		87,
		73,
		79,
		81,
		89,
		87,
		84,
		96,
		92,
		112,
		102,
		138,
		-1,
		231,
		-1,
		165,
		-1,
		-1,
		147,
		127,
		119,
		108,
		97,
		95,
		86,
		77,
		99,
		115,
		99,
		97,
		102,
		107,
		-1,
		220,
		219,
		-1,
		166,
		158,
		144,
		-1,
		137,
		-1,
		143,
		104,
		-1,
		106,
		86,
		-1,
		108,
		104,
		-1,
		-1,
		207,
		182,
		-1,
		-1,
		-1,
		167,
		147,
		138,
		122,
		-1,
		97,
		97,
		-1,
		-1,
		-1,
		192,
		191,
		-1,
		160,
		163,
		-1,
		153,
		144,
		152,
		99,
		103,
		-1,
		-1,
		-1,
		201,
		182,
		176,
		175,
		173,
		168,
		165,
		151,
		135,
		113,
		102,
		123,
		-1,
		-1,
		-1,
		173,
		165,
		158,
		-1,
		-1,
		160,
		143,
		124,
		122,
		-1,
		-1,
		-1,
		195,
		176,
		-1,
		-1,
		150,
		-1,
		-1,
		156,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		184,
		-1,
		-1,
		-1,
		146,
		142,
		143,
		-1,
		-1,
		-1,
		-1,
		206,
		207,
		230,
		194,
		-1,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		209,
		207,
		-1,
		-1,
		-1,
		166,
		150,
		-1,
		136,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		171,
		-1,
		171,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		184,
		176,
		184,
		-1,
		156,
		158,
		-1,
		206,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		161,
		168,
		190,
		193,
		229,
		-1,
		180
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		222,
		226,
		192,
		186,
		225,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		215,
		214,
		182,
		180,
		189,
		194,
		201,
		-1,
		200,
		-1,
		236,
		215,
		226,
		231,
		175,
		172,
		192,
		211,
		193,
		185,
		251,
		205,
		176,
		170,
		188,
		178,
		187,
		179,
		-1,
		176,
		166,
		188,
		167,
		178,
		170,
		-1,
		-1,
		170,
		171,
		177,
		163,
		169,
		165,
		-1,
		175,
		159,
		-1,
		-1,
		160,
		161,
		145,
		148,
		156,
		154,
		167,
		159,
		154,
		-1,
		-1,
		151,
		147,
		154,
		141,
		137,
		154,
		167,
		149,
		163,
		162,
		-1,
		155,
		173,
		180,
		148,
		146,
		130,
		128,
		146,
		148,
		154,
		154,
		-1,
		164,
		165,
		160,
		168,
		170,
		146,
		133,
		133,
		143,
		136,
		155,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		136,
		133,
		131,
		128,
		144,
		142,
		152,
		-1,
		-1,
		257,
		226,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		122,
		121,
		149,
		135,
		146,
		217,
		-1,
		-1,
		215,
		207,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		116,
		126,
		130,
		128,
		153,
		-1,
		-1,
		188,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		113,
		138,
		142,
		123,
		144,
		139,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		117,
		115,
		145,
		120,
		142,
		139,
		158,
		163,
		157,
		166,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		109,
		124,
		115,
		114,
		132,
		142,
		150,
		154,
		160,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		214,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		122,
		104,
		118,
		109,
		127,
		134,
		132,
		136,
		156,
		168,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		115,
		100,
		97,
		115,
		118,
		125,
		129,
		145,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		125,
		104,
		99,
		96,
		116,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		109,
		114,
		94,
		92,
		111,
		123,
		114,
		131,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		105,
		113,
		108,
		90,
		99,
		105,
		129,
		119,
		125,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		107,
		97,
		92,
		99,
		134,
		134,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		103,
		101,
		102,
		84,
		116,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		108,
		97,
		110,
		103,
		89,
		91,
		104,
		108,
		112,
		99,
		95,
		92,
		106,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		120,
		111,
		119,
		92,
		85,
		92,
		81,
		99,
		107,
		99,
		93,
		92,
		102,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		115,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		103,
		103,
		87,
		88,
		92,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		109,
		116,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		97,
		83,
		81,
		90,
		106,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		108,
		104,
		111,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		89,
		85,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		141,
		138,
		124,
		104,
		96,
		111,
		110,
		97,
		96,
		84,
		78,
		75,
		68,
		81,
		91,
		96,
		83,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		133,
		124,
		112,
		102,
		92,
		97,
		98,
		88,
		86,
		82,
		85,
		79,
		70,
		69,
		85,
		77,
		99,
		-1,
		-1,
		174,
		179,
		167,
		153,
		164,
		-1,
		-1,
		-1,
		173,
		186,
		152,
		131,
		113,
		-1,
		-1,
		96,
		89,
		83,
		86,
		74,
		94,
		94,
		78,
		63,
		78,
		82,
		90,
		81,
		-1,
		177,
		164,
		-1,
		-1,
		163,
		153,
		-1,
		-1,
		-1,
		-1,
		164,
		109,
		98,
		93,
		97,
		95,
		-1,
		69,
		80,
		73,
		92,
		99,
		80,
		65,
		59,
		65,
		77,
		86,
		-1,
		-1,
		177,
		-1,
		139,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		86,
		79,
		83,
		-1,
		71,
		73,
		70,
		82,
		83,
		80,
		71,
		62,
		58,
		62,
		66,
		80,
		84,
		200,
		-1,
		130,
		-1,
		-1,
		-1,
		139,
		154,
		125,
		102,
		75,
		70,
		63,
		57,
		62,
		73,
		82,
		93,
		58,
		62,
		55,
		54,
		58,
		75,
		79,
		-1,
		-1,
		128,
		124,
		159,
		147,
		140,
		152,
		-1,
		-1,
		79,
		70,
		61,
		53,
		66,
		69,
		54,
		56,
		64,
		59,
		53,
		63,
		78,
		73,
		-1,
		-1,
		-1,
		140,
		-1,
		142,
		-1,
		-1,
		130,
		150,
		97,
		79,
		75,
		70,
		48,
		42,
		44,
		49,
		67,
		61,
		58,
		49,
		53,
		76,
		65,
		104,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		119,
		111,
		106,
		112,
		114,
		105,
		112,
		109,
		-1,
		67,
		71,
		39,
		53,
		48,
		55,
		60,
		57,
		43,
		50,
		66,
		65,
		60,
		96,
		87,
		93,
		-1,
		-1,
		205,
		194,
		183,
		189,
		-1,
		112,
		108,
		98,
		88,
		91,
		-1,
		-1,
		85,
		82,
		62,
		31,
		37,
		42,
		44,
		49,
		30,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		99,
		-1,
		159,
		196,
		189,
		157,
		165,
		196,
		-1,
		102,
		94,
		105,
		80,
		82,
		-1,
		-1,
		58,
		49,
		50,
		38,
		35,
		50,
		65,
		34,
		47,
		57,
		46,
		45,
		63,
		67,
		76,
		83,
		73,
		86,
		90,
		-1,
		152,
		172,
		151,
		154,
		178,
		192,
		-1,
		99,
		-1,
		-1,
		111,
		83,
		67,
		57,
		54,
		97,
		44,
		39,
		16,
		14,
		31,
		22,
		63,
		49,
		54,
		57,
		72,
		77,
		69,
		83,
		83,
		84,
		-1,
		141,
		152,
		145,
		-1,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		127,
		-1,
		94,
		-1,
		77,
		81,
		52,
		55,
		16,
		0,
		24,
		41,
		47,
		47,
		52,
		55,
		59,
		68,
		79,
		91,
		90,
		91,
		166,
		122,
		125,
		136,
		147,
		162,
		166,
		-1,
		111,
		150,
		162,
		-1,
		136,
		-1,
		-1,
		-1,
		91,
		65,
		57,
		36,
		15,
		15,
		25,
		29,
		42,
		49,
		59,
		73,
		68,
		72,
		85,
		96,
		99,
		162,
		153,
		166,
		111,
		111,
		132,
		141,
		162,
		126,
		117,
		144,
		165,
		158,
		153,
		140,
		-1,
		-1,
		114,
		75,
		-1,
		-1,
		22,
		46,
		29,
		31,
		35,
		49,
		61,
		74,
		75,
		73,
		67,
		99,
		-1,
		155,
		154,
		143,
		140,
		116,
		107,
		102,
		129,
		-1,
		-1,
		124,
		145,
		135,
		139,
		155,
		180,
		-1,
		129,
		-1,
		-1,
		103,
		-1,
		-1,
		88,
		51,
		40,
		31,
		37,
		43,
		54,
		76,
		79,
		82,
		72,
		82,
		95,
		139,
		136,
		124,
		122,
		145,
		110,
		98,
		-1,
		111,
		109,
		115,
		122,
		139,
		169,
		-1,
		-1,
		145,
		125,
		-1,
		-1,
		86,
		84,
		73,
		-1,
		63,
		36,
		41,
		66,
		73,
		75,
		82,
		76,
		83,
		84,
		92,
		100,
		148,
		162,
		151,
		147,
		146,
		154,
		103,
		96,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		135,
		131,
		-1,
		-1,
		81,
		74,
		62,
		50,
		40,
		50,
		58,
		58,
		61,
		66,
		74,
		85,
		79,
		83,
		100,
		-1,
		182,
		-1,
		134,
		110,
		124,
		139,
		147,
		-1,
		-1,
		-1,
		152,
		138,
		131,
		119,
		117,
		-1,
		115,
		99,
		80,
		-1,
		50,
		63,
		94,
		62,
		67,
		62,
		80,
		91,
		82,
		85,
		99,
		94,
		-1,
		-1,
		122,
		125,
		-1,
		-1,
		142,
		144,
		-1,
		143,
		132,
		117,
		109,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		51,
		76,
		65,
		73,
		68,
		80,
		90,
		88,
		84,
		88,
		100,
		-1,
		-1,
		129,
		130,
		135,
		-1,
		127,
		-1,
		145,
		-1,
		112,
		118,
		106,
		-1,
		-1,
		-1,
		89,
		52,
		73,
		83,
		88,
		86,
		77,
		76,
		83,
		93,
		91,
		102,
		-1,
		-1,
		-1,
		145,
		119,
		152,
		143,
		126,
		106,
		98,
		117,
		-1,
		87,
		-1,
		56,
		53,
		90,
		82,
		99,
		93,
		79,
		94,
		90,
		89,
		97,
		151,
		-1,
		121,
		154,
		118,
		112,
		88,
		92,
		108,
		-1,
		84,
		64,
		-1,
		94,
		84,
		116,
		102,
		90,
		77,
		84,
		98,
		94,
		-1,
		-1,
		-1,
		123,
		122,
		114,
		108,
		108,
		93,
		84,
		-1,
		96,
		78,
		57,
		74,
		74,
		65,
		73,
		106,
		102,
		95,
		97,
		89,
		-1,
		224,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		117,
		112,
		85,
		73,
		79,
		75,
		61,
		67,
		69,
		77,
		75,
		72,
		84,
		80,
		100,
		90,
		126,
		-1,
		219,
		-1,
		153,
		-1,
		-1,
		135,
		115,
		107,
		96,
		85,
		83,
		74,
		65,
		87,
		103,
		87,
		85,
		90,
		95,
		-1,
		208,
		207,
		-1,
		154,
		146,
		132,
		-1,
		125,
		-1,
		131,
		92,
		-1,
		94,
		74,
		-1,
		96,
		92,
		-1,
		-1,
		195,
		170,
		-1,
		-1,
		-1,
		155,
		135,
		126,
		110,
		-1,
		85,
		85,
		-1,
		-1,
		-1,
		180,
		179,
		-1,
		148,
		151,
		-1,
		141,
		132,
		140,
		87,
		91,
		-1,
		-1,
		-1,
		189,
		170,
		164,
		163,
		161,
		156,
		153,
		139,
		123,
		101,
		90,
		111,
		-1,
		-1,
		-1,
		161,
		153,
		146,
		-1,
		-1,
		148,
		131,
		112,
		110,
		-1,
		-1,
		-1,
		183,
		164,
		-1,
		-1,
		138,
		-1,
		-1,
		144,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		172,
		-1,
		-1,
		-1,
		134,
		130,
		131,
		-1,
		-1,
		-1,
		-1,
		194,
		195,
		218,
		182,
		-1,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		197,
		195,
		-1,
		-1,
		-1,
		154,
		138,
		-1,
		124,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		159,
		-1,
		159,
		134,
		141,
		-1,
		-1,
		-1,
		-1,
		172,
		164,
		172,
		-1,
		144,
		146,
		-1,
		194,
		-1,
		-1,
		187,
		178,
		-1,
		-1,
		149,
		156,
		178,
		181,
		217,
		-1,
		168
	],
	[
		-1,
		209,
		198,
		209,
		217,
		190,
		197,
		-1,
		216,
		220,
		186,
		180,
		219,
		188,
		194,
		205,
		-1,
		-1,
		-1,
		209,
		208,
		176,
		174,
		183,
		188,
		195,
		-1,
		194,
		-1,
		230,
		209,
		220,
		225,
		169,
		166,
		186,
		205,
		187,
		179,
		245,
		199,
		170,
		164,
		182,
		172,
		181,
		173,
		-1,
		170,
		160,
		182,
		161,
		172,
		164,
		-1,
		-1,
		164,
		165,
		171,
		157,
		163,
		159,
		-1,
		169,
		153,
		-1,
		-1,
		154,
		155,
		139,
		142,
		150,
		148,
		161,
		153,
		148,
		-1,
		-1,
		145,
		141,
		148,
		135,
		131,
		148,
		161,
		143,
		157,
		156,
		-1,
		149,
		167,
		174,
		142,
		140,
		124,
		122,
		140,
		142,
		148,
		148,
		-1,
		158,
		159,
		154,
		162,
		164,
		140,
		127,
		127,
		137,
		130,
		149,
		137,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		158,
		141,
		158,
		150,
		140,
		155,
		148,
		130,
		127,
		125,
		122,
		138,
		136,
		146,
		-1,
		-1,
		251,
		220,
		249,
		207,
		188,
		-1,
		154,
		134,
		140,
		144,
		138,
		131,
		145,
		141,
		-1,
		116,
		115,
		143,
		129,
		140,
		211,
		-1,
		-1,
		209,
		201,
		184,
		187,
		164,
		160,
		149,
		148,
		140,
		126,
		122,
		128,
		131,
		131,
		137,
		110,
		120,
		124,
		122,
		147,
		-1,
		-1,
		182,
		-1,
		-1,
		208,
		191,
		-1,
		174,
		181,
		170,
		176,
		162,
		183,
		159,
		150,
		142,
		136,
		124,
		126,
		123,
		136,
		124,
		107,
		132,
		136,
		117,
		138,
		133,
		-1,
		181,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		167,
		170,
		176,
		200,
		199,
		-1,
		171,
		159,
		160,
		145,
		142,
		129,
		117,
		130,
		115,
		122,
		121,
		111,
		109,
		139,
		114,
		136,
		133,
		152,
		157,
		151,
		160,
		-1,
		216,
		212,
		208,
		215,
		164,
		-1,
		-1,
		204,
		-1,
		207,
		208,
		183,
		156,
		159,
		146,
		137,
		124,
		113,
		124,
		113,
		110,
		118,
		103,
		118,
		109,
		108,
		126,
		136,
		144,
		148,
		154,
		-1,
		266,
		-1,
		208,
		192,
		194,
		166,
		187,
		-1,
		224,
		208,
		200,
		185,
		185,
		-1,
		155,
		152,
		142,
		120,
		105,
		122,
		114,
		112,
		116,
		98,
		112,
		103,
		121,
		128,
		126,
		130,
		150,
		162,
		226,
		216,
		-1,
		198,
		203,
		162,
		170,
		189,
		227,
		191,
		-1,
		186,
		-1,
		157,
		170,
		-1,
		126,
		122,
		104,
		105,
		100,
		115,
		109,
		94,
		91,
		109,
		112,
		119,
		123,
		139,
		-1,
		-1,
		211,
		215,
		204,
		155,
		174,
		198,
		235,
		184,
		173,
		172,
		-1,
		163,
		140,
		137,
		125,
		112,
		97,
		98,
		106,
		119,
		98,
		93,
		90,
		110,
		136,
		114,
		126,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		181,
		152,
		176,
		218,
		202,
		195,
		183,
		148,
		148,
		142,
		-1,
		136,
		115,
		106,
		95,
		93,
		106,
		103,
		108,
		88,
		86,
		105,
		117,
		108,
		125,
		-1,
		-1,
		-1,
		211,
		200,
		201,
		147,
		170,
		207,
		181,
		167,
		172,
		147,
		140,
		134,
		149,
		132,
		113,
		102,
		94,
		83,
		99,
		107,
		102,
		84,
		93,
		99,
		123,
		113,
		119,
		-1,
		-1,
		218,
		208,
		192,
		194,
		191,
		161,
		168,
		200,
		172,
		185,
		-1,
		139,
		-1,
		128,
		123,
		107,
		102,
		99,
		96,
		90,
		99,
		101,
		91,
		86,
		93,
		128,
		128,
		103,
		123,
		126,
		-1,
		-1,
		-1,
		211,
		206,
		181,
		158,
		142,
		178,
		-1,
		155,
		156,
		-1,
		133,
		127,
		124,
		109,
		105,
		100,
		104,
		97,
		104,
		97,
		95,
		96,
		78,
		110,
		-1,
		111,
		105,
		113,
		103,
		91,
		-1,
		-1,
		-1,
		204,
		183,
		176,
		196,
		137,
		189,
		-1,
		-1,
		140,
		133,
		-1,
		120,
		102,
		109,
		107,
		101,
		105,
		102,
		91,
		104,
		97,
		83,
		85,
		98,
		102,
		106,
		93,
		89,
		86,
		100,
		-1,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		157,
		-1,
		149,
		141,
		131,
		125,
		119,
		115,
		113,
		129,
		113,
		116,
		114,
		105,
		113,
		86,
		79,
		86,
		75,
		93,
		101,
		93,
		87,
		86,
		96,
		-1,
		224,
		210,
		181,
		-1,
		-1,
		170,
		-1,
		134,
		148,
		164,
		-1,
		157,
		136,
		151,
		129,
		125,
		121,
		136,
		137,
		115,
		114,
		112,
		103,
		91,
		80,
		83,
		75,
		97,
		97,
		81,
		82,
		86,
		-1,
		230,
		217,
		175,
		171,
		160,
		180,
		131,
		119,
		151,
		-1,
		-1,
		193,
		-1,
		127,
		144,
		135,
		133,
		126,
		111,
		118,
		123,
		100,
		95,
		85,
		74,
		74,
		69,
		91,
		77,
		75,
		84,
		100,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		146,
		133,
		127,
		-1,
		168,
		-1,
		171,
		161,
		145,
		130,
		163,
		-1,
		110,
		106,
		113,
		-1,
		120,
		-1,
		93,
		90,
		81,
		66,
		63,
		74,
		72,
		83,
		79,
		-1,
		180,
		165,
		158,
		148,
		162,
		133,
		-1,
		188,
		-1,
		-1,
		158,
		152,
		152,
		136,
		139,
		126,
		106,
		98,
		113,
		112,
		99,
		98,
		79,
		72,
		69,
		62,
		75,
		85,
		90,
		77,
		-1,
		-1,
		-1,
		185,
		171,
		175,
		135,
		154,
		-1,
		-1,
		220,
		175,
		161,
		-1,
		135,
		126,
		114,
		104,
		94,
		99,
		100,
		90,
		88,
		77,
		79,
		73,
		64,
		63,
		79,
		71,
		93,
		-1,
		-1,
		168,
		173,
		161,
		147,
		166,
		-1,
		-1,
		-1,
		167,
		183,
		154,
		133,
		115,
		-1,
		-1,
		98,
		91,
		85,
		88,
		76,
		93,
		88,
		72,
		57,
		72,
		76,
		84,
		75,
		-1,
		171,
		158,
		-1,
		-1,
		169,
		159,
		-1,
		-1,
		-1,
		-1,
		166,
		111,
		100,
		95,
		99,
		97,
		-1,
		71,
		82,
		75,
		94,
		101,
		74,
		59,
		53,
		59,
		71,
		80,
		-1,
		-1,
		183,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		123,
		117,
		88,
		81,
		85,
		-1,
		73,
		75,
		72,
		84,
		77,
		74,
		65,
		56,
		52,
		56,
		60,
		74,
		78,
		206,
		-1,
		136,
		-1,
		-1,
		-1,
		141,
		156,
		127,
		104,
		77,
		72,
		65,
		59,
		64,
		75,
		84,
		95,
		60,
		59,
		49,
		48,
		52,
		69,
		73,
		-1,
		-1,
		134,
		130,
		165,
		149,
		146,
		154,
		-1,
		-1,
		81,
		72,
		63,
		55,
		68,
		71,
		56,
		58,
		58,
		53,
		47,
		57,
		72,
		67,
		-1,
		-1,
		-1,
		146,
		-1,
		148,
		-1,
		-1,
		136,
		152,
		99,
		81,
		77,
		75,
		54,
		48,
		46,
		51,
		61,
		55,
		52,
		43,
		47,
		70,
		59,
		98,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		125,
		117,
		112,
		118,
		120,
		111,
		114,
		111,
		-1,
		73,
		77,
		45,
		59,
		42,
		49,
		54,
		51,
		37,
		44,
		60,
		59,
		54,
		90,
		81,
		87,
		-1,
		-1,
		211,
		200,
		189,
		195,
		-1,
		118,
		114,
		104,
		94,
		97,
		-1,
		-1,
		91,
		88,
		68,
		37,
		43,
		43,
		38,
		43,
		24,
		33,
		37,
		41,
		47,
		52,
		57,
		63,
		78,
		93,
		-1,
		165,
		202,
		195,
		163,
		171,
		202,
		-1,
		108,
		100,
		111,
		86,
		88,
		-1,
		-1,
		64,
		55,
		56,
		44,
		41,
		56,
		61,
		28,
		37,
		51,
		40,
		39,
		57,
		61,
		70,
		77,
		67,
		80,
		84,
		-1,
		158,
		178,
		157,
		160,
		184,
		198,
		-1,
		105,
		-1,
		-1,
		117,
		89,
		73,
		63,
		60,
		103,
		50,
		45,
		22,
		20,
		25,
		16,
		57,
		37,
		48,
		51,
		66,
		71,
		63,
		77,
		77,
		78,
		-1,
		147,
		158,
		151,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		-1,
		133,
		-1,
		100,
		-1,
		83,
		87,
		58,
		61,
		36,
		23,
		0,
		29,
		35,
		35,
		40,
		43,
		53,
		62,
		73,
		85,
		84,
		85,
		172,
		128,
		131,
		142,
		153,
		168,
		172,
		-1,
		117,
		156,
		150,
		-1,
		134,
		-1,
		-1,
		-1,
		97,
		71,
		63,
		56,
		35,
		35,
		13,
		17,
		30,
		37,
		47,
		61,
		62,
		66,
		79,
		90,
		93,
		168,
		159,
		172,
		117,
		117,
		138,
		147,
		168,
		132,
		123,
		150,
		157,
		146,
		141,
		128,
		-1,
		-1,
		111,
		81,
		-1,
		-1,
		42,
		34,
		17,
		19,
		23,
		37,
		49,
		62,
		69,
		67,
		61,
		93,
		-1,
		161,
		160,
		149,
		146,
		122,
		113,
		108,
		135,
		-1,
		-1,
		130,
		151,
		141,
		145,
		161,
		186,
		-1,
		117,
		-1,
		-1,
		91,
		-1,
		-1,
		76,
		39,
		28,
		19,
		25,
		31,
		42,
		64,
		67,
		76,
		66,
		76,
		89,
		145,
		142,
		130,
		128,
		151,
		116,
		104,
		-1,
		117,
		115,
		121,
		128,
		145,
		175,
		-1,
		-1,
		133,
		113,
		-1,
		-1,
		74,
		72,
		61,
		-1,
		51,
		24,
		29,
		54,
		61,
		63,
		70,
		64,
		71,
		78,
		86,
		94,
		154,
		168,
		157,
		153,
		152,
		160,
		109,
		102,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		123,
		119,
		-1,
		-1,
		69,
		62,
		50,
		38,
		28,
		38,
		46,
		46,
		49,
		54,
		62,
		73,
		73,
		77,
		94,
		-1,
		188,
		-1,
		140,
		116,
		130,
		145,
		153,
		-1,
		-1,
		-1,
		140,
		126,
		119,
		107,
		105,
		-1,
		103,
		87,
		68,
		-1,
		38,
		51,
		82,
		50,
		55,
		50,
		68,
		79,
		76,
		79,
		93,
		88,
		-1,
		-1,
		128,
		131,
		-1,
		-1,
		130,
		132,
		-1,
		131,
		120,
		105,
		97,
		-1,
		-1,
		75,
		71,
		-1,
		-1,
		39,
		64,
		53,
		61,
		56,
		68,
		78,
		76,
		78,
		82,
		94,
		-1,
		-1,
		135,
		136,
		137,
		-1,
		115,
		-1,
		133,
		-1,
		100,
		106,
		94,
		-1,
		-1,
		-1,
		77,
		40,
		61,
		71,
		76,
		74,
		65,
		64,
		71,
		81,
		85,
		95,
		-1,
		-1,
		-1,
		133,
		107,
		140,
		131,
		114,
		94,
		86,
		105,
		-1,
		75,
		-1,
		44,
		41,
		78,
		70,
		87,
		81,
		67,
		82,
		78,
		83,
		85,
		139,
		-1,
		109,
		142,
		106,
		100,
		76,
		80,
		96,
		-1,
		72,
		52,
		-1,
		82,
		72,
		104,
		90,
		78,
		65,
		72,
		86,
		82,
		-1,
		-1,
		-1,
		111,
		110,
		102,
		96,
		96,
		81,
		72,
		-1,
		84,
		66,
		45,
		62,
		62,
		53,
		61,
		94,
		90,
		83,
		85,
		77,
		-1,
		212,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		105,
		100,
		73,
		61,
		67,
		63,
		49,
		55,
		57,
		65,
		63,
		60,
		72,
		68,
		88,
		78,
		114,
		-1,
		207,
		-1,
		141,
		-1,
		-1,
		123,
		103,
		95,
		84,
		73,
		71,
		62,
		53,
		75,
		91,
		75,
		73,
		78,
		83,
		-1,
		196,
		195,
		-1,
		142,
		134,
		120,
		-1,
		113,
		-1,
		119,
		80,
		-1,
		82,
		62,
		-1,
		84,
		80,
		-1,
		-1,
		183,
		158,
		-1,
		-1,
		-1,
		143,
		123,
		114,
		98,
		-1,
		73,
		73,
		-1,
		-1,
		-1,
		168,
		167,
		-1,
		136,
		139,
		-1,
		129,
		120,
		128,
		75,
		79,
		-1,
		-1,
		-1,
		177,
		158,
		152,
		151,
		149,
		144,
		141,
		127,
		111,
		89,
		78,
		99,
		-1,
		-1,
		-1,
		149,
		141,
		134,
		-1,
		-1,
		136,
		119,
		100,
		98,
		-1,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		126,
		-1,
		-1,
		132,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		160,
		-1,
		-1,
		-1,
		122,
		118,
		119,
		-1,
		-1,
		-1,
		-1,
		182,
		183,
		206,
		170,
		-1,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		185,
		183,
		-1,
		-1,
		-1,
		142,
		126,
		-1,
		112,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		147,
		-1,
		147,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		160,
		152,
		160,
		-1,
		132,
		134,
		-1,
		182,
		-1,
		-1,
		175,
		166,
		-1,
		-1,
		137,
		144,
		166,
		169,
		205,
		-1,
		156
	],
	[
		-1,
		198,
		187,
		198,
		206,
		179,
		186,
		-1,
		205,
		209,
		175,
		169,
		208,
		177,
		183,
		194,
		-1,
		-1,
		-1,
		198,
		197,
		165,
		163,
		172,
		177,
		184,
		-1,
		183,
		-1,
		219,
		198,
		209,
		214,
		158,
		155,
		175,
		194,
		176,
		168,
		234,
		188,
		159,
		153,
		171,
		161,
		170,
		162,
		-1,
		159,
		149,
		171,
		150,
		161,
		153,
		-1,
		-1,
		153,
		154,
		160,
		146,
		152,
		148,
		-1,
		158,
		142,
		-1,
		-1,
		143,
		144,
		128,
		131,
		139,
		137,
		150,
		142,
		137,
		-1,
		-1,
		134,
		130,
		137,
		124,
		120,
		137,
		150,
		132,
		146,
		145,
		-1,
		138,
		156,
		163,
		131,
		129,
		113,
		111,
		129,
		131,
		137,
		137,
		-1,
		147,
		148,
		143,
		151,
		153,
		129,
		116,
		116,
		126,
		119,
		138,
		126,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		147,
		130,
		147,
		139,
		129,
		144,
		137,
		119,
		116,
		114,
		111,
		127,
		125,
		135,
		-1,
		-1,
		240,
		209,
		238,
		196,
		177,
		-1,
		143,
		123,
		129,
		133,
		127,
		120,
		134,
		130,
		-1,
		105,
		104,
		132,
		118,
		129,
		200,
		-1,
		-1,
		198,
		190,
		173,
		176,
		153,
		149,
		138,
		137,
		129,
		115,
		111,
		117,
		120,
		120,
		126,
		99,
		109,
		113,
		111,
		136,
		-1,
		-1,
		171,
		-1,
		-1,
		197,
		180,
		-1,
		163,
		170,
		159,
		165,
		151,
		172,
		148,
		139,
		131,
		125,
		113,
		115,
		112,
		125,
		113,
		96,
		121,
		125,
		106,
		127,
		122,
		-1,
		170,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		156,
		159,
		165,
		189,
		188,
		-1,
		160,
		148,
		149,
		134,
		131,
		118,
		106,
		119,
		104,
		111,
		110,
		100,
		98,
		128,
		103,
		125,
		122,
		141,
		146,
		140,
		149,
		-1,
		205,
		201,
		197,
		204,
		153,
		-1,
		-1,
		193,
		-1,
		196,
		197,
		172,
		145,
		148,
		135,
		126,
		113,
		102,
		113,
		102,
		99,
		107,
		92,
		107,
		98,
		97,
		115,
		125,
		133,
		137,
		143,
		-1,
		255,
		-1,
		197,
		181,
		183,
		155,
		176,
		-1,
		213,
		197,
		189,
		174,
		174,
		-1,
		144,
		141,
		131,
		109,
		94,
		111,
		103,
		101,
		105,
		87,
		101,
		92,
		110,
		117,
		115,
		119,
		139,
		151,
		215,
		205,
		-1,
		187,
		192,
		151,
		159,
		178,
		216,
		180,
		-1,
		175,
		-1,
		146,
		159,
		-1,
		115,
		111,
		93,
		94,
		89,
		104,
		98,
		83,
		80,
		98,
		101,
		108,
		112,
		128,
		-1,
		-1,
		200,
		204,
		193,
		144,
		163,
		187,
		224,
		173,
		162,
		161,
		-1,
		152,
		129,
		126,
		114,
		101,
		86,
		87,
		95,
		108,
		87,
		82,
		79,
		99,
		125,
		103,
		115,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		170,
		141,
		165,
		207,
		191,
		184,
		172,
		137,
		137,
		131,
		-1,
		125,
		104,
		95,
		84,
		82,
		95,
		92,
		97,
		77,
		75,
		94,
		106,
		97,
		114,
		-1,
		-1,
		-1,
		200,
		189,
		190,
		136,
		159,
		196,
		170,
		156,
		161,
		136,
		129,
		123,
		138,
		121,
		102,
		91,
		83,
		72,
		88,
		96,
		91,
		73,
		82,
		88,
		112,
		102,
		108,
		-1,
		-1,
		207,
		197,
		181,
		183,
		180,
		150,
		157,
		189,
		161,
		174,
		-1,
		128,
		-1,
		117,
		112,
		96,
		91,
		88,
		85,
		79,
		88,
		90,
		80,
		75,
		82,
		117,
		117,
		92,
		112,
		115,
		-1,
		-1,
		-1,
		200,
		195,
		170,
		147,
		131,
		167,
		-1,
		144,
		145,
		-1,
		122,
		116,
		113,
		98,
		94,
		89,
		93,
		86,
		93,
		86,
		84,
		85,
		67,
		99,
		-1,
		100,
		94,
		102,
		92,
		80,
		-1,
		-1,
		-1,
		193,
		172,
		165,
		185,
		126,
		178,
		-1,
		-1,
		129,
		122,
		-1,
		109,
		91,
		98,
		96,
		90,
		94,
		91,
		80,
		93,
		86,
		72,
		74,
		87,
		91,
		95,
		82,
		78,
		75,
		89,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		146,
		-1,
		138,
		130,
		120,
		114,
		108,
		104,
		102,
		118,
		102,
		105,
		103,
		94,
		102,
		75,
		68,
		75,
		64,
		82,
		90,
		82,
		76,
		75,
		85,
		-1,
		213,
		199,
		170,
		-1,
		-1,
		159,
		-1,
		123,
		137,
		153,
		-1,
		146,
		125,
		140,
		118,
		114,
		110,
		125,
		126,
		104,
		103,
		101,
		92,
		80,
		69,
		72,
		64,
		86,
		86,
		70,
		71,
		75,
		-1,
		219,
		206,
		164,
		160,
		149,
		169,
		120,
		108,
		140,
		-1,
		-1,
		182,
		-1,
		116,
		133,
		124,
		122,
		115,
		106,
		112,
		112,
		89,
		84,
		74,
		63,
		63,
		58,
		80,
		66,
		64,
		73,
		89,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		135,
		122,
		116,
		-1,
		157,
		-1,
		160,
		150,
		134,
		119,
		152,
		-1,
		117,
		107,
		112,
		-1,
		109,
		-1,
		82,
		79,
		70,
		55,
		52,
		63,
		61,
		72,
		68,
		-1,
		169,
		154,
		147,
		137,
		151,
		122,
		-1,
		177,
		-1,
		-1,
		147,
		141,
		141,
		125,
		128,
		133,
		113,
		105,
		112,
		104,
		96,
		90,
		68,
		61,
		58,
		51,
		64,
		74,
		79,
		66,
		-1,
		-1,
		-1,
		174,
		160,
		164,
		124,
		143,
		-1,
		-1,
		209,
		164,
		150,
		-1,
		134,
		133,
		121,
		111,
		101,
		106,
		107,
		87,
		80,
		66,
		68,
		62,
		53,
		52,
		68,
		60,
		82,
		-1,
		-1,
		157,
		162,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		156,
		172,
		161,
		135,
		122,
		-1,
		-1,
		105,
		98,
		92,
		83,
		70,
		82,
		77,
		61,
		46,
		61,
		65,
		73,
		64,
		-1,
		160,
		147,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		173,
		118,
		107,
		102,
		106,
		104,
		-1,
		78,
		89,
		74,
		86,
		93,
		63,
		48,
		42,
		48,
		60,
		69,
		-1,
		-1,
		172,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		130,
		124,
		95,
		88,
		92,
		-1,
		80,
		82,
		76,
		91,
		66,
		63,
		54,
		45,
		41,
		45,
		49,
		63,
		67,
		195,
		-1,
		151,
		-1,
		-1,
		-1,
		148,
		163,
		134,
		111,
		84,
		79,
		72,
		66,
		71,
		82,
		74,
		85,
		52,
		48,
		38,
		37,
		41,
		58,
		62,
		-1,
		-1,
		149,
		145,
		174,
		156,
		160,
		161,
		-1,
		-1,
		88,
		79,
		70,
		62,
		75,
		78,
		58,
		55,
		49,
		42,
		36,
		46,
		61,
		56,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		151,
		159,
		106,
		88,
		84,
		82,
		69,
		63,
		53,
		58,
		59,
		50,
		44,
		32,
		36,
		59,
		48,
		87,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		140,
		132,
		127,
		133,
		135,
		126,
		121,
		118,
		-1,
		88,
		92,
		59,
		66,
		49,
		56,
		54,
		46,
		26,
		33,
		49,
		48,
		43,
		79,
		70,
		76,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		133,
		129,
		119,
		109,
		112,
		-1,
		-1,
		106,
		103,
		83,
		52,
		57,
		50,
		45,
		50,
		31,
		22,
		26,
		30,
		36,
		41,
		46,
		52,
		67,
		82,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		123,
		115,
		126,
		101,
		103,
		-1,
		-1,
		79,
		70,
		71,
		59,
		56,
		65,
		60,
		34,
		8,
		30,
		24,
		28,
		46,
		50,
		59,
		63,
		56,
		69,
		73,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		120,
		-1,
		-1,
		132,
		104,
		88,
		78,
		75,
		118,
		65,
		60,
		37,
		35,
		31,
		23,
		29,
		32,
		37,
		40,
		50,
		55,
		47,
		66,
		66,
		67,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		147,
		-1,
		115,
		-1,
		98,
		102,
		73,
		76,
		51,
		38,
		24,
		0,
		16,
		30,
		35,
		38,
		37,
		46,
		57,
		69,
		73,
		74,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		132,
		171,
		153,
		-1,
		137,
		-1,
		-1,
		-1,
		112,
		86,
		78,
		71,
		50,
		50,
		16,
		12,
		25,
		32,
		42,
		54,
		46,
		50,
		63,
		74,
		82,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		147,
		138,
		165,
		160,
		149,
		144,
		131,
		-1,
		-1,
		114,
		96,
		-1,
		-1,
		57,
		37,
		20,
		14,
		18,
		32,
		44,
		57,
		53,
		51,
		45,
		77,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		166,
		156,
		160,
		176,
		201,
		-1,
		120,
		-1,
		-1,
		94,
		-1,
		-1,
		79,
		42,
		31,
		22,
		20,
		26,
		37,
		59,
		59,
		60,
		50,
		60,
		73,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		132,
		130,
		136,
		143,
		160,
		190,
		-1,
		-1,
		136,
		116,
		-1,
		-1,
		77,
		75,
		64,
		-1,
		54,
		27,
		24,
		49,
		56,
		58,
		62,
		56,
		63,
		62,
		70,
		78,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		126,
		122,
		-1,
		-1,
		72,
		65,
		53,
		41,
		31,
		38,
		41,
		41,
		44,
		49,
		54,
		65,
		57,
		61,
		78,
		-1,
		203,
		-1,
		155,
		131,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		143,
		129,
		122,
		110,
		108,
		-1,
		106,
		90,
		71,
		-1,
		41,
		54,
		77,
		45,
		50,
		45,
		60,
		71,
		60,
		63,
		77,
		72,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		133,
		135,
		-1,
		134,
		123,
		108,
		100,
		-1,
		-1,
		78,
		74,
		-1,
		-1,
		42,
		59,
		48,
		56,
		51,
		63,
		70,
		71,
		62,
		66,
		78,
		-1,
		-1,
		150,
		146,
		140,
		-1,
		118,
		-1,
		136,
		-1,
		103,
		109,
		97,
		-1,
		-1,
		-1,
		80,
		43,
		64,
		66,
		71,
		69,
		60,
		59,
		66,
		73,
		69,
		80,
		-1,
		-1,
		-1,
		136,
		110,
		143,
		134,
		117,
		97,
		89,
		108,
		-1,
		78,
		-1,
		47,
		44,
		80,
		65,
		82,
		76,
		62,
		77,
		73,
		67,
		76,
		142,
		-1,
		112,
		145,
		109,
		103,
		79,
		83,
		99,
		-1,
		75,
		55,
		-1,
		85,
		75,
		99,
		85,
		73,
		60,
		67,
		80,
		73,
		-1,
		-1,
		-1,
		114,
		113,
		105,
		99,
		99,
		84,
		75,
		-1,
		87,
		69,
		48,
		65,
		65,
		56,
		64,
		89,
		85,
		78,
		80,
		72,
		-1,
		215,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		108,
		103,
		76,
		64,
		70,
		66,
		52,
		58,
		60,
		68,
		66,
		63,
		75,
		71,
		91,
		73,
		109,
		-1,
		210,
		-1,
		144,
		-1,
		-1,
		126,
		106,
		98,
		87,
		76,
		74,
		65,
		56,
		78,
		94,
		78,
		76,
		80,
		81,
		-1,
		199,
		198,
		-1,
		145,
		137,
		123,
		-1,
		116,
		-1,
		122,
		83,
		-1,
		85,
		65,
		-1,
		87,
		83,
		-1,
		-1,
		186,
		161,
		-1,
		-1,
		-1,
		146,
		126,
		117,
		101,
		-1,
		76,
		76,
		-1,
		-1,
		-1,
		171,
		170,
		-1,
		139,
		142,
		-1,
		132,
		123,
		131,
		78,
		82,
		-1,
		-1,
		-1,
		180,
		161,
		155,
		154,
		152,
		147,
		144,
		130,
		114,
		92,
		81,
		102,
		-1,
		-1,
		-1,
		152,
		144,
		137,
		-1,
		-1,
		139,
		122,
		103,
		101,
		-1,
		-1,
		-1,
		174,
		155,
		-1,
		-1,
		129,
		-1,
		-1,
		135,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		163,
		-1,
		-1,
		-1,
		125,
		121,
		122,
		-1,
		-1,
		-1,
		-1,
		185,
		186,
		209,
		173,
		-1,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		188,
		186,
		-1,
		-1,
		-1,
		145,
		129,
		-1,
		115,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		150,
		-1,
		150,
		125,
		132,
		-1,
		-1,
		-1,
		-1,
		163,
		155,
		163,
		-1,
		135,
		137,
		-1,
		185,
		-1,
		-1,
		178,
		169,
		-1,
		-1,
		140,
		147,
		169,
		172,
		208,
		-1,
		159
	],
	[
		-1,
		217,
		206,
		217,
		225,
		198,
		205,
		-1,
		224,
		228,
		194,
		188,
		227,
		196,
		202,
		213,
		-1,
		-1,
		-1,
		217,
		216,
		184,
		182,
		191,
		196,
		203,
		-1,
		202,
		-1,
		238,
		217,
		228,
		233,
		177,
		174,
		194,
		213,
		195,
		187,
		253,
		207,
		178,
		172,
		190,
		180,
		189,
		181,
		-1,
		178,
		168,
		190,
		169,
		180,
		172,
		-1,
		-1,
		172,
		173,
		179,
		165,
		171,
		167,
		-1,
		177,
		161,
		-1,
		-1,
		162,
		163,
		147,
		150,
		158,
		156,
		169,
		161,
		156,
		-1,
		-1,
		153,
		149,
		156,
		143,
		139,
		156,
		169,
		151,
		165,
		164,
		-1,
		157,
		175,
		182,
		150,
		148,
		132,
		130,
		148,
		150,
		156,
		156,
		-1,
		166,
		167,
		162,
		170,
		172,
		148,
		135,
		135,
		145,
		138,
		157,
		145,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		166,
		149,
		166,
		158,
		148,
		163,
		156,
		138,
		135,
		133,
		130,
		146,
		144,
		154,
		-1,
		-1,
		259,
		228,
		257,
		215,
		196,
		-1,
		162,
		142,
		148,
		152,
		146,
		139,
		153,
		149,
		-1,
		124,
		123,
		151,
		137,
		148,
		219,
		-1,
		-1,
		217,
		209,
		192,
		195,
		172,
		168,
		157,
		156,
		148,
		134,
		130,
		136,
		139,
		139,
		145,
		118,
		128,
		132,
		130,
		155,
		-1,
		-1,
		190,
		-1,
		-1,
		216,
		199,
		-1,
		182,
		189,
		178,
		184,
		170,
		191,
		167,
		158,
		150,
		144,
		132,
		134,
		131,
		144,
		132,
		115,
		140,
		144,
		125,
		146,
		141,
		-1,
		189,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		175,
		178,
		184,
		208,
		207,
		-1,
		179,
		167,
		168,
		153,
		150,
		137,
		125,
		138,
		123,
		130,
		129,
		119,
		117,
		147,
		122,
		144,
		141,
		160,
		165,
		159,
		168,
		-1,
		224,
		220,
		216,
		223,
		172,
		-1,
		-1,
		212,
		-1,
		215,
		216,
		191,
		164,
		167,
		154,
		145,
		132,
		121,
		132,
		121,
		118,
		126,
		111,
		126,
		117,
		116,
		134,
		144,
		152,
		156,
		162,
		-1,
		274,
		-1,
		216,
		200,
		202,
		174,
		195,
		-1,
		232,
		216,
		208,
		193,
		193,
		-1,
		163,
		160,
		150,
		128,
		113,
		130,
		122,
		120,
		124,
		106,
		120,
		111,
		129,
		136,
		134,
		138,
		158,
		170,
		234,
		224,
		-1,
		206,
		211,
		170,
		178,
		197,
		235,
		199,
		-1,
		194,
		-1,
		165,
		178,
		-1,
		134,
		130,
		112,
		113,
		108,
		123,
		117,
		102,
		99,
		117,
		120,
		127,
		131,
		147,
		-1,
		-1,
		219,
		223,
		212,
		163,
		182,
		206,
		243,
		192,
		181,
		180,
		-1,
		171,
		148,
		145,
		133,
		120,
		105,
		106,
		114,
		127,
		106,
		101,
		98,
		118,
		144,
		122,
		134,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		189,
		160,
		184,
		226,
		210,
		203,
		191,
		156,
		156,
		150,
		-1,
		144,
		123,
		114,
		103,
		101,
		114,
		111,
		116,
		96,
		94,
		113,
		125,
		116,
		133,
		-1,
		-1,
		-1,
		219,
		208,
		209,
		155,
		178,
		215,
		189,
		175,
		180,
		155,
		148,
		142,
		157,
		140,
		121,
		110,
		102,
		91,
		107,
		115,
		110,
		92,
		101,
		107,
		131,
		121,
		127,
		-1,
		-1,
		226,
		216,
		200,
		202,
		199,
		169,
		176,
		208,
		180,
		193,
		-1,
		147,
		-1,
		136,
		131,
		115,
		110,
		107,
		104,
		98,
		107,
		109,
		99,
		94,
		101,
		136,
		136,
		111,
		131,
		134,
		-1,
		-1,
		-1,
		219,
		214,
		189,
		166,
		150,
		186,
		-1,
		163,
		164,
		-1,
		141,
		135,
		132,
		117,
		113,
		108,
		112,
		105,
		112,
		105,
		103,
		104,
		86,
		118,
		-1,
		119,
		113,
		121,
		111,
		99,
		-1,
		-1,
		-1,
		212,
		191,
		184,
		204,
		145,
		197,
		-1,
		-1,
		148,
		141,
		-1,
		128,
		110,
		117,
		115,
		109,
		113,
		110,
		99,
		112,
		105,
		91,
		93,
		106,
		110,
		114,
		101,
		97,
		94,
		108,
		-1,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		165,
		-1,
		157,
		149,
		139,
		133,
		127,
		123,
		121,
		137,
		121,
		124,
		122,
		113,
		121,
		94,
		87,
		94,
		83,
		101,
		109,
		101,
		95,
		94,
		104,
		-1,
		232,
		218,
		189,
		-1,
		-1,
		178,
		-1,
		142,
		156,
		172,
		-1,
		165,
		144,
		159,
		137,
		133,
		129,
		144,
		145,
		123,
		122,
		120,
		111,
		99,
		88,
		91,
		83,
		105,
		105,
		89,
		90,
		94,
		-1,
		238,
		225,
		183,
		179,
		168,
		188,
		139,
		127,
		159,
		-1,
		-1,
		201,
		-1,
		135,
		152,
		143,
		141,
		134,
		125,
		131,
		131,
		108,
		103,
		93,
		82,
		82,
		77,
		99,
		85,
		83,
		92,
		108,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		154,
		141,
		135,
		-1,
		176,
		-1,
		179,
		169,
		153,
		138,
		171,
		-1,
		124,
		120,
		127,
		-1,
		128,
		-1,
		101,
		98,
		89,
		74,
		71,
		82,
		80,
		91,
		87,
		-1,
		188,
		173,
		166,
		156,
		170,
		141,
		-1,
		196,
		-1,
		-1,
		166,
		160,
		160,
		144,
		147,
		140,
		120,
		112,
		127,
		123,
		113,
		109,
		87,
		80,
		77,
		70,
		83,
		93,
		98,
		85,
		-1,
		-1,
		-1,
		193,
		179,
		183,
		143,
		162,
		-1,
		-1,
		228,
		183,
		169,
		-1,
		149,
		140,
		128,
		118,
		108,
		113,
		114,
		104,
		99,
		85,
		87,
		81,
		72,
		71,
		87,
		79,
		101,
		-1,
		-1,
		176,
		181,
		169,
		155,
		174,
		-1,
		-1,
		-1,
		175,
		191,
		168,
		147,
		129,
		-1,
		-1,
		112,
		105,
		99,
		102,
		89,
		101,
		96,
		80,
		65,
		80,
		84,
		92,
		83,
		-1,
		179,
		166,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		96,
		89,
		105,
		112,
		82,
		67,
		61,
		67,
		79,
		88,
		-1,
		-1,
		191,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		89,
		86,
		98,
		85,
		82,
		73,
		64,
		60,
		64,
		68,
		82,
		86,
		214,
		-1,
		158,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		78,
		89,
		93,
		104,
		71,
		67,
		57,
		56,
		60,
		77,
		81,
		-1,
		-1,
		156,
		152,
		181,
		163,
		167,
		168,
		-1,
		-1,
		95,
		86,
		77,
		69,
		82,
		85,
		70,
		72,
		68,
		61,
		55,
		65,
		80,
		75,
		-1,
		-1,
		-1,
		168,
		-1,
		170,
		-1,
		-1,
		158,
		166,
		113,
		95,
		91,
		89,
		76,
		70,
		60,
		65,
		75,
		69,
		63,
		51,
		55,
		78,
		67,
		105,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		147,
		139,
		134,
		140,
		142,
		133,
		128,
		125,
		-1,
		95,
		99,
		66,
		73,
		56,
		63,
		68,
		65,
		45,
		52,
		68,
		67,
		62,
		97,
		88,
		92,
		-1,
		-1,
		233,
		222,
		211,
		217,
		-1,
		140,
		136,
		126,
		116,
		119,
		-1,
		-1,
		113,
		110,
		90,
		59,
		64,
		57,
		52,
		57,
		38,
		41,
		45,
		49,
		55,
		60,
		65,
		71,
		83,
		98,
		-1,
		187,
		224,
		217,
		185,
		193,
		224,
		-1,
		130,
		122,
		133,
		108,
		110,
		-1,
		-1,
		86,
		77,
		78,
		66,
		63,
		76,
		75,
		42,
		27,
		49,
		35,
		45,
		65,
		69,
		73,
		74,
		75,
		88,
		92,
		-1,
		180,
		200,
		179,
		182,
		206,
		220,
		-1,
		127,
		-1,
		-1,
		139,
		111,
		95,
		85,
		82,
		125,
		72,
		67,
		44,
		42,
		39,
		30,
		45,
		30,
		42,
		45,
		61,
		66,
		58,
		84,
		85,
		86,
		-1,
		169,
		180,
		173,
		-1,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		154,
		-1,
		122,
		-1,
		105,
		109,
		80,
		83,
		58,
		45,
		31,
		19,
		0,
		28,
		33,
		36,
		48,
		57,
		68,
		80,
		90,
		92,
		194,
		150,
		153,
		164,
		175,
		190,
		194,
		-1,
		139,
		178,
		160,
		-1,
		144,
		-1,
		-1,
		-1,
		119,
		93,
		85,
		78,
		57,
		57,
		23,
		19,
		23,
		30,
		40,
		54,
		57,
		61,
		74,
		85,
		100,
		190,
		181,
		194,
		139,
		139,
		160,
		169,
		190,
		154,
		145,
		172,
		167,
		156,
		151,
		138,
		-1,
		-1,
		121,
		103,
		-1,
		-1,
		64,
		44,
		27,
		21,
		21,
		29,
		47,
		55,
		64,
		62,
		56,
		88,
		-1,
		183,
		182,
		171,
		168,
		144,
		135,
		130,
		157,
		-1,
		-1,
		152,
		173,
		163,
		167,
		183,
		208,
		-1,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		86,
		49,
		38,
		29,
		27,
		29,
		40,
		59,
		69,
		71,
		61,
		71,
		84,
		167,
		164,
		152,
		150,
		173,
		138,
		126,
		-1,
		139,
		137,
		143,
		150,
		167,
		197,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		84,
		82,
		71,
		-1,
		61,
		34,
		31,
		52,
		63,
		65,
		72,
		66,
		73,
		73,
		81,
		89,
		176,
		190,
		179,
		175,
		174,
		182,
		131,
		124,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		79,
		72,
		60,
		48,
		38,
		45,
		45,
		48,
		51,
		56,
		64,
		75,
		68,
		72,
		89,
		-1,
		210,
		-1,
		162,
		138,
		152,
		167,
		175,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		113,
		97,
		78,
		-1,
		48,
		61,
		84,
		52,
		57,
		52,
		70,
		81,
		71,
		74,
		88,
		83,
		-1,
		-1,
		150,
		153,
		-1,
		-1,
		140,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		85,
		81,
		-1,
		-1,
		49,
		66,
		55,
		63,
		58,
		70,
		80,
		78,
		73,
		77,
		89,
		-1,
		-1,
		157,
		153,
		147,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		87,
		50,
		71,
		73,
		78,
		76,
		67,
		66,
		73,
		83,
		80,
		91,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		85,
		-1,
		54,
		51,
		87,
		72,
		89,
		83,
		69,
		84,
		80,
		78,
		87,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		82,
		62,
		-1,
		92,
		82,
		106,
		92,
		80,
		67,
		74,
		88,
		84,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		72,
		63,
		71,
		96,
		92,
		85,
		87,
		79,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		75,
		73,
		70,
		82,
		78,
		98,
		80,
		116,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		101,
		85,
		83,
		87,
		88,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		94,
		90,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		190,
		179,
		190,
		198,
		171,
		178,
		-1,
		197,
		201,
		167,
		161,
		200,
		169,
		175,
		186,
		-1,
		-1,
		-1,
		190,
		189,
		157,
		155,
		164,
		169,
		176,
		-1,
		175,
		-1,
		211,
		190,
		201,
		206,
		150,
		147,
		167,
		186,
		168,
		160,
		226,
		180,
		151,
		145,
		163,
		153,
		162,
		154,
		-1,
		151,
		141,
		163,
		142,
		153,
		145,
		-1,
		-1,
		145,
		146,
		152,
		138,
		144,
		140,
		-1,
		150,
		134,
		-1,
		-1,
		135,
		136,
		120,
		123,
		131,
		129,
		142,
		134,
		129,
		-1,
		-1,
		126,
		122,
		129,
		116,
		112,
		129,
		142,
		124,
		138,
		137,
		-1,
		130,
		148,
		155,
		123,
		121,
		105,
		103,
		121,
		123,
		129,
		129,
		-1,
		139,
		140,
		135,
		143,
		145,
		121,
		108,
		108,
		118,
		111,
		130,
		118,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		139,
		122,
		139,
		131,
		121,
		136,
		129,
		111,
		108,
		106,
		103,
		119,
		117,
		127,
		-1,
		-1,
		232,
		201,
		230,
		188,
		169,
		-1,
		135,
		115,
		121,
		125,
		119,
		112,
		126,
		122,
		-1,
		97,
		96,
		124,
		110,
		121,
		192,
		-1,
		-1,
		190,
		182,
		165,
		168,
		145,
		141,
		130,
		129,
		121,
		107,
		103,
		109,
		112,
		112,
		118,
		91,
		101,
		105,
		103,
		128,
		-1,
		-1,
		163,
		-1,
		-1,
		189,
		172,
		-1,
		155,
		162,
		151,
		157,
		143,
		164,
		140,
		131,
		123,
		117,
		105,
		107,
		104,
		117,
		105,
		88,
		113,
		117,
		98,
		119,
		114,
		-1,
		162,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		148,
		151,
		157,
		181,
		180,
		-1,
		152,
		140,
		141,
		126,
		123,
		110,
		98,
		111,
		96,
		103,
		102,
		92,
		90,
		120,
		95,
		117,
		114,
		133,
		138,
		132,
		141,
		-1,
		197,
		193,
		189,
		196,
		145,
		-1,
		-1,
		185,
		-1,
		188,
		189,
		164,
		137,
		140,
		127,
		118,
		105,
		94,
		105,
		94,
		91,
		99,
		84,
		99,
		90,
		89,
		107,
		117,
		125,
		129,
		135,
		-1,
		247,
		-1,
		189,
		173,
		175,
		147,
		168,
		-1,
		205,
		189,
		181,
		166,
		166,
		-1,
		136,
		133,
		123,
		101,
		86,
		103,
		95,
		93,
		97,
		79,
		93,
		84,
		102,
		109,
		107,
		111,
		131,
		143,
		207,
		197,
		-1,
		179,
		184,
		143,
		151,
		170,
		208,
		172,
		-1,
		167,
		-1,
		138,
		151,
		-1,
		107,
		103,
		85,
		86,
		81,
		96,
		90,
		75,
		72,
		90,
		93,
		100,
		104,
		120,
		-1,
		-1,
		192,
		196,
		185,
		136,
		155,
		179,
		216,
		165,
		154,
		153,
		-1,
		144,
		121,
		118,
		106,
		93,
		78,
		79,
		87,
		100,
		79,
		74,
		71,
		91,
		117,
		95,
		107,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		162,
		133,
		157,
		199,
		183,
		176,
		164,
		129,
		129,
		123,
		-1,
		117,
		96,
		87,
		76,
		74,
		87,
		84,
		89,
		69,
		67,
		86,
		98,
		89,
		106,
		-1,
		-1,
		-1,
		192,
		181,
		182,
		128,
		151,
		188,
		162,
		148,
		153,
		128,
		121,
		115,
		130,
		113,
		94,
		83,
		75,
		64,
		80,
		88,
		83,
		65,
		74,
		80,
		104,
		94,
		100,
		-1,
		-1,
		199,
		189,
		173,
		175,
		172,
		142,
		149,
		181,
		153,
		166,
		-1,
		120,
		-1,
		109,
		104,
		88,
		83,
		80,
		77,
		71,
		80,
		82,
		72,
		67,
		74,
		109,
		109,
		84,
		104,
		107,
		-1,
		-1,
		-1,
		192,
		187,
		162,
		139,
		123,
		159,
		-1,
		136,
		137,
		-1,
		114,
		108,
		105,
		90,
		86,
		81,
		85,
		78,
		85,
		78,
		76,
		77,
		59,
		91,
		-1,
		92,
		86,
		94,
		84,
		72,
		-1,
		-1,
		-1,
		185,
		164,
		157,
		177,
		118,
		170,
		-1,
		-1,
		121,
		114,
		-1,
		101,
		83,
		90,
		88,
		82,
		86,
		83,
		72,
		85,
		78,
		64,
		66,
		79,
		83,
		87,
		74,
		70,
		67,
		81,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		138,
		-1,
		130,
		122,
		112,
		106,
		100,
		96,
		94,
		110,
		94,
		97,
		95,
		86,
		94,
		67,
		60,
		67,
		56,
		74,
		82,
		74,
		68,
		67,
		77,
		-1,
		205,
		191,
		162,
		-1,
		-1,
		151,
		-1,
		115,
		129,
		145,
		-1,
		138,
		117,
		132,
		110,
		106,
		102,
		117,
		118,
		96,
		95,
		93,
		84,
		72,
		61,
		64,
		56,
		78,
		78,
		62,
		63,
		67,
		-1,
		211,
		198,
		156,
		152,
		141,
		161,
		112,
		100,
		132,
		-1,
		-1,
		174,
		-1,
		108,
		125,
		116,
		114,
		107,
		98,
		104,
		104,
		81,
		76,
		66,
		55,
		55,
		50,
		72,
		58,
		56,
		65,
		81,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		127,
		114,
		108,
		-1,
		149,
		-1,
		152,
		142,
		126,
		111,
		144,
		-1,
		109,
		99,
		104,
		-1,
		101,
		-1,
		74,
		71,
		62,
		47,
		44,
		55,
		53,
		64,
		60,
		-1,
		161,
		146,
		139,
		129,
		143,
		114,
		-1,
		169,
		-1,
		-1,
		139,
		133,
		133,
		117,
		120,
		125,
		105,
		97,
		104,
		96,
		88,
		82,
		60,
		53,
		50,
		43,
		56,
		66,
		71,
		58,
		-1,
		-1,
		-1,
		166,
		152,
		156,
		116,
		135,
		-1,
		-1,
		201,
		156,
		142,
		-1,
		126,
		125,
		113,
		103,
		93,
		98,
		99,
		79,
		72,
		58,
		60,
		54,
		45,
		44,
		60,
		52,
		74,
		-1,
		-1,
		149,
		154,
		142,
		128,
		147,
		-1,
		-1,
		-1,
		148,
		164,
		153,
		127,
		114,
		-1,
		-1,
		97,
		90,
		84,
		75,
		62,
		74,
		69,
		53,
		38,
		53,
		57,
		65,
		56,
		-1,
		152,
		139,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		-1,
		-1,
		165,
		110,
		99,
		94,
		98,
		96,
		-1,
		70,
		81,
		66,
		78,
		85,
		55,
		40,
		34,
		40,
		52,
		61,
		-1,
		-1,
		164,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		122,
		116,
		87,
		80,
		84,
		-1,
		72,
		74,
		68,
		83,
		58,
		55,
		46,
		37,
		33,
		37,
		41,
		55,
		59,
		187,
		-1,
		150,
		-1,
		-1,
		-1,
		140,
		155,
		126,
		103,
		76,
		71,
		64,
		58,
		63,
		74,
		66,
		77,
		44,
		40,
		30,
		29,
		33,
		50,
		54,
		-1,
		-1,
		148,
		144,
		166,
		148,
		152,
		153,
		-1,
		-1,
		80,
		71,
		62,
		54,
		67,
		70,
		50,
		47,
		41,
		34,
		28,
		38,
		53,
		48,
		-1,
		-1,
		-1,
		160,
		-1,
		162,
		-1,
		-1,
		150,
		151,
		98,
		80,
		76,
		74,
		63,
		57,
		45,
		50,
		51,
		42,
		36,
		24,
		28,
		51,
		40,
		77,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		139,
		131,
		126,
		132,
		134,
		125,
		113,
		110,
		-1,
		80,
		86,
		51,
		58,
		41,
		48,
		46,
		38,
		18,
		25,
		41,
		40,
		35,
		69,
		60,
		64,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		132,
		128,
		118,
		108,
		111,
		-1,
		-1,
		105,
		102,
		82,
		51,
		49,
		42,
		37,
		47,
		27,
		14,
		18,
		22,
		28,
		33,
		38,
		44,
		55,
		70,
		-1,
		179,
		216,
		209,
		177,
		185,
		216,
		-1,
		122,
		114,
		125,
		100,
		102,
		-1,
		-1,
		78,
		69,
		70,
		58,
		55,
		57,
		52,
		42,
		23,
		29,
		7,
		17,
		38,
		41,
		45,
		46,
		48,
		61,
		65,
		-1,
		172,
		192,
		171,
		174,
		198,
		212,
		-1,
		119,
		-1,
		-1,
		131,
		103,
		87,
		77,
		74,
		117,
		72,
		67,
		44,
		42,
		39,
		30,
		25,
		2,
		20,
		23,
		33,
		38,
		30,
		56,
		58,
		59,
		-1,
		161,
		172,
		165,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		147,
		-1,
		114,
		-1,
		97,
		101,
		80,
		83,
		58,
		45,
		31,
		31,
		25,
		0,
		15,
		18,
		20,
		29,
		40,
		52,
		62,
		64,
		186,
		142,
		145,
		156,
		167,
		182,
		186,
		-1,
		131,
		170,
		160,
		-1,
		144,
		-1,
		-1,
		-1,
		111,
		93,
		85,
		78,
		57,
		57,
		23,
		19,
		5,
		12,
		22,
		35,
		29,
		33,
		46,
		57,
		72,
		182,
		173,
		186,
		131,
		131,
		152,
		161,
		182,
		146,
		137,
		164,
		167,
		156,
		151,
		138,
		-1,
		-1,
		121,
		103,
		-1,
		-1,
		64,
		44,
		27,
		16,
		12,
		15,
		30,
		37,
		36,
		34,
		28,
		60,
		-1,
		175,
		174,
		163,
		160,
		136,
		127,
		122,
		149,
		-1,
		-1,
		144,
		165,
		155,
		159,
		175,
		200,
		-1,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		86,
		49,
		38,
		29,
		27,
		20,
		31,
		41,
		42,
		43,
		33,
		43,
		56,
		159,
		156,
		144,
		142,
		165,
		130,
		118,
		-1,
		131,
		129,
		135,
		142,
		159,
		189,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		84,
		82,
		71,
		-1,
		61,
		34,
		31,
		47,
		62,
		51,
		45,
		39,
		46,
		45,
		53,
		61,
		168,
		182,
		171,
		167,
		166,
		174,
		123,
		116,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		79,
		72,
		60,
		48,
		38,
		45,
		40,
		48,
		49,
		42,
		37,
		48,
		40,
		44,
		61,
		-1,
		202,
		-1,
		154,
		130,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		113,
		97,
		78,
		-1,
		48,
		61,
		84,
		52,
		57,
		52,
		43,
		54,
		43,
		46,
		60,
		55,
		-1,
		-1,
		142,
		145,
		-1,
		-1,
		140,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		85,
		81,
		-1,
		-1,
		49,
		66,
		55,
		63,
		58,
		47,
		53,
		56,
		45,
		49,
		61,
		-1,
		-1,
		149,
		150,
		147,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		87,
		50,
		71,
		73,
		76,
		74,
		65,
		51,
		58,
		56,
		52,
		63,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		85,
		-1,
		54,
		51,
		87,
		72,
		87,
		81,
		54,
		69,
		59,
		50,
		59,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		82,
		62,
		-1,
		92,
		82,
		103,
		88,
		69,
		56,
		63,
		63,
		56,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		72,
		63,
		71,
		93,
		89,
		76,
		76,
		68,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		75,
		73,
		70,
		82,
		78,
		92,
		69,
		104,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		101,
		85,
		81,
		76,
		77,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		92,
		81,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		146,
		164,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		155,
		156,
		151,
		159,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		138,
		155,
		147,
		137,
		152,
		145,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		248,
		217,
		246,
		204,
		185,
		-1,
		151,
		131,
		137,
		141,
		135,
		128,
		142,
		138,
		-1,
		113,
		112,
		140,
		126,
		137,
		208,
		-1,
		-1,
		206,
		198,
		181,
		184,
		161,
		157,
		146,
		145,
		137,
		123,
		119,
		125,
		128,
		128,
		134,
		107,
		117,
		121,
		119,
		144,
		-1,
		-1,
		179,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		167,
		173,
		159,
		180,
		156,
		147,
		139,
		133,
		121,
		123,
		120,
		133,
		121,
		104,
		129,
		133,
		114,
		135,
		130,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		196,
		-1,
		168,
		156,
		157,
		142,
		139,
		126,
		114,
		127,
		112,
		119,
		118,
		108,
		106,
		136,
		111,
		133,
		130,
		149,
		154,
		148,
		157,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		204,
		205,
		180,
		153,
		156,
		143,
		134,
		121,
		110,
		121,
		110,
		107,
		115,
		100,
		115,
		106,
		105,
		123,
		133,
		141,
		145,
		151,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		205,
		197,
		182,
		182,
		-1,
		152,
		149,
		139,
		117,
		102,
		119,
		111,
		109,
		113,
		95,
		109,
		100,
		118,
		125,
		123,
		127,
		147,
		159,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		154,
		167,
		-1,
		123,
		119,
		101,
		102,
		97,
		112,
		106,
		91,
		88,
		106,
		109,
		116,
		120,
		136,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		137,
		134,
		122,
		109,
		94,
		95,
		103,
		116,
		95,
		90,
		87,
		107,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		90,
		103,
		100,
		105,
		85,
		83,
		102,
		114,
		105,
		122,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		146,
		129,
		110,
		99,
		91,
		80,
		96,
		104,
		99,
		81,
		90,
		96,
		120,
		110,
		116,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		98,
		88,
		83,
		90,
		125,
		125,
		100,
		120,
		123,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		94,
		92,
		93,
		75,
		107,
		-1,
		108,
		102,
		110,
		100,
		88,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		106,
		104,
		98,
		102,
		99,
		88,
		101,
		94,
		80,
		82,
		95,
		99,
		103,
		90,
		86,
		83,
		97,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		113,
		111,
		102,
		110,
		83,
		76,
		83,
		72,
		90,
		98,
		90,
		84,
		83,
		93,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		118,
		133,
		134,
		112,
		111,
		109,
		100,
		88,
		77,
		80,
		72,
		94,
		94,
		78,
		79,
		83,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		132,
		130,
		123,
		114,
		120,
		120,
		97,
		92,
		82,
		71,
		71,
		66,
		88,
		74,
		72,
		81,
		97,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		125,
		115,
		120,
		-1,
		117,
		-1,
		90,
		87,
		78,
		63,
		60,
		71,
		69,
		80,
		76,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		141,
		121,
		113,
		120,
		112,
		104,
		98,
		76,
		69,
		66,
		59,
		72,
		82,
		87,
		74,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		142,
		141,
		129,
		119,
		109,
		114,
		115,
		95,
		88,
		74,
		76,
		70,
		61,
		60,
		76,
		68,
		90,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		169,
		143,
		130,
		-1,
		-1,
		113,
		106,
		100,
		91,
		78,
		90,
		85,
		69,
		54,
		69,
		73,
		81,
		72,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		181,
		126,
		115,
		110,
		114,
		112,
		-1,
		86,
		97,
		82,
		94,
		101,
		71,
		56,
		50,
		56,
		68,
		77,
		-1,
		-1,
		180,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		103,
		96,
		100,
		-1,
		88,
		90,
		84,
		99,
		74,
		71,
		62,
		53,
		49,
		53,
		57,
		66,
		72,
		203,
		-1,
		165,
		-1,
		-1,
		-1,
		156,
		171,
		142,
		119,
		92,
		87,
		80,
		74,
		79,
		90,
		82,
		93,
		60,
		56,
		46,
		45,
		49,
		66,
		60,
		-1,
		-1,
		163,
		159,
		182,
		164,
		168,
		169,
		-1,
		-1,
		96,
		87,
		78,
		70,
		83,
		86,
		66,
		63,
		57,
		50,
		44,
		54,
		59,
		54,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		165,
		167,
		114,
		96,
		92,
		90,
		79,
		73,
		61,
		66,
		67,
		58,
		51,
		40,
		34,
		57,
		46,
		74,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		129,
		126,
		-1,
		96,
		102,
		67,
		74,
		57,
		64,
		62,
		54,
		34,
		31,
		47,
		46,
		41,
		66,
		57,
		61,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		120,
		117,
		97,
		66,
		65,
		58,
		53,
		63,
		43,
		30,
		24,
		19,
		34,
		39,
		44,
		45,
		52,
		67,
		-1,
		194,
		231,
		224,
		192,
		200,
		231,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		93,
		84,
		85,
		73,
		70,
		73,
		68,
		49,
		39,
		45,
		23,
		26,
		33,
		38,
		42,
		43,
		50,
		61,
		65,
		-1,
		187,
		207,
		186,
		189,
		213,
		227,
		-1,
		134,
		-1,
		-1,
		146,
		118,
		102,
		92,
		89,
		132,
		79,
		74,
		51,
		49,
		46,
		37,
		41,
		19,
		9,
		12,
		30,
		35,
		27,
		53,
		55,
		61,
		-1,
		176,
		187,
		180,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		161,
		-1,
		129,
		-1,
		112,
		116,
		87,
		90,
		65,
		52,
		38,
		38,
		32,
		17,
		0,
		3,
		17,
		26,
		37,
		49,
		59,
		61,
		201,
		157,
		160,
		171,
		182,
		197,
		201,
		-1,
		146,
		185,
		167,
		-1,
		151,
		-1,
		-1,
		-1,
		126,
		100,
		92,
		85,
		64,
		64,
		30,
		26,
		12,
		5,
		12,
		21,
		26,
		30,
		43,
		54,
		69,
		197,
		188,
		201,
		146,
		146,
		167,
		176,
		197,
		161,
		152,
		179,
		174,
		163,
		158,
		145,
		-1,
		-1,
		128,
		110,
		-1,
		-1,
		71,
		51,
		34,
		23,
		19,
		22,
		32,
		27,
		33,
		31,
		25,
		57,
		-1,
		190,
		189,
		178,
		175,
		151,
		142,
		137,
		164,
		-1,
		-1,
		159,
		180,
		170,
		174,
		190,
		215,
		-1,
		134,
		-1,
		-1,
		108,
		-1,
		-1,
		93,
		56,
		45,
		36,
		34,
		27,
		36,
		43,
		39,
		40,
		30,
		40,
		53,
		174,
		171,
		159,
		157,
		180,
		145,
		133,
		-1,
		146,
		144,
		150,
		157,
		174,
		204,
		-1,
		-1,
		150,
		130,
		-1,
		-1,
		91,
		89,
		78,
		-1,
		68,
		41,
		38,
		54,
		59,
		48,
		42,
		36,
		43,
		42,
		50,
		58,
		183,
		197,
		186,
		182,
		181,
		189,
		138,
		131,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		140,
		136,
		-1,
		-1,
		86,
		79,
		67,
		55,
		45,
		52,
		47,
		55,
		46,
		39,
		34,
		45,
		37,
		41,
		58,
		-1,
		217,
		-1,
		169,
		145,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		157,
		143,
		136,
		124,
		122,
		-1,
		120,
		104,
		85,
		-1,
		55,
		68,
		91,
		59,
		64,
		58,
		40,
		51,
		40,
		43,
		57,
		52,
		-1,
		-1,
		157,
		160,
		-1,
		-1,
		147,
		149,
		-1,
		148,
		137,
		122,
		114,
		-1,
		-1,
		92,
		88,
		-1,
		-1,
		56,
		73,
		62,
		70,
		65,
		44,
		50,
		53,
		42,
		46,
		58,
		-1,
		-1,
		164,
		160,
		154,
		-1,
		132,
		-1,
		150,
		-1,
		117,
		123,
		111,
		-1,
		-1,
		-1,
		94,
		57,
		78,
		80,
		73,
		71,
		62,
		48,
		55,
		53,
		49,
		60,
		-1,
		-1,
		-1,
		150,
		124,
		157,
		148,
		131,
		111,
		103,
		122,
		-1,
		92,
		-1,
		61,
		58,
		94,
		79,
		84,
		78,
		51,
		66,
		56,
		47,
		56,
		156,
		-1,
		126,
		159,
		123,
		117,
		93,
		97,
		113,
		-1,
		89,
		69,
		-1,
		99,
		89,
		100,
		85,
		66,
		53,
		60,
		60,
		53,
		-1,
		-1,
		-1,
		128,
		127,
		119,
		113,
		113,
		98,
		89,
		-1,
		101,
		83,
		62,
		79,
		79,
		70,
		78,
		90,
		86,
		73,
		73,
		65,
		-1,
		229,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		122,
		117,
		90,
		78,
		84,
		80,
		66,
		72,
		74,
		82,
		80,
		77,
		89,
		83,
		89,
		66,
		101,
		-1,
		224,
		-1,
		158,
		-1,
		-1,
		140,
		120,
		112,
		101,
		90,
		88,
		79,
		70,
		92,
		108,
		90,
		78,
		73,
		74,
		-1,
		213,
		212,
		-1,
		159,
		151,
		137,
		-1,
		130,
		-1,
		136,
		97,
		-1,
		99,
		79,
		-1,
		89,
		78,
		-1,
		-1,
		200,
		175,
		-1,
		-1,
		-1,
		160,
		140,
		131,
		115,
		-1,
		90,
		90,
		-1,
		-1,
		-1,
		185,
		184,
		-1,
		153,
		156,
		-1,
		146,
		137,
		145,
		92,
		96,
		-1,
		-1,
		-1,
		194,
		175,
		169,
		168,
		166,
		161,
		158,
		144,
		128,
		106,
		95,
		116,
		-1,
		-1,
		-1,
		166,
		158,
		151,
		-1,
		-1,
		153,
		136,
		117,
		115,
		-1,
		-1,
		-1,
		188,
		169,
		-1,
		-1,
		143,
		-1,
		-1,
		149,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		177,
		-1,
		-1,
		-1,
		139,
		135,
		136,
		-1,
		-1,
		-1,
		-1,
		199,
		200,
		223,
		187,
		-1,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		202,
		200,
		-1,
		-1,
		-1,
		159,
		143,
		-1,
		129,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		164,
		-1,
		164,
		139,
		146,
		-1,
		-1,
		-1,
		-1,
		177,
		169,
		177,
		-1,
		149,
		151,
		-1,
		199,
		-1,
		-1,
		192,
		183,
		-1,
		-1,
		154,
		161,
		183,
		186,
		222,
		-1,
		173
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		143,
		161,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		152,
		153,
		148,
		156,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		245,
		214,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		110,
		109,
		137,
		123,
		134,
		205,
		-1,
		-1,
		203,
		195,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		202,
		194,
		179,
		179,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		221,
		185,
		-1,
		180,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		113,
		92,
		87,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		97,
		102,
		82,
		80,
		99,
		111,
		102,
		119,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		143,
		126,
		107,
		96,
		88,
		77,
		93,
		101,
		96,
		78,
		87,
		93,
		117,
		107,
		113,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		90,
		84,
		93,
		95,
		85,
		80,
		87,
		122,
		122,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		94,
		98,
		91,
		98,
		91,
		89,
		90,
		72,
		104,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		101,
		95,
		99,
		96,
		85,
		98,
		91,
		77,
		79,
		92,
		96,
		100,
		87,
		83,
		80,
		94,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		110,
		108,
		99,
		107,
		80,
		73,
		80,
		69,
		87,
		95,
		87,
		81,
		80,
		90,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		130,
		131,
		109,
		108,
		106,
		97,
		85,
		74,
		77,
		69,
		91,
		91,
		75,
		76,
		80,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		129,
		127,
		120,
		111,
		117,
		117,
		94,
		89,
		79,
		68,
		68,
		63,
		85,
		71,
		69,
		78,
		94,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		122,
		112,
		117,
		-1,
		114,
		-1,
		87,
		84,
		75,
		60,
		57,
		68,
		66,
		77,
		73,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		138,
		118,
		110,
		117,
		109,
		101,
		95,
		73,
		66,
		63,
		56,
		69,
		79,
		84,
		71,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		138,
		126,
		116,
		106,
		111,
		112,
		92,
		85,
		71,
		73,
		67,
		58,
		57,
		73,
		65,
		87,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		177,
		166,
		140,
		127,
		-1,
		-1,
		110,
		103,
		97,
		88,
		75,
		87,
		82,
		66,
		51,
		66,
		70,
		78,
		69,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		178,
		123,
		112,
		107,
		111,
		109,
		-1,
		83,
		94,
		79,
		91,
		98,
		68,
		53,
		47,
		53,
		65,
		74,
		-1,
		-1,
		177,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		135,
		129,
		100,
		93,
		97,
		-1,
		85,
		87,
		81,
		96,
		71,
		68,
		59,
		50,
		46,
		50,
		54,
		63,
		69,
		200,
		-1,
		163,
		-1,
		-1,
		-1,
		153,
		168,
		139,
		116,
		89,
		84,
		77,
		71,
		76,
		87,
		79,
		90,
		57,
		53,
		43,
		42,
		46,
		63,
		57,
		-1,
		-1,
		161,
		157,
		179,
		161,
		165,
		166,
		-1,
		-1,
		93,
		84,
		75,
		67,
		80,
		83,
		63,
		60,
		54,
		47,
		41,
		51,
		56,
		51,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		164,
		111,
		93,
		89,
		87,
		76,
		70,
		58,
		63,
		64,
		55,
		48,
		37,
		31,
		54,
		43,
		71,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		126,
		123,
		-1,
		93,
		99,
		64,
		71,
		54,
		61,
		59,
		51,
		31,
		28,
		44,
		43,
		38,
		63,
		54,
		58,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		62,
		55,
		50,
		60,
		40,
		27,
		21,
		16,
		31,
		36,
		41,
		42,
		49,
		64,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		70,
		65,
		53,
		36,
		42,
		20,
		23,
		30,
		35,
		39,
		40,
		47,
		58,
		62,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		144,
		116,
		100,
		90,
		87,
		130,
		83,
		78,
		55,
		53,
		50,
		41,
		44,
		23,
		6,
		9,
		27,
		32,
		24,
		50,
		52,
		58,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		127,
		-1,
		110,
		114,
		91,
		94,
		69,
		56,
		42,
		42,
		36,
		21,
		4,
		0,
		14,
		23,
		34,
		46,
		56,
		58,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		171,
		-1,
		155,
		-1,
		-1,
		-1,
		124,
		104,
		96,
		89,
		68,
		68,
		34,
		30,
		16,
		9,
		16,
		18,
		23,
		27,
		40,
		51,
		66,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		178,
		167,
		162,
		149,
		-1,
		-1,
		132,
		114,
		-1,
		-1,
		75,
		55,
		38,
		27,
		23,
		26,
		36,
		27,
		30,
		28,
		22,
		54,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		188,
		213,
		-1,
		138,
		-1,
		-1,
		112,
		-1,
		-1,
		97,
		60,
		49,
		40,
		38,
		31,
		40,
		47,
		36,
		37,
		27,
		37,
		50,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		202,
		-1,
		-1,
		154,
		134,
		-1,
		-1,
		95,
		93,
		82,
		-1,
		72,
		45,
		42,
		58,
		56,
		45,
		39,
		33,
		40,
		39,
		47,
		55,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		140,
		-1,
		-1,
		90,
		83,
		71,
		59,
		49,
		56,
		51,
		57,
		43,
		36,
		31,
		42,
		34,
		38,
		55,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		124,
		108,
		89,
		-1,
		59,
		72,
		93,
		61,
		61,
		55,
		37,
		48,
		37,
		40,
		54,
		49,
		-1,
		-1,
		155,
		158,
		-1,
		-1,
		151,
		153,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		96,
		92,
		-1,
		-1,
		60,
		75,
		64,
		67,
		62,
		41,
		47,
		50,
		39,
		43,
		55,
		-1,
		-1,
		162,
		163,
		158,
		-1,
		136,
		-1,
		154,
		-1,
		121,
		127,
		115,
		-1,
		-1,
		-1,
		98,
		61,
		82,
		82,
		70,
		68,
		59,
		45,
		52,
		50,
		46,
		57,
		-1,
		-1,
		-1,
		154,
		128,
		161,
		152,
		135,
		115,
		107,
		126,
		-1,
		96,
		-1,
		65,
		62,
		96,
		78,
		81,
		75,
		48,
		63,
		53,
		44,
		53,
		160,
		-1,
		130,
		163,
		127,
		121,
		97,
		101,
		117,
		-1,
		93,
		73,
		-1,
		103,
		93,
		97,
		82,
		63,
		50,
		57,
		57,
		50,
		-1,
		-1,
		-1,
		132,
		131,
		123,
		117,
		117,
		102,
		93,
		-1,
		105,
		87,
		66,
		83,
		83,
		74,
		82,
		87,
		83,
		70,
		70,
		62,
		-1,
		233,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		126,
		121,
		94,
		82,
		88,
		84,
		70,
		76,
		78,
		86,
		84,
		81,
		89,
		80,
		86,
		63,
		98,
		-1,
		228,
		-1,
		162,
		-1,
		-1,
		144,
		124,
		116,
		105,
		94,
		92,
		83,
		74,
		96,
		112,
		87,
		75,
		70,
		71,
		-1,
		217,
		216,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		140,
		101,
		-1,
		103,
		83,
		-1,
		86,
		75,
		-1,
		-1,
		204,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		135,
		119,
		-1,
		94,
		94,
		-1,
		-1,
		-1,
		189,
		188,
		-1,
		157,
		160,
		-1,
		150,
		141,
		149,
		96,
		100,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		172,
		170,
		165,
		162,
		148,
		132,
		110,
		99,
		120,
		-1,
		-1,
		-1,
		170,
		162,
		155,
		-1,
		-1,
		157,
		140,
		121,
		119,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		147,
		-1,
		-1,
		153,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		181,
		-1,
		-1,
		-1,
		143,
		139,
		140,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		227,
		191,
		-1,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		133,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		168,
		-1,
		168,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		173,
		181,
		-1,
		153,
		155,
		-1,
		203,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		158,
		165,
		187,
		190,
		226,
		-1,
		177
	],
	[
		-1,
		194,
		183,
		194,
		202,
		175,
		182,
		-1,
		201,
		205,
		171,
		165,
		204,
		173,
		179,
		190,
		-1,
		-1,
		-1,
		194,
		193,
		161,
		159,
		168,
		173,
		180,
		-1,
		179,
		-1,
		215,
		194,
		205,
		210,
		154,
		151,
		171,
		190,
		172,
		164,
		230,
		184,
		155,
		149,
		167,
		157,
		166,
		158,
		-1,
		155,
		145,
		167,
		146,
		157,
		149,
		-1,
		-1,
		149,
		150,
		156,
		142,
		148,
		144,
		-1,
		154,
		138,
		-1,
		-1,
		139,
		140,
		124,
		127,
		135,
		133,
		146,
		138,
		133,
		-1,
		-1,
		130,
		126,
		133,
		120,
		116,
		133,
		146,
		128,
		142,
		141,
		-1,
		134,
		152,
		159,
		127,
		125,
		109,
		107,
		125,
		127,
		133,
		133,
		-1,
		143,
		144,
		139,
		147,
		149,
		125,
		112,
		112,
		122,
		115,
		134,
		122,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		143,
		126,
		143,
		135,
		125,
		140,
		133,
		115,
		112,
		110,
		107,
		123,
		121,
		131,
		-1,
		-1,
		236,
		205,
		234,
		192,
		173,
		-1,
		139,
		119,
		125,
		129,
		123,
		116,
		130,
		126,
		-1,
		101,
		100,
		128,
		114,
		125,
		196,
		-1,
		-1,
		194,
		186,
		169,
		172,
		149,
		145,
		134,
		133,
		125,
		111,
		107,
		113,
		116,
		116,
		122,
		95,
		105,
		109,
		107,
		132,
		-1,
		-1,
		167,
		-1,
		-1,
		193,
		176,
		-1,
		159,
		166,
		155,
		161,
		147,
		168,
		144,
		135,
		127,
		121,
		109,
		111,
		108,
		121,
		109,
		92,
		117,
		121,
		102,
		123,
		118,
		-1,
		166,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		152,
		155,
		161,
		185,
		184,
		-1,
		156,
		144,
		145,
		130,
		127,
		114,
		102,
		115,
		100,
		107,
		106,
		96,
		94,
		124,
		99,
		121,
		118,
		137,
		142,
		136,
		145,
		-1,
		201,
		197,
		193,
		200,
		149,
		-1,
		-1,
		189,
		-1,
		192,
		193,
		168,
		141,
		144,
		131,
		122,
		109,
		98,
		109,
		98,
		95,
		103,
		88,
		103,
		94,
		93,
		111,
		121,
		129,
		133,
		139,
		-1,
		251,
		-1,
		193,
		177,
		179,
		151,
		172,
		-1,
		209,
		193,
		185,
		170,
		170,
		-1,
		140,
		137,
		127,
		105,
		90,
		107,
		99,
		97,
		101,
		83,
		97,
		88,
		106,
		113,
		111,
		115,
		135,
		147,
		211,
		201,
		-1,
		183,
		188,
		147,
		155,
		174,
		212,
		176,
		-1,
		171,
		-1,
		142,
		155,
		-1,
		111,
		107,
		89,
		90,
		85,
		100,
		94,
		79,
		76,
		94,
		97,
		104,
		108,
		124,
		-1,
		-1,
		196,
		200,
		189,
		140,
		159,
		183,
		220,
		169,
		158,
		157,
		-1,
		148,
		125,
		122,
		110,
		97,
		82,
		83,
		91,
		104,
		83,
		78,
		75,
		95,
		121,
		99,
		111,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		166,
		137,
		161,
		203,
		187,
		180,
		168,
		133,
		133,
		127,
		-1,
		121,
		100,
		91,
		80,
		78,
		91,
		88,
		93,
		73,
		71,
		90,
		102,
		93,
		110,
		-1,
		-1,
		-1,
		196,
		185,
		186,
		132,
		155,
		192,
		166,
		152,
		157,
		132,
		125,
		119,
		134,
		117,
		98,
		87,
		79,
		68,
		84,
		92,
		87,
		69,
		78,
		84,
		108,
		98,
		104,
		-1,
		-1,
		203,
		193,
		177,
		179,
		176,
		146,
		153,
		185,
		157,
		170,
		-1,
		124,
		-1,
		113,
		108,
		92,
		87,
		84,
		81,
		75,
		84,
		86,
		76,
		71,
		78,
		113,
		113,
		88,
		108,
		111,
		-1,
		-1,
		-1,
		196,
		191,
		166,
		143,
		127,
		163,
		-1,
		140,
		141,
		-1,
		118,
		112,
		109,
		94,
		90,
		85,
		89,
		82,
		89,
		82,
		80,
		81,
		63,
		95,
		-1,
		96,
		90,
		98,
		88,
		76,
		-1,
		-1,
		-1,
		189,
		168,
		161,
		181,
		122,
		174,
		-1,
		-1,
		125,
		118,
		-1,
		105,
		87,
		94,
		92,
		86,
		90,
		87,
		76,
		89,
		82,
		68,
		70,
		83,
		87,
		91,
		78,
		74,
		71,
		85,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		142,
		-1,
		134,
		126,
		116,
		110,
		104,
		100,
		98,
		114,
		98,
		101,
		99,
		90,
		98,
		71,
		64,
		71,
		60,
		78,
		86,
		78,
		72,
		71,
		81,
		-1,
		209,
		195,
		166,
		-1,
		-1,
		155,
		-1,
		119,
		133,
		149,
		-1,
		142,
		121,
		136,
		114,
		110,
		106,
		121,
		122,
		100,
		99,
		97,
		88,
		76,
		65,
		68,
		60,
		82,
		82,
		66,
		67,
		71,
		-1,
		215,
		202,
		160,
		156,
		145,
		165,
		116,
		104,
		136,
		-1,
		-1,
		178,
		-1,
		112,
		129,
		120,
		118,
		111,
		102,
		108,
		108,
		85,
		80,
		70,
		59,
		59,
		54,
		76,
		62,
		60,
		69,
		85,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		131,
		118,
		112,
		-1,
		153,
		-1,
		156,
		146,
		130,
		115,
		148,
		-1,
		113,
		103,
		108,
		-1,
		105,
		-1,
		78,
		75,
		66,
		51,
		48,
		59,
		57,
		68,
		64,
		-1,
		165,
		150,
		143,
		133,
		147,
		118,
		-1,
		173,
		-1,
		-1,
		143,
		137,
		137,
		121,
		124,
		129,
		109,
		101,
		108,
		100,
		92,
		86,
		64,
		57,
		54,
		47,
		60,
		70,
		75,
		62,
		-1,
		-1,
		-1,
		170,
		156,
		160,
		120,
		139,
		-1,
		-1,
		205,
		160,
		146,
		-1,
		130,
		129,
		117,
		107,
		97,
		102,
		103,
		83,
		76,
		62,
		64,
		58,
		49,
		48,
		64,
		56,
		78,
		-1,
		-1,
		153,
		158,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		152,
		168,
		157,
		131,
		118,
		-1,
		-1,
		101,
		94,
		88,
		79,
		66,
		78,
		73,
		57,
		42,
		57,
		61,
		69,
		60,
		-1,
		156,
		143,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		169,
		114,
		103,
		98,
		102,
		100,
		-1,
		74,
		85,
		70,
		82,
		89,
		59,
		44,
		38,
		44,
		56,
		65,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		126,
		120,
		91,
		84,
		88,
		-1,
		76,
		78,
		72,
		87,
		62,
		59,
		50,
		41,
		37,
		41,
		45,
		59,
		63,
		191,
		-1,
		154,
		-1,
		-1,
		-1,
		144,
		159,
		130,
		107,
		80,
		75,
		68,
		62,
		67,
		78,
		70,
		81,
		48,
		44,
		34,
		33,
		37,
		54,
		54,
		-1,
		-1,
		152,
		148,
		170,
		152,
		156,
		157,
		-1,
		-1,
		84,
		75,
		66,
		58,
		71,
		74,
		54,
		51,
		45,
		38,
		32,
		42,
		53,
		48,
		-1,
		-1,
		-1,
		164,
		-1,
		166,
		-1,
		-1,
		154,
		155,
		102,
		84,
		80,
		78,
		67,
		61,
		49,
		54,
		55,
		46,
		40,
		28,
		28,
		51,
		40,
		57,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		143,
		135,
		130,
		136,
		138,
		129,
		117,
		114,
		-1,
		84,
		90,
		55,
		62,
		45,
		52,
		50,
		42,
		22,
		25,
		41,
		40,
		35,
		49,
		40,
		44,
		-1,
		-1,
		229,
		218,
		207,
		213,
		-1,
		136,
		132,
		122,
		112,
		115,
		-1,
		-1,
		109,
		106,
		86,
		55,
		53,
		46,
		41,
		51,
		31,
		18,
		18,
		13,
		28,
		33,
		35,
		28,
		35,
		50,
		-1,
		183,
		220,
		213,
		181,
		189,
		220,
		-1,
		126,
		118,
		129,
		104,
		106,
		-1,
		-1,
		82,
		73,
		74,
		62,
		59,
		61,
		56,
		47,
		27,
		33,
		11,
		18,
		29,
		21,
		25,
		26,
		33,
		44,
		48,
		-1,
		176,
		196,
		175,
		178,
		202,
		216,
		-1,
		123,
		-1,
		-1,
		135,
		107,
		91,
		81,
		78,
		121,
		76,
		71,
		55,
		53,
		44,
		35,
		35,
		19,
		7,
		4,
		13,
		18,
		10,
		36,
		38,
		44,
		-1,
		165,
		176,
		169,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		151,
		-1,
		118,
		-1,
		101,
		105,
		84,
		87,
		69,
		56,
		48,
		35,
		44,
		19,
		15,
		11,
		0,
		9,
		20,
		32,
		42,
		44,
		190,
		146,
		149,
		160,
		171,
		186,
		190,
		-1,
		135,
		174,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		115,
		97,
		89,
		89,
		68,
		68,
		42,
		38,
		24,
		20,
		27,
		17,
		9,
		13,
		26,
		37,
		52,
		186,
		177,
		190,
		135,
		135,
		156,
		165,
		186,
		150,
		141,
		168,
		175,
		164,
		159,
		146,
		-1,
		-1,
		138,
		107,
		-1,
		-1,
		75,
		63,
		46,
		35,
		31,
		34,
		42,
		26,
		16,
		14,
		8,
		40,
		-1,
		179,
		178,
		167,
		164,
		140,
		131,
		126,
		153,
		-1,
		-1,
		148,
		169,
		159,
		163,
		179,
		204,
		-1,
		135,
		-1,
		-1,
		119,
		-1,
		-1,
		104,
		68,
		57,
		48,
		46,
		39,
		46,
		57,
		22,
		23,
		13,
		23,
		36,
		163,
		160,
		148,
		146,
		169,
		134,
		122,
		-1,
		135,
		133,
		139,
		146,
		163,
		193,
		-1,
		-1,
		151,
		131,
		-1,
		-1,
		102,
		100,
		89,
		-1,
		79,
		53,
		47,
		66,
		42,
		31,
		25,
		19,
		26,
		25,
		33,
		41,
		172,
		186,
		175,
		171,
		170,
		178,
		127,
		120,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		141,
		137,
		-1,
		-1,
		97,
		90,
		78,
		66,
		56,
		61,
		47,
		43,
		29,
		22,
		17,
		28,
		20,
		24,
		41,
		-1,
		206,
		-1,
		158,
		134,
		148,
		163,
		171,
		-1,
		-1,
		-1,
		158,
		144,
		137,
		125,
		123,
		-1,
		131,
		115,
		96,
		-1,
		66,
		79,
		79,
		47,
		47,
		41,
		23,
		34,
		23,
		26,
		40,
		35,
		-1,
		-1,
		146,
		149,
		-1,
		-1,
		148,
		150,
		-1,
		149,
		138,
		123,
		115,
		-1,
		-1,
		103,
		99,
		-1,
		-1,
		67,
		61,
		50,
		53,
		48,
		27,
		33,
		36,
		25,
		29,
		41,
		-1,
		-1,
		153,
		154,
		155,
		-1,
		133,
		-1,
		151,
		-1,
		118,
		124,
		112,
		-1,
		-1,
		-1,
		105,
		68,
		89,
		68,
		56,
		54,
		45,
		31,
		38,
		36,
		32,
		43,
		-1,
		-1,
		-1,
		151,
		125,
		158,
		149,
		132,
		112,
		104,
		123,
		-1,
		93,
		-1,
		68,
		69,
		82,
		64,
		67,
		61,
		34,
		49,
		39,
		30,
		39,
		157,
		-1,
		127,
		160,
		124,
		118,
		94,
		98,
		114,
		-1,
		90,
		72,
		-1,
		100,
		89,
		83,
		68,
		49,
		36,
		43,
		43,
		36,
		-1,
		-1,
		-1,
		129,
		128,
		120,
		114,
		114,
		99,
		90,
		-1,
		102,
		84,
		63,
		80,
		80,
		71,
		79,
		73,
		69,
		56,
		56,
		48,
		-1,
		230,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		123,
		118,
		91,
		79,
		85,
		81,
		67,
		73,
		75,
		83,
		81,
		78,
		75,
		66,
		72,
		49,
		84,
		-1,
		225,
		-1,
		159,
		-1,
		-1,
		141,
		121,
		113,
		102,
		91,
		89,
		80,
		71,
		93,
		109,
		73,
		61,
		56,
		57,
		-1,
		214,
		213,
		-1,
		160,
		152,
		138,
		-1,
		131,
		-1,
		137,
		98,
		-1,
		100,
		80,
		-1,
		72,
		61,
		-1,
		-1,
		201,
		176,
		-1,
		-1,
		-1,
		161,
		141,
		132,
		116,
		-1,
		91,
		91,
		-1,
		-1,
		-1,
		186,
		185,
		-1,
		154,
		157,
		-1,
		147,
		138,
		146,
		93,
		97,
		-1,
		-1,
		-1,
		195,
		176,
		170,
		169,
		167,
		162,
		159,
		145,
		129,
		107,
		96,
		117,
		-1,
		-1,
		-1,
		167,
		159,
		152,
		-1,
		-1,
		154,
		137,
		118,
		116,
		-1,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		144,
		-1,
		-1,
		150,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		178,
		-1,
		-1,
		-1,
		140,
		136,
		137,
		-1,
		-1,
		-1,
		-1,
		200,
		201,
		224,
		188,
		-1,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		203,
		201,
		-1,
		-1,
		-1,
		160,
		144,
		-1,
		130,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		165,
		-1,
		165,
		140,
		147,
		-1,
		-1,
		-1,
		-1,
		178,
		170,
		178,
		-1,
		150,
		152,
		-1,
		200,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		155,
		162,
		184,
		187,
		223,
		-1,
		174
	],
	[
		-1,
		199,
		188,
		199,
		207,
		180,
		187,
		-1,
		206,
		210,
		176,
		170,
		209,
		178,
		184,
		195,
		-1,
		-1,
		-1,
		199,
		198,
		166,
		164,
		173,
		178,
		185,
		-1,
		184,
		-1,
		220,
		199,
		210,
		215,
		159,
		156,
		176,
		195,
		177,
		169,
		235,
		189,
		160,
		154,
		172,
		162,
		171,
		163,
		-1,
		160,
		150,
		172,
		151,
		162,
		154,
		-1,
		-1,
		154,
		155,
		161,
		147,
		153,
		149,
		-1,
		159,
		143,
		-1,
		-1,
		144,
		145,
		129,
		132,
		140,
		138,
		151,
		143,
		138,
		-1,
		-1,
		135,
		131,
		138,
		125,
		121,
		138,
		151,
		133,
		147,
		146,
		-1,
		139,
		157,
		164,
		132,
		130,
		114,
		112,
		130,
		132,
		138,
		138,
		-1,
		148,
		149,
		144,
		152,
		154,
		130,
		117,
		117,
		127,
		120,
		139,
		127,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		148,
		131,
		148,
		140,
		130,
		145,
		138,
		120,
		117,
		115,
		112,
		128,
		126,
		136,
		-1,
		-1,
		241,
		210,
		239,
		197,
		178,
		-1,
		144,
		124,
		130,
		134,
		128,
		121,
		135,
		131,
		-1,
		106,
		105,
		133,
		119,
		130,
		201,
		-1,
		-1,
		199,
		191,
		174,
		177,
		154,
		150,
		139,
		138,
		130,
		116,
		112,
		118,
		121,
		121,
		127,
		100,
		110,
		114,
		112,
		137,
		-1,
		-1,
		172,
		-1,
		-1,
		198,
		181,
		-1,
		164,
		171,
		160,
		166,
		152,
		173,
		149,
		140,
		132,
		126,
		114,
		116,
		113,
		126,
		114,
		97,
		122,
		126,
		107,
		128,
		123,
		-1,
		171,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		157,
		160,
		166,
		190,
		189,
		-1,
		161,
		149,
		150,
		135,
		132,
		119,
		107,
		120,
		105,
		112,
		111,
		101,
		99,
		129,
		104,
		126,
		123,
		142,
		147,
		141,
		150,
		-1,
		206,
		202,
		198,
		205,
		154,
		-1,
		-1,
		194,
		-1,
		197,
		198,
		173,
		146,
		149,
		136,
		127,
		114,
		103,
		114,
		103,
		100,
		108,
		93,
		108,
		99,
		98,
		116,
		126,
		134,
		138,
		144,
		-1,
		256,
		-1,
		198,
		182,
		184,
		156,
		177,
		-1,
		214,
		198,
		190,
		175,
		175,
		-1,
		145,
		142,
		132,
		110,
		95,
		112,
		104,
		102,
		106,
		88,
		102,
		93,
		111,
		118,
		116,
		120,
		140,
		152,
		216,
		206,
		-1,
		188,
		193,
		152,
		160,
		179,
		217,
		181,
		-1,
		176,
		-1,
		147,
		160,
		-1,
		116,
		112,
		94,
		95,
		90,
		105,
		99,
		84,
		81,
		99,
		102,
		109,
		113,
		129,
		-1,
		-1,
		201,
		205,
		194,
		145,
		164,
		188,
		225,
		174,
		163,
		162,
		-1,
		153,
		130,
		127,
		115,
		102,
		87,
		88,
		96,
		109,
		88,
		83,
		80,
		100,
		126,
		104,
		116,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		171,
		142,
		166,
		208,
		192,
		185,
		173,
		138,
		138,
		132,
		-1,
		126,
		105,
		96,
		85,
		83,
		96,
		93,
		98,
		78,
		76,
		95,
		107,
		98,
		115,
		-1,
		-1,
		-1,
		201,
		190,
		191,
		137,
		160,
		197,
		171,
		157,
		162,
		137,
		130,
		124,
		139,
		122,
		103,
		92,
		84,
		73,
		89,
		97,
		92,
		74,
		83,
		89,
		113,
		103,
		109,
		-1,
		-1,
		208,
		198,
		182,
		184,
		181,
		151,
		158,
		190,
		162,
		175,
		-1,
		129,
		-1,
		118,
		113,
		97,
		92,
		89,
		86,
		80,
		89,
		91,
		81,
		76,
		83,
		118,
		118,
		93,
		113,
		116,
		-1,
		-1,
		-1,
		201,
		196,
		171,
		148,
		132,
		168,
		-1,
		145,
		146,
		-1,
		123,
		117,
		114,
		99,
		95,
		90,
		94,
		87,
		94,
		87,
		85,
		86,
		68,
		100,
		-1,
		101,
		95,
		103,
		93,
		81,
		-1,
		-1,
		-1,
		194,
		173,
		166,
		186,
		127,
		179,
		-1,
		-1,
		130,
		123,
		-1,
		110,
		92,
		99,
		97,
		91,
		95,
		92,
		81,
		94,
		87,
		73,
		75,
		88,
		92,
		96,
		83,
		79,
		76,
		90,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		147,
		-1,
		139,
		131,
		121,
		115,
		109,
		105,
		103,
		119,
		103,
		106,
		104,
		95,
		103,
		76,
		69,
		76,
		65,
		83,
		91,
		83,
		77,
		76,
		86,
		-1,
		214,
		200,
		171,
		-1,
		-1,
		160,
		-1,
		124,
		138,
		154,
		-1,
		147,
		126,
		141,
		119,
		115,
		111,
		126,
		127,
		105,
		104,
		102,
		93,
		81,
		70,
		73,
		65,
		87,
		87,
		71,
		72,
		76,
		-1,
		220,
		207,
		165,
		161,
		150,
		170,
		121,
		109,
		141,
		-1,
		-1,
		183,
		-1,
		117,
		134,
		125,
		123,
		116,
		107,
		113,
		113,
		90,
		85,
		75,
		64,
		64,
		59,
		81,
		67,
		65,
		74,
		90,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		136,
		123,
		117,
		-1,
		158,
		-1,
		161,
		151,
		135,
		120,
		153,
		-1,
		118,
		108,
		113,
		-1,
		110,
		-1,
		83,
		80,
		71,
		56,
		53,
		64,
		62,
		73,
		69,
		-1,
		170,
		155,
		148,
		138,
		152,
		123,
		-1,
		178,
		-1,
		-1,
		148,
		142,
		142,
		126,
		129,
		134,
		114,
		106,
		113,
		105,
		97,
		91,
		69,
		62,
		59,
		52,
		65,
		75,
		80,
		67,
		-1,
		-1,
		-1,
		175,
		161,
		165,
		125,
		144,
		-1,
		-1,
		210,
		165,
		151,
		-1,
		135,
		134,
		122,
		112,
		102,
		107,
		108,
		88,
		81,
		67,
		69,
		63,
		54,
		53,
		69,
		61,
		83,
		-1,
		-1,
		158,
		163,
		151,
		137,
		156,
		-1,
		-1,
		-1,
		157,
		173,
		162,
		136,
		123,
		-1,
		-1,
		106,
		99,
		93,
		84,
		71,
		83,
		78,
		62,
		47,
		62,
		66,
		74,
		65,
		-1,
		161,
		148,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		90,
		75,
		87,
		94,
		64,
		49,
		43,
		49,
		61,
		70,
		-1,
		-1,
		173,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		83,
		77,
		92,
		67,
		64,
		55,
		46,
		42,
		46,
		50,
		64,
		68,
		196,
		-1,
		159,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		72,
		83,
		75,
		86,
		53,
		49,
		39,
		38,
		42,
		59,
		59,
		-1,
		-1,
		157,
		153,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		63,
		76,
		79,
		59,
		56,
		50,
		43,
		37,
		47,
		58,
		53,
		-1,
		-1,
		-1,
		169,
		-1,
		171,
		-1,
		-1,
		159,
		160,
		107,
		89,
		85,
		83,
		72,
		66,
		54,
		59,
		60,
		51,
		45,
		33,
		33,
		56,
		45,
		62,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		148,
		140,
		135,
		141,
		143,
		134,
		122,
		119,
		-1,
		89,
		95,
		60,
		67,
		50,
		57,
		55,
		47,
		27,
		30,
		46,
		45,
		40,
		54,
		45,
		49,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		141,
		137,
		127,
		117,
		120,
		-1,
		-1,
		114,
		111,
		91,
		60,
		58,
		51,
		46,
		56,
		36,
		23,
		23,
		18,
		33,
		38,
		40,
		33,
		40,
		55,
		-1,
		188,
		225,
		218,
		186,
		194,
		225,
		-1,
		131,
		123,
		134,
		109,
		111,
		-1,
		-1,
		87,
		78,
		79,
		67,
		64,
		66,
		61,
		52,
		32,
		38,
		16,
		23,
		34,
		26,
		30,
		31,
		38,
		49,
		53,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		128,
		-1,
		-1,
		140,
		112,
		96,
		86,
		83,
		126,
		81,
		76,
		60,
		58,
		49,
		40,
		40,
		24,
		12,
		9,
		18,
		23,
		15,
		41,
		43,
		49,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		156,
		-1,
		123,
		-1,
		106,
		110,
		89,
		92,
		74,
		61,
		53,
		40,
		49,
		24,
		20,
		16,
		5,
		0,
		12,
		33,
		43,
		49,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		140,
		179,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		120,
		102,
		94,
		94,
		73,
		73,
		47,
		43,
		29,
		25,
		32,
		22,
		10,
		4,
		27,
		38,
		53,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		155,
		146,
		173,
		180,
		169,
		164,
		151,
		-1,
		-1,
		143,
		112,
		-1,
		-1,
		80,
		68,
		51,
		40,
		36,
		39,
		47,
		31,
		17,
		15,
		9,
		41,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		174,
		164,
		168,
		184,
		209,
		-1,
		140,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		73,
		62,
		53,
		51,
		44,
		51,
		62,
		23,
		24,
		14,
		24,
		37,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		168,
		198,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		58,
		52,
		71,
		47,
		36,
		30,
		24,
		31,
		26,
		34,
		42,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		66,
		52,
		48,
		34,
		27,
		22,
		33,
		21,
		25,
		42,
		-1,
		211,
		-1,
		163,
		139,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		84,
		52,
		52,
		46,
		28,
		39,
		24,
		27,
		41,
		36,
		-1,
		-1,
		151,
		154,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		66,
		55,
		58,
		53,
		32,
		38,
		37,
		26,
		30,
		42,
		-1,
		-1,
		158,
		159,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		110,
		73,
		94,
		73,
		61,
		59,
		50,
		36,
		41,
		37,
		33,
		44,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		73,
		74,
		87,
		69,
		72,
		66,
		39,
		54,
		40,
		31,
		40,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		77,
		-1,
		105,
		94,
		88,
		73,
		54,
		41,
		48,
		44,
		37,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		83,
		78,
		74,
		61,
		61,
		53,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		85,
		82,
		78,
		69,
		75,
		52,
		85,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		76,
		64,
		59,
		60,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		75,
		64,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		218,
		222,
		188,
		182,
		221,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		211,
		210,
		178,
		176,
		185,
		190,
		197,
		-1,
		196,
		-1,
		232,
		211,
		222,
		227,
		171,
		168,
		188,
		207,
		189,
		181,
		247,
		201,
		172,
		166,
		184,
		174,
		183,
		175,
		-1,
		172,
		162,
		184,
		163,
		174,
		166,
		-1,
		-1,
		166,
		167,
		173,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		156,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		151,
		169,
		176,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		150,
		-1,
		160,
		161,
		156,
		164,
		166,
		142,
		129,
		129,
		139,
		132,
		151,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		143,
		160,
		152,
		142,
		157,
		150,
		132,
		129,
		127,
		124,
		140,
		138,
		148,
		-1,
		-1,
		253,
		222,
		251,
		209,
		190,
		-1,
		156,
		136,
		142,
		146,
		140,
		133,
		147,
		143,
		-1,
		118,
		117,
		145,
		131,
		142,
		213,
		-1,
		-1,
		211,
		203,
		186,
		189,
		166,
		162,
		151,
		150,
		142,
		128,
		124,
		130,
		133,
		133,
		139,
		112,
		122,
		126,
		124,
		149,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		193,
		-1,
		176,
		183,
		172,
		178,
		164,
		185,
		161,
		152,
		144,
		138,
		126,
		128,
		125,
		138,
		126,
		109,
		134,
		138,
		119,
		140,
		135,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		169,
		172,
		178,
		202,
		201,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		113,
		111,
		141,
		116,
		138,
		135,
		154,
		159,
		153,
		162,
		-1,
		218,
		214,
		210,
		217,
		166,
		-1,
		-1,
		206,
		-1,
		209,
		210,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		105,
		120,
		111,
		110,
		128,
		138,
		146,
		150,
		156,
		-1,
		268,
		-1,
		210,
		194,
		196,
		168,
		189,
		-1,
		226,
		210,
		202,
		187,
		187,
		-1,
		157,
		154,
		144,
		122,
		107,
		124,
		116,
		114,
		118,
		100,
		114,
		105,
		123,
		130,
		128,
		132,
		152,
		164,
		228,
		218,
		-1,
		200,
		205,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		111,
		96,
		93,
		111,
		114,
		121,
		125,
		141,
		-1,
		-1,
		213,
		217,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		142,
		139,
		127,
		114,
		99,
		100,
		108,
		121,
		100,
		95,
		92,
		112,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		108,
		105,
		110,
		90,
		88,
		107,
		119,
		110,
		127,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		151,
		134,
		115,
		104,
		96,
		85,
		101,
		109,
		104,
		86,
		95,
		101,
		125,
		115,
		121,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		98,
		92,
		101,
		103,
		93,
		88,
		95,
		130,
		130,
		105,
		125,
		128,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		102,
		106,
		99,
		106,
		99,
		97,
		98,
		80,
		112,
		-1,
		113,
		107,
		115,
		105,
		93,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		111,
		109,
		103,
		107,
		104,
		93,
		106,
		99,
		85,
		87,
		100,
		104,
		108,
		95,
		91,
		88,
		102,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		118,
		116,
		107,
		115,
		88,
		81,
		88,
		77,
		95,
		103,
		95,
		89,
		88,
		98,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		116,
		114,
		105,
		93,
		82,
		85,
		77,
		99,
		99,
		83,
		84,
		88,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		125,
		102,
		97,
		87,
		76,
		76,
		71,
		93,
		79,
		77,
		86,
		100,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		130,
		120,
		125,
		-1,
		122,
		-1,
		95,
		92,
		83,
		68,
		65,
		76,
		74,
		85,
		81,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		146,
		126,
		118,
		125,
		117,
		109,
		103,
		81,
		74,
		71,
		64,
		77,
		87,
		92,
		79,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		146,
		134,
		124,
		114,
		119,
		120,
		100,
		93,
		79,
		81,
		75,
		66,
		65,
		81,
		73,
		95,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		174,
		148,
		135,
		-1,
		-1,
		118,
		111,
		105,
		96,
		83,
		95,
		90,
		74,
		59,
		74,
		78,
		86,
		77,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		186,
		131,
		120,
		115,
		119,
		117,
		-1,
		91,
		102,
		87,
		99,
		106,
		76,
		61,
		55,
		61,
		73,
		82,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		143,
		137,
		108,
		101,
		105,
		-1,
		93,
		95,
		89,
		104,
		79,
		76,
		67,
		58,
		54,
		58,
		62,
		72,
		78,
		208,
		-1,
		171,
		-1,
		-1,
		-1,
		161,
		176,
		147,
		124,
		97,
		92,
		85,
		79,
		84,
		95,
		87,
		98,
		65,
		61,
		51,
		50,
		54,
		71,
		67,
		-1,
		-1,
		169,
		165,
		187,
		169,
		173,
		174,
		-1,
		-1,
		101,
		92,
		83,
		75,
		88,
		91,
		71,
		68,
		62,
		55,
		49,
		59,
		66,
		61,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		172,
		119,
		101,
		97,
		95,
		84,
		78,
		66,
		71,
		72,
		63,
		57,
		45,
		45,
		68,
		53,
		66,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		134,
		131,
		-1,
		101,
		107,
		72,
		79,
		62,
		69,
		67,
		59,
		39,
		42,
		58,
		56,
		44,
		58,
		49,
		53,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		103,
		72,
		70,
		63,
		58,
		68,
		48,
		35,
		35,
		30,
		45,
		46,
		41,
		37,
		44,
		59,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		78,
		73,
		64,
		44,
		50,
		28,
		35,
		46,
		38,
		28,
		33,
		42,
		53,
		57,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		95,
		138,
		93,
		88,
		72,
		70,
		61,
		52,
		52,
		36,
		24,
		21,
		30,
		22,
		19,
		40,
		47,
		53,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		168,
		-1,
		135,
		-1,
		118,
		122,
		101,
		104,
		86,
		73,
		65,
		52,
		61,
		36,
		32,
		28,
		17,
		12,
		0,
		22,
		36,
		53,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		152,
		191,
		185,
		-1,
		169,
		-1,
		-1,
		-1,
		132,
		114,
		106,
		106,
		85,
		85,
		59,
		55,
		41,
		37,
		44,
		34,
		22,
		16,
		32,
		27,
		48,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		167,
		158,
		185,
		192,
		181,
		176,
		163,
		-1,
		-1,
		155,
		124,
		-1,
		-1,
		92,
		80,
		63,
		52,
		48,
		51,
		59,
		43,
		29,
		27,
		21,
		32,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		186,
		176,
		180,
		196,
		221,
		-1,
		152,
		-1,
		-1,
		136,
		-1,
		-1,
		121,
		85,
		74,
		65,
		63,
		56,
		63,
		74,
		35,
		36,
		26,
		36,
		46,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		70,
		64,
		83,
		59,
		48,
		42,
		36,
		43,
		38,
		46,
		51,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		78,
		64,
		60,
		46,
		39,
		34,
		45,
		33,
		37,
		54,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		96,
		64,
		64,
		58,
		40,
		51,
		36,
		39,
		53,
		48,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		78,
		67,
		70,
		65,
		44,
		50,
		49,
		38,
		42,
		54,
		-1,
		-1,
		170,
		171,
		172,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		122,
		85,
		106,
		85,
		73,
		71,
		62,
		48,
		53,
		49,
		45,
		56,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		86,
		99,
		81,
		84,
		78,
		51,
		66,
		52,
		43,
		52,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		117,
		106,
		100,
		85,
		66,
		53,
		60,
		56,
		49,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		97,
		88,
		95,
		90,
		86,
		73,
		73,
		65,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		100,
		97,
		94,
		90,
		81,
		87,
		64,
		97,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		126,
		88,
		76,
		71,
		72,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		87,
		76,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		223,
		212,
		223,
		231,
		204,
		211,
		-1,
		230,
		234,
		200,
		194,
		233,
		202,
		208,
		219,
		-1,
		-1,
		-1,
		223,
		222,
		190,
		188,
		197,
		202,
		209,
		-1,
		208,
		-1,
		244,
		223,
		234,
		239,
		183,
		180,
		200,
		219,
		201,
		193,
		259,
		213,
		184,
		178,
		196,
		186,
		195,
		187,
		-1,
		184,
		174,
		196,
		175,
		186,
		178,
		-1,
		-1,
		178,
		179,
		185,
		171,
		177,
		173,
		-1,
		183,
		167,
		-1,
		-1,
		168,
		169,
		153,
		156,
		164,
		162,
		175,
		167,
		162,
		-1,
		-1,
		159,
		155,
		162,
		149,
		145,
		162,
		175,
		157,
		171,
		170,
		-1,
		163,
		181,
		188,
		156,
		154,
		138,
		136,
		154,
		156,
		162,
		162,
		-1,
		172,
		173,
		168,
		176,
		178,
		154,
		141,
		141,
		151,
		144,
		163,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		155,
		172,
		164,
		154,
		169,
		162,
		144,
		141,
		139,
		136,
		152,
		150,
		160,
		-1,
		-1,
		265,
		234,
		263,
		221,
		202,
		-1,
		168,
		148,
		154,
		158,
		152,
		145,
		159,
		155,
		-1,
		130,
		129,
		157,
		143,
		154,
		225,
		-1,
		-1,
		223,
		215,
		198,
		201,
		178,
		174,
		163,
		162,
		154,
		140,
		136,
		142,
		145,
		145,
		151,
		124,
		134,
		138,
		136,
		161,
		-1,
		-1,
		196,
		-1,
		-1,
		222,
		205,
		-1,
		188,
		195,
		184,
		190,
		176,
		197,
		173,
		164,
		156,
		150,
		138,
		140,
		137,
		150,
		138,
		121,
		146,
		150,
		131,
		152,
		147,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		181,
		184,
		190,
		214,
		213,
		-1,
		185,
		173,
		174,
		159,
		156,
		143,
		131,
		144,
		129,
		136,
		135,
		125,
		123,
		153,
		128,
		150,
		147,
		166,
		171,
		165,
		174,
		-1,
		230,
		226,
		222,
		229,
		178,
		-1,
		-1,
		218,
		-1,
		221,
		222,
		197,
		170,
		173,
		160,
		151,
		138,
		127,
		138,
		127,
		124,
		132,
		117,
		132,
		123,
		122,
		140,
		150,
		158,
		162,
		168,
		-1,
		280,
		-1,
		222,
		206,
		208,
		180,
		201,
		-1,
		238,
		222,
		214,
		199,
		199,
		-1,
		169,
		166,
		156,
		134,
		119,
		136,
		128,
		126,
		130,
		112,
		126,
		117,
		135,
		142,
		140,
		144,
		164,
		176,
		240,
		230,
		-1,
		212,
		217,
		176,
		184,
		203,
		241,
		205,
		-1,
		200,
		-1,
		171,
		184,
		-1,
		140,
		136,
		118,
		119,
		114,
		129,
		123,
		108,
		105,
		123,
		126,
		133,
		137,
		153,
		-1,
		-1,
		225,
		229,
		218,
		169,
		188,
		212,
		249,
		198,
		187,
		186,
		-1,
		177,
		154,
		151,
		139,
		126,
		111,
		112,
		120,
		133,
		112,
		107,
		104,
		124,
		150,
		128,
		140,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		195,
		166,
		190,
		232,
		216,
		209,
		197,
		162,
		162,
		156,
		-1,
		150,
		129,
		120,
		109,
		107,
		120,
		117,
		122,
		102,
		100,
		119,
		131,
		122,
		139,
		-1,
		-1,
		-1,
		225,
		214,
		215,
		161,
		184,
		221,
		195,
		181,
		186,
		161,
		154,
		148,
		163,
		146,
		127,
		116,
		108,
		97,
		113,
		121,
		116,
		98,
		107,
		113,
		137,
		127,
		133,
		-1,
		-1,
		232,
		222,
		206,
		208,
		205,
		175,
		182,
		214,
		186,
		199,
		-1,
		153,
		-1,
		142,
		137,
		121,
		116,
		113,
		110,
		104,
		113,
		115,
		105,
		100,
		107,
		142,
		142,
		117,
		137,
		140,
		-1,
		-1,
		-1,
		225,
		220,
		195,
		172,
		156,
		192,
		-1,
		169,
		170,
		-1,
		147,
		141,
		138,
		123,
		119,
		114,
		118,
		111,
		118,
		111,
		109,
		110,
		92,
		124,
		-1,
		125,
		119,
		127,
		117,
		105,
		-1,
		-1,
		-1,
		218,
		197,
		190,
		210,
		151,
		203,
		-1,
		-1,
		154,
		147,
		-1,
		134,
		116,
		123,
		121,
		115,
		119,
		116,
		105,
		118,
		111,
		97,
		99,
		112,
		116,
		120,
		107,
		103,
		100,
		114,
		-1,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		171,
		-1,
		163,
		155,
		145,
		139,
		133,
		129,
		127,
		143,
		127,
		130,
		128,
		119,
		127,
		100,
		93,
		100,
		89,
		107,
		115,
		107,
		101,
		100,
		110,
		-1,
		238,
		224,
		195,
		-1,
		-1,
		184,
		-1,
		148,
		162,
		178,
		-1,
		171,
		150,
		165,
		143,
		139,
		135,
		150,
		151,
		129,
		128,
		126,
		117,
		105,
		94,
		97,
		89,
		111,
		111,
		95,
		96,
		100,
		-1,
		244,
		231,
		189,
		185,
		174,
		194,
		145,
		133,
		165,
		-1,
		-1,
		207,
		-1,
		141,
		158,
		149,
		147,
		140,
		131,
		137,
		137,
		114,
		109,
		99,
		88,
		88,
		83,
		105,
		91,
		89,
		98,
		99,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		160,
		147,
		141,
		-1,
		182,
		-1,
		185,
		175,
		159,
		144,
		177,
		-1,
		142,
		132,
		137,
		-1,
		134,
		-1,
		107,
		104,
		95,
		80,
		77,
		88,
		86,
		97,
		93,
		-1,
		194,
		179,
		172,
		162,
		176,
		147,
		-1,
		202,
		-1,
		-1,
		172,
		166,
		166,
		150,
		153,
		158,
		138,
		130,
		137,
		129,
		121,
		115,
		93,
		86,
		83,
		76,
		89,
		99,
		104,
		91,
		-1,
		-1,
		-1,
		199,
		185,
		189,
		149,
		168,
		-1,
		-1,
		234,
		189,
		175,
		-1,
		159,
		158,
		146,
		136,
		126,
		131,
		132,
		112,
		105,
		91,
		93,
		87,
		78,
		77,
		93,
		85,
		107,
		-1,
		-1,
		182,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		181,
		197,
		186,
		160,
		147,
		-1,
		-1,
		130,
		123,
		117,
		108,
		95,
		107,
		102,
		86,
		71,
		86,
		90,
		98,
		89,
		-1,
		185,
		172,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		198,
		143,
		132,
		127,
		131,
		129,
		-1,
		103,
		114,
		99,
		111,
		118,
		88,
		73,
		67,
		73,
		85,
		86,
		-1,
		-1,
		197,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		155,
		149,
		120,
		113,
		117,
		-1,
		105,
		107,
		101,
		116,
		91,
		88,
		79,
		70,
		66,
		70,
		74,
		71,
		77,
		220,
		-1,
		183,
		-1,
		-1,
		-1,
		173,
		188,
		159,
		136,
		109,
		104,
		97,
		91,
		96,
		107,
		99,
		110,
		77,
		73,
		63,
		62,
		66,
		75,
		69,
		-1,
		-1,
		181,
		177,
		199,
		181,
		185,
		186,
		-1,
		-1,
		113,
		104,
		95,
		87,
		100,
		103,
		83,
		80,
		74,
		67,
		61,
		71,
		68,
		63,
		-1,
		-1,
		-1,
		193,
		-1,
		195,
		-1,
		-1,
		183,
		184,
		131,
		113,
		109,
		107,
		96,
		90,
		78,
		83,
		84,
		75,
		69,
		57,
		57,
		80,
		55,
		65,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		172,
		164,
		159,
		165,
		167,
		158,
		146,
		143,
		-1,
		113,
		119,
		84,
		91,
		74,
		81,
		79,
		71,
		51,
		54,
		70,
		58,
		46,
		57,
		48,
		52,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		165,
		161,
		151,
		141,
		144,
		-1,
		-1,
		138,
		135,
		115,
		84,
		82,
		75,
		70,
		80,
		60,
		47,
		47,
		42,
		55,
		48,
		43,
		36,
		43,
		58,
		-1,
		212,
		249,
		242,
		210,
		218,
		249,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		111,
		102,
		103,
		91,
		88,
		90,
		85,
		76,
		56,
		62,
		40,
		47,
		58,
		50,
		33,
		31,
		36,
		49,
		53,
		-1,
		205,
		225,
		204,
		207,
		231,
		245,
		-1,
		152,
		-1,
		-1,
		164,
		136,
		120,
		110,
		107,
		150,
		105,
		100,
		84,
		82,
		73,
		64,
		64,
		48,
		36,
		33,
		42,
		28,
		18,
		22,
		46,
		47,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		180,
		-1,
		147,
		-1,
		130,
		134,
		113,
		116,
		98,
		85,
		77,
		64,
		73,
		48,
		44,
		40,
		29,
		34,
		22,
		0,
		14,
		34,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		164,
		203,
		197,
		-1,
		181,
		-1,
		-1,
		-1,
		144,
		126,
		118,
		118,
		97,
		97,
		71,
		67,
		53,
		49,
		56,
		46,
		38,
		35,
		10,
		5,
		26,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		179,
		170,
		197,
		204,
		193,
		188,
		175,
		-1,
		-1,
		167,
		136,
		-1,
		-1,
		104,
		92,
		75,
		64,
		60,
		63,
		71,
		55,
		40,
		28,
		28,
		10,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		198,
		188,
		192,
		208,
		233,
		-1,
		164,
		-1,
		-1,
		148,
		-1,
		-1,
		133,
		97,
		86,
		77,
		75,
		68,
		75,
		86,
		46,
		38,
		33,
		34,
		24,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		192,
		222,
		-1,
		-1,
		180,
		160,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		82,
		76,
		95,
		71,
		60,
		54,
		48,
		53,
		42,
		47,
		29,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		166,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		90,
		76,
		72,
		58,
		51,
		46,
		57,
		40,
		44,
		35,
		-1,
		235,
		-1,
		187,
		163,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		108,
		76,
		76,
		70,
		52,
		63,
		43,
		46,
		43,
		41,
		-1,
		-1,
		175,
		178,
		-1,
		-1,
		177,
		179,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		96,
		90,
		79,
		82,
		77,
		56,
		62,
		56,
		45,
		44,
		44,
		-1,
		-1,
		182,
		183,
		184,
		-1,
		162,
		-1,
		180,
		-1,
		147,
		153,
		141,
		-1,
		-1,
		-1,
		134,
		97,
		118,
		97,
		85,
		83,
		74,
		60,
		60,
		56,
		52,
		54,
		-1,
		-1,
		-1,
		180,
		154,
		187,
		178,
		161,
		141,
		133,
		152,
		-1,
		122,
		-1,
		97,
		98,
		111,
		93,
		96,
		90,
		63,
		78,
		59,
		50,
		59,
		186,
		-1,
		156,
		189,
		153,
		147,
		123,
		127,
		143,
		-1,
		119,
		101,
		-1,
		129,
		118,
		112,
		97,
		78,
		65,
		72,
		63,
		56,
		-1,
		-1,
		-1,
		158,
		157,
		149,
		143,
		143,
		128,
		119,
		-1,
		131,
		113,
		92,
		109,
		109,
		100,
		102,
		102,
		98,
		85,
		85,
		72,
		-1,
		259,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		152,
		147,
		120,
		108,
		114,
		110,
		96,
		102,
		104,
		112,
		104,
		101,
		97,
		88,
		94,
		71,
		104,
		-1,
		254,
		-1,
		188,
		-1,
		-1,
		170,
		150,
		142,
		131,
		120,
		118,
		109,
		100,
		122,
		138,
		95,
		83,
		78,
		79,
		-1,
		243,
		242,
		-1,
		189,
		181,
		167,
		-1,
		160,
		-1,
		166,
		127,
		-1,
		129,
		109,
		-1,
		94,
		83,
		-1,
		-1,
		230,
		205,
		-1,
		-1,
		-1,
		190,
		170,
		161,
		145,
		-1,
		120,
		120,
		-1,
		-1,
		-1,
		215,
		214,
		-1,
		183,
		186,
		-1,
		176,
		167,
		175,
		122,
		126,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		198,
		196,
		191,
		188,
		174,
		158,
		136,
		125,
		146,
		-1,
		-1,
		-1,
		196,
		188,
		181,
		-1,
		-1,
		183,
		166,
		147,
		145,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		173,
		-1,
		-1,
		179,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		207,
		-1,
		-1,
		-1,
		169,
		165,
		166,
		-1,
		-1,
		-1,
		-1,
		229,
		230,
		253,
		217,
		-1,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		232,
		230,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		194,
		-1,
		194,
		169,
		176,
		-1,
		-1,
		-1,
		-1,
		207,
		199,
		207,
		-1,
		179,
		181,
		-1,
		229,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		184,
		191,
		213,
		216,
		252,
		-1,
		203
	],
	[
		-1,
		235,
		224,
		235,
		243,
		216,
		223,
		-1,
		242,
		246,
		212,
		206,
		245,
		214,
		220,
		231,
		-1,
		-1,
		-1,
		235,
		234,
		202,
		200,
		209,
		214,
		221,
		-1,
		220,
		-1,
		256,
		235,
		246,
		251,
		195,
		192,
		212,
		231,
		213,
		205,
		271,
		225,
		196,
		190,
		208,
		198,
		207,
		199,
		-1,
		196,
		186,
		208,
		187,
		198,
		190,
		-1,
		-1,
		190,
		191,
		197,
		183,
		189,
		185,
		-1,
		195,
		179,
		-1,
		-1,
		180,
		181,
		165,
		168,
		176,
		174,
		187,
		179,
		174,
		-1,
		-1,
		171,
		167,
		174,
		161,
		157,
		174,
		187,
		169,
		183,
		182,
		-1,
		175,
		193,
		200,
		168,
		166,
		150,
		148,
		166,
		168,
		174,
		174,
		-1,
		184,
		185,
		180,
		188,
		190,
		166,
		153,
		153,
		163,
		156,
		175,
		163,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		184,
		167,
		184,
		176,
		166,
		181,
		174,
		156,
		153,
		151,
		148,
		164,
		162,
		172,
		-1,
		-1,
		277,
		246,
		275,
		233,
		214,
		-1,
		180,
		160,
		166,
		170,
		164,
		157,
		171,
		167,
		-1,
		142,
		141,
		169,
		155,
		166,
		237,
		-1,
		-1,
		235,
		227,
		210,
		213,
		190,
		186,
		175,
		174,
		166,
		152,
		148,
		154,
		157,
		157,
		163,
		136,
		146,
		150,
		148,
		173,
		-1,
		-1,
		208,
		-1,
		-1,
		234,
		217,
		-1,
		200,
		207,
		196,
		202,
		188,
		209,
		185,
		176,
		168,
		162,
		150,
		152,
		149,
		162,
		150,
		133,
		158,
		162,
		143,
		164,
		159,
		-1,
		207,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		193,
		196,
		202,
		226,
		225,
		-1,
		197,
		185,
		186,
		171,
		168,
		155,
		143,
		156,
		141,
		148,
		147,
		137,
		135,
		165,
		140,
		162,
		159,
		178,
		183,
		177,
		186,
		-1,
		242,
		238,
		234,
		241,
		190,
		-1,
		-1,
		230,
		-1,
		233,
		234,
		209,
		182,
		185,
		172,
		163,
		150,
		139,
		150,
		139,
		136,
		144,
		129,
		144,
		135,
		134,
		152,
		162,
		170,
		174,
		180,
		-1,
		292,
		-1,
		234,
		218,
		220,
		192,
		213,
		-1,
		250,
		234,
		226,
		211,
		211,
		-1,
		181,
		178,
		168,
		146,
		131,
		148,
		140,
		138,
		142,
		124,
		138,
		129,
		147,
		154,
		152,
		156,
		176,
		188,
		252,
		242,
		-1,
		224,
		229,
		188,
		196,
		215,
		253,
		217,
		-1,
		212,
		-1,
		183,
		196,
		-1,
		152,
		148,
		130,
		131,
		126,
		141,
		135,
		120,
		117,
		135,
		138,
		145,
		149,
		165,
		-1,
		-1,
		237,
		241,
		230,
		181,
		200,
		224,
		261,
		210,
		199,
		198,
		-1,
		189,
		166,
		163,
		151,
		138,
		123,
		124,
		132,
		145,
		124,
		119,
		116,
		136,
		162,
		140,
		151,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		207,
		178,
		202,
		244,
		228,
		221,
		209,
		174,
		174,
		168,
		-1,
		162,
		141,
		132,
		121,
		119,
		132,
		129,
		134,
		114,
		112,
		131,
		143,
		134,
		142,
		-1,
		-1,
		-1,
		237,
		226,
		227,
		173,
		196,
		233,
		207,
		193,
		198,
		173,
		166,
		160,
		175,
		158,
		139,
		128,
		120,
		109,
		125,
		133,
		128,
		110,
		119,
		125,
		149,
		130,
		136,
		-1,
		-1,
		244,
		234,
		218,
		220,
		217,
		187,
		194,
		226,
		198,
		211,
		-1,
		165,
		-1,
		154,
		149,
		133,
		128,
		125,
		122,
		116,
		125,
		127,
		117,
		112,
		119,
		154,
		154,
		120,
		140,
		143,
		-1,
		-1,
		-1,
		237,
		232,
		207,
		184,
		168,
		204,
		-1,
		181,
		182,
		-1,
		159,
		153,
		150,
		135,
		131,
		126,
		130,
		123,
		130,
		123,
		121,
		122,
		104,
		136,
		-1,
		128,
		122,
		130,
		120,
		108,
		-1,
		-1,
		-1,
		230,
		209,
		202,
		222,
		163,
		215,
		-1,
		-1,
		166,
		159,
		-1,
		146,
		128,
		135,
		133,
		127,
		131,
		128,
		117,
		130,
		123,
		109,
		111,
		124,
		128,
		132,
		110,
		106,
		103,
		106,
		-1,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		183,
		-1,
		175,
		167,
		157,
		151,
		145,
		141,
		139,
		155,
		139,
		142,
		140,
		131,
		139,
		112,
		105,
		112,
		101,
		119,
		127,
		119,
		109,
		101,
		102,
		-1,
		250,
		236,
		207,
		-1,
		-1,
		196,
		-1,
		160,
		174,
		190,
		-1,
		183,
		162,
		177,
		155,
		151,
		147,
		162,
		163,
		141,
		140,
		138,
		129,
		117,
		106,
		109,
		101,
		123,
		123,
		107,
		104,
		97,
		-1,
		256,
		243,
		201,
		197,
		186,
		206,
		157,
		145,
		177,
		-1,
		-1,
		219,
		-1,
		153,
		170,
		161,
		159,
		152,
		143,
		149,
		149,
		126,
		121,
		111,
		100,
		100,
		95,
		117,
		103,
		101,
		95,
		87,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		172,
		159,
		153,
		-1,
		194,
		-1,
		197,
		187,
		171,
		156,
		189,
		-1,
		154,
		144,
		149,
		-1,
		146,
		-1,
		119,
		116,
		107,
		92,
		89,
		100,
		98,
		109,
		96,
		-1,
		206,
		191,
		184,
		174,
		188,
		159,
		-1,
		214,
		-1,
		-1,
		184,
		178,
		178,
		162,
		165,
		170,
		150,
		142,
		149,
		141,
		133,
		127,
		105,
		98,
		95,
		88,
		101,
		111,
		110,
		94,
		-1,
		-1,
		-1,
		211,
		197,
		201,
		161,
		180,
		-1,
		-1,
		246,
		201,
		187,
		-1,
		171,
		170,
		158,
		148,
		138,
		143,
		144,
		124,
		117,
		103,
		105,
		99,
		90,
		89,
		101,
		93,
		98,
		-1,
		-1,
		194,
		199,
		187,
		173,
		192,
		-1,
		-1,
		-1,
		193,
		209,
		198,
		172,
		159,
		-1,
		-1,
		142,
		135,
		129,
		120,
		107,
		119,
		114,
		98,
		83,
		98,
		96,
		88,
		80,
		-1,
		197,
		184,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		-1,
		-1,
		210,
		155,
		144,
		139,
		143,
		141,
		-1,
		115,
		126,
		111,
		123,
		130,
		100,
		85,
		79,
		81,
		91,
		74,
		-1,
		-1,
		209,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		167,
		161,
		132,
		125,
		129,
		-1,
		117,
		119,
		113,
		128,
		103,
		100,
		91,
		82,
		78,
		78,
		78,
		59,
		65,
		232,
		-1,
		195,
		-1,
		-1,
		-1,
		185,
		200,
		171,
		148,
		121,
		116,
		109,
		103,
		108,
		119,
		111,
		122,
		89,
		85,
		75,
		74,
		74,
		63,
		63,
		-1,
		-1,
		193,
		189,
		211,
		193,
		197,
		198,
		-1,
		-1,
		125,
		116,
		107,
		99,
		112,
		115,
		95,
		92,
		86,
		79,
		73,
		83,
		62,
		57,
		-1,
		-1,
		-1,
		205,
		-1,
		207,
		-1,
		-1,
		195,
		196,
		143,
		125,
		121,
		119,
		108,
		102,
		90,
		95,
		98,
		88,
		80,
		69,
		63,
		73,
		49,
		53,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		184,
		176,
		171,
		177,
		179,
		170,
		158,
		155,
		-1,
		125,
		131,
		96,
		103,
		86,
		93,
		92,
		84,
		63,
		60,
		66,
		52,
		40,
		45,
		36,
		44,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		177,
		173,
		163,
		153,
		156,
		-1,
		-1,
		150,
		147,
		127,
		96,
		94,
		87,
		82,
		92,
		72,
		59,
		53,
		56,
		43,
		42,
		37,
		30,
		35,
		50,
		-1,
		224,
		261,
		254,
		222,
		230,
		261,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		123,
		114,
		115,
		103,
		100,
		102,
		97,
		88,
		70,
		76,
		54,
		55,
		72,
		57,
		47,
		29,
		22,
		35,
		39,
		-1,
		217,
		237,
		216,
		219,
		243,
		257,
		-1,
		164,
		-1,
		-1,
		176,
		148,
		132,
		122,
		119,
		162,
		117,
		112,
		96,
		94,
		85,
		76,
		78,
		62,
		50,
		47,
		56,
		42,
		32,
		8,
		32,
		33,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		192,
		-1,
		159,
		-1,
		142,
		146,
		125,
		128,
		110,
		97,
		89,
		78,
		87,
		62,
		58,
		54,
		43,
		48,
		36,
		14,
		0,
		36,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		176,
		215,
		209,
		-1,
		193,
		-1,
		-1,
		-1,
		156,
		138,
		130,
		130,
		109,
		109,
		83,
		81,
		67,
		63,
		70,
		60,
		52,
		47,
		22,
		10,
		31,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		191,
		182,
		209,
		216,
		205,
		200,
		187,
		-1,
		-1,
		179,
		148,
		-1,
		-1,
		116,
		104,
		87,
		78,
		74,
		77,
		85,
		69,
		52,
		40,
		40,
		15,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		210,
		200,
		204,
		220,
		245,
		-1,
		176,
		-1,
		-1,
		161,
		-1,
		-1,
		146,
		109,
		98,
		89,
		89,
		82,
		89,
		100,
		58,
		50,
		45,
		39,
		29,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		192,
		172,
		-1,
		-1,
		144,
		142,
		131,
		-1,
		121,
		94,
		90,
		109,
		85,
		74,
		67,
		61,
		65,
		52,
		52,
		34,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		139,
		132,
		120,
		108,
		98,
		104,
		90,
		86,
		72,
		65,
		60,
		71,
		52,
		56,
		40,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		173,
		157,
		138,
		-1,
		108,
		121,
		122,
		90,
		90,
		84,
		66,
		77,
		55,
		56,
		48,
		46,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		189,
		191,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		104,
		93,
		96,
		91,
		70,
		76,
		68,
		57,
		49,
		49,
		-1,
		-1,
		194,
		195,
		196,
		-1,
		174,
		-1,
		192,
		-1,
		159,
		165,
		153,
		-1,
		-1,
		-1,
		147,
		110,
		131,
		111,
		99,
		97,
		88,
		74,
		72,
		68,
		64,
		59,
		-1,
		-1,
		-1,
		192,
		166,
		199,
		190,
		173,
		153,
		145,
		164,
		-1,
		134,
		-1,
		109,
		111,
		125,
		107,
		110,
		104,
		77,
		92,
		71,
		62,
		65,
		198,
		-1,
		168,
		201,
		165,
		159,
		135,
		139,
		155,
		-1,
		131,
		113,
		-1,
		137,
		124,
		126,
		111,
		92,
		79,
		84,
		69,
		62,
		-1,
		-1,
		-1,
		170,
		169,
		161,
		155,
		155,
		140,
		131,
		-1,
		143,
		125,
		104,
		121,
		117,
		108,
		108,
		116,
		112,
		99,
		99,
		78,
		-1,
		271,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		164,
		159,
		132,
		120,
		126,
		122,
		108,
		114,
		116,
		120,
		110,
		107,
		103,
		94,
		100,
		77,
		110,
		-1,
		266,
		-1,
		200,
		-1,
		-1,
		182,
		162,
		154,
		143,
		132,
		130,
		121,
		112,
		134,
		150,
		101,
		89,
		84,
		85,
		-1,
		255,
		254,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		178,
		139,
		-1,
		141,
		121,
		-1,
		100,
		89,
		-1,
		-1,
		242,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		173,
		157,
		-1,
		132,
		132,
		-1,
		-1,
		-1,
		227,
		226,
		-1,
		195,
		198,
		-1,
		188,
		179,
		187,
		134,
		138,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		210,
		208,
		203,
		200,
		186,
		170,
		148,
		137,
		158,
		-1,
		-1,
		-1,
		208,
		200,
		193,
		-1,
		-1,
		195,
		178,
		159,
		157,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		185,
		-1,
		-1,
		191,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		219,
		-1,
		-1,
		-1,
		181,
		177,
		178,
		-1,
		-1,
		-1,
		-1,
		241,
		242,
		265,
		229,
		-1,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		244,
		242,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		171,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		206,
		-1,
		206,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		219,
		211,
		219,
		-1,
		191,
		193,
		-1,
		241,
		-1,
		-1,
		234,
		225,
		-1,
		-1,
		196,
		203,
		225,
		228,
		264,
		-1,
		215
	],
	[
		-1,
		233,
		222,
		233,
		241,
		214,
		221,
		-1,
		240,
		244,
		210,
		204,
		243,
		212,
		218,
		229,
		-1,
		-1,
		-1,
		233,
		232,
		200,
		198,
		207,
		212,
		219,
		-1,
		218,
		-1,
		254,
		233,
		244,
		249,
		193,
		190,
		210,
		229,
		211,
		203,
		269,
		223,
		194,
		188,
		206,
		196,
		205,
		197,
		-1,
		194,
		184,
		206,
		185,
		196,
		188,
		-1,
		-1,
		188,
		189,
		195,
		181,
		187,
		183,
		-1,
		193,
		177,
		-1,
		-1,
		178,
		179,
		163,
		166,
		174,
		172,
		185,
		177,
		172,
		-1,
		-1,
		169,
		165,
		172,
		159,
		155,
		172,
		185,
		167,
		181,
		180,
		-1,
		173,
		191,
		198,
		166,
		164,
		148,
		146,
		164,
		166,
		172,
		172,
		-1,
		182,
		183,
		178,
		186,
		188,
		164,
		151,
		151,
		161,
		154,
		173,
		161,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		182,
		165,
		182,
		174,
		164,
		179,
		172,
		154,
		151,
		149,
		146,
		162,
		160,
		170,
		-1,
		-1,
		275,
		244,
		273,
		231,
		212,
		-1,
		178,
		158,
		164,
		168,
		162,
		155,
		169,
		165,
		-1,
		140,
		139,
		167,
		153,
		164,
		235,
		-1,
		-1,
		233,
		225,
		208,
		211,
		188,
		184,
		173,
		172,
		164,
		150,
		146,
		152,
		155,
		155,
		161,
		134,
		144,
		148,
		146,
		171,
		-1,
		-1,
		205,
		-1,
		-1,
		232,
		215,
		-1,
		198,
		205,
		194,
		200,
		186,
		207,
		183,
		174,
		166,
		160,
		148,
		150,
		147,
		160,
		148,
		131,
		156,
		160,
		141,
		162,
		157,
		-1,
		204,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		191,
		194,
		200,
		224,
		223,
		-1,
		195,
		183,
		184,
		169,
		166,
		153,
		141,
		154,
		139,
		146,
		145,
		135,
		133,
		163,
		138,
		160,
		157,
		175,
		180,
		174,
		183,
		-1,
		240,
		236,
		232,
		239,
		188,
		-1,
		-1,
		228,
		-1,
		231,
		232,
		207,
		180,
		183,
		170,
		161,
		148,
		137,
		148,
		137,
		134,
		142,
		127,
		142,
		133,
		132,
		150,
		159,
		167,
		171,
		177,
		-1,
		290,
		-1,
		232,
		216,
		218,
		190,
		211,
		-1,
		248,
		232,
		224,
		209,
		209,
		-1,
		179,
		176,
		166,
		144,
		129,
		146,
		138,
		136,
		140,
		122,
		136,
		127,
		145,
		152,
		149,
		153,
		173,
		185,
		250,
		240,
		-1,
		222,
		227,
		186,
		194,
		213,
		251,
		215,
		-1,
		210,
		-1,
		181,
		194,
		-1,
		150,
		146,
		128,
		129,
		124,
		139,
		133,
		118,
		115,
		133,
		136,
		142,
		146,
		162,
		-1,
		-1,
		235,
		239,
		228,
		179,
		198,
		222,
		259,
		208,
		197,
		196,
		-1,
		187,
		164,
		161,
		149,
		136,
		121,
		122,
		130,
		143,
		122,
		117,
		114,
		134,
		159,
		137,
		148,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		205,
		176,
		200,
		242,
		226,
		219,
		207,
		172,
		172,
		166,
		-1,
		160,
		139,
		130,
		119,
		117,
		130,
		127,
		132,
		112,
		110,
		129,
		140,
		131,
		139,
		-1,
		-1,
		-1,
		235,
		224,
		225,
		171,
		194,
		231,
		205,
		191,
		196,
		171,
		164,
		158,
		173,
		156,
		137,
		126,
		118,
		107,
		123,
		131,
		126,
		108,
		117,
		123,
		146,
		127,
		133,
		-1,
		-1,
		242,
		232,
		216,
		218,
		215,
		185,
		192,
		224,
		196,
		209,
		-1,
		163,
		-1,
		152,
		147,
		131,
		126,
		123,
		120,
		114,
		123,
		125,
		115,
		110,
		117,
		151,
		151,
		117,
		137,
		140,
		-1,
		-1,
		-1,
		235,
		230,
		205,
		182,
		166,
		202,
		-1,
		179,
		180,
		-1,
		157,
		151,
		148,
		133,
		129,
		124,
		128,
		121,
		128,
		121,
		119,
		120,
		102,
		134,
		-1,
		125,
		119,
		127,
		117,
		105,
		-1,
		-1,
		-1,
		228,
		207,
		200,
		220,
		161,
		213,
		-1,
		-1,
		164,
		157,
		-1,
		144,
		126,
		133,
		131,
		125,
		129,
		126,
		115,
		128,
		121,
		107,
		109,
		122,
		126,
		129,
		107,
		103,
		100,
		103,
		-1,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		181,
		-1,
		173,
		165,
		155,
		149,
		143,
		139,
		137,
		153,
		137,
		140,
		138,
		129,
		137,
		110,
		103,
		110,
		99,
		117,
		125,
		116,
		106,
		98,
		99,
		-1,
		248,
		234,
		205,
		-1,
		-1,
		194,
		-1,
		158,
		172,
		188,
		-1,
		181,
		160,
		175,
		153,
		149,
		145,
		160,
		161,
		139,
		138,
		136,
		127,
		115,
		104,
		107,
		99,
		121,
		120,
		104,
		101,
		94,
		-1,
		254,
		241,
		199,
		195,
		184,
		204,
		155,
		143,
		175,
		-1,
		-1,
		217,
		-1,
		151,
		168,
		159,
		157,
		150,
		141,
		147,
		147,
		124,
		119,
		109,
		98,
		98,
		93,
		115,
		101,
		99,
		92,
		84,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		170,
		157,
		151,
		-1,
		192,
		-1,
		195,
		185,
		169,
		154,
		187,
		-1,
		152,
		142,
		147,
		-1,
		144,
		-1,
		117,
		114,
		105,
		90,
		87,
		98,
		96,
		107,
		93,
		-1,
		204,
		189,
		182,
		172,
		186,
		157,
		-1,
		212,
		-1,
		-1,
		182,
		176,
		176,
		160,
		163,
		168,
		148,
		140,
		147,
		139,
		131,
		125,
		103,
		96,
		93,
		86,
		99,
		109,
		107,
		91,
		-1,
		-1,
		-1,
		209,
		195,
		199,
		159,
		178,
		-1,
		-1,
		244,
		199,
		185,
		-1,
		169,
		168,
		156,
		146,
		136,
		141,
		142,
		122,
		115,
		101,
		103,
		97,
		88,
		87,
		98,
		90,
		95,
		-1,
		-1,
		192,
		197,
		185,
		171,
		190,
		-1,
		-1,
		-1,
		191,
		207,
		196,
		170,
		157,
		-1,
		-1,
		140,
		133,
		127,
		118,
		105,
		117,
		112,
		96,
		81,
		96,
		93,
		85,
		77,
		-1,
		195,
		182,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		-1,
		-1,
		208,
		153,
		142,
		137,
		141,
		139,
		-1,
		113,
		124,
		109,
		121,
		128,
		98,
		83,
		77,
		78,
		88,
		71,
		-1,
		-1,
		207,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		165,
		159,
		130,
		123,
		127,
		-1,
		115,
		117,
		111,
		126,
		101,
		98,
		89,
		80,
		76,
		75,
		75,
		56,
		62,
		230,
		-1,
		193,
		-1,
		-1,
		-1,
		183,
		198,
		169,
		146,
		119,
		114,
		107,
		101,
		106,
		117,
		109,
		120,
		87,
		83,
		73,
		72,
		71,
		60,
		61,
		-1,
		-1,
		191,
		187,
		209,
		191,
		195,
		196,
		-1,
		-1,
		123,
		114,
		105,
		97,
		110,
		113,
		93,
		90,
		84,
		77,
		71,
		81,
		60,
		55,
		-1,
		-1,
		-1,
		203,
		-1,
		205,
		-1,
		-1,
		193,
		194,
		141,
		123,
		119,
		117,
		106,
		100,
		88,
		93,
		96,
		86,
		78,
		67,
		61,
		71,
		47,
		50,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		182,
		174,
		169,
		175,
		177,
		168,
		156,
		153,
		-1,
		123,
		129,
		94,
		101,
		84,
		91,
		90,
		82,
		61,
		58,
		64,
		50,
		38,
		42,
		33,
		37,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		175,
		171,
		161,
		151,
		154,
		-1,
		-1,
		148,
		145,
		125,
		94,
		92,
		85,
		80,
		90,
		70,
		57,
		51,
		55,
		41,
		40,
		35,
		28,
		28,
		43,
		-1,
		222,
		259,
		252,
		220,
		228,
		259,
		-1,
		165,
		157,
		168,
		143,
		145,
		-1,
		-1,
		121,
		112,
		113,
		101,
		98,
		100,
		95,
		86,
		71,
		77,
		55,
		53,
		70,
		55,
		48,
		31,
		20,
		30,
		34,
		-1,
		215,
		235,
		214,
		217,
		241,
		255,
		-1,
		162,
		-1,
		-1,
		174,
		146,
		130,
		120,
		117,
		160,
		115,
		110,
		94,
		92,
		83,
		74,
		79,
		63,
		51,
		48,
		57,
		43,
		33,
		28,
		24,
		31,
		-1,
		204,
		215,
		208,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		190,
		-1,
		157,
		-1,
		140,
		144,
		123,
		126,
		108,
		95,
		87,
		79,
		88,
		63,
		59,
		55,
		44,
		53,
		43,
		38,
		35,
		0,
		229,
		185,
		188,
		199,
		210,
		225,
		229,
		-1,
		174,
		213,
		207,
		-1,
		191,
		-1,
		-1,
		-1,
		154,
		136,
		128,
		128,
		107,
		107,
		81,
		82,
		68,
		64,
		71,
		61,
		53,
		57,
		48,
		36,
		8,
		225,
		216,
		229,
		174,
		174,
		195,
		204,
		225,
		189,
		180,
		207,
		214,
		203,
		198,
		185,
		-1,
		-1,
		177,
		146,
		-1,
		-1,
		114,
		102,
		85,
		79,
		75,
		78,
		86,
		70,
		60,
		58,
		52,
		31,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		165,
		192,
		-1,
		-1,
		187,
		208,
		198,
		202,
		218,
		243,
		-1,
		174,
		-1,
		-1,
		159,
		-1,
		-1,
		144,
		107,
		96,
		87,
		90,
		83,
		90,
		101,
		66,
		67,
		57,
		51,
		45,
		202,
		199,
		187,
		185,
		208,
		173,
		161,
		-1,
		174,
		172,
		178,
		185,
		202,
		232,
		-1,
		-1,
		190,
		170,
		-1,
		-1,
		142,
		140,
		129,
		-1,
		119,
		92,
		91,
		110,
		86,
		75,
		69,
		63,
		70,
		64,
		66,
		50,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		159,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		180,
		176,
		-1,
		-1,
		137,
		130,
		118,
		106,
		96,
		105,
		91,
		87,
		73,
		66,
		61,
		72,
		64,
		68,
		54,
		-1,
		245,
		-1,
		197,
		173,
		187,
		202,
		210,
		-1,
		-1,
		-1,
		197,
		183,
		176,
		164,
		162,
		-1,
		171,
		155,
		136,
		-1,
		106,
		119,
		123,
		91,
		91,
		85,
		67,
		78,
		67,
		70,
		61,
		60,
		-1,
		-1,
		185,
		188,
		-1,
		-1,
		187,
		189,
		-1,
		188,
		177,
		162,
		154,
		-1,
		-1,
		143,
		139,
		-1,
		-1,
		107,
		105,
		94,
		97,
		92,
		71,
		77,
		80,
		69,
		63,
		61,
		-1,
		-1,
		192,
		193,
		194,
		-1,
		172,
		-1,
		190,
		-1,
		157,
		163,
		151,
		-1,
		-1,
		-1,
		145,
		108,
		129,
		112,
		100,
		98,
		89,
		75,
		82,
		80,
		76,
		71,
		-1,
		-1,
		-1,
		190,
		164,
		197,
		188,
		171,
		151,
		143,
		162,
		-1,
		132,
		-1,
		107,
		109,
		126,
		108,
		111,
		105,
		78,
		93,
		83,
		74,
		77,
		196,
		-1,
		166,
		199,
		163,
		157,
		133,
		137,
		153,
		-1,
		129,
		111,
		-1,
		139,
		129,
		127,
		112,
		93,
		80,
		87,
		81,
		74,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		153,
		138,
		129,
		-1,
		141,
		123,
		102,
		119,
		119,
		110,
		118,
		117,
		113,
		100,
		100,
		90,
		-1,
		269,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		157,
		130,
		118,
		124,
		120,
		106,
		112,
		114,
		122,
		120,
		117,
		115,
		106,
		112,
		89,
		122,
		-1,
		264,
		-1,
		198,
		-1,
		-1,
		180,
		160,
		152,
		141,
		130,
		128,
		119,
		110,
		132,
		148,
		113,
		101,
		96,
		97,
		-1,
		253,
		252,
		-1,
		199,
		191,
		177,
		-1,
		170,
		-1,
		176,
		137,
		-1,
		139,
		119,
		-1,
		112,
		101,
		-1,
		-1,
		240,
		215,
		-1,
		-1,
		-1,
		200,
		180,
		171,
		155,
		-1,
		130,
		130,
		-1,
		-1,
		-1,
		225,
		224,
		-1,
		193,
		196,
		-1,
		186,
		177,
		185,
		132,
		136,
		-1,
		-1,
		-1,
		234,
		215,
		209,
		208,
		206,
		201,
		198,
		184,
		168,
		146,
		135,
		156,
		-1,
		-1,
		-1,
		206,
		198,
		191,
		-1,
		-1,
		193,
		176,
		157,
		155,
		-1,
		-1,
		-1,
		228,
		209,
		-1,
		-1,
		183,
		-1,
		-1,
		189,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		217,
		-1,
		-1,
		-1,
		179,
		175,
		176,
		-1,
		-1,
		-1,
		-1,
		239,
		240,
		263,
		227,
		-1,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		242,
		240,
		-1,
		-1,
		-1,
		199,
		183,
		-1,
		169,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		204,
		-1,
		204,
		179,
		186,
		-1,
		-1,
		-1,
		-1,
		217,
		209,
		217,
		-1,
		189,
		191,
		-1,
		239,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		194,
		201,
		223,
		226,
		262,
		-1,
		213
	],
	[
		-1,
		350,
		339,
		350,
		358,
		331,
		338,
		-1,
		357,
		361,
		327,
		321,
		360,
		329,
		335,
		346,
		-1,
		-1,
		-1,
		350,
		349,
		317,
		315,
		324,
		329,
		336,
		-1,
		335,
		-1,
		371,
		350,
		361,
		366,
		310,
		307,
		327,
		346,
		328,
		320,
		386,
		340,
		311,
		305,
		323,
		313,
		322,
		314,
		-1,
		311,
		301,
		323,
		302,
		313,
		305,
		-1,
		-1,
		305,
		306,
		312,
		298,
		304,
		300,
		-1,
		310,
		294,
		-1,
		-1,
		295,
		296,
		280,
		283,
		291,
		289,
		302,
		294,
		289,
		-1,
		-1,
		286,
		282,
		289,
		276,
		272,
		289,
		302,
		284,
		298,
		297,
		-1,
		292,
		310,
		315,
		283,
		281,
		265,
		263,
		281,
		283,
		289,
		289,
		-1,
		291,
		293,
		297,
		305,
		305,
		281,
		268,
		268,
		278,
		271,
		290,
		278,
		324,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		288,
		284,
		301,
		293,
		283,
		298,
		291,
		271,
		268,
		266,
		263,
		279,
		277,
		287,
		-1,
		-1,
		344,
		313,
		348,
		305,
		290,
		-1,
		284,
		277,
		283,
		287,
		281,
		274,
		288,
		284,
		-1,
		257,
		256,
		284,
		270,
		281,
		304,
		-1,
		-1,
		302,
		294,
		279,
		282,
		279,
		279,
		292,
		291,
		283,
		269,
		265,
		271,
		274,
		274,
		280,
		251,
		261,
		265,
		263,
		288,
		-1,
		-1,
		323,
		-1,
		-1,
		301,
		284,
		-1,
		267,
		274,
		274,
		291,
		281,
		302,
		302,
		293,
		285,
		279,
		267,
		269,
		266,
		279,
		267,
		248,
		273,
		277,
		258,
		279,
		274,
		-1,
		322,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		260,
		263,
		269,
		293,
		303,
		-1,
		314,
		302,
		303,
		288,
		285,
		272,
		260,
		273,
		258,
		265,
		264,
		252,
		250,
		280,
		255,
		277,
		274,
		293,
		298,
		292,
		301,
		-1,
		309,
		305,
		301,
		308,
		257,
		-1,
		-1,
		297,
		-1,
		311,
		324,
		326,
		299,
		302,
		289,
		280,
		267,
		256,
		267,
		256,
		253,
		261,
		244,
		259,
		250,
		249,
		267,
		277,
		285,
		289,
		295,
		-1,
		359,
		-1,
		301,
		285,
		287,
		259,
		280,
		-1,
		317,
		312,
		332,
		328,
		324,
		-1,
		298,
		295,
		285,
		263,
		248,
		265,
		257,
		255,
		257,
		239,
		253,
		244,
		262,
		269,
		267,
		271,
		291,
		303,
		319,
		309,
		-1,
		291,
		296,
		255,
		263,
		282,
		355,
		330,
		-1,
		325,
		-1,
		300,
		313,
		-1,
		269,
		265,
		247,
		248,
		243,
		258,
		250,
		235,
		232,
		250,
		253,
		260,
		264,
		280,
		-1,
		-1,
		304,
		308,
		297,
		248,
		267,
		291,
		328,
		323,
		312,
		311,
		-1,
		302,
		283,
		280,
		268,
		255,
		240,
		241,
		249,
		261,
		240,
		234,
		231,
		251,
		277,
		255,
		266,
		-1,
		-1,
		-1,
		329,
		-1,
		-1,
		274,
		245,
		269,
		311,
		341,
		334,
		322,
		287,
		287,
		281,
		-1,
		279,
		258,
		249,
		238,
		236,
		249,
		241,
		249,
		229,
		227,
		246,
		258,
		249,
		257,
		-1,
		-1,
		-1,
		304,
		293,
		294,
		243,
		266,
		300,
		320,
		306,
		311,
		286,
		279,
		273,
		292,
		275,
		256,
		245,
		237,
		226,
		237,
		245,
		243,
		225,
		234,
		240,
		264,
		245,
		251,
		-1,
		-1,
		311,
		301,
		285,
		287,
		284,
		257,
		264,
		296,
		311,
		308,
		-1,
		278,
		-1,
		267,
		265,
		250,
		245,
		242,
		229,
		228,
		242,
		242,
		232,
		227,
		234,
		269,
		269,
		235,
		255,
		258,
		-1,
		-1,
		-1,
		304,
		302,
		277,
		254,
		238,
		274,
		-1,
		278,
		279,
		-1,
		272,
		266,
		265,
		252,
		248,
		233,
		237,
		239,
		242,
		230,
		236,
		237,
		219,
		243,
		-1,
		243,
		237,
		245,
		235,
		223,
		-1,
		-1,
		-1,
		300,
		279,
		272,
		292,
		233,
		285,
		-1,
		-1,
		263,
		256,
		-1,
		259,
		243,
		245,
		240,
		236,
		238,
		235,
		224,
		237,
		230,
		224,
		218,
		231,
		235,
		236,
		225,
		221,
		218,
		232,
		-1,
		319,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		253,
		-1,
		266,
		258,
		254,
		248,
		254,
		256,
		254,
		264,
		248,
		250,
		246,
		238,
		233,
		219,
		212,
		223,
		208,
		226,
		232,
		223,
		218,
		217,
		228,
		-1,
		320,
		306,
		277,
		-1,
		-1,
		266,
		-1,
		230,
		244,
		260,
		-1,
		288,
		267,
		290,
		268,
		266,
		257,
		255,
		256,
		226,
		231,
		233,
		221,
		224,
		213,
		216,
		208,
		230,
		227,
		211,
		213,
		222,
		-1,
		326,
		313,
		271,
		267,
		256,
		276,
		227,
		236,
		247,
		-1,
		-1,
		317,
		-1,
		266,
		273,
		271,
		269,
		245,
		220,
		227,
		245,
		218,
		213,
		218,
		207,
		207,
		202,
		221,
		207,
		205,
		220,
		236,
		-1,
		-1,
		-1,
		293,
		-1,
		-1,
		242,
		229,
		223,
		-1,
		264,
		-1,
		295,
		283,
		270,
		252,
		292,
		-1,
		219,
		215,
		222,
		-1,
		238,
		-1,
		210,
		213,
		204,
		199,
		196,
		207,
		205,
		214,
		215,
		-1,
		276,
		261,
		254,
		244,
		258,
		229,
		-1,
		272,
		-1,
		-1,
		282,
		276,
		276,
		245,
		242,
		235,
		215,
		207,
		222,
		221,
		208,
		207,
		195,
		195,
		198,
		192,
		205,
		215,
		221,
		213,
		-1,
		-1,
		-1,
		281,
		233,
		241,
		217,
		238,
		-1,
		-1,
		343,
		299,
		285,
		-1,
		237,
		235,
		223,
		213,
		203,
		208,
		209,
		199,
		197,
		193,
		202,
		201,
		194,
		193,
		214,
		207,
		229,
		-1,
		-1,
		230,
		243,
		245,
		231,
		231,
		-1,
		-1,
		-1,
		289,
		290,
		256,
		235,
		224,
		-1,
		-1,
		207,
		200,
		194,
		197,
		185,
		205,
		212,
		200,
		187,
		202,
		212,
		220,
		219,
		-1,
		233,
		220,
		-1,
		-1,
		230,
		220,
		-1,
		-1,
		-1,
		-1,
		268,
		213,
		202,
		197,
		201,
		206,
		-1,
		180,
		191,
		184,
		203,
		210,
		202,
		187,
		181,
		192,
		207,
		224,
		-1,
		-1,
		244,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		225,
		219,
		190,
		183,
		187,
		-1,
		182,
		184,
		181,
		193,
		198,
		202,
		193,
		175,
		189,
		192,
		205,
		219,
		223,
		267,
		-1,
		197,
		-1,
		-1,
		-1,
		236,
		237,
		223,
		200,
		179,
		172,
		169,
		168,
		173,
		184,
		193,
		204,
		169,
		173,
		188,
		193,
		197,
		214,
		218,
		-1,
		-1,
		195,
		191,
		226,
		238,
		210,
		250,
		-1,
		-1,
		168,
		161,
		171,
		164,
		177,
		180,
		165,
		167,
		185,
		198,
		192,
		202,
		217,
		212,
		-1,
		-1,
		-1,
		193,
		-1,
		209,
		-1,
		-1,
		200,
		241,
		188,
		170,
		166,
		152,
		159,
		153,
		155,
		160,
		179,
		174,
		183,
		188,
		192,
		215,
		204,
		243,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		159,
		178,
		173,
		179,
		184,
		175,
		203,
		200,
		-1,
		149,
		182,
		150,
		164,
		160,
		167,
		172,
		178,
		182,
		189,
		205,
		204,
		199,
		235,
		226,
		232,
		-1,
		-1,
		179,
		168,
		157,
		163,
		-1,
		152,
		175,
		165,
		155,
		161,
		-1,
		-1,
		167,
		164,
		162,
		142,
		148,
		153,
		156,
		194,
		170,
		178,
		182,
		186,
		192,
		197,
		202,
		208,
		223,
		238,
		-1,
		133,
		170,
		163,
		131,
		139,
		170,
		-1,
		142,
		134,
		162,
		147,
		155,
		-1,
		-1,
		140,
		131,
		136,
		145,
		146,
		177,
		176,
		189,
		192,
		197,
		185,
		184,
		202,
		206,
		215,
		222,
		212,
		225,
		229,
		-1,
		126,
		146,
		125,
		128,
		152,
		166,
		-1,
		133,
		-1,
		-1,
		178,
		165,
		149,
		139,
		136,
		183,
		159,
		154,
		160,
		162,
		186,
		177,
		202,
		193,
		193,
		196,
		211,
		216,
		208,
		222,
		222,
		223,
		-1,
		115,
		126,
		119,
		-1,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		194,
		-1,
		176,
		-1,
		159,
		163,
		167,
		170,
		185,
		172,
		179,
		196,
		202,
		191,
		201,
		197,
		198,
		207,
		218,
		230,
		229,
		230,
		0,
		71,
		99,
		110,
		121,
		136,
		140,
		-1,
		117,
		153,
		163,
		-1,
		203,
		-1,
		-1,
		-1,
		173,
		180,
		172,
		188,
		184,
		184,
		180,
		184,
		196,
		203,
		213,
		215,
		207,
		211,
		224,
		235,
		238,
		9,
		60,
		125,
		70,
		85,
		106,
		115,
		136,
		113,
		110,
		147,
		152,
		167,
		172,
		196,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		191,
		201,
		184,
		186,
		190,
		204,
		216,
		224,
		214,
		212,
		206,
		238,
		-1,
		89,
		59,
		77,
		74,
		60,
		70,
		76,
		103,
		-1,
		-1,
		111,
		138,
		122,
		126,
		142,
		167,
		-1,
		203,
		-1,
		-1,
		217,
		-1,
		-1,
		243,
		206,
		195,
		186,
		192,
		198,
		209,
		231,
		220,
		221,
		211,
		221,
		234,
		73,
		70,
		58,
		56,
		76,
		84,
		79,
		-1,
		98,
		96,
		102,
		109,
		126,
		156,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		236,
		239,
		228,
		-1,
		218,
		191,
		196,
		221,
		228,
		229,
		223,
		217,
		224,
		223,
		231,
		239,
		82,
		96,
		85,
		76,
		77,
		86,
		84,
		83,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		248,
		229,
		-1,
		-1,
		236,
		229,
		217,
		205,
		195,
		205,
		213,
		213,
		216,
		220,
		215,
		226,
		218,
		222,
		239,
		-1,
		111,
		-1,
		115,
		97,
		111,
		126,
		134,
		-1,
		-1,
		-1,
		265,
		251,
		244,
		232,
		230,
		-1,
		270,
		254,
		235,
		-1,
		205,
		218,
		249,
		217,
		222,
		217,
		221,
		232,
		221,
		224,
		238,
		233,
		-1,
		-1,
		109,
		112,
		-1,
		-1,
		134,
		153,
		-1,
		256,
		245,
		230,
		222,
		-1,
		-1,
		242,
		238,
		-1,
		-1,
		206,
		231,
		220,
		228,
		223,
		225,
		231,
		234,
		223,
		227,
		239,
		-1,
		-1,
		116,
		117,
		122,
		-1,
		143,
		-1,
		258,
		-1,
		225,
		232,
		220,
		-1,
		-1,
		-1,
		244,
		207,
		228,
		238,
		243,
		241,
		232,
		229,
		236,
		234,
		230,
		241,
		-1,
		-1,
		-1,
		173,
		150,
		265,
		256,
		239,
		219,
		211,
		231,
		-1,
		232,
		-1,
		207,
		208,
		235,
		237,
		254,
		248,
		232,
		247,
		237,
		228,
		237,
		179,
		-1,
		154,
		213,
		196,
		225,
		191,
		203,
		253,
		-1,
		229,
		211,
		-1,
		239,
		229,
		271,
		252,
		245,
		232,
		239,
		241,
		234,
		-1,
		-1,
		-1,
		169,
		168,
		167,
		178,
		186,
		184,
		202,
		-1,
		241,
		223,
		202,
		219,
		219,
		210,
		218,
		261,
		257,
		250,
		252,
		242,
		-1,
		183,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		195,
		217,
		212,
		204,
		216,
		220,
		206,
		212,
		214,
		222,
		220,
		217,
		229,
		225,
		245,
		241,
		273,
		-1,
		190,
		-1,
		199,
		-1,
		-1,
		213,
		199,
		211,
		222,
		212,
		212,
		217,
		210,
		232,
		248,
		232,
		230,
		235,
		240,
		-1,
		200,
		201,
		-1,
		232,
		224,
		210,
		-1,
		203,
		-1,
		258,
		219,
		-1,
		239,
		219,
		-1,
		241,
		237,
		-1,
		-1,
		212,
		248,
		-1,
		-1,
		-1,
		233,
		213,
		253,
		237,
		-1,
		230,
		230,
		-1,
		-1,
		-1,
		226,
		249,
		-1,
		226,
		229,
		-1,
		220,
		226,
		255,
		232,
		236,
		-1,
		-1,
		-1,
		253,
		237,
		242,
		241,
		246,
		234,
		251,
		237,
		239,
		246,
		235,
		256,
		-1,
		-1,
		-1,
		254,
		246,
		246,
		-1,
		-1,
		264,
		247,
		247,
		255,
		-1,
		-1,
		-1,
		276,
		257,
		-1,
		-1,
		255,
		-1,
		-1,
		260,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		-1,
		-1,
		-1,
		256,
		263,
		271,
		-1,
		-1,
		-1,
		-1,
		243,
		244,
		288,
		286,
		-1,
		-1,
		-1,
		270,
		265,
		-1,
		-1,
		241,
		242,
		-1,
		-1,
		-1,
		298,
		282,
		-1,
		269,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		302,
		-1,
		-1,
		-1,
		303,
		-1,
		304,
		279,
		286,
		-1,
		-1,
		-1,
		-1,
		316,
		308,
		317,
		-1,
		289,
		291,
		-1,
		339,
		-1,
		-1,
		331,
		322,
		-1,
		-1,
		294,
		301,
		323,
		326,
		325,
		-1,
		313
	],
	[
		-1,
		304,
		293,
		304,
		312,
		285,
		292,
		-1,
		313,
		315,
		281,
		275,
		314,
		285,
		291,
		302,
		-1,
		-1,
		-1,
		304,
		303,
		273,
		271,
		280,
		285,
		292,
		-1,
		295,
		-1,
		325,
		304,
		315,
		320,
		266,
		263,
		283,
		302,
		288,
		280,
		340,
		296,
		267,
		261,
		279,
		273,
		282,
		274,
		-1,
		267,
		257,
		279,
		262,
		273,
		265,
		-1,
		-1,
		261,
		262,
		268,
		258,
		264,
		260,
		-1,
		270,
		254,
		-1,
		-1,
		251,
		256,
		240,
		243,
		251,
		249,
		262,
		254,
		249,
		-1,
		-1,
		246,
		242,
		249,
		236,
		232,
		249,
		262,
		244,
		258,
		257,
		-1,
		240,
		258,
		267,
		243,
		241,
		225,
		223,
		241,
		243,
		249,
		249,
		-1,
		232,
		234,
		257,
		265,
		265,
		241,
		228,
		228,
		238,
		231,
		250,
		238,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		229,
		237,
		261,
		253,
		243,
		258,
		251,
		231,
		228,
		226,
		223,
		239,
		237,
		247,
		-1,
		-1,
		285,
		254,
		289,
		246,
		231,
		-1,
		225,
		237,
		243,
		247,
		241,
		234,
		248,
		244,
		-1,
		217,
		216,
		244,
		230,
		241,
		245,
		-1,
		-1,
		243,
		235,
		220,
		223,
		220,
		220,
		250,
		249,
		243,
		229,
		225,
		231,
		234,
		234,
		240,
		211,
		221,
		225,
		223,
		248,
		-1,
		-1,
		283,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		215,
		232,
		222,
		243,
		258,
		253,
		245,
		239,
		227,
		229,
		226,
		239,
		227,
		208,
		233,
		237,
		218,
		239,
		234,
		-1,
		282,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		244,
		-1,
		265,
		262,
		263,
		248,
		245,
		232,
		220,
		233,
		218,
		225,
		224,
		212,
		210,
		240,
		215,
		237,
		234,
		253,
		258,
		252,
		261,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		252,
		265,
		272,
		259,
		262,
		249,
		240,
		227,
		216,
		227,
		216,
		213,
		221,
		204,
		219,
		210,
		209,
		227,
		237,
		245,
		249,
		255,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		253,
		273,
		274,
		265,
		-1,
		258,
		255,
		245,
		223,
		208,
		225,
		217,
		215,
		217,
		199,
		213,
		204,
		222,
		229,
		227,
		231,
		251,
		263,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		296,
		271,
		-1,
		266,
		-1,
		258,
		273,
		-1,
		229,
		225,
		207,
		208,
		203,
		218,
		210,
		195,
		192,
		210,
		213,
		220,
		224,
		240,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		264,
		253,
		252,
		-1,
		243,
		243,
		240,
		228,
		215,
		200,
		201,
		209,
		221,
		200,
		194,
		191,
		211,
		237,
		215,
		226,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		282,
		275,
		263,
		228,
		228,
		222,
		-1,
		239,
		218,
		209,
		198,
		196,
		209,
		201,
		209,
		189,
		187,
		206,
		218,
		209,
		217,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		184,
		207,
		241,
		261,
		247,
		252,
		227,
		220,
		214,
		252,
		235,
		216,
		205,
		197,
		186,
		197,
		205,
		203,
		185,
		194,
		200,
		224,
		205,
		211,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		198,
		205,
		237,
		252,
		249,
		-1,
		219,
		-1,
		208,
		216,
		210,
		205,
		202,
		189,
		188,
		202,
		202,
		192,
		187,
		194,
		229,
		229,
		195,
		215,
		218,
		-1,
		-1,
		-1,
		245,
		243,
		218,
		195,
		179,
		215,
		-1,
		219,
		220,
		-1,
		213,
		207,
		213,
		212,
		208,
		193,
		197,
		199,
		202,
		190,
		196,
		197,
		179,
		203,
		-1,
		203,
		197,
		205,
		195,
		183,
		-1,
		-1,
		-1,
		241,
		220,
		213,
		233,
		174,
		226,
		-1,
		-1,
		204,
		197,
		-1,
		200,
		200,
		205,
		200,
		196,
		198,
		195,
		184,
		197,
		190,
		184,
		178,
		191,
		195,
		196,
		185,
		181,
		178,
		192,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		194,
		-1,
		207,
		199,
		195,
		189,
		195,
		213,
		211,
		224,
		208,
		210,
		206,
		198,
		193,
		179,
		172,
		183,
		168,
		186,
		192,
		183,
		178,
		177,
		188,
		-1,
		261,
		247,
		218,
		-1,
		-1,
		207,
		-1,
		171,
		185,
		201,
		-1,
		229,
		208,
		231,
		209,
		223,
		217,
		215,
		216,
		186,
		191,
		193,
		181,
		184,
		173,
		176,
		168,
		190,
		187,
		171,
		173,
		182,
		-1,
		267,
		254,
		212,
		208,
		197,
		217,
		168,
		177,
		188,
		-1,
		-1,
		273,
		-1,
		207,
		224,
		231,
		229,
		205,
		180,
		187,
		205,
		178,
		173,
		178,
		167,
		167,
		162,
		181,
		167,
		165,
		180,
		196,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		183,
		170,
		164,
		-1,
		205,
		-1,
		251,
		241,
		225,
		210,
		243,
		-1,
		179,
		175,
		182,
		-1,
		198,
		-1,
		170,
		173,
		164,
		159,
		156,
		167,
		165,
		174,
		175,
		-1,
		217,
		202,
		195,
		185,
		199,
		170,
		-1,
		213,
		-1,
		-1,
		238,
		232,
		232,
		205,
		202,
		195,
		175,
		167,
		182,
		181,
		168,
		167,
		155,
		155,
		158,
		152,
		165,
		175,
		181,
		173,
		-1,
		-1,
		-1,
		222,
		174,
		182,
		158,
		179,
		-1,
		-1,
		300,
		255,
		241,
		-1,
		197,
		195,
		183,
		173,
		163,
		168,
		169,
		159,
		157,
		153,
		162,
		161,
		154,
		153,
		174,
		167,
		189,
		-1,
		-1,
		171,
		184,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		247,
		250,
		216,
		195,
		184,
		-1,
		-1,
		167,
		160,
		154,
		157,
		145,
		165,
		172,
		160,
		147,
		162,
		172,
		180,
		179,
		-1,
		174,
		161,
		-1,
		-1,
		190,
		180,
		-1,
		-1,
		-1,
		-1,
		228,
		173,
		162,
		157,
		161,
		166,
		-1,
		140,
		151,
		144,
		163,
		170,
		162,
		147,
		141,
		152,
		167,
		184,
		-1,
		-1,
		204,
		-1,
		166,
		-1,
		-1,
		-1,
		-1,
		185,
		179,
		150,
		143,
		147,
		-1,
		142,
		144,
		141,
		153,
		158,
		162,
		153,
		135,
		149,
		152,
		165,
		179,
		183,
		227,
		-1,
		157,
		-1,
		-1,
		-1,
		196,
		197,
		183,
		160,
		139,
		132,
		129,
		128,
		133,
		144,
		153,
		164,
		129,
		133,
		148,
		153,
		157,
		174,
		178,
		-1,
		-1,
		155,
		151,
		186,
		198,
		170,
		210,
		-1,
		-1,
		128,
		121,
		131,
		124,
		137,
		140,
		125,
		127,
		145,
		158,
		152,
		162,
		177,
		172,
		-1,
		-1,
		-1,
		153,
		-1,
		169,
		-1,
		-1,
		160,
		201,
		148,
		130,
		126,
		112,
		119,
		113,
		115,
		120,
		139,
		134,
		143,
		148,
		152,
		175,
		164,
		203,
		-1,
		-1,
		127,
		-1,
		-1,
		-1,
		119,
		138,
		133,
		139,
		144,
		135,
		163,
		160,
		-1,
		109,
		142,
		110,
		124,
		120,
		127,
		132,
		138,
		142,
		149,
		165,
		164,
		159,
		195,
		186,
		192,
		-1,
		-1,
		120,
		109,
		98,
		104,
		-1,
		112,
		135,
		125,
		115,
		121,
		-1,
		-1,
		127,
		124,
		122,
		102,
		108,
		113,
		116,
		154,
		130,
		138,
		142,
		146,
		152,
		157,
		162,
		168,
		183,
		198,
		-1,
		74,
		111,
		104,
		72,
		80,
		111,
		-1,
		102,
		94,
		122,
		107,
		115,
		-1,
		-1,
		100,
		91,
		96,
		105,
		106,
		137,
		136,
		149,
		152,
		157,
		145,
		144,
		162,
		166,
		175,
		182,
		172,
		185,
		189,
		-1,
		67,
		87,
		66,
		69,
		93,
		107,
		-1,
		93,
		-1,
		-1,
		138,
		125,
		109,
		99,
		96,
		143,
		119,
		114,
		120,
		122,
		146,
		137,
		162,
		153,
		153,
		156,
		171,
		176,
		168,
		182,
		182,
		183,
		-1,
		56,
		67,
		60,
		-1,
		-1,
		-1,
		-1,
		87,
		-1,
		-1,
		154,
		-1,
		136,
		-1,
		119,
		123,
		127,
		130,
		145,
		132,
		139,
		156,
		162,
		151,
		161,
		157,
		158,
		167,
		178,
		190,
		189,
		190,
		67,
		0,
		40,
		51,
		62,
		77,
		81,
		-1,
		77,
		113,
		123,
		-1,
		163,
		-1,
		-1,
		-1,
		133,
		140,
		132,
		148,
		144,
		144,
		140,
		144,
		156,
		163,
		173,
		175,
		167,
		171,
		184,
		195,
		198,
		63,
		76,
		66,
		11,
		26,
		47,
		56,
		77,
		73,
		70,
		107,
		112,
		127,
		132,
		156,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		151,
		161,
		144,
		146,
		150,
		164,
		176,
		184,
		174,
		172,
		166,
		198,
		-1,
		78,
		77,
		66,
		63,
		39,
		30,
		17,
		44,
		-1,
		-1,
		71,
		98,
		82,
		86,
		102,
		127,
		-1,
		163,
		-1,
		-1,
		177,
		-1,
		-1,
		203,
		166,
		155,
		146,
		152,
		158,
		169,
		191,
		180,
		181,
		171,
		181,
		194,
		62,
		59,
		47,
		45,
		68,
		25,
		21,
		-1,
		53,
		56,
		62,
		69,
		86,
		116,
		-1,
		-1,
		179,
		170,
		-1,
		-1,
		196,
		199,
		188,
		-1,
		178,
		151,
		156,
		181,
		188,
		189,
		183,
		177,
		184,
		183,
		191,
		199,
		71,
		85,
		74,
		70,
		69,
		77,
		26,
		43,
		50,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		189,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		173,
		173,
		176,
		180,
		175,
		186,
		178,
		182,
		199,
		-1,
		105,
		-1,
		57,
		50,
		65,
		80,
		88,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		209,
		177,
		182,
		177,
		181,
		192,
		181,
		184,
		198,
		193,
		-1,
		-1,
		63,
		66,
		-1,
		-1,
		88,
		107,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		166,
		191,
		180,
		188,
		183,
		185,
		191,
		194,
		183,
		187,
		199,
		-1,
		-1,
		70,
		71,
		76,
		-1,
		97,
		-1,
		212,
		-1,
		179,
		186,
		174,
		-1,
		-1,
		-1,
		204,
		167,
		188,
		198,
		203,
		201,
		192,
		189,
		196,
		194,
		190,
		201,
		-1,
		-1,
		-1,
		127,
		104,
		219,
		210,
		193,
		173,
		165,
		185,
		-1,
		192,
		-1,
		167,
		168,
		195,
		197,
		214,
		208,
		192,
		207,
		197,
		188,
		197,
		133,
		-1,
		108,
		167,
		150,
		179,
		145,
		157,
		213,
		-1,
		189,
		171,
		-1,
		199,
		189,
		231,
		212,
		205,
		192,
		199,
		201,
		194,
		-1,
		-1,
		-1,
		123,
		122,
		121,
		132,
		140,
		138,
		156,
		-1,
		201,
		183,
		162,
		179,
		179,
		170,
		178,
		221,
		217,
		210,
		212,
		202,
		-1,
		177,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		149,
		171,
		166,
		158,
		170,
		179,
		166,
		172,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		201,
		233,
		-1,
		184,
		-1,
		153,
		-1,
		-1,
		167,
		153,
		165,
		176,
		166,
		166,
		171,
		169,
		191,
		208,
		192,
		190,
		195,
		200,
		-1,
		194,
		195,
		-1,
		186,
		178,
		164,
		-1,
		157,
		-1,
		212,
		173,
		-1,
		198,
		178,
		-1,
		201,
		197,
		-1,
		-1,
		206,
		202,
		-1,
		-1,
		-1,
		187,
		167,
		207,
		191,
		-1,
		189,
		189,
		-1,
		-1,
		-1,
		220,
		211,
		-1,
		180,
		183,
		-1,
		174,
		180,
		209,
		191,
		195,
		-1,
		-1,
		-1,
		236,
		217,
		211,
		195,
		200,
		188,
		205,
		191,
		193,
		205,
		194,
		215,
		-1,
		-1,
		-1,
		208,
		200,
		200,
		-1,
		-1,
		218,
		201,
		201,
		214,
		-1,
		-1,
		-1,
		230,
		211,
		-1,
		-1,
		209,
		-1,
		-1,
		214,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		219,
		-1,
		-1,
		-1,
		210,
		217,
		225,
		-1,
		-1,
		-1,
		-1,
		237,
		238,
		265,
		240,
		-1,
		-1,
		-1,
		224,
		224,
		-1,
		-1,
		235,
		236,
		-1,
		-1,
		-1,
		252,
		236,
		-1,
		228,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		257,
		-1,
		263,
		238,
		245,
		-1,
		-1,
		-1,
		-1,
		270,
		262,
		276,
		-1,
		248,
		250,
		-1,
		298,
		-1,
		-1,
		285,
		276,
		-1,
		-1,
		253,
		260,
		282,
		285,
		315,
		-1,
		272
	],
	[
		-1,
		268,
		257,
		268,
		276,
		249,
		256,
		-1,
		277,
		279,
		245,
		239,
		278,
		249,
		255,
		266,
		-1,
		-1,
		-1,
		268,
		267,
		237,
		235,
		244,
		249,
		256,
		-1,
		279,
		-1,
		289,
		268,
		279,
		284,
		230,
		227,
		247,
		266,
		272,
		264,
		304,
		260,
		231,
		225,
		243,
		248,
		266,
		258,
		-1,
		231,
		221,
		243,
		247,
		259,
		242,
		-1,
		-1,
		225,
		226,
		232,
		244,
		249,
		254,
		-1,
		266,
		250,
		-1,
		-1,
		215,
		228,
		224,
		227,
		235,
		245,
		258,
		250,
		245,
		-1,
		-1,
		216,
		220,
		233,
		232,
		228,
		245,
		258,
		240,
		254,
		253,
		-1,
		204,
		222,
		231,
		239,
		237,
		221,
		219,
		237,
		239,
		245,
		245,
		-1,
		196,
		198,
		227,
		233,
		245,
		237,
		224,
		224,
		234,
		227,
		246,
		234,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		193,
		201,
		227,
		226,
		222,
		240,
		247,
		227,
		224,
		222,
		219,
		235,
		233,
		243,
		-1,
		-1,
		249,
		218,
		253,
		210,
		195,
		-1,
		189,
		208,
		214,
		218,
		223,
		230,
		244,
		240,
		-1,
		213,
		212,
		240,
		226,
		237,
		209,
		-1,
		-1,
		207,
		199,
		184,
		187,
		184,
		184,
		214,
		213,
		218,
		220,
		221,
		227,
		230,
		230,
		236,
		207,
		217,
		221,
		219,
		244,
		-1,
		-1,
		279,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		179,
		196,
		186,
		207,
		222,
		226,
		234,
		235,
		223,
		225,
		222,
		235,
		223,
		204,
		229,
		233,
		214,
		235,
		230,
		-1,
		278,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		208,
		-1,
		229,
		227,
		251,
		244,
		241,
		228,
		216,
		229,
		214,
		221,
		220,
		208,
		206,
		236,
		211,
		233,
		230,
		249,
		254,
		248,
		257,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		216,
		229,
		236,
		231,
		234,
		245,
		236,
		223,
		212,
		223,
		212,
		209,
		217,
		200,
		215,
		206,
		205,
		223,
		233,
		241,
		245,
		251,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		217,
		237,
		238,
		229,
		-1,
		232,
		235,
		241,
		219,
		204,
		221,
		213,
		211,
		213,
		195,
		209,
		200,
		218,
		225,
		223,
		227,
		247,
		259,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		260,
		235,
		-1,
		230,
		-1,
		222,
		247,
		-1,
		225,
		221,
		203,
		204,
		199,
		214,
		206,
		191,
		188,
		206,
		209,
		216,
		220,
		236,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		228,
		217,
		216,
		-1,
		207,
		237,
		234,
		220,
		207,
		196,
		197,
		205,
		217,
		196,
		190,
		187,
		207,
		233,
		211,
		222,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		246,
		239,
		227,
		192,
		192,
		186,
		-1,
		227,
		210,
		205,
		194,
		192,
		205,
		197,
		205,
		185,
		183,
		202,
		214,
		205,
		213,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		148,
		171,
		205,
		225,
		211,
		216,
		191,
		184,
		178,
		230,
		227,
		194,
		201,
		193,
		182,
		193,
		201,
		199,
		181,
		190,
		196,
		220,
		201,
		207,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		162,
		169,
		201,
		216,
		213,
		-1,
		183,
		-1,
		172,
		180,
		179,
		185,
		197,
		183,
		184,
		198,
		198,
		188,
		183,
		190,
		225,
		225,
		191,
		211,
		214,
		-1,
		-1,
		-1,
		209,
		207,
		182,
		159,
		143,
		179,
		-1,
		183,
		184,
		-1,
		177,
		171,
		177,
		176,
		183,
		180,
		180,
		194,
		198,
		186,
		192,
		193,
		175,
		199,
		-1,
		199,
		193,
		201,
		191,
		179,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		168,
		161,
		-1,
		164,
		164,
		171,
		180,
		185,
		190,
		191,
		180,
		193,
		186,
		180,
		174,
		187,
		191,
		192,
		181,
		177,
		174,
		188,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		171,
		163,
		159,
		153,
		159,
		177,
		175,
		195,
		187,
		201,
		201,
		194,
		189,
		175,
		168,
		179,
		164,
		182,
		188,
		179,
		174,
		173,
		184,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		149,
		165,
		-1,
		193,
		172,
		195,
		173,
		187,
		183,
		211,
		212,
		182,
		187,
		189,
		177,
		180,
		169,
		172,
		164,
		186,
		183,
		167,
		169,
		178,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		141,
		152,
		-1,
		-1,
		237,
		-1,
		171,
		188,
		197,
		195,
		201,
		176,
		183,
		201,
		174,
		169,
		174,
		163,
		163,
		158,
		177,
		163,
		161,
		176,
		192,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		215,
		205,
		189,
		174,
		207,
		-1,
		175,
		171,
		178,
		-1,
		194,
		-1,
		166,
		169,
		160,
		155,
		152,
		163,
		161,
		170,
		171,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		177,
		-1,
		-1,
		202,
		196,
		196,
		180,
		183,
		191,
		171,
		163,
		178,
		177,
		164,
		163,
		151,
		151,
		154,
		148,
		161,
		171,
		177,
		169,
		-1,
		-1,
		-1,
		186,
		138,
		146,
		122,
		143,
		-1,
		-1,
		264,
		219,
		205,
		-1,
		189,
		191,
		179,
		169,
		159,
		164,
		165,
		155,
		153,
		149,
		158,
		157,
		150,
		149,
		170,
		163,
		185,
		-1,
		-1,
		135,
		148,
		150,
		136,
		155,
		-1,
		-1,
		-1,
		211,
		227,
		212,
		190,
		180,
		-1,
		-1,
		163,
		156,
		150,
		153,
		141,
		161,
		168,
		156,
		143,
		158,
		168,
		176,
		175,
		-1,
		138,
		125,
		-1,
		-1,
		158,
		152,
		-1,
		-1,
		-1,
		-1,
		224,
		169,
		158,
		153,
		157,
		162,
		-1,
		136,
		147,
		140,
		159,
		166,
		158,
		143,
		137,
		148,
		163,
		180,
		-1,
		-1,
		172,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		181,
		175,
		146,
		139,
		143,
		-1,
		138,
		140,
		137,
		149,
		154,
		158,
		149,
		131,
		145,
		148,
		161,
		175,
		179,
		195,
		-1,
		153,
		-1,
		-1,
		-1,
		192,
		193,
		179,
		156,
		135,
		128,
		125,
		124,
		129,
		140,
		149,
		160,
		125,
		129,
		144,
		149,
		153,
		170,
		174,
		-1,
		-1,
		151,
		147,
		182,
		194,
		166,
		206,
		-1,
		-1,
		124,
		117,
		127,
		120,
		133,
		136,
		121,
		123,
		141,
		154,
		148,
		158,
		173,
		168,
		-1,
		-1,
		-1,
		149,
		-1,
		165,
		-1,
		-1,
		156,
		197,
		144,
		126,
		122,
		108,
		115,
		109,
		111,
		116,
		135,
		130,
		139,
		144,
		148,
		171,
		160,
		199,
		-1,
		-1,
		92,
		-1,
		-1,
		-1,
		115,
		134,
		129,
		135,
		140,
		131,
		159,
		156,
		-1,
		105,
		138,
		106,
		120,
		116,
		123,
		128,
		134,
		138,
		145,
		161,
		160,
		155,
		191,
		182,
		188,
		-1,
		-1,
		85,
		74,
		63,
		69,
		-1,
		108,
		131,
		121,
		111,
		117,
		-1,
		-1,
		123,
		120,
		118,
		98,
		104,
		109,
		112,
		150,
		126,
		134,
		138,
		142,
		148,
		153,
		158,
		164,
		179,
		194,
		-1,
		38,
		76,
		69,
		37,
		45,
		76,
		-1,
		98,
		90,
		118,
		103,
		111,
		-1,
		-1,
		96,
		87,
		92,
		101,
		102,
		133,
		132,
		145,
		148,
		153,
		141,
		140,
		158,
		162,
		171,
		178,
		168,
		181,
		185,
		-1,
		31,
		52,
		31,
		34,
		58,
		72,
		-1,
		89,
		-1,
		-1,
		134,
		121,
		105,
		95,
		92,
		139,
		115,
		110,
		116,
		118,
		142,
		133,
		158,
		149,
		149,
		152,
		167,
		172,
		164,
		178,
		178,
		179,
		-1,
		21,
		32,
		25,
		-1,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		150,
		-1,
		132,
		-1,
		115,
		119,
		123,
		126,
		141,
		128,
		135,
		152,
		158,
		147,
		157,
		153,
		154,
		163,
		174,
		186,
		185,
		186,
		78,
		33,
		0,
		16,
		42,
		57,
		61,
		-1,
		73,
		109,
		119,
		-1,
		159,
		-1,
		-1,
		-1,
		129,
		136,
		128,
		144,
		140,
		140,
		136,
		140,
		152,
		159,
		169,
		171,
		163,
		167,
		180,
		191,
		194,
		74,
		72,
		77,
		22,
		5,
		27,
		36,
		57,
		69,
		66,
		103,
		108,
		123,
		128,
		152,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		147,
		157,
		140,
		142,
		146,
		160,
		172,
		180,
		170,
		168,
		162,
		194,
		-1,
		74,
		73,
		62,
		59,
		35,
		26,
		13,
		28,
		-1,
		-1,
		67,
		94,
		78,
		82,
		98,
		123,
		-1,
		159,
		-1,
		-1,
		173,
		-1,
		-1,
		199,
		162,
		151,
		142,
		148,
		154,
		165,
		187,
		176,
		177,
		167,
		177,
		190,
		58,
		55,
		43,
		41,
		64,
		21,
		17,
		-1,
		49,
		52,
		58,
		65,
		82,
		112,
		-1,
		-1,
		175,
		166,
		-1,
		-1,
		192,
		195,
		184,
		-1,
		174,
		147,
		152,
		177,
		184,
		185,
		179,
		173,
		180,
		179,
		187,
		195,
		67,
		81,
		70,
		66,
		65,
		73,
		22,
		39,
		46,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		185,
		-1,
		-1,
		192,
		185,
		173,
		161,
		151,
		161,
		169,
		169,
		172,
		176,
		171,
		182,
		174,
		178,
		195,
		-1,
		101,
		-1,
		53,
		46,
		61,
		76,
		84,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		226,
		210,
		191,
		-1,
		161,
		174,
		205,
		173,
		178,
		173,
		177,
		188,
		177,
		180,
		194,
		189,
		-1,
		-1,
		59,
		62,
		-1,
		-1,
		84,
		103,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		198,
		194,
		-1,
		-1,
		162,
		187,
		176,
		184,
		179,
		181,
		187,
		190,
		179,
		183,
		195,
		-1,
		-1,
		66,
		67,
		72,
		-1,
		93,
		-1,
		208,
		-1,
		175,
		182,
		170,
		-1,
		-1,
		-1,
		200,
		163,
		184,
		194,
		199,
		197,
		188,
		185,
		192,
		190,
		186,
		197,
		-1,
		-1,
		-1,
		123,
		100,
		215,
		206,
		189,
		169,
		161,
		181,
		-1,
		188,
		-1,
		163,
		164,
		191,
		193,
		210,
		204,
		188,
		203,
		193,
		184,
		193,
		129,
		-1,
		104,
		163,
		146,
		175,
		141,
		153,
		209,
		-1,
		185,
		167,
		-1,
		195,
		185,
		227,
		208,
		201,
		188,
		195,
		197,
		190,
		-1,
		-1,
		-1,
		119,
		118,
		117,
		128,
		136,
		134,
		152,
		-1,
		197,
		179,
		158,
		175,
		175,
		166,
		174,
		217,
		213,
		206,
		208,
		198,
		-1,
		173,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		145,
		167,
		162,
		154,
		166,
		175,
		162,
		168,
		170,
		178,
		176,
		173,
		185,
		181,
		201,
		197,
		229,
		-1,
		180,
		-1,
		149,
		-1,
		-1,
		163,
		149,
		161,
		172,
		162,
		162,
		167,
		165,
		187,
		204,
		188,
		186,
		191,
		196,
		-1,
		190,
		191,
		-1,
		182,
		174,
		160,
		-1,
		153,
		-1,
		208,
		169,
		-1,
		194,
		174,
		-1,
		197,
		193,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		-1,
		183,
		163,
		203,
		187,
		-1,
		185,
		185,
		-1,
		-1,
		-1,
		216,
		207,
		-1,
		176,
		179,
		-1,
		170,
		176,
		205,
		187,
		191,
		-1,
		-1,
		-1,
		232,
		213,
		207,
		191,
		196,
		184,
		201,
		187,
		189,
		201,
		190,
		211,
		-1,
		-1,
		-1,
		204,
		196,
		196,
		-1,
		-1,
		214,
		197,
		197,
		210,
		-1,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		205,
		-1,
		-1,
		210,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		215,
		-1,
		-1,
		-1,
		206,
		213,
		221,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		261,
		236,
		-1,
		-1,
		-1,
		220,
		220,
		-1,
		-1,
		231,
		232,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		224,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		253,
		-1,
		259,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		266,
		258,
		272,
		-1,
		244,
		246,
		-1,
		294,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		249,
		256,
		278,
		281,
		311,
		-1,
		268
	],
	[
		-1,
		264,
		253,
		264,
		272,
		245,
		252,
		-1,
		273,
		275,
		241,
		235,
		274,
		245,
		251,
		262,
		-1,
		-1,
		-1,
		264,
		263,
		233,
		231,
		240,
		245,
		252,
		-1,
		275,
		-1,
		285,
		264,
		275,
		280,
		226,
		223,
		243,
		262,
		268,
		260,
		300,
		256,
		227,
		221,
		239,
		244,
		262,
		254,
		-1,
		227,
		217,
		239,
		243,
		255,
		238,
		-1,
		-1,
		221,
		222,
		228,
		240,
		245,
		250,
		-1,
		276,
		260,
		-1,
		-1,
		211,
		224,
		220,
		223,
		231,
		247,
		268,
		260,
		255,
		-1,
		-1,
		212,
		216,
		229,
		230,
		228,
		255,
		268,
		250,
		264,
		263,
		-1,
		200,
		218,
		227,
		236,
		242,
		231,
		229,
		247,
		249,
		255,
		258,
		-1,
		192,
		194,
		223,
		229,
		241,
		247,
		234,
		234,
		244,
		237,
		256,
		247,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		189,
		197,
		223,
		222,
		218,
		236,
		244,
		237,
		234,
		232,
		229,
		245,
		246,
		256,
		-1,
		-1,
		245,
		214,
		249,
		206,
		191,
		-1,
		185,
		204,
		210,
		214,
		219,
		227,
		241,
		237,
		-1,
		223,
		222,
		253,
		239,
		250,
		205,
		-1,
		-1,
		203,
		195,
		180,
		183,
		180,
		180,
		210,
		209,
		214,
		216,
		218,
		224,
		227,
		227,
		233,
		217,
		227,
		231,
		239,
		257,
		-1,
		-1,
		299,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		175,
		192,
		182,
		203,
		218,
		222,
		230,
		232,
		220,
		222,
		219,
		232,
		220,
		214,
		239,
		243,
		234,
		255,
		250,
		-1,
		298,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		204,
		-1,
		225,
		223,
		247,
		241,
		238,
		225,
		213,
		226,
		211,
		218,
		217,
		221,
		223,
		256,
		231,
		253,
		250,
		269,
		274,
		268,
		277,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		212,
		225,
		232,
		227,
		230,
		242,
		233,
		220,
		209,
		220,
		209,
		206,
		214,
		220,
		234,
		226,
		225,
		243,
		253,
		261,
		265,
		271,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		213,
		233,
		234,
		225,
		-1,
		228,
		231,
		238,
		216,
		201,
		218,
		210,
		208,
		213,
		215,
		229,
		220,
		238,
		245,
		243,
		247,
		267,
		279,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		256,
		231,
		-1,
		226,
		-1,
		218,
		243,
		-1,
		222,
		218,
		200,
		201,
		196,
		211,
		217,
		211,
		208,
		226,
		229,
		236,
		240,
		256,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		224,
		213,
		212,
		-1,
		203,
		233,
		230,
		216,
		203,
		193,
		194,
		202,
		215,
		194,
		210,
		207,
		227,
		253,
		231,
		242,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		242,
		235,
		223,
		188,
		188,
		182,
		-1,
		223,
		206,
		202,
		191,
		189,
		202,
		197,
		213,
		205,
		203,
		222,
		234,
		225,
		233,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		144,
		167,
		201,
		221,
		207,
		212,
		187,
		180,
		174,
		226,
		223,
		190,
		198,
		190,
		179,
		193,
		201,
		205,
		201,
		210,
		216,
		240,
		221,
		227,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		158,
		165,
		197,
		212,
		209,
		-1,
		179,
		-1,
		168,
		176,
		175,
		181,
		193,
		179,
		184,
		195,
		207,
		208,
		203,
		210,
		245,
		245,
		211,
		231,
		234,
		-1,
		-1,
		-1,
		205,
		203,
		178,
		155,
		139,
		175,
		-1,
		179,
		180,
		-1,
		173,
		167,
		173,
		172,
		179,
		176,
		176,
		190,
		198,
		194,
		210,
		213,
		195,
		219,
		-1,
		219,
		213,
		221,
		211,
		199,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		164,
		157,
		-1,
		160,
		160,
		167,
		176,
		181,
		186,
		194,
		189,
		202,
		206,
		200,
		194,
		207,
		211,
		212,
		201,
		197,
		194,
		208,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		167,
		159,
		155,
		149,
		155,
		173,
		171,
		191,
		183,
		197,
		197,
		203,
		209,
		195,
		188,
		199,
		184,
		202,
		208,
		199,
		194,
		193,
		204,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		189,
		168,
		191,
		169,
		183,
		179,
		217,
		218,
		196,
		201,
		209,
		197,
		200,
		189,
		192,
		184,
		206,
		203,
		187,
		189,
		198,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		137,
		148,
		-1,
		-1,
		233,
		-1,
		167,
		184,
		193,
		191,
		207,
		196,
		203,
		220,
		194,
		189,
		194,
		183,
		183,
		178,
		197,
		183,
		181,
		196,
		212,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		211,
		201,
		185,
		170,
		203,
		-1,
		195,
		191,
		198,
		-1,
		214,
		-1,
		186,
		189,
		180,
		175,
		172,
		183,
		181,
		190,
		191,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		173,
		-1,
		-1,
		198,
		192,
		192,
		176,
		179,
		211,
		191,
		183,
		198,
		197,
		184,
		183,
		171,
		171,
		174,
		168,
		181,
		191,
		197,
		189,
		-1,
		-1,
		-1,
		182,
		134,
		142,
		118,
		139,
		-1,
		-1,
		260,
		215,
		201,
		-1,
		185,
		211,
		199,
		189,
		179,
		184,
		185,
		175,
		173,
		169,
		178,
		177,
		170,
		169,
		190,
		183,
		205,
		-1,
		-1,
		131,
		144,
		146,
		132,
		151,
		-1,
		-1,
		-1,
		207,
		223,
		215,
		186,
		200,
		-1,
		-1,
		183,
		176,
		170,
		173,
		161,
		181,
		188,
		176,
		163,
		178,
		188,
		196,
		195,
		-1,
		134,
		121,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		-1,
		-1,
		240,
		189,
		178,
		173,
		177,
		182,
		-1,
		156,
		167,
		160,
		179,
		186,
		178,
		163,
		157,
		168,
		183,
		200,
		-1,
		-1,
		168,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		197,
		195,
		166,
		159,
		163,
		-1,
		158,
		160,
		157,
		169,
		174,
		178,
		169,
		151,
		165,
		168,
		181,
		195,
		199,
		191,
		-1,
		173,
		-1,
		-1,
		-1,
		212,
		213,
		199,
		176,
		155,
		148,
		145,
		144,
		149,
		160,
		169,
		180,
		145,
		149,
		164,
		169,
		173,
		190,
		194,
		-1,
		-1,
		171,
		167,
		202,
		214,
		186,
		226,
		-1,
		-1,
		144,
		137,
		147,
		140,
		153,
		156,
		141,
		143,
		161,
		174,
		168,
		178,
		193,
		188,
		-1,
		-1,
		-1,
		169,
		-1,
		185,
		-1,
		-1,
		176,
		217,
		164,
		146,
		142,
		128,
		135,
		129,
		131,
		136,
		155,
		150,
		159,
		164,
		168,
		191,
		180,
		219,
		-1,
		-1,
		76,
		-1,
		-1,
		-1,
		135,
		154,
		149,
		155,
		160,
		151,
		179,
		176,
		-1,
		125,
		158,
		126,
		140,
		136,
		143,
		148,
		154,
		158,
		165,
		181,
		180,
		175,
		211,
		202,
		208,
		-1,
		-1,
		69,
		58,
		47,
		53,
		-1,
		128,
		151,
		141,
		131,
		137,
		-1,
		-1,
		143,
		140,
		138,
		118,
		124,
		129,
		132,
		170,
		146,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		34,
		75,
		68,
		21,
		29,
		60,
		-1,
		118,
		110,
		138,
		123,
		131,
		-1,
		-1,
		116,
		107,
		112,
		121,
		122,
		153,
		152,
		165,
		168,
		173,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		27,
		51,
		15,
		18,
		42,
		56,
		-1,
		109,
		-1,
		-1,
		154,
		141,
		125,
		115,
		112,
		159,
		135,
		130,
		136,
		138,
		162,
		153,
		178,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		26,
		31,
		9,
		-1,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		170,
		-1,
		152,
		-1,
		135,
		139,
		143,
		146,
		161,
		148,
		155,
		172,
		178,
		167,
		177,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		99,
		54,
		21,
		0,
		58,
		73,
		77,
		-1,
		93,
		129,
		139,
		-1,
		179,
		-1,
		-1,
		-1,
		149,
		156,
		148,
		164,
		160,
		160,
		156,
		160,
		172,
		179,
		189,
		191,
		183,
		187,
		200,
		211,
		214,
		95,
		93,
		98,
		43,
		26,
		43,
		52,
		73,
		89,
		86,
		123,
		128,
		143,
		148,
		172,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		167,
		177,
		160,
		162,
		166,
		180,
		192,
		200,
		190,
		188,
		182,
		214,
		-1,
		95,
		94,
		83,
		80,
		56,
		47,
		34,
		44,
		-1,
		-1,
		87,
		114,
		98,
		102,
		118,
		143,
		-1,
		179,
		-1,
		-1,
		193,
		-1,
		-1,
		219,
		182,
		171,
		162,
		168,
		174,
		185,
		207,
		196,
		197,
		187,
		197,
		210,
		79,
		76,
		64,
		62,
		85,
		42,
		38,
		-1,
		69,
		72,
		78,
		85,
		102,
		132,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		212,
		215,
		204,
		-1,
		194,
		167,
		172,
		197,
		204,
		205,
		199,
		193,
		200,
		199,
		207,
		215,
		88,
		102,
		91,
		87,
		86,
		94,
		43,
		59,
		66,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		218,
		205,
		-1,
		-1,
		212,
		205,
		193,
		181,
		171,
		181,
		189,
		189,
		192,
		196,
		191,
		202,
		194,
		198,
		215,
		-1,
		122,
		-1,
		74,
		66,
		81,
		96,
		104,
		-1,
		-1,
		-1,
		235,
		221,
		214,
		202,
		200,
		-1,
		246,
		230,
		211,
		-1,
		181,
		194,
		225,
		193,
		198,
		193,
		197,
		208,
		197,
		200,
		214,
		209,
		-1,
		-1,
		79,
		82,
		-1,
		-1,
		104,
		123,
		-1,
		226,
		215,
		200,
		192,
		-1,
		-1,
		218,
		214,
		-1,
		-1,
		182,
		207,
		196,
		204,
		199,
		201,
		207,
		210,
		199,
		203,
		215,
		-1,
		-1,
		86,
		87,
		92,
		-1,
		113,
		-1,
		228,
		-1,
		195,
		202,
		190,
		-1,
		-1,
		-1,
		220,
		183,
		204,
		214,
		219,
		217,
		208,
		205,
		212,
		210,
		206,
		217,
		-1,
		-1,
		-1,
		143,
		120,
		235,
		226,
		209,
		189,
		181,
		201,
		-1,
		208,
		-1,
		183,
		184,
		211,
		213,
		230,
		224,
		208,
		223,
		213,
		204,
		213,
		149,
		-1,
		124,
		183,
		166,
		195,
		161,
		173,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		247,
		228,
		221,
		208,
		215,
		217,
		210,
		-1,
		-1,
		-1,
		139,
		138,
		137,
		148,
		156,
		154,
		172,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		237,
		233,
		226,
		228,
		218,
		-1,
		194,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		165,
		187,
		182,
		174,
		186,
		195,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		217,
		249,
		-1,
		201,
		-1,
		169,
		-1,
		-1,
		183,
		169,
		181,
		192,
		182,
		182,
		187,
		185,
		207,
		224,
		208,
		206,
		211,
		216,
		-1,
		211,
		212,
		-1,
		202,
		194,
		180,
		-1,
		173,
		-1,
		228,
		189,
		-1,
		214,
		194,
		-1,
		217,
		213,
		-1,
		-1,
		223,
		218,
		-1,
		-1,
		-1,
		203,
		183,
		223,
		207,
		-1,
		205,
		205,
		-1,
		-1,
		-1,
		237,
		227,
		-1,
		196,
		199,
		-1,
		190,
		196,
		225,
		207,
		211,
		-1,
		-1,
		-1,
		252,
		233,
		227,
		211,
		216,
		204,
		221,
		207,
		209,
		221,
		210,
		231,
		-1,
		-1,
		-1,
		224,
		216,
		216,
		-1,
		-1,
		234,
		217,
		217,
		230,
		-1,
		-1,
		-1,
		246,
		227,
		-1,
		-1,
		225,
		-1,
		-1,
		230,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		235,
		-1,
		-1,
		-1,
		226,
		233,
		241,
		-1,
		-1,
		-1,
		-1,
		254,
		255,
		281,
		256,
		-1,
		-1,
		-1,
		240,
		240,
		-1,
		-1,
		252,
		253,
		-1,
		-1,
		-1,
		268,
		252,
		-1,
		244,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		273,
		-1,
		279,
		254,
		261,
		-1,
		-1,
		-1,
		-1,
		286,
		278,
		292,
		-1,
		264,
		266,
		-1,
		314,
		-1,
		-1,
		301,
		292,
		-1,
		-1,
		269,
		276,
		298,
		301,
		331,
		-1,
		288
	],
	[
		-1,
		304,
		293,
		304,
		312,
		285,
		292,
		-1,
		313,
		315,
		281,
		275,
		314,
		285,
		291,
		302,
		-1,
		-1,
		-1,
		304,
		303,
		273,
		271,
		280,
		285,
		292,
		-1,
		315,
		-1,
		325,
		304,
		315,
		320,
		266,
		263,
		283,
		302,
		308,
		300,
		340,
		296,
		267,
		261,
		279,
		284,
		302,
		294,
		-1,
		267,
		257,
		279,
		282,
		293,
		278,
		-1,
		-1,
		261,
		262,
		268,
		278,
		284,
		280,
		-1,
		290,
		274,
		-1,
		-1,
		251,
		264,
		260,
		263,
		271,
		269,
		282,
		274,
		269,
		-1,
		-1,
		252,
		256,
		269,
		256,
		252,
		269,
		282,
		264,
		278,
		277,
		-1,
		240,
		258,
		267,
		263,
		261,
		245,
		243,
		261,
		263,
		269,
		269,
		-1,
		232,
		234,
		263,
		269,
		281,
		261,
		248,
		248,
		258,
		251,
		270,
		258,
		304,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		229,
		237,
		263,
		262,
		258,
		276,
		271,
		251,
		248,
		246,
		243,
		259,
		257,
		267,
		-1,
		-1,
		285,
		254,
		289,
		246,
		231,
		-1,
		225,
		244,
		250,
		254,
		259,
		254,
		268,
		264,
		-1,
		237,
		236,
		264,
		250,
		261,
		245,
		-1,
		-1,
		243,
		235,
		220,
		223,
		220,
		220,
		250,
		249,
		254,
		249,
		245,
		251,
		254,
		254,
		260,
		231,
		241,
		245,
		243,
		268,
		-1,
		-1,
		303,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		215,
		232,
		222,
		243,
		258,
		262,
		265,
		259,
		247,
		249,
		246,
		259,
		247,
		228,
		253,
		257,
		238,
		259,
		254,
		-1,
		302,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		244,
		-1,
		265,
		263,
		283,
		268,
		265,
		252,
		240,
		253,
		238,
		245,
		244,
		232,
		230,
		260,
		235,
		257,
		254,
		273,
		278,
		272,
		281,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		252,
		265,
		272,
		267,
		270,
		269,
		260,
		247,
		236,
		247,
		236,
		233,
		241,
		224,
		239,
		230,
		229,
		247,
		257,
		265,
		269,
		275,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		253,
		273,
		274,
		265,
		-1,
		268,
		271,
		265,
		243,
		228,
		245,
		237,
		235,
		237,
		219,
		233,
		224,
		242,
		249,
		247,
		251,
		271,
		283,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		296,
		271,
		-1,
		266,
		-1,
		258,
		283,
		-1,
		249,
		245,
		227,
		228,
		223,
		238,
		230,
		215,
		212,
		230,
		233,
		240,
		244,
		260,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		264,
		253,
		252,
		-1,
		243,
		263,
		260,
		248,
		235,
		220,
		221,
		229,
		241,
		220,
		214,
		211,
		231,
		257,
		235,
		246,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		282,
		275,
		263,
		228,
		228,
		222,
		-1,
		259,
		238,
		229,
		218,
		216,
		229,
		221,
		229,
		209,
		207,
		226,
		238,
		229,
		237,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		184,
		207,
		241,
		261,
		247,
		252,
		227,
		220,
		214,
		266,
		255,
		230,
		225,
		217,
		206,
		217,
		225,
		223,
		205,
		214,
		220,
		244,
		225,
		231,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		198,
		205,
		237,
		252,
		249,
		-1,
		219,
		-1,
		208,
		216,
		215,
		221,
		222,
		209,
		208,
		222,
		222,
		212,
		207,
		214,
		249,
		249,
		215,
		235,
		238,
		-1,
		-1,
		-1,
		245,
		243,
		218,
		195,
		179,
		215,
		-1,
		219,
		220,
		-1,
		213,
		207,
		213,
		212,
		219,
		213,
		216,
		219,
		222,
		210,
		216,
		217,
		199,
		223,
		-1,
		223,
		217,
		225,
		215,
		203,
		-1,
		-1,
		-1,
		241,
		220,
		213,
		233,
		174,
		226,
		-1,
		-1,
		204,
		197,
		-1,
		200,
		200,
		207,
		216,
		216,
		218,
		215,
		204,
		217,
		210,
		204,
		198,
		211,
		215,
		216,
		205,
		201,
		198,
		212,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		194,
		-1,
		207,
		199,
		195,
		189,
		195,
		213,
		211,
		231,
		223,
		230,
		226,
		218,
		213,
		199,
		192,
		203,
		188,
		206,
		212,
		203,
		198,
		197,
		208,
		-1,
		261,
		247,
		218,
		-1,
		-1,
		207,
		-1,
		171,
		185,
		201,
		-1,
		229,
		208,
		231,
		209,
		223,
		219,
		235,
		236,
		206,
		211,
		213,
		201,
		204,
		193,
		196,
		188,
		210,
		207,
		191,
		193,
		202,
		-1,
		267,
		254,
		212,
		208,
		197,
		217,
		168,
		177,
		188,
		-1,
		-1,
		273,
		-1,
		207,
		224,
		233,
		231,
		225,
		200,
		207,
		225,
		198,
		193,
		198,
		187,
		187,
		182,
		201,
		187,
		185,
		200,
		216,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		183,
		170,
		164,
		-1,
		205,
		-1,
		251,
		241,
		225,
		210,
		243,
		-1,
		199,
		195,
		202,
		-1,
		218,
		-1,
		190,
		193,
		184,
		179,
		176,
		187,
		185,
		194,
		195,
		-1,
		217,
		202,
		195,
		185,
		199,
		170,
		-1,
		213,
		-1,
		-1,
		238,
		232,
		232,
		216,
		219,
		215,
		195,
		187,
		202,
		201,
		188,
		187,
		175,
		175,
		178,
		172,
		185,
		195,
		201,
		193,
		-1,
		-1,
		-1,
		222,
		174,
		182,
		158,
		179,
		-1,
		-1,
		300,
		255,
		241,
		-1,
		217,
		215,
		203,
		193,
		183,
		188,
		189,
		179,
		177,
		173,
		182,
		181,
		174,
		173,
		194,
		187,
		209,
		-1,
		-1,
		171,
		184,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		247,
		263,
		236,
		215,
		204,
		-1,
		-1,
		187,
		180,
		174,
		177,
		165,
		185,
		192,
		180,
		167,
		182,
		192,
		200,
		199,
		-1,
		174,
		161,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		-1,
		-1,
		248,
		193,
		182,
		177,
		181,
		186,
		-1,
		160,
		171,
		164,
		183,
		190,
		182,
		167,
		161,
		172,
		187,
		204,
		-1,
		-1,
		208,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		205,
		199,
		170,
		163,
		167,
		-1,
		162,
		164,
		161,
		173,
		178,
		182,
		173,
		155,
		169,
		172,
		185,
		199,
		203,
		231,
		-1,
		177,
		-1,
		-1,
		-1,
		216,
		217,
		203,
		180,
		159,
		152,
		149,
		148,
		153,
		164,
		173,
		184,
		149,
		153,
		168,
		173,
		177,
		194,
		198,
		-1,
		-1,
		175,
		171,
		206,
		218,
		190,
		230,
		-1,
		-1,
		148,
		141,
		151,
		144,
		157,
		160,
		145,
		147,
		165,
		178,
		172,
		182,
		197,
		192,
		-1,
		-1,
		-1,
		173,
		-1,
		189,
		-1,
		-1,
		180,
		221,
		168,
		150,
		146,
		132,
		139,
		133,
		135,
		140,
		159,
		154,
		163,
		168,
		172,
		195,
		184,
		223,
		-1,
		-1,
		127,
		-1,
		-1,
		-1,
		139,
		158,
		153,
		159,
		164,
		155,
		183,
		180,
		-1,
		129,
		162,
		130,
		144,
		140,
		147,
		152,
		158,
		162,
		169,
		185,
		184,
		179,
		215,
		206,
		212,
		-1,
		-1,
		120,
		109,
		98,
		104,
		-1,
		132,
		155,
		145,
		135,
		141,
		-1,
		-1,
		147,
		144,
		142,
		122,
		128,
		133,
		136,
		174,
		150,
		158,
		162,
		166,
		172,
		177,
		182,
		188,
		203,
		218,
		-1,
		74,
		111,
		104,
		72,
		80,
		111,
		-1,
		122,
		114,
		142,
		127,
		135,
		-1,
		-1,
		120,
		111,
		116,
		125,
		126,
		157,
		156,
		169,
		172,
		177,
		165,
		164,
		182,
		186,
		195,
		202,
		192,
		205,
		209,
		-1,
		67,
		87,
		66,
		69,
		93,
		107,
		-1,
		113,
		-1,
		-1,
		158,
		145,
		129,
		119,
		116,
		163,
		139,
		134,
		140,
		142,
		166,
		157,
		182,
		173,
		173,
		176,
		191,
		196,
		188,
		202,
		202,
		203,
		-1,
		56,
		67,
		60,
		-1,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		174,
		-1,
		156,
		-1,
		139,
		143,
		147,
		150,
		165,
		152,
		159,
		176,
		182,
		171,
		181,
		177,
		178,
		187,
		198,
		210,
		209,
		210,
		106,
		61,
		40,
		51,
		0,
		15,
		19,
		-1,
		97,
		133,
		143,
		-1,
		183,
		-1,
		-1,
		-1,
		153,
		160,
		152,
		168,
		164,
		164,
		160,
		164,
		176,
		183,
		193,
		195,
		187,
		191,
		204,
		215,
		218,
		102,
		100,
		105,
		50,
		35,
		13,
		5,
		15,
		93,
		90,
		127,
		132,
		147,
		152,
		176,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		171,
		181,
		164,
		166,
		170,
		184,
		196,
		204,
		194,
		192,
		186,
		218,
		-1,
		102,
		101,
		90,
		87,
		63,
		54,
		41,
		48,
		-1,
		-1,
		91,
		118,
		102,
		106,
		122,
		147,
		-1,
		183,
		-1,
		-1,
		197,
		-1,
		-1,
		223,
		186,
		175,
		166,
		172,
		178,
		189,
		211,
		200,
		201,
		191,
		201,
		214,
		86,
		83,
		71,
		69,
		92,
		49,
		45,
		-1,
		73,
		76,
		82,
		89,
		106,
		136,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		216,
		219,
		208,
		-1,
		198,
		171,
		176,
		201,
		208,
		209,
		203,
		197,
		204,
		203,
		211,
		219,
		95,
		109,
		98,
		94,
		93,
		101,
		50,
		63,
		70,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		222,
		209,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		193,
		193,
		196,
		200,
		195,
		206,
		198,
		202,
		219,
		-1,
		129,
		-1,
		81,
		70,
		85,
		100,
		108,
		-1,
		-1,
		-1,
		239,
		225,
		218,
		206,
		204,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		229,
		197,
		202,
		197,
		201,
		212,
		201,
		204,
		218,
		213,
		-1,
		-1,
		83,
		86,
		-1,
		-1,
		108,
		127,
		-1,
		230,
		219,
		204,
		196,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		186,
		211,
		200,
		208,
		203,
		205,
		211,
		214,
		203,
		207,
		219,
		-1,
		-1,
		90,
		91,
		96,
		-1,
		117,
		-1,
		232,
		-1,
		199,
		206,
		194,
		-1,
		-1,
		-1,
		224,
		187,
		208,
		218,
		223,
		221,
		212,
		209,
		216,
		214,
		210,
		221,
		-1,
		-1,
		-1,
		147,
		124,
		239,
		230,
		213,
		193,
		185,
		205,
		-1,
		212,
		-1,
		187,
		188,
		215,
		217,
		234,
		228,
		212,
		227,
		217,
		208,
		217,
		153,
		-1,
		128,
		187,
		170,
		199,
		165,
		177,
		233,
		-1,
		209,
		191,
		-1,
		219,
		209,
		251,
		232,
		225,
		212,
		219,
		221,
		214,
		-1,
		-1,
		-1,
		143,
		142,
		141,
		152,
		160,
		158,
		176,
		-1,
		221,
		203,
		182,
		199,
		199,
		190,
		198,
		241,
		237,
		230,
		232,
		222,
		-1,
		201,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		169,
		191,
		186,
		178,
		190,
		199,
		186,
		192,
		194,
		202,
		200,
		197,
		209,
		205,
		225,
		221,
		253,
		-1,
		208,
		-1,
		173,
		-1,
		-1,
		187,
		173,
		185,
		196,
		186,
		186,
		191,
		189,
		211,
		228,
		212,
		210,
		215,
		220,
		-1,
		218,
		219,
		-1,
		206,
		198,
		184,
		-1,
		177,
		-1,
		232,
		193,
		-1,
		218,
		198,
		-1,
		221,
		217,
		-1,
		-1,
		230,
		222,
		-1,
		-1,
		-1,
		207,
		187,
		227,
		211,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		244,
		231,
		-1,
		200,
		203,
		-1,
		194,
		200,
		229,
		211,
		215,
		-1,
		-1,
		-1,
		256,
		237,
		231,
		215,
		220,
		208,
		225,
		211,
		213,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		228,
		220,
		220,
		-1,
		-1,
		238,
		221,
		221,
		234,
		-1,
		-1,
		-1,
		250,
		231,
		-1,
		-1,
		229,
		-1,
		-1,
		234,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		239,
		-1,
		-1,
		-1,
		230,
		237,
		245,
		-1,
		-1,
		-1,
		-1,
		260,
		261,
		285,
		260,
		-1,
		-1,
		-1,
		244,
		244,
		-1,
		-1,
		259,
		260,
		-1,
		-1,
		-1,
		272,
		256,
		-1,
		248,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		277,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		290,
		282,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		305,
		296,
		-1,
		-1,
		273,
		280,
		302,
		305,
		335,
		-1,
		292
	],
	[
		-1,
		319,
		308,
		319,
		327,
		300,
		307,
		-1,
		328,
		330,
		296,
		290,
		329,
		300,
		306,
		317,
		-1,
		-1,
		-1,
		319,
		318,
		288,
		286,
		295,
		300,
		307,
		-1,
		330,
		-1,
		340,
		319,
		330,
		335,
		281,
		278,
		298,
		317,
		323,
		315,
		355,
		311,
		282,
		276,
		294,
		299,
		317,
		309,
		-1,
		282,
		272,
		294,
		297,
		308,
		293,
		-1,
		-1,
		276,
		277,
		283,
		293,
		299,
		295,
		-1,
		305,
		289,
		-1,
		-1,
		266,
		279,
		275,
		278,
		286,
		284,
		297,
		289,
		284,
		-1,
		-1,
		267,
		271,
		284,
		271,
		267,
		284,
		297,
		279,
		293,
		292,
		-1,
		255,
		273,
		282,
		278,
		276,
		260,
		258,
		276,
		278,
		284,
		284,
		-1,
		247,
		249,
		278,
		284,
		296,
		276,
		263,
		263,
		273,
		266,
		285,
		273,
		319,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		244,
		252,
		278,
		277,
		273,
		291,
		286,
		266,
		263,
		261,
		258,
		274,
		272,
		282,
		-1,
		-1,
		300,
		269,
		304,
		261,
		246,
		-1,
		240,
		259,
		265,
		269,
		274,
		269,
		283,
		279,
		-1,
		252,
		251,
		279,
		265,
		276,
		260,
		-1,
		-1,
		258,
		250,
		235,
		238,
		235,
		235,
		265,
		264,
		269,
		264,
		260,
		266,
		269,
		269,
		275,
		246,
		256,
		260,
		258,
		283,
		-1,
		-1,
		318,
		-1,
		-1,
		257,
		240,
		-1,
		223,
		230,
		230,
		247,
		237,
		258,
		273,
		277,
		280,
		274,
		262,
		264,
		261,
		274,
		262,
		243,
		268,
		272,
		253,
		274,
		269,
		-1,
		317,
		301,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		216,
		219,
		225,
		249,
		259,
		-1,
		280,
		278,
		298,
		283,
		280,
		267,
		255,
		268,
		253,
		260,
		259,
		247,
		245,
		275,
		250,
		272,
		269,
		288,
		293,
		287,
		296,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		253,
		-1,
		267,
		280,
		287,
		282,
		285,
		284,
		275,
		262,
		251,
		262,
		251,
		248,
		256,
		239,
		254,
		245,
		244,
		262,
		272,
		280,
		284,
		290,
		-1,
		315,
		-1,
		257,
		241,
		243,
		215,
		236,
		-1,
		273,
		268,
		288,
		289,
		280,
		-1,
		283,
		286,
		280,
		258,
		243,
		260,
		252,
		250,
		252,
		234,
		248,
		239,
		257,
		264,
		262,
		266,
		286,
		298,
		275,
		265,
		-1,
		247,
		252,
		211,
		219,
		238,
		311,
		286,
		-1,
		281,
		-1,
		273,
		298,
		-1,
		264,
		260,
		242,
		243,
		238,
		253,
		245,
		230,
		227,
		245,
		248,
		255,
		259,
		275,
		-1,
		-1,
		260,
		264,
		253,
		204,
		223,
		247,
		284,
		279,
		268,
		267,
		-1,
		258,
		278,
		275,
		263,
		250,
		235,
		236,
		244,
		256,
		235,
		229,
		226,
		246,
		272,
		250,
		261,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		230,
		201,
		225,
		267,
		297,
		290,
		278,
		243,
		243,
		237,
		-1,
		274,
		253,
		244,
		233,
		231,
		244,
		236,
		244,
		224,
		222,
		241,
		253,
		244,
		252,
		-1,
		-1,
		-1,
		260,
		249,
		250,
		199,
		222,
		256,
		276,
		262,
		267,
		242,
		235,
		229,
		281,
		270,
		245,
		240,
		232,
		221,
		232,
		240,
		238,
		220,
		229,
		235,
		259,
		240,
		246,
		-1,
		-1,
		267,
		257,
		241,
		243,
		240,
		213,
		220,
		252,
		267,
		264,
		-1,
		234,
		-1,
		223,
		231,
		230,
		236,
		237,
		224,
		223,
		237,
		237,
		227,
		222,
		229,
		264,
		264,
		230,
		250,
		253,
		-1,
		-1,
		-1,
		260,
		258,
		233,
		210,
		194,
		230,
		-1,
		234,
		235,
		-1,
		228,
		222,
		228,
		227,
		234,
		228,
		231,
		234,
		237,
		225,
		231,
		232,
		214,
		238,
		-1,
		238,
		232,
		240,
		230,
		218,
		-1,
		-1,
		-1,
		256,
		235,
		228,
		248,
		189,
		241,
		-1,
		-1,
		219,
		212,
		-1,
		215,
		215,
		222,
		231,
		231,
		233,
		230,
		219,
		232,
		225,
		219,
		213,
		226,
		230,
		231,
		220,
		216,
		213,
		227,
		-1,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		209,
		-1,
		222,
		214,
		210,
		204,
		210,
		228,
		226,
		246,
		238,
		245,
		241,
		233,
		228,
		214,
		207,
		218,
		203,
		221,
		227,
		218,
		213,
		212,
		223,
		-1,
		276,
		262,
		233,
		-1,
		-1,
		222,
		-1,
		186,
		200,
		216,
		-1,
		244,
		223,
		246,
		224,
		238,
		234,
		250,
		251,
		221,
		226,
		228,
		216,
		219,
		208,
		211,
		203,
		225,
		222,
		206,
		208,
		217,
		-1,
		282,
		269,
		227,
		223,
		212,
		232,
		183,
		192,
		203,
		-1,
		-1,
		288,
		-1,
		222,
		239,
		248,
		246,
		240,
		215,
		222,
		240,
		213,
		208,
		213,
		202,
		202,
		197,
		216,
		202,
		200,
		215,
		231,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		198,
		185,
		179,
		-1,
		220,
		-1,
		266,
		256,
		240,
		225,
		258,
		-1,
		214,
		210,
		217,
		-1,
		233,
		-1,
		205,
		208,
		199,
		194,
		191,
		202,
		200,
		209,
		210,
		-1,
		232,
		217,
		210,
		200,
		214,
		185,
		-1,
		228,
		-1,
		-1,
		253,
		247,
		247,
		231,
		234,
		230,
		210,
		202,
		217,
		216,
		203,
		202,
		190,
		190,
		193,
		187,
		200,
		210,
		216,
		208,
		-1,
		-1,
		-1,
		237,
		189,
		197,
		173,
		194,
		-1,
		-1,
		315,
		270,
		256,
		-1,
		232,
		230,
		218,
		208,
		198,
		203,
		204,
		194,
		192,
		188,
		197,
		196,
		189,
		188,
		209,
		202,
		224,
		-1,
		-1,
		186,
		199,
		201,
		187,
		206,
		-1,
		-1,
		-1,
		262,
		278,
		251,
		230,
		219,
		-1,
		-1,
		202,
		195,
		189,
		192,
		180,
		200,
		207,
		195,
		182,
		197,
		207,
		215,
		214,
		-1,
		189,
		176,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		-1,
		-1,
		263,
		208,
		197,
		192,
		196,
		201,
		-1,
		175,
		186,
		179,
		198,
		205,
		197,
		182,
		176,
		187,
		202,
		219,
		-1,
		-1,
		223,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		220,
		214,
		185,
		178,
		182,
		-1,
		177,
		179,
		176,
		188,
		193,
		197,
		188,
		170,
		184,
		187,
		200,
		214,
		218,
		246,
		-1,
		192,
		-1,
		-1,
		-1,
		231,
		232,
		218,
		195,
		174,
		167,
		164,
		163,
		168,
		179,
		188,
		199,
		164,
		168,
		183,
		188,
		192,
		209,
		213,
		-1,
		-1,
		190,
		186,
		221,
		233,
		205,
		245,
		-1,
		-1,
		163,
		156,
		166,
		159,
		172,
		175,
		160,
		162,
		180,
		193,
		187,
		197,
		212,
		207,
		-1,
		-1,
		-1,
		188,
		-1,
		204,
		-1,
		-1,
		195,
		236,
		183,
		165,
		161,
		147,
		154,
		148,
		150,
		155,
		174,
		169,
		178,
		183,
		187,
		210,
		199,
		238,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		154,
		173,
		168,
		174,
		179,
		170,
		198,
		195,
		-1,
		144,
		177,
		145,
		159,
		155,
		162,
		167,
		173,
		177,
		184,
		200,
		199,
		194,
		230,
		221,
		227,
		-1,
		-1,
		135,
		124,
		113,
		119,
		-1,
		147,
		170,
		160,
		150,
		156,
		-1,
		-1,
		162,
		159,
		157,
		137,
		143,
		148,
		151,
		189,
		165,
		173,
		177,
		181,
		187,
		192,
		197,
		203,
		218,
		233,
		-1,
		89,
		126,
		119,
		87,
		95,
		126,
		-1,
		137,
		129,
		157,
		142,
		150,
		-1,
		-1,
		135,
		126,
		131,
		140,
		141,
		172,
		171,
		184,
		187,
		192,
		180,
		179,
		197,
		201,
		210,
		217,
		207,
		220,
		224,
		-1,
		82,
		102,
		81,
		84,
		108,
		122,
		-1,
		128,
		-1,
		-1,
		173,
		160,
		144,
		134,
		131,
		178,
		154,
		149,
		155,
		157,
		181,
		172,
		197,
		188,
		188,
		191,
		206,
		211,
		203,
		217,
		217,
		218,
		-1,
		71,
		82,
		75,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		189,
		-1,
		171,
		-1,
		154,
		158,
		162,
		165,
		180,
		167,
		174,
		191,
		197,
		186,
		196,
		192,
		193,
		202,
		213,
		225,
		224,
		225,
		121,
		76,
		55,
		66,
		15,
		0,
		4,
		-1,
		112,
		148,
		158,
		-1,
		198,
		-1,
		-1,
		-1,
		168,
		175,
		167,
		183,
		179,
		179,
		175,
		179,
		191,
		198,
		208,
		210,
		202,
		206,
		219,
		230,
		233,
		117,
		115,
		120,
		65,
		50,
		28,
		20,
		0,
		108,
		105,
		142,
		147,
		162,
		167,
		191,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		186,
		196,
		179,
		181,
		185,
		199,
		211,
		219,
		209,
		207,
		201,
		233,
		-1,
		117,
		116,
		105,
		102,
		78,
		69,
		56,
		63,
		-1,
		-1,
		106,
		133,
		117,
		121,
		137,
		162,
		-1,
		198,
		-1,
		-1,
		212,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		193,
		204,
		226,
		215,
		216,
		206,
		216,
		229,
		101,
		98,
		86,
		84,
		107,
		64,
		60,
		-1,
		88,
		91,
		97,
		104,
		121,
		151,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		231,
		234,
		223,
		-1,
		213,
		186,
		191,
		216,
		223,
		224,
		218,
		212,
		219,
		218,
		226,
		234,
		110,
		124,
		113,
		109,
		108,
		116,
		65,
		78,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		237,
		224,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		208,
		208,
		211,
		215,
		210,
		221,
		213,
		217,
		234,
		-1,
		144,
		-1,
		96,
		85,
		100,
		115,
		123,
		-1,
		-1,
		-1,
		254,
		240,
		233,
		221,
		219,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		216,
		227,
		216,
		219,
		233,
		228,
		-1,
		-1,
		98,
		101,
		-1,
		-1,
		123,
		142,
		-1,
		245,
		234,
		219,
		211,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		220,
		226,
		229,
		218,
		222,
		234,
		-1,
		-1,
		105,
		106,
		111,
		-1,
		132,
		-1,
		247,
		-1,
		214,
		221,
		209,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		238,
		236,
		227,
		224,
		231,
		229,
		225,
		236,
		-1,
		-1,
		-1,
		162,
		139,
		254,
		245,
		228,
		208,
		200,
		220,
		-1,
		227,
		-1,
		202,
		203,
		230,
		232,
		249,
		243,
		227,
		242,
		232,
		223,
		232,
		168,
		-1,
		143,
		202,
		185,
		214,
		180,
		192,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		266,
		247,
		240,
		227,
		234,
		236,
		229,
		-1,
		-1,
		-1,
		158,
		157,
		156,
		167,
		175,
		173,
		191,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		256,
		252,
		245,
		247,
		237,
		-1,
		216,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		184,
		206,
		201,
		193,
		205,
		214,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		236,
		268,
		-1,
		223,
		-1,
		188,
		-1,
		-1,
		202,
		188,
		200,
		211,
		201,
		201,
		206,
		204,
		226,
		243,
		227,
		225,
		230,
		235,
		-1,
		233,
		234,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		247,
		208,
		-1,
		233,
		213,
		-1,
		236,
		232,
		-1,
		-1,
		245,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		242,
		226,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		259,
		246,
		-1,
		215,
		218,
		-1,
		209,
		215,
		244,
		226,
		230,
		-1,
		-1,
		-1,
		271,
		252,
		246,
		230,
		235,
		223,
		240,
		226,
		228,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		243,
		235,
		235,
		-1,
		-1,
		253,
		236,
		236,
		249,
		-1,
		-1,
		-1,
		265,
		246,
		-1,
		-1,
		244,
		-1,
		-1,
		249,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		254,
		-1,
		-1,
		-1,
		245,
		252,
		260,
		-1,
		-1,
		-1,
		-1,
		275,
		276,
		300,
		275,
		-1,
		-1,
		-1,
		259,
		259,
		-1,
		-1,
		274,
		275,
		-1,
		-1,
		-1,
		287,
		271,
		-1,
		263,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		292,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		305,
		297,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		320,
		311,
		-1,
		-1,
		288,
		295,
		317,
		320,
		350,
		-1,
		307
	],
	[
		-1,
		323,
		312,
		323,
		331,
		304,
		311,
		-1,
		332,
		334,
		300,
		294,
		333,
		304,
		310,
		321,
		-1,
		-1,
		-1,
		323,
		322,
		292,
		290,
		299,
		304,
		311,
		-1,
		334,
		-1,
		344,
		323,
		334,
		339,
		285,
		282,
		302,
		321,
		327,
		319,
		359,
		315,
		286,
		280,
		298,
		303,
		321,
		313,
		-1,
		286,
		276,
		298,
		301,
		312,
		297,
		-1,
		-1,
		280,
		281,
		287,
		297,
		303,
		299,
		-1,
		309,
		293,
		-1,
		-1,
		270,
		283,
		279,
		282,
		290,
		288,
		301,
		293,
		288,
		-1,
		-1,
		271,
		275,
		288,
		275,
		271,
		288,
		301,
		283,
		297,
		296,
		-1,
		259,
		277,
		286,
		282,
		280,
		264,
		262,
		280,
		282,
		288,
		288,
		-1,
		251,
		253,
		282,
		288,
		300,
		280,
		267,
		267,
		277,
		270,
		289,
		277,
		323,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		248,
		256,
		282,
		281,
		277,
		295,
		290,
		270,
		267,
		265,
		262,
		278,
		276,
		286,
		-1,
		-1,
		304,
		273,
		308,
		265,
		250,
		-1,
		244,
		263,
		269,
		273,
		278,
		273,
		287,
		283,
		-1,
		256,
		255,
		283,
		269,
		280,
		264,
		-1,
		-1,
		262,
		254,
		239,
		242,
		239,
		239,
		269,
		268,
		273,
		268,
		264,
		270,
		273,
		273,
		279,
		250,
		260,
		264,
		262,
		287,
		-1,
		-1,
		322,
		-1,
		-1,
		261,
		244,
		-1,
		227,
		234,
		234,
		251,
		241,
		262,
		277,
		281,
		284,
		278,
		266,
		268,
		265,
		278,
		266,
		247,
		272,
		276,
		257,
		278,
		273,
		-1,
		321,
		305,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		220,
		223,
		229,
		253,
		263,
		-1,
		284,
		282,
		302,
		287,
		284,
		271,
		259,
		272,
		257,
		264,
		263,
		251,
		249,
		279,
		254,
		276,
		273,
		292,
		297,
		291,
		300,
		-1,
		269,
		265,
		261,
		268,
		217,
		-1,
		-1,
		257,
		-1,
		271,
		284,
		291,
		286,
		289,
		288,
		279,
		266,
		255,
		266,
		255,
		252,
		260,
		243,
		258,
		249,
		248,
		266,
		276,
		284,
		288,
		294,
		-1,
		319,
		-1,
		261,
		245,
		247,
		219,
		240,
		-1,
		277,
		272,
		292,
		293,
		284,
		-1,
		287,
		290,
		284,
		262,
		247,
		264,
		256,
		254,
		256,
		238,
		252,
		243,
		261,
		268,
		266,
		270,
		290,
		302,
		279,
		269,
		-1,
		251,
		256,
		215,
		223,
		242,
		315,
		290,
		-1,
		285,
		-1,
		277,
		302,
		-1,
		268,
		264,
		246,
		247,
		242,
		257,
		249,
		234,
		231,
		249,
		252,
		259,
		263,
		279,
		-1,
		-1,
		264,
		268,
		257,
		208,
		227,
		251,
		288,
		283,
		272,
		271,
		-1,
		262,
		282,
		279,
		267,
		254,
		239,
		240,
		248,
		260,
		239,
		233,
		230,
		250,
		276,
		254,
		265,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		234,
		205,
		229,
		271,
		301,
		294,
		282,
		247,
		247,
		241,
		-1,
		278,
		257,
		248,
		237,
		235,
		248,
		240,
		248,
		228,
		226,
		245,
		257,
		248,
		256,
		-1,
		-1,
		-1,
		264,
		253,
		254,
		203,
		226,
		260,
		280,
		266,
		271,
		246,
		239,
		233,
		285,
		274,
		249,
		244,
		236,
		225,
		236,
		244,
		242,
		224,
		233,
		239,
		263,
		244,
		250,
		-1,
		-1,
		271,
		261,
		245,
		247,
		244,
		217,
		224,
		256,
		271,
		268,
		-1,
		238,
		-1,
		227,
		235,
		234,
		240,
		241,
		228,
		227,
		241,
		241,
		231,
		226,
		233,
		268,
		268,
		234,
		254,
		257,
		-1,
		-1,
		-1,
		264,
		262,
		237,
		214,
		198,
		234,
		-1,
		238,
		239,
		-1,
		232,
		226,
		232,
		231,
		238,
		232,
		235,
		238,
		241,
		229,
		235,
		236,
		218,
		242,
		-1,
		242,
		236,
		244,
		234,
		222,
		-1,
		-1,
		-1,
		260,
		239,
		232,
		252,
		193,
		245,
		-1,
		-1,
		223,
		216,
		-1,
		219,
		219,
		226,
		235,
		235,
		237,
		234,
		223,
		236,
		229,
		223,
		217,
		230,
		234,
		235,
		224,
		220,
		217,
		231,
		-1,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		213,
		-1,
		226,
		218,
		214,
		208,
		214,
		232,
		230,
		250,
		242,
		249,
		245,
		237,
		232,
		218,
		211,
		222,
		207,
		225,
		231,
		222,
		217,
		216,
		227,
		-1,
		280,
		266,
		237,
		-1,
		-1,
		226,
		-1,
		190,
		204,
		220,
		-1,
		248,
		227,
		250,
		228,
		242,
		238,
		254,
		255,
		225,
		230,
		232,
		220,
		223,
		212,
		215,
		207,
		229,
		226,
		210,
		212,
		221,
		-1,
		286,
		273,
		231,
		227,
		216,
		236,
		187,
		196,
		207,
		-1,
		-1,
		292,
		-1,
		226,
		243,
		252,
		250,
		244,
		219,
		226,
		244,
		217,
		212,
		217,
		206,
		206,
		201,
		220,
		206,
		204,
		219,
		235,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		202,
		189,
		183,
		-1,
		224,
		-1,
		270,
		260,
		244,
		229,
		262,
		-1,
		218,
		214,
		221,
		-1,
		237,
		-1,
		209,
		212,
		203,
		198,
		195,
		206,
		204,
		213,
		214,
		-1,
		236,
		221,
		214,
		204,
		218,
		189,
		-1,
		232,
		-1,
		-1,
		257,
		251,
		251,
		235,
		238,
		234,
		214,
		206,
		221,
		220,
		207,
		206,
		194,
		194,
		197,
		191,
		204,
		214,
		220,
		212,
		-1,
		-1,
		-1,
		241,
		193,
		201,
		177,
		198,
		-1,
		-1,
		319,
		274,
		260,
		-1,
		236,
		234,
		222,
		212,
		202,
		207,
		208,
		198,
		196,
		192,
		201,
		200,
		193,
		192,
		213,
		206,
		228,
		-1,
		-1,
		190,
		203,
		205,
		191,
		210,
		-1,
		-1,
		-1,
		266,
		282,
		255,
		234,
		223,
		-1,
		-1,
		206,
		199,
		193,
		196,
		184,
		204,
		211,
		199,
		186,
		201,
		211,
		219,
		218,
		-1,
		193,
		180,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		-1,
		-1,
		267,
		212,
		201,
		196,
		200,
		205,
		-1,
		179,
		190,
		183,
		202,
		209,
		201,
		186,
		180,
		191,
		206,
		223,
		-1,
		-1,
		227,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		224,
		218,
		189,
		182,
		186,
		-1,
		181,
		183,
		180,
		192,
		197,
		201,
		192,
		174,
		188,
		191,
		204,
		218,
		222,
		250,
		-1,
		196,
		-1,
		-1,
		-1,
		235,
		236,
		222,
		199,
		178,
		171,
		168,
		167,
		172,
		183,
		192,
		203,
		168,
		172,
		187,
		192,
		196,
		213,
		217,
		-1,
		-1,
		194,
		190,
		225,
		237,
		209,
		249,
		-1,
		-1,
		167,
		160,
		170,
		163,
		176,
		179,
		164,
		166,
		184,
		197,
		191,
		201,
		216,
		211,
		-1,
		-1,
		-1,
		192,
		-1,
		208,
		-1,
		-1,
		199,
		240,
		187,
		169,
		165,
		151,
		158,
		152,
		154,
		159,
		178,
		173,
		182,
		187,
		191,
		214,
		203,
		242,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		158,
		177,
		172,
		178,
		183,
		174,
		202,
		199,
		-1,
		148,
		181,
		149,
		163,
		159,
		166,
		171,
		177,
		181,
		188,
		204,
		203,
		198,
		234,
		225,
		231,
		-1,
		-1,
		139,
		128,
		117,
		123,
		-1,
		151,
		174,
		164,
		154,
		160,
		-1,
		-1,
		166,
		163,
		161,
		141,
		147,
		152,
		155,
		193,
		169,
		177,
		181,
		185,
		191,
		196,
		201,
		207,
		222,
		237,
		-1,
		93,
		130,
		123,
		91,
		99,
		130,
		-1,
		141,
		133,
		161,
		146,
		154,
		-1,
		-1,
		139,
		130,
		135,
		144,
		145,
		176,
		175,
		188,
		191,
		196,
		184,
		183,
		201,
		205,
		214,
		221,
		211,
		224,
		228,
		-1,
		86,
		106,
		85,
		88,
		112,
		126,
		-1,
		132,
		-1,
		-1,
		177,
		164,
		148,
		138,
		135,
		182,
		158,
		153,
		159,
		161,
		185,
		176,
		201,
		192,
		192,
		195,
		210,
		215,
		207,
		221,
		221,
		222,
		-1,
		75,
		86,
		79,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		193,
		-1,
		175,
		-1,
		158,
		162,
		166,
		169,
		184,
		171,
		178,
		195,
		201,
		190,
		200,
		196,
		197,
		206,
		217,
		229,
		228,
		229,
		125,
		80,
		59,
		70,
		19,
		4,
		0,
		-1,
		116,
		152,
		162,
		-1,
		202,
		-1,
		-1,
		-1,
		172,
		179,
		171,
		187,
		183,
		183,
		179,
		183,
		195,
		202,
		212,
		214,
		206,
		210,
		223,
		234,
		237,
		121,
		119,
		124,
		69,
		54,
		32,
		24,
		4,
		112,
		109,
		146,
		151,
		166,
		171,
		195,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		190,
		200,
		183,
		185,
		189,
		203,
		215,
		223,
		213,
		211,
		205,
		237,
		-1,
		121,
		120,
		109,
		106,
		82,
		73,
		60,
		67,
		-1,
		-1,
		110,
		137,
		121,
		125,
		141,
		166,
		-1,
		202,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		205,
		194,
		185,
		191,
		197,
		208,
		230,
		219,
		220,
		210,
		220,
		233,
		105,
		102,
		90,
		88,
		111,
		68,
		64,
		-1,
		92,
		95,
		101,
		108,
		125,
		155,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		235,
		238,
		227,
		-1,
		217,
		190,
		195,
		220,
		227,
		228,
		222,
		216,
		223,
		222,
		230,
		238,
		114,
		128,
		117,
		113,
		112,
		120,
		69,
		82,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		-1,
		241,
		228,
		-1,
		-1,
		235,
		228,
		216,
		204,
		194,
		204,
		212,
		212,
		215,
		219,
		214,
		225,
		217,
		221,
		238,
		-1,
		148,
		-1,
		100,
		89,
		104,
		119,
		127,
		-1,
		-1,
		-1,
		258,
		244,
		237,
		225,
		223,
		-1,
		269,
		253,
		234,
		-1,
		204,
		217,
		248,
		216,
		221,
		216,
		220,
		231,
		220,
		223,
		237,
		232,
		-1,
		-1,
		102,
		105,
		-1,
		-1,
		127,
		146,
		-1,
		249,
		238,
		223,
		215,
		-1,
		-1,
		241,
		237,
		-1,
		-1,
		205,
		230,
		219,
		227,
		222,
		224,
		230,
		233,
		222,
		226,
		238,
		-1,
		-1,
		109,
		110,
		115,
		-1,
		136,
		-1,
		251,
		-1,
		218,
		225,
		213,
		-1,
		-1,
		-1,
		243,
		206,
		227,
		237,
		242,
		240,
		231,
		228,
		235,
		233,
		229,
		240,
		-1,
		-1,
		-1,
		166,
		143,
		258,
		249,
		232,
		212,
		204,
		224,
		-1,
		231,
		-1,
		206,
		207,
		234,
		236,
		253,
		247,
		231,
		246,
		236,
		227,
		236,
		172,
		-1,
		147,
		206,
		189,
		218,
		184,
		196,
		252,
		-1,
		228,
		210,
		-1,
		238,
		228,
		270,
		251,
		244,
		231,
		238,
		240,
		233,
		-1,
		-1,
		-1,
		162,
		161,
		160,
		171,
		179,
		177,
		195,
		-1,
		240,
		222,
		201,
		218,
		218,
		209,
		217,
		260,
		256,
		249,
		251,
		241,
		-1,
		220,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		188,
		210,
		205,
		197,
		209,
		218,
		205,
		211,
		213,
		221,
		219,
		216,
		228,
		224,
		244,
		240,
		272,
		-1,
		227,
		-1,
		192,
		-1,
		-1,
		206,
		192,
		204,
		215,
		205,
		205,
		210,
		208,
		230,
		247,
		231,
		229,
		234,
		239,
		-1,
		237,
		238,
		-1,
		225,
		217,
		203,
		-1,
		196,
		-1,
		251,
		212,
		-1,
		237,
		217,
		-1,
		240,
		236,
		-1,
		-1,
		249,
		241,
		-1,
		-1,
		-1,
		226,
		206,
		246,
		230,
		-1,
		228,
		228,
		-1,
		-1,
		-1,
		263,
		250,
		-1,
		219,
		222,
		-1,
		213,
		219,
		248,
		230,
		234,
		-1,
		-1,
		-1,
		275,
		256,
		250,
		234,
		239,
		227,
		244,
		230,
		232,
		244,
		233,
		254,
		-1,
		-1,
		-1,
		247,
		239,
		239,
		-1,
		-1,
		257,
		240,
		240,
		253,
		-1,
		-1,
		-1,
		269,
		250,
		-1,
		-1,
		248,
		-1,
		-1,
		253,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		258,
		-1,
		-1,
		-1,
		249,
		256,
		264,
		-1,
		-1,
		-1,
		-1,
		279,
		280,
		304,
		279,
		-1,
		-1,
		-1,
		263,
		263,
		-1,
		-1,
		278,
		279,
		-1,
		-1,
		-1,
		291,
		275,
		-1,
		267,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		296,
		-1,
		302,
		277,
		284,
		-1,
		-1,
		-1,
		-1,
		309,
		301,
		315,
		-1,
		287,
		289,
		-1,
		337,
		-1,
		-1,
		324,
		315,
		-1,
		-1,
		292,
		299,
		321,
		324,
		354,
		-1,
		311
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		281,
		270,
		281,
		289,
		262,
		269,
		-1,
		290,
		292,
		258,
		252,
		291,
		262,
		268,
		279,
		-1,
		-1,
		-1,
		281,
		280,
		250,
		248,
		257,
		262,
		269,
		-1,
		271,
		-1,
		302,
		281,
		292,
		297,
		243,
		240,
		260,
		279,
		264,
		256,
		317,
		273,
		244,
		238,
		256,
		249,
		258,
		250,
		-1,
		244,
		234,
		256,
		238,
		249,
		241,
		-1,
		-1,
		238,
		239,
		245,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		228,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		217,
		235,
		244,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		209,
		211,
		233,
		241,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		206,
		214,
		237,
		229,
		219,
		234,
		227,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		262,
		231,
		266,
		223,
		208,
		-1,
		202,
		213,
		219,
		223,
		217,
		210,
		224,
		220,
		-1,
		193,
		192,
		220,
		206,
		217,
		222,
		-1,
		-1,
		220,
		212,
		197,
		200,
		197,
		197,
		227,
		226,
		219,
		205,
		201,
		207,
		210,
		210,
		216,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		219,
		202,
		-1,
		185,
		192,
		192,
		209,
		199,
		220,
		235,
		229,
		221,
		215,
		203,
		205,
		202,
		215,
		203,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		178,
		181,
		187,
		211,
		221,
		-1,
		242,
		238,
		239,
		224,
		221,
		208,
		196,
		209,
		194,
		201,
		200,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		227,
		223,
		219,
		226,
		175,
		-1,
		-1,
		215,
		-1,
		229,
		242,
		246,
		235,
		238,
		225,
		216,
		203,
		192,
		203,
		192,
		189,
		197,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		277,
		-1,
		219,
		203,
		205,
		177,
		198,
		-1,
		235,
		230,
		250,
		248,
		239,
		-1,
		234,
		231,
		221,
		199,
		184,
		201,
		193,
		191,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		237,
		227,
		-1,
		209,
		214,
		173,
		181,
		200,
		273,
		245,
		-1,
		240,
		-1,
		232,
		249,
		-1,
		205,
		201,
		183,
		184,
		179,
		194,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		222,
		226,
		215,
		166,
		185,
		209,
		246,
		238,
		227,
		226,
		-1,
		217,
		219,
		216,
		204,
		191,
		176,
		177,
		185,
		197,
		176,
		170,
		167,
		187,
		213,
		191,
		202,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		192,
		163,
		187,
		229,
		256,
		249,
		237,
		202,
		202,
		196,
		-1,
		215,
		194,
		185,
		174,
		172,
		185,
		177,
		185,
		165,
		163,
		182,
		194,
		185,
		193,
		-1,
		-1,
		-1,
		222,
		211,
		212,
		158,
		181,
		218,
		235,
		221,
		226,
		201,
		194,
		188,
		228,
		211,
		192,
		181,
		173,
		162,
		173,
		181,
		179,
		161,
		170,
		176,
		200,
		181,
		187,
		-1,
		-1,
		229,
		219,
		203,
		205,
		202,
		172,
		179,
		211,
		226,
		223,
		-1,
		193,
		-1,
		182,
		190,
		186,
		181,
		178,
		165,
		164,
		178,
		178,
		168,
		163,
		170,
		205,
		205,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		222,
		217,
		192,
		169,
		153,
		189,
		-1,
		193,
		194,
		-1,
		187,
		181,
		187,
		186,
		184,
		169,
		173,
		175,
		178,
		166,
		172,
		173,
		155,
		179,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		215,
		194,
		187,
		207,
		148,
		200,
		-1,
		-1,
		178,
		171,
		-1,
		174,
		174,
		181,
		176,
		172,
		174,
		171,
		160,
		173,
		166,
		160,
		154,
		167,
		171,
		172,
		161,
		157,
		154,
		168,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		168,
		-1,
		186,
		178,
		169,
		163,
		169,
		187,
		185,
		200,
		184,
		186,
		182,
		174,
		169,
		155,
		148,
		159,
		144,
		162,
		168,
		159,
		154,
		153,
		164,
		-1,
		235,
		221,
		192,
		-1,
		-1,
		181,
		-1,
		145,
		164,
		180,
		-1,
		203,
		182,
		205,
		183,
		195,
		193,
		191,
		192,
		162,
		167,
		169,
		157,
		160,
		149,
		152,
		144,
		166,
		163,
		147,
		149,
		158,
		-1,
		241,
		228,
		186,
		182,
		171,
		191,
		142,
		151,
		167,
		-1,
		-1,
		219,
		-1,
		173,
		175,
		207,
		205,
		181,
		156,
		163,
		181,
		154,
		149,
		154,
		143,
		143,
		138,
		157,
		143,
		141,
		156,
		172,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		157,
		144,
		138,
		-1,
		184,
		-1,
		197,
		185,
		172,
		154,
		194,
		-1,
		155,
		151,
		158,
		-1,
		174,
		-1,
		146,
		149,
		140,
		135,
		132,
		143,
		141,
		150,
		151,
		-1,
		191,
		176,
		169,
		159,
		173,
		141,
		-1,
		175,
		-1,
		-1,
		184,
		178,
		178,
		147,
		144,
		171,
		151,
		143,
		158,
		157,
		144,
		143,
		131,
		131,
		134,
		128,
		141,
		151,
		157,
		149,
		-1,
		-1,
		-1,
		196,
		171,
		165,
		137,
		141,
		-1,
		-1,
		245,
		201,
		187,
		-1,
		139,
		171,
		159,
		149,
		139,
		144,
		145,
		135,
		133,
		129,
		138,
		137,
		130,
		129,
		150,
		143,
		165,
		-1,
		-1,
		170,
		163,
		151,
		119,
		114,
		-1,
		-1,
		-1,
		191,
		177,
		165,
		137,
		160,
		-1,
		-1,
		143,
		136,
		130,
		128,
		121,
		141,
		148,
		136,
		123,
		138,
		148,
		156,
		155,
		-1,
		173,
		160,
		-1,
		-1,
		113,
		103,
		-1,
		-1,
		-1,
		-1,
		155,
		136,
		131,
		126,
		130,
		142,
		-1,
		115,
		119,
		119,
		139,
		146,
		138,
		123,
		117,
		128,
		143,
		160,
		-1,
		-1,
		127,
		-1,
		89,
		-1,
		-1,
		-1,
		-1,
		127,
		142,
		119,
		112,
		116,
		-1,
		113,
		112,
		116,
		122,
		134,
		138,
		129,
		111,
		125,
		128,
		141,
		155,
		159,
		150,
		-1,
		80,
		-1,
		-1,
		-1,
		119,
		120,
		152,
		129,
		108,
		101,
		98,
		104,
		108,
		120,
		129,
		140,
		105,
		109,
		124,
		129,
		133,
		150,
		154,
		-1,
		-1,
		78,
		74,
		109,
		121,
		93,
		179,
		-1,
		-1,
		97,
		90,
		100,
		100,
		113,
		116,
		101,
		103,
		121,
		134,
		128,
		138,
		153,
		148,
		-1,
		-1,
		-1,
		76,
		-1,
		92,
		-1,
		-1,
		83,
		170,
		117,
		99,
		95,
		81,
		95,
		89,
		91,
		96,
		115,
		110,
		119,
		124,
		128,
		151,
		140,
		179,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		42,
		61,
		56,
		62,
		67,
		58,
		132,
		129,
		-1,
		77,
		118,
		86,
		100,
		96,
		103,
		108,
		114,
		118,
		125,
		141,
		140,
		135,
		171,
		162,
		168,
		-1,
		-1,
		145,
		134,
		123,
		129,
		-1,
		35,
		58,
		48,
		38,
		44,
		-1,
		-1,
		91,
		88,
		91,
		78,
		84,
		89,
		92,
		130,
		106,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		99,
		136,
		129,
		97,
		105,
		136,
		-1,
		25,
		17,
		45,
		30,
		38,
		-1,
		-1,
		64,
		60,
		65,
		74,
		77,
		113,
		112,
		125,
		128,
		133,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		92,
		112,
		91,
		94,
		118,
		132,
		-1,
		16,
		-1,
		-1,
		61,
		51,
		59,
		55,
		59,
		112,
		88,
		83,
		96,
		98,
		122,
		113,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		81,
		92,
		85,
		-1,
		-1,
		-1,
		-1,
		10,
		-1,
		-1,
		77,
		-1,
		85,
		-1,
		78,
		82,
		96,
		99,
		121,
		108,
		115,
		132,
		138,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		106,
		62,
		65,
		76,
		87,
		102,
		106,
		-1,
		0,
		39,
		88,
		-1,
		86,
		-1,
		-1,
		-1,
		92,
		109,
		101,
		117,
		120,
		120,
		116,
		120,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		102,
		93,
		106,
		51,
		51,
		72,
		81,
		102,
		15,
		6,
		33,
		77,
		92,
		97,
		93,
		-1,
		-1,
		115,
		119,
		-1,
		-1,
		127,
		137,
		120,
		122,
		126,
		140,
		152,
		160,
		150,
		148,
		142,
		174,
		-1,
		95,
		94,
		83,
		80,
		56,
		47,
		42,
		69,
		-1,
		-1,
		18,
		34,
		47,
		51,
		67,
		92,
		-1,
		96,
		-1,
		-1,
		136,
		-1,
		-1,
		179,
		142,
		131,
		122,
		128,
		134,
		145,
		167,
		156,
		157,
		147,
		157,
		170,
		79,
		76,
		64,
		62,
		85,
		50,
		38,
		-1,
		33,
		21,
		27,
		34,
		51,
		81,
		-1,
		-1,
		112,
		103,
		-1,
		-1,
		155,
		162,
		164,
		-1,
		154,
		127,
		132,
		157,
		164,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		88,
		102,
		91,
		87,
		86,
		94,
		43,
		36,
		36,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		122,
		-1,
		-1,
		162,
		165,
		153,
		141,
		131,
		141,
		149,
		149,
		152,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		122,
		-1,
		74,
		42,
		62,
		77,
		85,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		185,
		153,
		158,
		153,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		60,
		63,
		-1,
		-1,
		87,
		106,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		142,
		167,
		156,
		164,
		159,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		67,
		70,
		75,
		-1,
		96,
		-1,
		179,
		-1,
		124,
		140,
		142,
		-1,
		-1,
		-1,
		180,
		143,
		164,
		174,
		179,
		177,
		168,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		126,
		103,
		186,
		177,
		160,
		140,
		132,
		157,
		-1,
		168,
		-1,
		143,
		144,
		171,
		173,
		190,
		184,
		168,
		183,
		173,
		164,
		173,
		132,
		-1,
		107,
		166,
		149,
		146,
		144,
		145,
		189,
		-1,
		165,
		147,
		-1,
		175,
		165,
		207,
		188,
		181,
		168,
		175,
		177,
		170,
		-1,
		-1,
		-1,
		122,
		121,
		120,
		131,
		139,
		137,
		146,
		-1,
		177,
		159,
		138,
		155,
		155,
		146,
		154,
		197,
		193,
		186,
		188,
		178,
		-1,
		194,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		148,
		170,
		159,
		147,
		160,
		156,
		142,
		148,
		150,
		158,
		156,
		153,
		165,
		161,
		181,
		177,
		209,
		-1,
		201,
		-1,
		152,
		-1,
		-1,
		166,
		152,
		164,
		170,
		159,
		157,
		155,
		146,
		168,
		184,
		168,
		166,
		171,
		176,
		-1,
		211,
		212,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		205,
		166,
		-1,
		175,
		155,
		-1,
		177,
		173,
		-1,
		-1,
		223,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		200,
		184,
		-1,
		166,
		166,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		179,
		182,
		-1,
		173,
		179,
		208,
		168,
		172,
		-1,
		-1,
		-1,
		235,
		216,
		210,
		194,
		199,
		187,
		204,
		190,
		192,
		182,
		171,
		192,
		-1,
		-1,
		-1,
		207,
		199,
		199,
		-1,
		-1,
		217,
		200,
		193,
		191,
		-1,
		-1,
		-1,
		229,
		210,
		-1,
		-1,
		208,
		-1,
		-1,
		213,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		218,
		-1,
		-1,
		-1,
		209,
		211,
		212,
		-1,
		-1,
		-1,
		-1,
		239,
		240,
		264,
		239,
		-1,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		242,
		240,
		-1,
		-1,
		-1,
		235,
		219,
		-1,
		205,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		240,
		-1,
		240,
		215,
		222,
		-1,
		-1,
		-1,
		-1,
		253,
		245,
		253,
		-1,
		225,
		227,
		-1,
		275,
		-1,
		-1,
		268,
		259,
		-1,
		-1,
		230,
		237,
		259,
		262,
		298,
		-1,
		249
	],
	[
		-1,
		324,
		313,
		324,
		332,
		305,
		312,
		-1,
		333,
		335,
		301,
		295,
		334,
		305,
		311,
		322,
		-1,
		-1,
		-1,
		324,
		323,
		293,
		291,
		300,
		305,
		312,
		-1,
		314,
		-1,
		345,
		324,
		335,
		340,
		286,
		283,
		303,
		322,
		307,
		299,
		360,
		316,
		287,
		281,
		299,
		292,
		301,
		293,
		-1,
		287,
		277,
		299,
		281,
		292,
		284,
		-1,
		-1,
		281,
		282,
		288,
		277,
		283,
		279,
		-1,
		289,
		273,
		-1,
		-1,
		271,
		275,
		259,
		262,
		270,
		268,
		281,
		273,
		268,
		-1,
		-1,
		265,
		261,
		268,
		255,
		251,
		268,
		281,
		263,
		277,
		276,
		-1,
		260,
		278,
		287,
		262,
		260,
		244,
		242,
		260,
		262,
		268,
		268,
		-1,
		252,
		254,
		276,
		284,
		284,
		260,
		247,
		247,
		257,
		250,
		269,
		257,
		303,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		249,
		257,
		280,
		272,
		262,
		277,
		270,
		250,
		247,
		245,
		242,
		258,
		256,
		266,
		-1,
		-1,
		305,
		274,
		309,
		266,
		251,
		-1,
		245,
		256,
		262,
		266,
		260,
		253,
		267,
		263,
		-1,
		236,
		235,
		263,
		249,
		260,
		265,
		-1,
		-1,
		263,
		255,
		240,
		243,
		240,
		240,
		270,
		269,
		262,
		248,
		244,
		250,
		253,
		253,
		259,
		230,
		240,
		244,
		242,
		267,
		-1,
		-1,
		302,
		-1,
		-1,
		262,
		245,
		-1,
		228,
		235,
		235,
		252,
		242,
		263,
		278,
		272,
		264,
		258,
		246,
		248,
		245,
		258,
		246,
		227,
		252,
		256,
		237,
		258,
		253,
		-1,
		301,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		221,
		224,
		230,
		254,
		264,
		-1,
		285,
		281,
		282,
		267,
		264,
		251,
		239,
		252,
		237,
		244,
		243,
		231,
		229,
		259,
		234,
		256,
		253,
		272,
		277,
		271,
		280,
		-1,
		270,
		266,
		262,
		269,
		218,
		-1,
		-1,
		258,
		-1,
		272,
		285,
		289,
		278,
		281,
		268,
		259,
		246,
		235,
		246,
		235,
		232,
		240,
		223,
		238,
		229,
		228,
		246,
		256,
		264,
		268,
		274,
		-1,
		320,
		-1,
		262,
		246,
		248,
		220,
		241,
		-1,
		278,
		273,
		293,
		291,
		282,
		-1,
		277,
		274,
		264,
		242,
		227,
		244,
		236,
		234,
		236,
		218,
		232,
		223,
		241,
		248,
		246,
		250,
		270,
		282,
		280,
		270,
		-1,
		252,
		257,
		216,
		224,
		243,
		316,
		288,
		-1,
		283,
		-1,
		275,
		292,
		-1,
		248,
		244,
		226,
		227,
		222,
		237,
		229,
		214,
		211,
		229,
		232,
		239,
		243,
		259,
		-1,
		-1,
		265,
		269,
		258,
		209,
		228,
		252,
		289,
		281,
		270,
		269,
		-1,
		260,
		262,
		259,
		247,
		234,
		219,
		220,
		228,
		240,
		219,
		213,
		210,
		230,
		256,
		234,
		245,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		235,
		206,
		230,
		272,
		299,
		292,
		280,
		245,
		245,
		239,
		-1,
		258,
		237,
		228,
		217,
		215,
		228,
		220,
		228,
		208,
		206,
		225,
		237,
		228,
		236,
		-1,
		-1,
		-1,
		265,
		254,
		255,
		201,
		224,
		261,
		278,
		264,
		269,
		244,
		237,
		231,
		271,
		254,
		235,
		224,
		216,
		205,
		216,
		224,
		222,
		204,
		213,
		219,
		243,
		224,
		230,
		-1,
		-1,
		272,
		262,
		246,
		248,
		245,
		215,
		222,
		254,
		269,
		266,
		-1,
		236,
		-1,
		225,
		233,
		229,
		224,
		221,
		208,
		207,
		221,
		221,
		211,
		206,
		213,
		248,
		248,
		214,
		234,
		237,
		-1,
		-1,
		-1,
		265,
		260,
		235,
		212,
		196,
		232,
		-1,
		236,
		237,
		-1,
		230,
		224,
		230,
		229,
		227,
		212,
		216,
		218,
		221,
		209,
		215,
		216,
		198,
		222,
		-1,
		222,
		216,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		258,
		237,
		230,
		250,
		191,
		243,
		-1,
		-1,
		221,
		214,
		-1,
		217,
		217,
		224,
		219,
		215,
		217,
		214,
		203,
		216,
		209,
		203,
		197,
		210,
		214,
		215,
		204,
		200,
		197,
		211,
		-1,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		211,
		-1,
		229,
		221,
		212,
		206,
		212,
		230,
		228,
		243,
		227,
		229,
		225,
		217,
		212,
		198,
		191,
		202,
		187,
		205,
		211,
		202,
		197,
		196,
		207,
		-1,
		278,
		264,
		235,
		-1,
		-1,
		224,
		-1,
		188,
		207,
		223,
		-1,
		246,
		225,
		248,
		226,
		238,
		236,
		234,
		235,
		205,
		210,
		212,
		200,
		203,
		192,
		195,
		187,
		209,
		206,
		190,
		192,
		201,
		-1,
		284,
		271,
		229,
		225,
		214,
		234,
		185,
		194,
		210,
		-1,
		-1,
		262,
		-1,
		216,
		218,
		250,
		248,
		224,
		199,
		206,
		224,
		197,
		192,
		197,
		186,
		186,
		181,
		200,
		186,
		184,
		199,
		215,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		200,
		187,
		181,
		-1,
		227,
		-1,
		240,
		228,
		215,
		197,
		237,
		-1,
		198,
		194,
		201,
		-1,
		217,
		-1,
		189,
		192,
		183,
		178,
		175,
		186,
		184,
		193,
		194,
		-1,
		234,
		219,
		212,
		202,
		216,
		184,
		-1,
		218,
		-1,
		-1,
		227,
		221,
		221,
		190,
		187,
		214,
		194,
		186,
		201,
		200,
		187,
		186,
		174,
		174,
		177,
		171,
		184,
		194,
		200,
		192,
		-1,
		-1,
		-1,
		239,
		214,
		208,
		180,
		184,
		-1,
		-1,
		288,
		244,
		230,
		-1,
		182,
		214,
		202,
		192,
		182,
		187,
		188,
		178,
		176,
		172,
		181,
		180,
		173,
		172,
		193,
		186,
		208,
		-1,
		-1,
		213,
		206,
		194,
		162,
		157,
		-1,
		-1,
		-1,
		234,
		220,
		208,
		180,
		203,
		-1,
		-1,
		186,
		179,
		173,
		171,
		164,
		184,
		191,
		179,
		166,
		181,
		191,
		199,
		198,
		-1,
		216,
		203,
		-1,
		-1,
		156,
		146,
		-1,
		-1,
		-1,
		-1,
		198,
		179,
		174,
		169,
		173,
		185,
		-1,
		158,
		162,
		162,
		182,
		189,
		181,
		166,
		160,
		171,
		186,
		203,
		-1,
		-1,
		170,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		170,
		185,
		162,
		155,
		159,
		-1,
		156,
		155,
		159,
		165,
		177,
		181,
		172,
		154,
		168,
		171,
		184,
		198,
		202,
		193,
		-1,
		123,
		-1,
		-1,
		-1,
		162,
		163,
		195,
		172,
		151,
		144,
		141,
		147,
		151,
		163,
		172,
		183,
		148,
		152,
		167,
		172,
		176,
		193,
		197,
		-1,
		-1,
		121,
		117,
		152,
		164,
		136,
		222,
		-1,
		-1,
		140,
		133,
		143,
		143,
		156,
		159,
		144,
		146,
		164,
		177,
		171,
		181,
		196,
		191,
		-1,
		-1,
		-1,
		119,
		-1,
		135,
		-1,
		-1,
		126,
		213,
		160,
		142,
		138,
		124,
		138,
		132,
		134,
		139,
		158,
		153,
		162,
		167,
		171,
		194,
		183,
		222,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		85,
		104,
		99,
		105,
		110,
		101,
		175,
		172,
		-1,
		120,
		161,
		129,
		143,
		139,
		146,
		151,
		157,
		161,
		168,
		184,
		183,
		178,
		214,
		205,
		211,
		-1,
		-1,
		183,
		172,
		161,
		167,
		-1,
		78,
		101,
		91,
		81,
		87,
		-1,
		-1,
		134,
		131,
		134,
		121,
		127,
		132,
		135,
		173,
		149,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		137,
		174,
		167,
		135,
		143,
		174,
		-1,
		68,
		60,
		88,
		73,
		81,
		-1,
		-1,
		107,
		103,
		108,
		117,
		120,
		156,
		155,
		168,
		171,
		176,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		130,
		150,
		129,
		132,
		156,
		170,
		-1,
		58,
		-1,
		-1,
		104,
		94,
		102,
		98,
		102,
		155,
		131,
		126,
		139,
		141,
		165,
		156,
		181,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		119,
		130,
		123,
		-1,
		-1,
		-1,
		-1,
		53,
		-1,
		-1,
		120,
		-1,
		128,
		-1,
		121,
		125,
		139,
		142,
		164,
		151,
		158,
		175,
		181,
		170,
		180,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		144,
		100,
		103,
		114,
		125,
		140,
		144,
		-1,
		43,
		0,
		124,
		-1,
		129,
		-1,
		-1,
		-1,
		135,
		152,
		144,
		160,
		163,
		163,
		159,
		163,
		175,
		182,
		192,
		194,
		186,
		190,
		203,
		214,
		217,
		140,
		131,
		144,
		89,
		89,
		110,
		119,
		140,
		49,
		44,
		4,
		113,
		128,
		133,
		136,
		-1,
		-1,
		158,
		162,
		-1,
		-1,
		170,
		180,
		163,
		165,
		169,
		183,
		195,
		203,
		193,
		191,
		185,
		217,
		-1,
		133,
		132,
		121,
		118,
		94,
		85,
		80,
		107,
		-1,
		-1,
		55,
		68,
		83,
		87,
		103,
		128,
		-1,
		139,
		-1,
		-1,
		179,
		-1,
		-1,
		222,
		185,
		174,
		165,
		171,
		177,
		188,
		210,
		199,
		200,
		190,
		200,
		213,
		117,
		114,
		102,
		100,
		123,
		88,
		76,
		-1,
		71,
		59,
		65,
		70,
		87,
		117,
		-1,
		-1,
		155,
		146,
		-1,
		-1,
		198,
		205,
		207,
		-1,
		197,
		170,
		175,
		200,
		207,
		208,
		202,
		196,
		203,
		202,
		210,
		218,
		126,
		140,
		129,
		125,
		124,
		132,
		81,
		74,
		74,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		165,
		-1,
		-1,
		205,
		208,
		196,
		184,
		174,
		184,
		192,
		192,
		195,
		199,
		194,
		205,
		197,
		201,
		218,
		-1,
		160,
		-1,
		112,
		80,
		100,
		115,
		123,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		249,
		233,
		214,
		-1,
		184,
		197,
		228,
		196,
		201,
		196,
		200,
		211,
		200,
		203,
		217,
		212,
		-1,
		-1,
		98,
		101,
		-1,
		-1,
		125,
		144,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		221,
		217,
		-1,
		-1,
		185,
		210,
		199,
		207,
		202,
		204,
		210,
		213,
		202,
		206,
		218,
		-1,
		-1,
		105,
		108,
		113,
		-1,
		134,
		-1,
		222,
		-1,
		167,
		183,
		185,
		-1,
		-1,
		-1,
		223,
		186,
		207,
		217,
		222,
		220,
		211,
		208,
		215,
		213,
		209,
		220,
		-1,
		-1,
		-1,
		164,
		141,
		229,
		220,
		203,
		183,
		175,
		200,
		-1,
		211,
		-1,
		186,
		187,
		214,
		216,
		233,
		227,
		211,
		226,
		216,
		207,
		216,
		170,
		-1,
		145,
		204,
		187,
		189,
		182,
		188,
		232,
		-1,
		208,
		190,
		-1,
		218,
		208,
		250,
		231,
		224,
		211,
		218,
		220,
		213,
		-1,
		-1,
		-1,
		160,
		159,
		158,
		169,
		177,
		175,
		189,
		-1,
		220,
		202,
		181,
		198,
		198,
		189,
		197,
		240,
		236,
		229,
		231,
		221,
		-1,
		232,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		186,
		208,
		202,
		190,
		203,
		199,
		185,
		191,
		193,
		201,
		199,
		196,
		208,
		204,
		224,
		220,
		252,
		-1,
		239,
		-1,
		190,
		-1,
		-1,
		204,
		190,
		202,
		213,
		202,
		200,
		198,
		189,
		211,
		227,
		211,
		209,
		214,
		219,
		-1,
		249,
		250,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		248,
		209,
		-1,
		218,
		198,
		-1,
		220,
		216,
		-1,
		-1,
		261,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		243,
		227,
		-1,
		209,
		209,
		-1,
		-1,
		-1,
		264,
		248,
		-1,
		217,
		220,
		-1,
		211,
		217,
		246,
		211,
		215,
		-1,
		-1,
		-1,
		273,
		254,
		248,
		232,
		237,
		225,
		242,
		228,
		230,
		225,
		214,
		235,
		-1,
		-1,
		-1,
		245,
		237,
		237,
		-1,
		-1,
		255,
		238,
		236,
		234,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		246,
		-1,
		-1,
		251,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		256,
		-1,
		-1,
		-1,
		247,
		254,
		255,
		-1,
		-1,
		-1,
		-1,
		277,
		278,
		302,
		277,
		-1,
		-1,
		-1,
		250,
		244,
		-1,
		-1,
		280,
		278,
		-1,
		-1,
		-1,
		278,
		262,
		-1,
		248,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		283,
		-1,
		283,
		258,
		265,
		-1,
		-1,
		-1,
		-1,
		296,
		288,
		296,
		-1,
		268,
		270,
		-1,
		318,
		-1,
		-1,
		311,
		302,
		-1,
		-1,
		273,
		280,
		302,
		305,
		341,
		-1,
		292
	],
	[
		-1,
		329,
		318,
		329,
		337,
		310,
		317,
		-1,
		337,
		340,
		306,
		300,
		339,
		309,
		315,
		326,
		-1,
		-1,
		-1,
		329,
		328,
		297,
		295,
		304,
		309,
		316,
		-1,
		315,
		-1,
		350,
		329,
		340,
		345,
		290,
		287,
		307,
		326,
		308,
		300,
		365,
		320,
		291,
		285,
		303,
		293,
		302,
		294,
		-1,
		291,
		281,
		303,
		282,
		293,
		285,
		-1,
		-1,
		285,
		286,
		292,
		278,
		284,
		280,
		-1,
		290,
		274,
		-1,
		-1,
		275,
		276,
		260,
		263,
		271,
		269,
		282,
		274,
		269,
		-1,
		-1,
		266,
		262,
		269,
		256,
		252,
		269,
		282,
		264,
		278,
		277,
		-1,
		265,
		283,
		292,
		263,
		261,
		245,
		243,
		261,
		263,
		269,
		269,
		-1,
		257,
		259,
		275,
		283,
		285,
		261,
		248,
		248,
		258,
		251,
		270,
		258,
		304,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		254,
		262,
		279,
		271,
		261,
		276,
		269,
		251,
		248,
		246,
		243,
		259,
		257,
		267,
		-1,
		-1,
		310,
		279,
		314,
		271,
		256,
		-1,
		250,
		255,
		261,
		265,
		259,
		252,
		266,
		262,
		-1,
		237,
		236,
		264,
		250,
		261,
		270,
		-1,
		-1,
		268,
		260,
		245,
		248,
		245,
		245,
		270,
		269,
		261,
		247,
		243,
		249,
		252,
		252,
		258,
		231,
		241,
		245,
		243,
		268,
		-1,
		-1,
		303,
		-1,
		-1,
		267,
		250,
		-1,
		233,
		240,
		240,
		257,
		247,
		268,
		280,
		271,
		263,
		257,
		245,
		247,
		244,
		257,
		245,
		228,
		253,
		257,
		238,
		259,
		254,
		-1,
		302,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		226,
		229,
		235,
		259,
		269,
		-1,
		290,
		280,
		281,
		266,
		263,
		250,
		238,
		251,
		236,
		243,
		242,
		232,
		230,
		260,
		235,
		257,
		254,
		273,
		278,
		272,
		281,
		-1,
		275,
		271,
		267,
		274,
		223,
		-1,
		-1,
		263,
		-1,
		277,
		290,
		294,
		277,
		280,
		267,
		258,
		245,
		234,
		245,
		234,
		231,
		239,
		224,
		239,
		230,
		229,
		247,
		257,
		265,
		269,
		275,
		-1,
		325,
		-1,
		267,
		251,
		253,
		225,
		246,
		-1,
		283,
		278,
		298,
		296,
		287,
		-1,
		276,
		273,
		263,
		241,
		226,
		243,
		235,
		233,
		237,
		219,
		233,
		224,
		242,
		249,
		247,
		251,
		271,
		283,
		285,
		275,
		-1,
		257,
		262,
		221,
		229,
		248,
		321,
		293,
		-1,
		288,
		-1,
		278,
		291,
		-1,
		247,
		243,
		225,
		226,
		221,
		236,
		230,
		215,
		212,
		230,
		233,
		240,
		244,
		260,
		-1,
		-1,
		270,
		274,
		263,
		214,
		233,
		257,
		294,
		286,
		275,
		274,
		-1,
		265,
		261,
		258,
		246,
		233,
		218,
		219,
		227,
		240,
		219,
		214,
		211,
		231,
		257,
		235,
		247,
		-1,
		-1,
		-1,
		295,
		-1,
		-1,
		240,
		211,
		235,
		277,
		304,
		297,
		285,
		250,
		250,
		244,
		-1,
		257,
		236,
		227,
		216,
		214,
		227,
		224,
		229,
		209,
		207,
		226,
		238,
		229,
		246,
		-1,
		-1,
		-1,
		270,
		259,
		260,
		206,
		229,
		266,
		283,
		269,
		274,
		249,
		242,
		236,
		270,
		253,
		234,
		223,
		215,
		204,
		220,
		228,
		223,
		205,
		214,
		220,
		244,
		234,
		240,
		-1,
		-1,
		277,
		267,
		251,
		253,
		250,
		220,
		227,
		259,
		274,
		271,
		-1,
		241,
		-1,
		230,
		238,
		228,
		223,
		220,
		217,
		211,
		220,
		222,
		212,
		207,
		214,
		249,
		249,
		224,
		244,
		247,
		-1,
		-1,
		-1,
		270,
		265,
		240,
		217,
		201,
		237,
		-1,
		241,
		242,
		-1,
		235,
		229,
		235,
		230,
		226,
		221,
		225,
		218,
		225,
		218,
		216,
		217,
		199,
		231,
		-1,
		232,
		226,
		234,
		224,
		212,
		-1,
		-1,
		-1,
		263,
		242,
		235,
		255,
		196,
		248,
		-1,
		-1,
		226,
		219,
		-1,
		222,
		222,
		229,
		228,
		222,
		226,
		223,
		212,
		225,
		218,
		204,
		206,
		219,
		223,
		227,
		214,
		210,
		207,
		221,
		-1,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		216,
		-1,
		234,
		226,
		217,
		211,
		217,
		235,
		233,
		250,
		234,
		237,
		235,
		226,
		234,
		207,
		200,
		207,
		196,
		214,
		222,
		214,
		208,
		207,
		217,
		-1,
		283,
		269,
		240,
		-1,
		-1,
		229,
		-1,
		193,
		212,
		228,
		-1,
		251,
		230,
		253,
		231,
		245,
		241,
		257,
		258,
		235,
		235,
		233,
		224,
		212,
		201,
		204,
		196,
		218,
		218,
		202,
		203,
		207,
		-1,
		289,
		276,
		234,
		230,
		219,
		239,
		190,
		199,
		215,
		-1,
		-1,
		289,
		-1,
		229,
		245,
		255,
		253,
		247,
		229,
		236,
		244,
		221,
		216,
		206,
		195,
		195,
		190,
		212,
		198,
		196,
		205,
		221,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		205,
		192,
		186,
		-1,
		232,
		-1,
		267,
		255,
		242,
		224,
		264,
		-1,
		228,
		224,
		231,
		-1,
		241,
		-1,
		214,
		211,
		202,
		187,
		184,
		195,
		193,
		204,
		200,
		-1,
		239,
		224,
		217,
		207,
		221,
		189,
		-1,
		223,
		-1,
		-1,
		254,
		248,
		248,
		217,
		214,
		244,
		224,
		216,
		231,
		230,
		217,
		216,
		200,
		193,
		190,
		183,
		196,
		206,
		211,
		198,
		-1,
		-1,
		-1,
		244,
		219,
		213,
		185,
		189,
		-1,
		-1,
		315,
		271,
		257,
		-1,
		209,
		244,
		232,
		222,
		212,
		217,
		218,
		208,
		206,
		198,
		200,
		194,
		185,
		184,
		200,
		192,
		214,
		-1,
		-1,
		218,
		211,
		199,
		167,
		162,
		-1,
		-1,
		-1,
		261,
		247,
		235,
		207,
		233,
		-1,
		-1,
		216,
		209,
		203,
		204,
		194,
		214,
		209,
		193,
		178,
		193,
		197,
		205,
		196,
		-1,
		221,
		208,
		-1,
		-1,
		161,
		151,
		-1,
		-1,
		-1,
		-1,
		225,
		206,
		207,
		202,
		206,
		215,
		-1,
		189,
		195,
		193,
		212,
		219,
		195,
		180,
		174,
		180,
		192,
		201,
		-1,
		-1,
		175,
		-1,
		137,
		-1,
		-1,
		-1,
		-1,
		197,
		212,
		195,
		188,
		192,
		-1,
		189,
		188,
		190,
		198,
		198,
		195,
		186,
		177,
		173,
		177,
		181,
		195,
		199,
		198,
		-1,
		128,
		-1,
		-1,
		-1,
		174,
		196,
		228,
		205,
		184,
		177,
		174,
		177,
		182,
		193,
		202,
		213,
		178,
		180,
		170,
		169,
		173,
		190,
		194,
		-1,
		-1,
		126,
		122,
		157,
		169,
		169,
		255,
		-1,
		-1,
		173,
		166,
		176,
		173,
		186,
		189,
		174,
		176,
		176,
		174,
		168,
		178,
		193,
		188,
		-1,
		-1,
		-1,
		138,
		-1,
		140,
		-1,
		-1,
		159,
		246,
		193,
		175,
		171,
		157,
		169,
		163,
		164,
		169,
		179,
		173,
		170,
		164,
		168,
		191,
		180,
		219,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		141,
		109,
		104,
		138,
		143,
		134,
		208,
		205,
		-1,
		153,
		192,
		160,
		174,
		160,
		167,
		172,
		169,
		158,
		165,
		181,
		180,
		175,
		211,
		202,
		208,
		-1,
		-1,
		202,
		191,
		180,
		186,
		-1,
		134,
		106,
		124,
		114,
		120,
		-1,
		-1,
		167,
		164,
		167,
		152,
		158,
		161,
		156,
		166,
		142,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		156,
		193,
		186,
		154,
		162,
		193,
		-1,
		124,
		116,
		103,
		106,
		114,
		-1,
		-1,
		140,
		136,
		141,
		150,
		153,
		180,
		179,
		162,
		168,
		169,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		149,
		169,
		148,
		151,
		175,
		189,
		-1,
		115,
		-1,
		-1,
		63,
		127,
		135,
		131,
		135,
		188,
		164,
		159,
		167,
		165,
		160,
		151,
		176,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		138,
		149,
		142,
		-1,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		53,
		-1,
		161,
		-1,
		154,
		158,
		172,
		175,
		181,
		168,
		154,
		162,
		168,
		167,
		173,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		163,
		119,
		122,
		133,
		144,
		159,
		163,
		-1,
		99,
		132,
		0,
		-1,
		43,
		-1,
		-1,
		-1,
		168,
		185,
		177,
		193,
		180,
		180,
		146,
		150,
		163,
		170,
		180,
		191,
		183,
		187,
		200,
		211,
		214,
		159,
		150,
		163,
		108,
		108,
		129,
		138,
		159,
		83,
		92,
		126,
		7,
		4,
		9,
		33,
		-1,
		-1,
		191,
		195,
		-1,
		-1,
		187,
		154,
		142,
		152,
		156,
		170,
		182,
		195,
		183,
		188,
		182,
		214,
		-1,
		152,
		151,
		140,
		137,
		113,
		104,
		99,
		126,
		-1,
		-1,
		81,
		117,
		63,
		40,
		38,
		63,
		-1,
		40,
		-1,
		-1,
		194,
		-1,
		-1,
		179,
		159,
		148,
		139,
		144,
		164,
		175,
		197,
		179,
		196,
		187,
		197,
		201,
		136,
		133,
		121,
		119,
		142,
		107,
		95,
		-1,
		84,
		78,
		74,
		61,
		41,
		52,
		-1,
		-1,
		56,
		47,
		-1,
		-1,
		177,
		175,
		164,
		-1,
		154,
		136,
		141,
		171,
		173,
		175,
		182,
		176,
		183,
		191,
		202,
		194,
		145,
		159,
		148,
		144,
		143,
		151,
		100,
		93,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		91,
		66,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		158,
		158,
		161,
		166,
		174,
		185,
		181,
		185,
		188,
		-1,
		179,
		-1,
		131,
		99,
		119,
		134,
		142,
		-1,
		-1,
		-1,
		108,
		94,
		87,
		75,
		73,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		194,
		162,
		167,
		162,
		177,
		188,
		179,
		187,
		181,
		184,
		-1,
		-1,
		117,
		120,
		-1,
		-1,
		144,
		148,
		-1,
		99,
		88,
		73,
		65,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		128,
		166,
		165,
		173,
		168,
		173,
		185,
		181,
		177,
		187,
		178,
		-1,
		-1,
		124,
		127,
		132,
		-1,
		131,
		-1,
		123,
		-1,
		68,
		84,
		86,
		-1,
		-1,
		-1,
		159,
		122,
		138,
		161,
		187,
		185,
		176,
		169,
		176,
		179,
		172,
		178,
		-1,
		-1,
		-1,
		149,
		123,
		130,
		121,
		104,
		84,
		76,
		101,
		-1,
		140,
		-1,
		115,
		118,
		143,
		182,
		184,
		170,
		166,
		179,
		173,
		170,
		168,
		155,
		-1,
		125,
		158,
		122,
		90,
		90,
		89,
		154,
		-1,
		137,
		119,
		-1,
		147,
		137,
		185,
		160,
		169,
		162,
		156,
		157,
		165,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		110,
		95,
		90,
		-1,
		142,
		124,
		110,
		127,
		127,
		118,
		126,
		175,
		171,
		174,
		172,
		150,
		-1,
		241,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		130,
		103,
		91,
		105,
		112,
		107,
		109,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		236,
		-1,
		157,
		-1,
		-1,
		137,
		123,
		125,
		114,
		103,
		101,
		104,
		102,
		124,
		154,
		140,
		138,
		143,
		148,
		-1,
		225,
		224,
		-1,
		156,
		148,
		134,
		-1,
		127,
		-1,
		149,
		110,
		-1,
		131,
		111,
		-1,
		149,
		145,
		-1,
		-1,
		212,
		172,
		-1,
		-1,
		-1,
		157,
		137,
		144,
		128,
		-1,
		122,
		122,
		-1,
		-1,
		-1,
		197,
		181,
		-1,
		150,
		153,
		-1,
		144,
		150,
		177,
		124,
		128,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		165,
		170,
		158,
		175,
		161,
		160,
		138,
		127,
		148,
		-1,
		-1,
		-1,
		178,
		170,
		170,
		-1,
		-1,
		185,
		168,
		149,
		147,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		175,
		-1,
		-1,
		181,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		189,
		-1,
		-1,
		-1,
		171,
		167,
		168,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		235,
		210,
		-1,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		213,
		211,
		-1,
		-1,
		-1,
		191,
		175,
		-1,
		161,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		196,
		-1,
		196,
		171,
		178,
		-1,
		-1,
		-1,
		-1,
		209,
		201,
		209,
		-1,
		181,
		183,
		-1,
		231,
		-1,
		-1,
		224,
		215,
		-1,
		-1,
		186,
		193,
		215,
		218,
		254,
		-1,
		205
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		288,
		277,
		288,
		296,
		269,
		276,
		-1,
		297,
		299,
		265,
		259,
		298,
		269,
		275,
		286,
		-1,
		-1,
		-1,
		288,
		287,
		257,
		255,
		264,
		269,
		276,
		-1,
		299,
		-1,
		309,
		288,
		299,
		304,
		250,
		247,
		267,
		286,
		292,
		284,
		324,
		280,
		251,
		245,
		263,
		268,
		286,
		278,
		-1,
		251,
		241,
		263,
		267,
		278,
		262,
		-1,
		-1,
		245,
		246,
		252,
		263,
		269,
		265,
		-1,
		275,
		259,
		-1,
		-1,
		235,
		248,
		244,
		247,
		255,
		254,
		267,
		259,
		254,
		-1,
		-1,
		236,
		240,
		253,
		241,
		237,
		254,
		267,
		249,
		263,
		262,
		-1,
		224,
		242,
		251,
		248,
		246,
		230,
		228,
		246,
		248,
		254,
		254,
		-1,
		216,
		218,
		247,
		253,
		265,
		246,
		233,
		233,
		243,
		236,
		255,
		243,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		213,
		221,
		247,
		246,
		242,
		260,
		254,
		236,
		233,
		231,
		228,
		244,
		242,
		252,
		-1,
		-1,
		269,
		238,
		273,
		230,
		215,
		-1,
		209,
		228,
		234,
		238,
		243,
		237,
		251,
		247,
		-1,
		222,
		221,
		249,
		235,
		246,
		229,
		-1,
		-1,
		227,
		219,
		204,
		207,
		204,
		204,
		234,
		233,
		238,
		232,
		228,
		234,
		237,
		237,
		243,
		216,
		226,
		230,
		228,
		253,
		-1,
		-1,
		288,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		199,
		216,
		206,
		227,
		242,
		246,
		248,
		242,
		230,
		232,
		229,
		242,
		230,
		213,
		238,
		242,
		223,
		244,
		239,
		-1,
		287,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		228,
		-1,
		249,
		247,
		266,
		251,
		248,
		235,
		223,
		236,
		221,
		228,
		227,
		217,
		215,
		245,
		220,
		242,
		239,
		258,
		263,
		257,
		266,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		236,
		249,
		253,
		251,
		254,
		252,
		243,
		230,
		219,
		230,
		219,
		216,
		224,
		209,
		224,
		215,
		214,
		232,
		242,
		250,
		254,
		260,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		237,
		257,
		255,
		246,
		-1,
		249,
		252,
		248,
		226,
		211,
		228,
		220,
		218,
		222,
		204,
		218,
		209,
		227,
		234,
		232,
		236,
		256,
		268,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		280,
		252,
		-1,
		247,
		-1,
		239,
		264,
		-1,
		232,
		228,
		210,
		211,
		206,
		221,
		215,
		200,
		197,
		215,
		218,
		225,
		229,
		245,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		245,
		234,
		233,
		-1,
		224,
		246,
		243,
		231,
		218,
		203,
		204,
		212,
		225,
		204,
		199,
		196,
		216,
		242,
		220,
		232,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		263,
		256,
		244,
		209,
		209,
		203,
		-1,
		242,
		221,
		212,
		201,
		199,
		212,
		209,
		214,
		194,
		192,
		211,
		223,
		214,
		228,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		242,
		228,
		233,
		208,
		201,
		195,
		247,
		238,
		211,
		208,
		200,
		189,
		205,
		213,
		208,
		190,
		199,
		205,
		229,
		216,
		222,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		233,
		230,
		-1,
		200,
		-1,
		189,
		197,
		196,
		202,
		205,
		200,
		196,
		205,
		207,
		197,
		192,
		199,
		234,
		234,
		206,
		226,
		229,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		200,
		201,
		-1,
		194,
		188,
		194,
		193,
		200,
		197,
		197,
		203,
		210,
		201,
		201,
		202,
		184,
		214,
		-1,
		214,
		208,
		216,
		206,
		194,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		185,
		178,
		-1,
		181,
		181,
		188,
		197,
		202,
		207,
		206,
		195,
		208,
		201,
		189,
		189,
		202,
		206,
		207,
		196,
		192,
		189,
		203,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		193,
		185,
		176,
		170,
		176,
		194,
		192,
		212,
		204,
		218,
		217,
		209,
		204,
		190,
		183,
		192,
		179,
		197,
		203,
		194,
		189,
		188,
		199,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		171,
		187,
		-1,
		210,
		189,
		212,
		190,
		204,
		200,
		226,
		227,
		197,
		202,
		204,
		192,
		195,
		184,
		187,
		179,
		201,
		198,
		182,
		184,
		192,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		158,
		174,
		-1,
		-1,
		248,
		-1,
		188,
		204,
		214,
		212,
		216,
		191,
		198,
		216,
		189,
		184,
		189,
		178,
		178,
		173,
		192,
		178,
		176,
		190,
		206,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		191,
		-1,
		226,
		214,
		201,
		183,
		223,
		-1,
		190,
		186,
		193,
		-1,
		209,
		-1,
		181,
		184,
		175,
		170,
		167,
		178,
		176,
		185,
		185,
		-1,
		198,
		183,
		176,
		166,
		180,
		148,
		-1,
		182,
		-1,
		-1,
		213,
		207,
		207,
		176,
		173,
		206,
		186,
		178,
		193,
		192,
		179,
		178,
		166,
		166,
		169,
		163,
		176,
		186,
		192,
		183,
		-1,
		-1,
		-1,
		203,
		178,
		172,
		144,
		148,
		-1,
		-1,
		274,
		230,
		216,
		-1,
		168,
		206,
		194,
		184,
		174,
		179,
		180,
		170,
		168,
		164,
		173,
		172,
		165,
		164,
		185,
		177,
		199,
		-1,
		-1,
		177,
		170,
		158,
		126,
		121,
		-1,
		-1,
		-1,
		220,
		206,
		194,
		166,
		195,
		-1,
		-1,
		178,
		171,
		165,
		163,
		156,
		176,
		183,
		171,
		158,
		173,
		182,
		190,
		181,
		-1,
		180,
		167,
		-1,
		-1,
		120,
		110,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		166,
		161,
		165,
		177,
		-1,
		150,
		154,
		154,
		174,
		181,
		173,
		158,
		152,
		163,
		177,
		186,
		-1,
		-1,
		134,
		-1,
		96,
		-1,
		-1,
		-1,
		-1,
		156,
		171,
		154,
		147,
		151,
		-1,
		148,
		147,
		151,
		157,
		169,
		173,
		164,
		146,
		158,
		162,
		166,
		180,
		184,
		157,
		-1,
		87,
		-1,
		-1,
		-1,
		133,
		155,
		187,
		164,
		143,
		136,
		133,
		139,
		143,
		155,
		164,
		175,
		140,
		144,
		155,
		154,
		158,
		175,
		179,
		-1,
		-1,
		85,
		81,
		116,
		128,
		128,
		214,
		-1,
		-1,
		132,
		125,
		135,
		135,
		148,
		151,
		136,
		138,
		156,
		159,
		153,
		163,
		178,
		173,
		-1,
		-1,
		-1,
		97,
		-1,
		99,
		-1,
		-1,
		118,
		205,
		152,
		134,
		130,
		116,
		130,
		124,
		126,
		131,
		150,
		145,
		154,
		149,
		153,
		176,
		165,
		204,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		104,
		68,
		63,
		97,
		102,
		93,
		167,
		164,
		-1,
		112,
		153,
		121,
		135,
		131,
		138,
		143,
		149,
		143,
		150,
		166,
		165,
		160,
		196,
		187,
		193,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		97,
		65,
		83,
		73,
		79,
		-1,
		-1,
		126,
		123,
		126,
		113,
		119,
		124,
		127,
		151,
		127,
		139,
		143,
		147,
		153,
		158,
		163,
		169,
		184,
		199,
		-1,
		195,
		232,
		225,
		193,
		201,
		232,
		-1,
		87,
		79,
		62,
		65,
		73,
		-1,
		-1,
		99,
		95,
		100,
		109,
		112,
		148,
		147,
		147,
		153,
		154,
		146,
		145,
		163,
		167,
		176,
		183,
		173,
		186,
		190,
		-1,
		188,
		208,
		187,
		190,
		214,
		228,
		-1,
		84,
		-1,
		-1,
		20,
		86,
		94,
		90,
		94,
		147,
		123,
		118,
		131,
		133,
		145,
		136,
		161,
		154,
		154,
		157,
		172,
		177,
		169,
		183,
		183,
		184,
		-1,
		177,
		188,
		181,
		-1,
		-1,
		-1,
		-1,
		85,
		-1,
		-1,
		10,
		-1,
		120,
		-1,
		113,
		117,
		131,
		134,
		156,
		143,
		139,
		147,
		153,
		152,
		158,
		158,
		159,
		168,
		179,
		191,
		190,
		191,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		96,
		135,
		40,
		-1,
		0,
		-1,
		-1,
		-1,
		127,
		144,
		136,
		152,
		155,
		155,
		131,
		135,
		148,
		155,
		165,
		176,
		168,
		172,
		185,
		196,
		199,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		111,
		102,
		129,
		47,
		36,
		31,
		10,
		-1,
		-1,
		150,
		154,
		-1,
		-1,
		162,
		139,
		127,
		137,
		141,
		155,
		167,
		180,
		168,
		173,
		167,
		199,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		114,
		130,
		103,
		80,
		78,
		103,
		-1,
		25,
		-1,
		-1,
		171,
		-1,
		-1,
		164,
		144,
		133,
		124,
		129,
		149,
		160,
		182,
		164,
		181,
		172,
		182,
		186,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		124,
		117,
		114,
		101,
		81,
		92,
		-1,
		-1,
		41,
		32,
		-1,
		-1,
		162,
		160,
		149,
		-1,
		139,
		121,
		126,
		156,
		158,
		160,
		167,
		161,
		168,
		176,
		187,
		179,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		-1,
		76,
		51,
		-1,
		-1,
		157,
		150,
		138,
		126,
		116,
		126,
		143,
		143,
		146,
		151,
		159,
		170,
		166,
		170,
		173,
		-1,
		218,
		-1,
		170,
		138,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		93,
		79,
		72,
		60,
		58,
		-1,
		191,
		175,
		156,
		-1,
		126,
		139,
		179,
		147,
		152,
		147,
		162,
		173,
		164,
		172,
		166,
		169,
		-1,
		-1,
		156,
		157,
		-1,
		-1,
		131,
		133,
		-1,
		84,
		73,
		58,
		50,
		-1,
		-1,
		163,
		159,
		-1,
		-1,
		113,
		151,
		150,
		158,
		153,
		158,
		170,
		166,
		162,
		172,
		163,
		-1,
		-1,
		152,
		144,
		138,
		-1,
		116,
		-1,
		108,
		-1,
		53,
		69,
		71,
		-1,
		-1,
		-1,
		144,
		107,
		123,
		146,
		172,
		170,
		161,
		154,
		161,
		164,
		157,
		163,
		-1,
		-1,
		-1,
		134,
		108,
		115,
		106,
		89,
		69,
		61,
		86,
		-1,
		125,
		-1,
		100,
		103,
		128,
		167,
		169,
		155,
		151,
		164,
		158,
		155,
		153,
		140,
		-1,
		110,
		143,
		107,
		75,
		75,
		74,
		139,
		-1,
		122,
		104,
		-1,
		132,
		122,
		170,
		145,
		154,
		147,
		141,
		142,
		150,
		-1,
		-1,
		-1,
		112,
		111,
		103,
		97,
		95,
		80,
		75,
		-1,
		127,
		109,
		95,
		112,
		112,
		103,
		111,
		160,
		156,
		159,
		157,
		135,
		-1,
		226,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		106,
		115,
		88,
		76,
		90,
		97,
		92,
		94,
		107,
		115,
		113,
		110,
		122,
		118,
		138,
		134,
		166,
		-1,
		221,
		-1,
		142,
		-1,
		-1,
		122,
		108,
		110,
		99,
		88,
		86,
		89,
		87,
		109,
		139,
		125,
		123,
		128,
		133,
		-1,
		210,
		209,
		-1,
		141,
		133,
		119,
		-1,
		112,
		-1,
		134,
		95,
		-1,
		116,
		96,
		-1,
		134,
		130,
		-1,
		-1,
		197,
		157,
		-1,
		-1,
		-1,
		142,
		122,
		129,
		113,
		-1,
		107,
		107,
		-1,
		-1,
		-1,
		182,
		166,
		-1,
		135,
		138,
		-1,
		129,
		135,
		162,
		109,
		113,
		-1,
		-1,
		-1,
		191,
		172,
		166,
		150,
		155,
		143,
		160,
		146,
		145,
		123,
		112,
		133,
		-1,
		-1,
		-1,
		163,
		155,
		155,
		-1,
		-1,
		170,
		153,
		134,
		132,
		-1,
		-1,
		-1,
		185,
		166,
		-1,
		-1,
		160,
		-1,
		-1,
		166,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		174,
		-1,
		-1,
		-1,
		156,
		152,
		153,
		-1,
		-1,
		-1,
		-1,
		195,
		196,
		220,
		195,
		-1,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		198,
		196,
		-1,
		-1,
		-1,
		176,
		160,
		-1,
		146,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		181,
		-1,
		181,
		156,
		163,
		-1,
		-1,
		-1,
		-1,
		194,
		186,
		194,
		-1,
		166,
		168,
		-1,
		216,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		171,
		178,
		200,
		203,
		239,
		-1,
		190
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		269,
		258,
		269,
		277,
		250,
		257,
		-1,
		276,
		280,
		246,
		240,
		279,
		248,
		254,
		265,
		-1,
		-1,
		-1,
		269,
		268,
		236,
		234,
		243,
		248,
		255,
		-1,
		254,
		-1,
		290,
		269,
		280,
		285,
		229,
		226,
		246,
		265,
		247,
		239,
		305,
		259,
		230,
		224,
		242,
		232,
		241,
		233,
		-1,
		230,
		220,
		242,
		221,
		232,
		224,
		-1,
		-1,
		224,
		225,
		231,
		217,
		223,
		219,
		-1,
		229,
		213,
		-1,
		-1,
		214,
		215,
		199,
		202,
		210,
		208,
		221,
		213,
		208,
		-1,
		-1,
		205,
		201,
		208,
		195,
		191,
		208,
		221,
		203,
		217,
		216,
		-1,
		211,
		229,
		234,
		202,
		200,
		184,
		182,
		200,
		202,
		208,
		208,
		-1,
		220,
		221,
		216,
		224,
		224,
		200,
		187,
		187,
		197,
		190,
		209,
		197,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		220,
		203,
		220,
		212,
		202,
		217,
		210,
		190,
		187,
		185,
		182,
		198,
		196,
		206,
		-1,
		-1,
		306,
		275,
		310,
		267,
		250,
		-1,
		216,
		196,
		202,
		206,
		200,
		193,
		207,
		203,
		-1,
		176,
		175,
		203,
		189,
		200,
		266,
		-1,
		-1,
		264,
		256,
		241,
		244,
		226,
		222,
		211,
		210,
		202,
		188,
		184,
		190,
		193,
		193,
		199,
		170,
		180,
		184,
		182,
		207,
		-1,
		-1,
		242,
		-1,
		-1,
		263,
		246,
		-1,
		229,
		236,
		232,
		238,
		224,
		245,
		221,
		212,
		204,
		198,
		186,
		188,
		185,
		198,
		186,
		167,
		192,
		196,
		177,
		198,
		193,
		-1,
		241,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		222,
		225,
		231,
		255,
		261,
		-1,
		233,
		221,
		222,
		207,
		204,
		191,
		179,
		192,
		177,
		184,
		183,
		171,
		169,
		199,
		174,
		196,
		193,
		212,
		217,
		211,
		220,
		-1,
		271,
		267,
		263,
		270,
		219,
		-1,
		-1,
		259,
		-1,
		269,
		270,
		245,
		218,
		221,
		208,
		199,
		186,
		175,
		186,
		175,
		172,
		180,
		163,
		178,
		169,
		168,
		186,
		196,
		204,
		208,
		214,
		-1,
		321,
		-1,
		263,
		247,
		249,
		221,
		242,
		-1,
		279,
		270,
		262,
		247,
		245,
		-1,
		217,
		214,
		204,
		182,
		167,
		184,
		176,
		174,
		176,
		158,
		172,
		163,
		181,
		188,
		186,
		190,
		210,
		222,
		281,
		271,
		-1,
		253,
		258,
		217,
		225,
		244,
		287,
		251,
		-1,
		246,
		-1,
		219,
		232,
		-1,
		188,
		184,
		166,
		167,
		162,
		177,
		169,
		154,
		151,
		169,
		172,
		179,
		183,
		199,
		-1,
		-1,
		266,
		270,
		259,
		210,
		229,
		253,
		290,
		244,
		233,
		232,
		-1,
		223,
		202,
		199,
		187,
		174,
		159,
		160,
		168,
		180,
		159,
		153,
		150,
		170,
		196,
		174,
		186,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		236,
		207,
		231,
		273,
		262,
		255,
		243,
		208,
		208,
		202,
		-1,
		198,
		177,
		168,
		157,
		155,
		168,
		160,
		168,
		148,
		146,
		165,
		177,
		168,
		179,
		-1,
		-1,
		-1,
		266,
		255,
		256,
		202,
		225,
		262,
		241,
		227,
		232,
		207,
		200,
		194,
		211,
		194,
		175,
		164,
		156,
		145,
		156,
		164,
		162,
		144,
		153,
		159,
		183,
		167,
		173,
		-1,
		-1,
		273,
		263,
		247,
		249,
		246,
		216,
		223,
		255,
		232,
		245,
		-1,
		199,
		-1,
		188,
		184,
		169,
		164,
		161,
		148,
		147,
		161,
		161,
		151,
		146,
		153,
		188,
		188,
		157,
		177,
		180,
		-1,
		-1,
		-1,
		266,
		261,
		236,
		213,
		197,
		233,
		-1,
		215,
		216,
		-1,
		193,
		187,
		184,
		171,
		167,
		152,
		156,
		158,
		161,
		149,
		155,
		156,
		138,
		162,
		-1,
		165,
		159,
		167,
		157,
		145,
		-1,
		-1,
		-1,
		259,
		238,
		231,
		251,
		192,
		244,
		-1,
		-1,
		200,
		193,
		-1,
		180,
		162,
		164,
		157,
		151,
		157,
		153,
		143,
		156,
		149,
		143,
		137,
		150,
		154,
		158,
		147,
		143,
		140,
		154,
		-1,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		212,
		-1,
		209,
		201,
		191,
		185,
		179,
		175,
		173,
		179,
		163,
		166,
		161,
		157,
		148,
		138,
		131,
		142,
		127,
		145,
		153,
		145,
		139,
		138,
		150,
		-1,
		279,
		265,
		236,
		-1,
		-1,
		225,
		-1,
		189,
		208,
		224,
		-1,
		217,
		196,
		211,
		189,
		185,
		176,
		170,
		171,
		141,
		146,
		148,
		136,
		139,
		132,
		135,
		127,
		149,
		149,
		133,
		134,
		143,
		-1,
		285,
		272,
		230,
		226,
		215,
		235,
		186,
		179,
		211,
		-1,
		-1,
		225,
		-1,
		179,
		181,
		190,
		188,
		160,
		135,
		142,
		160,
		133,
		128,
		137,
		126,
		124,
		121,
		143,
		129,
		127,
		144,
		160,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		201,
		188,
		182,
		-1,
		228,
		-1,
		203,
		191,
		178,
		160,
		200,
		-1,
		134,
		130,
		137,
		-1,
		153,
		-1,
		125,
		128,
		119,
		116,
		115,
		126,
		124,
		135,
		139,
		-1,
		235,
		220,
		213,
		203,
		217,
		185,
		-1,
		219,
		-1,
		-1,
		190,
		184,
		184,
		153,
		150,
		150,
		130,
		122,
		137,
		136,
		123,
		122,
		110,
		110,
		113,
		116,
		129,
		139,
		142,
		137,
		-1,
		-1,
		-1,
		240,
		215,
		209,
		181,
		185,
		-1,
		-1,
		251,
		207,
		193,
		-1,
		145,
		150,
		138,
		128,
		118,
		123,
		124,
		114,
		112,
		108,
		117,
		121,
		118,
		117,
		138,
		131,
		153,
		-1,
		-1,
		214,
		207,
		195,
		163,
		158,
		-1,
		-1,
		-1,
		197,
		198,
		164,
		143,
		139,
		-1,
		-1,
		122,
		115,
		109,
		107,
		100,
		120,
		127,
		124,
		111,
		126,
		136,
		144,
		143,
		-1,
		217,
		204,
		-1,
		-1,
		157,
		147,
		-1,
		-1,
		-1,
		-1,
		176,
		121,
		110,
		105,
		109,
		121,
		-1,
		94,
		98,
		98,
		118,
		125,
		126,
		111,
		105,
		116,
		131,
		148,
		-1,
		-1,
		171,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		133,
		127,
		98,
		91,
		95,
		-1,
		92,
		91,
		95,
		101,
		114,
		119,
		117,
		99,
		113,
		116,
		129,
		143,
		147,
		194,
		-1,
		124,
		-1,
		-1,
		-1,
		151,
		156,
		131,
		108,
		87,
		80,
		77,
		83,
		87,
		103,
		109,
		120,
		93,
		97,
		112,
		117,
		121,
		138,
		142,
		-1,
		-1,
		122,
		118,
		153,
		159,
		129,
		158,
		-1,
		-1,
		76,
		69,
		79,
		88,
		93,
		96,
		89,
		91,
		109,
		122,
		116,
		126,
		141,
		136,
		-1,
		-1,
		-1,
		134,
		-1,
		136,
		-1,
		-1,
		119,
		149,
		96,
		78,
		74,
		60,
		83,
		77,
		79,
		84,
		103,
		98,
		107,
		112,
		116,
		139,
		128,
		167,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		113,
		105,
		99,
		102,
		103,
		94,
		111,
		108,
		-1,
		56,
		99,
		74,
		88,
		84,
		91,
		96,
		102,
		106,
		113,
		129,
		128,
		123,
		159,
		150,
		156,
		-1,
		-1,
		209,
		198,
		187,
		193,
		-1,
		106,
		102,
		88,
		78,
		80,
		-1,
		-1,
		73,
		70,
		79,
		66,
		72,
		77,
		80,
		118,
		94,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		147,
		162,
		-1,
		163,
		200,
		193,
		161,
		169,
		200,
		-1,
		96,
		88,
		98,
		74,
		71,
		-1,
		-1,
		46,
		48,
		53,
		62,
		65,
		101,
		100,
		113,
		116,
		121,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		156,
		176,
		155,
		158,
		182,
		196,
		-1,
		93,
		-1,
		-1,
		105,
		72,
		56,
		50,
		45,
		100,
		76,
		71,
		84,
		86,
		110,
		101,
		126,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		145,
		156,
		149,
		-1,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		121,
		-1,
		83,
		-1,
		18,
		47,
		84,
		87,
		109,
		96,
		103,
		120,
		126,
		115,
		125,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		170,
		126,
		129,
		140,
		151,
		166,
		170,
		-1,
		105,
		144,
		159,
		-1,
		130,
		-1,
		-1,
		-1,
		0,
		97,
		89,
		105,
		108,
		108,
		104,
		108,
		120,
		127,
		137,
		139,
		131,
		135,
		148,
		159,
		162,
		166,
		157,
		170,
		115,
		115,
		136,
		145,
		166,
		120,
		111,
		138,
		166,
		155,
		150,
		137,
		-1,
		-1,
		23,
		107,
		-1,
		-1,
		115,
		125,
		108,
		110,
		114,
		128,
		140,
		148,
		138,
		136,
		130,
		162,
		-1,
		159,
		158,
		147,
		144,
		120,
		111,
		106,
		133,
		-1,
		-1,
		123,
		139,
		139,
		143,
		159,
		184,
		-1,
		140,
		-1,
		-1,
		44,
		-1,
		-1,
		113,
		130,
		119,
		110,
		116,
		122,
		133,
		155,
		144,
		145,
		135,
		145,
		158,
		143,
		140,
		128,
		126,
		149,
		114,
		102,
		-1,
		115,
		113,
		119,
		126,
		143,
		173,
		-1,
		-1,
		156,
		147,
		-1,
		-1,
		63,
		70,
		98,
		-1,
		123,
		114,
		119,
		145,
		151,
		153,
		147,
		141,
		148,
		147,
		155,
		163,
		152,
		166,
		155,
		151,
		150,
		158,
		107,
		100,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		166,
		-1,
		-1,
		70,
		77,
		85,
		96,
		109,
		119,
		136,
		136,
		139,
		144,
		139,
		150,
		142,
		146,
		163,
		-1,
		186,
		-1,
		138,
		114,
		128,
		143,
		151,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		120,
		104,
		85,
		-1,
		119,
		132,
		172,
		140,
		145,
		140,
		145,
		156,
		145,
		148,
		162,
		157,
		-1,
		-1,
		126,
		129,
		-1,
		-1,
		151,
		170,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		92,
		88,
		-1,
		-1,
		120,
		154,
		143,
		151,
		146,
		149,
		155,
		158,
		147,
		151,
		163,
		-1,
		-1,
		133,
		134,
		139,
		-1,
		160,
		-1,
		214,
		-1,
		168,
		184,
		175,
		-1,
		-1,
		-1,
		158,
		121,
		142,
		161,
		166,
		164,
		155,
		153,
		160,
		158,
		154,
		165,
		-1,
		-1,
		-1,
		190,
		167,
		221,
		212,
		195,
		175,
		167,
		186,
		-1,
		156,
		-1,
		125,
		122,
		159,
		160,
		177,
		171,
		156,
		171,
		161,
		152,
		161,
		196,
		-1,
		171,
		223,
		187,
		181,
		157,
		161,
		177,
		-1,
		153,
		133,
		-1,
		163,
		153,
		194,
		176,
		168,
		155,
		162,
		165,
		158,
		-1,
		-1,
		-1,
		186,
		185,
		183,
		177,
		177,
		162,
		153,
		-1,
		165,
		147,
		126,
		143,
		143,
		134,
		142,
		184,
		180,
		173,
		175,
		166,
		-1,
		258,
		-1,
		-1,
		209,
		-1,
		-1,
		-1,
		186,
		181,
		154,
		142,
		148,
		144,
		130,
		136,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		165,
		197,
		-1,
		265,
		-1,
		216,
		-1,
		-1,
		204,
		184,
		176,
		165,
		154,
		152,
		143,
		134,
		156,
		172,
		156,
		154,
		159,
		164,
		-1,
		275,
		276,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		200,
		161,
		-1,
		163,
		143,
		-1,
		165,
		161,
		-1,
		-1,
		264,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		195,
		179,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		249,
		248,
		-1,
		217,
		220,
		-1,
		210,
		201,
		209,
		156,
		160,
		-1,
		-1,
		-1,
		258,
		239,
		233,
		232,
		230,
		225,
		222,
		208,
		192,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		230,
		222,
		215,
		-1,
		-1,
		217,
		200,
		181,
		179,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		207,
		-1,
		-1,
		213,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		241,
		-1,
		-1,
		-1,
		203,
		199,
		200,
		-1,
		-1,
		-1,
		-1,
		263,
		264,
		287,
		251,
		-1,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		266,
		264,
		-1,
		-1,
		-1,
		223,
		207,
		-1,
		193,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		228,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		241,
		233,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		218,
		225,
		247,
		250,
		286,
		-1,
		237
	],
	[
		-1,
		254,
		243,
		254,
		262,
		235,
		242,
		-1,
		261,
		265,
		231,
		225,
		264,
		233,
		239,
		250,
		-1,
		-1,
		-1,
		254,
		253,
		221,
		219,
		228,
		233,
		240,
		-1,
		239,
		-1,
		275,
		254,
		265,
		270,
		214,
		211,
		231,
		250,
		232,
		224,
		290,
		244,
		215,
		209,
		227,
		217,
		226,
		218,
		-1,
		215,
		205,
		227,
		206,
		217,
		209,
		-1,
		-1,
		209,
		210,
		216,
		202,
		208,
		204,
		-1,
		214,
		198,
		-1,
		-1,
		199,
		200,
		184,
		187,
		195,
		193,
		206,
		198,
		193,
		-1,
		-1,
		190,
		186,
		193,
		180,
		176,
		193,
		206,
		188,
		202,
		201,
		-1,
		196,
		214,
		219,
		187,
		185,
		169,
		167,
		185,
		187,
		193,
		193,
		-1,
		205,
		206,
		201,
		209,
		209,
		185,
		172,
		172,
		182,
		175,
		194,
		182,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		205,
		188,
		205,
		197,
		187,
		202,
		195,
		175,
		172,
		170,
		167,
		183,
		181,
		191,
		-1,
		-1,
		296,
		265,
		296,
		254,
		235,
		-1,
		201,
		181,
		187,
		191,
		185,
		178,
		192,
		188,
		-1,
		161,
		160,
		188,
		174,
		185,
		256,
		-1,
		-1,
		254,
		246,
		231,
		234,
		211,
		207,
		196,
		195,
		187,
		173,
		169,
		175,
		178,
		178,
		184,
		155,
		165,
		169,
		167,
		192,
		-1,
		-1,
		227,
		-1,
		-1,
		253,
		236,
		-1,
		219,
		226,
		217,
		223,
		209,
		230,
		206,
		197,
		189,
		183,
		171,
		173,
		170,
		183,
		171,
		152,
		177,
		181,
		162,
		183,
		178,
		-1,
		226,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		212,
		215,
		221,
		245,
		246,
		-1,
		218,
		206,
		207,
		192,
		189,
		176,
		164,
		177,
		162,
		169,
		168,
		156,
		154,
		184,
		159,
		181,
		178,
		197,
		202,
		196,
		205,
		-1,
		261,
		257,
		253,
		260,
		209,
		-1,
		-1,
		249,
		-1,
		254,
		255,
		230,
		203,
		206,
		193,
		184,
		171,
		160,
		171,
		160,
		157,
		165,
		148,
		163,
		154,
		153,
		171,
		181,
		189,
		193,
		199,
		-1,
		311,
		-1,
		253,
		237,
		239,
		211,
		232,
		-1,
		269,
		255,
		247,
		232,
		230,
		-1,
		202,
		199,
		189,
		167,
		152,
		169,
		161,
		159,
		161,
		143,
		157,
		148,
		166,
		173,
		171,
		175,
		195,
		207,
		271,
		261,
		-1,
		243,
		248,
		207,
		215,
		234,
		272,
		236,
		-1,
		231,
		-1,
		204,
		217,
		-1,
		173,
		169,
		151,
		152,
		147,
		162,
		154,
		139,
		136,
		154,
		157,
		164,
		168,
		184,
		-1,
		-1,
		256,
		260,
		249,
		200,
		219,
		243,
		280,
		229,
		218,
		217,
		-1,
		208,
		187,
		184,
		172,
		159,
		144,
		145,
		153,
		165,
		144,
		138,
		135,
		155,
		181,
		159,
		170,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		226,
		197,
		221,
		263,
		247,
		240,
		228,
		193,
		193,
		187,
		-1,
		183,
		162,
		153,
		142,
		140,
		153,
		145,
		153,
		133,
		131,
		150,
		162,
		153,
		161,
		-1,
		-1,
		-1,
		256,
		245,
		246,
		192,
		215,
		252,
		226,
		212,
		217,
		192,
		185,
		179,
		196,
		179,
		160,
		149,
		141,
		130,
		141,
		149,
		147,
		129,
		138,
		144,
		168,
		149,
		155,
		-1,
		-1,
		263,
		253,
		237,
		239,
		236,
		206,
		213,
		245,
		217,
		230,
		-1,
		184,
		-1,
		173,
		169,
		154,
		149,
		146,
		133,
		132,
		146,
		146,
		136,
		131,
		138,
		173,
		173,
		139,
		159,
		162,
		-1,
		-1,
		-1,
		256,
		251,
		226,
		203,
		187,
		223,
		-1,
		200,
		201,
		-1,
		178,
		172,
		169,
		156,
		152,
		137,
		141,
		143,
		146,
		134,
		140,
		141,
		123,
		147,
		-1,
		147,
		141,
		149,
		139,
		127,
		-1,
		-1,
		-1,
		249,
		228,
		221,
		241,
		182,
		234,
		-1,
		-1,
		185,
		178,
		-1,
		165,
		147,
		149,
		144,
		140,
		142,
		139,
		128,
		141,
		134,
		128,
		122,
		135,
		139,
		140,
		129,
		125,
		122,
		136,
		-1,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		202,
		-1,
		194,
		186,
		176,
		170,
		164,
		160,
		158,
		168,
		152,
		154,
		150,
		142,
		137,
		123,
		116,
		127,
		112,
		130,
		136,
		127,
		122,
		121,
		132,
		-1,
		269,
		255,
		226,
		-1,
		-1,
		215,
		-1,
		179,
		193,
		209,
		-1,
		202,
		181,
		196,
		174,
		170,
		161,
		159,
		160,
		130,
		135,
		137,
		125,
		128,
		117,
		120,
		112,
		134,
		131,
		115,
		117,
		126,
		-1,
		275,
		262,
		220,
		216,
		205,
		225,
		176,
		164,
		196,
		-1,
		-1,
		228,
		-1,
		172,
		184,
		175,
		173,
		149,
		124,
		131,
		149,
		122,
		117,
		122,
		111,
		111,
		106,
		125,
		111,
		109,
		124,
		140,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		191,
		178,
		172,
		-1,
		213,
		-1,
		206,
		194,
		181,
		163,
		203,
		-1,
		123,
		119,
		126,
		-1,
		142,
		-1,
		114,
		117,
		108,
		103,
		100,
		111,
		109,
		118,
		119,
		-1,
		225,
		210,
		203,
		193,
		207,
		178,
		-1,
		226,
		-1,
		-1,
		193,
		187,
		187,
		156,
		153,
		139,
		119,
		111,
		126,
		125,
		112,
		111,
		99,
		99,
		102,
		96,
		109,
		119,
		125,
		117,
		-1,
		-1,
		-1,
		230,
		216,
		216,
		180,
		192,
		-1,
		-1,
		254,
		210,
		196,
		-1,
		148,
		139,
		127,
		117,
		107,
		112,
		113,
		103,
		101,
		97,
		106,
		105,
		98,
		97,
		118,
		111,
		133,
		-1,
		-1,
		213,
		214,
		202,
		170,
		165,
		-1,
		-1,
		-1,
		200,
		201,
		167,
		146,
		128,
		-1,
		-1,
		111,
		104,
		98,
		101,
		89,
		109,
		116,
		104,
		91,
		106,
		116,
		124,
		123,
		-1,
		216,
		203,
		-1,
		-1,
		164,
		154,
		-1,
		-1,
		-1,
		-1,
		179,
		124,
		113,
		108,
		112,
		110,
		-1,
		84,
		95,
		88,
		107,
		114,
		106,
		91,
		85,
		96,
		111,
		128,
		-1,
		-1,
		178,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		136,
		130,
		101,
		94,
		98,
		-1,
		86,
		88,
		85,
		97,
		102,
		106,
		97,
		79,
		93,
		96,
		109,
		123,
		127,
		201,
		-1,
		131,
		-1,
		-1,
		-1,
		154,
		168,
		140,
		117,
		90,
		85,
		78,
		72,
		77,
		88,
		97,
		108,
		73,
		77,
		92,
		97,
		101,
		118,
		122,
		-1,
		-1,
		129,
		125,
		160,
		162,
		141,
		167,
		-1,
		-1,
		87,
		80,
		76,
		68,
		81,
		84,
		69,
		71,
		89,
		102,
		96,
		106,
		121,
		116,
		-1,
		-1,
		-1,
		141,
		-1,
		143,
		-1,
		-1,
		131,
		160,
		107,
		89,
		85,
		71,
		63,
		57,
		59,
		64,
		83,
		78,
		87,
		92,
		96,
		119,
		108,
		147,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		120,
		112,
		107,
		113,
		115,
		106,
		122,
		119,
		-1,
		68,
		86,
		54,
		68,
		64,
		71,
		76,
		82,
		86,
		93,
		109,
		108,
		103,
		139,
		130,
		136,
		-1,
		-1,
		211,
		200,
		189,
		195,
		-1,
		113,
		109,
		99,
		89,
		92,
		-1,
		-1,
		86,
		83,
		59,
		46,
		52,
		57,
		60,
		98,
		74,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		165,
		202,
		195,
		163,
		171,
		202,
		-1,
		103,
		95,
		106,
		81,
		83,
		-1,
		-1,
		59,
		50,
		50,
		38,
		41,
		69,
		80,
		85,
		96,
		101,
		89,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		158,
		178,
		157,
		160,
		184,
		198,
		-1,
		100,
		-1,
		-1,
		112,
		84,
		68,
		58,
		55,
		97,
		34,
		27,
		54,
		56,
		82,
		73,
		106,
		97,
		97,
		100,
		115,
		120,
		112,
		126,
		126,
		127,
		-1,
		147,
		158,
		151,
		-1,
		-1,
		-1,
		-1,
		101,
		-1,
		-1,
		128,
		-1,
		95,
		-1,
		78,
		82,
		12,
		45,
		81,
		68,
		75,
		92,
		98,
		95,
		103,
		101,
		102,
		111,
		122,
		134,
		133,
		134,
		172,
		128,
		131,
		142,
		153,
		168,
		172,
		-1,
		112,
		151,
		166,
		-1,
		137,
		-1,
		-1,
		-1,
		92,
		0,
		8,
		63,
		78,
		80,
		76,
		80,
		93,
		100,
		110,
		119,
		111,
		115,
		128,
		139,
		142,
		168,
		159,
		172,
		117,
		117,
		138,
		147,
		168,
		127,
		118,
		145,
		171,
		162,
		157,
		144,
		-1,
		-1,
		115,
		10,
		-1,
		-1,
		79,
		97,
		80,
		82,
		86,
		100,
		112,
		125,
		118,
		116,
		110,
		142,
		-1,
		161,
		160,
		149,
		146,
		122,
		113,
		108,
		135,
		-1,
		-1,
		130,
		146,
		141,
		145,
		161,
		186,
		-1,
		147,
		-1,
		-1,
		136,
		-1,
		-1,
		139,
		102,
		91,
		82,
		88,
		94,
		105,
		127,
		124,
		125,
		115,
		125,
		138,
		145,
		142,
		130,
		128,
		151,
		116,
		104,
		-1,
		117,
		115,
		121,
		128,
		145,
		175,
		-1,
		-1,
		163,
		154,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		87,
		92,
		117,
		124,
		126,
		127,
		121,
		128,
		127,
		135,
		143,
		154,
		168,
		157,
		153,
		152,
		160,
		109,
		102,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		184,
		173,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		101,
		109,
		109,
		112,
		117,
		119,
		130,
		122,
		126,
		143,
		-1,
		188,
		-1,
		140,
		116,
		130,
		145,
		153,
		-1,
		-1,
		-1,
		201,
		187,
		180,
		168,
		166,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		145,
		113,
		118,
		113,
		125,
		136,
		125,
		128,
		142,
		137,
		-1,
		-1,
		128,
		131,
		-1,
		-1,
		153,
		172,
		-1,
		192,
		181,
		166,
		158,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		102,
		127,
		116,
		124,
		119,
		129,
		135,
		138,
		127,
		131,
		143,
		-1,
		-1,
		135,
		136,
		141,
		-1,
		162,
		-1,
		194,
		-1,
		161,
		167,
		155,
		-1,
		-1,
		-1,
		140,
		103,
		124,
		134,
		139,
		137,
		128,
		127,
		134,
		138,
		134,
		145,
		-1,
		-1,
		-1,
		192,
		168,
		201,
		192,
		175,
		155,
		147,
		166,
		-1,
		136,
		-1,
		107,
		104,
		139,
		133,
		150,
		144,
		130,
		145,
		141,
		132,
		141,
		198,
		-1,
		170,
		203,
		167,
		161,
		137,
		141,
		157,
		-1,
		133,
		115,
		-1,
		143,
		133,
		167,
		153,
		141,
		128,
		135,
		145,
		138,
		-1,
		-1,
		-1,
		172,
		171,
		163,
		157,
		157,
		142,
		133,
		-1,
		145,
		127,
		106,
		123,
		123,
		114,
		122,
		157,
		153,
		146,
		148,
		140,
		-1,
		260,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		166,
		161,
		134,
		122,
		128,
		124,
		110,
		116,
		118,
		126,
		124,
		121,
		133,
		129,
		149,
		141,
		177,
		-1,
		267,
		-1,
		202,
		-1,
		-1,
		184,
		164,
		156,
		145,
		134,
		132,
		123,
		114,
		136,
		152,
		136,
		134,
		139,
		144,
		-1,
		257,
		256,
		-1,
		203,
		195,
		181,
		-1,
		174,
		-1,
		180,
		141,
		-1,
		143,
		123,
		-1,
		145,
		141,
		-1,
		-1,
		244,
		219,
		-1,
		-1,
		-1,
		204,
		184,
		175,
		159,
		-1,
		134,
		134,
		-1,
		-1,
		-1,
		229,
		228,
		-1,
		197,
		200,
		-1,
		190,
		181,
		189,
		136,
		140,
		-1,
		-1,
		-1,
		238,
		219,
		213,
		212,
		210,
		205,
		202,
		188,
		172,
		150,
		139,
		160,
		-1,
		-1,
		-1,
		210,
		202,
		195,
		-1,
		-1,
		197,
		180,
		161,
		159,
		-1,
		-1,
		-1,
		232,
		213,
		-1,
		-1,
		187,
		-1,
		-1,
		193,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		221,
		-1,
		-1,
		-1,
		183,
		179,
		180,
		-1,
		-1,
		-1,
		-1,
		243,
		244,
		267,
		231,
		-1,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		246,
		244,
		-1,
		-1,
		-1,
		203,
		187,
		-1,
		173,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		208,
		-1,
		208,
		183,
		190,
		-1,
		-1,
		-1,
		-1,
		221,
		213,
		221,
		-1,
		193,
		195,
		-1,
		243,
		-1,
		-1,
		236,
		227,
		-1,
		-1,
		198,
		205,
		227,
		230,
		266,
		-1,
		217
	],
	[
		-1,
		246,
		235,
		246,
		254,
		227,
		234,
		-1,
		253,
		257,
		223,
		217,
		256,
		225,
		231,
		242,
		-1,
		-1,
		-1,
		246,
		245,
		213,
		211,
		220,
		225,
		232,
		-1,
		231,
		-1,
		267,
		246,
		257,
		262,
		206,
		203,
		223,
		242,
		224,
		216,
		282,
		236,
		207,
		201,
		219,
		209,
		218,
		210,
		-1,
		207,
		197,
		219,
		198,
		209,
		201,
		-1,
		-1,
		201,
		202,
		208,
		194,
		200,
		196,
		-1,
		206,
		190,
		-1,
		-1,
		191,
		192,
		176,
		179,
		187,
		185,
		198,
		190,
		185,
		-1,
		-1,
		182,
		178,
		185,
		172,
		168,
		185,
		198,
		180,
		194,
		193,
		-1,
		188,
		206,
		211,
		179,
		177,
		161,
		159,
		177,
		179,
		185,
		185,
		-1,
		197,
		198,
		193,
		201,
		201,
		177,
		164,
		164,
		174,
		167,
		186,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		197,
		180,
		197,
		189,
		179,
		194,
		187,
		167,
		164,
		162,
		159,
		175,
		173,
		183,
		-1,
		-1,
		288,
		257,
		288,
		246,
		227,
		-1,
		193,
		173,
		179,
		183,
		177,
		170,
		184,
		180,
		-1,
		153,
		152,
		180,
		166,
		177,
		248,
		-1,
		-1,
		246,
		238,
		223,
		226,
		203,
		199,
		188,
		187,
		179,
		165,
		161,
		167,
		170,
		170,
		176,
		147,
		157,
		161,
		159,
		184,
		-1,
		-1,
		219,
		-1,
		-1,
		245,
		228,
		-1,
		211,
		218,
		209,
		215,
		201,
		222,
		198,
		189,
		181,
		175,
		163,
		165,
		162,
		175,
		163,
		144,
		169,
		173,
		154,
		175,
		170,
		-1,
		218,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		204,
		207,
		213,
		237,
		238,
		-1,
		210,
		198,
		199,
		184,
		181,
		168,
		156,
		169,
		154,
		161,
		160,
		148,
		146,
		176,
		151,
		173,
		170,
		189,
		194,
		188,
		197,
		-1,
		253,
		249,
		245,
		252,
		201,
		-1,
		-1,
		241,
		-1,
		246,
		247,
		222,
		195,
		198,
		185,
		176,
		163,
		152,
		163,
		152,
		149,
		157,
		140,
		155,
		146,
		145,
		163,
		173,
		181,
		185,
		191,
		-1,
		303,
		-1,
		245,
		229,
		231,
		203,
		224,
		-1,
		261,
		247,
		239,
		224,
		222,
		-1,
		194,
		191,
		181,
		159,
		144,
		161,
		153,
		151,
		153,
		135,
		149,
		140,
		158,
		165,
		163,
		167,
		187,
		199,
		263,
		253,
		-1,
		235,
		240,
		199,
		207,
		226,
		264,
		228,
		-1,
		223,
		-1,
		196,
		209,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		146,
		131,
		128,
		146,
		149,
		156,
		160,
		176,
		-1,
		-1,
		248,
		252,
		241,
		192,
		211,
		235,
		272,
		221,
		210,
		209,
		-1,
		200,
		179,
		176,
		164,
		151,
		136,
		137,
		145,
		157,
		136,
		130,
		127,
		147,
		173,
		151,
		162,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		218,
		189,
		213,
		255,
		239,
		232,
		220,
		185,
		185,
		179,
		-1,
		175,
		154,
		145,
		134,
		132,
		145,
		137,
		145,
		125,
		123,
		142,
		154,
		145,
		153,
		-1,
		-1,
		-1,
		248,
		237,
		238,
		184,
		207,
		244,
		218,
		204,
		209,
		184,
		177,
		171,
		188,
		171,
		152,
		141,
		133,
		122,
		133,
		141,
		139,
		121,
		130,
		136,
		160,
		141,
		147,
		-1,
		-1,
		255,
		245,
		229,
		231,
		228,
		198,
		205,
		237,
		209,
		222,
		-1,
		176,
		-1,
		165,
		161,
		146,
		141,
		138,
		125,
		124,
		138,
		138,
		128,
		123,
		130,
		165,
		165,
		131,
		151,
		154,
		-1,
		-1,
		-1,
		248,
		243,
		218,
		195,
		179,
		215,
		-1,
		192,
		193,
		-1,
		170,
		164,
		161,
		148,
		144,
		129,
		133,
		135,
		138,
		126,
		132,
		133,
		115,
		139,
		-1,
		139,
		133,
		141,
		131,
		119,
		-1,
		-1,
		-1,
		241,
		220,
		213,
		233,
		174,
		226,
		-1,
		-1,
		177,
		170,
		-1,
		157,
		139,
		141,
		136,
		132,
		134,
		131,
		120,
		133,
		126,
		120,
		114,
		127,
		131,
		132,
		121,
		117,
		114,
		128,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		194,
		-1,
		186,
		178,
		168,
		162,
		156,
		152,
		150,
		160,
		144,
		146,
		142,
		134,
		129,
		115,
		108,
		119,
		104,
		122,
		128,
		119,
		114,
		113,
		124,
		-1,
		261,
		247,
		218,
		-1,
		-1,
		207,
		-1,
		171,
		185,
		201,
		-1,
		194,
		173,
		188,
		166,
		162,
		153,
		151,
		152,
		122,
		127,
		129,
		117,
		120,
		109,
		112,
		104,
		126,
		123,
		107,
		109,
		118,
		-1,
		267,
		254,
		212,
		208,
		197,
		217,
		168,
		156,
		188,
		-1,
		-1,
		220,
		-1,
		164,
		176,
		167,
		165,
		141,
		116,
		123,
		141,
		114,
		109,
		114,
		103,
		103,
		98,
		117,
		103,
		101,
		116,
		132,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		183,
		170,
		164,
		-1,
		205,
		-1,
		198,
		186,
		173,
		155,
		195,
		-1,
		115,
		111,
		118,
		-1,
		134,
		-1,
		106,
		109,
		100,
		95,
		92,
		103,
		101,
		110,
		111,
		-1,
		217,
		202,
		195,
		185,
		199,
		170,
		-1,
		218,
		-1,
		-1,
		185,
		179,
		179,
		148,
		145,
		131,
		111,
		103,
		118,
		117,
		104,
		103,
		91,
		91,
		94,
		88,
		101,
		111,
		117,
		109,
		-1,
		-1,
		-1,
		222,
		208,
		208,
		172,
		184,
		-1,
		-1,
		246,
		202,
		188,
		-1,
		140,
		131,
		119,
		109,
		99,
		104,
		105,
		95,
		93,
		89,
		98,
		97,
		90,
		89,
		110,
		103,
		125,
		-1,
		-1,
		205,
		206,
		194,
		162,
		157,
		-1,
		-1,
		-1,
		192,
		193,
		159,
		138,
		120,
		-1,
		-1,
		103,
		96,
		90,
		93,
		81,
		101,
		108,
		96,
		83,
		98,
		108,
		116,
		115,
		-1,
		208,
		195,
		-1,
		-1,
		156,
		146,
		-1,
		-1,
		-1,
		-1,
		171,
		116,
		105,
		100,
		104,
		102,
		-1,
		76,
		87,
		80,
		99,
		106,
		98,
		83,
		77,
		88,
		103,
		120,
		-1,
		-1,
		170,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		93,
		86,
		90,
		-1,
		78,
		80,
		77,
		89,
		94,
		98,
		89,
		71,
		85,
		88,
		101,
		115,
		119,
		193,
		-1,
		123,
		-1,
		-1,
		-1,
		146,
		160,
		132,
		109,
		82,
		77,
		70,
		64,
		69,
		80,
		89,
		100,
		65,
		69,
		84,
		89,
		93,
		110,
		114,
		-1,
		-1,
		121,
		117,
		152,
		154,
		133,
		159,
		-1,
		-1,
		79,
		72,
		68,
		60,
		73,
		76,
		61,
		63,
		81,
		94,
		88,
		98,
		113,
		108,
		-1,
		-1,
		-1,
		133,
		-1,
		135,
		-1,
		-1,
		123,
		152,
		99,
		81,
		77,
		63,
		55,
		49,
		51,
		56,
		75,
		70,
		79,
		84,
		88,
		111,
		100,
		139,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		112,
		104,
		99,
		105,
		107,
		98,
		114,
		111,
		-1,
		60,
		78,
		46,
		60,
		56,
		63,
		68,
		74,
		78,
		85,
		101,
		100,
		95,
		131,
		122,
		128,
		-1,
		-1,
		203,
		192,
		181,
		187,
		-1,
		105,
		101,
		91,
		81,
		84,
		-1,
		-1,
		78,
		75,
		51,
		38,
		44,
		49,
		52,
		90,
		66,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		157,
		194,
		187,
		155,
		163,
		194,
		-1,
		95,
		87,
		98,
		73,
		75,
		-1,
		-1,
		51,
		42,
		42,
		30,
		33,
		61,
		72,
		77,
		88,
		93,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		150,
		170,
		149,
		152,
		176,
		190,
		-1,
		92,
		-1,
		-1,
		104,
		76,
		60,
		50,
		47,
		89,
		26,
		19,
		46,
		48,
		74,
		65,
		98,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		139,
		150,
		143,
		-1,
		-1,
		-1,
		-1,
		93,
		-1,
		-1,
		120,
		-1,
		87,
		-1,
		70,
		74,
		4,
		37,
		73,
		60,
		67,
		84,
		90,
		87,
		95,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		164,
		120,
		123,
		134,
		145,
		160,
		164,
		-1,
		104,
		143,
		158,
		-1,
		129,
		-1,
		-1,
		-1,
		84,
		8,
		0,
		55,
		70,
		72,
		68,
		72,
		85,
		92,
		102,
		111,
		103,
		107,
		120,
		131,
		134,
		160,
		151,
		164,
		109,
		109,
		130,
		139,
		160,
		119,
		110,
		137,
		163,
		154,
		149,
		136,
		-1,
		-1,
		107,
		18,
		-1,
		-1,
		71,
		89,
		72,
		74,
		78,
		92,
		104,
		117,
		110,
		108,
		102,
		134,
		-1,
		153,
		152,
		141,
		138,
		114,
		105,
		100,
		127,
		-1,
		-1,
		122,
		138,
		133,
		137,
		153,
		178,
		-1,
		139,
		-1,
		-1,
		128,
		-1,
		-1,
		131,
		94,
		83,
		74,
		80,
		86,
		97,
		119,
		116,
		117,
		107,
		117,
		130,
		137,
		134,
		122,
		120,
		143,
		108,
		96,
		-1,
		109,
		107,
		113,
		120,
		137,
		167,
		-1,
		-1,
		155,
		146,
		-1,
		-1,
		129,
		127,
		116,
		-1,
		106,
		79,
		84,
		109,
		116,
		118,
		119,
		113,
		120,
		119,
		127,
		135,
		146,
		160,
		149,
		145,
		144,
		152,
		101,
		94,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		165,
		-1,
		-1,
		124,
		117,
		105,
		93,
		83,
		93,
		101,
		101,
		104,
		109,
		111,
		122,
		114,
		118,
		135,
		-1,
		180,
		-1,
		132,
		108,
		122,
		137,
		145,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		158,
		142,
		123,
		-1,
		93,
		106,
		137,
		105,
		110,
		105,
		117,
		128,
		117,
		120,
		134,
		129,
		-1,
		-1,
		120,
		123,
		-1,
		-1,
		145,
		164,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		94,
		119,
		108,
		116,
		111,
		121,
		127,
		130,
		119,
		123,
		135,
		-1,
		-1,
		127,
		128,
		133,
		-1,
		154,
		-1,
		186,
		-1,
		153,
		159,
		147,
		-1,
		-1,
		-1,
		132,
		95,
		116,
		126,
		131,
		129,
		120,
		119,
		126,
		130,
		126,
		137,
		-1,
		-1,
		-1,
		184,
		160,
		193,
		184,
		167,
		147,
		139,
		158,
		-1,
		128,
		-1,
		99,
		96,
		131,
		125,
		142,
		136,
		122,
		137,
		133,
		124,
		133,
		190,
		-1,
		162,
		195,
		159,
		153,
		129,
		133,
		149,
		-1,
		125,
		107,
		-1,
		135,
		125,
		159,
		145,
		133,
		120,
		127,
		137,
		130,
		-1,
		-1,
		-1,
		164,
		163,
		155,
		149,
		149,
		134,
		125,
		-1,
		137,
		119,
		98,
		115,
		115,
		106,
		114,
		149,
		145,
		138,
		140,
		132,
		-1,
		252,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		158,
		153,
		126,
		114,
		120,
		116,
		102,
		108,
		110,
		118,
		116,
		113,
		125,
		121,
		141,
		133,
		169,
		-1,
		259,
		-1,
		194,
		-1,
		-1,
		176,
		156,
		148,
		137,
		126,
		124,
		115,
		106,
		128,
		144,
		128,
		126,
		131,
		136,
		-1,
		249,
		248,
		-1,
		195,
		187,
		173,
		-1,
		166,
		-1,
		172,
		133,
		-1,
		135,
		115,
		-1,
		137,
		133,
		-1,
		-1,
		236,
		211,
		-1,
		-1,
		-1,
		196,
		176,
		167,
		151,
		-1,
		126,
		126,
		-1,
		-1,
		-1,
		221,
		220,
		-1,
		189,
		192,
		-1,
		182,
		173,
		181,
		128,
		132,
		-1,
		-1,
		-1,
		230,
		211,
		205,
		204,
		202,
		197,
		194,
		180,
		164,
		142,
		131,
		152,
		-1,
		-1,
		-1,
		202,
		194,
		187,
		-1,
		-1,
		189,
		172,
		153,
		151,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		179,
		-1,
		-1,
		185,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		213,
		-1,
		-1,
		-1,
		175,
		171,
		172,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		259,
		223,
		-1,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		165,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		200,
		-1,
		200,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		213,
		-1,
		185,
		187,
		-1,
		235,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		190,
		197,
		219,
		222,
		258,
		-1,
		209
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		140,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		162,
		163,
		133,
		138,
		140,
		128,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		152,
		127,
		134,
		152,
		125,
		120,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		131,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		126,
		122,
		129,
		-1,
		145,
		-1,
		117,
		120,
		111,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		159,
		156,
		142,
		122,
		114,
		129,
		128,
		115,
		114,
		102,
		102,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		151,
		142,
		130,
		120,
		110,
		115,
		116,
		106,
		104,
		100,
		109,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		173,
		168,
		-1,
		-1,
		-1,
		198,
		204,
		170,
		149,
		131,
		-1,
		-1,
		114,
		107,
		101,
		104,
		92,
		112,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		167,
		157,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		113,
		-1,
		87,
		98,
		91,
		110,
		117,
		105,
		90,
		84,
		90,
		102,
		111,
		-1,
		-1,
		181,
		-1,
		143,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		89,
		91,
		88,
		100,
		105,
		105,
		96,
		82,
		83,
		87,
		91,
		105,
		109,
		204,
		-1,
		134,
		-1,
		-1,
		-1,
		157,
		171,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		91,
		100,
		111,
		76,
		80,
		80,
		79,
		83,
		100,
		104,
		-1,
		-1,
		132,
		128,
		163,
		165,
		144,
		170,
		-1,
		-1,
		90,
		83,
		79,
		71,
		84,
		87,
		72,
		74,
		89,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		144,
		-1,
		146,
		-1,
		-1,
		134,
		163,
		110,
		92,
		88,
		74,
		66,
		60,
		62,
		67,
		86,
		81,
		83,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		123,
		115,
		110,
		116,
		118,
		109,
		125,
		122,
		-1,
		71,
		89,
		57,
		71,
		67,
		74,
		79,
		82,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		214,
		203,
		192,
		198,
		-1,
		116,
		112,
		102,
		92,
		95,
		-1,
		-1,
		89,
		86,
		62,
		49,
		55,
		60,
		63,
		74,
		55,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		168,
		205,
		198,
		166,
		174,
		205,
		-1,
		106,
		98,
		109,
		84,
		86,
		-1,
		-1,
		62,
		53,
		53,
		41,
		44,
		72,
		83,
		59,
		72,
		82,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		161,
		181,
		160,
		163,
		187,
		201,
		-1,
		103,
		-1,
		-1,
		115,
		87,
		71,
		61,
		58,
		100,
		31,
		32,
		41,
		39,
		56,
		47,
		88,
		74,
		79,
		82,
		97,
		102,
		94,
		108,
		108,
		109,
		-1,
		150,
		161,
		154,
		-1,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		131,
		-1,
		98,
		-1,
		81,
		85,
		49,
		42,
		41,
		28,
		49,
		66,
		72,
		72,
		77,
		80,
		84,
		93,
		104,
		116,
		115,
		116,
		175,
		131,
		134,
		145,
		156,
		171,
		175,
		-1,
		115,
		154,
		169,
		-1,
		140,
		-1,
		-1,
		-1,
		95,
		62,
		54,
		0,
		15,
		24,
		50,
		54,
		67,
		74,
		84,
		98,
		93,
		97,
		110,
		121,
		124,
		171,
		162,
		175,
		120,
		120,
		141,
		150,
		171,
		130,
		121,
		148,
		174,
		165,
		160,
		147,
		-1,
		-1,
		118,
		72,
		-1,
		-1,
		16,
		71,
		54,
		56,
		60,
		74,
		86,
		99,
		100,
		98,
		92,
		124,
		-1,
		164,
		163,
		152,
		149,
		125,
		116,
		111,
		138,
		-1,
		-1,
		133,
		149,
		144,
		148,
		164,
		189,
		-1,
		150,
		-1,
		-1,
		128,
		-1,
		-1,
		113,
		76,
		65,
		56,
		62,
		68,
		79,
		101,
		104,
		107,
		97,
		107,
		120,
		148,
		145,
		133,
		131,
		154,
		119,
		107,
		-1,
		120,
		118,
		124,
		131,
		148,
		178,
		-1,
		-1,
		166,
		150,
		-1,
		-1,
		111,
		109,
		98,
		-1,
		88,
		61,
		66,
		91,
		98,
		100,
		107,
		101,
		108,
		109,
		117,
		125,
		157,
		171,
		160,
		156,
		155,
		163,
		112,
		105,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		106,
		99,
		87,
		75,
		65,
		75,
		83,
		83,
		86,
		91,
		99,
		110,
		104,
		108,
		125,
		-1,
		191,
		-1,
		143,
		119,
		133,
		148,
		156,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		140,
		124,
		105,
		-1,
		75,
		88,
		119,
		87,
		92,
		87,
		105,
		116,
		107,
		110,
		124,
		119,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		156,
		169,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		112,
		108,
		-1,
		-1,
		76,
		101,
		90,
		98,
		93,
		105,
		115,
		113,
		109,
		113,
		125,
		-1,
		-1,
		138,
		139,
		144,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		114,
		77,
		98,
		108,
		113,
		111,
		102,
		101,
		108,
		118,
		116,
		127,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		81,
		78,
		115,
		107,
		124,
		118,
		104,
		119,
		115,
		114,
		122,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		89,
		-1,
		119,
		109,
		141,
		127,
		115,
		102,
		109,
		123,
		119,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		99,
		90,
		98,
		131,
		127,
		120,
		122,
		114,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		102,
		100,
		97,
		109,
		105,
		125,
		115,
		151,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		128,
		112,
		110,
		115,
		120,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		121,
		117,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		225,
		214,
		225,
		233,
		206,
		213,
		-1,
		232,
		236,
		202,
		196,
		235,
		204,
		210,
		221,
		-1,
		-1,
		-1,
		225,
		224,
		192,
		190,
		199,
		204,
		211,
		-1,
		210,
		-1,
		246,
		225,
		236,
		241,
		185,
		182,
		202,
		221,
		203,
		195,
		261,
		215,
		186,
		180,
		198,
		188,
		197,
		189,
		-1,
		186,
		176,
		198,
		177,
		188,
		180,
		-1,
		-1,
		180,
		181,
		187,
		173,
		179,
		175,
		-1,
		185,
		169,
		-1,
		-1,
		170,
		171,
		155,
		158,
		166,
		164,
		177,
		169,
		164,
		-1,
		-1,
		161,
		157,
		164,
		151,
		147,
		164,
		177,
		159,
		173,
		172,
		-1,
		165,
		183,
		190,
		158,
		156,
		140,
		138,
		156,
		158,
		164,
		164,
		-1,
		174,
		175,
		170,
		178,
		180,
		156,
		143,
		143,
		153,
		146,
		165,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		174,
		157,
		174,
		166,
		156,
		171,
		164,
		146,
		143,
		141,
		138,
		154,
		152,
		162,
		-1,
		-1,
		267,
		236,
		265,
		223,
		204,
		-1,
		170,
		150,
		156,
		160,
		154,
		147,
		161,
		157,
		-1,
		132,
		131,
		159,
		145,
		156,
		227,
		-1,
		-1,
		225,
		217,
		200,
		203,
		180,
		176,
		165,
		164,
		156,
		142,
		138,
		144,
		147,
		147,
		153,
		126,
		136,
		140,
		138,
		163,
		-1,
		-1,
		198,
		-1,
		-1,
		224,
		207,
		-1,
		190,
		197,
		186,
		192,
		178,
		199,
		175,
		166,
		158,
		152,
		140,
		142,
		139,
		152,
		140,
		123,
		148,
		152,
		133,
		154,
		149,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		183,
		186,
		192,
		216,
		215,
		-1,
		187,
		175,
		176,
		161,
		158,
		145,
		133,
		146,
		131,
		138,
		137,
		127,
		125,
		155,
		130,
		152,
		149,
		168,
		173,
		167,
		176,
		-1,
		232,
		228,
		224,
		231,
		180,
		-1,
		-1,
		220,
		-1,
		223,
		224,
		199,
		172,
		175,
		162,
		153,
		140,
		129,
		140,
		129,
		126,
		134,
		119,
		134,
		125,
		124,
		142,
		152,
		160,
		164,
		170,
		-1,
		282,
		-1,
		224,
		208,
		210,
		182,
		203,
		-1,
		240,
		224,
		216,
		201,
		201,
		-1,
		171,
		168,
		158,
		136,
		121,
		138,
		130,
		128,
		132,
		114,
		128,
		119,
		137,
		144,
		142,
		146,
		166,
		178,
		242,
		232,
		-1,
		214,
		219,
		178,
		186,
		205,
		243,
		207,
		-1,
		202,
		-1,
		173,
		186,
		-1,
		142,
		138,
		120,
		121,
		116,
		131,
		125,
		110,
		107,
		125,
		128,
		135,
		139,
		155,
		-1,
		-1,
		227,
		231,
		220,
		171,
		190,
		214,
		251,
		200,
		189,
		188,
		-1,
		179,
		156,
		153,
		141,
		128,
		113,
		114,
		122,
		135,
		114,
		109,
		106,
		126,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		197,
		168,
		192,
		234,
		218,
		211,
		199,
		164,
		164,
		158,
		-1,
		152,
		131,
		122,
		111,
		109,
		122,
		119,
		124,
		104,
		102,
		121,
		133,
		124,
		141,
		-1,
		-1,
		-1,
		227,
		216,
		217,
		163,
		186,
		223,
		197,
		183,
		188,
		163,
		156,
		150,
		165,
		148,
		129,
		118,
		110,
		99,
		115,
		123,
		118,
		100,
		109,
		115,
		139,
		129,
		135,
		-1,
		-1,
		234,
		224,
		208,
		210,
		207,
		177,
		184,
		216,
		188,
		201,
		-1,
		155,
		-1,
		144,
		139,
		123,
		118,
		115,
		112,
		106,
		115,
		117,
		107,
		102,
		109,
		144,
		144,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		227,
		222,
		197,
		174,
		158,
		194,
		-1,
		171,
		172,
		-1,
		149,
		143,
		140,
		125,
		121,
		116,
		120,
		113,
		120,
		113,
		111,
		112,
		94,
		126,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		220,
		199,
		192,
		212,
		153,
		205,
		-1,
		-1,
		156,
		149,
		-1,
		136,
		118,
		125,
		123,
		117,
		121,
		118,
		107,
		120,
		113,
		99,
		101,
		114,
		118,
		122,
		109,
		105,
		102,
		116,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		173,
		-1,
		165,
		157,
		147,
		141,
		135,
		131,
		129,
		145,
		129,
		132,
		130,
		121,
		129,
		102,
		95,
		102,
		91,
		109,
		117,
		109,
		103,
		102,
		112,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		186,
		-1,
		150,
		164,
		180,
		-1,
		173,
		152,
		167,
		145,
		141,
		137,
		152,
		153,
		125,
		130,
		128,
		119,
		107,
		96,
		99,
		91,
		113,
		113,
		97,
		98,
		102,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		147,
		135,
		167,
		-1,
		-1,
		209,
		-1,
		143,
		160,
		151,
		149,
		142,
		119,
		126,
		139,
		116,
		111,
		101,
		90,
		90,
		85,
		107,
		93,
		91,
		100,
		116,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		184,
		-1,
		187,
		177,
		161,
		146,
		179,
		-1,
		118,
		114,
		121,
		-1,
		136,
		-1,
		109,
		106,
		97,
		82,
		79,
		90,
		88,
		99,
		95,
		-1,
		196,
		181,
		174,
		164,
		178,
		149,
		-1,
		204,
		-1,
		-1,
		174,
		168,
		168,
		151,
		148,
		134,
		114,
		106,
		121,
		120,
		107,
		106,
		94,
		88,
		85,
		78,
		91,
		101,
		106,
		93,
		-1,
		-1,
		-1,
		201,
		187,
		191,
		151,
		170,
		-1,
		-1,
		236,
		191,
		177,
		-1,
		143,
		134,
		122,
		112,
		102,
		107,
		108,
		98,
		96,
		92,
		95,
		89,
		80,
		79,
		95,
		87,
		109,
		-1,
		-1,
		184,
		189,
		177,
		163,
		174,
		-1,
		-1,
		-1,
		183,
		196,
		162,
		141,
		123,
		-1,
		-1,
		106,
		99,
		93,
		96,
		84,
		104,
		104,
		88,
		73,
		88,
		92,
		100,
		91,
		-1,
		187,
		174,
		-1,
		-1,
		173,
		163,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		90,
		83,
		102,
		109,
		90,
		75,
		69,
		75,
		87,
		96,
		-1,
		-1,
		187,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		83,
		80,
		92,
		93,
		90,
		81,
		72,
		68,
		72,
		76,
		90,
		94,
		210,
		-1,
		140,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		72,
		83,
		92,
		103,
		68,
		72,
		65,
		64,
		68,
		85,
		89,
		-1,
		-1,
		138,
		134,
		169,
		157,
		150,
		162,
		-1,
		-1,
		89,
		80,
		71,
		63,
		76,
		79,
		64,
		66,
		74,
		69,
		63,
		73,
		88,
		83,
		-1,
		-1,
		-1,
		150,
		-1,
		152,
		-1,
		-1,
		140,
		160,
		107,
		89,
		85,
		80,
		58,
		52,
		54,
		59,
		77,
		71,
		68,
		59,
		63,
		86,
		75,
		114,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		129,
		121,
		116,
		122,
		124,
		115,
		122,
		119,
		-1,
		77,
		81,
		49,
		63,
		58,
		65,
		70,
		67,
		53,
		60,
		76,
		75,
		70,
		106,
		97,
		103,
		-1,
		-1,
		215,
		204,
		193,
		199,
		-1,
		122,
		118,
		108,
		98,
		101,
		-1,
		-1,
		95,
		92,
		72,
		41,
		47,
		52,
		54,
		59,
		40,
		49,
		53,
		57,
		63,
		68,
		73,
		79,
		94,
		109,
		-1,
		169,
		206,
		199,
		167,
		175,
		206,
		-1,
		112,
		104,
		115,
		90,
		92,
		-1,
		-1,
		68,
		59,
		60,
		48,
		45,
		60,
		75,
		44,
		57,
		67,
		56,
		55,
		73,
		77,
		86,
		93,
		83,
		96,
		100,
		-1,
		162,
		182,
		161,
		164,
		188,
		202,
		-1,
		109,
		-1,
		-1,
		121,
		93,
		77,
		67,
		64,
		107,
		52,
		49,
		26,
		24,
		41,
		32,
		73,
		59,
		64,
		67,
		82,
		87,
		79,
		93,
		93,
		94,
		-1,
		151,
		162,
		155,
		-1,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		137,
		-1,
		104,
		-1,
		87,
		91,
		62,
		63,
		26,
		13,
		34,
		51,
		57,
		57,
		62,
		65,
		69,
		78,
		89,
		101,
		100,
		101,
		176,
		132,
		135,
		146,
		157,
		172,
		176,
		-1,
		121,
		160,
		172,
		-1,
		146,
		-1,
		-1,
		-1,
		101,
		75,
		67,
		21,
		0,
		9,
		35,
		39,
		52,
		59,
		69,
		83,
		78,
		82,
		95,
		106,
		109,
		172,
		163,
		176,
		121,
		121,
		142,
		151,
		172,
		136,
		127,
		154,
		175,
		168,
		163,
		150,
		-1,
		-1,
		124,
		85,
		-1,
		-1,
		7,
		56,
		39,
		41,
		45,
		59,
		71,
		84,
		85,
		83,
		77,
		109,
		-1,
		165,
		164,
		153,
		150,
		126,
		117,
		112,
		139,
		-1,
		-1,
		134,
		155,
		145,
		149,
		165,
		190,
		-1,
		139,
		-1,
		-1,
		113,
		-1,
		-1,
		98,
		61,
		50,
		41,
		47,
		53,
		64,
		86,
		89,
		92,
		82,
		92,
		105,
		149,
		146,
		134,
		132,
		155,
		120,
		108,
		-1,
		121,
		119,
		125,
		132,
		149,
		179,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		96,
		94,
		83,
		-1,
		73,
		46,
		51,
		76,
		83,
		85,
		92,
		86,
		93,
		94,
		102,
		110,
		158,
		172,
		161,
		157,
		156,
		164,
		113,
		106,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		91,
		84,
		72,
		60,
		50,
		60,
		68,
		68,
		71,
		76,
		84,
		95,
		89,
		93,
		110,
		-1,
		192,
		-1,
		144,
		120,
		134,
		149,
		157,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		125,
		109,
		90,
		-1,
		60,
		73,
		104,
		72,
		77,
		72,
		90,
		101,
		92,
		95,
		109,
		104,
		-1,
		-1,
		132,
		135,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		97,
		93,
		-1,
		-1,
		61,
		86,
		75,
		83,
		78,
		90,
		100,
		98,
		94,
		98,
		110,
		-1,
		-1,
		139,
		140,
		145,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		99,
		62,
		83,
		93,
		98,
		96,
		87,
		86,
		93,
		103,
		101,
		112,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		97,
		-1,
		66,
		63,
		100,
		92,
		109,
		103,
		89,
		104,
		100,
		99,
		107,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		94,
		74,
		-1,
		104,
		94,
		126,
		112,
		100,
		87,
		94,
		108,
		104,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		84,
		84,
		75,
		83,
		116,
		112,
		105,
		107,
		99,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		79,
		87,
		85,
		82,
		94,
		90,
		110,
		100,
		136,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		113,
		97,
		95,
		100,
		105,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		106,
		102,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		222,
		211,
		222,
		230,
		203,
		210,
		-1,
		229,
		233,
		199,
		193,
		232,
		201,
		207,
		218,
		-1,
		-1,
		-1,
		222,
		221,
		189,
		187,
		196,
		201,
		208,
		-1,
		207,
		-1,
		243,
		222,
		233,
		238,
		182,
		179,
		199,
		218,
		200,
		192,
		258,
		212,
		183,
		177,
		195,
		185,
		194,
		186,
		-1,
		183,
		173,
		195,
		174,
		185,
		177,
		-1,
		-1,
		177,
		178,
		184,
		170,
		176,
		172,
		-1,
		182,
		166,
		-1,
		-1,
		167,
		168,
		152,
		155,
		163,
		161,
		174,
		166,
		161,
		-1,
		-1,
		158,
		154,
		161,
		148,
		144,
		161,
		174,
		156,
		170,
		169,
		-1,
		162,
		180,
		187,
		155,
		153,
		137,
		135,
		153,
		155,
		161,
		161,
		-1,
		171,
		172,
		167,
		175,
		177,
		153,
		140,
		140,
		150,
		143,
		162,
		150,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		154,
		171,
		163,
		153,
		168,
		161,
		143,
		140,
		138,
		135,
		151,
		149,
		159,
		-1,
		-1,
		264,
		233,
		262,
		220,
		201,
		-1,
		167,
		147,
		153,
		157,
		151,
		144,
		158,
		154,
		-1,
		129,
		128,
		156,
		142,
		153,
		224,
		-1,
		-1,
		222,
		214,
		197,
		200,
		177,
		173,
		162,
		161,
		153,
		139,
		135,
		141,
		144,
		144,
		150,
		123,
		133,
		137,
		135,
		160,
		-1,
		-1,
		195,
		-1,
		-1,
		221,
		204,
		-1,
		187,
		194,
		183,
		189,
		175,
		196,
		172,
		163,
		155,
		149,
		137,
		139,
		136,
		149,
		137,
		120,
		145,
		149,
		130,
		151,
		146,
		-1,
		194,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		180,
		183,
		189,
		213,
		212,
		-1,
		184,
		172,
		173,
		158,
		155,
		142,
		130,
		143,
		128,
		135,
		134,
		124,
		122,
		152,
		127,
		149,
		146,
		165,
		170,
		164,
		173,
		-1,
		229,
		225,
		221,
		228,
		177,
		-1,
		-1,
		217,
		-1,
		220,
		221,
		196,
		169,
		172,
		159,
		150,
		137,
		126,
		137,
		126,
		123,
		131,
		116,
		131,
		122,
		121,
		139,
		149,
		157,
		161,
		167,
		-1,
		279,
		-1,
		221,
		205,
		207,
		179,
		200,
		-1,
		237,
		221,
		213,
		198,
		198,
		-1,
		168,
		165,
		155,
		133,
		118,
		135,
		127,
		125,
		129,
		111,
		125,
		116,
		134,
		141,
		139,
		143,
		163,
		175,
		239,
		229,
		-1,
		211,
		216,
		175,
		183,
		202,
		240,
		204,
		-1,
		199,
		-1,
		170,
		183,
		-1,
		139,
		135,
		117,
		118,
		113,
		128,
		122,
		107,
		104,
		122,
		125,
		132,
		136,
		152,
		-1,
		-1,
		224,
		228,
		217,
		168,
		187,
		211,
		248,
		197,
		186,
		185,
		-1,
		176,
		153,
		150,
		138,
		125,
		110,
		111,
		119,
		132,
		111,
		106,
		103,
		123,
		149,
		127,
		139,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		194,
		165,
		189,
		231,
		215,
		208,
		196,
		161,
		161,
		155,
		-1,
		149,
		128,
		119,
		108,
		106,
		119,
		116,
		121,
		101,
		99,
		118,
		130,
		121,
		138,
		-1,
		-1,
		-1,
		224,
		213,
		214,
		160,
		183,
		220,
		194,
		180,
		185,
		160,
		153,
		147,
		162,
		145,
		126,
		115,
		107,
		96,
		112,
		120,
		115,
		97,
		106,
		112,
		136,
		126,
		132,
		-1,
		-1,
		231,
		221,
		205,
		207,
		204,
		174,
		181,
		213,
		185,
		198,
		-1,
		152,
		-1,
		141,
		136,
		120,
		115,
		112,
		109,
		103,
		112,
		114,
		104,
		99,
		106,
		141,
		141,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		224,
		219,
		194,
		171,
		155,
		191,
		-1,
		168,
		169,
		-1,
		146,
		140,
		137,
		122,
		118,
		113,
		117,
		110,
		117,
		110,
		108,
		109,
		91,
		123,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		217,
		196,
		189,
		209,
		150,
		202,
		-1,
		-1,
		153,
		146,
		-1,
		133,
		115,
		122,
		120,
		114,
		118,
		115,
		104,
		117,
		110,
		96,
		98,
		111,
		115,
		119,
		106,
		102,
		99,
		113,
		-1,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		170,
		-1,
		162,
		154,
		144,
		138,
		132,
		128,
		126,
		142,
		126,
		129,
		127,
		118,
		126,
		99,
		92,
		99,
		88,
		106,
		114,
		106,
		100,
		99,
		109,
		-1,
		237,
		223,
		194,
		-1,
		-1,
		183,
		-1,
		147,
		161,
		177,
		-1,
		170,
		149,
		164,
		142,
		138,
		134,
		149,
		150,
		122,
		127,
		125,
		116,
		104,
		93,
		96,
		88,
		110,
		110,
		94,
		95,
		99,
		-1,
		243,
		230,
		188,
		184,
		173,
		193,
		144,
		132,
		164,
		-1,
		-1,
		206,
		-1,
		140,
		157,
		148,
		146,
		139,
		116,
		123,
		136,
		113,
		108,
		98,
		87,
		87,
		82,
		104,
		90,
		88,
		97,
		113,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		159,
		146,
		140,
		-1,
		181,
		-1,
		184,
		174,
		158,
		143,
		176,
		-1,
		115,
		111,
		118,
		-1,
		133,
		-1,
		106,
		103,
		94,
		79,
		76,
		87,
		85,
		96,
		92,
		-1,
		193,
		178,
		171,
		161,
		175,
		146,
		-1,
		201,
		-1,
		-1,
		171,
		165,
		165,
		148,
		145,
		131,
		111,
		103,
		118,
		117,
		104,
		103,
		91,
		85,
		82,
		75,
		88,
		98,
		103,
		90,
		-1,
		-1,
		-1,
		198,
		184,
		188,
		148,
		167,
		-1,
		-1,
		233,
		188,
		174,
		-1,
		140,
		131,
		119,
		109,
		99,
		104,
		105,
		95,
		93,
		89,
		92,
		86,
		77,
		76,
		92,
		84,
		106,
		-1,
		-1,
		181,
		186,
		174,
		160,
		171,
		-1,
		-1,
		-1,
		180,
		193,
		159,
		138,
		120,
		-1,
		-1,
		103,
		96,
		90,
		93,
		81,
		101,
		101,
		85,
		70,
		85,
		89,
		97,
		88,
		-1,
		184,
		171,
		-1,
		-1,
		170,
		160,
		-1,
		-1,
		-1,
		-1,
		171,
		116,
		105,
		100,
		104,
		102,
		-1,
		76,
		87,
		80,
		99,
		106,
		87,
		72,
		66,
		72,
		84,
		93,
		-1,
		-1,
		184,
		-1,
		146,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		93,
		86,
		90,
		-1,
		78,
		80,
		77,
		89,
		90,
		87,
		78,
		69,
		65,
		69,
		73,
		87,
		91,
		207,
		-1,
		137,
		-1,
		-1,
		-1,
		146,
		161,
		132,
		109,
		82,
		77,
		70,
		64,
		69,
		80,
		89,
		100,
		65,
		69,
		62,
		61,
		65,
		82,
		86,
		-1,
		-1,
		135,
		131,
		166,
		154,
		147,
		159,
		-1,
		-1,
		86,
		77,
		68,
		60,
		73,
		76,
		61,
		63,
		71,
		66,
		60,
		70,
		85,
		80,
		-1,
		-1,
		-1,
		147,
		-1,
		149,
		-1,
		-1,
		137,
		157,
		104,
		86,
		82,
		77,
		55,
		49,
		51,
		56,
		74,
		68,
		65,
		56,
		60,
		83,
		72,
		111,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		126,
		118,
		113,
		119,
		121,
		112,
		119,
		116,
		-1,
		74,
		78,
		46,
		60,
		55,
		62,
		67,
		64,
		50,
		57,
		73,
		72,
		67,
		103,
		94,
		100,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		119,
		115,
		105,
		95,
		98,
		-1,
		-1,
		92,
		89,
		69,
		38,
		44,
		49,
		51,
		56,
		37,
		46,
		50,
		54,
		60,
		65,
		70,
		76,
		91,
		106,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		109,
		101,
		112,
		87,
		89,
		-1,
		-1,
		65,
		56,
		57,
		45,
		42,
		57,
		72,
		41,
		54,
		64,
		53,
		52,
		70,
		74,
		83,
		90,
		80,
		93,
		97,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		106,
		-1,
		-1,
		118,
		90,
		74,
		64,
		61,
		104,
		51,
		46,
		23,
		21,
		38,
		29,
		70,
		56,
		61,
		64,
		79,
		84,
		76,
		90,
		90,
		91,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		134,
		-1,
		101,
		-1,
		84,
		88,
		59,
		62,
		23,
		10,
		31,
		48,
		54,
		54,
		59,
		62,
		66,
		75,
		86,
		98,
		97,
		98,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		118,
		157,
		169,
		-1,
		143,
		-1,
		-1,
		-1,
		98,
		72,
		64,
		27,
		6,
		0,
		32,
		36,
		49,
		56,
		66,
		80,
		75,
		79,
		92,
		103,
		106,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		133,
		124,
		151,
		172,
		165,
		160,
		147,
		-1,
		-1,
		121,
		82,
		-1,
		-1,
		13,
		53,
		36,
		38,
		42,
		56,
		68,
		81,
		82,
		80,
		74,
		106,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		152,
		142,
		146,
		162,
		187,
		-1,
		136,
		-1,
		-1,
		110,
		-1,
		-1,
		95,
		58,
		47,
		38,
		44,
		50,
		61,
		83,
		86,
		89,
		79,
		89,
		102,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		118,
		116,
		122,
		129,
		146,
		176,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		93,
		91,
		80,
		-1,
		70,
		43,
		48,
		73,
		80,
		82,
		89,
		83,
		90,
		91,
		99,
		107,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		88,
		81,
		69,
		57,
		47,
		57,
		65,
		65,
		68,
		73,
		81,
		92,
		86,
		90,
		107,
		-1,
		189,
		-1,
		141,
		117,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		122,
		106,
		87,
		-1,
		57,
		70,
		101,
		69,
		74,
		69,
		87,
		98,
		89,
		92,
		106,
		101,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		149,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		94,
		90,
		-1,
		-1,
		58,
		83,
		72,
		80,
		75,
		87,
		97,
		95,
		91,
		95,
		107,
		-1,
		-1,
		136,
		137,
		142,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		96,
		59,
		80,
		90,
		95,
		93,
		84,
		83,
		90,
		100,
		98,
		109,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		94,
		-1,
		63,
		60,
		97,
		89,
		106,
		100,
		86,
		101,
		97,
		96,
		104,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		91,
		71,
		-1,
		101,
		91,
		123,
		109,
		97,
		84,
		91,
		105,
		101,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		81,
		81,
		72,
		80,
		113,
		109,
		102,
		104,
		96,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		76,
		84,
		82,
		79,
		91,
		87,
		107,
		97,
		133,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		110,
		94,
		92,
		97,
		102,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		103,
		99,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		200,
		189,
		200,
		208,
		181,
		188,
		-1,
		207,
		211,
		177,
		171,
		210,
		179,
		185,
		196,
		-1,
		-1,
		-1,
		200,
		199,
		167,
		165,
		174,
		179,
		186,
		-1,
		185,
		-1,
		221,
		200,
		211,
		216,
		160,
		157,
		177,
		196,
		178,
		170,
		236,
		190,
		161,
		155,
		173,
		163,
		172,
		164,
		-1,
		161,
		151,
		173,
		152,
		163,
		155,
		-1,
		-1,
		155,
		156,
		162,
		148,
		154,
		150,
		-1,
		160,
		144,
		-1,
		-1,
		145,
		146,
		130,
		133,
		141,
		139,
		152,
		144,
		139,
		-1,
		-1,
		136,
		132,
		139,
		126,
		122,
		139,
		152,
		134,
		148,
		147,
		-1,
		140,
		158,
		165,
		133,
		131,
		115,
		113,
		131,
		133,
		139,
		139,
		-1,
		149,
		150,
		145,
		153,
		155,
		131,
		118,
		118,
		128,
		121,
		140,
		128,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		149,
		132,
		149,
		141,
		131,
		146,
		139,
		121,
		118,
		116,
		113,
		129,
		127,
		137,
		-1,
		-1,
		242,
		211,
		240,
		198,
		179,
		-1,
		145,
		125,
		131,
		135,
		129,
		122,
		136,
		132,
		-1,
		107,
		106,
		134,
		120,
		131,
		202,
		-1,
		-1,
		200,
		192,
		175,
		178,
		155,
		151,
		140,
		139,
		131,
		117,
		113,
		119,
		122,
		122,
		128,
		101,
		111,
		115,
		113,
		138,
		-1,
		-1,
		173,
		-1,
		-1,
		199,
		182,
		-1,
		165,
		172,
		161,
		167,
		153,
		174,
		150,
		141,
		133,
		127,
		115,
		117,
		114,
		127,
		115,
		98,
		123,
		127,
		108,
		129,
		124,
		-1,
		172,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		158,
		161,
		167,
		191,
		190,
		-1,
		162,
		150,
		151,
		136,
		133,
		120,
		108,
		121,
		106,
		113,
		112,
		102,
		100,
		130,
		105,
		127,
		124,
		143,
		148,
		142,
		151,
		-1,
		207,
		203,
		199,
		206,
		155,
		-1,
		-1,
		195,
		-1,
		198,
		199,
		174,
		147,
		150,
		137,
		128,
		115,
		104,
		115,
		104,
		101,
		109,
		94,
		109,
		100,
		99,
		117,
		127,
		135,
		139,
		145,
		-1,
		257,
		-1,
		199,
		183,
		185,
		157,
		178,
		-1,
		215,
		199,
		191,
		176,
		176,
		-1,
		146,
		143,
		133,
		111,
		96,
		113,
		105,
		103,
		107,
		89,
		103,
		94,
		112,
		119,
		117,
		121,
		141,
		153,
		217,
		207,
		-1,
		189,
		194,
		153,
		161,
		180,
		218,
		182,
		-1,
		177,
		-1,
		148,
		161,
		-1,
		117,
		113,
		95,
		96,
		91,
		106,
		100,
		85,
		82,
		100,
		103,
		110,
		114,
		130,
		-1,
		-1,
		202,
		206,
		195,
		146,
		165,
		189,
		226,
		175,
		164,
		163,
		-1,
		154,
		131,
		128,
		116,
		103,
		88,
		89,
		97,
		110,
		89,
		84,
		81,
		101,
		127,
		105,
		117,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		172,
		143,
		167,
		209,
		193,
		186,
		174,
		139,
		139,
		133,
		-1,
		127,
		106,
		97,
		86,
		84,
		97,
		94,
		99,
		79,
		77,
		96,
		108,
		99,
		116,
		-1,
		-1,
		-1,
		202,
		191,
		192,
		138,
		161,
		198,
		172,
		158,
		163,
		138,
		131,
		125,
		140,
		123,
		104,
		93,
		85,
		74,
		90,
		98,
		93,
		75,
		84,
		90,
		114,
		104,
		110,
		-1,
		-1,
		209,
		199,
		183,
		185,
		182,
		152,
		159,
		191,
		163,
		176,
		-1,
		130,
		-1,
		119,
		114,
		98,
		93,
		90,
		87,
		81,
		90,
		92,
		82,
		77,
		84,
		119,
		119,
		94,
		114,
		117,
		-1,
		-1,
		-1,
		202,
		197,
		172,
		149,
		133,
		169,
		-1,
		146,
		147,
		-1,
		124,
		118,
		115,
		100,
		96,
		91,
		95,
		88,
		95,
		88,
		86,
		87,
		69,
		101,
		-1,
		102,
		96,
		104,
		94,
		82,
		-1,
		-1,
		-1,
		195,
		174,
		167,
		187,
		128,
		180,
		-1,
		-1,
		131,
		124,
		-1,
		111,
		93,
		100,
		98,
		92,
		96,
		93,
		82,
		95,
		88,
		74,
		76,
		89,
		93,
		97,
		84,
		80,
		77,
		91,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		148,
		-1,
		140,
		132,
		122,
		116,
		110,
		106,
		104,
		120,
		104,
		107,
		105,
		96,
		104,
		77,
		70,
		77,
		66,
		84,
		92,
		84,
		78,
		77,
		87,
		-1,
		215,
		201,
		172,
		-1,
		-1,
		161,
		-1,
		125,
		139,
		155,
		-1,
		148,
		127,
		142,
		120,
		116,
		112,
		127,
		128,
		106,
		105,
		103,
		94,
		82,
		71,
		74,
		66,
		88,
		88,
		72,
		73,
		77,
		-1,
		221,
		208,
		166,
		162,
		151,
		171,
		122,
		110,
		142,
		-1,
		-1,
		184,
		-1,
		118,
		135,
		126,
		124,
		117,
		102,
		109,
		114,
		91,
		86,
		76,
		65,
		65,
		60,
		82,
		68,
		66,
		75,
		91,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		137,
		124,
		118,
		-1,
		159,
		-1,
		162,
		152,
		136,
		121,
		154,
		-1,
		101,
		97,
		104,
		-1,
		111,
		-1,
		84,
		81,
		72,
		57,
		54,
		65,
		63,
		74,
		70,
		-1,
		171,
		156,
		149,
		139,
		153,
		124,
		-1,
		179,
		-1,
		-1,
		149,
		143,
		143,
		127,
		130,
		117,
		97,
		89,
		104,
		103,
		90,
		89,
		70,
		63,
		60,
		53,
		66,
		76,
		81,
		68,
		-1,
		-1,
		-1,
		176,
		162,
		166,
		126,
		145,
		-1,
		-1,
		211,
		166,
		152,
		-1,
		126,
		117,
		105,
		95,
		85,
		90,
		91,
		81,
		79,
		68,
		70,
		64,
		55,
		54,
		70,
		62,
		84,
		-1,
		-1,
		159,
		164,
		152,
		138,
		157,
		-1,
		-1,
		-1,
		158,
		174,
		145,
		124,
		106,
		-1,
		-1,
		89,
		82,
		76,
		79,
		67,
		84,
		79,
		63,
		48,
		63,
		67,
		75,
		66,
		-1,
		162,
		149,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		-1,
		-1,
		157,
		102,
		91,
		86,
		90,
		88,
		-1,
		62,
		73,
		66,
		85,
		92,
		65,
		50,
		44,
		50,
		62,
		71,
		-1,
		-1,
		174,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		114,
		108,
		79,
		72,
		76,
		-1,
		64,
		66,
		63,
		75,
		68,
		65,
		56,
		47,
		43,
		47,
		51,
		65,
		69,
		197,
		-1,
		135,
		-1,
		-1,
		-1,
		132,
		147,
		118,
		95,
		68,
		63,
		56,
		50,
		55,
		66,
		75,
		86,
		51,
		50,
		40,
		39,
		43,
		60,
		64,
		-1,
		-1,
		133,
		129,
		158,
		140,
		144,
		145,
		-1,
		-1,
		72,
		63,
		54,
		46,
		59,
		62,
		47,
		49,
		49,
		44,
		38,
		48,
		63,
		58,
		-1,
		-1,
		-1,
		145,
		-1,
		147,
		-1,
		-1,
		135,
		143,
		90,
		72,
		68,
		66,
		53,
		47,
		37,
		42,
		52,
		46,
		43,
		34,
		38,
		61,
		50,
		89,
		-1,
		-1,
		217,
		-1,
		-1,
		-1,
		124,
		116,
		111,
		117,
		119,
		110,
		105,
		102,
		-1,
		72,
		76,
		43,
		50,
		33,
		40,
		45,
		42,
		28,
		35,
		51,
		50,
		45,
		81,
		72,
		78,
		-1,
		-1,
		210,
		199,
		188,
		194,
		-1,
		117,
		113,
		103,
		93,
		96,
		-1,
		-1,
		90,
		87,
		67,
		36,
		41,
		34,
		29,
		34,
		15,
		24,
		28,
		32,
		38,
		43,
		48,
		54,
		69,
		84,
		-1,
		164,
		201,
		194,
		162,
		170,
		201,
		-1,
		107,
		99,
		110,
		85,
		87,
		-1,
		-1,
		63,
		54,
		55,
		43,
		40,
		53,
		52,
		19,
		24,
		42,
		29,
		30,
		48,
		52,
		61,
		68,
		58,
		71,
		75,
		-1,
		157,
		177,
		156,
		159,
		183,
		197,
		-1,
		104,
		-1,
		-1,
		116,
		88,
		72,
		62,
		59,
		102,
		49,
		44,
		21,
		19,
		16,
		7,
		45,
		24,
		36,
		39,
		55,
		60,
		52,
		68,
		68,
		69,
		-1,
		146,
		157,
		150,
		-1,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		131,
		-1,
		99,
		-1,
		82,
		86,
		57,
		60,
		35,
		22,
		8,
		16,
		22,
		22,
		27,
		30,
		42,
		51,
		62,
		74,
		75,
		76,
		171,
		127,
		130,
		141,
		152,
		167,
		171,
		-1,
		116,
		155,
		137,
		-1,
		121,
		-1,
		-1,
		-1,
		96,
		70,
		62,
		55,
		34,
		34,
		0,
		4,
		17,
		24,
		34,
		48,
		51,
		55,
		68,
		79,
		84,
		167,
		158,
		171,
		116,
		116,
		137,
		146,
		167,
		131,
		122,
		149,
		144,
		133,
		128,
		115,
		-1,
		-1,
		98,
		80,
		-1,
		-1,
		41,
		21,
		4,
		6,
		10,
		24,
		36,
		49,
		58,
		56,
		50,
		82,
		-1,
		160,
		159,
		148,
		145,
		121,
		112,
		107,
		134,
		-1,
		-1,
		129,
		150,
		140,
		144,
		160,
		185,
		-1,
		104,
		-1,
		-1,
		78,
		-1,
		-1,
		63,
		26,
		15,
		6,
		12,
		18,
		29,
		51,
		54,
		65,
		55,
		65,
		78,
		144,
		141,
		129,
		127,
		150,
		115,
		103,
		-1,
		116,
		114,
		120,
		127,
		144,
		174,
		-1,
		-1,
		120,
		100,
		-1,
		-1,
		61,
		59,
		48,
		-1,
		38,
		11,
		16,
		41,
		48,
		50,
		57,
		51,
		58,
		67,
		75,
		83,
		153,
		167,
		156,
		152,
		151,
		159,
		108,
		101,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		-1,
		110,
		106,
		-1,
		-1,
		56,
		49,
		37,
		25,
		15,
		25,
		33,
		33,
		36,
		41,
		49,
		60,
		62,
		66,
		83,
		-1,
		187,
		-1,
		139,
		115,
		129,
		144,
		152,
		-1,
		-1,
		-1,
		127,
		113,
		106,
		94,
		92,
		-1,
		90,
		74,
		55,
		-1,
		25,
		38,
		69,
		37,
		42,
		37,
		55,
		66,
		65,
		68,
		82,
		77,
		-1,
		-1,
		127,
		130,
		-1,
		-1,
		117,
		119,
		-1,
		118,
		107,
		92,
		84,
		-1,
		-1,
		62,
		58,
		-1,
		-1,
		26,
		51,
		40,
		48,
		43,
		55,
		65,
		63,
		67,
		71,
		82,
		-1,
		-1,
		134,
		130,
		124,
		-1,
		102,
		-1,
		120,
		-1,
		87,
		93,
		81,
		-1,
		-1,
		-1,
		64,
		27,
		48,
		58,
		63,
		61,
		52,
		51,
		58,
		68,
		74,
		82,
		-1,
		-1,
		-1,
		120,
		94,
		127,
		118,
		101,
		81,
		73,
		92,
		-1,
		62,
		-1,
		31,
		28,
		65,
		57,
		74,
		68,
		54,
		69,
		65,
		72,
		72,
		126,
		-1,
		96,
		129,
		93,
		87,
		63,
		67,
		83,
		-1,
		59,
		39,
		-1,
		69,
		59,
		91,
		77,
		65,
		52,
		59,
		73,
		69,
		-1,
		-1,
		-1,
		98,
		97,
		89,
		83,
		83,
		68,
		59,
		-1,
		71,
		53,
		32,
		49,
		49,
		40,
		48,
		81,
		77,
		70,
		72,
		64,
		-1,
		199,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		92,
		87,
		60,
		48,
		54,
		50,
		36,
		42,
		44,
		52,
		50,
		47,
		59,
		55,
		75,
		65,
		101,
		-1,
		194,
		-1,
		128,
		-1,
		-1,
		110,
		90,
		82,
		71,
		60,
		58,
		49,
		40,
		62,
		78,
		62,
		60,
		65,
		70,
		-1,
		183,
		182,
		-1,
		129,
		121,
		107,
		-1,
		100,
		-1,
		106,
		67,
		-1,
		69,
		49,
		-1,
		71,
		67,
		-1,
		-1,
		170,
		145,
		-1,
		-1,
		-1,
		130,
		110,
		101,
		85,
		-1,
		60,
		60,
		-1,
		-1,
		-1,
		155,
		154,
		-1,
		123,
		126,
		-1,
		116,
		107,
		115,
		62,
		66,
		-1,
		-1,
		-1,
		164,
		145,
		139,
		138,
		136,
		131,
		128,
		114,
		98,
		76,
		65,
		86,
		-1,
		-1,
		-1,
		136,
		128,
		121,
		-1,
		-1,
		123,
		106,
		87,
		85,
		-1,
		-1,
		-1,
		158,
		139,
		-1,
		-1,
		113,
		-1,
		-1,
		119,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		147,
		-1,
		-1,
		-1,
		109,
		105,
		106,
		-1,
		-1,
		-1,
		-1,
		169,
		170,
		193,
		157,
		-1,
		-1,
		-1,
		101,
		95,
		-1,
		-1,
		172,
		170,
		-1,
		-1,
		-1,
		129,
		113,
		-1,
		99,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		134,
		-1,
		134,
		109,
		116,
		-1,
		-1,
		-1,
		-1,
		147,
		139,
		147,
		-1,
		119,
		121,
		-1,
		169,
		-1,
		-1,
		162,
		153,
		-1,
		-1,
		124,
		131,
		153,
		156,
		192,
		-1,
		143
	],
	[
		-1,
		204,
		193,
		204,
		212,
		185,
		192,
		-1,
		211,
		215,
		181,
		175,
		214,
		183,
		189,
		200,
		-1,
		-1,
		-1,
		204,
		203,
		171,
		169,
		178,
		183,
		190,
		-1,
		189,
		-1,
		225,
		204,
		215,
		220,
		164,
		161,
		181,
		200,
		182,
		174,
		240,
		194,
		165,
		159,
		177,
		167,
		176,
		168,
		-1,
		165,
		155,
		177,
		156,
		167,
		159,
		-1,
		-1,
		159,
		160,
		166,
		152,
		158,
		154,
		-1,
		164,
		148,
		-1,
		-1,
		149,
		150,
		134,
		137,
		145,
		143,
		156,
		148,
		143,
		-1,
		-1,
		140,
		136,
		143,
		130,
		126,
		143,
		156,
		138,
		152,
		151,
		-1,
		144,
		162,
		169,
		137,
		135,
		119,
		117,
		135,
		137,
		143,
		143,
		-1,
		153,
		154,
		149,
		157,
		159,
		135,
		122,
		122,
		132,
		125,
		144,
		132,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		153,
		136,
		153,
		145,
		135,
		150,
		143,
		125,
		122,
		120,
		117,
		133,
		131,
		141,
		-1,
		-1,
		246,
		215,
		244,
		202,
		183,
		-1,
		149,
		129,
		135,
		139,
		133,
		126,
		140,
		136,
		-1,
		111,
		110,
		138,
		124,
		135,
		206,
		-1,
		-1,
		204,
		196,
		179,
		182,
		159,
		155,
		144,
		143,
		135,
		121,
		117,
		123,
		126,
		126,
		132,
		105,
		115,
		119,
		117,
		142,
		-1,
		-1,
		177,
		-1,
		-1,
		203,
		186,
		-1,
		169,
		176,
		165,
		171,
		157,
		178,
		154,
		145,
		137,
		131,
		119,
		121,
		118,
		131,
		119,
		102,
		127,
		131,
		112,
		133,
		128,
		-1,
		176,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		162,
		165,
		171,
		195,
		194,
		-1,
		166,
		154,
		155,
		140,
		137,
		124,
		112,
		125,
		110,
		117,
		116,
		106,
		104,
		134,
		109,
		131,
		128,
		147,
		152,
		146,
		155,
		-1,
		211,
		207,
		203,
		210,
		159,
		-1,
		-1,
		199,
		-1,
		202,
		203,
		178,
		151,
		154,
		141,
		132,
		119,
		108,
		119,
		108,
		105,
		113,
		98,
		113,
		104,
		103,
		121,
		131,
		139,
		143,
		149,
		-1,
		261,
		-1,
		203,
		187,
		189,
		161,
		182,
		-1,
		219,
		203,
		195,
		180,
		180,
		-1,
		150,
		147,
		137,
		115,
		100,
		117,
		109,
		107,
		111,
		93,
		107,
		98,
		116,
		123,
		121,
		125,
		145,
		157,
		221,
		211,
		-1,
		193,
		198,
		157,
		165,
		184,
		222,
		186,
		-1,
		181,
		-1,
		152,
		165,
		-1,
		121,
		117,
		99,
		100,
		95,
		110,
		104,
		89,
		86,
		104,
		107,
		114,
		118,
		134,
		-1,
		-1,
		206,
		210,
		199,
		150,
		169,
		193,
		230,
		179,
		168,
		167,
		-1,
		158,
		135,
		132,
		120,
		107,
		92,
		93,
		101,
		114,
		93,
		88,
		85,
		105,
		131,
		109,
		121,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		176,
		147,
		171,
		213,
		197,
		190,
		178,
		143,
		143,
		137,
		-1,
		131,
		110,
		101,
		90,
		88,
		101,
		98,
		103,
		83,
		81,
		100,
		112,
		103,
		120,
		-1,
		-1,
		-1,
		206,
		195,
		196,
		142,
		165,
		202,
		176,
		162,
		167,
		142,
		135,
		129,
		144,
		127,
		108,
		97,
		89,
		78,
		94,
		102,
		97,
		79,
		88,
		94,
		118,
		108,
		114,
		-1,
		-1,
		213,
		203,
		187,
		189,
		186,
		156,
		163,
		195,
		167,
		180,
		-1,
		134,
		-1,
		123,
		118,
		102,
		97,
		94,
		91,
		85,
		94,
		96,
		86,
		81,
		88,
		123,
		123,
		98,
		118,
		121,
		-1,
		-1,
		-1,
		206,
		201,
		176,
		153,
		137,
		173,
		-1,
		150,
		151,
		-1,
		128,
		122,
		119,
		104,
		100,
		95,
		99,
		92,
		99,
		92,
		90,
		91,
		73,
		105,
		-1,
		106,
		100,
		108,
		98,
		86,
		-1,
		-1,
		-1,
		199,
		178,
		171,
		191,
		132,
		184,
		-1,
		-1,
		135,
		128,
		-1,
		115,
		97,
		104,
		102,
		96,
		100,
		97,
		86,
		99,
		92,
		78,
		80,
		93,
		97,
		101,
		88,
		84,
		81,
		95,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		152,
		-1,
		144,
		136,
		126,
		120,
		114,
		110,
		108,
		124,
		108,
		111,
		109,
		100,
		108,
		81,
		74,
		81,
		70,
		88,
		96,
		88,
		82,
		81,
		91,
		-1,
		219,
		205,
		176,
		-1,
		-1,
		165,
		-1,
		129,
		143,
		159,
		-1,
		152,
		131,
		146,
		124,
		120,
		116,
		131,
		132,
		110,
		109,
		107,
		98,
		86,
		75,
		78,
		70,
		92,
		92,
		76,
		77,
		81,
		-1,
		225,
		212,
		170,
		166,
		155,
		175,
		126,
		114,
		146,
		-1,
		-1,
		188,
		-1,
		122,
		139,
		130,
		128,
		121,
		106,
		113,
		118,
		95,
		90,
		80,
		69,
		69,
		64,
		86,
		72,
		70,
		79,
		95,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		141,
		128,
		122,
		-1,
		163,
		-1,
		166,
		156,
		140,
		125,
		158,
		-1,
		105,
		101,
		108,
		-1,
		115,
		-1,
		88,
		85,
		76,
		61,
		58,
		69,
		67,
		78,
		74,
		-1,
		175,
		160,
		153,
		143,
		157,
		128,
		-1,
		183,
		-1,
		-1,
		153,
		147,
		147,
		131,
		134,
		121,
		101,
		93,
		108,
		107,
		94,
		93,
		74,
		67,
		64,
		57,
		70,
		80,
		85,
		72,
		-1,
		-1,
		-1,
		180,
		166,
		170,
		130,
		149,
		-1,
		-1,
		215,
		170,
		156,
		-1,
		130,
		121,
		109,
		99,
		89,
		94,
		95,
		85,
		83,
		72,
		74,
		68,
		59,
		58,
		74,
		66,
		88,
		-1,
		-1,
		163,
		168,
		156,
		142,
		161,
		-1,
		-1,
		-1,
		162,
		178,
		149,
		128,
		110,
		-1,
		-1,
		93,
		86,
		80,
		83,
		71,
		88,
		83,
		67,
		52,
		67,
		71,
		79,
		70,
		-1,
		166,
		153,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		-1,
		-1,
		161,
		106,
		95,
		90,
		94,
		92,
		-1,
		66,
		77,
		70,
		89,
		96,
		69,
		54,
		48,
		54,
		66,
		75,
		-1,
		-1,
		178,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		118,
		112,
		83,
		76,
		80,
		-1,
		68,
		70,
		67,
		79,
		72,
		69,
		60,
		51,
		47,
		51,
		55,
		69,
		73,
		201,
		-1,
		139,
		-1,
		-1,
		-1,
		136,
		151,
		122,
		99,
		72,
		67,
		60,
		54,
		59,
		70,
		79,
		90,
		55,
		54,
		44,
		43,
		47,
		64,
		68,
		-1,
		-1,
		137,
		133,
		162,
		144,
		148,
		149,
		-1,
		-1,
		76,
		67,
		58,
		50,
		63,
		66,
		51,
		53,
		53,
		48,
		42,
		52,
		67,
		62,
		-1,
		-1,
		-1,
		149,
		-1,
		151,
		-1,
		-1,
		139,
		147,
		94,
		76,
		72,
		70,
		57,
		51,
		41,
		46,
		56,
		50,
		47,
		38,
		42,
		65,
		54,
		93,
		-1,
		-1,
		221,
		-1,
		-1,
		-1,
		128,
		120,
		115,
		121,
		123,
		114,
		109,
		106,
		-1,
		76,
		80,
		47,
		54,
		37,
		44,
		49,
		46,
		32,
		39,
		55,
		54,
		49,
		85,
		76,
		82,
		-1,
		-1,
		214,
		203,
		192,
		198,
		-1,
		121,
		117,
		107,
		97,
		100,
		-1,
		-1,
		94,
		91,
		71,
		40,
		45,
		38,
		33,
		38,
		19,
		28,
		32,
		36,
		42,
		47,
		52,
		58,
		73,
		88,
		-1,
		168,
		205,
		198,
		166,
		174,
		205,
		-1,
		111,
		103,
		114,
		89,
		91,
		-1,
		-1,
		67,
		58,
		59,
		47,
		44,
		57,
		56,
		23,
		20,
		42,
		25,
		34,
		52,
		56,
		63,
		64,
		62,
		75,
		79,
		-1,
		161,
		181,
		160,
		163,
		187,
		201,
		-1,
		108,
		-1,
		-1,
		120,
		92,
		76,
		66,
		63,
		106,
		53,
		48,
		25,
		23,
		20,
		11,
		41,
		20,
		32,
		35,
		51,
		56,
		48,
		72,
		72,
		73,
		-1,
		150,
		161,
		154,
		-1,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		135,
		-1,
		103,
		-1,
		86,
		90,
		61,
		64,
		39,
		26,
		12,
		12,
		18,
		18,
		23,
		26,
		38,
		47,
		58,
		70,
		79,
		80,
		175,
		131,
		134,
		145,
		156,
		171,
		175,
		-1,
		120,
		159,
		141,
		-1,
		125,
		-1,
		-1,
		-1,
		100,
		74,
		66,
		59,
		38,
		38,
		4,
		0,
		13,
		20,
		30,
		44,
		47,
		51,
		64,
		75,
		88,
		171,
		162,
		175,
		120,
		120,
		141,
		150,
		171,
		135,
		126,
		153,
		148,
		137,
		132,
		119,
		-1,
		-1,
		102,
		84,
		-1,
		-1,
		45,
		25,
		8,
		2,
		6,
		20,
		32,
		45,
		54,
		52,
		46,
		78,
		-1,
		164,
		163,
		152,
		149,
		125,
		116,
		111,
		138,
		-1,
		-1,
		133,
		154,
		144,
		148,
		164,
		189,
		-1,
		108,
		-1,
		-1,
		82,
		-1,
		-1,
		67,
		30,
		19,
		10,
		8,
		14,
		25,
		47,
		50,
		61,
		51,
		61,
		74,
		148,
		145,
		133,
		131,
		154,
		119,
		107,
		-1,
		120,
		118,
		124,
		131,
		148,
		178,
		-1,
		-1,
		124,
		104,
		-1,
		-1,
		65,
		63,
		52,
		-1,
		42,
		15,
		12,
		37,
		44,
		46,
		53,
		47,
		54,
		63,
		71,
		79,
		157,
		171,
		160,
		156,
		155,
		163,
		112,
		105,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		114,
		110,
		-1,
		-1,
		60,
		53,
		41,
		29,
		19,
		26,
		29,
		29,
		32,
		37,
		45,
		56,
		58,
		62,
		79,
		-1,
		191,
		-1,
		143,
		119,
		133,
		148,
		156,
		-1,
		-1,
		-1,
		131,
		117,
		110,
		98,
		96,
		-1,
		94,
		78,
		59,
		-1,
		29,
		42,
		65,
		33,
		38,
		33,
		51,
		62,
		61,
		64,
		78,
		73,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		121,
		123,
		-1,
		122,
		111,
		96,
		88,
		-1,
		-1,
		66,
		62,
		-1,
		-1,
		30,
		47,
		36,
		44,
		39,
		51,
		61,
		59,
		63,
		67,
		78,
		-1,
		-1,
		138,
		134,
		128,
		-1,
		106,
		-1,
		124,
		-1,
		91,
		97,
		85,
		-1,
		-1,
		-1,
		68,
		31,
		52,
		54,
		59,
		57,
		48,
		47,
		54,
		64,
		70,
		78,
		-1,
		-1,
		-1,
		124,
		98,
		131,
		122,
		105,
		85,
		77,
		96,
		-1,
		66,
		-1,
		35,
		32,
		68,
		53,
		70,
		64,
		50,
		65,
		61,
		68,
		68,
		130,
		-1,
		100,
		133,
		97,
		91,
		67,
		71,
		87,
		-1,
		63,
		43,
		-1,
		73,
		63,
		87,
		73,
		61,
		48,
		55,
		69,
		65,
		-1,
		-1,
		-1,
		102,
		101,
		93,
		87,
		87,
		72,
		63,
		-1,
		75,
		57,
		36,
		53,
		53,
		44,
		52,
		77,
		73,
		66,
		68,
		60,
		-1,
		203,
		-1,
		-1,
		125,
		-1,
		-1,
		-1,
		96,
		91,
		64,
		52,
		58,
		54,
		40,
		46,
		48,
		56,
		54,
		51,
		63,
		59,
		79,
		61,
		97,
		-1,
		198,
		-1,
		132,
		-1,
		-1,
		114,
		94,
		86,
		75,
		64,
		62,
		53,
		44,
		66,
		82,
		66,
		64,
		68,
		69,
		-1,
		187,
		186,
		-1,
		133,
		125,
		111,
		-1,
		104,
		-1,
		110,
		71,
		-1,
		73,
		53,
		-1,
		75,
		71,
		-1,
		-1,
		174,
		149,
		-1,
		-1,
		-1,
		134,
		114,
		105,
		89,
		-1,
		64,
		64,
		-1,
		-1,
		-1,
		159,
		158,
		-1,
		127,
		130,
		-1,
		120,
		111,
		119,
		66,
		70,
		-1,
		-1,
		-1,
		168,
		149,
		143,
		142,
		140,
		135,
		132,
		118,
		102,
		80,
		69,
		90,
		-1,
		-1,
		-1,
		140,
		132,
		125,
		-1,
		-1,
		127,
		110,
		91,
		89,
		-1,
		-1,
		-1,
		162,
		143,
		-1,
		-1,
		117,
		-1,
		-1,
		123,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		151,
		-1,
		-1,
		-1,
		113,
		109,
		110,
		-1,
		-1,
		-1,
		-1,
		173,
		174,
		197,
		161,
		-1,
		-1,
		-1,
		105,
		99,
		-1,
		-1,
		176,
		174,
		-1,
		-1,
		-1,
		133,
		117,
		-1,
		103,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		138,
		-1,
		138,
		113,
		120,
		-1,
		-1,
		-1,
		-1,
		151,
		143,
		151,
		-1,
		123,
		125,
		-1,
		173,
		-1,
		-1,
		166,
		157,
		-1,
		-1,
		128,
		135,
		157,
		160,
		196,
		-1,
		147
	],
	[
		-1,
		195,
		184,
		195,
		203,
		176,
		183,
		-1,
		202,
		206,
		172,
		166,
		205,
		174,
		180,
		191,
		-1,
		-1,
		-1,
		195,
		194,
		162,
		160,
		169,
		174,
		181,
		-1,
		180,
		-1,
		216,
		195,
		206,
		211,
		155,
		152,
		172,
		191,
		173,
		165,
		231,
		185,
		156,
		150,
		168,
		158,
		167,
		159,
		-1,
		156,
		146,
		168,
		147,
		158,
		150,
		-1,
		-1,
		150,
		151,
		157,
		143,
		149,
		145,
		-1,
		155,
		139,
		-1,
		-1,
		140,
		141,
		125,
		128,
		136,
		134,
		147,
		139,
		134,
		-1,
		-1,
		131,
		127,
		134,
		121,
		117,
		134,
		147,
		129,
		143,
		142,
		-1,
		135,
		153,
		160,
		128,
		126,
		110,
		108,
		126,
		128,
		134,
		134,
		-1,
		144,
		145,
		140,
		148,
		150,
		126,
		113,
		113,
		123,
		116,
		135,
		123,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		144,
		127,
		144,
		136,
		126,
		141,
		134,
		116,
		113,
		111,
		108,
		124,
		122,
		132,
		-1,
		-1,
		237,
		206,
		235,
		193,
		174,
		-1,
		140,
		120,
		126,
		130,
		124,
		117,
		131,
		127,
		-1,
		102,
		101,
		129,
		115,
		126,
		197,
		-1,
		-1,
		195,
		187,
		170,
		173,
		150,
		146,
		135,
		134,
		126,
		112,
		108,
		114,
		117,
		117,
		123,
		96,
		106,
		110,
		108,
		133,
		-1,
		-1,
		168,
		-1,
		-1,
		194,
		177,
		-1,
		160,
		167,
		156,
		162,
		148,
		169,
		145,
		136,
		128,
		122,
		110,
		112,
		109,
		122,
		110,
		93,
		118,
		122,
		103,
		124,
		119,
		-1,
		167,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		153,
		156,
		162,
		186,
		185,
		-1,
		157,
		145,
		146,
		131,
		128,
		115,
		103,
		116,
		101,
		108,
		107,
		97,
		95,
		125,
		100,
		122,
		119,
		138,
		143,
		137,
		146,
		-1,
		202,
		198,
		194,
		201,
		150,
		-1,
		-1,
		190,
		-1,
		193,
		194,
		169,
		142,
		145,
		132,
		123,
		110,
		99,
		110,
		99,
		96,
		104,
		89,
		104,
		95,
		94,
		112,
		122,
		130,
		134,
		140,
		-1,
		252,
		-1,
		194,
		178,
		180,
		152,
		173,
		-1,
		210,
		194,
		186,
		171,
		171,
		-1,
		141,
		138,
		128,
		106,
		91,
		108,
		100,
		98,
		102,
		84,
		98,
		89,
		107,
		114,
		112,
		116,
		136,
		148,
		212,
		202,
		-1,
		184,
		189,
		148,
		156,
		175,
		213,
		177,
		-1,
		172,
		-1,
		143,
		156,
		-1,
		112,
		108,
		90,
		91,
		86,
		101,
		95,
		80,
		77,
		95,
		98,
		105,
		109,
		125,
		-1,
		-1,
		197,
		201,
		190,
		141,
		160,
		184,
		221,
		170,
		159,
		158,
		-1,
		149,
		126,
		123,
		111,
		98,
		83,
		84,
		92,
		105,
		84,
		79,
		76,
		96,
		122,
		100,
		112,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		167,
		138,
		162,
		204,
		188,
		181,
		169,
		134,
		134,
		128,
		-1,
		122,
		101,
		92,
		81,
		79,
		92,
		89,
		94,
		74,
		72,
		91,
		103,
		94,
		111,
		-1,
		-1,
		-1,
		197,
		186,
		187,
		133,
		156,
		193,
		167,
		153,
		158,
		133,
		126,
		120,
		135,
		118,
		99,
		88,
		80,
		69,
		85,
		93,
		88,
		70,
		79,
		85,
		109,
		99,
		105,
		-1,
		-1,
		204,
		194,
		178,
		180,
		177,
		147,
		154,
		186,
		158,
		171,
		-1,
		125,
		-1,
		114,
		109,
		93,
		88,
		85,
		82,
		76,
		85,
		87,
		77,
		72,
		79,
		114,
		114,
		89,
		109,
		112,
		-1,
		-1,
		-1,
		197,
		192,
		167,
		144,
		128,
		164,
		-1,
		141,
		142,
		-1,
		119,
		113,
		110,
		95,
		91,
		86,
		90,
		83,
		90,
		83,
		81,
		82,
		64,
		96,
		-1,
		97,
		91,
		99,
		89,
		77,
		-1,
		-1,
		-1,
		190,
		169,
		162,
		182,
		123,
		175,
		-1,
		-1,
		126,
		119,
		-1,
		106,
		88,
		95,
		93,
		87,
		91,
		88,
		77,
		90,
		83,
		69,
		71,
		84,
		88,
		92,
		79,
		75,
		72,
		86,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		143,
		-1,
		135,
		127,
		117,
		111,
		105,
		101,
		99,
		115,
		99,
		102,
		100,
		91,
		99,
		72,
		65,
		72,
		61,
		79,
		87,
		79,
		73,
		72,
		82,
		-1,
		210,
		196,
		167,
		-1,
		-1,
		156,
		-1,
		120,
		134,
		150,
		-1,
		143,
		122,
		137,
		115,
		111,
		107,
		122,
		123,
		101,
		100,
		98,
		89,
		77,
		66,
		69,
		61,
		83,
		83,
		67,
		68,
		72,
		-1,
		216,
		203,
		161,
		157,
		146,
		166,
		117,
		105,
		137,
		-1,
		-1,
		179,
		-1,
		113,
		130,
		121,
		119,
		112,
		103,
		109,
		109,
		86,
		81,
		71,
		60,
		60,
		55,
		77,
		63,
		61,
		70,
		86,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		132,
		119,
		113,
		-1,
		154,
		-1,
		157,
		147,
		131,
		116,
		149,
		-1,
		114,
		104,
		109,
		-1,
		106,
		-1,
		79,
		76,
		67,
		52,
		49,
		60,
		58,
		69,
		65,
		-1,
		166,
		151,
		144,
		134,
		148,
		119,
		-1,
		174,
		-1,
		-1,
		144,
		138,
		138,
		122,
		125,
		130,
		110,
		102,
		109,
		101,
		93,
		87,
		65,
		58,
		55,
		48,
		61,
		71,
		76,
		63,
		-1,
		-1,
		-1,
		171,
		157,
		161,
		121,
		140,
		-1,
		-1,
		206,
		161,
		147,
		-1,
		131,
		130,
		118,
		108,
		98,
		103,
		104,
		84,
		77,
		63,
		65,
		59,
		50,
		49,
		65,
		57,
		79,
		-1,
		-1,
		154,
		159,
		147,
		133,
		152,
		-1,
		-1,
		-1,
		153,
		169,
		158,
		132,
		119,
		-1,
		-1,
		102,
		95,
		89,
		80,
		67,
		79,
		74,
		58,
		43,
		58,
		62,
		70,
		61,
		-1,
		157,
		144,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		-1,
		-1,
		170,
		115,
		104,
		99,
		103,
		101,
		-1,
		75,
		86,
		71,
		83,
		90,
		60,
		45,
		39,
		45,
		57,
		66,
		-1,
		-1,
		169,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		127,
		121,
		92,
		85,
		89,
		-1,
		77,
		79,
		73,
		88,
		63,
		60,
		51,
		42,
		38,
		42,
		46,
		60,
		64,
		192,
		-1,
		153,
		-1,
		-1,
		-1,
		145,
		160,
		131,
		108,
		81,
		76,
		69,
		63,
		68,
		79,
		71,
		82,
		49,
		45,
		35,
		34,
		38,
		55,
		59,
		-1,
		-1,
		151,
		147,
		171,
		153,
		157,
		158,
		-1,
		-1,
		85,
		76,
		67,
		59,
		72,
		75,
		55,
		52,
		46,
		39,
		33,
		43,
		58,
		53,
		-1,
		-1,
		-1,
		163,
		-1,
		165,
		-1,
		-1,
		153,
		156,
		103,
		85,
		81,
		79,
		68,
		62,
		50,
		55,
		56,
		47,
		41,
		29,
		33,
		56,
		45,
		82,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		142,
		134,
		129,
		135,
		137,
		128,
		118,
		115,
		-1,
		85,
		91,
		56,
		63,
		46,
		53,
		51,
		43,
		23,
		30,
		46,
		45,
		40,
		74,
		65,
		69,
		-1,
		-1,
		228,
		217,
		206,
		212,
		-1,
		135,
		131,
		121,
		111,
		114,
		-1,
		-1,
		108,
		105,
		85,
		54,
		54,
		47,
		42,
		52,
		32,
		19,
		23,
		27,
		33,
		38,
		43,
		49,
		60,
		75,
		-1,
		182,
		219,
		212,
		180,
		188,
		219,
		-1,
		125,
		117,
		128,
		103,
		105,
		-1,
		-1,
		81,
		72,
		73,
		61,
		58,
		62,
		57,
		37,
		28,
		34,
		12,
		22,
		43,
		46,
		50,
		51,
		53,
		66,
		70,
		-1,
		175,
		195,
		174,
		177,
		201,
		215,
		-1,
		122,
		-1,
		-1,
		134,
		106,
		90,
		80,
		77,
		120,
		67,
		62,
		39,
		37,
		34,
		25,
		30,
		7,
		19,
		22,
		38,
		43,
		35,
		61,
		63,
		64,
		-1,
		164,
		175,
		168,
		-1,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		149,
		-1,
		117,
		-1,
		100,
		104,
		75,
		78,
		53,
		40,
		26,
		26,
		20,
		5,
		10,
		13,
		25,
		34,
		45,
		57,
		67,
		69,
		189,
		145,
		148,
		159,
		170,
		185,
		189,
		-1,
		134,
		173,
		155,
		-1,
		139,
		-1,
		-1,
		-1,
		114,
		88,
		80,
		73,
		52,
		52,
		18,
		14,
		0,
		7,
		17,
		31,
		34,
		38,
		51,
		62,
		77,
		185,
		176,
		189,
		134,
		134,
		155,
		164,
		185,
		149,
		140,
		167,
		162,
		151,
		146,
		133,
		-1,
		-1,
		116,
		98,
		-1,
		-1,
		59,
		39,
		22,
		11,
		7,
		10,
		25,
		32,
		41,
		39,
		33,
		65,
		-1,
		178,
		177,
		166,
		163,
		139,
		130,
		125,
		152,
		-1,
		-1,
		147,
		168,
		158,
		162,
		178,
		203,
		-1,
		122,
		-1,
		-1,
		96,
		-1,
		-1,
		81,
		44,
		33,
		24,
		22,
		15,
		26,
		36,
		47,
		48,
		38,
		48,
		61,
		162,
		159,
		147,
		145,
		168,
		133,
		121,
		-1,
		134,
		132,
		138,
		145,
		162,
		192,
		-1,
		-1,
		138,
		118,
		-1,
		-1,
		79,
		77,
		66,
		-1,
		56,
		29,
		26,
		42,
		58,
		56,
		50,
		44,
		51,
		50,
		58,
		66,
		171,
		185,
		174,
		170,
		169,
		177,
		126,
		119,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		128,
		124,
		-1,
		-1,
		74,
		67,
		55,
		43,
		33,
		40,
		35,
		43,
		46,
		47,
		42,
		53,
		45,
		49,
		66,
		-1,
		205,
		-1,
		157,
		133,
		147,
		162,
		170,
		-1,
		-1,
		-1,
		145,
		131,
		124,
		112,
		110,
		-1,
		108,
		92,
		73,
		-1,
		43,
		56,
		79,
		47,
		52,
		47,
		48,
		59,
		48,
		51,
		65,
		60,
		-1,
		-1,
		145,
		148,
		-1,
		-1,
		135,
		137,
		-1,
		136,
		125,
		110,
		102,
		-1,
		-1,
		80,
		76,
		-1,
		-1,
		44,
		61,
		50,
		58,
		53,
		52,
		58,
		61,
		50,
		54,
		66,
		-1,
		-1,
		152,
		148,
		142,
		-1,
		120,
		-1,
		138,
		-1,
		105,
		111,
		99,
		-1,
		-1,
		-1,
		82,
		45,
		66,
		68,
		73,
		71,
		62,
		56,
		63,
		61,
		57,
		68,
		-1,
		-1,
		-1,
		138,
		112,
		145,
		136,
		119,
		99,
		91,
		110,
		-1,
		80,
		-1,
		49,
		46,
		82,
		67,
		84,
		78,
		59,
		74,
		64,
		55,
		64,
		144,
		-1,
		114,
		147,
		111,
		105,
		81,
		85,
		101,
		-1,
		77,
		57,
		-1,
		87,
		77,
		101,
		87,
		74,
		61,
		68,
		68,
		61,
		-1,
		-1,
		-1,
		116,
		115,
		107,
		101,
		101,
		86,
		77,
		-1,
		89,
		71,
		50,
		67,
		67,
		58,
		66,
		91,
		87,
		80,
		81,
		73,
		-1,
		217,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		110,
		105,
		78,
		66,
		72,
		68,
		54,
		60,
		62,
		70,
		68,
		65,
		77,
		73,
		93,
		74,
		109,
		-1,
		212,
		-1,
		146,
		-1,
		-1,
		128,
		108,
		100,
		89,
		78,
		76,
		67,
		58,
		80,
		96,
		80,
		78,
		81,
		82,
		-1,
		201,
		200,
		-1,
		147,
		139,
		125,
		-1,
		118,
		-1,
		124,
		85,
		-1,
		87,
		67,
		-1,
		89,
		85,
		-1,
		-1,
		188,
		163,
		-1,
		-1,
		-1,
		148,
		128,
		119,
		103,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		173,
		172,
		-1,
		141,
		144,
		-1,
		134,
		125,
		133,
		80,
		84,
		-1,
		-1,
		-1,
		182,
		163,
		157,
		156,
		154,
		149,
		146,
		132,
		116,
		94,
		83,
		104,
		-1,
		-1,
		-1,
		154,
		146,
		139,
		-1,
		-1,
		141,
		124,
		105,
		103,
		-1,
		-1,
		-1,
		176,
		157,
		-1,
		-1,
		131,
		-1,
		-1,
		137,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		165,
		-1,
		-1,
		-1,
		127,
		123,
		124,
		-1,
		-1,
		-1,
		-1,
		187,
		188,
		211,
		175,
		-1,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		190,
		188,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		117,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		152,
		-1,
		152,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		165,
		-1,
		137,
		139,
		-1,
		187,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		142,
		149,
		171,
		174,
		210,
		-1,
		161
	],
	[
		-1,
		202,
		191,
		202,
		210,
		183,
		190,
		-1,
		209,
		213,
		179,
		173,
		212,
		181,
		187,
		198,
		-1,
		-1,
		-1,
		202,
		201,
		169,
		167,
		176,
		181,
		188,
		-1,
		187,
		-1,
		223,
		202,
		213,
		218,
		162,
		159,
		179,
		198,
		180,
		172,
		238,
		192,
		163,
		157,
		175,
		165,
		174,
		166,
		-1,
		163,
		153,
		175,
		154,
		165,
		157,
		-1,
		-1,
		157,
		158,
		164,
		150,
		156,
		152,
		-1,
		162,
		146,
		-1,
		-1,
		147,
		148,
		132,
		135,
		143,
		141,
		154,
		146,
		141,
		-1,
		-1,
		138,
		134,
		141,
		128,
		124,
		141,
		154,
		136,
		150,
		149,
		-1,
		142,
		160,
		167,
		135,
		133,
		117,
		115,
		133,
		135,
		141,
		141,
		-1,
		151,
		152,
		147,
		155,
		157,
		133,
		120,
		120,
		130,
		123,
		142,
		130,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		123,
		120,
		118,
		115,
		131,
		129,
		139,
		-1,
		-1,
		244,
		213,
		242,
		200,
		181,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		109,
		108,
		136,
		122,
		133,
		204,
		-1,
		-1,
		202,
		194,
		177,
		180,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		103,
		113,
		117,
		115,
		140,
		-1,
		-1,
		175,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		163,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		100,
		125,
		129,
		110,
		131,
		126,
		-1,
		174,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		192,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		104,
		102,
		132,
		107,
		129,
		126,
		145,
		150,
		144,
		153,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		200,
		201,
		176,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		96,
		111,
		102,
		101,
		119,
		129,
		137,
		141,
		147,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		201,
		193,
		178,
		178,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		109,
		91,
		105,
		96,
		114,
		121,
		119,
		123,
		143,
		155,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		220,
		184,
		-1,
		179,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		102,
		87,
		84,
		102,
		105,
		112,
		116,
		132,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		177,
		166,
		165,
		-1,
		156,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		112,
		91,
		86,
		83,
		103,
		129,
		107,
		119,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		195,
		188,
		176,
		141,
		141,
		135,
		-1,
		129,
		108,
		99,
		88,
		86,
		99,
		96,
		101,
		81,
		79,
		98,
		110,
		101,
		118,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		140,
		163,
		200,
		174,
		160,
		165,
		140,
		133,
		127,
		142,
		125,
		106,
		95,
		87,
		76,
		92,
		100,
		95,
		77,
		86,
		92,
		116,
		106,
		112,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		154,
		161,
		193,
		165,
		178,
		-1,
		132,
		-1,
		121,
		116,
		100,
		95,
		92,
		89,
		83,
		92,
		94,
		84,
		79,
		86,
		121,
		121,
		96,
		116,
		119,
		-1,
		-1,
		-1,
		204,
		199,
		174,
		151,
		135,
		171,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		102,
		98,
		93,
		97,
		90,
		97,
		90,
		88,
		89,
		71,
		103,
		-1,
		104,
		98,
		106,
		96,
		84,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		130,
		182,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		102,
		100,
		94,
		98,
		95,
		84,
		97,
		90,
		76,
		78,
		91,
		95,
		99,
		86,
		82,
		79,
		93,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		150,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		122,
		106,
		109,
		107,
		98,
		106,
		79,
		72,
		79,
		68,
		86,
		94,
		86,
		80,
		79,
		89,
		-1,
		217,
		203,
		174,
		-1,
		-1,
		163,
		-1,
		127,
		141,
		157,
		-1,
		150,
		129,
		144,
		122,
		118,
		114,
		129,
		130,
		108,
		107,
		105,
		96,
		84,
		73,
		76,
		68,
		90,
		90,
		74,
		75,
		79,
		-1,
		223,
		210,
		168,
		164,
		153,
		173,
		124,
		112,
		144,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		128,
		126,
		119,
		110,
		116,
		116,
		93,
		88,
		78,
		67,
		67,
		62,
		84,
		70,
		68,
		77,
		93,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		139,
		126,
		120,
		-1,
		161,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		121,
		111,
		116,
		-1,
		113,
		-1,
		86,
		83,
		74,
		59,
		56,
		67,
		65,
		76,
		72,
		-1,
		173,
		158,
		151,
		141,
		155,
		126,
		-1,
		181,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		137,
		117,
		109,
		116,
		108,
		100,
		94,
		72,
		65,
		62,
		55,
		68,
		78,
		83,
		70,
		-1,
		-1,
		-1,
		178,
		164,
		168,
		128,
		147,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		138,
		137,
		125,
		115,
		105,
		110,
		111,
		91,
		84,
		70,
		72,
		66,
		57,
		56,
		72,
		64,
		86,
		-1,
		-1,
		161,
		166,
		154,
		140,
		159,
		-1,
		-1,
		-1,
		160,
		176,
		165,
		139,
		126,
		-1,
		-1,
		109,
		102,
		96,
		87,
		74,
		86,
		81,
		65,
		50,
		65,
		69,
		77,
		68,
		-1,
		164,
		151,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		-1,
		-1,
		177,
		122,
		111,
		106,
		110,
		108,
		-1,
		82,
		93,
		78,
		90,
		97,
		67,
		52,
		46,
		52,
		64,
		73,
		-1,
		-1,
		176,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		134,
		128,
		99,
		92,
		96,
		-1,
		84,
		86,
		80,
		95,
		70,
		67,
		58,
		49,
		45,
		49,
		53,
		67,
		71,
		199,
		-1,
		160,
		-1,
		-1,
		-1,
		152,
		167,
		138,
		115,
		88,
		83,
		76,
		70,
		75,
		86,
		78,
		89,
		56,
		52,
		42,
		41,
		45,
		62,
		63,
		-1,
		-1,
		158,
		154,
		178,
		160,
		164,
		165,
		-1,
		-1,
		92,
		83,
		74,
		66,
		79,
		82,
		62,
		59,
		53,
		46,
		40,
		50,
		62,
		57,
		-1,
		-1,
		-1,
		170,
		-1,
		172,
		-1,
		-1,
		160,
		163,
		110,
		92,
		88,
		86,
		75,
		69,
		57,
		62,
		63,
		54,
		48,
		36,
		37,
		60,
		49,
		77,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		149,
		141,
		136,
		142,
		144,
		135,
		125,
		122,
		-1,
		92,
		98,
		63,
		70,
		53,
		60,
		58,
		50,
		30,
		34,
		50,
		49,
		44,
		69,
		60,
		64,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		142,
		138,
		128,
		118,
		121,
		-1,
		-1,
		115,
		112,
		92,
		61,
		61,
		54,
		49,
		59,
		39,
		26,
		27,
		22,
		37,
		42,
		47,
		48,
		55,
		70,
		-1,
		189,
		226,
		219,
		187,
		195,
		226,
		-1,
		132,
		124,
		135,
		110,
		112,
		-1,
		-1,
		88,
		79,
		80,
		68,
		65,
		69,
		64,
		44,
		35,
		41,
		19,
		29,
		36,
		41,
		45,
		46,
		53,
		64,
		68,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		129,
		-1,
		-1,
		141,
		113,
		97,
		87,
		84,
		127,
		74,
		69,
		46,
		44,
		41,
		32,
		37,
		14,
		12,
		15,
		33,
		38,
		30,
		56,
		58,
		64,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		156,
		-1,
		124,
		-1,
		107,
		111,
		82,
		85,
		60,
		47,
		33,
		33,
		27,
		12,
		3,
		6,
		20,
		29,
		40,
		52,
		62,
		64,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		141,
		180,
		162,
		-1,
		146,
		-1,
		-1,
		-1,
		121,
		95,
		87,
		80,
		59,
		59,
		25,
		21,
		7,
		0,
		10,
		24,
		29,
		33,
		46,
		57,
		72,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		156,
		147,
		174,
		169,
		158,
		153,
		140,
		-1,
		-1,
		123,
		105,
		-1,
		-1,
		66,
		46,
		29,
		18,
		14,
		17,
		27,
		25,
		36,
		34,
		28,
		60,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		175,
		165,
		169,
		185,
		210,
		-1,
		129,
		-1,
		-1,
		103,
		-1,
		-1,
		88,
		51,
		40,
		31,
		29,
		22,
		31,
		38,
		40,
		43,
		33,
		43,
		56,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		141,
		139,
		145,
		152,
		169,
		199,
		-1,
		-1,
		145,
		125,
		-1,
		-1,
		86,
		84,
		73,
		-1,
		63,
		36,
		33,
		49,
		62,
		51,
		45,
		39,
		46,
		45,
		53,
		61,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		135,
		131,
		-1,
		-1,
		81,
		74,
		62,
		50,
		40,
		47,
		42,
		50,
		49,
		42,
		37,
		48,
		40,
		44,
		61,
		-1,
		212,
		-1,
		164,
		140,
		154,
		169,
		177,
		-1,
		-1,
		-1,
		152,
		138,
		131,
		119,
		117,
		-1,
		115,
		99,
		80,
		-1,
		50,
		63,
		86,
		54,
		59,
		54,
		43,
		54,
		43,
		46,
		60,
		55,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		142,
		144,
		-1,
		143,
		132,
		117,
		109,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		51,
		68,
		57,
		65,
		60,
		47,
		53,
		56,
		45,
		49,
		61,
		-1,
		-1,
		159,
		155,
		149,
		-1,
		127,
		-1,
		145,
		-1,
		112,
		118,
		106,
		-1,
		-1,
		-1,
		89,
		52,
		73,
		75,
		76,
		74,
		65,
		51,
		58,
		56,
		52,
		63,
		-1,
		-1,
		-1,
		145,
		119,
		152,
		143,
		126,
		106,
		98,
		117,
		-1,
		87,
		-1,
		56,
		53,
		89,
		74,
		87,
		81,
		54,
		69,
		59,
		50,
		59,
		151,
		-1,
		121,
		154,
		118,
		112,
		88,
		92,
		108,
		-1,
		84,
		64,
		-1,
		94,
		84,
		103,
		88,
		69,
		56,
		63,
		63,
		56,
		-1,
		-1,
		-1,
		123,
		122,
		114,
		108,
		108,
		93,
		84,
		-1,
		96,
		78,
		57,
		74,
		74,
		65,
		73,
		93,
		89,
		76,
		76,
		68,
		-1,
		224,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		117,
		112,
		85,
		73,
		79,
		75,
		61,
		67,
		69,
		77,
		75,
		72,
		84,
		80,
		92,
		69,
		104,
		-1,
		219,
		-1,
		153,
		-1,
		-1,
		135,
		115,
		107,
		96,
		85,
		83,
		74,
		65,
		87,
		103,
		87,
		81,
		76,
		77,
		-1,
		208,
		207,
		-1,
		154,
		146,
		132,
		-1,
		125,
		-1,
		131,
		92,
		-1,
		94,
		74,
		-1,
		92,
		81,
		-1,
		-1,
		195,
		170,
		-1,
		-1,
		-1,
		155,
		135,
		126,
		110,
		-1,
		85,
		85,
		-1,
		-1,
		-1,
		180,
		179,
		-1,
		148,
		151,
		-1,
		141,
		132,
		140,
		87,
		91,
		-1,
		-1,
		-1,
		189,
		170,
		164,
		163,
		161,
		156,
		153,
		139,
		123,
		101,
		90,
		111,
		-1,
		-1,
		-1,
		161,
		153,
		146,
		-1,
		-1,
		148,
		131,
		112,
		110,
		-1,
		-1,
		-1,
		183,
		164,
		-1,
		-1,
		138,
		-1,
		-1,
		144,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		172,
		-1,
		-1,
		-1,
		134,
		130,
		131,
		-1,
		-1,
		-1,
		-1,
		194,
		195,
		218,
		182,
		-1,
		-1,
		-1,
		126,
		120,
		-1,
		-1,
		197,
		195,
		-1,
		-1,
		-1,
		154,
		138,
		-1,
		124,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		159,
		-1,
		159,
		134,
		141,
		-1,
		-1,
		-1,
		-1,
		172,
		164,
		172,
		-1,
		144,
		146,
		-1,
		194,
		-1,
		-1,
		187,
		178,
		-1,
		-1,
		149,
		156,
		178,
		181,
		217,
		-1,
		168
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		220,
		224,
		190,
		184,
		223,
		192,
		198,
		209,
		-1,
		-1,
		-1,
		213,
		212,
		180,
		178,
		187,
		192,
		199,
		-1,
		198,
		-1,
		234,
		213,
		224,
		229,
		173,
		170,
		190,
		209,
		191,
		183,
		249,
		203,
		174,
		168,
		186,
		176,
		185,
		177,
		-1,
		174,
		164,
		186,
		165,
		176,
		168,
		-1,
		-1,
		168,
		169,
		175,
		161,
		167,
		163,
		-1,
		173,
		157,
		-1,
		-1,
		158,
		159,
		143,
		146,
		154,
		152,
		165,
		157,
		152,
		-1,
		-1,
		149,
		145,
		152,
		139,
		135,
		152,
		165,
		147,
		161,
		160,
		-1,
		153,
		171,
		178,
		146,
		144,
		128,
		126,
		144,
		146,
		152,
		152,
		-1,
		162,
		163,
		158,
		166,
		168,
		144,
		131,
		131,
		141,
		134,
		153,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		134,
		131,
		129,
		126,
		142,
		140,
		150,
		-1,
		-1,
		255,
		224,
		253,
		211,
		192,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		120,
		119,
		147,
		133,
		144,
		215,
		-1,
		-1,
		213,
		205,
		188,
		191,
		168,
		164,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		114,
		124,
		128,
		126,
		151,
		-1,
		-1,
		186,
		-1,
		-1,
		212,
		195,
		-1,
		178,
		185,
		174,
		180,
		166,
		187,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		111,
		136,
		140,
		121,
		142,
		137,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		171,
		174,
		180,
		204,
		203,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		115,
		113,
		143,
		118,
		140,
		137,
		156,
		161,
		155,
		164,
		-1,
		220,
		216,
		212,
		219,
		168,
		-1,
		-1,
		208,
		-1,
		211,
		212,
		187,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		107,
		122,
		113,
		112,
		130,
		140,
		148,
		152,
		158,
		-1,
		270,
		-1,
		212,
		196,
		198,
		170,
		191,
		-1,
		228,
		212,
		204,
		189,
		189,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		120,
		102,
		116,
		107,
		125,
		132,
		130,
		134,
		154,
		166,
		230,
		220,
		-1,
		202,
		207,
		166,
		174,
		193,
		231,
		195,
		-1,
		190,
		-1,
		161,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		113,
		98,
		95,
		113,
		116,
		123,
		127,
		143,
		-1,
		-1,
		215,
		219,
		208,
		159,
		178,
		202,
		239,
		188,
		177,
		176,
		-1,
		167,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		123,
		102,
		97,
		94,
		114,
		140,
		118,
		130,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		185,
		156,
		180,
		222,
		206,
		199,
		187,
		152,
		152,
		146,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		107,
		112,
		92,
		90,
		109,
		121,
		112,
		129,
		-1,
		-1,
		-1,
		215,
		204,
		205,
		151,
		174,
		211,
		185,
		171,
		176,
		151,
		144,
		138,
		153,
		136,
		117,
		106,
		98,
		87,
		103,
		111,
		106,
		88,
		97,
		103,
		127,
		117,
		123,
		-1,
		-1,
		222,
		212,
		196,
		198,
		195,
		165,
		172,
		204,
		176,
		189,
		-1,
		143,
		-1,
		132,
		127,
		111,
		106,
		103,
		100,
		94,
		103,
		105,
		95,
		90,
		97,
		132,
		132,
		107,
		127,
		130,
		-1,
		-1,
		-1,
		215,
		210,
		185,
		162,
		146,
		182,
		-1,
		159,
		160,
		-1,
		137,
		131,
		128,
		113,
		109,
		104,
		108,
		101,
		108,
		101,
		99,
		100,
		82,
		114,
		-1,
		115,
		109,
		117,
		107,
		95,
		-1,
		-1,
		-1,
		208,
		187,
		180,
		200,
		141,
		193,
		-1,
		-1,
		144,
		137,
		-1,
		124,
		106,
		113,
		111,
		105,
		109,
		106,
		95,
		108,
		101,
		87,
		89,
		102,
		106,
		110,
		97,
		93,
		90,
		104,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		161,
		-1,
		153,
		145,
		135,
		129,
		123,
		119,
		117,
		133,
		117,
		120,
		118,
		109,
		117,
		90,
		83,
		90,
		79,
		97,
		105,
		97,
		91,
		90,
		100,
		-1,
		228,
		214,
		185,
		-1,
		-1,
		174,
		-1,
		138,
		152,
		168,
		-1,
		161,
		140,
		155,
		133,
		129,
		125,
		140,
		141,
		119,
		118,
		116,
		107,
		95,
		84,
		87,
		79,
		101,
		101,
		85,
		86,
		90,
		-1,
		234,
		221,
		179,
		175,
		164,
		184,
		135,
		123,
		155,
		-1,
		-1,
		197,
		-1,
		131,
		148,
		139,
		137,
		130,
		121,
		127,
		127,
		104,
		99,
		89,
		78,
		78,
		73,
		95,
		81,
		79,
		88,
		104,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		150,
		137,
		131,
		-1,
		172,
		-1,
		175,
		165,
		149,
		134,
		167,
		-1,
		132,
		122,
		127,
		-1,
		124,
		-1,
		97,
		94,
		85,
		70,
		67,
		78,
		76,
		87,
		83,
		-1,
		184,
		169,
		162,
		152,
		166,
		137,
		-1,
		192,
		-1,
		-1,
		162,
		156,
		156,
		140,
		143,
		148,
		128,
		120,
		127,
		119,
		111,
		105,
		83,
		76,
		73,
		66,
		79,
		89,
		94,
		81,
		-1,
		-1,
		-1,
		189,
		175,
		179,
		139,
		158,
		-1,
		-1,
		224,
		179,
		165,
		-1,
		149,
		148,
		136,
		126,
		116,
		121,
		122,
		102,
		95,
		81,
		83,
		77,
		68,
		67,
		83,
		75,
		97,
		-1,
		-1,
		172,
		177,
		165,
		151,
		170,
		-1,
		-1,
		-1,
		171,
		187,
		176,
		150,
		137,
		-1,
		-1,
		120,
		113,
		107,
		98,
		85,
		97,
		92,
		76,
		61,
		76,
		80,
		88,
		79,
		-1,
		175,
		162,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		-1,
		-1,
		188,
		133,
		122,
		117,
		121,
		119,
		-1,
		93,
		104,
		89,
		101,
		108,
		78,
		63,
		57,
		63,
		75,
		84,
		-1,
		-1,
		187,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		145,
		139,
		110,
		103,
		107,
		-1,
		95,
		97,
		91,
		106,
		81,
		78,
		69,
		60,
		56,
		60,
		64,
		78,
		82,
		210,
		-1,
		171,
		-1,
		-1,
		-1,
		163,
		178,
		149,
		126,
		99,
		94,
		87,
		81,
		86,
		97,
		89,
		100,
		67,
		63,
		53,
		52,
		56,
		73,
		74,
		-1,
		-1,
		169,
		165,
		189,
		171,
		175,
		176,
		-1,
		-1,
		103,
		94,
		85,
		77,
		90,
		93,
		73,
		70,
		64,
		57,
		51,
		61,
		73,
		68,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		174,
		121,
		103,
		99,
		97,
		86,
		80,
		68,
		73,
		74,
		65,
		59,
		47,
		48,
		71,
		60,
		88,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		136,
		133,
		-1,
		103,
		109,
		74,
		81,
		64,
		71,
		69,
		61,
		41,
		45,
		61,
		60,
		55,
		80,
		71,
		75,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		103,
		72,
		72,
		65,
		60,
		70,
		50,
		37,
		38,
		33,
		48,
		53,
		58,
		59,
		66,
		81,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		80,
		75,
		55,
		46,
		52,
		30,
		40,
		47,
		52,
		56,
		57,
		64,
		75,
		79,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		95,
		138,
		85,
		80,
		57,
		55,
		52,
		43,
		48,
		25,
		23,
		26,
		44,
		49,
		41,
		67,
		69,
		75,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		167,
		-1,
		135,
		-1,
		118,
		122,
		93,
		96,
		71,
		58,
		44,
		44,
		38,
		23,
		14,
		17,
		31,
		40,
		51,
		63,
		73,
		75,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		152,
		191,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		132,
		106,
		98,
		91,
		70,
		70,
		36,
		32,
		18,
		11,
		0,
		21,
		38,
		40,
		57,
		68,
		83,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		167,
		158,
		185,
		180,
		169,
		164,
		151,
		-1,
		-1,
		134,
		116,
		-1,
		-1,
		77,
		57,
		40,
		29,
		25,
		28,
		27,
		15,
		34,
		45,
		39,
		71,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		186,
		176,
		180,
		196,
		221,
		-1,
		140,
		-1,
		-1,
		114,
		-1,
		-1,
		99,
		62,
		51,
		42,
		40,
		33,
		31,
		42,
		30,
		54,
		44,
		54,
		67,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		97,
		95,
		84,
		-1,
		74,
		47,
		44,
		60,
		61,
		50,
		36,
		33,
		45,
		56,
		64,
		72,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		92,
		85,
		73,
		61,
		51,
		58,
		53,
		61,
		48,
		41,
		36,
		47,
		51,
		55,
		72,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		126,
		110,
		91,
		-1,
		61,
		74,
		97,
		65,
		66,
		60,
		42,
		53,
		54,
		57,
		71,
		66,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		98,
		94,
		-1,
		-1,
		62,
		79,
		68,
		72,
		67,
		46,
		52,
		62,
		56,
		60,
		72,
		-1,
		-1,
		170,
		166,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		100,
		63,
		84,
		86,
		75,
		73,
		64,
		50,
		57,
		67,
		63,
		74,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		67,
		64,
		100,
		83,
		86,
		80,
		53,
		68,
		68,
		61,
		70,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		75,
		-1,
		105,
		95,
		102,
		87,
		68,
		55,
		62,
		74,
		67,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		84,
		92,
		88,
		75,
		75,
		67,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		86,
		83,
		94,
		85,
		91,
		68,
		104,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		92,
		80,
		75,
		76,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		91,
		80,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		222,
		226,
		192,
		186,
		225,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		215,
		214,
		182,
		180,
		189,
		194,
		201,
		-1,
		200,
		-1,
		236,
		215,
		226,
		231,
		175,
		172,
		192,
		211,
		193,
		185,
		251,
		205,
		176,
		170,
		188,
		178,
		187,
		179,
		-1,
		176,
		166,
		188,
		167,
		178,
		170,
		-1,
		-1,
		170,
		171,
		177,
		163,
		169,
		165,
		-1,
		175,
		159,
		-1,
		-1,
		160,
		161,
		145,
		148,
		156,
		154,
		167,
		159,
		154,
		-1,
		-1,
		151,
		147,
		154,
		141,
		137,
		154,
		167,
		149,
		163,
		162,
		-1,
		155,
		173,
		180,
		148,
		146,
		130,
		128,
		146,
		148,
		154,
		154,
		-1,
		164,
		165,
		160,
		168,
		170,
		146,
		133,
		133,
		143,
		136,
		155,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		136,
		133,
		131,
		128,
		144,
		142,
		152,
		-1,
		-1,
		257,
		226,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		122,
		121,
		149,
		135,
		146,
		217,
		-1,
		-1,
		215,
		207,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		116,
		126,
		130,
		128,
		153,
		-1,
		-1,
		188,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		113,
		138,
		142,
		123,
		144,
		139,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		117,
		115,
		145,
		120,
		142,
		139,
		158,
		163,
		157,
		166,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		109,
		124,
		115,
		114,
		132,
		142,
		150,
		154,
		160,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		214,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		122,
		104,
		118,
		109,
		127,
		134,
		132,
		136,
		156,
		168,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		115,
		100,
		97,
		115,
		118,
		125,
		129,
		145,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		125,
		104,
		99,
		96,
		116,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		109,
		114,
		94,
		92,
		111,
		123,
		114,
		131,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		105,
		113,
		108,
		90,
		99,
		105,
		129,
		119,
		125,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		107,
		97,
		92,
		99,
		134,
		134,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		103,
		101,
		102,
		84,
		116,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		108,
		97,
		110,
		103,
		89,
		91,
		104,
		108,
		112,
		99,
		95,
		92,
		106,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		120,
		111,
		119,
		92,
		85,
		92,
		81,
		99,
		107,
		99,
		93,
		92,
		102,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		121,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		103,
		103,
		87,
		88,
		92,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		123,
		129,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		97,
		83,
		81,
		90,
		106,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		134,
		124,
		129,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		89,
		85,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		150,
		130,
		122,
		129,
		121,
		113,
		107,
		85,
		78,
		75,
		68,
		81,
		91,
		96,
		83,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		150,
		138,
		128,
		118,
		123,
		124,
		104,
		97,
		83,
		85,
		79,
		70,
		69,
		85,
		77,
		99,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		178,
		152,
		139,
		-1,
		-1,
		122,
		115,
		109,
		100,
		87,
		99,
		94,
		78,
		63,
		78,
		82,
		90,
		81,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		190,
		135,
		124,
		119,
		123,
		121,
		-1,
		95,
		106,
		91,
		103,
		110,
		80,
		65,
		59,
		65,
		77,
		86,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		112,
		105,
		109,
		-1,
		97,
		99,
		93,
		108,
		83,
		80,
		71,
		62,
		58,
		62,
		66,
		80,
		84,
		212,
		-1,
		175,
		-1,
		-1,
		-1,
		165,
		180,
		151,
		128,
		101,
		96,
		89,
		83,
		88,
		99,
		91,
		102,
		69,
		65,
		55,
		54,
		58,
		75,
		75,
		-1,
		-1,
		173,
		169,
		191,
		173,
		177,
		178,
		-1,
		-1,
		105,
		96,
		87,
		79,
		92,
		95,
		75,
		72,
		66,
		59,
		53,
		63,
		74,
		69,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		176,
		123,
		105,
		101,
		99,
		88,
		82,
		70,
		75,
		76,
		67,
		61,
		49,
		49,
		72,
		61,
		78,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		138,
		135,
		-1,
		105,
		111,
		76,
		83,
		66,
		73,
		71,
		63,
		43,
		46,
		62,
		61,
		56,
		70,
		61,
		65,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		107,
		76,
		74,
		67,
		62,
		72,
		52,
		39,
		39,
		34,
		49,
		54,
		56,
		49,
		56,
		71,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		82,
		77,
		68,
		48,
		54,
		32,
		39,
		49,
		42,
		46,
		47,
		54,
		65,
		69,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		97,
		92,
		73,
		71,
		65,
		56,
		56,
		38,
		25,
		25,
		34,
		39,
		31,
		57,
		59,
		65,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		139,
		-1,
		122,
		126,
		105,
		108,
		87,
		74,
		60,
		56,
		54,
		36,
		22,
		19,
		21,
		29,
		41,
		53,
		63,
		65,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		136,
		118,
		110,
		107,
		86,
		86,
		52,
		48,
		34,
		27,
		20,
		0,
		24,
		33,
		47,
		58,
		73,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		196,
		185,
		180,
		167,
		-1,
		-1,
		150,
		128,
		-1,
		-1,
		93,
		73,
		56,
		45,
		41,
		44,
		25,
		9,
		31,
		35,
		29,
		61,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		200,
		225,
		-1,
		156,
		-1,
		-1,
		130,
		-1,
		-1,
		115,
		78,
		67,
		58,
		56,
		42,
		29,
		40,
		32,
		44,
		34,
		44,
		57,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		113,
		111,
		100,
		-1,
		90,
		63,
		60,
		76,
		63,
		52,
		38,
		35,
		47,
		46,
		54,
		62,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		108,
		101,
		89,
		77,
		67,
		74,
		68,
		64,
		50,
		43,
		38,
		49,
		41,
		45,
		62,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		142,
		126,
		107,
		-1,
		77,
		90,
		100,
		68,
		68,
		62,
		44,
		55,
		44,
		47,
		61,
		56,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		114,
		110,
		-1,
		-1,
		78,
		82,
		71,
		74,
		69,
		48,
		54,
		57,
		46,
		50,
		62,
		-1,
		-1,
		174,
		175,
		176,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		116,
		79,
		100,
		89,
		77,
		75,
		66,
		52,
		59,
		57,
		53,
		64,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		83,
		80,
		103,
		85,
		88,
		82,
		55,
		70,
		60,
		51,
		60,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		91,
		-1,
		121,
		110,
		104,
		89,
		70,
		57,
		64,
		64,
		57,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		100,
		94,
		90,
		77,
		77,
		69,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		104,
		102,
		99,
		96,
		87,
		93,
		70,
		105,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		94,
		82,
		77,
		78,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		93,
		82,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		205,
		194,
		205,
		213,
		186,
		193,
		-1,
		212,
		216,
		182,
		176,
		215,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		205,
		204,
		172,
		170,
		179,
		184,
		191,
		-1,
		190,
		-1,
		226,
		205,
		216,
		221,
		165,
		162,
		182,
		201,
		183,
		175,
		241,
		195,
		166,
		160,
		178,
		168,
		177,
		169,
		-1,
		166,
		156,
		178,
		157,
		168,
		160,
		-1,
		-1,
		160,
		161,
		167,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		150,
		151,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		141,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		145,
		163,
		170,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		144,
		-1,
		154,
		155,
		150,
		158,
		160,
		136,
		123,
		123,
		133,
		126,
		145,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		137,
		154,
		146,
		136,
		151,
		144,
		126,
		123,
		121,
		118,
		134,
		132,
		142,
		-1,
		-1,
		247,
		216,
		245,
		203,
		184,
		-1,
		150,
		130,
		136,
		140,
		134,
		127,
		141,
		137,
		-1,
		112,
		111,
		139,
		125,
		136,
		207,
		-1,
		-1,
		205,
		197,
		180,
		183,
		160,
		156,
		145,
		144,
		136,
		122,
		118,
		124,
		127,
		127,
		133,
		106,
		116,
		120,
		118,
		143,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		166,
		172,
		158,
		179,
		155,
		146,
		138,
		132,
		120,
		122,
		119,
		132,
		120,
		103,
		128,
		132,
		113,
		134,
		129,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		195,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		107,
		105,
		135,
		110,
		132,
		129,
		148,
		153,
		147,
		156,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		203,
		204,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		99,
		114,
		105,
		104,
		122,
		132,
		140,
		144,
		150,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		204,
		196,
		181,
		181,
		-1,
		151,
		148,
		138,
		116,
		101,
		118,
		110,
		108,
		112,
		94,
		108,
		99,
		117,
		124,
		122,
		126,
		146,
		158,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		105,
		90,
		87,
		105,
		108,
		115,
		119,
		135,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		136,
		133,
		121,
		108,
		93,
		94,
		102,
		115,
		94,
		89,
		86,
		106,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		89,
		102,
		99,
		104,
		84,
		82,
		101,
		113,
		104,
		121,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		145,
		128,
		109,
		98,
		90,
		79,
		95,
		103,
		98,
		80,
		89,
		95,
		119,
		109,
		115,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		92,
		86,
		95,
		97,
		87,
		82,
		89,
		124,
		124,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		96,
		100,
		93,
		100,
		93,
		91,
		92,
		74,
		106,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		103,
		97,
		101,
		98,
		87,
		100,
		93,
		79,
		81,
		94,
		98,
		102,
		89,
		85,
		82,
		96,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		112,
		110,
		101,
		109,
		82,
		75,
		82,
		71,
		89,
		97,
		89,
		83,
		82,
		92,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		110,
		108,
		99,
		87,
		76,
		79,
		71,
		93,
		93,
		77,
		78,
		82,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		119,
		96,
		91,
		81,
		70,
		70,
		65,
		87,
		73,
		71,
		80,
		96,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		124,
		114,
		119,
		-1,
		116,
		-1,
		89,
		86,
		77,
		62,
		59,
		70,
		68,
		79,
		75,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		140,
		120,
		112,
		119,
		111,
		103,
		97,
		75,
		68,
		65,
		58,
		71,
		81,
		86,
		73,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		140,
		128,
		118,
		108,
		113,
		114,
		94,
		87,
		73,
		75,
		69,
		60,
		59,
		75,
		67,
		89,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		168,
		142,
		129,
		-1,
		-1,
		112,
		105,
		99,
		90,
		77,
		89,
		84,
		68,
		53,
		68,
		72,
		80,
		71,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		96,
		81,
		93,
		100,
		70,
		55,
		49,
		55,
		67,
		76,
		-1,
		-1,
		179,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		89,
		83,
		98,
		73,
		70,
		61,
		52,
		48,
		52,
		56,
		70,
		74,
		202,
		-1,
		165,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		78,
		89,
		81,
		92,
		59,
		55,
		45,
		44,
		48,
		65,
		65,
		-1,
		-1,
		163,
		159,
		181,
		163,
		167,
		168,
		-1,
		-1,
		95,
		86,
		77,
		69,
		82,
		85,
		65,
		62,
		56,
		49,
		43,
		53,
		64,
		59,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		165,
		166,
		113,
		95,
		91,
		89,
		78,
		72,
		60,
		65,
		66,
		57,
		51,
		39,
		39,
		62,
		51,
		68,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		128,
		125,
		-1,
		95,
		101,
		66,
		73,
		56,
		63,
		61,
		53,
		33,
		36,
		52,
		51,
		46,
		60,
		51,
		55,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		120,
		117,
		97,
		66,
		64,
		57,
		52,
		62,
		42,
		29,
		29,
		24,
		39,
		44,
		46,
		39,
		46,
		61,
		-1,
		194,
		231,
		224,
		192,
		200,
		231,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		93,
		84,
		85,
		73,
		70,
		72,
		67,
		58,
		38,
		44,
		22,
		29,
		40,
		32,
		36,
		37,
		44,
		55,
		59,
		-1,
		187,
		207,
		186,
		189,
		213,
		227,
		-1,
		134,
		-1,
		-1,
		146,
		118,
		102,
		92,
		89,
		132,
		87,
		82,
		66,
		64,
		55,
		46,
		46,
		30,
		18,
		15,
		24,
		29,
		21,
		47,
		49,
		55,
		-1,
		176,
		187,
		180,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		162,
		-1,
		129,
		-1,
		112,
		116,
		95,
		98,
		80,
		67,
		59,
		46,
		55,
		30,
		26,
		22,
		11,
		14,
		26,
		43,
		53,
		55,
		201,
		157,
		160,
		171,
		182,
		197,
		201,
		-1,
		146,
		185,
		179,
		-1,
		163,
		-1,
		-1,
		-1,
		126,
		108,
		100,
		100,
		79,
		79,
		53,
		49,
		35,
		31,
		37,
		17,
		0,
		18,
		37,
		48,
		63,
		197,
		188,
		201,
		146,
		146,
		167,
		176,
		197,
		161,
		152,
		179,
		186,
		175,
		170,
		157,
		-1,
		-1,
		141,
		118,
		-1,
		-1,
		86,
		74,
		57,
		46,
		42,
		45,
		42,
		26,
		7,
		25,
		19,
		51,
		-1,
		190,
		189,
		178,
		175,
		151,
		142,
		137,
		164,
		-1,
		-1,
		159,
		180,
		170,
		174,
		190,
		215,
		-1,
		146,
		-1,
		-1,
		121,
		-1,
		-1,
		106,
		79,
		68,
		59,
		52,
		50,
		46,
		57,
		13,
		31,
		24,
		34,
		47,
		174,
		171,
		159,
		157,
		180,
		145,
		133,
		-1,
		146,
		144,
		150,
		157,
		174,
		204,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		104,
		102,
		91,
		-1,
		81,
		63,
		49,
		76,
		44,
		33,
		22,
		16,
		28,
		36,
		44,
		52,
		183,
		197,
		186,
		182,
		181,
		189,
		138,
		131,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		99,
		92,
		80,
		68,
		58,
		63,
		49,
		45,
		31,
		24,
		19,
		30,
		31,
		35,
		52,
		-1,
		217,
		-1,
		169,
		145,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		133,
		117,
		98,
		-1,
		68,
		81,
		81,
		49,
		49,
		43,
		25,
		36,
		34,
		37,
		51,
		46,
		-1,
		-1,
		157,
		160,
		-1,
		-1,
		159,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		105,
		101,
		-1,
		-1,
		69,
		63,
		52,
		55,
		50,
		29,
		35,
		45,
		36,
		40,
		52,
		-1,
		-1,
		164,
		165,
		166,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		107,
		70,
		91,
		70,
		58,
		56,
		47,
		33,
		40,
		47,
		43,
		54,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		74,
		71,
		84,
		66,
		69,
		63,
		36,
		51,
		50,
		41,
		50,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		82,
		-1,
		111,
		91,
		85,
		70,
		51,
		38,
		45,
		54,
		47,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		91,
		82,
		82,
		75,
		71,
		58,
		58,
		50,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		94,
		84,
		81,
		77,
		68,
		74,
		51,
		87,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		120,
		75,
		63,
		58,
		59,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		74,
		63,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		203,
		192,
		203,
		211,
		184,
		191,
		-1,
		210,
		214,
		180,
		174,
		213,
		182,
		188,
		199,
		-1,
		-1,
		-1,
		203,
		202,
		170,
		168,
		177,
		182,
		189,
		-1,
		188,
		-1,
		224,
		203,
		214,
		219,
		163,
		160,
		180,
		199,
		181,
		173,
		239,
		193,
		164,
		158,
		176,
		166,
		175,
		167,
		-1,
		164,
		154,
		176,
		155,
		166,
		158,
		-1,
		-1,
		158,
		159,
		165,
		151,
		157,
		153,
		-1,
		163,
		147,
		-1,
		-1,
		148,
		149,
		133,
		136,
		144,
		142,
		155,
		147,
		142,
		-1,
		-1,
		139,
		135,
		142,
		129,
		125,
		142,
		155,
		137,
		151,
		150,
		-1,
		143,
		161,
		168,
		136,
		134,
		118,
		116,
		134,
		136,
		142,
		142,
		-1,
		152,
		153,
		148,
		156,
		158,
		134,
		121,
		121,
		131,
		124,
		143,
		131,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		152,
		135,
		152,
		144,
		134,
		149,
		142,
		124,
		121,
		119,
		116,
		132,
		130,
		140,
		-1,
		-1,
		245,
		214,
		243,
		201,
		182,
		-1,
		148,
		128,
		134,
		138,
		132,
		125,
		139,
		135,
		-1,
		110,
		109,
		137,
		123,
		134,
		205,
		-1,
		-1,
		203,
		195,
		178,
		181,
		158,
		154,
		143,
		142,
		134,
		120,
		116,
		122,
		125,
		125,
		131,
		104,
		114,
		118,
		116,
		141,
		-1,
		-1,
		176,
		-1,
		-1,
		202,
		185,
		-1,
		168,
		175,
		164,
		170,
		156,
		177,
		153,
		144,
		136,
		130,
		118,
		120,
		117,
		130,
		118,
		101,
		126,
		130,
		111,
		132,
		127,
		-1,
		175,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		161,
		164,
		170,
		194,
		193,
		-1,
		165,
		153,
		154,
		139,
		136,
		123,
		111,
		124,
		109,
		116,
		115,
		105,
		103,
		133,
		108,
		130,
		127,
		146,
		151,
		145,
		154,
		-1,
		210,
		206,
		202,
		209,
		158,
		-1,
		-1,
		198,
		-1,
		201,
		202,
		177,
		150,
		153,
		140,
		131,
		118,
		107,
		118,
		107,
		104,
		112,
		97,
		112,
		103,
		102,
		120,
		130,
		138,
		142,
		148,
		-1,
		260,
		-1,
		202,
		186,
		188,
		160,
		181,
		-1,
		218,
		202,
		194,
		179,
		179,
		-1,
		149,
		146,
		136,
		114,
		99,
		116,
		108,
		106,
		110,
		92,
		106,
		97,
		115,
		122,
		120,
		124,
		144,
		156,
		220,
		210,
		-1,
		192,
		197,
		156,
		164,
		183,
		221,
		185,
		-1,
		180,
		-1,
		151,
		164,
		-1,
		120,
		116,
		98,
		99,
		94,
		109,
		103,
		88,
		85,
		103,
		106,
		113,
		117,
		133,
		-1,
		-1,
		205,
		209,
		198,
		149,
		168,
		192,
		229,
		178,
		167,
		166,
		-1,
		157,
		134,
		131,
		119,
		106,
		91,
		92,
		100,
		113,
		92,
		87,
		84,
		104,
		130,
		108,
		120,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		175,
		146,
		170,
		212,
		196,
		189,
		177,
		142,
		142,
		136,
		-1,
		130,
		109,
		100,
		89,
		87,
		100,
		97,
		102,
		82,
		80,
		99,
		111,
		102,
		119,
		-1,
		-1,
		-1,
		205,
		194,
		195,
		141,
		164,
		201,
		175,
		161,
		166,
		141,
		134,
		128,
		143,
		126,
		107,
		96,
		88,
		77,
		93,
		101,
		96,
		78,
		87,
		93,
		117,
		107,
		113,
		-1,
		-1,
		212,
		202,
		186,
		188,
		185,
		155,
		162,
		194,
		166,
		179,
		-1,
		133,
		-1,
		122,
		117,
		101,
		96,
		93,
		90,
		84,
		93,
		95,
		85,
		80,
		87,
		122,
		122,
		97,
		117,
		120,
		-1,
		-1,
		-1,
		205,
		200,
		175,
		152,
		136,
		172,
		-1,
		149,
		150,
		-1,
		127,
		121,
		118,
		103,
		99,
		94,
		98,
		91,
		98,
		91,
		89,
		90,
		72,
		104,
		-1,
		105,
		99,
		107,
		97,
		85,
		-1,
		-1,
		-1,
		198,
		177,
		170,
		190,
		131,
		183,
		-1,
		-1,
		134,
		127,
		-1,
		114,
		96,
		103,
		101,
		95,
		99,
		96,
		85,
		98,
		91,
		77,
		79,
		92,
		96,
		100,
		87,
		83,
		80,
		94,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		151,
		-1,
		143,
		135,
		125,
		119,
		113,
		109,
		107,
		123,
		107,
		110,
		108,
		99,
		107,
		80,
		73,
		80,
		69,
		87,
		95,
		87,
		81,
		80,
		90,
		-1,
		218,
		204,
		175,
		-1,
		-1,
		164,
		-1,
		128,
		142,
		158,
		-1,
		151,
		130,
		145,
		123,
		119,
		115,
		130,
		131,
		109,
		108,
		106,
		97,
		85,
		74,
		77,
		69,
		91,
		91,
		75,
		76,
		80,
		-1,
		224,
		211,
		169,
		165,
		154,
		174,
		125,
		113,
		145,
		-1,
		-1,
		187,
		-1,
		121,
		138,
		129,
		127,
		120,
		111,
		117,
		117,
		94,
		89,
		79,
		68,
		68,
		63,
		85,
		71,
		69,
		78,
		94,
		-1,
		-1,
		-1,
		191,
		-1,
		-1,
		140,
		127,
		121,
		-1,
		162,
		-1,
		165,
		155,
		139,
		124,
		157,
		-1,
		122,
		112,
		117,
		-1,
		114,
		-1,
		87,
		84,
		75,
		60,
		57,
		68,
		66,
		77,
		73,
		-1,
		174,
		159,
		152,
		142,
		156,
		127,
		-1,
		182,
		-1,
		-1,
		152,
		146,
		146,
		130,
		133,
		138,
		118,
		110,
		117,
		109,
		101,
		95,
		73,
		66,
		63,
		56,
		69,
		79,
		84,
		71,
		-1,
		-1,
		-1,
		179,
		165,
		169,
		129,
		148,
		-1,
		-1,
		214,
		169,
		155,
		-1,
		139,
		138,
		126,
		116,
		106,
		111,
		112,
		92,
		85,
		71,
		73,
		67,
		58,
		57,
		73,
		65,
		87,
		-1,
		-1,
		162,
		167,
		155,
		141,
		160,
		-1,
		-1,
		-1,
		161,
		177,
		166,
		140,
		127,
		-1,
		-1,
		110,
		103,
		97,
		88,
		75,
		87,
		82,
		66,
		51,
		66,
		70,
		78,
		69,
		-1,
		165,
		152,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		-1,
		-1,
		178,
		123,
		112,
		107,
		111,
		109,
		-1,
		83,
		94,
		79,
		91,
		98,
		68,
		53,
		47,
		53,
		65,
		74,
		-1,
		-1,
		177,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		135,
		129,
		100,
		93,
		97,
		-1,
		85,
		87,
		81,
		96,
		71,
		68,
		59,
		50,
		46,
		50,
		54,
		68,
		72,
		200,
		-1,
		163,
		-1,
		-1,
		-1,
		153,
		168,
		139,
		116,
		89,
		84,
		77,
		71,
		76,
		87,
		79,
		90,
		57,
		53,
		43,
		42,
		46,
		63,
		63,
		-1,
		-1,
		161,
		157,
		179,
		161,
		165,
		166,
		-1,
		-1,
		93,
		84,
		75,
		67,
		80,
		83,
		63,
		60,
		54,
		47,
		41,
		51,
		62,
		57,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		164,
		111,
		93,
		89,
		87,
		76,
		70,
		58,
		63,
		64,
		55,
		49,
		37,
		37,
		60,
		49,
		66,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		126,
		123,
		-1,
		93,
		99,
		64,
		71,
		54,
		61,
		59,
		51,
		31,
		34,
		50,
		49,
		44,
		58,
		49,
		53,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		62,
		55,
		50,
		60,
		40,
		27,
		27,
		22,
		37,
		42,
		44,
		37,
		44,
		59,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		70,
		65,
		56,
		36,
		42,
		20,
		27,
		38,
		30,
		34,
		35,
		42,
		53,
		57,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		144,
		116,
		100,
		90,
		87,
		130,
		85,
		80,
		64,
		62,
		53,
		44,
		44,
		28,
		16,
		13,
		22,
		27,
		19,
		45,
		47,
		53,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		160,
		-1,
		127,
		-1,
		110,
		114,
		93,
		96,
		78,
		65,
		57,
		44,
		53,
		28,
		24,
		20,
		9,
		4,
		16,
		31,
		41,
		53,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		177,
		-1,
		161,
		-1,
		-1,
		-1,
		124,
		106,
		98,
		98,
		77,
		77,
		51,
		47,
		33,
		29,
		36,
		26,
		14,
		0,
		25,
		36,
		51,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		184,
		173,
		168,
		155,
		-1,
		-1,
		147,
		116,
		-1,
		-1,
		84,
		72,
		55,
		44,
		40,
		43,
		51,
		35,
		21,
		13,
		7,
		39,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		188,
		213,
		-1,
		144,
		-1,
		-1,
		128,
		-1,
		-1,
		113,
		77,
		66,
		57,
		55,
		48,
		55,
		66,
		27,
		22,
		12,
		22,
		35,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		202,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		111,
		109,
		98,
		-1,
		88,
		62,
		56,
		75,
		51,
		40,
		34,
		28,
		33,
		24,
		32,
		40,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		106,
		99,
		87,
		75,
		65,
		70,
		56,
		52,
		38,
		31,
		26,
		37,
		19,
		23,
		40,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		140,
		124,
		105,
		-1,
		75,
		88,
		88,
		56,
		56,
		50,
		32,
		43,
		22,
		25,
		39,
		34,
		-1,
		-1,
		155,
		158,
		-1,
		-1,
		157,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		112,
		108,
		-1,
		-1,
		76,
		70,
		59,
		62,
		57,
		36,
		42,
		35,
		24,
		28,
		40,
		-1,
		-1,
		162,
		163,
		164,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		114,
		77,
		98,
		77,
		65,
		63,
		54,
		40,
		39,
		35,
		31,
		42,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		102,
		-1,
		77,
		78,
		91,
		73,
		76,
		70,
		43,
		58,
		38,
		29,
		38,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		99,
		81,
		-1,
		109,
		97,
		92,
		77,
		58,
		45,
		52,
		42,
		35,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		89,
		89,
		80,
		81,
		82,
		78,
		65,
		65,
		51,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		84,
		92,
		83,
		80,
		76,
		67,
		73,
		50,
		83,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		118,
		74,
		62,
		57,
		58,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		73,
		62,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		166,
		184,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		175,
		176,
		171,
		179,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		158,
		175,
		167,
		157,
		172,
		165,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		268,
		237,
		266,
		224,
		205,
		-1,
		171,
		151,
		157,
		161,
		155,
		148,
		162,
		158,
		-1,
		133,
		132,
		160,
		146,
		157,
		228,
		-1,
		-1,
		226,
		218,
		201,
		204,
		181,
		177,
		166,
		165,
		157,
		143,
		139,
		145,
		148,
		148,
		154,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		199,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		187,
		193,
		179,
		200,
		176,
		167,
		159,
		153,
		141,
		143,
		140,
		153,
		141,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		216,
		-1,
		188,
		176,
		177,
		162,
		159,
		146,
		134,
		147,
		132,
		139,
		138,
		128,
		126,
		156,
		131,
		153,
		150,
		169,
		174,
		168,
		177,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		224,
		225,
		200,
		173,
		176,
		163,
		154,
		141,
		130,
		141,
		130,
		127,
		135,
		120,
		135,
		126,
		125,
		143,
		153,
		161,
		165,
		171,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		225,
		217,
		202,
		202,
		-1,
		172,
		169,
		159,
		137,
		122,
		139,
		131,
		129,
		133,
		115,
		129,
		120,
		138,
		145,
		143,
		147,
		167,
		179,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		244,
		208,
		-1,
		203,
		-1,
		174,
		187,
		-1,
		143,
		139,
		121,
		122,
		117,
		132,
		126,
		111,
		108,
		126,
		129,
		136,
		140,
		156,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		201,
		190,
		189,
		-1,
		180,
		157,
		154,
		142,
		129,
		114,
		115,
		123,
		136,
		115,
		110,
		107,
		127,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		153,
		132,
		123,
		112,
		110,
		123,
		120,
		125,
		105,
		103,
		122,
		134,
		125,
		142,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		164,
		187,
		224,
		198,
		184,
		189,
		164,
		157,
		151,
		166,
		149,
		130,
		119,
		111,
		100,
		116,
		124,
		119,
		101,
		110,
		116,
		140,
		130,
		136,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		178,
		185,
		217,
		189,
		202,
		-1,
		156,
		-1,
		145,
		140,
		124,
		119,
		116,
		113,
		107,
		116,
		118,
		108,
		103,
		110,
		145,
		145,
		120,
		140,
		143,
		-1,
		-1,
		-1,
		228,
		223,
		198,
		175,
		159,
		195,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		126,
		122,
		117,
		121,
		114,
		121,
		114,
		112,
		113,
		95,
		127,
		-1,
		128,
		122,
		130,
		120,
		108,
		-1,
		-1,
		-1,
		221,
		200,
		193,
		213,
		154,
		206,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		126,
		124,
		118,
		122,
		119,
		108,
		121,
		114,
		100,
		102,
		115,
		119,
		123,
		110,
		106,
		103,
		117,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		174,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		146,
		130,
		133,
		131,
		122,
		130,
		103,
		96,
		103,
		92,
		110,
		118,
		110,
		104,
		103,
		113,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		187,
		-1,
		151,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		138,
		153,
		154,
		132,
		131,
		129,
		120,
		108,
		97,
		100,
		92,
		114,
		114,
		98,
		99,
		103,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		148,
		136,
		168,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		152,
		150,
		143,
		134,
		140,
		140,
		117,
		112,
		102,
		91,
		91,
		86,
		108,
		94,
		92,
		101,
		116,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		145,
		135,
		140,
		-1,
		137,
		-1,
		110,
		107,
		98,
		83,
		80,
		91,
		89,
		100,
		96,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		205,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		161,
		141,
		133,
		140,
		132,
		124,
		118,
		96,
		89,
		86,
		79,
		92,
		102,
		107,
		94,
		-1,
		-1,
		-1,
		202,
		188,
		192,
		152,
		171,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		162,
		161,
		149,
		139,
		129,
		134,
		135,
		115,
		108,
		94,
		96,
		90,
		81,
		80,
		96,
		88,
		110,
		-1,
		-1,
		185,
		190,
		178,
		164,
		183,
		-1,
		-1,
		-1,
		184,
		200,
		189,
		163,
		150,
		-1,
		-1,
		133,
		126,
		120,
		111,
		98,
		110,
		105,
		89,
		74,
		89,
		93,
		101,
		92,
		-1,
		188,
		175,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		-1,
		-1,
		201,
		146,
		135,
		130,
		134,
		132,
		-1,
		106,
		117,
		102,
		114,
		121,
		91,
		76,
		70,
		76,
		88,
		97,
		-1,
		-1,
		200,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		158,
		152,
		123,
		116,
		120,
		-1,
		108,
		110,
		104,
		119,
		94,
		91,
		82,
		73,
		69,
		73,
		77,
		88,
		94,
		223,
		-1,
		186,
		-1,
		-1,
		-1,
		176,
		191,
		162,
		139,
		112,
		107,
		100,
		94,
		99,
		110,
		102,
		113,
		80,
		76,
		66,
		65,
		69,
		86,
		86,
		-1,
		-1,
		184,
		180,
		202,
		184,
		188,
		189,
		-1,
		-1,
		116,
		107,
		98,
		90,
		103,
		106,
		86,
		83,
		77,
		70,
		64,
		74,
		85,
		80,
		-1,
		-1,
		-1,
		196,
		-1,
		198,
		-1,
		-1,
		186,
		187,
		134,
		116,
		112,
		110,
		99,
		93,
		81,
		86,
		87,
		78,
		72,
		60,
		60,
		83,
		72,
		82,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		175,
		167,
		162,
		168,
		170,
		161,
		149,
		146,
		-1,
		116,
		122,
		87,
		94,
		77,
		84,
		82,
		74,
		54,
		57,
		73,
		72,
		65,
		74,
		65,
		71,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		141,
		138,
		118,
		87,
		85,
		78,
		73,
		83,
		63,
		50,
		50,
		45,
		60,
		65,
		62,
		55,
		62,
		77,
		-1,
		215,
		252,
		245,
		213,
		221,
		252,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		114,
		105,
		106,
		94,
		91,
		93,
		88,
		79,
		59,
		65,
		43,
		50,
		61,
		53,
		52,
		49,
		51,
		64,
		68,
		-1,
		208,
		228,
		207,
		210,
		234,
		248,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		110,
		153,
		108,
		103,
		87,
		85,
		76,
		67,
		67,
		51,
		39,
		36,
		45,
		47,
		37,
		37,
		61,
		62,
		-1,
		197,
		208,
		201,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		183,
		-1,
		150,
		-1,
		133,
		137,
		116,
		119,
		101,
		88,
		80,
		67,
		76,
		51,
		47,
		43,
		32,
		29,
		41,
		19,
		29,
		50,
		222,
		178,
		181,
		192,
		203,
		218,
		222,
		-1,
		167,
		206,
		200,
		-1,
		184,
		-1,
		-1,
		-1,
		147,
		129,
		121,
		121,
		100,
		100,
		74,
		70,
		56,
		52,
		59,
		49,
		39,
		28,
		0,
		24,
		42,
		218,
		209,
		222,
		167,
		167,
		188,
		197,
		218,
		182,
		173,
		200,
		207,
		196,
		191,
		178,
		-1,
		-1,
		167,
		139,
		-1,
		-1,
		107,
		95,
		78,
		67,
		63,
		66,
		73,
		58,
		33,
		21,
		21,
		29,
		-1,
		211,
		210,
		199,
		196,
		172,
		163,
		158,
		185,
		-1,
		-1,
		180,
		201,
		191,
		195,
		211,
		236,
		-1,
		167,
		-1,
		-1,
		147,
		-1,
		-1,
		132,
		100,
		89,
		80,
		78,
		71,
		77,
		88,
		39,
		31,
		26,
		30,
		34,
		195,
		192,
		180,
		178,
		201,
		166,
		154,
		-1,
		167,
		165,
		171,
		178,
		195,
		225,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		130,
		128,
		117,
		-1,
		107,
		85,
		75,
		98,
		70,
		59,
		48,
		42,
		46,
		35,
		40,
		39,
		204,
		218,
		207,
		203,
		202,
		210,
		159,
		152,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		125,
		118,
		106,
		94,
		84,
		89,
		75,
		71,
		57,
		50,
		45,
		56,
		33,
		37,
		45,
		-1,
		238,
		-1,
		190,
		166,
		180,
		195,
		203,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		159,
		143,
		124,
		-1,
		94,
		107,
		107,
		75,
		75,
		69,
		51,
		62,
		36,
		39,
		53,
		48,
		-1,
		-1,
		178,
		181,
		-1,
		-1,
		180,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		131,
		127,
		-1,
		-1,
		95,
		89,
		78,
		81,
		76,
		55,
		60,
		49,
		38,
		42,
		54,
		-1,
		-1,
		185,
		186,
		187,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		133,
		96,
		117,
		96,
		84,
		82,
		73,
		59,
		53,
		49,
		45,
		56,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		125,
		-1,
		100,
		97,
		110,
		92,
		95,
		89,
		62,
		77,
		52,
		43,
		52,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		122,
		104,
		-1,
		124,
		111,
		111,
		96,
		77,
		64,
		71,
		56,
		49,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		104,
		95,
		95,
		101,
		97,
		84,
		84,
		65,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		107,
		97,
		94,
		90,
		81,
		87,
		64,
		97,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		138,
		88,
		76,
		71,
		72,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		87,
		76,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		116,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		112,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		97,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		97,
		89,
		108,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		94,
		98,
		90,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		77,
		89,
		84,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		69,
		75,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		70,
		73,
		73,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		72,
		67,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		88,
		79,
		73,
		61,
		61,
		83,
		59,
		63,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		83,
		75,
		55,
		58,
		74,
		62,
		50,
		55,
		46,
		54,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		51,
		46,
		53,
		52,
		47,
		40,
		45,
		60,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		80,
		60,
		66,
		44,
		51,
		62,
		54,
		37,
		35,
		32,
		45,
		49,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		68,
		52,
		40,
		37,
		46,
		32,
		22,
		18,
		42,
		43,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		102,
		89,
		81,
		68,
		77,
		52,
		48,
		44,
		33,
		38,
		26,
		4,
		10,
		29,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		122,
		101,
		101,
		75,
		71,
		57,
		53,
		60,
		50,
		42,
		39,
		14,
		0,
		21,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		208,
		197,
		192,
		179,
		-1,
		-1,
		171,
		140,
		-1,
		-1,
		108,
		96,
		79,
		68,
		64,
		67,
		75,
		59,
		44,
		32,
		32,
		5,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		212,
		237,
		-1,
		168,
		-1,
		-1,
		152,
		-1,
		-1,
		137,
		101,
		90,
		81,
		79,
		72,
		79,
		90,
		50,
		42,
		37,
		29,
		19,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		135,
		133,
		122,
		-1,
		112,
		86,
		80,
		99,
		75,
		64,
		58,
		52,
		57,
		42,
		42,
		24,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		130,
		123,
		111,
		99,
		89,
		94,
		80,
		76,
		62,
		55,
		50,
		61,
		44,
		48,
		30,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		164,
		148,
		129,
		-1,
		99,
		112,
		112,
		80,
		80,
		74,
		56,
		67,
		47,
		46,
		38,
		36,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		136,
		132,
		-1,
		-1,
		100,
		94,
		83,
		86,
		81,
		60,
		66,
		60,
		49,
		39,
		39,
		-1,
		-1,
		186,
		187,
		188,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		138,
		101,
		122,
		101,
		89,
		87,
		78,
		64,
		64,
		60,
		56,
		49,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		102,
		115,
		97,
		100,
		94,
		67,
		82,
		61,
		54,
		55,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		127,
		114,
		116,
		101,
		82,
		69,
		74,
		59,
		52,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		107,
		98,
		98,
		106,
		102,
		89,
		89,
		68,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		110,
		100,
		97,
		93,
		84,
		90,
		67,
		100,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		141,
		91,
		79,
		74,
		75,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		90,
		79,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		248,
		252,
		218,
		212,
		251,
		220,
		226,
		237,
		-1,
		-1,
		-1,
		241,
		240,
		208,
		206,
		215,
		220,
		227,
		-1,
		226,
		-1,
		262,
		241,
		252,
		257,
		201,
		198,
		218,
		237,
		219,
		211,
		277,
		231,
		202,
		196,
		214,
		204,
		213,
		205,
		-1,
		202,
		192,
		214,
		193,
		204,
		196,
		-1,
		-1,
		196,
		197,
		203,
		189,
		195,
		191,
		-1,
		201,
		185,
		-1,
		-1,
		186,
		187,
		171,
		174,
		182,
		180,
		193,
		185,
		180,
		-1,
		-1,
		177,
		173,
		180,
		167,
		163,
		180,
		193,
		175,
		189,
		188,
		-1,
		181,
		199,
		206,
		174,
		172,
		156,
		154,
		172,
		174,
		180,
		180,
		-1,
		190,
		191,
		186,
		194,
		196,
		172,
		159,
		159,
		169,
		162,
		181,
		169,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		190,
		173,
		190,
		182,
		172,
		187,
		180,
		162,
		159,
		157,
		154,
		170,
		168,
		178,
		-1,
		-1,
		283,
		252,
		281,
		239,
		220,
		-1,
		186,
		166,
		172,
		176,
		170,
		163,
		177,
		173,
		-1,
		148,
		147,
		175,
		161,
		172,
		243,
		-1,
		-1,
		241,
		233,
		216,
		219,
		196,
		192,
		181,
		180,
		172,
		158,
		154,
		160,
		163,
		163,
		169,
		142,
		152,
		156,
		154,
		179,
		-1,
		-1,
		213,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		202,
		208,
		194,
		215,
		191,
		182,
		174,
		168,
		156,
		158,
		155,
		168,
		156,
		139,
		164,
		168,
		149,
		170,
		165,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		231,
		-1,
		203,
		191,
		192,
		177,
		174,
		161,
		149,
		162,
		147,
		154,
		153,
		143,
		141,
		171,
		146,
		168,
		165,
		183,
		188,
		182,
		191,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		239,
		240,
		215,
		188,
		191,
		178,
		169,
		156,
		145,
		156,
		145,
		142,
		150,
		135,
		150,
		141,
		140,
		158,
		167,
		175,
		179,
		185,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		240,
		232,
		217,
		217,
		-1,
		187,
		184,
		174,
		152,
		137,
		154,
		146,
		144,
		148,
		130,
		144,
		135,
		153,
		160,
		157,
		161,
		181,
		193,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		259,
		223,
		-1,
		218,
		-1,
		189,
		202,
		-1,
		158,
		154,
		136,
		137,
		132,
		147,
		141,
		126,
		123,
		141,
		144,
		150,
		154,
		170,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		216,
		205,
		204,
		-1,
		195,
		172,
		169,
		157,
		144,
		129,
		130,
		138,
		151,
		130,
		125,
		122,
		142,
		167,
		145,
		156,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		234,
		227,
		215,
		180,
		180,
		174,
		-1,
		168,
		147,
		138,
		127,
		125,
		138,
		135,
		140,
		120,
		118,
		137,
		148,
		139,
		147,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		179,
		202,
		239,
		213,
		199,
		204,
		179,
		172,
		166,
		181,
		164,
		145,
		134,
		126,
		115,
		131,
		139,
		134,
		116,
		125,
		131,
		154,
		135,
		141,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		193,
		200,
		232,
		204,
		217,
		-1,
		171,
		-1,
		160,
		155,
		139,
		134,
		131,
		128,
		122,
		131,
		133,
		123,
		118,
		125,
		159,
		159,
		125,
		145,
		148,
		-1,
		-1,
		-1,
		243,
		238,
		213,
		190,
		174,
		210,
		-1,
		187,
		188,
		-1,
		165,
		159,
		156,
		141,
		137,
		132,
		136,
		129,
		136,
		129,
		127,
		128,
		110,
		142,
		-1,
		133,
		127,
		135,
		125,
		113,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		172,
		165,
		-1,
		152,
		134,
		141,
		139,
		133,
		137,
		134,
		123,
		136,
		129,
		115,
		117,
		130,
		134,
		137,
		115,
		111,
		108,
		111,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		181,
		173,
		163,
		157,
		151,
		147,
		145,
		161,
		145,
		148,
		146,
		137,
		145,
		118,
		111,
		118,
		107,
		125,
		133,
		124,
		114,
		106,
		107,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		180,
		196,
		-1,
		189,
		168,
		183,
		161,
		157,
		153,
		168,
		169,
		147,
		146,
		144,
		135,
		123,
		112,
		115,
		107,
		129,
		128,
		112,
		109,
		102,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		151,
		183,
		-1,
		-1,
		225,
		-1,
		159,
		176,
		167,
		165,
		158,
		149,
		155,
		155,
		132,
		127,
		117,
		106,
		106,
		101,
		123,
		109,
		107,
		100,
		92,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		203,
		193,
		177,
		162,
		195,
		-1,
		160,
		150,
		155,
		-1,
		152,
		-1,
		125,
		122,
		113,
		98,
		95,
		106,
		104,
		115,
		101,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		220,
		-1,
		-1,
		190,
		184,
		184,
		168,
		171,
		176,
		156,
		148,
		155,
		147,
		139,
		133,
		111,
		104,
		101,
		94,
		107,
		117,
		115,
		99,
		-1,
		-1,
		-1,
		217,
		203,
		207,
		167,
		186,
		-1,
		-1,
		252,
		207,
		193,
		-1,
		177,
		176,
		164,
		154,
		144,
		149,
		150,
		130,
		123,
		109,
		111,
		105,
		96,
		95,
		106,
		98,
		103,
		-1,
		-1,
		200,
		205,
		193,
		179,
		198,
		-1,
		-1,
		-1,
		199,
		215,
		204,
		178,
		165,
		-1,
		-1,
		148,
		141,
		135,
		126,
		113,
		125,
		120,
		104,
		89,
		104,
		101,
		93,
		85,
		-1,
		203,
		190,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		-1,
		-1,
		216,
		161,
		150,
		145,
		149,
		147,
		-1,
		121,
		132,
		117,
		129,
		136,
		106,
		91,
		85,
		86,
		96,
		79,
		-1,
		-1,
		215,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		173,
		167,
		138,
		131,
		135,
		-1,
		123,
		125,
		119,
		134,
		109,
		106,
		97,
		88,
		84,
		83,
		83,
		64,
		70,
		238,
		-1,
		201,
		-1,
		-1,
		-1,
		191,
		206,
		177,
		154,
		127,
		122,
		115,
		109,
		114,
		125,
		117,
		128,
		95,
		91,
		81,
		80,
		79,
		68,
		69,
		-1,
		-1,
		199,
		195,
		217,
		199,
		203,
		204,
		-1,
		-1,
		131,
		122,
		113,
		105,
		118,
		121,
		101,
		98,
		92,
		85,
		79,
		89,
		68,
		63,
		-1,
		-1,
		-1,
		211,
		-1,
		213,
		-1,
		-1,
		201,
		202,
		149,
		131,
		127,
		125,
		114,
		108,
		96,
		101,
		104,
		94,
		86,
		75,
		69,
		79,
		55,
		58,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		190,
		182,
		177,
		183,
		185,
		176,
		164,
		161,
		-1,
		131,
		137,
		102,
		109,
		92,
		99,
		98,
		90,
		69,
		66,
		72,
		58,
		46,
		50,
		41,
		45,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		183,
		179,
		169,
		159,
		162,
		-1,
		-1,
		156,
		153,
		133,
		102,
		100,
		93,
		88,
		98,
		78,
		65,
		59,
		63,
		49,
		48,
		43,
		36,
		36,
		51,
		-1,
		230,
		267,
		260,
		228,
		236,
		267,
		-1,
		173,
		165,
		176,
		151,
		153,
		-1,
		-1,
		129,
		120,
		121,
		109,
		106,
		108,
		103,
		94,
		79,
		85,
		63,
		61,
		78,
		63,
		56,
		39,
		28,
		38,
		42,
		-1,
		223,
		243,
		222,
		225,
		249,
		263,
		-1,
		170,
		-1,
		-1,
		182,
		154,
		138,
		128,
		125,
		168,
		123,
		118,
		102,
		100,
		91,
		82,
		87,
		71,
		59,
		56,
		65,
		51,
		41,
		36,
		32,
		39,
		-1,
		212,
		223,
		216,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		198,
		-1,
		165,
		-1,
		148,
		152,
		131,
		134,
		116,
		103,
		95,
		87,
		96,
		71,
		67,
		63,
		52,
		59,
		51,
		30,
		38,
		8,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		182,
		221,
		215,
		-1,
		199,
		-1,
		-1,
		-1,
		162,
		144,
		136,
		136,
		115,
		115,
		89,
		90,
		76,
		72,
		79,
		69,
		61,
		58,
		40,
		28,
		0,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		197,
		188,
		215,
		222,
		211,
		206,
		193,
		-1,
		-1,
		185,
		154,
		-1,
		-1,
		122,
		110,
		93,
		87,
		83,
		86,
		94,
		78,
		63,
		51,
		51,
		23,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		216,
		206,
		210,
		226,
		251,
		-1,
		182,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		115,
		104,
		95,
		98,
		91,
		98,
		109,
		69,
		61,
		56,
		43,
		37,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		240,
		-1,
		-1,
		198,
		178,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		100,
		99,
		118,
		94,
		83,
		77,
		71,
		76,
		56,
		58,
		42,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		188,
		184,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		113,
		99,
		95,
		81,
		74,
		69,
		80,
		63,
		63,
		46,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		205,
		191,
		184,
		172,
		170,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		131,
		99,
		99,
		93,
		75,
		86,
		66,
		62,
		54,
		52,
		-1,
		-1,
		193,
		196,
		-1,
		-1,
		195,
		197,
		-1,
		196,
		185,
		170,
		162,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		115,
		113,
		102,
		105,
		100,
		79,
		85,
		79,
		68,
		55,
		55,
		-1,
		-1,
		200,
		201,
		202,
		-1,
		180,
		-1,
		198,
		-1,
		165,
		171,
		159,
		-1,
		-1,
		-1,
		153,
		116,
		137,
		120,
		108,
		106,
		97,
		83,
		83,
		79,
		75,
		65,
		-1,
		-1,
		-1,
		198,
		172,
		205,
		196,
		179,
		159,
		151,
		170,
		-1,
		140,
		-1,
		115,
		117,
		134,
		116,
		119,
		113,
		86,
		101,
		77,
		73,
		71,
		204,
		-1,
		174,
		207,
		171,
		165,
		141,
		145,
		161,
		-1,
		137,
		119,
		-1,
		143,
		130,
		134,
		119,
		100,
		87,
		90,
		75,
		68,
		-1,
		-1,
		-1,
		176,
		175,
		167,
		161,
		161,
		146,
		137,
		-1,
		149,
		131,
		110,
		127,
		123,
		114,
		114,
		124,
		120,
		107,
		105,
		84,
		-1,
		277,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		170,
		165,
		138,
		126,
		132,
		128,
		114,
		120,
		122,
		126,
		116,
		113,
		109,
		100,
		106,
		83,
		116,
		-1,
		272,
		-1,
		206,
		-1,
		-1,
		188,
		168,
		160,
		149,
		138,
		136,
		127,
		118,
		140,
		156,
		107,
		95,
		90,
		91,
		-1,
		261,
		260,
		-1,
		207,
		199,
		185,
		-1,
		178,
		-1,
		184,
		145,
		-1,
		147,
		127,
		-1,
		106,
		95,
		-1,
		-1,
		248,
		223,
		-1,
		-1,
		-1,
		208,
		188,
		179,
		163,
		-1,
		138,
		138,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		201,
		204,
		-1,
		194,
		185,
		193,
		140,
		144,
		-1,
		-1,
		-1,
		242,
		223,
		217,
		216,
		214,
		209,
		206,
		192,
		176,
		154,
		143,
		164,
		-1,
		-1,
		-1,
		214,
		206,
		199,
		-1,
		-1,
		201,
		184,
		165,
		163,
		-1,
		-1,
		-1,
		236,
		217,
		-1,
		-1,
		191,
		-1,
		-1,
		197,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		225,
		-1,
		-1,
		-1,
		187,
		183,
		184,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		271,
		235,
		-1,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		177,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		212,
		-1,
		212,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		225,
		217,
		225,
		-1,
		197,
		199,
		-1,
		247,
		-1,
		-1,
		240,
		231,
		-1,
		-1,
		202,
		209,
		231,
		234,
		270,
		-1,
		221
	],
	[
		-1,
		341,
		330,
		341,
		349,
		322,
		329,
		-1,
		348,
		352,
		318,
		312,
		351,
		320,
		326,
		337,
		-1,
		-1,
		-1,
		341,
		340,
		308,
		306,
		315,
		320,
		327,
		-1,
		326,
		-1,
		362,
		341,
		352,
		357,
		301,
		298,
		318,
		337,
		319,
		311,
		377,
		331,
		302,
		296,
		314,
		304,
		313,
		305,
		-1,
		302,
		292,
		314,
		293,
		304,
		296,
		-1,
		-1,
		296,
		297,
		303,
		289,
		295,
		291,
		-1,
		301,
		285,
		-1,
		-1,
		286,
		287,
		271,
		274,
		282,
		280,
		293,
		285,
		280,
		-1,
		-1,
		277,
		273,
		280,
		267,
		263,
		280,
		293,
		275,
		289,
		288,
		-1,
		283,
		301,
		306,
		274,
		272,
		256,
		254,
		272,
		274,
		280,
		280,
		-1,
		282,
		284,
		288,
		296,
		296,
		272,
		259,
		259,
		269,
		262,
		281,
		269,
		315,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		279,
		275,
		292,
		284,
		274,
		289,
		282,
		262,
		259,
		257,
		254,
		270,
		268,
		278,
		-1,
		-1,
		335,
		304,
		339,
		296,
		281,
		-1,
		275,
		268,
		274,
		278,
		272,
		265,
		279,
		275,
		-1,
		248,
		247,
		275,
		261,
		272,
		295,
		-1,
		-1,
		293,
		285,
		270,
		273,
		270,
		270,
		283,
		282,
		274,
		260,
		256,
		262,
		265,
		265,
		271,
		242,
		252,
		256,
		254,
		279,
		-1,
		-1,
		314,
		-1,
		-1,
		292,
		275,
		-1,
		258,
		265,
		265,
		282,
		272,
		293,
		293,
		284,
		276,
		270,
		258,
		260,
		257,
		270,
		258,
		239,
		264,
		268,
		249,
		270,
		265,
		-1,
		313,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		251,
		254,
		260,
		284,
		294,
		-1,
		305,
		293,
		294,
		279,
		276,
		263,
		251,
		264,
		249,
		256,
		255,
		243,
		241,
		271,
		246,
		268,
		265,
		284,
		289,
		283,
		292,
		-1,
		300,
		296,
		292,
		299,
		248,
		-1,
		-1,
		288,
		-1,
		302,
		315,
		317,
		290,
		293,
		280,
		271,
		258,
		247,
		258,
		247,
		244,
		252,
		235,
		250,
		241,
		240,
		258,
		268,
		276,
		280,
		286,
		-1,
		350,
		-1,
		292,
		276,
		278,
		250,
		271,
		-1,
		308,
		303,
		323,
		319,
		315,
		-1,
		289,
		286,
		276,
		254,
		239,
		256,
		248,
		246,
		248,
		230,
		244,
		235,
		253,
		260,
		258,
		262,
		282,
		294,
		310,
		300,
		-1,
		282,
		287,
		246,
		254,
		273,
		346,
		321,
		-1,
		316,
		-1,
		291,
		304,
		-1,
		260,
		256,
		238,
		239,
		234,
		249,
		241,
		226,
		223,
		241,
		244,
		251,
		255,
		271,
		-1,
		-1,
		295,
		299,
		288,
		239,
		258,
		282,
		319,
		314,
		303,
		302,
		-1,
		293,
		274,
		271,
		259,
		246,
		231,
		232,
		240,
		252,
		231,
		225,
		222,
		242,
		268,
		246,
		257,
		-1,
		-1,
		-1,
		320,
		-1,
		-1,
		265,
		236,
		260,
		302,
		332,
		325,
		313,
		278,
		278,
		272,
		-1,
		270,
		249,
		240,
		229,
		227,
		240,
		232,
		240,
		220,
		218,
		237,
		249,
		240,
		248,
		-1,
		-1,
		-1,
		295,
		284,
		285,
		234,
		257,
		291,
		311,
		297,
		302,
		277,
		270,
		264,
		283,
		266,
		247,
		236,
		228,
		217,
		228,
		236,
		234,
		216,
		225,
		231,
		255,
		236,
		242,
		-1,
		-1,
		302,
		292,
		276,
		278,
		275,
		248,
		255,
		287,
		302,
		299,
		-1,
		269,
		-1,
		258,
		256,
		241,
		236,
		233,
		220,
		219,
		233,
		233,
		223,
		218,
		225,
		260,
		260,
		226,
		246,
		249,
		-1,
		-1,
		-1,
		295,
		293,
		268,
		245,
		229,
		265,
		-1,
		269,
		270,
		-1,
		263,
		257,
		256,
		243,
		239,
		224,
		228,
		230,
		233,
		221,
		227,
		228,
		210,
		234,
		-1,
		234,
		228,
		236,
		226,
		214,
		-1,
		-1,
		-1,
		291,
		270,
		263,
		283,
		224,
		276,
		-1,
		-1,
		254,
		247,
		-1,
		250,
		234,
		236,
		231,
		227,
		229,
		226,
		215,
		228,
		221,
		215,
		209,
		222,
		226,
		227,
		216,
		212,
		209,
		223,
		-1,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		244,
		-1,
		257,
		249,
		245,
		239,
		245,
		247,
		245,
		255,
		239,
		241,
		237,
		229,
		224,
		210,
		203,
		214,
		199,
		217,
		223,
		214,
		209,
		208,
		219,
		-1,
		311,
		297,
		268,
		-1,
		-1,
		257,
		-1,
		221,
		235,
		251,
		-1,
		279,
		258,
		281,
		259,
		257,
		248,
		246,
		247,
		217,
		222,
		224,
		212,
		215,
		204,
		207,
		199,
		221,
		218,
		202,
		204,
		213,
		-1,
		317,
		304,
		262,
		258,
		247,
		267,
		218,
		227,
		238,
		-1,
		-1,
		308,
		-1,
		257,
		264,
		262,
		260,
		236,
		211,
		218,
		236,
		209,
		204,
		209,
		198,
		198,
		193,
		212,
		198,
		196,
		211,
		227,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		233,
		220,
		214,
		-1,
		255,
		-1,
		286,
		274,
		261,
		243,
		283,
		-1,
		210,
		206,
		213,
		-1,
		229,
		-1,
		201,
		204,
		195,
		190,
		187,
		198,
		196,
		205,
		206,
		-1,
		267,
		252,
		245,
		235,
		249,
		220,
		-1,
		263,
		-1,
		-1,
		273,
		267,
		267,
		236,
		233,
		226,
		206,
		198,
		213,
		212,
		199,
		198,
		186,
		186,
		189,
		183,
		196,
		206,
		212,
		204,
		-1,
		-1,
		-1,
		272,
		224,
		232,
		208,
		229,
		-1,
		-1,
		334,
		290,
		276,
		-1,
		228,
		226,
		214,
		204,
		194,
		199,
		200,
		190,
		188,
		184,
		193,
		192,
		185,
		184,
		205,
		198,
		220,
		-1,
		-1,
		221,
		234,
		236,
		222,
		222,
		-1,
		-1,
		-1,
		280,
		281,
		247,
		226,
		215,
		-1,
		-1,
		198,
		191,
		185,
		188,
		176,
		196,
		203,
		191,
		178,
		193,
		203,
		211,
		210,
		-1,
		224,
		211,
		-1,
		-1,
		221,
		211,
		-1,
		-1,
		-1,
		-1,
		259,
		204,
		193,
		188,
		192,
		197,
		-1,
		171,
		182,
		175,
		194,
		201,
		193,
		178,
		172,
		183,
		198,
		215,
		-1,
		-1,
		235,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		216,
		210,
		181,
		174,
		178,
		-1,
		173,
		175,
		172,
		184,
		189,
		193,
		184,
		166,
		180,
		183,
		196,
		210,
		214,
		258,
		-1,
		188,
		-1,
		-1,
		-1,
		227,
		228,
		214,
		191,
		170,
		163,
		160,
		159,
		164,
		175,
		184,
		195,
		160,
		164,
		179,
		184,
		188,
		205,
		209,
		-1,
		-1,
		186,
		182,
		217,
		229,
		201,
		241,
		-1,
		-1,
		159,
		152,
		162,
		155,
		168,
		171,
		156,
		158,
		176,
		189,
		183,
		193,
		208,
		203,
		-1,
		-1,
		-1,
		184,
		-1,
		200,
		-1,
		-1,
		191,
		232,
		179,
		161,
		157,
		143,
		150,
		144,
		146,
		151,
		170,
		165,
		174,
		179,
		183,
		206,
		195,
		234,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		150,
		169,
		164,
		170,
		175,
		166,
		194,
		191,
		-1,
		140,
		173,
		141,
		155,
		151,
		158,
		163,
		169,
		173,
		180,
		196,
		195,
		190,
		226,
		217,
		223,
		-1,
		-1,
		170,
		159,
		148,
		154,
		-1,
		143,
		166,
		156,
		146,
		152,
		-1,
		-1,
		158,
		155,
		153,
		133,
		139,
		144,
		147,
		185,
		161,
		169,
		173,
		177,
		183,
		188,
		193,
		199,
		214,
		229,
		-1,
		124,
		161,
		154,
		122,
		130,
		161,
		-1,
		133,
		125,
		153,
		138,
		146,
		-1,
		-1,
		131,
		122,
		127,
		136,
		137,
		168,
		167,
		180,
		183,
		188,
		176,
		175,
		193,
		197,
		206,
		213,
		203,
		216,
		220,
		-1,
		117,
		137,
		116,
		119,
		143,
		157,
		-1,
		124,
		-1,
		-1,
		169,
		156,
		140,
		130,
		127,
		174,
		150,
		145,
		151,
		153,
		177,
		168,
		193,
		184,
		184,
		187,
		202,
		207,
		199,
		213,
		213,
		214,
		-1,
		106,
		117,
		110,
		-1,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		185,
		-1,
		167,
		-1,
		150,
		154,
		158,
		161,
		176,
		163,
		170,
		187,
		193,
		182,
		192,
		188,
		189,
		198,
		209,
		221,
		220,
		221,
		4,
		62,
		90,
		101,
		112,
		127,
		131,
		-1,
		108,
		144,
		154,
		-1,
		194,
		-1,
		-1,
		-1,
		164,
		171,
		163,
		179,
		175,
		175,
		171,
		175,
		187,
		194,
		204,
		206,
		198,
		202,
		215,
		226,
		229,
		0,
		51,
		116,
		61,
		76,
		97,
		106,
		127,
		104,
		101,
		138,
		143,
		158,
		163,
		187,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		182,
		192,
		175,
		177,
		181,
		195,
		207,
		215,
		205,
		203,
		197,
		229,
		-1,
		80,
		50,
		68,
		65,
		51,
		61,
		67,
		94,
		-1,
		-1,
		102,
		129,
		113,
		117,
		133,
		158,
		-1,
		194,
		-1,
		-1,
		208,
		-1,
		-1,
		234,
		197,
		186,
		177,
		183,
		189,
		200,
		222,
		211,
		212,
		202,
		212,
		225,
		64,
		61,
		49,
		47,
		67,
		75,
		70,
		-1,
		89,
		87,
		93,
		100,
		117,
		147,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		227,
		230,
		219,
		-1,
		209,
		182,
		187,
		212,
		219,
		220,
		214,
		208,
		215,
		214,
		222,
		230,
		73,
		87,
		76,
		67,
		68,
		77,
		75,
		74,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		-1,
		239,
		220,
		-1,
		-1,
		227,
		220,
		208,
		196,
		186,
		196,
		204,
		204,
		207,
		211,
		206,
		217,
		209,
		213,
		230,
		-1,
		102,
		-1,
		106,
		88,
		102,
		117,
		125,
		-1,
		-1,
		-1,
		256,
		242,
		235,
		223,
		221,
		-1,
		261,
		245,
		226,
		-1,
		196,
		209,
		240,
		208,
		213,
		208,
		212,
		223,
		212,
		215,
		229,
		224,
		-1,
		-1,
		100,
		103,
		-1,
		-1,
		125,
		144,
		-1,
		247,
		236,
		221,
		213,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		197,
		222,
		211,
		219,
		214,
		216,
		222,
		225,
		214,
		218,
		230,
		-1,
		-1,
		107,
		108,
		113,
		-1,
		134,
		-1,
		249,
		-1,
		216,
		223,
		211,
		-1,
		-1,
		-1,
		235,
		198,
		219,
		229,
		234,
		232,
		223,
		220,
		227,
		225,
		221,
		232,
		-1,
		-1,
		-1,
		164,
		141,
		256,
		247,
		230,
		210,
		202,
		222,
		-1,
		223,
		-1,
		198,
		199,
		226,
		228,
		245,
		239,
		223,
		238,
		228,
		219,
		228,
		170,
		-1,
		145,
		204,
		187,
		216,
		182,
		194,
		244,
		-1,
		220,
		202,
		-1,
		230,
		220,
		262,
		243,
		236,
		223,
		230,
		232,
		225,
		-1,
		-1,
		-1,
		160,
		159,
		158,
		169,
		177,
		175,
		193,
		-1,
		232,
		214,
		193,
		210,
		210,
		201,
		209,
		252,
		248,
		241,
		243,
		233,
		-1,
		174,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		186,
		208,
		203,
		195,
		207,
		211,
		197,
		203,
		205,
		213,
		211,
		208,
		220,
		216,
		236,
		232,
		264,
		-1,
		181,
		-1,
		190,
		-1,
		-1,
		204,
		190,
		202,
		213,
		203,
		203,
		208,
		201,
		223,
		239,
		223,
		221,
		226,
		231,
		-1,
		191,
		192,
		-1,
		223,
		215,
		201,
		-1,
		194,
		-1,
		249,
		210,
		-1,
		230,
		210,
		-1,
		232,
		228,
		-1,
		-1,
		203,
		239,
		-1,
		-1,
		-1,
		224,
		204,
		244,
		228,
		-1,
		221,
		221,
		-1,
		-1,
		-1,
		217,
		240,
		-1,
		217,
		220,
		-1,
		211,
		217,
		246,
		223,
		227,
		-1,
		-1,
		-1,
		244,
		228,
		233,
		232,
		237,
		225,
		242,
		228,
		230,
		237,
		226,
		247,
		-1,
		-1,
		-1,
		245,
		237,
		237,
		-1,
		-1,
		255,
		238,
		238,
		246,
		-1,
		-1,
		-1,
		267,
		248,
		-1,
		-1,
		246,
		-1,
		-1,
		251,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		256,
		-1,
		-1,
		-1,
		247,
		254,
		262,
		-1,
		-1,
		-1,
		-1,
		234,
		235,
		279,
		277,
		-1,
		-1,
		-1,
		261,
		256,
		-1,
		-1,
		232,
		233,
		-1,
		-1,
		-1,
		289,
		273,
		-1,
		260,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		294,
		-1,
		295,
		270,
		277,
		-1,
		-1,
		-1,
		-1,
		307,
		299,
		308,
		-1,
		280,
		282,
		-1,
		330,
		-1,
		-1,
		322,
		313,
		-1,
		-1,
		285,
		292,
		314,
		317,
		316,
		-1,
		304
	],
	[
		-1,
		339,
		328,
		339,
		347,
		320,
		327,
		-1,
		346,
		350,
		316,
		310,
		349,
		318,
		324,
		335,
		-1,
		-1,
		-1,
		339,
		338,
		306,
		304,
		313,
		318,
		325,
		-1,
		324,
		-1,
		360,
		339,
		350,
		355,
		299,
		296,
		316,
		335,
		317,
		309,
		375,
		329,
		300,
		294,
		312,
		302,
		311,
		303,
		-1,
		300,
		290,
		312,
		291,
		302,
		294,
		-1,
		-1,
		294,
		295,
		301,
		287,
		293,
		289,
		-1,
		299,
		283,
		-1,
		-1,
		284,
		285,
		269,
		272,
		280,
		278,
		291,
		283,
		278,
		-1,
		-1,
		275,
		271,
		278,
		265,
		261,
		278,
		291,
		273,
		287,
		286,
		-1,
		281,
		299,
		304,
		272,
		270,
		254,
		252,
		270,
		272,
		278,
		278,
		-1,
		277,
		279,
		286,
		294,
		294,
		270,
		257,
		257,
		267,
		260,
		279,
		267,
		313,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		274,
		273,
		290,
		282,
		272,
		287,
		280,
		260,
		257,
		255,
		252,
		268,
		266,
		276,
		-1,
		-1,
		330,
		299,
		334,
		291,
		276,
		-1,
		270,
		266,
		272,
		276,
		270,
		263,
		277,
		273,
		-1,
		246,
		245,
		273,
		259,
		270,
		290,
		-1,
		-1,
		288,
		280,
		265,
		268,
		265,
		265,
		281,
		280,
		272,
		258,
		254,
		260,
		263,
		263,
		269,
		240,
		250,
		254,
		252,
		277,
		-1,
		-1,
		312,
		-1,
		-1,
		287,
		270,
		-1,
		253,
		260,
		260,
		277,
		267,
		288,
		291,
		282,
		274,
		268,
		256,
		258,
		255,
		268,
		256,
		237,
		262,
		266,
		247,
		268,
		263,
		-1,
		311,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		246,
		249,
		255,
		279,
		289,
		-1,
		303,
		291,
		292,
		277,
		274,
		261,
		249,
		262,
		247,
		254,
		253,
		241,
		239,
		269,
		244,
		266,
		263,
		282,
		287,
		281,
		290,
		-1,
		295,
		291,
		287,
		294,
		243,
		-1,
		-1,
		283,
		-1,
		297,
		310,
		315,
		288,
		291,
		278,
		269,
		256,
		245,
		256,
		245,
		242,
		250,
		233,
		248,
		239,
		238,
		256,
		266,
		274,
		278,
		284,
		-1,
		345,
		-1,
		287,
		271,
		273,
		245,
		266,
		-1,
		303,
		298,
		318,
		317,
		310,
		-1,
		287,
		284,
		274,
		252,
		237,
		254,
		246,
		244,
		246,
		228,
		242,
		233,
		251,
		258,
		256,
		260,
		280,
		292,
		305,
		295,
		-1,
		277,
		282,
		241,
		249,
		268,
		341,
		316,
		-1,
		311,
		-1,
		289,
		302,
		-1,
		258,
		254,
		236,
		237,
		232,
		247,
		239,
		224,
		221,
		239,
		242,
		249,
		253,
		269,
		-1,
		-1,
		290,
		294,
		283,
		234,
		253,
		277,
		314,
		309,
		298,
		297,
		-1,
		288,
		272,
		269,
		257,
		244,
		229,
		230,
		238,
		250,
		229,
		223,
		220,
		240,
		266,
		244,
		255,
		-1,
		-1,
		-1,
		315,
		-1,
		-1,
		260,
		231,
		255,
		297,
		327,
		320,
		308,
		273,
		273,
		267,
		-1,
		268,
		247,
		238,
		227,
		225,
		238,
		230,
		238,
		218,
		216,
		235,
		247,
		238,
		246,
		-1,
		-1,
		-1,
		290,
		279,
		280,
		229,
		252,
		286,
		306,
		292,
		297,
		272,
		265,
		259,
		281,
		264,
		245,
		234,
		226,
		215,
		226,
		234,
		232,
		214,
		223,
		229,
		253,
		234,
		240,
		-1,
		-1,
		297,
		287,
		271,
		273,
		270,
		243,
		250,
		282,
		297,
		294,
		-1,
		264,
		-1,
		253,
		254,
		239,
		234,
		231,
		218,
		217,
		231,
		231,
		221,
		216,
		223,
		258,
		258,
		224,
		244,
		247,
		-1,
		-1,
		-1,
		290,
		288,
		263,
		240,
		224,
		260,
		-1,
		264,
		265,
		-1,
		258,
		252,
		254,
		241,
		237,
		222,
		226,
		228,
		231,
		219,
		225,
		226,
		208,
		232,
		-1,
		232,
		226,
		234,
		224,
		212,
		-1,
		-1,
		-1,
		286,
		265,
		258,
		278,
		219,
		271,
		-1,
		-1,
		249,
		242,
		-1,
		245,
		232,
		234,
		229,
		225,
		227,
		224,
		213,
		226,
		219,
		213,
		207,
		220,
		224,
		225,
		214,
		210,
		207,
		221,
		-1,
		305,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		239,
		-1,
		252,
		244,
		240,
		234,
		240,
		245,
		243,
		253,
		237,
		239,
		235,
		227,
		222,
		208,
		201,
		212,
		197,
		215,
		221,
		212,
		207,
		206,
		217,
		-1,
		306,
		292,
		263,
		-1,
		-1,
		252,
		-1,
		216,
		230,
		246,
		-1,
		274,
		253,
		276,
		254,
		255,
		246,
		244,
		245,
		215,
		220,
		222,
		210,
		213,
		202,
		205,
		197,
		219,
		216,
		200,
		202,
		211,
		-1,
		312,
		299,
		257,
		253,
		242,
		262,
		213,
		222,
		233,
		-1,
		-1,
		306,
		-1,
		252,
		262,
		260,
		258,
		234,
		209,
		216,
		234,
		207,
		202,
		207,
		196,
		196,
		191,
		210,
		196,
		194,
		209,
		225,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		228,
		215,
		209,
		-1,
		250,
		-1,
		284,
		272,
		259,
		241,
		281,
		-1,
		208,
		204,
		211,
		-1,
		227,
		-1,
		199,
		202,
		193,
		188,
		185,
		196,
		194,
		203,
		204,
		-1,
		262,
		247,
		240,
		230,
		244,
		215,
		-1,
		258,
		-1,
		-1,
		271,
		265,
		265,
		234,
		231,
		224,
		204,
		196,
		211,
		210,
		197,
		196,
		184,
		184,
		187,
		181,
		194,
		204,
		210,
		202,
		-1,
		-1,
		-1,
		267,
		219,
		227,
		203,
		224,
		-1,
		-1,
		332,
		288,
		274,
		-1,
		226,
		224,
		212,
		202,
		192,
		197,
		198,
		188,
		186,
		182,
		191,
		190,
		183,
		182,
		203,
		196,
		218,
		-1,
		-1,
		216,
		229,
		231,
		217,
		220,
		-1,
		-1,
		-1,
		278,
		279,
		245,
		224,
		213,
		-1,
		-1,
		196,
		189,
		183,
		186,
		174,
		194,
		201,
		189,
		176,
		191,
		201,
		209,
		208,
		-1,
		219,
		206,
		-1,
		-1,
		219,
		209,
		-1,
		-1,
		-1,
		-1,
		257,
		202,
		191,
		186,
		190,
		195,
		-1,
		169,
		180,
		173,
		192,
		199,
		191,
		176,
		170,
		181,
		196,
		213,
		-1,
		-1,
		233,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		214,
		208,
		179,
		172,
		176,
		-1,
		171,
		173,
		170,
		182,
		187,
		191,
		182,
		164,
		178,
		181,
		194,
		208,
		212,
		256,
		-1,
		186,
		-1,
		-1,
		-1,
		225,
		226,
		212,
		189,
		168,
		161,
		158,
		157,
		162,
		173,
		182,
		193,
		158,
		162,
		177,
		182,
		186,
		203,
		207,
		-1,
		-1,
		184,
		180,
		215,
		227,
		199,
		239,
		-1,
		-1,
		157,
		150,
		160,
		153,
		166,
		169,
		154,
		156,
		174,
		187,
		181,
		191,
		206,
		201,
		-1,
		-1,
		-1,
		182,
		-1,
		198,
		-1,
		-1,
		189,
		230,
		177,
		159,
		155,
		141,
		148,
		142,
		144,
		149,
		168,
		163,
		172,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		148,
		167,
		162,
		168,
		173,
		164,
		192,
		189,
		-1,
		138,
		171,
		139,
		153,
		149,
		156,
		161,
		167,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		165,
		154,
		143,
		149,
		-1,
		141,
		164,
		154,
		144,
		150,
		-1,
		-1,
		156,
		153,
		151,
		131,
		137,
		142,
		145,
		183,
		159,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		119,
		156,
		149,
		117,
		125,
		156,
		-1,
		131,
		123,
		151,
		136,
		144,
		-1,
		-1,
		129,
		120,
		125,
		134,
		135,
		166,
		165,
		178,
		181,
		186,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		112,
		132,
		111,
		114,
		138,
		152,
		-1,
		122,
		-1,
		-1,
		167,
		154,
		138,
		128,
		125,
		172,
		148,
		143,
		149,
		151,
		175,
		166,
		191,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		101,
		112,
		105,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		183,
		-1,
		165,
		-1,
		148,
		152,
		156,
		159,
		174,
		161,
		168,
		185,
		191,
		180,
		190,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		48,
		82,
		85,
		96,
		107,
		122,
		126,
		-1,
		106,
		142,
		152,
		-1,
		192,
		-1,
		-1,
		-1,
		162,
		169,
		161,
		177,
		173,
		173,
		169,
		173,
		185,
		192,
		202,
		204,
		196,
		200,
		213,
		224,
		227,
		44,
		0,
		126,
		71,
		71,
		92,
		101,
		122,
		102,
		99,
		136,
		141,
		156,
		161,
		185,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		180,
		190,
		173,
		175,
		179,
		193,
		205,
		213,
		203,
		201,
		195,
		227,
		-1,
		78,
		72,
		66,
		63,
		39,
		48,
		62,
		89,
		-1,
		-1,
		100,
		127,
		111,
		115,
		131,
		156,
		-1,
		192,
		-1,
		-1,
		206,
		-1,
		-1,
		232,
		195,
		184,
		175,
		181,
		187,
		198,
		220,
		209,
		210,
		200,
		210,
		223,
		62,
		59,
		47,
		45,
		63,
		70,
		58,
		-1,
		87,
		85,
		91,
		98,
		115,
		145,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		225,
		228,
		217,
		-1,
		207,
		180,
		185,
		210,
		217,
		218,
		212,
		206,
		213,
		212,
		220,
		228,
		71,
		85,
		74,
		65,
		64,
		71,
		63,
		72,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		237,
		218,
		-1,
		-1,
		225,
		218,
		206,
		194,
		184,
		194,
		202,
		202,
		205,
		209,
		204,
		215,
		207,
		211,
		228,
		-1,
		100,
		-1,
		94,
		86,
		100,
		115,
		123,
		-1,
		-1,
		-1,
		254,
		240,
		233,
		221,
		219,
		-1,
		259,
		243,
		224,
		-1,
		194,
		207,
		238,
		206,
		211,
		206,
		210,
		221,
		210,
		213,
		227,
		222,
		-1,
		-1,
		98,
		101,
		-1,
		-1,
		123,
		142,
		-1,
		245,
		234,
		219,
		211,
		-1,
		-1,
		231,
		227,
		-1,
		-1,
		195,
		220,
		209,
		217,
		212,
		214,
		220,
		223,
		212,
		216,
		228,
		-1,
		-1,
		105,
		106,
		111,
		-1,
		132,
		-1,
		247,
		-1,
		214,
		221,
		209,
		-1,
		-1,
		-1,
		233,
		196,
		217,
		227,
		232,
		230,
		221,
		218,
		225,
		223,
		219,
		230,
		-1,
		-1,
		-1,
		162,
		139,
		254,
		245,
		228,
		208,
		200,
		220,
		-1,
		221,
		-1,
		196,
		197,
		224,
		226,
		243,
		237,
		221,
		236,
		226,
		217,
		226,
		168,
		-1,
		143,
		202,
		185,
		214,
		180,
		192,
		242,
		-1,
		218,
		200,
		-1,
		228,
		218,
		260,
		241,
		234,
		221,
		228,
		230,
		223,
		-1,
		-1,
		-1,
		158,
		157,
		156,
		167,
		175,
		173,
		191,
		-1,
		230,
		212,
		191,
		208,
		208,
		199,
		207,
		250,
		246,
		239,
		241,
		231,
		-1,
		172,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		184,
		206,
		201,
		193,
		205,
		209,
		195,
		201,
		203,
		211,
		209,
		206,
		218,
		214,
		234,
		230,
		262,
		-1,
		179,
		-1,
		188,
		-1,
		-1,
		202,
		188,
		200,
		211,
		201,
		201,
		206,
		199,
		221,
		237,
		221,
		219,
		224,
		229,
		-1,
		189,
		190,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		247,
		208,
		-1,
		228,
		208,
		-1,
		230,
		226,
		-1,
		-1,
		201,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		242,
		226,
		-1,
		219,
		219,
		-1,
		-1,
		-1,
		215,
		238,
		-1,
		215,
		218,
		-1,
		209,
		215,
		244,
		221,
		225,
		-1,
		-1,
		-1,
		242,
		226,
		231,
		230,
		235,
		223,
		240,
		226,
		228,
		235,
		224,
		245,
		-1,
		-1,
		-1,
		243,
		235,
		235,
		-1,
		-1,
		253,
		236,
		236,
		244,
		-1,
		-1,
		-1,
		265,
		246,
		-1,
		-1,
		244,
		-1,
		-1,
		249,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		254,
		-1,
		-1,
		-1,
		245,
		252,
		260,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		277,
		275,
		-1,
		-1,
		-1,
		259,
		254,
		-1,
		-1,
		230,
		231,
		-1,
		-1,
		-1,
		287,
		271,
		-1,
		258,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		292,
		-1,
		293,
		268,
		275,
		-1,
		-1,
		-1,
		-1,
		305,
		297,
		306,
		-1,
		278,
		280,
		-1,
		328,
		-1,
		-1,
		320,
		311,
		-1,
		-1,
		283,
		290,
		312,
		315,
		314,
		-1,
		302
	],
	[
		-1,
		337,
		326,
		337,
		345,
		318,
		325,
		-1,
		346,
		348,
		314,
		308,
		347,
		318,
		324,
		335,
		-1,
		-1,
		-1,
		337,
		336,
		306,
		304,
		313,
		318,
		325,
		-1,
		328,
		-1,
		358,
		337,
		348,
		353,
		299,
		296,
		316,
		335,
		321,
		313,
		373,
		329,
		300,
		294,
		312,
		306,
		315,
		307,
		-1,
		300,
		290,
		312,
		295,
		306,
		298,
		-1,
		-1,
		294,
		295,
		301,
		291,
		297,
		293,
		-1,
		303,
		287,
		-1,
		-1,
		284,
		289,
		273,
		276,
		284,
		282,
		295,
		287,
		282,
		-1,
		-1,
		279,
		275,
		282,
		269,
		265,
		282,
		295,
		277,
		291,
		290,
		-1,
		273,
		291,
		300,
		276,
		274,
		258,
		256,
		274,
		276,
		282,
		282,
		-1,
		265,
		267,
		290,
		298,
		298,
		274,
		261,
		261,
		271,
		264,
		283,
		271,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		262,
		270,
		294,
		286,
		276,
		291,
		284,
		264,
		261,
		259,
		256,
		272,
		270,
		280,
		-1,
		-1,
		318,
		287,
		322,
		279,
		264,
		-1,
		258,
		270,
		276,
		280,
		274,
		267,
		281,
		277,
		-1,
		250,
		249,
		277,
		263,
		274,
		278,
		-1,
		-1,
		276,
		268,
		253,
		256,
		253,
		253,
		283,
		282,
		276,
		262,
		258,
		264,
		267,
		267,
		273,
		244,
		254,
		258,
		256,
		281,
		-1,
		-1,
		316,
		-1,
		-1,
		275,
		258,
		-1,
		241,
		248,
		248,
		265,
		255,
		276,
		291,
		286,
		278,
		272,
		260,
		262,
		259,
		272,
		260,
		241,
		266,
		270,
		251,
		272,
		267,
		-1,
		315,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		234,
		237,
		243,
		267,
		277,
		-1,
		298,
		295,
		296,
		281,
		278,
		265,
		253,
		266,
		251,
		258,
		257,
		245,
		243,
		273,
		248,
		270,
		267,
		286,
		291,
		285,
		294,
		-1,
		283,
		279,
		275,
		282,
		231,
		-1,
		-1,
		271,
		-1,
		285,
		298,
		305,
		292,
		295,
		282,
		273,
		260,
		249,
		260,
		249,
		246,
		254,
		237,
		252,
		243,
		242,
		260,
		270,
		278,
		282,
		288,
		-1,
		333,
		-1,
		275,
		259,
		261,
		233,
		254,
		-1,
		291,
		286,
		306,
		307,
		298,
		-1,
		291,
		288,
		278,
		256,
		241,
		258,
		250,
		248,
		250,
		232,
		246,
		237,
		255,
		262,
		260,
		264,
		284,
		296,
		293,
		283,
		-1,
		265,
		270,
		229,
		237,
		256,
		329,
		304,
		-1,
		299,
		-1,
		291,
		306,
		-1,
		262,
		258,
		240,
		241,
		236,
		251,
		243,
		228,
		225,
		243,
		246,
		253,
		257,
		273,
		-1,
		-1,
		278,
		282,
		271,
		222,
		241,
		265,
		302,
		297,
		286,
		285,
		-1,
		276,
		276,
		273,
		261,
		248,
		233,
		234,
		242,
		254,
		233,
		227,
		224,
		244,
		270,
		248,
		259,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		248,
		219,
		243,
		285,
		315,
		308,
		296,
		261,
		261,
		255,
		-1,
		272,
		251,
		242,
		231,
		229,
		242,
		234,
		242,
		222,
		220,
		239,
		251,
		242,
		250,
		-1,
		-1,
		-1,
		278,
		267,
		268,
		217,
		240,
		274,
		294,
		280,
		285,
		260,
		253,
		247,
		285,
		268,
		249,
		238,
		230,
		219,
		230,
		238,
		236,
		218,
		227,
		233,
		257,
		238,
		244,
		-1,
		-1,
		285,
		275,
		259,
		261,
		258,
		231,
		238,
		270,
		285,
		282,
		-1,
		252,
		-1,
		241,
		249,
		243,
		238,
		235,
		222,
		221,
		235,
		235,
		225,
		220,
		227,
		262,
		262,
		228,
		248,
		251,
		-1,
		-1,
		-1,
		278,
		276,
		251,
		228,
		212,
		248,
		-1,
		252,
		253,
		-1,
		246,
		240,
		246,
		245,
		241,
		226,
		230,
		232,
		235,
		223,
		229,
		230,
		212,
		236,
		-1,
		236,
		230,
		238,
		228,
		216,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		237,
		230,
		-1,
		233,
		233,
		238,
		233,
		229,
		231,
		228,
		217,
		230,
		223,
		217,
		211,
		224,
		228,
		229,
		218,
		214,
		211,
		225,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		240,
		232,
		228,
		222,
		228,
		246,
		244,
		257,
		241,
		243,
		239,
		231,
		226,
		212,
		205,
		216,
		201,
		219,
		225,
		216,
		211,
		210,
		221,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		218,
		234,
		-1,
		262,
		241,
		264,
		242,
		256,
		250,
		248,
		249,
		219,
		224,
		226,
		214,
		217,
		206,
		209,
		201,
		223,
		220,
		204,
		206,
		215,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		210,
		221,
		-1,
		-1,
		306,
		-1,
		240,
		257,
		264,
		262,
		238,
		213,
		220,
		238,
		211,
		206,
		211,
		200,
		200,
		195,
		214,
		200,
		198,
		213,
		229,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		238,
		-1,
		284,
		274,
		258,
		243,
		276,
		-1,
		212,
		208,
		215,
		-1,
		231,
		-1,
		203,
		206,
		197,
		192,
		189,
		200,
		198,
		207,
		208,
		-1,
		250,
		235,
		228,
		218,
		232,
		203,
		-1,
		246,
		-1,
		-1,
		271,
		265,
		265,
		238,
		235,
		228,
		208,
		200,
		215,
		214,
		201,
		200,
		188,
		188,
		191,
		185,
		198,
		208,
		214,
		206,
		-1,
		-1,
		-1,
		255,
		207,
		215,
		191,
		212,
		-1,
		-1,
		333,
		288,
		274,
		-1,
		230,
		228,
		216,
		206,
		196,
		201,
		202,
		192,
		190,
		186,
		195,
		194,
		187,
		186,
		207,
		200,
		222,
		-1,
		-1,
		204,
		217,
		219,
		205,
		224,
		-1,
		-1,
		-1,
		280,
		283,
		249,
		228,
		217,
		-1,
		-1,
		200,
		193,
		187,
		190,
		178,
		198,
		205,
		193,
		180,
		195,
		205,
		213,
		212,
		-1,
		207,
		194,
		-1,
		-1,
		223,
		213,
		-1,
		-1,
		-1,
		-1,
		261,
		206,
		195,
		190,
		194,
		199,
		-1,
		173,
		184,
		177,
		196,
		203,
		195,
		180,
		174,
		185,
		200,
		217,
		-1,
		-1,
		237,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		218,
		212,
		183,
		176,
		180,
		-1,
		175,
		177,
		174,
		186,
		191,
		195,
		186,
		168,
		182,
		185,
		198,
		212,
		216,
		260,
		-1,
		190,
		-1,
		-1,
		-1,
		229,
		230,
		216,
		193,
		172,
		165,
		162,
		161,
		166,
		177,
		186,
		197,
		162,
		166,
		181,
		186,
		190,
		207,
		211,
		-1,
		-1,
		188,
		184,
		219,
		231,
		203,
		243,
		-1,
		-1,
		161,
		154,
		164,
		157,
		170,
		173,
		158,
		160,
		178,
		191,
		185,
		195,
		210,
		205,
		-1,
		-1,
		-1,
		186,
		-1,
		202,
		-1,
		-1,
		193,
		234,
		181,
		163,
		159,
		145,
		152,
		146,
		148,
		153,
		172,
		167,
		176,
		181,
		185,
		208,
		197,
		236,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		152,
		171,
		166,
		172,
		177,
		168,
		196,
		193,
		-1,
		142,
		175,
		143,
		157,
		153,
		160,
		165,
		171,
		175,
		182,
		198,
		197,
		192,
		228,
		219,
		225,
		-1,
		-1,
		153,
		142,
		131,
		137,
		-1,
		145,
		168,
		158,
		148,
		154,
		-1,
		-1,
		160,
		157,
		155,
		135,
		141,
		146,
		149,
		187,
		163,
		171,
		175,
		179,
		185,
		190,
		195,
		201,
		216,
		231,
		-1,
		107,
		144,
		137,
		105,
		113,
		144,
		-1,
		135,
		127,
		155,
		140,
		148,
		-1,
		-1,
		133,
		124,
		129,
		138,
		139,
		170,
		169,
		182,
		185,
		190,
		178,
		177,
		195,
		199,
		208,
		215,
		205,
		218,
		222,
		-1,
		100,
		120,
		99,
		102,
		126,
		140,
		-1,
		126,
		-1,
		-1,
		171,
		158,
		142,
		132,
		129,
		176,
		152,
		147,
		153,
		155,
		179,
		170,
		195,
		186,
		186,
		189,
		204,
		209,
		201,
		215,
		215,
		216,
		-1,
		89,
		100,
		93,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		187,
		-1,
		169,
		-1,
		152,
		156,
		160,
		163,
		178,
		165,
		172,
		189,
		195,
		184,
		194,
		190,
		191,
		200,
		211,
		223,
		222,
		223,
		115,
		54,
		73,
		84,
		95,
		110,
		114,
		-1,
		110,
		146,
		156,
		-1,
		196,
		-1,
		-1,
		-1,
		166,
		173,
		165,
		181,
		177,
		177,
		173,
		177,
		189,
		196,
		206,
		208,
		200,
		204,
		217,
		228,
		231,
		111,
		109,
		0,
		44,
		59,
		80,
		89,
		110,
		106,
		103,
		140,
		145,
		160,
		165,
		189,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		184,
		194,
		177,
		179,
		183,
		197,
		209,
		217,
		207,
		205,
		199,
		231,
		-1,
		111,
		110,
		99,
		96,
		72,
		63,
		50,
		77,
		-1,
		-1,
		104,
		131,
		115,
		119,
		135,
		160,
		-1,
		196,
		-1,
		-1,
		210,
		-1,
		-1,
		236,
		199,
		188,
		179,
		185,
		191,
		202,
		224,
		213,
		214,
		204,
		214,
		227,
		95,
		92,
		80,
		78,
		101,
		58,
		54,
		-1,
		86,
		89,
		95,
		102,
		119,
		149,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		229,
		232,
		221,
		-1,
		211,
		184,
		189,
		214,
		221,
		222,
		216,
		210,
		217,
		216,
		224,
		232,
		104,
		118,
		107,
		103,
		102,
		110,
		59,
		76,
		83,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		222,
		-1,
		-1,
		229,
		222,
		210,
		198,
		188,
		198,
		206,
		206,
		209,
		213,
		208,
		219,
		211,
		215,
		232,
		-1,
		138,
		-1,
		90,
		83,
		98,
		113,
		121,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		263,
		247,
		228,
		-1,
		198,
		211,
		242,
		210,
		215,
		210,
		214,
		225,
		214,
		217,
		231,
		226,
		-1,
		-1,
		96,
		99,
		-1,
		-1,
		121,
		140,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		235,
		231,
		-1,
		-1,
		199,
		224,
		213,
		221,
		216,
		218,
		224,
		227,
		216,
		220,
		232,
		-1,
		-1,
		103,
		104,
		109,
		-1,
		130,
		-1,
		245,
		-1,
		212,
		219,
		207,
		-1,
		-1,
		-1,
		237,
		200,
		221,
		231,
		236,
		234,
		225,
		222,
		229,
		227,
		223,
		234,
		-1,
		-1,
		-1,
		160,
		137,
		252,
		243,
		226,
		206,
		198,
		218,
		-1,
		225,
		-1,
		200,
		201,
		228,
		230,
		247,
		241,
		225,
		240,
		230,
		221,
		230,
		166,
		-1,
		141,
		200,
		183,
		212,
		178,
		190,
		246,
		-1,
		222,
		204,
		-1,
		232,
		222,
		264,
		245,
		238,
		225,
		232,
		234,
		227,
		-1,
		-1,
		-1,
		156,
		155,
		154,
		165,
		173,
		171,
		189,
		-1,
		234,
		216,
		195,
		212,
		212,
		203,
		211,
		254,
		250,
		243,
		245,
		235,
		-1,
		210,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		182,
		204,
		199,
		191,
		203,
		212,
		199,
		205,
		207,
		215,
		213,
		210,
		222,
		218,
		238,
		234,
		266,
		-1,
		217,
		-1,
		186,
		-1,
		-1,
		200,
		186,
		198,
		209,
		199,
		199,
		204,
		202,
		224,
		241,
		225,
		223,
		228,
		233,
		-1,
		227,
		228,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		245,
		206,
		-1,
		231,
		211,
		-1,
		234,
		230,
		-1,
		-1,
		239,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		240,
		224,
		-1,
		222,
		222,
		-1,
		-1,
		-1,
		253,
		244,
		-1,
		213,
		216,
		-1,
		207,
		213,
		242,
		224,
		228,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		228,
		233,
		221,
		238,
		224,
		226,
		238,
		227,
		248,
		-1,
		-1,
		-1,
		241,
		233,
		233,
		-1,
		-1,
		251,
		234,
		234,
		247,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		242,
		-1,
		-1,
		247,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		252,
		-1,
		-1,
		-1,
		243,
		250,
		258,
		-1,
		-1,
		-1,
		-1,
		270,
		271,
		298,
		273,
		-1,
		-1,
		-1,
		257,
		257,
		-1,
		-1,
		268,
		269,
		-1,
		-1,
		-1,
		285,
		269,
		-1,
		261,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		294,
		-1,
		-1,
		-1,
		290,
		-1,
		296,
		271,
		278,
		-1,
		-1,
		-1,
		-1,
		303,
		295,
		309,
		-1,
		281,
		283,
		-1,
		331,
		-1,
		-1,
		318,
		309,
		-1,
		-1,
		286,
		293,
		315,
		318,
		348,
		-1,
		305
	],
	[
		-1,
		293,
		282,
		293,
		301,
		274,
		281,
		-1,
		302,
		304,
		270,
		264,
		303,
		274,
		280,
		291,
		-1,
		-1,
		-1,
		293,
		292,
		262,
		260,
		269,
		274,
		281,
		-1,
		284,
		-1,
		314,
		293,
		304,
		309,
		255,
		252,
		272,
		291,
		277,
		269,
		329,
		285,
		256,
		250,
		268,
		262,
		271,
		263,
		-1,
		256,
		246,
		268,
		251,
		262,
		254,
		-1,
		-1,
		250,
		251,
		257,
		247,
		253,
		249,
		-1,
		259,
		243,
		-1,
		-1,
		240,
		245,
		229,
		232,
		240,
		238,
		251,
		243,
		238,
		-1,
		-1,
		235,
		231,
		238,
		225,
		221,
		238,
		251,
		233,
		247,
		246,
		-1,
		229,
		247,
		256,
		232,
		230,
		214,
		212,
		230,
		232,
		238,
		238,
		-1,
		221,
		223,
		246,
		254,
		254,
		230,
		217,
		217,
		227,
		220,
		239,
		227,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		218,
		226,
		250,
		242,
		232,
		247,
		240,
		220,
		217,
		215,
		212,
		228,
		226,
		236,
		-1,
		-1,
		274,
		243,
		278,
		235,
		220,
		-1,
		214,
		226,
		232,
		236,
		230,
		223,
		237,
		233,
		-1,
		206,
		205,
		233,
		219,
		230,
		234,
		-1,
		-1,
		232,
		224,
		209,
		212,
		209,
		209,
		239,
		238,
		232,
		218,
		214,
		220,
		223,
		223,
		229,
		200,
		210,
		214,
		212,
		237,
		-1,
		-1,
		272,
		-1,
		-1,
		231,
		214,
		-1,
		197,
		204,
		204,
		221,
		211,
		232,
		247,
		242,
		234,
		228,
		216,
		218,
		215,
		228,
		216,
		197,
		222,
		226,
		207,
		228,
		223,
		-1,
		271,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		190,
		193,
		199,
		223,
		233,
		-1,
		254,
		251,
		252,
		237,
		234,
		221,
		209,
		222,
		207,
		214,
		213,
		201,
		199,
		229,
		204,
		226,
		223,
		242,
		247,
		241,
		250,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		227,
		-1,
		241,
		254,
		261,
		248,
		251,
		238,
		229,
		216,
		205,
		216,
		205,
		202,
		210,
		193,
		208,
		199,
		198,
		216,
		226,
		234,
		238,
		244,
		-1,
		289,
		-1,
		231,
		215,
		217,
		189,
		210,
		-1,
		247,
		242,
		262,
		263,
		254,
		-1,
		247,
		244,
		234,
		212,
		197,
		214,
		206,
		204,
		206,
		188,
		202,
		193,
		211,
		218,
		216,
		220,
		240,
		252,
		249,
		239,
		-1,
		221,
		226,
		185,
		193,
		212,
		285,
		260,
		-1,
		255,
		-1,
		247,
		262,
		-1,
		218,
		214,
		196,
		197,
		192,
		207,
		199,
		184,
		181,
		199,
		202,
		209,
		213,
		229,
		-1,
		-1,
		234,
		238,
		227,
		178,
		197,
		221,
		258,
		253,
		242,
		241,
		-1,
		232,
		232,
		229,
		217,
		204,
		189,
		190,
		198,
		210,
		189,
		183,
		180,
		200,
		226,
		204,
		215,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		204,
		175,
		199,
		241,
		271,
		264,
		252,
		217,
		217,
		211,
		-1,
		228,
		207,
		198,
		187,
		185,
		198,
		190,
		198,
		178,
		176,
		195,
		207,
		198,
		206,
		-1,
		-1,
		-1,
		234,
		223,
		224,
		173,
		196,
		230,
		250,
		236,
		241,
		216,
		209,
		203,
		241,
		224,
		205,
		194,
		186,
		175,
		186,
		194,
		192,
		174,
		183,
		189,
		213,
		194,
		200,
		-1,
		-1,
		241,
		231,
		215,
		217,
		214,
		187,
		194,
		226,
		241,
		238,
		-1,
		208,
		-1,
		197,
		205,
		199,
		194,
		191,
		178,
		177,
		191,
		191,
		181,
		176,
		183,
		218,
		218,
		184,
		204,
		207,
		-1,
		-1,
		-1,
		234,
		232,
		207,
		184,
		168,
		204,
		-1,
		208,
		209,
		-1,
		202,
		196,
		202,
		201,
		197,
		182,
		186,
		188,
		191,
		179,
		185,
		186,
		168,
		192,
		-1,
		192,
		186,
		194,
		184,
		172,
		-1,
		-1,
		-1,
		230,
		209,
		202,
		222,
		163,
		215,
		-1,
		-1,
		193,
		186,
		-1,
		189,
		189,
		194,
		189,
		185,
		187,
		184,
		173,
		186,
		179,
		173,
		167,
		180,
		184,
		185,
		174,
		170,
		167,
		181,
		-1,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		183,
		-1,
		196,
		188,
		184,
		178,
		184,
		202,
		200,
		213,
		197,
		199,
		195,
		187,
		182,
		168,
		161,
		172,
		157,
		175,
		181,
		172,
		167,
		166,
		177,
		-1,
		250,
		236,
		207,
		-1,
		-1,
		196,
		-1,
		160,
		174,
		190,
		-1,
		218,
		197,
		220,
		198,
		212,
		206,
		204,
		205,
		175,
		180,
		182,
		170,
		173,
		162,
		165,
		157,
		179,
		176,
		160,
		162,
		171,
		-1,
		256,
		243,
		201,
		197,
		186,
		206,
		157,
		166,
		177,
		-1,
		-1,
		262,
		-1,
		196,
		213,
		220,
		218,
		194,
		169,
		176,
		194,
		167,
		162,
		167,
		156,
		156,
		151,
		170,
		156,
		154,
		169,
		185,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		172,
		159,
		153,
		-1,
		194,
		-1,
		240,
		230,
		214,
		199,
		232,
		-1,
		168,
		164,
		171,
		-1,
		187,
		-1,
		159,
		162,
		153,
		148,
		145,
		156,
		154,
		163,
		164,
		-1,
		206,
		191,
		184,
		174,
		188,
		159,
		-1,
		202,
		-1,
		-1,
		227,
		221,
		221,
		194,
		191,
		184,
		164,
		156,
		171,
		170,
		157,
		156,
		144,
		144,
		147,
		141,
		154,
		164,
		170,
		162,
		-1,
		-1,
		-1,
		211,
		163,
		171,
		147,
		168,
		-1,
		-1,
		289,
		244,
		230,
		-1,
		186,
		184,
		172,
		162,
		152,
		157,
		158,
		148,
		146,
		142,
		151,
		150,
		143,
		142,
		163,
		156,
		178,
		-1,
		-1,
		160,
		173,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		236,
		239,
		205,
		184,
		173,
		-1,
		-1,
		156,
		149,
		143,
		146,
		134,
		154,
		161,
		149,
		136,
		151,
		161,
		169,
		168,
		-1,
		163,
		150,
		-1,
		-1,
		179,
		169,
		-1,
		-1,
		-1,
		-1,
		217,
		162,
		151,
		146,
		150,
		155,
		-1,
		129,
		140,
		133,
		152,
		159,
		151,
		136,
		130,
		141,
		156,
		173,
		-1,
		-1,
		193,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		174,
		168,
		139,
		132,
		136,
		-1,
		131,
		133,
		130,
		142,
		147,
		151,
		142,
		124,
		138,
		141,
		154,
		168,
		172,
		216,
		-1,
		146,
		-1,
		-1,
		-1,
		185,
		186,
		172,
		149,
		128,
		121,
		118,
		117,
		122,
		133,
		142,
		153,
		118,
		122,
		137,
		142,
		146,
		163,
		167,
		-1,
		-1,
		144,
		140,
		175,
		187,
		159,
		199,
		-1,
		-1,
		117,
		110,
		120,
		113,
		126,
		129,
		114,
		116,
		134,
		147,
		141,
		151,
		166,
		161,
		-1,
		-1,
		-1,
		142,
		-1,
		158,
		-1,
		-1,
		149,
		190,
		137,
		119,
		115,
		101,
		108,
		102,
		104,
		109,
		128,
		123,
		132,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		116,
		-1,
		-1,
		-1,
		108,
		127,
		122,
		128,
		133,
		124,
		152,
		149,
		-1,
		98,
		131,
		99,
		113,
		109,
		116,
		121,
		127,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		109,
		98,
		87,
		93,
		-1,
		101,
		124,
		114,
		104,
		110,
		-1,
		-1,
		116,
		113,
		111,
		91,
		97,
		102,
		105,
		143,
		119,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		63,
		100,
		93,
		61,
		69,
		100,
		-1,
		91,
		83,
		111,
		96,
		104,
		-1,
		-1,
		89,
		80,
		85,
		94,
		95,
		126,
		125,
		138,
		141,
		146,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		56,
		76,
		55,
		58,
		82,
		96,
		-1,
		82,
		-1,
		-1,
		127,
		114,
		98,
		88,
		85,
		132,
		108,
		103,
		109,
		111,
		135,
		126,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		45,
		56,
		49,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		143,
		-1,
		125,
		-1,
		108,
		112,
		116,
		119,
		134,
		121,
		128,
		145,
		151,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		71,
		11,
		29,
		40,
		51,
		66,
		70,
		-1,
		66,
		102,
		112,
		-1,
		152,
		-1,
		-1,
		-1,
		122,
		129,
		121,
		137,
		133,
		133,
		129,
		133,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		67,
		65,
		55,
		0,
		15,
		36,
		45,
		66,
		62,
		59,
		96,
		101,
		116,
		121,
		145,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		140,
		150,
		133,
		135,
		139,
		153,
		165,
		173,
		163,
		161,
		155,
		187,
		-1,
		67,
		66,
		55,
		52,
		28,
		19,
		6,
		33,
		-1,
		-1,
		60,
		87,
		71,
		75,
		91,
		116,
		-1,
		152,
		-1,
		-1,
		166,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		147,
		158,
		180,
		169,
		170,
		160,
		170,
		183,
		51,
		48,
		36,
		34,
		57,
		14,
		10,
		-1,
		42,
		45,
		51,
		58,
		75,
		105,
		-1,
		-1,
		168,
		159,
		-1,
		-1,
		185,
		188,
		177,
		-1,
		167,
		140,
		145,
		170,
		177,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		60,
		74,
		63,
		59,
		58,
		66,
		15,
		32,
		39,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		191,
		178,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		162,
		162,
		165,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		94,
		-1,
		46,
		39,
		54,
		69,
		77,
		-1,
		-1,
		-1,
		208,
		194,
		187,
		175,
		173,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		52,
		55,
		-1,
		-1,
		77,
		96,
		-1,
		199,
		188,
		173,
		165,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		59,
		60,
		65,
		-1,
		86,
		-1,
		201,
		-1,
		168,
		175,
		163,
		-1,
		-1,
		-1,
		193,
		156,
		177,
		187,
		192,
		190,
		181,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		116,
		93,
		208,
		199,
		182,
		162,
		154,
		174,
		-1,
		181,
		-1,
		156,
		157,
		184,
		186,
		203,
		197,
		181,
		196,
		186,
		177,
		186,
		122,
		-1,
		97,
		156,
		139,
		168,
		134,
		146,
		202,
		-1,
		178,
		160,
		-1,
		188,
		178,
		220,
		201,
		194,
		181,
		188,
		190,
		183,
		-1,
		-1,
		-1,
		112,
		111,
		110,
		121,
		129,
		127,
		145,
		-1,
		190,
		172,
		151,
		168,
		168,
		159,
		167,
		210,
		206,
		199,
		201,
		191,
		-1,
		166,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		138,
		160,
		155,
		147,
		159,
		168,
		155,
		161,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		190,
		222,
		-1,
		173,
		-1,
		142,
		-1,
		-1,
		156,
		142,
		154,
		165,
		155,
		155,
		160,
		158,
		180,
		197,
		181,
		179,
		184,
		189,
		-1,
		183,
		184,
		-1,
		175,
		167,
		153,
		-1,
		146,
		-1,
		201,
		162,
		-1,
		187,
		167,
		-1,
		190,
		186,
		-1,
		-1,
		195,
		191,
		-1,
		-1,
		-1,
		176,
		156,
		196,
		180,
		-1,
		178,
		178,
		-1,
		-1,
		-1,
		209,
		200,
		-1,
		169,
		172,
		-1,
		163,
		169,
		198,
		180,
		184,
		-1,
		-1,
		-1,
		225,
		206,
		200,
		184,
		189,
		177,
		194,
		180,
		182,
		194,
		183,
		204,
		-1,
		-1,
		-1,
		197,
		189,
		189,
		-1,
		-1,
		207,
		190,
		190,
		203,
		-1,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		198,
		-1,
		-1,
		203,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		208,
		-1,
		-1,
		-1,
		199,
		206,
		214,
		-1,
		-1,
		-1,
		-1,
		226,
		227,
		254,
		229,
		-1,
		-1,
		-1,
		213,
		213,
		-1,
		-1,
		224,
		225,
		-1,
		-1,
		-1,
		241,
		225,
		-1,
		217,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		246,
		-1,
		252,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		259,
		251,
		265,
		-1,
		237,
		239,
		-1,
		287,
		-1,
		-1,
		274,
		265,
		-1,
		-1,
		242,
		249,
		271,
		274,
		304,
		-1,
		261
	],
	[
		-1,
		278,
		267,
		278,
		286,
		259,
		266,
		-1,
		287,
		289,
		255,
		249,
		288,
		259,
		265,
		276,
		-1,
		-1,
		-1,
		278,
		277,
		247,
		245,
		254,
		259,
		266,
		-1,
		286,
		-1,
		299,
		278,
		289,
		294,
		240,
		237,
		257,
		276,
		279,
		271,
		314,
		270,
		241,
		235,
		253,
		258,
		273,
		265,
		-1,
		241,
		231,
		253,
		253,
		264,
		252,
		-1,
		-1,
		235,
		236,
		242,
		249,
		255,
		251,
		-1,
		261,
		245,
		-1,
		-1,
		225,
		238,
		231,
		234,
		242,
		240,
		253,
		245,
		240,
		-1,
		-1,
		226,
		230,
		240,
		227,
		223,
		240,
		253,
		235,
		249,
		248,
		-1,
		214,
		232,
		241,
		234,
		232,
		216,
		214,
		232,
		234,
		240,
		240,
		-1,
		206,
		208,
		237,
		243,
		255,
		232,
		219,
		219,
		229,
		222,
		241,
		229,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		203,
		211,
		237,
		236,
		232,
		249,
		242,
		222,
		219,
		217,
		214,
		230,
		228,
		238,
		-1,
		-1,
		259,
		228,
		263,
		220,
		205,
		-1,
		199,
		218,
		224,
		228,
		232,
		225,
		239,
		235,
		-1,
		208,
		207,
		235,
		221,
		232,
		219,
		-1,
		-1,
		217,
		209,
		194,
		197,
		194,
		194,
		224,
		223,
		228,
		220,
		216,
		222,
		225,
		225,
		231,
		202,
		212,
		216,
		214,
		239,
		-1,
		-1,
		274,
		-1,
		-1,
		216,
		199,
		-1,
		182,
		189,
		189,
		206,
		196,
		217,
		232,
		236,
		236,
		230,
		218,
		220,
		217,
		230,
		218,
		199,
		224,
		228,
		209,
		230,
		225,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		175,
		178,
		184,
		208,
		218,
		-1,
		239,
		237,
		254,
		239,
		236,
		223,
		211,
		224,
		209,
		216,
		215,
		203,
		201,
		231,
		206,
		228,
		225,
		244,
		249,
		243,
		252,
		-1,
		224,
		220,
		216,
		223,
		172,
		-1,
		-1,
		212,
		-1,
		226,
		239,
		246,
		241,
		244,
		240,
		231,
		218,
		207,
		218,
		207,
		204,
		212,
		195,
		210,
		201,
		200,
		218,
		228,
		236,
		240,
		246,
		-1,
		274,
		-1,
		216,
		200,
		202,
		174,
		195,
		-1,
		232,
		227,
		247,
		248,
		239,
		-1,
		242,
		245,
		236,
		214,
		199,
		216,
		208,
		206,
		208,
		190,
		204,
		195,
		213,
		220,
		218,
		222,
		242,
		254,
		234,
		224,
		-1,
		206,
		211,
		170,
		178,
		197,
		270,
		245,
		-1,
		240,
		-1,
		232,
		257,
		-1,
		220,
		216,
		198,
		199,
		194,
		209,
		201,
		186,
		183,
		201,
		204,
		211,
		215,
		231,
		-1,
		-1,
		219,
		223,
		212,
		163,
		182,
		206,
		243,
		238,
		227,
		226,
		-1,
		217,
		234,
		231,
		219,
		206,
		191,
		192,
		200,
		212,
		191,
		185,
		182,
		202,
		228,
		206,
		217,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		189,
		160,
		184,
		226,
		256,
		249,
		237,
		202,
		202,
		196,
		-1,
		230,
		209,
		200,
		189,
		187,
		200,
		192,
		200,
		180,
		178,
		197,
		209,
		200,
		208,
		-1,
		-1,
		-1,
		219,
		208,
		209,
		158,
		181,
		215,
		235,
		221,
		226,
		201,
		194,
		188,
		240,
		226,
		204,
		196,
		188,
		177,
		188,
		196,
		194,
		176,
		185,
		191,
		215,
		196,
		202,
		-1,
		-1,
		226,
		216,
		200,
		202,
		199,
		172,
		179,
		211,
		226,
		223,
		-1,
		193,
		-1,
		182,
		190,
		189,
		195,
		193,
		180,
		179,
		193,
		193,
		183,
		178,
		185,
		220,
		220,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		219,
		217,
		192,
		169,
		153,
		189,
		-1,
		193,
		194,
		-1,
		187,
		181,
		187,
		186,
		193,
		184,
		188,
		190,
		193,
		181,
		187,
		188,
		170,
		194,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		215,
		194,
		187,
		207,
		148,
		200,
		-1,
		-1,
		178,
		171,
		-1,
		174,
		174,
		181,
		190,
		187,
		189,
		186,
		175,
		188,
		181,
		175,
		169,
		182,
		186,
		187,
		176,
		172,
		169,
		183,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		168,
		-1,
		181,
		173,
		169,
		163,
		169,
		187,
		185,
		205,
		197,
		201,
		197,
		189,
		184,
		170,
		163,
		174,
		159,
		177,
		183,
		174,
		169,
		168,
		179,
		-1,
		235,
		221,
		192,
		-1,
		-1,
		181,
		-1,
		145,
		159,
		175,
		-1,
		203,
		182,
		205,
		183,
		197,
		193,
		206,
		207,
		177,
		182,
		184,
		172,
		175,
		164,
		167,
		159,
		181,
		178,
		162,
		164,
		173,
		-1,
		241,
		228,
		186,
		182,
		171,
		191,
		142,
		151,
		162,
		-1,
		-1,
		247,
		-1,
		181,
		198,
		207,
		205,
		196,
		171,
		178,
		196,
		169,
		164,
		169,
		158,
		158,
		153,
		172,
		158,
		156,
		171,
		187,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		157,
		144,
		138,
		-1,
		179,
		-1,
		225,
		215,
		199,
		184,
		217,
		-1,
		170,
		166,
		173,
		-1,
		189,
		-1,
		161,
		164,
		155,
		150,
		147,
		158,
		156,
		165,
		166,
		-1,
		191,
		176,
		169,
		159,
		173,
		144,
		-1,
		187,
		-1,
		-1,
		212,
		206,
		206,
		190,
		193,
		186,
		166,
		158,
		173,
		172,
		159,
		158,
		146,
		146,
		149,
		143,
		156,
		166,
		172,
		164,
		-1,
		-1,
		-1,
		196,
		148,
		156,
		132,
		153,
		-1,
		-1,
		274,
		229,
		215,
		-1,
		188,
		186,
		174,
		164,
		154,
		159,
		160,
		150,
		148,
		144,
		153,
		152,
		145,
		144,
		165,
		158,
		180,
		-1,
		-1,
		145,
		158,
		160,
		146,
		165,
		-1,
		-1,
		-1,
		221,
		237,
		207,
		186,
		175,
		-1,
		-1,
		158,
		151,
		145,
		148,
		136,
		156,
		163,
		151,
		138,
		153,
		163,
		171,
		170,
		-1,
		148,
		135,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		-1,
		-1,
		219,
		164,
		153,
		148,
		152,
		157,
		-1,
		131,
		142,
		135,
		154,
		161,
		153,
		138,
		132,
		143,
		158,
		175,
		-1,
		-1,
		182,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		176,
		170,
		141,
		134,
		138,
		-1,
		133,
		135,
		132,
		144,
		149,
		153,
		144,
		126,
		140,
		143,
		156,
		170,
		174,
		205,
		-1,
		148,
		-1,
		-1,
		-1,
		187,
		188,
		174,
		151,
		130,
		123,
		120,
		119,
		124,
		135,
		144,
		155,
		120,
		124,
		139,
		144,
		148,
		165,
		169,
		-1,
		-1,
		146,
		142,
		177,
		189,
		161,
		201,
		-1,
		-1,
		119,
		112,
		122,
		115,
		128,
		131,
		116,
		118,
		136,
		149,
		143,
		153,
		168,
		163,
		-1,
		-1,
		-1,
		144,
		-1,
		160,
		-1,
		-1,
		151,
		192,
		139,
		121,
		117,
		103,
		110,
		104,
		106,
		111,
		130,
		125,
		134,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		101,
		-1,
		-1,
		-1,
		110,
		129,
		124,
		130,
		135,
		126,
		154,
		151,
		-1,
		100,
		133,
		101,
		115,
		111,
		118,
		123,
		129,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		94,
		83,
		72,
		78,
		-1,
		103,
		126,
		116,
		106,
		112,
		-1,
		-1,
		118,
		115,
		113,
		93,
		99,
		104,
		107,
		145,
		121,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		48,
		85,
		78,
		46,
		54,
		85,
		-1,
		93,
		85,
		113,
		98,
		106,
		-1,
		-1,
		91,
		82,
		87,
		96,
		97,
		128,
		127,
		140,
		143,
		148,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		41,
		61,
		40,
		43,
		67,
		81,
		-1,
		84,
		-1,
		-1,
		129,
		116,
		100,
		90,
		87,
		134,
		110,
		105,
		111,
		113,
		137,
		128,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		30,
		41,
		34,
		-1,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		145,
		-1,
		127,
		-1,
		110,
		114,
		118,
		121,
		136,
		123,
		130,
		147,
		153,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		73,
		28,
		14,
		25,
		37,
		52,
		56,
		-1,
		68,
		104,
		114,
		-1,
		154,
		-1,
		-1,
		-1,
		124,
		131,
		123,
		139,
		135,
		135,
		131,
		135,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		69,
		67,
		72,
		17,
		0,
		22,
		31,
		52,
		64,
		61,
		98,
		103,
		118,
		123,
		147,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		142,
		152,
		135,
		137,
		141,
		155,
		167,
		175,
		165,
		163,
		157,
		189,
		-1,
		69,
		68,
		57,
		54,
		30,
		21,
		8,
		23,
		-1,
		-1,
		62,
		89,
		73,
		77,
		93,
		118,
		-1,
		154,
		-1,
		-1,
		168,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		149,
		160,
		182,
		171,
		172,
		162,
		172,
		185,
		53,
		50,
		38,
		36,
		59,
		16,
		12,
		-1,
		44,
		47,
		53,
		60,
		77,
		107,
		-1,
		-1,
		170,
		161,
		-1,
		-1,
		187,
		190,
		179,
		-1,
		169,
		142,
		147,
		172,
		179,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		62,
		76,
		65,
		61,
		60,
		68,
		17,
		34,
		41,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		180,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		164,
		164,
		167,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		96,
		-1,
		48,
		41,
		56,
		71,
		79,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		172,
		183,
		172,
		175,
		189,
		184,
		-1,
		-1,
		54,
		57,
		-1,
		-1,
		79,
		98,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		176,
		182,
		185,
		174,
		178,
		190,
		-1,
		-1,
		61,
		62,
		67,
		-1,
		88,
		-1,
		203,
		-1,
		170,
		177,
		165,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		194,
		192,
		183,
		180,
		187,
		185,
		181,
		192,
		-1,
		-1,
		-1,
		118,
		95,
		210,
		201,
		184,
		164,
		156,
		176,
		-1,
		183,
		-1,
		158,
		159,
		186,
		188,
		205,
		199,
		183,
		198,
		188,
		179,
		188,
		124,
		-1,
		99,
		158,
		141,
		170,
		136,
		148,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		222,
		203,
		196,
		183,
		190,
		192,
		185,
		-1,
		-1,
		-1,
		114,
		113,
		112,
		123,
		131,
		129,
		147,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		212,
		208,
		201,
		203,
		193,
		-1,
		168,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		140,
		162,
		157,
		149,
		161,
		170,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		192,
		224,
		-1,
		175,
		-1,
		144,
		-1,
		-1,
		158,
		144,
		156,
		167,
		157,
		157,
		162,
		160,
		182,
		199,
		183,
		181,
		186,
		191,
		-1,
		185,
		186,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		203,
		164,
		-1,
		189,
		169,
		-1,
		192,
		188,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		198,
		182,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		211,
		202,
		-1,
		171,
		174,
		-1,
		165,
		171,
		200,
		182,
		186,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		186,
		191,
		179,
		196,
		182,
		184,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		199,
		191,
		191,
		-1,
		-1,
		209,
		192,
		192,
		205,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		200,
		-1,
		-1,
		205,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		210,
		-1,
		-1,
		-1,
		201,
		208,
		216,
		-1,
		-1,
		-1,
		-1,
		228,
		229,
		256,
		231,
		-1,
		-1,
		-1,
		215,
		215,
		-1,
		-1,
		226,
		227,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		219,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		248,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		244,
		251,
		273,
		276,
		306,
		-1,
		263
	],
	[
		-1,
		291,
		280,
		291,
		299,
		272,
		279,
		-1,
		300,
		302,
		268,
		262,
		301,
		272,
		278,
		289,
		-1,
		-1,
		-1,
		291,
		290,
		260,
		258,
		267,
		272,
		279,
		-1,
		302,
		-1,
		312,
		291,
		302,
		307,
		253,
		250,
		270,
		289,
		295,
		287,
		327,
		283,
		254,
		248,
		266,
		271,
		289,
		281,
		-1,
		254,
		244,
		266,
		269,
		280,
		265,
		-1,
		-1,
		248,
		249,
		255,
		265,
		271,
		267,
		-1,
		277,
		261,
		-1,
		-1,
		238,
		251,
		247,
		250,
		258,
		256,
		269,
		261,
		256,
		-1,
		-1,
		239,
		243,
		256,
		243,
		239,
		256,
		269,
		251,
		265,
		264,
		-1,
		227,
		245,
		254,
		250,
		248,
		232,
		230,
		248,
		250,
		256,
		256,
		-1,
		219,
		221,
		250,
		256,
		268,
		248,
		235,
		235,
		245,
		238,
		257,
		245,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		216,
		224,
		250,
		249,
		245,
		263,
		258,
		238,
		235,
		233,
		230,
		246,
		244,
		254,
		-1,
		-1,
		272,
		241,
		276,
		233,
		218,
		-1,
		212,
		231,
		237,
		241,
		246,
		241,
		255,
		251,
		-1,
		224,
		223,
		251,
		237,
		248,
		232,
		-1,
		-1,
		230,
		222,
		207,
		210,
		207,
		207,
		237,
		236,
		241,
		236,
		232,
		238,
		241,
		241,
		247,
		218,
		228,
		232,
		230,
		255,
		-1,
		-1,
		290,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		202,
		219,
		209,
		230,
		245,
		249,
		252,
		246,
		234,
		236,
		233,
		246,
		234,
		215,
		240,
		244,
		225,
		246,
		241,
		-1,
		289,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		231,
		-1,
		252,
		250,
		270,
		255,
		252,
		239,
		227,
		240,
		225,
		232,
		231,
		219,
		217,
		247,
		222,
		244,
		241,
		260,
		265,
		259,
		268,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		239,
		252,
		259,
		254,
		257,
		256,
		247,
		234,
		223,
		234,
		223,
		220,
		228,
		211,
		226,
		217,
		216,
		234,
		244,
		252,
		256,
		262,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		240,
		260,
		261,
		252,
		-1,
		255,
		258,
		252,
		230,
		215,
		232,
		224,
		222,
		224,
		206,
		220,
		211,
		229,
		236,
		234,
		238,
		258,
		270,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		283,
		258,
		-1,
		253,
		-1,
		245,
		270,
		-1,
		236,
		232,
		214,
		215,
		210,
		225,
		217,
		202,
		199,
		217,
		220,
		227,
		231,
		247,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		251,
		240,
		239,
		-1,
		230,
		250,
		247,
		235,
		222,
		207,
		208,
		216,
		228,
		207,
		201,
		198,
		218,
		244,
		222,
		233,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		269,
		262,
		250,
		215,
		215,
		209,
		-1,
		246,
		225,
		216,
		205,
		203,
		216,
		208,
		216,
		196,
		194,
		213,
		225,
		216,
		224,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		171,
		194,
		228,
		248,
		234,
		239,
		214,
		207,
		201,
		253,
		242,
		217,
		212,
		204,
		193,
		204,
		212,
		210,
		192,
		201,
		207,
		231,
		212,
		218,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		185,
		192,
		224,
		239,
		236,
		-1,
		206,
		-1,
		195,
		203,
		202,
		208,
		209,
		196,
		195,
		209,
		209,
		199,
		194,
		201,
		236,
		236,
		202,
		222,
		225,
		-1,
		-1,
		-1,
		232,
		230,
		205,
		182,
		166,
		202,
		-1,
		206,
		207,
		-1,
		200,
		194,
		200,
		199,
		206,
		200,
		203,
		206,
		209,
		197,
		203,
		204,
		186,
		210,
		-1,
		210,
		204,
		212,
		202,
		190,
		-1,
		-1,
		-1,
		228,
		207,
		200,
		220,
		161,
		213,
		-1,
		-1,
		191,
		184,
		-1,
		187,
		187,
		194,
		203,
		203,
		205,
		202,
		191,
		204,
		197,
		191,
		185,
		198,
		202,
		203,
		192,
		188,
		185,
		199,
		-1,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		181,
		-1,
		194,
		186,
		182,
		176,
		182,
		200,
		198,
		218,
		210,
		217,
		213,
		205,
		200,
		186,
		179,
		190,
		175,
		193,
		199,
		190,
		185,
		184,
		195,
		-1,
		248,
		234,
		205,
		-1,
		-1,
		194,
		-1,
		158,
		172,
		188,
		-1,
		216,
		195,
		218,
		196,
		210,
		206,
		222,
		223,
		193,
		198,
		200,
		188,
		191,
		180,
		183,
		175,
		197,
		194,
		178,
		180,
		189,
		-1,
		254,
		241,
		199,
		195,
		184,
		204,
		155,
		164,
		175,
		-1,
		-1,
		260,
		-1,
		194,
		211,
		220,
		218,
		212,
		187,
		194,
		212,
		185,
		180,
		185,
		174,
		174,
		169,
		188,
		174,
		172,
		187,
		203,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		170,
		157,
		151,
		-1,
		192,
		-1,
		238,
		228,
		212,
		197,
		230,
		-1,
		186,
		182,
		189,
		-1,
		205,
		-1,
		177,
		180,
		171,
		166,
		163,
		174,
		172,
		181,
		182,
		-1,
		204,
		189,
		182,
		172,
		186,
		157,
		-1,
		200,
		-1,
		-1,
		225,
		219,
		219,
		203,
		206,
		202,
		182,
		174,
		189,
		188,
		175,
		174,
		162,
		162,
		165,
		159,
		172,
		182,
		188,
		180,
		-1,
		-1,
		-1,
		209,
		161,
		169,
		145,
		166,
		-1,
		-1,
		287,
		242,
		228,
		-1,
		204,
		202,
		190,
		180,
		170,
		175,
		176,
		166,
		164,
		160,
		169,
		168,
		161,
		160,
		181,
		174,
		196,
		-1,
		-1,
		158,
		171,
		173,
		159,
		178,
		-1,
		-1,
		-1,
		234,
		250,
		223,
		202,
		191,
		-1,
		-1,
		174,
		167,
		161,
		164,
		152,
		172,
		179,
		167,
		154,
		169,
		179,
		187,
		186,
		-1,
		161,
		148,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		-1,
		-1,
		235,
		180,
		169,
		164,
		168,
		173,
		-1,
		147,
		158,
		151,
		170,
		177,
		169,
		154,
		148,
		159,
		174,
		191,
		-1,
		-1,
		195,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		192,
		186,
		157,
		150,
		154,
		-1,
		149,
		151,
		148,
		160,
		165,
		169,
		160,
		142,
		156,
		159,
		172,
		186,
		190,
		218,
		-1,
		164,
		-1,
		-1,
		-1,
		203,
		204,
		190,
		167,
		146,
		139,
		136,
		135,
		140,
		151,
		160,
		171,
		136,
		140,
		155,
		160,
		164,
		181,
		185,
		-1,
		-1,
		162,
		158,
		193,
		205,
		177,
		217,
		-1,
		-1,
		135,
		128,
		138,
		131,
		144,
		147,
		132,
		134,
		152,
		165,
		159,
		169,
		184,
		179,
		-1,
		-1,
		-1,
		160,
		-1,
		176,
		-1,
		-1,
		167,
		208,
		155,
		137,
		133,
		119,
		126,
		120,
		122,
		127,
		146,
		141,
		150,
		155,
		159,
		182,
		171,
		210,
		-1,
		-1,
		114,
		-1,
		-1,
		-1,
		126,
		145,
		140,
		146,
		151,
		142,
		170,
		167,
		-1,
		116,
		149,
		117,
		131,
		127,
		134,
		139,
		145,
		149,
		156,
		172,
		171,
		166,
		202,
		193,
		199,
		-1,
		-1,
		107,
		96,
		85,
		91,
		-1,
		119,
		142,
		132,
		122,
		128,
		-1,
		-1,
		134,
		131,
		129,
		109,
		115,
		120,
		123,
		161,
		137,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		61,
		98,
		91,
		59,
		67,
		98,
		-1,
		109,
		101,
		129,
		114,
		122,
		-1,
		-1,
		107,
		98,
		103,
		112,
		113,
		144,
		143,
		156,
		159,
		164,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		54,
		74,
		53,
		56,
		80,
		94,
		-1,
		100,
		-1,
		-1,
		145,
		132,
		116,
		106,
		103,
		150,
		126,
		121,
		127,
		129,
		153,
		144,
		169,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		43,
		54,
		47,
		-1,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		161,
		-1,
		143,
		-1,
		126,
		130,
		134,
		137,
		152,
		139,
		146,
		163,
		169,
		158,
		168,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		93,
		48,
		27,
		38,
		15,
		30,
		34,
		-1,
		84,
		120,
		130,
		-1,
		170,
		-1,
		-1,
		-1,
		140,
		147,
		139,
		155,
		151,
		151,
		147,
		151,
		163,
		170,
		180,
		182,
		174,
		178,
		191,
		202,
		205,
		89,
		87,
		92,
		37,
		22,
		0,
		9,
		30,
		80,
		77,
		114,
		119,
		134,
		139,
		163,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		158,
		168,
		151,
		153,
		157,
		171,
		183,
		191,
		181,
		179,
		173,
		205,
		-1,
		89,
		88,
		77,
		74,
		50,
		41,
		28,
		35,
		-1,
		-1,
		78,
		105,
		89,
		93,
		109,
		134,
		-1,
		170,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		165,
		176,
		198,
		187,
		188,
		178,
		188,
		201,
		73,
		70,
		58,
		56,
		79,
		36,
		32,
		-1,
		60,
		63,
		69,
		76,
		93,
		123,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		203,
		206,
		195,
		-1,
		185,
		158,
		163,
		188,
		195,
		196,
		190,
		184,
		191,
		190,
		198,
		206,
		82,
		96,
		85,
		81,
		80,
		88,
		37,
		50,
		57,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		196,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		180,
		180,
		183,
		187,
		182,
		193,
		185,
		189,
		206,
		-1,
		116,
		-1,
		68,
		57,
		72,
		87,
		95,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		188,
		199,
		188,
		191,
		205,
		200,
		-1,
		-1,
		70,
		73,
		-1,
		-1,
		95,
		114,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		192,
		198,
		201,
		190,
		194,
		206,
		-1,
		-1,
		77,
		78,
		83,
		-1,
		104,
		-1,
		219,
		-1,
		186,
		193,
		181,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		210,
		208,
		199,
		196,
		203,
		201,
		197,
		208,
		-1,
		-1,
		-1,
		134,
		111,
		226,
		217,
		200,
		180,
		172,
		192,
		-1,
		199,
		-1,
		174,
		175,
		202,
		204,
		221,
		215,
		199,
		214,
		204,
		195,
		204,
		140,
		-1,
		115,
		174,
		157,
		186,
		152,
		164,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		238,
		219,
		212,
		199,
		206,
		208,
		201,
		-1,
		-1,
		-1,
		130,
		129,
		128,
		139,
		147,
		145,
		163,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		228,
		224,
		217,
		219,
		209,
		-1,
		188,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		156,
		178,
		173,
		165,
		177,
		186,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		208,
		240,
		-1,
		195,
		-1,
		160,
		-1,
		-1,
		174,
		160,
		172,
		183,
		173,
		173,
		178,
		176,
		198,
		215,
		199,
		197,
		202,
		207,
		-1,
		205,
		206,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		219,
		180,
		-1,
		205,
		185,
		-1,
		208,
		204,
		-1,
		-1,
		217,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		214,
		198,
		-1,
		196,
		196,
		-1,
		-1,
		-1,
		231,
		218,
		-1,
		187,
		190,
		-1,
		181,
		187,
		216,
		198,
		202,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		202,
		207,
		195,
		212,
		198,
		200,
		212,
		201,
		222,
		-1,
		-1,
		-1,
		215,
		207,
		207,
		-1,
		-1,
		225,
		208,
		208,
		221,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		216,
		-1,
		-1,
		221,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		226,
		-1,
		-1,
		-1,
		217,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		272,
		247,
		-1,
		-1,
		-1,
		231,
		231,
		-1,
		-1,
		246,
		247,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		235,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		264,
		-1,
		270,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		283,
		-1,
		255,
		257,
		-1,
		305,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		260,
		267,
		289,
		292,
		322,
		-1,
		279
	],
	[
		-1,
		299,
		288,
		299,
		307,
		280,
		287,
		-1,
		308,
		310,
		276,
		270,
		309,
		280,
		286,
		297,
		-1,
		-1,
		-1,
		299,
		298,
		268,
		266,
		275,
		280,
		287,
		-1,
		310,
		-1,
		320,
		299,
		310,
		315,
		261,
		258,
		278,
		297,
		303,
		295,
		335,
		291,
		262,
		256,
		274,
		279,
		297,
		289,
		-1,
		262,
		252,
		274,
		277,
		288,
		273,
		-1,
		-1,
		256,
		257,
		263,
		273,
		279,
		275,
		-1,
		285,
		269,
		-1,
		-1,
		246,
		259,
		255,
		258,
		266,
		264,
		277,
		269,
		264,
		-1,
		-1,
		247,
		251,
		264,
		251,
		247,
		264,
		277,
		259,
		273,
		272,
		-1,
		235,
		253,
		262,
		258,
		256,
		240,
		238,
		256,
		258,
		264,
		264,
		-1,
		227,
		229,
		258,
		264,
		276,
		256,
		243,
		243,
		253,
		246,
		265,
		253,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		224,
		232,
		258,
		257,
		253,
		271,
		266,
		246,
		243,
		241,
		238,
		254,
		252,
		262,
		-1,
		-1,
		280,
		249,
		284,
		241,
		226,
		-1,
		220,
		239,
		245,
		249,
		254,
		249,
		263,
		259,
		-1,
		232,
		231,
		259,
		245,
		256,
		240,
		-1,
		-1,
		238,
		230,
		215,
		218,
		215,
		215,
		245,
		244,
		249,
		244,
		240,
		246,
		249,
		249,
		255,
		226,
		236,
		240,
		238,
		263,
		-1,
		-1,
		298,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		210,
		227,
		217,
		238,
		253,
		257,
		260,
		254,
		242,
		244,
		241,
		254,
		242,
		223,
		248,
		252,
		233,
		254,
		249,
		-1,
		297,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		239,
		-1,
		260,
		258,
		278,
		263,
		260,
		247,
		235,
		248,
		233,
		240,
		239,
		227,
		225,
		255,
		230,
		252,
		249,
		268,
		273,
		267,
		276,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		247,
		260,
		267,
		262,
		265,
		264,
		255,
		242,
		231,
		242,
		231,
		228,
		236,
		219,
		234,
		225,
		224,
		242,
		252,
		260,
		264,
		270,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		248,
		268,
		269,
		260,
		-1,
		263,
		266,
		260,
		238,
		223,
		240,
		232,
		230,
		232,
		214,
		228,
		219,
		237,
		244,
		242,
		246,
		266,
		278,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		291,
		266,
		-1,
		261,
		-1,
		253,
		278,
		-1,
		244,
		240,
		222,
		223,
		218,
		233,
		225,
		210,
		207,
		225,
		228,
		235,
		239,
		255,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		259,
		248,
		247,
		-1,
		238,
		258,
		255,
		243,
		230,
		215,
		216,
		224,
		236,
		215,
		209,
		206,
		226,
		252,
		230,
		241,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		277,
		270,
		258,
		223,
		223,
		217,
		-1,
		254,
		233,
		224,
		213,
		211,
		224,
		216,
		224,
		204,
		202,
		221,
		233,
		224,
		232,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		179,
		202,
		236,
		256,
		242,
		247,
		222,
		215,
		209,
		261,
		250,
		225,
		220,
		212,
		201,
		212,
		220,
		218,
		200,
		209,
		215,
		239,
		220,
		226,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		193,
		200,
		232,
		247,
		244,
		-1,
		214,
		-1,
		203,
		211,
		210,
		216,
		217,
		204,
		203,
		217,
		217,
		207,
		202,
		209,
		244,
		244,
		210,
		230,
		233,
		-1,
		-1,
		-1,
		240,
		238,
		213,
		190,
		174,
		210,
		-1,
		214,
		215,
		-1,
		208,
		202,
		208,
		207,
		214,
		208,
		211,
		214,
		217,
		205,
		211,
		212,
		194,
		218,
		-1,
		218,
		212,
		220,
		210,
		198,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		199,
		192,
		-1,
		195,
		195,
		202,
		211,
		211,
		213,
		210,
		199,
		212,
		205,
		199,
		193,
		206,
		210,
		211,
		200,
		196,
		193,
		207,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		202,
		194,
		190,
		184,
		190,
		208,
		206,
		226,
		218,
		225,
		221,
		213,
		208,
		194,
		187,
		198,
		183,
		201,
		207,
		198,
		193,
		192,
		203,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		180,
		196,
		-1,
		224,
		203,
		226,
		204,
		218,
		214,
		230,
		231,
		201,
		206,
		208,
		196,
		199,
		188,
		191,
		183,
		205,
		202,
		186,
		188,
		197,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		172,
		183,
		-1,
		-1,
		268,
		-1,
		202,
		219,
		228,
		226,
		220,
		195,
		202,
		220,
		193,
		188,
		193,
		182,
		182,
		177,
		196,
		182,
		180,
		195,
		211,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		246,
		236,
		220,
		205,
		238,
		-1,
		194,
		190,
		197,
		-1,
		213,
		-1,
		185,
		188,
		179,
		174,
		171,
		182,
		180,
		189,
		190,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		208,
		-1,
		-1,
		233,
		227,
		227,
		211,
		214,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		170,
		170,
		173,
		167,
		180,
		190,
		196,
		188,
		-1,
		-1,
		-1,
		217,
		169,
		177,
		153,
		174,
		-1,
		-1,
		295,
		250,
		236,
		-1,
		212,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		168,
		177,
		176,
		169,
		168,
		189,
		182,
		204,
		-1,
		-1,
		166,
		179,
		181,
		167,
		186,
		-1,
		-1,
		-1,
		242,
		258,
		231,
		210,
		199,
		-1,
		-1,
		182,
		175,
		169,
		172,
		160,
		180,
		187,
		175,
		162,
		177,
		187,
		195,
		194,
		-1,
		169,
		156,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		-1,
		-1,
		243,
		188,
		177,
		172,
		176,
		181,
		-1,
		155,
		166,
		159,
		178,
		185,
		177,
		162,
		156,
		167,
		182,
		199,
		-1,
		-1,
		203,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		200,
		194,
		165,
		158,
		162,
		-1,
		157,
		159,
		156,
		168,
		173,
		177,
		168,
		150,
		164,
		167,
		180,
		194,
		198,
		226,
		-1,
		172,
		-1,
		-1,
		-1,
		211,
		212,
		198,
		175,
		154,
		147,
		144,
		143,
		148,
		159,
		168,
		179,
		144,
		148,
		163,
		168,
		172,
		189,
		193,
		-1,
		-1,
		170,
		166,
		201,
		213,
		185,
		225,
		-1,
		-1,
		143,
		136,
		146,
		139,
		152,
		155,
		140,
		142,
		160,
		173,
		167,
		177,
		192,
		187,
		-1,
		-1,
		-1,
		168,
		-1,
		184,
		-1,
		-1,
		175,
		216,
		163,
		145,
		141,
		127,
		134,
		128,
		130,
		135,
		154,
		149,
		158,
		163,
		167,
		190,
		179,
		218,
		-1,
		-1,
		122,
		-1,
		-1,
		-1,
		134,
		153,
		148,
		154,
		159,
		150,
		178,
		175,
		-1,
		124,
		157,
		125,
		139,
		135,
		142,
		147,
		153,
		157,
		164,
		180,
		179,
		174,
		210,
		201,
		207,
		-1,
		-1,
		115,
		104,
		93,
		99,
		-1,
		127,
		150,
		140,
		130,
		136,
		-1,
		-1,
		142,
		139,
		137,
		117,
		123,
		128,
		131,
		169,
		145,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		69,
		106,
		99,
		67,
		75,
		106,
		-1,
		117,
		109,
		137,
		122,
		130,
		-1,
		-1,
		115,
		106,
		111,
		120,
		121,
		152,
		151,
		164,
		167,
		172,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		62,
		82,
		61,
		64,
		88,
		102,
		-1,
		108,
		-1,
		-1,
		153,
		140,
		124,
		114,
		111,
		158,
		134,
		129,
		135,
		137,
		161,
		152,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		51,
		62,
		55,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		169,
		-1,
		151,
		-1,
		134,
		138,
		142,
		145,
		160,
		147,
		154,
		171,
		177,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		101,
		56,
		35,
		46,
		6,
		21,
		25,
		-1,
		92,
		128,
		138,
		-1,
		178,
		-1,
		-1,
		-1,
		148,
		155,
		147,
		163,
		159,
		159,
		155,
		159,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		97,
		95,
		100,
		45,
		30,
		8,
		0,
		21,
		88,
		85,
		122,
		127,
		142,
		147,
		171,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		166,
		176,
		159,
		161,
		165,
		179,
		191,
		199,
		189,
		187,
		181,
		213,
		-1,
		97,
		96,
		85,
		82,
		58,
		49,
		36,
		43,
		-1,
		-1,
		86,
		113,
		97,
		101,
		117,
		142,
		-1,
		178,
		-1,
		-1,
		192,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		173,
		184,
		206,
		195,
		196,
		186,
		196,
		209,
		81,
		78,
		66,
		64,
		87,
		44,
		40,
		-1,
		68,
		71,
		77,
		84,
		101,
		131,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		211,
		214,
		203,
		-1,
		193,
		166,
		171,
		196,
		203,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		90,
		104,
		93,
		89,
		88,
		96,
		45,
		58,
		65,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		217,
		204,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		188,
		188,
		191,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		124,
		-1,
		76,
		65,
		80,
		95,
		103,
		-1,
		-1,
		-1,
		234,
		220,
		213,
		201,
		199,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		78,
		81,
		-1,
		-1,
		103,
		122,
		-1,
		225,
		214,
		199,
		191,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		85,
		86,
		91,
		-1,
		112,
		-1,
		227,
		-1,
		194,
		201,
		189,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		218,
		216,
		207,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		142,
		119,
		234,
		225,
		208,
		188,
		180,
		200,
		-1,
		207,
		-1,
		182,
		183,
		210,
		212,
		229,
		223,
		207,
		222,
		212,
		203,
		212,
		148,
		-1,
		123,
		182,
		165,
		194,
		160,
		172,
		228,
		-1,
		204,
		186,
		-1,
		214,
		204,
		246,
		227,
		220,
		207,
		214,
		216,
		209,
		-1,
		-1,
		-1,
		138,
		137,
		136,
		147,
		155,
		153,
		171,
		-1,
		216,
		198,
		177,
		194,
		194,
		185,
		193,
		236,
		232,
		225,
		227,
		217,
		-1,
		196,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		164,
		186,
		181,
		173,
		185,
		194,
		181,
		187,
		189,
		197,
		195,
		192,
		204,
		200,
		220,
		216,
		248,
		-1,
		203,
		-1,
		168,
		-1,
		-1,
		182,
		168,
		180,
		191,
		181,
		181,
		186,
		184,
		206,
		223,
		207,
		205,
		210,
		215,
		-1,
		213,
		214,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		227,
		188,
		-1,
		213,
		193,
		-1,
		216,
		212,
		-1,
		-1,
		225,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		222,
		206,
		-1,
		204,
		204,
		-1,
		-1,
		-1,
		239,
		226,
		-1,
		195,
		198,
		-1,
		189,
		195,
		224,
		206,
		210,
		-1,
		-1,
		-1,
		251,
		232,
		226,
		210,
		215,
		203,
		220,
		206,
		208,
		220,
		209,
		230,
		-1,
		-1,
		-1,
		223,
		215,
		215,
		-1,
		-1,
		233,
		216,
		216,
		229,
		-1,
		-1,
		-1,
		245,
		226,
		-1,
		-1,
		224,
		-1,
		-1,
		229,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		234,
		-1,
		-1,
		-1,
		225,
		232,
		240,
		-1,
		-1,
		-1,
		-1,
		255,
		256,
		280,
		255,
		-1,
		-1,
		-1,
		239,
		239,
		-1,
		-1,
		254,
		255,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		243,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		272,
		-1,
		278,
		253,
		260,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		291,
		-1,
		263,
		265,
		-1,
		313,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		268,
		275,
		297,
		300,
		330,
		-1,
		287
	],
	[
		-1,
		319,
		308,
		319,
		327,
		300,
		307,
		-1,
		328,
		330,
		296,
		290,
		329,
		300,
		306,
		317,
		-1,
		-1,
		-1,
		319,
		318,
		288,
		286,
		295,
		300,
		307,
		-1,
		330,
		-1,
		340,
		319,
		330,
		335,
		281,
		278,
		298,
		317,
		323,
		315,
		355,
		311,
		282,
		276,
		294,
		299,
		317,
		309,
		-1,
		282,
		272,
		294,
		297,
		308,
		293,
		-1,
		-1,
		276,
		277,
		283,
		293,
		299,
		295,
		-1,
		305,
		289,
		-1,
		-1,
		266,
		279,
		275,
		278,
		286,
		284,
		297,
		289,
		284,
		-1,
		-1,
		267,
		271,
		284,
		271,
		267,
		284,
		297,
		279,
		293,
		292,
		-1,
		255,
		273,
		282,
		278,
		276,
		260,
		258,
		276,
		278,
		284,
		284,
		-1,
		247,
		249,
		278,
		284,
		296,
		276,
		263,
		263,
		273,
		266,
		285,
		273,
		319,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		244,
		252,
		278,
		277,
		273,
		291,
		286,
		266,
		263,
		261,
		258,
		274,
		272,
		282,
		-1,
		-1,
		300,
		269,
		304,
		261,
		246,
		-1,
		240,
		259,
		265,
		269,
		274,
		269,
		283,
		279,
		-1,
		252,
		251,
		279,
		265,
		276,
		260,
		-1,
		-1,
		258,
		250,
		235,
		238,
		235,
		235,
		265,
		264,
		269,
		264,
		260,
		266,
		269,
		269,
		275,
		246,
		256,
		260,
		258,
		283,
		-1,
		-1,
		318,
		-1,
		-1,
		257,
		240,
		-1,
		223,
		230,
		230,
		247,
		237,
		258,
		273,
		277,
		280,
		274,
		262,
		264,
		261,
		274,
		262,
		243,
		268,
		272,
		253,
		274,
		269,
		-1,
		317,
		301,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		216,
		219,
		225,
		249,
		259,
		-1,
		280,
		278,
		298,
		283,
		280,
		267,
		255,
		268,
		253,
		260,
		259,
		247,
		245,
		275,
		250,
		272,
		269,
		288,
		293,
		287,
		296,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		253,
		-1,
		267,
		280,
		287,
		282,
		285,
		284,
		275,
		262,
		251,
		262,
		251,
		248,
		256,
		239,
		254,
		245,
		244,
		262,
		272,
		280,
		284,
		290,
		-1,
		315,
		-1,
		257,
		241,
		243,
		215,
		236,
		-1,
		273,
		268,
		288,
		289,
		280,
		-1,
		283,
		286,
		280,
		258,
		243,
		260,
		252,
		250,
		252,
		234,
		248,
		239,
		257,
		264,
		262,
		266,
		286,
		298,
		275,
		265,
		-1,
		247,
		252,
		211,
		219,
		238,
		311,
		286,
		-1,
		281,
		-1,
		273,
		298,
		-1,
		264,
		260,
		242,
		243,
		238,
		253,
		245,
		230,
		227,
		245,
		248,
		255,
		259,
		275,
		-1,
		-1,
		260,
		264,
		253,
		204,
		223,
		247,
		284,
		279,
		268,
		267,
		-1,
		258,
		278,
		275,
		263,
		250,
		235,
		236,
		244,
		256,
		235,
		229,
		226,
		246,
		272,
		250,
		261,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		230,
		201,
		225,
		267,
		297,
		290,
		278,
		243,
		243,
		237,
		-1,
		274,
		253,
		244,
		233,
		231,
		244,
		236,
		244,
		224,
		222,
		241,
		253,
		244,
		252,
		-1,
		-1,
		-1,
		260,
		249,
		250,
		199,
		222,
		256,
		276,
		262,
		267,
		242,
		235,
		229,
		281,
		270,
		245,
		240,
		232,
		221,
		232,
		240,
		238,
		220,
		229,
		235,
		259,
		240,
		246,
		-1,
		-1,
		267,
		257,
		241,
		243,
		240,
		213,
		220,
		252,
		267,
		264,
		-1,
		234,
		-1,
		223,
		231,
		230,
		236,
		237,
		224,
		223,
		237,
		237,
		227,
		222,
		229,
		264,
		264,
		230,
		250,
		253,
		-1,
		-1,
		-1,
		260,
		258,
		233,
		210,
		194,
		230,
		-1,
		234,
		235,
		-1,
		228,
		222,
		228,
		227,
		234,
		228,
		231,
		234,
		237,
		225,
		231,
		232,
		214,
		238,
		-1,
		238,
		232,
		240,
		230,
		218,
		-1,
		-1,
		-1,
		256,
		235,
		228,
		248,
		189,
		241,
		-1,
		-1,
		219,
		212,
		-1,
		215,
		215,
		222,
		231,
		231,
		233,
		230,
		219,
		232,
		225,
		219,
		213,
		226,
		230,
		231,
		220,
		216,
		213,
		227,
		-1,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		209,
		-1,
		222,
		214,
		210,
		204,
		210,
		228,
		226,
		246,
		238,
		245,
		241,
		233,
		228,
		214,
		207,
		218,
		203,
		221,
		227,
		218,
		213,
		212,
		223,
		-1,
		276,
		262,
		233,
		-1,
		-1,
		222,
		-1,
		186,
		200,
		216,
		-1,
		244,
		223,
		246,
		224,
		238,
		234,
		250,
		251,
		221,
		226,
		228,
		216,
		219,
		208,
		211,
		203,
		225,
		222,
		206,
		208,
		217,
		-1,
		282,
		269,
		227,
		223,
		212,
		232,
		183,
		192,
		203,
		-1,
		-1,
		288,
		-1,
		222,
		239,
		248,
		246,
		240,
		215,
		222,
		240,
		213,
		208,
		213,
		202,
		202,
		197,
		216,
		202,
		200,
		215,
		231,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		198,
		185,
		179,
		-1,
		220,
		-1,
		266,
		256,
		240,
		225,
		258,
		-1,
		214,
		210,
		217,
		-1,
		233,
		-1,
		205,
		208,
		199,
		194,
		191,
		202,
		200,
		209,
		210,
		-1,
		232,
		217,
		210,
		200,
		214,
		185,
		-1,
		228,
		-1,
		-1,
		253,
		247,
		247,
		231,
		234,
		230,
		210,
		202,
		217,
		216,
		203,
		202,
		190,
		190,
		193,
		187,
		200,
		210,
		216,
		208,
		-1,
		-1,
		-1,
		237,
		189,
		197,
		173,
		194,
		-1,
		-1,
		315,
		270,
		256,
		-1,
		232,
		230,
		218,
		208,
		198,
		203,
		204,
		194,
		192,
		188,
		197,
		196,
		189,
		188,
		209,
		202,
		224,
		-1,
		-1,
		186,
		199,
		201,
		187,
		206,
		-1,
		-1,
		-1,
		262,
		278,
		251,
		230,
		219,
		-1,
		-1,
		202,
		195,
		189,
		192,
		180,
		200,
		207,
		195,
		182,
		197,
		207,
		215,
		214,
		-1,
		189,
		176,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		-1,
		-1,
		263,
		208,
		197,
		192,
		196,
		201,
		-1,
		175,
		186,
		179,
		198,
		205,
		197,
		182,
		176,
		187,
		202,
		219,
		-1,
		-1,
		223,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		220,
		214,
		185,
		178,
		182,
		-1,
		177,
		179,
		176,
		188,
		193,
		197,
		188,
		170,
		184,
		187,
		200,
		214,
		218,
		246,
		-1,
		192,
		-1,
		-1,
		-1,
		231,
		232,
		218,
		195,
		174,
		167,
		164,
		163,
		168,
		179,
		188,
		199,
		164,
		168,
		183,
		188,
		192,
		209,
		213,
		-1,
		-1,
		190,
		186,
		221,
		233,
		205,
		245,
		-1,
		-1,
		163,
		156,
		166,
		159,
		172,
		175,
		160,
		162,
		180,
		193,
		187,
		197,
		212,
		207,
		-1,
		-1,
		-1,
		188,
		-1,
		204,
		-1,
		-1,
		195,
		236,
		183,
		165,
		161,
		147,
		154,
		148,
		150,
		155,
		174,
		169,
		178,
		183,
		187,
		210,
		199,
		238,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		154,
		173,
		168,
		174,
		179,
		170,
		198,
		195,
		-1,
		144,
		177,
		145,
		159,
		155,
		162,
		167,
		173,
		177,
		184,
		200,
		199,
		194,
		230,
		221,
		227,
		-1,
		-1,
		135,
		124,
		113,
		119,
		-1,
		147,
		170,
		160,
		150,
		156,
		-1,
		-1,
		162,
		159,
		157,
		137,
		143,
		148,
		151,
		189,
		165,
		173,
		177,
		181,
		187,
		192,
		197,
		203,
		218,
		233,
		-1,
		89,
		126,
		119,
		87,
		95,
		126,
		-1,
		137,
		129,
		157,
		142,
		150,
		-1,
		-1,
		135,
		126,
		131,
		140,
		141,
		172,
		171,
		184,
		187,
		192,
		180,
		179,
		197,
		201,
		210,
		217,
		207,
		220,
		224,
		-1,
		82,
		102,
		81,
		84,
		108,
		122,
		-1,
		128,
		-1,
		-1,
		173,
		160,
		144,
		134,
		131,
		178,
		154,
		149,
		155,
		157,
		181,
		172,
		197,
		188,
		188,
		191,
		206,
		211,
		203,
		217,
		217,
		218,
		-1,
		71,
		82,
		75,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		189,
		-1,
		171,
		-1,
		154,
		158,
		162,
		165,
		180,
		167,
		174,
		191,
		197,
		186,
		196,
		192,
		193,
		202,
		213,
		225,
		224,
		225,
		121,
		76,
		55,
		66,
		15,
		0,
		4,
		-1,
		112,
		148,
		158,
		-1,
		198,
		-1,
		-1,
		-1,
		168,
		175,
		167,
		183,
		179,
		179,
		175,
		179,
		191,
		198,
		208,
		210,
		202,
		206,
		219,
		230,
		233,
		117,
		115,
		120,
		65,
		50,
		28,
		20,
		0,
		108,
		105,
		142,
		147,
		162,
		167,
		191,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		186,
		196,
		179,
		181,
		185,
		199,
		211,
		219,
		209,
		207,
		201,
		233,
		-1,
		117,
		116,
		105,
		102,
		78,
		69,
		56,
		63,
		-1,
		-1,
		106,
		133,
		117,
		121,
		137,
		162,
		-1,
		198,
		-1,
		-1,
		212,
		-1,
		-1,
		238,
		201,
		190,
		181,
		187,
		193,
		204,
		226,
		215,
		216,
		206,
		216,
		229,
		101,
		98,
		86,
		84,
		107,
		64,
		60,
		-1,
		88,
		91,
		97,
		104,
		121,
		151,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		231,
		234,
		223,
		-1,
		213,
		186,
		191,
		216,
		223,
		224,
		218,
		212,
		219,
		218,
		226,
		234,
		110,
		124,
		113,
		109,
		108,
		116,
		65,
		78,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		237,
		224,
		-1,
		-1,
		231,
		224,
		212,
		200,
		190,
		200,
		208,
		208,
		211,
		215,
		210,
		221,
		213,
		217,
		234,
		-1,
		144,
		-1,
		96,
		85,
		100,
		115,
		123,
		-1,
		-1,
		-1,
		254,
		240,
		233,
		221,
		219,
		-1,
		265,
		249,
		230,
		-1,
		200,
		213,
		244,
		212,
		217,
		212,
		216,
		227,
		216,
		219,
		233,
		228,
		-1,
		-1,
		98,
		101,
		-1,
		-1,
		123,
		142,
		-1,
		245,
		234,
		219,
		211,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		201,
		226,
		215,
		223,
		218,
		220,
		226,
		229,
		218,
		222,
		234,
		-1,
		-1,
		105,
		106,
		111,
		-1,
		132,
		-1,
		247,
		-1,
		214,
		221,
		209,
		-1,
		-1,
		-1,
		239,
		202,
		223,
		233,
		238,
		236,
		227,
		224,
		231,
		229,
		225,
		236,
		-1,
		-1,
		-1,
		162,
		139,
		254,
		245,
		228,
		208,
		200,
		220,
		-1,
		227,
		-1,
		202,
		203,
		230,
		232,
		249,
		243,
		227,
		242,
		232,
		223,
		232,
		168,
		-1,
		143,
		202,
		185,
		214,
		180,
		192,
		248,
		-1,
		224,
		206,
		-1,
		234,
		224,
		266,
		247,
		240,
		227,
		234,
		236,
		229,
		-1,
		-1,
		-1,
		158,
		157,
		156,
		167,
		175,
		173,
		191,
		-1,
		236,
		218,
		197,
		214,
		214,
		205,
		213,
		256,
		252,
		245,
		247,
		237,
		-1,
		216,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		184,
		206,
		201,
		193,
		205,
		214,
		201,
		207,
		209,
		217,
		215,
		212,
		224,
		220,
		240,
		236,
		268,
		-1,
		223,
		-1,
		188,
		-1,
		-1,
		202,
		188,
		200,
		211,
		201,
		201,
		206,
		204,
		226,
		243,
		227,
		225,
		230,
		235,
		-1,
		233,
		234,
		-1,
		221,
		213,
		199,
		-1,
		192,
		-1,
		247,
		208,
		-1,
		233,
		213,
		-1,
		236,
		232,
		-1,
		-1,
		245,
		237,
		-1,
		-1,
		-1,
		222,
		202,
		242,
		226,
		-1,
		224,
		224,
		-1,
		-1,
		-1,
		259,
		246,
		-1,
		215,
		218,
		-1,
		209,
		215,
		244,
		226,
		230,
		-1,
		-1,
		-1,
		271,
		252,
		246,
		230,
		235,
		223,
		240,
		226,
		228,
		240,
		229,
		250,
		-1,
		-1,
		-1,
		243,
		235,
		235,
		-1,
		-1,
		253,
		236,
		236,
		249,
		-1,
		-1,
		-1,
		265,
		246,
		-1,
		-1,
		244,
		-1,
		-1,
		249,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		254,
		-1,
		-1,
		-1,
		245,
		252,
		260,
		-1,
		-1,
		-1,
		-1,
		275,
		276,
		300,
		275,
		-1,
		-1,
		-1,
		259,
		259,
		-1,
		-1,
		274,
		275,
		-1,
		-1,
		-1,
		287,
		271,
		-1,
		263,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		292,
		-1,
		298,
		273,
		280,
		-1,
		-1,
		-1,
		-1,
		305,
		297,
		311,
		-1,
		283,
		285,
		-1,
		333,
		-1,
		-1,
		320,
		311,
		-1,
		-1,
		288,
		295,
		317,
		320,
		350,
		-1,
		307
	],
	[
		-1,
		292,
		281,
		292,
		300,
		273,
		280,
		-1,
		299,
		303,
		269,
		263,
		302,
		271,
		277,
		288,
		-1,
		-1,
		-1,
		292,
		291,
		259,
		257,
		266,
		271,
		278,
		-1,
		277,
		-1,
		313,
		292,
		303,
		308,
		252,
		249,
		269,
		288,
		270,
		262,
		328,
		282,
		253,
		247,
		265,
		255,
		264,
		256,
		-1,
		253,
		243,
		265,
		244,
		255,
		247,
		-1,
		-1,
		247,
		248,
		254,
		240,
		246,
		242,
		-1,
		252,
		236,
		-1,
		-1,
		237,
		238,
		222,
		225,
		233,
		231,
		244,
		236,
		231,
		-1,
		-1,
		228,
		224,
		231,
		218,
		214,
		231,
		244,
		226,
		240,
		239,
		-1,
		234,
		252,
		257,
		225,
		223,
		207,
		205,
		223,
		225,
		231,
		231,
		-1,
		226,
		228,
		239,
		247,
		247,
		223,
		210,
		210,
		220,
		213,
		232,
		220,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		223,
		226,
		243,
		235,
		225,
		240,
		233,
		213,
		210,
		208,
		205,
		221,
		219,
		229,
		-1,
		-1,
		279,
		248,
		283,
		240,
		225,
		-1,
		219,
		219,
		225,
		229,
		223,
		216,
		230,
		226,
		-1,
		199,
		198,
		226,
		212,
		223,
		239,
		-1,
		-1,
		237,
		229,
		214,
		217,
		214,
		214,
		234,
		233,
		225,
		211,
		207,
		213,
		216,
		216,
		222,
		193,
		203,
		207,
		205,
		230,
		-1,
		-1,
		265,
		-1,
		-1,
		236,
		219,
		-1,
		202,
		209,
		209,
		226,
		216,
		237,
		244,
		235,
		227,
		221,
		209,
		211,
		208,
		221,
		209,
		190,
		215,
		219,
		200,
		221,
		216,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		195,
		198,
		204,
		228,
		238,
		-1,
		256,
		244,
		245,
		230,
		227,
		214,
		202,
		215,
		200,
		207,
		206,
		194,
		192,
		222,
		197,
		219,
		216,
		235,
		240,
		234,
		243,
		-1,
		244,
		240,
		236,
		243,
		192,
		-1,
		-1,
		232,
		-1,
		246,
		259,
		263,
		241,
		244,
		231,
		222,
		209,
		198,
		209,
		198,
		195,
		203,
		186,
		201,
		192,
		191,
		209,
		219,
		227,
		231,
		237,
		-1,
		294,
		-1,
		236,
		220,
		222,
		194,
		215,
		-1,
		252,
		247,
		267,
		265,
		256,
		-1,
		240,
		237,
		227,
		205,
		190,
		207,
		199,
		197,
		199,
		181,
		195,
		186,
		204,
		211,
		209,
		213,
		233,
		245,
		254,
		244,
		-1,
		226,
		231,
		190,
		198,
		217,
		290,
		262,
		-1,
		257,
		-1,
		242,
		255,
		-1,
		211,
		207,
		189,
		190,
		185,
		200,
		192,
		177,
		174,
		192,
		195,
		202,
		206,
		222,
		-1,
		-1,
		239,
		243,
		232,
		183,
		202,
		226,
		263,
		255,
		244,
		243,
		-1,
		234,
		225,
		222,
		210,
		197,
		182,
		183,
		191,
		203,
		182,
		176,
		173,
		193,
		219,
		197,
		208,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		209,
		180,
		204,
		246,
		273,
		266,
		254,
		219,
		219,
		213,
		-1,
		221,
		200,
		191,
		180,
		178,
		191,
		183,
		191,
		171,
		169,
		188,
		200,
		191,
		199,
		-1,
		-1,
		-1,
		239,
		228,
		229,
		175,
		198,
		235,
		252,
		238,
		243,
		218,
		211,
		205,
		234,
		217,
		198,
		187,
		179,
		168,
		179,
		187,
		185,
		167,
		176,
		182,
		206,
		187,
		193,
		-1,
		-1,
		246,
		236,
		220,
		222,
		219,
		189,
		196,
		228,
		243,
		240,
		-1,
		210,
		-1,
		199,
		207,
		192,
		187,
		184,
		171,
		170,
		184,
		184,
		174,
		169,
		176,
		211,
		211,
		177,
		197,
		200,
		-1,
		-1,
		-1,
		239,
		234,
		209,
		186,
		170,
		206,
		-1,
		210,
		211,
		-1,
		204,
		198,
		204,
		194,
		190,
		175,
		179,
		181,
		184,
		172,
		178,
		179,
		161,
		185,
		-1,
		185,
		179,
		187,
		177,
		165,
		-1,
		-1,
		-1,
		232,
		211,
		204,
		224,
		165,
		217,
		-1,
		-1,
		195,
		188,
		-1,
		191,
		185,
		187,
		182,
		178,
		180,
		177,
		166,
		179,
		172,
		166,
		160,
		173,
		177,
		178,
		167,
		163,
		160,
		174,
		-1,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		185,
		-1,
		203,
		195,
		186,
		180,
		186,
		198,
		196,
		206,
		190,
		192,
		188,
		180,
		175,
		161,
		154,
		165,
		150,
		168,
		174,
		165,
		160,
		159,
		170,
		-1,
		252,
		238,
		209,
		-1,
		-1,
		198,
		-1,
		162,
		181,
		197,
		-1,
		220,
		199,
		222,
		200,
		208,
		199,
		197,
		198,
		168,
		173,
		175,
		163,
		166,
		155,
		158,
		150,
		172,
		169,
		153,
		155,
		164,
		-1,
		258,
		245,
		203,
		199,
		188,
		208,
		159,
		168,
		184,
		-1,
		-1,
		236,
		-1,
		190,
		192,
		213,
		211,
		187,
		162,
		169,
		187,
		160,
		155,
		160,
		149,
		149,
		144,
		163,
		149,
		147,
		162,
		178,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		174,
		161,
		155,
		-1,
		201,
		-1,
		214,
		202,
		189,
		171,
		211,
		-1,
		161,
		157,
		164,
		-1,
		180,
		-1,
		152,
		155,
		146,
		141,
		138,
		149,
		147,
		156,
		157,
		-1,
		208,
		193,
		186,
		176,
		190,
		158,
		-1,
		192,
		-1,
		-1,
		201,
		195,
		195,
		164,
		161,
		177,
		157,
		149,
		164,
		163,
		150,
		149,
		137,
		137,
		140,
		134,
		147,
		157,
		163,
		155,
		-1,
		-1,
		-1,
		213,
		188,
		182,
		154,
		158,
		-1,
		-1,
		262,
		218,
		204,
		-1,
		156,
		177,
		165,
		155,
		145,
		150,
		151,
		141,
		139,
		135,
		144,
		143,
		136,
		135,
		156,
		149,
		171,
		-1,
		-1,
		185,
		180,
		168,
		136,
		131,
		-1,
		-1,
		-1,
		208,
		194,
		182,
		154,
		166,
		-1,
		-1,
		149,
		142,
		136,
		139,
		127,
		147,
		154,
		142,
		129,
		144,
		154,
		162,
		161,
		-1,
		188,
		175,
		-1,
		-1,
		130,
		120,
		-1,
		-1,
		-1,
		-1,
		172,
		153,
		144,
		139,
		143,
		148,
		-1,
		122,
		133,
		126,
		145,
		152,
		144,
		129,
		123,
		134,
		149,
		166,
		-1,
		-1,
		144,
		-1,
		106,
		-1,
		-1,
		-1,
		-1,
		144,
		159,
		132,
		125,
		129,
		-1,
		124,
		126,
		123,
		135,
		140,
		144,
		135,
		117,
		131,
		134,
		147,
		161,
		165,
		167,
		-1,
		97,
		-1,
		-1,
		-1,
		136,
		137,
		165,
		142,
		121,
		114,
		111,
		110,
		115,
		126,
		135,
		146,
		111,
		115,
		130,
		135,
		139,
		156,
		160,
		-1,
		-1,
		95,
		91,
		126,
		138,
		110,
		192,
		-1,
		-1,
		110,
		103,
		113,
		106,
		119,
		122,
		107,
		109,
		127,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		93,
		-1,
		109,
		-1,
		-1,
		100,
		183,
		130,
		112,
		108,
		94,
		101,
		95,
		97,
		102,
		121,
		116,
		125,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		59,
		78,
		73,
		79,
		84,
		75,
		145,
		142,
		-1,
		91,
		124,
		92,
		106,
		102,
		109,
		114,
		120,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		134,
		123,
		112,
		118,
		-1,
		52,
		75,
		65,
		55,
		61,
		-1,
		-1,
		108,
		105,
		104,
		84,
		90,
		95,
		98,
		136,
		112,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		88,
		125,
		118,
		86,
		94,
		125,
		-1,
		42,
		34,
		62,
		47,
		55,
		-1,
		-1,
		81,
		73,
		78,
		87,
		88,
		119,
		118,
		131,
		134,
		139,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		81,
		101,
		80,
		83,
		107,
		121,
		-1,
		33,
		-1,
		-1,
		78,
		68,
		76,
		72,
		76,
		125,
		101,
		96,
		102,
		104,
		128,
		119,
		144,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		70,
		81,
		74,
		-1,
		-1,
		-1,
		-1,
		27,
		-1,
		-1,
		94,
		-1,
		102,
		-1,
		95,
		99,
		109,
		112,
		127,
		114,
		121,
		138,
		144,
		133,
		143,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		95,
		51,
		54,
		65,
		76,
		91,
		95,
		-1,
		17,
		49,
		75,
		-1,
		103,
		-1,
		-1,
		-1,
		109,
		122,
		114,
		130,
		126,
		126,
		122,
		126,
		138,
		145,
		155,
		157,
		149,
		153,
		166,
		177,
		180,
		91,
		82,
		95,
		40,
		40,
		61,
		70,
		91,
		0,
		10,
		43,
		64,
		79,
		84,
		108,
		-1,
		-1,
		132,
		132,
		-1,
		-1,
		133,
		143,
		126,
		128,
		132,
		146,
		158,
		166,
		156,
		154,
		148,
		180,
		-1,
		84,
		83,
		72,
		69,
		45,
		36,
		31,
		58,
		-1,
		-1,
		6,
		34,
		34,
		38,
		54,
		79,
		-1,
		113,
		-1,
		-1,
		153,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		140,
		151,
		173,
		162,
		163,
		153,
		163,
		176,
		68,
		65,
		53,
		51,
		74,
		39,
		27,
		-1,
		22,
		10,
		16,
		21,
		38,
		68,
		-1,
		-1,
		129,
		120,
		-1,
		-1,
		172,
		179,
		170,
		-1,
		160,
		133,
		138,
		163,
		170,
		171,
		165,
		159,
		166,
		165,
		173,
		181,
		77,
		91,
		80,
		76,
		75,
		83,
		32,
		25,
		25,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		139,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		155,
		155,
		158,
		162,
		157,
		168,
		160,
		164,
		181,
		-1,
		111,
		-1,
		63,
		31,
		51,
		66,
		74,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		163,
		174,
		163,
		166,
		180,
		175,
		-1,
		-1,
		49,
		52,
		-1,
		-1,
		76,
		95,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		167,
		173,
		176,
		165,
		169,
		181,
		-1,
		-1,
		56,
		59,
		64,
		-1,
		85,
		-1,
		196,
		-1,
		141,
		157,
		159,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		185,
		183,
		174,
		171,
		178,
		176,
		172,
		183,
		-1,
		-1,
		-1,
		115,
		92,
		203,
		194,
		177,
		157,
		149,
		173,
		-1,
		174,
		-1,
		149,
		150,
		177,
		179,
		196,
		190,
		174,
		189,
		179,
		170,
		179,
		121,
		-1,
		96,
		155,
		138,
		163,
		133,
		145,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		213,
		194,
		187,
		174,
		181,
		183,
		176,
		-1,
		-1,
		-1,
		111,
		110,
		109,
		120,
		128,
		126,
		144,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		203,
		199,
		192,
		194,
		184,
		-1,
		183,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		137,
		159,
		154,
		146,
		158,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		183,
		215,
		-1,
		190,
		-1,
		141,
		-1,
		-1,
		155,
		141,
		153,
		164,
		154,
		154,
		159,
		152,
		174,
		190,
		174,
		172,
		177,
		182,
		-1,
		200,
		201,
		-1,
		174,
		166,
		152,
		-1,
		145,
		-1,
		200,
		161,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		212,
		190,
		-1,
		-1,
		-1,
		175,
		155,
		195,
		179,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		215,
		199,
		-1,
		168,
		171,
		-1,
		162,
		168,
		197,
		174,
		178,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		183,
		188,
		176,
		193,
		179,
		181,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		196,
		188,
		188,
		-1,
		-1,
		206,
		189,
		189,
		197,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		197,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		207,
		-1,
		-1,
		-1,
		198,
		205,
		213,
		-1,
		-1,
		-1,
		-1,
		228,
		229,
		253,
		228,
		-1,
		-1,
		-1,
		212,
		207,
		-1,
		-1,
		231,
		229,
		-1,
		-1,
		-1,
		240,
		224,
		-1,
		211,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		245,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		258,
		250,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		236,
		243,
		265,
		268,
		303,
		-1,
		255
	],
	[
		-1,
		288,
		277,
		288,
		296,
		269,
		276,
		-1,
		297,
		299,
		265,
		259,
		298,
		269,
		275,
		286,
		-1,
		-1,
		-1,
		288,
		287,
		257,
		255,
		264,
		269,
		276,
		-1,
		278,
		-1,
		309,
		288,
		299,
		304,
		250,
		247,
		267,
		286,
		271,
		263,
		324,
		280,
		251,
		245,
		263,
		256,
		265,
		257,
		-1,
		251,
		241,
		263,
		245,
		256,
		248,
		-1,
		-1,
		245,
		246,
		252,
		241,
		247,
		243,
		-1,
		253,
		237,
		-1,
		-1,
		235,
		239,
		223,
		226,
		234,
		232,
		245,
		237,
		232,
		-1,
		-1,
		229,
		225,
		232,
		219,
		215,
		232,
		245,
		227,
		241,
		240,
		-1,
		224,
		242,
		251,
		226,
		224,
		208,
		206,
		224,
		226,
		232,
		232,
		-1,
		216,
		218,
		240,
		248,
		248,
		224,
		211,
		211,
		221,
		214,
		233,
		221,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		213,
		221,
		244,
		236,
		226,
		241,
		234,
		214,
		211,
		209,
		206,
		222,
		220,
		230,
		-1,
		-1,
		269,
		238,
		273,
		230,
		215,
		-1,
		209,
		220,
		226,
		230,
		224,
		217,
		231,
		227,
		-1,
		200,
		199,
		227,
		213,
		224,
		229,
		-1,
		-1,
		227,
		219,
		204,
		207,
		204,
		204,
		234,
		233,
		226,
		212,
		208,
		214,
		217,
		217,
		223,
		194,
		204,
		208,
		206,
		231,
		-1,
		-1,
		266,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		199,
		216,
		206,
		227,
		242,
		236,
		228,
		222,
		210,
		212,
		209,
		222,
		210,
		191,
		216,
		220,
		201,
		222,
		217,
		-1,
		265,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		228,
		-1,
		249,
		245,
		246,
		231,
		228,
		215,
		203,
		216,
		201,
		208,
		207,
		195,
		193,
		223,
		198,
		220,
		217,
		236,
		241,
		235,
		244,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		236,
		249,
		253,
		242,
		245,
		232,
		223,
		210,
		199,
		210,
		199,
		196,
		204,
		187,
		202,
		193,
		192,
		210,
		220,
		228,
		232,
		238,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		237,
		257,
		255,
		246,
		-1,
		241,
		238,
		228,
		206,
		191,
		208,
		200,
		198,
		200,
		182,
		196,
		187,
		205,
		212,
		210,
		214,
		234,
		246,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		280,
		252,
		-1,
		247,
		-1,
		239,
		256,
		-1,
		212,
		208,
		190,
		191,
		186,
		201,
		193,
		178,
		175,
		193,
		196,
		203,
		207,
		223,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		245,
		234,
		233,
		-1,
		224,
		226,
		223,
		211,
		198,
		183,
		184,
		192,
		204,
		183,
		177,
		174,
		194,
		220,
		198,
		209,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		263,
		256,
		244,
		209,
		209,
		203,
		-1,
		222,
		201,
		192,
		181,
		179,
		192,
		184,
		192,
		172,
		170,
		189,
		201,
		192,
		200,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		242,
		228,
		233,
		208,
		201,
		195,
		235,
		218,
		199,
		188,
		180,
		169,
		180,
		188,
		186,
		168,
		177,
		183,
		207,
		188,
		194,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		233,
		230,
		-1,
		200,
		-1,
		189,
		197,
		193,
		188,
		185,
		172,
		171,
		185,
		185,
		175,
		170,
		177,
		212,
		212,
		178,
		198,
		201,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		200,
		201,
		-1,
		194,
		188,
		194,
		193,
		191,
		176,
		180,
		182,
		185,
		173,
		179,
		180,
		162,
		186,
		-1,
		186,
		180,
		188,
		178,
		166,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		185,
		178,
		-1,
		181,
		181,
		188,
		183,
		179,
		181,
		178,
		167,
		180,
		173,
		167,
		161,
		174,
		178,
		179,
		168,
		164,
		161,
		175,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		193,
		185,
		176,
		170,
		176,
		194,
		192,
		207,
		191,
		193,
		189,
		181,
		176,
		162,
		155,
		166,
		151,
		169,
		175,
		166,
		161,
		160,
		171,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		171,
		187,
		-1,
		210,
		189,
		212,
		190,
		202,
		200,
		198,
		199,
		169,
		174,
		176,
		164,
		167,
		156,
		159,
		151,
		173,
		170,
		154,
		156,
		165,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		158,
		174,
		-1,
		-1,
		226,
		-1,
		180,
		182,
		214,
		212,
		188,
		163,
		170,
		188,
		161,
		156,
		161,
		150,
		150,
		145,
		164,
		150,
		148,
		163,
		179,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		191,
		-1,
		204,
		192,
		179,
		161,
		201,
		-1,
		162,
		158,
		165,
		-1,
		181,
		-1,
		153,
		156,
		147,
		142,
		139,
		150,
		148,
		157,
		158,
		-1,
		198,
		183,
		176,
		166,
		180,
		148,
		-1,
		182,
		-1,
		-1,
		191,
		185,
		185,
		154,
		151,
		178,
		158,
		150,
		165,
		164,
		151,
		150,
		138,
		138,
		141,
		135,
		148,
		158,
		164,
		156,
		-1,
		-1,
		-1,
		203,
		178,
		172,
		144,
		148,
		-1,
		-1,
		252,
		208,
		194,
		-1,
		146,
		178,
		166,
		156,
		146,
		151,
		152,
		142,
		140,
		136,
		145,
		144,
		137,
		136,
		157,
		150,
		172,
		-1,
		-1,
		177,
		170,
		158,
		126,
		121,
		-1,
		-1,
		-1,
		198,
		184,
		172,
		144,
		167,
		-1,
		-1,
		150,
		143,
		137,
		135,
		128,
		148,
		155,
		143,
		130,
		145,
		155,
		163,
		162,
		-1,
		180,
		167,
		-1,
		-1,
		120,
		110,
		-1,
		-1,
		-1,
		-1,
		162,
		143,
		138,
		133,
		137,
		149,
		-1,
		122,
		126,
		126,
		146,
		153,
		145,
		130,
		124,
		135,
		150,
		167,
		-1,
		-1,
		134,
		-1,
		96,
		-1,
		-1,
		-1,
		-1,
		134,
		149,
		126,
		119,
		123,
		-1,
		120,
		119,
		123,
		129,
		141,
		145,
		136,
		118,
		132,
		135,
		148,
		162,
		166,
		157,
		-1,
		87,
		-1,
		-1,
		-1,
		126,
		127,
		159,
		136,
		115,
		108,
		105,
		111,
		115,
		127,
		136,
		147,
		112,
		116,
		131,
		136,
		140,
		157,
		161,
		-1,
		-1,
		85,
		81,
		116,
		128,
		100,
		186,
		-1,
		-1,
		104,
		97,
		107,
		107,
		120,
		123,
		108,
		110,
		128,
		141,
		135,
		145,
		160,
		155,
		-1,
		-1,
		-1,
		83,
		-1,
		99,
		-1,
		-1,
		90,
		177,
		124,
		106,
		102,
		88,
		102,
		96,
		98,
		103,
		122,
		117,
		126,
		131,
		135,
		158,
		147,
		186,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		49,
		68,
		63,
		69,
		74,
		65,
		139,
		136,
		-1,
		84,
		125,
		93,
		107,
		103,
		110,
		115,
		121,
		125,
		132,
		148,
		147,
		142,
		178,
		169,
		175,
		-1,
		-1,
		139,
		128,
		117,
		123,
		-1,
		42,
		65,
		55,
		45,
		51,
		-1,
		-1,
		98,
		95,
		98,
		85,
		91,
		96,
		99,
		137,
		113,
		121,
		125,
		129,
		135,
		140,
		145,
		151,
		166,
		181,
		-1,
		93,
		130,
		123,
		91,
		99,
		130,
		-1,
		32,
		24,
		52,
		37,
		45,
		-1,
		-1,
		71,
		67,
		72,
		81,
		84,
		120,
		119,
		132,
		135,
		140,
		128,
		127,
		145,
		149,
		158,
		165,
		155,
		168,
		172,
		-1,
		86,
		106,
		85,
		88,
		112,
		126,
		-1,
		23,
		-1,
		-1,
		68,
		58,
		66,
		62,
		66,
		119,
		95,
		90,
		103,
		105,
		129,
		120,
		145,
		136,
		136,
		139,
		154,
		159,
		151,
		165,
		165,
		166,
		-1,
		75,
		86,
		79,
		-1,
		-1,
		-1,
		-1,
		17,
		-1,
		-1,
		84,
		-1,
		92,
		-1,
		85,
		89,
		103,
		106,
		128,
		115,
		122,
		139,
		145,
		134,
		144,
		140,
		141,
		150,
		161,
		173,
		172,
		173,
		100,
		56,
		59,
		70,
		81,
		96,
		100,
		-1,
		7,
		43,
		82,
		-1,
		93,
		-1,
		-1,
		-1,
		99,
		116,
		108,
		124,
		127,
		127,
		123,
		127,
		139,
		146,
		156,
		158,
		150,
		154,
		167,
		178,
		181,
		96,
		87,
		100,
		45,
		45,
		66,
		75,
		96,
		9,
		0,
		37,
		71,
		86,
		91,
		100,
		-1,
		-1,
		122,
		126,
		-1,
		-1,
		134,
		144,
		127,
		129,
		133,
		147,
		159,
		167,
		157,
		155,
		149,
		181,
		-1,
		89,
		88,
		77,
		74,
		50,
		41,
		36,
		63,
		-1,
		-1,
		12,
		28,
		41,
		45,
		61,
		86,
		-1,
		103,
		-1,
		-1,
		143,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		141,
		152,
		174,
		163,
		164,
		154,
		164,
		177,
		73,
		70,
		58,
		56,
		79,
		44,
		32,
		-1,
		27,
		15,
		21,
		28,
		45,
		75,
		-1,
		-1,
		119,
		110,
		-1,
		-1,
		162,
		169,
		171,
		-1,
		161,
		134,
		139,
		164,
		171,
		172,
		166,
		160,
		167,
		166,
		174,
		182,
		82,
		96,
		85,
		81,
		80,
		88,
		37,
		30,
		30,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		129,
		-1,
		-1,
		169,
		172,
		160,
		148,
		138,
		148,
		156,
		156,
		159,
		163,
		158,
		169,
		161,
		165,
		182,
		-1,
		116,
		-1,
		68,
		36,
		56,
		71,
		79,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		164,
		175,
		164,
		167,
		181,
		176,
		-1,
		-1,
		54,
		57,
		-1,
		-1,
		81,
		100,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		168,
		174,
		177,
		166,
		170,
		182,
		-1,
		-1,
		61,
		64,
		69,
		-1,
		90,
		-1,
		186,
		-1,
		131,
		147,
		149,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		186,
		184,
		175,
		172,
		179,
		177,
		173,
		184,
		-1,
		-1,
		-1,
		120,
		97,
		193,
		184,
		167,
		147,
		139,
		164,
		-1,
		175,
		-1,
		150,
		151,
		178,
		180,
		197,
		191,
		175,
		190,
		180,
		171,
		180,
		126,
		-1,
		101,
		160,
		143,
		153,
		138,
		150,
		196,
		-1,
		172,
		154,
		-1,
		182,
		172,
		214,
		195,
		188,
		175,
		182,
		184,
		177,
		-1,
		-1,
		-1,
		116,
		115,
		114,
		125,
		133,
		131,
		149,
		-1,
		184,
		166,
		145,
		162,
		162,
		153,
		161,
		204,
		200,
		193,
		195,
		185,
		-1,
		188,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		142,
		164,
		159,
		151,
		163,
		163,
		149,
		155,
		157,
		165,
		163,
		160,
		172,
		168,
		188,
		184,
		216,
		-1,
		195,
		-1,
		146,
		-1,
		-1,
		160,
		146,
		158,
		169,
		159,
		159,
		162,
		153,
		175,
		191,
		175,
		173,
		178,
		183,
		-1,
		205,
		206,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		205,
		166,
		-1,
		182,
		162,
		-1,
		184,
		180,
		-1,
		-1,
		217,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		200,
		184,
		-1,
		173,
		173,
		-1,
		-1,
		-1,
		220,
		204,
		-1,
		173,
		176,
		-1,
		167,
		173,
		202,
		175,
		179,
		-1,
		-1,
		-1,
		229,
		210,
		204,
		188,
		193,
		181,
		198,
		184,
		186,
		189,
		178,
		199,
		-1,
		-1,
		-1,
		201,
		193,
		193,
		-1,
		-1,
		211,
		194,
		194,
		198,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		202,
		-1,
		-1,
		207,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		212,
		-1,
		-1,
		-1,
		203,
		210,
		218,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		258,
		233,
		-1,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		242,
		226,
		-1,
		212,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		247,
		-1,
		247,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		260,
		252,
		260,
		-1,
		232,
		234,
		-1,
		282,
		-1,
		-1,
		275,
		266,
		-1,
		-1,
		237,
		244,
		266,
		269,
		305,
		-1,
		256
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		329,
		331,
		297,
		291,
		330,
		301,
		307,
		318,
		-1,
		-1,
		-1,
		320,
		319,
		289,
		287,
		296,
		301,
		308,
		-1,
		310,
		-1,
		341,
		320,
		331,
		336,
		282,
		279,
		299,
		318,
		303,
		295,
		356,
		312,
		283,
		277,
		295,
		288,
		297,
		289,
		-1,
		283,
		273,
		295,
		277,
		288,
		280,
		-1,
		-1,
		277,
		278,
		284,
		273,
		279,
		275,
		-1,
		285,
		269,
		-1,
		-1,
		267,
		271,
		255,
		258,
		266,
		264,
		277,
		269,
		264,
		-1,
		-1,
		261,
		257,
		264,
		251,
		247,
		264,
		277,
		259,
		273,
		272,
		-1,
		256,
		274,
		283,
		258,
		256,
		240,
		238,
		256,
		258,
		264,
		264,
		-1,
		248,
		250,
		272,
		280,
		280,
		256,
		243,
		243,
		253,
		246,
		265,
		253,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		245,
		253,
		276,
		268,
		258,
		273,
		266,
		246,
		243,
		241,
		238,
		254,
		252,
		262,
		-1,
		-1,
		301,
		270,
		305,
		262,
		247,
		-1,
		241,
		252,
		258,
		262,
		256,
		249,
		263,
		259,
		-1,
		232,
		231,
		259,
		245,
		256,
		261,
		-1,
		-1,
		259,
		251,
		236,
		239,
		236,
		236,
		266,
		265,
		258,
		244,
		240,
		246,
		249,
		249,
		255,
		226,
		236,
		240,
		238,
		263,
		-1,
		-1,
		298,
		-1,
		-1,
		258,
		241,
		-1,
		224,
		231,
		231,
		248,
		238,
		259,
		274,
		268,
		260,
		254,
		242,
		244,
		241,
		254,
		242,
		223,
		248,
		252,
		233,
		254,
		249,
		-1,
		297,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		217,
		220,
		226,
		250,
		260,
		-1,
		281,
		277,
		278,
		263,
		260,
		247,
		235,
		248,
		233,
		240,
		239,
		227,
		225,
		255,
		230,
		252,
		249,
		268,
		273,
		267,
		276,
		-1,
		266,
		262,
		258,
		265,
		214,
		-1,
		-1,
		254,
		-1,
		268,
		281,
		285,
		274,
		277,
		264,
		255,
		242,
		231,
		242,
		231,
		228,
		236,
		219,
		234,
		225,
		224,
		242,
		252,
		260,
		264,
		270,
		-1,
		316,
		-1,
		258,
		242,
		244,
		216,
		237,
		-1,
		274,
		269,
		289,
		287,
		278,
		-1,
		273,
		270,
		260,
		238,
		223,
		240,
		232,
		230,
		232,
		214,
		228,
		219,
		237,
		244,
		242,
		246,
		266,
		278,
		276,
		266,
		-1,
		248,
		253,
		212,
		220,
		239,
		312,
		284,
		-1,
		279,
		-1,
		271,
		288,
		-1,
		244,
		240,
		222,
		223,
		218,
		233,
		225,
		210,
		207,
		225,
		228,
		235,
		239,
		255,
		-1,
		-1,
		261,
		265,
		254,
		205,
		224,
		248,
		285,
		277,
		266,
		265,
		-1,
		256,
		258,
		255,
		243,
		230,
		215,
		216,
		224,
		236,
		215,
		209,
		206,
		226,
		252,
		230,
		241,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		231,
		202,
		226,
		268,
		295,
		288,
		276,
		241,
		241,
		235,
		-1,
		254,
		233,
		224,
		213,
		211,
		224,
		216,
		224,
		204,
		202,
		221,
		233,
		224,
		232,
		-1,
		-1,
		-1,
		261,
		250,
		251,
		197,
		220,
		257,
		274,
		260,
		265,
		240,
		233,
		227,
		267,
		250,
		231,
		220,
		212,
		201,
		212,
		220,
		218,
		200,
		209,
		215,
		239,
		220,
		226,
		-1,
		-1,
		268,
		258,
		242,
		244,
		241,
		211,
		218,
		250,
		265,
		262,
		-1,
		232,
		-1,
		221,
		229,
		225,
		220,
		217,
		204,
		203,
		217,
		217,
		207,
		202,
		209,
		244,
		244,
		210,
		230,
		233,
		-1,
		-1,
		-1,
		261,
		256,
		231,
		208,
		192,
		228,
		-1,
		232,
		233,
		-1,
		226,
		220,
		226,
		225,
		223,
		208,
		212,
		214,
		217,
		205,
		211,
		212,
		194,
		218,
		-1,
		218,
		212,
		220,
		210,
		198,
		-1,
		-1,
		-1,
		254,
		233,
		226,
		246,
		187,
		239,
		-1,
		-1,
		217,
		210,
		-1,
		213,
		213,
		220,
		215,
		211,
		213,
		210,
		199,
		212,
		205,
		199,
		193,
		206,
		210,
		211,
		200,
		196,
		193,
		207,
		-1,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		207,
		-1,
		225,
		217,
		208,
		202,
		208,
		226,
		224,
		239,
		223,
		225,
		221,
		213,
		208,
		194,
		187,
		198,
		183,
		201,
		207,
		198,
		193,
		192,
		203,
		-1,
		274,
		260,
		231,
		-1,
		-1,
		220,
		-1,
		184,
		203,
		219,
		-1,
		242,
		221,
		244,
		222,
		234,
		232,
		230,
		231,
		201,
		206,
		208,
		196,
		199,
		188,
		191,
		183,
		205,
		202,
		186,
		188,
		197,
		-1,
		280,
		267,
		225,
		221,
		210,
		230,
		181,
		190,
		206,
		-1,
		-1,
		258,
		-1,
		212,
		214,
		246,
		244,
		220,
		195,
		202,
		220,
		193,
		188,
		193,
		182,
		182,
		177,
		196,
		182,
		180,
		195,
		211,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		196,
		183,
		177,
		-1,
		223,
		-1,
		236,
		224,
		211,
		193,
		233,
		-1,
		194,
		190,
		197,
		-1,
		213,
		-1,
		185,
		188,
		179,
		174,
		171,
		182,
		180,
		189,
		190,
		-1,
		230,
		215,
		208,
		198,
		212,
		180,
		-1,
		214,
		-1,
		-1,
		223,
		217,
		217,
		186,
		183,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		170,
		170,
		173,
		167,
		180,
		190,
		196,
		188,
		-1,
		-1,
		-1,
		235,
		210,
		204,
		176,
		180,
		-1,
		-1,
		284,
		240,
		226,
		-1,
		178,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		168,
		177,
		176,
		169,
		168,
		189,
		182,
		204,
		-1,
		-1,
		209,
		202,
		190,
		158,
		153,
		-1,
		-1,
		-1,
		230,
		216,
		204,
		176,
		199,
		-1,
		-1,
		182,
		175,
		169,
		167,
		160,
		180,
		187,
		175,
		162,
		177,
		187,
		195,
		194,
		-1,
		212,
		199,
		-1,
		-1,
		152,
		142,
		-1,
		-1,
		-1,
		-1,
		194,
		175,
		170,
		165,
		169,
		181,
		-1,
		154,
		158,
		158,
		178,
		185,
		177,
		162,
		156,
		167,
		182,
		199,
		-1,
		-1,
		166,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		166,
		181,
		158,
		151,
		155,
		-1,
		152,
		151,
		155,
		161,
		173,
		177,
		168,
		150,
		164,
		167,
		180,
		194,
		198,
		189,
		-1,
		119,
		-1,
		-1,
		-1,
		158,
		159,
		191,
		168,
		147,
		140,
		137,
		143,
		147,
		159,
		168,
		179,
		144,
		148,
		163,
		168,
		172,
		189,
		193,
		-1,
		-1,
		117,
		113,
		148,
		160,
		132,
		218,
		-1,
		-1,
		136,
		129,
		139,
		139,
		152,
		155,
		140,
		142,
		160,
		173,
		167,
		177,
		192,
		187,
		-1,
		-1,
		-1,
		115,
		-1,
		131,
		-1,
		-1,
		122,
		209,
		156,
		138,
		134,
		120,
		134,
		128,
		130,
		135,
		154,
		149,
		158,
		163,
		167,
		190,
		179,
		218,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		81,
		100,
		95,
		101,
		106,
		97,
		171,
		168,
		-1,
		116,
		157,
		125,
		139,
		135,
		142,
		147,
		153,
		157,
		164,
		180,
		179,
		174,
		210,
		201,
		207,
		-1,
		-1,
		179,
		168,
		157,
		163,
		-1,
		74,
		97,
		87,
		77,
		83,
		-1,
		-1,
		130,
		127,
		130,
		117,
		123,
		128,
		131,
		169,
		145,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		133,
		170,
		163,
		131,
		139,
		170,
		-1,
		64,
		56,
		84,
		69,
		77,
		-1,
		-1,
		103,
		99,
		104,
		113,
		116,
		152,
		151,
		164,
		167,
		172,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		126,
		146,
		125,
		128,
		152,
		166,
		-1,
		54,
		-1,
		-1,
		100,
		90,
		98,
		94,
		98,
		151,
		127,
		122,
		135,
		137,
		161,
		152,
		177,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		115,
		126,
		119,
		-1,
		-1,
		-1,
		-1,
		49,
		-1,
		-1,
		116,
		-1,
		124,
		-1,
		117,
		121,
		135,
		138,
		160,
		147,
		154,
		171,
		177,
		166,
		176,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		140,
		96,
		99,
		110,
		121,
		136,
		140,
		-1,
		39,
		6,
		120,
		-1,
		125,
		-1,
		-1,
		-1,
		131,
		148,
		140,
		156,
		159,
		159,
		155,
		159,
		171,
		178,
		188,
		190,
		182,
		186,
		199,
		210,
		213,
		136,
		127,
		140,
		85,
		85,
		106,
		115,
		136,
		45,
		40,
		0,
		109,
		124,
		129,
		132,
		-1,
		-1,
		154,
		158,
		-1,
		-1,
		166,
		176,
		159,
		161,
		165,
		179,
		191,
		199,
		189,
		187,
		181,
		213,
		-1,
		129,
		128,
		117,
		114,
		90,
		81,
		76,
		103,
		-1,
		-1,
		51,
		64,
		79,
		83,
		99,
		124,
		-1,
		135,
		-1,
		-1,
		175,
		-1,
		-1,
		218,
		181,
		170,
		161,
		167,
		173,
		184,
		206,
		195,
		196,
		186,
		196,
		209,
		113,
		110,
		98,
		96,
		119,
		84,
		72,
		-1,
		67,
		55,
		61,
		66,
		83,
		113,
		-1,
		-1,
		151,
		142,
		-1,
		-1,
		194,
		201,
		203,
		-1,
		193,
		166,
		171,
		196,
		203,
		204,
		198,
		192,
		199,
		198,
		206,
		214,
		122,
		136,
		125,
		121,
		120,
		128,
		77,
		70,
		70,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		-1,
		186,
		161,
		-1,
		-1,
		201,
		204,
		192,
		180,
		170,
		180,
		188,
		188,
		191,
		195,
		190,
		201,
		193,
		197,
		214,
		-1,
		156,
		-1,
		108,
		76,
		96,
		111,
		119,
		-1,
		-1,
		-1,
		203,
		189,
		182,
		170,
		168,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		224,
		192,
		197,
		192,
		196,
		207,
		196,
		199,
		213,
		208,
		-1,
		-1,
		94,
		97,
		-1,
		-1,
		121,
		140,
		-1,
		194,
		183,
		168,
		160,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		181,
		206,
		195,
		203,
		198,
		200,
		206,
		209,
		198,
		202,
		214,
		-1,
		-1,
		101,
		104,
		109,
		-1,
		130,
		-1,
		218,
		-1,
		163,
		179,
		181,
		-1,
		-1,
		-1,
		219,
		182,
		203,
		213,
		218,
		216,
		207,
		204,
		211,
		209,
		205,
		216,
		-1,
		-1,
		-1,
		160,
		137,
		225,
		216,
		199,
		179,
		171,
		196,
		-1,
		207,
		-1,
		182,
		183,
		210,
		212,
		229,
		223,
		207,
		222,
		212,
		203,
		212,
		166,
		-1,
		141,
		200,
		183,
		185,
		178,
		184,
		228,
		-1,
		204,
		186,
		-1,
		214,
		204,
		246,
		227,
		220,
		207,
		214,
		216,
		209,
		-1,
		-1,
		-1,
		156,
		155,
		154,
		165,
		173,
		171,
		185,
		-1,
		216,
		198,
		177,
		194,
		194,
		185,
		193,
		236,
		232,
		225,
		227,
		217,
		-1,
		228,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		182,
		204,
		198,
		186,
		199,
		195,
		181,
		187,
		189,
		197,
		195,
		192,
		204,
		200,
		220,
		216,
		248,
		-1,
		235,
		-1,
		186,
		-1,
		-1,
		200,
		186,
		198,
		209,
		198,
		196,
		194,
		185,
		207,
		223,
		207,
		205,
		210,
		215,
		-1,
		245,
		246,
		-1,
		219,
		211,
		197,
		-1,
		190,
		-1,
		244,
		205,
		-1,
		214,
		194,
		-1,
		216,
		212,
		-1,
		-1,
		257,
		235,
		-1,
		-1,
		-1,
		220,
		200,
		239,
		223,
		-1,
		205,
		205,
		-1,
		-1,
		-1,
		260,
		244,
		-1,
		213,
		216,
		-1,
		207,
		213,
		242,
		207,
		211,
		-1,
		-1,
		-1,
		269,
		250,
		244,
		228,
		233,
		221,
		238,
		224,
		226,
		221,
		210,
		231,
		-1,
		-1,
		-1,
		241,
		233,
		233,
		-1,
		-1,
		251,
		234,
		232,
		230,
		-1,
		-1,
		-1,
		263,
		244,
		-1,
		-1,
		242,
		-1,
		-1,
		247,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		252,
		-1,
		-1,
		-1,
		243,
		250,
		251,
		-1,
		-1,
		-1,
		-1,
		273,
		274,
		298,
		273,
		-1,
		-1,
		-1,
		246,
		240,
		-1,
		-1,
		276,
		274,
		-1,
		-1,
		-1,
		274,
		258,
		-1,
		244,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		279,
		-1,
		279,
		254,
		261,
		-1,
		-1,
		-1,
		-1,
		292,
		284,
		292,
		-1,
		264,
		266,
		-1,
		314,
		-1,
		-1,
		307,
		298,
		-1,
		-1,
		269,
		276,
		298,
		301,
		337,
		-1,
		288
	],
	[
		-1,
		340,
		329,
		340,
		348,
		321,
		328,
		-1,
		348,
		351,
		317,
		311,
		350,
		320,
		326,
		337,
		-1,
		-1,
		-1,
		340,
		339,
		308,
		306,
		315,
		320,
		327,
		-1,
		326,
		-1,
		361,
		340,
		351,
		356,
		301,
		298,
		318,
		337,
		319,
		311,
		376,
		331,
		302,
		296,
		314,
		304,
		313,
		305,
		-1,
		302,
		292,
		314,
		293,
		304,
		296,
		-1,
		-1,
		296,
		297,
		303,
		289,
		295,
		291,
		-1,
		301,
		285,
		-1,
		-1,
		286,
		287,
		271,
		274,
		282,
		280,
		293,
		285,
		280,
		-1,
		-1,
		277,
		273,
		280,
		267,
		263,
		280,
		293,
		275,
		289,
		288,
		-1,
		276,
		294,
		303,
		274,
		272,
		256,
		254,
		272,
		274,
		280,
		280,
		-1,
		268,
		270,
		286,
		294,
		296,
		272,
		259,
		259,
		269,
		262,
		281,
		269,
		315,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		265,
		273,
		290,
		282,
		272,
		287,
		280,
		262,
		259,
		257,
		254,
		270,
		268,
		278,
		-1,
		-1,
		321,
		290,
		325,
		282,
		267,
		-1,
		261,
		266,
		272,
		276,
		270,
		263,
		277,
		273,
		-1,
		248,
		247,
		275,
		261,
		272,
		281,
		-1,
		-1,
		279,
		271,
		256,
		259,
		256,
		256,
		281,
		280,
		272,
		258,
		254,
		260,
		263,
		263,
		269,
		242,
		252,
		256,
		254,
		279,
		-1,
		-1,
		314,
		-1,
		-1,
		278,
		261,
		-1,
		244,
		251,
		251,
		268,
		258,
		279,
		291,
		282,
		274,
		268,
		256,
		258,
		255,
		268,
		256,
		239,
		264,
		268,
		249,
		270,
		265,
		-1,
		313,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		237,
		240,
		246,
		270,
		280,
		-1,
		301,
		291,
		292,
		277,
		274,
		261,
		249,
		262,
		247,
		254,
		253,
		243,
		241,
		271,
		246,
		268,
		265,
		284,
		289,
		283,
		292,
		-1,
		286,
		282,
		278,
		285,
		234,
		-1,
		-1,
		274,
		-1,
		288,
		301,
		305,
		288,
		291,
		278,
		269,
		256,
		245,
		256,
		245,
		242,
		250,
		235,
		250,
		241,
		240,
		258,
		268,
		276,
		280,
		286,
		-1,
		336,
		-1,
		278,
		262,
		264,
		236,
		257,
		-1,
		294,
		289,
		309,
		307,
		298,
		-1,
		287,
		284,
		274,
		252,
		237,
		254,
		246,
		244,
		248,
		230,
		244,
		235,
		253,
		260,
		258,
		262,
		282,
		294,
		296,
		286,
		-1,
		268,
		273,
		232,
		240,
		259,
		332,
		304,
		-1,
		299,
		-1,
		289,
		302,
		-1,
		258,
		254,
		236,
		237,
		232,
		247,
		241,
		226,
		223,
		241,
		244,
		251,
		255,
		271,
		-1,
		-1,
		281,
		285,
		274,
		225,
		244,
		268,
		305,
		297,
		286,
		285,
		-1,
		276,
		272,
		269,
		257,
		244,
		229,
		230,
		238,
		251,
		230,
		225,
		222,
		242,
		268,
		246,
		258,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		251,
		222,
		246,
		288,
		315,
		308,
		296,
		261,
		261,
		255,
		-1,
		268,
		247,
		238,
		227,
		225,
		238,
		235,
		240,
		220,
		218,
		237,
		249,
		240,
		257,
		-1,
		-1,
		-1,
		281,
		270,
		271,
		217,
		240,
		277,
		294,
		280,
		285,
		260,
		253,
		247,
		281,
		264,
		245,
		234,
		226,
		215,
		231,
		239,
		234,
		216,
		225,
		231,
		255,
		245,
		251,
		-1,
		-1,
		288,
		278,
		262,
		264,
		261,
		231,
		238,
		270,
		285,
		282,
		-1,
		252,
		-1,
		241,
		249,
		239,
		234,
		231,
		228,
		222,
		231,
		233,
		223,
		218,
		225,
		260,
		260,
		235,
		255,
		258,
		-1,
		-1,
		-1,
		281,
		276,
		251,
		228,
		212,
		248,
		-1,
		252,
		253,
		-1,
		246,
		240,
		246,
		241,
		237,
		232,
		236,
		229,
		236,
		229,
		227,
		228,
		210,
		242,
		-1,
		243,
		237,
		245,
		235,
		223,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		237,
		230,
		-1,
		233,
		233,
		240,
		239,
		233,
		237,
		234,
		223,
		236,
		229,
		215,
		217,
		230,
		234,
		238,
		225,
		221,
		218,
		232,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		245,
		237,
		228,
		222,
		228,
		246,
		244,
		261,
		245,
		248,
		246,
		237,
		236,
		218,
		211,
		218,
		207,
		225,
		233,
		225,
		219,
		218,
		228,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		223,
		239,
		-1,
		262,
		241,
		264,
		242,
		256,
		252,
		258,
		259,
		229,
		234,
		236,
		224,
		223,
		212,
		215,
		207,
		229,
		229,
		213,
		214,
		218,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		210,
		226,
		-1,
		-1,
		300,
		-1,
		240,
		256,
		266,
		264,
		248,
		223,
		230,
		248,
		221,
		216,
		217,
		206,
		206,
		201,
		223,
		209,
		207,
		216,
		232,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		243,
		-1,
		278,
		266,
		253,
		235,
		275,
		-1,
		222,
		218,
		225,
		-1,
		241,
		-1,
		213,
		216,
		207,
		198,
		195,
		206,
		204,
		215,
		211,
		-1,
		250,
		235,
		228,
		218,
		232,
		200,
		-1,
		234,
		-1,
		-1,
		265,
		259,
		259,
		228,
		225,
		238,
		218,
		210,
		225,
		224,
		211,
		210,
		198,
		198,
		201,
		194,
		207,
		217,
		222,
		209,
		-1,
		-1,
		-1,
		255,
		230,
		224,
		196,
		200,
		-1,
		-1,
		326,
		282,
		268,
		-1,
		220,
		238,
		226,
		216,
		206,
		211,
		212,
		202,
		200,
		196,
		205,
		204,
		196,
		195,
		211,
		203,
		225,
		-1,
		-1,
		229,
		222,
		210,
		178,
		173,
		-1,
		-1,
		-1,
		272,
		258,
		246,
		218,
		227,
		-1,
		-1,
		210,
		203,
		197,
		200,
		188,
		208,
		215,
		203,
		189,
		204,
		208,
		216,
		207,
		-1,
		232,
		219,
		-1,
		-1,
		172,
		162,
		-1,
		-1,
		-1,
		-1,
		236,
		216,
		205,
		200,
		204,
		209,
		-1,
		183,
		194,
		187,
		206,
		213,
		205,
		190,
		184,
		191,
		203,
		212,
		-1,
		-1,
		186,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		208,
		222,
		193,
		186,
		190,
		-1,
		185,
		187,
		184,
		196,
		201,
		205,
		196,
		178,
		184,
		188,
		192,
		206,
		210,
		209,
		-1,
		139,
		-1,
		-1,
		-1,
		185,
		207,
		226,
		203,
		182,
		175,
		172,
		171,
		176,
		187,
		196,
		207,
		172,
		176,
		181,
		180,
		184,
		201,
		205,
		-1,
		-1,
		137,
		133,
		168,
		180,
		180,
		253,
		-1,
		-1,
		171,
		164,
		174,
		167,
		180,
		183,
		168,
		170,
		187,
		185,
		179,
		189,
		204,
		199,
		-1,
		-1,
		-1,
		149,
		-1,
		151,
		-1,
		-1,
		170,
		244,
		191,
		173,
		169,
		155,
		162,
		156,
		158,
		163,
		182,
		177,
		181,
		175,
		179,
		202,
		191,
		230,
		-1,
		-1,
		202,
		-1,
		-1,
		-1,
		134,
		120,
		115,
		149,
		154,
		145,
		206,
		203,
		-1,
		152,
		185,
		153,
		167,
		163,
		170,
		175,
		180,
		169,
		176,
		192,
		191,
		186,
		222,
		213,
		219,
		-1,
		-1,
		195,
		184,
		173,
		179,
		-1,
		127,
		117,
		135,
		125,
		131,
		-1,
		-1,
		170,
		167,
		165,
		145,
		151,
		156,
		159,
		177,
		153,
		165,
		169,
		173,
		179,
		184,
		189,
		195,
		210,
		225,
		-1,
		149,
		186,
		179,
		147,
		155,
		186,
		-1,
		117,
		109,
		114,
		117,
		125,
		-1,
		-1,
		143,
		134,
		139,
		148,
		149,
		180,
		179,
		173,
		179,
		180,
		172,
		171,
		189,
		193,
		202,
		209,
		199,
		212,
		216,
		-1,
		142,
		162,
		141,
		144,
		168,
		182,
		-1,
		108,
		-1,
		-1,
		74,
		138,
		146,
		142,
		139,
		186,
		162,
		157,
		163,
		165,
		171,
		162,
		187,
		180,
		180,
		183,
		198,
		203,
		195,
		209,
		209,
		210,
		-1,
		131,
		142,
		135,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		64,
		-1,
		172,
		-1,
		162,
		166,
		170,
		173,
		188,
		175,
		165,
		173,
		179,
		178,
		184,
		184,
		185,
		194,
		205,
		217,
		216,
		217,
		156,
		112,
		115,
		126,
		137,
		152,
		156,
		-1,
		92,
		125,
		11,
		-1,
		54,
		-1,
		-1,
		-1,
		176,
		183,
		175,
		191,
		187,
		187,
		157,
		161,
		174,
		181,
		191,
		202,
		194,
		198,
		211,
		222,
		225,
		152,
		143,
		156,
		101,
		101,
		122,
		131,
		152,
		76,
		85,
		119,
		0,
		15,
		20,
		44,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		194,
		165,
		153,
		163,
		167,
		181,
		193,
		206,
		194,
		199,
		193,
		225,
		-1,
		145,
		144,
		133,
		130,
		106,
		97,
		92,
		119,
		-1,
		-1,
		74,
		110,
		56,
		33,
		31,
		56,
		-1,
		51,
		-1,
		-1,
		205,
		-1,
		-1,
		190,
		170,
		159,
		150,
		155,
		175,
		186,
		208,
		190,
		207,
		198,
		208,
		212,
		129,
		126,
		114,
		112,
		135,
		100,
		88,
		-1,
		77,
		71,
		67,
		54,
		34,
		45,
		-1,
		-1,
		67,
		58,
		-1,
		-1,
		188,
		186,
		175,
		-1,
		165,
		147,
		152,
		182,
		184,
		186,
		193,
		187,
		194,
		202,
		213,
		205,
		138,
		152,
		141,
		137,
		136,
		144,
		93,
		86,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		-1,
		102,
		77,
		-1,
		-1,
		183,
		176,
		164,
		152,
		142,
		152,
		169,
		169,
		172,
		177,
		185,
		196,
		192,
		196,
		199,
		-1,
		172,
		-1,
		124,
		92,
		112,
		127,
		135,
		-1,
		-1,
		-1,
		119,
		105,
		98,
		86,
		84,
		-1,
		217,
		201,
		182,
		-1,
		152,
		165,
		205,
		173,
		178,
		173,
		188,
		199,
		190,
		198,
		192,
		195,
		-1,
		-1,
		110,
		113,
		-1,
		-1,
		137,
		156,
		-1,
		110,
		99,
		84,
		76,
		-1,
		-1,
		189,
		185,
		-1,
		-1,
		139,
		177,
		176,
		184,
		179,
		184,
		196,
		192,
		188,
		198,
		189,
		-1,
		-1,
		117,
		120,
		125,
		-1,
		142,
		-1,
		134,
		-1,
		79,
		95,
		97,
		-1,
		-1,
		-1,
		170,
		133,
		149,
		172,
		198,
		196,
		187,
		180,
		187,
		190,
		183,
		189,
		-1,
		-1,
		-1,
		160,
		134,
		141,
		132,
		115,
		95,
		87,
		112,
		-1,
		151,
		-1,
		126,
		129,
		154,
		193,
		195,
		181,
		177,
		190,
		184,
		181,
		179,
		166,
		-1,
		136,
		169,
		133,
		101,
		101,
		100,
		165,
		-1,
		148,
		130,
		-1,
		158,
		148,
		196,
		171,
		180,
		173,
		167,
		168,
		176,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		121,
		106,
		101,
		-1,
		153,
		135,
		121,
		138,
		138,
		129,
		137,
		186,
		182,
		185,
		183,
		161,
		-1,
		244,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		141,
		114,
		102,
		116,
		123,
		118,
		120,
		133,
		141,
		139,
		136,
		148,
		144,
		164,
		160,
		192,
		-1,
		247,
		-1,
		168,
		-1,
		-1,
		148,
		134,
		136,
		125,
		114,
		112,
		115,
		113,
		135,
		165,
		151,
		149,
		154,
		159,
		-1,
		236,
		235,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		160,
		121,
		-1,
		142,
		122,
		-1,
		160,
		156,
		-1,
		-1,
		223,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		155,
		139,
		-1,
		133,
		133,
		-1,
		-1,
		-1,
		208,
		192,
		-1,
		161,
		164,
		-1,
		155,
		161,
		188,
		135,
		139,
		-1,
		-1,
		-1,
		217,
		198,
		192,
		176,
		181,
		169,
		186,
		172,
		171,
		149,
		138,
		159,
		-1,
		-1,
		-1,
		189,
		181,
		181,
		-1,
		-1,
		196,
		179,
		160,
		158,
		-1,
		-1,
		-1,
		211,
		192,
		-1,
		-1,
		186,
		-1,
		-1,
		192,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		200,
		-1,
		-1,
		-1,
		182,
		178,
		179,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		246,
		221,
		-1,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		202,
		186,
		-1,
		172,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		207,
		-1,
		207,
		182,
		189,
		-1,
		-1,
		-1,
		-1,
		220,
		212,
		220,
		-1,
		192,
		194,
		-1,
		242,
		-1,
		-1,
		235,
		226,
		-1,
		-1,
		197,
		204,
		226,
		229,
		265,
		-1,
		216
	],
	[
		-1,
		325,
		314,
		325,
		333,
		306,
		313,
		-1,
		333,
		336,
		302,
		296,
		335,
		305,
		311,
		322,
		-1,
		-1,
		-1,
		325,
		324,
		293,
		291,
		300,
		305,
		312,
		-1,
		311,
		-1,
		346,
		325,
		336,
		341,
		286,
		283,
		303,
		322,
		304,
		296,
		361,
		316,
		287,
		281,
		299,
		289,
		298,
		290,
		-1,
		287,
		277,
		299,
		278,
		289,
		281,
		-1,
		-1,
		281,
		282,
		288,
		274,
		280,
		276,
		-1,
		286,
		270,
		-1,
		-1,
		271,
		272,
		256,
		259,
		267,
		265,
		278,
		270,
		265,
		-1,
		-1,
		262,
		258,
		265,
		252,
		248,
		265,
		278,
		260,
		274,
		273,
		-1,
		261,
		279,
		288,
		259,
		257,
		241,
		239,
		257,
		259,
		265,
		265,
		-1,
		253,
		255,
		271,
		279,
		281,
		257,
		244,
		244,
		254,
		247,
		266,
		254,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		250,
		258,
		275,
		267,
		257,
		272,
		265,
		247,
		244,
		242,
		239,
		255,
		253,
		263,
		-1,
		-1,
		306,
		275,
		310,
		267,
		252,
		-1,
		246,
		251,
		257,
		261,
		255,
		248,
		262,
		258,
		-1,
		233,
		232,
		260,
		246,
		257,
		266,
		-1,
		-1,
		264,
		256,
		241,
		244,
		241,
		241,
		266,
		265,
		257,
		243,
		239,
		245,
		248,
		248,
		254,
		227,
		237,
		241,
		239,
		264,
		-1,
		-1,
		299,
		-1,
		-1,
		263,
		246,
		-1,
		229,
		236,
		236,
		253,
		243,
		264,
		276,
		267,
		259,
		253,
		241,
		243,
		240,
		253,
		241,
		224,
		249,
		253,
		234,
		255,
		250,
		-1,
		298,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		222,
		225,
		231,
		255,
		265,
		-1,
		286,
		276,
		277,
		262,
		259,
		246,
		234,
		247,
		232,
		239,
		238,
		228,
		226,
		256,
		231,
		253,
		250,
		269,
		274,
		268,
		277,
		-1,
		271,
		267,
		263,
		270,
		219,
		-1,
		-1,
		259,
		-1,
		273,
		286,
		290,
		273,
		276,
		263,
		254,
		241,
		230,
		241,
		230,
		227,
		235,
		220,
		235,
		226,
		225,
		243,
		253,
		261,
		265,
		271,
		-1,
		321,
		-1,
		263,
		247,
		249,
		221,
		242,
		-1,
		279,
		274,
		294,
		292,
		283,
		-1,
		272,
		269,
		259,
		237,
		222,
		239,
		231,
		229,
		233,
		215,
		229,
		220,
		238,
		245,
		243,
		247,
		267,
		279,
		281,
		271,
		-1,
		253,
		258,
		217,
		225,
		244,
		317,
		289,
		-1,
		284,
		-1,
		274,
		287,
		-1,
		243,
		239,
		221,
		222,
		217,
		232,
		226,
		211,
		208,
		226,
		229,
		236,
		240,
		256,
		-1,
		-1,
		266,
		270,
		259,
		210,
		229,
		253,
		290,
		282,
		271,
		270,
		-1,
		261,
		257,
		254,
		242,
		229,
		214,
		215,
		223,
		236,
		215,
		210,
		207,
		227,
		253,
		231,
		243,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		236,
		207,
		231,
		273,
		300,
		293,
		281,
		246,
		246,
		240,
		-1,
		253,
		232,
		223,
		212,
		210,
		223,
		220,
		225,
		205,
		203,
		222,
		234,
		225,
		242,
		-1,
		-1,
		-1,
		266,
		255,
		256,
		202,
		225,
		262,
		279,
		265,
		270,
		245,
		238,
		232,
		266,
		249,
		230,
		219,
		211,
		200,
		216,
		224,
		219,
		201,
		210,
		216,
		240,
		230,
		236,
		-1,
		-1,
		273,
		263,
		247,
		249,
		246,
		216,
		223,
		255,
		270,
		267,
		-1,
		237,
		-1,
		226,
		234,
		224,
		219,
		216,
		213,
		207,
		216,
		218,
		208,
		203,
		210,
		245,
		245,
		220,
		240,
		243,
		-1,
		-1,
		-1,
		266,
		261,
		236,
		213,
		197,
		233,
		-1,
		237,
		238,
		-1,
		231,
		225,
		231,
		226,
		222,
		217,
		221,
		214,
		221,
		214,
		212,
		213,
		195,
		227,
		-1,
		228,
		222,
		230,
		220,
		208,
		-1,
		-1,
		-1,
		259,
		238,
		231,
		251,
		192,
		244,
		-1,
		-1,
		222,
		215,
		-1,
		218,
		218,
		225,
		224,
		218,
		222,
		219,
		208,
		221,
		214,
		200,
		202,
		215,
		219,
		223,
		210,
		206,
		203,
		217,
		-1,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		212,
		-1,
		230,
		222,
		213,
		207,
		213,
		231,
		229,
		246,
		230,
		233,
		231,
		222,
		230,
		203,
		196,
		203,
		192,
		210,
		218,
		210,
		204,
		203,
		213,
		-1,
		279,
		265,
		236,
		-1,
		-1,
		225,
		-1,
		189,
		208,
		224,
		-1,
		247,
		226,
		249,
		227,
		241,
		237,
		253,
		254,
		231,
		231,
		229,
		220,
		208,
		197,
		200,
		192,
		214,
		214,
		198,
		199,
		203,
		-1,
		285,
		272,
		230,
		226,
		215,
		235,
		186,
		195,
		211,
		-1,
		-1,
		285,
		-1,
		225,
		241,
		251,
		249,
		243,
		225,
		232,
		240,
		217,
		212,
		202,
		191,
		191,
		186,
		208,
		194,
		192,
		201,
		217,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		201,
		188,
		182,
		-1,
		228,
		-1,
		263,
		251,
		238,
		220,
		260,
		-1,
		224,
		220,
		227,
		-1,
		237,
		-1,
		210,
		207,
		198,
		183,
		180,
		191,
		189,
		200,
		196,
		-1,
		235,
		220,
		213,
		203,
		217,
		185,
		-1,
		219,
		-1,
		-1,
		250,
		244,
		244,
		213,
		210,
		240,
		220,
		212,
		227,
		226,
		213,
		212,
		196,
		189,
		186,
		179,
		192,
		202,
		207,
		194,
		-1,
		-1,
		-1,
		240,
		215,
		209,
		181,
		185,
		-1,
		-1,
		311,
		267,
		253,
		-1,
		205,
		240,
		228,
		218,
		208,
		213,
		214,
		204,
		202,
		194,
		196,
		190,
		181,
		180,
		196,
		188,
		210,
		-1,
		-1,
		214,
		207,
		195,
		163,
		158,
		-1,
		-1,
		-1,
		257,
		243,
		231,
		203,
		229,
		-1,
		-1,
		212,
		205,
		199,
		200,
		190,
		210,
		205,
		189,
		174,
		189,
		193,
		201,
		192,
		-1,
		217,
		204,
		-1,
		-1,
		157,
		147,
		-1,
		-1,
		-1,
		-1,
		221,
		202,
		203,
		198,
		202,
		211,
		-1,
		185,
		191,
		189,
		208,
		215,
		191,
		176,
		170,
		176,
		188,
		197,
		-1,
		-1,
		171,
		-1,
		133,
		-1,
		-1,
		-1,
		-1,
		193,
		208,
		191,
		184,
		188,
		-1,
		185,
		184,
		186,
		194,
		194,
		191,
		182,
		173,
		169,
		173,
		177,
		191,
		195,
		194,
		-1,
		124,
		-1,
		-1,
		-1,
		170,
		192,
		224,
		201,
		180,
		173,
		170,
		173,
		178,
		189,
		198,
		209,
		174,
		176,
		166,
		165,
		169,
		186,
		190,
		-1,
		-1,
		122,
		118,
		153,
		165,
		165,
		251,
		-1,
		-1,
		169,
		162,
		172,
		169,
		182,
		185,
		170,
		172,
		172,
		170,
		164,
		174,
		189,
		184,
		-1,
		-1,
		-1,
		134,
		-1,
		136,
		-1,
		-1,
		155,
		242,
		189,
		171,
		167,
		153,
		167,
		161,
		160,
		165,
		175,
		169,
		166,
		160,
		164,
		187,
		176,
		215,
		-1,
		-1,
		213,
		-1,
		-1,
		-1,
		141,
		105,
		100,
		134,
		139,
		130,
		204,
		201,
		-1,
		149,
		190,
		158,
		172,
		156,
		163,
		168,
		165,
		154,
		161,
		177,
		176,
		171,
		207,
		198,
		204,
		-1,
		-1,
		206,
		195,
		184,
		190,
		-1,
		134,
		102,
		120,
		110,
		116,
		-1,
		-1,
		163,
		160,
		163,
		150,
		156,
		157,
		152,
		162,
		138,
		150,
		154,
		158,
		164,
		169,
		174,
		180,
		195,
		210,
		-1,
		160,
		197,
		190,
		158,
		166,
		197,
		-1,
		124,
		116,
		99,
		102,
		110,
		-1,
		-1,
		136,
		132,
		137,
		146,
		149,
		176,
		175,
		158,
		164,
		165,
		157,
		156,
		174,
		178,
		187,
		194,
		184,
		197,
		201,
		-1,
		153,
		173,
		152,
		155,
		179,
		193,
		-1,
		119,
		-1,
		-1,
		59,
		123,
		131,
		127,
		131,
		184,
		160,
		155,
		163,
		161,
		156,
		147,
		172,
		165,
		165,
		168,
		183,
		188,
		180,
		194,
		194,
		195,
		-1,
		142,
		153,
		146,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		49,
		-1,
		157,
		-1,
		150,
		154,
		168,
		171,
		177,
		164,
		150,
		158,
		164,
		163,
		169,
		169,
		170,
		179,
		190,
		202,
		201,
		202,
		167,
		123,
		126,
		137,
		148,
		163,
		167,
		-1,
		103,
		136,
		4,
		-1,
		39,
		-1,
		-1,
		-1,
		164,
		181,
		173,
		189,
		176,
		176,
		142,
		146,
		159,
		166,
		176,
		187,
		179,
		183,
		196,
		207,
		210,
		163,
		154,
		167,
		112,
		112,
		133,
		142,
		163,
		87,
		96,
		130,
		11,
		0,
		5,
		29,
		-1,
		-1,
		187,
		191,
		-1,
		-1,
		183,
		150,
		138,
		148,
		152,
		166,
		178,
		191,
		179,
		184,
		178,
		210,
		-1,
		156,
		155,
		144,
		141,
		117,
		108,
		103,
		130,
		-1,
		-1,
		85,
		121,
		67,
		44,
		42,
		67,
		-1,
		36,
		-1,
		-1,
		190,
		-1,
		-1,
		175,
		155,
		144,
		135,
		140,
		160,
		171,
		193,
		175,
		192,
		183,
		193,
		197,
		140,
		137,
		125,
		123,
		146,
		111,
		99,
		-1,
		88,
		82,
		78,
		65,
		45,
		56,
		-1,
		-1,
		52,
		43,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		132,
		137,
		167,
		169,
		171,
		178,
		172,
		179,
		187,
		198,
		190,
		149,
		163,
		152,
		148,
		147,
		155,
		104,
		97,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		87,
		62,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		154,
		154,
		157,
		162,
		170,
		181,
		177,
		181,
		184,
		-1,
		183,
		-1,
		135,
		103,
		123,
		138,
		146,
		-1,
		-1,
		-1,
		104,
		90,
		83,
		71,
		69,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		190,
		158,
		163,
		158,
		173,
		184,
		175,
		183,
		177,
		180,
		-1,
		-1,
		121,
		124,
		-1,
		-1,
		142,
		144,
		-1,
		95,
		84,
		69,
		61,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		124,
		162,
		161,
		169,
		164,
		169,
		181,
		177,
		173,
		183,
		174,
		-1,
		-1,
		128,
		131,
		136,
		-1,
		127,
		-1,
		119,
		-1,
		64,
		80,
		82,
		-1,
		-1,
		-1,
		155,
		118,
		134,
		157,
		183,
		181,
		172,
		165,
		172,
		175,
		168,
		174,
		-1,
		-1,
		-1,
		145,
		119,
		126,
		117,
		100,
		80,
		72,
		97,
		-1,
		136,
		-1,
		111,
		114,
		139,
		178,
		180,
		166,
		162,
		175,
		169,
		166,
		164,
		151,
		-1,
		121,
		154,
		118,
		86,
		86,
		85,
		150,
		-1,
		133,
		115,
		-1,
		143,
		133,
		181,
		156,
		165,
		158,
		152,
		153,
		161,
		-1,
		-1,
		-1,
		123,
		122,
		114,
		108,
		106,
		91,
		86,
		-1,
		138,
		120,
		106,
		123,
		123,
		114,
		122,
		171,
		167,
		170,
		168,
		146,
		-1,
		237,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		117,
		126,
		99,
		87,
		101,
		108,
		103,
		105,
		118,
		126,
		124,
		121,
		133,
		129,
		149,
		145,
		177,
		-1,
		232,
		-1,
		153,
		-1,
		-1,
		133,
		119,
		121,
		110,
		99,
		97,
		100,
		98,
		120,
		150,
		136,
		134,
		139,
		144,
		-1,
		221,
		220,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		145,
		106,
		-1,
		127,
		107,
		-1,
		145,
		141,
		-1,
		-1,
		208,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		140,
		124,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		146,
		149,
		-1,
		140,
		146,
		173,
		120,
		124,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		161,
		166,
		154,
		171,
		157,
		156,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		174,
		166,
		166,
		-1,
		-1,
		181,
		164,
		145,
		143,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		171,
		-1,
		-1,
		177,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		185,
		-1,
		-1,
		-1,
		167,
		163,
		164,
		-1,
		-1,
		-1,
		-1,
		206,
		207,
		231,
		206,
		-1,
		-1,
		-1,
		159,
		153,
		-1,
		-1,
		209,
		207,
		-1,
		-1,
		-1,
		187,
		171,
		-1,
		157,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		192,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		205,
		197,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		220,
		211,
		-1,
		-1,
		182,
		189,
		211,
		214,
		250,
		-1,
		201
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		328,
		331,
		297,
		291,
		330,
		300,
		306,
		317,
		-1,
		-1,
		-1,
		320,
		319,
		288,
		286,
		295,
		300,
		307,
		-1,
		306,
		-1,
		341,
		320,
		331,
		336,
		281,
		278,
		298,
		317,
		299,
		291,
		356,
		311,
		282,
		276,
		294,
		284,
		293,
		285,
		-1,
		282,
		272,
		294,
		273,
		284,
		276,
		-1,
		-1,
		276,
		277,
		283,
		269,
		275,
		271,
		-1,
		281,
		265,
		-1,
		-1,
		266,
		267,
		251,
		254,
		262,
		260,
		273,
		265,
		260,
		-1,
		-1,
		257,
		253,
		260,
		247,
		243,
		260,
		273,
		255,
		269,
		268,
		-1,
		256,
		274,
		283,
		254,
		252,
		236,
		234,
		252,
		254,
		260,
		260,
		-1,
		248,
		250,
		266,
		274,
		276,
		252,
		239,
		239,
		249,
		242,
		261,
		249,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		245,
		253,
		270,
		262,
		252,
		267,
		260,
		242,
		239,
		237,
		234,
		250,
		248,
		258,
		-1,
		-1,
		301,
		270,
		305,
		262,
		247,
		-1,
		241,
		246,
		252,
		256,
		250,
		243,
		257,
		253,
		-1,
		228,
		227,
		255,
		241,
		252,
		261,
		-1,
		-1,
		259,
		251,
		236,
		239,
		236,
		236,
		261,
		260,
		252,
		238,
		234,
		240,
		243,
		243,
		249,
		222,
		232,
		236,
		234,
		259,
		-1,
		-1,
		294,
		-1,
		-1,
		258,
		241,
		-1,
		224,
		231,
		231,
		248,
		238,
		259,
		271,
		262,
		254,
		248,
		236,
		238,
		235,
		248,
		236,
		219,
		244,
		248,
		229,
		250,
		245,
		-1,
		293,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		217,
		220,
		226,
		250,
		260,
		-1,
		281,
		271,
		272,
		257,
		254,
		241,
		229,
		242,
		227,
		234,
		233,
		223,
		221,
		251,
		226,
		248,
		245,
		264,
		269,
		263,
		272,
		-1,
		266,
		262,
		258,
		265,
		214,
		-1,
		-1,
		254,
		-1,
		268,
		281,
		285,
		268,
		271,
		258,
		249,
		236,
		225,
		236,
		225,
		222,
		230,
		215,
		230,
		221,
		220,
		238,
		248,
		256,
		260,
		266,
		-1,
		316,
		-1,
		258,
		242,
		244,
		216,
		237,
		-1,
		274,
		269,
		289,
		287,
		278,
		-1,
		267,
		264,
		254,
		232,
		217,
		234,
		226,
		224,
		228,
		210,
		224,
		215,
		233,
		240,
		238,
		242,
		262,
		274,
		276,
		266,
		-1,
		248,
		253,
		212,
		220,
		239,
		312,
		284,
		-1,
		279,
		-1,
		269,
		282,
		-1,
		238,
		234,
		216,
		217,
		212,
		227,
		221,
		206,
		203,
		221,
		224,
		231,
		235,
		251,
		-1,
		-1,
		261,
		265,
		254,
		205,
		224,
		248,
		285,
		277,
		266,
		265,
		-1,
		256,
		252,
		249,
		237,
		224,
		209,
		210,
		218,
		231,
		210,
		205,
		202,
		222,
		248,
		226,
		238,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		231,
		202,
		226,
		268,
		295,
		288,
		276,
		241,
		241,
		235,
		-1,
		248,
		227,
		218,
		207,
		205,
		218,
		215,
		220,
		200,
		198,
		217,
		229,
		220,
		237,
		-1,
		-1,
		-1,
		261,
		250,
		251,
		197,
		220,
		257,
		274,
		260,
		265,
		240,
		233,
		227,
		261,
		244,
		225,
		214,
		206,
		195,
		211,
		219,
		214,
		196,
		205,
		211,
		235,
		225,
		231,
		-1,
		-1,
		268,
		258,
		242,
		244,
		241,
		211,
		218,
		250,
		265,
		262,
		-1,
		232,
		-1,
		221,
		229,
		219,
		214,
		211,
		208,
		202,
		211,
		213,
		203,
		198,
		205,
		240,
		240,
		215,
		235,
		238,
		-1,
		-1,
		-1,
		261,
		256,
		231,
		208,
		192,
		228,
		-1,
		232,
		233,
		-1,
		226,
		220,
		226,
		221,
		217,
		212,
		216,
		209,
		216,
		209,
		207,
		208,
		190,
		222,
		-1,
		223,
		217,
		225,
		215,
		203,
		-1,
		-1,
		-1,
		254,
		233,
		226,
		246,
		187,
		239,
		-1,
		-1,
		217,
		210,
		-1,
		213,
		213,
		220,
		219,
		213,
		217,
		214,
		203,
		216,
		209,
		195,
		197,
		210,
		214,
		218,
		205,
		201,
		198,
		212,
		-1,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		207,
		-1,
		225,
		217,
		208,
		202,
		208,
		226,
		224,
		241,
		225,
		228,
		226,
		217,
		225,
		198,
		191,
		198,
		187,
		205,
		213,
		205,
		199,
		198,
		208,
		-1,
		274,
		260,
		231,
		-1,
		-1,
		220,
		-1,
		184,
		203,
		219,
		-1,
		242,
		221,
		244,
		222,
		236,
		232,
		248,
		249,
		226,
		226,
		224,
		215,
		203,
		192,
		195,
		187,
		209,
		209,
		193,
		194,
		198,
		-1,
		280,
		267,
		225,
		221,
		210,
		230,
		181,
		190,
		206,
		-1,
		-1,
		280,
		-1,
		220,
		236,
		246,
		244,
		238,
		220,
		227,
		235,
		212,
		207,
		197,
		186,
		186,
		181,
		203,
		189,
		187,
		196,
		212,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		196,
		183,
		177,
		-1,
		223,
		-1,
		258,
		246,
		233,
		215,
		255,
		-1,
		219,
		215,
		222,
		-1,
		232,
		-1,
		205,
		202,
		193,
		178,
		175,
		186,
		184,
		195,
		191,
		-1,
		230,
		215,
		208,
		198,
		212,
		180,
		-1,
		214,
		-1,
		-1,
		245,
		239,
		239,
		208,
		205,
		235,
		215,
		207,
		222,
		221,
		208,
		207,
		191,
		184,
		181,
		174,
		187,
		197,
		202,
		189,
		-1,
		-1,
		-1,
		235,
		210,
		204,
		176,
		180,
		-1,
		-1,
		306,
		262,
		248,
		-1,
		200,
		235,
		223,
		213,
		203,
		208,
		209,
		199,
		197,
		189,
		191,
		185,
		176,
		175,
		191,
		183,
		205,
		-1,
		-1,
		209,
		202,
		190,
		158,
		153,
		-1,
		-1,
		-1,
		252,
		238,
		226,
		198,
		224,
		-1,
		-1,
		207,
		200,
		194,
		195,
		185,
		205,
		200,
		184,
		169,
		184,
		188,
		196,
		187,
		-1,
		212,
		199,
		-1,
		-1,
		152,
		142,
		-1,
		-1,
		-1,
		-1,
		216,
		197,
		198,
		193,
		197,
		206,
		-1,
		180,
		186,
		184,
		203,
		210,
		186,
		171,
		165,
		171,
		183,
		192,
		-1,
		-1,
		166,
		-1,
		128,
		-1,
		-1,
		-1,
		-1,
		188,
		203,
		186,
		179,
		183,
		-1,
		180,
		179,
		181,
		189,
		189,
		186,
		177,
		168,
		164,
		168,
		172,
		186,
		190,
		189,
		-1,
		119,
		-1,
		-1,
		-1,
		165,
		187,
		219,
		196,
		175,
		168,
		165,
		168,
		173,
		184,
		193,
		204,
		169,
		171,
		161,
		160,
		164,
		181,
		185,
		-1,
		-1,
		117,
		113,
		148,
		160,
		160,
		246,
		-1,
		-1,
		164,
		157,
		167,
		164,
		177,
		180,
		165,
		167,
		167,
		165,
		159,
		169,
		184,
		179,
		-1,
		-1,
		-1,
		129,
		-1,
		131,
		-1,
		-1,
		150,
		237,
		184,
		166,
		162,
		148,
		162,
		156,
		155,
		160,
		170,
		164,
		161,
		155,
		159,
		182,
		171,
		210,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		136,
		100,
		95,
		129,
		134,
		125,
		199,
		196,
		-1,
		144,
		185,
		153,
		167,
		151,
		158,
		163,
		160,
		149,
		156,
		172,
		171,
		166,
		202,
		193,
		199,
		-1,
		-1,
		211,
		200,
		189,
		195,
		-1,
		129,
		97,
		115,
		105,
		111,
		-1,
		-1,
		158,
		155,
		158,
		145,
		151,
		152,
		147,
		157,
		133,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		165,
		202,
		195,
		163,
		171,
		202,
		-1,
		119,
		111,
		94,
		97,
		105,
		-1,
		-1,
		131,
		127,
		132,
		141,
		144,
		171,
		170,
		153,
		159,
		160,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		158,
		178,
		157,
		160,
		184,
		198,
		-1,
		116,
		-1,
		-1,
		54,
		118,
		126,
		122,
		126,
		179,
		155,
		150,
		158,
		156,
		151,
		142,
		167,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		147,
		158,
		151,
		-1,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		44,
		-1,
		152,
		-1,
		145,
		149,
		163,
		166,
		172,
		159,
		145,
		153,
		159,
		158,
		164,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		172,
		128,
		131,
		142,
		153,
		168,
		172,
		-1,
		108,
		141,
		9,
		-1,
		34,
		-1,
		-1,
		-1,
		159,
		176,
		168,
		184,
		171,
		171,
		137,
		141,
		154,
		161,
		171,
		182,
		174,
		178,
		191,
		202,
		205,
		168,
		159,
		172,
		117,
		117,
		138,
		147,
		168,
		92,
		101,
		135,
		16,
		5,
		0,
		24,
		-1,
		-1,
		182,
		186,
		-1,
		-1,
		178,
		145,
		133,
		143,
		147,
		161,
		173,
		186,
		174,
		179,
		173,
		205,
		-1,
		161,
		160,
		149,
		146,
		122,
		113,
		108,
		135,
		-1,
		-1,
		90,
		126,
		72,
		49,
		47,
		72,
		-1,
		31,
		-1,
		-1,
		185,
		-1,
		-1,
		170,
		150,
		139,
		130,
		135,
		155,
		166,
		188,
		170,
		187,
		178,
		188,
		192,
		145,
		142,
		130,
		128,
		151,
		116,
		104,
		-1,
		93,
		87,
		83,
		70,
		50,
		61,
		-1,
		-1,
		47,
		38,
		-1,
		-1,
		168,
		166,
		155,
		-1,
		145,
		127,
		132,
		162,
		164,
		166,
		173,
		167,
		174,
		182,
		193,
		185,
		154,
		168,
		157,
		153,
		152,
		160,
		109,
		102,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		-1,
		82,
		57,
		-1,
		-1,
		163,
		156,
		144,
		132,
		122,
		132,
		149,
		149,
		152,
		157,
		165,
		176,
		172,
		176,
		179,
		-1,
		188,
		-1,
		140,
		108,
		128,
		143,
		151,
		-1,
		-1,
		-1,
		99,
		85,
		78,
		66,
		64,
		-1,
		197,
		181,
		162,
		-1,
		132,
		145,
		185,
		153,
		158,
		153,
		168,
		179,
		170,
		178,
		172,
		175,
		-1,
		-1,
		126,
		129,
		-1,
		-1,
		137,
		139,
		-1,
		90,
		79,
		64,
		56,
		-1,
		-1,
		169,
		165,
		-1,
		-1,
		119,
		157,
		156,
		164,
		159,
		164,
		176,
		172,
		168,
		178,
		169,
		-1,
		-1,
		133,
		136,
		141,
		-1,
		122,
		-1,
		114,
		-1,
		59,
		75,
		77,
		-1,
		-1,
		-1,
		150,
		113,
		129,
		152,
		178,
		176,
		167,
		160,
		167,
		170,
		163,
		169,
		-1,
		-1,
		-1,
		140,
		114,
		121,
		112,
		95,
		75,
		67,
		92,
		-1,
		131,
		-1,
		106,
		109,
		134,
		173,
		175,
		161,
		157,
		170,
		164,
		161,
		159,
		146,
		-1,
		116,
		149,
		113,
		81,
		81,
		80,
		145,
		-1,
		128,
		110,
		-1,
		138,
		128,
		176,
		151,
		160,
		153,
		147,
		148,
		156,
		-1,
		-1,
		-1,
		118,
		117,
		109,
		103,
		101,
		86,
		81,
		-1,
		133,
		115,
		101,
		118,
		118,
		109,
		117,
		166,
		162,
		165,
		163,
		141,
		-1,
		232,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		112,
		121,
		94,
		82,
		96,
		103,
		98,
		100,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		140,
		172,
		-1,
		227,
		-1,
		148,
		-1,
		-1,
		128,
		114,
		116,
		105,
		94,
		92,
		95,
		93,
		115,
		145,
		131,
		129,
		134,
		139,
		-1,
		216,
		215,
		-1,
		147,
		139,
		125,
		-1,
		118,
		-1,
		140,
		101,
		-1,
		122,
		102,
		-1,
		140,
		136,
		-1,
		-1,
		203,
		163,
		-1,
		-1,
		-1,
		148,
		128,
		135,
		119,
		-1,
		113,
		113,
		-1,
		-1,
		-1,
		188,
		172,
		-1,
		141,
		144,
		-1,
		135,
		141,
		168,
		115,
		119,
		-1,
		-1,
		-1,
		197,
		178,
		172,
		156,
		161,
		149,
		166,
		152,
		151,
		129,
		118,
		139,
		-1,
		-1,
		-1,
		169,
		161,
		161,
		-1,
		-1,
		176,
		159,
		140,
		138,
		-1,
		-1,
		-1,
		191,
		172,
		-1,
		-1,
		166,
		-1,
		-1,
		172,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		180,
		-1,
		-1,
		-1,
		162,
		158,
		159,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		226,
		201,
		-1,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		182,
		166,
		-1,
		152,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		187,
		-1,
		187,
		162,
		169,
		-1,
		-1,
		-1,
		-1,
		200,
		192,
		200,
		-1,
		172,
		174,
		-1,
		222,
		-1,
		-1,
		215,
		206,
		-1,
		-1,
		177,
		184,
		206,
		209,
		245,
		-1,
		196
	],
	[
		-1,
		299,
		288,
		299,
		307,
		280,
		287,
		-1,
		308,
		310,
		276,
		270,
		309,
		280,
		286,
		297,
		-1,
		-1,
		-1,
		299,
		298,
		268,
		266,
		275,
		280,
		287,
		-1,
		290,
		-1,
		320,
		299,
		310,
		315,
		261,
		258,
		278,
		297,
		283,
		275,
		335,
		291,
		262,
		256,
		274,
		268,
		277,
		269,
		-1,
		262,
		252,
		274,
		257,
		268,
		260,
		-1,
		-1,
		256,
		257,
		263,
		253,
		259,
		255,
		-1,
		265,
		249,
		-1,
		-1,
		246,
		251,
		235,
		238,
		246,
		244,
		257,
		249,
		244,
		-1,
		-1,
		241,
		237,
		244,
		231,
		227,
		244,
		257,
		239,
		253,
		252,
		-1,
		235,
		253,
		262,
		238,
		236,
		220,
		218,
		236,
		238,
		244,
		244,
		-1,
		227,
		229,
		250,
		258,
		260,
		236,
		223,
		223,
		233,
		226,
		245,
		233,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		224,
		232,
		254,
		246,
		236,
		251,
		244,
		226,
		223,
		221,
		218,
		234,
		232,
		242,
		-1,
		-1,
		280,
		249,
		284,
		241,
		226,
		-1,
		220,
		230,
		236,
		240,
		234,
		227,
		241,
		237,
		-1,
		212,
		211,
		239,
		225,
		236,
		240,
		-1,
		-1,
		238,
		230,
		215,
		218,
		215,
		215,
		245,
		244,
		236,
		222,
		218,
		224,
		227,
		227,
		233,
		206,
		216,
		220,
		218,
		243,
		-1,
		-1,
		278,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		210,
		227,
		217,
		238,
		253,
		246,
		238,
		232,
		220,
		222,
		219,
		232,
		220,
		203,
		228,
		232,
		213,
		234,
		229,
		-1,
		277,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		239,
		-1,
		260,
		255,
		256,
		241,
		238,
		225,
		213,
		226,
		211,
		218,
		217,
		207,
		205,
		235,
		210,
		232,
		229,
		248,
		253,
		247,
		256,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		247,
		260,
		264,
		252,
		255,
		242,
		233,
		220,
		209,
		220,
		209,
		206,
		214,
		199,
		214,
		205,
		204,
		222,
		232,
		240,
		244,
		250,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		248,
		268,
		266,
		257,
		-1,
		251,
		248,
		238,
		216,
		201,
		218,
		210,
		208,
		212,
		194,
		208,
		199,
		217,
		224,
		222,
		226,
		246,
		258,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		291,
		263,
		-1,
		258,
		-1,
		250,
		266,
		-1,
		222,
		218,
		200,
		201,
		196,
		211,
		205,
		190,
		187,
		205,
		208,
		215,
		219,
		235,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		256,
		245,
		244,
		-1,
		235,
		236,
		233,
		221,
		208,
		193,
		194,
		202,
		215,
		194,
		189,
		186,
		206,
		232,
		210,
		222,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		274,
		267,
		255,
		220,
		220,
		214,
		-1,
		232,
		211,
		202,
		191,
		189,
		202,
		199,
		204,
		184,
		182,
		201,
		213,
		204,
		221,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		253,
		239,
		244,
		219,
		212,
		206,
		245,
		228,
		209,
		198,
		190,
		179,
		195,
		203,
		198,
		180,
		189,
		195,
		219,
		209,
		215,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		244,
		241,
		-1,
		211,
		-1,
		200,
		208,
		203,
		198,
		195,
		192,
		186,
		195,
		197,
		187,
		182,
		189,
		224,
		224,
		199,
		219,
		222,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		211,
		212,
		-1,
		205,
		199,
		205,
		204,
		201,
		196,
		200,
		193,
		200,
		193,
		191,
		192,
		174,
		206,
		-1,
		207,
		201,
		209,
		199,
		187,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		196,
		189,
		-1,
		192,
		192,
		199,
		203,
		197,
		201,
		198,
		187,
		200,
		193,
		179,
		181,
		194,
		198,
		202,
		189,
		185,
		182,
		196,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		204,
		196,
		187,
		181,
		187,
		205,
		203,
		223,
		209,
		212,
		210,
		201,
		209,
		182,
		175,
		182,
		171,
		189,
		197,
		189,
		183,
		182,
		192,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		182,
		198,
		-1,
		221,
		200,
		223,
		201,
		215,
		211,
		232,
		233,
		208,
		210,
		208,
		199,
		187,
		176,
		179,
		171,
		193,
		193,
		177,
		178,
		182,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		169,
		185,
		-1,
		-1,
		259,
		-1,
		199,
		215,
		225,
		223,
		222,
		202,
		209,
		219,
		196,
		191,
		181,
		170,
		170,
		165,
		187,
		173,
		171,
		180,
		196,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		202,
		-1,
		237,
		225,
		212,
		194,
		234,
		-1,
		201,
		197,
		204,
		-1,
		216,
		-1,
		189,
		186,
		177,
		162,
		159,
		170,
		168,
		179,
		175,
		-1,
		209,
		194,
		187,
		177,
		191,
		159,
		-1,
		193,
		-1,
		-1,
		224,
		218,
		218,
		187,
		184,
		217,
		197,
		189,
		204,
		203,
		190,
		189,
		175,
		168,
		165,
		158,
		171,
		181,
		186,
		173,
		-1,
		-1,
		-1,
		214,
		189,
		183,
		155,
		159,
		-1,
		-1,
		285,
		241,
		227,
		-1,
		179,
		217,
		205,
		195,
		185,
		190,
		191,
		181,
		179,
		173,
		175,
		169,
		160,
		159,
		175,
		167,
		189,
		-1,
		-1,
		188,
		181,
		169,
		137,
		132,
		-1,
		-1,
		-1,
		231,
		217,
		205,
		177,
		206,
		-1,
		-1,
		189,
		182,
		176,
		174,
		167,
		187,
		184,
		168,
		153,
		168,
		172,
		180,
		171,
		-1,
		191,
		178,
		-1,
		-1,
		131,
		121,
		-1,
		-1,
		-1,
		-1,
		195,
		176,
		177,
		172,
		176,
		188,
		-1,
		161,
		165,
		165,
		185,
		192,
		170,
		155,
		149,
		155,
		167,
		176,
		-1,
		-1,
		145,
		-1,
		107,
		-1,
		-1,
		-1,
		-1,
		167,
		182,
		165,
		158,
		162,
		-1,
		159,
		158,
		162,
		168,
		173,
		170,
		161,
		152,
		148,
		152,
		156,
		170,
		174,
		168,
		-1,
		98,
		-1,
		-1,
		-1,
		144,
		166,
		198,
		175,
		154,
		147,
		144,
		150,
		154,
		166,
		175,
		186,
		151,
		155,
		145,
		144,
		148,
		165,
		169,
		-1,
		-1,
		96,
		92,
		127,
		139,
		139,
		225,
		-1,
		-1,
		143,
		136,
		146,
		146,
		159,
		162,
		147,
		149,
		151,
		149,
		143,
		153,
		168,
		163,
		-1,
		-1,
		-1,
		108,
		-1,
		110,
		-1,
		-1,
		129,
		216,
		163,
		145,
		141,
		127,
		141,
		135,
		137,
		142,
		154,
		148,
		145,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		115,
		79,
		74,
		108,
		113,
		104,
		178,
		175,
		-1,
		123,
		164,
		132,
		146,
		135,
		142,
		147,
		144,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		108,
		76,
		94,
		84,
		90,
		-1,
		-1,
		137,
		134,
		137,
		124,
		130,
		135,
		131,
		141,
		117,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		186,
		223,
		216,
		184,
		192,
		223,
		-1,
		98,
		90,
		73,
		76,
		84,
		-1,
		-1,
		110,
		106,
		111,
		120,
		123,
		155,
		154,
		137,
		143,
		144,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		95,
		-1,
		-1,
		31,
		97,
		105,
		101,
		105,
		158,
		134,
		129,
		142,
		140,
		135,
		126,
		151,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		21,
		-1,
		131,
		-1,
		124,
		128,
		142,
		145,
		156,
		143,
		129,
		137,
		143,
		142,
		148,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		107,
		146,
		30,
		-1,
		11,
		-1,
		-1,
		-1,
		138,
		155,
		147,
		163,
		155,
		155,
		121,
		125,
		138,
		145,
		155,
		166,
		158,
		162,
		175,
		186,
		189,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		113,
		113,
		140,
		37,
		26,
		21,
		0,
		-1,
		-1,
		161,
		165,
		-1,
		-1,
		162,
		129,
		117,
		127,
		131,
		145,
		157,
		170,
		158,
		163,
		157,
		189,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		111,
		141,
		93,
		70,
		68,
		93,
		-1,
		15,
		-1,
		-1,
		169,
		-1,
		-1,
		154,
		134,
		123,
		114,
		119,
		139,
		150,
		172,
		154,
		171,
		162,
		172,
		176,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		114,
		108,
		104,
		91,
		71,
		82,
		-1,
		-1,
		31,
		22,
		-1,
		-1,
		152,
		150,
		139,
		-1,
		129,
		111,
		116,
		146,
		148,
		150,
		157,
		151,
		158,
		166,
		177,
		169,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		81,
		-1,
		66,
		41,
		-1,
		-1,
		147,
		140,
		128,
		116,
		106,
		116,
		133,
		133,
		136,
		141,
		149,
		160,
		156,
		160,
		163,
		-1,
		209,
		-1,
		161,
		129,
		149,
		164,
		172,
		-1,
		-1,
		-1,
		83,
		69,
		62,
		50,
		48,
		-1,
		181,
		165,
		146,
		-1,
		116,
		129,
		169,
		137,
		142,
		137,
		152,
		163,
		154,
		162,
		156,
		159,
		-1,
		-1,
		147,
		147,
		-1,
		-1,
		121,
		123,
		-1,
		74,
		63,
		48,
		40,
		-1,
		-1,
		153,
		149,
		-1,
		-1,
		103,
		141,
		140,
		148,
		143,
		148,
		160,
		156,
		152,
		162,
		153,
		-1,
		-1,
		142,
		134,
		128,
		-1,
		106,
		-1,
		98,
		-1,
		43,
		59,
		61,
		-1,
		-1,
		-1,
		134,
		97,
		113,
		136,
		162,
		160,
		151,
		144,
		151,
		154,
		147,
		153,
		-1,
		-1,
		-1,
		124,
		98,
		105,
		96,
		79,
		59,
		51,
		76,
		-1,
		115,
		-1,
		90,
		93,
		118,
		157,
		159,
		145,
		141,
		154,
		148,
		145,
		143,
		130,
		-1,
		100,
		133,
		97,
		65,
		65,
		64,
		129,
		-1,
		112,
		94,
		-1,
		122,
		112,
		160,
		135,
		144,
		137,
		131,
		132,
		140,
		-1,
		-1,
		-1,
		102,
		101,
		93,
		87,
		85,
		70,
		65,
		-1,
		117,
		99,
		85,
		102,
		102,
		93,
		101,
		150,
		146,
		149,
		147,
		125,
		-1,
		216,
		-1,
		-1,
		125,
		-1,
		-1,
		-1,
		96,
		105,
		78,
		66,
		80,
		87,
		82,
		84,
		97,
		105,
		103,
		100,
		112,
		108,
		128,
		124,
		156,
		-1,
		211,
		-1,
		132,
		-1,
		-1,
		112,
		98,
		100,
		89,
		78,
		76,
		79,
		77,
		99,
		129,
		115,
		113,
		118,
		123,
		-1,
		200,
		199,
		-1,
		131,
		123,
		109,
		-1,
		102,
		-1,
		124,
		85,
		-1,
		106,
		86,
		-1,
		124,
		120,
		-1,
		-1,
		187,
		147,
		-1,
		-1,
		-1,
		132,
		112,
		119,
		103,
		-1,
		97,
		97,
		-1,
		-1,
		-1,
		172,
		156,
		-1,
		125,
		128,
		-1,
		119,
		125,
		152,
		99,
		103,
		-1,
		-1,
		-1,
		181,
		162,
		156,
		140,
		145,
		133,
		150,
		136,
		135,
		113,
		102,
		123,
		-1,
		-1,
		-1,
		153,
		145,
		145,
		-1,
		-1,
		160,
		143,
		124,
		122,
		-1,
		-1,
		-1,
		175,
		156,
		-1,
		-1,
		150,
		-1,
		-1,
		156,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		164,
		-1,
		-1,
		-1,
		146,
		142,
		143,
		-1,
		-1,
		-1,
		-1,
		185,
		186,
		210,
		185,
		-1,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		188,
		186,
		-1,
		-1,
		-1,
		166,
		150,
		-1,
		136,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		171,
		-1,
		171,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		184,
		176,
		184,
		-1,
		156,
		158,
		-1,
		206,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		161,
		168,
		190,
		193,
		229,
		-1,
		180
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		291,
		280,
		291,
		299,
		272,
		279,
		-1,
		298,
		302,
		268,
		262,
		301,
		270,
		276,
		287,
		-1,
		-1,
		-1,
		291,
		290,
		258,
		256,
		265,
		270,
		277,
		-1,
		276,
		-1,
		312,
		291,
		302,
		307,
		251,
		248,
		268,
		287,
		269,
		261,
		327,
		281,
		252,
		246,
		264,
		254,
		263,
		255,
		-1,
		252,
		242,
		264,
		243,
		254,
		246,
		-1,
		-1,
		246,
		247,
		253,
		239,
		245,
		241,
		-1,
		251,
		235,
		-1,
		-1,
		236,
		237,
		221,
		224,
		232,
		230,
		243,
		235,
		230,
		-1,
		-1,
		227,
		223,
		230,
		217,
		213,
		230,
		243,
		225,
		239,
		238,
		-1,
		233,
		251,
		256,
		224,
		222,
		206,
		204,
		222,
		224,
		230,
		230,
		-1,
		242,
		243,
		238,
		246,
		246,
		222,
		209,
		209,
		219,
		212,
		231,
		219,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		242,
		225,
		242,
		234,
		224,
		239,
		232,
		212,
		209,
		207,
		204,
		220,
		218,
		228,
		-1,
		-1,
		328,
		297,
		332,
		289,
		272,
		-1,
		238,
		218,
		224,
		228,
		222,
		215,
		229,
		225,
		-1,
		198,
		197,
		225,
		211,
		222,
		288,
		-1,
		-1,
		286,
		278,
		263,
		266,
		248,
		244,
		233,
		232,
		224,
		210,
		206,
		212,
		215,
		215,
		221,
		192,
		202,
		206,
		204,
		229,
		-1,
		-1,
		264,
		-1,
		-1,
		285,
		268,
		-1,
		251,
		258,
		254,
		260,
		246,
		267,
		243,
		234,
		226,
		220,
		208,
		210,
		207,
		220,
		208,
		189,
		214,
		218,
		199,
		220,
		215,
		-1,
		263,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		244,
		247,
		253,
		277,
		283,
		-1,
		255,
		243,
		244,
		229,
		226,
		213,
		201,
		214,
		199,
		206,
		205,
		193,
		191,
		221,
		196,
		218,
		215,
		234,
		239,
		233,
		242,
		-1,
		293,
		289,
		285,
		292,
		241,
		-1,
		-1,
		281,
		-1,
		291,
		292,
		267,
		240,
		243,
		230,
		221,
		208,
		197,
		208,
		197,
		194,
		202,
		185,
		200,
		191,
		190,
		208,
		218,
		226,
		230,
		236,
		-1,
		343,
		-1,
		285,
		269,
		271,
		243,
		264,
		-1,
		301,
		292,
		284,
		269,
		267,
		-1,
		239,
		236,
		226,
		204,
		189,
		206,
		198,
		196,
		198,
		180,
		194,
		185,
		203,
		210,
		208,
		212,
		232,
		244,
		303,
		293,
		-1,
		275,
		280,
		239,
		247,
		266,
		309,
		273,
		-1,
		268,
		-1,
		241,
		254,
		-1,
		210,
		206,
		188,
		189,
		184,
		199,
		191,
		176,
		173,
		191,
		194,
		201,
		205,
		221,
		-1,
		-1,
		288,
		292,
		281,
		232,
		251,
		275,
		312,
		266,
		255,
		254,
		-1,
		245,
		224,
		221,
		209,
		196,
		181,
		182,
		190,
		202,
		181,
		175,
		172,
		192,
		218,
		196,
		208,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		258,
		229,
		253,
		295,
		284,
		277,
		265,
		230,
		230,
		224,
		-1,
		220,
		199,
		190,
		179,
		177,
		190,
		182,
		190,
		170,
		168,
		187,
		199,
		190,
		201,
		-1,
		-1,
		-1,
		288,
		277,
		278,
		224,
		247,
		284,
		263,
		249,
		254,
		229,
		222,
		216,
		233,
		216,
		197,
		186,
		178,
		167,
		178,
		186,
		184,
		166,
		175,
		181,
		205,
		189,
		195,
		-1,
		-1,
		295,
		285,
		269,
		271,
		268,
		238,
		245,
		277,
		254,
		267,
		-1,
		221,
		-1,
		210,
		206,
		191,
		186,
		183,
		170,
		169,
		183,
		183,
		173,
		168,
		175,
		210,
		210,
		179,
		199,
		202,
		-1,
		-1,
		-1,
		288,
		283,
		258,
		235,
		219,
		255,
		-1,
		237,
		238,
		-1,
		215,
		209,
		206,
		193,
		189,
		174,
		178,
		180,
		183,
		171,
		177,
		178,
		160,
		184,
		-1,
		187,
		181,
		189,
		179,
		167,
		-1,
		-1,
		-1,
		281,
		260,
		253,
		273,
		214,
		266,
		-1,
		-1,
		222,
		215,
		-1,
		202,
		184,
		186,
		179,
		173,
		179,
		175,
		165,
		178,
		171,
		165,
		159,
		172,
		176,
		180,
		169,
		165,
		162,
		176,
		-1,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		234,
		-1,
		231,
		223,
		213,
		207,
		201,
		197,
		195,
		201,
		185,
		188,
		183,
		179,
		170,
		160,
		153,
		164,
		149,
		167,
		175,
		167,
		161,
		160,
		172,
		-1,
		301,
		287,
		258,
		-1,
		-1,
		247,
		-1,
		211,
		230,
		246,
		-1,
		239,
		218,
		233,
		211,
		207,
		198,
		192,
		193,
		163,
		168,
		170,
		158,
		161,
		154,
		157,
		149,
		171,
		171,
		155,
		156,
		165,
		-1,
		307,
		294,
		252,
		248,
		237,
		257,
		208,
		201,
		233,
		-1,
		-1,
		247,
		-1,
		201,
		203,
		212,
		210,
		182,
		157,
		164,
		182,
		155,
		150,
		159,
		148,
		146,
		143,
		165,
		151,
		149,
		166,
		182,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		223,
		210,
		204,
		-1,
		250,
		-1,
		225,
		213,
		200,
		182,
		222,
		-1,
		156,
		152,
		159,
		-1,
		175,
		-1,
		147,
		150,
		141,
		138,
		137,
		148,
		146,
		157,
		161,
		-1,
		257,
		242,
		235,
		225,
		239,
		207,
		-1,
		241,
		-1,
		-1,
		212,
		206,
		206,
		175,
		172,
		172,
		152,
		144,
		159,
		158,
		145,
		144,
		132,
		132,
		135,
		138,
		151,
		161,
		164,
		159,
		-1,
		-1,
		-1,
		262,
		237,
		231,
		203,
		207,
		-1,
		-1,
		273,
		229,
		215,
		-1,
		167,
		172,
		160,
		150,
		140,
		145,
		146,
		136,
		134,
		130,
		139,
		143,
		140,
		139,
		160,
		153,
		175,
		-1,
		-1,
		236,
		229,
		217,
		185,
		180,
		-1,
		-1,
		-1,
		219,
		220,
		186,
		165,
		161,
		-1,
		-1,
		144,
		137,
		131,
		129,
		122,
		142,
		149,
		146,
		133,
		148,
		158,
		166,
		165,
		-1,
		239,
		226,
		-1,
		-1,
		179,
		169,
		-1,
		-1,
		-1,
		-1,
		198,
		143,
		132,
		127,
		131,
		143,
		-1,
		116,
		120,
		120,
		140,
		147,
		148,
		133,
		127,
		138,
		153,
		170,
		-1,
		-1,
		193,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		155,
		149,
		120,
		113,
		117,
		-1,
		114,
		113,
		117,
		123,
		136,
		141,
		139,
		121,
		135,
		138,
		151,
		165,
		169,
		216,
		-1,
		146,
		-1,
		-1,
		-1,
		173,
		178,
		153,
		130,
		109,
		102,
		99,
		105,
		109,
		125,
		131,
		142,
		115,
		119,
		134,
		139,
		143,
		160,
		164,
		-1,
		-1,
		144,
		140,
		175,
		181,
		151,
		180,
		-1,
		-1,
		98,
		91,
		101,
		110,
		115,
		118,
		111,
		113,
		131,
		144,
		138,
		148,
		163,
		158,
		-1,
		-1,
		-1,
		156,
		-1,
		158,
		-1,
		-1,
		141,
		171,
		118,
		100,
		96,
		82,
		105,
		99,
		101,
		106,
		125,
		120,
		129,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		135,
		127,
		121,
		124,
		125,
		116,
		133,
		130,
		-1,
		78,
		121,
		96,
		110,
		106,
		113,
		118,
		124,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		128,
		124,
		110,
		100,
		102,
		-1,
		-1,
		95,
		92,
		101,
		88,
		94,
		99,
		102,
		135,
		116,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		118,
		110,
		120,
		96,
		93,
		-1,
		-1,
		68,
		70,
		75,
		84,
		87,
		123,
		122,
		120,
		125,
		143,
		130,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		115,
		-1,
		-1,
		127,
		94,
		78,
		72,
		67,
		122,
		98,
		93,
		106,
		108,
		117,
		108,
		146,
		125,
		137,
		140,
		156,
		161,
		153,
		168,
		168,
		169,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		143,
		-1,
		105,
		-1,
		40,
		69,
		106,
		109,
		131,
		118,
		109,
		117,
		123,
		123,
		128,
		131,
		143,
		152,
		163,
		175,
		175,
		176,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		127,
		166,
		181,
		-1,
		152,
		-1,
		-1,
		-1,
		22,
		119,
		111,
		127,
		130,
		130,
		101,
		105,
		118,
		125,
		135,
		149,
		146,
		156,
		169,
		180,
		184,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		142,
		133,
		160,
		188,
		177,
		172,
		159,
		-1,
		-1,
		0,
		129,
		-1,
		-1,
		137,
		109,
		97,
		107,
		111,
		125,
		137,
		150,
		138,
		157,
		151,
		183,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		145,
		161,
		161,
		165,
		181,
		206,
		-1,
		162,
		-1,
		-1,
		21,
		-1,
		-1,
		90,
		114,
		103,
		94,
		99,
		119,
		130,
		152,
		134,
		151,
		156,
		166,
		179,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		137,
		135,
		141,
		148,
		165,
		195,
		-1,
		-1,
		178,
		169,
		-1,
		-1,
		40,
		47,
		75,
		-1,
		100,
		91,
		96,
		126,
		128,
		130,
		137,
		131,
		138,
		164,
		176,
		178,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		181,
		-1,
		-1,
		47,
		54,
		62,
		73,
		86,
		96,
		113,
		113,
		116,
		121,
		129,
		140,
		154,
		158,
		172,
		-1,
		208,
		-1,
		160,
		136,
		150,
		165,
		173,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		97,
		81,
		62,
		-1,
		96,
		109,
		149,
		117,
		122,
		117,
		135,
		146,
		157,
		160,
		165,
		168,
		-1,
		-1,
		148,
		151,
		-1,
		-1,
		173,
		192,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		69,
		65,
		-1,
		-1,
		97,
		131,
		120,
		128,
		123,
		135,
		145,
		143,
		155,
		163,
		162,
		-1,
		-1,
		155,
		156,
		161,
		-1,
		177,
		-1,
		195,
		-1,
		162,
		168,
		156,
		-1,
		-1,
		-1,
		135,
		98,
		119,
		138,
		143,
		141,
		132,
		131,
		138,
		148,
		156,
		162,
		-1,
		-1,
		-1,
		195,
		169,
		202,
		193,
		176,
		156,
		148,
		167,
		-1,
		134,
		-1,
		102,
		99,
		140,
		137,
		154,
		148,
		134,
		149,
		145,
		154,
		152,
		201,
		-1,
		171,
		204,
		168,
		162,
		138,
		142,
		158,
		-1,
		131,
		110,
		-1,
		144,
		134,
		171,
		157,
		145,
		132,
		139,
		153,
		149,
		-1,
		-1,
		-1,
		173,
		172,
		164,
		158,
		158,
		143,
		134,
		-1,
		146,
		128,
		107,
		124,
		124,
		115,
		123,
		161,
		157,
		150,
		152,
		144,
		-1,
		274,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		167,
		162,
		135,
		123,
		129,
		125,
		111,
		117,
		119,
		127,
		125,
		122,
		134,
		130,
		150,
		145,
		178,
		-1,
		269,
		-1,
		203,
		-1,
		-1,
		185,
		165,
		157,
		146,
		135,
		133,
		124,
		115,
		137,
		153,
		137,
		135,
		140,
		145,
		-1,
		258,
		257,
		-1,
		204,
		196,
		182,
		-1,
		175,
		-1,
		181,
		142,
		-1,
		144,
		124,
		-1,
		146,
		142,
		-1,
		-1,
		245,
		220,
		-1,
		-1,
		-1,
		205,
		185,
		176,
		160,
		-1,
		135,
		135,
		-1,
		-1,
		-1,
		230,
		229,
		-1,
		198,
		201,
		-1,
		191,
		182,
		190,
		137,
		141,
		-1,
		-1,
		-1,
		239,
		220,
		214,
		213,
		211,
		206,
		203,
		189,
		173,
		151,
		140,
		161,
		-1,
		-1,
		-1,
		211,
		203,
		196,
		-1,
		-1,
		198,
		181,
		162,
		160,
		-1,
		-1,
		-1,
		233,
		214,
		-1,
		-1,
		188,
		-1,
		-1,
		194,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		222,
		-1,
		-1,
		-1,
		184,
		180,
		181,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		268,
		232,
		-1,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		247,
		245,
		-1,
		-1,
		-1,
		204,
		188,
		-1,
		174,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		209,
		-1,
		209,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		222,
		214,
		222,
		-1,
		194,
		196,
		-1,
		244,
		-1,
		-1,
		237,
		228,
		-1,
		-1,
		199,
		206,
		228,
		231,
		267,
		-1,
		218
	],
	[
		-1,
		264,
		253,
		264,
		272,
		245,
		252,
		-1,
		271,
		275,
		241,
		235,
		274,
		243,
		249,
		260,
		-1,
		-1,
		-1,
		264,
		263,
		231,
		229,
		238,
		243,
		250,
		-1,
		249,
		-1,
		285,
		264,
		275,
		280,
		224,
		221,
		241,
		260,
		242,
		234,
		300,
		254,
		225,
		219,
		237,
		227,
		236,
		228,
		-1,
		225,
		215,
		237,
		216,
		227,
		219,
		-1,
		-1,
		219,
		220,
		226,
		212,
		218,
		214,
		-1,
		224,
		208,
		-1,
		-1,
		209,
		210,
		194,
		197,
		205,
		203,
		216,
		208,
		203,
		-1,
		-1,
		200,
		196,
		203,
		190,
		186,
		203,
		216,
		198,
		212,
		211,
		-1,
		206,
		224,
		229,
		197,
		195,
		179,
		177,
		195,
		197,
		203,
		203,
		-1,
		215,
		216,
		211,
		219,
		219,
		195,
		182,
		182,
		192,
		185,
		204,
		192,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		215,
		198,
		215,
		207,
		197,
		212,
		205,
		185,
		182,
		180,
		177,
		193,
		191,
		201,
		-1,
		-1,
		306,
		275,
		306,
		264,
		245,
		-1,
		211,
		191,
		197,
		201,
		195,
		188,
		202,
		198,
		-1,
		171,
		170,
		198,
		184,
		195,
		266,
		-1,
		-1,
		264,
		256,
		241,
		244,
		221,
		217,
		206,
		205,
		197,
		183,
		179,
		185,
		188,
		188,
		194,
		165,
		175,
		179,
		177,
		202,
		-1,
		-1,
		237,
		-1,
		-1,
		263,
		246,
		-1,
		229,
		236,
		227,
		233,
		219,
		240,
		216,
		207,
		199,
		193,
		181,
		183,
		180,
		193,
		181,
		162,
		187,
		191,
		172,
		193,
		188,
		-1,
		236,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		222,
		225,
		231,
		255,
		256,
		-1,
		228,
		216,
		217,
		202,
		199,
		186,
		174,
		187,
		172,
		179,
		178,
		166,
		164,
		194,
		169,
		191,
		188,
		207,
		212,
		206,
		215,
		-1,
		271,
		267,
		263,
		270,
		219,
		-1,
		-1,
		259,
		-1,
		264,
		265,
		240,
		213,
		216,
		203,
		194,
		181,
		170,
		181,
		170,
		167,
		175,
		158,
		173,
		164,
		163,
		181,
		191,
		199,
		203,
		209,
		-1,
		321,
		-1,
		263,
		247,
		249,
		221,
		242,
		-1,
		279,
		265,
		257,
		242,
		240,
		-1,
		212,
		209,
		199,
		177,
		162,
		179,
		171,
		169,
		171,
		153,
		167,
		158,
		176,
		183,
		181,
		185,
		205,
		217,
		281,
		271,
		-1,
		253,
		258,
		217,
		225,
		244,
		282,
		246,
		-1,
		241,
		-1,
		214,
		227,
		-1,
		183,
		179,
		161,
		162,
		157,
		172,
		164,
		149,
		146,
		164,
		167,
		174,
		178,
		194,
		-1,
		-1,
		266,
		270,
		259,
		210,
		229,
		253,
		290,
		239,
		228,
		227,
		-1,
		218,
		197,
		194,
		182,
		169,
		154,
		155,
		163,
		175,
		154,
		148,
		145,
		165,
		191,
		169,
		180,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		236,
		207,
		231,
		273,
		257,
		250,
		238,
		203,
		203,
		197,
		-1,
		193,
		172,
		163,
		152,
		150,
		163,
		155,
		163,
		143,
		141,
		160,
		172,
		163,
		171,
		-1,
		-1,
		-1,
		266,
		255,
		256,
		202,
		225,
		262,
		236,
		222,
		227,
		202,
		195,
		189,
		206,
		189,
		170,
		159,
		151,
		140,
		151,
		159,
		157,
		139,
		148,
		154,
		178,
		159,
		165,
		-1,
		-1,
		273,
		263,
		247,
		249,
		246,
		216,
		223,
		255,
		227,
		240,
		-1,
		194,
		-1,
		183,
		179,
		164,
		159,
		156,
		143,
		142,
		156,
		156,
		146,
		141,
		148,
		183,
		183,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		266,
		261,
		236,
		213,
		197,
		233,
		-1,
		210,
		211,
		-1,
		188,
		182,
		179,
		166,
		162,
		147,
		151,
		153,
		156,
		144,
		150,
		151,
		133,
		157,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		259,
		238,
		231,
		251,
		192,
		244,
		-1,
		-1,
		195,
		188,
		-1,
		175,
		157,
		159,
		154,
		150,
		152,
		149,
		138,
		151,
		144,
		138,
		132,
		145,
		149,
		150,
		139,
		135,
		132,
		146,
		-1,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		212,
		-1,
		204,
		196,
		186,
		180,
		174,
		170,
		168,
		178,
		162,
		164,
		160,
		152,
		147,
		133,
		126,
		137,
		122,
		140,
		146,
		137,
		132,
		131,
		142,
		-1,
		279,
		265,
		236,
		-1,
		-1,
		225,
		-1,
		189,
		203,
		219,
		-1,
		212,
		191,
		206,
		184,
		180,
		171,
		169,
		170,
		140,
		145,
		147,
		135,
		138,
		127,
		130,
		122,
		144,
		141,
		125,
		127,
		136,
		-1,
		285,
		272,
		230,
		226,
		215,
		235,
		186,
		174,
		206,
		-1,
		-1,
		238,
		-1,
		182,
		194,
		185,
		183,
		159,
		134,
		141,
		159,
		132,
		127,
		132,
		121,
		121,
		116,
		135,
		121,
		119,
		134,
		150,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		201,
		188,
		182,
		-1,
		223,
		-1,
		216,
		204,
		191,
		173,
		213,
		-1,
		133,
		129,
		136,
		-1,
		152,
		-1,
		124,
		127,
		118,
		113,
		110,
		121,
		119,
		128,
		129,
		-1,
		235,
		220,
		213,
		203,
		217,
		188,
		-1,
		236,
		-1,
		-1,
		203,
		197,
		197,
		166,
		163,
		149,
		129,
		121,
		136,
		135,
		122,
		121,
		109,
		109,
		112,
		106,
		119,
		129,
		135,
		127,
		-1,
		-1,
		-1,
		240,
		226,
		226,
		190,
		202,
		-1,
		-1,
		264,
		220,
		206,
		-1,
		158,
		149,
		137,
		127,
		117,
		122,
		123,
		113,
		111,
		107,
		116,
		115,
		108,
		107,
		128,
		121,
		143,
		-1,
		-1,
		223,
		224,
		212,
		180,
		175,
		-1,
		-1,
		-1,
		210,
		211,
		177,
		156,
		138,
		-1,
		-1,
		121,
		114,
		108,
		111,
		99,
		119,
		126,
		114,
		101,
		116,
		126,
		134,
		133,
		-1,
		226,
		213,
		-1,
		-1,
		174,
		164,
		-1,
		-1,
		-1,
		-1,
		189,
		134,
		123,
		118,
		122,
		120,
		-1,
		94,
		105,
		98,
		117,
		124,
		116,
		101,
		95,
		106,
		121,
		138,
		-1,
		-1,
		188,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		146,
		140,
		111,
		104,
		108,
		-1,
		96,
		98,
		95,
		107,
		112,
		116,
		107,
		89,
		103,
		106,
		119,
		133,
		137,
		211,
		-1,
		141,
		-1,
		-1,
		-1,
		164,
		178,
		150,
		127,
		100,
		95,
		88,
		82,
		87,
		98,
		107,
		118,
		83,
		87,
		102,
		107,
		111,
		128,
		132,
		-1,
		-1,
		139,
		135,
		170,
		172,
		151,
		177,
		-1,
		-1,
		97,
		90,
		86,
		78,
		91,
		94,
		79,
		81,
		99,
		112,
		106,
		116,
		131,
		126,
		-1,
		-1,
		-1,
		151,
		-1,
		153,
		-1,
		-1,
		141,
		170,
		117,
		99,
		95,
		81,
		73,
		67,
		69,
		74,
		93,
		88,
		97,
		102,
		106,
		129,
		118,
		157,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		130,
		122,
		117,
		123,
		125,
		116,
		132,
		129,
		-1,
		78,
		96,
		64,
		78,
		74,
		81,
		86,
		92,
		96,
		103,
		119,
		118,
		113,
		149,
		140,
		146,
		-1,
		-1,
		221,
		210,
		199,
		205,
		-1,
		123,
		119,
		109,
		99,
		102,
		-1,
		-1,
		96,
		93,
		69,
		56,
		62,
		67,
		70,
		108,
		84,
		92,
		96,
		100,
		106,
		111,
		116,
		122,
		137,
		152,
		-1,
		175,
		212,
		205,
		173,
		181,
		212,
		-1,
		113,
		105,
		116,
		91,
		93,
		-1,
		-1,
		69,
		60,
		60,
		48,
		51,
		79,
		90,
		95,
		106,
		111,
		99,
		98,
		116,
		120,
		129,
		136,
		126,
		139,
		143,
		-1,
		168,
		188,
		167,
		170,
		194,
		208,
		-1,
		110,
		-1,
		-1,
		122,
		94,
		78,
		68,
		65,
		107,
		44,
		37,
		64,
		66,
		92,
		83,
		116,
		107,
		107,
		110,
		125,
		130,
		122,
		136,
		136,
		137,
		-1,
		157,
		168,
		161,
		-1,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		138,
		-1,
		105,
		-1,
		88,
		92,
		22,
		55,
		91,
		78,
		85,
		102,
		108,
		105,
		113,
		111,
		112,
		121,
		132,
		144,
		143,
		144,
		182,
		138,
		141,
		152,
		163,
		178,
		182,
		-1,
		122,
		161,
		176,
		-1,
		147,
		-1,
		-1,
		-1,
		102,
		10,
		18,
		73,
		88,
		90,
		86,
		90,
		103,
		110,
		120,
		129,
		121,
		125,
		138,
		149,
		152,
		178,
		169,
		182,
		127,
		127,
		148,
		157,
		178,
		137,
		128,
		155,
		181,
		172,
		167,
		154,
		-1,
		-1,
		125,
		0,
		-1,
		-1,
		89,
		107,
		90,
		92,
		96,
		110,
		122,
		135,
		128,
		126,
		120,
		152,
		-1,
		171,
		170,
		159,
		156,
		132,
		123,
		118,
		145,
		-1,
		-1,
		140,
		156,
		151,
		155,
		171,
		196,
		-1,
		157,
		-1,
		-1,
		146,
		-1,
		-1,
		149,
		112,
		101,
		92,
		98,
		104,
		115,
		137,
		134,
		135,
		125,
		135,
		148,
		155,
		152,
		140,
		138,
		161,
		126,
		114,
		-1,
		127,
		125,
		131,
		138,
		155,
		185,
		-1,
		-1,
		173,
		164,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		97,
		102,
		127,
		134,
		136,
		137,
		131,
		138,
		137,
		145,
		153,
		164,
		178,
		167,
		163,
		162,
		170,
		119,
		112,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		-1,
		194,
		183,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		119,
		119,
		122,
		127,
		129,
		140,
		132,
		136,
		153,
		-1,
		198,
		-1,
		150,
		126,
		140,
		155,
		163,
		-1,
		-1,
		-1,
		211,
		197,
		190,
		178,
		176,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		155,
		123,
		128,
		123,
		135,
		146,
		135,
		138,
		152,
		147,
		-1,
		-1,
		138,
		141,
		-1,
		-1,
		163,
		182,
		-1,
		202,
		191,
		176,
		168,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		112,
		137,
		126,
		134,
		129,
		139,
		145,
		148,
		137,
		141,
		153,
		-1,
		-1,
		145,
		146,
		151,
		-1,
		172,
		-1,
		204,
		-1,
		171,
		177,
		165,
		-1,
		-1,
		-1,
		150,
		113,
		134,
		144,
		149,
		147,
		138,
		137,
		144,
		148,
		144,
		155,
		-1,
		-1,
		-1,
		202,
		178,
		211,
		202,
		185,
		165,
		157,
		176,
		-1,
		146,
		-1,
		117,
		114,
		149,
		143,
		160,
		154,
		140,
		155,
		151,
		142,
		151,
		208,
		-1,
		180,
		213,
		177,
		171,
		147,
		151,
		167,
		-1,
		143,
		125,
		-1,
		153,
		143,
		177,
		163,
		151,
		138,
		145,
		155,
		148,
		-1,
		-1,
		-1,
		182,
		181,
		173,
		167,
		167,
		152,
		143,
		-1,
		155,
		137,
		116,
		133,
		133,
		124,
		132,
		167,
		163,
		156,
		158,
		150,
		-1,
		270,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		176,
		171,
		144,
		132,
		138,
		134,
		120,
		126,
		128,
		136,
		134,
		131,
		143,
		139,
		159,
		151,
		187,
		-1,
		277,
		-1,
		212,
		-1,
		-1,
		194,
		174,
		166,
		155,
		144,
		142,
		133,
		124,
		146,
		162,
		146,
		144,
		149,
		154,
		-1,
		267,
		266,
		-1,
		213,
		205,
		191,
		-1,
		184,
		-1,
		190,
		151,
		-1,
		153,
		133,
		-1,
		155,
		151,
		-1,
		-1,
		254,
		229,
		-1,
		-1,
		-1,
		214,
		194,
		185,
		169,
		-1,
		144,
		144,
		-1,
		-1,
		-1,
		239,
		238,
		-1,
		207,
		210,
		-1,
		200,
		191,
		199,
		146,
		150,
		-1,
		-1,
		-1,
		248,
		229,
		223,
		222,
		220,
		215,
		212,
		198,
		182,
		160,
		149,
		170,
		-1,
		-1,
		-1,
		220,
		212,
		205,
		-1,
		-1,
		207,
		190,
		171,
		169,
		-1,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		197,
		-1,
		-1,
		203,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		231,
		-1,
		-1,
		-1,
		193,
		189,
		190,
		-1,
		-1,
		-1,
		-1,
		253,
		254,
		277,
		241,
		-1,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		256,
		254,
		-1,
		-1,
		-1,
		213,
		197,
		-1,
		183,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		216,
		-1,
		-1,
		-1,
		218,
		-1,
		218,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		231,
		223,
		231,
		-1,
		203,
		205,
		-1,
		253,
		-1,
		-1,
		246,
		237,
		-1,
		-1,
		208,
		215,
		237,
		240,
		276,
		-1,
		227
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		231,
		220,
		231,
		239,
		212,
		219,
		-1,
		238,
		242,
		208,
		202,
		241,
		210,
		216,
		227,
		-1,
		-1,
		-1,
		231,
		230,
		198,
		196,
		205,
		210,
		217,
		-1,
		216,
		-1,
		252,
		231,
		242,
		247,
		191,
		188,
		208,
		227,
		209,
		201,
		267,
		221,
		192,
		186,
		204,
		194,
		203,
		195,
		-1,
		192,
		182,
		204,
		183,
		194,
		186,
		-1,
		-1,
		186,
		187,
		193,
		179,
		185,
		181,
		-1,
		191,
		175,
		-1,
		-1,
		176,
		177,
		161,
		164,
		172,
		170,
		183,
		175,
		170,
		-1,
		-1,
		167,
		163,
		170,
		157,
		153,
		170,
		183,
		165,
		179,
		178,
		-1,
		171,
		189,
		196,
		164,
		162,
		146,
		144,
		162,
		164,
		170,
		170,
		-1,
		180,
		181,
		176,
		184,
		186,
		162,
		149,
		149,
		159,
		152,
		171,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		180,
		163,
		180,
		172,
		162,
		177,
		170,
		152,
		149,
		147,
		144,
		160,
		158,
		168,
		-1,
		-1,
		273,
		242,
		271,
		229,
		210,
		-1,
		176,
		156,
		162,
		166,
		160,
		153,
		167,
		163,
		-1,
		138,
		137,
		165,
		151,
		162,
		233,
		-1,
		-1,
		231,
		223,
		206,
		209,
		186,
		182,
		171,
		170,
		162,
		148,
		144,
		150,
		153,
		153,
		159,
		132,
		142,
		146,
		144,
		169,
		-1,
		-1,
		204,
		-1,
		-1,
		230,
		213,
		-1,
		196,
		203,
		192,
		198,
		184,
		205,
		181,
		172,
		164,
		158,
		146,
		148,
		145,
		158,
		146,
		129,
		154,
		158,
		139,
		160,
		155,
		-1,
		203,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		189,
		192,
		198,
		222,
		221,
		-1,
		193,
		181,
		182,
		167,
		164,
		151,
		139,
		152,
		137,
		144,
		143,
		133,
		131,
		161,
		136,
		158,
		155,
		174,
		179,
		173,
		182,
		-1,
		238,
		234,
		230,
		237,
		186,
		-1,
		-1,
		226,
		-1,
		229,
		230,
		205,
		178,
		181,
		168,
		159,
		146,
		135,
		146,
		135,
		132,
		140,
		125,
		140,
		131,
		130,
		148,
		158,
		166,
		170,
		176,
		-1,
		288,
		-1,
		230,
		214,
		216,
		188,
		209,
		-1,
		246,
		230,
		222,
		207,
		207,
		-1,
		177,
		174,
		164,
		142,
		127,
		144,
		136,
		134,
		138,
		120,
		134,
		125,
		143,
		150,
		148,
		152,
		172,
		184,
		248,
		238,
		-1,
		220,
		225,
		184,
		192,
		211,
		249,
		213,
		-1,
		208,
		-1,
		179,
		192,
		-1,
		148,
		144,
		126,
		127,
		122,
		137,
		131,
		116,
		113,
		131,
		134,
		141,
		145,
		161,
		-1,
		-1,
		233,
		237,
		226,
		177,
		196,
		220,
		257,
		206,
		195,
		194,
		-1,
		185,
		162,
		159,
		147,
		134,
		119,
		120,
		128,
		141,
		120,
		115,
		112,
		132,
		158,
		136,
		148,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		203,
		174,
		198,
		240,
		224,
		217,
		205,
		170,
		170,
		164,
		-1,
		158,
		137,
		128,
		117,
		115,
		128,
		125,
		130,
		110,
		108,
		127,
		139,
		130,
		147,
		-1,
		-1,
		-1,
		233,
		222,
		223,
		169,
		192,
		229,
		203,
		189,
		194,
		169,
		162,
		156,
		171,
		154,
		135,
		124,
		116,
		105,
		121,
		129,
		124,
		106,
		115,
		121,
		145,
		135,
		141,
		-1,
		-1,
		240,
		230,
		214,
		216,
		213,
		183,
		190,
		222,
		194,
		207,
		-1,
		161,
		-1,
		150,
		145,
		129,
		124,
		121,
		118,
		112,
		121,
		123,
		113,
		108,
		115,
		150,
		150,
		125,
		145,
		148,
		-1,
		-1,
		-1,
		233,
		228,
		203,
		180,
		164,
		200,
		-1,
		177,
		178,
		-1,
		155,
		149,
		146,
		131,
		127,
		122,
		126,
		119,
		126,
		119,
		117,
		118,
		100,
		132,
		-1,
		133,
		127,
		135,
		125,
		113,
		-1,
		-1,
		-1,
		226,
		205,
		198,
		218,
		159,
		211,
		-1,
		-1,
		162,
		155,
		-1,
		142,
		124,
		131,
		129,
		123,
		127,
		124,
		113,
		126,
		119,
		105,
		107,
		120,
		124,
		128,
		115,
		111,
		108,
		122,
		-1,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		179,
		-1,
		171,
		163,
		153,
		147,
		141,
		137,
		135,
		151,
		135,
		138,
		136,
		127,
		135,
		108,
		101,
		108,
		97,
		115,
		123,
		115,
		109,
		108,
		118,
		-1,
		246,
		232,
		203,
		-1,
		-1,
		192,
		-1,
		156,
		170,
		186,
		-1,
		179,
		158,
		173,
		151,
		147,
		143,
		158,
		159,
		131,
		136,
		134,
		125,
		113,
		102,
		105,
		97,
		119,
		119,
		103,
		104,
		108,
		-1,
		252,
		239,
		197,
		193,
		182,
		202,
		153,
		141,
		173,
		-1,
		-1,
		215,
		-1,
		149,
		166,
		157,
		155,
		148,
		125,
		132,
		145,
		122,
		117,
		107,
		96,
		96,
		91,
		113,
		99,
		97,
		106,
		122,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		168,
		155,
		149,
		-1,
		190,
		-1,
		193,
		183,
		167,
		152,
		185,
		-1,
		124,
		120,
		127,
		-1,
		142,
		-1,
		115,
		112,
		103,
		88,
		85,
		96,
		94,
		105,
		101,
		-1,
		202,
		187,
		180,
		170,
		184,
		155,
		-1,
		210,
		-1,
		-1,
		180,
		174,
		174,
		157,
		154,
		140,
		120,
		112,
		127,
		126,
		113,
		112,
		100,
		94,
		91,
		84,
		97,
		107,
		112,
		99,
		-1,
		-1,
		-1,
		207,
		193,
		197,
		157,
		176,
		-1,
		-1,
		242,
		197,
		183,
		-1,
		149,
		140,
		128,
		118,
		108,
		113,
		114,
		104,
		102,
		98,
		101,
		95,
		86,
		85,
		101,
		93,
		115,
		-1,
		-1,
		190,
		195,
		183,
		169,
		180,
		-1,
		-1,
		-1,
		189,
		202,
		168,
		147,
		129,
		-1,
		-1,
		112,
		105,
		99,
		102,
		90,
		110,
		110,
		94,
		79,
		94,
		98,
		106,
		97,
		-1,
		193,
		180,
		-1,
		-1,
		179,
		169,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		96,
		89,
		108,
		115,
		96,
		81,
		75,
		81,
		93,
		102,
		-1,
		-1,
		193,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		89,
		86,
		98,
		99,
		96,
		87,
		78,
		74,
		78,
		82,
		96,
		100,
		216,
		-1,
		146,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		78,
		89,
		98,
		109,
		74,
		78,
		71,
		70,
		74,
		91,
		95,
		-1,
		-1,
		144,
		140,
		175,
		163,
		156,
		168,
		-1,
		-1,
		95,
		86,
		77,
		69,
		82,
		85,
		70,
		72,
		80,
		75,
		69,
		79,
		94,
		89,
		-1,
		-1,
		-1,
		156,
		-1,
		158,
		-1,
		-1,
		146,
		166,
		113,
		95,
		91,
		86,
		64,
		58,
		60,
		65,
		83,
		77,
		74,
		65,
		69,
		92,
		81,
		120,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		135,
		127,
		122,
		128,
		130,
		121,
		128,
		125,
		-1,
		83,
		87,
		55,
		69,
		64,
		71,
		76,
		73,
		59,
		66,
		82,
		81,
		76,
		112,
		103,
		109,
		-1,
		-1,
		221,
		210,
		199,
		205,
		-1,
		128,
		124,
		114,
		104,
		107,
		-1,
		-1,
		101,
		98,
		78,
		47,
		53,
		58,
		60,
		65,
		46,
		55,
		59,
		63,
		69,
		74,
		79,
		85,
		100,
		115,
		-1,
		175,
		212,
		205,
		173,
		181,
		212,
		-1,
		118,
		110,
		121,
		96,
		98,
		-1,
		-1,
		74,
		65,
		66,
		54,
		51,
		66,
		81,
		50,
		63,
		73,
		62,
		61,
		79,
		83,
		92,
		99,
		89,
		102,
		106,
		-1,
		168,
		188,
		167,
		170,
		194,
		208,
		-1,
		115,
		-1,
		-1,
		127,
		99,
		83,
		73,
		70,
		113,
		52,
		53,
		32,
		30,
		47,
		38,
		79,
		65,
		70,
		73,
		88,
		93,
		85,
		99,
		99,
		100,
		-1,
		157,
		168,
		161,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		143,
		-1,
		110,
		-1,
		93,
		97,
		68,
		63,
		32,
		19,
		40,
		57,
		63,
		63,
		68,
		71,
		75,
		84,
		95,
		107,
		106,
		107,
		182,
		138,
		141,
		152,
		163,
		178,
		182,
		-1,
		127,
		166,
		178,
		-1,
		152,
		-1,
		-1,
		-1,
		107,
		81,
		73,
		21,
		6,
		15,
		41,
		45,
		58,
		65,
		75,
		89,
		84,
		88,
		101,
		112,
		115,
		178,
		169,
		182,
		127,
		127,
		148,
		157,
		178,
		142,
		133,
		160,
		181,
		174,
		169,
		156,
		-1,
		-1,
		130,
		91,
		-1,
		-1,
		0,
		62,
		45,
		47,
		51,
		65,
		77,
		90,
		91,
		89,
		83,
		115,
		-1,
		171,
		170,
		159,
		156,
		132,
		123,
		118,
		145,
		-1,
		-1,
		140,
		161,
		151,
		155,
		171,
		196,
		-1,
		145,
		-1,
		-1,
		119,
		-1,
		-1,
		104,
		67,
		56,
		47,
		53,
		59,
		70,
		92,
		95,
		98,
		88,
		98,
		111,
		155,
		152,
		140,
		138,
		161,
		126,
		114,
		-1,
		127,
		125,
		131,
		138,
		155,
		185,
		-1,
		-1,
		161,
		141,
		-1,
		-1,
		102,
		100,
		89,
		-1,
		79,
		52,
		57,
		82,
		89,
		91,
		98,
		92,
		99,
		100,
		108,
		116,
		164,
		178,
		167,
		163,
		162,
		170,
		119,
		112,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		97,
		90,
		78,
		66,
		56,
		66,
		74,
		74,
		77,
		82,
		90,
		101,
		95,
		99,
		116,
		-1,
		198,
		-1,
		150,
		126,
		140,
		155,
		163,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		131,
		115,
		96,
		-1,
		66,
		79,
		110,
		78,
		83,
		78,
		96,
		107,
		98,
		101,
		115,
		110,
		-1,
		-1,
		138,
		141,
		-1,
		-1,
		158,
		160,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		103,
		99,
		-1,
		-1,
		67,
		92,
		81,
		89,
		84,
		96,
		106,
		104,
		100,
		104,
		116,
		-1,
		-1,
		145,
		146,
		151,
		-1,
		143,
		-1,
		161,
		-1,
		128,
		134,
		122,
		-1,
		-1,
		-1,
		105,
		68,
		89,
		99,
		104,
		102,
		93,
		92,
		99,
		109,
		107,
		118,
		-1,
		-1,
		-1,
		161,
		135,
		168,
		159,
		142,
		122,
		114,
		133,
		-1,
		103,
		-1,
		72,
		69,
		106,
		98,
		115,
		109,
		95,
		110,
		106,
		105,
		113,
		167,
		-1,
		137,
		170,
		134,
		128,
		104,
		108,
		124,
		-1,
		100,
		80,
		-1,
		110,
		100,
		132,
		118,
		106,
		93,
		100,
		114,
		110,
		-1,
		-1,
		-1,
		139,
		138,
		130,
		124,
		124,
		109,
		100,
		-1,
		112,
		94,
		73,
		90,
		90,
		81,
		89,
		122,
		118,
		111,
		113,
		105,
		-1,
		240,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		133,
		128,
		101,
		89,
		95,
		91,
		77,
		83,
		85,
		93,
		91,
		88,
		100,
		96,
		116,
		106,
		142,
		-1,
		235,
		-1,
		169,
		-1,
		-1,
		151,
		131,
		123,
		112,
		101,
		99,
		90,
		81,
		103,
		119,
		103,
		101,
		106,
		111,
		-1,
		224,
		223,
		-1,
		170,
		162,
		148,
		-1,
		141,
		-1,
		147,
		108,
		-1,
		110,
		90,
		-1,
		112,
		108,
		-1,
		-1,
		211,
		186,
		-1,
		-1,
		-1,
		171,
		151,
		142,
		126,
		-1,
		101,
		101,
		-1,
		-1,
		-1,
		196,
		195,
		-1,
		164,
		167,
		-1,
		157,
		148,
		156,
		103,
		107,
		-1,
		-1,
		-1,
		205,
		186,
		180,
		179,
		177,
		172,
		169,
		155,
		139,
		117,
		106,
		127,
		-1,
		-1,
		-1,
		177,
		169,
		162,
		-1,
		-1,
		164,
		147,
		128,
		126,
		-1,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		154,
		-1,
		-1,
		160,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		188,
		-1,
		-1,
		-1,
		150,
		146,
		147,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		234,
		198,
		-1,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		213,
		211,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		140,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		175,
		-1,
		175,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		188,
		180,
		188,
		-1,
		160,
		162,
		-1,
		210,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		165,
		172,
		194,
		197,
		233,
		-1,
		184
	],
	[
		-1,
		225,
		214,
		225,
		233,
		206,
		213,
		-1,
		232,
		236,
		202,
		196,
		235,
		204,
		210,
		221,
		-1,
		-1,
		-1,
		225,
		224,
		192,
		190,
		199,
		204,
		211,
		-1,
		210,
		-1,
		246,
		225,
		236,
		241,
		185,
		182,
		202,
		221,
		203,
		195,
		261,
		215,
		186,
		180,
		198,
		188,
		197,
		189,
		-1,
		186,
		176,
		198,
		177,
		188,
		180,
		-1,
		-1,
		180,
		181,
		187,
		173,
		179,
		175,
		-1,
		185,
		169,
		-1,
		-1,
		170,
		171,
		155,
		158,
		166,
		164,
		177,
		169,
		164,
		-1,
		-1,
		161,
		157,
		164,
		151,
		147,
		164,
		177,
		159,
		173,
		172,
		-1,
		165,
		183,
		190,
		158,
		156,
		140,
		138,
		156,
		158,
		164,
		164,
		-1,
		174,
		175,
		170,
		178,
		180,
		156,
		143,
		143,
		153,
		146,
		165,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		174,
		157,
		174,
		166,
		156,
		171,
		164,
		146,
		143,
		141,
		138,
		154,
		152,
		162,
		-1,
		-1,
		267,
		236,
		265,
		223,
		204,
		-1,
		170,
		150,
		156,
		160,
		154,
		147,
		161,
		157,
		-1,
		132,
		131,
		159,
		145,
		156,
		227,
		-1,
		-1,
		225,
		217,
		200,
		203,
		180,
		176,
		165,
		164,
		156,
		142,
		138,
		144,
		147,
		147,
		153,
		126,
		136,
		140,
		138,
		163,
		-1,
		-1,
		198,
		-1,
		-1,
		224,
		207,
		-1,
		190,
		197,
		186,
		192,
		178,
		199,
		175,
		166,
		158,
		152,
		140,
		142,
		139,
		152,
		140,
		123,
		148,
		152,
		133,
		154,
		149,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		183,
		186,
		192,
		216,
		215,
		-1,
		187,
		175,
		176,
		161,
		158,
		145,
		133,
		146,
		131,
		138,
		137,
		127,
		125,
		155,
		130,
		152,
		149,
		168,
		173,
		167,
		176,
		-1,
		232,
		228,
		224,
		231,
		180,
		-1,
		-1,
		220,
		-1,
		223,
		224,
		199,
		172,
		175,
		162,
		153,
		140,
		129,
		140,
		129,
		126,
		134,
		119,
		134,
		125,
		124,
		142,
		152,
		160,
		164,
		170,
		-1,
		282,
		-1,
		224,
		208,
		210,
		182,
		203,
		-1,
		240,
		224,
		216,
		201,
		201,
		-1,
		171,
		168,
		158,
		136,
		121,
		138,
		130,
		128,
		132,
		114,
		128,
		119,
		137,
		144,
		142,
		146,
		166,
		178,
		242,
		232,
		-1,
		214,
		219,
		178,
		186,
		205,
		243,
		207,
		-1,
		202,
		-1,
		173,
		186,
		-1,
		142,
		138,
		120,
		121,
		116,
		131,
		125,
		110,
		107,
		125,
		128,
		135,
		139,
		155,
		-1,
		-1,
		227,
		231,
		220,
		171,
		190,
		214,
		251,
		200,
		189,
		188,
		-1,
		179,
		156,
		153,
		141,
		128,
		113,
		114,
		122,
		135,
		114,
		109,
		106,
		126,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		197,
		168,
		192,
		234,
		218,
		211,
		199,
		164,
		164,
		158,
		-1,
		152,
		131,
		122,
		111,
		109,
		122,
		119,
		124,
		104,
		102,
		121,
		133,
		124,
		141,
		-1,
		-1,
		-1,
		227,
		216,
		217,
		163,
		186,
		223,
		197,
		183,
		188,
		163,
		156,
		150,
		165,
		148,
		129,
		118,
		110,
		99,
		115,
		123,
		118,
		100,
		109,
		115,
		139,
		129,
		135,
		-1,
		-1,
		234,
		224,
		208,
		210,
		207,
		177,
		184,
		216,
		188,
		201,
		-1,
		155,
		-1,
		144,
		139,
		123,
		118,
		115,
		112,
		106,
		115,
		117,
		107,
		102,
		109,
		144,
		144,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		227,
		222,
		197,
		174,
		158,
		194,
		-1,
		171,
		172,
		-1,
		149,
		143,
		140,
		125,
		121,
		116,
		120,
		113,
		120,
		113,
		111,
		112,
		94,
		126,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		220,
		199,
		192,
		212,
		153,
		205,
		-1,
		-1,
		156,
		149,
		-1,
		136,
		118,
		125,
		123,
		117,
		121,
		118,
		107,
		120,
		113,
		99,
		101,
		114,
		118,
		122,
		109,
		105,
		102,
		116,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		173,
		-1,
		165,
		157,
		147,
		141,
		135,
		131,
		129,
		145,
		129,
		132,
		130,
		121,
		129,
		102,
		95,
		102,
		91,
		109,
		117,
		109,
		103,
		102,
		112,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		186,
		-1,
		150,
		164,
		180,
		-1,
		173,
		152,
		167,
		145,
		141,
		137,
		152,
		153,
		131,
		130,
		128,
		119,
		107,
		96,
		99,
		91,
		113,
		113,
		97,
		98,
		102,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		147,
		135,
		167,
		-1,
		-1,
		209,
		-1,
		143,
		160,
		151,
		149,
		142,
		127,
		134,
		139,
		116,
		111,
		101,
		90,
		90,
		85,
		107,
		93,
		91,
		100,
		116,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		184,
		-1,
		187,
		177,
		161,
		146,
		179,
		-1,
		126,
		122,
		129,
		-1,
		136,
		-1,
		109,
		106,
		97,
		82,
		79,
		90,
		88,
		99,
		95,
		-1,
		196,
		181,
		174,
		164,
		178,
		149,
		-1,
		204,
		-1,
		-1,
		174,
		168,
		168,
		152,
		155,
		142,
		122,
		114,
		129,
		128,
		115,
		114,
		95,
		88,
		85,
		78,
		91,
		101,
		106,
		93,
		-1,
		-1,
		-1,
		201,
		187,
		191,
		151,
		170,
		-1,
		-1,
		236,
		191,
		177,
		-1,
		151,
		142,
		130,
		120,
		110,
		115,
		116,
		106,
		104,
		93,
		95,
		89,
		80,
		79,
		95,
		87,
		109,
		-1,
		-1,
		184,
		189,
		177,
		163,
		182,
		-1,
		-1,
		-1,
		183,
		199,
		170,
		149,
		131,
		-1,
		-1,
		114,
		107,
		101,
		104,
		92,
		109,
		104,
		88,
		73,
		88,
		92,
		100,
		91,
		-1,
		187,
		174,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		113,
		-1,
		87,
		98,
		91,
		110,
		117,
		90,
		75,
		69,
		75,
		87,
		96,
		-1,
		-1,
		199,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		89,
		91,
		88,
		100,
		93,
		90,
		81,
		72,
		68,
		72,
		76,
		90,
		94,
		222,
		-1,
		160,
		-1,
		-1,
		-1,
		157,
		172,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		91,
		100,
		111,
		76,
		75,
		65,
		64,
		68,
		85,
		89,
		-1,
		-1,
		158,
		154,
		183,
		165,
		169,
		170,
		-1,
		-1,
		97,
		88,
		79,
		71,
		84,
		87,
		72,
		74,
		74,
		69,
		63,
		73,
		88,
		83,
		-1,
		-1,
		-1,
		170,
		-1,
		172,
		-1,
		-1,
		160,
		168,
		115,
		97,
		93,
		91,
		78,
		72,
		62,
		67,
		77,
		71,
		68,
		59,
		63,
		86,
		75,
		114,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		149,
		141,
		136,
		142,
		144,
		135,
		130,
		127,
		-1,
		97,
		101,
		68,
		75,
		58,
		65,
		70,
		67,
		53,
		60,
		76,
		75,
		70,
		106,
		97,
		103,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		142,
		138,
		128,
		118,
		121,
		-1,
		-1,
		115,
		112,
		92,
		61,
		66,
		59,
		54,
		59,
		40,
		49,
		53,
		57,
		63,
		68,
		73,
		79,
		94,
		109,
		-1,
		189,
		226,
		219,
		187,
		195,
		226,
		-1,
		132,
		124,
		135,
		110,
		112,
		-1,
		-1,
		88,
		79,
		80,
		68,
		65,
		78,
		77,
		44,
		49,
		67,
		54,
		55,
		73,
		77,
		86,
		93,
		83,
		96,
		100,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		129,
		-1,
		-1,
		141,
		113,
		97,
		87,
		84,
		127,
		74,
		69,
		46,
		44,
		41,
		32,
		70,
		49,
		61,
		64,
		80,
		85,
		77,
		93,
		93,
		94,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		147,
		-1,
		124,
		-1,
		107,
		111,
		82,
		85,
		60,
		47,
		33,
		41,
		47,
		47,
		52,
		55,
		67,
		76,
		87,
		99,
		100,
		101,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		141,
		180,
		153,
		-1,
		137,
		-1,
		-1,
		-1,
		121,
		95,
		87,
		80,
		59,
		59,
		25,
		29,
		42,
		49,
		59,
		73,
		76,
		80,
		93,
		104,
		109,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		156,
		147,
		174,
		160,
		149,
		144,
		131,
		-1,
		-1,
		110,
		105,
		-1,
		-1,
		66,
		0,
		21,
		31,
		35,
		49,
		61,
		74,
		79,
		81,
		75,
		107,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		175,
		165,
		169,
		185,
		210,
		-1,
		120,
		-1,
		-1,
		90,
		-1,
		-1,
		75,
		5,
		7,
		18,
		37,
		43,
		54,
		76,
		75,
		90,
		80,
		90,
		103,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		141,
		139,
		145,
		152,
		169,
		199,
		-1,
		-1,
		136,
		116,
		-1,
		-1,
		73,
		71,
		60,
		-1,
		50,
		23,
		37,
		61,
		69,
		71,
		78,
		72,
		79,
		92,
		100,
		108,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		126,
		122,
		-1,
		-1,
		68,
		61,
		49,
		37,
		27,
		37,
		48,
		54,
		57,
		62,
		70,
		81,
		87,
		91,
		108,
		-1,
		212,
		-1,
		164,
		140,
		154,
		169,
		177,
		-1,
		-1,
		-1,
		143,
		129,
		122,
		110,
		108,
		-1,
		102,
		86,
		67,
		-1,
		37,
		50,
		90,
		58,
		63,
		58,
		76,
		87,
		90,
		93,
		106,
		102,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		133,
		135,
		-1,
		134,
		123,
		108,
		100,
		-1,
		-1,
		74,
		70,
		-1,
		-1,
		38,
		72,
		61,
		69,
		64,
		76,
		86,
		84,
		92,
		96,
		103,
		-1,
		-1,
		154,
		146,
		140,
		-1,
		118,
		-1,
		136,
		-1,
		103,
		109,
		97,
		-1,
		-1,
		-1,
		76,
		39,
		60,
		79,
		84,
		82,
		73,
		72,
		79,
		89,
		97,
		103,
		-1,
		-1,
		-1,
		136,
		110,
		143,
		134,
		117,
		97,
		89,
		108,
		-1,
		75,
		-1,
		43,
		40,
		81,
		78,
		95,
		89,
		75,
		90,
		86,
		95,
		93,
		142,
		-1,
		112,
		145,
		109,
		103,
		79,
		83,
		99,
		-1,
		72,
		51,
		-1,
		85,
		75,
		112,
		98,
		86,
		73,
		80,
		94,
		90,
		-1,
		-1,
		-1,
		114,
		113,
		105,
		99,
		99,
		84,
		75,
		-1,
		87,
		69,
		48,
		65,
		65,
		56,
		64,
		102,
		98,
		91,
		93,
		85,
		-1,
		215,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		108,
		103,
		76,
		64,
		70,
		66,
		52,
		58,
		60,
		68,
		66,
		63,
		75,
		71,
		91,
		86,
		119,
		-1,
		210,
		-1,
		144,
		-1,
		-1,
		126,
		106,
		98,
		87,
		76,
		74,
		65,
		56,
		78,
		94,
		78,
		76,
		81,
		86,
		-1,
		199,
		198,
		-1,
		145,
		137,
		123,
		-1,
		116,
		-1,
		122,
		83,
		-1,
		85,
		65,
		-1,
		87,
		83,
		-1,
		-1,
		186,
		161,
		-1,
		-1,
		-1,
		146,
		126,
		117,
		101,
		-1,
		76,
		76,
		-1,
		-1,
		-1,
		171,
		170,
		-1,
		139,
		142,
		-1,
		132,
		123,
		131,
		78,
		82,
		-1,
		-1,
		-1,
		180,
		161,
		155,
		154,
		152,
		147,
		144,
		130,
		114,
		92,
		81,
		102,
		-1,
		-1,
		-1,
		152,
		144,
		137,
		-1,
		-1,
		139,
		122,
		103,
		101,
		-1,
		-1,
		-1,
		174,
		155,
		-1,
		-1,
		129,
		-1,
		-1,
		135,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		163,
		-1,
		-1,
		-1,
		125,
		121,
		122,
		-1,
		-1,
		-1,
		-1,
		185,
		186,
		209,
		173,
		-1,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		188,
		186,
		-1,
		-1,
		-1,
		145,
		129,
		-1,
		115,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		150,
		-1,
		150,
		125,
		132,
		-1,
		-1,
		-1,
		-1,
		163,
		155,
		163,
		-1,
		135,
		137,
		-1,
		185,
		-1,
		-1,
		178,
		169,
		-1,
		-1,
		140,
		147,
		169,
		172,
		208,
		-1,
		159
	],
	[
		-1,
		205,
		194,
		205,
		213,
		186,
		193,
		-1,
		212,
		216,
		182,
		176,
		215,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		205,
		204,
		172,
		170,
		179,
		184,
		191,
		-1,
		190,
		-1,
		226,
		205,
		216,
		221,
		165,
		162,
		182,
		201,
		183,
		175,
		241,
		195,
		166,
		160,
		178,
		168,
		177,
		169,
		-1,
		166,
		156,
		178,
		157,
		168,
		160,
		-1,
		-1,
		160,
		161,
		167,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		150,
		151,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		141,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		145,
		163,
		170,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		144,
		-1,
		154,
		155,
		150,
		158,
		160,
		136,
		123,
		123,
		133,
		126,
		145,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		137,
		154,
		146,
		136,
		151,
		144,
		126,
		123,
		121,
		118,
		134,
		132,
		142,
		-1,
		-1,
		247,
		216,
		245,
		203,
		184,
		-1,
		150,
		130,
		136,
		140,
		134,
		127,
		141,
		137,
		-1,
		112,
		111,
		139,
		125,
		136,
		207,
		-1,
		-1,
		205,
		197,
		180,
		183,
		160,
		156,
		145,
		144,
		136,
		122,
		118,
		124,
		127,
		127,
		133,
		106,
		116,
		120,
		118,
		143,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		166,
		172,
		158,
		179,
		155,
		146,
		138,
		132,
		120,
		122,
		119,
		132,
		120,
		103,
		128,
		132,
		113,
		134,
		129,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		195,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		107,
		105,
		135,
		110,
		132,
		129,
		148,
		153,
		147,
		156,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		203,
		204,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		99,
		114,
		105,
		104,
		122,
		132,
		140,
		144,
		150,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		204,
		196,
		181,
		181,
		-1,
		151,
		148,
		138,
		116,
		101,
		118,
		110,
		108,
		112,
		94,
		108,
		99,
		117,
		124,
		122,
		126,
		146,
		158,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		105,
		90,
		87,
		105,
		108,
		115,
		119,
		135,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		136,
		133,
		121,
		108,
		93,
		94,
		102,
		115,
		94,
		89,
		86,
		106,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		89,
		102,
		99,
		104,
		84,
		82,
		101,
		113,
		104,
		121,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		145,
		128,
		109,
		98,
		90,
		79,
		95,
		103,
		98,
		80,
		89,
		95,
		119,
		109,
		115,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		92,
		86,
		95,
		97,
		87,
		82,
		89,
		124,
		124,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		96,
		100,
		93,
		100,
		93,
		91,
		92,
		74,
		106,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		103,
		97,
		101,
		98,
		87,
		100,
		93,
		79,
		81,
		94,
		98,
		102,
		89,
		85,
		82,
		96,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		112,
		110,
		101,
		109,
		82,
		75,
		82,
		71,
		89,
		97,
		89,
		83,
		82,
		92,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		110,
		108,
		99,
		87,
		76,
		79,
		71,
		93,
		93,
		77,
		78,
		82,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		107,
		114,
		119,
		96,
		91,
		81,
		70,
		70,
		65,
		87,
		73,
		71,
		80,
		96,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		106,
		102,
		109,
		-1,
		116,
		-1,
		89,
		86,
		77,
		62,
		59,
		70,
		68,
		79,
		75,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		122,
		102,
		94,
		109,
		108,
		95,
		94,
		75,
		68,
		65,
		58,
		71,
		81,
		86,
		73,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		131,
		122,
		110,
		100,
		90,
		95,
		96,
		86,
		84,
		73,
		75,
		69,
		60,
		59,
		75,
		67,
		89,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		150,
		129,
		111,
		-1,
		-1,
		94,
		87,
		81,
		84,
		72,
		89,
		84,
		68,
		53,
		68,
		72,
		80,
		71,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		162,
		107,
		96,
		91,
		95,
		93,
		-1,
		67,
		78,
		71,
		90,
		97,
		70,
		55,
		49,
		55,
		67,
		76,
		-1,
		-1,
		179,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		119,
		113,
		84,
		77,
		81,
		-1,
		69,
		71,
		68,
		80,
		73,
		70,
		61,
		52,
		48,
		52,
		56,
		70,
		74,
		202,
		-1,
		140,
		-1,
		-1,
		-1,
		137,
		152,
		123,
		100,
		73,
		68,
		61,
		55,
		60,
		71,
		80,
		91,
		56,
		55,
		45,
		44,
		48,
		65,
		69,
		-1,
		-1,
		138,
		134,
		163,
		145,
		149,
		150,
		-1,
		-1,
		77,
		68,
		59,
		51,
		64,
		67,
		52,
		54,
		54,
		49,
		43,
		53,
		68,
		63,
		-1,
		-1,
		-1,
		150,
		-1,
		152,
		-1,
		-1,
		140,
		148,
		95,
		77,
		73,
		71,
		58,
		52,
		42,
		47,
		57,
		51,
		48,
		39,
		43,
		66,
		55,
		94,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		129,
		121,
		116,
		122,
		124,
		115,
		110,
		107,
		-1,
		77,
		81,
		48,
		55,
		38,
		45,
		50,
		47,
		33,
		40,
		56,
		55,
		50,
		86,
		77,
		83,
		-1,
		-1,
		215,
		204,
		193,
		199,
		-1,
		122,
		118,
		108,
		98,
		101,
		-1,
		-1,
		95,
		92,
		72,
		41,
		46,
		39,
		34,
		39,
		20,
		29,
		33,
		37,
		43,
		48,
		53,
		59,
		74,
		89,
		-1,
		169,
		206,
		199,
		167,
		175,
		206,
		-1,
		112,
		104,
		115,
		90,
		92,
		-1,
		-1,
		68,
		59,
		60,
		48,
		45,
		58,
		57,
		24,
		29,
		47,
		34,
		35,
		53,
		57,
		66,
		73,
		63,
		76,
		80,
		-1,
		162,
		182,
		161,
		164,
		188,
		202,
		-1,
		109,
		-1,
		-1,
		121,
		93,
		77,
		67,
		64,
		107,
		54,
		49,
		26,
		24,
		21,
		12,
		50,
		29,
		41,
		44,
		60,
		65,
		57,
		73,
		73,
		74,
		-1,
		151,
		162,
		155,
		-1,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		134,
		-1,
		104,
		-1,
		87,
		91,
		62,
		65,
		40,
		27,
		13,
		21,
		27,
		27,
		32,
		35,
		47,
		56,
		67,
		79,
		80,
		81,
		176,
		132,
		135,
		146,
		157,
		172,
		176,
		-1,
		121,
		160,
		140,
		-1,
		124,
		-1,
		-1,
		-1,
		101,
		75,
		67,
		60,
		39,
		39,
		5,
		9,
		22,
		29,
		39,
		53,
		56,
		60,
		73,
		84,
		89,
		172,
		163,
		176,
		121,
		121,
		142,
		151,
		172,
		136,
		127,
		154,
		147,
		136,
		131,
		118,
		-1,
		-1,
		97,
		85,
		-1,
		-1,
		46,
		20,
		0,
		11,
		15,
		29,
		41,
		54,
		63,
		61,
		55,
		87,
		-1,
		165,
		164,
		153,
		150,
		126,
		117,
		112,
		139,
		-1,
		-1,
		134,
		155,
		145,
		149,
		165,
		190,
		-1,
		107,
		-1,
		-1,
		77,
		-1,
		-1,
		62,
		25,
		14,
		5,
		17,
		23,
		34,
		56,
		59,
		70,
		60,
		70,
		83,
		149,
		146,
		134,
		132,
		155,
		120,
		108,
		-1,
		121,
		119,
		125,
		132,
		149,
		179,
		-1,
		-1,
		123,
		103,
		-1,
		-1,
		60,
		58,
		47,
		-1,
		37,
		10,
		21,
		46,
		53,
		55,
		62,
		56,
		63,
		72,
		80,
		88,
		158,
		172,
		161,
		157,
		156,
		164,
		113,
		106,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		-1,
		113,
		109,
		-1,
		-1,
		55,
		48,
		36,
		24,
		14,
		24,
		38,
		38,
		41,
		46,
		54,
		65,
		67,
		71,
		88,
		-1,
		192,
		-1,
		144,
		120,
		134,
		149,
		157,
		-1,
		-1,
		-1,
		130,
		116,
		109,
		97,
		95,
		-1,
		89,
		73,
		54,
		-1,
		24,
		37,
		74,
		42,
		47,
		42,
		60,
		71,
		70,
		73,
		87,
		82,
		-1,
		-1,
		132,
		135,
		-1,
		-1,
		120,
		122,
		-1,
		121,
		110,
		95,
		87,
		-1,
		-1,
		61,
		57,
		-1,
		-1,
		25,
		56,
		45,
		53,
		48,
		60,
		70,
		68,
		72,
		76,
		87,
		-1,
		-1,
		139,
		133,
		127,
		-1,
		105,
		-1,
		123,
		-1,
		90,
		96,
		84,
		-1,
		-1,
		-1,
		63,
		26,
		47,
		63,
		68,
		66,
		57,
		56,
		63,
		73,
		79,
		87,
		-1,
		-1,
		-1,
		123,
		97,
		130,
		121,
		104,
		84,
		76,
		95,
		-1,
		62,
		-1,
		30,
		27,
		68,
		62,
		79,
		73,
		59,
		74,
		70,
		77,
		77,
		129,
		-1,
		99,
		132,
		96,
		90,
		66,
		70,
		86,
		-1,
		59,
		38,
		-1,
		72,
		62,
		96,
		82,
		70,
		57,
		64,
		78,
		74,
		-1,
		-1,
		-1,
		101,
		100,
		92,
		86,
		86,
		71,
		62,
		-1,
		74,
		56,
		35,
		52,
		52,
		43,
		51,
		86,
		82,
		75,
		77,
		69,
		-1,
		202,
		-1,
		-1,
		124,
		-1,
		-1,
		-1,
		95,
		90,
		63,
		51,
		57,
		53,
		39,
		45,
		47,
		55,
		53,
		50,
		62,
		58,
		78,
		70,
		106,
		-1,
		197,
		-1,
		131,
		-1,
		-1,
		113,
		93,
		85,
		74,
		63,
		61,
		52,
		43,
		65,
		81,
		65,
		63,
		68,
		73,
		-1,
		186,
		185,
		-1,
		132,
		124,
		110,
		-1,
		103,
		-1,
		109,
		70,
		-1,
		72,
		52,
		-1,
		74,
		70,
		-1,
		-1,
		173,
		148,
		-1,
		-1,
		-1,
		133,
		113,
		104,
		88,
		-1,
		63,
		63,
		-1,
		-1,
		-1,
		158,
		157,
		-1,
		126,
		129,
		-1,
		119,
		110,
		118,
		65,
		69,
		-1,
		-1,
		-1,
		167,
		148,
		142,
		141,
		139,
		134,
		131,
		117,
		101,
		79,
		68,
		89,
		-1,
		-1,
		-1,
		139,
		131,
		124,
		-1,
		-1,
		126,
		109,
		90,
		88,
		-1,
		-1,
		-1,
		161,
		142,
		-1,
		-1,
		116,
		-1,
		-1,
		122,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		150,
		-1,
		-1,
		-1,
		112,
		108,
		109,
		-1,
		-1,
		-1,
		-1,
		172,
		173,
		196,
		160,
		-1,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		175,
		173,
		-1,
		-1,
		-1,
		132,
		116,
		-1,
		102,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		137,
		-1,
		137,
		112,
		119,
		-1,
		-1,
		-1,
		-1,
		150,
		142,
		150,
		-1,
		122,
		124,
		-1,
		172,
		-1,
		-1,
		165,
		156,
		-1,
		-1,
		127,
		134,
		156,
		159,
		195,
		-1,
		146
	],
	[
		-1,
		206,
		195,
		206,
		214,
		187,
		194,
		-1,
		213,
		217,
		183,
		177,
		216,
		185,
		191,
		202,
		-1,
		-1,
		-1,
		206,
		205,
		173,
		171,
		180,
		185,
		192,
		-1,
		191,
		-1,
		227,
		206,
		217,
		222,
		166,
		163,
		183,
		202,
		184,
		176,
		242,
		196,
		167,
		161,
		179,
		169,
		178,
		170,
		-1,
		167,
		157,
		179,
		158,
		169,
		161,
		-1,
		-1,
		161,
		162,
		168,
		154,
		160,
		156,
		-1,
		166,
		150,
		-1,
		-1,
		151,
		152,
		136,
		139,
		147,
		145,
		158,
		150,
		145,
		-1,
		-1,
		142,
		138,
		145,
		132,
		128,
		145,
		158,
		140,
		154,
		153,
		-1,
		146,
		164,
		171,
		139,
		137,
		121,
		119,
		137,
		139,
		145,
		145,
		-1,
		155,
		156,
		151,
		159,
		161,
		137,
		124,
		124,
		134,
		127,
		146,
		134,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		155,
		138,
		155,
		147,
		137,
		152,
		145,
		127,
		124,
		122,
		119,
		135,
		133,
		143,
		-1,
		-1,
		248,
		217,
		246,
		204,
		185,
		-1,
		151,
		131,
		137,
		141,
		135,
		128,
		142,
		138,
		-1,
		113,
		112,
		140,
		126,
		137,
		208,
		-1,
		-1,
		206,
		198,
		181,
		184,
		161,
		157,
		146,
		145,
		137,
		123,
		119,
		125,
		128,
		128,
		134,
		107,
		117,
		121,
		119,
		144,
		-1,
		-1,
		179,
		-1,
		-1,
		205,
		188,
		-1,
		171,
		178,
		167,
		173,
		159,
		180,
		156,
		147,
		139,
		133,
		121,
		123,
		120,
		133,
		121,
		104,
		129,
		133,
		114,
		135,
		130,
		-1,
		178,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		164,
		167,
		173,
		197,
		196,
		-1,
		168,
		156,
		157,
		142,
		139,
		126,
		114,
		127,
		112,
		119,
		118,
		108,
		106,
		136,
		111,
		133,
		130,
		149,
		154,
		148,
		157,
		-1,
		213,
		209,
		205,
		212,
		161,
		-1,
		-1,
		201,
		-1,
		204,
		205,
		180,
		153,
		156,
		143,
		134,
		121,
		110,
		121,
		110,
		107,
		115,
		100,
		115,
		106,
		105,
		123,
		133,
		141,
		145,
		151,
		-1,
		263,
		-1,
		205,
		189,
		191,
		163,
		184,
		-1,
		221,
		205,
		197,
		182,
		182,
		-1,
		152,
		149,
		139,
		117,
		102,
		119,
		111,
		109,
		113,
		95,
		109,
		100,
		118,
		125,
		123,
		127,
		147,
		159,
		223,
		213,
		-1,
		195,
		200,
		159,
		167,
		186,
		224,
		188,
		-1,
		183,
		-1,
		154,
		167,
		-1,
		123,
		119,
		101,
		102,
		97,
		112,
		106,
		91,
		88,
		106,
		109,
		116,
		120,
		136,
		-1,
		-1,
		208,
		212,
		201,
		152,
		171,
		195,
		232,
		181,
		170,
		169,
		-1,
		160,
		137,
		134,
		122,
		109,
		94,
		95,
		103,
		116,
		95,
		90,
		87,
		107,
		133,
		111,
		123,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		178,
		149,
		173,
		215,
		199,
		192,
		180,
		145,
		145,
		139,
		-1,
		133,
		112,
		103,
		92,
		90,
		103,
		100,
		105,
		85,
		83,
		102,
		114,
		105,
		122,
		-1,
		-1,
		-1,
		208,
		197,
		198,
		144,
		167,
		204,
		178,
		164,
		169,
		144,
		137,
		131,
		146,
		129,
		110,
		99,
		91,
		80,
		96,
		104,
		99,
		81,
		90,
		96,
		120,
		110,
		116,
		-1,
		-1,
		215,
		205,
		189,
		191,
		188,
		158,
		165,
		197,
		169,
		182,
		-1,
		136,
		-1,
		125,
		120,
		104,
		99,
		96,
		93,
		87,
		96,
		98,
		88,
		83,
		90,
		125,
		125,
		100,
		120,
		123,
		-1,
		-1,
		-1,
		208,
		203,
		178,
		155,
		139,
		175,
		-1,
		152,
		153,
		-1,
		130,
		124,
		121,
		106,
		102,
		97,
		101,
		94,
		101,
		94,
		92,
		93,
		75,
		107,
		-1,
		108,
		102,
		110,
		100,
		88,
		-1,
		-1,
		-1,
		201,
		180,
		173,
		193,
		134,
		186,
		-1,
		-1,
		137,
		130,
		-1,
		117,
		99,
		106,
		104,
		98,
		102,
		99,
		88,
		101,
		94,
		80,
		82,
		95,
		99,
		103,
		90,
		86,
		83,
		97,
		-1,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		154,
		-1,
		146,
		138,
		128,
		122,
		116,
		112,
		110,
		126,
		110,
		113,
		111,
		102,
		110,
		83,
		76,
		83,
		72,
		90,
		98,
		90,
		84,
		83,
		93,
		-1,
		221,
		207,
		178,
		-1,
		-1,
		167,
		-1,
		131,
		145,
		161,
		-1,
		154,
		133,
		148,
		126,
		122,
		118,
		133,
		134,
		112,
		111,
		109,
		100,
		88,
		77,
		80,
		72,
		94,
		94,
		78,
		79,
		83,
		-1,
		227,
		214,
		172,
		168,
		157,
		177,
		128,
		116,
		148,
		-1,
		-1,
		190,
		-1,
		124,
		141,
		132,
		130,
		123,
		109,
		116,
		120,
		97,
		92,
		82,
		71,
		71,
		66,
		88,
		74,
		72,
		81,
		97,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		143,
		130,
		124,
		-1,
		165,
		-1,
		168,
		158,
		142,
		127,
		160,
		-1,
		108,
		104,
		111,
		-1,
		117,
		-1,
		90,
		87,
		78,
		63,
		60,
		71,
		69,
		80,
		76,
		-1,
		177,
		162,
		155,
		145,
		159,
		130,
		-1,
		185,
		-1,
		-1,
		155,
		149,
		149,
		133,
		136,
		124,
		104,
		96,
		111,
		110,
		97,
		96,
		76,
		69,
		66,
		59,
		72,
		82,
		87,
		74,
		-1,
		-1,
		-1,
		182,
		168,
		172,
		132,
		151,
		-1,
		-1,
		217,
		172,
		158,
		-1,
		133,
		124,
		112,
		102,
		92,
		97,
		98,
		88,
		86,
		74,
		76,
		70,
		61,
		60,
		76,
		68,
		90,
		-1,
		-1,
		165,
		170,
		158,
		144,
		163,
		-1,
		-1,
		-1,
		164,
		180,
		152,
		131,
		113,
		-1,
		-1,
		96,
		89,
		83,
		86,
		74,
		90,
		85,
		69,
		54,
		69,
		73,
		81,
		72,
		-1,
		168,
		155,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		-1,
		-1,
		164,
		109,
		98,
		93,
		97,
		95,
		-1,
		69,
		80,
		73,
		92,
		99,
		71,
		56,
		50,
		56,
		68,
		77,
		-1,
		-1,
		180,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		86,
		79,
		83,
		-1,
		71,
		73,
		70,
		82,
		74,
		71,
		62,
		53,
		49,
		53,
		57,
		71,
		75,
		203,
		-1,
		142,
		-1,
		-1,
		-1,
		139,
		154,
		125,
		102,
		75,
		70,
		63,
		57,
		62,
		73,
		82,
		93,
		58,
		56,
		46,
		45,
		49,
		66,
		70,
		-1,
		-1,
		140,
		136,
		165,
		147,
		151,
		152,
		-1,
		-1,
		79,
		70,
		61,
		53,
		66,
		69,
		54,
		56,
		56,
		50,
		44,
		54,
		69,
		64,
		-1,
		-1,
		-1,
		152,
		-1,
		154,
		-1,
		-1,
		142,
		150,
		97,
		79,
		75,
		73,
		60,
		54,
		44,
		49,
		59,
		53,
		50,
		40,
		44,
		67,
		56,
		93,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		131,
		123,
		118,
		124,
		126,
		117,
		112,
		109,
		-1,
		79,
		83,
		50,
		57,
		40,
		47,
		52,
		49,
		34,
		41,
		57,
		56,
		51,
		85,
		76,
		80,
		-1,
		-1,
		217,
		206,
		195,
		201,
		-1,
		124,
		120,
		110,
		100,
		103,
		-1,
		-1,
		97,
		94,
		74,
		43,
		48,
		41,
		36,
		41,
		22,
		30,
		34,
		38,
		44,
		49,
		54,
		60,
		71,
		86,
		-1,
		171,
		208,
		201,
		169,
		177,
		208,
		-1,
		114,
		106,
		117,
		92,
		94,
		-1,
		-1,
		70,
		61,
		62,
		50,
		47,
		60,
		59,
		26,
		23,
		45,
		23,
		33,
		54,
		57,
		61,
		62,
		64,
		77,
		81,
		-1,
		164,
		184,
		163,
		166,
		190,
		204,
		-1,
		111,
		-1,
		-1,
		123,
		95,
		79,
		69,
		66,
		109,
		56,
		51,
		28,
		26,
		23,
		14,
		41,
		18,
		30,
		33,
		49,
		54,
		46,
		72,
		74,
		75,
		-1,
		153,
		164,
		157,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		138,
		-1,
		106,
		-1,
		89,
		93,
		64,
		67,
		42,
		29,
		15,
		15,
		21,
		16,
		21,
		24,
		36,
		45,
		56,
		68,
		78,
		80,
		178,
		134,
		137,
		148,
		159,
		174,
		178,
		-1,
		123,
		162,
		144,
		-1,
		128,
		-1,
		-1,
		-1,
		103,
		77,
		69,
		62,
		41,
		41,
		7,
		3,
		11,
		18,
		28,
		42,
		45,
		49,
		62,
		73,
		88,
		174,
		165,
		178,
		123,
		123,
		144,
		153,
		174,
		138,
		129,
		156,
		151,
		140,
		135,
		122,
		-1,
		-1,
		105,
		87,
		-1,
		-1,
		48,
		28,
		11,
		0,
		4,
		18,
		30,
		43,
		52,
		50,
		44,
		76,
		-1,
		167,
		166,
		155,
		152,
		128,
		119,
		114,
		141,
		-1,
		-1,
		136,
		157,
		147,
		151,
		167,
		192,
		-1,
		111,
		-1,
		-1,
		85,
		-1,
		-1,
		70,
		33,
		22,
		13,
		11,
		12,
		23,
		45,
		53,
		59,
		49,
		59,
		72,
		151,
		148,
		136,
		134,
		157,
		122,
		110,
		-1,
		123,
		121,
		127,
		134,
		151,
		181,
		-1,
		-1,
		127,
		107,
		-1,
		-1,
		68,
		66,
		55,
		-1,
		45,
		18,
		15,
		35,
		47,
		49,
		56,
		50,
		57,
		61,
		69,
		77,
		160,
		174,
		163,
		159,
		158,
		166,
		115,
		108,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		117,
		113,
		-1,
		-1,
		63,
		56,
		44,
		32,
		22,
		29,
		28,
		32,
		35,
		40,
		48,
		59,
		56,
		60,
		77,
		-1,
		194,
		-1,
		146,
		122,
		136,
		151,
		159,
		-1,
		-1,
		-1,
		134,
		120,
		113,
		101,
		99,
		-1,
		97,
		81,
		62,
		-1,
		32,
		45,
		68,
		36,
		41,
		36,
		54,
		65,
		59,
		62,
		76,
		71,
		-1,
		-1,
		134,
		137,
		-1,
		-1,
		124,
		126,
		-1,
		125,
		114,
		99,
		91,
		-1,
		-1,
		69,
		65,
		-1,
		-1,
		33,
		50,
		39,
		47,
		42,
		54,
		64,
		62,
		61,
		65,
		77,
		-1,
		-1,
		141,
		137,
		131,
		-1,
		109,
		-1,
		127,
		-1,
		94,
		100,
		88,
		-1,
		-1,
		-1,
		71,
		34,
		55,
		57,
		62,
		60,
		51,
		50,
		57,
		67,
		68,
		79,
		-1,
		-1,
		-1,
		127,
		101,
		134,
		125,
		108,
		88,
		80,
		99,
		-1,
		69,
		-1,
		38,
		35,
		71,
		56,
		73,
		67,
		53,
		68,
		64,
		66,
		71,
		133,
		-1,
		103,
		136,
		100,
		94,
		70,
		74,
		90,
		-1,
		66,
		46,
		-1,
		76,
		66,
		90,
		76,
		64,
		51,
		58,
		72,
		68,
		-1,
		-1,
		-1,
		105,
		104,
		96,
		90,
		90,
		75,
		66,
		-1,
		78,
		60,
		39,
		56,
		56,
		47,
		55,
		80,
		76,
		69,
		71,
		63,
		-1,
		206,
		-1,
		-1,
		128,
		-1,
		-1,
		-1,
		99,
		94,
		67,
		55,
		61,
		57,
		43,
		49,
		51,
		59,
		57,
		54,
		66,
		62,
		82,
		64,
		100,
		-1,
		201,
		-1,
		135,
		-1,
		-1,
		117,
		97,
		89,
		78,
		67,
		65,
		56,
		47,
		69,
		85,
		69,
		67,
		71,
		72,
		-1,
		190,
		189,
		-1,
		136,
		128,
		114,
		-1,
		107,
		-1,
		113,
		74,
		-1,
		76,
		56,
		-1,
		78,
		74,
		-1,
		-1,
		177,
		152,
		-1,
		-1,
		-1,
		137,
		117,
		108,
		92,
		-1,
		67,
		67,
		-1,
		-1,
		-1,
		162,
		161,
		-1,
		130,
		133,
		-1,
		123,
		114,
		122,
		69,
		73,
		-1,
		-1,
		-1,
		171,
		152,
		146,
		145,
		143,
		138,
		135,
		121,
		105,
		83,
		72,
		93,
		-1,
		-1,
		-1,
		143,
		135,
		128,
		-1,
		-1,
		130,
		113,
		94,
		92,
		-1,
		-1,
		-1,
		165,
		146,
		-1,
		-1,
		120,
		-1,
		-1,
		126,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		154,
		-1,
		-1,
		-1,
		116,
		112,
		113,
		-1,
		-1,
		-1,
		-1,
		176,
		177,
		200,
		164,
		-1,
		-1,
		-1,
		108,
		102,
		-1,
		-1,
		179,
		177,
		-1,
		-1,
		-1,
		136,
		120,
		-1,
		106,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		141,
		-1,
		141,
		116,
		123,
		-1,
		-1,
		-1,
		-1,
		154,
		146,
		154,
		-1,
		126,
		128,
		-1,
		176,
		-1,
		-1,
		169,
		160,
		-1,
		-1,
		131,
		138,
		160,
		163,
		199,
		-1,
		150
	],
	[
		-1,
		202,
		191,
		202,
		210,
		183,
		190,
		-1,
		209,
		213,
		179,
		173,
		212,
		181,
		187,
		198,
		-1,
		-1,
		-1,
		202,
		201,
		169,
		167,
		176,
		181,
		188,
		-1,
		187,
		-1,
		223,
		202,
		213,
		218,
		162,
		159,
		179,
		198,
		180,
		172,
		238,
		192,
		163,
		157,
		175,
		165,
		174,
		166,
		-1,
		163,
		153,
		175,
		154,
		165,
		157,
		-1,
		-1,
		157,
		158,
		164,
		150,
		156,
		152,
		-1,
		162,
		146,
		-1,
		-1,
		147,
		148,
		132,
		135,
		143,
		141,
		154,
		146,
		141,
		-1,
		-1,
		138,
		134,
		141,
		128,
		124,
		141,
		154,
		136,
		150,
		149,
		-1,
		142,
		160,
		167,
		135,
		133,
		117,
		115,
		133,
		135,
		141,
		141,
		-1,
		151,
		152,
		147,
		155,
		157,
		133,
		120,
		120,
		130,
		123,
		142,
		130,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		151,
		134,
		151,
		143,
		133,
		148,
		141,
		123,
		120,
		118,
		115,
		131,
		129,
		139,
		-1,
		-1,
		244,
		213,
		242,
		200,
		181,
		-1,
		147,
		127,
		133,
		137,
		131,
		124,
		138,
		134,
		-1,
		109,
		108,
		136,
		122,
		133,
		204,
		-1,
		-1,
		202,
		194,
		177,
		180,
		157,
		153,
		142,
		141,
		133,
		119,
		115,
		121,
		124,
		124,
		130,
		103,
		113,
		117,
		115,
		140,
		-1,
		-1,
		175,
		-1,
		-1,
		201,
		184,
		-1,
		167,
		174,
		163,
		169,
		155,
		176,
		152,
		143,
		135,
		129,
		117,
		119,
		116,
		129,
		117,
		100,
		125,
		129,
		110,
		131,
		126,
		-1,
		174,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		160,
		163,
		169,
		193,
		192,
		-1,
		164,
		152,
		153,
		138,
		135,
		122,
		110,
		123,
		108,
		115,
		114,
		104,
		102,
		132,
		107,
		129,
		126,
		145,
		150,
		144,
		153,
		-1,
		209,
		205,
		201,
		208,
		157,
		-1,
		-1,
		197,
		-1,
		200,
		201,
		176,
		149,
		152,
		139,
		130,
		117,
		106,
		117,
		106,
		103,
		111,
		96,
		111,
		102,
		101,
		119,
		129,
		137,
		141,
		147,
		-1,
		259,
		-1,
		201,
		185,
		187,
		159,
		180,
		-1,
		217,
		201,
		193,
		178,
		178,
		-1,
		148,
		145,
		135,
		113,
		98,
		115,
		107,
		105,
		109,
		91,
		105,
		96,
		114,
		121,
		119,
		123,
		143,
		155,
		219,
		209,
		-1,
		191,
		196,
		155,
		163,
		182,
		220,
		184,
		-1,
		179,
		-1,
		150,
		163,
		-1,
		119,
		115,
		97,
		98,
		93,
		108,
		102,
		87,
		84,
		102,
		105,
		112,
		116,
		132,
		-1,
		-1,
		204,
		208,
		197,
		148,
		167,
		191,
		228,
		177,
		166,
		165,
		-1,
		156,
		133,
		130,
		118,
		105,
		90,
		91,
		99,
		112,
		91,
		86,
		83,
		103,
		129,
		107,
		119,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		174,
		145,
		169,
		211,
		195,
		188,
		176,
		141,
		141,
		135,
		-1,
		129,
		108,
		99,
		88,
		86,
		99,
		96,
		101,
		81,
		79,
		98,
		110,
		101,
		118,
		-1,
		-1,
		-1,
		204,
		193,
		194,
		140,
		163,
		200,
		174,
		160,
		165,
		140,
		133,
		127,
		142,
		125,
		106,
		95,
		87,
		76,
		92,
		100,
		95,
		77,
		86,
		92,
		116,
		106,
		112,
		-1,
		-1,
		211,
		201,
		185,
		187,
		184,
		154,
		161,
		193,
		165,
		178,
		-1,
		132,
		-1,
		121,
		116,
		100,
		95,
		92,
		89,
		83,
		92,
		94,
		84,
		79,
		86,
		121,
		121,
		96,
		116,
		119,
		-1,
		-1,
		-1,
		204,
		199,
		174,
		151,
		135,
		171,
		-1,
		148,
		149,
		-1,
		126,
		120,
		117,
		102,
		98,
		93,
		97,
		90,
		97,
		90,
		88,
		89,
		71,
		103,
		-1,
		104,
		98,
		106,
		96,
		84,
		-1,
		-1,
		-1,
		197,
		176,
		169,
		189,
		130,
		182,
		-1,
		-1,
		133,
		126,
		-1,
		113,
		95,
		102,
		100,
		94,
		98,
		95,
		84,
		97,
		90,
		76,
		78,
		91,
		95,
		99,
		86,
		82,
		79,
		93,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		150,
		-1,
		142,
		134,
		124,
		118,
		112,
		108,
		106,
		122,
		106,
		109,
		107,
		98,
		106,
		79,
		72,
		79,
		68,
		86,
		94,
		86,
		80,
		79,
		89,
		-1,
		217,
		203,
		174,
		-1,
		-1,
		163,
		-1,
		127,
		141,
		157,
		-1,
		150,
		129,
		144,
		122,
		118,
		114,
		129,
		130,
		108,
		107,
		105,
		96,
		84,
		73,
		76,
		68,
		90,
		90,
		74,
		75,
		79,
		-1,
		223,
		210,
		168,
		164,
		153,
		173,
		124,
		112,
		144,
		-1,
		-1,
		186,
		-1,
		120,
		137,
		128,
		126,
		119,
		110,
		116,
		116,
		93,
		88,
		78,
		67,
		67,
		62,
		84,
		70,
		68,
		77,
		93,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		139,
		126,
		120,
		-1,
		161,
		-1,
		164,
		154,
		138,
		123,
		156,
		-1,
		112,
		108,
		115,
		-1,
		113,
		-1,
		86,
		83,
		74,
		59,
		56,
		67,
		65,
		76,
		72,
		-1,
		173,
		158,
		151,
		141,
		155,
		126,
		-1,
		181,
		-1,
		-1,
		151,
		145,
		145,
		129,
		132,
		128,
		108,
		100,
		115,
		108,
		100,
		94,
		72,
		65,
		62,
		55,
		68,
		78,
		83,
		70,
		-1,
		-1,
		-1,
		178,
		164,
		168,
		128,
		147,
		-1,
		-1,
		213,
		168,
		154,
		-1,
		137,
		128,
		116,
		106,
		96,
		101,
		102,
		91,
		84,
		70,
		72,
		66,
		57,
		56,
		72,
		64,
		86,
		-1,
		-1,
		161,
		166,
		154,
		140,
		159,
		-1,
		-1,
		-1,
		160,
		176,
		156,
		135,
		117,
		-1,
		-1,
		100,
		93,
		87,
		87,
		74,
		86,
		81,
		65,
		50,
		65,
		69,
		77,
		68,
		-1,
		164,
		151,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		-1,
		-1,
		168,
		113,
		102,
		97,
		101,
		99,
		-1,
		73,
		84,
		77,
		90,
		97,
		67,
		52,
		46,
		52,
		64,
		73,
		-1,
		-1,
		176,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		125,
		119,
		90,
		83,
		87,
		-1,
		75,
		77,
		74,
		86,
		70,
		67,
		58,
		49,
		45,
		49,
		53,
		67,
		71,
		199,
		-1,
		146,
		-1,
		-1,
		-1,
		143,
		158,
		129,
		106,
		79,
		74,
		67,
		61,
		66,
		77,
		78,
		89,
		56,
		52,
		42,
		41,
		45,
		62,
		66,
		-1,
		-1,
		144,
		140,
		169,
		151,
		155,
		156,
		-1,
		-1,
		83,
		74,
		65,
		57,
		70,
		73,
		58,
		59,
		53,
		46,
		40,
		50,
		65,
		60,
		-1,
		-1,
		-1,
		156,
		-1,
		158,
		-1,
		-1,
		146,
		154,
		101,
		83,
		79,
		77,
		64,
		58,
		48,
		53,
		63,
		54,
		48,
		36,
		40,
		63,
		52,
		89,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		135,
		127,
		122,
		128,
		130,
		121,
		116,
		113,
		-1,
		83,
		87,
		54,
		61,
		44,
		51,
		56,
		50,
		30,
		37,
		53,
		52,
		47,
		81,
		72,
		76,
		-1,
		-1,
		221,
		210,
		199,
		205,
		-1,
		128,
		124,
		114,
		104,
		107,
		-1,
		-1,
		101,
		98,
		78,
		47,
		52,
		45,
		40,
		45,
		26,
		26,
		30,
		34,
		40,
		45,
		50,
		56,
		67,
		82,
		-1,
		175,
		212,
		205,
		173,
		181,
		212,
		-1,
		118,
		110,
		121,
		96,
		98,
		-1,
		-1,
		74,
		65,
		66,
		54,
		51,
		64,
		63,
		30,
		27,
		41,
		19,
		29,
		50,
		53,
		57,
		58,
		60,
		73,
		77,
		-1,
		168,
		188,
		167,
		170,
		194,
		208,
		-1,
		115,
		-1,
		-1,
		127,
		99,
		83,
		73,
		70,
		113,
		60,
		55,
		32,
		30,
		27,
		18,
		37,
		14,
		26,
		29,
		45,
		50,
		42,
		68,
		70,
		71,
		-1,
		157,
		168,
		161,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		142,
		-1,
		110,
		-1,
		93,
		97,
		68,
		71,
		46,
		33,
		19,
		19,
		18,
		12,
		17,
		20,
		32,
		41,
		52,
		64,
		74,
		76,
		182,
		138,
		141,
		152,
		163,
		178,
		182,
		-1,
		127,
		166,
		148,
		-1,
		132,
		-1,
		-1,
		-1,
		107,
		81,
		73,
		66,
		45,
		45,
		11,
		7,
		7,
		14,
		24,
		38,
		41,
		45,
		58,
		69,
		84,
		178,
		169,
		182,
		127,
		127,
		148,
		157,
		178,
		142,
		133,
		160,
		155,
		144,
		139,
		126,
		-1,
		-1,
		109,
		91,
		-1,
		-1,
		52,
		32,
		15,
		4,
		0,
		14,
		26,
		39,
		48,
		46,
		40,
		72,
		-1,
		171,
		170,
		159,
		156,
		132,
		123,
		118,
		145,
		-1,
		-1,
		140,
		161,
		151,
		155,
		171,
		196,
		-1,
		115,
		-1,
		-1,
		89,
		-1,
		-1,
		74,
		37,
		26,
		17,
		15,
		8,
		19,
		41,
		54,
		55,
		45,
		55,
		68,
		155,
		152,
		140,
		138,
		161,
		126,
		114,
		-1,
		127,
		125,
		131,
		138,
		155,
		185,
		-1,
		-1,
		131,
		111,
		-1,
		-1,
		72,
		70,
		59,
		-1,
		49,
		22,
		19,
		35,
		51,
		53,
		57,
		51,
		58,
		57,
		65,
		73,
		164,
		178,
		167,
		163,
		162,
		170,
		119,
		112,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		121,
		117,
		-1,
		-1,
		67,
		60,
		48,
		36,
		26,
		33,
		28,
		36,
		39,
		44,
		49,
		60,
		52,
		56,
		73,
		-1,
		198,
		-1,
		150,
		126,
		140,
		155,
		163,
		-1,
		-1,
		-1,
		138,
		124,
		117,
		105,
		103,
		-1,
		101,
		85,
		66,
		-1,
		36,
		49,
		72,
		40,
		45,
		40,
		55,
		66,
		55,
		58,
		72,
		67,
		-1,
		-1,
		138,
		141,
		-1,
		-1,
		128,
		130,
		-1,
		129,
		118,
		103,
		95,
		-1,
		-1,
		73,
		69,
		-1,
		-1,
		37,
		54,
		43,
		51,
		46,
		58,
		65,
		66,
		57,
		61,
		73,
		-1,
		-1,
		145,
		141,
		135,
		-1,
		113,
		-1,
		131,
		-1,
		98,
		104,
		92,
		-1,
		-1,
		-1,
		75,
		38,
		59,
		61,
		66,
		64,
		55,
		54,
		61,
		68,
		64,
		75,
		-1,
		-1,
		-1,
		131,
		105,
		138,
		129,
		112,
		92,
		84,
		103,
		-1,
		73,
		-1,
		42,
		39,
		75,
		60,
		77,
		71,
		57,
		72,
		68,
		62,
		71,
		137,
		-1,
		107,
		140,
		104,
		98,
		74,
		78,
		94,
		-1,
		70,
		50,
		-1,
		80,
		70,
		94,
		80,
		68,
		55,
		62,
		75,
		68,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		94,
		79,
		70,
		-1,
		82,
		64,
		43,
		60,
		60,
		51,
		59,
		84,
		80,
		73,
		75,
		67,
		-1,
		210,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		98,
		71,
		59,
		65,
		61,
		47,
		53,
		55,
		63,
		61,
		58,
		70,
		66,
		86,
		68,
		104,
		-1,
		205,
		-1,
		139,
		-1,
		-1,
		121,
		101,
		93,
		82,
		71,
		69,
		60,
		51,
		73,
		89,
		73,
		71,
		75,
		76,
		-1,
		194,
		193,
		-1,
		140,
		132,
		118,
		-1,
		111,
		-1,
		117,
		78,
		-1,
		80,
		60,
		-1,
		82,
		78,
		-1,
		-1,
		181,
		156,
		-1,
		-1,
		-1,
		141,
		121,
		112,
		96,
		-1,
		71,
		71,
		-1,
		-1,
		-1,
		166,
		165,
		-1,
		134,
		137,
		-1,
		127,
		118,
		126,
		73,
		77,
		-1,
		-1,
		-1,
		175,
		156,
		150,
		149,
		147,
		142,
		139,
		125,
		109,
		87,
		76,
		97,
		-1,
		-1,
		-1,
		147,
		139,
		132,
		-1,
		-1,
		134,
		117,
		98,
		96,
		-1,
		-1,
		-1,
		169,
		150,
		-1,
		-1,
		124,
		-1,
		-1,
		130,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		158,
		-1,
		-1,
		-1,
		120,
		116,
		117,
		-1,
		-1,
		-1,
		-1,
		180,
		181,
		204,
		168,
		-1,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		183,
		181,
		-1,
		-1,
		-1,
		140,
		124,
		-1,
		110,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		145,
		-1,
		145,
		120,
		127,
		-1,
		-1,
		-1,
		-1,
		158,
		150,
		158,
		-1,
		130,
		132,
		-1,
		180,
		-1,
		-1,
		173,
		164,
		-1,
		-1,
		135,
		142,
		164,
		167,
		203,
		-1,
		154
	],
	[
		-1,
		212,
		201,
		212,
		220,
		193,
		200,
		-1,
		219,
		223,
		189,
		183,
		222,
		191,
		197,
		208,
		-1,
		-1,
		-1,
		212,
		211,
		179,
		177,
		186,
		191,
		198,
		-1,
		197,
		-1,
		233,
		212,
		223,
		228,
		172,
		169,
		189,
		208,
		190,
		182,
		248,
		202,
		173,
		167,
		185,
		175,
		184,
		176,
		-1,
		173,
		163,
		185,
		164,
		175,
		167,
		-1,
		-1,
		167,
		168,
		174,
		160,
		166,
		162,
		-1,
		172,
		156,
		-1,
		-1,
		157,
		158,
		142,
		145,
		153,
		151,
		164,
		156,
		151,
		-1,
		-1,
		148,
		144,
		151,
		138,
		134,
		151,
		164,
		146,
		160,
		159,
		-1,
		152,
		170,
		177,
		145,
		143,
		127,
		125,
		143,
		145,
		151,
		151,
		-1,
		161,
		162,
		157,
		165,
		167,
		143,
		130,
		130,
		140,
		133,
		152,
		140,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		161,
		144,
		161,
		153,
		143,
		158,
		151,
		133,
		130,
		128,
		125,
		141,
		139,
		149,
		-1,
		-1,
		254,
		223,
		252,
		210,
		191,
		-1,
		157,
		137,
		143,
		147,
		141,
		134,
		148,
		144,
		-1,
		119,
		118,
		146,
		132,
		143,
		214,
		-1,
		-1,
		212,
		204,
		187,
		190,
		167,
		163,
		152,
		151,
		143,
		129,
		125,
		131,
		134,
		134,
		140,
		113,
		123,
		127,
		125,
		150,
		-1,
		-1,
		185,
		-1,
		-1,
		211,
		194,
		-1,
		177,
		184,
		173,
		179,
		165,
		186,
		162,
		153,
		145,
		139,
		127,
		129,
		126,
		139,
		127,
		110,
		135,
		139,
		120,
		141,
		136,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		170,
		173,
		179,
		203,
		202,
		-1,
		174,
		162,
		163,
		148,
		145,
		132,
		120,
		133,
		118,
		125,
		124,
		114,
		112,
		142,
		117,
		139,
		136,
		155,
		160,
		154,
		163,
		-1,
		219,
		215,
		211,
		218,
		167,
		-1,
		-1,
		207,
		-1,
		210,
		211,
		186,
		159,
		162,
		149,
		140,
		127,
		116,
		127,
		116,
		113,
		121,
		106,
		121,
		112,
		111,
		129,
		139,
		147,
		151,
		157,
		-1,
		269,
		-1,
		211,
		195,
		197,
		169,
		190,
		-1,
		227,
		211,
		203,
		188,
		188,
		-1,
		158,
		155,
		145,
		123,
		108,
		125,
		117,
		115,
		119,
		101,
		115,
		106,
		124,
		131,
		129,
		133,
		153,
		165,
		229,
		219,
		-1,
		201,
		206,
		165,
		173,
		192,
		230,
		194,
		-1,
		189,
		-1,
		160,
		173,
		-1,
		129,
		125,
		107,
		108,
		103,
		118,
		112,
		97,
		94,
		112,
		115,
		122,
		126,
		142,
		-1,
		-1,
		214,
		218,
		207,
		158,
		177,
		201,
		238,
		187,
		176,
		175,
		-1,
		166,
		143,
		140,
		128,
		115,
		100,
		101,
		109,
		122,
		101,
		96,
		93,
		113,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		184,
		155,
		179,
		221,
		205,
		198,
		186,
		151,
		151,
		145,
		-1,
		139,
		118,
		109,
		98,
		96,
		109,
		106,
		111,
		91,
		89,
		108,
		120,
		111,
		128,
		-1,
		-1,
		-1,
		214,
		203,
		204,
		150,
		173,
		210,
		184,
		170,
		175,
		150,
		143,
		137,
		152,
		135,
		116,
		105,
		97,
		86,
		102,
		110,
		105,
		87,
		96,
		102,
		126,
		116,
		122,
		-1,
		-1,
		221,
		211,
		195,
		197,
		194,
		164,
		171,
		203,
		175,
		188,
		-1,
		142,
		-1,
		131,
		126,
		110,
		105,
		102,
		99,
		93,
		102,
		104,
		94,
		89,
		96,
		131,
		131,
		106,
		126,
		129,
		-1,
		-1,
		-1,
		214,
		209,
		184,
		161,
		145,
		181,
		-1,
		158,
		159,
		-1,
		136,
		130,
		127,
		112,
		108,
		103,
		107,
		100,
		107,
		100,
		98,
		99,
		81,
		113,
		-1,
		114,
		108,
		116,
		106,
		94,
		-1,
		-1,
		-1,
		207,
		186,
		179,
		199,
		140,
		192,
		-1,
		-1,
		143,
		136,
		-1,
		123,
		105,
		112,
		110,
		104,
		108,
		105,
		94,
		107,
		100,
		86,
		88,
		101,
		105,
		109,
		96,
		92,
		89,
		103,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		160,
		-1,
		152,
		144,
		134,
		128,
		122,
		118,
		116,
		132,
		116,
		119,
		117,
		108,
		116,
		89,
		82,
		89,
		78,
		96,
		104,
		96,
		90,
		89,
		99,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		173,
		-1,
		137,
		151,
		167,
		-1,
		160,
		139,
		154,
		132,
		128,
		124,
		139,
		140,
		118,
		117,
		115,
		106,
		94,
		83,
		86,
		78,
		100,
		100,
		84,
		85,
		89,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		134,
		122,
		154,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		138,
		136,
		129,
		120,
		126,
		126,
		103,
		98,
		88,
		77,
		77,
		72,
		94,
		80,
		78,
		87,
		103,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		131,
		121,
		126,
		-1,
		123,
		-1,
		96,
		93,
		84,
		69,
		66,
		77,
		75,
		86,
		82,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		191,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		147,
		127,
		119,
		126,
		118,
		110,
		104,
		82,
		75,
		72,
		65,
		78,
		88,
		93,
		80,
		-1,
		-1,
		-1,
		188,
		174,
		178,
		138,
		157,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		148,
		147,
		135,
		125,
		115,
		120,
		121,
		101,
		94,
		80,
		82,
		76,
		67,
		66,
		82,
		74,
		96,
		-1,
		-1,
		171,
		176,
		164,
		150,
		169,
		-1,
		-1,
		-1,
		170,
		186,
		175,
		149,
		136,
		-1,
		-1,
		119,
		112,
		106,
		97,
		84,
		96,
		91,
		75,
		60,
		75,
		79,
		87,
		78,
		-1,
		174,
		161,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		-1,
		-1,
		187,
		132,
		121,
		116,
		120,
		118,
		-1,
		92,
		103,
		88,
		100,
		107,
		77,
		62,
		56,
		62,
		74,
		83,
		-1,
		-1,
		186,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		144,
		138,
		109,
		102,
		106,
		-1,
		94,
		96,
		90,
		105,
		80,
		77,
		68,
		59,
		55,
		59,
		63,
		77,
		81,
		209,
		-1,
		165,
		-1,
		-1,
		-1,
		162,
		177,
		148,
		125,
		98,
		93,
		86,
		80,
		85,
		96,
		88,
		99,
		66,
		62,
		52,
		51,
		55,
		72,
		76,
		-1,
		-1,
		163,
		159,
		188,
		170,
		174,
		175,
		-1,
		-1,
		102,
		93,
		84,
		76,
		89,
		92,
		72,
		69,
		63,
		56,
		50,
		60,
		75,
		70,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		165,
		173,
		120,
		102,
		98,
		96,
		83,
		77,
		67,
		72,
		73,
		64,
		58,
		46,
		50,
		73,
		62,
		99,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		135,
		132,
		-1,
		102,
		106,
		73,
		80,
		63,
		70,
		68,
		60,
		40,
		47,
		63,
		62,
		57,
		91,
		82,
		86,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		120,
		117,
		97,
		66,
		71,
		64,
		59,
		64,
		45,
		36,
		40,
		44,
		50,
		55,
		60,
		66,
		77,
		92,
		-1,
		194,
		231,
		224,
		192,
		200,
		231,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		93,
		84,
		85,
		73,
		70,
		79,
		74,
		49,
		45,
		51,
		29,
		39,
		60,
		63,
		67,
		68,
		70,
		83,
		87,
		-1,
		187,
		207,
		186,
		189,
		213,
		227,
		-1,
		134,
		-1,
		-1,
		146,
		118,
		102,
		92,
		89,
		132,
		79,
		74,
		51,
		49,
		46,
		37,
		47,
		24,
		36,
		39,
		55,
		60,
		52,
		78,
		80,
		81,
		-1,
		176,
		187,
		180,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		161,
		-1,
		129,
		-1,
		112,
		116,
		87,
		90,
		65,
		52,
		38,
		37,
		33,
		22,
		27,
		30,
		42,
		51,
		62,
		74,
		84,
		86,
		201,
		157,
		160,
		171,
		182,
		197,
		201,
		-1,
		146,
		185,
		167,
		-1,
		151,
		-1,
		-1,
		-1,
		126,
		100,
		92,
		85,
		64,
		64,
		30,
		26,
		17,
		24,
		34,
		48,
		51,
		55,
		68,
		79,
		94,
		197,
		188,
		201,
		146,
		146,
		167,
		176,
		197,
		161,
		152,
		179,
		174,
		163,
		158,
		145,
		-1,
		-1,
		128,
		110,
		-1,
		-1,
		71,
		51,
		34,
		23,
		19,
		0,
		42,
		49,
		58,
		56,
		50,
		82,
		-1,
		190,
		189,
		178,
		175,
		151,
		142,
		137,
		164,
		-1,
		-1,
		159,
		180,
		170,
		174,
		190,
		215,
		-1,
		134,
		-1,
		-1,
		108,
		-1,
		-1,
		93,
		56,
		45,
		36,
		34,
		25,
		36,
		53,
		64,
		65,
		55,
		65,
		78,
		174,
		171,
		159,
		157,
		180,
		145,
		133,
		-1,
		146,
		144,
		150,
		157,
		174,
		204,
		-1,
		-1,
		150,
		130,
		-1,
		-1,
		91,
		89,
		78,
		-1,
		68,
		41,
		38,
		50,
		70,
		72,
		67,
		61,
		68,
		67,
		75,
		83,
		183,
		197,
		186,
		182,
		181,
		189,
		138,
		131,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		140,
		136,
		-1,
		-1,
		86,
		79,
		67,
		55,
		45,
		52,
		43,
		55,
		58,
		63,
		59,
		70,
		62,
		66,
		83,
		-1,
		217,
		-1,
		169,
		145,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		157,
		143,
		136,
		124,
		122,
		-1,
		120,
		104,
		85,
		-1,
		55,
		68,
		91,
		59,
		64,
		59,
		65,
		76,
		65,
		68,
		82,
		77,
		-1,
		-1,
		157,
		160,
		-1,
		-1,
		147,
		149,
		-1,
		148,
		137,
		122,
		114,
		-1,
		-1,
		92,
		88,
		-1,
		-1,
		56,
		73,
		62,
		70,
		65,
		69,
		75,
		78,
		67,
		71,
		83,
		-1,
		-1,
		164,
		160,
		154,
		-1,
		132,
		-1,
		150,
		-1,
		117,
		123,
		111,
		-1,
		-1,
		-1,
		94,
		57,
		78,
		80,
		85,
		83,
		74,
		73,
		80,
		78,
		74,
		85,
		-1,
		-1,
		-1,
		150,
		124,
		157,
		148,
		131,
		111,
		103,
		122,
		-1,
		92,
		-1,
		61,
		58,
		94,
		79,
		96,
		90,
		76,
		91,
		81,
		72,
		81,
		156,
		-1,
		126,
		159,
		123,
		117,
		93,
		97,
		113,
		-1,
		89,
		69,
		-1,
		99,
		89,
		113,
		99,
		87,
		74,
		81,
		85,
		78,
		-1,
		-1,
		-1,
		128,
		127,
		119,
		113,
		113,
		98,
		89,
		-1,
		101,
		83,
		62,
		79,
		79,
		70,
		78,
		103,
		99,
		92,
		94,
		86,
		-1,
		229,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		122,
		117,
		90,
		78,
		84,
		80,
		66,
		72,
		74,
		82,
		80,
		77,
		89,
		85,
		105,
		87,
		123,
		-1,
		224,
		-1,
		158,
		-1,
		-1,
		140,
		120,
		112,
		101,
		90,
		88,
		79,
		70,
		92,
		108,
		92,
		90,
		94,
		95,
		-1,
		213,
		212,
		-1,
		159,
		151,
		137,
		-1,
		130,
		-1,
		136,
		97,
		-1,
		99,
		79,
		-1,
		101,
		97,
		-1,
		-1,
		200,
		175,
		-1,
		-1,
		-1,
		160,
		140,
		131,
		115,
		-1,
		90,
		90,
		-1,
		-1,
		-1,
		185,
		184,
		-1,
		153,
		156,
		-1,
		146,
		137,
		145,
		92,
		96,
		-1,
		-1,
		-1,
		194,
		175,
		169,
		168,
		166,
		161,
		158,
		144,
		128,
		106,
		95,
		116,
		-1,
		-1,
		-1,
		166,
		158,
		151,
		-1,
		-1,
		153,
		136,
		117,
		115,
		-1,
		-1,
		-1,
		188,
		169,
		-1,
		-1,
		143,
		-1,
		-1,
		149,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		177,
		-1,
		-1,
		-1,
		139,
		135,
		136,
		-1,
		-1,
		-1,
		-1,
		199,
		200,
		223,
		187,
		-1,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		202,
		200,
		-1,
		-1,
		-1,
		159,
		143,
		-1,
		129,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		164,
		-1,
		164,
		139,
		146,
		-1,
		-1,
		-1,
		-1,
		177,
		169,
		177,
		-1,
		149,
		151,
		-1,
		199,
		-1,
		-1,
		192,
		183,
		-1,
		-1,
		154,
		161,
		183,
		186,
		222,
		-1,
		173
	],
	[
		-1,
		222,
		211,
		222,
		230,
		203,
		210,
		-1,
		229,
		233,
		199,
		193,
		232,
		201,
		207,
		218,
		-1,
		-1,
		-1,
		222,
		221,
		189,
		187,
		196,
		201,
		208,
		-1,
		207,
		-1,
		243,
		222,
		233,
		238,
		182,
		179,
		199,
		218,
		200,
		192,
		258,
		212,
		183,
		177,
		195,
		185,
		194,
		186,
		-1,
		183,
		173,
		195,
		174,
		185,
		177,
		-1,
		-1,
		177,
		178,
		184,
		170,
		176,
		172,
		-1,
		182,
		166,
		-1,
		-1,
		167,
		168,
		152,
		155,
		163,
		161,
		174,
		166,
		161,
		-1,
		-1,
		158,
		154,
		161,
		148,
		144,
		161,
		174,
		156,
		170,
		169,
		-1,
		162,
		180,
		187,
		155,
		153,
		137,
		135,
		153,
		155,
		161,
		161,
		-1,
		171,
		172,
		167,
		175,
		177,
		153,
		140,
		140,
		150,
		143,
		162,
		150,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		154,
		171,
		163,
		153,
		168,
		161,
		143,
		140,
		138,
		135,
		151,
		149,
		159,
		-1,
		-1,
		264,
		233,
		262,
		220,
		201,
		-1,
		167,
		147,
		153,
		157,
		151,
		144,
		158,
		154,
		-1,
		129,
		128,
		156,
		142,
		153,
		224,
		-1,
		-1,
		222,
		214,
		197,
		200,
		177,
		173,
		162,
		161,
		153,
		139,
		135,
		141,
		144,
		144,
		150,
		123,
		133,
		137,
		135,
		160,
		-1,
		-1,
		195,
		-1,
		-1,
		221,
		204,
		-1,
		187,
		194,
		183,
		189,
		175,
		196,
		172,
		163,
		155,
		149,
		137,
		139,
		136,
		149,
		137,
		120,
		145,
		149,
		130,
		151,
		146,
		-1,
		194,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		180,
		183,
		189,
		213,
		212,
		-1,
		184,
		172,
		173,
		158,
		155,
		142,
		130,
		143,
		128,
		135,
		134,
		124,
		122,
		152,
		127,
		149,
		146,
		165,
		170,
		164,
		173,
		-1,
		229,
		225,
		221,
		228,
		177,
		-1,
		-1,
		217,
		-1,
		220,
		221,
		196,
		169,
		172,
		159,
		150,
		137,
		126,
		137,
		126,
		123,
		131,
		116,
		131,
		122,
		121,
		139,
		149,
		157,
		161,
		167,
		-1,
		279,
		-1,
		221,
		205,
		207,
		179,
		200,
		-1,
		237,
		221,
		213,
		198,
		198,
		-1,
		168,
		165,
		155,
		133,
		118,
		135,
		127,
		125,
		129,
		111,
		125,
		116,
		134,
		141,
		139,
		143,
		163,
		175,
		239,
		229,
		-1,
		211,
		216,
		175,
		183,
		202,
		240,
		204,
		-1,
		199,
		-1,
		170,
		183,
		-1,
		139,
		135,
		117,
		118,
		113,
		128,
		122,
		107,
		104,
		122,
		125,
		132,
		136,
		152,
		-1,
		-1,
		224,
		228,
		217,
		168,
		187,
		211,
		248,
		197,
		186,
		185,
		-1,
		176,
		153,
		150,
		138,
		125,
		110,
		111,
		119,
		132,
		111,
		106,
		103,
		123,
		149,
		127,
		139,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		194,
		165,
		189,
		231,
		215,
		208,
		196,
		161,
		161,
		155,
		-1,
		149,
		128,
		119,
		108,
		106,
		119,
		116,
		121,
		101,
		99,
		118,
		130,
		121,
		138,
		-1,
		-1,
		-1,
		224,
		213,
		214,
		160,
		183,
		220,
		194,
		180,
		185,
		160,
		153,
		147,
		162,
		145,
		126,
		115,
		107,
		96,
		112,
		120,
		115,
		97,
		106,
		112,
		136,
		126,
		132,
		-1,
		-1,
		231,
		221,
		205,
		207,
		204,
		174,
		181,
		213,
		185,
		198,
		-1,
		152,
		-1,
		141,
		136,
		120,
		115,
		112,
		109,
		103,
		112,
		114,
		104,
		99,
		106,
		141,
		141,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		224,
		219,
		194,
		171,
		155,
		191,
		-1,
		168,
		169,
		-1,
		146,
		140,
		137,
		122,
		118,
		113,
		117,
		110,
		117,
		110,
		108,
		109,
		91,
		123,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		217,
		196,
		189,
		209,
		150,
		202,
		-1,
		-1,
		153,
		146,
		-1,
		133,
		115,
		122,
		120,
		114,
		118,
		115,
		104,
		117,
		110,
		96,
		98,
		111,
		115,
		119,
		106,
		102,
		99,
		113,
		-1,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		170,
		-1,
		162,
		154,
		144,
		138,
		132,
		128,
		126,
		142,
		126,
		129,
		127,
		118,
		126,
		99,
		92,
		99,
		88,
		106,
		114,
		106,
		100,
		99,
		109,
		-1,
		237,
		223,
		194,
		-1,
		-1,
		183,
		-1,
		147,
		161,
		177,
		-1,
		170,
		149,
		164,
		142,
		138,
		134,
		149,
		150,
		128,
		127,
		125,
		116,
		104,
		93,
		96,
		88,
		110,
		110,
		94,
		95,
		99,
		-1,
		243,
		230,
		188,
		184,
		173,
		193,
		144,
		132,
		164,
		-1,
		-1,
		206,
		-1,
		140,
		157,
		148,
		146,
		139,
		130,
		136,
		136,
		113,
		108,
		98,
		87,
		87,
		82,
		104,
		90,
		88,
		97,
		113,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		159,
		146,
		140,
		-1,
		181,
		-1,
		184,
		174,
		158,
		143,
		176,
		-1,
		137,
		131,
		136,
		-1,
		133,
		-1,
		106,
		103,
		94,
		79,
		76,
		87,
		85,
		96,
		92,
		-1,
		193,
		178,
		171,
		161,
		175,
		146,
		-1,
		201,
		-1,
		-1,
		171,
		165,
		165,
		149,
		152,
		153,
		133,
		125,
		136,
		128,
		120,
		114,
		92,
		85,
		82,
		75,
		88,
		98,
		103,
		90,
		-1,
		-1,
		-1,
		198,
		184,
		188,
		148,
		167,
		-1,
		-1,
		233,
		188,
		174,
		-1,
		158,
		153,
		141,
		131,
		121,
		126,
		127,
		111,
		104,
		90,
		92,
		86,
		77,
		76,
		92,
		84,
		106,
		-1,
		-1,
		181,
		186,
		174,
		160,
		179,
		-1,
		-1,
		-1,
		180,
		196,
		181,
		159,
		142,
		-1,
		-1,
		125,
		118,
		112,
		107,
		94,
		106,
		101,
		85,
		70,
		85,
		89,
		97,
		88,
		-1,
		184,
		171,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		-1,
		-1,
		193,
		138,
		127,
		122,
		126,
		124,
		-1,
		98,
		109,
		98,
		110,
		117,
		87,
		72,
		66,
		72,
		84,
		93,
		-1,
		-1,
		196,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		150,
		144,
		115,
		108,
		112,
		-1,
		100,
		102,
		99,
		111,
		90,
		87,
		78,
		69,
		65,
		69,
		73,
		87,
		91,
		219,
		-1,
		171,
		-1,
		-1,
		-1,
		168,
		183,
		154,
		131,
		104,
		99,
		92,
		86,
		91,
		102,
		98,
		109,
		76,
		72,
		62,
		61,
		65,
		82,
		86,
		-1,
		-1,
		169,
		165,
		194,
		176,
		180,
		181,
		-1,
		-1,
		108,
		99,
		90,
		82,
		95,
		98,
		82,
		79,
		73,
		66,
		60,
		70,
		85,
		80,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		179,
		126,
		108,
		104,
		102,
		89,
		83,
		73,
		78,
		83,
		74,
		68,
		56,
		60,
		83,
		72,
		100,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		141,
		138,
		-1,
		108,
		112,
		79,
		86,
		69,
		76,
		78,
		70,
		50,
		57,
		73,
		72,
		67,
		92,
		83,
		87,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		103,
		72,
		77,
		70,
		65,
		70,
		51,
		46,
		50,
		45,
		60,
		65,
		70,
		71,
		78,
		93,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		89,
		84,
		55,
		52,
		61,
		39,
		49,
		59,
		64,
		68,
		69,
		76,
		87,
		91,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		95,
		138,
		85,
		80,
		57,
		55,
		52,
		43,
		57,
		34,
		35,
		38,
		56,
		61,
		53,
		79,
		81,
		87,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		167,
		-1,
		135,
		-1,
		118,
		122,
		93,
		96,
		71,
		58,
		44,
		44,
		43,
		32,
		26,
		29,
		43,
		48,
		60,
		75,
		85,
		87,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		152,
		191,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		132,
		106,
		98,
		91,
		70,
		70,
		36,
		32,
		27,
		23,
		27,
		23,
		45,
		47,
		69,
		80,
		95,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		167,
		158,
		185,
		180,
		169,
		164,
		151,
		-1,
		-1,
		134,
		116,
		-1,
		-1,
		77,
		57,
		40,
		29,
		25,
		30,
		0,
		14,
		41,
		57,
		51,
		83,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		186,
		176,
		180,
		196,
		221,
		-1,
		140,
		-1,
		-1,
		114,
		-1,
		-1,
		99,
		62,
		51,
		42,
		40,
		17,
		4,
		15,
		37,
		65,
		56,
		66,
		79,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		97,
		95,
		84,
		-1,
		74,
		47,
		44,
		55,
		68,
		57,
		43,
		40,
		52,
		68,
		76,
		84,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		92,
		85,
		73,
		61,
		51,
		58,
		48,
		60,
		55,
		48,
		43,
		54,
		63,
		67,
		84,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		126,
		110,
		91,
		-1,
		61,
		74,
		97,
		65,
		70,
		65,
		49,
		60,
		66,
		69,
		83,
		78,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		98,
		94,
		-1,
		-1,
		62,
		78,
		67,
		76,
		71,
		53,
		59,
		69,
		68,
		72,
		84,
		-1,
		-1,
		170,
		166,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		100,
		63,
		84,
		85,
		82,
		80,
		71,
		57,
		64,
		74,
		75,
		86,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		67,
		64,
		99,
		84,
		93,
		87,
		60,
		75,
		75,
		73,
		82,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		75,
		-1,
		105,
		95,
		109,
		94,
		75,
		62,
		69,
		83,
		79,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		84,
		99,
		95,
		82,
		82,
		74,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		86,
		83,
		95,
		91,
		98,
		75,
		111,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		98,
		87,
		82,
		83,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		98,
		87,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		224,
		213,
		224,
		232,
		205,
		212,
		-1,
		231,
		235,
		201,
		195,
		234,
		203,
		209,
		220,
		-1,
		-1,
		-1,
		224,
		223,
		191,
		189,
		198,
		203,
		210,
		-1,
		209,
		-1,
		245,
		224,
		235,
		240,
		184,
		181,
		201,
		220,
		202,
		194,
		260,
		214,
		185,
		179,
		197,
		187,
		196,
		188,
		-1,
		185,
		175,
		197,
		176,
		187,
		179,
		-1,
		-1,
		179,
		180,
		186,
		172,
		178,
		174,
		-1,
		184,
		168,
		-1,
		-1,
		169,
		170,
		154,
		157,
		165,
		163,
		176,
		168,
		163,
		-1,
		-1,
		160,
		156,
		163,
		150,
		146,
		163,
		176,
		158,
		172,
		171,
		-1,
		164,
		182,
		189,
		157,
		155,
		139,
		137,
		155,
		157,
		163,
		163,
		-1,
		173,
		174,
		169,
		177,
		179,
		155,
		142,
		142,
		152,
		145,
		164,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		156,
		173,
		165,
		155,
		170,
		163,
		145,
		142,
		140,
		137,
		153,
		151,
		161,
		-1,
		-1,
		266,
		235,
		264,
		222,
		203,
		-1,
		169,
		149,
		155,
		159,
		153,
		146,
		160,
		156,
		-1,
		131,
		130,
		158,
		144,
		155,
		226,
		-1,
		-1,
		224,
		216,
		199,
		202,
		179,
		175,
		164,
		163,
		155,
		141,
		137,
		143,
		146,
		146,
		152,
		125,
		135,
		139,
		137,
		162,
		-1,
		-1,
		197,
		-1,
		-1,
		223,
		206,
		-1,
		189,
		196,
		185,
		191,
		177,
		198,
		174,
		165,
		157,
		151,
		139,
		141,
		138,
		151,
		139,
		122,
		147,
		151,
		132,
		153,
		148,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		182,
		185,
		191,
		215,
		214,
		-1,
		186,
		174,
		175,
		160,
		157,
		144,
		132,
		145,
		130,
		137,
		136,
		126,
		124,
		154,
		129,
		151,
		148,
		167,
		172,
		166,
		175,
		-1,
		231,
		227,
		223,
		230,
		179,
		-1,
		-1,
		219,
		-1,
		222,
		223,
		198,
		171,
		174,
		161,
		152,
		139,
		128,
		139,
		128,
		125,
		133,
		118,
		133,
		124,
		123,
		141,
		151,
		159,
		163,
		169,
		-1,
		281,
		-1,
		223,
		207,
		209,
		181,
		202,
		-1,
		239,
		223,
		215,
		200,
		200,
		-1,
		170,
		167,
		157,
		135,
		120,
		137,
		129,
		127,
		131,
		113,
		127,
		118,
		136,
		143,
		141,
		145,
		165,
		177,
		241,
		231,
		-1,
		213,
		218,
		177,
		185,
		204,
		242,
		206,
		-1,
		201,
		-1,
		172,
		185,
		-1,
		141,
		137,
		119,
		120,
		115,
		130,
		124,
		109,
		106,
		124,
		127,
		134,
		138,
		154,
		-1,
		-1,
		226,
		230,
		219,
		170,
		189,
		213,
		250,
		199,
		188,
		187,
		-1,
		178,
		155,
		152,
		140,
		127,
		112,
		113,
		121,
		134,
		113,
		108,
		105,
		125,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		196,
		167,
		191,
		233,
		217,
		210,
		198,
		163,
		163,
		157,
		-1,
		151,
		130,
		121,
		110,
		108,
		121,
		118,
		123,
		103,
		101,
		120,
		132,
		123,
		140,
		-1,
		-1,
		-1,
		226,
		215,
		216,
		162,
		185,
		222,
		196,
		182,
		187,
		162,
		155,
		149,
		164,
		147,
		128,
		117,
		109,
		98,
		114,
		122,
		117,
		99,
		108,
		114,
		138,
		128,
		134,
		-1,
		-1,
		233,
		223,
		207,
		209,
		206,
		176,
		183,
		215,
		187,
		200,
		-1,
		154,
		-1,
		143,
		138,
		122,
		117,
		114,
		111,
		105,
		114,
		116,
		106,
		101,
		108,
		143,
		143,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		226,
		221,
		196,
		173,
		157,
		193,
		-1,
		170,
		171,
		-1,
		148,
		142,
		139,
		124,
		120,
		115,
		119,
		112,
		119,
		112,
		110,
		111,
		93,
		125,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		219,
		198,
		191,
		211,
		152,
		204,
		-1,
		-1,
		155,
		148,
		-1,
		135,
		117,
		124,
		122,
		116,
		120,
		117,
		106,
		119,
		112,
		98,
		100,
		113,
		117,
		121,
		108,
		104,
		101,
		115,
		-1,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		172,
		-1,
		164,
		156,
		146,
		140,
		134,
		130,
		128,
		144,
		128,
		131,
		129,
		120,
		128,
		101,
		94,
		101,
		90,
		108,
		116,
		108,
		102,
		101,
		111,
		-1,
		239,
		225,
		196,
		-1,
		-1,
		185,
		-1,
		149,
		163,
		179,
		-1,
		172,
		151,
		166,
		144,
		140,
		136,
		151,
		152,
		130,
		129,
		127,
		118,
		106,
		95,
		98,
		90,
		112,
		112,
		96,
		97,
		101,
		-1,
		245,
		232,
		190,
		186,
		175,
		195,
		146,
		134,
		166,
		-1,
		-1,
		208,
		-1,
		142,
		159,
		150,
		148,
		141,
		132,
		138,
		138,
		115,
		110,
		100,
		89,
		89,
		84,
		106,
		92,
		90,
		99,
		115,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		161,
		148,
		142,
		-1,
		183,
		-1,
		186,
		176,
		160,
		145,
		178,
		-1,
		143,
		133,
		138,
		-1,
		135,
		-1,
		108,
		105,
		96,
		81,
		78,
		89,
		87,
		98,
		94,
		-1,
		195,
		180,
		173,
		163,
		177,
		148,
		-1,
		203,
		-1,
		-1,
		173,
		167,
		167,
		151,
		154,
		159,
		139,
		131,
		138,
		130,
		122,
		116,
		94,
		87,
		84,
		77,
		90,
		100,
		105,
		92,
		-1,
		-1,
		-1,
		200,
		186,
		190,
		150,
		169,
		-1,
		-1,
		235,
		190,
		176,
		-1,
		160,
		159,
		147,
		137,
		127,
		132,
		133,
		113,
		106,
		92,
		94,
		88,
		79,
		78,
		94,
		86,
		108,
		-1,
		-1,
		183,
		188,
		176,
		162,
		181,
		-1,
		-1,
		-1,
		182,
		198,
		187,
		161,
		148,
		-1,
		-1,
		131,
		124,
		118,
		109,
		96,
		108,
		103,
		87,
		72,
		87,
		91,
		99,
		90,
		-1,
		186,
		173,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		-1,
		-1,
		199,
		144,
		133,
		128,
		132,
		130,
		-1,
		104,
		115,
		100,
		112,
		119,
		89,
		74,
		68,
		74,
		86,
		95,
		-1,
		-1,
		198,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		156,
		150,
		121,
		114,
		118,
		-1,
		106,
		108,
		102,
		117,
		92,
		89,
		80,
		71,
		67,
		71,
		75,
		89,
		93,
		221,
		-1,
		184,
		-1,
		-1,
		-1,
		174,
		189,
		160,
		137,
		110,
		105,
		98,
		92,
		97,
		108,
		100,
		111,
		78,
		74,
		64,
		63,
		67,
		84,
		84,
		-1,
		-1,
		182,
		178,
		200,
		182,
		186,
		187,
		-1,
		-1,
		114,
		105,
		96,
		88,
		101,
		104,
		84,
		81,
		75,
		68,
		62,
		72,
		83,
		78,
		-1,
		-1,
		-1,
		194,
		-1,
		196,
		-1,
		-1,
		184,
		185,
		132,
		114,
		110,
		108,
		97,
		91,
		79,
		84,
		85,
		76,
		70,
		58,
		58,
		81,
		70,
		87,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		147,
		144,
		-1,
		114,
		120,
		85,
		92,
		75,
		82,
		80,
		72,
		52,
		55,
		71,
		70,
		65,
		79,
		70,
		74,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		139,
		136,
		116,
		85,
		83,
		76,
		71,
		81,
		61,
		48,
		48,
		43,
		58,
		63,
		65,
		58,
		65,
		80,
		-1,
		213,
		250,
		243,
		211,
		219,
		250,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		112,
		103,
		104,
		92,
		89,
		91,
		86,
		71,
		57,
		63,
		41,
		48,
		58,
		51,
		55,
		56,
		63,
		74,
		78,
		-1,
		206,
		226,
		205,
		208,
		232,
		246,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		108,
		151,
		101,
		96,
		73,
		71,
		68,
		59,
		64,
		41,
		34,
		34,
		43,
		48,
		40,
		66,
		68,
		74,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		-1,
		148,
		-1,
		131,
		135,
		109,
		112,
		87,
		74,
		60,
		60,
		54,
		39,
		30,
		28,
		30,
		34,
		46,
		62,
		72,
		74,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		165,
		204,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		145,
		122,
		114,
		107,
		86,
		86,
		52,
		48,
		34,
		27,
		16,
		9,
		31,
		33,
		56,
		67,
		82,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		180,
		171,
		198,
		196,
		185,
		180,
		167,
		-1,
		-1,
		150,
		132,
		-1,
		-1,
		93,
		73,
		56,
		45,
		41,
		44,
		16,
		0,
		27,
		44,
		38,
		70,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		199,
		189,
		193,
		209,
		234,
		-1,
		156,
		-1,
		-1,
		130,
		-1,
		-1,
		115,
		78,
		67,
		58,
		56,
		33,
		20,
		31,
		23,
		51,
		43,
		53,
		66,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		223,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		113,
		111,
		100,
		-1,
		90,
		63,
		59,
		71,
		54,
		43,
		29,
		26,
		38,
		55,
		63,
		71,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		108,
		101,
		89,
		77,
		67,
		73,
		59,
		55,
		41,
		34,
		29,
		40,
		50,
		54,
		71,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		142,
		126,
		107,
		-1,
		77,
		90,
		91,
		59,
		59,
		53,
		35,
		46,
		53,
		56,
		70,
		65,
		-1,
		-1,
		176,
		179,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		114,
		110,
		-1,
		-1,
		78,
		73,
		62,
		65,
		60,
		39,
		45,
		55,
		55,
		59,
		71,
		-1,
		-1,
		183,
		182,
		176,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		116,
		79,
		100,
		80,
		68,
		66,
		57,
		43,
		50,
		60,
		62,
		73,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		83,
		80,
		94,
		76,
		79,
		73,
		46,
		61,
		61,
		60,
		68,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		91,
		-1,
		121,
		101,
		95,
		80,
		61,
		48,
		55,
		69,
		65,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		92,
		85,
		81,
		68,
		68,
		60,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		104,
		94,
		91,
		87,
		78,
		84,
		61,
		97,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		85,
		73,
		68,
		69,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		84,
		73,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		147,
		165,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		156,
		157,
		152,
		160,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		114,
		113,
		141,
		127,
		138,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		117,
		96,
		91,
		88,
		108,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		101,
		106,
		86,
		84,
		103,
		115,
		106,
		123,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		97,
		105,
		100,
		82,
		91,
		97,
		121,
		111,
		117,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		88,
		97,
		99,
		89,
		84,
		91,
		126,
		126,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		102,
		95,
		93,
		94,
		76,
		108,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		100,
		89,
		102,
		95,
		81,
		83,
		96,
		100,
		104,
		91,
		87,
		84,
		98,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		112,
		103,
		111,
		84,
		77,
		84,
		73,
		91,
		99,
		91,
		85,
		84,
		94,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		112,
		110,
		101,
		89,
		78,
		81,
		73,
		95,
		95,
		79,
		80,
		84,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		115,
		121,
		121,
		98,
		93,
		83,
		72,
		72,
		67,
		89,
		75,
		73,
		82,
		98,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		126,
		116,
		121,
		-1,
		118,
		-1,
		91,
		88,
		79,
		64,
		61,
		72,
		70,
		81,
		77,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		142,
		122,
		114,
		121,
		113,
		105,
		99,
		77,
		70,
		67,
		60,
		73,
		83,
		88,
		75,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		143,
		142,
		130,
		120,
		110,
		115,
		116,
		96,
		89,
		75,
		77,
		71,
		62,
		61,
		77,
		69,
		91,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		170,
		144,
		131,
		-1,
		-1,
		114,
		107,
		101,
		92,
		79,
		91,
		86,
		70,
		55,
		70,
		74,
		82,
		73,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		113,
		-1,
		87,
		98,
		83,
		95,
		102,
		72,
		57,
		51,
		57,
		69,
		78,
		-1,
		-1,
		181,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		89,
		91,
		85,
		100,
		75,
		72,
		63,
		54,
		50,
		54,
		58,
		72,
		76,
		204,
		-1,
		167,
		-1,
		-1,
		-1,
		157,
		172,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		91,
		83,
		94,
		61,
		57,
		47,
		46,
		50,
		67,
		67,
		-1,
		-1,
		165,
		161,
		183,
		165,
		169,
		170,
		-1,
		-1,
		97,
		88,
		79,
		71,
		84,
		87,
		67,
		64,
		58,
		51,
		45,
		55,
		66,
		61,
		-1,
		-1,
		-1,
		177,
		-1,
		179,
		-1,
		-1,
		167,
		168,
		115,
		97,
		93,
		91,
		80,
		74,
		62,
		67,
		68,
		59,
		53,
		41,
		41,
		64,
		53,
		70,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		130,
		127,
		-1,
		97,
		103,
		68,
		75,
		58,
		65,
		63,
		55,
		35,
		38,
		54,
		53,
		48,
		62,
		53,
		57,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		122,
		119,
		99,
		68,
		66,
		59,
		54,
		64,
		44,
		31,
		31,
		26,
		41,
		46,
		48,
		41,
		48,
		63,
		-1,
		196,
		233,
		226,
		194,
		202,
		233,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		95,
		86,
		87,
		75,
		72,
		74,
		69,
		60,
		40,
		46,
		24,
		31,
		42,
		34,
		38,
		39,
		46,
		57,
		61,
		-1,
		189,
		209,
		188,
		191,
		215,
		229,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		91,
		134,
		89,
		84,
		68,
		66,
		57,
		48,
		48,
		32,
		20,
		17,
		26,
		31,
		23,
		49,
		51,
		57,
		-1,
		178,
		189,
		182,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		164,
		-1,
		131,
		-1,
		114,
		118,
		97,
		100,
		82,
		69,
		61,
		48,
		57,
		32,
		28,
		24,
		13,
		22,
		33,
		40,
		50,
		57,
		203,
		159,
		162,
		173,
		184,
		199,
		203,
		-1,
		148,
		187,
		177,
		-1,
		161,
		-1,
		-1,
		-1,
		128,
		110,
		102,
		102,
		81,
		81,
		55,
		51,
		37,
		33,
		36,
		25,
		8,
		26,
		34,
		45,
		60,
		199,
		190,
		203,
		148,
		148,
		169,
		178,
		199,
		163,
		154,
		181,
		184,
		173,
		168,
		155,
		-1,
		-1,
		134,
		120,
		-1,
		-1,
		88,
		74,
		59,
		48,
		44,
		47,
		40,
		28,
		0,
		20,
		21,
		48,
		-1,
		192,
		191,
		180,
		177,
		153,
		144,
		139,
		166,
		-1,
		-1,
		161,
		182,
		172,
		176,
		192,
		217,
		-1,
		144,
		-1,
		-1,
		114,
		-1,
		-1,
		99,
		79,
		68,
		59,
		45,
		52,
		44,
		55,
		6,
		24,
		26,
		31,
		44,
		176,
		173,
		161,
		159,
		182,
		147,
		135,
		-1,
		148,
		146,
		152,
		159,
		176,
		206,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		97,
		95,
		84,
		-1,
		74,
		56,
		42,
		69,
		37,
		26,
		15,
		9,
		21,
		36,
		41,
		49,
		185,
		199,
		188,
		184,
		183,
		191,
		140,
		133,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		92,
		85,
		73,
		61,
		51,
		56,
		42,
		38,
		24,
		17,
		12,
		23,
		33,
		37,
		53,
		-1,
		219,
		-1,
		171,
		147,
		161,
		176,
		184,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		126,
		110,
		91,
		-1,
		61,
		74,
		74,
		42,
		42,
		36,
		18,
		29,
		36,
		39,
		53,
		48,
		-1,
		-1,
		159,
		162,
		-1,
		-1,
		157,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		98,
		94,
		-1,
		-1,
		62,
		56,
		45,
		48,
		43,
		22,
		28,
		38,
		38,
		42,
		54,
		-1,
		-1,
		166,
		167,
		164,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		100,
		63,
		84,
		63,
		51,
		49,
		40,
		26,
		33,
		43,
		45,
		56,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		99,
		-1,
		67,
		64,
		77,
		59,
		62,
		56,
		29,
		44,
		44,
		43,
		51,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		96,
		75,
		-1,
		104,
		84,
		78,
		63,
		44,
		31,
		38,
		52,
		48,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		89,
		84,
		75,
		75,
		68,
		64,
		51,
		51,
		43,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		84,
		87,
		77,
		74,
		70,
		61,
		67,
		44,
		80,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		118,
		68,
		56,
		51,
		52,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		67,
		56,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		222,
		226,
		192,
		186,
		225,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		215,
		214,
		182,
		180,
		189,
		194,
		201,
		-1,
		200,
		-1,
		236,
		215,
		226,
		231,
		175,
		172,
		192,
		211,
		193,
		185,
		251,
		205,
		176,
		170,
		188,
		178,
		187,
		179,
		-1,
		176,
		166,
		188,
		167,
		178,
		170,
		-1,
		-1,
		170,
		171,
		177,
		163,
		169,
		165,
		-1,
		175,
		159,
		-1,
		-1,
		160,
		161,
		145,
		148,
		156,
		154,
		167,
		159,
		154,
		-1,
		-1,
		151,
		147,
		154,
		141,
		137,
		154,
		167,
		149,
		163,
		162,
		-1,
		155,
		173,
		180,
		148,
		146,
		130,
		128,
		146,
		148,
		154,
		154,
		-1,
		164,
		165,
		160,
		168,
		170,
		146,
		133,
		133,
		143,
		136,
		155,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		136,
		133,
		131,
		128,
		144,
		142,
		152,
		-1,
		-1,
		257,
		226,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		122,
		121,
		149,
		135,
		146,
		217,
		-1,
		-1,
		215,
		207,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		116,
		126,
		130,
		128,
		153,
		-1,
		-1,
		188,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		113,
		138,
		142,
		123,
		144,
		139,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		117,
		115,
		145,
		120,
		142,
		139,
		158,
		163,
		157,
		166,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		109,
		124,
		115,
		114,
		132,
		142,
		150,
		154,
		160,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		214,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		122,
		104,
		118,
		109,
		127,
		134,
		132,
		136,
		156,
		168,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		115,
		100,
		97,
		115,
		118,
		125,
		129,
		145,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		125,
		104,
		99,
		96,
		116,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		109,
		114,
		94,
		92,
		111,
		123,
		114,
		131,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		105,
		113,
		108,
		90,
		99,
		105,
		129,
		119,
		125,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		107,
		97,
		92,
		99,
		134,
		134,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		103,
		101,
		102,
		84,
		116,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		108,
		97,
		110,
		103,
		89,
		91,
		104,
		108,
		112,
		99,
		95,
		92,
		106,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		120,
		111,
		119,
		92,
		85,
		92,
		81,
		99,
		107,
		99,
		93,
		92,
		102,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		121,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		103,
		103,
		87,
		88,
		92,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		123,
		129,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		97,
		83,
		81,
		90,
		106,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		134,
		124,
		129,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		89,
		85,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		150,
		130,
		122,
		129,
		121,
		113,
		107,
		85,
		78,
		75,
		68,
		81,
		91,
		96,
		83,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		151,
		150,
		138,
		128,
		118,
		123,
		124,
		104,
		97,
		83,
		85,
		79,
		70,
		69,
		85,
		77,
		99,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		178,
		152,
		139,
		-1,
		-1,
		122,
		115,
		109,
		100,
		87,
		99,
		94,
		78,
		63,
		78,
		82,
		90,
		81,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		190,
		135,
		124,
		119,
		123,
		121,
		-1,
		95,
		106,
		91,
		103,
		110,
		80,
		65,
		59,
		65,
		77,
		86,
		-1,
		-1,
		189,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		112,
		105,
		109,
		-1,
		97,
		99,
		93,
		108,
		83,
		80,
		71,
		62,
		58,
		62,
		66,
		80,
		84,
		212,
		-1,
		175,
		-1,
		-1,
		-1,
		165,
		180,
		151,
		128,
		101,
		96,
		89,
		83,
		88,
		99,
		91,
		102,
		69,
		65,
		55,
		54,
		58,
		75,
		75,
		-1,
		-1,
		173,
		169,
		191,
		173,
		177,
		178,
		-1,
		-1,
		105,
		96,
		87,
		79,
		92,
		95,
		75,
		72,
		66,
		59,
		53,
		63,
		74,
		69,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		176,
		123,
		105,
		101,
		99,
		88,
		82,
		70,
		75,
		76,
		67,
		61,
		49,
		49,
		72,
		61,
		78,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		138,
		135,
		-1,
		105,
		111,
		76,
		83,
		66,
		73,
		71,
		63,
		43,
		46,
		62,
		61,
		56,
		70,
		61,
		65,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		107,
		76,
		74,
		67,
		62,
		72,
		52,
		39,
		39,
		34,
		49,
		54,
		56,
		49,
		56,
		71,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		82,
		77,
		68,
		48,
		54,
		32,
		39,
		50,
		42,
		46,
		47,
		54,
		65,
		69,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		97,
		92,
		76,
		74,
		65,
		56,
		56,
		40,
		28,
		25,
		34,
		39,
		31,
		40,
		59,
		65,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		172,
		-1,
		139,
		-1,
		122,
		126,
		105,
		108,
		90,
		77,
		69,
		56,
		65,
		40,
		36,
		32,
		21,
		18,
		30,
		22,
		32,
		50,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		136,
		118,
		110,
		110,
		89,
		89,
		63,
		59,
		45,
		41,
		48,
		38,
		28,
		17,
		14,
		27,
		42,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		196,
		185,
		180,
		167,
		-1,
		-1,
		156,
		128,
		-1,
		-1,
		96,
		84,
		67,
		56,
		52,
		55,
		62,
		47,
		22,
		0,
		10,
		30,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		200,
		225,
		-1,
		156,
		-1,
		-1,
		136,
		-1,
		-1,
		121,
		89,
		78,
		69,
		67,
		60,
		66,
		77,
		28,
		20,
		15,
		19,
		32,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		74,
		64,
		87,
		59,
		48,
		37,
		31,
		35,
		24,
		29,
		37,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		78,
		64,
		60,
		46,
		39,
		34,
		45,
		22,
		26,
		41,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		96,
		64,
		64,
		58,
		40,
		51,
		25,
		28,
		42,
		37,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		78,
		67,
		70,
		65,
		44,
		49,
		38,
		27,
		31,
		43,
		-1,
		-1,
		174,
		175,
		176,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		122,
		85,
		106,
		85,
		73,
		71,
		62,
		48,
		42,
		38,
		34,
		45,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		114,
		-1,
		89,
		86,
		99,
		81,
		84,
		78,
		51,
		66,
		41,
		32,
		41,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		111,
		93,
		-1,
		113,
		100,
		100,
		85,
		66,
		53,
		60,
		45,
		38,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		93,
		84,
		84,
		90,
		86,
		73,
		73,
		54,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		96,
		86,
		83,
		79,
		70,
		76,
		53,
		86,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		127,
		77,
		65,
		60,
		61,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		76,
		65,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		205,
		194,
		205,
		213,
		186,
		193,
		-1,
		212,
		216,
		182,
		176,
		215,
		184,
		190,
		201,
		-1,
		-1,
		-1,
		205,
		204,
		172,
		170,
		179,
		184,
		191,
		-1,
		190,
		-1,
		226,
		205,
		216,
		221,
		165,
		162,
		182,
		201,
		183,
		175,
		241,
		195,
		166,
		160,
		178,
		168,
		177,
		169,
		-1,
		166,
		156,
		178,
		157,
		168,
		160,
		-1,
		-1,
		160,
		161,
		167,
		153,
		159,
		155,
		-1,
		165,
		149,
		-1,
		-1,
		150,
		151,
		135,
		138,
		146,
		144,
		157,
		149,
		144,
		-1,
		-1,
		141,
		137,
		144,
		131,
		127,
		144,
		157,
		139,
		153,
		152,
		-1,
		145,
		163,
		170,
		138,
		136,
		120,
		118,
		136,
		138,
		144,
		144,
		-1,
		154,
		155,
		150,
		158,
		160,
		136,
		123,
		123,
		133,
		126,
		145,
		133,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		154,
		137,
		154,
		146,
		136,
		151,
		144,
		126,
		123,
		121,
		118,
		134,
		132,
		142,
		-1,
		-1,
		247,
		216,
		245,
		203,
		184,
		-1,
		150,
		130,
		136,
		140,
		134,
		127,
		141,
		137,
		-1,
		112,
		111,
		139,
		125,
		136,
		207,
		-1,
		-1,
		205,
		197,
		180,
		183,
		160,
		156,
		145,
		144,
		136,
		122,
		118,
		124,
		127,
		127,
		133,
		106,
		116,
		120,
		118,
		143,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		187,
		-1,
		170,
		177,
		166,
		172,
		158,
		179,
		155,
		146,
		138,
		132,
		120,
		122,
		119,
		132,
		120,
		103,
		128,
		132,
		113,
		134,
		129,
		-1,
		177,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		163,
		166,
		172,
		196,
		195,
		-1,
		167,
		155,
		156,
		141,
		138,
		125,
		113,
		126,
		111,
		118,
		117,
		107,
		105,
		135,
		110,
		132,
		129,
		148,
		153,
		147,
		156,
		-1,
		212,
		208,
		204,
		211,
		160,
		-1,
		-1,
		200,
		-1,
		203,
		204,
		179,
		152,
		155,
		142,
		133,
		120,
		109,
		120,
		109,
		106,
		114,
		99,
		114,
		105,
		104,
		122,
		132,
		140,
		144,
		150,
		-1,
		262,
		-1,
		204,
		188,
		190,
		162,
		183,
		-1,
		220,
		204,
		196,
		181,
		181,
		-1,
		151,
		148,
		138,
		116,
		101,
		118,
		110,
		108,
		112,
		94,
		108,
		99,
		117,
		124,
		122,
		126,
		146,
		158,
		222,
		212,
		-1,
		194,
		199,
		158,
		166,
		185,
		223,
		187,
		-1,
		182,
		-1,
		153,
		166,
		-1,
		122,
		118,
		100,
		101,
		96,
		111,
		105,
		90,
		87,
		105,
		108,
		115,
		119,
		135,
		-1,
		-1,
		207,
		211,
		200,
		151,
		170,
		194,
		231,
		180,
		169,
		168,
		-1,
		159,
		136,
		133,
		121,
		108,
		93,
		94,
		102,
		115,
		94,
		89,
		86,
		106,
		132,
		110,
		122,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		177,
		148,
		172,
		214,
		198,
		191,
		179,
		144,
		144,
		138,
		-1,
		132,
		111,
		102,
		91,
		89,
		102,
		99,
		104,
		84,
		82,
		101,
		113,
		104,
		121,
		-1,
		-1,
		-1,
		207,
		196,
		197,
		143,
		166,
		203,
		177,
		163,
		168,
		143,
		136,
		130,
		145,
		128,
		109,
		98,
		90,
		79,
		95,
		103,
		98,
		80,
		89,
		95,
		119,
		109,
		115,
		-1,
		-1,
		214,
		204,
		188,
		190,
		187,
		157,
		164,
		196,
		168,
		181,
		-1,
		135,
		-1,
		124,
		119,
		103,
		98,
		95,
		92,
		86,
		95,
		97,
		87,
		82,
		89,
		124,
		124,
		99,
		119,
		122,
		-1,
		-1,
		-1,
		207,
		202,
		177,
		154,
		138,
		174,
		-1,
		151,
		152,
		-1,
		129,
		123,
		120,
		105,
		101,
		96,
		100,
		93,
		100,
		93,
		91,
		92,
		74,
		106,
		-1,
		107,
		101,
		109,
		99,
		87,
		-1,
		-1,
		-1,
		200,
		179,
		172,
		192,
		133,
		185,
		-1,
		-1,
		136,
		129,
		-1,
		116,
		98,
		105,
		103,
		97,
		101,
		98,
		87,
		100,
		93,
		79,
		81,
		94,
		98,
		102,
		89,
		85,
		82,
		96,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		153,
		-1,
		145,
		137,
		127,
		121,
		115,
		111,
		109,
		125,
		109,
		112,
		110,
		101,
		109,
		82,
		75,
		82,
		71,
		89,
		97,
		89,
		83,
		82,
		92,
		-1,
		220,
		206,
		177,
		-1,
		-1,
		166,
		-1,
		130,
		144,
		160,
		-1,
		153,
		132,
		147,
		125,
		121,
		117,
		132,
		133,
		111,
		110,
		108,
		99,
		87,
		76,
		79,
		71,
		93,
		93,
		77,
		78,
		82,
		-1,
		226,
		213,
		171,
		167,
		156,
		176,
		127,
		115,
		147,
		-1,
		-1,
		189,
		-1,
		123,
		140,
		131,
		129,
		122,
		113,
		119,
		119,
		96,
		91,
		81,
		70,
		70,
		65,
		87,
		73,
		71,
		80,
		96,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		142,
		129,
		123,
		-1,
		164,
		-1,
		167,
		157,
		141,
		126,
		159,
		-1,
		124,
		114,
		119,
		-1,
		116,
		-1,
		89,
		86,
		77,
		62,
		59,
		70,
		68,
		79,
		75,
		-1,
		176,
		161,
		154,
		144,
		158,
		129,
		-1,
		184,
		-1,
		-1,
		154,
		148,
		148,
		132,
		135,
		140,
		120,
		112,
		119,
		111,
		103,
		97,
		75,
		68,
		65,
		58,
		71,
		81,
		86,
		73,
		-1,
		-1,
		-1,
		181,
		167,
		171,
		131,
		150,
		-1,
		-1,
		216,
		171,
		157,
		-1,
		141,
		140,
		128,
		118,
		108,
		113,
		114,
		94,
		87,
		73,
		75,
		69,
		60,
		59,
		75,
		67,
		89,
		-1,
		-1,
		164,
		169,
		157,
		143,
		162,
		-1,
		-1,
		-1,
		163,
		179,
		168,
		142,
		129,
		-1,
		-1,
		112,
		105,
		99,
		90,
		77,
		89,
		84,
		68,
		53,
		68,
		72,
		80,
		71,
		-1,
		167,
		154,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		-1,
		-1,
		180,
		125,
		114,
		109,
		113,
		111,
		-1,
		85,
		96,
		81,
		93,
		100,
		70,
		55,
		49,
		55,
		67,
		76,
		-1,
		-1,
		179,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		137,
		131,
		102,
		95,
		99,
		-1,
		87,
		89,
		83,
		98,
		73,
		70,
		61,
		52,
		48,
		52,
		56,
		70,
		74,
		202,
		-1,
		165,
		-1,
		-1,
		-1,
		155,
		170,
		141,
		118,
		91,
		86,
		79,
		73,
		78,
		89,
		81,
		92,
		59,
		55,
		45,
		44,
		48,
		65,
		65,
		-1,
		-1,
		163,
		159,
		181,
		163,
		167,
		168,
		-1,
		-1,
		95,
		86,
		77,
		69,
		82,
		85,
		65,
		62,
		56,
		49,
		43,
		53,
		64,
		59,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		165,
		166,
		113,
		95,
		91,
		89,
		78,
		72,
		60,
		65,
		66,
		57,
		51,
		39,
		39,
		62,
		51,
		68,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		128,
		125,
		-1,
		95,
		101,
		66,
		73,
		56,
		63,
		61,
		53,
		33,
		36,
		52,
		51,
		46,
		60,
		51,
		55,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		120,
		117,
		97,
		66,
		64,
		57,
		52,
		62,
		42,
		29,
		29,
		24,
		39,
		44,
		46,
		39,
		46,
		61,
		-1,
		194,
		231,
		224,
		192,
		200,
		231,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		93,
		84,
		85,
		73,
		70,
		72,
		67,
		58,
		38,
		44,
		22,
		29,
		40,
		32,
		36,
		37,
		44,
		55,
		59,
		-1,
		187,
		207,
		186,
		189,
		213,
		227,
		-1,
		134,
		-1,
		-1,
		146,
		118,
		102,
		92,
		89,
		132,
		87,
		82,
		66,
		64,
		55,
		46,
		46,
		30,
		18,
		15,
		24,
		29,
		21,
		42,
		49,
		55,
		-1,
		176,
		187,
		180,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		162,
		-1,
		129,
		-1,
		112,
		116,
		95,
		98,
		80,
		67,
		59,
		46,
		55,
		30,
		26,
		22,
		11,
		8,
		20,
		24,
		34,
		52,
		201,
		157,
		160,
		171,
		182,
		197,
		201,
		-1,
		146,
		185,
		179,
		-1,
		163,
		-1,
		-1,
		-1,
		126,
		108,
		100,
		100,
		79,
		79,
		53,
		49,
		35,
		31,
		38,
		28,
		18,
		7,
		18,
		29,
		44,
		197,
		188,
		201,
		146,
		146,
		167,
		176,
		197,
		161,
		152,
		179,
		186,
		175,
		170,
		157,
		-1,
		-1,
		148,
		118,
		-1,
		-1,
		86,
		74,
		57,
		46,
		42,
		45,
		53,
		37,
		17,
		6,
		0,
		32,
		-1,
		190,
		189,
		178,
		175,
		151,
		142,
		137,
		164,
		-1,
		-1,
		159,
		180,
		170,
		174,
		190,
		215,
		-1,
		146,
		-1,
		-1,
		128,
		-1,
		-1,
		113,
		79,
		68,
		59,
		57,
		50,
		57,
		68,
		23,
		15,
		5,
		15,
		28,
		174,
		171,
		159,
		157,
		180,
		145,
		133,
		-1,
		146,
		144,
		150,
		157,
		174,
		204,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		111,
		109,
		98,
		-1,
		88,
		64,
		56,
		77,
		51,
		40,
		32,
		26,
		26,
		17,
		25,
		33,
		183,
		197,
		186,
		182,
		181,
		189,
		138,
		131,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		106,
		99,
		87,
		75,
		65,
		70,
		56,
		52,
		38,
		31,
		26,
		37,
		12,
		16,
		33,
		-1,
		217,
		-1,
		169,
		145,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		140,
		124,
		105,
		-1,
		75,
		88,
		88,
		56,
		56,
		50,
		32,
		41,
		15,
		18,
		32,
		27,
		-1,
		-1,
		157,
		160,
		-1,
		-1,
		159,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		112,
		108,
		-1,
		-1,
		76,
		70,
		59,
		62,
		57,
		36,
		39,
		28,
		17,
		21,
		33,
		-1,
		-1,
		164,
		165,
		166,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		114,
		77,
		98,
		77,
		65,
		63,
		54,
		40,
		32,
		28,
		24,
		35,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		78,
		91,
		73,
		76,
		70,
		43,
		58,
		31,
		22,
		31,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		103,
		90,
		92,
		77,
		58,
		45,
		50,
		35,
		28,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		91,
		83,
		74,
		74,
		82,
		78,
		65,
		65,
		44,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		86,
		86,
		76,
		73,
		69,
		60,
		66,
		43,
		76,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		117,
		67,
		55,
		50,
		51,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		66,
		55,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		230,
		219,
		230,
		238,
		211,
		218,
		-1,
		237,
		241,
		207,
		201,
		240,
		209,
		215,
		226,
		-1,
		-1,
		-1,
		230,
		229,
		197,
		195,
		204,
		209,
		216,
		-1,
		215,
		-1,
		251,
		230,
		241,
		246,
		190,
		187,
		207,
		226,
		208,
		200,
		266,
		220,
		191,
		185,
		203,
		193,
		202,
		194,
		-1,
		191,
		181,
		203,
		182,
		193,
		185,
		-1,
		-1,
		185,
		186,
		192,
		178,
		184,
		180,
		-1,
		190,
		174,
		-1,
		-1,
		175,
		176,
		160,
		163,
		171,
		169,
		182,
		174,
		169,
		-1,
		-1,
		166,
		162,
		169,
		156,
		152,
		169,
		182,
		164,
		178,
		177,
		-1,
		170,
		188,
		195,
		163,
		161,
		145,
		143,
		161,
		163,
		169,
		169,
		-1,
		179,
		180,
		175,
		183,
		185,
		161,
		148,
		148,
		158,
		151,
		170,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		162,
		179,
		171,
		161,
		176,
		169,
		151,
		148,
		146,
		143,
		159,
		157,
		167,
		-1,
		-1,
		272,
		241,
		270,
		228,
		209,
		-1,
		175,
		155,
		161,
		165,
		159,
		152,
		166,
		162,
		-1,
		137,
		136,
		164,
		150,
		161,
		232,
		-1,
		-1,
		230,
		222,
		205,
		208,
		185,
		181,
		170,
		169,
		161,
		147,
		143,
		149,
		152,
		152,
		158,
		131,
		141,
		145,
		143,
		168,
		-1,
		-1,
		203,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		191,
		197,
		183,
		204,
		180,
		171,
		163,
		157,
		145,
		147,
		144,
		157,
		145,
		128,
		153,
		157,
		138,
		159,
		154,
		-1,
		202,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		220,
		-1,
		192,
		180,
		181,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		132,
		130,
		160,
		135,
		157,
		154,
		173,
		178,
		172,
		181,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		228,
		229,
		204,
		177,
		180,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		124,
		139,
		130,
		129,
		147,
		157,
		165,
		169,
		175,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		229,
		221,
		206,
		206,
		-1,
		176,
		173,
		163,
		141,
		126,
		143,
		135,
		133,
		137,
		119,
		133,
		124,
		142,
		149,
		147,
		151,
		171,
		183,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		248,
		212,
		-1,
		207,
		-1,
		178,
		191,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		130,
		115,
		112,
		130,
		133,
		140,
		144,
		160,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		205,
		194,
		193,
		-1,
		184,
		161,
		158,
		146,
		133,
		118,
		119,
		127,
		140,
		119,
		114,
		111,
		131,
		157,
		135,
		147,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		223,
		216,
		204,
		169,
		169,
		163,
		-1,
		157,
		136,
		127,
		116,
		114,
		127,
		124,
		129,
		109,
		107,
		126,
		138,
		129,
		146,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		168,
		191,
		228,
		202,
		188,
		193,
		168,
		161,
		155,
		170,
		153,
		134,
		123,
		115,
		104,
		120,
		128,
		123,
		105,
		114,
		120,
		144,
		134,
		140,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		182,
		189,
		221,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		117,
		111,
		120,
		122,
		112,
		107,
		114,
		149,
		149,
		124,
		144,
		147,
		-1,
		-1,
		-1,
		232,
		227,
		202,
		179,
		163,
		199,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		121,
		125,
		118,
		125,
		118,
		116,
		117,
		99,
		131,
		-1,
		132,
		126,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		128,
		122,
		126,
		123,
		112,
		125,
		118,
		104,
		106,
		119,
		123,
		127,
		114,
		110,
		107,
		121,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		137,
		135,
		126,
		134,
		107,
		100,
		107,
		96,
		114,
		122,
		114,
		108,
		107,
		117,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		136,
		135,
		133,
		124,
		112,
		101,
		104,
		96,
		118,
		118,
		102,
		103,
		107,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		140,
		172,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		138,
		144,
		144,
		121,
		116,
		106,
		95,
		95,
		90,
		112,
		98,
		96,
		105,
		102,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		149,
		139,
		144,
		-1,
		141,
		-1,
		114,
		111,
		102,
		87,
		84,
		95,
		93,
		104,
		100,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		209,
		-1,
		-1,
		179,
		173,
		173,
		157,
		160,
		165,
		145,
		137,
		144,
		136,
		128,
		122,
		100,
		93,
		90,
		83,
		96,
		106,
		111,
		98,
		-1,
		-1,
		-1,
		206,
		192,
		196,
		156,
		175,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		166,
		165,
		153,
		143,
		133,
		138,
		139,
		119,
		112,
		98,
		100,
		94,
		85,
		84,
		100,
		92,
		113,
		-1,
		-1,
		189,
		194,
		182,
		168,
		187,
		-1,
		-1,
		-1,
		188,
		204,
		193,
		167,
		154,
		-1,
		-1,
		137,
		130,
		124,
		115,
		102,
		114,
		109,
		93,
		78,
		93,
		97,
		103,
		95,
		-1,
		192,
		179,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		-1,
		-1,
		205,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		121,
		106,
		118,
		125,
		95,
		80,
		74,
		80,
		92,
		89,
		-1,
		-1,
		204,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		127,
		120,
		124,
		-1,
		112,
		114,
		108,
		123,
		98,
		95,
		86,
		77,
		73,
		77,
		81,
		74,
		80,
		227,
		-1,
		190,
		-1,
		-1,
		-1,
		180,
		195,
		166,
		143,
		116,
		111,
		104,
		98,
		103,
		114,
		106,
		117,
		84,
		80,
		70,
		69,
		73,
		78,
		76,
		-1,
		-1,
		188,
		184,
		206,
		188,
		192,
		193,
		-1,
		-1,
		120,
		111,
		102,
		94,
		107,
		110,
		90,
		87,
		81,
		74,
		68,
		78,
		75,
		70,
		-1,
		-1,
		-1,
		200,
		-1,
		202,
		-1,
		-1,
		190,
		191,
		138,
		120,
		116,
		114,
		103,
		97,
		85,
		90,
		91,
		82,
		76,
		64,
		64,
		87,
		62,
		68,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		179,
		171,
		166,
		172,
		174,
		165,
		153,
		150,
		-1,
		120,
		126,
		91,
		98,
		81,
		88,
		86,
		78,
		58,
		61,
		77,
		65,
		53,
		60,
		51,
		59,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		172,
		168,
		158,
		148,
		151,
		-1,
		-1,
		145,
		142,
		122,
		91,
		89,
		82,
		77,
		87,
		67,
		54,
		54,
		49,
		58,
		55,
		50,
		43,
		50,
		65,
		-1,
		219,
		256,
		249,
		217,
		225,
		256,
		-1,
		162,
		154,
		165,
		140,
		142,
		-1,
		-1,
		118,
		109,
		110,
		98,
		95,
		97,
		92,
		83,
		63,
		69,
		47,
		54,
		65,
		57,
		40,
		38,
		37,
		50,
		54,
		-1,
		212,
		232,
		211,
		214,
		238,
		252,
		-1,
		159,
		-1,
		-1,
		171,
		143,
		127,
		117,
		114,
		157,
		112,
		107,
		91,
		89,
		80,
		71,
		71,
		55,
		43,
		40,
		49,
		35,
		25,
		23,
		47,
		48,
		-1,
		201,
		212,
		205,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		187,
		-1,
		154,
		-1,
		137,
		141,
		120,
		123,
		105,
		92,
		84,
		71,
		80,
		55,
		51,
		47,
		36,
		40,
		29,
		7,
		15,
		24,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		171,
		210,
		204,
		-1,
		188,
		-1,
		-1,
		-1,
		151,
		133,
		125,
		125,
		104,
		104,
		78,
		74,
		60,
		56,
		63,
		53,
		45,
		39,
		17,
		5,
		16,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		186,
		177,
		204,
		211,
		200,
		195,
		182,
		-1,
		-1,
		174,
		143,
		-1,
		-1,
		111,
		99,
		82,
		71,
		67,
		70,
		78,
		62,
		44,
		32,
		32,
		0,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		205,
		195,
		199,
		215,
		240,
		-1,
		171,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		104,
		93,
		84,
		82,
		75,
		82,
		93,
		50,
		42,
		37,
		24,
		14,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		199,
		229,
		-1,
		-1,
		187,
		167,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		89,
		83,
		102,
		78,
		67,
		59,
		53,
		57,
		37,
		37,
		19,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		177,
		173,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		97,
		83,
		79,
		65,
		58,
		53,
		64,
		44,
		44,
		25,
		-1,
		242,
		-1,
		194,
		170,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		194,
		180,
		173,
		161,
		159,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		115,
		83,
		83,
		77,
		59,
		70,
		47,
		41,
		33,
		31,
		-1,
		-1,
		182,
		185,
		-1,
		-1,
		184,
		186,
		-1,
		185,
		174,
		159,
		151,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		103,
		97,
		86,
		89,
		84,
		63,
		69,
		60,
		49,
		34,
		34,
		-1,
		-1,
		189,
		190,
		191,
		-1,
		169,
		-1,
		187,
		-1,
		154,
		160,
		148,
		-1,
		-1,
		-1,
		141,
		104,
		125,
		104,
		91,
		89,
		80,
		67,
		64,
		60,
		54,
		44,
		-1,
		-1,
		-1,
		187,
		161,
		194,
		185,
		168,
		148,
		140,
		159,
		-1,
		129,
		-1,
		104,
		105,
		115,
		99,
		102,
		96,
		70,
		83,
		56,
		52,
		50,
		193,
		-1,
		163,
		196,
		160,
		154,
		130,
		134,
		150,
		-1,
		126,
		108,
		-1,
		122,
		109,
		113,
		98,
		79,
		66,
		69,
		54,
		47,
		-1,
		-1,
		-1,
		165,
		164,
		156,
		150,
		150,
		135,
		126,
		-1,
		138,
		120,
		99,
		116,
		102,
		93,
		93,
		103,
		99,
		86,
		84,
		63,
		-1,
		266,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		159,
		154,
		127,
		115,
		121,
		117,
		103,
		109,
		111,
		105,
		95,
		92,
		88,
		79,
		85,
		62,
		95,
		-1,
		261,
		-1,
		195,
		-1,
		-1,
		177,
		157,
		149,
		138,
		127,
		125,
		116,
		107,
		129,
		136,
		86,
		74,
		69,
		70,
		-1,
		250,
		249,
		-1,
		196,
		188,
		174,
		-1,
		167,
		-1,
		173,
		134,
		-1,
		136,
		116,
		-1,
		85,
		74,
		-1,
		-1,
		237,
		212,
		-1,
		-1,
		-1,
		197,
		177,
		168,
		152,
		-1,
		127,
		127,
		-1,
		-1,
		-1,
		222,
		221,
		-1,
		190,
		193,
		-1,
		183,
		174,
		182,
		129,
		133,
		-1,
		-1,
		-1,
		231,
		212,
		206,
		205,
		203,
		198,
		195,
		181,
		165,
		143,
		132,
		153,
		-1,
		-1,
		-1,
		203,
		195,
		188,
		-1,
		-1,
		190,
		173,
		154,
		152,
		-1,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		180,
		-1,
		-1,
		186,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		214,
		-1,
		-1,
		-1,
		176,
		172,
		173,
		-1,
		-1,
		-1,
		-1,
		236,
		237,
		260,
		224,
		-1,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		239,
		237,
		-1,
		-1,
		-1,
		196,
		180,
		-1,
		166,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		199,
		-1,
		-1,
		-1,
		201,
		-1,
		201,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		214,
		206,
		214,
		-1,
		186,
		188,
		-1,
		236,
		-1,
		-1,
		229,
		220,
		-1,
		-1,
		191,
		198,
		220,
		223,
		259,
		-1,
		210
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		326,
		315,
		326,
		334,
		307,
		314,
		-1,
		333,
		337,
		303,
		297,
		336,
		305,
		311,
		322,
		-1,
		-1,
		-1,
		326,
		325,
		293,
		291,
		300,
		305,
		312,
		-1,
		311,
		-1,
		347,
		326,
		337,
		342,
		286,
		283,
		303,
		322,
		304,
		296,
		362,
		316,
		287,
		281,
		299,
		289,
		298,
		290,
		-1,
		287,
		277,
		299,
		278,
		289,
		281,
		-1,
		-1,
		281,
		282,
		288,
		274,
		280,
		276,
		-1,
		286,
		270,
		-1,
		-1,
		271,
		272,
		256,
		259,
		267,
		265,
		278,
		270,
		265,
		-1,
		-1,
		262,
		258,
		265,
		252,
		248,
		265,
		278,
		260,
		274,
		273,
		-1,
		268,
		286,
		291,
		259,
		257,
		241,
		239,
		257,
		259,
		265,
		265,
		-1,
		274,
		276,
		273,
		281,
		281,
		257,
		244,
		244,
		254,
		247,
		266,
		254,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		271,
		260,
		277,
		269,
		259,
		274,
		267,
		247,
		244,
		242,
		239,
		255,
		253,
		263,
		-1,
		-1,
		327,
		296,
		331,
		288,
		273,
		-1,
		267,
		253,
		259,
		263,
		257,
		250,
		264,
		260,
		-1,
		233,
		232,
		260,
		246,
		257,
		287,
		-1,
		-1,
		285,
		277,
		262,
		265,
		262,
		262,
		268,
		267,
		259,
		245,
		241,
		247,
		250,
		250,
		256,
		227,
		237,
		241,
		239,
		264,
		-1,
		-1,
		299,
		-1,
		-1,
		284,
		267,
		-1,
		250,
		257,
		257,
		274,
		264,
		285,
		278,
		269,
		261,
		255,
		243,
		245,
		242,
		255,
		243,
		224,
		249,
		253,
		234,
		255,
		250,
		-1,
		298,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		243,
		246,
		252,
		276,
		286,
		-1,
		290,
		278,
		279,
		264,
		261,
		248,
		236,
		249,
		234,
		241,
		240,
		228,
		226,
		256,
		231,
		253,
		250,
		269,
		274,
		268,
		277,
		-1,
		292,
		288,
		284,
		291,
		240,
		-1,
		-1,
		280,
		-1,
		294,
		307,
		302,
		275,
		278,
		265,
		256,
		243,
		232,
		243,
		232,
		229,
		237,
		220,
		235,
		226,
		225,
		243,
		253,
		261,
		265,
		271,
		-1,
		342,
		-1,
		284,
		268,
		270,
		242,
		263,
		-1,
		300,
		295,
		315,
		304,
		302,
		-1,
		274,
		271,
		261,
		239,
		224,
		241,
		233,
		231,
		233,
		215,
		229,
		220,
		238,
		245,
		243,
		247,
		267,
		279,
		302,
		292,
		-1,
		274,
		279,
		238,
		246,
		265,
		338,
		308,
		-1,
		303,
		-1,
		276,
		289,
		-1,
		245,
		241,
		223,
		224,
		219,
		234,
		226,
		211,
		208,
		226,
		229,
		236,
		240,
		256,
		-1,
		-1,
		287,
		291,
		280,
		231,
		250,
		274,
		311,
		301,
		290,
		289,
		-1,
		280,
		259,
		256,
		244,
		231,
		216,
		217,
		225,
		237,
		216,
		210,
		207,
		227,
		253,
		231,
		242,
		-1,
		-1,
		-1,
		312,
		-1,
		-1,
		257,
		228,
		252,
		294,
		319,
		312,
		300,
		265,
		265,
		259,
		-1,
		255,
		234,
		225,
		214,
		212,
		225,
		217,
		225,
		205,
		203,
		222,
		234,
		225,
		233,
		-1,
		-1,
		-1,
		287,
		276,
		277,
		226,
		249,
		283,
		298,
		284,
		289,
		264,
		257,
		251,
		268,
		251,
		232,
		221,
		213,
		202,
		213,
		221,
		219,
		201,
		210,
		216,
		240,
		221,
		227,
		-1,
		-1,
		294,
		284,
		268,
		270,
		267,
		240,
		247,
		279,
		289,
		291,
		-1,
		256,
		-1,
		245,
		241,
		226,
		221,
		218,
		205,
		204,
		218,
		218,
		208,
		203,
		210,
		245,
		245,
		211,
		231,
		234,
		-1,
		-1,
		-1,
		287,
		285,
		260,
		237,
		221,
		257,
		-1,
		261,
		262,
		-1,
		250,
		244,
		241,
		228,
		224,
		209,
		213,
		215,
		218,
		206,
		212,
		213,
		195,
		219,
		-1,
		219,
		213,
		221,
		211,
		199,
		-1,
		-1,
		-1,
		283,
		262,
		255,
		275,
		216,
		268,
		-1,
		-1,
		246,
		239,
		-1,
		237,
		219,
		221,
		216,
		212,
		214,
		211,
		200,
		213,
		206,
		200,
		194,
		207,
		211,
		212,
		201,
		197,
		194,
		208,
		-1,
		302,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		236,
		-1,
		249,
		241,
		237,
		231,
		236,
		232,
		230,
		240,
		224,
		226,
		222,
		214,
		209,
		195,
		188,
		199,
		184,
		202,
		208,
		199,
		194,
		193,
		204,
		-1,
		303,
		289,
		260,
		-1,
		-1,
		249,
		-1,
		213,
		227,
		243,
		-1,
		271,
		250,
		268,
		246,
		242,
		233,
		231,
		232,
		202,
		207,
		209,
		197,
		200,
		189,
		192,
		184,
		206,
		203,
		187,
		189,
		198,
		-1,
		309,
		296,
		254,
		250,
		239,
		259,
		210,
		219,
		230,
		-1,
		-1,
		293,
		-1,
		244,
		249,
		247,
		245,
		221,
		196,
		203,
		221,
		194,
		189,
		194,
		183,
		183,
		178,
		197,
		183,
		181,
		196,
		212,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		225,
		212,
		206,
		-1,
		247,
		-1,
		271,
		259,
		246,
		228,
		268,
		-1,
		195,
		191,
		198,
		-1,
		214,
		-1,
		186,
		189,
		180,
		175,
		172,
		183,
		181,
		190,
		191,
		-1,
		259,
		244,
		237,
		227,
		241,
		212,
		-1,
		255,
		-1,
		-1,
		258,
		252,
		252,
		221,
		218,
		211,
		191,
		183,
		198,
		197,
		184,
		183,
		171,
		171,
		174,
		168,
		181,
		191,
		197,
		189,
		-1,
		-1,
		-1,
		264,
		216,
		224,
		200,
		221,
		-1,
		-1,
		319,
		275,
		261,
		-1,
		213,
		211,
		199,
		189,
		179,
		184,
		185,
		175,
		173,
		169,
		178,
		177,
		170,
		169,
		190,
		183,
		205,
		-1,
		-1,
		213,
		226,
		228,
		212,
		207,
		-1,
		-1,
		-1,
		265,
		266,
		232,
		211,
		200,
		-1,
		-1,
		183,
		176,
		170,
		173,
		161,
		181,
		188,
		176,
		163,
		178,
		188,
		196,
		195,
		-1,
		216,
		203,
		-1,
		-1,
		206,
		196,
		-1,
		-1,
		-1,
		-1,
		244,
		189,
		178,
		173,
		177,
		182,
		-1,
		156,
		167,
		160,
		179,
		186,
		178,
		163,
		157,
		168,
		183,
		200,
		-1,
		-1,
		220,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		201,
		195,
		166,
		159,
		163,
		-1,
		158,
		160,
		157,
		169,
		174,
		178,
		169,
		151,
		165,
		168,
		181,
		195,
		199,
		243,
		-1,
		173,
		-1,
		-1,
		-1,
		212,
		213,
		199,
		176,
		155,
		148,
		145,
		144,
		149,
		160,
		169,
		180,
		145,
		149,
		164,
		169,
		173,
		190,
		194,
		-1,
		-1,
		171,
		167,
		202,
		214,
		186,
		226,
		-1,
		-1,
		144,
		137,
		147,
		140,
		153,
		156,
		141,
		143,
		161,
		174,
		168,
		178,
		193,
		188,
		-1,
		-1,
		-1,
		169,
		-1,
		185,
		-1,
		-1,
		176,
		217,
		164,
		146,
		142,
		128,
		135,
		129,
		131,
		136,
		155,
		150,
		159,
		164,
		168,
		191,
		180,
		219,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		135,
		154,
		149,
		155,
		160,
		151,
		179,
		176,
		-1,
		125,
		158,
		126,
		140,
		136,
		143,
		148,
		154,
		158,
		165,
		181,
		180,
		175,
		211,
		202,
		208,
		-1,
		-1,
		162,
		151,
		140,
		146,
		-1,
		128,
		151,
		141,
		131,
		137,
		-1,
		-1,
		143,
		140,
		138,
		118,
		124,
		129,
		132,
		170,
		146,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		116,
		153,
		146,
		114,
		122,
		153,
		-1,
		118,
		110,
		138,
		123,
		131,
		-1,
		-1,
		116,
		107,
		112,
		121,
		122,
		153,
		152,
		165,
		168,
		173,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		109,
		129,
		108,
		111,
		135,
		149,
		-1,
		109,
		-1,
		-1,
		154,
		141,
		125,
		115,
		112,
		159,
		135,
		130,
		136,
		138,
		162,
		153,
		178,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		98,
		109,
		102,
		-1,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		170,
		-1,
		152,
		-1,
		135,
		139,
		143,
		146,
		161,
		148,
		155,
		172,
		178,
		167,
		177,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		76,
		79,
		82,
		93,
		104,
		119,
		123,
		-1,
		93,
		129,
		139,
		-1,
		179,
		-1,
		-1,
		-1,
		149,
		156,
		148,
		164,
		160,
		160,
		156,
		160,
		172,
		179,
		189,
		191,
		183,
		187,
		200,
		211,
		214,
		72,
		73,
		123,
		68,
		68,
		89,
		98,
		119,
		89,
		86,
		123,
		128,
		143,
		148,
		172,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		167,
		177,
		160,
		162,
		166,
		180,
		192,
		200,
		190,
		188,
		182,
		214,
		-1,
		0,
		36,
		39,
		44,
		36,
		48,
		59,
		86,
		-1,
		-1,
		87,
		114,
		98,
		102,
		118,
		143,
		-1,
		179,
		-1,
		-1,
		193,
		-1,
		-1,
		219,
		182,
		171,
		162,
		168,
		174,
		185,
		207,
		196,
		197,
		187,
		197,
		210,
		15,
		18,
		28,
		32,
		49,
		67,
		55,
		-1,
		74,
		72,
		78,
		85,
		102,
		132,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		212,
		215,
		204,
		-1,
		194,
		167,
		172,
		197,
		204,
		205,
		199,
		193,
		200,
		199,
		207,
		215,
		24,
		38,
		38,
		54,
		50,
		63,
		60,
		59,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		224,
		205,
		-1,
		-1,
		212,
		205,
		193,
		181,
		171,
		181,
		189,
		189,
		192,
		196,
		191,
		202,
		194,
		198,
		215,
		-1,
		87,
		-1,
		91,
		73,
		87,
		102,
		110,
		-1,
		-1,
		-1,
		241,
		227,
		220,
		208,
		206,
		-1,
		246,
		230,
		211,
		-1,
		181,
		194,
		225,
		193,
		198,
		193,
		197,
		208,
		197,
		200,
		214,
		209,
		-1,
		-1,
		85,
		88,
		-1,
		-1,
		110,
		129,
		-1,
		232,
		221,
		206,
		198,
		-1,
		-1,
		218,
		214,
		-1,
		-1,
		182,
		207,
		196,
		204,
		199,
		201,
		207,
		210,
		199,
		203,
		215,
		-1,
		-1,
		92,
		93,
		98,
		-1,
		119,
		-1,
		234,
		-1,
		201,
		208,
		196,
		-1,
		-1,
		-1,
		220,
		183,
		204,
		214,
		219,
		217,
		208,
		205,
		212,
		210,
		206,
		217,
		-1,
		-1,
		-1,
		149,
		126,
		241,
		232,
		215,
		195,
		187,
		207,
		-1,
		208,
		-1,
		183,
		184,
		211,
		213,
		230,
		224,
		208,
		223,
		213,
		204,
		213,
		155,
		-1,
		130,
		189,
		172,
		201,
		167,
		179,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		247,
		228,
		221,
		208,
		215,
		217,
		210,
		-1,
		-1,
		-1,
		145,
		144,
		143,
		154,
		162,
		160,
		178,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		237,
		233,
		226,
		228,
		218,
		-1,
		161,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		171,
		193,
		188,
		180,
		192,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		217,
		249,
		-1,
		168,
		-1,
		175,
		-1,
		-1,
		189,
		175,
		187,
		198,
		188,
		188,
		193,
		186,
		208,
		224,
		208,
		206,
		211,
		216,
		-1,
		178,
		179,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		234,
		195,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		190,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		229,
		213,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		204,
		227,
		-1,
		202,
		205,
		-1,
		196,
		202,
		231,
		208,
		212,
		-1,
		-1,
		-1,
		231,
		215,
		220,
		217,
		222,
		210,
		227,
		213,
		215,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		230,
		222,
		222,
		-1,
		-1,
		240,
		223,
		223,
		231,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		231,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		241,
		-1,
		-1,
		-1,
		232,
		239,
		247,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		269,
		262,
		-1,
		-1,
		-1,
		246,
		241,
		-1,
		-1,
		222,
		223,
		-1,
		-1,
		-1,
		274,
		258,
		-1,
		245,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		279,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		292,
		284,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		307,
		298,
		-1,
		-1,
		270,
		277,
		299,
		302,
		306,
		-1,
		289
	],
	[
		-1,
		332,
		321,
		332,
		340,
		313,
		320,
		-1,
		339,
		343,
		309,
		303,
		342,
		311,
		317,
		328,
		-1,
		-1,
		-1,
		332,
		331,
		299,
		297,
		306,
		311,
		318,
		-1,
		317,
		-1,
		353,
		332,
		343,
		348,
		292,
		289,
		309,
		328,
		310,
		302,
		368,
		322,
		293,
		287,
		305,
		295,
		304,
		296,
		-1,
		293,
		283,
		305,
		284,
		295,
		287,
		-1,
		-1,
		287,
		288,
		294,
		280,
		286,
		282,
		-1,
		292,
		276,
		-1,
		-1,
		277,
		278,
		262,
		265,
		273,
		271,
		284,
		276,
		271,
		-1,
		-1,
		268,
		264,
		271,
		258,
		254,
		271,
		284,
		266,
		280,
		279,
		-1,
		274,
		292,
		297,
		265,
		263,
		247,
		245,
		263,
		265,
		271,
		271,
		-1,
		280,
		282,
		279,
		287,
		287,
		263,
		250,
		250,
		260,
		253,
		272,
		260,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		277,
		266,
		283,
		275,
		265,
		280,
		273,
		253,
		250,
		248,
		245,
		261,
		259,
		269,
		-1,
		-1,
		333,
		302,
		337,
		294,
		279,
		-1,
		273,
		259,
		265,
		269,
		263,
		256,
		270,
		266,
		-1,
		239,
		238,
		266,
		252,
		263,
		293,
		-1,
		-1,
		291,
		283,
		268,
		271,
		268,
		268,
		274,
		273,
		265,
		251,
		247,
		253,
		256,
		256,
		262,
		233,
		243,
		247,
		245,
		270,
		-1,
		-1,
		305,
		-1,
		-1,
		290,
		273,
		-1,
		256,
		263,
		263,
		280,
		270,
		291,
		284,
		275,
		267,
		261,
		249,
		251,
		248,
		261,
		249,
		230,
		255,
		259,
		240,
		261,
		256,
		-1,
		304,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		249,
		252,
		258,
		282,
		292,
		-1,
		296,
		284,
		285,
		270,
		267,
		254,
		242,
		255,
		240,
		247,
		246,
		234,
		232,
		262,
		237,
		259,
		256,
		275,
		280,
		274,
		283,
		-1,
		298,
		294,
		290,
		297,
		246,
		-1,
		-1,
		286,
		-1,
		300,
		313,
		308,
		281,
		284,
		271,
		262,
		249,
		238,
		249,
		238,
		235,
		243,
		226,
		241,
		232,
		231,
		249,
		259,
		267,
		271,
		277,
		-1,
		348,
		-1,
		290,
		274,
		276,
		248,
		269,
		-1,
		306,
		301,
		321,
		310,
		308,
		-1,
		280,
		277,
		267,
		245,
		230,
		247,
		239,
		237,
		239,
		221,
		235,
		226,
		244,
		251,
		249,
		253,
		273,
		285,
		308,
		298,
		-1,
		280,
		285,
		244,
		252,
		271,
		344,
		314,
		-1,
		309,
		-1,
		282,
		295,
		-1,
		251,
		247,
		229,
		230,
		225,
		240,
		232,
		217,
		214,
		232,
		235,
		242,
		246,
		262,
		-1,
		-1,
		293,
		297,
		286,
		237,
		256,
		280,
		317,
		307,
		296,
		295,
		-1,
		286,
		265,
		262,
		250,
		237,
		222,
		223,
		231,
		243,
		222,
		216,
		213,
		233,
		259,
		237,
		248,
		-1,
		-1,
		-1,
		318,
		-1,
		-1,
		263,
		234,
		258,
		300,
		325,
		318,
		306,
		271,
		271,
		265,
		-1,
		261,
		240,
		231,
		220,
		218,
		231,
		223,
		231,
		211,
		209,
		228,
		240,
		231,
		239,
		-1,
		-1,
		-1,
		293,
		282,
		283,
		232,
		255,
		289,
		304,
		290,
		295,
		270,
		263,
		257,
		274,
		257,
		238,
		227,
		219,
		208,
		219,
		227,
		225,
		207,
		216,
		222,
		246,
		227,
		233,
		-1,
		-1,
		300,
		290,
		274,
		276,
		273,
		246,
		253,
		285,
		295,
		297,
		-1,
		262,
		-1,
		251,
		247,
		232,
		227,
		224,
		211,
		210,
		224,
		224,
		214,
		209,
		216,
		251,
		251,
		217,
		237,
		240,
		-1,
		-1,
		-1,
		293,
		291,
		266,
		243,
		227,
		263,
		-1,
		267,
		268,
		-1,
		256,
		250,
		247,
		234,
		230,
		215,
		219,
		221,
		224,
		212,
		218,
		219,
		201,
		225,
		-1,
		225,
		219,
		227,
		217,
		205,
		-1,
		-1,
		-1,
		289,
		268,
		261,
		281,
		222,
		274,
		-1,
		-1,
		252,
		245,
		-1,
		243,
		225,
		227,
		222,
		218,
		220,
		217,
		206,
		219,
		212,
		206,
		200,
		213,
		217,
		218,
		207,
		203,
		200,
		214,
		-1,
		308,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		242,
		-1,
		255,
		247,
		243,
		237,
		242,
		238,
		236,
		246,
		230,
		232,
		228,
		220,
		215,
		201,
		194,
		205,
		190,
		208,
		214,
		205,
		200,
		199,
		210,
		-1,
		309,
		295,
		266,
		-1,
		-1,
		255,
		-1,
		219,
		233,
		249,
		-1,
		277,
		256,
		274,
		252,
		248,
		239,
		237,
		238,
		208,
		213,
		215,
		203,
		206,
		195,
		198,
		190,
		212,
		209,
		193,
		195,
		204,
		-1,
		315,
		302,
		260,
		256,
		245,
		265,
		216,
		225,
		236,
		-1,
		-1,
		299,
		-1,
		250,
		255,
		253,
		251,
		227,
		202,
		209,
		227,
		200,
		195,
		200,
		189,
		189,
		184,
		203,
		189,
		187,
		202,
		218,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		231,
		218,
		212,
		-1,
		253,
		-1,
		277,
		265,
		252,
		234,
		274,
		-1,
		201,
		197,
		204,
		-1,
		220,
		-1,
		192,
		195,
		186,
		181,
		178,
		189,
		187,
		196,
		197,
		-1,
		265,
		250,
		243,
		233,
		247,
		218,
		-1,
		261,
		-1,
		-1,
		264,
		258,
		258,
		227,
		224,
		217,
		197,
		189,
		204,
		203,
		190,
		189,
		177,
		177,
		180,
		174,
		187,
		197,
		203,
		195,
		-1,
		-1,
		-1,
		270,
		222,
		230,
		206,
		227,
		-1,
		-1,
		325,
		281,
		267,
		-1,
		219,
		217,
		205,
		195,
		185,
		190,
		191,
		181,
		179,
		175,
		184,
		183,
		176,
		175,
		196,
		189,
		211,
		-1,
		-1,
		219,
		232,
		234,
		218,
		213,
		-1,
		-1,
		-1,
		271,
		272,
		238,
		217,
		206,
		-1,
		-1,
		189,
		182,
		176,
		179,
		167,
		187,
		194,
		182,
		169,
		184,
		194,
		202,
		201,
		-1,
		222,
		209,
		-1,
		-1,
		212,
		202,
		-1,
		-1,
		-1,
		-1,
		250,
		195,
		184,
		179,
		183,
		188,
		-1,
		162,
		173,
		166,
		185,
		192,
		184,
		169,
		163,
		174,
		189,
		206,
		-1,
		-1,
		226,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		172,
		165,
		169,
		-1,
		164,
		166,
		163,
		175,
		180,
		184,
		175,
		157,
		171,
		174,
		187,
		201,
		205,
		249,
		-1,
		179,
		-1,
		-1,
		-1,
		218,
		219,
		205,
		182,
		161,
		154,
		151,
		150,
		155,
		166,
		175,
		186,
		151,
		155,
		170,
		175,
		179,
		196,
		200,
		-1,
		-1,
		177,
		173,
		208,
		220,
		192,
		232,
		-1,
		-1,
		150,
		143,
		153,
		146,
		159,
		162,
		147,
		149,
		167,
		180,
		174,
		184,
		199,
		194,
		-1,
		-1,
		-1,
		175,
		-1,
		191,
		-1,
		-1,
		182,
		223,
		170,
		152,
		148,
		134,
		141,
		135,
		137,
		142,
		161,
		156,
		165,
		170,
		174,
		197,
		186,
		225,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		141,
		160,
		155,
		161,
		166,
		157,
		185,
		182,
		-1,
		131,
		164,
		132,
		146,
		142,
		149,
		154,
		160,
		164,
		171,
		187,
		186,
		181,
		217,
		208,
		214,
		-1,
		-1,
		168,
		157,
		146,
		152,
		-1,
		134,
		157,
		147,
		137,
		143,
		-1,
		-1,
		149,
		146,
		144,
		124,
		130,
		135,
		138,
		176,
		152,
		160,
		164,
		168,
		174,
		179,
		184,
		190,
		205,
		220,
		-1,
		122,
		159,
		152,
		120,
		128,
		159,
		-1,
		124,
		116,
		144,
		129,
		137,
		-1,
		-1,
		122,
		113,
		118,
		127,
		128,
		159,
		158,
		171,
		174,
		179,
		167,
		166,
		184,
		188,
		197,
		204,
		194,
		207,
		211,
		-1,
		115,
		135,
		114,
		117,
		141,
		155,
		-1,
		115,
		-1,
		-1,
		160,
		147,
		131,
		121,
		118,
		165,
		141,
		136,
		142,
		144,
		168,
		159,
		184,
		175,
		175,
		178,
		193,
		198,
		190,
		204,
		204,
		205,
		-1,
		104,
		115,
		108,
		-1,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		176,
		-1,
		158,
		-1,
		141,
		145,
		149,
		152,
		167,
		154,
		161,
		178,
		184,
		173,
		183,
		179,
		180,
		189,
		200,
		212,
		211,
		212,
		58,
		85,
		88,
		99,
		110,
		125,
		129,
		-1,
		99,
		135,
		145,
		-1,
		185,
		-1,
		-1,
		-1,
		155,
		162,
		154,
		170,
		166,
		166,
		162,
		166,
		178,
		185,
		195,
		197,
		189,
		193,
		206,
		217,
		220,
		54,
		79,
		129,
		74,
		74,
		95,
		104,
		125,
		95,
		92,
		129,
		134,
		149,
		154,
		178,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		173,
		183,
		166,
		168,
		172,
		186,
		198,
		206,
		196,
		194,
		188,
		220,
		-1,
		43,
		0,
		30,
		50,
		42,
		54,
		65,
		92,
		-1,
		-1,
		93,
		120,
		104,
		108,
		124,
		149,
		-1,
		185,
		-1,
		-1,
		199,
		-1,
		-1,
		225,
		188,
		177,
		168,
		174,
		180,
		191,
		213,
		202,
		203,
		193,
		203,
		216,
		27,
		24,
		34,
		38,
		52,
		73,
		61,
		-1,
		80,
		78,
		84,
		91,
		108,
		138,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		218,
		221,
		210,
		-1,
		200,
		173,
		178,
		203,
		210,
		211,
		205,
		199,
		206,
		205,
		213,
		221,
		36,
		42,
		38,
		57,
		53,
		66,
		66,
		65,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		230,
		211,
		-1,
		-1,
		218,
		211,
		199,
		187,
		177,
		187,
		195,
		195,
		198,
		202,
		197,
		208,
		200,
		204,
		221,
		-1,
		82,
		-1,
		97,
		79,
		93,
		108,
		116,
		-1,
		-1,
		-1,
		247,
		233,
		226,
		214,
		212,
		-1,
		252,
		236,
		217,
		-1,
		187,
		200,
		231,
		199,
		204,
		199,
		203,
		214,
		203,
		206,
		220,
		215,
		-1,
		-1,
		91,
		94,
		-1,
		-1,
		116,
		135,
		-1,
		238,
		227,
		212,
		204,
		-1,
		-1,
		224,
		220,
		-1,
		-1,
		188,
		213,
		202,
		210,
		205,
		207,
		213,
		216,
		205,
		209,
		221,
		-1,
		-1,
		98,
		99,
		104,
		-1,
		125,
		-1,
		240,
		-1,
		207,
		214,
		202,
		-1,
		-1,
		-1,
		226,
		189,
		210,
		220,
		225,
		223,
		214,
		211,
		218,
		216,
		212,
		223,
		-1,
		-1,
		-1,
		155,
		132,
		247,
		238,
		221,
		201,
		193,
		213,
		-1,
		214,
		-1,
		189,
		190,
		217,
		219,
		236,
		230,
		214,
		229,
		219,
		210,
		219,
		161,
		-1,
		136,
		195,
		178,
		207,
		173,
		185,
		235,
		-1,
		211,
		193,
		-1,
		221,
		211,
		253,
		234,
		227,
		214,
		221,
		223,
		216,
		-1,
		-1,
		-1,
		151,
		150,
		149,
		160,
		168,
		166,
		184,
		-1,
		223,
		205,
		184,
		201,
		201,
		192,
		200,
		243,
		239,
		232,
		234,
		224,
		-1,
		164,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		177,
		199,
		194,
		186,
		198,
		202,
		188,
		194,
		196,
		204,
		202,
		199,
		211,
		207,
		227,
		223,
		255,
		-1,
		171,
		-1,
		181,
		-1,
		-1,
		195,
		181,
		193,
		204,
		194,
		194,
		199,
		192,
		214,
		230,
		214,
		212,
		217,
		222,
		-1,
		181,
		182,
		-1,
		214,
		206,
		192,
		-1,
		185,
		-1,
		240,
		201,
		-1,
		221,
		201,
		-1,
		223,
		219,
		-1,
		-1,
		193,
		230,
		-1,
		-1,
		-1,
		215,
		195,
		235,
		219,
		-1,
		212,
		212,
		-1,
		-1,
		-1,
		207,
		230,
		-1,
		208,
		211,
		-1,
		202,
		208,
		237,
		214,
		218,
		-1,
		-1,
		-1,
		234,
		218,
		223,
		223,
		228,
		216,
		233,
		219,
		221,
		228,
		217,
		238,
		-1,
		-1,
		-1,
		236,
		228,
		228,
		-1,
		-1,
		246,
		229,
		229,
		237,
		-1,
		-1,
		-1,
		258,
		239,
		-1,
		-1,
		237,
		-1,
		-1,
		242,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		247,
		-1,
		-1,
		-1,
		238,
		245,
		253,
		-1,
		-1,
		-1,
		-1,
		227,
		228,
		272,
		268,
		-1,
		-1,
		-1,
		252,
		247,
		-1,
		-1,
		225,
		226,
		-1,
		-1,
		-1,
		280,
		264,
		-1,
		251,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		285,
		-1,
		286,
		261,
		268,
		-1,
		-1,
		-1,
		-1,
		298,
		290,
		299,
		-1,
		271,
		273,
		-1,
		321,
		-1,
		-1,
		313,
		304,
		-1,
		-1,
		276,
		283,
		305,
		308,
		309,
		-1,
		295
	],
	[
		-1,
		317,
		306,
		317,
		325,
		298,
		305,
		-1,
		324,
		328,
		294,
		288,
		327,
		296,
		302,
		313,
		-1,
		-1,
		-1,
		317,
		316,
		284,
		282,
		291,
		296,
		303,
		-1,
		302,
		-1,
		338,
		317,
		328,
		333,
		277,
		274,
		294,
		313,
		295,
		287,
		353,
		307,
		278,
		272,
		290,
		280,
		289,
		281,
		-1,
		278,
		268,
		290,
		269,
		280,
		272,
		-1,
		-1,
		272,
		273,
		279,
		265,
		271,
		267,
		-1,
		277,
		261,
		-1,
		-1,
		262,
		263,
		247,
		250,
		258,
		256,
		269,
		261,
		256,
		-1,
		-1,
		253,
		249,
		256,
		243,
		239,
		256,
		269,
		251,
		265,
		264,
		-1,
		259,
		277,
		282,
		250,
		248,
		232,
		230,
		248,
		250,
		256,
		256,
		-1,
		265,
		267,
		264,
		272,
		272,
		248,
		235,
		235,
		245,
		238,
		257,
		245,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		262,
		251,
		268,
		260,
		250,
		265,
		258,
		238,
		235,
		233,
		230,
		246,
		244,
		254,
		-1,
		-1,
		318,
		287,
		322,
		279,
		264,
		-1,
		258,
		244,
		250,
		254,
		248,
		241,
		255,
		251,
		-1,
		224,
		223,
		251,
		237,
		248,
		278,
		-1,
		-1,
		276,
		268,
		253,
		256,
		253,
		253,
		259,
		258,
		250,
		236,
		232,
		238,
		241,
		241,
		247,
		218,
		228,
		232,
		230,
		255,
		-1,
		-1,
		290,
		-1,
		-1,
		275,
		258,
		-1,
		241,
		248,
		248,
		265,
		255,
		276,
		269,
		260,
		252,
		246,
		234,
		236,
		233,
		246,
		234,
		215,
		240,
		244,
		225,
		246,
		241,
		-1,
		289,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		234,
		237,
		243,
		267,
		277,
		-1,
		281,
		269,
		270,
		255,
		252,
		239,
		227,
		240,
		225,
		232,
		231,
		219,
		217,
		247,
		222,
		244,
		241,
		260,
		265,
		259,
		268,
		-1,
		283,
		279,
		275,
		282,
		231,
		-1,
		-1,
		271,
		-1,
		285,
		298,
		293,
		266,
		269,
		256,
		247,
		234,
		223,
		234,
		223,
		220,
		228,
		211,
		226,
		217,
		216,
		234,
		244,
		252,
		256,
		262,
		-1,
		333,
		-1,
		275,
		259,
		261,
		233,
		254,
		-1,
		291,
		286,
		306,
		295,
		293,
		-1,
		265,
		262,
		252,
		230,
		215,
		232,
		224,
		222,
		224,
		206,
		220,
		211,
		229,
		236,
		234,
		238,
		258,
		270,
		293,
		283,
		-1,
		265,
		270,
		229,
		237,
		256,
		329,
		299,
		-1,
		294,
		-1,
		267,
		280,
		-1,
		236,
		232,
		214,
		215,
		210,
		225,
		217,
		202,
		199,
		217,
		220,
		227,
		231,
		247,
		-1,
		-1,
		278,
		282,
		271,
		222,
		241,
		265,
		302,
		292,
		281,
		280,
		-1,
		271,
		250,
		247,
		235,
		222,
		207,
		208,
		216,
		228,
		207,
		201,
		198,
		218,
		244,
		222,
		233,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		248,
		219,
		243,
		285,
		310,
		303,
		291,
		256,
		256,
		250,
		-1,
		246,
		225,
		216,
		205,
		203,
		216,
		208,
		216,
		196,
		194,
		213,
		225,
		216,
		224,
		-1,
		-1,
		-1,
		278,
		267,
		268,
		217,
		240,
		274,
		289,
		275,
		280,
		255,
		248,
		242,
		259,
		242,
		223,
		212,
		204,
		193,
		204,
		212,
		210,
		192,
		201,
		207,
		231,
		212,
		218,
		-1,
		-1,
		285,
		275,
		259,
		261,
		258,
		231,
		238,
		270,
		280,
		282,
		-1,
		247,
		-1,
		236,
		232,
		217,
		212,
		209,
		196,
		195,
		209,
		209,
		199,
		194,
		201,
		236,
		236,
		202,
		222,
		225,
		-1,
		-1,
		-1,
		278,
		276,
		251,
		228,
		212,
		248,
		-1,
		252,
		253,
		-1,
		241,
		235,
		232,
		219,
		215,
		200,
		204,
		206,
		209,
		197,
		203,
		204,
		186,
		210,
		-1,
		210,
		204,
		212,
		202,
		190,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		237,
		230,
		-1,
		228,
		210,
		212,
		207,
		203,
		205,
		202,
		191,
		204,
		197,
		191,
		185,
		198,
		202,
		203,
		192,
		188,
		185,
		199,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		240,
		232,
		228,
		222,
		227,
		223,
		221,
		231,
		215,
		217,
		213,
		205,
		200,
		186,
		179,
		190,
		175,
		193,
		199,
		190,
		185,
		184,
		195,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		218,
		234,
		-1,
		262,
		241,
		259,
		237,
		233,
		224,
		222,
		223,
		193,
		198,
		200,
		188,
		191,
		180,
		183,
		175,
		197,
		194,
		178,
		180,
		189,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		210,
		221,
		-1,
		-1,
		284,
		-1,
		235,
		240,
		238,
		236,
		212,
		187,
		194,
		212,
		185,
		180,
		185,
		174,
		174,
		169,
		188,
		174,
		172,
		187,
		203,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		238,
		-1,
		262,
		250,
		237,
		219,
		259,
		-1,
		186,
		182,
		189,
		-1,
		205,
		-1,
		177,
		180,
		171,
		166,
		163,
		174,
		172,
		181,
		182,
		-1,
		250,
		235,
		228,
		218,
		232,
		203,
		-1,
		246,
		-1,
		-1,
		249,
		243,
		243,
		212,
		209,
		202,
		182,
		174,
		189,
		188,
		175,
		174,
		162,
		162,
		165,
		159,
		172,
		182,
		188,
		180,
		-1,
		-1,
		-1,
		255,
		207,
		215,
		191,
		212,
		-1,
		-1,
		310,
		266,
		252,
		-1,
		204,
		202,
		190,
		180,
		170,
		175,
		176,
		166,
		164,
		160,
		169,
		168,
		161,
		160,
		181,
		174,
		196,
		-1,
		-1,
		204,
		217,
		219,
		203,
		198,
		-1,
		-1,
		-1,
		256,
		257,
		223,
		202,
		191,
		-1,
		-1,
		174,
		167,
		161,
		164,
		152,
		172,
		179,
		167,
		154,
		169,
		179,
		187,
		186,
		-1,
		207,
		194,
		-1,
		-1,
		197,
		187,
		-1,
		-1,
		-1,
		-1,
		235,
		180,
		169,
		164,
		168,
		173,
		-1,
		147,
		158,
		151,
		170,
		177,
		169,
		154,
		148,
		159,
		174,
		191,
		-1,
		-1,
		211,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		192,
		186,
		157,
		150,
		154,
		-1,
		149,
		151,
		148,
		160,
		165,
		169,
		160,
		142,
		156,
		159,
		172,
		186,
		190,
		234,
		-1,
		164,
		-1,
		-1,
		-1,
		203,
		204,
		190,
		167,
		146,
		139,
		136,
		135,
		140,
		151,
		160,
		171,
		136,
		140,
		155,
		160,
		164,
		181,
		185,
		-1,
		-1,
		162,
		158,
		193,
		205,
		177,
		217,
		-1,
		-1,
		135,
		128,
		138,
		131,
		144,
		147,
		132,
		134,
		152,
		165,
		159,
		169,
		184,
		179,
		-1,
		-1,
		-1,
		160,
		-1,
		176,
		-1,
		-1,
		167,
		208,
		155,
		137,
		133,
		119,
		126,
		120,
		122,
		127,
		146,
		141,
		150,
		155,
		159,
		182,
		171,
		210,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		126,
		145,
		140,
		146,
		151,
		142,
		170,
		167,
		-1,
		116,
		149,
		117,
		131,
		127,
		134,
		139,
		145,
		149,
		156,
		172,
		171,
		166,
		202,
		193,
		199,
		-1,
		-1,
		153,
		142,
		131,
		137,
		-1,
		119,
		142,
		132,
		122,
		128,
		-1,
		-1,
		134,
		131,
		129,
		109,
		115,
		120,
		123,
		161,
		137,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		107,
		144,
		137,
		105,
		113,
		144,
		-1,
		109,
		101,
		129,
		114,
		122,
		-1,
		-1,
		107,
		98,
		103,
		112,
		113,
		144,
		143,
		156,
		159,
		164,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		100,
		120,
		99,
		102,
		126,
		140,
		-1,
		100,
		-1,
		-1,
		145,
		132,
		116,
		106,
		103,
		150,
		126,
		121,
		127,
		129,
		153,
		144,
		169,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		89,
		100,
		93,
		-1,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		161,
		-1,
		143,
		-1,
		126,
		130,
		134,
		137,
		152,
		139,
		146,
		163,
		169,
		158,
		168,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		59,
		70,
		73,
		84,
		95,
		110,
		114,
		-1,
		84,
		120,
		130,
		-1,
		170,
		-1,
		-1,
		-1,
		140,
		147,
		139,
		155,
		151,
		151,
		147,
		151,
		163,
		170,
		180,
		182,
		174,
		178,
		191,
		202,
		205,
		55,
		64,
		114,
		59,
		59,
		80,
		89,
		110,
		80,
		77,
		114,
		119,
		134,
		139,
		163,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		158,
		168,
		151,
		153,
		157,
		171,
		183,
		191,
		181,
		179,
		173,
		205,
		-1,
		46,
		30,
		0,
		34,
		27,
		39,
		50,
		77,
		-1,
		-1,
		78,
		105,
		89,
		93,
		109,
		134,
		-1,
		170,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		165,
		176,
		198,
		187,
		188,
		178,
		188,
		201,
		30,
		23,
		19,
		23,
		36,
		58,
		46,
		-1,
		65,
		63,
		69,
		76,
		93,
		123,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		203,
		206,
		195,
		-1,
		185,
		158,
		163,
		188,
		195,
		196,
		190,
		184,
		191,
		190,
		198,
		206,
		39,
		49,
		38,
		41,
		37,
		50,
		51,
		50,
		62,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		215,
		196,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		180,
		180,
		183,
		187,
		182,
		193,
		185,
		189,
		206,
		-1,
		74,
		-1,
		82,
		64,
		78,
		93,
		101,
		-1,
		-1,
		-1,
		232,
		218,
		211,
		199,
		197,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		188,
		199,
		188,
		191,
		205,
		200,
		-1,
		-1,
		76,
		79,
		-1,
		-1,
		101,
		120,
		-1,
		223,
		212,
		197,
		189,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		192,
		198,
		201,
		190,
		194,
		206,
		-1,
		-1,
		83,
		84,
		89,
		-1,
		110,
		-1,
		225,
		-1,
		192,
		199,
		187,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		210,
		208,
		199,
		196,
		203,
		201,
		197,
		208,
		-1,
		-1,
		-1,
		140,
		117,
		232,
		223,
		206,
		186,
		178,
		198,
		-1,
		199,
		-1,
		174,
		175,
		202,
		204,
		221,
		215,
		199,
		214,
		204,
		195,
		204,
		146,
		-1,
		121,
		180,
		163,
		192,
		158,
		170,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		238,
		219,
		212,
		199,
		206,
		208,
		201,
		-1,
		-1,
		-1,
		136,
		135,
		134,
		145,
		153,
		151,
		169,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		228,
		224,
		217,
		219,
		209,
		-1,
		148,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		162,
		184,
		179,
		171,
		183,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		208,
		240,
		-1,
		155,
		-1,
		166,
		-1,
		-1,
		180,
		166,
		178,
		189,
		179,
		179,
		184,
		177,
		199,
		215,
		199,
		197,
		202,
		207,
		-1,
		165,
		166,
		-1,
		199,
		191,
		177,
		-1,
		170,
		-1,
		225,
		186,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		177,
		215,
		-1,
		-1,
		-1,
		200,
		180,
		220,
		204,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		191,
		214,
		-1,
		193,
		196,
		-1,
		187,
		193,
		222,
		199,
		203,
		-1,
		-1,
		-1,
		218,
		202,
		207,
		208,
		213,
		201,
		218,
		204,
		206,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		221,
		213,
		213,
		-1,
		-1,
		231,
		214,
		214,
		222,
		-1,
		-1,
		-1,
		243,
		224,
		-1,
		-1,
		222,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		232,
		-1,
		-1,
		-1,
		223,
		230,
		238,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		256,
		253,
		-1,
		-1,
		-1,
		237,
		232,
		-1,
		-1,
		209,
		210,
		-1,
		-1,
		-1,
		265,
		249,
		-1,
		236,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		270,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		283,
		275,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		298,
		289,
		-1,
		-1,
		261,
		268,
		290,
		293,
		293,
		-1,
		280
	],
	[
		-1,
		311,
		300,
		311,
		319,
		292,
		299,
		-1,
		318,
		322,
		288,
		282,
		321,
		290,
		296,
		307,
		-1,
		-1,
		-1,
		311,
		310,
		278,
		276,
		285,
		290,
		297,
		-1,
		296,
		-1,
		332,
		311,
		322,
		327,
		271,
		268,
		288,
		307,
		289,
		281,
		347,
		301,
		272,
		266,
		284,
		274,
		283,
		275,
		-1,
		272,
		262,
		284,
		263,
		274,
		266,
		-1,
		-1,
		266,
		267,
		273,
		259,
		265,
		261,
		-1,
		271,
		255,
		-1,
		-1,
		256,
		257,
		241,
		244,
		252,
		250,
		263,
		255,
		250,
		-1,
		-1,
		247,
		243,
		250,
		237,
		233,
		250,
		263,
		245,
		259,
		258,
		-1,
		253,
		271,
		276,
		244,
		242,
		226,
		224,
		242,
		244,
		250,
		250,
		-1,
		259,
		261,
		258,
		266,
		266,
		242,
		229,
		229,
		239,
		232,
		251,
		239,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		256,
		245,
		262,
		254,
		244,
		259,
		252,
		232,
		229,
		227,
		224,
		240,
		238,
		248,
		-1,
		-1,
		312,
		281,
		316,
		273,
		258,
		-1,
		252,
		238,
		244,
		248,
		242,
		235,
		249,
		245,
		-1,
		218,
		217,
		245,
		231,
		242,
		272,
		-1,
		-1,
		270,
		262,
		247,
		250,
		247,
		247,
		253,
		252,
		244,
		230,
		226,
		232,
		235,
		235,
		241,
		212,
		222,
		226,
		224,
		249,
		-1,
		-1,
		284,
		-1,
		-1,
		269,
		252,
		-1,
		235,
		242,
		242,
		259,
		249,
		270,
		263,
		254,
		246,
		240,
		228,
		230,
		227,
		240,
		228,
		209,
		234,
		238,
		219,
		240,
		235,
		-1,
		283,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		228,
		231,
		237,
		261,
		271,
		-1,
		275,
		263,
		264,
		249,
		246,
		233,
		221,
		234,
		219,
		226,
		225,
		213,
		211,
		241,
		216,
		238,
		235,
		254,
		259,
		253,
		262,
		-1,
		277,
		273,
		269,
		276,
		225,
		-1,
		-1,
		265,
		-1,
		279,
		292,
		287,
		260,
		263,
		250,
		241,
		228,
		217,
		228,
		217,
		214,
		222,
		205,
		220,
		211,
		210,
		228,
		238,
		246,
		250,
		256,
		-1,
		327,
		-1,
		269,
		253,
		255,
		227,
		248,
		-1,
		285,
		280,
		300,
		289,
		287,
		-1,
		259,
		256,
		246,
		224,
		209,
		226,
		218,
		216,
		218,
		200,
		214,
		205,
		223,
		230,
		228,
		232,
		252,
		264,
		287,
		277,
		-1,
		259,
		264,
		223,
		231,
		250,
		323,
		293,
		-1,
		288,
		-1,
		261,
		274,
		-1,
		230,
		226,
		208,
		209,
		204,
		219,
		211,
		196,
		193,
		211,
		214,
		221,
		225,
		241,
		-1,
		-1,
		272,
		276,
		265,
		216,
		235,
		259,
		296,
		286,
		275,
		274,
		-1,
		265,
		244,
		241,
		229,
		216,
		201,
		202,
		210,
		222,
		201,
		195,
		192,
		212,
		238,
		216,
		227,
		-1,
		-1,
		-1,
		297,
		-1,
		-1,
		242,
		213,
		237,
		279,
		304,
		297,
		285,
		250,
		250,
		244,
		-1,
		240,
		219,
		210,
		199,
		197,
		210,
		202,
		210,
		190,
		188,
		207,
		219,
		210,
		218,
		-1,
		-1,
		-1,
		272,
		261,
		262,
		211,
		234,
		268,
		283,
		269,
		274,
		249,
		242,
		236,
		253,
		236,
		217,
		206,
		198,
		187,
		198,
		206,
		204,
		186,
		195,
		201,
		225,
		206,
		212,
		-1,
		-1,
		279,
		269,
		253,
		255,
		252,
		225,
		232,
		264,
		274,
		276,
		-1,
		241,
		-1,
		230,
		226,
		211,
		206,
		203,
		190,
		189,
		203,
		203,
		193,
		188,
		195,
		230,
		230,
		196,
		216,
		219,
		-1,
		-1,
		-1,
		272,
		270,
		245,
		222,
		206,
		242,
		-1,
		246,
		247,
		-1,
		235,
		229,
		226,
		213,
		209,
		194,
		198,
		200,
		203,
		191,
		197,
		198,
		180,
		204,
		-1,
		204,
		198,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		268,
		247,
		240,
		260,
		201,
		253,
		-1,
		-1,
		231,
		224,
		-1,
		222,
		204,
		206,
		201,
		197,
		199,
		196,
		185,
		198,
		191,
		185,
		179,
		192,
		196,
		197,
		186,
		182,
		179,
		193,
		-1,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		221,
		-1,
		234,
		226,
		222,
		216,
		221,
		217,
		215,
		225,
		209,
		211,
		207,
		199,
		194,
		180,
		173,
		184,
		169,
		187,
		193,
		184,
		179,
		178,
		189,
		-1,
		288,
		274,
		245,
		-1,
		-1,
		234,
		-1,
		198,
		212,
		228,
		-1,
		256,
		235,
		253,
		231,
		227,
		218,
		216,
		217,
		187,
		192,
		194,
		182,
		185,
		174,
		177,
		169,
		191,
		188,
		172,
		174,
		183,
		-1,
		294,
		281,
		239,
		235,
		224,
		244,
		195,
		204,
		215,
		-1,
		-1,
		278,
		-1,
		229,
		234,
		232,
		230,
		206,
		181,
		188,
		206,
		179,
		174,
		179,
		168,
		168,
		163,
		182,
		168,
		166,
		181,
		197,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		210,
		197,
		191,
		-1,
		232,
		-1,
		256,
		244,
		231,
		213,
		253,
		-1,
		180,
		176,
		183,
		-1,
		199,
		-1,
		171,
		174,
		165,
		160,
		157,
		168,
		166,
		175,
		176,
		-1,
		244,
		229,
		222,
		212,
		226,
		197,
		-1,
		240,
		-1,
		-1,
		243,
		237,
		237,
		206,
		203,
		196,
		176,
		168,
		183,
		182,
		169,
		168,
		156,
		156,
		159,
		153,
		166,
		176,
		182,
		174,
		-1,
		-1,
		-1,
		249,
		201,
		209,
		185,
		206,
		-1,
		-1,
		304,
		260,
		246,
		-1,
		198,
		196,
		184,
		174,
		164,
		169,
		170,
		160,
		158,
		154,
		163,
		162,
		155,
		154,
		175,
		168,
		190,
		-1,
		-1,
		198,
		211,
		213,
		197,
		192,
		-1,
		-1,
		-1,
		250,
		251,
		217,
		196,
		185,
		-1,
		-1,
		168,
		161,
		155,
		158,
		146,
		166,
		173,
		161,
		148,
		163,
		173,
		181,
		180,
		-1,
		201,
		188,
		-1,
		-1,
		191,
		181,
		-1,
		-1,
		-1,
		-1,
		229,
		174,
		163,
		158,
		162,
		167,
		-1,
		141,
		152,
		145,
		164,
		171,
		163,
		148,
		142,
		153,
		168,
		185,
		-1,
		-1,
		205,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		186,
		180,
		151,
		144,
		148,
		-1,
		143,
		145,
		142,
		154,
		159,
		163,
		154,
		136,
		150,
		153,
		166,
		180,
		184,
		228,
		-1,
		158,
		-1,
		-1,
		-1,
		197,
		198,
		184,
		161,
		140,
		133,
		130,
		129,
		134,
		145,
		154,
		165,
		130,
		134,
		149,
		154,
		158,
		175,
		179,
		-1,
		-1,
		156,
		152,
		187,
		199,
		171,
		211,
		-1,
		-1,
		129,
		122,
		132,
		125,
		138,
		141,
		126,
		128,
		146,
		159,
		153,
		163,
		178,
		173,
		-1,
		-1,
		-1,
		154,
		-1,
		170,
		-1,
		-1,
		161,
		202,
		149,
		131,
		127,
		113,
		120,
		114,
		116,
		121,
		140,
		135,
		144,
		149,
		153,
		176,
		165,
		204,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		120,
		139,
		134,
		140,
		145,
		136,
		164,
		161,
		-1,
		110,
		143,
		111,
		125,
		121,
		128,
		133,
		139,
		143,
		150,
		166,
		165,
		160,
		196,
		187,
		193,
		-1,
		-1,
		147,
		136,
		125,
		131,
		-1,
		113,
		136,
		126,
		116,
		122,
		-1,
		-1,
		128,
		125,
		123,
		103,
		109,
		114,
		117,
		155,
		131,
		139,
		143,
		147,
		153,
		158,
		163,
		169,
		184,
		199,
		-1,
		101,
		138,
		131,
		99,
		107,
		138,
		-1,
		103,
		95,
		123,
		108,
		116,
		-1,
		-1,
		101,
		92,
		97,
		106,
		107,
		138,
		137,
		150,
		153,
		158,
		146,
		145,
		163,
		167,
		176,
		183,
		173,
		186,
		190,
		-1,
		94,
		114,
		93,
		96,
		120,
		134,
		-1,
		94,
		-1,
		-1,
		139,
		126,
		110,
		100,
		97,
		144,
		120,
		115,
		121,
		123,
		147,
		138,
		163,
		154,
		154,
		157,
		172,
		177,
		169,
		183,
		183,
		184,
		-1,
		83,
		94,
		87,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		155,
		-1,
		137,
		-1,
		120,
		124,
		128,
		131,
		146,
		133,
		140,
		157,
		163,
		152,
		162,
		158,
		159,
		168,
		179,
		191,
		190,
		191,
		55,
		64,
		67,
		78,
		89,
		104,
		108,
		-1,
		78,
		114,
		124,
		-1,
		164,
		-1,
		-1,
		-1,
		134,
		141,
		133,
		149,
		145,
		145,
		141,
		145,
		157,
		164,
		174,
		176,
		168,
		172,
		185,
		196,
		199,
		51,
		56,
		108,
		53,
		53,
		74,
		83,
		104,
		74,
		71,
		108,
		113,
		128,
		133,
		157,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		152,
		162,
		145,
		147,
		151,
		165,
		177,
		185,
		175,
		173,
		167,
		199,
		-1,
		48,
		43,
		30,
		0,
		21,
		33,
		44,
		71,
		-1,
		-1,
		72,
		99,
		83,
		87,
		103,
		128,
		-1,
		164,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		159,
		170,
		192,
		181,
		182,
		172,
		182,
		195,
		32,
		25,
		13,
		17,
		27,
		52,
		40,
		-1,
		59,
		57,
		63,
		70,
		87,
		117,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		197,
		200,
		189,
		-1,
		179,
		152,
		157,
		182,
		189,
		190,
		184,
		178,
		185,
		184,
		192,
		200,
		41,
		51,
		40,
		32,
		28,
		41,
		45,
		44,
		56,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		190,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		174,
		174,
		177,
		181,
		176,
		187,
		179,
		183,
		200,
		-1,
		65,
		-1,
		76,
		58,
		72,
		87,
		95,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		182,
		193,
		182,
		185,
		199,
		194,
		-1,
		-1,
		70,
		73,
		-1,
		-1,
		95,
		114,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		186,
		192,
		195,
		184,
		188,
		200,
		-1,
		-1,
		77,
		78,
		83,
		-1,
		104,
		-1,
		219,
		-1,
		186,
		193,
		181,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		204,
		202,
		193,
		190,
		197,
		195,
		191,
		202,
		-1,
		-1,
		-1,
		134,
		111,
		226,
		217,
		200,
		180,
		172,
		192,
		-1,
		193,
		-1,
		168,
		169,
		196,
		198,
		215,
		209,
		193,
		208,
		198,
		189,
		198,
		140,
		-1,
		115,
		174,
		157,
		186,
		152,
		164,
		214,
		-1,
		190,
		172,
		-1,
		200,
		190,
		232,
		213,
		206,
		193,
		200,
		202,
		195,
		-1,
		-1,
		-1,
		130,
		129,
		128,
		139,
		147,
		145,
		163,
		-1,
		202,
		184,
		163,
		180,
		180,
		171,
		179,
		222,
		218,
		211,
		213,
		203,
		-1,
		139,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		156,
		178,
		173,
		165,
		177,
		181,
		167,
		173,
		175,
		183,
		181,
		178,
		190,
		186,
		206,
		202,
		234,
		-1,
		146,
		-1,
		160,
		-1,
		-1,
		174,
		160,
		172,
		183,
		173,
		173,
		178,
		171,
		193,
		209,
		193,
		191,
		196,
		201,
		-1,
		156,
		157,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		219,
		180,
		-1,
		200,
		180,
		-1,
		202,
		198,
		-1,
		-1,
		168,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		214,
		198,
		-1,
		191,
		191,
		-1,
		-1,
		-1,
		182,
		205,
		-1,
		187,
		190,
		-1,
		181,
		187,
		216,
		193,
		197,
		-1,
		-1,
		-1,
		209,
		193,
		198,
		202,
		207,
		195,
		212,
		198,
		200,
		207,
		196,
		217,
		-1,
		-1,
		-1,
		212,
		207,
		207,
		-1,
		-1,
		225,
		208,
		208,
		216,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		216,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		223,
		-1,
		-1,
		-1,
		217,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		202,
		203,
		247,
		244,
		-1,
		-1,
		-1,
		231,
		226,
		-1,
		-1,
		200,
		201,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		230,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		264,
		-1,
		265,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		278,
		-1,
		250,
		252,
		-1,
		300,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		255,
		262,
		284,
		287,
		284,
		-1,
		274
	],
	[
		-1,
		300,
		289,
		300,
		308,
		281,
		288,
		-1,
		307,
		311,
		277,
		271,
		310,
		279,
		285,
		296,
		-1,
		-1,
		-1,
		300,
		299,
		267,
		265,
		274,
		279,
		286,
		-1,
		285,
		-1,
		321,
		300,
		311,
		316,
		260,
		257,
		277,
		296,
		278,
		270,
		336,
		290,
		261,
		255,
		273,
		263,
		272,
		264,
		-1,
		261,
		251,
		273,
		252,
		263,
		255,
		-1,
		-1,
		255,
		256,
		262,
		248,
		254,
		250,
		-1,
		260,
		244,
		-1,
		-1,
		245,
		246,
		230,
		233,
		241,
		239,
		252,
		244,
		239,
		-1,
		-1,
		236,
		232,
		239,
		226,
		222,
		239,
		252,
		234,
		248,
		247,
		-1,
		242,
		260,
		265,
		233,
		231,
		215,
		213,
		231,
		233,
		239,
		239,
		-1,
		238,
		240,
		247,
		255,
		255,
		231,
		218,
		218,
		228,
		221,
		240,
		228,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		235,
		234,
		251,
		243,
		233,
		248,
		241,
		221,
		218,
		216,
		213,
		229,
		227,
		237,
		-1,
		-1,
		291,
		260,
		295,
		252,
		237,
		-1,
		231,
		227,
		233,
		237,
		231,
		224,
		238,
		234,
		-1,
		207,
		206,
		234,
		220,
		231,
		251,
		-1,
		-1,
		249,
		241,
		226,
		229,
		226,
		226,
		242,
		241,
		233,
		219,
		215,
		221,
		224,
		224,
		230,
		201,
		211,
		215,
		213,
		238,
		-1,
		-1,
		273,
		-1,
		-1,
		248,
		231,
		-1,
		214,
		221,
		221,
		238,
		228,
		249,
		252,
		243,
		235,
		229,
		217,
		219,
		216,
		229,
		217,
		198,
		223,
		227,
		208,
		229,
		224,
		-1,
		272,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		207,
		210,
		216,
		240,
		250,
		-1,
		264,
		252,
		253,
		238,
		235,
		222,
		210,
		223,
		208,
		215,
		214,
		202,
		200,
		230,
		205,
		227,
		224,
		243,
		248,
		242,
		251,
		-1,
		256,
		252,
		248,
		255,
		204,
		-1,
		-1,
		244,
		-1,
		258,
		271,
		276,
		249,
		252,
		239,
		230,
		217,
		206,
		217,
		206,
		203,
		211,
		194,
		209,
		200,
		199,
		217,
		227,
		235,
		239,
		245,
		-1,
		306,
		-1,
		248,
		232,
		234,
		206,
		227,
		-1,
		264,
		259,
		279,
		278,
		271,
		-1,
		248,
		245,
		235,
		213,
		198,
		215,
		207,
		205,
		207,
		189,
		203,
		194,
		212,
		219,
		217,
		221,
		241,
		253,
		266,
		256,
		-1,
		238,
		243,
		202,
		210,
		229,
		302,
		277,
		-1,
		272,
		-1,
		250,
		263,
		-1,
		219,
		215,
		197,
		198,
		193,
		208,
		200,
		185,
		182,
		200,
		203,
		210,
		214,
		230,
		-1,
		-1,
		251,
		255,
		244,
		195,
		214,
		238,
		275,
		270,
		259,
		258,
		-1,
		249,
		233,
		230,
		218,
		205,
		190,
		191,
		199,
		211,
		190,
		184,
		181,
		201,
		227,
		205,
		216,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		221,
		192,
		216,
		258,
		288,
		281,
		269,
		234,
		234,
		228,
		-1,
		229,
		208,
		199,
		188,
		186,
		199,
		191,
		199,
		179,
		177,
		196,
		208,
		199,
		207,
		-1,
		-1,
		-1,
		251,
		240,
		241,
		190,
		213,
		247,
		267,
		253,
		258,
		233,
		226,
		220,
		242,
		225,
		206,
		195,
		187,
		176,
		187,
		195,
		193,
		175,
		184,
		190,
		214,
		195,
		201,
		-1,
		-1,
		258,
		248,
		232,
		234,
		231,
		204,
		211,
		243,
		258,
		255,
		-1,
		225,
		-1,
		214,
		215,
		200,
		195,
		192,
		179,
		178,
		192,
		192,
		182,
		177,
		184,
		219,
		219,
		185,
		205,
		208,
		-1,
		-1,
		-1,
		251,
		249,
		224,
		201,
		185,
		221,
		-1,
		225,
		226,
		-1,
		219,
		213,
		215,
		202,
		198,
		183,
		187,
		189,
		192,
		180,
		186,
		187,
		169,
		193,
		-1,
		193,
		187,
		195,
		185,
		173,
		-1,
		-1,
		-1,
		247,
		226,
		219,
		239,
		180,
		232,
		-1,
		-1,
		210,
		203,
		-1,
		206,
		193,
		195,
		190,
		186,
		188,
		185,
		174,
		187,
		180,
		174,
		168,
		181,
		185,
		186,
		175,
		171,
		168,
		182,
		-1,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		200,
		-1,
		213,
		205,
		201,
		195,
		201,
		206,
		204,
		214,
		198,
		200,
		196,
		188,
		183,
		169,
		162,
		173,
		158,
		176,
		182,
		173,
		168,
		167,
		178,
		-1,
		267,
		253,
		224,
		-1,
		-1,
		213,
		-1,
		177,
		191,
		207,
		-1,
		235,
		214,
		237,
		215,
		216,
		207,
		205,
		206,
		176,
		181,
		183,
		171,
		174,
		163,
		166,
		158,
		180,
		177,
		161,
		163,
		172,
		-1,
		273,
		260,
		218,
		214,
		203,
		223,
		174,
		183,
		194,
		-1,
		-1,
		267,
		-1,
		213,
		223,
		221,
		219,
		195,
		170,
		177,
		195,
		168,
		163,
		168,
		157,
		157,
		152,
		171,
		157,
		155,
		170,
		186,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		189,
		176,
		170,
		-1,
		211,
		-1,
		245,
		233,
		220,
		202,
		242,
		-1,
		169,
		165,
		172,
		-1,
		188,
		-1,
		160,
		163,
		154,
		149,
		146,
		157,
		155,
		164,
		165,
		-1,
		223,
		208,
		201,
		191,
		205,
		176,
		-1,
		219,
		-1,
		-1,
		232,
		226,
		226,
		195,
		192,
		185,
		165,
		157,
		172,
		171,
		158,
		157,
		145,
		145,
		148,
		142,
		155,
		165,
		171,
		163,
		-1,
		-1,
		-1,
		228,
		180,
		188,
		164,
		185,
		-1,
		-1,
		293,
		249,
		235,
		-1,
		187,
		185,
		173,
		163,
		153,
		158,
		159,
		149,
		147,
		143,
		152,
		151,
		144,
		143,
		164,
		157,
		179,
		-1,
		-1,
		177,
		190,
		192,
		178,
		181,
		-1,
		-1,
		-1,
		239,
		240,
		206,
		185,
		174,
		-1,
		-1,
		157,
		150,
		144,
		147,
		135,
		155,
		162,
		150,
		137,
		152,
		162,
		170,
		169,
		-1,
		180,
		167,
		-1,
		-1,
		180,
		170,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		156,
		-1,
		130,
		141,
		134,
		153,
		160,
		152,
		137,
		131,
		142,
		157,
		174,
		-1,
		-1,
		194,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		132,
		134,
		131,
		143,
		148,
		152,
		143,
		125,
		139,
		142,
		155,
		169,
		173,
		217,
		-1,
		147,
		-1,
		-1,
		-1,
		186,
		187,
		173,
		150,
		129,
		122,
		119,
		118,
		123,
		134,
		143,
		154,
		119,
		123,
		138,
		143,
		147,
		164,
		168,
		-1,
		-1,
		145,
		141,
		176,
		188,
		160,
		200,
		-1,
		-1,
		118,
		111,
		121,
		114,
		127,
		130,
		115,
		117,
		135,
		148,
		142,
		152,
		167,
		162,
		-1,
		-1,
		-1,
		143,
		-1,
		159,
		-1,
		-1,
		150,
		191,
		138,
		120,
		116,
		102,
		109,
		103,
		105,
		110,
		129,
		124,
		133,
		138,
		142,
		165,
		154,
		193,
		-1,
		-1,
		133,
		-1,
		-1,
		-1,
		109,
		128,
		123,
		129,
		134,
		125,
		153,
		150,
		-1,
		99,
		132,
		100,
		114,
		110,
		117,
		122,
		128,
		132,
		139,
		155,
		154,
		149,
		185,
		176,
		182,
		-1,
		-1,
		126,
		115,
		104,
		110,
		-1,
		102,
		125,
		115,
		105,
		111,
		-1,
		-1,
		117,
		114,
		112,
		92,
		98,
		103,
		106,
		144,
		120,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		80,
		117,
		110,
		78,
		86,
		117,
		-1,
		92,
		84,
		112,
		97,
		105,
		-1,
		-1,
		90,
		81,
		86,
		95,
		96,
		127,
		126,
		139,
		142,
		147,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		73,
		93,
		72,
		75,
		99,
		113,
		-1,
		83,
		-1,
		-1,
		128,
		115,
		99,
		89,
		86,
		133,
		109,
		104,
		110,
		112,
		136,
		127,
		152,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		62,
		73,
		66,
		-1,
		-1,
		-1,
		-1,
		77,
		-1,
		-1,
		144,
		-1,
		126,
		-1,
		109,
		113,
		117,
		120,
		135,
		122,
		129,
		146,
		152,
		141,
		151,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		50,
		43,
		46,
		57,
		68,
		83,
		87,
		-1,
		67,
		103,
		113,
		-1,
		153,
		-1,
		-1,
		-1,
		123,
		130,
		122,
		138,
		134,
		134,
		130,
		134,
		146,
		153,
		163,
		165,
		157,
		161,
		174,
		185,
		188,
		46,
		37,
		87,
		32,
		32,
		53,
		62,
		83,
		63,
		60,
		97,
		102,
		117,
		122,
		146,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		141,
		151,
		134,
		136,
		140,
		154,
		166,
		174,
		164,
		162,
		156,
		188,
		-1,
		39,
		38,
		27,
		24,
		0,
		12,
		23,
		50,
		-1,
		-1,
		61,
		88,
		72,
		76,
		92,
		117,
		-1,
		153,
		-1,
		-1,
		167,
		-1,
		-1,
		193,
		156,
		145,
		136,
		142,
		148,
		159,
		181,
		170,
		171,
		161,
		171,
		184,
		23,
		20,
		8,
		6,
		29,
		31,
		19,
		-1,
		48,
		46,
		52,
		59,
		76,
		106,
		-1,
		-1,
		169,
		160,
		-1,
		-1,
		186,
		189,
		178,
		-1,
		168,
		141,
		146,
		171,
		178,
		179,
		173,
		167,
		174,
		173,
		181,
		189,
		32,
		46,
		35,
		31,
		30,
		38,
		24,
		33,
		45,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		179,
		-1,
		-1,
		186,
		179,
		167,
		155,
		145,
		155,
		163,
		163,
		166,
		170,
		165,
		176,
		168,
		172,
		189,
		-1,
		66,
		-1,
		55,
		47,
		61,
		76,
		84,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		220,
		204,
		185,
		-1,
		155,
		168,
		199,
		167,
		172,
		167,
		171,
		182,
		171,
		174,
		188,
		183,
		-1,
		-1,
		59,
		62,
		-1,
		-1,
		84,
		103,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		192,
		188,
		-1,
		-1,
		156,
		181,
		170,
		178,
		173,
		175,
		181,
		184,
		173,
		177,
		189,
		-1,
		-1,
		66,
		67,
		72,
		-1,
		93,
		-1,
		208,
		-1,
		175,
		182,
		170,
		-1,
		-1,
		-1,
		194,
		157,
		178,
		188,
		193,
		191,
		182,
		179,
		186,
		184,
		180,
		191,
		-1,
		-1,
		-1,
		123,
		100,
		215,
		206,
		189,
		169,
		161,
		181,
		-1,
		182,
		-1,
		157,
		158,
		185,
		187,
		204,
		198,
		182,
		197,
		187,
		178,
		187,
		129,
		-1,
		104,
		163,
		146,
		175,
		141,
		153,
		203,
		-1,
		179,
		161,
		-1,
		189,
		179,
		221,
		202,
		195,
		182,
		189,
		191,
		184,
		-1,
		-1,
		-1,
		119,
		118,
		117,
		128,
		136,
		134,
		152,
		-1,
		191,
		173,
		152,
		169,
		169,
		160,
		168,
		211,
		207,
		200,
		202,
		192,
		-1,
		138,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		145,
		167,
		162,
		154,
		166,
		170,
		156,
		162,
		164,
		172,
		170,
		167,
		179,
		175,
		195,
		191,
		223,
		-1,
		145,
		-1,
		149,
		-1,
		-1,
		163,
		149,
		161,
		172,
		162,
		162,
		167,
		160,
		182,
		198,
		182,
		180,
		185,
		190,
		-1,
		155,
		156,
		-1,
		182,
		174,
		160,
		-1,
		153,
		-1,
		208,
		169,
		-1,
		189,
		169,
		-1,
		191,
		187,
		-1,
		-1,
		167,
		198,
		-1,
		-1,
		-1,
		183,
		163,
		203,
		187,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		181,
		204,
		-1,
		176,
		179,
		-1,
		170,
		176,
		205,
		182,
		186,
		-1,
		-1,
		-1,
		208,
		192,
		197,
		191,
		196,
		184,
		201,
		187,
		189,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		204,
		196,
		196,
		-1,
		-1,
		214,
		197,
		197,
		205,
		-1,
		-1,
		-1,
		226,
		207,
		-1,
		-1,
		205,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		215,
		-1,
		-1,
		-1,
		206,
		213,
		221,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		243,
		236,
		-1,
		-1,
		-1,
		220,
		215,
		-1,
		-1,
		196,
		197,
		-1,
		-1,
		-1,
		248,
		232,
		-1,
		219,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		253,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		266,
		258,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		281,
		272,
		-1,
		-1,
		244,
		251,
		273,
		276,
		280,
		-1,
		263
	],
	[
		-1,
		301,
		290,
		301,
		309,
		282,
		289,
		-1,
		308,
		312,
		278,
		272,
		311,
		280,
		286,
		297,
		-1,
		-1,
		-1,
		301,
		300,
		268,
		266,
		275,
		280,
		287,
		-1,
		286,
		-1,
		322,
		301,
		312,
		317,
		261,
		258,
		278,
		297,
		279,
		271,
		337,
		291,
		262,
		256,
		274,
		264,
		273,
		265,
		-1,
		262,
		252,
		274,
		253,
		264,
		256,
		-1,
		-1,
		256,
		257,
		263,
		249,
		255,
		251,
		-1,
		261,
		245,
		-1,
		-1,
		246,
		247,
		231,
		234,
		242,
		240,
		253,
		245,
		240,
		-1,
		-1,
		237,
		233,
		240,
		227,
		223,
		240,
		253,
		235,
		249,
		248,
		-1,
		239,
		257,
		266,
		234,
		232,
		216,
		214,
		232,
		234,
		240,
		240,
		-1,
		231,
		233,
		248,
		256,
		256,
		232,
		219,
		219,
		229,
		222,
		241,
		229,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		228,
		235,
		252,
		244,
		234,
		249,
		242,
		222,
		219,
		217,
		214,
		230,
		228,
		238,
		-1,
		-1,
		284,
		253,
		288,
		245,
		230,
		-1,
		224,
		228,
		234,
		238,
		232,
		225,
		239,
		235,
		-1,
		208,
		207,
		235,
		221,
		232,
		244,
		-1,
		-1,
		242,
		234,
		219,
		222,
		219,
		219,
		243,
		242,
		234,
		220,
		216,
		222,
		225,
		225,
		231,
		202,
		212,
		216,
		214,
		239,
		-1,
		-1,
		274,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		214,
		231,
		221,
		242,
		253,
		244,
		236,
		230,
		218,
		220,
		217,
		230,
		218,
		199,
		224,
		228,
		209,
		230,
		225,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		243,
		-1,
		264,
		253,
		254,
		239,
		236,
		223,
		211,
		224,
		209,
		216,
		215,
		203,
		201,
		231,
		206,
		228,
		225,
		244,
		249,
		243,
		252,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		251,
		264,
		271,
		250,
		253,
		240,
		231,
		218,
		207,
		218,
		207,
		204,
		212,
		195,
		210,
		201,
		200,
		218,
		228,
		236,
		240,
		246,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		252,
		272,
		273,
		264,
		-1,
		249,
		246,
		236,
		214,
		199,
		216,
		208,
		206,
		208,
		190,
		204,
		195,
		213,
		220,
		218,
		222,
		242,
		254,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		295,
		270,
		-1,
		265,
		-1,
		251,
		264,
		-1,
		220,
		216,
		198,
		199,
		194,
		209,
		201,
		186,
		183,
		201,
		204,
		211,
		215,
		231,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		263,
		252,
		251,
		-1,
		242,
		234,
		231,
		219,
		206,
		191,
		192,
		200,
		212,
		191,
		185,
		182,
		202,
		228,
		206,
		217,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		281,
		274,
		262,
		227,
		227,
		221,
		-1,
		230,
		209,
		200,
		189,
		187,
		200,
		192,
		200,
		180,
		178,
		197,
		209,
		200,
		208,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		183,
		206,
		240,
		260,
		246,
		251,
		226,
		219,
		213,
		243,
		226,
		207,
		196,
		188,
		177,
		188,
		196,
		194,
		176,
		185,
		191,
		215,
		196,
		202,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		197,
		204,
		236,
		251,
		248,
		-1,
		218,
		-1,
		207,
		215,
		201,
		196,
		193,
		180,
		179,
		193,
		193,
		183,
		178,
		185,
		220,
		220,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		244,
		242,
		217,
		194,
		178,
		214,
		-1,
		218,
		219,
		-1,
		212,
		206,
		212,
		203,
		199,
		184,
		188,
		190,
		193,
		181,
		187,
		188,
		170,
		194,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		240,
		219,
		212,
		232,
		173,
		225,
		-1,
		-1,
		203,
		196,
		-1,
		199,
		194,
		196,
		191,
		187,
		189,
		186,
		175,
		188,
		181,
		175,
		169,
		182,
		186,
		187,
		176,
		172,
		169,
		183,
		-1,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		193,
		-1,
		206,
		198,
		194,
		188,
		194,
		207,
		205,
		215,
		199,
		201,
		197,
		189,
		184,
		170,
		163,
		174,
		159,
		177,
		183,
		174,
		169,
		168,
		179,
		-1,
		260,
		246,
		217,
		-1,
		-1,
		206,
		-1,
		170,
		184,
		200,
		-1,
		228,
		207,
		230,
		208,
		217,
		208,
		206,
		207,
		177,
		182,
		184,
		172,
		175,
		164,
		167,
		159,
		181,
		178,
		162,
		164,
		173,
		-1,
		266,
		253,
		211,
		207,
		196,
		216,
		167,
		176,
		187,
		-1,
		-1,
		268,
		-1,
		206,
		223,
		222,
		220,
		196,
		171,
		178,
		196,
		169,
		164,
		169,
		158,
		158,
		153,
		172,
		158,
		156,
		171,
		187,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		182,
		169,
		163,
		-1,
		204,
		-1,
		246,
		234,
		221,
		203,
		242,
		-1,
		170,
		166,
		173,
		-1,
		189,
		-1,
		161,
		164,
		155,
		150,
		147,
		158,
		156,
		165,
		166,
		-1,
		216,
		201,
		194,
		184,
		198,
		169,
		-1,
		212,
		-1,
		-1,
		233,
		227,
		227,
		196,
		193,
		186,
		166,
		158,
		173,
		172,
		159,
		158,
		146,
		146,
		149,
		143,
		156,
		166,
		172,
		164,
		-1,
		-1,
		-1,
		221,
		173,
		181,
		157,
		178,
		-1,
		-1,
		294,
		250,
		236,
		-1,
		188,
		186,
		174,
		164,
		154,
		159,
		160,
		150,
		148,
		144,
		153,
		152,
		145,
		144,
		165,
		158,
		180,
		-1,
		-1,
		170,
		183,
		185,
		171,
		182,
		-1,
		-1,
		-1,
		240,
		241,
		207,
		186,
		175,
		-1,
		-1,
		158,
		151,
		145,
		148,
		136,
		156,
		163,
		151,
		138,
		153,
		163,
		171,
		170,
		-1,
		173,
		160,
		-1,
		-1,
		181,
		171,
		-1,
		-1,
		-1,
		-1,
		219,
		164,
		153,
		148,
		152,
		157,
		-1,
		131,
		142,
		135,
		154,
		161,
		153,
		138,
		132,
		143,
		158,
		175,
		-1,
		-1,
		195,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		176,
		170,
		141,
		134,
		138,
		-1,
		133,
		135,
		132,
		144,
		149,
		153,
		144,
		126,
		140,
		143,
		156,
		170,
		174,
		218,
		-1,
		148,
		-1,
		-1,
		-1,
		187,
		188,
		174,
		151,
		130,
		123,
		120,
		119,
		124,
		135,
		144,
		155,
		120,
		124,
		139,
		144,
		148,
		165,
		169,
		-1,
		-1,
		146,
		142,
		177,
		189,
		161,
		201,
		-1,
		-1,
		119,
		112,
		122,
		115,
		128,
		131,
		116,
		118,
		136,
		149,
		143,
		153,
		168,
		163,
		-1,
		-1,
		-1,
		144,
		-1,
		160,
		-1,
		-1,
		151,
		192,
		139,
		121,
		117,
		103,
		110,
		104,
		106,
		111,
		130,
		125,
		134,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		126,
		-1,
		-1,
		-1,
		110,
		129,
		124,
		130,
		135,
		126,
		154,
		151,
		-1,
		100,
		133,
		101,
		115,
		111,
		118,
		123,
		129,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		119,
		108,
		97,
		103,
		-1,
		103,
		126,
		116,
		106,
		112,
		-1,
		-1,
		118,
		115,
		113,
		93,
		99,
		104,
		107,
		145,
		121,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		73,
		110,
		103,
		71,
		79,
		110,
		-1,
		93,
		85,
		113,
		98,
		106,
		-1,
		-1,
		91,
		82,
		87,
		96,
		97,
		128,
		127,
		140,
		143,
		148,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		66,
		86,
		65,
		68,
		92,
		106,
		-1,
		84,
		-1,
		-1,
		129,
		116,
		100,
		90,
		87,
		134,
		110,
		105,
		111,
		113,
		137,
		128,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		55,
		66,
		59,
		-1,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		145,
		-1,
		127,
		-1,
		110,
		114,
		118,
		121,
		136,
		123,
		130,
		147,
		153,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		62,
		36,
		39,
		50,
		61,
		76,
		80,
		-1,
		68,
		104,
		114,
		-1,
		154,
		-1,
		-1,
		-1,
		124,
		131,
		123,
		139,
		135,
		135,
		131,
		135,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		58,
		49,
		80,
		25,
		25,
		46,
		55,
		76,
		64,
		61,
		98,
		103,
		118,
		123,
		147,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		142,
		152,
		135,
		137,
		141,
		155,
		167,
		175,
		165,
		163,
		157,
		189,
		-1,
		51,
		50,
		39,
		36,
		12,
		0,
		16,
		43,
		-1,
		-1,
		62,
		89,
		73,
		77,
		93,
		118,
		-1,
		154,
		-1,
		-1,
		168,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		149,
		160,
		182,
		171,
		172,
		162,
		172,
		185,
		35,
		32,
		20,
		18,
		41,
		24,
		12,
		-1,
		44,
		47,
		53,
		60,
		77,
		107,
		-1,
		-1,
		170,
		161,
		-1,
		-1,
		187,
		190,
		179,
		-1,
		169,
		142,
		147,
		172,
		179,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		44,
		58,
		47,
		43,
		42,
		47,
		17,
		34,
		41,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		180,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		164,
		164,
		167,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		78,
		-1,
		48,
		41,
		56,
		71,
		79,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		172,
		183,
		172,
		175,
		189,
		184,
		-1,
		-1,
		54,
		57,
		-1,
		-1,
		79,
		98,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		176,
		182,
		185,
		174,
		178,
		190,
		-1,
		-1,
		61,
		62,
		67,
		-1,
		88,
		-1,
		203,
		-1,
		170,
		177,
		165,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		194,
		192,
		183,
		180,
		187,
		185,
		181,
		192,
		-1,
		-1,
		-1,
		118,
		95,
		210,
		201,
		184,
		164,
		156,
		176,
		-1,
		183,
		-1,
		158,
		159,
		186,
		188,
		205,
		199,
		183,
		198,
		188,
		179,
		188,
		124,
		-1,
		99,
		158,
		141,
		170,
		136,
		148,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		222,
		203,
		196,
		183,
		190,
		192,
		185,
		-1,
		-1,
		-1,
		114,
		113,
		112,
		123,
		131,
		129,
		147,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		212,
		208,
		201,
		203,
		193,
		-1,
		150,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		140,
		162,
		157,
		149,
		161,
		170,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		192,
		224,
		-1,
		157,
		-1,
		144,
		-1,
		-1,
		158,
		144,
		156,
		167,
		157,
		157,
		162,
		160,
		182,
		199,
		183,
		181,
		186,
		191,
		-1,
		167,
		168,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		203,
		164,
		-1,
		189,
		169,
		-1,
		192,
		188,
		-1,
		-1,
		179,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		198,
		182,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		193,
		202,
		-1,
		171,
		174,
		-1,
		165,
		171,
		200,
		182,
		186,
		-1,
		-1,
		-1,
		220,
		204,
		202,
		186,
		191,
		179,
		196,
		182,
		184,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		199,
		191,
		191,
		-1,
		-1,
		209,
		192,
		192,
		205,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		200,
		-1,
		-1,
		205,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		210,
		-1,
		-1,
		-1,
		201,
		208,
		216,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		255,
		231,
		-1,
		-1,
		-1,
		215,
		215,
		-1,
		-1,
		208,
		209,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		219,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		248,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		244,
		251,
		273,
		276,
		292,
		-1,
		263
	],
	[
		-1,
		287,
		276,
		287,
		295,
		268,
		275,
		-1,
		296,
		298,
		264,
		258,
		297,
		268,
		274,
		285,
		-1,
		-1,
		-1,
		287,
		286,
		256,
		254,
		263,
		268,
		275,
		-1,
		278,
		-1,
		308,
		287,
		298,
		303,
		249,
		246,
		266,
		285,
		271,
		263,
		323,
		279,
		250,
		244,
		262,
		256,
		265,
		257,
		-1,
		250,
		240,
		262,
		245,
		256,
		248,
		-1,
		-1,
		244,
		245,
		251,
		241,
		247,
		243,
		-1,
		253,
		237,
		-1,
		-1,
		234,
		239,
		223,
		226,
		234,
		232,
		245,
		237,
		232,
		-1,
		-1,
		229,
		225,
		232,
		219,
		215,
		232,
		245,
		227,
		241,
		240,
		-1,
		223,
		241,
		250,
		226,
		224,
		208,
		206,
		224,
		226,
		232,
		232,
		-1,
		215,
		217,
		240,
		248,
		248,
		224,
		211,
		211,
		221,
		214,
		233,
		221,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		212,
		220,
		244,
		236,
		226,
		241,
		234,
		214,
		211,
		209,
		206,
		222,
		220,
		230,
		-1,
		-1,
		268,
		237,
		272,
		229,
		214,
		-1,
		208,
		220,
		226,
		230,
		224,
		217,
		231,
		227,
		-1,
		200,
		199,
		227,
		213,
		224,
		228,
		-1,
		-1,
		226,
		218,
		203,
		206,
		203,
		203,
		233,
		232,
		226,
		212,
		208,
		214,
		217,
		217,
		223,
		194,
		204,
		208,
		206,
		231,
		-1,
		-1,
		266,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		198,
		215,
		205,
		226,
		241,
		236,
		228,
		222,
		210,
		212,
		209,
		222,
		210,
		191,
		216,
		220,
		201,
		222,
		217,
		-1,
		265,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		227,
		-1,
		248,
		245,
		246,
		231,
		228,
		215,
		203,
		216,
		201,
		208,
		207,
		195,
		193,
		223,
		198,
		220,
		217,
		236,
		241,
		235,
		244,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		235,
		248,
		255,
		242,
		245,
		232,
		223,
		210,
		199,
		210,
		199,
		196,
		204,
		187,
		202,
		193,
		192,
		210,
		220,
		228,
		232,
		238,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		236,
		256,
		257,
		248,
		-1,
		241,
		238,
		228,
		206,
		191,
		208,
		200,
		198,
		200,
		182,
		196,
		187,
		205,
		212,
		210,
		214,
		234,
		246,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		279,
		254,
		-1,
		249,
		-1,
		241,
		256,
		-1,
		212,
		208,
		190,
		191,
		186,
		201,
		193,
		178,
		175,
		193,
		196,
		203,
		207,
		223,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		247,
		236,
		235,
		-1,
		226,
		226,
		223,
		211,
		198,
		183,
		184,
		192,
		204,
		183,
		177,
		174,
		194,
		220,
		198,
		209,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		265,
		258,
		246,
		211,
		211,
		205,
		-1,
		222,
		201,
		192,
		181,
		179,
		192,
		184,
		192,
		172,
		170,
		189,
		201,
		192,
		200,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		167,
		190,
		224,
		244,
		230,
		235,
		210,
		203,
		197,
		235,
		218,
		199,
		188,
		180,
		169,
		180,
		188,
		186,
		168,
		177,
		183,
		207,
		188,
		194,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		181,
		188,
		220,
		235,
		232,
		-1,
		202,
		-1,
		191,
		199,
		193,
		188,
		185,
		172,
		171,
		185,
		185,
		175,
		170,
		177,
		212,
		212,
		178,
		198,
		201,
		-1,
		-1,
		-1,
		228,
		226,
		201,
		178,
		162,
		198,
		-1,
		202,
		203,
		-1,
		196,
		190,
		196,
		195,
		191,
		176,
		180,
		182,
		185,
		173,
		179,
		180,
		162,
		186,
		-1,
		186,
		180,
		188,
		178,
		166,
		-1,
		-1,
		-1,
		224,
		203,
		196,
		216,
		157,
		209,
		-1,
		-1,
		187,
		180,
		-1,
		183,
		183,
		188,
		183,
		179,
		181,
		178,
		167,
		180,
		173,
		167,
		161,
		174,
		178,
		179,
		168,
		164,
		161,
		175,
		-1,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		177,
		-1,
		190,
		182,
		178,
		172,
		178,
		196,
		194,
		207,
		191,
		193,
		189,
		181,
		176,
		162,
		155,
		166,
		151,
		169,
		175,
		166,
		161,
		160,
		171,
		-1,
		244,
		230,
		201,
		-1,
		-1,
		190,
		-1,
		154,
		168,
		184,
		-1,
		212,
		191,
		214,
		192,
		206,
		200,
		198,
		199,
		169,
		174,
		176,
		164,
		167,
		156,
		159,
		151,
		173,
		170,
		154,
		156,
		165,
		-1,
		250,
		237,
		195,
		191,
		180,
		200,
		151,
		160,
		171,
		-1,
		-1,
		256,
		-1,
		190,
		207,
		214,
		212,
		188,
		163,
		170,
		188,
		161,
		156,
		161,
		150,
		150,
		145,
		164,
		150,
		148,
		163,
		179,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		166,
		153,
		147,
		-1,
		188,
		-1,
		234,
		224,
		208,
		193,
		226,
		-1,
		162,
		158,
		165,
		-1,
		181,
		-1,
		153,
		156,
		147,
		142,
		139,
		150,
		148,
		157,
		158,
		-1,
		200,
		185,
		178,
		168,
		182,
		153,
		-1,
		196,
		-1,
		-1,
		221,
		215,
		215,
		188,
		185,
		178,
		158,
		150,
		165,
		164,
		151,
		150,
		138,
		138,
		141,
		135,
		148,
		158,
		164,
		156,
		-1,
		-1,
		-1,
		205,
		157,
		165,
		141,
		162,
		-1,
		-1,
		283,
		238,
		224,
		-1,
		180,
		178,
		166,
		156,
		146,
		151,
		152,
		142,
		140,
		136,
		145,
		144,
		137,
		136,
		157,
		150,
		172,
		-1,
		-1,
		154,
		167,
		169,
		155,
		174,
		-1,
		-1,
		-1,
		230,
		233,
		199,
		178,
		167,
		-1,
		-1,
		150,
		143,
		137,
		140,
		128,
		148,
		155,
		143,
		130,
		145,
		155,
		163,
		162,
		-1,
		157,
		144,
		-1,
		-1,
		173,
		163,
		-1,
		-1,
		-1,
		-1,
		211,
		156,
		145,
		140,
		144,
		149,
		-1,
		123,
		134,
		127,
		146,
		153,
		145,
		130,
		124,
		135,
		150,
		167,
		-1,
		-1,
		187,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		168,
		162,
		133,
		126,
		130,
		-1,
		125,
		127,
		124,
		136,
		141,
		145,
		136,
		118,
		132,
		135,
		148,
		162,
		166,
		210,
		-1,
		140,
		-1,
		-1,
		-1,
		179,
		180,
		166,
		143,
		122,
		115,
		112,
		111,
		116,
		127,
		136,
		147,
		112,
		116,
		131,
		136,
		140,
		157,
		161,
		-1,
		-1,
		138,
		134,
		169,
		181,
		153,
		193,
		-1,
		-1,
		111,
		104,
		114,
		107,
		120,
		123,
		108,
		110,
		128,
		141,
		135,
		145,
		160,
		155,
		-1,
		-1,
		-1,
		136,
		-1,
		152,
		-1,
		-1,
		143,
		184,
		131,
		113,
		109,
		95,
		102,
		96,
		98,
		103,
		122,
		117,
		126,
		131,
		135,
		158,
		147,
		186,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		102,
		121,
		116,
		122,
		127,
		118,
		146,
		143,
		-1,
		92,
		125,
		93,
		107,
		103,
		110,
		115,
		121,
		125,
		132,
		148,
		147,
		142,
		178,
		169,
		175,
		-1,
		-1,
		103,
		92,
		81,
		87,
		-1,
		95,
		118,
		108,
		98,
		104,
		-1,
		-1,
		110,
		107,
		105,
		85,
		91,
		96,
		99,
		137,
		113,
		121,
		125,
		129,
		135,
		140,
		145,
		151,
		166,
		181,
		-1,
		57,
		94,
		87,
		55,
		63,
		94,
		-1,
		85,
		77,
		105,
		90,
		98,
		-1,
		-1,
		83,
		74,
		79,
		88,
		89,
		120,
		119,
		132,
		135,
		140,
		128,
		127,
		145,
		149,
		158,
		165,
		155,
		168,
		172,
		-1,
		50,
		70,
		49,
		52,
		76,
		90,
		-1,
		76,
		-1,
		-1,
		121,
		108,
		92,
		82,
		79,
		126,
		102,
		97,
		103,
		105,
		129,
		120,
		145,
		136,
		136,
		139,
		154,
		159,
		151,
		165,
		165,
		166,
		-1,
		39,
		50,
		43,
		-1,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		137,
		-1,
		119,
		-1,
		102,
		106,
		110,
		113,
		128,
		115,
		122,
		139,
		145,
		134,
		144,
		140,
		141,
		150,
		161,
		173,
		172,
		173,
		65,
		20,
		23,
		34,
		45,
		60,
		64,
		-1,
		60,
		96,
		106,
		-1,
		146,
		-1,
		-1,
		-1,
		116,
		123,
		115,
		131,
		127,
		127,
		123,
		127,
		139,
		146,
		156,
		158,
		150,
		154,
		167,
		178,
		181,
		61,
		59,
		64,
		9,
		9,
		30,
		39,
		60,
		56,
		53,
		90,
		95,
		110,
		115,
		139,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		134,
		144,
		127,
		129,
		133,
		147,
		159,
		167,
		157,
		155,
		149,
		181,
		-1,
		61,
		60,
		49,
		46,
		22,
		13,
		0,
		27,
		-1,
		-1,
		54,
		81,
		65,
		69,
		85,
		110,
		-1,
		146,
		-1,
		-1,
		160,
		-1,
		-1,
		186,
		149,
		138,
		129,
		135,
		141,
		152,
		174,
		163,
		164,
		154,
		164,
		177,
		45,
		42,
		30,
		28,
		51,
		8,
		4,
		-1,
		36,
		39,
		45,
		52,
		69,
		99,
		-1,
		-1,
		162,
		153,
		-1,
		-1,
		179,
		182,
		171,
		-1,
		161,
		134,
		139,
		164,
		171,
		172,
		166,
		160,
		167,
		166,
		174,
		182,
		54,
		68,
		57,
		53,
		52,
		60,
		9,
		26,
		33,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		172,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		156,
		156,
		159,
		163,
		158,
		169,
		161,
		165,
		182,
		-1,
		88,
		-1,
		40,
		33,
		48,
		63,
		71,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		192,
		160,
		165,
		160,
		164,
		175,
		164,
		167,
		181,
		176,
		-1,
		-1,
		46,
		49,
		-1,
		-1,
		71,
		90,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		149,
		174,
		163,
		171,
		166,
		168,
		174,
		177,
		166,
		170,
		182,
		-1,
		-1,
		53,
		54,
		59,
		-1,
		80,
		-1,
		195,
		-1,
		162,
		169,
		157,
		-1,
		-1,
		-1,
		187,
		150,
		171,
		181,
		186,
		184,
		175,
		172,
		179,
		177,
		173,
		184,
		-1,
		-1,
		-1,
		110,
		87,
		202,
		193,
		176,
		156,
		148,
		168,
		-1,
		175,
		-1,
		150,
		151,
		178,
		180,
		197,
		191,
		175,
		190,
		180,
		171,
		180,
		116,
		-1,
		91,
		150,
		133,
		162,
		128,
		140,
		196,
		-1,
		172,
		154,
		-1,
		182,
		172,
		214,
		195,
		188,
		175,
		182,
		184,
		177,
		-1,
		-1,
		-1,
		106,
		105,
		104,
		115,
		123,
		121,
		139,
		-1,
		184,
		166,
		145,
		162,
		162,
		153,
		161,
		204,
		200,
		193,
		195,
		185,
		-1,
		160,
		-1,
		-1,
		129,
		-1,
		-1,
		-1,
		132,
		154,
		149,
		141,
		153,
		162,
		149,
		155,
		157,
		165,
		163,
		160,
		172,
		168,
		188,
		184,
		216,
		-1,
		167,
		-1,
		136,
		-1,
		-1,
		150,
		136,
		148,
		159,
		149,
		149,
		154,
		152,
		174,
		191,
		175,
		173,
		178,
		183,
		-1,
		177,
		178,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		195,
		156,
		-1,
		181,
		161,
		-1,
		184,
		180,
		-1,
		-1,
		189,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		190,
		174,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		203,
		194,
		-1,
		163,
		166,
		-1,
		157,
		163,
		192,
		174,
		178,
		-1,
		-1,
		-1,
		219,
		200,
		194,
		178,
		183,
		171,
		188,
		174,
		176,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		191,
		183,
		183,
		-1,
		-1,
		201,
		184,
		184,
		197,
		-1,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		192,
		-1,
		-1,
		197,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		202,
		-1,
		-1,
		-1,
		193,
		200,
		208,
		-1,
		-1,
		-1,
		-1,
		220,
		221,
		248,
		223,
		-1,
		-1,
		-1,
		207,
		207,
		-1,
		-1,
		218,
		219,
		-1,
		-1,
		-1,
		235,
		219,
		-1,
		211,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		240,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		253,
		245,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		268,
		259,
		-1,
		-1,
		236,
		243,
		265,
		268,
		298,
		-1,
		255
	],
	[
		-1,
		292,
		281,
		292,
		300,
		273,
		280,
		-1,
		301,
		303,
		269,
		263,
		302,
		273,
		279,
		290,
		-1,
		-1,
		-1,
		292,
		291,
		261,
		259,
		268,
		273,
		280,
		-1,
		299,
		-1,
		313,
		292,
		303,
		308,
		254,
		251,
		271,
		290,
		292,
		284,
		328,
		284,
		255,
		249,
		267,
		272,
		286,
		278,
		-1,
		255,
		245,
		267,
		266,
		277,
		266,
		-1,
		-1,
		249,
		250,
		256,
		262,
		268,
		264,
		-1,
		274,
		258,
		-1,
		-1,
		239,
		252,
		244,
		247,
		255,
		253,
		266,
		258,
		253,
		-1,
		-1,
		240,
		244,
		253,
		240,
		236,
		253,
		266,
		248,
		262,
		261,
		-1,
		228,
		246,
		255,
		247,
		245,
		229,
		227,
		245,
		247,
		253,
		253,
		-1,
		220,
		222,
		251,
		257,
		269,
		245,
		232,
		232,
		242,
		235,
		254,
		242,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		217,
		225,
		251,
		250,
		246,
		262,
		255,
		235,
		232,
		230,
		227,
		243,
		241,
		251,
		-1,
		-1,
		273,
		242,
		277,
		234,
		219,
		-1,
		213,
		232,
		238,
		242,
		245,
		238,
		252,
		248,
		-1,
		221,
		220,
		248,
		234,
		245,
		233,
		-1,
		-1,
		231,
		223,
		208,
		211,
		208,
		208,
		238,
		237,
		242,
		233,
		229,
		235,
		238,
		238,
		244,
		215,
		225,
		229,
		227,
		252,
		-1,
		-1,
		287,
		-1,
		-1,
		230,
		213,
		-1,
		196,
		203,
		203,
		220,
		210,
		231,
		246,
		250,
		249,
		243,
		231,
		233,
		230,
		243,
		231,
		212,
		237,
		241,
		222,
		243,
		238,
		-1,
		286,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		189,
		192,
		198,
		222,
		232,
		-1,
		253,
		251,
		267,
		252,
		249,
		236,
		224,
		237,
		222,
		229,
		228,
		216,
		214,
		244,
		219,
		241,
		238,
		257,
		262,
		256,
		265,
		-1,
		238,
		234,
		230,
		237,
		186,
		-1,
		-1,
		226,
		-1,
		240,
		253,
		260,
		255,
		258,
		253,
		244,
		231,
		220,
		231,
		220,
		217,
		225,
		208,
		223,
		214,
		213,
		231,
		241,
		249,
		253,
		259,
		-1,
		288,
		-1,
		230,
		214,
		216,
		188,
		209,
		-1,
		246,
		241,
		261,
		262,
		253,
		-1,
		256,
		259,
		249,
		227,
		212,
		229,
		221,
		219,
		221,
		203,
		217,
		208,
		226,
		233,
		231,
		235,
		255,
		267,
		248,
		238,
		-1,
		220,
		225,
		184,
		192,
		211,
		284,
		259,
		-1,
		254,
		-1,
		246,
		271,
		-1,
		233,
		229,
		211,
		212,
		207,
		222,
		214,
		199,
		196,
		214,
		217,
		224,
		228,
		244,
		-1,
		-1,
		233,
		237,
		226,
		177,
		196,
		220,
		257,
		252,
		241,
		240,
		-1,
		231,
		247,
		244,
		232,
		219,
		204,
		205,
		213,
		225,
		204,
		198,
		195,
		215,
		241,
		219,
		230,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		203,
		174,
		198,
		240,
		270,
		263,
		251,
		216,
		216,
		210,
		-1,
		243,
		222,
		213,
		202,
		200,
		213,
		205,
		213,
		193,
		191,
		210,
		222,
		213,
		221,
		-1,
		-1,
		-1,
		233,
		222,
		223,
		172,
		195,
		229,
		249,
		235,
		240,
		215,
		208,
		202,
		254,
		239,
		218,
		209,
		201,
		190,
		201,
		209,
		207,
		189,
		198,
		204,
		228,
		209,
		215,
		-1,
		-1,
		240,
		230,
		214,
		216,
		213,
		186,
		193,
		225,
		240,
		237,
		-1,
		207,
		-1,
		196,
		204,
		203,
		209,
		206,
		193,
		192,
		206,
		206,
		196,
		191,
		198,
		233,
		233,
		199,
		219,
		222,
		-1,
		-1,
		-1,
		233,
		231,
		206,
		183,
		167,
		203,
		-1,
		207,
		208,
		-1,
		201,
		195,
		201,
		200,
		207,
		197,
		201,
		203,
		206,
		194,
		200,
		201,
		183,
		207,
		-1,
		207,
		201,
		209,
		199,
		187,
		-1,
		-1,
		-1,
		229,
		208,
		201,
		221,
		162,
		214,
		-1,
		-1,
		192,
		185,
		-1,
		188,
		188,
		195,
		204,
		200,
		202,
		199,
		188,
		201,
		194,
		188,
		182,
		195,
		199,
		200,
		189,
		185,
		182,
		196,
		-1,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		182,
		-1,
		195,
		187,
		183,
		177,
		183,
		201,
		199,
		219,
		211,
		214,
		210,
		202,
		197,
		183,
		176,
		187,
		172,
		190,
		196,
		187,
		182,
		181,
		192,
		-1,
		249,
		235,
		206,
		-1,
		-1,
		195,
		-1,
		159,
		173,
		189,
		-1,
		217,
		196,
		219,
		197,
		211,
		207,
		219,
		220,
		190,
		195,
		197,
		185,
		188,
		177,
		180,
		172,
		194,
		191,
		175,
		177,
		186,
		-1,
		255,
		242,
		200,
		196,
		185,
		205,
		156,
		165,
		176,
		-1,
		-1,
		261,
		-1,
		195,
		212,
		221,
		219,
		209,
		184,
		191,
		209,
		182,
		177,
		182,
		171,
		171,
		166,
		185,
		171,
		169,
		184,
		200,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		171,
		158,
		152,
		-1,
		193,
		-1,
		239,
		229,
		213,
		198,
		231,
		-1,
		183,
		179,
		186,
		-1,
		202,
		-1,
		174,
		177,
		168,
		163,
		160,
		171,
		169,
		178,
		179,
		-1,
		205,
		190,
		183,
		173,
		187,
		158,
		-1,
		201,
		-1,
		-1,
		226,
		220,
		220,
		204,
		206,
		199,
		179,
		171,
		186,
		185,
		172,
		171,
		159,
		159,
		162,
		156,
		169,
		179,
		185,
		177,
		-1,
		-1,
		-1,
		210,
		162,
		170,
		146,
		167,
		-1,
		-1,
		288,
		243,
		229,
		-1,
		201,
		199,
		187,
		177,
		167,
		172,
		173,
		163,
		161,
		157,
		166,
		165,
		158,
		157,
		178,
		171,
		193,
		-1,
		-1,
		159,
		172,
		174,
		160,
		179,
		-1,
		-1,
		-1,
		235,
		251,
		220,
		199,
		188,
		-1,
		-1,
		171,
		164,
		158,
		161,
		149,
		169,
		176,
		164,
		151,
		166,
		176,
		184,
		183,
		-1,
		162,
		149,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		-1,
		-1,
		232,
		177,
		166,
		161,
		165,
		170,
		-1,
		144,
		155,
		148,
		167,
		174,
		166,
		151,
		145,
		156,
		171,
		188,
		-1,
		-1,
		196,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		189,
		183,
		154,
		147,
		151,
		-1,
		146,
		148,
		145,
		157,
		162,
		166,
		157,
		139,
		153,
		156,
		169,
		183,
		187,
		219,
		-1,
		161,
		-1,
		-1,
		-1,
		200,
		201,
		187,
		164,
		143,
		136,
		133,
		132,
		137,
		148,
		157,
		168,
		133,
		137,
		152,
		157,
		161,
		178,
		182,
		-1,
		-1,
		159,
		155,
		190,
		202,
		174,
		214,
		-1,
		-1,
		132,
		125,
		135,
		128,
		141,
		144,
		129,
		131,
		149,
		162,
		156,
		166,
		181,
		176,
		-1,
		-1,
		-1,
		157,
		-1,
		173,
		-1,
		-1,
		164,
		205,
		152,
		134,
		130,
		116,
		123,
		117,
		119,
		124,
		143,
		138,
		147,
		152,
		156,
		179,
		168,
		207,
		-1,
		-1,
		115,
		-1,
		-1,
		-1,
		123,
		142,
		137,
		143,
		148,
		139,
		167,
		164,
		-1,
		113,
		146,
		114,
		128,
		124,
		131,
		136,
		142,
		146,
		153,
		169,
		168,
		163,
		199,
		190,
		196,
		-1,
		-1,
		108,
		97,
		86,
		92,
		-1,
		116,
		139,
		129,
		119,
		125,
		-1,
		-1,
		131,
		128,
		126,
		106,
		112,
		117,
		120,
		158,
		134,
		142,
		146,
		150,
		156,
		161,
		166,
		172,
		187,
		202,
		-1,
		62,
		99,
		92,
		60,
		68,
		99,
		-1,
		106,
		98,
		126,
		111,
		119,
		-1,
		-1,
		104,
		95,
		100,
		109,
		110,
		141,
		140,
		153,
		156,
		161,
		149,
		148,
		166,
		170,
		179,
		186,
		176,
		189,
		193,
		-1,
		55,
		75,
		54,
		57,
		81,
		95,
		-1,
		97,
		-1,
		-1,
		142,
		129,
		113,
		103,
		100,
		147,
		123,
		118,
		124,
		126,
		150,
		141,
		166,
		157,
		157,
		160,
		175,
		180,
		172,
		186,
		186,
		187,
		-1,
		44,
		55,
		48,
		-1,
		-1,
		-1,
		-1,
		91,
		-1,
		-1,
		158,
		-1,
		140,
		-1,
		123,
		127,
		131,
		134,
		149,
		136,
		143,
		160,
		166,
		155,
		165,
		161,
		162,
		171,
		182,
		194,
		193,
		194,
		90,
		45,
		28,
		39,
		50,
		65,
		69,
		-1,
		81,
		117,
		127,
		-1,
		167,
		-1,
		-1,
		-1,
		137,
		144,
		136,
		152,
		148,
		148,
		144,
		148,
		160,
		167,
		177,
		179,
		171,
		175,
		188,
		199,
		202,
		86,
		84,
		89,
		34,
		23,
		35,
		44,
		65,
		77,
		74,
		111,
		116,
		131,
		136,
		160,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		155,
		165,
		148,
		150,
		154,
		168,
		180,
		188,
		178,
		176,
		170,
		202,
		-1,
		86,
		85,
		74,
		71,
		47,
		38,
		25,
		0,
		-1,
		-1,
		75,
		102,
		86,
		90,
		106,
		131,
		-1,
		167,
		-1,
		-1,
		181,
		-1,
		-1,
		207,
		170,
		159,
		150,
		156,
		162,
		173,
		195,
		184,
		185,
		175,
		185,
		198,
		70,
		67,
		55,
		53,
		76,
		33,
		29,
		-1,
		57,
		60,
		66,
		73,
		90,
		120,
		-1,
		-1,
		183,
		174,
		-1,
		-1,
		200,
		203,
		192,
		-1,
		182,
		155,
		160,
		185,
		192,
		193,
		187,
		181,
		188,
		187,
		195,
		203,
		79,
		93,
		82,
		78,
		77,
		85,
		34,
		47,
		54,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		193,
		-1,
		-1,
		200,
		193,
		181,
		169,
		159,
		169,
		177,
		177,
		180,
		184,
		179,
		190,
		182,
		186,
		203,
		-1,
		113,
		-1,
		65,
		54,
		69,
		84,
		92,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		234,
		218,
		199,
		-1,
		169,
		182,
		213,
		181,
		186,
		181,
		185,
		196,
		185,
		188,
		202,
		197,
		-1,
		-1,
		67,
		70,
		-1,
		-1,
		92,
		111,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		206,
		202,
		-1,
		-1,
		170,
		195,
		184,
		192,
		187,
		189,
		195,
		198,
		187,
		191,
		203,
		-1,
		-1,
		74,
		75,
		80,
		-1,
		101,
		-1,
		216,
		-1,
		183,
		190,
		178,
		-1,
		-1,
		-1,
		208,
		171,
		192,
		202,
		207,
		205,
		196,
		193,
		200,
		198,
		194,
		205,
		-1,
		-1,
		-1,
		131,
		108,
		223,
		214,
		197,
		177,
		169,
		189,
		-1,
		196,
		-1,
		171,
		172,
		199,
		201,
		218,
		212,
		196,
		211,
		201,
		192,
		201,
		137,
		-1,
		112,
		171,
		154,
		183,
		149,
		161,
		217,
		-1,
		193,
		175,
		-1,
		203,
		193,
		235,
		216,
		209,
		196,
		203,
		205,
		198,
		-1,
		-1,
		-1,
		127,
		126,
		125,
		136,
		144,
		142,
		160,
		-1,
		205,
		187,
		166,
		183,
		183,
		174,
		182,
		225,
		221,
		214,
		216,
		206,
		-1,
		185,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		153,
		175,
		170,
		162,
		174,
		183,
		170,
		176,
		178,
		186,
		184,
		181,
		193,
		189,
		209,
		205,
		237,
		-1,
		192,
		-1,
		157,
		-1,
		-1,
		171,
		157,
		169,
		180,
		170,
		170,
		175,
		173,
		195,
		212,
		196,
		194,
		199,
		204,
		-1,
		202,
		203,
		-1,
		190,
		182,
		168,
		-1,
		161,
		-1,
		216,
		177,
		-1,
		202,
		182,
		-1,
		205,
		201,
		-1,
		-1,
		214,
		206,
		-1,
		-1,
		-1,
		191,
		171,
		211,
		195,
		-1,
		193,
		193,
		-1,
		-1,
		-1,
		228,
		215,
		-1,
		184,
		187,
		-1,
		178,
		184,
		213,
		195,
		199,
		-1,
		-1,
		-1,
		240,
		221,
		215,
		199,
		204,
		192,
		209,
		195,
		197,
		209,
		198,
		219,
		-1,
		-1,
		-1,
		212,
		204,
		204,
		-1,
		-1,
		222,
		205,
		205,
		218,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		213,
		-1,
		-1,
		218,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		223,
		-1,
		-1,
		-1,
		214,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		244,
		245,
		269,
		244,
		-1,
		-1,
		-1,
		228,
		228,
		-1,
		-1,
		243,
		244,
		-1,
		-1,
		-1,
		256,
		240,
		-1,
		232,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		261,
		-1,
		267,
		242,
		249,
		-1,
		-1,
		-1,
		-1,
		274,
		266,
		280,
		-1,
		252,
		254,
		-1,
		302,
		-1,
		-1,
		289,
		280,
		-1,
		-1,
		257,
		264,
		286,
		289,
		319,
		-1,
		276
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		286,
		275,
		286,
		294,
		267,
		274,
		-1,
		293,
		297,
		263,
		257,
		296,
		265,
		271,
		282,
		-1,
		-1,
		-1,
		286,
		285,
		253,
		251,
		260,
		265,
		272,
		-1,
		271,
		-1,
		307,
		286,
		297,
		302,
		246,
		243,
		263,
		282,
		264,
		256,
		322,
		276,
		247,
		241,
		259,
		249,
		258,
		250,
		-1,
		247,
		237,
		259,
		238,
		249,
		241,
		-1,
		-1,
		241,
		242,
		248,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		231,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		228,
		246,
		251,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		232,
		234,
		233,
		241,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		229,
		220,
		237,
		229,
		219,
		234,
		227,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		285,
		254,
		289,
		246,
		231,
		-1,
		225,
		213,
		219,
		223,
		217,
		210,
		224,
		220,
		-1,
		193,
		192,
		220,
		206,
		217,
		245,
		-1,
		-1,
		243,
		235,
		220,
		223,
		220,
		220,
		228,
		227,
		219,
		205,
		201,
		207,
		210,
		210,
		216,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		215,
		232,
		222,
		243,
		238,
		229,
		221,
		215,
		203,
		205,
		202,
		215,
		203,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		244,
		-1,
		250,
		238,
		239,
		224,
		221,
		208,
		196,
		209,
		194,
		201,
		200,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		252,
		265,
		262,
		235,
		238,
		225,
		216,
		203,
		192,
		203,
		192,
		189,
		197,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		253,
		273,
		264,
		262,
		-1,
		234,
		231,
		221,
		199,
		184,
		201,
		193,
		191,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		296,
		268,
		-1,
		263,
		-1,
		236,
		249,
		-1,
		205,
		201,
		183,
		184,
		179,
		194,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		261,
		250,
		249,
		-1,
		240,
		219,
		216,
		204,
		191,
		176,
		177,
		185,
		197,
		176,
		170,
		167,
		187,
		213,
		191,
		202,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		215,
		194,
		185,
		174,
		172,
		185,
		177,
		185,
		165,
		163,
		182,
		194,
		185,
		193,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		258,
		244,
		249,
		224,
		217,
		211,
		228,
		211,
		192,
		181,
		173,
		162,
		173,
		181,
		179,
		161,
		170,
		176,
		200,
		181,
		187,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		249,
		246,
		-1,
		216,
		-1,
		205,
		201,
		186,
		181,
		178,
		165,
		164,
		178,
		178,
		168,
		163,
		170,
		205,
		205,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		216,
		217,
		-1,
		210,
		204,
		201,
		188,
		184,
		169,
		173,
		175,
		178,
		166,
		172,
		173,
		155,
		179,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		201,
		194,
		-1,
		197,
		179,
		181,
		176,
		172,
		174,
		171,
		160,
		173,
		166,
		160,
		154,
		167,
		171,
		172,
		161,
		157,
		154,
		168,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		209,
		201,
		192,
		186,
		192,
		192,
		190,
		200,
		184,
		186,
		182,
		174,
		169,
		155,
		148,
		159,
		144,
		162,
		168,
		159,
		154,
		153,
		164,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		187,
		203,
		-1,
		226,
		205,
		228,
		206,
		202,
		193,
		191,
		192,
		162,
		167,
		169,
		157,
		160,
		149,
		152,
		144,
		166,
		163,
		147,
		149,
		158,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		174,
		190,
		-1,
		-1,
		242,
		-1,
		196,
		198,
		207,
		205,
		181,
		156,
		163,
		181,
		154,
		149,
		154,
		143,
		143,
		138,
		157,
		143,
		141,
		156,
		172,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		207,
		-1,
		220,
		208,
		195,
		177,
		217,
		-1,
		155,
		151,
		158,
		-1,
		174,
		-1,
		146,
		149,
		140,
		135,
		132,
		143,
		141,
		150,
		151,
		-1,
		214,
		199,
		192,
		182,
		196,
		164,
		-1,
		198,
		-1,
		-1,
		207,
		201,
		201,
		170,
		167,
		171,
		151,
		143,
		158,
		157,
		144,
		143,
		131,
		131,
		134,
		128,
		141,
		151,
		157,
		149,
		-1,
		-1,
		-1,
		219,
		182,
		188,
		160,
		164,
		-1,
		-1,
		268,
		224,
		210,
		-1,
		162,
		171,
		159,
		149,
		139,
		144,
		145,
		135,
		133,
		129,
		138,
		137,
		130,
		129,
		150,
		143,
		165,
		-1,
		-1,
		179,
		186,
		174,
		142,
		137,
		-1,
		-1,
		-1,
		214,
		200,
		188,
		160,
		160,
		-1,
		-1,
		143,
		136,
		130,
		133,
		121,
		141,
		148,
		136,
		123,
		138,
		148,
		156,
		155,
		-1,
		182,
		169,
		-1,
		-1,
		136,
		126,
		-1,
		-1,
		-1,
		-1,
		178,
		149,
		138,
		133,
		137,
		142,
		-1,
		116,
		127,
		120,
		139,
		146,
		138,
		123,
		117,
		128,
		143,
		160,
		-1,
		-1,
		150,
		-1,
		112,
		-1,
		-1,
		-1,
		-1,
		150,
		155,
		126,
		119,
		123,
		-1,
		118,
		120,
		117,
		129,
		134,
		138,
		129,
		111,
		125,
		128,
		141,
		155,
		159,
		173,
		-1,
		103,
		-1,
		-1,
		-1,
		142,
		143,
		159,
		136,
		115,
		108,
		105,
		104,
		109,
		120,
		129,
		140,
		105,
		109,
		124,
		129,
		133,
		150,
		154,
		-1,
		-1,
		101,
		97,
		132,
		144,
		116,
		186,
		-1,
		-1,
		104,
		97,
		107,
		100,
		113,
		116,
		101,
		103,
		121,
		134,
		128,
		138,
		153,
		148,
		-1,
		-1,
		-1,
		99,
		-1,
		115,
		-1,
		-1,
		106,
		177,
		124,
		106,
		102,
		88,
		95,
		89,
		91,
		96,
		115,
		110,
		119,
		124,
		128,
		151,
		140,
		179,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		65,
		84,
		79,
		85,
		90,
		81,
		139,
		136,
		-1,
		85,
		118,
		86,
		100,
		96,
		103,
		108,
		114,
		118,
		125,
		141,
		140,
		135,
		171,
		162,
		168,
		-1,
		-1,
		128,
		117,
		106,
		112,
		-1,
		58,
		81,
		71,
		61,
		67,
		-1,
		-1,
		103,
		100,
		98,
		78,
		84,
		89,
		92,
		130,
		106,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		82,
		119,
		112,
		80,
		88,
		119,
		-1,
		48,
		40,
		68,
		53,
		61,
		-1,
		-1,
		76,
		67,
		72,
		81,
		82,
		113,
		112,
		125,
		128,
		133,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		75,
		95,
		74,
		77,
		101,
		115,
		-1,
		39,
		-1,
		-1,
		84,
		74,
		82,
		75,
		72,
		119,
		95,
		90,
		96,
		98,
		122,
		113,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		64,
		75,
		68,
		-1,
		-1,
		-1,
		-1,
		33,
		-1,
		-1,
		100,
		-1,
		108,
		-1,
		95,
		99,
		103,
		106,
		121,
		108,
		115,
		132,
		138,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		89,
		45,
		48,
		59,
		70,
		85,
		89,
		-1,
		23,
		55,
		71,
		-1,
		109,
		-1,
		-1,
		-1,
		109,
		116,
		108,
		124,
		120,
		120,
		116,
		120,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		85,
		76,
		89,
		34,
		34,
		55,
		64,
		85,
		6,
		16,
		49,
		60,
		75,
		80,
		104,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		127,
		137,
		120,
		122,
		126,
		140,
		152,
		160,
		150,
		148,
		142,
		174,
		-1,
		78,
		77,
		66,
		63,
		39,
		30,
		25,
		52,
		-1,
		-1,
		0,
		40,
		30,
		34,
		50,
		75,
		-1,
		111,
		-1,
		-1,
		153,
		-1,
		-1,
		179,
		142,
		131,
		122,
		128,
		134,
		145,
		167,
		156,
		157,
		147,
		157,
		170,
		62,
		59,
		47,
		45,
		68,
		33,
		21,
		-1,
		16,
		4,
		10,
		17,
		34,
		64,
		-1,
		-1,
		127,
		118,
		-1,
		-1,
		172,
		175,
		164,
		-1,
		154,
		127,
		132,
		157,
		164,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		71,
		85,
		74,
		70,
		69,
		77,
		26,
		19,
		19,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		137,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		149,
		149,
		152,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		105,
		-1,
		57,
		25,
		45,
		60,
		68,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		185,
		153,
		158,
		153,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		43,
		46,
		-1,
		-1,
		70,
		89,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		142,
		167,
		156,
		164,
		159,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		50,
		53,
		58,
		-1,
		79,
		-1,
		194,
		-1,
		139,
		155,
		156,
		-1,
		-1,
		-1,
		180,
		143,
		164,
		174,
		179,
		177,
		168,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		109,
		86,
		201,
		192,
		175,
		155,
		147,
		167,
		-1,
		168,
		-1,
		143,
		144,
		171,
		173,
		190,
		184,
		168,
		183,
		173,
		164,
		173,
		115,
		-1,
		90,
		149,
		132,
		161,
		127,
		139,
		189,
		-1,
		165,
		147,
		-1,
		175,
		165,
		207,
		188,
		181,
		168,
		175,
		177,
		170,
		-1,
		-1,
		-1,
		105,
		104,
		103,
		114,
		122,
		120,
		138,
		-1,
		177,
		159,
		138,
		155,
		155,
		146,
		154,
		197,
		193,
		186,
		188,
		178,
		-1,
		177,
		-1,
		-1,
		128,
		-1,
		-1,
		-1,
		131,
		153,
		148,
		140,
		152,
		156,
		142,
		148,
		150,
		158,
		156,
		153,
		165,
		161,
		181,
		177,
		209,
		-1,
		184,
		-1,
		135,
		-1,
		-1,
		149,
		135,
		147,
		158,
		148,
		148,
		153,
		146,
		168,
		184,
		168,
		166,
		171,
		176,
		-1,
		194,
		195,
		-1,
		168,
		160,
		146,
		-1,
		139,
		-1,
		194,
		155,
		-1,
		175,
		155,
		-1,
		177,
		173,
		-1,
		-1,
		206,
		184,
		-1,
		-1,
		-1,
		169,
		149,
		189,
		173,
		-1,
		166,
		166,
		-1,
		-1,
		-1,
		209,
		193,
		-1,
		162,
		165,
		-1,
		156,
		162,
		191,
		168,
		172,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		177,
		182,
		170,
		187,
		173,
		175,
		182,
		171,
		192,
		-1,
		-1,
		-1,
		190,
		182,
		182,
		-1,
		-1,
		200,
		183,
		183,
		191,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		191,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		201,
		-1,
		-1,
		-1,
		192,
		199,
		207,
		-1,
		-1,
		-1,
		-1,
		222,
		223,
		247,
		222,
		-1,
		-1,
		-1,
		206,
		201,
		-1,
		-1,
		225,
		223,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		205,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		239,
		-1,
		240,
		215,
		222,
		-1,
		-1,
		-1,
		-1,
		252,
		244,
		253,
		-1,
		225,
		227,
		-1,
		275,
		-1,
		-1,
		267,
		258,
		-1,
		-1,
		230,
		237,
		259,
		262,
		297,
		-1,
		249
	],
	[
		-1,
		314,
		303,
		314,
		322,
		295,
		302,
		-1,
		323,
		325,
		291,
		285,
		324,
		295,
		301,
		312,
		-1,
		-1,
		-1,
		314,
		313,
		283,
		281,
		290,
		295,
		302,
		-1,
		304,
		-1,
		335,
		314,
		325,
		330,
		276,
		273,
		293,
		312,
		297,
		289,
		350,
		306,
		277,
		271,
		289,
		282,
		291,
		283,
		-1,
		277,
		267,
		289,
		271,
		282,
		274,
		-1,
		-1,
		271,
		272,
		278,
		267,
		273,
		269,
		-1,
		279,
		263,
		-1,
		-1,
		261,
		265,
		249,
		252,
		260,
		258,
		271,
		263,
		258,
		-1,
		-1,
		255,
		251,
		258,
		245,
		241,
		258,
		271,
		253,
		267,
		266,
		-1,
		250,
		268,
		277,
		252,
		250,
		234,
		232,
		250,
		252,
		258,
		258,
		-1,
		242,
		244,
		266,
		274,
		274,
		250,
		237,
		237,
		247,
		240,
		259,
		247,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		239,
		247,
		270,
		262,
		252,
		267,
		260,
		240,
		237,
		235,
		232,
		248,
		246,
		256,
		-1,
		-1,
		295,
		264,
		299,
		256,
		241,
		-1,
		235,
		246,
		252,
		256,
		250,
		243,
		257,
		253,
		-1,
		226,
		225,
		253,
		239,
		250,
		255,
		-1,
		-1,
		253,
		245,
		230,
		233,
		230,
		230,
		260,
		259,
		252,
		238,
		234,
		240,
		243,
		243,
		249,
		220,
		230,
		234,
		232,
		257,
		-1,
		-1,
		292,
		-1,
		-1,
		252,
		235,
		-1,
		218,
		225,
		225,
		242,
		232,
		253,
		268,
		262,
		254,
		248,
		236,
		238,
		235,
		248,
		236,
		217,
		242,
		246,
		227,
		248,
		243,
		-1,
		291,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		211,
		214,
		220,
		244,
		254,
		-1,
		275,
		271,
		272,
		257,
		254,
		241,
		229,
		242,
		227,
		234,
		233,
		221,
		219,
		249,
		224,
		246,
		243,
		262,
		267,
		261,
		270,
		-1,
		260,
		256,
		252,
		259,
		208,
		-1,
		-1,
		248,
		-1,
		262,
		275,
		279,
		268,
		271,
		258,
		249,
		236,
		225,
		236,
		225,
		222,
		230,
		213,
		228,
		219,
		218,
		236,
		246,
		254,
		258,
		264,
		-1,
		310,
		-1,
		252,
		236,
		238,
		210,
		231,
		-1,
		268,
		263,
		283,
		281,
		272,
		-1,
		267,
		264,
		254,
		232,
		217,
		234,
		226,
		224,
		226,
		208,
		222,
		213,
		231,
		238,
		236,
		240,
		260,
		272,
		270,
		260,
		-1,
		242,
		247,
		206,
		214,
		233,
		306,
		278,
		-1,
		273,
		-1,
		265,
		282,
		-1,
		238,
		234,
		216,
		217,
		212,
		227,
		219,
		204,
		201,
		219,
		222,
		229,
		233,
		249,
		-1,
		-1,
		255,
		259,
		248,
		199,
		218,
		242,
		279,
		271,
		260,
		259,
		-1,
		250,
		252,
		249,
		237,
		224,
		209,
		210,
		218,
		230,
		209,
		203,
		200,
		220,
		246,
		224,
		235,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		225,
		196,
		220,
		262,
		289,
		282,
		270,
		235,
		235,
		229,
		-1,
		248,
		227,
		218,
		207,
		205,
		218,
		210,
		218,
		198,
		196,
		215,
		227,
		218,
		226,
		-1,
		-1,
		-1,
		255,
		244,
		245,
		191,
		214,
		251,
		268,
		254,
		259,
		234,
		227,
		221,
		261,
		244,
		225,
		214,
		206,
		195,
		206,
		214,
		212,
		194,
		203,
		209,
		233,
		214,
		220,
		-1,
		-1,
		262,
		252,
		236,
		238,
		235,
		205,
		212,
		244,
		259,
		256,
		-1,
		226,
		-1,
		215,
		223,
		219,
		214,
		211,
		198,
		197,
		211,
		211,
		201,
		196,
		203,
		238,
		238,
		204,
		224,
		227,
		-1,
		-1,
		-1,
		255,
		250,
		225,
		202,
		186,
		222,
		-1,
		226,
		227,
		-1,
		220,
		214,
		220,
		219,
		217,
		202,
		206,
		208,
		211,
		199,
		205,
		206,
		188,
		212,
		-1,
		212,
		206,
		214,
		204,
		192,
		-1,
		-1,
		-1,
		248,
		227,
		220,
		240,
		181,
		233,
		-1,
		-1,
		211,
		204,
		-1,
		207,
		207,
		214,
		209,
		205,
		207,
		204,
		193,
		206,
		199,
		193,
		187,
		200,
		204,
		205,
		194,
		190,
		187,
		201,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		201,
		-1,
		219,
		211,
		202,
		196,
		202,
		220,
		218,
		233,
		217,
		219,
		215,
		207,
		202,
		188,
		181,
		192,
		177,
		195,
		201,
		192,
		187,
		186,
		197,
		-1,
		268,
		254,
		225,
		-1,
		-1,
		214,
		-1,
		178,
		197,
		213,
		-1,
		236,
		215,
		238,
		216,
		228,
		226,
		224,
		225,
		195,
		200,
		202,
		190,
		193,
		182,
		185,
		177,
		199,
		196,
		180,
		182,
		191,
		-1,
		274,
		261,
		219,
		215,
		204,
		224,
		175,
		184,
		200,
		-1,
		-1,
		252,
		-1,
		206,
		208,
		240,
		238,
		214,
		189,
		196,
		214,
		187,
		182,
		187,
		176,
		176,
		171,
		190,
		176,
		174,
		189,
		205,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		190,
		177,
		171,
		-1,
		217,
		-1,
		230,
		218,
		205,
		187,
		227,
		-1,
		188,
		184,
		191,
		-1,
		207,
		-1,
		179,
		182,
		173,
		168,
		165,
		176,
		174,
		183,
		184,
		-1,
		224,
		209,
		202,
		192,
		206,
		174,
		-1,
		208,
		-1,
		-1,
		217,
		211,
		211,
		180,
		177,
		204,
		184,
		176,
		191,
		190,
		177,
		176,
		164,
		164,
		167,
		161,
		174,
		184,
		190,
		182,
		-1,
		-1,
		-1,
		229,
		204,
		198,
		170,
		174,
		-1,
		-1,
		278,
		234,
		220,
		-1,
		172,
		204,
		192,
		182,
		172,
		177,
		178,
		168,
		166,
		162,
		171,
		170,
		163,
		162,
		183,
		176,
		198,
		-1,
		-1,
		203,
		196,
		184,
		152,
		147,
		-1,
		-1,
		-1,
		224,
		210,
		198,
		170,
		193,
		-1,
		-1,
		176,
		169,
		163,
		161,
		154,
		174,
		181,
		169,
		156,
		171,
		181,
		189,
		188,
		-1,
		206,
		193,
		-1,
		-1,
		146,
		136,
		-1,
		-1,
		-1,
		-1,
		188,
		169,
		164,
		159,
		163,
		175,
		-1,
		148,
		152,
		152,
		172,
		179,
		171,
		156,
		150,
		161,
		176,
		193,
		-1,
		-1,
		160,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		160,
		175,
		152,
		145,
		149,
		-1,
		146,
		145,
		149,
		155,
		167,
		171,
		162,
		144,
		158,
		161,
		174,
		188,
		192,
		183,
		-1,
		113,
		-1,
		-1,
		-1,
		152,
		153,
		185,
		162,
		141,
		134,
		131,
		137,
		141,
		153,
		162,
		173,
		138,
		142,
		157,
		162,
		166,
		183,
		187,
		-1,
		-1,
		111,
		107,
		142,
		154,
		126,
		212,
		-1,
		-1,
		130,
		123,
		133,
		133,
		146,
		149,
		134,
		136,
		154,
		167,
		161,
		171,
		186,
		181,
		-1,
		-1,
		-1,
		109,
		-1,
		125,
		-1,
		-1,
		116,
		203,
		150,
		132,
		128,
		114,
		128,
		122,
		124,
		129,
		148,
		143,
		152,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		75,
		94,
		89,
		95,
		100,
		91,
		165,
		162,
		-1,
		110,
		151,
		119,
		133,
		129,
		136,
		141,
		147,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		165,
		154,
		143,
		149,
		-1,
		68,
		91,
		81,
		71,
		77,
		-1,
		-1,
		124,
		121,
		124,
		111,
		117,
		122,
		125,
		163,
		139,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		119,
		156,
		149,
		117,
		125,
		156,
		-1,
		58,
		50,
		78,
		63,
		71,
		-1,
		-1,
		97,
		93,
		98,
		107,
		110,
		146,
		145,
		158,
		161,
		166,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		112,
		132,
		111,
		114,
		138,
		152,
		-1,
		49,
		-1,
		-1,
		94,
		84,
		92,
		88,
		92,
		145,
		121,
		116,
		129,
		131,
		155,
		146,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		101,
		112,
		105,
		-1,
		-1,
		-1,
		-1,
		43,
		-1,
		-1,
		110,
		-1,
		118,
		-1,
		111,
		115,
		129,
		132,
		154,
		141,
		148,
		165,
		171,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		126,
		82,
		85,
		96,
		107,
		122,
		126,
		-1,
		33,
		65,
		106,
		-1,
		119,
		-1,
		-1,
		-1,
		125,
		142,
		134,
		150,
		153,
		153,
		149,
		153,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		122,
		113,
		126,
		71,
		71,
		92,
		101,
		122,
		31,
		26,
		59,
		95,
		110,
		115,
		126,
		-1,
		-1,
		148,
		152,
		-1,
		-1,
		160,
		170,
		153,
		155,
		159,
		173,
		185,
		193,
		183,
		181,
		175,
		207,
		-1,
		115,
		114,
		103,
		100,
		76,
		67,
		62,
		89,
		-1,
		-1,
		37,
		0,
		65,
		69,
		85,
		110,
		-1,
		129,
		-1,
		-1,
		169,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		167,
		178,
		200,
		189,
		190,
		180,
		190,
		203,
		99,
		96,
		84,
		82,
		105,
		70,
		58,
		-1,
		53,
		41,
		47,
		52,
		69,
		99,
		-1,
		-1,
		145,
		136,
		-1,
		-1,
		188,
		195,
		197,
		-1,
		187,
		160,
		165,
		190,
		197,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		108,
		122,
		111,
		107,
		106,
		114,
		63,
		56,
		56,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		180,
		155,
		-1,
		-1,
		195,
		198,
		186,
		174,
		164,
		174,
		182,
		182,
		185,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		142,
		-1,
		94,
		62,
		82,
		97,
		105,
		-1,
		-1,
		-1,
		197,
		183,
		176,
		164,
		162,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		80,
		83,
		-1,
		-1,
		107,
		126,
		-1,
		188,
		177,
		162,
		154,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		87,
		90,
		95,
		-1,
		116,
		-1,
		212,
		-1,
		157,
		173,
		175,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		212,
		210,
		201,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		146,
		123,
		219,
		210,
		193,
		173,
		165,
		190,
		-1,
		201,
		-1,
		176,
		177,
		204,
		206,
		223,
		217,
		201,
		216,
		206,
		197,
		206,
		152,
		-1,
		127,
		186,
		169,
		179,
		164,
		176,
		222,
		-1,
		198,
		180,
		-1,
		208,
		198,
		240,
		221,
		214,
		201,
		208,
		210,
		203,
		-1,
		-1,
		-1,
		142,
		141,
		140,
		151,
		159,
		157,
		175,
		-1,
		210,
		192,
		171,
		188,
		188,
		179,
		187,
		230,
		226,
		219,
		221,
		211,
		-1,
		214,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		168,
		190,
		185,
		177,
		189,
		189,
		175,
		181,
		183,
		191,
		189,
		186,
		198,
		194,
		214,
		210,
		242,
		-1,
		221,
		-1,
		172,
		-1,
		-1,
		186,
		172,
		184,
		195,
		185,
		185,
		188,
		179,
		201,
		217,
		201,
		199,
		204,
		209,
		-1,
		231,
		232,
		-1,
		205,
		197,
		183,
		-1,
		176,
		-1,
		231,
		192,
		-1,
		208,
		188,
		-1,
		210,
		206,
		-1,
		-1,
		243,
		221,
		-1,
		-1,
		-1,
		206,
		186,
		226,
		210,
		-1,
		199,
		199,
		-1,
		-1,
		-1,
		246,
		230,
		-1,
		199,
		202,
		-1,
		193,
		199,
		228,
		201,
		205,
		-1,
		-1,
		-1,
		255,
		236,
		230,
		214,
		219,
		207,
		224,
		210,
		212,
		215,
		204,
		225,
		-1,
		-1,
		-1,
		227,
		219,
		219,
		-1,
		-1,
		237,
		220,
		220,
		224,
		-1,
		-1,
		-1,
		249,
		230,
		-1,
		-1,
		228,
		-1,
		-1,
		233,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		238,
		-1,
		-1,
		-1,
		229,
		236,
		244,
		-1,
		-1,
		-1,
		-1,
		259,
		260,
		284,
		259,
		-1,
		-1,
		-1,
		240,
		234,
		-1,
		-1,
		262,
		260,
		-1,
		-1,
		-1,
		268,
		252,
		-1,
		238,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		273,
		-1,
		273,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		286,
		278,
		286,
		-1,
		258,
		260,
		-1,
		308,
		-1,
		-1,
		301,
		292,
		-1,
		-1,
		263,
		270,
		292,
		295,
		331,
		-1,
		282
	],
	[
		-1,
		316,
		305,
		316,
		324,
		297,
		304,
		-1,
		323,
		327,
		293,
		287,
		326,
		295,
		301,
		312,
		-1,
		-1,
		-1,
		316,
		315,
		283,
		281,
		290,
		295,
		302,
		-1,
		301,
		-1,
		337,
		316,
		327,
		332,
		276,
		273,
		293,
		312,
		294,
		286,
		352,
		306,
		277,
		271,
		289,
		279,
		288,
		280,
		-1,
		277,
		267,
		289,
		268,
		279,
		271,
		-1,
		-1,
		271,
		272,
		278,
		264,
		270,
		266,
		-1,
		276,
		260,
		-1,
		-1,
		261,
		262,
		246,
		249,
		257,
		255,
		268,
		260,
		255,
		-1,
		-1,
		252,
		248,
		255,
		242,
		238,
		255,
		268,
		250,
		264,
		263,
		-1,
		258,
		276,
		281,
		249,
		247,
		231,
		229,
		247,
		249,
		255,
		255,
		-1,
		264,
		266,
		263,
		271,
		271,
		247,
		234,
		234,
		244,
		237,
		256,
		244,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		261,
		250,
		267,
		259,
		249,
		264,
		257,
		237,
		234,
		232,
		229,
		245,
		243,
		253,
		-1,
		-1,
		317,
		286,
		321,
		278,
		263,
		-1,
		257,
		243,
		249,
		253,
		247,
		240,
		254,
		250,
		-1,
		223,
		222,
		250,
		236,
		247,
		277,
		-1,
		-1,
		275,
		267,
		252,
		255,
		252,
		252,
		258,
		257,
		249,
		235,
		231,
		237,
		240,
		240,
		246,
		217,
		227,
		231,
		229,
		254,
		-1,
		-1,
		289,
		-1,
		-1,
		274,
		257,
		-1,
		240,
		247,
		247,
		264,
		254,
		275,
		268,
		259,
		251,
		245,
		233,
		235,
		232,
		245,
		233,
		214,
		239,
		243,
		224,
		245,
		240,
		-1,
		288,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		233,
		236,
		242,
		266,
		276,
		-1,
		280,
		268,
		269,
		254,
		251,
		238,
		226,
		239,
		224,
		231,
		230,
		218,
		216,
		246,
		221,
		243,
		240,
		259,
		264,
		258,
		267,
		-1,
		282,
		278,
		274,
		281,
		230,
		-1,
		-1,
		270,
		-1,
		284,
		297,
		292,
		265,
		268,
		255,
		246,
		233,
		222,
		233,
		222,
		219,
		227,
		210,
		225,
		216,
		215,
		233,
		243,
		251,
		255,
		261,
		-1,
		332,
		-1,
		274,
		258,
		260,
		232,
		253,
		-1,
		290,
		285,
		305,
		294,
		292,
		-1,
		264,
		261,
		251,
		229,
		214,
		231,
		223,
		221,
		223,
		205,
		219,
		210,
		228,
		235,
		233,
		237,
		257,
		269,
		292,
		282,
		-1,
		264,
		269,
		228,
		236,
		255,
		328,
		298,
		-1,
		293,
		-1,
		266,
		279,
		-1,
		235,
		231,
		213,
		214,
		209,
		224,
		216,
		201,
		198,
		216,
		219,
		226,
		230,
		246,
		-1,
		-1,
		277,
		281,
		270,
		221,
		240,
		264,
		301,
		291,
		280,
		279,
		-1,
		270,
		249,
		246,
		234,
		221,
		206,
		207,
		215,
		227,
		206,
		200,
		197,
		217,
		243,
		221,
		232,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		247,
		218,
		242,
		284,
		309,
		302,
		290,
		255,
		255,
		249,
		-1,
		245,
		224,
		215,
		204,
		202,
		215,
		207,
		215,
		195,
		193,
		212,
		224,
		215,
		223,
		-1,
		-1,
		-1,
		277,
		266,
		267,
		213,
		236,
		273,
		288,
		274,
		279,
		254,
		247,
		241,
		258,
		241,
		222,
		211,
		203,
		192,
		203,
		211,
		209,
		191,
		200,
		206,
		230,
		211,
		217,
		-1,
		-1,
		284,
		274,
		258,
		260,
		257,
		227,
		234,
		266,
		279,
		278,
		-1,
		246,
		-1,
		235,
		231,
		216,
		211,
		208,
		195,
		194,
		208,
		208,
		198,
		193,
		200,
		235,
		235,
		201,
		221,
		224,
		-1,
		-1,
		-1,
		277,
		272,
		247,
		224,
		208,
		244,
		-1,
		248,
		249,
		-1,
		240,
		234,
		231,
		218,
		214,
		199,
		203,
		205,
		208,
		196,
		202,
		203,
		185,
		209,
		-1,
		209,
		203,
		211,
		201,
		189,
		-1,
		-1,
		-1,
		270,
		249,
		242,
		262,
		203,
		255,
		-1,
		-1,
		233,
		226,
		-1,
		227,
		209,
		211,
		206,
		202,
		204,
		201,
		190,
		203,
		196,
		190,
		184,
		197,
		201,
		202,
		191,
		187,
		184,
		198,
		-1,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		223,
		-1,
		241,
		233,
		224,
		218,
		224,
		222,
		220,
		230,
		214,
		216,
		212,
		204,
		199,
		185,
		178,
		189,
		174,
		192,
		198,
		189,
		184,
		183,
		194,
		-1,
		290,
		276,
		247,
		-1,
		-1,
		236,
		-1,
		200,
		219,
		235,
		-1,
		258,
		237,
		258,
		236,
		232,
		223,
		221,
		222,
		192,
		197,
		199,
		187,
		190,
		179,
		182,
		174,
		196,
		193,
		177,
		179,
		188,
		-1,
		296,
		283,
		241,
		237,
		226,
		246,
		197,
		206,
		222,
		-1,
		-1,
		274,
		-1,
		228,
		230,
		237,
		235,
		211,
		186,
		193,
		211,
		184,
		179,
		184,
		173,
		173,
		168,
		187,
		173,
		171,
		186,
		202,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		212,
		199,
		193,
		-1,
		239,
		-1,
		252,
		240,
		227,
		209,
		249,
		-1,
		185,
		181,
		188,
		-1,
		204,
		-1,
		176,
		179,
		170,
		165,
		162,
		173,
		171,
		180,
		181,
		-1,
		246,
		231,
		224,
		214,
		228,
		196,
		-1,
		230,
		-1,
		-1,
		239,
		233,
		233,
		202,
		199,
		201,
		181,
		173,
		188,
		187,
		174,
		173,
		161,
		161,
		164,
		158,
		171,
		181,
		187,
		179,
		-1,
		-1,
		-1,
		251,
		212,
		220,
		192,
		196,
		-1,
		-1,
		300,
		256,
		242,
		-1,
		194,
		201,
		189,
		179,
		169,
		174,
		175,
		165,
		163,
		159,
		168,
		167,
		160,
		159,
		180,
		173,
		195,
		-1,
		-1,
		209,
		218,
		206,
		174,
		169,
		-1,
		-1,
		-1,
		246,
		232,
		220,
		192,
		190,
		-1,
		-1,
		173,
		166,
		160,
		163,
		151,
		171,
		178,
		166,
		153,
		168,
		178,
		186,
		185,
		-1,
		212,
		199,
		-1,
		-1,
		168,
		158,
		-1,
		-1,
		-1,
		-1,
		210,
		179,
		168,
		163,
		167,
		172,
		-1,
		146,
		157,
		150,
		169,
		176,
		168,
		153,
		147,
		158,
		173,
		190,
		-1,
		-1,
		182,
		-1,
		144,
		-1,
		-1,
		-1,
		-1,
		182,
		185,
		156,
		149,
		153,
		-1,
		148,
		150,
		147,
		159,
		164,
		168,
		159,
		141,
		155,
		158,
		171,
		185,
		189,
		205,
		-1,
		135,
		-1,
		-1,
		-1,
		174,
		175,
		189,
		166,
		145,
		138,
		135,
		134,
		139,
		150,
		159,
		170,
		135,
		139,
		154,
		159,
		163,
		180,
		184,
		-1,
		-1,
		133,
		129,
		164,
		176,
		148,
		216,
		-1,
		-1,
		134,
		127,
		137,
		130,
		143,
		146,
		131,
		133,
		151,
		164,
		158,
		168,
		183,
		178,
		-1,
		-1,
		-1,
		131,
		-1,
		147,
		-1,
		-1,
		138,
		207,
		154,
		136,
		132,
		118,
		125,
		119,
		121,
		126,
		145,
		140,
		149,
		154,
		158,
		181,
		170,
		209,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		97,
		116,
		111,
		117,
		122,
		113,
		169,
		166,
		-1,
		115,
		148,
		116,
		130,
		126,
		133,
		138,
		144,
		148,
		155,
		171,
		170,
		165,
		201,
		192,
		198,
		-1,
		-1,
		158,
		147,
		136,
		142,
		-1,
		90,
		113,
		103,
		93,
		99,
		-1,
		-1,
		133,
		130,
		128,
		108,
		114,
		119,
		122,
		160,
		136,
		144,
		148,
		152,
		158,
		163,
		168,
		174,
		189,
		204,
		-1,
		112,
		149,
		142,
		110,
		118,
		149,
		-1,
		80,
		72,
		100,
		85,
		93,
		-1,
		-1,
		106,
		97,
		102,
		111,
		112,
		143,
		142,
		155,
		158,
		163,
		151,
		150,
		168,
		172,
		181,
		188,
		178,
		191,
		195,
		-1,
		105,
		125,
		104,
		107,
		131,
		145,
		-1,
		71,
		-1,
		-1,
		116,
		106,
		114,
		105,
		102,
		149,
		125,
		120,
		126,
		128,
		152,
		143,
		168,
		159,
		159,
		162,
		177,
		182,
		174,
		188,
		188,
		189,
		-1,
		94,
		105,
		98,
		-1,
		-1,
		-1,
		-1,
		65,
		-1,
		-1,
		113,
		-1,
		140,
		-1,
		125,
		129,
		133,
		136,
		151,
		138,
		145,
		162,
		168,
		157,
		167,
		163,
		164,
		173,
		184,
		196,
		195,
		196,
		119,
		75,
		78,
		89,
		100,
		115,
		119,
		-1,
		55,
		88,
		60,
		-1,
		103,
		-1,
		-1,
		-1,
		139,
		146,
		138,
		154,
		150,
		150,
		146,
		150,
		162,
		169,
		179,
		181,
		173,
		177,
		190,
		201,
		204,
		115,
		106,
		119,
		64,
		64,
		85,
		94,
		115,
		39,
		48,
		82,
		49,
		64,
		69,
		93,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		157,
		167,
		150,
		152,
		156,
		170,
		182,
		190,
		180,
		178,
		172,
		204,
		-1,
		108,
		107,
		96,
		93,
		69,
		60,
		55,
		82,
		-1,
		-1,
		37,
		73,
		0,
		23,
		39,
		64,
		-1,
		100,
		-1,
		-1,
		183,
		-1,
		-1,
		209,
		172,
		161,
		152,
		158,
		164,
		175,
		197,
		186,
		187,
		177,
		187,
		200,
		92,
		89,
		77,
		75,
		98,
		63,
		51,
		-1,
		40,
		34,
		30,
		17,
		23,
		53,
		-1,
		-1,
		116,
		107,
		-1,
		-1,
		202,
		205,
		194,
		-1,
		184,
		157,
		162,
		187,
		194,
		195,
		189,
		183,
		190,
		189,
		197,
		205,
		101,
		115,
		104,
		100,
		99,
		107,
		56,
		49,
		43,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		126,
		-1,
		-1,
		202,
		195,
		183,
		171,
		161,
		171,
		179,
		179,
		182,
		186,
		181,
		192,
		184,
		188,
		205,
		-1,
		135,
		-1,
		87,
		55,
		75,
		90,
		98,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		236,
		220,
		201,
		-1,
		171,
		184,
		215,
		183,
		188,
		183,
		187,
		198,
		187,
		190,
		204,
		199,
		-1,
		-1,
		73,
		76,
		-1,
		-1,
		100,
		119,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		208,
		204,
		-1,
		-1,
		172,
		197,
		186,
		194,
		189,
		191,
		197,
		200,
		189,
		193,
		205,
		-1,
		-1,
		80,
		83,
		88,
		-1,
		109,
		-1,
		183,
		-1,
		128,
		144,
		146,
		-1,
		-1,
		-1,
		210,
		173,
		194,
		204,
		209,
		207,
		198,
		195,
		202,
		200,
		196,
		207,
		-1,
		-1,
		-1,
		139,
		116,
		190,
		181,
		164,
		144,
		136,
		161,
		-1,
		198,
		-1,
		173,
		174,
		201,
		203,
		220,
		214,
		198,
		213,
		203,
		194,
		203,
		145,
		-1,
		120,
		179,
		162,
		150,
		150,
		149,
		214,
		-1,
		195,
		177,
		-1,
		205,
		195,
		237,
		218,
		211,
		198,
		205,
		207,
		200,
		-1,
		-1,
		-1,
		135,
		134,
		133,
		144,
		152,
		150,
		150,
		-1,
		202,
		184,
		168,
		185,
		185,
		176,
		184,
		227,
		223,
		216,
		218,
		208,
		-1,
		207,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		161,
		183,
		163,
		151,
		165,
		172,
		167,
		169,
		180,
		188,
		186,
		183,
		195,
		191,
		211,
		207,
		239,
		-1,
		214,
		-1,
		165,
		-1,
		-1,
		179,
		165,
		177,
		174,
		163,
		161,
		164,
		162,
		184,
		214,
		198,
		196,
		201,
		206,
		-1,
		224,
		225,
		-1,
		198,
		190,
		176,
		-1,
		169,
		-1,
		209,
		170,
		-1,
		191,
		171,
		-1,
		207,
		203,
		-1,
		-1,
		236,
		214,
		-1,
		-1,
		-1,
		199,
		179,
		204,
		188,
		-1,
		182,
		182,
		-1,
		-1,
		-1,
		239,
		223,
		-1,
		192,
		195,
		-1,
		186,
		192,
		221,
		184,
		188,
		-1,
		-1,
		-1,
		248,
		229,
		223,
		207,
		212,
		200,
		217,
		203,
		205,
		198,
		187,
		208,
		-1,
		-1,
		-1,
		220,
		212,
		212,
		-1,
		-1,
		230,
		213,
		209,
		207,
		-1,
		-1,
		-1,
		242,
		223,
		-1,
		-1,
		221,
		-1,
		-1,
		226,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		231,
		-1,
		-1,
		-1,
		222,
		227,
		228,
		-1,
		-1,
		-1,
		-1,
		252,
		253,
		277,
		252,
		-1,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		255,
		253,
		-1,
		-1,
		-1,
		251,
		235,
		-1,
		221,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		256,
		-1,
		256,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		269,
		261,
		269,
		-1,
		241,
		243,
		-1,
		291,
		-1,
		-1,
		284,
		275,
		-1,
		-1,
		246,
		253,
		275,
		278,
		314,
		-1,
		265
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		327,
		331,
		297,
		291,
		330,
		299,
		305,
		316,
		-1,
		-1,
		-1,
		320,
		319,
		287,
		285,
		294,
		299,
		306,
		-1,
		305,
		-1,
		341,
		320,
		331,
		336,
		280,
		277,
		297,
		316,
		298,
		290,
		356,
		310,
		281,
		275,
		293,
		283,
		292,
		284,
		-1,
		281,
		271,
		293,
		272,
		283,
		275,
		-1,
		-1,
		275,
		276,
		282,
		268,
		274,
		270,
		-1,
		280,
		264,
		-1,
		-1,
		265,
		266,
		250,
		253,
		261,
		259,
		272,
		264,
		259,
		-1,
		-1,
		256,
		252,
		259,
		246,
		242,
		259,
		272,
		254,
		268,
		267,
		-1,
		262,
		280,
		285,
		253,
		251,
		235,
		233,
		251,
		253,
		259,
		259,
		-1,
		268,
		270,
		267,
		275,
		275,
		251,
		238,
		238,
		248,
		241,
		260,
		248,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		265,
		254,
		271,
		263,
		253,
		268,
		261,
		241,
		238,
		236,
		233,
		249,
		247,
		257,
		-1,
		-1,
		321,
		290,
		325,
		282,
		267,
		-1,
		261,
		247,
		253,
		257,
		251,
		244,
		258,
		254,
		-1,
		227,
		226,
		254,
		240,
		251,
		281,
		-1,
		-1,
		279,
		271,
		256,
		259,
		256,
		256,
		262,
		261,
		253,
		239,
		235,
		241,
		244,
		244,
		250,
		221,
		231,
		235,
		233,
		258,
		-1,
		-1,
		293,
		-1,
		-1,
		278,
		261,
		-1,
		244,
		251,
		251,
		268,
		258,
		279,
		272,
		263,
		255,
		249,
		237,
		239,
		236,
		249,
		237,
		218,
		243,
		247,
		228,
		249,
		244,
		-1,
		292,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		237,
		240,
		246,
		270,
		280,
		-1,
		284,
		272,
		273,
		258,
		255,
		242,
		230,
		243,
		228,
		235,
		234,
		222,
		220,
		250,
		225,
		247,
		244,
		263,
		268,
		262,
		271,
		-1,
		286,
		282,
		278,
		285,
		234,
		-1,
		-1,
		274,
		-1,
		288,
		301,
		296,
		269,
		272,
		259,
		250,
		237,
		226,
		237,
		226,
		223,
		231,
		214,
		229,
		220,
		219,
		237,
		247,
		255,
		259,
		265,
		-1,
		336,
		-1,
		278,
		262,
		264,
		236,
		257,
		-1,
		294,
		289,
		309,
		298,
		296,
		-1,
		268,
		265,
		255,
		233,
		218,
		235,
		227,
		225,
		227,
		209,
		223,
		214,
		232,
		239,
		237,
		241,
		261,
		273,
		296,
		286,
		-1,
		268,
		273,
		232,
		240,
		259,
		332,
		302,
		-1,
		297,
		-1,
		270,
		283,
		-1,
		239,
		235,
		217,
		218,
		213,
		228,
		220,
		205,
		202,
		220,
		223,
		230,
		234,
		250,
		-1,
		-1,
		281,
		285,
		274,
		225,
		244,
		268,
		305,
		295,
		284,
		283,
		-1,
		274,
		253,
		250,
		238,
		225,
		210,
		211,
		219,
		231,
		210,
		204,
		201,
		221,
		247,
		225,
		236,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		251,
		222,
		246,
		288,
		313,
		306,
		294,
		259,
		259,
		253,
		-1,
		249,
		228,
		219,
		208,
		206,
		219,
		211,
		219,
		199,
		197,
		216,
		228,
		219,
		227,
		-1,
		-1,
		-1,
		281,
		270,
		271,
		217,
		240,
		277,
		292,
		278,
		283,
		258,
		251,
		245,
		262,
		245,
		226,
		215,
		207,
		196,
		207,
		215,
		213,
		195,
		204,
		210,
		234,
		215,
		221,
		-1,
		-1,
		288,
		278,
		262,
		264,
		261,
		231,
		238,
		270,
		283,
		282,
		-1,
		250,
		-1,
		239,
		235,
		220,
		215,
		212,
		199,
		198,
		212,
		212,
		202,
		197,
		204,
		239,
		239,
		205,
		225,
		228,
		-1,
		-1,
		-1,
		281,
		276,
		251,
		228,
		212,
		248,
		-1,
		252,
		253,
		-1,
		244,
		238,
		235,
		222,
		218,
		203,
		207,
		209,
		212,
		200,
		206,
		207,
		189,
		213,
		-1,
		213,
		207,
		215,
		205,
		193,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		237,
		230,
		-1,
		231,
		213,
		215,
		210,
		206,
		208,
		205,
		194,
		207,
		200,
		194,
		188,
		201,
		205,
		206,
		195,
		191,
		188,
		202,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		245,
		237,
		228,
		222,
		228,
		226,
		224,
		234,
		218,
		220,
		216,
		208,
		203,
		189,
		182,
		193,
		178,
		196,
		202,
		193,
		188,
		187,
		198,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		223,
		239,
		-1,
		262,
		241,
		262,
		240,
		236,
		227,
		225,
		226,
		196,
		201,
		203,
		191,
		194,
		183,
		186,
		178,
		200,
		197,
		181,
		183,
		192,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		210,
		226,
		-1,
		-1,
		278,
		-1,
		232,
		234,
		241,
		239,
		215,
		190,
		197,
		215,
		188,
		183,
		188,
		177,
		177,
		172,
		191,
		177,
		175,
		190,
		206,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		243,
		-1,
		256,
		244,
		231,
		213,
		253,
		-1,
		189,
		185,
		192,
		-1,
		208,
		-1,
		180,
		183,
		174,
		169,
		166,
		177,
		175,
		184,
		185,
		-1,
		250,
		235,
		228,
		218,
		232,
		200,
		-1,
		234,
		-1,
		-1,
		243,
		237,
		237,
		206,
		203,
		205,
		185,
		177,
		192,
		191,
		178,
		177,
		165,
		165,
		168,
		162,
		175,
		185,
		191,
		183,
		-1,
		-1,
		-1,
		255,
		216,
		224,
		196,
		200,
		-1,
		-1,
		304,
		260,
		246,
		-1,
		198,
		205,
		193,
		183,
		173,
		178,
		179,
		169,
		167,
		163,
		172,
		171,
		164,
		163,
		184,
		177,
		199,
		-1,
		-1,
		213,
		222,
		210,
		178,
		173,
		-1,
		-1,
		-1,
		250,
		236,
		224,
		196,
		194,
		-1,
		-1,
		177,
		170,
		164,
		167,
		155,
		175,
		182,
		170,
		157,
		172,
		182,
		190,
		189,
		-1,
		216,
		203,
		-1,
		-1,
		172,
		162,
		-1,
		-1,
		-1,
		-1,
		214,
		183,
		172,
		167,
		171,
		176,
		-1,
		150,
		161,
		154,
		173,
		180,
		172,
		157,
		151,
		162,
		177,
		194,
		-1,
		-1,
		186,
		-1,
		148,
		-1,
		-1,
		-1,
		-1,
		186,
		189,
		160,
		153,
		157,
		-1,
		152,
		154,
		151,
		163,
		168,
		172,
		163,
		145,
		159,
		162,
		175,
		189,
		193,
		209,
		-1,
		139,
		-1,
		-1,
		-1,
		178,
		179,
		193,
		170,
		149,
		142,
		139,
		138,
		143,
		154,
		163,
		174,
		139,
		143,
		158,
		163,
		167,
		184,
		188,
		-1,
		-1,
		137,
		133,
		168,
		180,
		152,
		220,
		-1,
		-1,
		138,
		131,
		141,
		134,
		147,
		150,
		135,
		137,
		155,
		168,
		162,
		172,
		187,
		182,
		-1,
		-1,
		-1,
		135,
		-1,
		151,
		-1,
		-1,
		142,
		211,
		158,
		140,
		136,
		122,
		129,
		123,
		125,
		130,
		149,
		144,
		153,
		158,
		162,
		185,
		174,
		213,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		101,
		120,
		115,
		121,
		126,
		117,
		173,
		170,
		-1,
		119,
		152,
		120,
		134,
		130,
		137,
		142,
		148,
		152,
		159,
		175,
		174,
		169,
		205,
		196,
		202,
		-1,
		-1,
		162,
		151,
		140,
		146,
		-1,
		94,
		117,
		107,
		97,
		103,
		-1,
		-1,
		137,
		134,
		132,
		112,
		118,
		123,
		126,
		164,
		140,
		148,
		152,
		156,
		162,
		167,
		172,
		178,
		193,
		208,
		-1,
		116,
		153,
		146,
		114,
		122,
		153,
		-1,
		84,
		76,
		104,
		89,
		97,
		-1,
		-1,
		110,
		101,
		106,
		115,
		116,
		147,
		146,
		159,
		162,
		167,
		155,
		154,
		172,
		176,
		185,
		192,
		182,
		195,
		199,
		-1,
		109,
		129,
		108,
		111,
		135,
		149,
		-1,
		75,
		-1,
		-1,
		100,
		110,
		118,
		109,
		106,
		153,
		129,
		124,
		130,
		132,
		156,
		147,
		172,
		163,
		163,
		166,
		181,
		186,
		178,
		192,
		192,
		193,
		-1,
		98,
		109,
		102,
		-1,
		-1,
		-1,
		-1,
		69,
		-1,
		-1,
		90,
		-1,
		144,
		-1,
		129,
		133,
		137,
		140,
		155,
		142,
		149,
		166,
		172,
		161,
		171,
		167,
		168,
		177,
		188,
		200,
		199,
		200,
		123,
		79,
		82,
		93,
		104,
		119,
		123,
		-1,
		59,
		92,
		37,
		-1,
		80,
		-1,
		-1,
		-1,
		143,
		150,
		142,
		158,
		154,
		154,
		150,
		154,
		166,
		173,
		183,
		185,
		177,
		181,
		194,
		205,
		208,
		119,
		110,
		123,
		68,
		68,
		89,
		98,
		119,
		43,
		52,
		86,
		26,
		41,
		46,
		70,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		161,
		171,
		154,
		156,
		160,
		174,
		186,
		194,
		184,
		182,
		176,
		208,
		-1,
		112,
		111,
		100,
		97,
		73,
		64,
		59,
		86,
		-1,
		-1,
		41,
		77,
		23,
		0,
		16,
		41,
		-1,
		77,
		-1,
		-1,
		187,
		-1,
		-1,
		213,
		176,
		165,
		156,
		162,
		168,
		179,
		201,
		190,
		191,
		181,
		191,
		204,
		96,
		93,
		81,
		79,
		102,
		67,
		55,
		-1,
		44,
		38,
		34,
		21,
		1,
		30,
		-1,
		-1,
		93,
		84,
		-1,
		-1,
		206,
		209,
		198,
		-1,
		188,
		161,
		166,
		191,
		198,
		199,
		193,
		187,
		194,
		193,
		201,
		209,
		105,
		119,
		108,
		104,
		103,
		111,
		60,
		53,
		47,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		128,
		103,
		-1,
		-1,
		206,
		199,
		187,
		175,
		165,
		175,
		183,
		183,
		186,
		190,
		185,
		196,
		188,
		192,
		209,
		-1,
		139,
		-1,
		91,
		59,
		79,
		94,
		102,
		-1,
		-1,
		-1,
		145,
		131,
		124,
		112,
		110,
		-1,
		240,
		224,
		205,
		-1,
		175,
		188,
		219,
		187,
		192,
		187,
		191,
		202,
		191,
		194,
		208,
		203,
		-1,
		-1,
		77,
		80,
		-1,
		-1,
		104,
		123,
		-1,
		136,
		125,
		110,
		102,
		-1,
		-1,
		212,
		208,
		-1,
		-1,
		165,
		201,
		190,
		198,
		193,
		195,
		201,
		204,
		193,
		197,
		209,
		-1,
		-1,
		84,
		87,
		92,
		-1,
		113,
		-1,
		160,
		-1,
		105,
		121,
		123,
		-1,
		-1,
		-1,
		196,
		159,
		175,
		198,
		213,
		211,
		202,
		199,
		206,
		204,
		200,
		211,
		-1,
		-1,
		-1,
		143,
		120,
		167,
		158,
		141,
		121,
		113,
		138,
		-1,
		177,
		-1,
		152,
		155,
		180,
		207,
		221,
		207,
		202,
		216,
		207,
		198,
		205,
		149,
		-1,
		124,
		183,
		159,
		127,
		127,
		126,
		191,
		-1,
		174,
		156,
		-1,
		184,
		174,
		222,
		197,
		206,
		199,
		193,
		194,
		202,
		-1,
		-1,
		-1,
		139,
		138,
		137,
		148,
		147,
		132,
		127,
		-1,
		179,
		161,
		147,
		164,
		164,
		155,
		163,
		212,
		208,
		211,
		209,
		187,
		-1,
		211,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		158,
		167,
		140,
		128,
		142,
		149,
		144,
		146,
		159,
		167,
		165,
		162,
		174,
		170,
		190,
		186,
		218,
		-1,
		218,
		-1,
		169,
		-1,
		-1,
		174,
		160,
		162,
		151,
		140,
		138,
		141,
		139,
		161,
		191,
		177,
		175,
		180,
		185,
		-1,
		228,
		229,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		186,
		147,
		-1,
		168,
		148,
		-1,
		186,
		182,
		-1,
		-1,
		240,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		181,
		165,
		-1,
		159,
		159,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		187,
		190,
		-1,
		181,
		187,
		214,
		161,
		165,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		202,
		207,
		195,
		212,
		198,
		197,
		175,
		164,
		185,
		-1,
		-1,
		-1,
		215,
		207,
		207,
		-1,
		-1,
		222,
		205,
		186,
		184,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		212,
		-1,
		-1,
		218,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		226,
		-1,
		-1,
		-1,
		208,
		204,
		205,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		272,
		247,
		-1,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		198,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		233,
		-1,
		233,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		246,
		238,
		246,
		-1,
		218,
		220,
		-1,
		268,
		-1,
		-1,
		261,
		252,
		-1,
		-1,
		223,
		230,
		252,
		255,
		291,
		-1,
		242
	],
	[
		-1,
		336,
		325,
		336,
		344,
		317,
		324,
		-1,
		343,
		347,
		313,
		307,
		346,
		315,
		321,
		332,
		-1,
		-1,
		-1,
		336,
		335,
		303,
		301,
		310,
		315,
		322,
		-1,
		321,
		-1,
		357,
		336,
		347,
		352,
		296,
		293,
		313,
		332,
		314,
		306,
		372,
		326,
		297,
		291,
		309,
		299,
		308,
		300,
		-1,
		297,
		287,
		309,
		288,
		299,
		291,
		-1,
		-1,
		291,
		292,
		298,
		284,
		290,
		286,
		-1,
		296,
		280,
		-1,
		-1,
		281,
		282,
		266,
		269,
		277,
		275,
		288,
		280,
		275,
		-1,
		-1,
		272,
		268,
		275,
		262,
		258,
		275,
		288,
		270,
		284,
		283,
		-1,
		278,
		296,
		301,
		269,
		267,
		251,
		249,
		267,
		269,
		275,
		275,
		-1,
		284,
		286,
		283,
		291,
		291,
		267,
		254,
		254,
		264,
		257,
		276,
		264,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		281,
		270,
		287,
		279,
		269,
		284,
		277,
		257,
		254,
		252,
		249,
		265,
		263,
		273,
		-1,
		-1,
		337,
		306,
		341,
		298,
		283,
		-1,
		277,
		263,
		269,
		273,
		267,
		260,
		274,
		270,
		-1,
		243,
		242,
		270,
		256,
		267,
		297,
		-1,
		-1,
		295,
		287,
		272,
		275,
		272,
		272,
		278,
		277,
		269,
		255,
		251,
		257,
		260,
		260,
		266,
		237,
		247,
		251,
		249,
		274,
		-1,
		-1,
		309,
		-1,
		-1,
		294,
		277,
		-1,
		260,
		267,
		267,
		284,
		274,
		295,
		288,
		279,
		271,
		265,
		253,
		255,
		252,
		265,
		253,
		234,
		259,
		263,
		244,
		265,
		260,
		-1,
		308,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		253,
		256,
		262,
		286,
		296,
		-1,
		300,
		288,
		289,
		274,
		271,
		258,
		246,
		259,
		244,
		251,
		250,
		238,
		236,
		266,
		241,
		263,
		260,
		279,
		284,
		278,
		287,
		-1,
		302,
		298,
		294,
		301,
		250,
		-1,
		-1,
		290,
		-1,
		304,
		317,
		312,
		285,
		288,
		275,
		266,
		253,
		242,
		253,
		242,
		239,
		247,
		230,
		245,
		236,
		235,
		253,
		263,
		271,
		275,
		281,
		-1,
		352,
		-1,
		294,
		278,
		280,
		252,
		273,
		-1,
		310,
		305,
		325,
		314,
		312,
		-1,
		284,
		281,
		271,
		249,
		234,
		251,
		243,
		241,
		243,
		225,
		239,
		230,
		248,
		255,
		253,
		257,
		277,
		289,
		312,
		302,
		-1,
		284,
		289,
		248,
		256,
		275,
		348,
		318,
		-1,
		313,
		-1,
		286,
		299,
		-1,
		255,
		251,
		233,
		234,
		229,
		244,
		236,
		221,
		218,
		236,
		239,
		246,
		250,
		266,
		-1,
		-1,
		297,
		301,
		290,
		241,
		260,
		284,
		321,
		311,
		300,
		299,
		-1,
		290,
		269,
		266,
		254,
		241,
		226,
		227,
		235,
		247,
		226,
		220,
		217,
		237,
		263,
		241,
		252,
		-1,
		-1,
		-1,
		322,
		-1,
		-1,
		267,
		238,
		262,
		304,
		329,
		322,
		310,
		275,
		275,
		269,
		-1,
		265,
		244,
		235,
		224,
		222,
		235,
		227,
		235,
		215,
		213,
		232,
		244,
		235,
		243,
		-1,
		-1,
		-1,
		297,
		286,
		287,
		233,
		256,
		293,
		308,
		294,
		299,
		274,
		267,
		261,
		278,
		261,
		242,
		231,
		223,
		212,
		223,
		231,
		229,
		211,
		220,
		226,
		250,
		231,
		237,
		-1,
		-1,
		304,
		294,
		278,
		280,
		277,
		247,
		254,
		286,
		299,
		298,
		-1,
		266,
		-1,
		255,
		251,
		236,
		231,
		228,
		215,
		214,
		228,
		228,
		218,
		213,
		220,
		255,
		255,
		221,
		241,
		244,
		-1,
		-1,
		-1,
		297,
		292,
		267,
		244,
		228,
		264,
		-1,
		268,
		269,
		-1,
		260,
		254,
		251,
		238,
		234,
		219,
		223,
		225,
		228,
		216,
		222,
		223,
		205,
		229,
		-1,
		229,
		223,
		231,
		221,
		209,
		-1,
		-1,
		-1,
		290,
		269,
		262,
		282,
		223,
		275,
		-1,
		-1,
		253,
		246,
		-1,
		247,
		229,
		231,
		226,
		222,
		224,
		221,
		210,
		223,
		216,
		210,
		204,
		217,
		221,
		222,
		211,
		207,
		204,
		218,
		-1,
		309,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		243,
		-1,
		261,
		253,
		244,
		238,
		244,
		242,
		240,
		250,
		234,
		236,
		232,
		224,
		219,
		205,
		198,
		209,
		194,
		212,
		218,
		209,
		204,
		203,
		214,
		-1,
		310,
		296,
		267,
		-1,
		-1,
		256,
		-1,
		220,
		239,
		255,
		-1,
		278,
		257,
		278,
		256,
		252,
		243,
		241,
		242,
		212,
		217,
		219,
		207,
		210,
		199,
		202,
		194,
		216,
		213,
		197,
		199,
		208,
		-1,
		316,
		303,
		261,
		257,
		246,
		266,
		217,
		226,
		242,
		-1,
		-1,
		294,
		-1,
		248,
		250,
		257,
		255,
		231,
		206,
		213,
		231,
		204,
		199,
		204,
		193,
		193,
		188,
		207,
		193,
		191,
		206,
		222,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		232,
		219,
		213,
		-1,
		259,
		-1,
		272,
		260,
		247,
		229,
		269,
		-1,
		205,
		201,
		208,
		-1,
		224,
		-1,
		196,
		199,
		190,
		185,
		182,
		193,
		191,
		200,
		201,
		-1,
		266,
		251,
		244,
		234,
		248,
		216,
		-1,
		250,
		-1,
		-1,
		259,
		253,
		253,
		222,
		219,
		221,
		201,
		193,
		208,
		207,
		194,
		193,
		181,
		181,
		184,
		178,
		191,
		201,
		207,
		199,
		-1,
		-1,
		-1,
		271,
		232,
		240,
		212,
		216,
		-1,
		-1,
		320,
		276,
		262,
		-1,
		214,
		221,
		209,
		199,
		189,
		194,
		195,
		185,
		183,
		179,
		188,
		187,
		180,
		179,
		200,
		193,
		215,
		-1,
		-1,
		229,
		238,
		226,
		194,
		189,
		-1,
		-1,
		-1,
		266,
		252,
		240,
		212,
		210,
		-1,
		-1,
		193,
		186,
		180,
		183,
		171,
		191,
		198,
		186,
		173,
		188,
		198,
		206,
		205,
		-1,
		232,
		219,
		-1,
		-1,
		188,
		178,
		-1,
		-1,
		-1,
		-1,
		230,
		199,
		188,
		183,
		187,
		192,
		-1,
		166,
		177,
		170,
		189,
		196,
		188,
		173,
		167,
		178,
		193,
		210,
		-1,
		-1,
		202,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		202,
		205,
		176,
		169,
		173,
		-1,
		168,
		170,
		167,
		179,
		184,
		188,
		179,
		161,
		175,
		178,
		191,
		205,
		209,
		225,
		-1,
		155,
		-1,
		-1,
		-1,
		194,
		195,
		209,
		186,
		165,
		158,
		155,
		154,
		159,
		170,
		179,
		190,
		155,
		159,
		174,
		179,
		183,
		200,
		204,
		-1,
		-1,
		153,
		149,
		184,
		196,
		168,
		236,
		-1,
		-1,
		154,
		147,
		157,
		150,
		163,
		166,
		151,
		153,
		171,
		184,
		178,
		188,
		203,
		198,
		-1,
		-1,
		-1,
		151,
		-1,
		167,
		-1,
		-1,
		158,
		227,
		174,
		156,
		152,
		138,
		145,
		139,
		141,
		146,
		165,
		160,
		169,
		174,
		178,
		201,
		190,
		229,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		117,
		136,
		131,
		137,
		142,
		133,
		189,
		186,
		-1,
		135,
		168,
		136,
		150,
		146,
		153,
		158,
		164,
		168,
		175,
		191,
		190,
		185,
		221,
		212,
		218,
		-1,
		-1,
		178,
		167,
		156,
		162,
		-1,
		110,
		133,
		123,
		113,
		119,
		-1,
		-1,
		153,
		150,
		148,
		128,
		134,
		139,
		142,
		180,
		156,
		164,
		168,
		172,
		178,
		183,
		188,
		194,
		209,
		224,
		-1,
		132,
		169,
		162,
		130,
		138,
		169,
		-1,
		100,
		92,
		120,
		105,
		113,
		-1,
		-1,
		126,
		117,
		122,
		131,
		132,
		163,
		162,
		175,
		178,
		183,
		171,
		170,
		188,
		192,
		201,
		208,
		198,
		211,
		215,
		-1,
		125,
		145,
		124,
		127,
		151,
		165,
		-1,
		91,
		-1,
		-1,
		98,
		126,
		134,
		125,
		122,
		169,
		145,
		140,
		146,
		148,
		172,
		163,
		188,
		179,
		179,
		182,
		197,
		202,
		194,
		208,
		208,
		209,
		-1,
		114,
		125,
		118,
		-1,
		-1,
		-1,
		-1,
		85,
		-1,
		-1,
		88,
		-1,
		160,
		-1,
		145,
		149,
		153,
		156,
		171,
		158,
		165,
		182,
		188,
		177,
		187,
		183,
		184,
		193,
		204,
		216,
		215,
		216,
		139,
		95,
		98,
		109,
		120,
		135,
		139,
		-1,
		75,
		108,
		35,
		-1,
		78,
		-1,
		-1,
		-1,
		159,
		166,
		158,
		174,
		170,
		170,
		166,
		170,
		182,
		189,
		199,
		201,
		193,
		197,
		210,
		221,
		224,
		135,
		126,
		139,
		84,
		84,
		105,
		114,
		135,
		59,
		68,
		102,
		24,
		39,
		44,
		68,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		177,
		187,
		170,
		172,
		176,
		190,
		202,
		210,
		200,
		198,
		192,
		224,
		-1,
		128,
		127,
		116,
		113,
		89,
		80,
		75,
		102,
		-1,
		-1,
		57,
		93,
		39,
		16,
		0,
		25,
		-1,
		75,
		-1,
		-1,
		203,
		-1,
		-1,
		214,
		192,
		181,
		172,
		178,
		184,
		195,
		217,
		206,
		207,
		197,
		207,
		220,
		112,
		109,
		97,
		95,
		118,
		83,
		71,
		-1,
		60,
		54,
		50,
		37,
		17,
		14,
		-1,
		-1,
		91,
		82,
		-1,
		-1,
		212,
		210,
		199,
		-1,
		189,
		171,
		176,
		206,
		208,
		210,
		209,
		203,
		210,
		209,
		217,
		225,
		121,
		135,
		124,
		120,
		119,
		127,
		76,
		69,
		63,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		126,
		101,
		-1,
		-1,
		207,
		200,
		188,
		176,
		166,
		176,
		193,
		193,
		196,
		201,
		201,
		212,
		204,
		208,
		223,
		-1,
		155,
		-1,
		107,
		75,
		95,
		110,
		118,
		-1,
		-1,
		-1,
		143,
		129,
		122,
		110,
		108,
		-1,
		241,
		225,
		206,
		-1,
		176,
		189,
		229,
		197,
		202,
		197,
		207,
		218,
		207,
		210,
		216,
		219,
		-1,
		-1,
		93,
		96,
		-1,
		-1,
		120,
		139,
		-1,
		134,
		123,
		108,
		100,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		163,
		201,
		200,
		208,
		203,
		208,
		217,
		216,
		209,
		213,
		213,
		-1,
		-1,
		100,
		103,
		108,
		-1,
		129,
		-1,
		158,
		-1,
		103,
		119,
		121,
		-1,
		-1,
		-1,
		194,
		157,
		173,
		196,
		222,
		220,
		211,
		204,
		211,
		214,
		207,
		213,
		-1,
		-1,
		-1,
		159,
		136,
		165,
		156,
		139,
		119,
		111,
		136,
		-1,
		175,
		-1,
		150,
		153,
		178,
		217,
		219,
		205,
		201,
		214,
		208,
		205,
		203,
		165,
		-1,
		140,
		193,
		157,
		125,
		125,
		124,
		189,
		-1,
		172,
		154,
		-1,
		182,
		172,
		220,
		195,
		204,
		197,
		191,
		192,
		200,
		-1,
		-1,
		-1,
		155,
		154,
		153,
		147,
		145,
		130,
		125,
		-1,
		177,
		159,
		145,
		162,
		162,
		153,
		161,
		210,
		206,
		209,
		207,
		185,
		-1,
		227,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		156,
		165,
		138,
		126,
		140,
		147,
		142,
		144,
		157,
		165,
		163,
		160,
		172,
		168,
		188,
		184,
		216,
		-1,
		234,
		-1,
		185,
		-1,
		-1,
		172,
		158,
		160,
		149,
		138,
		136,
		139,
		137,
		159,
		189,
		175,
		173,
		178,
		183,
		-1,
		244,
		245,
		-1,
		191,
		183,
		169,
		-1,
		162,
		-1,
		184,
		145,
		-1,
		166,
		146,
		-1,
		184,
		180,
		-1,
		-1,
		247,
		207,
		-1,
		-1,
		-1,
		192,
		172,
		179,
		163,
		-1,
		157,
		157,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		185,
		188,
		-1,
		179,
		185,
		212,
		159,
		163,
		-1,
		-1,
		-1,
		241,
		222,
		216,
		200,
		205,
		193,
		210,
		196,
		195,
		173,
		162,
		183,
		-1,
		-1,
		-1,
		213,
		205,
		205,
		-1,
		-1,
		220,
		203,
		184,
		182,
		-1,
		-1,
		-1,
		235,
		216,
		-1,
		-1,
		210,
		-1,
		-1,
		216,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		224,
		-1,
		-1,
		-1,
		206,
		202,
		203,
		-1,
		-1,
		-1,
		-1,
		245,
		246,
		270,
		245,
		-1,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		248,
		246,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		196,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		231,
		-1,
		231,
		206,
		213,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		244,
		-1,
		216,
		218,
		-1,
		266,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		221,
		228,
		250,
		253,
		289,
		-1,
		240
	],
	[
		-1,
		363,
		352,
		363,
		371,
		344,
		351,
		-1,
		370,
		374,
		340,
		334,
		373,
		342,
		348,
		359,
		-1,
		-1,
		-1,
		363,
		362,
		330,
		328,
		337,
		342,
		349,
		-1,
		348,
		-1,
		384,
		363,
		374,
		379,
		323,
		320,
		340,
		359,
		341,
		333,
		399,
		353,
		324,
		318,
		336,
		326,
		335,
		327,
		-1,
		324,
		314,
		336,
		315,
		326,
		318,
		-1,
		-1,
		318,
		319,
		325,
		311,
		317,
		313,
		-1,
		323,
		307,
		-1,
		-1,
		308,
		309,
		293,
		296,
		304,
		302,
		315,
		307,
		302,
		-1,
		-1,
		299,
		295,
		302,
		289,
		285,
		302,
		315,
		297,
		311,
		310,
		-1,
		305,
		323,
		328,
		296,
		294,
		278,
		276,
		294,
		296,
		302,
		302,
		-1,
		311,
		313,
		310,
		318,
		318,
		294,
		281,
		281,
		291,
		284,
		303,
		291,
		337,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		308,
		297,
		314,
		306,
		296,
		311,
		304,
		284,
		281,
		279,
		276,
		292,
		290,
		300,
		-1,
		-1,
		364,
		333,
		368,
		325,
		310,
		-1,
		304,
		290,
		296,
		300,
		294,
		287,
		301,
		297,
		-1,
		270,
		269,
		297,
		283,
		294,
		324,
		-1,
		-1,
		322,
		314,
		299,
		302,
		299,
		299,
		305,
		304,
		296,
		282,
		278,
		284,
		287,
		287,
		293,
		264,
		274,
		278,
		276,
		301,
		-1,
		-1,
		336,
		-1,
		-1,
		321,
		304,
		-1,
		287,
		294,
		294,
		311,
		301,
		322,
		315,
		306,
		298,
		292,
		280,
		282,
		279,
		292,
		280,
		261,
		286,
		290,
		271,
		292,
		287,
		-1,
		335,
		319,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		280,
		283,
		289,
		313,
		323,
		-1,
		327,
		315,
		316,
		301,
		298,
		285,
		273,
		286,
		271,
		278,
		277,
		265,
		263,
		293,
		268,
		290,
		287,
		306,
		311,
		305,
		314,
		-1,
		329,
		325,
		321,
		328,
		277,
		-1,
		-1,
		317,
		-1,
		331,
		344,
		339,
		312,
		315,
		302,
		293,
		280,
		269,
		280,
		269,
		266,
		274,
		257,
		272,
		263,
		262,
		280,
		290,
		298,
		302,
		308,
		-1,
		379,
		-1,
		321,
		305,
		307,
		279,
		300,
		-1,
		337,
		332,
		352,
		341,
		339,
		-1,
		311,
		308,
		298,
		276,
		261,
		278,
		270,
		268,
		270,
		252,
		266,
		257,
		275,
		282,
		280,
		284,
		304,
		316,
		339,
		329,
		-1,
		311,
		316,
		275,
		283,
		302,
		375,
		345,
		-1,
		340,
		-1,
		313,
		326,
		-1,
		282,
		278,
		260,
		261,
		256,
		271,
		263,
		248,
		245,
		263,
		266,
		273,
		277,
		293,
		-1,
		-1,
		324,
		328,
		317,
		268,
		287,
		311,
		348,
		338,
		327,
		326,
		-1,
		317,
		296,
		293,
		281,
		268,
		253,
		254,
		262,
		274,
		253,
		247,
		244,
		264,
		290,
		268,
		279,
		-1,
		-1,
		-1,
		349,
		-1,
		-1,
		294,
		265,
		289,
		331,
		356,
		349,
		337,
		302,
		302,
		296,
		-1,
		292,
		271,
		262,
		251,
		249,
		262,
		254,
		262,
		242,
		240,
		259,
		271,
		262,
		270,
		-1,
		-1,
		-1,
		324,
		313,
		314,
		260,
		283,
		320,
		335,
		321,
		326,
		301,
		294,
		288,
		305,
		288,
		269,
		258,
		250,
		239,
		250,
		258,
		256,
		238,
		247,
		253,
		277,
		258,
		264,
		-1,
		-1,
		331,
		321,
		305,
		307,
		304,
		274,
		281,
		313,
		326,
		325,
		-1,
		293,
		-1,
		282,
		278,
		263,
		258,
		255,
		242,
		241,
		255,
		255,
		245,
		240,
		247,
		282,
		282,
		248,
		268,
		271,
		-1,
		-1,
		-1,
		324,
		319,
		294,
		271,
		255,
		291,
		-1,
		295,
		296,
		-1,
		287,
		281,
		278,
		265,
		261,
		246,
		250,
		252,
		255,
		243,
		249,
		250,
		232,
		256,
		-1,
		256,
		250,
		258,
		248,
		236,
		-1,
		-1,
		-1,
		317,
		296,
		289,
		309,
		250,
		302,
		-1,
		-1,
		280,
		273,
		-1,
		274,
		256,
		258,
		253,
		249,
		251,
		248,
		237,
		250,
		243,
		237,
		231,
		244,
		248,
		249,
		238,
		234,
		231,
		245,
		-1,
		336,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		270,
		-1,
		288,
		280,
		271,
		265,
		271,
		269,
		267,
		277,
		261,
		263,
		259,
		251,
		246,
		232,
		225,
		236,
		221,
		239,
		245,
		236,
		231,
		230,
		241,
		-1,
		337,
		323,
		294,
		-1,
		-1,
		283,
		-1,
		247,
		266,
		282,
		-1,
		305,
		284,
		305,
		283,
		279,
		270,
		268,
		269,
		239,
		244,
		246,
		234,
		237,
		226,
		229,
		221,
		243,
		240,
		224,
		226,
		235,
		-1,
		343,
		330,
		288,
		284,
		273,
		293,
		244,
		253,
		269,
		-1,
		-1,
		321,
		-1,
		275,
		277,
		284,
		282,
		258,
		233,
		240,
		258,
		231,
		226,
		231,
		220,
		220,
		215,
		234,
		220,
		218,
		233,
		249,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		259,
		246,
		240,
		-1,
		286,
		-1,
		299,
		287,
		274,
		256,
		296,
		-1,
		232,
		228,
		235,
		-1,
		251,
		-1,
		223,
		226,
		217,
		212,
		209,
		220,
		218,
		227,
		228,
		-1,
		293,
		278,
		271,
		261,
		275,
		243,
		-1,
		277,
		-1,
		-1,
		286,
		280,
		280,
		249,
		246,
		248,
		228,
		220,
		235,
		234,
		221,
		220,
		208,
		208,
		211,
		205,
		218,
		228,
		234,
		226,
		-1,
		-1,
		-1,
		298,
		259,
		267,
		239,
		243,
		-1,
		-1,
		347,
		303,
		289,
		-1,
		241,
		248,
		236,
		226,
		216,
		221,
		222,
		212,
		210,
		206,
		215,
		214,
		207,
		206,
		227,
		220,
		242,
		-1,
		-1,
		256,
		265,
		253,
		221,
		216,
		-1,
		-1,
		-1,
		293,
		279,
		267,
		239,
		237,
		-1,
		-1,
		220,
		213,
		207,
		210,
		198,
		218,
		225,
		213,
		200,
		215,
		225,
		233,
		232,
		-1,
		259,
		246,
		-1,
		-1,
		215,
		205,
		-1,
		-1,
		-1,
		-1,
		257,
		226,
		215,
		210,
		214,
		219,
		-1,
		193,
		204,
		197,
		216,
		223,
		215,
		200,
		194,
		205,
		220,
		237,
		-1,
		-1,
		229,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		229,
		232,
		203,
		196,
		200,
		-1,
		195,
		197,
		194,
		206,
		211,
		215,
		206,
		188,
		202,
		205,
		218,
		232,
		236,
		252,
		-1,
		182,
		-1,
		-1,
		-1,
		221,
		222,
		236,
		213,
		192,
		185,
		182,
		181,
		186,
		197,
		206,
		217,
		182,
		186,
		201,
		206,
		210,
		227,
		231,
		-1,
		-1,
		180,
		176,
		211,
		223,
		195,
		263,
		-1,
		-1,
		181,
		174,
		184,
		177,
		190,
		193,
		178,
		180,
		198,
		211,
		205,
		215,
		230,
		225,
		-1,
		-1,
		-1,
		178,
		-1,
		194,
		-1,
		-1,
		185,
		254,
		201,
		183,
		179,
		165,
		172,
		166,
		168,
		173,
		192,
		187,
		196,
		201,
		205,
		228,
		217,
		256,
		-1,
		-1,
		212,
		-1,
		-1,
		-1,
		144,
		163,
		158,
		164,
		169,
		160,
		216,
		213,
		-1,
		162,
		195,
		163,
		177,
		173,
		180,
		185,
		191,
		195,
		202,
		218,
		217,
		212,
		248,
		239,
		245,
		-1,
		-1,
		205,
		194,
		183,
		189,
		-1,
		137,
		160,
		150,
		140,
		146,
		-1,
		-1,
		180,
		177,
		175,
		155,
		161,
		166,
		169,
		207,
		183,
		191,
		195,
		199,
		205,
		210,
		215,
		221,
		236,
		251,
		-1,
		159,
		196,
		189,
		157,
		165,
		196,
		-1,
		127,
		119,
		147,
		132,
		140,
		-1,
		-1,
		153,
		144,
		149,
		158,
		159,
		190,
		189,
		202,
		205,
		210,
		198,
		197,
		215,
		219,
		228,
		235,
		225,
		238,
		242,
		-1,
		152,
		172,
		151,
		154,
		178,
		192,
		-1,
		118,
		-1,
		-1,
		125,
		153,
		161,
		152,
		149,
		196,
		172,
		167,
		173,
		175,
		199,
		190,
		215,
		206,
		206,
		209,
		224,
		229,
		221,
		235,
		235,
		236,
		-1,
		141,
		152,
		145,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		115,
		-1,
		187,
		-1,
		172,
		176,
		180,
		183,
		198,
		185,
		192,
		209,
		215,
		204,
		214,
		210,
		211,
		220,
		231,
		243,
		242,
		243,
		166,
		122,
		125,
		136,
		147,
		162,
		166,
		-1,
		102,
		135,
		62,
		-1,
		105,
		-1,
		-1,
		-1,
		186,
		193,
		185,
		201,
		197,
		197,
		193,
		197,
		209,
		216,
		226,
		228,
		220,
		224,
		237,
		248,
		251,
		162,
		153,
		166,
		111,
		111,
		132,
		141,
		162,
		86,
		95,
		129,
		51,
		66,
		71,
		95,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		204,
		214,
		197,
		199,
		203,
		217,
		229,
		237,
		227,
		225,
		219,
		251,
		-1,
		155,
		154,
		143,
		140,
		116,
		107,
		102,
		129,
		-1,
		-1,
		84,
		120,
		66,
		43,
		27,
		0,
		-1,
		102,
		-1,
		-1,
		230,
		-1,
		-1,
		241,
		219,
		208,
		199,
		205,
		211,
		222,
		244,
		233,
		234,
		224,
		234,
		247,
		139,
		136,
		124,
		122,
		145,
		110,
		98,
		-1,
		87,
		81,
		77,
		64,
		44,
		41,
		-1,
		-1,
		118,
		109,
		-1,
		-1,
		239,
		237,
		226,
		-1,
		216,
		198,
		203,
		233,
		235,
		237,
		236,
		230,
		237,
		236,
		244,
		252,
		148,
		162,
		151,
		147,
		146,
		154,
		103,
		96,
		90,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		153,
		128,
		-1,
		-1,
		234,
		227,
		215,
		203,
		193,
		203,
		220,
		220,
		223,
		228,
		228,
		239,
		231,
		235,
		250,
		-1,
		182,
		-1,
		134,
		102,
		122,
		137,
		145,
		-1,
		-1,
		-1,
		170,
		156,
		149,
		137,
		135,
		-1,
		268,
		252,
		233,
		-1,
		203,
		216,
		256,
		224,
		229,
		224,
		234,
		245,
		234,
		237,
		243,
		246,
		-1,
		-1,
		120,
		123,
		-1,
		-1,
		147,
		166,
		-1,
		161,
		150,
		135,
		127,
		-1,
		-1,
		240,
		236,
		-1,
		-1,
		190,
		228,
		227,
		235,
		230,
		235,
		244,
		243,
		236,
		240,
		240,
		-1,
		-1,
		127,
		130,
		135,
		-1,
		156,
		-1,
		185,
		-1,
		130,
		146,
		148,
		-1,
		-1,
		-1,
		221,
		184,
		200,
		223,
		249,
		247,
		238,
		231,
		238,
		241,
		234,
		240,
		-1,
		-1,
		-1,
		186,
		163,
		192,
		183,
		166,
		146,
		138,
		163,
		-1,
		202,
		-1,
		177,
		180,
		205,
		244,
		246,
		232,
		228,
		241,
		235,
		232,
		230,
		192,
		-1,
		167,
		220,
		184,
		152,
		152,
		151,
		216,
		-1,
		199,
		181,
		-1,
		209,
		199,
		247,
		222,
		231,
		224,
		218,
		219,
		227,
		-1,
		-1,
		-1,
		182,
		181,
		180,
		174,
		172,
		157,
		152,
		-1,
		204,
		186,
		172,
		189,
		189,
		180,
		188,
		237,
		233,
		236,
		234,
		212,
		-1,
		254,
		-1,
		-1,
		205,
		-1,
		-1,
		-1,
		183,
		192,
		165,
		153,
		167,
		174,
		169,
		171,
		184,
		192,
		190,
		187,
		199,
		195,
		215,
		211,
		243,
		-1,
		261,
		-1,
		212,
		-1,
		-1,
		199,
		185,
		187,
		176,
		165,
		163,
		166,
		164,
		186,
		216,
		202,
		200,
		205,
		210,
		-1,
		271,
		272,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		211,
		172,
		-1,
		193,
		173,
		-1,
		211,
		207,
		-1,
		-1,
		274,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		206,
		190,
		-1,
		184,
		184,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		212,
		215,
		-1,
		206,
		212,
		239,
		186,
		190,
		-1,
		-1,
		-1,
		268,
		249,
		243,
		227,
		232,
		220,
		237,
		223,
		222,
		200,
		189,
		210,
		-1,
		-1,
		-1,
		240,
		232,
		232,
		-1,
		-1,
		247,
		230,
		211,
		209,
		-1,
		-1,
		-1,
		262,
		243,
		-1,
		-1,
		237,
		-1,
		-1,
		243,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		251,
		-1,
		-1,
		-1,
		233,
		229,
		230,
		-1,
		-1,
		-1,
		-1,
		272,
		273,
		297,
		272,
		-1,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		275,
		273,
		-1,
		-1,
		-1,
		253,
		237,
		-1,
		223,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		258,
		-1,
		258,
		233,
		240,
		-1,
		-1,
		-1,
		-1,
		271,
		263,
		271,
		-1,
		243,
		245,
		-1,
		293,
		-1,
		-1,
		286,
		277,
		-1,
		-1,
		248,
		255,
		277,
		280,
		316,
		-1,
		267
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		296,
		285,
		296,
		304,
		277,
		284,
		-1,
		303,
		307,
		273,
		267,
		306,
		275,
		281,
		292,
		-1,
		-1,
		-1,
		296,
		295,
		263,
		261,
		270,
		275,
		282,
		-1,
		281,
		-1,
		317,
		296,
		307,
		312,
		256,
		253,
		273,
		292,
		274,
		266,
		332,
		286,
		257,
		251,
		269,
		259,
		268,
		260,
		-1,
		257,
		247,
		269,
		248,
		259,
		251,
		-1,
		-1,
		251,
		252,
		258,
		244,
		250,
		246,
		-1,
		256,
		240,
		-1,
		-1,
		241,
		242,
		226,
		229,
		237,
		235,
		248,
		240,
		235,
		-1,
		-1,
		232,
		228,
		235,
		222,
		218,
		235,
		248,
		230,
		244,
		243,
		-1,
		236,
		254,
		261,
		229,
		227,
		211,
		209,
		227,
		229,
		235,
		235,
		-1,
		240,
		242,
		241,
		249,
		251,
		227,
		214,
		214,
		224,
		217,
		236,
		224,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		237,
		228,
		245,
		237,
		227,
		242,
		235,
		217,
		214,
		212,
		209,
		225,
		223,
		233,
		-1,
		-1,
		293,
		262,
		297,
		254,
		239,
		-1,
		233,
		221,
		227,
		231,
		225,
		218,
		232,
		228,
		-1,
		203,
		202,
		230,
		216,
		227,
		253,
		-1,
		-1,
		251,
		243,
		228,
		231,
		228,
		228,
		236,
		235,
		227,
		213,
		209,
		215,
		218,
		218,
		224,
		197,
		207,
		211,
		209,
		234,
		-1,
		-1,
		269,
		-1,
		-1,
		250,
		233,
		-1,
		216,
		223,
		223,
		240,
		230,
		251,
		246,
		237,
		229,
		223,
		211,
		213,
		210,
		223,
		211,
		194,
		219,
		223,
		204,
		225,
		220,
		-1,
		268,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		209,
		212,
		218,
		242,
		252,
		-1,
		258,
		246,
		247,
		232,
		229,
		216,
		204,
		217,
		202,
		209,
		208,
		198,
		196,
		226,
		201,
		223,
		220,
		239,
		244,
		238,
		247,
		-1,
		258,
		254,
		250,
		257,
		206,
		-1,
		-1,
		246,
		-1,
		260,
		273,
		270,
		243,
		246,
		233,
		224,
		211,
		200,
		211,
		200,
		197,
		205,
		190,
		205,
		196,
		195,
		213,
		223,
		231,
		235,
		241,
		-1,
		308,
		-1,
		250,
		234,
		236,
		208,
		229,
		-1,
		266,
		261,
		281,
		272,
		270,
		-1,
		242,
		239,
		229,
		207,
		192,
		209,
		201,
		199,
		203,
		185,
		199,
		190,
		208,
		215,
		213,
		217,
		237,
		249,
		268,
		258,
		-1,
		240,
		245,
		204,
		212,
		231,
		304,
		276,
		-1,
		271,
		-1,
		244,
		257,
		-1,
		213,
		209,
		191,
		192,
		187,
		202,
		196,
		181,
		178,
		196,
		199,
		206,
		210,
		226,
		-1,
		-1,
		253,
		257,
		246,
		197,
		216,
		240,
		277,
		269,
		258,
		257,
		-1,
		248,
		227,
		224,
		212,
		199,
		184,
		185,
		193,
		206,
		185,
		180,
		177,
		197,
		223,
		201,
		213,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		223,
		194,
		218,
		260,
		287,
		280,
		268,
		233,
		233,
		227,
		-1,
		223,
		202,
		193,
		182,
		180,
		193,
		190,
		195,
		175,
		173,
		192,
		204,
		195,
		212,
		-1,
		-1,
		-1,
		253,
		242,
		243,
		189,
		212,
		249,
		266,
		252,
		257,
		232,
		225,
		219,
		236,
		219,
		200,
		189,
		181,
		170,
		186,
		194,
		189,
		171,
		180,
		186,
		210,
		200,
		206,
		-1,
		-1,
		260,
		250,
		234,
		236,
		233,
		203,
		210,
		242,
		257,
		254,
		-1,
		224,
		-1,
		213,
		210,
		194,
		189,
		186,
		183,
		177,
		186,
		188,
		178,
		173,
		180,
		215,
		215,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		253,
		248,
		223,
		200,
		184,
		220,
		-1,
		224,
		225,
		-1,
		218,
		212,
		211,
		196,
		192,
		187,
		191,
		184,
		191,
		184,
		182,
		183,
		165,
		197,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		246,
		225,
		218,
		238,
		179,
		231,
		-1,
		-1,
		209,
		202,
		-1,
		205,
		189,
		196,
		194,
		188,
		192,
		189,
		178,
		191,
		184,
		170,
		172,
		185,
		189,
		193,
		180,
		176,
		173,
		187,
		-1,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		199,
		-1,
		217,
		209,
		200,
		194,
		200,
		202,
		200,
		216,
		200,
		203,
		201,
		192,
		200,
		173,
		166,
		173,
		162,
		180,
		188,
		180,
		174,
		173,
		183,
		-1,
		266,
		252,
		223,
		-1,
		-1,
		212,
		-1,
		176,
		195,
		211,
		-1,
		234,
		213,
		236,
		214,
		212,
		208,
		223,
		224,
		201,
		201,
		199,
		190,
		178,
		167,
		170,
		162,
		184,
		184,
		168,
		169,
		173,
		-1,
		272,
		259,
		217,
		213,
		202,
		222,
		173,
		182,
		198,
		-1,
		-1,
		272,
		-1,
		212,
		228,
		222,
		220,
		213,
		195,
		202,
		210,
		187,
		182,
		172,
		161,
		161,
		156,
		178,
		164,
		162,
		171,
		187,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		188,
		175,
		169,
		-1,
		215,
		-1,
		250,
		238,
		225,
		207,
		247,
		-1,
		194,
		190,
		197,
		-1,
		207,
		-1,
		180,
		177,
		168,
		153,
		150,
		161,
		159,
		170,
		166,
		-1,
		222,
		207,
		200,
		190,
		204,
		172,
		-1,
		206,
		-1,
		-1,
		237,
		231,
		231,
		200,
		197,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		166,
		159,
		156,
		149,
		162,
		172,
		177,
		164,
		-1,
		-1,
		-1,
		227,
		202,
		196,
		168,
		172,
		-1,
		-1,
		298,
		254,
		240,
		-1,
		192,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		164,
		166,
		160,
		151,
		150,
		166,
		158,
		180,
		-1,
		-1,
		201,
		194,
		182,
		150,
		145,
		-1,
		-1,
		-1,
		244,
		230,
		218,
		190,
		199,
		-1,
		-1,
		182,
		175,
		169,
		172,
		160,
		180,
		175,
		159,
		144,
		159,
		163,
		171,
		162,
		-1,
		204,
		191,
		-1,
		-1,
		144,
		134,
		-1,
		-1,
		-1,
		-1,
		208,
		189,
		184,
		179,
		183,
		181,
		-1,
		155,
		166,
		159,
		178,
		185,
		161,
		146,
		140,
		146,
		158,
		167,
		-1,
		-1,
		158,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		180,
		195,
		172,
		165,
		169,
		-1,
		157,
		159,
		156,
		168,
		164,
		161,
		152,
		143,
		139,
		143,
		147,
		161,
		165,
		181,
		-1,
		111,
		-1,
		-1,
		-1,
		157,
		179,
		211,
		188,
		161,
		156,
		149,
		143,
		148,
		159,
		168,
		179,
		144,
		146,
		136,
		135,
		139,
		156,
		160,
		-1,
		-1,
		109,
		105,
		140,
		152,
		152,
		238,
		-1,
		-1,
		156,
		149,
		147,
		139,
		152,
		155,
		140,
		142,
		142,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		121,
		-1,
		123,
		-1,
		-1,
		142,
		229,
		176,
		158,
		154,
		140,
		148,
		142,
		130,
		135,
		145,
		139,
		136,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		128,
		92,
		87,
		121,
		126,
		117,
		191,
		188,
		-1,
		136,
		171,
		136,
		143,
		126,
		133,
		138,
		135,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		121,
		89,
		107,
		97,
		103,
		-1,
		-1,
		150,
		147,
		150,
		136,
		134,
		127,
		122,
		132,
		108,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		198,
		235,
		228,
		196,
		204,
		235,
		-1,
		111,
		103,
		86,
		89,
		97,
		-1,
		-1,
		123,
		119,
		124,
		133,
		136,
		146,
		145,
		128,
		134,
		135,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		191,
		211,
		190,
		193,
		217,
		231,
		-1,
		108,
		-1,
		-1,
		46,
		110,
		118,
		114,
		118,
		171,
		147,
		142,
		133,
		131,
		126,
		117,
		142,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		36,
		-1,
		144,
		-1,
		137,
		141,
		155,
		158,
		147,
		134,
		120,
		128,
		134,
		133,
		139,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		120,
		159,
		42,
		-1,
		26,
		-1,
		-1,
		-1,
		151,
		168,
		160,
		167,
		146,
		146,
		112,
		116,
		129,
		136,
		146,
		157,
		149,
		153,
		166,
		177,
		180,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		125,
		126,
		153,
		49,
		38,
		33,
		20,
		-1,
		-1,
		174,
		178,
		-1,
		-1,
		153,
		120,
		108,
		118,
		122,
		136,
		148,
		161,
		149,
		154,
		148,
		180,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		123,
		154,
		105,
		82,
		80,
		105,
		-1,
		0,
		-1,
		-1,
		160,
		-1,
		-1,
		145,
		125,
		114,
		105,
		110,
		130,
		141,
		163,
		145,
		162,
		153,
		163,
		167,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		126,
		120,
		116,
		103,
		83,
		94,
		-1,
		-1,
		16,
		13,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		102,
		107,
		137,
		139,
		141,
		148,
		142,
		149,
		157,
		168,
		160,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		-1,
		57,
		32,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		124,
		124,
		127,
		132,
		140,
		151,
		147,
		151,
		154,
		-1,
		221,
		-1,
		173,
		141,
		161,
		176,
		184,
		-1,
		-1,
		-1,
		74,
		60,
		53,
		41,
		39,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		160,
		128,
		133,
		128,
		143,
		154,
		145,
		153,
		147,
		150,
		-1,
		-1,
		155,
		138,
		-1,
		-1,
		112,
		114,
		-1,
		65,
		54,
		39,
		31,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		94,
		132,
		131,
		139,
		134,
		139,
		151,
		147,
		143,
		153,
		144,
		-1,
		-1,
		133,
		125,
		119,
		-1,
		97,
		-1,
		89,
		-1,
		34,
		50,
		52,
		-1,
		-1,
		-1,
		125,
		88,
		104,
		127,
		153,
		151,
		142,
		135,
		142,
		145,
		138,
		144,
		-1,
		-1,
		-1,
		115,
		89,
		96,
		87,
		70,
		50,
		42,
		67,
		-1,
		106,
		-1,
		81,
		84,
		109,
		148,
		150,
		136,
		132,
		145,
		139,
		136,
		134,
		121,
		-1,
		91,
		124,
		88,
		56,
		56,
		55,
		120,
		-1,
		103,
		85,
		-1,
		113,
		103,
		151,
		126,
		135,
		128,
		122,
		123,
		131,
		-1,
		-1,
		-1,
		93,
		92,
		84,
		78,
		76,
		61,
		56,
		-1,
		108,
		90,
		76,
		93,
		93,
		84,
		92,
		141,
		137,
		140,
		138,
		116,
		-1,
		207,
		-1,
		-1,
		116,
		-1,
		-1,
		-1,
		87,
		96,
		69,
		57,
		71,
		78,
		73,
		75,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		115,
		147,
		-1,
		202,
		-1,
		123,
		-1,
		-1,
		103,
		89,
		91,
		80,
		69,
		67,
		70,
		68,
		90,
		120,
		106,
		104,
		109,
		114,
		-1,
		191,
		190,
		-1,
		122,
		114,
		100,
		-1,
		93,
		-1,
		115,
		76,
		-1,
		97,
		77,
		-1,
		115,
		111,
		-1,
		-1,
		178,
		138,
		-1,
		-1,
		-1,
		123,
		103,
		110,
		94,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		116,
		119,
		-1,
		110,
		116,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		172,
		153,
		147,
		131,
		136,
		124,
		141,
		127,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		144,
		136,
		136,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		166,
		147,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		155,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		176,
		177,
		201,
		176,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		179,
		177,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		280,
		269,
		280,
		288,
		261,
		268,
		-1,
		287,
		291,
		257,
		251,
		290,
		259,
		265,
		276,
		-1,
		-1,
		-1,
		280,
		279,
		247,
		245,
		254,
		259,
		266,
		-1,
		265,
		-1,
		301,
		280,
		291,
		296,
		240,
		237,
		257,
		276,
		258,
		250,
		316,
		270,
		241,
		235,
		253,
		243,
		252,
		244,
		-1,
		241,
		231,
		253,
		232,
		243,
		235,
		-1,
		-1,
		235,
		236,
		242,
		228,
		234,
		230,
		-1,
		240,
		224,
		-1,
		-1,
		225,
		226,
		210,
		213,
		221,
		219,
		232,
		224,
		219,
		-1,
		-1,
		216,
		212,
		219,
		206,
		202,
		219,
		232,
		214,
		228,
		227,
		-1,
		220,
		238,
		245,
		213,
		211,
		195,
		193,
		211,
		213,
		219,
		219,
		-1,
		229,
		230,
		225,
		233,
		235,
		211,
		198,
		198,
		208,
		201,
		220,
		208,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		229,
		212,
		229,
		221,
		211,
		226,
		219,
		201,
		198,
		196,
		193,
		209,
		207,
		217,
		-1,
		-1,
		322,
		291,
		320,
		278,
		259,
		-1,
		225,
		205,
		211,
		215,
		209,
		202,
		216,
		212,
		-1,
		187,
		186,
		214,
		200,
		211,
		282,
		-1,
		-1,
		280,
		272,
		255,
		258,
		235,
		231,
		220,
		219,
		211,
		197,
		193,
		199,
		202,
		202,
		208,
		181,
		191,
		195,
		193,
		218,
		-1,
		-1,
		253,
		-1,
		-1,
		279,
		262,
		-1,
		245,
		252,
		241,
		247,
		233,
		254,
		230,
		221,
		213,
		207,
		195,
		197,
		194,
		207,
		195,
		178,
		203,
		207,
		188,
		209,
		204,
		-1,
		252,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		238,
		241,
		247,
		271,
		270,
		-1,
		242,
		230,
		231,
		216,
		213,
		200,
		188,
		201,
		186,
		193,
		192,
		182,
		180,
		210,
		185,
		207,
		204,
		223,
		228,
		222,
		231,
		-1,
		287,
		283,
		279,
		286,
		235,
		-1,
		-1,
		275,
		-1,
		278,
		279,
		254,
		227,
		230,
		217,
		208,
		195,
		184,
		195,
		184,
		181,
		189,
		174,
		189,
		180,
		179,
		197,
		207,
		215,
		219,
		225,
		-1,
		337,
		-1,
		279,
		263,
		265,
		237,
		258,
		-1,
		295,
		279,
		271,
		256,
		256,
		-1,
		226,
		223,
		213,
		191,
		176,
		193,
		185,
		183,
		187,
		169,
		183,
		174,
		192,
		199,
		197,
		201,
		221,
		233,
		297,
		287,
		-1,
		269,
		274,
		233,
		241,
		260,
		298,
		262,
		-1,
		257,
		-1,
		228,
		241,
		-1,
		197,
		193,
		175,
		176,
		171,
		186,
		180,
		165,
		162,
		180,
		183,
		190,
		194,
		210,
		-1,
		-1,
		282,
		286,
		275,
		226,
		245,
		269,
		306,
		255,
		244,
		243,
		-1,
		234,
		211,
		208,
		196,
		183,
		168,
		169,
		177,
		190,
		169,
		164,
		161,
		181,
		207,
		185,
		197,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		252,
		223,
		247,
		289,
		273,
		266,
		254,
		219,
		219,
		213,
		-1,
		207,
		186,
		177,
		166,
		164,
		177,
		174,
		179,
		159,
		157,
		176,
		188,
		179,
		196,
		-1,
		-1,
		-1,
		282,
		271,
		272,
		218,
		241,
		278,
		252,
		238,
		243,
		218,
		211,
		205,
		220,
		203,
		184,
		173,
		165,
		154,
		170,
		178,
		173,
		155,
		164,
		170,
		194,
		184,
		190,
		-1,
		-1,
		289,
		279,
		263,
		265,
		262,
		232,
		239,
		271,
		243,
		256,
		-1,
		210,
		-1,
		199,
		194,
		178,
		173,
		170,
		167,
		161,
		170,
		172,
		162,
		157,
		164,
		199,
		199,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		282,
		277,
		252,
		229,
		213,
		249,
		-1,
		226,
		227,
		-1,
		204,
		198,
		195,
		180,
		176,
		171,
		175,
		168,
		175,
		168,
		166,
		167,
		149,
		181,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		275,
		254,
		247,
		267,
		208,
		260,
		-1,
		-1,
		211,
		204,
		-1,
		191,
		173,
		180,
		178,
		172,
		176,
		173,
		162,
		175,
		168,
		154,
		156,
		169,
		173,
		177,
		164,
		160,
		157,
		171,
		-1,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		228,
		-1,
		220,
		212,
		202,
		196,
		190,
		186,
		184,
		200,
		184,
		187,
		185,
		176,
		184,
		157,
		150,
		157,
		146,
		164,
		172,
		164,
		158,
		157,
		167,
		-1,
		295,
		281,
		252,
		-1,
		-1,
		241,
		-1,
		205,
		219,
		235,
		-1,
		228,
		207,
		222,
		200,
		196,
		192,
		207,
		208,
		183,
		185,
		183,
		174,
		162,
		151,
		154,
		146,
		168,
		168,
		152,
		153,
		157,
		-1,
		301,
		288,
		246,
		242,
		231,
		251,
		202,
		190,
		222,
		-1,
		-1,
		264,
		-1,
		198,
		215,
		206,
		204,
		197,
		177,
		184,
		194,
		171,
		166,
		156,
		145,
		145,
		140,
		162,
		148,
		146,
		155,
		171,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		217,
		204,
		198,
		-1,
		239,
		-1,
		242,
		232,
		216,
		201,
		234,
		-1,
		176,
		172,
		179,
		-1,
		191,
		-1,
		164,
		161,
		152,
		137,
		134,
		145,
		143,
		154,
		150,
		-1,
		251,
		236,
		229,
		219,
		233,
		204,
		-1,
		259,
		-1,
		-1,
		229,
		223,
		223,
		195,
		192,
		192,
		172,
		164,
		179,
		178,
		165,
		164,
		150,
		143,
		140,
		133,
		146,
		156,
		161,
		148,
		-1,
		-1,
		-1,
		256,
		242,
		246,
		206,
		225,
		-1,
		-1,
		291,
		246,
		232,
		-1,
		187,
		192,
		180,
		170,
		160,
		165,
		166,
		156,
		154,
		148,
		150,
		144,
		135,
		134,
		150,
		142,
		164,
		-1,
		-1,
		239,
		244,
		232,
		205,
		200,
		-1,
		-1,
		-1,
		238,
		240,
		206,
		185,
		181,
		-1,
		-1,
		164,
		157,
		151,
		149,
		142,
		162,
		159,
		143,
		128,
		143,
		147,
		155,
		146,
		-1,
		242,
		229,
		-1,
		-1,
		199,
		189,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		163,
		-1,
		136,
		140,
		140,
		160,
		167,
		145,
		130,
		124,
		130,
		142,
		151,
		-1,
		-1,
		213,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		134,
		133,
		137,
		143,
		148,
		145,
		136,
		127,
		123,
		127,
		131,
		145,
		149,
		236,
		-1,
		166,
		-1,
		-1,
		-1,
		193,
		198,
		173,
		150,
		129,
		122,
		119,
		125,
		129,
		145,
		151,
		162,
		131,
		130,
		120,
		119,
		123,
		140,
		144,
		-1,
		-1,
		164,
		160,
		195,
		201,
		171,
		200,
		-1,
		-1,
		118,
		111,
		121,
		126,
		135,
		138,
		127,
		129,
		129,
		124,
		118,
		128,
		143,
		138,
		-1,
		-1,
		-1,
		176,
		-1,
		178,
		-1,
		-1,
		161,
		191,
		138,
		120,
		116,
		102,
		125,
		119,
		117,
		122,
		132,
		126,
		123,
		114,
		118,
		141,
		130,
		169,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		155,
		147,
		141,
		144,
		145,
		136,
		153,
		150,
		-1,
		98,
		141,
		116,
		130,
		113,
		120,
		125,
		122,
		108,
		115,
		131,
		130,
		125,
		161,
		152,
		158,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		148,
		144,
		130,
		120,
		122,
		-1,
		-1,
		115,
		112,
		121,
		108,
		114,
		114,
		109,
		114,
		95,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		205,
		242,
		235,
		203,
		211,
		242,
		-1,
		138,
		130,
		140,
		116,
		113,
		-1,
		-1,
		88,
		90,
		95,
		104,
		107,
		133,
		132,
		99,
		104,
		122,
		109,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		198,
		218,
		197,
		200,
		224,
		238,
		-1,
		135,
		-1,
		-1,
		147,
		114,
		98,
		92,
		87,
		142,
		118,
		113,
		101,
		99,
		96,
		87,
		125,
		104,
		116,
		119,
		135,
		140,
		132,
		148,
		148,
		149,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		163,
		-1,
		125,
		-1,
		60,
		89,
		126,
		129,
		115,
		102,
		88,
		96,
		102,
		102,
		107,
		110,
		122,
		131,
		142,
		154,
		155,
		156,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		147,
		186,
		191,
		-1,
		172,
		-1,
		-1,
		-1,
		42,
		139,
		131,
		135,
		114,
		114,
		80,
		84,
		97,
		104,
		114,
		128,
		125,
		135,
		148,
		159,
		164,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		162,
		153,
		180,
		198,
		187,
		182,
		169,
		-1,
		-1,
		20,
		149,
		-1,
		-1,
		121,
		88,
		76,
		86,
		90,
		104,
		116,
		129,
		117,
		136,
		130,
		162,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		165,
		181,
		181,
		185,
		201,
		226,
		-1,
		158,
		-1,
		-1,
		0,
		-1,
		-1,
		69,
		93,
		82,
		73,
		78,
		98,
		109,
		131,
		113,
		130,
		135,
		145,
		158,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		157,
		155,
		161,
		168,
		185,
		215,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		19,
		26,
		54,
		-1,
		79,
		70,
		75,
		105,
		107,
		109,
		116,
		110,
		117,
		143,
		155,
		157,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		26,
		33,
		41,
		52,
		65,
		75,
		92,
		92,
		95,
		100,
		108,
		119,
		133,
		137,
		151,
		-1,
		228,
		-1,
		180,
		156,
		170,
		185,
		193,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		76,
		60,
		41,
		-1,
		75,
		88,
		128,
		96,
		101,
		96,
		114,
		125,
		136,
		139,
		144,
		147,
		-1,
		-1,
		168,
		171,
		-1,
		-1,
		171,
		173,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		48,
		44,
		-1,
		-1,
		76,
		110,
		99,
		107,
		102,
		114,
		124,
		122,
		134,
		142,
		141,
		-1,
		-1,
		175,
		176,
		178,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		114,
		77,
		98,
		117,
		122,
		120,
		111,
		110,
		117,
		127,
		135,
		141,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		113,
		-1,
		81,
		78,
		119,
		116,
		133,
		127,
		113,
		128,
		124,
		133,
		131,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		110,
		89,
		-1,
		123,
		113,
		150,
		136,
		124,
		111,
		118,
		132,
		128,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		103,
		103,
		94,
		102,
		140,
		136,
		129,
		131,
		123,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		124,
		157,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		132,
		116,
		114,
		119,
		124,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		125,
		121,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		272,
		261,
		272,
		280,
		253,
		260,
		-1,
		279,
		283,
		249,
		243,
		282,
		251,
		257,
		268,
		-1,
		-1,
		-1,
		272,
		271,
		239,
		237,
		246,
		251,
		258,
		-1,
		257,
		-1,
		293,
		272,
		283,
		288,
		232,
		229,
		249,
		268,
		250,
		242,
		308,
		262,
		233,
		227,
		245,
		235,
		244,
		236,
		-1,
		233,
		223,
		245,
		224,
		235,
		227,
		-1,
		-1,
		227,
		228,
		234,
		220,
		226,
		222,
		-1,
		232,
		216,
		-1,
		-1,
		217,
		218,
		202,
		205,
		213,
		211,
		224,
		216,
		211,
		-1,
		-1,
		208,
		204,
		211,
		198,
		194,
		211,
		224,
		206,
		220,
		219,
		-1,
		212,
		230,
		237,
		205,
		203,
		187,
		185,
		203,
		205,
		211,
		211,
		-1,
		221,
		222,
		217,
		225,
		227,
		203,
		190,
		190,
		200,
		193,
		212,
		200,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		221,
		204,
		221,
		213,
		203,
		218,
		211,
		193,
		190,
		188,
		185,
		201,
		199,
		209,
		-1,
		-1,
		314,
		283,
		312,
		270,
		251,
		-1,
		217,
		197,
		203,
		207,
		201,
		194,
		208,
		204,
		-1,
		179,
		178,
		206,
		192,
		203,
		274,
		-1,
		-1,
		272,
		264,
		247,
		250,
		227,
		223,
		212,
		211,
		203,
		189,
		185,
		191,
		194,
		194,
		200,
		173,
		183,
		187,
		185,
		210,
		-1,
		-1,
		245,
		-1,
		-1,
		271,
		254,
		-1,
		237,
		244,
		233,
		239,
		225,
		246,
		222,
		213,
		205,
		199,
		187,
		189,
		186,
		199,
		187,
		170,
		195,
		199,
		180,
		201,
		196,
		-1,
		244,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		230,
		233,
		239,
		263,
		262,
		-1,
		234,
		222,
		223,
		208,
		205,
		192,
		180,
		193,
		178,
		185,
		184,
		174,
		172,
		202,
		177,
		199,
		196,
		215,
		220,
		214,
		223,
		-1,
		279,
		275,
		271,
		278,
		227,
		-1,
		-1,
		267,
		-1,
		270,
		271,
		246,
		219,
		222,
		209,
		200,
		187,
		176,
		187,
		176,
		173,
		181,
		166,
		181,
		172,
		171,
		189,
		199,
		207,
		211,
		217,
		-1,
		329,
		-1,
		271,
		255,
		257,
		229,
		250,
		-1,
		287,
		271,
		263,
		248,
		248,
		-1,
		218,
		215,
		205,
		183,
		168,
		185,
		177,
		175,
		179,
		161,
		175,
		166,
		184,
		191,
		189,
		193,
		213,
		225,
		289,
		279,
		-1,
		261,
		266,
		225,
		233,
		252,
		290,
		254,
		-1,
		249,
		-1,
		220,
		233,
		-1,
		189,
		185,
		167,
		168,
		163,
		178,
		172,
		157,
		154,
		172,
		175,
		182,
		186,
		202,
		-1,
		-1,
		274,
		278,
		267,
		218,
		237,
		261,
		298,
		247,
		236,
		235,
		-1,
		226,
		203,
		200,
		188,
		175,
		160,
		161,
		169,
		182,
		161,
		156,
		153,
		173,
		199,
		177,
		189,
		-1,
		-1,
		-1,
		299,
		-1,
		-1,
		244,
		215,
		239,
		281,
		265,
		258,
		246,
		211,
		211,
		205,
		-1,
		199,
		178,
		169,
		158,
		156,
		169,
		166,
		171,
		151,
		149,
		168,
		180,
		171,
		188,
		-1,
		-1,
		-1,
		274,
		263,
		264,
		210,
		233,
		270,
		244,
		230,
		235,
		210,
		203,
		197,
		212,
		195,
		176,
		165,
		157,
		146,
		162,
		170,
		165,
		147,
		156,
		162,
		186,
		176,
		182,
		-1,
		-1,
		281,
		271,
		255,
		257,
		254,
		224,
		231,
		263,
		235,
		248,
		-1,
		202,
		-1,
		191,
		186,
		170,
		165,
		162,
		159,
		153,
		162,
		164,
		154,
		149,
		156,
		191,
		191,
		166,
		186,
		189,
		-1,
		-1,
		-1,
		274,
		269,
		244,
		221,
		205,
		241,
		-1,
		218,
		219,
		-1,
		196,
		190,
		187,
		172,
		168,
		163,
		167,
		160,
		167,
		160,
		158,
		159,
		141,
		173,
		-1,
		174,
		168,
		176,
		166,
		154,
		-1,
		-1,
		-1,
		267,
		246,
		239,
		259,
		200,
		252,
		-1,
		-1,
		203,
		196,
		-1,
		183,
		165,
		172,
		170,
		164,
		168,
		165,
		154,
		167,
		160,
		146,
		148,
		161,
		165,
		169,
		156,
		152,
		149,
		163,
		-1,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		220,
		-1,
		212,
		204,
		194,
		188,
		182,
		178,
		176,
		192,
		176,
		179,
		177,
		168,
		176,
		149,
		142,
		149,
		138,
		156,
		164,
		156,
		150,
		149,
		159,
		-1,
		287,
		273,
		244,
		-1,
		-1,
		233,
		-1,
		197,
		211,
		227,
		-1,
		220,
		199,
		214,
		192,
		188,
		184,
		199,
		200,
		178,
		177,
		175,
		166,
		154,
		143,
		146,
		138,
		160,
		160,
		144,
		145,
		149,
		-1,
		293,
		280,
		238,
		234,
		223,
		243,
		194,
		182,
		214,
		-1,
		-1,
		256,
		-1,
		190,
		207,
		198,
		196,
		189,
		174,
		181,
		186,
		163,
		158,
		148,
		137,
		137,
		132,
		154,
		140,
		138,
		147,
		163,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		209,
		196,
		190,
		-1,
		231,
		-1,
		234,
		224,
		208,
		193,
		226,
		-1,
		173,
		169,
		176,
		-1,
		183,
		-1,
		156,
		153,
		144,
		129,
		126,
		137,
		135,
		146,
		142,
		-1,
		243,
		228,
		221,
		211,
		225,
		196,
		-1,
		251,
		-1,
		-1,
		221,
		215,
		215,
		199,
		202,
		189,
		169,
		161,
		176,
		175,
		162,
		161,
		142,
		135,
		132,
		125,
		138,
		148,
		153,
		140,
		-1,
		-1,
		-1,
		248,
		234,
		238,
		198,
		217,
		-1,
		-1,
		283,
		238,
		224,
		-1,
		198,
		189,
		177,
		167,
		157,
		162,
		163,
		153,
		151,
		140,
		142,
		136,
		127,
		126,
		142,
		134,
		156,
		-1,
		-1,
		231,
		236,
		224,
		210,
		229,
		-1,
		-1,
		-1,
		230,
		246,
		217,
		196,
		178,
		-1,
		-1,
		161,
		154,
		148,
		151,
		139,
		156,
		151,
		135,
		120,
		135,
		139,
		147,
		138,
		-1,
		234,
		221,
		-1,
		-1,
		232,
		226,
		-1,
		-1,
		-1,
		-1,
		229,
		174,
		163,
		158,
		162,
		160,
		-1,
		134,
		145,
		138,
		157,
		164,
		137,
		122,
		116,
		122,
		134,
		143,
		-1,
		-1,
		246,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		186,
		180,
		151,
		144,
		148,
		-1,
		136,
		138,
		135,
		147,
		140,
		137,
		128,
		119,
		115,
		119,
		123,
		137,
		141,
		269,
		-1,
		207,
		-1,
		-1,
		-1,
		204,
		219,
		190,
		167,
		140,
		135,
		128,
		122,
		127,
		138,
		147,
		158,
		123,
		122,
		112,
		111,
		115,
		132,
		136,
		-1,
		-1,
		205,
		201,
		230,
		212,
		216,
		217,
		-1,
		-1,
		144,
		135,
		126,
		118,
		131,
		134,
		119,
		121,
		121,
		116,
		110,
		120,
		135,
		130,
		-1,
		-1,
		-1,
		217,
		-1,
		219,
		-1,
		-1,
		207,
		215,
		162,
		144,
		140,
		138,
		125,
		119,
		109,
		114,
		124,
		118,
		115,
		106,
		110,
		133,
		122,
		161,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		196,
		188,
		183,
		189,
		191,
		182,
		177,
		174,
		-1,
		144,
		148,
		115,
		122,
		105,
		112,
		117,
		114,
		100,
		107,
		123,
		122,
		117,
		153,
		144,
		150,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		189,
		185,
		175,
		165,
		168,
		-1,
		-1,
		162,
		159,
		139,
		108,
		113,
		106,
		101,
		106,
		87,
		96,
		100,
		104,
		110,
		115,
		120,
		126,
		141,
		156,
		-1,
		236,
		273,
		266,
		234,
		242,
		273,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		135,
		126,
		127,
		115,
		112,
		125,
		124,
		91,
		96,
		114,
		101,
		102,
		120,
		124,
		133,
		140,
		130,
		143,
		147,
		-1,
		229,
		249,
		228,
		231,
		255,
		269,
		-1,
		176,
		-1,
		-1,
		187,
		160,
		144,
		134,
		131,
		174,
		121,
		116,
		93,
		91,
		88,
		79,
		117,
		96,
		108,
		111,
		127,
		132,
		124,
		140,
		140,
		141,
		-1,
		218,
		229,
		222,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		177,
		-1,
		171,
		-1,
		138,
		158,
		129,
		132,
		107,
		94,
		80,
		88,
		94,
		94,
		99,
		102,
		114,
		123,
		134,
		146,
		147,
		148,
		243,
		199,
		202,
		213,
		224,
		239,
		243,
		-1,
		188,
		227,
		183,
		-1,
		167,
		-1,
		-1,
		-1,
		120,
		142,
		134,
		127,
		106,
		106,
		72,
		76,
		89,
		96,
		106,
		120,
		117,
		127,
		140,
		151,
		156,
		239,
		230,
		243,
		188,
		188,
		209,
		218,
		239,
		203,
		194,
		221,
		190,
		179,
		174,
		161,
		-1,
		-1,
		98,
		152,
		-1,
		-1,
		113,
		80,
		68,
		78,
		82,
		96,
		108,
		121,
		109,
		128,
		122,
		154,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		179,
		206,
		-1,
		-1,
		201,
		222,
		212,
		216,
		221,
		246,
		-1,
		150,
		-1,
		-1,
		78,
		-1,
		-1,
		0,
		85,
		74,
		65,
		70,
		90,
		101,
		123,
		105,
		122,
		127,
		137,
		150,
		216,
		213,
		201,
		199,
		222,
		187,
		175,
		-1,
		188,
		186,
		192,
		199,
		216,
		235,
		-1,
		-1,
		166,
		146,
		-1,
		-1,
		61,
		59,
		20,
		-1,
		67,
		62,
		67,
		97,
		99,
		101,
		108,
		102,
		109,
		135,
		147,
		149,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		173,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		156,
		152,
		-1,
		-1,
		56,
		49,
		37,
		44,
		57,
		66,
		84,
		84,
		87,
		92,
		100,
		111,
		125,
		129,
		143,
		-1,
		259,
		-1,
		211,
		187,
		201,
		216,
		224,
		-1,
		-1,
		-1,
		173,
		159,
		152,
		140,
		138,
		-1,
		90,
		74,
		55,
		-1,
		63,
		76,
		120,
		88,
		93,
		88,
		106,
		117,
		128,
		131,
		136,
		139,
		-1,
		-1,
		199,
		189,
		-1,
		-1,
		163,
		165,
		-1,
		164,
		153,
		138,
		130,
		-1,
		-1,
		62,
		58,
		-1,
		-1,
		68,
		102,
		91,
		99,
		94,
		106,
		116,
		114,
		126,
		134,
		133,
		-1,
		-1,
		184,
		176,
		170,
		-1,
		148,
		-1,
		166,
		-1,
		133,
		139,
		127,
		-1,
		-1,
		-1,
		106,
		69,
		90,
		109,
		114,
		112,
		103,
		102,
		109,
		119,
		127,
		133,
		-1,
		-1,
		-1,
		166,
		140,
		173,
		164,
		147,
		127,
		119,
		138,
		-1,
		105,
		-1,
		73,
		70,
		111,
		108,
		125,
		119,
		105,
		120,
		116,
		125,
		123,
		172,
		-1,
		142,
		175,
		139,
		133,
		109,
		113,
		129,
		-1,
		102,
		81,
		-1,
		115,
		105,
		142,
		128,
		116,
		103,
		110,
		124,
		120,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		114,
		105,
		-1,
		117,
		99,
		78,
		95,
		95,
		86,
		94,
		132,
		128,
		121,
		123,
		115,
		-1,
		245,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		133,
		106,
		94,
		100,
		96,
		82,
		88,
		90,
		98,
		96,
		93,
		105,
		101,
		121,
		116,
		149,
		-1,
		240,
		-1,
		174,
		-1,
		-1,
		156,
		136,
		128,
		117,
		106,
		104,
		95,
		86,
		108,
		124,
		108,
		106,
		111,
		116,
		-1,
		229,
		228,
		-1,
		175,
		167,
		153,
		-1,
		146,
		-1,
		152,
		113,
		-1,
		115,
		95,
		-1,
		117,
		113,
		-1,
		-1,
		216,
		191,
		-1,
		-1,
		-1,
		176,
		156,
		147,
		131,
		-1,
		106,
		106,
		-1,
		-1,
		-1,
		201,
		200,
		-1,
		169,
		172,
		-1,
		162,
		153,
		161,
		108,
		112,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		184,
		182,
		177,
		174,
		160,
		144,
		122,
		111,
		132,
		-1,
		-1,
		-1,
		182,
		174,
		167,
		-1,
		-1,
		169,
		152,
		133,
		131,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		159,
		-1,
		-1,
		165,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		193,
		-1,
		-1,
		-1,
		155,
		151,
		152,
		-1,
		-1,
		-1,
		-1,
		215,
		216,
		239,
		203,
		-1,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		218,
		216,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		145,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		180,
		-1,
		180,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		193,
		-1,
		165,
		167,
		-1,
		215,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		170,
		177,
		199,
		202,
		238,
		-1,
		189
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		144,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		132,
		138,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		112,
		108,
		105,
		119,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		106,
		105,
		115,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		134,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		101,
		105,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		130,
		137,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		103,
		119,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		129,
		125,
		132,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		98,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		158,
		145,
		125,
		117,
		132,
		131,
		118,
		117,
		98,
		91,
		88,
		81,
		94,
		104,
		109,
		96,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		154,
		145,
		133,
		123,
		113,
		118,
		119,
		109,
		107,
		96,
		98,
		92,
		83,
		82,
		98,
		90,
		112,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		173,
		152,
		134,
		-1,
		-1,
		117,
		110,
		104,
		107,
		95,
		112,
		107,
		91,
		76,
		91,
		95,
		103,
		94,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		185,
		130,
		119,
		114,
		118,
		116,
		-1,
		90,
		101,
		94,
		113,
		120,
		93,
		78,
		72,
		78,
		90,
		99,
		-1,
		-1,
		202,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		142,
		136,
		107,
		100,
		104,
		-1,
		92,
		94,
		91,
		103,
		96,
		93,
		84,
		75,
		71,
		75,
		79,
		93,
		97,
		225,
		-1,
		163,
		-1,
		-1,
		-1,
		160,
		175,
		146,
		123,
		96,
		91,
		84,
		78,
		83,
		94,
		103,
		114,
		79,
		78,
		68,
		67,
		71,
		88,
		92,
		-1,
		-1,
		161,
		157,
		186,
		168,
		172,
		173,
		-1,
		-1,
		100,
		91,
		82,
		74,
		87,
		90,
		75,
		77,
		77,
		72,
		66,
		76,
		91,
		86,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		171,
		118,
		100,
		96,
		94,
		81,
		75,
		65,
		70,
		80,
		74,
		71,
		62,
		66,
		89,
		78,
		117,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		133,
		130,
		-1,
		100,
		104,
		71,
		78,
		61,
		68,
		73,
		70,
		56,
		63,
		79,
		78,
		73,
		109,
		100,
		106,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		69,
		62,
		57,
		62,
		43,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		81,
		80,
		47,
		52,
		70,
		57,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		144,
		116,
		100,
		90,
		87,
		130,
		77,
		72,
		49,
		47,
		44,
		35,
		73,
		52,
		64,
		67,
		83,
		88,
		80,
		96,
		96,
		97,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		150,
		-1,
		127,
		-1,
		110,
		114,
		85,
		88,
		63,
		50,
		36,
		44,
		50,
		50,
		55,
		58,
		70,
		79,
		90,
		102,
		103,
		104,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		124,
		98,
		90,
		83,
		62,
		62,
		28,
		32,
		45,
		52,
		62,
		76,
		79,
		83,
		96,
		107,
		112,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		163,
		152,
		147,
		134,
		-1,
		-1,
		113,
		108,
		-1,
		-1,
		69,
		3,
		24,
		34,
		38,
		52,
		64,
		77,
		82,
		84,
		78,
		110,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		188,
		213,
		-1,
		123,
		-1,
		-1,
		93,
		-1,
		-1,
		78,
		0,
		10,
		21,
		40,
		46,
		57,
		79,
		78,
		93,
		83,
		93,
		106,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		202,
		-1,
		-1,
		139,
		119,
		-1,
		-1,
		76,
		74,
		63,
		-1,
		53,
		26,
		40,
		64,
		72,
		74,
		81,
		75,
		82,
		95,
		103,
		111,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		125,
		-1,
		-1,
		71,
		64,
		52,
		40,
		30,
		40,
		51,
		57,
		60,
		65,
		73,
		84,
		90,
		94,
		111,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		105,
		89,
		70,
		-1,
		40,
		53,
		93,
		61,
		66,
		61,
		79,
		90,
		93,
		96,
		109,
		105,
		-1,
		-1,
		155,
		158,
		-1,
		-1,
		136,
		138,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		77,
		73,
		-1,
		-1,
		41,
		75,
		64,
		72,
		67,
		79,
		89,
		87,
		95,
		99,
		106,
		-1,
		-1,
		157,
		149,
		143,
		-1,
		121,
		-1,
		139,
		-1,
		106,
		112,
		100,
		-1,
		-1,
		-1,
		79,
		42,
		63,
		82,
		87,
		85,
		76,
		75,
		82,
		92,
		100,
		106,
		-1,
		-1,
		-1,
		139,
		113,
		146,
		137,
		120,
		100,
		92,
		111,
		-1,
		78,
		-1,
		46,
		43,
		84,
		81,
		98,
		92,
		78,
		93,
		89,
		98,
		96,
		145,
		-1,
		115,
		148,
		112,
		106,
		82,
		86,
		102,
		-1,
		75,
		54,
		-1,
		88,
		78,
		115,
		101,
		89,
		76,
		83,
		97,
		93,
		-1,
		-1,
		-1,
		117,
		116,
		108,
		102,
		102,
		87,
		78,
		-1,
		90,
		72,
		51,
		68,
		68,
		59,
		67,
		105,
		101,
		94,
		96,
		88,
		-1,
		218,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		111,
		106,
		79,
		67,
		73,
		69,
		55,
		61,
		63,
		71,
		69,
		66,
		78,
		74,
		94,
		89,
		122,
		-1,
		213,
		-1,
		147,
		-1,
		-1,
		129,
		109,
		101,
		90,
		79,
		77,
		68,
		59,
		81,
		97,
		81,
		79,
		84,
		89,
		-1,
		202,
		201,
		-1,
		148,
		140,
		126,
		-1,
		119,
		-1,
		125,
		86,
		-1,
		88,
		68,
		-1,
		90,
		86,
		-1,
		-1,
		189,
		164,
		-1,
		-1,
		-1,
		149,
		129,
		120,
		104,
		-1,
		79,
		79,
		-1,
		-1,
		-1,
		174,
		173,
		-1,
		142,
		145,
		-1,
		135,
		126,
		134,
		81,
		85,
		-1,
		-1,
		-1,
		183,
		164,
		158,
		157,
		155,
		150,
		147,
		133,
		117,
		95,
		84,
		105,
		-1,
		-1,
		-1,
		155,
		147,
		140,
		-1,
		-1,
		142,
		125,
		106,
		104,
		-1,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		132,
		-1,
		-1,
		138,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		166,
		-1,
		-1,
		-1,
		128,
		124,
		125,
		-1,
		-1,
		-1,
		-1,
		188,
		189,
		212,
		176,
		-1,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		191,
		189,
		-1,
		-1,
		-1,
		148,
		132,
		-1,
		118,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		153,
		-1,
		153,
		128,
		135,
		-1,
		-1,
		-1,
		-1,
		166,
		158,
		166,
		-1,
		138,
		140,
		-1,
		188,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		143,
		150,
		172,
		175,
		211,
		-1,
		162
	],
	[
		-1,
		218,
		207,
		218,
		226,
		199,
		206,
		-1,
		225,
		229,
		195,
		189,
		228,
		197,
		203,
		214,
		-1,
		-1,
		-1,
		218,
		217,
		185,
		183,
		192,
		197,
		204,
		-1,
		203,
		-1,
		239,
		218,
		229,
		234,
		178,
		175,
		195,
		214,
		196,
		188,
		254,
		208,
		179,
		173,
		191,
		181,
		190,
		182,
		-1,
		179,
		169,
		191,
		170,
		181,
		173,
		-1,
		-1,
		173,
		174,
		180,
		166,
		172,
		168,
		-1,
		178,
		162,
		-1,
		-1,
		163,
		164,
		148,
		151,
		159,
		157,
		170,
		162,
		157,
		-1,
		-1,
		154,
		150,
		157,
		144,
		140,
		157,
		170,
		152,
		166,
		165,
		-1,
		158,
		176,
		183,
		151,
		149,
		133,
		131,
		149,
		151,
		157,
		157,
		-1,
		167,
		168,
		163,
		171,
		173,
		149,
		136,
		136,
		146,
		139,
		158,
		146,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		167,
		150,
		167,
		159,
		149,
		164,
		157,
		139,
		136,
		134,
		131,
		147,
		145,
		155,
		-1,
		-1,
		260,
		229,
		258,
		216,
		197,
		-1,
		163,
		143,
		149,
		153,
		147,
		140,
		154,
		150,
		-1,
		125,
		124,
		152,
		138,
		149,
		220,
		-1,
		-1,
		218,
		210,
		193,
		196,
		173,
		169,
		158,
		157,
		149,
		135,
		131,
		137,
		140,
		140,
		146,
		119,
		129,
		133,
		131,
		156,
		-1,
		-1,
		191,
		-1,
		-1,
		217,
		200,
		-1,
		183,
		190,
		179,
		185,
		171,
		192,
		168,
		159,
		151,
		145,
		133,
		135,
		132,
		145,
		133,
		116,
		141,
		145,
		126,
		147,
		142,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		176,
		179,
		185,
		209,
		208,
		-1,
		180,
		168,
		169,
		154,
		151,
		138,
		126,
		139,
		124,
		131,
		130,
		120,
		118,
		148,
		123,
		145,
		142,
		161,
		166,
		160,
		169,
		-1,
		225,
		221,
		217,
		224,
		173,
		-1,
		-1,
		213,
		-1,
		216,
		217,
		192,
		165,
		168,
		155,
		146,
		133,
		122,
		133,
		122,
		119,
		127,
		112,
		127,
		118,
		117,
		135,
		145,
		153,
		157,
		163,
		-1,
		275,
		-1,
		217,
		201,
		203,
		175,
		196,
		-1,
		233,
		217,
		209,
		194,
		194,
		-1,
		164,
		161,
		151,
		129,
		114,
		131,
		123,
		121,
		125,
		107,
		121,
		112,
		130,
		137,
		135,
		139,
		159,
		171,
		235,
		225,
		-1,
		207,
		212,
		171,
		179,
		198,
		236,
		200,
		-1,
		195,
		-1,
		166,
		179,
		-1,
		135,
		131,
		113,
		114,
		109,
		124,
		118,
		103,
		100,
		118,
		121,
		128,
		132,
		148,
		-1,
		-1,
		220,
		224,
		213,
		164,
		183,
		207,
		244,
		193,
		182,
		181,
		-1,
		172,
		149,
		146,
		134,
		121,
		106,
		107,
		115,
		128,
		107,
		102,
		99,
		119,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		190,
		161,
		185,
		227,
		211,
		204,
		192,
		157,
		157,
		151,
		-1,
		145,
		124,
		115,
		104,
		102,
		115,
		112,
		117,
		97,
		95,
		114,
		126,
		117,
		134,
		-1,
		-1,
		-1,
		220,
		209,
		210,
		156,
		179,
		216,
		190,
		176,
		181,
		156,
		149,
		143,
		158,
		141,
		122,
		111,
		103,
		92,
		108,
		116,
		111,
		93,
		102,
		108,
		132,
		122,
		128,
		-1,
		-1,
		227,
		217,
		201,
		203,
		200,
		170,
		177,
		209,
		181,
		194,
		-1,
		148,
		-1,
		137,
		132,
		116,
		111,
		108,
		105,
		99,
		108,
		110,
		100,
		95,
		102,
		137,
		137,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		220,
		215,
		190,
		167,
		151,
		187,
		-1,
		164,
		165,
		-1,
		142,
		136,
		133,
		118,
		114,
		109,
		113,
		106,
		113,
		106,
		104,
		105,
		87,
		119,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		213,
		192,
		185,
		205,
		146,
		198,
		-1,
		-1,
		149,
		142,
		-1,
		129,
		111,
		118,
		116,
		110,
		114,
		111,
		100,
		113,
		106,
		92,
		94,
		107,
		111,
		115,
		102,
		98,
		95,
		109,
		-1,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		166,
		-1,
		158,
		150,
		140,
		134,
		128,
		124,
		122,
		138,
		122,
		125,
		123,
		114,
		122,
		95,
		88,
		95,
		84,
		102,
		110,
		102,
		96,
		95,
		105,
		-1,
		233,
		219,
		190,
		-1,
		-1,
		179,
		-1,
		143,
		157,
		173,
		-1,
		166,
		145,
		160,
		138,
		134,
		130,
		145,
		146,
		124,
		123,
		121,
		112,
		100,
		89,
		92,
		84,
		106,
		106,
		90,
		91,
		95,
		-1,
		239,
		226,
		184,
		180,
		169,
		189,
		140,
		128,
		160,
		-1,
		-1,
		202,
		-1,
		136,
		153,
		144,
		142,
		135,
		120,
		127,
		132,
		109,
		104,
		94,
		83,
		83,
		78,
		100,
		86,
		84,
		93,
		109,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		155,
		142,
		136,
		-1,
		177,
		-1,
		180,
		170,
		154,
		139,
		172,
		-1,
		119,
		115,
		122,
		-1,
		129,
		-1,
		102,
		99,
		90,
		75,
		72,
		83,
		81,
		92,
		88,
		-1,
		189,
		174,
		167,
		157,
		171,
		142,
		-1,
		197,
		-1,
		-1,
		167,
		161,
		161,
		145,
		148,
		135,
		115,
		107,
		122,
		121,
		108,
		107,
		88,
		81,
		78,
		71,
		84,
		94,
		99,
		86,
		-1,
		-1,
		-1,
		194,
		180,
		184,
		144,
		163,
		-1,
		-1,
		229,
		184,
		170,
		-1,
		144,
		135,
		123,
		113,
		103,
		108,
		109,
		99,
		97,
		86,
		88,
		82,
		73,
		72,
		88,
		80,
		102,
		-1,
		-1,
		177,
		182,
		170,
		156,
		175,
		-1,
		-1,
		-1,
		176,
		192,
		163,
		142,
		124,
		-1,
		-1,
		107,
		100,
		94,
		97,
		85,
		102,
		97,
		81,
		66,
		81,
		85,
		93,
		84,
		-1,
		180,
		167,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		-1,
		-1,
		175,
		120,
		109,
		104,
		108,
		106,
		-1,
		80,
		91,
		84,
		103,
		110,
		83,
		68,
		62,
		68,
		80,
		89,
		-1,
		-1,
		192,
		-1,
		162,
		-1,
		-1,
		-1,
		-1,
		132,
		126,
		97,
		90,
		94,
		-1,
		82,
		84,
		81,
		93,
		86,
		83,
		74,
		65,
		61,
		65,
		69,
		83,
		87,
		215,
		-1,
		153,
		-1,
		-1,
		-1,
		150,
		165,
		136,
		113,
		86,
		81,
		74,
		68,
		73,
		84,
		93,
		104,
		69,
		68,
		58,
		57,
		61,
		78,
		82,
		-1,
		-1,
		151,
		147,
		176,
		158,
		162,
		163,
		-1,
		-1,
		90,
		81,
		72,
		64,
		77,
		80,
		65,
		67,
		67,
		62,
		56,
		66,
		81,
		76,
		-1,
		-1,
		-1,
		163,
		-1,
		165,
		-1,
		-1,
		153,
		161,
		108,
		90,
		86,
		84,
		71,
		65,
		55,
		60,
		70,
		64,
		61,
		52,
		56,
		79,
		68,
		107,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		142,
		134,
		129,
		135,
		137,
		128,
		123,
		120,
		-1,
		90,
		94,
		61,
		68,
		51,
		58,
		63,
		60,
		46,
		53,
		69,
		68,
		63,
		99,
		90,
		96,
		-1,
		-1,
		228,
		217,
		206,
		212,
		-1,
		135,
		131,
		121,
		111,
		114,
		-1,
		-1,
		108,
		105,
		85,
		54,
		59,
		52,
		47,
		52,
		33,
		42,
		46,
		50,
		56,
		61,
		66,
		72,
		87,
		102,
		-1,
		182,
		219,
		212,
		180,
		188,
		219,
		-1,
		125,
		117,
		128,
		103,
		105,
		-1,
		-1,
		81,
		72,
		73,
		61,
		58,
		71,
		70,
		37,
		42,
		60,
		47,
		48,
		66,
		70,
		79,
		86,
		76,
		89,
		93,
		-1,
		175,
		195,
		174,
		177,
		201,
		215,
		-1,
		122,
		-1,
		-1,
		134,
		106,
		90,
		80,
		77,
		120,
		67,
		62,
		39,
		37,
		34,
		25,
		63,
		42,
		54,
		57,
		73,
		78,
		70,
		86,
		86,
		87,
		-1,
		164,
		175,
		168,
		-1,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		140,
		-1,
		117,
		-1,
		100,
		104,
		75,
		78,
		53,
		40,
		26,
		34,
		40,
		40,
		45,
		48,
		60,
		69,
		80,
		92,
		93,
		94,
		189,
		145,
		148,
		159,
		170,
		185,
		189,
		-1,
		134,
		173,
		146,
		-1,
		130,
		-1,
		-1,
		-1,
		114,
		88,
		80,
		73,
		52,
		52,
		18,
		22,
		35,
		42,
		52,
		66,
		69,
		73,
		86,
		97,
		102,
		185,
		176,
		189,
		134,
		134,
		155,
		164,
		185,
		149,
		140,
		167,
		153,
		142,
		137,
		124,
		-1,
		-1,
		103,
		98,
		-1,
		-1,
		59,
		6,
		14,
		24,
		28,
		42,
		54,
		67,
		72,
		74,
		68,
		100,
		-1,
		178,
		177,
		166,
		163,
		139,
		130,
		125,
		152,
		-1,
		-1,
		147,
		168,
		158,
		162,
		178,
		203,
		-1,
		113,
		-1,
		-1,
		83,
		-1,
		-1,
		68,
		11,
		0,
		11,
		30,
		36,
		47,
		69,
		68,
		83,
		73,
		83,
		96,
		162,
		159,
		147,
		145,
		168,
		133,
		121,
		-1,
		134,
		132,
		138,
		145,
		162,
		192,
		-1,
		-1,
		129,
		109,
		-1,
		-1,
		66,
		64,
		53,
		-1,
		43,
		16,
		30,
		54,
		62,
		64,
		71,
		65,
		72,
		85,
		93,
		101,
		171,
		185,
		174,
		170,
		169,
		177,
		126,
		119,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		119,
		115,
		-1,
		-1,
		61,
		54,
		42,
		30,
		20,
		30,
		41,
		47,
		50,
		55,
		63,
		74,
		80,
		84,
		101,
		-1,
		205,
		-1,
		157,
		133,
		147,
		162,
		170,
		-1,
		-1,
		-1,
		136,
		122,
		115,
		103,
		101,
		-1,
		95,
		79,
		60,
		-1,
		30,
		43,
		83,
		51,
		56,
		51,
		69,
		80,
		83,
		86,
		99,
		95,
		-1,
		-1,
		145,
		148,
		-1,
		-1,
		126,
		128,
		-1,
		127,
		116,
		101,
		93,
		-1,
		-1,
		67,
		63,
		-1,
		-1,
		31,
		65,
		54,
		62,
		57,
		69,
		79,
		77,
		85,
		89,
		96,
		-1,
		-1,
		147,
		139,
		133,
		-1,
		111,
		-1,
		129,
		-1,
		96,
		102,
		90,
		-1,
		-1,
		-1,
		69,
		32,
		53,
		72,
		77,
		75,
		66,
		65,
		72,
		82,
		90,
		96,
		-1,
		-1,
		-1,
		129,
		103,
		136,
		127,
		110,
		90,
		82,
		101,
		-1,
		68,
		-1,
		36,
		33,
		74,
		71,
		88,
		82,
		68,
		83,
		79,
		88,
		86,
		135,
		-1,
		105,
		138,
		102,
		96,
		72,
		76,
		92,
		-1,
		65,
		44,
		-1,
		78,
		68,
		105,
		91,
		79,
		66,
		73,
		87,
		83,
		-1,
		-1,
		-1,
		107,
		106,
		98,
		92,
		92,
		77,
		68,
		-1,
		80,
		62,
		41,
		58,
		58,
		49,
		57,
		95,
		91,
		84,
		86,
		78,
		-1,
		208,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		101,
		96,
		69,
		57,
		63,
		59,
		45,
		51,
		53,
		61,
		59,
		56,
		68,
		64,
		84,
		79,
		112,
		-1,
		203,
		-1,
		137,
		-1,
		-1,
		119,
		99,
		91,
		80,
		69,
		67,
		58,
		49,
		71,
		87,
		71,
		69,
		74,
		79,
		-1,
		192,
		191,
		-1,
		138,
		130,
		116,
		-1,
		109,
		-1,
		115,
		76,
		-1,
		78,
		58,
		-1,
		80,
		76,
		-1,
		-1,
		179,
		154,
		-1,
		-1,
		-1,
		139,
		119,
		110,
		94,
		-1,
		69,
		69,
		-1,
		-1,
		-1,
		164,
		163,
		-1,
		132,
		135,
		-1,
		125,
		116,
		124,
		71,
		75,
		-1,
		-1,
		-1,
		173,
		154,
		148,
		147,
		145,
		140,
		137,
		123,
		107,
		85,
		74,
		95,
		-1,
		-1,
		-1,
		145,
		137,
		130,
		-1,
		-1,
		132,
		115,
		96,
		94,
		-1,
		-1,
		-1,
		167,
		148,
		-1,
		-1,
		122,
		-1,
		-1,
		128,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		156,
		-1,
		-1,
		-1,
		118,
		114,
		115,
		-1,
		-1,
		-1,
		-1,
		178,
		179,
		202,
		166,
		-1,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		181,
		179,
		-1,
		-1,
		-1,
		138,
		122,
		-1,
		108,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		143,
		-1,
		143,
		118,
		125,
		-1,
		-1,
		-1,
		-1,
		156,
		148,
		156,
		-1,
		128,
		130,
		-1,
		178,
		-1,
		-1,
		171,
		162,
		-1,
		-1,
		133,
		140,
		162,
		165,
		201,
		-1,
		152
	],
	[
		-1,
		207,
		196,
		207,
		215,
		188,
		195,
		-1,
		214,
		218,
		184,
		178,
		217,
		186,
		192,
		203,
		-1,
		-1,
		-1,
		207,
		206,
		174,
		172,
		181,
		186,
		193,
		-1,
		192,
		-1,
		228,
		207,
		218,
		223,
		167,
		164,
		184,
		203,
		185,
		177,
		243,
		197,
		168,
		162,
		180,
		170,
		179,
		171,
		-1,
		168,
		158,
		180,
		159,
		170,
		162,
		-1,
		-1,
		162,
		163,
		169,
		155,
		161,
		157,
		-1,
		167,
		151,
		-1,
		-1,
		152,
		153,
		137,
		140,
		148,
		146,
		159,
		151,
		146,
		-1,
		-1,
		143,
		139,
		146,
		133,
		129,
		146,
		159,
		141,
		155,
		154,
		-1,
		147,
		165,
		172,
		140,
		138,
		122,
		120,
		138,
		140,
		146,
		146,
		-1,
		156,
		157,
		152,
		160,
		162,
		138,
		125,
		125,
		135,
		128,
		147,
		135,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		156,
		139,
		156,
		148,
		138,
		153,
		146,
		128,
		125,
		123,
		120,
		136,
		134,
		144,
		-1,
		-1,
		249,
		218,
		247,
		205,
		186,
		-1,
		152,
		132,
		138,
		142,
		136,
		129,
		143,
		139,
		-1,
		114,
		113,
		141,
		127,
		138,
		209,
		-1,
		-1,
		207,
		199,
		182,
		185,
		162,
		158,
		147,
		146,
		138,
		124,
		120,
		126,
		129,
		129,
		135,
		108,
		118,
		122,
		120,
		145,
		-1,
		-1,
		180,
		-1,
		-1,
		206,
		189,
		-1,
		172,
		179,
		168,
		174,
		160,
		181,
		157,
		148,
		140,
		134,
		122,
		124,
		121,
		134,
		122,
		105,
		130,
		134,
		115,
		136,
		131,
		-1,
		179,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		165,
		168,
		174,
		198,
		197,
		-1,
		169,
		157,
		158,
		143,
		140,
		127,
		115,
		128,
		113,
		120,
		119,
		109,
		107,
		137,
		112,
		134,
		131,
		150,
		155,
		149,
		158,
		-1,
		214,
		210,
		206,
		213,
		162,
		-1,
		-1,
		202,
		-1,
		205,
		206,
		181,
		154,
		157,
		144,
		135,
		122,
		111,
		122,
		111,
		108,
		116,
		101,
		116,
		107,
		106,
		124,
		134,
		142,
		146,
		152,
		-1,
		264,
		-1,
		206,
		190,
		192,
		164,
		185,
		-1,
		222,
		206,
		198,
		183,
		183,
		-1,
		153,
		150,
		140,
		118,
		103,
		120,
		112,
		110,
		114,
		96,
		110,
		101,
		119,
		126,
		124,
		128,
		148,
		160,
		224,
		214,
		-1,
		196,
		201,
		160,
		168,
		187,
		225,
		189,
		-1,
		184,
		-1,
		155,
		168,
		-1,
		124,
		120,
		102,
		103,
		98,
		113,
		107,
		92,
		89,
		107,
		110,
		117,
		121,
		137,
		-1,
		-1,
		209,
		213,
		202,
		153,
		172,
		196,
		233,
		182,
		171,
		170,
		-1,
		161,
		138,
		135,
		123,
		110,
		95,
		96,
		104,
		117,
		96,
		91,
		88,
		108,
		134,
		112,
		124,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		179,
		150,
		174,
		216,
		200,
		193,
		181,
		146,
		146,
		140,
		-1,
		134,
		113,
		104,
		93,
		91,
		104,
		101,
		106,
		86,
		84,
		103,
		115,
		106,
		123,
		-1,
		-1,
		-1,
		209,
		198,
		199,
		145,
		168,
		205,
		179,
		165,
		170,
		145,
		138,
		132,
		147,
		130,
		111,
		100,
		92,
		81,
		97,
		105,
		100,
		82,
		91,
		97,
		121,
		111,
		117,
		-1,
		-1,
		216,
		206,
		190,
		192,
		189,
		159,
		166,
		198,
		170,
		183,
		-1,
		137,
		-1,
		126,
		121,
		105,
		100,
		97,
		94,
		88,
		97,
		99,
		89,
		84,
		91,
		126,
		126,
		101,
		121,
		124,
		-1,
		-1,
		-1,
		209,
		204,
		179,
		156,
		140,
		176,
		-1,
		153,
		154,
		-1,
		131,
		125,
		122,
		107,
		103,
		98,
		102,
		95,
		102,
		95,
		93,
		94,
		76,
		108,
		-1,
		109,
		103,
		111,
		101,
		89,
		-1,
		-1,
		-1,
		202,
		181,
		174,
		194,
		135,
		187,
		-1,
		-1,
		138,
		131,
		-1,
		118,
		100,
		107,
		105,
		99,
		103,
		100,
		89,
		102,
		95,
		81,
		83,
		96,
		100,
		104,
		91,
		87,
		84,
		98,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		155,
		-1,
		147,
		139,
		129,
		123,
		117,
		113,
		111,
		127,
		111,
		114,
		112,
		103,
		111,
		84,
		77,
		84,
		73,
		91,
		99,
		91,
		85,
		84,
		94,
		-1,
		222,
		208,
		179,
		-1,
		-1,
		168,
		-1,
		132,
		146,
		162,
		-1,
		155,
		134,
		149,
		127,
		123,
		119,
		134,
		135,
		113,
		112,
		110,
		101,
		89,
		78,
		81,
		73,
		95,
		95,
		79,
		80,
		84,
		-1,
		228,
		215,
		173,
		169,
		158,
		178,
		129,
		117,
		149,
		-1,
		-1,
		191,
		-1,
		125,
		142,
		133,
		131,
		124,
		109,
		116,
		121,
		98,
		93,
		83,
		72,
		72,
		67,
		89,
		75,
		73,
		82,
		98,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		144,
		131,
		125,
		-1,
		166,
		-1,
		169,
		159,
		143,
		128,
		161,
		-1,
		108,
		104,
		111,
		-1,
		118,
		-1,
		91,
		88,
		79,
		64,
		61,
		72,
		70,
		81,
		77,
		-1,
		178,
		163,
		156,
		146,
		160,
		131,
		-1,
		186,
		-1,
		-1,
		156,
		150,
		150,
		134,
		137,
		124,
		104,
		96,
		111,
		110,
		97,
		96,
		77,
		70,
		67,
		60,
		73,
		83,
		88,
		75,
		-1,
		-1,
		-1,
		183,
		169,
		173,
		133,
		152,
		-1,
		-1,
		218,
		173,
		159,
		-1,
		133,
		124,
		112,
		102,
		92,
		97,
		98,
		88,
		86,
		75,
		77,
		71,
		62,
		61,
		77,
		69,
		91,
		-1,
		-1,
		166,
		171,
		159,
		145,
		164,
		-1,
		-1,
		-1,
		165,
		181,
		152,
		131,
		113,
		-1,
		-1,
		96,
		89,
		83,
		86,
		74,
		91,
		86,
		70,
		55,
		70,
		74,
		82,
		73,
		-1,
		169,
		156,
		-1,
		-1,
		167,
		161,
		-1,
		-1,
		-1,
		-1,
		164,
		109,
		98,
		93,
		97,
		95,
		-1,
		69,
		80,
		73,
		92,
		99,
		72,
		57,
		51,
		57,
		69,
		78,
		-1,
		-1,
		181,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		121,
		115,
		86,
		79,
		83,
		-1,
		71,
		73,
		70,
		82,
		75,
		72,
		63,
		54,
		50,
		54,
		58,
		72,
		76,
		204,
		-1,
		142,
		-1,
		-1,
		-1,
		139,
		154,
		125,
		102,
		75,
		70,
		63,
		57,
		62,
		73,
		82,
		93,
		58,
		57,
		47,
		46,
		50,
		67,
		71,
		-1,
		-1,
		140,
		136,
		165,
		147,
		151,
		152,
		-1,
		-1,
		79,
		70,
		61,
		53,
		66,
		69,
		54,
		56,
		56,
		51,
		45,
		55,
		70,
		65,
		-1,
		-1,
		-1,
		152,
		-1,
		154,
		-1,
		-1,
		142,
		150,
		97,
		79,
		75,
		73,
		60,
		54,
		44,
		49,
		59,
		53,
		50,
		41,
		45,
		68,
		57,
		96,
		-1,
		-1,
		224,
		-1,
		-1,
		-1,
		131,
		123,
		118,
		124,
		126,
		117,
		112,
		109,
		-1,
		79,
		83,
		50,
		57,
		40,
		47,
		52,
		49,
		35,
		42,
		58,
		57,
		52,
		88,
		79,
		85,
		-1,
		-1,
		217,
		206,
		195,
		201,
		-1,
		124,
		120,
		110,
		100,
		103,
		-1,
		-1,
		97,
		94,
		74,
		43,
		48,
		41,
		36,
		41,
		22,
		31,
		35,
		39,
		45,
		50,
		55,
		61,
		76,
		91,
		-1,
		171,
		208,
		201,
		169,
		177,
		208,
		-1,
		114,
		106,
		117,
		92,
		94,
		-1,
		-1,
		70,
		61,
		62,
		50,
		47,
		60,
		59,
		26,
		31,
		49,
		36,
		37,
		55,
		59,
		68,
		75,
		65,
		78,
		82,
		-1,
		164,
		184,
		163,
		166,
		190,
		204,
		-1,
		111,
		-1,
		-1,
		123,
		95,
		79,
		69,
		66,
		109,
		56,
		51,
		28,
		26,
		23,
		14,
		52,
		31,
		43,
		46,
		62,
		67,
		59,
		75,
		75,
		76,
		-1,
		153,
		164,
		157,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		129,
		-1,
		106,
		-1,
		89,
		93,
		64,
		67,
		42,
		29,
		15,
		23,
		29,
		29,
		34,
		37,
		49,
		58,
		69,
		81,
		82,
		83,
		178,
		134,
		137,
		148,
		159,
		174,
		178,
		-1,
		123,
		162,
		135,
		-1,
		119,
		-1,
		-1,
		-1,
		103,
		77,
		69,
		62,
		41,
		41,
		7,
		11,
		24,
		31,
		41,
		55,
		58,
		62,
		75,
		86,
		91,
		174,
		165,
		178,
		123,
		123,
		144,
		153,
		174,
		138,
		129,
		156,
		142,
		131,
		126,
		113,
		-1,
		-1,
		92,
		87,
		-1,
		-1,
		48,
		15,
		3,
		13,
		17,
		31,
		43,
		56,
		61,
		63,
		57,
		89,
		-1,
		167,
		166,
		155,
		152,
		128,
		119,
		114,
		141,
		-1,
		-1,
		136,
		157,
		147,
		151,
		167,
		192,
		-1,
		102,
		-1,
		-1,
		72,
		-1,
		-1,
		57,
		20,
		9,
		0,
		19,
		25,
		36,
		58,
		57,
		72,
		62,
		72,
		85,
		151,
		148,
		136,
		134,
		157,
		122,
		110,
		-1,
		123,
		121,
		127,
		134,
		151,
		181,
		-1,
		-1,
		118,
		98,
		-1,
		-1,
		55,
		53,
		42,
		-1,
		32,
		5,
		19,
		47,
		51,
		53,
		60,
		54,
		61,
		74,
		82,
		90,
		160,
		174,
		163,
		159,
		158,
		166,
		115,
		108,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		-1,
		108,
		104,
		-1,
		-1,
		50,
		43,
		31,
		19,
		9,
		19,
		34,
		36,
		39,
		44,
		52,
		63,
		69,
		73,
		90,
		-1,
		194,
		-1,
		146,
		122,
		136,
		151,
		159,
		-1,
		-1,
		-1,
		125,
		111,
		104,
		92,
		90,
		-1,
		84,
		68,
		49,
		-1,
		19,
		32,
		72,
		40,
		45,
		40,
		58,
		69,
		72,
		75,
		88,
		84,
		-1,
		-1,
		134,
		137,
		-1,
		-1,
		115,
		117,
		-1,
		116,
		105,
		90,
		82,
		-1,
		-1,
		56,
		52,
		-1,
		-1,
		20,
		54,
		43,
		51,
		46,
		58,
		68,
		66,
		74,
		78,
		85,
		-1,
		-1,
		136,
		128,
		122,
		-1,
		100,
		-1,
		118,
		-1,
		85,
		91,
		79,
		-1,
		-1,
		-1,
		58,
		21,
		42,
		61,
		66,
		64,
		55,
		54,
		61,
		71,
		79,
		85,
		-1,
		-1,
		-1,
		118,
		92,
		125,
		116,
		99,
		79,
		71,
		90,
		-1,
		57,
		-1,
		25,
		22,
		63,
		60,
		77,
		71,
		57,
		72,
		68,
		77,
		75,
		124,
		-1,
		94,
		127,
		91,
		85,
		61,
		65,
		81,
		-1,
		54,
		33,
		-1,
		67,
		57,
		94,
		80,
		68,
		55,
		62,
		76,
		72,
		-1,
		-1,
		-1,
		96,
		95,
		87,
		81,
		81,
		66,
		57,
		-1,
		69,
		51,
		30,
		47,
		47,
		38,
		46,
		84,
		80,
		73,
		75,
		67,
		-1,
		197,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		90,
		85,
		58,
		46,
		52,
		48,
		34,
		40,
		42,
		50,
		48,
		45,
		57,
		53,
		73,
		68,
		101,
		-1,
		192,
		-1,
		126,
		-1,
		-1,
		108,
		88,
		80,
		69,
		58,
		56,
		47,
		38,
		60,
		76,
		60,
		58,
		63,
		68,
		-1,
		181,
		180,
		-1,
		127,
		119,
		105,
		-1,
		98,
		-1,
		104,
		65,
		-1,
		67,
		47,
		-1,
		69,
		65,
		-1,
		-1,
		168,
		143,
		-1,
		-1,
		-1,
		128,
		108,
		99,
		83,
		-1,
		58,
		58,
		-1,
		-1,
		-1,
		153,
		152,
		-1,
		121,
		124,
		-1,
		114,
		105,
		113,
		60,
		64,
		-1,
		-1,
		-1,
		162,
		143,
		137,
		136,
		134,
		129,
		126,
		112,
		96,
		74,
		63,
		84,
		-1,
		-1,
		-1,
		134,
		126,
		119,
		-1,
		-1,
		121,
		104,
		85,
		83,
		-1,
		-1,
		-1,
		156,
		137,
		-1,
		-1,
		111,
		-1,
		-1,
		117,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		145,
		-1,
		-1,
		-1,
		107,
		103,
		104,
		-1,
		-1,
		-1,
		-1,
		167,
		168,
		191,
		155,
		-1,
		-1,
		-1,
		99,
		93,
		-1,
		-1,
		170,
		168,
		-1,
		-1,
		-1,
		127,
		111,
		-1,
		97,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		132,
		-1,
		132,
		107,
		114,
		-1,
		-1,
		-1,
		-1,
		145,
		137,
		145,
		-1,
		117,
		119,
		-1,
		167,
		-1,
		-1,
		160,
		151,
		-1,
		-1,
		122,
		129,
		151,
		154,
		190,
		-1,
		141
	],
	[
		-1,
		212,
		201,
		212,
		220,
		193,
		200,
		-1,
		219,
		223,
		189,
		183,
		222,
		191,
		197,
		208,
		-1,
		-1,
		-1,
		212,
		211,
		179,
		177,
		186,
		191,
		198,
		-1,
		197,
		-1,
		233,
		212,
		223,
		228,
		172,
		169,
		189,
		208,
		190,
		182,
		248,
		202,
		173,
		167,
		185,
		175,
		184,
		176,
		-1,
		173,
		163,
		185,
		164,
		175,
		167,
		-1,
		-1,
		167,
		168,
		174,
		160,
		166,
		162,
		-1,
		172,
		156,
		-1,
		-1,
		157,
		158,
		142,
		145,
		153,
		151,
		164,
		156,
		151,
		-1,
		-1,
		148,
		144,
		151,
		138,
		134,
		151,
		164,
		146,
		160,
		159,
		-1,
		152,
		170,
		177,
		145,
		143,
		127,
		125,
		143,
		145,
		151,
		151,
		-1,
		161,
		162,
		157,
		165,
		167,
		143,
		130,
		130,
		140,
		133,
		152,
		140,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		161,
		144,
		161,
		153,
		143,
		158,
		151,
		133,
		130,
		128,
		125,
		141,
		139,
		149,
		-1,
		-1,
		254,
		223,
		252,
		210,
		191,
		-1,
		157,
		137,
		143,
		147,
		141,
		134,
		148,
		144,
		-1,
		119,
		118,
		146,
		132,
		143,
		214,
		-1,
		-1,
		212,
		204,
		187,
		190,
		167,
		163,
		152,
		151,
		143,
		129,
		125,
		131,
		134,
		134,
		140,
		113,
		123,
		127,
		125,
		150,
		-1,
		-1,
		185,
		-1,
		-1,
		211,
		194,
		-1,
		177,
		184,
		173,
		179,
		165,
		186,
		162,
		153,
		145,
		139,
		127,
		129,
		126,
		139,
		127,
		110,
		135,
		139,
		120,
		141,
		136,
		-1,
		184,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		170,
		173,
		179,
		203,
		202,
		-1,
		174,
		162,
		163,
		148,
		145,
		132,
		120,
		133,
		118,
		125,
		124,
		114,
		112,
		142,
		117,
		139,
		136,
		155,
		160,
		154,
		163,
		-1,
		219,
		215,
		211,
		218,
		167,
		-1,
		-1,
		207,
		-1,
		210,
		211,
		186,
		159,
		162,
		149,
		140,
		127,
		116,
		127,
		116,
		113,
		121,
		106,
		121,
		112,
		111,
		129,
		139,
		147,
		151,
		157,
		-1,
		269,
		-1,
		211,
		195,
		197,
		169,
		190,
		-1,
		227,
		211,
		203,
		188,
		188,
		-1,
		158,
		155,
		145,
		123,
		108,
		125,
		117,
		115,
		119,
		101,
		115,
		106,
		124,
		131,
		129,
		133,
		153,
		165,
		229,
		219,
		-1,
		201,
		206,
		165,
		173,
		192,
		230,
		194,
		-1,
		189,
		-1,
		160,
		173,
		-1,
		129,
		125,
		107,
		108,
		103,
		118,
		112,
		97,
		94,
		112,
		115,
		122,
		126,
		142,
		-1,
		-1,
		214,
		218,
		207,
		158,
		177,
		201,
		238,
		187,
		176,
		175,
		-1,
		166,
		143,
		140,
		128,
		115,
		100,
		101,
		109,
		122,
		101,
		96,
		93,
		113,
		139,
		117,
		129,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		184,
		155,
		179,
		221,
		205,
		198,
		186,
		151,
		151,
		145,
		-1,
		139,
		118,
		109,
		98,
		96,
		109,
		106,
		111,
		91,
		89,
		108,
		120,
		111,
		128,
		-1,
		-1,
		-1,
		214,
		203,
		204,
		150,
		173,
		210,
		184,
		170,
		175,
		150,
		143,
		137,
		152,
		135,
		116,
		105,
		97,
		86,
		102,
		110,
		105,
		87,
		96,
		102,
		126,
		116,
		122,
		-1,
		-1,
		221,
		211,
		195,
		197,
		194,
		164,
		171,
		203,
		175,
		188,
		-1,
		142,
		-1,
		131,
		126,
		110,
		105,
		102,
		99,
		93,
		102,
		104,
		94,
		89,
		96,
		131,
		131,
		106,
		126,
		129,
		-1,
		-1,
		-1,
		214,
		209,
		184,
		161,
		145,
		181,
		-1,
		158,
		159,
		-1,
		136,
		130,
		127,
		112,
		108,
		103,
		107,
		100,
		107,
		100,
		98,
		99,
		81,
		113,
		-1,
		114,
		108,
		116,
		106,
		94,
		-1,
		-1,
		-1,
		207,
		186,
		179,
		199,
		140,
		192,
		-1,
		-1,
		143,
		136,
		-1,
		123,
		105,
		112,
		110,
		104,
		108,
		105,
		94,
		107,
		100,
		86,
		88,
		101,
		105,
		109,
		96,
		92,
		89,
		103,
		-1,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		160,
		-1,
		152,
		144,
		134,
		128,
		122,
		118,
		116,
		132,
		116,
		119,
		117,
		108,
		116,
		89,
		82,
		89,
		78,
		96,
		104,
		96,
		90,
		89,
		99,
		-1,
		227,
		213,
		184,
		-1,
		-1,
		173,
		-1,
		137,
		151,
		167,
		-1,
		160,
		139,
		154,
		132,
		128,
		124,
		139,
		140,
		118,
		117,
		115,
		106,
		94,
		83,
		86,
		78,
		100,
		100,
		84,
		85,
		89,
		-1,
		233,
		220,
		178,
		174,
		163,
		183,
		134,
		122,
		154,
		-1,
		-1,
		196,
		-1,
		130,
		147,
		138,
		136,
		129,
		114,
		121,
		126,
		103,
		98,
		88,
		77,
		77,
		72,
		94,
		80,
		78,
		87,
		103,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		149,
		136,
		130,
		-1,
		171,
		-1,
		174,
		164,
		148,
		133,
		166,
		-1,
		113,
		109,
		116,
		-1,
		123,
		-1,
		96,
		93,
		84,
		69,
		66,
		77,
		75,
		86,
		82,
		-1,
		183,
		168,
		161,
		151,
		165,
		136,
		-1,
		191,
		-1,
		-1,
		161,
		155,
		155,
		139,
		142,
		129,
		109,
		101,
		116,
		115,
		102,
		101,
		82,
		75,
		72,
		65,
		78,
		88,
		93,
		80,
		-1,
		-1,
		-1,
		188,
		174,
		178,
		138,
		157,
		-1,
		-1,
		223,
		178,
		164,
		-1,
		138,
		129,
		117,
		107,
		97,
		102,
		103,
		93,
		91,
		80,
		82,
		76,
		67,
		66,
		82,
		74,
		96,
		-1,
		-1,
		171,
		176,
		164,
		150,
		169,
		-1,
		-1,
		-1,
		170,
		186,
		157,
		136,
		118,
		-1,
		-1,
		101,
		94,
		88,
		91,
		79,
		96,
		91,
		75,
		60,
		75,
		79,
		87,
		78,
		-1,
		174,
		161,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		-1,
		-1,
		169,
		114,
		103,
		98,
		102,
		100,
		-1,
		74,
		85,
		78,
		97,
		104,
		77,
		62,
		56,
		62,
		74,
		83,
		-1,
		-1,
		186,
		-1,
		156,
		-1,
		-1,
		-1,
		-1,
		126,
		120,
		91,
		84,
		88,
		-1,
		76,
		78,
		75,
		87,
		80,
		77,
		68,
		59,
		55,
		59,
		63,
		77,
		81,
		209,
		-1,
		147,
		-1,
		-1,
		-1,
		144,
		159,
		130,
		107,
		80,
		75,
		68,
		62,
		67,
		78,
		87,
		98,
		63,
		62,
		52,
		51,
		55,
		72,
		76,
		-1,
		-1,
		145,
		141,
		170,
		152,
		156,
		157,
		-1,
		-1,
		84,
		75,
		66,
		58,
		71,
		74,
		59,
		61,
		61,
		56,
		50,
		60,
		75,
		70,
		-1,
		-1,
		-1,
		157,
		-1,
		159,
		-1,
		-1,
		147,
		155,
		102,
		84,
		80,
		78,
		65,
		59,
		49,
		54,
		64,
		58,
		55,
		46,
		50,
		73,
		62,
		101,
		-1,
		-1,
		229,
		-1,
		-1,
		-1,
		136,
		128,
		123,
		129,
		131,
		122,
		117,
		114,
		-1,
		84,
		88,
		55,
		62,
		45,
		52,
		57,
		54,
		40,
		47,
		63,
		62,
		57,
		93,
		84,
		90,
		-1,
		-1,
		222,
		211,
		200,
		206,
		-1,
		129,
		125,
		115,
		105,
		108,
		-1,
		-1,
		102,
		99,
		79,
		48,
		53,
		46,
		41,
		46,
		27,
		36,
		40,
		44,
		50,
		55,
		60,
		66,
		81,
		96,
		-1,
		176,
		213,
		206,
		174,
		182,
		213,
		-1,
		119,
		111,
		122,
		97,
		99,
		-1,
		-1,
		75,
		66,
		67,
		55,
		52,
		65,
		64,
		31,
		28,
		50,
		33,
		42,
		60,
		64,
		71,
		72,
		70,
		83,
		87,
		-1,
		169,
		189,
		168,
		171,
		195,
		209,
		-1,
		116,
		-1,
		-1,
		128,
		100,
		84,
		74,
		71,
		114,
		61,
		56,
		33,
		31,
		28,
		19,
		49,
		28,
		40,
		43,
		59,
		64,
		56,
		80,
		80,
		81,
		-1,
		158,
		169,
		162,
		-1,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		133,
		-1,
		111,
		-1,
		94,
		98,
		69,
		72,
		47,
		34,
		20,
		20,
		26,
		26,
		31,
		34,
		46,
		55,
		66,
		78,
		87,
		88,
		183,
		139,
		142,
		153,
		164,
		179,
		183,
		-1,
		128,
		167,
		139,
		-1,
		123,
		-1,
		-1,
		-1,
		108,
		82,
		74,
		67,
		46,
		46,
		12,
		8,
		21,
		28,
		38,
		52,
		54,
		59,
		72,
		83,
		96,
		179,
		170,
		183,
		128,
		128,
		149,
		158,
		179,
		143,
		134,
		161,
		146,
		135,
		130,
		117,
		-1,
		-1,
		96,
		92,
		-1,
		-1,
		53,
		33,
		16,
		10,
		14,
		28,
		40,
		53,
		46,
		60,
		54,
		86,
		-1,
		172,
		171,
		160,
		157,
		133,
		124,
		119,
		146,
		-1,
		-1,
		141,
		162,
		152,
		156,
		172,
		197,
		-1,
		106,
		-1,
		-1,
		76,
		-1,
		-1,
		61,
		38,
		27,
		18,
		0,
		22,
		33,
		55,
		42,
		59,
		59,
		69,
		82,
		156,
		153,
		141,
		139,
		162,
		127,
		115,
		-1,
		128,
		126,
		132,
		139,
		156,
		186,
		-1,
		-1,
		122,
		102,
		-1,
		-1,
		59,
		57,
		46,
		-1,
		36,
		18,
		4,
		29,
		36,
		38,
		45,
		39,
		46,
		71,
		79,
		86,
		165,
		179,
		168,
		164,
		163,
		171,
		120,
		113,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		-1,
		112,
		108,
		-1,
		-1,
		54,
		47,
		35,
		23,
		13,
		18,
		21,
		21,
		24,
		29,
		37,
		48,
		62,
		66,
		80,
		-1,
		199,
		-1,
		151,
		127,
		141,
		156,
		164,
		-1,
		-1,
		-1,
		129,
		115,
		108,
		96,
		94,
		-1,
		88,
		72,
		53,
		-1,
		23,
		36,
		57,
		25,
		30,
		25,
		43,
		54,
		65,
		68,
		73,
		76,
		-1,
		-1,
		139,
		142,
		-1,
		-1,
		119,
		121,
		-1,
		120,
		109,
		94,
		86,
		-1,
		-1,
		60,
		56,
		-1,
		-1,
		24,
		39,
		28,
		36,
		31,
		43,
		53,
		51,
		63,
		71,
		70,
		-1,
		-1,
		140,
		132,
		126,
		-1,
		104,
		-1,
		122,
		-1,
		89,
		95,
		83,
		-1,
		-1,
		-1,
		62,
		25,
		46,
		46,
		51,
		49,
		40,
		39,
		46,
		56,
		64,
		70,
		-1,
		-1,
		-1,
		122,
		96,
		129,
		120,
		103,
		83,
		75,
		94,
		-1,
		61,
		-1,
		29,
		26,
		60,
		45,
		62,
		56,
		42,
		57,
		53,
		62,
		60,
		128,
		-1,
		98,
		131,
		95,
		89,
		65,
		69,
		85,
		-1,
		58,
		37,
		-1,
		71,
		61,
		79,
		65,
		53,
		40,
		47,
		61,
		57,
		-1,
		-1,
		-1,
		100,
		99,
		91,
		85,
		85,
		70,
		61,
		-1,
		73,
		55,
		34,
		51,
		51,
		42,
		50,
		69,
		65,
		58,
		60,
		52,
		-1,
		201,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		94,
		89,
		62,
		50,
		56,
		52,
		38,
		44,
		46,
		54,
		52,
		49,
		61,
		57,
		74,
		53,
		89,
		-1,
		196,
		-1,
		130,
		-1,
		-1,
		112,
		92,
		84,
		73,
		62,
		60,
		51,
		42,
		64,
		80,
		64,
		62,
		60,
		61,
		-1,
		185,
		184,
		-1,
		131,
		123,
		109,
		-1,
		102,
		-1,
		108,
		69,
		-1,
		71,
		51,
		-1,
		73,
		65,
		-1,
		-1,
		172,
		147,
		-1,
		-1,
		-1,
		132,
		112,
		103,
		87,
		-1,
		62,
		62,
		-1,
		-1,
		-1,
		157,
		156,
		-1,
		125,
		128,
		-1,
		118,
		109,
		117,
		64,
		68,
		-1,
		-1,
		-1,
		166,
		147,
		141,
		140,
		138,
		133,
		130,
		116,
		100,
		78,
		67,
		88,
		-1,
		-1,
		-1,
		138,
		130,
		123,
		-1,
		-1,
		125,
		108,
		89,
		87,
		-1,
		-1,
		-1,
		160,
		141,
		-1,
		-1,
		115,
		-1,
		-1,
		121,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		149,
		-1,
		-1,
		-1,
		111,
		107,
		108,
		-1,
		-1,
		-1,
		-1,
		171,
		172,
		195,
		159,
		-1,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		174,
		172,
		-1,
		-1,
		-1,
		131,
		115,
		-1,
		101,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		136,
		-1,
		136,
		111,
		118,
		-1,
		-1,
		-1,
		-1,
		149,
		141,
		149,
		-1,
		121,
		123,
		-1,
		171,
		-1,
		-1,
		164,
		155,
		-1,
		-1,
		126,
		133,
		155,
		158,
		194,
		-1,
		145
	],
	[
		-1,
		210,
		199,
		210,
		218,
		191,
		198,
		-1,
		217,
		221,
		187,
		181,
		220,
		189,
		195,
		206,
		-1,
		-1,
		-1,
		210,
		209,
		177,
		175,
		184,
		189,
		196,
		-1,
		195,
		-1,
		231,
		210,
		221,
		226,
		170,
		167,
		187,
		206,
		188,
		180,
		246,
		200,
		171,
		165,
		183,
		173,
		182,
		174,
		-1,
		171,
		161,
		183,
		162,
		173,
		165,
		-1,
		-1,
		165,
		166,
		172,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		155,
		156,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		146,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		150,
		168,
		175,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		149,
		-1,
		159,
		160,
		155,
		163,
		165,
		141,
		128,
		128,
		138,
		131,
		150,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		142,
		159,
		151,
		141,
		156,
		149,
		131,
		128,
		126,
		123,
		139,
		137,
		147,
		-1,
		-1,
		252,
		221,
		250,
		208,
		189,
		-1,
		155,
		135,
		141,
		145,
		139,
		132,
		146,
		142,
		-1,
		117,
		116,
		144,
		130,
		141,
		212,
		-1,
		-1,
		210,
		202,
		185,
		188,
		165,
		161,
		150,
		149,
		141,
		127,
		123,
		129,
		132,
		132,
		138,
		111,
		121,
		125,
		123,
		148,
		-1,
		-1,
		183,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		171,
		177,
		163,
		184,
		160,
		151,
		143,
		137,
		125,
		127,
		124,
		137,
		125,
		108,
		133,
		137,
		118,
		139,
		134,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		200,
		-1,
		172,
		160,
		161,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		122,
		112,
		110,
		140,
		115,
		137,
		134,
		153,
		158,
		152,
		161,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		208,
		209,
		184,
		157,
		160,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		119,
		104,
		119,
		110,
		109,
		127,
		137,
		145,
		149,
		155,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		209,
		201,
		186,
		186,
		-1,
		156,
		153,
		143,
		121,
		106,
		123,
		115,
		113,
		117,
		99,
		113,
		104,
		122,
		129,
		127,
		131,
		151,
		163,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		228,
		192,
		-1,
		187,
		-1,
		158,
		171,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		110,
		95,
		92,
		110,
		113,
		120,
		124,
		140,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		185,
		174,
		173,
		-1,
		164,
		141,
		138,
		126,
		113,
		98,
		99,
		107,
		120,
		99,
		94,
		91,
		111,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		203,
		196,
		184,
		149,
		149,
		143,
		-1,
		137,
		116,
		107,
		96,
		94,
		107,
		104,
		109,
		89,
		87,
		106,
		118,
		109,
		126,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		182,
		168,
		173,
		148,
		141,
		135,
		150,
		133,
		114,
		103,
		95,
		84,
		100,
		108,
		103,
		85,
		94,
		100,
		124,
		114,
		120,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		173,
		186,
		-1,
		140,
		-1,
		129,
		124,
		108,
		103,
		100,
		97,
		91,
		100,
		102,
		92,
		87,
		94,
		129,
		129,
		104,
		124,
		127,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		110,
		106,
		101,
		105,
		98,
		105,
		98,
		96,
		97,
		79,
		111,
		-1,
		112,
		106,
		114,
		104,
		92,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		110,
		108,
		102,
		106,
		103,
		92,
		105,
		98,
		84,
		86,
		99,
		103,
		107,
		94,
		90,
		87,
		101,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		130,
		114,
		117,
		115,
		106,
		114,
		87,
		80,
		87,
		76,
		94,
		102,
		94,
		88,
		87,
		97,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		149,
		165,
		-1,
		158,
		137,
		152,
		130,
		126,
		122,
		137,
		138,
		116,
		115,
		113,
		104,
		92,
		81,
		84,
		76,
		98,
		98,
		82,
		83,
		87,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		120,
		152,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		136,
		134,
		127,
		118,
		124,
		124,
		101,
		96,
		86,
		75,
		75,
		70,
		92,
		78,
		76,
		85,
		101,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		120,
		116,
		123,
		-1,
		121,
		-1,
		94,
		91,
		82,
		67,
		64,
		75,
		73,
		84,
		80,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		189,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		136,
		116,
		108,
		123,
		116,
		108,
		102,
		80,
		73,
		70,
		63,
		76,
		86,
		91,
		78,
		-1,
		-1,
		-1,
		186,
		172,
		176,
		136,
		155,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		145,
		136,
		124,
		114,
		104,
		109,
		110,
		99,
		92,
		78,
		80,
		74,
		65,
		64,
		80,
		72,
		94,
		-1,
		-1,
		169,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		168,
		184,
		164,
		143,
		125,
		-1,
		-1,
		108,
		101,
		95,
		95,
		82,
		94,
		89,
		73,
		58,
		73,
		77,
		85,
		76,
		-1,
		172,
		159,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		176,
		121,
		110,
		105,
		109,
		107,
		-1,
		81,
		92,
		85,
		98,
		105,
		75,
		60,
		54,
		60,
		72,
		81,
		-1,
		-1,
		184,
		-1,
		163,
		-1,
		-1,
		-1,
		-1,
		133,
		127,
		98,
		91,
		95,
		-1,
		83,
		85,
		82,
		94,
		78,
		75,
		66,
		57,
		53,
		57,
		61,
		75,
		79,
		207,
		-1,
		154,
		-1,
		-1,
		-1,
		151,
		166,
		137,
		114,
		87,
		82,
		75,
		69,
		74,
		85,
		86,
		97,
		64,
		60,
		50,
		49,
		53,
		70,
		74,
		-1,
		-1,
		152,
		148,
		177,
		159,
		163,
		164,
		-1,
		-1,
		91,
		82,
		73,
		65,
		78,
		81,
		66,
		67,
		61,
		54,
		48,
		58,
		73,
		68,
		-1,
		-1,
		-1,
		164,
		-1,
		166,
		-1,
		-1,
		154,
		162,
		109,
		91,
		87,
		85,
		72,
		66,
		56,
		61,
		71,
		62,
		56,
		44,
		48,
		71,
		60,
		97,
		-1,
		-1,
		236,
		-1,
		-1,
		-1,
		143,
		135,
		130,
		136,
		138,
		129,
		124,
		121,
		-1,
		91,
		95,
		62,
		69,
		52,
		59,
		64,
		58,
		38,
		45,
		61,
		60,
		55,
		89,
		80,
		84,
		-1,
		-1,
		229,
		218,
		207,
		213,
		-1,
		136,
		132,
		122,
		112,
		115,
		-1,
		-1,
		109,
		106,
		86,
		55,
		60,
		53,
		48,
		53,
		34,
		34,
		38,
		42,
		48,
		53,
		58,
		64,
		75,
		90,
		-1,
		183,
		220,
		213,
		181,
		189,
		220,
		-1,
		126,
		118,
		129,
		104,
		106,
		-1,
		-1,
		82,
		73,
		74,
		62,
		59,
		72,
		71,
		38,
		35,
		49,
		27,
		37,
		58,
		61,
		65,
		66,
		68,
		81,
		85,
		-1,
		176,
		196,
		175,
		178,
		202,
		216,
		-1,
		123,
		-1,
		-1,
		135,
		107,
		91,
		81,
		78,
		121,
		68,
		63,
		40,
		38,
		35,
		26,
		45,
		22,
		34,
		37,
		53,
		58,
		50,
		76,
		78,
		79,
		-1,
		165,
		176,
		169,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		150,
		-1,
		118,
		-1,
		101,
		105,
		76,
		79,
		54,
		41,
		27,
		27,
		26,
		20,
		25,
		28,
		40,
		49,
		60,
		72,
		82,
		84,
		190,
		146,
		149,
		160,
		171,
		186,
		190,
		-1,
		135,
		174,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		115,
		89,
		81,
		74,
		53,
		53,
		19,
		15,
		15,
		22,
		32,
		41,
		49,
		53,
		66,
		77,
		92,
		186,
		177,
		190,
		135,
		135,
		156,
		165,
		186,
		150,
		141,
		168,
		163,
		152,
		147,
		134,
		-1,
		-1,
		117,
		99,
		-1,
		-1,
		60,
		40,
		23,
		12,
		8,
		22,
		18,
		32,
		56,
		54,
		48,
		80,
		-1,
		179,
		178,
		167,
		164,
		140,
		131,
		126,
		153,
		-1,
		-1,
		148,
		169,
		159,
		163,
		179,
		204,
		-1,
		123,
		-1,
		-1,
		97,
		-1,
		-1,
		82,
		45,
		34,
		25,
		23,
		0,
		11,
		33,
		55,
		63,
		53,
		63,
		76,
		163,
		160,
		148,
		146,
		169,
		134,
		122,
		-1,
		135,
		133,
		139,
		146,
		163,
		193,
		-1,
		-1,
		139,
		119,
		-1,
		-1,
		80,
		78,
		67,
		-1,
		57,
		30,
		27,
		38,
		59,
		61,
		61,
		58,
		66,
		65,
		73,
		81,
		172,
		186,
		175,
		171,
		170,
		178,
		127,
		120,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		125,
		-1,
		-1,
		75,
		68,
		56,
		44,
		34,
		41,
		31,
		43,
		47,
		52,
		57,
		68,
		60,
		64,
		81,
		-1,
		206,
		-1,
		158,
		134,
		148,
		163,
		171,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		109,
		93,
		74,
		-1,
		44,
		57,
		80,
		48,
		53,
		48,
		63,
		74,
		63,
		66,
		80,
		75,
		-1,
		-1,
		146,
		149,
		-1,
		-1,
		136,
		138,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		81,
		77,
		-1,
		-1,
		45,
		61,
		50,
		59,
		54,
		66,
		73,
		74,
		65,
		69,
		81,
		-1,
		-1,
		153,
		149,
		143,
		-1,
		121,
		-1,
		139,
		-1,
		106,
		112,
		100,
		-1,
		-1,
		-1,
		83,
		46,
		67,
		68,
		74,
		72,
		63,
		62,
		69,
		76,
		72,
		83,
		-1,
		-1,
		-1,
		139,
		113,
		146,
		137,
		120,
		100,
		92,
		111,
		-1,
		81,
		-1,
		50,
		47,
		82,
		67,
		85,
		79,
		65,
		80,
		76,
		70,
		79,
		145,
		-1,
		115,
		148,
		112,
		106,
		82,
		86,
		102,
		-1,
		78,
		58,
		-1,
		88,
		78,
		102,
		88,
		76,
		63,
		70,
		83,
		76,
		-1,
		-1,
		-1,
		117,
		116,
		108,
		102,
		102,
		87,
		78,
		-1,
		90,
		72,
		51,
		68,
		68,
		59,
		67,
		92,
		88,
		81,
		83,
		75,
		-1,
		218,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		111,
		106,
		79,
		67,
		73,
		69,
		55,
		61,
		63,
		71,
		69,
		66,
		78,
		74,
		94,
		76,
		112,
		-1,
		213,
		-1,
		147,
		-1,
		-1,
		129,
		109,
		101,
		90,
		79,
		77,
		68,
		59,
		81,
		97,
		81,
		79,
		83,
		84,
		-1,
		202,
		201,
		-1,
		148,
		140,
		126,
		-1,
		119,
		-1,
		125,
		86,
		-1,
		88,
		68,
		-1,
		90,
		86,
		-1,
		-1,
		189,
		164,
		-1,
		-1,
		-1,
		149,
		129,
		120,
		104,
		-1,
		79,
		79,
		-1,
		-1,
		-1,
		174,
		173,
		-1,
		142,
		145,
		-1,
		135,
		126,
		134,
		81,
		85,
		-1,
		-1,
		-1,
		183,
		164,
		158,
		157,
		155,
		150,
		147,
		133,
		117,
		95,
		84,
		105,
		-1,
		-1,
		-1,
		155,
		147,
		140,
		-1,
		-1,
		142,
		125,
		106,
		104,
		-1,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		132,
		-1,
		-1,
		138,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		166,
		-1,
		-1,
		-1,
		128,
		124,
		125,
		-1,
		-1,
		-1,
		-1,
		188,
		189,
		212,
		176,
		-1,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		191,
		189,
		-1,
		-1,
		-1,
		148,
		132,
		-1,
		118,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		153,
		-1,
		153,
		128,
		135,
		-1,
		-1,
		-1,
		-1,
		166,
		158,
		166,
		-1,
		138,
		140,
		-1,
		188,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		143,
		150,
		172,
		175,
		211,
		-1,
		162
	],
	[
		-1,
		223,
		212,
		223,
		231,
		204,
		211,
		-1,
		230,
		234,
		200,
		194,
		233,
		202,
		208,
		219,
		-1,
		-1,
		-1,
		223,
		222,
		190,
		188,
		197,
		202,
		209,
		-1,
		208,
		-1,
		244,
		223,
		234,
		239,
		183,
		180,
		200,
		219,
		201,
		193,
		259,
		213,
		184,
		178,
		196,
		186,
		195,
		187,
		-1,
		184,
		174,
		196,
		175,
		186,
		178,
		-1,
		-1,
		178,
		179,
		185,
		171,
		177,
		173,
		-1,
		183,
		167,
		-1,
		-1,
		168,
		169,
		153,
		156,
		164,
		162,
		175,
		167,
		162,
		-1,
		-1,
		159,
		155,
		162,
		149,
		145,
		162,
		175,
		157,
		171,
		170,
		-1,
		163,
		181,
		188,
		156,
		154,
		138,
		136,
		154,
		156,
		162,
		162,
		-1,
		172,
		173,
		168,
		176,
		178,
		154,
		141,
		141,
		151,
		144,
		163,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		155,
		172,
		164,
		154,
		169,
		162,
		144,
		141,
		139,
		136,
		152,
		150,
		160,
		-1,
		-1,
		265,
		234,
		263,
		221,
		202,
		-1,
		168,
		148,
		154,
		158,
		152,
		145,
		159,
		155,
		-1,
		130,
		129,
		157,
		143,
		154,
		225,
		-1,
		-1,
		223,
		215,
		198,
		201,
		178,
		174,
		163,
		162,
		154,
		140,
		136,
		142,
		145,
		145,
		151,
		124,
		134,
		138,
		136,
		161,
		-1,
		-1,
		196,
		-1,
		-1,
		222,
		205,
		-1,
		188,
		195,
		184,
		190,
		176,
		197,
		173,
		164,
		156,
		150,
		138,
		140,
		137,
		150,
		138,
		121,
		146,
		150,
		131,
		152,
		147,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		181,
		184,
		190,
		214,
		213,
		-1,
		185,
		173,
		174,
		159,
		156,
		143,
		131,
		144,
		129,
		136,
		135,
		125,
		123,
		153,
		128,
		150,
		147,
		166,
		171,
		165,
		174,
		-1,
		230,
		226,
		222,
		229,
		178,
		-1,
		-1,
		218,
		-1,
		221,
		222,
		197,
		170,
		173,
		160,
		151,
		138,
		127,
		138,
		127,
		124,
		132,
		117,
		132,
		123,
		122,
		140,
		150,
		158,
		162,
		168,
		-1,
		280,
		-1,
		222,
		206,
		208,
		180,
		201,
		-1,
		238,
		222,
		214,
		199,
		199,
		-1,
		169,
		166,
		156,
		134,
		119,
		136,
		128,
		126,
		130,
		112,
		126,
		117,
		135,
		142,
		140,
		144,
		164,
		176,
		240,
		230,
		-1,
		212,
		217,
		176,
		184,
		203,
		241,
		205,
		-1,
		200,
		-1,
		171,
		184,
		-1,
		140,
		136,
		118,
		119,
		114,
		129,
		123,
		108,
		105,
		123,
		126,
		133,
		137,
		153,
		-1,
		-1,
		225,
		229,
		218,
		169,
		188,
		212,
		249,
		198,
		187,
		186,
		-1,
		177,
		154,
		151,
		139,
		126,
		111,
		112,
		120,
		133,
		112,
		107,
		104,
		124,
		150,
		128,
		140,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		195,
		166,
		190,
		232,
		216,
		209,
		197,
		162,
		162,
		156,
		-1,
		150,
		129,
		120,
		109,
		107,
		120,
		117,
		122,
		102,
		100,
		119,
		131,
		122,
		139,
		-1,
		-1,
		-1,
		225,
		214,
		215,
		161,
		184,
		221,
		195,
		181,
		186,
		161,
		154,
		148,
		163,
		146,
		127,
		116,
		108,
		97,
		113,
		121,
		116,
		98,
		107,
		113,
		137,
		127,
		133,
		-1,
		-1,
		232,
		222,
		206,
		208,
		205,
		175,
		182,
		214,
		186,
		199,
		-1,
		153,
		-1,
		142,
		137,
		121,
		116,
		113,
		110,
		104,
		113,
		115,
		105,
		100,
		107,
		142,
		142,
		117,
		137,
		140,
		-1,
		-1,
		-1,
		225,
		220,
		195,
		172,
		156,
		192,
		-1,
		169,
		170,
		-1,
		147,
		141,
		138,
		123,
		119,
		114,
		118,
		111,
		118,
		111,
		109,
		110,
		92,
		124,
		-1,
		125,
		119,
		127,
		117,
		105,
		-1,
		-1,
		-1,
		218,
		197,
		190,
		210,
		151,
		203,
		-1,
		-1,
		154,
		147,
		-1,
		134,
		116,
		123,
		121,
		115,
		119,
		116,
		105,
		118,
		111,
		97,
		99,
		112,
		116,
		120,
		107,
		103,
		100,
		114,
		-1,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		171,
		-1,
		163,
		155,
		145,
		139,
		133,
		129,
		127,
		143,
		127,
		130,
		128,
		119,
		127,
		100,
		93,
		100,
		89,
		107,
		115,
		107,
		101,
		100,
		110,
		-1,
		238,
		224,
		195,
		-1,
		-1,
		184,
		-1,
		148,
		162,
		178,
		-1,
		171,
		150,
		165,
		143,
		139,
		135,
		150,
		151,
		129,
		128,
		126,
		117,
		105,
		94,
		97,
		89,
		111,
		111,
		95,
		96,
		100,
		-1,
		244,
		231,
		189,
		185,
		174,
		194,
		145,
		133,
		165,
		-1,
		-1,
		207,
		-1,
		141,
		158,
		149,
		147,
		140,
		131,
		137,
		137,
		114,
		109,
		99,
		88,
		88,
		83,
		105,
		91,
		89,
		98,
		114,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		160,
		147,
		141,
		-1,
		182,
		-1,
		185,
		175,
		159,
		144,
		177,
		-1,
		133,
		129,
		136,
		-1,
		134,
		-1,
		107,
		104,
		95,
		80,
		77,
		88,
		86,
		97,
		93,
		-1,
		194,
		179,
		172,
		162,
		176,
		147,
		-1,
		202,
		-1,
		-1,
		172,
		166,
		166,
		150,
		153,
		149,
		129,
		121,
		136,
		129,
		121,
		115,
		93,
		86,
		83,
		76,
		89,
		99,
		104,
		91,
		-1,
		-1,
		-1,
		199,
		185,
		189,
		149,
		168,
		-1,
		-1,
		234,
		189,
		175,
		-1,
		158,
		149,
		137,
		127,
		117,
		122,
		123,
		112,
		105,
		91,
		93,
		87,
		78,
		77,
		93,
		85,
		107,
		-1,
		-1,
		182,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		181,
		197,
		177,
		156,
		138,
		-1,
		-1,
		121,
		114,
		108,
		108,
		95,
		107,
		102,
		86,
		71,
		86,
		90,
		98,
		89,
		-1,
		185,
		172,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		189,
		134,
		123,
		118,
		122,
		120,
		-1,
		94,
		105,
		98,
		111,
		118,
		88,
		73,
		67,
		73,
		85,
		94,
		-1,
		-1,
		197,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		146,
		140,
		111,
		104,
		108,
		-1,
		96,
		98,
		95,
		107,
		91,
		88,
		79,
		70,
		66,
		70,
		74,
		88,
		92,
		220,
		-1,
		167,
		-1,
		-1,
		-1,
		164,
		179,
		150,
		127,
		100,
		95,
		88,
		82,
		87,
		98,
		99,
		110,
		77,
		73,
		63,
		62,
		66,
		83,
		87,
		-1,
		-1,
		165,
		161,
		190,
		172,
		176,
		177,
		-1,
		-1,
		104,
		95,
		86,
		78,
		91,
		94,
		79,
		80,
		74,
		67,
		61,
		71,
		86,
		81,
		-1,
		-1,
		-1,
		177,
		-1,
		179,
		-1,
		-1,
		167,
		175,
		122,
		104,
		100,
		98,
		85,
		79,
		69,
		74,
		84,
		75,
		69,
		57,
		61,
		84,
		73,
		107,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		137,
		134,
		-1,
		104,
		108,
		75,
		82,
		65,
		72,
		77,
		71,
		51,
		58,
		74,
		73,
		68,
		99,
		90,
		94,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		122,
		119,
		99,
		68,
		73,
		66,
		61,
		66,
		47,
		47,
		51,
		52,
		61,
		66,
		71,
		77,
		85,
		100,
		-1,
		196,
		233,
		226,
		194,
		202,
		233,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		95,
		86,
		87,
		75,
		72,
		85,
		84,
		51,
		48,
		62,
		40,
		50,
		66,
		71,
		75,
		76,
		81,
		94,
		98,
		-1,
		189,
		209,
		188,
		191,
		215,
		229,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		91,
		134,
		81,
		76,
		53,
		51,
		48,
		39,
		58,
		35,
		42,
		45,
		63,
		68,
		60,
		86,
		88,
		92,
		-1,
		178,
		189,
		182,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		163,
		-1,
		131,
		-1,
		114,
		118,
		89,
		92,
		67,
		54,
		40,
		40,
		39,
		33,
		33,
		36,
		50,
		55,
		67,
		82,
		92,
		94,
		203,
		159,
		162,
		173,
		184,
		199,
		203,
		-1,
		148,
		187,
		169,
		-1,
		153,
		-1,
		-1,
		-1,
		128,
		102,
		94,
		87,
		66,
		66,
		32,
		28,
		28,
		30,
		34,
		30,
		52,
		54,
		76,
		87,
		102,
		199,
		190,
		203,
		148,
		148,
		169,
		178,
		199,
		163,
		154,
		181,
		176,
		165,
		160,
		147,
		-1,
		-1,
		130,
		112,
		-1,
		-1,
		73,
		53,
		36,
		25,
		21,
		35,
		7,
		21,
		48,
		64,
		58,
		90,
		-1,
		192,
		191,
		180,
		177,
		153,
		144,
		139,
		166,
		-1,
		-1,
		161,
		182,
		172,
		176,
		192,
		217,
		-1,
		136,
		-1,
		-1,
		110,
		-1,
		-1,
		95,
		58,
		47,
		38,
		36,
		13,
		0,
		22,
		44,
		72,
		63,
		73,
		86,
		176,
		173,
		161,
		159,
		182,
		147,
		135,
		-1,
		148,
		146,
		152,
		159,
		176,
		206,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		93,
		91,
		80,
		-1,
		70,
		43,
		40,
		51,
		72,
		64,
		50,
		47,
		59,
		75,
		83,
		91,
		185,
		199,
		188,
		184,
		183,
		191,
		140,
		133,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		88,
		81,
		69,
		57,
		47,
		54,
		44,
		56,
		60,
		55,
		50,
		61,
		70,
		74,
		91,
		-1,
		219,
		-1,
		171,
		147,
		161,
		176,
		184,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		122,
		106,
		87,
		-1,
		57,
		70,
		93,
		61,
		66,
		61,
		56,
		67,
		73,
		76,
		90,
		85,
		-1,
		-1,
		159,
		162,
		-1,
		-1,
		149,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		94,
		90,
		-1,
		-1,
		58,
		74,
		63,
		72,
		67,
		60,
		66,
		76,
		75,
		79,
		91,
		-1,
		-1,
		166,
		162,
		156,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		96,
		59,
		80,
		81,
		87,
		85,
		76,
		64,
		71,
		81,
		82,
		93,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		94,
		-1,
		63,
		60,
		95,
		80,
		98,
		92,
		67,
		82,
		82,
		80,
		89,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		91,
		71,
		-1,
		101,
		91,
		115,
		101,
		82,
		69,
		76,
		90,
		86,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		81,
		81,
		72,
		80,
		105,
		101,
		89,
		89,
		81,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		76,
		84,
		82,
		79,
		91,
		87,
		105,
		82,
		118,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		110,
		94,
		92,
		89,
		90,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		103,
		94,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		159,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		147,
		153,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		127,
		123,
		120,
		134,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		120,
		130,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		149,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		120,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		151,
		157,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		118,
		134,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		162,
		152,
		157,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		113,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		173,
		178,
		158,
		150,
		157,
		149,
		141,
		135,
		113,
		106,
		103,
		96,
		109,
		119,
		124,
		111,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		179,
		178,
		166,
		156,
		146,
		151,
		152,
		132,
		125,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		127,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		206,
		180,
		167,
		-1,
		-1,
		150,
		143,
		137,
		128,
		115,
		127,
		122,
		106,
		91,
		106,
		110,
		118,
		109,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		149,
		-1,
		123,
		134,
		119,
		131,
		138,
		108,
		93,
		87,
		93,
		105,
		114,
		-1,
		-1,
		217,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		125,
		127,
		121,
		136,
		111,
		108,
		99,
		90,
		86,
		90,
		94,
		108,
		112,
		240,
		-1,
		196,
		-1,
		-1,
		-1,
		193,
		208,
		179,
		156,
		129,
		124,
		117,
		111,
		116,
		127,
		119,
		130,
		97,
		93,
		83,
		82,
		86,
		103,
		107,
		-1,
		-1,
		194,
		190,
		219,
		201,
		205,
		206,
		-1,
		-1,
		133,
		124,
		115,
		107,
		120,
		123,
		103,
		100,
		94,
		87,
		81,
		91,
		106,
		101,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		196,
		204,
		151,
		133,
		129,
		127,
		114,
		108,
		98,
		103,
		104,
		95,
		89,
		77,
		81,
		104,
		93,
		121,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		166,
		163,
		-1,
		133,
		137,
		104,
		111,
		94,
		101,
		99,
		91,
		71,
		78,
		94,
		93,
		88,
		113,
		104,
		108,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		151,
		148,
		128,
		97,
		102,
		95,
		90,
		95,
		76,
		67,
		71,
		66,
		81,
		86,
		91,
		92,
		99,
		114,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		124,
		115,
		116,
		104,
		101,
		110,
		105,
		80,
		76,
		82,
		60,
		70,
		80,
		85,
		89,
		90,
		97,
		108,
		112,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		120,
		163,
		110,
		105,
		82,
		80,
		77,
		68,
		78,
		55,
		56,
		59,
		77,
		82,
		74,
		100,
		102,
		108,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		192,
		-1,
		160,
		-1,
		143,
		147,
		118,
		121,
		96,
		83,
		69,
		69,
		68,
		53,
		47,
		50,
		64,
		73,
		84,
		96,
		106,
		108,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		177,
		216,
		198,
		-1,
		182,
		-1,
		-1,
		-1,
		157,
		131,
		123,
		116,
		95,
		95,
		61,
		57,
		48,
		44,
		48,
		48,
		70,
		72,
		90,
		101,
		116,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		192,
		183,
		210,
		205,
		194,
		189,
		176,
		-1,
		-1,
		159,
		141,
		-1,
		-1,
		102,
		82,
		65,
		54,
		50,
		51,
		25,
		39,
		66,
		78,
		72,
		104,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		211,
		201,
		205,
		221,
		246,
		-1,
		165,
		-1,
		-1,
		139,
		-1,
		-1,
		124,
		87,
		76,
		67,
		65,
		42,
		29,
		0,
		62,
		87,
		77,
		87,
		100,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		235,
		-1,
		-1,
		181,
		161,
		-1,
		-1,
		122,
		120,
		109,
		-1,
		99,
		72,
		69,
		80,
		93,
		82,
		68,
		65,
		77,
		89,
		97,
		105,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		171,
		167,
		-1,
		-1,
		117,
		110,
		98,
		86,
		76,
		83,
		73,
		85,
		80,
		73,
		68,
		79,
		84,
		88,
		105,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		188,
		174,
		167,
		155,
		153,
		-1,
		151,
		135,
		116,
		-1,
		86,
		99,
		122,
		90,
		95,
		90,
		74,
		85,
		87,
		90,
		104,
		99,
		-1,
		-1,
		188,
		191,
		-1,
		-1,
		178,
		180,
		-1,
		179,
		168,
		153,
		145,
		-1,
		-1,
		123,
		119,
		-1,
		-1,
		87,
		103,
		92,
		101,
		96,
		78,
		84,
		94,
		89,
		93,
		105,
		-1,
		-1,
		195,
		191,
		185,
		-1,
		163,
		-1,
		181,
		-1,
		148,
		154,
		142,
		-1,
		-1,
		-1,
		125,
		88,
		109,
		110,
		107,
		105,
		96,
		82,
		89,
		99,
		96,
		107,
		-1,
		-1,
		-1,
		181,
		155,
		188,
		179,
		162,
		142,
		134,
		153,
		-1,
		123,
		-1,
		92,
		89,
		124,
		109,
		118,
		112,
		85,
		100,
		100,
		94,
		103,
		187,
		-1,
		157,
		190,
		154,
		148,
		124,
		128,
		144,
		-1,
		120,
		100,
		-1,
		130,
		120,
		134,
		119,
		100,
		87,
		94,
		107,
		100,
		-1,
		-1,
		-1,
		159,
		158,
		150,
		144,
		144,
		129,
		120,
		-1,
		132,
		114,
		93,
		110,
		110,
		101,
		109,
		124,
		120,
		107,
		107,
		99,
		-1,
		260,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		153,
		148,
		121,
		109,
		115,
		111,
		97,
		103,
		105,
		113,
		111,
		108,
		120,
		116,
		123,
		100,
		136,
		-1,
		255,
		-1,
		189,
		-1,
		-1,
		171,
		151,
		143,
		132,
		121,
		119,
		110,
		101,
		123,
		139,
		123,
		112,
		107,
		108,
		-1,
		244,
		243,
		-1,
		190,
		182,
		168,
		-1,
		161,
		-1,
		167,
		128,
		-1,
		130,
		110,
		-1,
		123,
		112,
		-1,
		-1,
		231,
		206,
		-1,
		-1,
		-1,
		191,
		171,
		162,
		146,
		-1,
		121,
		121,
		-1,
		-1,
		-1,
		216,
		215,
		-1,
		184,
		187,
		-1,
		177,
		168,
		176,
		123,
		127,
		-1,
		-1,
		-1,
		225,
		206,
		200,
		199,
		197,
		192,
		189,
		175,
		159,
		137,
		126,
		147,
		-1,
		-1,
		-1,
		197,
		189,
		182,
		-1,
		-1,
		184,
		167,
		148,
		146,
		-1,
		-1,
		-1,
		219,
		200,
		-1,
		-1,
		174,
		-1,
		-1,
		180,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		208,
		-1,
		-1,
		-1,
		170,
		166,
		167,
		-1,
		-1,
		-1,
		-1,
		230,
		231,
		254,
		218,
		-1,
		-1,
		-1,
		162,
		156,
		-1,
		-1,
		233,
		231,
		-1,
		-1,
		-1,
		190,
		174,
		-1,
		160,
		-1,
		-1,
		-1,
		181,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		195,
		-1,
		195,
		170,
		177,
		-1,
		-1,
		-1,
		-1,
		208,
		200,
		208,
		-1,
		180,
		182,
		-1,
		230,
		-1,
		-1,
		223,
		214,
		-1,
		-1,
		185,
		192,
		214,
		217,
		253,
		-1,
		204
	],
	[
		-1,
		211,
		200,
		211,
		219,
		192,
		199,
		-1,
		218,
		222,
		188,
		182,
		221,
		190,
		196,
		207,
		-1,
		-1,
		-1,
		211,
		210,
		178,
		176,
		185,
		190,
		197,
		-1,
		196,
		-1,
		232,
		211,
		222,
		227,
		171,
		168,
		188,
		207,
		189,
		181,
		247,
		201,
		172,
		166,
		184,
		174,
		183,
		175,
		-1,
		172,
		162,
		184,
		163,
		174,
		166,
		-1,
		-1,
		166,
		167,
		173,
		159,
		165,
		161,
		-1,
		171,
		155,
		-1,
		-1,
		156,
		157,
		141,
		144,
		152,
		150,
		163,
		155,
		150,
		-1,
		-1,
		147,
		143,
		150,
		137,
		133,
		150,
		163,
		145,
		159,
		158,
		-1,
		151,
		169,
		176,
		144,
		142,
		126,
		124,
		142,
		144,
		150,
		150,
		-1,
		160,
		161,
		156,
		164,
		166,
		142,
		129,
		129,
		139,
		132,
		151,
		139,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		160,
		143,
		160,
		152,
		142,
		157,
		150,
		132,
		129,
		127,
		124,
		140,
		138,
		148,
		-1,
		-1,
		253,
		222,
		251,
		209,
		190,
		-1,
		156,
		136,
		142,
		146,
		140,
		133,
		147,
		143,
		-1,
		118,
		117,
		145,
		131,
		142,
		213,
		-1,
		-1,
		211,
		203,
		186,
		189,
		166,
		162,
		151,
		150,
		142,
		128,
		124,
		130,
		133,
		133,
		139,
		112,
		122,
		126,
		124,
		149,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		193,
		-1,
		176,
		183,
		172,
		178,
		164,
		185,
		161,
		152,
		144,
		138,
		126,
		128,
		125,
		138,
		126,
		109,
		134,
		138,
		119,
		140,
		135,
		-1,
		183,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		169,
		172,
		178,
		202,
		201,
		-1,
		173,
		161,
		162,
		147,
		144,
		131,
		119,
		132,
		117,
		124,
		123,
		113,
		111,
		141,
		116,
		138,
		135,
		154,
		159,
		153,
		162,
		-1,
		218,
		214,
		210,
		217,
		166,
		-1,
		-1,
		206,
		-1,
		209,
		210,
		185,
		158,
		161,
		148,
		139,
		126,
		115,
		126,
		115,
		112,
		120,
		105,
		120,
		111,
		110,
		128,
		138,
		146,
		150,
		156,
		-1,
		268,
		-1,
		210,
		194,
		196,
		168,
		189,
		-1,
		226,
		210,
		202,
		187,
		187,
		-1,
		157,
		154,
		144,
		122,
		107,
		124,
		116,
		114,
		118,
		100,
		114,
		105,
		123,
		130,
		128,
		132,
		152,
		164,
		228,
		218,
		-1,
		200,
		205,
		164,
		172,
		191,
		229,
		193,
		-1,
		188,
		-1,
		159,
		172,
		-1,
		128,
		124,
		106,
		107,
		102,
		117,
		111,
		96,
		93,
		111,
		114,
		121,
		125,
		141,
		-1,
		-1,
		213,
		217,
		206,
		157,
		176,
		200,
		237,
		186,
		175,
		174,
		-1,
		165,
		142,
		139,
		127,
		114,
		99,
		100,
		108,
		121,
		100,
		95,
		92,
		112,
		138,
		116,
		128,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		183,
		154,
		178,
		220,
		204,
		197,
		185,
		150,
		150,
		144,
		-1,
		138,
		117,
		108,
		97,
		95,
		108,
		105,
		110,
		90,
		88,
		107,
		119,
		110,
		127,
		-1,
		-1,
		-1,
		213,
		202,
		203,
		149,
		172,
		209,
		183,
		169,
		174,
		149,
		142,
		136,
		151,
		134,
		115,
		104,
		96,
		85,
		101,
		109,
		104,
		86,
		95,
		101,
		125,
		115,
		121,
		-1,
		-1,
		220,
		210,
		194,
		196,
		193,
		163,
		170,
		202,
		174,
		187,
		-1,
		141,
		-1,
		130,
		125,
		109,
		104,
		101,
		98,
		92,
		101,
		103,
		93,
		88,
		95,
		130,
		130,
		105,
		125,
		128,
		-1,
		-1,
		-1,
		213,
		208,
		183,
		160,
		144,
		180,
		-1,
		157,
		158,
		-1,
		135,
		129,
		126,
		111,
		107,
		102,
		106,
		99,
		106,
		99,
		97,
		98,
		80,
		112,
		-1,
		113,
		107,
		115,
		105,
		93,
		-1,
		-1,
		-1,
		206,
		185,
		178,
		198,
		139,
		191,
		-1,
		-1,
		142,
		135,
		-1,
		122,
		104,
		111,
		109,
		103,
		107,
		104,
		93,
		106,
		99,
		85,
		87,
		100,
		104,
		108,
		95,
		91,
		88,
		102,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		159,
		-1,
		151,
		143,
		133,
		127,
		121,
		117,
		115,
		131,
		115,
		118,
		116,
		107,
		115,
		88,
		81,
		88,
		77,
		95,
		103,
		95,
		89,
		88,
		98,
		-1,
		226,
		212,
		183,
		-1,
		-1,
		172,
		-1,
		136,
		150,
		166,
		-1,
		159,
		138,
		153,
		131,
		127,
		123,
		138,
		139,
		117,
		116,
		114,
		105,
		93,
		82,
		85,
		77,
		99,
		99,
		83,
		84,
		88,
		-1,
		232,
		219,
		177,
		173,
		162,
		182,
		133,
		121,
		153,
		-1,
		-1,
		195,
		-1,
		129,
		146,
		137,
		135,
		128,
		119,
		125,
		125,
		102,
		97,
		87,
		76,
		76,
		71,
		93,
		79,
		77,
		86,
		102,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		148,
		135,
		129,
		-1,
		170,
		-1,
		173,
		163,
		147,
		132,
		165,
		-1,
		130,
		120,
		125,
		-1,
		122,
		-1,
		95,
		92,
		83,
		68,
		65,
		76,
		74,
		85,
		81,
		-1,
		182,
		167,
		160,
		150,
		164,
		135,
		-1,
		190,
		-1,
		-1,
		160,
		154,
		154,
		138,
		141,
		146,
		126,
		118,
		125,
		117,
		109,
		103,
		81,
		74,
		71,
		64,
		77,
		87,
		92,
		79,
		-1,
		-1,
		-1,
		187,
		173,
		177,
		137,
		156,
		-1,
		-1,
		222,
		177,
		163,
		-1,
		147,
		146,
		134,
		124,
		114,
		119,
		120,
		100,
		93,
		79,
		81,
		75,
		66,
		65,
		81,
		73,
		95,
		-1,
		-1,
		170,
		175,
		163,
		149,
		168,
		-1,
		-1,
		-1,
		169,
		185,
		174,
		148,
		135,
		-1,
		-1,
		118,
		111,
		105,
		96,
		83,
		95,
		90,
		74,
		59,
		74,
		78,
		86,
		77,
		-1,
		173,
		160,
		-1,
		-1,
		171,
		165,
		-1,
		-1,
		-1,
		-1,
		186,
		131,
		120,
		115,
		119,
		117,
		-1,
		91,
		102,
		87,
		99,
		106,
		76,
		61,
		55,
		61,
		73,
		82,
		-1,
		-1,
		185,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		143,
		137,
		108,
		101,
		105,
		-1,
		93,
		95,
		89,
		104,
		79,
		76,
		67,
		58,
		54,
		58,
		62,
		76,
		80,
		208,
		-1,
		171,
		-1,
		-1,
		-1,
		161,
		176,
		147,
		124,
		97,
		92,
		85,
		79,
		84,
		95,
		87,
		98,
		65,
		61,
		51,
		50,
		54,
		71,
		71,
		-1,
		-1,
		169,
		165,
		187,
		169,
		173,
		174,
		-1,
		-1,
		101,
		92,
		83,
		75,
		88,
		91,
		71,
		68,
		62,
		55,
		49,
		59,
		70,
		65,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		172,
		119,
		101,
		97,
		95,
		84,
		78,
		66,
		71,
		72,
		63,
		57,
		45,
		45,
		68,
		57,
		74,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		134,
		131,
		-1,
		101,
		107,
		72,
		79,
		62,
		69,
		67,
		59,
		39,
		42,
		58,
		57,
		52,
		66,
		57,
		61,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		103,
		72,
		70,
		63,
		58,
		68,
		48,
		35,
		35,
		30,
		45,
		50,
		52,
		45,
		52,
		67,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		78,
		73,
		64,
		44,
		50,
		28,
		35,
		46,
		38,
		42,
		43,
		50,
		61,
		65,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		95,
		138,
		93,
		88,
		72,
		70,
		61,
		52,
		52,
		36,
		24,
		21,
		30,
		35,
		27,
		53,
		55,
		61,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		165,
		-1,
		135,
		-1,
		118,
		122,
		101,
		104,
		86,
		73,
		59,
		52,
		61,
		36,
		32,
		28,
		17,
		26,
		37,
		44,
		54,
		61,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		152,
		191,
		171,
		-1,
		155,
		-1,
		-1,
		-1,
		132,
		114,
		106,
		106,
		85,
		85,
		51,
		47,
		41,
		37,
		36,
		29,
		12,
		30,
		38,
		49,
		64,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		167,
		158,
		185,
		178,
		167,
		162,
		149,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		68,
		55,
		49,
		48,
		51,
		36,
		24,
		4,
		24,
		25,
		52,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		186,
		176,
		180,
		196,
		221,
		-1,
		138,
		-1,
		-1,
		108,
		-1,
		-1,
		93,
		73,
		62,
		53,
		39,
		53,
		40,
		51,
		0,
		28,
		30,
		35,
		48,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		210,
		-1,
		-1,
		154,
		134,
		-1,
		-1,
		91,
		89,
		78,
		-1,
		68,
		50,
		36,
		63,
		31,
		20,
		9,
		3,
		15,
		40,
		45,
		53,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		140,
		-1,
		-1,
		86,
		79,
		67,
		55,
		45,
		50,
		36,
		32,
		18,
		11,
		6,
		17,
		31,
		35,
		52,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		120,
		104,
		85,
		-1,
		55,
		68,
		68,
		36,
		36,
		30,
		12,
		23,
		34,
		37,
		51,
		46,
		-1,
		-1,
		163,
		166,
		-1,
		-1,
		151,
		153,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		92,
		88,
		-1,
		-1,
		56,
		50,
		39,
		42,
		37,
		16,
		22,
		32,
		36,
		40,
		52,
		-1,
		-1,
		170,
		164,
		158,
		-1,
		136,
		-1,
		154,
		-1,
		121,
		127,
		115,
		-1,
		-1,
		-1,
		94,
		57,
		78,
		57,
		45,
		43,
		34,
		20,
		27,
		37,
		43,
		54,
		-1,
		-1,
		-1,
		154,
		128,
		161,
		152,
		135,
		115,
		107,
		126,
		-1,
		93,
		-1,
		61,
		58,
		71,
		53,
		56,
		50,
		23,
		38,
		38,
		41,
		45,
		160,
		-1,
		130,
		163,
		127,
		121,
		97,
		101,
		117,
		-1,
		90,
		69,
		-1,
		98,
		78,
		72,
		57,
		38,
		25,
		32,
		46,
		42,
		-1,
		-1,
		-1,
		132,
		131,
		123,
		117,
		117,
		102,
		93,
		-1,
		105,
		87,
		66,
		83,
		78,
		69,
		69,
		62,
		58,
		45,
		45,
		37,
		-1,
		233,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		126,
		121,
		94,
		82,
		88,
		84,
		70,
		76,
		78,
		81,
		71,
		68,
		64,
		55,
		61,
		38,
		74,
		-1,
		228,
		-1,
		162,
		-1,
		-1,
		144,
		124,
		116,
		105,
		94,
		92,
		83,
		74,
		96,
		112,
		62,
		50,
		45,
		46,
		-1,
		217,
		216,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		140,
		101,
		-1,
		103,
		83,
		-1,
		61,
		50,
		-1,
		-1,
		204,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		135,
		119,
		-1,
		94,
		94,
		-1,
		-1,
		-1,
		189,
		188,
		-1,
		157,
		160,
		-1,
		150,
		141,
		149,
		96,
		100,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		172,
		170,
		165,
		162,
		148,
		132,
		110,
		99,
		120,
		-1,
		-1,
		-1,
		170,
		162,
		155,
		-1,
		-1,
		157,
		140,
		121,
		119,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		147,
		-1,
		-1,
		153,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		181,
		-1,
		-1,
		-1,
		143,
		139,
		140,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		227,
		191,
		-1,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		133,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		168,
		-1,
		168,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		173,
		181,
		-1,
		153,
		155,
		-1,
		203,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		158,
		165,
		187,
		190,
		226,
		-1,
		177
	],
	[
		-1,
		224,
		213,
		224,
		232,
		205,
		212,
		-1,
		231,
		235,
		201,
		195,
		234,
		203,
		209,
		220,
		-1,
		-1,
		-1,
		224,
		223,
		191,
		189,
		198,
		203,
		210,
		-1,
		209,
		-1,
		245,
		224,
		235,
		240,
		184,
		181,
		201,
		220,
		202,
		194,
		260,
		214,
		185,
		179,
		197,
		187,
		196,
		188,
		-1,
		185,
		175,
		197,
		176,
		187,
		179,
		-1,
		-1,
		179,
		180,
		186,
		172,
		178,
		174,
		-1,
		184,
		168,
		-1,
		-1,
		169,
		170,
		154,
		157,
		165,
		163,
		176,
		168,
		163,
		-1,
		-1,
		160,
		156,
		163,
		150,
		146,
		163,
		176,
		158,
		172,
		171,
		-1,
		164,
		182,
		189,
		157,
		155,
		139,
		137,
		155,
		157,
		163,
		163,
		-1,
		173,
		174,
		169,
		177,
		179,
		155,
		142,
		142,
		152,
		145,
		164,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		156,
		173,
		165,
		155,
		170,
		163,
		145,
		142,
		140,
		137,
		153,
		151,
		161,
		-1,
		-1,
		266,
		235,
		264,
		222,
		203,
		-1,
		169,
		149,
		155,
		159,
		153,
		146,
		160,
		156,
		-1,
		131,
		130,
		158,
		144,
		155,
		226,
		-1,
		-1,
		224,
		216,
		199,
		202,
		179,
		175,
		164,
		163,
		155,
		141,
		137,
		143,
		146,
		146,
		152,
		125,
		135,
		139,
		137,
		162,
		-1,
		-1,
		197,
		-1,
		-1,
		223,
		206,
		-1,
		189,
		196,
		185,
		191,
		177,
		198,
		174,
		165,
		157,
		151,
		139,
		141,
		138,
		151,
		139,
		122,
		147,
		151,
		132,
		153,
		148,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		182,
		185,
		191,
		215,
		214,
		-1,
		186,
		174,
		175,
		160,
		157,
		144,
		132,
		145,
		130,
		137,
		136,
		126,
		124,
		154,
		129,
		151,
		148,
		167,
		172,
		166,
		175,
		-1,
		231,
		227,
		223,
		230,
		179,
		-1,
		-1,
		219,
		-1,
		222,
		223,
		198,
		171,
		174,
		161,
		152,
		139,
		128,
		139,
		128,
		125,
		133,
		118,
		133,
		124,
		123,
		141,
		151,
		159,
		163,
		169,
		-1,
		281,
		-1,
		223,
		207,
		209,
		181,
		202,
		-1,
		239,
		223,
		215,
		200,
		200,
		-1,
		170,
		167,
		157,
		135,
		120,
		137,
		129,
		127,
		131,
		113,
		127,
		118,
		136,
		143,
		141,
		145,
		165,
		177,
		241,
		231,
		-1,
		213,
		218,
		177,
		185,
		204,
		242,
		206,
		-1,
		201,
		-1,
		172,
		185,
		-1,
		141,
		137,
		119,
		120,
		115,
		130,
		124,
		109,
		106,
		124,
		127,
		134,
		138,
		154,
		-1,
		-1,
		226,
		230,
		219,
		170,
		189,
		213,
		250,
		199,
		188,
		187,
		-1,
		178,
		155,
		152,
		140,
		127,
		112,
		113,
		121,
		134,
		113,
		108,
		105,
		125,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		196,
		167,
		191,
		233,
		217,
		210,
		198,
		163,
		163,
		157,
		-1,
		151,
		130,
		121,
		110,
		108,
		121,
		118,
		123,
		103,
		101,
		120,
		132,
		123,
		140,
		-1,
		-1,
		-1,
		226,
		215,
		216,
		162,
		185,
		222,
		196,
		182,
		187,
		162,
		155,
		149,
		164,
		147,
		128,
		117,
		109,
		98,
		114,
		122,
		117,
		99,
		108,
		114,
		138,
		128,
		134,
		-1,
		-1,
		233,
		223,
		207,
		209,
		206,
		176,
		183,
		215,
		187,
		200,
		-1,
		154,
		-1,
		143,
		138,
		122,
		117,
		114,
		111,
		105,
		114,
		116,
		106,
		101,
		108,
		143,
		143,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		226,
		221,
		196,
		173,
		157,
		193,
		-1,
		170,
		171,
		-1,
		148,
		142,
		139,
		124,
		120,
		115,
		119,
		112,
		119,
		112,
		110,
		111,
		93,
		125,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		219,
		198,
		191,
		211,
		152,
		204,
		-1,
		-1,
		155,
		148,
		-1,
		135,
		117,
		124,
		122,
		116,
		120,
		117,
		106,
		119,
		112,
		98,
		100,
		113,
		117,
		121,
		108,
		104,
		101,
		115,
		-1,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		172,
		-1,
		164,
		156,
		146,
		140,
		134,
		130,
		128,
		144,
		128,
		131,
		129,
		120,
		128,
		101,
		94,
		101,
		90,
		108,
		116,
		108,
		102,
		101,
		111,
		-1,
		239,
		225,
		196,
		-1,
		-1,
		185,
		-1,
		149,
		163,
		179,
		-1,
		172,
		151,
		166,
		144,
		140,
		136,
		151,
		152,
		130,
		129,
		127,
		118,
		106,
		95,
		98,
		90,
		112,
		112,
		96,
		97,
		101,
		-1,
		245,
		232,
		190,
		186,
		175,
		195,
		146,
		134,
		166,
		-1,
		-1,
		208,
		-1,
		142,
		159,
		150,
		148,
		141,
		132,
		138,
		138,
		115,
		110,
		100,
		89,
		89,
		84,
		106,
		92,
		90,
		99,
		115,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		161,
		148,
		142,
		-1,
		183,
		-1,
		186,
		176,
		160,
		145,
		178,
		-1,
		143,
		133,
		138,
		-1,
		135,
		-1,
		108,
		105,
		96,
		81,
		78,
		89,
		87,
		98,
		94,
		-1,
		195,
		180,
		173,
		163,
		177,
		148,
		-1,
		203,
		-1,
		-1,
		173,
		167,
		167,
		151,
		154,
		159,
		139,
		131,
		138,
		130,
		122,
		116,
		94,
		87,
		84,
		77,
		90,
		100,
		105,
		92,
		-1,
		-1,
		-1,
		200,
		186,
		190,
		150,
		169,
		-1,
		-1,
		235,
		190,
		176,
		-1,
		160,
		159,
		147,
		137,
		127,
		132,
		133,
		113,
		106,
		92,
		94,
		88,
		79,
		78,
		94,
		86,
		108,
		-1,
		-1,
		183,
		188,
		176,
		162,
		181,
		-1,
		-1,
		-1,
		182,
		198,
		187,
		161,
		148,
		-1,
		-1,
		131,
		124,
		118,
		109,
		96,
		108,
		103,
		87,
		72,
		87,
		91,
		99,
		90,
		-1,
		186,
		173,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		-1,
		-1,
		199,
		144,
		133,
		128,
		132,
		130,
		-1,
		104,
		115,
		100,
		112,
		119,
		89,
		74,
		68,
		74,
		86,
		95,
		-1,
		-1,
		198,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		156,
		150,
		121,
		114,
		118,
		-1,
		106,
		108,
		102,
		117,
		92,
		89,
		80,
		71,
		67,
		71,
		75,
		89,
		93,
		221,
		-1,
		184,
		-1,
		-1,
		-1,
		174,
		189,
		160,
		137,
		110,
		105,
		98,
		92,
		97,
		108,
		100,
		111,
		78,
		74,
		64,
		63,
		67,
		84,
		84,
		-1,
		-1,
		182,
		178,
		200,
		182,
		186,
		187,
		-1,
		-1,
		114,
		105,
		96,
		88,
		101,
		104,
		84,
		81,
		75,
		68,
		62,
		72,
		83,
		78,
		-1,
		-1,
		-1,
		194,
		-1,
		196,
		-1,
		-1,
		184,
		185,
		132,
		114,
		110,
		108,
		97,
		91,
		79,
		84,
		85,
		76,
		70,
		58,
		58,
		81,
		70,
		87,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		147,
		144,
		-1,
		114,
		120,
		85,
		92,
		75,
		82,
		80,
		72,
		52,
		55,
		71,
		70,
		65,
		79,
		70,
		74,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		139,
		136,
		116,
		85,
		83,
		76,
		71,
		81,
		61,
		48,
		48,
		43,
		58,
		63,
		65,
		58,
		65,
		80,
		-1,
		213,
		250,
		243,
		211,
		219,
		250,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		112,
		103,
		104,
		92,
		89,
		91,
		86,
		77,
		57,
		63,
		41,
		48,
		59,
		51,
		55,
		56,
		63,
		74,
		78,
		-1,
		206,
		226,
		205,
		208,
		232,
		246,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		108,
		151,
		106,
		101,
		85,
		83,
		74,
		65,
		65,
		49,
		37,
		34,
		43,
		48,
		40,
		55,
		68,
		74,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		181,
		-1,
		148,
		-1,
		131,
		135,
		114,
		117,
		99,
		86,
		78,
		65,
		74,
		49,
		45,
		41,
		30,
		27,
		39,
		37,
		47,
		65,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		165,
		204,
		192,
		-1,
		176,
		-1,
		-1,
		-1,
		145,
		127,
		119,
		119,
		98,
		98,
		72,
		68,
		54,
		50,
		57,
		47,
		32,
		26,
		31,
		42,
		57,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		180,
		171,
		198,
		199,
		188,
		183,
		170,
		-1,
		-1,
		149,
		137,
		-1,
		-1,
		105,
		89,
		76,
		65,
		61,
		64,
		64,
		52,
		24,
		17,
		19,
		45,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		199,
		189,
		193,
		209,
		234,
		-1,
		159,
		-1,
		-1,
		129,
		-1,
		-1,
		114,
		94,
		83,
		74,
		60,
		69,
		68,
		79,
		30,
		0,
		24,
		28,
		41,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		223,
		-1,
		-1,
		175,
		155,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		71,
		57,
		84,
		52,
		41,
		35,
		29,
		15,
		33,
		38,
		46,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		165,
		161,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		71,
		57,
		53,
		39,
		32,
		27,
		33,
		24,
		28,
		45,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		182,
		168,
		161,
		149,
		147,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		89,
		57,
		57,
		51,
		33,
		43,
		27,
		30,
		44,
		39,
		-1,
		-1,
		176,
		179,
		-1,
		-1,
		172,
		174,
		-1,
		173,
		162,
		147,
		139,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		71,
		60,
		63,
		58,
		37,
		43,
		40,
		29,
		33,
		45,
		-1,
		-1,
		183,
		184,
		179,
		-1,
		157,
		-1,
		175,
		-1,
		142,
		148,
		136,
		-1,
		-1,
		-1,
		115,
		78,
		99,
		78,
		66,
		64,
		55,
		41,
		44,
		40,
		36,
		47,
		-1,
		-1,
		-1,
		175,
		149,
		182,
		173,
		156,
		136,
		128,
		147,
		-1,
		114,
		-1,
		82,
		79,
		92,
		74,
		77,
		71,
		44,
		59,
		43,
		34,
		43,
		181,
		-1,
		151,
		184,
		148,
		142,
		118,
		122,
		138,
		-1,
		111,
		90,
		-1,
		115,
		99,
		93,
		78,
		59,
		46,
		53,
		47,
		40,
		-1,
		-1,
		-1,
		153,
		152,
		144,
		138,
		138,
		123,
		114,
		-1,
		126,
		108,
		87,
		104,
		95,
		86,
		86,
		83,
		79,
		66,
		66,
		56,
		-1,
		254,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		147,
		142,
		115,
		103,
		109,
		105,
		91,
		97,
		99,
		98,
		88,
		85,
		81,
		72,
		78,
		55,
		88,
		-1,
		249,
		-1,
		183,
		-1,
		-1,
		165,
		145,
		137,
		126,
		115,
		113,
		104,
		95,
		117,
		129,
		79,
		67,
		62,
		63,
		-1,
		238,
		237,
		-1,
		184,
		176,
		162,
		-1,
		155,
		-1,
		161,
		122,
		-1,
		124,
		104,
		-1,
		78,
		67,
		-1,
		-1,
		225,
		200,
		-1,
		-1,
		-1,
		185,
		165,
		156,
		140,
		-1,
		115,
		115,
		-1,
		-1,
		-1,
		210,
		209,
		-1,
		178,
		181,
		-1,
		171,
		162,
		170,
		117,
		121,
		-1,
		-1,
		-1,
		219,
		200,
		194,
		193,
		191,
		186,
		183,
		169,
		153,
		131,
		120,
		141,
		-1,
		-1,
		-1,
		191,
		183,
		176,
		-1,
		-1,
		178,
		161,
		142,
		140,
		-1,
		-1,
		-1,
		213,
		194,
		-1,
		-1,
		168,
		-1,
		-1,
		174,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		202,
		-1,
		-1,
		-1,
		164,
		160,
		161,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		248,
		212,
		-1,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		227,
		225,
		-1,
		-1,
		-1,
		184,
		168,
		-1,
		154,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		189,
		-1,
		189,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		202,
		194,
		202,
		-1,
		174,
		176,
		-1,
		224,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		179,
		186,
		208,
		211,
		247,
		-1,
		198
	],
	[
		-1,
		214,
		203,
		214,
		222,
		195,
		202,
		-1,
		221,
		225,
		191,
		185,
		224,
		193,
		199,
		210,
		-1,
		-1,
		-1,
		214,
		213,
		181,
		179,
		188,
		193,
		200,
		-1,
		199,
		-1,
		235,
		214,
		225,
		230,
		174,
		171,
		191,
		210,
		192,
		184,
		250,
		204,
		175,
		169,
		187,
		177,
		186,
		178,
		-1,
		175,
		165,
		187,
		166,
		177,
		169,
		-1,
		-1,
		169,
		170,
		176,
		162,
		168,
		164,
		-1,
		174,
		158,
		-1,
		-1,
		159,
		160,
		144,
		147,
		155,
		153,
		166,
		158,
		153,
		-1,
		-1,
		150,
		146,
		153,
		140,
		136,
		153,
		166,
		148,
		162,
		161,
		-1,
		154,
		172,
		179,
		147,
		145,
		129,
		127,
		145,
		147,
		153,
		153,
		-1,
		163,
		164,
		159,
		167,
		169,
		145,
		132,
		132,
		142,
		135,
		154,
		142,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		146,
		163,
		155,
		145,
		160,
		153,
		135,
		132,
		130,
		127,
		143,
		141,
		151,
		-1,
		-1,
		256,
		225,
		254,
		212,
		193,
		-1,
		159,
		139,
		145,
		149,
		143,
		136,
		150,
		146,
		-1,
		121,
		120,
		148,
		134,
		145,
		216,
		-1,
		-1,
		214,
		206,
		189,
		192,
		169,
		165,
		154,
		153,
		145,
		131,
		127,
		133,
		136,
		136,
		142,
		115,
		125,
		129,
		127,
		152,
		-1,
		-1,
		187,
		-1,
		-1,
		213,
		196,
		-1,
		179,
		186,
		175,
		181,
		167,
		188,
		164,
		155,
		147,
		141,
		129,
		131,
		128,
		141,
		129,
		112,
		137,
		141,
		122,
		143,
		138,
		-1,
		186,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		172,
		175,
		181,
		205,
		204,
		-1,
		176,
		164,
		165,
		150,
		147,
		134,
		122,
		135,
		120,
		127,
		126,
		116,
		114,
		144,
		119,
		141,
		138,
		157,
		162,
		156,
		165,
		-1,
		221,
		217,
		213,
		220,
		169,
		-1,
		-1,
		209,
		-1,
		212,
		213,
		188,
		161,
		164,
		151,
		142,
		129,
		118,
		129,
		118,
		115,
		123,
		108,
		123,
		114,
		113,
		131,
		141,
		149,
		153,
		159,
		-1,
		271,
		-1,
		213,
		197,
		199,
		171,
		192,
		-1,
		229,
		213,
		205,
		190,
		190,
		-1,
		160,
		157,
		147,
		125,
		110,
		127,
		119,
		117,
		121,
		103,
		117,
		108,
		126,
		133,
		131,
		135,
		155,
		167,
		231,
		221,
		-1,
		203,
		208,
		167,
		175,
		194,
		232,
		196,
		-1,
		191,
		-1,
		162,
		175,
		-1,
		131,
		127,
		109,
		110,
		105,
		120,
		114,
		99,
		96,
		114,
		117,
		124,
		128,
		144,
		-1,
		-1,
		216,
		220,
		209,
		160,
		179,
		203,
		240,
		189,
		178,
		177,
		-1,
		168,
		145,
		142,
		130,
		117,
		102,
		103,
		111,
		124,
		103,
		98,
		95,
		115,
		141,
		119,
		131,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		186,
		157,
		181,
		223,
		207,
		200,
		188,
		153,
		153,
		147,
		-1,
		141,
		120,
		111,
		100,
		98,
		111,
		108,
		113,
		93,
		91,
		110,
		122,
		113,
		130,
		-1,
		-1,
		-1,
		216,
		205,
		206,
		152,
		175,
		212,
		186,
		172,
		177,
		152,
		145,
		139,
		154,
		137,
		118,
		107,
		99,
		88,
		104,
		112,
		107,
		89,
		98,
		104,
		128,
		118,
		124,
		-1,
		-1,
		223,
		213,
		197,
		199,
		196,
		166,
		173,
		205,
		177,
		190,
		-1,
		144,
		-1,
		133,
		128,
		112,
		107,
		104,
		101,
		95,
		104,
		106,
		96,
		91,
		98,
		133,
		133,
		108,
		128,
		131,
		-1,
		-1,
		-1,
		216,
		211,
		186,
		163,
		147,
		183,
		-1,
		160,
		161,
		-1,
		138,
		132,
		129,
		114,
		110,
		105,
		109,
		102,
		109,
		102,
		100,
		101,
		83,
		115,
		-1,
		116,
		110,
		118,
		108,
		96,
		-1,
		-1,
		-1,
		209,
		188,
		181,
		201,
		142,
		194,
		-1,
		-1,
		145,
		138,
		-1,
		125,
		107,
		114,
		112,
		106,
		110,
		107,
		96,
		109,
		102,
		88,
		90,
		103,
		107,
		111,
		98,
		94,
		91,
		105,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		162,
		-1,
		154,
		146,
		136,
		130,
		124,
		120,
		118,
		134,
		118,
		121,
		119,
		110,
		118,
		91,
		84,
		91,
		80,
		98,
		106,
		98,
		92,
		91,
		101,
		-1,
		229,
		215,
		186,
		-1,
		-1,
		175,
		-1,
		139,
		153,
		169,
		-1,
		162,
		141,
		156,
		134,
		130,
		126,
		141,
		142,
		120,
		119,
		117,
		108,
		96,
		85,
		88,
		80,
		102,
		102,
		86,
		87,
		91,
		-1,
		235,
		222,
		180,
		176,
		165,
		185,
		136,
		124,
		156,
		-1,
		-1,
		198,
		-1,
		132,
		149,
		140,
		138,
		131,
		122,
		128,
		128,
		105,
		100,
		90,
		79,
		79,
		74,
		96,
		82,
		80,
		89,
		105,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		151,
		138,
		132,
		-1,
		173,
		-1,
		176,
		166,
		150,
		135,
		168,
		-1,
		133,
		123,
		128,
		-1,
		125,
		-1,
		98,
		95,
		86,
		71,
		68,
		79,
		77,
		88,
		84,
		-1,
		185,
		170,
		163,
		153,
		167,
		138,
		-1,
		193,
		-1,
		-1,
		163,
		157,
		157,
		141,
		144,
		149,
		129,
		121,
		128,
		120,
		112,
		106,
		84,
		77,
		74,
		67,
		80,
		90,
		95,
		82,
		-1,
		-1,
		-1,
		190,
		176,
		180,
		140,
		159,
		-1,
		-1,
		225,
		180,
		166,
		-1,
		150,
		149,
		137,
		127,
		117,
		122,
		123,
		103,
		96,
		82,
		84,
		78,
		69,
		68,
		84,
		76,
		98,
		-1,
		-1,
		173,
		178,
		166,
		152,
		171,
		-1,
		-1,
		-1,
		172,
		188,
		177,
		151,
		138,
		-1,
		-1,
		121,
		114,
		108,
		99,
		86,
		98,
		93,
		77,
		62,
		77,
		81,
		89,
		80,
		-1,
		176,
		163,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		-1,
		-1,
		189,
		134,
		123,
		118,
		122,
		120,
		-1,
		94,
		105,
		90,
		102,
		109,
		79,
		64,
		58,
		64,
		76,
		85,
		-1,
		-1,
		188,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		146,
		140,
		111,
		104,
		108,
		-1,
		96,
		98,
		92,
		107,
		82,
		79,
		70,
		61,
		57,
		61,
		65,
		79,
		83,
		211,
		-1,
		174,
		-1,
		-1,
		-1,
		164,
		179,
		150,
		127,
		100,
		95,
		88,
		82,
		87,
		98,
		90,
		101,
		68,
		64,
		54,
		53,
		57,
		74,
		74,
		-1,
		-1,
		172,
		168,
		190,
		172,
		176,
		177,
		-1,
		-1,
		104,
		95,
		86,
		78,
		91,
		94,
		74,
		71,
		65,
		58,
		52,
		62,
		73,
		68,
		-1,
		-1,
		-1,
		184,
		-1,
		186,
		-1,
		-1,
		174,
		175,
		122,
		104,
		100,
		98,
		87,
		81,
		69,
		74,
		75,
		66,
		60,
		48,
		48,
		71,
		60,
		77,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		163,
		155,
		150,
		156,
		158,
		149,
		137,
		134,
		-1,
		104,
		110,
		75,
		82,
		65,
		72,
		70,
		62,
		42,
		45,
		61,
		60,
		55,
		69,
		60,
		64,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		156,
		152,
		142,
		132,
		135,
		-1,
		-1,
		129,
		126,
		106,
		75,
		73,
		66,
		61,
		71,
		51,
		38,
		38,
		33,
		48,
		53,
		55,
		48,
		55,
		70,
		-1,
		203,
		240,
		233,
		201,
		209,
		240,
		-1,
		146,
		138,
		149,
		124,
		126,
		-1,
		-1,
		102,
		93,
		94,
		82,
		79,
		81,
		76,
		67,
		47,
		53,
		31,
		38,
		49,
		41,
		45,
		46,
		53,
		64,
		68,
		-1,
		196,
		216,
		195,
		198,
		222,
		236,
		-1,
		143,
		-1,
		-1,
		155,
		127,
		111,
		101,
		98,
		141,
		96,
		91,
		75,
		73,
		64,
		55,
		55,
		39,
		27,
		24,
		33,
		38,
		30,
		51,
		58,
		64,
		-1,
		185,
		196,
		189,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		171,
		-1,
		138,
		-1,
		121,
		125,
		104,
		107,
		89,
		76,
		68,
		55,
		64,
		39,
		35,
		31,
		20,
		17,
		29,
		33,
		43,
		61,
		210,
		166,
		169,
		180,
		191,
		206,
		210,
		-1,
		155,
		194,
		188,
		-1,
		172,
		-1,
		-1,
		-1,
		135,
		117,
		109,
		109,
		88,
		88,
		62,
		58,
		44,
		40,
		47,
		37,
		27,
		16,
		27,
		38,
		53,
		206,
		197,
		210,
		155,
		155,
		176,
		185,
		206,
		170,
		161,
		188,
		195,
		184,
		179,
		166,
		-1,
		-1,
		157,
		127,
		-1,
		-1,
		95,
		83,
		66,
		55,
		51,
		54,
		62,
		46,
		26,
		15,
		9,
		41,
		-1,
		199,
		198,
		187,
		184,
		160,
		151,
		146,
		173,
		-1,
		-1,
		168,
		189,
		179,
		183,
		199,
		224,
		-1,
		155,
		-1,
		-1,
		137,
		-1,
		-1,
		122,
		88,
		77,
		68,
		66,
		59,
		66,
		77,
		32,
		24,
		0,
		14,
		27,
		183,
		180,
		168,
		166,
		189,
		154,
		142,
		-1,
		155,
		153,
		159,
		166,
		183,
		213,
		-1,
		-1,
		171,
		151,
		-1,
		-1,
		120,
		118,
		107,
		-1,
		97,
		73,
		65,
		86,
		60,
		49,
		41,
		35,
		35,
		12,
		24,
		32,
		192,
		206,
		195,
		191,
		190,
		198,
		147,
		140,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		161,
		157,
		-1,
		-1,
		115,
		108,
		96,
		84,
		74,
		79,
		65,
		61,
		47,
		40,
		35,
		46,
		21,
		19,
		36,
		-1,
		226,
		-1,
		178,
		154,
		168,
		183,
		191,
		-1,
		-1,
		-1,
		178,
		164,
		157,
		145,
		143,
		-1,
		149,
		133,
		114,
		-1,
		84,
		97,
		97,
		65,
		65,
		59,
		41,
		50,
		24,
		27,
		41,
		36,
		-1,
		-1,
		166,
		169,
		-1,
		-1,
		168,
		170,
		-1,
		169,
		158,
		143,
		135,
		-1,
		-1,
		121,
		117,
		-1,
		-1,
		85,
		79,
		68,
		71,
		66,
		45,
		48,
		37,
		26,
		30,
		42,
		-1,
		-1,
		173,
		174,
		175,
		-1,
		153,
		-1,
		171,
		-1,
		138,
		144,
		132,
		-1,
		-1,
		-1,
		123,
		86,
		107,
		86,
		74,
		72,
		63,
		49,
		41,
		37,
		33,
		44,
		-1,
		-1,
		-1,
		171,
		145,
		178,
		169,
		152,
		132,
		124,
		143,
		-1,
		113,
		-1,
		88,
		87,
		100,
		82,
		85,
		79,
		52,
		67,
		40,
		31,
		40,
		177,
		-1,
		147,
		180,
		144,
		138,
		114,
		118,
		134,
		-1,
		110,
		92,
		-1,
		112,
		99,
		101,
		86,
		67,
		54,
		59,
		44,
		37,
		-1,
		-1,
		-1,
		149,
		148,
		140,
		134,
		134,
		119,
		110,
		-1,
		122,
		104,
		83,
		100,
		92,
		83,
		83,
		91,
		87,
		74,
		74,
		53,
		-1,
		250,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		143,
		138,
		111,
		99,
		105,
		101,
		87,
		93,
		95,
		95,
		85,
		82,
		78,
		69,
		75,
		52,
		85,
		-1,
		245,
		-1,
		179,
		-1,
		-1,
		161,
		141,
		133,
		122,
		111,
		109,
		100,
		91,
		113,
		126,
		76,
		64,
		59,
		60,
		-1,
		234,
		233,
		-1,
		180,
		172,
		158,
		-1,
		151,
		-1,
		157,
		118,
		-1,
		120,
		100,
		-1,
		75,
		64,
		-1,
		-1,
		221,
		196,
		-1,
		-1,
		-1,
		181,
		161,
		152,
		136,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		206,
		205,
		-1,
		174,
		177,
		-1,
		167,
		158,
		166,
		113,
		117,
		-1,
		-1,
		-1,
		215,
		196,
		190,
		189,
		187,
		182,
		179,
		165,
		149,
		127,
		116,
		137,
		-1,
		-1,
		-1,
		187,
		179,
		172,
		-1,
		-1,
		174,
		157,
		138,
		136,
		-1,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		164,
		-1,
		-1,
		170,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		198,
		-1,
		-1,
		-1,
		160,
		156,
		157,
		-1,
		-1,
		-1,
		-1,
		220,
		221,
		244,
		208,
		-1,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		223,
		221,
		-1,
		-1,
		-1,
		180,
		164,
		-1,
		150,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		185,
		-1,
		185,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		198,
		190,
		198,
		-1,
		170,
		172,
		-1,
		220,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		175,
		182,
		204,
		207,
		243,
		-1,
		194
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		118,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		114,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		118,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		97,
		89,
		111,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		94,
		102,
		93,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		77,
		89,
		98,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		92,
		96,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		70,
		87,
		87,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		86,
		81,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		88,
		79,
		73,
		61,
		61,
		84,
		73,
		90,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		83,
		75,
		55,
		58,
		74,
		73,
		68,
		82,
		73,
		77,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		51,
		46,
		61,
		66,
		68,
		61,
		68,
		83,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		80,
		60,
		66,
		44,
		51,
		62,
		54,
		58,
		59,
		65,
		77,
		81,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		68,
		52,
		40,
		37,
		46,
		51,
		43,
		51,
		71,
		65,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		102,
		89,
		81,
		68,
		77,
		52,
		48,
		44,
		33,
		30,
		42,
		35,
		43,
		48,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		122,
		101,
		101,
		75,
		71,
		57,
		53,
		60,
		50,
		40,
		29,
		34,
		33,
		40,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		208,
		197,
		192,
		179,
		-1,
		-1,
		168,
		140,
		-1,
		-1,
		108,
		96,
		79,
		68,
		64,
		67,
		74,
		59,
		34,
		22,
		22,
		28,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		212,
		237,
		-1,
		168,
		-1,
		-1,
		148,
		-1,
		-1,
		133,
		101,
		90,
		81,
		79,
		72,
		78,
		89,
		40,
		32,
		16,
		0,
		13,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		86,
		76,
		99,
		71,
		60,
		49,
		43,
		44,
		15,
		20,
		18,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		90,
		76,
		72,
		58,
		51,
		46,
		57,
		30,
		22,
		22,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		108,
		76,
		76,
		70,
		52,
		59,
		33,
		36,
		30,
		28,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		96,
		90,
		79,
		82,
		77,
		56,
		57,
		46,
		35,
		31,
		31,
		-1,
		-1,
		186,
		187,
		188,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		134,
		97,
		118,
		97,
		84,
		82,
		73,
		59,
		50,
		46,
		42,
		41,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		126,
		-1,
		101,
		98,
		111,
		92,
		95,
		89,
		62,
		77,
		49,
		40,
		47,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		147,
		-1,
		123,
		105,
		-1,
		119,
		106,
		110,
		95,
		76,
		63,
		66,
		51,
		44,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		135,
		117,
		96,
		113,
		99,
		90,
		90,
		100,
		96,
		83,
		81,
		60,
		-1,
		263,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		151,
		124,
		112,
		118,
		114,
		100,
		106,
		108,
		102,
		92,
		89,
		85,
		76,
		82,
		59,
		92,
		-1,
		258,
		-1,
		192,
		-1,
		-1,
		174,
		154,
		146,
		135,
		124,
		122,
		113,
		104,
		126,
		133,
		83,
		71,
		66,
		67,
		-1,
		247,
		246,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		170,
		131,
		-1,
		133,
		113,
		-1,
		82,
		71,
		-1,
		-1,
		234,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		165,
		149,
		-1,
		124,
		124,
		-1,
		-1,
		-1,
		219,
		218,
		-1,
		187,
		190,
		-1,
		180,
		171,
		179,
		126,
		130,
		-1,
		-1,
		-1,
		228,
		209,
		203,
		202,
		200,
		195,
		192,
		178,
		162,
		140,
		129,
		150,
		-1,
		-1,
		-1,
		200,
		192,
		185,
		-1,
		-1,
		187,
		170,
		151,
		149,
		-1,
		-1,
		-1,
		222,
		203,
		-1,
		-1,
		177,
		-1,
		-1,
		183,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		211,
		-1,
		-1,
		-1,
		173,
		169,
		170,
		-1,
		-1,
		-1,
		-1,
		233,
		234,
		257,
		221,
		-1,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		236,
		234,
		-1,
		-1,
		-1,
		193,
		177,
		-1,
		163,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		196,
		-1,
		-1,
		-1,
		198,
		-1,
		198,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		211,
		203,
		211,
		-1,
		183,
		185,
		-1,
		233,
		-1,
		-1,
		226,
		217,
		-1,
		-1,
		188,
		195,
		217,
		220,
		256,
		-1,
		207
	],
	[
		-1,
		237,
		226,
		237,
		245,
		218,
		225,
		-1,
		244,
		248,
		214,
		208,
		247,
		216,
		222,
		233,
		-1,
		-1,
		-1,
		237,
		236,
		204,
		202,
		211,
		216,
		223,
		-1,
		222,
		-1,
		258,
		237,
		248,
		253,
		197,
		194,
		214,
		233,
		215,
		207,
		273,
		227,
		198,
		192,
		210,
		200,
		209,
		201,
		-1,
		198,
		188,
		210,
		189,
		200,
		192,
		-1,
		-1,
		192,
		193,
		199,
		185,
		191,
		187,
		-1,
		197,
		181,
		-1,
		-1,
		182,
		183,
		167,
		170,
		178,
		176,
		189,
		181,
		176,
		-1,
		-1,
		173,
		169,
		176,
		163,
		159,
		176,
		189,
		171,
		185,
		184,
		-1,
		177,
		195,
		202,
		170,
		168,
		152,
		150,
		168,
		170,
		176,
		176,
		-1,
		186,
		187,
		182,
		190,
		192,
		168,
		155,
		155,
		165,
		158,
		177,
		165,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		186,
		169,
		186,
		178,
		168,
		183,
		176,
		158,
		155,
		153,
		150,
		166,
		164,
		174,
		-1,
		-1,
		279,
		248,
		277,
		235,
		216,
		-1,
		182,
		162,
		168,
		172,
		166,
		159,
		173,
		169,
		-1,
		144,
		143,
		171,
		157,
		168,
		239,
		-1,
		-1,
		237,
		229,
		212,
		215,
		192,
		188,
		177,
		176,
		168,
		154,
		150,
		156,
		159,
		159,
		165,
		138,
		148,
		152,
		150,
		175,
		-1,
		-1,
		210,
		-1,
		-1,
		236,
		219,
		-1,
		202,
		209,
		198,
		204,
		190,
		211,
		187,
		178,
		170,
		164,
		152,
		154,
		151,
		164,
		152,
		135,
		160,
		164,
		145,
		166,
		161,
		-1,
		209,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		195,
		198,
		204,
		228,
		227,
		-1,
		199,
		187,
		188,
		173,
		170,
		157,
		145,
		158,
		143,
		150,
		149,
		139,
		137,
		167,
		142,
		164,
		161,
		180,
		185,
		179,
		188,
		-1,
		244,
		240,
		236,
		243,
		192,
		-1,
		-1,
		232,
		-1,
		235,
		236,
		211,
		184,
		187,
		174,
		165,
		152,
		141,
		152,
		141,
		138,
		146,
		131,
		146,
		137,
		136,
		154,
		164,
		172,
		176,
		182,
		-1,
		294,
		-1,
		236,
		220,
		222,
		194,
		215,
		-1,
		252,
		236,
		228,
		213,
		213,
		-1,
		183,
		180,
		170,
		148,
		133,
		150,
		142,
		140,
		144,
		126,
		140,
		131,
		149,
		156,
		154,
		158,
		178,
		190,
		254,
		244,
		-1,
		226,
		231,
		190,
		198,
		217,
		255,
		219,
		-1,
		214,
		-1,
		185,
		198,
		-1,
		154,
		150,
		132,
		133,
		128,
		143,
		137,
		122,
		119,
		137,
		140,
		147,
		151,
		167,
		-1,
		-1,
		239,
		243,
		232,
		183,
		202,
		226,
		263,
		212,
		201,
		200,
		-1,
		191,
		168,
		165,
		153,
		140,
		125,
		126,
		134,
		147,
		126,
		121,
		118,
		138,
		164,
		142,
		154,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		209,
		180,
		204,
		246,
		230,
		223,
		211,
		176,
		176,
		170,
		-1,
		164,
		143,
		134,
		123,
		121,
		134,
		131,
		136,
		116,
		114,
		133,
		145,
		136,
		153,
		-1,
		-1,
		-1,
		239,
		228,
		229,
		175,
		198,
		235,
		209,
		195,
		200,
		175,
		168,
		162,
		177,
		160,
		141,
		130,
		122,
		111,
		127,
		135,
		130,
		112,
		121,
		127,
		151,
		141,
		147,
		-1,
		-1,
		246,
		236,
		220,
		222,
		219,
		189,
		196,
		228,
		200,
		213,
		-1,
		167,
		-1,
		156,
		151,
		135,
		130,
		127,
		124,
		118,
		127,
		129,
		119,
		114,
		121,
		156,
		156,
		131,
		151,
		154,
		-1,
		-1,
		-1,
		239,
		234,
		209,
		186,
		170,
		206,
		-1,
		183,
		184,
		-1,
		161,
		155,
		152,
		137,
		133,
		128,
		132,
		125,
		132,
		125,
		123,
		124,
		106,
		138,
		-1,
		139,
		133,
		141,
		131,
		119,
		-1,
		-1,
		-1,
		232,
		211,
		204,
		224,
		165,
		217,
		-1,
		-1,
		168,
		161,
		-1,
		148,
		130,
		137,
		135,
		129,
		133,
		130,
		119,
		132,
		125,
		111,
		113,
		126,
		130,
		134,
		121,
		117,
		114,
		128,
		-1,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		185,
		-1,
		177,
		169,
		159,
		153,
		147,
		143,
		141,
		157,
		141,
		144,
		142,
		133,
		141,
		114,
		107,
		114,
		103,
		121,
		129,
		121,
		115,
		114,
		124,
		-1,
		252,
		238,
		209,
		-1,
		-1,
		198,
		-1,
		162,
		176,
		192,
		-1,
		185,
		164,
		179,
		157,
		153,
		149,
		164,
		165,
		143,
		142,
		140,
		131,
		119,
		108,
		111,
		103,
		125,
		125,
		109,
		110,
		114,
		-1,
		258,
		245,
		203,
		199,
		188,
		208,
		159,
		147,
		179,
		-1,
		-1,
		221,
		-1,
		155,
		172,
		163,
		161,
		154,
		145,
		151,
		151,
		128,
		123,
		113,
		102,
		102,
		97,
		119,
		105,
		103,
		112,
		117,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		174,
		161,
		155,
		-1,
		196,
		-1,
		199,
		189,
		173,
		158,
		191,
		-1,
		156,
		146,
		151,
		-1,
		148,
		-1,
		121,
		118,
		109,
		94,
		91,
		102,
		100,
		111,
		107,
		-1,
		208,
		193,
		186,
		176,
		190,
		161,
		-1,
		216,
		-1,
		-1,
		186,
		180,
		180,
		164,
		167,
		172,
		152,
		144,
		151,
		143,
		135,
		129,
		107,
		100,
		97,
		90,
		103,
		113,
		118,
		105,
		-1,
		-1,
		-1,
		213,
		199,
		203,
		163,
		182,
		-1,
		-1,
		248,
		203,
		189,
		-1,
		173,
		172,
		160,
		150,
		140,
		145,
		146,
		126,
		119,
		105,
		107,
		101,
		92,
		91,
		107,
		99,
		121,
		-1,
		-1,
		196,
		201,
		189,
		175,
		194,
		-1,
		-1,
		-1,
		195,
		211,
		200,
		174,
		161,
		-1,
		-1,
		144,
		137,
		131,
		122,
		109,
		121,
		116,
		100,
		85,
		100,
		104,
		112,
		103,
		-1,
		199,
		186,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		-1,
		-1,
		212,
		157,
		146,
		141,
		145,
		143,
		-1,
		117,
		128,
		113,
		125,
		132,
		102,
		87,
		81,
		87,
		99,
		104,
		-1,
		-1,
		211,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		169,
		163,
		134,
		127,
		131,
		-1,
		119,
		121,
		115,
		130,
		105,
		102,
		93,
		84,
		80,
		84,
		88,
		89,
		95,
		234,
		-1,
		197,
		-1,
		-1,
		-1,
		187,
		202,
		173,
		150,
		123,
		118,
		111,
		105,
		110,
		121,
		113,
		124,
		91,
		87,
		77,
		76,
		80,
		93,
		91,
		-1,
		-1,
		195,
		191,
		213,
		195,
		199,
		200,
		-1,
		-1,
		127,
		118,
		109,
		101,
		114,
		117,
		97,
		94,
		88,
		81,
		75,
		85,
		90,
		85,
		-1,
		-1,
		-1,
		207,
		-1,
		209,
		-1,
		-1,
		197,
		198,
		145,
		127,
		123,
		121,
		110,
		104,
		92,
		97,
		98,
		89,
		83,
		71,
		71,
		94,
		77,
		83,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		186,
		178,
		173,
		179,
		181,
		172,
		160,
		157,
		-1,
		127,
		133,
		98,
		105,
		88,
		95,
		93,
		85,
		65,
		68,
		84,
		80,
		68,
		75,
		66,
		74,
		-1,
		-1,
		272,
		261,
		250,
		256,
		-1,
		179,
		175,
		165,
		155,
		158,
		-1,
		-1,
		152,
		149,
		129,
		98,
		96,
		89,
		84,
		94,
		74,
		61,
		61,
		56,
		71,
		70,
		65,
		58,
		65,
		80,
		-1,
		226,
		263,
		256,
		224,
		232,
		263,
		-1,
		169,
		161,
		172,
		147,
		149,
		-1,
		-1,
		125,
		116,
		117,
		105,
		102,
		104,
		99,
		90,
		70,
		76,
		54,
		61,
		72,
		64,
		55,
		53,
		52,
		65,
		69,
		-1,
		219,
		239,
		218,
		221,
		245,
		259,
		-1,
		166,
		-1,
		-1,
		178,
		150,
		134,
		124,
		121,
		164,
		119,
		114,
		98,
		96,
		87,
		78,
		78,
		62,
		50,
		47,
		56,
		50,
		40,
		38,
		61,
		54,
		-1,
		208,
		219,
		212,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		187,
		-1,
		161,
		-1,
		144,
		148,
		127,
		130,
		112,
		99,
		91,
		78,
		87,
		62,
		58,
		54,
		43,
		40,
		44,
		22,
		30,
		39,
		233,
		189,
		192,
		203,
		214,
		229,
		233,
		-1,
		178,
		217,
		193,
		-1,
		177,
		-1,
		-1,
		-1,
		158,
		140,
		132,
		132,
		111,
		111,
		85,
		81,
		67,
		63,
		70,
		60,
		50,
		39,
		32,
		20,
		31,
		229,
		220,
		233,
		178,
		178,
		199,
		208,
		229,
		193,
		184,
		211,
		200,
		189,
		184,
		171,
		-1,
		-1,
		178,
		150,
		-1,
		-1,
		118,
		106,
		89,
		78,
		74,
		77,
		84,
		69,
		44,
		32,
		32,
		15,
		-1,
		222,
		221,
		210,
		207,
		183,
		174,
		169,
		196,
		-1,
		-1,
		191,
		212,
		202,
		206,
		222,
		247,
		-1,
		160,
		-1,
		-1,
		158,
		-1,
		-1,
		143,
		111,
		100,
		91,
		89,
		82,
		88,
		99,
		50,
		42,
		26,
		10,
		0,
		206,
		203,
		191,
		189,
		212,
		177,
		165,
		-1,
		178,
		176,
		182,
		189,
		206,
		236,
		-1,
		-1,
		176,
		156,
		-1,
		-1,
		141,
		139,
		128,
		-1,
		118,
		96,
		86,
		109,
		81,
		70,
		59,
		53,
		52,
		23,
		23,
		5,
		215,
		229,
		218,
		214,
		213,
		221,
		170,
		163,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		-1,
		166,
		162,
		-1,
		-1,
		136,
		129,
		117,
		105,
		95,
		100,
		86,
		82,
		68,
		61,
		56,
		65,
		38,
		30,
		11,
		-1,
		249,
		-1,
		201,
		177,
		191,
		206,
		214,
		-1,
		-1,
		-1,
		183,
		169,
		162,
		150,
		148,
		-1,
		170,
		154,
		135,
		-1,
		105,
		118,
		118,
		86,
		79,
		77,
		62,
		66,
		41,
		27,
		19,
		17,
		-1,
		-1,
		189,
		192,
		-1,
		-1,
		173,
		175,
		-1,
		174,
		163,
		148,
		140,
		-1,
		-1,
		142,
		138,
		-1,
		-1,
		106,
		100,
		89,
		85,
		81,
		63,
		64,
		54,
		43,
		20,
		20,
		-1,
		-1,
		194,
		186,
		180,
		-1,
		158,
		-1,
		176,
		-1,
		143,
		149,
		137,
		-1,
		-1,
		-1,
		137,
		100,
		116,
		107,
		77,
		75,
		66,
		59,
		58,
		47,
		40,
		30,
		-1,
		-1,
		-1,
		176,
		150,
		183,
		174,
		157,
		137,
		129,
		148,
		-1,
		118,
		-1,
		93,
		96,
		101,
		85,
		88,
		82,
		56,
		69,
		42,
		38,
		36,
		182,
		-1,
		152,
		185,
		149,
		143,
		119,
		123,
		139,
		-1,
		115,
		97,
		-1,
		108,
		95,
		99,
		84,
		65,
		52,
		55,
		40,
		33,
		-1,
		-1,
		-1,
		154,
		153,
		145,
		139,
		139,
		124,
		115,
		-1,
		127,
		109,
		88,
		103,
		88,
		79,
		79,
		89,
		85,
		72,
		70,
		49,
		-1,
		255,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		148,
		143,
		116,
		104,
		110,
		106,
		92,
		98,
		98,
		91,
		81,
		78,
		74,
		65,
		71,
		48,
		81,
		-1,
		250,
		-1,
		184,
		-1,
		-1,
		166,
		146,
		138,
		127,
		116,
		114,
		105,
		96,
		118,
		122,
		72,
		60,
		55,
		56,
		-1,
		239,
		238,
		-1,
		185,
		177,
		163,
		-1,
		156,
		-1,
		162,
		123,
		-1,
		125,
		105,
		-1,
		71,
		60,
		-1,
		-1,
		226,
		201,
		-1,
		-1,
		-1,
		186,
		166,
		157,
		141,
		-1,
		116,
		116,
		-1,
		-1,
		-1,
		211,
		210,
		-1,
		179,
		182,
		-1,
		172,
		163,
		171,
		118,
		122,
		-1,
		-1,
		-1,
		220,
		201,
		195,
		194,
		192,
		187,
		184,
		170,
		154,
		132,
		121,
		142,
		-1,
		-1,
		-1,
		192,
		184,
		177,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		214,
		195,
		-1,
		-1,
		169,
		-1,
		-1,
		175,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		203,
		-1,
		-1,
		-1,
		165,
		161,
		162,
		-1,
		-1,
		-1,
		-1,
		225,
		226,
		249,
		213,
		-1,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		228,
		226,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		155,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		188,
		-1,
		-1,
		-1,
		190,
		-1,
		190,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		203,
		-1,
		175,
		177,
		-1,
		225,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		180,
		187,
		209,
		212,
		248,
		-1,
		199
	],
	[
		-1,
		311,
		300,
		311,
		319,
		292,
		299,
		-1,
		318,
		322,
		288,
		282,
		321,
		290,
		296,
		307,
		-1,
		-1,
		-1,
		311,
		310,
		278,
		276,
		285,
		290,
		297,
		-1,
		296,
		-1,
		332,
		311,
		322,
		327,
		271,
		268,
		288,
		307,
		289,
		281,
		347,
		301,
		272,
		266,
		284,
		274,
		283,
		275,
		-1,
		272,
		262,
		284,
		263,
		274,
		266,
		-1,
		-1,
		266,
		267,
		273,
		259,
		265,
		261,
		-1,
		271,
		255,
		-1,
		-1,
		256,
		257,
		241,
		244,
		252,
		250,
		263,
		255,
		250,
		-1,
		-1,
		247,
		243,
		250,
		237,
		233,
		250,
		263,
		245,
		259,
		258,
		-1,
		253,
		271,
		276,
		244,
		242,
		226,
		224,
		242,
		244,
		250,
		250,
		-1,
		259,
		261,
		258,
		266,
		266,
		242,
		229,
		229,
		239,
		232,
		251,
		239,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		256,
		245,
		262,
		254,
		244,
		259,
		252,
		232,
		229,
		227,
		224,
		240,
		238,
		248,
		-1,
		-1,
		312,
		281,
		316,
		273,
		258,
		-1,
		252,
		238,
		244,
		248,
		242,
		235,
		249,
		245,
		-1,
		218,
		217,
		245,
		231,
		242,
		272,
		-1,
		-1,
		270,
		262,
		247,
		250,
		247,
		247,
		253,
		252,
		244,
		230,
		226,
		232,
		235,
		235,
		241,
		212,
		222,
		226,
		224,
		249,
		-1,
		-1,
		284,
		-1,
		-1,
		269,
		252,
		-1,
		235,
		242,
		242,
		259,
		249,
		270,
		263,
		254,
		246,
		240,
		228,
		230,
		227,
		240,
		228,
		209,
		234,
		238,
		219,
		240,
		235,
		-1,
		283,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		228,
		231,
		237,
		261,
		271,
		-1,
		275,
		263,
		264,
		249,
		246,
		233,
		221,
		234,
		219,
		226,
		225,
		213,
		211,
		241,
		216,
		238,
		235,
		254,
		259,
		253,
		262,
		-1,
		277,
		273,
		269,
		276,
		225,
		-1,
		-1,
		265,
		-1,
		279,
		292,
		287,
		260,
		263,
		250,
		241,
		228,
		217,
		228,
		217,
		214,
		222,
		205,
		220,
		211,
		210,
		228,
		238,
		246,
		250,
		256,
		-1,
		327,
		-1,
		269,
		253,
		255,
		227,
		248,
		-1,
		285,
		280,
		300,
		289,
		287,
		-1,
		259,
		256,
		246,
		224,
		209,
		226,
		218,
		216,
		218,
		200,
		214,
		205,
		223,
		230,
		228,
		232,
		252,
		264,
		287,
		277,
		-1,
		259,
		264,
		223,
		231,
		250,
		323,
		293,
		-1,
		288,
		-1,
		261,
		274,
		-1,
		230,
		226,
		208,
		209,
		204,
		219,
		211,
		196,
		193,
		211,
		214,
		221,
		225,
		241,
		-1,
		-1,
		272,
		276,
		265,
		216,
		235,
		259,
		296,
		286,
		275,
		274,
		-1,
		265,
		244,
		241,
		229,
		216,
		201,
		202,
		210,
		222,
		201,
		195,
		192,
		212,
		238,
		216,
		227,
		-1,
		-1,
		-1,
		297,
		-1,
		-1,
		242,
		213,
		237,
		279,
		304,
		297,
		285,
		250,
		250,
		244,
		-1,
		240,
		219,
		210,
		199,
		197,
		210,
		202,
		210,
		190,
		188,
		207,
		219,
		210,
		218,
		-1,
		-1,
		-1,
		272,
		261,
		262,
		211,
		234,
		268,
		283,
		269,
		274,
		249,
		242,
		236,
		253,
		236,
		217,
		206,
		198,
		187,
		198,
		206,
		204,
		186,
		195,
		201,
		225,
		206,
		212,
		-1,
		-1,
		279,
		269,
		253,
		255,
		252,
		225,
		232,
		264,
		274,
		276,
		-1,
		241,
		-1,
		230,
		226,
		211,
		206,
		203,
		190,
		189,
		203,
		203,
		193,
		188,
		195,
		230,
		230,
		196,
		216,
		219,
		-1,
		-1,
		-1,
		272,
		270,
		245,
		222,
		206,
		242,
		-1,
		246,
		247,
		-1,
		235,
		229,
		226,
		213,
		209,
		194,
		198,
		200,
		203,
		191,
		197,
		198,
		180,
		204,
		-1,
		204,
		198,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		268,
		247,
		240,
		260,
		201,
		253,
		-1,
		-1,
		231,
		224,
		-1,
		222,
		204,
		206,
		201,
		197,
		199,
		196,
		185,
		198,
		191,
		185,
		179,
		192,
		196,
		197,
		186,
		182,
		179,
		193,
		-1,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		221,
		-1,
		234,
		226,
		222,
		216,
		221,
		217,
		215,
		225,
		209,
		211,
		207,
		199,
		194,
		180,
		173,
		184,
		169,
		187,
		193,
		184,
		179,
		178,
		189,
		-1,
		288,
		274,
		245,
		-1,
		-1,
		234,
		-1,
		198,
		212,
		228,
		-1,
		256,
		235,
		253,
		231,
		227,
		218,
		216,
		217,
		187,
		192,
		194,
		182,
		185,
		174,
		177,
		169,
		191,
		188,
		172,
		174,
		183,
		-1,
		294,
		281,
		239,
		235,
		224,
		244,
		195,
		204,
		215,
		-1,
		-1,
		278,
		-1,
		229,
		234,
		232,
		230,
		206,
		181,
		188,
		206,
		179,
		174,
		179,
		168,
		168,
		163,
		182,
		168,
		166,
		181,
		197,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		210,
		197,
		191,
		-1,
		232,
		-1,
		256,
		244,
		231,
		213,
		253,
		-1,
		180,
		176,
		183,
		-1,
		199,
		-1,
		171,
		174,
		165,
		160,
		157,
		168,
		166,
		175,
		176,
		-1,
		244,
		229,
		222,
		212,
		226,
		197,
		-1,
		240,
		-1,
		-1,
		243,
		237,
		237,
		206,
		203,
		196,
		176,
		168,
		183,
		182,
		169,
		168,
		156,
		156,
		159,
		153,
		166,
		176,
		182,
		174,
		-1,
		-1,
		-1,
		249,
		201,
		209,
		185,
		206,
		-1,
		-1,
		304,
		260,
		246,
		-1,
		198,
		196,
		184,
		174,
		164,
		169,
		170,
		160,
		158,
		154,
		163,
		162,
		155,
		154,
		175,
		168,
		190,
		-1,
		-1,
		198,
		211,
		213,
		197,
		192,
		-1,
		-1,
		-1,
		250,
		251,
		217,
		196,
		185,
		-1,
		-1,
		168,
		161,
		155,
		158,
		146,
		166,
		173,
		161,
		148,
		163,
		173,
		181,
		180,
		-1,
		201,
		188,
		-1,
		-1,
		191,
		181,
		-1,
		-1,
		-1,
		-1,
		229,
		174,
		163,
		158,
		162,
		167,
		-1,
		141,
		152,
		145,
		164,
		171,
		163,
		148,
		142,
		153,
		168,
		185,
		-1,
		-1,
		205,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		186,
		180,
		151,
		144,
		148,
		-1,
		143,
		145,
		142,
		154,
		159,
		163,
		154,
		136,
		150,
		153,
		166,
		180,
		184,
		228,
		-1,
		158,
		-1,
		-1,
		-1,
		197,
		198,
		184,
		161,
		140,
		133,
		130,
		129,
		134,
		145,
		154,
		165,
		130,
		134,
		149,
		154,
		158,
		175,
		179,
		-1,
		-1,
		156,
		152,
		187,
		199,
		171,
		211,
		-1,
		-1,
		129,
		122,
		132,
		125,
		138,
		141,
		126,
		128,
		146,
		159,
		153,
		163,
		178,
		173,
		-1,
		-1,
		-1,
		154,
		-1,
		170,
		-1,
		-1,
		161,
		202,
		149,
		131,
		127,
		113,
		120,
		114,
		116,
		121,
		140,
		135,
		144,
		149,
		153,
		176,
		165,
		204,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		120,
		139,
		134,
		140,
		145,
		136,
		164,
		161,
		-1,
		110,
		143,
		111,
		125,
		121,
		128,
		133,
		139,
		143,
		150,
		166,
		165,
		160,
		196,
		187,
		193,
		-1,
		-1,
		147,
		136,
		125,
		131,
		-1,
		113,
		136,
		126,
		116,
		122,
		-1,
		-1,
		128,
		125,
		123,
		103,
		109,
		114,
		117,
		155,
		131,
		139,
		143,
		147,
		153,
		158,
		163,
		169,
		184,
		199,
		-1,
		101,
		138,
		131,
		99,
		107,
		138,
		-1,
		103,
		95,
		123,
		108,
		116,
		-1,
		-1,
		101,
		92,
		97,
		106,
		107,
		138,
		137,
		150,
		153,
		158,
		146,
		145,
		163,
		167,
		176,
		183,
		173,
		186,
		190,
		-1,
		94,
		114,
		93,
		96,
		120,
		134,
		-1,
		94,
		-1,
		-1,
		139,
		126,
		110,
		100,
		97,
		144,
		120,
		115,
		121,
		123,
		147,
		138,
		163,
		154,
		154,
		157,
		172,
		177,
		169,
		183,
		183,
		184,
		-1,
		83,
		94,
		87,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		155,
		-1,
		137,
		-1,
		120,
		124,
		128,
		131,
		146,
		133,
		140,
		157,
		163,
		152,
		162,
		158,
		159,
		168,
		179,
		191,
		190,
		191,
		61,
		64,
		67,
		78,
		89,
		104,
		108,
		-1,
		78,
		114,
		124,
		-1,
		164,
		-1,
		-1,
		-1,
		134,
		141,
		133,
		149,
		145,
		145,
		141,
		145,
		157,
		164,
		174,
		176,
		168,
		172,
		185,
		196,
		199,
		57,
		58,
		108,
		53,
		53,
		74,
		83,
		104,
		74,
		71,
		108,
		113,
		128,
		133,
		157,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		152,
		162,
		145,
		147,
		151,
		165,
		177,
		185,
		175,
		173,
		167,
		199,
		-1,
		16,
		21,
		24,
		29,
		21,
		33,
		44,
		71,
		-1,
		-1,
		72,
		99,
		83,
		87,
		103,
		128,
		-1,
		164,
		-1,
		-1,
		178,
		-1,
		-1,
		204,
		167,
		156,
		147,
		153,
		159,
		170,
		192,
		181,
		182,
		172,
		182,
		195,
		0,
		3,
		13,
		17,
		34,
		52,
		40,
		-1,
		59,
		57,
		63,
		70,
		87,
		117,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		197,
		200,
		189,
		-1,
		179,
		152,
		157,
		182,
		189,
		190,
		184,
		178,
		185,
		184,
		192,
		200,
		9,
		23,
		23,
		39,
		35,
		48,
		45,
		44,
		56,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		190,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		174,
		174,
		177,
		181,
		176,
		187,
		179,
		183,
		200,
		-1,
		72,
		-1,
		76,
		58,
		72,
		87,
		95,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		210,
		178,
		183,
		178,
		182,
		193,
		182,
		185,
		199,
		194,
		-1,
		-1,
		70,
		73,
		-1,
		-1,
		95,
		114,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		167,
		192,
		181,
		189,
		184,
		186,
		192,
		195,
		184,
		188,
		200,
		-1,
		-1,
		77,
		78,
		83,
		-1,
		104,
		-1,
		219,
		-1,
		186,
		193,
		181,
		-1,
		-1,
		-1,
		205,
		168,
		189,
		199,
		204,
		202,
		193,
		190,
		197,
		195,
		191,
		202,
		-1,
		-1,
		-1,
		134,
		111,
		226,
		217,
		200,
		180,
		172,
		192,
		-1,
		193,
		-1,
		168,
		169,
		196,
		198,
		215,
		209,
		193,
		208,
		198,
		189,
		198,
		140,
		-1,
		115,
		174,
		157,
		186,
		152,
		164,
		214,
		-1,
		190,
		172,
		-1,
		200,
		190,
		232,
		213,
		206,
		193,
		200,
		202,
		195,
		-1,
		-1,
		-1,
		130,
		129,
		128,
		139,
		147,
		145,
		163,
		-1,
		202,
		184,
		163,
		180,
		180,
		171,
		179,
		222,
		218,
		211,
		213,
		203,
		-1,
		146,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		156,
		178,
		173,
		165,
		177,
		181,
		167,
		173,
		175,
		183,
		181,
		178,
		190,
		186,
		206,
		202,
		234,
		-1,
		153,
		-1,
		160,
		-1,
		-1,
		174,
		160,
		172,
		183,
		173,
		173,
		178,
		171,
		193,
		209,
		193,
		191,
		196,
		201,
		-1,
		163,
		164,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		219,
		180,
		-1,
		200,
		180,
		-1,
		202,
		198,
		-1,
		-1,
		175,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		214,
		198,
		-1,
		191,
		191,
		-1,
		-1,
		-1,
		189,
		212,
		-1,
		187,
		190,
		-1,
		181,
		187,
		216,
		193,
		197,
		-1,
		-1,
		-1,
		216,
		200,
		205,
		202,
		207,
		195,
		212,
		198,
		200,
		207,
		196,
		217,
		-1,
		-1,
		-1,
		215,
		207,
		207,
		-1,
		-1,
		225,
		208,
		208,
		216,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		216,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		226,
		-1,
		-1,
		-1,
		217,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		254,
		247,
		-1,
		-1,
		-1,
		231,
		226,
		-1,
		-1,
		207,
		208,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		230,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		264,
		-1,
		265,
		240,
		247,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		278,
		-1,
		250,
		252,
		-1,
		300,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		255,
		262,
		284,
		287,
		291,
		-1,
		274
	],
	[
		-1,
		308,
		297,
		308,
		316,
		289,
		296,
		-1,
		315,
		319,
		285,
		279,
		318,
		287,
		293,
		304,
		-1,
		-1,
		-1,
		308,
		307,
		275,
		273,
		282,
		287,
		294,
		-1,
		293,
		-1,
		329,
		308,
		319,
		324,
		268,
		265,
		285,
		304,
		286,
		278,
		344,
		298,
		269,
		263,
		281,
		271,
		280,
		272,
		-1,
		269,
		259,
		281,
		260,
		271,
		263,
		-1,
		-1,
		263,
		264,
		270,
		256,
		262,
		258,
		-1,
		268,
		252,
		-1,
		-1,
		253,
		254,
		238,
		241,
		249,
		247,
		260,
		252,
		247,
		-1,
		-1,
		244,
		240,
		247,
		234,
		230,
		247,
		260,
		242,
		256,
		255,
		-1,
		250,
		268,
		273,
		241,
		239,
		223,
		221,
		239,
		241,
		247,
		247,
		-1,
		256,
		258,
		255,
		263,
		263,
		239,
		226,
		226,
		236,
		229,
		248,
		236,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		253,
		242,
		259,
		251,
		241,
		256,
		249,
		229,
		226,
		224,
		221,
		237,
		235,
		245,
		-1,
		-1,
		309,
		278,
		313,
		270,
		255,
		-1,
		249,
		235,
		241,
		245,
		239,
		232,
		246,
		242,
		-1,
		215,
		214,
		242,
		228,
		239,
		269,
		-1,
		-1,
		267,
		259,
		244,
		247,
		244,
		244,
		250,
		249,
		241,
		227,
		223,
		229,
		232,
		232,
		238,
		209,
		219,
		223,
		221,
		246,
		-1,
		-1,
		281,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		239,
		256,
		246,
		267,
		260,
		251,
		243,
		237,
		225,
		227,
		224,
		237,
		225,
		206,
		231,
		235,
		216,
		237,
		232,
		-1,
		280,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		268,
		-1,
		272,
		260,
		261,
		246,
		243,
		230,
		218,
		231,
		216,
		223,
		222,
		210,
		208,
		238,
		213,
		235,
		232,
		251,
		256,
		250,
		259,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		276,
		289,
		284,
		257,
		260,
		247,
		238,
		225,
		214,
		225,
		214,
		211,
		219,
		202,
		217,
		208,
		207,
		225,
		235,
		243,
		247,
		253,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		277,
		297,
		286,
		284,
		-1,
		256,
		253,
		243,
		221,
		206,
		223,
		215,
		213,
		215,
		197,
		211,
		202,
		220,
		227,
		225,
		229,
		249,
		261,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		320,
		290,
		-1,
		285,
		-1,
		258,
		271,
		-1,
		227,
		223,
		205,
		206,
		201,
		216,
		208,
		193,
		190,
		208,
		211,
		218,
		222,
		238,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		283,
		272,
		271,
		-1,
		262,
		241,
		238,
		226,
		213,
		198,
		199,
		207,
		219,
		198,
		192,
		189,
		209,
		235,
		213,
		224,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		301,
		294,
		282,
		247,
		247,
		241,
		-1,
		237,
		216,
		207,
		196,
		194,
		207,
		199,
		207,
		187,
		185,
		204,
		216,
		207,
		215,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		208,
		231,
		265,
		280,
		266,
		271,
		246,
		239,
		233,
		250,
		233,
		214,
		203,
		195,
		184,
		195,
		203,
		201,
		183,
		192,
		198,
		222,
		203,
		209,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		222,
		229,
		261,
		271,
		273,
		-1,
		238,
		-1,
		227,
		223,
		208,
		203,
		200,
		187,
		186,
		200,
		200,
		190,
		185,
		192,
		227,
		227,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		269,
		267,
		242,
		219,
		203,
		239,
		-1,
		243,
		244,
		-1,
		232,
		226,
		223,
		210,
		206,
		191,
		195,
		197,
		200,
		188,
		194,
		195,
		177,
		201,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		265,
		244,
		237,
		257,
		198,
		250,
		-1,
		-1,
		228,
		221,
		-1,
		219,
		201,
		203,
		198,
		194,
		196,
		193,
		182,
		195,
		188,
		182,
		176,
		189,
		193,
		194,
		183,
		179,
		176,
		190,
		-1,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		218,
		-1,
		231,
		223,
		219,
		213,
		218,
		214,
		212,
		222,
		206,
		208,
		204,
		196,
		191,
		177,
		170,
		181,
		166,
		184,
		190,
		181,
		176,
		175,
		186,
		-1,
		285,
		271,
		242,
		-1,
		-1,
		231,
		-1,
		195,
		209,
		225,
		-1,
		253,
		232,
		250,
		228,
		224,
		215,
		213,
		214,
		184,
		189,
		191,
		179,
		182,
		171,
		174,
		166,
		188,
		185,
		169,
		171,
		180,
		-1,
		291,
		278,
		236,
		232,
		221,
		241,
		192,
		201,
		212,
		-1,
		-1,
		275,
		-1,
		226,
		231,
		229,
		227,
		203,
		178,
		185,
		203,
		176,
		171,
		176,
		165,
		165,
		160,
		179,
		165,
		163,
		178,
		194,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		207,
		194,
		188,
		-1,
		229,
		-1,
		253,
		241,
		228,
		210,
		250,
		-1,
		177,
		173,
		180,
		-1,
		196,
		-1,
		168,
		171,
		162,
		157,
		154,
		165,
		163,
		172,
		173,
		-1,
		241,
		226,
		219,
		209,
		223,
		194,
		-1,
		237,
		-1,
		-1,
		240,
		234,
		234,
		203,
		200,
		193,
		173,
		165,
		180,
		179,
		166,
		165,
		153,
		153,
		156,
		150,
		163,
		173,
		179,
		171,
		-1,
		-1,
		-1,
		246,
		198,
		206,
		182,
		203,
		-1,
		-1,
		301,
		257,
		243,
		-1,
		195,
		193,
		181,
		171,
		161,
		166,
		167,
		157,
		155,
		151,
		160,
		159,
		152,
		151,
		172,
		165,
		187,
		-1,
		-1,
		195,
		208,
		210,
		194,
		189,
		-1,
		-1,
		-1,
		247,
		248,
		214,
		193,
		182,
		-1,
		-1,
		165,
		158,
		152,
		155,
		143,
		163,
		170,
		158,
		145,
		160,
		170,
		178,
		177,
		-1,
		198,
		185,
		-1,
		-1,
		188,
		178,
		-1,
		-1,
		-1,
		-1,
		226,
		171,
		160,
		155,
		159,
		164,
		-1,
		138,
		149,
		142,
		161,
		168,
		160,
		145,
		139,
		150,
		165,
		182,
		-1,
		-1,
		202,
		-1,
		164,
		-1,
		-1,
		-1,
		-1,
		183,
		177,
		148,
		141,
		145,
		-1,
		140,
		142,
		139,
		151,
		156,
		160,
		151,
		133,
		147,
		150,
		163,
		177,
		181,
		225,
		-1,
		155,
		-1,
		-1,
		-1,
		194,
		195,
		181,
		158,
		137,
		130,
		127,
		126,
		131,
		142,
		151,
		162,
		127,
		131,
		146,
		151,
		155,
		172,
		176,
		-1,
		-1,
		153,
		149,
		184,
		196,
		168,
		208,
		-1,
		-1,
		126,
		119,
		129,
		122,
		135,
		138,
		123,
		125,
		143,
		156,
		150,
		160,
		175,
		170,
		-1,
		-1,
		-1,
		151,
		-1,
		167,
		-1,
		-1,
		158,
		199,
		146,
		128,
		124,
		110,
		117,
		111,
		113,
		118,
		137,
		132,
		141,
		146,
		150,
		173,
		162,
		201,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		117,
		136,
		131,
		137,
		142,
		133,
		161,
		158,
		-1,
		107,
		140,
		108,
		122,
		118,
		125,
		130,
		136,
		140,
		147,
		163,
		162,
		157,
		193,
		184,
		190,
		-1,
		-1,
		144,
		133,
		122,
		128,
		-1,
		110,
		133,
		123,
		113,
		119,
		-1,
		-1,
		125,
		122,
		120,
		100,
		106,
		111,
		114,
		152,
		128,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		98,
		135,
		128,
		96,
		104,
		135,
		-1,
		100,
		92,
		120,
		105,
		113,
		-1,
		-1,
		98,
		89,
		94,
		103,
		104,
		135,
		134,
		147,
		150,
		155,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		91,
		111,
		90,
		93,
		117,
		131,
		-1,
		91,
		-1,
		-1,
		136,
		123,
		107,
		97,
		94,
		141,
		117,
		112,
		118,
		120,
		144,
		135,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		80,
		91,
		84,
		-1,
		-1,
		-1,
		-1,
		85,
		-1,
		-1,
		152,
		-1,
		134,
		-1,
		117,
		121,
		125,
		128,
		143,
		130,
		137,
		154,
		160,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		58,
		61,
		64,
		75,
		86,
		101,
		105,
		-1,
		75,
		111,
		121,
		-1,
		161,
		-1,
		-1,
		-1,
		131,
		138,
		130,
		146,
		142,
		142,
		138,
		142,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		54,
		55,
		105,
		50,
		50,
		71,
		80,
		101,
		71,
		68,
		105,
		110,
		125,
		130,
		154,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		149,
		159,
		142,
		144,
		148,
		162,
		174,
		182,
		172,
		170,
		164,
		196,
		-1,
		23,
		18,
		21,
		26,
		18,
		30,
		41,
		68,
		-1,
		-1,
		69,
		96,
		80,
		84,
		100,
		125,
		-1,
		161,
		-1,
		-1,
		175,
		-1,
		-1,
		201,
		164,
		153,
		144,
		150,
		156,
		167,
		189,
		178,
		179,
		169,
		179,
		192,
		7,
		0,
		10,
		14,
		31,
		49,
		37,
		-1,
		56,
		54,
		60,
		67,
		84,
		114,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		194,
		197,
		186,
		-1,
		176,
		149,
		154,
		179,
		186,
		187,
		181,
		175,
		182,
		181,
		189,
		197,
		16,
		26,
		20,
		36,
		32,
		45,
		42,
		41,
		53,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		206,
		187,
		-1,
		-1,
		194,
		187,
		175,
		163,
		153,
		163,
		171,
		171,
		174,
		178,
		173,
		184,
		176,
		180,
		197,
		-1,
		69,
		-1,
		73,
		55,
		69,
		84,
		92,
		-1,
		-1,
		-1,
		223,
		209,
		202,
		190,
		188,
		-1,
		228,
		212,
		193,
		-1,
		163,
		176,
		207,
		175,
		180,
		175,
		179,
		190,
		179,
		182,
		196,
		191,
		-1,
		-1,
		67,
		70,
		-1,
		-1,
		92,
		111,
		-1,
		214,
		203,
		188,
		180,
		-1,
		-1,
		200,
		196,
		-1,
		-1,
		164,
		189,
		178,
		186,
		181,
		183,
		189,
		192,
		181,
		185,
		197,
		-1,
		-1,
		74,
		75,
		80,
		-1,
		101,
		-1,
		216,
		-1,
		183,
		190,
		178,
		-1,
		-1,
		-1,
		202,
		165,
		186,
		196,
		201,
		199,
		190,
		187,
		194,
		192,
		188,
		199,
		-1,
		-1,
		-1,
		131,
		108,
		223,
		214,
		197,
		177,
		169,
		189,
		-1,
		190,
		-1,
		165,
		166,
		193,
		195,
		212,
		206,
		190,
		205,
		195,
		186,
		195,
		137,
		-1,
		112,
		171,
		154,
		183,
		149,
		161,
		211,
		-1,
		187,
		169,
		-1,
		197,
		187,
		229,
		210,
		203,
		190,
		197,
		199,
		192,
		-1,
		-1,
		-1,
		127,
		126,
		125,
		136,
		144,
		142,
		160,
		-1,
		199,
		181,
		160,
		177,
		177,
		168,
		176,
		219,
		215,
		208,
		210,
		200,
		-1,
		143,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		153,
		175,
		170,
		162,
		174,
		178,
		164,
		170,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		199,
		231,
		-1,
		150,
		-1,
		157,
		-1,
		-1,
		171,
		157,
		169,
		180,
		170,
		170,
		175,
		168,
		190,
		206,
		190,
		188,
		193,
		198,
		-1,
		160,
		161,
		-1,
		190,
		182,
		168,
		-1,
		161,
		-1,
		216,
		177,
		-1,
		197,
		177,
		-1,
		199,
		195,
		-1,
		-1,
		172,
		206,
		-1,
		-1,
		-1,
		191,
		171,
		211,
		195,
		-1,
		188,
		188,
		-1,
		-1,
		-1,
		186,
		209,
		-1,
		184,
		187,
		-1,
		178,
		184,
		213,
		190,
		194,
		-1,
		-1,
		-1,
		213,
		197,
		202,
		199,
		204,
		192,
		209,
		195,
		197,
		204,
		193,
		214,
		-1,
		-1,
		-1,
		212,
		204,
		204,
		-1,
		-1,
		222,
		205,
		205,
		213,
		-1,
		-1,
		-1,
		234,
		215,
		-1,
		-1,
		213,
		-1,
		-1,
		218,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		223,
		-1,
		-1,
		-1,
		214,
		221,
		229,
		-1,
		-1,
		-1,
		-1,
		206,
		207,
		251,
		244,
		-1,
		-1,
		-1,
		228,
		223,
		-1,
		-1,
		204,
		205,
		-1,
		-1,
		-1,
		256,
		240,
		-1,
		227,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		261,
		-1,
		262,
		237,
		244,
		-1,
		-1,
		-1,
		-1,
		274,
		266,
		275,
		-1,
		247,
		249,
		-1,
		297,
		-1,
		-1,
		289,
		280,
		-1,
		-1,
		252,
		259,
		281,
		284,
		288,
		-1,
		271
	],
	[
		-1,
		298,
		287,
		298,
		306,
		279,
		286,
		-1,
		305,
		309,
		275,
		269,
		308,
		277,
		283,
		294,
		-1,
		-1,
		-1,
		298,
		297,
		265,
		263,
		272,
		277,
		284,
		-1,
		283,
		-1,
		319,
		298,
		309,
		314,
		258,
		255,
		275,
		294,
		276,
		268,
		334,
		288,
		259,
		253,
		271,
		261,
		270,
		262,
		-1,
		259,
		249,
		271,
		250,
		261,
		253,
		-1,
		-1,
		253,
		254,
		260,
		246,
		252,
		248,
		-1,
		258,
		242,
		-1,
		-1,
		243,
		244,
		228,
		231,
		239,
		237,
		250,
		242,
		237,
		-1,
		-1,
		234,
		230,
		237,
		224,
		220,
		237,
		250,
		232,
		246,
		245,
		-1,
		240,
		258,
		263,
		231,
		229,
		213,
		211,
		229,
		231,
		237,
		237,
		-1,
		246,
		248,
		245,
		253,
		253,
		229,
		216,
		216,
		226,
		219,
		238,
		226,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		243,
		232,
		249,
		241,
		231,
		246,
		239,
		219,
		216,
		214,
		211,
		227,
		225,
		235,
		-1,
		-1,
		299,
		268,
		303,
		260,
		245,
		-1,
		239,
		225,
		231,
		235,
		229,
		222,
		236,
		232,
		-1,
		205,
		204,
		232,
		218,
		229,
		259,
		-1,
		-1,
		257,
		249,
		234,
		237,
		234,
		234,
		240,
		239,
		231,
		217,
		213,
		219,
		222,
		222,
		228,
		199,
		209,
		213,
		211,
		236,
		-1,
		-1,
		271,
		-1,
		-1,
		256,
		239,
		-1,
		222,
		229,
		229,
		246,
		236,
		257,
		250,
		241,
		233,
		227,
		215,
		217,
		214,
		227,
		215,
		196,
		221,
		225,
		206,
		227,
		222,
		-1,
		270,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		215,
		218,
		224,
		248,
		258,
		-1,
		262,
		250,
		251,
		236,
		233,
		220,
		208,
		221,
		206,
		213,
		212,
		200,
		198,
		228,
		203,
		225,
		222,
		241,
		246,
		240,
		249,
		-1,
		264,
		260,
		256,
		263,
		212,
		-1,
		-1,
		252,
		-1,
		266,
		279,
		274,
		247,
		250,
		237,
		228,
		215,
		204,
		215,
		204,
		201,
		209,
		192,
		207,
		198,
		197,
		215,
		225,
		233,
		237,
		243,
		-1,
		314,
		-1,
		256,
		240,
		242,
		214,
		235,
		-1,
		272,
		267,
		287,
		276,
		274,
		-1,
		246,
		243,
		233,
		211,
		196,
		213,
		205,
		203,
		205,
		187,
		201,
		192,
		210,
		217,
		215,
		219,
		239,
		251,
		274,
		264,
		-1,
		246,
		251,
		210,
		218,
		237,
		310,
		280,
		-1,
		275,
		-1,
		248,
		261,
		-1,
		217,
		213,
		195,
		196,
		191,
		206,
		198,
		183,
		180,
		198,
		201,
		208,
		212,
		228,
		-1,
		-1,
		259,
		263,
		252,
		203,
		222,
		246,
		283,
		273,
		262,
		261,
		-1,
		252,
		231,
		228,
		216,
		203,
		188,
		189,
		197,
		209,
		188,
		182,
		179,
		199,
		225,
		203,
		214,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		229,
		200,
		224,
		266,
		291,
		284,
		272,
		237,
		237,
		231,
		-1,
		227,
		206,
		197,
		186,
		184,
		197,
		189,
		197,
		177,
		175,
		194,
		206,
		197,
		205,
		-1,
		-1,
		-1,
		259,
		248,
		249,
		198,
		221,
		255,
		270,
		256,
		261,
		236,
		229,
		223,
		240,
		223,
		204,
		193,
		185,
		174,
		185,
		193,
		191,
		173,
		182,
		188,
		212,
		193,
		199,
		-1,
		-1,
		266,
		256,
		240,
		242,
		239,
		212,
		219,
		251,
		261,
		263,
		-1,
		228,
		-1,
		217,
		213,
		198,
		193,
		190,
		177,
		176,
		190,
		190,
		180,
		175,
		182,
		217,
		217,
		183,
		203,
		206,
		-1,
		-1,
		-1,
		259,
		257,
		232,
		209,
		193,
		229,
		-1,
		233,
		234,
		-1,
		222,
		216,
		213,
		200,
		196,
		181,
		185,
		187,
		190,
		178,
		184,
		185,
		167,
		191,
		-1,
		191,
		185,
		193,
		183,
		171,
		-1,
		-1,
		-1,
		255,
		234,
		227,
		247,
		188,
		240,
		-1,
		-1,
		218,
		211,
		-1,
		209,
		191,
		193,
		188,
		184,
		186,
		183,
		172,
		185,
		178,
		172,
		166,
		179,
		183,
		184,
		173,
		169,
		166,
		180,
		-1,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		208,
		-1,
		221,
		213,
		209,
		203,
		208,
		204,
		202,
		212,
		196,
		198,
		194,
		186,
		181,
		167,
		160,
		171,
		156,
		174,
		180,
		171,
		166,
		165,
		176,
		-1,
		275,
		261,
		232,
		-1,
		-1,
		221,
		-1,
		185,
		199,
		215,
		-1,
		243,
		222,
		240,
		218,
		214,
		205,
		203,
		204,
		174,
		179,
		181,
		169,
		172,
		161,
		164,
		156,
		178,
		175,
		159,
		161,
		170,
		-1,
		281,
		268,
		226,
		222,
		211,
		231,
		182,
		191,
		202,
		-1,
		-1,
		265,
		-1,
		216,
		221,
		219,
		217,
		193,
		168,
		175,
		193,
		166,
		161,
		166,
		155,
		155,
		150,
		169,
		155,
		153,
		168,
		184,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		197,
		184,
		178,
		-1,
		219,
		-1,
		243,
		231,
		218,
		200,
		240,
		-1,
		167,
		163,
		170,
		-1,
		186,
		-1,
		158,
		161,
		152,
		147,
		144,
		155,
		153,
		162,
		163,
		-1,
		231,
		216,
		209,
		199,
		213,
		184,
		-1,
		227,
		-1,
		-1,
		230,
		224,
		224,
		193,
		190,
		183,
		163,
		155,
		170,
		169,
		156,
		155,
		143,
		143,
		146,
		140,
		153,
		163,
		169,
		161,
		-1,
		-1,
		-1,
		236,
		188,
		196,
		172,
		193,
		-1,
		-1,
		291,
		247,
		233,
		-1,
		185,
		183,
		171,
		161,
		151,
		156,
		157,
		147,
		145,
		141,
		150,
		149,
		142,
		141,
		162,
		155,
		177,
		-1,
		-1,
		185,
		198,
		200,
		184,
		179,
		-1,
		-1,
		-1,
		237,
		238,
		204,
		183,
		172,
		-1,
		-1,
		155,
		148,
		142,
		145,
		133,
		153,
		160,
		148,
		135,
		150,
		160,
		168,
		167,
		-1,
		188,
		175,
		-1,
		-1,
		178,
		168,
		-1,
		-1,
		-1,
		-1,
		216,
		161,
		150,
		145,
		149,
		154,
		-1,
		128,
		139,
		132,
		151,
		158,
		150,
		135,
		129,
		140,
		155,
		172,
		-1,
		-1,
		192,
		-1,
		154,
		-1,
		-1,
		-1,
		-1,
		173,
		167,
		138,
		131,
		135,
		-1,
		130,
		132,
		129,
		141,
		146,
		150,
		141,
		123,
		137,
		140,
		153,
		167,
		171,
		215,
		-1,
		145,
		-1,
		-1,
		-1,
		184,
		185,
		171,
		148,
		127,
		120,
		117,
		116,
		121,
		132,
		141,
		152,
		117,
		121,
		136,
		141,
		145,
		162,
		166,
		-1,
		-1,
		143,
		139,
		174,
		186,
		158,
		198,
		-1,
		-1,
		116,
		109,
		119,
		112,
		125,
		128,
		113,
		115,
		133,
		146,
		140,
		150,
		165,
		160,
		-1,
		-1,
		-1,
		141,
		-1,
		157,
		-1,
		-1,
		148,
		189,
		136,
		118,
		114,
		100,
		107,
		101,
		103,
		108,
		127,
		122,
		131,
		136,
		140,
		163,
		152,
		191,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		107,
		126,
		121,
		127,
		132,
		123,
		151,
		148,
		-1,
		97,
		130,
		98,
		112,
		108,
		115,
		120,
		126,
		130,
		137,
		153,
		152,
		147,
		183,
		174,
		180,
		-1,
		-1,
		134,
		123,
		112,
		118,
		-1,
		100,
		123,
		113,
		103,
		109,
		-1,
		-1,
		115,
		112,
		110,
		90,
		96,
		101,
		104,
		142,
		118,
		126,
		130,
		134,
		140,
		145,
		150,
		156,
		171,
		186,
		-1,
		88,
		125,
		118,
		86,
		94,
		125,
		-1,
		90,
		82,
		110,
		95,
		103,
		-1,
		-1,
		88,
		79,
		84,
		93,
		94,
		125,
		124,
		137,
		140,
		145,
		133,
		132,
		150,
		154,
		163,
		170,
		160,
		173,
		177,
		-1,
		81,
		101,
		80,
		83,
		107,
		121,
		-1,
		81,
		-1,
		-1,
		126,
		113,
		97,
		87,
		84,
		131,
		107,
		102,
		108,
		110,
		134,
		125,
		150,
		141,
		141,
		144,
		159,
		164,
		156,
		170,
		170,
		171,
		-1,
		70,
		81,
		74,
		-1,
		-1,
		-1,
		-1,
		75,
		-1,
		-1,
		142,
		-1,
		124,
		-1,
		107,
		111,
		115,
		118,
		133,
		120,
		127,
		144,
		150,
		139,
		149,
		145,
		146,
		155,
		166,
		178,
		177,
		178,
		48,
		51,
		54,
		65,
		76,
		91,
		95,
		-1,
		65,
		101,
		111,
		-1,
		151,
		-1,
		-1,
		-1,
		121,
		128,
		120,
		136,
		132,
		132,
		128,
		132,
		144,
		151,
		161,
		163,
		155,
		159,
		172,
		183,
		186,
		44,
		45,
		95,
		40,
		40,
		61,
		70,
		91,
		61,
		58,
		95,
		100,
		115,
		120,
		144,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		139,
		149,
		132,
		134,
		138,
		152,
		164,
		172,
		162,
		160,
		154,
		186,
		-1,
		35,
		30,
		19,
		16,
		8,
		20,
		31,
		58,
		-1,
		-1,
		59,
		86,
		70,
		74,
		90,
		115,
		-1,
		151,
		-1,
		-1,
		165,
		-1,
		-1,
		191,
		154,
		143,
		134,
		140,
		146,
		157,
		179,
		168,
		169,
		159,
		169,
		182,
		19,
		12,
		0,
		4,
		21,
		39,
		27,
		-1,
		46,
		44,
		50,
		57,
		74,
		104,
		-1,
		-1,
		167,
		158,
		-1,
		-1,
		184,
		187,
		176,
		-1,
		166,
		139,
		144,
		169,
		176,
		177,
		171,
		165,
		172,
		171,
		179,
		187,
		28,
		38,
		27,
		26,
		22,
		35,
		32,
		31,
		43,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		196,
		177,
		-1,
		-1,
		184,
		177,
		165,
		153,
		143,
		153,
		161,
		161,
		164,
		168,
		163,
		174,
		166,
		170,
		187,
		-1,
		59,
		-1,
		63,
		45,
		59,
		74,
		82,
		-1,
		-1,
		-1,
		213,
		199,
		192,
		180,
		178,
		-1,
		218,
		202,
		183,
		-1,
		153,
		166,
		197,
		165,
		170,
		165,
		169,
		180,
		169,
		172,
		186,
		181,
		-1,
		-1,
		57,
		60,
		-1,
		-1,
		82,
		101,
		-1,
		204,
		193,
		178,
		170,
		-1,
		-1,
		190,
		186,
		-1,
		-1,
		154,
		179,
		168,
		176,
		171,
		173,
		179,
		182,
		171,
		175,
		187,
		-1,
		-1,
		64,
		65,
		70,
		-1,
		91,
		-1,
		206,
		-1,
		173,
		180,
		168,
		-1,
		-1,
		-1,
		192,
		155,
		176,
		186,
		191,
		189,
		180,
		177,
		184,
		182,
		178,
		189,
		-1,
		-1,
		-1,
		121,
		98,
		213,
		204,
		187,
		167,
		159,
		179,
		-1,
		180,
		-1,
		155,
		156,
		183,
		185,
		202,
		196,
		180,
		195,
		185,
		176,
		185,
		127,
		-1,
		102,
		161,
		144,
		173,
		139,
		151,
		201,
		-1,
		177,
		159,
		-1,
		187,
		177,
		219,
		200,
		193,
		180,
		187,
		189,
		182,
		-1,
		-1,
		-1,
		117,
		116,
		115,
		126,
		134,
		132,
		150,
		-1,
		189,
		171,
		150,
		167,
		167,
		158,
		166,
		209,
		205,
		198,
		200,
		190,
		-1,
		133,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		143,
		165,
		160,
		152,
		164,
		168,
		154,
		160,
		162,
		170,
		168,
		165,
		177,
		173,
		193,
		189,
		221,
		-1,
		140,
		-1,
		147,
		-1,
		-1,
		161,
		147,
		159,
		170,
		160,
		160,
		165,
		158,
		180,
		196,
		180,
		178,
		183,
		188,
		-1,
		150,
		151,
		-1,
		180,
		172,
		158,
		-1,
		151,
		-1,
		206,
		167,
		-1,
		187,
		167,
		-1,
		189,
		185,
		-1,
		-1,
		162,
		196,
		-1,
		-1,
		-1,
		181,
		161,
		201,
		185,
		-1,
		178,
		178,
		-1,
		-1,
		-1,
		176,
		199,
		-1,
		174,
		177,
		-1,
		168,
		174,
		203,
		180,
		184,
		-1,
		-1,
		-1,
		203,
		187,
		192,
		189,
		194,
		182,
		199,
		185,
		187,
		194,
		183,
		204,
		-1,
		-1,
		-1,
		202,
		194,
		194,
		-1,
		-1,
		212,
		195,
		195,
		203,
		-1,
		-1,
		-1,
		224,
		205,
		-1,
		-1,
		203,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		-1,
		204,
		211,
		219,
		-1,
		-1,
		-1,
		-1,
		196,
		197,
		241,
		234,
		-1,
		-1,
		-1,
		218,
		213,
		-1,
		-1,
		194,
		195,
		-1,
		-1,
		-1,
		246,
		230,
		-1,
		217,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		251,
		-1,
		252,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		264,
		256,
		265,
		-1,
		237,
		239,
		-1,
		287,
		-1,
		-1,
		279,
		270,
		-1,
		-1,
		242,
		249,
		271,
		274,
		278,
		-1,
		261
	],
	[
		-1,
		294,
		283,
		294,
		302,
		275,
		282,
		-1,
		301,
		305,
		271,
		265,
		304,
		273,
		279,
		290,
		-1,
		-1,
		-1,
		294,
		293,
		261,
		259,
		268,
		273,
		280,
		-1,
		279,
		-1,
		315,
		294,
		305,
		310,
		254,
		251,
		271,
		290,
		272,
		264,
		330,
		284,
		255,
		249,
		267,
		257,
		266,
		258,
		-1,
		255,
		245,
		267,
		246,
		257,
		249,
		-1,
		-1,
		249,
		250,
		256,
		242,
		248,
		244,
		-1,
		254,
		238,
		-1,
		-1,
		239,
		240,
		224,
		227,
		235,
		233,
		246,
		238,
		233,
		-1,
		-1,
		230,
		226,
		233,
		220,
		216,
		233,
		246,
		228,
		242,
		241,
		-1,
		236,
		254,
		259,
		227,
		225,
		209,
		207,
		225,
		227,
		233,
		233,
		-1,
		242,
		244,
		241,
		249,
		249,
		225,
		212,
		212,
		222,
		215,
		234,
		222,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		239,
		228,
		245,
		237,
		227,
		242,
		235,
		215,
		212,
		210,
		207,
		223,
		221,
		231,
		-1,
		-1,
		295,
		264,
		299,
		256,
		241,
		-1,
		235,
		221,
		227,
		231,
		225,
		218,
		232,
		228,
		-1,
		201,
		200,
		228,
		214,
		225,
		255,
		-1,
		-1,
		253,
		245,
		230,
		233,
		230,
		230,
		236,
		235,
		227,
		213,
		209,
		215,
		218,
		218,
		224,
		195,
		205,
		209,
		207,
		232,
		-1,
		-1,
		267,
		-1,
		-1,
		252,
		235,
		-1,
		218,
		225,
		225,
		242,
		232,
		253,
		246,
		237,
		229,
		223,
		211,
		213,
		210,
		223,
		211,
		192,
		217,
		221,
		202,
		223,
		218,
		-1,
		266,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		211,
		214,
		220,
		244,
		254,
		-1,
		258,
		246,
		247,
		232,
		229,
		216,
		204,
		217,
		202,
		209,
		208,
		196,
		194,
		224,
		199,
		221,
		218,
		237,
		242,
		236,
		245,
		-1,
		260,
		256,
		252,
		259,
		208,
		-1,
		-1,
		248,
		-1,
		262,
		275,
		270,
		243,
		246,
		233,
		224,
		211,
		200,
		211,
		200,
		197,
		205,
		188,
		203,
		194,
		193,
		211,
		221,
		229,
		233,
		239,
		-1,
		310,
		-1,
		252,
		236,
		238,
		210,
		231,
		-1,
		268,
		263,
		283,
		272,
		270,
		-1,
		242,
		239,
		229,
		207,
		192,
		209,
		201,
		199,
		201,
		183,
		197,
		188,
		206,
		213,
		211,
		215,
		235,
		247,
		270,
		260,
		-1,
		242,
		247,
		206,
		214,
		233,
		306,
		276,
		-1,
		271,
		-1,
		244,
		257,
		-1,
		213,
		209,
		191,
		192,
		187,
		202,
		194,
		179,
		176,
		194,
		197,
		204,
		208,
		224,
		-1,
		-1,
		255,
		259,
		248,
		199,
		218,
		242,
		279,
		269,
		258,
		257,
		-1,
		248,
		227,
		224,
		212,
		199,
		184,
		185,
		193,
		205,
		184,
		178,
		175,
		195,
		221,
		199,
		210,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		225,
		196,
		220,
		262,
		287,
		280,
		268,
		233,
		233,
		227,
		-1,
		223,
		202,
		193,
		182,
		180,
		193,
		185,
		193,
		173,
		171,
		190,
		202,
		193,
		201,
		-1,
		-1,
		-1,
		255,
		244,
		245,
		194,
		217,
		251,
		266,
		252,
		257,
		232,
		225,
		219,
		236,
		219,
		200,
		189,
		181,
		170,
		181,
		189,
		187,
		169,
		178,
		184,
		208,
		189,
		195,
		-1,
		-1,
		262,
		252,
		236,
		238,
		235,
		208,
		215,
		247,
		257,
		259,
		-1,
		224,
		-1,
		213,
		209,
		194,
		189,
		186,
		173,
		172,
		186,
		186,
		176,
		171,
		178,
		213,
		213,
		179,
		199,
		202,
		-1,
		-1,
		-1,
		255,
		253,
		228,
		205,
		189,
		225,
		-1,
		229,
		230,
		-1,
		218,
		212,
		209,
		196,
		192,
		177,
		181,
		183,
		186,
		174,
		180,
		181,
		163,
		187,
		-1,
		187,
		181,
		189,
		179,
		167,
		-1,
		-1,
		-1,
		251,
		230,
		223,
		243,
		184,
		236,
		-1,
		-1,
		214,
		207,
		-1,
		205,
		187,
		189,
		184,
		180,
		182,
		179,
		168,
		181,
		174,
		168,
		162,
		175,
		179,
		180,
		169,
		165,
		162,
		176,
		-1,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		204,
		-1,
		217,
		209,
		205,
		199,
		204,
		200,
		198,
		208,
		192,
		194,
		190,
		182,
		177,
		163,
		156,
		167,
		152,
		170,
		176,
		167,
		162,
		161,
		172,
		-1,
		271,
		257,
		228,
		-1,
		-1,
		217,
		-1,
		181,
		195,
		211,
		-1,
		239,
		218,
		236,
		214,
		210,
		201,
		199,
		200,
		170,
		175,
		177,
		165,
		168,
		157,
		160,
		152,
		174,
		171,
		155,
		157,
		166,
		-1,
		277,
		264,
		222,
		218,
		207,
		227,
		178,
		187,
		198,
		-1,
		-1,
		261,
		-1,
		212,
		217,
		215,
		213,
		189,
		164,
		171,
		189,
		162,
		157,
		162,
		151,
		151,
		146,
		165,
		151,
		149,
		164,
		180,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		193,
		180,
		174,
		-1,
		215,
		-1,
		239,
		227,
		214,
		196,
		236,
		-1,
		163,
		159,
		166,
		-1,
		182,
		-1,
		154,
		157,
		148,
		143,
		140,
		151,
		149,
		158,
		159,
		-1,
		227,
		212,
		205,
		195,
		209,
		180,
		-1,
		223,
		-1,
		-1,
		226,
		220,
		220,
		189,
		186,
		179,
		159,
		151,
		166,
		165,
		152,
		151,
		139,
		139,
		142,
		136,
		149,
		159,
		165,
		157,
		-1,
		-1,
		-1,
		232,
		184,
		192,
		168,
		189,
		-1,
		-1,
		287,
		243,
		229,
		-1,
		181,
		179,
		167,
		157,
		147,
		152,
		153,
		143,
		141,
		137,
		146,
		145,
		138,
		137,
		158,
		151,
		173,
		-1,
		-1,
		181,
		194,
		196,
		180,
		175,
		-1,
		-1,
		-1,
		233,
		234,
		200,
		179,
		168,
		-1,
		-1,
		151,
		144,
		138,
		141,
		129,
		149,
		156,
		144,
		131,
		146,
		156,
		164,
		163,
		-1,
		184,
		171,
		-1,
		-1,
		174,
		164,
		-1,
		-1,
		-1,
		-1,
		212,
		157,
		146,
		141,
		145,
		150,
		-1,
		124,
		135,
		128,
		147,
		154,
		146,
		131,
		125,
		136,
		151,
		168,
		-1,
		-1,
		188,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		169,
		163,
		134,
		127,
		131,
		-1,
		126,
		128,
		125,
		137,
		142,
		146,
		137,
		119,
		133,
		136,
		149,
		163,
		167,
		211,
		-1,
		141,
		-1,
		-1,
		-1,
		180,
		181,
		167,
		144,
		123,
		116,
		113,
		112,
		117,
		128,
		137,
		148,
		113,
		117,
		132,
		137,
		141,
		158,
		162,
		-1,
		-1,
		139,
		135,
		170,
		182,
		154,
		194,
		-1,
		-1,
		112,
		105,
		115,
		108,
		121,
		124,
		109,
		111,
		129,
		142,
		136,
		146,
		161,
		156,
		-1,
		-1,
		-1,
		137,
		-1,
		153,
		-1,
		-1,
		144,
		185,
		132,
		114,
		110,
		96,
		103,
		97,
		99,
		104,
		123,
		118,
		127,
		132,
		136,
		159,
		148,
		187,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		103,
		122,
		117,
		123,
		128,
		119,
		147,
		144,
		-1,
		93,
		126,
		94,
		108,
		104,
		111,
		116,
		122,
		126,
		133,
		149,
		148,
		143,
		179,
		170,
		176,
		-1,
		-1,
		130,
		119,
		108,
		114,
		-1,
		96,
		119,
		109,
		99,
		105,
		-1,
		-1,
		111,
		108,
		106,
		86,
		92,
		97,
		100,
		138,
		114,
		122,
		126,
		130,
		136,
		141,
		146,
		152,
		167,
		182,
		-1,
		84,
		121,
		114,
		82,
		90,
		121,
		-1,
		86,
		78,
		106,
		91,
		99,
		-1,
		-1,
		84,
		75,
		80,
		89,
		90,
		121,
		120,
		133,
		136,
		141,
		129,
		128,
		146,
		150,
		159,
		166,
		156,
		169,
		173,
		-1,
		77,
		97,
		76,
		79,
		103,
		117,
		-1,
		77,
		-1,
		-1,
		122,
		109,
		93,
		83,
		80,
		127,
		103,
		98,
		104,
		106,
		130,
		121,
		146,
		137,
		137,
		140,
		155,
		160,
		152,
		166,
		166,
		167,
		-1,
		66,
		77,
		70,
		-1,
		-1,
		-1,
		-1,
		71,
		-1,
		-1,
		138,
		-1,
		120,
		-1,
		103,
		107,
		111,
		114,
		129,
		116,
		123,
		140,
		146,
		135,
		145,
		141,
		142,
		151,
		162,
		174,
		173,
		174,
		44,
		47,
		50,
		61,
		72,
		87,
		91,
		-1,
		61,
		97,
		107,
		-1,
		147,
		-1,
		-1,
		-1,
		117,
		124,
		116,
		132,
		128,
		128,
		124,
		128,
		140,
		147,
		157,
		159,
		151,
		155,
		168,
		179,
		182,
		40,
		41,
		91,
		36,
		36,
		57,
		66,
		87,
		57,
		54,
		91,
		96,
		111,
		116,
		140,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		135,
		145,
		128,
		130,
		134,
		148,
		160,
		168,
		158,
		156,
		150,
		182,
		-1,
		33,
		32,
		21,
		18,
		4,
		16,
		27,
		54,
		-1,
		-1,
		55,
		82,
		66,
		70,
		86,
		111,
		-1,
		147,
		-1,
		-1,
		161,
		-1,
		-1,
		187,
		150,
		139,
		130,
		136,
		142,
		153,
		175,
		164,
		165,
		155,
		165,
		178,
		17,
		14,
		2,
		0,
		23,
		35,
		23,
		-1,
		42,
		40,
		46,
		53,
		70,
		100,
		-1,
		-1,
		163,
		154,
		-1,
		-1,
		180,
		183,
		172,
		-1,
		162,
		135,
		140,
		165,
		172,
		173,
		167,
		161,
		168,
		167,
		175,
		183,
		26,
		40,
		29,
		25,
		24,
		37,
		28,
		27,
		39,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		-1,
		192,
		173,
		-1,
		-1,
		180,
		173,
		161,
		149,
		139,
		149,
		157,
		157,
		160,
		164,
		159,
		170,
		162,
		166,
		183,
		-1,
		60,
		-1,
		59,
		41,
		55,
		70,
		78,
		-1,
		-1,
		-1,
		209,
		195,
		188,
		176,
		174,
		-1,
		214,
		198,
		179,
		-1,
		149,
		162,
		193,
		161,
		166,
		161,
		165,
		176,
		165,
		168,
		182,
		177,
		-1,
		-1,
		53,
		56,
		-1,
		-1,
		78,
		97,
		-1,
		200,
		189,
		174,
		166,
		-1,
		-1,
		186,
		182,
		-1,
		-1,
		150,
		175,
		164,
		172,
		167,
		169,
		175,
		178,
		167,
		171,
		183,
		-1,
		-1,
		60,
		61,
		66,
		-1,
		87,
		-1,
		202,
		-1,
		169,
		176,
		164,
		-1,
		-1,
		-1,
		188,
		151,
		172,
		182,
		187,
		185,
		176,
		173,
		180,
		178,
		174,
		185,
		-1,
		-1,
		-1,
		117,
		94,
		209,
		200,
		183,
		163,
		155,
		175,
		-1,
		176,
		-1,
		151,
		152,
		179,
		181,
		198,
		192,
		176,
		191,
		181,
		172,
		181,
		123,
		-1,
		98,
		157,
		140,
		169,
		135,
		147,
		197,
		-1,
		173,
		155,
		-1,
		183,
		173,
		215,
		196,
		189,
		176,
		183,
		185,
		178,
		-1,
		-1,
		-1,
		113,
		112,
		111,
		122,
		130,
		128,
		146,
		-1,
		185,
		167,
		146,
		163,
		163,
		154,
		162,
		205,
		201,
		194,
		196,
		186,
		-1,
		132,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		139,
		161,
		156,
		148,
		160,
		164,
		150,
		156,
		158,
		166,
		164,
		161,
		173,
		169,
		189,
		185,
		217,
		-1,
		139,
		-1,
		143,
		-1,
		-1,
		157,
		143,
		155,
		166,
		156,
		156,
		161,
		154,
		176,
		192,
		176,
		174,
		179,
		184,
		-1,
		149,
		150,
		-1,
		176,
		168,
		154,
		-1,
		147,
		-1,
		202,
		163,
		-1,
		183,
		163,
		-1,
		185,
		181,
		-1,
		-1,
		161,
		192,
		-1,
		-1,
		-1,
		177,
		157,
		197,
		181,
		-1,
		174,
		174,
		-1,
		-1,
		-1,
		175,
		198,
		-1,
		170,
		173,
		-1,
		164,
		170,
		199,
		176,
		180,
		-1,
		-1,
		-1,
		202,
		186,
		191,
		185,
		190,
		178,
		195,
		181,
		183,
		190,
		179,
		200,
		-1,
		-1,
		-1,
		198,
		190,
		190,
		-1,
		-1,
		208,
		191,
		191,
		199,
		-1,
		-1,
		-1,
		220,
		201,
		-1,
		-1,
		199,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		209,
		-1,
		-1,
		-1,
		200,
		207,
		215,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		237,
		230,
		-1,
		-1,
		-1,
		214,
		209,
		-1,
		-1,
		190,
		191,
		-1,
		-1,
		-1,
		242,
		226,
		-1,
		213,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		247,
		-1,
		248,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		260,
		252,
		261,
		-1,
		233,
		235,
		-1,
		283,
		-1,
		-1,
		275,
		266,
		-1,
		-1,
		238,
		245,
		267,
		270,
		274,
		-1,
		257
	],
	[
		-1,
		319,
		308,
		319,
		327,
		300,
		307,
		-1,
		326,
		330,
		296,
		290,
		329,
		298,
		304,
		315,
		-1,
		-1,
		-1,
		319,
		318,
		286,
		284,
		293,
		298,
		305,
		-1,
		304,
		-1,
		340,
		319,
		330,
		335,
		279,
		276,
		296,
		315,
		297,
		289,
		355,
		309,
		280,
		274,
		292,
		282,
		291,
		283,
		-1,
		280,
		270,
		292,
		271,
		282,
		274,
		-1,
		-1,
		274,
		275,
		281,
		267,
		273,
		269,
		-1,
		279,
		263,
		-1,
		-1,
		264,
		265,
		249,
		252,
		260,
		258,
		271,
		263,
		258,
		-1,
		-1,
		255,
		251,
		258,
		245,
		241,
		258,
		271,
		253,
		267,
		266,
		-1,
		261,
		279,
		284,
		252,
		250,
		234,
		232,
		250,
		252,
		258,
		258,
		-1,
		267,
		269,
		266,
		274,
		274,
		250,
		237,
		237,
		247,
		240,
		259,
		247,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		264,
		253,
		270,
		262,
		252,
		267,
		260,
		240,
		237,
		235,
		232,
		248,
		246,
		256,
		-1,
		-1,
		320,
		289,
		324,
		281,
		266,
		-1,
		260,
		246,
		252,
		256,
		250,
		243,
		257,
		253,
		-1,
		226,
		225,
		253,
		239,
		250,
		280,
		-1,
		-1,
		278,
		270,
		255,
		258,
		255,
		255,
		261,
		260,
		252,
		238,
		234,
		240,
		243,
		243,
		249,
		220,
		230,
		234,
		232,
		257,
		-1,
		-1,
		292,
		-1,
		-1,
		277,
		260,
		-1,
		243,
		250,
		250,
		267,
		257,
		278,
		271,
		262,
		254,
		248,
		236,
		238,
		235,
		248,
		236,
		217,
		242,
		246,
		227,
		248,
		243,
		-1,
		291,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		236,
		239,
		245,
		269,
		279,
		-1,
		283,
		271,
		272,
		257,
		254,
		241,
		229,
		242,
		227,
		234,
		233,
		221,
		219,
		249,
		224,
		246,
		243,
		262,
		267,
		261,
		270,
		-1,
		285,
		281,
		277,
		284,
		233,
		-1,
		-1,
		273,
		-1,
		287,
		300,
		295,
		268,
		271,
		258,
		249,
		236,
		225,
		236,
		225,
		222,
		230,
		213,
		228,
		219,
		218,
		236,
		246,
		254,
		258,
		264,
		-1,
		335,
		-1,
		277,
		261,
		263,
		235,
		256,
		-1,
		293,
		288,
		308,
		297,
		295,
		-1,
		267,
		264,
		254,
		232,
		217,
		234,
		226,
		224,
		226,
		208,
		222,
		213,
		231,
		238,
		236,
		240,
		260,
		272,
		295,
		285,
		-1,
		267,
		272,
		231,
		239,
		258,
		331,
		301,
		-1,
		296,
		-1,
		269,
		282,
		-1,
		238,
		234,
		216,
		217,
		212,
		227,
		219,
		204,
		201,
		219,
		222,
		229,
		233,
		249,
		-1,
		-1,
		280,
		284,
		273,
		224,
		243,
		267,
		304,
		294,
		283,
		282,
		-1,
		273,
		252,
		249,
		237,
		224,
		209,
		210,
		218,
		230,
		209,
		203,
		200,
		220,
		246,
		224,
		235,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		250,
		221,
		245,
		287,
		312,
		305,
		293,
		258,
		258,
		252,
		-1,
		248,
		227,
		218,
		207,
		205,
		218,
		210,
		218,
		198,
		196,
		215,
		227,
		218,
		226,
		-1,
		-1,
		-1,
		280,
		269,
		270,
		219,
		242,
		276,
		291,
		277,
		282,
		257,
		250,
		244,
		261,
		244,
		225,
		214,
		206,
		195,
		206,
		214,
		212,
		194,
		203,
		209,
		233,
		214,
		220,
		-1,
		-1,
		287,
		277,
		261,
		263,
		260,
		233,
		240,
		272,
		282,
		284,
		-1,
		249,
		-1,
		238,
		234,
		219,
		214,
		211,
		198,
		197,
		211,
		211,
		201,
		196,
		203,
		238,
		238,
		204,
		224,
		227,
		-1,
		-1,
		-1,
		280,
		278,
		253,
		230,
		214,
		250,
		-1,
		254,
		255,
		-1,
		243,
		237,
		234,
		221,
		217,
		202,
		206,
		208,
		211,
		199,
		205,
		206,
		188,
		212,
		-1,
		212,
		206,
		214,
		204,
		192,
		-1,
		-1,
		-1,
		276,
		255,
		248,
		268,
		209,
		261,
		-1,
		-1,
		239,
		232,
		-1,
		230,
		212,
		214,
		209,
		205,
		207,
		204,
		193,
		206,
		199,
		193,
		187,
		200,
		204,
		205,
		194,
		190,
		187,
		201,
		-1,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		229,
		-1,
		242,
		234,
		230,
		224,
		229,
		225,
		223,
		233,
		217,
		219,
		215,
		207,
		202,
		188,
		181,
		192,
		177,
		195,
		201,
		192,
		187,
		186,
		197,
		-1,
		296,
		282,
		253,
		-1,
		-1,
		242,
		-1,
		206,
		220,
		236,
		-1,
		264,
		243,
		261,
		239,
		235,
		226,
		224,
		225,
		195,
		200,
		202,
		190,
		193,
		182,
		185,
		177,
		199,
		196,
		180,
		182,
		191,
		-1,
		302,
		289,
		247,
		243,
		232,
		252,
		203,
		212,
		223,
		-1,
		-1,
		286,
		-1,
		237,
		242,
		240,
		238,
		214,
		189,
		196,
		214,
		187,
		182,
		187,
		176,
		176,
		171,
		190,
		176,
		174,
		189,
		205,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		218,
		205,
		199,
		-1,
		240,
		-1,
		264,
		252,
		239,
		221,
		261,
		-1,
		188,
		184,
		191,
		-1,
		207,
		-1,
		179,
		182,
		173,
		168,
		165,
		176,
		174,
		183,
		184,
		-1,
		252,
		237,
		230,
		220,
		234,
		205,
		-1,
		248,
		-1,
		-1,
		251,
		245,
		245,
		214,
		211,
		204,
		184,
		176,
		191,
		190,
		177,
		176,
		164,
		164,
		167,
		161,
		174,
		184,
		190,
		182,
		-1,
		-1,
		-1,
		257,
		209,
		217,
		193,
		214,
		-1,
		-1,
		312,
		268,
		254,
		-1,
		206,
		204,
		192,
		182,
		172,
		177,
		178,
		168,
		166,
		162,
		171,
		170,
		163,
		162,
		183,
		176,
		198,
		-1,
		-1,
		206,
		219,
		221,
		205,
		200,
		-1,
		-1,
		-1,
		258,
		259,
		225,
		204,
		193,
		-1,
		-1,
		176,
		169,
		163,
		166,
		154,
		174,
		181,
		169,
		156,
		171,
		181,
		189,
		188,
		-1,
		209,
		196,
		-1,
		-1,
		199,
		189,
		-1,
		-1,
		-1,
		-1,
		237,
		182,
		171,
		166,
		170,
		175,
		-1,
		149,
		160,
		153,
		172,
		179,
		171,
		156,
		150,
		161,
		176,
		193,
		-1,
		-1,
		213,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		194,
		188,
		159,
		152,
		156,
		-1,
		151,
		153,
		150,
		162,
		167,
		171,
		162,
		144,
		158,
		161,
		174,
		188,
		192,
		236,
		-1,
		166,
		-1,
		-1,
		-1,
		205,
		206,
		192,
		169,
		148,
		141,
		138,
		137,
		142,
		153,
		162,
		173,
		138,
		142,
		157,
		162,
		166,
		183,
		187,
		-1,
		-1,
		164,
		160,
		195,
		207,
		179,
		219,
		-1,
		-1,
		137,
		130,
		140,
		133,
		146,
		149,
		134,
		136,
		154,
		167,
		161,
		171,
		186,
		181,
		-1,
		-1,
		-1,
		162,
		-1,
		178,
		-1,
		-1,
		169,
		210,
		157,
		139,
		135,
		121,
		128,
		122,
		124,
		129,
		148,
		143,
		152,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		128,
		147,
		142,
		148,
		153,
		144,
		172,
		169,
		-1,
		118,
		151,
		119,
		133,
		129,
		136,
		141,
		147,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		155,
		144,
		133,
		139,
		-1,
		121,
		144,
		134,
		124,
		130,
		-1,
		-1,
		136,
		133,
		131,
		111,
		117,
		122,
		125,
		163,
		139,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		109,
		146,
		139,
		107,
		115,
		146,
		-1,
		111,
		103,
		131,
		116,
		124,
		-1,
		-1,
		109,
		100,
		105,
		114,
		115,
		146,
		145,
		158,
		161,
		166,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		102,
		122,
		101,
		104,
		128,
		142,
		-1,
		102,
		-1,
		-1,
		147,
		134,
		118,
		108,
		105,
		152,
		128,
		123,
		129,
		131,
		155,
		146,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		91,
		102,
		95,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		163,
		-1,
		145,
		-1,
		128,
		132,
		136,
		139,
		154,
		141,
		148,
		165,
		171,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		62,
		72,
		75,
		86,
		97,
		112,
		116,
		-1,
		86,
		122,
		132,
		-1,
		172,
		-1,
		-1,
		-1,
		142,
		149,
		141,
		157,
		153,
		153,
		149,
		153,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		58,
		63,
		116,
		61,
		61,
		82,
		91,
		112,
		82,
		79,
		116,
		121,
		136,
		141,
		165,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		160,
		170,
		153,
		155,
		159,
		173,
		185,
		193,
		183,
		181,
		175,
		207,
		-1,
		58,
		53,
		40,
		35,
		29,
		41,
		52,
		79,
		-1,
		-1,
		80,
		107,
		91,
		95,
		111,
		136,
		-1,
		172,
		-1,
		-1,
		186,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		167,
		178,
		200,
		189,
		190,
		180,
		190,
		203,
		42,
		35,
		23,
		25,
		0,
		60,
		48,
		-1,
		67,
		65,
		71,
		78,
		95,
		125,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		205,
		208,
		197,
		-1,
		187,
		160,
		165,
		190,
		197,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		51,
		61,
		50,
		35,
		6,
		15,
		53,
		52,
		64,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		-1,
		217,
		198,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		182,
		182,
		185,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		68,
		-1,
		84,
		66,
		80,
		95,
		103,
		-1,
		-1,
		-1,
		234,
		220,
		213,
		201,
		199,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		78,
		81,
		-1,
		-1,
		103,
		122,
		-1,
		225,
		214,
		199,
		191,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		175,
		200,
		189,
		197,
		192,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		85,
		86,
		91,
		-1,
		112,
		-1,
		227,
		-1,
		194,
		201,
		189,
		-1,
		-1,
		-1,
		213,
		176,
		197,
		207,
		212,
		210,
		201,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		142,
		119,
		234,
		225,
		208,
		188,
		180,
		200,
		-1,
		201,
		-1,
		176,
		177,
		204,
		206,
		223,
		217,
		201,
		216,
		206,
		197,
		206,
		148,
		-1,
		123,
		182,
		165,
		194,
		160,
		172,
		222,
		-1,
		198,
		180,
		-1,
		208,
		198,
		240,
		221,
		214,
		201,
		208,
		210,
		203,
		-1,
		-1,
		-1,
		138,
		137,
		136,
		147,
		155,
		153,
		171,
		-1,
		210,
		192,
		171,
		188,
		188,
		179,
		187,
		230,
		226,
		219,
		221,
		211,
		-1,
		142,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		164,
		186,
		181,
		173,
		185,
		189,
		175,
		181,
		183,
		191,
		189,
		186,
		198,
		194,
		214,
		210,
		242,
		-1,
		149,
		-1,
		168,
		-1,
		-1,
		182,
		168,
		180,
		191,
		181,
		181,
		186,
		179,
		201,
		217,
		201,
		199,
		204,
		209,
		-1,
		159,
		160,
		-1,
		201,
		193,
		179,
		-1,
		172,
		-1,
		227,
		188,
		-1,
		208,
		188,
		-1,
		210,
		206,
		-1,
		-1,
		171,
		217,
		-1,
		-1,
		-1,
		202,
		182,
		222,
		206,
		-1,
		199,
		199,
		-1,
		-1,
		-1,
		185,
		208,
		-1,
		195,
		198,
		-1,
		189,
		195,
		224,
		201,
		205,
		-1,
		-1,
		-1,
		212,
		196,
		201,
		210,
		215,
		203,
		220,
		206,
		208,
		215,
		204,
		225,
		-1,
		-1,
		-1,
		215,
		212,
		215,
		-1,
		-1,
		233,
		216,
		216,
		224,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		224,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		226,
		-1,
		-1,
		-1,
		225,
		232,
		240,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		254,
		247,
		-1,
		-1,
		-1,
		239,
		234,
		-1,
		-1,
		207,
		208,
		-1,
		-1,
		-1,
		267,
		251,
		-1,
		238,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		272,
		-1,
		273,
		248,
		255,
		-1,
		-1,
		-1,
		-1,
		285,
		277,
		286,
		-1,
		258,
		260,
		-1,
		308,
		-1,
		-1,
		300,
		291,
		-1,
		-1,
		263,
		270,
		292,
		295,
		291,
		-1,
		282
	],
	[
		-1,
		296,
		285,
		296,
		304,
		277,
		284,
		-1,
		305,
		307,
		273,
		267,
		306,
		277,
		283,
		294,
		-1,
		-1,
		-1,
		296,
		295,
		265,
		263,
		272,
		277,
		284,
		-1,
		286,
		-1,
		317,
		296,
		307,
		312,
		258,
		255,
		275,
		294,
		279,
		271,
		332,
		288,
		259,
		253,
		271,
		264,
		273,
		265,
		-1,
		259,
		249,
		271,
		253,
		264,
		256,
		-1,
		-1,
		253,
		254,
		260,
		249,
		255,
		251,
		-1,
		261,
		245,
		-1,
		-1,
		243,
		247,
		231,
		234,
		242,
		240,
		253,
		245,
		240,
		-1,
		-1,
		237,
		233,
		240,
		227,
		223,
		240,
		253,
		235,
		249,
		248,
		-1,
		232,
		250,
		259,
		234,
		232,
		216,
		214,
		232,
		234,
		240,
		240,
		-1,
		224,
		226,
		248,
		256,
		256,
		232,
		219,
		219,
		229,
		222,
		241,
		229,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		221,
		229,
		252,
		244,
		234,
		249,
		242,
		222,
		219,
		217,
		214,
		230,
		228,
		238,
		-1,
		-1,
		277,
		246,
		281,
		238,
		223,
		-1,
		217,
		228,
		234,
		238,
		232,
		225,
		239,
		235,
		-1,
		208,
		207,
		235,
		221,
		232,
		237,
		-1,
		-1,
		235,
		227,
		212,
		215,
		212,
		212,
		242,
		241,
		234,
		220,
		216,
		222,
		225,
		225,
		231,
		202,
		212,
		216,
		214,
		239,
		-1,
		-1,
		274,
		-1,
		-1,
		234,
		217,
		-1,
		200,
		207,
		207,
		224,
		214,
		235,
		250,
		244,
		236,
		230,
		218,
		220,
		217,
		230,
		218,
		199,
		224,
		228,
		209,
		230,
		225,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		193,
		196,
		202,
		226,
		236,
		-1,
		257,
		253,
		254,
		239,
		236,
		223,
		211,
		224,
		209,
		216,
		215,
		203,
		201,
		231,
		206,
		228,
		225,
		244,
		249,
		243,
		252,
		-1,
		242,
		238,
		234,
		241,
		190,
		-1,
		-1,
		230,
		-1,
		244,
		257,
		264,
		250,
		253,
		240,
		231,
		218,
		207,
		218,
		207,
		204,
		212,
		195,
		210,
		201,
		200,
		218,
		228,
		236,
		240,
		246,
		-1,
		292,
		-1,
		234,
		218,
		220,
		192,
		213,
		-1,
		250,
		245,
		265,
		266,
		257,
		-1,
		249,
		246,
		236,
		214,
		199,
		216,
		208,
		206,
		208,
		190,
		204,
		195,
		213,
		220,
		218,
		222,
		242,
		254,
		252,
		242,
		-1,
		224,
		229,
		188,
		196,
		215,
		288,
		263,
		-1,
		258,
		-1,
		250,
		264,
		-1,
		220,
		216,
		198,
		199,
		194,
		209,
		201,
		186,
		183,
		201,
		204,
		211,
		215,
		231,
		-1,
		-1,
		237,
		241,
		230,
		181,
		200,
		224,
		261,
		256,
		245,
		244,
		-1,
		235,
		234,
		231,
		219,
		206,
		191,
		192,
		200,
		212,
		191,
		185,
		182,
		202,
		228,
		206,
		217,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		207,
		178,
		202,
		244,
		274,
		267,
		255,
		220,
		220,
		214,
		-1,
		230,
		209,
		200,
		189,
		187,
		200,
		192,
		200,
		180,
		178,
		197,
		209,
		200,
		208,
		-1,
		-1,
		-1,
		237,
		226,
		227,
		176,
		199,
		233,
		253,
		239,
		244,
		219,
		212,
		206,
		243,
		226,
		207,
		196,
		188,
		177,
		188,
		196,
		194,
		176,
		185,
		191,
		215,
		196,
		202,
		-1,
		-1,
		244,
		234,
		218,
		220,
		217,
		190,
		197,
		229,
		244,
		241,
		-1,
		211,
		-1,
		200,
		208,
		201,
		196,
		193,
		180,
		179,
		193,
		193,
		183,
		178,
		185,
		220,
		220,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		237,
		235,
		210,
		187,
		171,
		207,
		-1,
		211,
		212,
		-1,
		205,
		199,
		205,
		203,
		199,
		184,
		188,
		190,
		193,
		181,
		187,
		188,
		170,
		194,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		196,
		189,
		-1,
		192,
		192,
		196,
		191,
		187,
		189,
		186,
		175,
		188,
		181,
		175,
		169,
		182,
		186,
		187,
		176,
		172,
		169,
		183,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		199,
		191,
		187,
		181,
		187,
		205,
		203,
		215,
		199,
		201,
		197,
		189,
		184,
		170,
		163,
		174,
		159,
		177,
		183,
		174,
		169,
		168,
		179,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		221,
		200,
		223,
		201,
		215,
		208,
		206,
		207,
		177,
		182,
		184,
		172,
		175,
		164,
		167,
		159,
		181,
		178,
		162,
		164,
		173,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		169,
		180,
		-1,
		-1,
		265,
		-1,
		199,
		216,
		222,
		220,
		196,
		171,
		178,
		196,
		169,
		164,
		169,
		158,
		158,
		153,
		172,
		158,
		156,
		171,
		187,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		243,
		233,
		217,
		202,
		235,
		-1,
		170,
		166,
		173,
		-1,
		189,
		-1,
		161,
		164,
		155,
		150,
		147,
		158,
		156,
		165,
		166,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		205,
		-1,
		-1,
		230,
		224,
		224,
		196,
		193,
		186,
		166,
		158,
		173,
		172,
		159,
		158,
		146,
		146,
		149,
		143,
		156,
		166,
		172,
		164,
		-1,
		-1,
		-1,
		214,
		166,
		174,
		150,
		171,
		-1,
		-1,
		292,
		247,
		233,
		-1,
		188,
		186,
		174,
		164,
		154,
		159,
		160,
		150,
		148,
		144,
		153,
		152,
		145,
		144,
		165,
		158,
		180,
		-1,
		-1,
		163,
		176,
		178,
		164,
		182,
		-1,
		-1,
		-1,
		239,
		241,
		207,
		186,
		175,
		-1,
		-1,
		158,
		151,
		145,
		148,
		136,
		156,
		163,
		151,
		138,
		153,
		163,
		171,
		170,
		-1,
		166,
		153,
		-1,
		-1,
		181,
		171,
		-1,
		-1,
		-1,
		-1,
		219,
		164,
		153,
		148,
		152,
		157,
		-1,
		131,
		142,
		135,
		154,
		161,
		153,
		138,
		132,
		143,
		158,
		175,
		-1,
		-1,
		195,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		176,
		170,
		141,
		134,
		138,
		-1,
		133,
		135,
		132,
		144,
		149,
		153,
		144,
		126,
		140,
		143,
		156,
		170,
		174,
		218,
		-1,
		148,
		-1,
		-1,
		-1,
		187,
		188,
		174,
		151,
		130,
		123,
		120,
		119,
		124,
		135,
		144,
		155,
		120,
		124,
		139,
		144,
		148,
		165,
		169,
		-1,
		-1,
		146,
		142,
		177,
		189,
		161,
		201,
		-1,
		-1,
		119,
		112,
		122,
		115,
		128,
		131,
		116,
		118,
		136,
		149,
		143,
		153,
		168,
		163,
		-1,
		-1,
		-1,
		144,
		-1,
		160,
		-1,
		-1,
		151,
		192,
		139,
		121,
		117,
		103,
		110,
		104,
		106,
		111,
		130,
		125,
		134,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		110,
		129,
		124,
		130,
		135,
		126,
		154,
		151,
		-1,
		100,
		133,
		101,
		115,
		111,
		118,
		123,
		129,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		112,
		101,
		90,
		96,
		-1,
		103,
		126,
		116,
		106,
		112,
		-1,
		-1,
		118,
		115,
		113,
		93,
		99,
		104,
		107,
		145,
		121,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		66,
		103,
		96,
		64,
		72,
		103,
		-1,
		93,
		85,
		113,
		98,
		106,
		-1,
		-1,
		91,
		82,
		87,
		96,
		97,
		128,
		127,
		140,
		143,
		148,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		59,
		79,
		58,
		61,
		85,
		99,
		-1,
		84,
		-1,
		-1,
		129,
		116,
		100,
		90,
		87,
		134,
		110,
		105,
		111,
		113,
		137,
		128,
		153,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		48,
		59,
		52,
		-1,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		145,
		-1,
		127,
		-1,
		110,
		114,
		118,
		121,
		136,
		123,
		130,
		147,
		153,
		142,
		152,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		74,
		29,
		32,
		43,
		54,
		69,
		73,
		-1,
		68,
		104,
		114,
		-1,
		154,
		-1,
		-1,
		-1,
		124,
		131,
		123,
		139,
		135,
		135,
		131,
		135,
		147,
		154,
		164,
		166,
		158,
		162,
		175,
		186,
		189,
		70,
		68,
		73,
		18,
		18,
		39,
		48,
		69,
		64,
		61,
		98,
		103,
		118,
		123,
		147,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		142,
		152,
		135,
		137,
		141,
		155,
		167,
		175,
		165,
		163,
		157,
		189,
		-1,
		70,
		69,
		58,
		55,
		31,
		22,
		9,
		36,
		-1,
		-1,
		62,
		89,
		73,
		77,
		93,
		118,
		-1,
		154,
		-1,
		-1,
		168,
		-1,
		-1,
		194,
		157,
		146,
		137,
		143,
		149,
		160,
		182,
		171,
		172,
		162,
		172,
		185,
		54,
		51,
		39,
		37,
		60,
		0,
		13,
		-1,
		44,
		47,
		53,
		60,
		77,
		107,
		-1,
		-1,
		170,
		161,
		-1,
		-1,
		187,
		190,
		179,
		-1,
		169,
		142,
		147,
		172,
		179,
		180,
		174,
		168,
		175,
		174,
		182,
		190,
		63,
		77,
		66,
		62,
		61,
		69,
		18,
		34,
		41,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		180,
		-1,
		-1,
		187,
		180,
		168,
		156,
		146,
		156,
		164,
		164,
		167,
		171,
		166,
		177,
		169,
		173,
		190,
		-1,
		97,
		-1,
		49,
		41,
		56,
		71,
		79,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		221,
		205,
		186,
		-1,
		156,
		169,
		200,
		168,
		173,
		168,
		172,
		183,
		172,
		175,
		189,
		184,
		-1,
		-1,
		54,
		57,
		-1,
		-1,
		79,
		98,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		193,
		189,
		-1,
		-1,
		157,
		182,
		171,
		179,
		174,
		176,
		182,
		185,
		174,
		178,
		190,
		-1,
		-1,
		61,
		62,
		67,
		-1,
		88,
		-1,
		203,
		-1,
		170,
		177,
		165,
		-1,
		-1,
		-1,
		195,
		158,
		179,
		189,
		194,
		192,
		183,
		180,
		187,
		185,
		181,
		192,
		-1,
		-1,
		-1,
		118,
		95,
		210,
		201,
		184,
		164,
		156,
		176,
		-1,
		183,
		-1,
		158,
		159,
		186,
		188,
		205,
		199,
		183,
		198,
		188,
		179,
		188,
		124,
		-1,
		99,
		158,
		141,
		170,
		136,
		148,
		204,
		-1,
		180,
		162,
		-1,
		190,
		180,
		222,
		203,
		196,
		183,
		190,
		192,
		185,
		-1,
		-1,
		-1,
		114,
		113,
		112,
		123,
		131,
		129,
		147,
		-1,
		192,
		174,
		153,
		170,
		170,
		161,
		169,
		212,
		208,
		201,
		203,
		193,
		-1,
		169,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		140,
		162,
		157,
		149,
		161,
		170,
		157,
		163,
		165,
		173,
		171,
		168,
		180,
		176,
		196,
		192,
		224,
		-1,
		176,
		-1,
		144,
		-1,
		-1,
		158,
		144,
		156,
		167,
		157,
		157,
		162,
		160,
		182,
		199,
		183,
		181,
		186,
		191,
		-1,
		186,
		187,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		203,
		164,
		-1,
		189,
		169,
		-1,
		192,
		188,
		-1,
		-1,
		198,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		198,
		182,
		-1,
		180,
		180,
		-1,
		-1,
		-1,
		212,
		202,
		-1,
		171,
		174,
		-1,
		165,
		171,
		200,
		182,
		186,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		186,
		191,
		179,
		196,
		182,
		184,
		196,
		185,
		206,
		-1,
		-1,
		-1,
		199,
		191,
		191,
		-1,
		-1,
		209,
		192,
		192,
		205,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		200,
		-1,
		-1,
		205,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		210,
		-1,
		-1,
		-1,
		201,
		208,
		216,
		-1,
		-1,
		-1,
		-1,
		229,
		230,
		256,
		231,
		-1,
		-1,
		-1,
		215,
		215,
		-1,
		-1,
		227,
		228,
		-1,
		-1,
		-1,
		243,
		227,
		-1,
		219,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		248,
		-1,
		254,
		229,
		236,
		-1,
		-1,
		-1,
		-1,
		261,
		253,
		267,
		-1,
		239,
		241,
		-1,
		289,
		-1,
		-1,
		276,
		267,
		-1,
		-1,
		244,
		251,
		273,
		276,
		306,
		-1,
		263
	],
	[
		-1,
		289,
		278,
		289,
		297,
		270,
		277,
		-1,
		296,
		300,
		266,
		260,
		299,
		268,
		274,
		285,
		-1,
		-1,
		-1,
		289,
		288,
		256,
		254,
		263,
		268,
		275,
		-1,
		274,
		-1,
		310,
		289,
		300,
		305,
		249,
		246,
		266,
		285,
		267,
		259,
		325,
		279,
		250,
		244,
		262,
		252,
		261,
		253,
		-1,
		250,
		240,
		262,
		241,
		252,
		244,
		-1,
		-1,
		244,
		245,
		251,
		237,
		243,
		239,
		-1,
		249,
		233,
		-1,
		-1,
		234,
		235,
		219,
		222,
		230,
		228,
		241,
		233,
		228,
		-1,
		-1,
		225,
		221,
		228,
		215,
		211,
		228,
		241,
		223,
		237,
		236,
		-1,
		227,
		245,
		254,
		222,
		220,
		204,
		202,
		220,
		222,
		228,
		228,
		-1,
		219,
		221,
		236,
		244,
		244,
		220,
		207,
		207,
		217,
		210,
		229,
		217,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		216,
		223,
		240,
		232,
		222,
		237,
		230,
		210,
		207,
		205,
		202,
		218,
		216,
		226,
		-1,
		-1,
		272,
		241,
		276,
		233,
		218,
		-1,
		212,
		216,
		222,
		226,
		220,
		213,
		227,
		223,
		-1,
		196,
		195,
		223,
		209,
		220,
		232,
		-1,
		-1,
		230,
		222,
		207,
		210,
		207,
		207,
		231,
		230,
		222,
		208,
		204,
		210,
		213,
		213,
		219,
		190,
		200,
		204,
		202,
		227,
		-1,
		-1,
		262,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		202,
		219,
		209,
		230,
		241,
		232,
		224,
		218,
		206,
		208,
		205,
		218,
		206,
		187,
		212,
		216,
		197,
		218,
		213,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		231,
		-1,
		252,
		241,
		242,
		227,
		224,
		211,
		199,
		212,
		197,
		204,
		203,
		191,
		189,
		219,
		194,
		216,
		213,
		232,
		237,
		231,
		240,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		239,
		252,
		259,
		238,
		241,
		228,
		219,
		206,
		195,
		206,
		195,
		192,
		200,
		183,
		198,
		189,
		188,
		206,
		216,
		224,
		228,
		234,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		240,
		260,
		261,
		252,
		-1,
		237,
		234,
		224,
		202,
		187,
		204,
		196,
		194,
		196,
		178,
		192,
		183,
		201,
		208,
		206,
		210,
		230,
		242,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		283,
		258,
		-1,
		253,
		-1,
		239,
		252,
		-1,
		208,
		204,
		186,
		187,
		182,
		197,
		189,
		174,
		171,
		189,
		192,
		199,
		203,
		219,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		251,
		240,
		239,
		-1,
		230,
		222,
		219,
		207,
		194,
		179,
		180,
		188,
		200,
		179,
		173,
		170,
		190,
		216,
		194,
		205,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		269,
		262,
		250,
		215,
		215,
		209,
		-1,
		218,
		197,
		188,
		177,
		175,
		188,
		180,
		188,
		168,
		166,
		185,
		197,
		188,
		196,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		171,
		194,
		228,
		248,
		234,
		239,
		214,
		207,
		201,
		231,
		214,
		195,
		184,
		176,
		165,
		176,
		184,
		182,
		164,
		173,
		179,
		203,
		184,
		190,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		185,
		192,
		224,
		239,
		236,
		-1,
		206,
		-1,
		195,
		203,
		189,
		184,
		181,
		168,
		167,
		181,
		181,
		171,
		166,
		173,
		208,
		208,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		232,
		230,
		205,
		182,
		166,
		202,
		-1,
		206,
		207,
		-1,
		200,
		194,
		200,
		191,
		187,
		172,
		176,
		178,
		181,
		169,
		175,
		176,
		158,
		182,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		228,
		207,
		200,
		220,
		161,
		213,
		-1,
		-1,
		191,
		184,
		-1,
		187,
		182,
		184,
		179,
		175,
		177,
		174,
		163,
		176,
		169,
		163,
		157,
		170,
		174,
		175,
		164,
		160,
		157,
		171,
		-1,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		181,
		-1,
		194,
		186,
		182,
		176,
		182,
		195,
		193,
		203,
		187,
		189,
		185,
		177,
		172,
		158,
		151,
		162,
		147,
		165,
		171,
		162,
		157,
		156,
		167,
		-1,
		248,
		234,
		205,
		-1,
		-1,
		194,
		-1,
		158,
		172,
		188,
		-1,
		216,
		195,
		218,
		196,
		205,
		196,
		194,
		195,
		165,
		170,
		172,
		160,
		163,
		152,
		155,
		147,
		169,
		166,
		150,
		152,
		161,
		-1,
		254,
		241,
		199,
		195,
		184,
		204,
		155,
		164,
		175,
		-1,
		-1,
		256,
		-1,
		194,
		211,
		210,
		208,
		184,
		159,
		166,
		184,
		157,
		152,
		157,
		146,
		146,
		141,
		160,
		146,
		144,
		159,
		175,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		170,
		157,
		151,
		-1,
		192,
		-1,
		234,
		222,
		209,
		191,
		230,
		-1,
		158,
		154,
		161,
		-1,
		177,
		-1,
		149,
		152,
		143,
		138,
		135,
		146,
		144,
		153,
		154,
		-1,
		204,
		189,
		182,
		172,
		186,
		157,
		-1,
		200,
		-1,
		-1,
		221,
		215,
		215,
		184,
		181,
		174,
		154,
		146,
		161,
		160,
		147,
		146,
		134,
		134,
		137,
		131,
		144,
		154,
		160,
		152,
		-1,
		-1,
		-1,
		209,
		161,
		169,
		145,
		166,
		-1,
		-1,
		282,
		238,
		224,
		-1,
		176,
		174,
		162,
		152,
		142,
		147,
		148,
		138,
		136,
		132,
		141,
		140,
		133,
		132,
		153,
		146,
		168,
		-1,
		-1,
		158,
		171,
		173,
		159,
		170,
		-1,
		-1,
		-1,
		228,
		229,
		195,
		174,
		163,
		-1,
		-1,
		146,
		139,
		133,
		136,
		124,
		144,
		151,
		139,
		126,
		141,
		151,
		159,
		158,
		-1,
		161,
		148,
		-1,
		-1,
		169,
		159,
		-1,
		-1,
		-1,
		-1,
		207,
		152,
		141,
		136,
		140,
		145,
		-1,
		119,
		130,
		123,
		142,
		149,
		141,
		126,
		120,
		131,
		146,
		163,
		-1,
		-1,
		183,
		-1,
		145,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		129,
		122,
		126,
		-1,
		121,
		123,
		120,
		132,
		137,
		141,
		132,
		114,
		128,
		131,
		144,
		158,
		162,
		206,
		-1,
		136,
		-1,
		-1,
		-1,
		175,
		176,
		162,
		139,
		118,
		111,
		108,
		107,
		112,
		123,
		132,
		143,
		108,
		112,
		127,
		132,
		136,
		153,
		157,
		-1,
		-1,
		134,
		130,
		165,
		177,
		149,
		189,
		-1,
		-1,
		107,
		100,
		110,
		103,
		116,
		119,
		104,
		106,
		124,
		137,
		131,
		141,
		156,
		151,
		-1,
		-1,
		-1,
		132,
		-1,
		148,
		-1,
		-1,
		139,
		180,
		127,
		109,
		105,
		91,
		98,
		92,
		94,
		99,
		118,
		113,
		122,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		114,
		-1,
		-1,
		-1,
		98,
		117,
		112,
		118,
		123,
		114,
		142,
		139,
		-1,
		88,
		121,
		89,
		103,
		99,
		106,
		111,
		117,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		107,
		96,
		85,
		91,
		-1,
		91,
		114,
		104,
		94,
		100,
		-1,
		-1,
		106,
		103,
		101,
		81,
		87,
		92,
		95,
		133,
		109,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		61,
		98,
		91,
		59,
		67,
		98,
		-1,
		81,
		73,
		101,
		86,
		94,
		-1,
		-1,
		79,
		70,
		75,
		84,
		85,
		116,
		115,
		128,
		131,
		136,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		54,
		74,
		53,
		56,
		80,
		94,
		-1,
		72,
		-1,
		-1,
		117,
		104,
		88,
		78,
		75,
		122,
		98,
		93,
		99,
		101,
		125,
		116,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		43,
		54,
		47,
		-1,
		-1,
		-1,
		-1,
		66,
		-1,
		-1,
		133,
		-1,
		115,
		-1,
		98,
		102,
		106,
		109,
		124,
		111,
		118,
		135,
		141,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		68,
		24,
		27,
		38,
		49,
		64,
		68,
		-1,
		56,
		92,
		102,
		-1,
		142,
		-1,
		-1,
		-1,
		112,
		119,
		111,
		127,
		123,
		123,
		119,
		123,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		64,
		55,
		68,
		13,
		13,
		34,
		43,
		64,
		52,
		49,
		86,
		91,
		106,
		111,
		135,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		130,
		140,
		123,
		125,
		129,
		143,
		155,
		163,
		153,
		151,
		145,
		177,
		-1,
		57,
		56,
		45,
		42,
		18,
		9,
		4,
		31,
		-1,
		-1,
		50,
		77,
		61,
		65,
		81,
		106,
		-1,
		142,
		-1,
		-1,
		156,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		137,
		148,
		170,
		159,
		160,
		150,
		160,
		173,
		41,
		38,
		26,
		24,
		47,
		12,
		0,
		-1,
		32,
		35,
		41,
		48,
		65,
		95,
		-1,
		-1,
		158,
		149,
		-1,
		-1,
		175,
		178,
		167,
		-1,
		157,
		130,
		135,
		160,
		167,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		50,
		64,
		53,
		49,
		48,
		56,
		5,
		22,
		29,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		181,
		168,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		152,
		152,
		155,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		84,
		-1,
		36,
		29,
		44,
		59,
		67,
		-1,
		-1,
		-1,
		198,
		184,
		177,
		165,
		163,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		42,
		45,
		-1,
		-1,
		67,
		86,
		-1,
		189,
		178,
		163,
		155,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		49,
		50,
		55,
		-1,
		76,
		-1,
		191,
		-1,
		158,
		165,
		153,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		182,
		180,
		171,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		106,
		83,
		198,
		189,
		172,
		152,
		144,
		164,
		-1,
		171,
		-1,
		146,
		147,
		174,
		176,
		193,
		187,
		171,
		186,
		176,
		167,
		176,
		112,
		-1,
		87,
		146,
		129,
		158,
		124,
		136,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		210,
		191,
		184,
		171,
		178,
		180,
		173,
		-1,
		-1,
		-1,
		102,
		101,
		100,
		111,
		119,
		117,
		135,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		200,
		196,
		189,
		191,
		181,
		-1,
		156,
		-1,
		-1,
		125,
		-1,
		-1,
		-1,
		128,
		150,
		145,
		137,
		149,
		158,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		180,
		212,
		-1,
		163,
		-1,
		132,
		-1,
		-1,
		146,
		132,
		144,
		155,
		145,
		145,
		150,
		148,
		170,
		187,
		171,
		169,
		174,
		179,
		-1,
		173,
		174,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		191,
		152,
		-1,
		177,
		157,
		-1,
		180,
		176,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		186,
		170,
		-1,
		168,
		168,
		-1,
		-1,
		-1,
		199,
		190,
		-1,
		159,
		162,
		-1,
		153,
		159,
		188,
		170,
		174,
		-1,
		-1,
		-1,
		215,
		196,
		190,
		174,
		179,
		167,
		184,
		170,
		172,
		184,
		173,
		194,
		-1,
		-1,
		-1,
		187,
		179,
		179,
		-1,
		-1,
		197,
		180,
		180,
		193,
		-1,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		188,
		-1,
		-1,
		193,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		198,
		-1,
		-1,
		-1,
		189,
		196,
		204,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		244,
		219,
		-1,
		-1,
		-1,
		203,
		203,
		-1,
		-1,
		214,
		215,
		-1,
		-1,
		-1,
		231,
		215,
		-1,
		207,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		236,
		-1,
		242,
		217,
		224,
		-1,
		-1,
		-1,
		-1,
		249,
		241,
		255,
		-1,
		227,
		229,
		-1,
		277,
		-1,
		-1,
		264,
		255,
		-1,
		-1,
		232,
		239,
		261,
		264,
		294,
		-1,
		251
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		289,
		278,
		289,
		297,
		270,
		277,
		-1,
		296,
		300,
		266,
		260,
		299,
		268,
		274,
		285,
		-1,
		-1,
		-1,
		289,
		288,
		256,
		254,
		263,
		268,
		275,
		-1,
		274,
		-1,
		310,
		289,
		300,
		305,
		249,
		246,
		266,
		285,
		267,
		259,
		325,
		279,
		250,
		244,
		262,
		252,
		261,
		253,
		-1,
		250,
		240,
		262,
		241,
		252,
		244,
		-1,
		-1,
		244,
		245,
		251,
		237,
		243,
		239,
		-1,
		249,
		233,
		-1,
		-1,
		234,
		235,
		219,
		222,
		230,
		228,
		241,
		233,
		228,
		-1,
		-1,
		225,
		221,
		228,
		215,
		211,
		228,
		241,
		223,
		237,
		236,
		-1,
		231,
		249,
		254,
		222,
		220,
		204,
		202,
		220,
		222,
		228,
		228,
		-1,
		240,
		241,
		236,
		244,
		244,
		220,
		207,
		207,
		217,
		210,
		229,
		217,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		239,
		223,
		240,
		232,
		222,
		237,
		230,
		210,
		207,
		205,
		202,
		218,
		216,
		226,
		-1,
		-1,
		295,
		264,
		299,
		256,
		241,
		-1,
		235,
		216,
		222,
		226,
		220,
		213,
		227,
		223,
		-1,
		196,
		195,
		223,
		209,
		220,
		255,
		-1,
		-1,
		253,
		245,
		230,
		233,
		230,
		230,
		231,
		230,
		222,
		208,
		204,
		210,
		213,
		213,
		219,
		190,
		200,
		204,
		202,
		227,
		-1,
		-1,
		262,
		-1,
		-1,
		252,
		235,
		-1,
		218,
		225,
		225,
		242,
		232,
		253,
		241,
		232,
		224,
		218,
		206,
		208,
		205,
		218,
		206,
		187,
		212,
		216,
		197,
		218,
		213,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		211,
		214,
		220,
		244,
		254,
		-1,
		253,
		241,
		242,
		227,
		224,
		211,
		199,
		212,
		197,
		204,
		203,
		191,
		189,
		219,
		194,
		216,
		213,
		232,
		237,
		231,
		240,
		-1,
		260,
		256,
		252,
		259,
		208,
		-1,
		-1,
		248,
		-1,
		262,
		275,
		265,
		238,
		241,
		228,
		219,
		206,
		195,
		206,
		195,
		192,
		200,
		183,
		198,
		189,
		188,
		206,
		216,
		224,
		228,
		234,
		-1,
		310,
		-1,
		252,
		236,
		238,
		210,
		231,
		-1,
		268,
		263,
		282,
		267,
		265,
		-1,
		237,
		234,
		224,
		202,
		187,
		204,
		196,
		194,
		196,
		178,
		192,
		183,
		201,
		208,
		206,
		210,
		230,
		242,
		270,
		260,
		-1,
		242,
		247,
		206,
		214,
		233,
		306,
		271,
		-1,
		266,
		-1,
		239,
		252,
		-1,
		208,
		204,
		186,
		187,
		182,
		197,
		189,
		174,
		171,
		189,
		192,
		199,
		203,
		219,
		-1,
		-1,
		255,
		259,
		248,
		199,
		218,
		242,
		279,
		264,
		253,
		252,
		-1,
		243,
		222,
		219,
		207,
		194,
		179,
		180,
		188,
		200,
		179,
		173,
		170,
		190,
		216,
		194,
		205,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		225,
		196,
		220,
		262,
		282,
		275,
		263,
		228,
		228,
		222,
		-1,
		218,
		197,
		188,
		177,
		175,
		188,
		180,
		188,
		168,
		166,
		185,
		197,
		188,
		196,
		-1,
		-1,
		-1,
		255,
		244,
		245,
		191,
		214,
		251,
		261,
		247,
		252,
		227,
		220,
		214,
		231,
		214,
		195,
		184,
		176,
		165,
		176,
		184,
		182,
		164,
		173,
		179,
		203,
		184,
		190,
		-1,
		-1,
		262,
		252,
		236,
		238,
		235,
		205,
		212,
		244,
		252,
		256,
		-1,
		219,
		-1,
		208,
		204,
		189,
		184,
		181,
		168,
		167,
		181,
		181,
		171,
		166,
		173,
		208,
		208,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		255,
		250,
		225,
		202,
		186,
		222,
		-1,
		226,
		227,
		-1,
		213,
		207,
		204,
		191,
		187,
		172,
		176,
		178,
		181,
		169,
		175,
		176,
		158,
		182,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		248,
		227,
		220,
		240,
		181,
		233,
		-1,
		-1,
		211,
		204,
		-1,
		200,
		182,
		184,
		179,
		175,
		177,
		174,
		163,
		176,
		169,
		163,
		157,
		170,
		174,
		175,
		164,
		160,
		157,
		171,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		201,
		-1,
		218,
		210,
		202,
		196,
		199,
		195,
		193,
		203,
		187,
		189,
		185,
		177,
		172,
		158,
		151,
		162,
		147,
		165,
		171,
		162,
		157,
		156,
		167,
		-1,
		268,
		254,
		225,
		-1,
		-1,
		214,
		-1,
		178,
		196,
		212,
		-1,
		236,
		215,
		231,
		209,
		205,
		196,
		194,
		195,
		165,
		170,
		172,
		160,
		163,
		152,
		155,
		147,
		169,
		166,
		150,
		152,
		161,
		-1,
		274,
		261,
		219,
		215,
		204,
		224,
		175,
		184,
		199,
		-1,
		-1,
		252,
		-1,
		206,
		208,
		210,
		208,
		184,
		159,
		166,
		184,
		157,
		152,
		157,
		146,
		146,
		141,
		160,
		146,
		144,
		159,
		175,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		190,
		177,
		171,
		-1,
		216,
		-1,
		230,
		218,
		205,
		187,
		227,
		-1,
		158,
		154,
		161,
		-1,
		177,
		-1,
		149,
		152,
		143,
		138,
		135,
		146,
		144,
		153,
		154,
		-1,
		224,
		209,
		202,
		192,
		206,
		174,
		-1,
		208,
		-1,
		-1,
		217,
		211,
		211,
		180,
		177,
		174,
		154,
		146,
		161,
		160,
		147,
		146,
		134,
		134,
		137,
		131,
		144,
		154,
		160,
		152,
		-1,
		-1,
		-1,
		229,
		185,
		193,
		169,
		174,
		-1,
		-1,
		278,
		234,
		220,
		-1,
		172,
		174,
		162,
		152,
		142,
		147,
		148,
		138,
		136,
		132,
		141,
		140,
		133,
		132,
		153,
		146,
		168,
		-1,
		-1,
		182,
		195,
		184,
		152,
		147,
		-1,
		-1,
		-1,
		224,
		210,
		195,
		170,
		163,
		-1,
		-1,
		146,
		139,
		133,
		136,
		124,
		144,
		151,
		139,
		126,
		141,
		151,
		159,
		158,
		-1,
		185,
		172,
		-1,
		-1,
		146,
		136,
		-1,
		-1,
		-1,
		-1,
		188,
		152,
		141,
		136,
		140,
		145,
		-1,
		119,
		130,
		123,
		142,
		149,
		141,
		126,
		120,
		131,
		146,
		163,
		-1,
		-1,
		160,
		-1,
		122,
		-1,
		-1,
		-1,
		-1,
		160,
		158,
		129,
		122,
		126,
		-1,
		121,
		123,
		120,
		132,
		137,
		141,
		132,
		114,
		128,
		131,
		144,
		158,
		162,
		183,
		-1,
		113,
		-1,
		-1,
		-1,
		152,
		153,
		162,
		139,
		118,
		111,
		108,
		107,
		112,
		123,
		132,
		143,
		108,
		112,
		127,
		132,
		136,
		153,
		157,
		-1,
		-1,
		111,
		107,
		142,
		154,
		126,
		189,
		-1,
		-1,
		107,
		100,
		110,
		103,
		116,
		119,
		104,
		106,
		124,
		137,
		131,
		141,
		156,
		151,
		-1,
		-1,
		-1,
		109,
		-1,
		125,
		-1,
		-1,
		116,
		180,
		127,
		109,
		105,
		91,
		98,
		92,
		94,
		99,
		118,
		113,
		122,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		138,
		-1,
		-1,
		-1,
		75,
		94,
		89,
		95,
		100,
		91,
		142,
		139,
		-1,
		88,
		121,
		89,
		103,
		99,
		106,
		111,
		117,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		131,
		120,
		109,
		115,
		-1,
		68,
		91,
		81,
		71,
		77,
		-1,
		-1,
		106,
		103,
		101,
		81,
		87,
		92,
		95,
		133,
		109,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		85,
		122,
		115,
		83,
		91,
		122,
		-1,
		58,
		50,
		78,
		63,
		71,
		-1,
		-1,
		79,
		70,
		75,
		84,
		85,
		116,
		115,
		128,
		131,
		136,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		78,
		98,
		77,
		80,
		104,
		118,
		-1,
		49,
		-1,
		-1,
		94,
		84,
		88,
		78,
		75,
		122,
		98,
		93,
		99,
		101,
		125,
		116,
		141,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		67,
		78,
		71,
		-1,
		-1,
		-1,
		-1,
		43,
		-1,
		-1,
		110,
		-1,
		115,
		-1,
		98,
		102,
		106,
		109,
		124,
		111,
		118,
		135,
		141,
		130,
		140,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		92,
		48,
		51,
		62,
		73,
		88,
		92,
		-1,
		33,
		69,
		73,
		-1,
		116,
		-1,
		-1,
		-1,
		112,
		119,
		111,
		127,
		123,
		123,
		119,
		123,
		135,
		142,
		152,
		154,
		146,
		150,
		163,
		174,
		177,
		88,
		79,
		92,
		37,
		37,
		58,
		67,
		88,
		23,
		26,
		63,
		62,
		77,
		82,
		106,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		130,
		140,
		123,
		125,
		129,
		143,
		155,
		163,
		153,
		151,
		145,
		177,
		-1,
		81,
		80,
		69,
		66,
		42,
		33,
		28,
		55,
		-1,
		-1,
		21,
		54,
		32,
		36,
		52,
		77,
		-1,
		113,
		-1,
		-1,
		156,
		-1,
		-1,
		182,
		145,
		134,
		125,
		131,
		137,
		148,
		170,
		159,
		160,
		150,
		160,
		173,
		65,
		62,
		50,
		48,
		71,
		36,
		24,
		-1,
		0,
		12,
		12,
		19,
		36,
		66,
		-1,
		-1,
		129,
		120,
		-1,
		-1,
		175,
		178,
		167,
		-1,
		157,
		130,
		135,
		160,
		167,
		168,
		162,
		156,
		163,
		162,
		170,
		178,
		74,
		88,
		77,
		73,
		72,
		80,
		29,
		22,
		3,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		139,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		152,
		152,
		155,
		159,
		154,
		165,
		157,
		161,
		178,
		-1,
		108,
		-1,
		60,
		18,
		38,
		53,
		61,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		188,
		156,
		161,
		156,
		160,
		171,
		160,
		163,
		177,
		172,
		-1,
		-1,
		36,
		39,
		-1,
		-1,
		65,
		84,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		145,
		170,
		159,
		167,
		162,
		164,
		170,
		173,
		162,
		166,
		178,
		-1,
		-1,
		43,
		46,
		51,
		-1,
		74,
		-1,
		189,
		-1,
		141,
		157,
		151,
		-1,
		-1,
		-1,
		183,
		146,
		167,
		177,
		182,
		180,
		171,
		168,
		175,
		173,
		169,
		180,
		-1,
		-1,
		-1,
		104,
		81,
		196,
		187,
		170,
		150,
		142,
		162,
		-1,
		171,
		-1,
		146,
		147,
		174,
		176,
		193,
		187,
		171,
		186,
		176,
		167,
		176,
		110,
		-1,
		85,
		144,
		127,
		156,
		122,
		134,
		192,
		-1,
		168,
		150,
		-1,
		178,
		168,
		210,
		191,
		184,
		171,
		178,
		180,
		173,
		-1,
		-1,
		-1,
		100,
		99,
		98,
		109,
		117,
		115,
		133,
		-1,
		180,
		162,
		141,
		158,
		158,
		149,
		157,
		200,
		196,
		189,
		191,
		181,
		-1,
		180,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		126,
		148,
		143,
		135,
		147,
		156,
		145,
		151,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		180,
		212,
		-1,
		187,
		-1,
		130,
		-1,
		-1,
		144,
		130,
		142,
		153,
		143,
		143,
		148,
		146,
		168,
		187,
		171,
		169,
		174,
		179,
		-1,
		197,
		198,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		189,
		150,
		-1,
		175,
		155,
		-1,
		180,
		176,
		-1,
		-1,
		209,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		184,
		168,
		-1,
		166,
		166,
		-1,
		-1,
		-1,
		204,
		188,
		-1,
		157,
		160,
		-1,
		151,
		157,
		186,
		168,
		172,
		-1,
		-1,
		-1,
		213,
		194,
		188,
		172,
		177,
		165,
		182,
		168,
		170,
		182,
		171,
		192,
		-1,
		-1,
		-1,
		185,
		177,
		177,
		-1,
		-1,
		195,
		178,
		178,
		191,
		-1,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		186,
		-1,
		-1,
		191,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		196,
		-1,
		-1,
		-1,
		187,
		194,
		202,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		242,
		217,
		-1,
		-1,
		-1,
		201,
		201,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		229,
		213,
		-1,
		205,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		234,
		-1,
		240,
		215,
		222,
		-1,
		-1,
		-1,
		-1,
		247,
		239,
		253,
		-1,
		225,
		227,
		-1,
		275,
		-1,
		-1,
		262,
		253,
		-1,
		-1,
		230,
		237,
		259,
		262,
		292,
		-1,
		249
	],
	[
		-1,
		282,
		271,
		282,
		290,
		263,
		270,
		-1,
		289,
		293,
		259,
		253,
		292,
		261,
		267,
		278,
		-1,
		-1,
		-1,
		282,
		281,
		249,
		247,
		256,
		261,
		268,
		-1,
		267,
		-1,
		303,
		282,
		293,
		298,
		242,
		239,
		259,
		278,
		260,
		252,
		318,
		272,
		243,
		237,
		255,
		245,
		254,
		246,
		-1,
		243,
		233,
		255,
		234,
		245,
		237,
		-1,
		-1,
		237,
		238,
		244,
		230,
		236,
		232,
		-1,
		242,
		226,
		-1,
		-1,
		227,
		228,
		212,
		215,
		223,
		221,
		234,
		226,
		221,
		-1,
		-1,
		218,
		214,
		221,
		208,
		204,
		221,
		234,
		216,
		230,
		229,
		-1,
		224,
		242,
		247,
		215,
		213,
		197,
		195,
		213,
		215,
		221,
		221,
		-1,
		230,
		232,
		229,
		237,
		237,
		213,
		200,
		200,
		210,
		203,
		222,
		210,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		227,
		216,
		233,
		225,
		215,
		230,
		223,
		203,
		200,
		198,
		195,
		211,
		209,
		219,
		-1,
		-1,
		283,
		252,
		287,
		244,
		229,
		-1,
		223,
		209,
		215,
		219,
		213,
		206,
		220,
		216,
		-1,
		189,
		188,
		216,
		202,
		213,
		243,
		-1,
		-1,
		241,
		233,
		218,
		221,
		218,
		218,
		224,
		223,
		215,
		201,
		197,
		203,
		206,
		206,
		212,
		183,
		193,
		197,
		195,
		220,
		-1,
		-1,
		255,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		213,
		230,
		220,
		241,
		234,
		225,
		217,
		211,
		199,
		201,
		198,
		211,
		199,
		180,
		205,
		209,
		190,
		211,
		206,
		-1,
		254,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		242,
		-1,
		246,
		234,
		235,
		220,
		217,
		204,
		192,
		205,
		190,
		197,
		196,
		184,
		182,
		212,
		187,
		209,
		206,
		225,
		230,
		224,
		233,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		250,
		263,
		258,
		231,
		234,
		221,
		212,
		199,
		188,
		199,
		188,
		185,
		193,
		176,
		191,
		182,
		181,
		199,
		209,
		217,
		221,
		227,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		251,
		271,
		260,
		258,
		-1,
		230,
		227,
		217,
		195,
		180,
		197,
		189,
		187,
		189,
		171,
		185,
		176,
		194,
		201,
		199,
		203,
		223,
		235,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		294,
		264,
		-1,
		259,
		-1,
		232,
		245,
		-1,
		201,
		197,
		179,
		180,
		175,
		190,
		182,
		167,
		164,
		182,
		185,
		192,
		196,
		212,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		257,
		246,
		245,
		-1,
		236,
		215,
		212,
		200,
		187,
		172,
		173,
		181,
		193,
		172,
		166,
		163,
		183,
		209,
		187,
		198,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		275,
		268,
		256,
		221,
		221,
		215,
		-1,
		211,
		190,
		181,
		170,
		168,
		181,
		173,
		181,
		161,
		159,
		178,
		190,
		181,
		189,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		179,
		202,
		239,
		254,
		240,
		245,
		220,
		213,
		207,
		224,
		207,
		188,
		177,
		169,
		158,
		169,
		177,
		175,
		157,
		166,
		172,
		196,
		177,
		183,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		193,
		200,
		232,
		245,
		244,
		-1,
		212,
		-1,
		201,
		197,
		182,
		177,
		174,
		161,
		160,
		174,
		174,
		164,
		159,
		166,
		201,
		201,
		167,
		187,
		190,
		-1,
		-1,
		-1,
		243,
		238,
		213,
		190,
		174,
		210,
		-1,
		214,
		215,
		-1,
		206,
		200,
		197,
		184,
		180,
		165,
		169,
		171,
		174,
		162,
		168,
		169,
		151,
		175,
		-1,
		175,
		169,
		177,
		167,
		155,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		199,
		192,
		-1,
		193,
		175,
		177,
		172,
		168,
		170,
		167,
		156,
		169,
		162,
		156,
		150,
		163,
		167,
		168,
		157,
		153,
		150,
		164,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		207,
		199,
		190,
		184,
		190,
		188,
		186,
		196,
		180,
		182,
		178,
		170,
		165,
		151,
		144,
		155,
		140,
		158,
		164,
		155,
		150,
		149,
		160,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		185,
		201,
		-1,
		224,
		203,
		224,
		202,
		198,
		189,
		187,
		188,
		158,
		163,
		165,
		153,
		156,
		145,
		148,
		140,
		162,
		159,
		143,
		145,
		154,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		172,
		188,
		-1,
		-1,
		240,
		-1,
		194,
		196,
		203,
		201,
		177,
		152,
		159,
		177,
		150,
		145,
		150,
		139,
		139,
		134,
		153,
		139,
		137,
		152,
		168,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		205,
		-1,
		218,
		206,
		193,
		175,
		215,
		-1,
		151,
		147,
		154,
		-1,
		170,
		-1,
		142,
		145,
		136,
		131,
		128,
		139,
		137,
		146,
		147,
		-1,
		212,
		197,
		190,
		180,
		194,
		162,
		-1,
		196,
		-1,
		-1,
		205,
		199,
		199,
		168,
		165,
		167,
		147,
		139,
		154,
		153,
		140,
		139,
		127,
		127,
		130,
		124,
		137,
		147,
		153,
		145,
		-1,
		-1,
		-1,
		217,
		178,
		186,
		158,
		162,
		-1,
		-1,
		266,
		222,
		208,
		-1,
		160,
		167,
		155,
		145,
		135,
		140,
		141,
		131,
		129,
		125,
		134,
		133,
		126,
		125,
		146,
		139,
		161,
		-1,
		-1,
		175,
		184,
		172,
		140,
		135,
		-1,
		-1,
		-1,
		212,
		198,
		186,
		158,
		156,
		-1,
		-1,
		139,
		132,
		126,
		129,
		117,
		137,
		144,
		132,
		119,
		134,
		144,
		152,
		151,
		-1,
		178,
		165,
		-1,
		-1,
		134,
		124,
		-1,
		-1,
		-1,
		-1,
		176,
		145,
		134,
		129,
		133,
		138,
		-1,
		112,
		123,
		116,
		135,
		142,
		134,
		119,
		113,
		124,
		139,
		156,
		-1,
		-1,
		148,
		-1,
		110,
		-1,
		-1,
		-1,
		-1,
		148,
		151,
		122,
		115,
		119,
		-1,
		114,
		116,
		113,
		125,
		130,
		134,
		125,
		107,
		121,
		124,
		137,
		151,
		155,
		171,
		-1,
		101,
		-1,
		-1,
		-1,
		140,
		141,
		155,
		132,
		111,
		104,
		101,
		100,
		105,
		116,
		125,
		136,
		101,
		105,
		120,
		125,
		129,
		146,
		150,
		-1,
		-1,
		99,
		95,
		130,
		142,
		114,
		182,
		-1,
		-1,
		100,
		93,
		103,
		96,
		109,
		112,
		97,
		99,
		117,
		130,
		124,
		134,
		149,
		144,
		-1,
		-1,
		-1,
		97,
		-1,
		113,
		-1,
		-1,
		104,
		173,
		120,
		102,
		98,
		84,
		91,
		85,
		87,
		92,
		111,
		106,
		115,
		120,
		124,
		147,
		136,
		175,
		-1,
		-1,
		131,
		-1,
		-1,
		-1,
		63,
		82,
		77,
		83,
		88,
		79,
		135,
		132,
		-1,
		81,
		114,
		82,
		96,
		92,
		99,
		104,
		110,
		114,
		121,
		137,
		136,
		131,
		167,
		158,
		164,
		-1,
		-1,
		124,
		113,
		102,
		108,
		-1,
		56,
		79,
		69,
		59,
		65,
		-1,
		-1,
		99,
		96,
		94,
		74,
		80,
		85,
		88,
		126,
		102,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		78,
		115,
		108,
		76,
		84,
		115,
		-1,
		46,
		38,
		66,
		51,
		59,
		-1,
		-1,
		72,
		63,
		68,
		77,
		78,
		109,
		108,
		121,
		124,
		129,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		71,
		91,
		70,
		73,
		97,
		111,
		-1,
		37,
		-1,
		-1,
		82,
		72,
		80,
		71,
		68,
		115,
		91,
		86,
		92,
		94,
		118,
		109,
		134,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		60,
		71,
		64,
		-1,
		-1,
		-1,
		-1,
		31,
		-1,
		-1,
		98,
		-1,
		106,
		-1,
		91,
		95,
		99,
		102,
		117,
		104,
		111,
		128,
		134,
		123,
		133,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		85,
		41,
		44,
		55,
		66,
		81,
		85,
		-1,
		21,
		57,
		67,
		-1,
		107,
		-1,
		-1,
		-1,
		105,
		112,
		104,
		120,
		116,
		116,
		112,
		116,
		128,
		135,
		145,
		147,
		139,
		143,
		156,
		167,
		170,
		81,
		72,
		85,
		30,
		30,
		51,
		60,
		81,
		17,
		14,
		51,
		56,
		71,
		76,
		100,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		123,
		133,
		116,
		118,
		122,
		136,
		148,
		156,
		146,
		144,
		138,
		170,
		-1,
		74,
		73,
		62,
		59,
		35,
		26,
		21,
		48,
		-1,
		-1,
		15,
		42,
		26,
		30,
		46,
		71,
		-1,
		107,
		-1,
		-1,
		149,
		-1,
		-1,
		175,
		138,
		127,
		118,
		124,
		130,
		141,
		163,
		152,
		153,
		143,
		153,
		166,
		58,
		55,
		43,
		41,
		64,
		29,
		17,
		-1,
		12,
		0,
		6,
		13,
		30,
		60,
		-1,
		-1,
		123,
		114,
		-1,
		-1,
		168,
		171,
		160,
		-1,
		150,
		123,
		128,
		153,
		160,
		161,
		155,
		149,
		156,
		155,
		163,
		171,
		67,
		81,
		70,
		66,
		65,
		73,
		22,
		15,
		15,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		133,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		145,
		145,
		148,
		152,
		147,
		158,
		150,
		154,
		171,
		-1,
		101,
		-1,
		53,
		21,
		41,
		56,
		64,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		181,
		149,
		154,
		149,
		153,
		164,
		153,
		156,
		170,
		165,
		-1,
		-1,
		39,
		42,
		-1,
		-1,
		66,
		85,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		138,
		163,
		152,
		160,
		155,
		157,
		163,
		166,
		155,
		159,
		171,
		-1,
		-1,
		46,
		49,
		54,
		-1,
		75,
		-1,
		190,
		-1,
		135,
		151,
		152,
		-1,
		-1,
		-1,
		176,
		139,
		160,
		170,
		175,
		173,
		164,
		161,
		168,
		166,
		162,
		173,
		-1,
		-1,
		-1,
		105,
		82,
		197,
		188,
		171,
		151,
		143,
		163,
		-1,
		164,
		-1,
		139,
		140,
		167,
		169,
		186,
		180,
		164,
		179,
		169,
		160,
		169,
		111,
		-1,
		86,
		145,
		128,
		157,
		123,
		135,
		185,
		-1,
		161,
		143,
		-1,
		171,
		161,
		203,
		184,
		177,
		164,
		171,
		173,
		166,
		-1,
		-1,
		-1,
		101,
		100,
		99,
		110,
		118,
		116,
		134,
		-1,
		173,
		155,
		134,
		151,
		151,
		142,
		150,
		193,
		189,
		182,
		184,
		174,
		-1,
		173,
		-1,
		-1,
		124,
		-1,
		-1,
		-1,
		127,
		149,
		144,
		136,
		148,
		152,
		138,
		144,
		146,
		154,
		152,
		149,
		161,
		157,
		177,
		173,
		205,
		-1,
		180,
		-1,
		131,
		-1,
		-1,
		145,
		131,
		143,
		154,
		144,
		144,
		149,
		142,
		164,
		180,
		164,
		162,
		167,
		172,
		-1,
		190,
		191,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		190,
		151,
		-1,
		171,
		151,
		-1,
		173,
		169,
		-1,
		-1,
		202,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		185,
		169,
		-1,
		162,
		162,
		-1,
		-1,
		-1,
		205,
		189,
		-1,
		158,
		161,
		-1,
		152,
		158,
		187,
		164,
		168,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		173,
		178,
		166,
		183,
		169,
		171,
		178,
		167,
		188,
		-1,
		-1,
		-1,
		186,
		178,
		178,
		-1,
		-1,
		196,
		179,
		179,
		187,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		187,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		197,
		-1,
		-1,
		-1,
		188,
		195,
		203,
		-1,
		-1,
		-1,
		-1,
		218,
		219,
		243,
		218,
		-1,
		-1,
		-1,
		202,
		197,
		-1,
		-1,
		221,
		219,
		-1,
		-1,
		-1,
		230,
		214,
		-1,
		201,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		234,
		-1,
		-1,
		-1,
		235,
		-1,
		236,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		248,
		240,
		249,
		-1,
		221,
		223,
		-1,
		271,
		-1,
		-1,
		263,
		254,
		-1,
		-1,
		226,
		233,
		255,
		258,
		293,
		-1,
		245
	],
	[
		-1,
		292,
		281,
		292,
		300,
		273,
		280,
		-1,
		299,
		303,
		269,
		263,
		302,
		271,
		277,
		288,
		-1,
		-1,
		-1,
		292,
		291,
		259,
		257,
		266,
		271,
		278,
		-1,
		277,
		-1,
		313,
		292,
		303,
		308,
		252,
		249,
		269,
		288,
		270,
		262,
		328,
		282,
		253,
		247,
		265,
		255,
		264,
		256,
		-1,
		253,
		243,
		265,
		244,
		255,
		247,
		-1,
		-1,
		247,
		248,
		254,
		240,
		246,
		242,
		-1,
		252,
		236,
		-1,
		-1,
		237,
		238,
		222,
		225,
		233,
		231,
		244,
		236,
		231,
		-1,
		-1,
		228,
		224,
		231,
		218,
		214,
		231,
		244,
		226,
		240,
		239,
		-1,
		234,
		252,
		257,
		225,
		223,
		207,
		205,
		223,
		225,
		231,
		231,
		-1,
		240,
		242,
		239,
		247,
		247,
		223,
		210,
		210,
		220,
		213,
		232,
		220,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		237,
		226,
		243,
		235,
		225,
		240,
		233,
		213,
		210,
		208,
		205,
		221,
		219,
		229,
		-1,
		-1,
		293,
		262,
		297,
		254,
		239,
		-1,
		233,
		219,
		225,
		229,
		223,
		216,
		230,
		226,
		-1,
		199,
		198,
		226,
		212,
		223,
		253,
		-1,
		-1,
		251,
		243,
		228,
		231,
		228,
		228,
		234,
		233,
		225,
		211,
		207,
		213,
		216,
		216,
		222,
		193,
		203,
		207,
		205,
		230,
		-1,
		-1,
		265,
		-1,
		-1,
		250,
		233,
		-1,
		216,
		223,
		223,
		240,
		230,
		251,
		244,
		235,
		227,
		221,
		209,
		211,
		208,
		221,
		209,
		190,
		215,
		219,
		200,
		221,
		216,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		209,
		212,
		218,
		242,
		252,
		-1,
		256,
		244,
		245,
		230,
		227,
		214,
		202,
		215,
		200,
		207,
		206,
		194,
		192,
		222,
		197,
		219,
		216,
		235,
		240,
		234,
		243,
		-1,
		258,
		254,
		250,
		257,
		206,
		-1,
		-1,
		246,
		-1,
		260,
		273,
		268,
		241,
		244,
		231,
		222,
		209,
		198,
		209,
		198,
		195,
		203,
		186,
		201,
		192,
		191,
		209,
		219,
		227,
		231,
		237,
		-1,
		308,
		-1,
		250,
		234,
		236,
		208,
		229,
		-1,
		266,
		261,
		281,
		270,
		268,
		-1,
		240,
		237,
		227,
		205,
		190,
		207,
		199,
		197,
		199,
		181,
		195,
		186,
		204,
		211,
		209,
		213,
		233,
		245,
		268,
		258,
		-1,
		240,
		245,
		204,
		212,
		231,
		304,
		274,
		-1,
		269,
		-1,
		242,
		255,
		-1,
		211,
		207,
		189,
		190,
		185,
		200,
		192,
		177,
		174,
		192,
		195,
		202,
		206,
		222,
		-1,
		-1,
		253,
		257,
		246,
		197,
		216,
		240,
		277,
		267,
		256,
		255,
		-1,
		246,
		225,
		222,
		210,
		197,
		182,
		183,
		191,
		203,
		182,
		176,
		173,
		193,
		219,
		197,
		208,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		223,
		194,
		218,
		260,
		285,
		278,
		266,
		231,
		231,
		225,
		-1,
		221,
		200,
		191,
		180,
		178,
		191,
		183,
		191,
		171,
		169,
		188,
		200,
		191,
		199,
		-1,
		-1,
		-1,
		253,
		242,
		243,
		189,
		212,
		249,
		264,
		250,
		255,
		230,
		223,
		217,
		234,
		217,
		198,
		187,
		179,
		168,
		179,
		187,
		185,
		167,
		176,
		182,
		206,
		187,
		193,
		-1,
		-1,
		260,
		250,
		234,
		236,
		233,
		203,
		210,
		242,
		255,
		254,
		-1,
		222,
		-1,
		211,
		207,
		192,
		187,
		184,
		171,
		170,
		184,
		184,
		174,
		169,
		176,
		211,
		211,
		177,
		197,
		200,
		-1,
		-1,
		-1,
		253,
		248,
		223,
		200,
		184,
		220,
		-1,
		224,
		225,
		-1,
		216,
		210,
		207,
		194,
		190,
		175,
		179,
		181,
		184,
		172,
		178,
		179,
		161,
		185,
		-1,
		185,
		179,
		187,
		177,
		165,
		-1,
		-1,
		-1,
		246,
		225,
		218,
		238,
		179,
		231,
		-1,
		-1,
		209,
		202,
		-1,
		203,
		185,
		187,
		182,
		178,
		180,
		177,
		166,
		179,
		172,
		166,
		160,
		173,
		177,
		178,
		167,
		163,
		160,
		174,
		-1,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		199,
		-1,
		217,
		209,
		200,
		194,
		200,
		198,
		196,
		206,
		190,
		192,
		188,
		180,
		175,
		161,
		154,
		165,
		150,
		168,
		174,
		165,
		160,
		159,
		170,
		-1,
		266,
		252,
		223,
		-1,
		-1,
		212,
		-1,
		176,
		195,
		211,
		-1,
		234,
		213,
		234,
		212,
		208,
		199,
		197,
		198,
		168,
		173,
		175,
		163,
		166,
		155,
		158,
		150,
		172,
		169,
		153,
		155,
		164,
		-1,
		272,
		259,
		217,
		213,
		202,
		222,
		173,
		182,
		198,
		-1,
		-1,
		250,
		-1,
		204,
		206,
		213,
		211,
		187,
		162,
		169,
		187,
		160,
		155,
		160,
		149,
		149,
		144,
		163,
		149,
		147,
		162,
		178,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		188,
		175,
		169,
		-1,
		215,
		-1,
		228,
		216,
		203,
		185,
		225,
		-1,
		161,
		157,
		164,
		-1,
		180,
		-1,
		152,
		155,
		146,
		141,
		138,
		149,
		147,
		156,
		157,
		-1,
		222,
		207,
		200,
		190,
		204,
		172,
		-1,
		206,
		-1,
		-1,
		215,
		209,
		209,
		178,
		175,
		177,
		157,
		149,
		164,
		163,
		150,
		149,
		137,
		137,
		140,
		134,
		147,
		157,
		163,
		155,
		-1,
		-1,
		-1,
		227,
		188,
		196,
		168,
		172,
		-1,
		-1,
		276,
		232,
		218,
		-1,
		170,
		177,
		165,
		155,
		145,
		150,
		151,
		141,
		139,
		135,
		144,
		143,
		136,
		135,
		156,
		149,
		171,
		-1,
		-1,
		185,
		194,
		182,
		150,
		145,
		-1,
		-1,
		-1,
		222,
		208,
		196,
		168,
		166,
		-1,
		-1,
		149,
		142,
		136,
		139,
		127,
		147,
		154,
		142,
		129,
		144,
		154,
		162,
		161,
		-1,
		188,
		175,
		-1,
		-1,
		144,
		134,
		-1,
		-1,
		-1,
		-1,
		186,
		155,
		144,
		139,
		143,
		148,
		-1,
		122,
		133,
		126,
		145,
		152,
		144,
		129,
		123,
		134,
		149,
		166,
		-1,
		-1,
		158,
		-1,
		120,
		-1,
		-1,
		-1,
		-1,
		158,
		161,
		132,
		125,
		129,
		-1,
		124,
		126,
		123,
		135,
		140,
		144,
		135,
		117,
		131,
		134,
		147,
		161,
		165,
		181,
		-1,
		111,
		-1,
		-1,
		-1,
		150,
		151,
		165,
		142,
		121,
		114,
		111,
		110,
		115,
		126,
		135,
		146,
		111,
		115,
		130,
		135,
		139,
		156,
		160,
		-1,
		-1,
		109,
		105,
		140,
		152,
		124,
		192,
		-1,
		-1,
		110,
		103,
		113,
		106,
		119,
		122,
		107,
		109,
		127,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		107,
		-1,
		123,
		-1,
		-1,
		114,
		183,
		130,
		112,
		108,
		94,
		101,
		95,
		97,
		102,
		121,
		116,
		125,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		73,
		92,
		87,
		93,
		98,
		89,
		145,
		142,
		-1,
		91,
		124,
		92,
		106,
		102,
		109,
		114,
		120,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		134,
		123,
		112,
		118,
		-1,
		66,
		89,
		79,
		69,
		75,
		-1,
		-1,
		109,
		106,
		104,
		84,
		90,
		95,
		98,
		136,
		112,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		88,
		125,
		118,
		86,
		94,
		125,
		-1,
		56,
		48,
		76,
		61,
		69,
		-1,
		-1,
		82,
		73,
		78,
		87,
		88,
		119,
		118,
		131,
		134,
		139,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		81,
		101,
		80,
		83,
		107,
		121,
		-1,
		47,
		-1,
		-1,
		92,
		82,
		90,
		81,
		78,
		125,
		101,
		96,
		102,
		104,
		128,
		119,
		144,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		70,
		81,
		74,
		-1,
		-1,
		-1,
		-1,
		41,
		-1,
		-1,
		108,
		-1,
		116,
		-1,
		101,
		105,
		109,
		112,
		127,
		114,
		121,
		138,
		144,
		133,
		143,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		95,
		51,
		54,
		65,
		76,
		91,
		95,
		-1,
		31,
		64,
		65,
		-1,
		108,
		-1,
		-1,
		-1,
		115,
		122,
		114,
		130,
		126,
		126,
		122,
		126,
		138,
		145,
		155,
		157,
		149,
		153,
		166,
		177,
		180,
		91,
		82,
		95,
		40,
		40,
		61,
		70,
		91,
		15,
		24,
		58,
		54,
		69,
		74,
		98,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		133,
		143,
		126,
		128,
		132,
		146,
		158,
		166,
		156,
		154,
		148,
		180,
		-1,
		84,
		83,
		72,
		69,
		45,
		36,
		31,
		58,
		-1,
		-1,
		13,
		49,
		24,
		28,
		44,
		69,
		-1,
		105,
		-1,
		-1,
		159,
		-1,
		-1,
		185,
		148,
		137,
		128,
		134,
		140,
		151,
		173,
		162,
		163,
		153,
		163,
		176,
		68,
		65,
		53,
		51,
		74,
		39,
		27,
		-1,
		16,
		10,
		0,
		11,
		28,
		58,
		-1,
		-1,
		121,
		112,
		-1,
		-1,
		178,
		181,
		170,
		-1,
		160,
		133,
		138,
		163,
		170,
		171,
		165,
		159,
		166,
		165,
		173,
		181,
		77,
		91,
		80,
		76,
		75,
		83,
		32,
		25,
		19,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		156,
		131,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		155,
		155,
		158,
		162,
		157,
		168,
		160,
		164,
		181,
		-1,
		111,
		-1,
		63,
		31,
		51,
		66,
		74,
		-1,
		-1,
		-1,
		173,
		159,
		152,
		140,
		138,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		191,
		159,
		164,
		159,
		163,
		174,
		163,
		166,
		180,
		175,
		-1,
		-1,
		49,
		52,
		-1,
		-1,
		76,
		95,
		-1,
		164,
		153,
		138,
		130,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		148,
		173,
		162,
		170,
		165,
		167,
		173,
		176,
		165,
		169,
		181,
		-1,
		-1,
		56,
		59,
		64,
		-1,
		85,
		-1,
		188,
		-1,
		133,
		149,
		151,
		-1,
		-1,
		-1,
		186,
		149,
		170,
		180,
		185,
		183,
		174,
		171,
		178,
		176,
		172,
		183,
		-1,
		-1,
		-1,
		115,
		92,
		195,
		186,
		169,
		149,
		141,
		166,
		-1,
		174,
		-1,
		149,
		150,
		177,
		179,
		196,
		190,
		174,
		189,
		179,
		170,
		179,
		121,
		-1,
		96,
		155,
		138,
		155,
		133,
		145,
		195,
		-1,
		171,
		153,
		-1,
		181,
		171,
		213,
		194,
		187,
		174,
		181,
		183,
		176,
		-1,
		-1,
		-1,
		111,
		110,
		109,
		120,
		128,
		126,
		144,
		-1,
		183,
		165,
		144,
		161,
		161,
		152,
		160,
		203,
		199,
		192,
		194,
		184,
		-1,
		183,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		137,
		159,
		154,
		146,
		158,
		162,
		148,
		154,
		156,
		164,
		162,
		159,
		171,
		167,
		187,
		183,
		215,
		-1,
		190,
		-1,
		141,
		-1,
		-1,
		155,
		141,
		153,
		164,
		154,
		154,
		159,
		152,
		174,
		190,
		174,
		172,
		177,
		182,
		-1,
		200,
		201,
		-1,
		174,
		166,
		152,
		-1,
		145,
		-1,
		200,
		161,
		-1,
		181,
		161,
		-1,
		183,
		179,
		-1,
		-1,
		212,
		190,
		-1,
		-1,
		-1,
		175,
		155,
		195,
		179,
		-1,
		172,
		172,
		-1,
		-1,
		-1,
		215,
		199,
		-1,
		168,
		171,
		-1,
		162,
		168,
		197,
		174,
		178,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		183,
		188,
		176,
		193,
		179,
		181,
		188,
		177,
		198,
		-1,
		-1,
		-1,
		196,
		188,
		188,
		-1,
		-1,
		206,
		189,
		189,
		197,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		197,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		207,
		-1,
		-1,
		-1,
		198,
		205,
		213,
		-1,
		-1,
		-1,
		-1,
		228,
		229,
		253,
		228,
		-1,
		-1,
		-1,
		212,
		207,
		-1,
		-1,
		231,
		229,
		-1,
		-1,
		-1,
		240,
		224,
		-1,
		211,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		245,
		-1,
		246,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		258,
		250,
		259,
		-1,
		231,
		233,
		-1,
		281,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		236,
		243,
		265,
		268,
		303,
		-1,
		255
	],
	[
		-1,
		299,
		288,
		299,
		307,
		280,
		287,
		-1,
		306,
		310,
		276,
		270,
		309,
		278,
		284,
		295,
		-1,
		-1,
		-1,
		299,
		298,
		266,
		264,
		273,
		278,
		285,
		-1,
		284,
		-1,
		320,
		299,
		310,
		315,
		259,
		256,
		276,
		295,
		277,
		269,
		335,
		289,
		260,
		254,
		272,
		262,
		271,
		263,
		-1,
		260,
		250,
		272,
		251,
		262,
		254,
		-1,
		-1,
		254,
		255,
		261,
		247,
		253,
		249,
		-1,
		259,
		243,
		-1,
		-1,
		244,
		245,
		229,
		232,
		240,
		238,
		251,
		243,
		238,
		-1,
		-1,
		235,
		231,
		238,
		225,
		221,
		238,
		251,
		233,
		247,
		246,
		-1,
		241,
		259,
		264,
		232,
		230,
		214,
		212,
		230,
		232,
		238,
		238,
		-1,
		247,
		249,
		246,
		254,
		254,
		230,
		217,
		217,
		227,
		220,
		239,
		227,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		244,
		233,
		250,
		242,
		232,
		247,
		240,
		220,
		217,
		215,
		212,
		228,
		226,
		236,
		-1,
		-1,
		300,
		269,
		304,
		261,
		246,
		-1,
		240,
		226,
		232,
		236,
		230,
		223,
		237,
		233,
		-1,
		206,
		205,
		233,
		219,
		230,
		260,
		-1,
		-1,
		258,
		250,
		235,
		238,
		235,
		235,
		241,
		240,
		232,
		218,
		214,
		220,
		223,
		223,
		229,
		200,
		210,
		214,
		212,
		237,
		-1,
		-1,
		272,
		-1,
		-1,
		257,
		240,
		-1,
		223,
		230,
		230,
		247,
		237,
		258,
		251,
		242,
		234,
		228,
		216,
		218,
		215,
		228,
		216,
		197,
		222,
		226,
		207,
		228,
		223,
		-1,
		271,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		216,
		219,
		225,
		249,
		259,
		-1,
		263,
		251,
		252,
		237,
		234,
		221,
		209,
		222,
		207,
		214,
		213,
		201,
		199,
		229,
		204,
		226,
		223,
		242,
		247,
		241,
		250,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		253,
		-1,
		267,
		280,
		275,
		248,
		251,
		238,
		229,
		216,
		205,
		216,
		205,
		202,
		210,
		193,
		208,
		199,
		198,
		216,
		226,
		234,
		238,
		244,
		-1,
		315,
		-1,
		257,
		241,
		243,
		215,
		236,
		-1,
		273,
		268,
		288,
		277,
		275,
		-1,
		247,
		244,
		234,
		212,
		197,
		214,
		206,
		204,
		206,
		188,
		202,
		193,
		211,
		218,
		216,
		220,
		240,
		252,
		275,
		265,
		-1,
		247,
		252,
		211,
		219,
		238,
		311,
		281,
		-1,
		276,
		-1,
		249,
		262,
		-1,
		218,
		214,
		196,
		197,
		192,
		207,
		199,
		184,
		181,
		199,
		202,
		209,
		213,
		229,
		-1,
		-1,
		260,
		264,
		253,
		204,
		223,
		247,
		284,
		274,
		263,
		262,
		-1,
		253,
		232,
		229,
		217,
		204,
		189,
		190,
		198,
		210,
		189,
		183,
		180,
		200,
		226,
		204,
		215,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		230,
		201,
		225,
		267,
		292,
		285,
		273,
		238,
		238,
		232,
		-1,
		228,
		207,
		198,
		187,
		185,
		198,
		190,
		198,
		178,
		176,
		195,
		207,
		198,
		206,
		-1,
		-1,
		-1,
		260,
		249,
		250,
		196,
		219,
		256,
		271,
		257,
		262,
		237,
		230,
		224,
		241,
		224,
		205,
		194,
		186,
		175,
		186,
		194,
		192,
		174,
		183,
		189,
		213,
		194,
		200,
		-1,
		-1,
		267,
		257,
		241,
		243,
		240,
		210,
		217,
		249,
		262,
		261,
		-1,
		229,
		-1,
		218,
		214,
		199,
		194,
		191,
		178,
		177,
		191,
		191,
		181,
		176,
		183,
		218,
		218,
		184,
		204,
		207,
		-1,
		-1,
		-1,
		260,
		255,
		230,
		207,
		191,
		227,
		-1,
		231,
		232,
		-1,
		223,
		217,
		214,
		201,
		197,
		182,
		186,
		188,
		191,
		179,
		185,
		186,
		168,
		192,
		-1,
		192,
		186,
		194,
		184,
		172,
		-1,
		-1,
		-1,
		253,
		232,
		225,
		245,
		186,
		238,
		-1,
		-1,
		216,
		209,
		-1,
		210,
		192,
		194,
		189,
		185,
		187,
		184,
		173,
		186,
		179,
		173,
		167,
		180,
		184,
		185,
		174,
		170,
		167,
		181,
		-1,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		206,
		-1,
		224,
		216,
		207,
		201,
		207,
		205,
		203,
		213,
		197,
		199,
		195,
		187,
		182,
		168,
		161,
		172,
		157,
		175,
		181,
		172,
		167,
		166,
		177,
		-1,
		273,
		259,
		230,
		-1,
		-1,
		219,
		-1,
		183,
		202,
		218,
		-1,
		241,
		220,
		241,
		219,
		215,
		206,
		204,
		205,
		175,
		180,
		182,
		170,
		173,
		162,
		165,
		157,
		179,
		176,
		160,
		162,
		171,
		-1,
		279,
		266,
		224,
		220,
		209,
		229,
		180,
		189,
		205,
		-1,
		-1,
		257,
		-1,
		211,
		213,
		220,
		218,
		194,
		169,
		176,
		194,
		167,
		162,
		167,
		156,
		156,
		151,
		170,
		156,
		154,
		169,
		185,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		195,
		182,
		176,
		-1,
		222,
		-1,
		235,
		223,
		210,
		192,
		232,
		-1,
		168,
		164,
		171,
		-1,
		187,
		-1,
		159,
		162,
		153,
		148,
		145,
		156,
		154,
		163,
		164,
		-1,
		229,
		214,
		207,
		197,
		211,
		179,
		-1,
		213,
		-1,
		-1,
		222,
		216,
		216,
		185,
		182,
		184,
		164,
		156,
		171,
		170,
		157,
		156,
		144,
		144,
		147,
		141,
		154,
		164,
		170,
		162,
		-1,
		-1,
		-1,
		234,
		195,
		203,
		175,
		179,
		-1,
		-1,
		283,
		239,
		225,
		-1,
		177,
		184,
		172,
		162,
		152,
		157,
		158,
		148,
		146,
		142,
		151,
		150,
		143,
		142,
		163,
		156,
		178,
		-1,
		-1,
		192,
		201,
		189,
		157,
		152,
		-1,
		-1,
		-1,
		229,
		215,
		203,
		175,
		173,
		-1,
		-1,
		156,
		149,
		143,
		146,
		134,
		154,
		161,
		149,
		136,
		151,
		161,
		169,
		168,
		-1,
		195,
		182,
		-1,
		-1,
		151,
		141,
		-1,
		-1,
		-1,
		-1,
		193,
		162,
		151,
		146,
		150,
		155,
		-1,
		129,
		140,
		133,
		152,
		159,
		151,
		136,
		130,
		141,
		156,
		173,
		-1,
		-1,
		165,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		165,
		168,
		139,
		132,
		136,
		-1,
		131,
		133,
		130,
		142,
		147,
		151,
		142,
		124,
		138,
		141,
		154,
		168,
		172,
		188,
		-1,
		118,
		-1,
		-1,
		-1,
		157,
		158,
		172,
		149,
		128,
		121,
		118,
		117,
		122,
		133,
		142,
		153,
		118,
		122,
		137,
		142,
		146,
		163,
		167,
		-1,
		-1,
		116,
		112,
		147,
		159,
		131,
		199,
		-1,
		-1,
		117,
		110,
		120,
		113,
		126,
		129,
		114,
		116,
		134,
		147,
		141,
		151,
		166,
		161,
		-1,
		-1,
		-1,
		114,
		-1,
		130,
		-1,
		-1,
		121,
		190,
		137,
		119,
		115,
		101,
		108,
		102,
		104,
		109,
		128,
		123,
		132,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		80,
		99,
		94,
		100,
		105,
		96,
		152,
		149,
		-1,
		98,
		131,
		99,
		113,
		109,
		116,
		121,
		127,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		141,
		130,
		119,
		125,
		-1,
		73,
		96,
		86,
		76,
		82,
		-1,
		-1,
		116,
		113,
		111,
		91,
		97,
		102,
		105,
		143,
		119,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		95,
		132,
		125,
		93,
		101,
		132,
		-1,
		63,
		55,
		83,
		68,
		76,
		-1,
		-1,
		89,
		80,
		85,
		94,
		95,
		126,
		125,
		138,
		141,
		146,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		88,
		108,
		87,
		90,
		114,
		128,
		-1,
		54,
		-1,
		-1,
		99,
		89,
		97,
		88,
		85,
		132,
		108,
		103,
		109,
		111,
		135,
		126,
		151,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		77,
		88,
		81,
		-1,
		-1,
		-1,
		-1,
		48,
		-1,
		-1,
		107,
		-1,
		123,
		-1,
		108,
		112,
		116,
		119,
		134,
		121,
		128,
		145,
		151,
		140,
		150,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		102,
		58,
		61,
		72,
		83,
		98,
		102,
		-1,
		38,
		71,
		54,
		-1,
		97,
		-1,
		-1,
		-1,
		122,
		129,
		121,
		137,
		133,
		133,
		129,
		133,
		145,
		152,
		162,
		164,
		156,
		160,
		173,
		184,
		187,
		98,
		89,
		102,
		47,
		47,
		68,
		77,
		98,
		22,
		31,
		65,
		43,
		58,
		63,
		87,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		140,
		150,
		133,
		135,
		139,
		153,
		165,
		173,
		163,
		161,
		155,
		187,
		-1,
		91,
		90,
		79,
		76,
		52,
		43,
		38,
		65,
		-1,
		-1,
		20,
		56,
		13,
		17,
		33,
		58,
		-1,
		94,
		-1,
		-1,
		166,
		-1,
		-1,
		192,
		155,
		144,
		135,
		141,
		147,
		158,
		180,
		169,
		170,
		160,
		170,
		183,
		75,
		72,
		60,
		58,
		81,
		46,
		34,
		-1,
		23,
		17,
		13,
		0,
		17,
		47,
		-1,
		-1,
		110,
		101,
		-1,
		-1,
		185,
		188,
		177,
		-1,
		167,
		140,
		145,
		170,
		177,
		178,
		172,
		166,
		173,
		172,
		180,
		188,
		84,
		98,
		87,
		83,
		82,
		90,
		39,
		32,
		26,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		120,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		162,
		162,
		165,
		169,
		164,
		175,
		167,
		171,
		188,
		-1,
		118,
		-1,
		70,
		38,
		58,
		73,
		81,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		198,
		166,
		171,
		166,
		170,
		181,
		170,
		173,
		187,
		182,
		-1,
		-1,
		56,
		59,
		-1,
		-1,
		83,
		102,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		155,
		180,
		169,
		177,
		172,
		174,
		180,
		183,
		172,
		176,
		188,
		-1,
		-1,
		63,
		66,
		71,
		-1,
		92,
		-1,
		177,
		-1,
		122,
		138,
		140,
		-1,
		-1,
		-1,
		193,
		156,
		177,
		187,
		192,
		190,
		181,
		178,
		185,
		183,
		179,
		190,
		-1,
		-1,
		-1,
		122,
		99,
		184,
		175,
		158,
		138,
		130,
		155,
		-1,
		181,
		-1,
		156,
		157,
		184,
		186,
		203,
		197,
		181,
		196,
		186,
		177,
		186,
		128,
		-1,
		103,
		162,
		145,
		144,
		140,
		143,
		202,
		-1,
		178,
		160,
		-1,
		188,
		178,
		220,
		201,
		194,
		181,
		188,
		190,
		183,
		-1,
		-1,
		-1,
		118,
		117,
		116,
		127,
		135,
		133,
		144,
		-1,
		190,
		172,
		151,
		168,
		168,
		159,
		167,
		210,
		206,
		199,
		201,
		191,
		-1,
		190,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		144,
		166,
		157,
		145,
		159,
		166,
		155,
		161,
		163,
		171,
		169,
		166,
		178,
		174,
		194,
		190,
		222,
		-1,
		197,
		-1,
		148,
		-1,
		-1,
		162,
		148,
		160,
		168,
		157,
		155,
		158,
		156,
		178,
		197,
		181,
		179,
		184,
		189,
		-1,
		207,
		208,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		203,
		164,
		-1,
		185,
		165,
		-1,
		190,
		186,
		-1,
		-1,
		219,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		198,
		182,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		222,
		206,
		-1,
		175,
		178,
		-1,
		169,
		175,
		204,
		178,
		182,
		-1,
		-1,
		-1,
		231,
		212,
		206,
		190,
		195,
		183,
		200,
		186,
		188,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		203,
		195,
		195,
		-1,
		-1,
		213,
		196,
		196,
		201,
		-1,
		-1,
		-1,
		225,
		206,
		-1,
		-1,
		204,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		214,
		-1,
		-1,
		-1,
		205,
		212,
		220,
		-1,
		-1,
		-1,
		-1,
		235,
		236,
		260,
		235,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		238,
		236,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		319,
		308,
		319,
		327,
		300,
		307,
		-1,
		326,
		330,
		296,
		290,
		329,
		298,
		304,
		315,
		-1,
		-1,
		-1,
		319,
		318,
		286,
		284,
		293,
		298,
		305,
		-1,
		304,
		-1,
		340,
		319,
		330,
		335,
		279,
		276,
		296,
		315,
		297,
		289,
		355,
		309,
		280,
		274,
		292,
		282,
		291,
		283,
		-1,
		280,
		270,
		292,
		271,
		282,
		274,
		-1,
		-1,
		274,
		275,
		281,
		267,
		273,
		269,
		-1,
		279,
		263,
		-1,
		-1,
		264,
		265,
		249,
		252,
		260,
		258,
		271,
		263,
		258,
		-1,
		-1,
		255,
		251,
		258,
		245,
		241,
		258,
		271,
		253,
		267,
		266,
		-1,
		261,
		279,
		284,
		252,
		250,
		234,
		232,
		250,
		252,
		258,
		258,
		-1,
		267,
		269,
		266,
		274,
		274,
		250,
		237,
		237,
		247,
		240,
		259,
		247,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		264,
		253,
		270,
		262,
		252,
		267,
		260,
		240,
		237,
		235,
		232,
		248,
		246,
		256,
		-1,
		-1,
		320,
		289,
		324,
		281,
		266,
		-1,
		260,
		246,
		252,
		256,
		250,
		243,
		257,
		253,
		-1,
		226,
		225,
		253,
		239,
		250,
		280,
		-1,
		-1,
		278,
		270,
		255,
		258,
		255,
		255,
		261,
		260,
		252,
		238,
		234,
		240,
		243,
		243,
		249,
		220,
		230,
		234,
		232,
		257,
		-1,
		-1,
		292,
		-1,
		-1,
		277,
		260,
		-1,
		243,
		250,
		250,
		267,
		257,
		278,
		271,
		262,
		254,
		248,
		236,
		238,
		235,
		248,
		236,
		217,
		242,
		246,
		227,
		248,
		243,
		-1,
		291,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		236,
		239,
		245,
		269,
		279,
		-1,
		283,
		271,
		272,
		257,
		254,
		241,
		229,
		242,
		227,
		234,
		233,
		221,
		219,
		249,
		224,
		246,
		243,
		262,
		267,
		261,
		270,
		-1,
		285,
		281,
		277,
		284,
		233,
		-1,
		-1,
		273,
		-1,
		287,
		300,
		295,
		268,
		271,
		258,
		249,
		236,
		225,
		236,
		225,
		222,
		230,
		213,
		228,
		219,
		218,
		236,
		246,
		254,
		258,
		264,
		-1,
		335,
		-1,
		277,
		261,
		263,
		235,
		256,
		-1,
		293,
		288,
		308,
		297,
		295,
		-1,
		267,
		264,
		254,
		232,
		217,
		234,
		226,
		224,
		226,
		208,
		222,
		213,
		231,
		238,
		236,
		240,
		260,
		272,
		295,
		285,
		-1,
		267,
		272,
		231,
		239,
		258,
		331,
		301,
		-1,
		296,
		-1,
		269,
		282,
		-1,
		238,
		234,
		216,
		217,
		212,
		227,
		219,
		204,
		201,
		219,
		222,
		229,
		233,
		249,
		-1,
		-1,
		280,
		284,
		273,
		224,
		243,
		267,
		304,
		294,
		283,
		282,
		-1,
		273,
		252,
		249,
		237,
		224,
		209,
		210,
		218,
		230,
		209,
		203,
		200,
		220,
		246,
		224,
		235,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		250,
		221,
		245,
		287,
		312,
		305,
		293,
		258,
		258,
		252,
		-1,
		248,
		227,
		218,
		207,
		205,
		218,
		210,
		218,
		198,
		196,
		215,
		227,
		218,
		226,
		-1,
		-1,
		-1,
		280,
		269,
		270,
		216,
		239,
		276,
		291,
		277,
		282,
		257,
		250,
		244,
		261,
		244,
		225,
		214,
		206,
		195,
		206,
		214,
		212,
		194,
		203,
		209,
		233,
		214,
		220,
		-1,
		-1,
		287,
		277,
		261,
		263,
		260,
		230,
		237,
		269,
		282,
		281,
		-1,
		249,
		-1,
		238,
		234,
		219,
		214,
		211,
		198,
		197,
		211,
		211,
		201,
		196,
		203,
		238,
		238,
		204,
		224,
		227,
		-1,
		-1,
		-1,
		280,
		275,
		250,
		227,
		211,
		247,
		-1,
		251,
		252,
		-1,
		243,
		237,
		234,
		221,
		217,
		202,
		206,
		208,
		211,
		199,
		205,
		206,
		188,
		212,
		-1,
		212,
		206,
		214,
		204,
		192,
		-1,
		-1,
		-1,
		273,
		252,
		245,
		265,
		206,
		258,
		-1,
		-1,
		236,
		229,
		-1,
		230,
		212,
		214,
		209,
		205,
		207,
		204,
		193,
		206,
		199,
		193,
		187,
		200,
		204,
		205,
		194,
		190,
		187,
		201,
		-1,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		226,
		-1,
		244,
		236,
		227,
		221,
		227,
		225,
		223,
		233,
		217,
		219,
		215,
		207,
		202,
		188,
		181,
		192,
		177,
		195,
		201,
		192,
		187,
		186,
		197,
		-1,
		293,
		279,
		250,
		-1,
		-1,
		239,
		-1,
		203,
		222,
		238,
		-1,
		261,
		240,
		261,
		239,
		235,
		226,
		224,
		225,
		195,
		200,
		202,
		190,
		193,
		182,
		185,
		177,
		199,
		196,
		180,
		182,
		191,
		-1,
		299,
		286,
		244,
		240,
		229,
		249,
		200,
		209,
		225,
		-1,
		-1,
		277,
		-1,
		231,
		233,
		240,
		238,
		214,
		189,
		196,
		214,
		187,
		182,
		187,
		176,
		176,
		171,
		190,
		176,
		174,
		189,
		205,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		215,
		202,
		196,
		-1,
		242,
		-1,
		255,
		243,
		230,
		212,
		252,
		-1,
		188,
		184,
		191,
		-1,
		207,
		-1,
		179,
		182,
		173,
		168,
		165,
		176,
		174,
		183,
		184,
		-1,
		249,
		234,
		227,
		217,
		231,
		199,
		-1,
		233,
		-1,
		-1,
		242,
		236,
		236,
		205,
		202,
		204,
		184,
		176,
		191,
		190,
		177,
		176,
		164,
		164,
		167,
		161,
		174,
		184,
		190,
		182,
		-1,
		-1,
		-1,
		254,
		215,
		223,
		195,
		199,
		-1,
		-1,
		303,
		259,
		245,
		-1,
		197,
		204,
		192,
		182,
		172,
		177,
		178,
		168,
		166,
		162,
		171,
		170,
		163,
		162,
		183,
		176,
		198,
		-1,
		-1,
		212,
		221,
		209,
		177,
		172,
		-1,
		-1,
		-1,
		249,
		235,
		223,
		195,
		193,
		-1,
		-1,
		176,
		169,
		163,
		166,
		154,
		174,
		181,
		169,
		156,
		171,
		181,
		189,
		188,
		-1,
		215,
		202,
		-1,
		-1,
		171,
		161,
		-1,
		-1,
		-1,
		-1,
		213,
		182,
		171,
		166,
		170,
		175,
		-1,
		149,
		160,
		153,
		172,
		179,
		171,
		156,
		150,
		161,
		176,
		193,
		-1,
		-1,
		185,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		185,
		188,
		159,
		152,
		156,
		-1,
		151,
		153,
		150,
		162,
		167,
		171,
		162,
		144,
		158,
		161,
		174,
		188,
		192,
		208,
		-1,
		138,
		-1,
		-1,
		-1,
		177,
		178,
		192,
		169,
		148,
		141,
		138,
		137,
		142,
		153,
		162,
		173,
		138,
		142,
		157,
		162,
		166,
		183,
		187,
		-1,
		-1,
		136,
		132,
		167,
		179,
		151,
		219,
		-1,
		-1,
		137,
		130,
		140,
		133,
		146,
		149,
		134,
		136,
		154,
		167,
		161,
		171,
		186,
		181,
		-1,
		-1,
		-1,
		134,
		-1,
		150,
		-1,
		-1,
		141,
		210,
		157,
		139,
		135,
		121,
		128,
		122,
		124,
		129,
		148,
		143,
		152,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		100,
		119,
		114,
		120,
		125,
		116,
		172,
		169,
		-1,
		118,
		151,
		119,
		133,
		129,
		136,
		141,
		147,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		161,
		150,
		139,
		145,
		-1,
		93,
		116,
		106,
		96,
		102,
		-1,
		-1,
		136,
		133,
		131,
		111,
		117,
		122,
		125,
		163,
		139,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		115,
		152,
		145,
		113,
		121,
		152,
		-1,
		83,
		75,
		103,
		88,
		96,
		-1,
		-1,
		109,
		100,
		105,
		114,
		115,
		146,
		145,
		158,
		161,
		166,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		108,
		128,
		107,
		110,
		134,
		148,
		-1,
		74,
		-1,
		-1,
		101,
		109,
		117,
		108,
		105,
		152,
		128,
		123,
		129,
		131,
		155,
		146,
		171,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		97,
		108,
		101,
		-1,
		-1,
		-1,
		-1,
		68,
		-1,
		-1,
		91,
		-1,
		143,
		-1,
		128,
		132,
		136,
		139,
		154,
		141,
		148,
		165,
		171,
		160,
		170,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		122,
		78,
		81,
		92,
		103,
		118,
		122,
		-1,
		58,
		91,
		38,
		-1,
		81,
		-1,
		-1,
		-1,
		142,
		149,
		141,
		157,
		153,
		153,
		149,
		153,
		165,
		172,
		182,
		184,
		176,
		180,
		193,
		204,
		207,
		118,
		109,
		122,
		67,
		67,
		88,
		97,
		118,
		42,
		51,
		85,
		27,
		42,
		47,
		71,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		160,
		170,
		153,
		155,
		159,
		173,
		185,
		193,
		183,
		181,
		175,
		207,
		-1,
		111,
		110,
		99,
		96,
		72,
		63,
		58,
		85,
		-1,
		-1,
		40,
		76,
		22,
		1,
		17,
		42,
		-1,
		78,
		-1,
		-1,
		186,
		-1,
		-1,
		212,
		175,
		164,
		155,
		161,
		167,
		178,
		200,
		189,
		190,
		180,
		190,
		203,
		95,
		92,
		80,
		78,
		101,
		66,
		54,
		-1,
		43,
		37,
		33,
		20,
		0,
		31,
		-1,
		-1,
		94,
		85,
		-1,
		-1,
		205,
		208,
		197,
		-1,
		187,
		160,
		165,
		190,
		197,
		198,
		192,
		186,
		193,
		192,
		200,
		208,
		104,
		118,
		107,
		103,
		102,
		110,
		59,
		52,
		46,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		104,
		-1,
		-1,
		205,
		198,
		186,
		174,
		164,
		174,
		182,
		182,
		185,
		189,
		184,
		195,
		187,
		191,
		208,
		-1,
		138,
		-1,
		90,
		58,
		78,
		93,
		101,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		239,
		223,
		204,
		-1,
		174,
		187,
		218,
		186,
		191,
		186,
		190,
		201,
		190,
		193,
		207,
		202,
		-1,
		-1,
		76,
		79,
		-1,
		-1,
		103,
		122,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		211,
		207,
		-1,
		-1,
		166,
		200,
		189,
		197,
		192,
		194,
		200,
		203,
		192,
		196,
		208,
		-1,
		-1,
		83,
		86,
		91,
		-1,
		112,
		-1,
		161,
		-1,
		106,
		122,
		124,
		-1,
		-1,
		-1,
		197,
		160,
		176,
		199,
		212,
		210,
		201,
		198,
		205,
		203,
		199,
		210,
		-1,
		-1,
		-1,
		142,
		119,
		168,
		159,
		142,
		122,
		114,
		139,
		-1,
		178,
		-1,
		153,
		156,
		181,
		206,
		222,
		208,
		201,
		216,
		206,
		197,
		206,
		148,
		-1,
		123,
		182,
		160,
		128,
		128,
		127,
		192,
		-1,
		175,
		157,
		-1,
		185,
		175,
		223,
		198,
		207,
		200,
		194,
		195,
		203,
		-1,
		-1,
		-1,
		138,
		137,
		136,
		147,
		148,
		133,
		128,
		-1,
		180,
		162,
		148,
		165,
		165,
		156,
		164,
		213,
		209,
		212,
		210,
		188,
		-1,
		210,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		159,
		168,
		141,
		129,
		143,
		150,
		145,
		147,
		160,
		168,
		166,
		163,
		175,
		171,
		191,
		187,
		219,
		-1,
		217,
		-1,
		168,
		-1,
		-1,
		175,
		161,
		163,
		152,
		141,
		139,
		142,
		140,
		162,
		192,
		178,
		176,
		181,
		186,
		-1,
		227,
		228,
		-1,
		194,
		186,
		172,
		-1,
		165,
		-1,
		187,
		148,
		-1,
		169,
		149,
		-1,
		187,
		183,
		-1,
		-1,
		239,
		210,
		-1,
		-1,
		-1,
		195,
		175,
		182,
		166,
		-1,
		160,
		160,
		-1,
		-1,
		-1,
		235,
		219,
		-1,
		188,
		191,
		-1,
		182,
		188,
		215,
		162,
		166,
		-1,
		-1,
		-1,
		244,
		225,
		219,
		203,
		208,
		196,
		213,
		199,
		198,
		176,
		165,
		186,
		-1,
		-1,
		-1,
		216,
		208,
		208,
		-1,
		-1,
		223,
		206,
		187,
		185,
		-1,
		-1,
		-1,
		238,
		219,
		-1,
		-1,
		213,
		-1,
		-1,
		219,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		227,
		-1,
		-1,
		-1,
		209,
		205,
		206,
		-1,
		-1,
		-1,
		-1,
		248,
		249,
		273,
		248,
		-1,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		251,
		249,
		-1,
		-1,
		-1,
		229,
		213,
		-1,
		199,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		234,
		-1,
		234,
		209,
		216,
		-1,
		-1,
		-1,
		-1,
		247,
		239,
		247,
		-1,
		219,
		221,
		-1,
		269,
		-1,
		-1,
		262,
		253,
		-1,
		-1,
		224,
		231,
		253,
		256,
		292,
		-1,
		243
	],
	[
		-1,
		355,
		344,
		355,
		363,
		336,
		343,
		-1,
		362,
		366,
		332,
		326,
		365,
		334,
		340,
		351,
		-1,
		-1,
		-1,
		355,
		354,
		322,
		320,
		329,
		334,
		341,
		-1,
		340,
		-1,
		376,
		355,
		366,
		371,
		315,
		312,
		332,
		351,
		333,
		325,
		391,
		345,
		316,
		310,
		328,
		318,
		327,
		319,
		-1,
		316,
		306,
		328,
		307,
		318,
		310,
		-1,
		-1,
		310,
		311,
		317,
		303,
		309,
		305,
		-1,
		315,
		299,
		-1,
		-1,
		300,
		301,
		285,
		288,
		296,
		294,
		307,
		299,
		294,
		-1,
		-1,
		291,
		287,
		294,
		281,
		277,
		294,
		307,
		289,
		303,
		302,
		-1,
		297,
		315,
		320,
		288,
		286,
		270,
		268,
		286,
		288,
		294,
		294,
		-1,
		303,
		305,
		302,
		310,
		310,
		286,
		273,
		273,
		283,
		276,
		295,
		283,
		329,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		300,
		289,
		306,
		298,
		288,
		303,
		296,
		276,
		273,
		271,
		268,
		284,
		282,
		292,
		-1,
		-1,
		356,
		325,
		360,
		317,
		302,
		-1,
		296,
		282,
		288,
		292,
		286,
		279,
		293,
		289,
		-1,
		262,
		261,
		289,
		275,
		286,
		316,
		-1,
		-1,
		314,
		306,
		291,
		294,
		291,
		291,
		297,
		296,
		288,
		274,
		270,
		276,
		279,
		279,
		285,
		256,
		266,
		270,
		268,
		293,
		-1,
		-1,
		328,
		-1,
		-1,
		313,
		296,
		-1,
		279,
		286,
		286,
		303,
		293,
		314,
		307,
		298,
		290,
		284,
		272,
		274,
		271,
		284,
		272,
		253,
		278,
		282,
		263,
		284,
		279,
		-1,
		327,
		311,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		272,
		275,
		281,
		305,
		315,
		-1,
		319,
		307,
		308,
		293,
		290,
		277,
		265,
		278,
		263,
		270,
		269,
		257,
		255,
		285,
		260,
		282,
		279,
		298,
		303,
		297,
		306,
		-1,
		321,
		317,
		313,
		320,
		269,
		-1,
		-1,
		309,
		-1,
		323,
		336,
		331,
		304,
		307,
		294,
		285,
		272,
		261,
		272,
		261,
		258,
		266,
		249,
		264,
		255,
		254,
		272,
		282,
		290,
		294,
		300,
		-1,
		371,
		-1,
		313,
		297,
		299,
		271,
		292,
		-1,
		329,
		324,
		344,
		333,
		331,
		-1,
		303,
		300,
		290,
		268,
		253,
		270,
		262,
		260,
		262,
		244,
		258,
		249,
		267,
		274,
		272,
		276,
		296,
		308,
		331,
		321,
		-1,
		303,
		308,
		267,
		275,
		294,
		367,
		337,
		-1,
		332,
		-1,
		305,
		318,
		-1,
		274,
		270,
		252,
		253,
		248,
		263,
		255,
		240,
		237,
		255,
		258,
		265,
		269,
		285,
		-1,
		-1,
		316,
		320,
		309,
		260,
		279,
		303,
		340,
		330,
		319,
		318,
		-1,
		309,
		288,
		285,
		273,
		260,
		245,
		246,
		254,
		266,
		245,
		239,
		236,
		256,
		282,
		260,
		271,
		-1,
		-1,
		-1,
		341,
		-1,
		-1,
		286,
		257,
		281,
		323,
		348,
		341,
		329,
		294,
		294,
		288,
		-1,
		284,
		263,
		254,
		243,
		241,
		254,
		246,
		254,
		234,
		232,
		251,
		263,
		254,
		262,
		-1,
		-1,
		-1,
		316,
		305,
		306,
		252,
		275,
		312,
		327,
		313,
		318,
		293,
		286,
		280,
		297,
		280,
		261,
		250,
		242,
		231,
		242,
		250,
		248,
		230,
		239,
		245,
		269,
		250,
		256,
		-1,
		-1,
		323,
		313,
		297,
		299,
		296,
		266,
		273,
		305,
		318,
		317,
		-1,
		285,
		-1,
		274,
		270,
		255,
		250,
		247,
		234,
		233,
		247,
		247,
		237,
		232,
		239,
		274,
		274,
		240,
		260,
		263,
		-1,
		-1,
		-1,
		316,
		311,
		286,
		263,
		247,
		283,
		-1,
		287,
		288,
		-1,
		279,
		273,
		270,
		257,
		253,
		238,
		242,
		244,
		247,
		235,
		241,
		242,
		224,
		248,
		-1,
		248,
		242,
		250,
		240,
		228,
		-1,
		-1,
		-1,
		309,
		288,
		281,
		301,
		242,
		294,
		-1,
		-1,
		272,
		265,
		-1,
		266,
		248,
		250,
		245,
		241,
		243,
		240,
		229,
		242,
		235,
		229,
		223,
		236,
		240,
		241,
		230,
		226,
		223,
		237,
		-1,
		328,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		262,
		-1,
		280,
		272,
		263,
		257,
		263,
		261,
		259,
		269,
		253,
		255,
		251,
		243,
		238,
		224,
		217,
		228,
		213,
		231,
		237,
		228,
		223,
		222,
		233,
		-1,
		329,
		315,
		286,
		-1,
		-1,
		275,
		-1,
		239,
		258,
		274,
		-1,
		297,
		276,
		297,
		275,
		271,
		262,
		260,
		261,
		231,
		236,
		238,
		226,
		229,
		218,
		221,
		213,
		235,
		232,
		216,
		218,
		227,
		-1,
		335,
		322,
		280,
		276,
		265,
		285,
		236,
		245,
		261,
		-1,
		-1,
		313,
		-1,
		267,
		269,
		276,
		274,
		250,
		225,
		232,
		250,
		223,
		218,
		223,
		212,
		212,
		207,
		226,
		212,
		210,
		225,
		241,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		251,
		238,
		232,
		-1,
		278,
		-1,
		291,
		279,
		266,
		248,
		288,
		-1,
		224,
		220,
		227,
		-1,
		243,
		-1,
		215,
		218,
		209,
		204,
		201,
		212,
		210,
		219,
		220,
		-1,
		285,
		270,
		263,
		253,
		267,
		235,
		-1,
		269,
		-1,
		-1,
		278,
		272,
		272,
		241,
		238,
		240,
		220,
		212,
		227,
		226,
		213,
		212,
		200,
		200,
		203,
		197,
		210,
		220,
		226,
		218,
		-1,
		-1,
		-1,
		290,
		251,
		259,
		231,
		235,
		-1,
		-1,
		339,
		295,
		281,
		-1,
		233,
		240,
		228,
		218,
		208,
		213,
		214,
		204,
		202,
		198,
		207,
		206,
		199,
		198,
		219,
		212,
		234,
		-1,
		-1,
		248,
		257,
		245,
		213,
		208,
		-1,
		-1,
		-1,
		285,
		271,
		259,
		231,
		229,
		-1,
		-1,
		212,
		205,
		199,
		202,
		190,
		210,
		217,
		205,
		192,
		207,
		217,
		225,
		224,
		-1,
		251,
		238,
		-1,
		-1,
		207,
		197,
		-1,
		-1,
		-1,
		-1,
		249,
		218,
		207,
		202,
		206,
		211,
		-1,
		185,
		196,
		189,
		208,
		215,
		207,
		192,
		186,
		197,
		212,
		229,
		-1,
		-1,
		221,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		221,
		224,
		195,
		188,
		192,
		-1,
		187,
		189,
		186,
		198,
		203,
		207,
		198,
		180,
		194,
		197,
		210,
		224,
		228,
		244,
		-1,
		174,
		-1,
		-1,
		-1,
		213,
		214,
		228,
		205,
		184,
		177,
		174,
		173,
		178,
		189,
		198,
		209,
		174,
		178,
		193,
		198,
		202,
		219,
		223,
		-1,
		-1,
		172,
		168,
		203,
		215,
		187,
		255,
		-1,
		-1,
		173,
		166,
		176,
		169,
		182,
		185,
		170,
		172,
		190,
		203,
		197,
		207,
		222,
		217,
		-1,
		-1,
		-1,
		170,
		-1,
		186,
		-1,
		-1,
		177,
		246,
		193,
		175,
		171,
		157,
		164,
		158,
		160,
		165,
		184,
		179,
		188,
		193,
		197,
		220,
		209,
		248,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		136,
		155,
		150,
		156,
		161,
		152,
		208,
		205,
		-1,
		154,
		187,
		155,
		169,
		165,
		172,
		177,
		183,
		187,
		194,
		210,
		209,
		204,
		240,
		231,
		237,
		-1,
		-1,
		197,
		186,
		175,
		181,
		-1,
		129,
		152,
		142,
		132,
		138,
		-1,
		-1,
		172,
		169,
		167,
		147,
		153,
		158,
		161,
		199,
		175,
		183,
		187,
		191,
		197,
		202,
		207,
		213,
		228,
		243,
		-1,
		151,
		188,
		181,
		149,
		157,
		188,
		-1,
		119,
		111,
		139,
		124,
		132,
		-1,
		-1,
		145,
		136,
		141,
		150,
		151,
		182,
		181,
		194,
		197,
		202,
		190,
		189,
		207,
		211,
		220,
		227,
		217,
		230,
		234,
		-1,
		144,
		164,
		143,
		146,
		170,
		184,
		-1,
		110,
		-1,
		-1,
		117,
		145,
		153,
		144,
		141,
		188,
		164,
		159,
		165,
		167,
		191,
		182,
		207,
		198,
		198,
		201,
		216,
		221,
		213,
		227,
		227,
		228,
		-1,
		133,
		144,
		137,
		-1,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		107,
		-1,
		179,
		-1,
		164,
		168,
		172,
		175,
		190,
		177,
		184,
		201,
		207,
		196,
		206,
		202,
		203,
		212,
		223,
		235,
		234,
		235,
		158,
		114,
		117,
		128,
		139,
		154,
		158,
		-1,
		94,
		127,
		54,
		-1,
		97,
		-1,
		-1,
		-1,
		178,
		185,
		177,
		193,
		189,
		189,
		185,
		189,
		201,
		208,
		218,
		220,
		212,
		216,
		229,
		240,
		243,
		154,
		145,
		158,
		103,
		103,
		124,
		133,
		154,
		78,
		87,
		121,
		43,
		58,
		63,
		87,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		196,
		206,
		189,
		191,
		195,
		209,
		221,
		229,
		219,
		217,
		211,
		243,
		-1,
		147,
		146,
		135,
		132,
		108,
		99,
		94,
		121,
		-1,
		-1,
		76,
		112,
		58,
		35,
		19,
		44,
		-1,
		94,
		-1,
		-1,
		222,
		-1,
		-1,
		233,
		211,
		200,
		191,
		197,
		203,
		214,
		236,
		225,
		226,
		216,
		226,
		239,
		131,
		128,
		116,
		114,
		137,
		102,
		90,
		-1,
		79,
		73,
		69,
		56,
		36,
		0,
		-1,
		-1,
		110,
		101,
		-1,
		-1,
		231,
		229,
		218,
		-1,
		208,
		190,
		195,
		225,
		227,
		229,
		228,
		222,
		229,
		228,
		236,
		244,
		140,
		154,
		143,
		139,
		138,
		146,
		95,
		88,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		120,
		-1,
		-1,
		226,
		219,
		207,
		195,
		185,
		195,
		212,
		212,
		215,
		220,
		220,
		231,
		223,
		227,
		242,
		-1,
		174,
		-1,
		126,
		94,
		114,
		129,
		137,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		260,
		244,
		225,
		-1,
		195,
		208,
		248,
		216,
		221,
		216,
		226,
		237,
		226,
		229,
		235,
		238,
		-1,
		-1,
		112,
		115,
		-1,
		-1,
		139,
		158,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		232,
		228,
		-1,
		-1,
		182,
		220,
		219,
		227,
		222,
		227,
		236,
		235,
		228,
		232,
		232,
		-1,
		-1,
		119,
		122,
		127,
		-1,
		148,
		-1,
		177,
		-1,
		122,
		138,
		140,
		-1,
		-1,
		-1,
		213,
		176,
		192,
		215,
		241,
		239,
		230,
		223,
		230,
		233,
		226,
		232,
		-1,
		-1,
		-1,
		178,
		155,
		184,
		175,
		158,
		138,
		130,
		155,
		-1,
		194,
		-1,
		169,
		172,
		197,
		236,
		238,
		224,
		220,
		233,
		227,
		224,
		222,
		184,
		-1,
		159,
		212,
		176,
		144,
		144,
		143,
		208,
		-1,
		191,
		173,
		-1,
		201,
		191,
		239,
		214,
		223,
		216,
		210,
		211,
		219,
		-1,
		-1,
		-1,
		174,
		173,
		172,
		166,
		164,
		149,
		144,
		-1,
		196,
		178,
		164,
		181,
		181,
		172,
		180,
		229,
		225,
		228,
		226,
		204,
		-1,
		246,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		175,
		184,
		157,
		145,
		159,
		166,
		161,
		163,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		203,
		235,
		-1,
		253,
		-1,
		204,
		-1,
		-1,
		191,
		177,
		179,
		168,
		157,
		155,
		158,
		156,
		178,
		208,
		194,
		192,
		197,
		202,
		-1,
		263,
		264,
		-1,
		210,
		202,
		188,
		-1,
		181,
		-1,
		203,
		164,
		-1,
		185,
		165,
		-1,
		203,
		199,
		-1,
		-1,
		266,
		226,
		-1,
		-1,
		-1,
		211,
		191,
		198,
		182,
		-1,
		176,
		176,
		-1,
		-1,
		-1,
		251,
		235,
		-1,
		204,
		207,
		-1,
		198,
		204,
		231,
		178,
		182,
		-1,
		-1,
		-1,
		260,
		241,
		235,
		219,
		224,
		212,
		229,
		215,
		214,
		192,
		181,
		202,
		-1,
		-1,
		-1,
		232,
		224,
		224,
		-1,
		-1,
		239,
		222,
		203,
		201,
		-1,
		-1,
		-1,
		254,
		235,
		-1,
		-1,
		229,
		-1,
		-1,
		235,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		243,
		-1,
		-1,
		-1,
		225,
		221,
		222,
		-1,
		-1,
		-1,
		-1,
		264,
		265,
		289,
		264,
		-1,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		267,
		265,
		-1,
		-1,
		-1,
		245,
		229,
		-1,
		215,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		250,
		-1,
		250,
		225,
		232,
		-1,
		-1,
		-1,
		-1,
		263,
		255,
		263,
		-1,
		235,
		237,
		-1,
		285,
		-1,
		-1,
		278,
		269,
		-1,
		-1,
		240,
		247,
		269,
		272,
		308,
		-1,
		259
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		312,
		301,
		312,
		320,
		293,
		300,
		-1,
		319,
		323,
		289,
		283,
		322,
		291,
		297,
		308,
		-1,
		-1,
		-1,
		312,
		311,
		279,
		277,
		286,
		291,
		298,
		-1,
		297,
		-1,
		333,
		312,
		323,
		328,
		272,
		269,
		289,
		308,
		290,
		282,
		348,
		302,
		273,
		267,
		285,
		275,
		284,
		276,
		-1,
		273,
		263,
		285,
		264,
		275,
		267,
		-1,
		-1,
		267,
		268,
		274,
		260,
		266,
		262,
		-1,
		272,
		256,
		-1,
		-1,
		257,
		258,
		242,
		245,
		253,
		251,
		264,
		256,
		251,
		-1,
		-1,
		248,
		244,
		251,
		238,
		234,
		251,
		264,
		246,
		260,
		259,
		-1,
		252,
		270,
		277,
		245,
		243,
		227,
		225,
		243,
		245,
		251,
		251,
		-1,
		256,
		258,
		257,
		265,
		267,
		243,
		230,
		230,
		240,
		233,
		252,
		240,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		253,
		244,
		261,
		253,
		243,
		258,
		251,
		233,
		230,
		228,
		225,
		241,
		239,
		249,
		-1,
		-1,
		309,
		278,
		313,
		270,
		255,
		-1,
		249,
		237,
		243,
		247,
		241,
		234,
		248,
		244,
		-1,
		219,
		218,
		246,
		232,
		243,
		269,
		-1,
		-1,
		267,
		259,
		244,
		247,
		244,
		244,
		252,
		251,
		243,
		229,
		225,
		231,
		234,
		234,
		240,
		213,
		223,
		227,
		225,
		250,
		-1,
		-1,
		285,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		239,
		256,
		246,
		267,
		262,
		253,
		245,
		239,
		227,
		229,
		226,
		239,
		227,
		210,
		235,
		239,
		220,
		241,
		236,
		-1,
		284,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		268,
		-1,
		274,
		262,
		263,
		248,
		245,
		232,
		220,
		233,
		218,
		225,
		224,
		214,
		212,
		242,
		217,
		239,
		236,
		255,
		260,
		254,
		263,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		276,
		289,
		286,
		259,
		262,
		249,
		240,
		227,
		216,
		227,
		216,
		213,
		221,
		206,
		221,
		212,
		211,
		229,
		239,
		247,
		251,
		257,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		277,
		297,
		288,
		286,
		-1,
		258,
		255,
		245,
		223,
		208,
		225,
		217,
		215,
		219,
		201,
		215,
		206,
		224,
		231,
		229,
		233,
		253,
		265,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		320,
		292,
		-1,
		287,
		-1,
		260,
		273,
		-1,
		229,
		225,
		207,
		208,
		203,
		218,
		212,
		197,
		194,
		212,
		215,
		222,
		226,
		242,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		285,
		274,
		273,
		-1,
		264,
		243,
		240,
		228,
		215,
		200,
		201,
		209,
		222,
		201,
		196,
		193,
		213,
		239,
		217,
		229,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		303,
		296,
		284,
		249,
		249,
		243,
		-1,
		239,
		218,
		209,
		198,
		196,
		209,
		206,
		211,
		191,
		189,
		208,
		220,
		211,
		228,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		205,
		228,
		265,
		282,
		268,
		273,
		248,
		241,
		235,
		252,
		235,
		216,
		205,
		197,
		186,
		202,
		210,
		205,
		187,
		196,
		202,
		226,
		216,
		222,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		219,
		226,
		258,
		273,
		270,
		-1,
		240,
		-1,
		229,
		226,
		210,
		205,
		202,
		199,
		193,
		202,
		204,
		194,
		189,
		196,
		231,
		231,
		206,
		226,
		229,
		-1,
		-1,
		-1,
		269,
		264,
		239,
		216,
		200,
		236,
		-1,
		240,
		241,
		-1,
		234,
		228,
		227,
		212,
		208,
		203,
		207,
		200,
		207,
		200,
		198,
		199,
		181,
		213,
		-1,
		214,
		208,
		216,
		206,
		194,
		-1,
		-1,
		-1,
		262,
		241,
		234,
		254,
		195,
		247,
		-1,
		-1,
		225,
		218,
		-1,
		221,
		205,
		212,
		210,
		204,
		208,
		205,
		194,
		207,
		200,
		186,
		188,
		201,
		205,
		209,
		196,
		192,
		189,
		203,
		-1,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		215,
		-1,
		233,
		225,
		216,
		210,
		216,
		218,
		216,
		232,
		216,
		219,
		217,
		208,
		216,
		189,
		182,
		189,
		178,
		196,
		204,
		196,
		190,
		189,
		199,
		-1,
		282,
		268,
		239,
		-1,
		-1,
		228,
		-1,
		192,
		211,
		227,
		-1,
		250,
		229,
		252,
		230,
		228,
		224,
		239,
		240,
		217,
		217,
		215,
		206,
		194,
		183,
		186,
		178,
		200,
		200,
		184,
		185,
		189,
		-1,
		288,
		275,
		233,
		229,
		218,
		238,
		189,
		198,
		214,
		-1,
		-1,
		288,
		-1,
		228,
		244,
		238,
		236,
		229,
		211,
		218,
		226,
		203,
		198,
		188,
		177,
		177,
		172,
		194,
		180,
		178,
		187,
		203,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		204,
		191,
		185,
		-1,
		231,
		-1,
		266,
		254,
		241,
		223,
		263,
		-1,
		210,
		206,
		213,
		-1,
		223,
		-1,
		196,
		193,
		184,
		169,
		166,
		177,
		175,
		186,
		182,
		-1,
		238,
		223,
		216,
		206,
		220,
		188,
		-1,
		222,
		-1,
		-1,
		253,
		247,
		247,
		216,
		213,
		226,
		206,
		198,
		213,
		212,
		199,
		198,
		182,
		175,
		172,
		165,
		178,
		188,
		193,
		180,
		-1,
		-1,
		-1,
		243,
		218,
		212,
		184,
		188,
		-1,
		-1,
		314,
		270,
		256,
		-1,
		208,
		226,
		214,
		204,
		194,
		199,
		200,
		190,
		188,
		180,
		182,
		176,
		167,
		166,
		182,
		174,
		196,
		-1,
		-1,
		217,
		210,
		198,
		166,
		161,
		-1,
		-1,
		-1,
		260,
		246,
		234,
		206,
		215,
		-1,
		-1,
		198,
		191,
		185,
		188,
		176,
		196,
		191,
		175,
		160,
		175,
		179,
		187,
		178,
		-1,
		220,
		207,
		-1,
		-1,
		160,
		150,
		-1,
		-1,
		-1,
		-1,
		224,
		205,
		200,
		195,
		199,
		197,
		-1,
		171,
		182,
		175,
		194,
		201,
		177,
		162,
		156,
		162,
		174,
		183,
		-1,
		-1,
		174,
		-1,
		136,
		-1,
		-1,
		-1,
		-1,
		196,
		211,
		188,
		181,
		185,
		-1,
		173,
		175,
		172,
		184,
		180,
		177,
		168,
		159,
		155,
		159,
		163,
		177,
		181,
		197,
		-1,
		127,
		-1,
		-1,
		-1,
		173,
		195,
		227,
		204,
		177,
		172,
		165,
		159,
		164,
		175,
		184,
		195,
		160,
		162,
		152,
		151,
		155,
		172,
		176,
		-1,
		-1,
		125,
		121,
		156,
		168,
		168,
		254,
		-1,
		-1,
		172,
		165,
		163,
		155,
		168,
		171,
		156,
		158,
		158,
		156,
		150,
		160,
		175,
		170,
		-1,
		-1,
		-1,
		137,
		-1,
		139,
		-1,
		-1,
		158,
		245,
		192,
		174,
		170,
		156,
		164,
		158,
		146,
		151,
		161,
		155,
		152,
		146,
		150,
		173,
		162,
		201,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		144,
		108,
		103,
		137,
		142,
		133,
		207,
		204,
		-1,
		152,
		187,
		152,
		159,
		142,
		149,
		154,
		151,
		140,
		147,
		163,
		162,
		157,
		193,
		184,
		190,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		137,
		105,
		123,
		113,
		119,
		-1,
		-1,
		166,
		163,
		166,
		152,
		150,
		143,
		138,
		148,
		124,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		214,
		251,
		244,
		212,
		220,
		251,
		-1,
		127,
		119,
		102,
		105,
		113,
		-1,
		-1,
		139,
		135,
		140,
		149,
		152,
		162,
		161,
		144,
		150,
		151,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		207,
		227,
		206,
		209,
		233,
		247,
		-1,
		124,
		-1,
		-1,
		62,
		126,
		134,
		130,
		134,
		187,
		163,
		158,
		149,
		147,
		142,
		133,
		158,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		52,
		-1,
		160,
		-1,
		153,
		157,
		171,
		174,
		163,
		150,
		136,
		144,
		150,
		149,
		155,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		136,
		175,
		58,
		-1,
		42,
		-1,
		-1,
		-1,
		167,
		184,
		176,
		183,
		162,
		162,
		128,
		132,
		145,
		152,
		162,
		173,
		165,
		169,
		182,
		193,
		196,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		141,
		142,
		169,
		65,
		54,
		49,
		36,
		-1,
		-1,
		190,
		194,
		-1,
		-1,
		169,
		136,
		124,
		134,
		138,
		152,
		164,
		177,
		165,
		170,
		164,
		196,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		139,
		170,
		121,
		98,
		96,
		121,
		-1,
		16,
		-1,
		-1,
		176,
		-1,
		-1,
		161,
		141,
		130,
		121,
		126,
		146,
		157,
		179,
		161,
		178,
		169,
		179,
		183,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		142,
		136,
		132,
		119,
		99,
		110,
		-1,
		-1,
		0,
		29,
		-1,
		-1,
		159,
		157,
		146,
		-1,
		136,
		118,
		123,
		153,
		155,
		157,
		164,
		158,
		165,
		173,
		184,
		176,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		73,
		48,
		-1,
		-1,
		154,
		147,
		135,
		123,
		113,
		123,
		140,
		140,
		143,
		148,
		156,
		167,
		163,
		167,
		170,
		-1,
		237,
		-1,
		189,
		157,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		90,
		76,
		69,
		57,
		55,
		-1,
		188,
		172,
		153,
		-1,
		123,
		136,
		176,
		144,
		149,
		144,
		159,
		170,
		161,
		169,
		163,
		166,
		-1,
		-1,
		171,
		154,
		-1,
		-1,
		128,
		130,
		-1,
		81,
		70,
		55,
		47,
		-1,
		-1,
		160,
		156,
		-1,
		-1,
		110,
		148,
		147,
		155,
		150,
		155,
		167,
		163,
		159,
		169,
		160,
		-1,
		-1,
		149,
		141,
		135,
		-1,
		113,
		-1,
		105,
		-1,
		50,
		66,
		68,
		-1,
		-1,
		-1,
		141,
		104,
		120,
		143,
		169,
		167,
		158,
		151,
		158,
		161,
		154,
		160,
		-1,
		-1,
		-1,
		131,
		105,
		112,
		103,
		86,
		66,
		58,
		83,
		-1,
		122,
		-1,
		97,
		100,
		125,
		164,
		166,
		152,
		148,
		161,
		155,
		152,
		150,
		137,
		-1,
		107,
		140,
		104,
		72,
		72,
		71,
		136,
		-1,
		119,
		101,
		-1,
		129,
		119,
		167,
		142,
		151,
		144,
		138,
		139,
		147,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		92,
		77,
		72,
		-1,
		124,
		106,
		92,
		109,
		109,
		100,
		108,
		157,
		153,
		156,
		154,
		132,
		-1,
		223,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		112,
		85,
		73,
		87,
		94,
		89,
		91,
		104,
		112,
		110,
		107,
		119,
		115,
		135,
		131,
		163,
		-1,
		218,
		-1,
		139,
		-1,
		-1,
		119,
		105,
		107,
		96,
		85,
		83,
		86,
		84,
		106,
		136,
		122,
		120,
		125,
		130,
		-1,
		207,
		206,
		-1,
		138,
		130,
		116,
		-1,
		109,
		-1,
		131,
		92,
		-1,
		113,
		93,
		-1,
		131,
		127,
		-1,
		-1,
		194,
		154,
		-1,
		-1,
		-1,
		139,
		119,
		126,
		110,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		132,
		135,
		-1,
		126,
		132,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		188,
		169,
		163,
		147,
		152,
		140,
		157,
		143,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		160,
		152,
		152,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		182,
		163,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		171,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		217,
		192,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		290,
		279,
		290,
		298,
		271,
		278,
		-1,
		297,
		301,
		267,
		261,
		300,
		269,
		275,
		286,
		-1,
		-1,
		-1,
		290,
		289,
		257,
		255,
		264,
		269,
		276,
		-1,
		275,
		-1,
		311,
		290,
		301,
		306,
		250,
		247,
		267,
		286,
		268,
		260,
		326,
		280,
		251,
		245,
		263,
		253,
		262,
		254,
		-1,
		251,
		241,
		263,
		242,
		253,
		245,
		-1,
		-1,
		245,
		246,
		252,
		238,
		244,
		240,
		-1,
		250,
		234,
		-1,
		-1,
		235,
		236,
		220,
		223,
		231,
		229,
		242,
		234,
		229,
		-1,
		-1,
		226,
		222,
		229,
		216,
		212,
		229,
		242,
		224,
		238,
		237,
		-1,
		230,
		248,
		255,
		223,
		221,
		205,
		203,
		221,
		223,
		229,
		229,
		-1,
		239,
		240,
		235,
		243,
		245,
		221,
		208,
		208,
		218,
		211,
		230,
		218,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		239,
		222,
		239,
		231,
		221,
		236,
		229,
		211,
		208,
		206,
		203,
		219,
		217,
		227,
		-1,
		-1,
		300,
		269,
		304,
		261,
		246,
		-1,
		235,
		215,
		221,
		225,
		219,
		212,
		226,
		222,
		-1,
		197,
		196,
		224,
		210,
		221,
		260,
		-1,
		-1,
		258,
		250,
		235,
		238,
		235,
		235,
		230,
		229,
		221,
		207,
		203,
		209,
		212,
		212,
		218,
		191,
		201,
		205,
		203,
		228,
		-1,
		-1,
		263,
		-1,
		-1,
		257,
		240,
		-1,
		223,
		230,
		230,
		247,
		237,
		258,
		240,
		231,
		223,
		217,
		205,
		207,
		204,
		217,
		205,
		188,
		213,
		217,
		198,
		219,
		214,
		-1,
		262,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		216,
		219,
		225,
		249,
		259,
		-1,
		252,
		240,
		241,
		226,
		223,
		210,
		198,
		211,
		196,
		203,
		202,
		192,
		190,
		220,
		195,
		217,
		214,
		233,
		238,
		232,
		241,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		253,
		-1,
		267,
		280,
		264,
		237,
		240,
		227,
		218,
		205,
		194,
		205,
		194,
		191,
		199,
		184,
		199,
		190,
		189,
		207,
		217,
		225,
		229,
		235,
		-1,
		315,
		-1,
		257,
		241,
		243,
		215,
		236,
		-1,
		273,
		268,
		281,
		266,
		266,
		-1,
		236,
		233,
		223,
		201,
		186,
		203,
		195,
		193,
		197,
		179,
		193,
		184,
		202,
		209,
		207,
		211,
		231,
		243,
		275,
		265,
		-1,
		247,
		252,
		211,
		219,
		238,
		308,
		272,
		-1,
		267,
		-1,
		238,
		251,
		-1,
		207,
		203,
		185,
		186,
		181,
		196,
		190,
		175,
		172,
		190,
		193,
		200,
		204,
		220,
		-1,
		-1,
		260,
		264,
		253,
		204,
		223,
		247,
		284,
		265,
		254,
		253,
		-1,
		244,
		221,
		218,
		206,
		193,
		178,
		179,
		187,
		200,
		179,
		174,
		171,
		191,
		217,
		195,
		207,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		230,
		201,
		225,
		267,
		283,
		276,
		264,
		229,
		229,
		223,
		-1,
		217,
		196,
		187,
		176,
		174,
		187,
		184,
		189,
		169,
		167,
		186,
		198,
		189,
		206,
		-1,
		-1,
		-1,
		260,
		249,
		250,
		196,
		219,
		256,
		262,
		248,
		253,
		228,
		221,
		215,
		230,
		213,
		194,
		183,
		175,
		164,
		180,
		188,
		183,
		165,
		174,
		180,
		204,
		194,
		200,
		-1,
		-1,
		267,
		257,
		241,
		243,
		240,
		210,
		217,
		249,
		253,
		261,
		-1,
		220,
		-1,
		209,
		204,
		188,
		183,
		180,
		177,
		171,
		180,
		182,
		172,
		167,
		174,
		209,
		209,
		184,
		204,
		207,
		-1,
		-1,
		-1,
		260,
		255,
		230,
		207,
		191,
		227,
		-1,
		231,
		232,
		-1,
		214,
		208,
		205,
		190,
		186,
		181,
		185,
		178,
		185,
		178,
		176,
		177,
		159,
		191,
		-1,
		192,
		186,
		194,
		184,
		172,
		-1,
		-1,
		-1,
		253,
		232,
		225,
		245,
		186,
		238,
		-1,
		-1,
		216,
		209,
		-1,
		201,
		183,
		190,
		188,
		182,
		186,
		183,
		172,
		185,
		178,
		164,
		166,
		179,
		183,
		187,
		174,
		170,
		167,
		181,
		-1,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		206,
		-1,
		224,
		216,
		207,
		201,
		200,
		196,
		194,
		210,
		194,
		197,
		195,
		186,
		194,
		167,
		160,
		167,
		156,
		174,
		182,
		174,
		168,
		167,
		177,
		-1,
		273,
		259,
		230,
		-1,
		-1,
		219,
		-1,
		183,
		202,
		218,
		-1,
		238,
		217,
		232,
		210,
		206,
		202,
		217,
		218,
		195,
		195,
		193,
		184,
		172,
		161,
		164,
		156,
		178,
		178,
		162,
		163,
		167,
		-1,
		279,
		266,
		224,
		220,
		209,
		229,
		180,
		189,
		205,
		-1,
		-1,
		274,
		-1,
		208,
		225,
		216,
		214,
		207,
		189,
		196,
		204,
		181,
		176,
		166,
		155,
		155,
		150,
		172,
		158,
		156,
		165,
		181,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		195,
		182,
		176,
		-1,
		222,
		-1,
		252,
		242,
		226,
		211,
		244,
		-1,
		188,
		184,
		191,
		-1,
		201,
		-1,
		174,
		171,
		162,
		147,
		144,
		155,
		153,
		164,
		160,
		-1,
		229,
		214,
		207,
		197,
		211,
		179,
		-1,
		213,
		-1,
		-1,
		239,
		233,
		233,
		207,
		204,
		204,
		184,
		176,
		191,
		190,
		177,
		176,
		160,
		153,
		150,
		143,
		156,
		166,
		171,
		158,
		-1,
		-1,
		-1,
		234,
		209,
		203,
		175,
		179,
		-1,
		-1,
		301,
		256,
		242,
		-1,
		199,
		204,
		192,
		182,
		172,
		177,
		178,
		168,
		166,
		158,
		160,
		154,
		145,
		144,
		160,
		152,
		174,
		-1,
		-1,
		208,
		201,
		189,
		157,
		152,
		-1,
		-1,
		-1,
		248,
		237,
		225,
		197,
		193,
		-1,
		-1,
		176,
		169,
		163,
		166,
		154,
		174,
		169,
		153,
		138,
		153,
		157,
		165,
		156,
		-1,
		211,
		198,
		-1,
		-1,
		151,
		141,
		-1,
		-1,
		-1,
		-1,
		215,
		189,
		178,
		173,
		177,
		175,
		-1,
		149,
		160,
		153,
		172,
		179,
		155,
		140,
		134,
		140,
		152,
		161,
		-1,
		-1,
		165,
		-1,
		127,
		-1,
		-1,
		-1,
		-1,
		187,
		195,
		166,
		159,
		163,
		-1,
		151,
		153,
		150,
		162,
		158,
		155,
		146,
		137,
		133,
		137,
		141,
		155,
		159,
		188,
		-1,
		118,
		-1,
		-1,
		-1,
		164,
		186,
		205,
		182,
		155,
		150,
		143,
		137,
		142,
		153,
		162,
		173,
		138,
		140,
		130,
		129,
		133,
		150,
		154,
		-1,
		-1,
		116,
		112,
		147,
		159,
		159,
		232,
		-1,
		-1,
		159,
		150,
		141,
		133,
		146,
		149,
		134,
		136,
		136,
		134,
		128,
		138,
		153,
		148,
		-1,
		-1,
		-1,
		128,
		-1,
		130,
		-1,
		-1,
		149,
		230,
		177,
		159,
		155,
		147,
		142,
		136,
		124,
		129,
		139,
		133,
		130,
		124,
		128,
		151,
		140,
		179,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		135,
		99,
		94,
		128,
		133,
		124,
		192,
		189,
		-1,
		143,
		165,
		130,
		137,
		120,
		127,
		132,
		129,
		118,
		125,
		141,
		140,
		135,
		171,
		162,
		168,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		128,
		96,
		114,
		104,
		110,
		-1,
		-1,
		157,
		154,
		157,
		130,
		128,
		121,
		116,
		126,
		102,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		205,
		242,
		235,
		203,
		211,
		242,
		-1,
		118,
		110,
		93,
		96,
		104,
		-1,
		-1,
		130,
		126,
		131,
		137,
		134,
		140,
		139,
		122,
		128,
		129,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		198,
		218,
		197,
		200,
		224,
		238,
		-1,
		115,
		-1,
		-1,
		53,
		117,
		125,
		121,
		125,
		178,
		151,
		146,
		127,
		125,
		120,
		111,
		136,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		43,
		-1,
		151,
		-1,
		144,
		148,
		159,
		162,
		141,
		128,
		114,
		122,
		128,
		127,
		133,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		127,
		166,
		49,
		-1,
		33,
		-1,
		-1,
		-1,
		158,
		172,
		164,
		161,
		140,
		140,
		106,
		110,
		123,
		130,
		140,
		151,
		143,
		147,
		160,
		171,
		174,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		132,
		133,
		160,
		56,
		45,
		40,
		27,
		-1,
		-1,
		174,
		182,
		-1,
		-1,
		147,
		114,
		102,
		112,
		116,
		130,
		142,
		155,
		143,
		148,
		142,
		174,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		130,
		161,
		112,
		89,
		87,
		112,
		-1,
		11,
		-1,
		-1,
		154,
		-1,
		-1,
		139,
		119,
		108,
		99,
		104,
		124,
		135,
		157,
		139,
		156,
		147,
		157,
		161,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		133,
		127,
		123,
		110,
		90,
		101,
		-1,
		-1,
		27,
		0,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		96,
		101,
		131,
		133,
		135,
		142,
		136,
		143,
		151,
		162,
		154,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		66,
		-1,
		51,
		26,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		101,
		118,
		118,
		121,
		126,
		134,
		145,
		141,
		145,
		148,
		-1,
		228,
		-1,
		180,
		148,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		68,
		54,
		47,
		35,
		33,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		154,
		122,
		127,
		122,
		137,
		148,
		139,
		147,
		141,
		144,
		-1,
		-1,
		149,
		132,
		-1,
		-1,
		106,
		108,
		-1,
		59,
		48,
		33,
		25,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		88,
		126,
		125,
		133,
		128,
		133,
		145,
		141,
		137,
		147,
		138,
		-1,
		-1,
		127,
		119,
		113,
		-1,
		91,
		-1,
		83,
		-1,
		28,
		44,
		46,
		-1,
		-1,
		-1,
		119,
		82,
		98,
		121,
		147,
		145,
		136,
		129,
		136,
		139,
		132,
		138,
		-1,
		-1,
		-1,
		109,
		83,
		90,
		81,
		64,
		44,
		36,
		61,
		-1,
		100,
		-1,
		75,
		78,
		103,
		142,
		144,
		130,
		126,
		139,
		133,
		130,
		128,
		115,
		-1,
		85,
		118,
		82,
		50,
		50,
		49,
		114,
		-1,
		97,
		79,
		-1,
		107,
		97,
		145,
		120,
		129,
		122,
		116,
		117,
		125,
		-1,
		-1,
		-1,
		87,
		86,
		78,
		72,
		70,
		55,
		50,
		-1,
		102,
		84,
		70,
		87,
		87,
		78,
		86,
		135,
		131,
		134,
		132,
		110,
		-1,
		201,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		81,
		90,
		63,
		51,
		65,
		72,
		67,
		69,
		82,
		90,
		88,
		85,
		97,
		93,
		113,
		109,
		141,
		-1,
		196,
		-1,
		117,
		-1,
		-1,
		97,
		83,
		85,
		74,
		63,
		61,
		64,
		62,
		84,
		114,
		100,
		98,
		103,
		108,
		-1,
		185,
		184,
		-1,
		116,
		108,
		94,
		-1,
		87,
		-1,
		109,
		70,
		-1,
		91,
		71,
		-1,
		109,
		105,
		-1,
		-1,
		172,
		132,
		-1,
		-1,
		-1,
		117,
		97,
		104,
		88,
		-1,
		82,
		82,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		110,
		113,
		-1,
		104,
		110,
		137,
		84,
		88,
		-1,
		-1,
		-1,
		166,
		147,
		141,
		125,
		130,
		118,
		135,
		121,
		120,
		98,
		87,
		108,
		-1,
		-1,
		-1,
		138,
		130,
		130,
		-1,
		-1,
		145,
		128,
		109,
		107,
		-1,
		-1,
		-1,
		160,
		141,
		-1,
		-1,
		135,
		-1,
		-1,
		141,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		149,
		-1,
		-1,
		-1,
		131,
		127,
		128,
		-1,
		-1,
		-1,
		-1,
		170,
		171,
		195,
		170,
		-1,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		173,
		171,
		-1,
		-1,
		-1,
		151,
		135,
		-1,
		121,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		156,
		-1,
		156,
		131,
		138,
		-1,
		-1,
		-1,
		-1,
		169,
		161,
		169,
		-1,
		141,
		143,
		-1,
		191,
		-1,
		-1,
		184,
		175,
		-1,
		-1,
		146,
		153,
		175,
		178,
		214,
		-1,
		165
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		261,
		250,
		261,
		269,
		242,
		249,
		-1,
		268,
		272,
		238,
		232,
		271,
		240,
		246,
		257,
		-1,
		-1,
		-1,
		261,
		260,
		228,
		226,
		235,
		240,
		247,
		-1,
		246,
		-1,
		282,
		261,
		272,
		277,
		221,
		218,
		238,
		257,
		239,
		231,
		297,
		251,
		222,
		216,
		234,
		224,
		233,
		225,
		-1,
		222,
		212,
		234,
		213,
		224,
		216,
		-1,
		-1,
		216,
		217,
		223,
		209,
		215,
		211,
		-1,
		221,
		205,
		-1,
		-1,
		206,
		207,
		191,
		194,
		202,
		200,
		213,
		205,
		200,
		-1,
		-1,
		197,
		193,
		200,
		187,
		183,
		200,
		213,
		195,
		209,
		208,
		-1,
		201,
		219,
		226,
		194,
		192,
		176,
		174,
		192,
		194,
		200,
		200,
		-1,
		210,
		211,
		206,
		214,
		216,
		192,
		179,
		179,
		189,
		182,
		201,
		189,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		210,
		193,
		210,
		202,
		192,
		207,
		200,
		182,
		179,
		177,
		174,
		190,
		188,
		198,
		-1,
		-1,
		303,
		272,
		301,
		259,
		240,
		-1,
		206,
		186,
		192,
		196,
		190,
		183,
		197,
		193,
		-1,
		168,
		167,
		195,
		181,
		192,
		263,
		-1,
		-1,
		261,
		253,
		236,
		239,
		216,
		212,
		201,
		200,
		192,
		178,
		174,
		180,
		183,
		183,
		189,
		162,
		172,
		176,
		174,
		199,
		-1,
		-1,
		234,
		-1,
		-1,
		260,
		243,
		-1,
		226,
		233,
		222,
		228,
		214,
		235,
		211,
		202,
		194,
		188,
		176,
		178,
		175,
		188,
		176,
		159,
		184,
		188,
		169,
		190,
		185,
		-1,
		233,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		219,
		222,
		228,
		252,
		251,
		-1,
		223,
		211,
		212,
		197,
		194,
		181,
		169,
		182,
		167,
		174,
		173,
		163,
		161,
		191,
		166,
		188,
		185,
		204,
		209,
		203,
		212,
		-1,
		268,
		264,
		260,
		267,
		216,
		-1,
		-1,
		256,
		-1,
		259,
		260,
		235,
		208,
		211,
		198,
		189,
		176,
		165,
		176,
		165,
		162,
		170,
		155,
		170,
		161,
		160,
		178,
		188,
		196,
		200,
		206,
		-1,
		318,
		-1,
		260,
		244,
		246,
		218,
		239,
		-1,
		276,
		260,
		252,
		237,
		237,
		-1,
		207,
		204,
		194,
		172,
		157,
		174,
		166,
		164,
		168,
		150,
		164,
		155,
		173,
		180,
		178,
		182,
		202,
		214,
		278,
		268,
		-1,
		250,
		255,
		214,
		222,
		241,
		279,
		243,
		-1,
		238,
		-1,
		209,
		222,
		-1,
		178,
		174,
		156,
		157,
		152,
		167,
		161,
		146,
		143,
		161,
		164,
		171,
		175,
		191,
		-1,
		-1,
		263,
		267,
		256,
		207,
		226,
		250,
		287,
		236,
		225,
		224,
		-1,
		215,
		192,
		189,
		177,
		164,
		149,
		150,
		158,
		171,
		150,
		145,
		142,
		162,
		188,
		166,
		178,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		233,
		204,
		228,
		270,
		254,
		247,
		235,
		200,
		200,
		194,
		-1,
		188,
		167,
		158,
		147,
		145,
		158,
		155,
		160,
		140,
		138,
		157,
		169,
		160,
		177,
		-1,
		-1,
		-1,
		263,
		252,
		253,
		199,
		222,
		259,
		233,
		219,
		224,
		199,
		192,
		186,
		201,
		184,
		165,
		154,
		146,
		135,
		151,
		159,
		154,
		136,
		145,
		151,
		175,
		165,
		171,
		-1,
		-1,
		270,
		260,
		244,
		246,
		243,
		213,
		220,
		252,
		224,
		237,
		-1,
		191,
		-1,
		180,
		175,
		159,
		154,
		151,
		148,
		142,
		151,
		153,
		143,
		138,
		145,
		180,
		180,
		155,
		175,
		178,
		-1,
		-1,
		-1,
		263,
		258,
		233,
		210,
		194,
		230,
		-1,
		207,
		208,
		-1,
		185,
		179,
		176,
		161,
		157,
		152,
		156,
		149,
		156,
		149,
		147,
		148,
		130,
		162,
		-1,
		163,
		157,
		165,
		155,
		143,
		-1,
		-1,
		-1,
		256,
		235,
		228,
		248,
		189,
		241,
		-1,
		-1,
		192,
		185,
		-1,
		172,
		154,
		161,
		159,
		153,
		157,
		154,
		143,
		156,
		149,
		135,
		137,
		150,
		154,
		158,
		145,
		141,
		138,
		152,
		-1,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		209,
		-1,
		201,
		193,
		183,
		177,
		171,
		167,
		165,
		181,
		165,
		168,
		166,
		157,
		165,
		138,
		131,
		138,
		127,
		145,
		153,
		145,
		139,
		138,
		148,
		-1,
		276,
		262,
		233,
		-1,
		-1,
		222,
		-1,
		186,
		200,
		216,
		-1,
		209,
		188,
		203,
		181,
		177,
		173,
		188,
		189,
		167,
		166,
		164,
		155,
		143,
		132,
		135,
		127,
		149,
		149,
		133,
		134,
		138,
		-1,
		282,
		269,
		227,
		223,
		212,
		232,
		183,
		171,
		203,
		-1,
		-1,
		245,
		-1,
		179,
		196,
		187,
		185,
		178,
		163,
		170,
		175,
		152,
		147,
		137,
		126,
		126,
		121,
		143,
		129,
		127,
		136,
		152,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		198,
		185,
		179,
		-1,
		220,
		-1,
		223,
		213,
		197,
		182,
		215,
		-1,
		162,
		158,
		165,
		-1,
		172,
		-1,
		145,
		142,
		133,
		118,
		115,
		126,
		124,
		135,
		131,
		-1,
		232,
		217,
		210,
		200,
		214,
		185,
		-1,
		240,
		-1,
		-1,
		210,
		204,
		204,
		188,
		191,
		178,
		158,
		150,
		165,
		164,
		151,
		150,
		131,
		124,
		121,
		114,
		127,
		137,
		142,
		129,
		-1,
		-1,
		-1,
		237,
		223,
		227,
		187,
		206,
		-1,
		-1,
		272,
		227,
		213,
		-1,
		187,
		178,
		166,
		156,
		146,
		151,
		152,
		142,
		140,
		129,
		131,
		125,
		116,
		115,
		131,
		123,
		145,
		-1,
		-1,
		220,
		225,
		213,
		199,
		218,
		-1,
		-1,
		-1,
		219,
		235,
		206,
		185,
		167,
		-1,
		-1,
		150,
		143,
		137,
		140,
		128,
		145,
		140,
		124,
		109,
		124,
		128,
		136,
		127,
		-1,
		223,
		210,
		-1,
		-1,
		220,
		210,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		149,
		-1,
		123,
		134,
		127,
		146,
		153,
		126,
		111,
		105,
		111,
		123,
		132,
		-1,
		-1,
		234,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		125,
		127,
		124,
		136,
		129,
		126,
		117,
		108,
		104,
		108,
		112,
		126,
		130,
		257,
		-1,
		187,
		-1,
		-1,
		-1,
		193,
		208,
		179,
		156,
		129,
		124,
		117,
		111,
		116,
		127,
		136,
		147,
		112,
		111,
		101,
		100,
		104,
		121,
		125,
		-1,
		-1,
		185,
		181,
		216,
		201,
		192,
		206,
		-1,
		-1,
		133,
		124,
		115,
		107,
		120,
		123,
		108,
		110,
		110,
		105,
		99,
		109,
		124,
		119,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		182,
		204,
		151,
		133,
		129,
		123,
		114,
		108,
		98,
		103,
		113,
		107,
		104,
		95,
		99,
		122,
		111,
		150,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		176,
		168,
		162,
		165,
		166,
		157,
		166,
		163,
		-1,
		119,
		137,
		104,
		111,
		94,
		101,
		106,
		103,
		89,
		96,
		112,
		111,
		106,
		142,
		133,
		139,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		169,
		165,
		151,
		141,
		143,
		-1,
		-1,
		136,
		133,
		128,
		97,
		102,
		95,
		90,
		95,
		76,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		130,
		145,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		159,
		151,
		161,
		137,
		134,
		-1,
		-1,
		109,
		111,
		116,
		104,
		101,
		114,
		113,
		80,
		85,
		103,
		90,
		91,
		109,
		113,
		122,
		129,
		119,
		132,
		136,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		156,
		-1,
		-1,
		168,
		135,
		119,
		113,
		108,
		163,
		110,
		105,
		82,
		80,
		77,
		68,
		106,
		85,
		97,
		100,
		116,
		121,
		113,
		129,
		129,
		130,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		166,
		-1,
		146,
		-1,
		81,
		110,
		118,
		121,
		96,
		83,
		69,
		77,
		83,
		83,
		88,
		91,
		103,
		112,
		123,
		135,
		136,
		137,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		168,
		207,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		63,
		131,
		123,
		116,
		95,
		95,
		61,
		65,
		78,
		85,
		95,
		109,
		106,
		116,
		129,
		140,
		145,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		183,
		174,
		201,
		179,
		168,
		163,
		150,
		-1,
		-1,
		41,
		141,
		-1,
		-1,
		102,
		69,
		57,
		67,
		71,
		85,
		97,
		110,
		98,
		117,
		111,
		143,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		186,
		202,
		201,
		205,
		210,
		235,
		-1,
		139,
		-1,
		-1,
		21,
		-1,
		-1,
		50,
		74,
		63,
		54,
		59,
		79,
		90,
		112,
		94,
		111,
		116,
		126,
		139,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		224,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		0,
		7,
		35,
		-1,
		60,
		51,
		56,
		86,
		88,
		90,
		97,
		91,
		98,
		124,
		136,
		138,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		7,
		14,
		22,
		33,
		46,
		56,
		73,
		73,
		76,
		81,
		89,
		100,
		114,
		118,
		132,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		57,
		41,
		22,
		-1,
		56,
		69,
		109,
		77,
		82,
		77,
		95,
		106,
		117,
		120,
		125,
		128,
		-1,
		-1,
		188,
		178,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		29,
		25,
		-1,
		-1,
		57,
		91,
		80,
		88,
		83,
		95,
		105,
		103,
		115,
		123,
		122,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		95,
		58,
		79,
		98,
		103,
		101,
		92,
		91,
		98,
		108,
		116,
		122,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		94,
		-1,
		62,
		59,
		100,
		97,
		114,
		108,
		94,
		109,
		105,
		114,
		112,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		91,
		70,
		-1,
		104,
		94,
		131,
		117,
		105,
		92,
		99,
		113,
		109,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		84,
		84,
		75,
		83,
		121,
		117,
		110,
		112,
		104,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		79,
		87,
		85,
		82,
		94,
		90,
		110,
		105,
		138,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		113,
		97,
		95,
		100,
		105,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		106,
		102,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		260,
		249,
		260,
		268,
		241,
		248,
		-1,
		267,
		271,
		237,
		231,
		270,
		239,
		245,
		256,
		-1,
		-1,
		-1,
		260,
		259,
		227,
		225,
		234,
		239,
		246,
		-1,
		245,
		-1,
		281,
		260,
		271,
		276,
		220,
		217,
		237,
		256,
		238,
		230,
		296,
		250,
		221,
		215,
		233,
		223,
		232,
		224,
		-1,
		221,
		211,
		233,
		212,
		223,
		215,
		-1,
		-1,
		215,
		216,
		222,
		208,
		214,
		210,
		-1,
		220,
		204,
		-1,
		-1,
		205,
		206,
		190,
		193,
		201,
		199,
		212,
		204,
		199,
		-1,
		-1,
		196,
		192,
		199,
		186,
		182,
		199,
		212,
		194,
		208,
		207,
		-1,
		200,
		218,
		225,
		193,
		191,
		175,
		173,
		191,
		193,
		199,
		199,
		-1,
		209,
		210,
		205,
		213,
		215,
		191,
		178,
		178,
		188,
		181,
		200,
		188,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		209,
		192,
		209,
		201,
		191,
		206,
		199,
		181,
		178,
		176,
		173,
		189,
		187,
		197,
		-1,
		-1,
		302,
		271,
		300,
		258,
		239,
		-1,
		205,
		185,
		191,
		195,
		189,
		182,
		196,
		192,
		-1,
		167,
		166,
		194,
		180,
		191,
		262,
		-1,
		-1,
		260,
		252,
		235,
		238,
		215,
		211,
		200,
		199,
		191,
		177,
		173,
		179,
		182,
		182,
		188,
		161,
		171,
		175,
		173,
		198,
		-1,
		-1,
		233,
		-1,
		-1,
		259,
		242,
		-1,
		225,
		232,
		221,
		227,
		213,
		234,
		210,
		201,
		193,
		187,
		175,
		177,
		174,
		187,
		175,
		158,
		183,
		187,
		168,
		189,
		184,
		-1,
		232,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		218,
		221,
		227,
		251,
		250,
		-1,
		222,
		210,
		211,
		196,
		193,
		180,
		168,
		181,
		166,
		173,
		172,
		162,
		160,
		190,
		165,
		187,
		184,
		203,
		208,
		202,
		211,
		-1,
		267,
		263,
		259,
		266,
		215,
		-1,
		-1,
		255,
		-1,
		258,
		259,
		234,
		207,
		210,
		197,
		188,
		175,
		164,
		175,
		164,
		161,
		169,
		154,
		169,
		160,
		159,
		177,
		187,
		195,
		199,
		205,
		-1,
		317,
		-1,
		259,
		243,
		245,
		217,
		238,
		-1,
		275,
		259,
		251,
		236,
		236,
		-1,
		206,
		203,
		193,
		171,
		156,
		173,
		165,
		163,
		167,
		149,
		163,
		154,
		172,
		179,
		177,
		181,
		201,
		213,
		277,
		267,
		-1,
		249,
		254,
		213,
		221,
		240,
		278,
		242,
		-1,
		237,
		-1,
		208,
		221,
		-1,
		177,
		173,
		155,
		156,
		151,
		166,
		160,
		145,
		142,
		160,
		163,
		170,
		174,
		190,
		-1,
		-1,
		262,
		266,
		255,
		206,
		225,
		249,
		286,
		235,
		224,
		223,
		-1,
		214,
		191,
		188,
		176,
		163,
		148,
		149,
		157,
		170,
		149,
		144,
		141,
		161,
		187,
		165,
		177,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		232,
		203,
		227,
		269,
		253,
		246,
		234,
		199,
		199,
		193,
		-1,
		187,
		166,
		157,
		146,
		144,
		157,
		154,
		159,
		139,
		137,
		156,
		168,
		159,
		176,
		-1,
		-1,
		-1,
		262,
		251,
		252,
		198,
		221,
		258,
		232,
		218,
		223,
		198,
		191,
		185,
		200,
		183,
		164,
		153,
		145,
		134,
		150,
		158,
		153,
		135,
		144,
		150,
		174,
		164,
		170,
		-1,
		-1,
		269,
		259,
		243,
		245,
		242,
		212,
		219,
		251,
		223,
		236,
		-1,
		190,
		-1,
		179,
		174,
		158,
		153,
		150,
		147,
		141,
		150,
		152,
		142,
		137,
		144,
		179,
		179,
		154,
		174,
		177,
		-1,
		-1,
		-1,
		262,
		257,
		232,
		209,
		193,
		229,
		-1,
		206,
		207,
		-1,
		184,
		178,
		175,
		160,
		156,
		151,
		155,
		148,
		155,
		148,
		146,
		147,
		129,
		161,
		-1,
		162,
		156,
		164,
		154,
		142,
		-1,
		-1,
		-1,
		255,
		234,
		227,
		247,
		188,
		240,
		-1,
		-1,
		191,
		184,
		-1,
		171,
		153,
		160,
		158,
		152,
		156,
		153,
		142,
		155,
		148,
		134,
		136,
		149,
		153,
		157,
		144,
		140,
		137,
		151,
		-1,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		208,
		-1,
		200,
		192,
		182,
		176,
		170,
		166,
		164,
		180,
		164,
		167,
		165,
		156,
		164,
		137,
		130,
		137,
		126,
		144,
		152,
		144,
		138,
		137,
		147,
		-1,
		275,
		261,
		232,
		-1,
		-1,
		221,
		-1,
		185,
		199,
		215,
		-1,
		208,
		187,
		202,
		180,
		176,
		172,
		187,
		188,
		166,
		165,
		163,
		154,
		142,
		131,
		134,
		126,
		148,
		148,
		132,
		133,
		137,
		-1,
		281,
		268,
		226,
		222,
		211,
		231,
		182,
		170,
		202,
		-1,
		-1,
		244,
		-1,
		178,
		195,
		186,
		184,
		177,
		162,
		169,
		174,
		151,
		146,
		136,
		125,
		125,
		120,
		142,
		128,
		126,
		135,
		151,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		197,
		184,
		178,
		-1,
		219,
		-1,
		222,
		212,
		196,
		181,
		214,
		-1,
		161,
		157,
		164,
		-1,
		171,
		-1,
		144,
		141,
		132,
		117,
		114,
		125,
		123,
		134,
		130,
		-1,
		231,
		216,
		209,
		199,
		213,
		184,
		-1,
		239,
		-1,
		-1,
		209,
		203,
		203,
		187,
		190,
		177,
		157,
		149,
		164,
		163,
		150,
		149,
		130,
		123,
		120,
		113,
		126,
		136,
		141,
		128,
		-1,
		-1,
		-1,
		236,
		222,
		226,
		186,
		205,
		-1,
		-1,
		271,
		226,
		212,
		-1,
		186,
		177,
		165,
		155,
		145,
		150,
		151,
		141,
		139,
		128,
		130,
		124,
		115,
		114,
		130,
		122,
		144,
		-1,
		-1,
		219,
		224,
		212,
		198,
		217,
		-1,
		-1,
		-1,
		218,
		234,
		205,
		184,
		166,
		-1,
		-1,
		149,
		142,
		136,
		139,
		127,
		144,
		139,
		123,
		108,
		123,
		127,
		135,
		126,
		-1,
		222,
		209,
		-1,
		-1,
		220,
		214,
		-1,
		-1,
		-1,
		-1,
		217,
		162,
		151,
		146,
		150,
		148,
		-1,
		122,
		133,
		126,
		145,
		152,
		125,
		110,
		104,
		110,
		122,
		131,
		-1,
		-1,
		234,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		174,
		168,
		139,
		132,
		136,
		-1,
		124,
		126,
		123,
		135,
		128,
		125,
		116,
		107,
		103,
		107,
		111,
		125,
		129,
		257,
		-1,
		191,
		-1,
		-1,
		-1,
		192,
		207,
		178,
		155,
		128,
		123,
		116,
		110,
		115,
		126,
		135,
		146,
		111,
		110,
		100,
		99,
		103,
		120,
		124,
		-1,
		-1,
		189,
		185,
		218,
		200,
		196,
		205,
		-1,
		-1,
		132,
		123,
		114,
		106,
		119,
		122,
		107,
		109,
		109,
		104,
		98,
		108,
		123,
		118,
		-1,
		-1,
		-1,
		201,
		-1,
		203,
		-1,
		-1,
		186,
		203,
		150,
		132,
		128,
		126,
		113,
		107,
		97,
		102,
		112,
		106,
		103,
		94,
		98,
		121,
		110,
		149,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		180,
		172,
		166,
		169,
		170,
		161,
		165,
		162,
		-1,
		123,
		136,
		103,
		110,
		93,
		100,
		105,
		102,
		88,
		95,
		111,
		110,
		105,
		141,
		132,
		138,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		173,
		169,
		155,
		145,
		147,
		-1,
		-1,
		140,
		137,
		127,
		96,
		101,
		94,
		89,
		94,
		75,
		84,
		88,
		92,
		98,
		103,
		108,
		114,
		129,
		144,
		-1,
		224,
		261,
		254,
		222,
		230,
		261,
		-1,
		163,
		155,
		165,
		141,
		138,
		-1,
		-1,
		113,
		114,
		115,
		103,
		100,
		113,
		112,
		79,
		84,
		102,
		89,
		90,
		108,
		112,
		121,
		128,
		118,
		131,
		135,
		-1,
		217,
		237,
		216,
		219,
		243,
		257,
		-1,
		160,
		-1,
		-1,
		172,
		139,
		123,
		117,
		112,
		162,
		109,
		104,
		81,
		79,
		76,
		67,
		105,
		84,
		96,
		99,
		115,
		120,
		112,
		128,
		128,
		129,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		165,
		-1,
		150,
		-1,
		85,
		114,
		117,
		120,
		95,
		82,
		68,
		76,
		82,
		82,
		87,
		90,
		102,
		111,
		122,
		134,
		135,
		136,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		172,
		211,
		171,
		-1,
		155,
		-1,
		-1,
		-1,
		67,
		130,
		122,
		115,
		94,
		94,
		60,
		64,
		77,
		84,
		94,
		108,
		105,
		115,
		128,
		139,
		144,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		187,
		178,
		205,
		178,
		167,
		162,
		149,
		-1,
		-1,
		45,
		140,
		-1,
		-1,
		101,
		68,
		56,
		66,
		70,
		84,
		96,
		109,
		97,
		116,
		110,
		142,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		206,
		200,
		204,
		209,
		234,
		-1,
		138,
		-1,
		-1,
		25,
		-1,
		-1,
		49,
		73,
		62,
		53,
		58,
		78,
		89,
		111,
		93,
		110,
		115,
		125,
		138,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		223,
		-1,
		-1,
		154,
		134,
		-1,
		-1,
		8,
		0,
		34,
		-1,
		59,
		50,
		55,
		85,
		87,
		89,
		96,
		90,
		97,
		123,
		135,
		137,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		140,
		-1,
		-1,
		7,
		13,
		21,
		32,
		45,
		55,
		72,
		72,
		75,
		80,
		88,
		99,
		113,
		117,
		131,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		56,
		40,
		21,
		-1,
		55,
		68,
		108,
		76,
		81,
		76,
		94,
		105,
		116,
		119,
		124,
		127,
		-1,
		-1,
		187,
		177,
		-1,
		-1,
		151,
		153,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		28,
		24,
		-1,
		-1,
		56,
		90,
		79,
		87,
		82,
		94,
		104,
		102,
		114,
		122,
		121,
		-1,
		-1,
		172,
		164,
		158,
		-1,
		136,
		-1,
		154,
		-1,
		121,
		127,
		115,
		-1,
		-1,
		-1,
		94,
		57,
		78,
		97,
		102,
		100,
		91,
		90,
		97,
		107,
		115,
		121,
		-1,
		-1,
		-1,
		154,
		128,
		161,
		152,
		135,
		115,
		107,
		126,
		-1,
		93,
		-1,
		61,
		58,
		99,
		96,
		113,
		107,
		93,
		108,
		104,
		113,
		111,
		160,
		-1,
		130,
		163,
		127,
		121,
		97,
		101,
		117,
		-1,
		90,
		69,
		-1,
		103,
		93,
		130,
		116,
		104,
		91,
		98,
		112,
		108,
		-1,
		-1,
		-1,
		132,
		131,
		123,
		117,
		117,
		102,
		93,
		-1,
		105,
		87,
		66,
		83,
		83,
		74,
		82,
		120,
		116,
		109,
		111,
		103,
		-1,
		233,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		126,
		121,
		94,
		82,
		88,
		84,
		70,
		76,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		104,
		137,
		-1,
		228,
		-1,
		162,
		-1,
		-1,
		144,
		124,
		116,
		105,
		94,
		92,
		83,
		74,
		96,
		112,
		96,
		94,
		99,
		104,
		-1,
		217,
		216,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		140,
		101,
		-1,
		103,
		83,
		-1,
		105,
		101,
		-1,
		-1,
		204,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		135,
		119,
		-1,
		94,
		94,
		-1,
		-1,
		-1,
		189,
		188,
		-1,
		157,
		160,
		-1,
		150,
		141,
		149,
		96,
		100,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		172,
		170,
		165,
		162,
		148,
		132,
		110,
		99,
		120,
		-1,
		-1,
		-1,
		170,
		162,
		155,
		-1,
		-1,
		157,
		140,
		121,
		119,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		147,
		-1,
		-1,
		153,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		181,
		-1,
		-1,
		-1,
		143,
		139,
		140,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		227,
		191,
		-1,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		133,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		168,
		-1,
		168,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		173,
		181,
		-1,
		153,
		155,
		-1,
		203,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		158,
		165,
		187,
		190,
		226,
		-1,
		177
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		259,
		263,
		229,
		223,
		262,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		252,
		251,
		219,
		217,
		226,
		231,
		238,
		-1,
		237,
		-1,
		273,
		252,
		263,
		268,
		212,
		209,
		229,
		248,
		230,
		222,
		288,
		242,
		213,
		207,
		225,
		215,
		224,
		216,
		-1,
		213,
		203,
		225,
		204,
		215,
		207,
		-1,
		-1,
		207,
		208,
		214,
		200,
		206,
		202,
		-1,
		212,
		196,
		-1,
		-1,
		197,
		198,
		182,
		185,
		193,
		191,
		204,
		196,
		191,
		-1,
		-1,
		188,
		184,
		191,
		178,
		174,
		191,
		204,
		186,
		200,
		199,
		-1,
		192,
		210,
		217,
		185,
		183,
		167,
		165,
		183,
		185,
		191,
		191,
		-1,
		201,
		202,
		197,
		205,
		207,
		183,
		170,
		170,
		180,
		173,
		192,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		201,
		184,
		201,
		193,
		183,
		198,
		191,
		173,
		170,
		168,
		165,
		181,
		179,
		189,
		-1,
		-1,
		294,
		263,
		292,
		250,
		231,
		-1,
		197,
		177,
		183,
		187,
		181,
		174,
		188,
		184,
		-1,
		159,
		158,
		186,
		172,
		183,
		254,
		-1,
		-1,
		252,
		244,
		227,
		230,
		207,
		203,
		192,
		191,
		183,
		169,
		165,
		171,
		174,
		174,
		180,
		153,
		163,
		167,
		165,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		251,
		234,
		-1,
		217,
		224,
		213,
		219,
		205,
		226,
		202,
		193,
		185,
		179,
		167,
		169,
		166,
		179,
		167,
		150,
		175,
		179,
		160,
		181,
		176,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		210,
		213,
		219,
		243,
		242,
		-1,
		214,
		202,
		203,
		188,
		185,
		172,
		160,
		173,
		158,
		165,
		164,
		154,
		152,
		182,
		157,
		179,
		176,
		195,
		200,
		194,
		203,
		-1,
		259,
		255,
		251,
		258,
		207,
		-1,
		-1,
		247,
		-1,
		250,
		251,
		226,
		199,
		202,
		189,
		180,
		167,
		156,
		167,
		156,
		153,
		161,
		146,
		161,
		152,
		151,
		169,
		179,
		187,
		191,
		197,
		-1,
		309,
		-1,
		251,
		235,
		237,
		209,
		230,
		-1,
		267,
		251,
		243,
		228,
		228,
		-1,
		198,
		195,
		185,
		163,
		148,
		165,
		157,
		155,
		159,
		141,
		155,
		146,
		164,
		171,
		169,
		173,
		193,
		205,
		269,
		259,
		-1,
		241,
		246,
		205,
		213,
		232,
		270,
		234,
		-1,
		229,
		-1,
		200,
		213,
		-1,
		169,
		165,
		147,
		148,
		143,
		158,
		152,
		137,
		134,
		152,
		155,
		162,
		166,
		182,
		-1,
		-1,
		254,
		258,
		247,
		198,
		217,
		241,
		278,
		227,
		216,
		215,
		-1,
		206,
		183,
		180,
		168,
		155,
		140,
		141,
		149,
		162,
		141,
		136,
		133,
		153,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		224,
		195,
		219,
		261,
		245,
		238,
		226,
		191,
		191,
		185,
		-1,
		179,
		158,
		149,
		138,
		136,
		149,
		146,
		151,
		131,
		129,
		148,
		160,
		151,
		168,
		-1,
		-1,
		-1,
		254,
		243,
		244,
		190,
		213,
		250,
		224,
		210,
		215,
		190,
		183,
		177,
		192,
		175,
		156,
		145,
		137,
		126,
		142,
		150,
		145,
		127,
		136,
		142,
		166,
		156,
		162,
		-1,
		-1,
		261,
		251,
		235,
		237,
		234,
		204,
		211,
		243,
		215,
		228,
		-1,
		182,
		-1,
		171,
		166,
		150,
		145,
		142,
		139,
		133,
		142,
		144,
		134,
		129,
		136,
		171,
		171,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		254,
		249,
		224,
		201,
		185,
		221,
		-1,
		198,
		199,
		-1,
		176,
		170,
		167,
		152,
		148,
		143,
		147,
		140,
		147,
		140,
		138,
		139,
		121,
		153,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		247,
		226,
		219,
		239,
		180,
		232,
		-1,
		-1,
		183,
		176,
		-1,
		163,
		145,
		152,
		150,
		144,
		148,
		145,
		134,
		147,
		140,
		126,
		128,
		141,
		145,
		149,
		136,
		132,
		129,
		143,
		-1,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		200,
		-1,
		192,
		184,
		174,
		168,
		162,
		158,
		156,
		172,
		156,
		159,
		157,
		148,
		156,
		129,
		122,
		129,
		118,
		136,
		144,
		136,
		130,
		129,
		139,
		-1,
		267,
		253,
		224,
		-1,
		-1,
		213,
		-1,
		177,
		191,
		207,
		-1,
		200,
		179,
		194,
		172,
		168,
		164,
		179,
		180,
		158,
		157,
		155,
		146,
		134,
		123,
		126,
		118,
		140,
		140,
		124,
		125,
		129,
		-1,
		273,
		260,
		218,
		214,
		203,
		223,
		174,
		162,
		194,
		-1,
		-1,
		236,
		-1,
		170,
		187,
		178,
		176,
		169,
		154,
		161,
		166,
		143,
		138,
		128,
		117,
		117,
		112,
		134,
		120,
		118,
		127,
		143,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		189,
		176,
		170,
		-1,
		211,
		-1,
		214,
		204,
		188,
		173,
		206,
		-1,
		153,
		149,
		156,
		-1,
		163,
		-1,
		136,
		133,
		124,
		109,
		106,
		117,
		115,
		126,
		122,
		-1,
		223,
		208,
		201,
		191,
		205,
		176,
		-1,
		231,
		-1,
		-1,
		201,
		195,
		195,
		179,
		182,
		169,
		149,
		141,
		156,
		155,
		142,
		141,
		122,
		115,
		112,
		105,
		118,
		128,
		133,
		120,
		-1,
		-1,
		-1,
		228,
		214,
		218,
		178,
		197,
		-1,
		-1,
		263,
		218,
		204,
		-1,
		178,
		169,
		157,
		147,
		137,
		142,
		143,
		133,
		131,
		120,
		122,
		116,
		107,
		106,
		122,
		114,
		136,
		-1,
		-1,
		211,
		216,
		204,
		190,
		209,
		-1,
		-1,
		-1,
		210,
		226,
		197,
		176,
		158,
		-1,
		-1,
		141,
		134,
		128,
		131,
		119,
		136,
		131,
		115,
		100,
		115,
		119,
		127,
		118,
		-1,
		214,
		201,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		118,
		137,
		144,
		117,
		102,
		96,
		102,
		114,
		123,
		-1,
		-1,
		226,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		115,
		127,
		120,
		117,
		108,
		99,
		95,
		99,
		103,
		117,
		121,
		249,
		-1,
		187,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		127,
		138,
		103,
		102,
		92,
		91,
		95,
		112,
		116,
		-1,
		-1,
		185,
		181,
		210,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		99,
		101,
		101,
		96,
		90,
		100,
		115,
		110,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		195,
		142,
		124,
		120,
		118,
		105,
		99,
		89,
		94,
		104,
		98,
		95,
		86,
		90,
		113,
		102,
		141,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		157,
		154,
		-1,
		124,
		128,
		95,
		102,
		85,
		92,
		97,
		94,
		80,
		87,
		103,
		102,
		97,
		133,
		124,
		130,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		93,
		86,
		81,
		86,
		67,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		121,
		136,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		105,
		104,
		71,
		76,
		94,
		81,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		167,
		140,
		124,
		114,
		111,
		154,
		101,
		96,
		73,
		71,
		68,
		59,
		97,
		76,
		88,
		91,
		107,
		112,
		104,
		120,
		120,
		121,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		157,
		-1,
		151,
		-1,
		118,
		138,
		109,
		112,
		87,
		74,
		60,
		68,
		74,
		74,
		79,
		82,
		94,
		103,
		114,
		126,
		127,
		128,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		163,
		-1,
		147,
		-1,
		-1,
		-1,
		100,
		122,
		114,
		107,
		86,
		86,
		52,
		56,
		69,
		76,
		86,
		100,
		97,
		107,
		120,
		131,
		136,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		170,
		159,
		154,
		141,
		-1,
		-1,
		78,
		132,
		-1,
		-1,
		93,
		60,
		48,
		58,
		62,
		76,
		88,
		101,
		89,
		108,
		102,
		134,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		201,
		226,
		-1,
		130,
		-1,
		-1,
		58,
		-1,
		-1,
		15,
		65,
		54,
		45,
		50,
		70,
		81,
		103,
		85,
		102,
		107,
		117,
		130,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		215,
		-1,
		-1,
		146,
		126,
		-1,
		-1,
		41,
		39,
		0,
		-1,
		47,
		42,
		47,
		77,
		79,
		81,
		88,
		82,
		89,
		115,
		127,
		129,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		136,
		132,
		-1,
		-1,
		36,
		29,
		17,
		24,
		37,
		46,
		64,
		64,
		67,
		72,
		80,
		91,
		105,
		109,
		123,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		153,
		139,
		132,
		120,
		118,
		-1,
		70,
		54,
		35,
		-1,
		43,
		56,
		100,
		68,
		73,
		68,
		86,
		97,
		108,
		111,
		116,
		119,
		-1,
		-1,
		179,
		169,
		-1,
		-1,
		143,
		145,
		-1,
		144,
		133,
		118,
		110,
		-1,
		-1,
		42,
		38,
		-1,
		-1,
		48,
		82,
		71,
		79,
		74,
		86,
		96,
		94,
		106,
		114,
		113,
		-1,
		-1,
		164,
		156,
		150,
		-1,
		128,
		-1,
		146,
		-1,
		113,
		119,
		107,
		-1,
		-1,
		-1,
		86,
		49,
		70,
		89,
		94,
		92,
		83,
		82,
		89,
		99,
		107,
		113,
		-1,
		-1,
		-1,
		146,
		120,
		153,
		144,
		127,
		107,
		99,
		118,
		-1,
		85,
		-1,
		53,
		50,
		91,
		88,
		105,
		99,
		85,
		100,
		96,
		105,
		103,
		152,
		-1,
		122,
		155,
		119,
		113,
		89,
		93,
		109,
		-1,
		82,
		61,
		-1,
		95,
		85,
		122,
		108,
		96,
		83,
		90,
		104,
		100,
		-1,
		-1,
		-1,
		124,
		123,
		115,
		109,
		109,
		94,
		85,
		-1,
		97,
		79,
		58,
		75,
		75,
		66,
		74,
		112,
		108,
		101,
		103,
		95,
		-1,
		225,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		118,
		113,
		86,
		74,
		80,
		76,
		62,
		68,
		70,
		78,
		76,
		73,
		85,
		81,
		101,
		96,
		129,
		-1,
		220,
		-1,
		154,
		-1,
		-1,
		136,
		116,
		108,
		97,
		86,
		84,
		75,
		66,
		88,
		104,
		88,
		86,
		91,
		96,
		-1,
		209,
		208,
		-1,
		155,
		147,
		133,
		-1,
		126,
		-1,
		132,
		93,
		-1,
		95,
		75,
		-1,
		97,
		93,
		-1,
		-1,
		196,
		171,
		-1,
		-1,
		-1,
		156,
		136,
		127,
		111,
		-1,
		86,
		86,
		-1,
		-1,
		-1,
		181,
		180,
		-1,
		149,
		152,
		-1,
		142,
		133,
		141,
		88,
		92,
		-1,
		-1,
		-1,
		190,
		171,
		165,
		164,
		162,
		157,
		154,
		140,
		124,
		102,
		91,
		112,
		-1,
		-1,
		-1,
		162,
		154,
		147,
		-1,
		-1,
		149,
		132,
		113,
		111,
		-1,
		-1,
		-1,
		184,
		165,
		-1,
		-1,
		139,
		-1,
		-1,
		145,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		173,
		-1,
		-1,
		-1,
		135,
		131,
		132,
		-1,
		-1,
		-1,
		-1,
		195,
		196,
		219,
		183,
		-1,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		198,
		196,
		-1,
		-1,
		-1,
		155,
		139,
		-1,
		125,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		160,
		-1,
		160,
		135,
		142,
		-1,
		-1,
		-1,
		-1,
		173,
		165,
		173,
		-1,
		145,
		147,
		-1,
		195,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		150,
		157,
		179,
		182,
		218,
		-1,
		169
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		248,
		252,
		218,
		212,
		251,
		220,
		226,
		237,
		-1,
		-1,
		-1,
		241,
		240,
		208,
		206,
		215,
		220,
		227,
		-1,
		226,
		-1,
		262,
		241,
		252,
		257,
		201,
		198,
		218,
		237,
		219,
		211,
		277,
		231,
		202,
		196,
		214,
		204,
		213,
		205,
		-1,
		202,
		192,
		214,
		193,
		204,
		196,
		-1,
		-1,
		196,
		197,
		203,
		189,
		195,
		191,
		-1,
		201,
		185,
		-1,
		-1,
		186,
		187,
		171,
		174,
		182,
		180,
		193,
		185,
		180,
		-1,
		-1,
		177,
		173,
		180,
		167,
		163,
		180,
		193,
		175,
		189,
		188,
		-1,
		181,
		199,
		206,
		174,
		172,
		156,
		154,
		172,
		174,
		180,
		180,
		-1,
		190,
		191,
		186,
		194,
		196,
		172,
		159,
		159,
		169,
		162,
		181,
		169,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		190,
		173,
		190,
		182,
		172,
		187,
		180,
		162,
		159,
		157,
		154,
		170,
		168,
		178,
		-1,
		-1,
		283,
		252,
		281,
		239,
		220,
		-1,
		186,
		166,
		172,
		176,
		170,
		163,
		177,
		173,
		-1,
		148,
		147,
		175,
		161,
		172,
		243,
		-1,
		-1,
		241,
		233,
		216,
		219,
		196,
		192,
		181,
		180,
		172,
		158,
		154,
		160,
		163,
		163,
		169,
		142,
		152,
		156,
		154,
		179,
		-1,
		-1,
		214,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		202,
		208,
		194,
		215,
		191,
		182,
		174,
		168,
		156,
		158,
		155,
		168,
		156,
		139,
		164,
		168,
		149,
		170,
		165,
		-1,
		213,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		231,
		-1,
		203,
		191,
		192,
		177,
		174,
		161,
		149,
		162,
		147,
		154,
		153,
		143,
		141,
		171,
		146,
		168,
		165,
		184,
		189,
		183,
		192,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		239,
		240,
		215,
		188,
		191,
		178,
		169,
		156,
		145,
		156,
		145,
		142,
		150,
		135,
		150,
		141,
		140,
		158,
		168,
		176,
		180,
		186,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		240,
		232,
		217,
		217,
		-1,
		187,
		184,
		174,
		152,
		137,
		154,
		146,
		144,
		148,
		130,
		144,
		135,
		153,
		160,
		158,
		162,
		182,
		194,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		259,
		223,
		-1,
		218,
		-1,
		189,
		202,
		-1,
		158,
		154,
		136,
		137,
		132,
		147,
		141,
		126,
		123,
		141,
		144,
		151,
		155,
		171,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		216,
		205,
		204,
		-1,
		195,
		172,
		169,
		157,
		144,
		129,
		130,
		138,
		151,
		130,
		125,
		122,
		142,
		168,
		146,
		158,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		234,
		227,
		215,
		180,
		180,
		174,
		-1,
		168,
		147,
		138,
		127,
		125,
		138,
		135,
		140,
		120,
		118,
		137,
		149,
		140,
		157,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		179,
		202,
		239,
		213,
		199,
		204,
		179,
		172,
		166,
		181,
		164,
		145,
		134,
		126,
		115,
		131,
		139,
		134,
		116,
		125,
		131,
		155,
		145,
		151,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		193,
		200,
		232,
		204,
		217,
		-1,
		171,
		-1,
		160,
		155,
		139,
		134,
		131,
		128,
		122,
		131,
		133,
		123,
		118,
		125,
		160,
		160,
		135,
		155,
		158,
		-1,
		-1,
		-1,
		243,
		238,
		213,
		190,
		174,
		210,
		-1,
		187,
		188,
		-1,
		165,
		159,
		156,
		141,
		137,
		132,
		136,
		129,
		136,
		129,
		127,
		128,
		110,
		142,
		-1,
		143,
		137,
		145,
		135,
		123,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		172,
		165,
		-1,
		152,
		134,
		141,
		139,
		133,
		137,
		134,
		123,
		136,
		129,
		115,
		117,
		130,
		134,
		138,
		125,
		121,
		118,
		132,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		181,
		173,
		163,
		157,
		151,
		147,
		145,
		161,
		145,
		148,
		146,
		137,
		145,
		118,
		111,
		118,
		107,
		125,
		133,
		125,
		119,
		118,
		128,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		180,
		196,
		-1,
		189,
		168,
		183,
		161,
		157,
		153,
		168,
		169,
		147,
		146,
		144,
		135,
		123,
		112,
		115,
		107,
		129,
		129,
		113,
		114,
		118,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		151,
		183,
		-1,
		-1,
		225,
		-1,
		159,
		176,
		167,
		165,
		158,
		143,
		150,
		155,
		132,
		127,
		117,
		106,
		106,
		101,
		123,
		109,
		107,
		116,
		132,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		203,
		193,
		177,
		162,
		195,
		-1,
		142,
		138,
		145,
		-1,
		152,
		-1,
		125,
		122,
		113,
		98,
		95,
		106,
		104,
		115,
		111,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		220,
		-1,
		-1,
		190,
		184,
		184,
		168,
		171,
		158,
		138,
		130,
		145,
		144,
		131,
		130,
		111,
		104,
		101,
		94,
		107,
		117,
		122,
		109,
		-1,
		-1,
		-1,
		217,
		203,
		207,
		167,
		186,
		-1,
		-1,
		252,
		207,
		193,
		-1,
		167,
		158,
		146,
		136,
		126,
		131,
		132,
		122,
		120,
		109,
		111,
		105,
		96,
		95,
		111,
		103,
		125,
		-1,
		-1,
		200,
		205,
		193,
		179,
		198,
		-1,
		-1,
		-1,
		199,
		215,
		186,
		165,
		147,
		-1,
		-1,
		130,
		123,
		117,
		120,
		108,
		125,
		120,
		104,
		89,
		104,
		108,
		116,
		107,
		-1,
		203,
		190,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		-1,
		-1,
		198,
		143,
		132,
		127,
		131,
		129,
		-1,
		103,
		114,
		107,
		126,
		133,
		106,
		91,
		85,
		91,
		103,
		112,
		-1,
		-1,
		215,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		155,
		149,
		120,
		113,
		117,
		-1,
		105,
		107,
		104,
		116,
		109,
		106,
		97,
		88,
		84,
		88,
		92,
		106,
		110,
		238,
		-1,
		176,
		-1,
		-1,
		-1,
		173,
		188,
		159,
		136,
		109,
		104,
		97,
		91,
		96,
		107,
		116,
		127,
		92,
		91,
		81,
		80,
		84,
		101,
		105,
		-1,
		-1,
		174,
		170,
		199,
		181,
		185,
		186,
		-1,
		-1,
		113,
		104,
		95,
		87,
		100,
		103,
		88,
		90,
		90,
		85,
		79,
		89,
		104,
		99,
		-1,
		-1,
		-1,
		186,
		-1,
		188,
		-1,
		-1,
		176,
		184,
		131,
		113,
		109,
		107,
		94,
		88,
		78,
		83,
		93,
		87,
		84,
		75,
		79,
		102,
		91,
		130,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		165,
		157,
		152,
		158,
		160,
		151,
		146,
		143,
		-1,
		113,
		117,
		84,
		91,
		74,
		81,
		86,
		83,
		69,
		76,
		92,
		91,
		86,
		122,
		113,
		119,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		158,
		154,
		144,
		134,
		137,
		-1,
		-1,
		131,
		128,
		108,
		77,
		82,
		75,
		70,
		75,
		56,
		65,
		69,
		73,
		79,
		84,
		89,
		95,
		110,
		125,
		-1,
		205,
		242,
		235,
		203,
		211,
		242,
		-1,
		148,
		140,
		151,
		126,
		128,
		-1,
		-1,
		104,
		95,
		96,
		84,
		81,
		94,
		93,
		60,
		65,
		83,
		70,
		71,
		89,
		93,
		102,
		109,
		99,
		112,
		116,
		-1,
		198,
		218,
		197,
		200,
		224,
		238,
		-1,
		145,
		-1,
		-1,
		156,
		129,
		113,
		103,
		100,
		143,
		90,
		85,
		62,
		60,
		57,
		48,
		86,
		65,
		77,
		80,
		96,
		101,
		93,
		109,
		109,
		110,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		146,
		-1,
		140,
		-1,
		123,
		127,
		98,
		101,
		76,
		63,
		49,
		57,
		63,
		63,
		68,
		71,
		83,
		92,
		103,
		115,
		116,
		117,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		157,
		196,
		152,
		-1,
		136,
		-1,
		-1,
		-1,
		121,
		111,
		103,
		96,
		75,
		75,
		41,
		45,
		58,
		65,
		75,
		89,
		86,
		96,
		109,
		120,
		125,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		172,
		163,
		190,
		159,
		148,
		143,
		130,
		-1,
		-1,
		99,
		121,
		-1,
		-1,
		82,
		49,
		37,
		47,
		51,
		65,
		77,
		90,
		78,
		97,
		91,
		123,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		170,
		191,
		181,
		185,
		190,
		215,
		-1,
		119,
		-1,
		-1,
		79,
		-1,
		-1,
		60,
		54,
		43,
		34,
		39,
		59,
		70,
		92,
		74,
		91,
		96,
		106,
		119,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		157,
		155,
		161,
		168,
		185,
		204,
		-1,
		-1,
		135,
		115,
		-1,
		-1,
		62,
		60,
		45,
		-1,
		0,
		30,
		36,
		66,
		68,
		70,
		77,
		71,
		78,
		104,
		116,
		118,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		125,
		121,
		-1,
		-1,
		57,
		50,
		38,
		26,
		26,
		33,
		53,
		53,
		56,
		61,
		69,
		80,
		94,
		98,
		112,
		-1,
		228,
		-1,
		180,
		156,
		170,
		185,
		193,
		-1,
		-1,
		-1,
		142,
		128,
		121,
		109,
		107,
		-1,
		91,
		75,
		56,
		-1,
		30,
		43,
		89,
		57,
		62,
		57,
		75,
		86,
		97,
		100,
		105,
		108,
		-1,
		-1,
		168,
		158,
		-1,
		-1,
		132,
		134,
		-1,
		133,
		122,
		107,
		99,
		-1,
		-1,
		63,
		59,
		-1,
		-1,
		37,
		71,
		60,
		68,
		63,
		75,
		85,
		83,
		95,
		103,
		102,
		-1,
		-1,
		153,
		145,
		139,
		-1,
		117,
		-1,
		135,
		-1,
		102,
		108,
		96,
		-1,
		-1,
		-1,
		75,
		38,
		59,
		78,
		83,
		81,
		72,
		71,
		78,
		88,
		96,
		102,
		-1,
		-1,
		-1,
		135,
		109,
		142,
		133,
		116,
		96,
		88,
		107,
		-1,
		74,
		-1,
		42,
		39,
		80,
		77,
		94,
		88,
		74,
		89,
		85,
		94,
		92,
		141,
		-1,
		111,
		144,
		108,
		102,
		78,
		82,
		98,
		-1,
		71,
		50,
		-1,
		84,
		74,
		111,
		97,
		85,
		72,
		79,
		93,
		89,
		-1,
		-1,
		-1,
		113,
		112,
		104,
		98,
		98,
		83,
		74,
		-1,
		86,
		68,
		47,
		64,
		64,
		55,
		63,
		101,
		97,
		90,
		92,
		84,
		-1,
		214,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		107,
		102,
		75,
		63,
		69,
		65,
		51,
		57,
		59,
		67,
		65,
		62,
		74,
		70,
		90,
		85,
		118,
		-1,
		209,
		-1,
		143,
		-1,
		-1,
		125,
		105,
		97,
		86,
		75,
		73,
		64,
		55,
		77,
		93,
		77,
		75,
		80,
		85,
		-1,
		198,
		197,
		-1,
		144,
		136,
		122,
		-1,
		115,
		-1,
		121,
		82,
		-1,
		84,
		64,
		-1,
		86,
		82,
		-1,
		-1,
		185,
		160,
		-1,
		-1,
		-1,
		145,
		125,
		116,
		100,
		-1,
		75,
		75,
		-1,
		-1,
		-1,
		170,
		169,
		-1,
		138,
		141,
		-1,
		131,
		122,
		130,
		77,
		81,
		-1,
		-1,
		-1,
		179,
		160,
		154,
		153,
		151,
		146,
		143,
		129,
		113,
		91,
		80,
		101,
		-1,
		-1,
		-1,
		151,
		143,
		136,
		-1,
		-1,
		138,
		121,
		102,
		100,
		-1,
		-1,
		-1,
		173,
		154,
		-1,
		-1,
		128,
		-1,
		-1,
		134,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		162,
		-1,
		-1,
		-1,
		124,
		120,
		121,
		-1,
		-1,
		-1,
		-1,
		184,
		185,
		208,
		172,
		-1,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		187,
		185,
		-1,
		-1,
		-1,
		144,
		128,
		-1,
		114,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		149,
		-1,
		149,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		162,
		154,
		162,
		-1,
		134,
		136,
		-1,
		184,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		139,
		146,
		168,
		171,
		207,
		-1,
		158
	],
	[
		-1,
		214,
		203,
		214,
		222,
		195,
		202,
		-1,
		221,
		225,
		191,
		185,
		224,
		193,
		199,
		210,
		-1,
		-1,
		-1,
		214,
		213,
		181,
		179,
		188,
		193,
		200,
		-1,
		199,
		-1,
		235,
		214,
		225,
		230,
		174,
		171,
		191,
		210,
		192,
		184,
		250,
		204,
		175,
		169,
		187,
		177,
		186,
		178,
		-1,
		175,
		165,
		187,
		166,
		177,
		169,
		-1,
		-1,
		169,
		170,
		176,
		162,
		168,
		164,
		-1,
		174,
		158,
		-1,
		-1,
		159,
		160,
		144,
		147,
		155,
		153,
		166,
		158,
		153,
		-1,
		-1,
		150,
		146,
		153,
		140,
		136,
		153,
		166,
		148,
		162,
		161,
		-1,
		154,
		172,
		179,
		147,
		145,
		129,
		127,
		145,
		147,
		153,
		153,
		-1,
		163,
		164,
		159,
		167,
		169,
		145,
		132,
		132,
		142,
		135,
		154,
		142,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		163,
		146,
		163,
		155,
		145,
		160,
		153,
		135,
		132,
		130,
		127,
		143,
		141,
		151,
		-1,
		-1,
		256,
		225,
		254,
		212,
		193,
		-1,
		159,
		139,
		145,
		149,
		143,
		136,
		150,
		146,
		-1,
		121,
		120,
		148,
		134,
		145,
		216,
		-1,
		-1,
		214,
		206,
		189,
		192,
		169,
		165,
		154,
		153,
		145,
		131,
		127,
		133,
		136,
		136,
		142,
		115,
		125,
		129,
		127,
		152,
		-1,
		-1,
		187,
		-1,
		-1,
		213,
		196,
		-1,
		179,
		186,
		175,
		181,
		167,
		188,
		164,
		155,
		147,
		141,
		129,
		131,
		128,
		141,
		129,
		112,
		137,
		141,
		122,
		143,
		138,
		-1,
		186,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		172,
		175,
		181,
		205,
		204,
		-1,
		176,
		164,
		165,
		150,
		147,
		134,
		122,
		135,
		120,
		127,
		126,
		116,
		114,
		144,
		119,
		141,
		138,
		157,
		162,
		156,
		165,
		-1,
		221,
		217,
		213,
		220,
		169,
		-1,
		-1,
		209,
		-1,
		212,
		213,
		188,
		161,
		164,
		151,
		142,
		129,
		118,
		129,
		118,
		115,
		123,
		108,
		123,
		114,
		113,
		131,
		141,
		149,
		153,
		159,
		-1,
		271,
		-1,
		213,
		197,
		199,
		171,
		192,
		-1,
		229,
		213,
		205,
		190,
		190,
		-1,
		160,
		157,
		147,
		125,
		110,
		127,
		119,
		117,
		121,
		103,
		117,
		108,
		126,
		133,
		131,
		135,
		155,
		167,
		231,
		221,
		-1,
		203,
		208,
		167,
		175,
		194,
		232,
		196,
		-1,
		191,
		-1,
		162,
		175,
		-1,
		131,
		127,
		109,
		110,
		105,
		120,
		114,
		99,
		96,
		114,
		117,
		124,
		128,
		144,
		-1,
		-1,
		216,
		220,
		209,
		160,
		179,
		203,
		240,
		189,
		178,
		177,
		-1,
		168,
		145,
		142,
		130,
		117,
		102,
		103,
		111,
		124,
		103,
		98,
		95,
		115,
		141,
		119,
		131,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		186,
		157,
		181,
		223,
		207,
		200,
		188,
		153,
		153,
		147,
		-1,
		141,
		120,
		111,
		100,
		98,
		111,
		108,
		113,
		93,
		91,
		110,
		122,
		113,
		130,
		-1,
		-1,
		-1,
		216,
		205,
		206,
		152,
		175,
		212,
		186,
		172,
		177,
		152,
		145,
		139,
		154,
		137,
		118,
		107,
		99,
		88,
		104,
		112,
		107,
		89,
		98,
		104,
		128,
		118,
		124,
		-1,
		-1,
		223,
		213,
		197,
		199,
		196,
		166,
		173,
		205,
		177,
		190,
		-1,
		144,
		-1,
		133,
		128,
		112,
		107,
		104,
		101,
		95,
		104,
		106,
		96,
		91,
		98,
		133,
		133,
		108,
		128,
		131,
		-1,
		-1,
		-1,
		216,
		211,
		186,
		163,
		147,
		183,
		-1,
		160,
		161,
		-1,
		138,
		132,
		129,
		114,
		110,
		105,
		109,
		102,
		109,
		102,
		100,
		101,
		83,
		115,
		-1,
		116,
		110,
		118,
		108,
		96,
		-1,
		-1,
		-1,
		209,
		188,
		181,
		201,
		142,
		194,
		-1,
		-1,
		145,
		138,
		-1,
		125,
		107,
		114,
		112,
		106,
		110,
		107,
		96,
		109,
		102,
		88,
		90,
		103,
		107,
		111,
		98,
		94,
		91,
		105,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		162,
		-1,
		154,
		146,
		136,
		130,
		124,
		120,
		118,
		134,
		118,
		121,
		119,
		110,
		118,
		91,
		84,
		91,
		80,
		98,
		106,
		98,
		92,
		91,
		101,
		-1,
		229,
		215,
		186,
		-1,
		-1,
		175,
		-1,
		139,
		153,
		169,
		-1,
		162,
		141,
		156,
		134,
		130,
		126,
		141,
		142,
		120,
		119,
		117,
		108,
		96,
		85,
		88,
		80,
		102,
		102,
		86,
		87,
		91,
		-1,
		235,
		222,
		180,
		176,
		165,
		185,
		136,
		124,
		156,
		-1,
		-1,
		198,
		-1,
		132,
		149,
		140,
		138,
		131,
		116,
		123,
		128,
		105,
		100,
		90,
		79,
		79,
		74,
		96,
		82,
		80,
		89,
		105,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		151,
		138,
		132,
		-1,
		173,
		-1,
		176,
		166,
		150,
		135,
		168,
		-1,
		115,
		111,
		118,
		-1,
		125,
		-1,
		98,
		95,
		86,
		71,
		68,
		79,
		77,
		88,
		84,
		-1,
		185,
		170,
		163,
		153,
		167,
		138,
		-1,
		193,
		-1,
		-1,
		163,
		157,
		157,
		141,
		144,
		131,
		111,
		103,
		118,
		117,
		104,
		103,
		84,
		77,
		74,
		67,
		80,
		90,
		95,
		82,
		-1,
		-1,
		-1,
		190,
		176,
		180,
		140,
		159,
		-1,
		-1,
		225,
		180,
		166,
		-1,
		140,
		131,
		119,
		109,
		99,
		104,
		105,
		95,
		93,
		82,
		84,
		78,
		69,
		68,
		84,
		76,
		98,
		-1,
		-1,
		173,
		178,
		166,
		152,
		171,
		-1,
		-1,
		-1,
		172,
		188,
		159,
		138,
		120,
		-1,
		-1,
		103,
		96,
		90,
		93,
		81,
		98,
		93,
		77,
		62,
		77,
		81,
		89,
		80,
		-1,
		176,
		163,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		-1,
		-1,
		171,
		116,
		105,
		100,
		104,
		102,
		-1,
		76,
		87,
		80,
		99,
		106,
		79,
		64,
		58,
		64,
		76,
		85,
		-1,
		-1,
		188,
		-1,
		158,
		-1,
		-1,
		-1,
		-1,
		128,
		122,
		93,
		86,
		90,
		-1,
		78,
		80,
		77,
		89,
		82,
		79,
		70,
		61,
		57,
		61,
		65,
		79,
		83,
		211,
		-1,
		149,
		-1,
		-1,
		-1,
		146,
		161,
		132,
		109,
		82,
		77,
		70,
		64,
		69,
		80,
		89,
		100,
		65,
		64,
		54,
		53,
		57,
		74,
		78,
		-1,
		-1,
		147,
		143,
		172,
		154,
		158,
		159,
		-1,
		-1,
		86,
		77,
		68,
		60,
		73,
		76,
		61,
		63,
		63,
		58,
		52,
		62,
		77,
		72,
		-1,
		-1,
		-1,
		159,
		-1,
		161,
		-1,
		-1,
		149,
		157,
		104,
		86,
		82,
		80,
		67,
		61,
		51,
		56,
		66,
		60,
		57,
		48,
		52,
		75,
		64,
		103,
		-1,
		-1,
		231,
		-1,
		-1,
		-1,
		138,
		130,
		125,
		131,
		133,
		124,
		119,
		116,
		-1,
		86,
		90,
		57,
		64,
		47,
		54,
		59,
		56,
		42,
		49,
		65,
		64,
		59,
		95,
		86,
		92,
		-1,
		-1,
		224,
		213,
		202,
		208,
		-1,
		131,
		127,
		117,
		107,
		110,
		-1,
		-1,
		104,
		101,
		81,
		50,
		55,
		48,
		43,
		48,
		29,
		38,
		42,
		46,
		52,
		57,
		62,
		68,
		83,
		98,
		-1,
		178,
		215,
		208,
		176,
		184,
		215,
		-1,
		121,
		113,
		124,
		99,
		101,
		-1,
		-1,
		77,
		68,
		69,
		57,
		54,
		67,
		66,
		33,
		38,
		56,
		43,
		44,
		62,
		66,
		75,
		82,
		72,
		85,
		89,
		-1,
		171,
		191,
		170,
		173,
		197,
		211,
		-1,
		118,
		-1,
		-1,
		130,
		102,
		86,
		76,
		73,
		116,
		63,
		58,
		35,
		33,
		30,
		21,
		59,
		38,
		50,
		53,
		69,
		74,
		66,
		82,
		82,
		83,
		-1,
		160,
		171,
		164,
		-1,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		127,
		-1,
		113,
		-1,
		96,
		100,
		71,
		74,
		49,
		36,
		22,
		30,
		36,
		36,
		41,
		44,
		56,
		65,
		76,
		88,
		89,
		90,
		185,
		141,
		144,
		155,
		166,
		181,
		185,
		-1,
		130,
		169,
		133,
		-1,
		117,
		-1,
		-1,
		-1,
		110,
		84,
		76,
		69,
		48,
		48,
		14,
		18,
		31,
		38,
		48,
		62,
		65,
		69,
		82,
		93,
		98,
		181,
		172,
		185,
		130,
		130,
		151,
		160,
		181,
		145,
		136,
		163,
		140,
		129,
		124,
		111,
		-1,
		-1,
		90,
		94,
		-1,
		-1,
		55,
		22,
		10,
		20,
		24,
		38,
		50,
		63,
		59,
		70,
		64,
		96,
		-1,
		174,
		173,
		162,
		159,
		135,
		126,
		121,
		148,
		-1,
		-1,
		143,
		164,
		154,
		158,
		171,
		196,
		-1,
		100,
		-1,
		-1,
		70,
		-1,
		-1,
		53,
		27,
		16,
		7,
		20,
		32,
		43,
		65,
		55,
		72,
		69,
		79,
		92,
		158,
		155,
		143,
		141,
		164,
		129,
		117,
		-1,
		130,
		128,
		134,
		141,
		158,
		185,
		-1,
		-1,
		116,
		96,
		-1,
		-1,
		53,
		51,
		38,
		-1,
		27,
		0,
		17,
		47,
		49,
		51,
		58,
		52,
		59,
		81,
		89,
		97,
		167,
		181,
		170,
		166,
		165,
		173,
		122,
		115,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		106,
		102,
		-1,
		-1,
		48,
		41,
		29,
		17,
		7,
		17,
		34,
		34,
		37,
		42,
		50,
		61,
		75,
		79,
		93,
		-1,
		201,
		-1,
		153,
		129,
		143,
		158,
		166,
		-1,
		-1,
		-1,
		123,
		109,
		102,
		90,
		88,
		-1,
		82,
		66,
		47,
		-1,
		16,
		29,
		70,
		38,
		43,
		38,
		56,
		67,
		78,
		81,
		86,
		89,
		-1,
		-1,
		141,
		139,
		-1,
		-1,
		113,
		115,
		-1,
		114,
		103,
		88,
		80,
		-1,
		-1,
		54,
		50,
		-1,
		-1,
		18,
		52,
		41,
		49,
		44,
		56,
		66,
		64,
		76,
		84,
		83,
		-1,
		-1,
		134,
		126,
		120,
		-1,
		98,
		-1,
		116,
		-1,
		83,
		89,
		77,
		-1,
		-1,
		-1,
		56,
		19,
		40,
		59,
		64,
		62,
		53,
		52,
		59,
		69,
		77,
		83,
		-1,
		-1,
		-1,
		116,
		90,
		123,
		114,
		97,
		77,
		69,
		88,
		-1,
		55,
		-1,
		23,
		20,
		61,
		58,
		75,
		69,
		55,
		70,
		66,
		75,
		73,
		122,
		-1,
		92,
		125,
		89,
		83,
		59,
		63,
		79,
		-1,
		52,
		31,
		-1,
		65,
		55,
		92,
		78,
		66,
		53,
		60,
		74,
		70,
		-1,
		-1,
		-1,
		94,
		93,
		85,
		79,
		79,
		64,
		55,
		-1,
		67,
		49,
		28,
		45,
		45,
		36,
		44,
		82,
		78,
		71,
		73,
		65,
		-1,
		195,
		-1,
		-1,
		117,
		-1,
		-1,
		-1,
		88,
		83,
		56,
		44,
		50,
		46,
		32,
		38,
		40,
		48,
		46,
		43,
		55,
		51,
		71,
		66,
		99,
		-1,
		190,
		-1,
		124,
		-1,
		-1,
		106,
		86,
		78,
		67,
		56,
		54,
		45,
		36,
		58,
		74,
		58,
		56,
		61,
		66,
		-1,
		179,
		178,
		-1,
		125,
		117,
		103,
		-1,
		96,
		-1,
		102,
		63,
		-1,
		65,
		45,
		-1,
		67,
		63,
		-1,
		-1,
		166,
		141,
		-1,
		-1,
		-1,
		126,
		106,
		97,
		81,
		-1,
		56,
		56,
		-1,
		-1,
		-1,
		151,
		150,
		-1,
		119,
		122,
		-1,
		112,
		103,
		111,
		58,
		62,
		-1,
		-1,
		-1,
		160,
		141,
		135,
		134,
		132,
		127,
		124,
		110,
		94,
		72,
		61,
		82,
		-1,
		-1,
		-1,
		132,
		124,
		117,
		-1,
		-1,
		119,
		102,
		83,
		81,
		-1,
		-1,
		-1,
		154,
		135,
		-1,
		-1,
		109,
		-1,
		-1,
		115,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		143,
		-1,
		-1,
		-1,
		105,
		101,
		102,
		-1,
		-1,
		-1,
		-1,
		165,
		166,
		189,
		153,
		-1,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		168,
		166,
		-1,
		-1,
		-1,
		125,
		109,
		-1,
		95,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		128,
		-1,
		-1,
		-1,
		130,
		-1,
		130,
		105,
		112,
		-1,
		-1,
		-1,
		-1,
		143,
		135,
		143,
		-1,
		115,
		117,
		-1,
		165,
		-1,
		-1,
		158,
		149,
		-1,
		-1,
		120,
		127,
		149,
		152,
		188,
		-1,
		139
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		222,
		226,
		192,
		186,
		225,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		215,
		214,
		182,
		180,
		189,
		194,
		201,
		-1,
		200,
		-1,
		236,
		215,
		226,
		231,
		175,
		172,
		192,
		211,
		193,
		185,
		251,
		205,
		176,
		170,
		188,
		178,
		187,
		179,
		-1,
		176,
		166,
		188,
		167,
		178,
		170,
		-1,
		-1,
		170,
		171,
		177,
		163,
		169,
		165,
		-1,
		175,
		159,
		-1,
		-1,
		160,
		161,
		145,
		148,
		156,
		154,
		167,
		159,
		154,
		-1,
		-1,
		151,
		147,
		154,
		141,
		137,
		154,
		167,
		149,
		163,
		162,
		-1,
		155,
		173,
		180,
		148,
		146,
		130,
		128,
		146,
		148,
		154,
		154,
		-1,
		164,
		165,
		160,
		168,
		170,
		146,
		133,
		133,
		143,
		136,
		155,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		136,
		133,
		131,
		128,
		144,
		142,
		152,
		-1,
		-1,
		257,
		226,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		122,
		121,
		149,
		135,
		146,
		217,
		-1,
		-1,
		215,
		207,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		116,
		126,
		130,
		128,
		153,
		-1,
		-1,
		188,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		113,
		138,
		142,
		123,
		144,
		139,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		117,
		115,
		145,
		120,
		142,
		139,
		158,
		163,
		157,
		166,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		109,
		124,
		115,
		114,
		132,
		142,
		150,
		154,
		160,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		214,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		122,
		104,
		118,
		109,
		127,
		134,
		132,
		136,
		156,
		168,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		115,
		100,
		97,
		115,
		118,
		125,
		129,
		145,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		125,
		104,
		99,
		96,
		116,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		109,
		114,
		94,
		92,
		111,
		123,
		114,
		131,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		105,
		113,
		108,
		90,
		99,
		105,
		129,
		119,
		125,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		107,
		97,
		92,
		99,
		134,
		134,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		103,
		101,
		102,
		84,
		116,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		108,
		97,
		110,
		103,
		89,
		91,
		104,
		108,
		112,
		99,
		95,
		92,
		106,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		120,
		111,
		119,
		92,
		85,
		92,
		81,
		99,
		107,
		99,
		93,
		92,
		102,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		121,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		103,
		103,
		87,
		88,
		92,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		117,
		124,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		97,
		83,
		81,
		90,
		106,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		116,
		112,
		119,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		89,
		85,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		132,
		112,
		104,
		119,
		118,
		105,
		104,
		85,
		78,
		75,
		68,
		81,
		91,
		96,
		83,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		141,
		132,
		120,
		110,
		100,
		105,
		106,
		96,
		94,
		83,
		85,
		79,
		70,
		69,
		85,
		77,
		99,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		160,
		139,
		121,
		-1,
		-1,
		104,
		97,
		91,
		94,
		82,
		99,
		94,
		78,
		63,
		78,
		82,
		90,
		81,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		172,
		117,
		106,
		101,
		105,
		103,
		-1,
		77,
		88,
		81,
		100,
		107,
		80,
		65,
		59,
		65,
		77,
		86,
		-1,
		-1,
		189,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		129,
		123,
		94,
		87,
		91,
		-1,
		79,
		81,
		78,
		90,
		83,
		80,
		71,
		62,
		58,
		62,
		66,
		80,
		84,
		212,
		-1,
		150,
		-1,
		-1,
		-1,
		147,
		162,
		133,
		110,
		83,
		78,
		71,
		65,
		70,
		81,
		90,
		101,
		66,
		65,
		55,
		54,
		58,
		75,
		79,
		-1,
		-1,
		148,
		144,
		173,
		155,
		159,
		160,
		-1,
		-1,
		87,
		78,
		69,
		61,
		74,
		77,
		62,
		64,
		64,
		59,
		53,
		63,
		78,
		73,
		-1,
		-1,
		-1,
		160,
		-1,
		162,
		-1,
		-1,
		150,
		158,
		105,
		87,
		83,
		81,
		68,
		62,
		52,
		57,
		67,
		61,
		58,
		49,
		53,
		76,
		65,
		104,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		139,
		131,
		126,
		132,
		134,
		125,
		120,
		117,
		-1,
		87,
		91,
		58,
		65,
		48,
		55,
		60,
		57,
		43,
		50,
		66,
		65,
		60,
		96,
		87,
		93,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		132,
		128,
		118,
		108,
		111,
		-1,
		-1,
		105,
		102,
		82,
		51,
		56,
		49,
		44,
		49,
		30,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		99,
		-1,
		179,
		216,
		209,
		177,
		185,
		216,
		-1,
		122,
		114,
		125,
		100,
		102,
		-1,
		-1,
		78,
		69,
		70,
		58,
		55,
		68,
		67,
		34,
		31,
		53,
		36,
		45,
		63,
		67,
		74,
		75,
		73,
		86,
		90,
		-1,
		172,
		192,
		171,
		174,
		198,
		212,
		-1,
		119,
		-1,
		-1,
		131,
		103,
		87,
		77,
		74,
		117,
		64,
		59,
		36,
		34,
		31,
		22,
		52,
		31,
		43,
		46,
		62,
		67,
		59,
		83,
		83,
		84,
		-1,
		161,
		172,
		165,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		129,
		-1,
		114,
		-1,
		97,
		101,
		72,
		75,
		50,
		37,
		23,
		23,
		29,
		29,
		34,
		37,
		49,
		58,
		69,
		81,
		90,
		91,
		186,
		142,
		145,
		156,
		167,
		182,
		186,
		-1,
		131,
		170,
		135,
		-1,
		119,
		-1,
		-1,
		-1,
		111,
		85,
		77,
		70,
		49,
		49,
		15,
		11,
		24,
		31,
		41,
		55,
		50,
		62,
		75,
		86,
		99,
		182,
		173,
		186,
		131,
		131,
		152,
		161,
		182,
		146,
		137,
		164,
		142,
		131,
		126,
		113,
		-1,
		-1,
		92,
		95,
		-1,
		-1,
		56,
		32,
		19,
		13,
		17,
		31,
		43,
		56,
		42,
		62,
		57,
		89,
		-1,
		175,
		174,
		163,
		160,
		136,
		127,
		122,
		149,
		-1,
		-1,
		144,
		165,
		155,
		159,
		173,
		198,
		-1,
		102,
		-1,
		-1,
		72,
		-1,
		-1,
		57,
		37,
		26,
		17,
		3,
		25,
		36,
		58,
		38,
		55,
		62,
		72,
		85,
		159,
		156,
		144,
		142,
		165,
		130,
		118,
		-1,
		131,
		129,
		135,
		142,
		159,
		187,
		-1,
		-1,
		118,
		98,
		-1,
		-1,
		55,
		53,
		42,
		-1,
		32,
		14,
		0,
		30,
		32,
		34,
		41,
		35,
		42,
		68,
		81,
		82,
		168,
		182,
		171,
		167,
		166,
		174,
		123,
		116,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		-1,
		108,
		104,
		-1,
		-1,
		50,
		43,
		31,
		19,
		9,
		14,
		17,
		17,
		20,
		25,
		33,
		44,
		58,
		62,
		76,
		-1,
		202,
		-1,
		154,
		130,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		125,
		111,
		104,
		92,
		90,
		-1,
		84,
		68,
		49,
		-1,
		19,
		32,
		53,
		21,
		26,
		21,
		39,
		50,
		61,
		64,
		69,
		72,
		-1,
		-1,
		142,
		141,
		-1,
		-1,
		115,
		117,
		-1,
		116,
		105,
		90,
		82,
		-1,
		-1,
		56,
		52,
		-1,
		-1,
		20,
		35,
		24,
		32,
		27,
		39,
		49,
		47,
		59,
		67,
		66,
		-1,
		-1,
		136,
		128,
		122,
		-1,
		100,
		-1,
		118,
		-1,
		85,
		91,
		79,
		-1,
		-1,
		-1,
		58,
		21,
		42,
		42,
		47,
		45,
		36,
		35,
		42,
		52,
		60,
		66,
		-1,
		-1,
		-1,
		118,
		92,
		125,
		116,
		99,
		79,
		71,
		90,
		-1,
		57,
		-1,
		25,
		22,
		56,
		41,
		58,
		52,
		38,
		53,
		49,
		58,
		56,
		124,
		-1,
		94,
		127,
		91,
		85,
		61,
		65,
		81,
		-1,
		54,
		33,
		-1,
		67,
		57,
		75,
		61,
		49,
		36,
		43,
		57,
		53,
		-1,
		-1,
		-1,
		96,
		95,
		87,
		81,
		81,
		66,
		57,
		-1,
		69,
		51,
		30,
		47,
		47,
		38,
		46,
		65,
		61,
		54,
		56,
		48,
		-1,
		197,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		90,
		85,
		58,
		46,
		52,
		48,
		34,
		40,
		42,
		50,
		48,
		45,
		57,
		53,
		70,
		49,
		85,
		-1,
		192,
		-1,
		126,
		-1,
		-1,
		108,
		88,
		80,
		69,
		58,
		56,
		47,
		38,
		60,
		76,
		60,
		58,
		56,
		57,
		-1,
		181,
		180,
		-1,
		127,
		119,
		105,
		-1,
		98,
		-1,
		104,
		65,
		-1,
		67,
		47,
		-1,
		69,
		61,
		-1,
		-1,
		168,
		143,
		-1,
		-1,
		-1,
		128,
		108,
		99,
		83,
		-1,
		58,
		58,
		-1,
		-1,
		-1,
		153,
		152,
		-1,
		121,
		124,
		-1,
		114,
		105,
		113,
		60,
		64,
		-1,
		-1,
		-1,
		162,
		143,
		137,
		136,
		134,
		129,
		126,
		112,
		96,
		74,
		63,
		84,
		-1,
		-1,
		-1,
		134,
		126,
		119,
		-1,
		-1,
		121,
		104,
		85,
		83,
		-1,
		-1,
		-1,
		156,
		137,
		-1,
		-1,
		111,
		-1,
		-1,
		117,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		145,
		-1,
		-1,
		-1,
		107,
		103,
		104,
		-1,
		-1,
		-1,
		-1,
		167,
		168,
		191,
		155,
		-1,
		-1,
		-1,
		99,
		93,
		-1,
		-1,
		170,
		168,
		-1,
		-1,
		-1,
		127,
		111,
		-1,
		97,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		132,
		-1,
		132,
		107,
		114,
		-1,
		-1,
		-1,
		-1,
		145,
		137,
		145,
		-1,
		117,
		119,
		-1,
		167,
		-1,
		-1,
		160,
		151,
		-1,
		-1,
		122,
		129,
		151,
		154,
		190,
		-1,
		141
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		178,
		196,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		187,
		188,
		183,
		191,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		170,
		187,
		179,
		169,
		184,
		177,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		280,
		249,
		278,
		236,
		217,
		-1,
		183,
		163,
		169,
		173,
		167,
		160,
		174,
		170,
		-1,
		145,
		144,
		172,
		158,
		169,
		240,
		-1,
		-1,
		238,
		230,
		213,
		216,
		193,
		189,
		178,
		177,
		169,
		155,
		151,
		157,
		160,
		160,
		166,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		211,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		199,
		205,
		191,
		212,
		188,
		179,
		171,
		165,
		153,
		155,
		152,
		165,
		153,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		228,
		-1,
		200,
		188,
		189,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		140,
		138,
		168,
		143,
		165,
		162,
		181,
		186,
		180,
		189,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		236,
		237,
		212,
		185,
		188,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		132,
		147,
		138,
		137,
		155,
		165,
		173,
		177,
		183,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		237,
		229,
		214,
		214,
		-1,
		184,
		181,
		171,
		149,
		134,
		151,
		143,
		141,
		145,
		127,
		141,
		132,
		150,
		157,
		155,
		159,
		179,
		191,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		186,
		199,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		138,
		123,
		120,
		138,
		141,
		148,
		152,
		168,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		169,
		166,
		154,
		141,
		126,
		127,
		135,
		148,
		127,
		122,
		119,
		139,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		165,
		144,
		135,
		124,
		122,
		135,
		132,
		137,
		117,
		115,
		134,
		146,
		137,
		154,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		178,
		161,
		142,
		131,
		123,
		112,
		128,
		136,
		131,
		113,
		122,
		128,
		152,
		142,
		148,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		152,
		136,
		131,
		128,
		125,
		119,
		128,
		130,
		120,
		115,
		122,
		157,
		157,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		138,
		134,
		129,
		133,
		126,
		133,
		126,
		124,
		125,
		107,
		139,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		138,
		136,
		130,
		134,
		131,
		120,
		133,
		126,
		112,
		114,
		127,
		131,
		135,
		122,
		118,
		115,
		129,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		158,
		142,
		145,
		143,
		134,
		142,
		115,
		108,
		115,
		104,
		122,
		130,
		122,
		116,
		115,
		125,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		150,
		165,
		166,
		144,
		143,
		141,
		132,
		120,
		109,
		112,
		104,
		126,
		126,
		110,
		111,
		115,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		164,
		162,
		155,
		142,
		149,
		152,
		129,
		124,
		114,
		103,
		103,
		98,
		120,
		106,
		104,
		113,
		129,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		141,
		137,
		144,
		-1,
		149,
		-1,
		122,
		119,
		110,
		95,
		92,
		103,
		101,
		112,
		108,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		157,
		137,
		129,
		144,
		143,
		130,
		129,
		108,
		101,
		98,
		91,
		104,
		114,
		119,
		106,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		166,
		157,
		145,
		135,
		125,
		130,
		131,
		121,
		119,
		106,
		108,
		102,
		93,
		92,
		108,
		100,
		122,
		-1,
		-1,
		197,
		202,
		190,
		176,
		195,
		-1,
		-1,
		-1,
		196,
		212,
		185,
		164,
		146,
		-1,
		-1,
		129,
		122,
		116,
		119,
		107,
		122,
		117,
		101,
		86,
		101,
		105,
		113,
		104,
		-1,
		200,
		187,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		-1,
		-1,
		197,
		142,
		131,
		126,
		130,
		128,
		-1,
		102,
		113,
		106,
		125,
		132,
		103,
		88,
		82,
		88,
		100,
		109,
		-1,
		-1,
		212,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		154,
		148,
		119,
		112,
		116,
		-1,
		104,
		106,
		103,
		115,
		106,
		103,
		94,
		85,
		81,
		85,
		89,
		103,
		107,
		235,
		-1,
		175,
		-1,
		-1,
		-1,
		172,
		187,
		158,
		135,
		108,
		103,
		96,
		90,
		95,
		106,
		114,
		125,
		91,
		88,
		78,
		77,
		81,
		98,
		102,
		-1,
		-1,
		173,
		169,
		198,
		180,
		184,
		185,
		-1,
		-1,
		112,
		103,
		94,
		86,
		99,
		102,
		87,
		89,
		89,
		82,
		76,
		86,
		101,
		96,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		183,
		130,
		112,
		108,
		106,
		93,
		87,
		77,
		82,
		92,
		86,
		83,
		72,
		76,
		99,
		88,
		125,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		145,
		142,
		-1,
		112,
		116,
		83,
		90,
		73,
		80,
		85,
		82,
		66,
		73,
		89,
		88,
		83,
		117,
		108,
		112,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		107,
		76,
		81,
		74,
		69,
		74,
		55,
		62,
		66,
		70,
		76,
		81,
		86,
		92,
		103,
		118,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		93,
		92,
		59,
		56,
		77,
		55,
		65,
		86,
		89,
		93,
		94,
		96,
		109,
		113,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		89,
		84,
		61,
		59,
		56,
		47,
		73,
		50,
		62,
		65,
		81,
		86,
		78,
		104,
		106,
		107,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		160,
		-1,
		139,
		-1,
		122,
		126,
		97,
		100,
		75,
		62,
		48,
		48,
		54,
		48,
		53,
		56,
		68,
		77,
		88,
		100,
		110,
		112,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		136,
		110,
		102,
		95,
		74,
		74,
		40,
		36,
		43,
		50,
		60,
		74,
		75,
		81,
		94,
		105,
		120,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		173,
		162,
		157,
		144,
		-1,
		-1,
		123,
		120,
		-1,
		-1,
		81,
		61,
		44,
		33,
		36,
		46,
		56,
		70,
		67,
		82,
		76,
		108,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		200,
		225,
		-1,
		133,
		-1,
		-1,
		103,
		-1,
		-1,
		88,
		66,
		55,
		46,
		28,
		38,
		49,
		71,
		63,
		80,
		81,
		91,
		104,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		214,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		86,
		84,
		73,
		-1,
		63,
		45,
		31,
		0,
		57,
		59,
		66,
		60,
		67,
		93,
		101,
		107,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		81,
		74,
		62,
		50,
		40,
		42,
		24,
		36,
		45,
		50,
		58,
		69,
		83,
		87,
		101,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		115,
		99,
		80,
		-1,
		50,
		63,
		78,
		44,
		51,
		46,
		64,
		75,
		86,
		89,
		94,
		97,
		-1,
		-1,
		167,
		170,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		51,
		54,
		43,
		57,
		52,
		64,
		74,
		72,
		84,
		92,
		91,
		-1,
		-1,
		167,
		159,
		153,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		89,
		52,
		73,
		61,
		68,
		70,
		61,
		60,
		67,
		77,
		85,
		91,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		88,
		-1,
		56,
		53,
		75,
		60,
		83,
		77,
		63,
		78,
		74,
		83,
		81,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		85,
		64,
		-1,
		98,
		82,
		100,
		86,
		74,
		61,
		68,
		82,
		78,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		78,
		78,
		69,
		77,
		90,
		86,
		79,
		81,
		73,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		73,
		81,
		79,
		76,
		88,
		84,
		95,
		74,
		110,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		107,
		91,
		86,
		81,
		82,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		97,
		86,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		178,
		196,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		187,
		188,
		183,
		191,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		170,
		187,
		179,
		169,
		184,
		177,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		280,
		249,
		278,
		236,
		217,
		-1,
		183,
		163,
		169,
		173,
		167,
		160,
		174,
		170,
		-1,
		145,
		144,
		172,
		158,
		169,
		240,
		-1,
		-1,
		238,
		230,
		213,
		216,
		193,
		189,
		178,
		177,
		169,
		155,
		151,
		157,
		160,
		160,
		166,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		211,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		199,
		205,
		191,
		212,
		188,
		179,
		171,
		165,
		153,
		155,
		152,
		165,
		153,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		228,
		-1,
		200,
		188,
		189,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		140,
		138,
		168,
		143,
		165,
		162,
		181,
		186,
		180,
		189,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		236,
		237,
		212,
		185,
		188,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		132,
		147,
		138,
		137,
		155,
		165,
		173,
		177,
		183,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		237,
		229,
		214,
		214,
		-1,
		184,
		181,
		171,
		149,
		134,
		151,
		143,
		141,
		145,
		127,
		141,
		132,
		150,
		157,
		155,
		159,
		179,
		191,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		186,
		199,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		138,
		123,
		120,
		138,
		141,
		148,
		152,
		168,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		169,
		166,
		154,
		141,
		126,
		127,
		135,
		148,
		127,
		122,
		119,
		139,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		165,
		144,
		135,
		124,
		122,
		135,
		132,
		137,
		117,
		115,
		134,
		146,
		137,
		154,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		178,
		161,
		142,
		131,
		123,
		112,
		128,
		136,
		131,
		113,
		122,
		128,
		152,
		142,
		148,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		152,
		136,
		131,
		128,
		125,
		119,
		128,
		130,
		120,
		115,
		122,
		157,
		157,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		138,
		134,
		129,
		133,
		126,
		133,
		126,
		124,
		125,
		107,
		139,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		138,
		136,
		130,
		134,
		131,
		120,
		133,
		126,
		112,
		114,
		127,
		131,
		135,
		122,
		118,
		115,
		129,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		158,
		142,
		145,
		143,
		134,
		142,
		115,
		108,
		115,
		104,
		122,
		130,
		122,
		116,
		115,
		125,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		150,
		165,
		166,
		144,
		143,
		141,
		132,
		120,
		109,
		112,
		104,
		126,
		126,
		110,
		111,
		115,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		164,
		162,
		155,
		146,
		152,
		152,
		129,
		124,
		114,
		103,
		103,
		98,
		120,
		106,
		104,
		113,
		129,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		149,
		145,
		152,
		-1,
		149,
		-1,
		122,
		119,
		110,
		95,
		92,
		103,
		101,
		112,
		108,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		165,
		145,
		137,
		152,
		144,
		136,
		130,
		108,
		101,
		98,
		91,
		104,
		114,
		119,
		106,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		174,
		165,
		153,
		143,
		133,
		138,
		139,
		127,
		120,
		106,
		108,
		102,
		93,
		92,
		108,
		100,
		122,
		-1,
		-1,
		197,
		202,
		190,
		176,
		195,
		-1,
		-1,
		-1,
		196,
		212,
		193,
		172,
		154,
		-1,
		-1,
		137,
		130,
		124,
		123,
		110,
		122,
		117,
		101,
		86,
		101,
		105,
		113,
		104,
		-1,
		200,
		187,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		-1,
		-1,
		205,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		121,
		114,
		126,
		133,
		103,
		88,
		82,
		88,
		100,
		109,
		-1,
		-1,
		212,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		127,
		120,
		124,
		-1,
		112,
		114,
		111,
		123,
		106,
		103,
		94,
		85,
		81,
		85,
		89,
		103,
		107,
		235,
		-1,
		183,
		-1,
		-1,
		-1,
		180,
		195,
		166,
		143,
		116,
		111,
		104,
		98,
		103,
		114,
		114,
		125,
		92,
		88,
		78,
		77,
		81,
		98,
		98,
		-1,
		-1,
		181,
		177,
		206,
		188,
		192,
		193,
		-1,
		-1,
		120,
		111,
		102,
		94,
		107,
		110,
		95,
		95,
		89,
		82,
		76,
		86,
		97,
		92,
		-1,
		-1,
		-1,
		193,
		-1,
		195,
		-1,
		-1,
		183,
		191,
		138,
		120,
		116,
		114,
		101,
		95,
		85,
		90,
		99,
		90,
		84,
		72,
		72,
		95,
		84,
		101,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		172,
		164,
		159,
		165,
		167,
		158,
		153,
		150,
		-1,
		120,
		124,
		91,
		98,
		81,
		88,
		93,
		86,
		66,
		69,
		85,
		84,
		79,
		93,
		84,
		88,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		165,
		161,
		151,
		141,
		144,
		-1,
		-1,
		138,
		135,
		115,
		84,
		89,
		82,
		77,
		82,
		63,
		62,
		62,
		57,
		72,
		77,
		79,
		72,
		79,
		94,
		-1,
		212,
		249,
		242,
		210,
		218,
		249,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		111,
		102,
		103,
		91,
		88,
		101,
		100,
		67,
		64,
		77,
		55,
		62,
		73,
		65,
		69,
		70,
		77,
		88,
		92,
		-1,
		205,
		225,
		204,
		207,
		231,
		245,
		-1,
		152,
		-1,
		-1,
		164,
		136,
		120,
		110,
		107,
		150,
		97,
		92,
		69,
		67,
		64,
		55,
		79,
		63,
		51,
		48,
		57,
		62,
		54,
		80,
		82,
		88,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		162,
		-1,
		147,
		-1,
		130,
		134,
		105,
		108,
		83,
		70,
		56,
		56,
		62,
		62,
		59,
		55,
		44,
		53,
		64,
		76,
		86,
		88,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		164,
		203,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		144,
		118,
		110,
		103,
		82,
		82,
		48,
		44,
		57,
		64,
		69,
		61,
		45,
		57,
		70,
		81,
		96,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		179,
		170,
		197,
		175,
		164,
		159,
		146,
		-1,
		-1,
		125,
		128,
		-1,
		-1,
		89,
		65,
		52,
		46,
		50,
		64,
		69,
		57,
		37,
		57,
		52,
		84,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		198,
		188,
		192,
		206,
		231,
		-1,
		135,
		-1,
		-1,
		105,
		-1,
		-1,
		90,
		70,
		59,
		50,
		36,
		58,
		69,
		84,
		33,
		50,
		57,
		67,
		80,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		192,
		220,
		-1,
		-1,
		151,
		131,
		-1,
		-1,
		88,
		86,
		75,
		-1,
		65,
		47,
		33,
		60,
		0,
		29,
		36,
		30,
		37,
		63,
		76,
		80,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		141,
		137,
		-1,
		-1,
		83,
		76,
		64,
		52,
		42,
		47,
		33,
		29,
		15,
		20,
		28,
		39,
		53,
		57,
		74,
		-1,
		235,
		-1,
		187,
		163,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		158,
		144,
		137,
		125,
		123,
		-1,
		117,
		101,
		82,
		-1,
		52,
		65,
		65,
		33,
		33,
		26,
		34,
		45,
		56,
		59,
		73,
		68,
		-1,
		-1,
		175,
		174,
		-1,
		-1,
		148,
		150,
		-1,
		149,
		138,
		123,
		115,
		-1,
		-1,
		89,
		85,
		-1,
		-1,
		53,
		47,
		36,
		39,
		34,
		38,
		44,
		54,
		58,
		62,
		74,
		-1,
		-1,
		169,
		161,
		155,
		-1,
		133,
		-1,
		151,
		-1,
		118,
		124,
		112,
		-1,
		-1,
		-1,
		91,
		54,
		75,
		54,
		57,
		55,
		46,
		42,
		49,
		59,
		65,
		76,
		-1,
		-1,
		-1,
		151,
		125,
		158,
		149,
		132,
		112,
		104,
		123,
		-1,
		90,
		-1,
		58,
		55,
		68,
		53,
		68,
		62,
		45,
		60,
		59,
		63,
		66,
		157,
		-1,
		127,
		160,
		124,
		118,
		94,
		98,
		114,
		-1,
		87,
		66,
		-1,
		100,
		75,
		85,
		71,
		59,
		46,
		53,
		67,
		63,
		-1,
		-1,
		-1,
		129,
		128,
		120,
		114,
		114,
		99,
		90,
		-1,
		102,
		84,
		63,
		80,
		80,
		71,
		79,
		75,
		71,
		64,
		66,
		58,
		-1,
		230,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		123,
		118,
		91,
		79,
		85,
		81,
		67,
		73,
		75,
		83,
		81,
		78,
		85,
		76,
		80,
		59,
		95,
		-1,
		225,
		-1,
		159,
		-1,
		-1,
		141,
		121,
		113,
		102,
		91,
		89,
		80,
		71,
		93,
		109,
		83,
		71,
		66,
		67,
		-1,
		214,
		213,
		-1,
		160,
		152,
		138,
		-1,
		131,
		-1,
		137,
		98,
		-1,
		100,
		80,
		-1,
		82,
		71,
		-1,
		-1,
		201,
		176,
		-1,
		-1,
		-1,
		161,
		141,
		132,
		116,
		-1,
		91,
		91,
		-1,
		-1,
		-1,
		186,
		185,
		-1,
		154,
		157,
		-1,
		147,
		138,
		146,
		93,
		97,
		-1,
		-1,
		-1,
		195,
		176,
		170,
		169,
		167,
		162,
		159,
		145,
		129,
		107,
		96,
		117,
		-1,
		-1,
		-1,
		167,
		159,
		152,
		-1,
		-1,
		154,
		137,
		118,
		116,
		-1,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		144,
		-1,
		-1,
		150,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		178,
		-1,
		-1,
		-1,
		140,
		136,
		137,
		-1,
		-1,
		-1,
		-1,
		200,
		201,
		224,
		188,
		-1,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		203,
		201,
		-1,
		-1,
		-1,
		160,
		144,
		-1,
		130,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		165,
		-1,
		165,
		140,
		147,
		-1,
		-1,
		-1,
		-1,
		178,
		170,
		178,
		-1,
		150,
		152,
		-1,
		200,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		155,
		162,
		184,
		187,
		223,
		-1,
		174
	],
	[
		-1,
		231,
		220,
		231,
		239,
		212,
		219,
		-1,
		238,
		242,
		208,
		202,
		241,
		210,
		216,
		227,
		-1,
		-1,
		-1,
		231,
		230,
		198,
		196,
		205,
		210,
		217,
		-1,
		216,
		-1,
		252,
		231,
		242,
		247,
		191,
		188,
		208,
		227,
		209,
		201,
		267,
		221,
		192,
		186,
		204,
		194,
		203,
		195,
		-1,
		192,
		182,
		204,
		183,
		194,
		186,
		-1,
		-1,
		186,
		187,
		193,
		179,
		185,
		181,
		-1,
		191,
		175,
		-1,
		-1,
		176,
		177,
		161,
		164,
		172,
		170,
		183,
		175,
		170,
		-1,
		-1,
		167,
		163,
		170,
		157,
		153,
		170,
		183,
		165,
		179,
		178,
		-1,
		171,
		189,
		196,
		164,
		162,
		146,
		144,
		162,
		164,
		170,
		170,
		-1,
		180,
		181,
		176,
		184,
		186,
		162,
		149,
		149,
		159,
		152,
		171,
		159,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		180,
		163,
		180,
		172,
		162,
		177,
		170,
		152,
		149,
		147,
		144,
		160,
		158,
		168,
		-1,
		-1,
		273,
		242,
		271,
		229,
		210,
		-1,
		176,
		156,
		162,
		166,
		160,
		153,
		167,
		163,
		-1,
		138,
		137,
		165,
		151,
		162,
		233,
		-1,
		-1,
		231,
		223,
		206,
		209,
		186,
		182,
		171,
		170,
		162,
		148,
		144,
		150,
		153,
		153,
		159,
		132,
		142,
		146,
		144,
		169,
		-1,
		-1,
		204,
		-1,
		-1,
		230,
		213,
		-1,
		196,
		203,
		192,
		198,
		184,
		205,
		181,
		172,
		164,
		158,
		146,
		148,
		145,
		158,
		146,
		129,
		154,
		158,
		139,
		160,
		155,
		-1,
		203,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		189,
		192,
		198,
		222,
		221,
		-1,
		193,
		181,
		182,
		167,
		164,
		151,
		139,
		152,
		137,
		144,
		143,
		133,
		131,
		161,
		136,
		158,
		155,
		174,
		179,
		173,
		182,
		-1,
		238,
		234,
		230,
		237,
		186,
		-1,
		-1,
		226,
		-1,
		229,
		230,
		205,
		178,
		181,
		168,
		159,
		146,
		135,
		146,
		135,
		132,
		140,
		125,
		140,
		131,
		130,
		148,
		158,
		166,
		170,
		176,
		-1,
		288,
		-1,
		230,
		214,
		216,
		188,
		209,
		-1,
		246,
		230,
		222,
		207,
		207,
		-1,
		177,
		174,
		164,
		142,
		127,
		144,
		136,
		134,
		138,
		120,
		134,
		125,
		143,
		150,
		148,
		152,
		172,
		184,
		248,
		238,
		-1,
		220,
		225,
		184,
		192,
		211,
		249,
		213,
		-1,
		208,
		-1,
		179,
		192,
		-1,
		148,
		144,
		126,
		127,
		122,
		137,
		131,
		116,
		113,
		131,
		134,
		141,
		145,
		161,
		-1,
		-1,
		233,
		237,
		226,
		177,
		196,
		220,
		257,
		206,
		195,
		194,
		-1,
		185,
		162,
		159,
		147,
		134,
		119,
		120,
		128,
		141,
		120,
		115,
		112,
		132,
		158,
		136,
		148,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		203,
		174,
		198,
		240,
		224,
		217,
		205,
		170,
		170,
		164,
		-1,
		158,
		137,
		128,
		117,
		115,
		128,
		125,
		130,
		110,
		108,
		127,
		139,
		130,
		147,
		-1,
		-1,
		-1,
		233,
		222,
		223,
		169,
		192,
		229,
		203,
		189,
		194,
		169,
		162,
		156,
		171,
		154,
		135,
		124,
		116,
		105,
		121,
		129,
		124,
		106,
		115,
		121,
		145,
		135,
		141,
		-1,
		-1,
		240,
		230,
		214,
		216,
		213,
		183,
		190,
		222,
		194,
		207,
		-1,
		161,
		-1,
		150,
		145,
		129,
		124,
		121,
		118,
		112,
		121,
		123,
		113,
		108,
		115,
		150,
		150,
		125,
		145,
		148,
		-1,
		-1,
		-1,
		233,
		228,
		203,
		180,
		164,
		200,
		-1,
		177,
		178,
		-1,
		155,
		149,
		146,
		131,
		127,
		122,
		126,
		119,
		126,
		119,
		117,
		118,
		100,
		132,
		-1,
		133,
		127,
		135,
		125,
		113,
		-1,
		-1,
		-1,
		226,
		205,
		198,
		218,
		159,
		211,
		-1,
		-1,
		162,
		155,
		-1,
		142,
		124,
		131,
		129,
		123,
		127,
		124,
		113,
		126,
		119,
		105,
		107,
		120,
		124,
		128,
		115,
		111,
		108,
		122,
		-1,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		179,
		-1,
		171,
		163,
		153,
		147,
		141,
		137,
		135,
		151,
		135,
		138,
		136,
		127,
		135,
		108,
		101,
		108,
		97,
		115,
		123,
		115,
		109,
		108,
		118,
		-1,
		246,
		232,
		203,
		-1,
		-1,
		192,
		-1,
		156,
		170,
		186,
		-1,
		179,
		158,
		173,
		151,
		147,
		143,
		158,
		159,
		137,
		136,
		134,
		125,
		113,
		102,
		105,
		97,
		119,
		119,
		103,
		104,
		108,
		-1,
		252,
		239,
		197,
		193,
		182,
		202,
		153,
		141,
		173,
		-1,
		-1,
		215,
		-1,
		149,
		166,
		157,
		155,
		148,
		139,
		145,
		145,
		122,
		117,
		107,
		96,
		96,
		91,
		113,
		99,
		97,
		106,
		122,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		168,
		155,
		149,
		-1,
		190,
		-1,
		193,
		183,
		167,
		152,
		185,
		-1,
		150,
		140,
		145,
		-1,
		142,
		-1,
		115,
		112,
		103,
		88,
		85,
		96,
		94,
		105,
		101,
		-1,
		202,
		187,
		180,
		170,
		184,
		155,
		-1,
		210,
		-1,
		-1,
		180,
		174,
		174,
		158,
		161,
		166,
		146,
		138,
		145,
		137,
		129,
		123,
		101,
		94,
		91,
		84,
		97,
		107,
		112,
		99,
		-1,
		-1,
		-1,
		207,
		193,
		197,
		157,
		176,
		-1,
		-1,
		242,
		197,
		183,
		-1,
		167,
		166,
		154,
		144,
		134,
		139,
		140,
		120,
		113,
		99,
		101,
		95,
		86,
		85,
		101,
		93,
		115,
		-1,
		-1,
		190,
		195,
		183,
		169,
		188,
		-1,
		-1,
		-1,
		189,
		205,
		194,
		168,
		155,
		-1,
		-1,
		138,
		131,
		125,
		116,
		103,
		115,
		110,
		94,
		79,
		94,
		98,
		106,
		97,
		-1,
		193,
		180,
		-1,
		-1,
		191,
		185,
		-1,
		-1,
		-1,
		-1,
		206,
		151,
		140,
		135,
		139,
		137,
		-1,
		111,
		122,
		107,
		119,
		126,
		96,
		81,
		75,
		81,
		93,
		102,
		-1,
		-1,
		205,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		163,
		157,
		128,
		121,
		125,
		-1,
		113,
		115,
		109,
		124,
		99,
		96,
		87,
		78,
		74,
		78,
		82,
		96,
		100,
		228,
		-1,
		188,
		-1,
		-1,
		-1,
		181,
		196,
		167,
		144,
		117,
		112,
		105,
		99,
		104,
		115,
		107,
		118,
		85,
		81,
		71,
		70,
		74,
		91,
		91,
		-1,
		-1,
		186,
		182,
		207,
		189,
		193,
		194,
		-1,
		-1,
		121,
		112,
		103,
		95,
		108,
		111,
		91,
		88,
		82,
		75,
		69,
		79,
		90,
		85,
		-1,
		-1,
		-1,
		198,
		-1,
		200,
		-1,
		-1,
		188,
		192,
		139,
		121,
		117,
		115,
		104,
		98,
		86,
		91,
		92,
		83,
		77,
		65,
		65,
		88,
		77,
		94,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		177,
		169,
		164,
		170,
		172,
		163,
		154,
		151,
		-1,
		121,
		127,
		92,
		99,
		82,
		89,
		87,
		79,
		59,
		62,
		78,
		77,
		72,
		86,
		77,
		81,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		170,
		166,
		156,
		146,
		149,
		-1,
		-1,
		143,
		140,
		120,
		89,
		90,
		83,
		78,
		87,
		68,
		55,
		55,
		50,
		65,
		70,
		72,
		65,
		72,
		87,
		-1,
		217,
		254,
		247,
		215,
		223,
		254,
		-1,
		160,
		152,
		163,
		138,
		140,
		-1,
		-1,
		116,
		107,
		108,
		96,
		93,
		98,
		93,
		72,
		64,
		70,
		48,
		55,
		66,
		58,
		62,
		63,
		70,
		81,
		85,
		-1,
		210,
		230,
		209,
		212,
		236,
		250,
		-1,
		157,
		-1,
		-1,
		169,
		141,
		125,
		115,
		112,
		155,
		102,
		97,
		74,
		72,
		69,
		60,
		72,
		56,
		44,
		41,
		50,
		55,
		47,
		73,
		75,
		81,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		167,
		-1,
		152,
		-1,
		135,
		139,
		110,
		113,
		88,
		75,
		61,
		61,
		67,
		56,
		52,
		48,
		37,
		46,
		57,
		69,
		79,
		81,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		169,
		208,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		149,
		123,
		115,
		108,
		87,
		87,
		53,
		49,
		61,
		57,
		62,
		54,
		38,
		50,
		63,
		74,
		89,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		184,
		175,
		202,
		180,
		169,
		164,
		151,
		-1,
		-1,
		130,
		133,
		-1,
		-1,
		94,
		70,
		57,
		51,
		55,
		69,
		62,
		50,
		30,
		50,
		45,
		77,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		203,
		193,
		197,
		211,
		236,
		-1,
		140,
		-1,
		-1,
		110,
		-1,
		-1,
		95,
		75,
		64,
		55,
		41,
		63,
		66,
		77,
		26,
		43,
		50,
		60,
		73,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		197,
		225,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		93,
		91,
		80,
		-1,
		70,
		52,
		38,
		65,
		33,
		0,
		29,
		23,
		30,
		56,
		69,
		73,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		88,
		81,
		69,
		57,
		47,
		52,
		38,
		34,
		20,
		13,
		21,
		28,
		46,
		50,
		67,
		-1,
		240,
		-1,
		192,
		168,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		122,
		106,
		87,
		-1,
		57,
		70,
		70,
		38,
		38,
		32,
		27,
		35,
		49,
		52,
		66,
		61,
		-1,
		-1,
		180,
		179,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		94,
		90,
		-1,
		-1,
		58,
		52,
		41,
		44,
		39,
		31,
		37,
		47,
		51,
		55,
		67,
		-1,
		-1,
		174,
		166,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		96,
		59,
		80,
		59,
		60,
		58,
		49,
		35,
		42,
		52,
		58,
		69,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		95,
		-1,
		63,
		60,
		73,
		58,
		71,
		65,
		38,
		53,
		53,
		56,
		60,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		92,
		71,
		-1,
		105,
		80,
		87,
		72,
		53,
		40,
		47,
		61,
		57,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		85,
		85,
		76,
		84,
		77,
		73,
		60,
		60,
		52,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		80,
		88,
		86,
		83,
		79,
		70,
		76,
		53,
		89,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		114,
		77,
		65,
		60,
		61,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		76,
		65,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		221,
		210,
		221,
		229,
		202,
		209,
		-1,
		228,
		232,
		198,
		192,
		231,
		200,
		206,
		217,
		-1,
		-1,
		-1,
		221,
		220,
		188,
		186,
		195,
		200,
		207,
		-1,
		206,
		-1,
		242,
		221,
		232,
		237,
		181,
		178,
		198,
		217,
		199,
		191,
		257,
		211,
		182,
		176,
		194,
		184,
		193,
		185,
		-1,
		182,
		172,
		194,
		173,
		184,
		176,
		-1,
		-1,
		176,
		177,
		183,
		169,
		175,
		171,
		-1,
		181,
		165,
		-1,
		-1,
		166,
		167,
		151,
		154,
		162,
		160,
		173,
		165,
		160,
		-1,
		-1,
		157,
		153,
		160,
		147,
		143,
		160,
		173,
		155,
		169,
		168,
		-1,
		161,
		179,
		186,
		154,
		152,
		136,
		134,
		152,
		154,
		160,
		160,
		-1,
		170,
		171,
		166,
		174,
		176,
		152,
		139,
		139,
		149,
		142,
		161,
		149,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		170,
		153,
		170,
		162,
		152,
		167,
		160,
		142,
		139,
		137,
		134,
		150,
		148,
		158,
		-1,
		-1,
		263,
		232,
		261,
		219,
		200,
		-1,
		166,
		146,
		152,
		156,
		150,
		143,
		157,
		153,
		-1,
		128,
		127,
		155,
		141,
		152,
		223,
		-1,
		-1,
		221,
		213,
		196,
		199,
		176,
		172,
		161,
		160,
		152,
		138,
		134,
		140,
		143,
		143,
		149,
		122,
		132,
		136,
		134,
		159,
		-1,
		-1,
		194,
		-1,
		-1,
		220,
		203,
		-1,
		186,
		193,
		182,
		188,
		174,
		195,
		171,
		162,
		154,
		148,
		136,
		138,
		135,
		148,
		136,
		119,
		144,
		148,
		129,
		150,
		145,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		179,
		182,
		188,
		212,
		211,
		-1,
		183,
		171,
		172,
		157,
		154,
		141,
		129,
		142,
		127,
		134,
		133,
		123,
		121,
		151,
		126,
		148,
		145,
		164,
		169,
		163,
		172,
		-1,
		228,
		224,
		220,
		227,
		176,
		-1,
		-1,
		216,
		-1,
		219,
		220,
		195,
		168,
		171,
		158,
		149,
		136,
		125,
		136,
		125,
		122,
		130,
		115,
		130,
		121,
		120,
		138,
		148,
		156,
		160,
		166,
		-1,
		278,
		-1,
		220,
		204,
		206,
		178,
		199,
		-1,
		236,
		220,
		212,
		197,
		197,
		-1,
		167,
		164,
		154,
		132,
		117,
		134,
		126,
		124,
		128,
		110,
		124,
		115,
		133,
		140,
		138,
		142,
		162,
		174,
		238,
		228,
		-1,
		210,
		215,
		174,
		182,
		201,
		239,
		203,
		-1,
		198,
		-1,
		169,
		182,
		-1,
		138,
		134,
		116,
		117,
		112,
		127,
		121,
		106,
		103,
		121,
		124,
		131,
		135,
		151,
		-1,
		-1,
		223,
		227,
		216,
		167,
		186,
		210,
		247,
		196,
		185,
		184,
		-1,
		175,
		152,
		149,
		137,
		124,
		109,
		110,
		118,
		131,
		110,
		105,
		102,
		122,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		193,
		164,
		188,
		230,
		214,
		207,
		195,
		160,
		160,
		154,
		-1,
		148,
		127,
		118,
		107,
		105,
		118,
		115,
		120,
		100,
		98,
		117,
		129,
		120,
		137,
		-1,
		-1,
		-1,
		223,
		212,
		213,
		159,
		182,
		219,
		193,
		179,
		184,
		159,
		152,
		146,
		161,
		144,
		125,
		114,
		106,
		95,
		111,
		119,
		114,
		96,
		105,
		111,
		135,
		125,
		131,
		-1,
		-1,
		230,
		220,
		204,
		206,
		203,
		173,
		180,
		212,
		184,
		197,
		-1,
		151,
		-1,
		140,
		135,
		119,
		114,
		111,
		108,
		102,
		111,
		113,
		103,
		98,
		105,
		140,
		140,
		115,
		135,
		138,
		-1,
		-1,
		-1,
		223,
		218,
		193,
		170,
		154,
		190,
		-1,
		167,
		168,
		-1,
		145,
		139,
		136,
		121,
		117,
		112,
		116,
		109,
		116,
		109,
		107,
		108,
		90,
		122,
		-1,
		123,
		117,
		125,
		115,
		103,
		-1,
		-1,
		-1,
		216,
		195,
		188,
		208,
		149,
		201,
		-1,
		-1,
		152,
		145,
		-1,
		132,
		114,
		121,
		119,
		113,
		117,
		114,
		103,
		116,
		109,
		95,
		97,
		110,
		114,
		118,
		105,
		101,
		98,
		112,
		-1,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		169,
		-1,
		161,
		153,
		143,
		137,
		131,
		127,
		125,
		141,
		125,
		128,
		126,
		117,
		125,
		98,
		91,
		98,
		87,
		105,
		113,
		105,
		99,
		98,
		108,
		-1,
		236,
		222,
		193,
		-1,
		-1,
		182,
		-1,
		146,
		160,
		176,
		-1,
		169,
		148,
		163,
		141,
		137,
		133,
		148,
		149,
		127,
		126,
		124,
		115,
		103,
		92,
		95,
		87,
		109,
		109,
		93,
		94,
		98,
		-1,
		242,
		229,
		187,
		183,
		172,
		192,
		143,
		131,
		163,
		-1,
		-1,
		205,
		-1,
		139,
		156,
		147,
		145,
		138,
		129,
		135,
		135,
		112,
		107,
		97,
		86,
		86,
		81,
		103,
		89,
		87,
		96,
		112,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		158,
		145,
		139,
		-1,
		180,
		-1,
		183,
		173,
		157,
		142,
		175,
		-1,
		140,
		130,
		135,
		-1,
		132,
		-1,
		105,
		102,
		93,
		78,
		75,
		86,
		84,
		95,
		91,
		-1,
		192,
		177,
		170,
		160,
		174,
		145,
		-1,
		200,
		-1,
		-1,
		170,
		164,
		164,
		148,
		151,
		156,
		136,
		128,
		135,
		127,
		119,
		113,
		91,
		84,
		81,
		74,
		87,
		97,
		102,
		89,
		-1,
		-1,
		-1,
		197,
		183,
		187,
		147,
		166,
		-1,
		-1,
		232,
		187,
		173,
		-1,
		157,
		156,
		144,
		134,
		124,
		129,
		130,
		110,
		103,
		89,
		91,
		85,
		76,
		75,
		91,
		83,
		105,
		-1,
		-1,
		180,
		185,
		173,
		159,
		178,
		-1,
		-1,
		-1,
		179,
		195,
		184,
		158,
		145,
		-1,
		-1,
		128,
		121,
		115,
		106,
		93,
		105,
		100,
		84,
		69,
		84,
		88,
		96,
		87,
		-1,
		183,
		170,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		97,
		109,
		116,
		86,
		71,
		65,
		71,
		83,
		92,
		-1,
		-1,
		195,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		99,
		114,
		89,
		86,
		77,
		68,
		64,
		68,
		72,
		86,
		90,
		218,
		-1,
		181,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		97,
		108,
		75,
		71,
		61,
		60,
		64,
		81,
		81,
		-1,
		-1,
		179,
		175,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		81,
		78,
		72,
		65,
		59,
		69,
		80,
		75,
		-1,
		-1,
		-1,
		191,
		-1,
		193,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		94,
		88,
		76,
		81,
		82,
		73,
		67,
		55,
		55,
		78,
		67,
		84,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		170,
		162,
		157,
		163,
		165,
		156,
		144,
		141,
		-1,
		111,
		117,
		82,
		89,
		72,
		79,
		77,
		69,
		49,
		52,
		68,
		67,
		62,
		76,
		67,
		71,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		163,
		159,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		80,
		73,
		68,
		78,
		58,
		45,
		45,
		40,
		55,
		60,
		62,
		55,
		62,
		77,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		153,
		145,
		156,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		88,
		83,
		74,
		54,
		60,
		38,
		45,
		56,
		48,
		52,
		53,
		60,
		71,
		75,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		150,
		-1,
		-1,
		162,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		77,
		75,
		71,
		62,
		62,
		46,
		34,
		31,
		40,
		45,
		37,
		63,
		65,
		71,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		170,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		91,
		78,
		64,
		62,
		70,
		46,
		42,
		38,
		27,
		36,
		47,
		55,
		65,
		71,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		162,
		201,
		176,
		-1,
		160,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		111,
		90,
		90,
		56,
		52,
		51,
		47,
		47,
		40,
		23,
		40,
		49,
		60,
		75,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		168,
		195,
		183,
		172,
		167,
		154,
		-1,
		-1,
		133,
		134,
		-1,
		-1,
		97,
		73,
		60,
		54,
		58,
		61,
		47,
		35,
		15,
		35,
		35,
		63,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		196,
		186,
		190,
		206,
		231,
		-1,
		143,
		-1,
		-1,
		113,
		-1,
		-1,
		98,
		78,
		67,
		58,
		44,
		64,
		51,
		62,
		11,
		33,
		40,
		46,
		59,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		159,
		139,
		-1,
		-1,
		96,
		94,
		83,
		-1,
		73,
		55,
		41,
		68,
		36,
		25,
		0,
		8,
		20,
		46,
		56,
		63,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		145,
		-1,
		-1,
		91,
		84,
		72,
		60,
		50,
		55,
		41,
		37,
		23,
		16,
		11,
		22,
		36,
		40,
		57,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		125,
		109,
		90,
		-1,
		60,
		73,
		73,
		41,
		41,
		35,
		17,
		28,
		39,
		42,
		56,
		51,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		156,
		158,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		97,
		93,
		-1,
		-1,
		61,
		55,
		44,
		47,
		42,
		21,
		27,
		37,
		41,
		45,
		57,
		-1,
		-1,
		177,
		169,
		163,
		-1,
		141,
		-1,
		159,
		-1,
		126,
		132,
		120,
		-1,
		-1,
		-1,
		99,
		62,
		83,
		62,
		50,
		48,
		39,
		25,
		32,
		42,
		48,
		59,
		-1,
		-1,
		-1,
		159,
		133,
		166,
		157,
		140,
		120,
		112,
		131,
		-1,
		98,
		-1,
		66,
		63,
		76,
		58,
		61,
		55,
		28,
		43,
		43,
		46,
		50,
		165,
		-1,
		135,
		168,
		132,
		126,
		102,
		106,
		122,
		-1,
		95,
		74,
		-1,
		103,
		83,
		77,
		62,
		43,
		30,
		37,
		51,
		47,
		-1,
		-1,
		-1,
		137,
		136,
		128,
		122,
		122,
		107,
		98,
		-1,
		110,
		92,
		71,
		88,
		83,
		74,
		74,
		67,
		63,
		50,
		50,
		42,
		-1,
		238,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		131,
		126,
		99,
		87,
		93,
		89,
		75,
		81,
		83,
		86,
		76,
		73,
		69,
		60,
		66,
		43,
		79,
		-1,
		233,
		-1,
		167,
		-1,
		-1,
		149,
		129,
		121,
		110,
		99,
		97,
		88,
		79,
		101,
		117,
		67,
		55,
		50,
		51,
		-1,
		222,
		221,
		-1,
		168,
		160,
		146,
		-1,
		139,
		-1,
		145,
		106,
		-1,
		108,
		88,
		-1,
		66,
		55,
		-1,
		-1,
		209,
		184,
		-1,
		-1,
		-1,
		169,
		149,
		140,
		124,
		-1,
		99,
		99,
		-1,
		-1,
		-1,
		194,
		193,
		-1,
		162,
		165,
		-1,
		155,
		146,
		154,
		101,
		105,
		-1,
		-1,
		-1,
		203,
		184,
		178,
		177,
		175,
		170,
		167,
		153,
		137,
		115,
		104,
		125,
		-1,
		-1,
		-1,
		175,
		167,
		160,
		-1,
		-1,
		162,
		145,
		126,
		124,
		-1,
		-1,
		-1,
		197,
		178,
		-1,
		-1,
		152,
		-1,
		-1,
		158,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		186,
		-1,
		-1,
		-1,
		148,
		144,
		145,
		-1,
		-1,
		-1,
		-1,
		208,
		209,
		232,
		196,
		-1,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		211,
		209,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		138,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		173,
		-1,
		173,
		148,
		155,
		-1,
		-1,
		-1,
		-1,
		186,
		178,
		186,
		-1,
		158,
		160,
		-1,
		208,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		163,
		170,
		192,
		195,
		231,
		-1,
		182
	],
	[
		-1,
		213,
		202,
		213,
		221,
		194,
		201,
		-1,
		220,
		224,
		190,
		184,
		223,
		192,
		198,
		209,
		-1,
		-1,
		-1,
		213,
		212,
		180,
		178,
		187,
		192,
		199,
		-1,
		198,
		-1,
		234,
		213,
		224,
		229,
		173,
		170,
		190,
		209,
		191,
		183,
		249,
		203,
		174,
		168,
		186,
		176,
		185,
		177,
		-1,
		174,
		164,
		186,
		165,
		176,
		168,
		-1,
		-1,
		168,
		169,
		175,
		161,
		167,
		163,
		-1,
		173,
		157,
		-1,
		-1,
		158,
		159,
		143,
		146,
		154,
		152,
		165,
		157,
		152,
		-1,
		-1,
		149,
		145,
		152,
		139,
		135,
		152,
		165,
		147,
		161,
		160,
		-1,
		153,
		171,
		178,
		146,
		144,
		128,
		126,
		144,
		146,
		152,
		152,
		-1,
		162,
		163,
		158,
		166,
		168,
		144,
		131,
		131,
		141,
		134,
		153,
		141,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		162,
		145,
		162,
		154,
		144,
		159,
		152,
		134,
		131,
		129,
		126,
		142,
		140,
		150,
		-1,
		-1,
		255,
		224,
		253,
		211,
		192,
		-1,
		158,
		138,
		144,
		148,
		142,
		135,
		149,
		145,
		-1,
		120,
		119,
		147,
		133,
		144,
		215,
		-1,
		-1,
		213,
		205,
		188,
		191,
		168,
		164,
		153,
		152,
		144,
		130,
		126,
		132,
		135,
		135,
		141,
		114,
		124,
		128,
		126,
		151,
		-1,
		-1,
		186,
		-1,
		-1,
		212,
		195,
		-1,
		178,
		185,
		174,
		180,
		166,
		187,
		163,
		154,
		146,
		140,
		128,
		130,
		127,
		140,
		128,
		111,
		136,
		140,
		121,
		142,
		137,
		-1,
		185,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		171,
		174,
		180,
		204,
		203,
		-1,
		175,
		163,
		164,
		149,
		146,
		133,
		121,
		134,
		119,
		126,
		125,
		115,
		113,
		143,
		118,
		140,
		137,
		156,
		161,
		155,
		164,
		-1,
		220,
		216,
		212,
		219,
		168,
		-1,
		-1,
		208,
		-1,
		211,
		212,
		187,
		160,
		163,
		150,
		141,
		128,
		117,
		128,
		117,
		114,
		122,
		107,
		122,
		113,
		112,
		130,
		140,
		148,
		152,
		158,
		-1,
		270,
		-1,
		212,
		196,
		198,
		170,
		191,
		-1,
		228,
		212,
		204,
		189,
		189,
		-1,
		159,
		156,
		146,
		124,
		109,
		126,
		118,
		116,
		120,
		102,
		116,
		107,
		125,
		132,
		130,
		134,
		154,
		166,
		230,
		220,
		-1,
		202,
		207,
		166,
		174,
		193,
		231,
		195,
		-1,
		190,
		-1,
		161,
		174,
		-1,
		130,
		126,
		108,
		109,
		104,
		119,
		113,
		98,
		95,
		113,
		116,
		123,
		127,
		143,
		-1,
		-1,
		215,
		219,
		208,
		159,
		178,
		202,
		239,
		188,
		177,
		176,
		-1,
		167,
		144,
		141,
		129,
		116,
		101,
		102,
		110,
		123,
		102,
		97,
		94,
		114,
		140,
		118,
		130,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		185,
		156,
		180,
		222,
		206,
		199,
		187,
		152,
		152,
		146,
		-1,
		140,
		119,
		110,
		99,
		97,
		110,
		107,
		112,
		92,
		90,
		109,
		121,
		112,
		129,
		-1,
		-1,
		-1,
		215,
		204,
		205,
		151,
		174,
		211,
		185,
		171,
		176,
		151,
		144,
		138,
		153,
		136,
		117,
		106,
		98,
		87,
		103,
		111,
		106,
		88,
		97,
		103,
		127,
		117,
		123,
		-1,
		-1,
		222,
		212,
		196,
		198,
		195,
		165,
		172,
		204,
		176,
		189,
		-1,
		143,
		-1,
		132,
		127,
		111,
		106,
		103,
		100,
		94,
		103,
		105,
		95,
		90,
		97,
		132,
		132,
		107,
		127,
		130,
		-1,
		-1,
		-1,
		215,
		210,
		185,
		162,
		146,
		182,
		-1,
		159,
		160,
		-1,
		137,
		131,
		128,
		113,
		109,
		104,
		108,
		101,
		108,
		101,
		99,
		100,
		82,
		114,
		-1,
		115,
		109,
		117,
		107,
		95,
		-1,
		-1,
		-1,
		208,
		187,
		180,
		200,
		141,
		193,
		-1,
		-1,
		144,
		137,
		-1,
		124,
		106,
		113,
		111,
		105,
		109,
		106,
		95,
		108,
		101,
		87,
		89,
		102,
		106,
		110,
		97,
		93,
		90,
		104,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		161,
		-1,
		153,
		145,
		135,
		129,
		123,
		119,
		117,
		133,
		117,
		120,
		118,
		109,
		117,
		90,
		83,
		90,
		79,
		97,
		105,
		97,
		91,
		90,
		100,
		-1,
		228,
		214,
		185,
		-1,
		-1,
		174,
		-1,
		138,
		152,
		168,
		-1,
		161,
		140,
		155,
		133,
		129,
		125,
		140,
		141,
		119,
		118,
		116,
		107,
		95,
		84,
		87,
		79,
		101,
		101,
		85,
		86,
		90,
		-1,
		234,
		221,
		179,
		175,
		164,
		184,
		135,
		123,
		155,
		-1,
		-1,
		197,
		-1,
		131,
		148,
		139,
		137,
		130,
		121,
		127,
		127,
		104,
		99,
		89,
		78,
		78,
		73,
		95,
		81,
		79,
		88,
		104,
		-1,
		-1,
		-1,
		201,
		-1,
		-1,
		150,
		137,
		131,
		-1,
		172,
		-1,
		175,
		165,
		149,
		134,
		167,
		-1,
		132,
		122,
		127,
		-1,
		124,
		-1,
		97,
		94,
		85,
		70,
		67,
		78,
		76,
		87,
		83,
		-1,
		184,
		169,
		162,
		152,
		166,
		137,
		-1,
		192,
		-1,
		-1,
		162,
		156,
		156,
		140,
		143,
		148,
		128,
		120,
		127,
		119,
		111,
		105,
		83,
		76,
		73,
		66,
		79,
		89,
		94,
		81,
		-1,
		-1,
		-1,
		189,
		175,
		179,
		139,
		158,
		-1,
		-1,
		224,
		179,
		165,
		-1,
		149,
		148,
		136,
		126,
		116,
		121,
		122,
		102,
		95,
		81,
		83,
		77,
		68,
		67,
		83,
		75,
		97,
		-1,
		-1,
		172,
		177,
		165,
		151,
		170,
		-1,
		-1,
		-1,
		171,
		187,
		176,
		150,
		137,
		-1,
		-1,
		120,
		113,
		107,
		98,
		85,
		97,
		92,
		76,
		61,
		76,
		80,
		88,
		79,
		-1,
		175,
		162,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		-1,
		-1,
		188,
		133,
		122,
		117,
		121,
		119,
		-1,
		93,
		104,
		89,
		101,
		108,
		78,
		63,
		57,
		63,
		75,
		84,
		-1,
		-1,
		187,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		145,
		139,
		110,
		103,
		107,
		-1,
		95,
		97,
		91,
		106,
		81,
		78,
		69,
		60,
		56,
		60,
		64,
		78,
		82,
		210,
		-1,
		173,
		-1,
		-1,
		-1,
		163,
		178,
		149,
		126,
		99,
		94,
		87,
		81,
		86,
		97,
		89,
		100,
		67,
		63,
		53,
		52,
		56,
		73,
		73,
		-1,
		-1,
		171,
		167,
		189,
		171,
		175,
		176,
		-1,
		-1,
		103,
		94,
		85,
		77,
		90,
		93,
		73,
		70,
		64,
		57,
		51,
		61,
		72,
		67,
		-1,
		-1,
		-1,
		183,
		-1,
		185,
		-1,
		-1,
		173,
		174,
		121,
		103,
		99,
		97,
		86,
		80,
		68,
		73,
		74,
		65,
		59,
		47,
		47,
		70,
		59,
		76,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		162,
		154,
		149,
		155,
		157,
		148,
		136,
		133,
		-1,
		103,
		109,
		74,
		81,
		64,
		71,
		69,
		61,
		41,
		44,
		60,
		59,
		54,
		68,
		59,
		63,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		155,
		151,
		141,
		131,
		134,
		-1,
		-1,
		128,
		125,
		105,
		74,
		72,
		65,
		60,
		70,
		50,
		37,
		37,
		32,
		47,
		52,
		54,
		47,
		54,
		69,
		-1,
		202,
		239,
		232,
		200,
		208,
		239,
		-1,
		145,
		137,
		148,
		123,
		125,
		-1,
		-1,
		101,
		92,
		93,
		81,
		78,
		80,
		75,
		66,
		46,
		52,
		30,
		37,
		48,
		40,
		44,
		45,
		52,
		63,
		67,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		142,
		-1,
		-1,
		154,
		126,
		110,
		100,
		97,
		140,
		95,
		90,
		69,
		67,
		63,
		54,
		54,
		38,
		26,
		23,
		32,
		37,
		29,
		55,
		57,
		63,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		162,
		-1,
		137,
		-1,
		120,
		124,
		103,
		106,
		83,
		70,
		56,
		54,
		62,
		38,
		34,
		30,
		19,
		28,
		39,
		47,
		57,
		63,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		154,
		193,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		134,
		116,
		108,
		103,
		82,
		82,
		48,
		44,
		43,
		39,
		39,
		32,
		15,
		32,
		41,
		52,
		67,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		169,
		160,
		187,
		175,
		164,
		159,
		146,
		-1,
		-1,
		125,
		126,
		-1,
		-1,
		89,
		65,
		52,
		46,
		50,
		53,
		39,
		27,
		7,
		27,
		27,
		55,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		167,
		188,
		178,
		182,
		198,
		223,
		-1,
		135,
		-1,
		-1,
		105,
		-1,
		-1,
		90,
		70,
		59,
		50,
		36,
		56,
		43,
		54,
		3,
		25,
		32,
		38,
		51,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		154,
		152,
		158,
		165,
		182,
		212,
		-1,
		-1,
		151,
		131,
		-1,
		-1,
		88,
		86,
		75,
		-1,
		65,
		47,
		33,
		60,
		28,
		17,
		6,
		0,
		12,
		38,
		48,
		55,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		141,
		137,
		-1,
		-1,
		83,
		76,
		64,
		52,
		42,
		47,
		33,
		29,
		15,
		8,
		3,
		14,
		28,
		32,
		49,
		-1,
		225,
		-1,
		177,
		153,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		158,
		144,
		137,
		125,
		123,
		-1,
		117,
		101,
		82,
		-1,
		52,
		65,
		65,
		33,
		33,
		27,
		9,
		20,
		31,
		34,
		48,
		43,
		-1,
		-1,
		165,
		168,
		-1,
		-1,
		148,
		150,
		-1,
		149,
		138,
		123,
		115,
		-1,
		-1,
		89,
		85,
		-1,
		-1,
		53,
		47,
		36,
		39,
		34,
		13,
		19,
		29,
		33,
		37,
		49,
		-1,
		-1,
		169,
		161,
		155,
		-1,
		133,
		-1,
		151,
		-1,
		118,
		124,
		112,
		-1,
		-1,
		-1,
		91,
		54,
		75,
		54,
		42,
		40,
		31,
		17,
		24,
		34,
		40,
		51,
		-1,
		-1,
		-1,
		151,
		125,
		158,
		149,
		132,
		112,
		104,
		123,
		-1,
		90,
		-1,
		58,
		55,
		68,
		50,
		53,
		47,
		20,
		35,
		35,
		38,
		42,
		157,
		-1,
		127,
		160,
		124,
		118,
		94,
		98,
		114,
		-1,
		87,
		66,
		-1,
		95,
		75,
		69,
		54,
		35,
		22,
		29,
		43,
		39,
		-1,
		-1,
		-1,
		129,
		128,
		120,
		114,
		114,
		99,
		90,
		-1,
		102,
		84,
		63,
		80,
		75,
		66,
		66,
		59,
		55,
		42,
		42,
		34,
		-1,
		230,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		123,
		118,
		91,
		79,
		85,
		81,
		67,
		73,
		75,
		78,
		68,
		65,
		61,
		52,
		58,
		35,
		71,
		-1,
		225,
		-1,
		159,
		-1,
		-1,
		141,
		121,
		113,
		102,
		91,
		89,
		80,
		71,
		93,
		109,
		59,
		47,
		42,
		43,
		-1,
		214,
		213,
		-1,
		160,
		152,
		138,
		-1,
		131,
		-1,
		137,
		98,
		-1,
		100,
		80,
		-1,
		58,
		47,
		-1,
		-1,
		201,
		176,
		-1,
		-1,
		-1,
		161,
		141,
		132,
		116,
		-1,
		91,
		91,
		-1,
		-1,
		-1,
		186,
		185,
		-1,
		154,
		157,
		-1,
		147,
		138,
		146,
		93,
		97,
		-1,
		-1,
		-1,
		195,
		176,
		170,
		169,
		167,
		162,
		159,
		145,
		129,
		107,
		96,
		117,
		-1,
		-1,
		-1,
		167,
		159,
		152,
		-1,
		-1,
		154,
		137,
		118,
		116,
		-1,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		144,
		-1,
		-1,
		150,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		178,
		-1,
		-1,
		-1,
		140,
		136,
		137,
		-1,
		-1,
		-1,
		-1,
		200,
		201,
		224,
		188,
		-1,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		203,
		201,
		-1,
		-1,
		-1,
		160,
		144,
		-1,
		130,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		165,
		-1,
		165,
		140,
		147,
		-1,
		-1,
		-1,
		-1,
		178,
		170,
		178,
		-1,
		150,
		152,
		-1,
		200,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		155,
		162,
		184,
		187,
		223,
		-1,
		174
	],
	[
		-1,
		222,
		211,
		222,
		230,
		203,
		210,
		-1,
		229,
		233,
		199,
		193,
		232,
		201,
		207,
		218,
		-1,
		-1,
		-1,
		222,
		221,
		189,
		187,
		196,
		201,
		208,
		-1,
		207,
		-1,
		243,
		222,
		233,
		238,
		182,
		179,
		199,
		218,
		200,
		192,
		258,
		212,
		183,
		177,
		195,
		185,
		194,
		186,
		-1,
		183,
		173,
		195,
		174,
		185,
		177,
		-1,
		-1,
		177,
		178,
		184,
		170,
		176,
		172,
		-1,
		182,
		166,
		-1,
		-1,
		167,
		168,
		152,
		155,
		163,
		161,
		174,
		166,
		161,
		-1,
		-1,
		158,
		154,
		161,
		148,
		144,
		161,
		174,
		156,
		170,
		169,
		-1,
		162,
		180,
		187,
		155,
		153,
		137,
		135,
		153,
		155,
		161,
		161,
		-1,
		171,
		172,
		167,
		175,
		177,
		153,
		140,
		140,
		150,
		143,
		162,
		150,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		154,
		171,
		163,
		153,
		168,
		161,
		143,
		140,
		138,
		135,
		151,
		149,
		159,
		-1,
		-1,
		264,
		233,
		262,
		220,
		201,
		-1,
		167,
		147,
		153,
		157,
		151,
		144,
		158,
		154,
		-1,
		129,
		128,
		156,
		142,
		153,
		224,
		-1,
		-1,
		222,
		214,
		197,
		200,
		177,
		173,
		162,
		161,
		153,
		139,
		135,
		141,
		144,
		144,
		150,
		123,
		133,
		137,
		135,
		160,
		-1,
		-1,
		195,
		-1,
		-1,
		221,
		204,
		-1,
		187,
		194,
		183,
		189,
		175,
		196,
		172,
		163,
		155,
		149,
		137,
		139,
		136,
		149,
		137,
		120,
		145,
		149,
		130,
		151,
		146,
		-1,
		194,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		180,
		183,
		189,
		213,
		212,
		-1,
		184,
		172,
		173,
		158,
		155,
		142,
		130,
		143,
		128,
		135,
		134,
		124,
		122,
		152,
		127,
		149,
		146,
		165,
		170,
		164,
		173,
		-1,
		229,
		225,
		221,
		228,
		177,
		-1,
		-1,
		217,
		-1,
		220,
		221,
		196,
		169,
		172,
		159,
		150,
		137,
		126,
		137,
		126,
		123,
		131,
		116,
		131,
		122,
		121,
		139,
		149,
		157,
		161,
		167,
		-1,
		279,
		-1,
		221,
		205,
		207,
		179,
		200,
		-1,
		237,
		221,
		213,
		198,
		198,
		-1,
		168,
		165,
		155,
		133,
		118,
		135,
		127,
		125,
		129,
		111,
		125,
		116,
		134,
		141,
		139,
		143,
		163,
		175,
		239,
		229,
		-1,
		211,
		216,
		175,
		183,
		202,
		240,
		204,
		-1,
		199,
		-1,
		170,
		183,
		-1,
		139,
		135,
		117,
		118,
		113,
		128,
		122,
		107,
		104,
		122,
		125,
		132,
		136,
		152,
		-1,
		-1,
		224,
		228,
		217,
		168,
		187,
		211,
		248,
		197,
		186,
		185,
		-1,
		176,
		153,
		150,
		138,
		125,
		110,
		111,
		119,
		132,
		111,
		106,
		103,
		123,
		149,
		127,
		139,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		194,
		165,
		189,
		231,
		215,
		208,
		196,
		161,
		161,
		155,
		-1,
		149,
		128,
		119,
		108,
		106,
		119,
		116,
		121,
		101,
		99,
		118,
		130,
		121,
		138,
		-1,
		-1,
		-1,
		224,
		213,
		214,
		160,
		183,
		220,
		194,
		180,
		185,
		160,
		153,
		147,
		162,
		145,
		126,
		115,
		107,
		96,
		112,
		120,
		115,
		97,
		106,
		112,
		136,
		126,
		132,
		-1,
		-1,
		231,
		221,
		205,
		207,
		204,
		174,
		181,
		213,
		185,
		198,
		-1,
		152,
		-1,
		141,
		136,
		120,
		115,
		112,
		109,
		103,
		112,
		114,
		104,
		99,
		106,
		141,
		141,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		224,
		219,
		194,
		171,
		155,
		191,
		-1,
		168,
		169,
		-1,
		146,
		140,
		137,
		122,
		118,
		113,
		117,
		110,
		117,
		110,
		108,
		109,
		91,
		123,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		217,
		196,
		189,
		209,
		150,
		202,
		-1,
		-1,
		153,
		146,
		-1,
		133,
		115,
		122,
		120,
		114,
		118,
		115,
		104,
		117,
		110,
		96,
		98,
		111,
		115,
		119,
		106,
		102,
		99,
		113,
		-1,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		170,
		-1,
		162,
		154,
		144,
		138,
		132,
		128,
		126,
		142,
		126,
		129,
		127,
		118,
		126,
		99,
		92,
		99,
		88,
		106,
		114,
		106,
		100,
		99,
		109,
		-1,
		237,
		223,
		194,
		-1,
		-1,
		183,
		-1,
		147,
		161,
		177,
		-1,
		170,
		149,
		164,
		142,
		138,
		134,
		149,
		150,
		128,
		127,
		125,
		116,
		104,
		93,
		96,
		88,
		110,
		110,
		94,
		95,
		99,
		-1,
		243,
		230,
		188,
		184,
		173,
		193,
		144,
		132,
		164,
		-1,
		-1,
		206,
		-1,
		140,
		157,
		148,
		146,
		139,
		130,
		136,
		136,
		113,
		108,
		98,
		87,
		87,
		82,
		104,
		90,
		88,
		97,
		113,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		159,
		146,
		140,
		-1,
		181,
		-1,
		184,
		174,
		158,
		143,
		176,
		-1,
		141,
		131,
		136,
		-1,
		133,
		-1,
		106,
		103,
		94,
		79,
		76,
		87,
		85,
		96,
		92,
		-1,
		193,
		178,
		171,
		161,
		175,
		146,
		-1,
		201,
		-1,
		-1,
		171,
		165,
		165,
		149,
		152,
		157,
		137,
		129,
		136,
		128,
		120,
		114,
		92,
		85,
		82,
		75,
		88,
		98,
		103,
		90,
		-1,
		-1,
		-1,
		198,
		184,
		188,
		148,
		167,
		-1,
		-1,
		233,
		188,
		174,
		-1,
		158,
		157,
		145,
		135,
		125,
		130,
		131,
		111,
		104,
		90,
		92,
		86,
		77,
		76,
		92,
		84,
		106,
		-1,
		-1,
		181,
		186,
		174,
		160,
		179,
		-1,
		-1,
		-1,
		180,
		196,
		185,
		159,
		146,
		-1,
		-1,
		129,
		122,
		116,
		107,
		94,
		106,
		101,
		85,
		70,
		85,
		89,
		97,
		88,
		-1,
		184,
		171,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		-1,
		-1,
		197,
		142,
		131,
		126,
		130,
		128,
		-1,
		102,
		113,
		98,
		110,
		117,
		87,
		72,
		66,
		72,
		84,
		93,
		-1,
		-1,
		196,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		154,
		148,
		119,
		112,
		116,
		-1,
		104,
		106,
		100,
		115,
		90,
		87,
		78,
		69,
		65,
		69,
		73,
		87,
		91,
		219,
		-1,
		182,
		-1,
		-1,
		-1,
		172,
		187,
		158,
		135,
		108,
		103,
		96,
		90,
		95,
		106,
		98,
		109,
		76,
		72,
		62,
		61,
		65,
		82,
		82,
		-1,
		-1,
		180,
		176,
		198,
		180,
		184,
		185,
		-1,
		-1,
		112,
		103,
		94,
		86,
		99,
		102,
		82,
		79,
		73,
		66,
		60,
		70,
		81,
		76,
		-1,
		-1,
		-1,
		192,
		-1,
		194,
		-1,
		-1,
		182,
		183,
		130,
		112,
		108,
		106,
		95,
		89,
		77,
		82,
		83,
		74,
		68,
		56,
		56,
		79,
		68,
		85,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		145,
		142,
		-1,
		112,
		118,
		83,
		90,
		73,
		80,
		78,
		70,
		50,
		53,
		69,
		68,
		63,
		77,
		68,
		72,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		137,
		134,
		114,
		83,
		81,
		74,
		69,
		79,
		59,
		46,
		46,
		41,
		56,
		61,
		63,
		56,
		63,
		78,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		110,
		101,
		102,
		90,
		87,
		89,
		84,
		75,
		55,
		61,
		39,
		46,
		57,
		49,
		53,
		54,
		61,
		72,
		76,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		151,
		-1,
		-1,
		163,
		135,
		119,
		109,
		106,
		149,
		104,
		99,
		78,
		76,
		72,
		63,
		63,
		47,
		35,
		32,
		41,
		46,
		38,
		64,
		66,
		71,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		171,
		-1,
		146,
		-1,
		129,
		133,
		112,
		115,
		92,
		79,
		65,
		63,
		71,
		47,
		43,
		39,
		28,
		35,
		47,
		50,
		60,
		72,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		163,
		202,
		177,
		-1,
		161,
		-1,
		-1,
		-1,
		143,
		125,
		117,
		112,
		91,
		91,
		57,
		53,
		52,
		48,
		53,
		45,
		29,
		34,
		44,
		55,
		70,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		169,
		196,
		184,
		173,
		168,
		155,
		-1,
		-1,
		134,
		135,
		-1,
		-1,
		98,
		74,
		61,
		55,
		59,
		62,
		53,
		41,
		21,
		30,
		27,
		58,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		197,
		187,
		191,
		207,
		232,
		-1,
		144,
		-1,
		-1,
		114,
		-1,
		-1,
		99,
		79,
		68,
		59,
		45,
		67,
		57,
		68,
		17,
		13,
		32,
		39,
		50,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		191,
		221,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		97,
		95,
		84,
		-1,
		74,
		56,
		42,
		69,
		37,
		26,
		20,
		14,
		0,
		26,
		39,
		43,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		92,
		85,
		73,
		61,
		51,
		56,
		42,
		38,
		24,
		17,
		12,
		18,
		16,
		20,
		37,
		-1,
		234,
		-1,
		186,
		162,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		126,
		110,
		91,
		-1,
		61,
		74,
		74,
		42,
		42,
		36,
		18,
		28,
		19,
		22,
		36,
		31,
		-1,
		-1,
		174,
		177,
		-1,
		-1,
		157,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		98,
		94,
		-1,
		-1,
		62,
		56,
		45,
		48,
		43,
		22,
		28,
		32,
		21,
		25,
		37,
		-1,
		-1,
		178,
		170,
		164,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		100,
		63,
		84,
		63,
		51,
		49,
		40,
		26,
		33,
		32,
		28,
		39,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		99,
		-1,
		67,
		64,
		77,
		59,
		62,
		56,
		29,
		44,
		35,
		26,
		35,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		96,
		75,
		-1,
		104,
		84,
		78,
		63,
		44,
		31,
		38,
		39,
		32,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		89,
		84,
		75,
		75,
		68,
		64,
		51,
		51,
		43,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		84,
		87,
		77,
		74,
		70,
		61,
		67,
		44,
		80,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		118,
		68,
		56,
		51,
		52,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		67,
		56,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		118,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		114,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		118,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		97,
		89,
		111,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		94,
		102,
		93,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		77,
		89,
		98,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		92,
		96,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		70,
		87,
		87,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		86,
		81,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		88,
		79,
		73,
		61,
		61,
		84,
		73,
		90,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		83,
		75,
		55,
		58,
		74,
		73,
		68,
		82,
		73,
		77,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		51,
		46,
		61,
		66,
		68,
		61,
		68,
		83,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		80,
		60,
		66,
		44,
		51,
		62,
		54,
		58,
		59,
		66,
		77,
		81,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		68,
		52,
		40,
		37,
		46,
		51,
		43,
		62,
		71,
		70,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		184,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		102,
		89,
		81,
		68,
		77,
		52,
		48,
		44,
		33,
		30,
		42,
		44,
		54,
		59,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		191,
		-1,
		175,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		122,
		101,
		101,
		75,
		71,
		57,
		53,
		60,
		50,
		40,
		29,
		38,
		44,
		51,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		198,
		187,
		182,
		169,
		-1,
		-1,
		163,
		140,
		-1,
		-1,
		108,
		96,
		79,
		68,
		64,
		67,
		75,
		59,
		38,
		26,
		22,
		39,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		212,
		237,
		-1,
		158,
		-1,
		-1,
		143,
		-1,
		-1,
		128,
		101,
		90,
		81,
		74,
		72,
		79,
		90,
		44,
		35,
		13,
		13,
		24,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		126,
		124,
		113,
		-1,
		103,
		85,
		71,
		98,
		66,
		55,
		49,
		43,
		29,
		0,
		13,
		29,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		121,
		114,
		102,
		90,
		80,
		85,
		71,
		67,
		53,
		46,
		41,
		42,
		15,
		7,
		27,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		155,
		139,
		120,
		-1,
		90,
		103,
		103,
		71,
		71,
		65,
		47,
		44,
		18,
		21,
		35,
		30,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		171,
		173,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		127,
		123,
		-1,
		-1,
		91,
		85,
		74,
		77,
		72,
		48,
		42,
		31,
		20,
		24,
		36,
		-1,
		-1,
		186,
		184,
		178,
		-1,
		156,
		-1,
		174,
		-1,
		141,
		147,
		135,
		-1,
		-1,
		-1,
		129,
		92,
		113,
		92,
		69,
		67,
		58,
		44,
		35,
		31,
		27,
		38,
		-1,
		-1,
		-1,
		174,
		148,
		181,
		172,
		155,
		135,
		127,
		146,
		-1,
		116,
		-1,
		91,
		93,
		99,
		77,
		80,
		74,
		47,
		62,
		34,
		25,
		34,
		180,
		-1,
		150,
		183,
		147,
		141,
		117,
		121,
		137,
		-1,
		113,
		95,
		-1,
		106,
		93,
		97,
		82,
		63,
		50,
		53,
		38,
		31,
		-1,
		-1,
		-1,
		152,
		151,
		143,
		137,
		137,
		122,
		113,
		-1,
		125,
		107,
		86,
		101,
		86,
		77,
		77,
		87,
		83,
		70,
		68,
		47,
		-1,
		253,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		146,
		141,
		114,
		102,
		108,
		104,
		90,
		96,
		96,
		89,
		79,
		76,
		72,
		63,
		69,
		46,
		79,
		-1,
		248,
		-1,
		182,
		-1,
		-1,
		164,
		144,
		136,
		125,
		114,
		112,
		103,
		94,
		116,
		120,
		70,
		58,
		53,
		54,
		-1,
		237,
		236,
		-1,
		183,
		175,
		161,
		-1,
		154,
		-1,
		160,
		121,
		-1,
		123,
		103,
		-1,
		69,
		58,
		-1,
		-1,
		224,
		199,
		-1,
		-1,
		-1,
		184,
		164,
		155,
		139,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		209,
		208,
		-1,
		177,
		180,
		-1,
		170,
		161,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		218,
		199,
		193,
		192,
		190,
		185,
		182,
		168,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		190,
		182,
		175,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		212,
		193,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		201,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		223,
		224,
		247,
		211,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		226,
		224,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		178,
		196,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		187,
		188,
		183,
		191,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		170,
		187,
		179,
		169,
		184,
		177,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		280,
		249,
		278,
		236,
		217,
		-1,
		183,
		163,
		169,
		173,
		167,
		160,
		174,
		170,
		-1,
		145,
		144,
		172,
		158,
		169,
		240,
		-1,
		-1,
		238,
		230,
		213,
		216,
		193,
		189,
		178,
		177,
		169,
		155,
		151,
		157,
		160,
		160,
		166,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		211,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		199,
		205,
		191,
		212,
		188,
		179,
		171,
		165,
		153,
		155,
		152,
		165,
		153,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		228,
		-1,
		200,
		188,
		189,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		140,
		138,
		168,
		143,
		165,
		162,
		181,
		186,
		180,
		189,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		236,
		237,
		212,
		185,
		188,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		132,
		147,
		138,
		137,
		155,
		165,
		173,
		177,
		183,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		237,
		229,
		214,
		214,
		-1,
		184,
		181,
		171,
		149,
		134,
		151,
		143,
		141,
		145,
		127,
		141,
		132,
		150,
		157,
		155,
		159,
		179,
		191,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		186,
		199,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		138,
		123,
		120,
		138,
		141,
		148,
		152,
		168,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		169,
		166,
		154,
		141,
		126,
		127,
		135,
		148,
		127,
		122,
		119,
		139,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		165,
		144,
		135,
		124,
		122,
		135,
		132,
		137,
		117,
		115,
		134,
		146,
		137,
		154,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		178,
		161,
		142,
		131,
		123,
		112,
		128,
		136,
		131,
		113,
		122,
		128,
		152,
		142,
		148,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		152,
		136,
		131,
		128,
		125,
		119,
		128,
		130,
		120,
		115,
		122,
		157,
		157,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		138,
		134,
		129,
		133,
		126,
		133,
		126,
		124,
		125,
		107,
		139,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		138,
		136,
		130,
		134,
		131,
		120,
		133,
		126,
		112,
		114,
		127,
		131,
		135,
		122,
		118,
		115,
		129,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		158,
		142,
		145,
		143,
		134,
		142,
		115,
		108,
		115,
		104,
		122,
		130,
		122,
		116,
		115,
		125,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		150,
		165,
		166,
		144,
		143,
		141,
		132,
		120,
		109,
		112,
		104,
		126,
		126,
		110,
		111,
		115,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		164,
		162,
		155,
		146,
		152,
		152,
		129,
		124,
		114,
		103,
		103,
		98,
		120,
		106,
		104,
		113,
		123,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		157,
		147,
		152,
		-1,
		149,
		-1,
		122,
		119,
		110,
		95,
		92,
		103,
		101,
		112,
		108,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		173,
		153,
		145,
		152,
		144,
		136,
		130,
		108,
		101,
		98,
		91,
		104,
		114,
		119,
		106,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		174,
		173,
		161,
		151,
		141,
		146,
		147,
		127,
		120,
		106,
		108,
		102,
		93,
		92,
		108,
		100,
		122,
		-1,
		-1,
		197,
		202,
		190,
		176,
		195,
		-1,
		-1,
		-1,
		196,
		212,
		201,
		175,
		162,
		-1,
		-1,
		145,
		138,
		132,
		123,
		110,
		122,
		117,
		101,
		86,
		101,
		105,
		113,
		104,
		-1,
		200,
		187,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		-1,
		-1,
		213,
		158,
		147,
		142,
		146,
		144,
		-1,
		118,
		129,
		114,
		126,
		133,
		103,
		88,
		82,
		88,
		100,
		109,
		-1,
		-1,
		212,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		170,
		164,
		135,
		128,
		132,
		-1,
		120,
		122,
		116,
		131,
		106,
		103,
		94,
		85,
		81,
		85,
		89,
		95,
		101,
		235,
		-1,
		198,
		-1,
		-1,
		-1,
		188,
		203,
		174,
		151,
		124,
		119,
		112,
		106,
		111,
		122,
		114,
		125,
		92,
		88,
		78,
		77,
		81,
		98,
		98,
		-1,
		-1,
		196,
		192,
		214,
		196,
		200,
		201,
		-1,
		-1,
		128,
		119,
		110,
		102,
		115,
		118,
		98,
		95,
		89,
		82,
		76,
		86,
		97,
		92,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		198,
		199,
		146,
		128,
		124,
		122,
		111,
		105,
		93,
		98,
		99,
		90,
		84,
		72,
		72,
		95,
		84,
		89,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		161,
		158,
		-1,
		128,
		134,
		99,
		106,
		89,
		96,
		94,
		86,
		66,
		69,
		85,
		84,
		76,
		81,
		72,
		80,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		153,
		150,
		130,
		99,
		97,
		90,
		85,
		95,
		75,
		62,
		62,
		57,
		72,
		77,
		73,
		66,
		71,
		86,
		-1,
		227,
		264,
		257,
		225,
		233,
		264,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		126,
		117,
		118,
		106,
		103,
		105,
		100,
		91,
		71,
		77,
		55,
		62,
		73,
		65,
		69,
		69,
		58,
		71,
		75,
		-1,
		220,
		240,
		219,
		222,
		246,
		260,
		-1,
		167,
		-1,
		-1,
		179,
		151,
		135,
		125,
		122,
		165,
		120,
		115,
		99,
		97,
		88,
		79,
		79,
		63,
		51,
		48,
		57,
		62,
		54,
		63,
		64,
		57,
		-1,
		209,
		220,
		213,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		190,
		-1,
		162,
		-1,
		145,
		149,
		128,
		131,
		113,
		100,
		92,
		79,
		88,
		63,
		59,
		55,
		44,
		41,
		53,
		47,
		55,
		62,
		234,
		190,
		193,
		204,
		215,
		230,
		234,
		-1,
		179,
		218,
		196,
		-1,
		180,
		-1,
		-1,
		-1,
		159,
		141,
		133,
		133,
		112,
		112,
		86,
		82,
		68,
		64,
		71,
		61,
		51,
		40,
		45,
		45,
		54,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		194,
		185,
		212,
		203,
		192,
		187,
		174,
		-1,
		-1,
		179,
		151,
		-1,
		-1,
		119,
		107,
		90,
		79,
		75,
		78,
		85,
		70,
		45,
		33,
		33,
		40,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		213,
		203,
		207,
		223,
		248,
		-1,
		163,
		-1,
		-1,
		159,
		-1,
		-1,
		144,
		112,
		101,
		92,
		90,
		83,
		89,
		100,
		51,
		43,
		27,
		20,
		25,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		237,
		-1,
		-1,
		179,
		159,
		-1,
		-1,
		142,
		140,
		129,
		-1,
		119,
		97,
		87,
		110,
		82,
		71,
		60,
		54,
		47,
		18,
		0,
		18,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		169,
		165,
		-1,
		-1,
		137,
		130,
		118,
		106,
		96,
		101,
		87,
		83,
		69,
		62,
		57,
		60,
		33,
		25,
		14,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		186,
		172,
		165,
		153,
		151,
		-1,
		171,
		155,
		136,
		-1,
		106,
		119,
		119,
		87,
		82,
		80,
		63,
		62,
		36,
		30,
		22,
		18,
		-1,
		-1,
		190,
		193,
		-1,
		-1,
		176,
		178,
		-1,
		177,
		166,
		151,
		143,
		-1,
		-1,
		143,
		139,
		-1,
		-1,
		107,
		101,
		90,
		88,
		84,
		66,
		60,
		49,
		38,
		23,
		23,
		-1,
		-1,
		197,
		189,
		183,
		-1,
		161,
		-1,
		179,
		-1,
		146,
		152,
		140,
		-1,
		-1,
		-1,
		140,
		103,
		119,
		108,
		80,
		78,
		69,
		62,
		53,
		49,
		43,
		33,
		-1,
		-1,
		-1,
		179,
		153,
		186,
		177,
		160,
		140,
		132,
		151,
		-1,
		121,
		-1,
		96,
		99,
		104,
		88,
		91,
		85,
		59,
		72,
		45,
		41,
		39,
		185,
		-1,
		155,
		188,
		152,
		146,
		122,
		126,
		142,
		-1,
		118,
		100,
		-1,
		111,
		98,
		102,
		87,
		68,
		55,
		58,
		43,
		36,
		-1,
		-1,
		-1,
		157,
		156,
		148,
		142,
		142,
		127,
		118,
		-1,
		130,
		112,
		91,
		106,
		91,
		82,
		82,
		92,
		88,
		75,
		73,
		52,
		-1,
		258,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		151,
		146,
		119,
		107,
		113,
		109,
		95,
		101,
		101,
		94,
		84,
		81,
		77,
		68,
		74,
		51,
		84,
		-1,
		253,
		-1,
		187,
		-1,
		-1,
		169,
		149,
		141,
		130,
		119,
		117,
		108,
		99,
		121,
		125,
		75,
		63,
		58,
		59,
		-1,
		242,
		241,
		-1,
		188,
		180,
		166,
		-1,
		159,
		-1,
		165,
		126,
		-1,
		128,
		108,
		-1,
		74,
		63,
		-1,
		-1,
		229,
		204,
		-1,
		-1,
		-1,
		189,
		169,
		160,
		144,
		-1,
		119,
		119,
		-1,
		-1,
		-1,
		214,
		213,
		-1,
		182,
		185,
		-1,
		175,
		166,
		174,
		121,
		125,
		-1,
		-1,
		-1,
		223,
		204,
		198,
		197,
		195,
		190,
		187,
		173,
		157,
		135,
		124,
		145,
		-1,
		-1,
		-1,
		195,
		187,
		180,
		-1,
		-1,
		182,
		165,
		146,
		144,
		-1,
		-1,
		-1,
		217,
		198,
		-1,
		-1,
		172,
		-1,
		-1,
		178,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		206,
		-1,
		-1,
		-1,
		168,
		164,
		165,
		-1,
		-1,
		-1,
		-1,
		228,
		229,
		252,
		216,
		-1,
		-1,
		-1,
		160,
		154,
		-1,
		-1,
		231,
		229,
		-1,
		-1,
		-1,
		188,
		172,
		-1,
		158,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		193,
		-1,
		193,
		168,
		175,
		-1,
		-1,
		-1,
		-1,
		206,
		198,
		206,
		-1,
		178,
		180,
		-1,
		228,
		-1,
		-1,
		221,
		212,
		-1,
		-1,
		183,
		190,
		212,
		215,
		251,
		-1,
		202
	],
	[
		-1,
		244,
		233,
		244,
		252,
		225,
		232,
		-1,
		251,
		255,
		221,
		215,
		254,
		223,
		229,
		240,
		-1,
		-1,
		-1,
		244,
		243,
		211,
		209,
		218,
		223,
		230,
		-1,
		229,
		-1,
		265,
		244,
		255,
		260,
		204,
		201,
		221,
		240,
		222,
		214,
		280,
		234,
		205,
		199,
		217,
		207,
		216,
		208,
		-1,
		205,
		195,
		217,
		196,
		207,
		199,
		-1,
		-1,
		199,
		200,
		206,
		192,
		198,
		194,
		-1,
		204,
		188,
		-1,
		-1,
		189,
		190,
		174,
		177,
		185,
		183,
		196,
		188,
		183,
		-1,
		-1,
		180,
		176,
		183,
		170,
		166,
		183,
		196,
		178,
		192,
		191,
		-1,
		184,
		202,
		209,
		177,
		175,
		159,
		157,
		175,
		177,
		183,
		183,
		-1,
		193,
		194,
		189,
		197,
		199,
		175,
		162,
		162,
		172,
		165,
		184,
		172,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		193,
		176,
		193,
		185,
		175,
		190,
		183,
		165,
		162,
		160,
		157,
		173,
		171,
		181,
		-1,
		-1,
		286,
		255,
		284,
		242,
		223,
		-1,
		189,
		169,
		175,
		179,
		173,
		166,
		180,
		176,
		-1,
		151,
		150,
		178,
		164,
		175,
		246,
		-1,
		-1,
		244,
		236,
		219,
		222,
		199,
		195,
		184,
		183,
		175,
		161,
		157,
		163,
		166,
		166,
		172,
		145,
		155,
		159,
		157,
		182,
		-1,
		-1,
		217,
		-1,
		-1,
		243,
		226,
		-1,
		209,
		216,
		205,
		211,
		197,
		218,
		194,
		185,
		177,
		171,
		159,
		161,
		158,
		171,
		159,
		142,
		167,
		171,
		152,
		173,
		168,
		-1,
		216,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		202,
		205,
		211,
		235,
		234,
		-1,
		206,
		194,
		195,
		180,
		177,
		164,
		152,
		165,
		150,
		157,
		156,
		146,
		144,
		174,
		149,
		171,
		168,
		187,
		192,
		186,
		195,
		-1,
		251,
		247,
		243,
		250,
		199,
		-1,
		-1,
		239,
		-1,
		242,
		243,
		218,
		191,
		194,
		181,
		172,
		159,
		148,
		159,
		148,
		145,
		153,
		138,
		153,
		144,
		143,
		161,
		171,
		179,
		183,
		189,
		-1,
		301,
		-1,
		243,
		227,
		229,
		201,
		222,
		-1,
		259,
		243,
		235,
		220,
		220,
		-1,
		190,
		187,
		177,
		155,
		140,
		157,
		149,
		147,
		151,
		133,
		147,
		138,
		156,
		163,
		161,
		165,
		185,
		197,
		261,
		251,
		-1,
		233,
		238,
		197,
		205,
		224,
		262,
		226,
		-1,
		221,
		-1,
		192,
		205,
		-1,
		161,
		157,
		139,
		140,
		135,
		150,
		144,
		129,
		126,
		144,
		147,
		154,
		158,
		174,
		-1,
		-1,
		246,
		250,
		239,
		190,
		209,
		233,
		270,
		219,
		208,
		207,
		-1,
		198,
		175,
		172,
		160,
		147,
		132,
		133,
		141,
		154,
		133,
		128,
		125,
		145,
		171,
		149,
		161,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		216,
		187,
		211,
		253,
		237,
		230,
		218,
		183,
		183,
		177,
		-1,
		171,
		150,
		141,
		130,
		128,
		141,
		138,
		143,
		123,
		121,
		140,
		152,
		143,
		160,
		-1,
		-1,
		-1,
		246,
		235,
		236,
		182,
		205,
		242,
		216,
		202,
		207,
		182,
		175,
		169,
		184,
		167,
		148,
		137,
		129,
		118,
		134,
		142,
		137,
		119,
		128,
		134,
		158,
		148,
		154,
		-1,
		-1,
		253,
		243,
		227,
		229,
		226,
		196,
		203,
		235,
		207,
		220,
		-1,
		174,
		-1,
		163,
		158,
		142,
		137,
		134,
		131,
		125,
		134,
		136,
		126,
		121,
		128,
		163,
		163,
		138,
		158,
		161,
		-1,
		-1,
		-1,
		246,
		241,
		216,
		193,
		177,
		213,
		-1,
		190,
		191,
		-1,
		168,
		162,
		159,
		144,
		140,
		135,
		139,
		132,
		139,
		132,
		130,
		131,
		113,
		145,
		-1,
		146,
		140,
		148,
		138,
		126,
		-1,
		-1,
		-1,
		239,
		218,
		211,
		231,
		172,
		224,
		-1,
		-1,
		175,
		168,
		-1,
		155,
		137,
		144,
		142,
		136,
		140,
		137,
		126,
		139,
		132,
		118,
		120,
		133,
		137,
		141,
		128,
		124,
		121,
		134,
		-1,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		192,
		-1,
		184,
		176,
		166,
		160,
		154,
		150,
		148,
		164,
		148,
		151,
		149,
		140,
		148,
		121,
		114,
		121,
		110,
		128,
		136,
		128,
		122,
		121,
		130,
		-1,
		259,
		245,
		216,
		-1,
		-1,
		205,
		-1,
		169,
		183,
		199,
		-1,
		192,
		171,
		186,
		164,
		160,
		156,
		171,
		172,
		150,
		149,
		147,
		138,
		126,
		115,
		118,
		110,
		132,
		132,
		116,
		117,
		121,
		-1,
		265,
		252,
		210,
		206,
		195,
		215,
		166,
		154,
		186,
		-1,
		-1,
		228,
		-1,
		162,
		179,
		170,
		168,
		161,
		152,
		158,
		158,
		135,
		130,
		120,
		109,
		109,
		104,
		126,
		112,
		110,
		119,
		115,
		-1,
		-1,
		-1,
		232,
		-1,
		-1,
		181,
		168,
		162,
		-1,
		203,
		-1,
		206,
		196,
		180,
		165,
		198,
		-1,
		163,
		153,
		158,
		-1,
		155,
		-1,
		128,
		125,
		116,
		101,
		98,
		109,
		107,
		118,
		114,
		-1,
		215,
		200,
		193,
		183,
		197,
		168,
		-1,
		223,
		-1,
		-1,
		193,
		187,
		187,
		171,
		174,
		179,
		159,
		151,
		158,
		150,
		142,
		136,
		114,
		107,
		104,
		97,
		110,
		120,
		125,
		112,
		-1,
		-1,
		-1,
		220,
		206,
		210,
		170,
		189,
		-1,
		-1,
		255,
		210,
		196,
		-1,
		180,
		179,
		167,
		157,
		147,
		152,
		153,
		133,
		126,
		112,
		114,
		108,
		99,
		98,
		114,
		106,
		126,
		-1,
		-1,
		203,
		208,
		196,
		182,
		201,
		-1,
		-1,
		-1,
		202,
		218,
		207,
		181,
		168,
		-1,
		-1,
		151,
		144,
		138,
		129,
		116,
		128,
		123,
		107,
		92,
		107,
		111,
		116,
		108,
		-1,
		206,
		193,
		-1,
		-1,
		204,
		198,
		-1,
		-1,
		-1,
		-1,
		219,
		164,
		153,
		148,
		152,
		150,
		-1,
		124,
		135,
		120,
		132,
		139,
		109,
		94,
		88,
		94,
		106,
		102,
		-1,
		-1,
		218,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		176,
		170,
		141,
		134,
		138,
		-1,
		126,
		128,
		122,
		137,
		112,
		109,
		100,
		91,
		87,
		91,
		95,
		87,
		93,
		241,
		-1,
		204,
		-1,
		-1,
		-1,
		194,
		209,
		180,
		157,
		130,
		125,
		118,
		112,
		117,
		128,
		120,
		131,
		98,
		94,
		84,
		83,
		87,
		91,
		91,
		-1,
		-1,
		202,
		198,
		220,
		202,
		206,
		207,
		-1,
		-1,
		134,
		125,
		116,
		108,
		121,
		124,
		104,
		101,
		95,
		88,
		82,
		92,
		90,
		85,
		-1,
		-1,
		-1,
		214,
		-1,
		216,
		-1,
		-1,
		204,
		205,
		152,
		134,
		130,
		128,
		117,
		111,
		99,
		104,
		105,
		96,
		90,
		78,
		78,
		101,
		77,
		81,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		193,
		185,
		180,
		186,
		188,
		179,
		167,
		164,
		-1,
		134,
		140,
		105,
		112,
		95,
		102,
		100,
		92,
		72,
		75,
		91,
		80,
		68,
		73,
		64,
		72,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		186,
		182,
		172,
		162,
		165,
		-1,
		-1,
		159,
		156,
		136,
		105,
		103,
		96,
		91,
		101,
		81,
		68,
		68,
		63,
		71,
		70,
		65,
		58,
		63,
		78,
		-1,
		233,
		270,
		263,
		231,
		239,
		270,
		-1,
		176,
		168,
		179,
		154,
		156,
		-1,
		-1,
		132,
		123,
		124,
		112,
		109,
		111,
		106,
		97,
		77,
		83,
		61,
		68,
		79,
		71,
		62,
		60,
		50,
		63,
		67,
		-1,
		226,
		246,
		225,
		228,
		252,
		266,
		-1,
		173,
		-1,
		-1,
		185,
		157,
		141,
		131,
		128,
		171,
		126,
		121,
		105,
		103,
		94,
		85,
		85,
		69,
		57,
		54,
		63,
		57,
		47,
		45,
		56,
		49,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		182,
		-1,
		168,
		-1,
		151,
		155,
		134,
		137,
		119,
		106,
		98,
		85,
		94,
		69,
		65,
		61,
		50,
		47,
		51,
		29,
		37,
		46,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		185,
		224,
		188,
		-1,
		172,
		-1,
		-1,
		-1,
		165,
		147,
		139,
		139,
		118,
		118,
		92,
		88,
		74,
		70,
		77,
		67,
		57,
		46,
		39,
		27,
		38,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		200,
		191,
		218,
		195,
		184,
		179,
		166,
		-1,
		-1,
		174,
		157,
		-1,
		-1,
		125,
		113,
		96,
		85,
		81,
		84,
		91,
		76,
		51,
		39,
		39,
		22,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		219,
		209,
		213,
		226,
		251,
		-1,
		155,
		-1,
		-1,
		154,
		-1,
		-1,
		139,
		118,
		107,
		98,
		85,
		89,
		95,
		106,
		57,
		49,
		33,
		17,
		7,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		185,
		183,
		189,
		196,
		213,
		240,
		-1,
		-1,
		171,
		151,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		96,
		82,
		109,
		84,
		73,
		66,
		60,
		47,
		30,
		18,
		0,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		161,
		157,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		96,
		82,
		78,
		71,
		64,
		59,
		61,
		33,
		37,
		6,
		-1,
		256,
		-1,
		208,
		184,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		178,
		164,
		157,
		145,
		143,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		114,
		82,
		74,
		72,
		62,
		61,
		36,
		22,
		14,
		12,
		-1,
		-1,
		196,
		194,
		-1,
		-1,
		168,
		170,
		-1,
		169,
		158,
		143,
		135,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		101,
		96,
		85,
		80,
		76,
		58,
		59,
		49,
		38,
		15,
		15,
		-1,
		-1,
		189,
		181,
		175,
		-1,
		153,
		-1,
		171,
		-1,
		138,
		144,
		132,
		-1,
		-1,
		-1,
		132,
		95,
		111,
		103,
		72,
		70,
		61,
		54,
		53,
		42,
		35,
		25,
		-1,
		-1,
		-1,
		171,
		145,
		178,
		169,
		152,
		132,
		124,
		143,
		-1,
		113,
		-1,
		88,
		91,
		96,
		80,
		83,
		77,
		51,
		64,
		37,
		33,
		31,
		177,
		-1,
		147,
		180,
		144,
		138,
		114,
		118,
		134,
		-1,
		110,
		92,
		-1,
		103,
		90,
		94,
		79,
		60,
		47,
		50,
		35,
		28,
		-1,
		-1,
		-1,
		149,
		148,
		140,
		134,
		134,
		119,
		110,
		-1,
		122,
		104,
		83,
		98,
		83,
		74,
		74,
		84,
		80,
		67,
		65,
		44,
		-1,
		250,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		143,
		138,
		111,
		99,
		105,
		101,
		87,
		93,
		93,
		86,
		76,
		73,
		69,
		60,
		66,
		43,
		76,
		-1,
		245,
		-1,
		179,
		-1,
		-1,
		161,
		141,
		133,
		122,
		111,
		109,
		100,
		91,
		113,
		117,
		67,
		55,
		50,
		51,
		-1,
		234,
		233,
		-1,
		180,
		172,
		158,
		-1,
		151,
		-1,
		157,
		118,
		-1,
		120,
		100,
		-1,
		66,
		55,
		-1,
		-1,
		221,
		196,
		-1,
		-1,
		-1,
		181,
		161,
		152,
		136,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		206,
		205,
		-1,
		174,
		177,
		-1,
		167,
		158,
		166,
		113,
		117,
		-1,
		-1,
		-1,
		215,
		196,
		190,
		189,
		187,
		182,
		179,
		165,
		149,
		127,
		116,
		137,
		-1,
		-1,
		-1,
		187,
		179,
		172,
		-1,
		-1,
		174,
		157,
		138,
		136,
		-1,
		-1,
		-1,
		209,
		190,
		-1,
		-1,
		164,
		-1,
		-1,
		170,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		198,
		-1,
		-1,
		-1,
		160,
		156,
		157,
		-1,
		-1,
		-1,
		-1,
		220,
		221,
		244,
		208,
		-1,
		-1,
		-1,
		152,
		146,
		-1,
		-1,
		223,
		221,
		-1,
		-1,
		-1,
		180,
		164,
		-1,
		150,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		185,
		-1,
		185,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		198,
		190,
		198,
		-1,
		170,
		172,
		-1,
		220,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		175,
		182,
		204,
		207,
		243,
		-1,
		194
	],
	[
		-1,
		318,
		307,
		318,
		326,
		299,
		306,
		-1,
		325,
		329,
		295,
		289,
		328,
		297,
		303,
		314,
		-1,
		-1,
		-1,
		318,
		317,
		285,
		283,
		292,
		297,
		304,
		-1,
		303,
		-1,
		339,
		318,
		329,
		334,
		278,
		275,
		295,
		314,
		296,
		288,
		354,
		308,
		279,
		273,
		291,
		281,
		290,
		282,
		-1,
		279,
		269,
		291,
		270,
		281,
		273,
		-1,
		-1,
		273,
		274,
		280,
		266,
		272,
		268,
		-1,
		278,
		262,
		-1,
		-1,
		263,
		264,
		248,
		251,
		259,
		257,
		270,
		262,
		257,
		-1,
		-1,
		254,
		250,
		257,
		244,
		240,
		257,
		270,
		252,
		266,
		265,
		-1,
		260,
		278,
		283,
		251,
		249,
		233,
		231,
		249,
		251,
		257,
		257,
		-1,
		266,
		268,
		265,
		273,
		273,
		249,
		236,
		236,
		246,
		239,
		258,
		246,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		263,
		252,
		269,
		261,
		251,
		266,
		259,
		239,
		236,
		234,
		231,
		247,
		245,
		255,
		-1,
		-1,
		319,
		288,
		323,
		280,
		265,
		-1,
		259,
		245,
		251,
		255,
		249,
		242,
		256,
		252,
		-1,
		225,
		224,
		252,
		238,
		249,
		279,
		-1,
		-1,
		277,
		269,
		254,
		257,
		254,
		254,
		260,
		259,
		251,
		237,
		233,
		239,
		242,
		242,
		248,
		219,
		229,
		233,
		231,
		256,
		-1,
		-1,
		291,
		-1,
		-1,
		276,
		259,
		-1,
		242,
		249,
		249,
		266,
		256,
		277,
		270,
		261,
		253,
		247,
		235,
		237,
		234,
		247,
		235,
		216,
		241,
		245,
		226,
		247,
		242,
		-1,
		290,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		235,
		238,
		244,
		268,
		278,
		-1,
		282,
		270,
		271,
		256,
		253,
		240,
		228,
		241,
		226,
		233,
		232,
		220,
		218,
		248,
		223,
		245,
		242,
		261,
		266,
		260,
		269,
		-1,
		284,
		280,
		276,
		283,
		232,
		-1,
		-1,
		272,
		-1,
		286,
		299,
		294,
		267,
		270,
		257,
		248,
		235,
		224,
		235,
		224,
		221,
		229,
		212,
		227,
		218,
		217,
		235,
		245,
		253,
		257,
		263,
		-1,
		334,
		-1,
		276,
		260,
		262,
		234,
		255,
		-1,
		292,
		287,
		307,
		296,
		294,
		-1,
		266,
		263,
		253,
		231,
		216,
		233,
		225,
		223,
		225,
		207,
		221,
		212,
		230,
		237,
		235,
		239,
		259,
		271,
		294,
		284,
		-1,
		266,
		271,
		230,
		238,
		257,
		330,
		300,
		-1,
		295,
		-1,
		268,
		281,
		-1,
		237,
		233,
		215,
		216,
		211,
		226,
		218,
		203,
		200,
		218,
		221,
		228,
		232,
		248,
		-1,
		-1,
		279,
		283,
		272,
		223,
		242,
		266,
		303,
		293,
		282,
		281,
		-1,
		272,
		251,
		248,
		236,
		223,
		208,
		209,
		217,
		229,
		208,
		202,
		199,
		219,
		245,
		223,
		234,
		-1,
		-1,
		-1,
		304,
		-1,
		-1,
		249,
		220,
		244,
		286,
		311,
		304,
		292,
		257,
		257,
		251,
		-1,
		247,
		226,
		217,
		206,
		204,
		217,
		209,
		217,
		197,
		195,
		214,
		226,
		217,
		225,
		-1,
		-1,
		-1,
		279,
		268,
		269,
		218,
		241,
		275,
		290,
		276,
		281,
		256,
		249,
		243,
		260,
		243,
		224,
		213,
		205,
		194,
		205,
		213,
		211,
		193,
		202,
		208,
		232,
		213,
		219,
		-1,
		-1,
		286,
		276,
		260,
		262,
		259,
		232,
		239,
		271,
		281,
		283,
		-1,
		248,
		-1,
		237,
		233,
		218,
		213,
		210,
		197,
		196,
		210,
		210,
		200,
		195,
		202,
		237,
		237,
		203,
		223,
		226,
		-1,
		-1,
		-1,
		279,
		277,
		252,
		229,
		213,
		249,
		-1,
		253,
		254,
		-1,
		242,
		236,
		233,
		220,
		216,
		201,
		205,
		207,
		210,
		198,
		204,
		205,
		187,
		211,
		-1,
		211,
		205,
		213,
		203,
		191,
		-1,
		-1,
		-1,
		275,
		254,
		247,
		267,
		208,
		260,
		-1,
		-1,
		238,
		231,
		-1,
		229,
		211,
		213,
		208,
		204,
		206,
		203,
		192,
		205,
		198,
		192,
		186,
		199,
		203,
		204,
		193,
		189,
		186,
		200,
		-1,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		228,
		-1,
		241,
		233,
		229,
		223,
		228,
		224,
		222,
		232,
		216,
		218,
		214,
		206,
		201,
		187,
		180,
		191,
		176,
		194,
		200,
		191,
		186,
		185,
		196,
		-1,
		295,
		281,
		252,
		-1,
		-1,
		241,
		-1,
		205,
		219,
		235,
		-1,
		263,
		242,
		260,
		238,
		234,
		225,
		223,
		224,
		194,
		199,
		201,
		189,
		192,
		181,
		184,
		176,
		198,
		195,
		179,
		181,
		190,
		-1,
		301,
		288,
		246,
		242,
		231,
		251,
		202,
		211,
		222,
		-1,
		-1,
		285,
		-1,
		236,
		241,
		239,
		237,
		213,
		188,
		195,
		213,
		186,
		181,
		186,
		175,
		175,
		170,
		189,
		175,
		173,
		188,
		204,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		217,
		204,
		198,
		-1,
		239,
		-1,
		263,
		251,
		238,
		220,
		260,
		-1,
		187,
		183,
		190,
		-1,
		206,
		-1,
		178,
		181,
		172,
		167,
		164,
		175,
		173,
		182,
		183,
		-1,
		251,
		236,
		229,
		219,
		233,
		204,
		-1,
		247,
		-1,
		-1,
		250,
		244,
		244,
		213,
		210,
		203,
		183,
		175,
		190,
		189,
		176,
		175,
		163,
		163,
		166,
		160,
		173,
		183,
		189,
		181,
		-1,
		-1,
		-1,
		256,
		208,
		216,
		192,
		213,
		-1,
		-1,
		311,
		267,
		253,
		-1,
		205,
		203,
		191,
		181,
		171,
		176,
		177,
		167,
		165,
		161,
		170,
		169,
		162,
		161,
		182,
		175,
		197,
		-1,
		-1,
		205,
		218,
		220,
		204,
		199,
		-1,
		-1,
		-1,
		257,
		258,
		224,
		203,
		192,
		-1,
		-1,
		175,
		168,
		162,
		165,
		153,
		173,
		180,
		168,
		155,
		170,
		180,
		188,
		187,
		-1,
		208,
		195,
		-1,
		-1,
		198,
		188,
		-1,
		-1,
		-1,
		-1,
		236,
		181,
		170,
		165,
		169,
		174,
		-1,
		148,
		159,
		152,
		171,
		178,
		170,
		155,
		149,
		160,
		175,
		192,
		-1,
		-1,
		212,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		193,
		187,
		158,
		151,
		155,
		-1,
		150,
		152,
		149,
		161,
		166,
		170,
		161,
		143,
		157,
		160,
		173,
		187,
		191,
		235,
		-1,
		165,
		-1,
		-1,
		-1,
		204,
		205,
		191,
		168,
		147,
		140,
		137,
		136,
		141,
		152,
		161,
		172,
		137,
		141,
		156,
		161,
		165,
		182,
		186,
		-1,
		-1,
		163,
		159,
		194,
		206,
		178,
		218,
		-1,
		-1,
		136,
		129,
		139,
		132,
		145,
		148,
		133,
		135,
		153,
		166,
		160,
		170,
		185,
		180,
		-1,
		-1,
		-1,
		161,
		-1,
		177,
		-1,
		-1,
		168,
		209,
		156,
		138,
		134,
		120,
		127,
		121,
		123,
		128,
		147,
		142,
		151,
		156,
		160,
		183,
		172,
		211,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		127,
		146,
		141,
		147,
		152,
		143,
		171,
		168,
		-1,
		117,
		150,
		118,
		132,
		128,
		135,
		140,
		146,
		150,
		157,
		173,
		172,
		167,
		203,
		194,
		200,
		-1,
		-1,
		154,
		143,
		132,
		138,
		-1,
		120,
		143,
		133,
		123,
		129,
		-1,
		-1,
		135,
		132,
		130,
		110,
		116,
		121,
		124,
		162,
		138,
		146,
		150,
		154,
		160,
		165,
		170,
		176,
		191,
		206,
		-1,
		108,
		145,
		138,
		106,
		114,
		145,
		-1,
		110,
		102,
		130,
		115,
		123,
		-1,
		-1,
		108,
		99,
		104,
		113,
		114,
		145,
		144,
		157,
		160,
		165,
		153,
		152,
		170,
		174,
		183,
		190,
		180,
		193,
		197,
		-1,
		101,
		121,
		100,
		103,
		127,
		141,
		-1,
		101,
		-1,
		-1,
		146,
		133,
		117,
		107,
		104,
		151,
		127,
		122,
		128,
		130,
		154,
		145,
		170,
		161,
		161,
		164,
		179,
		184,
		176,
		190,
		190,
		191,
		-1,
		90,
		101,
		94,
		-1,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		162,
		-1,
		144,
		-1,
		127,
		131,
		135,
		138,
		153,
		140,
		147,
		164,
		170,
		159,
		169,
		165,
		166,
		175,
		186,
		198,
		197,
		198,
		68,
		71,
		74,
		85,
		96,
		111,
		115,
		-1,
		85,
		121,
		131,
		-1,
		171,
		-1,
		-1,
		-1,
		141,
		148,
		140,
		156,
		152,
		152,
		148,
		152,
		164,
		171,
		181,
		183,
		175,
		179,
		192,
		203,
		206,
		64,
		65,
		115,
		60,
		60,
		81,
		90,
		111,
		81,
		78,
		115,
		120,
		135,
		140,
		164,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		159,
		169,
		152,
		154,
		158,
		172,
		184,
		192,
		182,
		180,
		174,
		206,
		-1,
		23,
		28,
		31,
		36,
		28,
		40,
		51,
		78,
		-1,
		-1,
		79,
		106,
		90,
		94,
		110,
		135,
		-1,
		171,
		-1,
		-1,
		185,
		-1,
		-1,
		211,
		174,
		163,
		154,
		160,
		166,
		177,
		199,
		188,
		189,
		179,
		189,
		202,
		7,
		10,
		20,
		24,
		41,
		59,
		47,
		-1,
		66,
		64,
		70,
		77,
		94,
		124,
		-1,
		-1,
		187,
		178,
		-1,
		-1,
		204,
		207,
		196,
		-1,
		186,
		159,
		164,
		189,
		196,
		197,
		191,
		185,
		192,
		191,
		199,
		207,
		0,
		28,
		30,
		46,
		42,
		55,
		52,
		51,
		63,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		-1,
		216,
		197,
		-1,
		-1,
		204,
		197,
		185,
		173,
		163,
		173,
		181,
		181,
		184,
		188,
		183,
		194,
		186,
		190,
		207,
		-1,
		79,
		-1,
		83,
		65,
		79,
		94,
		102,
		-1,
		-1,
		-1,
		233,
		219,
		212,
		200,
		198,
		-1,
		238,
		222,
		203,
		-1,
		173,
		186,
		217,
		185,
		190,
		185,
		189,
		200,
		189,
		192,
		206,
		201,
		-1,
		-1,
		77,
		80,
		-1,
		-1,
		102,
		121,
		-1,
		224,
		213,
		198,
		190,
		-1,
		-1,
		210,
		206,
		-1,
		-1,
		174,
		199,
		188,
		196,
		191,
		193,
		199,
		202,
		191,
		195,
		207,
		-1,
		-1,
		84,
		85,
		90,
		-1,
		111,
		-1,
		226,
		-1,
		193,
		200,
		188,
		-1,
		-1,
		-1,
		212,
		175,
		196,
		206,
		211,
		209,
		200,
		197,
		204,
		202,
		198,
		209,
		-1,
		-1,
		-1,
		141,
		118,
		233,
		224,
		207,
		187,
		179,
		199,
		-1,
		200,
		-1,
		175,
		176,
		203,
		205,
		222,
		216,
		200,
		215,
		205,
		196,
		205,
		147,
		-1,
		122,
		181,
		164,
		193,
		159,
		171,
		221,
		-1,
		197,
		179,
		-1,
		207,
		197,
		239,
		220,
		213,
		200,
		207,
		209,
		202,
		-1,
		-1,
		-1,
		137,
		136,
		135,
		146,
		154,
		152,
		170,
		-1,
		209,
		191,
		170,
		187,
		187,
		178,
		186,
		229,
		225,
		218,
		220,
		210,
		-1,
		153,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		163,
		185,
		180,
		172,
		184,
		188,
		174,
		180,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		209,
		241,
		-1,
		160,
		-1,
		167,
		-1,
		-1,
		181,
		167,
		179,
		190,
		180,
		180,
		185,
		178,
		200,
		216,
		200,
		198,
		203,
		208,
		-1,
		170,
		171,
		-1,
		200,
		192,
		178,
		-1,
		171,
		-1,
		226,
		187,
		-1,
		207,
		187,
		-1,
		209,
		205,
		-1,
		-1,
		182,
		216,
		-1,
		-1,
		-1,
		201,
		181,
		221,
		205,
		-1,
		198,
		198,
		-1,
		-1,
		-1,
		196,
		219,
		-1,
		194,
		197,
		-1,
		188,
		194,
		223,
		200,
		204,
		-1,
		-1,
		-1,
		223,
		207,
		212,
		209,
		214,
		202,
		219,
		205,
		207,
		214,
		203,
		224,
		-1,
		-1,
		-1,
		222,
		214,
		214,
		-1,
		-1,
		232,
		215,
		215,
		223,
		-1,
		-1,
		-1,
		244,
		225,
		-1,
		-1,
		223,
		-1,
		-1,
		228,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		233,
		-1,
		-1,
		-1,
		224,
		231,
		239,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		261,
		254,
		-1,
		-1,
		-1,
		238,
		233,
		-1,
		-1,
		214,
		215,
		-1,
		-1,
		-1,
		266,
		250,
		-1,
		237,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		271,
		-1,
		272,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		284,
		276,
		285,
		-1,
		257,
		259,
		-1,
		307,
		-1,
		-1,
		299,
		290,
		-1,
		-1,
		262,
		269,
		291,
		294,
		298,
		-1,
		281
	],
	[
		-1,
		333,
		322,
		333,
		341,
		314,
		321,
		-1,
		340,
		344,
		310,
		304,
		343,
		312,
		318,
		329,
		-1,
		-1,
		-1,
		333,
		332,
		300,
		298,
		307,
		312,
		319,
		-1,
		318,
		-1,
		354,
		333,
		344,
		349,
		293,
		290,
		310,
		329,
		311,
		303,
		369,
		323,
		294,
		288,
		306,
		296,
		305,
		297,
		-1,
		294,
		284,
		306,
		285,
		296,
		288,
		-1,
		-1,
		288,
		289,
		295,
		281,
		287,
		283,
		-1,
		293,
		277,
		-1,
		-1,
		278,
		279,
		263,
		266,
		274,
		272,
		285,
		277,
		272,
		-1,
		-1,
		269,
		265,
		272,
		259,
		255,
		272,
		285,
		267,
		281,
		280,
		-1,
		275,
		293,
		298,
		266,
		264,
		248,
		246,
		264,
		266,
		272,
		272,
		-1,
		281,
		283,
		280,
		288,
		288,
		264,
		251,
		251,
		261,
		254,
		273,
		261,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		278,
		267,
		284,
		276,
		266,
		281,
		274,
		254,
		251,
		249,
		246,
		262,
		260,
		270,
		-1,
		-1,
		334,
		303,
		338,
		295,
		280,
		-1,
		274,
		260,
		266,
		270,
		264,
		257,
		271,
		267,
		-1,
		240,
		239,
		267,
		253,
		264,
		294,
		-1,
		-1,
		292,
		284,
		269,
		272,
		269,
		269,
		275,
		274,
		266,
		252,
		248,
		254,
		257,
		257,
		263,
		234,
		244,
		248,
		246,
		271,
		-1,
		-1,
		306,
		-1,
		-1,
		291,
		274,
		-1,
		257,
		264,
		264,
		281,
		271,
		292,
		285,
		276,
		268,
		262,
		250,
		252,
		249,
		262,
		250,
		231,
		256,
		260,
		241,
		262,
		257,
		-1,
		305,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		250,
		253,
		259,
		283,
		293,
		-1,
		297,
		285,
		286,
		271,
		268,
		255,
		243,
		256,
		241,
		248,
		247,
		235,
		233,
		263,
		238,
		260,
		257,
		276,
		281,
		275,
		284,
		-1,
		299,
		295,
		291,
		298,
		247,
		-1,
		-1,
		287,
		-1,
		301,
		314,
		309,
		282,
		285,
		272,
		263,
		250,
		239,
		250,
		239,
		236,
		244,
		227,
		242,
		233,
		232,
		250,
		260,
		268,
		272,
		278,
		-1,
		349,
		-1,
		291,
		275,
		277,
		249,
		270,
		-1,
		307,
		302,
		322,
		311,
		309,
		-1,
		281,
		278,
		268,
		246,
		231,
		248,
		240,
		238,
		240,
		222,
		236,
		227,
		245,
		252,
		250,
		254,
		274,
		286,
		309,
		299,
		-1,
		281,
		286,
		245,
		253,
		272,
		345,
		315,
		-1,
		310,
		-1,
		283,
		296,
		-1,
		252,
		248,
		230,
		231,
		226,
		241,
		233,
		218,
		215,
		233,
		236,
		243,
		247,
		263,
		-1,
		-1,
		294,
		298,
		287,
		238,
		257,
		281,
		318,
		308,
		297,
		296,
		-1,
		287,
		266,
		263,
		251,
		238,
		223,
		224,
		232,
		244,
		223,
		217,
		214,
		234,
		260,
		238,
		249,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		264,
		235,
		259,
		301,
		326,
		319,
		307,
		272,
		272,
		266,
		-1,
		262,
		241,
		232,
		221,
		219,
		232,
		224,
		232,
		212,
		210,
		229,
		241,
		232,
		240,
		-1,
		-1,
		-1,
		294,
		283,
		284,
		233,
		256,
		290,
		305,
		291,
		296,
		271,
		264,
		258,
		275,
		258,
		239,
		228,
		220,
		209,
		220,
		228,
		226,
		208,
		217,
		223,
		247,
		228,
		234,
		-1,
		-1,
		301,
		291,
		275,
		277,
		274,
		247,
		254,
		286,
		296,
		298,
		-1,
		263,
		-1,
		252,
		248,
		233,
		228,
		225,
		212,
		211,
		225,
		225,
		215,
		210,
		217,
		252,
		252,
		218,
		238,
		241,
		-1,
		-1,
		-1,
		294,
		292,
		267,
		244,
		228,
		264,
		-1,
		268,
		269,
		-1,
		257,
		251,
		248,
		235,
		231,
		216,
		220,
		222,
		225,
		213,
		219,
		220,
		202,
		226,
		-1,
		226,
		220,
		228,
		218,
		206,
		-1,
		-1,
		-1,
		290,
		269,
		262,
		282,
		223,
		275,
		-1,
		-1,
		253,
		246,
		-1,
		244,
		226,
		228,
		223,
		219,
		221,
		218,
		207,
		220,
		213,
		207,
		201,
		214,
		218,
		219,
		208,
		204,
		201,
		215,
		-1,
		309,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		243,
		-1,
		256,
		248,
		244,
		238,
		243,
		239,
		237,
		247,
		231,
		233,
		229,
		221,
		216,
		202,
		195,
		206,
		191,
		209,
		215,
		206,
		201,
		200,
		211,
		-1,
		310,
		296,
		267,
		-1,
		-1,
		256,
		-1,
		220,
		234,
		250,
		-1,
		278,
		257,
		275,
		253,
		249,
		240,
		238,
		239,
		209,
		214,
		216,
		204,
		207,
		196,
		199,
		191,
		213,
		210,
		194,
		196,
		205,
		-1,
		316,
		303,
		261,
		257,
		246,
		266,
		217,
		226,
		237,
		-1,
		-1,
		300,
		-1,
		251,
		256,
		254,
		252,
		228,
		203,
		210,
		228,
		201,
		196,
		201,
		190,
		190,
		185,
		204,
		190,
		188,
		203,
		219,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		232,
		219,
		213,
		-1,
		254,
		-1,
		278,
		266,
		253,
		235,
		275,
		-1,
		202,
		198,
		205,
		-1,
		221,
		-1,
		193,
		196,
		187,
		182,
		179,
		190,
		188,
		197,
		198,
		-1,
		266,
		251,
		244,
		234,
		248,
		219,
		-1,
		262,
		-1,
		-1,
		265,
		259,
		259,
		228,
		225,
		218,
		198,
		190,
		205,
		204,
		191,
		190,
		178,
		178,
		181,
		175,
		188,
		198,
		204,
		196,
		-1,
		-1,
		-1,
		271,
		223,
		231,
		207,
		228,
		-1,
		-1,
		326,
		282,
		268,
		-1,
		220,
		218,
		206,
		196,
		186,
		191,
		192,
		182,
		180,
		176,
		185,
		184,
		177,
		176,
		197,
		190,
		212,
		-1,
		-1,
		220,
		233,
		235,
		219,
		214,
		-1,
		-1,
		-1,
		272,
		273,
		239,
		218,
		207,
		-1,
		-1,
		190,
		183,
		177,
		180,
		168,
		188,
		195,
		183,
		170,
		185,
		195,
		203,
		202,
		-1,
		223,
		210,
		-1,
		-1,
		213,
		203,
		-1,
		-1,
		-1,
		-1,
		251,
		196,
		185,
		180,
		184,
		189,
		-1,
		163,
		174,
		167,
		186,
		193,
		185,
		170,
		164,
		175,
		190,
		207,
		-1,
		-1,
		227,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		208,
		202,
		173,
		166,
		170,
		-1,
		165,
		167,
		164,
		176,
		181,
		185,
		176,
		158,
		172,
		175,
		188,
		202,
		206,
		250,
		-1,
		180,
		-1,
		-1,
		-1,
		219,
		220,
		206,
		183,
		162,
		155,
		152,
		151,
		156,
		167,
		176,
		187,
		152,
		156,
		171,
		176,
		180,
		197,
		201,
		-1,
		-1,
		178,
		174,
		209,
		221,
		193,
		233,
		-1,
		-1,
		151,
		144,
		154,
		147,
		160,
		163,
		148,
		150,
		168,
		181,
		175,
		185,
		200,
		195,
		-1,
		-1,
		-1,
		176,
		-1,
		192,
		-1,
		-1,
		183,
		224,
		171,
		153,
		149,
		135,
		142,
		136,
		138,
		143,
		162,
		157,
		166,
		171,
		175,
		198,
		187,
		226,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		142,
		161,
		156,
		162,
		167,
		158,
		186,
		183,
		-1,
		132,
		165,
		133,
		147,
		143,
		150,
		155,
		161,
		165,
		172,
		188,
		187,
		182,
		218,
		209,
		215,
		-1,
		-1,
		169,
		158,
		147,
		153,
		-1,
		135,
		158,
		148,
		138,
		144,
		-1,
		-1,
		150,
		147,
		145,
		125,
		131,
		136,
		139,
		177,
		153,
		161,
		165,
		169,
		175,
		180,
		185,
		191,
		206,
		221,
		-1,
		123,
		160,
		153,
		121,
		129,
		160,
		-1,
		125,
		117,
		145,
		130,
		138,
		-1,
		-1,
		123,
		114,
		119,
		128,
		129,
		160,
		159,
		172,
		175,
		180,
		168,
		167,
		185,
		189,
		198,
		205,
		195,
		208,
		212,
		-1,
		116,
		136,
		115,
		118,
		142,
		156,
		-1,
		116,
		-1,
		-1,
		161,
		148,
		132,
		122,
		119,
		166,
		142,
		137,
		143,
		145,
		169,
		160,
		185,
		176,
		176,
		179,
		194,
		199,
		191,
		205,
		205,
		206,
		-1,
		105,
		116,
		109,
		-1,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		177,
		-1,
		159,
		-1,
		142,
		146,
		150,
		153,
		168,
		155,
		162,
		179,
		185,
		174,
		184,
		180,
		181,
		190,
		201,
		213,
		212,
		213,
		83,
		86,
		89,
		100,
		111,
		126,
		130,
		-1,
		100,
		136,
		146,
		-1,
		186,
		-1,
		-1,
		-1,
		156,
		163,
		155,
		171,
		167,
		167,
		163,
		167,
		179,
		186,
		196,
		198,
		190,
		194,
		207,
		218,
		221,
		79,
		80,
		130,
		75,
		75,
		96,
		105,
		126,
		96,
		93,
		130,
		135,
		150,
		155,
		179,
		-1,
		-1,
		179,
		173,
		-1,
		-1,
		174,
		184,
		167,
		169,
		173,
		187,
		199,
		207,
		197,
		195,
		189,
		221,
		-1,
		39,
		40,
		46,
		51,
		43,
		55,
		66,
		93,
		-1,
		-1,
		94,
		121,
		105,
		109,
		125,
		150,
		-1,
		186,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		189,
		178,
		169,
		175,
		181,
		192,
		214,
		203,
		204,
		194,
		204,
		217,
		23,
		25,
		35,
		39,
		56,
		74,
		62,
		-1,
		81,
		79,
		85,
		92,
		109,
		139,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		219,
		222,
		211,
		-1,
		201,
		174,
		179,
		204,
		211,
		212,
		206,
		200,
		207,
		206,
		214,
		222,
		26,
		0,
		45,
		61,
		57,
		70,
		67,
		66,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		231,
		212,
		-1,
		-1,
		219,
		212,
		200,
		188,
		178,
		188,
		196,
		196,
		199,
		203,
		198,
		209,
		201,
		205,
		222,
		-1,
		94,
		-1,
		98,
		80,
		94,
		109,
		117,
		-1,
		-1,
		-1,
		248,
		234,
		227,
		215,
		213,
		-1,
		253,
		237,
		218,
		-1,
		188,
		201,
		232,
		200,
		205,
		200,
		204,
		215,
		204,
		207,
		221,
		216,
		-1,
		-1,
		92,
		95,
		-1,
		-1,
		117,
		136,
		-1,
		239,
		228,
		213,
		205,
		-1,
		-1,
		225,
		221,
		-1,
		-1,
		189,
		214,
		203,
		211,
		206,
		208,
		214,
		217,
		206,
		210,
		222,
		-1,
		-1,
		99,
		100,
		105,
		-1,
		126,
		-1,
		241,
		-1,
		208,
		215,
		203,
		-1,
		-1,
		-1,
		227,
		190,
		211,
		221,
		226,
		224,
		215,
		212,
		219,
		217,
		213,
		224,
		-1,
		-1,
		-1,
		156,
		133,
		248,
		239,
		222,
		202,
		194,
		214,
		-1,
		215,
		-1,
		190,
		191,
		218,
		220,
		237,
		231,
		215,
		230,
		220,
		211,
		220,
		162,
		-1,
		137,
		196,
		179,
		208,
		174,
		186,
		236,
		-1,
		212,
		194,
		-1,
		222,
		212,
		254,
		235,
		228,
		215,
		222,
		224,
		217,
		-1,
		-1,
		-1,
		152,
		151,
		150,
		161,
		169,
		167,
		185,
		-1,
		224,
		206,
		185,
		202,
		202,
		193,
		201,
		244,
		240,
		233,
		235,
		225,
		-1,
		168,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		178,
		200,
		195,
		187,
		199,
		203,
		189,
		195,
		197,
		205,
		203,
		200,
		212,
		208,
		228,
		224,
		256,
		-1,
		175,
		-1,
		182,
		-1,
		-1,
		196,
		182,
		194,
		205,
		195,
		195,
		200,
		193,
		215,
		231,
		215,
		213,
		218,
		223,
		-1,
		185,
		186,
		-1,
		215,
		207,
		193,
		-1,
		186,
		-1,
		241,
		202,
		-1,
		222,
		202,
		-1,
		224,
		220,
		-1,
		-1,
		197,
		231,
		-1,
		-1,
		-1,
		216,
		196,
		236,
		220,
		-1,
		213,
		213,
		-1,
		-1,
		-1,
		211,
		234,
		-1,
		209,
		212,
		-1,
		203,
		209,
		238,
		215,
		219,
		-1,
		-1,
		-1,
		238,
		222,
		227,
		224,
		229,
		217,
		234,
		220,
		222,
		229,
		218,
		239,
		-1,
		-1,
		-1,
		237,
		229,
		229,
		-1,
		-1,
		247,
		230,
		230,
		238,
		-1,
		-1,
		-1,
		259,
		240,
		-1,
		-1,
		238,
		-1,
		-1,
		243,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		248,
		-1,
		-1,
		-1,
		239,
		246,
		254,
		-1,
		-1,
		-1,
		-1,
		231,
		232,
		276,
		269,
		-1,
		-1,
		-1,
		253,
		248,
		-1,
		-1,
		229,
		230,
		-1,
		-1,
		-1,
		281,
		265,
		-1,
		252,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		286,
		-1,
		287,
		262,
		269,
		-1,
		-1,
		-1,
		-1,
		299,
		291,
		300,
		-1,
		272,
		274,
		-1,
		322,
		-1,
		-1,
		314,
		305,
		-1,
		-1,
		277,
		284,
		306,
		309,
		313,
		-1,
		296
	],
	[
		-1,
		326,
		315,
		326,
		334,
		307,
		314,
		-1,
		333,
		337,
		303,
		297,
		336,
		305,
		311,
		322,
		-1,
		-1,
		-1,
		326,
		325,
		293,
		291,
		300,
		305,
		312,
		-1,
		311,
		-1,
		347,
		326,
		337,
		342,
		286,
		283,
		303,
		322,
		304,
		296,
		362,
		316,
		287,
		281,
		299,
		289,
		298,
		290,
		-1,
		287,
		277,
		299,
		278,
		289,
		281,
		-1,
		-1,
		281,
		282,
		288,
		274,
		280,
		276,
		-1,
		286,
		270,
		-1,
		-1,
		271,
		272,
		256,
		259,
		267,
		265,
		278,
		270,
		265,
		-1,
		-1,
		262,
		258,
		265,
		252,
		248,
		265,
		278,
		260,
		274,
		273,
		-1,
		268,
		286,
		291,
		259,
		257,
		241,
		239,
		257,
		259,
		265,
		265,
		-1,
		274,
		276,
		273,
		281,
		281,
		257,
		244,
		244,
		254,
		247,
		266,
		254,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		271,
		260,
		277,
		269,
		259,
		274,
		267,
		247,
		244,
		242,
		239,
		255,
		253,
		263,
		-1,
		-1,
		327,
		296,
		331,
		288,
		273,
		-1,
		267,
		253,
		259,
		263,
		257,
		250,
		264,
		260,
		-1,
		233,
		232,
		260,
		246,
		257,
		287,
		-1,
		-1,
		285,
		277,
		262,
		265,
		262,
		262,
		268,
		267,
		259,
		245,
		241,
		247,
		250,
		250,
		256,
		227,
		237,
		241,
		239,
		264,
		-1,
		-1,
		299,
		-1,
		-1,
		284,
		267,
		-1,
		250,
		257,
		257,
		274,
		264,
		285,
		278,
		269,
		261,
		255,
		243,
		245,
		242,
		255,
		243,
		224,
		249,
		253,
		234,
		255,
		250,
		-1,
		298,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		243,
		246,
		252,
		276,
		286,
		-1,
		290,
		278,
		279,
		264,
		261,
		248,
		236,
		249,
		234,
		241,
		240,
		228,
		226,
		256,
		231,
		253,
		250,
		269,
		274,
		268,
		277,
		-1,
		292,
		288,
		284,
		291,
		240,
		-1,
		-1,
		280,
		-1,
		294,
		307,
		302,
		275,
		278,
		265,
		256,
		243,
		232,
		243,
		232,
		229,
		237,
		220,
		235,
		226,
		225,
		243,
		253,
		261,
		265,
		271,
		-1,
		342,
		-1,
		284,
		268,
		270,
		242,
		263,
		-1,
		300,
		295,
		315,
		304,
		302,
		-1,
		274,
		271,
		261,
		239,
		224,
		241,
		233,
		231,
		233,
		215,
		229,
		220,
		238,
		245,
		243,
		247,
		267,
		279,
		302,
		292,
		-1,
		274,
		279,
		238,
		246,
		265,
		338,
		308,
		-1,
		303,
		-1,
		276,
		289,
		-1,
		245,
		241,
		223,
		224,
		219,
		234,
		226,
		211,
		208,
		226,
		229,
		236,
		240,
		256,
		-1,
		-1,
		287,
		291,
		280,
		231,
		250,
		274,
		311,
		301,
		290,
		289,
		-1,
		280,
		259,
		256,
		244,
		231,
		216,
		217,
		225,
		237,
		216,
		210,
		207,
		227,
		253,
		231,
		242,
		-1,
		-1,
		-1,
		312,
		-1,
		-1,
		257,
		228,
		252,
		294,
		319,
		312,
		300,
		265,
		265,
		259,
		-1,
		255,
		234,
		225,
		214,
		212,
		225,
		217,
		225,
		205,
		203,
		222,
		234,
		225,
		233,
		-1,
		-1,
		-1,
		287,
		276,
		277,
		226,
		249,
		283,
		298,
		284,
		289,
		264,
		257,
		251,
		268,
		251,
		232,
		221,
		213,
		202,
		213,
		221,
		219,
		201,
		210,
		216,
		240,
		221,
		227,
		-1,
		-1,
		294,
		284,
		268,
		270,
		267,
		240,
		247,
		279,
		289,
		291,
		-1,
		256,
		-1,
		245,
		241,
		226,
		221,
		218,
		205,
		204,
		218,
		218,
		208,
		203,
		210,
		245,
		245,
		211,
		231,
		234,
		-1,
		-1,
		-1,
		287,
		285,
		260,
		237,
		221,
		257,
		-1,
		261,
		262,
		-1,
		250,
		244,
		241,
		228,
		224,
		209,
		213,
		215,
		218,
		206,
		212,
		213,
		195,
		219,
		-1,
		219,
		213,
		221,
		211,
		199,
		-1,
		-1,
		-1,
		283,
		262,
		255,
		275,
		216,
		268,
		-1,
		-1,
		246,
		239,
		-1,
		237,
		219,
		221,
		216,
		212,
		214,
		211,
		200,
		213,
		206,
		200,
		194,
		207,
		211,
		212,
		201,
		197,
		194,
		208,
		-1,
		302,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		236,
		-1,
		249,
		241,
		237,
		231,
		236,
		232,
		230,
		240,
		224,
		226,
		222,
		214,
		209,
		195,
		188,
		199,
		184,
		202,
		208,
		199,
		194,
		193,
		204,
		-1,
		303,
		289,
		260,
		-1,
		-1,
		249,
		-1,
		213,
		227,
		243,
		-1,
		271,
		250,
		268,
		246,
		242,
		233,
		231,
		232,
		202,
		207,
		209,
		197,
		200,
		189,
		192,
		184,
		206,
		203,
		187,
		189,
		198,
		-1,
		309,
		296,
		254,
		250,
		239,
		259,
		210,
		219,
		230,
		-1,
		-1,
		293,
		-1,
		244,
		249,
		247,
		245,
		221,
		196,
		203,
		221,
		194,
		189,
		194,
		183,
		183,
		178,
		197,
		183,
		181,
		196,
		212,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		225,
		212,
		206,
		-1,
		247,
		-1,
		271,
		259,
		246,
		228,
		268,
		-1,
		195,
		191,
		198,
		-1,
		214,
		-1,
		186,
		189,
		180,
		175,
		172,
		183,
		181,
		190,
		191,
		-1,
		259,
		244,
		237,
		227,
		241,
		212,
		-1,
		255,
		-1,
		-1,
		258,
		252,
		252,
		221,
		218,
		211,
		191,
		183,
		198,
		197,
		184,
		183,
		171,
		171,
		174,
		168,
		181,
		191,
		197,
		189,
		-1,
		-1,
		-1,
		264,
		216,
		224,
		200,
		221,
		-1,
		-1,
		319,
		275,
		261,
		-1,
		213,
		211,
		199,
		189,
		179,
		184,
		185,
		175,
		173,
		169,
		178,
		177,
		170,
		169,
		190,
		183,
		205,
		-1,
		-1,
		213,
		226,
		228,
		212,
		207,
		-1,
		-1,
		-1,
		265,
		266,
		232,
		211,
		200,
		-1,
		-1,
		183,
		176,
		170,
		173,
		161,
		181,
		188,
		176,
		163,
		178,
		188,
		196,
		195,
		-1,
		216,
		203,
		-1,
		-1,
		206,
		196,
		-1,
		-1,
		-1,
		-1,
		244,
		189,
		178,
		173,
		177,
		182,
		-1,
		156,
		167,
		160,
		179,
		186,
		178,
		163,
		157,
		168,
		183,
		200,
		-1,
		-1,
		220,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		201,
		195,
		166,
		159,
		163,
		-1,
		158,
		160,
		157,
		169,
		174,
		178,
		169,
		151,
		165,
		168,
		181,
		195,
		199,
		243,
		-1,
		173,
		-1,
		-1,
		-1,
		212,
		213,
		199,
		176,
		155,
		148,
		145,
		144,
		149,
		160,
		169,
		180,
		145,
		149,
		164,
		169,
		173,
		190,
		194,
		-1,
		-1,
		171,
		167,
		202,
		214,
		186,
		226,
		-1,
		-1,
		144,
		137,
		147,
		140,
		153,
		156,
		141,
		143,
		161,
		174,
		168,
		178,
		193,
		188,
		-1,
		-1,
		-1,
		169,
		-1,
		185,
		-1,
		-1,
		176,
		217,
		164,
		146,
		142,
		128,
		135,
		129,
		131,
		136,
		155,
		150,
		159,
		164,
		168,
		191,
		180,
		219,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		135,
		154,
		149,
		155,
		160,
		151,
		179,
		176,
		-1,
		125,
		158,
		126,
		140,
		136,
		143,
		148,
		154,
		158,
		165,
		181,
		180,
		175,
		211,
		202,
		208,
		-1,
		-1,
		162,
		151,
		140,
		146,
		-1,
		128,
		151,
		141,
		131,
		137,
		-1,
		-1,
		143,
		140,
		138,
		118,
		124,
		129,
		132,
		170,
		146,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		116,
		153,
		146,
		114,
		122,
		153,
		-1,
		118,
		110,
		138,
		123,
		131,
		-1,
		-1,
		116,
		107,
		112,
		121,
		122,
		153,
		152,
		165,
		168,
		173,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		109,
		129,
		108,
		111,
		135,
		149,
		-1,
		109,
		-1,
		-1,
		154,
		141,
		125,
		115,
		112,
		159,
		135,
		130,
		136,
		138,
		162,
		153,
		178,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		98,
		109,
		102,
		-1,
		-1,
		-1,
		-1,
		103,
		-1,
		-1,
		170,
		-1,
		152,
		-1,
		135,
		139,
		143,
		146,
		161,
		148,
		155,
		172,
		178,
		167,
		177,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		76,
		79,
		82,
		93,
		104,
		119,
		123,
		-1,
		93,
		129,
		139,
		-1,
		179,
		-1,
		-1,
		-1,
		149,
		156,
		148,
		164,
		160,
		160,
		156,
		160,
		172,
		179,
		189,
		191,
		183,
		187,
		200,
		211,
		214,
		72,
		73,
		123,
		68,
		68,
		89,
		98,
		119,
		89,
		86,
		123,
		128,
		143,
		148,
		172,
		-1,
		-1,
		172,
		166,
		-1,
		-1,
		167,
		177,
		160,
		162,
		166,
		180,
		192,
		200,
		190,
		188,
		182,
		214,
		-1,
		47,
		38,
		39,
		44,
		36,
		48,
		59,
		86,
		-1,
		-1,
		87,
		114,
		98,
		102,
		118,
		143,
		-1,
		179,
		-1,
		-1,
		193,
		-1,
		-1,
		219,
		182,
		171,
		162,
		168,
		174,
		185,
		207,
		196,
		197,
		187,
		197,
		210,
		31,
		24,
		28,
		32,
		49,
		67,
		55,
		-1,
		74,
		72,
		78,
		85,
		102,
		132,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		212,
		215,
		204,
		-1,
		194,
		167,
		172,
		197,
		204,
		205,
		199,
		193,
		200,
		199,
		207,
		215,
		40,
		50,
		0,
		54,
		50,
		63,
		60,
		59,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		-1,
		224,
		205,
		-1,
		-1,
		212,
		205,
		193,
		181,
		171,
		181,
		189,
		189,
		192,
		196,
		191,
		202,
		194,
		198,
		215,
		-1,
		87,
		-1,
		91,
		73,
		87,
		102,
		110,
		-1,
		-1,
		-1,
		241,
		227,
		220,
		208,
		206,
		-1,
		246,
		230,
		211,
		-1,
		181,
		194,
		225,
		193,
		198,
		193,
		197,
		208,
		197,
		200,
		214,
		209,
		-1,
		-1,
		85,
		88,
		-1,
		-1,
		110,
		129,
		-1,
		232,
		221,
		206,
		198,
		-1,
		-1,
		218,
		214,
		-1,
		-1,
		182,
		207,
		196,
		204,
		199,
		201,
		207,
		210,
		199,
		203,
		215,
		-1,
		-1,
		92,
		93,
		98,
		-1,
		119,
		-1,
		234,
		-1,
		201,
		208,
		196,
		-1,
		-1,
		-1,
		220,
		183,
		204,
		214,
		219,
		217,
		208,
		205,
		212,
		210,
		206,
		217,
		-1,
		-1,
		-1,
		149,
		126,
		241,
		232,
		215,
		195,
		187,
		207,
		-1,
		208,
		-1,
		183,
		184,
		211,
		213,
		230,
		224,
		208,
		223,
		213,
		204,
		213,
		155,
		-1,
		130,
		189,
		172,
		201,
		167,
		179,
		229,
		-1,
		205,
		187,
		-1,
		215,
		205,
		247,
		228,
		221,
		208,
		215,
		217,
		210,
		-1,
		-1,
		-1,
		145,
		144,
		143,
		154,
		162,
		160,
		178,
		-1,
		217,
		199,
		178,
		195,
		195,
		186,
		194,
		237,
		233,
		226,
		228,
		218,
		-1,
		161,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		171,
		193,
		188,
		180,
		192,
		196,
		182,
		188,
		190,
		198,
		196,
		193,
		205,
		201,
		221,
		217,
		249,
		-1,
		168,
		-1,
		175,
		-1,
		-1,
		189,
		175,
		187,
		198,
		188,
		188,
		193,
		186,
		208,
		224,
		208,
		206,
		211,
		216,
		-1,
		178,
		179,
		-1,
		208,
		200,
		186,
		-1,
		179,
		-1,
		234,
		195,
		-1,
		215,
		195,
		-1,
		217,
		213,
		-1,
		-1,
		190,
		224,
		-1,
		-1,
		-1,
		209,
		189,
		229,
		213,
		-1,
		206,
		206,
		-1,
		-1,
		-1,
		204,
		227,
		-1,
		202,
		205,
		-1,
		196,
		202,
		231,
		208,
		212,
		-1,
		-1,
		-1,
		231,
		215,
		220,
		217,
		222,
		210,
		227,
		213,
		215,
		222,
		211,
		232,
		-1,
		-1,
		-1,
		230,
		222,
		222,
		-1,
		-1,
		240,
		223,
		223,
		231,
		-1,
		-1,
		-1,
		252,
		233,
		-1,
		-1,
		231,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		241,
		-1,
		-1,
		-1,
		232,
		239,
		247,
		-1,
		-1,
		-1,
		-1,
		224,
		225,
		269,
		262,
		-1,
		-1,
		-1,
		246,
		241,
		-1,
		-1,
		222,
		223,
		-1,
		-1,
		-1,
		274,
		258,
		-1,
		245,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		279,
		-1,
		280,
		255,
		262,
		-1,
		-1,
		-1,
		-1,
		292,
		284,
		293,
		-1,
		265,
		267,
		-1,
		315,
		-1,
		-1,
		307,
		298,
		-1,
		-1,
		270,
		277,
		299,
		302,
		306,
		-1,
		289
	],
	[
		-1,
		317,
		306,
		317,
		325,
		298,
		305,
		-1,
		324,
		328,
		294,
		288,
		327,
		296,
		302,
		313,
		-1,
		-1,
		-1,
		317,
		316,
		284,
		282,
		291,
		296,
		303,
		-1,
		302,
		-1,
		338,
		317,
		328,
		333,
		277,
		274,
		294,
		313,
		295,
		287,
		353,
		307,
		278,
		272,
		290,
		280,
		289,
		281,
		-1,
		278,
		268,
		290,
		269,
		280,
		272,
		-1,
		-1,
		272,
		273,
		279,
		265,
		271,
		267,
		-1,
		277,
		261,
		-1,
		-1,
		262,
		263,
		247,
		250,
		258,
		256,
		269,
		261,
		256,
		-1,
		-1,
		253,
		249,
		256,
		243,
		239,
		256,
		269,
		251,
		265,
		264,
		-1,
		259,
		277,
		282,
		250,
		248,
		232,
		230,
		248,
		250,
		256,
		256,
		-1,
		265,
		267,
		264,
		272,
		272,
		248,
		235,
		235,
		245,
		238,
		257,
		245,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		262,
		251,
		268,
		260,
		250,
		265,
		258,
		238,
		235,
		233,
		230,
		246,
		244,
		254,
		-1,
		-1,
		318,
		287,
		322,
		279,
		264,
		-1,
		258,
		244,
		250,
		254,
		248,
		241,
		255,
		251,
		-1,
		224,
		223,
		251,
		237,
		248,
		278,
		-1,
		-1,
		276,
		268,
		253,
		256,
		253,
		253,
		259,
		258,
		250,
		236,
		232,
		238,
		241,
		241,
		247,
		218,
		228,
		232,
		230,
		255,
		-1,
		-1,
		290,
		-1,
		-1,
		275,
		258,
		-1,
		241,
		248,
		248,
		265,
		255,
		276,
		269,
		260,
		252,
		246,
		234,
		236,
		233,
		246,
		234,
		215,
		240,
		244,
		225,
		246,
		241,
		-1,
		289,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		234,
		237,
		243,
		267,
		277,
		-1,
		281,
		269,
		270,
		255,
		252,
		239,
		227,
		240,
		225,
		232,
		231,
		219,
		217,
		247,
		222,
		244,
		241,
		260,
		265,
		259,
		268,
		-1,
		283,
		279,
		275,
		282,
		231,
		-1,
		-1,
		271,
		-1,
		285,
		298,
		293,
		266,
		269,
		256,
		247,
		234,
		223,
		234,
		223,
		220,
		228,
		211,
		226,
		217,
		216,
		234,
		244,
		252,
		256,
		262,
		-1,
		333,
		-1,
		275,
		259,
		261,
		233,
		254,
		-1,
		291,
		286,
		306,
		295,
		293,
		-1,
		265,
		262,
		252,
		230,
		215,
		232,
		224,
		222,
		224,
		206,
		220,
		211,
		229,
		236,
		234,
		238,
		258,
		270,
		293,
		283,
		-1,
		265,
		270,
		229,
		237,
		256,
		329,
		299,
		-1,
		294,
		-1,
		267,
		280,
		-1,
		236,
		232,
		214,
		215,
		210,
		225,
		217,
		202,
		199,
		217,
		220,
		227,
		231,
		247,
		-1,
		-1,
		278,
		282,
		271,
		222,
		241,
		265,
		302,
		292,
		281,
		280,
		-1,
		271,
		250,
		247,
		235,
		222,
		207,
		208,
		216,
		228,
		207,
		201,
		198,
		218,
		244,
		222,
		233,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		248,
		219,
		243,
		285,
		310,
		303,
		291,
		256,
		256,
		250,
		-1,
		246,
		225,
		216,
		205,
		203,
		216,
		208,
		216,
		196,
		194,
		213,
		225,
		216,
		224,
		-1,
		-1,
		-1,
		278,
		267,
		268,
		217,
		240,
		274,
		289,
		275,
		280,
		255,
		248,
		242,
		259,
		242,
		223,
		212,
		204,
		193,
		204,
		212,
		210,
		192,
		201,
		207,
		231,
		212,
		218,
		-1,
		-1,
		285,
		275,
		259,
		261,
		258,
		231,
		238,
		270,
		280,
		282,
		-1,
		247,
		-1,
		236,
		232,
		217,
		212,
		209,
		196,
		195,
		209,
		209,
		199,
		194,
		201,
		236,
		236,
		202,
		222,
		225,
		-1,
		-1,
		-1,
		278,
		276,
		251,
		228,
		212,
		248,
		-1,
		252,
		253,
		-1,
		241,
		235,
		232,
		219,
		215,
		200,
		204,
		206,
		209,
		197,
		203,
		204,
		186,
		210,
		-1,
		210,
		204,
		212,
		202,
		190,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		237,
		230,
		-1,
		228,
		210,
		212,
		207,
		203,
		205,
		202,
		191,
		204,
		197,
		191,
		185,
		198,
		202,
		203,
		192,
		188,
		185,
		199,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		240,
		232,
		228,
		222,
		227,
		223,
		221,
		231,
		215,
		217,
		213,
		205,
		200,
		186,
		179,
		190,
		175,
		193,
		199,
		190,
		185,
		184,
		195,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		218,
		234,
		-1,
		262,
		241,
		259,
		237,
		233,
		224,
		222,
		223,
		193,
		198,
		200,
		188,
		191,
		180,
		183,
		175,
		197,
		194,
		178,
		180,
		189,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		210,
		221,
		-1,
		-1,
		284,
		-1,
		235,
		240,
		238,
		236,
		212,
		187,
		194,
		212,
		185,
		180,
		185,
		174,
		174,
		169,
		188,
		174,
		172,
		187,
		203,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		238,
		-1,
		262,
		250,
		237,
		219,
		259,
		-1,
		186,
		182,
		189,
		-1,
		205,
		-1,
		177,
		180,
		171,
		166,
		163,
		174,
		172,
		181,
		182,
		-1,
		250,
		235,
		228,
		218,
		232,
		203,
		-1,
		246,
		-1,
		-1,
		249,
		243,
		243,
		212,
		209,
		202,
		182,
		174,
		189,
		188,
		175,
		174,
		162,
		162,
		165,
		159,
		172,
		182,
		188,
		180,
		-1,
		-1,
		-1,
		255,
		207,
		215,
		191,
		212,
		-1,
		-1,
		310,
		266,
		252,
		-1,
		204,
		202,
		190,
		180,
		170,
		175,
		176,
		166,
		164,
		160,
		169,
		168,
		161,
		160,
		181,
		174,
		196,
		-1,
		-1,
		204,
		217,
		219,
		203,
		198,
		-1,
		-1,
		-1,
		256,
		257,
		223,
		202,
		191,
		-1,
		-1,
		174,
		167,
		161,
		164,
		152,
		172,
		179,
		167,
		154,
		169,
		179,
		187,
		186,
		-1,
		207,
		194,
		-1,
		-1,
		197,
		187,
		-1,
		-1,
		-1,
		-1,
		235,
		180,
		169,
		164,
		168,
		173,
		-1,
		147,
		158,
		151,
		170,
		177,
		169,
		154,
		148,
		159,
		174,
		191,
		-1,
		-1,
		211,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		192,
		186,
		157,
		150,
		154,
		-1,
		149,
		151,
		148,
		160,
		165,
		169,
		160,
		142,
		156,
		159,
		172,
		186,
		190,
		234,
		-1,
		164,
		-1,
		-1,
		-1,
		203,
		204,
		190,
		167,
		146,
		139,
		136,
		135,
		140,
		151,
		160,
		171,
		136,
		140,
		155,
		160,
		164,
		181,
		185,
		-1,
		-1,
		162,
		158,
		193,
		205,
		177,
		217,
		-1,
		-1,
		135,
		128,
		138,
		131,
		144,
		147,
		132,
		134,
		152,
		165,
		159,
		169,
		184,
		179,
		-1,
		-1,
		-1,
		160,
		-1,
		176,
		-1,
		-1,
		167,
		208,
		155,
		137,
		133,
		119,
		126,
		120,
		122,
		127,
		146,
		141,
		150,
		155,
		159,
		182,
		171,
		210,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		126,
		145,
		140,
		146,
		151,
		142,
		170,
		167,
		-1,
		116,
		149,
		117,
		131,
		127,
		134,
		139,
		145,
		149,
		156,
		172,
		171,
		166,
		202,
		193,
		199,
		-1,
		-1,
		153,
		142,
		131,
		137,
		-1,
		119,
		142,
		132,
		122,
		128,
		-1,
		-1,
		134,
		131,
		129,
		109,
		115,
		120,
		123,
		161,
		137,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		107,
		144,
		137,
		105,
		113,
		144,
		-1,
		109,
		101,
		129,
		114,
		122,
		-1,
		-1,
		107,
		98,
		103,
		112,
		113,
		144,
		143,
		156,
		159,
		164,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		100,
		120,
		99,
		102,
		126,
		140,
		-1,
		100,
		-1,
		-1,
		145,
		132,
		116,
		106,
		103,
		150,
		126,
		121,
		127,
		129,
		153,
		144,
		169,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		89,
		100,
		93,
		-1,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		161,
		-1,
		143,
		-1,
		126,
		130,
		134,
		137,
		152,
		139,
		146,
		163,
		169,
		158,
		168,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		60,
		70,
		73,
		84,
		95,
		110,
		114,
		-1,
		84,
		120,
		130,
		-1,
		170,
		-1,
		-1,
		-1,
		140,
		147,
		139,
		155,
		151,
		151,
		147,
		151,
		163,
		170,
		180,
		182,
		174,
		178,
		191,
		202,
		205,
		56,
		61,
		114,
		59,
		59,
		80,
		89,
		110,
		80,
		77,
		114,
		119,
		134,
		139,
		163,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		158,
		168,
		151,
		153,
		157,
		171,
		183,
		191,
		181,
		179,
		173,
		205,
		-1,
		56,
		51,
		38,
		33,
		27,
		39,
		50,
		77,
		-1,
		-1,
		78,
		105,
		89,
		93,
		109,
		134,
		-1,
		170,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		165,
		176,
		198,
		187,
		188,
		178,
		188,
		201,
		40,
		33,
		21,
		23,
		29,
		58,
		46,
		-1,
		65,
		63,
		69,
		76,
		93,
		123,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		203,
		206,
		195,
		-1,
		185,
		158,
		163,
		188,
		195,
		196,
		190,
		184,
		191,
		190,
		198,
		206,
		49,
		59,
		48,
		0,
		30,
		43,
		51,
		50,
		62,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		-1,
		215,
		196,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		180,
		180,
		183,
		187,
		182,
		193,
		185,
		189,
		206,
		-1,
		58,
		-1,
		82,
		64,
		78,
		93,
		101,
		-1,
		-1,
		-1,
		232,
		218,
		211,
		199,
		197,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		188,
		199,
		188,
		191,
		205,
		200,
		-1,
		-1,
		76,
		79,
		-1,
		-1,
		101,
		120,
		-1,
		223,
		212,
		197,
		189,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		192,
		198,
		201,
		190,
		194,
		206,
		-1,
		-1,
		83,
		84,
		89,
		-1,
		110,
		-1,
		225,
		-1,
		192,
		199,
		187,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		210,
		208,
		199,
		196,
		203,
		201,
		197,
		208,
		-1,
		-1,
		-1,
		140,
		117,
		232,
		223,
		206,
		186,
		178,
		198,
		-1,
		199,
		-1,
		174,
		175,
		202,
		204,
		221,
		215,
		199,
		214,
		204,
		195,
		204,
		146,
		-1,
		121,
		180,
		163,
		192,
		158,
		170,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		238,
		219,
		212,
		199,
		206,
		208,
		201,
		-1,
		-1,
		-1,
		136,
		135,
		134,
		145,
		153,
		151,
		169,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		228,
		224,
		217,
		219,
		209,
		-1,
		128,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		162,
		184,
		179,
		171,
		183,
		187,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		208,
		240,
		-1,
		135,
		-1,
		166,
		-1,
		-1,
		180,
		166,
		178,
		189,
		179,
		179,
		184,
		177,
		199,
		215,
		199,
		197,
		202,
		207,
		-1,
		145,
		146,
		-1,
		199,
		191,
		177,
		-1,
		170,
		-1,
		225,
		186,
		-1,
		206,
		186,
		-1,
		208,
		204,
		-1,
		-1,
		157,
		203,
		-1,
		-1,
		-1,
		200,
		180,
		220,
		204,
		-1,
		197,
		197,
		-1,
		-1,
		-1,
		171,
		194,
		-1,
		193,
		196,
		-1,
		187,
		193,
		222,
		199,
		203,
		-1,
		-1,
		-1,
		198,
		182,
		187,
		208,
		213,
		201,
		218,
		204,
		206,
		213,
		202,
		223,
		-1,
		-1,
		-1,
		201,
		198,
		209,
		-1,
		-1,
		231,
		214,
		214,
		222,
		-1,
		-1,
		-1,
		223,
		204,
		-1,
		-1,
		218,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		219,
		226,
		238,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		252,
		233,
		-1,
		-1,
		-1,
		233,
		232,
		-1,
		-1,
		205,
		206,
		-1,
		-1,
		-1,
		261,
		245,
		-1,
		236,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		266,
		-1,
		271,
		246,
		253,
		-1,
		-1,
		-1,
		-1,
		279,
		271,
		284,
		-1,
		256,
		258,
		-1,
		306,
		-1,
		-1,
		294,
		285,
		-1,
		-1,
		261,
		268,
		290,
		293,
		289,
		-1,
		280
	],
	[
		-1,
		322,
		311,
		322,
		330,
		303,
		310,
		-1,
		329,
		333,
		299,
		293,
		332,
		301,
		307,
		318,
		-1,
		-1,
		-1,
		322,
		321,
		289,
		287,
		296,
		301,
		308,
		-1,
		307,
		-1,
		343,
		322,
		333,
		338,
		282,
		279,
		299,
		318,
		300,
		292,
		358,
		312,
		283,
		277,
		295,
		285,
		294,
		286,
		-1,
		283,
		273,
		295,
		274,
		285,
		277,
		-1,
		-1,
		277,
		278,
		284,
		270,
		276,
		272,
		-1,
		282,
		266,
		-1,
		-1,
		267,
		268,
		252,
		255,
		263,
		261,
		274,
		266,
		261,
		-1,
		-1,
		258,
		254,
		261,
		248,
		244,
		261,
		274,
		256,
		270,
		269,
		-1,
		264,
		282,
		287,
		255,
		253,
		237,
		235,
		253,
		255,
		261,
		261,
		-1,
		270,
		272,
		269,
		277,
		277,
		253,
		240,
		240,
		250,
		243,
		262,
		250,
		296,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		267,
		256,
		273,
		265,
		255,
		270,
		263,
		243,
		240,
		238,
		235,
		251,
		249,
		259,
		-1,
		-1,
		323,
		292,
		327,
		284,
		269,
		-1,
		263,
		249,
		255,
		259,
		253,
		246,
		260,
		256,
		-1,
		229,
		228,
		256,
		242,
		253,
		283,
		-1,
		-1,
		281,
		273,
		258,
		261,
		258,
		258,
		264,
		263,
		255,
		241,
		237,
		243,
		246,
		246,
		252,
		223,
		233,
		237,
		235,
		260,
		-1,
		-1,
		295,
		-1,
		-1,
		280,
		263,
		-1,
		246,
		253,
		253,
		270,
		260,
		281,
		274,
		265,
		257,
		251,
		239,
		241,
		238,
		251,
		239,
		220,
		245,
		249,
		230,
		251,
		246,
		-1,
		294,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		239,
		242,
		248,
		272,
		282,
		-1,
		286,
		274,
		275,
		260,
		257,
		244,
		232,
		245,
		230,
		237,
		236,
		224,
		222,
		252,
		227,
		249,
		246,
		265,
		270,
		264,
		273,
		-1,
		288,
		284,
		280,
		287,
		236,
		-1,
		-1,
		276,
		-1,
		290,
		303,
		298,
		271,
		274,
		261,
		252,
		239,
		228,
		239,
		228,
		225,
		233,
		216,
		231,
		222,
		221,
		239,
		249,
		257,
		261,
		267,
		-1,
		338,
		-1,
		280,
		264,
		266,
		238,
		259,
		-1,
		296,
		291,
		311,
		300,
		298,
		-1,
		270,
		267,
		257,
		235,
		220,
		237,
		229,
		227,
		229,
		211,
		225,
		216,
		234,
		241,
		239,
		243,
		263,
		275,
		298,
		288,
		-1,
		270,
		275,
		234,
		242,
		261,
		334,
		304,
		-1,
		299,
		-1,
		272,
		285,
		-1,
		241,
		237,
		219,
		220,
		215,
		230,
		222,
		207,
		204,
		222,
		225,
		232,
		236,
		252,
		-1,
		-1,
		283,
		287,
		276,
		227,
		246,
		270,
		307,
		297,
		286,
		285,
		-1,
		276,
		255,
		252,
		240,
		227,
		212,
		213,
		221,
		233,
		212,
		206,
		203,
		223,
		249,
		227,
		238,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		253,
		224,
		248,
		290,
		315,
		308,
		296,
		261,
		261,
		255,
		-1,
		251,
		230,
		221,
		210,
		208,
		221,
		213,
		221,
		201,
		199,
		218,
		230,
		221,
		229,
		-1,
		-1,
		-1,
		283,
		272,
		273,
		222,
		245,
		279,
		294,
		280,
		285,
		260,
		253,
		247,
		264,
		247,
		228,
		217,
		209,
		198,
		209,
		217,
		215,
		197,
		206,
		212,
		236,
		217,
		223,
		-1,
		-1,
		290,
		280,
		264,
		266,
		263,
		236,
		243,
		275,
		285,
		287,
		-1,
		252,
		-1,
		241,
		237,
		222,
		217,
		214,
		201,
		200,
		214,
		214,
		204,
		199,
		206,
		241,
		241,
		207,
		227,
		230,
		-1,
		-1,
		-1,
		283,
		281,
		256,
		233,
		217,
		253,
		-1,
		257,
		258,
		-1,
		246,
		240,
		237,
		224,
		220,
		205,
		209,
		211,
		214,
		202,
		208,
		209,
		191,
		215,
		-1,
		215,
		209,
		217,
		207,
		195,
		-1,
		-1,
		-1,
		279,
		258,
		251,
		271,
		212,
		264,
		-1,
		-1,
		242,
		235,
		-1,
		233,
		215,
		217,
		212,
		208,
		210,
		207,
		196,
		209,
		202,
		196,
		190,
		203,
		207,
		208,
		197,
		193,
		190,
		204,
		-1,
		298,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		232,
		-1,
		245,
		237,
		233,
		227,
		232,
		228,
		226,
		236,
		220,
		222,
		218,
		210,
		205,
		191,
		184,
		195,
		180,
		198,
		204,
		195,
		190,
		189,
		200,
		-1,
		299,
		285,
		256,
		-1,
		-1,
		245,
		-1,
		209,
		223,
		239,
		-1,
		267,
		246,
		264,
		242,
		238,
		229,
		227,
		228,
		198,
		203,
		205,
		193,
		196,
		185,
		188,
		180,
		202,
		199,
		183,
		185,
		194,
		-1,
		305,
		292,
		250,
		246,
		235,
		255,
		206,
		215,
		226,
		-1,
		-1,
		289,
		-1,
		240,
		245,
		243,
		241,
		217,
		192,
		199,
		217,
		190,
		185,
		190,
		179,
		179,
		174,
		193,
		179,
		177,
		192,
		208,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		221,
		208,
		202,
		-1,
		243,
		-1,
		267,
		255,
		242,
		224,
		264,
		-1,
		191,
		187,
		194,
		-1,
		210,
		-1,
		182,
		185,
		176,
		171,
		168,
		179,
		177,
		186,
		187,
		-1,
		255,
		240,
		233,
		223,
		237,
		208,
		-1,
		251,
		-1,
		-1,
		254,
		248,
		248,
		217,
		214,
		207,
		187,
		179,
		194,
		193,
		180,
		179,
		167,
		167,
		170,
		164,
		177,
		187,
		193,
		185,
		-1,
		-1,
		-1,
		260,
		212,
		220,
		196,
		217,
		-1,
		-1,
		315,
		271,
		257,
		-1,
		209,
		207,
		195,
		185,
		175,
		180,
		181,
		171,
		169,
		165,
		174,
		173,
		166,
		165,
		186,
		179,
		201,
		-1,
		-1,
		209,
		222,
		224,
		208,
		203,
		-1,
		-1,
		-1,
		261,
		262,
		228,
		207,
		196,
		-1,
		-1,
		179,
		172,
		166,
		169,
		157,
		177,
		184,
		172,
		159,
		174,
		184,
		192,
		191,
		-1,
		212,
		199,
		-1,
		-1,
		202,
		192,
		-1,
		-1,
		-1,
		-1,
		240,
		185,
		174,
		169,
		173,
		178,
		-1,
		152,
		163,
		156,
		175,
		182,
		174,
		159,
		153,
		164,
		179,
		196,
		-1,
		-1,
		216,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		197,
		191,
		162,
		155,
		159,
		-1,
		154,
		156,
		153,
		165,
		170,
		174,
		165,
		147,
		161,
		164,
		177,
		191,
		195,
		239,
		-1,
		169,
		-1,
		-1,
		-1,
		208,
		209,
		195,
		172,
		151,
		144,
		141,
		140,
		145,
		156,
		165,
		176,
		141,
		145,
		160,
		165,
		169,
		186,
		190,
		-1,
		-1,
		167,
		163,
		198,
		210,
		182,
		222,
		-1,
		-1,
		140,
		133,
		143,
		136,
		149,
		152,
		137,
		139,
		157,
		170,
		164,
		174,
		189,
		184,
		-1,
		-1,
		-1,
		165,
		-1,
		181,
		-1,
		-1,
		172,
		213,
		160,
		142,
		138,
		124,
		131,
		125,
		127,
		132,
		151,
		146,
		155,
		160,
		164,
		187,
		176,
		215,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		131,
		150,
		145,
		151,
		156,
		147,
		175,
		172,
		-1,
		121,
		154,
		122,
		136,
		132,
		139,
		144,
		150,
		154,
		161,
		177,
		176,
		171,
		207,
		198,
		204,
		-1,
		-1,
		158,
		147,
		136,
		142,
		-1,
		124,
		147,
		137,
		127,
		133,
		-1,
		-1,
		139,
		136,
		134,
		114,
		120,
		125,
		128,
		166,
		142,
		150,
		154,
		158,
		164,
		169,
		174,
		180,
		195,
		210,
		-1,
		112,
		149,
		142,
		110,
		118,
		149,
		-1,
		114,
		106,
		134,
		119,
		127,
		-1,
		-1,
		112,
		103,
		108,
		117,
		118,
		149,
		148,
		161,
		164,
		169,
		157,
		156,
		174,
		178,
		187,
		194,
		184,
		197,
		201,
		-1,
		105,
		125,
		104,
		107,
		131,
		145,
		-1,
		105,
		-1,
		-1,
		150,
		137,
		121,
		111,
		108,
		155,
		131,
		126,
		132,
		134,
		158,
		149,
		174,
		165,
		165,
		168,
		183,
		188,
		180,
		194,
		194,
		195,
		-1,
		94,
		105,
		98,
		-1,
		-1,
		-1,
		-1,
		99,
		-1,
		-1,
		166,
		-1,
		148,
		-1,
		131,
		135,
		139,
		142,
		157,
		144,
		151,
		168,
		174,
		163,
		173,
		169,
		170,
		179,
		190,
		202,
		201,
		202,
		65,
		75,
		78,
		89,
		100,
		115,
		119,
		-1,
		89,
		125,
		135,
		-1,
		175,
		-1,
		-1,
		-1,
		145,
		152,
		144,
		160,
		156,
		156,
		152,
		156,
		168,
		175,
		185,
		187,
		179,
		183,
		196,
		207,
		210,
		61,
		66,
		119,
		64,
		64,
		85,
		94,
		115,
		85,
		82,
		119,
		124,
		139,
		144,
		168,
		-1,
		-1,
		168,
		162,
		-1,
		-1,
		163,
		173,
		156,
		158,
		162,
		176,
		188,
		196,
		186,
		184,
		178,
		210,
		-1,
		61,
		56,
		43,
		38,
		32,
		44,
		55,
		82,
		-1,
		-1,
		83,
		110,
		94,
		98,
		114,
		139,
		-1,
		175,
		-1,
		-1,
		189,
		-1,
		-1,
		215,
		178,
		167,
		158,
		164,
		170,
		181,
		203,
		192,
		193,
		183,
		193,
		206,
		45,
		38,
		26,
		28,
		5,
		63,
		51,
		-1,
		70,
		68,
		74,
		81,
		98,
		128,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		208,
		211,
		200,
		-1,
		190,
		163,
		168,
		193,
		200,
		201,
		195,
		189,
		196,
		195,
		203,
		211,
		54,
		64,
		53,
		38,
		0,
		13,
		56,
		55,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		-1,
		220,
		201,
		-1,
		-1,
		208,
		201,
		189,
		177,
		167,
		177,
		185,
		185,
		188,
		192,
		187,
		198,
		190,
		194,
		211,
		-1,
		71,
		-1,
		87,
		69,
		83,
		98,
		106,
		-1,
		-1,
		-1,
		237,
		223,
		216,
		204,
		202,
		-1,
		242,
		226,
		207,
		-1,
		177,
		190,
		221,
		189,
		194,
		189,
		193,
		204,
		193,
		196,
		210,
		205,
		-1,
		-1,
		81,
		84,
		-1,
		-1,
		106,
		125,
		-1,
		228,
		217,
		202,
		194,
		-1,
		-1,
		214,
		210,
		-1,
		-1,
		178,
		203,
		192,
		200,
		195,
		197,
		203,
		206,
		195,
		199,
		211,
		-1,
		-1,
		88,
		89,
		94,
		-1,
		115,
		-1,
		230,
		-1,
		197,
		204,
		192,
		-1,
		-1,
		-1,
		216,
		179,
		200,
		210,
		215,
		213,
		204,
		201,
		208,
		206,
		202,
		213,
		-1,
		-1,
		-1,
		145,
		122,
		237,
		228,
		211,
		191,
		183,
		203,
		-1,
		204,
		-1,
		179,
		180,
		207,
		209,
		226,
		220,
		204,
		219,
		209,
		200,
		209,
		151,
		-1,
		126,
		185,
		168,
		197,
		163,
		175,
		225,
		-1,
		201,
		183,
		-1,
		211,
		201,
		243,
		224,
		217,
		204,
		211,
		213,
		206,
		-1,
		-1,
		-1,
		141,
		140,
		139,
		150,
		158,
		156,
		174,
		-1,
		213,
		195,
		174,
		191,
		191,
		182,
		190,
		233,
		229,
		222,
		224,
		214,
		-1,
		145,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		167,
		189,
		184,
		176,
		188,
		192,
		178,
		184,
		186,
		194,
		192,
		189,
		201,
		197,
		217,
		213,
		245,
		-1,
		152,
		-1,
		171,
		-1,
		-1,
		185,
		171,
		183,
		194,
		184,
		184,
		189,
		182,
		204,
		220,
		204,
		202,
		207,
		212,
		-1,
		162,
		163,
		-1,
		204,
		196,
		182,
		-1,
		175,
		-1,
		230,
		191,
		-1,
		211,
		191,
		-1,
		213,
		209,
		-1,
		-1,
		174,
		220,
		-1,
		-1,
		-1,
		205,
		185,
		225,
		209,
		-1,
		202,
		202,
		-1,
		-1,
		-1,
		188,
		211,
		-1,
		198,
		201,
		-1,
		192,
		198,
		227,
		204,
		208,
		-1,
		-1,
		-1,
		215,
		199,
		204,
		213,
		218,
		206,
		223,
		209,
		211,
		218,
		207,
		228,
		-1,
		-1,
		-1,
		218,
		215,
		218,
		-1,
		-1,
		236,
		219,
		219,
		227,
		-1,
		-1,
		-1,
		240,
		221,
		-1,
		-1,
		227,
		-1,
		-1,
		232,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		229,
		-1,
		-1,
		-1,
		228,
		235,
		243,
		-1,
		-1,
		-1,
		-1,
		212,
		213,
		257,
		250,
		-1,
		-1,
		-1,
		242,
		237,
		-1,
		-1,
		210,
		211,
		-1,
		-1,
		-1,
		270,
		254,
		-1,
		241,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		275,
		-1,
		276,
		251,
		258,
		-1,
		-1,
		-1,
		-1,
		288,
		280,
		289,
		-1,
		261,
		263,
		-1,
		311,
		-1,
		-1,
		303,
		294,
		-1,
		-1,
		266,
		273,
		295,
		298,
		294,
		-1,
		285
	],
	[
		-1,
		336,
		325,
		336,
		344,
		317,
		324,
		-1,
		343,
		347,
		313,
		307,
		346,
		315,
		321,
		332,
		-1,
		-1,
		-1,
		336,
		335,
		303,
		301,
		310,
		315,
		322,
		-1,
		321,
		-1,
		357,
		336,
		347,
		352,
		296,
		293,
		313,
		332,
		314,
		306,
		372,
		326,
		297,
		291,
		309,
		299,
		308,
		300,
		-1,
		297,
		287,
		309,
		288,
		299,
		291,
		-1,
		-1,
		291,
		292,
		298,
		284,
		290,
		286,
		-1,
		296,
		280,
		-1,
		-1,
		281,
		282,
		266,
		269,
		277,
		275,
		288,
		280,
		275,
		-1,
		-1,
		272,
		268,
		275,
		262,
		258,
		275,
		288,
		270,
		284,
		283,
		-1,
		278,
		296,
		301,
		269,
		267,
		251,
		249,
		267,
		269,
		275,
		275,
		-1,
		281,
		283,
		283,
		291,
		291,
		267,
		254,
		254,
		264,
		257,
		276,
		264,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		278,
		270,
		287,
		279,
		269,
		284,
		277,
		257,
		254,
		252,
		249,
		265,
		263,
		273,
		-1,
		-1,
		334,
		303,
		338,
		295,
		280,
		-1,
		274,
		263,
		269,
		273,
		267,
		260,
		274,
		270,
		-1,
		243,
		242,
		270,
		256,
		267,
		294,
		-1,
		-1,
		292,
		284,
		269,
		272,
		269,
		269,
		278,
		277,
		269,
		255,
		251,
		257,
		260,
		260,
		266,
		237,
		247,
		251,
		249,
		274,
		-1,
		-1,
		309,
		-1,
		-1,
		291,
		274,
		-1,
		257,
		264,
		264,
		281,
		271,
		292,
		288,
		279,
		271,
		265,
		253,
		255,
		252,
		265,
		253,
		234,
		259,
		263,
		244,
		265,
		260,
		-1,
		308,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		250,
		253,
		259,
		283,
		293,
		-1,
		300,
		288,
		289,
		274,
		271,
		258,
		246,
		259,
		244,
		251,
		250,
		238,
		236,
		266,
		241,
		263,
		260,
		279,
		284,
		278,
		287,
		-1,
		299,
		295,
		291,
		298,
		247,
		-1,
		-1,
		287,
		-1,
		301,
		314,
		312,
		285,
		288,
		275,
		266,
		253,
		242,
		253,
		242,
		239,
		247,
		230,
		245,
		236,
		235,
		253,
		263,
		271,
		275,
		281,
		-1,
		349,
		-1,
		291,
		275,
		277,
		249,
		270,
		-1,
		307,
		302,
		322,
		314,
		312,
		-1,
		284,
		281,
		271,
		249,
		234,
		251,
		243,
		241,
		243,
		225,
		239,
		230,
		248,
		255,
		253,
		257,
		277,
		289,
		309,
		299,
		-1,
		281,
		286,
		245,
		253,
		272,
		345,
		318,
		-1,
		313,
		-1,
		286,
		299,
		-1,
		255,
		251,
		233,
		234,
		229,
		244,
		236,
		221,
		218,
		236,
		239,
		246,
		250,
		266,
		-1,
		-1,
		294,
		298,
		287,
		238,
		257,
		281,
		318,
		311,
		300,
		299,
		-1,
		290,
		269,
		266,
		254,
		241,
		226,
		227,
		235,
		247,
		226,
		220,
		217,
		237,
		263,
		241,
		252,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		264,
		235,
		259,
		301,
		329,
		322,
		310,
		275,
		275,
		269,
		-1,
		265,
		244,
		235,
		224,
		222,
		235,
		227,
		235,
		215,
		213,
		232,
		244,
		235,
		243,
		-1,
		-1,
		-1,
		294,
		283,
		284,
		233,
		256,
		290,
		308,
		294,
		299,
		274,
		267,
		261,
		278,
		261,
		242,
		231,
		223,
		212,
		223,
		231,
		229,
		211,
		220,
		226,
		250,
		231,
		237,
		-1,
		-1,
		301,
		291,
		275,
		277,
		274,
		247,
		254,
		286,
		299,
		298,
		-1,
		266,
		-1,
		255,
		251,
		236,
		231,
		228,
		215,
		214,
		228,
		228,
		218,
		213,
		220,
		255,
		255,
		221,
		241,
		244,
		-1,
		-1,
		-1,
		294,
		292,
		267,
		244,
		228,
		264,
		-1,
		268,
		269,
		-1,
		260,
		254,
		251,
		238,
		234,
		219,
		223,
		225,
		228,
		216,
		222,
		223,
		205,
		229,
		-1,
		229,
		223,
		231,
		221,
		209,
		-1,
		-1,
		-1,
		290,
		269,
		262,
		282,
		223,
		275,
		-1,
		-1,
		253,
		246,
		-1,
		247,
		229,
		231,
		226,
		222,
		224,
		221,
		210,
		223,
		216,
		210,
		204,
		217,
		221,
		222,
		211,
		207,
		204,
		218,
		-1,
		309,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		243,
		-1,
		256,
		248,
		244,
		238,
		244,
		242,
		240,
		250,
		234,
		236,
		232,
		224,
		219,
		205,
		198,
		209,
		194,
		212,
		218,
		209,
		204,
		203,
		214,
		-1,
		310,
		296,
		267,
		-1,
		-1,
		256,
		-1,
		220,
		234,
		250,
		-1,
		278,
		257,
		278,
		256,
		252,
		243,
		241,
		242,
		212,
		217,
		219,
		207,
		210,
		199,
		202,
		194,
		216,
		213,
		197,
		199,
		208,
		-1,
		316,
		303,
		261,
		257,
		246,
		266,
		217,
		226,
		237,
		-1,
		-1,
		303,
		-1,
		254,
		259,
		257,
		255,
		231,
		206,
		213,
		231,
		204,
		199,
		204,
		193,
		193,
		188,
		207,
		193,
		191,
		206,
		222,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		232,
		219,
		213,
		-1,
		254,
		-1,
		281,
		269,
		256,
		238,
		278,
		-1,
		205,
		201,
		208,
		-1,
		224,
		-1,
		196,
		199,
		190,
		185,
		182,
		193,
		191,
		200,
		201,
		-1,
		266,
		251,
		244,
		234,
		248,
		219,
		-1,
		262,
		-1,
		-1,
		268,
		262,
		262,
		231,
		228,
		221,
		201,
		193,
		208,
		207,
		194,
		193,
		181,
		181,
		184,
		178,
		191,
		201,
		207,
		199,
		-1,
		-1,
		-1,
		271,
		223,
		231,
		207,
		228,
		-1,
		-1,
		329,
		285,
		271,
		-1,
		223,
		221,
		209,
		199,
		189,
		194,
		195,
		185,
		183,
		179,
		188,
		187,
		180,
		179,
		200,
		193,
		215,
		-1,
		-1,
		220,
		233,
		235,
		221,
		217,
		-1,
		-1,
		-1,
		275,
		276,
		242,
		221,
		210,
		-1,
		-1,
		193,
		186,
		180,
		183,
		171,
		191,
		198,
		186,
		173,
		188,
		198,
		206,
		205,
		-1,
		223,
		210,
		-1,
		-1,
		216,
		206,
		-1,
		-1,
		-1,
		-1,
		254,
		199,
		188,
		183,
		187,
		192,
		-1,
		166,
		177,
		170,
		189,
		196,
		188,
		173,
		167,
		178,
		193,
		210,
		-1,
		-1,
		230,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		211,
		205,
		176,
		169,
		173,
		-1,
		168,
		170,
		167,
		179,
		184,
		188,
		179,
		161,
		175,
		178,
		191,
		205,
		209,
		253,
		-1,
		183,
		-1,
		-1,
		-1,
		222,
		223,
		209,
		186,
		165,
		158,
		155,
		154,
		159,
		170,
		179,
		190,
		155,
		159,
		174,
		179,
		183,
		200,
		204,
		-1,
		-1,
		181,
		177,
		212,
		224,
		196,
		236,
		-1,
		-1,
		154,
		147,
		157,
		150,
		163,
		166,
		151,
		153,
		171,
		184,
		178,
		188,
		203,
		198,
		-1,
		-1,
		-1,
		179,
		-1,
		195,
		-1,
		-1,
		186,
		227,
		174,
		156,
		152,
		138,
		145,
		139,
		141,
		146,
		165,
		160,
		169,
		174,
		178,
		201,
		190,
		229,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		145,
		164,
		159,
		165,
		170,
		161,
		189,
		186,
		-1,
		135,
		168,
		136,
		150,
		146,
		153,
		158,
		164,
		168,
		175,
		191,
		190,
		185,
		221,
		212,
		218,
		-1,
		-1,
		169,
		158,
		147,
		153,
		-1,
		138,
		161,
		151,
		141,
		147,
		-1,
		-1,
		153,
		150,
		148,
		128,
		134,
		139,
		142,
		180,
		156,
		164,
		168,
		172,
		178,
		183,
		188,
		194,
		209,
		224,
		-1,
		123,
		160,
		153,
		121,
		129,
		160,
		-1,
		128,
		120,
		148,
		133,
		141,
		-1,
		-1,
		126,
		117,
		122,
		131,
		132,
		163,
		162,
		175,
		178,
		183,
		171,
		170,
		188,
		192,
		201,
		208,
		198,
		211,
		215,
		-1,
		116,
		136,
		115,
		118,
		142,
		156,
		-1,
		119,
		-1,
		-1,
		164,
		151,
		135,
		125,
		122,
		169,
		145,
		140,
		146,
		148,
		172,
		163,
		188,
		179,
		179,
		182,
		197,
		202,
		194,
		208,
		208,
		209,
		-1,
		105,
		116,
		109,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		180,
		-1,
		162,
		-1,
		145,
		149,
		153,
		156,
		171,
		158,
		165,
		182,
		188,
		177,
		187,
		183,
		184,
		193,
		204,
		216,
		215,
		216,
		79,
		86,
		89,
		100,
		111,
		126,
		130,
		-1,
		103,
		139,
		149,
		-1,
		189,
		-1,
		-1,
		-1,
		159,
		166,
		158,
		174,
		170,
		170,
		166,
		170,
		182,
		189,
		199,
		201,
		193,
		197,
		210,
		221,
		224,
		75,
		75,
		130,
		75,
		75,
		96,
		105,
		126,
		99,
		96,
		133,
		138,
		153,
		158,
		182,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		177,
		187,
		170,
		172,
		176,
		190,
		202,
		210,
		200,
		198,
		192,
		224,
		-1,
		75,
		72,
		59,
		54,
		43,
		51,
		66,
		93,
		-1,
		-1,
		97,
		124,
		108,
		112,
		128,
		153,
		-1,
		189,
		-1,
		-1,
		203,
		-1,
		-1,
		229,
		192,
		181,
		172,
		178,
		184,
		195,
		217,
		206,
		207,
		197,
		207,
		220,
		59,
		54,
		42,
		42,
		24,
		74,
		62,
		-1,
		84,
		82,
		88,
		95,
		112,
		142,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		222,
		225,
		214,
		-1,
		204,
		177,
		182,
		207,
		214,
		215,
		209,
		203,
		210,
		209,
		217,
		225,
		68,
		80,
		69,
		58,
		23,
		0,
		67,
		69,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		-1,
		234,
		215,
		-1,
		-1,
		222,
		215,
		203,
		191,
		181,
		191,
		199,
		199,
		202,
		206,
		201,
		212,
		204,
		208,
		225,
		-1,
		91,
		-1,
		98,
		83,
		97,
		112,
		120,
		-1,
		-1,
		-1,
		251,
		237,
		230,
		218,
		216,
		-1,
		256,
		240,
		221,
		-1,
		191,
		204,
		235,
		203,
		208,
		203,
		207,
		218,
		207,
		210,
		224,
		219,
		-1,
		-1,
		95,
		98,
		-1,
		-1,
		120,
		139,
		-1,
		242,
		231,
		216,
		208,
		-1,
		-1,
		228,
		224,
		-1,
		-1,
		192,
		217,
		206,
		214,
		209,
		211,
		217,
		220,
		209,
		213,
		225,
		-1,
		-1,
		102,
		103,
		108,
		-1,
		129,
		-1,
		244,
		-1,
		211,
		218,
		206,
		-1,
		-1,
		-1,
		230,
		193,
		214,
		224,
		229,
		227,
		218,
		215,
		222,
		220,
		216,
		227,
		-1,
		-1,
		-1,
		159,
		136,
		251,
		242,
		225,
		205,
		197,
		217,
		-1,
		218,
		-1,
		193,
		194,
		221,
		223,
		240,
		234,
		218,
		233,
		223,
		214,
		223,
		165,
		-1,
		140,
		199,
		182,
		211,
		177,
		189,
		239,
		-1,
		215,
		197,
		-1,
		225,
		215,
		257,
		238,
		231,
		218,
		225,
		227,
		220,
		-1,
		-1,
		-1,
		155,
		154,
		153,
		164,
		172,
		170,
		188,
		-1,
		227,
		209,
		188,
		205,
		205,
		196,
		204,
		247,
		243,
		236,
		238,
		228,
		-1,
		165,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		181,
		203,
		198,
		190,
		202,
		206,
		192,
		198,
		200,
		208,
		206,
		203,
		215,
		211,
		231,
		227,
		259,
		-1,
		172,
		-1,
		185,
		-1,
		-1,
		199,
		185,
		197,
		208,
		198,
		198,
		203,
		196,
		218,
		234,
		218,
		216,
		221,
		226,
		-1,
		182,
		183,
		-1,
		218,
		210,
		196,
		-1,
		189,
		-1,
		244,
		205,
		-1,
		225,
		205,
		-1,
		227,
		223,
		-1,
		-1,
		194,
		234,
		-1,
		-1,
		-1,
		219,
		199,
		239,
		223,
		-1,
		216,
		216,
		-1,
		-1,
		-1,
		208,
		231,
		-1,
		212,
		215,
		-1,
		206,
		212,
		241,
		218,
		222,
		-1,
		-1,
		-1,
		235,
		219,
		224,
		227,
		232,
		220,
		237,
		223,
		225,
		232,
		221,
		242,
		-1,
		-1,
		-1,
		238,
		232,
		232,
		-1,
		-1,
		250,
		233,
		233,
		241,
		-1,
		-1,
		-1,
		260,
		241,
		-1,
		-1,
		241,
		-1,
		-1,
		246,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		249,
		-1,
		-1,
		-1,
		242,
		249,
		257,
		-1,
		-1,
		-1,
		-1,
		226,
		227,
		271,
		270,
		-1,
		-1,
		-1,
		256,
		251,
		-1,
		-1,
		224,
		225,
		-1,
		-1,
		-1,
		284,
		268,
		-1,
		255,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		289,
		-1,
		290,
		265,
		272,
		-1,
		-1,
		-1,
		-1,
		302,
		294,
		303,
		-1,
		275,
		277,
		-1,
		325,
		-1,
		-1,
		317,
		308,
		-1,
		-1,
		280,
		287,
		309,
		312,
		308,
		-1,
		299
	],
	[
		-1,
		284,
		273,
		284,
		292,
		265,
		272,
		-1,
		291,
		295,
		261,
		255,
		294,
		263,
		269,
		280,
		-1,
		-1,
		-1,
		284,
		283,
		251,
		249,
		258,
		263,
		270,
		-1,
		269,
		-1,
		305,
		284,
		295,
		300,
		244,
		241,
		261,
		280,
		262,
		254,
		320,
		274,
		245,
		239,
		257,
		247,
		256,
		248,
		-1,
		245,
		235,
		257,
		236,
		247,
		239,
		-1,
		-1,
		239,
		240,
		246,
		232,
		238,
		234,
		-1,
		244,
		228,
		-1,
		-1,
		229,
		230,
		214,
		217,
		225,
		223,
		236,
		228,
		223,
		-1,
		-1,
		220,
		216,
		223,
		210,
		206,
		223,
		236,
		218,
		232,
		231,
		-1,
		226,
		244,
		249,
		217,
		215,
		199,
		197,
		215,
		217,
		223,
		223,
		-1,
		228,
		230,
		231,
		239,
		239,
		215,
		202,
		202,
		212,
		205,
		224,
		212,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		225,
		218,
		235,
		227,
		217,
		232,
		225,
		205,
		202,
		200,
		197,
		213,
		211,
		221,
		-1,
		-1,
		281,
		250,
		285,
		242,
		227,
		-1,
		221,
		211,
		217,
		221,
		215,
		208,
		222,
		218,
		-1,
		191,
		190,
		218,
		204,
		215,
		241,
		-1,
		-1,
		239,
		231,
		216,
		219,
		216,
		216,
		226,
		225,
		217,
		203,
		199,
		205,
		208,
		208,
		214,
		185,
		195,
		199,
		197,
		222,
		-1,
		-1,
		257,
		-1,
		-1,
		238,
		221,
		-1,
		204,
		211,
		211,
		228,
		218,
		239,
		236,
		227,
		219,
		213,
		201,
		203,
		200,
		213,
		201,
		182,
		207,
		211,
		192,
		213,
		208,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		197,
		200,
		206,
		230,
		240,
		-1,
		248,
		236,
		237,
		222,
		219,
		206,
		194,
		207,
		192,
		199,
		198,
		186,
		184,
		214,
		189,
		211,
		208,
		227,
		232,
		226,
		235,
		-1,
		246,
		242,
		238,
		245,
		194,
		-1,
		-1,
		234,
		-1,
		248,
		261,
		260,
		233,
		236,
		223,
		214,
		201,
		190,
		201,
		190,
		187,
		195,
		178,
		193,
		184,
		183,
		201,
		211,
		219,
		223,
		229,
		-1,
		296,
		-1,
		238,
		222,
		224,
		196,
		217,
		-1,
		254,
		249,
		269,
		262,
		260,
		-1,
		232,
		229,
		219,
		197,
		182,
		199,
		191,
		189,
		191,
		173,
		187,
		178,
		196,
		203,
		201,
		205,
		225,
		237,
		256,
		246,
		-1,
		228,
		233,
		192,
		200,
		219,
		292,
		266,
		-1,
		261,
		-1,
		234,
		247,
		-1,
		203,
		199,
		181,
		182,
		177,
		192,
		184,
		169,
		166,
		184,
		187,
		194,
		198,
		214,
		-1,
		-1,
		241,
		245,
		234,
		185,
		204,
		228,
		265,
		259,
		248,
		247,
		-1,
		238,
		217,
		214,
		202,
		189,
		174,
		175,
		183,
		195,
		174,
		168,
		165,
		185,
		211,
		189,
		200,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		211,
		182,
		206,
		248,
		277,
		270,
		258,
		223,
		223,
		217,
		-1,
		213,
		192,
		183,
		172,
		170,
		183,
		175,
		183,
		163,
		161,
		180,
		192,
		183,
		191,
		-1,
		-1,
		-1,
		241,
		230,
		231,
		180,
		203,
		237,
		256,
		242,
		247,
		222,
		215,
		209,
		226,
		209,
		190,
		179,
		171,
		160,
		171,
		179,
		177,
		159,
		168,
		174,
		198,
		179,
		185,
		-1,
		-1,
		248,
		238,
		222,
		224,
		221,
		194,
		201,
		233,
		247,
		245,
		-1,
		214,
		-1,
		203,
		199,
		184,
		179,
		176,
		163,
		162,
		176,
		176,
		166,
		161,
		168,
		203,
		203,
		169,
		189,
		192,
		-1,
		-1,
		-1,
		241,
		239,
		214,
		191,
		175,
		211,
		-1,
		215,
		216,
		-1,
		208,
		202,
		199,
		186,
		182,
		167,
		171,
		173,
		176,
		164,
		170,
		171,
		153,
		177,
		-1,
		177,
		171,
		179,
		169,
		157,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		200,
		193,
		-1,
		195,
		177,
		179,
		174,
		170,
		172,
		169,
		158,
		171,
		164,
		158,
		152,
		165,
		169,
		170,
		159,
		155,
		152,
		166,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		203,
		195,
		191,
		185,
		191,
		190,
		188,
		198,
		182,
		184,
		180,
		172,
		167,
		153,
		146,
		157,
		142,
		160,
		166,
		157,
		152,
		151,
		162,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		225,
		204,
		226,
		204,
		200,
		191,
		189,
		190,
		160,
		165,
		167,
		155,
		158,
		147,
		150,
		142,
		164,
		161,
		145,
		147,
		156,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		173,
		184,
		-1,
		-1,
		251,
		-1,
		202,
		207,
		205,
		203,
		179,
		154,
		161,
		179,
		152,
		147,
		152,
		141,
		141,
		136,
		155,
		141,
		139,
		154,
		170,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		229,
		217,
		204,
		186,
		226,
		-1,
		153,
		149,
		156,
		-1,
		172,
		-1,
		144,
		147,
		138,
		133,
		130,
		141,
		139,
		148,
		149,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		209,
		-1,
		-1,
		216,
		210,
		210,
		179,
		176,
		169,
		149,
		141,
		156,
		155,
		142,
		141,
		129,
		129,
		132,
		126,
		139,
		149,
		155,
		147,
		-1,
		-1,
		-1,
		218,
		170,
		178,
		154,
		175,
		-1,
		-1,
		277,
		233,
		219,
		-1,
		171,
		169,
		157,
		147,
		137,
		142,
		143,
		133,
		131,
		127,
		136,
		135,
		128,
		127,
		148,
		141,
		163,
		-1,
		-1,
		167,
		180,
		182,
		168,
		165,
		-1,
		-1,
		-1,
		223,
		224,
		190,
		169,
		158,
		-1,
		-1,
		141,
		134,
		128,
		131,
		119,
		139,
		146,
		134,
		121,
		136,
		146,
		154,
		153,
		-1,
		170,
		157,
		-1,
		-1,
		164,
		154,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		140,
		-1,
		114,
		125,
		118,
		137,
		144,
		136,
		121,
		115,
		126,
		141,
		158,
		-1,
		-1,
		178,
		-1,
		140,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		116,
		118,
		115,
		127,
		132,
		136,
		127,
		109,
		123,
		126,
		139,
		153,
		157,
		201,
		-1,
		131,
		-1,
		-1,
		-1,
		170,
		171,
		157,
		134,
		113,
		106,
		103,
		102,
		107,
		118,
		127,
		138,
		103,
		107,
		122,
		127,
		131,
		148,
		152,
		-1,
		-1,
		129,
		125,
		160,
		172,
		144,
		184,
		-1,
		-1,
		102,
		95,
		105,
		98,
		111,
		114,
		99,
		101,
		119,
		132,
		126,
		136,
		151,
		146,
		-1,
		-1,
		-1,
		127,
		-1,
		143,
		-1,
		-1,
		134,
		175,
		122,
		104,
		100,
		86,
		93,
		87,
		89,
		94,
		113,
		108,
		117,
		122,
		126,
		149,
		138,
		177,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		93,
		112,
		107,
		113,
		118,
		109,
		137,
		134,
		-1,
		83,
		116,
		84,
		98,
		94,
		101,
		106,
		112,
		116,
		123,
		139,
		138,
		133,
		169,
		160,
		166,
		-1,
		-1,
		116,
		105,
		94,
		100,
		-1,
		86,
		109,
		99,
		89,
		95,
		-1,
		-1,
		101,
		98,
		96,
		76,
		82,
		87,
		90,
		128,
		104,
		112,
		116,
		120,
		126,
		131,
		136,
		142,
		157,
		172,
		-1,
		70,
		107,
		100,
		68,
		76,
		107,
		-1,
		76,
		68,
		96,
		81,
		89,
		-1,
		-1,
		74,
		65,
		70,
		79,
		80,
		111,
		110,
		123,
		126,
		131,
		119,
		118,
		136,
		140,
		149,
		156,
		146,
		159,
		163,
		-1,
		63,
		83,
		62,
		65,
		89,
		103,
		-1,
		67,
		-1,
		-1,
		112,
		99,
		83,
		73,
		70,
		117,
		93,
		88,
		94,
		96,
		120,
		111,
		136,
		127,
		127,
		130,
		145,
		150,
		142,
		156,
		156,
		157,
		-1,
		52,
		63,
		56,
		-1,
		-1,
		-1,
		-1,
		61,
		-1,
		-1,
		128,
		-1,
		110,
		-1,
		93,
		97,
		101,
		104,
		119,
		106,
		113,
		130,
		136,
		125,
		135,
		131,
		132,
		141,
		152,
		164,
		163,
		164,
		77,
		33,
		36,
		47,
		58,
		73,
		77,
		-1,
		51,
		87,
		97,
		-1,
		137,
		-1,
		-1,
		-1,
		107,
		114,
		106,
		122,
		118,
		118,
		114,
		118,
		130,
		137,
		147,
		149,
		141,
		145,
		158,
		169,
		172,
		73,
		64,
		77,
		22,
		22,
		43,
		52,
		73,
		47,
		44,
		81,
		86,
		101,
		106,
		130,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		125,
		135,
		118,
		120,
		124,
		138,
		150,
		158,
		148,
		146,
		140,
		172,
		-1,
		66,
		65,
		54,
		51,
		27,
		18,
		13,
		40,
		-1,
		-1,
		45,
		72,
		56,
		60,
		76,
		101,
		-1,
		137,
		-1,
		-1,
		151,
		-1,
		-1,
		177,
		140,
		129,
		120,
		126,
		132,
		143,
		165,
		154,
		155,
		145,
		155,
		168,
		50,
		47,
		35,
		33,
		56,
		19,
		9,
		-1,
		27,
		30,
		36,
		43,
		60,
		90,
		-1,
		-1,
		153,
		144,
		-1,
		-1,
		170,
		173,
		162,
		-1,
		152,
		125,
		130,
		155,
		162,
		163,
		157,
		151,
		158,
		157,
		165,
		173,
		59,
		73,
		62,
		58,
		57,
		65,
		0,
		17,
		24,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		-1,
		176,
		163,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		147,
		147,
		150,
		154,
		149,
		160,
		152,
		156,
		173,
		-1,
		93,
		-1,
		36,
		24,
		39,
		54,
		62,
		-1,
		-1,
		-1,
		193,
		179,
		172,
		160,
		158,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		183,
		151,
		156,
		151,
		155,
		166,
		155,
		158,
		172,
		167,
		-1,
		-1,
		37,
		40,
		-1,
		-1,
		62,
		81,
		-1,
		184,
		173,
		158,
		150,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		140,
		165,
		154,
		162,
		157,
		159,
		165,
		168,
		157,
		161,
		173,
		-1,
		-1,
		44,
		45,
		50,
		-1,
		71,
		-1,
		186,
		-1,
		153,
		160,
		148,
		-1,
		-1,
		-1,
		178,
		141,
		162,
		172,
		177,
		175,
		166,
		163,
		170,
		168,
		164,
		175,
		-1,
		-1,
		-1,
		101,
		78,
		193,
		184,
		167,
		147,
		139,
		159,
		-1,
		166,
		-1,
		141,
		142,
		169,
		171,
		188,
		182,
		166,
		181,
		171,
		162,
		171,
		107,
		-1,
		82,
		141,
		124,
		153,
		119,
		131,
		187,
		-1,
		163,
		145,
		-1,
		173,
		163,
		205,
		186,
		179,
		166,
		173,
		175,
		168,
		-1,
		-1,
		-1,
		97,
		96,
		95,
		106,
		114,
		112,
		130,
		-1,
		175,
		157,
		136,
		153,
		153,
		144,
		152,
		195,
		191,
		184,
		186,
		176,
		-1,
		165,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		123,
		145,
		140,
		132,
		144,
		153,
		140,
		146,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		175,
		207,
		-1,
		172,
		-1,
		127,
		-1,
		-1,
		141,
		127,
		139,
		150,
		140,
		140,
		145,
		143,
		165,
		182,
		166,
		164,
		169,
		174,
		-1,
		182,
		183,
		-1,
		160,
		152,
		138,
		-1,
		131,
		-1,
		186,
		147,
		-1,
		172,
		152,
		-1,
		175,
		171,
		-1,
		-1,
		194,
		176,
		-1,
		-1,
		-1,
		161,
		141,
		181,
		165,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		154,
		157,
		-1,
		148,
		154,
		183,
		165,
		169,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		169,
		174,
		162,
		179,
		165,
		167,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		182,
		174,
		174,
		-1,
		-1,
		192,
		175,
		175,
		188,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		183,
		-1,
		-1,
		188,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		193,
		-1,
		-1,
		-1,
		184,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		214,
		215,
		239,
		214,
		-1,
		-1,
		-1,
		198,
		198,
		-1,
		-1,
		217,
		215,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		202,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		231,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		227,
		234,
		256,
		259,
		289,
		-1,
		246
	],
	[
		-1,
		267,
		256,
		267,
		275,
		248,
		255,
		-1,
		274,
		278,
		244,
		238,
		277,
		246,
		252,
		263,
		-1,
		-1,
		-1,
		267,
		266,
		234,
		232,
		241,
		246,
		253,
		-1,
		252,
		-1,
		288,
		267,
		278,
		283,
		227,
		224,
		244,
		263,
		245,
		237,
		303,
		257,
		228,
		222,
		240,
		230,
		239,
		231,
		-1,
		228,
		218,
		240,
		219,
		230,
		222,
		-1,
		-1,
		222,
		223,
		229,
		215,
		221,
		217,
		-1,
		227,
		211,
		-1,
		-1,
		212,
		213,
		197,
		200,
		208,
		206,
		219,
		211,
		206,
		-1,
		-1,
		203,
		199,
		206,
		193,
		189,
		206,
		219,
		201,
		215,
		214,
		-1,
		209,
		227,
		232,
		200,
		198,
		182,
		180,
		198,
		200,
		206,
		206,
		-1,
		218,
		219,
		214,
		222,
		222,
		198,
		185,
		185,
		195,
		188,
		207,
		195,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		218,
		201,
		218,
		210,
		200,
		215,
		208,
		188,
		185,
		183,
		180,
		196,
		194,
		204,
		-1,
		-1,
		274,
		243,
		278,
		235,
		220,
		-1,
		214,
		194,
		200,
		204,
		198,
		191,
		205,
		201,
		-1,
		174,
		173,
		201,
		187,
		198,
		234,
		-1,
		-1,
		232,
		224,
		209,
		212,
		209,
		209,
		209,
		208,
		200,
		186,
		182,
		188,
		191,
		191,
		197,
		168,
		178,
		182,
		180,
		205,
		-1,
		-1,
		240,
		-1,
		-1,
		231,
		214,
		-1,
		197,
		204,
		204,
		221,
		211,
		232,
		219,
		210,
		202,
		196,
		184,
		186,
		183,
		196,
		184,
		165,
		190,
		194,
		175,
		196,
		191,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		190,
		193,
		199,
		223,
		233,
		-1,
		231,
		219,
		220,
		205,
		202,
		189,
		177,
		190,
		175,
		182,
		181,
		169,
		167,
		197,
		172,
		194,
		191,
		210,
		215,
		209,
		218,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		227,
		-1,
		241,
		254,
		243,
		216,
		219,
		206,
		197,
		184,
		173,
		184,
		173,
		170,
		178,
		161,
		176,
		167,
		166,
		184,
		194,
		202,
		206,
		212,
		-1,
		289,
		-1,
		231,
		215,
		217,
		189,
		210,
		-1,
		247,
		242,
		260,
		245,
		243,
		-1,
		215,
		212,
		202,
		180,
		165,
		182,
		174,
		172,
		174,
		156,
		170,
		161,
		179,
		186,
		184,
		188,
		208,
		220,
		249,
		239,
		-1,
		221,
		226,
		185,
		193,
		212,
		285,
		249,
		-1,
		244,
		-1,
		217,
		230,
		-1,
		186,
		182,
		164,
		165,
		160,
		175,
		167,
		152,
		149,
		167,
		170,
		177,
		181,
		197,
		-1,
		-1,
		234,
		238,
		227,
		178,
		197,
		221,
		258,
		242,
		231,
		230,
		-1,
		221,
		200,
		197,
		185,
		172,
		157,
		158,
		166,
		178,
		157,
		151,
		148,
		168,
		194,
		172,
		183,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		204,
		175,
		199,
		241,
		260,
		253,
		241,
		206,
		206,
		200,
		-1,
		196,
		175,
		166,
		155,
		153,
		166,
		158,
		166,
		146,
		144,
		163,
		175,
		166,
		174,
		-1,
		-1,
		-1,
		234,
		223,
		224,
		173,
		196,
		230,
		239,
		225,
		230,
		205,
		198,
		192,
		209,
		192,
		173,
		162,
		154,
		143,
		154,
		162,
		160,
		142,
		151,
		157,
		181,
		162,
		168,
		-1,
		-1,
		241,
		231,
		215,
		217,
		214,
		187,
		194,
		226,
		230,
		238,
		-1,
		197,
		-1,
		186,
		182,
		167,
		162,
		159,
		146,
		145,
		159,
		159,
		149,
		144,
		151,
		186,
		186,
		152,
		172,
		175,
		-1,
		-1,
		-1,
		234,
		232,
		207,
		184,
		168,
		204,
		-1,
		208,
		209,
		-1,
		191,
		185,
		182,
		169,
		165,
		150,
		154,
		156,
		159,
		147,
		153,
		154,
		136,
		160,
		-1,
		160,
		154,
		162,
		152,
		140,
		-1,
		-1,
		-1,
		230,
		209,
		202,
		222,
		163,
		215,
		-1,
		-1,
		193,
		186,
		-1,
		178,
		160,
		162,
		157,
		153,
		155,
		152,
		141,
		154,
		147,
		141,
		135,
		148,
		152,
		153,
		142,
		138,
		135,
		149,
		-1,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		183,
		-1,
		196,
		188,
		184,
		178,
		177,
		173,
		171,
		181,
		165,
		167,
		163,
		155,
		150,
		136,
		129,
		140,
		125,
		143,
		149,
		140,
		135,
		134,
		145,
		-1,
		250,
		236,
		207,
		-1,
		-1,
		196,
		-1,
		160,
		174,
		190,
		-1,
		215,
		194,
		209,
		187,
		183,
		174,
		172,
		173,
		143,
		148,
		150,
		138,
		141,
		130,
		133,
		125,
		147,
		144,
		128,
		130,
		139,
		-1,
		256,
		243,
		201,
		197,
		186,
		206,
		157,
		166,
		177,
		-1,
		-1,
		234,
		-1,
		185,
		190,
		188,
		186,
		162,
		137,
		144,
		162,
		135,
		130,
		135,
		124,
		124,
		119,
		138,
		124,
		122,
		137,
		153,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		172,
		159,
		153,
		-1,
		194,
		-1,
		212,
		200,
		187,
		169,
		209,
		-1,
		136,
		132,
		139,
		-1,
		155,
		-1,
		127,
		130,
		121,
		116,
		113,
		124,
		122,
		131,
		132,
		-1,
		206,
		191,
		184,
		174,
		188,
		159,
		-1,
		202,
		-1,
		-1,
		199,
		193,
		193,
		162,
		159,
		152,
		132,
		124,
		139,
		138,
		125,
		124,
		112,
		112,
		115,
		109,
		122,
		132,
		138,
		130,
		-1,
		-1,
		-1,
		211,
		163,
		171,
		147,
		168,
		-1,
		-1,
		260,
		216,
		202,
		-1,
		154,
		152,
		140,
		130,
		120,
		125,
		126,
		116,
		114,
		110,
		119,
		118,
		111,
		110,
		131,
		124,
		146,
		-1,
		-1,
		160,
		173,
		175,
		153,
		148,
		-1,
		-1,
		-1,
		206,
		207,
		173,
		152,
		141,
		-1,
		-1,
		124,
		117,
		111,
		114,
		102,
		122,
		129,
		117,
		104,
		119,
		129,
		137,
		136,
		-1,
		163,
		150,
		-1,
		-1,
		147,
		137,
		-1,
		-1,
		-1,
		-1,
		185,
		130,
		119,
		114,
		118,
		123,
		-1,
		97,
		108,
		101,
		120,
		127,
		119,
		104,
		98,
		109,
		124,
		141,
		-1,
		-1,
		161,
		-1,
		123,
		-1,
		-1,
		-1,
		-1,
		142,
		136,
		107,
		100,
		104,
		-1,
		99,
		101,
		98,
		110,
		115,
		119,
		110,
		92,
		106,
		109,
		122,
		136,
		140,
		184,
		-1,
		114,
		-1,
		-1,
		-1,
		153,
		154,
		140,
		117,
		96,
		89,
		86,
		85,
		90,
		101,
		110,
		121,
		86,
		90,
		105,
		110,
		114,
		131,
		135,
		-1,
		-1,
		112,
		108,
		143,
		155,
		127,
		167,
		-1,
		-1,
		85,
		78,
		88,
		81,
		94,
		97,
		82,
		84,
		102,
		115,
		109,
		119,
		134,
		129,
		-1,
		-1,
		-1,
		110,
		-1,
		126,
		-1,
		-1,
		117,
		158,
		105,
		87,
		83,
		69,
		76,
		70,
		72,
		77,
		96,
		91,
		100,
		105,
		109,
		132,
		121,
		160,
		-1,
		-1,
		116,
		-1,
		-1,
		-1,
		76,
		95,
		90,
		96,
		101,
		92,
		120,
		117,
		-1,
		66,
		99,
		67,
		81,
		77,
		84,
		89,
		95,
		99,
		106,
		122,
		121,
		116,
		152,
		143,
		149,
		-1,
		-1,
		109,
		98,
		87,
		93,
		-1,
		69,
		92,
		82,
		72,
		78,
		-1,
		-1,
		84,
		81,
		79,
		59,
		65,
		70,
		73,
		111,
		87,
		95,
		99,
		103,
		109,
		114,
		119,
		125,
		140,
		155,
		-1,
		63,
		100,
		93,
		61,
		69,
		100,
		-1,
		59,
		51,
		79,
		64,
		72,
		-1,
		-1,
		57,
		48,
		53,
		62,
		63,
		94,
		93,
		106,
		109,
		114,
		102,
		101,
		119,
		123,
		132,
		139,
		129,
		142,
		146,
		-1,
		56,
		76,
		55,
		58,
		82,
		96,
		-1,
		50,
		-1,
		-1,
		95,
		82,
		66,
		56,
		53,
		100,
		76,
		71,
		77,
		79,
		103,
		94,
		119,
		110,
		110,
		113,
		128,
		133,
		125,
		139,
		139,
		140,
		-1,
		45,
		56,
		49,
		-1,
		-1,
		-1,
		-1,
		44,
		-1,
		-1,
		111,
		-1,
		93,
		-1,
		76,
		80,
		84,
		87,
		102,
		89,
		96,
		113,
		119,
		108,
		118,
		114,
		115,
		124,
		135,
		147,
		146,
		147,
		70,
		26,
		29,
		40,
		51,
		66,
		70,
		-1,
		34,
		70,
		80,
		-1,
		120,
		-1,
		-1,
		-1,
		90,
		97,
		89,
		105,
		101,
		101,
		97,
		101,
		113,
		120,
		130,
		132,
		124,
		128,
		141,
		152,
		155,
		66,
		57,
		70,
		15,
		15,
		36,
		45,
		66,
		30,
		27,
		64,
		69,
		84,
		89,
		113,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		108,
		118,
		101,
		103,
		107,
		121,
		133,
		141,
		131,
		129,
		123,
		155,
		-1,
		59,
		58,
		47,
		44,
		20,
		11,
		6,
		33,
		-1,
		-1,
		28,
		55,
		39,
		43,
		59,
		84,
		-1,
		120,
		-1,
		-1,
		134,
		-1,
		-1,
		160,
		123,
		112,
		103,
		109,
		115,
		126,
		148,
		137,
		138,
		128,
		138,
		151,
		43,
		40,
		28,
		26,
		49,
		14,
		2,
		-1,
		15,
		13,
		19,
		26,
		43,
		73,
		-1,
		-1,
		136,
		127,
		-1,
		-1,
		153,
		156,
		145,
		-1,
		135,
		108,
		113,
		138,
		145,
		146,
		140,
		134,
		141,
		140,
		148,
		156,
		52,
		66,
		55,
		51,
		50,
		58,
		7,
		0,
		12,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		165,
		146,
		-1,
		-1,
		153,
		146,
		134,
		122,
		112,
		122,
		130,
		130,
		133,
		137,
		132,
		143,
		135,
		139,
		156,
		-1,
		86,
		-1,
		38,
		14,
		28,
		43,
		51,
		-1,
		-1,
		-1,
		182,
		168,
		161,
		149,
		147,
		-1,
		187,
		171,
		152,
		-1,
		122,
		135,
		166,
		134,
		139,
		134,
		138,
		149,
		138,
		141,
		155,
		150,
		-1,
		-1,
		26,
		29,
		-1,
		-1,
		51,
		70,
		-1,
		173,
		162,
		147,
		139,
		-1,
		-1,
		159,
		155,
		-1,
		-1,
		123,
		148,
		137,
		145,
		140,
		142,
		148,
		151,
		140,
		144,
		156,
		-1,
		-1,
		33,
		34,
		39,
		-1,
		60,
		-1,
		175,
		-1,
		142,
		149,
		137,
		-1,
		-1,
		-1,
		161,
		124,
		145,
		155,
		160,
		158,
		149,
		146,
		153,
		151,
		147,
		158,
		-1,
		-1,
		-1,
		90,
		67,
		182,
		173,
		156,
		136,
		128,
		148,
		-1,
		149,
		-1,
		124,
		125,
		152,
		154,
		171,
		165,
		149,
		164,
		154,
		145,
		154,
		96,
		-1,
		71,
		130,
		113,
		142,
		108,
		120,
		170,
		-1,
		146,
		128,
		-1,
		156,
		146,
		188,
		169,
		162,
		149,
		156,
		158,
		151,
		-1,
		-1,
		-1,
		86,
		85,
		84,
		95,
		103,
		101,
		119,
		-1,
		158,
		140,
		119,
		136,
		136,
		127,
		135,
		178,
		174,
		167,
		169,
		159,
		-1,
		158,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		112,
		134,
		129,
		121,
		133,
		137,
		123,
		129,
		131,
		139,
		137,
		134,
		146,
		142,
		162,
		158,
		190,
		-1,
		165,
		-1,
		116,
		-1,
		-1,
		130,
		116,
		128,
		139,
		129,
		129,
		134,
		127,
		149,
		165,
		149,
		147,
		152,
		157,
		-1,
		175,
		176,
		-1,
		149,
		141,
		127,
		-1,
		120,
		-1,
		175,
		136,
		-1,
		156,
		136,
		-1,
		158,
		154,
		-1,
		-1,
		187,
		165,
		-1,
		-1,
		-1,
		150,
		130,
		170,
		154,
		-1,
		147,
		147,
		-1,
		-1,
		-1,
		190,
		174,
		-1,
		143,
		146,
		-1,
		137,
		143,
		172,
		149,
		153,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		158,
		163,
		151,
		168,
		154,
		156,
		163,
		152,
		173,
		-1,
		-1,
		-1,
		171,
		163,
		163,
		-1,
		-1,
		181,
		164,
		164,
		172,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		172,
		-1,
		-1,
		177,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		182,
		-1,
		-1,
		-1,
		173,
		180,
		188,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		228,
		203,
		-1,
		-1,
		-1,
		187,
		182,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		215,
		199,
		-1,
		186,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		220,
		-1,
		221,
		196,
		203,
		-1,
		-1,
		-1,
		-1,
		233,
		225,
		234,
		-1,
		206,
		208,
		-1,
		256,
		-1,
		-1,
		248,
		239,
		-1,
		-1,
		211,
		218,
		240,
		243,
		278,
		-1,
		230
	],
	[
		-1,
		286,
		275,
		286,
		294,
		267,
		274,
		-1,
		293,
		297,
		263,
		257,
		296,
		265,
		271,
		282,
		-1,
		-1,
		-1,
		286,
		285,
		253,
		251,
		260,
		265,
		272,
		-1,
		271,
		-1,
		307,
		286,
		297,
		302,
		246,
		243,
		263,
		282,
		264,
		256,
		322,
		276,
		247,
		241,
		259,
		249,
		258,
		250,
		-1,
		247,
		237,
		259,
		238,
		249,
		241,
		-1,
		-1,
		241,
		242,
		248,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		231,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		228,
		246,
		251,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		237,
		238,
		233,
		241,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		237,
		220,
		237,
		229,
		219,
		234,
		227,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		293,
		262,
		297,
		254,
		239,
		-1,
		233,
		213,
		219,
		223,
		217,
		210,
		224,
		220,
		-1,
		193,
		192,
		220,
		206,
		217,
		253,
		-1,
		-1,
		251,
		243,
		228,
		231,
		228,
		228,
		228,
		227,
		219,
		205,
		201,
		207,
		210,
		210,
		216,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		250,
		233,
		-1,
		216,
		223,
		223,
		240,
		230,
		251,
		238,
		229,
		221,
		215,
		203,
		205,
		202,
		215,
		203,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		209,
		212,
		218,
		242,
		252,
		-1,
		250,
		238,
		239,
		224,
		221,
		208,
		196,
		209,
		194,
		201,
		200,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		258,
		254,
		250,
		257,
		206,
		-1,
		-1,
		246,
		-1,
		260,
		273,
		262,
		235,
		238,
		225,
		216,
		203,
		192,
		203,
		192,
		189,
		197,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		308,
		-1,
		250,
		234,
		236,
		208,
		229,
		-1,
		266,
		261,
		279,
		264,
		262,
		-1,
		234,
		231,
		221,
		199,
		184,
		201,
		193,
		191,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		268,
		258,
		-1,
		240,
		245,
		204,
		212,
		231,
		304,
		268,
		-1,
		263,
		-1,
		236,
		249,
		-1,
		205,
		201,
		183,
		184,
		179,
		194,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		253,
		257,
		246,
		197,
		216,
		240,
		277,
		261,
		250,
		249,
		-1,
		240,
		219,
		216,
		204,
		191,
		176,
		177,
		185,
		197,
		176,
		170,
		167,
		187,
		213,
		191,
		202,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		223,
		194,
		218,
		260,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		215,
		194,
		185,
		174,
		172,
		185,
		177,
		185,
		165,
		163,
		182,
		194,
		185,
		193,
		-1,
		-1,
		-1,
		253,
		242,
		243,
		192,
		215,
		249,
		258,
		244,
		249,
		224,
		217,
		211,
		228,
		211,
		192,
		181,
		173,
		162,
		173,
		181,
		179,
		161,
		170,
		176,
		200,
		181,
		187,
		-1,
		-1,
		260,
		250,
		234,
		236,
		233,
		206,
		213,
		245,
		249,
		257,
		-1,
		216,
		-1,
		205,
		201,
		186,
		181,
		178,
		165,
		164,
		178,
		178,
		168,
		163,
		170,
		205,
		205,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		253,
		251,
		226,
		203,
		187,
		223,
		-1,
		227,
		228,
		-1,
		210,
		204,
		201,
		188,
		184,
		169,
		173,
		175,
		178,
		166,
		172,
		173,
		155,
		179,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		249,
		228,
		221,
		241,
		182,
		234,
		-1,
		-1,
		212,
		205,
		-1,
		197,
		179,
		181,
		176,
		172,
		174,
		171,
		160,
		173,
		166,
		160,
		154,
		167,
		171,
		172,
		161,
		157,
		154,
		168,
		-1,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		202,
		-1,
		215,
		207,
		203,
		197,
		196,
		192,
		190,
		200,
		184,
		186,
		182,
		174,
		169,
		155,
		148,
		159,
		144,
		162,
		168,
		159,
		154,
		153,
		164,
		-1,
		269,
		255,
		226,
		-1,
		-1,
		215,
		-1,
		179,
		193,
		209,
		-1,
		234,
		213,
		228,
		206,
		202,
		193,
		191,
		192,
		162,
		167,
		169,
		157,
		160,
		149,
		152,
		144,
		166,
		163,
		147,
		149,
		158,
		-1,
		275,
		262,
		220,
		216,
		205,
		225,
		176,
		185,
		196,
		-1,
		-1,
		253,
		-1,
		204,
		209,
		207,
		205,
		181,
		156,
		163,
		181,
		154,
		149,
		154,
		143,
		143,
		138,
		157,
		143,
		141,
		156,
		172,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		191,
		178,
		172,
		-1,
		213,
		-1,
		231,
		219,
		206,
		188,
		228,
		-1,
		155,
		151,
		158,
		-1,
		174,
		-1,
		146,
		149,
		140,
		135,
		132,
		143,
		141,
		150,
		151,
		-1,
		225,
		210,
		203,
		193,
		207,
		177,
		-1,
		211,
		-1,
		-1,
		218,
		212,
		212,
		181,
		178,
		171,
		151,
		143,
		158,
		157,
		144,
		143,
		131,
		131,
		134,
		128,
		141,
		151,
		157,
		149,
		-1,
		-1,
		-1,
		230,
		182,
		190,
		166,
		177,
		-1,
		-1,
		279,
		235,
		221,
		-1,
		173,
		171,
		159,
		149,
		139,
		144,
		145,
		135,
		133,
		129,
		138,
		137,
		130,
		129,
		150,
		143,
		165,
		-1,
		-1,
		179,
		192,
		187,
		155,
		150,
		-1,
		-1,
		-1,
		225,
		213,
		192,
		171,
		160,
		-1,
		-1,
		143,
		136,
		130,
		133,
		121,
		141,
		148,
		136,
		123,
		138,
		148,
		156,
		155,
		-1,
		182,
		169,
		-1,
		-1,
		149,
		139,
		-1,
		-1,
		-1,
		-1,
		191,
		149,
		138,
		133,
		137,
		142,
		-1,
		116,
		127,
		120,
		139,
		146,
		138,
		123,
		117,
		128,
		143,
		160,
		-1,
		-1,
		163,
		-1,
		125,
		-1,
		-1,
		-1,
		-1,
		161,
		155,
		126,
		119,
		123,
		-1,
		118,
		120,
		117,
		129,
		134,
		138,
		129,
		111,
		125,
		128,
		141,
		155,
		159,
		186,
		-1,
		116,
		-1,
		-1,
		-1,
		155,
		156,
		159,
		136,
		115,
		108,
		105,
		104,
		109,
		120,
		129,
		140,
		105,
		109,
		124,
		129,
		133,
		150,
		154,
		-1,
		-1,
		114,
		110,
		145,
		157,
		129,
		186,
		-1,
		-1,
		104,
		97,
		107,
		100,
		113,
		116,
		101,
		103,
		121,
		134,
		128,
		138,
		153,
		148,
		-1,
		-1,
		-1,
		112,
		-1,
		128,
		-1,
		-1,
		119,
		177,
		124,
		106,
		102,
		88,
		95,
		89,
		91,
		96,
		115,
		110,
		119,
		124,
		128,
		151,
		140,
		179,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		78,
		97,
		92,
		98,
		103,
		94,
		139,
		136,
		-1,
		85,
		118,
		86,
		100,
		96,
		103,
		108,
		114,
		118,
		125,
		141,
		140,
		135,
		171,
		162,
		168,
		-1,
		-1,
		128,
		117,
		106,
		112,
		-1,
		71,
		94,
		84,
		74,
		80,
		-1,
		-1,
		103,
		100,
		98,
		78,
		84,
		89,
		92,
		130,
		106,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		82,
		119,
		112,
		80,
		88,
		119,
		-1,
		61,
		53,
		81,
		66,
		74,
		-1,
		-1,
		76,
		67,
		72,
		81,
		82,
		113,
		112,
		125,
		128,
		133,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		75,
		95,
		74,
		77,
		101,
		115,
		-1,
		52,
		-1,
		-1,
		97,
		87,
		85,
		75,
		72,
		119,
		95,
		90,
		96,
		98,
		122,
		113,
		138,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		64,
		75,
		68,
		-1,
		-1,
		-1,
		-1,
		46,
		-1,
		-1,
		113,
		-1,
		112,
		-1,
		95,
		99,
		103,
		106,
		121,
		108,
		115,
		132,
		138,
		127,
		137,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		89,
		45,
		48,
		59,
		70,
		85,
		89,
		-1,
		36,
		72,
		76,
		-1,
		119,
		-1,
		-1,
		-1,
		109,
		116,
		108,
		124,
		120,
		120,
		116,
		120,
		132,
		139,
		149,
		151,
		143,
		147,
		160,
		171,
		174,
		85,
		76,
		89,
		34,
		34,
		55,
		64,
		85,
		26,
		29,
		66,
		65,
		80,
		85,
		109,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		127,
		137,
		120,
		122,
		126,
		140,
		152,
		160,
		150,
		148,
		142,
		174,
		-1,
		78,
		77,
		66,
		63,
		39,
		30,
		25,
		52,
		-1,
		-1,
		24,
		57,
		35,
		39,
		55,
		80,
		-1,
		116,
		-1,
		-1,
		153,
		-1,
		-1,
		179,
		142,
		131,
		122,
		128,
		134,
		145,
		167,
		156,
		157,
		147,
		157,
		170,
		62,
		59,
		47,
		45,
		68,
		33,
		21,
		-1,
		3,
		15,
		15,
		22,
		39,
		69,
		-1,
		-1,
		132,
		123,
		-1,
		-1,
		172,
		175,
		164,
		-1,
		154,
		127,
		132,
		157,
		164,
		165,
		159,
		153,
		160,
		159,
		167,
		175,
		71,
		85,
		74,
		70,
		69,
		77,
		26,
		19,
		0,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		167,
		142,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		149,
		149,
		152,
		156,
		151,
		162,
		154,
		158,
		175,
		-1,
		105,
		-1,
		57,
		15,
		35,
		50,
		58,
		-1,
		-1,
		-1,
		184,
		170,
		163,
		151,
		149,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		185,
		153,
		158,
		153,
		157,
		168,
		157,
		160,
		174,
		169,
		-1,
		-1,
		33,
		36,
		-1,
		-1,
		62,
		81,
		-1,
		175,
		164,
		149,
		141,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		142,
		167,
		156,
		164,
		159,
		161,
		167,
		170,
		159,
		163,
		175,
		-1,
		-1,
		40,
		43,
		48,
		-1,
		71,
		-1,
		186,
		-1,
		144,
		160,
		148,
		-1,
		-1,
		-1,
		180,
		143,
		164,
		174,
		179,
		177,
		168,
		165,
		172,
		170,
		166,
		177,
		-1,
		-1,
		-1,
		101,
		78,
		193,
		184,
		167,
		147,
		139,
		159,
		-1,
		168,
		-1,
		143,
		144,
		171,
		173,
		190,
		184,
		168,
		183,
		173,
		164,
		173,
		107,
		-1,
		82,
		141,
		124,
		153,
		119,
		131,
		189,
		-1,
		165,
		147,
		-1,
		175,
		165,
		207,
		188,
		181,
		168,
		175,
		177,
		170,
		-1,
		-1,
		-1,
		97,
		96,
		95,
		106,
		114,
		112,
		130,
		-1,
		177,
		159,
		138,
		155,
		155,
		146,
		154,
		197,
		193,
		186,
		188,
		178,
		-1,
		177,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		123,
		145,
		140,
		132,
		144,
		153,
		142,
		148,
		150,
		158,
		156,
		153,
		165,
		161,
		181,
		177,
		209,
		-1,
		184,
		-1,
		127,
		-1,
		-1,
		141,
		127,
		139,
		150,
		140,
		140,
		145,
		143,
		165,
		184,
		168,
		166,
		171,
		176,
		-1,
		194,
		195,
		-1,
		160,
		152,
		138,
		-1,
		131,
		-1,
		186,
		147,
		-1,
		172,
		152,
		-1,
		177,
		173,
		-1,
		-1,
		206,
		176,
		-1,
		-1,
		-1,
		161,
		141,
		181,
		165,
		-1,
		163,
		163,
		-1,
		-1,
		-1,
		201,
		185,
		-1,
		154,
		157,
		-1,
		148,
		154,
		183,
		165,
		169,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		169,
		174,
		162,
		179,
		165,
		167,
		179,
		168,
		189,
		-1,
		-1,
		-1,
		182,
		174,
		174,
		-1,
		-1,
		192,
		175,
		175,
		188,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		183,
		-1,
		-1,
		188,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		193,
		-1,
		-1,
		-1,
		184,
		191,
		199,
		-1,
		-1,
		-1,
		-1,
		214,
		215,
		239,
		214,
		-1,
		-1,
		-1,
		198,
		198,
		-1,
		-1,
		217,
		215,
		-1,
		-1,
		-1,
		226,
		210,
		-1,
		202,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		231,
		-1,
		237,
		212,
		219,
		-1,
		-1,
		-1,
		-1,
		244,
		236,
		250,
		-1,
		222,
		224,
		-1,
		272,
		-1,
		-1,
		259,
		250,
		-1,
		-1,
		227,
		234,
		256,
		259,
		289,
		-1,
		246
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		328,
		317,
		328,
		336,
		309,
		316,
		-1,
		335,
		339,
		305,
		299,
		338,
		307,
		313,
		324,
		-1,
		-1,
		-1,
		328,
		327,
		295,
		293,
		302,
		307,
		314,
		-1,
		313,
		-1,
		349,
		328,
		339,
		344,
		288,
		285,
		305,
		324,
		306,
		298,
		364,
		318,
		289,
		283,
		301,
		291,
		300,
		292,
		-1,
		289,
		279,
		301,
		280,
		291,
		283,
		-1,
		-1,
		283,
		284,
		290,
		276,
		282,
		278,
		-1,
		288,
		272,
		-1,
		-1,
		273,
		274,
		258,
		261,
		269,
		267,
		280,
		272,
		267,
		-1,
		-1,
		264,
		260,
		267,
		254,
		250,
		267,
		280,
		262,
		276,
		275,
		-1,
		268,
		286,
		293,
		261,
		259,
		243,
		241,
		259,
		261,
		267,
		267,
		-1,
		277,
		278,
		273,
		281,
		283,
		259,
		246,
		246,
		256,
		249,
		268,
		256,
		302,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		277,
		260,
		277,
		269,
		259,
		274,
		267,
		249,
		246,
		244,
		241,
		257,
		255,
		265,
		-1,
		-1,
		370,
		339,
		368,
		326,
		307,
		-1,
		273,
		253,
		259,
		263,
		257,
		250,
		264,
		260,
		-1,
		235,
		234,
		262,
		248,
		259,
		330,
		-1,
		-1,
		328,
		320,
		303,
		306,
		283,
		279,
		268,
		267,
		259,
		245,
		241,
		247,
		250,
		250,
		256,
		229,
		239,
		243,
		241,
		266,
		-1,
		-1,
		301,
		-1,
		-1,
		327,
		310,
		-1,
		293,
		300,
		289,
		295,
		281,
		302,
		278,
		269,
		261,
		255,
		243,
		245,
		242,
		255,
		243,
		226,
		251,
		255,
		236,
		257,
		252,
		-1,
		300,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		286,
		289,
		295,
		319,
		318,
		-1,
		290,
		278,
		279,
		264,
		261,
		248,
		236,
		249,
		234,
		241,
		240,
		230,
		228,
		258,
		233,
		255,
		252,
		271,
		276,
		270,
		279,
		-1,
		335,
		331,
		327,
		334,
		283,
		-1,
		-1,
		323,
		-1,
		326,
		327,
		302,
		275,
		278,
		265,
		256,
		243,
		232,
		243,
		232,
		229,
		237,
		222,
		237,
		228,
		227,
		245,
		255,
		263,
		267,
		273,
		-1,
		385,
		-1,
		327,
		311,
		313,
		285,
		306,
		-1,
		343,
		327,
		319,
		304,
		304,
		-1,
		274,
		271,
		261,
		239,
		224,
		241,
		233,
		231,
		235,
		217,
		231,
		222,
		240,
		247,
		245,
		249,
		269,
		281,
		345,
		335,
		-1,
		317,
		322,
		281,
		289,
		308,
		346,
		310,
		-1,
		305,
		-1,
		276,
		289,
		-1,
		245,
		241,
		223,
		224,
		219,
		234,
		228,
		213,
		210,
		228,
		231,
		238,
		242,
		258,
		-1,
		-1,
		330,
		334,
		323,
		274,
		293,
		317,
		354,
		303,
		292,
		291,
		-1,
		282,
		259,
		256,
		244,
		231,
		216,
		217,
		225,
		238,
		217,
		212,
		209,
		229,
		255,
		233,
		245,
		-1,
		-1,
		-1,
		355,
		-1,
		-1,
		300,
		271,
		295,
		337,
		321,
		314,
		302,
		267,
		267,
		261,
		-1,
		255,
		234,
		225,
		214,
		212,
		225,
		222,
		227,
		207,
		205,
		224,
		236,
		227,
		244,
		-1,
		-1,
		-1,
		330,
		319,
		320,
		266,
		289,
		326,
		300,
		286,
		291,
		266,
		259,
		253,
		268,
		251,
		232,
		221,
		213,
		202,
		218,
		226,
		221,
		203,
		212,
		218,
		242,
		232,
		238,
		-1,
		-1,
		337,
		327,
		311,
		313,
		310,
		280,
		287,
		319,
		291,
		304,
		-1,
		258,
		-1,
		247,
		242,
		226,
		221,
		218,
		215,
		209,
		218,
		220,
		210,
		205,
		212,
		247,
		247,
		222,
		242,
		245,
		-1,
		-1,
		-1,
		330,
		325,
		300,
		277,
		261,
		297,
		-1,
		274,
		275,
		-1,
		252,
		246,
		243,
		228,
		224,
		219,
		223,
		216,
		223,
		216,
		214,
		215,
		197,
		229,
		-1,
		230,
		224,
		232,
		222,
		210,
		-1,
		-1,
		-1,
		323,
		302,
		295,
		315,
		256,
		308,
		-1,
		-1,
		259,
		252,
		-1,
		239,
		221,
		228,
		226,
		220,
		224,
		221,
		210,
		223,
		216,
		202,
		204,
		217,
		221,
		225,
		212,
		208,
		205,
		219,
		-1,
		342,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		276,
		-1,
		268,
		260,
		250,
		244,
		238,
		234,
		232,
		248,
		232,
		235,
		233,
		224,
		232,
		205,
		198,
		205,
		194,
		212,
		220,
		212,
		206,
		205,
		215,
		-1,
		343,
		329,
		300,
		-1,
		-1,
		289,
		-1,
		253,
		267,
		283,
		-1,
		276,
		255,
		270,
		248,
		244,
		240,
		255,
		256,
		233,
		233,
		231,
		222,
		210,
		199,
		202,
		194,
		216,
		216,
		200,
		201,
		205,
		-1,
		349,
		336,
		294,
		290,
		279,
		299,
		250,
		238,
		270,
		-1,
		-1,
		312,
		-1,
		246,
		263,
		254,
		252,
		245,
		227,
		234,
		242,
		219,
		214,
		204,
		193,
		193,
		188,
		210,
		196,
		194,
		203,
		219,
		-1,
		-1,
		-1,
		316,
		-1,
		-1,
		265,
		252,
		246,
		-1,
		287,
		-1,
		290,
		280,
		264,
		249,
		282,
		-1,
		226,
		222,
		229,
		-1,
		239,
		-1,
		212,
		209,
		200,
		185,
		182,
		193,
		191,
		202,
		198,
		-1,
		299,
		284,
		277,
		267,
		281,
		251,
		-1,
		285,
		-1,
		-1,
		277,
		271,
		271,
		255,
		256,
		242,
		222,
		214,
		229,
		228,
		215,
		214,
		198,
		191,
		188,
		181,
		194,
		204,
		209,
		196,
		-1,
		-1,
		-1,
		304,
		281,
		275,
		247,
		251,
		-1,
		-1,
		339,
		294,
		280,
		-1,
		251,
		242,
		230,
		220,
		210,
		215,
		216,
		206,
		204,
		196,
		198,
		192,
		183,
		182,
		198,
		190,
		212,
		-1,
		-1,
		280,
		273,
		261,
		229,
		224,
		-1,
		-1,
		-1,
		286,
		302,
		270,
		249,
		231,
		-1,
		-1,
		214,
		207,
		201,
		204,
		192,
		212,
		207,
		191,
		176,
		191,
		195,
		203,
		194,
		-1,
		283,
		270,
		-1,
		-1,
		223,
		213,
		-1,
		-1,
		-1,
		-1,
		282,
		227,
		216,
		211,
		215,
		213,
		-1,
		187,
		198,
		191,
		210,
		217,
		193,
		178,
		172,
		178,
		190,
		199,
		-1,
		-1,
		237,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		239,
		233,
		204,
		197,
		201,
		-1,
		189,
		191,
		188,
		200,
		196,
		193,
		184,
		175,
		171,
		175,
		179,
		193,
		197,
		260,
		-1,
		190,
		-1,
		-1,
		-1,
		236,
		258,
		243,
		220,
		193,
		188,
		181,
		175,
		180,
		191,
		200,
		211,
		176,
		178,
		168,
		167,
		171,
		188,
		192,
		-1,
		-1,
		188,
		184,
		219,
		231,
		231,
		270,
		-1,
		-1,
		197,
		188,
		179,
		171,
		184,
		187,
		172,
		174,
		174,
		172,
		166,
		176,
		191,
		186,
		-1,
		-1,
		-1,
		200,
		-1,
		202,
		-1,
		-1,
		221,
		268,
		215,
		197,
		193,
		191,
		180,
		174,
		162,
		167,
		177,
		171,
		168,
		162,
		166,
		189,
		178,
		217,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		207,
		171,
		166,
		200,
		205,
		196,
		230,
		227,
		-1,
		197,
		203,
		168,
		175,
		158,
		165,
		170,
		167,
		156,
		163,
		179,
		178,
		173,
		209,
		200,
		206,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		200,
		168,
		186,
		176,
		182,
		-1,
		-1,
		222,
		219,
		199,
		168,
		166,
		159,
		154,
		164,
		140,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		252,
		289,
		282,
		250,
		258,
		289,
		-1,
		190,
		182,
		165,
		168,
		176,
		-1,
		-1,
		195,
		186,
		187,
		175,
		172,
		178,
		177,
		160,
		166,
		167,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		245,
		265,
		244,
		247,
		271,
		285,
		-1,
		187,
		-1,
		-1,
		125,
		189,
		197,
		193,
		191,
		234,
		189,
		184,
		165,
		163,
		158,
		149,
		174,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		234,
		245,
		238,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		-1,
		115,
		-1,
		223,
		-1,
		214,
		218,
		197,
		200,
		179,
		166,
		152,
		160,
		166,
		165,
		171,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		259,
		215,
		218,
		229,
		240,
		255,
		259,
		-1,
		199,
		238,
		121,
		-1,
		105,
		-1,
		-1,
		-1,
		228,
		210,
		202,
		199,
		178,
		178,
		144,
		148,
		161,
		168,
		178,
		189,
		181,
		185,
		198,
		209,
		212,
		255,
		246,
		259,
		204,
		204,
		225,
		234,
		255,
		204,
		205,
		232,
		128,
		117,
		112,
		99,
		-1,
		-1,
		212,
		220,
		-1,
		-1,
		185,
		152,
		140,
		150,
		154,
		168,
		180,
		193,
		181,
		186,
		180,
		212,
		-1,
		248,
		247,
		236,
		233,
		209,
		200,
		195,
		222,
		-1,
		-1,
		202,
		233,
		184,
		161,
		159,
		184,
		-1,
		83,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		157,
		146,
		137,
		142,
		162,
		173,
		195,
		177,
		194,
		185,
		195,
		199,
		232,
		229,
		217,
		215,
		238,
		203,
		191,
		-1,
		199,
		199,
		195,
		182,
		162,
		173,
		-1,
		-1,
		99,
		79,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		134,
		139,
		169,
		171,
		173,
		180,
		174,
		181,
		189,
		200,
		192,
		241,
		255,
		244,
		240,
		239,
		247,
		196,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		0,
		-1,
		81,
		85,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		156,
		156,
		159,
		164,
		172,
		183,
		179,
		183,
		186,
		-1,
		275,
		-1,
		227,
		188,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		88,
		16,
		28,
		65,
		67,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		192,
		160,
		165,
		160,
		175,
		186,
		177,
		185,
		179,
		182,
		-1,
		-1,
		187,
		170,
		-1,
		-1,
		144,
		146,
		-1,
		79,
		68,
		44,
		59,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		126,
		164,
		163,
		171,
		166,
		171,
		183,
		179,
		175,
		185,
		176,
		-1,
		-1,
		165,
		157,
		151,
		-1,
		129,
		-1,
		117,
		-1,
		49,
		78,
		80,
		-1,
		-1,
		-1,
		157,
		120,
		136,
		159,
		185,
		183,
		174,
		167,
		174,
		177,
		170,
		176,
		-1,
		-1,
		-1,
		147,
		121,
		124,
		115,
		98,
		78,
		74,
		95,
		-1,
		138,
		-1,
		113,
		116,
		141,
		180,
		182,
		168,
		164,
		177,
		171,
		168,
		166,
		153,
		-1,
		123,
		156,
		120,
		84,
		88,
		83,
		152,
		-1,
		135,
		117,
		-1,
		145,
		135,
		183,
		158,
		167,
		160,
		154,
		155,
		163,
		-1,
		-1,
		-1,
		125,
		124,
		116,
		110,
		108,
		93,
		88,
		-1,
		140,
		122,
		108,
		125,
		125,
		116,
		124,
		173,
		169,
		172,
		170,
		148,
		-1,
		239,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		119,
		128,
		101,
		89,
		103,
		110,
		105,
		107,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		147,
		179,
		-1,
		234,
		-1,
		155,
		-1,
		-1,
		135,
		121,
		123,
		112,
		101,
		99,
		102,
		100,
		122,
		152,
		138,
		136,
		141,
		146,
		-1,
		223,
		222,
		-1,
		154,
		146,
		132,
		-1,
		125,
		-1,
		147,
		108,
		-1,
		129,
		109,
		-1,
		147,
		143,
		-1,
		-1,
		210,
		170,
		-1,
		-1,
		-1,
		155,
		135,
		142,
		126,
		-1,
		120,
		120,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		148,
		151,
		-1,
		142,
		148,
		175,
		122,
		126,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		163,
		168,
		156,
		173,
		159,
		158,
		136,
		125,
		146,
		-1,
		-1,
		-1,
		176,
		168,
		168,
		-1,
		-1,
		183,
		166,
		147,
		145,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		173,
		-1,
		-1,
		179,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		187,
		-1,
		-1,
		-1,
		169,
		165,
		166,
		-1,
		-1,
		-1,
		-1,
		208,
		209,
		233,
		208,
		-1,
		-1,
		-1,
		161,
		155,
		-1,
		-1,
		211,
		209,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		159,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		192,
		-1,
		-1,
		-1,
		194,
		-1,
		194,
		169,
		176,
		-1,
		-1,
		-1,
		-1,
		207,
		199,
		207,
		-1,
		179,
		181,
		-1,
		229,
		-1,
		-1,
		222,
		213,
		-1,
		-1,
		184,
		191,
		213,
		216,
		252,
		-1,
		203
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		303,
		292,
		303,
		311,
		284,
		291,
		-1,
		310,
		314,
		280,
		274,
		313,
		282,
		288,
		299,
		-1,
		-1,
		-1,
		303,
		302,
		270,
		268,
		277,
		282,
		289,
		-1,
		288,
		-1,
		324,
		303,
		314,
		319,
		263,
		260,
		280,
		299,
		281,
		273,
		339,
		293,
		264,
		258,
		276,
		266,
		275,
		267,
		-1,
		264,
		254,
		276,
		255,
		266,
		258,
		-1,
		-1,
		258,
		259,
		265,
		251,
		257,
		253,
		-1,
		263,
		247,
		-1,
		-1,
		248,
		249,
		233,
		236,
		244,
		242,
		255,
		247,
		242,
		-1,
		-1,
		239,
		235,
		242,
		229,
		225,
		242,
		255,
		237,
		251,
		250,
		-1,
		243,
		261,
		268,
		236,
		234,
		218,
		216,
		234,
		236,
		242,
		242,
		-1,
		252,
		253,
		248,
		256,
		258,
		234,
		221,
		221,
		231,
		224,
		243,
		231,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		252,
		235,
		252,
		244,
		234,
		249,
		242,
		224,
		221,
		219,
		216,
		232,
		230,
		240,
		-1,
		-1,
		345,
		314,
		343,
		301,
		282,
		-1,
		248,
		228,
		234,
		238,
		232,
		225,
		239,
		235,
		-1,
		210,
		209,
		237,
		223,
		234,
		305,
		-1,
		-1,
		303,
		295,
		278,
		281,
		258,
		254,
		243,
		242,
		234,
		220,
		216,
		222,
		225,
		225,
		231,
		204,
		214,
		218,
		216,
		241,
		-1,
		-1,
		276,
		-1,
		-1,
		302,
		285,
		-1,
		268,
		275,
		264,
		270,
		256,
		277,
		253,
		244,
		236,
		230,
		218,
		220,
		217,
		230,
		218,
		201,
		226,
		230,
		211,
		232,
		227,
		-1,
		275,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		261,
		264,
		270,
		294,
		293,
		-1,
		265,
		253,
		254,
		239,
		236,
		223,
		211,
		224,
		209,
		216,
		215,
		205,
		203,
		233,
		208,
		230,
		227,
		246,
		251,
		245,
		254,
		-1,
		310,
		306,
		302,
		309,
		258,
		-1,
		-1,
		298,
		-1,
		301,
		302,
		277,
		250,
		253,
		240,
		231,
		218,
		207,
		218,
		207,
		204,
		212,
		197,
		212,
		203,
		202,
		220,
		230,
		238,
		242,
		248,
		-1,
		360,
		-1,
		302,
		286,
		288,
		260,
		281,
		-1,
		318,
		302,
		294,
		279,
		279,
		-1,
		249,
		246,
		236,
		214,
		199,
		216,
		208,
		206,
		210,
		192,
		206,
		197,
		215,
		222,
		220,
		224,
		244,
		256,
		320,
		310,
		-1,
		292,
		297,
		256,
		264,
		283,
		321,
		285,
		-1,
		280,
		-1,
		251,
		264,
		-1,
		220,
		216,
		198,
		199,
		194,
		209,
		203,
		188,
		185,
		203,
		206,
		213,
		217,
		233,
		-1,
		-1,
		305,
		309,
		298,
		249,
		268,
		292,
		329,
		278,
		267,
		266,
		-1,
		257,
		234,
		231,
		219,
		206,
		191,
		192,
		200,
		213,
		192,
		187,
		184,
		204,
		230,
		208,
		220,
		-1,
		-1,
		-1,
		330,
		-1,
		-1,
		275,
		246,
		270,
		312,
		296,
		289,
		277,
		242,
		242,
		236,
		-1,
		230,
		209,
		200,
		189,
		187,
		200,
		197,
		202,
		182,
		180,
		199,
		211,
		202,
		219,
		-1,
		-1,
		-1,
		305,
		294,
		295,
		241,
		264,
		301,
		275,
		261,
		266,
		241,
		234,
		228,
		243,
		226,
		207,
		196,
		188,
		177,
		193,
		201,
		196,
		178,
		187,
		193,
		217,
		207,
		213,
		-1,
		-1,
		312,
		302,
		286,
		288,
		285,
		255,
		262,
		294,
		266,
		279,
		-1,
		233,
		-1,
		222,
		217,
		201,
		196,
		193,
		190,
		184,
		193,
		195,
		185,
		180,
		187,
		222,
		222,
		197,
		217,
		220,
		-1,
		-1,
		-1,
		305,
		300,
		275,
		252,
		236,
		272,
		-1,
		249,
		250,
		-1,
		227,
		221,
		218,
		203,
		199,
		194,
		198,
		191,
		198,
		191,
		189,
		190,
		172,
		204,
		-1,
		205,
		199,
		207,
		197,
		185,
		-1,
		-1,
		-1,
		298,
		277,
		270,
		290,
		231,
		283,
		-1,
		-1,
		234,
		227,
		-1,
		214,
		196,
		203,
		201,
		195,
		199,
		196,
		185,
		198,
		191,
		177,
		179,
		192,
		196,
		200,
		187,
		183,
		180,
		194,
		-1,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		251,
		-1,
		243,
		235,
		225,
		219,
		213,
		209,
		207,
		223,
		207,
		210,
		208,
		199,
		207,
		180,
		173,
		180,
		169,
		187,
		195,
		187,
		181,
		180,
		190,
		-1,
		318,
		304,
		275,
		-1,
		-1,
		264,
		-1,
		228,
		242,
		258,
		-1,
		251,
		230,
		245,
		223,
		219,
		215,
		230,
		231,
		208,
		208,
		206,
		197,
		185,
		174,
		177,
		169,
		191,
		191,
		175,
		176,
		180,
		-1,
		324,
		311,
		269,
		265,
		254,
		274,
		225,
		213,
		245,
		-1,
		-1,
		287,
		-1,
		221,
		238,
		229,
		227,
		220,
		202,
		209,
		217,
		194,
		189,
		179,
		168,
		168,
		163,
		185,
		171,
		169,
		178,
		194,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		240,
		227,
		221,
		-1,
		262,
		-1,
		265,
		255,
		239,
		224,
		257,
		-1,
		201,
		197,
		204,
		-1,
		214,
		-1,
		187,
		184,
		175,
		160,
		157,
		168,
		166,
		177,
		173,
		-1,
		274,
		259,
		252,
		242,
		256,
		226,
		-1,
		260,
		-1,
		-1,
		252,
		246,
		246,
		230,
		231,
		217,
		197,
		189,
		204,
		203,
		190,
		189,
		173,
		166,
		163,
		156,
		169,
		179,
		184,
		171,
		-1,
		-1,
		-1,
		279,
		256,
		250,
		222,
		226,
		-1,
		-1,
		314,
		269,
		255,
		-1,
		226,
		217,
		205,
		195,
		185,
		190,
		191,
		181,
		179,
		171,
		173,
		167,
		158,
		157,
		173,
		165,
		187,
		-1,
		-1,
		255,
		248,
		236,
		204,
		199,
		-1,
		-1,
		-1,
		261,
		277,
		245,
		224,
		206,
		-1,
		-1,
		189,
		182,
		176,
		179,
		167,
		187,
		182,
		166,
		151,
		166,
		170,
		178,
		169,
		-1,
		258,
		245,
		-1,
		-1,
		198,
		188,
		-1,
		-1,
		-1,
		-1,
		257,
		202,
		191,
		186,
		190,
		188,
		-1,
		162,
		173,
		166,
		185,
		192,
		168,
		153,
		147,
		153,
		165,
		174,
		-1,
		-1,
		212,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		214,
		208,
		179,
		172,
		176,
		-1,
		164,
		166,
		163,
		175,
		171,
		168,
		159,
		150,
		146,
		150,
		154,
		168,
		172,
		235,
		-1,
		165,
		-1,
		-1,
		-1,
		211,
		233,
		218,
		195,
		168,
		163,
		156,
		150,
		155,
		166,
		175,
		186,
		151,
		153,
		143,
		142,
		146,
		163,
		167,
		-1,
		-1,
		163,
		159,
		194,
		206,
		206,
		245,
		-1,
		-1,
		172,
		163,
		154,
		146,
		159,
		162,
		147,
		149,
		149,
		147,
		141,
		151,
		166,
		161,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		196,
		243,
		190,
		172,
		168,
		166,
		155,
		149,
		137,
		142,
		152,
		146,
		143,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		182,
		146,
		141,
		175,
		180,
		171,
		205,
		202,
		-1,
		172,
		178,
		143,
		150,
		133,
		140,
		145,
		142,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		175,
		143,
		161,
		151,
		157,
		-1,
		-1,
		197,
		194,
		174,
		143,
		141,
		134,
		129,
		139,
		115,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		227,
		264,
		257,
		225,
		233,
		264,
		-1,
		165,
		157,
		140,
		143,
		151,
		-1,
		-1,
		170,
		161,
		162,
		150,
		147,
		153,
		152,
		135,
		141,
		142,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		220,
		240,
		219,
		222,
		246,
		260,
		-1,
		162,
		-1,
		-1,
		100,
		164,
		172,
		168,
		166,
		209,
		164,
		159,
		140,
		138,
		133,
		124,
		149,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		209,
		220,
		213,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		90,
		-1,
		198,
		-1,
		189,
		193,
		172,
		175,
		154,
		141,
		127,
		135,
		141,
		140,
		146,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		234,
		190,
		193,
		204,
		215,
		230,
		234,
		-1,
		174,
		213,
		96,
		-1,
		80,
		-1,
		-1,
		-1,
		203,
		185,
		177,
		174,
		153,
		153,
		119,
		123,
		136,
		143,
		153,
		164,
		156,
		160,
		173,
		184,
		187,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		179,
		180,
		207,
		103,
		92,
		87,
		74,
		-1,
		-1,
		187,
		195,
		-1,
		-1,
		160,
		127,
		115,
		125,
		129,
		143,
		155,
		168,
		156,
		161,
		155,
		187,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		177,
		208,
		159,
		136,
		134,
		159,
		-1,
		58,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		132,
		121,
		112,
		117,
		137,
		148,
		170,
		152,
		169,
		160,
		170,
		174,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		174,
		174,
		170,
		157,
		137,
		148,
		-1,
		-1,
		74,
		54,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		109,
		114,
		144,
		146,
		148,
		155,
		149,
		156,
		164,
		175,
		167,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		-1,
		0,
		60,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		131,
		131,
		134,
		139,
		147,
		158,
		154,
		158,
		161,
		-1,
		250,
		-1,
		202,
		163,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		74,
		59,
		52,
		14,
		42,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		167,
		135,
		140,
		135,
		150,
		161,
		152,
		160,
		154,
		157,
		-1,
		-1,
		162,
		145,
		-1,
		-1,
		119,
		121,
		-1,
		65,
		54,
		38,
		34,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		101,
		139,
		138,
		146,
		141,
		146,
		158,
		154,
		150,
		160,
		151,
		-1,
		-1,
		140,
		132,
		126,
		-1,
		104,
		-1,
		92,
		-1,
		33,
		53,
		55,
		-1,
		-1,
		-1,
		132,
		95,
		111,
		134,
		160,
		158,
		149,
		142,
		149,
		152,
		145,
		151,
		-1,
		-1,
		-1,
		122,
		96,
		99,
		90,
		73,
		53,
		49,
		70,
		-1,
		113,
		-1,
		88,
		91,
		116,
		155,
		157,
		143,
		139,
		152,
		146,
		143,
		141,
		128,
		-1,
		98,
		131,
		95,
		59,
		63,
		58,
		127,
		-1,
		110,
		92,
		-1,
		120,
		110,
		158,
		133,
		142,
		135,
		129,
		130,
		138,
		-1,
		-1,
		-1,
		100,
		99,
		91,
		85,
		83,
		68,
		63,
		-1,
		115,
		97,
		83,
		100,
		100,
		91,
		99,
		148,
		144,
		147,
		145,
		123,
		-1,
		214,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		94,
		103,
		76,
		64,
		78,
		85,
		80,
		82,
		95,
		103,
		101,
		98,
		110,
		106,
		126,
		122,
		154,
		-1,
		209,
		-1,
		130,
		-1,
		-1,
		110,
		96,
		98,
		87,
		76,
		74,
		77,
		75,
		97,
		127,
		113,
		111,
		116,
		121,
		-1,
		198,
		197,
		-1,
		129,
		121,
		107,
		-1,
		100,
		-1,
		122,
		83,
		-1,
		104,
		84,
		-1,
		122,
		118,
		-1,
		-1,
		185,
		145,
		-1,
		-1,
		-1,
		130,
		110,
		117,
		101,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		123,
		126,
		-1,
		117,
		123,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		179,
		160,
		154,
		138,
		143,
		131,
		148,
		134,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		151,
		143,
		143,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		173,
		154,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		162,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		183,
		184,
		208,
		183,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		186,
		184,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		301,
		290,
		301,
		309,
		282,
		289,
		-1,
		308,
		312,
		278,
		272,
		311,
		280,
		286,
		297,
		-1,
		-1,
		-1,
		301,
		300,
		268,
		266,
		275,
		280,
		287,
		-1,
		286,
		-1,
		322,
		301,
		312,
		317,
		261,
		258,
		278,
		297,
		279,
		271,
		337,
		291,
		262,
		256,
		274,
		264,
		273,
		265,
		-1,
		262,
		252,
		274,
		253,
		264,
		256,
		-1,
		-1,
		256,
		257,
		263,
		249,
		255,
		251,
		-1,
		261,
		245,
		-1,
		-1,
		246,
		247,
		231,
		234,
		242,
		240,
		253,
		245,
		240,
		-1,
		-1,
		237,
		233,
		240,
		227,
		223,
		240,
		253,
		235,
		249,
		248,
		-1,
		241,
		259,
		266,
		234,
		232,
		216,
		214,
		232,
		234,
		240,
		240,
		-1,
		250,
		251,
		246,
		254,
		256,
		232,
		219,
		219,
		229,
		222,
		241,
		229,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		250,
		233,
		250,
		242,
		232,
		247,
		240,
		222,
		219,
		217,
		214,
		230,
		228,
		238,
		-1,
		-1,
		320,
		289,
		324,
		281,
		266,
		-1,
		246,
		226,
		232,
		236,
		230,
		223,
		237,
		233,
		-1,
		208,
		207,
		235,
		221,
		232,
		280,
		-1,
		-1,
		278,
		270,
		255,
		258,
		255,
		252,
		241,
		240,
		232,
		218,
		214,
		220,
		223,
		223,
		229,
		202,
		212,
		216,
		214,
		239,
		-1,
		-1,
		274,
		-1,
		-1,
		277,
		260,
		-1,
		243,
		250,
		250,
		267,
		254,
		275,
		251,
		242,
		234,
		228,
		216,
		218,
		215,
		228,
		216,
		199,
		224,
		228,
		209,
		230,
		225,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		236,
		239,
		245,
		269,
		279,
		-1,
		263,
		251,
		252,
		237,
		234,
		221,
		209,
		222,
		207,
		214,
		213,
		203,
		201,
		231,
		206,
		228,
		225,
		244,
		249,
		243,
		252,
		-1,
		285,
		281,
		277,
		284,
		233,
		-1,
		-1,
		273,
		-1,
		287,
		300,
		275,
		248,
		251,
		238,
		229,
		216,
		205,
		216,
		205,
		202,
		210,
		195,
		210,
		201,
		200,
		218,
		228,
		236,
		240,
		246,
		-1,
		335,
		-1,
		277,
		261,
		263,
		235,
		256,
		-1,
		293,
		288,
		292,
		277,
		277,
		-1,
		247,
		244,
		234,
		212,
		197,
		214,
		206,
		204,
		208,
		190,
		204,
		195,
		213,
		220,
		218,
		222,
		242,
		254,
		295,
		285,
		-1,
		267,
		272,
		231,
		239,
		258,
		319,
		283,
		-1,
		278,
		-1,
		249,
		262,
		-1,
		218,
		214,
		196,
		197,
		192,
		207,
		201,
		186,
		183,
		201,
		204,
		211,
		215,
		231,
		-1,
		-1,
		280,
		284,
		273,
		224,
		243,
		267,
		304,
		276,
		265,
		264,
		-1,
		255,
		232,
		229,
		217,
		204,
		189,
		190,
		198,
		211,
		190,
		185,
		182,
		202,
		228,
		206,
		218,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		250,
		221,
		245,
		287,
		294,
		287,
		275,
		240,
		240,
		234,
		-1,
		228,
		207,
		198,
		187,
		185,
		198,
		195,
		200,
		180,
		178,
		197,
		209,
		200,
		217,
		-1,
		-1,
		-1,
		280,
		269,
		270,
		216,
		239,
		276,
		273,
		259,
		264,
		239,
		232,
		226,
		241,
		224,
		205,
		194,
		186,
		175,
		191,
		199,
		194,
		176,
		185,
		191,
		215,
		205,
		211,
		-1,
		-1,
		287,
		277,
		261,
		263,
		260,
		230,
		237,
		269,
		264,
		277,
		-1,
		231,
		-1,
		220,
		215,
		199,
		194,
		191,
		188,
		182,
		191,
		193,
		183,
		178,
		185,
		220,
		220,
		195,
		215,
		218,
		-1,
		-1,
		-1,
		280,
		275,
		250,
		227,
		211,
		247,
		-1,
		247,
		248,
		-1,
		225,
		219,
		216,
		201,
		197,
		192,
		196,
		189,
		196,
		189,
		187,
		188,
		170,
		202,
		-1,
		203,
		197,
		205,
		195,
		183,
		-1,
		-1,
		-1,
		273,
		252,
		245,
		265,
		206,
		258,
		-1,
		-1,
		232,
		225,
		-1,
		212,
		194,
		201,
		199,
		193,
		197,
		194,
		183,
		196,
		189,
		175,
		177,
		190,
		194,
		198,
		185,
		181,
		178,
		192,
		-1,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		226,
		-1,
		241,
		233,
		223,
		217,
		211,
		207,
		205,
		221,
		205,
		208,
		206,
		197,
		205,
		178,
		171,
		178,
		167,
		185,
		193,
		185,
		179,
		178,
		188,
		-1,
		293,
		279,
		250,
		-1,
		-1,
		239,
		-1,
		203,
		222,
		238,
		-1,
		249,
		228,
		243,
		221,
		217,
		213,
		228,
		229,
		206,
		206,
		204,
		195,
		183,
		172,
		175,
		167,
		189,
		189,
		173,
		174,
		178,
		-1,
		299,
		286,
		244,
		240,
		229,
		249,
		200,
		209,
		225,
		-1,
		-1,
		285,
		-1,
		219,
		236,
		227,
		225,
		218,
		200,
		207,
		215,
		192,
		187,
		177,
		166,
		166,
		161,
		183,
		169,
		167,
		176,
		192,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		215,
		202,
		196,
		-1,
		242,
		-1,
		263,
		253,
		237,
		222,
		255,
		-1,
		199,
		195,
		202,
		-1,
		212,
		-1,
		185,
		182,
		173,
		158,
		155,
		166,
		164,
		175,
		171,
		-1,
		249,
		234,
		227,
		217,
		231,
		199,
		-1,
		233,
		-1,
		-1,
		250,
		244,
		244,
		227,
		224,
		215,
		195,
		187,
		202,
		201,
		188,
		187,
		171,
		164,
		161,
		154,
		167,
		177,
		182,
		169,
		-1,
		-1,
		-1,
		254,
		229,
		223,
		195,
		199,
		-1,
		-1,
		312,
		267,
		253,
		-1,
		219,
		215,
		203,
		193,
		183,
		188,
		189,
		179,
		177,
		169,
		171,
		165,
		156,
		155,
		171,
		163,
		185,
		-1,
		-1,
		228,
		221,
		209,
		177,
		172,
		-1,
		-1,
		-1,
		259,
		257,
		243,
		217,
		204,
		-1,
		-1,
		187,
		180,
		174,
		177,
		165,
		185,
		180,
		164,
		149,
		164,
		168,
		176,
		167,
		-1,
		231,
		218,
		-1,
		-1,
		171,
		161,
		-1,
		-1,
		-1,
		-1,
		235,
		200,
		189,
		184,
		188,
		186,
		-1,
		160,
		171,
		164,
		183,
		190,
		166,
		151,
		145,
		151,
		163,
		172,
		-1,
		-1,
		185,
		-1,
		147,
		-1,
		-1,
		-1,
		-1,
		207,
		206,
		177,
		170,
		174,
		-1,
		162,
		164,
		161,
		173,
		169,
		166,
		157,
		148,
		144,
		148,
		152,
		166,
		170,
		208,
		-1,
		138,
		-1,
		-1,
		-1,
		184,
		206,
		216,
		193,
		166,
		161,
		154,
		148,
		153,
		164,
		173,
		184,
		149,
		151,
		141,
		140,
		144,
		161,
		165,
		-1,
		-1,
		136,
		132,
		167,
		179,
		179,
		243,
		-1,
		-1,
		170,
		161,
		152,
		144,
		157,
		160,
		145,
		147,
		147,
		145,
		139,
		149,
		164,
		159,
		-1,
		-1,
		-1,
		148,
		-1,
		150,
		-1,
		-1,
		169,
		241,
		188,
		170,
		166,
		164,
		153,
		147,
		135,
		140,
		150,
		144,
		141,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		155,
		119,
		114,
		148,
		153,
		144,
		203,
		200,
		-1,
		163,
		176,
		141,
		148,
		131,
		138,
		143,
		140,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		148,
		116,
		134,
		124,
		130,
		-1,
		-1,
		177,
		174,
		172,
		141,
		139,
		132,
		127,
		137,
		113,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		138,
		130,
		113,
		116,
		124,
		-1,
		-1,
		150,
		146,
		151,
		148,
		145,
		151,
		150,
		133,
		139,
		140,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		135,
		-1,
		-1,
		73,
		137,
		145,
		141,
		145,
		198,
		162,
		157,
		138,
		136,
		131,
		122,
		147,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		63,
		-1,
		171,
		-1,
		164,
		168,
		170,
		173,
		152,
		139,
		125,
		133,
		139,
		138,
		144,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		147,
		186,
		69,
		-1,
		53,
		-1,
		-1,
		-1,
		178,
		183,
		175,
		172,
		151,
		151,
		117,
		121,
		134,
		141,
		151,
		162,
		154,
		158,
		171,
		182,
		185,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		152,
		153,
		180,
		76,
		65,
		60,
		47,
		-1,
		-1,
		185,
		193,
		-1,
		-1,
		158,
		125,
		113,
		123,
		127,
		141,
		153,
		166,
		154,
		159,
		153,
		185,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		150,
		181,
		132,
		109,
		107,
		132,
		-1,
		31,
		-1,
		-1,
		165,
		-1,
		-1,
		150,
		130,
		119,
		110,
		115,
		135,
		146,
		168,
		150,
		167,
		158,
		168,
		172,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		153,
		147,
		143,
		130,
		110,
		121,
		-1,
		-1,
		47,
		27,
		-1,
		-1,
		148,
		146,
		135,
		-1,
		125,
		107,
		112,
		142,
		144,
		146,
		153,
		147,
		154,
		162,
		173,
		165,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		-1,
		62,
		0,
		-1,
		-1,
		143,
		136,
		124,
		112,
		102,
		112,
		129,
		129,
		132,
		137,
		145,
		156,
		152,
		156,
		159,
		-1,
		248,
		-1,
		200,
		161,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		79,
		65,
		58,
		46,
		44,
		-1,
		177,
		161,
		142,
		-1,
		112,
		125,
		165,
		133,
		138,
		133,
		148,
		159,
		150,
		158,
		152,
		155,
		-1,
		-1,
		160,
		143,
		-1,
		-1,
		117,
		119,
		-1,
		70,
		59,
		44,
		36,
		-1,
		-1,
		149,
		145,
		-1,
		-1,
		99,
		137,
		136,
		144,
		139,
		144,
		156,
		152,
		148,
		158,
		149,
		-1,
		-1,
		138,
		130,
		124,
		-1,
		102,
		-1,
		94,
		-1,
		39,
		55,
		57,
		-1,
		-1,
		-1,
		130,
		93,
		109,
		132,
		158,
		156,
		147,
		140,
		147,
		150,
		143,
		149,
		-1,
		-1,
		-1,
		120,
		94,
		101,
		92,
		75,
		55,
		47,
		72,
		-1,
		111,
		-1,
		86,
		89,
		114,
		153,
		155,
		141,
		137,
		150,
		144,
		141,
		139,
		126,
		-1,
		96,
		129,
		93,
		61,
		61,
		60,
		125,
		-1,
		108,
		90,
		-1,
		118,
		108,
		156,
		131,
		140,
		133,
		127,
		128,
		136,
		-1,
		-1,
		-1,
		98,
		97,
		89,
		83,
		81,
		66,
		61,
		-1,
		113,
		95,
		81,
		98,
		98,
		89,
		97,
		146,
		142,
		145,
		143,
		121,
		-1,
		212,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		92,
		101,
		74,
		62,
		76,
		83,
		78,
		80,
		93,
		101,
		99,
		96,
		108,
		104,
		124,
		120,
		152,
		-1,
		207,
		-1,
		128,
		-1,
		-1,
		108,
		94,
		96,
		85,
		74,
		72,
		75,
		73,
		95,
		125,
		111,
		109,
		114,
		119,
		-1,
		196,
		195,
		-1,
		127,
		119,
		105,
		-1,
		98,
		-1,
		120,
		81,
		-1,
		102,
		82,
		-1,
		120,
		116,
		-1,
		-1,
		183,
		143,
		-1,
		-1,
		-1,
		128,
		108,
		115,
		99,
		-1,
		93,
		93,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		121,
		124,
		-1,
		115,
		121,
		148,
		95,
		99,
		-1,
		-1,
		-1,
		177,
		158,
		152,
		136,
		141,
		129,
		146,
		132,
		131,
		109,
		98,
		119,
		-1,
		-1,
		-1,
		149,
		141,
		141,
		-1,
		-1,
		156,
		139,
		120,
		118,
		-1,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		146,
		-1,
		-1,
		152,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		160,
		-1,
		-1,
		-1,
		142,
		138,
		139,
		-1,
		-1,
		-1,
		-1,
		181,
		182,
		206,
		181,
		-1,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		184,
		182,
		-1,
		-1,
		-1,
		162,
		146,
		-1,
		132,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		167,
		-1,
		167,
		142,
		149,
		-1,
		-1,
		-1,
		-1,
		180,
		172,
		180,
		-1,
		152,
		154,
		-1,
		202,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		157,
		164,
		186,
		189,
		225,
		-1,
		176
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		258,
		247,
		258,
		266,
		239,
		246,
		-1,
		265,
		269,
		235,
		229,
		268,
		237,
		243,
		254,
		-1,
		-1,
		-1,
		258,
		257,
		225,
		223,
		232,
		237,
		244,
		-1,
		243,
		-1,
		279,
		258,
		269,
		274,
		218,
		215,
		235,
		254,
		236,
		228,
		294,
		248,
		219,
		213,
		231,
		221,
		230,
		222,
		-1,
		219,
		209,
		231,
		210,
		221,
		213,
		-1,
		-1,
		213,
		214,
		220,
		206,
		212,
		208,
		-1,
		218,
		202,
		-1,
		-1,
		203,
		204,
		188,
		191,
		199,
		197,
		210,
		202,
		197,
		-1,
		-1,
		194,
		190,
		197,
		184,
		180,
		197,
		210,
		192,
		206,
		205,
		-1,
		198,
		216,
		223,
		191,
		189,
		173,
		171,
		189,
		191,
		197,
		197,
		-1,
		207,
		208,
		203,
		211,
		213,
		189,
		176,
		176,
		186,
		179,
		198,
		186,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		207,
		190,
		207,
		199,
		189,
		204,
		197,
		179,
		176,
		174,
		171,
		187,
		185,
		195,
		-1,
		-1,
		300,
		269,
		298,
		256,
		237,
		-1,
		203,
		183,
		189,
		193,
		187,
		180,
		194,
		190,
		-1,
		165,
		164,
		192,
		178,
		189,
		260,
		-1,
		-1,
		258,
		250,
		233,
		236,
		213,
		209,
		198,
		197,
		189,
		175,
		171,
		177,
		180,
		180,
		186,
		159,
		169,
		173,
		171,
		196,
		-1,
		-1,
		231,
		-1,
		-1,
		257,
		240,
		-1,
		223,
		230,
		219,
		225,
		211,
		232,
		208,
		199,
		191,
		185,
		173,
		175,
		172,
		185,
		173,
		156,
		181,
		185,
		166,
		187,
		182,
		-1,
		230,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		216,
		219,
		225,
		249,
		248,
		-1,
		220,
		208,
		209,
		194,
		191,
		178,
		166,
		179,
		164,
		171,
		170,
		160,
		158,
		188,
		163,
		185,
		182,
		201,
		206,
		200,
		209,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		253,
		-1,
		256,
		257,
		232,
		205,
		208,
		195,
		186,
		173,
		162,
		173,
		162,
		159,
		167,
		152,
		167,
		158,
		157,
		175,
		185,
		193,
		197,
		203,
		-1,
		315,
		-1,
		257,
		241,
		243,
		215,
		236,
		-1,
		273,
		257,
		249,
		234,
		234,
		-1,
		204,
		201,
		191,
		169,
		154,
		171,
		163,
		161,
		165,
		147,
		161,
		152,
		170,
		177,
		175,
		179,
		199,
		211,
		275,
		265,
		-1,
		247,
		252,
		211,
		219,
		238,
		276,
		240,
		-1,
		235,
		-1,
		206,
		219,
		-1,
		175,
		171,
		153,
		154,
		149,
		164,
		158,
		143,
		140,
		158,
		161,
		168,
		172,
		188,
		-1,
		-1,
		260,
		264,
		253,
		204,
		223,
		247,
		284,
		233,
		222,
		221,
		-1,
		212,
		189,
		186,
		174,
		161,
		146,
		147,
		155,
		168,
		147,
		142,
		139,
		159,
		185,
		163,
		175,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		230,
		201,
		225,
		267,
		251,
		244,
		232,
		197,
		197,
		191,
		-1,
		185,
		164,
		155,
		144,
		142,
		155,
		152,
		157,
		137,
		135,
		154,
		166,
		157,
		174,
		-1,
		-1,
		-1,
		260,
		249,
		250,
		196,
		219,
		256,
		230,
		216,
		221,
		196,
		189,
		183,
		198,
		181,
		162,
		151,
		143,
		132,
		148,
		156,
		151,
		133,
		142,
		148,
		172,
		162,
		168,
		-1,
		-1,
		267,
		257,
		241,
		243,
		240,
		210,
		217,
		249,
		221,
		234,
		-1,
		188,
		-1,
		177,
		172,
		156,
		151,
		148,
		145,
		139,
		148,
		150,
		140,
		135,
		142,
		177,
		177,
		152,
		172,
		175,
		-1,
		-1,
		-1,
		260,
		255,
		230,
		207,
		191,
		227,
		-1,
		204,
		205,
		-1,
		182,
		176,
		173,
		158,
		154,
		149,
		153,
		146,
		153,
		146,
		144,
		145,
		127,
		159,
		-1,
		160,
		154,
		162,
		152,
		140,
		-1,
		-1,
		-1,
		253,
		232,
		225,
		245,
		186,
		238,
		-1,
		-1,
		189,
		182,
		-1,
		169,
		151,
		158,
		156,
		150,
		154,
		151,
		140,
		153,
		146,
		132,
		134,
		147,
		151,
		155,
		142,
		138,
		135,
		149,
		-1,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		206,
		-1,
		198,
		190,
		180,
		174,
		168,
		164,
		162,
		178,
		162,
		165,
		163,
		154,
		162,
		135,
		128,
		135,
		124,
		142,
		150,
		142,
		136,
		135,
		145,
		-1,
		273,
		259,
		230,
		-1,
		-1,
		219,
		-1,
		183,
		197,
		213,
		-1,
		206,
		185,
		200,
		178,
		174,
		170,
		185,
		186,
		164,
		163,
		161,
		152,
		140,
		129,
		132,
		124,
		146,
		146,
		130,
		131,
		135,
		-1,
		279,
		266,
		224,
		220,
		209,
		229,
		180,
		168,
		200,
		-1,
		-1,
		242,
		-1,
		176,
		193,
		184,
		182,
		175,
		160,
		167,
		172,
		149,
		144,
		134,
		123,
		123,
		118,
		140,
		126,
		124,
		133,
		149,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		195,
		182,
		176,
		-1,
		217,
		-1,
		220,
		210,
		194,
		179,
		212,
		-1,
		159,
		155,
		162,
		-1,
		169,
		-1,
		142,
		139,
		130,
		115,
		112,
		123,
		121,
		132,
		128,
		-1,
		229,
		214,
		207,
		197,
		211,
		182,
		-1,
		237,
		-1,
		-1,
		207,
		201,
		201,
		185,
		188,
		175,
		155,
		147,
		162,
		161,
		148,
		147,
		128,
		121,
		118,
		111,
		124,
		134,
		139,
		126,
		-1,
		-1,
		-1,
		234,
		220,
		224,
		184,
		203,
		-1,
		-1,
		269,
		224,
		210,
		-1,
		184,
		175,
		163,
		153,
		143,
		148,
		149,
		139,
		137,
		126,
		128,
		122,
		113,
		112,
		128,
		120,
		142,
		-1,
		-1,
		217,
		222,
		210,
		196,
		215,
		-1,
		-1,
		-1,
		216,
		232,
		203,
		182,
		164,
		-1,
		-1,
		147,
		140,
		134,
		137,
		125,
		142,
		137,
		121,
		106,
		121,
		125,
		133,
		124,
		-1,
		220,
		207,
		-1,
		-1,
		218,
		212,
		-1,
		-1,
		-1,
		-1,
		215,
		160,
		149,
		144,
		148,
		146,
		-1,
		120,
		131,
		124,
		143,
		150,
		123,
		108,
		102,
		108,
		120,
		129,
		-1,
		-1,
		232,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		172,
		166,
		137,
		130,
		134,
		-1,
		122,
		124,
		121,
		133,
		126,
		123,
		114,
		105,
		101,
		105,
		109,
		123,
		127,
		255,
		-1,
		192,
		-1,
		-1,
		-1,
		190,
		205,
		176,
		153,
		126,
		121,
		114,
		108,
		113,
		124,
		133,
		144,
		109,
		108,
		98,
		97,
		101,
		118,
		122,
		-1,
		-1,
		190,
		186,
		216,
		198,
		197,
		203,
		-1,
		-1,
		130,
		121,
		112,
		104,
		117,
		120,
		105,
		107,
		107,
		102,
		96,
		106,
		121,
		116,
		-1,
		-1,
		-1,
		202,
		-1,
		204,
		-1,
		-1,
		187,
		201,
		148,
		130,
		126,
		124,
		111,
		105,
		95,
		100,
		110,
		104,
		101,
		92,
		96,
		119,
		108,
		147,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		181,
		173,
		167,
		170,
		171,
		162,
		163,
		160,
		-1,
		124,
		134,
		101,
		108,
		91,
		98,
		103,
		100,
		86,
		93,
		109,
		108,
		103,
		139,
		130,
		136,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		174,
		170,
		156,
		146,
		148,
		-1,
		-1,
		141,
		138,
		125,
		94,
		99,
		92,
		87,
		92,
		73,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		222,
		259,
		252,
		220,
		228,
		259,
		-1,
		164,
		156,
		166,
		142,
		139,
		-1,
		-1,
		114,
		112,
		113,
		101,
		98,
		111,
		110,
		77,
		82,
		100,
		87,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		215,
		235,
		214,
		217,
		241,
		255,
		-1,
		161,
		-1,
		-1,
		173,
		140,
		124,
		118,
		113,
		160,
		107,
		102,
		79,
		77,
		74,
		65,
		103,
		82,
		94,
		97,
		113,
		118,
		110,
		126,
		126,
		127,
		-1,
		204,
		215,
		208,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		163,
		-1,
		151,
		-1,
		86,
		115,
		115,
		118,
		93,
		80,
		66,
		74,
		80,
		80,
		85,
		88,
		100,
		109,
		120,
		132,
		133,
		134,
		229,
		185,
		188,
		199,
		210,
		225,
		229,
		-1,
		173,
		212,
		169,
		-1,
		153,
		-1,
		-1,
		-1,
		68,
		128,
		120,
		113,
		92,
		92,
		58,
		62,
		75,
		82,
		92,
		106,
		103,
		113,
		126,
		137,
		142,
		225,
		216,
		229,
		174,
		174,
		195,
		204,
		225,
		188,
		179,
		206,
		176,
		165,
		160,
		147,
		-1,
		-1,
		46,
		138,
		-1,
		-1,
		99,
		66,
		54,
		64,
		68,
		82,
		94,
		107,
		95,
		114,
		108,
		140,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		165,
		192,
		-1,
		-1,
		187,
		207,
		198,
		202,
		207,
		232,
		-1,
		136,
		-1,
		-1,
		26,
		-1,
		-1,
		46,
		71,
		60,
		51,
		56,
		76,
		87,
		109,
		91,
		108,
		113,
		123,
		136,
		202,
		199,
		187,
		185,
		208,
		173,
		161,
		-1,
		174,
		172,
		178,
		185,
		202,
		221,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		9,
		7,
		31,
		-1,
		57,
		48,
		53,
		83,
		85,
		87,
		94,
		88,
		95,
		121,
		133,
		135,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		159,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		0,
		12,
		19,
		30,
		43,
		53,
		70,
		70,
		73,
		78,
		86,
		97,
		111,
		115,
		129,
		-1,
		245,
		-1,
		197,
		173,
		187,
		202,
		210,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		53,
		37,
		18,
		-1,
		53,
		66,
		106,
		74,
		79,
		74,
		92,
		103,
		114,
		117,
		122,
		125,
		-1,
		-1,
		185,
		175,
		-1,
		-1,
		149,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		25,
		21,
		-1,
		-1,
		54,
		88,
		77,
		85,
		80,
		92,
		102,
		100,
		112,
		120,
		119,
		-1,
		-1,
		170,
		162,
		156,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		92,
		55,
		76,
		95,
		100,
		98,
		89,
		88,
		95,
		105,
		113,
		119,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		91,
		-1,
		59,
		56,
		97,
		94,
		111,
		105,
		91,
		106,
		102,
		111,
		109,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		88,
		67,
		-1,
		101,
		91,
		128,
		114,
		102,
		89,
		96,
		110,
		106,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		81,
		81,
		72,
		80,
		118,
		114,
		107,
		109,
		101,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		76,
		84,
		82,
		79,
		91,
		87,
		107,
		102,
		135,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		110,
		94,
		92,
		97,
		102,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		103,
		99,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		247,
		236,
		247,
		255,
		228,
		235,
		-1,
		254,
		258,
		224,
		218,
		257,
		226,
		232,
		243,
		-1,
		-1,
		-1,
		247,
		246,
		214,
		212,
		221,
		226,
		233,
		-1,
		232,
		-1,
		268,
		247,
		258,
		263,
		207,
		204,
		224,
		243,
		225,
		217,
		283,
		237,
		208,
		202,
		220,
		210,
		219,
		211,
		-1,
		208,
		198,
		220,
		199,
		210,
		202,
		-1,
		-1,
		202,
		203,
		209,
		195,
		201,
		197,
		-1,
		207,
		191,
		-1,
		-1,
		192,
		193,
		177,
		180,
		188,
		186,
		199,
		191,
		186,
		-1,
		-1,
		183,
		179,
		186,
		173,
		169,
		186,
		199,
		181,
		195,
		194,
		-1,
		187,
		205,
		212,
		180,
		178,
		162,
		160,
		178,
		180,
		186,
		186,
		-1,
		196,
		197,
		192,
		200,
		202,
		178,
		165,
		165,
		175,
		168,
		187,
		175,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		196,
		179,
		196,
		188,
		178,
		193,
		186,
		168,
		165,
		163,
		160,
		176,
		174,
		184,
		-1,
		-1,
		289,
		258,
		287,
		245,
		226,
		-1,
		192,
		172,
		178,
		182,
		176,
		169,
		183,
		179,
		-1,
		154,
		153,
		181,
		167,
		178,
		249,
		-1,
		-1,
		247,
		239,
		222,
		225,
		202,
		198,
		187,
		186,
		178,
		164,
		160,
		166,
		169,
		169,
		175,
		148,
		158,
		162,
		160,
		185,
		-1,
		-1,
		220,
		-1,
		-1,
		246,
		229,
		-1,
		212,
		219,
		208,
		214,
		200,
		221,
		197,
		188,
		180,
		174,
		162,
		164,
		161,
		174,
		162,
		145,
		170,
		174,
		155,
		176,
		171,
		-1,
		219,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		205,
		208,
		214,
		238,
		237,
		-1,
		209,
		197,
		198,
		183,
		180,
		167,
		155,
		168,
		153,
		160,
		159,
		149,
		147,
		177,
		152,
		174,
		171,
		190,
		195,
		189,
		198,
		-1,
		254,
		250,
		246,
		253,
		202,
		-1,
		-1,
		242,
		-1,
		245,
		246,
		221,
		194,
		197,
		184,
		175,
		162,
		151,
		162,
		151,
		148,
		156,
		141,
		156,
		147,
		146,
		164,
		174,
		182,
		186,
		192,
		-1,
		304,
		-1,
		246,
		230,
		232,
		204,
		225,
		-1,
		262,
		246,
		238,
		223,
		223,
		-1,
		193,
		190,
		180,
		158,
		143,
		160,
		152,
		150,
		154,
		136,
		150,
		141,
		159,
		166,
		164,
		168,
		188,
		200,
		264,
		254,
		-1,
		236,
		241,
		200,
		208,
		227,
		265,
		229,
		-1,
		224,
		-1,
		195,
		208,
		-1,
		164,
		160,
		142,
		143,
		138,
		153,
		147,
		132,
		129,
		147,
		150,
		157,
		161,
		177,
		-1,
		-1,
		249,
		253,
		242,
		193,
		212,
		236,
		273,
		222,
		211,
		210,
		-1,
		201,
		178,
		175,
		163,
		150,
		135,
		136,
		144,
		157,
		136,
		131,
		128,
		148,
		174,
		152,
		164,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		219,
		190,
		214,
		256,
		240,
		233,
		221,
		186,
		186,
		180,
		-1,
		174,
		153,
		144,
		133,
		131,
		144,
		141,
		146,
		126,
		124,
		143,
		155,
		146,
		163,
		-1,
		-1,
		-1,
		249,
		238,
		239,
		185,
		208,
		245,
		219,
		205,
		210,
		185,
		178,
		172,
		187,
		170,
		151,
		140,
		132,
		121,
		137,
		145,
		140,
		122,
		131,
		137,
		161,
		151,
		157,
		-1,
		-1,
		256,
		246,
		230,
		232,
		229,
		199,
		206,
		238,
		210,
		223,
		-1,
		177,
		-1,
		166,
		161,
		145,
		140,
		137,
		134,
		128,
		137,
		139,
		129,
		124,
		131,
		166,
		166,
		141,
		161,
		164,
		-1,
		-1,
		-1,
		249,
		244,
		219,
		196,
		180,
		216,
		-1,
		193,
		194,
		-1,
		171,
		165,
		162,
		147,
		143,
		138,
		142,
		135,
		142,
		135,
		133,
		134,
		116,
		148,
		-1,
		149,
		143,
		151,
		141,
		129,
		-1,
		-1,
		-1,
		242,
		221,
		214,
		234,
		175,
		227,
		-1,
		-1,
		178,
		171,
		-1,
		158,
		140,
		147,
		145,
		139,
		143,
		140,
		129,
		142,
		135,
		121,
		123,
		136,
		140,
		144,
		131,
		127,
		124,
		138,
		-1,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		195,
		-1,
		187,
		179,
		169,
		163,
		157,
		153,
		151,
		167,
		151,
		154,
		152,
		143,
		151,
		124,
		117,
		124,
		113,
		131,
		139,
		131,
		125,
		124,
		134,
		-1,
		262,
		248,
		219,
		-1,
		-1,
		208,
		-1,
		172,
		186,
		202,
		-1,
		195,
		174,
		189,
		167,
		163,
		159,
		174,
		175,
		153,
		152,
		150,
		141,
		129,
		118,
		121,
		113,
		135,
		135,
		119,
		120,
		124,
		-1,
		268,
		255,
		213,
		209,
		198,
		218,
		169,
		157,
		189,
		-1,
		-1,
		231,
		-1,
		165,
		182,
		173,
		171,
		164,
		149,
		156,
		161,
		138,
		133,
		123,
		112,
		112,
		107,
		129,
		115,
		113,
		122,
		138,
		-1,
		-1,
		-1,
		235,
		-1,
		-1,
		184,
		171,
		165,
		-1,
		206,
		-1,
		209,
		199,
		183,
		168,
		201,
		-1,
		148,
		144,
		151,
		-1,
		158,
		-1,
		131,
		128,
		119,
		104,
		101,
		112,
		110,
		121,
		117,
		-1,
		218,
		203,
		196,
		186,
		200,
		171,
		-1,
		226,
		-1,
		-1,
		196,
		190,
		190,
		174,
		177,
		164,
		144,
		136,
		151,
		150,
		137,
		136,
		117,
		110,
		107,
		100,
		113,
		123,
		128,
		115,
		-1,
		-1,
		-1,
		223,
		209,
		213,
		173,
		192,
		-1,
		-1,
		258,
		213,
		199,
		-1,
		173,
		164,
		152,
		142,
		132,
		137,
		138,
		128,
		126,
		115,
		117,
		111,
		102,
		101,
		117,
		109,
		131,
		-1,
		-1,
		206,
		211,
		199,
		185,
		204,
		-1,
		-1,
		-1,
		205,
		221,
		192,
		171,
		153,
		-1,
		-1,
		136,
		129,
		123,
		126,
		114,
		131,
		126,
		110,
		95,
		110,
		114,
		122,
		113,
		-1,
		209,
		196,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		-1,
		-1,
		204,
		149,
		138,
		133,
		137,
		135,
		-1,
		109,
		120,
		113,
		132,
		139,
		112,
		97,
		91,
		97,
		109,
		118,
		-1,
		-1,
		221,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		161,
		155,
		126,
		119,
		123,
		-1,
		111,
		113,
		110,
		122,
		115,
		112,
		103,
		94,
		90,
		94,
		98,
		112,
		116,
		244,
		-1,
		182,
		-1,
		-1,
		-1,
		179,
		194,
		165,
		142,
		115,
		110,
		103,
		97,
		102,
		113,
		122,
		133,
		98,
		97,
		87,
		86,
		90,
		107,
		111,
		-1,
		-1,
		180,
		176,
		205,
		187,
		191,
		192,
		-1,
		-1,
		119,
		110,
		101,
		93,
		106,
		109,
		94,
		96,
		96,
		91,
		85,
		95,
		110,
		105,
		-1,
		-1,
		-1,
		192,
		-1,
		194,
		-1,
		-1,
		182,
		190,
		137,
		119,
		115,
		113,
		100,
		94,
		84,
		89,
		99,
		93,
		90,
		81,
		85,
		108,
		97,
		136,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		152,
		149,
		-1,
		119,
		123,
		90,
		97,
		80,
		87,
		92,
		89,
		75,
		82,
		98,
		97,
		92,
		128,
		119,
		125,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		137,
		134,
		114,
		83,
		88,
		81,
		76,
		81,
		62,
		71,
		75,
		79,
		85,
		90,
		95,
		101,
		116,
		131,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		110,
		101,
		102,
		90,
		87,
		100,
		99,
		66,
		71,
		89,
		76,
		77,
		95,
		99,
		108,
		115,
		105,
		118,
		122,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		151,
		-1,
		-1,
		162,
		135,
		119,
		109,
		106,
		149,
		96,
		91,
		68,
		66,
		63,
		54,
		92,
		71,
		83,
		86,
		102,
		107,
		99,
		115,
		115,
		116,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		152,
		-1,
		146,
		-1,
		93,
		122,
		104,
		107,
		82,
		69,
		55,
		63,
		69,
		69,
		74,
		77,
		89,
		98,
		109,
		121,
		122,
		123,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		163,
		202,
		158,
		-1,
		142,
		-1,
		-1,
		-1,
		75,
		117,
		109,
		102,
		81,
		81,
		47,
		51,
		64,
		71,
		81,
		95,
		92,
		102,
		115,
		126,
		131,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		169,
		196,
		165,
		154,
		149,
		136,
		-1,
		-1,
		53,
		127,
		-1,
		-1,
		88,
		55,
		43,
		53,
		57,
		71,
		83,
		96,
		84,
		103,
		97,
		129,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		197,
		187,
		191,
		196,
		221,
		-1,
		125,
		-1,
		-1,
		33,
		-1,
		-1,
		36,
		60,
		49,
		40,
		45,
		65,
		76,
		98,
		80,
		97,
		102,
		112,
		125,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		191,
		210,
		-1,
		-1,
		141,
		121,
		-1,
		-1,
		16,
		13,
		21,
		-1,
		46,
		37,
		42,
		72,
		74,
		76,
		83,
		77,
		84,
		110,
		122,
		124,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		131,
		127,
		-1,
		-1,
		11,
		0,
		8,
		19,
		32,
		42,
		59,
		59,
		62,
		67,
		75,
		86,
		100,
		104,
		118,
		-1,
		234,
		-1,
		186,
		162,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		148,
		134,
		127,
		115,
		113,
		-1,
		43,
		27,
		8,
		-1,
		42,
		55,
		95,
		63,
		68,
		63,
		81,
		92,
		103,
		106,
		111,
		114,
		-1,
		-1,
		174,
		164,
		-1,
		-1,
		138,
		140,
		-1,
		139,
		128,
		113,
		105,
		-1,
		-1,
		15,
		11,
		-1,
		-1,
		43,
		77,
		66,
		74,
		69,
		81,
		91,
		89,
		101,
		109,
		108,
		-1,
		-1,
		159,
		151,
		145,
		-1,
		123,
		-1,
		141,
		-1,
		108,
		114,
		102,
		-1,
		-1,
		-1,
		81,
		44,
		65,
		84,
		89,
		87,
		78,
		77,
		84,
		94,
		102,
		108,
		-1,
		-1,
		-1,
		141,
		115,
		148,
		139,
		122,
		102,
		94,
		113,
		-1,
		80,
		-1,
		48,
		45,
		86,
		83,
		100,
		94,
		80,
		95,
		91,
		100,
		98,
		147,
		-1,
		117,
		150,
		114,
		108,
		84,
		88,
		104,
		-1,
		77,
		56,
		-1,
		90,
		80,
		117,
		103,
		91,
		78,
		85,
		99,
		95,
		-1,
		-1,
		-1,
		119,
		118,
		110,
		104,
		104,
		89,
		80,
		-1,
		92,
		74,
		53,
		70,
		70,
		61,
		69,
		107,
		103,
		96,
		98,
		90,
		-1,
		220,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		113,
		108,
		81,
		69,
		75,
		71,
		57,
		63,
		65,
		73,
		71,
		68,
		80,
		76,
		96,
		91,
		124,
		-1,
		215,
		-1,
		149,
		-1,
		-1,
		131,
		111,
		103,
		92,
		81,
		79,
		70,
		61,
		83,
		99,
		83,
		81,
		86,
		91,
		-1,
		204,
		203,
		-1,
		150,
		142,
		128,
		-1,
		121,
		-1,
		127,
		88,
		-1,
		90,
		70,
		-1,
		92,
		88,
		-1,
		-1,
		191,
		166,
		-1,
		-1,
		-1,
		151,
		131,
		122,
		106,
		-1,
		81,
		81,
		-1,
		-1,
		-1,
		176,
		175,
		-1,
		144,
		147,
		-1,
		137,
		128,
		136,
		83,
		87,
		-1,
		-1,
		-1,
		185,
		166,
		160,
		159,
		157,
		152,
		149,
		135,
		119,
		97,
		86,
		107,
		-1,
		-1,
		-1,
		157,
		149,
		142,
		-1,
		-1,
		144,
		127,
		108,
		106,
		-1,
		-1,
		-1,
		179,
		160,
		-1,
		-1,
		134,
		-1,
		-1,
		140,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		168,
		-1,
		-1,
		-1,
		130,
		126,
		127,
		-1,
		-1,
		-1,
		-1,
		190,
		191,
		214,
		178,
		-1,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		193,
		191,
		-1,
		-1,
		-1,
		150,
		134,
		-1,
		120,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		155,
		-1,
		155,
		130,
		137,
		-1,
		-1,
		-1,
		-1,
		168,
		160,
		168,
		-1,
		140,
		142,
		-1,
		190,
		-1,
		-1,
		183,
		174,
		-1,
		-1,
		145,
		152,
		174,
		177,
		213,
		-1,
		164
	],
	[
		-1,
		239,
		228,
		239,
		247,
		220,
		227,
		-1,
		246,
		250,
		216,
		210,
		249,
		218,
		224,
		235,
		-1,
		-1,
		-1,
		239,
		238,
		206,
		204,
		213,
		218,
		225,
		-1,
		224,
		-1,
		260,
		239,
		250,
		255,
		199,
		196,
		216,
		235,
		217,
		209,
		275,
		229,
		200,
		194,
		212,
		202,
		211,
		203,
		-1,
		200,
		190,
		212,
		191,
		202,
		194,
		-1,
		-1,
		194,
		195,
		201,
		187,
		193,
		189,
		-1,
		199,
		183,
		-1,
		-1,
		184,
		185,
		169,
		172,
		180,
		178,
		191,
		183,
		178,
		-1,
		-1,
		175,
		171,
		178,
		165,
		161,
		178,
		191,
		173,
		187,
		186,
		-1,
		179,
		197,
		204,
		172,
		170,
		154,
		152,
		170,
		172,
		178,
		178,
		-1,
		188,
		189,
		184,
		192,
		194,
		170,
		157,
		157,
		167,
		160,
		179,
		167,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		188,
		171,
		188,
		180,
		170,
		185,
		178,
		160,
		157,
		155,
		152,
		168,
		166,
		176,
		-1,
		-1,
		281,
		250,
		279,
		237,
		218,
		-1,
		184,
		164,
		170,
		174,
		168,
		161,
		175,
		171,
		-1,
		146,
		145,
		173,
		159,
		170,
		241,
		-1,
		-1,
		239,
		231,
		214,
		217,
		194,
		190,
		179,
		178,
		170,
		156,
		152,
		158,
		161,
		161,
		167,
		140,
		150,
		154,
		152,
		177,
		-1,
		-1,
		212,
		-1,
		-1,
		238,
		221,
		-1,
		204,
		211,
		200,
		206,
		192,
		213,
		189,
		180,
		172,
		166,
		154,
		156,
		153,
		166,
		154,
		137,
		162,
		166,
		147,
		168,
		163,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		197,
		200,
		206,
		230,
		229,
		-1,
		201,
		189,
		190,
		175,
		172,
		159,
		147,
		160,
		145,
		152,
		151,
		141,
		139,
		169,
		144,
		166,
		163,
		182,
		187,
		181,
		190,
		-1,
		246,
		242,
		238,
		245,
		194,
		-1,
		-1,
		234,
		-1,
		237,
		238,
		213,
		186,
		189,
		176,
		167,
		154,
		143,
		154,
		143,
		140,
		148,
		133,
		148,
		139,
		138,
		156,
		166,
		174,
		178,
		184,
		-1,
		296,
		-1,
		238,
		222,
		224,
		196,
		217,
		-1,
		254,
		238,
		230,
		215,
		215,
		-1,
		185,
		182,
		172,
		150,
		135,
		152,
		144,
		142,
		146,
		128,
		142,
		133,
		151,
		158,
		156,
		160,
		180,
		192,
		256,
		246,
		-1,
		228,
		233,
		192,
		200,
		219,
		257,
		221,
		-1,
		216,
		-1,
		187,
		200,
		-1,
		156,
		152,
		134,
		135,
		130,
		145,
		139,
		124,
		121,
		139,
		142,
		149,
		153,
		169,
		-1,
		-1,
		241,
		245,
		234,
		185,
		204,
		228,
		265,
		214,
		203,
		202,
		-1,
		193,
		170,
		167,
		155,
		142,
		127,
		128,
		136,
		149,
		128,
		123,
		120,
		140,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		211,
		182,
		206,
		248,
		232,
		225,
		213,
		178,
		178,
		172,
		-1,
		166,
		145,
		136,
		125,
		123,
		136,
		133,
		138,
		118,
		116,
		135,
		147,
		138,
		155,
		-1,
		-1,
		-1,
		241,
		230,
		231,
		177,
		200,
		237,
		211,
		197,
		202,
		177,
		170,
		164,
		179,
		162,
		143,
		132,
		124,
		113,
		129,
		137,
		132,
		114,
		123,
		129,
		153,
		143,
		149,
		-1,
		-1,
		248,
		238,
		222,
		224,
		221,
		191,
		198,
		230,
		202,
		215,
		-1,
		169,
		-1,
		158,
		153,
		137,
		132,
		129,
		126,
		120,
		129,
		131,
		121,
		116,
		123,
		158,
		158,
		133,
		153,
		156,
		-1,
		-1,
		-1,
		241,
		236,
		211,
		188,
		172,
		208,
		-1,
		185,
		186,
		-1,
		163,
		157,
		154,
		139,
		135,
		130,
		134,
		127,
		134,
		127,
		125,
		126,
		108,
		140,
		-1,
		141,
		135,
		143,
		133,
		121,
		-1,
		-1,
		-1,
		234,
		213,
		206,
		226,
		167,
		219,
		-1,
		-1,
		170,
		163,
		-1,
		150,
		132,
		139,
		137,
		131,
		135,
		132,
		121,
		134,
		127,
		113,
		115,
		128,
		132,
		136,
		123,
		119,
		116,
		130,
		-1,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		187,
		-1,
		179,
		171,
		161,
		155,
		149,
		145,
		143,
		159,
		143,
		146,
		144,
		135,
		143,
		116,
		109,
		116,
		105,
		123,
		131,
		123,
		117,
		116,
		126,
		-1,
		254,
		240,
		211,
		-1,
		-1,
		200,
		-1,
		164,
		178,
		194,
		-1,
		187,
		166,
		181,
		159,
		155,
		151,
		166,
		167,
		145,
		144,
		142,
		133,
		121,
		110,
		113,
		105,
		127,
		127,
		111,
		112,
		116,
		-1,
		260,
		247,
		205,
		201,
		190,
		210,
		161,
		149,
		181,
		-1,
		-1,
		223,
		-1,
		157,
		174,
		165,
		163,
		156,
		141,
		148,
		153,
		130,
		125,
		115,
		104,
		104,
		99,
		121,
		107,
		105,
		114,
		130,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		176,
		163,
		157,
		-1,
		198,
		-1,
		201,
		191,
		175,
		160,
		193,
		-1,
		140,
		136,
		143,
		-1,
		150,
		-1,
		123,
		120,
		111,
		96,
		93,
		104,
		102,
		113,
		109,
		-1,
		210,
		195,
		188,
		178,
		192,
		163,
		-1,
		218,
		-1,
		-1,
		188,
		182,
		182,
		166,
		169,
		156,
		136,
		128,
		143,
		142,
		129,
		128,
		109,
		102,
		99,
		92,
		105,
		115,
		120,
		107,
		-1,
		-1,
		-1,
		215,
		201,
		205,
		165,
		184,
		-1,
		-1,
		250,
		205,
		191,
		-1,
		165,
		156,
		144,
		134,
		124,
		129,
		130,
		120,
		118,
		107,
		109,
		103,
		94,
		93,
		109,
		101,
		123,
		-1,
		-1,
		198,
		203,
		191,
		177,
		196,
		-1,
		-1,
		-1,
		197,
		213,
		184,
		163,
		145,
		-1,
		-1,
		128,
		121,
		115,
		118,
		106,
		123,
		118,
		102,
		87,
		102,
		106,
		114,
		105,
		-1,
		201,
		188,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		105,
		124,
		131,
		104,
		89,
		83,
		89,
		101,
		110,
		-1,
		-1,
		213,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		102,
		114,
		107,
		104,
		95,
		86,
		82,
		86,
		90,
		104,
		108,
		236,
		-1,
		174,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		114,
		125,
		90,
		89,
		79,
		78,
		82,
		99,
		103,
		-1,
		-1,
		172,
		168,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		86,
		88,
		88,
		83,
		77,
		87,
		102,
		97,
		-1,
		-1,
		-1,
		184,
		-1,
		186,
		-1,
		-1,
		174,
		182,
		129,
		111,
		107,
		105,
		92,
		86,
		76,
		81,
		91,
		85,
		82,
		73,
		77,
		100,
		89,
		128,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		163,
		155,
		150,
		156,
		158,
		149,
		144,
		141,
		-1,
		111,
		115,
		82,
		89,
		72,
		79,
		84,
		81,
		67,
		74,
		90,
		89,
		84,
		120,
		111,
		117,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		156,
		152,
		142,
		132,
		135,
		-1,
		-1,
		129,
		126,
		106,
		75,
		80,
		73,
		68,
		73,
		54,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		203,
		240,
		233,
		201,
		209,
		240,
		-1,
		146,
		138,
		149,
		124,
		126,
		-1,
		-1,
		102,
		93,
		94,
		82,
		79,
		92,
		91,
		58,
		63,
		81,
		68,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		196,
		216,
		195,
		198,
		222,
		236,
		-1,
		143,
		-1,
		-1,
		154,
		127,
		111,
		101,
		98,
		141,
		88,
		83,
		60,
		58,
		55,
		46,
		84,
		63,
		75,
		78,
		94,
		99,
		91,
		107,
		107,
		108,
		-1,
		185,
		196,
		189,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		144,
		-1,
		138,
		-1,
		101,
		125,
		96,
		99,
		74,
		61,
		47,
		55,
		61,
		61,
		66,
		69,
		81,
		90,
		101,
		113,
		114,
		115,
		210,
		166,
		169,
		180,
		191,
		206,
		210,
		-1,
		155,
		194,
		150,
		-1,
		134,
		-1,
		-1,
		-1,
		83,
		109,
		101,
		94,
		73,
		73,
		39,
		43,
		56,
		63,
		73,
		87,
		84,
		94,
		107,
		118,
		123,
		206,
		197,
		210,
		155,
		155,
		176,
		185,
		206,
		170,
		161,
		188,
		157,
		146,
		141,
		128,
		-1,
		-1,
		61,
		119,
		-1,
		-1,
		80,
		47,
		35,
		45,
		49,
		63,
		75,
		88,
		76,
		95,
		89,
		121,
		-1,
		199,
		198,
		187,
		184,
		160,
		151,
		146,
		173,
		-1,
		-1,
		168,
		189,
		179,
		183,
		188,
		213,
		-1,
		117,
		-1,
		-1,
		41,
		-1,
		-1,
		29,
		52,
		41,
		32,
		37,
		57,
		68,
		90,
		72,
		89,
		94,
		104,
		117,
		183,
		180,
		168,
		166,
		189,
		154,
		142,
		-1,
		155,
		153,
		159,
		166,
		183,
		202,
		-1,
		-1,
		133,
		113,
		-1,
		-1,
		24,
		22,
		14,
		-1,
		38,
		29,
		34,
		64,
		66,
		68,
		75,
		69,
		76,
		102,
		114,
		116,
		192,
		206,
		195,
		191,
		190,
		198,
		147,
		140,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		123,
		119,
		-1,
		-1,
		19,
		12,
		0,
		11,
		24,
		34,
		51,
		51,
		54,
		59,
		67,
		78,
		92,
		96,
		110,
		-1,
		226,
		-1,
		178,
		154,
		168,
		183,
		191,
		-1,
		-1,
		-1,
		140,
		126,
		119,
		107,
		105,
		-1,
		53,
		37,
		18,
		-1,
		34,
		47,
		87,
		55,
		60,
		55,
		73,
		84,
		95,
		98,
		103,
		106,
		-1,
		-1,
		166,
		156,
		-1,
		-1,
		130,
		132,
		-1,
		131,
		120,
		105,
		97,
		-1,
		-1,
		25,
		21,
		-1,
		-1,
		35,
		69,
		58,
		66,
		61,
		73,
		83,
		81,
		93,
		101,
		100,
		-1,
		-1,
		151,
		143,
		137,
		-1,
		115,
		-1,
		133,
		-1,
		100,
		106,
		94,
		-1,
		-1,
		-1,
		73,
		36,
		57,
		76,
		81,
		79,
		70,
		69,
		76,
		86,
		94,
		100,
		-1,
		-1,
		-1,
		133,
		107,
		140,
		131,
		114,
		94,
		86,
		105,
		-1,
		72,
		-1,
		40,
		37,
		78,
		75,
		92,
		86,
		72,
		87,
		83,
		92,
		90,
		139,
		-1,
		109,
		142,
		106,
		100,
		76,
		80,
		96,
		-1,
		69,
		48,
		-1,
		82,
		72,
		109,
		95,
		83,
		70,
		77,
		91,
		87,
		-1,
		-1,
		-1,
		111,
		110,
		102,
		96,
		96,
		81,
		72,
		-1,
		84,
		66,
		45,
		62,
		62,
		53,
		61,
		99,
		95,
		88,
		90,
		82,
		-1,
		212,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		105,
		100,
		73,
		61,
		67,
		63,
		49,
		55,
		57,
		65,
		63,
		60,
		72,
		68,
		88,
		83,
		116,
		-1,
		207,
		-1,
		141,
		-1,
		-1,
		123,
		103,
		95,
		84,
		73,
		71,
		62,
		53,
		75,
		91,
		75,
		73,
		78,
		83,
		-1,
		196,
		195,
		-1,
		142,
		134,
		120,
		-1,
		113,
		-1,
		119,
		80,
		-1,
		82,
		62,
		-1,
		84,
		80,
		-1,
		-1,
		183,
		158,
		-1,
		-1,
		-1,
		143,
		123,
		114,
		98,
		-1,
		73,
		73,
		-1,
		-1,
		-1,
		168,
		167,
		-1,
		136,
		139,
		-1,
		129,
		120,
		128,
		75,
		79,
		-1,
		-1,
		-1,
		177,
		158,
		152,
		151,
		149,
		144,
		141,
		127,
		111,
		89,
		78,
		99,
		-1,
		-1,
		-1,
		149,
		141,
		134,
		-1,
		-1,
		136,
		119,
		100,
		98,
		-1,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		126,
		-1,
		-1,
		132,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		160,
		-1,
		-1,
		-1,
		122,
		118,
		119,
		-1,
		-1,
		-1,
		-1,
		182,
		183,
		206,
		170,
		-1,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		185,
		183,
		-1,
		-1,
		-1,
		142,
		126,
		-1,
		112,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		147,
		-1,
		147,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		160,
		152,
		160,
		-1,
		132,
		134,
		-1,
		182,
		-1,
		-1,
		175,
		166,
		-1,
		-1,
		137,
		144,
		166,
		169,
		205,
		-1,
		156
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		144,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		132,
		138,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		112,
		108,
		105,
		119,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		106,
		105,
		115,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		134,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		101,
		105,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		130,
		137,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		103,
		119,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		129,
		125,
		132,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		98,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		158,
		145,
		125,
		117,
		132,
		131,
		118,
		117,
		98,
		91,
		88,
		81,
		94,
		104,
		109,
		96,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		154,
		145,
		133,
		123,
		113,
		118,
		119,
		109,
		107,
		96,
		98,
		92,
		83,
		82,
		98,
		90,
		112,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		173,
		152,
		134,
		-1,
		-1,
		117,
		110,
		104,
		107,
		95,
		112,
		107,
		91,
		76,
		91,
		95,
		103,
		94,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		185,
		130,
		119,
		114,
		118,
		116,
		-1,
		90,
		101,
		94,
		113,
		120,
		93,
		78,
		72,
		78,
		90,
		99,
		-1,
		-1,
		202,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		142,
		136,
		107,
		100,
		104,
		-1,
		92,
		94,
		91,
		103,
		96,
		93,
		84,
		75,
		71,
		75,
		79,
		93,
		97,
		225,
		-1,
		163,
		-1,
		-1,
		-1,
		160,
		175,
		146,
		123,
		96,
		91,
		84,
		78,
		83,
		94,
		103,
		114,
		79,
		78,
		68,
		67,
		71,
		88,
		92,
		-1,
		-1,
		161,
		157,
		186,
		168,
		172,
		173,
		-1,
		-1,
		100,
		91,
		82,
		74,
		87,
		90,
		75,
		77,
		77,
		72,
		66,
		76,
		91,
		86,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		171,
		118,
		100,
		96,
		94,
		81,
		75,
		65,
		70,
		80,
		74,
		71,
		62,
		66,
		89,
		78,
		117,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		133,
		130,
		-1,
		100,
		104,
		71,
		78,
		61,
		68,
		73,
		70,
		56,
		63,
		79,
		78,
		73,
		109,
		100,
		106,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		69,
		62,
		57,
		62,
		43,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		81,
		80,
		47,
		52,
		70,
		57,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		143,
		116,
		100,
		90,
		87,
		130,
		77,
		72,
		49,
		47,
		44,
		35,
		73,
		52,
		64,
		67,
		83,
		88,
		80,
		96,
		96,
		97,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		133,
		-1,
		127,
		-1,
		110,
		114,
		85,
		88,
		63,
		50,
		36,
		44,
		50,
		50,
		55,
		58,
		70,
		79,
		90,
		102,
		103,
		104,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		139,
		-1,
		123,
		-1,
		-1,
		-1,
		95,
		98,
		90,
		83,
		62,
		62,
		28,
		32,
		45,
		52,
		62,
		76,
		73,
		83,
		96,
		107,
		112,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		146,
		135,
		130,
		117,
		-1,
		-1,
		73,
		108,
		-1,
		-1,
		69,
		36,
		24,
		34,
		38,
		52,
		64,
		77,
		65,
		84,
		78,
		110,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		177,
		202,
		-1,
		106,
		-1,
		-1,
		53,
		-1,
		-1,
		38,
		41,
		30,
		21,
		26,
		46,
		57,
		79,
		61,
		78,
		83,
		93,
		106,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		191,
		-1,
		-1,
		122,
		102,
		-1,
		-1,
		36,
		34,
		23,
		-1,
		27,
		18,
		23,
		53,
		55,
		57,
		64,
		58,
		65,
		91,
		103,
		105,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		-1,
		112,
		108,
		-1,
		-1,
		31,
		24,
		12,
		0,
		13,
		23,
		40,
		40,
		43,
		48,
		56,
		67,
		81,
		85,
		99,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		129,
		115,
		108,
		96,
		94,
		-1,
		65,
		49,
		30,
		-1,
		23,
		36,
		76,
		44,
		49,
		44,
		62,
		73,
		84,
		87,
		92,
		95,
		-1,
		-1,
		155,
		145,
		-1,
		-1,
		119,
		121,
		-1,
		120,
		109,
		94,
		86,
		-1,
		-1,
		37,
		33,
		-1,
		-1,
		24,
		58,
		47,
		55,
		50,
		62,
		72,
		70,
		82,
		90,
		89,
		-1,
		-1,
		140,
		132,
		126,
		-1,
		104,
		-1,
		122,
		-1,
		89,
		95,
		83,
		-1,
		-1,
		-1,
		62,
		25,
		46,
		65,
		70,
		68,
		59,
		58,
		65,
		75,
		83,
		89,
		-1,
		-1,
		-1,
		122,
		96,
		129,
		120,
		103,
		83,
		75,
		94,
		-1,
		61,
		-1,
		29,
		26,
		67,
		64,
		81,
		75,
		61,
		76,
		72,
		81,
		79,
		128,
		-1,
		98,
		131,
		95,
		89,
		65,
		69,
		85,
		-1,
		58,
		37,
		-1,
		71,
		61,
		98,
		84,
		72,
		59,
		66,
		80,
		76,
		-1,
		-1,
		-1,
		100,
		99,
		91,
		85,
		85,
		70,
		61,
		-1,
		73,
		55,
		34,
		51,
		51,
		42,
		50,
		88,
		84,
		77,
		79,
		71,
		-1,
		201,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		94,
		89,
		62,
		50,
		56,
		52,
		38,
		44,
		46,
		54,
		52,
		49,
		61,
		57,
		77,
		72,
		105,
		-1,
		196,
		-1,
		130,
		-1,
		-1,
		112,
		92,
		84,
		73,
		62,
		60,
		51,
		42,
		64,
		80,
		64,
		62,
		67,
		72,
		-1,
		185,
		184,
		-1,
		131,
		123,
		109,
		-1,
		102,
		-1,
		108,
		69,
		-1,
		71,
		51,
		-1,
		73,
		69,
		-1,
		-1,
		172,
		147,
		-1,
		-1,
		-1,
		132,
		112,
		103,
		87,
		-1,
		62,
		62,
		-1,
		-1,
		-1,
		157,
		156,
		-1,
		125,
		128,
		-1,
		118,
		109,
		117,
		64,
		68,
		-1,
		-1,
		-1,
		166,
		147,
		141,
		140,
		138,
		133,
		130,
		116,
		100,
		78,
		67,
		88,
		-1,
		-1,
		-1,
		138,
		130,
		123,
		-1,
		-1,
		125,
		108,
		89,
		87,
		-1,
		-1,
		-1,
		160,
		141,
		-1,
		-1,
		115,
		-1,
		-1,
		121,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		149,
		-1,
		-1,
		-1,
		111,
		107,
		108,
		-1,
		-1,
		-1,
		-1,
		171,
		172,
		195,
		159,
		-1,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		174,
		172,
		-1,
		-1,
		-1,
		131,
		115,
		-1,
		101,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		136,
		-1,
		136,
		111,
		118,
		-1,
		-1,
		-1,
		-1,
		149,
		141,
		149,
		-1,
		121,
		123,
		-1,
		171,
		-1,
		-1,
		164,
		155,
		-1,
		-1,
		126,
		133,
		155,
		158,
		194,
		-1,
		145
	],
	[
		-1,
		215,
		204,
		215,
		223,
		196,
		203,
		-1,
		222,
		226,
		192,
		186,
		225,
		194,
		200,
		211,
		-1,
		-1,
		-1,
		215,
		214,
		182,
		180,
		189,
		194,
		201,
		-1,
		200,
		-1,
		236,
		215,
		226,
		231,
		175,
		172,
		192,
		211,
		193,
		185,
		251,
		205,
		176,
		170,
		188,
		178,
		187,
		179,
		-1,
		176,
		166,
		188,
		167,
		178,
		170,
		-1,
		-1,
		170,
		171,
		177,
		163,
		169,
		165,
		-1,
		175,
		159,
		-1,
		-1,
		160,
		161,
		145,
		148,
		156,
		154,
		167,
		159,
		154,
		-1,
		-1,
		151,
		147,
		154,
		141,
		137,
		154,
		167,
		149,
		163,
		162,
		-1,
		155,
		173,
		180,
		148,
		146,
		130,
		128,
		146,
		148,
		154,
		154,
		-1,
		164,
		165,
		160,
		168,
		170,
		146,
		133,
		133,
		143,
		136,
		155,
		143,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		164,
		147,
		164,
		156,
		146,
		161,
		154,
		136,
		133,
		131,
		128,
		144,
		142,
		152,
		-1,
		-1,
		257,
		226,
		255,
		213,
		194,
		-1,
		160,
		140,
		146,
		150,
		144,
		137,
		151,
		147,
		-1,
		122,
		121,
		149,
		135,
		146,
		217,
		-1,
		-1,
		215,
		207,
		190,
		193,
		170,
		166,
		155,
		154,
		146,
		132,
		128,
		134,
		137,
		137,
		143,
		116,
		126,
		130,
		128,
		153,
		-1,
		-1,
		188,
		-1,
		-1,
		214,
		197,
		-1,
		180,
		187,
		176,
		182,
		168,
		189,
		165,
		156,
		148,
		142,
		130,
		132,
		129,
		142,
		130,
		113,
		138,
		142,
		123,
		144,
		139,
		-1,
		187,
		171,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		173,
		176,
		182,
		206,
		205,
		-1,
		177,
		165,
		166,
		151,
		148,
		135,
		123,
		136,
		121,
		128,
		127,
		117,
		115,
		145,
		120,
		142,
		139,
		158,
		163,
		157,
		166,
		-1,
		222,
		218,
		214,
		221,
		170,
		-1,
		-1,
		210,
		-1,
		213,
		214,
		189,
		162,
		165,
		152,
		143,
		130,
		119,
		130,
		119,
		116,
		124,
		109,
		124,
		115,
		114,
		132,
		142,
		150,
		154,
		160,
		-1,
		272,
		-1,
		214,
		198,
		200,
		172,
		193,
		-1,
		230,
		214,
		206,
		191,
		191,
		-1,
		161,
		158,
		148,
		126,
		111,
		128,
		120,
		118,
		122,
		104,
		118,
		109,
		127,
		134,
		132,
		136,
		156,
		168,
		232,
		222,
		-1,
		204,
		209,
		168,
		176,
		195,
		233,
		197,
		-1,
		192,
		-1,
		163,
		176,
		-1,
		132,
		128,
		110,
		111,
		106,
		121,
		115,
		100,
		97,
		115,
		118,
		125,
		129,
		145,
		-1,
		-1,
		217,
		221,
		210,
		161,
		180,
		204,
		241,
		190,
		179,
		178,
		-1,
		169,
		146,
		143,
		131,
		118,
		103,
		104,
		112,
		125,
		104,
		99,
		96,
		116,
		142,
		120,
		132,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		187,
		158,
		182,
		224,
		208,
		201,
		189,
		154,
		154,
		148,
		-1,
		142,
		121,
		112,
		101,
		99,
		112,
		109,
		114,
		94,
		92,
		111,
		123,
		114,
		131,
		-1,
		-1,
		-1,
		217,
		206,
		207,
		153,
		176,
		213,
		187,
		173,
		178,
		153,
		146,
		140,
		155,
		138,
		119,
		108,
		100,
		89,
		105,
		113,
		108,
		90,
		99,
		105,
		129,
		119,
		125,
		-1,
		-1,
		224,
		214,
		198,
		200,
		197,
		167,
		174,
		206,
		178,
		191,
		-1,
		145,
		-1,
		134,
		129,
		113,
		108,
		105,
		102,
		96,
		105,
		107,
		97,
		92,
		99,
		134,
		134,
		109,
		129,
		132,
		-1,
		-1,
		-1,
		217,
		212,
		187,
		164,
		148,
		184,
		-1,
		161,
		162,
		-1,
		139,
		133,
		130,
		115,
		111,
		106,
		110,
		103,
		110,
		103,
		101,
		102,
		84,
		116,
		-1,
		117,
		111,
		119,
		109,
		97,
		-1,
		-1,
		-1,
		210,
		189,
		182,
		202,
		143,
		195,
		-1,
		-1,
		146,
		139,
		-1,
		126,
		108,
		115,
		113,
		107,
		111,
		108,
		97,
		110,
		103,
		89,
		91,
		104,
		108,
		112,
		99,
		95,
		92,
		106,
		-1,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		163,
		-1,
		155,
		147,
		137,
		131,
		125,
		121,
		119,
		135,
		119,
		122,
		120,
		111,
		119,
		92,
		85,
		92,
		81,
		99,
		107,
		99,
		93,
		92,
		102,
		-1,
		230,
		216,
		187,
		-1,
		-1,
		176,
		-1,
		140,
		154,
		170,
		-1,
		163,
		142,
		157,
		135,
		131,
		127,
		142,
		143,
		121,
		120,
		118,
		109,
		97,
		86,
		89,
		81,
		103,
		103,
		87,
		88,
		92,
		-1,
		236,
		223,
		181,
		177,
		166,
		186,
		137,
		125,
		157,
		-1,
		-1,
		199,
		-1,
		133,
		150,
		141,
		139,
		132,
		117,
		124,
		129,
		106,
		101,
		91,
		80,
		80,
		75,
		97,
		83,
		81,
		90,
		106,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		152,
		139,
		133,
		-1,
		174,
		-1,
		177,
		167,
		151,
		136,
		169,
		-1,
		116,
		112,
		119,
		-1,
		126,
		-1,
		99,
		96,
		87,
		72,
		69,
		80,
		78,
		89,
		85,
		-1,
		186,
		171,
		164,
		154,
		168,
		139,
		-1,
		194,
		-1,
		-1,
		164,
		158,
		158,
		142,
		145,
		132,
		112,
		104,
		119,
		118,
		105,
		104,
		85,
		78,
		75,
		68,
		81,
		91,
		96,
		83,
		-1,
		-1,
		-1,
		191,
		177,
		181,
		141,
		160,
		-1,
		-1,
		226,
		181,
		167,
		-1,
		141,
		132,
		120,
		110,
		100,
		105,
		106,
		96,
		94,
		83,
		85,
		79,
		70,
		69,
		85,
		77,
		99,
		-1,
		-1,
		174,
		179,
		167,
		153,
		172,
		-1,
		-1,
		-1,
		173,
		189,
		160,
		139,
		121,
		-1,
		-1,
		104,
		97,
		91,
		94,
		82,
		99,
		94,
		78,
		63,
		78,
		82,
		90,
		81,
		-1,
		177,
		164,
		-1,
		-1,
		175,
		169,
		-1,
		-1,
		-1,
		-1,
		172,
		117,
		106,
		101,
		105,
		103,
		-1,
		77,
		88,
		81,
		100,
		107,
		80,
		65,
		59,
		65,
		77,
		86,
		-1,
		-1,
		189,
		-1,
		159,
		-1,
		-1,
		-1,
		-1,
		129,
		123,
		94,
		87,
		91,
		-1,
		79,
		81,
		78,
		90,
		83,
		80,
		71,
		62,
		58,
		62,
		66,
		80,
		84,
		212,
		-1,
		150,
		-1,
		-1,
		-1,
		147,
		162,
		133,
		110,
		83,
		78,
		71,
		65,
		70,
		81,
		90,
		101,
		66,
		65,
		55,
		54,
		58,
		75,
		79,
		-1,
		-1,
		148,
		144,
		173,
		155,
		159,
		160,
		-1,
		-1,
		87,
		78,
		69,
		61,
		74,
		77,
		62,
		64,
		64,
		59,
		53,
		63,
		78,
		73,
		-1,
		-1,
		-1,
		160,
		-1,
		162,
		-1,
		-1,
		150,
		158,
		105,
		87,
		83,
		81,
		68,
		62,
		52,
		57,
		67,
		61,
		58,
		49,
		53,
		76,
		65,
		104,
		-1,
		-1,
		232,
		-1,
		-1,
		-1,
		139,
		131,
		126,
		132,
		134,
		125,
		120,
		117,
		-1,
		87,
		91,
		58,
		65,
		48,
		55,
		60,
		57,
		43,
		50,
		66,
		65,
		60,
		96,
		87,
		93,
		-1,
		-1,
		225,
		214,
		203,
		209,
		-1,
		132,
		128,
		118,
		108,
		111,
		-1,
		-1,
		105,
		102,
		82,
		51,
		56,
		49,
		44,
		49,
		30,
		39,
		43,
		47,
		53,
		58,
		63,
		69,
		84,
		99,
		-1,
		179,
		216,
		209,
		177,
		185,
		216,
		-1,
		122,
		114,
		125,
		100,
		102,
		-1,
		-1,
		78,
		69,
		70,
		58,
		55,
		68,
		67,
		34,
		39,
		57,
		44,
		45,
		63,
		67,
		76,
		83,
		73,
		86,
		90,
		-1,
		172,
		192,
		171,
		174,
		198,
		212,
		-1,
		119,
		-1,
		-1,
		130,
		103,
		87,
		77,
		74,
		117,
		64,
		59,
		36,
		34,
		31,
		22,
		60,
		39,
		51,
		54,
		70,
		75,
		67,
		83,
		83,
		84,
		-1,
		161,
		172,
		165,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		120,
		-1,
		114,
		-1,
		97,
		101,
		72,
		75,
		50,
		37,
		23,
		31,
		37,
		37,
		42,
		45,
		57,
		66,
		77,
		89,
		90,
		91,
		186,
		142,
		145,
		156,
		167,
		182,
		186,
		-1,
		131,
		170,
		126,
		-1,
		110,
		-1,
		-1,
		-1,
		105,
		85,
		77,
		70,
		49,
		49,
		15,
		19,
		32,
		39,
		49,
		63,
		60,
		70,
		83,
		94,
		99,
		182,
		173,
		186,
		131,
		131,
		152,
		161,
		182,
		146,
		137,
		164,
		133,
		122,
		117,
		104,
		-1,
		-1,
		83,
		95,
		-1,
		-1,
		56,
		23,
		11,
		21,
		25,
		39,
		51,
		64,
		52,
		71,
		65,
		97,
		-1,
		175,
		174,
		163,
		160,
		136,
		127,
		122,
		149,
		-1,
		-1,
		144,
		165,
		155,
		159,
		164,
		189,
		-1,
		93,
		-1,
		-1,
		63,
		-1,
		-1,
		48,
		28,
		17,
		8,
		13,
		33,
		44,
		66,
		48,
		65,
		70,
		80,
		93,
		159,
		156,
		144,
		142,
		165,
		130,
		118,
		-1,
		131,
		129,
		135,
		142,
		159,
		178,
		-1,
		-1,
		109,
		89,
		-1,
		-1,
		46,
		44,
		33,
		-1,
		23,
		5,
		10,
		40,
		42,
		44,
		51,
		45,
		52,
		78,
		90,
		92,
		168,
		182,
		171,
		167,
		166,
		174,
		123,
		116,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		-1,
		99,
		95,
		-1,
		-1,
		41,
		34,
		22,
		10,
		0,
		10,
		27,
		27,
		30,
		35,
		43,
		54,
		68,
		72,
		86,
		-1,
		202,
		-1,
		154,
		130,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		116,
		102,
		95,
		83,
		81,
		-1,
		75,
		59,
		40,
		-1,
		10,
		23,
		63,
		31,
		36,
		31,
		49,
		60,
		71,
		74,
		79,
		82,
		-1,
		-1,
		142,
		132,
		-1,
		-1,
		106,
		108,
		-1,
		107,
		96,
		81,
		73,
		-1,
		-1,
		47,
		43,
		-1,
		-1,
		11,
		45,
		34,
		42,
		37,
		49,
		59,
		57,
		69,
		77,
		76,
		-1,
		-1,
		127,
		119,
		113,
		-1,
		91,
		-1,
		109,
		-1,
		76,
		82,
		70,
		-1,
		-1,
		-1,
		49,
		12,
		33,
		52,
		57,
		55,
		46,
		45,
		52,
		62,
		70,
		76,
		-1,
		-1,
		-1,
		109,
		83,
		116,
		107,
		90,
		70,
		62,
		81,
		-1,
		48,
		-1,
		16,
		13,
		54,
		51,
		68,
		62,
		48,
		63,
		59,
		68,
		66,
		115,
		-1,
		85,
		118,
		82,
		76,
		52,
		56,
		72,
		-1,
		45,
		24,
		-1,
		58,
		48,
		85,
		71,
		59,
		46,
		53,
		67,
		63,
		-1,
		-1,
		-1,
		87,
		86,
		78,
		72,
		72,
		57,
		48,
		-1,
		60,
		42,
		21,
		38,
		38,
		29,
		37,
		75,
		71,
		64,
		66,
		58,
		-1,
		188,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		81,
		76,
		49,
		37,
		43,
		39,
		25,
		31,
		33,
		41,
		39,
		36,
		48,
		44,
		64,
		59,
		92,
		-1,
		183,
		-1,
		117,
		-1,
		-1,
		99,
		79,
		71,
		60,
		49,
		47,
		38,
		29,
		51,
		67,
		51,
		49,
		54,
		59,
		-1,
		172,
		171,
		-1,
		118,
		110,
		96,
		-1,
		89,
		-1,
		95,
		56,
		-1,
		58,
		38,
		-1,
		60,
		56,
		-1,
		-1,
		159,
		134,
		-1,
		-1,
		-1,
		119,
		99,
		90,
		74,
		-1,
		49,
		49,
		-1,
		-1,
		-1,
		144,
		143,
		-1,
		112,
		115,
		-1,
		105,
		96,
		104,
		51,
		55,
		-1,
		-1,
		-1,
		153,
		134,
		128,
		127,
		125,
		120,
		117,
		103,
		87,
		65,
		54,
		75,
		-1,
		-1,
		-1,
		125,
		117,
		110,
		-1,
		-1,
		112,
		95,
		76,
		74,
		-1,
		-1,
		-1,
		147,
		128,
		-1,
		-1,
		102,
		-1,
		-1,
		108,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		136,
		-1,
		-1,
		-1,
		98,
		94,
		95,
		-1,
		-1,
		-1,
		-1,
		158,
		159,
		182,
		146,
		-1,
		-1,
		-1,
		90,
		84,
		-1,
		-1,
		161,
		159,
		-1,
		-1,
		-1,
		118,
		102,
		-1,
		88,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		123,
		-1,
		123,
		98,
		105,
		-1,
		-1,
		-1,
		-1,
		136,
		128,
		136,
		-1,
		108,
		110,
		-1,
		158,
		-1,
		-1,
		151,
		142,
		-1,
		-1,
		113,
		120,
		142,
		145,
		181,
		-1,
		132
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		144,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		132,
		138,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		112,
		108,
		105,
		119,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		106,
		105,
		115,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		134,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		101,
		105,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		130,
		137,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		103,
		119,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		129,
		125,
		132,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		98,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		158,
		145,
		125,
		117,
		132,
		131,
		118,
		117,
		98,
		91,
		88,
		81,
		94,
		104,
		109,
		96,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		154,
		145,
		133,
		123,
		113,
		118,
		119,
		109,
		107,
		96,
		98,
		92,
		83,
		82,
		98,
		90,
		112,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		173,
		152,
		134,
		-1,
		-1,
		117,
		110,
		104,
		107,
		95,
		112,
		107,
		91,
		76,
		91,
		95,
		103,
		94,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		185,
		130,
		119,
		114,
		118,
		116,
		-1,
		90,
		101,
		94,
		113,
		120,
		93,
		78,
		72,
		78,
		90,
		99,
		-1,
		-1,
		202,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		142,
		136,
		107,
		100,
		104,
		-1,
		92,
		94,
		91,
		103,
		96,
		93,
		84,
		75,
		71,
		75,
		79,
		93,
		97,
		225,
		-1,
		163,
		-1,
		-1,
		-1,
		160,
		175,
		146,
		123,
		96,
		91,
		84,
		78,
		83,
		94,
		103,
		114,
		79,
		78,
		68,
		67,
		71,
		88,
		92,
		-1,
		-1,
		161,
		157,
		186,
		168,
		172,
		173,
		-1,
		-1,
		100,
		91,
		82,
		74,
		87,
		90,
		75,
		77,
		77,
		72,
		66,
		76,
		91,
		86,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		171,
		118,
		100,
		96,
		94,
		81,
		75,
		65,
		70,
		80,
		74,
		71,
		62,
		66,
		89,
		78,
		117,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		133,
		130,
		-1,
		100,
		104,
		71,
		78,
		61,
		68,
		73,
		70,
		56,
		63,
		79,
		78,
		73,
		109,
		100,
		106,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		69,
		62,
		57,
		62,
		43,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		81,
		80,
		47,
		47,
		69,
		52,
		58,
		76,
		80,
		89,
		91,
		86,
		99,
		103,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		143,
		116,
		100,
		90,
		87,
		130,
		77,
		72,
		49,
		47,
		44,
		35,
		68,
		47,
		59,
		62,
		78,
		83,
		75,
		96,
		96,
		97,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		133,
		-1,
		127,
		-1,
		110,
		114,
		85,
		88,
		63,
		50,
		36,
		39,
		45,
		45,
		50,
		53,
		65,
		74,
		85,
		97,
		103,
		104,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		139,
		-1,
		123,
		-1,
		-1,
		-1,
		118,
		98,
		90,
		83,
		62,
		62,
		28,
		27,
		40,
		47,
		57,
		71,
		66,
		78,
		91,
		102,
		112,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		146,
		135,
		130,
		117,
		-1,
		-1,
		96,
		108,
		-1,
		-1,
		69,
		36,
		24,
		29,
		33,
		47,
		59,
		72,
		58,
		78,
		73,
		105,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		172,
		177,
		202,
		-1,
		106,
		-1,
		-1,
		76,
		-1,
		-1,
		60,
		41,
		30,
		21,
		19,
		41,
		52,
		74,
		54,
		71,
		78,
		88,
		101,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		172,
		191,
		-1,
		-1,
		122,
		102,
		-1,
		-1,
		59,
		57,
		45,
		-1,
		34,
		18,
		16,
		38,
		48,
		50,
		57,
		51,
		58,
		84,
		97,
		98,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		-1,
		112,
		108,
		-1,
		-1,
		54,
		47,
		35,
		23,
		13,
		0,
		20,
		32,
		36,
		41,
		49,
		60,
		74,
		78,
		92,
		-1,
		215,
		-1,
		167,
		143,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		129,
		115,
		108,
		96,
		94,
		-1,
		88,
		72,
		53,
		-1,
		21,
		34,
		69,
		37,
		42,
		37,
		55,
		66,
		77,
		80,
		85,
		88,
		-1,
		-1,
		155,
		145,
		-1,
		-1,
		119,
		121,
		-1,
		120,
		109,
		94,
		86,
		-1,
		-1,
		60,
		56,
		-1,
		-1,
		24,
		50,
		39,
		48,
		43,
		55,
		65,
		63,
		75,
		83,
		82,
		-1,
		-1,
		140,
		132,
		126,
		-1,
		104,
		-1,
		122,
		-1,
		89,
		95,
		83,
		-1,
		-1,
		-1,
		62,
		25,
		46,
		57,
		63,
		61,
		52,
		51,
		58,
		68,
		76,
		82,
		-1,
		-1,
		-1,
		122,
		96,
		129,
		120,
		103,
		83,
		75,
		94,
		-1,
		61,
		-1,
		29,
		26,
		67,
		56,
		74,
		68,
		54,
		69,
		65,
		74,
		72,
		128,
		-1,
		98,
		131,
		95,
		89,
		65,
		69,
		85,
		-1,
		58,
		37,
		-1,
		71,
		61,
		91,
		77,
		65,
		52,
		59,
		73,
		69,
		-1,
		-1,
		-1,
		100,
		99,
		91,
		85,
		85,
		70,
		61,
		-1,
		73,
		55,
		34,
		51,
		51,
		42,
		50,
		81,
		77,
		70,
		72,
		64,
		-1,
		201,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		94,
		89,
		62,
		50,
		56,
		52,
		38,
		44,
		46,
		54,
		52,
		49,
		61,
		57,
		77,
		65,
		101,
		-1,
		196,
		-1,
		130,
		-1,
		-1,
		112,
		92,
		84,
		73,
		62,
		60,
		51,
		42,
		64,
		80,
		64,
		62,
		67,
		72,
		-1,
		185,
		184,
		-1,
		131,
		123,
		109,
		-1,
		102,
		-1,
		108,
		69,
		-1,
		71,
		51,
		-1,
		73,
		69,
		-1,
		-1,
		172,
		147,
		-1,
		-1,
		-1,
		132,
		112,
		103,
		87,
		-1,
		62,
		62,
		-1,
		-1,
		-1,
		157,
		156,
		-1,
		125,
		128,
		-1,
		118,
		109,
		117,
		64,
		68,
		-1,
		-1,
		-1,
		166,
		147,
		141,
		140,
		138,
		133,
		130,
		116,
		100,
		78,
		67,
		88,
		-1,
		-1,
		-1,
		138,
		130,
		123,
		-1,
		-1,
		125,
		108,
		89,
		87,
		-1,
		-1,
		-1,
		160,
		141,
		-1,
		-1,
		115,
		-1,
		-1,
		121,
		86,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		149,
		-1,
		-1,
		-1,
		111,
		107,
		108,
		-1,
		-1,
		-1,
		-1,
		171,
		172,
		195,
		159,
		-1,
		-1,
		-1,
		103,
		97,
		-1,
		-1,
		174,
		172,
		-1,
		-1,
		-1,
		131,
		115,
		-1,
		101,
		-1,
		-1,
		-1,
		122,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		136,
		-1,
		136,
		111,
		118,
		-1,
		-1,
		-1,
		-1,
		149,
		141,
		149,
		-1,
		121,
		123,
		-1,
		171,
		-1,
		-1,
		164,
		155,
		-1,
		-1,
		126,
		133,
		155,
		158,
		194,
		-1,
		145
	],
	[
		-1,
		234,
		223,
		234,
		242,
		215,
		222,
		-1,
		241,
		245,
		211,
		205,
		244,
		213,
		219,
		230,
		-1,
		-1,
		-1,
		234,
		233,
		201,
		199,
		208,
		213,
		220,
		-1,
		219,
		-1,
		255,
		234,
		245,
		250,
		194,
		191,
		211,
		230,
		212,
		204,
		270,
		224,
		195,
		189,
		207,
		197,
		206,
		198,
		-1,
		195,
		185,
		207,
		186,
		197,
		189,
		-1,
		-1,
		189,
		190,
		196,
		182,
		188,
		184,
		-1,
		194,
		178,
		-1,
		-1,
		179,
		180,
		164,
		167,
		175,
		173,
		186,
		178,
		173,
		-1,
		-1,
		170,
		166,
		173,
		160,
		156,
		173,
		186,
		168,
		182,
		181,
		-1,
		174,
		192,
		199,
		167,
		165,
		149,
		147,
		165,
		167,
		173,
		173,
		-1,
		183,
		184,
		179,
		187,
		189,
		165,
		152,
		152,
		162,
		155,
		174,
		162,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		183,
		166,
		183,
		175,
		165,
		180,
		173,
		155,
		152,
		150,
		147,
		163,
		161,
		171,
		-1,
		-1,
		276,
		245,
		274,
		232,
		213,
		-1,
		179,
		159,
		165,
		169,
		163,
		156,
		170,
		166,
		-1,
		141,
		140,
		168,
		154,
		165,
		236,
		-1,
		-1,
		234,
		226,
		209,
		212,
		189,
		185,
		174,
		173,
		165,
		151,
		147,
		153,
		156,
		156,
		162,
		135,
		145,
		149,
		147,
		172,
		-1,
		-1,
		207,
		-1,
		-1,
		233,
		216,
		-1,
		199,
		206,
		195,
		201,
		187,
		208,
		184,
		175,
		167,
		161,
		149,
		151,
		148,
		161,
		149,
		132,
		157,
		161,
		142,
		163,
		158,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		192,
		195,
		201,
		225,
		224,
		-1,
		196,
		184,
		185,
		170,
		167,
		154,
		142,
		155,
		140,
		147,
		146,
		136,
		134,
		164,
		139,
		161,
		158,
		177,
		182,
		176,
		185,
		-1,
		241,
		237,
		233,
		240,
		189,
		-1,
		-1,
		229,
		-1,
		232,
		233,
		208,
		181,
		184,
		171,
		162,
		149,
		138,
		149,
		138,
		135,
		143,
		128,
		143,
		134,
		133,
		151,
		161,
		169,
		173,
		179,
		-1,
		291,
		-1,
		233,
		217,
		219,
		191,
		212,
		-1,
		249,
		233,
		225,
		210,
		210,
		-1,
		180,
		177,
		167,
		145,
		130,
		147,
		139,
		137,
		141,
		123,
		137,
		128,
		146,
		153,
		151,
		155,
		175,
		187,
		251,
		241,
		-1,
		223,
		228,
		187,
		195,
		214,
		252,
		216,
		-1,
		211,
		-1,
		182,
		195,
		-1,
		151,
		147,
		129,
		130,
		125,
		140,
		134,
		119,
		116,
		134,
		137,
		144,
		148,
		164,
		-1,
		-1,
		236,
		240,
		229,
		180,
		199,
		223,
		260,
		209,
		198,
		197,
		-1,
		188,
		165,
		162,
		150,
		137,
		122,
		123,
		131,
		144,
		123,
		118,
		115,
		135,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		206,
		177,
		201,
		243,
		227,
		220,
		208,
		173,
		173,
		167,
		-1,
		161,
		140,
		131,
		120,
		118,
		131,
		128,
		133,
		113,
		111,
		130,
		142,
		133,
		150,
		-1,
		-1,
		-1,
		236,
		225,
		226,
		172,
		195,
		232,
		206,
		192,
		197,
		172,
		165,
		159,
		174,
		157,
		138,
		127,
		119,
		108,
		124,
		132,
		127,
		109,
		118,
		124,
		148,
		138,
		144,
		-1,
		-1,
		243,
		233,
		217,
		219,
		216,
		186,
		193,
		225,
		197,
		210,
		-1,
		164,
		-1,
		153,
		148,
		132,
		127,
		124,
		121,
		115,
		124,
		126,
		116,
		111,
		118,
		153,
		153,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		236,
		231,
		206,
		183,
		167,
		203,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		134,
		130,
		125,
		129,
		122,
		129,
		122,
		120,
		121,
		103,
		135,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		229,
		208,
		201,
		221,
		162,
		214,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		134,
		132,
		126,
		130,
		127,
		116,
		129,
		122,
		108,
		110,
		123,
		127,
		131,
		118,
		114,
		111,
		125,
		-1,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		182,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		154,
		138,
		141,
		139,
		130,
		138,
		111,
		104,
		111,
		100,
		118,
		126,
		118,
		112,
		111,
		121,
		-1,
		249,
		235,
		206,
		-1,
		-1,
		195,
		-1,
		159,
		173,
		189,
		-1,
		182,
		161,
		176,
		154,
		150,
		146,
		161,
		162,
		140,
		139,
		137,
		128,
		116,
		105,
		108,
		100,
		122,
		122,
		106,
		107,
		111,
		-1,
		255,
		242,
		200,
		196,
		185,
		205,
		156,
		144,
		176,
		-1,
		-1,
		218,
		-1,
		152,
		169,
		160,
		158,
		151,
		138,
		145,
		148,
		125,
		120,
		110,
		99,
		99,
		94,
		116,
		102,
		100,
		109,
		125,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		171,
		158,
		152,
		-1,
		193,
		-1,
		196,
		186,
		170,
		155,
		188,
		-1,
		137,
		133,
		140,
		-1,
		145,
		-1,
		118,
		115,
		106,
		91,
		88,
		99,
		97,
		108,
		104,
		-1,
		205,
		190,
		183,
		173,
		187,
		158,
		-1,
		213,
		-1,
		-1,
		183,
		177,
		177,
		161,
		164,
		153,
		133,
		125,
		140,
		139,
		126,
		125,
		104,
		97,
		94,
		87,
		100,
		110,
		115,
		102,
		-1,
		-1,
		-1,
		210,
		196,
		200,
		160,
		179,
		-1,
		-1,
		245,
		200,
		186,
		-1,
		162,
		153,
		141,
		131,
		121,
		126,
		127,
		117,
		115,
		102,
		104,
		98,
		89,
		88,
		104,
		96,
		118,
		-1,
		-1,
		193,
		198,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		192,
		208,
		181,
		160,
		142,
		-1,
		-1,
		125,
		118,
		112,
		115,
		103,
		118,
		113,
		97,
		82,
		97,
		101,
		109,
		100,
		-1,
		196,
		183,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		-1,
		-1,
		193,
		138,
		127,
		122,
		126,
		124,
		-1,
		98,
		109,
		102,
		121,
		128,
		99,
		84,
		78,
		84,
		96,
		105,
		-1,
		-1,
		208,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		150,
		144,
		115,
		108,
		112,
		-1,
		100,
		102,
		99,
		111,
		102,
		99,
		90,
		81,
		77,
		81,
		85,
		99,
		103,
		231,
		-1,
		171,
		-1,
		-1,
		-1,
		168,
		183,
		154,
		131,
		104,
		99,
		92,
		86,
		91,
		102,
		110,
		121,
		87,
		84,
		74,
		73,
		77,
		94,
		98,
		-1,
		-1,
		169,
		165,
		194,
		176,
		180,
		181,
		-1,
		-1,
		108,
		99,
		90,
		82,
		95,
		98,
		83,
		85,
		85,
		78,
		72,
		82,
		97,
		92,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		179,
		126,
		108,
		104,
		102,
		89,
		83,
		73,
		78,
		88,
		82,
		79,
		68,
		72,
		95,
		84,
		107,
		-1,
		-1,
		253,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		141,
		138,
		-1,
		108,
		112,
		79,
		86,
		69,
		76,
		81,
		78,
		62,
		69,
		85,
		84,
		79,
		99,
		90,
		94,
		-1,
		-1,
		246,
		235,
		224,
		230,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		103,
		72,
		77,
		70,
		65,
		70,
		51,
		58,
		62,
		63,
		72,
		77,
		82,
		78,
		85,
		100,
		-1,
		200,
		237,
		230,
		198,
		206,
		237,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		89,
		88,
		55,
		52,
		73,
		51,
		61,
		79,
		71,
		75,
		76,
		83,
		94,
		98,
		-1,
		193,
		213,
		192,
		195,
		219,
		233,
		-1,
		140,
		-1,
		-1,
		152,
		124,
		108,
		98,
		95,
		138,
		85,
		80,
		57,
		55,
		52,
		43,
		69,
		46,
		57,
		54,
		63,
		68,
		60,
		86,
		88,
		94,
		-1,
		182,
		193,
		186,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		150,
		-1,
		135,
		-1,
		118,
		122,
		93,
		96,
		71,
		58,
		44,
		44,
		50,
		44,
		49,
		52,
		50,
		59,
		70,
		82,
		92,
		94,
		207,
		163,
		166,
		177,
		188,
		203,
		207,
		-1,
		152,
		191,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		132,
		106,
		98,
		91,
		70,
		70,
		36,
		32,
		39,
		46,
		56,
		67,
		51,
		63,
		76,
		87,
		102,
		203,
		194,
		207,
		152,
		152,
		173,
		182,
		203,
		167,
		158,
		185,
		163,
		152,
		147,
		134,
		-1,
		-1,
		113,
		116,
		-1,
		-1,
		77,
		51,
		40,
		29,
		32,
		42,
		52,
		63,
		43,
		63,
		58,
		90,
		-1,
		196,
		195,
		184,
		181,
		157,
		148,
		143,
		170,
		-1,
		-1,
		165,
		186,
		176,
		180,
		194,
		219,
		-1,
		123,
		-1,
		-1,
		93,
		-1,
		-1,
		78,
		56,
		45,
		38,
		24,
		34,
		45,
		67,
		39,
		56,
		63,
		73,
		86,
		180,
		177,
		165,
		163,
		186,
		151,
		139,
		-1,
		152,
		150,
		156,
		163,
		180,
		208,
		-1,
		-1,
		139,
		119,
		-1,
		-1,
		76,
		74,
		63,
		-1,
		53,
		35,
		21,
		27,
		33,
		35,
		42,
		36,
		43,
		69,
		82,
		83,
		189,
		203,
		192,
		188,
		187,
		195,
		144,
		137,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		125,
		-1,
		-1,
		71,
		64,
		52,
		40,
		30,
		27,
		0,
		12,
		21,
		26,
		34,
		45,
		59,
		63,
		77,
		-1,
		223,
		-1,
		175,
		151,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		105,
		89,
		70,
		-1,
		40,
		53,
		54,
		20,
		27,
		22,
		40,
		51,
		62,
		65,
		70,
		73,
		-1,
		-1,
		163,
		162,
		-1,
		-1,
		136,
		138,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		77,
		73,
		-1,
		-1,
		41,
		30,
		19,
		33,
		28,
		40,
		50,
		48,
		60,
		68,
		67,
		-1,
		-1,
		157,
		149,
		143,
		-1,
		121,
		-1,
		139,
		-1,
		106,
		112,
		100,
		-1,
		-1,
		-1,
		79,
		42,
		63,
		37,
		44,
		46,
		37,
		36,
		43,
		53,
		61,
		67,
		-1,
		-1,
		-1,
		139,
		113,
		146,
		137,
		120,
		100,
		92,
		111,
		-1,
		78,
		-1,
		46,
		43,
		51,
		36,
		59,
		53,
		39,
		54,
		50,
		59,
		57,
		145,
		-1,
		115,
		148,
		112,
		106,
		82,
		86,
		102,
		-1,
		75,
		54,
		-1,
		88,
		58,
		76,
		62,
		50,
		37,
		44,
		58,
		54,
		-1,
		-1,
		-1,
		117,
		116,
		108,
		102,
		102,
		87,
		78,
		-1,
		90,
		72,
		51,
		68,
		68,
		59,
		67,
		66,
		62,
		55,
		57,
		49,
		-1,
		218,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		111,
		106,
		79,
		67,
		73,
		69,
		55,
		61,
		63,
		71,
		69,
		66,
		76,
		67,
		71,
		50,
		86,
		-1,
		213,
		-1,
		147,
		-1,
		-1,
		129,
		109,
		101,
		90,
		79,
		77,
		68,
		59,
		81,
		97,
		74,
		62,
		57,
		58,
		-1,
		202,
		201,
		-1,
		148,
		140,
		126,
		-1,
		119,
		-1,
		125,
		86,
		-1,
		88,
		68,
		-1,
		73,
		62,
		-1,
		-1,
		189,
		164,
		-1,
		-1,
		-1,
		149,
		129,
		120,
		104,
		-1,
		79,
		79,
		-1,
		-1,
		-1,
		174,
		173,
		-1,
		142,
		145,
		-1,
		135,
		126,
		134,
		81,
		85,
		-1,
		-1,
		-1,
		183,
		164,
		158,
		157,
		155,
		150,
		147,
		133,
		117,
		95,
		84,
		105,
		-1,
		-1,
		-1,
		155,
		147,
		140,
		-1,
		-1,
		142,
		125,
		106,
		104,
		-1,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		132,
		-1,
		-1,
		138,
		103,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		166,
		-1,
		-1,
		-1,
		128,
		124,
		125,
		-1,
		-1,
		-1,
		-1,
		188,
		189,
		212,
		176,
		-1,
		-1,
		-1,
		120,
		114,
		-1,
		-1,
		191,
		189,
		-1,
		-1,
		-1,
		148,
		132,
		-1,
		118,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		153,
		-1,
		153,
		128,
		135,
		-1,
		-1,
		-1,
		-1,
		166,
		158,
		166,
		-1,
		138,
		140,
		-1,
		188,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		143,
		150,
		172,
		175,
		211,
		-1,
		162
	],
	[
		-1,
		232,
		221,
		232,
		240,
		213,
		220,
		-1,
		239,
		243,
		209,
		203,
		242,
		211,
		217,
		228,
		-1,
		-1,
		-1,
		232,
		231,
		199,
		197,
		206,
		211,
		218,
		-1,
		217,
		-1,
		253,
		232,
		243,
		248,
		192,
		189,
		209,
		228,
		210,
		202,
		268,
		222,
		193,
		187,
		205,
		195,
		204,
		196,
		-1,
		193,
		183,
		205,
		184,
		195,
		187,
		-1,
		-1,
		187,
		188,
		194,
		180,
		186,
		182,
		-1,
		192,
		176,
		-1,
		-1,
		177,
		178,
		162,
		165,
		173,
		171,
		184,
		176,
		171,
		-1,
		-1,
		168,
		164,
		171,
		158,
		154,
		171,
		184,
		166,
		180,
		179,
		-1,
		172,
		190,
		197,
		165,
		163,
		147,
		145,
		163,
		165,
		171,
		171,
		-1,
		181,
		182,
		177,
		185,
		187,
		163,
		150,
		150,
		160,
		153,
		172,
		160,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		181,
		164,
		181,
		173,
		163,
		178,
		171,
		153,
		150,
		148,
		145,
		161,
		159,
		169,
		-1,
		-1,
		274,
		243,
		272,
		230,
		211,
		-1,
		177,
		157,
		163,
		167,
		161,
		154,
		168,
		164,
		-1,
		139,
		138,
		166,
		152,
		163,
		234,
		-1,
		-1,
		232,
		224,
		207,
		210,
		187,
		183,
		172,
		171,
		163,
		149,
		145,
		151,
		154,
		154,
		160,
		133,
		143,
		147,
		145,
		170,
		-1,
		-1,
		205,
		-1,
		-1,
		231,
		214,
		-1,
		197,
		204,
		193,
		199,
		185,
		206,
		182,
		173,
		165,
		159,
		147,
		149,
		146,
		159,
		147,
		130,
		155,
		159,
		140,
		161,
		156,
		-1,
		204,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		190,
		193,
		199,
		223,
		222,
		-1,
		194,
		182,
		183,
		168,
		165,
		152,
		140,
		153,
		138,
		145,
		144,
		134,
		132,
		162,
		137,
		159,
		156,
		175,
		180,
		174,
		183,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		227,
		-1,
		230,
		231,
		206,
		179,
		182,
		169,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		126,
		141,
		132,
		131,
		149,
		159,
		167,
		171,
		177,
		-1,
		289,
		-1,
		231,
		215,
		217,
		189,
		210,
		-1,
		247,
		231,
		223,
		208,
		208,
		-1,
		178,
		175,
		165,
		143,
		128,
		145,
		137,
		135,
		139,
		121,
		135,
		126,
		144,
		151,
		149,
		153,
		173,
		185,
		249,
		239,
		-1,
		221,
		226,
		185,
		193,
		212,
		250,
		214,
		-1,
		209,
		-1,
		180,
		193,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		132,
		117,
		114,
		132,
		135,
		142,
		146,
		162,
		-1,
		-1,
		234,
		238,
		227,
		178,
		197,
		221,
		258,
		207,
		196,
		195,
		-1,
		186,
		163,
		160,
		148,
		135,
		120,
		121,
		129,
		142,
		121,
		116,
		113,
		133,
		159,
		137,
		149,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		204,
		175,
		199,
		241,
		225,
		218,
		206,
		171,
		171,
		165,
		-1,
		159,
		138,
		129,
		118,
		116,
		129,
		126,
		131,
		111,
		109,
		128,
		140,
		131,
		148,
		-1,
		-1,
		-1,
		234,
		223,
		224,
		170,
		193,
		230,
		204,
		190,
		195,
		170,
		163,
		157,
		172,
		155,
		136,
		125,
		117,
		106,
		122,
		130,
		125,
		107,
		116,
		122,
		146,
		136,
		142,
		-1,
		-1,
		241,
		231,
		215,
		217,
		214,
		184,
		191,
		223,
		195,
		208,
		-1,
		162,
		-1,
		151,
		146,
		130,
		125,
		122,
		119,
		113,
		122,
		124,
		114,
		109,
		116,
		151,
		151,
		126,
		146,
		149,
		-1,
		-1,
		-1,
		234,
		229,
		204,
		181,
		165,
		201,
		-1,
		178,
		179,
		-1,
		156,
		150,
		147,
		132,
		128,
		123,
		127,
		120,
		127,
		120,
		118,
		119,
		101,
		133,
		-1,
		134,
		128,
		136,
		126,
		114,
		-1,
		-1,
		-1,
		227,
		206,
		199,
		219,
		160,
		212,
		-1,
		-1,
		163,
		156,
		-1,
		143,
		125,
		132,
		130,
		124,
		128,
		125,
		114,
		127,
		120,
		106,
		108,
		121,
		125,
		129,
		116,
		112,
		109,
		123,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		180,
		-1,
		172,
		164,
		154,
		148,
		142,
		138,
		136,
		152,
		136,
		139,
		137,
		128,
		136,
		109,
		102,
		109,
		98,
		116,
		124,
		116,
		110,
		109,
		119,
		-1,
		247,
		233,
		204,
		-1,
		-1,
		193,
		-1,
		157,
		171,
		187,
		-1,
		180,
		159,
		174,
		152,
		148,
		144,
		159,
		160,
		138,
		137,
		135,
		126,
		114,
		103,
		106,
		98,
		120,
		120,
		104,
		105,
		109,
		-1,
		253,
		240,
		198,
		194,
		183,
		203,
		154,
		142,
		174,
		-1,
		-1,
		216,
		-1,
		150,
		167,
		158,
		156,
		149,
		134,
		141,
		146,
		123,
		118,
		108,
		97,
		97,
		92,
		114,
		100,
		98,
		107,
		123,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		169,
		156,
		150,
		-1,
		191,
		-1,
		194,
		184,
		168,
		153,
		186,
		-1,
		133,
		129,
		136,
		-1,
		143,
		-1,
		116,
		113,
		104,
		89,
		86,
		97,
		95,
		106,
		102,
		-1,
		203,
		188,
		181,
		171,
		185,
		156,
		-1,
		211,
		-1,
		-1,
		181,
		175,
		175,
		159,
		162,
		149,
		129,
		121,
		136,
		135,
		122,
		121,
		102,
		95,
		92,
		85,
		98,
		108,
		113,
		100,
		-1,
		-1,
		-1,
		208,
		194,
		198,
		158,
		177,
		-1,
		-1,
		243,
		198,
		184,
		-1,
		158,
		149,
		137,
		127,
		117,
		122,
		123,
		113,
		111,
		100,
		102,
		96,
		87,
		86,
		102,
		94,
		116,
		-1,
		-1,
		191,
		196,
		184,
		170,
		189,
		-1,
		-1,
		-1,
		190,
		206,
		177,
		156,
		138,
		-1,
		-1,
		121,
		114,
		108,
		111,
		99,
		116,
		111,
		95,
		80,
		95,
		99,
		107,
		98,
		-1,
		194,
		181,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		-1,
		-1,
		189,
		134,
		123,
		118,
		122,
		120,
		-1,
		94,
		105,
		98,
		117,
		124,
		97,
		82,
		76,
		82,
		94,
		103,
		-1,
		-1,
		206,
		-1,
		176,
		-1,
		-1,
		-1,
		-1,
		146,
		140,
		111,
		104,
		108,
		-1,
		96,
		98,
		95,
		107,
		100,
		97,
		88,
		79,
		75,
		79,
		83,
		97,
		101,
		229,
		-1,
		167,
		-1,
		-1,
		-1,
		164,
		179,
		150,
		127,
		100,
		95,
		88,
		82,
		87,
		98,
		107,
		118,
		83,
		82,
		72,
		71,
		75,
		92,
		96,
		-1,
		-1,
		165,
		161,
		190,
		172,
		176,
		177,
		-1,
		-1,
		104,
		95,
		86,
		78,
		91,
		94,
		79,
		81,
		81,
		76,
		70,
		80,
		95,
		90,
		-1,
		-1,
		-1,
		177,
		-1,
		179,
		-1,
		-1,
		167,
		175,
		122,
		104,
		100,
		98,
		85,
		79,
		69,
		74,
		84,
		78,
		75,
		66,
		70,
		93,
		82,
		102,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		156,
		148,
		143,
		149,
		151,
		142,
		137,
		134,
		-1,
		104,
		108,
		75,
		82,
		65,
		72,
		77,
		74,
		60,
		67,
		83,
		82,
		77,
		94,
		85,
		89,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		149,
		145,
		135,
		125,
		128,
		-1,
		-1,
		122,
		119,
		99,
		68,
		73,
		66,
		61,
		66,
		47,
		56,
		60,
		58,
		70,
		75,
		80,
		73,
		80,
		95,
		-1,
		196,
		233,
		226,
		194,
		202,
		233,
		-1,
		139,
		131,
		142,
		117,
		119,
		-1,
		-1,
		95,
		86,
		87,
		75,
		72,
		85,
		84,
		51,
		48,
		70,
		53,
		62,
		74,
		66,
		70,
		71,
		78,
		89,
		93,
		-1,
		189,
		209,
		188,
		191,
		215,
		229,
		-1,
		136,
		-1,
		-1,
		148,
		120,
		104,
		94,
		91,
		134,
		81,
		76,
		53,
		51,
		48,
		39,
		69,
		48,
		52,
		49,
		58,
		63,
		55,
		81,
		83,
		89,
		-1,
		178,
		189,
		182,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		146,
		-1,
		131,
		-1,
		114,
		118,
		89,
		92,
		67,
		54,
		40,
		40,
		46,
		46,
		51,
		54,
		45,
		54,
		65,
		77,
		87,
		89,
		203,
		159,
		162,
		173,
		184,
		199,
		203,
		-1,
		148,
		187,
		152,
		-1,
		136,
		-1,
		-1,
		-1,
		128,
		102,
		94,
		87,
		66,
		66,
		32,
		28,
		41,
		48,
		58,
		62,
		46,
		58,
		71,
		82,
		97,
		199,
		190,
		203,
		148,
		148,
		169,
		178,
		199,
		163,
		154,
		181,
		159,
		148,
		143,
		130,
		-1,
		-1,
		109,
		112,
		-1,
		-1,
		73,
		49,
		36,
		30,
		34,
		48,
		60,
		58,
		38,
		58,
		53,
		85,
		-1,
		192,
		191,
		180,
		177,
		153,
		144,
		139,
		166,
		-1,
		-1,
		161,
		182,
		172,
		176,
		190,
		215,
		-1,
		119,
		-1,
		-1,
		89,
		-1,
		-1,
		74,
		54,
		43,
		34,
		20,
		42,
		53,
		75,
		34,
		51,
		58,
		68,
		81,
		176,
		173,
		161,
		159,
		182,
		147,
		135,
		-1,
		148,
		146,
		152,
		159,
		176,
		204,
		-1,
		-1,
		135,
		115,
		-1,
		-1,
		72,
		70,
		59,
		-1,
		49,
		31,
		17,
		38,
		28,
		30,
		37,
		31,
		38,
		64,
		77,
		78,
		185,
		199,
		188,
		184,
		183,
		191,
		140,
		133,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		125,
		121,
		-1,
		-1,
		67,
		60,
		48,
		36,
		26,
		31,
		11,
		0,
		16,
		21,
		29,
		40,
		54,
		58,
		72,
		-1,
		219,
		-1,
		171,
		147,
		161,
		176,
		184,
		-1,
		-1,
		-1,
		142,
		128,
		121,
		109,
		107,
		-1,
		101,
		85,
		66,
		-1,
		36,
		49,
		44,
		8,
		22,
		17,
		35,
		46,
		57,
		60,
		65,
		68,
		-1,
		-1,
		159,
		158,
		-1,
		-1,
		132,
		134,
		-1,
		133,
		122,
		107,
		99,
		-1,
		-1,
		73,
		69,
		-1,
		-1,
		37,
		25,
		11,
		28,
		23,
		35,
		45,
		43,
		55,
		63,
		62,
		-1,
		-1,
		153,
		145,
		139,
		-1,
		117,
		-1,
		135,
		-1,
		102,
		108,
		96,
		-1,
		-1,
		-1,
		75,
		38,
		59,
		32,
		39,
		41,
		32,
		31,
		38,
		48,
		56,
		62,
		-1,
		-1,
		-1,
		135,
		109,
		142,
		133,
		116,
		96,
		88,
		107,
		-1,
		74,
		-1,
		42,
		39,
		46,
		31,
		54,
		48,
		34,
		49,
		45,
		54,
		52,
		141,
		-1,
		111,
		144,
		108,
		102,
		78,
		82,
		98,
		-1,
		71,
		50,
		-1,
		84,
		53,
		71,
		57,
		45,
		32,
		39,
		53,
		49,
		-1,
		-1,
		-1,
		113,
		112,
		104,
		98,
		98,
		83,
		74,
		-1,
		86,
		68,
		47,
		64,
		64,
		55,
		63,
		61,
		57,
		50,
		52,
		44,
		-1,
		214,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		107,
		102,
		75,
		63,
		69,
		65,
		51,
		57,
		59,
		67,
		65,
		62,
		71,
		62,
		66,
		45,
		81,
		-1,
		209,
		-1,
		143,
		-1,
		-1,
		125,
		105,
		97,
		86,
		75,
		73,
		64,
		55,
		77,
		93,
		69,
		57,
		52,
		53,
		-1,
		198,
		197,
		-1,
		144,
		136,
		122,
		-1,
		115,
		-1,
		121,
		82,
		-1,
		84,
		64,
		-1,
		68,
		57,
		-1,
		-1,
		185,
		160,
		-1,
		-1,
		-1,
		145,
		125,
		116,
		100,
		-1,
		75,
		75,
		-1,
		-1,
		-1,
		170,
		169,
		-1,
		138,
		141,
		-1,
		131,
		122,
		130,
		77,
		81,
		-1,
		-1,
		-1,
		179,
		160,
		154,
		153,
		151,
		146,
		143,
		129,
		113,
		91,
		80,
		101,
		-1,
		-1,
		-1,
		151,
		143,
		136,
		-1,
		-1,
		138,
		121,
		102,
		100,
		-1,
		-1,
		-1,
		173,
		154,
		-1,
		-1,
		128,
		-1,
		-1,
		134,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		162,
		-1,
		-1,
		-1,
		124,
		120,
		121,
		-1,
		-1,
		-1,
		-1,
		184,
		185,
		208,
		172,
		-1,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		187,
		185,
		-1,
		-1,
		-1,
		144,
		128,
		-1,
		114,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		149,
		-1,
		149,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		162,
		154,
		162,
		-1,
		134,
		136,
		-1,
		184,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		139,
		146,
		168,
		171,
		207,
		-1,
		158
	],
	[
		-1,
		223,
		212,
		223,
		231,
		204,
		211,
		-1,
		230,
		234,
		200,
		194,
		233,
		202,
		208,
		219,
		-1,
		-1,
		-1,
		223,
		222,
		190,
		188,
		197,
		202,
		209,
		-1,
		208,
		-1,
		244,
		223,
		234,
		239,
		183,
		180,
		200,
		219,
		201,
		193,
		259,
		213,
		184,
		178,
		196,
		186,
		195,
		187,
		-1,
		184,
		174,
		196,
		175,
		186,
		178,
		-1,
		-1,
		178,
		179,
		185,
		171,
		177,
		173,
		-1,
		183,
		167,
		-1,
		-1,
		168,
		169,
		153,
		156,
		164,
		162,
		175,
		167,
		162,
		-1,
		-1,
		159,
		155,
		162,
		149,
		145,
		162,
		175,
		157,
		171,
		170,
		-1,
		163,
		181,
		188,
		156,
		154,
		138,
		136,
		154,
		156,
		162,
		162,
		-1,
		172,
		173,
		168,
		176,
		178,
		154,
		141,
		141,
		151,
		144,
		163,
		151,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		172,
		155,
		172,
		164,
		154,
		169,
		162,
		144,
		141,
		139,
		136,
		152,
		150,
		160,
		-1,
		-1,
		265,
		234,
		263,
		221,
		202,
		-1,
		168,
		148,
		154,
		158,
		152,
		145,
		159,
		155,
		-1,
		130,
		129,
		157,
		143,
		154,
		225,
		-1,
		-1,
		223,
		215,
		198,
		201,
		178,
		174,
		163,
		162,
		154,
		140,
		136,
		142,
		145,
		145,
		151,
		124,
		134,
		138,
		136,
		161,
		-1,
		-1,
		196,
		-1,
		-1,
		222,
		205,
		-1,
		188,
		195,
		184,
		190,
		176,
		197,
		173,
		164,
		156,
		150,
		138,
		140,
		137,
		150,
		138,
		121,
		146,
		150,
		131,
		152,
		147,
		-1,
		195,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		181,
		184,
		190,
		214,
		213,
		-1,
		185,
		173,
		174,
		159,
		156,
		143,
		131,
		144,
		129,
		136,
		135,
		125,
		123,
		153,
		128,
		150,
		147,
		166,
		171,
		165,
		174,
		-1,
		230,
		226,
		222,
		229,
		178,
		-1,
		-1,
		218,
		-1,
		221,
		222,
		197,
		170,
		173,
		160,
		151,
		138,
		127,
		138,
		127,
		124,
		132,
		117,
		132,
		123,
		122,
		140,
		150,
		158,
		162,
		168,
		-1,
		280,
		-1,
		222,
		206,
		208,
		180,
		201,
		-1,
		238,
		222,
		214,
		199,
		199,
		-1,
		169,
		166,
		156,
		134,
		119,
		136,
		128,
		126,
		130,
		112,
		126,
		117,
		135,
		142,
		140,
		144,
		164,
		176,
		240,
		230,
		-1,
		212,
		217,
		176,
		184,
		203,
		241,
		205,
		-1,
		200,
		-1,
		171,
		184,
		-1,
		140,
		136,
		118,
		119,
		114,
		129,
		123,
		108,
		105,
		123,
		126,
		133,
		137,
		153,
		-1,
		-1,
		225,
		229,
		218,
		169,
		188,
		212,
		249,
		198,
		187,
		186,
		-1,
		177,
		154,
		151,
		139,
		126,
		111,
		112,
		120,
		133,
		112,
		107,
		104,
		124,
		150,
		128,
		140,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		195,
		166,
		190,
		232,
		216,
		209,
		197,
		162,
		162,
		156,
		-1,
		150,
		129,
		120,
		109,
		107,
		120,
		117,
		122,
		102,
		100,
		119,
		131,
		122,
		139,
		-1,
		-1,
		-1,
		225,
		214,
		215,
		161,
		184,
		221,
		195,
		181,
		186,
		161,
		154,
		148,
		163,
		146,
		127,
		116,
		108,
		97,
		113,
		121,
		116,
		98,
		107,
		113,
		137,
		127,
		133,
		-1,
		-1,
		232,
		222,
		206,
		208,
		205,
		175,
		182,
		214,
		186,
		199,
		-1,
		153,
		-1,
		142,
		137,
		121,
		116,
		113,
		110,
		104,
		113,
		115,
		105,
		100,
		107,
		142,
		142,
		117,
		137,
		140,
		-1,
		-1,
		-1,
		225,
		220,
		195,
		172,
		156,
		192,
		-1,
		169,
		170,
		-1,
		147,
		141,
		138,
		123,
		119,
		114,
		118,
		111,
		118,
		111,
		109,
		110,
		92,
		124,
		-1,
		125,
		119,
		127,
		117,
		105,
		-1,
		-1,
		-1,
		218,
		197,
		190,
		210,
		151,
		203,
		-1,
		-1,
		154,
		147,
		-1,
		134,
		116,
		123,
		121,
		115,
		119,
		116,
		105,
		118,
		111,
		97,
		99,
		112,
		116,
		120,
		107,
		103,
		100,
		114,
		-1,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		171,
		-1,
		163,
		155,
		145,
		139,
		133,
		129,
		127,
		143,
		127,
		130,
		128,
		119,
		127,
		100,
		93,
		100,
		89,
		107,
		115,
		107,
		101,
		100,
		110,
		-1,
		238,
		224,
		195,
		-1,
		-1,
		184,
		-1,
		148,
		162,
		178,
		-1,
		171,
		150,
		165,
		143,
		139,
		135,
		150,
		151,
		129,
		128,
		126,
		117,
		105,
		94,
		97,
		89,
		111,
		111,
		95,
		96,
		100,
		-1,
		244,
		231,
		189,
		185,
		174,
		194,
		145,
		133,
		165,
		-1,
		-1,
		207,
		-1,
		141,
		158,
		149,
		147,
		140,
		131,
		137,
		137,
		114,
		109,
		99,
		88,
		88,
		83,
		105,
		91,
		89,
		98,
		114,
		-1,
		-1,
		-1,
		211,
		-1,
		-1,
		160,
		147,
		141,
		-1,
		182,
		-1,
		185,
		175,
		159,
		144,
		177,
		-1,
		134,
		130,
		137,
		-1,
		134,
		-1,
		107,
		104,
		95,
		80,
		77,
		88,
		86,
		97,
		93,
		-1,
		194,
		179,
		172,
		162,
		176,
		147,
		-1,
		202,
		-1,
		-1,
		172,
		166,
		166,
		150,
		153,
		150,
		130,
		122,
		137,
		129,
		121,
		115,
		93,
		86,
		83,
		76,
		89,
		99,
		104,
		91,
		-1,
		-1,
		-1,
		199,
		185,
		189,
		149,
		168,
		-1,
		-1,
		234,
		189,
		175,
		-1,
		159,
		150,
		138,
		128,
		118,
		123,
		124,
		112,
		105,
		91,
		93,
		87,
		78,
		77,
		93,
		85,
		107,
		-1,
		-1,
		182,
		187,
		175,
		161,
		180,
		-1,
		-1,
		-1,
		181,
		197,
		178,
		157,
		139,
		-1,
		-1,
		122,
		115,
		109,
		108,
		95,
		107,
		102,
		86,
		71,
		86,
		90,
		98,
		89,
		-1,
		185,
		172,
		-1,
		-1,
		183,
		177,
		-1,
		-1,
		-1,
		-1,
		190,
		135,
		124,
		119,
		123,
		121,
		-1,
		95,
		106,
		99,
		111,
		118,
		88,
		73,
		67,
		73,
		85,
		94,
		-1,
		-1,
		197,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		147,
		141,
		112,
		105,
		109,
		-1,
		97,
		99,
		96,
		108,
		91,
		88,
		79,
		70,
		66,
		70,
		74,
		88,
		92,
		220,
		-1,
		168,
		-1,
		-1,
		-1,
		165,
		180,
		151,
		128,
		101,
		96,
		89,
		83,
		88,
		99,
		99,
		110,
		77,
		73,
		63,
		62,
		66,
		83,
		83,
		-1,
		-1,
		166,
		162,
		191,
		173,
		177,
		178,
		-1,
		-1,
		105,
		96,
		87,
		79,
		92,
		95,
		80,
		80,
		74,
		67,
		61,
		71,
		82,
		77,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		168,
		176,
		123,
		105,
		101,
		99,
		86,
		80,
		70,
		75,
		84,
		75,
		69,
		57,
		57,
		80,
		69,
		86,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		138,
		135,
		-1,
		105,
		109,
		76,
		83,
		66,
		73,
		78,
		71,
		51,
		54,
		70,
		69,
		64,
		78,
		69,
		73,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		123,
		120,
		100,
		69,
		74,
		67,
		62,
		67,
		48,
		47,
		47,
		42,
		57,
		62,
		64,
		57,
		64,
		79,
		-1,
		197,
		234,
		227,
		195,
		203,
		234,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		96,
		87,
		88,
		76,
		73,
		86,
		85,
		52,
		49,
		62,
		40,
		47,
		58,
		50,
		54,
		55,
		62,
		73,
		77,
		-1,
		190,
		210,
		189,
		192,
		216,
		230,
		-1,
		137,
		-1,
		-1,
		149,
		121,
		105,
		95,
		92,
		135,
		82,
		77,
		54,
		52,
		49,
		40,
		64,
		48,
		36,
		33,
		42,
		47,
		39,
		65,
		67,
		73,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		147,
		-1,
		132,
		-1,
		115,
		119,
		90,
		93,
		68,
		55,
		41,
		41,
		47,
		47,
		44,
		40,
		29,
		38,
		49,
		61,
		71,
		73,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		149,
		188,
		153,
		-1,
		137,
		-1,
		-1,
		-1,
		129,
		103,
		95,
		88,
		67,
		67,
		33,
		29,
		42,
		49,
		54,
		46,
		30,
		42,
		55,
		66,
		81,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		164,
		155,
		182,
		160,
		149,
		144,
		131,
		-1,
		-1,
		110,
		113,
		-1,
		-1,
		74,
		50,
		37,
		31,
		35,
		49,
		54,
		42,
		22,
		42,
		37,
		69,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		183,
		173,
		177,
		191,
		216,
		-1,
		120,
		-1,
		-1,
		90,
		-1,
		-1,
		75,
		55,
		44,
		35,
		21,
		43,
		54,
		69,
		18,
		35,
		42,
		52,
		65,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		149,
		147,
		153,
		160,
		177,
		205,
		-1,
		-1,
		136,
		116,
		-1,
		-1,
		73,
		71,
		60,
		-1,
		50,
		32,
		18,
		45,
		13,
		14,
		21,
		15,
		22,
		48,
		61,
		65,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		126,
		122,
		-1,
		-1,
		68,
		61,
		49,
		37,
		27,
		32,
		18,
		14,
		0,
		5,
		13,
		24,
		38,
		42,
		59,
		-1,
		220,
		-1,
		172,
		148,
		162,
		177,
		185,
		-1,
		-1,
		-1,
		143,
		129,
		122,
		110,
		108,
		-1,
		102,
		86,
		67,
		-1,
		37,
		50,
		50,
		18,
		18,
		12,
		19,
		30,
		41,
		44,
		58,
		53,
		-1,
		-1,
		160,
		159,
		-1,
		-1,
		133,
		135,
		-1,
		134,
		123,
		108,
		100,
		-1,
		-1,
		74,
		70,
		-1,
		-1,
		38,
		32,
		21,
		24,
		19,
		23,
		29,
		39,
		43,
		47,
		59,
		-1,
		-1,
		154,
		146,
		140,
		-1,
		118,
		-1,
		136,
		-1,
		103,
		109,
		97,
		-1,
		-1,
		-1,
		76,
		39,
		60,
		39,
		42,
		40,
		31,
		27,
		34,
		44,
		50,
		61,
		-1,
		-1,
		-1,
		136,
		110,
		143,
		134,
		117,
		97,
		89,
		108,
		-1,
		75,
		-1,
		43,
		40,
		53,
		38,
		53,
		47,
		30,
		45,
		44,
		48,
		51,
		142,
		-1,
		112,
		145,
		109,
		103,
		79,
		83,
		99,
		-1,
		72,
		51,
		-1,
		85,
		60,
		70,
		56,
		44,
		31,
		38,
		52,
		48,
		-1,
		-1,
		-1,
		114,
		113,
		105,
		99,
		99,
		84,
		75,
		-1,
		87,
		69,
		48,
		65,
		65,
		56,
		64,
		60,
		56,
		49,
		51,
		43,
		-1,
		215,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		108,
		103,
		76,
		64,
		70,
		66,
		52,
		58,
		60,
		68,
		66,
		63,
		70,
		61,
		65,
		44,
		80,
		-1,
		210,
		-1,
		144,
		-1,
		-1,
		126,
		106,
		98,
		87,
		76,
		74,
		65,
		56,
		78,
		94,
		68,
		56,
		51,
		52,
		-1,
		199,
		198,
		-1,
		145,
		137,
		123,
		-1,
		116,
		-1,
		122,
		83,
		-1,
		85,
		65,
		-1,
		67,
		56,
		-1,
		-1,
		186,
		161,
		-1,
		-1,
		-1,
		146,
		126,
		117,
		101,
		-1,
		76,
		76,
		-1,
		-1,
		-1,
		171,
		170,
		-1,
		139,
		142,
		-1,
		132,
		123,
		131,
		78,
		82,
		-1,
		-1,
		-1,
		180,
		161,
		155,
		154,
		152,
		147,
		144,
		130,
		114,
		92,
		81,
		102,
		-1,
		-1,
		-1,
		152,
		144,
		137,
		-1,
		-1,
		139,
		122,
		103,
		101,
		-1,
		-1,
		-1,
		174,
		155,
		-1,
		-1,
		129,
		-1,
		-1,
		135,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		163,
		-1,
		-1,
		-1,
		125,
		121,
		122,
		-1,
		-1,
		-1,
		-1,
		185,
		186,
		209,
		173,
		-1,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		188,
		186,
		-1,
		-1,
		-1,
		145,
		129,
		-1,
		115,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		150,
		-1,
		150,
		125,
		132,
		-1,
		-1,
		-1,
		-1,
		163,
		155,
		163,
		-1,
		135,
		137,
		-1,
		185,
		-1,
		-1,
		178,
		169,
		-1,
		-1,
		140,
		147,
		169,
		172,
		208,
		-1,
		159
	],
	[
		-1,
		218,
		207,
		218,
		226,
		199,
		206,
		-1,
		225,
		229,
		195,
		189,
		228,
		197,
		203,
		214,
		-1,
		-1,
		-1,
		218,
		217,
		185,
		183,
		192,
		197,
		204,
		-1,
		203,
		-1,
		239,
		218,
		229,
		234,
		178,
		175,
		195,
		214,
		196,
		188,
		254,
		208,
		179,
		173,
		191,
		181,
		190,
		182,
		-1,
		179,
		169,
		191,
		170,
		181,
		173,
		-1,
		-1,
		173,
		174,
		180,
		166,
		172,
		168,
		-1,
		178,
		162,
		-1,
		-1,
		163,
		164,
		148,
		151,
		159,
		157,
		170,
		162,
		157,
		-1,
		-1,
		154,
		150,
		157,
		144,
		140,
		157,
		170,
		152,
		166,
		165,
		-1,
		158,
		176,
		183,
		151,
		149,
		133,
		131,
		149,
		151,
		157,
		157,
		-1,
		167,
		168,
		163,
		171,
		173,
		149,
		136,
		136,
		146,
		139,
		158,
		146,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		167,
		150,
		167,
		159,
		149,
		164,
		157,
		139,
		136,
		134,
		131,
		147,
		145,
		155,
		-1,
		-1,
		260,
		229,
		258,
		216,
		197,
		-1,
		163,
		143,
		149,
		153,
		147,
		140,
		154,
		150,
		-1,
		125,
		124,
		152,
		138,
		149,
		220,
		-1,
		-1,
		218,
		210,
		193,
		196,
		173,
		169,
		158,
		157,
		149,
		135,
		131,
		137,
		140,
		140,
		146,
		119,
		129,
		133,
		131,
		156,
		-1,
		-1,
		191,
		-1,
		-1,
		217,
		200,
		-1,
		183,
		190,
		179,
		185,
		171,
		192,
		168,
		159,
		151,
		145,
		133,
		135,
		132,
		145,
		133,
		116,
		141,
		145,
		126,
		147,
		142,
		-1,
		190,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		176,
		179,
		185,
		209,
		208,
		-1,
		180,
		168,
		169,
		154,
		151,
		138,
		126,
		139,
		124,
		131,
		130,
		120,
		118,
		148,
		123,
		145,
		142,
		161,
		166,
		160,
		169,
		-1,
		225,
		221,
		217,
		224,
		173,
		-1,
		-1,
		213,
		-1,
		216,
		217,
		192,
		165,
		168,
		155,
		146,
		133,
		122,
		133,
		122,
		119,
		127,
		112,
		127,
		118,
		117,
		135,
		145,
		153,
		157,
		163,
		-1,
		275,
		-1,
		217,
		201,
		203,
		175,
		196,
		-1,
		233,
		217,
		209,
		194,
		194,
		-1,
		164,
		161,
		151,
		129,
		114,
		131,
		123,
		121,
		125,
		107,
		121,
		112,
		130,
		137,
		135,
		139,
		159,
		171,
		235,
		225,
		-1,
		207,
		212,
		171,
		179,
		198,
		236,
		200,
		-1,
		195,
		-1,
		166,
		179,
		-1,
		135,
		131,
		113,
		114,
		109,
		124,
		118,
		103,
		100,
		118,
		121,
		128,
		132,
		148,
		-1,
		-1,
		220,
		224,
		213,
		164,
		183,
		207,
		244,
		193,
		182,
		181,
		-1,
		172,
		149,
		146,
		134,
		121,
		106,
		107,
		115,
		128,
		107,
		102,
		99,
		119,
		145,
		123,
		135,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		190,
		161,
		185,
		227,
		211,
		204,
		192,
		157,
		157,
		151,
		-1,
		145,
		124,
		115,
		104,
		102,
		115,
		112,
		117,
		97,
		95,
		114,
		126,
		117,
		134,
		-1,
		-1,
		-1,
		220,
		209,
		210,
		156,
		179,
		216,
		190,
		176,
		181,
		156,
		149,
		143,
		158,
		141,
		122,
		111,
		103,
		92,
		108,
		116,
		111,
		93,
		102,
		108,
		132,
		122,
		128,
		-1,
		-1,
		227,
		217,
		201,
		203,
		200,
		170,
		177,
		209,
		181,
		194,
		-1,
		148,
		-1,
		137,
		132,
		116,
		111,
		108,
		105,
		99,
		108,
		110,
		100,
		95,
		102,
		137,
		137,
		112,
		132,
		135,
		-1,
		-1,
		-1,
		220,
		215,
		190,
		167,
		151,
		187,
		-1,
		164,
		165,
		-1,
		142,
		136,
		133,
		118,
		114,
		109,
		113,
		106,
		113,
		106,
		104,
		105,
		87,
		119,
		-1,
		120,
		114,
		122,
		112,
		100,
		-1,
		-1,
		-1,
		213,
		192,
		185,
		205,
		146,
		198,
		-1,
		-1,
		149,
		142,
		-1,
		129,
		111,
		118,
		116,
		110,
		114,
		111,
		100,
		113,
		106,
		92,
		94,
		107,
		111,
		115,
		102,
		98,
		95,
		109,
		-1,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		166,
		-1,
		158,
		150,
		140,
		134,
		128,
		124,
		122,
		138,
		122,
		125,
		123,
		114,
		122,
		95,
		88,
		95,
		84,
		102,
		110,
		102,
		96,
		95,
		105,
		-1,
		233,
		219,
		190,
		-1,
		-1,
		179,
		-1,
		143,
		157,
		173,
		-1,
		166,
		145,
		160,
		138,
		134,
		130,
		145,
		146,
		124,
		123,
		121,
		112,
		100,
		89,
		92,
		84,
		106,
		106,
		90,
		91,
		95,
		-1,
		239,
		226,
		184,
		180,
		169,
		189,
		140,
		128,
		160,
		-1,
		-1,
		202,
		-1,
		136,
		153,
		144,
		142,
		135,
		126,
		132,
		132,
		109,
		104,
		94,
		83,
		83,
		78,
		100,
		86,
		84,
		93,
		109,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		155,
		142,
		136,
		-1,
		177,
		-1,
		180,
		170,
		154,
		139,
		172,
		-1,
		137,
		127,
		132,
		-1,
		129,
		-1,
		102,
		99,
		90,
		75,
		72,
		83,
		81,
		92,
		88,
		-1,
		189,
		174,
		167,
		157,
		171,
		142,
		-1,
		197,
		-1,
		-1,
		167,
		161,
		161,
		145,
		148,
		153,
		133,
		125,
		132,
		124,
		116,
		110,
		88,
		81,
		78,
		71,
		84,
		94,
		99,
		86,
		-1,
		-1,
		-1,
		194,
		180,
		184,
		144,
		163,
		-1,
		-1,
		229,
		184,
		170,
		-1,
		154,
		153,
		141,
		131,
		121,
		126,
		127,
		107,
		100,
		86,
		88,
		82,
		73,
		72,
		88,
		80,
		102,
		-1,
		-1,
		177,
		182,
		170,
		156,
		175,
		-1,
		-1,
		-1,
		176,
		192,
		181,
		155,
		142,
		-1,
		-1,
		125,
		118,
		112,
		103,
		90,
		102,
		97,
		81,
		66,
		81,
		85,
		93,
		84,
		-1,
		180,
		167,
		-1,
		-1,
		178,
		172,
		-1,
		-1,
		-1,
		-1,
		193,
		138,
		127,
		122,
		126,
		124,
		-1,
		98,
		109,
		94,
		106,
		113,
		83,
		68,
		62,
		68,
		80,
		89,
		-1,
		-1,
		192,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		150,
		144,
		115,
		108,
		112,
		-1,
		100,
		102,
		96,
		111,
		86,
		83,
		74,
		65,
		61,
		65,
		69,
		83,
		87,
		215,
		-1,
		175,
		-1,
		-1,
		-1,
		168,
		183,
		154,
		131,
		104,
		99,
		92,
		86,
		91,
		102,
		94,
		105,
		72,
		68,
		58,
		57,
		61,
		78,
		78,
		-1,
		-1,
		173,
		169,
		194,
		176,
		180,
		181,
		-1,
		-1,
		108,
		99,
		90,
		82,
		95,
		98,
		78,
		75,
		69,
		62,
		56,
		66,
		77,
		72,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		179,
		126,
		108,
		104,
		102,
		91,
		85,
		73,
		78,
		79,
		70,
		64,
		52,
		52,
		75,
		64,
		81,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		141,
		138,
		-1,
		108,
		114,
		79,
		86,
		69,
		76,
		74,
		66,
		46,
		49,
		65,
		64,
		59,
		73,
		64,
		68,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		107,
		76,
		77,
		70,
		65,
		74,
		55,
		42,
		42,
		37,
		52,
		57,
		59,
		52,
		59,
		74,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		85,
		80,
		59,
		51,
		57,
		35,
		42,
		53,
		45,
		49,
		50,
		57,
		68,
		72,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		89,
		84,
		61,
		59,
		56,
		47,
		59,
		43,
		31,
		28,
		37,
		42,
		34,
		60,
		62,
		68,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		154,
		-1,
		139,
		-1,
		122,
		126,
		97,
		100,
		75,
		62,
		48,
		48,
		54,
		43,
		39,
		35,
		24,
		33,
		44,
		56,
		66,
		68,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		160,
		-1,
		144,
		-1,
		-1,
		-1,
		136,
		110,
		102,
		95,
		74,
		74,
		40,
		36,
		48,
		44,
		49,
		41,
		25,
		37,
		50,
		61,
		76,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		167,
		156,
		151,
		138,
		-1,
		-1,
		117,
		120,
		-1,
		-1,
		81,
		57,
		44,
		38,
		42,
		56,
		49,
		37,
		17,
		37,
		32,
		64,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		198,
		223,
		-1,
		127,
		-1,
		-1,
		97,
		-1,
		-1,
		82,
		62,
		51,
		42,
		28,
		50,
		53,
		64,
		13,
		30,
		37,
		47,
		60,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		212,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		80,
		78,
		67,
		-1,
		57,
		39,
		25,
		52,
		20,
		9,
		16,
		10,
		17,
		43,
		56,
		60,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		75,
		68,
		56,
		44,
		34,
		39,
		25,
		21,
		7,
		0,
		8,
		19,
		33,
		37,
		54,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		109,
		93,
		74,
		-1,
		44,
		57,
		57,
		25,
		25,
		19,
		14,
		25,
		36,
		39,
		53,
		48,
		-1,
		-1,
		167,
		166,
		-1,
		-1,
		140,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		81,
		77,
		-1,
		-1,
		45,
		39,
		28,
		31,
		26,
		18,
		24,
		34,
		38,
		42,
		54,
		-1,
		-1,
		161,
		153,
		147,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		83,
		46,
		67,
		46,
		47,
		45,
		36,
		22,
		29,
		39,
		45,
		56,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		82,
		-1,
		50,
		47,
		60,
		45,
		58,
		52,
		25,
		40,
		40,
		43,
		47,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		79,
		58,
		-1,
		92,
		67,
		74,
		59,
		40,
		27,
		34,
		48,
		44,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		72,
		63,
		71,
		64,
		60,
		47,
		47,
		39,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		75,
		73,
		70,
		66,
		57,
		63,
		40,
		76,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		101,
		64,
		52,
		47,
		48,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		63,
		52,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		210,
		199,
		210,
		218,
		191,
		198,
		-1,
		217,
		221,
		187,
		181,
		220,
		189,
		195,
		206,
		-1,
		-1,
		-1,
		210,
		209,
		177,
		175,
		184,
		189,
		196,
		-1,
		195,
		-1,
		231,
		210,
		221,
		226,
		170,
		167,
		187,
		206,
		188,
		180,
		246,
		200,
		171,
		165,
		183,
		173,
		182,
		174,
		-1,
		171,
		161,
		183,
		162,
		173,
		165,
		-1,
		-1,
		165,
		166,
		172,
		158,
		164,
		160,
		-1,
		170,
		154,
		-1,
		-1,
		155,
		156,
		140,
		143,
		151,
		149,
		162,
		154,
		149,
		-1,
		-1,
		146,
		142,
		149,
		136,
		132,
		149,
		162,
		144,
		158,
		157,
		-1,
		150,
		168,
		175,
		143,
		141,
		125,
		123,
		141,
		143,
		149,
		149,
		-1,
		159,
		160,
		155,
		163,
		165,
		141,
		128,
		128,
		138,
		131,
		150,
		138,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		159,
		142,
		159,
		151,
		141,
		156,
		149,
		131,
		128,
		126,
		123,
		139,
		137,
		147,
		-1,
		-1,
		252,
		221,
		250,
		208,
		189,
		-1,
		155,
		135,
		141,
		145,
		139,
		132,
		146,
		142,
		-1,
		117,
		116,
		144,
		130,
		141,
		212,
		-1,
		-1,
		210,
		202,
		185,
		188,
		165,
		161,
		150,
		149,
		141,
		127,
		123,
		129,
		132,
		132,
		138,
		111,
		121,
		125,
		123,
		148,
		-1,
		-1,
		183,
		-1,
		-1,
		209,
		192,
		-1,
		175,
		182,
		171,
		177,
		163,
		184,
		160,
		151,
		143,
		137,
		125,
		127,
		124,
		137,
		125,
		108,
		133,
		137,
		118,
		139,
		134,
		-1,
		182,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		168,
		171,
		177,
		201,
		200,
		-1,
		172,
		160,
		161,
		146,
		143,
		130,
		118,
		131,
		116,
		123,
		122,
		112,
		110,
		140,
		115,
		137,
		134,
		153,
		158,
		152,
		161,
		-1,
		217,
		213,
		209,
		216,
		165,
		-1,
		-1,
		205,
		-1,
		208,
		209,
		184,
		157,
		160,
		147,
		138,
		125,
		114,
		125,
		114,
		111,
		119,
		104,
		119,
		110,
		109,
		127,
		137,
		145,
		149,
		155,
		-1,
		267,
		-1,
		209,
		193,
		195,
		167,
		188,
		-1,
		225,
		209,
		201,
		186,
		186,
		-1,
		156,
		153,
		143,
		121,
		106,
		123,
		115,
		113,
		117,
		99,
		113,
		104,
		122,
		129,
		127,
		131,
		151,
		163,
		227,
		217,
		-1,
		199,
		204,
		163,
		171,
		190,
		228,
		192,
		-1,
		187,
		-1,
		158,
		171,
		-1,
		127,
		123,
		105,
		106,
		101,
		116,
		110,
		95,
		92,
		110,
		113,
		120,
		124,
		140,
		-1,
		-1,
		212,
		216,
		205,
		156,
		175,
		199,
		236,
		185,
		174,
		173,
		-1,
		164,
		141,
		138,
		126,
		113,
		98,
		99,
		107,
		120,
		99,
		94,
		91,
		111,
		137,
		115,
		127,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		182,
		153,
		177,
		219,
		203,
		196,
		184,
		149,
		149,
		143,
		-1,
		137,
		116,
		107,
		96,
		94,
		107,
		104,
		109,
		89,
		87,
		106,
		118,
		109,
		126,
		-1,
		-1,
		-1,
		212,
		201,
		202,
		148,
		171,
		208,
		182,
		168,
		173,
		148,
		141,
		135,
		150,
		133,
		114,
		103,
		95,
		84,
		100,
		108,
		103,
		85,
		94,
		100,
		124,
		114,
		120,
		-1,
		-1,
		219,
		209,
		193,
		195,
		192,
		162,
		169,
		201,
		173,
		186,
		-1,
		140,
		-1,
		129,
		124,
		108,
		103,
		100,
		97,
		91,
		100,
		102,
		92,
		87,
		94,
		129,
		129,
		104,
		124,
		127,
		-1,
		-1,
		-1,
		212,
		207,
		182,
		159,
		143,
		179,
		-1,
		156,
		157,
		-1,
		134,
		128,
		125,
		110,
		106,
		101,
		105,
		98,
		105,
		98,
		96,
		97,
		79,
		111,
		-1,
		112,
		106,
		114,
		104,
		92,
		-1,
		-1,
		-1,
		205,
		184,
		177,
		197,
		138,
		190,
		-1,
		-1,
		141,
		134,
		-1,
		121,
		103,
		110,
		108,
		102,
		106,
		103,
		92,
		105,
		98,
		84,
		86,
		99,
		103,
		107,
		94,
		90,
		87,
		101,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		158,
		-1,
		150,
		142,
		132,
		126,
		120,
		116,
		114,
		130,
		114,
		117,
		115,
		106,
		114,
		87,
		80,
		87,
		76,
		94,
		102,
		94,
		88,
		87,
		97,
		-1,
		225,
		211,
		182,
		-1,
		-1,
		171,
		-1,
		135,
		149,
		165,
		-1,
		158,
		137,
		152,
		130,
		126,
		122,
		137,
		138,
		116,
		115,
		113,
		104,
		92,
		81,
		84,
		76,
		98,
		98,
		82,
		83,
		87,
		-1,
		231,
		218,
		176,
		172,
		161,
		181,
		132,
		120,
		152,
		-1,
		-1,
		194,
		-1,
		128,
		145,
		136,
		134,
		127,
		118,
		124,
		124,
		101,
		96,
		86,
		75,
		75,
		70,
		92,
		78,
		76,
		85,
		101,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		147,
		134,
		128,
		-1,
		169,
		-1,
		172,
		162,
		146,
		131,
		164,
		-1,
		129,
		119,
		124,
		-1,
		121,
		-1,
		94,
		91,
		82,
		67,
		64,
		75,
		73,
		84,
		80,
		-1,
		181,
		166,
		159,
		149,
		163,
		134,
		-1,
		189,
		-1,
		-1,
		159,
		153,
		153,
		137,
		140,
		145,
		125,
		117,
		124,
		116,
		108,
		102,
		80,
		73,
		70,
		63,
		76,
		86,
		91,
		78,
		-1,
		-1,
		-1,
		186,
		172,
		176,
		136,
		155,
		-1,
		-1,
		221,
		176,
		162,
		-1,
		146,
		145,
		133,
		123,
		113,
		118,
		119,
		99,
		92,
		78,
		80,
		74,
		65,
		64,
		80,
		72,
		94,
		-1,
		-1,
		169,
		174,
		162,
		148,
		167,
		-1,
		-1,
		-1,
		168,
		184,
		173,
		147,
		134,
		-1,
		-1,
		117,
		110,
		104,
		95,
		82,
		94,
		89,
		73,
		58,
		73,
		77,
		85,
		76,
		-1,
		172,
		159,
		-1,
		-1,
		170,
		164,
		-1,
		-1,
		-1,
		-1,
		185,
		130,
		119,
		114,
		118,
		116,
		-1,
		90,
		101,
		86,
		98,
		105,
		75,
		60,
		54,
		60,
		72,
		81,
		-1,
		-1,
		184,
		-1,
		179,
		-1,
		-1,
		-1,
		-1,
		142,
		136,
		107,
		100,
		104,
		-1,
		92,
		94,
		88,
		103,
		78,
		75,
		66,
		57,
		53,
		57,
		61,
		75,
		79,
		207,
		-1,
		170,
		-1,
		-1,
		-1,
		160,
		175,
		146,
		123,
		96,
		91,
		84,
		78,
		83,
		94,
		86,
		97,
		64,
		60,
		50,
		49,
		53,
		70,
		70,
		-1,
		-1,
		168,
		164,
		186,
		168,
		172,
		173,
		-1,
		-1,
		100,
		91,
		82,
		74,
		87,
		90,
		70,
		67,
		61,
		54,
		48,
		58,
		69,
		64,
		-1,
		-1,
		-1,
		180,
		-1,
		182,
		-1,
		-1,
		170,
		171,
		118,
		100,
		96,
		94,
		83,
		77,
		65,
		70,
		71,
		62,
		56,
		44,
		44,
		67,
		56,
		73,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		159,
		151,
		146,
		152,
		154,
		145,
		133,
		130,
		-1,
		100,
		106,
		71,
		78,
		61,
		68,
		66,
		58,
		38,
		41,
		57,
		56,
		51,
		65,
		56,
		60,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		152,
		148,
		138,
		128,
		131,
		-1,
		-1,
		125,
		122,
		102,
		71,
		69,
		62,
		57,
		67,
		47,
		34,
		34,
		29,
		44,
		49,
		51,
		44,
		51,
		66,
		-1,
		199,
		236,
		229,
		197,
		205,
		236,
		-1,
		142,
		134,
		145,
		120,
		122,
		-1,
		-1,
		98,
		89,
		90,
		78,
		75,
		77,
		72,
		63,
		43,
		49,
		27,
		34,
		45,
		37,
		41,
		42,
		49,
		60,
		64,
		-1,
		192,
		212,
		191,
		194,
		218,
		232,
		-1,
		139,
		-1,
		-1,
		151,
		123,
		107,
		97,
		94,
		137,
		92,
		87,
		66,
		64,
		60,
		51,
		51,
		35,
		23,
		20,
		29,
		34,
		26,
		52,
		54,
		60,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		159,
		-1,
		134,
		-1,
		117,
		121,
		100,
		103,
		80,
		67,
		53,
		51,
		59,
		35,
		31,
		27,
		16,
		25,
		36,
		48,
		58,
		60,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		151,
		190,
		165,
		-1,
		149,
		-1,
		-1,
		-1,
		131,
		113,
		105,
		100,
		79,
		79,
		45,
		41,
		40,
		36,
		41,
		33,
		17,
		29,
		42,
		53,
		68,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		166,
		157,
		184,
		172,
		161,
		156,
		143,
		-1,
		-1,
		122,
		123,
		-1,
		-1,
		86,
		62,
		49,
		43,
		47,
		50,
		41,
		29,
		9,
		29,
		24,
		56,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		185,
		175,
		179,
		195,
		220,
		-1,
		132,
		-1,
		-1,
		102,
		-1,
		-1,
		87,
		67,
		56,
		47,
		33,
		55,
		45,
		56,
		5,
		22,
		29,
		39,
		52,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		151,
		149,
		155,
		162,
		179,
		209,
		-1,
		-1,
		148,
		128,
		-1,
		-1,
		85,
		83,
		72,
		-1,
		62,
		44,
		30,
		57,
		25,
		14,
		8,
		2,
		9,
		35,
		48,
		52,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		138,
		134,
		-1,
		-1,
		80,
		73,
		61,
		49,
		39,
		44,
		30,
		26,
		12,
		5,
		0,
		11,
		25,
		29,
		46,
		-1,
		222,
		-1,
		174,
		150,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		155,
		141,
		134,
		122,
		120,
		-1,
		114,
		98,
		79,
		-1,
		49,
		62,
		62,
		30,
		30,
		24,
		6,
		17,
		28,
		31,
		45,
		40,
		-1,
		-1,
		162,
		165,
		-1,
		-1,
		145,
		147,
		-1,
		146,
		135,
		120,
		112,
		-1,
		-1,
		86,
		82,
		-1,
		-1,
		50,
		44,
		33,
		36,
		31,
		10,
		16,
		26,
		30,
		34,
		46,
		-1,
		-1,
		166,
		158,
		152,
		-1,
		130,
		-1,
		148,
		-1,
		115,
		121,
		109,
		-1,
		-1,
		-1,
		88,
		51,
		72,
		51,
		39,
		37,
		28,
		14,
		21,
		31,
		37,
		48,
		-1,
		-1,
		-1,
		148,
		122,
		155,
		146,
		129,
		109,
		101,
		120,
		-1,
		87,
		-1,
		55,
		52,
		65,
		47,
		50,
		44,
		17,
		32,
		32,
		35,
		39,
		154,
		-1,
		124,
		157,
		121,
		115,
		91,
		95,
		111,
		-1,
		84,
		63,
		-1,
		92,
		72,
		66,
		51,
		32,
		19,
		26,
		40,
		36,
		-1,
		-1,
		-1,
		126,
		125,
		117,
		111,
		111,
		96,
		87,
		-1,
		99,
		81,
		60,
		77,
		72,
		63,
		63,
		56,
		52,
		39,
		39,
		31,
		-1,
		227,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		120,
		115,
		88,
		76,
		82,
		78,
		64,
		70,
		72,
		75,
		65,
		62,
		58,
		49,
		55,
		32,
		68,
		-1,
		222,
		-1,
		156,
		-1,
		-1,
		138,
		118,
		110,
		99,
		88,
		86,
		77,
		68,
		90,
		106,
		56,
		44,
		39,
		40,
		-1,
		211,
		210,
		-1,
		157,
		149,
		135,
		-1,
		128,
		-1,
		134,
		95,
		-1,
		97,
		77,
		-1,
		55,
		44,
		-1,
		-1,
		198,
		173,
		-1,
		-1,
		-1,
		158,
		138,
		129,
		113,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		183,
		182,
		-1,
		151,
		154,
		-1,
		144,
		135,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		192,
		173,
		167,
		166,
		164,
		159,
		156,
		142,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		164,
		156,
		149,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		175,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		197,
		198,
		221,
		185,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		200,
		198,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		229,
		218,
		229,
		237,
		210,
		217,
		-1,
		236,
		240,
		206,
		200,
		239,
		208,
		214,
		225,
		-1,
		-1,
		-1,
		229,
		228,
		196,
		194,
		203,
		208,
		215,
		-1,
		214,
		-1,
		250,
		229,
		240,
		245,
		189,
		186,
		206,
		225,
		207,
		199,
		265,
		219,
		190,
		184,
		202,
		192,
		201,
		193,
		-1,
		190,
		180,
		202,
		181,
		192,
		184,
		-1,
		-1,
		184,
		185,
		191,
		177,
		183,
		179,
		-1,
		189,
		173,
		-1,
		-1,
		174,
		175,
		159,
		162,
		170,
		168,
		181,
		173,
		168,
		-1,
		-1,
		165,
		161,
		168,
		155,
		151,
		168,
		181,
		163,
		177,
		176,
		-1,
		169,
		187,
		194,
		162,
		160,
		144,
		142,
		160,
		162,
		168,
		168,
		-1,
		178,
		179,
		174,
		182,
		184,
		160,
		147,
		147,
		157,
		150,
		169,
		157,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		178,
		161,
		178,
		170,
		160,
		175,
		168,
		150,
		147,
		145,
		142,
		158,
		156,
		166,
		-1,
		-1,
		271,
		240,
		269,
		227,
		208,
		-1,
		174,
		154,
		160,
		164,
		158,
		151,
		165,
		161,
		-1,
		136,
		135,
		163,
		149,
		160,
		231,
		-1,
		-1,
		229,
		221,
		204,
		207,
		184,
		180,
		169,
		168,
		160,
		146,
		142,
		148,
		151,
		151,
		157,
		130,
		140,
		144,
		142,
		167,
		-1,
		-1,
		202,
		-1,
		-1,
		228,
		211,
		-1,
		194,
		201,
		190,
		196,
		182,
		203,
		179,
		170,
		162,
		156,
		144,
		146,
		143,
		156,
		144,
		127,
		152,
		156,
		137,
		158,
		153,
		-1,
		201,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		187,
		190,
		196,
		220,
		219,
		-1,
		191,
		179,
		180,
		165,
		162,
		149,
		137,
		150,
		135,
		142,
		141,
		131,
		129,
		159,
		134,
		156,
		153,
		172,
		177,
		171,
		180,
		-1,
		236,
		232,
		228,
		235,
		184,
		-1,
		-1,
		224,
		-1,
		227,
		228,
		203,
		176,
		179,
		166,
		157,
		144,
		133,
		144,
		133,
		130,
		138,
		123,
		138,
		129,
		128,
		146,
		156,
		164,
		168,
		174,
		-1,
		286,
		-1,
		228,
		212,
		214,
		186,
		207,
		-1,
		244,
		228,
		220,
		205,
		205,
		-1,
		175,
		172,
		162,
		140,
		125,
		142,
		134,
		132,
		136,
		118,
		132,
		123,
		141,
		148,
		146,
		150,
		170,
		182,
		246,
		236,
		-1,
		218,
		223,
		182,
		190,
		209,
		247,
		211,
		-1,
		206,
		-1,
		177,
		190,
		-1,
		146,
		142,
		124,
		125,
		120,
		135,
		129,
		114,
		111,
		129,
		132,
		139,
		143,
		159,
		-1,
		-1,
		231,
		235,
		224,
		175,
		194,
		218,
		255,
		204,
		193,
		192,
		-1,
		183,
		160,
		157,
		145,
		132,
		117,
		118,
		126,
		139,
		118,
		113,
		110,
		130,
		156,
		134,
		146,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		201,
		172,
		196,
		238,
		222,
		215,
		203,
		168,
		168,
		162,
		-1,
		156,
		135,
		126,
		115,
		113,
		126,
		123,
		128,
		108,
		106,
		125,
		137,
		128,
		145,
		-1,
		-1,
		-1,
		231,
		220,
		221,
		167,
		190,
		227,
		201,
		187,
		192,
		167,
		160,
		154,
		169,
		152,
		133,
		122,
		114,
		103,
		119,
		127,
		122,
		104,
		113,
		119,
		143,
		133,
		139,
		-1,
		-1,
		238,
		228,
		212,
		214,
		211,
		181,
		188,
		220,
		192,
		205,
		-1,
		159,
		-1,
		148,
		143,
		127,
		122,
		119,
		116,
		110,
		119,
		121,
		111,
		106,
		113,
		148,
		148,
		123,
		143,
		146,
		-1,
		-1,
		-1,
		231,
		226,
		201,
		178,
		162,
		198,
		-1,
		175,
		176,
		-1,
		153,
		147,
		144,
		129,
		125,
		120,
		124,
		117,
		124,
		117,
		115,
		116,
		98,
		130,
		-1,
		131,
		125,
		133,
		123,
		111,
		-1,
		-1,
		-1,
		224,
		203,
		196,
		216,
		157,
		209,
		-1,
		-1,
		160,
		153,
		-1,
		140,
		122,
		129,
		127,
		121,
		125,
		122,
		111,
		124,
		117,
		103,
		105,
		118,
		122,
		126,
		113,
		109,
		106,
		120,
		-1,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		177,
		-1,
		169,
		161,
		151,
		145,
		139,
		135,
		133,
		149,
		133,
		136,
		134,
		125,
		133,
		106,
		99,
		106,
		95,
		113,
		121,
		113,
		107,
		106,
		116,
		-1,
		244,
		230,
		201,
		-1,
		-1,
		190,
		-1,
		154,
		168,
		184,
		-1,
		177,
		156,
		171,
		149,
		145,
		141,
		156,
		157,
		135,
		134,
		132,
		123,
		111,
		100,
		103,
		95,
		117,
		117,
		101,
		102,
		106,
		-1,
		250,
		237,
		195,
		191,
		180,
		200,
		151,
		139,
		171,
		-1,
		-1,
		213,
		-1,
		147,
		164,
		155,
		153,
		146,
		137,
		143,
		143,
		120,
		115,
		105,
		94,
		94,
		89,
		111,
		97,
		95,
		104,
		120,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		166,
		153,
		147,
		-1,
		188,
		-1,
		191,
		181,
		165,
		150,
		183,
		-1,
		148,
		138,
		143,
		-1,
		140,
		-1,
		113,
		110,
		101,
		86,
		83,
		94,
		92,
		103,
		99,
		-1,
		200,
		185,
		178,
		168,
		182,
		153,
		-1,
		208,
		-1,
		-1,
		178,
		172,
		172,
		156,
		159,
		164,
		144,
		136,
		143,
		135,
		127,
		121,
		99,
		92,
		89,
		82,
		95,
		105,
		110,
		97,
		-1,
		-1,
		-1,
		205,
		191,
		195,
		155,
		174,
		-1,
		-1,
		240,
		195,
		181,
		-1,
		165,
		164,
		152,
		142,
		132,
		137,
		138,
		118,
		111,
		97,
		99,
		93,
		84,
		83,
		99,
		91,
		113,
		-1,
		-1,
		188,
		193,
		181,
		167,
		186,
		-1,
		-1,
		-1,
		187,
		203,
		192,
		166,
		153,
		-1,
		-1,
		136,
		129,
		123,
		114,
		101,
		113,
		108,
		92,
		77,
		92,
		96,
		104,
		95,
		-1,
		191,
		178,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		-1,
		-1,
		204,
		149,
		138,
		133,
		137,
		135,
		-1,
		109,
		120,
		105,
		117,
		124,
		94,
		79,
		73,
		79,
		91,
		100,
		-1,
		-1,
		203,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		161,
		155,
		126,
		119,
		123,
		-1,
		111,
		113,
		107,
		122,
		97,
		94,
		85,
		76,
		72,
		76,
		80,
		94,
		98,
		226,
		-1,
		189,
		-1,
		-1,
		-1,
		179,
		194,
		165,
		142,
		115,
		110,
		103,
		97,
		102,
		113,
		105,
		116,
		83,
		79,
		69,
		68,
		72,
		89,
		89,
		-1,
		-1,
		187,
		183,
		205,
		187,
		191,
		192,
		-1,
		-1,
		119,
		110,
		101,
		93,
		106,
		109,
		89,
		86,
		80,
		73,
		67,
		77,
		88,
		83,
		-1,
		-1,
		-1,
		199,
		-1,
		201,
		-1,
		-1,
		189,
		190,
		137,
		119,
		115,
		113,
		102,
		96,
		84,
		89,
		90,
		81,
		75,
		63,
		63,
		86,
		75,
		92,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		178,
		170,
		165,
		171,
		173,
		164,
		152,
		149,
		-1,
		119,
		125,
		90,
		97,
		80,
		87,
		85,
		77,
		57,
		60,
		76,
		75,
		70,
		84,
		75,
		79,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		144,
		141,
		121,
		90,
		88,
		81,
		76,
		86,
		66,
		53,
		53,
		48,
		63,
		68,
		70,
		63,
		70,
		85,
		-1,
		218,
		255,
		248,
		216,
		224,
		255,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		117,
		108,
		109,
		97,
		94,
		96,
		91,
		82,
		62,
		68,
		46,
		53,
		64,
		56,
		60,
		61,
		68,
		79,
		83,
		-1,
		211,
		231,
		210,
		213,
		237,
		251,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		113,
		156,
		111,
		106,
		85,
		83,
		79,
		70,
		70,
		54,
		42,
		39,
		48,
		53,
		45,
		71,
		73,
		79,
		-1,
		200,
		211,
		204,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		178,
		-1,
		153,
		-1,
		136,
		140,
		119,
		122,
		99,
		86,
		72,
		70,
		78,
		54,
		50,
		46,
		35,
		44,
		55,
		62,
		72,
		79,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		170,
		209,
		184,
		-1,
		168,
		-1,
		-1,
		-1,
		150,
		132,
		124,
		119,
		98,
		98,
		64,
		60,
		59,
		55,
		60,
		52,
		36,
		45,
		56,
		67,
		82,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		185,
		176,
		203,
		191,
		180,
		175,
		162,
		-1,
		-1,
		141,
		142,
		-1,
		-1,
		105,
		81,
		68,
		62,
		66,
		69,
		60,
		48,
		28,
		44,
		38,
		70,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		204,
		194,
		198,
		214,
		239,
		-1,
		151,
		-1,
		-1,
		121,
		-1,
		-1,
		106,
		86,
		75,
		66,
		52,
		74,
		64,
		75,
		24,
		35,
		43,
		50,
		61,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		228,
		-1,
		-1,
		167,
		147,
		-1,
		-1,
		104,
		102,
		91,
		-1,
		81,
		63,
		49,
		76,
		44,
		31,
		27,
		21,
		22,
		37,
		50,
		54,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		157,
		153,
		-1,
		-1,
		99,
		92,
		80,
		68,
		58,
		63,
		49,
		45,
		31,
		24,
		19,
		0,
		27,
		31,
		48,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		174,
		160,
		153,
		141,
		139,
		-1,
		133,
		117,
		98,
		-1,
		68,
		81,
		81,
		49,
		49,
		43,
		25,
		23,
		28,
		33,
		47,
		42,
		-1,
		-1,
		181,
		184,
		-1,
		-1,
		164,
		166,
		-1,
		165,
		154,
		139,
		131,
		-1,
		-1,
		105,
		101,
		-1,
		-1,
		69,
		63,
		52,
		55,
		50,
		29,
		28,
		40,
		32,
		36,
		48,
		-1,
		-1,
		185,
		177,
		171,
		-1,
		149,
		-1,
		167,
		-1,
		134,
		140,
		128,
		-1,
		-1,
		-1,
		107,
		70,
		91,
		70,
		58,
		56,
		47,
		33,
		40,
		43,
		39,
		50,
		-1,
		-1,
		-1,
		167,
		141,
		174,
		165,
		148,
		128,
		120,
		139,
		-1,
		106,
		-1,
		74,
		71,
		84,
		66,
		69,
		63,
		36,
		51,
		46,
		37,
		46,
		173,
		-1,
		143,
		176,
		140,
		134,
		110,
		114,
		130,
		-1,
		103,
		82,
		-1,
		111,
		91,
		85,
		70,
		51,
		38,
		45,
		50,
		43,
		-1,
		-1,
		-1,
		145,
		144,
		136,
		130,
		130,
		115,
		106,
		-1,
		118,
		100,
		79,
		96,
		91,
		82,
		82,
		75,
		71,
		58,
		58,
		50,
		-1,
		246,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		139,
		134,
		107,
		95,
		101,
		97,
		83,
		89,
		91,
		94,
		84,
		81,
		77,
		68,
		74,
		51,
		87,
		-1,
		241,
		-1,
		175,
		-1,
		-1,
		157,
		137,
		129,
		118,
		107,
		105,
		96,
		87,
		109,
		125,
		75,
		63,
		58,
		59,
		-1,
		230,
		229,
		-1,
		176,
		168,
		154,
		-1,
		147,
		-1,
		153,
		114,
		-1,
		116,
		96,
		-1,
		74,
		63,
		-1,
		-1,
		217,
		192,
		-1,
		-1,
		-1,
		177,
		157,
		148,
		132,
		-1,
		107,
		107,
		-1,
		-1,
		-1,
		202,
		201,
		-1,
		170,
		173,
		-1,
		163,
		154,
		162,
		109,
		113,
		-1,
		-1,
		-1,
		211,
		192,
		186,
		185,
		183,
		178,
		175,
		161,
		145,
		123,
		112,
		133,
		-1,
		-1,
		-1,
		183,
		175,
		168,
		-1,
		-1,
		170,
		153,
		134,
		132,
		-1,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		160,
		-1,
		-1,
		166,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		194,
		-1,
		-1,
		-1,
		156,
		152,
		153,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		240,
		204,
		-1,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		219,
		217,
		-1,
		-1,
		-1,
		176,
		160,
		-1,
		146,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		181,
		-1,
		181,
		156,
		163,
		-1,
		-1,
		-1,
		-1,
		194,
		186,
		194,
		-1,
		166,
		168,
		-1,
		216,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		171,
		178,
		200,
		203,
		239,
		-1,
		190
	],
	[
		-1,
		216,
		205,
		216,
		224,
		197,
		204,
		-1,
		223,
		227,
		193,
		187,
		226,
		195,
		201,
		212,
		-1,
		-1,
		-1,
		216,
		215,
		183,
		181,
		190,
		195,
		202,
		-1,
		201,
		-1,
		237,
		216,
		227,
		232,
		176,
		173,
		193,
		212,
		194,
		186,
		252,
		206,
		177,
		171,
		189,
		179,
		188,
		180,
		-1,
		177,
		167,
		189,
		168,
		179,
		171,
		-1,
		-1,
		171,
		172,
		178,
		164,
		170,
		166,
		-1,
		176,
		160,
		-1,
		-1,
		161,
		162,
		146,
		149,
		157,
		155,
		168,
		160,
		155,
		-1,
		-1,
		152,
		148,
		155,
		142,
		138,
		155,
		168,
		150,
		164,
		163,
		-1,
		156,
		174,
		181,
		149,
		147,
		131,
		129,
		147,
		149,
		155,
		155,
		-1,
		165,
		166,
		161,
		169,
		171,
		147,
		134,
		134,
		144,
		137,
		156,
		144,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		165,
		148,
		165,
		157,
		147,
		162,
		155,
		137,
		134,
		132,
		129,
		145,
		143,
		153,
		-1,
		-1,
		258,
		227,
		256,
		214,
		195,
		-1,
		161,
		141,
		147,
		151,
		145,
		138,
		152,
		148,
		-1,
		123,
		122,
		150,
		136,
		147,
		218,
		-1,
		-1,
		216,
		208,
		191,
		194,
		171,
		167,
		156,
		155,
		147,
		133,
		129,
		135,
		138,
		138,
		144,
		117,
		127,
		131,
		129,
		154,
		-1,
		-1,
		189,
		-1,
		-1,
		215,
		198,
		-1,
		181,
		188,
		177,
		183,
		169,
		190,
		166,
		157,
		149,
		143,
		131,
		133,
		130,
		143,
		131,
		114,
		139,
		143,
		124,
		145,
		140,
		-1,
		188,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		174,
		177,
		183,
		207,
		206,
		-1,
		178,
		166,
		167,
		152,
		149,
		136,
		124,
		137,
		122,
		129,
		128,
		118,
		116,
		146,
		121,
		143,
		140,
		159,
		164,
		158,
		167,
		-1,
		223,
		219,
		215,
		222,
		171,
		-1,
		-1,
		211,
		-1,
		214,
		215,
		190,
		163,
		166,
		153,
		144,
		131,
		120,
		131,
		120,
		117,
		125,
		110,
		125,
		116,
		115,
		133,
		143,
		151,
		155,
		161,
		-1,
		273,
		-1,
		215,
		199,
		201,
		173,
		194,
		-1,
		231,
		215,
		207,
		192,
		192,
		-1,
		162,
		159,
		149,
		127,
		112,
		129,
		121,
		119,
		123,
		105,
		119,
		110,
		128,
		135,
		133,
		137,
		157,
		169,
		233,
		223,
		-1,
		205,
		210,
		169,
		177,
		196,
		234,
		198,
		-1,
		193,
		-1,
		164,
		177,
		-1,
		133,
		129,
		111,
		112,
		107,
		122,
		116,
		101,
		98,
		116,
		119,
		126,
		130,
		146,
		-1,
		-1,
		218,
		222,
		211,
		162,
		181,
		205,
		242,
		191,
		180,
		179,
		-1,
		170,
		147,
		144,
		132,
		119,
		104,
		105,
		113,
		126,
		105,
		100,
		97,
		117,
		143,
		121,
		133,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		188,
		159,
		183,
		225,
		209,
		202,
		190,
		155,
		155,
		149,
		-1,
		143,
		122,
		113,
		102,
		100,
		113,
		110,
		115,
		95,
		93,
		112,
		124,
		115,
		132,
		-1,
		-1,
		-1,
		218,
		207,
		208,
		154,
		177,
		214,
		188,
		174,
		179,
		154,
		147,
		141,
		156,
		139,
		120,
		109,
		101,
		90,
		106,
		114,
		109,
		91,
		100,
		106,
		130,
		120,
		126,
		-1,
		-1,
		225,
		215,
		199,
		201,
		198,
		168,
		175,
		207,
		179,
		192,
		-1,
		146,
		-1,
		135,
		130,
		114,
		109,
		106,
		103,
		97,
		106,
		108,
		98,
		93,
		100,
		135,
		135,
		110,
		130,
		133,
		-1,
		-1,
		-1,
		218,
		213,
		188,
		165,
		149,
		185,
		-1,
		162,
		163,
		-1,
		140,
		134,
		131,
		116,
		112,
		107,
		111,
		104,
		111,
		104,
		102,
		103,
		85,
		117,
		-1,
		118,
		112,
		120,
		110,
		98,
		-1,
		-1,
		-1,
		211,
		190,
		183,
		203,
		144,
		196,
		-1,
		-1,
		147,
		140,
		-1,
		127,
		109,
		116,
		114,
		108,
		112,
		109,
		98,
		111,
		104,
		90,
		92,
		105,
		109,
		113,
		100,
		96,
		93,
		107,
		-1,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		164,
		-1,
		156,
		148,
		138,
		132,
		126,
		122,
		120,
		136,
		120,
		123,
		121,
		112,
		120,
		93,
		86,
		93,
		82,
		100,
		108,
		100,
		94,
		93,
		103,
		-1,
		231,
		217,
		188,
		-1,
		-1,
		177,
		-1,
		141,
		155,
		171,
		-1,
		164,
		143,
		158,
		136,
		132,
		128,
		143,
		144,
		122,
		121,
		119,
		110,
		98,
		87,
		90,
		82,
		104,
		104,
		88,
		89,
		93,
		-1,
		237,
		224,
		182,
		178,
		167,
		187,
		138,
		126,
		158,
		-1,
		-1,
		200,
		-1,
		134,
		151,
		142,
		140,
		133,
		124,
		130,
		130,
		107,
		102,
		92,
		81,
		81,
		76,
		98,
		84,
		82,
		91,
		107,
		-1,
		-1,
		-1,
		204,
		-1,
		-1,
		153,
		140,
		134,
		-1,
		175,
		-1,
		178,
		168,
		152,
		137,
		170,
		-1,
		135,
		125,
		130,
		-1,
		127,
		-1,
		100,
		97,
		88,
		73,
		70,
		81,
		79,
		90,
		86,
		-1,
		187,
		172,
		165,
		155,
		169,
		140,
		-1,
		195,
		-1,
		-1,
		165,
		159,
		159,
		143,
		146,
		151,
		131,
		123,
		130,
		122,
		114,
		108,
		86,
		79,
		76,
		69,
		82,
		92,
		97,
		84,
		-1,
		-1,
		-1,
		192,
		178,
		182,
		142,
		161,
		-1,
		-1,
		227,
		182,
		168,
		-1,
		152,
		151,
		139,
		129,
		119,
		124,
		125,
		105,
		98,
		84,
		86,
		80,
		71,
		70,
		86,
		78,
		100,
		-1,
		-1,
		175,
		180,
		168,
		154,
		173,
		-1,
		-1,
		-1,
		174,
		190,
		179,
		153,
		140,
		-1,
		-1,
		123,
		116,
		110,
		101,
		88,
		100,
		95,
		79,
		64,
		79,
		83,
		91,
		82,
		-1,
		178,
		165,
		-1,
		-1,
		176,
		170,
		-1,
		-1,
		-1,
		-1,
		191,
		136,
		125,
		120,
		124,
		122,
		-1,
		96,
		107,
		92,
		104,
		111,
		81,
		66,
		60,
		66,
		78,
		87,
		-1,
		-1,
		190,
		-1,
		185,
		-1,
		-1,
		-1,
		-1,
		148,
		142,
		113,
		106,
		110,
		-1,
		98,
		100,
		94,
		109,
		84,
		81,
		72,
		63,
		59,
		63,
		67,
		81,
		85,
		213,
		-1,
		176,
		-1,
		-1,
		-1,
		166,
		181,
		152,
		129,
		102,
		97,
		90,
		84,
		89,
		100,
		92,
		103,
		70,
		66,
		56,
		55,
		59,
		76,
		76,
		-1,
		-1,
		174,
		170,
		192,
		174,
		178,
		179,
		-1,
		-1,
		106,
		97,
		88,
		80,
		93,
		96,
		76,
		73,
		67,
		60,
		54,
		64,
		75,
		70,
		-1,
		-1,
		-1,
		186,
		-1,
		188,
		-1,
		-1,
		176,
		177,
		124,
		106,
		102,
		100,
		89,
		83,
		71,
		76,
		77,
		68,
		62,
		50,
		50,
		73,
		62,
		79,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		165,
		157,
		152,
		158,
		160,
		151,
		139,
		136,
		-1,
		106,
		112,
		77,
		84,
		67,
		74,
		72,
		64,
		44,
		47,
		63,
		62,
		57,
		71,
		62,
		66,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		158,
		154,
		144,
		134,
		137,
		-1,
		-1,
		131,
		128,
		108,
		77,
		75,
		68,
		63,
		73,
		53,
		40,
		40,
		35,
		50,
		55,
		57,
		50,
		57,
		72,
		-1,
		205,
		242,
		235,
		203,
		211,
		242,
		-1,
		148,
		140,
		151,
		126,
		128,
		-1,
		-1,
		104,
		95,
		96,
		84,
		81,
		83,
		78,
		69,
		49,
		55,
		33,
		40,
		51,
		43,
		47,
		48,
		55,
		66,
		70,
		-1,
		198,
		218,
		197,
		200,
		224,
		238,
		-1,
		145,
		-1,
		-1,
		157,
		129,
		113,
		103,
		100,
		143,
		98,
		93,
		77,
		75,
		66,
		57,
		57,
		41,
		29,
		26,
		35,
		40,
		32,
		53,
		60,
		55,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		170,
		-1,
		140,
		-1,
		123,
		127,
		106,
		109,
		91,
		78,
		70,
		57,
		66,
		41,
		37,
		33,
		22,
		19,
		31,
		35,
		45,
		63,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		157,
		196,
		176,
		-1,
		160,
		-1,
		-1,
		-1,
		137,
		119,
		111,
		111,
		90,
		90,
		64,
		60,
		46,
		42,
		49,
		39,
		29,
		18,
		29,
		40,
		55,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		172,
		163,
		190,
		183,
		172,
		167,
		154,
		-1,
		-1,
		148,
		129,
		-1,
		-1,
		97,
		85,
		68,
		57,
		53,
		56,
		64,
		48,
		28,
		17,
		11,
		43,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		170,
		191,
		181,
		185,
		201,
		226,
		-1,
		143,
		-1,
		-1,
		128,
		-1,
		-1,
		113,
		90,
		79,
		70,
		59,
		61,
		68,
		79,
		31,
		23,
		16,
		23,
		34,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		157,
		155,
		161,
		168,
		185,
		215,
		-1,
		-1,
		159,
		139,
		-1,
		-1,
		111,
		109,
		98,
		-1,
		88,
		70,
		56,
		83,
		51,
		40,
		34,
		28,
		14,
		10,
		23,
		27,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		145,
		-1,
		-1,
		106,
		99,
		87,
		75,
		65,
		70,
		56,
		52,
		38,
		31,
		26,
		28,
		0,
		4,
		21,
		-1,
		228,
		-1,
		180,
		156,
		170,
		185,
		193,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		140,
		124,
		105,
		-1,
		75,
		88,
		88,
		56,
		56,
		50,
		32,
		29,
		3,
		6,
		20,
		15,
		-1,
		-1,
		168,
		171,
		-1,
		-1,
		156,
		158,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		112,
		108,
		-1,
		-1,
		76,
		70,
		59,
		62,
		57,
		33,
		27,
		16,
		5,
		9,
		21,
		-1,
		-1,
		175,
		169,
		163,
		-1,
		141,
		-1,
		159,
		-1,
		126,
		132,
		120,
		-1,
		-1,
		-1,
		114,
		77,
		98,
		77,
		54,
		52,
		43,
		29,
		20,
		16,
		12,
		23,
		-1,
		-1,
		-1,
		159,
		133,
		166,
		157,
		140,
		120,
		112,
		131,
		-1,
		101,
		-1,
		76,
		78,
		84,
		62,
		65,
		59,
		32,
		47,
		19,
		10,
		19,
		165,
		-1,
		135,
		168,
		132,
		126,
		102,
		106,
		122,
		-1,
		98,
		80,
		-1,
		91,
		78,
		82,
		67,
		48,
		35,
		38,
		23,
		16,
		-1,
		-1,
		-1,
		137,
		136,
		128,
		122,
		122,
		107,
		98,
		-1,
		110,
		92,
		71,
		86,
		71,
		62,
		62,
		72,
		68,
		55,
		53,
		32,
		-1,
		238,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		131,
		126,
		99,
		87,
		93,
		89,
		75,
		81,
		81,
		74,
		64,
		61,
		57,
		48,
		54,
		31,
		64,
		-1,
		233,
		-1,
		167,
		-1,
		-1,
		149,
		129,
		121,
		110,
		99,
		97,
		88,
		79,
		101,
		105,
		55,
		43,
		38,
		39,
		-1,
		222,
		221,
		-1,
		168,
		160,
		146,
		-1,
		139,
		-1,
		145,
		106,
		-1,
		108,
		88,
		-1,
		54,
		43,
		-1,
		-1,
		209,
		184,
		-1,
		-1,
		-1,
		169,
		149,
		140,
		124,
		-1,
		99,
		99,
		-1,
		-1,
		-1,
		194,
		193,
		-1,
		162,
		165,
		-1,
		155,
		146,
		154,
		101,
		105,
		-1,
		-1,
		-1,
		203,
		184,
		178,
		177,
		175,
		170,
		167,
		153,
		137,
		115,
		104,
		125,
		-1,
		-1,
		-1,
		175,
		167,
		160,
		-1,
		-1,
		162,
		145,
		126,
		124,
		-1,
		-1,
		-1,
		197,
		178,
		-1,
		-1,
		152,
		-1,
		-1,
		158,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		186,
		-1,
		-1,
		-1,
		148,
		144,
		145,
		-1,
		-1,
		-1,
		-1,
		208,
		209,
		232,
		196,
		-1,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		211,
		209,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		138,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		173,
		-1,
		173,
		148,
		155,
		-1,
		-1,
		-1,
		-1,
		186,
		178,
		186,
		-1,
		158,
		160,
		-1,
		208,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		163,
		170,
		192,
		195,
		231,
		-1,
		182
	],
	[
		-1,
		224,
		213,
		224,
		232,
		205,
		212,
		-1,
		231,
		235,
		201,
		195,
		234,
		203,
		209,
		220,
		-1,
		-1,
		-1,
		224,
		223,
		191,
		189,
		198,
		203,
		210,
		-1,
		209,
		-1,
		245,
		224,
		235,
		240,
		184,
		181,
		201,
		220,
		202,
		194,
		260,
		214,
		185,
		179,
		197,
		187,
		196,
		188,
		-1,
		185,
		175,
		197,
		176,
		187,
		179,
		-1,
		-1,
		179,
		180,
		186,
		172,
		178,
		174,
		-1,
		184,
		168,
		-1,
		-1,
		169,
		170,
		154,
		157,
		165,
		163,
		176,
		168,
		163,
		-1,
		-1,
		160,
		156,
		163,
		150,
		146,
		163,
		176,
		158,
		172,
		171,
		-1,
		164,
		182,
		189,
		157,
		155,
		139,
		137,
		155,
		157,
		163,
		163,
		-1,
		173,
		174,
		169,
		177,
		179,
		155,
		142,
		142,
		152,
		145,
		164,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		156,
		173,
		165,
		155,
		170,
		163,
		145,
		142,
		140,
		137,
		153,
		151,
		161,
		-1,
		-1,
		266,
		235,
		264,
		222,
		203,
		-1,
		169,
		149,
		155,
		159,
		153,
		146,
		160,
		156,
		-1,
		131,
		130,
		158,
		144,
		155,
		226,
		-1,
		-1,
		224,
		216,
		199,
		202,
		179,
		175,
		164,
		163,
		155,
		141,
		137,
		143,
		146,
		146,
		152,
		125,
		135,
		139,
		137,
		162,
		-1,
		-1,
		197,
		-1,
		-1,
		223,
		206,
		-1,
		189,
		196,
		185,
		191,
		177,
		198,
		174,
		165,
		157,
		151,
		139,
		141,
		138,
		151,
		139,
		122,
		147,
		151,
		132,
		153,
		148,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		182,
		185,
		191,
		215,
		214,
		-1,
		186,
		174,
		175,
		160,
		157,
		144,
		132,
		145,
		130,
		137,
		136,
		126,
		124,
		154,
		129,
		151,
		148,
		167,
		172,
		166,
		175,
		-1,
		231,
		227,
		223,
		230,
		179,
		-1,
		-1,
		219,
		-1,
		222,
		223,
		198,
		171,
		174,
		161,
		152,
		139,
		128,
		139,
		128,
		125,
		133,
		118,
		133,
		124,
		123,
		141,
		151,
		159,
		163,
		169,
		-1,
		281,
		-1,
		223,
		207,
		209,
		181,
		202,
		-1,
		239,
		223,
		215,
		200,
		200,
		-1,
		170,
		167,
		157,
		135,
		120,
		137,
		129,
		127,
		131,
		113,
		127,
		118,
		136,
		143,
		141,
		145,
		165,
		177,
		241,
		231,
		-1,
		213,
		218,
		177,
		185,
		204,
		242,
		206,
		-1,
		201,
		-1,
		172,
		185,
		-1,
		141,
		137,
		119,
		120,
		115,
		130,
		124,
		109,
		106,
		124,
		127,
		134,
		138,
		154,
		-1,
		-1,
		226,
		230,
		219,
		170,
		189,
		213,
		250,
		199,
		188,
		187,
		-1,
		178,
		155,
		152,
		140,
		127,
		112,
		113,
		121,
		134,
		113,
		108,
		105,
		125,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		196,
		167,
		191,
		233,
		217,
		210,
		198,
		163,
		163,
		157,
		-1,
		151,
		130,
		121,
		110,
		108,
		121,
		118,
		123,
		103,
		101,
		120,
		132,
		123,
		140,
		-1,
		-1,
		-1,
		226,
		215,
		216,
		162,
		185,
		222,
		196,
		182,
		187,
		162,
		155,
		149,
		164,
		147,
		128,
		117,
		109,
		98,
		114,
		122,
		117,
		99,
		108,
		114,
		138,
		128,
		134,
		-1,
		-1,
		233,
		223,
		207,
		209,
		206,
		176,
		183,
		215,
		187,
		200,
		-1,
		154,
		-1,
		143,
		138,
		122,
		117,
		114,
		111,
		105,
		114,
		116,
		106,
		101,
		108,
		143,
		143,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		226,
		221,
		196,
		173,
		157,
		193,
		-1,
		170,
		171,
		-1,
		148,
		142,
		139,
		124,
		120,
		115,
		119,
		112,
		119,
		112,
		110,
		111,
		93,
		125,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		219,
		198,
		191,
		211,
		152,
		204,
		-1,
		-1,
		155,
		148,
		-1,
		135,
		117,
		124,
		122,
		116,
		120,
		117,
		106,
		119,
		112,
		98,
		100,
		113,
		117,
		121,
		108,
		104,
		101,
		115,
		-1,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		172,
		-1,
		164,
		156,
		146,
		140,
		134,
		130,
		128,
		144,
		128,
		131,
		129,
		120,
		128,
		101,
		94,
		101,
		90,
		108,
		116,
		108,
		102,
		101,
		111,
		-1,
		239,
		225,
		196,
		-1,
		-1,
		185,
		-1,
		149,
		163,
		179,
		-1,
		172,
		151,
		166,
		144,
		140,
		136,
		151,
		152,
		130,
		129,
		127,
		118,
		106,
		95,
		98,
		90,
		112,
		112,
		96,
		97,
		101,
		-1,
		245,
		232,
		190,
		186,
		175,
		195,
		146,
		134,
		166,
		-1,
		-1,
		208,
		-1,
		142,
		159,
		150,
		148,
		141,
		132,
		138,
		138,
		115,
		110,
		100,
		89,
		89,
		84,
		106,
		92,
		90,
		99,
		115,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		161,
		148,
		142,
		-1,
		183,
		-1,
		186,
		176,
		160,
		145,
		178,
		-1,
		143,
		133,
		138,
		-1,
		135,
		-1,
		108,
		105,
		96,
		81,
		78,
		89,
		87,
		98,
		94,
		-1,
		195,
		180,
		173,
		163,
		177,
		148,
		-1,
		203,
		-1,
		-1,
		173,
		167,
		167,
		151,
		154,
		159,
		139,
		131,
		138,
		130,
		122,
		116,
		94,
		87,
		84,
		77,
		90,
		100,
		105,
		92,
		-1,
		-1,
		-1,
		200,
		186,
		190,
		150,
		169,
		-1,
		-1,
		235,
		190,
		176,
		-1,
		160,
		159,
		147,
		137,
		127,
		132,
		133,
		113,
		106,
		92,
		94,
		88,
		79,
		78,
		94,
		86,
		108,
		-1,
		-1,
		183,
		188,
		176,
		162,
		181,
		-1,
		-1,
		-1,
		182,
		198,
		187,
		161,
		148,
		-1,
		-1,
		131,
		124,
		118,
		109,
		96,
		108,
		103,
		87,
		72,
		87,
		91,
		99,
		90,
		-1,
		186,
		173,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		-1,
		-1,
		199,
		144,
		133,
		128,
		132,
		130,
		-1,
		104,
		115,
		100,
		112,
		119,
		89,
		74,
		68,
		74,
		86,
		95,
		-1,
		-1,
		198,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		156,
		150,
		121,
		114,
		118,
		-1,
		106,
		108,
		102,
		117,
		92,
		89,
		80,
		71,
		67,
		71,
		75,
		89,
		93,
		221,
		-1,
		184,
		-1,
		-1,
		-1,
		174,
		189,
		160,
		137,
		110,
		105,
		98,
		92,
		97,
		108,
		100,
		111,
		78,
		74,
		64,
		63,
		67,
		84,
		84,
		-1,
		-1,
		182,
		178,
		200,
		182,
		186,
		187,
		-1,
		-1,
		114,
		105,
		96,
		88,
		101,
		104,
		84,
		81,
		75,
		68,
		62,
		72,
		83,
		78,
		-1,
		-1,
		-1,
		194,
		-1,
		196,
		-1,
		-1,
		184,
		185,
		132,
		114,
		110,
		108,
		97,
		91,
		79,
		84,
		85,
		76,
		70,
		58,
		58,
		81,
		70,
		87,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		147,
		144,
		-1,
		114,
		120,
		85,
		92,
		75,
		82,
		80,
		72,
		52,
		55,
		71,
		70,
		65,
		79,
		70,
		74,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		139,
		136,
		116,
		85,
		83,
		76,
		71,
		81,
		61,
		48,
		48,
		43,
		58,
		63,
		65,
		58,
		65,
		80,
		-1,
		213,
		250,
		243,
		211,
		219,
		250,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		112,
		103,
		104,
		92,
		89,
		91,
		86,
		77,
		57,
		63,
		41,
		48,
		59,
		51,
		55,
		56,
		63,
		74,
		78,
		-1,
		206,
		226,
		205,
		208,
		232,
		246,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		108,
		151,
		106,
		101,
		85,
		83,
		74,
		65,
		65,
		49,
		37,
		34,
		43,
		48,
		40,
		61,
		68,
		63,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		178,
		-1,
		148,
		-1,
		131,
		135,
		114,
		117,
		99,
		86,
		78,
		65,
		74,
		49,
		45,
		41,
		30,
		27,
		39,
		43,
		53,
		65,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		165,
		204,
		184,
		-1,
		168,
		-1,
		-1,
		-1,
		145,
		127,
		119,
		119,
		98,
		98,
		72,
		68,
		54,
		50,
		57,
		47,
		37,
		26,
		37,
		48,
		57,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		180,
		171,
		198,
		191,
		180,
		175,
		162,
		-1,
		-1,
		156,
		137,
		-1,
		-1,
		105,
		93,
		76,
		65,
		61,
		64,
		72,
		56,
		36,
		25,
		19,
		45,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		199,
		189,
		193,
		209,
		234,
		-1,
		151,
		-1,
		-1,
		136,
		-1,
		-1,
		121,
		98,
		87,
		78,
		67,
		69,
		76,
		87,
		39,
		28,
		19,
		19,
		30,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		223,
		-1,
		-1,
		167,
		147,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		78,
		64,
		91,
		59,
		48,
		42,
		36,
		22,
		6,
		19,
		35,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		157,
		153,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		78,
		64,
		60,
		46,
		39,
		34,
		35,
		8,
		0,
		29,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		174,
		160,
		153,
		141,
		139,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		96,
		64,
		64,
		58,
		40,
		37,
		11,
		14,
		28,
		23,
		-1,
		-1,
		176,
		179,
		-1,
		-1,
		164,
		166,
		-1,
		165,
		154,
		139,
		131,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		84,
		78,
		67,
		70,
		65,
		41,
		35,
		24,
		13,
		17,
		29,
		-1,
		-1,
		183,
		177,
		171,
		-1,
		149,
		-1,
		167,
		-1,
		134,
		140,
		128,
		-1,
		-1,
		-1,
		122,
		85,
		106,
		85,
		62,
		60,
		51,
		37,
		28,
		24,
		20,
		31,
		-1,
		-1,
		-1,
		167,
		141,
		174,
		165,
		148,
		128,
		120,
		139,
		-1,
		109,
		-1,
		84,
		86,
		92,
		70,
		73,
		67,
		40,
		55,
		27,
		18,
		27,
		173,
		-1,
		143,
		176,
		140,
		134,
		110,
		114,
		130,
		-1,
		106,
		88,
		-1,
		99,
		86,
		90,
		75,
		56,
		43,
		46,
		31,
		24,
		-1,
		-1,
		-1,
		145,
		144,
		136,
		130,
		130,
		115,
		106,
		-1,
		118,
		100,
		79,
		94,
		79,
		70,
		70,
		80,
		76,
		63,
		61,
		40,
		-1,
		246,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		139,
		134,
		107,
		95,
		101,
		97,
		83,
		89,
		89,
		82,
		72,
		69,
		65,
		56,
		62,
		39,
		72,
		-1,
		241,
		-1,
		175,
		-1,
		-1,
		157,
		137,
		129,
		118,
		107,
		105,
		96,
		87,
		109,
		113,
		63,
		51,
		46,
		47,
		-1,
		230,
		229,
		-1,
		176,
		168,
		154,
		-1,
		147,
		-1,
		153,
		114,
		-1,
		116,
		96,
		-1,
		62,
		51,
		-1,
		-1,
		217,
		192,
		-1,
		-1,
		-1,
		177,
		157,
		148,
		132,
		-1,
		107,
		107,
		-1,
		-1,
		-1,
		202,
		201,
		-1,
		170,
		173,
		-1,
		163,
		154,
		162,
		109,
		113,
		-1,
		-1,
		-1,
		211,
		192,
		186,
		185,
		183,
		178,
		175,
		161,
		145,
		123,
		112,
		133,
		-1,
		-1,
		-1,
		183,
		175,
		168,
		-1,
		-1,
		170,
		153,
		134,
		132,
		-1,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		160,
		-1,
		-1,
		166,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		194,
		-1,
		-1,
		-1,
		156,
		152,
		153,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		240,
		204,
		-1,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		219,
		217,
		-1,
		-1,
		-1,
		176,
		160,
		-1,
		146,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		181,
		-1,
		181,
		156,
		163,
		-1,
		-1,
		-1,
		-1,
		194,
		186,
		194,
		-1,
		166,
		168,
		-1,
		216,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		171,
		178,
		200,
		203,
		239,
		-1,
		190
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		159,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		147,
		153,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		127,
		123,
		120,
		128,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		120,
		124,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		149,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		119,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		151,
		157,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		117,
		109,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		162,
		152,
		157,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		113,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		173,
		178,
		158,
		150,
		157,
		149,
		141,
		135,
		113,
		106,
		103,
		96,
		109,
		119,
		124,
		111,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		179,
		178,
		166,
		156,
		146,
		151,
		152,
		132,
		125,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		120,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		206,
		180,
		167,
		-1,
		-1,
		150,
		143,
		137,
		128,
		115,
		127,
		122,
		106,
		91,
		106,
		110,
		110,
		102,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		149,
		-1,
		123,
		134,
		119,
		131,
		138,
		108,
		93,
		87,
		93,
		105,
		96,
		-1,
		-1,
		217,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		125,
		127,
		121,
		136,
		111,
		108,
		99,
		90,
		86,
		90,
		94,
		81,
		87,
		240,
		-1,
		203,
		-1,
		-1,
		-1,
		193,
		208,
		179,
		156,
		129,
		124,
		117,
		111,
		116,
		127,
		119,
		130,
		97,
		93,
		83,
		82,
		86,
		85,
		85,
		-1,
		-1,
		201,
		197,
		219,
		201,
		205,
		206,
		-1,
		-1,
		133,
		124,
		115,
		107,
		120,
		123,
		103,
		100,
		94,
		87,
		81,
		91,
		84,
		79,
		-1,
		-1,
		-1,
		213,
		-1,
		215,
		-1,
		-1,
		203,
		204,
		151,
		133,
		129,
		127,
		116,
		110,
		98,
		103,
		104,
		95,
		89,
		77,
		77,
		95,
		71,
		75,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		192,
		184,
		179,
		185,
		187,
		178,
		166,
		163,
		-1,
		133,
		139,
		104,
		111,
		94,
		101,
		99,
		91,
		71,
		74,
		88,
		74,
		62,
		67,
		58,
		66,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		185,
		181,
		171,
		161,
		164,
		-1,
		-1,
		158,
		155,
		135,
		104,
		102,
		95,
		90,
		100,
		80,
		67,
		67,
		62,
		65,
		64,
		59,
		52,
		57,
		72,
		-1,
		232,
		269,
		262,
		230,
		238,
		269,
		-1,
		175,
		167,
		178,
		153,
		155,
		-1,
		-1,
		131,
		122,
		123,
		111,
		108,
		110,
		105,
		96,
		76,
		82,
		60,
		67,
		78,
		70,
		68,
		55,
		44,
		57,
		61,
		-1,
		225,
		245,
		224,
		227,
		251,
		265,
		-1,
		172,
		-1,
		-1,
		184,
		156,
		140,
		130,
		127,
		170,
		125,
		120,
		104,
		102,
		93,
		84,
		84,
		68,
		56,
		53,
		62,
		63,
		53,
		51,
		50,
		43,
		-1,
		214,
		225,
		218,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		176,
		-1,
		167,
		-1,
		150,
		154,
		133,
		136,
		118,
		105,
		97,
		84,
		93,
		68,
		64,
		60,
		49,
		46,
		57,
		35,
		43,
		50,
		239,
		195,
		198,
		209,
		220,
		235,
		239,
		-1,
		184,
		223,
		182,
		-1,
		166,
		-1,
		-1,
		-1,
		164,
		146,
		138,
		138,
		117,
		117,
		91,
		87,
		73,
		69,
		76,
		66,
		56,
		45,
		45,
		33,
		42,
		235,
		226,
		239,
		184,
		184,
		205,
		214,
		235,
		199,
		190,
		217,
		189,
		178,
		173,
		160,
		-1,
		-1,
		168,
		156,
		-1,
		-1,
		124,
		108,
		95,
		84,
		80,
		83,
		91,
		75,
		55,
		43,
		38,
		28,
		-1,
		228,
		227,
		216,
		213,
		189,
		180,
		175,
		202,
		-1,
		-1,
		197,
		218,
		208,
		212,
		220,
		245,
		-1,
		149,
		-1,
		-1,
		148,
		-1,
		-1,
		133,
		113,
		102,
		93,
		79,
		88,
		95,
		106,
		58,
		50,
		37,
		21,
		13,
		212,
		209,
		197,
		195,
		218,
		183,
		171,
		-1,
		184,
		182,
		188,
		195,
		212,
		234,
		-1,
		-1,
		165,
		145,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		90,
		76,
		103,
		78,
		67,
		61,
		55,
		41,
		32,
		14,
		6,
		221,
		235,
		224,
		220,
		219,
		227,
		176,
		169,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		155,
		151,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		90,
		76,
		72,
		65,
		58,
		53,
		55,
		27,
		31,
		0,
		-1,
		255,
		-1,
		207,
		183,
		197,
		212,
		220,
		-1,
		-1,
		-1,
		172,
		158,
		151,
		139,
		137,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		108,
		76,
		68,
		66,
		56,
		55,
		30,
		16,
		8,
		6,
		-1,
		-1,
		195,
		188,
		-1,
		-1,
		162,
		164,
		-1,
		163,
		152,
		137,
		129,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		95,
		90,
		79,
		74,
		70,
		52,
		53,
		43,
		32,
		9,
		9,
		-1,
		-1,
		183,
		175,
		169,
		-1,
		147,
		-1,
		165,
		-1,
		132,
		138,
		126,
		-1,
		-1,
		-1,
		126,
		89,
		105,
		97,
		66,
		64,
		55,
		48,
		47,
		36,
		29,
		19,
		-1,
		-1,
		-1,
		165,
		139,
		172,
		163,
		146,
		126,
		118,
		137,
		-1,
		107,
		-1,
		82,
		85,
		90,
		74,
		77,
		71,
		45,
		58,
		31,
		27,
		25,
		171,
		-1,
		141,
		174,
		138,
		132,
		108,
		112,
		128,
		-1,
		104,
		86,
		-1,
		97,
		84,
		88,
		73,
		54,
		41,
		44,
		29,
		22,
		-1,
		-1,
		-1,
		143,
		142,
		134,
		128,
		128,
		113,
		104,
		-1,
		116,
		98,
		77,
		92,
		77,
		68,
		68,
		78,
		74,
		61,
		59,
		38,
		-1,
		244,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		137,
		132,
		105,
		93,
		99,
		95,
		81,
		87,
		87,
		80,
		70,
		67,
		63,
		54,
		60,
		37,
		70,
		-1,
		239,
		-1,
		173,
		-1,
		-1,
		155,
		135,
		127,
		116,
		105,
		103,
		94,
		85,
		107,
		111,
		61,
		49,
		44,
		45,
		-1,
		228,
		227,
		-1,
		174,
		166,
		152,
		-1,
		145,
		-1,
		151,
		112,
		-1,
		114,
		94,
		-1,
		60,
		49,
		-1,
		-1,
		215,
		190,
		-1,
		-1,
		-1,
		175,
		155,
		146,
		130,
		-1,
		105,
		105,
		-1,
		-1,
		-1,
		200,
		199,
		-1,
		168,
		171,
		-1,
		161,
		152,
		160,
		107,
		111,
		-1,
		-1,
		-1,
		209,
		190,
		184,
		183,
		181,
		176,
		173,
		159,
		143,
		121,
		110,
		131,
		-1,
		-1,
		-1,
		181,
		173,
		166,
		-1,
		-1,
		168,
		151,
		132,
		130,
		-1,
		-1,
		-1,
		203,
		184,
		-1,
		-1,
		158,
		-1,
		-1,
		164,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		192,
		-1,
		-1,
		-1,
		154,
		150,
		151,
		-1,
		-1,
		-1,
		-1,
		214,
		215,
		238,
		202,
		-1,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		217,
		215,
		-1,
		-1,
		-1,
		174,
		158,
		-1,
		144,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		179,
		-1,
		179,
		154,
		161,
		-1,
		-1,
		-1,
		-1,
		192,
		184,
		192,
		-1,
		164,
		166,
		-1,
		214,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		169,
		176,
		198,
		201,
		237,
		-1,
		188
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		361,
		350,
		361,
		369,
		342,
		349,
		-1,
		368,
		372,
		338,
		332,
		371,
		340,
		346,
		357,
		-1,
		-1,
		-1,
		361,
		360,
		328,
		326,
		335,
		340,
		347,
		-1,
		346,
		-1,
		382,
		361,
		372,
		377,
		321,
		318,
		338,
		357,
		339,
		331,
		397,
		351,
		322,
		316,
		334,
		324,
		333,
		325,
		-1,
		322,
		312,
		334,
		313,
		324,
		316,
		-1,
		-1,
		316,
		317,
		323,
		309,
		315,
		311,
		-1,
		321,
		305,
		-1,
		-1,
		306,
		307,
		291,
		294,
		302,
		300,
		313,
		305,
		300,
		-1,
		-1,
		297,
		293,
		300,
		287,
		283,
		300,
		313,
		295,
		309,
		308,
		-1,
		303,
		321,
		326,
		294,
		292,
		276,
		274,
		292,
		294,
		300,
		300,
		-1,
		309,
		311,
		308,
		316,
		316,
		292,
		279,
		279,
		289,
		282,
		301,
		289,
		335,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		306,
		295,
		312,
		304,
		294,
		309,
		302,
		282,
		279,
		277,
		274,
		290,
		288,
		298,
		-1,
		-1,
		362,
		331,
		366,
		323,
		308,
		-1,
		302,
		288,
		294,
		298,
		292,
		285,
		299,
		295,
		-1,
		268,
		267,
		295,
		281,
		292,
		322,
		-1,
		-1,
		320,
		312,
		297,
		300,
		297,
		297,
		303,
		302,
		294,
		280,
		276,
		282,
		285,
		285,
		291,
		262,
		272,
		276,
		274,
		299,
		-1,
		-1,
		334,
		-1,
		-1,
		319,
		302,
		-1,
		285,
		292,
		292,
		309,
		299,
		320,
		313,
		304,
		296,
		290,
		278,
		280,
		277,
		290,
		278,
		259,
		284,
		288,
		269,
		290,
		285,
		-1,
		333,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		278,
		281,
		287,
		311,
		321,
		-1,
		325,
		313,
		314,
		299,
		296,
		283,
		271,
		284,
		269,
		276,
		275,
		263,
		261,
		291,
		266,
		288,
		285,
		304,
		309,
		303,
		312,
		-1,
		327,
		323,
		319,
		326,
		275,
		-1,
		-1,
		315,
		-1,
		329,
		342,
		337,
		310,
		313,
		300,
		291,
		278,
		267,
		278,
		267,
		264,
		272,
		255,
		270,
		261,
		260,
		278,
		288,
		296,
		300,
		306,
		-1,
		377,
		-1,
		319,
		303,
		305,
		277,
		298,
		-1,
		335,
		330,
		350,
		339,
		337,
		-1,
		309,
		306,
		296,
		274,
		259,
		276,
		268,
		266,
		268,
		250,
		264,
		255,
		273,
		280,
		278,
		282,
		302,
		314,
		337,
		327,
		-1,
		309,
		314,
		273,
		281,
		300,
		373,
		343,
		-1,
		338,
		-1,
		311,
		324,
		-1,
		280,
		276,
		258,
		259,
		254,
		269,
		261,
		246,
		243,
		261,
		264,
		271,
		275,
		291,
		-1,
		-1,
		322,
		326,
		315,
		266,
		285,
		309,
		346,
		336,
		325,
		324,
		-1,
		315,
		294,
		291,
		279,
		266,
		251,
		252,
		260,
		272,
		251,
		245,
		242,
		262,
		288,
		266,
		277,
		-1,
		-1,
		-1,
		347,
		-1,
		-1,
		292,
		263,
		287,
		329,
		354,
		347,
		335,
		300,
		300,
		294,
		-1,
		290,
		269,
		260,
		249,
		247,
		260,
		252,
		260,
		240,
		238,
		257,
		269,
		260,
		268,
		-1,
		-1,
		-1,
		322,
		311,
		312,
		261,
		284,
		318,
		333,
		319,
		324,
		299,
		292,
		286,
		303,
		286,
		267,
		256,
		248,
		237,
		248,
		256,
		254,
		236,
		245,
		251,
		275,
		256,
		262,
		-1,
		-1,
		329,
		319,
		303,
		305,
		302,
		275,
		282,
		314,
		324,
		326,
		-1,
		291,
		-1,
		280,
		276,
		261,
		256,
		253,
		240,
		239,
		253,
		253,
		243,
		238,
		245,
		280,
		280,
		246,
		266,
		269,
		-1,
		-1,
		-1,
		322,
		320,
		295,
		272,
		256,
		292,
		-1,
		296,
		297,
		-1,
		285,
		279,
		276,
		263,
		259,
		244,
		248,
		250,
		253,
		241,
		247,
		248,
		230,
		254,
		-1,
		254,
		248,
		256,
		246,
		234,
		-1,
		-1,
		-1,
		318,
		297,
		290,
		310,
		251,
		303,
		-1,
		-1,
		281,
		274,
		-1,
		272,
		254,
		256,
		251,
		247,
		249,
		246,
		235,
		248,
		241,
		235,
		229,
		242,
		246,
		247,
		236,
		232,
		229,
		243,
		-1,
		337,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		271,
		-1,
		284,
		276,
		272,
		266,
		271,
		267,
		265,
		275,
		259,
		261,
		257,
		249,
		244,
		230,
		223,
		234,
		219,
		237,
		243,
		234,
		229,
		228,
		239,
		-1,
		338,
		324,
		295,
		-1,
		-1,
		284,
		-1,
		248,
		262,
		278,
		-1,
		306,
		285,
		303,
		281,
		277,
		268,
		266,
		267,
		237,
		242,
		244,
		232,
		235,
		224,
		227,
		219,
		241,
		238,
		222,
		224,
		233,
		-1,
		344,
		331,
		289,
		285,
		274,
		294,
		245,
		254,
		265,
		-1,
		-1,
		328,
		-1,
		279,
		284,
		282,
		280,
		256,
		231,
		238,
		256,
		229,
		224,
		229,
		218,
		218,
		213,
		232,
		218,
		216,
		231,
		247,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		260,
		247,
		241,
		-1,
		282,
		-1,
		306,
		294,
		281,
		263,
		303,
		-1,
		230,
		226,
		233,
		-1,
		249,
		-1,
		221,
		224,
		215,
		210,
		207,
		218,
		216,
		225,
		226,
		-1,
		294,
		279,
		272,
		262,
		276,
		247,
		-1,
		290,
		-1,
		-1,
		293,
		287,
		287,
		256,
		253,
		246,
		226,
		218,
		233,
		232,
		219,
		218,
		206,
		206,
		209,
		203,
		216,
		226,
		232,
		224,
		-1,
		-1,
		-1,
		299,
		251,
		259,
		235,
		256,
		-1,
		-1,
		354,
		310,
		296,
		-1,
		248,
		246,
		234,
		224,
		214,
		219,
		220,
		210,
		208,
		204,
		213,
		212,
		205,
		204,
		225,
		218,
		240,
		-1,
		-1,
		248,
		261,
		263,
		247,
		242,
		-1,
		-1,
		-1,
		300,
		301,
		267,
		246,
		235,
		-1,
		-1,
		218,
		211,
		205,
		208,
		196,
		216,
		223,
		211,
		198,
		213,
		223,
		231,
		230,
		-1,
		251,
		238,
		-1,
		-1,
		241,
		231,
		-1,
		-1,
		-1,
		-1,
		279,
		224,
		213,
		208,
		212,
		217,
		-1,
		191,
		202,
		195,
		214,
		221,
		213,
		198,
		192,
		203,
		218,
		235,
		-1,
		-1,
		255,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		236,
		230,
		201,
		194,
		198,
		-1,
		193,
		195,
		192,
		204,
		209,
		213,
		204,
		186,
		200,
		203,
		216,
		230,
		234,
		278,
		-1,
		208,
		-1,
		-1,
		-1,
		247,
		248,
		234,
		211,
		190,
		183,
		180,
		179,
		184,
		195,
		204,
		215,
		180,
		184,
		199,
		204,
		208,
		225,
		229,
		-1,
		-1,
		206,
		202,
		237,
		249,
		221,
		261,
		-1,
		-1,
		179,
		172,
		182,
		175,
		188,
		191,
		176,
		178,
		196,
		209,
		203,
		213,
		228,
		223,
		-1,
		-1,
		-1,
		204,
		-1,
		220,
		-1,
		-1,
		211,
		252,
		199,
		181,
		177,
		163,
		170,
		164,
		166,
		171,
		190,
		185,
		194,
		199,
		203,
		226,
		215,
		254,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		170,
		189,
		184,
		190,
		195,
		186,
		214,
		211,
		-1,
		160,
		193,
		161,
		175,
		171,
		178,
		183,
		189,
		193,
		200,
		216,
		215,
		210,
		246,
		237,
		243,
		-1,
		-1,
		197,
		186,
		175,
		181,
		-1,
		163,
		186,
		176,
		166,
		172,
		-1,
		-1,
		178,
		175,
		173,
		153,
		159,
		164,
		167,
		205,
		181,
		189,
		193,
		197,
		203,
		208,
		213,
		219,
		234,
		249,
		-1,
		151,
		188,
		181,
		149,
		157,
		188,
		-1,
		153,
		145,
		173,
		158,
		166,
		-1,
		-1,
		151,
		142,
		147,
		156,
		157,
		188,
		187,
		200,
		203,
		208,
		196,
		195,
		213,
		217,
		226,
		233,
		223,
		236,
		240,
		-1,
		144,
		164,
		143,
		146,
		170,
		184,
		-1,
		144,
		-1,
		-1,
		189,
		176,
		160,
		150,
		147,
		194,
		170,
		165,
		171,
		173,
		197,
		188,
		213,
		204,
		204,
		207,
		222,
		227,
		219,
		233,
		233,
		234,
		-1,
		133,
		144,
		137,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		205,
		-1,
		187,
		-1,
		170,
		174,
		178,
		181,
		196,
		183,
		190,
		207,
		213,
		202,
		212,
		208,
		209,
		218,
		229,
		241,
		240,
		241,
		104,
		114,
		117,
		128,
		139,
		154,
		158,
		-1,
		128,
		164,
		174,
		-1,
		214,
		-1,
		-1,
		-1,
		184,
		191,
		183,
		199,
		195,
		195,
		191,
		195,
		207,
		214,
		224,
		226,
		218,
		222,
		235,
		246,
		249,
		100,
		105,
		158,
		103,
		103,
		124,
		133,
		154,
		124,
		121,
		158,
		163,
		178,
		183,
		207,
		-1,
		-1,
		207,
		201,
		-1,
		-1,
		202,
		212,
		195,
		197,
		201,
		215,
		227,
		235,
		225,
		223,
		217,
		249,
		-1,
		100,
		82,
		82,
		77,
		71,
		83,
		94,
		121,
		-1,
		-1,
		122,
		149,
		133,
		137,
		153,
		178,
		-1,
		214,
		-1,
		-1,
		228,
		-1,
		-1,
		254,
		217,
		206,
		197,
		203,
		209,
		220,
		242,
		231,
		232,
		222,
		232,
		245,
		84,
		77,
		65,
		67,
		73,
		102,
		90,
		-1,
		109,
		107,
		113,
		120,
		137,
		167,
		-1,
		-1,
		230,
		221,
		-1,
		-1,
		247,
		250,
		239,
		-1,
		229,
		202,
		207,
		232,
		239,
		240,
		234,
		228,
		235,
		234,
		242,
		250,
		93,
		103,
		92,
		69,
		74,
		87,
		95,
		94,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		-1,
		259,
		240,
		-1,
		-1,
		247,
		240,
		228,
		216,
		206,
		216,
		224,
		224,
		227,
		231,
		226,
		237,
		229,
		233,
		250,
		-1,
		0,
		-1,
		126,
		108,
		122,
		137,
		145,
		-1,
		-1,
		-1,
		276,
		262,
		255,
		243,
		241,
		-1,
		281,
		265,
		246,
		-1,
		216,
		229,
		260,
		228,
		233,
		228,
		232,
		243,
		232,
		235,
		249,
		244,
		-1,
		-1,
		120,
		123,
		-1,
		-1,
		145,
		164,
		-1,
		267,
		256,
		241,
		233,
		-1,
		-1,
		253,
		249,
		-1,
		-1,
		217,
		242,
		231,
		239,
		234,
		236,
		242,
		245,
		234,
		238,
		250,
		-1,
		-1,
		127,
		128,
		133,
		-1,
		154,
		-1,
		269,
		-1,
		236,
		243,
		231,
		-1,
		-1,
		-1,
		255,
		218,
		239,
		249,
		254,
		252,
		243,
		240,
		247,
		245,
		241,
		252,
		-1,
		-1,
		-1,
		184,
		161,
		276,
		267,
		250,
		230,
		222,
		242,
		-1,
		243,
		-1,
		218,
		219,
		246,
		248,
		265,
		259,
		243,
		258,
		248,
		239,
		248,
		190,
		-1,
		165,
		224,
		207,
		236,
		202,
		214,
		264,
		-1,
		240,
		222,
		-1,
		250,
		240,
		282,
		263,
		256,
		243,
		250,
		252,
		245,
		-1,
		-1,
		-1,
		180,
		179,
		178,
		189,
		197,
		195,
		213,
		-1,
		252,
		234,
		213,
		230,
		230,
		221,
		229,
		272,
		268,
		261,
		263,
		253,
		-1,
		176,
		-1,
		-1,
		203,
		-1,
		-1,
		-1,
		206,
		228,
		223,
		215,
		227,
		231,
		217,
		223,
		225,
		233,
		231,
		228,
		240,
		236,
		256,
		252,
		284,
		-1,
		183,
		-1,
		210,
		-1,
		-1,
		224,
		210,
		222,
		233,
		223,
		223,
		228,
		221,
		243,
		259,
		243,
		241,
		246,
		251,
		-1,
		193,
		194,
		-1,
		243,
		235,
		221,
		-1,
		214,
		-1,
		269,
		230,
		-1,
		250,
		230,
		-1,
		252,
		248,
		-1,
		-1,
		205,
		251,
		-1,
		-1,
		-1,
		244,
		224,
		264,
		248,
		-1,
		241,
		241,
		-1,
		-1,
		-1,
		219,
		242,
		-1,
		237,
		240,
		-1,
		231,
		237,
		266,
		243,
		247,
		-1,
		-1,
		-1,
		246,
		230,
		235,
		252,
		257,
		245,
		262,
		248,
		250,
		257,
		246,
		267,
		-1,
		-1,
		-1,
		249,
		246,
		257,
		-1,
		-1,
		275,
		258,
		258,
		266,
		-1,
		-1,
		-1,
		271,
		252,
		-1,
		-1,
		266,
		-1,
		-1,
		271,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		260,
		-1,
		-1,
		-1,
		267,
		274,
		282,
		-1,
		-1,
		-1,
		-1,
		251,
		252,
		296,
		281,
		-1,
		-1,
		-1,
		281,
		276,
		-1,
		-1,
		249,
		250,
		-1,
		-1,
		-1,
		309,
		293,
		-1,
		280,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		314,
		-1,
		315,
		290,
		297,
		-1,
		-1,
		-1,
		-1,
		327,
		319,
		328,
		-1,
		300,
		302,
		-1,
		350,
		-1,
		-1,
		342,
		333,
		-1,
		-1,
		305,
		312,
		334,
		337,
		333,
		-1,
		324
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		317,
		306,
		317,
		325,
		298,
		305,
		-1,
		324,
		328,
		294,
		288,
		327,
		296,
		302,
		313,
		-1,
		-1,
		-1,
		317,
		316,
		284,
		282,
		291,
		296,
		303,
		-1,
		302,
		-1,
		338,
		317,
		328,
		333,
		277,
		274,
		294,
		313,
		295,
		287,
		353,
		307,
		278,
		272,
		290,
		280,
		289,
		281,
		-1,
		278,
		268,
		290,
		269,
		280,
		272,
		-1,
		-1,
		272,
		273,
		279,
		265,
		271,
		267,
		-1,
		277,
		261,
		-1,
		-1,
		262,
		263,
		247,
		250,
		258,
		256,
		269,
		261,
		256,
		-1,
		-1,
		253,
		249,
		256,
		243,
		239,
		256,
		269,
		251,
		265,
		264,
		-1,
		259,
		277,
		282,
		250,
		248,
		232,
		230,
		248,
		250,
		256,
		256,
		-1,
		256,
		258,
		264,
		272,
		272,
		248,
		235,
		235,
		245,
		238,
		257,
		245,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		253,
		251,
		268,
		260,
		250,
		265,
		258,
		238,
		235,
		233,
		230,
		246,
		244,
		254,
		-1,
		-1,
		309,
		278,
		313,
		270,
		255,
		-1,
		249,
		244,
		250,
		254,
		248,
		241,
		255,
		251,
		-1,
		224,
		223,
		251,
		237,
		248,
		269,
		-1,
		-1,
		267,
		259,
		244,
		247,
		244,
		244,
		259,
		258,
		250,
		236,
		232,
		238,
		241,
		241,
		247,
		218,
		228,
		232,
		230,
		255,
		-1,
		-1,
		290,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		239,
		256,
		246,
		267,
		269,
		260,
		252,
		246,
		234,
		236,
		233,
		246,
		234,
		215,
		240,
		244,
		225,
		246,
		241,
		-1,
		289,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		268,
		-1,
		281,
		269,
		270,
		255,
		252,
		239,
		227,
		240,
		225,
		232,
		231,
		219,
		217,
		247,
		222,
		244,
		241,
		260,
		265,
		259,
		268,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		276,
		289,
		293,
		266,
		269,
		256,
		247,
		234,
		223,
		234,
		223,
		220,
		228,
		211,
		226,
		217,
		216,
		234,
		244,
		252,
		256,
		262,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		277,
		297,
		295,
		289,
		-1,
		265,
		262,
		252,
		230,
		215,
		232,
		224,
		222,
		224,
		206,
		220,
		211,
		229,
		236,
		234,
		238,
		258,
		270,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		320,
		295,
		-1,
		290,
		-1,
		267,
		280,
		-1,
		236,
		232,
		214,
		215,
		210,
		225,
		217,
		202,
		199,
		217,
		220,
		227,
		231,
		247,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		288,
		277,
		276,
		-1,
		267,
		250,
		247,
		235,
		222,
		207,
		208,
		216,
		228,
		207,
		201,
		198,
		218,
		244,
		222,
		233,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		306,
		299,
		287,
		252,
		252,
		246,
		-1,
		246,
		225,
		216,
		205,
		203,
		216,
		208,
		216,
		196,
		194,
		213,
		225,
		216,
		224,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		208,
		231,
		265,
		285,
		271,
		276,
		251,
		244,
		238,
		259,
		242,
		223,
		212,
		204,
		193,
		204,
		212,
		210,
		192,
		201,
		207,
		231,
		212,
		218,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		222,
		229,
		261,
		276,
		273,
		-1,
		243,
		-1,
		232,
		232,
		217,
		212,
		209,
		196,
		195,
		209,
		209,
		199,
		194,
		201,
		236,
		236,
		202,
		222,
		225,
		-1,
		-1,
		-1,
		269,
		267,
		242,
		219,
		203,
		239,
		-1,
		243,
		244,
		-1,
		237,
		231,
		232,
		219,
		215,
		200,
		204,
		206,
		209,
		197,
		203,
		204,
		186,
		210,
		-1,
		210,
		204,
		212,
		202,
		190,
		-1,
		-1,
		-1,
		265,
		244,
		237,
		257,
		198,
		250,
		-1,
		-1,
		228,
		221,
		-1,
		224,
		210,
		212,
		207,
		203,
		205,
		202,
		191,
		204,
		197,
		191,
		185,
		198,
		202,
		203,
		192,
		188,
		185,
		199,
		-1,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		218,
		-1,
		231,
		223,
		219,
		213,
		219,
		223,
		221,
		231,
		215,
		217,
		213,
		205,
		200,
		186,
		179,
		190,
		175,
		193,
		199,
		190,
		185,
		184,
		195,
		-1,
		285,
		271,
		242,
		-1,
		-1,
		231,
		-1,
		195,
		209,
		225,
		-1,
		253,
		232,
		255,
		233,
		233,
		224,
		222,
		223,
		193,
		198,
		200,
		188,
		191,
		180,
		183,
		175,
		197,
		194,
		178,
		180,
		189,
		-1,
		291,
		278,
		236,
		232,
		221,
		241,
		192,
		201,
		212,
		-1,
		-1,
		284,
		-1,
		231,
		240,
		238,
		236,
		212,
		187,
		194,
		212,
		185,
		180,
		185,
		174,
		174,
		169,
		188,
		174,
		172,
		187,
		203,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		207,
		194,
		188,
		-1,
		229,
		-1,
		262,
		250,
		237,
		219,
		259,
		-1,
		186,
		182,
		189,
		-1,
		205,
		-1,
		177,
		180,
		171,
		166,
		163,
		174,
		172,
		181,
		182,
		-1,
		241,
		226,
		219,
		209,
		223,
		194,
		-1,
		237,
		-1,
		-1,
		249,
		243,
		243,
		212,
		209,
		202,
		182,
		174,
		189,
		188,
		175,
		174,
		162,
		162,
		165,
		159,
		172,
		182,
		188,
		180,
		-1,
		-1,
		-1,
		246,
		198,
		206,
		182,
		203,
		-1,
		-1,
		310,
		266,
		252,
		-1,
		204,
		202,
		190,
		180,
		170,
		175,
		176,
		166,
		164,
		160,
		169,
		168,
		161,
		160,
		181,
		174,
		196,
		-1,
		-1,
		195,
		208,
		210,
		196,
		198,
		-1,
		-1,
		-1,
		256,
		257,
		223,
		202,
		191,
		-1,
		-1,
		174,
		167,
		161,
		164,
		152,
		172,
		179,
		167,
		154,
		169,
		179,
		187,
		186,
		-1,
		198,
		185,
		-1,
		-1,
		197,
		187,
		-1,
		-1,
		-1,
		-1,
		235,
		180,
		169,
		164,
		168,
		173,
		-1,
		147,
		158,
		151,
		170,
		177,
		169,
		154,
		148,
		159,
		174,
		191,
		-1,
		-1,
		211,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		192,
		186,
		157,
		150,
		154,
		-1,
		149,
		151,
		148,
		160,
		165,
		169,
		160,
		142,
		156,
		159,
		172,
		186,
		190,
		234,
		-1,
		164,
		-1,
		-1,
		-1,
		203,
		204,
		190,
		167,
		146,
		139,
		136,
		135,
		140,
		151,
		160,
		171,
		136,
		140,
		155,
		160,
		164,
		181,
		185,
		-1,
		-1,
		162,
		158,
		193,
		205,
		177,
		217,
		-1,
		-1,
		135,
		128,
		138,
		131,
		144,
		147,
		132,
		134,
		152,
		165,
		159,
		169,
		184,
		179,
		-1,
		-1,
		-1,
		160,
		-1,
		176,
		-1,
		-1,
		167,
		208,
		155,
		137,
		133,
		119,
		126,
		120,
		122,
		127,
		146,
		141,
		150,
		155,
		159,
		182,
		171,
		210,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		126,
		145,
		140,
		146,
		151,
		142,
		170,
		167,
		-1,
		116,
		149,
		117,
		131,
		127,
		134,
		139,
		145,
		149,
		156,
		172,
		171,
		166,
		202,
		193,
		199,
		-1,
		-1,
		144,
		133,
		122,
		128,
		-1,
		119,
		142,
		132,
		122,
		128,
		-1,
		-1,
		134,
		131,
		129,
		109,
		115,
		120,
		123,
		161,
		137,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		98,
		135,
		128,
		96,
		104,
		135,
		-1,
		109,
		101,
		129,
		114,
		122,
		-1,
		-1,
		107,
		98,
		103,
		112,
		113,
		144,
		143,
		156,
		159,
		164,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		91,
		111,
		90,
		93,
		117,
		131,
		-1,
		100,
		-1,
		-1,
		145,
		132,
		116,
		106,
		103,
		150,
		126,
		121,
		127,
		129,
		153,
		144,
		169,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		80,
		91,
		84,
		-1,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		161,
		-1,
		143,
		-1,
		126,
		130,
		134,
		137,
		152,
		139,
		146,
		163,
		169,
		158,
		168,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		105,
		61,
		64,
		75,
		86,
		101,
		105,
		-1,
		84,
		120,
		130,
		-1,
		170,
		-1,
		-1,
		-1,
		140,
		147,
		139,
		155,
		151,
		151,
		147,
		151,
		163,
		170,
		180,
		182,
		174,
		178,
		191,
		202,
		205,
		101,
		92,
		105,
		50,
		50,
		71,
		80,
		101,
		80,
		77,
		114,
		119,
		134,
		139,
		163,
		-1,
		-1,
		163,
		157,
		-1,
		-1,
		158,
		168,
		151,
		153,
		157,
		171,
		183,
		191,
		181,
		179,
		173,
		205,
		-1,
		94,
		93,
		82,
		79,
		55,
		46,
		41,
		68,
		-1,
		-1,
		78,
		105,
		89,
		93,
		109,
		134,
		-1,
		170,
		-1,
		-1,
		184,
		-1,
		-1,
		210,
		173,
		162,
		153,
		159,
		165,
		176,
		198,
		187,
		188,
		178,
		188,
		201,
		78,
		75,
		63,
		61,
		84,
		47,
		37,
		-1,
		60,
		63,
		69,
		76,
		93,
		123,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		203,
		206,
		195,
		-1,
		185,
		158,
		163,
		188,
		195,
		196,
		190,
		184,
		191,
		190,
		198,
		206,
		87,
		101,
		90,
		86,
		85,
		93,
		33,
		50,
		57,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		-1,
		209,
		196,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		180,
		180,
		183,
		187,
		182,
		193,
		185,
		189,
		206,
		-1,
		121,
		-1,
		0,
		57,
		72,
		87,
		95,
		-1,
		-1,
		-1,
		226,
		212,
		205,
		193,
		191,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		216,
		184,
		189,
		184,
		188,
		199,
		188,
		191,
		205,
		200,
		-1,
		-1,
		70,
		73,
		-1,
		-1,
		95,
		114,
		-1,
		217,
		206,
		191,
		183,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		173,
		198,
		187,
		195,
		190,
		192,
		198,
		201,
		190,
		194,
		206,
		-1,
		-1,
		77,
		78,
		83,
		-1,
		104,
		-1,
		219,
		-1,
		186,
		193,
		181,
		-1,
		-1,
		-1,
		211,
		174,
		195,
		205,
		210,
		208,
		199,
		196,
		203,
		201,
		197,
		208,
		-1,
		-1,
		-1,
		134,
		111,
		226,
		217,
		200,
		180,
		172,
		192,
		-1,
		199,
		-1,
		174,
		175,
		202,
		204,
		221,
		215,
		199,
		214,
		204,
		195,
		204,
		140,
		-1,
		115,
		174,
		157,
		186,
		152,
		164,
		220,
		-1,
		196,
		178,
		-1,
		206,
		196,
		238,
		219,
		212,
		199,
		206,
		208,
		201,
		-1,
		-1,
		-1,
		130,
		129,
		128,
		139,
		147,
		145,
		163,
		-1,
		208,
		190,
		169,
		186,
		186,
		177,
		185,
		228,
		224,
		217,
		219,
		209,
		-1,
		193,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		156,
		178,
		173,
		165,
		177,
		186,
		173,
		179,
		181,
		189,
		187,
		184,
		196,
		192,
		212,
		208,
		240,
		-1,
		200,
		-1,
		160,
		-1,
		-1,
		174,
		160,
		172,
		183,
		173,
		173,
		178,
		176,
		198,
		215,
		199,
		197,
		202,
		207,
		-1,
		210,
		211,
		-1,
		193,
		185,
		171,
		-1,
		164,
		-1,
		219,
		180,
		-1,
		205,
		185,
		-1,
		208,
		204,
		-1,
		-1,
		222,
		209,
		-1,
		-1,
		-1,
		194,
		174,
		214,
		198,
		-1,
		196,
		196,
		-1,
		-1,
		-1,
		234,
		218,
		-1,
		187,
		190,
		-1,
		181,
		187,
		216,
		198,
		202,
		-1,
		-1,
		-1,
		243,
		224,
		218,
		202,
		207,
		195,
		212,
		198,
		200,
		212,
		201,
		222,
		-1,
		-1,
		-1,
		215,
		207,
		207,
		-1,
		-1,
		225,
		208,
		208,
		221,
		-1,
		-1,
		-1,
		237,
		218,
		-1,
		-1,
		216,
		-1,
		-1,
		221,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		226,
		-1,
		-1,
		-1,
		217,
		224,
		232,
		-1,
		-1,
		-1,
		-1,
		247,
		248,
		272,
		247,
		-1,
		-1,
		-1,
		231,
		231,
		-1,
		-1,
		250,
		248,
		-1,
		-1,
		-1,
		259,
		243,
		-1,
		235,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		264,
		-1,
		270,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		277,
		269,
		283,
		-1,
		255,
		257,
		-1,
		305,
		-1,
		-1,
		292,
		283,
		-1,
		-1,
		260,
		267,
		289,
		292,
		322,
		-1,
		279
	],
	[
		-1,
		285,
		274,
		285,
		293,
		266,
		273,
		-1,
		292,
		296,
		262,
		256,
		295,
		264,
		270,
		281,
		-1,
		-1,
		-1,
		285,
		284,
		252,
		250,
		259,
		264,
		271,
		-1,
		270,
		-1,
		306,
		285,
		296,
		301,
		245,
		242,
		262,
		281,
		263,
		255,
		321,
		275,
		246,
		240,
		258,
		248,
		257,
		249,
		-1,
		246,
		236,
		258,
		237,
		248,
		240,
		-1,
		-1,
		240,
		241,
		247,
		233,
		239,
		235,
		-1,
		245,
		229,
		-1,
		-1,
		230,
		231,
		215,
		218,
		226,
		224,
		237,
		229,
		224,
		-1,
		-1,
		221,
		217,
		224,
		211,
		207,
		224,
		237,
		219,
		233,
		232,
		-1,
		227,
		245,
		250,
		218,
		216,
		200,
		198,
		216,
		218,
		224,
		224,
		-1,
		236,
		237,
		232,
		240,
		240,
		216,
		203,
		203,
		213,
		206,
		225,
		213,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		236,
		219,
		236,
		228,
		218,
		233,
		226,
		206,
		203,
		201,
		198,
		214,
		212,
		222,
		-1,
		-1,
		292,
		261,
		296,
		253,
		238,
		-1,
		232,
		212,
		218,
		222,
		216,
		209,
		223,
		219,
		-1,
		192,
		191,
		219,
		205,
		216,
		252,
		-1,
		-1,
		250,
		242,
		227,
		230,
		227,
		227,
		227,
		226,
		218,
		204,
		200,
		206,
		209,
		209,
		215,
		186,
		196,
		200,
		198,
		223,
		-1,
		-1,
		258,
		-1,
		-1,
		249,
		232,
		-1,
		215,
		222,
		222,
		239,
		229,
		250,
		237,
		228,
		220,
		214,
		202,
		204,
		201,
		214,
		202,
		183,
		208,
		212,
		193,
		214,
		209,
		-1,
		257,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		208,
		211,
		217,
		241,
		251,
		-1,
		249,
		237,
		238,
		223,
		220,
		207,
		195,
		208,
		193,
		200,
		199,
		187,
		185,
		215,
		190,
		212,
		209,
		228,
		233,
		227,
		236,
		-1,
		257,
		253,
		249,
		256,
		205,
		-1,
		-1,
		245,
		-1,
		259,
		272,
		261,
		234,
		237,
		224,
		215,
		202,
		191,
		202,
		191,
		188,
		196,
		179,
		194,
		185,
		184,
		202,
		212,
		220,
		224,
		230,
		-1,
		307,
		-1,
		249,
		233,
		235,
		207,
		228,
		-1,
		265,
		260,
		278,
		263,
		261,
		-1,
		233,
		230,
		220,
		198,
		183,
		200,
		192,
		190,
		192,
		174,
		188,
		179,
		197,
		204,
		202,
		206,
		226,
		238,
		267,
		257,
		-1,
		239,
		244,
		203,
		211,
		230,
		303,
		267,
		-1,
		262,
		-1,
		235,
		248,
		-1,
		204,
		200,
		182,
		183,
		178,
		193,
		185,
		170,
		167,
		185,
		188,
		195,
		199,
		215,
		-1,
		-1,
		252,
		256,
		245,
		196,
		215,
		239,
		276,
		260,
		249,
		248,
		-1,
		239,
		218,
		215,
		203,
		190,
		175,
		176,
		184,
		196,
		175,
		169,
		166,
		186,
		212,
		190,
		201,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		222,
		193,
		217,
		259,
		278,
		271,
		259,
		224,
		224,
		218,
		-1,
		214,
		193,
		184,
		173,
		171,
		184,
		176,
		184,
		164,
		162,
		181,
		193,
		184,
		192,
		-1,
		-1,
		-1,
		252,
		241,
		242,
		191,
		214,
		248,
		257,
		243,
		248,
		223,
		216,
		210,
		227,
		210,
		191,
		180,
		172,
		161,
		172,
		180,
		178,
		160,
		169,
		175,
		199,
		180,
		186,
		-1,
		-1,
		259,
		249,
		233,
		235,
		232,
		205,
		212,
		244,
		248,
		256,
		-1,
		215,
		-1,
		204,
		200,
		185,
		180,
		177,
		164,
		163,
		177,
		177,
		167,
		162,
		169,
		204,
		204,
		170,
		190,
		193,
		-1,
		-1,
		-1,
		252,
		250,
		225,
		202,
		186,
		222,
		-1,
		226,
		227,
		-1,
		209,
		203,
		200,
		187,
		183,
		168,
		172,
		174,
		177,
		165,
		171,
		172,
		154,
		178,
		-1,
		178,
		172,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		248,
		227,
		220,
		240,
		181,
		233,
		-1,
		-1,
		211,
		204,
		-1,
		196,
		178,
		180,
		175,
		171,
		173,
		170,
		159,
		172,
		165,
		159,
		153,
		166,
		170,
		171,
		160,
		156,
		153,
		167,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		201,
		-1,
		214,
		206,
		202,
		196,
		195,
		191,
		189,
		199,
		183,
		185,
		181,
		173,
		168,
		154,
		147,
		158,
		143,
		161,
		167,
		158,
		153,
		152,
		163,
		-1,
		268,
		254,
		225,
		-1,
		-1,
		214,
		-1,
		178,
		192,
		208,
		-1,
		233,
		212,
		227,
		205,
		201,
		192,
		190,
		191,
		161,
		166,
		168,
		156,
		159,
		148,
		151,
		143,
		165,
		162,
		146,
		148,
		157,
		-1,
		274,
		261,
		219,
		215,
		204,
		224,
		175,
		184,
		195,
		-1,
		-1,
		252,
		-1,
		203,
		208,
		206,
		204,
		180,
		155,
		162,
		180,
		153,
		148,
		153,
		142,
		142,
		137,
		156,
		142,
		140,
		155,
		171,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		190,
		177,
		171,
		-1,
		212,
		-1,
		230,
		218,
		205,
		187,
		227,
		-1,
		154,
		150,
		157,
		-1,
		173,
		-1,
		145,
		148,
		139,
		134,
		131,
		142,
		140,
		149,
		150,
		-1,
		224,
		209,
		202,
		192,
		206,
		177,
		-1,
		218,
		-1,
		-1,
		217,
		211,
		211,
		180,
		177,
		170,
		150,
		142,
		157,
		156,
		143,
		142,
		130,
		130,
		133,
		127,
		140,
		150,
		156,
		148,
		-1,
		-1,
		-1,
		229,
		181,
		189,
		165,
		184,
		-1,
		-1,
		278,
		234,
		220,
		-1,
		172,
		170,
		158,
		148,
		138,
		143,
		144,
		134,
		132,
		128,
		137,
		136,
		129,
		128,
		149,
		142,
		164,
		-1,
		-1,
		178,
		191,
		193,
		162,
		157,
		-1,
		-1,
		-1,
		224,
		220,
		191,
		170,
		159,
		-1,
		-1,
		142,
		135,
		129,
		132,
		120,
		140,
		147,
		135,
		122,
		137,
		147,
		155,
		154,
		-1,
		181,
		168,
		-1,
		-1,
		156,
		146,
		-1,
		-1,
		-1,
		-1,
		198,
		148,
		137,
		132,
		136,
		141,
		-1,
		115,
		126,
		119,
		138,
		145,
		137,
		122,
		116,
		127,
		142,
		159,
		-1,
		-1,
		170,
		-1,
		132,
		-1,
		-1,
		-1,
		-1,
		160,
		154,
		125,
		118,
		122,
		-1,
		117,
		119,
		116,
		128,
		133,
		137,
		128,
		110,
		124,
		127,
		140,
		154,
		158,
		193,
		-1,
		123,
		-1,
		-1,
		-1,
		162,
		163,
		158,
		135,
		114,
		107,
		104,
		103,
		108,
		119,
		128,
		139,
		104,
		108,
		123,
		128,
		132,
		149,
		153,
		-1,
		-1,
		121,
		117,
		152,
		164,
		136,
		185,
		-1,
		-1,
		103,
		96,
		106,
		99,
		112,
		115,
		100,
		102,
		120,
		133,
		127,
		137,
		152,
		147,
		-1,
		-1,
		-1,
		119,
		-1,
		135,
		-1,
		-1,
		126,
		176,
		123,
		105,
		101,
		87,
		94,
		88,
		90,
		95,
		114,
		109,
		118,
		123,
		127,
		150,
		139,
		178,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		85,
		104,
		99,
		105,
		110,
		101,
		138,
		135,
		-1,
		84,
		117,
		85,
		99,
		95,
		102,
		107,
		113,
		117,
		124,
		140,
		139,
		134,
		170,
		161,
		167,
		-1,
		-1,
		127,
		116,
		105,
		111,
		-1,
		78,
		101,
		91,
		81,
		87,
		-1,
		-1,
		102,
		99,
		97,
		77,
		83,
		88,
		91,
		129,
		105,
		113,
		117,
		121,
		127,
		132,
		137,
		143,
		158,
		173,
		-1,
		81,
		118,
		111,
		79,
		87,
		118,
		-1,
		68,
		60,
		88,
		73,
		81,
		-1,
		-1,
		75,
		66,
		71,
		80,
		81,
		112,
		111,
		124,
		127,
		132,
		120,
		119,
		137,
		141,
		150,
		157,
		147,
		160,
		164,
		-1,
		74,
		94,
		73,
		76,
		100,
		114,
		-1,
		59,
		-1,
		-1,
		104,
		94,
		84,
		74,
		71,
		118,
		94,
		89,
		95,
		97,
		121,
		112,
		137,
		128,
		128,
		131,
		146,
		151,
		143,
		157,
		157,
		158,
		-1,
		63,
		74,
		67,
		-1,
		-1,
		-1,
		-1,
		53,
		-1,
		-1,
		120,
		-1,
		111,
		-1,
		94,
		98,
		102,
		105,
		120,
		107,
		114,
		131,
		137,
		126,
		136,
		132,
		133,
		142,
		153,
		165,
		164,
		165,
		88,
		44,
		47,
		58,
		69,
		84,
		88,
		-1,
		43,
		79,
		88,
		-1,
		129,
		-1,
		-1,
		-1,
		108,
		115,
		107,
		123,
		119,
		119,
		115,
		119,
		131,
		138,
		148,
		150,
		142,
		146,
		159,
		170,
		173,
		84,
		75,
		88,
		33,
		33,
		54,
		63,
		84,
		38,
		36,
		73,
		77,
		92,
		97,
		121,
		-1,
		-1,
		131,
		125,
		-1,
		-1,
		126,
		136,
		119,
		121,
		125,
		139,
		151,
		159,
		149,
		147,
		141,
		173,
		-1,
		77,
		76,
		65,
		62,
		38,
		29,
		24,
		51,
		-1,
		-1,
		36,
		64,
		47,
		51,
		67,
		92,
		-1,
		128,
		-1,
		-1,
		152,
		-1,
		-1,
		178,
		141,
		130,
		121,
		127,
		133,
		144,
		166,
		155,
		156,
		146,
		156,
		169,
		61,
		58,
		46,
		44,
		67,
		32,
		20,
		-1,
		15,
		22,
		27,
		34,
		51,
		81,
		-1,
		-1,
		144,
		135,
		-1,
		-1,
		171,
		174,
		163,
		-1,
		153,
		126,
		131,
		156,
		163,
		164,
		158,
		152,
		159,
		158,
		166,
		174,
		70,
		84,
		73,
		69,
		68,
		76,
		25,
		18,
		12,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		161,
		154,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		148,
		148,
		151,
		155,
		150,
		161,
		153,
		157,
		174,
		-1,
		104,
		-1,
		56,
		0,
		20,
		35,
		43,
		-1,
		-1,
		-1,
		178,
		164,
		157,
		145,
		143,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		184,
		152,
		157,
		152,
		156,
		167,
		156,
		159,
		173,
		168,
		-1,
		-1,
		18,
		21,
		-1,
		-1,
		47,
		66,
		-1,
		169,
		158,
		143,
		135,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		141,
		166,
		155,
		163,
		158,
		160,
		166,
		169,
		158,
		162,
		174,
		-1,
		-1,
		25,
		28,
		33,
		-1,
		56,
		-1,
		171,
		-1,
		138,
		145,
		133,
		-1,
		-1,
		-1,
		179,
		142,
		163,
		173,
		178,
		176,
		167,
		164,
		171,
		169,
		165,
		176,
		-1,
		-1,
		-1,
		86,
		63,
		178,
		169,
		152,
		132,
		124,
		144,
		-1,
		166,
		-1,
		141,
		143,
		169,
		172,
		189,
		183,
		167,
		182,
		172,
		163,
		172,
		92,
		-1,
		67,
		126,
		109,
		138,
		104,
		116,
		180,
		-1,
		163,
		145,
		-1,
		173,
		163,
		206,
		186,
		180,
		167,
		174,
		176,
		169,
		-1,
		-1,
		-1,
		82,
		81,
		80,
		91,
		99,
		97,
		115,
		-1,
		168,
		150,
		136,
		153,
		153,
		144,
		152,
		196,
		192,
		185,
		187,
		176,
		-1,
		176,
		-1,
		-1,
		105,
		-1,
		-1,
		-1,
		108,
		130,
		125,
		117,
		129,
		138,
		133,
		135,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		175,
		207,
		-1,
		183,
		-1,
		112,
		-1,
		-1,
		126,
		112,
		124,
		135,
		125,
		125,
		130,
		128,
		150,
		180,
		166,
		164,
		169,
		174,
		-1,
		193,
		194,
		-1,
		145,
		137,
		123,
		-1,
		116,
		-1,
		171,
		132,
		-1,
		157,
		137,
		-1,
		175,
		171,
		-1,
		-1,
		201,
		161,
		-1,
		-1,
		-1,
		146,
		126,
		166,
		150,
		-1,
		148,
		148,
		-1,
		-1,
		-1,
		186,
		170,
		-1,
		139,
		142,
		-1,
		133,
		139,
		168,
		150,
		154,
		-1,
		-1,
		-1,
		195,
		176,
		170,
		154,
		159,
		147,
		164,
		150,
		152,
		164,
		153,
		174,
		-1,
		-1,
		-1,
		167,
		159,
		159,
		-1,
		-1,
		177,
		160,
		160,
		173,
		-1,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		168,
		-1,
		-1,
		173,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		178,
		-1,
		-1,
		-1,
		169,
		176,
		184,
		-1,
		-1,
		-1,
		-1,
		199,
		200,
		224,
		199,
		-1,
		-1,
		-1,
		183,
		183,
		-1,
		-1,
		202,
		200,
		-1,
		-1,
		-1,
		211,
		195,
		-1,
		187,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		216,
		-1,
		222,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		229,
		221,
		235,
		-1,
		207,
		209,
		-1,
		257,
		-1,
		-1,
		244,
		235,
		-1,
		-1,
		212,
		219,
		241,
		244,
		274,
		-1,
		231
	],
	[
		-1,
		305,
		294,
		305,
		313,
		286,
		293,
		-1,
		312,
		316,
		282,
		276,
		315,
		284,
		290,
		301,
		-1,
		-1,
		-1,
		305,
		304,
		272,
		270,
		279,
		284,
		291,
		-1,
		290,
		-1,
		326,
		305,
		316,
		321,
		265,
		262,
		282,
		301,
		283,
		275,
		341,
		295,
		266,
		260,
		278,
		268,
		277,
		269,
		-1,
		266,
		256,
		278,
		257,
		268,
		260,
		-1,
		-1,
		260,
		261,
		267,
		253,
		259,
		255,
		-1,
		265,
		249,
		-1,
		-1,
		250,
		251,
		235,
		238,
		246,
		244,
		257,
		249,
		244,
		-1,
		-1,
		241,
		237,
		244,
		231,
		227,
		244,
		257,
		239,
		253,
		252,
		-1,
		247,
		265,
		270,
		238,
		236,
		220,
		218,
		236,
		238,
		244,
		244,
		-1,
		256,
		257,
		252,
		260,
		260,
		236,
		223,
		223,
		233,
		226,
		245,
		233,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		256,
		239,
		256,
		248,
		238,
		253,
		246,
		226,
		223,
		221,
		218,
		234,
		232,
		242,
		-1,
		-1,
		312,
		281,
		316,
		273,
		258,
		-1,
		252,
		232,
		238,
		242,
		236,
		229,
		243,
		239,
		-1,
		212,
		211,
		239,
		225,
		236,
		272,
		-1,
		-1,
		270,
		262,
		247,
		250,
		247,
		247,
		247,
		246,
		238,
		224,
		220,
		226,
		229,
		229,
		235,
		206,
		216,
		220,
		218,
		243,
		-1,
		-1,
		278,
		-1,
		-1,
		269,
		252,
		-1,
		235,
		242,
		242,
		259,
		249,
		270,
		257,
		248,
		240,
		234,
		222,
		224,
		221,
		234,
		222,
		203,
		228,
		232,
		213,
		234,
		229,
		-1,
		277,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		228,
		231,
		237,
		261,
		271,
		-1,
		269,
		257,
		258,
		243,
		240,
		227,
		215,
		228,
		213,
		220,
		219,
		207,
		205,
		235,
		210,
		232,
		229,
		248,
		253,
		247,
		256,
		-1,
		277,
		273,
		269,
		276,
		225,
		-1,
		-1,
		265,
		-1,
		279,
		292,
		281,
		254,
		257,
		244,
		235,
		222,
		211,
		222,
		211,
		208,
		216,
		199,
		214,
		205,
		204,
		222,
		232,
		240,
		244,
		250,
		-1,
		327,
		-1,
		269,
		253,
		255,
		227,
		248,
		-1,
		285,
		280,
		298,
		283,
		281,
		-1,
		253,
		250,
		240,
		218,
		203,
		220,
		212,
		210,
		212,
		194,
		208,
		199,
		217,
		224,
		222,
		226,
		246,
		258,
		287,
		277,
		-1,
		259,
		264,
		223,
		231,
		250,
		323,
		287,
		-1,
		282,
		-1,
		255,
		268,
		-1,
		224,
		220,
		202,
		203,
		198,
		213,
		205,
		190,
		187,
		205,
		208,
		215,
		219,
		235,
		-1,
		-1,
		272,
		276,
		265,
		216,
		235,
		259,
		296,
		280,
		269,
		268,
		-1,
		259,
		238,
		235,
		223,
		210,
		195,
		196,
		204,
		216,
		195,
		189,
		186,
		206,
		232,
		210,
		221,
		-1,
		-1,
		-1,
		297,
		-1,
		-1,
		242,
		213,
		237,
		279,
		298,
		291,
		279,
		244,
		244,
		238,
		-1,
		234,
		213,
		204,
		193,
		191,
		204,
		196,
		204,
		184,
		182,
		201,
		213,
		204,
		212,
		-1,
		-1,
		-1,
		272,
		261,
		262,
		211,
		234,
		268,
		277,
		263,
		268,
		243,
		236,
		230,
		247,
		230,
		211,
		200,
		192,
		181,
		192,
		200,
		198,
		180,
		189,
		195,
		219,
		200,
		206,
		-1,
		-1,
		279,
		269,
		253,
		255,
		252,
		225,
		232,
		264,
		268,
		276,
		-1,
		235,
		-1,
		224,
		220,
		205,
		200,
		197,
		184,
		183,
		197,
		197,
		187,
		182,
		189,
		224,
		224,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		272,
		270,
		245,
		222,
		206,
		242,
		-1,
		246,
		247,
		-1,
		229,
		223,
		220,
		207,
		203,
		188,
		192,
		194,
		197,
		185,
		191,
		192,
		174,
		198,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		268,
		247,
		240,
		260,
		201,
		253,
		-1,
		-1,
		231,
		224,
		-1,
		216,
		198,
		200,
		195,
		191,
		193,
		190,
		179,
		192,
		185,
		179,
		173,
		186,
		190,
		191,
		180,
		176,
		173,
		187,
		-1,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		221,
		-1,
		234,
		226,
		222,
		216,
		215,
		211,
		209,
		219,
		203,
		205,
		201,
		193,
		188,
		174,
		167,
		178,
		163,
		181,
		187,
		178,
		173,
		172,
		183,
		-1,
		288,
		274,
		245,
		-1,
		-1,
		234,
		-1,
		198,
		212,
		228,
		-1,
		253,
		232,
		247,
		225,
		221,
		212,
		210,
		211,
		181,
		186,
		188,
		176,
		179,
		168,
		171,
		163,
		185,
		182,
		166,
		168,
		177,
		-1,
		294,
		281,
		239,
		235,
		224,
		244,
		195,
		204,
		215,
		-1,
		-1,
		272,
		-1,
		223,
		228,
		226,
		224,
		200,
		175,
		182,
		200,
		173,
		168,
		173,
		162,
		162,
		157,
		176,
		162,
		160,
		175,
		191,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		210,
		197,
		191,
		-1,
		232,
		-1,
		250,
		238,
		225,
		207,
		247,
		-1,
		174,
		170,
		177,
		-1,
		193,
		-1,
		165,
		168,
		159,
		154,
		151,
		162,
		160,
		169,
		170,
		-1,
		244,
		229,
		222,
		212,
		226,
		197,
		-1,
		238,
		-1,
		-1,
		237,
		231,
		231,
		200,
		197,
		190,
		170,
		162,
		177,
		176,
		163,
		162,
		150,
		150,
		153,
		147,
		160,
		170,
		176,
		168,
		-1,
		-1,
		-1,
		249,
		201,
		209,
		185,
		204,
		-1,
		-1,
		298,
		254,
		240,
		-1,
		192,
		190,
		178,
		168,
		158,
		163,
		164,
		154,
		152,
		148,
		157,
		156,
		149,
		148,
		169,
		162,
		184,
		-1,
		-1,
		198,
		211,
		213,
		182,
		177,
		-1,
		-1,
		-1,
		244,
		240,
		211,
		190,
		179,
		-1,
		-1,
		162,
		155,
		149,
		152,
		140,
		160,
		167,
		155,
		142,
		157,
		167,
		175,
		174,
		-1,
		201,
		188,
		-1,
		-1,
		176,
		166,
		-1,
		-1,
		-1,
		-1,
		218,
		168,
		157,
		152,
		156,
		161,
		-1,
		135,
		146,
		139,
		158,
		165,
		157,
		142,
		136,
		147,
		162,
		179,
		-1,
		-1,
		190,
		-1,
		152,
		-1,
		-1,
		-1,
		-1,
		180,
		174,
		145,
		138,
		142,
		-1,
		137,
		139,
		136,
		148,
		153,
		157,
		148,
		130,
		144,
		147,
		160,
		174,
		178,
		213,
		-1,
		143,
		-1,
		-1,
		-1,
		182,
		183,
		178,
		155,
		134,
		127,
		124,
		123,
		128,
		139,
		148,
		159,
		124,
		128,
		143,
		148,
		152,
		169,
		173,
		-1,
		-1,
		141,
		137,
		172,
		184,
		156,
		205,
		-1,
		-1,
		123,
		116,
		126,
		119,
		132,
		135,
		120,
		122,
		140,
		153,
		147,
		157,
		172,
		167,
		-1,
		-1,
		-1,
		139,
		-1,
		155,
		-1,
		-1,
		146,
		196,
		143,
		125,
		121,
		107,
		114,
		108,
		110,
		115,
		134,
		129,
		138,
		143,
		147,
		170,
		159,
		198,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		105,
		124,
		119,
		125,
		130,
		121,
		158,
		155,
		-1,
		104,
		137,
		105,
		119,
		115,
		122,
		127,
		133,
		137,
		144,
		160,
		159,
		154,
		190,
		181,
		187,
		-1,
		-1,
		147,
		136,
		125,
		131,
		-1,
		98,
		121,
		111,
		101,
		107,
		-1,
		-1,
		122,
		119,
		117,
		97,
		103,
		108,
		111,
		149,
		125,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		101,
		138,
		131,
		99,
		107,
		138,
		-1,
		88,
		80,
		108,
		93,
		101,
		-1,
		-1,
		95,
		86,
		91,
		100,
		101,
		132,
		131,
		144,
		147,
		152,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		94,
		114,
		93,
		96,
		120,
		134,
		-1,
		79,
		-1,
		-1,
		124,
		114,
		104,
		94,
		91,
		138,
		114,
		109,
		115,
		117,
		141,
		132,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		83,
		94,
		87,
		-1,
		-1,
		-1,
		-1,
		73,
		-1,
		-1,
		140,
		-1,
		131,
		-1,
		114,
		118,
		122,
		125,
		140,
		127,
		134,
		151,
		157,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		108,
		64,
		67,
		78,
		89,
		104,
		108,
		-1,
		63,
		99,
		108,
		-1,
		149,
		-1,
		-1,
		-1,
		128,
		135,
		127,
		143,
		139,
		139,
		135,
		139,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		104,
		95,
		108,
		53,
		53,
		74,
		83,
		104,
		58,
		56,
		93,
		97,
		112,
		117,
		141,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		146,
		156,
		139,
		141,
		145,
		159,
		171,
		179,
		169,
		167,
		161,
		193,
		-1,
		97,
		96,
		85,
		82,
		58,
		49,
		44,
		71,
		-1,
		-1,
		56,
		84,
		67,
		71,
		87,
		112,
		-1,
		148,
		-1,
		-1,
		172,
		-1,
		-1,
		198,
		161,
		150,
		141,
		147,
		153,
		164,
		186,
		175,
		176,
		166,
		176,
		189,
		81,
		78,
		66,
		64,
		87,
		52,
		40,
		-1,
		35,
		42,
		47,
		54,
		71,
		101,
		-1,
		-1,
		164,
		155,
		-1,
		-1,
		191,
		194,
		183,
		-1,
		173,
		146,
		151,
		176,
		183,
		184,
		178,
		172,
		179,
		178,
		186,
		194,
		90,
		104,
		93,
		89,
		88,
		96,
		45,
		38,
		32,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		167,
		163,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		168,
		168,
		171,
		175,
		170,
		181,
		173,
		177,
		194,
		-1,
		124,
		-1,
		76,
		20,
		0,
		15,
		23,
		-1,
		-1,
		-1,
		184,
		170,
		163,
		151,
		149,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		204,
		172,
		177,
		172,
		176,
		187,
		176,
		179,
		193,
		188,
		-1,
		-1,
		24,
		27,
		-1,
		-1,
		53,
		72,
		-1,
		175,
		164,
		149,
		141,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		160,
		186,
		175,
		183,
		178,
		180,
		186,
		189,
		178,
		182,
		194,
		-1,
		-1,
		31,
		34,
		39,
		-1,
		62,
		-1,
		177,
		-1,
		144,
		151,
		139,
		-1,
		-1,
		-1,
		191,
		154,
		170,
		193,
		198,
		196,
		187,
		184,
		191,
		189,
		185,
		196,
		-1,
		-1,
		-1,
		92,
		69,
		184,
		175,
		158,
		138,
		130,
		150,
		-1,
		172,
		-1,
		147,
		150,
		175,
		192,
		209,
		202,
		187,
		202,
		192,
		183,
		192,
		98,
		-1,
		73,
		132,
		115,
		144,
		110,
		122,
		186,
		-1,
		169,
		151,
		-1,
		179,
		169,
		217,
		192,
		200,
		187,
		188,
		189,
		189,
		-1,
		-1,
		-1,
		88,
		87,
		86,
		97,
		105,
		103,
		121,
		-1,
		174,
		156,
		142,
		159,
		159,
		150,
		158,
		207,
		203,
		205,
		204,
		182,
		-1,
		191,
		-1,
		-1,
		111,
		-1,
		-1,
		-1,
		114,
		136,
		131,
		123,
		135,
		144,
		139,
		141,
		154,
		162,
		160,
		157,
		169,
		165,
		185,
		181,
		213,
		-1,
		198,
		-1,
		118,
		-1,
		-1,
		132,
		118,
		130,
		141,
		131,
		131,
		136,
		134,
		156,
		186,
		172,
		170,
		175,
		180,
		-1,
		208,
		209,
		-1,
		151,
		143,
		129,
		-1,
		122,
		-1,
		177,
		138,
		-1,
		163,
		143,
		-1,
		181,
		177,
		-1,
		-1,
		207,
		167,
		-1,
		-1,
		-1,
		152,
		132,
		172,
		156,
		-1,
		154,
		154,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		145,
		148,
		-1,
		139,
		145,
		174,
		156,
		160,
		-1,
		-1,
		-1,
		201,
		182,
		176,
		160,
		165,
		153,
		170,
		156,
		158,
		170,
		159,
		180,
		-1,
		-1,
		-1,
		173,
		165,
		165,
		-1,
		-1,
		183,
		166,
		166,
		179,
		-1,
		-1,
		-1,
		195,
		176,
		-1,
		-1,
		174,
		-1,
		-1,
		179,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		184,
		-1,
		-1,
		-1,
		175,
		182,
		190,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		230,
		205,
		-1,
		-1,
		-1,
		189,
		189,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		217,
		201,
		-1,
		193,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		222,
		-1,
		228,
		203,
		210,
		-1,
		-1,
		-1,
		-1,
		235,
		227,
		241,
		-1,
		213,
		215,
		-1,
		263,
		-1,
		-1,
		250,
		241,
		-1,
		-1,
		218,
		225,
		247,
		250,
		280,
		-1,
		237
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		327,
		331,
		297,
		291,
		330,
		299,
		305,
		316,
		-1,
		-1,
		-1,
		320,
		319,
		287,
		285,
		294,
		299,
		306,
		-1,
		305,
		-1,
		341,
		320,
		331,
		336,
		280,
		277,
		297,
		316,
		298,
		290,
		356,
		310,
		281,
		275,
		293,
		283,
		292,
		284,
		-1,
		281,
		271,
		293,
		272,
		283,
		275,
		-1,
		-1,
		275,
		276,
		282,
		268,
		274,
		270,
		-1,
		280,
		264,
		-1,
		-1,
		265,
		266,
		250,
		253,
		261,
		259,
		272,
		264,
		259,
		-1,
		-1,
		256,
		252,
		259,
		246,
		242,
		259,
		272,
		254,
		268,
		267,
		-1,
		262,
		280,
		285,
		253,
		251,
		235,
		233,
		251,
		253,
		259,
		259,
		-1,
		271,
		272,
		267,
		275,
		275,
		251,
		238,
		238,
		248,
		241,
		260,
		248,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		271,
		254,
		271,
		263,
		253,
		268,
		261,
		241,
		238,
		236,
		233,
		249,
		247,
		257,
		-1,
		-1,
		327,
		296,
		331,
		288,
		273,
		-1,
		267,
		247,
		253,
		257,
		251,
		244,
		258,
		254,
		-1,
		227,
		226,
		254,
		240,
		251,
		287,
		-1,
		-1,
		285,
		277,
		262,
		265,
		262,
		262,
		262,
		261,
		253,
		239,
		235,
		241,
		244,
		244,
		250,
		221,
		231,
		235,
		233,
		258,
		-1,
		-1,
		293,
		-1,
		-1,
		284,
		267,
		-1,
		250,
		257,
		257,
		274,
		264,
		285,
		272,
		263,
		255,
		249,
		237,
		239,
		236,
		249,
		237,
		218,
		243,
		247,
		228,
		249,
		244,
		-1,
		292,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		243,
		246,
		252,
		276,
		286,
		-1,
		284,
		272,
		273,
		258,
		255,
		242,
		230,
		243,
		228,
		235,
		234,
		222,
		220,
		250,
		225,
		247,
		244,
		263,
		268,
		262,
		271,
		-1,
		292,
		288,
		284,
		291,
		240,
		-1,
		-1,
		280,
		-1,
		294,
		307,
		296,
		269,
		272,
		259,
		250,
		237,
		226,
		237,
		226,
		223,
		231,
		214,
		229,
		220,
		219,
		237,
		247,
		255,
		259,
		265,
		-1,
		342,
		-1,
		284,
		268,
		270,
		242,
		263,
		-1,
		300,
		295,
		313,
		298,
		296,
		-1,
		268,
		265,
		255,
		233,
		218,
		235,
		227,
		225,
		227,
		209,
		223,
		214,
		232,
		239,
		237,
		241,
		261,
		273,
		302,
		292,
		-1,
		274,
		279,
		238,
		246,
		265,
		338,
		302,
		-1,
		297,
		-1,
		270,
		283,
		-1,
		239,
		235,
		217,
		218,
		213,
		228,
		220,
		205,
		202,
		220,
		223,
		230,
		234,
		250,
		-1,
		-1,
		287,
		291,
		280,
		231,
		250,
		274,
		311,
		295,
		284,
		283,
		-1,
		274,
		253,
		250,
		238,
		225,
		210,
		211,
		219,
		231,
		210,
		204,
		201,
		221,
		247,
		225,
		236,
		-1,
		-1,
		-1,
		312,
		-1,
		-1,
		257,
		228,
		252,
		294,
		313,
		306,
		294,
		259,
		259,
		253,
		-1,
		249,
		228,
		219,
		208,
		206,
		219,
		211,
		219,
		199,
		197,
		216,
		228,
		219,
		227,
		-1,
		-1,
		-1,
		287,
		276,
		277,
		226,
		249,
		283,
		292,
		278,
		283,
		258,
		251,
		245,
		262,
		245,
		226,
		215,
		207,
		196,
		207,
		215,
		213,
		195,
		204,
		210,
		234,
		215,
		221,
		-1,
		-1,
		294,
		284,
		268,
		270,
		267,
		240,
		247,
		279,
		283,
		291,
		-1,
		250,
		-1,
		239,
		235,
		220,
		215,
		212,
		199,
		198,
		212,
		212,
		202,
		197,
		204,
		239,
		239,
		205,
		225,
		228,
		-1,
		-1,
		-1,
		287,
		285,
		260,
		237,
		221,
		257,
		-1,
		261,
		262,
		-1,
		244,
		238,
		235,
		222,
		218,
		203,
		207,
		209,
		212,
		200,
		206,
		207,
		189,
		213,
		-1,
		213,
		207,
		215,
		205,
		193,
		-1,
		-1,
		-1,
		283,
		262,
		255,
		275,
		216,
		268,
		-1,
		-1,
		246,
		239,
		-1,
		231,
		213,
		215,
		210,
		206,
		208,
		205,
		194,
		207,
		200,
		194,
		188,
		201,
		205,
		206,
		195,
		191,
		188,
		202,
		-1,
		302,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		236,
		-1,
		249,
		241,
		237,
		231,
		230,
		226,
		224,
		234,
		218,
		220,
		216,
		208,
		203,
		189,
		182,
		193,
		178,
		196,
		202,
		193,
		188,
		187,
		198,
		-1,
		303,
		289,
		260,
		-1,
		-1,
		249,
		-1,
		213,
		227,
		243,
		-1,
		268,
		247,
		262,
		240,
		236,
		227,
		225,
		226,
		196,
		201,
		203,
		191,
		194,
		183,
		186,
		178,
		200,
		197,
		181,
		183,
		192,
		-1,
		309,
		296,
		254,
		250,
		239,
		259,
		210,
		219,
		230,
		-1,
		-1,
		287,
		-1,
		238,
		243,
		241,
		239,
		215,
		190,
		197,
		215,
		188,
		183,
		188,
		177,
		177,
		172,
		191,
		177,
		175,
		190,
		206,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		225,
		212,
		206,
		-1,
		247,
		-1,
		265,
		253,
		240,
		222,
		262,
		-1,
		189,
		185,
		192,
		-1,
		208,
		-1,
		180,
		183,
		174,
		169,
		166,
		177,
		175,
		184,
		185,
		-1,
		259,
		244,
		237,
		227,
		241,
		212,
		-1,
		253,
		-1,
		-1,
		252,
		246,
		246,
		215,
		212,
		205,
		185,
		177,
		192,
		191,
		178,
		177,
		165,
		165,
		168,
		162,
		175,
		185,
		191,
		183,
		-1,
		-1,
		-1,
		264,
		216,
		224,
		200,
		219,
		-1,
		-1,
		313,
		269,
		255,
		-1,
		207,
		205,
		193,
		183,
		173,
		178,
		179,
		169,
		167,
		163,
		172,
		171,
		164,
		163,
		184,
		177,
		199,
		-1,
		-1,
		213,
		226,
		228,
		197,
		192,
		-1,
		-1,
		-1,
		259,
		255,
		226,
		205,
		194,
		-1,
		-1,
		177,
		170,
		164,
		167,
		155,
		175,
		182,
		170,
		157,
		172,
		182,
		190,
		189,
		-1,
		216,
		203,
		-1,
		-1,
		191,
		181,
		-1,
		-1,
		-1,
		-1,
		233,
		183,
		172,
		167,
		171,
		176,
		-1,
		150,
		161,
		154,
		173,
		180,
		172,
		157,
		151,
		162,
		177,
		194,
		-1,
		-1,
		205,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		195,
		189,
		160,
		153,
		157,
		-1,
		152,
		154,
		151,
		163,
		168,
		172,
		163,
		145,
		159,
		162,
		175,
		189,
		193,
		228,
		-1,
		158,
		-1,
		-1,
		-1,
		197,
		198,
		193,
		170,
		149,
		142,
		139,
		138,
		143,
		154,
		163,
		174,
		139,
		143,
		158,
		163,
		167,
		184,
		188,
		-1,
		-1,
		156,
		152,
		187,
		199,
		171,
		220,
		-1,
		-1,
		138,
		131,
		141,
		134,
		147,
		150,
		135,
		137,
		155,
		168,
		162,
		172,
		187,
		182,
		-1,
		-1,
		-1,
		154,
		-1,
		170,
		-1,
		-1,
		161,
		211,
		158,
		140,
		136,
		122,
		129,
		123,
		125,
		130,
		149,
		144,
		153,
		158,
		162,
		185,
		174,
		213,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		120,
		139,
		134,
		140,
		145,
		136,
		173,
		170,
		-1,
		119,
		152,
		120,
		134,
		130,
		137,
		142,
		148,
		152,
		159,
		175,
		174,
		169,
		205,
		196,
		202,
		-1,
		-1,
		162,
		151,
		140,
		146,
		-1,
		113,
		136,
		126,
		116,
		122,
		-1,
		-1,
		137,
		134,
		132,
		112,
		118,
		123,
		126,
		164,
		140,
		148,
		152,
		156,
		162,
		167,
		172,
		178,
		193,
		208,
		-1,
		116,
		153,
		146,
		114,
		122,
		153,
		-1,
		103,
		95,
		123,
		108,
		116,
		-1,
		-1,
		110,
		101,
		106,
		115,
		116,
		147,
		146,
		159,
		162,
		167,
		155,
		154,
		172,
		176,
		185,
		192,
		182,
		195,
		199,
		-1,
		109,
		129,
		108,
		111,
		135,
		149,
		-1,
		94,
		-1,
		-1,
		139,
		129,
		119,
		109,
		106,
		153,
		129,
		124,
		130,
		132,
		156,
		147,
		172,
		163,
		163,
		166,
		181,
		186,
		178,
		192,
		192,
		193,
		-1,
		98,
		109,
		102,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		155,
		-1,
		146,
		-1,
		129,
		133,
		137,
		140,
		155,
		142,
		149,
		166,
		172,
		161,
		171,
		167,
		168,
		177,
		188,
		200,
		199,
		200,
		123,
		79,
		82,
		93,
		104,
		119,
		123,
		-1,
		78,
		114,
		123,
		-1,
		164,
		-1,
		-1,
		-1,
		143,
		150,
		142,
		158,
		154,
		154,
		150,
		154,
		166,
		173,
		183,
		185,
		177,
		181,
		194,
		205,
		208,
		119,
		110,
		123,
		68,
		68,
		89,
		98,
		119,
		73,
		71,
		108,
		112,
		127,
		132,
		156,
		-1,
		-1,
		166,
		160,
		-1,
		-1,
		161,
		171,
		154,
		156,
		160,
		174,
		186,
		194,
		184,
		182,
		176,
		208,
		-1,
		112,
		111,
		100,
		97,
		73,
		64,
		59,
		86,
		-1,
		-1,
		71,
		99,
		82,
		86,
		102,
		127,
		-1,
		163,
		-1,
		-1,
		187,
		-1,
		-1,
		213,
		176,
		165,
		156,
		162,
		168,
		179,
		201,
		190,
		191,
		181,
		191,
		204,
		96,
		93,
		81,
		79,
		102,
		67,
		55,
		-1,
		50,
		57,
		62,
		69,
		86,
		116,
		-1,
		-1,
		179,
		170,
		-1,
		-1,
		206,
		209,
		198,
		-1,
		188,
		161,
		166,
		191,
		198,
		199,
		193,
		187,
		194,
		193,
		201,
		209,
		105,
		119,
		108,
		104,
		103,
		111,
		60,
		53,
		47,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		206,
		199,
		187,
		175,
		165,
		175,
		183,
		183,
		186,
		190,
		185,
		196,
		188,
		192,
		209,
		-1,
		139,
		-1,
		91,
		35,
		15,
		0,
		8,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		240,
		224,
		205,
		-1,
		175,
		188,
		219,
		187,
		192,
		187,
		191,
		202,
		191,
		194,
		208,
		203,
		-1,
		-1,
		39,
		42,
		-1,
		-1,
		68,
		87,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		212,
		208,
		-1,
		-1,
		175,
		201,
		190,
		198,
		193,
		195,
		201,
		204,
		193,
		197,
		209,
		-1,
		-1,
		46,
		49,
		54,
		-1,
		77,
		-1,
		192,
		-1,
		159,
		166,
		154,
		-1,
		-1,
		-1,
		206,
		169,
		185,
		208,
		213,
		211,
		202,
		199,
		206,
		204,
		200,
		211,
		-1,
		-1,
		-1,
		107,
		84,
		199,
		190,
		173,
		153,
		145,
		165,
		-1,
		187,
		-1,
		162,
		165,
		190,
		207,
		224,
		217,
		202,
		217,
		207,
		198,
		207,
		113,
		-1,
		88,
		147,
		130,
		159,
		125,
		137,
		201,
		-1,
		184,
		166,
		-1,
		194,
		184,
		232,
		207,
		215,
		202,
		203,
		204,
		204,
		-1,
		-1,
		-1,
		103,
		102,
		101,
		112,
		120,
		118,
		136,
		-1,
		189,
		171,
		157,
		174,
		174,
		165,
		173,
		222,
		218,
		220,
		219,
		197,
		-1,
		206,
		-1,
		-1,
		126,
		-1,
		-1,
		-1,
		129,
		151,
		146,
		138,
		150,
		159,
		154,
		156,
		169,
		177,
		175,
		172,
		184,
		180,
		200,
		196,
		228,
		-1,
		213,
		-1,
		133,
		-1,
		-1,
		147,
		133,
		145,
		156,
		146,
		146,
		151,
		149,
		171,
		201,
		187,
		185,
		190,
		195,
		-1,
		223,
		224,
		-1,
		166,
		158,
		144,
		-1,
		137,
		-1,
		192,
		153,
		-1,
		178,
		158,
		-1,
		196,
		192,
		-1,
		-1,
		222,
		182,
		-1,
		-1,
		-1,
		167,
		147,
		187,
		171,
		-1,
		169,
		169,
		-1,
		-1,
		-1,
		207,
		191,
		-1,
		160,
		163,
		-1,
		154,
		160,
		189,
		171,
		175,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		175,
		180,
		168,
		185,
		171,
		173,
		185,
		174,
		195,
		-1,
		-1,
		-1,
		188,
		180,
		180,
		-1,
		-1,
		198,
		181,
		181,
		194,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		189,
		-1,
		-1,
		194,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		199,
		-1,
		-1,
		-1,
		190,
		197,
		205,
		-1,
		-1,
		-1,
		-1,
		220,
		221,
		245,
		220,
		-1,
		-1,
		-1,
		204,
		204,
		-1,
		-1,
		223,
		221,
		-1,
		-1,
		-1,
		232,
		216,
		-1,
		208,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		237,
		-1,
		243,
		218,
		225,
		-1,
		-1,
		-1,
		-1,
		250,
		242,
		256,
		-1,
		228,
		230,
		-1,
		278,
		-1,
		-1,
		265,
		256,
		-1,
		-1,
		233,
		240,
		262,
		265,
		295,
		-1,
		252
	],
	[
		-1,
		328,
		317,
		328,
		336,
		309,
		316,
		-1,
		335,
		339,
		305,
		299,
		338,
		307,
		313,
		324,
		-1,
		-1,
		-1,
		328,
		327,
		295,
		293,
		302,
		307,
		314,
		-1,
		313,
		-1,
		349,
		328,
		339,
		344,
		288,
		285,
		305,
		324,
		306,
		298,
		364,
		318,
		289,
		283,
		301,
		291,
		300,
		292,
		-1,
		289,
		279,
		301,
		280,
		291,
		283,
		-1,
		-1,
		283,
		284,
		290,
		276,
		282,
		278,
		-1,
		288,
		272,
		-1,
		-1,
		273,
		274,
		258,
		261,
		269,
		267,
		280,
		272,
		267,
		-1,
		-1,
		264,
		260,
		267,
		254,
		250,
		267,
		280,
		262,
		276,
		275,
		-1,
		270,
		288,
		293,
		261,
		259,
		243,
		241,
		259,
		261,
		267,
		267,
		-1,
		279,
		280,
		275,
		283,
		283,
		259,
		246,
		246,
		256,
		249,
		268,
		256,
		302,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		279,
		262,
		279,
		271,
		261,
		276,
		269,
		249,
		246,
		244,
		241,
		257,
		255,
		265,
		-1,
		-1,
		335,
		304,
		339,
		296,
		281,
		-1,
		275,
		255,
		261,
		265,
		259,
		252,
		266,
		262,
		-1,
		235,
		234,
		262,
		248,
		259,
		295,
		-1,
		-1,
		293,
		285,
		270,
		273,
		270,
		270,
		270,
		269,
		261,
		247,
		243,
		249,
		252,
		252,
		258,
		229,
		239,
		243,
		241,
		266,
		-1,
		-1,
		301,
		-1,
		-1,
		292,
		275,
		-1,
		258,
		265,
		265,
		282,
		272,
		293,
		280,
		271,
		263,
		257,
		245,
		247,
		244,
		257,
		245,
		226,
		251,
		255,
		236,
		257,
		252,
		-1,
		300,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		251,
		254,
		260,
		284,
		294,
		-1,
		292,
		280,
		281,
		266,
		263,
		250,
		238,
		251,
		236,
		243,
		242,
		230,
		228,
		258,
		233,
		255,
		252,
		271,
		276,
		270,
		279,
		-1,
		300,
		296,
		292,
		299,
		248,
		-1,
		-1,
		288,
		-1,
		302,
		315,
		304,
		277,
		280,
		267,
		258,
		245,
		234,
		245,
		234,
		231,
		239,
		222,
		237,
		228,
		227,
		245,
		255,
		263,
		267,
		273,
		-1,
		350,
		-1,
		292,
		276,
		278,
		250,
		271,
		-1,
		308,
		303,
		321,
		306,
		304,
		-1,
		276,
		273,
		263,
		241,
		226,
		243,
		235,
		233,
		235,
		217,
		231,
		222,
		240,
		247,
		245,
		249,
		269,
		281,
		310,
		300,
		-1,
		282,
		287,
		246,
		254,
		273,
		346,
		310,
		-1,
		305,
		-1,
		278,
		291,
		-1,
		247,
		243,
		225,
		226,
		221,
		236,
		228,
		213,
		210,
		228,
		231,
		238,
		242,
		258,
		-1,
		-1,
		295,
		299,
		288,
		239,
		258,
		282,
		319,
		303,
		292,
		291,
		-1,
		282,
		261,
		258,
		246,
		233,
		218,
		219,
		227,
		239,
		218,
		212,
		209,
		229,
		255,
		233,
		244,
		-1,
		-1,
		-1,
		320,
		-1,
		-1,
		265,
		236,
		260,
		302,
		321,
		314,
		302,
		267,
		267,
		261,
		-1,
		257,
		236,
		227,
		216,
		214,
		227,
		219,
		227,
		207,
		205,
		224,
		236,
		227,
		235,
		-1,
		-1,
		-1,
		295,
		284,
		285,
		234,
		257,
		291,
		300,
		286,
		291,
		266,
		259,
		253,
		270,
		253,
		234,
		223,
		215,
		204,
		215,
		223,
		221,
		203,
		212,
		218,
		242,
		223,
		229,
		-1,
		-1,
		302,
		292,
		276,
		278,
		275,
		248,
		255,
		287,
		291,
		299,
		-1,
		258,
		-1,
		247,
		243,
		228,
		223,
		220,
		207,
		206,
		220,
		220,
		210,
		205,
		212,
		247,
		247,
		213,
		233,
		236,
		-1,
		-1,
		-1,
		295,
		293,
		268,
		245,
		229,
		265,
		-1,
		269,
		270,
		-1,
		252,
		246,
		243,
		230,
		226,
		211,
		215,
		217,
		220,
		208,
		214,
		215,
		197,
		221,
		-1,
		221,
		215,
		223,
		213,
		201,
		-1,
		-1,
		-1,
		291,
		270,
		263,
		283,
		224,
		276,
		-1,
		-1,
		254,
		247,
		-1,
		239,
		221,
		223,
		218,
		214,
		216,
		213,
		202,
		215,
		208,
		202,
		196,
		209,
		213,
		214,
		203,
		199,
		196,
		210,
		-1,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		244,
		-1,
		257,
		249,
		245,
		239,
		238,
		234,
		232,
		242,
		226,
		228,
		224,
		216,
		211,
		197,
		190,
		201,
		186,
		204,
		210,
		201,
		196,
		195,
		206,
		-1,
		311,
		297,
		268,
		-1,
		-1,
		257,
		-1,
		221,
		235,
		251,
		-1,
		276,
		255,
		270,
		248,
		244,
		235,
		233,
		234,
		204,
		209,
		211,
		199,
		202,
		191,
		194,
		186,
		208,
		205,
		189,
		191,
		200,
		-1,
		317,
		304,
		262,
		258,
		247,
		267,
		218,
		227,
		238,
		-1,
		-1,
		295,
		-1,
		246,
		251,
		249,
		247,
		223,
		198,
		205,
		223,
		196,
		191,
		196,
		185,
		185,
		180,
		199,
		185,
		183,
		198,
		214,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		233,
		220,
		214,
		-1,
		255,
		-1,
		273,
		261,
		248,
		230,
		270,
		-1,
		197,
		193,
		200,
		-1,
		216,
		-1,
		188,
		191,
		182,
		177,
		174,
		185,
		183,
		192,
		193,
		-1,
		267,
		252,
		245,
		235,
		249,
		220,
		-1,
		261,
		-1,
		-1,
		260,
		254,
		254,
		223,
		220,
		213,
		193,
		185,
		200,
		199,
		186,
		185,
		173,
		173,
		176,
		170,
		183,
		193,
		199,
		191,
		-1,
		-1,
		-1,
		272,
		224,
		232,
		208,
		227,
		-1,
		-1,
		321,
		277,
		263,
		-1,
		215,
		213,
		201,
		191,
		181,
		186,
		187,
		177,
		175,
		171,
		180,
		179,
		172,
		171,
		192,
		185,
		207,
		-1,
		-1,
		221,
		234,
		236,
		205,
		200,
		-1,
		-1,
		-1,
		267,
		263,
		234,
		213,
		202,
		-1,
		-1,
		185,
		178,
		172,
		175,
		163,
		183,
		190,
		178,
		165,
		180,
		190,
		198,
		197,
		-1,
		224,
		211,
		-1,
		-1,
		199,
		189,
		-1,
		-1,
		-1,
		-1,
		241,
		191,
		180,
		175,
		179,
		184,
		-1,
		158,
		169,
		162,
		181,
		188,
		180,
		165,
		159,
		170,
		185,
		202,
		-1,
		-1,
		213,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		203,
		197,
		168,
		161,
		165,
		-1,
		160,
		162,
		159,
		171,
		176,
		180,
		171,
		153,
		167,
		170,
		183,
		197,
		201,
		236,
		-1,
		166,
		-1,
		-1,
		-1,
		205,
		206,
		201,
		178,
		157,
		150,
		147,
		146,
		151,
		162,
		171,
		182,
		147,
		151,
		166,
		171,
		175,
		192,
		196,
		-1,
		-1,
		164,
		160,
		195,
		207,
		179,
		228,
		-1,
		-1,
		146,
		139,
		149,
		142,
		155,
		158,
		143,
		145,
		163,
		176,
		170,
		180,
		195,
		190,
		-1,
		-1,
		-1,
		162,
		-1,
		178,
		-1,
		-1,
		169,
		219,
		166,
		148,
		144,
		130,
		137,
		131,
		133,
		138,
		157,
		152,
		161,
		166,
		170,
		193,
		182,
		221,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		128,
		147,
		142,
		148,
		153,
		144,
		181,
		178,
		-1,
		127,
		160,
		128,
		142,
		138,
		145,
		150,
		156,
		160,
		167,
		183,
		182,
		177,
		213,
		204,
		210,
		-1,
		-1,
		170,
		159,
		148,
		154,
		-1,
		121,
		144,
		134,
		124,
		130,
		-1,
		-1,
		145,
		142,
		140,
		120,
		126,
		131,
		134,
		172,
		148,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		124,
		161,
		154,
		122,
		130,
		161,
		-1,
		111,
		103,
		131,
		116,
		124,
		-1,
		-1,
		118,
		109,
		114,
		123,
		124,
		155,
		154,
		167,
		170,
		175,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		117,
		137,
		116,
		119,
		143,
		157,
		-1,
		102,
		-1,
		-1,
		147,
		137,
		127,
		117,
		114,
		161,
		137,
		132,
		138,
		140,
		164,
		155,
		180,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		106,
		117,
		110,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		163,
		-1,
		154,
		-1,
		137,
		141,
		145,
		148,
		163,
		150,
		157,
		174,
		180,
		169,
		179,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		131,
		87,
		90,
		101,
		112,
		127,
		131,
		-1,
		86,
		122,
		131,
		-1,
		172,
		-1,
		-1,
		-1,
		151,
		158,
		150,
		166,
		162,
		162,
		158,
		162,
		174,
		181,
		191,
		193,
		185,
		189,
		202,
		213,
		216,
		127,
		118,
		131,
		76,
		76,
		97,
		106,
		127,
		81,
		79,
		116,
		120,
		135,
		140,
		164,
		-1,
		-1,
		174,
		168,
		-1,
		-1,
		169,
		179,
		162,
		164,
		168,
		182,
		194,
		202,
		192,
		190,
		184,
		216,
		-1,
		120,
		119,
		108,
		105,
		81,
		72,
		67,
		94,
		-1,
		-1,
		79,
		107,
		90,
		94,
		110,
		135,
		-1,
		171,
		-1,
		-1,
		195,
		-1,
		-1,
		221,
		184,
		173,
		164,
		170,
		176,
		187,
		209,
		198,
		199,
		189,
		199,
		212,
		104,
		101,
		89,
		87,
		110,
		75,
		63,
		-1,
		58,
		65,
		70,
		77,
		94,
		124,
		-1,
		-1,
		187,
		178,
		-1,
		-1,
		214,
		217,
		206,
		-1,
		196,
		169,
		174,
		199,
		206,
		207,
		201,
		195,
		202,
		201,
		209,
		217,
		113,
		127,
		116,
		112,
		111,
		119,
		68,
		61,
		55,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		190,
		186,
		-1,
		-1,
		214,
		207,
		195,
		183,
		173,
		183,
		191,
		191,
		194,
		198,
		193,
		204,
		196,
		200,
		217,
		-1,
		147,
		-1,
		99,
		43,
		23,
		8,
		0,
		-1,
		-1,
		-1,
		207,
		193,
		186,
		174,
		172,
		-1,
		248,
		232,
		213,
		-1,
		183,
		196,
		227,
		195,
		200,
		195,
		199,
		210,
		199,
		202,
		216,
		211,
		-1,
		-1,
		47,
		50,
		-1,
		-1,
		76,
		95,
		-1,
		198,
		187,
		172,
		164,
		-1,
		-1,
		220,
		216,
		-1,
		-1,
		183,
		209,
		198,
		206,
		201,
		203,
		209,
		212,
		201,
		205,
		217,
		-1,
		-1,
		54,
		57,
		62,
		-1,
		85,
		-1,
		200,
		-1,
		167,
		174,
		162,
		-1,
		-1,
		-1,
		214,
		177,
		193,
		216,
		221,
		219,
		210,
		207,
		214,
		212,
		208,
		219,
		-1,
		-1,
		-1,
		115,
		92,
		207,
		198,
		181,
		161,
		153,
		173,
		-1,
		195,
		-1,
		170,
		173,
		198,
		215,
		232,
		225,
		210,
		225,
		215,
		206,
		215,
		121,
		-1,
		96,
		155,
		138,
		167,
		133,
		145,
		209,
		-1,
		192,
		174,
		-1,
		202,
		192,
		240,
		215,
		223,
		210,
		211,
		212,
		212,
		-1,
		-1,
		-1,
		111,
		110,
		109,
		120,
		128,
		126,
		144,
		-1,
		197,
		179,
		165,
		182,
		182,
		173,
		181,
		230,
		226,
		228,
		227,
		205,
		-1,
		214,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		137,
		159,
		154,
		146,
		158,
		167,
		162,
		164,
		177,
		185,
		183,
		180,
		192,
		188,
		208,
		204,
		236,
		-1,
		221,
		-1,
		141,
		-1,
		-1,
		155,
		141,
		153,
		164,
		154,
		154,
		159,
		157,
		179,
		209,
		195,
		193,
		198,
		203,
		-1,
		231,
		232,
		-1,
		174,
		166,
		152,
		-1,
		145,
		-1,
		200,
		161,
		-1,
		186,
		166,
		-1,
		204,
		200,
		-1,
		-1,
		230,
		190,
		-1,
		-1,
		-1,
		175,
		155,
		195,
		179,
		-1,
		177,
		177,
		-1,
		-1,
		-1,
		215,
		199,
		-1,
		168,
		171,
		-1,
		162,
		168,
		197,
		179,
		183,
		-1,
		-1,
		-1,
		224,
		205,
		199,
		183,
		188,
		176,
		193,
		179,
		181,
		193,
		182,
		203,
		-1,
		-1,
		-1,
		196,
		188,
		188,
		-1,
		-1,
		206,
		189,
		189,
		202,
		-1,
		-1,
		-1,
		218,
		199,
		-1,
		-1,
		197,
		-1,
		-1,
		202,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		207,
		-1,
		-1,
		-1,
		198,
		205,
		213,
		-1,
		-1,
		-1,
		-1,
		228,
		229,
		253,
		228,
		-1,
		-1,
		-1,
		212,
		212,
		-1,
		-1,
		231,
		229,
		-1,
		-1,
		-1,
		240,
		224,
		-1,
		216,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		245,
		-1,
		251,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		258,
		250,
		264,
		-1,
		236,
		238,
		-1,
		286,
		-1,
		-1,
		273,
		264,
		-1,
		-1,
		241,
		248,
		270,
		273,
		303,
		-1,
		260
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		322,
		311,
		322,
		330,
		303,
		310,
		-1,
		329,
		333,
		299,
		293,
		332,
		301,
		307,
		318,
		-1,
		-1,
		-1,
		322,
		321,
		289,
		287,
		296,
		301,
		308,
		-1,
		307,
		-1,
		343,
		322,
		333,
		338,
		282,
		279,
		299,
		318,
		300,
		292,
		358,
		312,
		283,
		277,
		295,
		285,
		294,
		286,
		-1,
		283,
		273,
		295,
		274,
		285,
		277,
		-1,
		-1,
		277,
		278,
		284,
		270,
		276,
		272,
		-1,
		282,
		266,
		-1,
		-1,
		267,
		268,
		252,
		255,
		263,
		261,
		274,
		266,
		261,
		-1,
		-1,
		258,
		254,
		261,
		248,
		244,
		261,
		274,
		256,
		270,
		269,
		-1,
		262,
		280,
		287,
		255,
		253,
		237,
		235,
		253,
		255,
		261,
		261,
		-1,
		271,
		272,
		267,
		275,
		277,
		253,
		240,
		240,
		250,
		243,
		262,
		250,
		296,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		271,
		254,
		271,
		263,
		253,
		268,
		261,
		243,
		240,
		238,
		235,
		251,
		249,
		259,
		-1,
		-1,
		364,
		333,
		362,
		320,
		301,
		-1,
		267,
		247,
		253,
		257,
		251,
		244,
		258,
		254,
		-1,
		229,
		228,
		256,
		242,
		253,
		324,
		-1,
		-1,
		322,
		314,
		297,
		300,
		277,
		273,
		262,
		261,
		253,
		239,
		235,
		241,
		244,
		244,
		250,
		223,
		233,
		237,
		235,
		260,
		-1,
		-1,
		295,
		-1,
		-1,
		321,
		304,
		-1,
		287,
		294,
		283,
		289,
		275,
		296,
		272,
		263,
		255,
		249,
		237,
		239,
		236,
		249,
		237,
		220,
		245,
		249,
		230,
		251,
		246,
		-1,
		294,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		280,
		283,
		289,
		313,
		312,
		-1,
		284,
		272,
		273,
		258,
		255,
		242,
		230,
		243,
		228,
		235,
		234,
		224,
		222,
		252,
		227,
		249,
		246,
		265,
		270,
		264,
		273,
		-1,
		329,
		325,
		321,
		328,
		277,
		-1,
		-1,
		317,
		-1,
		320,
		321,
		296,
		269,
		272,
		259,
		250,
		237,
		226,
		237,
		226,
		223,
		231,
		216,
		231,
		222,
		221,
		239,
		249,
		257,
		261,
		267,
		-1,
		379,
		-1,
		321,
		305,
		307,
		279,
		300,
		-1,
		337,
		321,
		313,
		298,
		298,
		-1,
		268,
		265,
		255,
		233,
		218,
		235,
		227,
		225,
		229,
		211,
		225,
		216,
		234,
		241,
		239,
		243,
		263,
		275,
		339,
		329,
		-1,
		311,
		316,
		275,
		283,
		302,
		340,
		304,
		-1,
		299,
		-1,
		270,
		283,
		-1,
		239,
		235,
		217,
		218,
		213,
		228,
		222,
		207,
		204,
		222,
		225,
		232,
		236,
		252,
		-1,
		-1,
		324,
		328,
		317,
		268,
		287,
		311,
		348,
		297,
		286,
		285,
		-1,
		276,
		253,
		250,
		238,
		225,
		210,
		211,
		219,
		232,
		211,
		206,
		203,
		223,
		249,
		227,
		239,
		-1,
		-1,
		-1,
		349,
		-1,
		-1,
		294,
		265,
		289,
		331,
		315,
		308,
		296,
		261,
		261,
		255,
		-1,
		249,
		228,
		219,
		208,
		206,
		219,
		216,
		221,
		201,
		199,
		218,
		230,
		221,
		238,
		-1,
		-1,
		-1,
		324,
		313,
		314,
		260,
		283,
		320,
		294,
		280,
		285,
		260,
		253,
		247,
		262,
		245,
		226,
		215,
		207,
		196,
		212,
		220,
		215,
		197,
		206,
		212,
		236,
		226,
		232,
		-1,
		-1,
		331,
		321,
		305,
		307,
		304,
		274,
		281,
		313,
		285,
		298,
		-1,
		252,
		-1,
		241,
		236,
		220,
		215,
		212,
		209,
		203,
		212,
		214,
		204,
		199,
		206,
		241,
		241,
		216,
		236,
		239,
		-1,
		-1,
		-1,
		324,
		319,
		294,
		271,
		255,
		291,
		-1,
		268,
		269,
		-1,
		246,
		240,
		237,
		222,
		218,
		213,
		217,
		210,
		217,
		210,
		208,
		209,
		191,
		223,
		-1,
		224,
		218,
		226,
		216,
		204,
		-1,
		-1,
		-1,
		317,
		296,
		289,
		309,
		250,
		302,
		-1,
		-1,
		253,
		246,
		-1,
		233,
		215,
		222,
		220,
		214,
		218,
		215,
		204,
		217,
		210,
		196,
		198,
		211,
		215,
		219,
		206,
		202,
		199,
		213,
		-1,
		336,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		270,
		-1,
		262,
		254,
		244,
		238,
		232,
		228,
		226,
		242,
		226,
		229,
		227,
		218,
		226,
		199,
		192,
		199,
		188,
		206,
		214,
		206,
		200,
		199,
		209,
		-1,
		337,
		323,
		294,
		-1,
		-1,
		283,
		-1,
		247,
		261,
		277,
		-1,
		270,
		249,
		264,
		242,
		238,
		234,
		249,
		250,
		227,
		227,
		225,
		216,
		204,
		193,
		196,
		188,
		210,
		210,
		194,
		195,
		199,
		-1,
		343,
		330,
		288,
		284,
		273,
		293,
		244,
		232,
		264,
		-1,
		-1,
		306,
		-1,
		240,
		257,
		248,
		246,
		239,
		221,
		228,
		236,
		213,
		208,
		198,
		187,
		187,
		182,
		204,
		190,
		188,
		197,
		213,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		259,
		246,
		240,
		-1,
		281,
		-1,
		284,
		274,
		258,
		243,
		276,
		-1,
		220,
		216,
		223,
		-1,
		233,
		-1,
		206,
		203,
		194,
		179,
		176,
		187,
		185,
		196,
		192,
		-1,
		293,
		278,
		271,
		261,
		275,
		245,
		-1,
		279,
		-1,
		-1,
		271,
		265,
		265,
		249,
		250,
		236,
		216,
		208,
		223,
		222,
		209,
		208,
		192,
		185,
		182,
		175,
		188,
		198,
		203,
		190,
		-1,
		-1,
		-1,
		298,
		275,
		269,
		241,
		245,
		-1,
		-1,
		333,
		288,
		274,
		-1,
		245,
		236,
		224,
		214,
		204,
		209,
		210,
		200,
		198,
		190,
		192,
		186,
		177,
		176,
		192,
		184,
		206,
		-1,
		-1,
		274,
		267,
		255,
		223,
		218,
		-1,
		-1,
		-1,
		280,
		296,
		264,
		243,
		225,
		-1,
		-1,
		208,
		201,
		195,
		198,
		186,
		206,
		201,
		185,
		170,
		185,
		189,
		197,
		188,
		-1,
		277,
		264,
		-1,
		-1,
		217,
		207,
		-1,
		-1,
		-1,
		-1,
		276,
		221,
		210,
		205,
		209,
		207,
		-1,
		181,
		192,
		185,
		204,
		211,
		187,
		172,
		166,
		172,
		184,
		193,
		-1,
		-1,
		231,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		233,
		227,
		198,
		191,
		195,
		-1,
		183,
		185,
		182,
		194,
		190,
		187,
		178,
		169,
		165,
		169,
		173,
		187,
		191,
		254,
		-1,
		184,
		-1,
		-1,
		-1,
		230,
		252,
		237,
		214,
		187,
		182,
		175,
		169,
		174,
		185,
		194,
		205,
		170,
		172,
		162,
		161,
		165,
		182,
		186,
		-1,
		-1,
		182,
		178,
		213,
		225,
		225,
		264,
		-1,
		-1,
		191,
		182,
		173,
		165,
		178,
		181,
		166,
		168,
		168,
		166,
		160,
		170,
		185,
		180,
		-1,
		-1,
		-1,
		194,
		-1,
		196,
		-1,
		-1,
		215,
		262,
		209,
		191,
		187,
		185,
		174,
		168,
		156,
		161,
		171,
		165,
		162,
		156,
		160,
		183,
		172,
		211,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		201,
		165,
		160,
		194,
		199,
		190,
		224,
		221,
		-1,
		191,
		197,
		162,
		169,
		152,
		159,
		164,
		161,
		150,
		157,
		173,
		172,
		167,
		203,
		194,
		200,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		194,
		162,
		180,
		170,
		176,
		-1,
		-1,
		216,
		213,
		193,
		162,
		160,
		153,
		148,
		158,
		134,
		146,
		150,
		154,
		160,
		165,
		170,
		176,
		191,
		206,
		-1,
		246,
		283,
		276,
		244,
		252,
		283,
		-1,
		184,
		176,
		159,
		162,
		170,
		-1,
		-1,
		189,
		180,
		181,
		169,
		166,
		172,
		171,
		154,
		160,
		161,
		153,
		152,
		170,
		174,
		183,
		190,
		180,
		193,
		197,
		-1,
		239,
		259,
		238,
		241,
		265,
		279,
		-1,
		181,
		-1,
		-1,
		119,
		183,
		191,
		187,
		185,
		228,
		183,
		178,
		159,
		157,
		152,
		143,
		168,
		161,
		161,
		164,
		179,
		184,
		176,
		190,
		190,
		191,
		-1,
		228,
		239,
		232,
		-1,
		-1,
		-1,
		-1,
		182,
		-1,
		-1,
		109,
		-1,
		217,
		-1,
		208,
		212,
		191,
		194,
		173,
		160,
		146,
		154,
		160,
		159,
		165,
		165,
		166,
		175,
		186,
		198,
		197,
		198,
		253,
		209,
		212,
		223,
		234,
		249,
		253,
		-1,
		193,
		232,
		115,
		-1,
		99,
		-1,
		-1,
		-1,
		222,
		204,
		196,
		193,
		172,
		172,
		138,
		142,
		155,
		162,
		172,
		183,
		175,
		179,
		192,
		203,
		206,
		249,
		240,
		253,
		198,
		198,
		219,
		228,
		249,
		198,
		199,
		226,
		122,
		111,
		106,
		93,
		-1,
		-1,
		206,
		214,
		-1,
		-1,
		179,
		146,
		134,
		144,
		148,
		162,
		174,
		187,
		175,
		180,
		174,
		206,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		216,
		-1,
		-1,
		196,
		227,
		178,
		155,
		153,
		178,
		-1,
		77,
		-1,
		-1,
		186,
		-1,
		-1,
		171,
		151,
		140,
		131,
		136,
		156,
		167,
		189,
		171,
		188,
		179,
		189,
		193,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		193,
		193,
		189,
		176,
		156,
		167,
		-1,
		-1,
		93,
		73,
		-1,
		-1,
		169,
		167,
		156,
		-1,
		146,
		128,
		133,
		163,
		165,
		167,
		174,
		168,
		175,
		183,
		194,
		186,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		-1,
		76,
		79,
		-1,
		-1,
		164,
		157,
		145,
		133,
		123,
		133,
		150,
		150,
		153,
		158,
		166,
		177,
		173,
		177,
		180,
		-1,
		269,
		-1,
		221,
		182,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		0,
		61,
		54,
		60,
		61,
		-1,
		198,
		182,
		163,
		-1,
		133,
		146,
		186,
		154,
		159,
		154,
		169,
		180,
		171,
		179,
		173,
		176,
		-1,
		-1,
		181,
		164,
		-1,
		-1,
		138,
		140,
		-1,
		9,
		21,
		45,
		53,
		-1,
		-1,
		170,
		166,
		-1,
		-1,
		120,
		158,
		157,
		165,
		160,
		165,
		177,
		173,
		169,
		179,
		170,
		-1,
		-1,
		159,
		151,
		145,
		-1,
		123,
		-1,
		111,
		-1,
		50,
		72,
		74,
		-1,
		-1,
		-1,
		151,
		114,
		130,
		153,
		179,
		177,
		168,
		161,
		168,
		171,
		164,
		170,
		-1,
		-1,
		-1,
		141,
		115,
		118,
		109,
		92,
		72,
		68,
		89,
		-1,
		132,
		-1,
		107,
		110,
		135,
		174,
		176,
		162,
		158,
		171,
		165,
		162,
		160,
		147,
		-1,
		117,
		150,
		114,
		78,
		82,
		77,
		146,
		-1,
		129,
		111,
		-1,
		139,
		129,
		177,
		152,
		161,
		154,
		148,
		149,
		157,
		-1,
		-1,
		-1,
		119,
		118,
		110,
		104,
		102,
		87,
		82,
		-1,
		134,
		116,
		102,
		119,
		119,
		110,
		118,
		167,
		163,
		166,
		164,
		142,
		-1,
		233,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		113,
		122,
		95,
		83,
		97,
		104,
		99,
		101,
		114,
		122,
		120,
		117,
		129,
		125,
		145,
		141,
		173,
		-1,
		228,
		-1,
		149,
		-1,
		-1,
		129,
		115,
		117,
		106,
		95,
		93,
		96,
		94,
		116,
		146,
		132,
		130,
		135,
		140,
		-1,
		217,
		216,
		-1,
		148,
		140,
		126,
		-1,
		119,
		-1,
		141,
		102,
		-1,
		123,
		103,
		-1,
		141,
		137,
		-1,
		-1,
		204,
		164,
		-1,
		-1,
		-1,
		149,
		129,
		136,
		120,
		-1,
		114,
		114,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		142,
		145,
		-1,
		136,
		142,
		169,
		116,
		120,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		157,
		162,
		150,
		167,
		153,
		152,
		130,
		119,
		140,
		-1,
		-1,
		-1,
		170,
		162,
		162,
		-1,
		-1,
		177,
		160,
		141,
		139,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		167,
		-1,
		-1,
		173,
		138,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		181,
		-1,
		-1,
		-1,
		163,
		159,
		160,
		-1,
		-1,
		-1,
		-1,
		202,
		203,
		227,
		202,
		-1,
		-1,
		-1,
		155,
		149,
		-1,
		-1,
		205,
		203,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		153,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		188,
		-1,
		188,
		163,
		170,
		-1,
		-1,
		-1,
		-1,
		201,
		193,
		201,
		-1,
		173,
		175,
		-1,
		223,
		-1,
		-1,
		216,
		207,
		-1,
		-1,
		178,
		185,
		207,
		210,
		246,
		-1,
		197
	],
	[
		-1,
		312,
		301,
		312,
		320,
		293,
		300,
		-1,
		319,
		323,
		289,
		283,
		322,
		291,
		297,
		308,
		-1,
		-1,
		-1,
		312,
		311,
		279,
		277,
		286,
		291,
		298,
		-1,
		297,
		-1,
		333,
		312,
		323,
		328,
		272,
		269,
		289,
		308,
		290,
		282,
		348,
		302,
		273,
		267,
		285,
		275,
		284,
		276,
		-1,
		273,
		263,
		285,
		264,
		275,
		267,
		-1,
		-1,
		267,
		268,
		274,
		260,
		266,
		262,
		-1,
		272,
		256,
		-1,
		-1,
		257,
		258,
		242,
		245,
		253,
		251,
		264,
		256,
		251,
		-1,
		-1,
		248,
		244,
		251,
		238,
		234,
		251,
		264,
		246,
		260,
		259,
		-1,
		252,
		270,
		277,
		245,
		243,
		227,
		225,
		243,
		245,
		251,
		251,
		-1,
		261,
		262,
		257,
		265,
		267,
		243,
		230,
		230,
		240,
		233,
		252,
		240,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		261,
		244,
		261,
		253,
		243,
		258,
		251,
		233,
		230,
		228,
		225,
		241,
		239,
		249,
		-1,
		-1,
		354,
		323,
		352,
		310,
		291,
		-1,
		257,
		237,
		243,
		247,
		241,
		234,
		248,
		244,
		-1,
		219,
		218,
		246,
		232,
		243,
		314,
		-1,
		-1,
		312,
		304,
		287,
		290,
		267,
		263,
		252,
		251,
		243,
		229,
		225,
		231,
		234,
		234,
		240,
		213,
		223,
		227,
		225,
		250,
		-1,
		-1,
		285,
		-1,
		-1,
		311,
		294,
		-1,
		277,
		284,
		273,
		279,
		265,
		286,
		262,
		253,
		245,
		239,
		227,
		229,
		226,
		239,
		227,
		210,
		235,
		239,
		220,
		241,
		236,
		-1,
		284,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		270,
		273,
		279,
		303,
		302,
		-1,
		274,
		262,
		263,
		248,
		245,
		232,
		220,
		233,
		218,
		225,
		224,
		214,
		212,
		242,
		217,
		239,
		236,
		255,
		260,
		254,
		263,
		-1,
		319,
		315,
		311,
		318,
		267,
		-1,
		-1,
		307,
		-1,
		310,
		311,
		286,
		259,
		262,
		249,
		240,
		227,
		216,
		227,
		216,
		213,
		221,
		206,
		221,
		212,
		211,
		229,
		239,
		247,
		251,
		257,
		-1,
		369,
		-1,
		311,
		295,
		297,
		269,
		290,
		-1,
		327,
		311,
		303,
		288,
		288,
		-1,
		258,
		255,
		245,
		223,
		208,
		225,
		217,
		215,
		219,
		201,
		215,
		206,
		224,
		231,
		229,
		233,
		253,
		265,
		329,
		319,
		-1,
		301,
		306,
		265,
		273,
		292,
		330,
		294,
		-1,
		289,
		-1,
		260,
		273,
		-1,
		229,
		225,
		207,
		208,
		203,
		218,
		212,
		197,
		194,
		212,
		215,
		222,
		226,
		242,
		-1,
		-1,
		314,
		318,
		307,
		258,
		277,
		301,
		338,
		287,
		276,
		275,
		-1,
		266,
		243,
		240,
		228,
		215,
		200,
		201,
		209,
		222,
		201,
		196,
		193,
		213,
		239,
		217,
		229,
		-1,
		-1,
		-1,
		339,
		-1,
		-1,
		284,
		255,
		279,
		321,
		305,
		298,
		286,
		251,
		251,
		245,
		-1,
		239,
		218,
		209,
		198,
		196,
		209,
		206,
		211,
		191,
		189,
		208,
		220,
		211,
		228,
		-1,
		-1,
		-1,
		314,
		303,
		304,
		250,
		273,
		310,
		284,
		270,
		275,
		250,
		243,
		237,
		252,
		235,
		216,
		205,
		197,
		186,
		202,
		210,
		205,
		187,
		196,
		202,
		226,
		216,
		222,
		-1,
		-1,
		321,
		311,
		295,
		297,
		294,
		264,
		271,
		303,
		275,
		288,
		-1,
		242,
		-1,
		231,
		226,
		210,
		205,
		202,
		199,
		193,
		202,
		204,
		194,
		189,
		196,
		231,
		231,
		206,
		226,
		229,
		-1,
		-1,
		-1,
		314,
		309,
		284,
		261,
		245,
		281,
		-1,
		258,
		259,
		-1,
		236,
		230,
		227,
		212,
		208,
		203,
		207,
		200,
		207,
		200,
		198,
		199,
		181,
		213,
		-1,
		214,
		208,
		216,
		206,
		194,
		-1,
		-1,
		-1,
		307,
		286,
		279,
		299,
		240,
		292,
		-1,
		-1,
		243,
		236,
		-1,
		223,
		205,
		212,
		210,
		204,
		208,
		205,
		194,
		207,
		200,
		186,
		188,
		201,
		205,
		209,
		196,
		192,
		189,
		203,
		-1,
		326,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		260,
		-1,
		252,
		244,
		234,
		228,
		222,
		218,
		216,
		232,
		216,
		219,
		217,
		208,
		216,
		189,
		182,
		189,
		178,
		196,
		204,
		196,
		190,
		189,
		199,
		-1,
		327,
		313,
		284,
		-1,
		-1,
		273,
		-1,
		237,
		251,
		267,
		-1,
		260,
		239,
		254,
		232,
		228,
		224,
		239,
		240,
		217,
		217,
		215,
		206,
		194,
		183,
		186,
		178,
		200,
		200,
		184,
		185,
		189,
		-1,
		333,
		320,
		278,
		274,
		263,
		283,
		234,
		222,
		254,
		-1,
		-1,
		296,
		-1,
		230,
		247,
		238,
		236,
		229,
		211,
		218,
		226,
		203,
		198,
		188,
		177,
		177,
		172,
		194,
		180,
		178,
		187,
		203,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		249,
		236,
		230,
		-1,
		271,
		-1,
		274,
		264,
		248,
		233,
		266,
		-1,
		210,
		206,
		213,
		-1,
		223,
		-1,
		196,
		193,
		184,
		169,
		166,
		177,
		175,
		186,
		182,
		-1,
		283,
		268,
		261,
		251,
		265,
		235,
		-1,
		269,
		-1,
		-1,
		261,
		255,
		255,
		239,
		240,
		226,
		206,
		198,
		213,
		212,
		199,
		198,
		182,
		175,
		172,
		165,
		178,
		188,
		193,
		180,
		-1,
		-1,
		-1,
		288,
		265,
		259,
		231,
		235,
		-1,
		-1,
		323,
		278,
		264,
		-1,
		235,
		226,
		214,
		204,
		194,
		199,
		200,
		190,
		188,
		180,
		182,
		176,
		167,
		166,
		182,
		174,
		196,
		-1,
		-1,
		264,
		257,
		245,
		213,
		208,
		-1,
		-1,
		-1,
		270,
		286,
		254,
		233,
		215,
		-1,
		-1,
		198,
		191,
		185,
		188,
		176,
		196,
		191,
		175,
		160,
		175,
		179,
		187,
		178,
		-1,
		267,
		254,
		-1,
		-1,
		207,
		197,
		-1,
		-1,
		-1,
		-1,
		266,
		211,
		200,
		195,
		199,
		197,
		-1,
		171,
		182,
		175,
		194,
		201,
		177,
		162,
		156,
		162,
		174,
		183,
		-1,
		-1,
		221,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		223,
		217,
		188,
		181,
		185,
		-1,
		173,
		175,
		172,
		184,
		180,
		177,
		168,
		159,
		155,
		159,
		163,
		177,
		181,
		244,
		-1,
		174,
		-1,
		-1,
		-1,
		220,
		242,
		227,
		204,
		177,
		172,
		165,
		159,
		164,
		175,
		184,
		195,
		160,
		162,
		152,
		151,
		155,
		172,
		176,
		-1,
		-1,
		172,
		168,
		203,
		215,
		215,
		254,
		-1,
		-1,
		181,
		172,
		163,
		155,
		168,
		171,
		156,
		158,
		158,
		156,
		150,
		160,
		175,
		170,
		-1,
		-1,
		-1,
		184,
		-1,
		186,
		-1,
		-1,
		205,
		252,
		199,
		181,
		177,
		175,
		164,
		158,
		146,
		151,
		161,
		155,
		152,
		146,
		150,
		173,
		162,
		201,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		191,
		155,
		150,
		184,
		189,
		180,
		214,
		211,
		-1,
		181,
		187,
		152,
		159,
		142,
		149,
		154,
		151,
		140,
		147,
		163,
		162,
		157,
		193,
		184,
		190,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		184,
		152,
		170,
		160,
		166,
		-1,
		-1,
		206,
		203,
		183,
		152,
		150,
		143,
		138,
		148,
		124,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		236,
		273,
		266,
		234,
		242,
		273,
		-1,
		174,
		166,
		149,
		152,
		160,
		-1,
		-1,
		179,
		170,
		171,
		159,
		156,
		162,
		161,
		144,
		150,
		151,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		229,
		249,
		228,
		231,
		255,
		269,
		-1,
		171,
		-1,
		-1,
		109,
		173,
		181,
		177,
		175,
		218,
		173,
		168,
		149,
		147,
		142,
		133,
		158,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		218,
		229,
		222,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		99,
		-1,
		207,
		-1,
		198,
		202,
		181,
		184,
		163,
		150,
		136,
		144,
		150,
		149,
		155,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		243,
		199,
		202,
		213,
		224,
		239,
		243,
		-1,
		183,
		222,
		105,
		-1,
		89,
		-1,
		-1,
		-1,
		212,
		194,
		186,
		183,
		162,
		162,
		128,
		132,
		145,
		152,
		162,
		173,
		165,
		169,
		182,
		193,
		196,
		239,
		230,
		243,
		188,
		188,
		209,
		218,
		239,
		188,
		189,
		216,
		112,
		101,
		96,
		83,
		-1,
		-1,
		196,
		204,
		-1,
		-1,
		169,
		136,
		124,
		134,
		138,
		152,
		164,
		177,
		165,
		170,
		164,
		196,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		179,
		206,
		-1,
		-1,
		186,
		217,
		168,
		145,
		143,
		168,
		-1,
		67,
		-1,
		-1,
		176,
		-1,
		-1,
		161,
		141,
		130,
		121,
		126,
		146,
		157,
		179,
		161,
		178,
		169,
		179,
		183,
		216,
		213,
		201,
		199,
		222,
		187,
		175,
		-1,
		183,
		183,
		179,
		166,
		146,
		157,
		-1,
		-1,
		83,
		63,
		-1,
		-1,
		159,
		157,
		146,
		-1,
		136,
		118,
		123,
		153,
		155,
		157,
		164,
		158,
		165,
		173,
		184,
		176,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		12,
		-1,
		65,
		69,
		-1,
		-1,
		154,
		147,
		135,
		123,
		113,
		123,
		140,
		140,
		143,
		148,
		156,
		167,
		163,
		167,
		170,
		-1,
		259,
		-1,
		211,
		172,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		72,
		0,
		12,
		49,
		51,
		-1,
		188,
		172,
		153,
		-1,
		123,
		136,
		176,
		144,
		149,
		144,
		159,
		170,
		161,
		169,
		163,
		166,
		-1,
		-1,
		171,
		154,
		-1,
		-1,
		128,
		130,
		-1,
		63,
		52,
		28,
		43,
		-1,
		-1,
		160,
		156,
		-1,
		-1,
		110,
		148,
		147,
		155,
		150,
		155,
		167,
		163,
		159,
		169,
		160,
		-1,
		-1,
		149,
		141,
		135,
		-1,
		113,
		-1,
		101,
		-1,
		33,
		62,
		64,
		-1,
		-1,
		-1,
		141,
		104,
		120,
		143,
		169,
		167,
		158,
		151,
		158,
		161,
		154,
		160,
		-1,
		-1,
		-1,
		131,
		105,
		108,
		99,
		82,
		62,
		58,
		79,
		-1,
		122,
		-1,
		97,
		100,
		125,
		164,
		166,
		152,
		148,
		161,
		155,
		152,
		150,
		137,
		-1,
		107,
		140,
		104,
		68,
		72,
		67,
		136,
		-1,
		119,
		101,
		-1,
		129,
		119,
		167,
		142,
		151,
		144,
		138,
		139,
		147,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		92,
		77,
		72,
		-1,
		124,
		106,
		92,
		109,
		109,
		100,
		108,
		157,
		153,
		156,
		154,
		132,
		-1,
		223,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		112,
		85,
		73,
		87,
		94,
		89,
		91,
		104,
		112,
		110,
		107,
		119,
		115,
		135,
		131,
		163,
		-1,
		218,
		-1,
		139,
		-1,
		-1,
		119,
		105,
		107,
		96,
		85,
		83,
		86,
		84,
		106,
		136,
		122,
		120,
		125,
		130,
		-1,
		207,
		206,
		-1,
		138,
		130,
		116,
		-1,
		109,
		-1,
		131,
		92,
		-1,
		113,
		93,
		-1,
		131,
		127,
		-1,
		-1,
		194,
		154,
		-1,
		-1,
		-1,
		139,
		119,
		126,
		110,
		-1,
		104,
		104,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		132,
		135,
		-1,
		126,
		132,
		159,
		106,
		110,
		-1,
		-1,
		-1,
		188,
		169,
		163,
		147,
		152,
		140,
		157,
		143,
		142,
		120,
		109,
		130,
		-1,
		-1,
		-1,
		160,
		152,
		152,
		-1,
		-1,
		167,
		150,
		131,
		129,
		-1,
		-1,
		-1,
		182,
		163,
		-1,
		-1,
		157,
		-1,
		-1,
		163,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		171,
		-1,
		-1,
		-1,
		153,
		149,
		150,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		217,
		192,
		-1,
		-1,
		-1,
		145,
		139,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		143,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		178,
		-1,
		178,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		191,
		183,
		191,
		-1,
		163,
		165,
		-1,
		213,
		-1,
		-1,
		206,
		197,
		-1,
		-1,
		168,
		175,
		197,
		200,
		236,
		-1,
		187
	],
	[
		-1,
		300,
		289,
		300,
		308,
		281,
		288,
		-1,
		307,
		311,
		277,
		271,
		310,
		279,
		285,
		296,
		-1,
		-1,
		-1,
		300,
		299,
		267,
		265,
		274,
		279,
		286,
		-1,
		285,
		-1,
		321,
		300,
		311,
		316,
		260,
		257,
		277,
		296,
		278,
		270,
		336,
		290,
		261,
		255,
		273,
		263,
		272,
		264,
		-1,
		261,
		251,
		273,
		252,
		263,
		255,
		-1,
		-1,
		255,
		256,
		262,
		248,
		254,
		250,
		-1,
		260,
		244,
		-1,
		-1,
		245,
		246,
		230,
		233,
		241,
		239,
		252,
		244,
		239,
		-1,
		-1,
		236,
		232,
		239,
		226,
		222,
		239,
		252,
		234,
		248,
		247,
		-1,
		240,
		258,
		265,
		233,
		231,
		215,
		213,
		231,
		233,
		239,
		239,
		-1,
		249,
		250,
		245,
		253,
		255,
		231,
		218,
		218,
		228,
		221,
		240,
		228,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		249,
		232,
		249,
		241,
		231,
		246,
		239,
		221,
		218,
		216,
		213,
		229,
		227,
		237,
		-1,
		-1,
		342,
		311,
		340,
		298,
		279,
		-1,
		245,
		225,
		231,
		235,
		229,
		222,
		236,
		232,
		-1,
		207,
		206,
		234,
		220,
		231,
		302,
		-1,
		-1,
		300,
		292,
		275,
		278,
		255,
		251,
		240,
		239,
		231,
		217,
		213,
		219,
		222,
		222,
		228,
		201,
		211,
		215,
		213,
		238,
		-1,
		-1,
		273,
		-1,
		-1,
		299,
		282,
		-1,
		265,
		272,
		261,
		267,
		253,
		274,
		250,
		241,
		233,
		227,
		215,
		217,
		214,
		227,
		215,
		198,
		223,
		227,
		208,
		229,
		224,
		-1,
		272,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		258,
		261,
		267,
		291,
		290,
		-1,
		262,
		250,
		251,
		236,
		233,
		220,
		208,
		221,
		206,
		213,
		212,
		202,
		200,
		230,
		205,
		227,
		224,
		243,
		248,
		242,
		251,
		-1,
		307,
		303,
		299,
		306,
		255,
		-1,
		-1,
		295,
		-1,
		298,
		299,
		274,
		247,
		250,
		237,
		228,
		215,
		204,
		215,
		204,
		201,
		209,
		194,
		209,
		200,
		199,
		217,
		227,
		235,
		239,
		245,
		-1,
		357,
		-1,
		299,
		283,
		285,
		257,
		278,
		-1,
		315,
		299,
		291,
		276,
		276,
		-1,
		246,
		243,
		233,
		211,
		196,
		213,
		205,
		203,
		207,
		189,
		203,
		194,
		212,
		219,
		217,
		221,
		241,
		253,
		317,
		307,
		-1,
		289,
		294,
		253,
		261,
		280,
		318,
		282,
		-1,
		277,
		-1,
		248,
		261,
		-1,
		217,
		213,
		195,
		196,
		191,
		206,
		200,
		185,
		182,
		200,
		203,
		210,
		214,
		230,
		-1,
		-1,
		302,
		306,
		295,
		246,
		265,
		289,
		326,
		275,
		264,
		263,
		-1,
		254,
		231,
		228,
		216,
		203,
		188,
		189,
		197,
		210,
		189,
		184,
		181,
		201,
		227,
		205,
		217,
		-1,
		-1,
		-1,
		327,
		-1,
		-1,
		272,
		243,
		267,
		309,
		293,
		286,
		274,
		239,
		239,
		233,
		-1,
		227,
		206,
		197,
		186,
		184,
		197,
		194,
		199,
		179,
		177,
		196,
		208,
		199,
		216,
		-1,
		-1,
		-1,
		302,
		291,
		292,
		238,
		261,
		298,
		272,
		258,
		263,
		238,
		231,
		225,
		240,
		223,
		204,
		193,
		185,
		174,
		190,
		198,
		193,
		175,
		184,
		190,
		214,
		204,
		210,
		-1,
		-1,
		309,
		299,
		283,
		285,
		282,
		252,
		259,
		291,
		263,
		276,
		-1,
		230,
		-1,
		219,
		214,
		198,
		193,
		190,
		187,
		181,
		190,
		192,
		182,
		177,
		184,
		219,
		219,
		194,
		214,
		217,
		-1,
		-1,
		-1,
		302,
		297,
		272,
		249,
		233,
		269,
		-1,
		246,
		247,
		-1,
		224,
		218,
		215,
		200,
		196,
		191,
		195,
		188,
		195,
		188,
		186,
		187,
		169,
		201,
		-1,
		202,
		196,
		204,
		194,
		182,
		-1,
		-1,
		-1,
		295,
		274,
		267,
		287,
		228,
		280,
		-1,
		-1,
		231,
		224,
		-1,
		211,
		193,
		200,
		198,
		192,
		196,
		193,
		182,
		195,
		188,
		174,
		176,
		189,
		193,
		197,
		184,
		180,
		177,
		191,
		-1,
		314,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		248,
		-1,
		240,
		232,
		222,
		216,
		210,
		206,
		204,
		220,
		204,
		207,
		205,
		196,
		204,
		177,
		170,
		177,
		166,
		184,
		192,
		184,
		178,
		177,
		187,
		-1,
		315,
		301,
		272,
		-1,
		-1,
		261,
		-1,
		225,
		239,
		255,
		-1,
		248,
		227,
		242,
		220,
		216,
		212,
		227,
		228,
		205,
		205,
		203,
		194,
		182,
		171,
		174,
		166,
		188,
		188,
		172,
		173,
		177,
		-1,
		321,
		308,
		266,
		262,
		251,
		271,
		222,
		210,
		242,
		-1,
		-1,
		284,
		-1,
		218,
		235,
		226,
		224,
		217,
		199,
		206,
		214,
		191,
		186,
		176,
		165,
		165,
		160,
		182,
		168,
		166,
		175,
		191,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		237,
		224,
		218,
		-1,
		259,
		-1,
		262,
		252,
		236,
		221,
		254,
		-1,
		198,
		194,
		201,
		-1,
		211,
		-1,
		184,
		181,
		172,
		157,
		154,
		165,
		163,
		174,
		170,
		-1,
		271,
		256,
		249,
		239,
		253,
		223,
		-1,
		257,
		-1,
		-1,
		249,
		243,
		243,
		227,
		228,
		214,
		194,
		186,
		201,
		200,
		187,
		186,
		170,
		163,
		160,
		153,
		166,
		176,
		181,
		168,
		-1,
		-1,
		-1,
		276,
		253,
		247,
		219,
		223,
		-1,
		-1,
		311,
		266,
		252,
		-1,
		223,
		214,
		202,
		192,
		182,
		187,
		188,
		178,
		176,
		168,
		170,
		164,
		155,
		154,
		170,
		162,
		184,
		-1,
		-1,
		252,
		245,
		233,
		201,
		196,
		-1,
		-1,
		-1,
		258,
		274,
		242,
		221,
		203,
		-1,
		-1,
		186,
		179,
		173,
		176,
		164,
		184,
		179,
		163,
		148,
		163,
		167,
		175,
		166,
		-1,
		255,
		242,
		-1,
		-1,
		195,
		185,
		-1,
		-1,
		-1,
		-1,
		254,
		199,
		188,
		183,
		187,
		185,
		-1,
		159,
		170,
		163,
		182,
		189,
		165,
		150,
		144,
		150,
		162,
		171,
		-1,
		-1,
		209,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		211,
		205,
		176,
		169,
		173,
		-1,
		161,
		163,
		160,
		172,
		168,
		165,
		156,
		147,
		143,
		147,
		151,
		165,
		169,
		232,
		-1,
		162,
		-1,
		-1,
		-1,
		208,
		230,
		215,
		192,
		165,
		160,
		153,
		147,
		152,
		163,
		172,
		183,
		148,
		150,
		140,
		139,
		143,
		160,
		164,
		-1,
		-1,
		160,
		156,
		191,
		203,
		203,
		242,
		-1,
		-1,
		169,
		160,
		151,
		143,
		156,
		159,
		144,
		146,
		146,
		144,
		138,
		148,
		163,
		158,
		-1,
		-1,
		-1,
		172,
		-1,
		174,
		-1,
		-1,
		193,
		240,
		187,
		169,
		165,
		163,
		152,
		146,
		134,
		139,
		149,
		143,
		140,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		179,
		143,
		138,
		172,
		177,
		168,
		202,
		199,
		-1,
		169,
		175,
		140,
		147,
		130,
		137,
		142,
		139,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		172,
		140,
		158,
		148,
		154,
		-1,
		-1,
		194,
		191,
		171,
		140,
		138,
		131,
		126,
		136,
		112,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		224,
		261,
		254,
		222,
		230,
		261,
		-1,
		162,
		154,
		137,
		140,
		148,
		-1,
		-1,
		167,
		158,
		159,
		147,
		144,
		150,
		149,
		132,
		138,
		139,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		217,
		237,
		216,
		219,
		243,
		257,
		-1,
		159,
		-1,
		-1,
		97,
		161,
		169,
		165,
		163,
		206,
		161,
		156,
		137,
		135,
		130,
		121,
		146,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		87,
		-1,
		195,
		-1,
		186,
		190,
		169,
		172,
		151,
		138,
		124,
		132,
		138,
		137,
		143,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		171,
		210,
		93,
		-1,
		77,
		-1,
		-1,
		-1,
		200,
		182,
		174,
		171,
		150,
		150,
		116,
		120,
		133,
		140,
		150,
		161,
		153,
		157,
		170,
		181,
		184,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		176,
		177,
		204,
		100,
		89,
		84,
		71,
		-1,
		-1,
		184,
		192,
		-1,
		-1,
		157,
		124,
		112,
		122,
		126,
		140,
		152,
		165,
		153,
		158,
		152,
		184,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		174,
		205,
		156,
		133,
		131,
		156,
		-1,
		55,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		129,
		118,
		109,
		114,
		134,
		145,
		167,
		149,
		166,
		157,
		167,
		171,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		171,
		171,
		167,
		154,
		134,
		145,
		-1,
		-1,
		71,
		51,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		106,
		111,
		141,
		143,
		145,
		152,
		146,
		153,
		161,
		172,
		164,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		19,
		-1,
		53,
		57,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		128,
		128,
		131,
		136,
		144,
		155,
		151,
		155,
		158,
		-1,
		247,
		-1,
		199,
		160,
		166,
		181,
		189,
		-1,
		-1,
		-1,
		60,
		7,
		0,
		37,
		39,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		164,
		132,
		137,
		132,
		147,
		158,
		149,
		157,
		151,
		154,
		-1,
		-1,
		159,
		142,
		-1,
		-1,
		116,
		118,
		-1,
		51,
		40,
		16,
		31,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		98,
		136,
		135,
		143,
		138,
		143,
		155,
		151,
		147,
		157,
		148,
		-1,
		-1,
		137,
		129,
		123,
		-1,
		101,
		-1,
		89,
		-1,
		21,
		50,
		52,
		-1,
		-1,
		-1,
		129,
		92,
		108,
		131,
		157,
		155,
		146,
		139,
		146,
		149,
		142,
		148,
		-1,
		-1,
		-1,
		119,
		93,
		96,
		87,
		70,
		50,
		46,
		67,
		-1,
		110,
		-1,
		85,
		88,
		113,
		152,
		154,
		140,
		136,
		149,
		143,
		140,
		138,
		125,
		-1,
		95,
		128,
		92,
		56,
		60,
		55,
		124,
		-1,
		107,
		89,
		-1,
		117,
		107,
		155,
		130,
		139,
		132,
		126,
		127,
		135,
		-1,
		-1,
		-1,
		97,
		96,
		88,
		82,
		80,
		65,
		60,
		-1,
		112,
		94,
		80,
		97,
		97,
		88,
		96,
		145,
		141,
		144,
		142,
		120,
		-1,
		211,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		91,
		100,
		73,
		61,
		75,
		82,
		77,
		79,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		206,
		-1,
		127,
		-1,
		-1,
		107,
		93,
		95,
		84,
		73,
		71,
		74,
		72,
		94,
		124,
		110,
		108,
		113,
		118,
		-1,
		195,
		194,
		-1,
		126,
		118,
		104,
		-1,
		97,
		-1,
		119,
		80,
		-1,
		101,
		81,
		-1,
		119,
		115,
		-1,
		-1,
		182,
		142,
		-1,
		-1,
		-1,
		127,
		107,
		114,
		98,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		120,
		123,
		-1,
		114,
		120,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		176,
		157,
		151,
		135,
		140,
		128,
		145,
		131,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		148,
		140,
		140,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		170,
		151,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		159,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		180,
		181,
		205,
		180,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		183,
		181,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		289,
		278,
		289,
		297,
		270,
		277,
		-1,
		296,
		300,
		266,
		260,
		299,
		268,
		274,
		285,
		-1,
		-1,
		-1,
		289,
		288,
		256,
		254,
		263,
		268,
		275,
		-1,
		274,
		-1,
		310,
		289,
		300,
		305,
		249,
		246,
		266,
		285,
		267,
		259,
		325,
		279,
		250,
		244,
		262,
		252,
		261,
		253,
		-1,
		250,
		240,
		262,
		241,
		252,
		244,
		-1,
		-1,
		244,
		245,
		251,
		237,
		243,
		239,
		-1,
		249,
		233,
		-1,
		-1,
		234,
		235,
		219,
		222,
		230,
		228,
		241,
		233,
		228,
		-1,
		-1,
		225,
		221,
		228,
		215,
		211,
		228,
		241,
		223,
		237,
		236,
		-1,
		229,
		247,
		254,
		222,
		220,
		204,
		202,
		220,
		222,
		228,
		228,
		-1,
		238,
		239,
		234,
		242,
		244,
		220,
		207,
		207,
		217,
		210,
		229,
		217,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		238,
		221,
		238,
		230,
		220,
		235,
		228,
		210,
		207,
		205,
		202,
		218,
		216,
		226,
		-1,
		-1,
		331,
		300,
		329,
		287,
		268,
		-1,
		234,
		214,
		220,
		224,
		218,
		211,
		225,
		221,
		-1,
		196,
		195,
		223,
		209,
		220,
		291,
		-1,
		-1,
		289,
		281,
		264,
		267,
		244,
		240,
		229,
		228,
		220,
		206,
		202,
		208,
		211,
		211,
		217,
		190,
		200,
		204,
		202,
		227,
		-1,
		-1,
		262,
		-1,
		-1,
		288,
		271,
		-1,
		254,
		261,
		250,
		256,
		242,
		263,
		239,
		230,
		222,
		216,
		204,
		206,
		203,
		216,
		204,
		187,
		212,
		216,
		197,
		218,
		213,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		247,
		250,
		256,
		280,
		279,
		-1,
		251,
		239,
		240,
		225,
		222,
		209,
		197,
		210,
		195,
		202,
		201,
		191,
		189,
		219,
		194,
		216,
		213,
		232,
		237,
		231,
		240,
		-1,
		296,
		292,
		288,
		295,
		244,
		-1,
		-1,
		284,
		-1,
		287,
		288,
		263,
		236,
		239,
		226,
		217,
		204,
		193,
		204,
		193,
		190,
		198,
		183,
		198,
		189,
		188,
		206,
		216,
		224,
		228,
		234,
		-1,
		346,
		-1,
		288,
		272,
		274,
		246,
		267,
		-1,
		304,
		288,
		280,
		265,
		265,
		-1,
		235,
		232,
		222,
		200,
		185,
		202,
		194,
		192,
		196,
		178,
		192,
		183,
		201,
		208,
		206,
		210,
		230,
		242,
		306,
		296,
		-1,
		278,
		283,
		242,
		250,
		269,
		307,
		271,
		-1,
		266,
		-1,
		237,
		250,
		-1,
		206,
		202,
		184,
		185,
		180,
		195,
		189,
		174,
		171,
		189,
		192,
		199,
		203,
		219,
		-1,
		-1,
		291,
		295,
		284,
		235,
		254,
		278,
		315,
		264,
		253,
		252,
		-1,
		243,
		220,
		217,
		205,
		192,
		177,
		178,
		186,
		199,
		178,
		173,
		170,
		190,
		216,
		194,
		206,
		-1,
		-1,
		-1,
		316,
		-1,
		-1,
		261,
		232,
		256,
		298,
		282,
		275,
		263,
		228,
		228,
		222,
		-1,
		216,
		195,
		186,
		175,
		173,
		186,
		183,
		188,
		168,
		166,
		185,
		197,
		188,
		205,
		-1,
		-1,
		-1,
		291,
		280,
		281,
		227,
		250,
		287,
		261,
		247,
		252,
		227,
		220,
		214,
		229,
		212,
		193,
		182,
		174,
		163,
		179,
		187,
		182,
		164,
		173,
		179,
		203,
		193,
		199,
		-1,
		-1,
		298,
		288,
		272,
		274,
		271,
		241,
		248,
		280,
		252,
		265,
		-1,
		219,
		-1,
		208,
		203,
		187,
		182,
		179,
		176,
		170,
		179,
		181,
		171,
		166,
		173,
		208,
		208,
		183,
		203,
		206,
		-1,
		-1,
		-1,
		291,
		286,
		261,
		238,
		222,
		258,
		-1,
		235,
		236,
		-1,
		213,
		207,
		204,
		189,
		185,
		180,
		184,
		177,
		184,
		177,
		175,
		176,
		158,
		190,
		-1,
		191,
		185,
		193,
		183,
		171,
		-1,
		-1,
		-1,
		284,
		263,
		256,
		276,
		217,
		269,
		-1,
		-1,
		220,
		213,
		-1,
		200,
		182,
		189,
		187,
		181,
		185,
		182,
		171,
		184,
		177,
		163,
		165,
		178,
		182,
		186,
		173,
		169,
		166,
		180,
		-1,
		303,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		237,
		-1,
		229,
		221,
		211,
		205,
		199,
		195,
		193,
		209,
		193,
		196,
		194,
		185,
		193,
		166,
		159,
		166,
		155,
		173,
		181,
		173,
		167,
		166,
		176,
		-1,
		304,
		290,
		261,
		-1,
		-1,
		250,
		-1,
		214,
		228,
		244,
		-1,
		237,
		216,
		231,
		209,
		205,
		201,
		216,
		217,
		194,
		194,
		192,
		183,
		171,
		160,
		163,
		155,
		177,
		177,
		161,
		162,
		166,
		-1,
		310,
		297,
		255,
		251,
		240,
		260,
		211,
		199,
		231,
		-1,
		-1,
		273,
		-1,
		207,
		224,
		215,
		213,
		206,
		188,
		195,
		203,
		180,
		175,
		165,
		154,
		154,
		149,
		171,
		157,
		155,
		164,
		180,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		226,
		213,
		207,
		-1,
		248,
		-1,
		251,
		241,
		225,
		210,
		243,
		-1,
		187,
		183,
		190,
		-1,
		200,
		-1,
		173,
		170,
		161,
		146,
		143,
		154,
		152,
		163,
		159,
		-1,
		260,
		245,
		238,
		228,
		242,
		212,
		-1,
		246,
		-1,
		-1,
		238,
		232,
		232,
		216,
		217,
		203,
		183,
		175,
		190,
		189,
		176,
		175,
		159,
		152,
		149,
		142,
		155,
		165,
		170,
		157,
		-1,
		-1,
		-1,
		265,
		242,
		236,
		208,
		212,
		-1,
		-1,
		300,
		255,
		241,
		-1,
		212,
		203,
		191,
		181,
		171,
		176,
		177,
		167,
		165,
		157,
		159,
		153,
		144,
		143,
		159,
		151,
		173,
		-1,
		-1,
		241,
		234,
		222,
		190,
		185,
		-1,
		-1,
		-1,
		247,
		263,
		231,
		210,
		192,
		-1,
		-1,
		175,
		168,
		162,
		165,
		153,
		173,
		168,
		152,
		137,
		152,
		156,
		164,
		155,
		-1,
		244,
		231,
		-1,
		-1,
		184,
		174,
		-1,
		-1,
		-1,
		-1,
		243,
		188,
		177,
		172,
		176,
		174,
		-1,
		148,
		159,
		152,
		171,
		178,
		154,
		139,
		133,
		139,
		151,
		160,
		-1,
		-1,
		198,
		-1,
		160,
		-1,
		-1,
		-1,
		-1,
		200,
		194,
		165,
		158,
		162,
		-1,
		150,
		152,
		149,
		161,
		157,
		154,
		145,
		136,
		132,
		136,
		140,
		154,
		158,
		221,
		-1,
		151,
		-1,
		-1,
		-1,
		197,
		219,
		204,
		181,
		154,
		149,
		142,
		136,
		141,
		152,
		161,
		172,
		137,
		139,
		129,
		128,
		132,
		149,
		153,
		-1,
		-1,
		149,
		145,
		180,
		192,
		192,
		231,
		-1,
		-1,
		158,
		149,
		140,
		132,
		145,
		148,
		133,
		135,
		135,
		133,
		127,
		137,
		152,
		147,
		-1,
		-1,
		-1,
		161,
		-1,
		163,
		-1,
		-1,
		182,
		229,
		176,
		158,
		154,
		152,
		141,
		135,
		123,
		128,
		138,
		132,
		129,
		123,
		127,
		150,
		139,
		178,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		168,
		132,
		127,
		161,
		166,
		157,
		191,
		188,
		-1,
		158,
		164,
		129,
		136,
		119,
		126,
		131,
		128,
		117,
		124,
		140,
		139,
		134,
		170,
		161,
		167,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		161,
		129,
		147,
		137,
		143,
		-1,
		-1,
		183,
		180,
		160,
		129,
		127,
		120,
		115,
		125,
		101,
		113,
		117,
		121,
		127,
		132,
		137,
		143,
		158,
		173,
		-1,
		213,
		250,
		243,
		211,
		219,
		250,
		-1,
		151,
		143,
		126,
		129,
		137,
		-1,
		-1,
		156,
		147,
		148,
		136,
		133,
		139,
		138,
		121,
		127,
		128,
		120,
		119,
		137,
		141,
		150,
		157,
		147,
		160,
		164,
		-1,
		206,
		226,
		205,
		208,
		232,
		246,
		-1,
		148,
		-1,
		-1,
		86,
		150,
		158,
		154,
		152,
		195,
		150,
		145,
		126,
		124,
		119,
		110,
		135,
		128,
		128,
		131,
		146,
		151,
		143,
		157,
		157,
		158,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		76,
		-1,
		184,
		-1,
		175,
		179,
		158,
		161,
		140,
		127,
		113,
		121,
		127,
		126,
		132,
		132,
		133,
		142,
		153,
		165,
		164,
		165,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		160,
		199,
		82,
		-1,
		66,
		-1,
		-1,
		-1,
		189,
		171,
		163,
		160,
		139,
		139,
		105,
		109,
		122,
		129,
		139,
		150,
		142,
		146,
		159,
		170,
		173,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		165,
		166,
		193,
		89,
		78,
		73,
		60,
		-1,
		-1,
		173,
		181,
		-1,
		-1,
		146,
		113,
		101,
		111,
		115,
		129,
		141,
		154,
		142,
		147,
		141,
		173,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		163,
		194,
		145,
		122,
		120,
		145,
		-1,
		44,
		-1,
		-1,
		153,
		-1,
		-1,
		138,
		118,
		107,
		98,
		103,
		123,
		134,
		156,
		138,
		155,
		146,
		156,
		160,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		160,
		160,
		156,
		143,
		123,
		134,
		-1,
		-1,
		60,
		40,
		-1,
		-1,
		136,
		134,
		123,
		-1,
		113,
		95,
		100,
		130,
		132,
		134,
		141,
		135,
		142,
		150,
		161,
		153,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		57,
		-1,
		16,
		46,
		-1,
		-1,
		131,
		124,
		112,
		100,
		90,
		100,
		117,
		117,
		120,
		125,
		133,
		144,
		140,
		144,
		147,
		-1,
		236,
		-1,
		188,
		149,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		60,
		45,
		38,
		0,
		28,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		153,
		121,
		126,
		121,
		136,
		147,
		138,
		146,
		140,
		143,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		51,
		40,
		24,
		20,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		87,
		125,
		124,
		132,
		127,
		132,
		144,
		140,
		136,
		146,
		137,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		78,
		-1,
		19,
		39,
		41,
		-1,
		-1,
		-1,
		118,
		81,
		97,
		120,
		146,
		144,
		135,
		128,
		135,
		138,
		131,
		137,
		-1,
		-1,
		-1,
		108,
		82,
		85,
		76,
		59,
		39,
		35,
		56,
		-1,
		99,
		-1,
		74,
		77,
		102,
		141,
		143,
		129,
		125,
		138,
		132,
		129,
		127,
		114,
		-1,
		84,
		117,
		81,
		45,
		49,
		44,
		113,
		-1,
		96,
		78,
		-1,
		106,
		96,
		144,
		119,
		128,
		121,
		115,
		116,
		124,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		69,
		54,
		49,
		-1,
		101,
		83,
		69,
		86,
		86,
		77,
		85,
		134,
		130,
		133,
		131,
		109,
		-1,
		200,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		89,
		62,
		50,
		64,
		71,
		66,
		68,
		81,
		89,
		87,
		84,
		96,
		92,
		112,
		108,
		140,
		-1,
		195,
		-1,
		116,
		-1,
		-1,
		96,
		82,
		84,
		73,
		62,
		60,
		63,
		61,
		83,
		113,
		99,
		97,
		102,
		107,
		-1,
		184,
		183,
		-1,
		115,
		107,
		93,
		-1,
		86,
		-1,
		108,
		69,
		-1,
		90,
		70,
		-1,
		108,
		104,
		-1,
		-1,
		171,
		131,
		-1,
		-1,
		-1,
		116,
		96,
		103,
		87,
		-1,
		81,
		81,
		-1,
		-1,
		-1,
		156,
		140,
		-1,
		109,
		112,
		-1,
		103,
		109,
		136,
		83,
		87,
		-1,
		-1,
		-1,
		165,
		146,
		140,
		124,
		129,
		117,
		134,
		120,
		119,
		97,
		86,
		107,
		-1,
		-1,
		-1,
		137,
		129,
		129,
		-1,
		-1,
		144,
		127,
		108,
		106,
		-1,
		-1,
		-1,
		159,
		140,
		-1,
		-1,
		134,
		-1,
		-1,
		140,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		148,
		-1,
		-1,
		-1,
		130,
		126,
		127,
		-1,
		-1,
		-1,
		-1,
		169,
		170,
		194,
		169,
		-1,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		172,
		170,
		-1,
		-1,
		-1,
		150,
		134,
		-1,
		120,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		155,
		-1,
		155,
		130,
		137,
		-1,
		-1,
		-1,
		-1,
		168,
		160,
		168,
		-1,
		140,
		142,
		-1,
		190,
		-1,
		-1,
		183,
		174,
		-1,
		-1,
		145,
		152,
		174,
		177,
		213,
		-1,
		164
	],
	[
		-1,
		286,
		275,
		286,
		294,
		267,
		274,
		-1,
		293,
		297,
		263,
		257,
		296,
		265,
		271,
		282,
		-1,
		-1,
		-1,
		286,
		285,
		253,
		251,
		260,
		265,
		272,
		-1,
		271,
		-1,
		307,
		286,
		297,
		302,
		246,
		243,
		263,
		282,
		264,
		256,
		322,
		276,
		247,
		241,
		259,
		249,
		258,
		250,
		-1,
		247,
		237,
		259,
		238,
		249,
		241,
		-1,
		-1,
		241,
		242,
		248,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		231,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		226,
		244,
		251,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		235,
		236,
		231,
		239,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		235,
		218,
		235,
		227,
		217,
		232,
		225,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		328,
		297,
		326,
		284,
		265,
		-1,
		231,
		211,
		217,
		221,
		215,
		208,
		222,
		218,
		-1,
		193,
		192,
		220,
		206,
		217,
		288,
		-1,
		-1,
		286,
		278,
		261,
		264,
		241,
		237,
		226,
		225,
		217,
		203,
		199,
		205,
		208,
		208,
		214,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		285,
		268,
		-1,
		251,
		258,
		247,
		253,
		239,
		260,
		236,
		227,
		219,
		213,
		201,
		203,
		200,
		213,
		201,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		244,
		247,
		253,
		277,
		276,
		-1,
		248,
		236,
		237,
		222,
		219,
		206,
		194,
		207,
		192,
		199,
		198,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		293,
		289,
		285,
		292,
		241,
		-1,
		-1,
		281,
		-1,
		284,
		285,
		260,
		233,
		236,
		223,
		214,
		201,
		190,
		201,
		190,
		187,
		195,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		343,
		-1,
		285,
		269,
		271,
		243,
		264,
		-1,
		301,
		285,
		277,
		262,
		262,
		-1,
		232,
		229,
		219,
		197,
		182,
		199,
		191,
		189,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		303,
		293,
		-1,
		275,
		280,
		239,
		247,
		266,
		304,
		268,
		-1,
		263,
		-1,
		234,
		247,
		-1,
		203,
		199,
		181,
		182,
		177,
		192,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		288,
		292,
		281,
		232,
		251,
		275,
		312,
		261,
		250,
		249,
		-1,
		240,
		217,
		214,
		202,
		189,
		174,
		175,
		183,
		196,
		175,
		170,
		167,
		187,
		213,
		191,
		203,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		258,
		229,
		253,
		295,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		213,
		192,
		183,
		172,
		170,
		183,
		180,
		185,
		165,
		163,
		182,
		194,
		185,
		202,
		-1,
		-1,
		-1,
		288,
		277,
		278,
		224,
		247,
		284,
		258,
		244,
		249,
		224,
		217,
		211,
		226,
		209,
		190,
		179,
		171,
		160,
		176,
		184,
		179,
		161,
		170,
		176,
		200,
		190,
		196,
		-1,
		-1,
		295,
		285,
		269,
		271,
		268,
		238,
		245,
		277,
		249,
		262,
		-1,
		216,
		-1,
		205,
		200,
		184,
		179,
		176,
		173,
		167,
		176,
		178,
		168,
		163,
		170,
		205,
		205,
		180,
		200,
		203,
		-1,
		-1,
		-1,
		288,
		283,
		258,
		235,
		219,
		255,
		-1,
		232,
		233,
		-1,
		210,
		204,
		201,
		186,
		182,
		177,
		181,
		174,
		181,
		174,
		172,
		173,
		155,
		187,
		-1,
		188,
		182,
		190,
		180,
		168,
		-1,
		-1,
		-1,
		281,
		260,
		253,
		273,
		214,
		266,
		-1,
		-1,
		217,
		210,
		-1,
		197,
		179,
		186,
		184,
		178,
		182,
		179,
		168,
		181,
		174,
		160,
		162,
		175,
		179,
		183,
		170,
		166,
		163,
		177,
		-1,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		234,
		-1,
		226,
		218,
		208,
		202,
		196,
		192,
		190,
		206,
		190,
		193,
		191,
		182,
		190,
		163,
		156,
		163,
		152,
		170,
		178,
		170,
		164,
		163,
		173,
		-1,
		301,
		287,
		258,
		-1,
		-1,
		247,
		-1,
		211,
		225,
		241,
		-1,
		234,
		213,
		228,
		206,
		202,
		198,
		213,
		214,
		191,
		191,
		189,
		180,
		168,
		157,
		160,
		152,
		174,
		174,
		158,
		159,
		163,
		-1,
		307,
		294,
		252,
		248,
		237,
		257,
		208,
		196,
		228,
		-1,
		-1,
		270,
		-1,
		204,
		221,
		212,
		210,
		203,
		185,
		192,
		200,
		177,
		172,
		162,
		151,
		151,
		146,
		168,
		154,
		152,
		161,
		177,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		223,
		210,
		204,
		-1,
		245,
		-1,
		248,
		238,
		222,
		207,
		240,
		-1,
		184,
		180,
		187,
		-1,
		197,
		-1,
		170,
		167,
		158,
		143,
		140,
		151,
		149,
		160,
		156,
		-1,
		257,
		242,
		235,
		225,
		239,
		209,
		-1,
		243,
		-1,
		-1,
		235,
		229,
		229,
		213,
		214,
		200,
		180,
		172,
		187,
		186,
		173,
		172,
		156,
		149,
		146,
		139,
		152,
		162,
		167,
		154,
		-1,
		-1,
		-1,
		262,
		239,
		233,
		205,
		209,
		-1,
		-1,
		297,
		252,
		238,
		-1,
		209,
		200,
		188,
		178,
		168,
		173,
		174,
		164,
		162,
		154,
		156,
		150,
		141,
		140,
		156,
		148,
		170,
		-1,
		-1,
		238,
		231,
		219,
		187,
		182,
		-1,
		-1,
		-1,
		244,
		260,
		228,
		207,
		189,
		-1,
		-1,
		172,
		165,
		159,
		162,
		150,
		170,
		165,
		149,
		134,
		149,
		153,
		161,
		152,
		-1,
		241,
		228,
		-1,
		-1,
		181,
		171,
		-1,
		-1,
		-1,
		-1,
		240,
		185,
		174,
		169,
		173,
		171,
		-1,
		145,
		156,
		149,
		168,
		175,
		151,
		136,
		130,
		136,
		148,
		157,
		-1,
		-1,
		195,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		197,
		191,
		162,
		155,
		159,
		-1,
		147,
		149,
		146,
		158,
		154,
		151,
		142,
		133,
		129,
		133,
		137,
		151,
		155,
		218,
		-1,
		148,
		-1,
		-1,
		-1,
		194,
		216,
		201,
		178,
		151,
		146,
		139,
		133,
		138,
		149,
		158,
		169,
		134,
		136,
		126,
		125,
		129,
		146,
		150,
		-1,
		-1,
		146,
		142,
		177,
		189,
		189,
		228,
		-1,
		-1,
		155,
		146,
		137,
		129,
		142,
		145,
		130,
		132,
		132,
		130,
		124,
		134,
		149,
		144,
		-1,
		-1,
		-1,
		158,
		-1,
		160,
		-1,
		-1,
		179,
		226,
		173,
		155,
		151,
		149,
		138,
		132,
		120,
		125,
		135,
		129,
		126,
		120,
		124,
		147,
		136,
		175,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		165,
		129,
		124,
		158,
		163,
		154,
		188,
		185,
		-1,
		155,
		161,
		126,
		133,
		116,
		123,
		128,
		125,
		114,
		121,
		137,
		136,
		131,
		167,
		158,
		164,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		158,
		126,
		144,
		134,
		140,
		-1,
		-1,
		180,
		177,
		157,
		126,
		124,
		117,
		112,
		122,
		98,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		148,
		140,
		123,
		126,
		134,
		-1,
		-1,
		153,
		144,
		145,
		133,
		130,
		136,
		135,
		118,
		124,
		125,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		145,
		-1,
		-1,
		83,
		147,
		155,
		151,
		149,
		192,
		147,
		142,
		123,
		121,
		116,
		107,
		132,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		73,
		-1,
		181,
		-1,
		172,
		176,
		155,
		158,
		137,
		124,
		110,
		118,
		124,
		123,
		129,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		157,
		196,
		79,
		-1,
		63,
		-1,
		-1,
		-1,
		186,
		168,
		160,
		157,
		136,
		136,
		102,
		106,
		119,
		126,
		136,
		147,
		139,
		143,
		156,
		167,
		170,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		162,
		163,
		190,
		86,
		75,
		70,
		57,
		-1,
		-1,
		170,
		178,
		-1,
		-1,
		143,
		110,
		98,
		108,
		112,
		126,
		138,
		151,
		139,
		144,
		138,
		170,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		160,
		191,
		142,
		119,
		117,
		142,
		-1,
		41,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		115,
		104,
		95,
		100,
		120,
		131,
		153,
		135,
		152,
		143,
		153,
		157,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		157,
		157,
		153,
		140,
		120,
		131,
		-1,
		-1,
		57,
		37,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		92,
		97,
		127,
		129,
		131,
		138,
		132,
		139,
		147,
		158,
		150,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		-1,
		43,
		43,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		114,
		114,
		117,
		122,
		130,
		141,
		137,
		141,
		144,
		-1,
		233,
		-1,
		185,
		146,
		152,
		167,
		175,
		-1,
		-1,
		-1,
		60,
		46,
		39,
		27,
		0,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		150,
		118,
		123,
		118,
		133,
		144,
		135,
		143,
		137,
		140,
		-1,
		-1,
		145,
		128,
		-1,
		-1,
		102,
		104,
		-1,
		51,
		40,
		25,
		8,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		84,
		122,
		121,
		129,
		124,
		129,
		141,
		137,
		133,
		143,
		134,
		-1,
		-1,
		123,
		115,
		109,
		-1,
		87,
		-1,
		75,
		-1,
		20,
		36,
		38,
		-1,
		-1,
		-1,
		115,
		78,
		94,
		117,
		143,
		141,
		132,
		125,
		132,
		135,
		128,
		134,
		-1,
		-1,
		-1,
		105,
		79,
		82,
		73,
		56,
		36,
		32,
		53,
		-1,
		96,
		-1,
		71,
		74,
		99,
		138,
		140,
		126,
		122,
		135,
		129,
		126,
		124,
		111,
		-1,
		81,
		114,
		78,
		42,
		46,
		41,
		110,
		-1,
		93,
		75,
		-1,
		103,
		93,
		141,
		116,
		125,
		118,
		112,
		113,
		121,
		-1,
		-1,
		-1,
		83,
		82,
		74,
		68,
		66,
		51,
		46,
		-1,
		98,
		80,
		66,
		83,
		83,
		74,
		82,
		131,
		127,
		130,
		128,
		106,
		-1,
		197,
		-1,
		-1,
		106,
		-1,
		-1,
		-1,
		77,
		86,
		59,
		47,
		61,
		68,
		63,
		65,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		105,
		137,
		-1,
		192,
		-1,
		113,
		-1,
		-1,
		93,
		79,
		81,
		70,
		59,
		57,
		60,
		58,
		80,
		110,
		96,
		94,
		99,
		104,
		-1,
		181,
		180,
		-1,
		112,
		104,
		90,
		-1,
		83,
		-1,
		105,
		66,
		-1,
		87,
		67,
		-1,
		105,
		101,
		-1,
		-1,
		168,
		128,
		-1,
		-1,
		-1,
		113,
		93,
		100,
		84,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		153,
		137,
		-1,
		106,
		109,
		-1,
		100,
		106,
		133,
		80,
		84,
		-1,
		-1,
		-1,
		162,
		143,
		137,
		121,
		126,
		114,
		131,
		117,
		116,
		94,
		83,
		104,
		-1,
		-1,
		-1,
		134,
		126,
		126,
		-1,
		-1,
		141,
		124,
		105,
		103,
		-1,
		-1,
		-1,
		156,
		137,
		-1,
		-1,
		131,
		-1,
		-1,
		137,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		145,
		-1,
		-1,
		-1,
		127,
		123,
		124,
		-1,
		-1,
		-1,
		-1,
		166,
		167,
		191,
		166,
		-1,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		169,
		167,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		117,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		152,
		-1,
		152,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		165,
		-1,
		137,
		139,
		-1,
		187,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		142,
		149,
		171,
		174,
		210,
		-1,
		161
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		289,
		278,
		289,
		297,
		270,
		277,
		-1,
		296,
		300,
		266,
		260,
		299,
		268,
		274,
		285,
		-1,
		-1,
		-1,
		289,
		288,
		256,
		254,
		263,
		268,
		275,
		-1,
		274,
		-1,
		310,
		289,
		300,
		305,
		249,
		246,
		266,
		285,
		267,
		259,
		325,
		279,
		250,
		244,
		262,
		252,
		261,
		253,
		-1,
		250,
		240,
		262,
		241,
		252,
		244,
		-1,
		-1,
		244,
		245,
		251,
		237,
		243,
		239,
		-1,
		249,
		233,
		-1,
		-1,
		234,
		235,
		219,
		222,
		230,
		228,
		241,
		233,
		228,
		-1,
		-1,
		225,
		221,
		228,
		215,
		211,
		228,
		241,
		223,
		237,
		236,
		-1,
		229,
		247,
		254,
		222,
		220,
		204,
		202,
		220,
		222,
		228,
		228,
		-1,
		238,
		239,
		234,
		242,
		244,
		220,
		207,
		207,
		217,
		210,
		229,
		217,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		272,
		238,
		221,
		238,
		230,
		220,
		235,
		228,
		210,
		207,
		205,
		202,
		218,
		216,
		226,
		-1,
		-1,
		331,
		300,
		329,
		287,
		268,
		-1,
		234,
		214,
		220,
		224,
		218,
		211,
		225,
		221,
		-1,
		196,
		195,
		223,
		209,
		220,
		291,
		-1,
		-1,
		289,
		281,
		264,
		267,
		244,
		240,
		229,
		228,
		220,
		206,
		202,
		208,
		211,
		211,
		217,
		190,
		200,
		204,
		202,
		227,
		-1,
		-1,
		262,
		-1,
		-1,
		288,
		271,
		-1,
		254,
		261,
		250,
		256,
		242,
		263,
		239,
		230,
		222,
		216,
		204,
		206,
		203,
		216,
		204,
		187,
		212,
		216,
		197,
		218,
		213,
		-1,
		261,
		245,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		247,
		250,
		256,
		280,
		279,
		-1,
		251,
		239,
		240,
		225,
		222,
		209,
		197,
		210,
		195,
		202,
		201,
		191,
		189,
		219,
		194,
		216,
		213,
		232,
		237,
		231,
		240,
		-1,
		296,
		292,
		288,
		295,
		244,
		-1,
		-1,
		284,
		-1,
		287,
		288,
		263,
		236,
		239,
		226,
		217,
		204,
		193,
		204,
		193,
		190,
		198,
		183,
		198,
		189,
		188,
		206,
		216,
		224,
		228,
		234,
		-1,
		346,
		-1,
		288,
		272,
		274,
		246,
		267,
		-1,
		304,
		288,
		280,
		265,
		265,
		-1,
		235,
		232,
		222,
		200,
		185,
		202,
		194,
		192,
		196,
		178,
		192,
		183,
		201,
		208,
		206,
		210,
		230,
		242,
		306,
		296,
		-1,
		278,
		283,
		242,
		250,
		269,
		307,
		271,
		-1,
		266,
		-1,
		237,
		250,
		-1,
		206,
		202,
		184,
		185,
		180,
		195,
		189,
		174,
		171,
		189,
		192,
		199,
		203,
		219,
		-1,
		-1,
		291,
		295,
		284,
		235,
		254,
		278,
		315,
		264,
		253,
		252,
		-1,
		243,
		220,
		217,
		205,
		192,
		177,
		178,
		186,
		199,
		178,
		173,
		170,
		190,
		216,
		194,
		206,
		-1,
		-1,
		-1,
		316,
		-1,
		-1,
		261,
		232,
		256,
		298,
		282,
		275,
		263,
		228,
		228,
		222,
		-1,
		216,
		195,
		186,
		175,
		173,
		186,
		183,
		188,
		168,
		166,
		185,
		197,
		188,
		205,
		-1,
		-1,
		-1,
		291,
		280,
		281,
		227,
		250,
		287,
		261,
		247,
		252,
		227,
		220,
		214,
		229,
		212,
		193,
		182,
		174,
		163,
		179,
		187,
		182,
		164,
		173,
		179,
		203,
		193,
		199,
		-1,
		-1,
		298,
		288,
		272,
		274,
		271,
		241,
		248,
		280,
		252,
		265,
		-1,
		219,
		-1,
		208,
		203,
		187,
		182,
		179,
		176,
		170,
		179,
		181,
		171,
		166,
		173,
		208,
		208,
		183,
		203,
		206,
		-1,
		-1,
		-1,
		291,
		286,
		261,
		238,
		222,
		258,
		-1,
		235,
		236,
		-1,
		213,
		207,
		204,
		189,
		185,
		180,
		184,
		177,
		184,
		177,
		175,
		176,
		158,
		190,
		-1,
		191,
		185,
		193,
		183,
		171,
		-1,
		-1,
		-1,
		284,
		263,
		256,
		276,
		217,
		269,
		-1,
		-1,
		220,
		213,
		-1,
		200,
		182,
		189,
		187,
		181,
		185,
		182,
		171,
		184,
		177,
		163,
		165,
		178,
		182,
		186,
		173,
		169,
		166,
		180,
		-1,
		303,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		237,
		-1,
		229,
		221,
		211,
		205,
		199,
		195,
		193,
		209,
		193,
		196,
		194,
		185,
		193,
		166,
		159,
		166,
		155,
		173,
		181,
		173,
		167,
		166,
		176,
		-1,
		304,
		290,
		261,
		-1,
		-1,
		250,
		-1,
		214,
		228,
		244,
		-1,
		237,
		216,
		231,
		209,
		205,
		201,
		216,
		217,
		195,
		194,
		192,
		183,
		171,
		160,
		163,
		155,
		177,
		177,
		161,
		162,
		166,
		-1,
		310,
		297,
		255,
		251,
		240,
		260,
		211,
		199,
		231,
		-1,
		-1,
		273,
		-1,
		207,
		224,
		215,
		213,
		206,
		191,
		198,
		203,
		180,
		175,
		165,
		154,
		154,
		149,
		171,
		157,
		155,
		164,
		180,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		226,
		213,
		207,
		-1,
		248,
		-1,
		251,
		241,
		225,
		210,
		243,
		-1,
		190,
		186,
		193,
		-1,
		200,
		-1,
		173,
		170,
		161,
		146,
		143,
		154,
		152,
		163,
		159,
		-1,
		260,
		245,
		238,
		228,
		242,
		213,
		-1,
		268,
		-1,
		-1,
		238,
		232,
		232,
		216,
		219,
		206,
		186,
		178,
		193,
		192,
		179,
		178,
		159,
		152,
		149,
		142,
		155,
		165,
		170,
		157,
		-1,
		-1,
		-1,
		265,
		251,
		255,
		215,
		234,
		-1,
		-1,
		300,
		255,
		241,
		-1,
		215,
		206,
		194,
		184,
		174,
		179,
		180,
		170,
		168,
		157,
		159,
		153,
		144,
		143,
		159,
		151,
		173,
		-1,
		-1,
		248,
		253,
		241,
		227,
		246,
		-1,
		-1,
		-1,
		247,
		263,
		234,
		213,
		195,
		-1,
		-1,
		178,
		171,
		165,
		168,
		156,
		173,
		168,
		152,
		137,
		152,
		156,
		164,
		155,
		-1,
		251,
		238,
		-1,
		-1,
		249,
		243,
		-1,
		-1,
		-1,
		-1,
		246,
		191,
		180,
		175,
		179,
		177,
		-1,
		151,
		162,
		155,
		174,
		181,
		154,
		139,
		133,
		139,
		151,
		160,
		-1,
		-1,
		263,
		-1,
		233,
		-1,
		-1,
		-1,
		-1,
		203,
		197,
		168,
		161,
		165,
		-1,
		153,
		155,
		152,
		164,
		157,
		154,
		145,
		136,
		132,
		136,
		140,
		154,
		158,
		286,
		-1,
		224,
		-1,
		-1,
		-1,
		221,
		236,
		207,
		184,
		157,
		152,
		145,
		139,
		144,
		155,
		164,
		175,
		140,
		139,
		129,
		128,
		132,
		149,
		153,
		-1,
		-1,
		222,
		218,
		247,
		229,
		233,
		234,
		-1,
		-1,
		161,
		152,
		143,
		135,
		148,
		151,
		136,
		138,
		138,
		133,
		127,
		137,
		152,
		147,
		-1,
		-1,
		-1,
		234,
		-1,
		236,
		-1,
		-1,
		224,
		232,
		179,
		161,
		157,
		155,
		142,
		136,
		126,
		131,
		141,
		135,
		132,
		123,
		127,
		150,
		139,
		178,
		-1,
		-1,
		306,
		-1,
		-1,
		-1,
		213,
		205,
		200,
		206,
		208,
		199,
		194,
		191,
		-1,
		161,
		165,
		132,
		139,
		122,
		129,
		134,
		131,
		117,
		124,
		140,
		139,
		134,
		170,
		161,
		167,
		-1,
		-1,
		299,
		288,
		277,
		283,
		-1,
		206,
		202,
		192,
		182,
		185,
		-1,
		-1,
		179,
		176,
		156,
		125,
		130,
		123,
		118,
		123,
		104,
		113,
		117,
		121,
		127,
		132,
		137,
		143,
		158,
		173,
		-1,
		253,
		290,
		283,
		251,
		259,
		290,
		-1,
		196,
		188,
		199,
		174,
		176,
		-1,
		-1,
		152,
		143,
		144,
		132,
		129,
		142,
		141,
		108,
		113,
		131,
		118,
		119,
		137,
		141,
		150,
		157,
		147,
		160,
		164,
		-1,
		246,
		266,
		245,
		248,
		272,
		286,
		-1,
		193,
		-1,
		-1,
		204,
		177,
		161,
		151,
		148,
		191,
		138,
		133,
		110,
		108,
		105,
		96,
		134,
		113,
		125,
		128,
		144,
		149,
		141,
		157,
		157,
		158,
		-1,
		235,
		246,
		239,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		194,
		-1,
		188,
		-1,
		134,
		163,
		146,
		149,
		124,
		111,
		97,
		105,
		111,
		111,
		116,
		119,
		131,
		140,
		151,
		163,
		164,
		165,
		260,
		216,
		219,
		230,
		241,
		256,
		260,
		-1,
		205,
		244,
		200,
		-1,
		184,
		-1,
		-1,
		-1,
		116,
		159,
		151,
		144,
		123,
		123,
		89,
		93,
		106,
		113,
		123,
		137,
		134,
		144,
		157,
		168,
		173,
		256,
		247,
		260,
		205,
		205,
		226,
		235,
		256,
		220,
		211,
		238,
		207,
		196,
		191,
		178,
		-1,
		-1,
		94,
		169,
		-1,
		-1,
		130,
		97,
		85,
		95,
		99,
		113,
		125,
		138,
		126,
		145,
		139,
		171,
		-1,
		249,
		248,
		237,
		234,
		210,
		201,
		196,
		223,
		-1,
		-1,
		218,
		239,
		229,
		233,
		238,
		263,
		-1,
		167,
		-1,
		-1,
		74,
		-1,
		-1,
		77,
		102,
		91,
		82,
		87,
		107,
		118,
		140,
		122,
		139,
		144,
		154,
		167,
		233,
		230,
		218,
		216,
		239,
		204,
		192,
		-1,
		205,
		203,
		209,
		216,
		233,
		252,
		-1,
		-1,
		183,
		163,
		-1,
		-1,
		57,
		55,
		62,
		-1,
		88,
		79,
		84,
		114,
		116,
		118,
		125,
		119,
		126,
		152,
		164,
		166,
		242,
		256,
		245,
		241,
		240,
		248,
		197,
		190,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		-1,
		173,
		169,
		-1,
		-1,
		52,
		43,
		50,
		61,
		74,
		84,
		101,
		101,
		104,
		109,
		117,
		128,
		142,
		146,
		160,
		-1,
		276,
		-1,
		228,
		204,
		218,
		233,
		241,
		-1,
		-1,
		-1,
		190,
		176,
		169,
		157,
		155,
		-1,
		0,
		68,
		32,
		-1,
		84,
		97,
		137,
		105,
		110,
		105,
		123,
		134,
		145,
		148,
		153,
		156,
		-1,
		-1,
		216,
		206,
		-1,
		-1,
		180,
		182,
		-1,
		181,
		170,
		155,
		147,
		-1,
		-1,
		22,
		28,
		-1,
		-1,
		85,
		119,
		108,
		116,
		111,
		123,
		133,
		131,
		143,
		151,
		150,
		-1,
		-1,
		201,
		193,
		187,
		-1,
		165,
		-1,
		183,
		-1,
		150,
		156,
		144,
		-1,
		-1,
		-1,
		123,
		86,
		107,
		126,
		131,
		129,
		120,
		119,
		126,
		136,
		144,
		150,
		-1,
		-1,
		-1,
		183,
		157,
		190,
		181,
		164,
		144,
		136,
		155,
		-1,
		122,
		-1,
		90,
		87,
		128,
		125,
		142,
		136,
		122,
		137,
		133,
		142,
		140,
		189,
		-1,
		159,
		192,
		156,
		150,
		126,
		130,
		146,
		-1,
		119,
		98,
		-1,
		132,
		122,
		159,
		145,
		133,
		120,
		127,
		141,
		137,
		-1,
		-1,
		-1,
		161,
		160,
		152,
		146,
		146,
		131,
		122,
		-1,
		134,
		116,
		95,
		112,
		112,
		103,
		111,
		149,
		145,
		138,
		140,
		132,
		-1,
		262,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		155,
		150,
		123,
		111,
		117,
		113,
		99,
		105,
		107,
		115,
		113,
		110,
		122,
		118,
		138,
		133,
		166,
		-1,
		257,
		-1,
		191,
		-1,
		-1,
		173,
		153,
		145,
		134,
		123,
		121,
		112,
		103,
		125,
		141,
		125,
		123,
		128,
		133,
		-1,
		246,
		245,
		-1,
		192,
		184,
		170,
		-1,
		163,
		-1,
		169,
		130,
		-1,
		132,
		112,
		-1,
		134,
		130,
		-1,
		-1,
		233,
		208,
		-1,
		-1,
		-1,
		193,
		173,
		164,
		148,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		218,
		217,
		-1,
		186,
		189,
		-1,
		179,
		170,
		178,
		125,
		129,
		-1,
		-1,
		-1,
		227,
		208,
		202,
		201,
		199,
		194,
		191,
		177,
		161,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		199,
		191,
		184,
		-1,
		-1,
		186,
		169,
		150,
		148,
		-1,
		-1,
		-1,
		221,
		202,
		-1,
		-1,
		176,
		-1,
		-1,
		182,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		210,
		-1,
		-1,
		-1,
		172,
		168,
		169,
		-1,
		-1,
		-1,
		-1,
		232,
		233,
		256,
		220,
		-1,
		-1,
		-1,
		164,
		158,
		-1,
		-1,
		235,
		233,
		-1,
		-1,
		-1,
		192,
		176,
		-1,
		162,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		197,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		210,
		202,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		225,
		216,
		-1,
		-1,
		187,
		194,
		216,
		219,
		255,
		-1,
		206
	],
	[
		-1,
		273,
		262,
		273,
		281,
		254,
		261,
		-1,
		280,
		284,
		250,
		244,
		283,
		252,
		258,
		269,
		-1,
		-1,
		-1,
		273,
		272,
		240,
		238,
		247,
		252,
		259,
		-1,
		258,
		-1,
		294,
		273,
		284,
		289,
		233,
		230,
		250,
		269,
		251,
		243,
		309,
		263,
		234,
		228,
		246,
		236,
		245,
		237,
		-1,
		234,
		224,
		246,
		225,
		236,
		228,
		-1,
		-1,
		228,
		229,
		235,
		221,
		227,
		223,
		-1,
		233,
		217,
		-1,
		-1,
		218,
		219,
		203,
		206,
		214,
		212,
		225,
		217,
		212,
		-1,
		-1,
		209,
		205,
		212,
		199,
		195,
		212,
		225,
		207,
		221,
		220,
		-1,
		213,
		231,
		238,
		206,
		204,
		188,
		186,
		204,
		206,
		212,
		212,
		-1,
		222,
		223,
		218,
		226,
		228,
		204,
		191,
		191,
		201,
		194,
		213,
		201,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		222,
		205,
		222,
		214,
		204,
		219,
		212,
		194,
		191,
		189,
		186,
		202,
		200,
		210,
		-1,
		-1,
		315,
		284,
		313,
		271,
		252,
		-1,
		218,
		198,
		204,
		208,
		202,
		195,
		209,
		205,
		-1,
		180,
		179,
		207,
		193,
		204,
		275,
		-1,
		-1,
		273,
		265,
		248,
		251,
		228,
		224,
		213,
		212,
		204,
		190,
		186,
		192,
		195,
		195,
		201,
		174,
		184,
		188,
		186,
		211,
		-1,
		-1,
		246,
		-1,
		-1,
		272,
		255,
		-1,
		238,
		245,
		234,
		240,
		226,
		247,
		223,
		214,
		206,
		200,
		188,
		190,
		187,
		200,
		188,
		171,
		196,
		200,
		181,
		202,
		197,
		-1,
		245,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		231,
		234,
		240,
		264,
		263,
		-1,
		235,
		223,
		224,
		209,
		206,
		193,
		181,
		194,
		179,
		186,
		185,
		175,
		173,
		203,
		178,
		200,
		197,
		216,
		221,
		215,
		224,
		-1,
		280,
		276,
		272,
		279,
		228,
		-1,
		-1,
		268,
		-1,
		271,
		272,
		247,
		220,
		223,
		210,
		201,
		188,
		177,
		188,
		177,
		174,
		182,
		167,
		182,
		173,
		172,
		190,
		200,
		208,
		212,
		218,
		-1,
		330,
		-1,
		272,
		256,
		258,
		230,
		251,
		-1,
		288,
		272,
		264,
		249,
		249,
		-1,
		219,
		216,
		206,
		184,
		169,
		186,
		178,
		176,
		180,
		162,
		176,
		167,
		185,
		192,
		190,
		194,
		214,
		226,
		290,
		280,
		-1,
		262,
		267,
		226,
		234,
		253,
		291,
		255,
		-1,
		250,
		-1,
		221,
		234,
		-1,
		190,
		186,
		168,
		169,
		164,
		179,
		173,
		158,
		155,
		173,
		176,
		183,
		187,
		203,
		-1,
		-1,
		275,
		279,
		268,
		219,
		238,
		262,
		299,
		248,
		237,
		236,
		-1,
		227,
		204,
		201,
		189,
		176,
		161,
		162,
		170,
		183,
		162,
		157,
		154,
		174,
		200,
		178,
		190,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		245,
		216,
		240,
		282,
		266,
		259,
		247,
		212,
		212,
		206,
		-1,
		200,
		179,
		170,
		159,
		157,
		170,
		167,
		172,
		152,
		150,
		169,
		181,
		172,
		189,
		-1,
		-1,
		-1,
		275,
		264,
		265,
		211,
		234,
		271,
		245,
		231,
		236,
		211,
		204,
		198,
		213,
		196,
		177,
		166,
		158,
		147,
		163,
		171,
		166,
		148,
		157,
		163,
		187,
		177,
		183,
		-1,
		-1,
		282,
		272,
		256,
		258,
		255,
		225,
		232,
		264,
		236,
		249,
		-1,
		203,
		-1,
		192,
		187,
		171,
		166,
		163,
		160,
		154,
		163,
		165,
		155,
		150,
		157,
		192,
		192,
		167,
		187,
		190,
		-1,
		-1,
		-1,
		275,
		270,
		245,
		222,
		206,
		242,
		-1,
		219,
		220,
		-1,
		197,
		191,
		188,
		173,
		169,
		164,
		168,
		161,
		168,
		161,
		159,
		160,
		142,
		174,
		-1,
		175,
		169,
		177,
		167,
		155,
		-1,
		-1,
		-1,
		268,
		247,
		240,
		260,
		201,
		253,
		-1,
		-1,
		204,
		197,
		-1,
		184,
		166,
		173,
		171,
		165,
		169,
		166,
		155,
		168,
		161,
		147,
		149,
		162,
		166,
		170,
		157,
		153,
		150,
		164,
		-1,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		221,
		-1,
		213,
		205,
		195,
		189,
		183,
		179,
		177,
		193,
		177,
		180,
		178,
		169,
		177,
		150,
		143,
		150,
		139,
		157,
		165,
		157,
		151,
		150,
		160,
		-1,
		288,
		274,
		245,
		-1,
		-1,
		234,
		-1,
		198,
		212,
		228,
		-1,
		221,
		200,
		215,
		193,
		189,
		185,
		200,
		201,
		179,
		178,
		176,
		167,
		155,
		144,
		147,
		139,
		161,
		161,
		145,
		146,
		150,
		-1,
		294,
		281,
		239,
		235,
		224,
		244,
		195,
		183,
		215,
		-1,
		-1,
		257,
		-1,
		191,
		208,
		199,
		197,
		190,
		175,
		182,
		187,
		164,
		159,
		149,
		138,
		138,
		133,
		155,
		141,
		139,
		148,
		164,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		210,
		197,
		191,
		-1,
		232,
		-1,
		235,
		225,
		209,
		194,
		227,
		-1,
		174,
		170,
		177,
		-1,
		184,
		-1,
		157,
		154,
		145,
		130,
		127,
		138,
		136,
		147,
		143,
		-1,
		244,
		229,
		222,
		212,
		226,
		197,
		-1,
		252,
		-1,
		-1,
		222,
		216,
		216,
		200,
		203,
		190,
		170,
		162,
		177,
		176,
		163,
		162,
		143,
		136,
		133,
		126,
		139,
		149,
		154,
		141,
		-1,
		-1,
		-1,
		249,
		235,
		239,
		199,
		218,
		-1,
		-1,
		284,
		239,
		225,
		-1,
		199,
		190,
		178,
		168,
		158,
		163,
		164,
		154,
		152,
		141,
		143,
		137,
		128,
		127,
		143,
		135,
		157,
		-1,
		-1,
		232,
		237,
		225,
		211,
		230,
		-1,
		-1,
		-1,
		231,
		247,
		218,
		197,
		179,
		-1,
		-1,
		162,
		155,
		149,
		152,
		140,
		157,
		152,
		136,
		121,
		136,
		140,
		148,
		139,
		-1,
		235,
		222,
		-1,
		-1,
		233,
		227,
		-1,
		-1,
		-1,
		-1,
		230,
		175,
		164,
		159,
		163,
		161,
		-1,
		135,
		146,
		139,
		158,
		165,
		138,
		123,
		117,
		123,
		135,
		144,
		-1,
		-1,
		247,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		187,
		181,
		152,
		145,
		149,
		-1,
		137,
		139,
		136,
		148,
		141,
		138,
		129,
		120,
		116,
		120,
		124,
		138,
		142,
		270,
		-1,
		208,
		-1,
		-1,
		-1,
		205,
		220,
		191,
		168,
		141,
		136,
		129,
		123,
		128,
		139,
		148,
		159,
		124,
		123,
		113,
		112,
		116,
		133,
		137,
		-1,
		-1,
		206,
		202,
		231,
		213,
		217,
		218,
		-1,
		-1,
		145,
		136,
		127,
		119,
		132,
		135,
		120,
		122,
		122,
		117,
		111,
		121,
		136,
		131,
		-1,
		-1,
		-1,
		218,
		-1,
		220,
		-1,
		-1,
		208,
		216,
		163,
		145,
		141,
		139,
		126,
		120,
		110,
		115,
		125,
		119,
		116,
		107,
		111,
		134,
		123,
		162,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		197,
		189,
		184,
		190,
		192,
		183,
		178,
		175,
		-1,
		145,
		149,
		116,
		123,
		106,
		113,
		118,
		115,
		101,
		108,
		124,
		123,
		118,
		154,
		145,
		151,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		190,
		186,
		176,
		166,
		169,
		-1,
		-1,
		163,
		160,
		140,
		109,
		114,
		107,
		102,
		107,
		88,
		97,
		101,
		105,
		111,
		116,
		121,
		127,
		142,
		157,
		-1,
		237,
		274,
		267,
		235,
		243,
		274,
		-1,
		180,
		172,
		183,
		158,
		160,
		-1,
		-1,
		136,
		127,
		128,
		116,
		113,
		126,
		125,
		92,
		97,
		115,
		102,
		103,
		121,
		125,
		134,
		141,
		131,
		144,
		148,
		-1,
		230,
		250,
		229,
		232,
		256,
		270,
		-1,
		177,
		-1,
		-1,
		188,
		161,
		145,
		135,
		132,
		175,
		122,
		117,
		94,
		92,
		89,
		80,
		118,
		97,
		109,
		112,
		128,
		133,
		125,
		141,
		141,
		142,
		-1,
		219,
		230,
		223,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		178,
		-1,
		172,
		-1,
		118,
		147,
		130,
		133,
		108,
		95,
		81,
		89,
		95,
		95,
		100,
		103,
		115,
		124,
		135,
		147,
		148,
		149,
		244,
		200,
		203,
		214,
		225,
		240,
		244,
		-1,
		189,
		228,
		184,
		-1,
		168,
		-1,
		-1,
		-1,
		100,
		143,
		135,
		128,
		107,
		107,
		73,
		77,
		90,
		97,
		107,
		121,
		118,
		128,
		141,
		152,
		157,
		240,
		231,
		244,
		189,
		189,
		210,
		219,
		240,
		204,
		195,
		222,
		191,
		180,
		175,
		162,
		-1,
		-1,
		78,
		153,
		-1,
		-1,
		114,
		81,
		69,
		79,
		83,
		97,
		109,
		122,
		110,
		129,
		123,
		155,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		207,
		-1,
		-1,
		202,
		223,
		213,
		217,
		222,
		247,
		-1,
		151,
		-1,
		-1,
		58,
		-1,
		-1,
		61,
		86,
		75,
		66,
		71,
		91,
		102,
		124,
		106,
		123,
		128,
		138,
		151,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		189,
		187,
		193,
		200,
		217,
		236,
		-1,
		-1,
		167,
		147,
		-1,
		-1,
		41,
		39,
		46,
		-1,
		72,
		63,
		68,
		98,
		100,
		102,
		109,
		103,
		110,
		136,
		148,
		150,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		157,
		153,
		-1,
		-1,
		36,
		27,
		34,
		45,
		58,
		68,
		85,
		85,
		88,
		93,
		101,
		112,
		126,
		130,
		144,
		-1,
		260,
		-1,
		212,
		188,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		174,
		160,
		153,
		141,
		139,
		-1,
		68,
		0,
		33,
		-1,
		68,
		81,
		121,
		89,
		94,
		89,
		107,
		118,
		129,
		132,
		137,
		140,
		-1,
		-1,
		200,
		190,
		-1,
		-1,
		164,
		166,
		-1,
		165,
		154,
		139,
		131,
		-1,
		-1,
		40,
		36,
		-1,
		-1,
		69,
		103,
		92,
		100,
		95,
		107,
		117,
		115,
		127,
		135,
		134,
		-1,
		-1,
		185,
		177,
		171,
		-1,
		149,
		-1,
		167,
		-1,
		134,
		140,
		128,
		-1,
		-1,
		-1,
		107,
		70,
		91,
		110,
		115,
		113,
		104,
		103,
		110,
		120,
		128,
		134,
		-1,
		-1,
		-1,
		167,
		141,
		174,
		165,
		148,
		128,
		120,
		139,
		-1,
		106,
		-1,
		74,
		71,
		112,
		109,
		126,
		120,
		106,
		121,
		117,
		126,
		124,
		173,
		-1,
		143,
		176,
		140,
		134,
		110,
		114,
		130,
		-1,
		103,
		82,
		-1,
		116,
		106,
		143,
		129,
		117,
		104,
		111,
		125,
		121,
		-1,
		-1,
		-1,
		145,
		144,
		136,
		130,
		130,
		115,
		106,
		-1,
		118,
		100,
		79,
		96,
		96,
		87,
		95,
		133,
		129,
		122,
		124,
		116,
		-1,
		246,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		139,
		134,
		107,
		95,
		101,
		97,
		83,
		89,
		91,
		99,
		97,
		94,
		106,
		102,
		122,
		117,
		150,
		-1,
		241,
		-1,
		175,
		-1,
		-1,
		157,
		137,
		129,
		118,
		107,
		105,
		96,
		87,
		109,
		125,
		109,
		107,
		112,
		117,
		-1,
		230,
		229,
		-1,
		176,
		168,
		154,
		-1,
		147,
		-1,
		153,
		114,
		-1,
		116,
		96,
		-1,
		118,
		114,
		-1,
		-1,
		217,
		192,
		-1,
		-1,
		-1,
		177,
		157,
		148,
		132,
		-1,
		107,
		107,
		-1,
		-1,
		-1,
		202,
		201,
		-1,
		170,
		173,
		-1,
		163,
		154,
		162,
		109,
		113,
		-1,
		-1,
		-1,
		211,
		192,
		186,
		185,
		183,
		178,
		175,
		161,
		145,
		123,
		112,
		133,
		-1,
		-1,
		-1,
		183,
		175,
		168,
		-1,
		-1,
		170,
		153,
		134,
		132,
		-1,
		-1,
		-1,
		205,
		186,
		-1,
		-1,
		160,
		-1,
		-1,
		166,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		194,
		-1,
		-1,
		-1,
		156,
		152,
		153,
		-1,
		-1,
		-1,
		-1,
		216,
		217,
		240,
		204,
		-1,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		219,
		217,
		-1,
		-1,
		-1,
		176,
		160,
		-1,
		146,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		181,
		-1,
		181,
		156,
		163,
		-1,
		-1,
		-1,
		-1,
		194,
		186,
		194,
		-1,
		166,
		168,
		-1,
		216,
		-1,
		-1,
		209,
		200,
		-1,
		-1,
		171,
		178,
		200,
		203,
		239,
		-1,
		190
	],
	[
		-1,
		257,
		246,
		257,
		265,
		238,
		245,
		-1,
		264,
		268,
		234,
		228,
		267,
		236,
		242,
		253,
		-1,
		-1,
		-1,
		257,
		256,
		224,
		222,
		231,
		236,
		243,
		-1,
		242,
		-1,
		278,
		257,
		268,
		273,
		217,
		214,
		234,
		253,
		235,
		227,
		293,
		247,
		218,
		212,
		230,
		220,
		229,
		221,
		-1,
		218,
		208,
		230,
		209,
		220,
		212,
		-1,
		-1,
		212,
		213,
		219,
		205,
		211,
		207,
		-1,
		217,
		201,
		-1,
		-1,
		202,
		203,
		187,
		190,
		198,
		196,
		209,
		201,
		196,
		-1,
		-1,
		193,
		189,
		196,
		183,
		179,
		196,
		209,
		191,
		205,
		204,
		-1,
		197,
		215,
		222,
		190,
		188,
		172,
		170,
		188,
		190,
		196,
		196,
		-1,
		206,
		207,
		202,
		210,
		212,
		188,
		175,
		175,
		185,
		178,
		197,
		185,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		206,
		189,
		206,
		198,
		188,
		203,
		196,
		178,
		175,
		173,
		170,
		186,
		184,
		194,
		-1,
		-1,
		299,
		268,
		297,
		255,
		236,
		-1,
		202,
		182,
		188,
		192,
		186,
		179,
		193,
		189,
		-1,
		164,
		163,
		191,
		177,
		188,
		259,
		-1,
		-1,
		257,
		249,
		232,
		235,
		212,
		208,
		197,
		196,
		188,
		174,
		170,
		176,
		179,
		179,
		185,
		158,
		168,
		172,
		170,
		195,
		-1,
		-1,
		230,
		-1,
		-1,
		256,
		239,
		-1,
		222,
		229,
		218,
		224,
		210,
		231,
		207,
		198,
		190,
		184,
		172,
		174,
		171,
		184,
		172,
		155,
		180,
		184,
		165,
		186,
		181,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		215,
		218,
		224,
		248,
		247,
		-1,
		219,
		207,
		208,
		193,
		190,
		177,
		165,
		178,
		163,
		170,
		169,
		159,
		157,
		187,
		162,
		184,
		181,
		200,
		205,
		199,
		208,
		-1,
		264,
		260,
		256,
		263,
		212,
		-1,
		-1,
		252,
		-1,
		255,
		256,
		231,
		204,
		207,
		194,
		185,
		172,
		161,
		172,
		161,
		158,
		166,
		151,
		166,
		157,
		156,
		174,
		184,
		192,
		196,
		202,
		-1,
		314,
		-1,
		256,
		240,
		242,
		214,
		235,
		-1,
		272,
		256,
		248,
		233,
		233,
		-1,
		203,
		200,
		190,
		168,
		153,
		170,
		162,
		160,
		164,
		146,
		160,
		151,
		169,
		176,
		174,
		178,
		198,
		210,
		274,
		264,
		-1,
		246,
		251,
		210,
		218,
		237,
		275,
		239,
		-1,
		234,
		-1,
		205,
		218,
		-1,
		174,
		170,
		152,
		153,
		148,
		163,
		157,
		142,
		139,
		157,
		160,
		167,
		171,
		187,
		-1,
		-1,
		259,
		263,
		252,
		203,
		222,
		246,
		283,
		232,
		221,
		220,
		-1,
		211,
		188,
		185,
		173,
		160,
		145,
		146,
		154,
		167,
		146,
		141,
		138,
		158,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		229,
		200,
		224,
		266,
		250,
		243,
		231,
		196,
		196,
		190,
		-1,
		184,
		163,
		154,
		143,
		141,
		154,
		151,
		156,
		136,
		134,
		153,
		165,
		156,
		173,
		-1,
		-1,
		-1,
		259,
		248,
		249,
		195,
		218,
		255,
		229,
		215,
		220,
		195,
		188,
		182,
		197,
		180,
		161,
		150,
		142,
		131,
		147,
		155,
		150,
		132,
		141,
		147,
		171,
		161,
		167,
		-1,
		-1,
		266,
		256,
		240,
		242,
		239,
		209,
		216,
		248,
		220,
		233,
		-1,
		187,
		-1,
		176,
		171,
		155,
		150,
		147,
		144,
		138,
		147,
		149,
		139,
		134,
		141,
		176,
		176,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		259,
		254,
		229,
		206,
		190,
		226,
		-1,
		203,
		204,
		-1,
		181,
		175,
		172,
		157,
		153,
		148,
		152,
		145,
		152,
		145,
		143,
		144,
		126,
		158,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		252,
		231,
		224,
		244,
		185,
		237,
		-1,
		-1,
		188,
		181,
		-1,
		168,
		150,
		157,
		155,
		149,
		153,
		150,
		139,
		152,
		145,
		131,
		133,
		146,
		150,
		154,
		141,
		137,
		134,
		148,
		-1,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		205,
		-1,
		197,
		189,
		179,
		173,
		167,
		163,
		161,
		177,
		161,
		164,
		162,
		153,
		161,
		134,
		127,
		134,
		123,
		141,
		149,
		141,
		135,
		134,
		144,
		-1,
		272,
		258,
		229,
		-1,
		-1,
		218,
		-1,
		182,
		196,
		212,
		-1,
		205,
		184,
		199,
		177,
		173,
		169,
		184,
		185,
		163,
		162,
		160,
		151,
		139,
		128,
		131,
		123,
		145,
		145,
		129,
		130,
		134,
		-1,
		278,
		265,
		223,
		219,
		208,
		228,
		179,
		167,
		199,
		-1,
		-1,
		241,
		-1,
		175,
		192,
		183,
		181,
		174,
		159,
		166,
		171,
		148,
		143,
		133,
		122,
		122,
		117,
		139,
		125,
		123,
		132,
		148,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		194,
		181,
		175,
		-1,
		216,
		-1,
		219,
		209,
		193,
		178,
		211,
		-1,
		158,
		154,
		161,
		-1,
		168,
		-1,
		141,
		138,
		129,
		114,
		111,
		122,
		120,
		131,
		127,
		-1,
		228,
		213,
		206,
		196,
		210,
		181,
		-1,
		236,
		-1,
		-1,
		206,
		200,
		200,
		184,
		187,
		174,
		154,
		146,
		161,
		160,
		147,
		146,
		127,
		120,
		117,
		110,
		123,
		133,
		138,
		125,
		-1,
		-1,
		-1,
		233,
		219,
		223,
		183,
		202,
		-1,
		-1,
		268,
		223,
		209,
		-1,
		183,
		174,
		162,
		152,
		142,
		147,
		148,
		138,
		136,
		125,
		127,
		121,
		112,
		111,
		127,
		119,
		141,
		-1,
		-1,
		216,
		221,
		209,
		195,
		214,
		-1,
		-1,
		-1,
		215,
		231,
		202,
		181,
		163,
		-1,
		-1,
		146,
		139,
		133,
		136,
		124,
		141,
		136,
		120,
		105,
		120,
		124,
		132,
		123,
		-1,
		219,
		206,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		-1,
		-1,
		214,
		159,
		148,
		143,
		147,
		145,
		-1,
		119,
		130,
		123,
		142,
		149,
		122,
		107,
		101,
		107,
		119,
		128,
		-1,
		-1,
		231,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		171,
		165,
		136,
		129,
		133,
		-1,
		121,
		123,
		120,
		132,
		125,
		122,
		113,
		104,
		100,
		104,
		108,
		122,
		126,
		254,
		-1,
		192,
		-1,
		-1,
		-1,
		189,
		204,
		175,
		152,
		125,
		120,
		113,
		107,
		112,
		123,
		132,
		143,
		108,
		107,
		97,
		96,
		100,
		117,
		121,
		-1,
		-1,
		190,
		186,
		215,
		197,
		201,
		202,
		-1,
		-1,
		129,
		120,
		111,
		103,
		116,
		119,
		104,
		106,
		106,
		101,
		95,
		105,
		120,
		115,
		-1,
		-1,
		-1,
		202,
		-1,
		204,
		-1,
		-1,
		192,
		200,
		147,
		129,
		125,
		123,
		110,
		104,
		94,
		99,
		109,
		103,
		100,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		162,
		159,
		-1,
		129,
		133,
		100,
		107,
		90,
		97,
		102,
		99,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		147,
		144,
		124,
		93,
		98,
		91,
		86,
		91,
		72,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		120,
		111,
		112,
		100,
		97,
		110,
		109,
		76,
		81,
		99,
		86,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		161,
		-1,
		-1,
		172,
		145,
		129,
		119,
		116,
		159,
		106,
		101,
		78,
		76,
		73,
		64,
		102,
		81,
		93,
		96,
		112,
		117,
		109,
		125,
		125,
		126,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		162,
		-1,
		156,
		-1,
		102,
		131,
		114,
		117,
		92,
		79,
		65,
		73,
		79,
		79,
		84,
		87,
		99,
		108,
		119,
		131,
		132,
		133,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		173,
		212,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		84,
		127,
		119,
		112,
		91,
		91,
		57,
		61,
		74,
		81,
		91,
		105,
		102,
		112,
		125,
		136,
		141,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		188,
		179,
		206,
		175,
		164,
		159,
		146,
		-1,
		-1,
		62,
		137,
		-1,
		-1,
		98,
		65,
		53,
		63,
		67,
		81,
		93,
		106,
		94,
		113,
		107,
		139,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		207,
		197,
		201,
		206,
		231,
		-1,
		135,
		-1,
		-1,
		42,
		-1,
		-1,
		45,
		70,
		59,
		50,
		55,
		75,
		86,
		108,
		90,
		107,
		112,
		122,
		135,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		220,
		-1,
		-1,
		151,
		131,
		-1,
		-1,
		25,
		23,
		30,
		-1,
		56,
		47,
		52,
		82,
		84,
		86,
		93,
		87,
		94,
		120,
		132,
		134,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		141,
		137,
		-1,
		-1,
		20,
		11,
		18,
		29,
		42,
		52,
		69,
		69,
		72,
		77,
		85,
		96,
		110,
		114,
		128,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		158,
		144,
		137,
		125,
		123,
		-1,
		35,
		36,
		0,
		-1,
		52,
		65,
		105,
		73,
		78,
		73,
		91,
		102,
		113,
		116,
		121,
		124,
		-1,
		-1,
		184,
		174,
		-1,
		-1,
		148,
		150,
		-1,
		149,
		138,
		123,
		115,
		-1,
		-1,
		7,
		3,
		-1,
		-1,
		53,
		87,
		76,
		84,
		79,
		91,
		101,
		99,
		111,
		119,
		118,
		-1,
		-1,
		169,
		161,
		155,
		-1,
		133,
		-1,
		151,
		-1,
		118,
		124,
		112,
		-1,
		-1,
		-1,
		91,
		54,
		75,
		94,
		99,
		97,
		88,
		87,
		94,
		104,
		112,
		118,
		-1,
		-1,
		-1,
		151,
		125,
		158,
		149,
		132,
		112,
		104,
		123,
		-1,
		90,
		-1,
		58,
		55,
		96,
		93,
		110,
		104,
		90,
		105,
		101,
		110,
		108,
		157,
		-1,
		127,
		160,
		124,
		118,
		94,
		98,
		114,
		-1,
		87,
		66,
		-1,
		100,
		90,
		127,
		113,
		101,
		88,
		95,
		109,
		105,
		-1,
		-1,
		-1,
		129,
		128,
		120,
		114,
		114,
		99,
		90,
		-1,
		102,
		84,
		63,
		80,
		80,
		71,
		79,
		117,
		113,
		106,
		108,
		100,
		-1,
		230,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		123,
		118,
		91,
		79,
		85,
		81,
		67,
		73,
		75,
		83,
		81,
		78,
		90,
		86,
		106,
		101,
		134,
		-1,
		225,
		-1,
		159,
		-1,
		-1,
		141,
		121,
		113,
		102,
		91,
		89,
		80,
		71,
		93,
		109,
		93,
		91,
		96,
		101,
		-1,
		214,
		213,
		-1,
		160,
		152,
		138,
		-1,
		131,
		-1,
		137,
		98,
		-1,
		100,
		80,
		-1,
		102,
		98,
		-1,
		-1,
		201,
		176,
		-1,
		-1,
		-1,
		161,
		141,
		132,
		116,
		-1,
		91,
		91,
		-1,
		-1,
		-1,
		186,
		185,
		-1,
		154,
		157,
		-1,
		147,
		138,
		146,
		93,
		97,
		-1,
		-1,
		-1,
		195,
		176,
		170,
		169,
		167,
		162,
		159,
		145,
		129,
		107,
		96,
		117,
		-1,
		-1,
		-1,
		167,
		159,
		152,
		-1,
		-1,
		154,
		137,
		118,
		116,
		-1,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		144,
		-1,
		-1,
		150,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		178,
		-1,
		-1,
		-1,
		140,
		136,
		137,
		-1,
		-1,
		-1,
		-1,
		200,
		201,
		224,
		188,
		-1,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		203,
		201,
		-1,
		-1,
		-1,
		160,
		144,
		-1,
		130,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		165,
		-1,
		165,
		140,
		147,
		-1,
		-1,
		-1,
		-1,
		178,
		170,
		178,
		-1,
		150,
		152,
		-1,
		200,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		155,
		162,
		184,
		187,
		223,
		-1,
		174
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		230,
		219,
		230,
		238,
		211,
		218,
		-1,
		237,
		241,
		207,
		201,
		240,
		209,
		215,
		226,
		-1,
		-1,
		-1,
		230,
		229,
		197,
		195,
		204,
		209,
		216,
		-1,
		215,
		-1,
		251,
		230,
		241,
		246,
		190,
		187,
		207,
		226,
		208,
		200,
		266,
		220,
		191,
		185,
		203,
		193,
		202,
		194,
		-1,
		191,
		181,
		203,
		182,
		193,
		185,
		-1,
		-1,
		185,
		186,
		192,
		178,
		184,
		180,
		-1,
		190,
		174,
		-1,
		-1,
		175,
		176,
		160,
		163,
		171,
		169,
		182,
		174,
		169,
		-1,
		-1,
		166,
		162,
		169,
		156,
		152,
		169,
		182,
		164,
		178,
		177,
		-1,
		170,
		188,
		195,
		163,
		161,
		145,
		143,
		161,
		163,
		169,
		169,
		-1,
		179,
		180,
		175,
		183,
		185,
		161,
		148,
		148,
		158,
		151,
		170,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		162,
		179,
		171,
		161,
		176,
		169,
		151,
		148,
		146,
		143,
		159,
		157,
		167,
		-1,
		-1,
		272,
		241,
		270,
		228,
		209,
		-1,
		175,
		155,
		161,
		165,
		159,
		152,
		166,
		162,
		-1,
		137,
		136,
		164,
		150,
		161,
		232,
		-1,
		-1,
		230,
		222,
		205,
		208,
		185,
		181,
		170,
		169,
		161,
		147,
		143,
		149,
		152,
		152,
		158,
		131,
		141,
		145,
		143,
		168,
		-1,
		-1,
		203,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		191,
		197,
		183,
		204,
		180,
		171,
		163,
		157,
		145,
		147,
		144,
		157,
		145,
		128,
		153,
		157,
		138,
		159,
		154,
		-1,
		202,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		220,
		-1,
		192,
		180,
		181,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		132,
		130,
		160,
		135,
		157,
		154,
		173,
		178,
		172,
		181,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		228,
		229,
		204,
		177,
		180,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		124,
		139,
		130,
		129,
		147,
		157,
		165,
		169,
		175,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		229,
		221,
		206,
		206,
		-1,
		176,
		173,
		163,
		141,
		126,
		143,
		135,
		133,
		137,
		119,
		133,
		124,
		142,
		149,
		147,
		151,
		171,
		183,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		248,
		212,
		-1,
		207,
		-1,
		178,
		191,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		130,
		115,
		112,
		130,
		133,
		140,
		144,
		160,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		205,
		194,
		193,
		-1,
		184,
		161,
		158,
		146,
		133,
		118,
		119,
		127,
		140,
		119,
		114,
		111,
		131,
		157,
		135,
		147,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		223,
		216,
		204,
		169,
		169,
		163,
		-1,
		157,
		136,
		127,
		116,
		114,
		127,
		124,
		129,
		109,
		107,
		126,
		138,
		129,
		146,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		168,
		191,
		228,
		202,
		188,
		193,
		168,
		161,
		155,
		170,
		153,
		134,
		123,
		115,
		104,
		120,
		128,
		123,
		105,
		114,
		120,
		144,
		134,
		140,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		182,
		189,
		221,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		117,
		111,
		120,
		122,
		112,
		107,
		114,
		149,
		149,
		124,
		144,
		147,
		-1,
		-1,
		-1,
		232,
		227,
		202,
		179,
		163,
		199,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		121,
		125,
		118,
		125,
		118,
		116,
		117,
		99,
		131,
		-1,
		132,
		126,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		128,
		122,
		126,
		123,
		112,
		125,
		118,
		104,
		106,
		119,
		123,
		127,
		114,
		110,
		107,
		121,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		137,
		135,
		126,
		134,
		107,
		100,
		107,
		96,
		114,
		122,
		114,
		108,
		107,
		117,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		136,
		135,
		133,
		124,
		112,
		101,
		104,
		96,
		118,
		118,
		102,
		103,
		107,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		140,
		172,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		132,
		139,
		144,
		121,
		116,
		106,
		95,
		95,
		90,
		112,
		98,
		96,
		105,
		121,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		131,
		127,
		134,
		-1,
		141,
		-1,
		114,
		111,
		102,
		87,
		84,
		95,
		93,
		104,
		100,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		209,
		-1,
		-1,
		179,
		173,
		173,
		157,
		160,
		147,
		127,
		119,
		134,
		133,
		120,
		119,
		100,
		93,
		90,
		83,
		96,
		106,
		111,
		98,
		-1,
		-1,
		-1,
		206,
		192,
		196,
		156,
		175,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		156,
		147,
		135,
		125,
		115,
		120,
		121,
		111,
		109,
		98,
		100,
		94,
		85,
		84,
		100,
		92,
		114,
		-1,
		-1,
		189,
		194,
		182,
		168,
		187,
		-1,
		-1,
		-1,
		188,
		204,
		175,
		154,
		136,
		-1,
		-1,
		119,
		112,
		106,
		109,
		97,
		114,
		109,
		93,
		78,
		93,
		97,
		105,
		96,
		-1,
		192,
		179,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		-1,
		-1,
		187,
		132,
		121,
		116,
		120,
		118,
		-1,
		92,
		103,
		96,
		115,
		122,
		95,
		80,
		74,
		80,
		92,
		101,
		-1,
		-1,
		204,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		144,
		138,
		109,
		102,
		106,
		-1,
		94,
		96,
		93,
		105,
		98,
		95,
		86,
		77,
		73,
		77,
		81,
		95,
		99,
		227,
		-1,
		165,
		-1,
		-1,
		-1,
		162,
		177,
		148,
		125,
		98,
		93,
		86,
		80,
		85,
		96,
		105,
		116,
		81,
		80,
		70,
		69,
		73,
		90,
		94,
		-1,
		-1,
		163,
		159,
		188,
		170,
		174,
		175,
		-1,
		-1,
		102,
		93,
		84,
		76,
		89,
		92,
		77,
		79,
		79,
		74,
		68,
		78,
		93,
		88,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		165,
		173,
		120,
		102,
		98,
		96,
		83,
		77,
		67,
		72,
		82,
		76,
		73,
		64,
		68,
		91,
		80,
		119,
		-1,
		-1,
		247,
		-1,
		-1,
		-1,
		154,
		146,
		141,
		147,
		149,
		140,
		135,
		132,
		-1,
		102,
		106,
		73,
		80,
		63,
		70,
		75,
		72,
		58,
		65,
		81,
		80,
		75,
		111,
		102,
		108,
		-1,
		-1,
		240,
		229,
		218,
		224,
		-1,
		147,
		143,
		133,
		123,
		126,
		-1,
		-1,
		120,
		117,
		97,
		66,
		71,
		64,
		59,
		64,
		45,
		54,
		58,
		62,
		68,
		73,
		78,
		84,
		99,
		114,
		-1,
		194,
		231,
		224,
		192,
		200,
		231,
		-1,
		137,
		129,
		140,
		115,
		117,
		-1,
		-1,
		93,
		84,
		85,
		73,
		70,
		83,
		82,
		49,
		54,
		72,
		59,
		60,
		78,
		82,
		91,
		98,
		88,
		101,
		105,
		-1,
		187,
		207,
		186,
		189,
		213,
		227,
		-1,
		134,
		-1,
		-1,
		145,
		118,
		102,
		92,
		89,
		132,
		79,
		74,
		51,
		49,
		46,
		37,
		75,
		54,
		66,
		69,
		85,
		90,
		82,
		98,
		98,
		99,
		-1,
		176,
		187,
		180,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		135,
		-1,
		129,
		-1,
		112,
		116,
		87,
		90,
		65,
		52,
		38,
		46,
		52,
		52,
		57,
		60,
		72,
		81,
		92,
		104,
		105,
		106,
		201,
		157,
		160,
		171,
		182,
		197,
		201,
		-1,
		146,
		185,
		141,
		-1,
		125,
		-1,
		-1,
		-1,
		119,
		100,
		92,
		85,
		64,
		64,
		30,
		34,
		47,
		54,
		64,
		78,
		75,
		85,
		98,
		109,
		114,
		197,
		188,
		201,
		146,
		146,
		167,
		176,
		197,
		161,
		152,
		179,
		148,
		137,
		132,
		119,
		-1,
		-1,
		97,
		110,
		-1,
		-1,
		71,
		38,
		26,
		36,
		40,
		54,
		66,
		79,
		67,
		86,
		80,
		112,
		-1,
		190,
		189,
		178,
		175,
		151,
		142,
		137,
		164,
		-1,
		-1,
		159,
		180,
		170,
		174,
		179,
		204,
		-1,
		108,
		-1,
		-1,
		77,
		-1,
		-1,
		58,
		43,
		32,
		23,
		28,
		48,
		59,
		81,
		63,
		80,
		85,
		95,
		108,
		174,
		171,
		159,
		157,
		180,
		145,
		133,
		-1,
		146,
		144,
		150,
		157,
		174,
		193,
		-1,
		-1,
		124,
		104,
		-1,
		-1,
		60,
		58,
		43,
		-1,
		32,
		20,
		25,
		55,
		57,
		59,
		66,
		60,
		67,
		93,
		105,
		107,
		183,
		197,
		186,
		182,
		181,
		189,
		138,
		131,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		114,
		110,
		-1,
		-1,
		55,
		48,
		36,
		24,
		15,
		22,
		42,
		42,
		45,
		50,
		58,
		69,
		83,
		87,
		101,
		-1,
		217,
		-1,
		169,
		145,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		131,
		117,
		110,
		98,
		96,
		-1,
		89,
		73,
		54,
		-1,
		0,
		13,
		78,
		46,
		51,
		46,
		64,
		75,
		86,
		89,
		94,
		97,
		-1,
		-1,
		157,
		147,
		-1,
		-1,
		121,
		123,
		-1,
		122,
		111,
		96,
		88,
		-1,
		-1,
		61,
		57,
		-1,
		-1,
		26,
		60,
		49,
		57,
		52,
		64,
		74,
		72,
		84,
		92,
		91,
		-1,
		-1,
		142,
		134,
		128,
		-1,
		106,
		-1,
		124,
		-1,
		91,
		97,
		85,
		-1,
		-1,
		-1,
		64,
		27,
		48,
		67,
		72,
		70,
		61,
		60,
		67,
		77,
		85,
		91,
		-1,
		-1,
		-1,
		124,
		98,
		131,
		122,
		105,
		85,
		77,
		96,
		-1,
		63,
		-1,
		31,
		28,
		69,
		66,
		83,
		77,
		63,
		78,
		74,
		83,
		81,
		130,
		-1,
		100,
		133,
		97,
		91,
		67,
		71,
		87,
		-1,
		60,
		39,
		-1,
		73,
		63,
		100,
		86,
		74,
		61,
		68,
		82,
		78,
		-1,
		-1,
		-1,
		102,
		101,
		93,
		87,
		87,
		72,
		63,
		-1,
		75,
		57,
		36,
		53,
		53,
		44,
		52,
		90,
		86,
		79,
		81,
		73,
		-1,
		203,
		-1,
		-1,
		125,
		-1,
		-1,
		-1,
		96,
		91,
		64,
		52,
		58,
		54,
		40,
		46,
		48,
		56,
		54,
		51,
		63,
		59,
		79,
		74,
		107,
		-1,
		198,
		-1,
		132,
		-1,
		-1,
		114,
		94,
		86,
		75,
		64,
		62,
		53,
		44,
		66,
		82,
		66,
		64,
		69,
		74,
		-1,
		187,
		186,
		-1,
		133,
		125,
		111,
		-1,
		104,
		-1,
		110,
		71,
		-1,
		73,
		53,
		-1,
		75,
		71,
		-1,
		-1,
		174,
		149,
		-1,
		-1,
		-1,
		134,
		114,
		105,
		89,
		-1,
		64,
		64,
		-1,
		-1,
		-1,
		159,
		158,
		-1,
		127,
		130,
		-1,
		120,
		111,
		119,
		66,
		70,
		-1,
		-1,
		-1,
		168,
		149,
		143,
		142,
		140,
		135,
		132,
		118,
		102,
		80,
		69,
		90,
		-1,
		-1,
		-1,
		140,
		132,
		125,
		-1,
		-1,
		127,
		110,
		91,
		89,
		-1,
		-1,
		-1,
		162,
		143,
		-1,
		-1,
		117,
		-1,
		-1,
		123,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		151,
		-1,
		-1,
		-1,
		113,
		109,
		110,
		-1,
		-1,
		-1,
		-1,
		173,
		174,
		197,
		161,
		-1,
		-1,
		-1,
		105,
		99,
		-1,
		-1,
		176,
		174,
		-1,
		-1,
		-1,
		133,
		117,
		-1,
		103,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		138,
		-1,
		138,
		113,
		120,
		-1,
		-1,
		-1,
		-1,
		151,
		143,
		151,
		-1,
		123,
		125,
		-1,
		173,
		-1,
		-1,
		166,
		157,
		-1,
		-1,
		128,
		135,
		157,
		160,
		196,
		-1,
		147
	],
	[
		-1,
		248,
		237,
		248,
		256,
		229,
		236,
		-1,
		255,
		259,
		225,
		219,
		258,
		227,
		233,
		244,
		-1,
		-1,
		-1,
		248,
		247,
		215,
		213,
		222,
		227,
		234,
		-1,
		233,
		-1,
		269,
		248,
		259,
		264,
		208,
		205,
		225,
		244,
		226,
		218,
		284,
		238,
		209,
		203,
		221,
		211,
		220,
		212,
		-1,
		209,
		199,
		221,
		200,
		211,
		203,
		-1,
		-1,
		203,
		204,
		210,
		196,
		202,
		198,
		-1,
		208,
		192,
		-1,
		-1,
		193,
		194,
		178,
		181,
		189,
		187,
		200,
		192,
		187,
		-1,
		-1,
		184,
		180,
		187,
		174,
		170,
		187,
		200,
		182,
		196,
		195,
		-1,
		188,
		206,
		213,
		181,
		179,
		163,
		161,
		179,
		181,
		187,
		187,
		-1,
		197,
		198,
		193,
		201,
		203,
		179,
		166,
		166,
		176,
		169,
		188,
		176,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		197,
		180,
		197,
		189,
		179,
		194,
		187,
		169,
		166,
		164,
		161,
		177,
		175,
		185,
		-1,
		-1,
		290,
		259,
		288,
		246,
		227,
		-1,
		193,
		173,
		179,
		183,
		177,
		170,
		184,
		180,
		-1,
		155,
		154,
		182,
		168,
		179,
		250,
		-1,
		-1,
		248,
		240,
		223,
		226,
		203,
		199,
		188,
		187,
		179,
		165,
		161,
		167,
		170,
		170,
		176,
		149,
		159,
		163,
		161,
		186,
		-1,
		-1,
		221,
		-1,
		-1,
		247,
		230,
		-1,
		213,
		220,
		209,
		215,
		201,
		222,
		198,
		189,
		181,
		175,
		163,
		165,
		162,
		175,
		163,
		146,
		171,
		175,
		156,
		177,
		172,
		-1,
		220,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		206,
		209,
		215,
		239,
		238,
		-1,
		210,
		198,
		199,
		184,
		181,
		168,
		156,
		169,
		154,
		161,
		160,
		150,
		148,
		178,
		153,
		175,
		172,
		191,
		196,
		190,
		199,
		-1,
		255,
		251,
		247,
		254,
		203,
		-1,
		-1,
		243,
		-1,
		246,
		247,
		222,
		195,
		198,
		185,
		176,
		163,
		152,
		163,
		152,
		149,
		157,
		142,
		157,
		148,
		147,
		165,
		175,
		183,
		187,
		193,
		-1,
		305,
		-1,
		247,
		231,
		233,
		205,
		226,
		-1,
		263,
		247,
		239,
		224,
		224,
		-1,
		194,
		191,
		181,
		159,
		144,
		161,
		153,
		151,
		155,
		137,
		151,
		142,
		160,
		167,
		165,
		169,
		189,
		201,
		265,
		255,
		-1,
		237,
		242,
		201,
		209,
		228,
		266,
		230,
		-1,
		225,
		-1,
		196,
		209,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		148,
		133,
		130,
		148,
		151,
		158,
		162,
		178,
		-1,
		-1,
		250,
		254,
		243,
		194,
		213,
		237,
		274,
		223,
		212,
		211,
		-1,
		202,
		179,
		176,
		164,
		151,
		136,
		137,
		145,
		158,
		137,
		132,
		129,
		149,
		175,
		153,
		165,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		220,
		191,
		215,
		257,
		241,
		234,
		222,
		187,
		187,
		181,
		-1,
		175,
		154,
		145,
		134,
		132,
		145,
		142,
		147,
		127,
		125,
		144,
		156,
		147,
		164,
		-1,
		-1,
		-1,
		250,
		239,
		240,
		186,
		209,
		246,
		220,
		206,
		211,
		186,
		179,
		173,
		188,
		171,
		152,
		141,
		133,
		122,
		138,
		146,
		141,
		123,
		132,
		138,
		162,
		152,
		158,
		-1,
		-1,
		257,
		247,
		231,
		233,
		230,
		200,
		207,
		239,
		211,
		224,
		-1,
		178,
		-1,
		167,
		162,
		146,
		141,
		138,
		135,
		129,
		138,
		140,
		130,
		125,
		132,
		167,
		167,
		142,
		162,
		165,
		-1,
		-1,
		-1,
		250,
		245,
		220,
		197,
		181,
		217,
		-1,
		194,
		195,
		-1,
		172,
		166,
		163,
		148,
		144,
		139,
		143,
		136,
		143,
		136,
		134,
		135,
		117,
		149,
		-1,
		150,
		144,
		152,
		142,
		130,
		-1,
		-1,
		-1,
		243,
		222,
		215,
		235,
		176,
		228,
		-1,
		-1,
		179,
		172,
		-1,
		159,
		141,
		148,
		146,
		140,
		144,
		141,
		130,
		143,
		136,
		122,
		124,
		137,
		141,
		145,
		132,
		128,
		125,
		139,
		-1,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		196,
		-1,
		188,
		180,
		170,
		164,
		158,
		154,
		152,
		168,
		152,
		155,
		153,
		144,
		152,
		125,
		118,
		125,
		114,
		132,
		140,
		132,
		126,
		125,
		135,
		-1,
		263,
		249,
		220,
		-1,
		-1,
		209,
		-1,
		173,
		187,
		203,
		-1,
		196,
		175,
		190,
		168,
		164,
		160,
		175,
		176,
		154,
		153,
		151,
		142,
		130,
		119,
		122,
		114,
		136,
		136,
		120,
		121,
		125,
		-1,
		269,
		256,
		214,
		210,
		199,
		219,
		170,
		158,
		190,
		-1,
		-1,
		232,
		-1,
		166,
		183,
		174,
		172,
		165,
		150,
		157,
		162,
		139,
		134,
		124,
		113,
		113,
		108,
		130,
		116,
		114,
		123,
		139,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		185,
		172,
		166,
		-1,
		207,
		-1,
		210,
		200,
		184,
		169,
		202,
		-1,
		149,
		145,
		152,
		-1,
		159,
		-1,
		132,
		129,
		120,
		105,
		102,
		113,
		111,
		122,
		118,
		-1,
		219,
		204,
		197,
		187,
		201,
		172,
		-1,
		227,
		-1,
		-1,
		197,
		191,
		191,
		175,
		178,
		165,
		145,
		137,
		152,
		151,
		138,
		137,
		118,
		111,
		108,
		101,
		114,
		124,
		129,
		116,
		-1,
		-1,
		-1,
		224,
		210,
		214,
		174,
		193,
		-1,
		-1,
		259,
		214,
		200,
		-1,
		174,
		165,
		153,
		143,
		133,
		138,
		139,
		129,
		127,
		116,
		118,
		112,
		103,
		102,
		118,
		110,
		132,
		-1,
		-1,
		207,
		212,
		200,
		186,
		205,
		-1,
		-1,
		-1,
		206,
		222,
		193,
		172,
		154,
		-1,
		-1,
		137,
		130,
		124,
		127,
		115,
		132,
		127,
		111,
		96,
		111,
		115,
		123,
		114,
		-1,
		210,
		197,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		-1,
		-1,
		205,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		121,
		114,
		133,
		140,
		113,
		98,
		92,
		98,
		110,
		119,
		-1,
		-1,
		222,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		127,
		120,
		124,
		-1,
		112,
		114,
		111,
		123,
		116,
		113,
		104,
		95,
		91,
		95,
		99,
		113,
		117,
		245,
		-1,
		183,
		-1,
		-1,
		-1,
		180,
		195,
		166,
		143,
		116,
		111,
		104,
		98,
		103,
		114,
		123,
		134,
		99,
		98,
		88,
		87,
		91,
		108,
		112,
		-1,
		-1,
		181,
		177,
		206,
		188,
		192,
		193,
		-1,
		-1,
		120,
		111,
		102,
		94,
		107,
		110,
		95,
		97,
		97,
		92,
		86,
		96,
		111,
		106,
		-1,
		-1,
		-1,
		193,
		-1,
		195,
		-1,
		-1,
		183,
		191,
		138,
		120,
		116,
		114,
		101,
		95,
		85,
		90,
		100,
		94,
		91,
		82,
		86,
		109,
		98,
		137,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		172,
		164,
		159,
		165,
		167,
		158,
		153,
		150,
		-1,
		120,
		124,
		91,
		98,
		81,
		88,
		93,
		90,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		165,
		161,
		151,
		141,
		144,
		-1,
		-1,
		138,
		135,
		115,
		84,
		89,
		82,
		77,
		82,
		63,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		212,
		249,
		242,
		210,
		218,
		249,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		111,
		102,
		103,
		91,
		88,
		101,
		100,
		67,
		72,
		90,
		77,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		205,
		225,
		204,
		207,
		231,
		245,
		-1,
		152,
		-1,
		-1,
		163,
		136,
		120,
		110,
		107,
		150,
		97,
		92,
		69,
		67,
		64,
		55,
		93,
		72,
		84,
		87,
		103,
		108,
		100,
		116,
		116,
		117,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		153,
		-1,
		147,
		-1,
		130,
		134,
		105,
		108,
		83,
		70,
		56,
		64,
		70,
		70,
		75,
		78,
		90,
		99,
		110,
		122,
		123,
		124,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		164,
		203,
		159,
		-1,
		143,
		-1,
		-1,
		-1,
		137,
		118,
		110,
		103,
		82,
		82,
		48,
		52,
		65,
		72,
		82,
		96,
		93,
		103,
		116,
		127,
		132,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		179,
		170,
		197,
		166,
		155,
		150,
		137,
		-1,
		-1,
		115,
		128,
		-1,
		-1,
		89,
		56,
		44,
		54,
		58,
		72,
		84,
		97,
		85,
		104,
		98,
		130,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		198,
		188,
		192,
		197,
		222,
		-1,
		126,
		-1,
		-1,
		95,
		-1,
		-1,
		76,
		61,
		50,
		41,
		46,
		66,
		77,
		99,
		81,
		98,
		103,
		113,
		126,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		192,
		211,
		-1,
		-1,
		142,
		122,
		-1,
		-1,
		78,
		76,
		61,
		-1,
		50,
		38,
		43,
		73,
		75,
		77,
		84,
		78,
		85,
		111,
		123,
		125,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		132,
		128,
		-1,
		-1,
		73,
		66,
		54,
		42,
		33,
		40,
		60,
		60,
		63,
		68,
		76,
		87,
		101,
		105,
		119,
		-1,
		235,
		-1,
		187,
		163,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		149,
		135,
		128,
		116,
		114,
		-1,
		107,
		91,
		72,
		-1,
		18,
		0,
		96,
		64,
		69,
		64,
		82,
		93,
		104,
		107,
		112,
		115,
		-1,
		-1,
		175,
		165,
		-1,
		-1,
		139,
		141,
		-1,
		140,
		129,
		114,
		106,
		-1,
		-1,
		79,
		75,
		-1,
		-1,
		44,
		78,
		67,
		75,
		70,
		82,
		92,
		90,
		102,
		110,
		109,
		-1,
		-1,
		160,
		152,
		146,
		-1,
		124,
		-1,
		142,
		-1,
		109,
		115,
		103,
		-1,
		-1,
		-1,
		82,
		45,
		66,
		85,
		90,
		88,
		79,
		78,
		85,
		95,
		103,
		109,
		-1,
		-1,
		-1,
		142,
		116,
		149,
		140,
		123,
		103,
		95,
		114,
		-1,
		81,
		-1,
		49,
		46,
		87,
		84,
		101,
		95,
		81,
		96,
		92,
		101,
		99,
		148,
		-1,
		118,
		151,
		115,
		109,
		85,
		89,
		105,
		-1,
		78,
		57,
		-1,
		91,
		81,
		118,
		104,
		92,
		79,
		86,
		100,
		96,
		-1,
		-1,
		-1,
		120,
		119,
		111,
		105,
		105,
		90,
		81,
		-1,
		93,
		75,
		54,
		71,
		71,
		62,
		70,
		108,
		104,
		97,
		99,
		91,
		-1,
		221,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		114,
		109,
		82,
		70,
		76,
		72,
		58,
		64,
		66,
		74,
		72,
		69,
		81,
		77,
		97,
		92,
		125,
		-1,
		216,
		-1,
		150,
		-1,
		-1,
		132,
		112,
		104,
		93,
		82,
		80,
		71,
		62,
		84,
		100,
		84,
		82,
		87,
		92,
		-1,
		205,
		204,
		-1,
		151,
		143,
		129,
		-1,
		122,
		-1,
		128,
		89,
		-1,
		91,
		71,
		-1,
		93,
		89,
		-1,
		-1,
		192,
		167,
		-1,
		-1,
		-1,
		152,
		132,
		123,
		107,
		-1,
		82,
		82,
		-1,
		-1,
		-1,
		177,
		176,
		-1,
		145,
		148,
		-1,
		138,
		129,
		137,
		84,
		88,
		-1,
		-1,
		-1,
		186,
		167,
		161,
		160,
		158,
		153,
		150,
		136,
		120,
		98,
		87,
		108,
		-1,
		-1,
		-1,
		158,
		150,
		143,
		-1,
		-1,
		145,
		128,
		109,
		107,
		-1,
		-1,
		-1,
		180,
		161,
		-1,
		-1,
		135,
		-1,
		-1,
		141,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		169,
		-1,
		-1,
		-1,
		131,
		127,
		128,
		-1,
		-1,
		-1,
		-1,
		191,
		192,
		215,
		179,
		-1,
		-1,
		-1,
		123,
		117,
		-1,
		-1,
		194,
		192,
		-1,
		-1,
		-1,
		151,
		135,
		-1,
		121,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		156,
		-1,
		156,
		131,
		138,
		-1,
		-1,
		-1,
		-1,
		169,
		161,
		169,
		-1,
		141,
		143,
		-1,
		191,
		-1,
		-1,
		184,
		175,
		-1,
		-1,
		146,
		153,
		175,
		178,
		214,
		-1,
		165
	],
	[
		-1,
		269,
		258,
		269,
		277,
		250,
		257,
		-1,
		276,
		280,
		246,
		240,
		279,
		248,
		254,
		265,
		-1,
		-1,
		-1,
		269,
		268,
		236,
		234,
		243,
		248,
		255,
		-1,
		254,
		-1,
		290,
		269,
		280,
		285,
		229,
		226,
		246,
		265,
		247,
		239,
		305,
		259,
		230,
		224,
		242,
		232,
		241,
		233,
		-1,
		230,
		220,
		242,
		221,
		232,
		224,
		-1,
		-1,
		224,
		225,
		231,
		217,
		223,
		219,
		-1,
		229,
		213,
		-1,
		-1,
		214,
		215,
		199,
		202,
		210,
		208,
		221,
		213,
		208,
		-1,
		-1,
		205,
		201,
		208,
		195,
		191,
		208,
		221,
		203,
		217,
		216,
		-1,
		209,
		227,
		234,
		202,
		200,
		184,
		182,
		200,
		202,
		208,
		208,
		-1,
		218,
		219,
		214,
		222,
		224,
		200,
		187,
		187,
		197,
		190,
		209,
		197,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		218,
		201,
		218,
		210,
		200,
		215,
		208,
		190,
		187,
		185,
		182,
		198,
		196,
		206,
		-1,
		-1,
		311,
		280,
		309,
		267,
		248,
		-1,
		214,
		194,
		200,
		204,
		198,
		191,
		205,
		201,
		-1,
		176,
		175,
		203,
		189,
		200,
		271,
		-1,
		-1,
		269,
		261,
		244,
		247,
		224,
		220,
		209,
		208,
		200,
		186,
		182,
		188,
		191,
		191,
		197,
		170,
		180,
		184,
		182,
		207,
		-1,
		-1,
		242,
		-1,
		-1,
		268,
		251,
		-1,
		234,
		241,
		230,
		236,
		222,
		243,
		219,
		210,
		202,
		196,
		184,
		186,
		183,
		196,
		184,
		167,
		192,
		196,
		177,
		198,
		193,
		-1,
		241,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		227,
		230,
		236,
		260,
		259,
		-1,
		231,
		219,
		220,
		205,
		202,
		189,
		177,
		190,
		175,
		182,
		181,
		171,
		169,
		199,
		174,
		196,
		193,
		212,
		217,
		211,
		220,
		-1,
		276,
		272,
		268,
		275,
		224,
		-1,
		-1,
		264,
		-1,
		267,
		268,
		243,
		216,
		219,
		206,
		197,
		184,
		173,
		184,
		173,
		170,
		178,
		163,
		178,
		169,
		168,
		186,
		196,
		204,
		208,
		214,
		-1,
		326,
		-1,
		268,
		252,
		254,
		226,
		247,
		-1,
		284,
		268,
		260,
		245,
		245,
		-1,
		215,
		212,
		202,
		180,
		165,
		182,
		174,
		172,
		176,
		158,
		172,
		163,
		181,
		188,
		186,
		190,
		210,
		222,
		286,
		276,
		-1,
		258,
		263,
		222,
		230,
		249,
		287,
		251,
		-1,
		246,
		-1,
		217,
		230,
		-1,
		186,
		182,
		164,
		165,
		160,
		175,
		169,
		154,
		151,
		169,
		172,
		179,
		183,
		199,
		-1,
		-1,
		271,
		275,
		264,
		215,
		234,
		258,
		295,
		244,
		233,
		232,
		-1,
		223,
		200,
		197,
		185,
		172,
		157,
		158,
		166,
		179,
		158,
		153,
		150,
		170,
		196,
		174,
		186,
		-1,
		-1,
		-1,
		296,
		-1,
		-1,
		241,
		212,
		236,
		278,
		262,
		255,
		243,
		208,
		208,
		202,
		-1,
		196,
		175,
		166,
		155,
		153,
		166,
		163,
		168,
		148,
		146,
		165,
		177,
		168,
		185,
		-1,
		-1,
		-1,
		271,
		260,
		261,
		207,
		230,
		267,
		241,
		227,
		232,
		207,
		200,
		194,
		209,
		192,
		173,
		162,
		154,
		143,
		159,
		167,
		162,
		144,
		153,
		159,
		183,
		173,
		179,
		-1,
		-1,
		278,
		268,
		252,
		254,
		251,
		221,
		228,
		260,
		232,
		245,
		-1,
		199,
		-1,
		188,
		183,
		167,
		162,
		159,
		156,
		150,
		159,
		161,
		151,
		146,
		153,
		188,
		188,
		163,
		183,
		186,
		-1,
		-1,
		-1,
		271,
		266,
		241,
		218,
		202,
		238,
		-1,
		215,
		216,
		-1,
		193,
		187,
		184,
		169,
		165,
		160,
		164,
		157,
		164,
		157,
		155,
		156,
		138,
		170,
		-1,
		171,
		165,
		173,
		163,
		151,
		-1,
		-1,
		-1,
		264,
		243,
		236,
		256,
		197,
		249,
		-1,
		-1,
		200,
		193,
		-1,
		180,
		162,
		169,
		167,
		161,
		165,
		162,
		151,
		164,
		157,
		143,
		145,
		158,
		162,
		166,
		153,
		149,
		146,
		160,
		-1,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		217,
		-1,
		209,
		201,
		191,
		185,
		179,
		175,
		173,
		189,
		173,
		176,
		174,
		165,
		173,
		146,
		139,
		146,
		135,
		153,
		161,
		153,
		147,
		146,
		156,
		-1,
		284,
		270,
		241,
		-1,
		-1,
		230,
		-1,
		194,
		208,
		224,
		-1,
		217,
		196,
		211,
		189,
		185,
		181,
		196,
		197,
		175,
		174,
		172,
		163,
		151,
		140,
		143,
		135,
		157,
		157,
		141,
		142,
		146,
		-1,
		290,
		277,
		235,
		231,
		220,
		240,
		191,
		179,
		211,
		-1,
		-1,
		253,
		-1,
		187,
		204,
		195,
		193,
		186,
		171,
		178,
		183,
		160,
		155,
		145,
		134,
		134,
		129,
		151,
		137,
		135,
		144,
		160,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		206,
		193,
		187,
		-1,
		228,
		-1,
		231,
		221,
		205,
		190,
		223,
		-1,
		170,
		166,
		173,
		-1,
		180,
		-1,
		153,
		150,
		141,
		126,
		123,
		134,
		132,
		143,
		139,
		-1,
		240,
		225,
		218,
		208,
		222,
		193,
		-1,
		248,
		-1,
		-1,
		218,
		212,
		212,
		196,
		199,
		186,
		166,
		158,
		173,
		172,
		159,
		158,
		139,
		132,
		129,
		122,
		135,
		145,
		150,
		137,
		-1,
		-1,
		-1,
		245,
		231,
		235,
		195,
		214,
		-1,
		-1,
		280,
		235,
		221,
		-1,
		195,
		186,
		174,
		164,
		154,
		159,
		160,
		150,
		148,
		137,
		139,
		133,
		124,
		123,
		139,
		131,
		153,
		-1,
		-1,
		228,
		233,
		221,
		207,
		226,
		-1,
		-1,
		-1,
		227,
		243,
		214,
		193,
		175,
		-1,
		-1,
		158,
		151,
		145,
		148,
		136,
		153,
		148,
		132,
		117,
		132,
		136,
		144,
		135,
		-1,
		231,
		218,
		-1,
		-1,
		229,
		223,
		-1,
		-1,
		-1,
		-1,
		226,
		171,
		160,
		155,
		159,
		157,
		-1,
		131,
		142,
		135,
		154,
		161,
		134,
		119,
		113,
		119,
		131,
		140,
		-1,
		-1,
		243,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		183,
		177,
		148,
		141,
		145,
		-1,
		133,
		135,
		132,
		144,
		137,
		134,
		125,
		116,
		112,
		116,
		120,
		134,
		138,
		266,
		-1,
		204,
		-1,
		-1,
		-1,
		201,
		216,
		187,
		164,
		137,
		132,
		125,
		119,
		124,
		135,
		144,
		155,
		120,
		119,
		109,
		108,
		112,
		129,
		133,
		-1,
		-1,
		202,
		198,
		227,
		209,
		213,
		214,
		-1,
		-1,
		141,
		132,
		123,
		115,
		128,
		131,
		116,
		118,
		118,
		113,
		107,
		117,
		132,
		127,
		-1,
		-1,
		-1,
		214,
		-1,
		216,
		-1,
		-1,
		204,
		212,
		159,
		141,
		137,
		135,
		122,
		116,
		106,
		111,
		121,
		115,
		112,
		103,
		107,
		130,
		119,
		139,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		193,
		185,
		180,
		186,
		188,
		179,
		174,
		171,
		-1,
		141,
		145,
		112,
		119,
		102,
		109,
		114,
		111,
		97,
		104,
		120,
		119,
		114,
		131,
		122,
		126,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		186,
		182,
		172,
		162,
		165,
		-1,
		-1,
		159,
		156,
		136,
		105,
		110,
		103,
		98,
		103,
		84,
		93,
		97,
		95,
		107,
		112,
		117,
		110,
		117,
		132,
		-1,
		233,
		270,
		263,
		231,
		239,
		270,
		-1,
		176,
		168,
		179,
		154,
		156,
		-1,
		-1,
		132,
		123,
		124,
		112,
		109,
		122,
		121,
		88,
		85,
		107,
		90,
		99,
		111,
		103,
		107,
		108,
		115,
		126,
		130,
		-1,
		226,
		246,
		225,
		228,
		252,
		266,
		-1,
		173,
		-1,
		-1,
		185,
		157,
		141,
		131,
		128,
		171,
		118,
		113,
		90,
		88,
		85,
		76,
		106,
		85,
		89,
		86,
		95,
		100,
		92,
		118,
		120,
		126,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		183,
		-1,
		168,
		-1,
		151,
		155,
		126,
		129,
		104,
		91,
		77,
		77,
		83,
		83,
		88,
		91,
		82,
		91,
		102,
		114,
		124,
		126,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		185,
		224,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		165,
		139,
		131,
		124,
		103,
		103,
		69,
		65,
		78,
		85,
		95,
		99,
		83,
		95,
		108,
		119,
		134,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		200,
		191,
		218,
		196,
		185,
		180,
		167,
		-1,
		-1,
		146,
		149,
		-1,
		-1,
		110,
		86,
		73,
		67,
		71,
		85,
		97,
		95,
		75,
		95,
		90,
		122,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		219,
		209,
		213,
		227,
		252,
		-1,
		156,
		-1,
		-1,
		126,
		-1,
		-1,
		111,
		91,
		80,
		71,
		57,
		79,
		90,
		112,
		71,
		88,
		95,
		105,
		118,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		185,
		183,
		189,
		196,
		213,
		241,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		68,
		54,
		81,
		65,
		67,
		74,
		68,
		75,
		101,
		114,
		115,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		68,
		54,
		44,
		53,
		58,
		66,
		77,
		91,
		95,
		109,
		-1,
		256,
		-1,
		208,
		184,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		0,
		42,
		59,
		54,
		72,
		83,
		94,
		97,
		102,
		105,
		-1,
		-1,
		196,
		195,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		74,
		46,
		45,
		65,
		60,
		72,
		82,
		80,
		92,
		100,
		99,
		-1,
		-1,
		190,
		182,
		176,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		112,
		75,
		96,
		53,
		62,
		66,
		69,
		68,
		75,
		85,
		93,
		99,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		111,
		-1,
		79,
		76,
		67,
		54,
		89,
		83,
		71,
		86,
		82,
		91,
		89,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		135,
		-1,
		108,
		87,
		-1,
		105,
		74,
		106,
		92,
		82,
		69,
		76,
		90,
		86,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		123,
		105,
		84,
		101,
		101,
		92,
		92,
		96,
		92,
		87,
		89,
		81,
		-1,
		251,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		139,
		112,
		100,
		106,
		102,
		88,
		94,
		96,
		95,
		89,
		93,
		108,
		99,
		103,
		82,
		118,
		-1,
		246,
		-1,
		180,
		-1,
		-1,
		162,
		142,
		134,
		123,
		112,
		110,
		101,
		92,
		114,
		130,
		106,
		94,
		89,
		90,
		-1,
		235,
		234,
		-1,
		181,
		173,
		159,
		-1,
		152,
		-1,
		158,
		119,
		-1,
		121,
		101,
		-1,
		105,
		94,
		-1,
		-1,
		222,
		197,
		-1,
		-1,
		-1,
		182,
		162,
		153,
		137,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		207,
		206,
		-1,
		175,
		178,
		-1,
		168,
		159,
		167,
		114,
		118,
		-1,
		-1,
		-1,
		216,
		197,
		191,
		190,
		188,
		183,
		180,
		166,
		150,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		188,
		180,
		173,
		-1,
		-1,
		175,
		158,
		139,
		137,
		-1,
		-1,
		-1,
		210,
		191,
		-1,
		-1,
		165,
		-1,
		-1,
		171,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		199,
		-1,
		-1,
		-1,
		161,
		157,
		158,
		-1,
		-1,
		-1,
		-1,
		221,
		222,
		245,
		209,
		-1,
		-1,
		-1,
		153,
		147,
		-1,
		-1,
		224,
		222,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		151,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		186,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		176,
		183,
		205,
		208,
		244,
		-1,
		195
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		178,
		196,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		187,
		188,
		183,
		191,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		170,
		187,
		179,
		169,
		184,
		177,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		280,
		249,
		278,
		236,
		217,
		-1,
		183,
		163,
		169,
		173,
		167,
		160,
		174,
		170,
		-1,
		145,
		144,
		172,
		158,
		169,
		240,
		-1,
		-1,
		238,
		230,
		213,
		216,
		193,
		189,
		178,
		177,
		169,
		155,
		151,
		157,
		160,
		160,
		166,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		211,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		199,
		205,
		191,
		212,
		188,
		179,
		171,
		165,
		153,
		155,
		152,
		165,
		153,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		228,
		-1,
		200,
		188,
		189,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		140,
		138,
		168,
		143,
		165,
		162,
		181,
		186,
		180,
		189,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		236,
		237,
		212,
		185,
		188,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		132,
		147,
		138,
		137,
		155,
		165,
		173,
		177,
		183,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		237,
		229,
		214,
		214,
		-1,
		184,
		181,
		171,
		149,
		134,
		151,
		143,
		141,
		145,
		127,
		141,
		132,
		150,
		157,
		155,
		159,
		179,
		191,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		186,
		199,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		138,
		123,
		120,
		138,
		141,
		148,
		152,
		168,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		169,
		166,
		154,
		141,
		126,
		127,
		135,
		148,
		127,
		122,
		119,
		139,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		165,
		144,
		135,
		124,
		122,
		135,
		132,
		137,
		117,
		115,
		134,
		146,
		137,
		154,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		178,
		161,
		142,
		131,
		123,
		112,
		128,
		136,
		131,
		113,
		122,
		128,
		152,
		142,
		148,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		152,
		136,
		131,
		128,
		125,
		119,
		128,
		130,
		120,
		115,
		122,
		157,
		157,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		138,
		134,
		129,
		133,
		126,
		133,
		126,
		124,
		125,
		107,
		139,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		138,
		136,
		130,
		134,
		131,
		120,
		133,
		126,
		112,
		114,
		127,
		131,
		135,
		122,
		118,
		115,
		129,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		158,
		142,
		145,
		143,
		134,
		142,
		115,
		108,
		115,
		104,
		122,
		130,
		122,
		116,
		115,
		125,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		150,
		165,
		166,
		144,
		143,
		141,
		132,
		120,
		109,
		112,
		104,
		126,
		126,
		110,
		111,
		115,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		164,
		162,
		155,
		140,
		147,
		152,
		129,
		124,
		114,
		103,
		103,
		98,
		120,
		106,
		104,
		113,
		129,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		139,
		135,
		142,
		-1,
		149,
		-1,
		122,
		119,
		110,
		95,
		92,
		103,
		101,
		112,
		108,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		155,
		135,
		127,
		142,
		141,
		128,
		127,
		108,
		101,
		98,
		91,
		104,
		114,
		119,
		106,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		164,
		155,
		143,
		133,
		123,
		128,
		129,
		119,
		117,
		106,
		108,
		102,
		93,
		92,
		108,
		100,
		122,
		-1,
		-1,
		197,
		202,
		190,
		176,
		195,
		-1,
		-1,
		-1,
		196,
		212,
		183,
		162,
		144,
		-1,
		-1,
		127,
		120,
		114,
		117,
		105,
		122,
		117,
		101,
		86,
		101,
		105,
		113,
		104,
		-1,
		200,
		187,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		-1,
		-1,
		195,
		140,
		129,
		124,
		128,
		126,
		-1,
		100,
		111,
		104,
		123,
		130,
		103,
		88,
		82,
		88,
		100,
		109,
		-1,
		-1,
		212,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		152,
		146,
		117,
		110,
		114,
		-1,
		102,
		104,
		101,
		113,
		106,
		103,
		94,
		85,
		81,
		85,
		89,
		103,
		107,
		235,
		-1,
		173,
		-1,
		-1,
		-1,
		170,
		185,
		156,
		133,
		106,
		101,
		94,
		88,
		93,
		104,
		113,
		124,
		89,
		88,
		78,
		77,
		81,
		98,
		102,
		-1,
		-1,
		171,
		167,
		196,
		178,
		182,
		183,
		-1,
		-1,
		110,
		101,
		92,
		84,
		97,
		100,
		85,
		87,
		87,
		82,
		76,
		86,
		101,
		96,
		-1,
		-1,
		-1,
		183,
		-1,
		185,
		-1,
		-1,
		173,
		181,
		128,
		110,
		106,
		104,
		91,
		85,
		75,
		80,
		90,
		84,
		81,
		72,
		76,
		99,
		88,
		108,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		162,
		154,
		149,
		155,
		157,
		148,
		143,
		140,
		-1,
		110,
		114,
		81,
		88,
		71,
		78,
		83,
		80,
		66,
		73,
		89,
		88,
		83,
		100,
		91,
		95,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		155,
		151,
		141,
		131,
		134,
		-1,
		-1,
		128,
		125,
		105,
		74,
		79,
		72,
		67,
		72,
		53,
		62,
		66,
		64,
		76,
		81,
		86,
		79,
		86,
		101,
		-1,
		202,
		239,
		232,
		200,
		208,
		239,
		-1,
		145,
		137,
		148,
		123,
		125,
		-1,
		-1,
		101,
		92,
		93,
		81,
		78,
		91,
		90,
		57,
		54,
		76,
		59,
		68,
		80,
		72,
		76,
		77,
		84,
		95,
		99,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		142,
		-1,
		-1,
		154,
		126,
		110,
		100,
		97,
		140,
		87,
		82,
		59,
		57,
		54,
		45,
		75,
		54,
		58,
		55,
		64,
		69,
		61,
		87,
		89,
		95,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		152,
		-1,
		137,
		-1,
		120,
		124,
		95,
		98,
		73,
		60,
		46,
		46,
		52,
		52,
		57,
		60,
		51,
		60,
		71,
		83,
		93,
		95,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		154,
		193,
		158,
		-1,
		142,
		-1,
		-1,
		-1,
		134,
		108,
		100,
		93,
		72,
		72,
		38,
		34,
		47,
		54,
		64,
		68,
		52,
		64,
		77,
		88,
		103,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		169,
		160,
		187,
		165,
		154,
		149,
		136,
		-1,
		-1,
		115,
		118,
		-1,
		-1,
		79,
		55,
		42,
		36,
		40,
		54,
		66,
		64,
		44,
		64,
		59,
		91,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		167,
		188,
		178,
		182,
		196,
		221,
		-1,
		125,
		-1,
		-1,
		95,
		-1,
		-1,
		80,
		60,
		49,
		40,
		26,
		48,
		59,
		81,
		40,
		57,
		64,
		74,
		87,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		154,
		152,
		158,
		165,
		182,
		210,
		-1,
		-1,
		141,
		121,
		-1,
		-1,
		78,
		76,
		65,
		-1,
		55,
		37,
		23,
		47,
		34,
		36,
		43,
		37,
		44,
		70,
		83,
		84,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		131,
		127,
		-1,
		-1,
		73,
		66,
		54,
		42,
		32,
		37,
		20,
		9,
		22,
		27,
		35,
		46,
		60,
		64,
		78,
		-1,
		225,
		-1,
		177,
		153,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		148,
		134,
		127,
		115,
		113,
		-1,
		107,
		91,
		72,
		-1,
		42,
		55,
		43,
		0,
		28,
		23,
		41,
		52,
		63,
		66,
		71,
		74,
		-1,
		-1,
		165,
		164,
		-1,
		-1,
		138,
		140,
		-1,
		139,
		128,
		113,
		105,
		-1,
		-1,
		79,
		75,
		-1,
		-1,
		43,
		17,
		3,
		34,
		29,
		41,
		51,
		49,
		61,
		69,
		68,
		-1,
		-1,
		159,
		151,
		145,
		-1,
		123,
		-1,
		141,
		-1,
		108,
		114,
		102,
		-1,
		-1,
		-1,
		81,
		44,
		65,
		24,
		31,
		35,
		38,
		37,
		44,
		54,
		62,
		68,
		-1,
		-1,
		-1,
		141,
		115,
		148,
		139,
		122,
		102,
		94,
		113,
		-1,
		80,
		-1,
		48,
		45,
		38,
		23,
		58,
		52,
		40,
		55,
		51,
		60,
		58,
		147,
		-1,
		117,
		150,
		114,
		108,
		84,
		88,
		104,
		-1,
		77,
		56,
		-1,
		76,
		45,
		75,
		61,
		51,
		38,
		45,
		59,
		55,
		-1,
		-1,
		-1,
		119,
		118,
		110,
		104,
		104,
		89,
		80,
		-1,
		92,
		74,
		53,
		70,
		70,
		61,
		63,
		65,
		61,
		56,
		58,
		50,
		-1,
		220,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		113,
		108,
		81,
		69,
		75,
		71,
		57,
		63,
		65,
		66,
		60,
		64,
		77,
		68,
		72,
		51,
		87,
		-1,
		215,
		-1,
		149,
		-1,
		-1,
		131,
		111,
		103,
		92,
		81,
		79,
		70,
		61,
		83,
		99,
		75,
		63,
		58,
		59,
		-1,
		204,
		203,
		-1,
		150,
		142,
		128,
		-1,
		121,
		-1,
		127,
		88,
		-1,
		90,
		70,
		-1,
		74,
		63,
		-1,
		-1,
		191,
		166,
		-1,
		-1,
		-1,
		151,
		131,
		122,
		106,
		-1,
		81,
		81,
		-1,
		-1,
		-1,
		176,
		175,
		-1,
		144,
		147,
		-1,
		137,
		128,
		136,
		83,
		87,
		-1,
		-1,
		-1,
		185,
		166,
		160,
		159,
		157,
		152,
		149,
		135,
		119,
		97,
		86,
		107,
		-1,
		-1,
		-1,
		157,
		149,
		142,
		-1,
		-1,
		144,
		127,
		108,
		106,
		-1,
		-1,
		-1,
		179,
		160,
		-1,
		-1,
		134,
		-1,
		-1,
		140,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		168,
		-1,
		-1,
		-1,
		130,
		126,
		127,
		-1,
		-1,
		-1,
		-1,
		190,
		191,
		214,
		178,
		-1,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		193,
		191,
		-1,
		-1,
		-1,
		150,
		134,
		-1,
		120,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		155,
		-1,
		155,
		130,
		137,
		-1,
		-1,
		-1,
		-1,
		168,
		160,
		168,
		-1,
		140,
		142,
		-1,
		190,
		-1,
		-1,
		183,
		174,
		-1,
		-1,
		145,
		152,
		174,
		177,
		213,
		-1,
		164
	],
	[
		-1,
		245,
		234,
		245,
		253,
		226,
		233,
		-1,
		252,
		256,
		222,
		216,
		255,
		224,
		230,
		241,
		-1,
		-1,
		-1,
		245,
		244,
		212,
		210,
		219,
		224,
		231,
		-1,
		230,
		-1,
		266,
		245,
		256,
		261,
		205,
		202,
		222,
		241,
		223,
		215,
		281,
		235,
		206,
		200,
		218,
		208,
		217,
		209,
		-1,
		206,
		196,
		218,
		197,
		208,
		200,
		-1,
		-1,
		200,
		201,
		207,
		193,
		199,
		195,
		-1,
		205,
		189,
		-1,
		-1,
		190,
		191,
		175,
		178,
		186,
		184,
		197,
		189,
		184,
		-1,
		-1,
		181,
		177,
		184,
		171,
		167,
		184,
		197,
		179,
		193,
		192,
		-1,
		185,
		203,
		210,
		178,
		176,
		160,
		158,
		176,
		178,
		184,
		184,
		-1,
		194,
		195,
		190,
		198,
		200,
		176,
		163,
		163,
		173,
		166,
		185,
		173,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		194,
		177,
		194,
		186,
		176,
		191,
		184,
		166,
		163,
		161,
		158,
		174,
		172,
		182,
		-1,
		-1,
		287,
		256,
		285,
		243,
		224,
		-1,
		190,
		170,
		176,
		180,
		174,
		167,
		181,
		177,
		-1,
		152,
		151,
		179,
		165,
		176,
		247,
		-1,
		-1,
		245,
		237,
		220,
		223,
		200,
		196,
		185,
		184,
		176,
		162,
		158,
		164,
		167,
		167,
		173,
		146,
		156,
		160,
		158,
		183,
		-1,
		-1,
		218,
		-1,
		-1,
		244,
		227,
		-1,
		210,
		217,
		206,
		212,
		198,
		219,
		195,
		186,
		178,
		172,
		160,
		162,
		159,
		172,
		160,
		143,
		168,
		172,
		153,
		174,
		169,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		203,
		206,
		212,
		236,
		235,
		-1,
		207,
		195,
		196,
		181,
		178,
		165,
		153,
		166,
		151,
		158,
		157,
		147,
		145,
		175,
		150,
		172,
		169,
		188,
		193,
		187,
		196,
		-1,
		252,
		248,
		244,
		251,
		200,
		-1,
		-1,
		240,
		-1,
		243,
		244,
		219,
		192,
		195,
		182,
		173,
		160,
		149,
		160,
		149,
		146,
		154,
		139,
		154,
		145,
		144,
		162,
		172,
		180,
		184,
		190,
		-1,
		302,
		-1,
		244,
		228,
		230,
		202,
		223,
		-1,
		260,
		244,
		236,
		221,
		221,
		-1,
		191,
		188,
		178,
		156,
		141,
		158,
		150,
		148,
		152,
		134,
		148,
		139,
		157,
		164,
		162,
		166,
		186,
		198,
		262,
		252,
		-1,
		234,
		239,
		198,
		206,
		225,
		263,
		227,
		-1,
		222,
		-1,
		193,
		206,
		-1,
		162,
		158,
		140,
		141,
		136,
		151,
		145,
		130,
		127,
		145,
		148,
		155,
		159,
		175,
		-1,
		-1,
		247,
		251,
		240,
		191,
		210,
		234,
		271,
		220,
		209,
		208,
		-1,
		199,
		176,
		173,
		161,
		148,
		133,
		134,
		142,
		155,
		134,
		129,
		126,
		146,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		217,
		188,
		212,
		254,
		238,
		231,
		219,
		184,
		184,
		178,
		-1,
		172,
		151,
		142,
		131,
		129,
		142,
		139,
		144,
		124,
		122,
		141,
		153,
		144,
		161,
		-1,
		-1,
		-1,
		247,
		236,
		237,
		183,
		206,
		243,
		217,
		203,
		208,
		183,
		176,
		170,
		185,
		168,
		149,
		138,
		130,
		119,
		135,
		143,
		138,
		120,
		129,
		135,
		159,
		149,
		155,
		-1,
		-1,
		254,
		244,
		228,
		230,
		227,
		197,
		204,
		236,
		208,
		221,
		-1,
		175,
		-1,
		164,
		159,
		143,
		138,
		135,
		132,
		126,
		135,
		137,
		127,
		122,
		129,
		164,
		164,
		139,
		159,
		162,
		-1,
		-1,
		-1,
		247,
		242,
		217,
		194,
		178,
		214,
		-1,
		191,
		192,
		-1,
		169,
		163,
		160,
		145,
		141,
		136,
		140,
		133,
		140,
		133,
		131,
		132,
		114,
		146,
		-1,
		147,
		141,
		149,
		139,
		127,
		-1,
		-1,
		-1,
		240,
		219,
		212,
		232,
		173,
		225,
		-1,
		-1,
		176,
		169,
		-1,
		156,
		138,
		145,
		143,
		137,
		141,
		138,
		127,
		140,
		133,
		119,
		121,
		134,
		138,
		142,
		129,
		125,
		122,
		136,
		-1,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		193,
		-1,
		185,
		177,
		167,
		161,
		155,
		151,
		149,
		165,
		149,
		152,
		150,
		141,
		149,
		122,
		115,
		122,
		111,
		129,
		137,
		129,
		123,
		122,
		132,
		-1,
		260,
		246,
		217,
		-1,
		-1,
		206,
		-1,
		170,
		184,
		200,
		-1,
		193,
		172,
		187,
		165,
		161,
		157,
		172,
		173,
		151,
		150,
		148,
		139,
		127,
		116,
		119,
		111,
		133,
		133,
		117,
		118,
		122,
		-1,
		266,
		253,
		211,
		207,
		196,
		216,
		167,
		155,
		187,
		-1,
		-1,
		229,
		-1,
		163,
		180,
		171,
		169,
		162,
		147,
		154,
		159,
		136,
		131,
		121,
		110,
		110,
		105,
		127,
		113,
		111,
		120,
		136,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		182,
		169,
		163,
		-1,
		204,
		-1,
		207,
		197,
		181,
		166,
		199,
		-1,
		146,
		142,
		149,
		-1,
		156,
		-1,
		129,
		126,
		117,
		102,
		99,
		110,
		108,
		119,
		115,
		-1,
		216,
		201,
		194,
		184,
		198,
		169,
		-1,
		224,
		-1,
		-1,
		194,
		188,
		188,
		172,
		175,
		162,
		142,
		134,
		149,
		148,
		135,
		134,
		115,
		108,
		105,
		98,
		111,
		121,
		126,
		113,
		-1,
		-1,
		-1,
		221,
		207,
		211,
		171,
		190,
		-1,
		-1,
		256,
		211,
		197,
		-1,
		171,
		162,
		150,
		140,
		130,
		135,
		136,
		126,
		124,
		113,
		115,
		109,
		100,
		99,
		115,
		107,
		129,
		-1,
		-1,
		204,
		209,
		197,
		183,
		202,
		-1,
		-1,
		-1,
		203,
		219,
		190,
		169,
		151,
		-1,
		-1,
		134,
		127,
		121,
		124,
		112,
		129,
		124,
		108,
		93,
		108,
		112,
		120,
		111,
		-1,
		207,
		194,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		111,
		130,
		137,
		110,
		95,
		89,
		95,
		107,
		116,
		-1,
		-1,
		219,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		108,
		120,
		113,
		110,
		101,
		92,
		88,
		92,
		96,
		110,
		114,
		242,
		-1,
		180,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		120,
		131,
		96,
		95,
		85,
		84,
		88,
		105,
		107,
		-1,
		-1,
		178,
		174,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		92,
		94,
		94,
		89,
		83,
		93,
		106,
		101,
		-1,
		-1,
		-1,
		190,
		-1,
		192,
		-1,
		-1,
		180,
		188,
		135,
		117,
		113,
		111,
		98,
		92,
		82,
		87,
		97,
		91,
		88,
		79,
		81,
		104,
		93,
		110,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		169,
		161,
		156,
		162,
		164,
		155,
		150,
		147,
		-1,
		117,
		121,
		88,
		95,
		78,
		85,
		90,
		87,
		73,
		78,
		94,
		93,
		88,
		102,
		93,
		97,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		162,
		158,
		148,
		138,
		141,
		-1,
		-1,
		135,
		132,
		112,
		81,
		86,
		79,
		74,
		79,
		60,
		69,
		71,
		66,
		81,
		86,
		88,
		81,
		88,
		103,
		-1,
		209,
		246,
		239,
		207,
		215,
		246,
		-1,
		152,
		144,
		155,
		130,
		132,
		-1,
		-1,
		108,
		99,
		100,
		88,
		85,
		98,
		97,
		64,
		61,
		83,
		64,
		71,
		82,
		74,
		78,
		79,
		86,
		97,
		101,
		-1,
		202,
		222,
		201,
		204,
		228,
		242,
		-1,
		149,
		-1,
		-1,
		161,
		133,
		117,
		107,
		104,
		147,
		94,
		89,
		66,
		64,
		61,
		52,
		82,
		61,
		60,
		57,
		66,
		71,
		63,
		89,
		91,
		93,
		-1,
		191,
		202,
		195,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		159,
		-1,
		144,
		-1,
		127,
		131,
		102,
		105,
		80,
		67,
		53,
		53,
		59,
		59,
		64,
		64,
		53,
		62,
		73,
		85,
		95,
		97,
		216,
		172,
		175,
		186,
		197,
		212,
		216,
		-1,
		161,
		200,
		165,
		-1,
		149,
		-1,
		-1,
		-1,
		141,
		115,
		107,
		100,
		79,
		79,
		45,
		41,
		54,
		61,
		71,
		70,
		54,
		66,
		79,
		90,
		101,
		212,
		203,
		216,
		161,
		161,
		182,
		191,
		212,
		176,
		167,
		194,
		172,
		161,
		156,
		143,
		-1,
		-1,
		122,
		125,
		-1,
		-1,
		86,
		62,
		49,
		43,
		47,
		61,
		73,
		66,
		46,
		66,
		61,
		93,
		-1,
		205,
		204,
		193,
		190,
		166,
		157,
		152,
		179,
		-1,
		-1,
		174,
		195,
		185,
		189,
		203,
		228,
		-1,
		132,
		-1,
		-1,
		102,
		-1,
		-1,
		87,
		67,
		56,
		47,
		33,
		55,
		66,
		88,
		42,
		59,
		66,
		76,
		82,
		189,
		186,
		174,
		172,
		195,
		160,
		148,
		-1,
		161,
		159,
		165,
		172,
		189,
		217,
		-1,
		-1,
		148,
		128,
		-1,
		-1,
		85,
		83,
		72,
		-1,
		62,
		44,
		30,
		57,
		36,
		38,
		45,
		39,
		46,
		68,
		81,
		75,
		198,
		212,
		201,
		197,
		196,
		204,
		153,
		146,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		138,
		134,
		-1,
		-1,
		80,
		73,
		61,
		49,
		39,
		44,
		30,
		26,
		24,
		29,
		37,
		48,
		58,
		62,
		69,
		-1,
		232,
		-1,
		184,
		160,
		174,
		189,
		197,
		-1,
		-1,
		-1,
		155,
		141,
		134,
		122,
		120,
		-1,
		114,
		98,
		79,
		-1,
		49,
		62,
		62,
		30,
		0,
		16,
		36,
		45,
		54,
		64,
		62,
		65,
		-1,
		-1,
		172,
		171,
		-1,
		-1,
		145,
		147,
		-1,
		146,
		135,
		120,
		112,
		-1,
		-1,
		86,
		82,
		-1,
		-1,
		50,
		44,
		33,
		6,
		5,
		32,
		41,
		40,
		52,
		67,
		59,
		-1,
		-1,
		166,
		158,
		152,
		-1,
		130,
		-1,
		148,
		-1,
		115,
		121,
		109,
		-1,
		-1,
		-1,
		88,
		51,
		72,
		51,
		24,
		22,
		22,
		28,
		35,
		45,
		53,
		59,
		-1,
		-1,
		-1,
		148,
		122,
		155,
		146,
		129,
		109,
		101,
		120,
		-1,
		87,
		-1,
		55,
		52,
		65,
		32,
		35,
		29,
		30,
		38,
		42,
		51,
		49,
		154,
		-1,
		124,
		157,
		121,
		115,
		91,
		95,
		111,
		-1,
		84,
		63,
		-1,
		97,
		72,
		52,
		38,
		34,
		29,
		36,
		50,
		46,
		-1,
		-1,
		-1,
		126,
		125,
		117,
		111,
		111,
		96,
		87,
		-1,
		99,
		81,
		60,
		77,
		77,
		68,
		73,
		42,
		38,
		47,
		49,
		41,
		-1,
		227,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		120,
		115,
		88,
		76,
		82,
		78,
		64,
		70,
		72,
		80,
		75,
		72,
		68,
		59,
		61,
		42,
		78,
		-1,
		222,
		-1,
		156,
		-1,
		-1,
		138,
		118,
		110,
		99,
		88,
		86,
		77,
		68,
		90,
		106,
		66,
		54,
		49,
		50,
		-1,
		211,
		210,
		-1,
		157,
		149,
		135,
		-1,
		128,
		-1,
		134,
		95,
		-1,
		97,
		77,
		-1,
		65,
		54,
		-1,
		-1,
		198,
		173,
		-1,
		-1,
		-1,
		158,
		138,
		129,
		113,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		183,
		182,
		-1,
		151,
		154,
		-1,
		144,
		135,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		192,
		173,
		167,
		166,
		164,
		159,
		156,
		142,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		164,
		156,
		149,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		175,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		197,
		198,
		221,
		185,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		200,
		198,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		237,
		226,
		237,
		245,
		218,
		225,
		-1,
		244,
		248,
		214,
		208,
		247,
		216,
		222,
		233,
		-1,
		-1,
		-1,
		237,
		236,
		204,
		202,
		211,
		216,
		223,
		-1,
		222,
		-1,
		258,
		237,
		248,
		253,
		197,
		194,
		214,
		233,
		215,
		207,
		273,
		227,
		198,
		192,
		210,
		200,
		209,
		201,
		-1,
		198,
		188,
		210,
		189,
		200,
		192,
		-1,
		-1,
		192,
		193,
		199,
		185,
		191,
		187,
		-1,
		197,
		181,
		-1,
		-1,
		182,
		183,
		167,
		170,
		178,
		176,
		189,
		181,
		176,
		-1,
		-1,
		173,
		169,
		176,
		163,
		159,
		176,
		189,
		171,
		185,
		184,
		-1,
		177,
		195,
		202,
		170,
		168,
		152,
		150,
		168,
		170,
		176,
		176,
		-1,
		186,
		187,
		182,
		190,
		192,
		168,
		155,
		155,
		165,
		158,
		177,
		165,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		186,
		169,
		186,
		178,
		168,
		183,
		176,
		158,
		155,
		153,
		150,
		166,
		164,
		174,
		-1,
		-1,
		279,
		248,
		277,
		235,
		216,
		-1,
		182,
		162,
		168,
		172,
		166,
		159,
		173,
		169,
		-1,
		144,
		143,
		171,
		157,
		168,
		239,
		-1,
		-1,
		237,
		229,
		212,
		215,
		192,
		188,
		177,
		176,
		168,
		154,
		150,
		156,
		159,
		159,
		165,
		138,
		148,
		152,
		150,
		175,
		-1,
		-1,
		210,
		-1,
		-1,
		236,
		219,
		-1,
		202,
		209,
		198,
		204,
		190,
		211,
		187,
		178,
		170,
		164,
		152,
		154,
		151,
		164,
		152,
		135,
		160,
		164,
		145,
		166,
		161,
		-1,
		209,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		195,
		198,
		204,
		228,
		227,
		-1,
		199,
		187,
		188,
		173,
		170,
		157,
		145,
		158,
		143,
		150,
		149,
		139,
		137,
		167,
		142,
		164,
		161,
		180,
		185,
		179,
		188,
		-1,
		244,
		240,
		236,
		243,
		192,
		-1,
		-1,
		232,
		-1,
		235,
		236,
		211,
		184,
		187,
		174,
		165,
		152,
		141,
		152,
		141,
		138,
		146,
		131,
		146,
		137,
		136,
		154,
		164,
		172,
		176,
		182,
		-1,
		294,
		-1,
		236,
		220,
		222,
		194,
		215,
		-1,
		252,
		236,
		228,
		213,
		213,
		-1,
		183,
		180,
		170,
		148,
		133,
		150,
		142,
		140,
		144,
		126,
		140,
		131,
		149,
		156,
		154,
		158,
		178,
		190,
		254,
		244,
		-1,
		226,
		231,
		190,
		198,
		217,
		255,
		219,
		-1,
		214,
		-1,
		185,
		198,
		-1,
		154,
		150,
		132,
		133,
		128,
		143,
		137,
		122,
		119,
		137,
		140,
		147,
		151,
		167,
		-1,
		-1,
		239,
		243,
		232,
		183,
		202,
		226,
		263,
		212,
		201,
		200,
		-1,
		191,
		168,
		165,
		153,
		140,
		125,
		126,
		134,
		147,
		126,
		121,
		118,
		138,
		164,
		142,
		154,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		209,
		180,
		204,
		246,
		230,
		223,
		211,
		176,
		176,
		170,
		-1,
		164,
		143,
		134,
		123,
		121,
		134,
		131,
		136,
		116,
		114,
		133,
		145,
		136,
		153,
		-1,
		-1,
		-1,
		239,
		228,
		229,
		175,
		198,
		235,
		209,
		195,
		200,
		175,
		168,
		162,
		177,
		160,
		141,
		130,
		122,
		111,
		127,
		135,
		130,
		112,
		121,
		127,
		151,
		141,
		147,
		-1,
		-1,
		246,
		236,
		220,
		222,
		219,
		189,
		196,
		228,
		200,
		213,
		-1,
		167,
		-1,
		156,
		151,
		135,
		130,
		127,
		124,
		118,
		127,
		129,
		119,
		114,
		121,
		156,
		156,
		131,
		151,
		154,
		-1,
		-1,
		-1,
		239,
		234,
		209,
		186,
		170,
		206,
		-1,
		183,
		184,
		-1,
		161,
		155,
		152,
		137,
		133,
		128,
		132,
		125,
		132,
		125,
		123,
		124,
		106,
		138,
		-1,
		139,
		133,
		141,
		131,
		119,
		-1,
		-1,
		-1,
		232,
		211,
		204,
		224,
		165,
		217,
		-1,
		-1,
		168,
		161,
		-1,
		148,
		130,
		137,
		135,
		129,
		133,
		130,
		119,
		132,
		125,
		111,
		113,
		126,
		130,
		134,
		121,
		117,
		114,
		128,
		-1,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		185,
		-1,
		177,
		169,
		159,
		153,
		147,
		143,
		141,
		157,
		141,
		144,
		142,
		133,
		141,
		114,
		107,
		114,
		103,
		121,
		129,
		121,
		115,
		114,
		124,
		-1,
		252,
		238,
		209,
		-1,
		-1,
		198,
		-1,
		162,
		176,
		192,
		-1,
		185,
		164,
		179,
		157,
		153,
		149,
		164,
		165,
		143,
		142,
		140,
		131,
		119,
		108,
		111,
		103,
		125,
		125,
		109,
		110,
		114,
		-1,
		258,
		245,
		203,
		199,
		188,
		208,
		159,
		147,
		179,
		-1,
		-1,
		221,
		-1,
		155,
		172,
		163,
		161,
		154,
		139,
		146,
		151,
		128,
		123,
		113,
		102,
		102,
		97,
		119,
		105,
		103,
		112,
		128,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		174,
		161,
		155,
		-1,
		196,
		-1,
		199,
		189,
		173,
		158,
		191,
		-1,
		138,
		134,
		141,
		-1,
		148,
		-1,
		121,
		118,
		109,
		94,
		91,
		102,
		100,
		111,
		107,
		-1,
		208,
		193,
		186,
		176,
		190,
		161,
		-1,
		216,
		-1,
		-1,
		186,
		180,
		180,
		164,
		167,
		154,
		134,
		126,
		141,
		140,
		127,
		126,
		107,
		100,
		97,
		90,
		103,
		113,
		118,
		105,
		-1,
		-1,
		-1,
		213,
		199,
		203,
		163,
		182,
		-1,
		-1,
		248,
		203,
		189,
		-1,
		163,
		154,
		142,
		132,
		122,
		127,
		128,
		118,
		116,
		105,
		107,
		101,
		92,
		91,
		107,
		99,
		121,
		-1,
		-1,
		196,
		201,
		189,
		175,
		194,
		-1,
		-1,
		-1,
		195,
		211,
		182,
		161,
		143,
		-1,
		-1,
		126,
		119,
		113,
		116,
		104,
		121,
		116,
		100,
		85,
		100,
		104,
		112,
		103,
		-1,
		199,
		186,
		-1,
		-1,
		197,
		191,
		-1,
		-1,
		-1,
		-1,
		194,
		139,
		128,
		123,
		127,
		125,
		-1,
		99,
		110,
		103,
		122,
		129,
		102,
		87,
		81,
		87,
		99,
		108,
		-1,
		-1,
		211,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		116,
		109,
		113,
		-1,
		101,
		103,
		100,
		112,
		105,
		102,
		93,
		84,
		80,
		84,
		88,
		102,
		106,
		234,
		-1,
		172,
		-1,
		-1,
		-1,
		169,
		184,
		155,
		132,
		105,
		100,
		93,
		87,
		92,
		103,
		112,
		123,
		88,
		87,
		77,
		76,
		80,
		97,
		98,
		-1,
		-1,
		170,
		166,
		195,
		177,
		181,
		182,
		-1,
		-1,
		109,
		100,
		91,
		83,
		96,
		99,
		84,
		86,
		86,
		81,
		75,
		85,
		97,
		92,
		-1,
		-1,
		-1,
		182,
		-1,
		184,
		-1,
		-1,
		172,
		180,
		127,
		109,
		105,
		103,
		90,
		84,
		74,
		79,
		89,
		83,
		80,
		71,
		72,
		95,
		84,
		101,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		161,
		153,
		148,
		154,
		156,
		147,
		142,
		139,
		-1,
		109,
		113,
		80,
		87,
		70,
		77,
		82,
		79,
		65,
		69,
		85,
		84,
		79,
		93,
		84,
		88,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		154,
		150,
		140,
		130,
		133,
		-1,
		-1,
		127,
		124,
		104,
		73,
		78,
		71,
		66,
		71,
		52,
		61,
		62,
		57,
		72,
		77,
		79,
		72,
		79,
		94,
		-1,
		201,
		238,
		231,
		199,
		207,
		238,
		-1,
		144,
		136,
		147,
		122,
		124,
		-1,
		-1,
		100,
		91,
		92,
		80,
		77,
		90,
		89,
		56,
		53,
		75,
		55,
		62,
		73,
		65,
		69,
		70,
		77,
		88,
		92,
		-1,
		194,
		214,
		193,
		196,
		220,
		234,
		-1,
		141,
		-1,
		-1,
		153,
		125,
		109,
		99,
		96,
		139,
		86,
		81,
		58,
		56,
		53,
		44,
		74,
		53,
		51,
		48,
		57,
		62,
		54,
		80,
		82,
		88,
		-1,
		183,
		194,
		187,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		151,
		-1,
		136,
		-1,
		119,
		123,
		94,
		97,
		72,
		59,
		45,
		45,
		51,
		51,
		56,
		55,
		44,
		53,
		64,
		76,
		86,
		88,
		208,
		164,
		167,
		178,
		189,
		204,
		208,
		-1,
		153,
		192,
		157,
		-1,
		141,
		-1,
		-1,
		-1,
		133,
		107,
		99,
		92,
		71,
		71,
		37,
		33,
		46,
		53,
		63,
		61,
		45,
		57,
		70,
		81,
		96,
		204,
		195,
		208,
		153,
		153,
		174,
		183,
		204,
		168,
		159,
		186,
		164,
		153,
		148,
		135,
		-1,
		-1,
		114,
		117,
		-1,
		-1,
		78,
		54,
		41,
		35,
		39,
		53,
		65,
		57,
		37,
		57,
		52,
		84,
		-1,
		197,
		196,
		185,
		182,
		158,
		149,
		144,
		171,
		-1,
		-1,
		166,
		187,
		177,
		181,
		195,
		220,
		-1,
		124,
		-1,
		-1,
		94,
		-1,
		-1,
		79,
		59,
		48,
		39,
		25,
		47,
		58,
		80,
		33,
		50,
		57,
		67,
		80,
		181,
		178,
		166,
		164,
		187,
		152,
		140,
		-1,
		153,
		151,
		157,
		164,
		181,
		209,
		-1,
		-1,
		140,
		120,
		-1,
		-1,
		77,
		75,
		64,
		-1,
		54,
		36,
		22,
		49,
		26,
		29,
		36,
		30,
		37,
		63,
		76,
		74,
		190,
		204,
		193,
		189,
		188,
		196,
		145,
		138,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		130,
		126,
		-1,
		-1,
		72,
		65,
		53,
		41,
		31,
		36,
		22,
		18,
		15,
		20,
		28,
		39,
		53,
		57,
		68,
		-1,
		224,
		-1,
		176,
		152,
		166,
		181,
		189,
		-1,
		-1,
		-1,
		147,
		133,
		126,
		114,
		112,
		-1,
		106,
		90,
		71,
		-1,
		41,
		54,
		54,
		22,
		13,
		0,
		34,
		45,
		53,
		59,
		61,
		64,
		-1,
		-1,
		164,
		163,
		-1,
		-1,
		137,
		139,
		-1,
		138,
		127,
		112,
		104,
		-1,
		-1,
		78,
		74,
		-1,
		-1,
		42,
		36,
		25,
		19,
		14,
		31,
		43,
		39,
		51,
		62,
		58,
		-1,
		-1,
		158,
		150,
		144,
		-1,
		122,
		-1,
		140,
		-1,
		107,
		113,
		101,
		-1,
		-1,
		-1,
		80,
		43,
		64,
		43,
		37,
		35,
		28,
		27,
		34,
		44,
		52,
		58,
		-1,
		-1,
		-1,
		140,
		114,
		147,
		138,
		121,
		101,
		93,
		112,
		-1,
		79,
		-1,
		47,
		44,
		57,
		42,
		48,
		42,
		30,
		45,
		41,
		50,
		48,
		146,
		-1,
		116,
		149,
		113,
		107,
		83,
		87,
		103,
		-1,
		76,
		55,
		-1,
		89,
		64,
		65,
		51,
		41,
		28,
		35,
		49,
		45,
		-1,
		-1,
		-1,
		118,
		117,
		109,
		103,
		103,
		88,
		79,
		-1,
		91,
		73,
		52,
		69,
		69,
		60,
		68,
		55,
		51,
		46,
		48,
		40,
		-1,
		219,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		112,
		107,
		80,
		68,
		74,
		70,
		56,
		62,
		64,
		72,
		70,
		67,
		67,
		58,
		62,
		41,
		77,
		-1,
		214,
		-1,
		148,
		-1,
		-1,
		130,
		110,
		102,
		91,
		80,
		78,
		69,
		60,
		82,
		98,
		65,
		53,
		48,
		49,
		-1,
		203,
		202,
		-1,
		149,
		141,
		127,
		-1,
		120,
		-1,
		126,
		87,
		-1,
		89,
		69,
		-1,
		64,
		53,
		-1,
		-1,
		190,
		165,
		-1,
		-1,
		-1,
		150,
		130,
		121,
		105,
		-1,
		80,
		80,
		-1,
		-1,
		-1,
		175,
		174,
		-1,
		143,
		146,
		-1,
		136,
		127,
		135,
		82,
		86,
		-1,
		-1,
		-1,
		184,
		165,
		159,
		158,
		156,
		151,
		148,
		134,
		118,
		96,
		85,
		106,
		-1,
		-1,
		-1,
		156,
		148,
		141,
		-1,
		-1,
		143,
		126,
		107,
		105,
		-1,
		-1,
		-1,
		178,
		159,
		-1,
		-1,
		133,
		-1,
		-1,
		139,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		167,
		-1,
		-1,
		-1,
		129,
		125,
		126,
		-1,
		-1,
		-1,
		-1,
		189,
		190,
		213,
		177,
		-1,
		-1,
		-1,
		121,
		115,
		-1,
		-1,
		192,
		190,
		-1,
		-1,
		-1,
		149,
		133,
		-1,
		119,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		154,
		-1,
		154,
		129,
		136,
		-1,
		-1,
		-1,
		-1,
		167,
		159,
		167,
		-1,
		139,
		141,
		-1,
		189,
		-1,
		-1,
		182,
		173,
		-1,
		-1,
		144,
		151,
		173,
		176,
		212,
		-1,
		163
	],
	[
		-1,
		232,
		221,
		232,
		240,
		213,
		220,
		-1,
		239,
		243,
		209,
		203,
		242,
		211,
		217,
		228,
		-1,
		-1,
		-1,
		232,
		231,
		199,
		197,
		206,
		211,
		218,
		-1,
		217,
		-1,
		253,
		232,
		243,
		248,
		192,
		189,
		209,
		228,
		210,
		202,
		268,
		222,
		193,
		187,
		205,
		195,
		204,
		196,
		-1,
		193,
		183,
		205,
		184,
		195,
		187,
		-1,
		-1,
		187,
		188,
		194,
		180,
		186,
		182,
		-1,
		192,
		176,
		-1,
		-1,
		177,
		178,
		162,
		165,
		173,
		171,
		184,
		176,
		171,
		-1,
		-1,
		168,
		164,
		171,
		158,
		154,
		171,
		184,
		166,
		180,
		179,
		-1,
		172,
		190,
		197,
		165,
		163,
		147,
		145,
		163,
		165,
		171,
		171,
		-1,
		181,
		182,
		177,
		185,
		187,
		163,
		150,
		150,
		160,
		153,
		172,
		160,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		181,
		164,
		181,
		173,
		163,
		178,
		171,
		153,
		150,
		148,
		145,
		161,
		159,
		169,
		-1,
		-1,
		274,
		243,
		272,
		230,
		211,
		-1,
		177,
		157,
		163,
		167,
		161,
		154,
		168,
		164,
		-1,
		139,
		138,
		166,
		152,
		163,
		234,
		-1,
		-1,
		232,
		224,
		207,
		210,
		187,
		183,
		172,
		171,
		163,
		149,
		145,
		151,
		154,
		154,
		160,
		133,
		143,
		147,
		145,
		170,
		-1,
		-1,
		205,
		-1,
		-1,
		231,
		214,
		-1,
		197,
		204,
		193,
		199,
		185,
		206,
		182,
		173,
		165,
		159,
		147,
		149,
		146,
		159,
		147,
		130,
		155,
		159,
		140,
		161,
		156,
		-1,
		204,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		190,
		193,
		199,
		223,
		222,
		-1,
		194,
		182,
		183,
		168,
		165,
		152,
		140,
		153,
		138,
		145,
		144,
		134,
		132,
		162,
		137,
		159,
		156,
		175,
		180,
		174,
		183,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		227,
		-1,
		230,
		231,
		206,
		179,
		182,
		169,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		126,
		141,
		132,
		131,
		149,
		159,
		167,
		171,
		177,
		-1,
		289,
		-1,
		231,
		215,
		217,
		189,
		210,
		-1,
		247,
		231,
		223,
		208,
		208,
		-1,
		178,
		175,
		165,
		143,
		128,
		145,
		137,
		135,
		139,
		121,
		135,
		126,
		144,
		151,
		149,
		153,
		173,
		185,
		249,
		239,
		-1,
		221,
		226,
		185,
		193,
		212,
		250,
		214,
		-1,
		209,
		-1,
		180,
		193,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		132,
		117,
		114,
		132,
		135,
		142,
		146,
		162,
		-1,
		-1,
		234,
		238,
		227,
		178,
		197,
		221,
		258,
		207,
		196,
		195,
		-1,
		186,
		163,
		160,
		148,
		135,
		120,
		121,
		129,
		142,
		121,
		116,
		113,
		133,
		159,
		137,
		149,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		204,
		175,
		199,
		241,
		225,
		218,
		206,
		171,
		171,
		165,
		-1,
		159,
		138,
		129,
		118,
		116,
		129,
		126,
		131,
		111,
		109,
		128,
		140,
		131,
		148,
		-1,
		-1,
		-1,
		234,
		223,
		224,
		170,
		193,
		230,
		204,
		190,
		195,
		170,
		163,
		157,
		172,
		155,
		136,
		125,
		117,
		106,
		122,
		130,
		125,
		107,
		116,
		122,
		146,
		136,
		142,
		-1,
		-1,
		241,
		231,
		215,
		217,
		214,
		184,
		191,
		223,
		195,
		208,
		-1,
		162,
		-1,
		151,
		146,
		130,
		125,
		122,
		119,
		113,
		122,
		124,
		114,
		109,
		116,
		151,
		151,
		126,
		146,
		149,
		-1,
		-1,
		-1,
		234,
		229,
		204,
		181,
		165,
		201,
		-1,
		178,
		179,
		-1,
		156,
		150,
		147,
		132,
		128,
		123,
		127,
		120,
		127,
		120,
		118,
		119,
		101,
		133,
		-1,
		134,
		128,
		136,
		126,
		114,
		-1,
		-1,
		-1,
		227,
		206,
		199,
		219,
		160,
		212,
		-1,
		-1,
		163,
		156,
		-1,
		143,
		125,
		132,
		130,
		124,
		128,
		125,
		114,
		127,
		120,
		106,
		108,
		121,
		125,
		129,
		116,
		112,
		109,
		123,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		180,
		-1,
		172,
		164,
		154,
		148,
		142,
		138,
		136,
		152,
		136,
		139,
		137,
		128,
		136,
		109,
		102,
		109,
		98,
		116,
		124,
		116,
		110,
		109,
		119,
		-1,
		247,
		233,
		204,
		-1,
		-1,
		193,
		-1,
		157,
		171,
		187,
		-1,
		180,
		159,
		174,
		152,
		148,
		144,
		159,
		160,
		138,
		137,
		135,
		126,
		114,
		103,
		106,
		98,
		120,
		120,
		104,
		105,
		109,
		-1,
		253,
		240,
		198,
		194,
		183,
		203,
		154,
		142,
		174,
		-1,
		-1,
		216,
		-1,
		150,
		167,
		158,
		156,
		149,
		140,
		146,
		146,
		123,
		118,
		108,
		97,
		97,
		92,
		114,
		100,
		98,
		107,
		123,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		169,
		156,
		150,
		-1,
		191,
		-1,
		194,
		184,
		168,
		153,
		186,
		-1,
		151,
		141,
		146,
		-1,
		143,
		-1,
		116,
		113,
		104,
		89,
		86,
		97,
		95,
		106,
		102,
		-1,
		203,
		188,
		181,
		171,
		185,
		156,
		-1,
		211,
		-1,
		-1,
		181,
		175,
		175,
		159,
		162,
		167,
		147,
		139,
		146,
		138,
		130,
		124,
		102,
		95,
		92,
		85,
		98,
		108,
		113,
		100,
		-1,
		-1,
		-1,
		208,
		194,
		198,
		158,
		177,
		-1,
		-1,
		243,
		198,
		184,
		-1,
		168,
		167,
		155,
		145,
		135,
		140,
		141,
		121,
		114,
		100,
		102,
		96,
		87,
		86,
		102,
		94,
		116,
		-1,
		-1,
		191,
		196,
		184,
		170,
		189,
		-1,
		-1,
		-1,
		190,
		206,
		195,
		169,
		156,
		-1,
		-1,
		139,
		132,
		126,
		117,
		104,
		116,
		111,
		95,
		80,
		95,
		99,
		107,
		98,
		-1,
		194,
		181,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		-1,
		-1,
		207,
		152,
		141,
		136,
		140,
		138,
		-1,
		112,
		123,
		108,
		120,
		127,
		97,
		82,
		76,
		82,
		94,
		103,
		-1,
		-1,
		206,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		129,
		122,
		126,
		-1,
		114,
		116,
		110,
		125,
		100,
		97,
		88,
		79,
		75,
		79,
		83,
		97,
		101,
		229,
		-1,
		192,
		-1,
		-1,
		-1,
		182,
		197,
		168,
		145,
		118,
		113,
		106,
		100,
		105,
		116,
		108,
		119,
		86,
		82,
		72,
		71,
		75,
		92,
		92,
		-1,
		-1,
		190,
		186,
		208,
		190,
		194,
		195,
		-1,
		-1,
		122,
		113,
		104,
		96,
		109,
		112,
		92,
		89,
		83,
		76,
		70,
		80,
		91,
		86,
		-1,
		-1,
		-1,
		202,
		-1,
		204,
		-1,
		-1,
		192,
		193,
		140,
		122,
		118,
		116,
		105,
		99,
		87,
		92,
		93,
		84,
		78,
		66,
		66,
		89,
		78,
		95,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		155,
		152,
		-1,
		122,
		128,
		93,
		100,
		83,
		90,
		88,
		80,
		60,
		63,
		79,
		78,
		73,
		87,
		78,
		82,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		147,
		144,
		124,
		93,
		91,
		84,
		79,
		89,
		69,
		56,
		56,
		51,
		66,
		71,
		73,
		66,
		73,
		88,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		120,
		111,
		112,
		100,
		97,
		99,
		94,
		77,
		65,
		71,
		49,
		56,
		67,
		59,
		63,
		64,
		71,
		82,
		86,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		161,
		-1,
		-1,
		173,
		145,
		129,
		119,
		116,
		159,
		107,
		102,
		79,
		77,
		74,
		65,
		73,
		57,
		45,
		42,
		51,
		56,
		48,
		74,
		76,
		79,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		167,
		-1,
		156,
		-1,
		139,
		143,
		115,
		118,
		93,
		80,
		66,
		66,
		72,
		57,
		53,
		49,
		38,
		47,
		58,
		70,
		80,
		82,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		173,
		212,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		153,
		128,
		120,
		113,
		92,
		92,
		58,
		54,
		62,
		58,
		63,
		55,
		39,
		51,
		64,
		75,
		87,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		188,
		179,
		206,
		180,
		169,
		164,
		151,
		-1,
		-1,
		135,
		138,
		-1,
		-1,
		99,
		75,
		62,
		56,
		60,
		72,
		63,
		51,
		31,
		51,
		46,
		78,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		207,
		197,
		201,
		211,
		236,
		-1,
		140,
		-1,
		-1,
		115,
		-1,
		-1,
		100,
		80,
		69,
		60,
		46,
		68,
		67,
		78,
		27,
		44,
		51,
		61,
		68,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		225,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		98,
		96,
		85,
		-1,
		75,
		57,
		43,
		70,
		46,
		32,
		30,
		24,
		31,
		48,
		61,
		61,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		93,
		86,
		74,
		62,
		52,
		57,
		43,
		39,
		34,
		27,
		22,
		30,
		38,
		42,
		55,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		127,
		111,
		92,
		-1,
		62,
		75,
		75,
		43,
		35,
		33,
		0,
		11,
		34,
		44,
		48,
		51,
		-1,
		-1,
		184,
		179,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		99,
		95,
		-1,
		-1,
		63,
		57,
		46,
		41,
		34,
		4,
		10,
		20,
		32,
		47,
		45,
		-1,
		-1,
		174,
		166,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		101,
		64,
		85,
		64,
		33,
		31,
		22,
		8,
		15,
		25,
		33,
		45,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		68,
		65,
		78,
		41,
		44,
		38,
		11,
		26,
		28,
		34,
		35,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		76,
		-1,
		88,
		75,
		61,
		47,
		28,
		15,
		22,
		36,
		32,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		83,
		68,
		59,
		59,
		51,
		47,
		35,
		35,
		27,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		78,
		71,
		61,
		58,
		54,
		45,
		51,
		28,
		64,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		102,
		52,
		40,
		35,
		36,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		51,
		40,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		235,
		224,
		235,
		243,
		216,
		223,
		-1,
		242,
		246,
		212,
		206,
		245,
		214,
		220,
		231,
		-1,
		-1,
		-1,
		235,
		234,
		202,
		200,
		209,
		214,
		221,
		-1,
		220,
		-1,
		256,
		235,
		246,
		251,
		195,
		192,
		212,
		231,
		213,
		205,
		271,
		225,
		196,
		190,
		208,
		198,
		207,
		199,
		-1,
		196,
		186,
		208,
		187,
		198,
		190,
		-1,
		-1,
		190,
		191,
		197,
		183,
		189,
		185,
		-1,
		195,
		179,
		-1,
		-1,
		180,
		181,
		165,
		168,
		176,
		174,
		187,
		179,
		174,
		-1,
		-1,
		171,
		167,
		174,
		161,
		157,
		174,
		187,
		169,
		183,
		182,
		-1,
		175,
		193,
		200,
		168,
		166,
		150,
		148,
		166,
		168,
		174,
		174,
		-1,
		184,
		185,
		180,
		188,
		190,
		166,
		153,
		153,
		163,
		156,
		175,
		163,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		184,
		167,
		184,
		176,
		166,
		181,
		174,
		156,
		153,
		151,
		148,
		164,
		162,
		172,
		-1,
		-1,
		277,
		246,
		275,
		233,
		214,
		-1,
		180,
		160,
		166,
		170,
		164,
		157,
		171,
		167,
		-1,
		142,
		141,
		169,
		155,
		166,
		237,
		-1,
		-1,
		235,
		227,
		210,
		213,
		190,
		186,
		175,
		174,
		166,
		152,
		148,
		154,
		157,
		157,
		163,
		136,
		146,
		150,
		148,
		173,
		-1,
		-1,
		208,
		-1,
		-1,
		234,
		217,
		-1,
		200,
		207,
		196,
		202,
		188,
		209,
		185,
		176,
		168,
		162,
		150,
		152,
		149,
		162,
		150,
		133,
		158,
		162,
		143,
		164,
		159,
		-1,
		207,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		193,
		196,
		202,
		226,
		225,
		-1,
		197,
		185,
		186,
		171,
		168,
		155,
		143,
		156,
		141,
		148,
		147,
		137,
		135,
		165,
		140,
		162,
		159,
		178,
		183,
		177,
		186,
		-1,
		242,
		238,
		234,
		241,
		190,
		-1,
		-1,
		230,
		-1,
		233,
		234,
		209,
		182,
		185,
		172,
		163,
		150,
		139,
		150,
		139,
		136,
		144,
		129,
		144,
		135,
		134,
		152,
		162,
		170,
		174,
		180,
		-1,
		292,
		-1,
		234,
		218,
		220,
		192,
		213,
		-1,
		250,
		234,
		226,
		211,
		211,
		-1,
		181,
		178,
		168,
		146,
		131,
		148,
		140,
		138,
		142,
		124,
		138,
		129,
		147,
		154,
		152,
		156,
		176,
		188,
		252,
		242,
		-1,
		224,
		229,
		188,
		196,
		215,
		253,
		217,
		-1,
		212,
		-1,
		183,
		196,
		-1,
		152,
		148,
		130,
		131,
		126,
		141,
		135,
		120,
		117,
		135,
		138,
		145,
		149,
		165,
		-1,
		-1,
		237,
		241,
		230,
		181,
		200,
		224,
		261,
		210,
		199,
		198,
		-1,
		189,
		166,
		163,
		151,
		138,
		123,
		124,
		132,
		145,
		124,
		119,
		116,
		136,
		162,
		140,
		152,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		207,
		178,
		202,
		244,
		228,
		221,
		209,
		174,
		174,
		168,
		-1,
		162,
		141,
		132,
		121,
		119,
		132,
		129,
		134,
		114,
		112,
		131,
		143,
		134,
		151,
		-1,
		-1,
		-1,
		237,
		226,
		227,
		173,
		196,
		233,
		207,
		193,
		198,
		173,
		166,
		160,
		175,
		158,
		139,
		128,
		120,
		109,
		125,
		133,
		128,
		110,
		119,
		125,
		149,
		139,
		145,
		-1,
		-1,
		244,
		234,
		218,
		220,
		217,
		187,
		194,
		226,
		198,
		211,
		-1,
		165,
		-1,
		154,
		149,
		133,
		128,
		125,
		122,
		116,
		125,
		127,
		117,
		112,
		119,
		154,
		154,
		129,
		149,
		152,
		-1,
		-1,
		-1,
		237,
		232,
		207,
		184,
		168,
		204,
		-1,
		181,
		182,
		-1,
		159,
		153,
		150,
		135,
		131,
		126,
		130,
		123,
		130,
		123,
		121,
		122,
		104,
		136,
		-1,
		137,
		131,
		139,
		129,
		117,
		-1,
		-1,
		-1,
		230,
		209,
		202,
		222,
		163,
		215,
		-1,
		-1,
		166,
		159,
		-1,
		146,
		128,
		135,
		133,
		127,
		131,
		128,
		117,
		130,
		123,
		109,
		111,
		124,
		128,
		132,
		119,
		115,
		112,
		126,
		-1,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		183,
		-1,
		175,
		167,
		157,
		151,
		145,
		141,
		139,
		155,
		139,
		142,
		140,
		131,
		139,
		112,
		105,
		112,
		101,
		119,
		127,
		119,
		113,
		112,
		122,
		-1,
		250,
		236,
		207,
		-1,
		-1,
		196,
		-1,
		160,
		174,
		190,
		-1,
		183,
		162,
		177,
		155,
		151,
		147,
		162,
		163,
		141,
		140,
		138,
		129,
		117,
		106,
		109,
		101,
		123,
		123,
		107,
		108,
		112,
		-1,
		256,
		243,
		201,
		197,
		186,
		206,
		157,
		145,
		177,
		-1,
		-1,
		219,
		-1,
		153,
		170,
		161,
		159,
		152,
		143,
		149,
		149,
		126,
		121,
		111,
		100,
		100,
		95,
		117,
		103,
		101,
		110,
		126,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		172,
		159,
		153,
		-1,
		194,
		-1,
		197,
		187,
		171,
		156,
		189,
		-1,
		154,
		144,
		149,
		-1,
		146,
		-1,
		119,
		116,
		107,
		92,
		89,
		100,
		98,
		109,
		105,
		-1,
		206,
		191,
		184,
		174,
		188,
		159,
		-1,
		214,
		-1,
		-1,
		184,
		178,
		178,
		162,
		165,
		170,
		150,
		142,
		149,
		141,
		133,
		127,
		105,
		98,
		95,
		88,
		101,
		111,
		116,
		103,
		-1,
		-1,
		-1,
		211,
		197,
		201,
		161,
		180,
		-1,
		-1,
		246,
		201,
		187,
		-1,
		171,
		170,
		158,
		148,
		138,
		143,
		144,
		124,
		117,
		103,
		105,
		99,
		90,
		89,
		105,
		97,
		119,
		-1,
		-1,
		194,
		199,
		187,
		173,
		192,
		-1,
		-1,
		-1,
		193,
		209,
		198,
		172,
		159,
		-1,
		-1,
		142,
		135,
		129,
		120,
		107,
		119,
		114,
		98,
		83,
		98,
		102,
		110,
		101,
		-1,
		197,
		184,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		-1,
		-1,
		210,
		155,
		144,
		139,
		143,
		141,
		-1,
		115,
		126,
		111,
		123,
		130,
		100,
		85,
		79,
		85,
		97,
		106,
		-1,
		-1,
		209,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		167,
		161,
		132,
		125,
		129,
		-1,
		117,
		119,
		113,
		128,
		103,
		100,
		91,
		82,
		78,
		82,
		86,
		100,
		104,
		232,
		-1,
		195,
		-1,
		-1,
		-1,
		185,
		200,
		171,
		148,
		121,
		116,
		109,
		103,
		108,
		119,
		111,
		122,
		89,
		85,
		75,
		74,
		78,
		95,
		95,
		-1,
		-1,
		193,
		189,
		211,
		193,
		197,
		198,
		-1,
		-1,
		125,
		116,
		107,
		99,
		112,
		115,
		95,
		92,
		86,
		79,
		73,
		83,
		94,
		89,
		-1,
		-1,
		-1,
		205,
		-1,
		207,
		-1,
		-1,
		195,
		196,
		143,
		125,
		121,
		119,
		108,
		102,
		90,
		95,
		96,
		87,
		81,
		69,
		69,
		92,
		81,
		98,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		184,
		176,
		171,
		177,
		179,
		170,
		158,
		155,
		-1,
		125,
		131,
		96,
		103,
		86,
		93,
		91,
		83,
		63,
		66,
		82,
		81,
		76,
		90,
		81,
		85,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		177,
		173,
		163,
		153,
		156,
		-1,
		-1,
		150,
		147,
		127,
		96,
		94,
		87,
		82,
		92,
		72,
		59,
		59,
		54,
		69,
		74,
		76,
		69,
		76,
		91,
		-1,
		224,
		261,
		254,
		222,
		230,
		261,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		123,
		114,
		115,
		103,
		100,
		102,
		97,
		88,
		68,
		74,
		52,
		59,
		70,
		62,
		66,
		67,
		74,
		85,
		89,
		-1,
		217,
		237,
		216,
		219,
		243,
		257,
		-1,
		164,
		-1,
		-1,
		176,
		148,
		132,
		122,
		119,
		162,
		117,
		112,
		91,
		89,
		85,
		76,
		76,
		60,
		48,
		45,
		54,
		59,
		51,
		77,
		79,
		82,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		180,
		-1,
		159,
		-1,
		142,
		146,
		125,
		128,
		105,
		92,
		78,
		76,
		84,
		60,
		56,
		52,
		41,
		50,
		61,
		68,
		78,
		85,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		176,
		215,
		186,
		-1,
		170,
		-1,
		-1,
		-1,
		156,
		138,
		130,
		125,
		104,
		104,
		70,
		66,
		65,
		61,
		66,
		58,
		42,
		51,
		62,
		73,
		88,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		191,
		182,
		209,
		193,
		182,
		177,
		164,
		-1,
		-1,
		147,
		148,
		-1,
		-1,
		111,
		87,
		74,
		68,
		72,
		75,
		66,
		54,
		34,
		50,
		44,
		76,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		210,
		200,
		204,
		220,
		245,
		-1,
		153,
		-1,
		-1,
		127,
		-1,
		-1,
		112,
		92,
		81,
		72,
		58,
		80,
		70,
		81,
		30,
		44,
		49,
		56,
		67,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		204,
		234,
		-1,
		-1,
		169,
		149,
		-1,
		-1,
		110,
		108,
		97,
		-1,
		87,
		69,
		55,
		82,
		50,
		33,
		33,
		27,
		31,
		43,
		56,
		60,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		159,
		155,
		-1,
		-1,
		105,
		98,
		86,
		74,
		64,
		69,
		55,
		51,
		37,
		30,
		25,
		22,
		33,
		37,
		54,
		-1,
		247,
		-1,
		199,
		175,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		176,
		162,
		155,
		143,
		141,
		-1,
		139,
		123,
		104,
		-1,
		74,
		87,
		87,
		55,
		45,
		46,
		13,
		0,
		29,
		39,
		51,
		48,
		-1,
		-1,
		187,
		190,
		-1,
		-1,
		166,
		168,
		-1,
		167,
		156,
		141,
		133,
		-1,
		-1,
		111,
		107,
		-1,
		-1,
		75,
		69,
		58,
		51,
		47,
		17,
		5,
		17,
		27,
		42,
		48,
		-1,
		-1,
		187,
		179,
		173,
		-1,
		151,
		-1,
		169,
		-1,
		136,
		142,
		130,
		-1,
		-1,
		-1,
		113,
		76,
		97,
		76,
		43,
		41,
		30,
		21,
		21,
		20,
		28,
		48,
		-1,
		-1,
		-1,
		169,
		143,
		176,
		167,
		150,
		130,
		122,
		141,
		-1,
		111,
		-1,
		80,
		77,
		90,
		51,
		54,
		48,
		24,
		39,
		32,
		29,
		38,
		175,
		-1,
		145,
		178,
		142,
		136,
		112,
		116,
		132,
		-1,
		108,
		88,
		-1,
		101,
		88,
		71,
		57,
		41,
		28,
		35,
		42,
		35,
		-1,
		-1,
		-1,
		147,
		146,
		138,
		132,
		132,
		117,
		108,
		-1,
		120,
		102,
		81,
		96,
		81,
		72,
		72,
		61,
		57,
		48,
		48,
		40,
		-1,
		248,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		141,
		136,
		109,
		97,
		103,
		99,
		85,
		91,
		91,
		84,
		74,
		71,
		67,
		58,
		64,
		41,
		77,
		-1,
		243,
		-1,
		177,
		-1,
		-1,
		159,
		139,
		131,
		120,
		109,
		107,
		98,
		89,
		111,
		115,
		65,
		53,
		48,
		49,
		-1,
		232,
		231,
		-1,
		178,
		170,
		156,
		-1,
		149,
		-1,
		155,
		116,
		-1,
		118,
		98,
		-1,
		64,
		53,
		-1,
		-1,
		219,
		194,
		-1,
		-1,
		-1,
		179,
		159,
		150,
		134,
		-1,
		109,
		109,
		-1,
		-1,
		-1,
		204,
		203,
		-1,
		172,
		175,
		-1,
		165,
		156,
		164,
		111,
		115,
		-1,
		-1,
		-1,
		213,
		194,
		188,
		187,
		185,
		180,
		177,
		163,
		147,
		125,
		114,
		135,
		-1,
		-1,
		-1,
		185,
		177,
		170,
		-1,
		-1,
		172,
		155,
		136,
		134,
		-1,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		162,
		-1,
		-1,
		168,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		196,
		-1,
		-1,
		-1,
		158,
		154,
		155,
		-1,
		-1,
		-1,
		-1,
		218,
		219,
		242,
		206,
		-1,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		221,
		219,
		-1,
		-1,
		-1,
		178,
		162,
		-1,
		148,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		183,
		-1,
		183,
		158,
		165,
		-1,
		-1,
		-1,
		-1,
		196,
		188,
		196,
		-1,
		168,
		170,
		-1,
		218,
		-1,
		-1,
		211,
		202,
		-1,
		-1,
		173,
		180,
		202,
		205,
		241,
		-1,
		192
	],
	[
		-1,
		221,
		210,
		221,
		229,
		202,
		209,
		-1,
		228,
		232,
		198,
		192,
		231,
		200,
		206,
		217,
		-1,
		-1,
		-1,
		221,
		220,
		188,
		186,
		195,
		200,
		207,
		-1,
		206,
		-1,
		242,
		221,
		232,
		237,
		181,
		178,
		198,
		217,
		199,
		191,
		257,
		211,
		182,
		176,
		194,
		184,
		193,
		185,
		-1,
		182,
		172,
		194,
		173,
		184,
		176,
		-1,
		-1,
		176,
		177,
		183,
		169,
		175,
		171,
		-1,
		181,
		165,
		-1,
		-1,
		166,
		167,
		151,
		154,
		162,
		160,
		173,
		165,
		160,
		-1,
		-1,
		157,
		153,
		160,
		147,
		143,
		160,
		173,
		155,
		169,
		168,
		-1,
		161,
		179,
		186,
		154,
		152,
		136,
		134,
		152,
		154,
		160,
		160,
		-1,
		170,
		171,
		166,
		174,
		176,
		152,
		139,
		139,
		149,
		142,
		161,
		149,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		170,
		153,
		170,
		162,
		152,
		167,
		160,
		142,
		139,
		137,
		134,
		150,
		148,
		158,
		-1,
		-1,
		263,
		232,
		261,
		219,
		200,
		-1,
		166,
		146,
		152,
		156,
		150,
		143,
		157,
		153,
		-1,
		128,
		127,
		155,
		141,
		152,
		223,
		-1,
		-1,
		221,
		213,
		196,
		199,
		176,
		172,
		161,
		160,
		152,
		138,
		134,
		140,
		143,
		143,
		149,
		122,
		132,
		136,
		134,
		159,
		-1,
		-1,
		194,
		-1,
		-1,
		220,
		203,
		-1,
		186,
		193,
		182,
		188,
		174,
		195,
		171,
		162,
		154,
		148,
		136,
		138,
		135,
		148,
		136,
		119,
		144,
		148,
		129,
		150,
		145,
		-1,
		193,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		179,
		182,
		188,
		212,
		211,
		-1,
		183,
		171,
		172,
		157,
		154,
		141,
		129,
		142,
		127,
		134,
		133,
		123,
		121,
		151,
		126,
		148,
		145,
		164,
		169,
		163,
		172,
		-1,
		228,
		224,
		220,
		227,
		176,
		-1,
		-1,
		216,
		-1,
		219,
		220,
		195,
		168,
		171,
		158,
		149,
		136,
		125,
		136,
		125,
		122,
		130,
		115,
		130,
		121,
		120,
		138,
		148,
		156,
		160,
		166,
		-1,
		278,
		-1,
		220,
		204,
		206,
		178,
		199,
		-1,
		236,
		220,
		212,
		197,
		197,
		-1,
		167,
		164,
		154,
		132,
		117,
		134,
		126,
		124,
		128,
		110,
		124,
		115,
		133,
		140,
		138,
		142,
		162,
		174,
		238,
		228,
		-1,
		210,
		215,
		174,
		182,
		201,
		239,
		203,
		-1,
		198,
		-1,
		169,
		182,
		-1,
		138,
		134,
		116,
		117,
		112,
		127,
		121,
		106,
		103,
		121,
		124,
		131,
		135,
		151,
		-1,
		-1,
		223,
		227,
		216,
		167,
		186,
		210,
		247,
		196,
		185,
		184,
		-1,
		175,
		152,
		149,
		137,
		124,
		109,
		110,
		118,
		131,
		110,
		105,
		102,
		122,
		148,
		126,
		138,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		193,
		164,
		188,
		230,
		214,
		207,
		195,
		160,
		160,
		154,
		-1,
		148,
		127,
		118,
		107,
		105,
		118,
		115,
		120,
		100,
		98,
		117,
		129,
		120,
		137,
		-1,
		-1,
		-1,
		223,
		212,
		213,
		159,
		182,
		219,
		193,
		179,
		184,
		159,
		152,
		146,
		161,
		144,
		125,
		114,
		106,
		95,
		111,
		119,
		114,
		96,
		105,
		111,
		135,
		125,
		131,
		-1,
		-1,
		230,
		220,
		204,
		206,
		203,
		173,
		180,
		212,
		184,
		197,
		-1,
		151,
		-1,
		140,
		135,
		119,
		114,
		111,
		108,
		102,
		111,
		113,
		103,
		98,
		105,
		140,
		140,
		115,
		135,
		138,
		-1,
		-1,
		-1,
		223,
		218,
		193,
		170,
		154,
		190,
		-1,
		167,
		168,
		-1,
		145,
		139,
		136,
		121,
		117,
		112,
		116,
		109,
		116,
		109,
		107,
		108,
		90,
		122,
		-1,
		123,
		117,
		125,
		115,
		103,
		-1,
		-1,
		-1,
		216,
		195,
		188,
		208,
		149,
		201,
		-1,
		-1,
		152,
		145,
		-1,
		132,
		114,
		121,
		119,
		113,
		117,
		114,
		103,
		116,
		109,
		95,
		97,
		110,
		114,
		118,
		105,
		101,
		98,
		112,
		-1,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		169,
		-1,
		161,
		153,
		143,
		137,
		131,
		127,
		125,
		141,
		125,
		128,
		126,
		117,
		125,
		98,
		91,
		98,
		87,
		105,
		113,
		105,
		99,
		98,
		108,
		-1,
		236,
		222,
		193,
		-1,
		-1,
		182,
		-1,
		146,
		160,
		176,
		-1,
		169,
		148,
		163,
		141,
		137,
		133,
		148,
		149,
		127,
		126,
		124,
		115,
		103,
		92,
		95,
		87,
		109,
		109,
		93,
		94,
		98,
		-1,
		242,
		229,
		187,
		183,
		172,
		192,
		143,
		131,
		163,
		-1,
		-1,
		205,
		-1,
		139,
		156,
		147,
		145,
		138,
		129,
		135,
		135,
		112,
		107,
		97,
		86,
		86,
		81,
		103,
		89,
		87,
		96,
		112,
		-1,
		-1,
		-1,
		209,
		-1,
		-1,
		158,
		145,
		139,
		-1,
		180,
		-1,
		183,
		173,
		157,
		142,
		175,
		-1,
		140,
		130,
		135,
		-1,
		132,
		-1,
		105,
		102,
		93,
		78,
		75,
		86,
		84,
		95,
		91,
		-1,
		192,
		177,
		170,
		160,
		174,
		145,
		-1,
		200,
		-1,
		-1,
		170,
		164,
		164,
		148,
		151,
		156,
		136,
		128,
		135,
		127,
		119,
		113,
		91,
		84,
		81,
		74,
		87,
		97,
		102,
		89,
		-1,
		-1,
		-1,
		197,
		183,
		187,
		147,
		166,
		-1,
		-1,
		232,
		187,
		173,
		-1,
		157,
		156,
		144,
		134,
		124,
		129,
		130,
		110,
		103,
		89,
		91,
		85,
		76,
		75,
		91,
		83,
		105,
		-1,
		-1,
		180,
		185,
		173,
		159,
		178,
		-1,
		-1,
		-1,
		179,
		195,
		184,
		158,
		145,
		-1,
		-1,
		128,
		121,
		115,
		106,
		93,
		105,
		100,
		84,
		69,
		84,
		88,
		96,
		87,
		-1,
		183,
		170,
		-1,
		-1,
		181,
		175,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		97,
		109,
		116,
		86,
		71,
		65,
		71,
		83,
		92,
		-1,
		-1,
		195,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		99,
		114,
		89,
		86,
		77,
		68,
		64,
		68,
		72,
		86,
		90,
		218,
		-1,
		181,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		97,
		108,
		75,
		71,
		61,
		60,
		64,
		81,
		81,
		-1,
		-1,
		179,
		175,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		81,
		78,
		72,
		65,
		59,
		69,
		80,
		75,
		-1,
		-1,
		-1,
		191,
		-1,
		193,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		94,
		88,
		76,
		81,
		82,
		73,
		67,
		55,
		55,
		78,
		67,
		84,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		170,
		162,
		157,
		163,
		165,
		156,
		144,
		141,
		-1,
		111,
		117,
		82,
		89,
		72,
		79,
		77,
		69,
		49,
		52,
		68,
		67,
		62,
		76,
		67,
		71,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		163,
		159,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		80,
		73,
		68,
		78,
		58,
		45,
		45,
		40,
		55,
		60,
		62,
		55,
		62,
		77,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		153,
		145,
		156,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		88,
		83,
		74,
		54,
		60,
		38,
		45,
		56,
		48,
		52,
		53,
		60,
		71,
		75,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		150,
		-1,
		-1,
		162,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		82,
		80,
		71,
		62,
		62,
		46,
		34,
		31,
		40,
		45,
		37,
		58,
		65,
		60,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		170,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		96,
		83,
		75,
		62,
		71,
		46,
		42,
		38,
		27,
		24,
		36,
		40,
		50,
		68,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		162,
		201,
		176,
		-1,
		160,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		116,
		95,
		95,
		69,
		65,
		51,
		47,
		54,
		44,
		34,
		23,
		34,
		45,
		60,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		168,
		195,
		183,
		172,
		167,
		154,
		-1,
		-1,
		153,
		134,
		-1,
		-1,
		102,
		90,
		73,
		62,
		58,
		61,
		69,
		53,
		33,
		22,
		16,
		48,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		196,
		186,
		190,
		206,
		231,
		-1,
		143,
		-1,
		-1,
		133,
		-1,
		-1,
		118,
		95,
		84,
		75,
		64,
		66,
		73,
		84,
		36,
		28,
		21,
		28,
		39,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		220,
		-1,
		-1,
		159,
		139,
		-1,
		-1,
		116,
		114,
		103,
		-1,
		93,
		75,
		61,
		88,
		56,
		45,
		39,
		33,
		19,
		15,
		28,
		32,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		145,
		-1,
		-1,
		111,
		104,
		92,
		80,
		70,
		75,
		61,
		57,
		43,
		36,
		31,
		32,
		5,
		9,
		26,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		145,
		129,
		110,
		-1,
		80,
		93,
		93,
		61,
		55,
		53,
		35,
		28,
		0,
		11,
		25,
		20,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		156,
		158,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		117,
		113,
		-1,
		-1,
		81,
		75,
		64,
		61,
		57,
		32,
		26,
		15,
		4,
		14,
		26,
		-1,
		-1,
		177,
		169,
		163,
		-1,
		141,
		-1,
		159,
		-1,
		126,
		132,
		120,
		-1,
		-1,
		-1,
		119,
		82,
		99,
		82,
		53,
		51,
		42,
		28,
		19,
		15,
		12,
		28,
		-1,
		-1,
		-1,
		159,
		133,
		166,
		157,
		140,
		120,
		112,
		131,
		-1,
		101,
		-1,
		76,
		79,
		84,
		61,
		64,
		58,
		31,
		46,
		19,
		10,
		19,
		165,
		-1,
		135,
		168,
		132,
		126,
		102,
		106,
		122,
		-1,
		98,
		80,
		-1,
		91,
		78,
		81,
		67,
		48,
		35,
		38,
		23,
		16,
		-1,
		-1,
		-1,
		137,
		136,
		128,
		122,
		122,
		107,
		98,
		-1,
		110,
		92,
		71,
		86,
		71,
		62,
		62,
		71,
		67,
		55,
		53,
		32,
		-1,
		238,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		131,
		126,
		99,
		87,
		93,
		89,
		75,
		81,
		81,
		74,
		64,
		61,
		57,
		48,
		54,
		31,
		64,
		-1,
		233,
		-1,
		167,
		-1,
		-1,
		149,
		129,
		121,
		110,
		99,
		97,
		88,
		79,
		101,
		105,
		55,
		43,
		38,
		39,
		-1,
		222,
		221,
		-1,
		168,
		160,
		146,
		-1,
		139,
		-1,
		145,
		106,
		-1,
		108,
		88,
		-1,
		54,
		43,
		-1,
		-1,
		209,
		184,
		-1,
		-1,
		-1,
		169,
		149,
		140,
		124,
		-1,
		99,
		99,
		-1,
		-1,
		-1,
		194,
		193,
		-1,
		162,
		165,
		-1,
		155,
		146,
		154,
		101,
		105,
		-1,
		-1,
		-1,
		203,
		184,
		178,
		177,
		175,
		170,
		167,
		153,
		137,
		115,
		104,
		125,
		-1,
		-1,
		-1,
		175,
		167,
		160,
		-1,
		-1,
		162,
		145,
		126,
		124,
		-1,
		-1,
		-1,
		197,
		178,
		-1,
		-1,
		152,
		-1,
		-1,
		158,
		123,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		186,
		-1,
		-1,
		-1,
		148,
		144,
		145,
		-1,
		-1,
		-1,
		-1,
		208,
		209,
		232,
		196,
		-1,
		-1,
		-1,
		140,
		134,
		-1,
		-1,
		211,
		209,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		138,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		173,
		-1,
		173,
		148,
		155,
		-1,
		-1,
		-1,
		-1,
		186,
		178,
		186,
		-1,
		158,
		160,
		-1,
		208,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		163,
		170,
		192,
		195,
		231,
		-1,
		182
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		118,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		114,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		115,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		97,
		89,
		111,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		94,
		102,
		93,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		77,
		89,
		98,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		87,
		93,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		70,
		87,
		87,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		86,
		81,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		88,
		79,
		73,
		61,
		61,
		84,
		73,
		81,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		83,
		75,
		55,
		58,
		74,
		73,
		68,
		73,
		64,
		72,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		51,
		46,
		61,
		66,
		65,
		58,
		63,
		78,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		80,
		60,
		66,
		44,
		51,
		62,
		54,
		58,
		59,
		50,
		63,
		67,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		68,
		52,
		40,
		37,
		46,
		51,
		43,
		60,
		56,
		49,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		181,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		102,
		89,
		81,
		68,
		77,
		52,
		48,
		44,
		33,
		30,
		42,
		46,
		56,
		65,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		187,
		-1,
		171,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		122,
		101,
		101,
		75,
		71,
		57,
		53,
		60,
		50,
		40,
		29,
		40,
		48,
		57,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		194,
		183,
		178,
		165,
		-1,
		-1,
		159,
		140,
		-1,
		-1,
		108,
		96,
		79,
		68,
		64,
		67,
		75,
		59,
		39,
		28,
		22,
		43,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		212,
		237,
		-1,
		154,
		-1,
		-1,
		139,
		-1,
		-1,
		124,
		101,
		90,
		81,
		70,
		72,
		79,
		90,
		42,
		34,
		27,
		34,
		28,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		226,
		-1,
		-1,
		170,
		150,
		-1,
		-1,
		122,
		120,
		109,
		-1,
		99,
		81,
		67,
		94,
		62,
		51,
		45,
		39,
		25,
		21,
		27,
		21,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		117,
		110,
		98,
		86,
		76,
		81,
		67,
		63,
		49,
		42,
		37,
		39,
		11,
		15,
		15,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		151,
		135,
		116,
		-1,
		86,
		99,
		99,
		67,
		67,
		61,
		43,
		40,
		14,
		0,
		14,
		9,
		-1,
		-1,
		179,
		182,
		-1,
		-1,
		167,
		169,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		123,
		119,
		-1,
		-1,
		87,
		81,
		70,
		73,
		68,
		44,
		38,
		27,
		16,
		3,
		15,
		-1,
		-1,
		186,
		180,
		174,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		125,
		88,
		109,
		88,
		65,
		63,
		54,
		40,
		31,
		27,
		23,
		17,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		112,
		-1,
		87,
		89,
		95,
		73,
		76,
		70,
		43,
		58,
		30,
		21,
		30,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		109,
		91,
		-1,
		102,
		89,
		93,
		78,
		59,
		46,
		49,
		34,
		27,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		97,
		82,
		73,
		73,
		83,
		79,
		66,
		64,
		43,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		92,
		85,
		75,
		72,
		68,
		59,
		65,
		42,
		75,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		116,
		66,
		54,
		49,
		50,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		65,
		54,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		120,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		115,
		116,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		146,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		111,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		148,
		154,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		109,
		101,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		159,
		149,
		154,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		170,
		175,
		155,
		147,
		154,
		146,
		138,
		132,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		176,
		175,
		163,
		153,
		143,
		148,
		149,
		129,
		122,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		112,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		203,
		177,
		164,
		-1,
		-1,
		147,
		140,
		134,
		125,
		112,
		124,
		119,
		103,
		88,
		103,
		107,
		102,
		94,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		215,
		160,
		149,
		144,
		148,
		146,
		-1,
		120,
		131,
		116,
		128,
		135,
		105,
		90,
		84,
		90,
		102,
		88,
		-1,
		-1,
		214,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		172,
		166,
		137,
		130,
		134,
		-1,
		122,
		124,
		118,
		133,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		73,
		79,
		237,
		-1,
		200,
		-1,
		-1,
		-1,
		190,
		205,
		176,
		153,
		126,
		121,
		114,
		108,
		113,
		124,
		116,
		127,
		94,
		90,
		80,
		79,
		83,
		77,
		77,
		-1,
		-1,
		198,
		194,
		216,
		198,
		202,
		203,
		-1,
		-1,
		130,
		121,
		112,
		104,
		117,
		120,
		100,
		97,
		91,
		84,
		78,
		88,
		76,
		71,
		-1,
		-1,
		-1,
		210,
		-1,
		212,
		-1,
		-1,
		200,
		201,
		148,
		130,
		126,
		124,
		113,
		107,
		95,
		100,
		101,
		92,
		86,
		74,
		74,
		87,
		63,
		67,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		189,
		181,
		176,
		182,
		184,
		175,
		163,
		160,
		-1,
		130,
		136,
		101,
		108,
		91,
		98,
		96,
		88,
		68,
		71,
		80,
		66,
		54,
		59,
		50,
		58,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		182,
		178,
		168,
		158,
		161,
		-1,
		-1,
		155,
		152,
		132,
		101,
		99,
		92,
		87,
		97,
		77,
		64,
		64,
		59,
		57,
		56,
		51,
		44,
		49,
		64,
		-1,
		229,
		266,
		259,
		227,
		235,
		266,
		-1,
		172,
		164,
		175,
		150,
		152,
		-1,
		-1,
		128,
		119,
		120,
		108,
		105,
		107,
		102,
		93,
		73,
		79,
		57,
		64,
		75,
		67,
		64,
		47,
		36,
		49,
		53,
		-1,
		222,
		242,
		221,
		224,
		248,
		262,
		-1,
		169,
		-1,
		-1,
		178,
		153,
		137,
		127,
		124,
		167,
		122,
		117,
		101,
		99,
		90,
		81,
		81,
		65,
		53,
		50,
		59,
		59,
		49,
		46,
		42,
		35,
		-1,
		211,
		222,
		215,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		168,
		-1,
		164,
		-1,
		147,
		151,
		130,
		133,
		115,
		102,
		91,
		81,
		90,
		65,
		61,
		57,
		46,
		43,
		55,
		42,
		50,
		51,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		181,
		220,
		174,
		-1,
		158,
		-1,
		-1,
		-1,
		161,
		143,
		135,
		135,
		114,
		114,
		83,
		79,
		70,
		66,
		73,
		63,
		53,
		42,
		52,
		40,
		43,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		196,
		187,
		214,
		181,
		170,
		165,
		152,
		-1,
		-1,
		160,
		153,
		-1,
		-1,
		121,
		100,
		87,
		81,
		77,
		80,
		88,
		72,
		52,
		41,
		35,
		35,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		215,
		205,
		209,
		212,
		237,
		-1,
		141,
		-1,
		-1,
		140,
		-1,
		-1,
		125,
		105,
		94,
		85,
		71,
		85,
		92,
		103,
		55,
		47,
		40,
		28,
		20,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		226,
		-1,
		-1,
		157,
		137,
		-1,
		-1,
		123,
		121,
		110,
		-1,
		100,
		82,
		68,
		95,
		75,
		64,
		58,
		52,
		38,
		34,
		21,
		13,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		143,
		-1,
		-1,
		118,
		111,
		99,
		87,
		77,
		82,
		68,
		64,
		62,
		55,
		50,
		52,
		24,
		28,
		7,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		152,
		136,
		117,
		-1,
		87,
		100,
		100,
		68,
		60,
		58,
		48,
		47,
		27,
		13,
		0,
		3,
		-1,
		-1,
		192,
		180,
		-1,
		-1,
		154,
		156,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		124,
		120,
		-1,
		-1,
		87,
		82,
		71,
		66,
		62,
		44,
		45,
		36,
		26,
		6,
		1,
		-1,
		-1,
		175,
		167,
		161,
		-1,
		139,
		-1,
		157,
		-1,
		124,
		130,
		118,
		-1,
		-1,
		-1,
		118,
		81,
		97,
		89,
		58,
		56,
		47,
		40,
		40,
		28,
		21,
		11,
		-1,
		-1,
		-1,
		157,
		131,
		164,
		155,
		138,
		118,
		110,
		129,
		-1,
		99,
		-1,
		74,
		77,
		82,
		66,
		69,
		63,
		37,
		50,
		23,
		19,
		17,
		163,
		-1,
		133,
		166,
		130,
		124,
		100,
		104,
		120,
		-1,
		96,
		78,
		-1,
		89,
		76,
		80,
		65,
		46,
		33,
		36,
		21,
		14,
		-1,
		-1,
		-1,
		135,
		134,
		126,
		120,
		120,
		105,
		96,
		-1,
		108,
		90,
		69,
		84,
		69,
		60,
		60,
		70,
		66,
		53,
		51,
		30,
		-1,
		236,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		129,
		124,
		97,
		85,
		91,
		87,
		73,
		79,
		79,
		72,
		62,
		59,
		55,
		46,
		52,
		29,
		62,
		-1,
		231,
		-1,
		165,
		-1,
		-1,
		147,
		127,
		119,
		108,
		97,
		95,
		86,
		77,
		99,
		103,
		53,
		41,
		36,
		37,
		-1,
		220,
		219,
		-1,
		166,
		158,
		144,
		-1,
		137,
		-1,
		143,
		104,
		-1,
		106,
		86,
		-1,
		52,
		41,
		-1,
		-1,
		207,
		182,
		-1,
		-1,
		-1,
		167,
		147,
		138,
		122,
		-1,
		97,
		97,
		-1,
		-1,
		-1,
		192,
		191,
		-1,
		160,
		163,
		-1,
		153,
		144,
		152,
		99,
		103,
		-1,
		-1,
		-1,
		201,
		182,
		176,
		175,
		173,
		168,
		165,
		151,
		135,
		113,
		102,
		123,
		-1,
		-1,
		-1,
		173,
		165,
		158,
		-1,
		-1,
		160,
		143,
		124,
		122,
		-1,
		-1,
		-1,
		195,
		176,
		-1,
		-1,
		150,
		-1,
		-1,
		156,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		184,
		-1,
		-1,
		-1,
		146,
		142,
		143,
		-1,
		-1,
		-1,
		-1,
		206,
		207,
		230,
		194,
		-1,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		209,
		207,
		-1,
		-1,
		-1,
		166,
		150,
		-1,
		136,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		171,
		-1,
		171,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		184,
		176,
		184,
		-1,
		156,
		158,
		-1,
		206,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		161,
		168,
		190,
		193,
		229,
		-1,
		180
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		159,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		147,
		153,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		127,
		123,
		120,
		129,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		120,
		125,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		149,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		120,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		151,
		157,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		118,
		110,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		162,
		152,
		157,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		113,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		173,
		178,
		158,
		150,
		157,
		149,
		141,
		135,
		113,
		106,
		103,
		96,
		109,
		119,
		124,
		111,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		179,
		178,
		166,
		156,
		146,
		151,
		152,
		132,
		125,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		121,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		206,
		180,
		167,
		-1,
		-1,
		150,
		143,
		137,
		128,
		115,
		127,
		122,
		106,
		91,
		106,
		110,
		111,
		103,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		149,
		-1,
		123,
		134,
		119,
		131,
		138,
		108,
		93,
		87,
		93,
		105,
		97,
		-1,
		-1,
		217,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		125,
		127,
		121,
		136,
		111,
		108,
		99,
		90,
		86,
		90,
		94,
		82,
		88,
		240,
		-1,
		203,
		-1,
		-1,
		-1,
		193,
		208,
		179,
		156,
		129,
		124,
		117,
		111,
		116,
		127,
		119,
		130,
		97,
		93,
		83,
		82,
		86,
		86,
		86,
		-1,
		-1,
		201,
		197,
		219,
		201,
		205,
		206,
		-1,
		-1,
		133,
		124,
		115,
		107,
		120,
		123,
		103,
		100,
		94,
		87,
		81,
		91,
		85,
		80,
		-1,
		-1,
		-1,
		213,
		-1,
		215,
		-1,
		-1,
		203,
		204,
		151,
		133,
		129,
		127,
		116,
		110,
		98,
		103,
		104,
		95,
		89,
		77,
		77,
		96,
		72,
		76,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		192,
		184,
		179,
		185,
		187,
		178,
		166,
		163,
		-1,
		133,
		139,
		104,
		111,
		94,
		101,
		99,
		91,
		71,
		74,
		89,
		75,
		63,
		68,
		59,
		67,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		185,
		181,
		171,
		161,
		164,
		-1,
		-1,
		158,
		155,
		135,
		104,
		102,
		95,
		90,
		100,
		80,
		67,
		67,
		62,
		66,
		65,
		60,
		53,
		58,
		73,
		-1,
		232,
		269,
		262,
		230,
		238,
		269,
		-1,
		175,
		167,
		178,
		153,
		155,
		-1,
		-1,
		131,
		122,
		123,
		111,
		108,
		110,
		105,
		96,
		76,
		82,
		60,
		67,
		78,
		70,
		73,
		56,
		45,
		58,
		62,
		-1,
		225,
		245,
		224,
		227,
		251,
		265,
		-1,
		172,
		-1,
		-1,
		184,
		156,
		140,
		130,
		127,
		170,
		125,
		120,
		104,
		102,
		93,
		84,
		84,
		68,
		56,
		53,
		62,
		67,
		58,
		55,
		51,
		44,
		-1,
		214,
		225,
		218,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		177,
		-1,
		167,
		-1,
		150,
		154,
		133,
		136,
		118,
		105,
		97,
		84,
		93,
		68,
		64,
		60,
		49,
		46,
		58,
		41,
		49,
		56,
		239,
		195,
		198,
		209,
		220,
		235,
		239,
		-1,
		184,
		223,
		183,
		-1,
		167,
		-1,
		-1,
		-1,
		164,
		146,
		138,
		138,
		117,
		117,
		91,
		87,
		73,
		69,
		76,
		66,
		56,
		45,
		51,
		39,
		48,
		235,
		226,
		239,
		184,
		184,
		205,
		214,
		235,
		199,
		190,
		217,
		190,
		179,
		174,
		161,
		-1,
		-1,
		169,
		156,
		-1,
		-1,
		124,
		109,
		95,
		84,
		80,
		83,
		91,
		75,
		55,
		44,
		38,
		34,
		-1,
		228,
		227,
		216,
		213,
		189,
		180,
		175,
		202,
		-1,
		-1,
		197,
		218,
		208,
		212,
		221,
		246,
		-1,
		150,
		-1,
		-1,
		149,
		-1,
		-1,
		134,
		114,
		103,
		94,
		80,
		88,
		95,
		106,
		58,
		50,
		43,
		27,
		19,
		212,
		209,
		197,
		195,
		218,
		183,
		171,
		-1,
		184,
		182,
		188,
		195,
		212,
		235,
		-1,
		-1,
		166,
		146,
		-1,
		-1,
		132,
		130,
		119,
		-1,
		109,
		91,
		77,
		104,
		78,
		67,
		61,
		55,
		41,
		36,
		18,
		12,
		221,
		235,
		224,
		220,
		219,
		227,
		176,
		169,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		156,
		152,
		-1,
		-1,
		127,
		120,
		108,
		96,
		86,
		91,
		77,
		73,
		65,
		58,
		53,
		55,
		27,
		31,
		6,
		-1,
		255,
		-1,
		207,
		183,
		197,
		212,
		220,
		-1,
		-1,
		-1,
		173,
		159,
		152,
		140,
		138,
		-1,
		161,
		145,
		126,
		-1,
		96,
		109,
		109,
		77,
		69,
		67,
		57,
		56,
		30,
		16,
		9,
		0,
		-1,
		-1,
		195,
		189,
		-1,
		-1,
		163,
		165,
		-1,
		164,
		153,
		138,
		130,
		-1,
		-1,
		133,
		129,
		-1,
		-1,
		96,
		91,
		80,
		75,
		71,
		53,
		54,
		43,
		32,
		9,
		10,
		-1,
		-1,
		184,
		176,
		170,
		-1,
		148,
		-1,
		166,
		-1,
		133,
		139,
		127,
		-1,
		-1,
		-1,
		127,
		90,
		106,
		98,
		67,
		65,
		56,
		49,
		47,
		37,
		30,
		20,
		-1,
		-1,
		-1,
		166,
		140,
		173,
		164,
		147,
		127,
		119,
		138,
		-1,
		108,
		-1,
		83,
		86,
		91,
		75,
		78,
		72,
		46,
		59,
		32,
		28,
		26,
		172,
		-1,
		142,
		175,
		139,
		133,
		109,
		113,
		129,
		-1,
		105,
		87,
		-1,
		98,
		85,
		89,
		74,
		55,
		42,
		45,
		30,
		23,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		114,
		105,
		-1,
		117,
		99,
		78,
		93,
		78,
		69,
		69,
		79,
		75,
		62,
		60,
		39,
		-1,
		245,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		133,
		106,
		94,
		100,
		96,
		82,
		88,
		88,
		81,
		71,
		68,
		64,
		55,
		61,
		38,
		71,
		-1,
		240,
		-1,
		174,
		-1,
		-1,
		156,
		136,
		128,
		117,
		106,
		104,
		95,
		86,
		108,
		112,
		62,
		50,
		45,
		46,
		-1,
		229,
		228,
		-1,
		175,
		167,
		153,
		-1,
		146,
		-1,
		152,
		113,
		-1,
		115,
		95,
		-1,
		61,
		50,
		-1,
		-1,
		216,
		191,
		-1,
		-1,
		-1,
		176,
		156,
		147,
		131,
		-1,
		106,
		106,
		-1,
		-1,
		-1,
		201,
		200,
		-1,
		169,
		172,
		-1,
		162,
		153,
		161,
		108,
		112,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		184,
		182,
		177,
		174,
		160,
		144,
		122,
		111,
		132,
		-1,
		-1,
		-1,
		182,
		174,
		167,
		-1,
		-1,
		169,
		152,
		133,
		131,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		159,
		-1,
		-1,
		165,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		193,
		-1,
		-1,
		-1,
		155,
		151,
		152,
		-1,
		-1,
		-1,
		-1,
		215,
		216,
		239,
		203,
		-1,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		218,
		216,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		145,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		180,
		-1,
		180,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		193,
		-1,
		165,
		167,
		-1,
		215,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		170,
		177,
		199,
		202,
		238,
		-1,
		189
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		302,
		291,
		302,
		310,
		283,
		290,
		-1,
		309,
		313,
		279,
		273,
		312,
		281,
		287,
		298,
		-1,
		-1,
		-1,
		302,
		301,
		269,
		267,
		276,
		281,
		288,
		-1,
		287,
		-1,
		323,
		302,
		313,
		318,
		262,
		259,
		279,
		298,
		280,
		272,
		338,
		292,
		263,
		257,
		275,
		265,
		274,
		266,
		-1,
		263,
		253,
		275,
		254,
		265,
		257,
		-1,
		-1,
		257,
		258,
		264,
		250,
		256,
		252,
		-1,
		262,
		246,
		-1,
		-1,
		247,
		248,
		232,
		235,
		243,
		241,
		254,
		246,
		241,
		-1,
		-1,
		238,
		234,
		241,
		228,
		224,
		241,
		254,
		236,
		250,
		249,
		-1,
		244,
		262,
		267,
		235,
		233,
		217,
		215,
		233,
		235,
		241,
		241,
		-1,
		253,
		254,
		249,
		257,
		257,
		233,
		220,
		220,
		230,
		223,
		242,
		230,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		253,
		236,
		253,
		245,
		235,
		250,
		243,
		223,
		220,
		218,
		215,
		231,
		229,
		239,
		-1,
		-1,
		309,
		278,
		313,
		270,
		255,
		-1,
		249,
		229,
		235,
		239,
		233,
		226,
		240,
		236,
		-1,
		209,
		208,
		236,
		222,
		233,
		269,
		-1,
		-1,
		267,
		259,
		244,
		247,
		244,
		244,
		244,
		243,
		235,
		221,
		217,
		223,
		226,
		226,
		232,
		203,
		213,
		217,
		215,
		240,
		-1,
		-1,
		275,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		239,
		256,
		246,
		267,
		254,
		245,
		237,
		231,
		219,
		221,
		218,
		231,
		219,
		200,
		225,
		229,
		210,
		231,
		226,
		-1,
		274,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		268,
		-1,
		266,
		254,
		255,
		240,
		237,
		224,
		212,
		225,
		210,
		217,
		216,
		204,
		202,
		232,
		207,
		229,
		226,
		245,
		250,
		244,
		253,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		276,
		289,
		278,
		251,
		254,
		241,
		232,
		219,
		208,
		219,
		208,
		205,
		213,
		196,
		211,
		202,
		201,
		219,
		229,
		237,
		241,
		247,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		277,
		295,
		280,
		278,
		-1,
		250,
		247,
		237,
		215,
		200,
		217,
		209,
		207,
		209,
		191,
		205,
		196,
		214,
		221,
		219,
		223,
		243,
		255,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		320,
		284,
		-1,
		279,
		-1,
		252,
		265,
		-1,
		221,
		217,
		199,
		200,
		195,
		210,
		202,
		187,
		184,
		202,
		205,
		212,
		216,
		232,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		277,
		266,
		265,
		-1,
		256,
		235,
		232,
		220,
		207,
		192,
		193,
		201,
		213,
		192,
		186,
		183,
		203,
		229,
		207,
		218,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		295,
		288,
		276,
		241,
		241,
		235,
		-1,
		231,
		210,
		201,
		190,
		188,
		201,
		193,
		201,
		181,
		179,
		198,
		210,
		201,
		209,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		208,
		231,
		265,
		274,
		260,
		265,
		240,
		233,
		227,
		244,
		227,
		208,
		197,
		189,
		178,
		189,
		197,
		195,
		177,
		186,
		192,
		216,
		197,
		203,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		222,
		229,
		261,
		265,
		273,
		-1,
		232,
		-1,
		221,
		217,
		202,
		197,
		194,
		181,
		180,
		194,
		194,
		184,
		179,
		186,
		221,
		221,
		187,
		207,
		210,
		-1,
		-1,
		-1,
		269,
		267,
		242,
		219,
		203,
		239,
		-1,
		243,
		244,
		-1,
		226,
		220,
		217,
		204,
		200,
		185,
		189,
		191,
		194,
		182,
		188,
		189,
		171,
		195,
		-1,
		195,
		189,
		197,
		187,
		175,
		-1,
		-1,
		-1,
		265,
		244,
		237,
		257,
		198,
		250,
		-1,
		-1,
		228,
		221,
		-1,
		213,
		195,
		197,
		192,
		188,
		190,
		187,
		176,
		189,
		182,
		176,
		170,
		183,
		187,
		188,
		177,
		173,
		170,
		184,
		-1,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		218,
		-1,
		231,
		223,
		219,
		213,
		212,
		208,
		206,
		216,
		200,
		202,
		198,
		190,
		185,
		171,
		164,
		175,
		160,
		178,
		184,
		175,
		170,
		169,
		180,
		-1,
		285,
		271,
		242,
		-1,
		-1,
		231,
		-1,
		195,
		209,
		225,
		-1,
		250,
		229,
		244,
		222,
		218,
		209,
		207,
		208,
		178,
		183,
		185,
		173,
		176,
		165,
		168,
		160,
		182,
		179,
		163,
		165,
		174,
		-1,
		291,
		278,
		236,
		232,
		221,
		241,
		192,
		201,
		212,
		-1,
		-1,
		269,
		-1,
		220,
		225,
		223,
		221,
		197,
		172,
		179,
		197,
		170,
		165,
		170,
		159,
		159,
		154,
		173,
		159,
		157,
		172,
		188,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		207,
		194,
		188,
		-1,
		229,
		-1,
		247,
		235,
		222,
		204,
		244,
		-1,
		171,
		167,
		174,
		-1,
		190,
		-1,
		162,
		165,
		156,
		151,
		148,
		159,
		157,
		166,
		167,
		-1,
		241,
		226,
		219,
		209,
		223,
		194,
		-1,
		235,
		-1,
		-1,
		234,
		228,
		228,
		197,
		194,
		187,
		167,
		159,
		174,
		173,
		160,
		159,
		147,
		147,
		150,
		144,
		157,
		167,
		173,
		165,
		-1,
		-1,
		-1,
		246,
		198,
		206,
		182,
		201,
		-1,
		-1,
		295,
		251,
		237,
		-1,
		189,
		187,
		175,
		165,
		155,
		160,
		161,
		151,
		149,
		145,
		154,
		153,
		146,
		145,
		166,
		159,
		181,
		-1,
		-1,
		195,
		208,
		210,
		179,
		174,
		-1,
		-1,
		-1,
		241,
		237,
		208,
		187,
		176,
		-1,
		-1,
		159,
		152,
		146,
		149,
		137,
		157,
		164,
		152,
		139,
		154,
		164,
		172,
		171,
		-1,
		198,
		185,
		-1,
		-1,
		173,
		163,
		-1,
		-1,
		-1,
		-1,
		215,
		165,
		154,
		149,
		153,
		158,
		-1,
		132,
		143,
		136,
		155,
		162,
		154,
		139,
		133,
		144,
		159,
		176,
		-1,
		-1,
		187,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		177,
		171,
		142,
		135,
		139,
		-1,
		134,
		136,
		133,
		145,
		150,
		154,
		145,
		127,
		141,
		144,
		157,
		171,
		175,
		210,
		-1,
		140,
		-1,
		-1,
		-1,
		179,
		180,
		175,
		152,
		131,
		124,
		121,
		120,
		125,
		136,
		145,
		156,
		121,
		125,
		140,
		145,
		149,
		166,
		170,
		-1,
		-1,
		138,
		134,
		169,
		181,
		153,
		202,
		-1,
		-1,
		120,
		113,
		123,
		116,
		129,
		132,
		117,
		119,
		137,
		150,
		144,
		154,
		169,
		164,
		-1,
		-1,
		-1,
		136,
		-1,
		152,
		-1,
		-1,
		143,
		193,
		140,
		122,
		118,
		104,
		111,
		105,
		107,
		112,
		131,
		126,
		135,
		140,
		144,
		167,
		156,
		195,
		-1,
		-1,
		151,
		-1,
		-1,
		-1,
		102,
		121,
		116,
		122,
		127,
		118,
		155,
		152,
		-1,
		101,
		134,
		102,
		116,
		112,
		119,
		124,
		130,
		134,
		141,
		157,
		156,
		151,
		187,
		178,
		184,
		-1,
		-1,
		144,
		133,
		122,
		128,
		-1,
		95,
		118,
		108,
		98,
		104,
		-1,
		-1,
		119,
		116,
		114,
		94,
		100,
		105,
		108,
		146,
		122,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		98,
		135,
		128,
		96,
		104,
		135,
		-1,
		85,
		77,
		105,
		90,
		98,
		-1,
		-1,
		92,
		83,
		88,
		97,
		98,
		129,
		128,
		141,
		144,
		149,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		91,
		111,
		90,
		93,
		117,
		131,
		-1,
		76,
		-1,
		-1,
		121,
		111,
		101,
		91,
		88,
		135,
		111,
		106,
		112,
		114,
		138,
		129,
		154,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		80,
		91,
		84,
		-1,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		137,
		-1,
		128,
		-1,
		111,
		115,
		119,
		122,
		137,
		124,
		131,
		148,
		154,
		143,
		153,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		105,
		61,
		64,
		75,
		86,
		101,
		105,
		-1,
		60,
		96,
		105,
		-1,
		146,
		-1,
		-1,
		-1,
		125,
		132,
		124,
		140,
		136,
		136,
		132,
		136,
		148,
		155,
		165,
		167,
		159,
		163,
		176,
		187,
		190,
		101,
		92,
		105,
		50,
		50,
		71,
		80,
		101,
		55,
		53,
		90,
		94,
		109,
		114,
		138,
		-1,
		-1,
		148,
		142,
		-1,
		-1,
		143,
		153,
		136,
		138,
		142,
		156,
		168,
		176,
		166,
		164,
		158,
		190,
		-1,
		94,
		93,
		82,
		79,
		55,
		46,
		41,
		68,
		-1,
		-1,
		53,
		81,
		64,
		68,
		84,
		109,
		-1,
		145,
		-1,
		-1,
		169,
		-1,
		-1,
		195,
		158,
		147,
		138,
		144,
		150,
		161,
		183,
		172,
		173,
		163,
		173,
		186,
		78,
		75,
		63,
		61,
		84,
		49,
		37,
		-1,
		32,
		39,
		44,
		51,
		68,
		98,
		-1,
		-1,
		161,
		152,
		-1,
		-1,
		188,
		191,
		180,
		-1,
		170,
		143,
		148,
		173,
		180,
		181,
		175,
		169,
		176,
		175,
		183,
		191,
		87,
		101,
		90,
		86,
		85,
		93,
		42,
		35,
		29,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		165,
		165,
		168,
		172,
		167,
		178,
		170,
		174,
		191,
		-1,
		121,
		-1,
		73,
		17,
		23,
		38,
		46,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		201,
		169,
		174,
		169,
		173,
		184,
		173,
		176,
		190,
		185,
		-1,
		-1,
		0,
		19,
		-1,
		-1,
		50,
		69,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		157,
		183,
		172,
		180,
		175,
		177,
		183,
		186,
		175,
		179,
		191,
		-1,
		-1,
		23,
		31,
		36,
		-1,
		59,
		-1,
		174,
		-1,
		141,
		148,
		136,
		-1,
		-1,
		-1,
		188,
		151,
		167,
		190,
		195,
		193,
		184,
		181,
		188,
		186,
		182,
		193,
		-1,
		-1,
		-1,
		89,
		66,
		181,
		172,
		155,
		135,
		127,
		147,
		-1,
		169,
		-1,
		144,
		147,
		172,
		189,
		206,
		199,
		184,
		199,
		189,
		180,
		189,
		95,
		-1,
		70,
		129,
		112,
		141,
		107,
		119,
		183,
		-1,
		166,
		148,
		-1,
		176,
		166,
		214,
		189,
		197,
		184,
		185,
		186,
		186,
		-1,
		-1,
		-1,
		85,
		84,
		83,
		94,
		102,
		100,
		118,
		-1,
		171,
		153,
		139,
		156,
		156,
		147,
		155,
		204,
		200,
		202,
		201,
		179,
		-1,
		188,
		-1,
		-1,
		108,
		-1,
		-1,
		-1,
		111,
		133,
		128,
		120,
		132,
		141,
		136,
		138,
		151,
		159,
		157,
		154,
		166,
		162,
		182,
		178,
		210,
		-1,
		195,
		-1,
		115,
		-1,
		-1,
		129,
		115,
		127,
		138,
		128,
		128,
		133,
		131,
		153,
		183,
		169,
		167,
		172,
		177,
		-1,
		205,
		206,
		-1,
		148,
		140,
		126,
		-1,
		119,
		-1,
		174,
		135,
		-1,
		160,
		140,
		-1,
		178,
		174,
		-1,
		-1,
		204,
		164,
		-1,
		-1,
		-1,
		149,
		129,
		169,
		153,
		-1,
		151,
		151,
		-1,
		-1,
		-1,
		189,
		173,
		-1,
		142,
		145,
		-1,
		136,
		142,
		171,
		153,
		157,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		157,
		162,
		150,
		167,
		153,
		155,
		167,
		156,
		177,
		-1,
		-1,
		-1,
		170,
		162,
		162,
		-1,
		-1,
		180,
		163,
		163,
		176,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		171,
		-1,
		-1,
		176,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		181,
		-1,
		-1,
		-1,
		172,
		179,
		187,
		-1,
		-1,
		-1,
		-1,
		202,
		203,
		227,
		202,
		-1,
		-1,
		-1,
		186,
		186,
		-1,
		-1,
		205,
		203,
		-1,
		-1,
		-1,
		214,
		198,
		-1,
		190,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		223,
		-1,
		-1,
		-1,
		219,
		-1,
		225,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		232,
		224,
		238,
		-1,
		210,
		212,
		-1,
		260,
		-1,
		-1,
		247,
		238,
		-1,
		-1,
		215,
		222,
		244,
		247,
		277,
		-1,
		234
	],
	[
		-1,
		303,
		292,
		303,
		311,
		284,
		291,
		-1,
		310,
		314,
		280,
		274,
		313,
		282,
		288,
		299,
		-1,
		-1,
		-1,
		303,
		302,
		270,
		268,
		277,
		282,
		289,
		-1,
		288,
		-1,
		324,
		303,
		314,
		319,
		263,
		260,
		280,
		299,
		281,
		273,
		339,
		293,
		264,
		258,
		276,
		266,
		275,
		267,
		-1,
		264,
		254,
		276,
		255,
		266,
		258,
		-1,
		-1,
		258,
		259,
		265,
		251,
		257,
		253,
		-1,
		263,
		247,
		-1,
		-1,
		248,
		249,
		233,
		236,
		244,
		242,
		255,
		247,
		242,
		-1,
		-1,
		239,
		235,
		242,
		229,
		225,
		242,
		255,
		237,
		251,
		250,
		-1,
		245,
		263,
		268,
		236,
		234,
		218,
		216,
		234,
		236,
		242,
		242,
		-1,
		254,
		255,
		250,
		258,
		258,
		234,
		221,
		221,
		231,
		224,
		243,
		231,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		254,
		237,
		254,
		246,
		236,
		251,
		244,
		224,
		221,
		219,
		216,
		232,
		230,
		240,
		-1,
		-1,
		310,
		279,
		314,
		271,
		256,
		-1,
		250,
		230,
		236,
		240,
		234,
		227,
		241,
		237,
		-1,
		210,
		209,
		237,
		223,
		234,
		270,
		-1,
		-1,
		268,
		260,
		245,
		248,
		245,
		245,
		245,
		244,
		236,
		222,
		218,
		224,
		227,
		227,
		233,
		204,
		214,
		218,
		216,
		241,
		-1,
		-1,
		276,
		-1,
		-1,
		267,
		250,
		-1,
		233,
		240,
		240,
		257,
		247,
		268,
		255,
		246,
		238,
		232,
		220,
		222,
		219,
		232,
		220,
		201,
		226,
		230,
		211,
		232,
		227,
		-1,
		275,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		226,
		229,
		235,
		259,
		269,
		-1,
		267,
		255,
		256,
		241,
		238,
		225,
		213,
		226,
		211,
		218,
		217,
		205,
		203,
		233,
		208,
		230,
		227,
		246,
		251,
		245,
		254,
		-1,
		275,
		271,
		267,
		274,
		223,
		-1,
		-1,
		263,
		-1,
		277,
		290,
		279,
		252,
		255,
		242,
		233,
		220,
		209,
		220,
		209,
		206,
		214,
		197,
		212,
		203,
		202,
		220,
		230,
		238,
		242,
		248,
		-1,
		325,
		-1,
		267,
		251,
		253,
		225,
		246,
		-1,
		283,
		278,
		296,
		281,
		279,
		-1,
		251,
		248,
		238,
		216,
		201,
		218,
		210,
		208,
		210,
		192,
		206,
		197,
		215,
		222,
		220,
		224,
		244,
		256,
		285,
		275,
		-1,
		257,
		262,
		221,
		229,
		248,
		321,
		285,
		-1,
		280,
		-1,
		253,
		266,
		-1,
		222,
		218,
		200,
		201,
		196,
		211,
		203,
		188,
		185,
		203,
		206,
		213,
		217,
		233,
		-1,
		-1,
		270,
		274,
		263,
		214,
		233,
		257,
		294,
		278,
		267,
		266,
		-1,
		257,
		236,
		233,
		221,
		208,
		193,
		194,
		202,
		214,
		193,
		187,
		184,
		204,
		230,
		208,
		219,
		-1,
		-1,
		-1,
		295,
		-1,
		-1,
		240,
		211,
		235,
		277,
		296,
		289,
		277,
		242,
		242,
		236,
		-1,
		232,
		211,
		202,
		191,
		189,
		202,
		194,
		202,
		182,
		180,
		199,
		211,
		202,
		210,
		-1,
		-1,
		-1,
		270,
		259,
		260,
		209,
		232,
		266,
		275,
		261,
		266,
		241,
		234,
		228,
		245,
		228,
		209,
		198,
		190,
		179,
		190,
		198,
		196,
		178,
		187,
		193,
		217,
		198,
		204,
		-1,
		-1,
		277,
		267,
		251,
		253,
		250,
		223,
		230,
		262,
		266,
		274,
		-1,
		233,
		-1,
		222,
		218,
		203,
		198,
		195,
		182,
		181,
		195,
		195,
		185,
		180,
		187,
		222,
		222,
		188,
		208,
		211,
		-1,
		-1,
		-1,
		270,
		268,
		243,
		220,
		204,
		240,
		-1,
		244,
		245,
		-1,
		227,
		221,
		218,
		205,
		201,
		186,
		190,
		192,
		195,
		183,
		189,
		190,
		172,
		196,
		-1,
		196,
		190,
		198,
		188,
		176,
		-1,
		-1,
		-1,
		266,
		245,
		238,
		258,
		199,
		251,
		-1,
		-1,
		229,
		222,
		-1,
		214,
		196,
		198,
		193,
		189,
		191,
		188,
		177,
		190,
		183,
		177,
		171,
		184,
		188,
		189,
		178,
		174,
		171,
		185,
		-1,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		219,
		-1,
		232,
		224,
		220,
		214,
		213,
		209,
		207,
		217,
		201,
		203,
		199,
		191,
		186,
		172,
		165,
		176,
		161,
		179,
		185,
		176,
		171,
		170,
		181,
		-1,
		286,
		272,
		243,
		-1,
		-1,
		232,
		-1,
		196,
		210,
		226,
		-1,
		251,
		230,
		245,
		223,
		219,
		210,
		208,
		209,
		179,
		184,
		186,
		174,
		177,
		166,
		169,
		161,
		183,
		180,
		164,
		166,
		175,
		-1,
		292,
		279,
		237,
		233,
		222,
		242,
		193,
		202,
		213,
		-1,
		-1,
		270,
		-1,
		221,
		226,
		224,
		222,
		198,
		173,
		180,
		198,
		171,
		166,
		171,
		160,
		160,
		155,
		174,
		160,
		158,
		173,
		189,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		208,
		195,
		189,
		-1,
		230,
		-1,
		248,
		236,
		223,
		205,
		245,
		-1,
		172,
		168,
		175,
		-1,
		191,
		-1,
		163,
		166,
		157,
		152,
		149,
		160,
		158,
		167,
		168,
		-1,
		242,
		227,
		220,
		210,
		224,
		195,
		-1,
		236,
		-1,
		-1,
		235,
		229,
		229,
		198,
		195,
		188,
		168,
		160,
		175,
		174,
		161,
		160,
		148,
		148,
		151,
		145,
		158,
		168,
		174,
		166,
		-1,
		-1,
		-1,
		247,
		199,
		207,
		183,
		202,
		-1,
		-1,
		296,
		252,
		238,
		-1,
		190,
		188,
		176,
		166,
		156,
		161,
		162,
		152,
		150,
		146,
		155,
		154,
		147,
		146,
		167,
		160,
		182,
		-1,
		-1,
		196,
		209,
		211,
		180,
		175,
		-1,
		-1,
		-1,
		242,
		238,
		209,
		188,
		177,
		-1,
		-1,
		160,
		153,
		147,
		150,
		138,
		158,
		165,
		153,
		140,
		155,
		165,
		173,
		172,
		-1,
		199,
		186,
		-1,
		-1,
		174,
		164,
		-1,
		-1,
		-1,
		-1,
		216,
		166,
		155,
		150,
		154,
		159,
		-1,
		133,
		144,
		137,
		156,
		163,
		155,
		140,
		134,
		145,
		160,
		177,
		-1,
		-1,
		188,
		-1,
		150,
		-1,
		-1,
		-1,
		-1,
		178,
		172,
		143,
		136,
		140,
		-1,
		135,
		137,
		134,
		146,
		151,
		155,
		146,
		128,
		142,
		145,
		158,
		172,
		176,
		211,
		-1,
		141,
		-1,
		-1,
		-1,
		180,
		181,
		176,
		153,
		132,
		125,
		122,
		121,
		126,
		137,
		146,
		157,
		122,
		126,
		141,
		146,
		150,
		167,
		171,
		-1,
		-1,
		139,
		135,
		170,
		182,
		154,
		203,
		-1,
		-1,
		121,
		114,
		124,
		117,
		130,
		133,
		118,
		120,
		138,
		151,
		145,
		155,
		170,
		165,
		-1,
		-1,
		-1,
		137,
		-1,
		153,
		-1,
		-1,
		144,
		194,
		141,
		123,
		119,
		105,
		112,
		106,
		108,
		113,
		132,
		127,
		136,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		103,
		122,
		117,
		123,
		128,
		119,
		156,
		153,
		-1,
		102,
		135,
		103,
		117,
		113,
		120,
		125,
		131,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		145,
		134,
		123,
		129,
		-1,
		96,
		119,
		109,
		99,
		105,
		-1,
		-1,
		120,
		117,
		115,
		95,
		101,
		106,
		109,
		147,
		123,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		99,
		136,
		129,
		97,
		105,
		136,
		-1,
		86,
		78,
		106,
		91,
		99,
		-1,
		-1,
		93,
		84,
		89,
		98,
		99,
		130,
		129,
		142,
		145,
		150,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		92,
		112,
		91,
		94,
		118,
		132,
		-1,
		77,
		-1,
		-1,
		122,
		112,
		102,
		92,
		89,
		136,
		112,
		107,
		113,
		115,
		139,
		130,
		155,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		81,
		92,
		85,
		-1,
		-1,
		-1,
		-1,
		71,
		-1,
		-1,
		138,
		-1,
		129,
		-1,
		112,
		116,
		120,
		123,
		138,
		125,
		132,
		149,
		155,
		144,
		154,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		106,
		62,
		65,
		76,
		87,
		102,
		106,
		-1,
		61,
		97,
		106,
		-1,
		147,
		-1,
		-1,
		-1,
		126,
		133,
		125,
		141,
		137,
		137,
		133,
		137,
		149,
		156,
		166,
		168,
		160,
		164,
		177,
		188,
		191,
		102,
		93,
		106,
		51,
		51,
		72,
		81,
		102,
		56,
		54,
		91,
		95,
		110,
		115,
		139,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		144,
		154,
		137,
		139,
		143,
		157,
		169,
		177,
		167,
		165,
		159,
		191,
		-1,
		95,
		94,
		83,
		80,
		56,
		47,
		42,
		69,
		-1,
		-1,
		54,
		82,
		65,
		69,
		85,
		110,
		-1,
		143,
		-1,
		-1,
		170,
		-1,
		-1,
		193,
		159,
		148,
		139,
		145,
		151,
		162,
		184,
		173,
		174,
		164,
		174,
		187,
		79,
		76,
		64,
		62,
		85,
		50,
		38,
		-1,
		33,
		40,
		45,
		52,
		69,
		99,
		-1,
		-1,
		159,
		139,
		-1,
		-1,
		189,
		189,
		178,
		-1,
		168,
		144,
		149,
		174,
		181,
		182,
		176,
		170,
		177,
		176,
		184,
		192,
		88,
		102,
		91,
		87,
		86,
		94,
		43,
		36,
		30,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		145,
		-1,
		-1,
		186,
		179,
		167,
		155,
		145,
		155,
		166,
		166,
		169,
		173,
		168,
		179,
		171,
		175,
		192,
		-1,
		122,
		-1,
		74,
		18,
		24,
		39,
		47,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		220,
		204,
		185,
		-1,
		155,
		168,
		202,
		170,
		175,
		170,
		174,
		185,
		174,
		177,
		191,
		186,
		-1,
		-1,
		17,
		0,
		-1,
		-1,
		35,
		54,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		192,
		188,
		-1,
		-1,
		142,
		180,
		173,
		181,
		176,
		178,
		184,
		187,
		176,
		180,
		192,
		-1,
		-1,
		4,
		16,
		21,
		-1,
		44,
		-1,
		159,
		-1,
		126,
		133,
		121,
		-1,
		-1,
		-1,
		173,
		136,
		152,
		175,
		196,
		194,
		185,
		182,
		189,
		187,
		183,
		192,
		-1,
		-1,
		-1,
		74,
		51,
		166,
		157,
		140,
		120,
		112,
		132,
		-1,
		154,
		-1,
		129,
		132,
		157,
		190,
		198,
		184,
		180,
		193,
		187,
		181,
		182,
		80,
		-1,
		55,
		114,
		97,
		126,
		92,
		104,
		168,
		-1,
		151,
		133,
		-1,
		161,
		151,
		199,
		174,
		183,
		176,
		170,
		171,
		179,
		-1,
		-1,
		-1,
		70,
		69,
		68,
		79,
		87,
		85,
		103,
		-1,
		156,
		138,
		124,
		141,
		141,
		132,
		140,
		189,
		185,
		188,
		186,
		164,
		-1,
		173,
		-1,
		-1,
		93,
		-1,
		-1,
		-1,
		96,
		118,
		113,
		105,
		117,
		126,
		121,
		123,
		136,
		144,
		142,
		139,
		151,
		147,
		167,
		163,
		195,
		-1,
		180,
		-1,
		100,
		-1,
		-1,
		114,
		100,
		112,
		123,
		113,
		113,
		118,
		116,
		138,
		168,
		154,
		152,
		157,
		162,
		-1,
		190,
		191,
		-1,
		133,
		125,
		111,
		-1,
		104,
		-1,
		159,
		120,
		-1,
		145,
		125,
		-1,
		163,
		159,
		-1,
		-1,
		189,
		149,
		-1,
		-1,
		-1,
		134,
		114,
		154,
		138,
		-1,
		136,
		136,
		-1,
		-1,
		-1,
		174,
		158,
		-1,
		127,
		130,
		-1,
		121,
		127,
		156,
		138,
		142,
		-1,
		-1,
		-1,
		183,
		164,
		158,
		142,
		147,
		135,
		152,
		138,
		140,
		152,
		141,
		162,
		-1,
		-1,
		-1,
		155,
		147,
		147,
		-1,
		-1,
		165,
		148,
		148,
		161,
		-1,
		-1,
		-1,
		177,
		158,
		-1,
		-1,
		156,
		-1,
		-1,
		161,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		166,
		-1,
		-1,
		-1,
		157,
		164,
		172,
		-1,
		-1,
		-1,
		-1,
		187,
		188,
		212,
		187,
		-1,
		-1,
		-1,
		171,
		171,
		-1,
		-1,
		190,
		188,
		-1,
		-1,
		-1,
		199,
		183,
		-1,
		175,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		204,
		-1,
		210,
		185,
		192,
		-1,
		-1,
		-1,
		-1,
		217,
		209,
		223,
		-1,
		195,
		197,
		-1,
		245,
		-1,
		-1,
		232,
		223,
		-1,
		-1,
		200,
		207,
		229,
		232,
		262,
		-1,
		219
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		316,
		305,
		316,
		324,
		297,
		304,
		-1,
		323,
		327,
		293,
		287,
		326,
		295,
		301,
		312,
		-1,
		-1,
		-1,
		316,
		315,
		283,
		281,
		290,
		295,
		302,
		-1,
		301,
		-1,
		337,
		316,
		327,
		332,
		276,
		273,
		293,
		312,
		294,
		286,
		352,
		306,
		277,
		271,
		289,
		279,
		288,
		280,
		-1,
		277,
		267,
		289,
		268,
		279,
		271,
		-1,
		-1,
		271,
		272,
		278,
		264,
		270,
		266,
		-1,
		276,
		260,
		-1,
		-1,
		261,
		262,
		246,
		249,
		257,
		255,
		268,
		260,
		255,
		-1,
		-1,
		252,
		248,
		255,
		242,
		238,
		255,
		268,
		250,
		264,
		263,
		-1,
		256,
		274,
		281,
		249,
		247,
		231,
		229,
		247,
		249,
		255,
		255,
		-1,
		265,
		266,
		261,
		269,
		271,
		247,
		234,
		234,
		244,
		237,
		256,
		244,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		265,
		248,
		265,
		257,
		247,
		262,
		255,
		237,
		234,
		232,
		229,
		245,
		243,
		253,
		-1,
		-1,
		326,
		295,
		330,
		287,
		272,
		-1,
		261,
		241,
		247,
		251,
		245,
		238,
		252,
		248,
		-1,
		223,
		222,
		250,
		236,
		247,
		286,
		-1,
		-1,
		284,
		276,
		261,
		264,
		261,
		261,
		256,
		255,
		247,
		233,
		229,
		235,
		238,
		238,
		244,
		217,
		227,
		231,
		229,
		254,
		-1,
		-1,
		289,
		-1,
		-1,
		283,
		266,
		-1,
		249,
		256,
		256,
		273,
		263,
		284,
		266,
		257,
		249,
		243,
		231,
		233,
		230,
		243,
		231,
		214,
		239,
		243,
		224,
		245,
		240,
		-1,
		288,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		242,
		245,
		251,
		275,
		285,
		-1,
		278,
		266,
		267,
		252,
		249,
		236,
		224,
		237,
		222,
		229,
		228,
		218,
		216,
		246,
		221,
		243,
		240,
		259,
		264,
		258,
		267,
		-1,
		291,
		287,
		283,
		290,
		239,
		-1,
		-1,
		279,
		-1,
		293,
		306,
		290,
		263,
		266,
		253,
		244,
		231,
		220,
		231,
		220,
		217,
		225,
		210,
		225,
		216,
		215,
		233,
		243,
		251,
		255,
		261,
		-1,
		341,
		-1,
		283,
		267,
		269,
		241,
		262,
		-1,
		299,
		294,
		307,
		292,
		292,
		-1,
		262,
		259,
		249,
		227,
		212,
		229,
		221,
		219,
		223,
		205,
		219,
		210,
		228,
		235,
		233,
		237,
		257,
		269,
		301,
		291,
		-1,
		273,
		278,
		237,
		245,
		264,
		334,
		298,
		-1,
		293,
		-1,
		264,
		277,
		-1,
		233,
		229,
		211,
		212,
		207,
		222,
		216,
		201,
		198,
		216,
		219,
		226,
		230,
		246,
		-1,
		-1,
		286,
		290,
		279,
		230,
		249,
		273,
		310,
		291,
		280,
		279,
		-1,
		270,
		247,
		244,
		232,
		219,
		204,
		205,
		213,
		226,
		205,
		200,
		197,
		217,
		243,
		221,
		233,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		256,
		227,
		251,
		293,
		309,
		302,
		290,
		255,
		255,
		249,
		-1,
		243,
		222,
		213,
		202,
		200,
		213,
		210,
		215,
		195,
		193,
		212,
		224,
		215,
		226,
		-1,
		-1,
		-1,
		286,
		275,
		276,
		225,
		248,
		282,
		288,
		274,
		279,
		254,
		247,
		241,
		256,
		239,
		220,
		209,
		201,
		190,
		206,
		214,
		209,
		191,
		200,
		206,
		230,
		214,
		220,
		-1,
		-1,
		293,
		283,
		267,
		269,
		266,
		239,
		246,
		278,
		279,
		290,
		-1,
		246,
		-1,
		235,
		230,
		214,
		209,
		206,
		198,
		197,
		206,
		208,
		198,
		193,
		200,
		235,
		235,
		204,
		224,
		227,
		-1,
		-1,
		-1,
		286,
		284,
		259,
		236,
		220,
		256,
		-1,
		260,
		261,
		-1,
		240,
		234,
		231,
		216,
		212,
		202,
		206,
		204,
		211,
		199,
		202,
		203,
		185,
		212,
		-1,
		212,
		206,
		214,
		204,
		192,
		-1,
		-1,
		-1,
		282,
		261,
		254,
		274,
		215,
		267,
		-1,
		-1,
		245,
		238,
		-1,
		227,
		209,
		214,
		209,
		205,
		207,
		204,
		193,
		206,
		199,
		190,
		187,
		200,
		204,
		205,
		194,
		190,
		187,
		201,
		-1,
		301,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		235,
		-1,
		248,
		240,
		236,
		230,
		226,
		222,
		220,
		233,
		217,
		219,
		215,
		207,
		202,
		188,
		181,
		192,
		177,
		195,
		201,
		192,
		187,
		186,
		197,
		-1,
		302,
		288,
		259,
		-1,
		-1,
		248,
		-1,
		212,
		226,
		242,
		-1,
		264,
		243,
		258,
		236,
		232,
		226,
		224,
		225,
		195,
		200,
		202,
		190,
		193,
		182,
		185,
		177,
		199,
		196,
		180,
		182,
		191,
		-1,
		308,
		295,
		253,
		249,
		238,
		258,
		209,
		218,
		229,
		-1,
		-1,
		286,
		-1,
		234,
		242,
		240,
		238,
		214,
		189,
		196,
		214,
		187,
		182,
		187,
		176,
		176,
		171,
		190,
		176,
		174,
		189,
		205,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		224,
		211,
		205,
		-1,
		246,
		-1,
		264,
		252,
		239,
		221,
		261,
		-1,
		188,
		184,
		191,
		-1,
		207,
		-1,
		179,
		182,
		173,
		168,
		165,
		176,
		174,
		183,
		184,
		-1,
		258,
		243,
		236,
		226,
		240,
		211,
		-1,
		254,
		-1,
		-1,
		251,
		245,
		245,
		214,
		211,
		204,
		184,
		176,
		191,
		190,
		177,
		176,
		164,
		164,
		167,
		161,
		174,
		184,
		190,
		182,
		-1,
		-1,
		-1,
		263,
		215,
		223,
		199,
		220,
		-1,
		-1,
		312,
		268,
		254,
		-1,
		206,
		204,
		192,
		182,
		172,
		177,
		178,
		168,
		166,
		162,
		171,
		170,
		163,
		162,
		183,
		176,
		198,
		-1,
		-1,
		212,
		225,
		227,
		205,
		200,
		-1,
		-1,
		-1,
		258,
		259,
		225,
		204,
		193,
		-1,
		-1,
		176,
		169,
		163,
		166,
		154,
		174,
		181,
		169,
		156,
		171,
		181,
		189,
		182,
		-1,
		215,
		202,
		-1,
		-1,
		199,
		189,
		-1,
		-1,
		-1,
		-1,
		237,
		182,
		171,
		166,
		170,
		175,
		-1,
		149,
		160,
		153,
		172,
		179,
		171,
		156,
		150,
		161,
		176,
		187,
		-1,
		-1,
		213,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		194,
		188,
		159,
		152,
		156,
		-1,
		151,
		153,
		150,
		162,
		167,
		171,
		162,
		144,
		158,
		161,
		167,
		181,
		185,
		236,
		-1,
		166,
		-1,
		-1,
		-1,
		205,
		206,
		192,
		169,
		148,
		141,
		138,
		137,
		142,
		153,
		162,
		173,
		138,
		142,
		156,
		155,
		159,
		176,
		180,
		-1,
		-1,
		164,
		160,
		195,
		207,
		179,
		219,
		-1,
		-1,
		137,
		130,
		140,
		133,
		146,
		149,
		134,
		136,
		154,
		160,
		154,
		164,
		179,
		174,
		-1,
		-1,
		-1,
		162,
		-1,
		178,
		-1,
		-1,
		169,
		210,
		157,
		139,
		135,
		121,
		128,
		122,
		124,
		129,
		148,
		143,
		152,
		150,
		154,
		177,
		166,
		205,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		128,
		147,
		142,
		148,
		153,
		144,
		172,
		169,
		-1,
		118,
		151,
		119,
		133,
		129,
		136,
		141,
		147,
		144,
		151,
		167,
		166,
		161,
		197,
		188,
		194,
		-1,
		-1,
		161,
		150,
		139,
		145,
		-1,
		121,
		144,
		134,
		124,
		130,
		-1,
		-1,
		136,
		133,
		131,
		111,
		117,
		122,
		125,
		152,
		128,
		140,
		144,
		148,
		154,
		159,
		164,
		170,
		185,
		200,
		-1,
		115,
		152,
		145,
		113,
		121,
		152,
		-1,
		111,
		103,
		131,
		116,
		124,
		-1,
		-1,
		109,
		100,
		105,
		114,
		115,
		146,
		145,
		148,
		154,
		155,
		147,
		146,
		164,
		168,
		177,
		184,
		174,
		187,
		191,
		-1,
		108,
		128,
		107,
		110,
		134,
		148,
		-1,
		102,
		-1,
		-1,
		147,
		134,
		118,
		108,
		105,
		152,
		128,
		123,
		129,
		131,
		146,
		137,
		162,
		155,
		155,
		158,
		173,
		178,
		170,
		184,
		184,
		185,
		-1,
		97,
		108,
		101,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		147,
		-1,
		145,
		-1,
		128,
		132,
		136,
		139,
		154,
		141,
		140,
		148,
		154,
		153,
		159,
		159,
		160,
		169,
		180,
		192,
		191,
		192,
		122,
		78,
		81,
		92,
		103,
		118,
		122,
		-1,
		86,
		122,
		132,
		-1,
		137,
		-1,
		-1,
		-1,
		142,
		149,
		141,
		157,
		153,
		153,
		132,
		136,
		149,
		156,
		166,
		177,
		169,
		173,
		186,
		197,
		200,
		118,
		109,
		122,
		67,
		67,
		88,
		97,
		118,
		82,
		79,
		116,
		121,
		136,
		141,
		131,
		-1,
		-1,
		165,
		159,
		-1,
		-1,
		160,
		140,
		128,
		138,
		142,
		156,
		168,
		181,
		169,
		174,
		168,
		200,
		-1,
		111,
		110,
		99,
		96,
		72,
		63,
		58,
		85,
		-1,
		-1,
		80,
		107,
		91,
		95,
		111,
		136,
		-1,
		115,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		145,
		134,
		125,
		130,
		150,
		161,
		183,
		165,
		182,
		173,
		183,
		187,
		95,
		92,
		80,
		78,
		101,
		66,
		54,
		-1,
		62,
		65,
		71,
		78,
		95,
		125,
		-1,
		-1,
		131,
		111,
		-1,
		-1,
		163,
		161,
		150,
		-1,
		140,
		122,
		127,
		157,
		159,
		161,
		168,
		162,
		169,
		177,
		188,
		180,
		104,
		118,
		107,
		103,
		102,
		110,
		59,
		52,
		59,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		121,
		117,
		-1,
		-1,
		158,
		151,
		139,
		127,
		117,
		127,
		144,
		144,
		147,
		152,
		160,
		171,
		167,
		171,
		174,
		-1,
		138,
		-1,
		90,
		51,
		57,
		72,
		80,
		-1,
		-1,
		-1,
		138,
		124,
		117,
		105,
		103,
		-1,
		192,
		176,
		157,
		-1,
		127,
		140,
		180,
		148,
		153,
		148,
		163,
		174,
		165,
		173,
		167,
		170,
		-1,
		-1,
		50,
		33,
		-1,
		-1,
		0,
		22,
		-1,
		129,
		118,
		103,
		95,
		-1,
		-1,
		164,
		160,
		-1,
		-1,
		114,
		152,
		151,
		159,
		154,
		159,
		171,
		167,
		163,
		173,
		164,
		-1,
		-1,
		28,
		20,
		14,
		-1,
		16,
		-1,
		131,
		-1,
		98,
		105,
		93,
		-1,
		-1,
		-1,
		145,
		108,
		124,
		147,
		173,
		171,
		162,
		155,
		162,
		165,
		158,
		164,
		-1,
		-1,
		-1,
		46,
		23,
		138,
		129,
		112,
		92,
		84,
		104,
		-1,
		126,
		-1,
		101,
		104,
		129,
		168,
		170,
		156,
		152,
		165,
		159,
		156,
		154,
		52,
		-1,
		27,
		86,
		69,
		98,
		64,
		76,
		140,
		-1,
		123,
		105,
		-1,
		133,
		123,
		171,
		146,
		155,
		148,
		142,
		143,
		151,
		-1,
		-1,
		-1,
		42,
		41,
		40,
		51,
		59,
		57,
		75,
		-1,
		128,
		110,
		96,
		113,
		113,
		104,
		112,
		161,
		157,
		160,
		158,
		136,
		-1,
		145,
		-1,
		-1,
		65,
		-1,
		-1,
		-1,
		68,
		90,
		85,
		77,
		89,
		98,
		93,
		95,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		135,
		167,
		-1,
		152,
		-1,
		72,
		-1,
		-1,
		86,
		72,
		84,
		95,
		85,
		85,
		90,
		88,
		110,
		140,
		126,
		124,
		129,
		134,
		-1,
		162,
		163,
		-1,
		105,
		97,
		83,
		-1,
		76,
		-1,
		131,
		92,
		-1,
		117,
		97,
		-1,
		135,
		131,
		-1,
		-1,
		161,
		121,
		-1,
		-1,
		-1,
		106,
		86,
		126,
		110,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		146,
		130,
		-1,
		99,
		102,
		-1,
		93,
		99,
		128,
		110,
		114,
		-1,
		-1,
		-1,
		155,
		136,
		130,
		114,
		119,
		107,
		124,
		110,
		112,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		127,
		119,
		119,
		-1,
		-1,
		137,
		120,
		120,
		133,
		-1,
		-1,
		-1,
		149,
		130,
		-1,
		-1,
		128,
		-1,
		-1,
		133,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		138,
		-1,
		-1,
		-1,
		129,
		136,
		144,
		-1,
		-1,
		-1,
		-1,
		159,
		160,
		184,
		159,
		-1,
		-1,
		-1,
		143,
		143,
		-1,
		-1,
		162,
		160,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		147,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		176,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		172,
		179,
		201,
		204,
		234,
		-1,
		191
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		327,
		331,
		297,
		291,
		330,
		299,
		305,
		316,
		-1,
		-1,
		-1,
		320,
		319,
		287,
		285,
		294,
		299,
		306,
		-1,
		305,
		-1,
		341,
		320,
		331,
		336,
		280,
		277,
		297,
		316,
		298,
		290,
		356,
		310,
		281,
		275,
		293,
		283,
		292,
		284,
		-1,
		281,
		271,
		293,
		272,
		283,
		275,
		-1,
		-1,
		275,
		276,
		282,
		268,
		274,
		270,
		-1,
		280,
		264,
		-1,
		-1,
		265,
		266,
		250,
		253,
		261,
		259,
		272,
		264,
		259,
		-1,
		-1,
		256,
		252,
		259,
		246,
		242,
		259,
		272,
		254,
		268,
		267,
		-1,
		260,
		278,
		285,
		253,
		251,
		235,
		233,
		251,
		253,
		259,
		259,
		-1,
		269,
		270,
		265,
		273,
		275,
		251,
		238,
		238,
		248,
		241,
		260,
		248,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		295,
		269,
		252,
		269,
		261,
		251,
		266,
		259,
		241,
		238,
		236,
		233,
		249,
		247,
		257,
		-1,
		-1,
		345,
		314,
		349,
		306,
		291,
		-1,
		265,
		245,
		251,
		255,
		249,
		242,
		256,
		252,
		-1,
		227,
		226,
		254,
		240,
		251,
		305,
		-1,
		-1,
		303,
		295,
		280,
		283,
		275,
		271,
		260,
		259,
		251,
		237,
		233,
		239,
		242,
		242,
		248,
		221,
		231,
		235,
		233,
		258,
		-1,
		-1,
		293,
		-1,
		-1,
		302,
		285,
		-1,
		268,
		275,
		275,
		287,
		273,
		294,
		270,
		261,
		253,
		247,
		235,
		237,
		234,
		247,
		235,
		218,
		243,
		247,
		228,
		249,
		244,
		-1,
		292,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		261,
		264,
		270,
		294,
		304,
		-1,
		282,
		270,
		271,
		256,
		253,
		240,
		228,
		241,
		226,
		233,
		232,
		222,
		220,
		250,
		225,
		247,
		244,
		263,
		268,
		262,
		271,
		-1,
		310,
		306,
		302,
		309,
		258,
		-1,
		-1,
		298,
		-1,
		312,
		319,
		294,
		267,
		270,
		257,
		248,
		235,
		224,
		235,
		224,
		221,
		229,
		214,
		229,
		220,
		219,
		237,
		247,
		255,
		259,
		265,
		-1,
		360,
		-1,
		302,
		286,
		288,
		260,
		281,
		-1,
		318,
		313,
		311,
		296,
		296,
		-1,
		266,
		263,
		253,
		231,
		216,
		233,
		225,
		223,
		227,
		209,
		223,
		214,
		232,
		239,
		237,
		241,
		261,
		273,
		320,
		310,
		-1,
		292,
		297,
		256,
		264,
		283,
		338,
		302,
		-1,
		297,
		-1,
		268,
		281,
		-1,
		237,
		233,
		215,
		216,
		211,
		226,
		220,
		205,
		202,
		220,
		223,
		230,
		234,
		250,
		-1,
		-1,
		305,
		309,
		298,
		249,
		268,
		292,
		329,
		295,
		284,
		283,
		-1,
		274,
		251,
		248,
		236,
		223,
		208,
		209,
		217,
		230,
		209,
		204,
		201,
		221,
		247,
		225,
		237,
		-1,
		-1,
		-1,
		330,
		-1,
		-1,
		275,
		246,
		270,
		312,
		313,
		306,
		294,
		259,
		259,
		253,
		-1,
		247,
		226,
		217,
		206,
		204,
		217,
		214,
		219,
		199,
		197,
		216,
		228,
		219,
		236,
		-1,
		-1,
		-1,
		305,
		294,
		295,
		244,
		267,
		301,
		292,
		278,
		283,
		258,
		251,
		245,
		260,
		243,
		224,
		213,
		205,
		194,
		210,
		218,
		213,
		195,
		204,
		210,
		234,
		224,
		230,
		-1,
		-1,
		312,
		302,
		286,
		288,
		285,
		258,
		265,
		297,
		283,
		296,
		-1,
		250,
		-1,
		239,
		234,
		218,
		213,
		210,
		207,
		201,
		210,
		212,
		202,
		197,
		204,
		239,
		239,
		214,
		234,
		237,
		-1,
		-1,
		-1,
		305,
		303,
		278,
		255,
		239,
		275,
		-1,
		266,
		267,
		-1,
		244,
		238,
		235,
		220,
		216,
		211,
		215,
		208,
		215,
		208,
		206,
		207,
		189,
		221,
		-1,
		222,
		216,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		301,
		280,
		273,
		293,
		234,
		286,
		-1,
		-1,
		251,
		244,
		-1,
		231,
		213,
		220,
		218,
		212,
		216,
		213,
		202,
		215,
		208,
		194,
		196,
		209,
		213,
		217,
		204,
		200,
		197,
		211,
		-1,
		320,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		254,
		-1,
		260,
		252,
		242,
		236,
		230,
		226,
		224,
		240,
		224,
		227,
		225,
		216,
		221,
		197,
		190,
		197,
		186,
		204,
		212,
		204,
		198,
		197,
		207,
		-1,
		321,
		307,
		278,
		-1,
		-1,
		267,
		-1,
		231,
		245,
		261,
		-1,
		268,
		247,
		262,
		240,
		236,
		232,
		243,
		244,
		214,
		219,
		221,
		209,
		202,
		191,
		194,
		186,
		208,
		208,
		192,
		193,
		197,
		-1,
		327,
		314,
		272,
		268,
		257,
		277,
		228,
		230,
		248,
		-1,
		-1,
		304,
		-1,
		238,
		255,
		246,
		244,
		233,
		208,
		215,
		233,
		206,
		201,
		196,
		185,
		185,
		180,
		202,
		188,
		186,
		195,
		211,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		243,
		230,
		224,
		-1,
		265,
		-1,
		282,
		271,
		256,
		240,
		274,
		-1,
		207,
		203,
		210,
		-1,
		226,
		-1,
		198,
		201,
		192,
		177,
		174,
		185,
		183,
		194,
		190,
		-1,
		277,
		262,
		255,
		245,
		259,
		230,
		-1,
		273,
		-1,
		-1,
		269,
		263,
		263,
		233,
		230,
		223,
		203,
		195,
		210,
		209,
		196,
		195,
		183,
		183,
		180,
		173,
		186,
		196,
		201,
		188,
		-1,
		-1,
		-1,
		282,
		234,
		242,
		218,
		239,
		-1,
		-1,
		331,
		286,
		272,
		-1,
		225,
		223,
		211,
		201,
		191,
		196,
		197,
		187,
		185,
		181,
		190,
		184,
		175,
		174,
		190,
		182,
		204,
		-1,
		-1,
		231,
		244,
		246,
		224,
		219,
		-1,
		-1,
		-1,
		277,
		278,
		244,
		223,
		212,
		-1,
		-1,
		195,
		188,
		182,
		185,
		173,
		193,
		199,
		183,
		168,
		183,
		187,
		195,
		186,
		-1,
		234,
		221,
		-1,
		-1,
		218,
		208,
		-1,
		-1,
		-1,
		-1,
		256,
		201,
		190,
		185,
		189,
		194,
		-1,
		168,
		179,
		172,
		191,
		198,
		185,
		170,
		164,
		170,
		182,
		191,
		-1,
		-1,
		232,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		213,
		207,
		178,
		171,
		175,
		-1,
		170,
		172,
		169,
		181,
		186,
		185,
		176,
		163,
		163,
		167,
		171,
		185,
		189,
		255,
		-1,
		185,
		-1,
		-1,
		-1,
		224,
		225,
		211,
		188,
		167,
		160,
		157,
		156,
		161,
		172,
		181,
		192,
		157,
		161,
		160,
		159,
		163,
		180,
		184,
		-1,
		-1,
		183,
		179,
		214,
		226,
		198,
		238,
		-1,
		-1,
		156,
		149,
		159,
		152,
		165,
		168,
		153,
		155,
		166,
		164,
		158,
		168,
		183,
		178,
		-1,
		-1,
		-1,
		181,
		-1,
		197,
		-1,
		-1,
		188,
		229,
		176,
		158,
		154,
		140,
		147,
		141,
		143,
		148,
		167,
		162,
		160,
		154,
		158,
		181,
		170,
		209,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		147,
		166,
		161,
		167,
		172,
		163,
		191,
		188,
		-1,
		137,
		170,
		138,
		152,
		148,
		155,
		160,
		159,
		148,
		155,
		171,
		170,
		165,
		201,
		192,
		198,
		-1,
		-1,
		180,
		169,
		158,
		164,
		-1,
		140,
		163,
		153,
		143,
		149,
		-1,
		-1,
		155,
		152,
		150,
		130,
		136,
		141,
		144,
		156,
		132,
		144,
		148,
		152,
		158,
		163,
		168,
		174,
		189,
		204,
		-1,
		134,
		171,
		164,
		132,
		140,
		171,
		-1,
		130,
		122,
		150,
		135,
		143,
		-1,
		-1,
		128,
		119,
		124,
		133,
		134,
		165,
		164,
		152,
		158,
		159,
		151,
		150,
		168,
		172,
		181,
		188,
		178,
		191,
		195,
		-1,
		127,
		147,
		126,
		129,
		153,
		167,
		-1,
		121,
		-1,
		-1,
		161,
		153,
		137,
		127,
		124,
		171,
		147,
		142,
		148,
		150,
		150,
		141,
		166,
		159,
		159,
		162,
		177,
		182,
		174,
		188,
		188,
		189,
		-1,
		116,
		127,
		120,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		151,
		-1,
		164,
		-1,
		147,
		151,
		155,
		158,
		171,
		158,
		144,
		152,
		158,
		157,
		163,
		163,
		164,
		173,
		184,
		196,
		195,
		196,
		141,
		97,
		100,
		111,
		122,
		137,
		141,
		-1,
		105,
		141,
		151,
		-1,
		141,
		-1,
		-1,
		-1,
		161,
		168,
		160,
		176,
		170,
		170,
		136,
		140,
		153,
		160,
		170,
		181,
		173,
		177,
		190,
		201,
		204,
		137,
		128,
		141,
		86,
		86,
		107,
		116,
		137,
		101,
		98,
		135,
		140,
		153,
		148,
		135,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		177,
		144,
		132,
		142,
		146,
		160,
		172,
		185,
		173,
		178,
		172,
		204,
		-1,
		130,
		129,
		118,
		115,
		91,
		82,
		77,
		104,
		-1,
		-1,
		99,
		126,
		110,
		114,
		130,
		155,
		-1,
		119,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		149,
		138,
		129,
		134,
		154,
		165,
		187,
		169,
		186,
		177,
		187,
		191,
		114,
		111,
		99,
		97,
		120,
		85,
		73,
		-1,
		81,
		84,
		90,
		97,
		114,
		144,
		-1,
		-1,
		135,
		115,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		126,
		131,
		161,
		163,
		165,
		172,
		166,
		173,
		181,
		192,
		184,
		123,
		137,
		126,
		122,
		121,
		129,
		78,
		71,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		125,
		121,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		148,
		148,
		151,
		156,
		164,
		175,
		171,
		175,
		178,
		-1,
		157,
		-1,
		109,
		70,
		76,
		91,
		99,
		-1,
		-1,
		-1,
		142,
		128,
		121,
		109,
		107,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		184,
		152,
		157,
		152,
		167,
		178,
		169,
		177,
		171,
		174,
		-1,
		-1,
		69,
		52,
		-1,
		-1,
		21,
		0,
		-1,
		133,
		122,
		107,
		99,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		118,
		156,
		155,
		163,
		158,
		163,
		175,
		171,
		167,
		177,
		168,
		-1,
		-1,
		47,
		39,
		33,
		-1,
		20,
		-1,
		135,
		-1,
		102,
		109,
		97,
		-1,
		-1,
		-1,
		149,
		112,
		128,
		151,
		177,
		175,
		166,
		159,
		166,
		169,
		162,
		168,
		-1,
		-1,
		-1,
		50,
		27,
		142,
		133,
		116,
		96,
		88,
		108,
		-1,
		130,
		-1,
		105,
		108,
		133,
		172,
		174,
		160,
		156,
		169,
		163,
		160,
		158,
		56,
		-1,
		31,
		90,
		73,
		102,
		68,
		80,
		144,
		-1,
		127,
		109,
		-1,
		137,
		127,
		175,
		150,
		159,
		152,
		146,
		147,
		155,
		-1,
		-1,
		-1,
		46,
		45,
		44,
		55,
		63,
		61,
		79,
		-1,
		132,
		114,
		100,
		117,
		117,
		108,
		116,
		165,
		161,
		164,
		162,
		140,
		-1,
		149,
		-1,
		-1,
		69,
		-1,
		-1,
		-1,
		72,
		94,
		89,
		81,
		93,
		102,
		97,
		99,
		112,
		120,
		118,
		115,
		127,
		123,
		143,
		139,
		171,
		-1,
		156,
		-1,
		76,
		-1,
		-1,
		90,
		76,
		88,
		99,
		89,
		89,
		94,
		92,
		114,
		144,
		130,
		128,
		133,
		138,
		-1,
		166,
		167,
		-1,
		109,
		101,
		87,
		-1,
		80,
		-1,
		135,
		96,
		-1,
		121,
		101,
		-1,
		139,
		135,
		-1,
		-1,
		165,
		125,
		-1,
		-1,
		-1,
		110,
		90,
		130,
		114,
		-1,
		112,
		112,
		-1,
		-1,
		-1,
		150,
		134,
		-1,
		103,
		106,
		-1,
		97,
		103,
		132,
		114,
		118,
		-1,
		-1,
		-1,
		159,
		140,
		134,
		118,
		123,
		111,
		128,
		114,
		116,
		128,
		117,
		138,
		-1,
		-1,
		-1,
		131,
		123,
		123,
		-1,
		-1,
		141,
		124,
		124,
		137,
		-1,
		-1,
		-1,
		153,
		134,
		-1,
		-1,
		132,
		-1,
		-1,
		137,
		136,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		142,
		-1,
		-1,
		-1,
		133,
		140,
		148,
		-1,
		-1,
		-1,
		-1,
		163,
		164,
		188,
		163,
		-1,
		-1,
		-1,
		147,
		147,
		-1,
		-1,
		166,
		164,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		151,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		180,
		-1,
		186,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		199,
		-1,
		171,
		173,
		-1,
		221,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		176,
		183,
		205,
		208,
		238,
		-1,
		195
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		313,
		302,
		313,
		321,
		294,
		301,
		-1,
		320,
		324,
		290,
		284,
		323,
		292,
		298,
		309,
		-1,
		-1,
		-1,
		313,
		312,
		280,
		278,
		287,
		292,
		299,
		-1,
		298,
		-1,
		334,
		313,
		324,
		329,
		273,
		270,
		290,
		309,
		291,
		283,
		349,
		303,
		274,
		268,
		286,
		276,
		285,
		277,
		-1,
		274,
		264,
		286,
		265,
		276,
		268,
		-1,
		-1,
		268,
		269,
		275,
		261,
		267,
		263,
		-1,
		273,
		257,
		-1,
		-1,
		258,
		259,
		243,
		246,
		254,
		252,
		265,
		257,
		252,
		-1,
		-1,
		249,
		245,
		252,
		239,
		235,
		252,
		265,
		247,
		261,
		260,
		-1,
		253,
		271,
		278,
		246,
		244,
		228,
		226,
		244,
		246,
		252,
		252,
		-1,
		262,
		263,
		258,
		266,
		268,
		244,
		231,
		231,
		241,
		234,
		253,
		241,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		262,
		245,
		262,
		254,
		244,
		259,
		252,
		234,
		231,
		229,
		226,
		242,
		240,
		250,
		-1,
		-1,
		355,
		324,
		353,
		311,
		292,
		-1,
		258,
		238,
		244,
		248,
		242,
		235,
		249,
		245,
		-1,
		220,
		219,
		247,
		233,
		244,
		315,
		-1,
		-1,
		313,
		305,
		288,
		291,
		268,
		264,
		253,
		252,
		244,
		230,
		226,
		232,
		235,
		235,
		241,
		214,
		224,
		228,
		226,
		251,
		-1,
		-1,
		286,
		-1,
		-1,
		312,
		295,
		-1,
		278,
		285,
		274,
		280,
		266,
		287,
		263,
		254,
		246,
		240,
		228,
		230,
		227,
		240,
		228,
		211,
		236,
		240,
		221,
		242,
		237,
		-1,
		285,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		271,
		274,
		280,
		304,
		303,
		-1,
		275,
		263,
		264,
		249,
		246,
		233,
		221,
		234,
		219,
		226,
		225,
		215,
		213,
		243,
		218,
		240,
		237,
		256,
		261,
		255,
		264,
		-1,
		320,
		316,
		312,
		319,
		268,
		-1,
		-1,
		308,
		-1,
		311,
		312,
		287,
		260,
		263,
		250,
		241,
		228,
		217,
		228,
		217,
		214,
		222,
		207,
		222,
		213,
		212,
		230,
		240,
		248,
		252,
		258,
		-1,
		370,
		-1,
		312,
		296,
		298,
		270,
		291,
		-1,
		328,
		312,
		304,
		289,
		289,
		-1,
		259,
		256,
		246,
		224,
		209,
		226,
		218,
		216,
		220,
		202,
		216,
		207,
		225,
		232,
		230,
		234,
		254,
		266,
		330,
		320,
		-1,
		302,
		307,
		266,
		274,
		293,
		331,
		295,
		-1,
		290,
		-1,
		261,
		274,
		-1,
		230,
		226,
		208,
		209,
		204,
		219,
		213,
		198,
		195,
		213,
		216,
		223,
		227,
		243,
		-1,
		-1,
		315,
		319,
		308,
		259,
		278,
		302,
		339,
		288,
		277,
		276,
		-1,
		267,
		244,
		241,
		229,
		216,
		201,
		202,
		210,
		223,
		202,
		197,
		194,
		214,
		240,
		218,
		230,
		-1,
		-1,
		-1,
		340,
		-1,
		-1,
		285,
		256,
		280,
		322,
		306,
		299,
		287,
		252,
		252,
		246,
		-1,
		240,
		219,
		210,
		199,
		197,
		210,
		207,
		212,
		192,
		190,
		209,
		221,
		212,
		229,
		-1,
		-1,
		-1,
		315,
		304,
		305,
		251,
		274,
		311,
		285,
		271,
		276,
		251,
		244,
		238,
		253,
		236,
		217,
		206,
		198,
		187,
		203,
		211,
		206,
		188,
		197,
		203,
		227,
		217,
		223,
		-1,
		-1,
		322,
		312,
		296,
		298,
		295,
		265,
		272,
		304,
		276,
		289,
		-1,
		243,
		-1,
		232,
		227,
		211,
		206,
		203,
		200,
		194,
		203,
		205,
		195,
		190,
		197,
		232,
		232,
		207,
		227,
		230,
		-1,
		-1,
		-1,
		315,
		310,
		285,
		262,
		246,
		282,
		-1,
		259,
		260,
		-1,
		237,
		231,
		228,
		213,
		209,
		204,
		208,
		201,
		208,
		201,
		199,
		200,
		182,
		214,
		-1,
		215,
		209,
		217,
		207,
		195,
		-1,
		-1,
		-1,
		308,
		287,
		280,
		300,
		241,
		293,
		-1,
		-1,
		244,
		237,
		-1,
		224,
		206,
		213,
		211,
		205,
		209,
		206,
		195,
		208,
		201,
		187,
		189,
		202,
		206,
		210,
		197,
		193,
		190,
		204,
		-1,
		327,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		261,
		-1,
		253,
		245,
		235,
		229,
		223,
		219,
		217,
		233,
		217,
		220,
		218,
		209,
		217,
		190,
		183,
		190,
		179,
		197,
		205,
		197,
		191,
		190,
		200,
		-1,
		328,
		314,
		285,
		-1,
		-1,
		274,
		-1,
		238,
		252,
		268,
		-1,
		261,
		240,
		255,
		233,
		229,
		225,
		240,
		241,
		218,
		218,
		216,
		207,
		195,
		184,
		187,
		179,
		201,
		201,
		185,
		186,
		190,
		-1,
		334,
		321,
		279,
		275,
		264,
		284,
		235,
		223,
		255,
		-1,
		-1,
		297,
		-1,
		231,
		248,
		239,
		237,
		230,
		212,
		219,
		227,
		204,
		199,
		189,
		178,
		178,
		173,
		195,
		181,
		179,
		188,
		204,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		250,
		237,
		231,
		-1,
		272,
		-1,
		275,
		265,
		249,
		234,
		267,
		-1,
		211,
		207,
		214,
		-1,
		224,
		-1,
		197,
		194,
		185,
		170,
		167,
		178,
		176,
		187,
		183,
		-1,
		284,
		269,
		262,
		252,
		266,
		236,
		-1,
		270,
		-1,
		-1,
		262,
		256,
		256,
		240,
		241,
		227,
		207,
		199,
		214,
		213,
		200,
		199,
		183,
		176,
		173,
		166,
		179,
		189,
		194,
		181,
		-1,
		-1,
		-1,
		289,
		266,
		260,
		232,
		236,
		-1,
		-1,
		324,
		279,
		265,
		-1,
		236,
		227,
		215,
		205,
		195,
		200,
		201,
		191,
		189,
		181,
		183,
		177,
		168,
		167,
		183,
		175,
		197,
		-1,
		-1,
		265,
		258,
		246,
		214,
		209,
		-1,
		-1,
		-1,
		271,
		287,
		255,
		234,
		216,
		-1,
		-1,
		199,
		192,
		186,
		189,
		177,
		197,
		192,
		176,
		161,
		176,
		180,
		188,
		179,
		-1,
		268,
		255,
		-1,
		-1,
		208,
		198,
		-1,
		-1,
		-1,
		-1,
		267,
		212,
		201,
		196,
		200,
		198,
		-1,
		172,
		183,
		176,
		195,
		202,
		178,
		163,
		157,
		163,
		175,
		184,
		-1,
		-1,
		222,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		224,
		218,
		189,
		182,
		186,
		-1,
		174,
		176,
		173,
		185,
		181,
		178,
		169,
		160,
		156,
		160,
		164,
		178,
		182,
		245,
		-1,
		175,
		-1,
		-1,
		-1,
		221,
		243,
		228,
		205,
		178,
		173,
		166,
		160,
		165,
		176,
		185,
		196,
		161,
		163,
		153,
		152,
		156,
		173,
		177,
		-1,
		-1,
		173,
		169,
		204,
		216,
		216,
		255,
		-1,
		-1,
		182,
		173,
		164,
		156,
		169,
		172,
		157,
		159,
		159,
		157,
		151,
		161,
		176,
		171,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		206,
		253,
		200,
		182,
		178,
		176,
		165,
		159,
		147,
		152,
		162,
		156,
		153,
		147,
		151,
		174,
		163,
		202,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		192,
		156,
		151,
		185,
		190,
		181,
		215,
		212,
		-1,
		182,
		188,
		153,
		160,
		143,
		150,
		155,
		152,
		141,
		148,
		164,
		163,
		158,
		194,
		185,
		191,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		185,
		153,
		171,
		161,
		167,
		-1,
		-1,
		207,
		204,
		184,
		153,
		151,
		144,
		139,
		149,
		125,
		137,
		141,
		145,
		151,
		156,
		161,
		167,
		182,
		197,
		-1,
		237,
		274,
		267,
		235,
		243,
		274,
		-1,
		175,
		167,
		150,
		153,
		161,
		-1,
		-1,
		180,
		171,
		172,
		160,
		157,
		163,
		162,
		145,
		151,
		152,
		144,
		143,
		161,
		165,
		174,
		181,
		171,
		184,
		188,
		-1,
		230,
		250,
		229,
		232,
		256,
		270,
		-1,
		172,
		-1,
		-1,
		110,
		174,
		182,
		178,
		176,
		219,
		174,
		169,
		150,
		148,
		143,
		134,
		159,
		152,
		152,
		155,
		170,
		175,
		167,
		181,
		181,
		182,
		-1,
		219,
		230,
		223,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		100,
		-1,
		208,
		-1,
		199,
		203,
		182,
		185,
		164,
		151,
		137,
		145,
		151,
		150,
		156,
		156,
		157,
		166,
		177,
		189,
		188,
		189,
		244,
		200,
		203,
		214,
		225,
		240,
		244,
		-1,
		184,
		223,
		106,
		-1,
		90,
		-1,
		-1,
		-1,
		213,
		195,
		187,
		184,
		163,
		163,
		129,
		133,
		146,
		153,
		163,
		174,
		166,
		170,
		183,
		194,
		197,
		240,
		231,
		244,
		189,
		189,
		210,
		219,
		240,
		189,
		190,
		217,
		113,
		102,
		97,
		84,
		-1,
		-1,
		197,
		205,
		-1,
		-1,
		170,
		137,
		125,
		135,
		139,
		153,
		165,
		178,
		166,
		171,
		165,
		197,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		207,
		-1,
		-1,
		187,
		218,
		169,
		146,
		144,
		169,
		-1,
		68,
		-1,
		-1,
		177,
		-1,
		-1,
		162,
		142,
		131,
		122,
		127,
		147,
		158,
		180,
		162,
		179,
		170,
		180,
		184,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		184,
		184,
		180,
		167,
		147,
		158,
		-1,
		-1,
		84,
		64,
		-1,
		-1,
		160,
		158,
		147,
		-1,
		137,
		119,
		124,
		154,
		156,
		158,
		165,
		159,
		166,
		174,
		185,
		177,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		64,
		-1,
		67,
		70,
		-1,
		-1,
		155,
		148,
		136,
		124,
		114,
		124,
		141,
		141,
		144,
		149,
		157,
		168,
		164,
		168,
		171,
		-1,
		260,
		-1,
		212,
		173,
		179,
		194,
		202,
		-1,
		-1,
		-1,
		9,
		52,
		45,
		51,
		52,
		-1,
		189,
		173,
		154,
		-1,
		124,
		137,
		177,
		145,
		150,
		145,
		160,
		171,
		162,
		170,
		164,
		167,
		-1,
		-1,
		172,
		155,
		-1,
		-1,
		129,
		131,
		-1,
		0,
		12,
		36,
		44,
		-1,
		-1,
		161,
		157,
		-1,
		-1,
		111,
		149,
		148,
		156,
		151,
		156,
		168,
		164,
		160,
		170,
		161,
		-1,
		-1,
		150,
		142,
		136,
		-1,
		114,
		-1,
		102,
		-1,
		41,
		63,
		65,
		-1,
		-1,
		-1,
		142,
		105,
		121,
		144,
		170,
		168,
		159,
		152,
		159,
		162,
		155,
		161,
		-1,
		-1,
		-1,
		132,
		106,
		109,
		100,
		83,
		63,
		59,
		80,
		-1,
		123,
		-1,
		98,
		101,
		126,
		165,
		167,
		153,
		149,
		162,
		156,
		153,
		151,
		138,
		-1,
		108,
		141,
		105,
		69,
		73,
		68,
		137,
		-1,
		120,
		102,
		-1,
		130,
		120,
		168,
		143,
		152,
		145,
		139,
		140,
		148,
		-1,
		-1,
		-1,
		110,
		109,
		101,
		95,
		93,
		78,
		73,
		-1,
		125,
		107,
		93,
		110,
		110,
		101,
		109,
		158,
		154,
		157,
		155,
		133,
		-1,
		224,
		-1,
		-1,
		133,
		-1,
		-1,
		-1,
		104,
		113,
		86,
		74,
		88,
		95,
		90,
		92,
		105,
		113,
		111,
		108,
		120,
		116,
		136,
		132,
		164,
		-1,
		219,
		-1,
		140,
		-1,
		-1,
		120,
		106,
		108,
		97,
		86,
		84,
		87,
		85,
		107,
		137,
		123,
		121,
		126,
		131,
		-1,
		208,
		207,
		-1,
		139,
		131,
		117,
		-1,
		110,
		-1,
		132,
		93,
		-1,
		114,
		94,
		-1,
		132,
		128,
		-1,
		-1,
		195,
		155,
		-1,
		-1,
		-1,
		140,
		120,
		127,
		111,
		-1,
		105,
		105,
		-1,
		-1,
		-1,
		180,
		164,
		-1,
		133,
		136,
		-1,
		127,
		133,
		160,
		107,
		111,
		-1,
		-1,
		-1,
		189,
		170,
		164,
		148,
		153,
		141,
		158,
		144,
		143,
		121,
		110,
		131,
		-1,
		-1,
		-1,
		161,
		153,
		153,
		-1,
		-1,
		168,
		151,
		132,
		130,
		-1,
		-1,
		-1,
		183,
		164,
		-1,
		-1,
		158,
		-1,
		-1,
		164,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		172,
		-1,
		-1,
		-1,
		154,
		150,
		151,
		-1,
		-1,
		-1,
		-1,
		193,
		194,
		218,
		193,
		-1,
		-1,
		-1,
		146,
		140,
		-1,
		-1,
		196,
		194,
		-1,
		-1,
		-1,
		174,
		158,
		-1,
		144,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		179,
		-1,
		179,
		154,
		161,
		-1,
		-1,
		-1,
		-1,
		192,
		184,
		192,
		-1,
		164,
		166,
		-1,
		214,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		169,
		176,
		198,
		201,
		237,
		-1,
		188
	],
	[
		-1,
		301,
		290,
		301,
		309,
		282,
		289,
		-1,
		308,
		312,
		278,
		272,
		311,
		280,
		286,
		297,
		-1,
		-1,
		-1,
		301,
		300,
		268,
		266,
		275,
		280,
		287,
		-1,
		286,
		-1,
		322,
		301,
		312,
		317,
		261,
		258,
		278,
		297,
		279,
		271,
		337,
		291,
		262,
		256,
		274,
		264,
		273,
		265,
		-1,
		262,
		252,
		274,
		253,
		264,
		256,
		-1,
		-1,
		256,
		257,
		263,
		249,
		255,
		251,
		-1,
		261,
		245,
		-1,
		-1,
		246,
		247,
		231,
		234,
		242,
		240,
		253,
		245,
		240,
		-1,
		-1,
		237,
		233,
		240,
		227,
		223,
		240,
		253,
		235,
		249,
		248,
		-1,
		241,
		259,
		266,
		234,
		232,
		216,
		214,
		232,
		234,
		240,
		240,
		-1,
		250,
		251,
		246,
		254,
		256,
		232,
		219,
		219,
		229,
		222,
		241,
		229,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		250,
		233,
		250,
		242,
		232,
		247,
		240,
		222,
		219,
		217,
		214,
		230,
		228,
		238,
		-1,
		-1,
		343,
		312,
		341,
		299,
		280,
		-1,
		246,
		226,
		232,
		236,
		230,
		223,
		237,
		233,
		-1,
		208,
		207,
		235,
		221,
		232,
		303,
		-1,
		-1,
		301,
		293,
		276,
		279,
		256,
		252,
		241,
		240,
		232,
		218,
		214,
		220,
		223,
		223,
		229,
		202,
		212,
		216,
		214,
		239,
		-1,
		-1,
		274,
		-1,
		-1,
		300,
		283,
		-1,
		266,
		273,
		262,
		268,
		254,
		275,
		251,
		242,
		234,
		228,
		216,
		218,
		215,
		228,
		216,
		199,
		224,
		228,
		209,
		230,
		225,
		-1,
		273,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		278,
		259,
		262,
		268,
		292,
		291,
		-1,
		263,
		251,
		252,
		237,
		234,
		221,
		209,
		222,
		207,
		214,
		213,
		203,
		201,
		231,
		206,
		228,
		225,
		244,
		249,
		243,
		252,
		-1,
		308,
		304,
		300,
		307,
		256,
		-1,
		-1,
		296,
		-1,
		299,
		300,
		275,
		248,
		251,
		238,
		229,
		216,
		205,
		216,
		205,
		202,
		210,
		195,
		210,
		201,
		200,
		218,
		228,
		236,
		240,
		246,
		-1,
		358,
		-1,
		300,
		284,
		286,
		258,
		279,
		-1,
		316,
		300,
		292,
		277,
		277,
		-1,
		247,
		244,
		234,
		212,
		197,
		214,
		206,
		204,
		208,
		190,
		204,
		195,
		213,
		220,
		218,
		222,
		242,
		254,
		318,
		308,
		-1,
		290,
		295,
		254,
		262,
		281,
		319,
		283,
		-1,
		278,
		-1,
		249,
		262,
		-1,
		218,
		214,
		196,
		197,
		192,
		207,
		201,
		186,
		183,
		201,
		204,
		211,
		215,
		231,
		-1,
		-1,
		303,
		307,
		296,
		247,
		266,
		290,
		327,
		276,
		265,
		264,
		-1,
		255,
		232,
		229,
		217,
		204,
		189,
		190,
		198,
		211,
		190,
		185,
		182,
		202,
		228,
		206,
		218,
		-1,
		-1,
		-1,
		328,
		-1,
		-1,
		273,
		244,
		268,
		310,
		294,
		287,
		275,
		240,
		240,
		234,
		-1,
		228,
		207,
		198,
		187,
		185,
		198,
		195,
		200,
		180,
		178,
		197,
		209,
		200,
		217,
		-1,
		-1,
		-1,
		303,
		292,
		293,
		239,
		262,
		299,
		273,
		259,
		264,
		239,
		232,
		226,
		241,
		224,
		205,
		194,
		186,
		175,
		191,
		199,
		194,
		176,
		185,
		191,
		215,
		205,
		211,
		-1,
		-1,
		310,
		300,
		284,
		286,
		283,
		253,
		260,
		292,
		264,
		277,
		-1,
		231,
		-1,
		220,
		215,
		199,
		194,
		191,
		188,
		182,
		191,
		193,
		183,
		178,
		185,
		220,
		220,
		195,
		215,
		218,
		-1,
		-1,
		-1,
		303,
		298,
		273,
		250,
		234,
		270,
		-1,
		247,
		248,
		-1,
		225,
		219,
		216,
		201,
		197,
		192,
		196,
		189,
		196,
		189,
		187,
		188,
		170,
		202,
		-1,
		203,
		197,
		205,
		195,
		183,
		-1,
		-1,
		-1,
		296,
		275,
		268,
		288,
		229,
		281,
		-1,
		-1,
		232,
		225,
		-1,
		212,
		194,
		201,
		199,
		193,
		197,
		194,
		183,
		196,
		189,
		175,
		177,
		190,
		194,
		198,
		185,
		181,
		178,
		192,
		-1,
		315,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		249,
		-1,
		241,
		233,
		223,
		217,
		211,
		207,
		205,
		221,
		205,
		208,
		206,
		197,
		205,
		178,
		171,
		178,
		167,
		185,
		193,
		185,
		179,
		178,
		188,
		-1,
		316,
		302,
		273,
		-1,
		-1,
		262,
		-1,
		226,
		240,
		256,
		-1,
		249,
		228,
		243,
		221,
		217,
		213,
		228,
		229,
		206,
		206,
		204,
		195,
		183,
		172,
		175,
		167,
		189,
		189,
		173,
		174,
		178,
		-1,
		322,
		309,
		267,
		263,
		252,
		272,
		223,
		211,
		243,
		-1,
		-1,
		285,
		-1,
		219,
		236,
		227,
		225,
		218,
		200,
		207,
		215,
		192,
		187,
		177,
		166,
		166,
		161,
		183,
		169,
		167,
		176,
		192,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		238,
		225,
		219,
		-1,
		260,
		-1,
		263,
		253,
		237,
		222,
		255,
		-1,
		199,
		195,
		202,
		-1,
		212,
		-1,
		185,
		182,
		173,
		158,
		155,
		166,
		164,
		175,
		171,
		-1,
		272,
		257,
		250,
		240,
		254,
		224,
		-1,
		258,
		-1,
		-1,
		250,
		244,
		244,
		228,
		229,
		215,
		195,
		187,
		202,
		201,
		188,
		187,
		171,
		164,
		161,
		154,
		167,
		177,
		182,
		169,
		-1,
		-1,
		-1,
		277,
		254,
		248,
		220,
		224,
		-1,
		-1,
		312,
		267,
		253,
		-1,
		224,
		215,
		203,
		193,
		183,
		188,
		189,
		179,
		177,
		169,
		171,
		165,
		156,
		155,
		171,
		163,
		185,
		-1,
		-1,
		253,
		246,
		234,
		202,
		197,
		-1,
		-1,
		-1,
		259,
		275,
		243,
		222,
		204,
		-1,
		-1,
		187,
		180,
		174,
		177,
		165,
		185,
		180,
		164,
		149,
		164,
		168,
		176,
		167,
		-1,
		256,
		243,
		-1,
		-1,
		196,
		186,
		-1,
		-1,
		-1,
		-1,
		255,
		200,
		189,
		184,
		188,
		186,
		-1,
		160,
		171,
		164,
		183,
		190,
		166,
		151,
		145,
		151,
		163,
		172,
		-1,
		-1,
		210,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		212,
		206,
		177,
		170,
		174,
		-1,
		162,
		164,
		161,
		173,
		169,
		166,
		157,
		148,
		144,
		148,
		152,
		166,
		170,
		233,
		-1,
		163,
		-1,
		-1,
		-1,
		209,
		231,
		216,
		193,
		166,
		161,
		154,
		148,
		153,
		164,
		173,
		184,
		149,
		151,
		141,
		140,
		144,
		161,
		165,
		-1,
		-1,
		161,
		157,
		192,
		204,
		204,
		243,
		-1,
		-1,
		170,
		161,
		152,
		144,
		157,
		160,
		145,
		147,
		147,
		145,
		139,
		149,
		164,
		159,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		194,
		241,
		188,
		170,
		166,
		164,
		153,
		147,
		135,
		140,
		150,
		144,
		141,
		135,
		139,
		162,
		151,
		190,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		180,
		144,
		139,
		173,
		178,
		169,
		203,
		200,
		-1,
		170,
		176,
		141,
		148,
		131,
		138,
		143,
		140,
		129,
		136,
		152,
		151,
		146,
		182,
		173,
		179,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		173,
		141,
		159,
		149,
		155,
		-1,
		-1,
		195,
		192,
		172,
		141,
		139,
		132,
		127,
		137,
		113,
		125,
		129,
		133,
		139,
		144,
		149,
		155,
		170,
		185,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		163,
		155,
		138,
		141,
		149,
		-1,
		-1,
		168,
		159,
		160,
		148,
		145,
		151,
		150,
		133,
		139,
		140,
		132,
		131,
		149,
		153,
		162,
		169,
		159,
		172,
		176,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		160,
		-1,
		-1,
		98,
		162,
		170,
		166,
		164,
		207,
		162,
		157,
		138,
		136,
		131,
		122,
		147,
		140,
		140,
		143,
		158,
		163,
		155,
		169,
		169,
		170,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		88,
		-1,
		196,
		-1,
		187,
		191,
		170,
		173,
		152,
		139,
		125,
		133,
		139,
		138,
		144,
		144,
		145,
		154,
		165,
		177,
		176,
		177,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		172,
		211,
		94,
		-1,
		78,
		-1,
		-1,
		-1,
		201,
		183,
		175,
		172,
		151,
		151,
		117,
		121,
		134,
		141,
		151,
		162,
		154,
		158,
		171,
		182,
		185,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		177,
		178,
		205,
		101,
		90,
		85,
		72,
		-1,
		-1,
		185,
		193,
		-1,
		-1,
		158,
		125,
		113,
		123,
		127,
		141,
		153,
		166,
		154,
		159,
		153,
		185,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		175,
		206,
		157,
		134,
		132,
		157,
		-1,
		56,
		-1,
		-1,
		165,
		-1,
		-1,
		150,
		130,
		119,
		110,
		115,
		135,
		146,
		168,
		150,
		167,
		158,
		168,
		172,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		172,
		172,
		168,
		155,
		135,
		146,
		-1,
		-1,
		72,
		52,
		-1,
		-1,
		148,
		146,
		135,
		-1,
		125,
		107,
		112,
		142,
		144,
		146,
		153,
		147,
		154,
		162,
		173,
		165,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		52,
		-1,
		55,
		58,
		-1,
		-1,
		143,
		136,
		124,
		112,
		102,
		112,
		129,
		129,
		132,
		137,
		145,
		156,
		152,
		156,
		159,
		-1,
		248,
		-1,
		200,
		161,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		20,
		40,
		33,
		39,
		40,
		-1,
		177,
		161,
		142,
		-1,
		112,
		125,
		165,
		133,
		138,
		133,
		148,
		159,
		150,
		158,
		152,
		155,
		-1,
		-1,
		160,
		143,
		-1,
		-1,
		117,
		119,
		-1,
		11,
		0,
		24,
		32,
		-1,
		-1,
		149,
		145,
		-1,
		-1,
		99,
		137,
		136,
		144,
		139,
		144,
		156,
		152,
		148,
		158,
		149,
		-1,
		-1,
		138,
		130,
		124,
		-1,
		102,
		-1,
		90,
		-1,
		29,
		51,
		53,
		-1,
		-1,
		-1,
		130,
		93,
		109,
		132,
		158,
		156,
		147,
		140,
		147,
		150,
		143,
		149,
		-1,
		-1,
		-1,
		120,
		94,
		97,
		88,
		71,
		51,
		47,
		68,
		-1,
		111,
		-1,
		86,
		89,
		114,
		153,
		155,
		141,
		137,
		150,
		144,
		141,
		139,
		126,
		-1,
		96,
		129,
		93,
		57,
		61,
		56,
		125,
		-1,
		108,
		90,
		-1,
		118,
		108,
		156,
		131,
		140,
		133,
		127,
		128,
		136,
		-1,
		-1,
		-1,
		98,
		97,
		89,
		83,
		81,
		66,
		61,
		-1,
		113,
		95,
		81,
		98,
		98,
		89,
		97,
		146,
		142,
		145,
		143,
		121,
		-1,
		212,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		92,
		101,
		74,
		62,
		76,
		83,
		78,
		80,
		93,
		101,
		99,
		96,
		108,
		104,
		124,
		120,
		152,
		-1,
		207,
		-1,
		128,
		-1,
		-1,
		108,
		94,
		96,
		85,
		74,
		72,
		75,
		73,
		95,
		125,
		111,
		109,
		114,
		119,
		-1,
		196,
		195,
		-1,
		127,
		119,
		105,
		-1,
		98,
		-1,
		120,
		81,
		-1,
		102,
		82,
		-1,
		120,
		116,
		-1,
		-1,
		183,
		143,
		-1,
		-1,
		-1,
		128,
		108,
		115,
		99,
		-1,
		93,
		93,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		121,
		124,
		-1,
		115,
		121,
		148,
		95,
		99,
		-1,
		-1,
		-1,
		177,
		158,
		152,
		136,
		141,
		129,
		146,
		132,
		131,
		109,
		98,
		119,
		-1,
		-1,
		-1,
		149,
		141,
		141,
		-1,
		-1,
		156,
		139,
		120,
		118,
		-1,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		146,
		-1,
		-1,
		152,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		160,
		-1,
		-1,
		-1,
		142,
		138,
		139,
		-1,
		-1,
		-1,
		-1,
		181,
		182,
		206,
		181,
		-1,
		-1,
		-1,
		134,
		128,
		-1,
		-1,
		184,
		182,
		-1,
		-1,
		-1,
		162,
		146,
		-1,
		132,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		165,
		-1,
		-1,
		-1,
		167,
		-1,
		167,
		142,
		149,
		-1,
		-1,
		-1,
		-1,
		180,
		172,
		180,
		-1,
		152,
		154,
		-1,
		202,
		-1,
		-1,
		195,
		186,
		-1,
		-1,
		157,
		164,
		186,
		189,
		225,
		-1,
		176
	],
	[
		-1,
		286,
		275,
		286,
		294,
		267,
		274,
		-1,
		293,
		297,
		263,
		257,
		296,
		265,
		271,
		282,
		-1,
		-1,
		-1,
		286,
		285,
		253,
		251,
		260,
		265,
		272,
		-1,
		271,
		-1,
		307,
		286,
		297,
		302,
		246,
		243,
		263,
		282,
		264,
		256,
		322,
		276,
		247,
		241,
		259,
		249,
		258,
		250,
		-1,
		247,
		237,
		259,
		238,
		249,
		241,
		-1,
		-1,
		241,
		242,
		248,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		231,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		226,
		244,
		251,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		235,
		236,
		231,
		239,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		235,
		218,
		235,
		227,
		217,
		232,
		225,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		328,
		297,
		326,
		284,
		265,
		-1,
		231,
		211,
		217,
		221,
		215,
		208,
		222,
		218,
		-1,
		193,
		192,
		220,
		206,
		217,
		288,
		-1,
		-1,
		286,
		278,
		261,
		264,
		241,
		237,
		226,
		225,
		217,
		203,
		199,
		205,
		208,
		208,
		214,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		285,
		268,
		-1,
		251,
		258,
		247,
		253,
		239,
		260,
		236,
		227,
		219,
		213,
		201,
		203,
		200,
		213,
		201,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		244,
		247,
		253,
		277,
		276,
		-1,
		248,
		236,
		237,
		222,
		219,
		206,
		194,
		207,
		192,
		199,
		198,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		293,
		289,
		285,
		292,
		241,
		-1,
		-1,
		281,
		-1,
		284,
		285,
		260,
		233,
		236,
		223,
		214,
		201,
		190,
		201,
		190,
		187,
		195,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		343,
		-1,
		285,
		269,
		271,
		243,
		264,
		-1,
		301,
		285,
		277,
		262,
		262,
		-1,
		232,
		229,
		219,
		197,
		182,
		199,
		191,
		189,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		303,
		293,
		-1,
		275,
		280,
		239,
		247,
		266,
		304,
		268,
		-1,
		263,
		-1,
		234,
		247,
		-1,
		203,
		199,
		181,
		182,
		177,
		192,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		288,
		292,
		281,
		232,
		251,
		275,
		312,
		261,
		250,
		249,
		-1,
		240,
		217,
		214,
		202,
		189,
		174,
		175,
		183,
		196,
		175,
		170,
		167,
		187,
		213,
		191,
		203,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		258,
		229,
		253,
		295,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		213,
		192,
		183,
		172,
		170,
		183,
		180,
		185,
		165,
		163,
		182,
		194,
		185,
		202,
		-1,
		-1,
		-1,
		288,
		277,
		278,
		224,
		247,
		284,
		258,
		244,
		249,
		224,
		217,
		211,
		226,
		209,
		190,
		179,
		171,
		160,
		176,
		184,
		179,
		161,
		170,
		176,
		200,
		190,
		196,
		-1,
		-1,
		295,
		285,
		269,
		271,
		268,
		238,
		245,
		277,
		249,
		262,
		-1,
		216,
		-1,
		205,
		200,
		184,
		179,
		176,
		173,
		167,
		176,
		178,
		168,
		163,
		170,
		205,
		205,
		180,
		200,
		203,
		-1,
		-1,
		-1,
		288,
		283,
		258,
		235,
		219,
		255,
		-1,
		232,
		233,
		-1,
		210,
		204,
		201,
		186,
		182,
		177,
		181,
		174,
		181,
		174,
		172,
		173,
		155,
		187,
		-1,
		188,
		182,
		190,
		180,
		168,
		-1,
		-1,
		-1,
		281,
		260,
		253,
		273,
		214,
		266,
		-1,
		-1,
		217,
		210,
		-1,
		197,
		179,
		186,
		184,
		178,
		182,
		179,
		168,
		181,
		174,
		160,
		162,
		175,
		179,
		183,
		170,
		166,
		163,
		177,
		-1,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		234,
		-1,
		226,
		218,
		208,
		202,
		196,
		192,
		190,
		206,
		190,
		193,
		191,
		182,
		190,
		163,
		156,
		163,
		152,
		170,
		178,
		170,
		164,
		163,
		173,
		-1,
		301,
		287,
		258,
		-1,
		-1,
		247,
		-1,
		211,
		225,
		241,
		-1,
		234,
		213,
		228,
		206,
		202,
		198,
		213,
		214,
		191,
		191,
		189,
		180,
		168,
		157,
		160,
		152,
		174,
		174,
		158,
		159,
		163,
		-1,
		307,
		294,
		252,
		248,
		237,
		257,
		208,
		196,
		228,
		-1,
		-1,
		270,
		-1,
		204,
		221,
		212,
		210,
		203,
		185,
		192,
		200,
		177,
		172,
		162,
		151,
		151,
		146,
		168,
		154,
		152,
		161,
		177,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		223,
		210,
		204,
		-1,
		245,
		-1,
		248,
		238,
		222,
		207,
		240,
		-1,
		184,
		180,
		187,
		-1,
		197,
		-1,
		170,
		167,
		158,
		143,
		140,
		151,
		149,
		160,
		156,
		-1,
		257,
		242,
		235,
		225,
		239,
		209,
		-1,
		243,
		-1,
		-1,
		235,
		229,
		229,
		213,
		214,
		200,
		180,
		172,
		187,
		186,
		173,
		172,
		156,
		149,
		146,
		139,
		152,
		162,
		167,
		154,
		-1,
		-1,
		-1,
		262,
		239,
		233,
		205,
		209,
		-1,
		-1,
		297,
		252,
		238,
		-1,
		209,
		200,
		188,
		178,
		168,
		173,
		174,
		164,
		162,
		154,
		156,
		150,
		141,
		140,
		156,
		148,
		170,
		-1,
		-1,
		238,
		231,
		219,
		187,
		182,
		-1,
		-1,
		-1,
		244,
		260,
		228,
		207,
		189,
		-1,
		-1,
		172,
		165,
		159,
		162,
		150,
		170,
		165,
		149,
		134,
		149,
		153,
		161,
		152,
		-1,
		241,
		228,
		-1,
		-1,
		181,
		171,
		-1,
		-1,
		-1,
		-1,
		240,
		185,
		174,
		169,
		173,
		171,
		-1,
		145,
		156,
		149,
		168,
		175,
		151,
		136,
		130,
		136,
		148,
		157,
		-1,
		-1,
		195,
		-1,
		157,
		-1,
		-1,
		-1,
		-1,
		197,
		191,
		162,
		155,
		159,
		-1,
		147,
		149,
		146,
		158,
		154,
		151,
		142,
		133,
		129,
		133,
		137,
		151,
		155,
		218,
		-1,
		148,
		-1,
		-1,
		-1,
		194,
		216,
		201,
		178,
		151,
		146,
		139,
		133,
		138,
		149,
		158,
		169,
		134,
		136,
		126,
		125,
		129,
		146,
		150,
		-1,
		-1,
		146,
		142,
		177,
		189,
		189,
		228,
		-1,
		-1,
		155,
		146,
		137,
		129,
		142,
		145,
		130,
		132,
		132,
		130,
		124,
		134,
		149,
		144,
		-1,
		-1,
		-1,
		158,
		-1,
		160,
		-1,
		-1,
		179,
		226,
		173,
		155,
		151,
		149,
		138,
		132,
		120,
		125,
		135,
		129,
		126,
		120,
		124,
		147,
		136,
		175,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		165,
		129,
		124,
		158,
		163,
		154,
		188,
		185,
		-1,
		155,
		161,
		126,
		133,
		116,
		123,
		128,
		125,
		114,
		121,
		137,
		136,
		131,
		167,
		158,
		164,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		158,
		126,
		144,
		134,
		140,
		-1,
		-1,
		180,
		177,
		157,
		126,
		124,
		117,
		112,
		122,
		98,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		148,
		140,
		123,
		126,
		134,
		-1,
		-1,
		153,
		144,
		145,
		133,
		130,
		136,
		135,
		118,
		124,
		125,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		145,
		-1,
		-1,
		83,
		147,
		155,
		151,
		149,
		192,
		147,
		142,
		123,
		121,
		116,
		107,
		132,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		73,
		-1,
		181,
		-1,
		172,
		176,
		155,
		158,
		137,
		124,
		110,
		118,
		124,
		123,
		129,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		157,
		196,
		79,
		-1,
		63,
		-1,
		-1,
		-1,
		186,
		168,
		160,
		157,
		136,
		136,
		102,
		106,
		119,
		126,
		136,
		147,
		139,
		143,
		156,
		167,
		170,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		162,
		163,
		190,
		86,
		75,
		70,
		57,
		-1,
		-1,
		170,
		178,
		-1,
		-1,
		143,
		110,
		98,
		108,
		112,
		126,
		138,
		151,
		139,
		144,
		138,
		170,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		160,
		191,
		142,
		119,
		117,
		142,
		-1,
		41,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		115,
		104,
		95,
		100,
		120,
		131,
		153,
		135,
		152,
		143,
		153,
		157,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		157,
		157,
		153,
		140,
		120,
		131,
		-1,
		-1,
		57,
		37,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		92,
		97,
		127,
		129,
		131,
		138,
		132,
		139,
		147,
		158,
		150,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		34,
		-1,
		39,
		43,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		114,
		114,
		117,
		122,
		130,
		141,
		137,
		141,
		144,
		-1,
		233,
		-1,
		185,
		146,
		152,
		167,
		175,
		-1,
		-1,
		-1,
		50,
		22,
		15,
		23,
		25,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		150,
		118,
		123,
		118,
		133,
		144,
		135,
		143,
		137,
		140,
		-1,
		-1,
		145,
		128,
		-1,
		-1,
		102,
		104,
		-1,
		41,
		30,
		0,
		17,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		84,
		122,
		121,
		129,
		124,
		129,
		141,
		137,
		133,
		143,
		134,
		-1,
		-1,
		123,
		115,
		109,
		-1,
		87,
		-1,
		75,
		-1,
		7,
		36,
		38,
		-1,
		-1,
		-1,
		115,
		78,
		94,
		117,
		143,
		141,
		132,
		125,
		132,
		135,
		128,
		134,
		-1,
		-1,
		-1,
		105,
		79,
		82,
		73,
		56,
		36,
		32,
		53,
		-1,
		96,
		-1,
		71,
		74,
		99,
		138,
		140,
		126,
		122,
		135,
		129,
		126,
		124,
		111,
		-1,
		81,
		114,
		78,
		42,
		46,
		41,
		110,
		-1,
		93,
		75,
		-1,
		103,
		93,
		141,
		116,
		125,
		118,
		112,
		113,
		121,
		-1,
		-1,
		-1,
		83,
		82,
		74,
		68,
		66,
		51,
		46,
		-1,
		98,
		80,
		66,
		83,
		83,
		74,
		82,
		131,
		127,
		130,
		128,
		106,
		-1,
		197,
		-1,
		-1,
		106,
		-1,
		-1,
		-1,
		77,
		86,
		59,
		47,
		61,
		68,
		63,
		65,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		105,
		137,
		-1,
		192,
		-1,
		113,
		-1,
		-1,
		93,
		79,
		81,
		70,
		59,
		57,
		60,
		58,
		80,
		110,
		96,
		94,
		99,
		104,
		-1,
		181,
		180,
		-1,
		112,
		104,
		90,
		-1,
		83,
		-1,
		105,
		66,
		-1,
		87,
		67,
		-1,
		105,
		101,
		-1,
		-1,
		168,
		128,
		-1,
		-1,
		-1,
		113,
		93,
		100,
		84,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		153,
		137,
		-1,
		106,
		109,
		-1,
		100,
		106,
		133,
		80,
		84,
		-1,
		-1,
		-1,
		162,
		143,
		137,
		121,
		126,
		114,
		131,
		117,
		116,
		94,
		83,
		104,
		-1,
		-1,
		-1,
		134,
		126,
		126,
		-1,
		-1,
		141,
		124,
		105,
		103,
		-1,
		-1,
		-1,
		156,
		137,
		-1,
		-1,
		131,
		-1,
		-1,
		137,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		145,
		-1,
		-1,
		-1,
		127,
		123,
		124,
		-1,
		-1,
		-1,
		-1,
		166,
		167,
		191,
		166,
		-1,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		169,
		167,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		117,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		152,
		-1,
		152,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		165,
		-1,
		137,
		139,
		-1,
		187,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		142,
		149,
		171,
		174,
		210,
		-1,
		161
	],
	[
		-1,
		278,
		267,
		278,
		286,
		259,
		266,
		-1,
		285,
		289,
		255,
		249,
		288,
		257,
		263,
		274,
		-1,
		-1,
		-1,
		278,
		277,
		245,
		243,
		252,
		257,
		264,
		-1,
		263,
		-1,
		299,
		278,
		289,
		294,
		238,
		235,
		255,
		274,
		256,
		248,
		314,
		268,
		239,
		233,
		251,
		241,
		250,
		242,
		-1,
		239,
		229,
		251,
		230,
		241,
		233,
		-1,
		-1,
		233,
		234,
		240,
		226,
		232,
		228,
		-1,
		238,
		222,
		-1,
		-1,
		223,
		224,
		208,
		211,
		219,
		217,
		230,
		222,
		217,
		-1,
		-1,
		214,
		210,
		217,
		204,
		200,
		217,
		230,
		212,
		226,
		225,
		-1,
		218,
		236,
		243,
		211,
		209,
		193,
		191,
		209,
		211,
		217,
		217,
		-1,
		227,
		228,
		223,
		231,
		233,
		209,
		196,
		196,
		206,
		199,
		218,
		206,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		227,
		210,
		227,
		219,
		209,
		224,
		217,
		199,
		196,
		194,
		191,
		207,
		205,
		215,
		-1,
		-1,
		320,
		289,
		318,
		276,
		257,
		-1,
		223,
		203,
		209,
		213,
		207,
		200,
		214,
		210,
		-1,
		185,
		184,
		212,
		198,
		209,
		280,
		-1,
		-1,
		278,
		270,
		253,
		256,
		233,
		229,
		218,
		217,
		209,
		195,
		191,
		197,
		200,
		200,
		206,
		179,
		189,
		193,
		191,
		216,
		-1,
		-1,
		251,
		-1,
		-1,
		277,
		260,
		-1,
		243,
		250,
		239,
		245,
		231,
		252,
		228,
		219,
		211,
		205,
		193,
		195,
		192,
		205,
		193,
		176,
		201,
		205,
		186,
		207,
		202,
		-1,
		250,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		236,
		239,
		245,
		269,
		268,
		-1,
		240,
		228,
		229,
		214,
		211,
		198,
		186,
		199,
		184,
		191,
		190,
		180,
		178,
		208,
		183,
		205,
		202,
		221,
		226,
		220,
		229,
		-1,
		285,
		281,
		277,
		284,
		233,
		-1,
		-1,
		273,
		-1,
		276,
		277,
		252,
		225,
		228,
		215,
		206,
		193,
		182,
		193,
		182,
		179,
		187,
		172,
		187,
		178,
		177,
		195,
		205,
		213,
		217,
		223,
		-1,
		335,
		-1,
		277,
		261,
		263,
		235,
		256,
		-1,
		293,
		277,
		269,
		254,
		254,
		-1,
		224,
		221,
		211,
		189,
		174,
		191,
		183,
		181,
		185,
		167,
		181,
		172,
		190,
		197,
		195,
		199,
		219,
		231,
		295,
		285,
		-1,
		267,
		272,
		231,
		239,
		258,
		296,
		260,
		-1,
		255,
		-1,
		226,
		239,
		-1,
		195,
		191,
		173,
		174,
		169,
		184,
		178,
		163,
		160,
		178,
		181,
		188,
		192,
		208,
		-1,
		-1,
		280,
		284,
		273,
		224,
		243,
		267,
		304,
		253,
		242,
		241,
		-1,
		232,
		209,
		206,
		194,
		181,
		166,
		167,
		175,
		188,
		167,
		162,
		159,
		179,
		205,
		183,
		195,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		250,
		221,
		245,
		287,
		271,
		264,
		252,
		217,
		217,
		211,
		-1,
		205,
		184,
		175,
		164,
		162,
		175,
		172,
		177,
		157,
		155,
		174,
		186,
		177,
		194,
		-1,
		-1,
		-1,
		280,
		269,
		270,
		216,
		239,
		276,
		250,
		236,
		241,
		216,
		209,
		203,
		218,
		201,
		182,
		171,
		163,
		152,
		168,
		176,
		171,
		153,
		162,
		168,
		192,
		182,
		188,
		-1,
		-1,
		287,
		277,
		261,
		263,
		260,
		230,
		237,
		269,
		241,
		254,
		-1,
		208,
		-1,
		197,
		192,
		176,
		171,
		168,
		165,
		159,
		168,
		170,
		160,
		155,
		162,
		197,
		197,
		172,
		192,
		195,
		-1,
		-1,
		-1,
		280,
		275,
		250,
		227,
		211,
		247,
		-1,
		224,
		225,
		-1,
		202,
		196,
		193,
		178,
		174,
		169,
		173,
		166,
		173,
		166,
		164,
		165,
		147,
		179,
		-1,
		180,
		174,
		182,
		172,
		160,
		-1,
		-1,
		-1,
		273,
		252,
		245,
		265,
		206,
		258,
		-1,
		-1,
		209,
		202,
		-1,
		189,
		171,
		178,
		176,
		170,
		174,
		171,
		160,
		173,
		166,
		152,
		154,
		167,
		171,
		175,
		162,
		158,
		155,
		169,
		-1,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		226,
		-1,
		218,
		210,
		200,
		194,
		188,
		184,
		182,
		198,
		182,
		185,
		183,
		174,
		182,
		155,
		148,
		155,
		144,
		162,
		170,
		162,
		156,
		155,
		165,
		-1,
		293,
		279,
		250,
		-1,
		-1,
		239,
		-1,
		203,
		217,
		233,
		-1,
		226,
		205,
		220,
		198,
		194,
		190,
		205,
		206,
		183,
		183,
		181,
		172,
		160,
		149,
		152,
		144,
		166,
		166,
		150,
		151,
		155,
		-1,
		299,
		286,
		244,
		240,
		229,
		249,
		200,
		188,
		220,
		-1,
		-1,
		262,
		-1,
		196,
		213,
		204,
		202,
		195,
		177,
		184,
		192,
		169,
		164,
		154,
		143,
		143,
		138,
		160,
		146,
		144,
		153,
		169,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		215,
		202,
		196,
		-1,
		237,
		-1,
		240,
		230,
		214,
		199,
		232,
		-1,
		176,
		172,
		179,
		-1,
		189,
		-1,
		162,
		159,
		150,
		135,
		132,
		143,
		141,
		152,
		148,
		-1,
		249,
		234,
		227,
		217,
		231,
		201,
		-1,
		235,
		-1,
		-1,
		227,
		221,
		221,
		205,
		206,
		192,
		172,
		164,
		179,
		178,
		165,
		164,
		148,
		141,
		138,
		131,
		144,
		154,
		159,
		146,
		-1,
		-1,
		-1,
		254,
		231,
		225,
		197,
		201,
		-1,
		-1,
		289,
		244,
		230,
		-1,
		201,
		192,
		180,
		170,
		160,
		165,
		166,
		156,
		154,
		146,
		148,
		142,
		133,
		132,
		148,
		140,
		162,
		-1,
		-1,
		230,
		223,
		211,
		179,
		174,
		-1,
		-1,
		-1,
		236,
		252,
		220,
		199,
		181,
		-1,
		-1,
		164,
		157,
		151,
		154,
		142,
		162,
		157,
		141,
		126,
		141,
		145,
		153,
		144,
		-1,
		233,
		220,
		-1,
		-1,
		173,
		163,
		-1,
		-1,
		-1,
		-1,
		232,
		177,
		166,
		161,
		165,
		163,
		-1,
		137,
		148,
		141,
		160,
		167,
		143,
		128,
		122,
		128,
		140,
		149,
		-1,
		-1,
		187,
		-1,
		149,
		-1,
		-1,
		-1,
		-1,
		189,
		183,
		154,
		147,
		151,
		-1,
		139,
		141,
		138,
		150,
		146,
		143,
		134,
		125,
		121,
		125,
		129,
		143,
		147,
		210,
		-1,
		140,
		-1,
		-1,
		-1,
		186,
		208,
		193,
		170,
		143,
		138,
		131,
		125,
		130,
		141,
		150,
		161,
		126,
		128,
		118,
		117,
		121,
		138,
		142,
		-1,
		-1,
		138,
		134,
		169,
		181,
		181,
		220,
		-1,
		-1,
		147,
		138,
		129,
		121,
		134,
		137,
		122,
		124,
		124,
		122,
		116,
		126,
		141,
		136,
		-1,
		-1,
		-1,
		150,
		-1,
		152,
		-1,
		-1,
		171,
		218,
		165,
		147,
		143,
		141,
		130,
		124,
		112,
		117,
		127,
		121,
		118,
		112,
		116,
		139,
		128,
		167,
		-1,
		-1,
		255,
		-1,
		-1,
		-1,
		157,
		121,
		116,
		150,
		155,
		146,
		180,
		177,
		-1,
		147,
		153,
		118,
		125,
		108,
		115,
		120,
		117,
		106,
		113,
		129,
		128,
		123,
		159,
		150,
		156,
		-1,
		-1,
		248,
		237,
		226,
		232,
		-1,
		150,
		118,
		136,
		126,
		132,
		-1,
		-1,
		172,
		169,
		149,
		118,
		116,
		109,
		104,
		114,
		90,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		147,
		162,
		-1,
		202,
		239,
		232,
		200,
		208,
		239,
		-1,
		140,
		132,
		115,
		118,
		126,
		-1,
		-1,
		145,
		136,
		137,
		125,
		122,
		128,
		127,
		110,
		116,
		117,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		195,
		215,
		194,
		197,
		221,
		235,
		-1,
		137,
		-1,
		-1,
		75,
		139,
		147,
		143,
		141,
		184,
		139,
		134,
		115,
		113,
		108,
		99,
		124,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		184,
		195,
		188,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		65,
		-1,
		173,
		-1,
		164,
		168,
		147,
		150,
		129,
		116,
		102,
		110,
		116,
		115,
		121,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		209,
		165,
		168,
		179,
		190,
		205,
		209,
		-1,
		149,
		188,
		71,
		-1,
		55,
		-1,
		-1,
		-1,
		178,
		160,
		152,
		149,
		128,
		128,
		94,
		98,
		111,
		118,
		128,
		139,
		131,
		135,
		148,
		159,
		162,
		205,
		196,
		209,
		154,
		154,
		175,
		184,
		205,
		154,
		155,
		182,
		78,
		67,
		62,
		49,
		-1,
		-1,
		162,
		170,
		-1,
		-1,
		135,
		102,
		90,
		100,
		104,
		118,
		130,
		143,
		131,
		136,
		130,
		162,
		-1,
		198,
		197,
		186,
		183,
		159,
		150,
		145,
		172,
		-1,
		-1,
		152,
		183,
		134,
		111,
		109,
		134,
		-1,
		33,
		-1,
		-1,
		142,
		-1,
		-1,
		127,
		107,
		96,
		87,
		92,
		112,
		123,
		145,
		127,
		144,
		135,
		145,
		149,
		182,
		179,
		167,
		165,
		188,
		153,
		141,
		-1,
		149,
		149,
		145,
		132,
		112,
		123,
		-1,
		-1,
		49,
		29,
		-1,
		-1,
		125,
		123,
		112,
		-1,
		102,
		84,
		89,
		119,
		121,
		123,
		130,
		124,
		131,
		139,
		150,
		142,
		191,
		205,
		194,
		190,
		189,
		197,
		146,
		139,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		-1,
		35,
		35,
		-1,
		-1,
		120,
		113,
		101,
		89,
		79,
		89,
		106,
		106,
		109,
		114,
		122,
		133,
		129,
		133,
		136,
		-1,
		225,
		-1,
		177,
		138,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		52,
		38,
		31,
		19,
		8,
		-1,
		154,
		138,
		119,
		-1,
		89,
		102,
		142,
		110,
		115,
		110,
		125,
		136,
		127,
		135,
		129,
		132,
		-1,
		-1,
		137,
		120,
		-1,
		-1,
		94,
		96,
		-1,
		43,
		32,
		17,
		0,
		-1,
		-1,
		126,
		122,
		-1,
		-1,
		76,
		114,
		113,
		121,
		116,
		121,
		133,
		129,
		125,
		135,
		126,
		-1,
		-1,
		115,
		107,
		101,
		-1,
		79,
		-1,
		67,
		-1,
		12,
		28,
		30,
		-1,
		-1,
		-1,
		107,
		70,
		86,
		109,
		135,
		133,
		124,
		117,
		124,
		127,
		120,
		126,
		-1,
		-1,
		-1,
		97,
		71,
		74,
		65,
		48,
		28,
		24,
		45,
		-1,
		88,
		-1,
		63,
		66,
		91,
		130,
		132,
		118,
		114,
		127,
		121,
		118,
		116,
		103,
		-1,
		73,
		106,
		70,
		34,
		38,
		33,
		102,
		-1,
		85,
		67,
		-1,
		95,
		85,
		133,
		108,
		117,
		110,
		104,
		105,
		113,
		-1,
		-1,
		-1,
		75,
		74,
		66,
		60,
		58,
		43,
		38,
		-1,
		90,
		72,
		58,
		75,
		75,
		66,
		74,
		123,
		119,
		122,
		120,
		98,
		-1,
		189,
		-1,
		-1,
		98,
		-1,
		-1,
		-1,
		69,
		78,
		51,
		39,
		53,
		60,
		55,
		57,
		70,
		78,
		76,
		73,
		85,
		81,
		101,
		97,
		129,
		-1,
		184,
		-1,
		105,
		-1,
		-1,
		85,
		71,
		73,
		62,
		51,
		49,
		52,
		50,
		72,
		102,
		88,
		86,
		91,
		96,
		-1,
		173,
		172,
		-1,
		104,
		96,
		82,
		-1,
		75,
		-1,
		97,
		58,
		-1,
		79,
		59,
		-1,
		97,
		93,
		-1,
		-1,
		160,
		120,
		-1,
		-1,
		-1,
		105,
		85,
		92,
		76,
		-1,
		70,
		70,
		-1,
		-1,
		-1,
		145,
		129,
		-1,
		98,
		101,
		-1,
		92,
		98,
		125,
		72,
		76,
		-1,
		-1,
		-1,
		154,
		135,
		129,
		113,
		118,
		106,
		123,
		109,
		108,
		86,
		75,
		96,
		-1,
		-1,
		-1,
		126,
		118,
		118,
		-1,
		-1,
		133,
		116,
		97,
		95,
		-1,
		-1,
		-1,
		148,
		129,
		-1,
		-1,
		123,
		-1,
		-1,
		129,
		94,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		137,
		-1,
		-1,
		-1,
		119,
		115,
		116,
		-1,
		-1,
		-1,
		-1,
		158,
		159,
		183,
		158,
		-1,
		-1,
		-1,
		111,
		105,
		-1,
		-1,
		161,
		159,
		-1,
		-1,
		-1,
		139,
		123,
		-1,
		109,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		144,
		-1,
		144,
		119,
		126,
		-1,
		-1,
		-1,
		-1,
		157,
		149,
		157,
		-1,
		129,
		131,
		-1,
		179,
		-1,
		-1,
		172,
		163,
		-1,
		-1,
		134,
		141,
		163,
		166,
		202,
		-1,
		153
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		267,
		256,
		267,
		275,
		248,
		255,
		-1,
		274,
		278,
		244,
		238,
		277,
		246,
		252,
		263,
		-1,
		-1,
		-1,
		267,
		266,
		234,
		232,
		241,
		246,
		253,
		-1,
		252,
		-1,
		288,
		267,
		278,
		283,
		227,
		224,
		244,
		263,
		245,
		237,
		303,
		257,
		228,
		222,
		240,
		230,
		239,
		231,
		-1,
		228,
		218,
		240,
		219,
		230,
		222,
		-1,
		-1,
		222,
		223,
		229,
		215,
		221,
		217,
		-1,
		227,
		211,
		-1,
		-1,
		212,
		213,
		197,
		200,
		208,
		206,
		219,
		211,
		206,
		-1,
		-1,
		203,
		199,
		206,
		193,
		189,
		206,
		219,
		201,
		215,
		214,
		-1,
		207,
		225,
		232,
		200,
		198,
		182,
		180,
		198,
		200,
		206,
		206,
		-1,
		216,
		217,
		212,
		220,
		222,
		198,
		185,
		185,
		195,
		188,
		207,
		195,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		216,
		199,
		216,
		208,
		198,
		213,
		206,
		188,
		185,
		183,
		180,
		196,
		194,
		204,
		-1,
		-1,
		309,
		278,
		307,
		265,
		246,
		-1,
		212,
		192,
		198,
		202,
		196,
		189,
		203,
		199,
		-1,
		174,
		173,
		201,
		187,
		198,
		269,
		-1,
		-1,
		267,
		259,
		242,
		245,
		222,
		218,
		207,
		206,
		198,
		184,
		180,
		186,
		189,
		189,
		195,
		168,
		178,
		182,
		180,
		205,
		-1,
		-1,
		240,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		228,
		234,
		220,
		241,
		217,
		208,
		200,
		194,
		182,
		184,
		181,
		194,
		182,
		165,
		190,
		194,
		175,
		196,
		191,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		257,
		-1,
		229,
		217,
		218,
		203,
		200,
		187,
		175,
		188,
		173,
		180,
		179,
		169,
		167,
		197,
		172,
		194,
		191,
		210,
		215,
		209,
		218,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		265,
		266,
		241,
		214,
		217,
		204,
		195,
		182,
		171,
		182,
		171,
		168,
		176,
		161,
		176,
		167,
		166,
		184,
		194,
		202,
		206,
		212,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		266,
		258,
		243,
		243,
		-1,
		213,
		210,
		200,
		178,
		163,
		180,
		172,
		170,
		174,
		156,
		170,
		161,
		179,
		186,
		184,
		188,
		208,
		220,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		285,
		249,
		-1,
		244,
		-1,
		215,
		228,
		-1,
		184,
		180,
		162,
		163,
		158,
		173,
		167,
		152,
		149,
		167,
		170,
		177,
		181,
		197,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		242,
		231,
		230,
		-1,
		221,
		198,
		195,
		183,
		170,
		155,
		156,
		164,
		177,
		156,
		151,
		148,
		168,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		260,
		253,
		241,
		206,
		206,
		200,
		-1,
		194,
		173,
		164,
		153,
		151,
		164,
		161,
		166,
		146,
		144,
		163,
		175,
		166,
		183,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		205,
		228,
		265,
		239,
		225,
		230,
		205,
		198,
		192,
		207,
		190,
		171,
		160,
		152,
		141,
		157,
		165,
		160,
		142,
		151,
		157,
		181,
		171,
		177,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		219,
		226,
		258,
		230,
		243,
		-1,
		197,
		-1,
		186,
		181,
		165,
		160,
		157,
		154,
		148,
		157,
		159,
		149,
		144,
		151,
		186,
		186,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		269,
		264,
		239,
		216,
		200,
		236,
		-1,
		213,
		214,
		-1,
		191,
		185,
		182,
		167,
		163,
		158,
		162,
		155,
		162,
		155,
		153,
		154,
		136,
		168,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		262,
		241,
		234,
		254,
		195,
		247,
		-1,
		-1,
		198,
		191,
		-1,
		178,
		160,
		167,
		165,
		159,
		163,
		160,
		149,
		162,
		155,
		141,
		143,
		156,
		160,
		164,
		151,
		147,
		144,
		158,
		-1,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		215,
		-1,
		207,
		199,
		189,
		183,
		177,
		173,
		171,
		187,
		171,
		174,
		172,
		163,
		171,
		144,
		137,
		144,
		133,
		151,
		159,
		151,
		145,
		144,
		154,
		-1,
		282,
		268,
		239,
		-1,
		-1,
		228,
		-1,
		192,
		206,
		222,
		-1,
		215,
		194,
		209,
		187,
		183,
		179,
		194,
		195,
		173,
		172,
		170,
		161,
		149,
		138,
		141,
		133,
		155,
		155,
		139,
		140,
		144,
		-1,
		288,
		275,
		233,
		229,
		218,
		238,
		189,
		177,
		209,
		-1,
		-1,
		251,
		-1,
		185,
		202,
		193,
		191,
		184,
		169,
		176,
		181,
		158,
		153,
		143,
		132,
		132,
		127,
		149,
		135,
		133,
		142,
		158,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		204,
		191,
		185,
		-1,
		226,
		-1,
		229,
		219,
		203,
		188,
		221,
		-1,
		168,
		164,
		171,
		-1,
		178,
		-1,
		151,
		148,
		139,
		124,
		121,
		132,
		130,
		141,
		137,
		-1,
		238,
		223,
		216,
		206,
		220,
		191,
		-1,
		246,
		-1,
		-1,
		216,
		210,
		210,
		194,
		197,
		184,
		164,
		156,
		171,
		170,
		157,
		156,
		137,
		130,
		127,
		120,
		133,
		143,
		148,
		135,
		-1,
		-1,
		-1,
		243,
		229,
		233,
		193,
		212,
		-1,
		-1,
		278,
		233,
		219,
		-1,
		193,
		184,
		172,
		162,
		152,
		157,
		158,
		148,
		146,
		135,
		137,
		131,
		122,
		121,
		137,
		129,
		151,
		-1,
		-1,
		226,
		231,
		219,
		205,
		224,
		-1,
		-1,
		-1,
		225,
		241,
		212,
		191,
		173,
		-1,
		-1,
		156,
		149,
		143,
		146,
		134,
		151,
		146,
		130,
		115,
		130,
		134,
		142,
		133,
		-1,
		229,
		216,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		-1,
		-1,
		224,
		169,
		158,
		153,
		157,
		155,
		-1,
		129,
		140,
		133,
		152,
		159,
		132,
		117,
		111,
		117,
		129,
		138,
		-1,
		-1,
		241,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		181,
		175,
		146,
		139,
		143,
		-1,
		131,
		133,
		130,
		142,
		135,
		132,
		123,
		114,
		110,
		114,
		118,
		132,
		136,
		264,
		-1,
		202,
		-1,
		-1,
		-1,
		199,
		214,
		185,
		162,
		135,
		130,
		123,
		117,
		122,
		133,
		142,
		153,
		118,
		117,
		107,
		106,
		110,
		127,
		131,
		-1,
		-1,
		200,
		196,
		225,
		207,
		211,
		212,
		-1,
		-1,
		139,
		130,
		121,
		113,
		126,
		129,
		114,
		116,
		116,
		111,
		105,
		115,
		130,
		125,
		-1,
		-1,
		-1,
		212,
		-1,
		214,
		-1,
		-1,
		202,
		210,
		157,
		139,
		135,
		133,
		120,
		114,
		104,
		109,
		119,
		113,
		110,
		101,
		105,
		128,
		117,
		156,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		191,
		183,
		178,
		184,
		186,
		177,
		172,
		169,
		-1,
		139,
		143,
		110,
		117,
		100,
		107,
		112,
		109,
		95,
		102,
		118,
		117,
		112,
		148,
		139,
		145,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		184,
		180,
		170,
		160,
		163,
		-1,
		-1,
		157,
		154,
		134,
		103,
		108,
		101,
		96,
		101,
		82,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		231,
		268,
		261,
		229,
		237,
		268,
		-1,
		174,
		166,
		177,
		152,
		154,
		-1,
		-1,
		130,
		121,
		122,
		110,
		107,
		120,
		119,
		86,
		91,
		109,
		96,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		224,
		244,
		223,
		226,
		250,
		264,
		-1,
		171,
		-1,
		-1,
		182,
		155,
		139,
		129,
		126,
		169,
		116,
		111,
		88,
		86,
		83,
		74,
		112,
		91,
		103,
		106,
		122,
		127,
		119,
		135,
		135,
		136,
		-1,
		213,
		224,
		217,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		172,
		-1,
		166,
		-1,
		112,
		141,
		124,
		127,
		102,
		89,
		75,
		83,
		89,
		89,
		94,
		97,
		109,
		118,
		129,
		141,
		142,
		143,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		183,
		222,
		178,
		-1,
		162,
		-1,
		-1,
		-1,
		94,
		137,
		129,
		122,
		101,
		101,
		67,
		71,
		84,
		91,
		101,
		115,
		112,
		122,
		135,
		146,
		151,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		198,
		189,
		216,
		185,
		174,
		169,
		156,
		-1,
		-1,
		72,
		147,
		-1,
		-1,
		108,
		75,
		63,
		73,
		77,
		91,
		103,
		116,
		104,
		123,
		117,
		149,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		217,
		207,
		211,
		216,
		241,
		-1,
		145,
		-1,
		-1,
		52,
		-1,
		-1,
		55,
		80,
		69,
		60,
		65,
		85,
		96,
		118,
		100,
		117,
		122,
		132,
		145,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		230,
		-1,
		-1,
		161,
		141,
		-1,
		-1,
		35,
		33,
		40,
		-1,
		66,
		57,
		62,
		92,
		94,
		96,
		103,
		97,
		104,
		130,
		142,
		144,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		30,
		21,
		28,
		39,
		52,
		62,
		79,
		79,
		82,
		87,
		95,
		106,
		120,
		124,
		138,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		29,
		46,
		10,
		-1,
		62,
		75,
		115,
		83,
		88,
		83,
		101,
		112,
		123,
		126,
		131,
		134,
		-1,
		-1,
		194,
		184,
		-1,
		-1,
		158,
		160,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		0,
		6,
		-1,
		-1,
		63,
		97,
		86,
		94,
		89,
		101,
		111,
		109,
		121,
		129,
		128,
		-1,
		-1,
		179,
		171,
		165,
		-1,
		143,
		-1,
		161,
		-1,
		128,
		134,
		122,
		-1,
		-1,
		-1,
		101,
		64,
		85,
		104,
		109,
		107,
		98,
		97,
		104,
		114,
		122,
		128,
		-1,
		-1,
		-1,
		161,
		135,
		168,
		159,
		142,
		122,
		114,
		133,
		-1,
		100,
		-1,
		68,
		65,
		106,
		103,
		120,
		114,
		100,
		115,
		111,
		120,
		118,
		167,
		-1,
		137,
		170,
		134,
		128,
		104,
		108,
		124,
		-1,
		97,
		76,
		-1,
		110,
		100,
		137,
		123,
		111,
		98,
		105,
		119,
		115,
		-1,
		-1,
		-1,
		139,
		138,
		130,
		124,
		124,
		109,
		100,
		-1,
		112,
		94,
		73,
		90,
		90,
		81,
		89,
		127,
		123,
		116,
		118,
		110,
		-1,
		240,
		-1,
		-1,
		162,
		-1,
		-1,
		-1,
		133,
		128,
		101,
		89,
		95,
		91,
		77,
		83,
		85,
		93,
		91,
		88,
		100,
		96,
		116,
		111,
		144,
		-1,
		235,
		-1,
		169,
		-1,
		-1,
		151,
		131,
		123,
		112,
		101,
		99,
		90,
		81,
		103,
		119,
		103,
		101,
		106,
		111,
		-1,
		224,
		223,
		-1,
		170,
		162,
		148,
		-1,
		141,
		-1,
		147,
		108,
		-1,
		110,
		90,
		-1,
		112,
		108,
		-1,
		-1,
		211,
		186,
		-1,
		-1,
		-1,
		171,
		151,
		142,
		126,
		-1,
		101,
		101,
		-1,
		-1,
		-1,
		196,
		195,
		-1,
		164,
		167,
		-1,
		157,
		148,
		156,
		103,
		107,
		-1,
		-1,
		-1,
		205,
		186,
		180,
		179,
		177,
		172,
		169,
		155,
		139,
		117,
		106,
		127,
		-1,
		-1,
		-1,
		177,
		169,
		162,
		-1,
		-1,
		164,
		147,
		128,
		126,
		-1,
		-1,
		-1,
		199,
		180,
		-1,
		-1,
		154,
		-1,
		-1,
		160,
		125,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		188,
		-1,
		-1,
		-1,
		150,
		146,
		147,
		-1,
		-1,
		-1,
		-1,
		210,
		211,
		234,
		198,
		-1,
		-1,
		-1,
		142,
		136,
		-1,
		-1,
		213,
		211,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		140,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		175,
		-1,
		175,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		188,
		180,
		188,
		-1,
		160,
		162,
		-1,
		210,
		-1,
		-1,
		203,
		194,
		-1,
		-1,
		165,
		172,
		194,
		197,
		233,
		-1,
		184
	],
	[
		-1,
		261,
		250,
		261,
		269,
		242,
		249,
		-1,
		268,
		272,
		238,
		232,
		271,
		240,
		246,
		257,
		-1,
		-1,
		-1,
		261,
		260,
		228,
		226,
		235,
		240,
		247,
		-1,
		246,
		-1,
		282,
		261,
		272,
		277,
		221,
		218,
		238,
		257,
		239,
		231,
		297,
		251,
		222,
		216,
		234,
		224,
		233,
		225,
		-1,
		222,
		212,
		234,
		213,
		224,
		216,
		-1,
		-1,
		216,
		217,
		223,
		209,
		215,
		211,
		-1,
		221,
		205,
		-1,
		-1,
		206,
		207,
		191,
		194,
		202,
		200,
		213,
		205,
		200,
		-1,
		-1,
		197,
		193,
		200,
		187,
		183,
		200,
		213,
		195,
		209,
		208,
		-1,
		201,
		219,
		226,
		194,
		192,
		176,
		174,
		192,
		194,
		200,
		200,
		-1,
		210,
		211,
		206,
		214,
		216,
		192,
		179,
		179,
		189,
		182,
		201,
		189,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		210,
		193,
		210,
		202,
		192,
		207,
		200,
		182,
		179,
		177,
		174,
		190,
		188,
		198,
		-1,
		-1,
		303,
		272,
		301,
		259,
		240,
		-1,
		206,
		186,
		192,
		196,
		190,
		183,
		197,
		193,
		-1,
		168,
		167,
		195,
		181,
		192,
		263,
		-1,
		-1,
		261,
		253,
		236,
		239,
		216,
		212,
		201,
		200,
		192,
		178,
		174,
		180,
		183,
		183,
		189,
		162,
		172,
		176,
		174,
		199,
		-1,
		-1,
		234,
		-1,
		-1,
		260,
		243,
		-1,
		226,
		233,
		222,
		228,
		214,
		235,
		211,
		202,
		194,
		188,
		176,
		178,
		175,
		188,
		176,
		159,
		184,
		188,
		169,
		190,
		185,
		-1,
		233,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		219,
		222,
		228,
		252,
		251,
		-1,
		223,
		211,
		212,
		197,
		194,
		181,
		169,
		182,
		167,
		174,
		173,
		163,
		161,
		191,
		166,
		188,
		185,
		204,
		209,
		203,
		212,
		-1,
		268,
		264,
		260,
		267,
		216,
		-1,
		-1,
		256,
		-1,
		259,
		260,
		235,
		208,
		211,
		198,
		189,
		176,
		165,
		176,
		165,
		162,
		170,
		155,
		170,
		161,
		160,
		178,
		188,
		196,
		200,
		206,
		-1,
		318,
		-1,
		260,
		244,
		246,
		218,
		239,
		-1,
		276,
		260,
		252,
		237,
		237,
		-1,
		207,
		204,
		194,
		172,
		157,
		174,
		166,
		164,
		168,
		150,
		164,
		155,
		173,
		180,
		178,
		182,
		202,
		214,
		278,
		268,
		-1,
		250,
		255,
		214,
		222,
		241,
		279,
		243,
		-1,
		238,
		-1,
		209,
		222,
		-1,
		178,
		174,
		156,
		157,
		152,
		167,
		161,
		146,
		143,
		161,
		164,
		171,
		175,
		191,
		-1,
		-1,
		263,
		267,
		256,
		207,
		226,
		250,
		287,
		236,
		225,
		224,
		-1,
		215,
		192,
		189,
		177,
		164,
		149,
		150,
		158,
		171,
		150,
		145,
		142,
		162,
		188,
		166,
		178,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		233,
		204,
		228,
		270,
		254,
		247,
		235,
		200,
		200,
		194,
		-1,
		188,
		167,
		158,
		147,
		145,
		158,
		155,
		160,
		140,
		138,
		157,
		169,
		160,
		177,
		-1,
		-1,
		-1,
		263,
		252,
		253,
		199,
		222,
		259,
		233,
		219,
		224,
		199,
		192,
		186,
		201,
		184,
		165,
		154,
		146,
		135,
		151,
		159,
		154,
		136,
		145,
		151,
		175,
		165,
		171,
		-1,
		-1,
		270,
		260,
		244,
		246,
		243,
		213,
		220,
		252,
		224,
		237,
		-1,
		191,
		-1,
		180,
		175,
		159,
		154,
		151,
		148,
		142,
		151,
		153,
		143,
		138,
		145,
		180,
		180,
		155,
		175,
		178,
		-1,
		-1,
		-1,
		263,
		258,
		233,
		210,
		194,
		230,
		-1,
		207,
		208,
		-1,
		185,
		179,
		176,
		161,
		157,
		152,
		156,
		149,
		156,
		149,
		147,
		148,
		130,
		162,
		-1,
		163,
		157,
		165,
		155,
		143,
		-1,
		-1,
		-1,
		256,
		235,
		228,
		248,
		189,
		241,
		-1,
		-1,
		192,
		185,
		-1,
		172,
		154,
		161,
		159,
		153,
		157,
		154,
		143,
		156,
		149,
		135,
		137,
		150,
		154,
		158,
		145,
		141,
		138,
		152,
		-1,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		209,
		-1,
		201,
		193,
		183,
		177,
		171,
		167,
		165,
		181,
		165,
		168,
		166,
		157,
		165,
		138,
		131,
		138,
		127,
		145,
		153,
		145,
		139,
		138,
		148,
		-1,
		276,
		262,
		233,
		-1,
		-1,
		222,
		-1,
		186,
		200,
		216,
		-1,
		209,
		188,
		203,
		181,
		177,
		173,
		188,
		189,
		167,
		166,
		164,
		155,
		143,
		132,
		135,
		127,
		149,
		149,
		133,
		134,
		138,
		-1,
		282,
		269,
		227,
		223,
		212,
		232,
		183,
		171,
		203,
		-1,
		-1,
		245,
		-1,
		179,
		196,
		187,
		185,
		178,
		163,
		170,
		175,
		152,
		147,
		137,
		126,
		126,
		121,
		143,
		129,
		127,
		136,
		152,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		198,
		185,
		179,
		-1,
		220,
		-1,
		223,
		213,
		197,
		182,
		215,
		-1,
		162,
		158,
		165,
		-1,
		172,
		-1,
		145,
		142,
		133,
		118,
		115,
		126,
		124,
		135,
		131,
		-1,
		232,
		217,
		210,
		200,
		214,
		185,
		-1,
		240,
		-1,
		-1,
		210,
		204,
		204,
		188,
		191,
		178,
		158,
		150,
		165,
		164,
		151,
		150,
		131,
		124,
		121,
		114,
		127,
		137,
		142,
		129,
		-1,
		-1,
		-1,
		237,
		223,
		227,
		187,
		206,
		-1,
		-1,
		272,
		227,
		213,
		-1,
		187,
		178,
		166,
		156,
		146,
		151,
		152,
		142,
		140,
		129,
		131,
		125,
		116,
		115,
		131,
		123,
		145,
		-1,
		-1,
		220,
		225,
		213,
		199,
		218,
		-1,
		-1,
		-1,
		219,
		235,
		206,
		185,
		167,
		-1,
		-1,
		150,
		143,
		137,
		140,
		128,
		145,
		140,
		124,
		109,
		124,
		128,
		136,
		127,
		-1,
		223,
		210,
		-1,
		-1,
		221,
		215,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		149,
		-1,
		123,
		134,
		127,
		146,
		153,
		126,
		111,
		105,
		111,
		123,
		132,
		-1,
		-1,
		235,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		125,
		127,
		124,
		136,
		129,
		126,
		117,
		108,
		104,
		108,
		112,
		126,
		130,
		258,
		-1,
		196,
		-1,
		-1,
		-1,
		193,
		208,
		179,
		156,
		129,
		124,
		117,
		111,
		116,
		127,
		136,
		147,
		112,
		111,
		101,
		100,
		104,
		121,
		125,
		-1,
		-1,
		194,
		190,
		219,
		201,
		205,
		206,
		-1,
		-1,
		133,
		124,
		115,
		107,
		120,
		123,
		108,
		110,
		110,
		105,
		99,
		109,
		124,
		119,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		196,
		204,
		151,
		133,
		129,
		127,
		114,
		108,
		98,
		103,
		113,
		107,
		104,
		95,
		99,
		122,
		111,
		150,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		166,
		163,
		-1,
		133,
		137,
		104,
		111,
		94,
		101,
		106,
		103,
		89,
		96,
		112,
		111,
		106,
		142,
		133,
		139,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		151,
		148,
		128,
		97,
		102,
		95,
		90,
		95,
		76,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		130,
		145,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		124,
		115,
		116,
		104,
		101,
		114,
		113,
		80,
		85,
		103,
		90,
		91,
		109,
		113,
		122,
		129,
		119,
		132,
		136,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		165,
		-1,
		-1,
		176,
		149,
		133,
		123,
		120,
		163,
		110,
		105,
		82,
		80,
		77,
		68,
		106,
		85,
		97,
		100,
		116,
		121,
		113,
		129,
		129,
		130,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		166,
		-1,
		160,
		-1,
		106,
		135,
		118,
		121,
		96,
		83,
		69,
		77,
		83,
		83,
		88,
		91,
		103,
		112,
		123,
		135,
		136,
		137,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		177,
		216,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		88,
		131,
		123,
		116,
		95,
		95,
		61,
		65,
		78,
		85,
		95,
		109,
		106,
		116,
		129,
		140,
		145,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		192,
		183,
		210,
		179,
		168,
		163,
		150,
		-1,
		-1,
		66,
		141,
		-1,
		-1,
		102,
		69,
		57,
		67,
		71,
		85,
		97,
		110,
		98,
		117,
		111,
		143,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		211,
		201,
		205,
		210,
		235,
		-1,
		139,
		-1,
		-1,
		46,
		-1,
		-1,
		49,
		74,
		63,
		54,
		59,
		79,
		90,
		112,
		94,
		111,
		116,
		126,
		139,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		224,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		29,
		27,
		34,
		-1,
		60,
		51,
		56,
		86,
		88,
		90,
		97,
		91,
		98,
		124,
		136,
		138,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		24,
		15,
		22,
		33,
		46,
		56,
		73,
		73,
		76,
		81,
		89,
		100,
		114,
		118,
		132,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		33,
		40,
		4,
		-1,
		56,
		69,
		109,
		77,
		82,
		77,
		95,
		106,
		117,
		120,
		125,
		128,
		-1,
		-1,
		188,
		178,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		5,
		0,
		-1,
		-1,
		57,
		91,
		80,
		88,
		83,
		95,
		105,
		103,
		115,
		123,
		122,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		95,
		58,
		79,
		98,
		103,
		101,
		92,
		91,
		98,
		108,
		116,
		122,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		94,
		-1,
		62,
		59,
		100,
		97,
		114,
		108,
		94,
		109,
		105,
		114,
		112,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		91,
		70,
		-1,
		104,
		94,
		131,
		117,
		105,
		92,
		99,
		113,
		109,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		84,
		84,
		75,
		83,
		121,
		117,
		110,
		112,
		104,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		79,
		87,
		85,
		82,
		94,
		90,
		110,
		105,
		138,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		113,
		97,
		95,
		100,
		105,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		106,
		102,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		229,
		218,
		229,
		237,
		210,
		217,
		-1,
		236,
		240,
		206,
		200,
		239,
		208,
		214,
		225,
		-1,
		-1,
		-1,
		229,
		228,
		196,
		194,
		203,
		208,
		215,
		-1,
		214,
		-1,
		250,
		229,
		240,
		245,
		189,
		186,
		206,
		225,
		207,
		199,
		265,
		219,
		190,
		184,
		202,
		192,
		201,
		193,
		-1,
		190,
		180,
		202,
		181,
		192,
		184,
		-1,
		-1,
		184,
		185,
		191,
		177,
		183,
		179,
		-1,
		189,
		173,
		-1,
		-1,
		174,
		175,
		159,
		162,
		170,
		168,
		181,
		173,
		168,
		-1,
		-1,
		165,
		161,
		168,
		155,
		151,
		168,
		181,
		163,
		177,
		176,
		-1,
		169,
		187,
		194,
		162,
		160,
		144,
		142,
		160,
		162,
		168,
		168,
		-1,
		178,
		179,
		174,
		182,
		184,
		160,
		147,
		147,
		157,
		150,
		169,
		157,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		178,
		161,
		178,
		170,
		160,
		175,
		168,
		150,
		147,
		145,
		142,
		158,
		156,
		166,
		-1,
		-1,
		271,
		240,
		269,
		227,
		208,
		-1,
		174,
		154,
		160,
		164,
		158,
		151,
		165,
		161,
		-1,
		136,
		135,
		163,
		149,
		160,
		231,
		-1,
		-1,
		229,
		221,
		204,
		207,
		184,
		180,
		169,
		168,
		160,
		146,
		142,
		148,
		151,
		151,
		157,
		130,
		140,
		144,
		142,
		167,
		-1,
		-1,
		202,
		-1,
		-1,
		228,
		211,
		-1,
		194,
		201,
		190,
		196,
		182,
		203,
		179,
		170,
		162,
		156,
		144,
		146,
		143,
		156,
		144,
		127,
		152,
		156,
		137,
		158,
		153,
		-1,
		201,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		187,
		190,
		196,
		220,
		219,
		-1,
		191,
		179,
		180,
		165,
		162,
		149,
		137,
		150,
		135,
		142,
		141,
		131,
		129,
		159,
		134,
		156,
		153,
		172,
		177,
		171,
		180,
		-1,
		236,
		232,
		228,
		235,
		184,
		-1,
		-1,
		224,
		-1,
		227,
		228,
		203,
		176,
		179,
		166,
		157,
		144,
		133,
		144,
		133,
		130,
		138,
		123,
		138,
		129,
		128,
		146,
		156,
		164,
		168,
		174,
		-1,
		286,
		-1,
		228,
		212,
		214,
		186,
		207,
		-1,
		244,
		228,
		220,
		205,
		205,
		-1,
		175,
		172,
		162,
		140,
		125,
		142,
		134,
		132,
		136,
		118,
		132,
		123,
		141,
		148,
		146,
		150,
		170,
		182,
		246,
		236,
		-1,
		218,
		223,
		182,
		190,
		209,
		247,
		211,
		-1,
		206,
		-1,
		177,
		190,
		-1,
		146,
		142,
		124,
		125,
		120,
		135,
		129,
		114,
		111,
		129,
		132,
		139,
		143,
		159,
		-1,
		-1,
		231,
		235,
		224,
		175,
		194,
		218,
		255,
		204,
		193,
		192,
		-1,
		183,
		160,
		157,
		145,
		132,
		117,
		118,
		126,
		139,
		118,
		113,
		110,
		130,
		156,
		134,
		146,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		201,
		172,
		196,
		238,
		222,
		215,
		203,
		168,
		168,
		162,
		-1,
		156,
		135,
		126,
		115,
		113,
		126,
		123,
		128,
		108,
		106,
		125,
		137,
		128,
		145,
		-1,
		-1,
		-1,
		231,
		220,
		221,
		167,
		190,
		227,
		201,
		187,
		192,
		167,
		160,
		154,
		169,
		152,
		133,
		122,
		114,
		103,
		119,
		127,
		122,
		104,
		113,
		119,
		143,
		133,
		139,
		-1,
		-1,
		238,
		228,
		212,
		214,
		211,
		181,
		188,
		220,
		192,
		205,
		-1,
		159,
		-1,
		148,
		143,
		127,
		122,
		119,
		116,
		110,
		119,
		121,
		111,
		106,
		113,
		148,
		148,
		123,
		143,
		146,
		-1,
		-1,
		-1,
		231,
		226,
		201,
		178,
		162,
		198,
		-1,
		175,
		176,
		-1,
		153,
		147,
		144,
		129,
		125,
		120,
		124,
		117,
		124,
		117,
		115,
		116,
		98,
		130,
		-1,
		131,
		125,
		133,
		123,
		111,
		-1,
		-1,
		-1,
		224,
		203,
		196,
		216,
		157,
		209,
		-1,
		-1,
		160,
		153,
		-1,
		140,
		122,
		129,
		127,
		121,
		125,
		122,
		111,
		124,
		117,
		103,
		105,
		118,
		122,
		126,
		113,
		109,
		106,
		120,
		-1,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		177,
		-1,
		169,
		161,
		151,
		145,
		139,
		135,
		133,
		149,
		133,
		136,
		134,
		125,
		133,
		106,
		99,
		106,
		95,
		113,
		121,
		113,
		107,
		106,
		116,
		-1,
		244,
		230,
		201,
		-1,
		-1,
		190,
		-1,
		154,
		168,
		184,
		-1,
		177,
		156,
		171,
		149,
		145,
		141,
		156,
		157,
		135,
		134,
		132,
		123,
		111,
		100,
		103,
		95,
		117,
		117,
		101,
		102,
		106,
		-1,
		250,
		237,
		195,
		191,
		180,
		200,
		151,
		139,
		171,
		-1,
		-1,
		213,
		-1,
		147,
		164,
		155,
		153,
		146,
		131,
		138,
		143,
		120,
		115,
		105,
		94,
		94,
		89,
		111,
		97,
		95,
		104,
		120,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		166,
		153,
		147,
		-1,
		188,
		-1,
		191,
		181,
		165,
		150,
		183,
		-1,
		130,
		126,
		133,
		-1,
		140,
		-1,
		113,
		110,
		101,
		86,
		83,
		94,
		92,
		103,
		99,
		-1,
		200,
		185,
		178,
		168,
		182,
		153,
		-1,
		208,
		-1,
		-1,
		178,
		172,
		172,
		156,
		159,
		146,
		126,
		118,
		133,
		132,
		119,
		118,
		99,
		92,
		89,
		82,
		95,
		105,
		110,
		97,
		-1,
		-1,
		-1,
		205,
		191,
		195,
		155,
		174,
		-1,
		-1,
		240,
		195,
		181,
		-1,
		155,
		146,
		134,
		124,
		114,
		119,
		120,
		110,
		108,
		97,
		99,
		93,
		84,
		83,
		99,
		91,
		113,
		-1,
		-1,
		188,
		193,
		181,
		167,
		186,
		-1,
		-1,
		-1,
		187,
		203,
		174,
		153,
		135,
		-1,
		-1,
		118,
		111,
		105,
		108,
		96,
		113,
		108,
		92,
		77,
		92,
		96,
		104,
		95,
		-1,
		191,
		178,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		-1,
		-1,
		186,
		131,
		120,
		115,
		119,
		117,
		-1,
		91,
		102,
		95,
		114,
		121,
		94,
		79,
		73,
		79,
		91,
		100,
		-1,
		-1,
		203,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		143,
		137,
		108,
		101,
		105,
		-1,
		93,
		95,
		92,
		104,
		97,
		94,
		85,
		76,
		72,
		76,
		80,
		94,
		98,
		226,
		-1,
		164,
		-1,
		-1,
		-1,
		161,
		176,
		147,
		124,
		97,
		92,
		85,
		79,
		84,
		95,
		104,
		115,
		80,
		79,
		69,
		68,
		72,
		89,
		93,
		-1,
		-1,
		162,
		158,
		187,
		169,
		173,
		174,
		-1,
		-1,
		101,
		92,
		83,
		75,
		88,
		91,
		76,
		78,
		78,
		73,
		67,
		77,
		92,
		87,
		-1,
		-1,
		-1,
		174,
		-1,
		176,
		-1,
		-1,
		164,
		172,
		119,
		101,
		97,
		95,
		82,
		76,
		66,
		71,
		81,
		75,
		72,
		63,
		67,
		90,
		79,
		118,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		153,
		145,
		140,
		146,
		148,
		139,
		134,
		131,
		-1,
		101,
		105,
		72,
		79,
		62,
		69,
		74,
		71,
		57,
		64,
		80,
		79,
		74,
		110,
		101,
		107,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		146,
		142,
		132,
		122,
		125,
		-1,
		-1,
		119,
		116,
		96,
		65,
		70,
		63,
		58,
		63,
		44,
		53,
		57,
		61,
		67,
		72,
		77,
		83,
		98,
		113,
		-1,
		193,
		230,
		223,
		191,
		199,
		230,
		-1,
		136,
		128,
		139,
		114,
		116,
		-1,
		-1,
		92,
		83,
		84,
		72,
		69,
		82,
		81,
		48,
		53,
		71,
		58,
		59,
		77,
		81,
		90,
		97,
		87,
		100,
		104,
		-1,
		186,
		206,
		185,
		188,
		212,
		226,
		-1,
		133,
		-1,
		-1,
		129,
		117,
		101,
		91,
		88,
		131,
		78,
		73,
		50,
		48,
		45,
		36,
		74,
		53,
		65,
		68,
		84,
		89,
		81,
		97,
		97,
		98,
		-1,
		175,
		186,
		179,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		119,
		-1,
		128,
		-1,
		111,
		115,
		86,
		89,
		64,
		51,
		37,
		45,
		51,
		51,
		56,
		59,
		71,
		80,
		91,
		103,
		104,
		105,
		200,
		156,
		159,
		170,
		181,
		196,
		200,
		-1,
		145,
		184,
		125,
		-1,
		109,
		-1,
		-1,
		-1,
		119,
		99,
		91,
		84,
		63,
		63,
		29,
		33,
		46,
		53,
		63,
		77,
		74,
		84,
		97,
		108,
		113,
		196,
		187,
		200,
		145,
		145,
		166,
		175,
		196,
		160,
		151,
		178,
		132,
		121,
		116,
		103,
		-1,
		-1,
		97,
		109,
		-1,
		-1,
		70,
		37,
		25,
		35,
		39,
		53,
		65,
		78,
		66,
		85,
		79,
		111,
		-1,
		189,
		188,
		177,
		174,
		150,
		141,
		136,
		163,
		-1,
		-1,
		158,
		179,
		169,
		165,
		163,
		188,
		-1,
		92,
		-1,
		-1,
		77,
		-1,
		-1,
		62,
		42,
		31,
		22,
		27,
		47,
		58,
		80,
		62,
		79,
		84,
		94,
		107,
		173,
		170,
		158,
		156,
		179,
		144,
		132,
		-1,
		145,
		143,
		149,
		156,
		166,
		177,
		-1,
		-1,
		108,
		88,
		-1,
		-1,
		60,
		58,
		47,
		-1,
		37,
		19,
		24,
		54,
		56,
		58,
		65,
		59,
		66,
		92,
		104,
		104,
		182,
		196,
		185,
		181,
		180,
		188,
		137,
		130,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		98,
		94,
		-1,
		-1,
		55,
		48,
		36,
		24,
		14,
		24,
		41,
		41,
		44,
		49,
		57,
		68,
		82,
		86,
		98,
		-1,
		216,
		-1,
		168,
		144,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		115,
		101,
		94,
		82,
		80,
		-1,
		89,
		73,
		54,
		-1,
		24,
		37,
		77,
		45,
		50,
		45,
		63,
		74,
		85,
		88,
		91,
		94,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		106,
		95,
		80,
		72,
		-1,
		-1,
		61,
		57,
		-1,
		-1,
		0,
		59,
		48,
		56,
		51,
		63,
		73,
		71,
		83,
		91,
		88,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		108,
		-1,
		75,
		81,
		69,
		-1,
		-1,
		-1,
		44,
		7,
		30,
		66,
		71,
		69,
		60,
		59,
		66,
		76,
		82,
		88,
		-1,
		-1,
		-1,
		108,
		82,
		115,
		106,
		89,
		69,
		61,
		80,
		-1,
		47,
		-1,
		15,
		12,
		53,
		65,
		82,
		76,
		62,
		77,
		73,
		80,
		78,
		114,
		-1,
		84,
		117,
		81,
		75,
		51,
		55,
		71,
		-1,
		44,
		23,
		-1,
		57,
		47,
		95,
		70,
		73,
		60,
		66,
		67,
		75,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		71,
		56,
		47,
		-1,
		59,
		41,
		20,
		37,
		37,
		28,
		36,
		85,
		81,
		78,
		80,
		60,
		-1,
		187,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		75,
		48,
		36,
		42,
		38,
		24,
		30,
		32,
		40,
		38,
		35,
		47,
		43,
		63,
		59,
		91,
		-1,
		182,
		-1,
		116,
		-1,
		-1,
		98,
		78,
		70,
		59,
		48,
		46,
		37,
		28,
		50,
		66,
		50,
		48,
		53,
		58,
		-1,
		171,
		170,
		-1,
		117,
		109,
		95,
		-1,
		88,
		-1,
		94,
		55,
		-1,
		57,
		37,
		-1,
		59,
		55,
		-1,
		-1,
		158,
		133,
		-1,
		-1,
		-1,
		118,
		98,
		89,
		73,
		-1,
		48,
		48,
		-1,
		-1,
		-1,
		143,
		142,
		-1,
		111,
		114,
		-1,
		104,
		95,
		103,
		50,
		54,
		-1,
		-1,
		-1,
		152,
		133,
		127,
		126,
		124,
		119,
		116,
		102,
		86,
		64,
		53,
		74,
		-1,
		-1,
		-1,
		124,
		116,
		109,
		-1,
		-1,
		111,
		94,
		75,
		73,
		-1,
		-1,
		-1,
		146,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		107,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		135,
		-1,
		-1,
		-1,
		97,
		93,
		94,
		-1,
		-1,
		-1,
		-1,
		157,
		158,
		181,
		145,
		-1,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		160,
		158,
		-1,
		-1,
		-1,
		117,
		101,
		-1,
		87,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		122,
		-1,
		122,
		97,
		104,
		-1,
		-1,
		-1,
		-1,
		135,
		127,
		135,
		-1,
		107,
		109,
		-1,
		157,
		-1,
		-1,
		150,
		141,
		-1,
		-1,
		112,
		119,
		141,
		144,
		180,
		-1,
		131
	],
	[
		-1,
		254,
		243,
		254,
		262,
		235,
		242,
		-1,
		261,
		265,
		231,
		225,
		264,
		233,
		239,
		250,
		-1,
		-1,
		-1,
		254,
		253,
		221,
		219,
		228,
		233,
		240,
		-1,
		239,
		-1,
		275,
		254,
		265,
		270,
		214,
		211,
		231,
		250,
		232,
		224,
		290,
		244,
		215,
		209,
		227,
		217,
		226,
		218,
		-1,
		215,
		205,
		227,
		206,
		217,
		209,
		-1,
		-1,
		209,
		210,
		216,
		202,
		208,
		204,
		-1,
		214,
		198,
		-1,
		-1,
		199,
		200,
		184,
		187,
		195,
		193,
		206,
		198,
		193,
		-1,
		-1,
		190,
		186,
		193,
		180,
		176,
		193,
		206,
		188,
		202,
		201,
		-1,
		194,
		212,
		219,
		187,
		185,
		169,
		167,
		185,
		187,
		193,
		193,
		-1,
		203,
		204,
		199,
		207,
		209,
		185,
		172,
		172,
		182,
		175,
		194,
		182,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		203,
		186,
		203,
		195,
		185,
		200,
		193,
		175,
		172,
		170,
		167,
		183,
		181,
		191,
		-1,
		-1,
		296,
		265,
		294,
		252,
		233,
		-1,
		199,
		179,
		185,
		189,
		183,
		176,
		190,
		186,
		-1,
		161,
		160,
		188,
		174,
		185,
		256,
		-1,
		-1,
		254,
		246,
		229,
		232,
		209,
		205,
		194,
		193,
		185,
		171,
		167,
		173,
		176,
		176,
		182,
		155,
		165,
		169,
		167,
		192,
		-1,
		-1,
		227,
		-1,
		-1,
		253,
		236,
		-1,
		219,
		226,
		215,
		221,
		207,
		228,
		204,
		195,
		187,
		181,
		169,
		171,
		168,
		181,
		169,
		152,
		177,
		181,
		162,
		183,
		178,
		-1,
		226,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		212,
		215,
		221,
		245,
		244,
		-1,
		216,
		204,
		205,
		190,
		187,
		174,
		162,
		175,
		160,
		167,
		166,
		156,
		154,
		184,
		159,
		181,
		178,
		197,
		202,
		196,
		205,
		-1,
		261,
		257,
		253,
		260,
		209,
		-1,
		-1,
		249,
		-1,
		252,
		253,
		228,
		201,
		204,
		191,
		182,
		169,
		158,
		169,
		158,
		155,
		163,
		148,
		163,
		154,
		153,
		171,
		181,
		189,
		193,
		199,
		-1,
		311,
		-1,
		253,
		237,
		239,
		211,
		232,
		-1,
		269,
		253,
		245,
		230,
		230,
		-1,
		200,
		197,
		187,
		165,
		150,
		167,
		159,
		157,
		161,
		143,
		157,
		148,
		166,
		173,
		171,
		175,
		195,
		207,
		271,
		261,
		-1,
		243,
		248,
		207,
		215,
		234,
		272,
		236,
		-1,
		231,
		-1,
		202,
		215,
		-1,
		171,
		167,
		149,
		150,
		145,
		160,
		154,
		139,
		136,
		154,
		157,
		164,
		168,
		184,
		-1,
		-1,
		256,
		260,
		249,
		200,
		219,
		243,
		280,
		229,
		218,
		217,
		-1,
		208,
		185,
		182,
		170,
		157,
		142,
		143,
		151,
		164,
		143,
		138,
		135,
		155,
		181,
		159,
		171,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		226,
		197,
		221,
		263,
		247,
		240,
		228,
		193,
		193,
		187,
		-1,
		181,
		160,
		151,
		140,
		138,
		151,
		148,
		153,
		133,
		131,
		150,
		162,
		153,
		170,
		-1,
		-1,
		-1,
		256,
		245,
		246,
		192,
		215,
		252,
		226,
		212,
		217,
		192,
		185,
		179,
		194,
		177,
		158,
		147,
		139,
		128,
		144,
		152,
		147,
		129,
		138,
		144,
		168,
		158,
		164,
		-1,
		-1,
		263,
		253,
		237,
		239,
		236,
		206,
		213,
		245,
		217,
		230,
		-1,
		184,
		-1,
		173,
		168,
		152,
		147,
		144,
		141,
		135,
		144,
		146,
		136,
		131,
		138,
		173,
		173,
		148,
		168,
		171,
		-1,
		-1,
		-1,
		256,
		251,
		226,
		203,
		187,
		223,
		-1,
		200,
		201,
		-1,
		178,
		172,
		169,
		154,
		150,
		145,
		149,
		142,
		149,
		142,
		140,
		141,
		123,
		155,
		-1,
		156,
		150,
		158,
		148,
		136,
		-1,
		-1,
		-1,
		249,
		228,
		221,
		241,
		182,
		234,
		-1,
		-1,
		185,
		178,
		-1,
		165,
		147,
		154,
		152,
		146,
		150,
		147,
		136,
		149,
		142,
		128,
		130,
		143,
		147,
		151,
		138,
		134,
		131,
		145,
		-1,
		268,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		202,
		-1,
		194,
		186,
		176,
		170,
		164,
		160,
		158,
		174,
		158,
		161,
		159,
		150,
		158,
		131,
		124,
		131,
		120,
		138,
		146,
		138,
		132,
		131,
		141,
		-1,
		269,
		255,
		226,
		-1,
		-1,
		215,
		-1,
		179,
		193,
		209,
		-1,
		202,
		181,
		196,
		174,
		170,
		166,
		181,
		182,
		160,
		159,
		157,
		148,
		136,
		125,
		128,
		120,
		142,
		142,
		126,
		127,
		131,
		-1,
		275,
		262,
		220,
		216,
		205,
		225,
		176,
		164,
		196,
		-1,
		-1,
		238,
		-1,
		172,
		189,
		180,
		178,
		171,
		156,
		163,
		168,
		145,
		140,
		130,
		119,
		119,
		114,
		136,
		122,
		120,
		129,
		145,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		191,
		178,
		172,
		-1,
		213,
		-1,
		216,
		206,
		190,
		175,
		208,
		-1,
		155,
		151,
		158,
		-1,
		165,
		-1,
		138,
		135,
		126,
		111,
		108,
		119,
		117,
		128,
		124,
		-1,
		225,
		210,
		203,
		193,
		207,
		178,
		-1,
		233,
		-1,
		-1,
		203,
		197,
		197,
		181,
		184,
		171,
		151,
		143,
		158,
		157,
		144,
		143,
		124,
		117,
		114,
		107,
		120,
		130,
		135,
		122,
		-1,
		-1,
		-1,
		230,
		216,
		220,
		180,
		199,
		-1,
		-1,
		265,
		220,
		206,
		-1,
		180,
		171,
		159,
		149,
		139,
		144,
		145,
		135,
		133,
		122,
		124,
		118,
		109,
		108,
		124,
		116,
		138,
		-1,
		-1,
		213,
		218,
		206,
		192,
		211,
		-1,
		-1,
		-1,
		212,
		228,
		199,
		178,
		160,
		-1,
		-1,
		143,
		136,
		130,
		133,
		121,
		138,
		133,
		117,
		102,
		117,
		121,
		129,
		120,
		-1,
		216,
		203,
		-1,
		-1,
		214,
		208,
		-1,
		-1,
		-1,
		-1,
		211,
		156,
		145,
		140,
		144,
		142,
		-1,
		116,
		127,
		120,
		139,
		146,
		119,
		104,
		98,
		104,
		116,
		125,
		-1,
		-1,
		228,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		168,
		162,
		133,
		126,
		130,
		-1,
		118,
		120,
		117,
		129,
		122,
		119,
		110,
		101,
		97,
		101,
		105,
		119,
		123,
		251,
		-1,
		189,
		-1,
		-1,
		-1,
		186,
		201,
		172,
		149,
		122,
		117,
		110,
		104,
		109,
		120,
		129,
		140,
		105,
		104,
		94,
		93,
		97,
		114,
		118,
		-1,
		-1,
		187,
		183,
		212,
		194,
		198,
		199,
		-1,
		-1,
		126,
		117,
		108,
		100,
		113,
		116,
		101,
		103,
		103,
		98,
		92,
		102,
		117,
		112,
		-1,
		-1,
		-1,
		199,
		-1,
		201,
		-1,
		-1,
		189,
		197,
		144,
		126,
		122,
		120,
		107,
		101,
		91,
		96,
		106,
		100,
		97,
		88,
		92,
		115,
		104,
		124,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		178,
		170,
		165,
		171,
		173,
		164,
		159,
		156,
		-1,
		126,
		130,
		97,
		104,
		87,
		94,
		99,
		96,
		82,
		89,
		105,
		104,
		99,
		116,
		107,
		111,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		171,
		167,
		157,
		147,
		150,
		-1,
		-1,
		144,
		141,
		121,
		90,
		95,
		88,
		83,
		88,
		69,
		78,
		82,
		80,
		92,
		97,
		102,
		95,
		102,
		117,
		-1,
		218,
		255,
		248,
		216,
		224,
		255,
		-1,
		161,
		153,
		164,
		139,
		141,
		-1,
		-1,
		117,
		108,
		109,
		97,
		94,
		107,
		106,
		73,
		70,
		92,
		75,
		84,
		96,
		88,
		92,
		93,
		100,
		111,
		115,
		-1,
		211,
		231,
		210,
		213,
		237,
		251,
		-1,
		158,
		-1,
		-1,
		170,
		142,
		126,
		116,
		113,
		156,
		103,
		98,
		75,
		73,
		70,
		61,
		91,
		70,
		74,
		71,
		80,
		85,
		77,
		103,
		105,
		111,
		-1,
		200,
		211,
		204,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		162,
		-1,
		153,
		-1,
		136,
		140,
		111,
		114,
		89,
		76,
		62,
		62,
		68,
		68,
		73,
		76,
		67,
		76,
		87,
		99,
		109,
		111,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		170,
		209,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		150,
		124,
		116,
		109,
		88,
		88,
		54,
		50,
		63,
		70,
		80,
		84,
		68,
		80,
		93,
		104,
		119,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		185,
		176,
		203,
		175,
		164,
		159,
		146,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		95,
		71,
		58,
		52,
		56,
		70,
		82,
		80,
		60,
		80,
		75,
		107,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		204,
		194,
		198,
		206,
		231,
		-1,
		135,
		-1,
		-1,
		111,
		-1,
		-1,
		96,
		76,
		65,
		56,
		42,
		64,
		75,
		97,
		56,
		73,
		80,
		90,
		103,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		170,
		168,
		174,
		181,
		198,
		220,
		-1,
		-1,
		151,
		131,
		-1,
		-1,
		94,
		92,
		81,
		-1,
		71,
		53,
		39,
		66,
		50,
		52,
		59,
		53,
		60,
		86,
		99,
		100,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		141,
		137,
		-1,
		-1,
		89,
		82,
		70,
		58,
		48,
		53,
		39,
		29,
		38,
		43,
		51,
		62,
		76,
		80,
		94,
		-1,
		241,
		-1,
		193,
		169,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		158,
		144,
		137,
		125,
		123,
		-1,
		123,
		107,
		88,
		-1,
		58,
		71,
		49,
		20,
		44,
		39,
		57,
		68,
		79,
		82,
		87,
		90,
		-1,
		-1,
		181,
		174,
		-1,
		-1,
		148,
		150,
		-1,
		149,
		138,
		123,
		115,
		-1,
		-1,
		95,
		91,
		-1,
		-1,
		59,
		0,
		18,
		50,
		45,
		57,
		67,
		65,
		77,
		85,
		84,
		-1,
		-1,
		169,
		161,
		155,
		-1,
		133,
		-1,
		151,
		-1,
		118,
		124,
		112,
		-1,
		-1,
		-1,
		97,
		60,
		81,
		7,
		35,
		39,
		54,
		53,
		60,
		70,
		78,
		84,
		-1,
		-1,
		-1,
		151,
		125,
		158,
		149,
		132,
		112,
		104,
		123,
		-1,
		93,
		-1,
		64,
		61,
		21,
		27,
		62,
		56,
		56,
		71,
		67,
		76,
		74,
		157,
		-1,
		127,
		160,
		124,
		118,
		94,
		98,
		114,
		-1,
		90,
		72,
		-1,
		59,
		28,
		79,
		65,
		67,
		54,
		61,
		75,
		71,
		-1,
		-1,
		-1,
		129,
		128,
		120,
		114,
		114,
		99,
		90,
		-1,
		102,
		84,
		63,
		72,
		57,
		54,
		46,
		69,
		65,
		72,
		74,
		66,
		-1,
		230,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		123,
		118,
		91,
		79,
		85,
		81,
		67,
		73,
		67,
		49,
		43,
		47,
		63,
		64,
		84,
		67,
		103,
		-1,
		225,
		-1,
		159,
		-1,
		-1,
		141,
		121,
		113,
		102,
		91,
		89,
		80,
		71,
		93,
		85,
		69,
		69,
		74,
		75,
		-1,
		214,
		213,
		-1,
		160,
		152,
		138,
		-1,
		131,
		-1,
		137,
		98,
		-1,
		100,
		80,
		-1,
		80,
		76,
		-1,
		-1,
		201,
		176,
		-1,
		-1,
		-1,
		161,
		141,
		132,
		116,
		-1,
		91,
		91,
		-1,
		-1,
		-1,
		186,
		185,
		-1,
		154,
		157,
		-1,
		147,
		138,
		146,
		93,
		97,
		-1,
		-1,
		-1,
		195,
		176,
		170,
		169,
		167,
		162,
		159,
		145,
		129,
		107,
		96,
		117,
		-1,
		-1,
		-1,
		167,
		159,
		152,
		-1,
		-1,
		154,
		137,
		118,
		116,
		-1,
		-1,
		-1,
		189,
		170,
		-1,
		-1,
		144,
		-1,
		-1,
		150,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		178,
		-1,
		-1,
		-1,
		140,
		136,
		137,
		-1,
		-1,
		-1,
		-1,
		200,
		201,
		224,
		188,
		-1,
		-1,
		-1,
		132,
		126,
		-1,
		-1,
		203,
		201,
		-1,
		-1,
		-1,
		160,
		144,
		-1,
		130,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		165,
		-1,
		165,
		140,
		147,
		-1,
		-1,
		-1,
		-1,
		178,
		170,
		178,
		-1,
		150,
		152,
		-1,
		200,
		-1,
		-1,
		193,
		184,
		-1,
		-1,
		155,
		162,
		184,
		187,
		223,
		-1,
		174
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		146,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		142,
		149,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		131,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		141,
		137,
		144,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		170,
		157,
		137,
		129,
		144,
		143,
		130,
		129,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		166,
		157,
		145,
		135,
		125,
		130,
		131,
		121,
		119,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		185,
		164,
		146,
		-1,
		-1,
		129,
		122,
		116,
		119,
		107,
		124,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		197,
		142,
		131,
		126,
		130,
		128,
		-1,
		102,
		113,
		106,
		125,
		132,
		105,
		90,
		84,
		90,
		102,
		111,
		-1,
		-1,
		214,
		-1,
		184,
		-1,
		-1,
		-1,
		-1,
		154,
		148,
		119,
		112,
		116,
		-1,
		104,
		106,
		103,
		115,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		105,
		109,
		237,
		-1,
		175,
		-1,
		-1,
		-1,
		172,
		187,
		158,
		135,
		108,
		103,
		96,
		90,
		95,
		106,
		115,
		126,
		91,
		90,
		80,
		79,
		83,
		100,
		104,
		-1,
		-1,
		173,
		169,
		198,
		180,
		184,
		185,
		-1,
		-1,
		112,
		103,
		94,
		86,
		99,
		102,
		87,
		89,
		89,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		185,
		-1,
		187,
		-1,
		-1,
		175,
		183,
		130,
		112,
		108,
		106,
		93,
		87,
		77,
		82,
		92,
		86,
		83,
		74,
		78,
		101,
		90,
		110,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		164,
		156,
		151,
		157,
		159,
		150,
		145,
		142,
		-1,
		112,
		116,
		83,
		90,
		73,
		80,
		85,
		82,
		68,
		75,
		91,
		90,
		85,
		102,
		93,
		97,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		157,
		153,
		143,
		133,
		136,
		-1,
		-1,
		130,
		127,
		107,
		76,
		81,
		74,
		69,
		74,
		55,
		64,
		68,
		66,
		78,
		83,
		88,
		81,
		88,
		103,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		147,
		139,
		150,
		125,
		127,
		-1,
		-1,
		103,
		94,
		95,
		83,
		80,
		93,
		92,
		59,
		56,
		78,
		61,
		70,
		82,
		74,
		78,
		79,
		86,
		97,
		101,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		144,
		-1,
		-1,
		156,
		128,
		112,
		102,
		99,
		142,
		89,
		84,
		61,
		59,
		56,
		47,
		77,
		56,
		60,
		57,
		66,
		71,
		63,
		89,
		91,
		97,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		154,
		-1,
		139,
		-1,
		122,
		126,
		97,
		100,
		75,
		62,
		48,
		48,
		54,
		54,
		59,
		62,
		53,
		62,
		73,
		85,
		95,
		97,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		156,
		195,
		160,
		-1,
		144,
		-1,
		-1,
		-1,
		136,
		110,
		102,
		95,
		74,
		74,
		40,
		36,
		49,
		56,
		66,
		70,
		54,
		66,
		79,
		90,
		105,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		162,
		189,
		167,
		156,
		151,
		138,
		-1,
		-1,
		117,
		120,
		-1,
		-1,
		81,
		57,
		44,
		38,
		42,
		56,
		68,
		66,
		46,
		66,
		61,
		93,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		190,
		180,
		184,
		198,
		223,
		-1,
		127,
		-1,
		-1,
		97,
		-1,
		-1,
		82,
		62,
		51,
		42,
		28,
		50,
		61,
		83,
		42,
		59,
		66,
		76,
		89,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		156,
		154,
		160,
		167,
		184,
		212,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		80,
		78,
		67,
		-1,
		57,
		39,
		25,
		49,
		36,
		38,
		45,
		39,
		46,
		72,
		85,
		86,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		75,
		68,
		56,
		44,
		34,
		39,
		22,
		11,
		24,
		29,
		37,
		48,
		62,
		66,
		80,
		-1,
		227,
		-1,
		179,
		155,
		169,
		184,
		192,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		109,
		93,
		74,
		-1,
		44,
		57,
		44,
		2,
		30,
		25,
		43,
		54,
		65,
		68,
		73,
		76,
		-1,
		-1,
		167,
		166,
		-1,
		-1,
		140,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		81,
		77,
		-1,
		-1,
		45,
		14,
		0,
		36,
		31,
		43,
		53,
		51,
		63,
		71,
		70,
		-1,
		-1,
		161,
		153,
		147,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		83,
		46,
		67,
		21,
		28,
		32,
		40,
		39,
		46,
		56,
		64,
		70,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		82,
		-1,
		50,
		47,
		35,
		20,
		55,
		49,
		42,
		57,
		53,
		62,
		60,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		79,
		58,
		-1,
		73,
		42,
		72,
		58,
		53,
		40,
		47,
		61,
		57,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		72,
		71,
		63,
		60,
		62,
		58,
		58,
		60,
		52,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		67,
		63,
		57,
		61,
		77,
		70,
		74,
		53,
		89,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		99,
		77,
		65,
		60,
		61,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		76,
		65,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		259,
		263,
		229,
		223,
		262,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		252,
		251,
		219,
		217,
		226,
		231,
		238,
		-1,
		237,
		-1,
		273,
		252,
		263,
		268,
		212,
		209,
		229,
		248,
		230,
		222,
		288,
		242,
		213,
		207,
		225,
		215,
		224,
		216,
		-1,
		213,
		203,
		225,
		204,
		215,
		207,
		-1,
		-1,
		207,
		208,
		214,
		200,
		206,
		202,
		-1,
		212,
		196,
		-1,
		-1,
		197,
		198,
		182,
		185,
		193,
		191,
		204,
		196,
		191,
		-1,
		-1,
		188,
		184,
		191,
		178,
		174,
		191,
		204,
		186,
		200,
		199,
		-1,
		192,
		210,
		217,
		185,
		183,
		167,
		165,
		183,
		185,
		191,
		191,
		-1,
		201,
		202,
		197,
		205,
		207,
		183,
		170,
		170,
		180,
		173,
		192,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		201,
		184,
		201,
		193,
		183,
		198,
		191,
		173,
		170,
		168,
		165,
		181,
		179,
		189,
		-1,
		-1,
		294,
		263,
		292,
		250,
		231,
		-1,
		197,
		177,
		183,
		187,
		181,
		174,
		188,
		184,
		-1,
		159,
		158,
		186,
		172,
		183,
		254,
		-1,
		-1,
		252,
		244,
		227,
		230,
		207,
		203,
		192,
		191,
		183,
		169,
		165,
		171,
		174,
		174,
		180,
		153,
		163,
		167,
		165,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		251,
		234,
		-1,
		217,
		224,
		213,
		219,
		205,
		226,
		202,
		193,
		185,
		179,
		167,
		169,
		166,
		179,
		167,
		150,
		175,
		179,
		160,
		181,
		176,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		210,
		213,
		219,
		243,
		242,
		-1,
		214,
		202,
		203,
		188,
		185,
		172,
		160,
		173,
		158,
		165,
		164,
		154,
		152,
		182,
		157,
		179,
		176,
		195,
		200,
		194,
		203,
		-1,
		259,
		255,
		251,
		258,
		207,
		-1,
		-1,
		247,
		-1,
		250,
		251,
		226,
		199,
		202,
		189,
		180,
		167,
		156,
		167,
		156,
		153,
		161,
		146,
		161,
		152,
		151,
		169,
		179,
		187,
		191,
		197,
		-1,
		309,
		-1,
		251,
		235,
		237,
		209,
		230,
		-1,
		267,
		251,
		243,
		228,
		228,
		-1,
		198,
		195,
		185,
		163,
		148,
		165,
		157,
		155,
		159,
		141,
		155,
		146,
		164,
		171,
		169,
		173,
		193,
		205,
		269,
		259,
		-1,
		241,
		246,
		205,
		213,
		232,
		270,
		234,
		-1,
		229,
		-1,
		200,
		213,
		-1,
		169,
		165,
		147,
		148,
		143,
		158,
		152,
		137,
		134,
		152,
		155,
		162,
		166,
		182,
		-1,
		-1,
		254,
		258,
		247,
		198,
		217,
		241,
		278,
		227,
		216,
		215,
		-1,
		206,
		183,
		180,
		168,
		155,
		140,
		141,
		149,
		162,
		141,
		136,
		133,
		153,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		224,
		195,
		219,
		261,
		245,
		238,
		226,
		191,
		191,
		185,
		-1,
		179,
		158,
		149,
		138,
		136,
		149,
		146,
		151,
		131,
		129,
		148,
		160,
		151,
		168,
		-1,
		-1,
		-1,
		254,
		243,
		244,
		190,
		213,
		250,
		224,
		210,
		215,
		190,
		183,
		177,
		192,
		175,
		156,
		145,
		137,
		126,
		142,
		150,
		145,
		127,
		136,
		142,
		166,
		156,
		162,
		-1,
		-1,
		261,
		251,
		235,
		237,
		234,
		204,
		211,
		243,
		215,
		228,
		-1,
		182,
		-1,
		171,
		166,
		150,
		145,
		142,
		139,
		133,
		142,
		144,
		134,
		129,
		136,
		171,
		171,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		254,
		249,
		224,
		201,
		185,
		221,
		-1,
		198,
		199,
		-1,
		176,
		170,
		167,
		152,
		148,
		143,
		147,
		140,
		147,
		140,
		138,
		139,
		121,
		153,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		247,
		226,
		219,
		239,
		180,
		232,
		-1,
		-1,
		183,
		176,
		-1,
		163,
		145,
		152,
		150,
		144,
		148,
		145,
		134,
		147,
		140,
		126,
		128,
		141,
		145,
		149,
		136,
		132,
		129,
		143,
		-1,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		200,
		-1,
		192,
		184,
		174,
		168,
		162,
		158,
		156,
		172,
		156,
		159,
		157,
		148,
		156,
		129,
		122,
		129,
		118,
		136,
		144,
		136,
		130,
		129,
		139,
		-1,
		267,
		253,
		224,
		-1,
		-1,
		213,
		-1,
		177,
		191,
		207,
		-1,
		200,
		179,
		194,
		172,
		168,
		164,
		179,
		180,
		158,
		157,
		155,
		146,
		134,
		123,
		126,
		118,
		140,
		140,
		124,
		125,
		129,
		-1,
		273,
		260,
		218,
		214,
		203,
		223,
		174,
		162,
		194,
		-1,
		-1,
		236,
		-1,
		170,
		187,
		178,
		176,
		169,
		154,
		161,
		166,
		143,
		138,
		128,
		117,
		117,
		112,
		134,
		120,
		118,
		127,
		143,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		189,
		176,
		170,
		-1,
		211,
		-1,
		214,
		204,
		188,
		173,
		206,
		-1,
		153,
		149,
		156,
		-1,
		163,
		-1,
		136,
		133,
		124,
		109,
		106,
		117,
		115,
		126,
		122,
		-1,
		223,
		208,
		201,
		191,
		205,
		176,
		-1,
		231,
		-1,
		-1,
		201,
		195,
		195,
		179,
		182,
		169,
		149,
		141,
		156,
		155,
		142,
		141,
		122,
		115,
		112,
		105,
		118,
		128,
		133,
		120,
		-1,
		-1,
		-1,
		228,
		214,
		218,
		178,
		197,
		-1,
		-1,
		263,
		218,
		204,
		-1,
		178,
		169,
		157,
		147,
		137,
		142,
		143,
		133,
		131,
		120,
		122,
		116,
		107,
		106,
		122,
		114,
		136,
		-1,
		-1,
		211,
		216,
		204,
		190,
		209,
		-1,
		-1,
		-1,
		210,
		226,
		197,
		176,
		158,
		-1,
		-1,
		141,
		134,
		128,
		131,
		119,
		136,
		131,
		115,
		100,
		115,
		119,
		127,
		118,
		-1,
		214,
		201,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		118,
		137,
		144,
		117,
		102,
		96,
		102,
		114,
		123,
		-1,
		-1,
		226,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		115,
		127,
		120,
		117,
		108,
		99,
		95,
		99,
		103,
		117,
		121,
		249,
		-1,
		187,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		127,
		138,
		103,
		102,
		92,
		91,
		95,
		112,
		114,
		-1,
		-1,
		185,
		181,
		210,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		99,
		101,
		101,
		96,
		90,
		100,
		113,
		108,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		195,
		142,
		124,
		120,
		118,
		105,
		99,
		89,
		94,
		104,
		98,
		95,
		86,
		88,
		111,
		100,
		117,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		157,
		154,
		-1,
		124,
		128,
		95,
		102,
		85,
		92,
		97,
		94,
		80,
		85,
		101,
		100,
		95,
		109,
		100,
		104,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		93,
		86,
		81,
		86,
		67,
		76,
		78,
		73,
		88,
		93,
		95,
		88,
		95,
		110,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		105,
		104,
		71,
		68,
		90,
		71,
		78,
		89,
		81,
		85,
		86,
		93,
		104,
		108,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		101,
		96,
		73,
		71,
		68,
		59,
		89,
		68,
		67,
		64,
		73,
		78,
		70,
		96,
		98,
		100,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		166,
		-1,
		151,
		-1,
		134,
		138,
		109,
		112,
		87,
		74,
		60,
		60,
		66,
		66,
		71,
		71,
		60,
		69,
		80,
		92,
		102,
		104,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		148,
		122,
		114,
		107,
		86,
		86,
		52,
		48,
		61,
		68,
		78,
		77,
		61,
		73,
		86,
		97,
		108,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		179,
		168,
		163,
		150,
		-1,
		-1,
		129,
		132,
		-1,
		-1,
		93,
		69,
		56,
		50,
		54,
		68,
		80,
		73,
		53,
		73,
		68,
		100,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		210,
		235,
		-1,
		139,
		-1,
		-1,
		109,
		-1,
		-1,
		94,
		74,
		63,
		54,
		40,
		62,
		73,
		95,
		49,
		66,
		73,
		83,
		89,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		224,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		92,
		90,
		79,
		-1,
		69,
		51,
		37,
		60,
		43,
		45,
		52,
		46,
		53,
		75,
		88,
		82,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		87,
		80,
		68,
		56,
		46,
		51,
		33,
		29,
		31,
		36,
		44,
		55,
		65,
		69,
		76,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		121,
		105,
		86,
		-1,
		56,
		69,
		69,
		37,
		7,
		23,
		43,
		52,
		61,
		71,
		69,
		72,
		-1,
		-1,
		179,
		178,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		93,
		89,
		-1,
		-1,
		57,
		47,
		36,
		0,
		12,
		39,
		48,
		47,
		59,
		74,
		66,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		95,
		58,
		79,
		54,
		31,
		29,
		29,
		35,
		42,
		52,
		60,
		66,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		94,
		-1,
		62,
		59,
		68,
		39,
		42,
		36,
		37,
		45,
		49,
		58,
		56,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		91,
		70,
		-1,
		104,
		75,
		59,
		45,
		41,
		36,
		43,
		57,
		53,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		84,
		84,
		75,
		80,
		49,
		45,
		54,
		56,
		48,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		79,
		87,
		82,
		79,
		75,
		66,
		68,
		49,
		85,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		113,
		73,
		61,
		56,
		57,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		72,
		61,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		246,
		235,
		246,
		254,
		227,
		234,
		-1,
		253,
		257,
		223,
		217,
		256,
		225,
		231,
		242,
		-1,
		-1,
		-1,
		246,
		245,
		213,
		211,
		220,
		225,
		232,
		-1,
		231,
		-1,
		267,
		246,
		257,
		262,
		206,
		203,
		223,
		242,
		224,
		216,
		282,
		236,
		207,
		201,
		219,
		209,
		218,
		210,
		-1,
		207,
		197,
		219,
		198,
		209,
		201,
		-1,
		-1,
		201,
		202,
		208,
		194,
		200,
		196,
		-1,
		206,
		190,
		-1,
		-1,
		191,
		192,
		176,
		179,
		187,
		185,
		198,
		190,
		185,
		-1,
		-1,
		182,
		178,
		185,
		172,
		168,
		185,
		198,
		180,
		194,
		193,
		-1,
		186,
		204,
		211,
		179,
		177,
		161,
		159,
		177,
		179,
		185,
		185,
		-1,
		195,
		196,
		191,
		199,
		201,
		177,
		164,
		164,
		174,
		167,
		186,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		195,
		178,
		195,
		187,
		177,
		192,
		185,
		167,
		164,
		162,
		159,
		175,
		173,
		183,
		-1,
		-1,
		288,
		257,
		286,
		244,
		225,
		-1,
		191,
		171,
		177,
		181,
		175,
		168,
		182,
		178,
		-1,
		153,
		152,
		180,
		166,
		177,
		248,
		-1,
		-1,
		246,
		238,
		221,
		224,
		201,
		197,
		186,
		185,
		177,
		163,
		159,
		165,
		168,
		168,
		174,
		147,
		157,
		161,
		159,
		184,
		-1,
		-1,
		219,
		-1,
		-1,
		245,
		228,
		-1,
		211,
		218,
		207,
		213,
		199,
		220,
		196,
		187,
		179,
		173,
		161,
		163,
		160,
		173,
		161,
		144,
		169,
		173,
		154,
		175,
		170,
		-1,
		218,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		204,
		207,
		213,
		237,
		236,
		-1,
		208,
		196,
		197,
		182,
		179,
		166,
		154,
		167,
		152,
		159,
		158,
		148,
		146,
		176,
		151,
		173,
		170,
		189,
		194,
		188,
		197,
		-1,
		253,
		249,
		245,
		252,
		201,
		-1,
		-1,
		241,
		-1,
		244,
		245,
		220,
		193,
		196,
		183,
		174,
		161,
		150,
		161,
		150,
		147,
		155,
		140,
		155,
		146,
		145,
		163,
		173,
		181,
		185,
		191,
		-1,
		303,
		-1,
		245,
		229,
		231,
		203,
		224,
		-1,
		261,
		245,
		237,
		222,
		222,
		-1,
		192,
		189,
		179,
		157,
		142,
		159,
		151,
		149,
		153,
		135,
		149,
		140,
		158,
		165,
		163,
		167,
		187,
		199,
		263,
		253,
		-1,
		235,
		240,
		199,
		207,
		226,
		264,
		228,
		-1,
		223,
		-1,
		194,
		207,
		-1,
		163,
		159,
		141,
		142,
		137,
		152,
		146,
		131,
		128,
		146,
		149,
		156,
		160,
		176,
		-1,
		-1,
		248,
		252,
		241,
		192,
		211,
		235,
		272,
		221,
		210,
		209,
		-1,
		200,
		177,
		174,
		162,
		149,
		134,
		135,
		143,
		156,
		135,
		130,
		127,
		147,
		173,
		151,
		163,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		218,
		189,
		213,
		255,
		239,
		232,
		220,
		185,
		185,
		179,
		-1,
		173,
		152,
		143,
		132,
		130,
		143,
		140,
		145,
		125,
		123,
		142,
		154,
		145,
		162,
		-1,
		-1,
		-1,
		248,
		237,
		238,
		184,
		207,
		244,
		218,
		204,
		209,
		184,
		177,
		171,
		186,
		169,
		150,
		139,
		131,
		120,
		136,
		144,
		139,
		121,
		130,
		136,
		160,
		150,
		156,
		-1,
		-1,
		255,
		245,
		229,
		231,
		228,
		198,
		205,
		237,
		209,
		222,
		-1,
		176,
		-1,
		165,
		160,
		144,
		139,
		136,
		133,
		127,
		136,
		138,
		128,
		123,
		130,
		165,
		165,
		140,
		160,
		163,
		-1,
		-1,
		-1,
		248,
		243,
		218,
		195,
		179,
		215,
		-1,
		192,
		193,
		-1,
		170,
		164,
		161,
		146,
		142,
		137,
		141,
		134,
		141,
		134,
		132,
		133,
		115,
		147,
		-1,
		148,
		142,
		150,
		140,
		128,
		-1,
		-1,
		-1,
		241,
		220,
		213,
		233,
		174,
		226,
		-1,
		-1,
		177,
		170,
		-1,
		157,
		139,
		146,
		144,
		138,
		142,
		139,
		128,
		141,
		134,
		120,
		122,
		135,
		139,
		143,
		130,
		126,
		123,
		137,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		194,
		-1,
		186,
		178,
		168,
		162,
		156,
		152,
		150,
		166,
		150,
		153,
		151,
		142,
		150,
		123,
		116,
		123,
		112,
		130,
		138,
		130,
		124,
		123,
		133,
		-1,
		261,
		247,
		218,
		-1,
		-1,
		207,
		-1,
		171,
		185,
		201,
		-1,
		194,
		173,
		188,
		166,
		162,
		158,
		173,
		174,
		152,
		151,
		149,
		140,
		128,
		117,
		120,
		112,
		134,
		134,
		118,
		119,
		123,
		-1,
		267,
		254,
		212,
		208,
		197,
		217,
		168,
		156,
		188,
		-1,
		-1,
		230,
		-1,
		164,
		181,
		172,
		170,
		163,
		148,
		155,
		160,
		137,
		132,
		122,
		111,
		111,
		106,
		128,
		114,
		112,
		121,
		137,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		183,
		170,
		164,
		-1,
		205,
		-1,
		208,
		198,
		182,
		167,
		200,
		-1,
		147,
		143,
		150,
		-1,
		157,
		-1,
		130,
		127,
		118,
		103,
		100,
		111,
		109,
		120,
		116,
		-1,
		217,
		202,
		195,
		185,
		199,
		170,
		-1,
		225,
		-1,
		-1,
		195,
		189,
		189,
		173,
		176,
		163,
		143,
		135,
		150,
		149,
		136,
		135,
		116,
		109,
		106,
		99,
		112,
		122,
		127,
		114,
		-1,
		-1,
		-1,
		222,
		208,
		212,
		172,
		191,
		-1,
		-1,
		257,
		212,
		198,
		-1,
		172,
		163,
		151,
		141,
		131,
		136,
		137,
		127,
		125,
		114,
		116,
		110,
		101,
		100,
		116,
		108,
		130,
		-1,
		-1,
		205,
		210,
		198,
		184,
		203,
		-1,
		-1,
		-1,
		204,
		220,
		191,
		170,
		152,
		-1,
		-1,
		135,
		128,
		122,
		125,
		113,
		130,
		125,
		109,
		94,
		109,
		113,
		121,
		112,
		-1,
		208,
		195,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		-1,
		-1,
		203,
		148,
		137,
		132,
		136,
		134,
		-1,
		108,
		119,
		112,
		131,
		138,
		111,
		96,
		90,
		96,
		108,
		117,
		-1,
		-1,
		220,
		-1,
		190,
		-1,
		-1,
		-1,
		-1,
		160,
		154,
		125,
		118,
		122,
		-1,
		110,
		112,
		109,
		121,
		114,
		111,
		102,
		93,
		89,
		93,
		97,
		111,
		115,
		243,
		-1,
		181,
		-1,
		-1,
		-1,
		178,
		193,
		164,
		141,
		114,
		109,
		102,
		96,
		101,
		112,
		121,
		132,
		97,
		96,
		86,
		85,
		89,
		106,
		108,
		-1,
		-1,
		179,
		175,
		204,
		186,
		190,
		191,
		-1,
		-1,
		118,
		109,
		100,
		92,
		105,
		108,
		93,
		95,
		95,
		90,
		84,
		94,
		107,
		102,
		-1,
		-1,
		-1,
		191,
		-1,
		193,
		-1,
		-1,
		181,
		189,
		136,
		118,
		114,
		112,
		99,
		93,
		83,
		88,
		98,
		92,
		89,
		80,
		82,
		105,
		94,
		111,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		170,
		162,
		157,
		163,
		165,
		156,
		151,
		148,
		-1,
		118,
		122,
		89,
		96,
		79,
		86,
		91,
		88,
		74,
		79,
		95,
		94,
		89,
		103,
		94,
		98,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		163,
		159,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		87,
		80,
		75,
		80,
		61,
		70,
		72,
		67,
		82,
		87,
		89,
		82,
		89,
		104,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		153,
		145,
		156,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		99,
		98,
		65,
		62,
		84,
		65,
		72,
		83,
		75,
		79,
		80,
		87,
		98,
		102,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		150,
		-1,
		-1,
		162,
		134,
		118,
		108,
		105,
		148,
		95,
		90,
		67,
		65,
		62,
		53,
		83,
		62,
		61,
		58,
		67,
		72,
		64,
		90,
		92,
		92,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		160,
		-1,
		145,
		-1,
		128,
		132,
		103,
		106,
		81,
		68,
		54,
		54,
		60,
		60,
		65,
		65,
		54,
		63,
		74,
		86,
		96,
		98,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		162,
		201,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		142,
		116,
		108,
		101,
		80,
		80,
		46,
		42,
		55,
		62,
		72,
		71,
		55,
		67,
		80,
		91,
		100,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		168,
		195,
		173,
		162,
		157,
		144,
		-1,
		-1,
		123,
		126,
		-1,
		-1,
		87,
		63,
		50,
		44,
		48,
		62,
		74,
		67,
		47,
		67,
		62,
		94,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		196,
		186,
		190,
		204,
		229,
		-1,
		133,
		-1,
		-1,
		103,
		-1,
		-1,
		88,
		68,
		57,
		48,
		34,
		56,
		67,
		89,
		43,
		60,
		67,
		77,
		81,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		162,
		160,
		166,
		173,
		190,
		218,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		86,
		84,
		73,
		-1,
		63,
		45,
		31,
		58,
		37,
		39,
		46,
		40,
		47,
		67,
		80,
		74,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		81,
		74,
		62,
		50,
		40,
		45,
		31,
		27,
		25,
		30,
		38,
		49,
		57,
		61,
		68,
		-1,
		233,
		-1,
		185,
		161,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		115,
		99,
		80,
		-1,
		50,
		63,
		63,
		31,
		5,
		17,
		32,
		43,
		53,
		63,
		61,
		64,
		-1,
		-1,
		173,
		172,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		51,
		45,
		34,
		11,
		0,
		28,
		42,
		39,
		51,
		66,
		58,
		-1,
		-1,
		167,
		159,
		153,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		89,
		52,
		73,
		52,
		29,
		27,
		27,
		27,
		34,
		44,
		52,
		58,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		88,
		-1,
		56,
		53,
		66,
		37,
		40,
		34,
		30,
		43,
		41,
		50,
		48,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		85,
		64,
		-1,
		98,
		73,
		57,
		43,
		39,
		28,
		35,
		49,
		45,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		78,
		78,
		69,
		72,
		47,
		43,
		46,
		48,
		40,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		73,
		81,
		74,
		71,
		67,
		58,
		62,
		41,
		77,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		107,
		65,
		53,
		48,
		49,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		64,
		53,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		144,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		132,
		138,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		112,
		108,
		105,
		119,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		106,
		105,
		115,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		134,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		101,
		105,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		136,
		142,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		103,
		119,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		147,
		137,
		142,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		98,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		158,
		163,
		143,
		135,
		142,
		134,
		126,
		120,
		98,
		91,
		88,
		81,
		94,
		104,
		109,
		96,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		164,
		163,
		151,
		141,
		131,
		136,
		137,
		117,
		110,
		96,
		98,
		92,
		83,
		82,
		98,
		90,
		112,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		191,
		165,
		152,
		-1,
		-1,
		135,
		128,
		122,
		113,
		100,
		112,
		107,
		91,
		76,
		91,
		95,
		103,
		94,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		203,
		148,
		137,
		132,
		136,
		134,
		-1,
		108,
		119,
		104,
		116,
		123,
		93,
		78,
		72,
		78,
		90,
		99,
		-1,
		-1,
		202,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		160,
		154,
		125,
		118,
		122,
		-1,
		110,
		112,
		106,
		121,
		96,
		93,
		84,
		75,
		71,
		75,
		79,
		93,
		97,
		225,
		-1,
		188,
		-1,
		-1,
		-1,
		178,
		193,
		164,
		141,
		114,
		109,
		102,
		96,
		101,
		112,
		104,
		115,
		82,
		78,
		68,
		67,
		71,
		88,
		88,
		-1,
		-1,
		186,
		182,
		204,
		186,
		190,
		191,
		-1,
		-1,
		118,
		109,
		100,
		92,
		105,
		108,
		88,
		85,
		79,
		72,
		66,
		76,
		87,
		82,
		-1,
		-1,
		-1,
		198,
		-1,
		200,
		-1,
		-1,
		188,
		189,
		136,
		118,
		114,
		112,
		101,
		95,
		83,
		88,
		89,
		80,
		74,
		62,
		62,
		85,
		74,
		91,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		177,
		169,
		164,
		170,
		172,
		163,
		151,
		148,
		-1,
		118,
		124,
		89,
		96,
		79,
		86,
		84,
		76,
		56,
		59,
		75,
		74,
		69,
		83,
		74,
		78,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		170,
		166,
		156,
		146,
		149,
		-1,
		-1,
		143,
		140,
		120,
		89,
		87,
		80,
		75,
		85,
		65,
		52,
		52,
		47,
		62,
		67,
		69,
		62,
		69,
		84,
		-1,
		217,
		254,
		247,
		215,
		223,
		254,
		-1,
		160,
		152,
		163,
		138,
		140,
		-1,
		-1,
		116,
		107,
		108,
		96,
		93,
		95,
		90,
		73,
		61,
		67,
		45,
		52,
		63,
		55,
		59,
		60,
		67,
		78,
		82,
		-1,
		210,
		230,
		209,
		212,
		236,
		250,
		-1,
		157,
		-1,
		-1,
		169,
		141,
		125,
		115,
		112,
		155,
		103,
		98,
		75,
		73,
		70,
		61,
		69,
		53,
		41,
		38,
		47,
		52,
		44,
		70,
		72,
		75,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		163,
		-1,
		152,
		-1,
		135,
		139,
		111,
		114,
		89,
		76,
		62,
		62,
		68,
		53,
		49,
		45,
		34,
		43,
		54,
		66,
		76,
		78,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		169,
		208,
		169,
		-1,
		153,
		-1,
		-1,
		-1,
		149,
		124,
		116,
		109,
		88,
		88,
		54,
		50,
		58,
		54,
		59,
		51,
		35,
		47,
		60,
		71,
		83,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		184,
		175,
		202,
		176,
		165,
		160,
		147,
		-1,
		-1,
		131,
		134,
		-1,
		-1,
		95,
		71,
		58,
		52,
		56,
		68,
		59,
		47,
		27,
		47,
		42,
		74,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		203,
		193,
		197,
		207,
		232,
		-1,
		136,
		-1,
		-1,
		111,
		-1,
		-1,
		96,
		76,
		65,
		56,
		42,
		64,
		63,
		74,
		23,
		40,
		47,
		57,
		64,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		197,
		221,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		94,
		92,
		81,
		-1,
		71,
		53,
		39,
		66,
		42,
		32,
		26,
		20,
		27,
		44,
		57,
		57,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		89,
		82,
		70,
		58,
		48,
		53,
		39,
		35,
		30,
		23,
		18,
		29,
		34,
		38,
		51,
		-1,
		240,
		-1,
		192,
		168,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		123,
		107,
		88,
		-1,
		58,
		71,
		71,
		39,
		31,
		29,
		4,
		15,
		30,
		40,
		44,
		47,
		-1,
		-1,
		180,
		175,
		-1,
		-1,
		149,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		95,
		91,
		-1,
		-1,
		59,
		53,
		42,
		37,
		30,
		0,
		14,
		16,
		28,
		43,
		41,
		-1,
		-1,
		170,
		162,
		156,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		97,
		60,
		81,
		60,
		29,
		27,
		18,
		4,
		11,
		21,
		29,
		41,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		94,
		-1,
		64,
		61,
		74,
		37,
		40,
		34,
		7,
		22,
		24,
		30,
		31,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		91,
		72,
		-1,
		84,
		71,
		57,
		43,
		24,
		11,
		18,
		32,
		28,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		79,
		64,
		55,
		55,
		47,
		43,
		31,
		31,
		23,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		74,
		67,
		57,
		54,
		50,
		41,
		47,
		24,
		60,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		98,
		48,
		36,
		31,
		32,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		47,
		36,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		239,
		228,
		239,
		247,
		220,
		227,
		-1,
		246,
		250,
		216,
		210,
		249,
		218,
		224,
		235,
		-1,
		-1,
		-1,
		239,
		238,
		206,
		204,
		213,
		218,
		225,
		-1,
		224,
		-1,
		260,
		239,
		250,
		255,
		199,
		196,
		216,
		235,
		217,
		209,
		275,
		229,
		200,
		194,
		212,
		202,
		211,
		203,
		-1,
		200,
		190,
		212,
		191,
		202,
		194,
		-1,
		-1,
		194,
		195,
		201,
		187,
		193,
		189,
		-1,
		199,
		183,
		-1,
		-1,
		184,
		185,
		169,
		172,
		180,
		178,
		191,
		183,
		178,
		-1,
		-1,
		175,
		171,
		178,
		165,
		161,
		178,
		191,
		173,
		187,
		186,
		-1,
		179,
		197,
		204,
		172,
		170,
		154,
		152,
		170,
		172,
		178,
		178,
		-1,
		188,
		189,
		184,
		192,
		194,
		170,
		157,
		157,
		167,
		160,
		179,
		167,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		188,
		171,
		188,
		180,
		170,
		185,
		178,
		160,
		157,
		155,
		152,
		168,
		166,
		176,
		-1,
		-1,
		281,
		250,
		279,
		237,
		218,
		-1,
		184,
		164,
		170,
		174,
		168,
		161,
		175,
		171,
		-1,
		146,
		145,
		173,
		159,
		170,
		241,
		-1,
		-1,
		239,
		231,
		214,
		217,
		194,
		190,
		179,
		178,
		170,
		156,
		152,
		158,
		161,
		161,
		167,
		140,
		150,
		154,
		152,
		177,
		-1,
		-1,
		212,
		-1,
		-1,
		238,
		221,
		-1,
		204,
		211,
		200,
		206,
		192,
		213,
		189,
		180,
		172,
		166,
		154,
		156,
		153,
		166,
		154,
		137,
		162,
		166,
		147,
		168,
		163,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		197,
		200,
		206,
		230,
		229,
		-1,
		201,
		189,
		190,
		175,
		172,
		159,
		147,
		160,
		145,
		152,
		151,
		141,
		139,
		169,
		144,
		166,
		163,
		182,
		187,
		181,
		190,
		-1,
		246,
		242,
		238,
		245,
		194,
		-1,
		-1,
		234,
		-1,
		237,
		238,
		213,
		186,
		189,
		176,
		167,
		154,
		143,
		154,
		143,
		140,
		148,
		133,
		148,
		139,
		138,
		156,
		166,
		174,
		178,
		184,
		-1,
		296,
		-1,
		238,
		222,
		224,
		196,
		217,
		-1,
		254,
		238,
		230,
		215,
		215,
		-1,
		185,
		182,
		172,
		150,
		135,
		152,
		144,
		142,
		146,
		128,
		142,
		133,
		151,
		158,
		156,
		160,
		180,
		192,
		256,
		246,
		-1,
		228,
		233,
		192,
		200,
		219,
		257,
		221,
		-1,
		216,
		-1,
		187,
		200,
		-1,
		156,
		152,
		134,
		135,
		130,
		145,
		139,
		124,
		121,
		139,
		142,
		149,
		153,
		169,
		-1,
		-1,
		241,
		245,
		234,
		185,
		204,
		228,
		265,
		214,
		203,
		202,
		-1,
		193,
		170,
		167,
		155,
		142,
		127,
		128,
		136,
		149,
		128,
		123,
		120,
		140,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		211,
		182,
		206,
		248,
		232,
		225,
		213,
		178,
		178,
		172,
		-1,
		166,
		145,
		136,
		125,
		123,
		136,
		133,
		138,
		118,
		116,
		135,
		147,
		138,
		155,
		-1,
		-1,
		-1,
		241,
		230,
		231,
		177,
		200,
		237,
		211,
		197,
		202,
		177,
		170,
		164,
		179,
		162,
		143,
		132,
		124,
		113,
		129,
		137,
		132,
		114,
		123,
		129,
		153,
		143,
		149,
		-1,
		-1,
		248,
		238,
		222,
		224,
		221,
		191,
		198,
		230,
		202,
		215,
		-1,
		169,
		-1,
		158,
		153,
		137,
		132,
		129,
		126,
		120,
		129,
		131,
		121,
		116,
		123,
		158,
		158,
		133,
		153,
		156,
		-1,
		-1,
		-1,
		241,
		236,
		211,
		188,
		172,
		208,
		-1,
		185,
		186,
		-1,
		163,
		157,
		154,
		139,
		135,
		130,
		134,
		127,
		134,
		127,
		125,
		126,
		108,
		140,
		-1,
		141,
		135,
		143,
		133,
		121,
		-1,
		-1,
		-1,
		234,
		213,
		206,
		226,
		167,
		219,
		-1,
		-1,
		170,
		163,
		-1,
		150,
		132,
		139,
		137,
		131,
		135,
		132,
		121,
		134,
		127,
		113,
		115,
		128,
		132,
		136,
		123,
		119,
		116,
		130,
		-1,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		187,
		-1,
		179,
		171,
		161,
		155,
		149,
		145,
		143,
		159,
		143,
		146,
		144,
		135,
		143,
		116,
		109,
		116,
		105,
		123,
		131,
		123,
		117,
		116,
		126,
		-1,
		254,
		240,
		211,
		-1,
		-1,
		200,
		-1,
		164,
		178,
		194,
		-1,
		187,
		166,
		181,
		159,
		155,
		151,
		166,
		167,
		145,
		144,
		142,
		133,
		121,
		110,
		113,
		105,
		127,
		127,
		111,
		112,
		116,
		-1,
		260,
		247,
		205,
		201,
		190,
		210,
		161,
		149,
		181,
		-1,
		-1,
		223,
		-1,
		157,
		174,
		165,
		163,
		156,
		147,
		153,
		153,
		130,
		125,
		115,
		104,
		104,
		99,
		121,
		107,
		105,
		114,
		130,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		176,
		163,
		157,
		-1,
		198,
		-1,
		201,
		191,
		175,
		160,
		193,
		-1,
		158,
		148,
		153,
		-1,
		150,
		-1,
		123,
		120,
		111,
		96,
		93,
		104,
		102,
		113,
		109,
		-1,
		210,
		195,
		188,
		178,
		192,
		163,
		-1,
		218,
		-1,
		-1,
		188,
		182,
		182,
		166,
		169,
		174,
		154,
		146,
		153,
		145,
		137,
		131,
		109,
		102,
		99,
		92,
		105,
		115,
		120,
		107,
		-1,
		-1,
		-1,
		215,
		201,
		205,
		165,
		184,
		-1,
		-1,
		250,
		205,
		191,
		-1,
		175,
		174,
		162,
		152,
		142,
		147,
		148,
		128,
		121,
		107,
		109,
		103,
		94,
		93,
		109,
		101,
		123,
		-1,
		-1,
		198,
		203,
		191,
		177,
		196,
		-1,
		-1,
		-1,
		197,
		213,
		202,
		176,
		163,
		-1,
		-1,
		146,
		139,
		133,
		124,
		111,
		123,
		118,
		102,
		87,
		102,
		106,
		114,
		105,
		-1,
		201,
		188,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		-1,
		-1,
		214,
		159,
		148,
		143,
		147,
		145,
		-1,
		119,
		130,
		115,
		127,
		134,
		104,
		89,
		83,
		89,
		101,
		110,
		-1,
		-1,
		213,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		171,
		165,
		136,
		129,
		133,
		-1,
		121,
		123,
		117,
		132,
		107,
		104,
		95,
		86,
		82,
		86,
		90,
		104,
		108,
		236,
		-1,
		199,
		-1,
		-1,
		-1,
		189,
		204,
		175,
		152,
		125,
		120,
		113,
		107,
		112,
		123,
		115,
		126,
		93,
		89,
		79,
		78,
		82,
		99,
		99,
		-1,
		-1,
		197,
		193,
		215,
		197,
		201,
		202,
		-1,
		-1,
		129,
		120,
		111,
		103,
		116,
		119,
		99,
		96,
		90,
		83,
		77,
		87,
		98,
		93,
		-1,
		-1,
		-1,
		209,
		-1,
		211,
		-1,
		-1,
		199,
		200,
		147,
		129,
		125,
		123,
		112,
		106,
		94,
		99,
		100,
		91,
		85,
		73,
		73,
		96,
		85,
		102,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		188,
		180,
		175,
		181,
		183,
		174,
		162,
		159,
		-1,
		129,
		135,
		100,
		107,
		90,
		97,
		95,
		87,
		67,
		70,
		86,
		85,
		80,
		94,
		85,
		89,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		181,
		177,
		167,
		157,
		160,
		-1,
		-1,
		154,
		151,
		131,
		100,
		98,
		91,
		86,
		96,
		76,
		63,
		63,
		58,
		73,
		78,
		80,
		73,
		80,
		95,
		-1,
		228,
		265,
		258,
		226,
		234,
		265,
		-1,
		171,
		163,
		174,
		149,
		151,
		-1,
		-1,
		127,
		118,
		119,
		107,
		104,
		106,
		101,
		86,
		72,
		78,
		56,
		63,
		74,
		66,
		70,
		71,
		78,
		89,
		93,
		-1,
		221,
		241,
		220,
		223,
		247,
		261,
		-1,
		168,
		-1,
		-1,
		180,
		152,
		136,
		126,
		123,
		166,
		116,
		111,
		88,
		86,
		83,
		74,
		80,
		64,
		52,
		49,
		58,
		63,
		55,
		81,
		83,
		79,
		-1,
		210,
		221,
		214,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		177,
		-1,
		163,
		-1,
		146,
		150,
		124,
		127,
		102,
		89,
		75,
		75,
		81,
		64,
		60,
		56,
		45,
		49,
		61,
		65,
		75,
		89,
		235,
		191,
		194,
		205,
		216,
		231,
		235,
		-1,
		180,
		219,
		183,
		-1,
		167,
		-1,
		-1,
		-1,
		160,
		137,
		129,
		122,
		101,
		101,
		67,
		63,
		69,
		65,
		70,
		62,
		46,
		48,
		59,
		70,
		85,
		231,
		222,
		235,
		180,
		180,
		201,
		210,
		231,
		195,
		186,
		213,
		190,
		179,
		174,
		161,
		-1,
		-1,
		144,
		147,
		-1,
		-1,
		108,
		84,
		71,
		65,
		69,
		79,
		70,
		58,
		38,
		47,
		41,
		73,
		-1,
		224,
		223,
		212,
		209,
		185,
		176,
		171,
		198,
		-1,
		-1,
		193,
		214,
		204,
		208,
		221,
		246,
		-1,
		150,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		89,
		78,
		69,
		55,
		77,
		74,
		85,
		34,
		48,
		46,
		53,
		64,
		208,
		205,
		193,
		191,
		214,
		179,
		167,
		-1,
		180,
		178,
		184,
		191,
		208,
		235,
		-1,
		-1,
		166,
		146,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		66,
		52,
		79,
		54,
		35,
		37,
		31,
		35,
		40,
		53,
		57,
		217,
		231,
		220,
		216,
		215,
		223,
		172,
		165,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		156,
		152,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		66,
		52,
		48,
		41,
		34,
		29,
		26,
		30,
		34,
		51,
		-1,
		251,
		-1,
		203,
		179,
		193,
		208,
		216,
		-1,
		-1,
		-1,
		173,
		159,
		152,
		140,
		138,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		84,
		52,
		40,
		42,
		11,
		4,
		26,
		36,
		48,
		45,
		-1,
		-1,
		191,
		189,
		-1,
		-1,
		163,
		165,
		-1,
		164,
		153,
		138,
		130,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		66,
		55,
		46,
		45,
		15,
		0,
		14,
		24,
		39,
		45,
		-1,
		-1,
		184,
		176,
		170,
		-1,
		148,
		-1,
		166,
		-1,
		133,
		139,
		127,
		-1,
		-1,
		-1,
		110,
		73,
		94,
		73,
		38,
		36,
		25,
		18,
		18,
		17,
		25,
		45,
		-1,
		-1,
		-1,
		166,
		140,
		173,
		164,
		147,
		127,
		119,
		138,
		-1,
		108,
		-1,
		77,
		74,
		87,
		46,
		49,
		43,
		21,
		34,
		29,
		26,
		35,
		172,
		-1,
		142,
		175,
		139,
		133,
		109,
		113,
		129,
		-1,
		105,
		85,
		-1,
		98,
		85,
		66,
		52,
		38,
		25,
		32,
		39,
		32,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		114,
		105,
		-1,
		117,
		99,
		78,
		93,
		78,
		69,
		69,
		56,
		52,
		45,
		45,
		37,
		-1,
		245,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		133,
		106,
		94,
		100,
		96,
		82,
		88,
		88,
		81,
		71,
		68,
		64,
		55,
		61,
		38,
		74,
		-1,
		240,
		-1,
		174,
		-1,
		-1,
		156,
		136,
		128,
		117,
		106,
		104,
		95,
		86,
		108,
		112,
		62,
		50,
		45,
		46,
		-1,
		229,
		228,
		-1,
		175,
		167,
		153,
		-1,
		146,
		-1,
		152,
		113,
		-1,
		115,
		95,
		-1,
		61,
		50,
		-1,
		-1,
		216,
		191,
		-1,
		-1,
		-1,
		176,
		156,
		147,
		131,
		-1,
		106,
		106,
		-1,
		-1,
		-1,
		201,
		200,
		-1,
		169,
		172,
		-1,
		162,
		153,
		161,
		108,
		112,
		-1,
		-1,
		-1,
		210,
		191,
		185,
		184,
		182,
		177,
		174,
		160,
		144,
		122,
		111,
		132,
		-1,
		-1,
		-1,
		182,
		174,
		167,
		-1,
		-1,
		169,
		152,
		133,
		131,
		-1,
		-1,
		-1,
		204,
		185,
		-1,
		-1,
		159,
		-1,
		-1,
		165,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		193,
		-1,
		-1,
		-1,
		155,
		151,
		152,
		-1,
		-1,
		-1,
		-1,
		215,
		216,
		239,
		203,
		-1,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		218,
		216,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		145,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		180,
		-1,
		180,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		193,
		-1,
		165,
		167,
		-1,
		215,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		170,
		177,
		199,
		202,
		238,
		-1,
		189
	],
	[
		-1,
		234,
		223,
		234,
		242,
		215,
		222,
		-1,
		241,
		245,
		211,
		205,
		244,
		213,
		219,
		230,
		-1,
		-1,
		-1,
		234,
		233,
		201,
		199,
		208,
		213,
		220,
		-1,
		219,
		-1,
		255,
		234,
		245,
		250,
		194,
		191,
		211,
		230,
		212,
		204,
		270,
		224,
		195,
		189,
		207,
		197,
		206,
		198,
		-1,
		195,
		185,
		207,
		186,
		197,
		189,
		-1,
		-1,
		189,
		190,
		196,
		182,
		188,
		184,
		-1,
		194,
		178,
		-1,
		-1,
		179,
		180,
		164,
		167,
		175,
		173,
		186,
		178,
		173,
		-1,
		-1,
		170,
		166,
		173,
		160,
		156,
		173,
		186,
		168,
		182,
		181,
		-1,
		174,
		192,
		199,
		167,
		165,
		149,
		147,
		165,
		167,
		173,
		173,
		-1,
		183,
		184,
		179,
		187,
		189,
		165,
		152,
		152,
		162,
		155,
		174,
		162,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		183,
		166,
		183,
		175,
		165,
		180,
		173,
		155,
		152,
		150,
		147,
		163,
		161,
		171,
		-1,
		-1,
		276,
		245,
		274,
		232,
		213,
		-1,
		179,
		159,
		165,
		169,
		163,
		156,
		170,
		166,
		-1,
		141,
		140,
		168,
		154,
		165,
		236,
		-1,
		-1,
		234,
		226,
		209,
		212,
		189,
		185,
		174,
		173,
		165,
		151,
		147,
		153,
		156,
		156,
		162,
		135,
		145,
		149,
		147,
		172,
		-1,
		-1,
		207,
		-1,
		-1,
		233,
		216,
		-1,
		199,
		206,
		195,
		201,
		187,
		208,
		184,
		175,
		167,
		161,
		149,
		151,
		148,
		161,
		149,
		132,
		157,
		161,
		142,
		163,
		158,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		192,
		195,
		201,
		225,
		224,
		-1,
		196,
		184,
		185,
		170,
		167,
		154,
		142,
		155,
		140,
		147,
		146,
		136,
		134,
		164,
		139,
		161,
		158,
		177,
		182,
		176,
		185,
		-1,
		241,
		237,
		233,
		240,
		189,
		-1,
		-1,
		229,
		-1,
		232,
		233,
		208,
		181,
		184,
		171,
		162,
		149,
		138,
		149,
		138,
		135,
		143,
		128,
		143,
		134,
		133,
		151,
		161,
		169,
		173,
		179,
		-1,
		291,
		-1,
		233,
		217,
		219,
		191,
		212,
		-1,
		249,
		233,
		225,
		210,
		210,
		-1,
		180,
		177,
		167,
		145,
		130,
		147,
		139,
		137,
		141,
		123,
		137,
		128,
		146,
		153,
		151,
		155,
		175,
		187,
		251,
		241,
		-1,
		223,
		228,
		187,
		195,
		214,
		252,
		216,
		-1,
		211,
		-1,
		182,
		195,
		-1,
		151,
		147,
		129,
		130,
		125,
		140,
		134,
		119,
		116,
		134,
		137,
		144,
		148,
		164,
		-1,
		-1,
		236,
		240,
		229,
		180,
		199,
		223,
		260,
		209,
		198,
		197,
		-1,
		188,
		165,
		162,
		150,
		137,
		122,
		123,
		131,
		144,
		123,
		118,
		115,
		135,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		206,
		177,
		201,
		243,
		227,
		220,
		208,
		173,
		173,
		167,
		-1,
		161,
		140,
		131,
		120,
		118,
		131,
		128,
		133,
		113,
		111,
		130,
		142,
		133,
		150,
		-1,
		-1,
		-1,
		236,
		225,
		226,
		172,
		195,
		232,
		206,
		192,
		197,
		172,
		165,
		159,
		174,
		157,
		138,
		127,
		119,
		108,
		124,
		132,
		127,
		109,
		118,
		124,
		148,
		138,
		144,
		-1,
		-1,
		243,
		233,
		217,
		219,
		216,
		186,
		193,
		225,
		197,
		210,
		-1,
		164,
		-1,
		153,
		148,
		132,
		127,
		124,
		121,
		115,
		124,
		126,
		116,
		111,
		118,
		153,
		153,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		236,
		231,
		206,
		183,
		167,
		203,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		134,
		130,
		125,
		129,
		122,
		129,
		122,
		120,
		121,
		103,
		135,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		229,
		208,
		201,
		221,
		162,
		214,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		134,
		132,
		126,
		130,
		127,
		116,
		129,
		122,
		108,
		110,
		123,
		127,
		131,
		118,
		114,
		111,
		125,
		-1,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		182,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		154,
		138,
		141,
		139,
		130,
		138,
		111,
		104,
		111,
		100,
		118,
		126,
		118,
		112,
		111,
		121,
		-1,
		249,
		235,
		206,
		-1,
		-1,
		195,
		-1,
		159,
		173,
		189,
		-1,
		182,
		161,
		176,
		154,
		150,
		146,
		161,
		162,
		140,
		139,
		137,
		128,
		116,
		105,
		108,
		100,
		122,
		122,
		106,
		107,
		111,
		-1,
		255,
		242,
		200,
		196,
		185,
		205,
		156,
		144,
		176,
		-1,
		-1,
		218,
		-1,
		152,
		169,
		160,
		158,
		151,
		142,
		148,
		148,
		125,
		120,
		110,
		99,
		99,
		94,
		116,
		102,
		100,
		109,
		125,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		171,
		158,
		152,
		-1,
		193,
		-1,
		196,
		186,
		170,
		155,
		188,
		-1,
		153,
		143,
		148,
		-1,
		145,
		-1,
		118,
		115,
		106,
		91,
		88,
		99,
		97,
		108,
		104,
		-1,
		205,
		190,
		183,
		173,
		187,
		158,
		-1,
		213,
		-1,
		-1,
		183,
		177,
		177,
		161,
		164,
		169,
		149,
		141,
		148,
		140,
		132,
		126,
		104,
		97,
		94,
		87,
		100,
		110,
		115,
		102,
		-1,
		-1,
		-1,
		210,
		196,
		200,
		160,
		179,
		-1,
		-1,
		245,
		200,
		186,
		-1,
		170,
		169,
		157,
		147,
		137,
		142,
		143,
		123,
		116,
		102,
		104,
		98,
		89,
		88,
		104,
		96,
		118,
		-1,
		-1,
		193,
		198,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		192,
		208,
		197,
		171,
		158,
		-1,
		-1,
		141,
		134,
		128,
		119,
		106,
		118,
		113,
		97,
		82,
		97,
		101,
		109,
		100,
		-1,
		196,
		183,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		110,
		122,
		129,
		99,
		84,
		78,
		84,
		96,
		105,
		-1,
		-1,
		208,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		112,
		127,
		102,
		99,
		90,
		81,
		77,
		81,
		85,
		99,
		103,
		231,
		-1,
		194,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		110,
		121,
		88,
		84,
		74,
		73,
		77,
		94,
		94,
		-1,
		-1,
		192,
		188,
		210,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		94,
		91,
		85,
		78,
		72,
		82,
		93,
		88,
		-1,
		-1,
		-1,
		204,
		-1,
		206,
		-1,
		-1,
		194,
		195,
		142,
		124,
		120,
		118,
		107,
		101,
		89,
		94,
		95,
		86,
		80,
		68,
		68,
		91,
		80,
		97,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		183,
		175,
		170,
		176,
		178,
		169,
		157,
		154,
		-1,
		124,
		130,
		95,
		102,
		85,
		92,
		90,
		82,
		62,
		65,
		81,
		80,
		75,
		89,
		80,
		84,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		176,
		172,
		162,
		152,
		155,
		-1,
		-1,
		149,
		146,
		126,
		95,
		93,
		86,
		81,
		91,
		71,
		58,
		58,
		53,
		68,
		73,
		75,
		68,
		75,
		90,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		166,
		158,
		169,
		144,
		146,
		-1,
		-1,
		122,
		113,
		114,
		102,
		99,
		101,
		96,
		83,
		67,
		73,
		51,
		58,
		69,
		61,
		65,
		66,
		70,
		83,
		87,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		163,
		-1,
		-1,
		175,
		147,
		131,
		121,
		118,
		161,
		113,
		108,
		85,
		83,
		80,
		71,
		75,
		59,
		47,
		44,
		53,
		58,
		50,
		71,
		76,
		69,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		173,
		-1,
		158,
		-1,
		141,
		145,
		121,
		124,
		99,
		86,
		72,
		72,
		78,
		59,
		55,
		51,
		40,
		37,
		49,
		53,
		63,
		81,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		175,
		214,
		179,
		-1,
		163,
		-1,
		-1,
		-1,
		155,
		134,
		126,
		119,
		98,
		98,
		64,
		60,
		64,
		60,
		67,
		57,
		45,
		36,
		47,
		58,
		73,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		181,
		208,
		186,
		175,
		170,
		157,
		-1,
		-1,
		141,
		144,
		-1,
		-1,
		105,
		81,
		68,
		62,
		66,
		74,
		69,
		57,
		37,
		35,
		29,
		61,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		209,
		199,
		203,
		217,
		242,
		-1,
		146,
		-1,
		-1,
		121,
		-1,
		-1,
		106,
		86,
		75,
		66,
		52,
		74,
		73,
		84,
		33,
		41,
		34,
		41,
		52,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		203,
		231,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		104,
		102,
		91,
		-1,
		81,
		63,
		49,
		76,
		53,
		42,
		36,
		30,
		32,
		28,
		41,
		45,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		99,
		92,
		80,
		68,
		58,
		63,
		49,
		45,
		40,
		33,
		28,
		37,
		18,
		22,
		39,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		133,
		117,
		98,
		-1,
		68,
		81,
		81,
		49,
		41,
		39,
		22,
		15,
		14,
		24,
		38,
		33,
		-1,
		-1,
		186,
		185,
		-1,
		-1,
		159,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		105,
		101,
		-1,
		-1,
		69,
		63,
		52,
		47,
		43,
		18,
		13,
		0,
		12,
		27,
		35,
		-1,
		-1,
		180,
		172,
		166,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		107,
		70,
		91,
		70,
		39,
		37,
		28,
		14,
		4,
		7,
		15,
		35,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		74,
		71,
		84,
		47,
		50,
		44,
		17,
		32,
		19,
		16,
		25,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		82,
		-1,
		94,
		81,
		67,
		53,
		34,
		21,
		28,
		29,
		22,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		89,
		74,
		65,
		65,
		57,
		53,
		41,
		41,
		33,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		84,
		77,
		67,
		64,
		60,
		51,
		57,
		34,
		70,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		108,
		58,
		46,
		41,
		42,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		57,
		46,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		222,
		211,
		222,
		230,
		203,
		210,
		-1,
		229,
		233,
		199,
		193,
		232,
		201,
		207,
		218,
		-1,
		-1,
		-1,
		222,
		221,
		189,
		187,
		196,
		201,
		208,
		-1,
		207,
		-1,
		243,
		222,
		233,
		238,
		182,
		179,
		199,
		218,
		200,
		192,
		258,
		212,
		183,
		177,
		195,
		185,
		194,
		186,
		-1,
		183,
		173,
		195,
		174,
		185,
		177,
		-1,
		-1,
		177,
		178,
		184,
		170,
		176,
		172,
		-1,
		182,
		166,
		-1,
		-1,
		167,
		168,
		152,
		155,
		163,
		161,
		174,
		166,
		161,
		-1,
		-1,
		158,
		154,
		161,
		148,
		144,
		161,
		174,
		156,
		170,
		169,
		-1,
		162,
		180,
		187,
		155,
		153,
		137,
		135,
		153,
		155,
		161,
		161,
		-1,
		171,
		172,
		167,
		175,
		177,
		153,
		140,
		140,
		150,
		143,
		162,
		150,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		171,
		154,
		171,
		163,
		153,
		168,
		161,
		143,
		140,
		138,
		135,
		151,
		149,
		159,
		-1,
		-1,
		264,
		233,
		262,
		220,
		201,
		-1,
		167,
		147,
		153,
		157,
		151,
		144,
		158,
		154,
		-1,
		129,
		128,
		156,
		142,
		153,
		224,
		-1,
		-1,
		222,
		214,
		197,
		200,
		177,
		173,
		162,
		161,
		153,
		139,
		135,
		141,
		144,
		144,
		150,
		123,
		133,
		137,
		135,
		160,
		-1,
		-1,
		195,
		-1,
		-1,
		221,
		204,
		-1,
		187,
		194,
		183,
		189,
		175,
		196,
		172,
		163,
		155,
		149,
		137,
		139,
		136,
		149,
		137,
		120,
		145,
		149,
		130,
		151,
		146,
		-1,
		194,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		180,
		183,
		189,
		213,
		212,
		-1,
		184,
		172,
		173,
		158,
		155,
		142,
		130,
		143,
		128,
		135,
		134,
		124,
		122,
		152,
		127,
		149,
		146,
		165,
		170,
		164,
		173,
		-1,
		229,
		225,
		221,
		228,
		177,
		-1,
		-1,
		217,
		-1,
		220,
		221,
		196,
		169,
		172,
		159,
		150,
		137,
		126,
		137,
		126,
		123,
		131,
		116,
		131,
		122,
		121,
		139,
		149,
		157,
		161,
		167,
		-1,
		279,
		-1,
		221,
		205,
		207,
		179,
		200,
		-1,
		237,
		221,
		213,
		198,
		198,
		-1,
		168,
		165,
		155,
		133,
		118,
		135,
		127,
		125,
		129,
		111,
		125,
		116,
		134,
		141,
		139,
		143,
		163,
		175,
		239,
		229,
		-1,
		211,
		216,
		175,
		183,
		202,
		240,
		204,
		-1,
		199,
		-1,
		170,
		183,
		-1,
		139,
		135,
		117,
		118,
		113,
		128,
		122,
		107,
		104,
		122,
		125,
		132,
		136,
		152,
		-1,
		-1,
		224,
		228,
		217,
		168,
		187,
		211,
		248,
		197,
		186,
		185,
		-1,
		176,
		153,
		150,
		138,
		125,
		110,
		111,
		119,
		132,
		111,
		106,
		103,
		123,
		149,
		127,
		139,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		194,
		165,
		189,
		231,
		215,
		208,
		196,
		161,
		161,
		155,
		-1,
		149,
		128,
		119,
		108,
		106,
		119,
		116,
		121,
		101,
		99,
		118,
		130,
		121,
		138,
		-1,
		-1,
		-1,
		224,
		213,
		214,
		160,
		183,
		220,
		194,
		180,
		185,
		160,
		153,
		147,
		162,
		145,
		126,
		115,
		107,
		96,
		112,
		120,
		115,
		97,
		106,
		112,
		136,
		126,
		132,
		-1,
		-1,
		231,
		221,
		205,
		207,
		204,
		174,
		181,
		213,
		185,
		198,
		-1,
		152,
		-1,
		141,
		136,
		120,
		115,
		112,
		109,
		103,
		112,
		114,
		104,
		99,
		106,
		141,
		141,
		116,
		136,
		139,
		-1,
		-1,
		-1,
		224,
		219,
		194,
		171,
		155,
		191,
		-1,
		168,
		169,
		-1,
		146,
		140,
		137,
		122,
		118,
		113,
		117,
		110,
		117,
		110,
		108,
		109,
		91,
		123,
		-1,
		124,
		118,
		126,
		116,
		104,
		-1,
		-1,
		-1,
		217,
		196,
		189,
		209,
		150,
		202,
		-1,
		-1,
		153,
		146,
		-1,
		133,
		115,
		122,
		120,
		114,
		118,
		115,
		104,
		117,
		110,
		96,
		98,
		111,
		115,
		119,
		106,
		102,
		99,
		113,
		-1,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		170,
		-1,
		162,
		154,
		144,
		138,
		132,
		128,
		126,
		142,
		126,
		129,
		127,
		118,
		126,
		99,
		92,
		99,
		88,
		106,
		114,
		106,
		100,
		99,
		109,
		-1,
		237,
		223,
		194,
		-1,
		-1,
		183,
		-1,
		147,
		161,
		177,
		-1,
		170,
		149,
		164,
		142,
		138,
		134,
		149,
		150,
		128,
		127,
		125,
		116,
		104,
		93,
		96,
		88,
		110,
		110,
		94,
		95,
		99,
		-1,
		243,
		230,
		188,
		184,
		173,
		193,
		144,
		132,
		164,
		-1,
		-1,
		206,
		-1,
		140,
		157,
		148,
		146,
		139,
		130,
		136,
		136,
		113,
		108,
		98,
		87,
		87,
		82,
		104,
		90,
		88,
		97,
		113,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		159,
		146,
		140,
		-1,
		181,
		-1,
		184,
		174,
		158,
		143,
		176,
		-1,
		141,
		131,
		136,
		-1,
		133,
		-1,
		106,
		103,
		94,
		79,
		76,
		87,
		85,
		96,
		92,
		-1,
		193,
		178,
		171,
		161,
		175,
		146,
		-1,
		201,
		-1,
		-1,
		171,
		165,
		165,
		149,
		152,
		157,
		137,
		129,
		136,
		128,
		120,
		114,
		92,
		85,
		82,
		75,
		88,
		98,
		103,
		90,
		-1,
		-1,
		-1,
		198,
		184,
		188,
		148,
		167,
		-1,
		-1,
		233,
		188,
		174,
		-1,
		158,
		157,
		145,
		135,
		125,
		130,
		131,
		111,
		104,
		90,
		92,
		86,
		77,
		76,
		92,
		84,
		106,
		-1,
		-1,
		181,
		186,
		174,
		160,
		179,
		-1,
		-1,
		-1,
		180,
		196,
		185,
		159,
		146,
		-1,
		-1,
		129,
		122,
		116,
		107,
		94,
		106,
		101,
		85,
		70,
		85,
		89,
		97,
		88,
		-1,
		184,
		171,
		-1,
		-1,
		182,
		176,
		-1,
		-1,
		-1,
		-1,
		197,
		142,
		131,
		126,
		130,
		128,
		-1,
		102,
		113,
		98,
		110,
		117,
		87,
		72,
		66,
		72,
		84,
		93,
		-1,
		-1,
		196,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		154,
		148,
		119,
		112,
		116,
		-1,
		104,
		106,
		100,
		115,
		90,
		87,
		78,
		69,
		65,
		69,
		73,
		87,
		91,
		219,
		-1,
		182,
		-1,
		-1,
		-1,
		172,
		187,
		158,
		135,
		108,
		103,
		96,
		90,
		95,
		106,
		98,
		109,
		76,
		72,
		62,
		61,
		65,
		82,
		82,
		-1,
		-1,
		180,
		176,
		198,
		180,
		184,
		185,
		-1,
		-1,
		112,
		103,
		94,
		86,
		99,
		102,
		82,
		79,
		73,
		66,
		60,
		70,
		81,
		76,
		-1,
		-1,
		-1,
		192,
		-1,
		194,
		-1,
		-1,
		182,
		183,
		130,
		112,
		108,
		106,
		95,
		89,
		77,
		82,
		83,
		74,
		68,
		56,
		56,
		79,
		68,
		85,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		145,
		142,
		-1,
		112,
		118,
		83,
		90,
		73,
		80,
		78,
		70,
		50,
		53,
		69,
		68,
		63,
		77,
		68,
		72,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		137,
		134,
		114,
		83,
		81,
		74,
		69,
		79,
		59,
		46,
		46,
		41,
		56,
		61,
		63,
		56,
		63,
		78,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		110,
		101,
		102,
		90,
		87,
		89,
		84,
		75,
		55,
		61,
		39,
		46,
		57,
		49,
		53,
		54,
		60,
		72,
		76,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		151,
		-1,
		-1,
		163,
		135,
		119,
		109,
		106,
		149,
		104,
		99,
		83,
		81,
		72,
		63,
		63,
		47,
		35,
		32,
		41,
		46,
		38,
		59,
		66,
		59,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		166,
		-1,
		146,
		-1,
		129,
		133,
		112,
		115,
		97,
		84,
		76,
		63,
		72,
		47,
		43,
		39,
		28,
		25,
		37,
		41,
		51,
		69,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		163,
		202,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		143,
		125,
		117,
		117,
		96,
		96,
		70,
		66,
		52,
		48,
		55,
		45,
		35,
		24,
		35,
		46,
		61,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		169,
		196,
		179,
		168,
		163,
		150,
		-1,
		-1,
		151,
		135,
		-1,
		-1,
		103,
		91,
		74,
		63,
		59,
		62,
		70,
		54,
		34,
		23,
		17,
		49,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		197,
		187,
		191,
		207,
		232,
		-1,
		139,
		-1,
		-1,
		131,
		-1,
		-1,
		116,
		96,
		85,
		76,
		62,
		67,
		74,
		85,
		37,
		29,
		22,
		29,
		40,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		191,
		221,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		114,
		112,
		101,
		-1,
		91,
		73,
		59,
		86,
		57,
		46,
		40,
		34,
		20,
		16,
		29,
		33,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		109,
		102,
		90,
		78,
		68,
		73,
		59,
		55,
		44,
		37,
		32,
		34,
		6,
		10,
		27,
		-1,
		234,
		-1,
		186,
		162,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		143,
		127,
		108,
		-1,
		78,
		91,
		91,
		59,
		51,
		49,
		31,
		24,
		2,
		12,
		26,
		21,
		-1,
		-1,
		174,
		177,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		115,
		111,
		-1,
		-1,
		79,
		73,
		62,
		57,
		53,
		28,
		22,
		11,
		0,
		15,
		25,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		116,
		79,
		95,
		80,
		49,
		47,
		38,
		24,
		15,
		11,
		8,
		25,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		97,
		-1,
		72,
		75,
		80,
		57,
		60,
		54,
		27,
		42,
		15,
		6,
		15,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		94,
		76,
		-1,
		87,
		74,
		77,
		63,
		44,
		31,
		34,
		19,
		12,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		82,
		67,
		58,
		58,
		67,
		63,
		51,
		49,
		28,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		77,
		70,
		60,
		57,
		53,
		44,
		50,
		27,
		60,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		101,
		51,
		39,
		34,
		35,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		50,
		39,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		234,
		223,
		234,
		242,
		215,
		222,
		-1,
		241,
		245,
		211,
		205,
		244,
		213,
		219,
		230,
		-1,
		-1,
		-1,
		234,
		233,
		201,
		199,
		208,
		213,
		220,
		-1,
		219,
		-1,
		255,
		234,
		245,
		250,
		194,
		191,
		211,
		230,
		212,
		204,
		270,
		224,
		195,
		189,
		207,
		197,
		206,
		198,
		-1,
		195,
		185,
		207,
		186,
		197,
		189,
		-1,
		-1,
		189,
		190,
		196,
		182,
		188,
		184,
		-1,
		194,
		178,
		-1,
		-1,
		179,
		180,
		164,
		167,
		175,
		173,
		186,
		178,
		173,
		-1,
		-1,
		170,
		166,
		173,
		160,
		156,
		173,
		186,
		168,
		182,
		181,
		-1,
		174,
		192,
		199,
		167,
		165,
		149,
		147,
		165,
		167,
		173,
		173,
		-1,
		183,
		184,
		179,
		187,
		189,
		165,
		152,
		152,
		162,
		155,
		174,
		162,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		183,
		166,
		183,
		175,
		165,
		180,
		173,
		155,
		152,
		150,
		147,
		163,
		161,
		171,
		-1,
		-1,
		276,
		245,
		274,
		232,
		213,
		-1,
		179,
		159,
		165,
		169,
		163,
		156,
		170,
		166,
		-1,
		141,
		140,
		168,
		154,
		165,
		236,
		-1,
		-1,
		234,
		226,
		209,
		212,
		189,
		185,
		174,
		173,
		165,
		151,
		147,
		153,
		156,
		156,
		162,
		135,
		145,
		149,
		147,
		172,
		-1,
		-1,
		207,
		-1,
		-1,
		233,
		216,
		-1,
		199,
		206,
		195,
		201,
		187,
		208,
		184,
		175,
		167,
		161,
		149,
		151,
		148,
		161,
		149,
		132,
		157,
		161,
		142,
		163,
		158,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		192,
		195,
		201,
		225,
		224,
		-1,
		196,
		184,
		185,
		170,
		167,
		154,
		142,
		155,
		140,
		147,
		146,
		136,
		134,
		164,
		139,
		161,
		158,
		177,
		182,
		176,
		185,
		-1,
		241,
		237,
		233,
		240,
		189,
		-1,
		-1,
		229,
		-1,
		232,
		233,
		208,
		181,
		184,
		171,
		162,
		149,
		138,
		149,
		138,
		135,
		143,
		128,
		143,
		134,
		133,
		151,
		161,
		169,
		173,
		179,
		-1,
		291,
		-1,
		233,
		217,
		219,
		191,
		212,
		-1,
		249,
		233,
		225,
		210,
		210,
		-1,
		180,
		177,
		167,
		145,
		130,
		147,
		139,
		137,
		141,
		123,
		137,
		128,
		146,
		153,
		151,
		155,
		175,
		187,
		251,
		241,
		-1,
		223,
		228,
		187,
		195,
		214,
		252,
		216,
		-1,
		211,
		-1,
		182,
		195,
		-1,
		151,
		147,
		129,
		130,
		125,
		140,
		134,
		119,
		116,
		134,
		137,
		144,
		148,
		164,
		-1,
		-1,
		236,
		240,
		229,
		180,
		199,
		223,
		260,
		209,
		198,
		197,
		-1,
		188,
		165,
		162,
		150,
		137,
		122,
		123,
		131,
		144,
		123,
		118,
		115,
		135,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		206,
		177,
		201,
		243,
		227,
		220,
		208,
		173,
		173,
		167,
		-1,
		161,
		140,
		131,
		120,
		118,
		131,
		128,
		133,
		113,
		111,
		130,
		142,
		133,
		150,
		-1,
		-1,
		-1,
		236,
		225,
		226,
		172,
		195,
		232,
		206,
		192,
		197,
		172,
		165,
		159,
		174,
		157,
		138,
		127,
		119,
		108,
		124,
		132,
		127,
		109,
		118,
		124,
		148,
		138,
		144,
		-1,
		-1,
		243,
		233,
		217,
		219,
		216,
		186,
		193,
		225,
		197,
		210,
		-1,
		164,
		-1,
		153,
		148,
		132,
		127,
		124,
		121,
		115,
		124,
		126,
		116,
		111,
		118,
		153,
		153,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		236,
		231,
		206,
		183,
		167,
		203,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		134,
		130,
		125,
		129,
		122,
		129,
		122,
		120,
		121,
		103,
		135,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		229,
		208,
		201,
		221,
		162,
		214,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		134,
		132,
		126,
		130,
		127,
		116,
		129,
		122,
		108,
		110,
		123,
		127,
		131,
		118,
		114,
		111,
		125,
		-1,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		182,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		154,
		138,
		141,
		139,
		130,
		138,
		111,
		104,
		111,
		100,
		118,
		126,
		118,
		112,
		111,
		121,
		-1,
		249,
		235,
		206,
		-1,
		-1,
		195,
		-1,
		159,
		173,
		189,
		-1,
		182,
		161,
		176,
		154,
		150,
		146,
		161,
		162,
		140,
		139,
		137,
		128,
		116,
		105,
		108,
		100,
		122,
		122,
		106,
		107,
		111,
		-1,
		255,
		242,
		200,
		196,
		185,
		205,
		156,
		144,
		176,
		-1,
		-1,
		218,
		-1,
		152,
		169,
		160,
		158,
		151,
		142,
		148,
		148,
		125,
		120,
		110,
		99,
		99,
		94,
		116,
		102,
		100,
		109,
		112,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		171,
		158,
		152,
		-1,
		193,
		-1,
		196,
		186,
		170,
		155,
		188,
		-1,
		153,
		143,
		148,
		-1,
		145,
		-1,
		118,
		115,
		106,
		91,
		88,
		99,
		97,
		108,
		104,
		-1,
		205,
		190,
		183,
		173,
		187,
		158,
		-1,
		213,
		-1,
		-1,
		183,
		177,
		177,
		161,
		164,
		169,
		149,
		141,
		148,
		140,
		132,
		126,
		104,
		97,
		94,
		87,
		100,
		110,
		115,
		102,
		-1,
		-1,
		-1,
		210,
		196,
		200,
		160,
		179,
		-1,
		-1,
		245,
		200,
		186,
		-1,
		170,
		169,
		157,
		147,
		137,
		142,
		143,
		123,
		116,
		102,
		104,
		98,
		89,
		88,
		104,
		96,
		118,
		-1,
		-1,
		193,
		198,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		192,
		208,
		197,
		171,
		158,
		-1,
		-1,
		141,
		134,
		128,
		119,
		106,
		118,
		113,
		97,
		82,
		97,
		101,
		109,
		100,
		-1,
		196,
		183,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		110,
		122,
		129,
		99,
		84,
		78,
		84,
		96,
		99,
		-1,
		-1,
		208,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		112,
		127,
		102,
		99,
		90,
		81,
		77,
		81,
		85,
		84,
		90,
		231,
		-1,
		194,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		110,
		121,
		88,
		84,
		74,
		73,
		77,
		88,
		88,
		-1,
		-1,
		192,
		188,
		210,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		94,
		91,
		85,
		78,
		72,
		82,
		87,
		82,
		-1,
		-1,
		-1,
		204,
		-1,
		206,
		-1,
		-1,
		194,
		195,
		142,
		124,
		120,
		118,
		107,
		101,
		89,
		94,
		95,
		86,
		80,
		68,
		68,
		91,
		74,
		78,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		183,
		175,
		170,
		176,
		178,
		169,
		157,
		154,
		-1,
		124,
		130,
		95,
		102,
		85,
		92,
		90,
		82,
		62,
		65,
		81,
		77,
		65,
		70,
		61,
		69,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		176,
		172,
		162,
		152,
		155,
		-1,
		-1,
		149,
		146,
		126,
		95,
		93,
		86,
		81,
		91,
		71,
		58,
		58,
		53,
		68,
		67,
		62,
		55,
		60,
		75,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		166,
		158,
		169,
		144,
		146,
		-1,
		-1,
		122,
		113,
		114,
		102,
		99,
		101,
		96,
		87,
		67,
		73,
		51,
		58,
		69,
		61,
		65,
		58,
		47,
		60,
		64,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		163,
		-1,
		-1,
		175,
		147,
		131,
		121,
		118,
		161,
		116,
		111,
		95,
		93,
		84,
		75,
		75,
		59,
		47,
		44,
		53,
		58,
		50,
		57,
		53,
		46,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		179,
		-1,
		158,
		-1,
		141,
		145,
		124,
		127,
		109,
		96,
		88,
		75,
		84,
		59,
		55,
		51,
		40,
		37,
		49,
		47,
		55,
		62,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		175,
		214,
		185,
		-1,
		169,
		-1,
		-1,
		-1,
		155,
		137,
		129,
		129,
		108,
		108,
		82,
		78,
		64,
		60,
		67,
		57,
		47,
		36,
		47,
		45,
		54,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		181,
		208,
		192,
		181,
		176,
		163,
		-1,
		-1,
		166,
		147,
		-1,
		-1,
		115,
		103,
		86,
		75,
		71,
		74,
		82,
		66,
		46,
		35,
		29,
		40,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		209,
		199,
		203,
		219,
		244,
		-1,
		152,
		-1,
		-1,
		146,
		-1,
		-1,
		131,
		108,
		97,
		88,
		77,
		79,
		86,
		97,
		49,
		41,
		34,
		33,
		25,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		203,
		233,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		129,
		127,
		116,
		-1,
		106,
		88,
		74,
		101,
		69,
		58,
		52,
		46,
		32,
		28,
		24,
		18,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		124,
		117,
		105,
		93,
		83,
		88,
		74,
		70,
		56,
		49,
		44,
		46,
		18,
		22,
		12,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		158,
		142,
		123,
		-1,
		93,
		106,
		106,
		74,
		71,
		68,
		50,
		47,
		21,
		7,
		11,
		6,
		-1,
		-1,
		186,
		189,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		94,
		88,
		77,
		77,
		73,
		51,
		45,
		34,
		23,
		0,
		12,
		-1,
		-1,
		186,
		178,
		172,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		129,
		92,
		108,
		95,
		69,
		67,
		58,
		47,
		38,
		34,
		30,
		14,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		88,
		93,
		77,
		80,
		74,
		48,
		61,
		34,
		28,
		28,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		100,
		87,
		91,
		76,
		57,
		44,
		47,
		32,
		25,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		95,
		80,
		71,
		71,
		81,
		77,
		64,
		62,
		41,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		90,
		83,
		73,
		70,
		66,
		57,
		63,
		40,
		73,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		114,
		64,
		52,
		47,
		48,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		63,
		52,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		155,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		143,
		149,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		133,
		153,
		156,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		141,
		135,
		143,
		133,
		121,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		123,
		119,
		116,
		119,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		114,
		115,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		149,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		110,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		151,
		157,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		108,
		100,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		162,
		152,
		157,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		109,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		173,
		178,
		158,
		150,
		157,
		149,
		141,
		135,
		113,
		106,
		103,
		96,
		109,
		119,
		123,
		107,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		179,
		178,
		166,
		156,
		146,
		151,
		152,
		132,
		125,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		111,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		206,
		180,
		167,
		-1,
		-1,
		150,
		143,
		137,
		128,
		115,
		127,
		122,
		106,
		91,
		106,
		109,
		101,
		93,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		218,
		163,
		152,
		147,
		151,
		149,
		-1,
		123,
		134,
		119,
		131,
		138,
		108,
		93,
		87,
		93,
		104,
		87,
		-1,
		-1,
		217,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		175,
		169,
		140,
		133,
		137,
		-1,
		125,
		127,
		121,
		136,
		111,
		108,
		99,
		90,
		86,
		90,
		91,
		72,
		78,
		240,
		-1,
		203,
		-1,
		-1,
		-1,
		193,
		208,
		179,
		156,
		129,
		124,
		117,
		111,
		116,
		127,
		119,
		130,
		97,
		93,
		83,
		82,
		86,
		76,
		76,
		-1,
		-1,
		201,
		197,
		219,
		201,
		205,
		206,
		-1,
		-1,
		133,
		124,
		115,
		107,
		120,
		123,
		103,
		100,
		94,
		87,
		81,
		91,
		75,
		70,
		-1,
		-1,
		-1,
		213,
		-1,
		215,
		-1,
		-1,
		203,
		204,
		151,
		133,
		129,
		127,
		116,
		110,
		98,
		103,
		104,
		95,
		89,
		77,
		76,
		86,
		62,
		66,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		192,
		184,
		179,
		185,
		187,
		178,
		166,
		163,
		-1,
		133,
		139,
		104,
		111,
		94,
		101,
		99,
		91,
		71,
		73,
		79,
		65,
		53,
		58,
		49,
		57,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		185,
		181,
		171,
		161,
		164,
		-1,
		-1,
		158,
		155,
		135,
		104,
		102,
		95,
		90,
		100,
		80,
		67,
		66,
		62,
		56,
		55,
		50,
		43,
		48,
		63,
		-1,
		232,
		269,
		262,
		230,
		238,
		269,
		-1,
		175,
		167,
		178,
		153,
		155,
		-1,
		-1,
		131,
		122,
		123,
		111,
		108,
		110,
		105,
		96,
		76,
		82,
		60,
		67,
		78,
		70,
		63,
		46,
		35,
		48,
		52,
		-1,
		225,
		245,
		224,
		227,
		251,
		265,
		-1,
		172,
		-1,
		-1,
		177,
		156,
		140,
		130,
		127,
		170,
		125,
		120,
		103,
		101,
		93,
		84,
		84,
		68,
		56,
		53,
		62,
		58,
		48,
		45,
		41,
		34,
		-1,
		214,
		225,
		218,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		-1,
		167,
		-1,
		167,
		-1,
		150,
		154,
		133,
		136,
		117,
		104,
		90,
		84,
		93,
		68,
		64,
		60,
		49,
		46,
		58,
		45,
		52,
		50,
		239,
		195,
		198,
		209,
		220,
		235,
		239,
		-1,
		184,
		223,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		164,
		146,
		138,
		137,
		116,
		116,
		82,
		78,
		73,
		69,
		76,
		66,
		56,
		45,
		55,
		43,
		42,
		235,
		226,
		239,
		184,
		184,
		205,
		214,
		235,
		199,
		190,
		217,
		180,
		169,
		164,
		151,
		-1,
		-1,
		159,
		156,
		-1,
		-1,
		123,
		99,
		86,
		80,
		80,
		83,
		91,
		75,
		55,
		44,
		38,
		38,
		-1,
		228,
		227,
		216,
		213,
		189,
		180,
		175,
		202,
		-1,
		-1,
		197,
		218,
		208,
		212,
		211,
		236,
		-1,
		140,
		-1,
		-1,
		139,
		-1,
		-1,
		124,
		104,
		93,
		84,
		70,
		88,
		95,
		106,
		58,
		50,
		43,
		31,
		23,
		212,
		209,
		197,
		195,
		218,
		183,
		171,
		-1,
		184,
		182,
		188,
		195,
		212,
		225,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		122,
		120,
		109,
		-1,
		99,
		81,
		67,
		94,
		75,
		67,
		61,
		55,
		41,
		37,
		24,
		16,
		221,
		235,
		224,
		220,
		219,
		227,
		176,
		169,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		117,
		110,
		98,
		86,
		76,
		81,
		67,
		63,
		63,
		58,
		53,
		55,
		27,
		31,
		10,
		-1,
		255,
		-1,
		207,
		183,
		197,
		212,
		220,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		151,
		135,
		116,
		-1,
		86,
		99,
		99,
		67,
		59,
		57,
		47,
		46,
		27,
		16,
		3,
		6,
		-1,
		-1,
		195,
		179,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		123,
		119,
		-1,
		-1,
		86,
		81,
		70,
		65,
		61,
		43,
		44,
		35,
		25,
		9,
		0,
		-1,
		-1,
		174,
		166,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		117,
		80,
		96,
		88,
		57,
		55,
		46,
		39,
		39,
		27,
		20,
		10,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		73,
		76,
		81,
		65,
		68,
		62,
		36,
		49,
		22,
		18,
		16,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		77,
		-1,
		88,
		75,
		79,
		64,
		45,
		32,
		35,
		20,
		13,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		83,
		68,
		59,
		59,
		69,
		65,
		52,
		50,
		29,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		78,
		71,
		61,
		58,
		54,
		45,
		51,
		28,
		61,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		102,
		52,
		40,
		35,
		36,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		51,
		40,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		308,
		297,
		308,
		316,
		289,
		296,
		-1,
		315,
		319,
		285,
		279,
		318,
		287,
		293,
		304,
		-1,
		-1,
		-1,
		308,
		307,
		275,
		273,
		282,
		287,
		294,
		-1,
		293,
		-1,
		329,
		308,
		319,
		324,
		268,
		265,
		285,
		304,
		286,
		278,
		344,
		298,
		269,
		263,
		281,
		271,
		280,
		272,
		-1,
		269,
		259,
		281,
		260,
		271,
		263,
		-1,
		-1,
		263,
		264,
		270,
		256,
		262,
		258,
		-1,
		268,
		252,
		-1,
		-1,
		253,
		254,
		238,
		241,
		249,
		247,
		260,
		252,
		247,
		-1,
		-1,
		244,
		240,
		247,
		234,
		230,
		247,
		260,
		242,
		256,
		255,
		-1,
		250,
		268,
		273,
		241,
		239,
		223,
		221,
		239,
		241,
		247,
		247,
		-1,
		259,
		260,
		255,
		263,
		263,
		239,
		226,
		226,
		236,
		229,
		248,
		236,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		259,
		242,
		259,
		251,
		241,
		256,
		249,
		229,
		226,
		224,
		221,
		237,
		235,
		245,
		-1,
		-1,
		315,
		284,
		319,
		276,
		261,
		-1,
		255,
		235,
		241,
		245,
		239,
		232,
		246,
		242,
		-1,
		215,
		214,
		242,
		228,
		239,
		275,
		-1,
		-1,
		273,
		265,
		250,
		253,
		250,
		250,
		250,
		249,
		241,
		227,
		223,
		229,
		232,
		232,
		238,
		209,
		219,
		223,
		221,
		246,
		-1,
		-1,
		281,
		-1,
		-1,
		272,
		255,
		-1,
		238,
		245,
		245,
		262,
		252,
		273,
		260,
		251,
		243,
		237,
		225,
		227,
		224,
		237,
		225,
		206,
		231,
		235,
		216,
		237,
		232,
		-1,
		280,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		231,
		234,
		240,
		264,
		274,
		-1,
		272,
		260,
		261,
		246,
		243,
		230,
		218,
		231,
		216,
		223,
		222,
		210,
		208,
		238,
		213,
		235,
		232,
		251,
		256,
		250,
		259,
		-1,
		280,
		276,
		272,
		279,
		228,
		-1,
		-1,
		268,
		-1,
		282,
		295,
		284,
		257,
		260,
		247,
		238,
		225,
		214,
		225,
		214,
		211,
		219,
		202,
		217,
		208,
		207,
		225,
		235,
		243,
		247,
		253,
		-1,
		330,
		-1,
		272,
		256,
		258,
		230,
		251,
		-1,
		288,
		283,
		301,
		286,
		284,
		-1,
		256,
		253,
		243,
		221,
		206,
		223,
		215,
		213,
		215,
		197,
		211,
		202,
		220,
		227,
		225,
		229,
		249,
		261,
		290,
		280,
		-1,
		262,
		267,
		226,
		234,
		253,
		326,
		290,
		-1,
		285,
		-1,
		258,
		271,
		-1,
		227,
		223,
		205,
		206,
		201,
		216,
		208,
		193,
		190,
		208,
		211,
		218,
		222,
		238,
		-1,
		-1,
		275,
		279,
		268,
		219,
		238,
		262,
		299,
		283,
		272,
		271,
		-1,
		262,
		241,
		238,
		226,
		213,
		198,
		199,
		207,
		219,
		198,
		192,
		189,
		209,
		235,
		213,
		224,
		-1,
		-1,
		-1,
		300,
		-1,
		-1,
		245,
		216,
		240,
		282,
		301,
		294,
		282,
		247,
		247,
		241,
		-1,
		237,
		216,
		207,
		196,
		194,
		207,
		199,
		207,
		187,
		185,
		204,
		216,
		207,
		215,
		-1,
		-1,
		-1,
		275,
		264,
		265,
		214,
		237,
		271,
		280,
		266,
		271,
		246,
		239,
		233,
		250,
		233,
		214,
		203,
		195,
		184,
		195,
		203,
		201,
		183,
		192,
		198,
		222,
		203,
		209,
		-1,
		-1,
		282,
		272,
		256,
		258,
		255,
		228,
		235,
		267,
		271,
		279,
		-1,
		238,
		-1,
		227,
		223,
		208,
		203,
		200,
		187,
		186,
		200,
		200,
		190,
		185,
		192,
		227,
		227,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		275,
		273,
		248,
		225,
		209,
		245,
		-1,
		249,
		250,
		-1,
		232,
		226,
		223,
		210,
		206,
		191,
		195,
		197,
		200,
		188,
		194,
		195,
		177,
		201,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		271,
		250,
		243,
		263,
		204,
		256,
		-1,
		-1,
		234,
		227,
		-1,
		219,
		201,
		203,
		198,
		194,
		196,
		193,
		182,
		195,
		188,
		182,
		176,
		189,
		193,
		194,
		183,
		179,
		176,
		190,
		-1,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		224,
		-1,
		237,
		229,
		225,
		219,
		218,
		214,
		212,
		222,
		206,
		208,
		204,
		196,
		191,
		177,
		170,
		181,
		166,
		184,
		190,
		181,
		176,
		175,
		186,
		-1,
		291,
		277,
		248,
		-1,
		-1,
		237,
		-1,
		201,
		215,
		231,
		-1,
		256,
		235,
		250,
		228,
		224,
		215,
		213,
		214,
		184,
		189,
		191,
		179,
		182,
		171,
		174,
		166,
		188,
		185,
		169,
		171,
		180,
		-1,
		297,
		284,
		242,
		238,
		227,
		247,
		198,
		207,
		218,
		-1,
		-1,
		275,
		-1,
		226,
		231,
		229,
		227,
		203,
		178,
		185,
		203,
		176,
		171,
		176,
		165,
		165,
		160,
		179,
		165,
		163,
		178,
		194,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		213,
		200,
		194,
		-1,
		235,
		-1,
		253,
		241,
		228,
		210,
		250,
		-1,
		177,
		173,
		180,
		-1,
		196,
		-1,
		168,
		171,
		162,
		157,
		154,
		165,
		163,
		172,
		173,
		-1,
		247,
		232,
		225,
		215,
		229,
		200,
		-1,
		241,
		-1,
		-1,
		240,
		234,
		234,
		203,
		200,
		193,
		173,
		165,
		180,
		179,
		166,
		165,
		153,
		153,
		156,
		150,
		163,
		173,
		179,
		171,
		-1,
		-1,
		-1,
		252,
		204,
		212,
		188,
		207,
		-1,
		-1,
		301,
		257,
		243,
		-1,
		195,
		193,
		181,
		171,
		161,
		166,
		167,
		157,
		155,
		151,
		160,
		159,
		152,
		151,
		172,
		165,
		187,
		-1,
		-1,
		201,
		214,
		216,
		185,
		180,
		-1,
		-1,
		-1,
		247,
		243,
		214,
		193,
		182,
		-1,
		-1,
		165,
		158,
		152,
		155,
		143,
		163,
		170,
		158,
		145,
		160,
		170,
		178,
		177,
		-1,
		204,
		191,
		-1,
		-1,
		179,
		169,
		-1,
		-1,
		-1,
		-1,
		221,
		171,
		160,
		155,
		159,
		164,
		-1,
		138,
		149,
		142,
		161,
		168,
		160,
		145,
		139,
		150,
		165,
		182,
		-1,
		-1,
		193,
		-1,
		155,
		-1,
		-1,
		-1,
		-1,
		183,
		177,
		148,
		141,
		145,
		-1,
		140,
		142,
		139,
		151,
		156,
		160,
		151,
		133,
		147,
		150,
		163,
		177,
		181,
		216,
		-1,
		146,
		-1,
		-1,
		-1,
		185,
		186,
		181,
		158,
		137,
		130,
		127,
		126,
		131,
		142,
		151,
		162,
		127,
		131,
		146,
		151,
		155,
		172,
		176,
		-1,
		-1,
		144,
		140,
		175,
		187,
		159,
		208,
		-1,
		-1,
		126,
		119,
		129,
		122,
		135,
		138,
		123,
		125,
		143,
		156,
		150,
		160,
		175,
		170,
		-1,
		-1,
		-1,
		142,
		-1,
		158,
		-1,
		-1,
		149,
		199,
		146,
		128,
		124,
		110,
		117,
		111,
		113,
		118,
		137,
		132,
		141,
		146,
		150,
		173,
		162,
		201,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		108,
		127,
		122,
		128,
		133,
		124,
		161,
		158,
		-1,
		107,
		140,
		108,
		122,
		118,
		125,
		130,
		136,
		140,
		147,
		163,
		162,
		157,
		193,
		184,
		190,
		-1,
		-1,
		150,
		139,
		128,
		134,
		-1,
		101,
		124,
		114,
		104,
		110,
		-1,
		-1,
		125,
		122,
		120,
		100,
		106,
		111,
		114,
		152,
		128,
		136,
		140,
		144,
		150,
		155,
		160,
		166,
		181,
		196,
		-1,
		104,
		141,
		134,
		102,
		110,
		141,
		-1,
		91,
		83,
		111,
		96,
		104,
		-1,
		-1,
		98,
		89,
		94,
		103,
		104,
		135,
		134,
		147,
		150,
		155,
		143,
		142,
		160,
		164,
		173,
		180,
		170,
		183,
		187,
		-1,
		97,
		117,
		96,
		99,
		123,
		137,
		-1,
		82,
		-1,
		-1,
		127,
		117,
		107,
		97,
		94,
		141,
		117,
		112,
		118,
		120,
		144,
		135,
		160,
		151,
		151,
		154,
		169,
		174,
		166,
		180,
		180,
		181,
		-1,
		86,
		97,
		90,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		143,
		-1,
		134,
		-1,
		117,
		121,
		125,
		128,
		143,
		130,
		137,
		154,
		160,
		149,
		159,
		155,
		156,
		165,
		176,
		188,
		187,
		188,
		111,
		67,
		70,
		81,
		92,
		107,
		111,
		-1,
		66,
		102,
		111,
		-1,
		152,
		-1,
		-1,
		-1,
		131,
		138,
		130,
		146,
		142,
		142,
		138,
		142,
		154,
		161,
		171,
		173,
		165,
		169,
		182,
		193,
		196,
		107,
		98,
		111,
		56,
		56,
		77,
		86,
		107,
		61,
		59,
		96,
		100,
		115,
		120,
		144,
		-1,
		-1,
		154,
		148,
		-1,
		-1,
		149,
		159,
		142,
		144,
		148,
		162,
		174,
		182,
		172,
		170,
		164,
		196,
		-1,
		100,
		99,
		88,
		85,
		61,
		52,
		47,
		74,
		-1,
		-1,
		59,
		87,
		70,
		74,
		90,
		115,
		-1,
		139,
		-1,
		-1,
		175,
		-1,
		-1,
		189,
		164,
		153,
		144,
		150,
		156,
		167,
		189,
		178,
		179,
		169,
		179,
		192,
		84,
		81,
		69,
		67,
		90,
		55,
		43,
		-1,
		38,
		45,
		50,
		57,
		74,
		104,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		187,
		185,
		174,
		-1,
		164,
		146,
		151,
		179,
		183,
		185,
		181,
		175,
		182,
		181,
		189,
		197,
		93,
		107,
		96,
		92,
		91,
		99,
		48,
		41,
		35,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		182,
		175,
		163,
		151,
		141,
		151,
		168,
		168,
		171,
		176,
		173,
		184,
		176,
		180,
		197,
		-1,
		127,
		-1,
		79,
		23,
		29,
		44,
		52,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		216,
		200,
		181,
		-1,
		151,
		164,
		204,
		172,
		177,
		172,
		179,
		190,
		179,
		182,
		191,
		191,
		-1,
		-1,
		22,
		5,
		-1,
		-1,
		31,
		50,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		188,
		184,
		-1,
		-1,
		138,
		176,
		175,
		183,
		178,
		183,
		189,
		191,
		181,
		185,
		188,
		-1,
		-1,
		0,
		12,
		17,
		-1,
		40,
		-1,
		155,
		-1,
		122,
		129,
		117,
		-1,
		-1,
		-1,
		169,
		132,
		148,
		171,
		197,
		195,
		186,
		179,
		186,
		189,
		182,
		188,
		-1,
		-1,
		-1,
		70,
		47,
		162,
		153,
		136,
		116,
		108,
		128,
		-1,
		150,
		-1,
		125,
		128,
		153,
		192,
		194,
		180,
		176,
		189,
		183,
		180,
		178,
		76,
		-1,
		51,
		110,
		93,
		122,
		88,
		100,
		164,
		-1,
		147,
		129,
		-1,
		157,
		147,
		195,
		170,
		179,
		172,
		166,
		167,
		175,
		-1,
		-1,
		-1,
		66,
		65,
		64,
		75,
		83,
		81,
		99,
		-1,
		152,
		134,
		120,
		137,
		137,
		128,
		136,
		185,
		181,
		184,
		182,
		160,
		-1,
		169,
		-1,
		-1,
		89,
		-1,
		-1,
		-1,
		92,
		114,
		109,
		101,
		113,
		122,
		117,
		119,
		132,
		140,
		138,
		135,
		147,
		143,
		163,
		159,
		191,
		-1,
		176,
		-1,
		96,
		-1,
		-1,
		110,
		96,
		108,
		119,
		109,
		109,
		114,
		112,
		134,
		164,
		150,
		148,
		153,
		158,
		-1,
		186,
		187,
		-1,
		129,
		121,
		107,
		-1,
		100,
		-1,
		155,
		116,
		-1,
		141,
		121,
		-1,
		159,
		155,
		-1,
		-1,
		185,
		145,
		-1,
		-1,
		-1,
		130,
		110,
		150,
		134,
		-1,
		132,
		132,
		-1,
		-1,
		-1,
		170,
		154,
		-1,
		123,
		126,
		-1,
		117,
		123,
		152,
		134,
		138,
		-1,
		-1,
		-1,
		179,
		160,
		154,
		138,
		143,
		131,
		148,
		134,
		136,
		148,
		137,
		158,
		-1,
		-1,
		-1,
		151,
		143,
		143,
		-1,
		-1,
		161,
		144,
		144,
		157,
		-1,
		-1,
		-1,
		173,
		154,
		-1,
		-1,
		152,
		-1,
		-1,
		157,
		156,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		162,
		-1,
		-1,
		-1,
		153,
		160,
		168,
		-1,
		-1,
		-1,
		-1,
		183,
		184,
		208,
		183,
		-1,
		-1,
		-1,
		167,
		167,
		-1,
		-1,
		186,
		184,
		-1,
		-1,
		-1,
		195,
		179,
		-1,
		171,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		200,
		-1,
		206,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		213,
		205,
		219,
		-1,
		191,
		193,
		-1,
		241,
		-1,
		-1,
		228,
		219,
		-1,
		-1,
		196,
		203,
		225,
		228,
		258,
		-1,
		215
	],
	[
		-1,
		305,
		294,
		305,
		313,
		286,
		293,
		-1,
		312,
		316,
		282,
		276,
		315,
		284,
		290,
		301,
		-1,
		-1,
		-1,
		305,
		304,
		272,
		270,
		279,
		284,
		291,
		-1,
		290,
		-1,
		326,
		305,
		316,
		321,
		265,
		262,
		282,
		301,
		283,
		275,
		341,
		295,
		266,
		260,
		278,
		268,
		277,
		269,
		-1,
		266,
		256,
		278,
		257,
		268,
		260,
		-1,
		-1,
		260,
		261,
		267,
		253,
		259,
		255,
		-1,
		265,
		249,
		-1,
		-1,
		250,
		251,
		235,
		238,
		246,
		244,
		257,
		249,
		244,
		-1,
		-1,
		241,
		237,
		244,
		231,
		227,
		244,
		257,
		239,
		253,
		252,
		-1,
		247,
		265,
		270,
		238,
		236,
		220,
		218,
		236,
		238,
		244,
		244,
		-1,
		256,
		257,
		252,
		260,
		260,
		236,
		223,
		223,
		233,
		226,
		245,
		233,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		256,
		239,
		256,
		248,
		238,
		253,
		246,
		226,
		223,
		221,
		218,
		234,
		232,
		242,
		-1,
		-1,
		312,
		281,
		316,
		273,
		258,
		-1,
		252,
		232,
		238,
		242,
		236,
		229,
		243,
		239,
		-1,
		212,
		211,
		239,
		225,
		236,
		272,
		-1,
		-1,
		270,
		262,
		247,
		250,
		247,
		247,
		247,
		246,
		238,
		224,
		220,
		226,
		229,
		229,
		235,
		206,
		216,
		220,
		218,
		243,
		-1,
		-1,
		278,
		-1,
		-1,
		269,
		252,
		-1,
		235,
		242,
		242,
		259,
		249,
		270,
		257,
		248,
		240,
		234,
		222,
		224,
		221,
		234,
		222,
		203,
		228,
		232,
		213,
		234,
		229,
		-1,
		277,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		228,
		231,
		237,
		261,
		271,
		-1,
		269,
		257,
		258,
		243,
		240,
		227,
		215,
		228,
		213,
		220,
		219,
		207,
		205,
		235,
		210,
		232,
		229,
		248,
		253,
		247,
		256,
		-1,
		277,
		273,
		269,
		276,
		225,
		-1,
		-1,
		265,
		-1,
		279,
		292,
		281,
		254,
		257,
		244,
		235,
		222,
		211,
		222,
		211,
		208,
		216,
		199,
		214,
		205,
		204,
		222,
		232,
		240,
		244,
		250,
		-1,
		327,
		-1,
		269,
		253,
		255,
		227,
		248,
		-1,
		285,
		280,
		298,
		283,
		281,
		-1,
		253,
		250,
		240,
		218,
		203,
		220,
		212,
		210,
		212,
		194,
		208,
		199,
		217,
		224,
		222,
		226,
		246,
		258,
		287,
		277,
		-1,
		259,
		264,
		223,
		231,
		250,
		323,
		287,
		-1,
		282,
		-1,
		255,
		268,
		-1,
		224,
		220,
		202,
		203,
		198,
		213,
		205,
		190,
		187,
		205,
		208,
		215,
		219,
		235,
		-1,
		-1,
		272,
		276,
		265,
		216,
		235,
		259,
		296,
		280,
		269,
		268,
		-1,
		259,
		238,
		235,
		223,
		210,
		195,
		196,
		204,
		216,
		195,
		189,
		186,
		206,
		232,
		210,
		221,
		-1,
		-1,
		-1,
		297,
		-1,
		-1,
		242,
		213,
		237,
		279,
		298,
		291,
		279,
		244,
		244,
		238,
		-1,
		234,
		213,
		204,
		193,
		191,
		204,
		196,
		204,
		184,
		182,
		201,
		213,
		204,
		212,
		-1,
		-1,
		-1,
		272,
		261,
		262,
		211,
		234,
		268,
		277,
		263,
		268,
		243,
		236,
		230,
		247,
		230,
		211,
		200,
		192,
		181,
		192,
		200,
		198,
		180,
		189,
		195,
		219,
		200,
		206,
		-1,
		-1,
		279,
		269,
		253,
		255,
		252,
		225,
		232,
		264,
		268,
		276,
		-1,
		235,
		-1,
		224,
		220,
		205,
		200,
		197,
		184,
		183,
		197,
		197,
		187,
		182,
		189,
		224,
		224,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		272,
		270,
		245,
		222,
		206,
		242,
		-1,
		246,
		247,
		-1,
		229,
		223,
		220,
		207,
		203,
		188,
		192,
		194,
		197,
		185,
		191,
		192,
		174,
		198,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		268,
		247,
		240,
		260,
		201,
		253,
		-1,
		-1,
		231,
		224,
		-1,
		216,
		198,
		200,
		195,
		191,
		193,
		190,
		179,
		192,
		185,
		179,
		173,
		186,
		190,
		191,
		180,
		176,
		173,
		187,
		-1,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		221,
		-1,
		234,
		226,
		222,
		216,
		215,
		211,
		209,
		219,
		203,
		205,
		201,
		193,
		188,
		174,
		167,
		178,
		163,
		181,
		187,
		178,
		173,
		172,
		183,
		-1,
		288,
		274,
		245,
		-1,
		-1,
		234,
		-1,
		198,
		212,
		228,
		-1,
		253,
		232,
		247,
		225,
		221,
		212,
		210,
		211,
		181,
		186,
		188,
		176,
		179,
		168,
		171,
		163,
		185,
		182,
		166,
		168,
		177,
		-1,
		294,
		281,
		239,
		235,
		224,
		244,
		195,
		204,
		215,
		-1,
		-1,
		272,
		-1,
		223,
		228,
		226,
		224,
		200,
		175,
		182,
		200,
		173,
		168,
		173,
		162,
		162,
		157,
		176,
		162,
		160,
		175,
		191,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		210,
		197,
		191,
		-1,
		232,
		-1,
		250,
		238,
		225,
		207,
		247,
		-1,
		174,
		170,
		177,
		-1,
		193,
		-1,
		165,
		168,
		159,
		154,
		151,
		162,
		160,
		169,
		170,
		-1,
		244,
		229,
		222,
		212,
		226,
		197,
		-1,
		240,
		-1,
		-1,
		237,
		231,
		231,
		200,
		197,
		190,
		170,
		162,
		177,
		176,
		163,
		162,
		150,
		150,
		153,
		147,
		160,
		170,
		176,
		168,
		-1,
		-1,
		-1,
		249,
		201,
		209,
		185,
		206,
		-1,
		-1,
		298,
		254,
		240,
		-1,
		192,
		190,
		178,
		168,
		158,
		163,
		164,
		154,
		152,
		148,
		157,
		156,
		149,
		148,
		169,
		162,
		184,
		-1,
		-1,
		198,
		211,
		213,
		191,
		186,
		-1,
		-1,
		-1,
		244,
		245,
		211,
		190,
		179,
		-1,
		-1,
		162,
		155,
		149,
		152,
		140,
		160,
		167,
		155,
		142,
		157,
		167,
		175,
		174,
		-1,
		201,
		188,
		-1,
		-1,
		185,
		175,
		-1,
		-1,
		-1,
		-1,
		223,
		168,
		157,
		152,
		156,
		161,
		-1,
		135,
		146,
		139,
		158,
		165,
		157,
		142,
		136,
		147,
		162,
		179,
		-1,
		-1,
		199,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		180,
		174,
		145,
		138,
		142,
		-1,
		137,
		139,
		136,
		148,
		153,
		157,
		148,
		130,
		144,
		147,
		160,
		174,
		178,
		222,
		-1,
		152,
		-1,
		-1,
		-1,
		191,
		192,
		178,
		155,
		134,
		127,
		124,
		123,
		128,
		139,
		148,
		159,
		124,
		128,
		143,
		148,
		152,
		169,
		173,
		-1,
		-1,
		150,
		146,
		181,
		193,
		165,
		205,
		-1,
		-1,
		123,
		116,
		126,
		119,
		132,
		135,
		120,
		122,
		140,
		153,
		147,
		157,
		172,
		167,
		-1,
		-1,
		-1,
		148,
		-1,
		164,
		-1,
		-1,
		155,
		196,
		143,
		125,
		121,
		107,
		114,
		108,
		110,
		115,
		134,
		129,
		138,
		143,
		147,
		170,
		159,
		198,
		-1,
		-1,
		154,
		-1,
		-1,
		-1,
		114,
		133,
		128,
		134,
		139,
		130,
		158,
		155,
		-1,
		104,
		137,
		105,
		119,
		115,
		122,
		127,
		133,
		137,
		144,
		160,
		159,
		154,
		190,
		181,
		187,
		-1,
		-1,
		147,
		136,
		125,
		131,
		-1,
		107,
		130,
		120,
		110,
		116,
		-1,
		-1,
		122,
		119,
		117,
		97,
		103,
		108,
		111,
		149,
		125,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		101,
		138,
		131,
		99,
		107,
		138,
		-1,
		97,
		89,
		117,
		102,
		110,
		-1,
		-1,
		95,
		86,
		91,
		100,
		101,
		132,
		131,
		144,
		147,
		152,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		94,
		114,
		93,
		96,
		120,
		134,
		-1,
		88,
		-1,
		-1,
		133,
		120,
		104,
		94,
		91,
		138,
		114,
		109,
		115,
		117,
		141,
		132,
		157,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		83,
		94,
		87,
		-1,
		-1,
		-1,
		-1,
		82,
		-1,
		-1,
		149,
		-1,
		131,
		-1,
		114,
		118,
		122,
		125,
		140,
		127,
		134,
		151,
		157,
		146,
		156,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		108,
		64,
		67,
		78,
		89,
		104,
		108,
		-1,
		72,
		108,
		118,
		-1,
		152,
		-1,
		-1,
		-1,
		128,
		135,
		127,
		143,
		139,
		139,
		135,
		139,
		151,
		158,
		168,
		170,
		162,
		166,
		179,
		190,
		193,
		104,
		95,
		108,
		53,
		53,
		74,
		83,
		104,
		68,
		65,
		102,
		107,
		122,
		127,
		146,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		146,
		155,
		139,
		141,
		145,
		159,
		171,
		179,
		169,
		167,
		161,
		193,
		-1,
		97,
		96,
		85,
		82,
		58,
		49,
		44,
		71,
		-1,
		-1,
		66,
		93,
		77,
		81,
		97,
		122,
		-1,
		130,
		-1,
		-1,
		172,
		-1,
		-1,
		180,
		160,
		149,
		140,
		145,
		153,
		164,
		186,
		175,
		176,
		166,
		176,
		189,
		81,
		78,
		66,
		64,
		87,
		52,
		40,
		-1,
		46,
		51,
		57,
		64,
		81,
		111,
		-1,
		-1,
		146,
		126,
		-1,
		-1,
		178,
		176,
		165,
		-1,
		155,
		137,
		142,
		172,
		174,
		176,
		178,
		172,
		179,
		178,
		186,
		194,
		90,
		104,
		93,
		89,
		88,
		96,
		45,
		38,
		43,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		136,
		132,
		-1,
		-1,
		173,
		166,
		154,
		142,
		132,
		142,
		159,
		159,
		162,
		167,
		170,
		181,
		173,
		177,
		189,
		-1,
		124,
		-1,
		76,
		31,
		37,
		52,
		60,
		-1,
		-1,
		-1,
		153,
		139,
		132,
		120,
		118,
		-1,
		207,
		191,
		172,
		-1,
		142,
		155,
		195,
		163,
		168,
		163,
		176,
		187,
		176,
		179,
		182,
		185,
		-1,
		-1,
		30,
		13,
		-1,
		-1,
		22,
		41,
		-1,
		144,
		133,
		118,
		110,
		-1,
		-1,
		179,
		175,
		-1,
		-1,
		129,
		167,
		166,
		174,
		169,
		174,
		186,
		182,
		178,
		182,
		179,
		-1,
		-1,
		8,
		0,
		5,
		-1,
		31,
		-1,
		146,
		-1,
		113,
		120,
		108,
		-1,
		-1,
		-1,
		160,
		123,
		139,
		162,
		188,
		186,
		177,
		170,
		177,
		180,
		173,
		179,
		-1,
		-1,
		-1,
		61,
		38,
		153,
		144,
		127,
		107,
		99,
		119,
		-1,
		141,
		-1,
		116,
		119,
		144,
		183,
		185,
		171,
		167,
		180,
		174,
		171,
		169,
		67,
		-1,
		42,
		101,
		84,
		113,
		79,
		91,
		155,
		-1,
		138,
		120,
		-1,
		148,
		138,
		186,
		161,
		170,
		163,
		157,
		158,
		166,
		-1,
		-1,
		-1,
		57,
		56,
		55,
		66,
		74,
		72,
		90,
		-1,
		143,
		125,
		111,
		128,
		128,
		119,
		127,
		176,
		172,
		175,
		173,
		151,
		-1,
		160,
		-1,
		-1,
		80,
		-1,
		-1,
		-1,
		83,
		105,
		100,
		92,
		104,
		113,
		108,
		110,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		150,
		182,
		-1,
		167,
		-1,
		87,
		-1,
		-1,
		101,
		87,
		99,
		110,
		100,
		100,
		105,
		103,
		125,
		155,
		141,
		139,
		144,
		149,
		-1,
		177,
		178,
		-1,
		120,
		112,
		98,
		-1,
		91,
		-1,
		146,
		107,
		-1,
		132,
		112,
		-1,
		150,
		146,
		-1,
		-1,
		176,
		136,
		-1,
		-1,
		-1,
		121,
		101,
		141,
		125,
		-1,
		123,
		123,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		114,
		117,
		-1,
		108,
		114,
		143,
		125,
		129,
		-1,
		-1,
		-1,
		170,
		151,
		145,
		129,
		134,
		122,
		139,
		125,
		127,
		139,
		128,
		149,
		-1,
		-1,
		-1,
		142,
		134,
		134,
		-1,
		-1,
		152,
		135,
		135,
		148,
		-1,
		-1,
		-1,
		164,
		145,
		-1,
		-1,
		143,
		-1,
		-1,
		148,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		153,
		-1,
		-1,
		-1,
		144,
		151,
		159,
		-1,
		-1,
		-1,
		-1,
		174,
		175,
		199,
		174,
		-1,
		-1,
		-1,
		158,
		158,
		-1,
		-1,
		177,
		175,
		-1,
		-1,
		-1,
		186,
		170,
		-1,
		162,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		195,
		-1,
		-1,
		-1,
		191,
		-1,
		197,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		204,
		196,
		210,
		-1,
		182,
		184,
		-1,
		232,
		-1,
		-1,
		219,
		210,
		-1,
		-1,
		187,
		194,
		216,
		219,
		249,
		-1,
		206
	],
	[
		-1,
		311,
		300,
		311,
		319,
		292,
		299,
		-1,
		318,
		322,
		288,
		282,
		321,
		290,
		296,
		307,
		-1,
		-1,
		-1,
		311,
		310,
		278,
		276,
		285,
		290,
		297,
		-1,
		296,
		-1,
		332,
		311,
		322,
		327,
		271,
		268,
		288,
		307,
		289,
		281,
		347,
		301,
		272,
		266,
		284,
		274,
		283,
		275,
		-1,
		272,
		262,
		284,
		263,
		274,
		266,
		-1,
		-1,
		266,
		267,
		273,
		259,
		265,
		261,
		-1,
		271,
		255,
		-1,
		-1,
		256,
		257,
		241,
		244,
		252,
		250,
		263,
		255,
		250,
		-1,
		-1,
		247,
		243,
		250,
		237,
		233,
		250,
		263,
		245,
		259,
		258,
		-1,
		253,
		271,
		276,
		244,
		242,
		226,
		224,
		242,
		244,
		250,
		250,
		-1,
		262,
		263,
		258,
		266,
		266,
		242,
		229,
		229,
		239,
		232,
		251,
		239,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		262,
		245,
		262,
		254,
		244,
		259,
		252,
		232,
		229,
		227,
		224,
		240,
		238,
		248,
		-1,
		-1,
		318,
		287,
		322,
		279,
		264,
		-1,
		258,
		238,
		244,
		248,
		242,
		235,
		249,
		245,
		-1,
		218,
		217,
		245,
		231,
		242,
		278,
		-1,
		-1,
		276,
		268,
		253,
		256,
		253,
		253,
		253,
		252,
		244,
		230,
		226,
		232,
		235,
		235,
		241,
		212,
		222,
		226,
		224,
		249,
		-1,
		-1,
		284,
		-1,
		-1,
		275,
		258,
		-1,
		241,
		248,
		248,
		265,
		255,
		276,
		263,
		254,
		246,
		240,
		228,
		230,
		227,
		240,
		228,
		209,
		234,
		238,
		219,
		240,
		235,
		-1,
		283,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		234,
		237,
		243,
		267,
		277,
		-1,
		275,
		263,
		264,
		249,
		246,
		233,
		221,
		234,
		219,
		226,
		225,
		213,
		211,
		241,
		216,
		238,
		235,
		254,
		259,
		253,
		262,
		-1,
		283,
		279,
		275,
		282,
		231,
		-1,
		-1,
		271,
		-1,
		285,
		298,
		287,
		260,
		263,
		250,
		241,
		228,
		217,
		228,
		217,
		214,
		222,
		205,
		220,
		211,
		210,
		228,
		238,
		246,
		250,
		256,
		-1,
		333,
		-1,
		275,
		259,
		261,
		233,
		254,
		-1,
		291,
		286,
		304,
		289,
		287,
		-1,
		259,
		256,
		246,
		224,
		209,
		226,
		218,
		216,
		218,
		200,
		214,
		205,
		223,
		230,
		228,
		232,
		252,
		264,
		293,
		283,
		-1,
		265,
		270,
		229,
		237,
		256,
		329,
		293,
		-1,
		288,
		-1,
		261,
		274,
		-1,
		230,
		226,
		208,
		209,
		204,
		219,
		211,
		196,
		193,
		211,
		214,
		221,
		225,
		241,
		-1,
		-1,
		278,
		282,
		271,
		222,
		241,
		265,
		302,
		286,
		275,
		274,
		-1,
		265,
		244,
		241,
		229,
		216,
		201,
		202,
		210,
		222,
		201,
		195,
		192,
		212,
		238,
		216,
		227,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		248,
		219,
		243,
		285,
		304,
		297,
		285,
		250,
		250,
		244,
		-1,
		240,
		219,
		210,
		199,
		197,
		210,
		202,
		210,
		190,
		188,
		207,
		219,
		210,
		218,
		-1,
		-1,
		-1,
		278,
		267,
		268,
		217,
		240,
		274,
		283,
		269,
		274,
		249,
		242,
		236,
		253,
		236,
		217,
		206,
		198,
		187,
		198,
		206,
		204,
		186,
		195,
		201,
		225,
		206,
		212,
		-1,
		-1,
		285,
		275,
		259,
		261,
		258,
		231,
		238,
		270,
		274,
		282,
		-1,
		241,
		-1,
		230,
		226,
		211,
		206,
		203,
		190,
		189,
		203,
		203,
		193,
		188,
		195,
		230,
		230,
		196,
		216,
		219,
		-1,
		-1,
		-1,
		278,
		276,
		251,
		228,
		212,
		248,
		-1,
		252,
		253,
		-1,
		235,
		229,
		226,
		213,
		209,
		194,
		198,
		200,
		203,
		191,
		197,
		198,
		180,
		204,
		-1,
		204,
		198,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		237,
		230,
		-1,
		222,
		204,
		206,
		201,
		197,
		199,
		196,
		185,
		198,
		191,
		185,
		179,
		192,
		196,
		197,
		186,
		182,
		179,
		193,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		240,
		232,
		228,
		222,
		221,
		217,
		215,
		225,
		209,
		211,
		207,
		199,
		194,
		180,
		173,
		184,
		169,
		187,
		193,
		184,
		179,
		178,
		189,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		218,
		234,
		-1,
		259,
		238,
		253,
		231,
		227,
		218,
		216,
		217,
		187,
		192,
		194,
		182,
		185,
		174,
		177,
		169,
		191,
		188,
		172,
		174,
		183,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		210,
		221,
		-1,
		-1,
		278,
		-1,
		229,
		234,
		232,
		230,
		206,
		181,
		188,
		206,
		179,
		174,
		179,
		168,
		168,
		163,
		182,
		168,
		166,
		181,
		197,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		238,
		-1,
		256,
		244,
		231,
		213,
		253,
		-1,
		180,
		176,
		183,
		-1,
		199,
		-1,
		171,
		174,
		165,
		160,
		157,
		168,
		166,
		175,
		176,
		-1,
		250,
		235,
		228,
		218,
		232,
		203,
		-1,
		246,
		-1,
		-1,
		243,
		237,
		237,
		206,
		203,
		196,
		176,
		168,
		183,
		182,
		169,
		168,
		156,
		156,
		159,
		153,
		166,
		176,
		182,
		174,
		-1,
		-1,
		-1,
		255,
		207,
		215,
		191,
		212,
		-1,
		-1,
		304,
		260,
		246,
		-1,
		198,
		196,
		184,
		174,
		164,
		169,
		170,
		160,
		158,
		154,
		163,
		162,
		155,
		154,
		175,
		168,
		190,
		-1,
		-1,
		204,
		217,
		219,
		197,
		192,
		-1,
		-1,
		-1,
		250,
		251,
		217,
		196,
		185,
		-1,
		-1,
		168,
		161,
		155,
		158,
		146,
		166,
		173,
		161,
		148,
		163,
		173,
		181,
		180,
		-1,
		207,
		194,
		-1,
		-1,
		191,
		181,
		-1,
		-1,
		-1,
		-1,
		229,
		174,
		163,
		158,
		162,
		167,
		-1,
		141,
		152,
		145,
		164,
		171,
		163,
		148,
		142,
		153,
		168,
		185,
		-1,
		-1,
		205,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		186,
		180,
		151,
		144,
		148,
		-1,
		143,
		145,
		142,
		154,
		159,
		163,
		154,
		136,
		150,
		153,
		166,
		180,
		184,
		228,
		-1,
		158,
		-1,
		-1,
		-1,
		197,
		198,
		184,
		161,
		140,
		133,
		130,
		129,
		134,
		145,
		154,
		165,
		130,
		134,
		149,
		154,
		158,
		175,
		179,
		-1,
		-1,
		156,
		152,
		187,
		199,
		171,
		211,
		-1,
		-1,
		129,
		122,
		132,
		125,
		138,
		141,
		126,
		128,
		146,
		159,
		153,
		163,
		178,
		173,
		-1,
		-1,
		-1,
		154,
		-1,
		170,
		-1,
		-1,
		161,
		202,
		149,
		131,
		127,
		113,
		120,
		114,
		116,
		121,
		140,
		135,
		144,
		149,
		153,
		176,
		165,
		204,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		120,
		139,
		134,
		140,
		145,
		136,
		164,
		161,
		-1,
		110,
		143,
		111,
		125,
		121,
		128,
		133,
		139,
		143,
		150,
		166,
		165,
		160,
		196,
		187,
		193,
		-1,
		-1,
		153,
		142,
		131,
		137,
		-1,
		113,
		136,
		126,
		116,
		122,
		-1,
		-1,
		128,
		125,
		123,
		103,
		109,
		114,
		117,
		155,
		131,
		139,
		143,
		147,
		153,
		158,
		163,
		169,
		184,
		199,
		-1,
		107,
		144,
		137,
		105,
		113,
		144,
		-1,
		103,
		95,
		123,
		108,
		116,
		-1,
		-1,
		101,
		92,
		97,
		106,
		107,
		138,
		137,
		150,
		153,
		158,
		146,
		145,
		163,
		167,
		176,
		183,
		173,
		186,
		190,
		-1,
		100,
		120,
		99,
		102,
		126,
		140,
		-1,
		94,
		-1,
		-1,
		139,
		126,
		110,
		100,
		97,
		144,
		120,
		115,
		121,
		123,
		147,
		138,
		163,
		154,
		154,
		157,
		172,
		177,
		169,
		183,
		183,
		184,
		-1,
		89,
		100,
		93,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		155,
		-1,
		137,
		-1,
		120,
		124,
		128,
		131,
		146,
		133,
		140,
		157,
		163,
		152,
		162,
		158,
		159,
		168,
		179,
		191,
		190,
		191,
		114,
		70,
		73,
		84,
		95,
		110,
		114,
		-1,
		78,
		114,
		124,
		-1,
		147,
		-1,
		-1,
		-1,
		134,
		141,
		133,
		149,
		145,
		145,
		141,
		145,
		157,
		164,
		174,
		176,
		168,
		172,
		185,
		196,
		199,
		110,
		101,
		114,
		59,
		59,
		80,
		89,
		110,
		74,
		71,
		108,
		113,
		128,
		133,
		141,
		-1,
		-1,
		157,
		151,
		-1,
		-1,
		152,
		150,
		138,
		147,
		151,
		165,
		177,
		185,
		175,
		173,
		167,
		199,
		-1,
		103,
		102,
		91,
		88,
		64,
		55,
		50,
		77,
		-1,
		-1,
		72,
		99,
		83,
		87,
		103,
		128,
		-1,
		125,
		-1,
		-1,
		178,
		-1,
		-1,
		175,
		155,
		144,
		135,
		140,
		159,
		170,
		192,
		175,
		182,
		172,
		182,
		195,
		87,
		84,
		72,
		70,
		93,
		58,
		46,
		-1,
		52,
		57,
		63,
		70,
		87,
		117,
		-1,
		-1,
		141,
		121,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		132,
		137,
		167,
		169,
		171,
		178,
		172,
		179,
		184,
		192,
		190,
		96,
		110,
		99,
		95,
		94,
		102,
		51,
		44,
		49,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		131,
		127,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		154,
		154,
		157,
		162,
		170,
		181,
		177,
		181,
		184,
		-1,
		130,
		-1,
		82,
		37,
		43,
		58,
		66,
		-1,
		-1,
		-1,
		148,
		134,
		127,
		115,
		113,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		190,
		158,
		163,
		158,
		173,
		184,
		175,
		183,
		177,
		180,
		-1,
		-1,
		36,
		19,
		-1,
		-1,
		17,
		36,
		-1,
		139,
		128,
		113,
		105,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		124,
		162,
		161,
		169,
		164,
		169,
		181,
		177,
		173,
		183,
		174,
		-1,
		-1,
		14,
		6,
		0,
		-1,
		26,
		-1,
		141,
		-1,
		108,
		115,
		103,
		-1,
		-1,
		-1,
		155,
		118,
		134,
		157,
		183,
		181,
		172,
		165,
		172,
		175,
		168,
		174,
		-1,
		-1,
		-1,
		56,
		33,
		148,
		139,
		122,
		102,
		94,
		114,
		-1,
		136,
		-1,
		111,
		114,
		139,
		178,
		180,
		166,
		162,
		175,
		169,
		166,
		164,
		62,
		-1,
		37,
		96,
		79,
		108,
		74,
		86,
		150,
		-1,
		133,
		115,
		-1,
		143,
		133,
		181,
		156,
		165,
		158,
		152,
		153,
		161,
		-1,
		-1,
		-1,
		52,
		51,
		50,
		61,
		69,
		67,
		85,
		-1,
		138,
		120,
		106,
		123,
		123,
		114,
		122,
		171,
		167,
		170,
		168,
		146,
		-1,
		155,
		-1,
		-1,
		75,
		-1,
		-1,
		-1,
		78,
		100,
		95,
		87,
		99,
		108,
		103,
		105,
		118,
		126,
		124,
		121,
		133,
		129,
		149,
		145,
		177,
		-1,
		162,
		-1,
		82,
		-1,
		-1,
		96,
		82,
		94,
		105,
		95,
		95,
		100,
		98,
		120,
		150,
		136,
		134,
		139,
		144,
		-1,
		172,
		173,
		-1,
		115,
		107,
		93,
		-1,
		86,
		-1,
		141,
		102,
		-1,
		127,
		107,
		-1,
		145,
		141,
		-1,
		-1,
		171,
		131,
		-1,
		-1,
		-1,
		116,
		96,
		136,
		120,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		156,
		140,
		-1,
		109,
		112,
		-1,
		103,
		109,
		138,
		120,
		124,
		-1,
		-1,
		-1,
		165,
		146,
		140,
		124,
		129,
		117,
		134,
		120,
		122,
		134,
		123,
		144,
		-1,
		-1,
		-1,
		137,
		129,
		129,
		-1,
		-1,
		147,
		130,
		130,
		143,
		-1,
		-1,
		-1,
		159,
		140,
		-1,
		-1,
		138,
		-1,
		-1,
		143,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		148,
		-1,
		-1,
		-1,
		139,
		146,
		154,
		-1,
		-1,
		-1,
		-1,
		169,
		170,
		194,
		169,
		-1,
		-1,
		-1,
		153,
		153,
		-1,
		-1,
		172,
		170,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		157,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		186,
		-1,
		192,
		167,
		174,
		-1,
		-1,
		-1,
		-1,
		199,
		191,
		205,
		-1,
		177,
		179,
		-1,
		227,
		-1,
		-1,
		214,
		205,
		-1,
		-1,
		182,
		189,
		211,
		214,
		244,
		-1,
		201
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		300,
		289,
		300,
		308,
		281,
		288,
		-1,
		307,
		311,
		277,
		271,
		310,
		279,
		285,
		296,
		-1,
		-1,
		-1,
		300,
		299,
		267,
		265,
		274,
		279,
		286,
		-1,
		285,
		-1,
		321,
		300,
		311,
		316,
		260,
		257,
		277,
		296,
		278,
		270,
		336,
		290,
		261,
		255,
		273,
		263,
		272,
		264,
		-1,
		261,
		251,
		273,
		252,
		263,
		255,
		-1,
		-1,
		255,
		256,
		262,
		248,
		254,
		250,
		-1,
		260,
		244,
		-1,
		-1,
		245,
		246,
		230,
		233,
		241,
		239,
		252,
		244,
		239,
		-1,
		-1,
		236,
		232,
		239,
		226,
		222,
		239,
		252,
		234,
		248,
		247,
		-1,
		240,
		258,
		265,
		233,
		231,
		215,
		213,
		231,
		233,
		239,
		239,
		-1,
		249,
		250,
		245,
		253,
		255,
		231,
		218,
		218,
		228,
		221,
		240,
		228,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		249,
		232,
		249,
		241,
		231,
		246,
		239,
		221,
		218,
		216,
		213,
		229,
		227,
		237,
		-1,
		-1,
		334,
		303,
		338,
		295,
		279,
		-1,
		245,
		225,
		231,
		235,
		229,
		222,
		236,
		232,
		-1,
		207,
		206,
		234,
		220,
		231,
		294,
		-1,
		-1,
		292,
		284,
		269,
		272,
		255,
		251,
		240,
		239,
		231,
		217,
		213,
		219,
		222,
		222,
		228,
		201,
		211,
		215,
		213,
		238,
		-1,
		-1,
		273,
		-1,
		-1,
		291,
		274,
		-1,
		257,
		264,
		261,
		267,
		253,
		274,
		250,
		241,
		233,
		227,
		215,
		217,
		214,
		227,
		215,
		198,
		223,
		227,
		208,
		229,
		224,
		-1,
		272,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		250,
		253,
		259,
		283,
		290,
		-1,
		262,
		250,
		251,
		236,
		233,
		220,
		208,
		221,
		206,
		213,
		212,
		202,
		200,
		230,
		205,
		227,
		224,
		243,
		248,
		242,
		251,
		-1,
		299,
		295,
		291,
		298,
		247,
		-1,
		-1,
		287,
		-1,
		298,
		299,
		274,
		247,
		250,
		237,
		228,
		215,
		204,
		215,
		204,
		201,
		209,
		194,
		209,
		200,
		199,
		217,
		227,
		235,
		239,
		245,
		-1,
		349,
		-1,
		291,
		275,
		277,
		249,
		270,
		-1,
		307,
		299,
		291,
		276,
		276,
		-1,
		246,
		243,
		233,
		211,
		196,
		213,
		205,
		203,
		207,
		189,
		203,
		194,
		212,
		219,
		217,
		221,
		241,
		253,
		309,
		299,
		-1,
		281,
		286,
		245,
		253,
		272,
		318,
		282,
		-1,
		277,
		-1,
		248,
		261,
		-1,
		217,
		213,
		195,
		196,
		191,
		206,
		200,
		185,
		182,
		200,
		203,
		210,
		214,
		230,
		-1,
		-1,
		294,
		298,
		287,
		238,
		257,
		281,
		318,
		275,
		264,
		263,
		-1,
		254,
		231,
		228,
		216,
		203,
		188,
		189,
		197,
		210,
		189,
		184,
		181,
		201,
		227,
		205,
		217,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		264,
		235,
		259,
		301,
		293,
		286,
		274,
		239,
		239,
		233,
		-1,
		227,
		206,
		197,
		186,
		184,
		197,
		194,
		199,
		179,
		177,
		196,
		208,
		199,
		216,
		-1,
		-1,
		-1,
		294,
		283,
		284,
		233,
		256,
		290,
		272,
		258,
		263,
		238,
		231,
		225,
		240,
		223,
		204,
		193,
		185,
		174,
		190,
		198,
		193,
		175,
		184,
		190,
		214,
		204,
		210,
		-1,
		-1,
		301,
		291,
		275,
		277,
		274,
		247,
		254,
		286,
		263,
		276,
		-1,
		230,
		-1,
		219,
		214,
		198,
		193,
		190,
		187,
		181,
		190,
		192,
		182,
		177,
		184,
		219,
		219,
		194,
		214,
		217,
		-1,
		-1,
		-1,
		294,
		292,
		267,
		244,
		228,
		264,
		-1,
		246,
		247,
		-1,
		224,
		218,
		215,
		200,
		196,
		191,
		195,
		188,
		195,
		188,
		186,
		187,
		169,
		201,
		-1,
		202,
		196,
		204,
		194,
		182,
		-1,
		-1,
		-1,
		290,
		269,
		262,
		282,
		223,
		275,
		-1,
		-1,
		231,
		224,
		-1,
		211,
		193,
		200,
		198,
		192,
		196,
		193,
		182,
		195,
		188,
		174,
		176,
		189,
		193,
		197,
		184,
		180,
		177,
		191,
		-1,
		309,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		243,
		-1,
		240,
		232,
		222,
		216,
		210,
		206,
		204,
		220,
		204,
		207,
		205,
		196,
		204,
		177,
		170,
		177,
		166,
		184,
		192,
		184,
		178,
		177,
		187,
		-1,
		310,
		296,
		267,
		-1,
		-1,
		256,
		-1,
		220,
		234,
		250,
		-1,
		248,
		227,
		242,
		220,
		216,
		212,
		227,
		228,
		203,
		205,
		203,
		194,
		182,
		171,
		174,
		166,
		188,
		188,
		172,
		173,
		177,
		-1,
		316,
		303,
		261,
		257,
		246,
		266,
		217,
		210,
		237,
		-1,
		-1,
		284,
		-1,
		218,
		235,
		226,
		224,
		217,
		197,
		204,
		214,
		191,
		186,
		176,
		165,
		165,
		160,
		182,
		168,
		166,
		175,
		191,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		232,
		219,
		213,
		-1,
		254,
		-1,
		262,
		252,
		236,
		221,
		254,
		-1,
		196,
		192,
		199,
		-1,
		211,
		-1,
		184,
		181,
		172,
		157,
		154,
		165,
		163,
		174,
		170,
		-1,
		266,
		251,
		244,
		234,
		248,
		219,
		-1,
		262,
		-1,
		-1,
		249,
		243,
		243,
		222,
		219,
		212,
		192,
		184,
		199,
		198,
		185,
		184,
		170,
		163,
		160,
		153,
		166,
		176,
		181,
		168,
		-1,
		-1,
		-1,
		271,
		223,
		231,
		207,
		228,
		-1,
		-1,
		311,
		266,
		252,
		-1,
		214,
		212,
		200,
		190,
		180,
		185,
		186,
		176,
		174,
		168,
		170,
		164,
		155,
		154,
		170,
		162,
		184,
		-1,
		-1,
		220,
		233,
		235,
		213,
		208,
		-1,
		-1,
		-1,
		258,
		267,
		233,
		212,
		201,
		-1,
		-1,
		184,
		177,
		171,
		174,
		162,
		182,
		179,
		163,
		148,
		163,
		167,
		175,
		166,
		-1,
		223,
		210,
		-1,
		-1,
		207,
		197,
		-1,
		-1,
		-1,
		-1,
		245,
		190,
		179,
		174,
		178,
		183,
		-1,
		157,
		168,
		161,
		180,
		187,
		165,
		150,
		144,
		150,
		162,
		171,
		-1,
		-1,
		221,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		202,
		196,
		167,
		160,
		164,
		-1,
		159,
		161,
		158,
		170,
		168,
		165,
		156,
		147,
		143,
		147,
		151,
		165,
		169,
		244,
		-1,
		174,
		-1,
		-1,
		-1,
		213,
		214,
		200,
		177,
		156,
		149,
		146,
		145,
		150,
		161,
		170,
		181,
		146,
		150,
		140,
		139,
		143,
		160,
		164,
		-1,
		-1,
		172,
		168,
		203,
		215,
		187,
		227,
		-1,
		-1,
		145,
		138,
		148,
		141,
		154,
		157,
		142,
		144,
		146,
		144,
		138,
		148,
		163,
		158,
		-1,
		-1,
		-1,
		170,
		-1,
		186,
		-1,
		-1,
		177,
		218,
		165,
		147,
		143,
		129,
		136,
		130,
		132,
		137,
		149,
		143,
		140,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		136,
		155,
		150,
		156,
		161,
		152,
		180,
		177,
		-1,
		126,
		159,
		127,
		141,
		130,
		137,
		142,
		139,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		169,
		158,
		147,
		153,
		-1,
		129,
		152,
		142,
		132,
		138,
		-1,
		-1,
		144,
		141,
		139,
		119,
		125,
		130,
		126,
		136,
		112,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		123,
		160,
		153,
		121,
		129,
		160,
		-1,
		119,
		111,
		139,
		124,
		132,
		-1,
		-1,
		117,
		108,
		113,
		122,
		123,
		150,
		149,
		132,
		138,
		139,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		116,
		136,
		115,
		118,
		142,
		156,
		-1,
		110,
		-1,
		-1,
		141,
		142,
		126,
		116,
		113,
		160,
		136,
		131,
		137,
		135,
		130,
		121,
		146,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		105,
		116,
		109,
		-1,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		131,
		-1,
		153,
		-1,
		136,
		140,
		144,
		147,
		151,
		138,
		124,
		132,
		138,
		137,
		143,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		130,
		86,
		89,
		100,
		111,
		126,
		130,
		-1,
		94,
		130,
		137,
		-1,
		121,
		-1,
		-1,
		-1,
		150,
		157,
		149,
		165,
		150,
		150,
		116,
		120,
		133,
		140,
		150,
		161,
		153,
		157,
		170,
		181,
		184,
		126,
		117,
		130,
		75,
		75,
		96,
		105,
		126,
		90,
		87,
		124,
		129,
		133,
		128,
		115,
		-1,
		-1,
		173,
		167,
		-1,
		-1,
		157,
		124,
		112,
		122,
		126,
		140,
		152,
		165,
		153,
		158,
		152,
		184,
		-1,
		119,
		118,
		107,
		104,
		80,
		71,
		66,
		93,
		-1,
		-1,
		88,
		115,
		99,
		103,
		119,
		144,
		-1,
		99,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		129,
		118,
		109,
		114,
		134,
		145,
		167,
		149,
		166,
		157,
		167,
		171,
		103,
		100,
		88,
		86,
		109,
		74,
		62,
		-1,
		70,
		73,
		79,
		86,
		103,
		133,
		-1,
		-1,
		115,
		95,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		106,
		111,
		141,
		143,
		145,
		152,
		146,
		153,
		161,
		172,
		164,
		112,
		126,
		115,
		111,
		110,
		118,
		67,
		60,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		105,
		101,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		128,
		128,
		131,
		136,
		144,
		155,
		151,
		155,
		158,
		-1,
		146,
		-1,
		98,
		59,
		65,
		80,
		88,
		-1,
		-1,
		-1,
		122,
		108,
		101,
		89,
		87,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		164,
		132,
		137,
		132,
		147,
		158,
		149,
		157,
		151,
		154,
		-1,
		-1,
		58,
		41,
		-1,
		-1,
		15,
		17,
		-1,
		113,
		102,
		87,
		79,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		98,
		136,
		135,
		143,
		138,
		143,
		155,
		151,
		147,
		157,
		148,
		-1,
		-1,
		36,
		28,
		22,
		-1,
		0,
		-1,
		115,
		-1,
		82,
		89,
		77,
		-1,
		-1,
		-1,
		129,
		92,
		108,
		131,
		157,
		155,
		146,
		139,
		146,
		149,
		142,
		148,
		-1,
		-1,
		-1,
		30,
		7,
		122,
		113,
		96,
		76,
		68,
		88,
		-1,
		110,
		-1,
		85,
		88,
		113,
		152,
		154,
		140,
		136,
		149,
		143,
		140,
		138,
		36,
		-1,
		11,
		70,
		53,
		82,
		48,
		60,
		124,
		-1,
		107,
		89,
		-1,
		117,
		107,
		155,
		130,
		139,
		132,
		126,
		127,
		135,
		-1,
		-1,
		-1,
		26,
		25,
		24,
		35,
		43,
		41,
		59,
		-1,
		112,
		94,
		80,
		97,
		97,
		88,
		96,
		145,
		141,
		144,
		142,
		120,
		-1,
		129,
		-1,
		-1,
		49,
		-1,
		-1,
		-1,
		52,
		74,
		69,
		61,
		73,
		82,
		77,
		79,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		136,
		-1,
		56,
		-1,
		-1,
		70,
		56,
		68,
		79,
		69,
		69,
		74,
		72,
		94,
		124,
		110,
		108,
		113,
		118,
		-1,
		146,
		147,
		-1,
		89,
		81,
		67,
		-1,
		60,
		-1,
		115,
		76,
		-1,
		101,
		81,
		-1,
		119,
		115,
		-1,
		-1,
		145,
		105,
		-1,
		-1,
		-1,
		90,
		70,
		110,
		94,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		130,
		114,
		-1,
		83,
		86,
		-1,
		77,
		83,
		112,
		94,
		98,
		-1,
		-1,
		-1,
		139,
		120,
		114,
		98,
		103,
		91,
		108,
		94,
		96,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		111,
		103,
		103,
		-1,
		-1,
		121,
		104,
		104,
		117,
		-1,
		-1,
		-1,
		133,
		114,
		-1,
		-1,
		112,
		-1,
		-1,
		117,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		122,
		-1,
		-1,
		-1,
		113,
		120,
		128,
		-1,
		-1,
		-1,
		-1,
		143,
		144,
		168,
		143,
		-1,
		-1,
		-1,
		127,
		127,
		-1,
		-1,
		146,
		144,
		-1,
		-1,
		-1,
		155,
		139,
		-1,
		131,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		160,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		173,
		165,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		156,
		163,
		185,
		188,
		218,
		-1,
		175
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		316,
		305,
		316,
		324,
		297,
		304,
		-1,
		323,
		327,
		293,
		287,
		326,
		295,
		301,
		312,
		-1,
		-1,
		-1,
		316,
		315,
		283,
		281,
		290,
		295,
		302,
		-1,
		301,
		-1,
		337,
		316,
		327,
		332,
		276,
		273,
		293,
		312,
		294,
		286,
		352,
		306,
		277,
		271,
		289,
		279,
		288,
		280,
		-1,
		277,
		267,
		289,
		268,
		279,
		271,
		-1,
		-1,
		271,
		272,
		278,
		264,
		270,
		266,
		-1,
		276,
		260,
		-1,
		-1,
		261,
		262,
		246,
		249,
		257,
		255,
		268,
		260,
		255,
		-1,
		-1,
		252,
		248,
		255,
		242,
		238,
		255,
		268,
		250,
		264,
		263,
		-1,
		256,
		274,
		281,
		249,
		247,
		231,
		229,
		247,
		249,
		255,
		255,
		-1,
		265,
		266,
		261,
		269,
		271,
		247,
		234,
		234,
		244,
		237,
		256,
		244,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		265,
		248,
		265,
		257,
		247,
		262,
		255,
		237,
		234,
		232,
		229,
		245,
		243,
		253,
		-1,
		-1,
		358,
		327,
		356,
		314,
		295,
		-1,
		261,
		241,
		247,
		251,
		245,
		238,
		252,
		248,
		-1,
		223,
		222,
		250,
		236,
		247,
		318,
		-1,
		-1,
		316,
		308,
		291,
		294,
		271,
		267,
		256,
		255,
		247,
		233,
		229,
		235,
		238,
		238,
		244,
		217,
		227,
		231,
		229,
		254,
		-1,
		-1,
		289,
		-1,
		-1,
		315,
		298,
		-1,
		281,
		288,
		277,
		283,
		269,
		290,
		266,
		257,
		249,
		243,
		231,
		233,
		230,
		243,
		231,
		214,
		239,
		243,
		224,
		245,
		240,
		-1,
		288,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		293,
		274,
		277,
		283,
		307,
		306,
		-1,
		278,
		266,
		267,
		252,
		249,
		236,
		224,
		237,
		222,
		229,
		228,
		218,
		216,
		246,
		221,
		243,
		240,
		259,
		264,
		258,
		267,
		-1,
		323,
		319,
		315,
		322,
		271,
		-1,
		-1,
		311,
		-1,
		314,
		315,
		290,
		263,
		266,
		253,
		244,
		231,
		220,
		231,
		220,
		217,
		225,
		210,
		225,
		216,
		215,
		233,
		243,
		251,
		255,
		261,
		-1,
		373,
		-1,
		315,
		299,
		301,
		273,
		294,
		-1,
		331,
		315,
		307,
		292,
		292,
		-1,
		262,
		259,
		249,
		227,
		212,
		229,
		221,
		219,
		223,
		205,
		219,
		210,
		228,
		235,
		233,
		237,
		257,
		269,
		333,
		323,
		-1,
		305,
		310,
		269,
		277,
		296,
		334,
		298,
		-1,
		293,
		-1,
		264,
		277,
		-1,
		233,
		229,
		211,
		212,
		207,
		222,
		216,
		201,
		198,
		216,
		219,
		226,
		230,
		246,
		-1,
		-1,
		318,
		322,
		311,
		262,
		281,
		305,
		342,
		291,
		280,
		279,
		-1,
		270,
		247,
		244,
		232,
		219,
		204,
		205,
		213,
		226,
		205,
		200,
		197,
		217,
		243,
		221,
		233,
		-1,
		-1,
		-1,
		343,
		-1,
		-1,
		288,
		259,
		283,
		325,
		309,
		302,
		290,
		255,
		255,
		249,
		-1,
		243,
		222,
		213,
		202,
		200,
		213,
		210,
		215,
		195,
		193,
		212,
		224,
		215,
		232,
		-1,
		-1,
		-1,
		318,
		307,
		308,
		254,
		277,
		314,
		288,
		274,
		279,
		254,
		247,
		241,
		256,
		239,
		220,
		209,
		201,
		190,
		206,
		214,
		209,
		191,
		200,
		206,
		230,
		220,
		226,
		-1,
		-1,
		325,
		315,
		299,
		301,
		298,
		268,
		275,
		307,
		279,
		292,
		-1,
		246,
		-1,
		235,
		230,
		214,
		209,
		206,
		203,
		197,
		206,
		208,
		198,
		193,
		200,
		235,
		235,
		210,
		230,
		233,
		-1,
		-1,
		-1,
		318,
		313,
		288,
		265,
		249,
		285,
		-1,
		262,
		263,
		-1,
		240,
		234,
		231,
		216,
		212,
		207,
		211,
		204,
		211,
		204,
		202,
		203,
		185,
		217,
		-1,
		218,
		212,
		220,
		210,
		198,
		-1,
		-1,
		-1,
		311,
		290,
		283,
		303,
		244,
		296,
		-1,
		-1,
		247,
		240,
		-1,
		227,
		209,
		216,
		214,
		208,
		212,
		209,
		198,
		211,
		204,
		190,
		192,
		205,
		209,
		213,
		200,
		196,
		193,
		207,
		-1,
		330,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		264,
		-1,
		256,
		248,
		238,
		232,
		226,
		222,
		220,
		236,
		220,
		223,
		221,
		212,
		220,
		193,
		186,
		193,
		182,
		200,
		208,
		200,
		194,
		193,
		203,
		-1,
		331,
		317,
		288,
		-1,
		-1,
		277,
		-1,
		241,
		255,
		271,
		-1,
		264,
		243,
		258,
		236,
		232,
		228,
		243,
		244,
		221,
		221,
		219,
		210,
		198,
		187,
		190,
		182,
		204,
		204,
		188,
		189,
		193,
		-1,
		337,
		324,
		282,
		278,
		267,
		287,
		238,
		226,
		258,
		-1,
		-1,
		300,
		-1,
		234,
		251,
		242,
		240,
		233,
		215,
		222,
		230,
		207,
		202,
		192,
		181,
		181,
		176,
		198,
		184,
		182,
		191,
		207,
		-1,
		-1,
		-1,
		304,
		-1,
		-1,
		253,
		240,
		234,
		-1,
		275,
		-1,
		278,
		268,
		252,
		237,
		270,
		-1,
		214,
		210,
		217,
		-1,
		227,
		-1,
		200,
		197,
		188,
		173,
		170,
		181,
		179,
		190,
		186,
		-1,
		287,
		272,
		265,
		255,
		269,
		240,
		-1,
		293,
		-1,
		-1,
		265,
		259,
		259,
		243,
		244,
		230,
		210,
		202,
		217,
		216,
		203,
		202,
		186,
		179,
		176,
		169,
		182,
		192,
		197,
		184,
		-1,
		-1,
		-1,
		292,
		278,
		282,
		242,
		259,
		-1,
		-1,
		327,
		282,
		268,
		-1,
		239,
		230,
		218,
		208,
		198,
		203,
		204,
		194,
		192,
		184,
		186,
		180,
		171,
		170,
		186,
		178,
		200,
		-1,
		-1,
		275,
		280,
		268,
		237,
		232,
		-1,
		-1,
		-1,
		274,
		290,
		258,
		237,
		219,
		-1,
		-1,
		202,
		195,
		189,
		192,
		180,
		200,
		195,
		179,
		164,
		179,
		183,
		191,
		182,
		-1,
		278,
		265,
		-1,
		-1,
		231,
		221,
		-1,
		-1,
		-1,
		-1,
		270,
		215,
		204,
		199,
		203,
		201,
		-1,
		175,
		186,
		179,
		198,
		205,
		181,
		166,
		160,
		166,
		178,
		187,
		-1,
		-1,
		245,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		227,
		221,
		192,
		185,
		189,
		-1,
		177,
		179,
		176,
		188,
		184,
		181,
		172,
		163,
		159,
		163,
		167,
		181,
		185,
		268,
		-1,
		198,
		-1,
		-1,
		-1,
		244,
		260,
		231,
		208,
		181,
		176,
		169,
		163,
		168,
		179,
		188,
		199,
		164,
		166,
		156,
		155,
		159,
		176,
		180,
		-1,
		-1,
		196,
		192,
		227,
		239,
		239,
		258,
		-1,
		-1,
		185,
		176,
		167,
		159,
		172,
		175,
		160,
		162,
		162,
		160,
		154,
		164,
		179,
		174,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		229,
		256,
		203,
		185,
		181,
		179,
		168,
		162,
		150,
		155,
		165,
		159,
		156,
		150,
		154,
		177,
		166,
		205,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		215,
		179,
		174,
		208,
		213,
		204,
		218,
		215,
		-1,
		185,
		191,
		156,
		163,
		146,
		153,
		158,
		155,
		144,
		151,
		167,
		166,
		161,
		197,
		188,
		194,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		208,
		176,
		194,
		184,
		190,
		-1,
		-1,
		210,
		207,
		187,
		156,
		154,
		147,
		142,
		152,
		128,
		140,
		144,
		148,
		154,
		159,
		164,
		170,
		185,
		200,
		-1,
		240,
		277,
		270,
		238,
		246,
		277,
		-1,
		198,
		190,
		173,
		176,
		184,
		-1,
		-1,
		183,
		174,
		175,
		163,
		160,
		166,
		165,
		148,
		154,
		155,
		147,
		146,
		164,
		168,
		177,
		184,
		174,
		187,
		191,
		-1,
		233,
		253,
		232,
		235,
		259,
		273,
		-1,
		195,
		-1,
		-1,
		133,
		197,
		192,
		182,
		179,
		222,
		177,
		172,
		153,
		151,
		146,
		137,
		162,
		155,
		155,
		158,
		173,
		178,
		170,
		184,
		184,
		185,
		-1,
		222,
		233,
		226,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		123,
		-1,
		219,
		-1,
		202,
		206,
		185,
		188,
		167,
		154,
		140,
		148,
		154,
		153,
		159,
		159,
		160,
		169,
		180,
		192,
		191,
		192,
		247,
		203,
		206,
		217,
		228,
		243,
		247,
		-1,
		207,
		246,
		129,
		-1,
		113,
		-1,
		-1,
		-1,
		216,
		198,
		190,
		187,
		166,
		166,
		132,
		136,
		149,
		156,
		166,
		177,
		169,
		173,
		186,
		197,
		200,
		243,
		234,
		247,
		192,
		192,
		213,
		222,
		243,
		207,
		204,
		240,
		136,
		125,
		120,
		107,
		-1,
		-1,
		200,
		208,
		-1,
		-1,
		173,
		140,
		128,
		138,
		142,
		156,
		168,
		181,
		169,
		174,
		168,
		200,
		-1,
		236,
		235,
		224,
		221,
		197,
		188,
		183,
		210,
		-1,
		-1,
		205,
		232,
		192,
		169,
		167,
		192,
		-1,
		91,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		145,
		134,
		125,
		130,
		150,
		161,
		183,
		165,
		182,
		173,
		183,
		187,
		220,
		217,
		205,
		203,
		226,
		191,
		179,
		-1,
		187,
		190,
		196,
		190,
		170,
		181,
		-1,
		-1,
		107,
		87,
		-1,
		-1,
		163,
		161,
		150,
		-1,
		140,
		122,
		127,
		157,
		159,
		161,
		168,
		162,
		169,
		177,
		188,
		180,
		229,
		243,
		232,
		228,
		227,
		235,
		184,
		177,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		-1,
		93,
		93,
		-1,
		-1,
		158,
		151,
		139,
		127,
		117,
		127,
		144,
		144,
		147,
		152,
		160,
		171,
		167,
		171,
		174,
		-1,
		263,
		-1,
		215,
		176,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		110,
		96,
		89,
		77,
		75,
		-1,
		192,
		176,
		157,
		-1,
		127,
		140,
		180,
		148,
		153,
		148,
		163,
		174,
		165,
		173,
		167,
		170,
		-1,
		-1,
		175,
		158,
		-1,
		-1,
		132,
		134,
		-1,
		101,
		90,
		75,
		67,
		-1,
		-1,
		164,
		160,
		-1,
		-1,
		114,
		152,
		151,
		159,
		154,
		159,
		171,
		167,
		163,
		173,
		164,
		-1,
		-1,
		153,
		145,
		139,
		-1,
		117,
		-1,
		0,
		-1,
		70,
		86,
		88,
		-1,
		-1,
		-1,
		145,
		108,
		124,
		147,
		173,
		171,
		162,
		155,
		162,
		165,
		158,
		164,
		-1,
		-1,
		-1,
		135,
		109,
		7,
		2,
		20,
		39,
		49,
		103,
		-1,
		126,
		-1,
		101,
		104,
		129,
		168,
		170,
		156,
		152,
		165,
		159,
		156,
		154,
		141,
		-1,
		111,
		144,
		108,
		33,
		76,
		81,
		140,
		-1,
		123,
		105,
		-1,
		133,
		123,
		171,
		146,
		155,
		148,
		142,
		143,
		151,
		-1,
		-1,
		-1,
		113,
		112,
		104,
		98,
		96,
		81,
		76,
		-1,
		128,
		110,
		96,
		113,
		113,
		104,
		112,
		161,
		157,
		160,
		158,
		136,
		-1,
		227,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		107,
		116,
		89,
		77,
		91,
		98,
		93,
		95,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		135,
		167,
		-1,
		222,
		-1,
		143,
		-1,
		-1,
		123,
		109,
		111,
		100,
		89,
		87,
		90,
		88,
		110,
		140,
		126,
		124,
		129,
		134,
		-1,
		211,
		210,
		-1,
		142,
		134,
		120,
		-1,
		113,
		-1,
		135,
		96,
		-1,
		117,
		97,
		-1,
		135,
		131,
		-1,
		-1,
		198,
		158,
		-1,
		-1,
		-1,
		143,
		123,
		130,
		114,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		183,
		167,
		-1,
		136,
		139,
		-1,
		130,
		136,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		192,
		173,
		167,
		151,
		156,
		144,
		161,
		147,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		164,
		156,
		156,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		175,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		196,
		197,
		221,
		196,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		199,
		197,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		280,
		269,
		280,
		288,
		261,
		268,
		-1,
		287,
		291,
		257,
		251,
		290,
		259,
		265,
		276,
		-1,
		-1,
		-1,
		280,
		279,
		247,
		245,
		254,
		259,
		266,
		-1,
		265,
		-1,
		301,
		280,
		291,
		296,
		240,
		237,
		257,
		276,
		258,
		250,
		316,
		270,
		241,
		235,
		253,
		243,
		252,
		244,
		-1,
		241,
		231,
		253,
		232,
		243,
		235,
		-1,
		-1,
		235,
		236,
		242,
		228,
		234,
		230,
		-1,
		240,
		224,
		-1,
		-1,
		225,
		226,
		210,
		213,
		221,
		219,
		232,
		224,
		219,
		-1,
		-1,
		216,
		212,
		219,
		206,
		202,
		219,
		232,
		214,
		228,
		227,
		-1,
		220,
		238,
		245,
		213,
		211,
		195,
		193,
		211,
		213,
		219,
		219,
		-1,
		229,
		230,
		225,
		233,
		235,
		211,
		198,
		198,
		208,
		201,
		220,
		208,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		229,
		212,
		229,
		221,
		211,
		226,
		219,
		201,
		198,
		196,
		193,
		209,
		207,
		217,
		-1,
		-1,
		322,
		291,
		320,
		278,
		259,
		-1,
		225,
		205,
		211,
		215,
		209,
		202,
		216,
		212,
		-1,
		187,
		186,
		214,
		200,
		211,
		282,
		-1,
		-1,
		280,
		272,
		255,
		258,
		235,
		231,
		220,
		219,
		211,
		197,
		193,
		199,
		202,
		202,
		208,
		181,
		191,
		195,
		193,
		218,
		-1,
		-1,
		253,
		-1,
		-1,
		279,
		262,
		-1,
		245,
		252,
		241,
		247,
		233,
		254,
		230,
		221,
		213,
		207,
		195,
		197,
		194,
		207,
		195,
		178,
		203,
		207,
		188,
		209,
		204,
		-1,
		252,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		238,
		241,
		247,
		271,
		270,
		-1,
		242,
		230,
		231,
		216,
		213,
		200,
		188,
		201,
		186,
		193,
		192,
		182,
		180,
		210,
		185,
		207,
		204,
		223,
		228,
		222,
		231,
		-1,
		287,
		283,
		279,
		286,
		235,
		-1,
		-1,
		275,
		-1,
		278,
		279,
		254,
		227,
		230,
		217,
		208,
		195,
		184,
		195,
		184,
		181,
		189,
		174,
		189,
		180,
		179,
		197,
		207,
		215,
		219,
		225,
		-1,
		337,
		-1,
		279,
		263,
		265,
		237,
		258,
		-1,
		295,
		279,
		271,
		256,
		256,
		-1,
		226,
		223,
		213,
		191,
		176,
		193,
		185,
		183,
		187,
		169,
		183,
		174,
		192,
		199,
		197,
		201,
		221,
		233,
		297,
		287,
		-1,
		269,
		274,
		233,
		241,
		260,
		298,
		262,
		-1,
		257,
		-1,
		228,
		241,
		-1,
		197,
		193,
		175,
		176,
		171,
		186,
		180,
		165,
		162,
		180,
		183,
		190,
		194,
		210,
		-1,
		-1,
		282,
		286,
		275,
		226,
		245,
		269,
		306,
		255,
		244,
		243,
		-1,
		234,
		211,
		208,
		196,
		183,
		168,
		169,
		177,
		190,
		169,
		164,
		161,
		181,
		207,
		185,
		197,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		252,
		223,
		247,
		289,
		273,
		266,
		254,
		219,
		219,
		213,
		-1,
		207,
		186,
		177,
		166,
		164,
		177,
		174,
		179,
		159,
		157,
		176,
		188,
		179,
		196,
		-1,
		-1,
		-1,
		282,
		271,
		272,
		218,
		241,
		278,
		252,
		238,
		243,
		218,
		211,
		205,
		220,
		203,
		184,
		173,
		165,
		154,
		170,
		178,
		173,
		155,
		164,
		170,
		194,
		184,
		190,
		-1,
		-1,
		289,
		279,
		263,
		265,
		262,
		232,
		239,
		271,
		243,
		256,
		-1,
		210,
		-1,
		199,
		194,
		178,
		173,
		170,
		167,
		161,
		170,
		172,
		162,
		157,
		164,
		199,
		199,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		282,
		277,
		252,
		229,
		213,
		249,
		-1,
		226,
		227,
		-1,
		204,
		198,
		195,
		180,
		176,
		171,
		175,
		168,
		175,
		168,
		166,
		167,
		149,
		181,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		275,
		254,
		247,
		267,
		208,
		260,
		-1,
		-1,
		211,
		204,
		-1,
		191,
		173,
		180,
		178,
		172,
		176,
		173,
		162,
		175,
		168,
		154,
		156,
		169,
		173,
		177,
		164,
		160,
		157,
		171,
		-1,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		228,
		-1,
		220,
		212,
		202,
		196,
		190,
		186,
		184,
		200,
		184,
		187,
		185,
		176,
		184,
		157,
		150,
		157,
		146,
		164,
		172,
		164,
		158,
		157,
		167,
		-1,
		295,
		281,
		252,
		-1,
		-1,
		241,
		-1,
		205,
		219,
		235,
		-1,
		228,
		207,
		222,
		200,
		196,
		192,
		207,
		208,
		185,
		185,
		183,
		174,
		162,
		151,
		154,
		146,
		168,
		168,
		152,
		153,
		157,
		-1,
		301,
		288,
		246,
		242,
		231,
		251,
		202,
		190,
		222,
		-1,
		-1,
		264,
		-1,
		198,
		215,
		206,
		204,
		197,
		179,
		186,
		194,
		171,
		166,
		156,
		145,
		145,
		140,
		162,
		148,
		146,
		155,
		171,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		217,
		204,
		198,
		-1,
		239,
		-1,
		242,
		232,
		216,
		201,
		234,
		-1,
		178,
		174,
		181,
		-1,
		191,
		-1,
		164,
		161,
		152,
		137,
		134,
		145,
		143,
		154,
		150,
		-1,
		251,
		236,
		229,
		219,
		233,
		203,
		-1,
		237,
		-1,
		-1,
		229,
		223,
		223,
		207,
		208,
		194,
		174,
		166,
		181,
		180,
		167,
		166,
		150,
		143,
		140,
		133,
		146,
		156,
		161,
		148,
		-1,
		-1,
		-1,
		256,
		233,
		227,
		199,
		203,
		-1,
		-1,
		291,
		246,
		232,
		-1,
		203,
		194,
		182,
		172,
		162,
		167,
		168,
		158,
		156,
		148,
		150,
		144,
		135,
		134,
		150,
		142,
		164,
		-1,
		-1,
		232,
		225,
		213,
		181,
		176,
		-1,
		-1,
		-1,
		238,
		254,
		222,
		201,
		183,
		-1,
		-1,
		166,
		159,
		153,
		156,
		144,
		164,
		159,
		143,
		128,
		143,
		147,
		155,
		146,
		-1,
		235,
		222,
		-1,
		-1,
		175,
		165,
		-1,
		-1,
		-1,
		-1,
		234,
		179,
		168,
		163,
		167,
		165,
		-1,
		139,
		150,
		143,
		162,
		169,
		145,
		130,
		124,
		130,
		142,
		151,
		-1,
		-1,
		189,
		-1,
		151,
		-1,
		-1,
		-1,
		-1,
		191,
		185,
		156,
		149,
		153,
		-1,
		141,
		143,
		140,
		152,
		148,
		145,
		136,
		127,
		123,
		127,
		131,
		145,
		149,
		212,
		-1,
		142,
		-1,
		-1,
		-1,
		188,
		210,
		195,
		172,
		145,
		140,
		133,
		127,
		132,
		143,
		152,
		163,
		128,
		130,
		120,
		119,
		123,
		140,
		144,
		-1,
		-1,
		140,
		136,
		171,
		183,
		183,
		222,
		-1,
		-1,
		149,
		140,
		131,
		123,
		136,
		139,
		124,
		126,
		126,
		124,
		118,
		128,
		143,
		138,
		-1,
		-1,
		-1,
		152,
		-1,
		154,
		-1,
		-1,
		173,
		220,
		167,
		149,
		145,
		143,
		132,
		126,
		114,
		119,
		129,
		123,
		120,
		114,
		118,
		141,
		130,
		169,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		159,
		123,
		118,
		152,
		157,
		148,
		182,
		179,
		-1,
		149,
		155,
		120,
		127,
		110,
		117,
		122,
		119,
		108,
		115,
		131,
		130,
		125,
		161,
		152,
		158,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		152,
		120,
		138,
		128,
		134,
		-1,
		-1,
		174,
		171,
		151,
		120,
		118,
		111,
		106,
		116,
		92,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		142,
		134,
		117,
		120,
		128,
		-1,
		-1,
		147,
		138,
		139,
		127,
		124,
		130,
		129,
		112,
		118,
		119,
		111,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		139,
		-1,
		-1,
		77,
		141,
		149,
		145,
		143,
		186,
		141,
		136,
		117,
		115,
		110,
		101,
		126,
		119,
		119,
		122,
		137,
		142,
		134,
		148,
		148,
		149,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		-1,
		67,
		-1,
		175,
		-1,
		166,
		170,
		149,
		152,
		131,
		118,
		104,
		112,
		118,
		117,
		123,
		123,
		124,
		133,
		144,
		156,
		155,
		156,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		151,
		190,
		73,
		-1,
		57,
		-1,
		-1,
		-1,
		180,
		162,
		154,
		151,
		130,
		130,
		96,
		100,
		113,
		120,
		130,
		141,
		133,
		137,
		150,
		161,
		164,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		156,
		157,
		184,
		80,
		69,
		64,
		51,
		-1,
		-1,
		164,
		172,
		-1,
		-1,
		137,
		104,
		92,
		102,
		106,
		120,
		132,
		145,
		133,
		138,
		132,
		164,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		154,
		185,
		136,
		113,
		111,
		136,
		-1,
		35,
		-1,
		-1,
		144,
		-1,
		-1,
		129,
		109,
		98,
		89,
		94,
		114,
		125,
		147,
		129,
		146,
		137,
		147,
		151,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		151,
		151,
		147,
		134,
		114,
		125,
		-1,
		-1,
		51,
		31,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		86,
		91,
		121,
		123,
		125,
		132,
		126,
		133,
		141,
		152,
		144,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		38,
		-1,
		33,
		37,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		108,
		108,
		111,
		116,
		124,
		135,
		131,
		135,
		138,
		-1,
		227,
		-1,
		179,
		140,
		146,
		161,
		169,
		-1,
		-1,
		-1,
		52,
		26,
		19,
		17,
		19,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		144,
		112,
		117,
		112,
		127,
		138,
		129,
		137,
		131,
		134,
		-1,
		-1,
		139,
		122,
		-1,
		-1,
		96,
		98,
		-1,
		43,
		32,
		5,
		11,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		78,
		116,
		115,
		123,
		118,
		123,
		135,
		131,
		127,
		137,
		128,
		-1,
		-1,
		117,
		109,
		103,
		-1,
		81,
		-1,
		69,
		-1,
		0,
		30,
		32,
		-1,
		-1,
		-1,
		109,
		72,
		88,
		111,
		137,
		135,
		126,
		119,
		126,
		129,
		122,
		128,
		-1,
		-1,
		-1,
		99,
		73,
		76,
		67,
		50,
		30,
		26,
		47,
		-1,
		90,
		-1,
		65,
		68,
		93,
		132,
		134,
		120,
		116,
		129,
		123,
		120,
		118,
		105,
		-1,
		75,
		108,
		72,
		36,
		40,
		35,
		104,
		-1,
		87,
		69,
		-1,
		97,
		87,
		135,
		110,
		119,
		112,
		106,
		107,
		115,
		-1,
		-1,
		-1,
		77,
		76,
		68,
		62,
		60,
		45,
		40,
		-1,
		92,
		74,
		60,
		77,
		77,
		68,
		76,
		125,
		121,
		124,
		122,
		100,
		-1,
		191,
		-1,
		-1,
		100,
		-1,
		-1,
		-1,
		71,
		80,
		53,
		41,
		55,
		62,
		57,
		59,
		72,
		80,
		78,
		75,
		87,
		83,
		103,
		99,
		131,
		-1,
		186,
		-1,
		107,
		-1,
		-1,
		87,
		73,
		75,
		64,
		53,
		51,
		54,
		52,
		74,
		104,
		90,
		88,
		93,
		98,
		-1,
		175,
		174,
		-1,
		106,
		98,
		84,
		-1,
		77,
		-1,
		99,
		60,
		-1,
		81,
		61,
		-1,
		99,
		95,
		-1,
		-1,
		162,
		122,
		-1,
		-1,
		-1,
		107,
		87,
		94,
		78,
		-1,
		72,
		72,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		100,
		103,
		-1,
		94,
		100,
		127,
		74,
		78,
		-1,
		-1,
		-1,
		156,
		137,
		131,
		115,
		120,
		108,
		125,
		111,
		110,
		88,
		77,
		98,
		-1,
		-1,
		-1,
		128,
		120,
		120,
		-1,
		-1,
		135,
		118,
		99,
		97,
		-1,
		-1,
		-1,
		150,
		131,
		-1,
		-1,
		125,
		-1,
		-1,
		131,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		139,
		-1,
		-1,
		-1,
		121,
		117,
		118,
		-1,
		-1,
		-1,
		-1,
		160,
		161,
		185,
		160,
		-1,
		-1,
		-1,
		113,
		107,
		-1,
		-1,
		163,
		161,
		-1,
		-1,
		-1,
		141,
		125,
		-1,
		111,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		146,
		-1,
		146,
		121,
		128,
		-1,
		-1,
		-1,
		-1,
		159,
		151,
		159,
		-1,
		131,
		133,
		-1,
		181,
		-1,
		-1,
		174,
		165,
		-1,
		-1,
		136,
		143,
		165,
		168,
		204,
		-1,
		155
	],
	[
		-1,
		283,
		272,
		283,
		291,
		264,
		271,
		-1,
		290,
		294,
		260,
		254,
		293,
		262,
		268,
		279,
		-1,
		-1,
		-1,
		283,
		282,
		250,
		248,
		257,
		262,
		269,
		-1,
		268,
		-1,
		304,
		283,
		294,
		299,
		243,
		240,
		260,
		279,
		261,
		253,
		319,
		273,
		244,
		238,
		256,
		246,
		255,
		247,
		-1,
		244,
		234,
		256,
		235,
		246,
		238,
		-1,
		-1,
		238,
		239,
		245,
		231,
		237,
		233,
		-1,
		243,
		227,
		-1,
		-1,
		228,
		229,
		213,
		216,
		224,
		222,
		235,
		227,
		222,
		-1,
		-1,
		219,
		215,
		222,
		209,
		205,
		222,
		235,
		217,
		231,
		230,
		-1,
		223,
		241,
		248,
		216,
		214,
		198,
		196,
		214,
		216,
		222,
		222,
		-1,
		232,
		233,
		228,
		236,
		238,
		214,
		201,
		201,
		211,
		204,
		223,
		211,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		232,
		215,
		232,
		224,
		214,
		229,
		222,
		204,
		201,
		199,
		196,
		212,
		210,
		220,
		-1,
		-1,
		325,
		294,
		323,
		281,
		262,
		-1,
		228,
		208,
		214,
		218,
		212,
		205,
		219,
		215,
		-1,
		190,
		189,
		217,
		203,
		214,
		285,
		-1,
		-1,
		283,
		275,
		258,
		261,
		238,
		234,
		223,
		222,
		214,
		200,
		196,
		202,
		205,
		205,
		211,
		184,
		194,
		198,
		196,
		221,
		-1,
		-1,
		256,
		-1,
		-1,
		282,
		265,
		-1,
		248,
		255,
		244,
		250,
		236,
		257,
		233,
		224,
		216,
		210,
		198,
		200,
		197,
		210,
		198,
		181,
		206,
		210,
		191,
		212,
		207,
		-1,
		255,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		241,
		244,
		250,
		274,
		273,
		-1,
		245,
		233,
		234,
		219,
		216,
		203,
		191,
		204,
		189,
		196,
		195,
		185,
		183,
		213,
		188,
		210,
		207,
		226,
		231,
		225,
		234,
		-1,
		290,
		286,
		282,
		289,
		238,
		-1,
		-1,
		278,
		-1,
		281,
		282,
		257,
		230,
		233,
		220,
		211,
		198,
		187,
		198,
		187,
		184,
		192,
		177,
		192,
		183,
		182,
		200,
		210,
		218,
		222,
		228,
		-1,
		340,
		-1,
		282,
		266,
		268,
		240,
		261,
		-1,
		298,
		282,
		274,
		259,
		259,
		-1,
		229,
		226,
		216,
		194,
		179,
		196,
		188,
		186,
		190,
		172,
		186,
		177,
		195,
		202,
		200,
		204,
		224,
		236,
		300,
		290,
		-1,
		272,
		277,
		236,
		244,
		263,
		301,
		265,
		-1,
		260,
		-1,
		231,
		244,
		-1,
		200,
		196,
		178,
		179,
		174,
		189,
		183,
		168,
		165,
		183,
		186,
		193,
		197,
		213,
		-1,
		-1,
		285,
		289,
		278,
		229,
		248,
		272,
		309,
		258,
		247,
		246,
		-1,
		237,
		214,
		211,
		199,
		186,
		171,
		172,
		180,
		193,
		172,
		167,
		164,
		184,
		210,
		188,
		200,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		255,
		226,
		250,
		292,
		276,
		269,
		257,
		222,
		222,
		216,
		-1,
		210,
		189,
		180,
		169,
		167,
		180,
		177,
		182,
		162,
		160,
		179,
		191,
		182,
		199,
		-1,
		-1,
		-1,
		285,
		274,
		275,
		221,
		244,
		281,
		255,
		241,
		246,
		221,
		214,
		208,
		223,
		206,
		187,
		176,
		168,
		157,
		173,
		181,
		176,
		158,
		167,
		173,
		197,
		187,
		193,
		-1,
		-1,
		292,
		282,
		266,
		268,
		265,
		235,
		242,
		274,
		246,
		259,
		-1,
		213,
		-1,
		202,
		197,
		181,
		176,
		173,
		170,
		164,
		173,
		175,
		165,
		160,
		167,
		202,
		202,
		177,
		197,
		200,
		-1,
		-1,
		-1,
		285,
		280,
		255,
		232,
		216,
		252,
		-1,
		229,
		230,
		-1,
		207,
		201,
		198,
		183,
		179,
		174,
		178,
		171,
		178,
		171,
		169,
		170,
		152,
		184,
		-1,
		185,
		179,
		187,
		177,
		165,
		-1,
		-1,
		-1,
		278,
		257,
		250,
		270,
		211,
		263,
		-1,
		-1,
		214,
		207,
		-1,
		194,
		176,
		183,
		181,
		175,
		179,
		176,
		165,
		178,
		171,
		157,
		159,
		172,
		176,
		180,
		167,
		163,
		160,
		174,
		-1,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		231,
		-1,
		223,
		215,
		205,
		199,
		193,
		189,
		187,
		203,
		187,
		190,
		188,
		179,
		187,
		160,
		153,
		160,
		149,
		167,
		175,
		167,
		161,
		160,
		170,
		-1,
		298,
		284,
		255,
		-1,
		-1,
		244,
		-1,
		208,
		222,
		238,
		-1,
		231,
		210,
		225,
		203,
		199,
		195,
		210,
		211,
		188,
		188,
		186,
		177,
		165,
		154,
		157,
		149,
		171,
		171,
		155,
		156,
		160,
		-1,
		304,
		291,
		249,
		245,
		234,
		254,
		205,
		193,
		225,
		-1,
		-1,
		267,
		-1,
		201,
		218,
		209,
		207,
		200,
		182,
		189,
		197,
		174,
		169,
		159,
		148,
		148,
		143,
		165,
		151,
		149,
		158,
		174,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		220,
		207,
		201,
		-1,
		242,
		-1,
		245,
		235,
		219,
		204,
		237,
		-1,
		181,
		177,
		184,
		-1,
		194,
		-1,
		167,
		164,
		155,
		140,
		137,
		148,
		146,
		157,
		153,
		-1,
		254,
		239,
		232,
		222,
		236,
		207,
		-1,
		247,
		-1,
		-1,
		232,
		226,
		226,
		210,
		211,
		197,
		177,
		169,
		184,
		183,
		170,
		169,
		153,
		146,
		143,
		136,
		149,
		159,
		164,
		151,
		-1,
		-1,
		-1,
		259,
		243,
		237,
		209,
		213,
		-1,
		-1,
		294,
		249,
		235,
		-1,
		206,
		197,
		185,
		175,
		165,
		170,
		171,
		161,
		159,
		151,
		153,
		147,
		138,
		137,
		153,
		145,
		167,
		-1,
		-1,
		242,
		235,
		223,
		191,
		186,
		-1,
		-1,
		-1,
		241,
		257,
		225,
		204,
		186,
		-1,
		-1,
		169,
		162,
		156,
		159,
		147,
		167,
		162,
		146,
		131,
		146,
		150,
		158,
		149,
		-1,
		245,
		232,
		-1,
		-1,
		185,
		175,
		-1,
		-1,
		-1,
		-1,
		237,
		182,
		171,
		166,
		170,
		168,
		-1,
		142,
		153,
		146,
		165,
		172,
		148,
		133,
		127,
		133,
		145,
		154,
		-1,
		-1,
		199,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		194,
		188,
		159,
		152,
		156,
		-1,
		144,
		146,
		143,
		155,
		151,
		148,
		139,
		130,
		126,
		130,
		134,
		148,
		152,
		222,
		-1,
		152,
		-1,
		-1,
		-1,
		198,
		220,
		198,
		175,
		148,
		143,
		136,
		130,
		135,
		146,
		155,
		166,
		131,
		133,
		123,
		122,
		126,
		143,
		147,
		-1,
		-1,
		150,
		146,
		181,
		193,
		193,
		225,
		-1,
		-1,
		152,
		143,
		134,
		126,
		139,
		142,
		127,
		129,
		129,
		127,
		121,
		131,
		146,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		183,
		223,
		170,
		152,
		148,
		146,
		135,
		129,
		117,
		122,
		132,
		126,
		123,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		169,
		133,
		128,
		162,
		167,
		158,
		185,
		182,
		-1,
		152,
		158,
		123,
		130,
		113,
		120,
		125,
		122,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		162,
		130,
		148,
		138,
		144,
		-1,
		-1,
		177,
		174,
		154,
		123,
		121,
		114,
		109,
		119,
		95,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		152,
		144,
		127,
		130,
		138,
		-1,
		-1,
		150,
		141,
		142,
		130,
		127,
		133,
		132,
		115,
		121,
		122,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		149,
		-1,
		-1,
		87,
		151,
		159,
		149,
		146,
		189,
		144,
		139,
		120,
		118,
		113,
		104,
		129,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		77,
		-1,
		185,
		-1,
		169,
		173,
		152,
		155,
		134,
		121,
		107,
		115,
		121,
		120,
		126,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		161,
		200,
		83,
		-1,
		67,
		-1,
		-1,
		-1,
		183,
		165,
		157,
		154,
		133,
		133,
		99,
		103,
		116,
		123,
		133,
		144,
		136,
		140,
		153,
		164,
		167,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		166,
		167,
		194,
		90,
		79,
		74,
		61,
		-1,
		-1,
		167,
		175,
		-1,
		-1,
		140,
		107,
		95,
		105,
		109,
		123,
		135,
		148,
		136,
		141,
		135,
		167,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		164,
		195,
		146,
		123,
		121,
		146,
		-1,
		45,
		-1,
		-1,
		147,
		-1,
		-1,
		132,
		112,
		101,
		92,
		97,
		117,
		128,
		150,
		132,
		149,
		140,
		150,
		154,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		158,
		161,
		157,
		144,
		124,
		135,
		-1,
		-1,
		61,
		41,
		-1,
		-1,
		130,
		128,
		117,
		-1,
		107,
		89,
		94,
		124,
		126,
		128,
		135,
		129,
		136,
		144,
		155,
		147,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		62,
		-1,
		47,
		47,
		-1,
		-1,
		125,
		118,
		106,
		94,
		84,
		94,
		111,
		111,
		114,
		119,
		127,
		138,
		134,
		138,
		141,
		-1,
		234,
		-1,
		186,
		147,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		64,
		50,
		43,
		31,
		29,
		-1,
		159,
		143,
		124,
		-1,
		94,
		107,
		147,
		115,
		120,
		115,
		130,
		141,
		132,
		140,
		134,
		137,
		-1,
		-1,
		146,
		129,
		-1,
		-1,
		103,
		105,
		-1,
		55,
		44,
		29,
		21,
		-1,
		-1,
		131,
		127,
		-1,
		-1,
		81,
		119,
		118,
		126,
		121,
		126,
		138,
		134,
		130,
		140,
		131,
		-1,
		-1,
		124,
		116,
		110,
		-1,
		88,
		-1,
		79,
		-1,
		24,
		0,
		22,
		-1,
		-1,
		-1,
		112,
		75,
		91,
		114,
		140,
		138,
		129,
		122,
		129,
		132,
		125,
		131,
		-1,
		-1,
		-1,
		106,
		80,
		86,
		77,
		60,
		40,
		36,
		37,
		-1,
		93,
		-1,
		68,
		71,
		96,
		135,
		137,
		123,
		119,
		132,
		126,
		123,
		121,
		112,
		-1,
		82,
		115,
		79,
		46,
		47,
		25,
		107,
		-1,
		90,
		72,
		-1,
		100,
		90,
		138,
		113,
		122,
		115,
		109,
		110,
		118,
		-1,
		-1,
		-1,
		84,
		83,
		75,
		69,
		63,
		50,
		39,
		-1,
		95,
		77,
		63,
		80,
		80,
		71,
		79,
		128,
		124,
		127,
		125,
		103,
		-1,
		198,
		-1,
		-1,
		107,
		-1,
		-1,
		-1,
		78,
		75,
		48,
		44,
		52,
		65,
		60,
		62,
		75,
		83,
		81,
		78,
		90,
		86,
		106,
		102,
		134,
		-1,
		193,
		-1,
		114,
		-1,
		-1,
		94,
		80,
		70,
		59,
		48,
		48,
		53,
		55,
		77,
		107,
		93,
		91,
		96,
		101,
		-1,
		182,
		181,
		-1,
		113,
		105,
		91,
		-1,
		84,
		-1,
		94,
		55,
		-1,
		84,
		64,
		-1,
		102,
		98,
		-1,
		-1,
		169,
		129,
		-1,
		-1,
		-1,
		114,
		94,
		89,
		73,
		-1,
		75,
		75,
		-1,
		-1,
		-1,
		154,
		138,
		-1,
		107,
		110,
		-1,
		101,
		107,
		130,
		77,
		81,
		-1,
		-1,
		-1,
		163,
		144,
		138,
		122,
		127,
		115,
		132,
		118,
		113,
		91,
		80,
		101,
		-1,
		-1,
		-1,
		135,
		127,
		127,
		-1,
		-1,
		138,
		121,
		102,
		100,
		-1,
		-1,
		-1,
		157,
		138,
		-1,
		-1,
		128,
		-1,
		-1,
		134,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		146,
		-1,
		-1,
		-1,
		124,
		120,
		121,
		-1,
		-1,
		-1,
		-1,
		167,
		168,
		192,
		167,
		-1,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		170,
		168,
		-1,
		-1,
		-1,
		144,
		128,
		-1,
		114,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		149,
		-1,
		149,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		162,
		154,
		162,
		-1,
		134,
		136,
		-1,
		184,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		139,
		146,
		168,
		171,
		207,
		-1,
		158
	],
	[
		-1,
		275,
		264,
		275,
		283,
		256,
		263,
		-1,
		282,
		286,
		252,
		246,
		285,
		254,
		260,
		271,
		-1,
		-1,
		-1,
		275,
		274,
		242,
		240,
		249,
		254,
		261,
		-1,
		260,
		-1,
		296,
		275,
		286,
		291,
		235,
		232,
		252,
		271,
		253,
		245,
		311,
		265,
		236,
		230,
		248,
		238,
		247,
		239,
		-1,
		236,
		226,
		248,
		227,
		238,
		230,
		-1,
		-1,
		230,
		231,
		237,
		223,
		229,
		225,
		-1,
		235,
		219,
		-1,
		-1,
		220,
		221,
		205,
		208,
		216,
		214,
		227,
		219,
		214,
		-1,
		-1,
		211,
		207,
		214,
		201,
		197,
		214,
		227,
		209,
		223,
		222,
		-1,
		215,
		233,
		240,
		208,
		206,
		190,
		188,
		206,
		208,
		214,
		214,
		-1,
		224,
		225,
		220,
		228,
		230,
		206,
		193,
		193,
		203,
		196,
		215,
		203,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		224,
		207,
		224,
		216,
		206,
		221,
		214,
		196,
		193,
		191,
		188,
		204,
		202,
		212,
		-1,
		-1,
		317,
		286,
		315,
		273,
		254,
		-1,
		220,
		200,
		206,
		210,
		204,
		197,
		211,
		207,
		-1,
		182,
		181,
		209,
		195,
		206,
		277,
		-1,
		-1,
		275,
		267,
		250,
		253,
		230,
		226,
		215,
		214,
		206,
		192,
		188,
		194,
		197,
		197,
		203,
		176,
		186,
		190,
		188,
		213,
		-1,
		-1,
		248,
		-1,
		-1,
		274,
		257,
		-1,
		240,
		247,
		236,
		242,
		228,
		249,
		225,
		216,
		208,
		202,
		190,
		192,
		189,
		202,
		190,
		173,
		198,
		202,
		183,
		204,
		199,
		-1,
		247,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		252,
		233,
		236,
		242,
		266,
		265,
		-1,
		237,
		225,
		226,
		211,
		208,
		195,
		183,
		196,
		181,
		188,
		187,
		177,
		175,
		205,
		180,
		202,
		199,
		218,
		223,
		217,
		226,
		-1,
		282,
		278,
		274,
		281,
		230,
		-1,
		-1,
		270,
		-1,
		273,
		274,
		249,
		222,
		225,
		212,
		203,
		190,
		179,
		190,
		179,
		176,
		184,
		169,
		184,
		175,
		174,
		192,
		202,
		210,
		214,
		220,
		-1,
		332,
		-1,
		274,
		258,
		260,
		232,
		253,
		-1,
		290,
		274,
		266,
		251,
		251,
		-1,
		221,
		218,
		208,
		186,
		171,
		188,
		180,
		178,
		182,
		164,
		178,
		169,
		187,
		194,
		192,
		196,
		216,
		228,
		292,
		282,
		-1,
		264,
		269,
		228,
		236,
		255,
		293,
		257,
		-1,
		252,
		-1,
		223,
		236,
		-1,
		192,
		188,
		170,
		171,
		166,
		181,
		175,
		160,
		157,
		175,
		178,
		185,
		189,
		205,
		-1,
		-1,
		277,
		281,
		270,
		221,
		240,
		264,
		301,
		250,
		239,
		238,
		-1,
		229,
		206,
		203,
		191,
		178,
		163,
		164,
		172,
		185,
		164,
		159,
		156,
		176,
		202,
		180,
		192,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		247,
		218,
		242,
		284,
		268,
		261,
		249,
		214,
		214,
		208,
		-1,
		202,
		181,
		172,
		161,
		159,
		172,
		169,
		174,
		154,
		152,
		171,
		183,
		174,
		191,
		-1,
		-1,
		-1,
		277,
		266,
		267,
		213,
		236,
		273,
		247,
		233,
		238,
		213,
		206,
		200,
		215,
		198,
		179,
		168,
		160,
		149,
		165,
		173,
		168,
		150,
		159,
		165,
		189,
		179,
		185,
		-1,
		-1,
		284,
		274,
		258,
		260,
		257,
		227,
		234,
		266,
		238,
		251,
		-1,
		205,
		-1,
		194,
		189,
		173,
		168,
		165,
		162,
		156,
		165,
		167,
		157,
		152,
		159,
		194,
		194,
		169,
		189,
		192,
		-1,
		-1,
		-1,
		277,
		272,
		247,
		224,
		208,
		244,
		-1,
		221,
		222,
		-1,
		199,
		193,
		190,
		175,
		171,
		166,
		170,
		163,
		170,
		163,
		161,
		162,
		144,
		176,
		-1,
		177,
		171,
		179,
		169,
		157,
		-1,
		-1,
		-1,
		270,
		249,
		242,
		262,
		203,
		255,
		-1,
		-1,
		206,
		199,
		-1,
		186,
		168,
		175,
		173,
		167,
		171,
		168,
		157,
		170,
		163,
		149,
		151,
		164,
		168,
		172,
		159,
		155,
		152,
		166,
		-1,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		223,
		-1,
		215,
		207,
		197,
		191,
		185,
		181,
		179,
		195,
		179,
		182,
		180,
		171,
		179,
		152,
		145,
		152,
		141,
		159,
		167,
		159,
		153,
		152,
		162,
		-1,
		290,
		276,
		247,
		-1,
		-1,
		236,
		-1,
		200,
		214,
		230,
		-1,
		223,
		202,
		217,
		195,
		191,
		187,
		202,
		203,
		180,
		180,
		178,
		169,
		157,
		146,
		149,
		141,
		163,
		163,
		147,
		148,
		152,
		-1,
		296,
		283,
		241,
		237,
		226,
		246,
		197,
		185,
		217,
		-1,
		-1,
		259,
		-1,
		193,
		210,
		201,
		199,
		192,
		174,
		181,
		189,
		166,
		161,
		151,
		140,
		140,
		135,
		157,
		143,
		141,
		150,
		166,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		212,
		199,
		193,
		-1,
		234,
		-1,
		237,
		227,
		211,
		196,
		229,
		-1,
		173,
		169,
		176,
		-1,
		186,
		-1,
		159,
		156,
		147,
		132,
		129,
		140,
		138,
		149,
		145,
		-1,
		246,
		231,
		224,
		214,
		228,
		199,
		-1,
		254,
		-1,
		-1,
		224,
		218,
		218,
		202,
		203,
		189,
		169,
		161,
		176,
		175,
		162,
		161,
		145,
		138,
		135,
		128,
		141,
		151,
		156,
		143,
		-1,
		-1,
		-1,
		251,
		237,
		241,
		201,
		220,
		-1,
		-1,
		286,
		241,
		227,
		-1,
		198,
		189,
		177,
		167,
		157,
		162,
		163,
		153,
		151,
		143,
		145,
		139,
		130,
		129,
		145,
		137,
		159,
		-1,
		-1,
		234,
		239,
		227,
		198,
		193,
		-1,
		-1,
		-1,
		233,
		249,
		217,
		196,
		178,
		-1,
		-1,
		161,
		154,
		148,
		151,
		139,
		159,
		154,
		138,
		123,
		138,
		142,
		150,
		141,
		-1,
		237,
		224,
		-1,
		-1,
		192,
		182,
		-1,
		-1,
		-1,
		-1,
		229,
		174,
		163,
		158,
		162,
		160,
		-1,
		134,
		145,
		138,
		157,
		164,
		140,
		125,
		119,
		125,
		137,
		146,
		-1,
		-1,
		206,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		186,
		180,
		151,
		144,
		148,
		-1,
		136,
		138,
		135,
		147,
		143,
		140,
		131,
		122,
		118,
		122,
		126,
		140,
		144,
		229,
		-1,
		159,
		-1,
		-1,
		-1,
		204,
		219,
		190,
		167,
		140,
		135,
		128,
		122,
		127,
		138,
		147,
		158,
		123,
		125,
		115,
		114,
		118,
		135,
		139,
		-1,
		-1,
		157,
		153,
		188,
		200,
		200,
		217,
		-1,
		-1,
		144,
		135,
		126,
		118,
		131,
		134,
		119,
		121,
		121,
		119,
		113,
		123,
		138,
		133,
		-1,
		-1,
		-1,
		169,
		-1,
		171,
		-1,
		-1,
		190,
		215,
		162,
		144,
		140,
		138,
		127,
		121,
		109,
		114,
		124,
		118,
		115,
		109,
		113,
		136,
		125,
		164,
		-1,
		-1,
		256,
		-1,
		-1,
		-1,
		176,
		140,
		135,
		169,
		174,
		165,
		177,
		174,
		-1,
		144,
		150,
		115,
		122,
		105,
		112,
		117,
		114,
		103,
		110,
		126,
		125,
		120,
		156,
		147,
		153,
		-1,
		-1,
		249,
		238,
		227,
		233,
		-1,
		169,
		137,
		155,
		145,
		151,
		-1,
		-1,
		169,
		166,
		146,
		115,
		113,
		106,
		101,
		111,
		87,
		99,
		103,
		107,
		113,
		118,
		123,
		129,
		144,
		159,
		-1,
		203,
		240,
		233,
		201,
		209,
		240,
		-1,
		159,
		151,
		134,
		137,
		145,
		-1,
		-1,
		142,
		133,
		134,
		122,
		119,
		125,
		124,
		107,
		113,
		114,
		106,
		105,
		123,
		127,
		136,
		143,
		133,
		146,
		150,
		-1,
		196,
		216,
		195,
		198,
		222,
		236,
		-1,
		156,
		-1,
		-1,
		94,
		158,
		151,
		141,
		138,
		181,
		136,
		131,
		112,
		110,
		105,
		96,
		121,
		114,
		114,
		117,
		132,
		137,
		129,
		143,
		143,
		144,
		-1,
		185,
		196,
		189,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		84,
		-1,
		178,
		-1,
		161,
		165,
		144,
		147,
		126,
		113,
		99,
		107,
		113,
		112,
		118,
		118,
		119,
		128,
		139,
		151,
		150,
		151,
		210,
		166,
		169,
		180,
		191,
		206,
		210,
		-1,
		168,
		207,
		90,
		-1,
		74,
		-1,
		-1,
		-1,
		175,
		157,
		149,
		146,
		125,
		125,
		91,
		95,
		108,
		115,
		125,
		136,
		128,
		132,
		145,
		156,
		159,
		206,
		197,
		210,
		155,
		155,
		176,
		185,
		206,
		170,
		167,
		201,
		97,
		86,
		81,
		68,
		-1,
		-1,
		159,
		167,
		-1,
		-1,
		132,
		99,
		87,
		97,
		101,
		115,
		127,
		140,
		128,
		133,
		127,
		159,
		-1,
		199,
		198,
		187,
		184,
		160,
		151,
		146,
		173,
		-1,
		-1,
		168,
		195,
		153,
		130,
		128,
		153,
		-1,
		52,
		-1,
		-1,
		139,
		-1,
		-1,
		124,
		104,
		93,
		84,
		89,
		109,
		120,
		142,
		124,
		141,
		132,
		142,
		146,
		183,
		180,
		168,
		166,
		189,
		154,
		142,
		-1,
		150,
		153,
		159,
		151,
		131,
		142,
		-1,
		-1,
		68,
		48,
		-1,
		-1,
		122,
		120,
		109,
		-1,
		99,
		81,
		86,
		116,
		118,
		120,
		127,
		121,
		128,
		136,
		147,
		139,
		192,
		206,
		195,
		191,
		190,
		198,
		147,
		140,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		-1,
		54,
		54,
		-1,
		-1,
		117,
		110,
		98,
		86,
		76,
		86,
		103,
		103,
		106,
		111,
		119,
		130,
		126,
		130,
		133,
		-1,
		226,
		-1,
		178,
		139,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		71,
		57,
		50,
		38,
		36,
		-1,
		151,
		135,
		116,
		-1,
		86,
		99,
		139,
		107,
		112,
		107,
		122,
		133,
		124,
		132,
		126,
		129,
		-1,
		-1,
		138,
		121,
		-1,
		-1,
		95,
		97,
		-1,
		62,
		51,
		36,
		28,
		-1,
		-1,
		123,
		119,
		-1,
		-1,
		73,
		111,
		110,
		118,
		113,
		118,
		130,
		126,
		122,
		132,
		123,
		-1,
		-1,
		116,
		108,
		102,
		-1,
		80,
		-1,
		86,
		-1,
		31,
		26,
		0,
		-1,
		-1,
		-1,
		104,
		67,
		83,
		106,
		132,
		130,
		121,
		114,
		121,
		124,
		117,
		123,
		-1,
		-1,
		-1,
		98,
		72,
		93,
		84,
		67,
		47,
		43,
		29,
		-1,
		85,
		-1,
		60,
		63,
		88,
		127,
		129,
		115,
		111,
		124,
		118,
		115,
		113,
		104,
		-1,
		74,
		107,
		71,
		53,
		39,
		17,
		99,
		-1,
		82,
		64,
		-1,
		92,
		82,
		130,
		105,
		114,
		107,
		101,
		102,
		110,
		-1,
		-1,
		-1,
		76,
		75,
		67,
		61,
		55,
		42,
		31,
		-1,
		87,
		69,
		55,
		72,
		72,
		63,
		71,
		120,
		116,
		119,
		117,
		95,
		-1,
		190,
		-1,
		-1,
		99,
		-1,
		-1,
		-1,
		70,
		67,
		40,
		36,
		44,
		57,
		52,
		54,
		67,
		75,
		73,
		70,
		82,
		78,
		98,
		94,
		126,
		-1,
		185,
		-1,
		106,
		-1,
		-1,
		86,
		72,
		62,
		51,
		40,
		40,
		45,
		47,
		69,
		99,
		85,
		83,
		88,
		93,
		-1,
		174,
		173,
		-1,
		105,
		97,
		83,
		-1,
		76,
		-1,
		86,
		47,
		-1,
		76,
		56,
		-1,
		94,
		90,
		-1,
		-1,
		161,
		121,
		-1,
		-1,
		-1,
		106,
		86,
		81,
		65,
		-1,
		67,
		67,
		-1,
		-1,
		-1,
		146,
		130,
		-1,
		99,
		102,
		-1,
		93,
		99,
		122,
		69,
		73,
		-1,
		-1,
		-1,
		155,
		136,
		130,
		114,
		119,
		107,
		124,
		110,
		105,
		83,
		72,
		93,
		-1,
		-1,
		-1,
		127,
		119,
		119,
		-1,
		-1,
		130,
		113,
		94,
		92,
		-1,
		-1,
		-1,
		149,
		130,
		-1,
		-1,
		120,
		-1,
		-1,
		126,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		138,
		-1,
		-1,
		-1,
		116,
		112,
		113,
		-1,
		-1,
		-1,
		-1,
		159,
		160,
		184,
		159,
		-1,
		-1,
		-1,
		108,
		102,
		-1,
		-1,
		162,
		160,
		-1,
		-1,
		-1,
		136,
		120,
		-1,
		106,
		-1,
		-1,
		-1,
		127,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		141,
		-1,
		141,
		116,
		123,
		-1,
		-1,
		-1,
		-1,
		154,
		146,
		154,
		-1,
		126,
		128,
		-1,
		176,
		-1,
		-1,
		169,
		160,
		-1,
		-1,
		131,
		138,
		160,
		163,
		199,
		-1,
		150
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		263,
		252,
		263,
		271,
		244,
		251,
		-1,
		270,
		274,
		240,
		234,
		273,
		242,
		248,
		259,
		-1,
		-1,
		-1,
		263,
		262,
		230,
		228,
		237,
		242,
		249,
		-1,
		248,
		-1,
		284,
		263,
		274,
		279,
		223,
		220,
		240,
		259,
		241,
		233,
		299,
		253,
		224,
		218,
		236,
		226,
		235,
		227,
		-1,
		224,
		214,
		236,
		215,
		226,
		218,
		-1,
		-1,
		218,
		219,
		225,
		211,
		217,
		213,
		-1,
		223,
		207,
		-1,
		-1,
		208,
		209,
		193,
		196,
		204,
		202,
		215,
		207,
		202,
		-1,
		-1,
		199,
		195,
		202,
		189,
		185,
		202,
		215,
		197,
		211,
		210,
		-1,
		203,
		221,
		228,
		196,
		194,
		178,
		176,
		194,
		196,
		202,
		202,
		-1,
		212,
		213,
		208,
		216,
		218,
		194,
		181,
		181,
		191,
		184,
		203,
		191,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		212,
		195,
		212,
		204,
		194,
		209,
		202,
		184,
		181,
		179,
		176,
		192,
		190,
		200,
		-1,
		-1,
		305,
		274,
		303,
		261,
		242,
		-1,
		208,
		188,
		194,
		198,
		192,
		185,
		199,
		195,
		-1,
		170,
		169,
		197,
		183,
		194,
		265,
		-1,
		-1,
		263,
		255,
		238,
		241,
		218,
		214,
		203,
		202,
		194,
		180,
		176,
		182,
		185,
		185,
		191,
		164,
		174,
		178,
		176,
		201,
		-1,
		-1,
		236,
		-1,
		-1,
		262,
		245,
		-1,
		228,
		235,
		224,
		230,
		216,
		237,
		213,
		204,
		196,
		190,
		178,
		180,
		177,
		190,
		178,
		161,
		186,
		190,
		171,
		192,
		187,
		-1,
		235,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		221,
		224,
		230,
		254,
		253,
		-1,
		225,
		213,
		214,
		199,
		196,
		183,
		171,
		184,
		169,
		176,
		175,
		165,
		163,
		193,
		168,
		190,
		187,
		206,
		211,
		205,
		214,
		-1,
		270,
		266,
		262,
		269,
		218,
		-1,
		-1,
		258,
		-1,
		261,
		262,
		237,
		210,
		213,
		200,
		191,
		178,
		167,
		178,
		167,
		164,
		172,
		157,
		172,
		163,
		162,
		180,
		190,
		198,
		202,
		208,
		-1,
		320,
		-1,
		262,
		246,
		248,
		220,
		241,
		-1,
		278,
		262,
		254,
		239,
		239,
		-1,
		209,
		206,
		196,
		174,
		159,
		176,
		168,
		166,
		170,
		152,
		166,
		157,
		175,
		182,
		180,
		184,
		204,
		216,
		280,
		270,
		-1,
		252,
		257,
		216,
		224,
		243,
		281,
		245,
		-1,
		240,
		-1,
		211,
		224,
		-1,
		180,
		176,
		158,
		159,
		154,
		169,
		163,
		148,
		145,
		163,
		166,
		173,
		177,
		193,
		-1,
		-1,
		265,
		269,
		258,
		209,
		228,
		252,
		289,
		238,
		227,
		226,
		-1,
		217,
		194,
		191,
		179,
		166,
		151,
		152,
		160,
		173,
		152,
		147,
		144,
		164,
		190,
		168,
		180,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		235,
		206,
		230,
		272,
		256,
		249,
		237,
		202,
		202,
		196,
		-1,
		190,
		169,
		160,
		149,
		147,
		160,
		157,
		162,
		142,
		140,
		159,
		171,
		162,
		179,
		-1,
		-1,
		-1,
		265,
		254,
		255,
		201,
		224,
		261,
		235,
		221,
		226,
		201,
		194,
		188,
		203,
		186,
		167,
		156,
		148,
		137,
		153,
		161,
		156,
		138,
		147,
		153,
		177,
		167,
		173,
		-1,
		-1,
		272,
		262,
		246,
		248,
		245,
		215,
		222,
		254,
		226,
		239,
		-1,
		193,
		-1,
		182,
		177,
		161,
		156,
		153,
		150,
		144,
		153,
		155,
		145,
		140,
		147,
		182,
		182,
		157,
		177,
		180,
		-1,
		-1,
		-1,
		265,
		260,
		235,
		212,
		196,
		232,
		-1,
		209,
		210,
		-1,
		187,
		181,
		178,
		163,
		159,
		154,
		158,
		151,
		158,
		151,
		149,
		150,
		132,
		164,
		-1,
		165,
		159,
		167,
		157,
		145,
		-1,
		-1,
		-1,
		258,
		237,
		230,
		250,
		191,
		243,
		-1,
		-1,
		194,
		187,
		-1,
		174,
		156,
		163,
		161,
		155,
		159,
		156,
		145,
		158,
		151,
		137,
		139,
		152,
		156,
		160,
		147,
		143,
		140,
		154,
		-1,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		211,
		-1,
		203,
		195,
		185,
		179,
		173,
		169,
		167,
		183,
		167,
		170,
		168,
		159,
		167,
		140,
		133,
		140,
		129,
		147,
		155,
		147,
		141,
		140,
		150,
		-1,
		278,
		264,
		235,
		-1,
		-1,
		224,
		-1,
		188,
		202,
		218,
		-1,
		211,
		190,
		205,
		183,
		179,
		175,
		190,
		191,
		169,
		168,
		166,
		157,
		145,
		134,
		137,
		129,
		151,
		151,
		135,
		136,
		140,
		-1,
		284,
		271,
		229,
		225,
		214,
		234,
		185,
		173,
		205,
		-1,
		-1,
		247,
		-1,
		181,
		198,
		189,
		187,
		180,
		165,
		172,
		177,
		154,
		149,
		139,
		128,
		128,
		123,
		145,
		131,
		129,
		138,
		154,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		200,
		187,
		181,
		-1,
		222,
		-1,
		225,
		215,
		199,
		184,
		217,
		-1,
		164,
		160,
		167,
		-1,
		174,
		-1,
		147,
		144,
		135,
		120,
		117,
		128,
		126,
		137,
		133,
		-1,
		234,
		219,
		212,
		202,
		216,
		187,
		-1,
		242,
		-1,
		-1,
		212,
		206,
		206,
		190,
		193,
		180,
		160,
		152,
		167,
		166,
		153,
		152,
		133,
		126,
		123,
		116,
		129,
		139,
		144,
		131,
		-1,
		-1,
		-1,
		239,
		225,
		229,
		189,
		208,
		-1,
		-1,
		274,
		229,
		215,
		-1,
		189,
		180,
		168,
		158,
		148,
		153,
		154,
		144,
		142,
		131,
		133,
		127,
		118,
		117,
		133,
		125,
		147,
		-1,
		-1,
		222,
		227,
		215,
		201,
		220,
		-1,
		-1,
		-1,
		221,
		237,
		208,
		187,
		169,
		-1,
		-1,
		152,
		145,
		139,
		142,
		130,
		147,
		142,
		126,
		111,
		126,
		130,
		138,
		129,
		-1,
		225,
		212,
		-1,
		-1,
		223,
		217,
		-1,
		-1,
		-1,
		-1,
		220,
		165,
		154,
		149,
		153,
		151,
		-1,
		125,
		136,
		129,
		148,
		155,
		128,
		113,
		107,
		113,
		125,
		134,
		-1,
		-1,
		237,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		177,
		171,
		142,
		135,
		139,
		-1,
		127,
		129,
		126,
		138,
		131,
		128,
		119,
		110,
		106,
		110,
		114,
		128,
		132,
		260,
		-1,
		198,
		-1,
		-1,
		-1,
		195,
		210,
		181,
		158,
		131,
		126,
		119,
		113,
		118,
		129,
		138,
		149,
		114,
		113,
		103,
		102,
		106,
		123,
		127,
		-1,
		-1,
		196,
		192,
		221,
		203,
		207,
		208,
		-1,
		-1,
		135,
		126,
		117,
		109,
		122,
		125,
		110,
		112,
		112,
		107,
		101,
		111,
		126,
		121,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		198,
		206,
		153,
		135,
		131,
		129,
		116,
		110,
		100,
		105,
		115,
		109,
		106,
		97,
		101,
		124,
		113,
		152,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		168,
		165,
		-1,
		135,
		139,
		106,
		113,
		96,
		103,
		108,
		105,
		91,
		98,
		114,
		113,
		108,
		144,
		135,
		141,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		153,
		150,
		130,
		99,
		104,
		97,
		92,
		97,
		78,
		87,
		91,
		95,
		101,
		106,
		111,
		117,
		132,
		147,
		-1,
		227,
		264,
		257,
		225,
		233,
		264,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		126,
		117,
		118,
		106,
		103,
		116,
		115,
		82,
		87,
		105,
		92,
		93,
		111,
		115,
		124,
		131,
		121,
		134,
		138,
		-1,
		220,
		240,
		219,
		222,
		246,
		260,
		-1,
		167,
		-1,
		-1,
		159,
		151,
		135,
		125,
		122,
		165,
		112,
		107,
		84,
		82,
		79,
		70,
		108,
		87,
		99,
		102,
		118,
		123,
		115,
		131,
		131,
		132,
		-1,
		209,
		220,
		213,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		149,
		-1,
		162,
		-1,
		145,
		149,
		120,
		123,
		98,
		85,
		71,
		79,
		85,
		85,
		90,
		93,
		105,
		114,
		125,
		137,
		138,
		139,
		234,
		190,
		193,
		204,
		215,
		230,
		234,
		-1,
		179,
		218,
		155,
		-1,
		139,
		-1,
		-1,
		-1,
		153,
		133,
		125,
		118,
		97,
		97,
		63,
		67,
		80,
		87,
		97,
		111,
		108,
		118,
		131,
		142,
		147,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		194,
		185,
		212,
		162,
		151,
		146,
		133,
		-1,
		-1,
		131,
		143,
		-1,
		-1,
		104,
		71,
		59,
		69,
		73,
		87,
		99,
		112,
		100,
		119,
		113,
		145,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		213,
		203,
		195,
		193,
		218,
		-1,
		122,
		-1,
		-1,
		111,
		-1,
		-1,
		96,
		76,
		65,
		56,
		61,
		81,
		92,
		114,
		96,
		113,
		118,
		128,
		141,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		196,
		207,
		-1,
		-1,
		138,
		118,
		-1,
		-1,
		94,
		92,
		81,
		-1,
		71,
		53,
		58,
		88,
		90,
		92,
		99,
		93,
		100,
		126,
		138,
		134,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		-1,
		128,
		124,
		-1,
		-1,
		89,
		82,
		70,
		58,
		48,
		58,
		75,
		75,
		78,
		83,
		91,
		102,
		116,
		120,
		128,
		-1,
		250,
		-1,
		202,
		178,
		185,
		200,
		208,
		-1,
		-1,
		-1,
		145,
		131,
		124,
		112,
		110,
		-1,
		123,
		107,
		88,
		-1,
		58,
		71,
		111,
		79,
		84,
		79,
		97,
		108,
		119,
		122,
		121,
		124,
		-1,
		-1,
		178,
		161,
		-1,
		-1,
		135,
		137,
		-1,
		136,
		125,
		110,
		102,
		-1,
		-1,
		95,
		91,
		-1,
		-1,
		43,
		93,
		82,
		90,
		85,
		97,
		107,
		105,
		117,
		125,
		118,
		-1,
		-1,
		156,
		148,
		142,
		-1,
		120,
		-1,
		138,
		-1,
		105,
		111,
		99,
		-1,
		-1,
		-1,
		0,
		37,
		62,
		100,
		105,
		103,
		94,
		93,
		100,
		110,
		112,
		118,
		-1,
		-1,
		-1,
		138,
		112,
		145,
		136,
		119,
		99,
		91,
		110,
		-1,
		77,
		-1,
		45,
		42,
		83,
		99,
		116,
		110,
		96,
		111,
		107,
		110,
		108,
		144,
		-1,
		114,
		147,
		111,
		105,
		81,
		85,
		101,
		-1,
		74,
		50,
		-1,
		87,
		77,
		125,
		100,
		107,
		94,
		96,
		97,
		105,
		-1,
		-1,
		-1,
		116,
		115,
		107,
		101,
		101,
		86,
		77,
		-1,
		89,
		71,
		50,
		67,
		67,
		58,
		66,
		115,
		111,
		112,
		112,
		90,
		-1,
		217,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		110,
		105,
		78,
		66,
		72,
		68,
		54,
		60,
		62,
		70,
		68,
		65,
		77,
		73,
		93,
		89,
		121,
		-1,
		212,
		-1,
		146,
		-1,
		-1,
		128,
		108,
		100,
		89,
		78,
		76,
		67,
		58,
		80,
		96,
		80,
		78,
		83,
		88,
		-1,
		201,
		200,
		-1,
		147,
		139,
		125,
		-1,
		118,
		-1,
		124,
		85,
		-1,
		87,
		67,
		-1,
		89,
		85,
		-1,
		-1,
		188,
		163,
		-1,
		-1,
		-1,
		148,
		128,
		119,
		103,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		173,
		172,
		-1,
		141,
		144,
		-1,
		134,
		125,
		133,
		80,
		84,
		-1,
		-1,
		-1,
		182,
		163,
		157,
		156,
		154,
		149,
		146,
		132,
		116,
		94,
		83,
		104,
		-1,
		-1,
		-1,
		154,
		146,
		139,
		-1,
		-1,
		141,
		124,
		105,
		103,
		-1,
		-1,
		-1,
		176,
		157,
		-1,
		-1,
		131,
		-1,
		-1,
		137,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		165,
		-1,
		-1,
		-1,
		127,
		123,
		124,
		-1,
		-1,
		-1,
		-1,
		187,
		188,
		211,
		175,
		-1,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		190,
		188,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		117,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		152,
		-1,
		152,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		165,
		-1,
		137,
		139,
		-1,
		187,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		142,
		149,
		171,
		174,
		210,
		-1,
		161
	],
	[
		-1,
		226,
		215,
		226,
		234,
		207,
		214,
		-1,
		233,
		237,
		203,
		197,
		236,
		205,
		211,
		222,
		-1,
		-1,
		-1,
		226,
		225,
		193,
		191,
		200,
		205,
		212,
		-1,
		211,
		-1,
		247,
		226,
		237,
		242,
		186,
		183,
		203,
		222,
		204,
		196,
		262,
		216,
		187,
		181,
		199,
		189,
		198,
		190,
		-1,
		187,
		177,
		199,
		178,
		189,
		181,
		-1,
		-1,
		181,
		182,
		188,
		174,
		180,
		176,
		-1,
		186,
		170,
		-1,
		-1,
		171,
		172,
		156,
		159,
		167,
		165,
		178,
		170,
		165,
		-1,
		-1,
		162,
		158,
		165,
		152,
		148,
		165,
		178,
		160,
		174,
		173,
		-1,
		166,
		184,
		191,
		159,
		157,
		141,
		139,
		157,
		159,
		165,
		165,
		-1,
		175,
		176,
		171,
		179,
		181,
		157,
		144,
		144,
		154,
		147,
		166,
		154,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		175,
		158,
		175,
		167,
		157,
		172,
		165,
		147,
		144,
		142,
		139,
		155,
		153,
		163,
		-1,
		-1,
		268,
		237,
		266,
		224,
		205,
		-1,
		171,
		151,
		157,
		161,
		155,
		148,
		162,
		158,
		-1,
		133,
		132,
		160,
		146,
		157,
		228,
		-1,
		-1,
		226,
		218,
		201,
		204,
		181,
		177,
		166,
		165,
		157,
		143,
		139,
		145,
		148,
		148,
		154,
		127,
		137,
		141,
		139,
		164,
		-1,
		-1,
		199,
		-1,
		-1,
		225,
		208,
		-1,
		191,
		198,
		187,
		193,
		179,
		200,
		176,
		167,
		159,
		153,
		141,
		143,
		140,
		153,
		141,
		124,
		149,
		153,
		134,
		155,
		150,
		-1,
		198,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		184,
		187,
		193,
		217,
		216,
		-1,
		188,
		176,
		177,
		162,
		159,
		146,
		134,
		147,
		132,
		139,
		138,
		128,
		126,
		156,
		131,
		153,
		150,
		169,
		174,
		168,
		177,
		-1,
		233,
		229,
		225,
		232,
		181,
		-1,
		-1,
		221,
		-1,
		224,
		225,
		200,
		173,
		176,
		163,
		154,
		141,
		130,
		141,
		130,
		127,
		135,
		120,
		135,
		126,
		125,
		143,
		153,
		161,
		165,
		171,
		-1,
		283,
		-1,
		225,
		209,
		211,
		183,
		204,
		-1,
		241,
		225,
		217,
		202,
		202,
		-1,
		172,
		169,
		159,
		137,
		122,
		139,
		131,
		129,
		133,
		115,
		129,
		120,
		138,
		145,
		143,
		147,
		167,
		179,
		243,
		233,
		-1,
		215,
		220,
		179,
		187,
		206,
		244,
		208,
		-1,
		203,
		-1,
		174,
		187,
		-1,
		143,
		139,
		121,
		122,
		117,
		132,
		126,
		111,
		108,
		126,
		129,
		136,
		140,
		156,
		-1,
		-1,
		228,
		232,
		221,
		172,
		191,
		215,
		252,
		201,
		190,
		189,
		-1,
		180,
		157,
		154,
		142,
		129,
		114,
		115,
		123,
		136,
		115,
		110,
		107,
		127,
		153,
		131,
		143,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		198,
		169,
		193,
		235,
		219,
		212,
		200,
		165,
		165,
		159,
		-1,
		153,
		132,
		123,
		112,
		110,
		123,
		120,
		125,
		105,
		103,
		122,
		134,
		125,
		142,
		-1,
		-1,
		-1,
		228,
		217,
		218,
		164,
		187,
		224,
		198,
		184,
		189,
		164,
		157,
		151,
		166,
		149,
		130,
		119,
		111,
		100,
		116,
		124,
		119,
		101,
		110,
		116,
		140,
		130,
		136,
		-1,
		-1,
		235,
		225,
		209,
		211,
		208,
		178,
		185,
		217,
		189,
		202,
		-1,
		156,
		-1,
		145,
		140,
		124,
		119,
		116,
		113,
		107,
		116,
		118,
		108,
		103,
		110,
		145,
		145,
		120,
		140,
		143,
		-1,
		-1,
		-1,
		228,
		223,
		198,
		175,
		159,
		195,
		-1,
		172,
		173,
		-1,
		150,
		144,
		141,
		126,
		122,
		117,
		121,
		114,
		121,
		114,
		112,
		113,
		95,
		127,
		-1,
		128,
		122,
		130,
		120,
		108,
		-1,
		-1,
		-1,
		221,
		200,
		193,
		213,
		154,
		206,
		-1,
		-1,
		157,
		150,
		-1,
		137,
		119,
		126,
		124,
		118,
		122,
		119,
		108,
		121,
		114,
		100,
		102,
		115,
		119,
		123,
		110,
		106,
		103,
		117,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		174,
		-1,
		166,
		158,
		148,
		142,
		136,
		132,
		130,
		146,
		130,
		133,
		131,
		122,
		130,
		103,
		96,
		103,
		92,
		110,
		118,
		110,
		104,
		103,
		113,
		-1,
		241,
		227,
		198,
		-1,
		-1,
		187,
		-1,
		151,
		165,
		181,
		-1,
		174,
		153,
		168,
		146,
		142,
		138,
		153,
		154,
		132,
		131,
		129,
		120,
		108,
		97,
		100,
		92,
		114,
		114,
		98,
		99,
		103,
		-1,
		247,
		234,
		192,
		188,
		177,
		197,
		148,
		136,
		168,
		-1,
		-1,
		210,
		-1,
		144,
		161,
		152,
		150,
		143,
		128,
		135,
		140,
		117,
		112,
		102,
		91,
		91,
		86,
		108,
		94,
		92,
		101,
		117,
		-1,
		-1,
		-1,
		214,
		-1,
		-1,
		163,
		150,
		144,
		-1,
		185,
		-1,
		188,
		178,
		162,
		147,
		180,
		-1,
		127,
		123,
		130,
		-1,
		137,
		-1,
		110,
		107,
		98,
		83,
		80,
		91,
		89,
		100,
		96,
		-1,
		197,
		182,
		175,
		165,
		179,
		150,
		-1,
		205,
		-1,
		-1,
		175,
		169,
		169,
		153,
		156,
		143,
		123,
		115,
		130,
		129,
		116,
		115,
		96,
		89,
		86,
		79,
		92,
		102,
		107,
		94,
		-1,
		-1,
		-1,
		202,
		188,
		192,
		152,
		171,
		-1,
		-1,
		237,
		192,
		178,
		-1,
		152,
		143,
		131,
		121,
		111,
		116,
		117,
		107,
		105,
		94,
		96,
		90,
		81,
		80,
		96,
		88,
		110,
		-1,
		-1,
		185,
		190,
		178,
		164,
		183,
		-1,
		-1,
		-1,
		184,
		200,
		171,
		150,
		132,
		-1,
		-1,
		115,
		108,
		102,
		105,
		93,
		110,
		105,
		89,
		74,
		89,
		93,
		101,
		92,
		-1,
		188,
		175,
		-1,
		-1,
		186,
		180,
		-1,
		-1,
		-1,
		-1,
		183,
		128,
		117,
		112,
		116,
		114,
		-1,
		88,
		99,
		92,
		111,
		118,
		91,
		76,
		70,
		76,
		88,
		97,
		-1,
		-1,
		200,
		-1,
		170,
		-1,
		-1,
		-1,
		-1,
		140,
		134,
		105,
		98,
		102,
		-1,
		90,
		92,
		89,
		101,
		94,
		91,
		82,
		73,
		69,
		73,
		77,
		91,
		95,
		223,
		-1,
		161,
		-1,
		-1,
		-1,
		158,
		173,
		144,
		121,
		94,
		89,
		82,
		76,
		81,
		92,
		101,
		112,
		77,
		76,
		66,
		65,
		69,
		86,
		90,
		-1,
		-1,
		159,
		155,
		184,
		166,
		170,
		171,
		-1,
		-1,
		98,
		89,
		80,
		72,
		85,
		88,
		73,
		75,
		75,
		70,
		64,
		74,
		89,
		84,
		-1,
		-1,
		-1,
		171,
		-1,
		173,
		-1,
		-1,
		161,
		169,
		116,
		98,
		94,
		92,
		79,
		73,
		63,
		68,
		78,
		72,
		69,
		60,
		64,
		87,
		76,
		115,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		150,
		142,
		137,
		143,
		145,
		136,
		131,
		128,
		-1,
		98,
		102,
		69,
		76,
		59,
		66,
		71,
		68,
		54,
		61,
		77,
		76,
		71,
		107,
		98,
		104,
		-1,
		-1,
		236,
		225,
		214,
		220,
		-1,
		143,
		139,
		129,
		119,
		122,
		-1,
		-1,
		116,
		113,
		93,
		62,
		67,
		60,
		55,
		60,
		41,
		50,
		54,
		58,
		64,
		69,
		74,
		80,
		95,
		110,
		-1,
		190,
		227,
		220,
		188,
		196,
		227,
		-1,
		133,
		125,
		136,
		111,
		113,
		-1,
		-1,
		89,
		80,
		81,
		69,
		66,
		79,
		78,
		45,
		50,
		68,
		55,
		56,
		74,
		78,
		87,
		94,
		84,
		97,
		101,
		-1,
		183,
		203,
		182,
		185,
		209,
		223,
		-1,
		130,
		-1,
		-1,
		122,
		114,
		98,
		88,
		85,
		128,
		75,
		70,
		47,
		45,
		42,
		33,
		71,
		50,
		62,
		65,
		81,
		86,
		78,
		94,
		94,
		95,
		-1,
		172,
		183,
		176,
		-1,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		112,
		-1,
		125,
		-1,
		108,
		112,
		83,
		86,
		61,
		48,
		34,
		42,
		48,
		48,
		53,
		56,
		68,
		77,
		88,
		100,
		101,
		102,
		197,
		153,
		156,
		167,
		178,
		193,
		197,
		-1,
		142,
		181,
		118,
		-1,
		102,
		-1,
		-1,
		-1,
		116,
		96,
		88,
		81,
		60,
		60,
		26,
		30,
		43,
		50,
		60,
		74,
		71,
		81,
		94,
		105,
		110,
		193,
		184,
		197,
		142,
		142,
		163,
		172,
		193,
		157,
		148,
		175,
		125,
		114,
		109,
		96,
		-1,
		-1,
		94,
		106,
		-1,
		-1,
		67,
		34,
		22,
		32,
		36,
		50,
		62,
		75,
		63,
		82,
		76,
		108,
		-1,
		186,
		185,
		174,
		171,
		147,
		138,
		133,
		160,
		-1,
		-1,
		155,
		176,
		166,
		158,
		156,
		181,
		-1,
		85,
		-1,
		-1,
		74,
		-1,
		-1,
		59,
		39,
		28,
		19,
		24,
		44,
		55,
		77,
		59,
		76,
		81,
		91,
		104,
		170,
		167,
		155,
		153,
		176,
		141,
		129,
		-1,
		142,
		140,
		146,
		153,
		159,
		170,
		-1,
		-1,
		101,
		81,
		-1,
		-1,
		57,
		55,
		44,
		-1,
		34,
		16,
		21,
		51,
		53,
		55,
		62,
		56,
		63,
		89,
		101,
		97,
		179,
		193,
		182,
		178,
		177,
		185,
		134,
		127,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		91,
		87,
		-1,
		-1,
		52,
		45,
		33,
		21,
		11,
		21,
		38,
		38,
		41,
		46,
		54,
		65,
		79,
		83,
		91,
		-1,
		213,
		-1,
		165,
		141,
		148,
		163,
		171,
		-1,
		-1,
		-1,
		108,
		94,
		87,
		75,
		73,
		-1,
		86,
		70,
		51,
		-1,
		21,
		34,
		74,
		42,
		47,
		42,
		60,
		71,
		82,
		85,
		84,
		87,
		-1,
		-1,
		141,
		124,
		-1,
		-1,
		98,
		100,
		-1,
		99,
		88,
		73,
		65,
		-1,
		-1,
		58,
		54,
		-1,
		-1,
		6,
		56,
		45,
		53,
		48,
		60,
		70,
		68,
		80,
		88,
		81,
		-1,
		-1,
		119,
		111,
		105,
		-1,
		83,
		-1,
		101,
		-1,
		68,
		74,
		62,
		-1,
		-1,
		-1,
		37,
		0,
		25,
		63,
		68,
		66,
		57,
		56,
		63,
		73,
		75,
		81,
		-1,
		-1,
		-1,
		101,
		75,
		108,
		99,
		82,
		62,
		54,
		73,
		-1,
		40,
		-1,
		8,
		5,
		46,
		62,
		79,
		73,
		59,
		74,
		70,
		73,
		71,
		107,
		-1,
		77,
		110,
		74,
		68,
		44,
		48,
		64,
		-1,
		37,
		16,
		-1,
		50,
		40,
		88,
		63,
		70,
		57,
		59,
		60,
		68,
		-1,
		-1,
		-1,
		79,
		78,
		70,
		64,
		64,
		49,
		40,
		-1,
		52,
		34,
		13,
		30,
		30,
		21,
		29,
		78,
		74,
		75,
		75,
		53,
		-1,
		180,
		-1,
		-1,
		102,
		-1,
		-1,
		-1,
		73,
		68,
		41,
		29,
		35,
		31,
		17,
		23,
		25,
		33,
		31,
		28,
		40,
		36,
		56,
		52,
		84,
		-1,
		175,
		-1,
		109,
		-1,
		-1,
		91,
		71,
		63,
		52,
		41,
		39,
		30,
		21,
		43,
		59,
		43,
		41,
		46,
		51,
		-1,
		164,
		163,
		-1,
		110,
		102,
		88,
		-1,
		81,
		-1,
		87,
		48,
		-1,
		50,
		30,
		-1,
		52,
		48,
		-1,
		-1,
		151,
		126,
		-1,
		-1,
		-1,
		111,
		91,
		82,
		66,
		-1,
		41,
		41,
		-1,
		-1,
		-1,
		136,
		135,
		-1,
		104,
		107,
		-1,
		97,
		88,
		96,
		43,
		47,
		-1,
		-1,
		-1,
		145,
		126,
		120,
		119,
		117,
		112,
		109,
		95,
		79,
		57,
		46,
		67,
		-1,
		-1,
		-1,
		117,
		109,
		102,
		-1,
		-1,
		104,
		87,
		68,
		66,
		-1,
		-1,
		-1,
		139,
		120,
		-1,
		-1,
		94,
		-1,
		-1,
		100,
		65,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		128,
		-1,
		-1,
		-1,
		90,
		86,
		87,
		-1,
		-1,
		-1,
		-1,
		150,
		151,
		174,
		138,
		-1,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		153,
		151,
		-1,
		-1,
		-1,
		110,
		94,
		-1,
		80,
		-1,
		-1,
		-1,
		101,
		-1,
		-1,
		113,
		-1,
		-1,
		-1,
		115,
		-1,
		115,
		90,
		97,
		-1,
		-1,
		-1,
		-1,
		128,
		120,
		128,
		-1,
		100,
		102,
		-1,
		150,
		-1,
		-1,
		143,
		134,
		-1,
		-1,
		105,
		112,
		134,
		137,
		173,
		-1,
		124
	],
	[
		-1,
		248,
		237,
		248,
		256,
		229,
		236,
		-1,
		255,
		259,
		225,
		219,
		258,
		227,
		233,
		244,
		-1,
		-1,
		-1,
		248,
		247,
		215,
		213,
		222,
		227,
		234,
		-1,
		233,
		-1,
		269,
		248,
		259,
		264,
		208,
		205,
		225,
		244,
		226,
		218,
		284,
		238,
		209,
		203,
		221,
		211,
		220,
		212,
		-1,
		209,
		199,
		221,
		200,
		211,
		203,
		-1,
		-1,
		203,
		204,
		210,
		196,
		202,
		198,
		-1,
		208,
		192,
		-1,
		-1,
		193,
		194,
		178,
		181,
		189,
		187,
		200,
		192,
		187,
		-1,
		-1,
		184,
		180,
		187,
		174,
		170,
		187,
		200,
		182,
		196,
		195,
		-1,
		188,
		206,
		213,
		181,
		179,
		163,
		161,
		179,
		181,
		187,
		187,
		-1,
		197,
		198,
		193,
		201,
		203,
		179,
		166,
		166,
		176,
		169,
		188,
		176,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		197,
		180,
		197,
		189,
		179,
		194,
		187,
		169,
		166,
		164,
		161,
		177,
		175,
		185,
		-1,
		-1,
		290,
		259,
		288,
		246,
		227,
		-1,
		193,
		173,
		179,
		183,
		177,
		170,
		184,
		180,
		-1,
		155,
		154,
		182,
		168,
		179,
		250,
		-1,
		-1,
		248,
		240,
		223,
		226,
		203,
		199,
		188,
		187,
		179,
		165,
		161,
		167,
		170,
		170,
		176,
		149,
		159,
		163,
		161,
		186,
		-1,
		-1,
		221,
		-1,
		-1,
		247,
		230,
		-1,
		213,
		220,
		209,
		215,
		201,
		222,
		198,
		189,
		181,
		175,
		163,
		165,
		162,
		175,
		163,
		146,
		171,
		175,
		156,
		177,
		172,
		-1,
		220,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		206,
		209,
		215,
		239,
		238,
		-1,
		210,
		198,
		199,
		184,
		181,
		168,
		156,
		169,
		154,
		161,
		160,
		150,
		148,
		178,
		153,
		175,
		172,
		191,
		196,
		190,
		199,
		-1,
		255,
		251,
		247,
		254,
		203,
		-1,
		-1,
		243,
		-1,
		246,
		247,
		222,
		195,
		198,
		185,
		176,
		163,
		152,
		163,
		152,
		149,
		157,
		142,
		157,
		148,
		147,
		165,
		175,
		183,
		187,
		193,
		-1,
		305,
		-1,
		247,
		231,
		233,
		205,
		226,
		-1,
		263,
		247,
		239,
		224,
		224,
		-1,
		194,
		191,
		181,
		159,
		144,
		161,
		153,
		151,
		155,
		137,
		151,
		142,
		160,
		167,
		165,
		169,
		189,
		201,
		265,
		255,
		-1,
		237,
		242,
		201,
		209,
		228,
		266,
		230,
		-1,
		225,
		-1,
		196,
		209,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		148,
		133,
		130,
		148,
		151,
		158,
		162,
		178,
		-1,
		-1,
		250,
		254,
		243,
		194,
		213,
		237,
		274,
		223,
		212,
		211,
		-1,
		202,
		179,
		176,
		164,
		151,
		136,
		137,
		145,
		158,
		137,
		132,
		129,
		149,
		175,
		153,
		165,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		220,
		191,
		215,
		257,
		241,
		234,
		222,
		187,
		187,
		181,
		-1,
		175,
		154,
		145,
		134,
		132,
		145,
		142,
		147,
		127,
		125,
		144,
		156,
		147,
		164,
		-1,
		-1,
		-1,
		250,
		239,
		240,
		186,
		209,
		246,
		220,
		206,
		211,
		186,
		179,
		173,
		188,
		171,
		152,
		141,
		133,
		122,
		138,
		146,
		141,
		123,
		132,
		138,
		162,
		152,
		158,
		-1,
		-1,
		257,
		247,
		231,
		233,
		230,
		200,
		207,
		239,
		211,
		224,
		-1,
		178,
		-1,
		167,
		162,
		146,
		141,
		138,
		135,
		129,
		138,
		140,
		130,
		125,
		132,
		167,
		167,
		142,
		162,
		165,
		-1,
		-1,
		-1,
		250,
		245,
		220,
		197,
		181,
		217,
		-1,
		194,
		195,
		-1,
		172,
		166,
		163,
		148,
		144,
		139,
		143,
		136,
		143,
		136,
		134,
		135,
		117,
		149,
		-1,
		150,
		144,
		152,
		142,
		130,
		-1,
		-1,
		-1,
		243,
		222,
		215,
		235,
		176,
		228,
		-1,
		-1,
		179,
		172,
		-1,
		159,
		141,
		148,
		146,
		140,
		144,
		141,
		130,
		143,
		136,
		122,
		124,
		137,
		141,
		145,
		132,
		128,
		125,
		139,
		-1,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		196,
		-1,
		188,
		180,
		170,
		164,
		158,
		154,
		152,
		168,
		152,
		155,
		153,
		144,
		152,
		125,
		118,
		125,
		114,
		132,
		140,
		132,
		126,
		125,
		135,
		-1,
		263,
		249,
		220,
		-1,
		-1,
		209,
		-1,
		173,
		187,
		203,
		-1,
		196,
		175,
		190,
		168,
		164,
		160,
		175,
		176,
		153,
		153,
		151,
		142,
		130,
		119,
		122,
		114,
		136,
		136,
		120,
		121,
		125,
		-1,
		269,
		256,
		214,
		210,
		199,
		219,
		170,
		158,
		190,
		-1,
		-1,
		232,
		-1,
		166,
		183,
		174,
		172,
		165,
		147,
		154,
		162,
		139,
		134,
		124,
		113,
		113,
		108,
		130,
		116,
		114,
		123,
		139,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		185,
		172,
		166,
		-1,
		207,
		-1,
		210,
		200,
		184,
		169,
		202,
		-1,
		146,
		142,
		149,
		-1,
		159,
		-1,
		132,
		129,
		120,
		105,
		102,
		113,
		111,
		122,
		118,
		-1,
		219,
		204,
		197,
		187,
		201,
		172,
		-1,
		227,
		-1,
		-1,
		197,
		191,
		191,
		175,
		176,
		162,
		142,
		134,
		149,
		148,
		135,
		134,
		118,
		111,
		108,
		101,
		114,
		124,
		129,
		116,
		-1,
		-1,
		-1,
		224,
		210,
		214,
		174,
		193,
		-1,
		-1,
		259,
		214,
		200,
		-1,
		171,
		162,
		150,
		140,
		130,
		135,
		136,
		126,
		124,
		116,
		118,
		112,
		103,
		102,
		118,
		110,
		132,
		-1,
		-1,
		207,
		212,
		200,
		186,
		205,
		-1,
		-1,
		-1,
		206,
		222,
		190,
		169,
		151,
		-1,
		-1,
		134,
		127,
		121,
		124,
		112,
		132,
		127,
		111,
		96,
		111,
		115,
		123,
		114,
		-1,
		210,
		197,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		111,
		130,
		137,
		113,
		98,
		92,
		98,
		110,
		119,
		-1,
		-1,
		222,
		-1,
		192,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		108,
		120,
		116,
		113,
		104,
		95,
		91,
		95,
		99,
		113,
		117,
		245,
		-1,
		183,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		120,
		131,
		96,
		98,
		88,
		87,
		91,
		108,
		112,
		-1,
		-1,
		181,
		177,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		92,
		94,
		94,
		92,
		86,
		96,
		111,
		106,
		-1,
		-1,
		-1,
		193,
		-1,
		195,
		-1,
		-1,
		183,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		97,
		91,
		88,
		82,
		86,
		109,
		98,
		137,
		-1,
		-1,
		265,
		-1,
		-1,
		-1,
		172,
		164,
		159,
		165,
		167,
		158,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		90,
		87,
		76,
		83,
		99,
		98,
		93,
		129,
		120,
		126,
		-1,
		-1,
		258,
		247,
		236,
		242,
		-1,
		165,
		161,
		151,
		141,
		144,
		-1,
		-1,
		138,
		135,
		115,
		84,
		86,
		79,
		74,
		82,
		60,
		72,
		76,
		80,
		86,
		91,
		96,
		102,
		117,
		132,
		-1,
		212,
		249,
		242,
		210,
		218,
		249,
		-1,
		155,
		147,
		158,
		133,
		135,
		-1,
		-1,
		111,
		102,
		103,
		91,
		88,
		98,
		97,
		67,
		72,
		87,
		77,
		78,
		96,
		100,
		109,
		116,
		106,
		119,
		123,
		-1,
		205,
		225,
		204,
		207,
		231,
		245,
		-1,
		152,
		-1,
		-1,
		137,
		136,
		120,
		110,
		107,
		150,
		97,
		92,
		69,
		67,
		64,
		55,
		93,
		72,
		84,
		87,
		103,
		108,
		100,
		116,
		116,
		117,
		-1,
		194,
		205,
		198,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		-1,
		127,
		-1,
		147,
		-1,
		130,
		134,
		105,
		108,
		83,
		70,
		56,
		64,
		70,
		70,
		75,
		78,
		90,
		99,
		110,
		122,
		123,
		124,
		219,
		175,
		178,
		189,
		200,
		215,
		219,
		-1,
		164,
		203,
		133,
		-1,
		117,
		-1,
		-1,
		-1,
		138,
		118,
		110,
		103,
		82,
		82,
		48,
		52,
		65,
		72,
		82,
		96,
		93,
		103,
		116,
		127,
		132,
		215,
		206,
		219,
		164,
		164,
		185,
		194,
		215,
		179,
		170,
		197,
		140,
		129,
		124,
		111,
		-1,
		-1,
		116,
		128,
		-1,
		-1,
		89,
		56,
		44,
		54,
		58,
		72,
		84,
		97,
		85,
		104,
		98,
		130,
		-1,
		208,
		207,
		196,
		193,
		169,
		160,
		155,
		182,
		-1,
		-1,
		177,
		198,
		188,
		173,
		171,
		196,
		-1,
		100,
		-1,
		-1,
		96,
		-1,
		-1,
		81,
		61,
		50,
		41,
		46,
		66,
		77,
		99,
		81,
		98,
		103,
		113,
		119,
		192,
		189,
		177,
		175,
		198,
		163,
		151,
		-1,
		164,
		162,
		168,
		175,
		174,
		185,
		-1,
		-1,
		116,
		96,
		-1,
		-1,
		79,
		77,
		66,
		-1,
		56,
		38,
		43,
		73,
		75,
		77,
		84,
		78,
		85,
		109,
		120,
		112,
		201,
		215,
		204,
		200,
		199,
		207,
		156,
		149,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		106,
		102,
		-1,
		-1,
		74,
		67,
		55,
		43,
		33,
		43,
		60,
		60,
		63,
		68,
		76,
		87,
		99,
		103,
		106,
		-1,
		235,
		-1,
		187,
		157,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		123,
		109,
		102,
		90,
		88,
		-1,
		108,
		92,
		73,
		-1,
		43,
		56,
		96,
		64,
		69,
		64,
		82,
		93,
		97,
		105,
		99,
		102,
		-1,
		-1,
		156,
		139,
		-1,
		-1,
		113,
		115,
		-1,
		114,
		103,
		88,
		80,
		-1,
		-1,
		80,
		76,
		-1,
		-1,
		29,
		78,
		67,
		75,
		70,
		82,
		92,
		90,
		95,
		105,
		96,
		-1,
		-1,
		134,
		126,
		120,
		-1,
		98,
		-1,
		116,
		-1,
		83,
		89,
		77,
		-1,
		-1,
		-1,
		61,
		24,
		0,
		79,
		90,
		88,
		79,
		78,
		85,
		95,
		90,
		96,
		-1,
		-1,
		-1,
		116,
		90,
		123,
		114,
		97,
		77,
		69,
		88,
		-1,
		55,
		-1,
		23,
		20,
		61,
		84,
		101,
		88,
		81,
		96,
		91,
		88,
		86,
		122,
		-1,
		92,
		125,
		89,
		83,
		59,
		63,
		79,
		-1,
		52,
		31,
		-1,
		65,
		55,
		103,
		78,
		87,
		79,
		74,
		75,
		83,
		-1,
		-1,
		-1,
		94,
		93,
		85,
		79,
		79,
		64,
		55,
		-1,
		67,
		49,
		28,
		45,
		45,
		36,
		44,
		93,
		89,
		92,
		90,
		68,
		-1,
		195,
		-1,
		-1,
		117,
		-1,
		-1,
		-1,
		88,
		83,
		56,
		44,
		50,
		46,
		32,
		38,
		40,
		48,
		46,
		43,
		55,
		51,
		71,
		67,
		99,
		-1,
		190,
		-1,
		124,
		-1,
		-1,
		106,
		86,
		78,
		67,
		56,
		54,
		45,
		36,
		58,
		74,
		58,
		56,
		61,
		66,
		-1,
		179,
		178,
		-1,
		125,
		117,
		103,
		-1,
		96,
		-1,
		102,
		63,
		-1,
		65,
		45,
		-1,
		67,
		63,
		-1,
		-1,
		166,
		141,
		-1,
		-1,
		-1,
		126,
		106,
		97,
		81,
		-1,
		56,
		56,
		-1,
		-1,
		-1,
		151,
		150,
		-1,
		119,
		122,
		-1,
		112,
		103,
		111,
		58,
		62,
		-1,
		-1,
		-1,
		160,
		141,
		135,
		134,
		132,
		127,
		124,
		110,
		94,
		72,
		61,
		82,
		-1,
		-1,
		-1,
		132,
		124,
		117,
		-1,
		-1,
		119,
		102,
		83,
		81,
		-1,
		-1,
		-1,
		154,
		135,
		-1,
		-1,
		109,
		-1,
		-1,
		115,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		143,
		-1,
		-1,
		-1,
		105,
		101,
		102,
		-1,
		-1,
		-1,
		-1,
		165,
		166,
		189,
		153,
		-1,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		168,
		166,
		-1,
		-1,
		-1,
		125,
		109,
		-1,
		95,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		128,
		-1,
		-1,
		-1,
		130,
		-1,
		130,
		105,
		112,
		-1,
		-1,
		-1,
		-1,
		143,
		135,
		143,
		-1,
		115,
		117,
		-1,
		165,
		-1,
		-1,
		158,
		149,
		-1,
		-1,
		120,
		127,
		149,
		152,
		188,
		-1,
		139
	],
	[
		-1,
		259,
		248,
		259,
		267,
		240,
		247,
		-1,
		266,
		270,
		236,
		230,
		269,
		238,
		244,
		255,
		-1,
		-1,
		-1,
		259,
		258,
		226,
		224,
		233,
		238,
		245,
		-1,
		244,
		-1,
		280,
		259,
		270,
		275,
		219,
		216,
		236,
		255,
		237,
		229,
		295,
		249,
		220,
		214,
		232,
		222,
		231,
		223,
		-1,
		220,
		210,
		232,
		211,
		222,
		214,
		-1,
		-1,
		214,
		215,
		221,
		207,
		213,
		209,
		-1,
		219,
		203,
		-1,
		-1,
		204,
		205,
		189,
		192,
		200,
		198,
		211,
		203,
		198,
		-1,
		-1,
		195,
		191,
		198,
		185,
		181,
		198,
		211,
		193,
		207,
		206,
		-1,
		199,
		217,
		224,
		192,
		190,
		174,
		172,
		190,
		192,
		198,
		198,
		-1,
		208,
		209,
		204,
		212,
		214,
		190,
		177,
		177,
		187,
		180,
		199,
		187,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		208,
		191,
		208,
		200,
		190,
		205,
		198,
		180,
		177,
		175,
		172,
		188,
		186,
		196,
		-1,
		-1,
		301,
		270,
		299,
		257,
		238,
		-1,
		204,
		184,
		190,
		194,
		188,
		181,
		195,
		191,
		-1,
		166,
		165,
		193,
		179,
		190,
		261,
		-1,
		-1,
		259,
		251,
		234,
		237,
		214,
		210,
		199,
		198,
		190,
		176,
		172,
		178,
		181,
		181,
		187,
		160,
		170,
		174,
		172,
		197,
		-1,
		-1,
		232,
		-1,
		-1,
		258,
		241,
		-1,
		224,
		231,
		220,
		226,
		212,
		233,
		209,
		200,
		192,
		186,
		174,
		176,
		173,
		186,
		174,
		157,
		182,
		186,
		167,
		188,
		183,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		217,
		220,
		226,
		250,
		249,
		-1,
		221,
		209,
		210,
		195,
		192,
		179,
		167,
		180,
		165,
		172,
		171,
		161,
		159,
		189,
		164,
		186,
		183,
		202,
		207,
		201,
		210,
		-1,
		266,
		262,
		258,
		265,
		214,
		-1,
		-1,
		254,
		-1,
		257,
		258,
		233,
		206,
		209,
		196,
		187,
		174,
		163,
		174,
		163,
		160,
		168,
		153,
		168,
		159,
		158,
		176,
		186,
		194,
		198,
		204,
		-1,
		316,
		-1,
		258,
		242,
		244,
		216,
		237,
		-1,
		274,
		258,
		250,
		235,
		235,
		-1,
		205,
		202,
		192,
		170,
		155,
		172,
		164,
		162,
		166,
		148,
		162,
		153,
		171,
		178,
		176,
		180,
		200,
		212,
		276,
		266,
		-1,
		248,
		253,
		212,
		220,
		239,
		277,
		241,
		-1,
		236,
		-1,
		207,
		220,
		-1,
		176,
		172,
		154,
		155,
		150,
		165,
		159,
		144,
		141,
		159,
		162,
		169,
		173,
		189,
		-1,
		-1,
		261,
		265,
		254,
		205,
		224,
		248,
		285,
		234,
		223,
		222,
		-1,
		213,
		190,
		187,
		175,
		162,
		147,
		148,
		156,
		169,
		148,
		143,
		140,
		160,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		231,
		202,
		226,
		268,
		252,
		245,
		233,
		198,
		198,
		192,
		-1,
		186,
		165,
		156,
		145,
		143,
		156,
		153,
		158,
		138,
		136,
		155,
		167,
		158,
		175,
		-1,
		-1,
		-1,
		261,
		250,
		251,
		197,
		220,
		257,
		231,
		217,
		222,
		197,
		190,
		184,
		199,
		182,
		163,
		152,
		144,
		133,
		149,
		157,
		152,
		134,
		143,
		149,
		173,
		163,
		169,
		-1,
		-1,
		268,
		258,
		242,
		244,
		241,
		211,
		218,
		250,
		222,
		235,
		-1,
		189,
		-1,
		178,
		173,
		157,
		152,
		149,
		146,
		140,
		149,
		151,
		141,
		136,
		143,
		178,
		178,
		153,
		173,
		176,
		-1,
		-1,
		-1,
		261,
		256,
		231,
		208,
		192,
		228,
		-1,
		205,
		206,
		-1,
		183,
		177,
		174,
		159,
		155,
		150,
		154,
		147,
		154,
		147,
		145,
		146,
		128,
		160,
		-1,
		161,
		155,
		163,
		153,
		141,
		-1,
		-1,
		-1,
		254,
		233,
		226,
		246,
		187,
		239,
		-1,
		-1,
		190,
		183,
		-1,
		170,
		152,
		159,
		157,
		151,
		155,
		152,
		141,
		154,
		147,
		133,
		135,
		148,
		152,
		156,
		143,
		139,
		136,
		150,
		-1,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		207,
		-1,
		199,
		191,
		181,
		175,
		169,
		165,
		163,
		179,
		163,
		166,
		164,
		155,
		163,
		136,
		129,
		136,
		125,
		143,
		151,
		143,
		137,
		136,
		146,
		-1,
		274,
		260,
		231,
		-1,
		-1,
		220,
		-1,
		184,
		198,
		214,
		-1,
		207,
		186,
		201,
		179,
		175,
		171,
		186,
		187,
		165,
		164,
		162,
		153,
		141,
		130,
		133,
		125,
		147,
		147,
		131,
		132,
		136,
		-1,
		280,
		267,
		225,
		221,
		210,
		230,
		181,
		169,
		201,
		-1,
		-1,
		243,
		-1,
		177,
		194,
		185,
		183,
		176,
		161,
		168,
		173,
		150,
		145,
		135,
		124,
		124,
		119,
		141,
		127,
		125,
		134,
		150,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		196,
		183,
		177,
		-1,
		218,
		-1,
		221,
		211,
		195,
		180,
		213,
		-1,
		160,
		156,
		163,
		-1,
		170,
		-1,
		143,
		140,
		131,
		116,
		113,
		124,
		122,
		133,
		129,
		-1,
		230,
		215,
		208,
		198,
		212,
		183,
		-1,
		238,
		-1,
		-1,
		208,
		202,
		202,
		186,
		189,
		176,
		156,
		148,
		163,
		162,
		149,
		148,
		129,
		122,
		119,
		112,
		125,
		135,
		140,
		127,
		-1,
		-1,
		-1,
		235,
		221,
		225,
		185,
		204,
		-1,
		-1,
		270,
		225,
		211,
		-1,
		185,
		176,
		164,
		154,
		144,
		149,
		150,
		140,
		138,
		127,
		129,
		123,
		114,
		113,
		129,
		121,
		143,
		-1,
		-1,
		218,
		223,
		211,
		197,
		216,
		-1,
		-1,
		-1,
		217,
		233,
		204,
		183,
		165,
		-1,
		-1,
		148,
		141,
		135,
		138,
		126,
		143,
		138,
		122,
		107,
		122,
		126,
		134,
		125,
		-1,
		221,
		208,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		-1,
		-1,
		216,
		161,
		150,
		145,
		149,
		147,
		-1,
		121,
		132,
		125,
		144,
		151,
		124,
		109,
		103,
		109,
		121,
		130,
		-1,
		-1,
		233,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		173,
		167,
		138,
		131,
		135,
		-1,
		123,
		125,
		122,
		134,
		127,
		124,
		115,
		106,
		102,
		106,
		110,
		124,
		128,
		256,
		-1,
		194,
		-1,
		-1,
		-1,
		191,
		206,
		177,
		154,
		127,
		122,
		115,
		109,
		114,
		125,
		134,
		145,
		110,
		109,
		99,
		98,
		102,
		119,
		123,
		-1,
		-1,
		192,
		188,
		217,
		199,
		203,
		204,
		-1,
		-1,
		131,
		122,
		113,
		105,
		118,
		121,
		106,
		108,
		108,
		103,
		97,
		107,
		122,
		117,
		-1,
		-1,
		-1,
		204,
		-1,
		206,
		-1,
		-1,
		194,
		202,
		149,
		131,
		127,
		125,
		112,
		106,
		96,
		101,
		111,
		105,
		102,
		93,
		97,
		120,
		109,
		129,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		183,
		175,
		170,
		176,
		178,
		169,
		164,
		161,
		-1,
		131,
		135,
		102,
		109,
		92,
		99,
		104,
		101,
		87,
		94,
		110,
		109,
		104,
		121,
		112,
		116,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		176,
		172,
		162,
		152,
		155,
		-1,
		-1,
		149,
		146,
		126,
		95,
		100,
		93,
		88,
		93,
		74,
		83,
		87,
		85,
		97,
		102,
		107,
		100,
		107,
		122,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		166,
		158,
		169,
		144,
		146,
		-1,
		-1,
		122,
		113,
		114,
		102,
		99,
		112,
		111,
		78,
		75,
		97,
		80,
		89,
		101,
		93,
		97,
		98,
		105,
		116,
		120,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		163,
		-1,
		-1,
		165,
		147,
		131,
		121,
		118,
		161,
		108,
		103,
		80,
		78,
		75,
		66,
		96,
		75,
		79,
		76,
		85,
		90,
		82,
		108,
		110,
		116,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		155,
		-1,
		158,
		-1,
		141,
		145,
		116,
		119,
		94,
		81,
		67,
		67,
		73,
		73,
		78,
		81,
		72,
		81,
		92,
		104,
		114,
		116,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		175,
		214,
		161,
		-1,
		145,
		-1,
		-1,
		-1,
		155,
		129,
		121,
		114,
		93,
		93,
		59,
		55,
		68,
		75,
		85,
		89,
		73,
		85,
		98,
		109,
		124,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		181,
		208,
		168,
		157,
		152,
		139,
		-1,
		-1,
		136,
		139,
		-1,
		-1,
		100,
		76,
		63,
		57,
		61,
		75,
		87,
		85,
		65,
		85,
		80,
		112,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		209,
		199,
		201,
		199,
		224,
		-1,
		128,
		-1,
		-1,
		116,
		-1,
		-1,
		101,
		81,
		70,
		61,
		47,
		69,
		80,
		102,
		61,
		78,
		85,
		95,
		108,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		202,
		213,
		-1,
		-1,
		144,
		124,
		-1,
		-1,
		99,
		97,
		86,
		-1,
		76,
		58,
		44,
		71,
		55,
		57,
		64,
		58,
		65,
		91,
		104,
		105,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		134,
		130,
		-1,
		-1,
		94,
		87,
		75,
		63,
		53,
		58,
		44,
		34,
		43,
		48,
		56,
		67,
		81,
		85,
		99,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		151,
		137,
		130,
		118,
		116,
		-1,
		128,
		112,
		93,
		-1,
		63,
		76,
		54,
		25,
		49,
		44,
		62,
		73,
		84,
		87,
		92,
		95,
		-1,
		-1,
		184,
		167,
		-1,
		-1,
		141,
		143,
		-1,
		142,
		131,
		116,
		108,
		-1,
		-1,
		100,
		96,
		-1,
		-1,
		64,
		5,
		23,
		55,
		50,
		62,
		72,
		70,
		82,
		90,
		89,
		-1,
		-1,
		162,
		154,
		148,
		-1,
		126,
		-1,
		144,
		-1,
		111,
		117,
		105,
		-1,
		-1,
		-1,
		102,
		65,
		84,
		0,
		40,
		44,
		59,
		58,
		65,
		75,
		83,
		89,
		-1,
		-1,
		-1,
		144,
		118,
		151,
		142,
		125,
		105,
		97,
		116,
		-1,
		86,
		-1,
		61,
		64,
		14,
		32,
		67,
		61,
		61,
		76,
		72,
		81,
		79,
		150,
		-1,
		120,
		153,
		117,
		111,
		87,
		91,
		107,
		-1,
		83,
		65,
		-1,
		52,
		21,
		84,
		70,
		72,
		59,
		66,
		80,
		76,
		-1,
		-1,
		-1,
		122,
		121,
		113,
		107,
		107,
		92,
		83,
		-1,
		95,
		77,
		56,
		65,
		50,
		47,
		39,
		74,
		70,
		77,
		79,
		71,
		-1,
		223,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		116,
		111,
		84,
		72,
		78,
		74,
		60,
		66,
		60,
		42,
		36,
		40,
		56,
		57,
		77,
		72,
		105,
		-1,
		218,
		-1,
		152,
		-1,
		-1,
		134,
		114,
		106,
		95,
		84,
		82,
		73,
		64,
		86,
		78,
		62,
		62,
		67,
		72,
		-1,
		207,
		206,
		-1,
		153,
		145,
		131,
		-1,
		124,
		-1,
		130,
		91,
		-1,
		93,
		73,
		-1,
		73,
		69,
		-1,
		-1,
		194,
		169,
		-1,
		-1,
		-1,
		154,
		134,
		125,
		109,
		-1,
		84,
		84,
		-1,
		-1,
		-1,
		179,
		178,
		-1,
		147,
		150,
		-1,
		140,
		131,
		139,
		86,
		90,
		-1,
		-1,
		-1,
		188,
		169,
		163,
		162,
		160,
		155,
		152,
		138,
		122,
		100,
		89,
		110,
		-1,
		-1,
		-1,
		160,
		152,
		145,
		-1,
		-1,
		147,
		130,
		111,
		109,
		-1,
		-1,
		-1,
		182,
		163,
		-1,
		-1,
		137,
		-1,
		-1,
		143,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		199,
		171,
		-1,
		-1,
		-1,
		133,
		129,
		130,
		-1,
		-1,
		-1,
		-1,
		193,
		194,
		217,
		181,
		-1,
		-1,
		-1,
		125,
		119,
		-1,
		-1,
		196,
		194,
		-1,
		-1,
		-1,
		153,
		137,
		-1,
		123,
		-1,
		-1,
		-1,
		144,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		158,
		-1,
		158,
		133,
		140,
		-1,
		-1,
		-1,
		-1,
		171,
		163,
		171,
		-1,
		143,
		145,
		-1,
		193,
		-1,
		-1,
		186,
		177,
		-1,
		-1,
		148,
		155,
		177,
		180,
		216,
		-1,
		167
	],
	[
		-1,
		257,
		246,
		257,
		265,
		238,
		245,
		-1,
		264,
		268,
		234,
		228,
		267,
		236,
		242,
		253,
		-1,
		-1,
		-1,
		257,
		256,
		224,
		222,
		231,
		236,
		243,
		-1,
		242,
		-1,
		278,
		257,
		268,
		273,
		217,
		214,
		234,
		253,
		235,
		227,
		293,
		247,
		218,
		212,
		230,
		220,
		229,
		221,
		-1,
		218,
		208,
		230,
		209,
		220,
		212,
		-1,
		-1,
		212,
		213,
		219,
		205,
		211,
		207,
		-1,
		217,
		201,
		-1,
		-1,
		202,
		203,
		187,
		190,
		198,
		196,
		209,
		201,
		196,
		-1,
		-1,
		193,
		189,
		196,
		183,
		179,
		196,
		209,
		191,
		205,
		204,
		-1,
		197,
		215,
		222,
		190,
		188,
		172,
		170,
		188,
		190,
		196,
		196,
		-1,
		206,
		207,
		202,
		210,
		212,
		188,
		175,
		175,
		185,
		178,
		197,
		185,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		206,
		189,
		206,
		198,
		188,
		203,
		196,
		178,
		175,
		173,
		170,
		186,
		184,
		194,
		-1,
		-1,
		299,
		268,
		297,
		255,
		236,
		-1,
		202,
		182,
		188,
		192,
		186,
		179,
		193,
		189,
		-1,
		164,
		163,
		191,
		177,
		188,
		259,
		-1,
		-1,
		257,
		249,
		232,
		235,
		212,
		208,
		197,
		196,
		188,
		174,
		170,
		176,
		179,
		179,
		185,
		158,
		168,
		172,
		170,
		195,
		-1,
		-1,
		230,
		-1,
		-1,
		256,
		239,
		-1,
		222,
		229,
		218,
		224,
		210,
		231,
		207,
		198,
		190,
		184,
		172,
		174,
		171,
		184,
		172,
		155,
		180,
		184,
		165,
		186,
		181,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		215,
		218,
		224,
		248,
		247,
		-1,
		219,
		207,
		208,
		193,
		190,
		177,
		165,
		178,
		163,
		170,
		169,
		159,
		157,
		187,
		162,
		184,
		181,
		200,
		205,
		199,
		208,
		-1,
		264,
		260,
		256,
		263,
		212,
		-1,
		-1,
		252,
		-1,
		255,
		256,
		231,
		204,
		207,
		194,
		185,
		172,
		161,
		172,
		161,
		158,
		166,
		151,
		166,
		157,
		156,
		174,
		184,
		192,
		196,
		202,
		-1,
		314,
		-1,
		256,
		240,
		242,
		214,
		235,
		-1,
		272,
		256,
		248,
		233,
		233,
		-1,
		203,
		200,
		190,
		168,
		153,
		170,
		162,
		160,
		164,
		146,
		160,
		151,
		169,
		176,
		174,
		178,
		198,
		210,
		274,
		264,
		-1,
		246,
		251,
		210,
		218,
		237,
		275,
		239,
		-1,
		234,
		-1,
		205,
		218,
		-1,
		174,
		170,
		152,
		153,
		148,
		163,
		157,
		142,
		139,
		157,
		160,
		167,
		171,
		187,
		-1,
		-1,
		259,
		263,
		252,
		203,
		222,
		246,
		283,
		232,
		221,
		220,
		-1,
		211,
		188,
		185,
		173,
		160,
		145,
		146,
		154,
		167,
		146,
		141,
		138,
		158,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		229,
		200,
		224,
		266,
		250,
		243,
		231,
		196,
		196,
		190,
		-1,
		184,
		163,
		154,
		143,
		141,
		154,
		151,
		156,
		136,
		134,
		153,
		165,
		156,
		173,
		-1,
		-1,
		-1,
		259,
		248,
		249,
		195,
		218,
		255,
		229,
		215,
		220,
		195,
		188,
		182,
		197,
		180,
		161,
		150,
		142,
		131,
		147,
		155,
		150,
		132,
		141,
		147,
		171,
		161,
		167,
		-1,
		-1,
		266,
		256,
		240,
		242,
		239,
		209,
		216,
		248,
		220,
		233,
		-1,
		187,
		-1,
		176,
		171,
		155,
		150,
		147,
		144,
		138,
		147,
		149,
		139,
		134,
		141,
		176,
		176,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		259,
		254,
		229,
		206,
		190,
		226,
		-1,
		203,
		204,
		-1,
		181,
		175,
		172,
		157,
		153,
		148,
		152,
		145,
		152,
		145,
		143,
		144,
		126,
		158,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		252,
		231,
		224,
		244,
		185,
		237,
		-1,
		-1,
		188,
		181,
		-1,
		168,
		150,
		157,
		155,
		149,
		153,
		150,
		139,
		152,
		145,
		131,
		133,
		146,
		150,
		154,
		141,
		137,
		134,
		148,
		-1,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		205,
		-1,
		197,
		189,
		179,
		173,
		167,
		163,
		161,
		177,
		161,
		164,
		162,
		153,
		161,
		134,
		127,
		134,
		123,
		141,
		149,
		141,
		135,
		134,
		144,
		-1,
		272,
		258,
		229,
		-1,
		-1,
		218,
		-1,
		182,
		196,
		212,
		-1,
		205,
		184,
		199,
		177,
		173,
		169,
		184,
		185,
		163,
		162,
		160,
		151,
		139,
		128,
		131,
		123,
		145,
		145,
		129,
		130,
		134,
		-1,
		278,
		265,
		223,
		219,
		208,
		228,
		179,
		167,
		199,
		-1,
		-1,
		241,
		-1,
		175,
		192,
		183,
		181,
		174,
		165,
		171,
		171,
		148,
		143,
		133,
		122,
		122,
		117,
		139,
		125,
		123,
		132,
		148,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		194,
		181,
		175,
		-1,
		216,
		-1,
		219,
		209,
		193,
		178,
		211,
		-1,
		166,
		162,
		169,
		-1,
		168,
		-1,
		141,
		138,
		129,
		114,
		111,
		122,
		120,
		131,
		127,
		-1,
		228,
		213,
		206,
		196,
		210,
		181,
		-1,
		236,
		-1,
		-1,
		206,
		200,
		200,
		184,
		187,
		182,
		162,
		154,
		169,
		163,
		155,
		149,
		127,
		120,
		117,
		110,
		123,
		133,
		138,
		125,
		-1,
		-1,
		-1,
		233,
		219,
		223,
		183,
		202,
		-1,
		-1,
		268,
		223,
		209,
		-1,
		191,
		182,
		170,
		160,
		150,
		155,
		156,
		146,
		139,
		125,
		127,
		121,
		112,
		111,
		127,
		119,
		141,
		-1,
		-1,
		216,
		221,
		209,
		195,
		214,
		-1,
		-1,
		-1,
		215,
		231,
		210,
		189,
		171,
		-1,
		-1,
		154,
		147,
		141,
		142,
		129,
		141,
		136,
		120,
		105,
		120,
		124,
		132,
		123,
		-1,
		219,
		206,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		-1,
		-1,
		222,
		167,
		156,
		151,
		155,
		153,
		-1,
		127,
		138,
		131,
		145,
		152,
		122,
		107,
		101,
		107,
		119,
		128,
		-1,
		-1,
		231,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		179,
		173,
		144,
		137,
		141,
		-1,
		129,
		131,
		128,
		140,
		125,
		122,
		113,
		104,
		100,
		104,
		108,
		122,
		126,
		254,
		-1,
		200,
		-1,
		-1,
		-1,
		197,
		212,
		183,
		160,
		133,
		128,
		121,
		115,
		120,
		131,
		133,
		144,
		111,
		107,
		97,
		96,
		100,
		117,
		117,
		-1,
		-1,
		198,
		194,
		223,
		205,
		209,
		210,
		-1,
		-1,
		137,
		128,
		119,
		111,
		124,
		127,
		112,
		114,
		108,
		101,
		95,
		105,
		116,
		111,
		-1,
		-1,
		-1,
		210,
		-1,
		212,
		-1,
		-1,
		200,
		208,
		155,
		137,
		133,
		131,
		118,
		112,
		102,
		107,
		117,
		109,
		103,
		91,
		91,
		114,
		103,
		120,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		189,
		181,
		176,
		182,
		184,
		175,
		170,
		167,
		-1,
		137,
		141,
		108,
		115,
		98,
		105,
		110,
		105,
		85,
		88,
		104,
		103,
		98,
		112,
		103,
		107,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		182,
		178,
		168,
		158,
		161,
		-1,
		-1,
		155,
		152,
		132,
		101,
		106,
		99,
		94,
		99,
		80,
		81,
		81,
		76,
		91,
		96,
		98,
		91,
		98,
		113,
		-1,
		229,
		266,
		259,
		227,
		235,
		266,
		-1,
		172,
		164,
		175,
		150,
		152,
		-1,
		-1,
		128,
		119,
		120,
		108,
		105,
		118,
		117,
		84,
		81,
		96,
		74,
		81,
		92,
		84,
		88,
		89,
		96,
		107,
		111,
		-1,
		222,
		242,
		221,
		224,
		248,
		262,
		-1,
		169,
		-1,
		-1,
		181,
		153,
		137,
		127,
		124,
		167,
		114,
		109,
		86,
		84,
		81,
		72,
		98,
		81,
		70,
		67,
		76,
		81,
		73,
		99,
		101,
		98,
		-1,
		211,
		222,
		215,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		179,
		-1,
		164,
		-1,
		147,
		151,
		122,
		125,
		100,
		87,
		73,
		73,
		79,
		79,
		78,
		74,
		63,
		72,
		83,
		95,
		105,
		107,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		181,
		220,
		185,
		-1,
		169,
		-1,
		-1,
		-1,
		161,
		135,
		127,
		120,
		99,
		99,
		65,
		61,
		74,
		81,
		88,
		80,
		64,
		76,
		89,
		100,
		106,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		196,
		187,
		214,
		192,
		181,
		176,
		163,
		-1,
		-1,
		142,
		145,
		-1,
		-1,
		106,
		82,
		69,
		63,
		67,
		81,
		88,
		76,
		56,
		76,
		71,
		102,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		215,
		205,
		209,
		223,
		248,
		-1,
		152,
		-1,
		-1,
		122,
		-1,
		-1,
		107,
		87,
		76,
		67,
		53,
		75,
		86,
		103,
		52,
		69,
		76,
		86,
		87,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		237,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		105,
		103,
		92,
		-1,
		82,
		64,
		50,
		75,
		61,
		61,
		55,
		49,
		56,
		73,
		86,
		80,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		100,
		93,
		81,
		69,
		59,
		64,
		48,
		38,
		49,
		52,
		47,
		58,
		63,
		67,
		74,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		134,
		118,
		99,
		-1,
		69,
		82,
		60,
		29,
		37,
		45,
		41,
		52,
		59,
		69,
		67,
		70,
		-1,
		-1,
		192,
		191,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		70,
		30,
		27,
		43,
		42,
		37,
		49,
		45,
		57,
		72,
		64,
		-1,
		-1,
		186,
		178,
		172,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		108,
		71,
		92,
		37,
		0,
		4,
		32,
		33,
		40,
		50,
		58,
		64,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		107,
		-1,
		75,
		72,
		51,
		8,
		27,
		21,
		36,
		48,
		47,
		56,
		54,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		104,
		83,
		-1,
		89,
		58,
		44,
		30,
		46,
		34,
		41,
		55,
		51,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		97,
		87,
		78,
		76,
		34,
		30,
		52,
		54,
		46,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		92,
		79,
		73,
		77,
		71,
		64,
		68,
		47,
		83,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		115,
		70,
		59,
		54,
		55,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		70,
		59,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		259,
		248,
		259,
		267,
		240,
		247,
		-1,
		266,
		270,
		236,
		230,
		269,
		238,
		244,
		255,
		-1,
		-1,
		-1,
		259,
		258,
		226,
		224,
		233,
		238,
		245,
		-1,
		244,
		-1,
		280,
		259,
		270,
		275,
		219,
		216,
		236,
		255,
		237,
		229,
		295,
		249,
		220,
		214,
		232,
		222,
		231,
		223,
		-1,
		220,
		210,
		232,
		211,
		222,
		214,
		-1,
		-1,
		214,
		215,
		221,
		207,
		213,
		209,
		-1,
		219,
		203,
		-1,
		-1,
		204,
		205,
		189,
		192,
		200,
		198,
		211,
		203,
		198,
		-1,
		-1,
		195,
		191,
		198,
		185,
		181,
		198,
		211,
		193,
		207,
		206,
		-1,
		199,
		217,
		224,
		192,
		190,
		174,
		172,
		190,
		192,
		198,
		198,
		-1,
		208,
		209,
		204,
		212,
		214,
		190,
		177,
		177,
		187,
		180,
		199,
		187,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		208,
		191,
		208,
		200,
		190,
		205,
		198,
		180,
		177,
		175,
		172,
		188,
		186,
		196,
		-1,
		-1,
		301,
		270,
		299,
		257,
		238,
		-1,
		204,
		184,
		190,
		194,
		188,
		181,
		195,
		191,
		-1,
		166,
		165,
		193,
		179,
		190,
		261,
		-1,
		-1,
		259,
		251,
		234,
		237,
		214,
		210,
		199,
		198,
		190,
		176,
		172,
		178,
		181,
		181,
		187,
		160,
		170,
		174,
		172,
		197,
		-1,
		-1,
		232,
		-1,
		-1,
		258,
		241,
		-1,
		224,
		231,
		220,
		226,
		212,
		233,
		209,
		200,
		192,
		186,
		174,
		176,
		173,
		186,
		174,
		157,
		182,
		186,
		167,
		188,
		183,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		217,
		220,
		226,
		250,
		249,
		-1,
		221,
		209,
		210,
		195,
		192,
		179,
		167,
		180,
		165,
		172,
		171,
		161,
		159,
		189,
		164,
		186,
		183,
		202,
		207,
		201,
		210,
		-1,
		266,
		262,
		258,
		265,
		214,
		-1,
		-1,
		254,
		-1,
		257,
		258,
		233,
		206,
		209,
		196,
		187,
		174,
		163,
		174,
		163,
		160,
		168,
		153,
		168,
		159,
		158,
		176,
		186,
		194,
		198,
		204,
		-1,
		316,
		-1,
		258,
		242,
		244,
		216,
		237,
		-1,
		274,
		258,
		250,
		235,
		235,
		-1,
		205,
		202,
		192,
		170,
		155,
		172,
		164,
		162,
		166,
		148,
		162,
		153,
		171,
		178,
		176,
		180,
		200,
		212,
		276,
		266,
		-1,
		248,
		253,
		212,
		220,
		239,
		277,
		241,
		-1,
		236,
		-1,
		207,
		220,
		-1,
		176,
		172,
		154,
		155,
		150,
		165,
		159,
		144,
		141,
		159,
		162,
		169,
		173,
		189,
		-1,
		-1,
		261,
		265,
		254,
		205,
		224,
		248,
		285,
		234,
		223,
		222,
		-1,
		213,
		190,
		187,
		175,
		162,
		147,
		148,
		156,
		169,
		148,
		143,
		140,
		160,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		231,
		202,
		226,
		268,
		252,
		245,
		233,
		198,
		198,
		192,
		-1,
		186,
		165,
		156,
		145,
		143,
		156,
		153,
		158,
		138,
		136,
		155,
		167,
		158,
		175,
		-1,
		-1,
		-1,
		261,
		250,
		251,
		197,
		220,
		257,
		231,
		217,
		222,
		197,
		190,
		184,
		199,
		182,
		163,
		152,
		144,
		133,
		149,
		157,
		152,
		134,
		143,
		149,
		173,
		163,
		169,
		-1,
		-1,
		268,
		258,
		242,
		244,
		241,
		211,
		218,
		250,
		222,
		235,
		-1,
		189,
		-1,
		178,
		173,
		157,
		152,
		149,
		146,
		140,
		149,
		151,
		141,
		136,
		143,
		178,
		178,
		153,
		173,
		176,
		-1,
		-1,
		-1,
		261,
		256,
		231,
		208,
		192,
		228,
		-1,
		205,
		206,
		-1,
		183,
		177,
		174,
		159,
		155,
		150,
		154,
		147,
		154,
		147,
		145,
		146,
		128,
		160,
		-1,
		161,
		155,
		163,
		153,
		141,
		-1,
		-1,
		-1,
		254,
		233,
		226,
		246,
		187,
		239,
		-1,
		-1,
		190,
		183,
		-1,
		170,
		152,
		159,
		157,
		151,
		155,
		152,
		141,
		154,
		147,
		133,
		135,
		148,
		152,
		156,
		143,
		139,
		136,
		150,
		-1,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		207,
		-1,
		199,
		191,
		181,
		175,
		169,
		165,
		163,
		179,
		163,
		166,
		164,
		155,
		163,
		136,
		129,
		136,
		125,
		143,
		151,
		143,
		137,
		136,
		146,
		-1,
		274,
		260,
		231,
		-1,
		-1,
		220,
		-1,
		184,
		198,
		214,
		-1,
		207,
		186,
		201,
		179,
		175,
		171,
		186,
		187,
		165,
		164,
		162,
		153,
		141,
		130,
		133,
		125,
		147,
		147,
		131,
		132,
		136,
		-1,
		280,
		267,
		225,
		221,
		210,
		230,
		181,
		169,
		201,
		-1,
		-1,
		243,
		-1,
		177,
		194,
		185,
		183,
		176,
		167,
		173,
		173,
		150,
		145,
		135,
		124,
		124,
		119,
		141,
		127,
		125,
		134,
		150,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		196,
		183,
		177,
		-1,
		218,
		-1,
		221,
		211,
		195,
		180,
		213,
		-1,
		168,
		164,
		171,
		-1,
		170,
		-1,
		143,
		140,
		131,
		116,
		113,
		124,
		122,
		133,
		129,
		-1,
		230,
		215,
		208,
		198,
		212,
		183,
		-1,
		238,
		-1,
		-1,
		208,
		202,
		202,
		186,
		189,
		184,
		164,
		156,
		171,
		165,
		157,
		151,
		129,
		122,
		119,
		112,
		125,
		135,
		140,
		127,
		-1,
		-1,
		-1,
		235,
		221,
		225,
		185,
		204,
		-1,
		-1,
		270,
		225,
		211,
		-1,
		193,
		184,
		172,
		162,
		152,
		157,
		158,
		148,
		141,
		127,
		129,
		123,
		114,
		113,
		129,
		121,
		143,
		-1,
		-1,
		218,
		223,
		211,
		197,
		216,
		-1,
		-1,
		-1,
		217,
		233,
		212,
		191,
		173,
		-1,
		-1,
		156,
		149,
		143,
		144,
		131,
		143,
		138,
		122,
		107,
		122,
		126,
		134,
		125,
		-1,
		221,
		208,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		-1,
		-1,
		224,
		169,
		158,
		153,
		157,
		155,
		-1,
		129,
		140,
		133,
		147,
		154,
		124,
		109,
		103,
		109,
		121,
		130,
		-1,
		-1,
		233,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		181,
		175,
		146,
		139,
		143,
		-1,
		131,
		133,
		130,
		142,
		127,
		124,
		115,
		106,
		102,
		106,
		110,
		124,
		128,
		256,
		-1,
		202,
		-1,
		-1,
		-1,
		199,
		214,
		185,
		162,
		135,
		130,
		123,
		117,
		122,
		133,
		135,
		146,
		113,
		109,
		99,
		98,
		102,
		119,
		119,
		-1,
		-1,
		200,
		196,
		225,
		207,
		211,
		212,
		-1,
		-1,
		139,
		130,
		121,
		113,
		126,
		129,
		114,
		116,
		110,
		103,
		97,
		107,
		118,
		113,
		-1,
		-1,
		-1,
		212,
		-1,
		214,
		-1,
		-1,
		202,
		210,
		157,
		139,
		135,
		133,
		120,
		114,
		104,
		109,
		119,
		111,
		105,
		93,
		93,
		116,
		105,
		122,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		191,
		183,
		178,
		184,
		186,
		177,
		172,
		169,
		-1,
		139,
		143,
		110,
		117,
		100,
		107,
		112,
		107,
		87,
		90,
		106,
		105,
		100,
		114,
		105,
		109,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		184,
		180,
		170,
		160,
		163,
		-1,
		-1,
		157,
		154,
		134,
		103,
		108,
		101,
		96,
		101,
		82,
		83,
		83,
		78,
		93,
		98,
		100,
		93,
		100,
		115,
		-1,
		231,
		268,
		261,
		229,
		237,
		268,
		-1,
		174,
		166,
		177,
		152,
		154,
		-1,
		-1,
		130,
		121,
		122,
		110,
		107,
		120,
		119,
		86,
		83,
		98,
		76,
		83,
		94,
		86,
		90,
		91,
		98,
		109,
		113,
		-1,
		224,
		244,
		223,
		226,
		250,
		264,
		-1,
		171,
		-1,
		-1,
		183,
		155,
		139,
		129,
		126,
		169,
		116,
		111,
		88,
		86,
		83,
		74,
		100,
		83,
		72,
		69,
		78,
		83,
		75,
		101,
		103,
		100,
		-1,
		213,
		224,
		217,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		181,
		-1,
		166,
		-1,
		149,
		153,
		124,
		127,
		102,
		89,
		75,
		75,
		81,
		81,
		80,
		76,
		65,
		74,
		85,
		97,
		107,
		109,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		183,
		222,
		187,
		-1,
		171,
		-1,
		-1,
		-1,
		163,
		137,
		129,
		122,
		101,
		101,
		67,
		63,
		76,
		83,
		90,
		82,
		66,
		78,
		91,
		102,
		108,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		198,
		189,
		216,
		194,
		183,
		178,
		165,
		-1,
		-1,
		144,
		147,
		-1,
		-1,
		108,
		84,
		71,
		65,
		69,
		83,
		90,
		78,
		58,
		78,
		73,
		104,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		217,
		207,
		211,
		225,
		250,
		-1,
		154,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		89,
		78,
		69,
		55,
		77,
		88,
		105,
		54,
		71,
		78,
		88,
		89,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		211,
		239,
		-1,
		-1,
		170,
		150,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		66,
		52,
		77,
		63,
		63,
		57,
		51,
		58,
		75,
		88,
		82,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		160,
		156,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		66,
		50,
		40,
		51,
		54,
		49,
		60,
		65,
		69,
		76,
		-1,
		254,
		-1,
		206,
		182,
		196,
		211,
		219,
		-1,
		-1,
		-1,
		177,
		163,
		156,
		144,
		142,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		62,
		31,
		39,
		47,
		43,
		54,
		61,
		71,
		69,
		72,
		-1,
		-1,
		194,
		193,
		-1,
		-1,
		167,
		169,
		-1,
		168,
		157,
		142,
		134,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		72,
		32,
		29,
		45,
		44,
		39,
		51,
		47,
		59,
		74,
		66,
		-1,
		-1,
		188,
		180,
		174,
		-1,
		152,
		-1,
		170,
		-1,
		137,
		143,
		131,
		-1,
		-1,
		-1,
		110,
		73,
		94,
		39,
		2,
		0,
		34,
		35,
		42,
		52,
		60,
		66,
		-1,
		-1,
		-1,
		170,
		144,
		177,
		168,
		151,
		131,
		123,
		142,
		-1,
		109,
		-1,
		77,
		74,
		53,
		10,
		29,
		23,
		38,
		50,
		49,
		58,
		56,
		176,
		-1,
		146,
		179,
		143,
		137,
		113,
		117,
		133,
		-1,
		106,
		85,
		-1,
		91,
		60,
		46,
		32,
		48,
		36,
		43,
		57,
		53,
		-1,
		-1,
		-1,
		148,
		147,
		139,
		133,
		133,
		118,
		109,
		-1,
		121,
		103,
		82,
		99,
		89,
		80,
		78,
		36,
		32,
		54,
		56,
		48,
		-1,
		249,
		-1,
		-1,
		171,
		-1,
		-1,
		-1,
		142,
		137,
		110,
		98,
		104,
		100,
		86,
		92,
		94,
		81,
		75,
		79,
		73,
		66,
		70,
		49,
		85,
		-1,
		244,
		-1,
		178,
		-1,
		-1,
		160,
		140,
		132,
		121,
		110,
		108,
		99,
		90,
		112,
		117,
		72,
		61,
		56,
		57,
		-1,
		233,
		232,
		-1,
		179,
		171,
		157,
		-1,
		150,
		-1,
		156,
		117,
		-1,
		119,
		99,
		-1,
		72,
		61,
		-1,
		-1,
		220,
		195,
		-1,
		-1,
		-1,
		180,
		160,
		151,
		135,
		-1,
		110,
		110,
		-1,
		-1,
		-1,
		205,
		204,
		-1,
		173,
		176,
		-1,
		166,
		157,
		165,
		112,
		116,
		-1,
		-1,
		-1,
		214,
		195,
		189,
		188,
		186,
		181,
		178,
		164,
		148,
		126,
		115,
		136,
		-1,
		-1,
		-1,
		186,
		178,
		171,
		-1,
		-1,
		173,
		156,
		137,
		135,
		-1,
		-1,
		-1,
		208,
		189,
		-1,
		-1,
		163,
		-1,
		-1,
		169,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		197,
		-1,
		-1,
		-1,
		159,
		155,
		156,
		-1,
		-1,
		-1,
		-1,
		219,
		220,
		243,
		207,
		-1,
		-1,
		-1,
		151,
		145,
		-1,
		-1,
		222,
		220,
		-1,
		-1,
		-1,
		179,
		163,
		-1,
		149,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		184,
		-1,
		184,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		197,
		189,
		197,
		-1,
		169,
		171,
		-1,
		219,
		-1,
		-1,
		212,
		203,
		-1,
		-1,
		174,
		181,
		203,
		206,
		242,
		-1,
		193
	],
	[
		-1,
		238,
		227,
		238,
		246,
		219,
		226,
		-1,
		245,
		249,
		215,
		209,
		248,
		217,
		223,
		234,
		-1,
		-1,
		-1,
		238,
		237,
		205,
		203,
		212,
		217,
		224,
		-1,
		223,
		-1,
		259,
		238,
		249,
		254,
		198,
		195,
		215,
		234,
		216,
		208,
		274,
		228,
		199,
		193,
		211,
		201,
		210,
		202,
		-1,
		199,
		189,
		211,
		190,
		201,
		193,
		-1,
		-1,
		193,
		194,
		200,
		186,
		192,
		188,
		-1,
		198,
		182,
		-1,
		-1,
		183,
		184,
		168,
		171,
		179,
		177,
		190,
		182,
		177,
		-1,
		-1,
		174,
		170,
		177,
		164,
		160,
		177,
		190,
		172,
		186,
		185,
		-1,
		178,
		196,
		203,
		171,
		169,
		153,
		151,
		169,
		171,
		177,
		177,
		-1,
		187,
		188,
		183,
		191,
		193,
		169,
		156,
		156,
		166,
		159,
		178,
		166,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		187,
		170,
		187,
		179,
		169,
		184,
		177,
		159,
		156,
		154,
		151,
		167,
		165,
		175,
		-1,
		-1,
		280,
		249,
		278,
		236,
		217,
		-1,
		183,
		163,
		169,
		173,
		167,
		160,
		174,
		170,
		-1,
		145,
		144,
		172,
		158,
		169,
		240,
		-1,
		-1,
		238,
		230,
		213,
		216,
		193,
		189,
		178,
		177,
		169,
		155,
		151,
		157,
		160,
		160,
		166,
		139,
		149,
		153,
		151,
		176,
		-1,
		-1,
		211,
		-1,
		-1,
		237,
		220,
		-1,
		203,
		210,
		199,
		205,
		191,
		212,
		188,
		179,
		171,
		165,
		153,
		155,
		152,
		165,
		153,
		136,
		161,
		165,
		146,
		167,
		162,
		-1,
		210,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		196,
		199,
		205,
		229,
		228,
		-1,
		200,
		188,
		189,
		174,
		171,
		158,
		146,
		159,
		144,
		151,
		150,
		140,
		138,
		168,
		143,
		165,
		162,
		181,
		186,
		180,
		189,
		-1,
		245,
		241,
		237,
		244,
		193,
		-1,
		-1,
		233,
		-1,
		236,
		237,
		212,
		185,
		188,
		175,
		166,
		153,
		142,
		153,
		142,
		139,
		147,
		132,
		147,
		138,
		137,
		155,
		165,
		173,
		177,
		183,
		-1,
		295,
		-1,
		237,
		221,
		223,
		195,
		216,
		-1,
		253,
		237,
		229,
		214,
		214,
		-1,
		184,
		181,
		171,
		149,
		134,
		151,
		143,
		141,
		145,
		127,
		141,
		132,
		150,
		157,
		155,
		159,
		179,
		191,
		255,
		245,
		-1,
		227,
		232,
		191,
		199,
		218,
		256,
		220,
		-1,
		215,
		-1,
		186,
		199,
		-1,
		155,
		151,
		133,
		134,
		129,
		144,
		138,
		123,
		120,
		138,
		141,
		148,
		152,
		168,
		-1,
		-1,
		240,
		244,
		233,
		184,
		203,
		227,
		264,
		213,
		202,
		201,
		-1,
		192,
		169,
		166,
		154,
		141,
		126,
		127,
		135,
		148,
		127,
		122,
		119,
		139,
		165,
		143,
		155,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		210,
		181,
		205,
		247,
		231,
		224,
		212,
		177,
		177,
		171,
		-1,
		165,
		144,
		135,
		124,
		122,
		135,
		132,
		137,
		117,
		115,
		134,
		146,
		137,
		154,
		-1,
		-1,
		-1,
		240,
		229,
		230,
		176,
		199,
		236,
		210,
		196,
		201,
		176,
		169,
		163,
		178,
		161,
		142,
		131,
		123,
		112,
		128,
		136,
		131,
		113,
		122,
		128,
		152,
		142,
		148,
		-1,
		-1,
		247,
		237,
		221,
		223,
		220,
		190,
		197,
		229,
		201,
		214,
		-1,
		168,
		-1,
		157,
		152,
		136,
		131,
		128,
		125,
		119,
		128,
		130,
		120,
		115,
		122,
		157,
		157,
		132,
		152,
		155,
		-1,
		-1,
		-1,
		240,
		235,
		210,
		187,
		171,
		207,
		-1,
		184,
		185,
		-1,
		162,
		156,
		153,
		138,
		134,
		129,
		133,
		126,
		133,
		126,
		124,
		125,
		107,
		139,
		-1,
		140,
		134,
		142,
		132,
		120,
		-1,
		-1,
		-1,
		233,
		212,
		205,
		225,
		166,
		218,
		-1,
		-1,
		169,
		162,
		-1,
		149,
		131,
		138,
		136,
		130,
		134,
		131,
		120,
		133,
		126,
		112,
		114,
		127,
		131,
		135,
		122,
		118,
		115,
		129,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		186,
		-1,
		178,
		170,
		160,
		154,
		148,
		144,
		142,
		158,
		142,
		145,
		143,
		134,
		142,
		115,
		108,
		115,
		104,
		122,
		130,
		122,
		116,
		115,
		125,
		-1,
		253,
		239,
		210,
		-1,
		-1,
		199,
		-1,
		163,
		177,
		193,
		-1,
		186,
		165,
		180,
		158,
		154,
		150,
		165,
		166,
		144,
		143,
		141,
		132,
		120,
		109,
		112,
		104,
		126,
		126,
		110,
		111,
		115,
		-1,
		259,
		246,
		204,
		200,
		189,
		209,
		160,
		148,
		180,
		-1,
		-1,
		222,
		-1,
		156,
		173,
		164,
		162,
		155,
		146,
		152,
		152,
		129,
		124,
		114,
		103,
		103,
		98,
		120,
		106,
		104,
		113,
		129,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		175,
		162,
		156,
		-1,
		197,
		-1,
		200,
		190,
		174,
		159,
		192,
		-1,
		152,
		147,
		152,
		-1,
		149,
		-1,
		122,
		119,
		110,
		95,
		92,
		103,
		101,
		112,
		108,
		-1,
		209,
		194,
		187,
		177,
		191,
		162,
		-1,
		217,
		-1,
		-1,
		187,
		181,
		181,
		165,
		168,
		168,
		148,
		140,
		152,
		144,
		136,
		130,
		108,
		101,
		98,
		91,
		104,
		114,
		119,
		106,
		-1,
		-1,
		-1,
		214,
		200,
		204,
		164,
		183,
		-1,
		-1,
		249,
		204,
		190,
		-1,
		174,
		168,
		156,
		146,
		136,
		141,
		142,
		127,
		120,
		106,
		108,
		102,
		93,
		92,
		108,
		100,
		122,
		-1,
		-1,
		197,
		202,
		190,
		176,
		195,
		-1,
		-1,
		-1,
		196,
		212,
		196,
		175,
		157,
		-1,
		-1,
		140,
		133,
		127,
		123,
		110,
		122,
		117,
		101,
		86,
		101,
		105,
		113,
		104,
		-1,
		200,
		187,
		-1,
		-1,
		198,
		192,
		-1,
		-1,
		-1,
		-1,
		208,
		153,
		142,
		137,
		141,
		139,
		-1,
		113,
		124,
		114,
		126,
		133,
		103,
		88,
		82,
		88,
		100,
		109,
		-1,
		-1,
		212,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		165,
		159,
		130,
		123,
		127,
		-1,
		115,
		117,
		114,
		126,
		106,
		103,
		94,
		85,
		81,
		85,
		89,
		103,
		107,
		235,
		-1,
		186,
		-1,
		-1,
		-1,
		183,
		198,
		169,
		146,
		119,
		114,
		107,
		101,
		106,
		117,
		114,
		125,
		92,
		88,
		78,
		77,
		81,
		98,
		98,
		-1,
		-1,
		184,
		180,
		209,
		191,
		195,
		196,
		-1,
		-1,
		123,
		114,
		105,
		97,
		110,
		113,
		98,
		95,
		89,
		82,
		76,
		86,
		97,
		92,
		-1,
		-1,
		-1,
		196,
		-1,
		198,
		-1,
		-1,
		186,
		194,
		141,
		123,
		119,
		117,
		104,
		98,
		88,
		93,
		99,
		90,
		84,
		72,
		72,
		95,
		84,
		101,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		175,
		167,
		162,
		168,
		170,
		161,
		156,
		153,
		-1,
		123,
		127,
		94,
		101,
		84,
		91,
		94,
		86,
		66,
		69,
		85,
		84,
		79,
		93,
		84,
		88,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		168,
		164,
		154,
		144,
		147,
		-1,
		-1,
		141,
		138,
		118,
		87,
		92,
		85,
		80,
		85,
		66,
		62,
		62,
		57,
		72,
		77,
		79,
		72,
		79,
		94,
		-1,
		215,
		252,
		245,
		213,
		221,
		252,
		-1,
		158,
		150,
		161,
		136,
		138,
		-1,
		-1,
		114,
		105,
		106,
		94,
		91,
		104,
		100,
		70,
		67,
		77,
		55,
		62,
		73,
		65,
		69,
		70,
		77,
		88,
		92,
		-1,
		208,
		228,
		207,
		210,
		234,
		248,
		-1,
		155,
		-1,
		-1,
		167,
		139,
		123,
		113,
		110,
		153,
		100,
		95,
		72,
		70,
		67,
		58,
		79,
		63,
		51,
		48,
		57,
		62,
		54,
		80,
		82,
		79,
		-1,
		197,
		208,
		201,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		165,
		-1,
		150,
		-1,
		133,
		137,
		108,
		111,
		86,
		73,
		59,
		59,
		65,
		63,
		59,
		55,
		44,
		53,
		64,
		76,
		86,
		88,
		222,
		178,
		181,
		192,
		203,
		218,
		222,
		-1,
		167,
		206,
		171,
		-1,
		155,
		-1,
		-1,
		-1,
		147,
		121,
		113,
		106,
		85,
		85,
		51,
		47,
		60,
		64,
		69,
		61,
		45,
		57,
		70,
		81,
		87,
		218,
		209,
		222,
		167,
		167,
		188,
		197,
		218,
		182,
		173,
		200,
		178,
		167,
		162,
		149,
		-1,
		-1,
		128,
		131,
		-1,
		-1,
		92,
		68,
		55,
		49,
		53,
		67,
		69,
		57,
		37,
		57,
		52,
		83,
		-1,
		211,
		210,
		199,
		196,
		172,
		163,
		158,
		185,
		-1,
		-1,
		180,
		201,
		191,
		195,
		209,
		234,
		-1,
		138,
		-1,
		-1,
		108,
		-1,
		-1,
		93,
		73,
		62,
		53,
		39,
		61,
		72,
		84,
		33,
		50,
		57,
		67,
		68,
		195,
		192,
		180,
		178,
		201,
		166,
		154,
		-1,
		167,
		165,
		171,
		178,
		195,
		223,
		-1,
		-1,
		154,
		134,
		-1,
		-1,
		91,
		89,
		78,
		-1,
		68,
		50,
		36,
		63,
		44,
		42,
		36,
		30,
		37,
		54,
		67,
		61,
		204,
		218,
		207,
		203,
		202,
		210,
		159,
		152,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		144,
		140,
		-1,
		-1,
		86,
		79,
		67,
		55,
		45,
		50,
		36,
		32,
		32,
		33,
		28,
		39,
		44,
		48,
		55,
		-1,
		238,
		-1,
		190,
		166,
		180,
		195,
		203,
		-1,
		-1,
		-1,
		161,
		147,
		140,
		128,
		126,
		-1,
		120,
		104,
		85,
		-1,
		55,
		68,
		68,
		36,
		22,
		26,
		22,
		30,
		40,
		50,
		48,
		51,
		-1,
		-1,
		178,
		177,
		-1,
		-1,
		151,
		153,
		-1,
		152,
		141,
		126,
		118,
		-1,
		-1,
		92,
		88,
		-1,
		-1,
		56,
		50,
		39,
		28,
		27,
		18,
		26,
		26,
		38,
		53,
		45,
		-1,
		-1,
		172,
		164,
		158,
		-1,
		136,
		-1,
		154,
		-1,
		121,
		127,
		115,
		-1,
		-1,
		-1,
		94,
		57,
		78,
		57,
		20,
		18,
		0,
		14,
		21,
		31,
		39,
		45,
		-1,
		-1,
		-1,
		154,
		128,
		161,
		152,
		135,
		115,
		107,
		126,
		-1,
		93,
		-1,
		61,
		58,
		71,
		28,
		31,
		25,
		15,
		23,
		28,
		37,
		35,
		160,
		-1,
		130,
		163,
		127,
		121,
		97,
		101,
		117,
		-1,
		90,
		69,
		-1,
		88,
		75,
		48,
		34,
		28,
		15,
		22,
		36,
		32,
		-1,
		-1,
		-1,
		132,
		131,
		123,
		117,
		117,
		102,
		93,
		-1,
		105,
		87,
		66,
		83,
		68,
		59,
		59,
		38,
		34,
		33,
		35,
		27,
		-1,
		233,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		126,
		121,
		94,
		82,
		88,
		84,
		70,
		76,
		78,
		71,
		61,
		58,
		54,
		45,
		49,
		28,
		64,
		-1,
		228,
		-1,
		162,
		-1,
		-1,
		144,
		124,
		116,
		105,
		94,
		92,
		83,
		74,
		96,
		102,
		52,
		40,
		35,
		36,
		-1,
		217,
		216,
		-1,
		163,
		155,
		141,
		-1,
		134,
		-1,
		140,
		101,
		-1,
		103,
		83,
		-1,
		51,
		40,
		-1,
		-1,
		204,
		179,
		-1,
		-1,
		-1,
		164,
		144,
		135,
		119,
		-1,
		94,
		94,
		-1,
		-1,
		-1,
		189,
		188,
		-1,
		157,
		160,
		-1,
		150,
		141,
		149,
		96,
		100,
		-1,
		-1,
		-1,
		198,
		179,
		173,
		172,
		170,
		165,
		162,
		148,
		132,
		110,
		99,
		120,
		-1,
		-1,
		-1,
		170,
		162,
		155,
		-1,
		-1,
		157,
		140,
		121,
		119,
		-1,
		-1,
		-1,
		192,
		173,
		-1,
		-1,
		147,
		-1,
		-1,
		153,
		118,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		181,
		-1,
		-1,
		-1,
		143,
		139,
		140,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		227,
		191,
		-1,
		-1,
		-1,
		135,
		129,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		133,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		166,
		-1,
		-1,
		-1,
		168,
		-1,
		168,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		181,
		173,
		181,
		-1,
		153,
		155,
		-1,
		203,
		-1,
		-1,
		196,
		187,
		-1,
		-1,
		158,
		165,
		187,
		190,
		226,
		-1,
		177
	],
	[
		-1,
		224,
		213,
		224,
		232,
		205,
		212,
		-1,
		231,
		235,
		201,
		195,
		234,
		203,
		209,
		220,
		-1,
		-1,
		-1,
		224,
		223,
		191,
		189,
		198,
		203,
		210,
		-1,
		209,
		-1,
		245,
		224,
		235,
		240,
		184,
		181,
		201,
		220,
		202,
		194,
		260,
		214,
		185,
		179,
		197,
		187,
		196,
		188,
		-1,
		185,
		175,
		197,
		176,
		187,
		179,
		-1,
		-1,
		179,
		180,
		186,
		172,
		178,
		174,
		-1,
		184,
		168,
		-1,
		-1,
		169,
		170,
		154,
		157,
		165,
		163,
		176,
		168,
		163,
		-1,
		-1,
		160,
		156,
		163,
		150,
		146,
		163,
		176,
		158,
		172,
		171,
		-1,
		164,
		182,
		189,
		157,
		155,
		139,
		137,
		155,
		157,
		163,
		163,
		-1,
		173,
		174,
		169,
		177,
		179,
		155,
		142,
		142,
		152,
		145,
		164,
		152,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		173,
		156,
		173,
		165,
		155,
		170,
		163,
		145,
		142,
		140,
		137,
		153,
		151,
		161,
		-1,
		-1,
		266,
		235,
		264,
		222,
		203,
		-1,
		169,
		149,
		155,
		159,
		153,
		146,
		160,
		156,
		-1,
		131,
		130,
		158,
		144,
		155,
		226,
		-1,
		-1,
		224,
		216,
		199,
		202,
		179,
		175,
		164,
		163,
		155,
		141,
		137,
		143,
		146,
		146,
		152,
		125,
		135,
		139,
		137,
		162,
		-1,
		-1,
		197,
		-1,
		-1,
		223,
		206,
		-1,
		189,
		196,
		185,
		191,
		177,
		198,
		174,
		165,
		157,
		151,
		139,
		141,
		138,
		151,
		139,
		122,
		147,
		151,
		132,
		153,
		148,
		-1,
		196,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		182,
		185,
		191,
		215,
		214,
		-1,
		186,
		174,
		175,
		160,
		157,
		144,
		132,
		145,
		130,
		137,
		136,
		126,
		124,
		154,
		129,
		151,
		148,
		167,
		172,
		166,
		175,
		-1,
		231,
		227,
		223,
		230,
		179,
		-1,
		-1,
		219,
		-1,
		222,
		223,
		198,
		171,
		174,
		161,
		152,
		139,
		128,
		139,
		128,
		125,
		133,
		118,
		133,
		124,
		123,
		141,
		151,
		159,
		163,
		169,
		-1,
		281,
		-1,
		223,
		207,
		209,
		181,
		202,
		-1,
		239,
		223,
		215,
		200,
		200,
		-1,
		170,
		167,
		157,
		135,
		120,
		137,
		129,
		127,
		131,
		113,
		127,
		118,
		136,
		143,
		141,
		145,
		165,
		177,
		241,
		231,
		-1,
		213,
		218,
		177,
		185,
		204,
		242,
		206,
		-1,
		201,
		-1,
		172,
		185,
		-1,
		141,
		137,
		119,
		120,
		115,
		130,
		124,
		109,
		106,
		124,
		127,
		134,
		138,
		154,
		-1,
		-1,
		226,
		230,
		219,
		170,
		189,
		213,
		250,
		199,
		188,
		187,
		-1,
		178,
		155,
		152,
		140,
		127,
		112,
		113,
		121,
		134,
		113,
		108,
		105,
		125,
		151,
		129,
		141,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		196,
		167,
		191,
		233,
		217,
		210,
		198,
		163,
		163,
		157,
		-1,
		151,
		130,
		121,
		110,
		108,
		121,
		118,
		123,
		103,
		101,
		120,
		132,
		123,
		140,
		-1,
		-1,
		-1,
		226,
		215,
		216,
		162,
		185,
		222,
		196,
		182,
		187,
		162,
		155,
		149,
		164,
		147,
		128,
		117,
		109,
		98,
		114,
		122,
		117,
		99,
		108,
		114,
		138,
		128,
		134,
		-1,
		-1,
		233,
		223,
		207,
		209,
		206,
		176,
		183,
		215,
		187,
		200,
		-1,
		154,
		-1,
		143,
		138,
		122,
		117,
		114,
		111,
		105,
		114,
		116,
		106,
		101,
		108,
		143,
		143,
		118,
		138,
		141,
		-1,
		-1,
		-1,
		226,
		221,
		196,
		173,
		157,
		193,
		-1,
		170,
		171,
		-1,
		148,
		142,
		139,
		124,
		120,
		115,
		119,
		112,
		119,
		112,
		110,
		111,
		93,
		125,
		-1,
		126,
		120,
		128,
		118,
		106,
		-1,
		-1,
		-1,
		219,
		198,
		191,
		211,
		152,
		204,
		-1,
		-1,
		155,
		148,
		-1,
		135,
		117,
		124,
		122,
		116,
		120,
		117,
		106,
		119,
		112,
		98,
		100,
		113,
		117,
		121,
		108,
		104,
		101,
		115,
		-1,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		172,
		-1,
		164,
		156,
		146,
		140,
		134,
		130,
		128,
		144,
		128,
		131,
		129,
		120,
		128,
		101,
		94,
		101,
		90,
		108,
		116,
		108,
		102,
		101,
		111,
		-1,
		239,
		225,
		196,
		-1,
		-1,
		185,
		-1,
		149,
		163,
		179,
		-1,
		172,
		151,
		166,
		144,
		140,
		136,
		151,
		152,
		130,
		129,
		127,
		118,
		106,
		95,
		98,
		90,
		112,
		112,
		96,
		97,
		101,
		-1,
		245,
		232,
		190,
		186,
		175,
		195,
		146,
		134,
		166,
		-1,
		-1,
		208,
		-1,
		142,
		159,
		150,
		148,
		141,
		132,
		138,
		138,
		115,
		110,
		100,
		89,
		89,
		84,
		106,
		92,
		90,
		99,
		115,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		161,
		148,
		142,
		-1,
		183,
		-1,
		186,
		176,
		160,
		145,
		178,
		-1,
		143,
		133,
		138,
		-1,
		135,
		-1,
		108,
		105,
		96,
		81,
		78,
		89,
		87,
		98,
		94,
		-1,
		195,
		180,
		173,
		163,
		177,
		148,
		-1,
		203,
		-1,
		-1,
		173,
		167,
		167,
		151,
		154,
		159,
		139,
		131,
		138,
		130,
		122,
		116,
		94,
		87,
		84,
		77,
		90,
		100,
		105,
		92,
		-1,
		-1,
		-1,
		200,
		186,
		190,
		150,
		169,
		-1,
		-1,
		235,
		190,
		176,
		-1,
		160,
		159,
		147,
		137,
		127,
		132,
		133,
		113,
		106,
		92,
		94,
		88,
		79,
		78,
		94,
		86,
		108,
		-1,
		-1,
		183,
		188,
		176,
		162,
		181,
		-1,
		-1,
		-1,
		182,
		198,
		187,
		161,
		148,
		-1,
		-1,
		131,
		124,
		118,
		109,
		96,
		108,
		103,
		87,
		72,
		87,
		91,
		99,
		90,
		-1,
		186,
		173,
		-1,
		-1,
		184,
		178,
		-1,
		-1,
		-1,
		-1,
		199,
		144,
		133,
		128,
		132,
		130,
		-1,
		104,
		115,
		100,
		112,
		119,
		89,
		74,
		68,
		74,
		86,
		95,
		-1,
		-1,
		198,
		-1,
		193,
		-1,
		-1,
		-1,
		-1,
		156,
		150,
		121,
		114,
		118,
		-1,
		106,
		108,
		102,
		117,
		92,
		89,
		80,
		71,
		67,
		71,
		75,
		89,
		93,
		221,
		-1,
		184,
		-1,
		-1,
		-1,
		174,
		189,
		160,
		137,
		110,
		105,
		98,
		92,
		97,
		108,
		100,
		111,
		78,
		74,
		64,
		63,
		67,
		84,
		84,
		-1,
		-1,
		182,
		178,
		200,
		182,
		186,
		187,
		-1,
		-1,
		114,
		105,
		96,
		88,
		101,
		104,
		84,
		81,
		75,
		68,
		62,
		72,
		83,
		78,
		-1,
		-1,
		-1,
		194,
		-1,
		196,
		-1,
		-1,
		184,
		185,
		132,
		114,
		110,
		108,
		97,
		91,
		79,
		84,
		85,
		76,
		70,
		58,
		58,
		81,
		70,
		87,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		173,
		165,
		160,
		166,
		168,
		159,
		147,
		144,
		-1,
		114,
		120,
		85,
		92,
		75,
		82,
		80,
		72,
		52,
		55,
		71,
		70,
		65,
		79,
		70,
		74,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		166,
		162,
		152,
		142,
		145,
		-1,
		-1,
		139,
		136,
		116,
		85,
		83,
		76,
		71,
		81,
		61,
		48,
		48,
		43,
		58,
		63,
		65,
		58,
		65,
		80,
		-1,
		213,
		250,
		243,
		211,
		219,
		250,
		-1,
		156,
		148,
		159,
		134,
		136,
		-1,
		-1,
		112,
		103,
		104,
		92,
		89,
		91,
		86,
		69,
		57,
		63,
		41,
		48,
		59,
		51,
		55,
		56,
		63,
		74,
		78,
		-1,
		206,
		226,
		205,
		208,
		232,
		246,
		-1,
		153,
		-1,
		-1,
		165,
		137,
		121,
		111,
		108,
		151,
		99,
		94,
		71,
		69,
		66,
		57,
		65,
		49,
		37,
		34,
		43,
		48,
		40,
		66,
		68,
		71,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		159,
		-1,
		148,
		-1,
		131,
		135,
		107,
		110,
		85,
		72,
		58,
		58,
		64,
		49,
		45,
		41,
		30,
		39,
		50,
		62,
		72,
		74,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		165,
		204,
		165,
		-1,
		149,
		-1,
		-1,
		-1,
		145,
		120,
		112,
		105,
		84,
		84,
		50,
		46,
		54,
		50,
		55,
		47,
		31,
		43,
		56,
		67,
		79,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		180,
		171,
		198,
		172,
		161,
		156,
		143,
		-1,
		-1,
		127,
		130,
		-1,
		-1,
		91,
		67,
		54,
		48,
		52,
		64,
		55,
		43,
		23,
		43,
		38,
		70,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		199,
		189,
		193,
		203,
		228,
		-1,
		132,
		-1,
		-1,
		107,
		-1,
		-1,
		92,
		72,
		61,
		52,
		38,
		60,
		59,
		70,
		19,
		36,
		43,
		53,
		60,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		165,
		163,
		169,
		176,
		193,
		217,
		-1,
		-1,
		148,
		128,
		-1,
		-1,
		90,
		88,
		77,
		-1,
		67,
		49,
		35,
		62,
		39,
		28,
		22,
		16,
		23,
		40,
		53,
		53,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		138,
		134,
		-1,
		-1,
		85,
		78,
		66,
		54,
		44,
		49,
		35,
		31,
		26,
		19,
		14,
		25,
		30,
		34,
		47,
		-1,
		236,
		-1,
		188,
		164,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		155,
		141,
		134,
		122,
		120,
		-1,
		119,
		103,
		84,
		-1,
		54,
		67,
		67,
		35,
		27,
		25,
		8,
		19,
		26,
		36,
		40,
		43,
		-1,
		-1,
		176,
		171,
		-1,
		-1,
		145,
		147,
		-1,
		146,
		135,
		120,
		112,
		-1,
		-1,
		91,
		87,
		-1,
		-1,
		55,
		49,
		38,
		33,
		29,
		4,
		16,
		12,
		24,
		39,
		37,
		-1,
		-1,
		166,
		158,
		152,
		-1,
		130,
		-1,
		148,
		-1,
		115,
		121,
		109,
		-1,
		-1,
		-1,
		93,
		56,
		77,
		56,
		25,
		23,
		14,
		0,
		7,
		17,
		25,
		37,
		-1,
		-1,
		-1,
		148,
		122,
		155,
		146,
		129,
		109,
		101,
		120,
		-1,
		90,
		-1,
		60,
		57,
		70,
		33,
		36,
		30,
		3,
		18,
		20,
		26,
		27,
		154,
		-1,
		124,
		157,
		121,
		115,
		91,
		95,
		111,
		-1,
		87,
		68,
		-1,
		80,
		67,
		53,
		39,
		20,
		7,
		14,
		28,
		24,
		-1,
		-1,
		-1,
		126,
		125,
		117,
		111,
		111,
		96,
		87,
		-1,
		99,
		81,
		60,
		75,
		60,
		51,
		51,
		43,
		39,
		27,
		27,
		19,
		-1,
		227,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		120,
		115,
		88,
		76,
		82,
		78,
		64,
		70,
		70,
		63,
		53,
		50,
		46,
		37,
		43,
		20,
		56,
		-1,
		222,
		-1,
		156,
		-1,
		-1,
		138,
		118,
		110,
		99,
		88,
		86,
		77,
		68,
		90,
		94,
		44,
		32,
		27,
		28,
		-1,
		211,
		210,
		-1,
		157,
		149,
		135,
		-1,
		128,
		-1,
		134,
		95,
		-1,
		97,
		77,
		-1,
		43,
		32,
		-1,
		-1,
		198,
		173,
		-1,
		-1,
		-1,
		158,
		138,
		129,
		113,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		183,
		182,
		-1,
		151,
		154,
		-1,
		144,
		135,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		192,
		173,
		167,
		166,
		164,
		159,
		156,
		142,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		164,
		156,
		149,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		186,
		167,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		175,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		197,
		198,
		221,
		185,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		200,
		198,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		234,
		223,
		234,
		242,
		215,
		222,
		-1,
		241,
		245,
		211,
		205,
		244,
		213,
		219,
		230,
		-1,
		-1,
		-1,
		234,
		233,
		201,
		199,
		208,
		213,
		220,
		-1,
		219,
		-1,
		255,
		234,
		245,
		250,
		194,
		191,
		211,
		230,
		212,
		204,
		270,
		224,
		195,
		189,
		207,
		197,
		206,
		198,
		-1,
		195,
		185,
		207,
		186,
		197,
		189,
		-1,
		-1,
		189,
		190,
		196,
		182,
		188,
		184,
		-1,
		194,
		178,
		-1,
		-1,
		179,
		180,
		164,
		167,
		175,
		173,
		186,
		178,
		173,
		-1,
		-1,
		170,
		166,
		173,
		160,
		156,
		173,
		186,
		168,
		182,
		181,
		-1,
		174,
		192,
		199,
		167,
		165,
		149,
		147,
		165,
		167,
		173,
		173,
		-1,
		183,
		184,
		179,
		187,
		189,
		165,
		152,
		152,
		162,
		155,
		174,
		162,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		183,
		166,
		183,
		175,
		165,
		180,
		173,
		155,
		152,
		150,
		147,
		163,
		161,
		171,
		-1,
		-1,
		276,
		245,
		274,
		232,
		213,
		-1,
		179,
		159,
		165,
		169,
		163,
		156,
		170,
		166,
		-1,
		141,
		140,
		168,
		154,
		165,
		236,
		-1,
		-1,
		234,
		226,
		209,
		212,
		189,
		185,
		174,
		173,
		165,
		151,
		147,
		153,
		156,
		156,
		162,
		135,
		145,
		149,
		147,
		172,
		-1,
		-1,
		207,
		-1,
		-1,
		233,
		216,
		-1,
		199,
		206,
		195,
		201,
		187,
		208,
		184,
		175,
		167,
		161,
		149,
		151,
		148,
		161,
		149,
		132,
		157,
		161,
		142,
		163,
		158,
		-1,
		206,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		192,
		195,
		201,
		225,
		224,
		-1,
		196,
		184,
		185,
		170,
		167,
		154,
		142,
		155,
		140,
		147,
		146,
		136,
		134,
		164,
		139,
		161,
		158,
		177,
		182,
		176,
		185,
		-1,
		241,
		237,
		233,
		240,
		189,
		-1,
		-1,
		229,
		-1,
		232,
		233,
		208,
		181,
		184,
		171,
		162,
		149,
		138,
		149,
		138,
		135,
		143,
		128,
		143,
		134,
		133,
		151,
		161,
		169,
		173,
		179,
		-1,
		291,
		-1,
		233,
		217,
		219,
		191,
		212,
		-1,
		249,
		233,
		225,
		210,
		210,
		-1,
		180,
		177,
		167,
		145,
		130,
		147,
		139,
		137,
		141,
		123,
		137,
		128,
		146,
		153,
		151,
		155,
		175,
		187,
		251,
		241,
		-1,
		223,
		228,
		187,
		195,
		214,
		252,
		216,
		-1,
		211,
		-1,
		182,
		195,
		-1,
		151,
		147,
		129,
		130,
		125,
		140,
		134,
		119,
		116,
		134,
		137,
		144,
		148,
		164,
		-1,
		-1,
		236,
		240,
		229,
		180,
		199,
		223,
		260,
		209,
		198,
		197,
		-1,
		188,
		165,
		162,
		150,
		137,
		122,
		123,
		131,
		144,
		123,
		118,
		115,
		135,
		161,
		139,
		151,
		-1,
		-1,
		-1,
		261,
		-1,
		-1,
		206,
		177,
		201,
		243,
		227,
		220,
		208,
		173,
		173,
		167,
		-1,
		161,
		140,
		131,
		120,
		118,
		131,
		128,
		133,
		113,
		111,
		130,
		142,
		133,
		150,
		-1,
		-1,
		-1,
		236,
		225,
		226,
		172,
		195,
		232,
		206,
		192,
		197,
		172,
		165,
		159,
		174,
		157,
		138,
		127,
		119,
		108,
		124,
		132,
		127,
		109,
		118,
		124,
		148,
		138,
		144,
		-1,
		-1,
		243,
		233,
		217,
		219,
		216,
		186,
		193,
		225,
		197,
		210,
		-1,
		164,
		-1,
		153,
		148,
		132,
		127,
		124,
		121,
		115,
		124,
		126,
		116,
		111,
		118,
		153,
		153,
		128,
		148,
		151,
		-1,
		-1,
		-1,
		236,
		231,
		206,
		183,
		167,
		203,
		-1,
		180,
		181,
		-1,
		158,
		152,
		149,
		134,
		130,
		125,
		129,
		122,
		129,
		122,
		120,
		121,
		103,
		135,
		-1,
		136,
		130,
		138,
		128,
		116,
		-1,
		-1,
		-1,
		229,
		208,
		201,
		221,
		162,
		214,
		-1,
		-1,
		165,
		158,
		-1,
		145,
		127,
		134,
		132,
		126,
		130,
		127,
		116,
		129,
		122,
		108,
		110,
		123,
		127,
		131,
		118,
		114,
		111,
		125,
		-1,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		182,
		-1,
		174,
		166,
		156,
		150,
		144,
		140,
		138,
		154,
		138,
		141,
		139,
		130,
		138,
		111,
		104,
		111,
		100,
		118,
		126,
		118,
		112,
		111,
		121,
		-1,
		249,
		235,
		206,
		-1,
		-1,
		195,
		-1,
		159,
		173,
		189,
		-1,
		182,
		161,
		176,
		154,
		150,
		146,
		161,
		162,
		140,
		139,
		137,
		128,
		116,
		105,
		108,
		100,
		122,
		122,
		106,
		107,
		111,
		-1,
		255,
		242,
		200,
		196,
		185,
		205,
		156,
		144,
		176,
		-1,
		-1,
		218,
		-1,
		152,
		169,
		160,
		158,
		151,
		142,
		148,
		148,
		125,
		120,
		110,
		99,
		99,
		94,
		116,
		102,
		100,
		109,
		125,
		-1,
		-1,
		-1,
		222,
		-1,
		-1,
		171,
		158,
		152,
		-1,
		193,
		-1,
		196,
		186,
		170,
		155,
		188,
		-1,
		153,
		143,
		148,
		-1,
		145,
		-1,
		118,
		115,
		106,
		91,
		88,
		99,
		97,
		108,
		104,
		-1,
		205,
		190,
		183,
		173,
		187,
		158,
		-1,
		213,
		-1,
		-1,
		183,
		177,
		177,
		161,
		164,
		169,
		149,
		141,
		148,
		140,
		132,
		126,
		104,
		97,
		94,
		87,
		100,
		110,
		115,
		102,
		-1,
		-1,
		-1,
		210,
		196,
		200,
		160,
		179,
		-1,
		-1,
		245,
		200,
		186,
		-1,
		170,
		169,
		157,
		147,
		137,
		142,
		143,
		123,
		116,
		102,
		104,
		98,
		89,
		88,
		104,
		96,
		118,
		-1,
		-1,
		193,
		198,
		186,
		172,
		191,
		-1,
		-1,
		-1,
		192,
		208,
		197,
		171,
		158,
		-1,
		-1,
		141,
		134,
		128,
		119,
		106,
		118,
		113,
		97,
		82,
		97,
		101,
		109,
		100,
		-1,
		196,
		183,
		-1,
		-1,
		194,
		188,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		110,
		122,
		129,
		99,
		84,
		78,
		84,
		96,
		105,
		-1,
		-1,
		208,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		112,
		127,
		102,
		99,
		90,
		81,
		77,
		81,
		85,
		99,
		103,
		231,
		-1,
		194,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		110,
		121,
		88,
		84,
		74,
		73,
		77,
		94,
		94,
		-1,
		-1,
		192,
		188,
		210,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		94,
		91,
		85,
		78,
		72,
		82,
		93,
		88,
		-1,
		-1,
		-1,
		204,
		-1,
		206,
		-1,
		-1,
		194,
		195,
		142,
		124,
		120,
		118,
		107,
		101,
		89,
		94,
		95,
		86,
		80,
		68,
		68,
		91,
		80,
		97,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		183,
		175,
		170,
		176,
		178,
		169,
		157,
		154,
		-1,
		124,
		130,
		95,
		102,
		85,
		92,
		90,
		82,
		62,
		65,
		81,
		80,
		75,
		89,
		80,
		84,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		176,
		172,
		162,
		152,
		155,
		-1,
		-1,
		149,
		146,
		126,
		95,
		93,
		86,
		81,
		91,
		71,
		58,
		58,
		53,
		68,
		73,
		75,
		68,
		75,
		90,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		166,
		158,
		169,
		144,
		146,
		-1,
		-1,
		122,
		113,
		114,
		102,
		99,
		101,
		96,
		79,
		67,
		73,
		51,
		58,
		69,
		61,
		65,
		66,
		73,
		84,
		88,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		163,
		-1,
		-1,
		175,
		147,
		131,
		121,
		118,
		161,
		109,
		104,
		81,
		79,
		76,
		67,
		75,
		59,
		47,
		44,
		53,
		58,
		50,
		76,
		78,
		74,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		169,
		-1,
		158,
		-1,
		141,
		145,
		117,
		120,
		95,
		82,
		68,
		68,
		74,
		59,
		55,
		51,
		40,
		42,
		54,
		58,
		68,
		84,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		175,
		214,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		155,
		130,
		122,
		115,
		94,
		94,
		60,
		56,
		64,
		60,
		65,
		57,
		41,
		41,
		52,
		63,
		78,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		181,
		208,
		182,
		171,
		166,
		153,
		-1,
		-1,
		137,
		140,
		-1,
		-1,
		101,
		77,
		64,
		58,
		62,
		74,
		65,
		53,
		33,
		40,
		34,
		66,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		209,
		199,
		203,
		213,
		238,
		-1,
		142,
		-1,
		-1,
		117,
		-1,
		-1,
		102,
		82,
		71,
		62,
		48,
		70,
		69,
		80,
		29,
		46,
		39,
		46,
		57,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		203,
		227,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		59,
		45,
		72,
		49,
		38,
		32,
		26,
		33,
		33,
		46,
		50,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		59,
		45,
		41,
		36,
		29,
		24,
		35,
		23,
		27,
		44,
		-1,
		246,
		-1,
		198,
		174,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		77,
		45,
		37,
		35,
		18,
		20,
		19,
		29,
		43,
		38,
		-1,
		-1,
		186,
		181,
		-1,
		-1,
		155,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		65,
		59,
		48,
		43,
		39,
		14,
		18,
		5,
		17,
		32,
		40,
		-1,
		-1,
		176,
		168,
		162,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		103,
		66,
		87,
		66,
		35,
		33,
		24,
		10,
		0,
		12,
		20,
		40,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		70,
		67,
		80,
		43,
		46,
		40,
		13,
		28,
		24,
		21,
		30,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		78,
		-1,
		90,
		77,
		63,
		49,
		30,
		17,
		24,
		34,
		27,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		85,
		70,
		61,
		61,
		53,
		49,
		37,
		37,
		29,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		80,
		73,
		63,
		60,
		56,
		47,
		53,
		30,
		66,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		104,
		54,
		42,
		37,
		38,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		53,
		42,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		236,
		225,
		236,
		244,
		217,
		224,
		-1,
		243,
		247,
		213,
		207,
		246,
		215,
		221,
		232,
		-1,
		-1,
		-1,
		236,
		235,
		203,
		201,
		210,
		215,
		222,
		-1,
		221,
		-1,
		257,
		236,
		247,
		252,
		196,
		193,
		213,
		232,
		214,
		206,
		272,
		226,
		197,
		191,
		209,
		199,
		208,
		200,
		-1,
		197,
		187,
		209,
		188,
		199,
		191,
		-1,
		-1,
		191,
		192,
		198,
		184,
		190,
		186,
		-1,
		196,
		180,
		-1,
		-1,
		181,
		182,
		166,
		169,
		177,
		175,
		188,
		180,
		175,
		-1,
		-1,
		172,
		168,
		175,
		162,
		158,
		175,
		188,
		170,
		184,
		183,
		-1,
		176,
		194,
		201,
		169,
		167,
		151,
		149,
		167,
		169,
		175,
		175,
		-1,
		185,
		186,
		181,
		189,
		191,
		167,
		154,
		154,
		164,
		157,
		176,
		164,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		185,
		168,
		185,
		177,
		167,
		182,
		175,
		157,
		154,
		152,
		149,
		165,
		163,
		173,
		-1,
		-1,
		278,
		247,
		276,
		234,
		215,
		-1,
		181,
		161,
		167,
		171,
		165,
		158,
		172,
		168,
		-1,
		143,
		142,
		170,
		156,
		167,
		238,
		-1,
		-1,
		236,
		228,
		211,
		214,
		191,
		187,
		176,
		175,
		167,
		153,
		149,
		155,
		158,
		158,
		164,
		137,
		147,
		151,
		149,
		174,
		-1,
		-1,
		209,
		-1,
		-1,
		235,
		218,
		-1,
		201,
		208,
		197,
		203,
		189,
		210,
		186,
		177,
		169,
		163,
		151,
		153,
		150,
		163,
		151,
		134,
		159,
		163,
		144,
		165,
		160,
		-1,
		208,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		194,
		197,
		203,
		227,
		226,
		-1,
		198,
		186,
		187,
		172,
		169,
		156,
		144,
		157,
		142,
		149,
		148,
		138,
		136,
		166,
		141,
		163,
		160,
		179,
		184,
		178,
		187,
		-1,
		243,
		239,
		235,
		242,
		191,
		-1,
		-1,
		231,
		-1,
		234,
		235,
		210,
		183,
		186,
		173,
		164,
		151,
		140,
		151,
		140,
		137,
		145,
		130,
		145,
		136,
		135,
		153,
		163,
		171,
		175,
		181,
		-1,
		293,
		-1,
		235,
		219,
		221,
		193,
		214,
		-1,
		251,
		235,
		227,
		212,
		212,
		-1,
		182,
		179,
		169,
		147,
		132,
		149,
		141,
		139,
		143,
		125,
		139,
		130,
		148,
		155,
		153,
		157,
		177,
		189,
		253,
		243,
		-1,
		225,
		230,
		189,
		197,
		216,
		254,
		218,
		-1,
		213,
		-1,
		184,
		197,
		-1,
		153,
		149,
		131,
		132,
		127,
		142,
		136,
		121,
		118,
		136,
		139,
		146,
		150,
		166,
		-1,
		-1,
		238,
		242,
		231,
		182,
		201,
		225,
		262,
		211,
		200,
		199,
		-1,
		190,
		167,
		164,
		152,
		139,
		124,
		125,
		133,
		146,
		125,
		120,
		117,
		137,
		163,
		141,
		153,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		208,
		179,
		203,
		245,
		229,
		222,
		210,
		175,
		175,
		169,
		-1,
		163,
		142,
		133,
		122,
		120,
		133,
		130,
		135,
		115,
		113,
		132,
		144,
		135,
		152,
		-1,
		-1,
		-1,
		238,
		227,
		228,
		174,
		197,
		234,
		208,
		194,
		199,
		174,
		167,
		161,
		176,
		159,
		140,
		129,
		121,
		110,
		126,
		134,
		129,
		111,
		120,
		126,
		150,
		140,
		146,
		-1,
		-1,
		245,
		235,
		219,
		221,
		218,
		188,
		195,
		227,
		199,
		212,
		-1,
		166,
		-1,
		155,
		150,
		134,
		129,
		126,
		123,
		117,
		126,
		128,
		118,
		113,
		120,
		155,
		155,
		130,
		150,
		153,
		-1,
		-1,
		-1,
		238,
		233,
		208,
		185,
		169,
		205,
		-1,
		182,
		183,
		-1,
		160,
		154,
		151,
		136,
		132,
		127,
		131,
		124,
		131,
		124,
		122,
		123,
		105,
		137,
		-1,
		138,
		132,
		140,
		130,
		118,
		-1,
		-1,
		-1,
		231,
		210,
		203,
		223,
		164,
		216,
		-1,
		-1,
		167,
		160,
		-1,
		147,
		129,
		136,
		134,
		128,
		132,
		129,
		118,
		131,
		124,
		110,
		112,
		125,
		129,
		133,
		120,
		116,
		113,
		127,
		-1,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		184,
		-1,
		176,
		168,
		158,
		152,
		146,
		142,
		140,
		156,
		140,
		143,
		141,
		132,
		140,
		113,
		106,
		113,
		102,
		120,
		128,
		120,
		114,
		113,
		123,
		-1,
		251,
		237,
		208,
		-1,
		-1,
		197,
		-1,
		161,
		175,
		191,
		-1,
		184,
		163,
		178,
		156,
		152,
		148,
		163,
		164,
		142,
		141,
		139,
		130,
		118,
		107,
		110,
		102,
		124,
		124,
		108,
		109,
		113,
		-1,
		257,
		244,
		202,
		198,
		187,
		207,
		158,
		146,
		178,
		-1,
		-1,
		220,
		-1,
		154,
		171,
		162,
		160,
		153,
		144,
		150,
		150,
		127,
		122,
		112,
		101,
		101,
		96,
		118,
		104,
		102,
		111,
		127,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		173,
		160,
		154,
		-1,
		195,
		-1,
		198,
		188,
		172,
		157,
		190,
		-1,
		155,
		145,
		150,
		-1,
		147,
		-1,
		120,
		117,
		108,
		93,
		90,
		101,
		99,
		110,
		106,
		-1,
		207,
		192,
		185,
		175,
		189,
		160,
		-1,
		215,
		-1,
		-1,
		185,
		179,
		179,
		163,
		166,
		171,
		151,
		143,
		150,
		142,
		134,
		128,
		106,
		99,
		96,
		89,
		102,
		112,
		117,
		104,
		-1,
		-1,
		-1,
		212,
		198,
		202,
		162,
		181,
		-1,
		-1,
		247,
		202,
		188,
		-1,
		172,
		171,
		159,
		149,
		139,
		144,
		145,
		125,
		118,
		104,
		106,
		100,
		91,
		90,
		106,
		98,
		120,
		-1,
		-1,
		195,
		200,
		188,
		174,
		193,
		-1,
		-1,
		-1,
		194,
		210,
		199,
		173,
		160,
		-1,
		-1,
		143,
		136,
		130,
		121,
		108,
		120,
		115,
		99,
		84,
		99,
		103,
		111,
		102,
		-1,
		198,
		185,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		-1,
		-1,
		211,
		156,
		145,
		140,
		144,
		142,
		-1,
		116,
		127,
		112,
		124,
		131,
		101,
		86,
		80,
		86,
		98,
		107,
		-1,
		-1,
		210,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		168,
		162,
		133,
		126,
		130,
		-1,
		118,
		120,
		114,
		129,
		104,
		101,
		92,
		83,
		79,
		83,
		87,
		100,
		105,
		233,
		-1,
		196,
		-1,
		-1,
		-1,
		186,
		201,
		172,
		149,
		122,
		117,
		110,
		104,
		109,
		120,
		112,
		123,
		90,
		86,
		76,
		75,
		79,
		96,
		96,
		-1,
		-1,
		194,
		190,
		212,
		194,
		198,
		199,
		-1,
		-1,
		126,
		117,
		108,
		100,
		113,
		116,
		96,
		93,
		87,
		80,
		74,
		84,
		95,
		90,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		196,
		197,
		144,
		126,
		122,
		120,
		109,
		103,
		91,
		96,
		97,
		88,
		82,
		70,
		70,
		93,
		82,
		94,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		159,
		156,
		-1,
		126,
		132,
		97,
		104,
		87,
		94,
		92,
		84,
		64,
		67,
		83,
		82,
		77,
		86,
		77,
		85,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		151,
		148,
		128,
		97,
		95,
		88,
		83,
		93,
		73,
		60,
		60,
		55,
		70,
		75,
		77,
		70,
		76,
		91,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		124,
		115,
		116,
		104,
		101,
		103,
		98,
		88,
		69,
		75,
		53,
		60,
		71,
		63,
		67,
		68,
		63,
		76,
		80,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		120,
		163,
		118,
		113,
		90,
		88,
		85,
		76,
		77,
		61,
		49,
		46,
		55,
		60,
		52,
		73,
		69,
		62,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		169,
		-1,
		160,
		-1,
		143,
		147,
		126,
		129,
		104,
		91,
		77,
		77,
		83,
		61,
		57,
		53,
		42,
		39,
		51,
		55,
		65,
		78,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		177,
		216,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		157,
		139,
		131,
		124,
		103,
		103,
		69,
		65,
		66,
		62,
		69,
		59,
		49,
		38,
		49,
		60,
		70,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		192,
		183,
		210,
		182,
		171,
		166,
		153,
		-1,
		-1,
		146,
		149,
		-1,
		-1,
		110,
		86,
		73,
		67,
		71,
		76,
		74,
		62,
		42,
		37,
		31,
		63,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		211,
		201,
		205,
		213,
		238,
		-1,
		142,
		-1,
		-1,
		126,
		-1,
		-1,
		111,
		91,
		80,
		71,
		57,
		79,
		78,
		89,
		38,
		43,
		36,
		43,
		51,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		227,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		68,
		54,
		81,
		58,
		47,
		41,
		35,
		34,
		30,
		43,
		44,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		68,
		54,
		50,
		45,
		38,
		33,
		41,
		20,
		24,
		38,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		86,
		54,
		46,
		44,
		26,
		19,
		16,
		26,
		31,
		34,
		-1,
		-1,
		188,
		181,
		-1,
		-1,
		155,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		74,
		68,
		57,
		52,
		48,
		23,
		17,
		8,
		14,
		29,
		28,
		-1,
		-1,
		176,
		168,
		162,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		112,
		75,
		96,
		75,
		44,
		42,
		33,
		19,
		12,
		0,
		8,
		28,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		76,
		83,
		52,
		55,
		49,
		22,
		37,
		12,
		9,
		18,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		90,
		77,
		72,
		58,
		39,
		26,
		33,
		22,
		15,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		85,
		70,
		61,
		61,
		62,
		58,
		46,
		46,
		31,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		80,
		73,
		63,
		60,
		56,
		47,
		53,
		30,
		63,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		104,
		54,
		42,
		37,
		38,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		53,
		42,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		230,
		219,
		230,
		238,
		211,
		218,
		-1,
		237,
		241,
		207,
		201,
		240,
		209,
		215,
		226,
		-1,
		-1,
		-1,
		230,
		229,
		197,
		195,
		204,
		209,
		216,
		-1,
		215,
		-1,
		251,
		230,
		241,
		246,
		190,
		187,
		207,
		226,
		208,
		200,
		266,
		220,
		191,
		185,
		203,
		193,
		202,
		194,
		-1,
		191,
		181,
		203,
		182,
		193,
		185,
		-1,
		-1,
		185,
		186,
		192,
		178,
		184,
		180,
		-1,
		190,
		174,
		-1,
		-1,
		175,
		176,
		160,
		163,
		171,
		169,
		182,
		174,
		169,
		-1,
		-1,
		166,
		162,
		169,
		156,
		152,
		169,
		182,
		164,
		178,
		177,
		-1,
		170,
		188,
		195,
		163,
		161,
		145,
		143,
		161,
		163,
		169,
		169,
		-1,
		179,
		180,
		175,
		183,
		185,
		161,
		148,
		148,
		158,
		151,
		170,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		162,
		179,
		171,
		161,
		176,
		169,
		151,
		148,
		146,
		143,
		159,
		157,
		167,
		-1,
		-1,
		272,
		241,
		270,
		228,
		209,
		-1,
		175,
		155,
		161,
		165,
		159,
		152,
		166,
		162,
		-1,
		137,
		136,
		164,
		150,
		161,
		232,
		-1,
		-1,
		230,
		222,
		205,
		208,
		185,
		181,
		170,
		169,
		161,
		147,
		143,
		149,
		152,
		152,
		158,
		131,
		141,
		145,
		143,
		168,
		-1,
		-1,
		203,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		191,
		197,
		183,
		204,
		180,
		171,
		163,
		157,
		145,
		147,
		144,
		157,
		145,
		128,
		153,
		157,
		138,
		159,
		154,
		-1,
		202,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		220,
		-1,
		192,
		180,
		181,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		132,
		130,
		160,
		135,
		157,
		154,
		173,
		178,
		172,
		181,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		228,
		229,
		204,
		177,
		180,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		124,
		139,
		130,
		129,
		147,
		157,
		165,
		169,
		175,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		229,
		221,
		206,
		206,
		-1,
		176,
		173,
		163,
		141,
		126,
		143,
		135,
		133,
		137,
		119,
		133,
		124,
		142,
		149,
		147,
		151,
		171,
		183,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		248,
		212,
		-1,
		207,
		-1,
		178,
		191,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		130,
		115,
		112,
		130,
		133,
		140,
		144,
		160,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		205,
		194,
		193,
		-1,
		184,
		161,
		158,
		146,
		133,
		118,
		119,
		127,
		140,
		119,
		114,
		111,
		131,
		157,
		135,
		147,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		223,
		216,
		204,
		169,
		169,
		163,
		-1,
		157,
		136,
		127,
		116,
		114,
		127,
		124,
		129,
		109,
		107,
		126,
		138,
		129,
		146,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		168,
		191,
		228,
		202,
		188,
		193,
		168,
		161,
		155,
		170,
		153,
		134,
		123,
		115,
		104,
		120,
		128,
		123,
		105,
		114,
		120,
		144,
		134,
		140,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		182,
		189,
		221,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		117,
		111,
		120,
		122,
		112,
		107,
		114,
		149,
		149,
		124,
		144,
		147,
		-1,
		-1,
		-1,
		232,
		227,
		202,
		179,
		163,
		199,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		121,
		125,
		118,
		125,
		118,
		116,
		117,
		99,
		131,
		-1,
		132,
		126,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		128,
		122,
		126,
		123,
		112,
		125,
		118,
		104,
		106,
		119,
		123,
		127,
		114,
		110,
		107,
		121,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		137,
		135,
		126,
		134,
		107,
		100,
		107,
		96,
		114,
		122,
		114,
		108,
		107,
		117,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		136,
		135,
		133,
		124,
		112,
		101,
		104,
		96,
		118,
		118,
		102,
		103,
		107,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		140,
		172,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		138,
		144,
		144,
		121,
		116,
		106,
		95,
		95,
		90,
		112,
		98,
		96,
		105,
		121,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		149,
		139,
		144,
		-1,
		141,
		-1,
		114,
		111,
		102,
		87,
		84,
		95,
		93,
		104,
		100,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		209,
		-1,
		-1,
		179,
		173,
		173,
		157,
		160,
		165,
		145,
		137,
		144,
		136,
		128,
		122,
		100,
		93,
		90,
		83,
		96,
		106,
		111,
		98,
		-1,
		-1,
		-1,
		206,
		192,
		196,
		156,
		175,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		166,
		165,
		153,
		143,
		133,
		138,
		139,
		119,
		112,
		98,
		100,
		94,
		85,
		84,
		100,
		92,
		114,
		-1,
		-1,
		189,
		194,
		182,
		168,
		187,
		-1,
		-1,
		-1,
		188,
		204,
		193,
		167,
		154,
		-1,
		-1,
		137,
		130,
		124,
		115,
		102,
		114,
		109,
		93,
		78,
		93,
		97,
		105,
		96,
		-1,
		192,
		179,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		-1,
		-1,
		205,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		121,
		106,
		118,
		125,
		95,
		80,
		74,
		80,
		92,
		101,
		-1,
		-1,
		204,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		127,
		120,
		124,
		-1,
		112,
		114,
		108,
		123,
		98,
		95,
		86,
		77,
		73,
		77,
		81,
		94,
		99,
		227,
		-1,
		190,
		-1,
		-1,
		-1,
		180,
		195,
		166,
		143,
		116,
		111,
		104,
		98,
		103,
		114,
		106,
		117,
		84,
		80,
		70,
		69,
		73,
		90,
		90,
		-1,
		-1,
		188,
		184,
		206,
		188,
		192,
		193,
		-1,
		-1,
		120,
		111,
		102,
		94,
		107,
		110,
		90,
		87,
		81,
		74,
		68,
		78,
		89,
		84,
		-1,
		-1,
		-1,
		200,
		-1,
		202,
		-1,
		-1,
		190,
		191,
		138,
		120,
		116,
		114,
		103,
		97,
		85,
		90,
		91,
		82,
		76,
		64,
		64,
		87,
		76,
		88,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		179,
		171,
		166,
		172,
		174,
		165,
		153,
		150,
		-1,
		120,
		126,
		91,
		98,
		81,
		88,
		86,
		78,
		58,
		61,
		77,
		76,
		71,
		80,
		71,
		79,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		172,
		168,
		158,
		148,
		151,
		-1,
		-1,
		145,
		142,
		122,
		91,
		89,
		82,
		77,
		87,
		67,
		54,
		54,
		49,
		64,
		69,
		71,
		64,
		70,
		85,
		-1,
		219,
		256,
		249,
		217,
		225,
		256,
		-1,
		162,
		154,
		165,
		140,
		142,
		-1,
		-1,
		118,
		109,
		110,
		98,
		95,
		97,
		92,
		83,
		63,
		69,
		47,
		54,
		65,
		57,
		61,
		62,
		57,
		70,
		74,
		-1,
		212,
		232,
		211,
		214,
		238,
		252,
		-1,
		159,
		-1,
		-1,
		171,
		143,
		127,
		117,
		114,
		157,
		112,
		107,
		91,
		89,
		80,
		71,
		71,
		55,
		43,
		40,
		49,
		54,
		46,
		67,
		63,
		56,
		-1,
		201,
		212,
		205,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		163,
		-1,
		154,
		-1,
		137,
		141,
		120,
		123,
		105,
		92,
		84,
		71,
		80,
		55,
		51,
		47,
		36,
		33,
		45,
		49,
		59,
		72,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		171,
		210,
		169,
		-1,
		153,
		-1,
		-1,
		-1,
		151,
		133,
		125,
		125,
		104,
		104,
		77,
		73,
		60,
		56,
		63,
		53,
		43,
		32,
		43,
		54,
		64,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		186,
		177,
		204,
		176,
		165,
		160,
		147,
		-1,
		-1,
		154,
		143,
		-1,
		-1,
		111,
		94,
		81,
		71,
		67,
		70,
		78,
		62,
		42,
		31,
		25,
		57,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		205,
		195,
		199,
		207,
		232,
		-1,
		136,
		-1,
		-1,
		134,
		-1,
		-1,
		119,
		99,
		88,
		79,
		65,
		75,
		82,
		93,
		45,
		37,
		30,
		37,
		45,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		199,
		221,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		117,
		115,
		104,
		-1,
		94,
		76,
		62,
		89,
		65,
		54,
		48,
		42,
		28,
		24,
		37,
		38,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		112,
		105,
		93,
		81,
		71,
		76,
		62,
		58,
		52,
		45,
		40,
		42,
		14,
		18,
		32,
		-1,
		242,
		-1,
		194,
		170,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		146,
		130,
		111,
		-1,
		81,
		94,
		94,
		62,
		54,
		52,
		34,
		27,
		11,
		20,
		25,
		28,
		-1,
		-1,
		182,
		175,
		-1,
		-1,
		149,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		118,
		114,
		-1,
		-1,
		82,
		76,
		65,
		60,
		56,
		31,
		25,
		16,
		9,
		23,
		22,
		-1,
		-1,
		170,
		162,
		156,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		113,
		76,
		92,
		83,
		52,
		50,
		41,
		27,
		20,
		8,
		0,
		22,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		94,
		-1,
		69,
		72,
		77,
		60,
		63,
		57,
		30,
		45,
		12,
		3,
		12,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		91,
		73,
		-1,
		84,
		71,
		75,
		60,
		41,
		28,
		31,
		16,
		9,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		79,
		64,
		55,
		55,
		65,
		61,
		48,
		46,
		25,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		74,
		67,
		57,
		54,
		50,
		41,
		47,
		24,
		57,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		98,
		48,
		36,
		31,
		32,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		47,
		36,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		248,
		237,
		248,
		256,
		229,
		236,
		-1,
		255,
		259,
		225,
		219,
		258,
		227,
		233,
		244,
		-1,
		-1,
		-1,
		248,
		247,
		215,
		213,
		222,
		227,
		234,
		-1,
		233,
		-1,
		269,
		248,
		259,
		264,
		208,
		205,
		225,
		244,
		226,
		218,
		284,
		238,
		209,
		203,
		221,
		211,
		220,
		212,
		-1,
		209,
		199,
		221,
		200,
		211,
		203,
		-1,
		-1,
		203,
		204,
		210,
		196,
		202,
		198,
		-1,
		208,
		192,
		-1,
		-1,
		193,
		194,
		178,
		181,
		189,
		187,
		200,
		192,
		187,
		-1,
		-1,
		184,
		180,
		187,
		174,
		170,
		187,
		200,
		182,
		196,
		195,
		-1,
		188,
		206,
		213,
		181,
		179,
		163,
		161,
		179,
		181,
		187,
		187,
		-1,
		197,
		198,
		193,
		201,
		203,
		179,
		166,
		166,
		176,
		169,
		188,
		176,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		197,
		180,
		197,
		189,
		179,
		194,
		187,
		169,
		166,
		164,
		161,
		177,
		175,
		185,
		-1,
		-1,
		290,
		259,
		288,
		246,
		227,
		-1,
		193,
		173,
		179,
		183,
		177,
		170,
		184,
		180,
		-1,
		155,
		154,
		182,
		168,
		179,
		250,
		-1,
		-1,
		248,
		240,
		223,
		226,
		203,
		199,
		188,
		187,
		179,
		165,
		161,
		167,
		170,
		170,
		176,
		149,
		159,
		163,
		161,
		186,
		-1,
		-1,
		221,
		-1,
		-1,
		247,
		230,
		-1,
		213,
		220,
		209,
		215,
		201,
		222,
		198,
		189,
		181,
		175,
		163,
		165,
		162,
		175,
		163,
		146,
		171,
		175,
		156,
		177,
		172,
		-1,
		220,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		206,
		209,
		215,
		239,
		238,
		-1,
		210,
		198,
		199,
		184,
		181,
		168,
		156,
		169,
		154,
		161,
		160,
		150,
		148,
		178,
		153,
		175,
		172,
		191,
		196,
		190,
		199,
		-1,
		255,
		251,
		247,
		254,
		203,
		-1,
		-1,
		243,
		-1,
		246,
		247,
		222,
		195,
		198,
		185,
		176,
		163,
		152,
		163,
		152,
		149,
		157,
		142,
		157,
		148,
		147,
		165,
		175,
		183,
		187,
		193,
		-1,
		305,
		-1,
		247,
		231,
		233,
		205,
		226,
		-1,
		263,
		247,
		239,
		224,
		224,
		-1,
		194,
		191,
		181,
		159,
		144,
		161,
		153,
		151,
		155,
		137,
		151,
		142,
		160,
		167,
		165,
		169,
		189,
		201,
		265,
		255,
		-1,
		237,
		242,
		201,
		209,
		228,
		266,
		230,
		-1,
		225,
		-1,
		196,
		209,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		148,
		133,
		130,
		148,
		151,
		158,
		162,
		178,
		-1,
		-1,
		250,
		254,
		243,
		194,
		213,
		237,
		274,
		223,
		212,
		211,
		-1,
		202,
		179,
		176,
		164,
		151,
		136,
		137,
		145,
		158,
		137,
		132,
		129,
		149,
		175,
		153,
		165,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		220,
		191,
		215,
		257,
		241,
		234,
		222,
		187,
		187,
		181,
		-1,
		175,
		154,
		145,
		134,
		132,
		145,
		142,
		147,
		127,
		125,
		144,
		156,
		147,
		162,
		-1,
		-1,
		-1,
		250,
		239,
		240,
		186,
		209,
		246,
		220,
		206,
		211,
		186,
		179,
		173,
		188,
		171,
		152,
		141,
		133,
		122,
		138,
		146,
		141,
		123,
		132,
		138,
		162,
		150,
		156,
		-1,
		-1,
		257,
		247,
		231,
		233,
		230,
		200,
		207,
		239,
		211,
		224,
		-1,
		178,
		-1,
		167,
		162,
		146,
		141,
		138,
		135,
		129,
		138,
		140,
		130,
		125,
		132,
		167,
		167,
		140,
		160,
		163,
		-1,
		-1,
		-1,
		250,
		245,
		220,
		197,
		181,
		217,
		-1,
		194,
		195,
		-1,
		172,
		166,
		163,
		148,
		144,
		139,
		143,
		136,
		143,
		136,
		134,
		135,
		117,
		149,
		-1,
		148,
		142,
		150,
		140,
		128,
		-1,
		-1,
		-1,
		243,
		222,
		215,
		235,
		176,
		228,
		-1,
		-1,
		179,
		172,
		-1,
		159,
		141,
		148,
		146,
		140,
		144,
		141,
		130,
		143,
		136,
		122,
		124,
		137,
		141,
		145,
		130,
		126,
		123,
		126,
		-1,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		196,
		-1,
		188,
		180,
		170,
		164,
		158,
		154,
		152,
		168,
		152,
		155,
		153,
		144,
		152,
		125,
		118,
		125,
		114,
		132,
		140,
		132,
		126,
		121,
		122,
		-1,
		263,
		249,
		220,
		-1,
		-1,
		209,
		-1,
		173,
		187,
		203,
		-1,
		196,
		175,
		190,
		168,
		164,
		160,
		175,
		176,
		154,
		153,
		151,
		142,
		130,
		119,
		122,
		114,
		136,
		136,
		120,
		121,
		117,
		-1,
		269,
		256,
		214,
		210,
		199,
		219,
		170,
		158,
		190,
		-1,
		-1,
		232,
		-1,
		166,
		183,
		174,
		172,
		165,
		156,
		162,
		162,
		139,
		134,
		124,
		113,
		113,
		108,
		130,
		116,
		114,
		115,
		107,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		185,
		172,
		166,
		-1,
		207,
		-1,
		210,
		200,
		184,
		169,
		202,
		-1,
		167,
		157,
		162,
		-1,
		159,
		-1,
		132,
		129,
		120,
		105,
		102,
		113,
		111,
		122,
		116,
		-1,
		219,
		204,
		197,
		187,
		201,
		172,
		-1,
		227,
		-1,
		-1,
		197,
		191,
		191,
		175,
		178,
		183,
		163,
		155,
		162,
		154,
		146,
		140,
		118,
		111,
		108,
		101,
		114,
		124,
		129,
		114,
		-1,
		-1,
		-1,
		224,
		210,
		214,
		174,
		193,
		-1,
		-1,
		259,
		214,
		200,
		-1,
		184,
		183,
		171,
		161,
		151,
		156,
		157,
		137,
		130,
		116,
		118,
		112,
		103,
		102,
		118,
		110,
		118,
		-1,
		-1,
		207,
		212,
		200,
		186,
		205,
		-1,
		-1,
		-1,
		206,
		222,
		211,
		185,
		172,
		-1,
		-1,
		155,
		148,
		142,
		133,
		120,
		132,
		127,
		111,
		96,
		111,
		115,
		108,
		100,
		-1,
		210,
		197,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		-1,
		-1,
		223,
		168,
		157,
		152,
		156,
		154,
		-1,
		128,
		139,
		124,
		136,
		143,
		113,
		98,
		92,
		98,
		110,
		94,
		-1,
		-1,
		222,
		-1,
		217,
		-1,
		-1,
		-1,
		-1,
		180,
		174,
		145,
		138,
		142,
		-1,
		130,
		132,
		126,
		141,
		116,
		113,
		104,
		95,
		91,
		95,
		98,
		79,
		85,
		245,
		-1,
		208,
		-1,
		-1,
		-1,
		198,
		213,
		184,
		161,
		134,
		129,
		122,
		116,
		121,
		132,
		124,
		135,
		102,
		98,
		88,
		87,
		91,
		83,
		83,
		-1,
		-1,
		206,
		202,
		224,
		206,
		210,
		211,
		-1,
		-1,
		138,
		129,
		120,
		112,
		125,
		128,
		108,
		105,
		99,
		92,
		86,
		96,
		82,
		77,
		-1,
		-1,
		-1,
		218,
		-1,
		220,
		-1,
		-1,
		208,
		209,
		156,
		138,
		134,
		132,
		121,
		115,
		103,
		108,
		109,
		100,
		94,
		82,
		82,
		93,
		69,
		73,
		-1,
		-1,
		290,
		-1,
		-1,
		-1,
		197,
		189,
		184,
		190,
		192,
		183,
		171,
		168,
		-1,
		138,
		144,
		109,
		116,
		99,
		106,
		104,
		96,
		76,
		79,
		86,
		72,
		60,
		65,
		56,
		64,
		-1,
		-1,
		283,
		272,
		261,
		267,
		-1,
		190,
		186,
		176,
		166,
		169,
		-1,
		-1,
		163,
		160,
		140,
		109,
		107,
		100,
		95,
		105,
		85,
		72,
		72,
		67,
		63,
		62,
		57,
		50,
		55,
		70,
		-1,
		237,
		274,
		267,
		235,
		243,
		274,
		-1,
		180,
		172,
		183,
		158,
		160,
		-1,
		-1,
		136,
		127,
		128,
		116,
		113,
		115,
		110,
		101,
		81,
		87,
		65,
		72,
		83,
		75,
		70,
		53,
		42,
		55,
		59,
		-1,
		230,
		250,
		229,
		232,
		256,
		270,
		-1,
		177,
		-1,
		-1,
		184,
		161,
		145,
		135,
		132,
		175,
		130,
		125,
		109,
		107,
		98,
		89,
		89,
		73,
		61,
		58,
		67,
		65,
		55,
		52,
		48,
		41,
		-1,
		219,
		230,
		223,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		174,
		-1,
		172,
		-1,
		155,
		159,
		138,
		141,
		123,
		110,
		97,
		89,
		98,
		73,
		69,
		65,
		54,
		51,
		63,
		52,
		59,
		57,
		244,
		200,
		203,
		214,
		225,
		240,
		244,
		-1,
		189,
		228,
		180,
		-1,
		164,
		-1,
		-1,
		-1,
		169,
		151,
		143,
		143,
		122,
		122,
		89,
		85,
		78,
		74,
		81,
		71,
		61,
		50,
		61,
		50,
		49,
		240,
		231,
		244,
		189,
		189,
		210,
		219,
		240,
		204,
		195,
		222,
		187,
		176,
		171,
		158,
		-1,
		-1,
		166,
		161,
		-1,
		-1,
		129,
		106,
		93,
		87,
		85,
		88,
		96,
		80,
		60,
		49,
		43,
		45,
		-1,
		233,
		232,
		221,
		218,
		194,
		185,
		180,
		207,
		-1,
		-1,
		202,
		223,
		213,
		217,
		218,
		243,
		-1,
		147,
		-1,
		-1,
		146,
		-1,
		-1,
		131,
		111,
		100,
		91,
		77,
		93,
		100,
		111,
		63,
		55,
		48,
		38,
		30,
		217,
		214,
		202,
		200,
		223,
		188,
		176,
		-1,
		189,
		187,
		193,
		200,
		217,
		232,
		-1,
		-1,
		163,
		143,
		-1,
		-1,
		129,
		127,
		116,
		-1,
		106,
		88,
		74,
		101,
		82,
		72,
		66,
		60,
		46,
		42,
		31,
		23,
		226,
		240,
		229,
		225,
		224,
		232,
		181,
		174,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		153,
		149,
		-1,
		-1,
		124,
		117,
		105,
		93,
		83,
		88,
		74,
		70,
		70,
		63,
		58,
		60,
		32,
		36,
		17,
		-1,
		260,
		-1,
		212,
		188,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		170,
		156,
		149,
		137,
		135,
		-1,
		158,
		142,
		123,
		-1,
		93,
		106,
		106,
		74,
		66,
		64,
		54,
		52,
		34,
		21,
		10,
		13,
		-1,
		-1,
		200,
		186,
		-1,
		-1,
		160,
		162,
		-1,
		161,
		150,
		135,
		127,
		-1,
		-1,
		130,
		126,
		-1,
		-1,
		93,
		88,
		77,
		72,
		68,
		50,
		50,
		41,
		32,
		14,
		7,
		-1,
		-1,
		181,
		173,
		167,
		-1,
		145,
		-1,
		163,
		-1,
		130,
		136,
		124,
		-1,
		-1,
		-1,
		124,
		87,
		103,
		95,
		64,
		62,
		53,
		46,
		45,
		33,
		27,
		0,
		-1,
		-1,
		-1,
		163,
		137,
		170,
		161,
		144,
		124,
		116,
		135,
		-1,
		105,
		-1,
		80,
		83,
		88,
		72,
		75,
		69,
		43,
		56,
		29,
		25,
		19,
		169,
		-1,
		139,
		172,
		136,
		130,
		106,
		110,
		126,
		-1,
		102,
		84,
		-1,
		95,
		82,
		86,
		71,
		52,
		39,
		42,
		27,
		20,
		-1,
		-1,
		-1,
		141,
		140,
		132,
		126,
		126,
		111,
		102,
		-1,
		114,
		96,
		75,
		90,
		75,
		66,
		66,
		76,
		72,
		59,
		57,
		36,
		-1,
		242,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		135,
		130,
		103,
		91,
		97,
		93,
		79,
		85,
		85,
		78,
		68,
		65,
		61,
		52,
		58,
		35,
		68,
		-1,
		237,
		-1,
		171,
		-1,
		-1,
		153,
		133,
		125,
		114,
		103,
		101,
		92,
		83,
		105,
		109,
		59,
		47,
		42,
		43,
		-1,
		226,
		225,
		-1,
		172,
		164,
		150,
		-1,
		143,
		-1,
		149,
		110,
		-1,
		112,
		92,
		-1,
		58,
		47,
		-1,
		-1,
		213,
		188,
		-1,
		-1,
		-1,
		173,
		153,
		144,
		128,
		-1,
		103,
		103,
		-1,
		-1,
		-1,
		198,
		197,
		-1,
		166,
		169,
		-1,
		159,
		150,
		158,
		105,
		109,
		-1,
		-1,
		-1,
		207,
		188,
		182,
		181,
		179,
		174,
		171,
		157,
		141,
		119,
		108,
		129,
		-1,
		-1,
		-1,
		179,
		171,
		164,
		-1,
		-1,
		166,
		149,
		130,
		128,
		-1,
		-1,
		-1,
		201,
		182,
		-1,
		-1,
		156,
		-1,
		-1,
		162,
		127,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		190,
		-1,
		-1,
		-1,
		152,
		148,
		149,
		-1,
		-1,
		-1,
		-1,
		212,
		213,
		236,
		200,
		-1,
		-1,
		-1,
		144,
		138,
		-1,
		-1,
		215,
		213,
		-1,
		-1,
		-1,
		172,
		156,
		-1,
		142,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		175,
		-1,
		-1,
		-1,
		177,
		-1,
		177,
		152,
		159,
		-1,
		-1,
		-1,
		-1,
		190,
		182,
		190,
		-1,
		162,
		164,
		-1,
		212,
		-1,
		-1,
		205,
		196,
		-1,
		-1,
		167,
		174,
		196,
		199,
		235,
		-1,
		186
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		313,
		302,
		313,
		321,
		294,
		301,
		-1,
		320,
		324,
		290,
		284,
		323,
		292,
		298,
		309,
		-1,
		-1,
		-1,
		313,
		312,
		280,
		278,
		287,
		292,
		299,
		-1,
		298,
		-1,
		334,
		313,
		324,
		329,
		273,
		270,
		290,
		309,
		291,
		283,
		349,
		303,
		274,
		268,
		286,
		276,
		285,
		277,
		-1,
		274,
		264,
		286,
		265,
		276,
		268,
		-1,
		-1,
		268,
		269,
		275,
		261,
		267,
		263,
		-1,
		273,
		257,
		-1,
		-1,
		258,
		259,
		243,
		246,
		254,
		252,
		265,
		257,
		252,
		-1,
		-1,
		249,
		245,
		252,
		239,
		235,
		252,
		265,
		247,
		261,
		260,
		-1,
		253,
		271,
		278,
		246,
		244,
		228,
		226,
		244,
		246,
		252,
		252,
		-1,
		262,
		263,
		258,
		266,
		268,
		244,
		231,
		231,
		241,
		234,
		253,
		241,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		262,
		245,
		262,
		254,
		244,
		259,
		252,
		234,
		231,
		229,
		226,
		242,
		240,
		250,
		-1,
		-1,
		355,
		324,
		353,
		311,
		292,
		-1,
		258,
		238,
		244,
		248,
		242,
		235,
		249,
		245,
		-1,
		220,
		219,
		247,
		233,
		244,
		315,
		-1,
		-1,
		313,
		305,
		288,
		291,
		268,
		264,
		253,
		252,
		244,
		230,
		226,
		232,
		235,
		235,
		241,
		214,
		224,
		228,
		226,
		251,
		-1,
		-1,
		286,
		-1,
		-1,
		312,
		295,
		-1,
		278,
		285,
		274,
		280,
		266,
		287,
		263,
		254,
		246,
		240,
		228,
		230,
		227,
		240,
		228,
		211,
		236,
		240,
		221,
		242,
		237,
		-1,
		285,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		271,
		274,
		280,
		304,
		303,
		-1,
		275,
		263,
		264,
		249,
		246,
		233,
		221,
		234,
		219,
		226,
		225,
		215,
		213,
		243,
		218,
		240,
		237,
		256,
		261,
		255,
		264,
		-1,
		320,
		316,
		312,
		319,
		268,
		-1,
		-1,
		308,
		-1,
		311,
		312,
		287,
		260,
		263,
		250,
		241,
		228,
		217,
		228,
		217,
		214,
		222,
		207,
		222,
		213,
		212,
		230,
		240,
		248,
		252,
		258,
		-1,
		370,
		-1,
		312,
		296,
		298,
		270,
		291,
		-1,
		328,
		312,
		304,
		289,
		289,
		-1,
		259,
		256,
		246,
		224,
		209,
		226,
		218,
		216,
		220,
		202,
		216,
		207,
		225,
		232,
		230,
		234,
		254,
		266,
		330,
		320,
		-1,
		302,
		307,
		266,
		274,
		293,
		331,
		295,
		-1,
		290,
		-1,
		261,
		274,
		-1,
		230,
		226,
		208,
		209,
		204,
		219,
		213,
		198,
		195,
		213,
		216,
		223,
		227,
		243,
		-1,
		-1,
		315,
		319,
		308,
		259,
		278,
		302,
		339,
		288,
		277,
		276,
		-1,
		267,
		244,
		241,
		229,
		216,
		201,
		202,
		210,
		223,
		202,
		197,
		194,
		214,
		240,
		218,
		230,
		-1,
		-1,
		-1,
		340,
		-1,
		-1,
		285,
		256,
		280,
		322,
		306,
		299,
		287,
		252,
		252,
		246,
		-1,
		240,
		219,
		210,
		199,
		197,
		210,
		207,
		212,
		192,
		190,
		209,
		221,
		212,
		229,
		-1,
		-1,
		-1,
		315,
		304,
		305,
		251,
		274,
		311,
		285,
		271,
		276,
		251,
		244,
		238,
		253,
		236,
		217,
		206,
		198,
		187,
		203,
		211,
		206,
		188,
		197,
		203,
		227,
		217,
		223,
		-1,
		-1,
		322,
		312,
		296,
		298,
		295,
		265,
		272,
		304,
		276,
		289,
		-1,
		243,
		-1,
		232,
		227,
		211,
		206,
		203,
		200,
		194,
		203,
		205,
		195,
		190,
		197,
		232,
		232,
		207,
		227,
		230,
		-1,
		-1,
		-1,
		315,
		310,
		285,
		262,
		246,
		282,
		-1,
		259,
		260,
		-1,
		237,
		231,
		228,
		213,
		209,
		204,
		208,
		201,
		208,
		201,
		199,
		200,
		182,
		214,
		-1,
		215,
		209,
		217,
		207,
		195,
		-1,
		-1,
		-1,
		308,
		287,
		280,
		300,
		241,
		293,
		-1,
		-1,
		244,
		237,
		-1,
		224,
		206,
		213,
		211,
		205,
		209,
		206,
		195,
		208,
		201,
		187,
		189,
		202,
		206,
		210,
		197,
		193,
		190,
		204,
		-1,
		327,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		261,
		-1,
		253,
		245,
		235,
		229,
		223,
		219,
		217,
		233,
		217,
		220,
		218,
		209,
		217,
		190,
		183,
		190,
		179,
		197,
		205,
		197,
		191,
		190,
		200,
		-1,
		328,
		314,
		285,
		-1,
		-1,
		274,
		-1,
		238,
		252,
		268,
		-1,
		261,
		240,
		255,
		233,
		229,
		225,
		240,
		241,
		218,
		218,
		216,
		207,
		195,
		184,
		187,
		179,
		201,
		201,
		185,
		186,
		190,
		-1,
		334,
		321,
		279,
		275,
		264,
		284,
		235,
		223,
		255,
		-1,
		-1,
		297,
		-1,
		231,
		248,
		239,
		237,
		230,
		212,
		219,
		227,
		204,
		199,
		189,
		178,
		178,
		173,
		195,
		181,
		179,
		188,
		204,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		250,
		237,
		231,
		-1,
		272,
		-1,
		275,
		265,
		249,
		234,
		267,
		-1,
		211,
		207,
		214,
		-1,
		224,
		-1,
		197,
		194,
		185,
		170,
		167,
		178,
		176,
		187,
		183,
		-1,
		284,
		269,
		262,
		252,
		266,
		237,
		-1,
		287,
		-1,
		-1,
		262,
		256,
		256,
		240,
		241,
		227,
		207,
		199,
		214,
		213,
		200,
		199,
		183,
		176,
		173,
		166,
		179,
		189,
		194,
		181,
		-1,
		-1,
		-1,
		289,
		248,
		256,
		232,
		253,
		-1,
		-1,
		324,
		279,
		265,
		-1,
		236,
		227,
		215,
		205,
		195,
		200,
		201,
		191,
		189,
		181,
		183,
		177,
		168,
		167,
		183,
		175,
		197,
		-1,
		-1,
		245,
		258,
		260,
		238,
		233,
		-1,
		-1,
		-1,
		271,
		287,
		255,
		234,
		216,
		-1,
		-1,
		199,
		192,
		186,
		189,
		177,
		197,
		192,
		176,
		161,
		176,
		180,
		188,
		179,
		-1,
		248,
		235,
		-1,
		-1,
		232,
		222,
		-1,
		-1,
		-1,
		-1,
		267,
		212,
		201,
		196,
		200,
		198,
		-1,
		172,
		183,
		176,
		195,
		202,
		178,
		163,
		157,
		163,
		175,
		184,
		-1,
		-1,
		246,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		224,
		218,
		189,
		182,
		186,
		-1,
		174,
		176,
		173,
		185,
		181,
		178,
		169,
		160,
		156,
		160,
		164,
		178,
		182,
		269,
		-1,
		199,
		-1,
		-1,
		-1,
		238,
		239,
		225,
		202,
		178,
		173,
		166,
		160,
		165,
		176,
		185,
		196,
		161,
		163,
		153,
		152,
		156,
		173,
		177,
		-1,
		-1,
		197,
		193,
		228,
		240,
		212,
		252,
		-1,
		-1,
		170,
		163,
		164,
		156,
		169,
		172,
		157,
		159,
		159,
		157,
		151,
		161,
		176,
		171,
		-1,
		-1,
		-1,
		195,
		-1,
		211,
		-1,
		-1,
		202,
		243,
		190,
		172,
		168,
		154,
		161,
		155,
		147,
		152,
		162,
		156,
		153,
		147,
		151,
		174,
		163,
		202,
		-1,
		-1,
		201,
		-1,
		-1,
		-1,
		161,
		180,
		175,
		181,
		186,
		177,
		205,
		202,
		-1,
		151,
		184,
		152,
		160,
		143,
		150,
		155,
		152,
		141,
		148,
		164,
		163,
		158,
		194,
		185,
		191,
		-1,
		-1,
		194,
		183,
		172,
		178,
		-1,
		154,
		177,
		167,
		157,
		163,
		-1,
		-1,
		169,
		166,
		164,
		144,
		150,
		144,
		139,
		149,
		125,
		137,
		141,
		145,
		151,
		156,
		161,
		167,
		182,
		197,
		-1,
		148,
		185,
		178,
		146,
		154,
		185,
		-1,
		144,
		136,
		164,
		149,
		157,
		-1,
		-1,
		142,
		133,
		138,
		147,
		148,
		163,
		162,
		145,
		151,
		152,
		144,
		143,
		161,
		165,
		174,
		181,
		171,
		184,
		188,
		-1,
		141,
		161,
		140,
		143,
		167,
		181,
		-1,
		135,
		-1,
		-1,
		154,
		167,
		151,
		141,
		138,
		185,
		161,
		156,
		150,
		148,
		143,
		134,
		159,
		152,
		152,
		155,
		170,
		175,
		167,
		181,
		181,
		182,
		-1,
		130,
		141,
		134,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		144,
		-1,
		178,
		-1,
		161,
		165,
		169,
		172,
		164,
		151,
		137,
		145,
		151,
		150,
		156,
		156,
		157,
		166,
		177,
		189,
		188,
		189,
		155,
		111,
		114,
		125,
		136,
		151,
		155,
		-1,
		119,
		155,
		150,
		-1,
		134,
		-1,
		-1,
		-1,
		175,
		182,
		174,
		184,
		163,
		163,
		129,
		133,
		146,
		153,
		163,
		174,
		166,
		170,
		183,
		194,
		197,
		151,
		142,
		155,
		100,
		100,
		121,
		130,
		151,
		115,
		112,
		149,
		154,
		146,
		141,
		128,
		-1,
		-1,
		197,
		192,
		-1,
		-1,
		170,
		137,
		125,
		135,
		139,
		153,
		165,
		178,
		166,
		171,
		165,
		197,
		-1,
		144,
		143,
		132,
		129,
		105,
		96,
		91,
		118,
		-1,
		-1,
		113,
		140,
		124,
		128,
		144,
		169,
		-1,
		112,
		-1,
		-1,
		177,
		-1,
		-1,
		162,
		142,
		131,
		122,
		127,
		147,
		158,
		180,
		162,
		179,
		170,
		180,
		184,
		128,
		125,
		113,
		111,
		134,
		99,
		87,
		-1,
		95,
		98,
		104,
		111,
		128,
		158,
		-1,
		-1,
		128,
		108,
		-1,
		-1,
		160,
		158,
		147,
		-1,
		137,
		119,
		124,
		154,
		156,
		158,
		165,
		159,
		166,
		174,
		185,
		177,
		137,
		151,
		140,
		136,
		135,
		143,
		92,
		85,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		118,
		114,
		-1,
		-1,
		155,
		148,
		136,
		124,
		114,
		124,
		141,
		141,
		144,
		149,
		157,
		168,
		164,
		168,
		171,
		-1,
		171,
		-1,
		123,
		84,
		90,
		105,
		113,
		-1,
		-1,
		-1,
		135,
		121,
		114,
		102,
		100,
		-1,
		189,
		173,
		154,
		-1,
		124,
		137,
		177,
		145,
		150,
		145,
		160,
		171,
		162,
		170,
		164,
		167,
		-1,
		-1,
		83,
		66,
		-1,
		-1,
		40,
		42,
		-1,
		126,
		115,
		100,
		92,
		-1,
		-1,
		161,
		157,
		-1,
		-1,
		111,
		149,
		148,
		156,
		151,
		156,
		168,
		164,
		160,
		170,
		161,
		-1,
		-1,
		61,
		53,
		47,
		-1,
		25,
		-1,
		128,
		-1,
		95,
		102,
		90,
		-1,
		-1,
		-1,
		142,
		105,
		121,
		144,
		170,
		168,
		159,
		152,
		159,
		162,
		155,
		161,
		-1,
		-1,
		-1,
		0,
		20,
		135,
		126,
		109,
		89,
		81,
		101,
		-1,
		123,
		-1,
		98,
		101,
		126,
		165,
		167,
		153,
		149,
		162,
		156,
		153,
		151,
		6,
		-1,
		24,
		83,
		66,
		95,
		61,
		73,
		137,
		-1,
		120,
		102,
		-1,
		130,
		120,
		168,
		143,
		152,
		145,
		139,
		140,
		148,
		-1,
		-1,
		-1,
		39,
		38,
		37,
		48,
		56,
		54,
		72,
		-1,
		125,
		107,
		93,
		110,
		110,
		101,
		109,
		158,
		154,
		157,
		155,
		133,
		-1,
		99,
		-1,
		-1,
		62,
		-1,
		-1,
		-1,
		65,
		87,
		82,
		74,
		86,
		95,
		90,
		92,
		105,
		113,
		111,
		108,
		120,
		116,
		136,
		132,
		164,
		-1,
		106,
		-1,
		69,
		-1,
		-1,
		83,
		69,
		81,
		92,
		82,
		82,
		87,
		85,
		107,
		137,
		123,
		121,
		126,
		131,
		-1,
		116,
		117,
		-1,
		102,
		94,
		80,
		-1,
		73,
		-1,
		128,
		89,
		-1,
		114,
		94,
		-1,
		132,
		128,
		-1,
		-1,
		128,
		118,
		-1,
		-1,
		-1,
		103,
		83,
		123,
		107,
		-1,
		105,
		105,
		-1,
		-1,
		-1,
		142,
		127,
		-1,
		96,
		99,
		-1,
		90,
		96,
		125,
		107,
		111,
		-1,
		-1,
		-1,
		152,
		133,
		127,
		111,
		116,
		104,
		121,
		107,
		109,
		121,
		110,
		131,
		-1,
		-1,
		-1,
		124,
		116,
		116,
		-1,
		-1,
		134,
		117,
		117,
		130,
		-1,
		-1,
		-1,
		146,
		127,
		-1,
		-1,
		125,
		-1,
		-1,
		130,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		135,
		-1,
		-1,
		-1,
		126,
		133,
		141,
		-1,
		-1,
		-1,
		-1,
		156,
		157,
		181,
		156,
		-1,
		-1,
		-1,
		140,
		140,
		-1,
		-1,
		159,
		157,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		144,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		177,
		-1,
		-1,
		-1,
		173,
		-1,
		179,
		154,
		161,
		-1,
		-1,
		-1,
		-1,
		186,
		178,
		192,
		-1,
		164,
		166,
		-1,
		214,
		-1,
		-1,
		201,
		192,
		-1,
		-1,
		169,
		176,
		198,
		201,
		231,
		-1,
		188
	],
	[
		-1,
		293,
		282,
		293,
		301,
		274,
		281,
		-1,
		300,
		304,
		270,
		264,
		303,
		272,
		278,
		289,
		-1,
		-1,
		-1,
		293,
		292,
		260,
		258,
		267,
		272,
		279,
		-1,
		278,
		-1,
		314,
		293,
		304,
		309,
		253,
		250,
		270,
		289,
		271,
		263,
		329,
		283,
		254,
		248,
		266,
		256,
		265,
		257,
		-1,
		254,
		244,
		266,
		245,
		256,
		248,
		-1,
		-1,
		248,
		249,
		255,
		241,
		247,
		243,
		-1,
		253,
		237,
		-1,
		-1,
		238,
		239,
		223,
		226,
		234,
		232,
		245,
		237,
		232,
		-1,
		-1,
		229,
		225,
		232,
		219,
		215,
		232,
		245,
		227,
		241,
		240,
		-1,
		233,
		251,
		258,
		226,
		224,
		208,
		206,
		224,
		226,
		232,
		232,
		-1,
		242,
		243,
		238,
		246,
		248,
		224,
		211,
		211,
		221,
		214,
		233,
		221,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		242,
		225,
		242,
		234,
		224,
		239,
		232,
		214,
		211,
		209,
		206,
		222,
		220,
		230,
		-1,
		-1,
		335,
		304,
		333,
		291,
		272,
		-1,
		238,
		218,
		224,
		228,
		222,
		215,
		229,
		225,
		-1,
		200,
		199,
		227,
		213,
		224,
		295,
		-1,
		-1,
		293,
		285,
		268,
		271,
		248,
		244,
		233,
		232,
		224,
		210,
		206,
		212,
		215,
		215,
		221,
		194,
		204,
		208,
		206,
		231,
		-1,
		-1,
		266,
		-1,
		-1,
		292,
		275,
		-1,
		258,
		265,
		254,
		260,
		246,
		267,
		243,
		234,
		226,
		220,
		208,
		210,
		207,
		220,
		208,
		191,
		216,
		220,
		201,
		222,
		217,
		-1,
		265,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		251,
		254,
		260,
		284,
		283,
		-1,
		255,
		243,
		244,
		229,
		226,
		213,
		201,
		214,
		199,
		206,
		205,
		195,
		193,
		223,
		198,
		220,
		217,
		236,
		241,
		235,
		244,
		-1,
		300,
		296,
		292,
		299,
		248,
		-1,
		-1,
		288,
		-1,
		291,
		292,
		267,
		240,
		243,
		230,
		221,
		208,
		197,
		208,
		197,
		194,
		202,
		187,
		202,
		193,
		192,
		210,
		220,
		228,
		232,
		238,
		-1,
		350,
		-1,
		292,
		276,
		278,
		250,
		271,
		-1,
		308,
		292,
		284,
		269,
		269,
		-1,
		239,
		236,
		226,
		204,
		189,
		206,
		198,
		196,
		200,
		182,
		196,
		187,
		205,
		212,
		210,
		214,
		234,
		246,
		310,
		300,
		-1,
		282,
		287,
		246,
		254,
		273,
		311,
		275,
		-1,
		270,
		-1,
		241,
		254,
		-1,
		210,
		206,
		188,
		189,
		184,
		199,
		193,
		178,
		175,
		193,
		196,
		203,
		207,
		223,
		-1,
		-1,
		295,
		299,
		288,
		239,
		258,
		282,
		319,
		268,
		257,
		256,
		-1,
		247,
		224,
		221,
		209,
		196,
		181,
		182,
		190,
		203,
		182,
		177,
		174,
		194,
		220,
		198,
		210,
		-1,
		-1,
		-1,
		320,
		-1,
		-1,
		265,
		236,
		260,
		302,
		286,
		279,
		267,
		232,
		232,
		226,
		-1,
		220,
		199,
		190,
		179,
		177,
		190,
		187,
		192,
		172,
		170,
		189,
		201,
		192,
		209,
		-1,
		-1,
		-1,
		295,
		284,
		285,
		231,
		254,
		291,
		265,
		251,
		256,
		231,
		224,
		218,
		233,
		216,
		197,
		186,
		178,
		167,
		183,
		191,
		186,
		168,
		177,
		183,
		207,
		197,
		203,
		-1,
		-1,
		302,
		292,
		276,
		278,
		275,
		245,
		252,
		284,
		256,
		269,
		-1,
		223,
		-1,
		212,
		207,
		191,
		186,
		183,
		180,
		174,
		183,
		185,
		175,
		170,
		177,
		212,
		212,
		187,
		207,
		210,
		-1,
		-1,
		-1,
		295,
		290,
		265,
		242,
		226,
		262,
		-1,
		239,
		240,
		-1,
		217,
		211,
		208,
		193,
		189,
		184,
		188,
		181,
		188,
		181,
		179,
		180,
		162,
		194,
		-1,
		195,
		189,
		197,
		187,
		175,
		-1,
		-1,
		-1,
		288,
		267,
		260,
		280,
		221,
		273,
		-1,
		-1,
		224,
		217,
		-1,
		204,
		186,
		193,
		191,
		185,
		189,
		186,
		175,
		188,
		181,
		167,
		169,
		182,
		186,
		190,
		177,
		173,
		170,
		184,
		-1,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		241,
		-1,
		233,
		225,
		215,
		209,
		203,
		199,
		197,
		213,
		197,
		200,
		198,
		189,
		197,
		170,
		163,
		170,
		159,
		177,
		185,
		177,
		171,
		170,
		180,
		-1,
		308,
		294,
		265,
		-1,
		-1,
		254,
		-1,
		218,
		232,
		248,
		-1,
		241,
		220,
		235,
		213,
		209,
		205,
		220,
		221,
		198,
		198,
		196,
		187,
		175,
		164,
		167,
		159,
		181,
		181,
		165,
		166,
		170,
		-1,
		314,
		301,
		259,
		255,
		244,
		264,
		215,
		203,
		235,
		-1,
		-1,
		277,
		-1,
		211,
		228,
		219,
		217,
		210,
		192,
		199,
		207,
		184,
		179,
		169,
		158,
		158,
		153,
		175,
		161,
		159,
		168,
		184,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		230,
		217,
		211,
		-1,
		252,
		-1,
		255,
		245,
		229,
		214,
		247,
		-1,
		191,
		187,
		194,
		-1,
		204,
		-1,
		177,
		174,
		165,
		150,
		147,
		158,
		156,
		167,
		163,
		-1,
		264,
		249,
		242,
		232,
		246,
		217,
		-1,
		270,
		-1,
		-1,
		242,
		236,
		236,
		220,
		221,
		207,
		187,
		179,
		194,
		193,
		180,
		179,
		163,
		156,
		153,
		146,
		159,
		169,
		174,
		161,
		-1,
		-1,
		-1,
		269,
		231,
		239,
		215,
		236,
		-1,
		-1,
		304,
		259,
		245,
		-1,
		216,
		207,
		195,
		185,
		175,
		180,
		181,
		171,
		169,
		161,
		163,
		157,
		148,
		147,
		163,
		155,
		177,
		-1,
		-1,
		228,
		241,
		243,
		221,
		216,
		-1,
		-1,
		-1,
		251,
		267,
		235,
		214,
		196,
		-1,
		-1,
		179,
		172,
		166,
		169,
		157,
		177,
		172,
		156,
		141,
		156,
		160,
		168,
		159,
		-1,
		231,
		218,
		-1,
		-1,
		215,
		205,
		-1,
		-1,
		-1,
		-1,
		247,
		192,
		181,
		176,
		180,
		178,
		-1,
		152,
		163,
		156,
		175,
		182,
		158,
		143,
		137,
		143,
		155,
		164,
		-1,
		-1,
		229,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		204,
		198,
		169,
		162,
		166,
		-1,
		154,
		156,
		153,
		165,
		161,
		158,
		149,
		140,
		136,
		140,
		144,
		158,
		162,
		252,
		-1,
		182,
		-1,
		-1,
		-1,
		221,
		222,
		208,
		185,
		158,
		153,
		146,
		140,
		145,
		156,
		165,
		176,
		141,
		143,
		133,
		132,
		136,
		153,
		157,
		-1,
		-1,
		180,
		176,
		211,
		223,
		195,
		235,
		-1,
		-1,
		153,
		146,
		144,
		136,
		149,
		152,
		137,
		139,
		139,
		137,
		131,
		141,
		156,
		151,
		-1,
		-1,
		-1,
		178,
		-1,
		194,
		-1,
		-1,
		185,
		226,
		173,
		155,
		151,
		137,
		144,
		138,
		127,
		132,
		142,
		136,
		133,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		184,
		-1,
		-1,
		-1,
		144,
		163,
		158,
		164,
		169,
		160,
		188,
		185,
		-1,
		134,
		167,
		133,
		140,
		123,
		130,
		135,
		132,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		177,
		166,
		155,
		161,
		-1,
		137,
		160,
		150,
		140,
		146,
		-1,
		-1,
		152,
		149,
		147,
		127,
		131,
		124,
		119,
		129,
		105,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		131,
		168,
		161,
		129,
		137,
		168,
		-1,
		127,
		119,
		147,
		132,
		140,
		-1,
		-1,
		125,
		116,
		121,
		130,
		131,
		143,
		142,
		125,
		131,
		132,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		124,
		144,
		123,
		126,
		150,
		164,
		-1,
		118,
		-1,
		-1,
		134,
		150,
		134,
		124,
		121,
		168,
		144,
		139,
		130,
		128,
		123,
		114,
		139,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		113,
		124,
		117,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		-1,
		124,
		-1,
		161,
		-1,
		144,
		148,
		152,
		155,
		144,
		131,
		117,
		125,
		131,
		130,
		136,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		138,
		94,
		97,
		108,
		119,
		134,
		138,
		-1,
		102,
		138,
		130,
		-1,
		114,
		-1,
		-1,
		-1,
		158,
		165,
		157,
		164,
		143,
		143,
		109,
		113,
		126,
		133,
		143,
		154,
		146,
		150,
		163,
		174,
		177,
		134,
		125,
		138,
		83,
		83,
		104,
		113,
		134,
		98,
		95,
		132,
		137,
		126,
		121,
		108,
		-1,
		-1,
		177,
		175,
		-1,
		-1,
		150,
		117,
		105,
		115,
		119,
		133,
		145,
		158,
		146,
		151,
		145,
		177,
		-1,
		127,
		126,
		115,
		112,
		88,
		79,
		74,
		101,
		-1,
		-1,
		96,
		123,
		107,
		111,
		127,
		152,
		-1,
		92,
		-1,
		-1,
		157,
		-1,
		-1,
		142,
		122,
		111,
		102,
		107,
		127,
		138,
		160,
		142,
		159,
		150,
		160,
		164,
		111,
		108,
		96,
		94,
		117,
		82,
		70,
		-1,
		78,
		81,
		87,
		94,
		111,
		141,
		-1,
		-1,
		108,
		88,
		-1,
		-1,
		140,
		138,
		127,
		-1,
		117,
		99,
		104,
		134,
		136,
		138,
		145,
		139,
		146,
		154,
		165,
		157,
		120,
		134,
		123,
		119,
		118,
		126,
		75,
		68,
		75,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		98,
		94,
		-1,
		-1,
		135,
		128,
		116,
		104,
		94,
		104,
		121,
		121,
		124,
		129,
		137,
		148,
		144,
		148,
		151,
		-1,
		154,
		-1,
		106,
		67,
		73,
		88,
		96,
		-1,
		-1,
		-1,
		115,
		101,
		94,
		82,
		80,
		-1,
		169,
		153,
		134,
		-1,
		104,
		117,
		157,
		125,
		130,
		125,
		140,
		151,
		142,
		150,
		144,
		147,
		-1,
		-1,
		66,
		49,
		-1,
		-1,
		23,
		25,
		-1,
		106,
		95,
		80,
		72,
		-1,
		-1,
		141,
		137,
		-1,
		-1,
		91,
		129,
		128,
		136,
		131,
		136,
		148,
		144,
		140,
		150,
		141,
		-1,
		-1,
		44,
		36,
		30,
		-1,
		8,
		-1,
		108,
		-1,
		75,
		82,
		70,
		-1,
		-1,
		-1,
		122,
		85,
		101,
		124,
		150,
		148,
		139,
		132,
		139,
		142,
		135,
		141,
		-1,
		-1,
		-1,
		26,
		0,
		115,
		106,
		89,
		69,
		61,
		81,
		-1,
		103,
		-1,
		78,
		81,
		106,
		145,
		147,
		133,
		129,
		142,
		136,
		133,
		131,
		32,
		-1,
		4,
		63,
		46,
		75,
		41,
		53,
		117,
		-1,
		100,
		82,
		-1,
		110,
		100,
		148,
		123,
		132,
		125,
		119,
		120,
		128,
		-1,
		-1,
		-1,
		19,
		18,
		17,
		28,
		36,
		34,
		52,
		-1,
		105,
		87,
		73,
		90,
		90,
		81,
		89,
		138,
		134,
		137,
		135,
		113,
		-1,
		125,
		-1,
		-1,
		42,
		-1,
		-1,
		-1,
		45,
		67,
		62,
		54,
		66,
		75,
		70,
		72,
		85,
		93,
		91,
		88,
		100,
		96,
		116,
		112,
		144,
		-1,
		132,
		-1,
		49,
		-1,
		-1,
		63,
		49,
		61,
		72,
		62,
		62,
		67,
		65,
		87,
		117,
		103,
		101,
		106,
		111,
		-1,
		142,
		143,
		-1,
		82,
		74,
		60,
		-1,
		53,
		-1,
		108,
		69,
		-1,
		94,
		74,
		-1,
		112,
		108,
		-1,
		-1,
		138,
		98,
		-1,
		-1,
		-1,
		83,
		63,
		103,
		87,
		-1,
		85,
		85,
		-1,
		-1,
		-1,
		123,
		107,
		-1,
		76,
		79,
		-1,
		70,
		76,
		105,
		87,
		91,
		-1,
		-1,
		-1,
		132,
		113,
		107,
		91,
		96,
		84,
		101,
		87,
		89,
		101,
		90,
		111,
		-1,
		-1,
		-1,
		104,
		96,
		96,
		-1,
		-1,
		114,
		97,
		97,
		110,
		-1,
		-1,
		-1,
		126,
		107,
		-1,
		-1,
		105,
		-1,
		-1,
		110,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		115,
		-1,
		-1,
		-1,
		106,
		113,
		121,
		-1,
		-1,
		-1,
		-1,
		136,
		137,
		161,
		136,
		-1,
		-1,
		-1,
		120,
		120,
		-1,
		-1,
		139,
		137,
		-1,
		-1,
		-1,
		148,
		132,
		-1,
		124,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		153,
		-1,
		159,
		134,
		141,
		-1,
		-1,
		-1,
		-1,
		166,
		158,
		172,
		-1,
		144,
		146,
		-1,
		194,
		-1,
		-1,
		181,
		172,
		-1,
		-1,
		149,
		156,
		178,
		181,
		211,
		-1,
		168
	],
	[
		-1,
		323,
		312,
		323,
		331,
		304,
		311,
		-1,
		330,
		334,
		300,
		294,
		333,
		302,
		308,
		319,
		-1,
		-1,
		-1,
		323,
		322,
		290,
		288,
		297,
		302,
		309,
		-1,
		308,
		-1,
		344,
		323,
		334,
		339,
		283,
		280,
		300,
		319,
		301,
		293,
		359,
		313,
		284,
		278,
		296,
		286,
		295,
		287,
		-1,
		284,
		274,
		296,
		275,
		286,
		278,
		-1,
		-1,
		278,
		279,
		285,
		271,
		277,
		273,
		-1,
		283,
		267,
		-1,
		-1,
		268,
		269,
		253,
		256,
		264,
		262,
		275,
		267,
		262,
		-1,
		-1,
		259,
		255,
		262,
		249,
		245,
		262,
		275,
		257,
		271,
		270,
		-1,
		263,
		281,
		288,
		256,
		254,
		238,
		236,
		254,
		256,
		262,
		262,
		-1,
		272,
		273,
		268,
		276,
		278,
		254,
		241,
		241,
		251,
		244,
		263,
		251,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		272,
		255,
		272,
		264,
		254,
		269,
		262,
		244,
		241,
		239,
		236,
		252,
		250,
		260,
		-1,
		-1,
		365,
		334,
		363,
		321,
		302,
		-1,
		268,
		248,
		254,
		258,
		252,
		245,
		259,
		255,
		-1,
		230,
		229,
		257,
		243,
		254,
		325,
		-1,
		-1,
		323,
		315,
		298,
		301,
		278,
		274,
		263,
		262,
		254,
		240,
		236,
		242,
		245,
		245,
		251,
		224,
		234,
		238,
		236,
		261,
		-1,
		-1,
		296,
		-1,
		-1,
		322,
		305,
		-1,
		288,
		295,
		284,
		290,
		276,
		297,
		273,
		264,
		256,
		250,
		238,
		240,
		237,
		250,
		238,
		221,
		246,
		250,
		231,
		252,
		247,
		-1,
		295,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		281,
		284,
		290,
		314,
		313,
		-1,
		285,
		273,
		274,
		259,
		256,
		243,
		231,
		244,
		229,
		236,
		235,
		225,
		223,
		253,
		228,
		250,
		247,
		266,
		271,
		265,
		274,
		-1,
		330,
		326,
		322,
		329,
		278,
		-1,
		-1,
		318,
		-1,
		321,
		322,
		297,
		270,
		273,
		260,
		251,
		238,
		227,
		238,
		227,
		224,
		232,
		217,
		232,
		223,
		222,
		240,
		250,
		258,
		262,
		268,
		-1,
		380,
		-1,
		322,
		306,
		308,
		280,
		301,
		-1,
		338,
		322,
		314,
		299,
		299,
		-1,
		269,
		266,
		256,
		234,
		219,
		236,
		228,
		226,
		230,
		212,
		226,
		217,
		235,
		242,
		240,
		244,
		264,
		276,
		340,
		330,
		-1,
		312,
		317,
		276,
		284,
		303,
		341,
		305,
		-1,
		300,
		-1,
		271,
		284,
		-1,
		240,
		236,
		218,
		219,
		214,
		229,
		223,
		208,
		205,
		223,
		226,
		233,
		237,
		253,
		-1,
		-1,
		325,
		329,
		318,
		269,
		288,
		312,
		349,
		298,
		287,
		286,
		-1,
		277,
		254,
		251,
		239,
		226,
		211,
		212,
		220,
		233,
		212,
		207,
		204,
		224,
		250,
		228,
		240,
		-1,
		-1,
		-1,
		350,
		-1,
		-1,
		295,
		266,
		290,
		332,
		316,
		309,
		297,
		262,
		262,
		256,
		-1,
		250,
		229,
		220,
		209,
		207,
		220,
		217,
		222,
		202,
		200,
		219,
		231,
		222,
		239,
		-1,
		-1,
		-1,
		325,
		314,
		315,
		261,
		284,
		321,
		295,
		281,
		286,
		261,
		254,
		248,
		263,
		246,
		227,
		216,
		208,
		197,
		213,
		221,
		216,
		198,
		207,
		213,
		237,
		227,
		233,
		-1,
		-1,
		332,
		322,
		306,
		308,
		305,
		275,
		282,
		314,
		286,
		299,
		-1,
		253,
		-1,
		242,
		237,
		221,
		216,
		213,
		210,
		204,
		213,
		215,
		205,
		200,
		207,
		242,
		242,
		217,
		237,
		240,
		-1,
		-1,
		-1,
		325,
		320,
		295,
		272,
		256,
		292,
		-1,
		269,
		270,
		-1,
		247,
		241,
		238,
		223,
		219,
		214,
		218,
		211,
		218,
		211,
		209,
		210,
		192,
		224,
		-1,
		225,
		219,
		227,
		217,
		205,
		-1,
		-1,
		-1,
		318,
		297,
		290,
		310,
		251,
		303,
		-1,
		-1,
		254,
		247,
		-1,
		234,
		216,
		223,
		221,
		215,
		219,
		216,
		205,
		218,
		211,
		197,
		199,
		212,
		216,
		220,
		207,
		203,
		200,
		214,
		-1,
		337,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		271,
		-1,
		263,
		255,
		245,
		239,
		233,
		229,
		227,
		243,
		227,
		230,
		228,
		219,
		227,
		200,
		193,
		200,
		189,
		207,
		215,
		207,
		201,
		200,
		210,
		-1,
		338,
		324,
		295,
		-1,
		-1,
		284,
		-1,
		248,
		262,
		278,
		-1,
		271,
		250,
		265,
		243,
		239,
		235,
		250,
		251,
		228,
		228,
		226,
		217,
		205,
		194,
		197,
		189,
		211,
		211,
		195,
		196,
		200,
		-1,
		344,
		331,
		289,
		285,
		274,
		294,
		245,
		233,
		265,
		-1,
		-1,
		307,
		-1,
		241,
		258,
		249,
		247,
		240,
		222,
		229,
		237,
		214,
		209,
		199,
		188,
		188,
		183,
		205,
		191,
		189,
		198,
		214,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		260,
		247,
		241,
		-1,
		282,
		-1,
		285,
		275,
		259,
		244,
		277,
		-1,
		221,
		217,
		224,
		-1,
		234,
		-1,
		207,
		204,
		195,
		180,
		177,
		188,
		186,
		197,
		193,
		-1,
		294,
		279,
		272,
		262,
		276,
		247,
		-1,
		300,
		-1,
		-1,
		272,
		266,
		266,
		250,
		251,
		237,
		217,
		209,
		224,
		223,
		210,
		209,
		193,
		186,
		183,
		176,
		189,
		199,
		204,
		191,
		-1,
		-1,
		-1,
		299,
		285,
		289,
		249,
		266,
		-1,
		-1,
		334,
		289,
		275,
		-1,
		246,
		237,
		225,
		215,
		205,
		210,
		211,
		201,
		199,
		191,
		193,
		187,
		178,
		177,
		193,
		185,
		207,
		-1,
		-1,
		282,
		287,
		275,
		244,
		239,
		-1,
		-1,
		-1,
		281,
		297,
		265,
		244,
		226,
		-1,
		-1,
		209,
		202,
		196,
		199,
		187,
		207,
		202,
		186,
		171,
		186,
		190,
		198,
		189,
		-1,
		285,
		272,
		-1,
		-1,
		238,
		228,
		-1,
		-1,
		-1,
		-1,
		277,
		222,
		211,
		206,
		210,
		208,
		-1,
		182,
		193,
		186,
		205,
		212,
		188,
		173,
		167,
		173,
		185,
		194,
		-1,
		-1,
		252,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		234,
		228,
		199,
		192,
		196,
		-1,
		184,
		186,
		183,
		195,
		191,
		188,
		179,
		170,
		166,
		170,
		174,
		188,
		192,
		275,
		-1,
		205,
		-1,
		-1,
		-1,
		251,
		267,
		238,
		215,
		188,
		183,
		176,
		170,
		175,
		186,
		195,
		206,
		171,
		173,
		163,
		162,
		166,
		183,
		187,
		-1,
		-1,
		203,
		199,
		234,
		246,
		246,
		265,
		-1,
		-1,
		192,
		183,
		174,
		166,
		179,
		182,
		167,
		169,
		169,
		167,
		161,
		171,
		186,
		181,
		-1,
		-1,
		-1,
		215,
		-1,
		217,
		-1,
		-1,
		236,
		263,
		210,
		192,
		188,
		186,
		175,
		169,
		157,
		162,
		172,
		166,
		163,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		222,
		186,
		181,
		215,
		220,
		211,
		225,
		222,
		-1,
		192,
		198,
		163,
		170,
		153,
		160,
		165,
		162,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		293,
		282,
		271,
		277,
		-1,
		215,
		183,
		201,
		191,
		197,
		-1,
		-1,
		217,
		214,
		194,
		163,
		161,
		154,
		149,
		159,
		135,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		247,
		284,
		277,
		245,
		253,
		284,
		-1,
		205,
		197,
		180,
		183,
		191,
		-1,
		-1,
		190,
		181,
		182,
		170,
		167,
		173,
		172,
		155,
		161,
		162,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		240,
		260,
		239,
		242,
		266,
		280,
		-1,
		202,
		-1,
		-1,
		140,
		204,
		199,
		189,
		186,
		229,
		184,
		179,
		160,
		158,
		153,
		144,
		169,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		229,
		240,
		233,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		130,
		-1,
		226,
		-1,
		209,
		213,
		192,
		195,
		174,
		161,
		147,
		155,
		161,
		160,
		166,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		254,
		210,
		213,
		224,
		235,
		250,
		254,
		-1,
		214,
		253,
		136,
		-1,
		120,
		-1,
		-1,
		-1,
		223,
		205,
		197,
		194,
		173,
		173,
		139,
		143,
		156,
		163,
		173,
		184,
		176,
		180,
		193,
		204,
		207,
		250,
		241,
		254,
		199,
		199,
		220,
		229,
		250,
		214,
		211,
		247,
		143,
		132,
		127,
		114,
		-1,
		-1,
		207,
		215,
		-1,
		-1,
		180,
		147,
		135,
		145,
		149,
		163,
		175,
		188,
		176,
		181,
		175,
		207,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		217,
		-1,
		-1,
		212,
		239,
		199,
		176,
		174,
		199,
		-1,
		98,
		-1,
		-1,
		187,
		-1,
		-1,
		172,
		152,
		141,
		132,
		137,
		157,
		168,
		190,
		172,
		189,
		180,
		190,
		194,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		194,
		197,
		203,
		197,
		177,
		188,
		-1,
		-1,
		114,
		94,
		-1,
		-1,
		170,
		168,
		157,
		-1,
		147,
		129,
		134,
		164,
		166,
		168,
		175,
		169,
		176,
		184,
		195,
		187,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		100,
		100,
		-1,
		-1,
		165,
		158,
		146,
		134,
		124,
		134,
		151,
		151,
		154,
		159,
		167,
		178,
		174,
		178,
		181,
		-1,
		270,
		-1,
		222,
		183,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		117,
		103,
		96,
		84,
		82,
		-1,
		199,
		183,
		164,
		-1,
		134,
		147,
		187,
		155,
		160,
		155,
		170,
		181,
		172,
		180,
		174,
		177,
		-1,
		-1,
		182,
		165,
		-1,
		-1,
		139,
		141,
		-1,
		108,
		97,
		82,
		74,
		-1,
		-1,
		171,
		167,
		-1,
		-1,
		121,
		159,
		158,
		166,
		161,
		166,
		178,
		174,
		170,
		180,
		171,
		-1,
		-1,
		160,
		152,
		146,
		-1,
		124,
		-1,
		7,
		-1,
		77,
		93,
		95,
		-1,
		-1,
		-1,
		152,
		115,
		131,
		154,
		180,
		178,
		169,
		162,
		169,
		172,
		165,
		171,
		-1,
		-1,
		-1,
		142,
		116,
		0,
		9,
		27,
		46,
		56,
		110,
		-1,
		133,
		-1,
		108,
		111,
		136,
		175,
		177,
		163,
		159,
		172,
		166,
		163,
		161,
		148,
		-1,
		118,
		151,
		115,
		40,
		83,
		88,
		147,
		-1,
		130,
		112,
		-1,
		140,
		130,
		178,
		153,
		162,
		155,
		149,
		150,
		158,
		-1,
		-1,
		-1,
		120,
		119,
		111,
		105,
		103,
		88,
		83,
		-1,
		135,
		117,
		103,
		120,
		120,
		111,
		119,
		168,
		164,
		167,
		165,
		143,
		-1,
		234,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		114,
		123,
		96,
		84,
		98,
		105,
		100,
		102,
		115,
		123,
		121,
		118,
		130,
		126,
		146,
		142,
		174,
		-1,
		229,
		-1,
		150,
		-1,
		-1,
		130,
		116,
		118,
		107,
		96,
		94,
		97,
		95,
		117,
		147,
		133,
		131,
		136,
		141,
		-1,
		218,
		217,
		-1,
		149,
		141,
		127,
		-1,
		120,
		-1,
		142,
		103,
		-1,
		124,
		104,
		-1,
		142,
		138,
		-1,
		-1,
		205,
		165,
		-1,
		-1,
		-1,
		150,
		130,
		137,
		121,
		-1,
		115,
		115,
		-1,
		-1,
		-1,
		190,
		174,
		-1,
		143,
		146,
		-1,
		137,
		143,
		170,
		117,
		121,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		158,
		163,
		151,
		168,
		154,
		153,
		131,
		120,
		141,
		-1,
		-1,
		-1,
		171,
		163,
		163,
		-1,
		-1,
		178,
		161,
		142,
		140,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		168,
		-1,
		-1,
		174,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		182,
		-1,
		-1,
		-1,
		164,
		160,
		161,
		-1,
		-1,
		-1,
		-1,
		203,
		204,
		228,
		203,
		-1,
		-1,
		-1,
		156,
		150,
		-1,
		-1,
		206,
		204,
		-1,
		-1,
		-1,
		184,
		168,
		-1,
		154,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		189,
		-1,
		189,
		164,
		171,
		-1,
		-1,
		-1,
		-1,
		202,
		194,
		202,
		-1,
		174,
		176,
		-1,
		224,
		-1,
		-1,
		217,
		208,
		-1,
		-1,
		179,
		186,
		208,
		211,
		247,
		-1,
		198
	],
	[
		-1,
		314,
		303,
		314,
		322,
		295,
		302,
		-1,
		321,
		325,
		291,
		285,
		324,
		293,
		299,
		310,
		-1,
		-1,
		-1,
		314,
		313,
		281,
		279,
		288,
		293,
		300,
		-1,
		299,
		-1,
		335,
		314,
		325,
		330,
		274,
		271,
		291,
		310,
		292,
		284,
		350,
		304,
		275,
		269,
		287,
		277,
		286,
		278,
		-1,
		275,
		265,
		287,
		266,
		277,
		269,
		-1,
		-1,
		269,
		270,
		276,
		262,
		268,
		264,
		-1,
		274,
		258,
		-1,
		-1,
		259,
		260,
		244,
		247,
		255,
		253,
		266,
		258,
		253,
		-1,
		-1,
		250,
		246,
		253,
		240,
		236,
		253,
		266,
		248,
		262,
		261,
		-1,
		254,
		272,
		279,
		247,
		245,
		229,
		227,
		245,
		247,
		253,
		253,
		-1,
		263,
		264,
		259,
		267,
		269,
		245,
		232,
		232,
		242,
		235,
		254,
		242,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		263,
		246,
		263,
		255,
		245,
		260,
		253,
		235,
		232,
		230,
		227,
		243,
		241,
		251,
		-1,
		-1,
		356,
		325,
		354,
		312,
		293,
		-1,
		259,
		239,
		245,
		249,
		243,
		236,
		250,
		246,
		-1,
		221,
		220,
		248,
		234,
		245,
		316,
		-1,
		-1,
		314,
		306,
		289,
		292,
		269,
		265,
		254,
		253,
		245,
		231,
		227,
		233,
		236,
		236,
		242,
		215,
		225,
		229,
		227,
		252,
		-1,
		-1,
		287,
		-1,
		-1,
		313,
		296,
		-1,
		279,
		286,
		275,
		281,
		267,
		288,
		264,
		255,
		247,
		241,
		229,
		231,
		228,
		241,
		229,
		212,
		237,
		241,
		222,
		243,
		238,
		-1,
		286,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		272,
		275,
		281,
		305,
		304,
		-1,
		276,
		264,
		265,
		250,
		247,
		234,
		222,
		235,
		220,
		227,
		226,
		216,
		214,
		244,
		219,
		241,
		238,
		257,
		262,
		256,
		265,
		-1,
		321,
		317,
		313,
		320,
		269,
		-1,
		-1,
		309,
		-1,
		312,
		313,
		288,
		261,
		264,
		251,
		242,
		229,
		218,
		229,
		218,
		215,
		223,
		208,
		223,
		214,
		213,
		231,
		241,
		249,
		253,
		259,
		-1,
		371,
		-1,
		313,
		297,
		299,
		271,
		292,
		-1,
		329,
		313,
		305,
		290,
		290,
		-1,
		260,
		257,
		247,
		225,
		210,
		227,
		219,
		217,
		221,
		203,
		217,
		208,
		226,
		233,
		231,
		235,
		255,
		267,
		331,
		321,
		-1,
		303,
		308,
		267,
		275,
		294,
		332,
		296,
		-1,
		291,
		-1,
		262,
		275,
		-1,
		231,
		227,
		209,
		210,
		205,
		220,
		214,
		199,
		196,
		214,
		217,
		224,
		228,
		244,
		-1,
		-1,
		316,
		320,
		309,
		260,
		279,
		303,
		340,
		289,
		278,
		277,
		-1,
		268,
		245,
		242,
		230,
		217,
		202,
		203,
		211,
		224,
		203,
		198,
		195,
		215,
		241,
		219,
		231,
		-1,
		-1,
		-1,
		341,
		-1,
		-1,
		286,
		257,
		281,
		323,
		307,
		300,
		288,
		253,
		253,
		247,
		-1,
		241,
		220,
		211,
		200,
		198,
		211,
		208,
		213,
		193,
		191,
		210,
		222,
		213,
		230,
		-1,
		-1,
		-1,
		316,
		305,
		306,
		252,
		275,
		312,
		286,
		272,
		277,
		252,
		245,
		239,
		254,
		237,
		218,
		207,
		199,
		188,
		204,
		212,
		207,
		189,
		198,
		204,
		228,
		218,
		224,
		-1,
		-1,
		323,
		313,
		297,
		299,
		296,
		266,
		273,
		305,
		277,
		290,
		-1,
		244,
		-1,
		233,
		228,
		212,
		207,
		204,
		201,
		195,
		204,
		206,
		196,
		191,
		198,
		233,
		233,
		208,
		228,
		231,
		-1,
		-1,
		-1,
		316,
		311,
		286,
		263,
		247,
		283,
		-1,
		260,
		261,
		-1,
		238,
		232,
		229,
		214,
		210,
		205,
		209,
		202,
		209,
		202,
		200,
		201,
		183,
		215,
		-1,
		216,
		210,
		218,
		208,
		196,
		-1,
		-1,
		-1,
		309,
		288,
		281,
		301,
		242,
		294,
		-1,
		-1,
		245,
		238,
		-1,
		225,
		207,
		214,
		212,
		206,
		210,
		207,
		196,
		209,
		202,
		188,
		190,
		203,
		207,
		211,
		198,
		194,
		191,
		205,
		-1,
		328,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		262,
		-1,
		254,
		246,
		236,
		230,
		224,
		220,
		218,
		234,
		218,
		221,
		219,
		210,
		218,
		191,
		184,
		191,
		180,
		198,
		206,
		198,
		192,
		191,
		201,
		-1,
		329,
		315,
		286,
		-1,
		-1,
		275,
		-1,
		239,
		253,
		269,
		-1,
		262,
		241,
		256,
		234,
		230,
		226,
		241,
		242,
		219,
		219,
		217,
		208,
		196,
		185,
		188,
		180,
		202,
		202,
		186,
		187,
		191,
		-1,
		335,
		322,
		280,
		276,
		265,
		285,
		236,
		224,
		256,
		-1,
		-1,
		298,
		-1,
		232,
		249,
		240,
		238,
		231,
		213,
		220,
		228,
		205,
		200,
		190,
		179,
		179,
		174,
		196,
		182,
		180,
		189,
		205,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		251,
		238,
		232,
		-1,
		273,
		-1,
		276,
		266,
		250,
		235,
		268,
		-1,
		212,
		208,
		215,
		-1,
		225,
		-1,
		198,
		195,
		186,
		171,
		168,
		179,
		177,
		188,
		184,
		-1,
		285,
		270,
		263,
		253,
		267,
		238,
		-1,
		291,
		-1,
		-1,
		263,
		257,
		257,
		241,
		242,
		228,
		208,
		200,
		215,
		214,
		201,
		200,
		184,
		177,
		174,
		167,
		180,
		190,
		195,
		182,
		-1,
		-1,
		-1,
		290,
		276,
		280,
		240,
		257,
		-1,
		-1,
		325,
		280,
		266,
		-1,
		237,
		228,
		216,
		206,
		196,
		201,
		202,
		192,
		190,
		182,
		184,
		178,
		169,
		168,
		184,
		176,
		198,
		-1,
		-1,
		273,
		278,
		266,
		235,
		230,
		-1,
		-1,
		-1,
		272,
		288,
		256,
		235,
		217,
		-1,
		-1,
		200,
		193,
		187,
		190,
		178,
		198,
		193,
		177,
		162,
		177,
		181,
		189,
		180,
		-1,
		276,
		263,
		-1,
		-1,
		229,
		219,
		-1,
		-1,
		-1,
		-1,
		268,
		213,
		202,
		197,
		201,
		199,
		-1,
		173,
		184,
		177,
		196,
		203,
		179,
		164,
		158,
		164,
		176,
		185,
		-1,
		-1,
		243,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		225,
		219,
		190,
		183,
		187,
		-1,
		175,
		177,
		174,
		186,
		182,
		179,
		170,
		161,
		157,
		161,
		165,
		179,
		183,
		266,
		-1,
		196,
		-1,
		-1,
		-1,
		242,
		258,
		229,
		206,
		179,
		174,
		167,
		161,
		166,
		177,
		186,
		197,
		162,
		164,
		154,
		153,
		157,
		174,
		178,
		-1,
		-1,
		194,
		190,
		225,
		237,
		237,
		256,
		-1,
		-1,
		183,
		174,
		165,
		157,
		170,
		173,
		158,
		160,
		160,
		158,
		152,
		162,
		177,
		172,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		227,
		254,
		201,
		183,
		179,
		177,
		166,
		160,
		148,
		153,
		163,
		157,
		154,
		148,
		152,
		175,
		164,
		203,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		213,
		177,
		172,
		206,
		211,
		202,
		216,
		213,
		-1,
		183,
		189,
		154,
		161,
		144,
		151,
		156,
		153,
		142,
		149,
		165,
		164,
		159,
		195,
		186,
		192,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		206,
		174,
		192,
		182,
		188,
		-1,
		-1,
		208,
		205,
		185,
		154,
		152,
		145,
		140,
		150,
		126,
		138,
		142,
		146,
		152,
		157,
		162,
		168,
		183,
		198,
		-1,
		238,
		275,
		268,
		236,
		244,
		275,
		-1,
		196,
		188,
		171,
		174,
		182,
		-1,
		-1,
		181,
		172,
		173,
		161,
		158,
		164,
		163,
		146,
		152,
		153,
		145,
		144,
		162,
		166,
		175,
		182,
		172,
		185,
		189,
		-1,
		231,
		251,
		230,
		233,
		257,
		271,
		-1,
		193,
		-1,
		-1,
		131,
		195,
		190,
		180,
		177,
		220,
		175,
		170,
		151,
		149,
		144,
		135,
		160,
		153,
		153,
		156,
		171,
		176,
		168,
		182,
		182,
		183,
		-1,
		220,
		231,
		224,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		121,
		-1,
		217,
		-1,
		200,
		204,
		183,
		186,
		165,
		152,
		138,
		146,
		152,
		151,
		157,
		157,
		158,
		167,
		178,
		190,
		189,
		190,
		245,
		201,
		204,
		215,
		226,
		241,
		245,
		-1,
		205,
		244,
		127,
		-1,
		111,
		-1,
		-1,
		-1,
		214,
		196,
		188,
		185,
		164,
		164,
		130,
		134,
		147,
		154,
		164,
		175,
		167,
		171,
		184,
		195,
		198,
		241,
		232,
		245,
		190,
		190,
		211,
		220,
		241,
		205,
		202,
		238,
		134,
		123,
		118,
		105,
		-1,
		-1,
		198,
		206,
		-1,
		-1,
		171,
		138,
		126,
		136,
		140,
		154,
		166,
		179,
		167,
		172,
		166,
		198,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		181,
		208,
		-1,
		-1,
		203,
		230,
		190,
		167,
		165,
		190,
		-1,
		89,
		-1,
		-1,
		178,
		-1,
		-1,
		163,
		143,
		132,
		123,
		128,
		148,
		159,
		181,
		163,
		180,
		171,
		181,
		185,
		218,
		215,
		203,
		201,
		224,
		189,
		177,
		-1,
		185,
		188,
		194,
		188,
		168,
		179,
		-1,
		-1,
		105,
		85,
		-1,
		-1,
		161,
		159,
		148,
		-1,
		138,
		120,
		125,
		155,
		157,
		159,
		166,
		160,
		167,
		175,
		186,
		178,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		91,
		91,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		142,
		142,
		145,
		150,
		158,
		169,
		165,
		169,
		172,
		-1,
		261,
		-1,
		213,
		174,
		180,
		195,
		203,
		-1,
		-1,
		-1,
		108,
		94,
		87,
		75,
		73,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		178,
		146,
		151,
		146,
		161,
		172,
		163,
		171,
		165,
		168,
		-1,
		-1,
		173,
		156,
		-1,
		-1,
		130,
		132,
		-1,
		99,
		88,
		73,
		65,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		112,
		150,
		149,
		157,
		152,
		157,
		169,
		165,
		161,
		171,
		162,
		-1,
		-1,
		151,
		143,
		137,
		-1,
		115,
		-1,
		2,
		-1,
		68,
		84,
		86,
		-1,
		-1,
		-1,
		143,
		106,
		122,
		145,
		171,
		169,
		160,
		153,
		160,
		163,
		156,
		162,
		-1,
		-1,
		-1,
		133,
		107,
		9,
		0,
		18,
		37,
		47,
		101,
		-1,
		124,
		-1,
		99,
		102,
		127,
		166,
		168,
		154,
		150,
		163,
		157,
		154,
		152,
		139,
		-1,
		109,
		142,
		106,
		31,
		74,
		79,
		138,
		-1,
		121,
		103,
		-1,
		131,
		121,
		169,
		144,
		153,
		146,
		140,
		141,
		149,
		-1,
		-1,
		-1,
		111,
		110,
		102,
		96,
		94,
		79,
		74,
		-1,
		126,
		108,
		94,
		111,
		111,
		102,
		110,
		159,
		155,
		158,
		156,
		134,
		-1,
		225,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		105,
		114,
		87,
		75,
		89,
		96,
		91,
		93,
		106,
		114,
		112,
		109,
		121,
		117,
		137,
		133,
		165,
		-1,
		220,
		-1,
		141,
		-1,
		-1,
		121,
		107,
		109,
		98,
		87,
		85,
		88,
		86,
		108,
		138,
		124,
		122,
		127,
		132,
		-1,
		209,
		208,
		-1,
		140,
		132,
		118,
		-1,
		111,
		-1,
		133,
		94,
		-1,
		115,
		95,
		-1,
		133,
		129,
		-1,
		-1,
		196,
		156,
		-1,
		-1,
		-1,
		141,
		121,
		128,
		112,
		-1,
		106,
		106,
		-1,
		-1,
		-1,
		181,
		165,
		-1,
		134,
		137,
		-1,
		128,
		134,
		161,
		108,
		112,
		-1,
		-1,
		-1,
		190,
		171,
		165,
		149,
		154,
		142,
		159,
		145,
		144,
		122,
		111,
		132,
		-1,
		-1,
		-1,
		162,
		154,
		154,
		-1,
		-1,
		169,
		152,
		133,
		131,
		-1,
		-1,
		-1,
		184,
		165,
		-1,
		-1,
		159,
		-1,
		-1,
		165,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		173,
		-1,
		-1,
		-1,
		155,
		151,
		152,
		-1,
		-1,
		-1,
		-1,
		194,
		195,
		219,
		194,
		-1,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		197,
		195,
		-1,
		-1,
		-1,
		175,
		159,
		-1,
		145,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		178,
		-1,
		-1,
		-1,
		180,
		-1,
		180,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		193,
		185,
		193,
		-1,
		165,
		167,
		-1,
		215,
		-1,
		-1,
		208,
		199,
		-1,
		-1,
		170,
		177,
		199,
		202,
		238,
		-1,
		189
	],
	[
		-1,
		296,
		285,
		296,
		304,
		277,
		284,
		-1,
		303,
		307,
		273,
		267,
		306,
		275,
		281,
		292,
		-1,
		-1,
		-1,
		296,
		295,
		263,
		261,
		270,
		275,
		282,
		-1,
		281,
		-1,
		317,
		296,
		307,
		312,
		256,
		253,
		273,
		292,
		274,
		266,
		332,
		286,
		257,
		251,
		269,
		259,
		268,
		260,
		-1,
		257,
		247,
		269,
		248,
		259,
		251,
		-1,
		-1,
		251,
		252,
		258,
		244,
		250,
		246,
		-1,
		256,
		240,
		-1,
		-1,
		241,
		242,
		226,
		229,
		237,
		235,
		248,
		240,
		235,
		-1,
		-1,
		232,
		228,
		235,
		222,
		218,
		235,
		248,
		230,
		244,
		243,
		-1,
		236,
		254,
		261,
		229,
		227,
		211,
		209,
		227,
		229,
		235,
		235,
		-1,
		245,
		246,
		241,
		249,
		251,
		227,
		214,
		214,
		224,
		217,
		236,
		224,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		245,
		228,
		245,
		237,
		227,
		242,
		235,
		217,
		214,
		212,
		209,
		225,
		223,
		233,
		-1,
		-1,
		338,
		307,
		336,
		294,
		275,
		-1,
		241,
		221,
		227,
		231,
		225,
		218,
		232,
		228,
		-1,
		203,
		202,
		230,
		216,
		227,
		298,
		-1,
		-1,
		296,
		288,
		271,
		274,
		251,
		247,
		236,
		235,
		227,
		213,
		209,
		215,
		218,
		218,
		224,
		197,
		207,
		211,
		209,
		234,
		-1,
		-1,
		269,
		-1,
		-1,
		295,
		278,
		-1,
		261,
		268,
		257,
		263,
		249,
		270,
		246,
		237,
		229,
		223,
		211,
		213,
		210,
		223,
		211,
		194,
		219,
		223,
		204,
		225,
		220,
		-1,
		268,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		254,
		257,
		263,
		287,
		286,
		-1,
		258,
		246,
		247,
		232,
		229,
		216,
		204,
		217,
		202,
		209,
		208,
		198,
		196,
		226,
		201,
		223,
		220,
		239,
		244,
		238,
		247,
		-1,
		303,
		299,
		295,
		302,
		251,
		-1,
		-1,
		291,
		-1,
		294,
		295,
		270,
		243,
		246,
		233,
		224,
		211,
		200,
		211,
		200,
		197,
		205,
		190,
		205,
		196,
		195,
		213,
		223,
		231,
		235,
		241,
		-1,
		353,
		-1,
		295,
		279,
		281,
		253,
		274,
		-1,
		311,
		295,
		287,
		272,
		272,
		-1,
		242,
		239,
		229,
		207,
		192,
		209,
		201,
		199,
		203,
		185,
		199,
		190,
		208,
		215,
		213,
		217,
		237,
		249,
		313,
		303,
		-1,
		285,
		290,
		249,
		257,
		276,
		314,
		278,
		-1,
		273,
		-1,
		244,
		257,
		-1,
		213,
		209,
		191,
		192,
		187,
		202,
		196,
		181,
		178,
		196,
		199,
		206,
		210,
		226,
		-1,
		-1,
		298,
		302,
		291,
		242,
		261,
		285,
		322,
		271,
		260,
		259,
		-1,
		250,
		227,
		224,
		212,
		199,
		184,
		185,
		193,
		206,
		185,
		180,
		177,
		197,
		223,
		201,
		213,
		-1,
		-1,
		-1,
		323,
		-1,
		-1,
		268,
		239,
		263,
		305,
		289,
		282,
		270,
		235,
		235,
		229,
		-1,
		223,
		202,
		193,
		182,
		180,
		193,
		190,
		195,
		175,
		173,
		192,
		204,
		195,
		212,
		-1,
		-1,
		-1,
		298,
		287,
		288,
		234,
		257,
		294,
		268,
		254,
		259,
		234,
		227,
		221,
		236,
		219,
		200,
		189,
		181,
		170,
		186,
		194,
		189,
		171,
		180,
		186,
		210,
		200,
		206,
		-1,
		-1,
		305,
		295,
		279,
		281,
		278,
		248,
		255,
		287,
		259,
		272,
		-1,
		226,
		-1,
		215,
		210,
		194,
		189,
		186,
		183,
		177,
		186,
		188,
		178,
		173,
		180,
		215,
		215,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		298,
		293,
		268,
		245,
		229,
		265,
		-1,
		242,
		243,
		-1,
		220,
		214,
		211,
		196,
		192,
		187,
		191,
		184,
		191,
		184,
		182,
		183,
		165,
		197,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		291,
		270,
		263,
		283,
		224,
		276,
		-1,
		-1,
		227,
		220,
		-1,
		207,
		189,
		196,
		194,
		188,
		192,
		189,
		178,
		191,
		184,
		170,
		172,
		185,
		189,
		193,
		180,
		176,
		173,
		187,
		-1,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		244,
		-1,
		236,
		228,
		218,
		212,
		206,
		202,
		200,
		216,
		200,
		203,
		201,
		192,
		200,
		173,
		166,
		173,
		162,
		180,
		188,
		180,
		174,
		173,
		183,
		-1,
		311,
		297,
		268,
		-1,
		-1,
		257,
		-1,
		221,
		235,
		251,
		-1,
		244,
		223,
		238,
		216,
		212,
		208,
		223,
		224,
		201,
		201,
		199,
		190,
		178,
		167,
		170,
		162,
		184,
		184,
		168,
		169,
		173,
		-1,
		317,
		304,
		262,
		258,
		247,
		267,
		218,
		206,
		238,
		-1,
		-1,
		280,
		-1,
		214,
		231,
		222,
		220,
		213,
		195,
		202,
		210,
		187,
		182,
		172,
		161,
		161,
		156,
		178,
		164,
		162,
		171,
		187,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		233,
		220,
		214,
		-1,
		255,
		-1,
		258,
		248,
		232,
		217,
		250,
		-1,
		194,
		190,
		197,
		-1,
		207,
		-1,
		180,
		177,
		168,
		153,
		150,
		161,
		159,
		170,
		166,
		-1,
		267,
		252,
		245,
		235,
		249,
		220,
		-1,
		273,
		-1,
		-1,
		245,
		239,
		239,
		223,
		224,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		166,
		159,
		156,
		149,
		162,
		172,
		177,
		164,
		-1,
		-1,
		-1,
		272,
		258,
		262,
		222,
		239,
		-1,
		-1,
		307,
		262,
		248,
		-1,
		219,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		164,
		166,
		160,
		151,
		150,
		166,
		158,
		180,
		-1,
		-1,
		255,
		260,
		248,
		217,
		212,
		-1,
		-1,
		-1,
		254,
		270,
		238,
		217,
		199,
		-1,
		-1,
		182,
		175,
		169,
		172,
		160,
		180,
		175,
		159,
		144,
		159,
		163,
		171,
		162,
		-1,
		258,
		245,
		-1,
		-1,
		211,
		201,
		-1,
		-1,
		-1,
		-1,
		250,
		195,
		184,
		179,
		183,
		181,
		-1,
		155,
		166,
		159,
		178,
		185,
		161,
		146,
		140,
		146,
		158,
		167,
		-1,
		-1,
		225,
		-1,
		187,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		172,
		165,
		169,
		-1,
		157,
		159,
		156,
		168,
		164,
		161,
		152,
		143,
		139,
		143,
		147,
		161,
		165,
		248,
		-1,
		178,
		-1,
		-1,
		-1,
		224,
		240,
		211,
		188,
		161,
		156,
		149,
		143,
		148,
		159,
		168,
		179,
		144,
		146,
		136,
		135,
		139,
		156,
		160,
		-1,
		-1,
		176,
		172,
		207,
		219,
		219,
		238,
		-1,
		-1,
		165,
		156,
		147,
		139,
		152,
		155,
		140,
		142,
		142,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		188,
		-1,
		190,
		-1,
		-1,
		209,
		236,
		183,
		165,
		161,
		159,
		148,
		142,
		130,
		135,
		145,
		139,
		136,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		195,
		159,
		154,
		188,
		193,
		184,
		198,
		195,
		-1,
		165,
		171,
		136,
		143,
		126,
		133,
		138,
		135,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		188,
		156,
		174,
		164,
		170,
		-1,
		-1,
		190,
		187,
		167,
		136,
		134,
		127,
		122,
		132,
		108,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		220,
		257,
		250,
		218,
		226,
		257,
		-1,
		178,
		170,
		153,
		156,
		164,
		-1,
		-1,
		163,
		154,
		155,
		143,
		140,
		146,
		145,
		128,
		134,
		135,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		213,
		233,
		212,
		215,
		239,
		253,
		-1,
		175,
		-1,
		-1,
		113,
		177,
		172,
		162,
		159,
		202,
		157,
		152,
		133,
		131,
		126,
		117,
		142,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		202,
		213,
		206,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		103,
		-1,
		199,
		-1,
		182,
		186,
		165,
		168,
		147,
		134,
		120,
		128,
		134,
		133,
		139,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		227,
		183,
		186,
		197,
		208,
		223,
		227,
		-1,
		187,
		226,
		109,
		-1,
		93,
		-1,
		-1,
		-1,
		196,
		178,
		170,
		167,
		146,
		146,
		112,
		116,
		129,
		136,
		146,
		157,
		149,
		153,
		166,
		177,
		180,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		187,
		184,
		220,
		116,
		105,
		100,
		87,
		-1,
		-1,
		180,
		188,
		-1,
		-1,
		153,
		120,
		108,
		118,
		122,
		136,
		148,
		161,
		149,
		154,
		148,
		180,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		212,
		172,
		149,
		147,
		172,
		-1,
		71,
		-1,
		-1,
		160,
		-1,
		-1,
		145,
		125,
		114,
		105,
		110,
		130,
		141,
		163,
		145,
		162,
		153,
		163,
		167,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		167,
		170,
		176,
		170,
		150,
		161,
		-1,
		-1,
		87,
		67,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		102,
		107,
		137,
		139,
		141,
		148,
		142,
		149,
		157,
		168,
		160,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		73,
		73,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		124,
		124,
		127,
		132,
		140,
		151,
		147,
		151,
		154,
		-1,
		243,
		-1,
		195,
		156,
		162,
		177,
		185,
		-1,
		-1,
		-1,
		90,
		76,
		69,
		57,
		55,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		160,
		128,
		133,
		128,
		143,
		154,
		145,
		153,
		147,
		150,
		-1,
		-1,
		155,
		138,
		-1,
		-1,
		112,
		114,
		-1,
		81,
		70,
		55,
		47,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		94,
		132,
		131,
		139,
		134,
		139,
		151,
		147,
		143,
		153,
		144,
		-1,
		-1,
		133,
		125,
		119,
		-1,
		97,
		-1,
		19,
		-1,
		50,
		66,
		68,
		-1,
		-1,
		-1,
		125,
		88,
		104,
		127,
		153,
		151,
		142,
		135,
		142,
		145,
		138,
		144,
		-1,
		-1,
		-1,
		115,
		89,
		26,
		17,
		0,
		19,
		29,
		83,
		-1,
		106,
		-1,
		81,
		84,
		109,
		148,
		150,
		136,
		132,
		145,
		139,
		136,
		134,
		121,
		-1,
		91,
		124,
		88,
		13,
		56,
		61,
		120,
		-1,
		103,
		85,
		-1,
		113,
		103,
		151,
		126,
		135,
		128,
		122,
		123,
		131,
		-1,
		-1,
		-1,
		93,
		92,
		84,
		78,
		76,
		61,
		56,
		-1,
		108,
		90,
		76,
		93,
		93,
		84,
		92,
		141,
		137,
		140,
		138,
		116,
		-1,
		207,
		-1,
		-1,
		116,
		-1,
		-1,
		-1,
		87,
		96,
		69,
		57,
		71,
		78,
		73,
		75,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		115,
		147,
		-1,
		202,
		-1,
		123,
		-1,
		-1,
		103,
		89,
		91,
		80,
		69,
		67,
		70,
		68,
		90,
		120,
		106,
		104,
		109,
		114,
		-1,
		191,
		190,
		-1,
		122,
		114,
		100,
		-1,
		93,
		-1,
		115,
		76,
		-1,
		97,
		77,
		-1,
		115,
		111,
		-1,
		-1,
		178,
		138,
		-1,
		-1,
		-1,
		123,
		103,
		110,
		94,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		163,
		147,
		-1,
		116,
		119,
		-1,
		110,
		116,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		172,
		153,
		147,
		131,
		136,
		124,
		141,
		127,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		144,
		136,
		136,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		166,
		147,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		182,
		155,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		176,
		177,
		201,
		176,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		179,
		177,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		277,
		266,
		277,
		285,
		258,
		265,
		-1,
		284,
		288,
		254,
		248,
		287,
		256,
		262,
		273,
		-1,
		-1,
		-1,
		277,
		276,
		244,
		242,
		251,
		256,
		263,
		-1,
		262,
		-1,
		298,
		277,
		288,
		293,
		237,
		234,
		254,
		273,
		255,
		247,
		313,
		267,
		238,
		232,
		250,
		240,
		249,
		241,
		-1,
		238,
		228,
		250,
		229,
		240,
		232,
		-1,
		-1,
		232,
		233,
		239,
		225,
		231,
		227,
		-1,
		237,
		221,
		-1,
		-1,
		222,
		223,
		207,
		210,
		218,
		216,
		229,
		221,
		216,
		-1,
		-1,
		213,
		209,
		216,
		203,
		199,
		216,
		229,
		211,
		225,
		224,
		-1,
		217,
		235,
		242,
		210,
		208,
		192,
		190,
		208,
		210,
		216,
		216,
		-1,
		226,
		227,
		222,
		230,
		232,
		208,
		195,
		195,
		205,
		198,
		217,
		205,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		226,
		209,
		226,
		218,
		208,
		223,
		216,
		198,
		195,
		193,
		190,
		206,
		204,
		214,
		-1,
		-1,
		319,
		288,
		317,
		275,
		256,
		-1,
		222,
		202,
		208,
		212,
		206,
		199,
		213,
		209,
		-1,
		184,
		183,
		211,
		197,
		208,
		279,
		-1,
		-1,
		277,
		269,
		252,
		255,
		232,
		228,
		217,
		216,
		208,
		194,
		190,
		196,
		199,
		199,
		205,
		178,
		188,
		192,
		190,
		215,
		-1,
		-1,
		250,
		-1,
		-1,
		276,
		259,
		-1,
		242,
		249,
		238,
		244,
		230,
		251,
		227,
		218,
		210,
		204,
		192,
		194,
		191,
		204,
		192,
		175,
		200,
		204,
		185,
		206,
		201,
		-1,
		249,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		235,
		238,
		244,
		268,
		267,
		-1,
		239,
		227,
		228,
		213,
		210,
		197,
		185,
		198,
		183,
		190,
		189,
		179,
		177,
		207,
		182,
		204,
		201,
		220,
		225,
		219,
		228,
		-1,
		284,
		280,
		276,
		283,
		232,
		-1,
		-1,
		272,
		-1,
		275,
		276,
		251,
		224,
		227,
		214,
		205,
		192,
		181,
		192,
		181,
		178,
		186,
		171,
		186,
		177,
		176,
		194,
		204,
		212,
		216,
		222,
		-1,
		334,
		-1,
		276,
		260,
		262,
		234,
		255,
		-1,
		292,
		276,
		268,
		253,
		253,
		-1,
		223,
		220,
		210,
		188,
		173,
		190,
		182,
		180,
		184,
		166,
		180,
		171,
		189,
		196,
		194,
		198,
		218,
		230,
		294,
		284,
		-1,
		266,
		271,
		230,
		238,
		257,
		295,
		259,
		-1,
		254,
		-1,
		225,
		238,
		-1,
		194,
		190,
		172,
		173,
		168,
		183,
		177,
		162,
		159,
		177,
		180,
		187,
		191,
		207,
		-1,
		-1,
		279,
		283,
		272,
		223,
		242,
		266,
		303,
		252,
		241,
		240,
		-1,
		231,
		208,
		205,
		193,
		180,
		165,
		166,
		174,
		187,
		166,
		161,
		158,
		178,
		204,
		182,
		194,
		-1,
		-1,
		-1,
		304,
		-1,
		-1,
		249,
		220,
		244,
		286,
		270,
		263,
		251,
		216,
		216,
		210,
		-1,
		204,
		183,
		174,
		163,
		161,
		174,
		171,
		176,
		156,
		154,
		173,
		185,
		176,
		193,
		-1,
		-1,
		-1,
		279,
		268,
		269,
		215,
		238,
		275,
		249,
		235,
		240,
		215,
		208,
		202,
		217,
		200,
		181,
		170,
		162,
		151,
		167,
		175,
		170,
		152,
		161,
		167,
		191,
		181,
		187,
		-1,
		-1,
		286,
		276,
		260,
		262,
		259,
		229,
		236,
		268,
		240,
		253,
		-1,
		207,
		-1,
		196,
		191,
		175,
		170,
		167,
		164,
		158,
		167,
		169,
		159,
		154,
		161,
		196,
		196,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		279,
		274,
		249,
		226,
		210,
		246,
		-1,
		223,
		224,
		-1,
		201,
		195,
		192,
		177,
		173,
		168,
		172,
		165,
		172,
		165,
		163,
		164,
		146,
		178,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		272,
		251,
		244,
		264,
		205,
		257,
		-1,
		-1,
		208,
		201,
		-1,
		188,
		170,
		177,
		175,
		169,
		173,
		170,
		159,
		172,
		165,
		151,
		153,
		166,
		170,
		174,
		161,
		157,
		154,
		168,
		-1,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		225,
		-1,
		217,
		209,
		199,
		193,
		187,
		183,
		181,
		197,
		181,
		184,
		182,
		173,
		181,
		154,
		147,
		154,
		143,
		161,
		169,
		161,
		155,
		154,
		164,
		-1,
		292,
		278,
		249,
		-1,
		-1,
		238,
		-1,
		202,
		216,
		232,
		-1,
		225,
		204,
		219,
		197,
		193,
		189,
		204,
		205,
		182,
		182,
		180,
		171,
		159,
		148,
		151,
		143,
		165,
		165,
		149,
		150,
		154,
		-1,
		298,
		285,
		243,
		239,
		228,
		248,
		199,
		187,
		219,
		-1,
		-1,
		261,
		-1,
		195,
		212,
		203,
		201,
		194,
		176,
		183,
		191,
		168,
		163,
		153,
		142,
		142,
		137,
		159,
		145,
		143,
		152,
		168,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		214,
		201,
		195,
		-1,
		236,
		-1,
		239,
		229,
		213,
		198,
		231,
		-1,
		175,
		171,
		178,
		-1,
		188,
		-1,
		161,
		158,
		149,
		134,
		131,
		142,
		140,
		151,
		147,
		-1,
		248,
		233,
		226,
		216,
		230,
		201,
		-1,
		254,
		-1,
		-1,
		226,
		220,
		220,
		204,
		205,
		191,
		171,
		163,
		178,
		177,
		164,
		163,
		147,
		140,
		137,
		130,
		143,
		153,
		158,
		145,
		-1,
		-1,
		-1,
		253,
		239,
		243,
		203,
		220,
		-1,
		-1,
		288,
		243,
		229,
		-1,
		200,
		191,
		179,
		169,
		159,
		164,
		165,
		155,
		153,
		145,
		147,
		141,
		132,
		131,
		147,
		139,
		161,
		-1,
		-1,
		236,
		241,
		229,
		198,
		193,
		-1,
		-1,
		-1,
		235,
		251,
		219,
		198,
		180,
		-1,
		-1,
		163,
		156,
		150,
		153,
		141,
		161,
		156,
		140,
		125,
		140,
		144,
		152,
		143,
		-1,
		239,
		226,
		-1,
		-1,
		192,
		182,
		-1,
		-1,
		-1,
		-1,
		231,
		176,
		165,
		160,
		164,
		162,
		-1,
		136,
		147,
		140,
		159,
		166,
		142,
		127,
		121,
		127,
		139,
		148,
		-1,
		-1,
		206,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		188,
		182,
		153,
		146,
		150,
		-1,
		138,
		140,
		137,
		149,
		145,
		142,
		133,
		124,
		120,
		124,
		128,
		142,
		146,
		229,
		-1,
		159,
		-1,
		-1,
		-1,
		205,
		221,
		192,
		169,
		142,
		137,
		130,
		124,
		129,
		140,
		149,
		160,
		125,
		127,
		117,
		116,
		120,
		137,
		141,
		-1,
		-1,
		157,
		153,
		188,
		200,
		200,
		219,
		-1,
		-1,
		146,
		137,
		128,
		120,
		133,
		136,
		121,
		123,
		123,
		121,
		115,
		125,
		140,
		135,
		-1,
		-1,
		-1,
		169,
		-1,
		171,
		-1,
		-1,
		190,
		217,
		164,
		146,
		142,
		140,
		129,
		123,
		111,
		116,
		126,
		120,
		117,
		111,
		115,
		138,
		127,
		166,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		176,
		140,
		135,
		169,
		174,
		165,
		179,
		176,
		-1,
		146,
		152,
		117,
		124,
		107,
		114,
		119,
		116,
		105,
		112,
		128,
		127,
		122,
		158,
		149,
		155,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		169,
		137,
		155,
		145,
		151,
		-1,
		-1,
		171,
		168,
		148,
		117,
		115,
		108,
		103,
		113,
		89,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		201,
		238,
		231,
		199,
		207,
		238,
		-1,
		159,
		151,
		134,
		137,
		145,
		-1,
		-1,
		144,
		135,
		136,
		124,
		121,
		127,
		126,
		109,
		115,
		116,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		194,
		214,
		193,
		196,
		220,
		234,
		-1,
		156,
		-1,
		-1,
		94,
		158,
		153,
		143,
		140,
		183,
		138,
		133,
		114,
		112,
		107,
		98,
		123,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		183,
		194,
		187,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		84,
		-1,
		180,
		-1,
		163,
		167,
		146,
		149,
		128,
		115,
		101,
		109,
		115,
		114,
		120,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		208,
		164,
		167,
		178,
		189,
		204,
		208,
		-1,
		168,
		207,
		90,
		-1,
		74,
		-1,
		-1,
		-1,
		177,
		159,
		151,
		148,
		127,
		127,
		93,
		97,
		110,
		117,
		127,
		138,
		130,
		134,
		147,
		158,
		161,
		204,
		195,
		208,
		153,
		153,
		174,
		183,
		204,
		168,
		165,
		201,
		97,
		86,
		81,
		68,
		-1,
		-1,
		161,
		169,
		-1,
		-1,
		134,
		101,
		89,
		99,
		103,
		117,
		129,
		142,
		130,
		135,
		129,
		161,
		-1,
		197,
		196,
		185,
		182,
		158,
		149,
		144,
		171,
		-1,
		-1,
		166,
		193,
		153,
		130,
		128,
		153,
		-1,
		52,
		-1,
		-1,
		141,
		-1,
		-1,
		126,
		106,
		95,
		86,
		91,
		111,
		122,
		144,
		126,
		143,
		134,
		144,
		148,
		181,
		178,
		166,
		164,
		187,
		152,
		140,
		-1,
		148,
		151,
		157,
		151,
		131,
		142,
		-1,
		-1,
		68,
		48,
		-1,
		-1,
		124,
		122,
		111,
		-1,
		101,
		83,
		88,
		118,
		120,
		122,
		129,
		123,
		130,
		138,
		149,
		141,
		190,
		204,
		193,
		189,
		188,
		196,
		145,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		69,
		-1,
		54,
		54,
		-1,
		-1,
		119,
		112,
		100,
		88,
		78,
		88,
		105,
		105,
		108,
		113,
		121,
		132,
		128,
		132,
		135,
		-1,
		224,
		-1,
		176,
		137,
		143,
		158,
		166,
		-1,
		-1,
		-1,
		71,
		57,
		50,
		38,
		36,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		141,
		109,
		114,
		109,
		124,
		135,
		126,
		134,
		128,
		131,
		-1,
		-1,
		136,
		119,
		-1,
		-1,
		93,
		95,
		-1,
		62,
		51,
		36,
		28,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		75,
		113,
		112,
		120,
		115,
		120,
		132,
		128,
		124,
		134,
		125,
		-1,
		-1,
		114,
		106,
		100,
		-1,
		78,
		-1,
		39,
		-1,
		31,
		47,
		49,
		-1,
		-1,
		-1,
		106,
		69,
		85,
		108,
		134,
		132,
		123,
		116,
		123,
		126,
		119,
		125,
		-1,
		-1,
		-1,
		96,
		70,
		46,
		37,
		20,
		0,
		10,
		64,
		-1,
		87,
		-1,
		62,
		65,
		90,
		129,
		131,
		117,
		113,
		126,
		120,
		117,
		115,
		102,
		-1,
		72,
		105,
		69,
		6,
		37,
		42,
		101,
		-1,
		84,
		66,
		-1,
		94,
		84,
		132,
		107,
		116,
		109,
		103,
		104,
		112,
		-1,
		-1,
		-1,
		74,
		73,
		65,
		59,
		57,
		42,
		37,
		-1,
		89,
		71,
		57,
		74,
		74,
		65,
		73,
		122,
		118,
		121,
		119,
		97,
		-1,
		188,
		-1,
		-1,
		97,
		-1,
		-1,
		-1,
		68,
		77,
		50,
		38,
		52,
		59,
		54,
		56,
		69,
		77,
		75,
		72,
		84,
		80,
		100,
		96,
		128,
		-1,
		183,
		-1,
		104,
		-1,
		-1,
		84,
		70,
		72,
		61,
		50,
		48,
		51,
		49,
		71,
		101,
		87,
		85,
		90,
		95,
		-1,
		172,
		171,
		-1,
		103,
		95,
		81,
		-1,
		74,
		-1,
		96,
		57,
		-1,
		78,
		58,
		-1,
		96,
		92,
		-1,
		-1,
		159,
		119,
		-1,
		-1,
		-1,
		104,
		84,
		91,
		75,
		-1,
		69,
		69,
		-1,
		-1,
		-1,
		144,
		128,
		-1,
		97,
		100,
		-1,
		91,
		97,
		124,
		71,
		75,
		-1,
		-1,
		-1,
		153,
		134,
		128,
		112,
		117,
		105,
		122,
		108,
		107,
		85,
		74,
		95,
		-1,
		-1,
		-1,
		125,
		117,
		117,
		-1,
		-1,
		132,
		115,
		96,
		94,
		-1,
		-1,
		-1,
		147,
		128,
		-1,
		-1,
		122,
		-1,
		-1,
		128,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		136,
		-1,
		-1,
		-1,
		118,
		114,
		115,
		-1,
		-1,
		-1,
		-1,
		157,
		158,
		182,
		157,
		-1,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		160,
		158,
		-1,
		-1,
		-1,
		138,
		122,
		-1,
		108,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		143,
		-1,
		143,
		118,
		125,
		-1,
		-1,
		-1,
		-1,
		156,
		148,
		156,
		-1,
		128,
		130,
		-1,
		178,
		-1,
		-1,
		171,
		162,
		-1,
		-1,
		133,
		140,
		162,
		165,
		201,
		-1,
		152
	],
	[
		-1,
		267,
		256,
		267,
		275,
		248,
		255,
		-1,
		274,
		278,
		244,
		238,
		277,
		246,
		252,
		263,
		-1,
		-1,
		-1,
		267,
		266,
		234,
		232,
		241,
		246,
		253,
		-1,
		252,
		-1,
		288,
		267,
		278,
		283,
		227,
		224,
		244,
		263,
		245,
		237,
		303,
		257,
		228,
		222,
		240,
		230,
		239,
		231,
		-1,
		228,
		218,
		240,
		219,
		230,
		222,
		-1,
		-1,
		222,
		223,
		229,
		215,
		221,
		217,
		-1,
		227,
		211,
		-1,
		-1,
		212,
		213,
		197,
		200,
		208,
		206,
		219,
		211,
		206,
		-1,
		-1,
		203,
		199,
		206,
		193,
		189,
		206,
		219,
		201,
		215,
		214,
		-1,
		207,
		225,
		232,
		200,
		198,
		182,
		180,
		198,
		200,
		206,
		206,
		-1,
		216,
		217,
		212,
		220,
		222,
		198,
		185,
		185,
		195,
		188,
		207,
		195,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		216,
		199,
		216,
		208,
		198,
		213,
		206,
		188,
		185,
		183,
		180,
		196,
		194,
		204,
		-1,
		-1,
		309,
		278,
		307,
		265,
		246,
		-1,
		212,
		192,
		198,
		202,
		196,
		189,
		203,
		199,
		-1,
		174,
		173,
		201,
		187,
		198,
		269,
		-1,
		-1,
		267,
		259,
		242,
		245,
		222,
		218,
		207,
		206,
		198,
		184,
		180,
		186,
		189,
		189,
		195,
		168,
		178,
		182,
		180,
		205,
		-1,
		-1,
		240,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		228,
		234,
		220,
		241,
		217,
		208,
		200,
		194,
		182,
		184,
		181,
		194,
		182,
		165,
		190,
		194,
		175,
		196,
		191,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		257,
		-1,
		229,
		217,
		218,
		203,
		200,
		187,
		175,
		188,
		173,
		180,
		179,
		169,
		167,
		197,
		172,
		194,
		191,
		210,
		215,
		209,
		218,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		265,
		266,
		241,
		214,
		217,
		204,
		195,
		182,
		171,
		182,
		171,
		168,
		176,
		161,
		176,
		167,
		166,
		184,
		194,
		202,
		206,
		212,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		266,
		258,
		243,
		243,
		-1,
		213,
		210,
		200,
		178,
		163,
		180,
		172,
		170,
		174,
		156,
		170,
		161,
		179,
		186,
		184,
		188,
		208,
		220,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		285,
		249,
		-1,
		244,
		-1,
		215,
		228,
		-1,
		184,
		180,
		162,
		163,
		158,
		173,
		167,
		152,
		149,
		167,
		170,
		177,
		181,
		197,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		242,
		231,
		230,
		-1,
		221,
		198,
		195,
		183,
		170,
		155,
		156,
		164,
		177,
		156,
		151,
		148,
		168,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		260,
		253,
		241,
		206,
		206,
		200,
		-1,
		194,
		173,
		164,
		153,
		151,
		164,
		161,
		166,
		146,
		144,
		163,
		175,
		166,
		183,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		205,
		228,
		265,
		239,
		225,
		230,
		205,
		198,
		192,
		207,
		190,
		171,
		160,
		152,
		141,
		157,
		165,
		160,
		142,
		151,
		157,
		181,
		171,
		177,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		219,
		226,
		258,
		230,
		243,
		-1,
		197,
		-1,
		186,
		181,
		165,
		160,
		157,
		154,
		148,
		157,
		159,
		149,
		144,
		151,
		186,
		186,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		269,
		264,
		239,
		216,
		200,
		236,
		-1,
		213,
		214,
		-1,
		191,
		185,
		182,
		167,
		163,
		158,
		162,
		155,
		162,
		155,
		153,
		154,
		136,
		168,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		262,
		241,
		234,
		254,
		195,
		247,
		-1,
		-1,
		198,
		191,
		-1,
		178,
		160,
		167,
		165,
		159,
		163,
		160,
		149,
		162,
		155,
		141,
		143,
		156,
		160,
		164,
		151,
		147,
		144,
		158,
		-1,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		215,
		-1,
		207,
		199,
		189,
		183,
		177,
		173,
		171,
		187,
		171,
		174,
		172,
		163,
		171,
		144,
		137,
		144,
		133,
		151,
		159,
		151,
		145,
		144,
		154,
		-1,
		282,
		268,
		239,
		-1,
		-1,
		228,
		-1,
		192,
		206,
		222,
		-1,
		215,
		194,
		209,
		187,
		183,
		179,
		194,
		195,
		172,
		172,
		170,
		161,
		149,
		138,
		141,
		133,
		155,
		155,
		139,
		140,
		144,
		-1,
		288,
		275,
		233,
		229,
		218,
		238,
		189,
		177,
		209,
		-1,
		-1,
		251,
		-1,
		185,
		202,
		193,
		191,
		184,
		166,
		173,
		181,
		158,
		153,
		143,
		132,
		132,
		127,
		149,
		135,
		133,
		142,
		158,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		204,
		191,
		185,
		-1,
		226,
		-1,
		229,
		219,
		203,
		188,
		221,
		-1,
		165,
		161,
		168,
		-1,
		178,
		-1,
		151,
		148,
		139,
		124,
		121,
		132,
		130,
		141,
		137,
		-1,
		238,
		223,
		216,
		206,
		220,
		191,
		-1,
		246,
		-1,
		-1,
		216,
		210,
		210,
		194,
		195,
		181,
		161,
		153,
		168,
		167,
		154,
		153,
		137,
		130,
		127,
		120,
		133,
		143,
		148,
		135,
		-1,
		-1,
		-1,
		243,
		229,
		233,
		193,
		212,
		-1,
		-1,
		278,
		233,
		219,
		-1,
		190,
		181,
		169,
		159,
		149,
		154,
		155,
		145,
		143,
		135,
		137,
		131,
		122,
		121,
		137,
		129,
		151,
		-1,
		-1,
		226,
		231,
		219,
		191,
		186,
		-1,
		-1,
		-1,
		225,
		241,
		209,
		188,
		170,
		-1,
		-1,
		153,
		146,
		140,
		143,
		131,
		151,
		146,
		130,
		115,
		130,
		134,
		142,
		133,
		-1,
		229,
		216,
		-1,
		-1,
		185,
		175,
		-1,
		-1,
		-1,
		-1,
		221,
		166,
		155,
		150,
		154,
		152,
		-1,
		126,
		137,
		130,
		149,
		156,
		132,
		117,
		111,
		117,
		129,
		138,
		-1,
		-1,
		199,
		-1,
		161,
		-1,
		-1,
		-1,
		-1,
		178,
		172,
		143,
		136,
		140,
		-1,
		128,
		130,
		127,
		139,
		135,
		132,
		123,
		114,
		110,
		114,
		118,
		132,
		136,
		222,
		-1,
		152,
		-1,
		-1,
		-1,
		196,
		211,
		182,
		159,
		132,
		127,
		120,
		114,
		119,
		130,
		139,
		150,
		115,
		117,
		107,
		106,
		110,
		127,
		131,
		-1,
		-1,
		150,
		146,
		181,
		193,
		193,
		209,
		-1,
		-1,
		136,
		127,
		118,
		110,
		123,
		126,
		111,
		113,
		113,
		111,
		105,
		115,
		130,
		125,
		-1,
		-1,
		-1,
		162,
		-1,
		164,
		-1,
		-1,
		183,
		207,
		154,
		136,
		132,
		130,
		119,
		113,
		101,
		106,
		116,
		110,
		107,
		101,
		105,
		128,
		117,
		156,
		-1,
		-1,
		244,
		-1,
		-1,
		-1,
		169,
		133,
		128,
		162,
		167,
		158,
		169,
		166,
		-1,
		136,
		142,
		107,
		114,
		97,
		104,
		109,
		106,
		95,
		102,
		118,
		117,
		112,
		148,
		139,
		145,
		-1,
		-1,
		237,
		226,
		215,
		221,
		-1,
		162,
		130,
		148,
		138,
		144,
		-1,
		-1,
		161,
		158,
		138,
		107,
		105,
		98,
		93,
		103,
		79,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		191,
		228,
		221,
		189,
		197,
		228,
		-1,
		152,
		144,
		127,
		130,
		138,
		-1,
		-1,
		134,
		125,
		126,
		114,
		111,
		117,
		116,
		99,
		105,
		106,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		184,
		204,
		183,
		186,
		210,
		224,
		-1,
		149,
		-1,
		-1,
		87,
		151,
		143,
		133,
		130,
		173,
		128,
		123,
		104,
		102,
		97,
		88,
		113,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		173,
		184,
		177,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		77,
		-1,
		170,
		-1,
		153,
		157,
		136,
		139,
		118,
		105,
		91,
		99,
		105,
		104,
		110,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		198,
		154,
		157,
		168,
		179,
		194,
		198,
		-1,
		161,
		198,
		83,
		-1,
		67,
		-1,
		-1,
		-1,
		167,
		149,
		141,
		138,
		117,
		117,
		83,
		87,
		100,
		107,
		117,
		128,
		120,
		124,
		137,
		148,
		151,
		194,
		185,
		198,
		143,
		143,
		164,
		173,
		194,
		158,
		155,
		192,
		90,
		79,
		74,
		61,
		-1,
		-1,
		151,
		159,
		-1,
		-1,
		124,
		91,
		79,
		89,
		93,
		107,
		119,
		132,
		120,
		125,
		119,
		151,
		-1,
		187,
		186,
		175,
		172,
		148,
		139,
		134,
		161,
		-1,
		-1,
		156,
		183,
		146,
		123,
		121,
		146,
		-1,
		45,
		-1,
		-1,
		131,
		-1,
		-1,
		116,
		96,
		85,
		76,
		81,
		101,
		112,
		134,
		116,
		133,
		124,
		134,
		138,
		171,
		168,
		156,
		154,
		177,
		142,
		130,
		-1,
		138,
		141,
		147,
		144,
		124,
		135,
		-1,
		-1,
		61,
		41,
		-1,
		-1,
		114,
		112,
		101,
		-1,
		91,
		73,
		78,
		108,
		110,
		112,
		119,
		113,
		120,
		128,
		139,
		131,
		180,
		194,
		183,
		179,
		178,
		186,
		135,
		128,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		63,
		-1,
		48,
		47,
		-1,
		-1,
		109,
		102,
		90,
		78,
		68,
		78,
		95,
		95,
		98,
		103,
		111,
		122,
		118,
		122,
		125,
		-1,
		214,
		-1,
		166,
		127,
		133,
		148,
		156,
		-1,
		-1,
		-1,
		65,
		51,
		44,
		32,
		30,
		-1,
		143,
		127,
		108,
		-1,
		78,
		91,
		131,
		99,
		104,
		99,
		114,
		125,
		116,
		124,
		118,
		121,
		-1,
		-1,
		126,
		109,
		-1,
		-1,
		83,
		85,
		-1,
		56,
		45,
		30,
		22,
		-1,
		-1,
		115,
		111,
		-1,
		-1,
		65,
		103,
		102,
		110,
		105,
		110,
		122,
		118,
		114,
		124,
		115,
		-1,
		-1,
		104,
		96,
		90,
		-1,
		68,
		-1,
		47,
		-1,
		25,
		41,
		43,
		-1,
		-1,
		-1,
		96,
		59,
		75,
		98,
		124,
		122,
		113,
		106,
		113,
		116,
		109,
		115,
		-1,
		-1,
		-1,
		86,
		60,
		54,
		45,
		28,
		8,
		0,
		58,
		-1,
		77,
		-1,
		52,
		55,
		80,
		119,
		121,
		107,
		103,
		116,
		110,
		107,
		105,
		92,
		-1,
		62,
		95,
		59,
		14,
		27,
		32,
		91,
		-1,
		74,
		56,
		-1,
		84,
		74,
		122,
		97,
		106,
		99,
		93,
		94,
		102,
		-1,
		-1,
		-1,
		64,
		63,
		55,
		49,
		47,
		32,
		27,
		-1,
		79,
		61,
		47,
		64,
		64,
		55,
		63,
		112,
		108,
		111,
		109,
		87,
		-1,
		178,
		-1,
		-1,
		87,
		-1,
		-1,
		-1,
		58,
		67,
		40,
		28,
		42,
		49,
		44,
		46,
		59,
		67,
		65,
		62,
		74,
		70,
		90,
		86,
		118,
		-1,
		173,
		-1,
		94,
		-1,
		-1,
		74,
		60,
		62,
		51,
		40,
		38,
		41,
		39,
		61,
		91,
		77,
		75,
		80,
		85,
		-1,
		162,
		161,
		-1,
		93,
		85,
		71,
		-1,
		64,
		-1,
		86,
		47,
		-1,
		68,
		48,
		-1,
		86,
		82,
		-1,
		-1,
		149,
		109,
		-1,
		-1,
		-1,
		94,
		74,
		81,
		65,
		-1,
		59,
		59,
		-1,
		-1,
		-1,
		134,
		118,
		-1,
		87,
		90,
		-1,
		81,
		87,
		114,
		61,
		65,
		-1,
		-1,
		-1,
		143,
		124,
		118,
		102,
		107,
		95,
		112,
		98,
		97,
		75,
		64,
		85,
		-1,
		-1,
		-1,
		115,
		107,
		107,
		-1,
		-1,
		122,
		105,
		86,
		84,
		-1,
		-1,
		-1,
		137,
		118,
		-1,
		-1,
		112,
		-1,
		-1,
		118,
		83,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		126,
		-1,
		-1,
		-1,
		108,
		104,
		105,
		-1,
		-1,
		-1,
		-1,
		147,
		148,
		172,
		147,
		-1,
		-1,
		-1,
		100,
		94,
		-1,
		-1,
		150,
		148,
		-1,
		-1,
		-1,
		128,
		112,
		-1,
		98,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		131,
		-1,
		-1,
		-1,
		133,
		-1,
		133,
		108,
		115,
		-1,
		-1,
		-1,
		-1,
		146,
		138,
		146,
		-1,
		118,
		120,
		-1,
		168,
		-1,
		-1,
		161,
		152,
		-1,
		-1,
		123,
		130,
		152,
		155,
		191,
		-1,
		142
	],
	[
		-1,
		286,
		275,
		286,
		294,
		267,
		274,
		-1,
		293,
		297,
		263,
		257,
		296,
		265,
		271,
		282,
		-1,
		-1,
		-1,
		286,
		285,
		253,
		251,
		260,
		265,
		272,
		-1,
		271,
		-1,
		307,
		286,
		297,
		302,
		246,
		243,
		263,
		282,
		264,
		256,
		322,
		276,
		247,
		241,
		259,
		249,
		258,
		250,
		-1,
		247,
		237,
		259,
		238,
		249,
		241,
		-1,
		-1,
		241,
		242,
		248,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		231,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		226,
		244,
		251,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		235,
		236,
		231,
		239,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		235,
		218,
		235,
		227,
		217,
		232,
		225,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		328,
		297,
		326,
		284,
		265,
		-1,
		231,
		211,
		217,
		221,
		215,
		208,
		222,
		218,
		-1,
		193,
		192,
		220,
		206,
		217,
		288,
		-1,
		-1,
		286,
		278,
		261,
		264,
		241,
		237,
		226,
		225,
		217,
		203,
		199,
		205,
		208,
		208,
		214,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		285,
		268,
		-1,
		251,
		258,
		247,
		253,
		239,
		260,
		236,
		227,
		219,
		213,
		201,
		203,
		200,
		213,
		201,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		244,
		247,
		253,
		277,
		276,
		-1,
		248,
		236,
		237,
		222,
		219,
		206,
		194,
		207,
		192,
		199,
		198,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		293,
		289,
		285,
		292,
		241,
		-1,
		-1,
		281,
		-1,
		284,
		285,
		260,
		233,
		236,
		223,
		214,
		201,
		190,
		201,
		190,
		187,
		195,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		343,
		-1,
		285,
		269,
		271,
		243,
		264,
		-1,
		301,
		285,
		277,
		262,
		262,
		-1,
		232,
		229,
		219,
		197,
		182,
		199,
		191,
		189,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		303,
		293,
		-1,
		275,
		280,
		239,
		247,
		266,
		304,
		268,
		-1,
		263,
		-1,
		234,
		247,
		-1,
		203,
		199,
		181,
		182,
		177,
		192,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		288,
		292,
		281,
		232,
		251,
		275,
		312,
		261,
		250,
		249,
		-1,
		240,
		217,
		214,
		202,
		189,
		174,
		175,
		183,
		196,
		175,
		170,
		167,
		187,
		213,
		191,
		203,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		258,
		229,
		253,
		295,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		213,
		192,
		183,
		172,
		170,
		183,
		180,
		185,
		165,
		163,
		182,
		194,
		185,
		202,
		-1,
		-1,
		-1,
		288,
		277,
		278,
		224,
		247,
		284,
		258,
		244,
		249,
		224,
		217,
		211,
		226,
		209,
		190,
		179,
		171,
		160,
		176,
		184,
		179,
		161,
		170,
		176,
		200,
		190,
		196,
		-1,
		-1,
		295,
		285,
		269,
		271,
		268,
		238,
		245,
		277,
		249,
		262,
		-1,
		216,
		-1,
		205,
		200,
		184,
		179,
		176,
		173,
		167,
		176,
		178,
		168,
		163,
		170,
		205,
		205,
		180,
		200,
		203,
		-1,
		-1,
		-1,
		288,
		283,
		258,
		235,
		219,
		255,
		-1,
		232,
		233,
		-1,
		210,
		204,
		201,
		186,
		182,
		177,
		181,
		174,
		181,
		174,
		172,
		173,
		155,
		187,
		-1,
		188,
		182,
		190,
		180,
		168,
		-1,
		-1,
		-1,
		281,
		260,
		253,
		273,
		214,
		266,
		-1,
		-1,
		217,
		210,
		-1,
		197,
		179,
		186,
		184,
		178,
		182,
		179,
		168,
		181,
		174,
		160,
		162,
		175,
		179,
		183,
		170,
		166,
		163,
		177,
		-1,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		234,
		-1,
		226,
		218,
		208,
		202,
		196,
		192,
		190,
		206,
		190,
		193,
		191,
		182,
		190,
		163,
		156,
		163,
		152,
		170,
		178,
		170,
		164,
		163,
		173,
		-1,
		301,
		287,
		258,
		-1,
		-1,
		247,
		-1,
		211,
		225,
		241,
		-1,
		234,
		213,
		228,
		206,
		202,
		198,
		213,
		214,
		191,
		191,
		189,
		180,
		168,
		157,
		160,
		152,
		174,
		174,
		158,
		159,
		163,
		-1,
		307,
		294,
		252,
		248,
		237,
		257,
		208,
		196,
		228,
		-1,
		-1,
		270,
		-1,
		204,
		221,
		212,
		210,
		203,
		185,
		192,
		200,
		177,
		172,
		162,
		151,
		151,
		146,
		168,
		154,
		152,
		161,
		177,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		223,
		210,
		204,
		-1,
		245,
		-1,
		248,
		238,
		222,
		207,
		240,
		-1,
		184,
		180,
		187,
		-1,
		197,
		-1,
		170,
		167,
		158,
		143,
		140,
		151,
		149,
		160,
		156,
		-1,
		257,
		242,
		235,
		225,
		239,
		210,
		-1,
		265,
		-1,
		-1,
		235,
		229,
		229,
		213,
		214,
		200,
		180,
		172,
		187,
		186,
		173,
		172,
		156,
		149,
		146,
		139,
		152,
		162,
		167,
		154,
		-1,
		-1,
		-1,
		262,
		248,
		252,
		212,
		231,
		-1,
		-1,
		297,
		252,
		238,
		-1,
		209,
		200,
		188,
		178,
		168,
		173,
		174,
		164,
		162,
		154,
		156,
		150,
		141,
		140,
		156,
		148,
		170,
		-1,
		-1,
		245,
		250,
		238,
		213,
		208,
		-1,
		-1,
		-1,
		244,
		260,
		228,
		207,
		189,
		-1,
		-1,
		172,
		165,
		159,
		162,
		150,
		170,
		165,
		149,
		134,
		149,
		153,
		161,
		152,
		-1,
		248,
		235,
		-1,
		-1,
		207,
		197,
		-1,
		-1,
		-1,
		-1,
		240,
		185,
		174,
		169,
		173,
		171,
		-1,
		145,
		156,
		149,
		168,
		175,
		151,
		136,
		130,
		136,
		148,
		157,
		-1,
		-1,
		221,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		197,
		191,
		162,
		155,
		159,
		-1,
		147,
		149,
		146,
		158,
		154,
		151,
		142,
		133,
		129,
		133,
		137,
		151,
		155,
		244,
		-1,
		174,
		-1,
		-1,
		-1,
		215,
		230,
		201,
		178,
		151,
		146,
		139,
		133,
		138,
		149,
		158,
		169,
		134,
		136,
		126,
		125,
		129,
		146,
		150,
		-1,
		-1,
		172,
		168,
		203,
		215,
		215,
		228,
		-1,
		-1,
		155,
		146,
		137,
		129,
		142,
		145,
		130,
		132,
		132,
		130,
		124,
		134,
		149,
		144,
		-1,
		-1,
		-1,
		184,
		-1,
		186,
		-1,
		-1,
		205,
		226,
		173,
		155,
		151,
		149,
		138,
		132,
		120,
		125,
		135,
		129,
		126,
		120,
		124,
		147,
		136,
		175,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		191,
		155,
		150,
		184,
		189,
		180,
		188,
		185,
		-1,
		155,
		161,
		126,
		133,
		116,
		123,
		128,
		125,
		114,
		121,
		137,
		136,
		131,
		167,
		158,
		164,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		184,
		152,
		170,
		160,
		166,
		-1,
		-1,
		180,
		177,
		157,
		126,
		124,
		117,
		112,
		122,
		98,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		214,
		251,
		244,
		212,
		220,
		251,
		-1,
		174,
		166,
		149,
		152,
		160,
		-1,
		-1,
		153,
		144,
		145,
		133,
		130,
		136,
		135,
		118,
		124,
		125,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		207,
		227,
		206,
		209,
		233,
		247,
		-1,
		171,
		-1,
		-1,
		109,
		173,
		162,
		152,
		149,
		192,
		147,
		142,
		123,
		121,
		116,
		107,
		132,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		99,
		-1,
		189,
		-1,
		172,
		176,
		155,
		158,
		137,
		124,
		110,
		118,
		124,
		123,
		129,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		183,
		221,
		105,
		-1,
		89,
		-1,
		-1,
		-1,
		186,
		168,
		160,
		157,
		136,
		136,
		102,
		106,
		119,
		126,
		136,
		147,
		139,
		143,
		156,
		167,
		170,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		181,
		178,
		215,
		112,
		101,
		96,
		83,
		-1,
		-1,
		170,
		178,
		-1,
		-1,
		143,
		110,
		98,
		108,
		112,
		126,
		138,
		151,
		139,
		144,
		138,
		170,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		206,
		168,
		145,
		143,
		168,
		-1,
		67,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		115,
		104,
		95,
		100,
		120,
		131,
		153,
		135,
		152,
		143,
		153,
		157,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		161,
		164,
		170,
		166,
		146,
		157,
		-1,
		-1,
		83,
		63,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		92,
		97,
		127,
		129,
		131,
		138,
		132,
		139,
		147,
		158,
		150,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		-1,
		69,
		69,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		114,
		114,
		117,
		122,
		130,
		141,
		137,
		141,
		144,
		-1,
		237,
		-1,
		189,
		150,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		86,
		72,
		65,
		53,
		51,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		150,
		118,
		123,
		118,
		133,
		144,
		135,
		143,
		137,
		140,
		-1,
		-1,
		149,
		132,
		-1,
		-1,
		106,
		108,
		-1,
		77,
		66,
		51,
		43,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		84,
		122,
		121,
		129,
		124,
		129,
		141,
		137,
		133,
		143,
		134,
		-1,
		-1,
		127,
		119,
		113,
		-1,
		91,
		-1,
		101,
		-1,
		46,
		41,
		29,
		-1,
		-1,
		-1,
		115,
		78,
		94,
		117,
		143,
		141,
		132,
		125,
		132,
		135,
		128,
		134,
		-1,
		-1,
		-1,
		109,
		83,
		108,
		99,
		82,
		62,
		58,
		0,
		-1,
		96,
		-1,
		71,
		74,
		99,
		138,
		140,
		126,
		122,
		135,
		129,
		126,
		124,
		115,
		-1,
		85,
		118,
		82,
		68,
		50,
		28,
		110,
		-1,
		93,
		75,
		-1,
		103,
		93,
		141,
		116,
		125,
		118,
		112,
		113,
		121,
		-1,
		-1,
		-1,
		87,
		86,
		78,
		72,
		66,
		53,
		42,
		-1,
		98,
		80,
		66,
		83,
		83,
		74,
		82,
		131,
		127,
		130,
		128,
		106,
		-1,
		201,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		81,
		78,
		51,
		47,
		55,
		68,
		63,
		65,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		105,
		137,
		-1,
		196,
		-1,
		117,
		-1,
		-1,
		97,
		83,
		73,
		62,
		51,
		51,
		56,
		58,
		80,
		110,
		96,
		94,
		99,
		104,
		-1,
		185,
		184,
		-1,
		116,
		108,
		94,
		-1,
		87,
		-1,
		97,
		58,
		-1,
		87,
		67,
		-1,
		105,
		101,
		-1,
		-1,
		172,
		132,
		-1,
		-1,
		-1,
		117,
		97,
		92,
		76,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		110,
		113,
		-1,
		104,
		110,
		133,
		80,
		84,
		-1,
		-1,
		-1,
		166,
		147,
		141,
		125,
		130,
		118,
		135,
		121,
		116,
		94,
		83,
		104,
		-1,
		-1,
		-1,
		138,
		130,
		130,
		-1,
		-1,
		141,
		124,
		105,
		103,
		-1,
		-1,
		-1,
		160,
		141,
		-1,
		-1,
		131,
		-1,
		-1,
		137,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		149,
		-1,
		-1,
		-1,
		127,
		123,
		124,
		-1,
		-1,
		-1,
		-1,
		170,
		171,
		195,
		170,
		-1,
		-1,
		-1,
		119,
		113,
		-1,
		-1,
		173,
		171,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		117,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		152,
		-1,
		152,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		165,
		-1,
		137,
		139,
		-1,
		187,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		142,
		149,
		171,
		174,
		210,
		-1,
		161
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		259,
		263,
		229,
		223,
		262,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		252,
		251,
		219,
		217,
		226,
		231,
		238,
		-1,
		237,
		-1,
		273,
		252,
		263,
		268,
		212,
		209,
		229,
		248,
		230,
		222,
		288,
		242,
		213,
		207,
		225,
		215,
		224,
		216,
		-1,
		213,
		203,
		225,
		204,
		215,
		207,
		-1,
		-1,
		207,
		208,
		214,
		200,
		206,
		202,
		-1,
		212,
		196,
		-1,
		-1,
		197,
		198,
		182,
		185,
		193,
		191,
		204,
		196,
		191,
		-1,
		-1,
		188,
		184,
		191,
		178,
		174,
		191,
		204,
		186,
		200,
		199,
		-1,
		192,
		210,
		217,
		185,
		183,
		167,
		165,
		183,
		185,
		191,
		191,
		-1,
		201,
		202,
		197,
		205,
		207,
		183,
		170,
		170,
		180,
		173,
		192,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		201,
		184,
		201,
		193,
		183,
		198,
		191,
		173,
		170,
		168,
		165,
		181,
		179,
		189,
		-1,
		-1,
		294,
		263,
		292,
		250,
		231,
		-1,
		197,
		177,
		183,
		187,
		181,
		174,
		188,
		184,
		-1,
		159,
		158,
		186,
		172,
		183,
		254,
		-1,
		-1,
		252,
		244,
		227,
		230,
		207,
		203,
		192,
		191,
		183,
		169,
		165,
		171,
		174,
		174,
		180,
		153,
		163,
		167,
		165,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		251,
		234,
		-1,
		217,
		224,
		213,
		219,
		205,
		226,
		202,
		193,
		185,
		179,
		167,
		169,
		166,
		179,
		167,
		150,
		175,
		179,
		160,
		181,
		176,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		210,
		213,
		219,
		243,
		242,
		-1,
		214,
		202,
		203,
		188,
		185,
		172,
		160,
		173,
		158,
		165,
		164,
		154,
		152,
		182,
		157,
		179,
		176,
		195,
		200,
		194,
		203,
		-1,
		259,
		255,
		251,
		258,
		207,
		-1,
		-1,
		247,
		-1,
		250,
		251,
		226,
		199,
		202,
		189,
		180,
		167,
		156,
		167,
		156,
		153,
		161,
		146,
		161,
		152,
		151,
		169,
		179,
		187,
		191,
		197,
		-1,
		309,
		-1,
		251,
		235,
		237,
		209,
		230,
		-1,
		267,
		251,
		243,
		228,
		228,
		-1,
		198,
		195,
		185,
		163,
		148,
		165,
		157,
		155,
		159,
		141,
		155,
		146,
		164,
		171,
		169,
		173,
		193,
		205,
		269,
		259,
		-1,
		241,
		246,
		205,
		213,
		232,
		270,
		234,
		-1,
		229,
		-1,
		200,
		213,
		-1,
		169,
		165,
		147,
		148,
		143,
		158,
		152,
		137,
		134,
		152,
		155,
		162,
		166,
		182,
		-1,
		-1,
		254,
		258,
		247,
		198,
		217,
		241,
		278,
		227,
		216,
		215,
		-1,
		206,
		183,
		180,
		168,
		155,
		140,
		141,
		149,
		162,
		141,
		136,
		133,
		153,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		224,
		195,
		219,
		261,
		245,
		238,
		226,
		191,
		191,
		185,
		-1,
		179,
		158,
		149,
		138,
		136,
		149,
		146,
		151,
		131,
		129,
		148,
		160,
		151,
		168,
		-1,
		-1,
		-1,
		254,
		243,
		244,
		190,
		213,
		250,
		224,
		210,
		215,
		190,
		183,
		177,
		192,
		175,
		156,
		145,
		137,
		126,
		142,
		150,
		145,
		127,
		136,
		142,
		166,
		156,
		162,
		-1,
		-1,
		261,
		251,
		235,
		237,
		234,
		204,
		211,
		243,
		215,
		228,
		-1,
		182,
		-1,
		171,
		166,
		150,
		145,
		142,
		139,
		133,
		142,
		144,
		134,
		129,
		136,
		171,
		171,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		254,
		249,
		224,
		201,
		185,
		221,
		-1,
		198,
		199,
		-1,
		176,
		170,
		167,
		152,
		148,
		143,
		147,
		140,
		147,
		140,
		138,
		139,
		121,
		153,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		247,
		226,
		219,
		239,
		180,
		232,
		-1,
		-1,
		183,
		176,
		-1,
		163,
		145,
		152,
		150,
		144,
		148,
		145,
		134,
		147,
		140,
		126,
		128,
		141,
		145,
		149,
		136,
		132,
		129,
		143,
		-1,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		200,
		-1,
		192,
		184,
		174,
		168,
		162,
		158,
		156,
		172,
		156,
		159,
		157,
		148,
		156,
		129,
		122,
		129,
		118,
		136,
		144,
		136,
		130,
		129,
		139,
		-1,
		267,
		253,
		224,
		-1,
		-1,
		213,
		-1,
		177,
		191,
		207,
		-1,
		200,
		179,
		194,
		172,
		168,
		164,
		179,
		180,
		157,
		157,
		155,
		146,
		134,
		123,
		126,
		118,
		140,
		140,
		124,
		125,
		129,
		-1,
		273,
		260,
		218,
		214,
		203,
		223,
		174,
		162,
		194,
		-1,
		-1,
		236,
		-1,
		170,
		187,
		178,
		176,
		169,
		151,
		158,
		166,
		143,
		138,
		128,
		117,
		117,
		112,
		134,
		120,
		118,
		127,
		143,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		189,
		176,
		170,
		-1,
		211,
		-1,
		214,
		204,
		188,
		173,
		206,
		-1,
		150,
		146,
		153,
		-1,
		163,
		-1,
		136,
		133,
		124,
		109,
		106,
		117,
		115,
		126,
		122,
		-1,
		223,
		208,
		201,
		191,
		205,
		176,
		-1,
		231,
		-1,
		-1,
		201,
		195,
		195,
		179,
		180,
		166,
		146,
		138,
		153,
		152,
		139,
		138,
		122,
		115,
		112,
		105,
		118,
		128,
		133,
		120,
		-1,
		-1,
		-1,
		228,
		214,
		218,
		178,
		197,
		-1,
		-1,
		263,
		218,
		204,
		-1,
		175,
		166,
		154,
		144,
		134,
		139,
		140,
		130,
		128,
		120,
		122,
		116,
		107,
		106,
		122,
		114,
		136,
		-1,
		-1,
		211,
		216,
		204,
		190,
		209,
		-1,
		-1,
		-1,
		210,
		226,
		194,
		173,
		155,
		-1,
		-1,
		138,
		131,
		125,
		128,
		116,
		136,
		131,
		115,
		100,
		115,
		119,
		127,
		118,
		-1,
		214,
		201,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		-1,
		-1,
		206,
		151,
		140,
		135,
		139,
		137,
		-1,
		111,
		122,
		115,
		134,
		141,
		117,
		102,
		96,
		102,
		114,
		123,
		-1,
		-1,
		226,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		163,
		157,
		128,
		121,
		125,
		-1,
		113,
		115,
		112,
		124,
		120,
		117,
		108,
		99,
		95,
		99,
		103,
		117,
		121,
		249,
		-1,
		191,
		-1,
		-1,
		-1,
		181,
		196,
		167,
		144,
		117,
		112,
		105,
		99,
		104,
		115,
		124,
		135,
		100,
		102,
		92,
		91,
		95,
		112,
		116,
		-1,
		-1,
		189,
		185,
		207,
		189,
		193,
		194,
		-1,
		-1,
		121,
		112,
		103,
		95,
		108,
		111,
		96,
		98,
		98,
		96,
		90,
		100,
		115,
		110,
		-1,
		-1,
		-1,
		201,
		-1,
		203,
		-1,
		-1,
		191,
		192,
		139,
		121,
		117,
		115,
		104,
		98,
		86,
		91,
		101,
		95,
		92,
		86,
		90,
		113,
		102,
		141,
		-1,
		-1,
		273,
		-1,
		-1,
		-1,
		180,
		172,
		167,
		173,
		175,
		166,
		154,
		151,
		-1,
		121,
		127,
		92,
		99,
		82,
		89,
		94,
		91,
		80,
		87,
		103,
		102,
		97,
		133,
		124,
		130,
		-1,
		-1,
		266,
		255,
		244,
		250,
		-1,
		173,
		169,
		159,
		149,
		152,
		-1,
		-1,
		146,
		143,
		123,
		92,
		90,
		83,
		78,
		88,
		64,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		121,
		136,
		-1,
		220,
		257,
		250,
		218,
		226,
		257,
		-1,
		163,
		155,
		166,
		141,
		143,
		-1,
		-1,
		119,
		110,
		111,
		99,
		96,
		102,
		101,
		84,
		89,
		91,
		83,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		213,
		233,
		212,
		215,
		239,
		253,
		-1,
		160,
		-1,
		-1,
		141,
		144,
		128,
		118,
		115,
		158,
		113,
		108,
		86,
		84,
		81,
		72,
		98,
		89,
		91,
		94,
		109,
		114,
		106,
		120,
		120,
		121,
		-1,
		202,
		213,
		206,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		-1,
		131,
		-1,
		155,
		-1,
		138,
		142,
		121,
		124,
		100,
		87,
		73,
		81,
		87,
		87,
		92,
		95,
		96,
		105,
		116,
		128,
		127,
		128,
		227,
		183,
		186,
		197,
		208,
		223,
		227,
		-1,
		172,
		211,
		137,
		-1,
		121,
		-1,
		-1,
		-1,
		152,
		134,
		126,
		120,
		99,
		99,
		65,
		69,
		82,
		89,
		99,
		113,
		105,
		109,
		122,
		133,
		136,
		223,
		214,
		227,
		172,
		172,
		193,
		202,
		223,
		187,
		178,
		205,
		144,
		133,
		128,
		115,
		-1,
		-1,
		133,
		144,
		-1,
		-1,
		106,
		73,
		61,
		71,
		75,
		89,
		101,
		114,
		102,
		110,
		104,
		136,
		-1,
		216,
		215,
		204,
		201,
		177,
		168,
		163,
		190,
		-1,
		-1,
		185,
		206,
		196,
		177,
		175,
		200,
		-1,
		104,
		-1,
		-1,
		113,
		-1,
		-1,
		98,
		78,
		67,
		58,
		63,
		83,
		94,
		116,
		98,
		115,
		109,
		119,
		123,
		200,
		197,
		185,
		183,
		206,
		171,
		159,
		-1,
		172,
		170,
		176,
		183,
		178,
		189,
		-1,
		-1,
		120,
		100,
		-1,
		-1,
		96,
		94,
		83,
		-1,
		73,
		55,
		60,
		90,
		92,
		94,
		101,
		95,
		102,
		113,
		124,
		116,
		209,
		223,
		212,
		208,
		207,
		215,
		164,
		157,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		-1,
		110,
		106,
		-1,
		-1,
		91,
		84,
		72,
		60,
		50,
		60,
		77,
		77,
		80,
		85,
		93,
		104,
		103,
		107,
		110,
		-1,
		243,
		-1,
		195,
		161,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		127,
		113,
		106,
		94,
		92,
		-1,
		125,
		109,
		90,
		-1,
		60,
		73,
		113,
		81,
		86,
		81,
		99,
		110,
		101,
		109,
		103,
		106,
		-1,
		-1,
		160,
		143,
		-1,
		-1,
		117,
		119,
		-1,
		118,
		107,
		92,
		84,
		-1,
		-1,
		97,
		93,
		-1,
		-1,
		47,
		88,
		84,
		92,
		87,
		95,
		107,
		103,
		99,
		109,
		100,
		-1,
		-1,
		138,
		130,
		124,
		-1,
		102,
		-1,
		120,
		-1,
		87,
		93,
		81,
		-1,
		-1,
		-1,
		78,
		41,
		57,
		83,
		107,
		105,
		96,
		91,
		98,
		101,
		94,
		100,
		-1,
		-1,
		-1,
		120,
		94,
		127,
		118,
		101,
		81,
		73,
		92,
		-1,
		0,
		-1,
		33,
		37,
		65,
		101,
		106,
		92,
		88,
		101,
		95,
		92,
		90,
		126,
		-1,
		96,
		129,
		93,
		87,
		63,
		67,
		83,
		-1,
		3,
		30,
		-1,
		69,
		59,
		107,
		82,
		91,
		84,
		78,
		79,
		87,
		-1,
		-1,
		-1,
		98,
		97,
		89,
		83,
		83,
		68,
		59,
		-1,
		71,
		53,
		32,
		40,
		47,
		40,
		48,
		97,
		93,
		96,
		94,
		72,
		-1,
		199,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		92,
		87,
		60,
		48,
		54,
		50,
		36,
		42,
		35,
		52,
		50,
		47,
		59,
		55,
		75,
		71,
		103,
		-1,
		194,
		-1,
		128,
		-1,
		-1,
		110,
		90,
		82,
		71,
		60,
		58,
		49,
		40,
		62,
		69,
		62,
		60,
		65,
		70,
		-1,
		183,
		182,
		-1,
		129,
		121,
		107,
		-1,
		100,
		-1,
		106,
		67,
		-1,
		69,
		49,
		-1,
		71,
		67,
		-1,
		-1,
		170,
		145,
		-1,
		-1,
		-1,
		130,
		110,
		101,
		85,
		-1,
		60,
		60,
		-1,
		-1,
		-1,
		155,
		154,
		-1,
		123,
		126,
		-1,
		116,
		107,
		115,
		62,
		66,
		-1,
		-1,
		-1,
		164,
		145,
		139,
		138,
		136,
		131,
		128,
		114,
		98,
		76,
		65,
		86,
		-1,
		-1,
		-1,
		136,
		128,
		121,
		-1,
		-1,
		123,
		106,
		87,
		85,
		-1,
		-1,
		-1,
		158,
		139,
		-1,
		-1,
		113,
		-1,
		-1,
		119,
		84,
		-1,
		-1,
		-1,
		-1,
		-1,
		175,
		147,
		-1,
		-1,
		-1,
		109,
		105,
		106,
		-1,
		-1,
		-1,
		-1,
		169,
		170,
		193,
		157,
		-1,
		-1,
		-1,
		101,
		95,
		-1,
		-1,
		172,
		170,
		-1,
		-1,
		-1,
		129,
		113,
		-1,
		99,
		-1,
		-1,
		-1,
		120,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		134,
		-1,
		134,
		109,
		116,
		-1,
		-1,
		-1,
		-1,
		147,
		139,
		147,
		-1,
		119,
		121,
		-1,
		169,
		-1,
		-1,
		162,
		153,
		-1,
		-1,
		124,
		131,
		153,
		156,
		192,
		-1,
		143
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		118,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		114,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		132,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		126,
		133,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		118,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		125,
		121,
		128,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		155,
		141,
		121,
		113,
		128,
		127,
		114,
		113,
		97,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		150,
		141,
		129,
		119,
		109,
		114,
		115,
		105,
		103,
		95,
		97,
		91,
		82,
		81,
		97,
		89,
		111,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		169,
		148,
		130,
		-1,
		-1,
		113,
		106,
		100,
		103,
		91,
		111,
		106,
		90,
		75,
		90,
		94,
		102,
		93,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		181,
		126,
		115,
		110,
		114,
		112,
		-1,
		86,
		97,
		90,
		109,
		116,
		92,
		77,
		71,
		77,
		89,
		98,
		-1,
		-1,
		201,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		138,
		132,
		103,
		96,
		100,
		-1,
		88,
		90,
		87,
		99,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		92,
		96,
		224,
		-1,
		166,
		-1,
		-1,
		-1,
		156,
		171,
		142,
		119,
		92,
		87,
		80,
		74,
		79,
		90,
		99,
		110,
		75,
		77,
		67,
		66,
		70,
		87,
		91,
		-1,
		-1,
		164,
		160,
		182,
		164,
		168,
		169,
		-1,
		-1,
		96,
		87,
		78,
		70,
		83,
		86,
		71,
		73,
		73,
		71,
		65,
		75,
		90,
		85,
		-1,
		-1,
		-1,
		176,
		-1,
		178,
		-1,
		-1,
		166,
		167,
		114,
		96,
		92,
		90,
		79,
		73,
		61,
		66,
		76,
		70,
		67,
		61,
		65,
		88,
		77,
		116,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		155,
		147,
		142,
		148,
		150,
		141,
		129,
		126,
		-1,
		96,
		102,
		67,
		74,
		57,
		64,
		69,
		66,
		55,
		62,
		78,
		77,
		72,
		108,
		99,
		105,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		148,
		144,
		134,
		124,
		127,
		-1,
		-1,
		121,
		118,
		98,
		67,
		65,
		58,
		53,
		63,
		39,
		51,
		55,
		59,
		65,
		70,
		75,
		81,
		96,
		111,
		-1,
		195,
		232,
		225,
		193,
		201,
		232,
		-1,
		138,
		130,
		141,
		116,
		118,
		-1,
		-1,
		94,
		85,
		86,
		74,
		71,
		77,
		76,
		51,
		56,
		66,
		58,
		57,
		75,
		79,
		88,
		95,
		85,
		98,
		102,
		-1,
		188,
		208,
		187,
		190,
		214,
		228,
		-1,
		135,
		-1,
		-1,
		116,
		119,
		103,
		93,
		90,
		133,
		81,
		76,
		53,
		51,
		48,
		39,
		73,
		56,
		66,
		69,
		84,
		89,
		81,
		95,
		95,
		96,
		-1,
		177,
		188,
		181,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		106,
		-1,
		130,
		-1,
		113,
		117,
		89,
		92,
		67,
		54,
		40,
		48,
		54,
		54,
		59,
		62,
		71,
		80,
		91,
		103,
		102,
		103,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		147,
		186,
		112,
		-1,
		96,
		-1,
		-1,
		-1,
		122,
		102,
		94,
		87,
		66,
		66,
		32,
		36,
		49,
		56,
		66,
		80,
		77,
		84,
		97,
		108,
		111,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		162,
		153,
		180,
		119,
		108,
		103,
		90,
		-1,
		-1,
		100,
		112,
		-1,
		-1,
		73,
		40,
		28,
		38,
		42,
		56,
		68,
		81,
		69,
		85,
		79,
		111,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		160,
		181,
		171,
		152,
		150,
		175,
		-1,
		79,
		-1,
		-1,
		80,
		-1,
		-1,
		65,
		45,
		34,
		25,
		30,
		50,
		61,
		83,
		65,
		82,
		84,
		94,
		98,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		147,
		145,
		151,
		158,
		153,
		164,
		-1,
		-1,
		95,
		75,
		-1,
		-1,
		63,
		61,
		50,
		-1,
		40,
		22,
		27,
		57,
		59,
		61,
		68,
		62,
		69,
		88,
		99,
		91,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		144,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		-1,
		85,
		81,
		-1,
		-1,
		58,
		51,
		39,
		27,
		17,
		27,
		44,
		44,
		47,
		52,
		60,
		71,
		78,
		82,
		85,
		-1,
		218,
		-1,
		170,
		136,
		142,
		157,
		165,
		-1,
		-1,
		-1,
		102,
		88,
		81,
		69,
		67,
		-1,
		92,
		76,
		57,
		-1,
		27,
		40,
		80,
		48,
		53,
		48,
		66,
		77,
		76,
		84,
		78,
		81,
		-1,
		-1,
		135,
		118,
		-1,
		-1,
		92,
		94,
		-1,
		93,
		82,
		67,
		59,
		-1,
		-1,
		64,
		60,
		-1,
		-1,
		14,
		62,
		51,
		59,
		54,
		66,
		76,
		74,
		74,
		84,
		75,
		-1,
		-1,
		113,
		105,
		99,
		-1,
		77,
		-1,
		95,
		-1,
		62,
		68,
		56,
		-1,
		-1,
		-1,
		45,
		8,
		24,
		58,
		74,
		72,
		63,
		62,
		69,
		76,
		69,
		75,
		-1,
		-1,
		-1,
		95,
		69,
		102,
		93,
		76,
		56,
		48,
		67,
		-1,
		32,
		-1,
		0,
		4,
		40,
		68,
		81,
		67,
		63,
		76,
		70,
		67,
		65,
		101,
		-1,
		71,
		104,
		68,
		62,
		38,
		42,
		58,
		-1,
		29,
		8,
		-1,
		44,
		34,
		82,
		57,
		66,
		59,
		53,
		54,
		62,
		-1,
		-1,
		-1,
		73,
		72,
		64,
		58,
		58,
		43,
		34,
		-1,
		46,
		28,
		7,
		23,
		24,
		15,
		23,
		72,
		68,
		71,
		69,
		47,
		-1,
		174,
		-1,
		-1,
		96,
		-1,
		-1,
		-1,
		67,
		62,
		35,
		23,
		29,
		25,
		11,
		17,
		18,
		27,
		25,
		22,
		34,
		30,
		50,
		46,
		78,
		-1,
		169,
		-1,
		103,
		-1,
		-1,
		85,
		65,
		57,
		46,
		35,
		33,
		24,
		15,
		37,
		52,
		37,
		35,
		40,
		45,
		-1,
		158,
		157,
		-1,
		104,
		96,
		82,
		-1,
		75,
		-1,
		81,
		42,
		-1,
		44,
		24,
		-1,
		46,
		42,
		-1,
		-1,
		145,
		120,
		-1,
		-1,
		-1,
		105,
		85,
		76,
		60,
		-1,
		35,
		35,
		-1,
		-1,
		-1,
		130,
		129,
		-1,
		98,
		101,
		-1,
		91,
		82,
		90,
		37,
		41,
		-1,
		-1,
		-1,
		139,
		120,
		114,
		113,
		111,
		106,
		103,
		89,
		73,
		51,
		40,
		61,
		-1,
		-1,
		-1,
		111,
		103,
		96,
		-1,
		-1,
		98,
		81,
		62,
		60,
		-1,
		-1,
		-1,
		133,
		114,
		-1,
		-1,
		88,
		-1,
		-1,
		94,
		59,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		122,
		-1,
		-1,
		-1,
		84,
		80,
		81,
		-1,
		-1,
		-1,
		-1,
		144,
		145,
		168,
		132,
		-1,
		-1,
		-1,
		76,
		70,
		-1,
		-1,
		147,
		145,
		-1,
		-1,
		-1,
		104,
		88,
		-1,
		74,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		107,
		-1,
		-1,
		-1,
		109,
		-1,
		109,
		84,
		91,
		-1,
		-1,
		-1,
		-1,
		122,
		114,
		122,
		-1,
		94,
		96,
		-1,
		144,
		-1,
		-1,
		137,
		128,
		-1,
		-1,
		99,
		106,
		128,
		131,
		167,
		-1,
		118
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		144,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		132,
		138,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		112,
		108,
		105,
		119,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		106,
		105,
		115,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		133,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		101,
		105,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		127,
		134,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		103,
		119,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		126,
		122,
		129,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		98,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		156,
		142,
		122,
		114,
		129,
		128,
		115,
		114,
		98,
		91,
		88,
		81,
		94,
		104,
		109,
		96,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		151,
		142,
		130,
		120,
		110,
		115,
		116,
		106,
		104,
		96,
		98,
		92,
		83,
		82,
		98,
		90,
		112,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		170,
		149,
		131,
		-1,
		-1,
		114,
		107,
		101,
		104,
		92,
		112,
		107,
		91,
		76,
		91,
		95,
		103,
		94,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		113,
		-1,
		87,
		98,
		91,
		110,
		117,
		93,
		78,
		72,
		78,
		90,
		99,
		-1,
		-1,
		202,
		-1,
		172,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		89,
		91,
		88,
		100,
		96,
		93,
		84,
		75,
		71,
		75,
		79,
		93,
		97,
		225,
		-1,
		163,
		-1,
		-1,
		-1,
		157,
		172,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		91,
		100,
		111,
		76,
		78,
		68,
		67,
		71,
		88,
		92,
		-1,
		-1,
		161,
		157,
		183,
		165,
		169,
		170,
		-1,
		-1,
		97,
		88,
		79,
		71,
		84,
		87,
		72,
		74,
		74,
		72,
		66,
		76,
		91,
		86,
		-1,
		-1,
		-1,
		173,
		-1,
		175,
		-1,
		-1,
		163,
		168,
		115,
		97,
		93,
		91,
		80,
		74,
		62,
		67,
		77,
		71,
		68,
		62,
		66,
		89,
		78,
		117,
		-1,
		-1,
		245,
		-1,
		-1,
		-1,
		152,
		144,
		139,
		145,
		147,
		138,
		130,
		127,
		-1,
		97,
		103,
		68,
		75,
		58,
		65,
		70,
		67,
		56,
		63,
		79,
		78,
		73,
		109,
		100,
		106,
		-1,
		-1,
		238,
		227,
		216,
		222,
		-1,
		145,
		141,
		131,
		121,
		124,
		-1,
		-1,
		118,
		115,
		95,
		64,
		66,
		59,
		54,
		62,
		40,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		192,
		229,
		222,
		190,
		198,
		229,
		-1,
		135,
		127,
		138,
		113,
		115,
		-1,
		-1,
		91,
		82,
		83,
		71,
		68,
		78,
		77,
		47,
		52,
		67,
		57,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		185,
		205,
		184,
		187,
		211,
		225,
		-1,
		132,
		-1,
		-1,
		117,
		116,
		100,
		90,
		87,
		130,
		77,
		72,
		49,
		47,
		44,
		35,
		73,
		52,
		64,
		67,
		83,
		88,
		80,
		96,
		96,
		97,
		-1,
		174,
		185,
		178,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		107,
		-1,
		127,
		-1,
		110,
		114,
		85,
		88,
		63,
		50,
		36,
		44,
		50,
		50,
		55,
		58,
		70,
		79,
		90,
		102,
		103,
		104,
		199,
		155,
		158,
		169,
		180,
		195,
		199,
		-1,
		144,
		183,
		113,
		-1,
		97,
		-1,
		-1,
		-1,
		118,
		98,
		90,
		83,
		62,
		62,
		28,
		32,
		45,
		52,
		62,
		76,
		73,
		83,
		96,
		107,
		112,
		195,
		186,
		199,
		144,
		144,
		165,
		174,
		195,
		159,
		150,
		177,
		120,
		109,
		104,
		91,
		-1,
		-1,
		96,
		108,
		-1,
		-1,
		69,
		36,
		24,
		34,
		38,
		52,
		64,
		77,
		65,
		84,
		78,
		110,
		-1,
		188,
		187,
		176,
		173,
		149,
		140,
		135,
		162,
		-1,
		-1,
		157,
		178,
		168,
		153,
		151,
		176,
		-1,
		80,
		-1,
		-1,
		76,
		-1,
		-1,
		61,
		41,
		30,
		21,
		26,
		46,
		57,
		79,
		61,
		78,
		83,
		93,
		99,
		172,
		169,
		157,
		155,
		178,
		143,
		131,
		-1,
		144,
		142,
		148,
		155,
		154,
		165,
		-1,
		-1,
		96,
		76,
		-1,
		-1,
		59,
		57,
		46,
		-1,
		36,
		18,
		23,
		53,
		55,
		57,
		64,
		58,
		65,
		89,
		100,
		92,
		181,
		195,
		184,
		180,
		179,
		187,
		136,
		129,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		-1,
		86,
		82,
		-1,
		-1,
		54,
		47,
		35,
		23,
		13,
		23,
		40,
		40,
		43,
		48,
		56,
		67,
		79,
		83,
		86,
		-1,
		215,
		-1,
		167,
		137,
		143,
		158,
		166,
		-1,
		-1,
		-1,
		103,
		89,
		82,
		70,
		68,
		-1,
		88,
		72,
		53,
		-1,
		23,
		36,
		76,
		44,
		49,
		44,
		62,
		73,
		77,
		85,
		79,
		82,
		-1,
		-1,
		136,
		119,
		-1,
		-1,
		93,
		95,
		-1,
		94,
		83,
		68,
		60,
		-1,
		-1,
		60,
		56,
		-1,
		-1,
		10,
		58,
		47,
		55,
		50,
		62,
		72,
		70,
		75,
		85,
		76,
		-1,
		-1,
		114,
		106,
		100,
		-1,
		78,
		-1,
		96,
		-1,
		63,
		69,
		57,
		-1,
		-1,
		-1,
		41,
		4,
		20,
		59,
		70,
		68,
		59,
		58,
		65,
		75,
		70,
		76,
		-1,
		-1,
		-1,
		96,
		70,
		103,
		94,
		77,
		57,
		49,
		68,
		-1,
		35,
		-1,
		3,
		0,
		41,
		64,
		81,
		68,
		61,
		76,
		71,
		68,
		66,
		102,
		-1,
		72,
		105,
		69,
		63,
		39,
		43,
		59,
		-1,
		32,
		11,
		-1,
		45,
		35,
		83,
		58,
		67,
		59,
		54,
		55,
		63,
		-1,
		-1,
		-1,
		74,
		73,
		65,
		59,
		59,
		44,
		35,
		-1,
		47,
		29,
		8,
		25,
		25,
		16,
		24,
		73,
		69,
		72,
		70,
		48,
		-1,
		175,
		-1,
		-1,
		97,
		-1,
		-1,
		-1,
		68,
		63,
		36,
		24,
		30,
		26,
		12,
		18,
		20,
		28,
		26,
		23,
		35,
		31,
		51,
		47,
		79,
		-1,
		170,
		-1,
		104,
		-1,
		-1,
		86,
		66,
		58,
		47,
		36,
		34,
		25,
		16,
		38,
		54,
		38,
		36,
		41,
		46,
		-1,
		159,
		158,
		-1,
		105,
		97,
		83,
		-1,
		76,
		-1,
		82,
		43,
		-1,
		45,
		25,
		-1,
		47,
		43,
		-1,
		-1,
		146,
		121,
		-1,
		-1,
		-1,
		106,
		86,
		77,
		61,
		-1,
		36,
		36,
		-1,
		-1,
		-1,
		131,
		130,
		-1,
		99,
		102,
		-1,
		92,
		83,
		91,
		38,
		42,
		-1,
		-1,
		-1,
		140,
		121,
		115,
		114,
		112,
		107,
		104,
		90,
		74,
		52,
		41,
		62,
		-1,
		-1,
		-1,
		112,
		104,
		97,
		-1,
		-1,
		99,
		82,
		63,
		61,
		-1,
		-1,
		-1,
		134,
		115,
		-1,
		-1,
		89,
		-1,
		-1,
		95,
		60,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		123,
		-1,
		-1,
		-1,
		85,
		81,
		82,
		-1,
		-1,
		-1,
		-1,
		145,
		146,
		169,
		133,
		-1,
		-1,
		-1,
		77,
		71,
		-1,
		-1,
		148,
		146,
		-1,
		-1,
		-1,
		105,
		89,
		-1,
		75,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		108,
		-1,
		-1,
		-1,
		110,
		-1,
		110,
		85,
		92,
		-1,
		-1,
		-1,
		-1,
		123,
		115,
		123,
		-1,
		95,
		97,
		-1,
		145,
		-1,
		-1,
		138,
		129,
		-1,
		-1,
		100,
		107,
		129,
		132,
		168,
		-1,
		119
	],
	[
		-1,
		262,
		251,
		262,
		270,
		243,
		250,
		-1,
		269,
		273,
		239,
		233,
		272,
		241,
		247,
		258,
		-1,
		-1,
		-1,
		262,
		261,
		229,
		227,
		236,
		241,
		248,
		-1,
		247,
		-1,
		283,
		262,
		273,
		278,
		222,
		219,
		239,
		258,
		240,
		232,
		298,
		252,
		223,
		217,
		235,
		225,
		234,
		226,
		-1,
		223,
		213,
		235,
		214,
		225,
		217,
		-1,
		-1,
		217,
		218,
		224,
		210,
		216,
		212,
		-1,
		222,
		206,
		-1,
		-1,
		207,
		208,
		192,
		195,
		203,
		201,
		214,
		206,
		201,
		-1,
		-1,
		198,
		194,
		201,
		188,
		184,
		201,
		214,
		196,
		210,
		209,
		-1,
		202,
		220,
		227,
		195,
		193,
		177,
		175,
		193,
		195,
		201,
		201,
		-1,
		211,
		212,
		207,
		215,
		217,
		193,
		180,
		180,
		190,
		183,
		202,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		211,
		194,
		211,
		203,
		193,
		208,
		201,
		183,
		180,
		178,
		175,
		191,
		189,
		199,
		-1,
		-1,
		304,
		273,
		302,
		260,
		241,
		-1,
		207,
		187,
		193,
		197,
		191,
		184,
		198,
		194,
		-1,
		169,
		168,
		196,
		182,
		193,
		264,
		-1,
		-1,
		262,
		254,
		237,
		240,
		217,
		213,
		202,
		201,
		193,
		179,
		175,
		181,
		184,
		184,
		190,
		163,
		173,
		177,
		175,
		200,
		-1,
		-1,
		235,
		-1,
		-1,
		261,
		244,
		-1,
		227,
		234,
		223,
		229,
		215,
		236,
		212,
		203,
		195,
		189,
		177,
		179,
		176,
		189,
		177,
		160,
		185,
		189,
		170,
		191,
		186,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		220,
		223,
		229,
		253,
		252,
		-1,
		224,
		212,
		213,
		198,
		195,
		182,
		170,
		183,
		168,
		175,
		174,
		164,
		162,
		192,
		167,
		189,
		186,
		205,
		210,
		204,
		213,
		-1,
		269,
		265,
		261,
		268,
		217,
		-1,
		-1,
		257,
		-1,
		260,
		261,
		236,
		209,
		212,
		199,
		190,
		177,
		166,
		177,
		166,
		163,
		171,
		156,
		171,
		162,
		161,
		179,
		189,
		197,
		201,
		207,
		-1,
		319,
		-1,
		261,
		245,
		247,
		219,
		240,
		-1,
		277,
		261,
		253,
		238,
		238,
		-1,
		208,
		205,
		195,
		173,
		158,
		175,
		167,
		165,
		169,
		151,
		165,
		156,
		174,
		181,
		179,
		183,
		203,
		215,
		279,
		269,
		-1,
		251,
		256,
		215,
		223,
		242,
		280,
		244,
		-1,
		239,
		-1,
		210,
		223,
		-1,
		179,
		175,
		157,
		158,
		153,
		168,
		162,
		147,
		144,
		162,
		165,
		172,
		176,
		192,
		-1,
		-1,
		264,
		268,
		257,
		208,
		227,
		251,
		288,
		237,
		226,
		225,
		-1,
		216,
		193,
		190,
		178,
		165,
		150,
		151,
		159,
		172,
		151,
		146,
		143,
		163,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		234,
		205,
		229,
		271,
		255,
		248,
		236,
		201,
		201,
		195,
		-1,
		189,
		168,
		159,
		148,
		146,
		159,
		156,
		161,
		141,
		139,
		158,
		170,
		161,
		178,
		-1,
		-1,
		-1,
		264,
		253,
		254,
		200,
		223,
		260,
		234,
		220,
		225,
		200,
		193,
		187,
		202,
		185,
		166,
		155,
		147,
		136,
		152,
		160,
		155,
		137,
		146,
		152,
		176,
		166,
		172,
		-1,
		-1,
		271,
		261,
		245,
		247,
		244,
		214,
		221,
		253,
		225,
		238,
		-1,
		192,
		-1,
		181,
		176,
		160,
		155,
		152,
		149,
		143,
		152,
		154,
		144,
		139,
		146,
		181,
		181,
		156,
		176,
		179,
		-1,
		-1,
		-1,
		264,
		259,
		234,
		211,
		195,
		231,
		-1,
		208,
		209,
		-1,
		186,
		180,
		177,
		162,
		158,
		153,
		157,
		150,
		157,
		150,
		148,
		149,
		131,
		163,
		-1,
		164,
		158,
		166,
		156,
		144,
		-1,
		-1,
		-1,
		257,
		236,
		229,
		249,
		190,
		242,
		-1,
		-1,
		193,
		186,
		-1,
		173,
		155,
		162,
		160,
		154,
		158,
		155,
		144,
		157,
		150,
		136,
		138,
		151,
		155,
		159,
		146,
		142,
		139,
		153,
		-1,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		210,
		-1,
		202,
		194,
		184,
		178,
		172,
		168,
		166,
		182,
		166,
		169,
		167,
		158,
		166,
		139,
		132,
		139,
		128,
		146,
		154,
		146,
		140,
		139,
		149,
		-1,
		277,
		263,
		234,
		-1,
		-1,
		223,
		-1,
		187,
		201,
		217,
		-1,
		210,
		189,
		204,
		182,
		178,
		174,
		189,
		190,
		167,
		167,
		165,
		156,
		144,
		133,
		136,
		128,
		150,
		150,
		134,
		135,
		139,
		-1,
		283,
		270,
		228,
		224,
		213,
		233,
		184,
		172,
		204,
		-1,
		-1,
		246,
		-1,
		180,
		197,
		188,
		186,
		179,
		161,
		168,
		176,
		153,
		148,
		138,
		127,
		127,
		122,
		144,
		130,
		128,
		137,
		153,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		199,
		186,
		180,
		-1,
		221,
		-1,
		224,
		214,
		198,
		183,
		216,
		-1,
		160,
		156,
		163,
		-1,
		173,
		-1,
		146,
		143,
		134,
		119,
		116,
		127,
		125,
		136,
		132,
		-1,
		233,
		218,
		211,
		201,
		215,
		186,
		-1,
		241,
		-1,
		-1,
		211,
		205,
		205,
		189,
		190,
		176,
		156,
		148,
		163,
		162,
		149,
		148,
		132,
		125,
		122,
		115,
		128,
		138,
		143,
		130,
		-1,
		-1,
		-1,
		238,
		224,
		228,
		188,
		207,
		-1,
		-1,
		273,
		228,
		214,
		-1,
		185,
		176,
		164,
		154,
		144,
		149,
		150,
		140,
		138,
		130,
		132,
		126,
		117,
		116,
		132,
		124,
		146,
		-1,
		-1,
		221,
		226,
		214,
		200,
		219,
		-1,
		-1,
		-1,
		220,
		236,
		204,
		183,
		165,
		-1,
		-1,
		148,
		141,
		135,
		138,
		126,
		146,
		141,
		125,
		110,
		125,
		129,
		137,
		128,
		-1,
		224,
		211,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		-1,
		-1,
		216,
		161,
		150,
		145,
		149,
		147,
		-1,
		121,
		132,
		125,
		144,
		151,
		127,
		112,
		106,
		112,
		124,
		133,
		-1,
		-1,
		236,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		173,
		167,
		138,
		131,
		135,
		-1,
		123,
		125,
		122,
		134,
		130,
		127,
		118,
		109,
		105,
		109,
		113,
		127,
		131,
		259,
		-1,
		201,
		-1,
		-1,
		-1,
		191,
		206,
		177,
		154,
		127,
		122,
		115,
		109,
		114,
		125,
		134,
		145,
		110,
		112,
		102,
		101,
		105,
		122,
		126,
		-1,
		-1,
		199,
		195,
		217,
		199,
		203,
		204,
		-1,
		-1,
		131,
		122,
		113,
		105,
		118,
		121,
		106,
		108,
		108,
		106,
		100,
		110,
		125,
		120,
		-1,
		-1,
		-1,
		211,
		-1,
		213,
		-1,
		-1,
		201,
		202,
		149,
		131,
		127,
		125,
		114,
		108,
		96,
		101,
		111,
		105,
		102,
		96,
		100,
		123,
		112,
		147,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		190,
		182,
		177,
		183,
		185,
		176,
		164,
		161,
		-1,
		131,
		137,
		102,
		109,
		92,
		99,
		104,
		101,
		90,
		97,
		113,
		112,
		107,
		139,
		130,
		134,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		183,
		179,
		169,
		159,
		162,
		-1,
		-1,
		156,
		153,
		133,
		102,
		100,
		93,
		88,
		98,
		74,
		86,
		90,
		94,
		100,
		105,
		110,
		116,
		125,
		140,
		-1,
		230,
		267,
		260,
		228,
		236,
		267,
		-1,
		173,
		165,
		176,
		151,
		153,
		-1,
		-1,
		129,
		120,
		121,
		109,
		106,
		112,
		111,
		94,
		93,
		101,
		93,
		92,
		110,
		111,
		115,
		116,
		120,
		133,
		137,
		-1,
		223,
		243,
		222,
		225,
		249,
		263,
		-1,
		170,
		-1,
		-1,
		151,
		154,
		138,
		128,
		125,
		168,
		123,
		118,
		98,
		96,
		92,
		83,
		108,
		93,
		97,
		94,
		103,
		108,
		100,
		126,
		128,
		122,
		-1,
		212,
		223,
		216,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		141,
		-1,
		165,
		-1,
		148,
		152,
		131,
		134,
		112,
		99,
		85,
		85,
		91,
		91,
		96,
		99,
		90,
		99,
		110,
		122,
		132,
		134,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		182,
		221,
		147,
		-1,
		131,
		-1,
		-1,
		-1,
		162,
		144,
		136,
		132,
		111,
		111,
		77,
		73,
		86,
		93,
		103,
		107,
		91,
		103,
		116,
		127,
		130,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		197,
		188,
		215,
		154,
		143,
		138,
		125,
		-1,
		-1,
		146,
		154,
		-1,
		-1,
		118,
		86,
		74,
		75,
		79,
		93,
		105,
		103,
		83,
		103,
		98,
		126,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		216,
		206,
		187,
		185,
		210,
		-1,
		114,
		-1,
		-1,
		126,
		-1,
		-1,
		111,
		91,
		80,
		71,
		65,
		87,
		98,
		120,
		79,
		96,
		103,
		113,
		111,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		188,
		199,
		-1,
		-1,
		130,
		110,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		68,
		62,
		89,
		73,
		75,
		82,
		76,
		83,
		101,
		112,
		104,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		120,
		116,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		73,
		62,
		52,
		61,
		66,
		74,
		85,
		91,
		95,
		98,
		-1,
		253,
		-1,
		205,
		171,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		137,
		123,
		116,
		104,
		102,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		72,
		43,
		67,
		62,
		80,
		91,
		89,
		97,
		91,
		94,
		-1,
		-1,
		170,
		153,
		-1,
		-1,
		127,
		129,
		-1,
		128,
		117,
		102,
		94,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		60,
		23,
		41,
		73,
		68,
		80,
		90,
		88,
		87,
		97,
		88,
		-1,
		-1,
		148,
		140,
		134,
		-1,
		112,
		-1,
		130,
		-1,
		97,
		103,
		91,
		-1,
		-1,
		-1,
		91,
		54,
		70,
		18,
		58,
		62,
		77,
		76,
		83,
		89,
		82,
		88,
		-1,
		-1,
		-1,
		130,
		104,
		137,
		128,
		111,
		91,
		83,
		102,
		-1,
		72,
		-1,
		47,
		50,
		0,
		50,
		85,
		79,
		76,
		89,
		83,
		80,
		78,
		136,
		-1,
		106,
		139,
		103,
		97,
		73,
		77,
		93,
		-1,
		69,
		51,
		-1,
		38,
		7,
		95,
		70,
		79,
		72,
		66,
		67,
		75,
		-1,
		-1,
		-1,
		108,
		107,
		99,
		93,
		93,
		78,
		69,
		-1,
		81,
		63,
		42,
		51,
		36,
		33,
		25,
		85,
		81,
		84,
		82,
		60,
		-1,
		209,
		-1,
		-1,
		131,
		-1,
		-1,
		-1,
		102,
		97,
		70,
		58,
		64,
		60,
		46,
		52,
		46,
		28,
		22,
		26,
		42,
		43,
		63,
		59,
		91,
		-1,
		204,
		-1,
		138,
		-1,
		-1,
		120,
		100,
		92,
		81,
		70,
		68,
		59,
		50,
		72,
		64,
		48,
		48,
		53,
		58,
		-1,
		193,
		192,
		-1,
		139,
		131,
		117,
		-1,
		110,
		-1,
		116,
		77,
		-1,
		79,
		59,
		-1,
		59,
		55,
		-1,
		-1,
		180,
		155,
		-1,
		-1,
		-1,
		140,
		120,
		111,
		95,
		-1,
		70,
		70,
		-1,
		-1,
		-1,
		165,
		164,
		-1,
		133,
		136,
		-1,
		126,
		117,
		125,
		72,
		76,
		-1,
		-1,
		-1,
		174,
		155,
		149,
		148,
		146,
		141,
		138,
		124,
		108,
		86,
		75,
		96,
		-1,
		-1,
		-1,
		146,
		138,
		131,
		-1,
		-1,
		133,
		116,
		97,
		95,
		-1,
		-1,
		-1,
		168,
		149,
		-1,
		-1,
		123,
		-1,
		-1,
		129,
		94,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		157,
		-1,
		-1,
		-1,
		119,
		115,
		116,
		-1,
		-1,
		-1,
		-1,
		179,
		180,
		203,
		167,
		-1,
		-1,
		-1,
		111,
		105,
		-1,
		-1,
		182,
		180,
		-1,
		-1,
		-1,
		139,
		123,
		-1,
		109,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		144,
		-1,
		144,
		119,
		126,
		-1,
		-1,
		-1,
		-1,
		157,
		149,
		157,
		-1,
		129,
		131,
		-1,
		179,
		-1,
		-1,
		172,
		163,
		-1,
		-1,
		134,
		141,
		163,
		166,
		202,
		-1,
		153
	],
	[
		-1,
		257,
		246,
		257,
		265,
		238,
		245,
		-1,
		264,
		268,
		234,
		228,
		267,
		236,
		242,
		253,
		-1,
		-1,
		-1,
		257,
		256,
		224,
		222,
		231,
		236,
		243,
		-1,
		242,
		-1,
		278,
		257,
		268,
		273,
		217,
		214,
		234,
		253,
		235,
		227,
		293,
		247,
		218,
		212,
		230,
		220,
		229,
		221,
		-1,
		218,
		208,
		230,
		209,
		220,
		212,
		-1,
		-1,
		212,
		213,
		219,
		205,
		211,
		207,
		-1,
		217,
		201,
		-1,
		-1,
		202,
		203,
		187,
		190,
		198,
		196,
		209,
		201,
		196,
		-1,
		-1,
		193,
		189,
		196,
		183,
		179,
		196,
		209,
		191,
		205,
		204,
		-1,
		197,
		215,
		222,
		190,
		188,
		172,
		170,
		188,
		190,
		196,
		196,
		-1,
		206,
		207,
		202,
		210,
		212,
		188,
		175,
		175,
		185,
		178,
		197,
		185,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		206,
		189,
		206,
		198,
		188,
		203,
		196,
		178,
		175,
		173,
		170,
		186,
		184,
		194,
		-1,
		-1,
		299,
		268,
		297,
		255,
		236,
		-1,
		202,
		182,
		188,
		192,
		186,
		179,
		193,
		189,
		-1,
		164,
		163,
		191,
		177,
		188,
		259,
		-1,
		-1,
		257,
		249,
		232,
		235,
		212,
		208,
		197,
		196,
		188,
		174,
		170,
		176,
		179,
		179,
		185,
		158,
		168,
		172,
		170,
		195,
		-1,
		-1,
		230,
		-1,
		-1,
		256,
		239,
		-1,
		222,
		229,
		218,
		224,
		210,
		231,
		207,
		198,
		190,
		184,
		172,
		174,
		171,
		184,
		172,
		155,
		180,
		184,
		165,
		186,
		181,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		215,
		218,
		224,
		248,
		247,
		-1,
		219,
		207,
		208,
		193,
		190,
		177,
		165,
		178,
		163,
		170,
		169,
		159,
		157,
		187,
		162,
		184,
		181,
		200,
		205,
		199,
		208,
		-1,
		264,
		260,
		256,
		263,
		212,
		-1,
		-1,
		252,
		-1,
		255,
		256,
		231,
		204,
		207,
		194,
		185,
		172,
		161,
		172,
		161,
		158,
		166,
		151,
		166,
		157,
		156,
		174,
		184,
		192,
		196,
		202,
		-1,
		314,
		-1,
		256,
		240,
		242,
		214,
		235,
		-1,
		272,
		256,
		248,
		233,
		233,
		-1,
		203,
		200,
		190,
		168,
		153,
		170,
		162,
		160,
		164,
		146,
		160,
		151,
		169,
		176,
		174,
		178,
		198,
		210,
		274,
		264,
		-1,
		246,
		251,
		210,
		218,
		237,
		275,
		239,
		-1,
		234,
		-1,
		205,
		218,
		-1,
		174,
		170,
		152,
		153,
		148,
		163,
		157,
		142,
		139,
		157,
		160,
		167,
		171,
		187,
		-1,
		-1,
		259,
		263,
		252,
		203,
		222,
		246,
		283,
		232,
		221,
		220,
		-1,
		211,
		188,
		185,
		173,
		160,
		145,
		146,
		154,
		167,
		146,
		141,
		138,
		158,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		229,
		200,
		224,
		266,
		250,
		243,
		231,
		196,
		196,
		190,
		-1,
		184,
		163,
		154,
		143,
		141,
		154,
		151,
		156,
		136,
		134,
		153,
		165,
		156,
		173,
		-1,
		-1,
		-1,
		259,
		248,
		249,
		195,
		218,
		255,
		229,
		215,
		220,
		195,
		188,
		182,
		197,
		180,
		161,
		150,
		142,
		131,
		147,
		155,
		150,
		132,
		141,
		147,
		171,
		161,
		167,
		-1,
		-1,
		266,
		256,
		240,
		242,
		239,
		209,
		216,
		248,
		220,
		233,
		-1,
		187,
		-1,
		176,
		171,
		155,
		150,
		147,
		144,
		138,
		147,
		149,
		139,
		134,
		141,
		176,
		176,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		259,
		254,
		229,
		206,
		190,
		226,
		-1,
		203,
		204,
		-1,
		181,
		175,
		172,
		157,
		153,
		148,
		152,
		145,
		152,
		145,
		143,
		144,
		126,
		158,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		252,
		231,
		224,
		244,
		185,
		237,
		-1,
		-1,
		188,
		181,
		-1,
		168,
		150,
		157,
		155,
		149,
		153,
		150,
		139,
		152,
		145,
		131,
		133,
		146,
		150,
		154,
		141,
		137,
		134,
		148,
		-1,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		205,
		-1,
		197,
		189,
		179,
		173,
		167,
		163,
		161,
		177,
		161,
		164,
		162,
		153,
		161,
		134,
		127,
		134,
		123,
		141,
		149,
		141,
		135,
		134,
		144,
		-1,
		272,
		258,
		229,
		-1,
		-1,
		218,
		-1,
		182,
		196,
		212,
		-1,
		205,
		184,
		199,
		177,
		173,
		169,
		184,
		185,
		163,
		162,
		160,
		151,
		139,
		128,
		131,
		123,
		145,
		145,
		129,
		130,
		134,
		-1,
		278,
		265,
		223,
		219,
		208,
		228,
		179,
		167,
		199,
		-1,
		-1,
		241,
		-1,
		175,
		192,
		183,
		181,
		174,
		159,
		166,
		171,
		148,
		143,
		133,
		122,
		122,
		117,
		139,
		125,
		123,
		132,
		148,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		194,
		181,
		175,
		-1,
		216,
		-1,
		219,
		209,
		193,
		178,
		211,
		-1,
		158,
		154,
		161,
		-1,
		168,
		-1,
		141,
		138,
		129,
		114,
		111,
		122,
		120,
		131,
		127,
		-1,
		228,
		213,
		206,
		196,
		210,
		181,
		-1,
		236,
		-1,
		-1,
		206,
		200,
		200,
		184,
		187,
		174,
		154,
		146,
		161,
		160,
		147,
		146,
		127,
		120,
		117,
		110,
		123,
		133,
		138,
		125,
		-1,
		-1,
		-1,
		233,
		219,
		223,
		183,
		202,
		-1,
		-1,
		268,
		223,
		209,
		-1,
		183,
		174,
		162,
		152,
		142,
		147,
		148,
		138,
		136,
		125,
		127,
		121,
		112,
		111,
		127,
		119,
		141,
		-1,
		-1,
		216,
		221,
		209,
		195,
		214,
		-1,
		-1,
		-1,
		215,
		231,
		202,
		181,
		163,
		-1,
		-1,
		146,
		139,
		133,
		136,
		124,
		141,
		136,
		120,
		105,
		120,
		124,
		132,
		123,
		-1,
		219,
		206,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		-1,
		-1,
		214,
		159,
		148,
		143,
		147,
		145,
		-1,
		119,
		130,
		123,
		142,
		149,
		122,
		107,
		101,
		107,
		119,
		128,
		-1,
		-1,
		231,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		171,
		165,
		136,
		129,
		133,
		-1,
		121,
		123,
		120,
		132,
		125,
		122,
		113,
		104,
		100,
		104,
		108,
		122,
		126,
		254,
		-1,
		192,
		-1,
		-1,
		-1,
		189,
		204,
		175,
		152,
		125,
		120,
		113,
		107,
		112,
		123,
		132,
		143,
		108,
		107,
		97,
		96,
		100,
		117,
		121,
		-1,
		-1,
		190,
		186,
		215,
		197,
		201,
		202,
		-1,
		-1,
		129,
		120,
		111,
		103,
		116,
		119,
		104,
		106,
		106,
		101,
		95,
		105,
		120,
		115,
		-1,
		-1,
		-1,
		202,
		-1,
		204,
		-1,
		-1,
		192,
		200,
		147,
		129,
		125,
		123,
		110,
		104,
		94,
		99,
		109,
		103,
		100,
		91,
		95,
		118,
		107,
		127,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		162,
		159,
		-1,
		129,
		133,
		100,
		107,
		90,
		97,
		102,
		99,
		85,
		92,
		108,
		107,
		102,
		119,
		110,
		114,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		147,
		144,
		124,
		93,
		98,
		91,
		86,
		91,
		72,
		81,
		85,
		83,
		95,
		100,
		105,
		98,
		105,
		120,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		120,
		111,
		112,
		100,
		97,
		110,
		109,
		76,
		73,
		95,
		78,
		87,
		99,
		91,
		95,
		96,
		103,
		114,
		118,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		161,
		-1,
		-1,
		173,
		145,
		129,
		119,
		116,
		159,
		106,
		101,
		78,
		76,
		73,
		64,
		94,
		73,
		77,
		74,
		83,
		88,
		80,
		106,
		108,
		106,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		171,
		-1,
		156,
		-1,
		139,
		143,
		114,
		117,
		92,
		79,
		65,
		65,
		71,
		71,
		76,
		79,
		70,
		79,
		90,
		102,
		112,
		114,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		173,
		212,
		177,
		-1,
		161,
		-1,
		-1,
		-1,
		153,
		127,
		119,
		112,
		91,
		91,
		57,
		53,
		66,
		73,
		83,
		87,
		71,
		83,
		96,
		107,
		114,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		188,
		179,
		206,
		184,
		173,
		168,
		155,
		-1,
		-1,
		134,
		137,
		-1,
		-1,
		98,
		74,
		61,
		55,
		59,
		73,
		85,
		83,
		63,
		83,
		78,
		110,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		207,
		197,
		201,
		215,
		240,
		-1,
		144,
		-1,
		-1,
		114,
		-1,
		-1,
		99,
		79,
		68,
		59,
		45,
		67,
		78,
		100,
		59,
		76,
		83,
		93,
		95,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		229,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		97,
		95,
		84,
		-1,
		74,
		56,
		42,
		67,
		53,
		55,
		62,
		56,
		63,
		81,
		94,
		88,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		92,
		85,
		73,
		61,
		51,
		56,
		40,
		30,
		41,
		46,
		54,
		65,
		71,
		75,
		82,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		126,
		110,
		91,
		-1,
		61,
		74,
		52,
		21,
		45,
		42,
		49,
		60,
		67,
		77,
		75,
		78,
		-1,
		-1,
		184,
		183,
		-1,
		-1,
		157,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		98,
		94,
		-1,
		-1,
		62,
		22,
		19,
		51,
		48,
		45,
		57,
		53,
		65,
		80,
		72,
		-1,
		-1,
		178,
		170,
		164,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		100,
		63,
		84,
		29,
		8,
		12,
		40,
		41,
		48,
		58,
		66,
		72,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		99,
		-1,
		67,
		64,
		43,
		0,
		35,
		29,
		44,
		56,
		55,
		64,
		62,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		96,
		75,
		-1,
		81,
		50,
		52,
		38,
		54,
		42,
		49,
		63,
		59,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		89,
		79,
		76,
		68,
		42,
		38,
		60,
		62,
		54,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		84,
		71,
		65,
		69,
		79,
		72,
		76,
		55,
		91,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		107,
		78,
		67,
		62,
		63,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		78,
		67,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		262,
		251,
		262,
		270,
		243,
		250,
		-1,
		269,
		273,
		239,
		233,
		272,
		241,
		247,
		258,
		-1,
		-1,
		-1,
		262,
		261,
		229,
		227,
		236,
		241,
		248,
		-1,
		247,
		-1,
		283,
		262,
		273,
		278,
		222,
		219,
		239,
		258,
		240,
		232,
		298,
		252,
		223,
		217,
		235,
		225,
		234,
		226,
		-1,
		223,
		213,
		235,
		214,
		225,
		217,
		-1,
		-1,
		217,
		218,
		224,
		210,
		216,
		212,
		-1,
		222,
		206,
		-1,
		-1,
		207,
		208,
		192,
		195,
		203,
		201,
		214,
		206,
		201,
		-1,
		-1,
		198,
		194,
		201,
		188,
		184,
		201,
		214,
		196,
		210,
		209,
		-1,
		202,
		220,
		227,
		195,
		193,
		177,
		175,
		193,
		195,
		201,
		201,
		-1,
		211,
		212,
		207,
		215,
		217,
		193,
		180,
		180,
		190,
		183,
		202,
		190,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		211,
		194,
		211,
		203,
		193,
		208,
		201,
		183,
		180,
		178,
		175,
		191,
		189,
		199,
		-1,
		-1,
		304,
		273,
		302,
		260,
		241,
		-1,
		207,
		187,
		193,
		197,
		191,
		184,
		198,
		194,
		-1,
		169,
		168,
		196,
		182,
		193,
		264,
		-1,
		-1,
		262,
		254,
		237,
		240,
		217,
		213,
		202,
		201,
		193,
		179,
		175,
		181,
		184,
		184,
		190,
		163,
		173,
		177,
		175,
		200,
		-1,
		-1,
		235,
		-1,
		-1,
		261,
		244,
		-1,
		227,
		234,
		223,
		229,
		215,
		236,
		212,
		203,
		195,
		189,
		177,
		179,
		176,
		189,
		177,
		160,
		185,
		189,
		170,
		191,
		186,
		-1,
		234,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		220,
		223,
		229,
		253,
		252,
		-1,
		224,
		212,
		213,
		198,
		195,
		182,
		170,
		183,
		168,
		175,
		174,
		164,
		162,
		192,
		167,
		189,
		186,
		205,
		210,
		204,
		213,
		-1,
		269,
		265,
		261,
		268,
		217,
		-1,
		-1,
		257,
		-1,
		260,
		261,
		236,
		209,
		212,
		199,
		190,
		177,
		166,
		177,
		166,
		163,
		171,
		156,
		171,
		162,
		161,
		179,
		189,
		197,
		201,
		207,
		-1,
		319,
		-1,
		261,
		245,
		247,
		219,
		240,
		-1,
		277,
		261,
		253,
		238,
		238,
		-1,
		208,
		205,
		195,
		173,
		158,
		175,
		167,
		165,
		169,
		151,
		165,
		156,
		174,
		181,
		179,
		183,
		203,
		215,
		279,
		269,
		-1,
		251,
		256,
		215,
		223,
		242,
		280,
		244,
		-1,
		239,
		-1,
		210,
		223,
		-1,
		179,
		175,
		157,
		158,
		153,
		168,
		162,
		147,
		144,
		162,
		165,
		172,
		176,
		192,
		-1,
		-1,
		264,
		268,
		257,
		208,
		227,
		251,
		288,
		237,
		226,
		225,
		-1,
		216,
		193,
		190,
		178,
		165,
		150,
		151,
		159,
		172,
		151,
		146,
		143,
		163,
		189,
		167,
		179,
		-1,
		-1,
		-1,
		289,
		-1,
		-1,
		234,
		205,
		229,
		271,
		255,
		248,
		236,
		201,
		201,
		195,
		-1,
		189,
		168,
		159,
		148,
		146,
		159,
		156,
		161,
		141,
		139,
		158,
		170,
		161,
		178,
		-1,
		-1,
		-1,
		264,
		253,
		254,
		200,
		223,
		260,
		234,
		220,
		225,
		200,
		193,
		187,
		202,
		185,
		166,
		155,
		147,
		136,
		152,
		160,
		155,
		137,
		146,
		152,
		176,
		166,
		172,
		-1,
		-1,
		271,
		261,
		245,
		247,
		244,
		214,
		221,
		253,
		225,
		238,
		-1,
		192,
		-1,
		181,
		176,
		160,
		155,
		152,
		149,
		143,
		152,
		154,
		144,
		139,
		146,
		181,
		181,
		156,
		176,
		179,
		-1,
		-1,
		-1,
		264,
		259,
		234,
		211,
		195,
		231,
		-1,
		208,
		209,
		-1,
		186,
		180,
		177,
		162,
		158,
		153,
		157,
		150,
		157,
		150,
		148,
		149,
		131,
		163,
		-1,
		164,
		158,
		166,
		156,
		144,
		-1,
		-1,
		-1,
		257,
		236,
		229,
		249,
		190,
		242,
		-1,
		-1,
		193,
		186,
		-1,
		173,
		155,
		162,
		160,
		154,
		158,
		155,
		144,
		157,
		150,
		136,
		138,
		151,
		155,
		159,
		146,
		142,
		139,
		153,
		-1,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		210,
		-1,
		202,
		194,
		184,
		178,
		172,
		168,
		166,
		182,
		166,
		169,
		167,
		158,
		166,
		139,
		132,
		139,
		128,
		146,
		154,
		146,
		140,
		139,
		149,
		-1,
		277,
		263,
		234,
		-1,
		-1,
		223,
		-1,
		187,
		201,
		217,
		-1,
		210,
		189,
		204,
		182,
		178,
		174,
		189,
		190,
		168,
		167,
		165,
		156,
		144,
		133,
		136,
		128,
		150,
		150,
		134,
		135,
		139,
		-1,
		283,
		270,
		228,
		224,
		213,
		233,
		184,
		172,
		204,
		-1,
		-1,
		246,
		-1,
		180,
		197,
		188,
		186,
		179,
		170,
		176,
		176,
		153,
		148,
		138,
		127,
		127,
		122,
		144,
		130,
		128,
		137,
		153,
		-1,
		-1,
		-1,
		250,
		-1,
		-1,
		199,
		186,
		180,
		-1,
		221,
		-1,
		224,
		214,
		198,
		183,
		216,
		-1,
		176,
		171,
		176,
		-1,
		173,
		-1,
		146,
		143,
		134,
		119,
		116,
		127,
		125,
		136,
		132,
		-1,
		233,
		218,
		211,
		201,
		215,
		186,
		-1,
		241,
		-1,
		-1,
		211,
		205,
		205,
		189,
		192,
		192,
		172,
		164,
		176,
		168,
		160,
		154,
		132,
		125,
		122,
		115,
		128,
		138,
		143,
		130,
		-1,
		-1,
		-1,
		238,
		224,
		228,
		188,
		207,
		-1,
		-1,
		273,
		228,
		214,
		-1,
		198,
		192,
		180,
		170,
		160,
		165,
		166,
		151,
		144,
		130,
		132,
		126,
		117,
		116,
		132,
		124,
		146,
		-1,
		-1,
		221,
		226,
		214,
		200,
		219,
		-1,
		-1,
		-1,
		220,
		236,
		220,
		199,
		181,
		-1,
		-1,
		164,
		157,
		151,
		147,
		134,
		146,
		141,
		125,
		110,
		125,
		129,
		137,
		128,
		-1,
		224,
		211,
		-1,
		-1,
		222,
		216,
		-1,
		-1,
		-1,
		-1,
		232,
		177,
		166,
		161,
		165,
		163,
		-1,
		137,
		148,
		138,
		150,
		157,
		127,
		112,
		106,
		112,
		124,
		133,
		-1,
		-1,
		236,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		189,
		183,
		154,
		147,
		151,
		-1,
		139,
		141,
		138,
		150,
		130,
		127,
		118,
		109,
		105,
		109,
		113,
		127,
		131,
		259,
		-1,
		210,
		-1,
		-1,
		-1,
		207,
		222,
		193,
		170,
		143,
		138,
		131,
		125,
		130,
		141,
		138,
		149,
		116,
		112,
		102,
		101,
		105,
		122,
		122,
		-1,
		-1,
		208,
		204,
		233,
		215,
		219,
		220,
		-1,
		-1,
		147,
		138,
		129,
		121,
		134,
		137,
		122,
		119,
		113,
		106,
		100,
		110,
		121,
		116,
		-1,
		-1,
		-1,
		220,
		-1,
		222,
		-1,
		-1,
		210,
		218,
		165,
		147,
		143,
		141,
		128,
		122,
		112,
		117,
		123,
		114,
		108,
		96,
		96,
		119,
		108,
		125,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		199,
		191,
		186,
		192,
		194,
		185,
		180,
		177,
		-1,
		147,
		151,
		118,
		125,
		108,
		115,
		118,
		110,
		90,
		93,
		109,
		108,
		103,
		117,
		108,
		112,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		192,
		188,
		178,
		168,
		171,
		-1,
		-1,
		165,
		162,
		142,
		111,
		116,
		109,
		104,
		109,
		90,
		86,
		86,
		81,
		96,
		101,
		103,
		96,
		103,
		118,
		-1,
		239,
		276,
		269,
		237,
		245,
		276,
		-1,
		182,
		174,
		185,
		160,
		162,
		-1,
		-1,
		138,
		129,
		130,
		118,
		115,
		128,
		124,
		94,
		91,
		101,
		79,
		86,
		97,
		89,
		93,
		94,
		101,
		112,
		116,
		-1,
		232,
		252,
		231,
		234,
		258,
		272,
		-1,
		179,
		-1,
		-1,
		190,
		163,
		147,
		137,
		134,
		177,
		124,
		119,
		96,
		94,
		91,
		82,
		103,
		87,
		75,
		72,
		81,
		86,
		78,
		104,
		106,
		103,
		-1,
		221,
		232,
		225,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		180,
		-1,
		174,
		-1,
		157,
		161,
		132,
		135,
		110,
		97,
		83,
		83,
		89,
		87,
		83,
		79,
		68,
		77,
		88,
		100,
		110,
		112,
		246,
		202,
		205,
		216,
		227,
		242,
		246,
		-1,
		191,
		230,
		186,
		-1,
		170,
		-1,
		-1,
		-1,
		171,
		145,
		137,
		130,
		109,
		109,
		75,
		71,
		84,
		88,
		93,
		85,
		69,
		81,
		94,
		105,
		111,
		242,
		233,
		246,
		191,
		191,
		212,
		221,
		242,
		206,
		197,
		224,
		193,
		182,
		177,
		164,
		-1,
		-1,
		152,
		155,
		-1,
		-1,
		116,
		92,
		79,
		73,
		77,
		91,
		93,
		81,
		61,
		81,
		76,
		107,
		-1,
		235,
		234,
		223,
		220,
		196,
		187,
		182,
		209,
		-1,
		-1,
		204,
		225,
		215,
		219,
		224,
		249,
		-1,
		153,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		97,
		86,
		77,
		63,
		85,
		96,
		108,
		57,
		74,
		81,
		91,
		92,
		219,
		216,
		204,
		202,
		225,
		190,
		178,
		-1,
		191,
		189,
		195,
		202,
		219,
		238,
		-1,
		-1,
		169,
		149,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		74,
		60,
		87,
		68,
		66,
		60,
		54,
		61,
		78,
		91,
		85,
		228,
		242,
		231,
		227,
		226,
		234,
		183,
		176,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		159,
		155,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		74,
		60,
		56,
		56,
		57,
		52,
		63,
		68,
		72,
		79,
		-1,
		262,
		-1,
		214,
		190,
		204,
		219,
		227,
		-1,
		-1,
		-1,
		176,
		162,
		155,
		143,
		141,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		84,
		53,
		42,
		50,
		46,
		57,
		64,
		74,
		72,
		75,
		-1,
		-1,
		202,
		192,
		-1,
		-1,
		166,
		168,
		-1,
		167,
		156,
		141,
		133,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		80,
		54,
		51,
		48,
		47,
		42,
		54,
		50,
		62,
		77,
		69,
		-1,
		-1,
		187,
		179,
		173,
		-1,
		151,
		-1,
		169,
		-1,
		136,
		142,
		130,
		-1,
		-1,
		-1,
		118,
		81,
		102,
		61,
		24,
		22,
		37,
		38,
		45,
		55,
		63,
		69,
		-1,
		-1,
		-1,
		169,
		143,
		176,
		167,
		150,
		130,
		122,
		141,
		-1,
		111,
		-1,
		85,
		82,
		75,
		32,
		0,
		14,
		41,
		53,
		52,
		61,
		59,
		175,
		-1,
		145,
		178,
		142,
		136,
		112,
		116,
		132,
		-1,
		108,
		90,
		-1,
		101,
		82,
		37,
		23,
		39,
		39,
		46,
		60,
		56,
		-1,
		-1,
		-1,
		147,
		146,
		138,
		132,
		132,
		117,
		108,
		-1,
		120,
		102,
		81,
		96,
		81,
		72,
		72,
		27,
		23,
		49,
		51,
		51,
		-1,
		248,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		141,
		136,
		109,
		97,
		103,
		99,
		85,
		91,
		91,
		84,
		74,
		71,
		64,
		58,
		61,
		52,
		88,
		-1,
		243,
		-1,
		177,
		-1,
		-1,
		159,
		139,
		131,
		120,
		109,
		107,
		98,
		89,
		111,
		115,
		63,
		63,
		59,
		60,
		-1,
		232,
		231,
		-1,
		178,
		170,
		156,
		-1,
		149,
		-1,
		155,
		116,
		-1,
		118,
		98,
		-1,
		74,
		64,
		-1,
		-1,
		219,
		194,
		-1,
		-1,
		-1,
		179,
		159,
		150,
		134,
		-1,
		109,
		109,
		-1,
		-1,
		-1,
		204,
		203,
		-1,
		172,
		175,
		-1,
		165,
		156,
		164,
		111,
		115,
		-1,
		-1,
		-1,
		213,
		194,
		188,
		187,
		185,
		180,
		177,
		163,
		147,
		125,
		114,
		135,
		-1,
		-1,
		-1,
		185,
		177,
		170,
		-1,
		-1,
		172,
		155,
		136,
		134,
		-1,
		-1,
		-1,
		207,
		188,
		-1,
		-1,
		162,
		-1,
		-1,
		168,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		196,
		-1,
		-1,
		-1,
		158,
		154,
		155,
		-1,
		-1,
		-1,
		-1,
		218,
		219,
		242,
		206,
		-1,
		-1,
		-1,
		150,
		144,
		-1,
		-1,
		221,
		219,
		-1,
		-1,
		-1,
		178,
		162,
		-1,
		148,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		183,
		-1,
		183,
		158,
		165,
		-1,
		-1,
		-1,
		-1,
		196,
		188,
		196,
		-1,
		168,
		170,
		-1,
		218,
		-1,
		-1,
		211,
		202,
		-1,
		-1,
		173,
		180,
		202,
		205,
		241,
		-1,
		192
	],
	[
		-1,
		256,
		245,
		256,
		264,
		237,
		244,
		-1,
		263,
		267,
		233,
		227,
		266,
		235,
		241,
		252,
		-1,
		-1,
		-1,
		256,
		255,
		223,
		221,
		230,
		235,
		242,
		-1,
		241,
		-1,
		277,
		256,
		267,
		272,
		216,
		213,
		233,
		252,
		234,
		226,
		292,
		246,
		217,
		211,
		229,
		219,
		228,
		220,
		-1,
		217,
		207,
		229,
		208,
		219,
		211,
		-1,
		-1,
		211,
		212,
		218,
		204,
		210,
		206,
		-1,
		216,
		200,
		-1,
		-1,
		201,
		202,
		186,
		189,
		197,
		195,
		208,
		200,
		195,
		-1,
		-1,
		192,
		188,
		195,
		182,
		178,
		195,
		208,
		190,
		204,
		203,
		-1,
		196,
		214,
		221,
		189,
		187,
		171,
		169,
		187,
		189,
		195,
		195,
		-1,
		205,
		206,
		201,
		209,
		211,
		187,
		174,
		174,
		184,
		177,
		196,
		184,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		205,
		188,
		205,
		197,
		187,
		202,
		195,
		177,
		174,
		172,
		169,
		185,
		183,
		193,
		-1,
		-1,
		298,
		267,
		296,
		254,
		235,
		-1,
		201,
		181,
		187,
		191,
		185,
		178,
		192,
		188,
		-1,
		163,
		162,
		190,
		176,
		187,
		258,
		-1,
		-1,
		256,
		248,
		231,
		234,
		211,
		207,
		196,
		195,
		187,
		173,
		169,
		175,
		178,
		178,
		184,
		157,
		167,
		171,
		169,
		194,
		-1,
		-1,
		229,
		-1,
		-1,
		255,
		238,
		-1,
		221,
		228,
		217,
		223,
		209,
		230,
		206,
		197,
		189,
		183,
		171,
		173,
		170,
		183,
		171,
		154,
		179,
		183,
		164,
		185,
		180,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		214,
		217,
		223,
		247,
		246,
		-1,
		218,
		206,
		207,
		192,
		189,
		176,
		164,
		177,
		162,
		169,
		168,
		158,
		156,
		186,
		161,
		183,
		180,
		199,
		204,
		198,
		207,
		-1,
		263,
		259,
		255,
		262,
		211,
		-1,
		-1,
		251,
		-1,
		254,
		255,
		230,
		203,
		206,
		193,
		184,
		171,
		160,
		171,
		160,
		157,
		165,
		150,
		165,
		156,
		155,
		173,
		183,
		191,
		195,
		201,
		-1,
		313,
		-1,
		255,
		239,
		241,
		213,
		234,
		-1,
		271,
		255,
		247,
		232,
		232,
		-1,
		202,
		199,
		189,
		167,
		152,
		169,
		161,
		159,
		163,
		145,
		159,
		150,
		168,
		175,
		173,
		177,
		197,
		209,
		273,
		263,
		-1,
		245,
		250,
		209,
		217,
		236,
		274,
		238,
		-1,
		233,
		-1,
		204,
		217,
		-1,
		173,
		169,
		151,
		152,
		147,
		162,
		156,
		141,
		138,
		156,
		159,
		166,
		170,
		186,
		-1,
		-1,
		258,
		262,
		251,
		202,
		221,
		245,
		282,
		231,
		220,
		219,
		-1,
		210,
		187,
		184,
		172,
		159,
		144,
		145,
		153,
		166,
		145,
		140,
		137,
		157,
		183,
		161,
		173,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		228,
		199,
		223,
		265,
		249,
		242,
		230,
		195,
		195,
		189,
		-1,
		183,
		162,
		153,
		142,
		140,
		153,
		150,
		155,
		135,
		133,
		152,
		164,
		155,
		172,
		-1,
		-1,
		-1,
		258,
		247,
		248,
		194,
		217,
		254,
		228,
		214,
		219,
		194,
		187,
		181,
		196,
		179,
		160,
		149,
		141,
		130,
		146,
		154,
		149,
		131,
		140,
		146,
		170,
		160,
		166,
		-1,
		-1,
		265,
		255,
		239,
		241,
		238,
		208,
		215,
		247,
		219,
		232,
		-1,
		186,
		-1,
		175,
		170,
		154,
		149,
		146,
		143,
		137,
		146,
		148,
		138,
		133,
		140,
		175,
		175,
		150,
		170,
		173,
		-1,
		-1,
		-1,
		258,
		253,
		228,
		205,
		189,
		225,
		-1,
		202,
		203,
		-1,
		180,
		174,
		171,
		156,
		152,
		147,
		151,
		144,
		151,
		144,
		142,
		143,
		125,
		157,
		-1,
		158,
		152,
		160,
		150,
		138,
		-1,
		-1,
		-1,
		251,
		230,
		223,
		243,
		184,
		236,
		-1,
		-1,
		187,
		180,
		-1,
		167,
		149,
		156,
		154,
		148,
		152,
		149,
		138,
		151,
		144,
		130,
		132,
		145,
		149,
		153,
		140,
		136,
		133,
		147,
		-1,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		204,
		-1,
		196,
		188,
		178,
		172,
		166,
		162,
		160,
		176,
		160,
		163,
		161,
		152,
		160,
		133,
		126,
		133,
		122,
		140,
		148,
		140,
		134,
		133,
		143,
		-1,
		271,
		257,
		228,
		-1,
		-1,
		217,
		-1,
		181,
		195,
		211,
		-1,
		204,
		183,
		198,
		176,
		172,
		168,
		183,
		184,
		162,
		161,
		159,
		150,
		138,
		127,
		130,
		122,
		144,
		144,
		128,
		129,
		133,
		-1,
		277,
		264,
		222,
		218,
		207,
		227,
		178,
		166,
		198,
		-1,
		-1,
		240,
		-1,
		174,
		191,
		182,
		180,
		173,
		164,
		170,
		170,
		147,
		142,
		132,
		121,
		121,
		116,
		138,
		124,
		122,
		131,
		147,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		193,
		180,
		174,
		-1,
		215,
		-1,
		218,
		208,
		192,
		177,
		210,
		-1,
		170,
		165,
		170,
		-1,
		167,
		-1,
		140,
		137,
		128,
		113,
		110,
		121,
		119,
		130,
		126,
		-1,
		227,
		212,
		205,
		195,
		209,
		180,
		-1,
		235,
		-1,
		-1,
		205,
		199,
		199,
		183,
		186,
		186,
		166,
		158,
		170,
		162,
		154,
		148,
		126,
		119,
		116,
		109,
		122,
		132,
		137,
		124,
		-1,
		-1,
		-1,
		232,
		218,
		222,
		182,
		201,
		-1,
		-1,
		267,
		222,
		208,
		-1,
		192,
		186,
		174,
		164,
		154,
		159,
		160,
		145,
		138,
		124,
		126,
		120,
		111,
		110,
		126,
		118,
		140,
		-1,
		-1,
		215,
		220,
		208,
		194,
		213,
		-1,
		-1,
		-1,
		214,
		230,
		214,
		193,
		175,
		-1,
		-1,
		158,
		151,
		145,
		141,
		128,
		140,
		135,
		119,
		104,
		119,
		123,
		131,
		122,
		-1,
		218,
		205,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		-1,
		-1,
		226,
		171,
		160,
		155,
		159,
		157,
		-1,
		131,
		142,
		132,
		144,
		151,
		121,
		106,
		100,
		106,
		118,
		127,
		-1,
		-1,
		230,
		-1,
		213,
		-1,
		-1,
		-1,
		-1,
		183,
		177,
		148,
		141,
		145,
		-1,
		133,
		135,
		132,
		144,
		124,
		121,
		112,
		103,
		99,
		103,
		107,
		121,
		125,
		253,
		-1,
		204,
		-1,
		-1,
		-1,
		201,
		216,
		187,
		164,
		137,
		132,
		125,
		119,
		124,
		135,
		132,
		143,
		110,
		106,
		96,
		95,
		99,
		116,
		116,
		-1,
		-1,
		202,
		198,
		227,
		209,
		213,
		214,
		-1,
		-1,
		141,
		132,
		123,
		115,
		128,
		131,
		116,
		113,
		107,
		100,
		94,
		104,
		115,
		110,
		-1,
		-1,
		-1,
		214,
		-1,
		216,
		-1,
		-1,
		204,
		212,
		159,
		141,
		137,
		135,
		122,
		116,
		106,
		111,
		117,
		108,
		102,
		90,
		90,
		113,
		102,
		119,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		193,
		185,
		180,
		186,
		188,
		179,
		174,
		171,
		-1,
		141,
		145,
		112,
		119,
		102,
		109,
		112,
		104,
		84,
		87,
		103,
		102,
		97,
		111,
		102,
		106,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		186,
		182,
		172,
		162,
		165,
		-1,
		-1,
		159,
		156,
		136,
		105,
		110,
		103,
		98,
		103,
		84,
		80,
		80,
		75,
		90,
		95,
		97,
		90,
		97,
		112,
		-1,
		233,
		270,
		263,
		231,
		239,
		270,
		-1,
		176,
		168,
		179,
		154,
		156,
		-1,
		-1,
		132,
		123,
		124,
		112,
		109,
		122,
		118,
		88,
		85,
		95,
		73,
		80,
		91,
		83,
		87,
		88,
		95,
		106,
		110,
		-1,
		226,
		246,
		225,
		228,
		252,
		266,
		-1,
		173,
		-1,
		-1,
		176,
		157,
		141,
		131,
		128,
		171,
		118,
		113,
		90,
		88,
		85,
		76,
		97,
		81,
		69,
		66,
		75,
		80,
		72,
		98,
		100,
		97,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		166,
		-1,
		168,
		-1,
		151,
		155,
		126,
		129,
		104,
		91,
		77,
		77,
		83,
		81,
		77,
		73,
		62,
		71,
		82,
		94,
		104,
		106,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		185,
		224,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		165,
		139,
		131,
		124,
		103,
		103,
		69,
		65,
		78,
		82,
		87,
		79,
		63,
		75,
		88,
		99,
		105,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		200,
		191,
		218,
		179,
		168,
		163,
		150,
		-1,
		-1,
		146,
		149,
		-1,
		-1,
		110,
		86,
		73,
		67,
		71,
		85,
		87,
		75,
		55,
		75,
		70,
		101,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		219,
		209,
		212,
		210,
		235,
		-1,
		139,
		-1,
		-1,
		126,
		-1,
		-1,
		111,
		91,
		80,
		71,
		57,
		79,
		90,
		102,
		51,
		68,
		75,
		85,
		86,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		185,
		183,
		189,
		196,
		213,
		224,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		68,
		54,
		81,
		62,
		60,
		54,
		48,
		55,
		72,
		85,
		79,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		68,
		54,
		50,
		50,
		51,
		46,
		57,
		62,
		66,
		73,
		-1,
		256,
		-1,
		208,
		184,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		78,
		47,
		36,
		44,
		40,
		51,
		58,
		68,
		66,
		69,
		-1,
		-1,
		195,
		178,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		74,
		48,
		45,
		42,
		41,
		36,
		48,
		44,
		56,
		71,
		63,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		112,
		75,
		95,
		55,
		18,
		16,
		31,
		32,
		39,
		49,
		57,
		63,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		97,
		-1,
		72,
		75,
		69,
		26,
		14,
		0,
		35,
		41,
		46,
		55,
		53,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		94,
		76,
		-1,
		87,
		74,
		23,
		9,
		25,
		33,
		40,
		52,
		50,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		82,
		67,
		58,
		58,
		13,
		9,
		35,
		37,
		45,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		77,
		70,
		60,
		57,
		50,
		44,
		47,
		46,
		82,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		101,
		49,
		49,
		53,
		54,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		60,
		56,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		118,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		114,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		118,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		97,
		89,
		111,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		94,
		102,
		93,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		77,
		89,
		98,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		92,
		96,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		70,
		87,
		87,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		86,
		81,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		88,
		79,
		73,
		61,
		61,
		84,
		73,
		90,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		83,
		75,
		55,
		58,
		74,
		73,
		68,
		82,
		73,
		77,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		51,
		46,
		61,
		66,
		68,
		61,
		68,
		83,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		72,
		60,
		66,
		44,
		51,
		62,
		54,
		58,
		59,
		66,
		77,
		81,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		167,
		140,
		124,
		114,
		111,
		154,
		102,
		97,
		74,
		72,
		69,
		60,
		68,
		52,
		40,
		37,
		46,
		51,
		43,
		69,
		71,
		69,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		157,
		-1,
		151,
		-1,
		134,
		138,
		110,
		113,
		88,
		75,
		61,
		61,
		67,
		52,
		48,
		44,
		33,
		42,
		53,
		65,
		75,
		77,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		163,
		-1,
		147,
		-1,
		-1,
		-1,
		148,
		123,
		115,
		108,
		87,
		87,
		53,
		49,
		57,
		53,
		58,
		50,
		34,
		46,
		59,
		70,
		77,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		170,
		159,
		154,
		141,
		-1,
		-1,
		130,
		133,
		-1,
		-1,
		94,
		70,
		57,
		51,
		55,
		67,
		58,
		46,
		26,
		46,
		41,
		73,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		201,
		226,
		-1,
		130,
		-1,
		-1,
		110,
		-1,
		-1,
		95,
		75,
		64,
		55,
		41,
		63,
		62,
		73,
		22,
		39,
		46,
		56,
		58,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		215,
		-1,
		-1,
		146,
		126,
		-1,
		-1,
		93,
		91,
		80,
		-1,
		70,
		52,
		38,
		65,
		42,
		31,
		25,
		19,
		26,
		43,
		56,
		51,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		136,
		132,
		-1,
		-1,
		88,
		81,
		69,
		57,
		47,
		52,
		38,
		34,
		29,
		22,
		17,
		28,
		33,
		37,
		45,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		153,
		139,
		132,
		120,
		118,
		-1,
		122,
		106,
		87,
		-1,
		57,
		70,
		70,
		38,
		28,
		28,
		11,
		22,
		29,
		39,
		38,
		41,
		-1,
		-1,
		179,
		169,
		-1,
		-1,
		143,
		145,
		-1,
		144,
		133,
		118,
		110,
		-1,
		-1,
		94,
		90,
		-1,
		-1,
		58,
		52,
		41,
		34,
		32,
		7,
		19,
		15,
		27,
		42,
		35,
		-1,
		-1,
		164,
		156,
		150,
		-1,
		128,
		-1,
		146,
		-1,
		113,
		119,
		107,
		-1,
		-1,
		-1,
		96,
		59,
		80,
		59,
		26,
		24,
		13,
		3,
		10,
		20,
		28,
		35,
		-1,
		-1,
		-1,
		146,
		120,
		153,
		144,
		127,
		107,
		99,
		118,
		-1,
		88,
		-1,
		63,
		60,
		71,
		34,
		37,
		31,
		0,
		15,
		18,
		27,
		25,
		152,
		-1,
		122,
		155,
		119,
		113,
		89,
		93,
		109,
		-1,
		85,
		67,
		-1,
		78,
		65,
		52,
		37,
		18,
		5,
		12,
		26,
		22,
		-1,
		-1,
		-1,
		124,
		123,
		115,
		109,
		109,
		94,
		85,
		-1,
		97,
		79,
		58,
		73,
		58,
		49,
		49,
		42,
		38,
		25,
		25,
		17,
		-1,
		225,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		118,
		113,
		86,
		74,
		80,
		76,
		62,
		68,
		68,
		61,
		51,
		48,
		44,
		35,
		41,
		18,
		54,
		-1,
		220,
		-1,
		154,
		-1,
		-1,
		136,
		116,
		108,
		97,
		86,
		84,
		75,
		66,
		88,
		92,
		42,
		30,
		25,
		26,
		-1,
		209,
		208,
		-1,
		155,
		147,
		133,
		-1,
		126,
		-1,
		132,
		93,
		-1,
		95,
		75,
		-1,
		41,
		30,
		-1,
		-1,
		196,
		171,
		-1,
		-1,
		-1,
		156,
		136,
		127,
		111,
		-1,
		86,
		86,
		-1,
		-1,
		-1,
		181,
		180,
		-1,
		149,
		152,
		-1,
		142,
		133,
		141,
		88,
		92,
		-1,
		-1,
		-1,
		190,
		171,
		165,
		164,
		162,
		157,
		154,
		140,
		124,
		102,
		91,
		112,
		-1,
		-1,
		-1,
		162,
		154,
		147,
		-1,
		-1,
		149,
		132,
		113,
		111,
		-1,
		-1,
		-1,
		184,
		165,
		-1,
		-1,
		139,
		-1,
		-1,
		145,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		201,
		173,
		-1,
		-1,
		-1,
		135,
		131,
		132,
		-1,
		-1,
		-1,
		-1,
		195,
		196,
		219,
		183,
		-1,
		-1,
		-1,
		127,
		121,
		-1,
		-1,
		198,
		196,
		-1,
		-1,
		-1,
		155,
		139,
		-1,
		125,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		160,
		-1,
		160,
		135,
		142,
		-1,
		-1,
		-1,
		-1,
		173,
		165,
		173,
		-1,
		145,
		147,
		-1,
		195,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		150,
		157,
		179,
		182,
		218,
		-1,
		169
	],
	[
		-1,
		242,
		231,
		242,
		250,
		223,
		230,
		-1,
		249,
		253,
		219,
		213,
		252,
		221,
		227,
		238,
		-1,
		-1,
		-1,
		242,
		241,
		209,
		207,
		216,
		221,
		228,
		-1,
		227,
		-1,
		263,
		242,
		253,
		258,
		202,
		199,
		219,
		238,
		220,
		212,
		278,
		232,
		203,
		197,
		215,
		205,
		214,
		206,
		-1,
		203,
		193,
		215,
		194,
		205,
		197,
		-1,
		-1,
		197,
		198,
		204,
		190,
		196,
		192,
		-1,
		202,
		186,
		-1,
		-1,
		187,
		188,
		172,
		175,
		183,
		181,
		194,
		186,
		181,
		-1,
		-1,
		178,
		174,
		181,
		168,
		164,
		181,
		194,
		176,
		190,
		189,
		-1,
		182,
		200,
		207,
		175,
		173,
		157,
		155,
		173,
		175,
		181,
		181,
		-1,
		191,
		192,
		187,
		195,
		197,
		173,
		160,
		160,
		170,
		163,
		182,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		174,
		191,
		183,
		173,
		188,
		181,
		163,
		160,
		158,
		155,
		171,
		169,
		179,
		-1,
		-1,
		284,
		253,
		282,
		240,
		221,
		-1,
		187,
		167,
		173,
		177,
		171,
		164,
		178,
		174,
		-1,
		149,
		148,
		176,
		162,
		173,
		244,
		-1,
		-1,
		242,
		234,
		217,
		220,
		197,
		193,
		182,
		181,
		173,
		159,
		155,
		161,
		164,
		164,
		170,
		143,
		153,
		157,
		155,
		180,
		-1,
		-1,
		215,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		203,
		209,
		195,
		216,
		192,
		183,
		175,
		169,
		157,
		159,
		156,
		169,
		157,
		140,
		165,
		169,
		150,
		171,
		166,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		232,
		-1,
		204,
		192,
		193,
		178,
		175,
		162,
		150,
		163,
		148,
		155,
		154,
		144,
		142,
		172,
		147,
		169,
		166,
		185,
		190,
		184,
		193,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		240,
		241,
		216,
		189,
		192,
		179,
		170,
		157,
		146,
		157,
		146,
		143,
		151,
		136,
		151,
		142,
		141,
		159,
		169,
		177,
		181,
		187,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		241,
		233,
		218,
		218,
		-1,
		188,
		185,
		175,
		153,
		138,
		155,
		147,
		145,
		149,
		131,
		145,
		136,
		154,
		161,
		159,
		163,
		183,
		195,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		260,
		224,
		-1,
		219,
		-1,
		190,
		203,
		-1,
		159,
		155,
		137,
		138,
		133,
		148,
		142,
		127,
		124,
		142,
		145,
		152,
		156,
		172,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		217,
		206,
		205,
		-1,
		196,
		173,
		170,
		158,
		145,
		130,
		131,
		139,
		152,
		131,
		126,
		123,
		143,
		169,
		147,
		159,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		235,
		228,
		216,
		181,
		181,
		175,
		-1,
		169,
		148,
		139,
		128,
		126,
		139,
		136,
		141,
		121,
		119,
		138,
		150,
		141,
		158,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		180,
		203,
		240,
		214,
		200,
		205,
		180,
		173,
		167,
		182,
		165,
		146,
		135,
		127,
		116,
		132,
		140,
		135,
		117,
		126,
		132,
		156,
		146,
		152,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		194,
		201,
		233,
		205,
		218,
		-1,
		172,
		-1,
		161,
		156,
		140,
		135,
		132,
		129,
		123,
		132,
		134,
		124,
		119,
		126,
		161,
		161,
		136,
		156,
		159,
		-1,
		-1,
		-1,
		244,
		239,
		214,
		191,
		175,
		211,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		142,
		138,
		133,
		137,
		130,
		137,
		130,
		128,
		129,
		111,
		143,
		-1,
		144,
		138,
		146,
		136,
		124,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		142,
		140,
		134,
		138,
		135,
		124,
		137,
		130,
		116,
		118,
		131,
		135,
		139,
		126,
		122,
		119,
		133,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		162,
		146,
		149,
		147,
		138,
		146,
		119,
		112,
		119,
		108,
		126,
		134,
		126,
		120,
		119,
		129,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		190,
		169,
		184,
		162,
		158,
		154,
		169,
		170,
		148,
		147,
		145,
		136,
		124,
		113,
		116,
		108,
		130,
		130,
		114,
		115,
		119,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		152,
		184,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		168,
		166,
		159,
		150,
		156,
		156,
		133,
		128,
		118,
		107,
		107,
		102,
		124,
		110,
		108,
		117,
		133,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		161,
		151,
		156,
		-1,
		153,
		-1,
		126,
		123,
		114,
		99,
		96,
		107,
		105,
		116,
		112,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		221,
		-1,
		-1,
		191,
		185,
		185,
		169,
		172,
		177,
		157,
		149,
		156,
		148,
		140,
		134,
		112,
		105,
		102,
		95,
		108,
		118,
		123,
		110,
		-1,
		-1,
		-1,
		218,
		204,
		208,
		168,
		187,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		178,
		177,
		165,
		155,
		145,
		150,
		151,
		131,
		124,
		110,
		112,
		106,
		97,
		96,
		112,
		104,
		126,
		-1,
		-1,
		201,
		206,
		194,
		180,
		199,
		-1,
		-1,
		-1,
		200,
		216,
		205,
		179,
		166,
		-1,
		-1,
		149,
		142,
		136,
		127,
		114,
		126,
		121,
		105,
		90,
		105,
		109,
		117,
		108,
		-1,
		204,
		191,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		217,
		162,
		151,
		146,
		150,
		148,
		-1,
		122,
		133,
		118,
		130,
		137,
		107,
		92,
		86,
		92,
		104,
		113,
		-1,
		-1,
		216,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		174,
		168,
		139,
		132,
		136,
		-1,
		124,
		126,
		120,
		135,
		110,
		107,
		98,
		89,
		85,
		89,
		93,
		107,
		111,
		239,
		-1,
		198,
		-1,
		-1,
		-1,
		192,
		207,
		178,
		155,
		128,
		123,
		116,
		110,
		115,
		126,
		118,
		129,
		96,
		92,
		82,
		81,
		85,
		102,
		102,
		-1,
		-1,
		196,
		192,
		218,
		200,
		204,
		205,
		-1,
		-1,
		132,
		123,
		114,
		106,
		119,
		122,
		102,
		99,
		93,
		86,
		80,
		90,
		101,
		96,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		198,
		203,
		150,
		132,
		128,
		126,
		115,
		109,
		97,
		102,
		103,
		94,
		88,
		76,
		76,
		99,
		88,
		105,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		165,
		162,
		-1,
		132,
		138,
		103,
		110,
		93,
		100,
		98,
		90,
		70,
		73,
		89,
		88,
		83,
		97,
		88,
		92,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		153,
		150,
		130,
		99,
		101,
		94,
		89,
		97,
		78,
		66,
		66,
		61,
		76,
		81,
		83,
		76,
		83,
		98,
		-1,
		227,
		264,
		257,
		225,
		233,
		264,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		126,
		117,
		118,
		106,
		103,
		109,
		104,
		82,
		75,
		81,
		59,
		66,
		77,
		69,
		73,
		74,
		81,
		92,
		96,
		-1,
		220,
		240,
		219,
		222,
		246,
		260,
		-1,
		167,
		-1,
		-1,
		179,
		151,
		135,
		125,
		122,
		165,
		112,
		107,
		84,
		82,
		79,
		70,
		83,
		67,
		55,
		52,
		61,
		66,
		58,
		84,
		86,
		83,
		-1,
		209,
		220,
		213,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		171,
		-1,
		162,
		-1,
		145,
		149,
		120,
		123,
		98,
		85,
		71,
		71,
		77,
		67,
		63,
		59,
		48,
		57,
		68,
		80,
		90,
		92,
		234,
		190,
		193,
		204,
		215,
		230,
		234,
		-1,
		179,
		218,
		177,
		-1,
		161,
		-1,
		-1,
		-1,
		159,
		133,
		125,
		118,
		97,
		97,
		63,
		59,
		72,
		68,
		73,
		65,
		49,
		61,
		74,
		85,
		91,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		194,
		185,
		212,
		184,
		173,
		168,
		155,
		-1,
		-1,
		140,
		143,
		-1,
		-1,
		104,
		80,
		67,
		61,
		65,
		79,
		73,
		61,
		41,
		61,
		56,
		87,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		213,
		203,
		207,
		215,
		240,
		-1,
		144,
		-1,
		-1,
		120,
		-1,
		-1,
		105,
		85,
		74,
		65,
		51,
		73,
		77,
		88,
		37,
		54,
		61,
		70,
		72,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		207,
		229,
		-1,
		-1,
		160,
		140,
		-1,
		-1,
		103,
		101,
		90,
		-1,
		80,
		62,
		48,
		75,
		56,
		46,
		40,
		34,
		41,
		57,
		70,
		65,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		150,
		146,
		-1,
		-1,
		98,
		91,
		79,
		67,
		57,
		62,
		48,
		44,
		44,
		37,
		32,
		43,
		47,
		51,
		59,
		-1,
		250,
		-1,
		202,
		178,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		167,
		153,
		146,
		134,
		132,
		-1,
		132,
		116,
		97,
		-1,
		67,
		80,
		80,
		48,
		35,
		38,
		26,
		34,
		43,
		53,
		52,
		55,
		-1,
		-1,
		190,
		183,
		-1,
		-1,
		157,
		159,
		-1,
		158,
		147,
		132,
		124,
		-1,
		-1,
		104,
		100,
		-1,
		-1,
		68,
		62,
		51,
		41,
		40,
		22,
		30,
		30,
		41,
		56,
		49,
		-1,
		-1,
		178,
		170,
		164,
		-1,
		142,
		-1,
		160,
		-1,
		127,
		133,
		121,
		-1,
		-1,
		-1,
		106,
		69,
		90,
		69,
		33,
		31,
		20,
		18,
		25,
		34,
		41,
		49,
		-1,
		-1,
		-1,
		160,
		134,
		167,
		158,
		141,
		121,
		113,
		132,
		-1,
		102,
		-1,
		73,
		70,
		83,
		41,
		44,
		38,
		16,
		0,
		30,
		39,
		39,
		166,
		-1,
		136,
		169,
		133,
		127,
		103,
		107,
		123,
		-1,
		99,
		81,
		-1,
		92,
		79,
		57,
		42,
		23,
		19,
		26,
		39,
		36,
		-1,
		-1,
		-1,
		138,
		137,
		129,
		123,
		123,
		108,
		99,
		-1,
		111,
		93,
		72,
		87,
		72,
		63,
		63,
		47,
		43,
		30,
		30,
		31,
		-1,
		239,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		132,
		127,
		100,
		88,
		94,
		90,
		76,
		82,
		82,
		75,
		65,
		62,
		58,
		49,
		46,
		32,
		68,
		-1,
		234,
		-1,
		168,
		-1,
		-1,
		150,
		130,
		122,
		111,
		100,
		98,
		89,
		80,
		102,
		106,
		56,
		44,
		39,
		40,
		-1,
		223,
		222,
		-1,
		169,
		161,
		147,
		-1,
		140,
		-1,
		146,
		107,
		-1,
		109,
		89,
		-1,
		55,
		44,
		-1,
		-1,
		210,
		185,
		-1,
		-1,
		-1,
		170,
		150,
		141,
		125,
		-1,
		100,
		100,
		-1,
		-1,
		-1,
		195,
		194,
		-1,
		163,
		166,
		-1,
		156,
		147,
		155,
		102,
		106,
		-1,
		-1,
		-1,
		204,
		185,
		179,
		178,
		176,
		171,
		168,
		154,
		138,
		116,
		105,
		126,
		-1,
		-1,
		-1,
		176,
		168,
		161,
		-1,
		-1,
		163,
		146,
		127,
		125,
		-1,
		-1,
		-1,
		198,
		179,
		-1,
		-1,
		153,
		-1,
		-1,
		159,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		187,
		-1,
		-1,
		-1,
		149,
		145,
		146,
		-1,
		-1,
		-1,
		-1,
		209,
		210,
		233,
		197,
		-1,
		-1,
		-1,
		141,
		135,
		-1,
		-1,
		212,
		210,
		-1,
		-1,
		-1,
		169,
		153,
		-1,
		139,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		172,
		-1,
		-1,
		-1,
		174,
		-1,
		174,
		149,
		156,
		-1,
		-1,
		-1,
		-1,
		187,
		179,
		187,
		-1,
		159,
		161,
		-1,
		209,
		-1,
		-1,
		202,
		193,
		-1,
		-1,
		164,
		171,
		193,
		196,
		232,
		-1,
		183
	],
	[
		-1,
		236,
		225,
		236,
		244,
		217,
		224,
		-1,
		243,
		247,
		213,
		207,
		246,
		215,
		221,
		232,
		-1,
		-1,
		-1,
		236,
		235,
		203,
		201,
		210,
		215,
		222,
		-1,
		221,
		-1,
		257,
		236,
		247,
		252,
		196,
		193,
		213,
		232,
		214,
		206,
		272,
		226,
		197,
		191,
		209,
		199,
		208,
		200,
		-1,
		197,
		187,
		209,
		188,
		199,
		191,
		-1,
		-1,
		191,
		192,
		198,
		184,
		190,
		186,
		-1,
		196,
		180,
		-1,
		-1,
		181,
		182,
		166,
		169,
		177,
		175,
		188,
		180,
		175,
		-1,
		-1,
		172,
		168,
		175,
		162,
		158,
		175,
		188,
		170,
		184,
		183,
		-1,
		176,
		194,
		201,
		169,
		167,
		151,
		149,
		167,
		169,
		175,
		175,
		-1,
		185,
		186,
		181,
		189,
		191,
		167,
		154,
		154,
		164,
		157,
		176,
		164,
		210,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		185,
		168,
		185,
		177,
		167,
		182,
		175,
		157,
		154,
		152,
		149,
		165,
		163,
		173,
		-1,
		-1,
		278,
		247,
		276,
		234,
		215,
		-1,
		181,
		161,
		167,
		171,
		165,
		158,
		172,
		168,
		-1,
		143,
		142,
		170,
		156,
		167,
		238,
		-1,
		-1,
		236,
		228,
		211,
		214,
		191,
		187,
		176,
		175,
		167,
		153,
		149,
		155,
		158,
		158,
		164,
		137,
		147,
		151,
		149,
		174,
		-1,
		-1,
		209,
		-1,
		-1,
		235,
		218,
		-1,
		201,
		208,
		197,
		203,
		189,
		210,
		186,
		177,
		169,
		163,
		151,
		153,
		150,
		163,
		151,
		134,
		159,
		163,
		144,
		165,
		160,
		-1,
		208,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		194,
		197,
		203,
		227,
		226,
		-1,
		198,
		186,
		187,
		172,
		169,
		156,
		144,
		157,
		142,
		149,
		148,
		138,
		136,
		166,
		141,
		163,
		160,
		179,
		184,
		178,
		187,
		-1,
		243,
		239,
		235,
		242,
		191,
		-1,
		-1,
		231,
		-1,
		234,
		235,
		210,
		183,
		186,
		173,
		164,
		151,
		140,
		151,
		140,
		137,
		145,
		130,
		145,
		136,
		135,
		153,
		163,
		171,
		175,
		181,
		-1,
		293,
		-1,
		235,
		219,
		221,
		193,
		214,
		-1,
		251,
		235,
		227,
		212,
		212,
		-1,
		182,
		179,
		169,
		147,
		132,
		149,
		141,
		139,
		143,
		125,
		139,
		130,
		148,
		155,
		153,
		157,
		177,
		189,
		253,
		243,
		-1,
		225,
		230,
		189,
		197,
		216,
		254,
		218,
		-1,
		213,
		-1,
		184,
		197,
		-1,
		153,
		149,
		131,
		132,
		127,
		142,
		136,
		121,
		118,
		136,
		139,
		146,
		150,
		166,
		-1,
		-1,
		238,
		242,
		231,
		182,
		201,
		225,
		262,
		211,
		200,
		199,
		-1,
		190,
		167,
		164,
		152,
		139,
		124,
		125,
		133,
		146,
		125,
		120,
		117,
		137,
		163,
		141,
		153,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		208,
		179,
		203,
		245,
		229,
		222,
		210,
		175,
		175,
		169,
		-1,
		163,
		142,
		133,
		122,
		120,
		133,
		130,
		135,
		115,
		113,
		132,
		144,
		135,
		152,
		-1,
		-1,
		-1,
		238,
		227,
		228,
		174,
		197,
		234,
		208,
		194,
		199,
		174,
		167,
		161,
		176,
		159,
		140,
		129,
		121,
		110,
		126,
		134,
		129,
		111,
		120,
		126,
		150,
		140,
		146,
		-1,
		-1,
		245,
		235,
		219,
		221,
		218,
		188,
		195,
		227,
		199,
		212,
		-1,
		166,
		-1,
		155,
		150,
		134,
		129,
		126,
		123,
		117,
		126,
		128,
		118,
		113,
		120,
		155,
		155,
		130,
		150,
		153,
		-1,
		-1,
		-1,
		238,
		233,
		208,
		185,
		169,
		205,
		-1,
		182,
		183,
		-1,
		160,
		154,
		151,
		136,
		132,
		127,
		131,
		124,
		131,
		124,
		122,
		123,
		105,
		137,
		-1,
		138,
		132,
		140,
		130,
		118,
		-1,
		-1,
		-1,
		231,
		210,
		203,
		223,
		164,
		216,
		-1,
		-1,
		167,
		160,
		-1,
		147,
		129,
		136,
		134,
		128,
		132,
		129,
		118,
		131,
		124,
		110,
		112,
		125,
		129,
		133,
		120,
		116,
		113,
		127,
		-1,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		184,
		-1,
		176,
		168,
		158,
		152,
		146,
		142,
		140,
		156,
		140,
		143,
		141,
		132,
		140,
		113,
		106,
		113,
		102,
		120,
		128,
		120,
		114,
		113,
		123,
		-1,
		251,
		237,
		208,
		-1,
		-1,
		197,
		-1,
		161,
		175,
		191,
		-1,
		184,
		163,
		178,
		156,
		152,
		148,
		163,
		164,
		142,
		141,
		139,
		130,
		118,
		107,
		110,
		102,
		124,
		124,
		108,
		109,
		113,
		-1,
		257,
		244,
		202,
		198,
		187,
		207,
		158,
		146,
		178,
		-1,
		-1,
		220,
		-1,
		154,
		171,
		162,
		160,
		153,
		144,
		150,
		150,
		127,
		122,
		112,
		101,
		101,
		96,
		118,
		104,
		102,
		111,
		127,
		-1,
		-1,
		-1,
		224,
		-1,
		-1,
		173,
		160,
		154,
		-1,
		195,
		-1,
		198,
		188,
		172,
		157,
		190,
		-1,
		155,
		145,
		150,
		-1,
		147,
		-1,
		120,
		117,
		108,
		93,
		90,
		101,
		99,
		110,
		106,
		-1,
		207,
		192,
		185,
		175,
		189,
		160,
		-1,
		215,
		-1,
		-1,
		185,
		179,
		179,
		163,
		166,
		171,
		151,
		143,
		150,
		142,
		134,
		128,
		106,
		99,
		96,
		89,
		102,
		112,
		117,
		104,
		-1,
		-1,
		-1,
		212,
		198,
		202,
		162,
		181,
		-1,
		-1,
		247,
		202,
		188,
		-1,
		172,
		171,
		159,
		149,
		139,
		144,
		145,
		125,
		118,
		104,
		106,
		100,
		91,
		90,
		106,
		98,
		120,
		-1,
		-1,
		195,
		200,
		188,
		174,
		193,
		-1,
		-1,
		-1,
		194,
		210,
		199,
		173,
		160,
		-1,
		-1,
		143,
		136,
		130,
		121,
		108,
		120,
		115,
		99,
		84,
		99,
		103,
		111,
		102,
		-1,
		198,
		185,
		-1,
		-1,
		196,
		190,
		-1,
		-1,
		-1,
		-1,
		211,
		156,
		145,
		140,
		144,
		142,
		-1,
		116,
		127,
		112,
		124,
		131,
		101,
		86,
		80,
		86,
		98,
		107,
		-1,
		-1,
		210,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		168,
		162,
		133,
		126,
		130,
		-1,
		118,
		120,
		114,
		129,
		104,
		101,
		92,
		83,
		79,
		83,
		87,
		100,
		105,
		233,
		-1,
		196,
		-1,
		-1,
		-1,
		186,
		201,
		172,
		149,
		122,
		117,
		110,
		104,
		109,
		120,
		112,
		123,
		90,
		86,
		76,
		75,
		79,
		96,
		96,
		-1,
		-1,
		194,
		190,
		212,
		194,
		198,
		199,
		-1,
		-1,
		126,
		117,
		108,
		100,
		113,
		116,
		96,
		93,
		87,
		80,
		74,
		84,
		95,
		90,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		196,
		197,
		144,
		126,
		122,
		120,
		109,
		103,
		91,
		96,
		97,
		88,
		82,
		70,
		70,
		93,
		82,
		94,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		159,
		156,
		-1,
		126,
		132,
		97,
		104,
		87,
		94,
		92,
		84,
		64,
		67,
		83,
		82,
		77,
		86,
		77,
		85,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		151,
		148,
		128,
		97,
		95,
		88,
		83,
		93,
		73,
		60,
		60,
		55,
		70,
		75,
		77,
		70,
		76,
		91,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		124,
		115,
		116,
		104,
		101,
		103,
		98,
		89,
		69,
		75,
		53,
		60,
		71,
		63,
		67,
		68,
		63,
		76,
		80,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		165,
		-1,
		-1,
		177,
		149,
		133,
		123,
		120,
		163,
		118,
		113,
		93,
		91,
		86,
		77,
		77,
		61,
		49,
		46,
		55,
		60,
		52,
		73,
		69,
		62,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		168,
		-1,
		160,
		-1,
		143,
		147,
		126,
		129,
		107,
		94,
		80,
		77,
		86,
		61,
		57,
		53,
		42,
		39,
		51,
		55,
		65,
		78,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		177,
		216,
		174,
		-1,
		158,
		-1,
		-1,
		-1,
		157,
		139,
		131,
		127,
		106,
		106,
		72,
		68,
		66,
		62,
		69,
		59,
		49,
		38,
		49,
		60,
		70,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		192,
		183,
		210,
		181,
		170,
		165,
		152,
		-1,
		-1,
		149,
		149,
		-1,
		-1,
		113,
		89,
		76,
		70,
		73,
		76,
		84,
		68,
		48,
		37,
		31,
		63,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		211,
		201,
		205,
		212,
		237,
		-1,
		141,
		-1,
		-1,
		129,
		-1,
		-1,
		114,
		94,
		83,
		74,
		60,
		81,
		88,
		99,
		48,
		43,
		36,
		43,
		51,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		205,
		226,
		-1,
		-1,
		157,
		137,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		71,
		57,
		84,
		65,
		57,
		51,
		45,
		34,
		30,
		43,
		44,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		143,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		71,
		57,
		53,
		53,
		48,
		43,
		48,
		20,
		24,
		38,
		-1,
		248,
		-1,
		200,
		176,
		190,
		205,
		213,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		89,
		57,
		49,
		47,
		37,
		30,
		18,
		26,
		31,
		34,
		-1,
		-1,
		188,
		180,
		-1,
		-1,
		154,
		156,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		71,
		60,
		55,
		51,
		33,
		28,
		19,
		16,
		29,
		28,
		-1,
		-1,
		175,
		167,
		161,
		-1,
		139,
		-1,
		157,
		-1,
		124,
		130,
		118,
		-1,
		-1,
		-1,
		115,
		78,
		97,
		78,
		47,
		45,
		36,
		29,
		23,
		11,
		11,
		28,
		-1,
		-1,
		-1,
		157,
		131,
		164,
		155,
		138,
		118,
		110,
		129,
		-1,
		99,
		-1,
		74,
		77,
		82,
		55,
		58,
		52,
		26,
		37,
		0,
		9,
		18,
		163,
		-1,
		133,
		166,
		130,
		124,
		100,
		104,
		120,
		-1,
		96,
		78,
		-1,
		89,
		76,
		69,
		54,
		35,
		22,
		24,
		21,
		15,
		-1,
		-1,
		-1,
		135,
		134,
		126,
		120,
		120,
		105,
		96,
		-1,
		108,
		90,
		69,
		84,
		69,
		60,
		60,
		59,
		55,
		42,
		40,
		29,
		-1,
		236,
		-1,
		-1,
		158,
		-1,
		-1,
		-1,
		129,
		124,
		97,
		85,
		91,
		87,
		73,
		79,
		79,
		72,
		62,
		59,
		55,
		46,
		52,
		29,
		62,
		-1,
		231,
		-1,
		165,
		-1,
		-1,
		147,
		127,
		119,
		108,
		97,
		95,
		86,
		77,
		99,
		103,
		53,
		41,
		36,
		37,
		-1,
		220,
		219,
		-1,
		166,
		158,
		144,
		-1,
		137,
		-1,
		143,
		104,
		-1,
		106,
		86,
		-1,
		52,
		41,
		-1,
		-1,
		207,
		182,
		-1,
		-1,
		-1,
		167,
		147,
		138,
		122,
		-1,
		97,
		97,
		-1,
		-1,
		-1,
		192,
		191,
		-1,
		160,
		163,
		-1,
		153,
		144,
		152,
		99,
		103,
		-1,
		-1,
		-1,
		201,
		182,
		176,
		175,
		173,
		168,
		165,
		151,
		135,
		113,
		102,
		123,
		-1,
		-1,
		-1,
		173,
		165,
		158,
		-1,
		-1,
		160,
		143,
		124,
		122,
		-1,
		-1,
		-1,
		195,
		176,
		-1,
		-1,
		150,
		-1,
		-1,
		156,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		184,
		-1,
		-1,
		-1,
		146,
		142,
		143,
		-1,
		-1,
		-1,
		-1,
		206,
		207,
		230,
		194,
		-1,
		-1,
		-1,
		138,
		132,
		-1,
		-1,
		209,
		207,
		-1,
		-1,
		-1,
		166,
		150,
		-1,
		136,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		171,
		-1,
		171,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		184,
		176,
		184,
		-1,
		156,
		158,
		-1,
		206,
		-1,
		-1,
		199,
		190,
		-1,
		-1,
		161,
		168,
		190,
		193,
		229,
		-1,
		180
	],
	[
		-1,
		227,
		216,
		227,
		235,
		208,
		215,
		-1,
		234,
		238,
		204,
		198,
		237,
		206,
		212,
		223,
		-1,
		-1,
		-1,
		227,
		226,
		194,
		192,
		201,
		206,
		213,
		-1,
		212,
		-1,
		248,
		227,
		238,
		243,
		187,
		184,
		204,
		223,
		205,
		197,
		263,
		217,
		188,
		182,
		200,
		190,
		199,
		191,
		-1,
		188,
		178,
		200,
		179,
		190,
		182,
		-1,
		-1,
		182,
		183,
		189,
		175,
		181,
		177,
		-1,
		187,
		171,
		-1,
		-1,
		172,
		173,
		157,
		160,
		168,
		166,
		179,
		171,
		166,
		-1,
		-1,
		163,
		159,
		166,
		153,
		149,
		166,
		179,
		161,
		175,
		174,
		-1,
		167,
		185,
		192,
		160,
		158,
		142,
		140,
		158,
		160,
		166,
		166,
		-1,
		176,
		177,
		172,
		180,
		182,
		158,
		145,
		145,
		155,
		148,
		167,
		155,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		176,
		159,
		176,
		168,
		158,
		173,
		166,
		148,
		145,
		143,
		140,
		156,
		154,
		164,
		-1,
		-1,
		269,
		238,
		267,
		225,
		206,
		-1,
		172,
		152,
		158,
		162,
		156,
		149,
		163,
		159,
		-1,
		134,
		133,
		161,
		147,
		158,
		229,
		-1,
		-1,
		227,
		219,
		202,
		205,
		182,
		178,
		167,
		166,
		158,
		144,
		140,
		146,
		149,
		149,
		155,
		128,
		138,
		142,
		140,
		165,
		-1,
		-1,
		200,
		-1,
		-1,
		226,
		209,
		-1,
		192,
		199,
		188,
		194,
		180,
		201,
		177,
		168,
		160,
		154,
		142,
		144,
		141,
		154,
		142,
		125,
		150,
		154,
		135,
		156,
		151,
		-1,
		199,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		185,
		188,
		194,
		218,
		217,
		-1,
		189,
		177,
		178,
		163,
		160,
		147,
		135,
		148,
		133,
		140,
		139,
		129,
		127,
		157,
		132,
		154,
		151,
		170,
		175,
		169,
		178,
		-1,
		234,
		230,
		226,
		233,
		182,
		-1,
		-1,
		222,
		-1,
		225,
		226,
		201,
		174,
		177,
		164,
		155,
		142,
		131,
		142,
		131,
		128,
		136,
		121,
		136,
		127,
		126,
		144,
		154,
		162,
		166,
		172,
		-1,
		284,
		-1,
		226,
		210,
		212,
		184,
		205,
		-1,
		242,
		226,
		218,
		203,
		203,
		-1,
		173,
		170,
		160,
		138,
		123,
		140,
		132,
		130,
		134,
		116,
		130,
		121,
		139,
		146,
		144,
		148,
		168,
		180,
		244,
		234,
		-1,
		216,
		221,
		180,
		188,
		207,
		245,
		209,
		-1,
		204,
		-1,
		175,
		188,
		-1,
		144,
		140,
		122,
		123,
		118,
		133,
		127,
		112,
		109,
		127,
		130,
		137,
		141,
		157,
		-1,
		-1,
		229,
		233,
		222,
		173,
		192,
		216,
		253,
		202,
		191,
		190,
		-1,
		181,
		158,
		155,
		143,
		130,
		115,
		116,
		124,
		137,
		116,
		111,
		108,
		128,
		154,
		132,
		144,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		199,
		170,
		194,
		236,
		220,
		213,
		201,
		166,
		166,
		160,
		-1,
		154,
		133,
		124,
		113,
		111,
		124,
		121,
		126,
		106,
		104,
		123,
		135,
		126,
		143,
		-1,
		-1,
		-1,
		229,
		218,
		219,
		165,
		188,
		225,
		199,
		185,
		190,
		165,
		158,
		152,
		167,
		150,
		131,
		120,
		112,
		101,
		117,
		125,
		120,
		102,
		111,
		117,
		141,
		131,
		137,
		-1,
		-1,
		236,
		226,
		210,
		212,
		209,
		179,
		186,
		218,
		190,
		203,
		-1,
		157,
		-1,
		146,
		141,
		125,
		120,
		117,
		114,
		108,
		117,
		119,
		109,
		104,
		111,
		146,
		146,
		121,
		141,
		144,
		-1,
		-1,
		-1,
		229,
		224,
		199,
		176,
		160,
		196,
		-1,
		173,
		174,
		-1,
		151,
		145,
		142,
		127,
		123,
		118,
		122,
		115,
		122,
		115,
		113,
		114,
		96,
		128,
		-1,
		129,
		123,
		131,
		121,
		109,
		-1,
		-1,
		-1,
		222,
		201,
		194,
		214,
		155,
		207,
		-1,
		-1,
		158,
		151,
		-1,
		138,
		120,
		127,
		125,
		119,
		123,
		120,
		109,
		122,
		115,
		101,
		103,
		116,
		120,
		124,
		111,
		107,
		104,
		118,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		175,
		-1,
		167,
		159,
		149,
		143,
		137,
		133,
		131,
		147,
		131,
		134,
		132,
		123,
		131,
		104,
		97,
		104,
		93,
		111,
		119,
		111,
		105,
		104,
		114,
		-1,
		242,
		228,
		199,
		-1,
		-1,
		188,
		-1,
		152,
		166,
		182,
		-1,
		175,
		154,
		169,
		147,
		143,
		139,
		154,
		155,
		133,
		132,
		130,
		121,
		109,
		98,
		101,
		93,
		115,
		115,
		99,
		100,
		104,
		-1,
		248,
		235,
		193,
		189,
		178,
		198,
		149,
		137,
		169,
		-1,
		-1,
		211,
		-1,
		145,
		162,
		153,
		151,
		144,
		135,
		141,
		141,
		118,
		113,
		103,
		92,
		92,
		87,
		109,
		95,
		93,
		102,
		118,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		164,
		151,
		145,
		-1,
		186,
		-1,
		189,
		179,
		163,
		148,
		181,
		-1,
		146,
		136,
		141,
		-1,
		138,
		-1,
		111,
		108,
		99,
		84,
		81,
		92,
		90,
		101,
		97,
		-1,
		198,
		183,
		176,
		166,
		180,
		151,
		-1,
		206,
		-1,
		-1,
		176,
		170,
		170,
		154,
		157,
		162,
		142,
		134,
		141,
		133,
		125,
		119,
		97,
		90,
		87,
		80,
		93,
		103,
		108,
		95,
		-1,
		-1,
		-1,
		203,
		189,
		193,
		153,
		172,
		-1,
		-1,
		238,
		193,
		179,
		-1,
		163,
		162,
		150,
		140,
		130,
		135,
		136,
		116,
		109,
		95,
		97,
		91,
		82,
		81,
		97,
		89,
		111,
		-1,
		-1,
		186,
		191,
		179,
		165,
		184,
		-1,
		-1,
		-1,
		185,
		201,
		190,
		164,
		151,
		-1,
		-1,
		134,
		127,
		121,
		112,
		99,
		111,
		106,
		90,
		75,
		90,
		94,
		102,
		93,
		-1,
		189,
		176,
		-1,
		-1,
		187,
		181,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		103,
		115,
		122,
		92,
		77,
		71,
		77,
		89,
		98,
		-1,
		-1,
		201,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		105,
		120,
		95,
		92,
		83,
		74,
		70,
		74,
		78,
		91,
		96,
		224,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		103,
		114,
		81,
		77,
		67,
		66,
		70,
		87,
		87,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		87,
		84,
		78,
		71,
		65,
		75,
		86,
		81,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		88,
		79,
		73,
		61,
		61,
		84,
		73,
		85,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		83,
		75,
		55,
		58,
		74,
		73,
		68,
		77,
		68,
		76,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		64,
		51,
		51,
		46,
		61,
		66,
		68,
		61,
		67,
		82,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		94,
		89,
		80,
		60,
		66,
		44,
		51,
		62,
		54,
		58,
		59,
		54,
		67,
		71,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		168,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		88,
		86,
		77,
		68,
		68,
		52,
		40,
		37,
		46,
		51,
		43,
		64,
		60,
		53,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		160,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		102,
		89,
		81,
		68,
		77,
		52,
		48,
		44,
		33,
		30,
		42,
		46,
		56,
		69,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		122,
		101,
		101,
		75,
		71,
		57,
		53,
		60,
		50,
		40,
		29,
		40,
		51,
		61,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		173,
		162,
		157,
		144,
		-1,
		-1,
		152,
		140,
		-1,
		-1,
		108,
		92,
		79,
		68,
		64,
		67,
		75,
		59,
		39,
		28,
		22,
		54,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		196,
		204,
		229,
		-1,
		133,
		-1,
		-1,
		132,
		-1,
		-1,
		117,
		97,
		86,
		77,
		63,
		72,
		79,
		90,
		42,
		34,
		27,
		34,
		42,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		196,
		218,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		115,
		113,
		102,
		-1,
		92,
		74,
		60,
		87,
		62,
		51,
		45,
		39,
		25,
		21,
		34,
		35,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		110,
		103,
		91,
		79,
		69,
		74,
		60,
		56,
		49,
		42,
		37,
		39,
		11,
		15,
		29,
		-1,
		239,
		-1,
		191,
		167,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		144,
		128,
		109,
		-1,
		79,
		92,
		92,
		60,
		52,
		50,
		35,
		28,
		9,
		17,
		22,
		25,
		-1,
		-1,
		179,
		172,
		-1,
		-1,
		146,
		148,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		116,
		112,
		-1,
		-1,
		79,
		74,
		63,
		58,
		54,
		32,
		26,
		17,
		7,
		20,
		19,
		-1,
		-1,
		167,
		159,
		153,
		-1,
		131,
		-1,
		149,
		-1,
		116,
		122,
		110,
		-1,
		-1,
		-1,
		110,
		73,
		89,
		81,
		50,
		48,
		39,
		28,
		21,
		9,
		2,
		19,
		-1,
		-1,
		-1,
		149,
		123,
		156,
		147,
		130,
		110,
		102,
		121,
		-1,
		91,
		-1,
		66,
		69,
		74,
		58,
		61,
		55,
		29,
		42,
		9,
		0,
		9,
		155,
		-1,
		125,
		158,
		122,
		116,
		92,
		96,
		112,
		-1,
		88,
		70,
		-1,
		81,
		68,
		72,
		57,
		38,
		25,
		28,
		13,
		6,
		-1,
		-1,
		-1,
		127,
		126,
		118,
		112,
		112,
		97,
		88,
		-1,
		100,
		82,
		61,
		76,
		61,
		52,
		52,
		62,
		58,
		45,
		43,
		22,
		-1,
		228,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		121,
		116,
		89,
		77,
		83,
		79,
		65,
		71,
		71,
		64,
		54,
		51,
		47,
		38,
		44,
		21,
		54,
		-1,
		223,
		-1,
		157,
		-1,
		-1,
		139,
		119,
		111,
		100,
		89,
		87,
		78,
		69,
		91,
		95,
		45,
		33,
		28,
		29,
		-1,
		212,
		211,
		-1,
		158,
		150,
		136,
		-1,
		129,
		-1,
		135,
		96,
		-1,
		98,
		78,
		-1,
		44,
		33,
		-1,
		-1,
		199,
		174,
		-1,
		-1,
		-1,
		159,
		139,
		130,
		114,
		-1,
		89,
		89,
		-1,
		-1,
		-1,
		184,
		183,
		-1,
		152,
		155,
		-1,
		145,
		136,
		144,
		91,
		95,
		-1,
		-1,
		-1,
		193,
		174,
		168,
		167,
		165,
		160,
		157,
		143,
		127,
		105,
		94,
		115,
		-1,
		-1,
		-1,
		165,
		157,
		150,
		-1,
		-1,
		152,
		135,
		116,
		114,
		-1,
		-1,
		-1,
		187,
		168,
		-1,
		-1,
		142,
		-1,
		-1,
		148,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		176,
		-1,
		-1,
		-1,
		138,
		134,
		135,
		-1,
		-1,
		-1,
		-1,
		198,
		199,
		222,
		186,
		-1,
		-1,
		-1,
		130,
		124,
		-1,
		-1,
		201,
		199,
		-1,
		-1,
		-1,
		158,
		142,
		-1,
		128,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		161,
		-1,
		-1,
		-1,
		163,
		-1,
		163,
		138,
		145,
		-1,
		-1,
		-1,
		-1,
		176,
		168,
		176,
		-1,
		148,
		150,
		-1,
		198,
		-1,
		-1,
		191,
		182,
		-1,
		-1,
		153,
		160,
		182,
		185,
		221,
		-1,
		172
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		248,
		252,
		218,
		212,
		251,
		220,
		226,
		237,
		-1,
		-1,
		-1,
		241,
		240,
		208,
		206,
		215,
		220,
		227,
		-1,
		226,
		-1,
		262,
		241,
		252,
		257,
		201,
		198,
		218,
		237,
		219,
		211,
		277,
		231,
		202,
		196,
		214,
		204,
		213,
		205,
		-1,
		202,
		192,
		214,
		193,
		204,
		196,
		-1,
		-1,
		196,
		197,
		203,
		189,
		195,
		191,
		-1,
		201,
		185,
		-1,
		-1,
		186,
		187,
		171,
		174,
		182,
		180,
		193,
		185,
		180,
		-1,
		-1,
		177,
		173,
		180,
		167,
		163,
		180,
		193,
		175,
		189,
		188,
		-1,
		181,
		199,
		206,
		174,
		172,
		156,
		154,
		172,
		174,
		180,
		180,
		-1,
		190,
		191,
		186,
		194,
		196,
		172,
		159,
		159,
		169,
		162,
		181,
		169,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		190,
		173,
		190,
		182,
		172,
		187,
		180,
		162,
		159,
		157,
		154,
		170,
		168,
		178,
		-1,
		-1,
		283,
		252,
		281,
		239,
		220,
		-1,
		186,
		166,
		172,
		176,
		170,
		163,
		177,
		173,
		-1,
		148,
		147,
		175,
		161,
		172,
		243,
		-1,
		-1,
		241,
		233,
		216,
		219,
		196,
		192,
		181,
		180,
		172,
		158,
		154,
		160,
		163,
		163,
		169,
		142,
		152,
		156,
		154,
		179,
		-1,
		-1,
		214,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		202,
		208,
		194,
		215,
		191,
		182,
		174,
		168,
		156,
		158,
		155,
		168,
		156,
		139,
		164,
		168,
		149,
		170,
		165,
		-1,
		213,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		231,
		-1,
		203,
		191,
		192,
		177,
		174,
		161,
		149,
		162,
		147,
		154,
		153,
		143,
		141,
		171,
		146,
		168,
		165,
		184,
		189,
		183,
		192,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		239,
		240,
		215,
		188,
		191,
		178,
		169,
		156,
		145,
		156,
		145,
		142,
		150,
		135,
		150,
		141,
		140,
		158,
		168,
		176,
		180,
		186,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		240,
		232,
		217,
		217,
		-1,
		187,
		184,
		174,
		152,
		137,
		154,
		146,
		144,
		148,
		130,
		144,
		135,
		153,
		160,
		158,
		162,
		182,
		194,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		259,
		223,
		-1,
		218,
		-1,
		189,
		202,
		-1,
		158,
		154,
		136,
		137,
		132,
		147,
		141,
		126,
		123,
		141,
		144,
		151,
		155,
		171,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		216,
		205,
		204,
		-1,
		195,
		172,
		169,
		157,
		144,
		129,
		130,
		138,
		151,
		130,
		125,
		122,
		142,
		168,
		146,
		158,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		234,
		227,
		215,
		180,
		180,
		174,
		-1,
		168,
		147,
		138,
		127,
		125,
		138,
		135,
		140,
		120,
		118,
		137,
		149,
		140,
		157,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		179,
		202,
		239,
		213,
		199,
		204,
		179,
		172,
		166,
		181,
		164,
		145,
		134,
		126,
		115,
		131,
		139,
		134,
		116,
		125,
		131,
		155,
		145,
		151,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		193,
		200,
		232,
		204,
		217,
		-1,
		171,
		-1,
		160,
		155,
		139,
		134,
		131,
		128,
		122,
		131,
		133,
		123,
		118,
		125,
		160,
		160,
		135,
		155,
		158,
		-1,
		-1,
		-1,
		243,
		238,
		213,
		190,
		174,
		210,
		-1,
		187,
		188,
		-1,
		165,
		159,
		156,
		141,
		137,
		132,
		136,
		129,
		136,
		129,
		127,
		128,
		110,
		142,
		-1,
		143,
		137,
		145,
		135,
		123,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		172,
		165,
		-1,
		152,
		134,
		141,
		139,
		133,
		137,
		134,
		123,
		136,
		129,
		115,
		117,
		130,
		134,
		138,
		125,
		121,
		118,
		132,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		181,
		173,
		163,
		157,
		151,
		147,
		145,
		161,
		145,
		148,
		146,
		137,
		145,
		118,
		111,
		118,
		107,
		125,
		133,
		125,
		119,
		118,
		128,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		180,
		196,
		-1,
		189,
		168,
		183,
		161,
		157,
		153,
		168,
		169,
		147,
		146,
		144,
		135,
		123,
		112,
		115,
		107,
		129,
		129,
		113,
		114,
		118,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		151,
		183,
		-1,
		-1,
		225,
		-1,
		159,
		176,
		167,
		165,
		158,
		149,
		155,
		155,
		132,
		127,
		117,
		106,
		106,
		101,
		123,
		109,
		107,
		116,
		117,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		203,
		193,
		177,
		162,
		195,
		-1,
		160,
		150,
		155,
		-1,
		152,
		-1,
		125,
		122,
		113,
		98,
		95,
		106,
		104,
		115,
		111,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		220,
		-1,
		-1,
		190,
		184,
		184,
		168,
		171,
		176,
		156,
		148,
		155,
		147,
		139,
		133,
		111,
		104,
		101,
		94,
		107,
		117,
		122,
		109,
		-1,
		-1,
		-1,
		217,
		203,
		207,
		167,
		186,
		-1,
		-1,
		252,
		207,
		193,
		-1,
		177,
		176,
		164,
		154,
		144,
		149,
		150,
		130,
		123,
		109,
		111,
		105,
		96,
		95,
		111,
		103,
		125,
		-1,
		-1,
		200,
		205,
		193,
		179,
		198,
		-1,
		-1,
		-1,
		199,
		215,
		204,
		178,
		165,
		-1,
		-1,
		148,
		141,
		135,
		126,
		113,
		125,
		120,
		104,
		89,
		104,
		108,
		116,
		107,
		-1,
		203,
		190,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		-1,
		-1,
		216,
		161,
		150,
		145,
		149,
		147,
		-1,
		121,
		132,
		117,
		129,
		136,
		106,
		91,
		85,
		91,
		103,
		104,
		-1,
		-1,
		215,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		173,
		167,
		138,
		131,
		135,
		-1,
		123,
		125,
		119,
		134,
		109,
		106,
		97,
		88,
		84,
		88,
		92,
		89,
		95,
		238,
		-1,
		201,
		-1,
		-1,
		-1,
		191,
		206,
		177,
		154,
		127,
		122,
		115,
		109,
		114,
		125,
		117,
		128,
		95,
		91,
		81,
		80,
		84,
		93,
		93,
		-1,
		-1,
		199,
		195,
		217,
		199,
		203,
		204,
		-1,
		-1,
		131,
		122,
		113,
		105,
		118,
		121,
		101,
		98,
		92,
		85,
		79,
		89,
		92,
		87,
		-1,
		-1,
		-1,
		211,
		-1,
		213,
		-1,
		-1,
		201,
		202,
		149,
		131,
		127,
		125,
		114,
		108,
		96,
		101,
		102,
		93,
		87,
		75,
		75,
		98,
		79,
		83,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		190,
		182,
		177,
		183,
		185,
		176,
		164,
		161,
		-1,
		131,
		137,
		102,
		109,
		92,
		99,
		97,
		89,
		69,
		72,
		88,
		82,
		70,
		75,
		66,
		74,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		183,
		179,
		169,
		159,
		162,
		-1,
		-1,
		156,
		153,
		133,
		102,
		100,
		93,
		88,
		98,
		78,
		65,
		65,
		60,
		73,
		72,
		67,
		60,
		65,
		80,
		-1,
		230,
		267,
		260,
		228,
		236,
		267,
		-1,
		173,
		165,
		176,
		151,
		153,
		-1,
		-1,
		129,
		120,
		121,
		109,
		106,
		108,
		103,
		94,
		74,
		80,
		58,
		65,
		76,
		68,
		72,
		63,
		52,
		65,
		69,
		-1,
		223,
		243,
		222,
		225,
		249,
		263,
		-1,
		170,
		-1,
		-1,
		173,
		154,
		138,
		128,
		125,
		168,
		123,
		118,
		99,
		97,
		91,
		82,
		82,
		66,
		54,
		51,
		60,
		65,
		57,
		62,
		58,
		51,
		-1,
		212,
		223,
		216,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		163,
		-1,
		165,
		-1,
		148,
		152,
		131,
		134,
		113,
		100,
		86,
		82,
		91,
		66,
		62,
		58,
		47,
		44,
		56,
		60,
		69,
		67,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		182,
		221,
		169,
		-1,
		153,
		-1,
		-1,
		-1,
		162,
		144,
		136,
		133,
		112,
		112,
		78,
		74,
		71,
		67,
		74,
		64,
		54,
		43,
		54,
		60,
		59,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		197,
		188,
		215,
		176,
		165,
		160,
		147,
		-1,
		-1,
		155,
		154,
		-1,
		-1,
		119,
		95,
		82,
		76,
		78,
		81,
		89,
		73,
		53,
		42,
		36,
		55,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		216,
		206,
		209,
		207,
		232,
		-1,
		136,
		-1,
		-1,
		135,
		-1,
		-1,
		120,
		100,
		89,
		80,
		66,
		86,
		93,
		104,
		54,
		48,
		41,
		48,
		40,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		210,
		221,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		118,
		116,
		105,
		-1,
		95,
		77,
		63,
		90,
		71,
		63,
		57,
		51,
		39,
		35,
		41,
		33,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		113,
		106,
		94,
		82,
		72,
		77,
		63,
		59,
		59,
		54,
		49,
		53,
		25,
		29,
		27,
		-1,
		253,
		-1,
		205,
		181,
		195,
		210,
		218,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		147,
		131,
		112,
		-1,
		82,
		95,
		95,
		63,
		55,
		53,
		43,
		42,
		23,
		31,
		20,
		23,
		-1,
		-1,
		192,
		175,
		-1,
		-1,
		149,
		151,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		119,
		115,
		-1,
		-1,
		82,
		77,
		66,
		61,
		57,
		39,
		40,
		31,
		21,
		24,
		17,
		-1,
		-1,
		170,
		162,
		156,
		-1,
		134,
		-1,
		152,
		-1,
		119,
		125,
		113,
		-1,
		-1,
		-1,
		113,
		76,
		92,
		84,
		53,
		51,
		42,
		35,
		35,
		23,
		16,
		10,
		-1,
		-1,
		-1,
		152,
		126,
		159,
		150,
		133,
		113,
		105,
		124,
		-1,
		94,
		-1,
		69,
		72,
		77,
		61,
		64,
		58,
		32,
		45,
		18,
		14,
		0,
		158,
		-1,
		128,
		161,
		125,
		119,
		95,
		99,
		115,
		-1,
		91,
		73,
		-1,
		84,
		71,
		75,
		60,
		41,
		28,
		31,
		16,
		9,
		-1,
		-1,
		-1,
		130,
		129,
		121,
		115,
		115,
		100,
		91,
		-1,
		103,
		85,
		64,
		79,
		64,
		55,
		55,
		65,
		61,
		48,
		46,
		25,
		-1,
		231,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		124,
		119,
		92,
		80,
		86,
		82,
		68,
		74,
		74,
		67,
		57,
		54,
		50,
		41,
		47,
		24,
		57,
		-1,
		226,
		-1,
		160,
		-1,
		-1,
		142,
		122,
		114,
		103,
		92,
		90,
		81,
		72,
		94,
		98,
		48,
		36,
		31,
		32,
		-1,
		215,
		214,
		-1,
		161,
		153,
		139,
		-1,
		132,
		-1,
		138,
		99,
		-1,
		101,
		81,
		-1,
		47,
		36,
		-1,
		-1,
		202,
		177,
		-1,
		-1,
		-1,
		162,
		142,
		133,
		117,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		187,
		186,
		-1,
		155,
		158,
		-1,
		148,
		139,
		147,
		94,
		98,
		-1,
		-1,
		-1,
		196,
		177,
		171,
		170,
		168,
		163,
		160,
		146,
		130,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		168,
		160,
		153,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		190,
		171,
		-1,
		-1,
		145,
		-1,
		-1,
		151,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		179,
		-1,
		-1,
		-1,
		141,
		137,
		138,
		-1,
		-1,
		-1,
		-1,
		201,
		202,
		225,
		189,
		-1,
		-1,
		-1,
		133,
		127,
		-1,
		-1,
		204,
		202,
		-1,
		-1,
		-1,
		161,
		145,
		-1,
		131,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		166,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		179,
		171,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		194,
		185,
		-1,
		-1,
		156,
		163,
		185,
		188,
		224,
		-1,
		175
	],
	[
		-1,
		319,
		308,
		319,
		327,
		300,
		307,
		-1,
		326,
		330,
		296,
		290,
		329,
		298,
		304,
		315,
		-1,
		-1,
		-1,
		319,
		318,
		286,
		284,
		293,
		298,
		305,
		-1,
		304,
		-1,
		340,
		319,
		330,
		335,
		279,
		276,
		296,
		315,
		297,
		289,
		355,
		309,
		280,
		274,
		292,
		282,
		291,
		283,
		-1,
		280,
		270,
		292,
		271,
		282,
		274,
		-1,
		-1,
		274,
		275,
		281,
		267,
		273,
		269,
		-1,
		279,
		263,
		-1,
		-1,
		264,
		265,
		249,
		252,
		260,
		258,
		271,
		263,
		258,
		-1,
		-1,
		255,
		251,
		258,
		245,
		241,
		258,
		271,
		253,
		267,
		266,
		-1,
		259,
		277,
		284,
		252,
		250,
		234,
		232,
		250,
		252,
		258,
		258,
		-1,
		268,
		269,
		264,
		272,
		274,
		250,
		237,
		237,
		247,
		240,
		259,
		247,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		268,
		251,
		268,
		260,
		250,
		265,
		258,
		240,
		237,
		235,
		232,
		248,
		246,
		256,
		-1,
		-1,
		361,
		330,
		359,
		317,
		298,
		-1,
		264,
		244,
		250,
		254,
		248,
		241,
		255,
		251,
		-1,
		226,
		225,
		253,
		239,
		250,
		321,
		-1,
		-1,
		319,
		311,
		294,
		297,
		274,
		270,
		259,
		258,
		250,
		236,
		232,
		238,
		241,
		241,
		247,
		220,
		230,
		234,
		232,
		257,
		-1,
		-1,
		292,
		-1,
		-1,
		318,
		301,
		-1,
		284,
		291,
		280,
		286,
		272,
		293,
		269,
		260,
		252,
		246,
		234,
		236,
		233,
		246,
		234,
		217,
		242,
		246,
		227,
		248,
		243,
		-1,
		291,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		277,
		280,
		286,
		310,
		309,
		-1,
		281,
		269,
		270,
		255,
		252,
		239,
		227,
		240,
		225,
		232,
		231,
		221,
		219,
		249,
		224,
		246,
		243,
		262,
		267,
		261,
		270,
		-1,
		326,
		322,
		318,
		325,
		274,
		-1,
		-1,
		314,
		-1,
		317,
		318,
		293,
		266,
		269,
		256,
		247,
		234,
		223,
		234,
		223,
		220,
		228,
		213,
		228,
		219,
		218,
		236,
		246,
		254,
		258,
		264,
		-1,
		376,
		-1,
		318,
		302,
		304,
		276,
		297,
		-1,
		334,
		318,
		310,
		295,
		295,
		-1,
		265,
		262,
		252,
		230,
		215,
		232,
		224,
		222,
		226,
		208,
		222,
		213,
		231,
		238,
		236,
		240,
		260,
		272,
		336,
		326,
		-1,
		308,
		313,
		272,
		280,
		299,
		337,
		301,
		-1,
		296,
		-1,
		267,
		280,
		-1,
		236,
		232,
		214,
		215,
		210,
		225,
		219,
		204,
		201,
		219,
		222,
		229,
		233,
		249,
		-1,
		-1,
		321,
		325,
		314,
		265,
		284,
		308,
		345,
		294,
		283,
		282,
		-1,
		273,
		250,
		247,
		235,
		222,
		207,
		208,
		216,
		229,
		208,
		203,
		200,
		220,
		246,
		224,
		236,
		-1,
		-1,
		-1,
		346,
		-1,
		-1,
		291,
		262,
		286,
		328,
		312,
		305,
		293,
		258,
		258,
		252,
		-1,
		246,
		225,
		216,
		205,
		203,
		216,
		213,
		218,
		198,
		196,
		215,
		227,
		218,
		235,
		-1,
		-1,
		-1,
		321,
		310,
		311,
		257,
		280,
		317,
		291,
		277,
		282,
		257,
		250,
		244,
		259,
		242,
		223,
		212,
		204,
		193,
		209,
		217,
		212,
		194,
		203,
		209,
		233,
		223,
		229,
		-1,
		-1,
		328,
		318,
		302,
		304,
		301,
		271,
		278,
		310,
		282,
		295,
		-1,
		249,
		-1,
		238,
		233,
		217,
		212,
		209,
		206,
		200,
		209,
		211,
		201,
		196,
		203,
		238,
		238,
		213,
		233,
		236,
		-1,
		-1,
		-1,
		321,
		316,
		291,
		268,
		252,
		288,
		-1,
		265,
		266,
		-1,
		243,
		237,
		234,
		219,
		215,
		210,
		214,
		207,
		214,
		207,
		205,
		206,
		188,
		220,
		-1,
		221,
		215,
		223,
		213,
		201,
		-1,
		-1,
		-1,
		314,
		293,
		286,
		306,
		247,
		299,
		-1,
		-1,
		250,
		243,
		-1,
		230,
		212,
		219,
		217,
		211,
		215,
		212,
		201,
		214,
		207,
		193,
		195,
		208,
		212,
		216,
		203,
		199,
		196,
		210,
		-1,
		333,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		267,
		-1,
		259,
		251,
		241,
		235,
		229,
		225,
		223,
		239,
		223,
		226,
		224,
		215,
		223,
		196,
		189,
		196,
		185,
		203,
		211,
		203,
		197,
		196,
		206,
		-1,
		334,
		320,
		291,
		-1,
		-1,
		280,
		-1,
		244,
		258,
		274,
		-1,
		267,
		246,
		261,
		239,
		235,
		231,
		246,
		247,
		224,
		224,
		222,
		213,
		201,
		190,
		193,
		185,
		207,
		207,
		191,
		192,
		196,
		-1,
		340,
		327,
		285,
		281,
		270,
		290,
		241,
		229,
		261,
		-1,
		-1,
		303,
		-1,
		237,
		254,
		245,
		243,
		236,
		218,
		225,
		233,
		210,
		205,
		195,
		184,
		184,
		179,
		201,
		187,
		185,
		194,
		210,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		256,
		243,
		237,
		-1,
		278,
		-1,
		281,
		271,
		255,
		240,
		273,
		-1,
		217,
		213,
		220,
		-1,
		230,
		-1,
		203,
		200,
		191,
		176,
		173,
		184,
		182,
		193,
		189,
		-1,
		290,
		275,
		268,
		258,
		272,
		243,
		-1,
		293,
		-1,
		-1,
		268,
		262,
		262,
		246,
		247,
		233,
		213,
		205,
		220,
		219,
		206,
		205,
		189,
		182,
		179,
		172,
		185,
		195,
		200,
		187,
		-1,
		-1,
		-1,
		295,
		254,
		262,
		238,
		259,
		-1,
		-1,
		330,
		285,
		271,
		-1,
		242,
		233,
		221,
		211,
		201,
		206,
		207,
		197,
		195,
		187,
		189,
		183,
		174,
		173,
		189,
		181,
		203,
		-1,
		-1,
		251,
		264,
		266,
		244,
		239,
		-1,
		-1,
		-1,
		277,
		293,
		261,
		240,
		222,
		-1,
		-1,
		205,
		198,
		192,
		195,
		183,
		203,
		198,
		182,
		167,
		182,
		186,
		194,
		185,
		-1,
		254,
		241,
		-1,
		-1,
		238,
		228,
		-1,
		-1,
		-1,
		-1,
		273,
		218,
		207,
		202,
		206,
		204,
		-1,
		178,
		189,
		182,
		201,
		208,
		184,
		169,
		163,
		169,
		181,
		190,
		-1,
		-1,
		252,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		230,
		224,
		195,
		188,
		192,
		-1,
		180,
		182,
		179,
		191,
		187,
		184,
		175,
		166,
		162,
		166,
		170,
		184,
		188,
		275,
		-1,
		205,
		-1,
		-1,
		-1,
		244,
		245,
		231,
		208,
		184,
		179,
		172,
		166,
		171,
		182,
		191,
		202,
		167,
		169,
		159,
		158,
		162,
		179,
		183,
		-1,
		-1,
		203,
		199,
		234,
		246,
		218,
		258,
		-1,
		-1,
		176,
		169,
		170,
		162,
		175,
		178,
		163,
		165,
		165,
		163,
		157,
		167,
		182,
		177,
		-1,
		-1,
		-1,
		201,
		-1,
		217,
		-1,
		-1,
		208,
		249,
		196,
		178,
		174,
		160,
		167,
		161,
		153,
		158,
		168,
		162,
		159,
		153,
		157,
		180,
		169,
		208,
		-1,
		-1,
		207,
		-1,
		-1,
		-1,
		167,
		186,
		181,
		187,
		192,
		183,
		211,
		208,
		-1,
		157,
		190,
		158,
		166,
		149,
		156,
		161,
		158,
		147,
		154,
		170,
		169,
		164,
		200,
		191,
		197,
		-1,
		-1,
		200,
		189,
		178,
		184,
		-1,
		160,
		183,
		173,
		163,
		169,
		-1,
		-1,
		175,
		172,
		170,
		150,
		156,
		150,
		145,
		155,
		131,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		154,
		191,
		184,
		152,
		160,
		191,
		-1,
		150,
		142,
		170,
		155,
		163,
		-1,
		-1,
		148,
		139,
		144,
		153,
		154,
		169,
		168,
		151,
		157,
		158,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		147,
		167,
		146,
		149,
		173,
		187,
		-1,
		141,
		-1,
		-1,
		160,
		173,
		157,
		147,
		144,
		191,
		167,
		162,
		156,
		154,
		149,
		140,
		165,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		136,
		147,
		140,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		150,
		-1,
		184,
		-1,
		167,
		171,
		175,
		178,
		170,
		157,
		143,
		151,
		157,
		156,
		162,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		161,
		117,
		120,
		131,
		142,
		157,
		161,
		-1,
		125,
		161,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		181,
		188,
		180,
		190,
		169,
		169,
		135,
		139,
		152,
		159,
		169,
		180,
		172,
		176,
		189,
		200,
		203,
		157,
		148,
		161,
		106,
		106,
		127,
		136,
		157,
		121,
		118,
		155,
		160,
		152,
		147,
		134,
		-1,
		-1,
		203,
		198,
		-1,
		-1,
		176,
		143,
		131,
		141,
		145,
		159,
		171,
		184,
		172,
		177,
		171,
		203,
		-1,
		150,
		149,
		138,
		135,
		111,
		102,
		97,
		124,
		-1,
		-1,
		119,
		146,
		130,
		134,
		150,
		175,
		-1,
		118,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		148,
		137,
		128,
		133,
		153,
		164,
		186,
		168,
		185,
		176,
		186,
		190,
		134,
		131,
		119,
		117,
		140,
		105,
		93,
		-1,
		101,
		104,
		110,
		117,
		134,
		164,
		-1,
		-1,
		134,
		114,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		125,
		130,
		160,
		162,
		164,
		171,
		165,
		172,
		180,
		191,
		183,
		143,
		157,
		146,
		142,
		141,
		149,
		98,
		91,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		124,
		120,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		147,
		147,
		150,
		155,
		163,
		174,
		170,
		174,
		177,
		-1,
		177,
		-1,
		129,
		90,
		96,
		111,
		119,
		-1,
		-1,
		-1,
		141,
		127,
		120,
		108,
		106,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		183,
		151,
		156,
		151,
		166,
		177,
		168,
		176,
		170,
		173,
		-1,
		-1,
		89,
		72,
		-1,
		-1,
		46,
		48,
		-1,
		132,
		121,
		106,
		98,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		117,
		155,
		154,
		162,
		157,
		162,
		174,
		170,
		166,
		176,
		167,
		-1,
		-1,
		67,
		59,
		53,
		-1,
		31,
		-1,
		134,
		-1,
		101,
		108,
		96,
		-1,
		-1,
		-1,
		148,
		111,
		127,
		150,
		176,
		174,
		165,
		158,
		165,
		168,
		161,
		167,
		-1,
		-1,
		-1,
		6,
		26,
		141,
		132,
		115,
		95,
		87,
		107,
		-1,
		129,
		-1,
		104,
		107,
		132,
		171,
		173,
		159,
		155,
		168,
		162,
		159,
		157,
		0,
		-1,
		30,
		89,
		72,
		101,
		67,
		79,
		143,
		-1,
		126,
		108,
		-1,
		136,
		126,
		174,
		149,
		158,
		151,
		145,
		146,
		154,
		-1,
		-1,
		-1,
		45,
		44,
		43,
		54,
		62,
		60,
		78,
		-1,
		131,
		113,
		99,
		116,
		116,
		107,
		115,
		164,
		160,
		163,
		161,
		139,
		-1,
		93,
		-1,
		-1,
		68,
		-1,
		-1,
		-1,
		71,
		93,
		88,
		80,
		92,
		101,
		96,
		98,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		138,
		170,
		-1,
		100,
		-1,
		75,
		-1,
		-1,
		89,
		75,
		87,
		98,
		88,
		88,
		93,
		91,
		113,
		143,
		129,
		127,
		132,
		137,
		-1,
		110,
		111,
		-1,
		108,
		100,
		86,
		-1,
		79,
		-1,
		134,
		95,
		-1,
		120,
		100,
		-1,
		138,
		134,
		-1,
		-1,
		122,
		124,
		-1,
		-1,
		-1,
		109,
		89,
		129,
		113,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		136,
		133,
		-1,
		102,
		105,
		-1,
		96,
		102,
		131,
		113,
		117,
		-1,
		-1,
		-1,
		158,
		139,
		133,
		117,
		122,
		110,
		127,
		113,
		115,
		127,
		116,
		137,
		-1,
		-1,
		-1,
		130,
		122,
		122,
		-1,
		-1,
		140,
		123,
		123,
		136,
		-1,
		-1,
		-1,
		152,
		133,
		-1,
		-1,
		131,
		-1,
		-1,
		136,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		141,
		-1,
		-1,
		-1,
		132,
		139,
		147,
		-1,
		-1,
		-1,
		-1,
		162,
		163,
		187,
		162,
		-1,
		-1,
		-1,
		146,
		146,
		-1,
		-1,
		165,
		163,
		-1,
		-1,
		-1,
		174,
		158,
		-1,
		150,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		179,
		-1,
		185,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		192,
		184,
		198,
		-1,
		170,
		172,
		-1,
		220,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		175,
		182,
		204,
		207,
		237,
		-1,
		194
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		292,
		281,
		292,
		300,
		273,
		280,
		-1,
		299,
		303,
		269,
		263,
		302,
		271,
		277,
		288,
		-1,
		-1,
		-1,
		292,
		291,
		259,
		257,
		266,
		271,
		278,
		-1,
		277,
		-1,
		313,
		292,
		303,
		308,
		252,
		249,
		269,
		288,
		270,
		262,
		328,
		282,
		253,
		247,
		265,
		255,
		264,
		256,
		-1,
		253,
		243,
		265,
		244,
		255,
		247,
		-1,
		-1,
		247,
		248,
		254,
		240,
		246,
		242,
		-1,
		252,
		236,
		-1,
		-1,
		237,
		238,
		222,
		225,
		233,
		231,
		244,
		236,
		231,
		-1,
		-1,
		228,
		224,
		231,
		218,
		214,
		231,
		244,
		226,
		240,
		239,
		-1,
		232,
		250,
		257,
		225,
		223,
		207,
		205,
		223,
		225,
		231,
		231,
		-1,
		241,
		242,
		237,
		245,
		247,
		223,
		210,
		210,
		220,
		213,
		232,
		220,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		241,
		224,
		241,
		233,
		223,
		238,
		231,
		213,
		210,
		208,
		205,
		221,
		219,
		229,
		-1,
		-1,
		334,
		303,
		332,
		290,
		271,
		-1,
		237,
		217,
		223,
		227,
		221,
		214,
		228,
		224,
		-1,
		199,
		198,
		226,
		212,
		223,
		294,
		-1,
		-1,
		292,
		284,
		267,
		270,
		247,
		243,
		232,
		231,
		223,
		209,
		205,
		211,
		214,
		214,
		220,
		193,
		203,
		207,
		205,
		230,
		-1,
		-1,
		265,
		-1,
		-1,
		291,
		274,
		-1,
		257,
		264,
		253,
		259,
		245,
		266,
		242,
		233,
		225,
		219,
		207,
		209,
		206,
		219,
		207,
		190,
		215,
		219,
		200,
		221,
		216,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		250,
		253,
		259,
		283,
		282,
		-1,
		254,
		242,
		243,
		228,
		225,
		212,
		200,
		213,
		198,
		205,
		204,
		194,
		192,
		222,
		197,
		219,
		216,
		235,
		240,
		234,
		243,
		-1,
		299,
		295,
		291,
		298,
		247,
		-1,
		-1,
		287,
		-1,
		290,
		291,
		266,
		239,
		242,
		229,
		220,
		207,
		196,
		207,
		196,
		193,
		201,
		186,
		201,
		192,
		191,
		209,
		219,
		227,
		231,
		237,
		-1,
		349,
		-1,
		291,
		275,
		277,
		249,
		270,
		-1,
		307,
		291,
		283,
		268,
		268,
		-1,
		238,
		235,
		225,
		203,
		188,
		205,
		197,
		195,
		199,
		181,
		195,
		186,
		204,
		211,
		209,
		213,
		233,
		245,
		309,
		299,
		-1,
		281,
		286,
		245,
		253,
		272,
		310,
		274,
		-1,
		269,
		-1,
		240,
		253,
		-1,
		209,
		205,
		187,
		188,
		183,
		198,
		192,
		177,
		174,
		192,
		195,
		202,
		206,
		222,
		-1,
		-1,
		294,
		298,
		287,
		238,
		257,
		281,
		318,
		267,
		256,
		255,
		-1,
		246,
		223,
		220,
		208,
		195,
		180,
		181,
		189,
		202,
		181,
		176,
		173,
		193,
		219,
		197,
		209,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		264,
		235,
		259,
		301,
		285,
		278,
		266,
		231,
		231,
		225,
		-1,
		219,
		198,
		189,
		178,
		176,
		189,
		186,
		191,
		171,
		169,
		188,
		200,
		191,
		208,
		-1,
		-1,
		-1,
		294,
		283,
		284,
		230,
		253,
		290,
		264,
		250,
		255,
		230,
		223,
		217,
		232,
		215,
		196,
		185,
		177,
		166,
		182,
		190,
		185,
		167,
		176,
		182,
		206,
		196,
		202,
		-1,
		-1,
		301,
		291,
		275,
		277,
		274,
		244,
		251,
		283,
		255,
		268,
		-1,
		222,
		-1,
		211,
		206,
		190,
		185,
		182,
		179,
		173,
		182,
		184,
		174,
		169,
		176,
		211,
		211,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		294,
		289,
		264,
		241,
		225,
		261,
		-1,
		238,
		239,
		-1,
		216,
		210,
		207,
		192,
		188,
		183,
		187,
		180,
		187,
		180,
		178,
		179,
		161,
		193,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		287,
		266,
		259,
		279,
		220,
		272,
		-1,
		-1,
		223,
		216,
		-1,
		203,
		185,
		192,
		190,
		184,
		188,
		185,
		174,
		187,
		180,
		166,
		168,
		181,
		185,
		189,
		176,
		172,
		169,
		183,
		-1,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		240,
		-1,
		232,
		224,
		214,
		208,
		202,
		198,
		196,
		212,
		196,
		199,
		197,
		188,
		196,
		169,
		162,
		169,
		158,
		176,
		184,
		176,
		170,
		169,
		179,
		-1,
		307,
		293,
		264,
		-1,
		-1,
		253,
		-1,
		217,
		231,
		247,
		-1,
		240,
		219,
		234,
		212,
		208,
		204,
		219,
		220,
		197,
		197,
		195,
		186,
		174,
		163,
		166,
		158,
		180,
		180,
		164,
		165,
		169,
		-1,
		313,
		300,
		258,
		254,
		243,
		263,
		214,
		202,
		234,
		-1,
		-1,
		276,
		-1,
		210,
		227,
		218,
		216,
		209,
		191,
		198,
		206,
		183,
		178,
		168,
		157,
		157,
		152,
		174,
		160,
		158,
		167,
		183,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		229,
		216,
		210,
		-1,
		251,
		-1,
		254,
		244,
		228,
		213,
		246,
		-1,
		190,
		186,
		193,
		-1,
		203,
		-1,
		176,
		173,
		164,
		149,
		146,
		157,
		155,
		166,
		162,
		-1,
		263,
		248,
		241,
		231,
		245,
		216,
		-1,
		271,
		-1,
		-1,
		241,
		235,
		235,
		219,
		220,
		206,
		186,
		178,
		193,
		192,
		179,
		178,
		162,
		155,
		152,
		145,
		158,
		168,
		173,
		160,
		-1,
		-1,
		-1,
		268,
		234,
		242,
		218,
		237,
		-1,
		-1,
		303,
		258,
		244,
		-1,
		215,
		206,
		194,
		184,
		174,
		179,
		180,
		170,
		168,
		160,
		162,
		156,
		147,
		146,
		162,
		154,
		176,
		-1,
		-1,
		231,
		244,
		244,
		224,
		219,
		-1,
		-1,
		-1,
		250,
		266,
		234,
		213,
		195,
		-1,
		-1,
		178,
		171,
		165,
		168,
		156,
		176,
		171,
		155,
		140,
		155,
		159,
		167,
		158,
		-1,
		234,
		221,
		-1,
		-1,
		218,
		208,
		-1,
		-1,
		-1,
		-1,
		246,
		191,
		180,
		175,
		179,
		177,
		-1,
		151,
		162,
		155,
		174,
		181,
		157,
		142,
		136,
		142,
		154,
		163,
		-1,
		-1,
		232,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		203,
		197,
		168,
		161,
		165,
		-1,
		153,
		155,
		152,
		164,
		160,
		157,
		148,
		139,
		135,
		139,
		143,
		157,
		161,
		255,
		-1,
		185,
		-1,
		-1,
		-1,
		221,
		225,
		207,
		184,
		157,
		152,
		145,
		139,
		144,
		155,
		164,
		175,
		140,
		142,
		132,
		131,
		135,
		152,
		156,
		-1,
		-1,
		183,
		179,
		214,
		226,
		198,
		234,
		-1,
		-1,
		156,
		149,
		143,
		135,
		148,
		151,
		136,
		138,
		138,
		136,
		130,
		140,
		155,
		150,
		-1,
		-1,
		-1,
		181,
		-1,
		197,
		-1,
		-1,
		188,
		229,
		176,
		158,
		154,
		140,
		144,
		138,
		126,
		131,
		141,
		135,
		132,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		187,
		-1,
		-1,
		-1,
		147,
		166,
		161,
		167,
		172,
		163,
		191,
		188,
		-1,
		137,
		167,
		132,
		139,
		122,
		129,
		134,
		131,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		180,
		169,
		158,
		164,
		-1,
		140,
		163,
		153,
		143,
		149,
		-1,
		-1,
		155,
		152,
		150,
		130,
		130,
		123,
		118,
		128,
		104,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		134,
		171,
		164,
		132,
		140,
		171,
		-1,
		130,
		122,
		150,
		135,
		143,
		-1,
		-1,
		128,
		119,
		124,
		133,
		134,
		142,
		141,
		124,
		130,
		131,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		127,
		147,
		126,
		129,
		153,
		167,
		-1,
		121,
		-1,
		-1,
		133,
		153,
		137,
		127,
		124,
		171,
		147,
		142,
		129,
		127,
		122,
		113,
		138,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		116,
		127,
		120,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		123,
		-1,
		164,
		-1,
		147,
		151,
		155,
		158,
		143,
		130,
		116,
		124,
		130,
		129,
		135,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		141,
		97,
		100,
		111,
		122,
		137,
		141,
		-1,
		105,
		141,
		129,
		-1,
		113,
		-1,
		-1,
		-1,
		161,
		168,
		160,
		163,
		142,
		142,
		108,
		112,
		125,
		132,
		142,
		153,
		145,
		149,
		162,
		173,
		176,
		137,
		128,
		141,
		86,
		86,
		107,
		116,
		137,
		101,
		98,
		135,
		136,
		125,
		120,
		107,
		-1,
		-1,
		176,
		178,
		-1,
		-1,
		149,
		116,
		104,
		114,
		118,
		132,
		144,
		157,
		145,
		150,
		144,
		176,
		-1,
		130,
		129,
		118,
		115,
		91,
		82,
		77,
		104,
		-1,
		-1,
		99,
		126,
		110,
		114,
		130,
		155,
		-1,
		91,
		-1,
		-1,
		156,
		-1,
		-1,
		141,
		121,
		110,
		101,
		106,
		126,
		137,
		159,
		141,
		158,
		149,
		159,
		163,
		114,
		111,
		99,
		97,
		120,
		85,
		73,
		-1,
		81,
		84,
		90,
		97,
		114,
		144,
		-1,
		-1,
		107,
		87,
		-1,
		-1,
		139,
		137,
		126,
		-1,
		116,
		98,
		103,
		133,
		135,
		137,
		144,
		138,
		145,
		153,
		164,
		156,
		123,
		137,
		126,
		122,
		121,
		129,
		78,
		71,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		97,
		93,
		-1,
		-1,
		134,
		127,
		115,
		103,
		93,
		103,
		120,
		120,
		123,
		128,
		136,
		147,
		143,
		147,
		150,
		-1,
		157,
		-1,
		109,
		70,
		76,
		91,
		99,
		-1,
		-1,
		-1,
		114,
		100,
		93,
		81,
		79,
		-1,
		168,
		152,
		133,
		-1,
		103,
		116,
		156,
		124,
		129,
		124,
		139,
		150,
		141,
		149,
		143,
		146,
		-1,
		-1,
		69,
		52,
		-1,
		-1,
		26,
		28,
		-1,
		105,
		94,
		79,
		71,
		-1,
		-1,
		140,
		136,
		-1,
		-1,
		90,
		128,
		127,
		135,
		130,
		135,
		147,
		143,
		139,
		149,
		140,
		-1,
		-1,
		47,
		39,
		33,
		-1,
		11,
		-1,
		107,
		-1,
		74,
		81,
		69,
		-1,
		-1,
		-1,
		121,
		84,
		100,
		123,
		149,
		147,
		138,
		131,
		138,
		141,
		134,
		140,
		-1,
		-1,
		-1,
		29,
		3,
		114,
		105,
		88,
		68,
		60,
		80,
		-1,
		102,
		-1,
		77,
		80,
		105,
		144,
		146,
		132,
		128,
		141,
		135,
		132,
		130,
		35,
		-1,
		0,
		59,
		43,
		74,
		40,
		52,
		116,
		-1,
		99,
		81,
		-1,
		109,
		99,
		147,
		122,
		131,
		124,
		118,
		119,
		127,
		-1,
		-1,
		-1,
		15,
		14,
		13,
		24,
		35,
		33,
		51,
		-1,
		104,
		86,
		72,
		89,
		89,
		80,
		88,
		137,
		133,
		136,
		134,
		112,
		-1,
		128,
		-1,
		-1,
		38,
		-1,
		-1,
		-1,
		41,
		66,
		61,
		53,
		65,
		74,
		69,
		71,
		84,
		92,
		90,
		87,
		99,
		95,
		115,
		111,
		143,
		-1,
		135,
		-1,
		45,
		-1,
		-1,
		62,
		48,
		60,
		71,
		61,
		61,
		66,
		64,
		86,
		116,
		102,
		100,
		105,
		110,
		-1,
		145,
		146,
		-1,
		81,
		73,
		59,
		-1,
		52,
		-1,
		107,
		68,
		-1,
		93,
		73,
		-1,
		111,
		107,
		-1,
		-1,
		137,
		97,
		-1,
		-1,
		-1,
		82,
		62,
		102,
		86,
		-1,
		84,
		84,
		-1,
		-1,
		-1,
		122,
		106,
		-1,
		75,
		78,
		-1,
		69,
		75,
		104,
		86,
		90,
		-1,
		-1,
		-1,
		131,
		112,
		106,
		90,
		95,
		83,
		100,
		86,
		88,
		100,
		89,
		110,
		-1,
		-1,
		-1,
		103,
		95,
		95,
		-1,
		-1,
		113,
		96,
		96,
		109,
		-1,
		-1,
		-1,
		125,
		106,
		-1,
		-1,
		104,
		-1,
		-1,
		109,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		114,
		-1,
		-1,
		-1,
		105,
		112,
		120,
		-1,
		-1,
		-1,
		-1,
		135,
		136,
		160,
		135,
		-1,
		-1,
		-1,
		119,
		119,
		-1,
		-1,
		138,
		136,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		123,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		152,
		-1,
		158,
		133,
		140,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		171,
		-1,
		143,
		145,
		-1,
		193,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		148,
		155,
		177,
		180,
		210,
		-1,
		167
	],
	[
		-1,
		330,
		319,
		330,
		338,
		311,
		318,
		-1,
		337,
		341,
		307,
		301,
		340,
		309,
		315,
		326,
		-1,
		-1,
		-1,
		330,
		329,
		297,
		295,
		304,
		309,
		316,
		-1,
		315,
		-1,
		351,
		330,
		341,
		346,
		290,
		287,
		307,
		326,
		308,
		300,
		366,
		320,
		291,
		285,
		303,
		293,
		302,
		294,
		-1,
		291,
		281,
		303,
		282,
		293,
		285,
		-1,
		-1,
		285,
		286,
		292,
		278,
		284,
		280,
		-1,
		290,
		274,
		-1,
		-1,
		275,
		276,
		260,
		263,
		271,
		269,
		282,
		274,
		269,
		-1,
		-1,
		266,
		262,
		269,
		256,
		252,
		269,
		282,
		264,
		278,
		277,
		-1,
		270,
		288,
		295,
		263,
		261,
		245,
		243,
		261,
		263,
		269,
		269,
		-1,
		279,
		280,
		275,
		283,
		285,
		261,
		248,
		248,
		258,
		251,
		270,
		258,
		304,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		279,
		262,
		279,
		271,
		261,
		276,
		269,
		251,
		248,
		246,
		243,
		259,
		257,
		267,
		-1,
		-1,
		372,
		341,
		370,
		328,
		309,
		-1,
		275,
		255,
		261,
		265,
		259,
		252,
		266,
		262,
		-1,
		237,
		236,
		264,
		250,
		261,
		332,
		-1,
		-1,
		330,
		322,
		305,
		308,
		285,
		281,
		270,
		269,
		261,
		247,
		243,
		249,
		252,
		252,
		258,
		231,
		241,
		245,
		243,
		268,
		-1,
		-1,
		303,
		-1,
		-1,
		329,
		312,
		-1,
		295,
		302,
		291,
		297,
		283,
		304,
		280,
		271,
		263,
		257,
		245,
		247,
		244,
		257,
		245,
		228,
		253,
		257,
		238,
		259,
		254,
		-1,
		302,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		288,
		291,
		297,
		321,
		320,
		-1,
		292,
		280,
		281,
		266,
		263,
		250,
		238,
		251,
		236,
		243,
		242,
		232,
		230,
		260,
		235,
		257,
		254,
		273,
		278,
		272,
		281,
		-1,
		337,
		333,
		329,
		336,
		285,
		-1,
		-1,
		325,
		-1,
		328,
		329,
		304,
		277,
		280,
		267,
		258,
		245,
		234,
		245,
		234,
		231,
		239,
		224,
		239,
		230,
		229,
		247,
		257,
		265,
		269,
		275,
		-1,
		387,
		-1,
		329,
		313,
		315,
		287,
		308,
		-1,
		345,
		329,
		321,
		306,
		306,
		-1,
		276,
		273,
		263,
		241,
		226,
		243,
		235,
		233,
		237,
		219,
		233,
		224,
		242,
		249,
		247,
		251,
		271,
		283,
		347,
		337,
		-1,
		319,
		324,
		283,
		291,
		310,
		348,
		312,
		-1,
		307,
		-1,
		278,
		291,
		-1,
		247,
		243,
		225,
		226,
		221,
		236,
		230,
		215,
		212,
		230,
		233,
		240,
		244,
		260,
		-1,
		-1,
		332,
		336,
		325,
		276,
		295,
		319,
		356,
		305,
		294,
		293,
		-1,
		284,
		261,
		258,
		246,
		233,
		218,
		219,
		227,
		240,
		219,
		214,
		211,
		231,
		257,
		235,
		247,
		-1,
		-1,
		-1,
		357,
		-1,
		-1,
		302,
		273,
		297,
		339,
		323,
		316,
		304,
		269,
		269,
		263,
		-1,
		257,
		236,
		227,
		216,
		214,
		227,
		224,
		229,
		209,
		207,
		226,
		238,
		229,
		246,
		-1,
		-1,
		-1,
		332,
		321,
		322,
		268,
		291,
		328,
		302,
		288,
		293,
		268,
		261,
		255,
		270,
		253,
		234,
		223,
		215,
		204,
		220,
		228,
		223,
		205,
		214,
		220,
		244,
		234,
		240,
		-1,
		-1,
		339,
		329,
		313,
		315,
		312,
		282,
		289,
		321,
		293,
		306,
		-1,
		260,
		-1,
		249,
		244,
		228,
		223,
		220,
		217,
		211,
		220,
		222,
		212,
		207,
		214,
		249,
		249,
		224,
		244,
		247,
		-1,
		-1,
		-1,
		332,
		327,
		302,
		279,
		263,
		299,
		-1,
		276,
		277,
		-1,
		254,
		248,
		245,
		230,
		226,
		221,
		225,
		218,
		225,
		218,
		216,
		217,
		199,
		231,
		-1,
		232,
		226,
		234,
		224,
		212,
		-1,
		-1,
		-1,
		325,
		304,
		297,
		317,
		258,
		310,
		-1,
		-1,
		261,
		254,
		-1,
		241,
		223,
		230,
		228,
		222,
		226,
		223,
		212,
		225,
		218,
		204,
		206,
		219,
		223,
		227,
		214,
		210,
		207,
		221,
		-1,
		344,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		278,
		-1,
		270,
		262,
		252,
		246,
		240,
		236,
		234,
		250,
		234,
		237,
		235,
		226,
		234,
		207,
		200,
		207,
		196,
		214,
		222,
		214,
		208,
		207,
		217,
		-1,
		345,
		331,
		302,
		-1,
		-1,
		291,
		-1,
		255,
		269,
		285,
		-1,
		278,
		257,
		272,
		250,
		246,
		242,
		257,
		258,
		235,
		235,
		233,
		224,
		212,
		201,
		204,
		196,
		218,
		218,
		202,
		203,
		207,
		-1,
		351,
		338,
		296,
		292,
		281,
		301,
		252,
		240,
		272,
		-1,
		-1,
		314,
		-1,
		248,
		265,
		256,
		254,
		247,
		229,
		236,
		244,
		221,
		216,
		206,
		195,
		195,
		190,
		212,
		198,
		196,
		205,
		221,
		-1,
		-1,
		-1,
		318,
		-1,
		-1,
		267,
		254,
		248,
		-1,
		289,
		-1,
		292,
		282,
		266,
		251,
		284,
		-1,
		228,
		224,
		231,
		-1,
		241,
		-1,
		214,
		211,
		202,
		187,
		184,
		195,
		193,
		204,
		200,
		-1,
		301,
		286,
		279,
		269,
		283,
		254,
		-1,
		309,
		-1,
		-1,
		279,
		273,
		273,
		257,
		258,
		244,
		224,
		216,
		231,
		230,
		217,
		216,
		200,
		193,
		190,
		183,
		196,
		206,
		211,
		198,
		-1,
		-1,
		-1,
		306,
		292,
		296,
		256,
		275,
		-1,
		-1,
		341,
		296,
		282,
		-1,
		253,
		244,
		232,
		222,
		212,
		217,
		218,
		208,
		206,
		198,
		200,
		194,
		185,
		184,
		200,
		192,
		214,
		-1,
		-1,
		289,
		294,
		282,
		268,
		270,
		-1,
		-1,
		-1,
		288,
		304,
		272,
		251,
		233,
		-1,
		-1,
		216,
		209,
		203,
		206,
		194,
		214,
		209,
		193,
		178,
		193,
		197,
		205,
		196,
		-1,
		292,
		279,
		-1,
		-1,
		269,
		259,
		-1,
		-1,
		-1,
		-1,
		284,
		229,
		218,
		213,
		217,
		215,
		-1,
		189,
		200,
		193,
		212,
		219,
		195,
		180,
		174,
		180,
		192,
		201,
		-1,
		-1,
		283,
		-1,
		245,
		-1,
		-1,
		-1,
		-1,
		241,
		235,
		206,
		199,
		203,
		-1,
		191,
		193,
		190,
		202,
		198,
		195,
		186,
		177,
		173,
		177,
		181,
		195,
		199,
		306,
		-1,
		236,
		-1,
		-1,
		-1,
		259,
		274,
		245,
		222,
		195,
		190,
		183,
		177,
		182,
		193,
		202,
		213,
		178,
		180,
		170,
		169,
		173,
		190,
		194,
		-1,
		-1,
		234,
		230,
		265,
		267,
		261,
		272,
		-1,
		-1,
		199,
		190,
		181,
		173,
		186,
		189,
		174,
		176,
		176,
		174,
		168,
		178,
		193,
		188,
		-1,
		-1,
		-1,
		244,
		-1,
		248,
		-1,
		-1,
		251,
		270,
		217,
		199,
		195,
		193,
		182,
		176,
		164,
		169,
		179,
		173,
		170,
		164,
		168,
		191,
		180,
		219,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		210,
		217,
		212,
		230,
		235,
		226,
		232,
		229,
		-1,
		199,
		205,
		170,
		177,
		160,
		167,
		172,
		169,
		158,
		165,
		181,
		180,
		175,
		211,
		202,
		208,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		203,
		214,
		216,
		206,
		212,
		-1,
		-1,
		218,
		215,
		201,
		170,
		168,
		161,
		156,
		166,
		142,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		197,
		234,
		227,
		195,
		203,
		234,
		-1,
		193,
		185,
		211,
		198,
		206,
		-1,
		-1,
		191,
		182,
		187,
		177,
		174,
		180,
		179,
		162,
		168,
		169,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		190,
		210,
		189,
		192,
		216,
		230,
		-1,
		184,
		-1,
		-1,
		171,
		216,
		200,
		190,
		187,
		234,
		191,
		186,
		167,
		165,
		160,
		151,
		176,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		178,
		-1,
		-1,
		161,
		-1,
		227,
		-1,
		210,
		214,
		199,
		202,
		181,
		168,
		154,
		162,
		168,
		167,
		173,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		168,
		204,
		167,
		-1,
		151,
		-1,
		-1,
		-1,
		224,
		212,
		204,
		201,
		180,
		180,
		146,
		150,
		163,
		170,
		180,
		191,
		183,
		187,
		200,
		211,
		214,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		164,
		161,
		198,
		174,
		163,
		158,
		145,
		-1,
		-1,
		214,
		222,
		-1,
		-1,
		187,
		154,
		142,
		152,
		156,
		170,
		182,
		195,
		183,
		188,
		182,
		214,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		189,
		173,
		177,
		193,
		218,
		-1,
		129,
		-1,
		-1,
		194,
		-1,
		-1,
		179,
		159,
		148,
		139,
		144,
		164,
		175,
		197,
		179,
		196,
		187,
		197,
		201,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		144,
		147,
		153,
		160,
		177,
		207,
		-1,
		-1,
		145,
		125,
		-1,
		-1,
		177,
		175,
		164,
		-1,
		154,
		136,
		141,
		171,
		173,
		175,
		182,
		176,
		183,
		191,
		202,
		194,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		135,
		131,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		158,
		158,
		161,
		166,
		174,
		185,
		181,
		185,
		188,
		-1,
		220,
		-1,
		172,
		133,
		139,
		154,
		162,
		-1,
		-1,
		-1,
		152,
		138,
		131,
		119,
		117,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		194,
		162,
		167,
		162,
		177,
		188,
		179,
		187,
		181,
		184,
		-1,
		-1,
		132,
		115,
		-1,
		-1,
		89,
		91,
		-1,
		143,
		132,
		117,
		109,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		128,
		166,
		165,
		173,
		168,
		173,
		185,
		181,
		177,
		187,
		178,
		-1,
		-1,
		110,
		102,
		96,
		-1,
		74,
		-1,
		145,
		-1,
		112,
		119,
		107,
		-1,
		-1,
		-1,
		159,
		122,
		138,
		161,
		187,
		185,
		176,
		169,
		176,
		179,
		172,
		178,
		-1,
		-1,
		-1,
		92,
		66,
		152,
		143,
		126,
		106,
		98,
		118,
		-1,
		140,
		-1,
		115,
		118,
		143,
		182,
		184,
		170,
		166,
		179,
		173,
		170,
		168,
		98,
		-1,
		63,
		0,
		81,
		112,
		78,
		90,
		154,
		-1,
		137,
		119,
		-1,
		147,
		137,
		185,
		160,
		169,
		162,
		156,
		157,
		165,
		-1,
		-1,
		-1,
		65,
		64,
		56,
		62,
		73,
		71,
		89,
		-1,
		142,
		124,
		110,
		127,
		127,
		118,
		126,
		175,
		171,
		174,
		172,
		150,
		-1,
		191,
		-1,
		-1,
		88,
		-1,
		-1,
		-1,
		79,
		104,
		99,
		91,
		103,
		112,
		107,
		109,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		198,
		-1,
		95,
		-1,
		-1,
		100,
		86,
		98,
		109,
		99,
		99,
		104,
		102,
		124,
		154,
		140,
		138,
		143,
		148,
		-1,
		188,
		187,
		-1,
		119,
		111,
		97,
		-1,
		90,
		-1,
		145,
		106,
		-1,
		131,
		111,
		-1,
		149,
		145,
		-1,
		-1,
		175,
		135,
		-1,
		-1,
		-1,
		120,
		100,
		140,
		124,
		-1,
		122,
		122,
		-1,
		-1,
		-1,
		160,
		144,
		-1,
		113,
		116,
		-1,
		107,
		113,
		142,
		124,
		128,
		-1,
		-1,
		-1,
		169,
		150,
		144,
		128,
		133,
		121,
		138,
		124,
		126,
		138,
		127,
		148,
		-1,
		-1,
		-1,
		141,
		133,
		133,
		-1,
		-1,
		151,
		134,
		134,
		147,
		-1,
		-1,
		-1,
		163,
		144,
		-1,
		-1,
		142,
		-1,
		-1,
		147,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		152,
		-1,
		-1,
		-1,
		143,
		150,
		158,
		-1,
		-1,
		-1,
		-1,
		173,
		174,
		198,
		173,
		-1,
		-1,
		-1,
		157,
		157,
		-1,
		-1,
		176,
		174,
		-1,
		-1,
		-1,
		185,
		169,
		-1,
		161,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		194,
		-1,
		-1,
		-1,
		190,
		-1,
		196,
		171,
		178,
		-1,
		-1,
		-1,
		-1,
		203,
		195,
		209,
		-1,
		181,
		183,
		-1,
		231,
		-1,
		-1,
		218,
		209,
		-1,
		-1,
		186,
		193,
		215,
		218,
		248,
		-1,
		205
	],
	[
		-1,
		300,
		289,
		300,
		308,
		281,
		288,
		-1,
		307,
		311,
		277,
		271,
		310,
		279,
		285,
		296,
		-1,
		-1,
		-1,
		300,
		299,
		267,
		265,
		274,
		279,
		286,
		-1,
		285,
		-1,
		321,
		300,
		311,
		316,
		260,
		257,
		277,
		296,
		278,
		270,
		336,
		290,
		261,
		255,
		273,
		263,
		272,
		264,
		-1,
		261,
		251,
		273,
		252,
		263,
		255,
		-1,
		-1,
		255,
		256,
		262,
		248,
		254,
		250,
		-1,
		260,
		244,
		-1,
		-1,
		245,
		246,
		230,
		233,
		241,
		239,
		252,
		244,
		239,
		-1,
		-1,
		236,
		232,
		239,
		226,
		222,
		239,
		252,
		234,
		248,
		247,
		-1,
		240,
		258,
		265,
		233,
		231,
		215,
		213,
		231,
		233,
		239,
		239,
		-1,
		249,
		250,
		245,
		253,
		255,
		231,
		218,
		218,
		228,
		221,
		240,
		228,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		249,
		232,
		249,
		241,
		231,
		246,
		239,
		221,
		218,
		216,
		213,
		229,
		227,
		237,
		-1,
		-1,
		342,
		311,
		340,
		298,
		279,
		-1,
		245,
		225,
		231,
		235,
		229,
		222,
		236,
		232,
		-1,
		207,
		206,
		234,
		220,
		231,
		302,
		-1,
		-1,
		300,
		292,
		275,
		278,
		255,
		251,
		240,
		239,
		231,
		217,
		213,
		219,
		222,
		222,
		228,
		201,
		211,
		215,
		213,
		238,
		-1,
		-1,
		273,
		-1,
		-1,
		299,
		282,
		-1,
		265,
		272,
		261,
		267,
		253,
		274,
		250,
		241,
		233,
		227,
		215,
		217,
		214,
		227,
		215,
		198,
		223,
		227,
		208,
		229,
		224,
		-1,
		272,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		258,
		261,
		267,
		291,
		290,
		-1,
		262,
		250,
		251,
		236,
		233,
		220,
		208,
		221,
		206,
		213,
		212,
		202,
		200,
		230,
		205,
		227,
		224,
		243,
		248,
		242,
		251,
		-1,
		307,
		303,
		299,
		306,
		255,
		-1,
		-1,
		295,
		-1,
		298,
		299,
		274,
		247,
		250,
		237,
		228,
		215,
		204,
		215,
		204,
		201,
		209,
		194,
		209,
		200,
		199,
		217,
		227,
		235,
		239,
		245,
		-1,
		357,
		-1,
		299,
		283,
		285,
		257,
		278,
		-1,
		315,
		299,
		291,
		276,
		276,
		-1,
		246,
		243,
		233,
		211,
		196,
		213,
		205,
		203,
		207,
		189,
		203,
		194,
		212,
		219,
		217,
		221,
		241,
		253,
		317,
		307,
		-1,
		289,
		294,
		253,
		261,
		280,
		318,
		282,
		-1,
		277,
		-1,
		248,
		261,
		-1,
		217,
		213,
		195,
		196,
		191,
		206,
		200,
		185,
		182,
		200,
		203,
		210,
		214,
		230,
		-1,
		-1,
		302,
		306,
		295,
		246,
		265,
		289,
		326,
		275,
		264,
		263,
		-1,
		254,
		231,
		228,
		216,
		203,
		188,
		189,
		197,
		210,
		189,
		184,
		181,
		201,
		227,
		205,
		217,
		-1,
		-1,
		-1,
		327,
		-1,
		-1,
		272,
		243,
		267,
		309,
		293,
		286,
		274,
		239,
		239,
		233,
		-1,
		227,
		206,
		197,
		186,
		184,
		197,
		194,
		199,
		179,
		177,
		196,
		208,
		199,
		216,
		-1,
		-1,
		-1,
		302,
		291,
		292,
		238,
		261,
		298,
		272,
		258,
		263,
		238,
		231,
		225,
		240,
		223,
		204,
		193,
		185,
		174,
		190,
		198,
		193,
		175,
		184,
		190,
		214,
		204,
		210,
		-1,
		-1,
		309,
		299,
		283,
		285,
		282,
		252,
		259,
		291,
		263,
		276,
		-1,
		230,
		-1,
		219,
		214,
		198,
		193,
		190,
		187,
		181,
		190,
		192,
		182,
		177,
		184,
		219,
		219,
		194,
		214,
		217,
		-1,
		-1,
		-1,
		302,
		297,
		272,
		249,
		233,
		269,
		-1,
		246,
		247,
		-1,
		224,
		218,
		215,
		200,
		196,
		191,
		195,
		188,
		195,
		188,
		186,
		187,
		169,
		201,
		-1,
		202,
		196,
		204,
		194,
		182,
		-1,
		-1,
		-1,
		295,
		274,
		267,
		287,
		228,
		280,
		-1,
		-1,
		231,
		224,
		-1,
		211,
		193,
		200,
		198,
		192,
		196,
		193,
		182,
		195,
		188,
		174,
		176,
		189,
		193,
		197,
		184,
		180,
		177,
		191,
		-1,
		314,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		248,
		-1,
		240,
		232,
		222,
		216,
		210,
		206,
		204,
		220,
		204,
		207,
		205,
		196,
		204,
		177,
		170,
		177,
		166,
		184,
		192,
		184,
		178,
		177,
		187,
		-1,
		315,
		301,
		272,
		-1,
		-1,
		261,
		-1,
		225,
		239,
		255,
		-1,
		248,
		227,
		242,
		220,
		216,
		212,
		227,
		228,
		205,
		205,
		203,
		194,
		182,
		171,
		174,
		166,
		188,
		188,
		172,
		173,
		177,
		-1,
		321,
		308,
		266,
		262,
		251,
		271,
		222,
		210,
		242,
		-1,
		-1,
		284,
		-1,
		218,
		235,
		226,
		224,
		217,
		199,
		206,
		214,
		191,
		186,
		176,
		165,
		165,
		160,
		182,
		168,
		166,
		175,
		191,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		237,
		224,
		218,
		-1,
		259,
		-1,
		262,
		252,
		236,
		221,
		254,
		-1,
		198,
		194,
		201,
		-1,
		211,
		-1,
		184,
		181,
		172,
		157,
		154,
		165,
		163,
		174,
		170,
		-1,
		271,
		256,
		249,
		239,
		253,
		224,
		-1,
		279,
		-1,
		-1,
		249,
		243,
		243,
		227,
		228,
		214,
		194,
		186,
		201,
		200,
		187,
		186,
		170,
		163,
		160,
		153,
		166,
		176,
		181,
		168,
		-1,
		-1,
		-1,
		276,
		262,
		266,
		226,
		245,
		-1,
		-1,
		311,
		266,
		252,
		-1,
		223,
		214,
		202,
		192,
		182,
		187,
		188,
		178,
		176,
		168,
		170,
		164,
		155,
		154,
		170,
		162,
		184,
		-1,
		-1,
		259,
		264,
		252,
		238,
		240,
		-1,
		-1,
		-1,
		258,
		274,
		242,
		221,
		203,
		-1,
		-1,
		186,
		179,
		173,
		176,
		164,
		184,
		179,
		163,
		148,
		163,
		167,
		175,
		166,
		-1,
		262,
		249,
		-1,
		-1,
		239,
		229,
		-1,
		-1,
		-1,
		-1,
		254,
		199,
		188,
		183,
		187,
		185,
		-1,
		159,
		170,
		163,
		182,
		189,
		165,
		150,
		144,
		150,
		162,
		171,
		-1,
		-1,
		253,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		211,
		205,
		176,
		169,
		173,
		-1,
		161,
		163,
		160,
		172,
		168,
		165,
		156,
		147,
		143,
		147,
		151,
		165,
		169,
		276,
		-1,
		206,
		-1,
		-1,
		-1,
		229,
		244,
		215,
		192,
		165,
		160,
		153,
		147,
		152,
		163,
		172,
		183,
		148,
		150,
		140,
		139,
		143,
		160,
		164,
		-1,
		-1,
		204,
		200,
		235,
		237,
		241,
		242,
		-1,
		-1,
		169,
		160,
		151,
		143,
		156,
		159,
		144,
		146,
		146,
		144,
		138,
		148,
		163,
		158,
		-1,
		-1,
		-1,
		216,
		-1,
		218,
		-1,
		-1,
		237,
		240,
		187,
		169,
		165,
		163,
		152,
		146,
		134,
		139,
		149,
		143,
		140,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		198,
		187,
		182,
		216,
		221,
		212,
		202,
		199,
		-1,
		169,
		175,
		140,
		147,
		130,
		137,
		142,
		139,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		191,
		184,
		202,
		192,
		198,
		-1,
		-1,
		194,
		191,
		171,
		140,
		138,
		131,
		126,
		136,
		112,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		181,
		173,
		181,
		184,
		191,
		-1,
		-1,
		167,
		158,
		159,
		147,
		144,
		150,
		149,
		132,
		138,
		139,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		172,
		-1,
		-1,
		141,
		192,
		176,
		166,
		163,
		206,
		161,
		156,
		137,
		135,
		130,
		121,
		146,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		131,
		-1,
		203,
		-1,
		186,
		190,
		169,
		172,
		151,
		138,
		124,
		132,
		138,
		137,
		143,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		156,
		192,
		137,
		-1,
		121,
		-1,
		-1,
		-1,
		200,
		182,
		174,
		171,
		150,
		150,
		116,
		120,
		133,
		140,
		150,
		161,
		153,
		157,
		170,
		181,
		184,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		152,
		149,
		186,
		144,
		133,
		128,
		115,
		-1,
		-1,
		184,
		192,
		-1,
		-1,
		157,
		124,
		112,
		122,
		126,
		140,
		152,
		165,
		153,
		158,
		152,
		184,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		150,
		177,
		161,
		165,
		175,
		200,
		-1,
		99,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		129,
		118,
		109,
		114,
		134,
		145,
		167,
		149,
		166,
		157,
		167,
		171,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		132,
		135,
		141,
		148,
		165,
		189,
		-1,
		-1,
		115,
		95,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		106,
		111,
		141,
		143,
		145,
		152,
		146,
		153,
		161,
		172,
		164,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		105,
		101,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		128,
		128,
		131,
		136,
		144,
		155,
		151,
		155,
		158,
		-1,
		208,
		-1,
		160,
		121,
		127,
		142,
		150,
		-1,
		-1,
		-1,
		122,
		108,
		101,
		89,
		87,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		164,
		132,
		137,
		132,
		147,
		158,
		149,
		157,
		151,
		154,
		-1,
		-1,
		120,
		103,
		-1,
		-1,
		77,
		79,
		-1,
		113,
		102,
		87,
		79,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		98,
		136,
		135,
		143,
		138,
		143,
		155,
		151,
		147,
		157,
		148,
		-1,
		-1,
		98,
		90,
		84,
		-1,
		62,
		-1,
		115,
		-1,
		82,
		89,
		77,
		-1,
		-1,
		-1,
		129,
		92,
		108,
		131,
		157,
		155,
		146,
		139,
		146,
		149,
		142,
		148,
		-1,
		-1,
		-1,
		80,
		54,
		122,
		113,
		96,
		76,
		68,
		88,
		-1,
		110,
		-1,
		85,
		88,
		113,
		152,
		154,
		140,
		136,
		149,
		143,
		140,
		138,
		86,
		-1,
		51,
		84,
		0,
		82,
		48,
		60,
		124,
		-1,
		107,
		89,
		-1,
		117,
		107,
		155,
		130,
		139,
		132,
		126,
		127,
		135,
		-1,
		-1,
		-1,
		53,
		52,
		44,
		38,
		43,
		41,
		59,
		-1,
		112,
		94,
		80,
		97,
		97,
		88,
		96,
		145,
		141,
		144,
		142,
		120,
		-1,
		174,
		-1,
		-1,
		76,
		-1,
		-1,
		-1,
		47,
		74,
		69,
		61,
		73,
		82,
		77,
		79,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		169,
		-1,
		83,
		-1,
		-1,
		70,
		56,
		68,
		79,
		69,
		69,
		74,
		72,
		94,
		124,
		110,
		108,
		113,
		118,
		-1,
		158,
		157,
		-1,
		89,
		81,
		67,
		-1,
		60,
		-1,
		115,
		76,
		-1,
		101,
		81,
		-1,
		119,
		115,
		-1,
		-1,
		145,
		105,
		-1,
		-1,
		-1,
		90,
		70,
		110,
		94,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		130,
		114,
		-1,
		83,
		86,
		-1,
		77,
		83,
		112,
		94,
		98,
		-1,
		-1,
		-1,
		139,
		120,
		114,
		98,
		103,
		91,
		108,
		94,
		96,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		111,
		103,
		103,
		-1,
		-1,
		121,
		104,
		104,
		117,
		-1,
		-1,
		-1,
		133,
		114,
		-1,
		-1,
		112,
		-1,
		-1,
		117,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		122,
		-1,
		-1,
		-1,
		113,
		120,
		128,
		-1,
		-1,
		-1,
		-1,
		143,
		144,
		168,
		143,
		-1,
		-1,
		-1,
		127,
		127,
		-1,
		-1,
		146,
		144,
		-1,
		-1,
		-1,
		155,
		139,
		-1,
		131,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		160,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		173,
		165,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		156,
		163,
		185,
		188,
		218,
		-1,
		175
	],
	[
		-1,
		283,
		272,
		283,
		291,
		264,
		271,
		-1,
		290,
		294,
		260,
		254,
		293,
		262,
		268,
		279,
		-1,
		-1,
		-1,
		283,
		282,
		250,
		248,
		257,
		262,
		269,
		-1,
		268,
		-1,
		304,
		283,
		294,
		299,
		243,
		240,
		260,
		279,
		261,
		253,
		319,
		273,
		244,
		238,
		256,
		246,
		255,
		247,
		-1,
		244,
		234,
		256,
		235,
		246,
		238,
		-1,
		-1,
		238,
		239,
		245,
		231,
		237,
		233,
		-1,
		243,
		227,
		-1,
		-1,
		228,
		229,
		213,
		216,
		224,
		222,
		235,
		227,
		222,
		-1,
		-1,
		219,
		215,
		222,
		209,
		205,
		222,
		235,
		217,
		231,
		230,
		-1,
		223,
		241,
		248,
		216,
		214,
		198,
		196,
		214,
		216,
		222,
		222,
		-1,
		232,
		233,
		228,
		236,
		238,
		214,
		201,
		201,
		211,
		204,
		223,
		211,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		232,
		215,
		232,
		224,
		214,
		229,
		222,
		204,
		201,
		199,
		196,
		212,
		210,
		220,
		-1,
		-1,
		325,
		294,
		323,
		281,
		262,
		-1,
		228,
		208,
		214,
		218,
		212,
		205,
		219,
		215,
		-1,
		190,
		189,
		217,
		203,
		214,
		285,
		-1,
		-1,
		283,
		275,
		258,
		261,
		238,
		234,
		223,
		222,
		214,
		200,
		196,
		202,
		205,
		205,
		211,
		184,
		194,
		198,
		196,
		221,
		-1,
		-1,
		256,
		-1,
		-1,
		282,
		265,
		-1,
		248,
		255,
		244,
		250,
		236,
		257,
		233,
		224,
		216,
		210,
		198,
		200,
		197,
		210,
		198,
		181,
		206,
		210,
		191,
		212,
		207,
		-1,
		255,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		241,
		244,
		250,
		274,
		273,
		-1,
		245,
		233,
		234,
		219,
		216,
		203,
		191,
		204,
		189,
		196,
		195,
		185,
		183,
		213,
		188,
		210,
		207,
		226,
		231,
		225,
		234,
		-1,
		290,
		286,
		282,
		289,
		238,
		-1,
		-1,
		278,
		-1,
		281,
		282,
		257,
		230,
		233,
		220,
		211,
		198,
		187,
		198,
		187,
		184,
		192,
		177,
		192,
		183,
		182,
		200,
		210,
		218,
		222,
		228,
		-1,
		340,
		-1,
		282,
		266,
		268,
		240,
		261,
		-1,
		298,
		282,
		274,
		259,
		259,
		-1,
		229,
		226,
		216,
		194,
		179,
		196,
		188,
		186,
		190,
		172,
		186,
		177,
		195,
		202,
		200,
		204,
		224,
		236,
		300,
		290,
		-1,
		272,
		277,
		236,
		244,
		263,
		301,
		265,
		-1,
		260,
		-1,
		231,
		244,
		-1,
		200,
		196,
		178,
		179,
		174,
		189,
		183,
		168,
		165,
		183,
		186,
		193,
		197,
		213,
		-1,
		-1,
		285,
		289,
		278,
		229,
		248,
		272,
		309,
		258,
		247,
		246,
		-1,
		237,
		214,
		211,
		199,
		186,
		171,
		172,
		180,
		193,
		172,
		167,
		164,
		184,
		210,
		188,
		200,
		-1,
		-1,
		-1,
		310,
		-1,
		-1,
		255,
		226,
		250,
		292,
		276,
		269,
		257,
		222,
		222,
		216,
		-1,
		210,
		189,
		180,
		169,
		167,
		180,
		177,
		182,
		162,
		160,
		179,
		191,
		182,
		199,
		-1,
		-1,
		-1,
		285,
		274,
		275,
		221,
		244,
		281,
		255,
		241,
		246,
		221,
		214,
		208,
		223,
		206,
		187,
		176,
		168,
		157,
		173,
		181,
		176,
		158,
		167,
		173,
		197,
		187,
		193,
		-1,
		-1,
		292,
		282,
		266,
		268,
		265,
		235,
		242,
		274,
		246,
		259,
		-1,
		213,
		-1,
		202,
		197,
		181,
		176,
		173,
		170,
		164,
		173,
		175,
		165,
		160,
		167,
		202,
		202,
		177,
		197,
		200,
		-1,
		-1,
		-1,
		285,
		280,
		255,
		232,
		216,
		252,
		-1,
		229,
		230,
		-1,
		207,
		201,
		198,
		183,
		179,
		174,
		178,
		171,
		178,
		171,
		169,
		170,
		152,
		184,
		-1,
		185,
		179,
		187,
		177,
		165,
		-1,
		-1,
		-1,
		278,
		257,
		250,
		270,
		211,
		263,
		-1,
		-1,
		214,
		207,
		-1,
		194,
		176,
		183,
		181,
		175,
		179,
		176,
		165,
		178,
		171,
		157,
		159,
		172,
		176,
		180,
		167,
		163,
		160,
		174,
		-1,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		231,
		-1,
		223,
		215,
		205,
		199,
		193,
		189,
		187,
		203,
		187,
		190,
		188,
		179,
		187,
		160,
		153,
		160,
		149,
		167,
		175,
		167,
		161,
		160,
		170,
		-1,
		298,
		284,
		255,
		-1,
		-1,
		244,
		-1,
		208,
		222,
		238,
		-1,
		231,
		210,
		225,
		203,
		199,
		195,
		210,
		211,
		188,
		188,
		186,
		177,
		165,
		154,
		157,
		149,
		171,
		171,
		155,
		156,
		160,
		-1,
		304,
		291,
		249,
		245,
		234,
		254,
		205,
		193,
		225,
		-1,
		-1,
		267,
		-1,
		201,
		218,
		209,
		207,
		200,
		182,
		189,
		197,
		174,
		169,
		159,
		148,
		148,
		143,
		165,
		151,
		149,
		158,
		174,
		-1,
		-1,
		-1,
		271,
		-1,
		-1,
		220,
		207,
		201,
		-1,
		242,
		-1,
		245,
		235,
		219,
		204,
		237,
		-1,
		181,
		177,
		184,
		-1,
		194,
		-1,
		167,
		164,
		155,
		140,
		137,
		148,
		146,
		157,
		153,
		-1,
		254,
		239,
		232,
		222,
		236,
		207,
		-1,
		260,
		-1,
		-1,
		232,
		226,
		226,
		210,
		211,
		197,
		177,
		169,
		184,
		183,
		170,
		169,
		153,
		146,
		143,
		136,
		149,
		159,
		164,
		151,
		-1,
		-1,
		-1,
		259,
		245,
		249,
		209,
		226,
		-1,
		-1,
		294,
		249,
		235,
		-1,
		206,
		197,
		185,
		175,
		165,
		170,
		171,
		161,
		159,
		151,
		153,
		147,
		138,
		137,
		153,
		145,
		167,
		-1,
		-1,
		242,
		247,
		235,
		204,
		199,
		-1,
		-1,
		-1,
		241,
		257,
		225,
		204,
		186,
		-1,
		-1,
		169,
		162,
		156,
		159,
		147,
		167,
		162,
		146,
		131,
		146,
		150,
		158,
		149,
		-1,
		245,
		232,
		-1,
		-1,
		198,
		188,
		-1,
		-1,
		-1,
		-1,
		237,
		182,
		171,
		166,
		170,
		168,
		-1,
		142,
		153,
		146,
		165,
		172,
		148,
		133,
		127,
		133,
		145,
		154,
		-1,
		-1,
		212,
		-1,
		174,
		-1,
		-1,
		-1,
		-1,
		194,
		188,
		159,
		152,
		156,
		-1,
		144,
		146,
		143,
		155,
		151,
		148,
		139,
		130,
		126,
		130,
		134,
		148,
		152,
		235,
		-1,
		165,
		-1,
		-1,
		-1,
		211,
		227,
		198,
		175,
		148,
		143,
		136,
		130,
		135,
		146,
		155,
		166,
		131,
		133,
		123,
		122,
		126,
		143,
		147,
		-1,
		-1,
		163,
		159,
		194,
		206,
		206,
		225,
		-1,
		-1,
		152,
		143,
		134,
		126,
		139,
		142,
		127,
		129,
		129,
		127,
		121,
		131,
		146,
		141,
		-1,
		-1,
		-1,
		175,
		-1,
		177,
		-1,
		-1,
		196,
		223,
		170,
		152,
		148,
		146,
		135,
		129,
		117,
		122,
		132,
		126,
		123,
		117,
		121,
		144,
		133,
		172,
		-1,
		-1,
		260,
		-1,
		-1,
		-1,
		182,
		146,
		141,
		175,
		180,
		171,
		185,
		182,
		-1,
		152,
		158,
		123,
		130,
		113,
		120,
		125,
		122,
		111,
		118,
		134,
		133,
		128,
		164,
		155,
		161,
		-1,
		-1,
		253,
		242,
		231,
		237,
		-1,
		175,
		143,
		161,
		151,
		157,
		-1,
		-1,
		177,
		174,
		154,
		123,
		121,
		114,
		109,
		119,
		95,
		107,
		111,
		115,
		121,
		126,
		131,
		137,
		152,
		167,
		-1,
		207,
		244,
		237,
		205,
		213,
		244,
		-1,
		165,
		157,
		140,
		143,
		151,
		-1,
		-1,
		150,
		141,
		142,
		130,
		127,
		133,
		132,
		115,
		121,
		122,
		114,
		113,
		131,
		135,
		144,
		151,
		141,
		154,
		158,
		-1,
		200,
		220,
		199,
		202,
		226,
		240,
		-1,
		162,
		-1,
		-1,
		100,
		164,
		159,
		149,
		146,
		189,
		144,
		139,
		120,
		118,
		113,
		104,
		129,
		122,
		122,
		125,
		140,
		145,
		137,
		151,
		151,
		152,
		-1,
		189,
		200,
		193,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		-1,
		90,
		-1,
		186,
		-1,
		169,
		173,
		152,
		155,
		134,
		121,
		107,
		115,
		121,
		120,
		126,
		126,
		127,
		136,
		147,
		159,
		158,
		159,
		214,
		170,
		173,
		184,
		195,
		210,
		214,
		-1,
		174,
		213,
		96,
		-1,
		80,
		-1,
		-1,
		-1,
		183,
		165,
		157,
		154,
		133,
		133,
		99,
		103,
		116,
		123,
		133,
		144,
		136,
		140,
		153,
		164,
		167,
		210,
		201,
		214,
		159,
		159,
		180,
		189,
		210,
		174,
		171,
		207,
		103,
		92,
		87,
		74,
		-1,
		-1,
		167,
		175,
		-1,
		-1,
		140,
		107,
		95,
		105,
		109,
		123,
		135,
		148,
		136,
		141,
		135,
		167,
		-1,
		203,
		202,
		191,
		188,
		164,
		155,
		150,
		177,
		-1,
		-1,
		172,
		199,
		159,
		136,
		134,
		159,
		-1,
		58,
		-1,
		-1,
		147,
		-1,
		-1,
		132,
		112,
		101,
		92,
		97,
		117,
		128,
		150,
		132,
		149,
		140,
		150,
		154,
		187,
		184,
		172,
		170,
		193,
		158,
		146,
		-1,
		154,
		157,
		163,
		157,
		137,
		148,
		-1,
		-1,
		74,
		54,
		-1,
		-1,
		130,
		128,
		117,
		-1,
		107,
		89,
		94,
		124,
		126,
		128,
		135,
		129,
		136,
		144,
		155,
		147,
		196,
		210,
		199,
		195,
		194,
		202,
		151,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		-1,
		60,
		60,
		-1,
		-1,
		125,
		118,
		106,
		94,
		84,
		94,
		111,
		111,
		114,
		119,
		127,
		138,
		134,
		138,
		141,
		-1,
		230,
		-1,
		182,
		143,
		149,
		164,
		172,
		-1,
		-1,
		-1,
		77,
		63,
		56,
		44,
		42,
		-1,
		159,
		143,
		124,
		-1,
		94,
		107,
		147,
		115,
		120,
		115,
		130,
		141,
		132,
		140,
		134,
		137,
		-1,
		-1,
		142,
		125,
		-1,
		-1,
		99,
		101,
		-1,
		68,
		57,
		42,
		34,
		-1,
		-1,
		131,
		127,
		-1,
		-1,
		81,
		119,
		118,
		126,
		121,
		126,
		138,
		134,
		130,
		140,
		131,
		-1,
		-1,
		120,
		112,
		106,
		-1,
		84,
		-1,
		33,
		-1,
		37,
		53,
		55,
		-1,
		-1,
		-1,
		112,
		75,
		91,
		114,
		140,
		138,
		129,
		122,
		129,
		132,
		125,
		131,
		-1,
		-1,
		-1,
		102,
		76,
		40,
		31,
		14,
		6,
		16,
		70,
		-1,
		93,
		-1,
		68,
		71,
		96,
		135,
		137,
		123,
		119,
		132,
		126,
		123,
		121,
		108,
		-1,
		78,
		111,
		75,
		0,
		43,
		48,
		107,
		-1,
		90,
		72,
		-1,
		100,
		90,
		138,
		113,
		122,
		115,
		109,
		110,
		118,
		-1,
		-1,
		-1,
		80,
		79,
		71,
		65,
		63,
		48,
		43,
		-1,
		95,
		77,
		63,
		80,
		80,
		71,
		79,
		128,
		124,
		127,
		125,
		103,
		-1,
		194,
		-1,
		-1,
		103,
		-1,
		-1,
		-1,
		74,
		83,
		56,
		44,
		58,
		65,
		60,
		62,
		75,
		83,
		81,
		78,
		90,
		86,
		106,
		102,
		134,
		-1,
		189,
		-1,
		110,
		-1,
		-1,
		90,
		76,
		78,
		67,
		56,
		54,
		57,
		55,
		77,
		107,
		93,
		91,
		96,
		101,
		-1,
		178,
		177,
		-1,
		109,
		101,
		87,
		-1,
		80,
		-1,
		102,
		63,
		-1,
		84,
		64,
		-1,
		102,
		98,
		-1,
		-1,
		165,
		125,
		-1,
		-1,
		-1,
		110,
		90,
		97,
		81,
		-1,
		75,
		75,
		-1,
		-1,
		-1,
		150,
		134,
		-1,
		103,
		106,
		-1,
		97,
		103,
		130,
		77,
		81,
		-1,
		-1,
		-1,
		159,
		140,
		134,
		118,
		123,
		111,
		128,
		114,
		113,
		91,
		80,
		101,
		-1,
		-1,
		-1,
		131,
		123,
		123,
		-1,
		-1,
		138,
		121,
		102,
		100,
		-1,
		-1,
		-1,
		153,
		134,
		-1,
		-1,
		128,
		-1,
		-1,
		134,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		142,
		-1,
		-1,
		-1,
		124,
		120,
		121,
		-1,
		-1,
		-1,
		-1,
		163,
		164,
		188,
		163,
		-1,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		166,
		164,
		-1,
		-1,
		-1,
		144,
		128,
		-1,
		114,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		149,
		-1,
		149,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		162,
		154,
		162,
		-1,
		134,
		136,
		-1,
		184,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		139,
		146,
		168,
		171,
		207,
		-1,
		158
	],
	[
		-1,
		255,
		244,
		255,
		263,
		236,
		243,
		-1,
		262,
		266,
		232,
		226,
		265,
		234,
		240,
		251,
		-1,
		-1,
		-1,
		255,
		254,
		222,
		220,
		229,
		234,
		241,
		-1,
		240,
		-1,
		276,
		255,
		266,
		271,
		215,
		212,
		232,
		251,
		233,
		225,
		291,
		245,
		216,
		210,
		228,
		218,
		227,
		219,
		-1,
		216,
		206,
		228,
		207,
		218,
		210,
		-1,
		-1,
		210,
		211,
		217,
		203,
		209,
		205,
		-1,
		215,
		199,
		-1,
		-1,
		200,
		201,
		185,
		188,
		196,
		194,
		207,
		199,
		194,
		-1,
		-1,
		191,
		187,
		194,
		181,
		177,
		194,
		207,
		189,
		203,
		202,
		-1,
		195,
		213,
		220,
		188,
		186,
		170,
		168,
		186,
		188,
		194,
		194,
		-1,
		204,
		205,
		200,
		208,
		210,
		186,
		173,
		173,
		183,
		176,
		195,
		183,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		204,
		187,
		204,
		196,
		186,
		201,
		194,
		176,
		173,
		171,
		168,
		184,
		182,
		192,
		-1,
		-1,
		297,
		266,
		295,
		253,
		234,
		-1,
		200,
		180,
		186,
		190,
		184,
		177,
		191,
		187,
		-1,
		162,
		161,
		189,
		175,
		186,
		257,
		-1,
		-1,
		255,
		247,
		230,
		233,
		210,
		206,
		195,
		194,
		186,
		172,
		168,
		174,
		177,
		177,
		183,
		156,
		166,
		170,
		168,
		193,
		-1,
		-1,
		228,
		-1,
		-1,
		254,
		237,
		-1,
		220,
		227,
		216,
		222,
		208,
		229,
		205,
		196,
		188,
		182,
		170,
		172,
		169,
		182,
		170,
		153,
		178,
		182,
		163,
		184,
		179,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		213,
		216,
		222,
		246,
		245,
		-1,
		217,
		205,
		206,
		191,
		188,
		175,
		163,
		176,
		161,
		168,
		167,
		157,
		155,
		185,
		160,
		182,
		179,
		198,
		203,
		197,
		206,
		-1,
		262,
		258,
		254,
		261,
		210,
		-1,
		-1,
		250,
		-1,
		253,
		254,
		229,
		202,
		205,
		192,
		183,
		170,
		159,
		170,
		159,
		156,
		164,
		149,
		164,
		155,
		154,
		172,
		182,
		190,
		194,
		200,
		-1,
		312,
		-1,
		254,
		238,
		240,
		212,
		233,
		-1,
		270,
		254,
		246,
		231,
		231,
		-1,
		201,
		198,
		188,
		166,
		151,
		168,
		160,
		158,
		162,
		144,
		158,
		149,
		167,
		174,
		172,
		176,
		196,
		208,
		272,
		262,
		-1,
		244,
		249,
		208,
		216,
		235,
		273,
		237,
		-1,
		232,
		-1,
		203,
		216,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		155,
		140,
		137,
		155,
		158,
		165,
		169,
		185,
		-1,
		-1,
		257,
		261,
		250,
		201,
		220,
		244,
		281,
		230,
		219,
		218,
		-1,
		209,
		186,
		183,
		171,
		158,
		143,
		144,
		152,
		165,
		144,
		139,
		136,
		156,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		227,
		198,
		222,
		264,
		248,
		241,
		229,
		194,
		194,
		188,
		-1,
		182,
		161,
		152,
		141,
		139,
		152,
		149,
		154,
		134,
		132,
		151,
		163,
		154,
		171,
		-1,
		-1,
		-1,
		257,
		246,
		247,
		193,
		216,
		253,
		227,
		213,
		218,
		193,
		186,
		180,
		195,
		178,
		159,
		148,
		140,
		129,
		145,
		153,
		148,
		130,
		139,
		145,
		169,
		159,
		165,
		-1,
		-1,
		264,
		254,
		238,
		240,
		237,
		207,
		214,
		246,
		218,
		231,
		-1,
		185,
		-1,
		174,
		169,
		153,
		148,
		145,
		142,
		136,
		145,
		147,
		137,
		132,
		139,
		174,
		174,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		257,
		252,
		227,
		204,
		188,
		224,
		-1,
		201,
		202,
		-1,
		179,
		173,
		170,
		155,
		151,
		146,
		150,
		143,
		150,
		143,
		141,
		142,
		124,
		156,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		250,
		229,
		222,
		242,
		183,
		235,
		-1,
		-1,
		186,
		179,
		-1,
		166,
		148,
		155,
		153,
		147,
		151,
		148,
		137,
		150,
		143,
		129,
		131,
		144,
		148,
		152,
		139,
		135,
		132,
		146,
		-1,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		203,
		-1,
		195,
		187,
		177,
		171,
		165,
		161,
		159,
		175,
		159,
		162,
		160,
		151,
		159,
		132,
		125,
		132,
		121,
		139,
		147,
		139,
		133,
		132,
		142,
		-1,
		270,
		256,
		227,
		-1,
		-1,
		216,
		-1,
		180,
		194,
		210,
		-1,
		203,
		182,
		197,
		175,
		171,
		167,
		182,
		183,
		160,
		160,
		158,
		149,
		137,
		126,
		129,
		121,
		143,
		143,
		127,
		128,
		132,
		-1,
		276,
		263,
		221,
		217,
		206,
		226,
		177,
		165,
		197,
		-1,
		-1,
		239,
		-1,
		173,
		190,
		181,
		179,
		172,
		154,
		161,
		169,
		146,
		141,
		131,
		120,
		120,
		115,
		137,
		123,
		121,
		130,
		146,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		192,
		179,
		173,
		-1,
		214,
		-1,
		217,
		207,
		191,
		176,
		209,
		-1,
		153,
		149,
		156,
		-1,
		166,
		-1,
		139,
		136,
		127,
		112,
		109,
		120,
		118,
		129,
		125,
		-1,
		226,
		211,
		204,
		194,
		208,
		179,
		-1,
		234,
		-1,
		-1,
		204,
		198,
		198,
		182,
		183,
		169,
		149,
		141,
		156,
		155,
		142,
		141,
		125,
		118,
		115,
		108,
		121,
		131,
		136,
		123,
		-1,
		-1,
		-1,
		231,
		217,
		221,
		181,
		200,
		-1,
		-1,
		266,
		221,
		207,
		-1,
		178,
		169,
		157,
		147,
		137,
		142,
		143,
		133,
		131,
		123,
		125,
		119,
		110,
		109,
		125,
		117,
		139,
		-1,
		-1,
		214,
		219,
		207,
		193,
		194,
		-1,
		-1,
		-1,
		213,
		229,
		197,
		176,
		158,
		-1,
		-1,
		141,
		134,
		128,
		131,
		119,
		139,
		134,
		118,
		103,
		118,
		122,
		130,
		121,
		-1,
		217,
		204,
		-1,
		-1,
		193,
		183,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		118,
		137,
		144,
		120,
		105,
		99,
		105,
		117,
		126,
		-1,
		-1,
		207,
		-1,
		169,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		115,
		127,
		123,
		120,
		111,
		102,
		98,
		102,
		106,
		120,
		124,
		230,
		-1,
		160,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		127,
		138,
		103,
		105,
		95,
		94,
		98,
		115,
		119,
		-1,
		-1,
		158,
		154,
		189,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		99,
		101,
		101,
		99,
		93,
		103,
		118,
		113,
		-1,
		-1,
		-1,
		170,
		-1,
		172,
		-1,
		-1,
		191,
		195,
		142,
		124,
		120,
		118,
		107,
		101,
		89,
		94,
		104,
		98,
		95,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		219,
		-1,
		-1,
		-1,
		177,
		141,
		136,
		170,
		175,
		166,
		157,
		154,
		-1,
		124,
		130,
		95,
		102,
		85,
		92,
		97,
		94,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		212,
		201,
		190,
		196,
		-1,
		170,
		138,
		156,
		146,
		152,
		-1,
		-1,
		149,
		146,
		126,
		95,
		93,
		86,
		81,
		91,
		67,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		166,
		203,
		196,
		164,
		172,
		203,
		-1,
		160,
		152,
		135,
		138,
		146,
		-1,
		-1,
		122,
		113,
		114,
		102,
		99,
		105,
		104,
		87,
		93,
		94,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		159,
		179,
		158,
		161,
		185,
		199,
		-1,
		153,
		-1,
		-1,
		95,
		147,
		131,
		121,
		118,
		161,
		116,
		111,
		92,
		90,
		85,
		76,
		101,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		148,
		159,
		152,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		85,
		-1,
		158,
		-1,
		141,
		145,
		124,
		127,
		106,
		93,
		79,
		87,
		93,
		92,
		98,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		173,
		129,
		132,
		143,
		154,
		169,
		173,
		-1,
		137,
		173,
		91,
		-1,
		75,
		-1,
		-1,
		-1,
		155,
		137,
		129,
		126,
		105,
		105,
		71,
		75,
		88,
		95,
		105,
		116,
		108,
		112,
		125,
		136,
		139,
		169,
		160,
		173,
		118,
		118,
		139,
		148,
		169,
		133,
		130,
		167,
		98,
		87,
		82,
		69,
		-1,
		-1,
		139,
		147,
		-1,
		-1,
		112,
		79,
		67,
		77,
		81,
		95,
		107,
		120,
		108,
		113,
		107,
		139,
		-1,
		162,
		161,
		150,
		147,
		123,
		114,
		109,
		136,
		-1,
		-1,
		131,
		158,
		142,
		131,
		129,
		154,
		-1,
		53,
		-1,
		-1,
		119,
		-1,
		-1,
		104,
		84,
		73,
		64,
		69,
		89,
		100,
		122,
		104,
		121,
		112,
		122,
		126,
		146,
		143,
		131,
		129,
		152,
		117,
		105,
		-1,
		113,
		116,
		122,
		129,
		132,
		143,
		-1,
		-1,
		69,
		49,
		-1,
		-1,
		102,
		100,
		89,
		-1,
		79,
		61,
		66,
		96,
		98,
		100,
		107,
		101,
		108,
		116,
		127,
		119,
		155,
		169,
		158,
		154,
		153,
		161,
		110,
		103,
		110,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		74,
		-1,
		59,
		55,
		-1,
		-1,
		97,
		90,
		78,
		66,
		56,
		66,
		83,
		83,
		86,
		91,
		99,
		110,
		106,
		110,
		113,
		-1,
		189,
		-1,
		141,
		102,
		108,
		123,
		131,
		-1,
		-1,
		-1,
		76,
		62,
		55,
		43,
		41,
		-1,
		131,
		115,
		96,
		-1,
		66,
		79,
		119,
		87,
		92,
		87,
		102,
		113,
		104,
		112,
		106,
		109,
		-1,
		-1,
		101,
		84,
		-1,
		-1,
		58,
		60,
		-1,
		67,
		56,
		41,
		33,
		-1,
		-1,
		103,
		99,
		-1,
		-1,
		53,
		91,
		90,
		98,
		93,
		98,
		110,
		106,
		102,
		112,
		103,
		-1,
		-1,
		79,
		71,
		65,
		-1,
		43,
		-1,
		69,
		-1,
		36,
		46,
		34,
		-1,
		-1,
		-1,
		84,
		47,
		63,
		86,
		112,
		110,
		101,
		94,
		101,
		104,
		97,
		103,
		-1,
		-1,
		-1,
		61,
		35,
		76,
		67,
		50,
		30,
		22,
		45,
		-1,
		65,
		-1,
		40,
		43,
		68,
		107,
		109,
		95,
		91,
		104,
		98,
		95,
		93,
		67,
		-1,
		37,
		70,
		34,
		36,
		0,
		17,
		79,
		-1,
		62,
		44,
		-1,
		72,
		62,
		110,
		85,
		94,
		87,
		81,
		82,
		90,
		-1,
		-1,
		-1,
		39,
		38,
		30,
		24,
		20,
		7,
		14,
		-1,
		67,
		49,
		35,
		52,
		52,
		43,
		51,
		100,
		96,
		99,
		97,
		75,
		-1,
		153,
		-1,
		-1,
		62,
		-1,
		-1,
		-1,
		33,
		53,
		28,
		16,
		30,
		37,
		32,
		34,
		47,
		55,
		53,
		50,
		62,
		58,
		78,
		74,
		106,
		-1,
		148,
		-1,
		69,
		-1,
		-1,
		49,
		35,
		47,
		39,
		28,
		26,
		29,
		27,
		49,
		79,
		65,
		63,
		68,
		73,
		-1,
		137,
		136,
		-1,
		68,
		60,
		46,
		-1,
		39,
		-1,
		74,
		35,
		-1,
		56,
		36,
		-1,
		74,
		70,
		-1,
		-1,
		124,
		84,
		-1,
		-1,
		-1,
		69,
		49,
		69,
		53,
		-1,
		47,
		47,
		-1,
		-1,
		-1,
		109,
		93,
		-1,
		62,
		65,
		-1,
		56,
		62,
		91,
		49,
		53,
		-1,
		-1,
		-1,
		118,
		99,
		93,
		77,
		82,
		70,
		87,
		73,
		75,
		63,
		52,
		73,
		-1,
		-1,
		-1,
		90,
		82,
		82,
		-1,
		-1,
		100,
		83,
		74,
		72,
		-1,
		-1,
		-1,
		112,
		93,
		-1,
		-1,
		91,
		-1,
		-1,
		96,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		101,
		-1,
		-1,
		-1,
		92,
		92,
		93,
		-1,
		-1,
		-1,
		-1,
		122,
		123,
		147,
		122,
		-1,
		-1,
		-1,
		88,
		82,
		-1,
		-1,
		125,
		123,
		-1,
		-1,
		-1,
		116,
		100,
		-1,
		86,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		121,
		-1,
		121,
		96,
		103,
		-1,
		-1,
		-1,
		-1,
		134,
		126,
		134,
		-1,
		106,
		108,
		-1,
		156,
		-1,
		-1,
		149,
		140,
		-1,
		-1,
		111,
		118,
		140,
		143,
		179,
		-1,
		130
	],
	[
		-1,
		261,
		250,
		261,
		269,
		242,
		249,
		-1,
		268,
		272,
		238,
		232,
		271,
		240,
		246,
		257,
		-1,
		-1,
		-1,
		261,
		260,
		228,
		226,
		235,
		240,
		247,
		-1,
		246,
		-1,
		282,
		261,
		272,
		277,
		221,
		218,
		238,
		257,
		239,
		231,
		297,
		251,
		222,
		216,
		234,
		224,
		233,
		225,
		-1,
		222,
		212,
		234,
		213,
		224,
		216,
		-1,
		-1,
		216,
		217,
		223,
		209,
		215,
		211,
		-1,
		221,
		205,
		-1,
		-1,
		206,
		207,
		191,
		194,
		202,
		200,
		213,
		205,
		200,
		-1,
		-1,
		197,
		193,
		200,
		187,
		183,
		200,
		213,
		195,
		209,
		208,
		-1,
		201,
		219,
		226,
		194,
		192,
		176,
		174,
		192,
		194,
		200,
		200,
		-1,
		210,
		211,
		206,
		214,
		216,
		192,
		179,
		179,
		189,
		182,
		201,
		189,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		210,
		193,
		210,
		202,
		192,
		207,
		200,
		182,
		179,
		177,
		174,
		190,
		188,
		198,
		-1,
		-1,
		303,
		272,
		301,
		259,
		240,
		-1,
		206,
		186,
		192,
		196,
		190,
		183,
		197,
		193,
		-1,
		168,
		167,
		195,
		181,
		192,
		263,
		-1,
		-1,
		261,
		253,
		236,
		239,
		216,
		212,
		201,
		200,
		192,
		178,
		174,
		180,
		183,
		183,
		189,
		162,
		172,
		176,
		174,
		199,
		-1,
		-1,
		234,
		-1,
		-1,
		260,
		243,
		-1,
		226,
		233,
		222,
		228,
		214,
		235,
		211,
		202,
		194,
		188,
		176,
		178,
		175,
		188,
		176,
		159,
		184,
		188,
		169,
		190,
		185,
		-1,
		233,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		219,
		222,
		228,
		252,
		251,
		-1,
		223,
		211,
		212,
		197,
		194,
		181,
		169,
		182,
		167,
		174,
		173,
		163,
		161,
		191,
		166,
		188,
		185,
		204,
		209,
		203,
		212,
		-1,
		268,
		264,
		260,
		267,
		216,
		-1,
		-1,
		256,
		-1,
		259,
		260,
		235,
		208,
		211,
		198,
		189,
		176,
		165,
		176,
		165,
		162,
		170,
		155,
		170,
		161,
		160,
		178,
		188,
		196,
		200,
		206,
		-1,
		318,
		-1,
		260,
		244,
		246,
		218,
		239,
		-1,
		276,
		260,
		252,
		237,
		237,
		-1,
		207,
		204,
		194,
		172,
		157,
		174,
		166,
		164,
		168,
		150,
		164,
		155,
		173,
		180,
		178,
		182,
		202,
		214,
		278,
		268,
		-1,
		250,
		255,
		214,
		222,
		241,
		279,
		243,
		-1,
		238,
		-1,
		209,
		222,
		-1,
		178,
		174,
		156,
		157,
		152,
		167,
		161,
		146,
		143,
		161,
		164,
		171,
		175,
		191,
		-1,
		-1,
		263,
		267,
		256,
		207,
		226,
		250,
		287,
		236,
		225,
		224,
		-1,
		215,
		192,
		189,
		177,
		164,
		149,
		150,
		158,
		171,
		150,
		145,
		142,
		162,
		188,
		166,
		178,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		233,
		204,
		228,
		270,
		254,
		247,
		235,
		200,
		200,
		194,
		-1,
		188,
		167,
		158,
		147,
		145,
		158,
		155,
		160,
		140,
		138,
		157,
		169,
		160,
		177,
		-1,
		-1,
		-1,
		263,
		252,
		253,
		199,
		222,
		259,
		233,
		219,
		224,
		199,
		192,
		186,
		201,
		184,
		165,
		154,
		146,
		135,
		151,
		159,
		154,
		136,
		145,
		151,
		175,
		165,
		171,
		-1,
		-1,
		270,
		260,
		244,
		246,
		243,
		213,
		220,
		252,
		224,
		237,
		-1,
		191,
		-1,
		180,
		175,
		159,
		154,
		151,
		148,
		142,
		151,
		153,
		143,
		138,
		145,
		180,
		180,
		155,
		175,
		178,
		-1,
		-1,
		-1,
		263,
		258,
		233,
		210,
		194,
		230,
		-1,
		207,
		208,
		-1,
		185,
		179,
		176,
		161,
		157,
		152,
		156,
		149,
		156,
		149,
		147,
		148,
		130,
		162,
		-1,
		163,
		157,
		165,
		155,
		143,
		-1,
		-1,
		-1,
		256,
		235,
		228,
		248,
		189,
		241,
		-1,
		-1,
		192,
		185,
		-1,
		172,
		154,
		161,
		159,
		153,
		157,
		154,
		143,
		156,
		149,
		135,
		137,
		150,
		154,
		158,
		145,
		141,
		138,
		152,
		-1,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		209,
		-1,
		201,
		193,
		183,
		177,
		171,
		167,
		165,
		181,
		165,
		168,
		166,
		157,
		165,
		138,
		131,
		138,
		127,
		145,
		153,
		145,
		139,
		138,
		148,
		-1,
		276,
		262,
		233,
		-1,
		-1,
		222,
		-1,
		186,
		200,
		216,
		-1,
		209,
		188,
		203,
		181,
		177,
		173,
		188,
		189,
		166,
		166,
		164,
		155,
		143,
		132,
		135,
		127,
		149,
		149,
		133,
		134,
		138,
		-1,
		282,
		269,
		227,
		223,
		212,
		232,
		183,
		171,
		203,
		-1,
		-1,
		245,
		-1,
		179,
		196,
		187,
		185,
		178,
		160,
		167,
		175,
		152,
		147,
		137,
		126,
		126,
		121,
		143,
		129,
		127,
		136,
		152,
		-1,
		-1,
		-1,
		249,
		-1,
		-1,
		198,
		185,
		179,
		-1,
		220,
		-1,
		223,
		213,
		197,
		182,
		215,
		-1,
		159,
		155,
		162,
		-1,
		172,
		-1,
		145,
		142,
		133,
		118,
		115,
		126,
		124,
		135,
		131,
		-1,
		232,
		217,
		210,
		200,
		214,
		185,
		-1,
		240,
		-1,
		-1,
		210,
		204,
		204,
		188,
		189,
		175,
		155,
		147,
		162,
		161,
		148,
		147,
		131,
		124,
		121,
		114,
		127,
		137,
		142,
		129,
		-1,
		-1,
		-1,
		237,
		223,
		227,
		187,
		206,
		-1,
		-1,
		272,
		227,
		213,
		-1,
		184,
		175,
		163,
		153,
		143,
		148,
		149,
		139,
		137,
		129,
		131,
		125,
		116,
		115,
		131,
		123,
		145,
		-1,
		-1,
		220,
		225,
		213,
		199,
		196,
		-1,
		-1,
		-1,
		219,
		235,
		203,
		182,
		164,
		-1,
		-1,
		147,
		140,
		134,
		137,
		125,
		145,
		140,
		124,
		109,
		124,
		128,
		136,
		127,
		-1,
		223,
		210,
		-1,
		-1,
		195,
		185,
		-1,
		-1,
		-1,
		-1,
		215,
		160,
		149,
		144,
		148,
		146,
		-1,
		120,
		131,
		124,
		143,
		150,
		126,
		111,
		105,
		111,
		123,
		132,
		-1,
		-1,
		209,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		172,
		166,
		137,
		130,
		134,
		-1,
		122,
		124,
		121,
		133,
		129,
		126,
		117,
		108,
		104,
		108,
		112,
		126,
		130,
		232,
		-1,
		162,
		-1,
		-1,
		-1,
		190,
		205,
		176,
		153,
		126,
		121,
		114,
		108,
		113,
		124,
		133,
		144,
		109,
		111,
		101,
		100,
		104,
		121,
		125,
		-1,
		-1,
		160,
		156,
		191,
		198,
		202,
		203,
		-1,
		-1,
		130,
		121,
		112,
		104,
		117,
		120,
		105,
		107,
		107,
		105,
		99,
		109,
		124,
		119,
		-1,
		-1,
		-1,
		172,
		-1,
		174,
		-1,
		-1,
		193,
		201,
		148,
		130,
		126,
		124,
		113,
		107,
		95,
		100,
		110,
		104,
		101,
		95,
		99,
		122,
		111,
		150,
		-1,
		-1,
		239,
		-1,
		-1,
		-1,
		179,
		143,
		138,
		172,
		177,
		168,
		163,
		160,
		-1,
		130,
		136,
		101,
		108,
		91,
		98,
		103,
		100,
		89,
		96,
		112,
		111,
		106,
		142,
		133,
		139,
		-1,
		-1,
		232,
		221,
		210,
		216,
		-1,
		172,
		140,
		158,
		148,
		154,
		-1,
		-1,
		155,
		152,
		132,
		101,
		99,
		92,
		87,
		97,
		73,
		85,
		89,
		93,
		99,
		104,
		109,
		115,
		130,
		145,
		-1,
		186,
		223,
		216,
		184,
		192,
		223,
		-1,
		162,
		154,
		137,
		140,
		148,
		-1,
		-1,
		128,
		119,
		120,
		108,
		105,
		111,
		110,
		93,
		99,
		100,
		92,
		91,
		109,
		113,
		122,
		129,
		119,
		132,
		136,
		-1,
		179,
		199,
		178,
		181,
		205,
		219,
		-1,
		159,
		-1,
		-1,
		97,
		153,
		137,
		127,
		124,
		167,
		122,
		117,
		98,
		96,
		91,
		82,
		107,
		100,
		100,
		103,
		118,
		123,
		115,
		129,
		129,
		130,
		-1,
		168,
		179,
		172,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		87,
		-1,
		164,
		-1,
		147,
		151,
		130,
		133,
		112,
		99,
		85,
		93,
		99,
		98,
		104,
		104,
		105,
		114,
		125,
		137,
		136,
		137,
		193,
		149,
		152,
		163,
		174,
		189,
		193,
		-1,
		157,
		193,
		93,
		-1,
		77,
		-1,
		-1,
		-1,
		161,
		143,
		135,
		132,
		111,
		111,
		77,
		81,
		94,
		101,
		111,
		122,
		114,
		118,
		131,
		142,
		145,
		189,
		180,
		193,
		138,
		138,
		159,
		168,
		189,
		153,
		150,
		187,
		100,
		89,
		84,
		71,
		-1,
		-1,
		145,
		153,
		-1,
		-1,
		118,
		85,
		73,
		83,
		87,
		101,
		113,
		126,
		114,
		119,
		113,
		145,
		-1,
		182,
		181,
		170,
		167,
		143,
		134,
		129,
		156,
		-1,
		-1,
		151,
		178,
		156,
		133,
		131,
		156,
		-1,
		55,
		-1,
		-1,
		125,
		-1,
		-1,
		110,
		90,
		79,
		70,
		75,
		95,
		106,
		128,
		110,
		127,
		118,
		128,
		132,
		166,
		163,
		151,
		149,
		172,
		137,
		125,
		-1,
		133,
		136,
		142,
		149,
		134,
		145,
		-1,
		-1,
		71,
		51,
		-1,
		-1,
		108,
		106,
		95,
		-1,
		85,
		67,
		72,
		102,
		104,
		106,
		113,
		107,
		114,
		122,
		133,
		125,
		175,
		189,
		178,
		174,
		173,
		181,
		130,
		123,
		130,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		-1,
		57,
		57,
		-1,
		-1,
		103,
		96,
		84,
		72,
		62,
		72,
		89,
		89,
		92,
		97,
		105,
		116,
		112,
		116,
		119,
		-1,
		209,
		-1,
		161,
		122,
		128,
		143,
		151,
		-1,
		-1,
		-1,
		74,
		60,
		53,
		41,
		39,
		-1,
		137,
		121,
		102,
		-1,
		72,
		85,
		125,
		93,
		98,
		93,
		108,
		119,
		110,
		118,
		112,
		115,
		-1,
		-1,
		121,
		104,
		-1,
		-1,
		78,
		80,
		-1,
		65,
		54,
		39,
		31,
		-1,
		-1,
		109,
		105,
		-1,
		-1,
		59,
		97,
		96,
		104,
		99,
		104,
		116,
		112,
		108,
		118,
		109,
		-1,
		-1,
		99,
		91,
		85,
		-1,
		63,
		-1,
		77,
		-1,
		34,
		29,
		17,
		-1,
		-1,
		-1,
		90,
		53,
		69,
		92,
		118,
		116,
		107,
		100,
		107,
		110,
		103,
		109,
		-1,
		-1,
		-1,
		81,
		55,
		84,
		75,
		58,
		38,
		30,
		28,
		-1,
		71,
		-1,
		46,
		49,
		74,
		113,
		115,
		101,
		97,
		110,
		104,
		101,
		99,
		87,
		-1,
		57,
		90,
		54,
		44,
		22,
		0,
		85,
		-1,
		68,
		50,
		-1,
		78,
		68,
		116,
		91,
		100,
		93,
		87,
		88,
		96,
		-1,
		-1,
		-1,
		59,
		58,
		50,
		44,
		38,
		25,
		14,
		-1,
		73,
		55,
		41,
		58,
		58,
		49,
		57,
		106,
		102,
		105,
		103,
		81,
		-1,
		173,
		-1,
		-1,
		82,
		-1,
		-1,
		-1,
		53,
		55,
		28,
		22,
		32,
		43,
		38,
		40,
		53,
		61,
		59,
		56,
		68,
		64,
		84,
		80,
		112,
		-1,
		168,
		-1,
		89,
		-1,
		-1,
		69,
		55,
		50,
		39,
		28,
		28,
		33,
		33,
		55,
		85,
		71,
		69,
		74,
		79,
		-1,
		157,
		156,
		-1,
		88,
		80,
		66,
		-1,
		59,
		-1,
		74,
		35,
		-1,
		62,
		42,
		-1,
		80,
		76,
		-1,
		-1,
		144,
		104,
		-1,
		-1,
		-1,
		89,
		69,
		69,
		53,
		-1,
		53,
		53,
		-1,
		-1,
		-1,
		129,
		113,
		-1,
		82,
		85,
		-1,
		76,
		82,
		108,
		55,
		59,
		-1,
		-1,
		-1,
		138,
		119,
		113,
		97,
		102,
		90,
		107,
		93,
		91,
		69,
		58,
		79,
		-1,
		-1,
		-1,
		110,
		102,
		102,
		-1,
		-1,
		116,
		99,
		80,
		78,
		-1,
		-1,
		-1,
		132,
		113,
		-1,
		-1,
		106,
		-1,
		-1,
		112,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		121,
		-1,
		-1,
		-1,
		102,
		98,
		99,
		-1,
		-1,
		-1,
		-1,
		142,
		143,
		167,
		142,
		-1,
		-1,
		-1,
		94,
		88,
		-1,
		-1,
		145,
		143,
		-1,
		-1,
		-1,
		122,
		106,
		-1,
		92,
		-1,
		-1,
		-1,
		113,
		-1,
		-1,
		125,
		-1,
		-1,
		-1,
		127,
		-1,
		127,
		102,
		109,
		-1,
		-1,
		-1,
		-1,
		140,
		132,
		140,
		-1,
		112,
		114,
		-1,
		162,
		-1,
		-1,
		155,
		146,
		-1,
		-1,
		117,
		124,
		146,
		149,
		185,
		-1,
		136
	],
	[
		-1,
		274,
		263,
		274,
		282,
		255,
		262,
		-1,
		281,
		285,
		251,
		245,
		284,
		253,
		259,
		270,
		-1,
		-1,
		-1,
		274,
		273,
		241,
		239,
		248,
		253,
		260,
		-1,
		259,
		-1,
		295,
		274,
		285,
		290,
		234,
		231,
		251,
		270,
		252,
		244,
		310,
		264,
		235,
		229,
		247,
		237,
		246,
		238,
		-1,
		235,
		225,
		247,
		226,
		237,
		229,
		-1,
		-1,
		229,
		230,
		236,
		222,
		228,
		224,
		-1,
		234,
		218,
		-1,
		-1,
		219,
		220,
		204,
		207,
		215,
		213,
		226,
		218,
		213,
		-1,
		-1,
		210,
		206,
		213,
		200,
		196,
		213,
		226,
		208,
		222,
		221,
		-1,
		214,
		232,
		239,
		207,
		205,
		189,
		187,
		205,
		207,
		213,
		213,
		-1,
		223,
		224,
		219,
		227,
		229,
		205,
		192,
		192,
		202,
		195,
		214,
		202,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		223,
		206,
		223,
		215,
		205,
		220,
		213,
		195,
		192,
		190,
		187,
		203,
		201,
		211,
		-1,
		-1,
		316,
		285,
		314,
		272,
		253,
		-1,
		219,
		199,
		205,
		209,
		203,
		196,
		210,
		206,
		-1,
		181,
		180,
		208,
		194,
		205,
		276,
		-1,
		-1,
		274,
		266,
		249,
		252,
		229,
		225,
		214,
		213,
		205,
		191,
		187,
		193,
		196,
		196,
		202,
		175,
		185,
		189,
		187,
		212,
		-1,
		-1,
		247,
		-1,
		-1,
		273,
		256,
		-1,
		239,
		246,
		235,
		241,
		227,
		248,
		224,
		215,
		207,
		201,
		189,
		191,
		188,
		201,
		189,
		172,
		197,
		201,
		182,
		203,
		198,
		-1,
		246,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		232,
		235,
		241,
		265,
		264,
		-1,
		236,
		224,
		225,
		210,
		207,
		194,
		182,
		195,
		180,
		187,
		186,
		176,
		174,
		204,
		179,
		201,
		198,
		217,
		222,
		216,
		225,
		-1,
		281,
		277,
		273,
		280,
		229,
		-1,
		-1,
		269,
		-1,
		272,
		273,
		248,
		221,
		224,
		211,
		202,
		189,
		178,
		189,
		178,
		175,
		183,
		168,
		183,
		174,
		173,
		191,
		201,
		209,
		213,
		219,
		-1,
		331,
		-1,
		273,
		257,
		259,
		231,
		252,
		-1,
		289,
		273,
		265,
		250,
		250,
		-1,
		220,
		217,
		207,
		185,
		170,
		187,
		179,
		177,
		181,
		163,
		177,
		168,
		186,
		193,
		191,
		195,
		215,
		227,
		291,
		281,
		-1,
		263,
		268,
		227,
		235,
		254,
		292,
		256,
		-1,
		251,
		-1,
		222,
		235,
		-1,
		191,
		187,
		169,
		170,
		165,
		180,
		174,
		159,
		156,
		174,
		177,
		184,
		188,
		204,
		-1,
		-1,
		276,
		280,
		269,
		220,
		239,
		263,
		300,
		249,
		238,
		237,
		-1,
		228,
		205,
		202,
		190,
		177,
		162,
		163,
		171,
		184,
		163,
		158,
		155,
		175,
		201,
		179,
		191,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		246,
		217,
		241,
		283,
		267,
		260,
		248,
		213,
		213,
		207,
		-1,
		201,
		180,
		171,
		160,
		158,
		171,
		168,
		173,
		153,
		151,
		170,
		182,
		173,
		190,
		-1,
		-1,
		-1,
		276,
		265,
		266,
		212,
		235,
		272,
		246,
		232,
		237,
		212,
		205,
		199,
		214,
		197,
		178,
		167,
		159,
		148,
		164,
		172,
		167,
		149,
		158,
		164,
		188,
		178,
		184,
		-1,
		-1,
		283,
		273,
		257,
		259,
		256,
		226,
		233,
		265,
		237,
		250,
		-1,
		204,
		-1,
		193,
		188,
		172,
		167,
		164,
		161,
		155,
		164,
		166,
		156,
		151,
		158,
		193,
		193,
		168,
		188,
		191,
		-1,
		-1,
		-1,
		276,
		271,
		246,
		223,
		207,
		243,
		-1,
		220,
		221,
		-1,
		198,
		192,
		189,
		174,
		170,
		165,
		169,
		162,
		169,
		162,
		160,
		161,
		143,
		175,
		-1,
		176,
		170,
		178,
		168,
		156,
		-1,
		-1,
		-1,
		269,
		248,
		241,
		261,
		202,
		254,
		-1,
		-1,
		205,
		198,
		-1,
		185,
		167,
		174,
		172,
		166,
		170,
		167,
		156,
		169,
		162,
		148,
		150,
		163,
		167,
		171,
		158,
		154,
		151,
		165,
		-1,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		222,
		-1,
		214,
		206,
		196,
		190,
		184,
		180,
		178,
		194,
		178,
		181,
		179,
		170,
		178,
		151,
		144,
		151,
		140,
		158,
		166,
		158,
		152,
		151,
		161,
		-1,
		289,
		275,
		246,
		-1,
		-1,
		235,
		-1,
		199,
		213,
		229,
		-1,
		222,
		201,
		216,
		194,
		190,
		186,
		201,
		202,
		179,
		179,
		177,
		168,
		156,
		145,
		148,
		140,
		162,
		162,
		146,
		147,
		151,
		-1,
		295,
		282,
		240,
		236,
		225,
		245,
		196,
		184,
		216,
		-1,
		-1,
		258,
		-1,
		192,
		209,
		200,
		198,
		191,
		173,
		180,
		188,
		165,
		160,
		150,
		139,
		139,
		134,
		156,
		142,
		140,
		149,
		165,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		211,
		198,
		192,
		-1,
		233,
		-1,
		236,
		226,
		210,
		195,
		228,
		-1,
		172,
		168,
		175,
		-1,
		185,
		-1,
		158,
		155,
		146,
		131,
		128,
		139,
		137,
		148,
		144,
		-1,
		245,
		230,
		223,
		213,
		227,
		198,
		-1,
		253,
		-1,
		-1,
		223,
		217,
		217,
		201,
		202,
		188,
		168,
		160,
		175,
		174,
		161,
		160,
		144,
		137,
		134,
		127,
		140,
		150,
		155,
		142,
		-1,
		-1,
		-1,
		250,
		236,
		240,
		200,
		219,
		-1,
		-1,
		285,
		240,
		226,
		-1,
		197,
		188,
		176,
		166,
		156,
		161,
		162,
		152,
		150,
		142,
		144,
		138,
		129,
		128,
		144,
		136,
		158,
		-1,
		-1,
		233,
		238,
		226,
		212,
		231,
		-1,
		-1,
		-1,
		232,
		248,
		216,
		195,
		177,
		-1,
		-1,
		160,
		153,
		147,
		150,
		138,
		158,
		153,
		137,
		122,
		137,
		141,
		149,
		140,
		-1,
		236,
		223,
		-1,
		-1,
		234,
		228,
		-1,
		-1,
		-1,
		-1,
		228,
		173,
		162,
		157,
		161,
		159,
		-1,
		133,
		144,
		137,
		156,
		163,
		139,
		124,
		118,
		124,
		136,
		145,
		-1,
		-1,
		248,
		-1,
		222,
		-1,
		-1,
		-1,
		-1,
		185,
		179,
		150,
		143,
		147,
		-1,
		135,
		137,
		134,
		146,
		142,
		139,
		130,
		121,
		117,
		121,
		125,
		139,
		143,
		271,
		-1,
		213,
		-1,
		-1,
		-1,
		203,
		218,
		189,
		166,
		139,
		134,
		127,
		121,
		126,
		137,
		146,
		157,
		122,
		124,
		114,
		113,
		117,
		134,
		138,
		-1,
		-1,
		211,
		207,
		229,
		211,
		215,
		216,
		-1,
		-1,
		143,
		134,
		125,
		117,
		130,
		133,
		118,
		120,
		120,
		118,
		112,
		122,
		137,
		132,
		-1,
		-1,
		-1,
		223,
		-1,
		225,
		-1,
		-1,
		213,
		214,
		161,
		143,
		139,
		137,
		126,
		120,
		108,
		113,
		123,
		117,
		114,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		202,
		194,
		189,
		195,
		197,
		188,
		176,
		173,
		-1,
		143,
		149,
		114,
		121,
		104,
		111,
		116,
		113,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		195,
		191,
		181,
		171,
		174,
		-1,
		-1,
		168,
		165,
		145,
		114,
		112,
		105,
		100,
		110,
		86,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		238,
		275,
		268,
		236,
		244,
		275,
		-1,
		185,
		177,
		188,
		163,
		165,
		-1,
		-1,
		141,
		132,
		133,
		121,
		118,
		124,
		123,
		106,
		112,
		113,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		231,
		251,
		230,
		233,
		257,
		271,
		-1,
		182,
		-1,
		-1,
		154,
		166,
		150,
		140,
		137,
		180,
		135,
		130,
		111,
		109,
		104,
		95,
		120,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		220,
		231,
		224,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		144,
		-1,
		177,
		-1,
		160,
		164,
		143,
		146,
		125,
		112,
		98,
		106,
		112,
		111,
		117,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		245,
		201,
		204,
		215,
		226,
		241,
		245,
		-1,
		194,
		233,
		150,
		-1,
		134,
		-1,
		-1,
		-1,
		174,
		156,
		148,
		145,
		124,
		124,
		90,
		94,
		107,
		114,
		124,
		135,
		127,
		131,
		144,
		155,
		158,
		241,
		232,
		245,
		190,
		190,
		211,
		220,
		241,
		205,
		200,
		227,
		157,
		146,
		141,
		128,
		-1,
		-1,
		158,
		166,
		-1,
		-1,
		131,
		98,
		86,
		96,
		100,
		114,
		126,
		139,
		127,
		132,
		126,
		158,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		181,
		208,
		-1,
		-1,
		203,
		228,
		213,
		190,
		188,
		213,
		-1,
		117,
		-1,
		-1,
		138,
		-1,
		-1,
		123,
		103,
		92,
		83,
		88,
		108,
		119,
		141,
		123,
		140,
		131,
		141,
		145,
		218,
		215,
		203,
		201,
		224,
		189,
		177,
		-1,
		185,
		188,
		194,
		201,
		191,
		202,
		-1,
		-1,
		133,
		113,
		-1,
		-1,
		121,
		119,
		108,
		-1,
		98,
		80,
		85,
		115,
		117,
		119,
		126,
		120,
		127,
		135,
		146,
		138,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		123,
		119,
		-1,
		-1,
		116,
		109,
		97,
		85,
		75,
		85,
		102,
		102,
		105,
		110,
		118,
		129,
		125,
		129,
		132,
		-1,
		261,
		-1,
		213,
		174,
		180,
		195,
		203,
		-1,
		-1,
		-1,
		140,
		126,
		119,
		107,
		105,
		-1,
		150,
		134,
		115,
		-1,
		85,
		98,
		138,
		106,
		111,
		106,
		121,
		132,
		123,
		131,
		125,
		128,
		-1,
		-1,
		173,
		156,
		-1,
		-1,
		130,
		132,
		-1,
		131,
		120,
		105,
		97,
		-1,
		-1,
		122,
		118,
		-1,
		-1,
		72,
		110,
		109,
		117,
		112,
		117,
		129,
		125,
		121,
		131,
		122,
		-1,
		-1,
		151,
		143,
		137,
		-1,
		115,
		-1,
		133,
		-1,
		100,
		106,
		94,
		-1,
		-1,
		-1,
		103,
		66,
		82,
		105,
		131,
		129,
		120,
		113,
		120,
		123,
		116,
		122,
		-1,
		-1,
		-1,
		133,
		107,
		140,
		131,
		114,
		94,
		86,
		105,
		-1,
		84,
		-1,
		59,
		62,
		87,
		126,
		128,
		114,
		110,
		123,
		117,
		114,
		112,
		139,
		-1,
		109,
		142,
		106,
		100,
		76,
		80,
		0,
		-1,
		81,
		63,
		-1,
		91,
		81,
		129,
		104,
		113,
		106,
		100,
		101,
		109,
		-1,
		-1,
		-1,
		111,
		110,
		102,
		96,
		96,
		81,
		72,
		-1,
		15,
		33,
		54,
		71,
		71,
		62,
		70,
		119,
		115,
		118,
		116,
		94,
		-1,
		212,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		105,
		100,
		73,
		61,
		67,
		63,
		49,
		55,
		66,
		74,
		72,
		69,
		81,
		77,
		97,
		93,
		125,
		-1,
		207,
		-1,
		141,
		-1,
		-1,
		123,
		103,
		95,
		84,
		73,
		71,
		62,
		53,
		75,
		100,
		84,
		82,
		87,
		92,
		-1,
		196,
		195,
		-1,
		142,
		134,
		120,
		-1,
		113,
		-1,
		119,
		80,
		-1,
		82,
		62,
		-1,
		93,
		89,
		-1,
		-1,
		183,
		158,
		-1,
		-1,
		-1,
		143,
		123,
		114,
		98,
		-1,
		73,
		73,
		-1,
		-1,
		-1,
		168,
		167,
		-1,
		136,
		139,
		-1,
		129,
		120,
		128,
		75,
		79,
		-1,
		-1,
		-1,
		177,
		158,
		152,
		151,
		149,
		144,
		141,
		127,
		111,
		89,
		78,
		99,
		-1,
		-1,
		-1,
		149,
		141,
		134,
		-1,
		-1,
		136,
		119,
		100,
		98,
		-1,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		126,
		-1,
		-1,
		132,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		160,
		-1,
		-1,
		-1,
		122,
		118,
		119,
		-1,
		-1,
		-1,
		-1,
		182,
		183,
		206,
		170,
		-1,
		-1,
		-1,
		114,
		108,
		-1,
		-1,
		185,
		183,
		-1,
		-1,
		-1,
		142,
		126,
		-1,
		112,
		-1,
		-1,
		-1,
		133,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		147,
		-1,
		147,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		160,
		152,
		160,
		-1,
		132,
		134,
		-1,
		182,
		-1,
		-1,
		175,
		166,
		-1,
		-1,
		137,
		144,
		166,
		169,
		205,
		-1,
		156
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		249,
		238,
		249,
		257,
		230,
		237,
		-1,
		256,
		260,
		226,
		220,
		259,
		228,
		234,
		245,
		-1,
		-1,
		-1,
		249,
		248,
		216,
		214,
		223,
		228,
		235,
		-1,
		234,
		-1,
		270,
		249,
		260,
		265,
		209,
		206,
		226,
		245,
		227,
		219,
		285,
		239,
		210,
		204,
		222,
		212,
		221,
		213,
		-1,
		210,
		200,
		222,
		201,
		212,
		204,
		-1,
		-1,
		204,
		205,
		211,
		197,
		203,
		199,
		-1,
		209,
		193,
		-1,
		-1,
		194,
		195,
		179,
		182,
		190,
		188,
		201,
		193,
		188,
		-1,
		-1,
		185,
		181,
		188,
		175,
		171,
		188,
		201,
		183,
		197,
		196,
		-1,
		189,
		207,
		214,
		182,
		180,
		164,
		162,
		180,
		182,
		188,
		188,
		-1,
		198,
		199,
		194,
		202,
		204,
		180,
		167,
		167,
		177,
		170,
		189,
		177,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		198,
		181,
		198,
		190,
		180,
		195,
		188,
		170,
		167,
		165,
		162,
		178,
		176,
		186,
		-1,
		-1,
		291,
		260,
		289,
		247,
		228,
		-1,
		194,
		174,
		180,
		184,
		178,
		171,
		185,
		181,
		-1,
		156,
		155,
		183,
		169,
		180,
		251,
		-1,
		-1,
		249,
		241,
		224,
		227,
		204,
		200,
		189,
		188,
		180,
		166,
		162,
		168,
		171,
		171,
		177,
		150,
		160,
		164,
		162,
		187,
		-1,
		-1,
		222,
		-1,
		-1,
		248,
		231,
		-1,
		214,
		221,
		210,
		216,
		202,
		223,
		199,
		190,
		182,
		176,
		164,
		166,
		163,
		176,
		164,
		147,
		172,
		176,
		157,
		178,
		173,
		-1,
		221,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		207,
		210,
		216,
		240,
		239,
		-1,
		211,
		199,
		200,
		185,
		182,
		169,
		157,
		170,
		155,
		162,
		161,
		151,
		149,
		179,
		154,
		176,
		173,
		192,
		197,
		191,
		200,
		-1,
		256,
		252,
		248,
		255,
		204,
		-1,
		-1,
		244,
		-1,
		247,
		248,
		223,
		196,
		199,
		186,
		177,
		164,
		153,
		164,
		153,
		150,
		158,
		143,
		158,
		149,
		148,
		166,
		176,
		184,
		188,
		194,
		-1,
		306,
		-1,
		248,
		232,
		234,
		206,
		227,
		-1,
		264,
		248,
		240,
		225,
		225,
		-1,
		195,
		192,
		182,
		160,
		145,
		162,
		154,
		152,
		156,
		138,
		152,
		143,
		161,
		168,
		166,
		170,
		190,
		202,
		266,
		256,
		-1,
		238,
		243,
		202,
		210,
		229,
		267,
		231,
		-1,
		226,
		-1,
		197,
		210,
		-1,
		166,
		162,
		144,
		145,
		140,
		155,
		149,
		134,
		131,
		149,
		152,
		159,
		163,
		179,
		-1,
		-1,
		251,
		255,
		244,
		195,
		214,
		238,
		275,
		224,
		213,
		212,
		-1,
		203,
		180,
		177,
		165,
		152,
		137,
		138,
		146,
		159,
		138,
		133,
		130,
		150,
		176,
		154,
		166,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		221,
		192,
		216,
		258,
		242,
		235,
		223,
		188,
		188,
		182,
		-1,
		176,
		155,
		146,
		135,
		133,
		146,
		143,
		148,
		128,
		126,
		145,
		157,
		148,
		165,
		-1,
		-1,
		-1,
		251,
		240,
		241,
		187,
		210,
		247,
		221,
		207,
		212,
		187,
		180,
		174,
		189,
		172,
		153,
		142,
		134,
		123,
		139,
		147,
		142,
		124,
		133,
		139,
		163,
		153,
		159,
		-1,
		-1,
		258,
		248,
		232,
		234,
		231,
		201,
		208,
		240,
		212,
		225,
		-1,
		179,
		-1,
		168,
		163,
		147,
		142,
		139,
		136,
		130,
		139,
		141,
		131,
		126,
		133,
		168,
		168,
		143,
		163,
		166,
		-1,
		-1,
		-1,
		251,
		246,
		221,
		198,
		182,
		218,
		-1,
		195,
		196,
		-1,
		173,
		167,
		164,
		149,
		145,
		140,
		144,
		137,
		144,
		137,
		135,
		136,
		118,
		150,
		-1,
		151,
		145,
		153,
		143,
		131,
		-1,
		-1,
		-1,
		244,
		223,
		216,
		236,
		177,
		229,
		-1,
		-1,
		180,
		173,
		-1,
		160,
		142,
		149,
		147,
		141,
		145,
		142,
		131,
		144,
		137,
		123,
		125,
		138,
		142,
		146,
		133,
		129,
		126,
		140,
		-1,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		197,
		-1,
		189,
		181,
		171,
		165,
		159,
		155,
		153,
		169,
		153,
		156,
		154,
		145,
		153,
		126,
		119,
		126,
		115,
		133,
		141,
		133,
		127,
		126,
		136,
		-1,
		264,
		250,
		221,
		-1,
		-1,
		210,
		-1,
		174,
		188,
		204,
		-1,
		197,
		176,
		191,
		169,
		165,
		161,
		176,
		177,
		154,
		154,
		152,
		143,
		131,
		120,
		123,
		115,
		137,
		137,
		121,
		122,
		126,
		-1,
		270,
		257,
		215,
		211,
		200,
		220,
		171,
		159,
		191,
		-1,
		-1,
		233,
		-1,
		167,
		184,
		175,
		173,
		166,
		148,
		155,
		163,
		140,
		135,
		125,
		114,
		114,
		109,
		131,
		117,
		115,
		124,
		140,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		186,
		173,
		167,
		-1,
		208,
		-1,
		211,
		201,
		185,
		170,
		203,
		-1,
		147,
		143,
		150,
		-1,
		160,
		-1,
		133,
		130,
		121,
		106,
		103,
		114,
		112,
		123,
		119,
		-1,
		220,
		205,
		198,
		188,
		202,
		173,
		-1,
		228,
		-1,
		-1,
		198,
		192,
		192,
		176,
		177,
		163,
		143,
		135,
		150,
		149,
		136,
		135,
		119,
		112,
		109,
		102,
		115,
		125,
		130,
		117,
		-1,
		-1,
		-1,
		225,
		211,
		215,
		175,
		194,
		-1,
		-1,
		260,
		215,
		201,
		-1,
		172,
		163,
		151,
		141,
		131,
		136,
		137,
		127,
		125,
		117,
		119,
		113,
		104,
		103,
		119,
		111,
		133,
		-1,
		-1,
		208,
		213,
		201,
		187,
		206,
		-1,
		-1,
		-1,
		207,
		223,
		191,
		170,
		152,
		-1,
		-1,
		135,
		128,
		122,
		125,
		113,
		133,
		128,
		112,
		97,
		112,
		116,
		124,
		115,
		-1,
		211,
		198,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		-1,
		-1,
		203,
		148,
		137,
		132,
		136,
		134,
		-1,
		108,
		119,
		112,
		131,
		138,
		114,
		99,
		93,
		99,
		111,
		120,
		-1,
		-1,
		223,
		-1,
		197,
		-1,
		-1,
		-1,
		-1,
		160,
		154,
		125,
		118,
		122,
		-1,
		110,
		112,
		109,
		121,
		117,
		114,
		105,
		96,
		92,
		96,
		100,
		114,
		118,
		246,
		-1,
		188,
		-1,
		-1,
		-1,
		178,
		193,
		164,
		141,
		114,
		109,
		102,
		96,
		101,
		112,
		121,
		132,
		97,
		99,
		89,
		88,
		92,
		109,
		113,
		-1,
		-1,
		186,
		182,
		204,
		186,
		190,
		191,
		-1,
		-1,
		118,
		109,
		100,
		92,
		105,
		108,
		93,
		95,
		95,
		93,
		87,
		97,
		112,
		107,
		-1,
		-1,
		-1,
		198,
		-1,
		200,
		-1,
		-1,
		188,
		189,
		136,
		118,
		114,
		112,
		101,
		95,
		83,
		88,
		98,
		92,
		89,
		83,
		87,
		110,
		99,
		138,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		177,
		169,
		164,
		170,
		172,
		163,
		151,
		148,
		-1,
		118,
		124,
		89,
		96,
		79,
		86,
		91,
		88,
		77,
		84,
		100,
		99,
		94,
		130,
		121,
		127,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		170,
		166,
		156,
		146,
		149,
		-1,
		-1,
		143,
		140,
		120,
		89,
		87,
		80,
		75,
		85,
		61,
		73,
		77,
		81,
		87,
		92,
		97,
		103,
		118,
		133,
		-1,
		217,
		254,
		247,
		215,
		223,
		254,
		-1,
		160,
		152,
		163,
		138,
		140,
		-1,
		-1,
		116,
		107,
		108,
		96,
		93,
		99,
		98,
		81,
		86,
		88,
		80,
		79,
		97,
		101,
		110,
		117,
		107,
		120,
		124,
		-1,
		210,
		230,
		209,
		212,
		236,
		250,
		-1,
		157,
		-1,
		-1,
		138,
		141,
		125,
		115,
		112,
		155,
		110,
		105,
		83,
		81,
		78,
		69,
		95,
		86,
		88,
		91,
		106,
		111,
		103,
		117,
		117,
		118,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		128,
		-1,
		152,
		-1,
		135,
		139,
		118,
		121,
		97,
		84,
		70,
		78,
		84,
		84,
		89,
		92,
		93,
		102,
		113,
		125,
		124,
		125,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		169,
		208,
		134,
		-1,
		118,
		-1,
		-1,
		-1,
		149,
		131,
		123,
		117,
		96,
		96,
		62,
		66,
		79,
		86,
		96,
		110,
		102,
		106,
		119,
		130,
		133,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		184,
		175,
		202,
		141,
		130,
		125,
		112,
		-1,
		-1,
		130,
		141,
		-1,
		-1,
		103,
		70,
		58,
		68,
		72,
		86,
		98,
		111,
		99,
		107,
		101,
		133,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		203,
		193,
		174,
		172,
		197,
		-1,
		101,
		-1,
		-1,
		110,
		-1,
		-1,
		95,
		75,
		64,
		55,
		60,
		80,
		91,
		113,
		95,
		112,
		106,
		116,
		120,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		169,
		167,
		173,
		180,
		175,
		186,
		-1,
		-1,
		117,
		97,
		-1,
		-1,
		93,
		91,
		80,
		-1,
		70,
		52,
		57,
		87,
		89,
		91,
		98,
		92,
		99,
		110,
		121,
		113,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		107,
		103,
		-1,
		-1,
		88,
		81,
		69,
		57,
		47,
		57,
		74,
		74,
		77,
		82,
		90,
		101,
		100,
		104,
		107,
		-1,
		240,
		-1,
		192,
		158,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		124,
		110,
		103,
		91,
		89,
		-1,
		122,
		106,
		87,
		-1,
		57,
		70,
		110,
		78,
		83,
		78,
		96,
		107,
		98,
		106,
		100,
		103,
		-1,
		-1,
		157,
		140,
		-1,
		-1,
		114,
		116,
		-1,
		115,
		104,
		89,
		81,
		-1,
		-1,
		94,
		90,
		-1,
		-1,
		44,
		85,
		81,
		89,
		84,
		92,
		104,
		100,
		96,
		106,
		97,
		-1,
		-1,
		135,
		127,
		121,
		-1,
		99,
		-1,
		117,
		-1,
		84,
		90,
		78,
		-1,
		-1,
		-1,
		75,
		38,
		54,
		80,
		104,
		102,
		93,
		88,
		95,
		98,
		91,
		97,
		-1,
		-1,
		-1,
		117,
		91,
		124,
		115,
		98,
		78,
		70,
		89,
		-1,
		3,
		-1,
		30,
		34,
		62,
		98,
		103,
		89,
		85,
		98,
		92,
		89,
		87,
		123,
		-1,
		93,
		126,
		90,
		84,
		60,
		64,
		80,
		-1,
		0,
		27,
		-1,
		66,
		56,
		104,
		79,
		88,
		81,
		75,
		76,
		84,
		-1,
		-1,
		-1,
		95,
		94,
		86,
		80,
		80,
		65,
		56,
		-1,
		68,
		50,
		29,
		37,
		44,
		37,
		45,
		94,
		90,
		93,
		91,
		69,
		-1,
		196,
		-1,
		-1,
		118,
		-1,
		-1,
		-1,
		89,
		84,
		57,
		45,
		51,
		47,
		33,
		39,
		32,
		49,
		47,
		44,
		56,
		52,
		72,
		68,
		100,
		-1,
		191,
		-1,
		125,
		-1,
		-1,
		107,
		87,
		79,
		68,
		57,
		55,
		46,
		37,
		59,
		66,
		59,
		57,
		62,
		67,
		-1,
		180,
		179,
		-1,
		126,
		118,
		104,
		-1,
		97,
		-1,
		103,
		64,
		-1,
		66,
		46,
		-1,
		68,
		64,
		-1,
		-1,
		167,
		142,
		-1,
		-1,
		-1,
		127,
		107,
		98,
		82,
		-1,
		57,
		57,
		-1,
		-1,
		-1,
		152,
		151,
		-1,
		120,
		123,
		-1,
		113,
		104,
		112,
		59,
		63,
		-1,
		-1,
		-1,
		161,
		142,
		136,
		135,
		133,
		128,
		125,
		111,
		95,
		73,
		62,
		83,
		-1,
		-1,
		-1,
		133,
		125,
		118,
		-1,
		-1,
		120,
		103,
		84,
		82,
		-1,
		-1,
		-1,
		155,
		136,
		-1,
		-1,
		110,
		-1,
		-1,
		116,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		144,
		-1,
		-1,
		-1,
		106,
		102,
		103,
		-1,
		-1,
		-1,
		-1,
		166,
		167,
		190,
		154,
		-1,
		-1,
		-1,
		98,
		92,
		-1,
		-1,
		169,
		167,
		-1,
		-1,
		-1,
		126,
		110,
		-1,
		96,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		129,
		-1,
		-1,
		-1,
		131,
		-1,
		131,
		106,
		113,
		-1,
		-1,
		-1,
		-1,
		144,
		136,
		144,
		-1,
		116,
		118,
		-1,
		166,
		-1,
		-1,
		159,
		150,
		-1,
		-1,
		121,
		128,
		150,
		153,
		189,
		-1,
		140
	],
	[
		-1,
		230,
		219,
		230,
		238,
		211,
		218,
		-1,
		237,
		241,
		207,
		201,
		240,
		209,
		215,
		226,
		-1,
		-1,
		-1,
		230,
		229,
		197,
		195,
		204,
		209,
		216,
		-1,
		215,
		-1,
		251,
		230,
		241,
		246,
		190,
		187,
		207,
		226,
		208,
		200,
		266,
		220,
		191,
		185,
		203,
		193,
		202,
		194,
		-1,
		191,
		181,
		203,
		182,
		193,
		185,
		-1,
		-1,
		185,
		186,
		192,
		178,
		184,
		180,
		-1,
		190,
		174,
		-1,
		-1,
		175,
		176,
		160,
		163,
		171,
		169,
		182,
		174,
		169,
		-1,
		-1,
		166,
		162,
		169,
		156,
		152,
		169,
		182,
		164,
		178,
		177,
		-1,
		170,
		188,
		195,
		163,
		161,
		145,
		143,
		161,
		163,
		169,
		169,
		-1,
		179,
		180,
		175,
		183,
		185,
		161,
		148,
		148,
		158,
		151,
		170,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		162,
		179,
		171,
		161,
		176,
		169,
		151,
		148,
		146,
		143,
		159,
		157,
		167,
		-1,
		-1,
		272,
		241,
		270,
		228,
		209,
		-1,
		175,
		155,
		161,
		165,
		159,
		152,
		166,
		162,
		-1,
		137,
		136,
		164,
		150,
		161,
		232,
		-1,
		-1,
		230,
		222,
		205,
		208,
		185,
		181,
		170,
		169,
		161,
		147,
		143,
		149,
		152,
		152,
		158,
		131,
		141,
		145,
		143,
		168,
		-1,
		-1,
		203,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		191,
		197,
		183,
		204,
		180,
		171,
		163,
		157,
		145,
		147,
		144,
		157,
		145,
		128,
		153,
		157,
		138,
		159,
		154,
		-1,
		202,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		220,
		-1,
		192,
		180,
		181,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		132,
		130,
		160,
		135,
		157,
		154,
		173,
		178,
		172,
		181,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		228,
		229,
		204,
		177,
		180,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		124,
		139,
		130,
		129,
		147,
		157,
		165,
		169,
		175,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		229,
		221,
		206,
		206,
		-1,
		176,
		173,
		163,
		141,
		126,
		143,
		135,
		133,
		137,
		119,
		133,
		124,
		142,
		149,
		147,
		151,
		171,
		183,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		248,
		212,
		-1,
		207,
		-1,
		178,
		191,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		130,
		115,
		112,
		130,
		133,
		140,
		144,
		160,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		205,
		194,
		193,
		-1,
		184,
		161,
		158,
		146,
		133,
		118,
		119,
		127,
		140,
		119,
		114,
		111,
		131,
		157,
		135,
		147,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		223,
		216,
		204,
		169,
		169,
		163,
		-1,
		157,
		136,
		127,
		116,
		114,
		127,
		124,
		129,
		109,
		107,
		126,
		138,
		129,
		146,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		168,
		191,
		228,
		202,
		188,
		193,
		168,
		161,
		155,
		170,
		153,
		134,
		123,
		115,
		104,
		120,
		128,
		123,
		105,
		114,
		120,
		144,
		134,
		140,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		182,
		189,
		221,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		117,
		111,
		120,
		122,
		112,
		107,
		114,
		149,
		149,
		124,
		144,
		147,
		-1,
		-1,
		-1,
		232,
		227,
		202,
		179,
		163,
		199,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		121,
		125,
		118,
		125,
		118,
		116,
		117,
		99,
		131,
		-1,
		132,
		126,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		128,
		122,
		126,
		123,
		112,
		125,
		118,
		104,
		106,
		119,
		123,
		127,
		114,
		110,
		107,
		121,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		137,
		135,
		126,
		134,
		107,
		100,
		107,
		96,
		114,
		122,
		114,
		108,
		107,
		117,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		135,
		135,
		133,
		124,
		112,
		101,
		104,
		96,
		118,
		118,
		102,
		103,
		107,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		140,
		172,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		129,
		136,
		144,
		121,
		116,
		106,
		95,
		95,
		90,
		112,
		98,
		96,
		105,
		121,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		128,
		124,
		131,
		-1,
		141,
		-1,
		114,
		111,
		102,
		87,
		84,
		95,
		93,
		104,
		100,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		209,
		-1,
		-1,
		179,
		173,
		173,
		157,
		158,
		144,
		124,
		116,
		131,
		130,
		117,
		116,
		100,
		93,
		90,
		83,
		96,
		106,
		111,
		98,
		-1,
		-1,
		-1,
		206,
		192,
		196,
		156,
		175,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		153,
		144,
		132,
		122,
		112,
		117,
		118,
		108,
		106,
		98,
		100,
		94,
		85,
		84,
		100,
		92,
		114,
		-1,
		-1,
		189,
		194,
		182,
		168,
		187,
		-1,
		-1,
		-1,
		188,
		204,
		172,
		151,
		133,
		-1,
		-1,
		116,
		109,
		103,
		106,
		94,
		114,
		109,
		93,
		78,
		93,
		97,
		105,
		96,
		-1,
		192,
		179,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		-1,
		-1,
		184,
		129,
		118,
		113,
		117,
		115,
		-1,
		89,
		100,
		93,
		112,
		119,
		95,
		80,
		74,
		80,
		92,
		101,
		-1,
		-1,
		204,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		141,
		135,
		106,
		99,
		103,
		-1,
		91,
		93,
		90,
		102,
		98,
		95,
		86,
		77,
		73,
		77,
		81,
		95,
		99,
		227,
		-1,
		169,
		-1,
		-1,
		-1,
		159,
		174,
		145,
		122,
		95,
		90,
		83,
		77,
		82,
		93,
		102,
		113,
		78,
		80,
		70,
		69,
		73,
		90,
		94,
		-1,
		-1,
		167,
		163,
		185,
		167,
		171,
		172,
		-1,
		-1,
		99,
		90,
		81,
		73,
		86,
		89,
		74,
		76,
		76,
		74,
		68,
		78,
		93,
		88,
		-1,
		-1,
		-1,
		179,
		-1,
		181,
		-1,
		-1,
		169,
		170,
		117,
		99,
		95,
		93,
		82,
		76,
		64,
		69,
		79,
		73,
		70,
		64,
		68,
		91,
		80,
		119,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		158,
		150,
		145,
		151,
		153,
		144,
		132,
		129,
		-1,
		99,
		105,
		70,
		77,
		60,
		67,
		72,
		69,
		58,
		65,
		81,
		80,
		75,
		111,
		102,
		108,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		151,
		147,
		137,
		127,
		130,
		-1,
		-1,
		124,
		121,
		101,
		70,
		68,
		61,
		56,
		66,
		42,
		54,
		58,
		62,
		68,
		73,
		78,
		84,
		99,
		114,
		-1,
		198,
		235,
		228,
		196,
		204,
		235,
		-1,
		141,
		133,
		144,
		119,
		121,
		-1,
		-1,
		97,
		88,
		89,
		77,
		74,
		80,
		79,
		62,
		67,
		69,
		61,
		60,
		78,
		82,
		91,
		98,
		88,
		101,
		105,
		-1,
		191,
		211,
		190,
		193,
		217,
		231,
		-1,
		138,
		-1,
		-1,
		119,
		122,
		106,
		96,
		93,
		136,
		91,
		86,
		64,
		62,
		59,
		50,
		76,
		67,
		69,
		72,
		87,
		92,
		84,
		98,
		98,
		99,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		-1,
		109,
		-1,
		133,
		-1,
		116,
		120,
		99,
		102,
		78,
		65,
		51,
		59,
		65,
		65,
		70,
		73,
		74,
		83,
		94,
		106,
		105,
		106,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		150,
		189,
		115,
		-1,
		99,
		-1,
		-1,
		-1,
		130,
		112,
		104,
		98,
		77,
		77,
		43,
		47,
		60,
		67,
		77,
		91,
		83,
		87,
		100,
		111,
		114,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		165,
		156,
		183,
		122,
		111,
		106,
		93,
		-1,
		-1,
		111,
		122,
		-1,
		-1,
		84,
		51,
		39,
		49,
		53,
		67,
		79,
		92,
		80,
		88,
		82,
		114,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		163,
		184,
		174,
		155,
		153,
		178,
		-1,
		82,
		-1,
		-1,
		91,
		-1,
		-1,
		76,
		56,
		45,
		36,
		41,
		61,
		72,
		94,
		76,
		93,
		87,
		97,
		101,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		150,
		148,
		154,
		161,
		156,
		167,
		-1,
		-1,
		98,
		78,
		-1,
		-1,
		74,
		72,
		61,
		-1,
		51,
		33,
		38,
		68,
		70,
		72,
		79,
		73,
		80,
		91,
		102,
		94,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		147,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		-1,
		88,
		84,
		-1,
		-1,
		69,
		62,
		50,
		38,
		28,
		38,
		55,
		55,
		58,
		63,
		71,
		82,
		81,
		85,
		88,
		-1,
		221,
		-1,
		173,
		139,
		145,
		160,
		168,
		-1,
		-1,
		-1,
		105,
		91,
		84,
		72,
		70,
		-1,
		103,
		87,
		68,
		-1,
		38,
		51,
		91,
		59,
		64,
		59,
		77,
		88,
		79,
		87,
		81,
		84,
		-1,
		-1,
		138,
		121,
		-1,
		-1,
		95,
		97,
		-1,
		96,
		85,
		70,
		62,
		-1,
		-1,
		75,
		71,
		-1,
		-1,
		25,
		66,
		62,
		70,
		65,
		73,
		85,
		81,
		77,
		87,
		78,
		-1,
		-1,
		116,
		108,
		102,
		-1,
		80,
		-1,
		98,
		-1,
		65,
		71,
		59,
		-1,
		-1,
		-1,
		56,
		19,
		35,
		61,
		85,
		83,
		74,
		69,
		76,
		79,
		72,
		78,
		-1,
		-1,
		-1,
		98,
		72,
		105,
		96,
		79,
		59,
		51,
		70,
		-1,
		29,
		-1,
		11,
		15,
		43,
		79,
		84,
		70,
		66,
		79,
		73,
		70,
		68,
		104,
		-1,
		74,
		107,
		71,
		65,
		41,
		45,
		61,
		-1,
		26,
		0,
		-1,
		47,
		37,
		85,
		60,
		69,
		62,
		56,
		57,
		65,
		-1,
		-1,
		-1,
		76,
		75,
		67,
		61,
		61,
		46,
		37,
		-1,
		49,
		31,
		10,
		20,
		27,
		18,
		26,
		75,
		71,
		74,
		72,
		50,
		-1,
		177,
		-1,
		-1,
		99,
		-1,
		-1,
		-1,
		70,
		65,
		38,
		26,
		32,
		28,
		14,
		20,
		15,
		30,
		28,
		25,
		37,
		33,
		53,
		49,
		81,
		-1,
		172,
		-1,
		106,
		-1,
		-1,
		88,
		68,
		60,
		49,
		38,
		36,
		27,
		18,
		40,
		49,
		40,
		38,
		43,
		48,
		-1,
		161,
		160,
		-1,
		107,
		99,
		85,
		-1,
		78,
		-1,
		84,
		45,
		-1,
		47,
		27,
		-1,
		49,
		45,
		-1,
		-1,
		148,
		123,
		-1,
		-1,
		-1,
		108,
		88,
		79,
		63,
		-1,
		38,
		38,
		-1,
		-1,
		-1,
		133,
		132,
		-1,
		101,
		104,
		-1,
		94,
		85,
		93,
		40,
		44,
		-1,
		-1,
		-1,
		142,
		123,
		117,
		116,
		114,
		109,
		106,
		92,
		76,
		54,
		43,
		64,
		-1,
		-1,
		-1,
		114,
		106,
		99,
		-1,
		-1,
		101,
		84,
		65,
		63,
		-1,
		-1,
		-1,
		136,
		117,
		-1,
		-1,
		91,
		-1,
		-1,
		97,
		62,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		125,
		-1,
		-1,
		-1,
		87,
		83,
		84,
		-1,
		-1,
		-1,
		-1,
		147,
		148,
		171,
		135,
		-1,
		-1,
		-1,
		79,
		73,
		-1,
		-1,
		150,
		148,
		-1,
		-1,
		-1,
		107,
		91,
		-1,
		77,
		-1,
		-1,
		-1,
		98,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		112,
		-1,
		112,
		87,
		94,
		-1,
		-1,
		-1,
		-1,
		125,
		117,
		125,
		-1,
		97,
		99,
		-1,
		147,
		-1,
		-1,
		140,
		131,
		-1,
		-1,
		102,
		109,
		131,
		134,
		170,
		-1,
		121
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		257,
		246,
		257,
		265,
		238,
		245,
		-1,
		264,
		268,
		234,
		228,
		267,
		236,
		242,
		253,
		-1,
		-1,
		-1,
		257,
		256,
		224,
		222,
		231,
		236,
		243,
		-1,
		242,
		-1,
		278,
		257,
		268,
		273,
		217,
		214,
		234,
		253,
		235,
		227,
		293,
		247,
		218,
		212,
		230,
		220,
		229,
		221,
		-1,
		218,
		208,
		230,
		209,
		220,
		212,
		-1,
		-1,
		212,
		213,
		219,
		205,
		211,
		207,
		-1,
		217,
		201,
		-1,
		-1,
		202,
		203,
		187,
		190,
		198,
		196,
		209,
		201,
		196,
		-1,
		-1,
		193,
		189,
		196,
		183,
		179,
		196,
		209,
		191,
		205,
		204,
		-1,
		197,
		215,
		222,
		190,
		188,
		172,
		170,
		188,
		190,
		196,
		196,
		-1,
		206,
		207,
		202,
		210,
		212,
		188,
		175,
		175,
		185,
		178,
		197,
		185,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		206,
		189,
		206,
		198,
		188,
		203,
		196,
		178,
		175,
		173,
		170,
		186,
		184,
		194,
		-1,
		-1,
		299,
		268,
		297,
		255,
		236,
		-1,
		202,
		182,
		188,
		192,
		186,
		179,
		193,
		189,
		-1,
		164,
		163,
		191,
		177,
		188,
		259,
		-1,
		-1,
		257,
		249,
		232,
		235,
		212,
		208,
		197,
		196,
		188,
		174,
		170,
		176,
		179,
		179,
		185,
		158,
		168,
		172,
		170,
		195,
		-1,
		-1,
		230,
		-1,
		-1,
		256,
		239,
		-1,
		222,
		229,
		218,
		224,
		210,
		231,
		207,
		198,
		190,
		184,
		172,
		174,
		171,
		184,
		172,
		155,
		180,
		184,
		165,
		186,
		181,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		215,
		218,
		224,
		248,
		247,
		-1,
		219,
		207,
		208,
		193,
		190,
		177,
		165,
		178,
		163,
		170,
		169,
		159,
		157,
		187,
		162,
		184,
		181,
		200,
		205,
		199,
		208,
		-1,
		264,
		260,
		256,
		263,
		212,
		-1,
		-1,
		252,
		-1,
		255,
		256,
		231,
		204,
		207,
		194,
		185,
		172,
		161,
		172,
		161,
		158,
		166,
		151,
		166,
		157,
		156,
		174,
		184,
		192,
		196,
		202,
		-1,
		314,
		-1,
		256,
		240,
		242,
		214,
		235,
		-1,
		272,
		256,
		248,
		233,
		233,
		-1,
		203,
		200,
		190,
		168,
		153,
		170,
		162,
		160,
		164,
		146,
		160,
		151,
		169,
		176,
		174,
		178,
		198,
		210,
		274,
		264,
		-1,
		246,
		251,
		210,
		218,
		237,
		275,
		239,
		-1,
		234,
		-1,
		205,
		218,
		-1,
		174,
		170,
		152,
		153,
		148,
		163,
		157,
		142,
		139,
		157,
		160,
		167,
		171,
		187,
		-1,
		-1,
		259,
		263,
		252,
		203,
		222,
		246,
		283,
		232,
		221,
		220,
		-1,
		211,
		188,
		185,
		173,
		160,
		145,
		146,
		154,
		167,
		146,
		141,
		138,
		158,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		229,
		200,
		224,
		266,
		250,
		243,
		231,
		196,
		196,
		190,
		-1,
		184,
		163,
		154,
		143,
		141,
		154,
		151,
		156,
		136,
		134,
		153,
		165,
		156,
		173,
		-1,
		-1,
		-1,
		259,
		248,
		249,
		195,
		218,
		255,
		229,
		215,
		220,
		195,
		188,
		182,
		197,
		180,
		161,
		150,
		142,
		131,
		147,
		155,
		150,
		132,
		141,
		147,
		171,
		161,
		167,
		-1,
		-1,
		266,
		256,
		240,
		242,
		239,
		209,
		216,
		248,
		220,
		233,
		-1,
		187,
		-1,
		176,
		171,
		155,
		150,
		147,
		144,
		138,
		147,
		149,
		139,
		134,
		141,
		176,
		176,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		259,
		254,
		229,
		206,
		190,
		226,
		-1,
		203,
		204,
		-1,
		181,
		175,
		172,
		157,
		153,
		148,
		152,
		145,
		152,
		145,
		143,
		144,
		126,
		158,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		252,
		231,
		224,
		244,
		185,
		237,
		-1,
		-1,
		188,
		181,
		-1,
		168,
		150,
		157,
		155,
		149,
		153,
		150,
		139,
		152,
		145,
		131,
		133,
		146,
		150,
		154,
		141,
		137,
		134,
		148,
		-1,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		205,
		-1,
		197,
		189,
		179,
		173,
		167,
		163,
		161,
		177,
		161,
		164,
		162,
		153,
		161,
		134,
		127,
		134,
		123,
		141,
		149,
		141,
		135,
		134,
		144,
		-1,
		272,
		258,
		229,
		-1,
		-1,
		218,
		-1,
		182,
		196,
		212,
		-1,
		205,
		184,
		199,
		177,
		173,
		169,
		184,
		185,
		162,
		162,
		160,
		151,
		139,
		128,
		131,
		123,
		145,
		145,
		129,
		130,
		134,
		-1,
		278,
		265,
		223,
		219,
		208,
		228,
		179,
		167,
		199,
		-1,
		-1,
		241,
		-1,
		175,
		192,
		183,
		181,
		174,
		156,
		163,
		171,
		148,
		143,
		133,
		122,
		122,
		117,
		139,
		125,
		123,
		132,
		148,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		194,
		181,
		175,
		-1,
		216,
		-1,
		219,
		209,
		193,
		178,
		211,
		-1,
		155,
		151,
		158,
		-1,
		168,
		-1,
		141,
		138,
		129,
		114,
		111,
		122,
		120,
		131,
		127,
		-1,
		228,
		213,
		206,
		196,
		210,
		181,
		-1,
		236,
		-1,
		-1,
		206,
		200,
		200,
		184,
		185,
		171,
		151,
		143,
		158,
		157,
		144,
		143,
		127,
		120,
		117,
		110,
		123,
		133,
		138,
		125,
		-1,
		-1,
		-1,
		233,
		219,
		223,
		183,
		202,
		-1,
		-1,
		268,
		223,
		209,
		-1,
		180,
		171,
		159,
		149,
		139,
		144,
		145,
		135,
		133,
		125,
		127,
		121,
		112,
		111,
		127,
		119,
		141,
		-1,
		-1,
		216,
		221,
		209,
		195,
		214,
		-1,
		-1,
		-1,
		215,
		231,
		199,
		178,
		160,
		-1,
		-1,
		143,
		136,
		130,
		133,
		121,
		141,
		136,
		120,
		105,
		120,
		124,
		132,
		123,
		-1,
		219,
		206,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		-1,
		-1,
		211,
		156,
		145,
		140,
		144,
		142,
		-1,
		116,
		127,
		120,
		139,
		146,
		122,
		107,
		101,
		107,
		119,
		128,
		-1,
		-1,
		231,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		168,
		162,
		133,
		126,
		130,
		-1,
		118,
		120,
		117,
		129,
		125,
		122,
		113,
		104,
		100,
		104,
		108,
		122,
		126,
		254,
		-1,
		196,
		-1,
		-1,
		-1,
		186,
		201,
		172,
		149,
		122,
		117,
		110,
		104,
		109,
		120,
		129,
		140,
		105,
		107,
		97,
		96,
		100,
		117,
		121,
		-1,
		-1,
		194,
		190,
		212,
		194,
		198,
		199,
		-1,
		-1,
		126,
		117,
		108,
		100,
		113,
		116,
		101,
		103,
		103,
		101,
		95,
		105,
		120,
		115,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		196,
		197,
		144,
		126,
		122,
		120,
		109,
		103,
		91,
		96,
		106,
		100,
		97,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		185,
		177,
		172,
		178,
		180,
		171,
		159,
		156,
		-1,
		126,
		132,
		97,
		104,
		87,
		94,
		99,
		96,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		178,
		174,
		164,
		154,
		157,
		-1,
		-1,
		151,
		148,
		128,
		97,
		95,
		88,
		83,
		93,
		69,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		168,
		160,
		171,
		146,
		148,
		-1,
		-1,
		124,
		115,
		116,
		104,
		101,
		107,
		106,
		89,
		95,
		96,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		165,
		-1,
		-1,
		146,
		149,
		133,
		123,
		120,
		163,
		118,
		113,
		94,
		92,
		87,
		78,
		103,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		122,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		136,
		-1,
		160,
		-1,
		143,
		147,
		126,
		129,
		108,
		95,
		81,
		89,
		95,
		94,
		100,
		100,
		101,
		110,
		121,
		126,
		132,
		133,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		177,
		216,
		142,
		-1,
		126,
		-1,
		-1,
		-1,
		157,
		139,
		131,
		128,
		107,
		107,
		73,
		77,
		90,
		97,
		107,
		118,
		110,
		109,
		120,
		131,
		130,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		192,
		183,
		210,
		149,
		138,
		133,
		120,
		-1,
		-1,
		141,
		149,
		-1,
		-1,
		114,
		81,
		69,
		79,
		83,
		97,
		109,
		122,
		102,
		108,
		102,
		126,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		211,
		201,
		182,
		180,
		205,
		-1,
		109,
		-1,
		-1,
		121,
		-1,
		-1,
		106,
		86,
		75,
		66,
		71,
		91,
		102,
		124,
		98,
		114,
		107,
		114,
		111,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		177,
		175,
		181,
		188,
		183,
		194,
		-1,
		-1,
		125,
		105,
		-1,
		-1,
		104,
		102,
		91,
		-1,
		81,
		63,
		68,
		98,
		100,
		102,
		101,
		95,
		102,
		101,
		112,
		104,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		174,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		130,
		-1,
		115,
		111,
		-1,
		-1,
		99,
		92,
		80,
		68,
		58,
		68,
		85,
		81,
		88,
		93,
		93,
		104,
		91,
		95,
		98,
		-1,
		248,
		-1,
		200,
		166,
		172,
		187,
		195,
		-1,
		-1,
		-1,
		132,
		118,
		111,
		99,
		97,
		-1,
		133,
		117,
		98,
		-1,
		68,
		81,
		101,
		72,
		94,
		89,
		87,
		98,
		89,
		97,
		91,
		94,
		-1,
		-1,
		165,
		148,
		-1,
		-1,
		122,
		124,
		-1,
		123,
		112,
		97,
		89,
		-1,
		-1,
		105,
		101,
		-1,
		-1,
		55,
		52,
		70,
		100,
		95,
		83,
		95,
		91,
		87,
		97,
		88,
		-1,
		-1,
		143,
		135,
		129,
		-1,
		107,
		-1,
		125,
		-1,
		92,
		98,
		86,
		-1,
		-1,
		-1,
		86,
		49,
		65,
		47,
		87,
		91,
		86,
		79,
		86,
		89,
		82,
		88,
		-1,
		-1,
		-1,
		125,
		99,
		132,
		123,
		106,
		86,
		78,
		97,
		-1,
		67,
		-1,
		42,
		45,
		29,
		79,
		94,
		80,
		76,
		89,
		83,
		80,
		78,
		131,
		-1,
		101,
		134,
		98,
		92,
		68,
		72,
		88,
		-1,
		64,
		46,
		-1,
		0,
		23,
		95,
		70,
		79,
		72,
		66,
		67,
		75,
		-1,
		-1,
		-1,
		103,
		102,
		94,
		88,
		88,
		73,
		64,
		-1,
		76,
		58,
		37,
		46,
		31,
		28,
		28,
		85,
		81,
		84,
		82,
		60,
		-1,
		204,
		-1,
		-1,
		126,
		-1,
		-1,
		-1,
		97,
		92,
		65,
		53,
		59,
		55,
		41,
		47,
		41,
		31,
		25,
		29,
		45,
		43,
		63,
		59,
		91,
		-1,
		199,
		-1,
		133,
		-1,
		-1,
		115,
		95,
		87,
		76,
		65,
		63,
		54,
		45,
		67,
		65,
		50,
		48,
		53,
		58,
		-1,
		188,
		187,
		-1,
		134,
		126,
		112,
		-1,
		105,
		-1,
		111,
		72,
		-1,
		74,
		54,
		-1,
		59,
		55,
		-1,
		-1,
		175,
		150,
		-1,
		-1,
		-1,
		135,
		115,
		106,
		90,
		-1,
		65,
		65,
		-1,
		-1,
		-1,
		160,
		159,
		-1,
		128,
		131,
		-1,
		121,
		112,
		120,
		67,
		71,
		-1,
		-1,
		-1,
		169,
		150,
		144,
		143,
		141,
		136,
		133,
		119,
		103,
		81,
		70,
		91,
		-1,
		-1,
		-1,
		141,
		133,
		126,
		-1,
		-1,
		128,
		111,
		92,
		90,
		-1,
		-1,
		-1,
		163,
		144,
		-1,
		-1,
		118,
		-1,
		-1,
		124,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		152,
		-1,
		-1,
		-1,
		114,
		110,
		111,
		-1,
		-1,
		-1,
		-1,
		174,
		175,
		198,
		162,
		-1,
		-1,
		-1,
		106,
		100,
		-1,
		-1,
		177,
		175,
		-1,
		-1,
		-1,
		134,
		118,
		-1,
		104,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		139,
		-1,
		139,
		114,
		121,
		-1,
		-1,
		-1,
		-1,
		152,
		144,
		152,
		-1,
		124,
		126,
		-1,
		174,
		-1,
		-1,
		167,
		158,
		-1,
		-1,
		129,
		136,
		158,
		161,
		197,
		-1,
		148
	],
	[
		-1,
		255,
		244,
		255,
		263,
		236,
		243,
		-1,
		262,
		266,
		232,
		226,
		265,
		234,
		240,
		251,
		-1,
		-1,
		-1,
		255,
		254,
		222,
		220,
		229,
		234,
		241,
		-1,
		240,
		-1,
		276,
		255,
		266,
		271,
		215,
		212,
		232,
		251,
		233,
		225,
		291,
		245,
		216,
		210,
		228,
		218,
		227,
		219,
		-1,
		216,
		206,
		228,
		207,
		218,
		210,
		-1,
		-1,
		210,
		211,
		217,
		203,
		209,
		205,
		-1,
		215,
		199,
		-1,
		-1,
		200,
		201,
		185,
		188,
		196,
		194,
		207,
		199,
		194,
		-1,
		-1,
		191,
		187,
		194,
		181,
		177,
		194,
		207,
		189,
		203,
		202,
		-1,
		195,
		213,
		220,
		188,
		186,
		170,
		168,
		186,
		188,
		194,
		194,
		-1,
		204,
		205,
		200,
		208,
		210,
		186,
		173,
		173,
		183,
		176,
		195,
		183,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		204,
		187,
		204,
		196,
		186,
		201,
		194,
		176,
		173,
		171,
		168,
		184,
		182,
		192,
		-1,
		-1,
		297,
		266,
		295,
		253,
		234,
		-1,
		200,
		180,
		186,
		190,
		184,
		177,
		191,
		187,
		-1,
		162,
		161,
		189,
		175,
		186,
		257,
		-1,
		-1,
		255,
		247,
		230,
		233,
		210,
		206,
		195,
		194,
		186,
		172,
		168,
		174,
		177,
		177,
		183,
		156,
		166,
		170,
		168,
		193,
		-1,
		-1,
		228,
		-1,
		-1,
		254,
		237,
		-1,
		220,
		227,
		216,
		222,
		208,
		229,
		205,
		196,
		188,
		182,
		170,
		172,
		169,
		182,
		170,
		153,
		178,
		182,
		163,
		184,
		179,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		213,
		216,
		222,
		246,
		245,
		-1,
		217,
		205,
		206,
		191,
		188,
		175,
		163,
		176,
		161,
		168,
		167,
		157,
		155,
		185,
		160,
		182,
		179,
		198,
		203,
		197,
		206,
		-1,
		262,
		258,
		254,
		261,
		210,
		-1,
		-1,
		250,
		-1,
		253,
		254,
		229,
		202,
		205,
		192,
		183,
		170,
		159,
		170,
		159,
		156,
		164,
		149,
		164,
		155,
		154,
		172,
		182,
		190,
		194,
		200,
		-1,
		312,
		-1,
		254,
		238,
		240,
		212,
		233,
		-1,
		270,
		254,
		246,
		231,
		231,
		-1,
		201,
		198,
		188,
		166,
		151,
		168,
		160,
		158,
		162,
		144,
		158,
		149,
		167,
		174,
		172,
		176,
		196,
		208,
		272,
		262,
		-1,
		244,
		249,
		208,
		216,
		235,
		273,
		237,
		-1,
		232,
		-1,
		203,
		216,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		155,
		140,
		137,
		155,
		158,
		165,
		169,
		185,
		-1,
		-1,
		257,
		261,
		250,
		201,
		220,
		244,
		281,
		230,
		219,
		218,
		-1,
		209,
		186,
		183,
		171,
		158,
		143,
		144,
		152,
		165,
		144,
		139,
		136,
		156,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		227,
		198,
		222,
		264,
		248,
		241,
		229,
		194,
		194,
		188,
		-1,
		182,
		161,
		152,
		141,
		139,
		152,
		149,
		154,
		134,
		132,
		151,
		163,
		154,
		171,
		-1,
		-1,
		-1,
		257,
		246,
		247,
		193,
		216,
		253,
		227,
		213,
		218,
		193,
		186,
		180,
		195,
		178,
		159,
		148,
		140,
		129,
		145,
		153,
		148,
		130,
		139,
		145,
		169,
		159,
		165,
		-1,
		-1,
		264,
		254,
		238,
		240,
		237,
		207,
		214,
		246,
		218,
		231,
		-1,
		185,
		-1,
		174,
		169,
		153,
		148,
		145,
		142,
		136,
		145,
		147,
		137,
		132,
		139,
		174,
		174,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		257,
		252,
		227,
		204,
		188,
		224,
		-1,
		201,
		202,
		-1,
		179,
		173,
		170,
		155,
		151,
		146,
		150,
		143,
		150,
		143,
		141,
		142,
		124,
		156,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		250,
		229,
		222,
		242,
		183,
		235,
		-1,
		-1,
		186,
		179,
		-1,
		166,
		148,
		155,
		153,
		147,
		151,
		148,
		137,
		150,
		143,
		129,
		131,
		144,
		148,
		152,
		139,
		135,
		132,
		146,
		-1,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		203,
		-1,
		195,
		187,
		177,
		171,
		165,
		161,
		159,
		175,
		159,
		162,
		160,
		151,
		159,
		132,
		125,
		132,
		121,
		139,
		147,
		139,
		133,
		132,
		142,
		-1,
		270,
		256,
		227,
		-1,
		-1,
		216,
		-1,
		180,
		194,
		210,
		-1,
		203,
		182,
		197,
		175,
		171,
		167,
		182,
		183,
		160,
		160,
		158,
		149,
		137,
		126,
		129,
		121,
		143,
		143,
		127,
		128,
		132,
		-1,
		276,
		263,
		221,
		217,
		206,
		226,
		177,
		165,
		197,
		-1,
		-1,
		239,
		-1,
		173,
		190,
		181,
		179,
		172,
		154,
		161,
		169,
		146,
		141,
		131,
		120,
		120,
		115,
		137,
		123,
		121,
		130,
		146,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		192,
		179,
		173,
		-1,
		214,
		-1,
		217,
		207,
		191,
		176,
		209,
		-1,
		153,
		149,
		156,
		-1,
		166,
		-1,
		139,
		136,
		127,
		112,
		109,
		120,
		118,
		129,
		125,
		-1,
		226,
		211,
		204,
		194,
		208,
		179,
		-1,
		234,
		-1,
		-1,
		204,
		198,
		198,
		182,
		183,
		169,
		149,
		141,
		156,
		155,
		142,
		141,
		125,
		118,
		115,
		108,
		121,
		131,
		136,
		123,
		-1,
		-1,
		-1,
		231,
		217,
		221,
		181,
		200,
		-1,
		-1,
		266,
		221,
		207,
		-1,
		178,
		169,
		157,
		147,
		137,
		142,
		143,
		133,
		131,
		123,
		125,
		119,
		110,
		109,
		125,
		117,
		139,
		-1,
		-1,
		214,
		219,
		207,
		193,
		212,
		-1,
		-1,
		-1,
		213,
		229,
		197,
		176,
		158,
		-1,
		-1,
		141,
		134,
		128,
		131,
		119,
		139,
		134,
		118,
		103,
		118,
		122,
		130,
		121,
		-1,
		217,
		204,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		118,
		137,
		144,
		120,
		105,
		99,
		105,
		117,
		126,
		-1,
		-1,
		229,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		115,
		127,
		123,
		120,
		111,
		102,
		98,
		102,
		106,
		120,
		124,
		252,
		-1,
		194,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		127,
		138,
		103,
		105,
		95,
		94,
		98,
		115,
		119,
		-1,
		-1,
		192,
		188,
		210,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		99,
		101,
		101,
		99,
		93,
		103,
		118,
		113,
		-1,
		-1,
		-1,
		204,
		-1,
		206,
		-1,
		-1,
		194,
		195,
		142,
		124,
		120,
		118,
		107,
		101,
		89,
		94,
		104,
		98,
		95,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		183,
		175,
		170,
		176,
		178,
		169,
		157,
		154,
		-1,
		124,
		130,
		95,
		102,
		85,
		92,
		97,
		94,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		176,
		172,
		162,
		152,
		155,
		-1,
		-1,
		149,
		146,
		126,
		95,
		93,
		86,
		81,
		91,
		67,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		166,
		158,
		169,
		144,
		146,
		-1,
		-1,
		122,
		113,
		114,
		102,
		99,
		105,
		104,
		87,
		93,
		94,
		86,
		85,
		103,
		107,
		116,
		122,
		113,
		126,
		130,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		163,
		-1,
		-1,
		144,
		147,
		131,
		121,
		118,
		161,
		116,
		111,
		92,
		90,
		85,
		76,
		101,
		94,
		94,
		97,
		109,
		114,
		106,
		123,
		122,
		115,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		134,
		-1,
		158,
		-1,
		141,
		145,
		124,
		127,
		106,
		93,
		79,
		87,
		93,
		92,
		98,
		98,
		96,
		103,
		115,
		119,
		129,
		131,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		175,
		214,
		140,
		-1,
		124,
		-1,
		-1,
		-1,
		155,
		137,
		129,
		126,
		105,
		105,
		71,
		75,
		88,
		95,
		105,
		113,
		97,
		102,
		113,
		124,
		123,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		181,
		208,
		147,
		136,
		131,
		118,
		-1,
		-1,
		139,
		147,
		-1,
		-1,
		112,
		79,
		67,
		77,
		81,
		95,
		107,
		109,
		89,
		101,
		95,
		119,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		209,
		199,
		180,
		178,
		203,
		-1,
		107,
		-1,
		-1,
		119,
		-1,
		-1,
		104,
		84,
		73,
		64,
		69,
		89,
		100,
		122,
		85,
		102,
		100,
		107,
		104,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		175,
		173,
		179,
		186,
		181,
		192,
		-1,
		-1,
		123,
		103,
		-1,
		-1,
		102,
		100,
		89,
		-1,
		79,
		61,
		66,
		95,
		79,
		81,
		88,
		82,
		89,
		94,
		105,
		97,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		128,
		-1,
		113,
		109,
		-1,
		-1,
		97,
		90,
		78,
		66,
		56,
		66,
		68,
		58,
		67,
		72,
		80,
		91,
		84,
		88,
		91,
		-1,
		246,
		-1,
		198,
		164,
		170,
		185,
		193,
		-1,
		-1,
		-1,
		130,
		116,
		109,
		97,
		95,
		-1,
		131,
		115,
		96,
		-1,
		66,
		79,
		78,
		49,
		73,
		68,
		80,
		91,
		82,
		90,
		84,
		87,
		-1,
		-1,
		163,
		146,
		-1,
		-1,
		120,
		122,
		-1,
		121,
		110,
		95,
		87,
		-1,
		-1,
		103,
		99,
		-1,
		-1,
		53,
		29,
		47,
		79,
		74,
		76,
		88,
		84,
		80,
		90,
		81,
		-1,
		-1,
		141,
		133,
		127,
		-1,
		105,
		-1,
		123,
		-1,
		90,
		96,
		84,
		-1,
		-1,
		-1,
		84,
		47,
		63,
		24,
		64,
		68,
		79,
		72,
		79,
		82,
		75,
		81,
		-1,
		-1,
		-1,
		123,
		97,
		130,
		121,
		104,
		84,
		76,
		95,
		-1,
		65,
		-1,
		40,
		43,
		6,
		56,
		87,
		73,
		69,
		82,
		76,
		73,
		71,
		129,
		-1,
		99,
		132,
		96,
		90,
		66,
		70,
		86,
		-1,
		62,
		44,
		-1,
		31,
		0,
		88,
		63,
		72,
		65,
		59,
		60,
		68,
		-1,
		-1,
		-1,
		101,
		100,
		92,
		86,
		86,
		71,
		62,
		-1,
		74,
		56,
		35,
		44,
		29,
		26,
		18,
		78,
		74,
		77,
		75,
		53,
		-1,
		202,
		-1,
		-1,
		124,
		-1,
		-1,
		-1,
		95,
		90,
		63,
		51,
		57,
		53,
		39,
		45,
		39,
		21,
		15,
		19,
		35,
		36,
		56,
		52,
		84,
		-1,
		197,
		-1,
		131,
		-1,
		-1,
		113,
		93,
		85,
		74,
		63,
		61,
		52,
		43,
		65,
		57,
		41,
		41,
		46,
		51,
		-1,
		186,
		185,
		-1,
		132,
		124,
		110,
		-1,
		103,
		-1,
		109,
		70,
		-1,
		72,
		52,
		-1,
		52,
		48,
		-1,
		-1,
		173,
		148,
		-1,
		-1,
		-1,
		133,
		113,
		104,
		88,
		-1,
		63,
		63,
		-1,
		-1,
		-1,
		158,
		157,
		-1,
		126,
		129,
		-1,
		119,
		110,
		118,
		65,
		69,
		-1,
		-1,
		-1,
		167,
		148,
		142,
		141,
		139,
		134,
		131,
		117,
		101,
		79,
		68,
		89,
		-1,
		-1,
		-1,
		139,
		131,
		124,
		-1,
		-1,
		126,
		109,
		90,
		88,
		-1,
		-1,
		-1,
		161,
		142,
		-1,
		-1,
		116,
		-1,
		-1,
		122,
		87,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		150,
		-1,
		-1,
		-1,
		112,
		108,
		109,
		-1,
		-1,
		-1,
		-1,
		172,
		173,
		196,
		160,
		-1,
		-1,
		-1,
		104,
		98,
		-1,
		-1,
		175,
		173,
		-1,
		-1,
		-1,
		132,
		116,
		-1,
		102,
		-1,
		-1,
		-1,
		123,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		137,
		-1,
		137,
		112,
		119,
		-1,
		-1,
		-1,
		-1,
		150,
		142,
		150,
		-1,
		122,
		124,
		-1,
		172,
		-1,
		-1,
		165,
		156,
		-1,
		-1,
		127,
		134,
		156,
		159,
		195,
		-1,
		146
	],
	[
		-1,
		280,
		269,
		280,
		288,
		261,
		268,
		-1,
		287,
		291,
		257,
		251,
		290,
		259,
		265,
		276,
		-1,
		-1,
		-1,
		280,
		279,
		247,
		245,
		254,
		259,
		266,
		-1,
		265,
		-1,
		301,
		280,
		291,
		296,
		240,
		237,
		257,
		276,
		258,
		250,
		316,
		270,
		241,
		235,
		253,
		243,
		252,
		244,
		-1,
		241,
		231,
		253,
		232,
		243,
		235,
		-1,
		-1,
		235,
		236,
		242,
		228,
		234,
		230,
		-1,
		240,
		224,
		-1,
		-1,
		225,
		226,
		210,
		213,
		221,
		219,
		232,
		224,
		219,
		-1,
		-1,
		216,
		212,
		219,
		206,
		202,
		219,
		232,
		214,
		228,
		227,
		-1,
		220,
		238,
		245,
		213,
		211,
		195,
		193,
		211,
		213,
		219,
		219,
		-1,
		229,
		230,
		225,
		233,
		235,
		211,
		198,
		198,
		208,
		201,
		220,
		208,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		229,
		212,
		229,
		221,
		211,
		226,
		219,
		201,
		198,
		196,
		193,
		209,
		207,
		217,
		-1,
		-1,
		322,
		291,
		320,
		278,
		259,
		-1,
		225,
		205,
		211,
		215,
		209,
		202,
		216,
		212,
		-1,
		187,
		186,
		214,
		200,
		211,
		282,
		-1,
		-1,
		280,
		272,
		255,
		258,
		235,
		231,
		220,
		219,
		211,
		197,
		193,
		199,
		202,
		202,
		208,
		181,
		191,
		195,
		193,
		218,
		-1,
		-1,
		253,
		-1,
		-1,
		279,
		262,
		-1,
		245,
		252,
		241,
		247,
		233,
		254,
		230,
		221,
		213,
		207,
		195,
		197,
		194,
		207,
		195,
		178,
		203,
		207,
		188,
		209,
		204,
		-1,
		252,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		238,
		241,
		247,
		271,
		270,
		-1,
		242,
		230,
		231,
		216,
		213,
		200,
		188,
		201,
		186,
		193,
		192,
		182,
		180,
		210,
		185,
		207,
		204,
		223,
		228,
		222,
		231,
		-1,
		287,
		283,
		279,
		286,
		235,
		-1,
		-1,
		275,
		-1,
		278,
		279,
		254,
		227,
		230,
		217,
		208,
		195,
		184,
		195,
		184,
		181,
		189,
		174,
		189,
		180,
		179,
		197,
		207,
		215,
		219,
		225,
		-1,
		337,
		-1,
		279,
		263,
		265,
		237,
		258,
		-1,
		295,
		279,
		271,
		256,
		256,
		-1,
		226,
		223,
		213,
		191,
		176,
		193,
		185,
		183,
		187,
		169,
		183,
		174,
		192,
		199,
		197,
		201,
		221,
		233,
		297,
		287,
		-1,
		269,
		274,
		233,
		241,
		260,
		298,
		262,
		-1,
		257,
		-1,
		228,
		241,
		-1,
		197,
		193,
		175,
		176,
		171,
		186,
		180,
		165,
		162,
		180,
		183,
		190,
		194,
		210,
		-1,
		-1,
		282,
		286,
		275,
		226,
		245,
		269,
		306,
		255,
		244,
		243,
		-1,
		234,
		211,
		208,
		196,
		183,
		168,
		169,
		177,
		190,
		169,
		164,
		161,
		181,
		207,
		185,
		197,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		252,
		223,
		247,
		289,
		273,
		266,
		254,
		219,
		219,
		213,
		-1,
		207,
		186,
		177,
		166,
		164,
		177,
		174,
		179,
		159,
		157,
		176,
		188,
		179,
		196,
		-1,
		-1,
		-1,
		282,
		271,
		272,
		218,
		241,
		278,
		252,
		238,
		243,
		218,
		211,
		205,
		220,
		203,
		184,
		173,
		165,
		154,
		170,
		178,
		173,
		155,
		164,
		170,
		194,
		184,
		190,
		-1,
		-1,
		289,
		279,
		263,
		265,
		262,
		232,
		239,
		271,
		243,
		256,
		-1,
		210,
		-1,
		199,
		194,
		178,
		173,
		170,
		167,
		161,
		170,
		172,
		162,
		157,
		164,
		199,
		199,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		282,
		277,
		252,
		229,
		213,
		249,
		-1,
		226,
		227,
		-1,
		204,
		198,
		195,
		180,
		176,
		171,
		175,
		168,
		175,
		168,
		166,
		167,
		149,
		181,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		275,
		254,
		247,
		267,
		208,
		260,
		-1,
		-1,
		211,
		204,
		-1,
		191,
		173,
		180,
		178,
		172,
		176,
		173,
		162,
		175,
		168,
		154,
		156,
		169,
		173,
		177,
		164,
		160,
		157,
		171,
		-1,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		228,
		-1,
		220,
		212,
		202,
		196,
		190,
		186,
		184,
		200,
		184,
		187,
		185,
		176,
		184,
		157,
		150,
		157,
		146,
		164,
		172,
		164,
		158,
		157,
		167,
		-1,
		295,
		281,
		252,
		-1,
		-1,
		241,
		-1,
		205,
		219,
		235,
		-1,
		228,
		207,
		222,
		200,
		196,
		192,
		207,
		208,
		186,
		185,
		183,
		174,
		162,
		151,
		154,
		146,
		168,
		168,
		152,
		153,
		157,
		-1,
		301,
		288,
		246,
		242,
		231,
		251,
		202,
		190,
		222,
		-1,
		-1,
		264,
		-1,
		198,
		215,
		206,
		204,
		197,
		188,
		194,
		194,
		171,
		166,
		156,
		145,
		145,
		140,
		162,
		148,
		146,
		155,
		171,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		217,
		204,
		198,
		-1,
		239,
		-1,
		242,
		232,
		216,
		201,
		234,
		-1,
		194,
		189,
		194,
		-1,
		191,
		-1,
		164,
		161,
		152,
		137,
		134,
		145,
		143,
		154,
		150,
		-1,
		251,
		236,
		229,
		219,
		233,
		204,
		-1,
		259,
		-1,
		-1,
		229,
		223,
		223,
		207,
		210,
		210,
		190,
		182,
		194,
		186,
		178,
		172,
		150,
		143,
		140,
		133,
		146,
		156,
		161,
		148,
		-1,
		-1,
		-1,
		256,
		242,
		246,
		206,
		225,
		-1,
		-1,
		291,
		246,
		232,
		-1,
		216,
		210,
		198,
		188,
		178,
		183,
		184,
		169,
		162,
		148,
		150,
		144,
		135,
		134,
		150,
		142,
		164,
		-1,
		-1,
		239,
		244,
		232,
		218,
		237,
		-1,
		-1,
		-1,
		238,
		254,
		238,
		217,
		199,
		-1,
		-1,
		182,
		175,
		169,
		165,
		152,
		164,
		159,
		143,
		128,
		143,
		147,
		155,
		146,
		-1,
		242,
		229,
		-1,
		-1,
		240,
		234,
		-1,
		-1,
		-1,
		-1,
		250,
		195,
		184,
		179,
		183,
		181,
		-1,
		155,
		166,
		156,
		168,
		175,
		145,
		130,
		124,
		130,
		142,
		151,
		-1,
		-1,
		254,
		-1,
		237,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		172,
		165,
		169,
		-1,
		157,
		159,
		156,
		168,
		148,
		145,
		136,
		127,
		123,
		127,
		131,
		145,
		149,
		277,
		-1,
		228,
		-1,
		-1,
		-1,
		225,
		240,
		211,
		188,
		161,
		156,
		149,
		143,
		148,
		159,
		156,
		167,
		134,
		130,
		120,
		119,
		123,
		140,
		140,
		-1,
		-1,
		226,
		222,
		251,
		233,
		237,
		238,
		-1,
		-1,
		165,
		156,
		147,
		139,
		152,
		155,
		140,
		137,
		131,
		124,
		118,
		128,
		139,
		134,
		-1,
		-1,
		-1,
		238,
		-1,
		240,
		-1,
		-1,
		228,
		236,
		183,
		165,
		161,
		159,
		146,
		140,
		130,
		135,
		141,
		132,
		126,
		114,
		114,
		137,
		126,
		143,
		-1,
		-1,
		310,
		-1,
		-1,
		-1,
		217,
		209,
		204,
		210,
		212,
		203,
		198,
		195,
		-1,
		165,
		169,
		136,
		143,
		126,
		133,
		136,
		128,
		108,
		111,
		127,
		126,
		121,
		135,
		126,
		130,
		-1,
		-1,
		303,
		292,
		281,
		287,
		-1,
		210,
		206,
		196,
		186,
		189,
		-1,
		-1,
		183,
		180,
		160,
		129,
		134,
		127,
		122,
		127,
		108,
		104,
		104,
		99,
		114,
		119,
		121,
		114,
		121,
		136,
		-1,
		257,
		294,
		287,
		255,
		263,
		294,
		-1,
		200,
		192,
		203,
		178,
		180,
		-1,
		-1,
		156,
		147,
		148,
		136,
		133,
		146,
		142,
		112,
		109,
		119,
		97,
		104,
		115,
		107,
		111,
		112,
		115,
		128,
		132,
		-1,
		250,
		270,
		249,
		252,
		276,
		290,
		-1,
		197,
		-1,
		-1,
		189,
		181,
		165,
		155,
		152,
		195,
		142,
		137,
		114,
		112,
		109,
		100,
		121,
		105,
		93,
		90,
		99,
		104,
		96,
		122,
		121,
		114,
		-1,
		239,
		250,
		243,
		-1,
		-1,
		-1,
		-1,
		198,
		-1,
		-1,
		179,
		-1,
		192,
		-1,
		175,
		179,
		150,
		153,
		128,
		115,
		101,
		101,
		107,
		105,
		101,
		97,
		86,
		95,
		106,
		118,
		128,
		130,
		264,
		220,
		223,
		234,
		245,
		260,
		264,
		-1,
		209,
		248,
		185,
		-1,
		169,
		-1,
		-1,
		-1,
		189,
		163,
		155,
		148,
		127,
		127,
		93,
		89,
		102,
		106,
		111,
		103,
		87,
		99,
		112,
		123,
		122,
		260,
		251,
		264,
		209,
		209,
		230,
		239,
		260,
		224,
		215,
		242,
		192,
		181,
		176,
		163,
		-1,
		-1,
		170,
		173,
		-1,
		-1,
		134,
		110,
		97,
		91,
		95,
		109,
		111,
		99,
		79,
		99,
		94,
		118,
		-1,
		253,
		252,
		241,
		238,
		214,
		205,
		200,
		227,
		-1,
		-1,
		222,
		243,
		233,
		225,
		223,
		248,
		-1,
		152,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		115,
		104,
		95,
		81,
		103,
		114,
		126,
		75,
		92,
		99,
		106,
		103,
		237,
		234,
		222,
		220,
		243,
		208,
		196,
		-1,
		209,
		207,
		213,
		220,
		226,
		237,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		92,
		78,
		105,
		86,
		84,
		78,
		72,
		79,
		93,
		104,
		96,
		246,
		260,
		249,
		245,
		244,
		252,
		201,
		194,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		92,
		78,
		74,
		74,
		75,
		70,
		81,
		83,
		87,
		90,
		-1,
		280,
		-1,
		232,
		208,
		215,
		230,
		238,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		102,
		71,
		57,
		68,
		64,
		75,
		81,
		89,
		83,
		86,
		-1,
		-1,
		208,
		191,
		-1,
		-1,
		165,
		167,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		98,
		72,
		69,
		63,
		62,
		60,
		71,
		68,
		79,
		89,
		80,
		-1,
		-1,
		186,
		178,
		172,
		-1,
		150,
		-1,
		168,
		-1,
		135,
		141,
		129,
		-1,
		-1,
		-1,
		129,
		92,
		108,
		79,
		42,
		40,
		52,
		56,
		63,
		73,
		74,
		80,
		-1,
		-1,
		-1,
		168,
		142,
		175,
		166,
		149,
		129,
		121,
		140,
		-1,
		110,
		-1,
		85,
		88,
		93,
		50,
		38,
		24,
		54,
		57,
		63,
		72,
		70,
		174,
		-1,
		144,
		177,
		141,
		135,
		111,
		115,
		131,
		-1,
		107,
		89,
		-1,
		100,
		87,
		0,
		22,
		41,
		50,
		57,
		68,
		67,
		-1,
		-1,
		-1,
		146,
		145,
		137,
		131,
		131,
		116,
		107,
		-1,
		119,
		101,
		80,
		95,
		80,
		71,
		71,
		19,
		25,
		51,
		53,
		62,
		-1,
		247,
		-1,
		-1,
		169,
		-1,
		-1,
		-1,
		140,
		135,
		108,
		96,
		102,
		98,
		84,
		90,
		90,
		83,
		73,
		70,
		63,
		57,
		63,
		63,
		99,
		-1,
		242,
		-1,
		176,
		-1,
		-1,
		158,
		138,
		130,
		119,
		108,
		106,
		97,
		88,
		110,
		114,
		62,
		62,
		67,
		71,
		-1,
		231,
		230,
		-1,
		177,
		169,
		155,
		-1,
		148,
		-1,
		154,
		115,
		-1,
		117,
		97,
		-1,
		73,
		69,
		-1,
		-1,
		218,
		193,
		-1,
		-1,
		-1,
		178,
		158,
		149,
		133,
		-1,
		108,
		108,
		-1,
		-1,
		-1,
		203,
		202,
		-1,
		171,
		174,
		-1,
		164,
		155,
		163,
		110,
		114,
		-1,
		-1,
		-1,
		212,
		193,
		187,
		186,
		184,
		179,
		176,
		162,
		146,
		124,
		113,
		134,
		-1,
		-1,
		-1,
		184,
		176,
		169,
		-1,
		-1,
		171,
		154,
		135,
		133,
		-1,
		-1,
		-1,
		206,
		187,
		-1,
		-1,
		161,
		-1,
		-1,
		167,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		195,
		-1,
		-1,
		-1,
		157,
		153,
		154,
		-1,
		-1,
		-1,
		-1,
		217,
		218,
		241,
		205,
		-1,
		-1,
		-1,
		149,
		143,
		-1,
		-1,
		220,
		218,
		-1,
		-1,
		-1,
		177,
		161,
		-1,
		147,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		182,
		-1,
		182,
		157,
		164,
		-1,
		-1,
		-1,
		-1,
		195,
		187,
		195,
		-1,
		167,
		169,
		-1,
		217,
		-1,
		-1,
		210,
		201,
		-1,
		-1,
		172,
		179,
		201,
		204,
		240,
		-1,
		191
	],
	[
		-1,
		266,
		255,
		266,
		274,
		247,
		254,
		-1,
		273,
		277,
		243,
		237,
		276,
		245,
		251,
		262,
		-1,
		-1,
		-1,
		266,
		265,
		233,
		231,
		240,
		245,
		252,
		-1,
		251,
		-1,
		287,
		266,
		277,
		282,
		226,
		223,
		243,
		262,
		244,
		236,
		302,
		256,
		227,
		221,
		239,
		229,
		238,
		230,
		-1,
		227,
		217,
		239,
		218,
		229,
		221,
		-1,
		-1,
		221,
		222,
		228,
		214,
		220,
		216,
		-1,
		226,
		210,
		-1,
		-1,
		211,
		212,
		196,
		199,
		207,
		205,
		218,
		210,
		205,
		-1,
		-1,
		202,
		198,
		205,
		192,
		188,
		205,
		218,
		200,
		214,
		213,
		-1,
		206,
		224,
		231,
		199,
		197,
		181,
		179,
		197,
		199,
		205,
		205,
		-1,
		215,
		216,
		211,
		219,
		221,
		197,
		184,
		184,
		194,
		187,
		206,
		194,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		215,
		198,
		215,
		207,
		197,
		212,
		205,
		187,
		184,
		182,
		179,
		195,
		193,
		203,
		-1,
		-1,
		308,
		277,
		306,
		264,
		245,
		-1,
		211,
		191,
		197,
		201,
		195,
		188,
		202,
		198,
		-1,
		173,
		172,
		200,
		186,
		197,
		268,
		-1,
		-1,
		266,
		258,
		241,
		244,
		221,
		217,
		206,
		205,
		197,
		183,
		179,
		185,
		188,
		188,
		194,
		167,
		177,
		181,
		179,
		204,
		-1,
		-1,
		239,
		-1,
		-1,
		265,
		248,
		-1,
		231,
		238,
		227,
		233,
		219,
		240,
		216,
		207,
		199,
		193,
		181,
		183,
		180,
		193,
		181,
		164,
		189,
		193,
		174,
		195,
		190,
		-1,
		238,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		224,
		227,
		233,
		257,
		256,
		-1,
		228,
		216,
		217,
		202,
		199,
		186,
		174,
		187,
		172,
		179,
		178,
		168,
		166,
		196,
		171,
		193,
		190,
		209,
		214,
		208,
		217,
		-1,
		273,
		269,
		265,
		272,
		221,
		-1,
		-1,
		261,
		-1,
		264,
		265,
		240,
		213,
		216,
		203,
		194,
		181,
		170,
		181,
		170,
		167,
		175,
		160,
		175,
		166,
		165,
		183,
		193,
		201,
		205,
		211,
		-1,
		323,
		-1,
		265,
		249,
		251,
		223,
		244,
		-1,
		281,
		265,
		257,
		242,
		242,
		-1,
		212,
		209,
		199,
		177,
		162,
		179,
		171,
		169,
		173,
		155,
		169,
		160,
		178,
		185,
		183,
		187,
		207,
		219,
		283,
		273,
		-1,
		255,
		260,
		219,
		227,
		246,
		284,
		248,
		-1,
		243,
		-1,
		214,
		227,
		-1,
		183,
		179,
		161,
		162,
		157,
		172,
		166,
		151,
		148,
		166,
		169,
		176,
		180,
		196,
		-1,
		-1,
		268,
		272,
		261,
		212,
		231,
		255,
		292,
		241,
		230,
		229,
		-1,
		220,
		197,
		194,
		182,
		169,
		154,
		155,
		163,
		176,
		155,
		150,
		147,
		167,
		193,
		171,
		183,
		-1,
		-1,
		-1,
		293,
		-1,
		-1,
		238,
		209,
		233,
		275,
		259,
		252,
		240,
		205,
		205,
		199,
		-1,
		193,
		172,
		163,
		152,
		150,
		163,
		160,
		165,
		145,
		143,
		162,
		174,
		165,
		182,
		-1,
		-1,
		-1,
		268,
		257,
		258,
		204,
		227,
		264,
		238,
		224,
		229,
		204,
		197,
		191,
		206,
		189,
		170,
		159,
		151,
		140,
		156,
		164,
		159,
		141,
		150,
		156,
		180,
		170,
		176,
		-1,
		-1,
		275,
		265,
		249,
		251,
		248,
		218,
		225,
		257,
		229,
		242,
		-1,
		196,
		-1,
		185,
		180,
		164,
		159,
		156,
		153,
		147,
		156,
		158,
		148,
		143,
		150,
		185,
		185,
		160,
		180,
		183,
		-1,
		-1,
		-1,
		268,
		263,
		238,
		215,
		199,
		235,
		-1,
		212,
		213,
		-1,
		190,
		184,
		181,
		166,
		162,
		157,
		161,
		154,
		161,
		154,
		152,
		153,
		135,
		167,
		-1,
		168,
		162,
		170,
		160,
		148,
		-1,
		-1,
		-1,
		261,
		240,
		233,
		253,
		194,
		246,
		-1,
		-1,
		197,
		190,
		-1,
		177,
		159,
		166,
		164,
		158,
		162,
		159,
		148,
		161,
		154,
		140,
		142,
		155,
		159,
		163,
		150,
		146,
		143,
		157,
		-1,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		214,
		-1,
		206,
		198,
		188,
		182,
		176,
		172,
		170,
		186,
		170,
		173,
		171,
		162,
		170,
		143,
		136,
		143,
		132,
		150,
		158,
		150,
		144,
		143,
		153,
		-1,
		281,
		267,
		238,
		-1,
		-1,
		227,
		-1,
		191,
		205,
		221,
		-1,
		214,
		193,
		208,
		186,
		182,
		178,
		193,
		194,
		172,
		171,
		169,
		160,
		148,
		137,
		140,
		132,
		154,
		154,
		138,
		139,
		143,
		-1,
		287,
		274,
		232,
		228,
		217,
		237,
		188,
		176,
		208,
		-1,
		-1,
		250,
		-1,
		184,
		201,
		192,
		190,
		183,
		174,
		180,
		180,
		157,
		152,
		142,
		131,
		131,
		126,
		148,
		134,
		132,
		141,
		157,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		203,
		190,
		184,
		-1,
		225,
		-1,
		228,
		218,
		202,
		187,
		220,
		-1,
		177,
		173,
		180,
		-1,
		177,
		-1,
		150,
		147,
		138,
		123,
		120,
		131,
		129,
		140,
		136,
		-1,
		237,
		222,
		215,
		205,
		219,
		190,
		-1,
		245,
		-1,
		-1,
		215,
		209,
		209,
		193,
		196,
		193,
		173,
		165,
		180,
		172,
		164,
		158,
		136,
		129,
		126,
		119,
		132,
		142,
		147,
		134,
		-1,
		-1,
		-1,
		242,
		228,
		232,
		192,
		211,
		-1,
		-1,
		277,
		232,
		218,
		-1,
		202,
		193,
		181,
		171,
		161,
		166,
		167,
		155,
		148,
		134,
		136,
		130,
		121,
		120,
		136,
		128,
		150,
		-1,
		-1,
		225,
		230,
		218,
		204,
		223,
		-1,
		-1,
		-1,
		224,
		240,
		221,
		200,
		182,
		-1,
		-1,
		165,
		158,
		152,
		151,
		138,
		150,
		145,
		129,
		114,
		129,
		133,
		141,
		132,
		-1,
		228,
		215,
		-1,
		-1,
		226,
		220,
		-1,
		-1,
		-1,
		-1,
		233,
		178,
		167,
		162,
		166,
		164,
		-1,
		138,
		149,
		142,
		154,
		161,
		131,
		116,
		110,
		116,
		128,
		137,
		-1,
		-1,
		240,
		-1,
		223,
		-1,
		-1,
		-1,
		-1,
		190,
		184,
		155,
		148,
		152,
		-1,
		140,
		142,
		139,
		151,
		134,
		131,
		122,
		113,
		109,
		113,
		117,
		131,
		135,
		263,
		-1,
		214,
		-1,
		-1,
		-1,
		208,
		223,
		194,
		171,
		144,
		139,
		132,
		126,
		131,
		142,
		142,
		153,
		120,
		116,
		106,
		105,
		109,
		126,
		126,
		-1,
		-1,
		212,
		208,
		234,
		216,
		220,
		221,
		-1,
		-1,
		148,
		139,
		130,
		122,
		135,
		138,
		123,
		123,
		117,
		110,
		104,
		114,
		125,
		120,
		-1,
		-1,
		-1,
		224,
		-1,
		226,
		-1,
		-1,
		214,
		219,
		166,
		148,
		144,
		142,
		131,
		125,
		113,
		118,
		127,
		118,
		112,
		100,
		100,
		123,
		112,
		129,
		-1,
		-1,
		296,
		-1,
		-1,
		-1,
		203,
		195,
		190,
		196,
		198,
		189,
		181,
		178,
		-1,
		148,
		154,
		119,
		126,
		109,
		116,
		121,
		114,
		94,
		97,
		113,
		112,
		107,
		121,
		112,
		116,
		-1,
		-1,
		289,
		278,
		267,
		273,
		-1,
		196,
		192,
		182,
		172,
		175,
		-1,
		-1,
		169,
		166,
		146,
		115,
		117,
		110,
		105,
		113,
		91,
		90,
		90,
		85,
		100,
		105,
		107,
		100,
		107,
		122,
		-1,
		243,
		280,
		273,
		241,
		249,
		280,
		-1,
		186,
		178,
		189,
		164,
		166,
		-1,
		-1,
		142,
		133,
		134,
		122,
		119,
		129,
		128,
		98,
		95,
		105,
		83,
		90,
		101,
		93,
		97,
		98,
		101,
		114,
		118,
		-1,
		236,
		256,
		235,
		238,
		262,
		276,
		-1,
		183,
		-1,
		-1,
		168,
		167,
		151,
		141,
		138,
		181,
		128,
		123,
		100,
		98,
		95,
		86,
		107,
		91,
		79,
		76,
		85,
		90,
		82,
		108,
		107,
		100,
		-1,
		225,
		236,
		229,
		-1,
		-1,
		-1,
		-1,
		184,
		-1,
		-1,
		158,
		-1,
		178,
		-1,
		161,
		165,
		136,
		139,
		114,
		101,
		87,
		87,
		93,
		91,
		87,
		83,
		72,
		81,
		92,
		104,
		114,
		116,
		250,
		206,
		209,
		220,
		231,
		246,
		250,
		-1,
		195,
		234,
		164,
		-1,
		148,
		-1,
		-1,
		-1,
		175,
		149,
		141,
		134,
		113,
		113,
		79,
		75,
		88,
		92,
		97,
		89,
		73,
		85,
		98,
		109,
		108,
		246,
		237,
		250,
		195,
		195,
		216,
		225,
		246,
		210,
		201,
		228,
		171,
		160,
		155,
		142,
		-1,
		-1,
		156,
		159,
		-1,
		-1,
		120,
		96,
		83,
		77,
		81,
		95,
		97,
		85,
		65,
		85,
		80,
		104,
		-1,
		239,
		238,
		227,
		224,
		200,
		191,
		186,
		213,
		-1,
		-1,
		208,
		229,
		219,
		204,
		202,
		227,
		-1,
		131,
		-1,
		-1,
		136,
		-1,
		-1,
		121,
		101,
		90,
		81,
		67,
		89,
		100,
		112,
		61,
		78,
		85,
		92,
		89,
		223,
		220,
		208,
		206,
		229,
		194,
		182,
		-1,
		195,
		193,
		199,
		206,
		205,
		216,
		-1,
		-1,
		147,
		127,
		-1,
		-1,
		119,
		117,
		106,
		-1,
		96,
		78,
		64,
		91,
		72,
		70,
		64,
		58,
		65,
		79,
		90,
		82,
		232,
		246,
		235,
		231,
		230,
		238,
		187,
		180,
		192,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		137,
		133,
		-1,
		-1,
		114,
		107,
		95,
		83,
		73,
		78,
		64,
		60,
		60,
		61,
		56,
		67,
		69,
		73,
		76,
		-1,
		266,
		-1,
		218,
		188,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		154,
		140,
		133,
		121,
		119,
		-1,
		148,
		132,
		113,
		-1,
		83,
		96,
		88,
		57,
		43,
		54,
		50,
		61,
		67,
		75,
		69,
		72,
		-1,
		-1,
		187,
		170,
		-1,
		-1,
		144,
		146,
		-1,
		145,
		134,
		119,
		111,
		-1,
		-1,
		120,
		116,
		-1,
		-1,
		77,
		58,
		55,
		49,
		48,
		46,
		57,
		54,
		65,
		75,
		66,
		-1,
		-1,
		165,
		157,
		151,
		-1,
		129,
		-1,
		147,
		-1,
		114,
		120,
		108,
		-1,
		-1,
		-1,
		108,
		71,
		87,
		65,
		28,
		26,
		38,
		42,
		49,
		59,
		60,
		66,
		-1,
		-1,
		-1,
		147,
		121,
		154,
		145,
		128,
		108,
		100,
		119,
		-1,
		89,
		-1,
		64,
		67,
		72,
		36,
		24,
		10,
		40,
		43,
		49,
		58,
		56,
		153,
		-1,
		123,
		156,
		120,
		114,
		90,
		94,
		110,
		-1,
		86,
		68,
		-1,
		79,
		66,
		25,
		0,
		23,
		36,
		43,
		54,
		53,
		-1,
		-1,
		-1,
		125,
		124,
		116,
		110,
		110,
		95,
		86,
		-1,
		98,
		80,
		59,
		74,
		59,
		50,
		50,
		15,
		11,
		34,
		36,
		48,
		-1,
		226,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		119,
		114,
		87,
		75,
		81,
		77,
		63,
		69,
		69,
		62,
		52,
		49,
		42,
		36,
		45,
		49,
		84,
		-1,
		221,
		-1,
		155,
		-1,
		-1,
		137,
		117,
		109,
		98,
		87,
		85,
		76,
		67,
		89,
		93,
		41,
		41,
		46,
		51,
		-1,
		210,
		209,
		-1,
		156,
		148,
		134,
		-1,
		127,
		-1,
		133,
		94,
		-1,
		96,
		76,
		-1,
		52,
		48,
		-1,
		-1,
		197,
		172,
		-1,
		-1,
		-1,
		157,
		137,
		128,
		112,
		-1,
		87,
		87,
		-1,
		-1,
		-1,
		182,
		181,
		-1,
		150,
		153,
		-1,
		143,
		134,
		142,
		89,
		93,
		-1,
		-1,
		-1,
		191,
		172,
		166,
		165,
		163,
		158,
		155,
		141,
		125,
		103,
		92,
		113,
		-1,
		-1,
		-1,
		163,
		155,
		148,
		-1,
		-1,
		150,
		133,
		114,
		112,
		-1,
		-1,
		-1,
		185,
		166,
		-1,
		-1,
		140,
		-1,
		-1,
		146,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		174,
		-1,
		-1,
		-1,
		136,
		132,
		133,
		-1,
		-1,
		-1,
		-1,
		196,
		197,
		220,
		184,
		-1,
		-1,
		-1,
		128,
		122,
		-1,
		-1,
		199,
		197,
		-1,
		-1,
		-1,
		156,
		140,
		-1,
		126,
		-1,
		-1,
		-1,
		147,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		161,
		-1,
		161,
		136,
		143,
		-1,
		-1,
		-1,
		-1,
		174,
		166,
		174,
		-1,
		146,
		148,
		-1,
		196,
		-1,
		-1,
		189,
		180,
		-1,
		-1,
		151,
		158,
		180,
		183,
		219,
		-1,
		170
	],
	[
		-1,
		245,
		234,
		245,
		253,
		226,
		233,
		-1,
		252,
		256,
		222,
		216,
		255,
		224,
		230,
		241,
		-1,
		-1,
		-1,
		245,
		244,
		212,
		210,
		219,
		224,
		231,
		-1,
		230,
		-1,
		266,
		245,
		256,
		261,
		205,
		202,
		222,
		241,
		223,
		215,
		281,
		235,
		206,
		200,
		218,
		208,
		217,
		209,
		-1,
		206,
		196,
		218,
		197,
		208,
		200,
		-1,
		-1,
		200,
		201,
		207,
		193,
		199,
		195,
		-1,
		205,
		189,
		-1,
		-1,
		190,
		191,
		175,
		178,
		186,
		184,
		197,
		189,
		184,
		-1,
		-1,
		181,
		177,
		184,
		171,
		167,
		184,
		197,
		179,
		193,
		192,
		-1,
		185,
		203,
		210,
		178,
		176,
		160,
		158,
		176,
		178,
		184,
		184,
		-1,
		194,
		195,
		190,
		198,
		200,
		176,
		163,
		163,
		173,
		166,
		185,
		173,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		194,
		177,
		194,
		186,
		176,
		191,
		184,
		166,
		163,
		161,
		158,
		174,
		172,
		182,
		-1,
		-1,
		287,
		256,
		285,
		243,
		224,
		-1,
		190,
		170,
		176,
		180,
		174,
		167,
		181,
		177,
		-1,
		152,
		151,
		179,
		165,
		176,
		247,
		-1,
		-1,
		245,
		237,
		220,
		223,
		200,
		196,
		185,
		184,
		176,
		162,
		158,
		164,
		167,
		167,
		173,
		146,
		156,
		160,
		158,
		183,
		-1,
		-1,
		218,
		-1,
		-1,
		244,
		227,
		-1,
		210,
		217,
		206,
		212,
		198,
		219,
		195,
		186,
		178,
		172,
		160,
		162,
		159,
		172,
		160,
		143,
		168,
		172,
		153,
		174,
		169,
		-1,
		217,
		201,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		203,
		206,
		212,
		236,
		235,
		-1,
		207,
		195,
		196,
		181,
		178,
		165,
		153,
		166,
		151,
		158,
		157,
		147,
		145,
		175,
		150,
		172,
		169,
		188,
		193,
		187,
		196,
		-1,
		252,
		248,
		244,
		251,
		200,
		-1,
		-1,
		240,
		-1,
		243,
		244,
		219,
		192,
		195,
		182,
		173,
		160,
		149,
		160,
		149,
		146,
		154,
		139,
		154,
		145,
		144,
		162,
		172,
		180,
		184,
		190,
		-1,
		302,
		-1,
		244,
		228,
		230,
		202,
		223,
		-1,
		260,
		244,
		236,
		221,
		221,
		-1,
		191,
		188,
		178,
		156,
		141,
		158,
		150,
		148,
		152,
		134,
		148,
		139,
		157,
		164,
		162,
		166,
		186,
		198,
		262,
		252,
		-1,
		234,
		239,
		198,
		206,
		225,
		263,
		227,
		-1,
		222,
		-1,
		193,
		206,
		-1,
		162,
		158,
		140,
		141,
		136,
		151,
		145,
		130,
		127,
		145,
		148,
		155,
		159,
		175,
		-1,
		-1,
		247,
		251,
		240,
		191,
		210,
		234,
		271,
		220,
		209,
		208,
		-1,
		199,
		176,
		173,
		161,
		148,
		133,
		134,
		142,
		155,
		134,
		129,
		126,
		146,
		172,
		150,
		162,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		217,
		188,
		212,
		254,
		238,
		231,
		219,
		184,
		184,
		178,
		-1,
		172,
		151,
		142,
		131,
		129,
		142,
		139,
		144,
		124,
		122,
		141,
		153,
		144,
		161,
		-1,
		-1,
		-1,
		247,
		236,
		237,
		183,
		206,
		243,
		217,
		203,
		208,
		183,
		176,
		170,
		185,
		168,
		149,
		138,
		130,
		119,
		135,
		143,
		138,
		120,
		129,
		135,
		159,
		149,
		155,
		-1,
		-1,
		254,
		244,
		228,
		230,
		227,
		197,
		204,
		236,
		208,
		221,
		-1,
		175,
		-1,
		164,
		159,
		143,
		138,
		135,
		132,
		126,
		135,
		137,
		127,
		122,
		129,
		164,
		164,
		139,
		159,
		162,
		-1,
		-1,
		-1,
		247,
		242,
		217,
		194,
		178,
		214,
		-1,
		191,
		192,
		-1,
		169,
		163,
		160,
		145,
		141,
		136,
		140,
		133,
		140,
		133,
		131,
		132,
		114,
		146,
		-1,
		147,
		141,
		149,
		139,
		127,
		-1,
		-1,
		-1,
		240,
		219,
		212,
		232,
		173,
		225,
		-1,
		-1,
		176,
		169,
		-1,
		156,
		138,
		145,
		143,
		137,
		141,
		138,
		127,
		140,
		133,
		119,
		121,
		134,
		138,
		142,
		129,
		125,
		122,
		136,
		-1,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		193,
		-1,
		185,
		177,
		167,
		161,
		155,
		151,
		149,
		165,
		149,
		152,
		150,
		141,
		149,
		122,
		115,
		122,
		111,
		129,
		137,
		129,
		123,
		122,
		132,
		-1,
		260,
		246,
		217,
		-1,
		-1,
		206,
		-1,
		170,
		184,
		200,
		-1,
		193,
		172,
		187,
		165,
		161,
		157,
		172,
		173,
		151,
		150,
		148,
		139,
		127,
		116,
		119,
		111,
		133,
		133,
		117,
		118,
		122,
		-1,
		266,
		253,
		211,
		207,
		196,
		216,
		167,
		155,
		187,
		-1,
		-1,
		229,
		-1,
		163,
		180,
		171,
		169,
		162,
		153,
		159,
		159,
		136,
		131,
		121,
		110,
		110,
		105,
		127,
		113,
		111,
		120,
		136,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		182,
		169,
		163,
		-1,
		204,
		-1,
		207,
		197,
		181,
		166,
		199,
		-1,
		164,
		154,
		159,
		-1,
		156,
		-1,
		129,
		126,
		117,
		102,
		99,
		110,
		108,
		119,
		115,
		-1,
		216,
		201,
		194,
		184,
		198,
		169,
		-1,
		224,
		-1,
		-1,
		194,
		188,
		188,
		172,
		175,
		180,
		160,
		152,
		159,
		151,
		143,
		137,
		115,
		108,
		105,
		98,
		111,
		121,
		126,
		113,
		-1,
		-1,
		-1,
		221,
		207,
		211,
		171,
		190,
		-1,
		-1,
		256,
		211,
		197,
		-1,
		181,
		180,
		168,
		158,
		148,
		153,
		154,
		134,
		127,
		113,
		115,
		109,
		100,
		99,
		115,
		107,
		129,
		-1,
		-1,
		204,
		209,
		197,
		183,
		202,
		-1,
		-1,
		-1,
		203,
		219,
		208,
		182,
		169,
		-1,
		-1,
		152,
		145,
		139,
		130,
		117,
		129,
		124,
		108,
		93,
		108,
		112,
		120,
		111,
		-1,
		207,
		194,
		-1,
		-1,
		205,
		199,
		-1,
		-1,
		-1,
		-1,
		220,
		165,
		154,
		149,
		153,
		151,
		-1,
		125,
		136,
		121,
		133,
		140,
		110,
		95,
		89,
		95,
		107,
		116,
		-1,
		-1,
		219,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		177,
		171,
		142,
		135,
		139,
		-1,
		127,
		129,
		123,
		138,
		113,
		110,
		101,
		92,
		88,
		92,
		96,
		110,
		114,
		242,
		-1,
		200,
		-1,
		-1,
		-1,
		195,
		210,
		181,
		158,
		131,
		126,
		119,
		113,
		118,
		129,
		121,
		132,
		99,
		95,
		85,
		84,
		88,
		105,
		105,
		-1,
		-1,
		198,
		194,
		221,
		203,
		207,
		208,
		-1,
		-1,
		135,
		126,
		117,
		109,
		122,
		125,
		105,
		102,
		96,
		89,
		83,
		93,
		104,
		99,
		-1,
		-1,
		-1,
		210,
		-1,
		212,
		-1,
		-1,
		200,
		206,
		153,
		135,
		131,
		129,
		118,
		112,
		100,
		105,
		106,
		97,
		91,
		79,
		79,
		102,
		91,
		108,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		189,
		181,
		176,
		182,
		184,
		175,
		168,
		165,
		-1,
		135,
		141,
		106,
		113,
		96,
		103,
		101,
		93,
		73,
		76,
		92,
		91,
		86,
		100,
		91,
		95,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		182,
		178,
		168,
		158,
		161,
		-1,
		-1,
		155,
		152,
		132,
		101,
		104,
		97,
		92,
		99,
		80,
		69,
		69,
		64,
		79,
		84,
		86,
		79,
		86,
		101,
		-1,
		229,
		266,
		259,
		227,
		235,
		266,
		-1,
		172,
		164,
		175,
		150,
		152,
		-1,
		-1,
		128,
		119,
		120,
		108,
		105,
		112,
		107,
		84,
		78,
		84,
		62,
		69,
		80,
		72,
		76,
		77,
		80,
		93,
		97,
		-1,
		222,
		242,
		221,
		224,
		248,
		262,
		-1,
		169,
		-1,
		-1,
		176,
		153,
		137,
		127,
		124,
		167,
		114,
		109,
		86,
		84,
		81,
		72,
		86,
		70,
		58,
		55,
		64,
		69,
		61,
		87,
		86,
		79,
		-1,
		211,
		222,
		215,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		166,
		-1,
		164,
		-1,
		147,
		151,
		122,
		125,
		100,
		87,
		73,
		73,
		79,
		70,
		66,
		62,
		51,
		60,
		71,
		83,
		93,
		95,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		181,
		220,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		161,
		135,
		127,
		120,
		99,
		99,
		65,
		61,
		74,
		71,
		77,
		68,
		53,
		64,
		77,
		88,
		87,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		196,
		187,
		214,
		179,
		168,
		163,
		150,
		-1,
		-1,
		142,
		145,
		-1,
		-1,
		106,
		82,
		69,
		63,
		67,
		81,
		77,
		65,
		45,
		65,
		59,
		83,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		215,
		205,
		209,
		210,
		235,
		-1,
		139,
		-1,
		-1,
		122,
		-1,
		-1,
		107,
		87,
		76,
		67,
		53,
		75,
		81,
		92,
		41,
		58,
		64,
		71,
		68,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		209,
		224,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		105,
		103,
		92,
		-1,
		82,
		64,
		50,
		77,
		58,
		50,
		44,
		38,
		45,
		58,
		69,
		61,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		100,
		93,
		81,
		69,
		59,
		64,
		50,
		46,
		46,
		41,
		36,
		47,
		48,
		52,
		55,
		-1,
		252,
		-1,
		204,
		180,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		134,
		118,
		99,
		-1,
		69,
		82,
		82,
		50,
		34,
		40,
		30,
		41,
		46,
		54,
		48,
		51,
		-1,
		-1,
		192,
		178,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		70,
		62,
		53,
		40,
		39,
		26,
		38,
		34,
		44,
		54,
		45,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		108,
		71,
		92,
		69,
		32,
		30,
		28,
		22,
		29,
		39,
		39,
		45,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		97,
		-1,
		72,
		72,
		80,
		40,
		42,
		28,
		19,
		22,
		28,
		37,
		35,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		94,
		76,
		-1,
		87,
		74,
		43,
		19,
		0,
		15,
		22,
		33,
		32,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		82,
		67,
		58,
		58,
		33,
		29,
		15,
		17,
		27,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		77,
		70,
		60,
		57,
		50,
		44,
		27,
		28,
		64,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		101,
		49,
		40,
		35,
		36,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		51,
		40,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		230,
		219,
		230,
		238,
		211,
		218,
		-1,
		237,
		241,
		207,
		201,
		240,
		209,
		215,
		226,
		-1,
		-1,
		-1,
		230,
		229,
		197,
		195,
		204,
		209,
		216,
		-1,
		215,
		-1,
		251,
		230,
		241,
		246,
		190,
		187,
		207,
		226,
		208,
		200,
		266,
		220,
		191,
		185,
		203,
		193,
		202,
		194,
		-1,
		191,
		181,
		203,
		182,
		193,
		185,
		-1,
		-1,
		185,
		186,
		192,
		178,
		184,
		180,
		-1,
		190,
		174,
		-1,
		-1,
		175,
		176,
		160,
		163,
		171,
		169,
		182,
		174,
		169,
		-1,
		-1,
		166,
		162,
		169,
		156,
		152,
		169,
		182,
		164,
		178,
		177,
		-1,
		170,
		188,
		195,
		163,
		161,
		145,
		143,
		161,
		163,
		169,
		169,
		-1,
		179,
		180,
		175,
		183,
		185,
		161,
		148,
		148,
		158,
		151,
		170,
		158,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		179,
		162,
		179,
		171,
		161,
		176,
		169,
		151,
		148,
		146,
		143,
		159,
		157,
		167,
		-1,
		-1,
		272,
		241,
		270,
		228,
		209,
		-1,
		175,
		155,
		161,
		165,
		159,
		152,
		166,
		162,
		-1,
		137,
		136,
		164,
		150,
		161,
		232,
		-1,
		-1,
		230,
		222,
		205,
		208,
		185,
		181,
		170,
		169,
		161,
		147,
		143,
		149,
		152,
		152,
		158,
		131,
		141,
		145,
		143,
		168,
		-1,
		-1,
		203,
		-1,
		-1,
		229,
		212,
		-1,
		195,
		202,
		191,
		197,
		183,
		204,
		180,
		171,
		163,
		157,
		145,
		147,
		144,
		157,
		145,
		128,
		153,
		157,
		138,
		159,
		154,
		-1,
		202,
		186,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		188,
		191,
		197,
		221,
		220,
		-1,
		192,
		180,
		181,
		166,
		163,
		150,
		138,
		151,
		136,
		143,
		142,
		132,
		130,
		160,
		135,
		157,
		154,
		173,
		178,
		172,
		181,
		-1,
		237,
		233,
		229,
		236,
		185,
		-1,
		-1,
		225,
		-1,
		228,
		229,
		204,
		177,
		180,
		167,
		158,
		145,
		134,
		145,
		134,
		131,
		139,
		124,
		139,
		130,
		129,
		147,
		157,
		165,
		169,
		175,
		-1,
		287,
		-1,
		229,
		213,
		215,
		187,
		208,
		-1,
		245,
		229,
		221,
		206,
		206,
		-1,
		176,
		173,
		163,
		141,
		126,
		143,
		135,
		133,
		137,
		119,
		133,
		124,
		142,
		149,
		147,
		151,
		171,
		183,
		247,
		237,
		-1,
		219,
		224,
		183,
		191,
		210,
		248,
		212,
		-1,
		207,
		-1,
		178,
		191,
		-1,
		147,
		143,
		125,
		126,
		121,
		136,
		130,
		115,
		112,
		130,
		133,
		140,
		144,
		160,
		-1,
		-1,
		232,
		236,
		225,
		176,
		195,
		219,
		256,
		205,
		194,
		193,
		-1,
		184,
		161,
		158,
		146,
		133,
		118,
		119,
		127,
		140,
		119,
		114,
		111,
		131,
		157,
		135,
		147,
		-1,
		-1,
		-1,
		257,
		-1,
		-1,
		202,
		173,
		197,
		239,
		223,
		216,
		204,
		169,
		169,
		163,
		-1,
		157,
		136,
		127,
		116,
		114,
		127,
		124,
		129,
		109,
		107,
		126,
		138,
		129,
		146,
		-1,
		-1,
		-1,
		232,
		221,
		222,
		168,
		191,
		228,
		202,
		188,
		193,
		168,
		161,
		155,
		170,
		153,
		134,
		123,
		115,
		104,
		120,
		128,
		123,
		105,
		114,
		120,
		144,
		134,
		140,
		-1,
		-1,
		239,
		229,
		213,
		215,
		212,
		182,
		189,
		221,
		193,
		206,
		-1,
		160,
		-1,
		149,
		144,
		128,
		123,
		120,
		117,
		111,
		120,
		122,
		112,
		107,
		114,
		149,
		149,
		124,
		144,
		147,
		-1,
		-1,
		-1,
		232,
		227,
		202,
		179,
		163,
		199,
		-1,
		176,
		177,
		-1,
		154,
		148,
		145,
		130,
		126,
		121,
		125,
		118,
		125,
		118,
		116,
		117,
		99,
		131,
		-1,
		132,
		126,
		134,
		124,
		112,
		-1,
		-1,
		-1,
		225,
		204,
		197,
		217,
		158,
		210,
		-1,
		-1,
		161,
		154,
		-1,
		141,
		123,
		130,
		128,
		122,
		126,
		123,
		112,
		125,
		118,
		104,
		106,
		119,
		123,
		127,
		114,
		110,
		107,
		121,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		178,
		-1,
		170,
		162,
		152,
		146,
		140,
		136,
		134,
		150,
		134,
		137,
		135,
		126,
		134,
		107,
		100,
		107,
		96,
		114,
		122,
		114,
		108,
		107,
		117,
		-1,
		245,
		231,
		202,
		-1,
		-1,
		191,
		-1,
		155,
		169,
		185,
		-1,
		178,
		157,
		172,
		150,
		146,
		142,
		157,
		158,
		136,
		135,
		133,
		124,
		112,
		101,
		104,
		96,
		118,
		118,
		102,
		103,
		107,
		-1,
		251,
		238,
		196,
		192,
		181,
		201,
		152,
		140,
		172,
		-1,
		-1,
		214,
		-1,
		148,
		165,
		156,
		154,
		147,
		138,
		144,
		144,
		121,
		116,
		106,
		95,
		95,
		90,
		112,
		98,
		96,
		105,
		121,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		167,
		154,
		148,
		-1,
		189,
		-1,
		192,
		182,
		166,
		151,
		184,
		-1,
		149,
		139,
		144,
		-1,
		141,
		-1,
		114,
		111,
		102,
		87,
		84,
		95,
		93,
		104,
		100,
		-1,
		201,
		186,
		179,
		169,
		183,
		154,
		-1,
		209,
		-1,
		-1,
		179,
		173,
		173,
		157,
		160,
		165,
		145,
		137,
		144,
		136,
		128,
		122,
		100,
		93,
		90,
		83,
		96,
		106,
		111,
		98,
		-1,
		-1,
		-1,
		206,
		192,
		196,
		156,
		175,
		-1,
		-1,
		241,
		196,
		182,
		-1,
		166,
		165,
		153,
		143,
		133,
		138,
		139,
		119,
		112,
		98,
		100,
		94,
		85,
		84,
		100,
		92,
		114,
		-1,
		-1,
		189,
		194,
		182,
		168,
		187,
		-1,
		-1,
		-1,
		188,
		204,
		193,
		167,
		154,
		-1,
		-1,
		137,
		130,
		124,
		115,
		102,
		114,
		109,
		93,
		78,
		93,
		97,
		105,
		96,
		-1,
		192,
		179,
		-1,
		-1,
		190,
		184,
		-1,
		-1,
		-1,
		-1,
		205,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		121,
		106,
		118,
		125,
		95,
		80,
		74,
		80,
		92,
		101,
		-1,
		-1,
		204,
		-1,
		194,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		127,
		120,
		124,
		-1,
		112,
		114,
		108,
		123,
		98,
		95,
		86,
		77,
		73,
		77,
		81,
		95,
		99,
		227,
		-1,
		185,
		-1,
		-1,
		-1,
		180,
		195,
		166,
		143,
		116,
		111,
		104,
		98,
		103,
		114,
		106,
		117,
		84,
		80,
		70,
		69,
		73,
		90,
		90,
		-1,
		-1,
		183,
		179,
		206,
		188,
		192,
		193,
		-1,
		-1,
		120,
		111,
		102,
		94,
		107,
		110,
		90,
		87,
		81,
		74,
		68,
		78,
		89,
		84,
		-1,
		-1,
		-1,
		195,
		-1,
		197,
		-1,
		-1,
		185,
		191,
		138,
		120,
		116,
		114,
		103,
		97,
		85,
		90,
		91,
		82,
		76,
		64,
		64,
		87,
		76,
		93,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		174,
		166,
		161,
		167,
		169,
		160,
		153,
		150,
		-1,
		120,
		126,
		91,
		98,
		81,
		88,
		86,
		78,
		58,
		61,
		77,
		76,
		71,
		85,
		76,
		80,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		167,
		163,
		153,
		143,
		146,
		-1,
		-1,
		140,
		137,
		117,
		86,
		89,
		82,
		77,
		84,
		65,
		54,
		54,
		49,
		64,
		69,
		71,
		64,
		71,
		86,
		-1,
		214,
		251,
		244,
		212,
		220,
		251,
		-1,
		157,
		149,
		160,
		135,
		137,
		-1,
		-1,
		113,
		104,
		105,
		93,
		90,
		97,
		92,
		69,
		63,
		69,
		47,
		54,
		65,
		57,
		61,
		62,
		65,
		78,
		82,
		-1,
		207,
		227,
		206,
		209,
		233,
		247,
		-1,
		154,
		-1,
		-1,
		162,
		138,
		122,
		112,
		109,
		152,
		99,
		94,
		71,
		69,
		66,
		57,
		71,
		55,
		43,
		40,
		49,
		54,
		46,
		72,
		71,
		64,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		152,
		-1,
		149,
		-1,
		132,
		136,
		107,
		110,
		85,
		72,
		58,
		58,
		64,
		55,
		51,
		47,
		36,
		45,
		56,
		68,
		78,
		80,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		166,
		205,
		158,
		-1,
		142,
		-1,
		-1,
		-1,
		146,
		120,
		112,
		105,
		84,
		84,
		50,
		46,
		59,
		56,
		62,
		53,
		38,
		49,
		62,
		73,
		72,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		181,
		172,
		199,
		165,
		154,
		149,
		136,
		-1,
		-1,
		127,
		130,
		-1,
		-1,
		91,
		67,
		54,
		48,
		52,
		66,
		62,
		50,
		30,
		50,
		44,
		68,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		200,
		190,
		194,
		196,
		221,
		-1,
		125,
		-1,
		-1,
		107,
		-1,
		-1,
		92,
		72,
		61,
		52,
		38,
		60,
		66,
		77,
		26,
		43,
		49,
		56,
		53,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		166,
		164,
		170,
		177,
		194,
		210,
		-1,
		-1,
		141,
		121,
		-1,
		-1,
		90,
		88,
		77,
		-1,
		67,
		49,
		35,
		62,
		43,
		35,
		29,
		23,
		30,
		43,
		54,
		46,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		163,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		131,
		127,
		-1,
		-1,
		85,
		78,
		66,
		54,
		44,
		49,
		35,
		31,
		31,
		26,
		21,
		32,
		33,
		37,
		40,
		-1,
		237,
		-1,
		189,
		165,
		179,
		194,
		202,
		-1,
		-1,
		-1,
		148,
		134,
		127,
		115,
		113,
		-1,
		119,
		103,
		84,
		-1,
		54,
		67,
		67,
		35,
		27,
		25,
		15,
		26,
		31,
		39,
		33,
		36,
		-1,
		-1,
		177,
		164,
		-1,
		-1,
		138,
		140,
		-1,
		139,
		128,
		113,
		105,
		-1,
		-1,
		91,
		87,
		-1,
		-1,
		55,
		49,
		38,
		33,
		29,
		11,
		23,
		19,
		29,
		39,
		30,
		-1,
		-1,
		159,
		151,
		145,
		-1,
		123,
		-1,
		141,
		-1,
		108,
		114,
		102,
		-1,
		-1,
		-1,
		93,
		56,
		77,
		56,
		25,
		23,
		14,
		7,
		14,
		24,
		24,
		30,
		-1,
		-1,
		-1,
		141,
		115,
		148,
		139,
		122,
		102,
		94,
		113,
		-1,
		83,
		-1,
		58,
		57,
		66,
		33,
		36,
		30,
		4,
		17,
		13,
		22,
		20,
		147,
		-1,
		117,
		150,
		114,
		108,
		84,
		88,
		104,
		-1,
		80,
		62,
		-1,
		73,
		60,
		47,
		32,
		13,
		0,
		7,
		21,
		17,
		-1,
		-1,
		-1,
		119,
		118,
		110,
		104,
		104,
		89,
		80,
		-1,
		92,
		74,
		53,
		68,
		53,
		44,
		44,
		37,
		33,
		20,
		20,
		12,
		-1,
		220,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		113,
		108,
		81,
		69,
		75,
		71,
		57,
		63,
		63,
		56,
		46,
		43,
		39,
		30,
		36,
		13,
		49,
		-1,
		215,
		-1,
		149,
		-1,
		-1,
		131,
		111,
		103,
		92,
		81,
		79,
		70,
		61,
		83,
		87,
		37,
		25,
		20,
		21,
		-1,
		204,
		203,
		-1,
		150,
		142,
		128,
		-1,
		121,
		-1,
		127,
		88,
		-1,
		90,
		70,
		-1,
		36,
		25,
		-1,
		-1,
		191,
		166,
		-1,
		-1,
		-1,
		151,
		131,
		122,
		106,
		-1,
		81,
		81,
		-1,
		-1,
		-1,
		176,
		175,
		-1,
		144,
		147,
		-1,
		137,
		128,
		136,
		83,
		87,
		-1,
		-1,
		-1,
		185,
		166,
		160,
		159,
		157,
		152,
		149,
		135,
		119,
		97,
		86,
		107,
		-1,
		-1,
		-1,
		157,
		149,
		142,
		-1,
		-1,
		144,
		127,
		108,
		106,
		-1,
		-1,
		-1,
		179,
		160,
		-1,
		-1,
		134,
		-1,
		-1,
		140,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		196,
		168,
		-1,
		-1,
		-1,
		130,
		126,
		127,
		-1,
		-1,
		-1,
		-1,
		190,
		191,
		214,
		178,
		-1,
		-1,
		-1,
		122,
		116,
		-1,
		-1,
		193,
		191,
		-1,
		-1,
		-1,
		150,
		134,
		-1,
		120,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		153,
		-1,
		-1,
		-1,
		155,
		-1,
		155,
		130,
		137,
		-1,
		-1,
		-1,
		-1,
		168,
		160,
		168,
		-1,
		140,
		142,
		-1,
		190,
		-1,
		-1,
		183,
		174,
		-1,
		-1,
		145,
		152,
		174,
		177,
		213,
		-1,
		164
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		146,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		148,
		154,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		131,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		159,
		149,
		154,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		170,
		175,
		155,
		147,
		154,
		146,
		138,
		132,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		176,
		175,
		163,
		153,
		143,
		148,
		149,
		129,
		122,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		203,
		177,
		164,
		-1,
		-1,
		147,
		140,
		134,
		125,
		112,
		124,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		215,
		160,
		149,
		144,
		148,
		146,
		-1,
		120,
		131,
		116,
		128,
		135,
		105,
		90,
		84,
		90,
		102,
		111,
		-1,
		-1,
		214,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		172,
		166,
		137,
		130,
		134,
		-1,
		122,
		124,
		118,
		133,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		105,
		109,
		237,
		-1,
		195,
		-1,
		-1,
		-1,
		190,
		205,
		176,
		153,
		126,
		121,
		114,
		108,
		113,
		124,
		116,
		127,
		94,
		90,
		80,
		79,
		83,
		100,
		100,
		-1,
		-1,
		193,
		189,
		216,
		198,
		202,
		203,
		-1,
		-1,
		130,
		121,
		112,
		104,
		117,
		120,
		100,
		97,
		91,
		84,
		78,
		88,
		99,
		94,
		-1,
		-1,
		-1,
		205,
		-1,
		207,
		-1,
		-1,
		195,
		201,
		148,
		130,
		126,
		124,
		113,
		107,
		95,
		100,
		101,
		92,
		86,
		74,
		74,
		97,
		86,
		103,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		184,
		176,
		171,
		177,
		179,
		170,
		163,
		160,
		-1,
		130,
		136,
		101,
		108,
		91,
		98,
		96,
		88,
		68,
		71,
		87,
		86,
		81,
		95,
		86,
		90,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		177,
		173,
		163,
		153,
		156,
		-1,
		-1,
		150,
		147,
		127,
		96,
		99,
		92,
		87,
		94,
		75,
		64,
		64,
		59,
		74,
		79,
		81,
		74,
		81,
		96,
		-1,
		224,
		261,
		254,
		222,
		230,
		261,
		-1,
		167,
		159,
		170,
		145,
		147,
		-1,
		-1,
		123,
		114,
		115,
		103,
		100,
		107,
		102,
		79,
		73,
		79,
		57,
		64,
		75,
		67,
		71,
		72,
		73,
		86,
		90,
		-1,
		217,
		237,
		216,
		219,
		243,
		257,
		-1,
		164,
		-1,
		-1,
		158,
		148,
		132,
		122,
		119,
		162,
		109,
		104,
		81,
		79,
		76,
		67,
		81,
		65,
		53,
		50,
		59,
		64,
		56,
		82,
		79,
		72,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		148,
		-1,
		159,
		-1,
		142,
		146,
		117,
		120,
		95,
		82,
		68,
		68,
		74,
		65,
		61,
		57,
		46,
		55,
		66,
		74,
		84,
		88,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		176,
		215,
		154,
		-1,
		138,
		-1,
		-1,
		-1,
		156,
		130,
		122,
		115,
		94,
		94,
		60,
		56,
		69,
		66,
		72,
		63,
		48,
		57,
		68,
		79,
		80,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		191,
		182,
		209,
		161,
		150,
		145,
		132,
		-1,
		-1,
		137,
		140,
		-1,
		-1,
		101,
		77,
		64,
		58,
		62,
		76,
		72,
		60,
		40,
		56,
		50,
		76,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		210,
		200,
		194,
		192,
		217,
		-1,
		121,
		-1,
		-1,
		117,
		-1,
		-1,
		102,
		82,
		71,
		62,
		48,
		70,
		76,
		87,
		36,
		53,
		55,
		62,
		61,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		176,
		174,
		180,
		187,
		195,
		206,
		-1,
		-1,
		137,
		117,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		59,
		45,
		72,
		53,
		45,
		39,
		33,
		40,
		49,
		62,
		54,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		127,
		123,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		59,
		45,
		41,
		41,
		36,
		31,
		42,
		39,
		43,
		48,
		-1,
		247,
		-1,
		199,
		175,
		184,
		199,
		207,
		-1,
		-1,
		-1,
		144,
		130,
		123,
		111,
		109,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		77,
		45,
		37,
		35,
		25,
		36,
		37,
		45,
		41,
		44,
		-1,
		-1,
		177,
		160,
		-1,
		-1,
		134,
		136,
		-1,
		135,
		124,
		109,
		101,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		65,
		59,
		48,
		43,
		39,
		21,
		33,
		29,
		35,
		47,
		38,
		-1,
		-1,
		155,
		147,
		141,
		-1,
		119,
		-1,
		137,
		-1,
		104,
		110,
		98,
		-1,
		-1,
		-1,
		98,
		61,
		77,
		66,
		35,
		33,
		24,
		17,
		24,
		30,
		30,
		38,
		-1,
		-1,
		-1,
		137,
		111,
		144,
		135,
		118,
		98,
		90,
		109,
		-1,
		79,
		-1,
		54,
		57,
		62,
		43,
		46,
		40,
		14,
		27,
		19,
		28,
		28,
		143,
		-1,
		113,
		146,
		110,
		104,
		80,
		84,
		100,
		-1,
		76,
		58,
		-1,
		69,
		56,
		57,
		42,
		23,
		10,
		0,
		17,
		25,
		-1,
		-1,
		-1,
		115,
		114,
		106,
		100,
		100,
		85,
		76,
		-1,
		88,
		70,
		49,
		64,
		49,
		40,
		40,
		47,
		43,
		28,
		26,
		6,
		-1,
		216,
		-1,
		-1,
		138,
		-1,
		-1,
		-1,
		109,
		104,
		77,
		65,
		71,
		67,
		53,
		59,
		59,
		52,
		42,
		39,
		35,
		26,
		32,
		9,
		44,
		-1,
		211,
		-1,
		145,
		-1,
		-1,
		127,
		107,
		99,
		88,
		77,
		75,
		66,
		57,
		79,
		83,
		33,
		21,
		16,
		17,
		-1,
		200,
		199,
		-1,
		146,
		138,
		124,
		-1,
		117,
		-1,
		123,
		84,
		-1,
		86,
		66,
		-1,
		32,
		21,
		-1,
		-1,
		187,
		162,
		-1,
		-1,
		-1,
		147,
		127,
		118,
		102,
		-1,
		77,
		77,
		-1,
		-1,
		-1,
		172,
		171,
		-1,
		140,
		143,
		-1,
		133,
		124,
		132,
		79,
		83,
		-1,
		-1,
		-1,
		181,
		162,
		156,
		155,
		153,
		148,
		145,
		131,
		115,
		93,
		82,
		103,
		-1,
		-1,
		-1,
		153,
		145,
		138,
		-1,
		-1,
		140,
		123,
		104,
		102,
		-1,
		-1,
		-1,
		175,
		156,
		-1,
		-1,
		130,
		-1,
		-1,
		136,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		164,
		-1,
		-1,
		-1,
		126,
		122,
		123,
		-1,
		-1,
		-1,
		-1,
		186,
		187,
		210,
		174,
		-1,
		-1,
		-1,
		118,
		112,
		-1,
		-1,
		189,
		187,
		-1,
		-1,
		-1,
		146,
		130,
		-1,
		116,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		149,
		-1,
		-1,
		-1,
		151,
		-1,
		151,
		126,
		133,
		-1,
		-1,
		-1,
		-1,
		164,
		156,
		164,
		-1,
		136,
		138,
		-1,
		186,
		-1,
		-1,
		179,
		170,
		-1,
		-1,
		141,
		148,
		170,
		173,
		209,
		-1,
		160
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		146,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		148,
		154,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		121,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		159,
		149,
		154,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		170,
		175,
		155,
		147,
		154,
		146,
		138,
		132,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		176,
		175,
		163,
		153,
		143,
		148,
		149,
		129,
		122,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		203,
		177,
		164,
		-1,
		-1,
		147,
		140,
		134,
		125,
		112,
		124,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		215,
		160,
		149,
		144,
		148,
		146,
		-1,
		120,
		131,
		116,
		128,
		135,
		105,
		90,
		84,
		90,
		102,
		108,
		-1,
		-1,
		214,
		-1,
		209,
		-1,
		-1,
		-1,
		-1,
		172,
		166,
		137,
		130,
		134,
		-1,
		122,
		124,
		118,
		133,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		93,
		99,
		237,
		-1,
		200,
		-1,
		-1,
		-1,
		190,
		205,
		176,
		153,
		126,
		121,
		114,
		108,
		113,
		124,
		116,
		127,
		94,
		90,
		80,
		79,
		83,
		97,
		97,
		-1,
		-1,
		198,
		194,
		216,
		198,
		202,
		203,
		-1,
		-1,
		130,
		121,
		112,
		104,
		117,
		120,
		100,
		97,
		91,
		84,
		78,
		88,
		96,
		91,
		-1,
		-1,
		-1,
		210,
		-1,
		212,
		-1,
		-1,
		200,
		201,
		148,
		130,
		126,
		124,
		113,
		107,
		95,
		100,
		101,
		92,
		86,
		74,
		74,
		97,
		83,
		87,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		189,
		181,
		176,
		182,
		184,
		175,
		163,
		160,
		-1,
		130,
		136,
		101,
		108,
		91,
		98,
		96,
		88,
		68,
		71,
		87,
		86,
		74,
		79,
		70,
		78,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		182,
		178,
		168,
		158,
		161,
		-1,
		-1,
		155,
		152,
		132,
		101,
		99,
		92,
		87,
		97,
		77,
		64,
		64,
		59,
		74,
		76,
		71,
		64,
		69,
		84,
		-1,
		229,
		266,
		259,
		227,
		235,
		266,
		-1,
		172,
		164,
		175,
		150,
		152,
		-1,
		-1,
		128,
		119,
		120,
		108,
		105,
		107,
		102,
		90,
		73,
		79,
		57,
		64,
		75,
		67,
		71,
		67,
		56,
		69,
		73,
		-1,
		222,
		242,
		221,
		224,
		248,
		262,
		-1,
		169,
		-1,
		-1,
		157,
		153,
		137,
		127,
		124,
		167,
		120,
		115,
		92,
		90,
		87,
		78,
		81,
		65,
		53,
		50,
		59,
		64,
		56,
		66,
		62,
		55,
		-1,
		211,
		222,
		215,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		147,
		-1,
		164,
		-1,
		147,
		151,
		128,
		131,
		106,
		93,
		79,
		79,
		85,
		65,
		61,
		57,
		46,
		43,
		55,
		59,
		69,
		71,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		181,
		220,
		153,
		-1,
		137,
		-1,
		-1,
		-1,
		161,
		141,
		133,
		126,
		105,
		105,
		71,
		67,
		70,
		66,
		73,
		63,
		53,
		42,
		53,
		64,
		63,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		196,
		187,
		214,
		160,
		149,
		144,
		131,
		-1,
		-1,
		148,
		151,
		-1,
		-1,
		112,
		88,
		75,
		69,
		73,
		80,
		83,
		71,
		51,
		41,
		35,
		59,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		215,
		205,
		193,
		191,
		216,
		-1,
		120,
		-1,
		-1,
		128,
		-1,
		-1,
		113,
		93,
		82,
		73,
		59,
		81,
		87,
		98,
		47,
		47,
		40,
		47,
		44,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		181,
		179,
		185,
		192,
		194,
		205,
		-1,
		-1,
		136,
		116,
		-1,
		-1,
		111,
		109,
		98,
		-1,
		88,
		70,
		56,
		83,
		64,
		56,
		50,
		44,
		38,
		34,
		45,
		37,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		126,
		122,
		-1,
		-1,
		106,
		99,
		87,
		75,
		65,
		70,
		56,
		52,
		52,
		47,
		42,
		52,
		24,
		28,
		31,
		-1,
		252,
		-1,
		204,
		177,
		183,
		198,
		206,
		-1,
		-1,
		-1,
		143,
		129,
		122,
		110,
		108,
		-1,
		140,
		124,
		105,
		-1,
		75,
		88,
		88,
		56,
		48,
		46,
		36,
		41,
		22,
		30,
		24,
		27,
		-1,
		-1,
		176,
		159,
		-1,
		-1,
		133,
		135,
		-1,
		134,
		123,
		108,
		100,
		-1,
		-1,
		112,
		108,
		-1,
		-1,
		66,
		70,
		59,
		54,
		50,
		32,
		39,
		30,
		20,
		30,
		21,
		-1,
		-1,
		154,
		146,
		140,
		-1,
		118,
		-1,
		136,
		-1,
		103,
		109,
		97,
		-1,
		-1,
		-1,
		97,
		60,
		76,
		77,
		46,
		44,
		35,
		28,
		34,
		22,
		15,
		21,
		-1,
		-1,
		-1,
		136,
		110,
		143,
		134,
		117,
		97,
		89,
		108,
		-1,
		78,
		-1,
		53,
		56,
		61,
		54,
		57,
		49,
		25,
		34,
		16,
		13,
		11,
		142,
		-1,
		112,
		145,
		109,
		103,
		79,
		83,
		99,
		-1,
		75,
		57,
		-1,
		68,
		55,
		64,
		49,
		30,
		21,
		15,
		0,
		8,
		-1,
		-1,
		-1,
		114,
		113,
		105,
		99,
		99,
		84,
		75,
		-1,
		87,
		69,
		48,
		63,
		48,
		39,
		39,
		54,
		50,
		32,
		30,
		9,
		-1,
		215,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		108,
		103,
		76,
		64,
		70,
		66,
		52,
		58,
		58,
		51,
		41,
		38,
		34,
		25,
		31,
		8,
		41,
		-1,
		210,
		-1,
		144,
		-1,
		-1,
		126,
		106,
		98,
		87,
		76,
		74,
		65,
		56,
		78,
		82,
		32,
		20,
		15,
		16,
		-1,
		199,
		198,
		-1,
		145,
		137,
		123,
		-1,
		116,
		-1,
		122,
		83,
		-1,
		85,
		65,
		-1,
		31,
		20,
		-1,
		-1,
		186,
		161,
		-1,
		-1,
		-1,
		146,
		126,
		117,
		101,
		-1,
		76,
		76,
		-1,
		-1,
		-1,
		171,
		170,
		-1,
		139,
		142,
		-1,
		132,
		123,
		131,
		78,
		82,
		-1,
		-1,
		-1,
		180,
		161,
		155,
		154,
		152,
		147,
		144,
		130,
		114,
		92,
		81,
		102,
		-1,
		-1,
		-1,
		152,
		144,
		137,
		-1,
		-1,
		139,
		122,
		103,
		101,
		-1,
		-1,
		-1,
		174,
		155,
		-1,
		-1,
		129,
		-1,
		-1,
		135,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		163,
		-1,
		-1,
		-1,
		125,
		121,
		122,
		-1,
		-1,
		-1,
		-1,
		185,
		186,
		209,
		173,
		-1,
		-1,
		-1,
		117,
		111,
		-1,
		-1,
		188,
		186,
		-1,
		-1,
		-1,
		145,
		129,
		-1,
		115,
		-1,
		-1,
		-1,
		136,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		150,
		-1,
		150,
		125,
		132,
		-1,
		-1,
		-1,
		-1,
		163,
		155,
		163,
		-1,
		135,
		137,
		-1,
		185,
		-1,
		-1,
		178,
		169,
		-1,
		-1,
		140,
		147,
		169,
		172,
		208,
		-1,
		159
	],
	[
		-1,
		232,
		221,
		232,
		240,
		213,
		220,
		-1,
		239,
		243,
		209,
		203,
		242,
		211,
		217,
		228,
		-1,
		-1,
		-1,
		232,
		231,
		199,
		197,
		206,
		211,
		218,
		-1,
		217,
		-1,
		253,
		232,
		243,
		248,
		192,
		189,
		209,
		228,
		210,
		202,
		268,
		222,
		193,
		187,
		205,
		195,
		204,
		196,
		-1,
		193,
		183,
		205,
		184,
		195,
		187,
		-1,
		-1,
		187,
		188,
		194,
		180,
		186,
		182,
		-1,
		192,
		176,
		-1,
		-1,
		177,
		178,
		162,
		165,
		173,
		171,
		184,
		176,
		171,
		-1,
		-1,
		168,
		164,
		171,
		158,
		154,
		171,
		184,
		166,
		180,
		179,
		-1,
		172,
		190,
		197,
		165,
		163,
		147,
		145,
		163,
		165,
		171,
		171,
		-1,
		181,
		182,
		177,
		185,
		187,
		163,
		150,
		150,
		160,
		153,
		172,
		160,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		181,
		164,
		181,
		173,
		163,
		178,
		171,
		153,
		150,
		148,
		145,
		161,
		159,
		169,
		-1,
		-1,
		274,
		243,
		272,
		230,
		211,
		-1,
		177,
		157,
		163,
		167,
		161,
		154,
		168,
		164,
		-1,
		139,
		138,
		166,
		152,
		163,
		234,
		-1,
		-1,
		232,
		224,
		207,
		210,
		187,
		183,
		172,
		171,
		163,
		149,
		145,
		151,
		154,
		154,
		160,
		133,
		143,
		147,
		145,
		170,
		-1,
		-1,
		205,
		-1,
		-1,
		231,
		214,
		-1,
		197,
		204,
		193,
		199,
		185,
		206,
		182,
		173,
		165,
		159,
		147,
		149,
		146,
		159,
		147,
		130,
		155,
		159,
		140,
		161,
		156,
		-1,
		204,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		190,
		193,
		199,
		223,
		222,
		-1,
		194,
		182,
		183,
		168,
		165,
		152,
		140,
		153,
		138,
		145,
		144,
		134,
		132,
		162,
		137,
		159,
		156,
		175,
		180,
		174,
		183,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		227,
		-1,
		230,
		231,
		206,
		179,
		182,
		169,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		126,
		141,
		132,
		131,
		149,
		159,
		167,
		171,
		177,
		-1,
		289,
		-1,
		231,
		215,
		217,
		189,
		210,
		-1,
		247,
		231,
		223,
		208,
		208,
		-1,
		178,
		175,
		165,
		143,
		128,
		145,
		137,
		135,
		139,
		121,
		135,
		126,
		144,
		151,
		149,
		153,
		173,
		185,
		249,
		239,
		-1,
		221,
		226,
		185,
		193,
		212,
		250,
		214,
		-1,
		209,
		-1,
		180,
		193,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		132,
		117,
		114,
		132,
		135,
		142,
		146,
		162,
		-1,
		-1,
		234,
		238,
		227,
		178,
		197,
		221,
		258,
		207,
		196,
		195,
		-1,
		186,
		163,
		160,
		148,
		135,
		120,
		121,
		129,
		142,
		121,
		116,
		113,
		133,
		159,
		137,
		149,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		204,
		175,
		199,
		241,
		225,
		218,
		206,
		171,
		171,
		165,
		-1,
		159,
		138,
		129,
		118,
		116,
		129,
		126,
		131,
		111,
		109,
		128,
		140,
		131,
		148,
		-1,
		-1,
		-1,
		234,
		223,
		224,
		170,
		193,
		230,
		204,
		190,
		195,
		170,
		163,
		157,
		172,
		155,
		136,
		125,
		117,
		106,
		122,
		130,
		125,
		107,
		116,
		122,
		146,
		136,
		142,
		-1,
		-1,
		241,
		231,
		215,
		217,
		214,
		184,
		191,
		223,
		195,
		208,
		-1,
		162,
		-1,
		151,
		146,
		130,
		125,
		122,
		119,
		113,
		122,
		124,
		114,
		109,
		116,
		151,
		151,
		126,
		146,
		149,
		-1,
		-1,
		-1,
		234,
		229,
		204,
		181,
		165,
		201,
		-1,
		178,
		179,
		-1,
		156,
		150,
		147,
		132,
		128,
		123,
		127,
		120,
		127,
		120,
		118,
		119,
		101,
		133,
		-1,
		134,
		128,
		136,
		126,
		114,
		-1,
		-1,
		-1,
		227,
		206,
		199,
		219,
		160,
		212,
		-1,
		-1,
		163,
		156,
		-1,
		143,
		125,
		132,
		130,
		124,
		128,
		125,
		114,
		127,
		120,
		106,
		108,
		121,
		125,
		129,
		116,
		112,
		109,
		123,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		180,
		-1,
		172,
		164,
		154,
		148,
		142,
		138,
		136,
		152,
		136,
		139,
		137,
		128,
		136,
		109,
		102,
		109,
		98,
		116,
		124,
		116,
		110,
		109,
		119,
		-1,
		247,
		233,
		204,
		-1,
		-1,
		193,
		-1,
		157,
		171,
		187,
		-1,
		180,
		159,
		174,
		152,
		148,
		144,
		159,
		160,
		138,
		137,
		135,
		126,
		114,
		103,
		106,
		98,
		120,
		120,
		104,
		105,
		109,
		-1,
		253,
		240,
		198,
		194,
		183,
		203,
		154,
		142,
		174,
		-1,
		-1,
		216,
		-1,
		150,
		167,
		158,
		156,
		149,
		140,
		146,
		146,
		123,
		118,
		108,
		97,
		97,
		92,
		114,
		100,
		98,
		107,
		113,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		169,
		156,
		150,
		-1,
		191,
		-1,
		194,
		184,
		168,
		153,
		186,
		-1,
		151,
		141,
		146,
		-1,
		143,
		-1,
		116,
		113,
		104,
		89,
		86,
		97,
		95,
		106,
		102,
		-1,
		203,
		188,
		181,
		171,
		185,
		156,
		-1,
		211,
		-1,
		-1,
		181,
		175,
		175,
		159,
		162,
		167,
		147,
		139,
		146,
		138,
		130,
		124,
		102,
		95,
		92,
		85,
		98,
		108,
		113,
		100,
		-1,
		-1,
		-1,
		208,
		194,
		198,
		158,
		177,
		-1,
		-1,
		243,
		198,
		184,
		-1,
		168,
		167,
		155,
		145,
		135,
		140,
		141,
		121,
		114,
		100,
		102,
		96,
		87,
		86,
		102,
		94,
		116,
		-1,
		-1,
		191,
		196,
		184,
		170,
		189,
		-1,
		-1,
		-1,
		190,
		206,
		195,
		169,
		156,
		-1,
		-1,
		139,
		132,
		126,
		117,
		104,
		116,
		111,
		95,
		80,
		95,
		99,
		107,
		98,
		-1,
		194,
		181,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		-1,
		-1,
		207,
		152,
		141,
		136,
		140,
		138,
		-1,
		112,
		123,
		108,
		120,
		127,
		97,
		82,
		76,
		82,
		94,
		100,
		-1,
		-1,
		206,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		129,
		122,
		126,
		-1,
		114,
		116,
		110,
		125,
		100,
		97,
		88,
		79,
		75,
		79,
		83,
		85,
		91,
		229,
		-1,
		192,
		-1,
		-1,
		-1,
		182,
		197,
		168,
		145,
		118,
		113,
		106,
		100,
		105,
		116,
		108,
		119,
		86,
		82,
		72,
		71,
		75,
		89,
		89,
		-1,
		-1,
		190,
		186,
		208,
		190,
		194,
		195,
		-1,
		-1,
		122,
		113,
		104,
		96,
		109,
		112,
		92,
		89,
		83,
		76,
		70,
		80,
		88,
		83,
		-1,
		-1,
		-1,
		202,
		-1,
		204,
		-1,
		-1,
		192,
		193,
		140,
		122,
		118,
		116,
		105,
		99,
		87,
		92,
		93,
		84,
		78,
		66,
		66,
		89,
		75,
		79,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		155,
		152,
		-1,
		122,
		128,
		93,
		100,
		83,
		90,
		88,
		80,
		60,
		63,
		79,
		78,
		66,
		71,
		62,
		70,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		147,
		144,
		124,
		93,
		91,
		84,
		79,
		89,
		69,
		56,
		56,
		51,
		66,
		68,
		63,
		56,
		61,
		76,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		120,
		111,
		112,
		100,
		97,
		99,
		94,
		85,
		65,
		71,
		49,
		56,
		67,
		59,
		63,
		59,
		48,
		61,
		65,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		161,
		-1,
		-1,
		164,
		145,
		129,
		119,
		116,
		159,
		114,
		109,
		90,
		88,
		82,
		73,
		73,
		57,
		45,
		42,
		51,
		56,
		48,
		58,
		54,
		47,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		154,
		-1,
		156,
		-1,
		139,
		143,
		122,
		125,
		104,
		91,
		77,
		73,
		82,
		57,
		53,
		49,
		38,
		35,
		47,
		51,
		61,
		63,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		173,
		212,
		160,
		-1,
		144,
		-1,
		-1,
		-1,
		153,
		135,
		127,
		124,
		103,
		103,
		69,
		65,
		62,
		58,
		65,
		55,
		45,
		34,
		45,
		56,
		55,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		188,
		179,
		206,
		167,
		156,
		151,
		138,
		-1,
		-1,
		146,
		145,
		-1,
		-1,
		110,
		86,
		73,
		67,
		69,
		72,
		80,
		64,
		44,
		33,
		27,
		51,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		207,
		197,
		200,
		198,
		223,
		-1,
		127,
		-1,
		-1,
		126,
		-1,
		-1,
		111,
		91,
		80,
		71,
		57,
		77,
		84,
		95,
		45,
		39,
		32,
		39,
		36,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		201,
		212,
		-1,
		-1,
		143,
		123,
		-1,
		-1,
		109,
		107,
		96,
		-1,
		86,
		68,
		54,
		81,
		62,
		54,
		48,
		42,
		30,
		26,
		37,
		29,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		133,
		129,
		-1,
		-1,
		104,
		97,
		85,
		73,
		63,
		68,
		54,
		50,
		50,
		45,
		40,
		44,
		16,
		20,
		23,
		-1,
		244,
		-1,
		196,
		172,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		150,
		136,
		129,
		117,
		115,
		-1,
		138,
		122,
		103,
		-1,
		73,
		86,
		86,
		54,
		46,
		44,
		34,
		33,
		14,
		22,
		16,
		19,
		-1,
		-1,
		183,
		166,
		-1,
		-1,
		140,
		142,
		-1,
		141,
		130,
		115,
		107,
		-1,
		-1,
		110,
		106,
		-1,
		-1,
		73,
		68,
		57,
		52,
		48,
		30,
		31,
		22,
		12,
		22,
		13,
		-1,
		-1,
		161,
		153,
		147,
		-1,
		125,
		-1,
		143,
		-1,
		110,
		116,
		104,
		-1,
		-1,
		-1,
		104,
		67,
		83,
		75,
		44,
		42,
		33,
		26,
		26,
		14,
		7,
		13,
		-1,
		-1,
		-1,
		143,
		117,
		150,
		141,
		124,
		104,
		96,
		115,
		-1,
		85,
		-1,
		60,
		63,
		68,
		52,
		55,
		49,
		23,
		36,
		9,
		5,
		3,
		149,
		-1,
		119,
		152,
		116,
		110,
		86,
		90,
		106,
		-1,
		82,
		64,
		-1,
		75,
		62,
		66,
		51,
		32,
		19,
		22,
		7,
		0,
		-1,
		-1,
		-1,
		121,
		120,
		112,
		106,
		106,
		91,
		82,
		-1,
		94,
		76,
		55,
		70,
		55,
		46,
		46,
		56,
		52,
		39,
		37,
		16,
		-1,
		222,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		115,
		110,
		83,
		71,
		77,
		73,
		59,
		65,
		65,
		58,
		48,
		45,
		41,
		32,
		38,
		15,
		48,
		-1,
		217,
		-1,
		151,
		-1,
		-1,
		133,
		113,
		105,
		94,
		83,
		81,
		72,
		63,
		85,
		89,
		39,
		27,
		22,
		23,
		-1,
		206,
		205,
		-1,
		152,
		144,
		130,
		-1,
		123,
		-1,
		129,
		90,
		-1,
		92,
		72,
		-1,
		38,
		27,
		-1,
		-1,
		193,
		168,
		-1,
		-1,
		-1,
		153,
		133,
		124,
		108,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		178,
		177,
		-1,
		146,
		149,
		-1,
		139,
		130,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		187,
		168,
		162,
		161,
		159,
		154,
		151,
		137,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		159,
		151,
		144,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		181,
		162,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		198,
		170,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		192,
		193,
		216,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		195,
		193,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		300,
		289,
		300,
		308,
		281,
		288,
		-1,
		307,
		311,
		277,
		271,
		310,
		279,
		285,
		296,
		-1,
		-1,
		-1,
		300,
		299,
		267,
		265,
		274,
		279,
		286,
		-1,
		285,
		-1,
		321,
		300,
		311,
		316,
		260,
		257,
		277,
		296,
		278,
		270,
		336,
		290,
		261,
		255,
		273,
		263,
		272,
		264,
		-1,
		261,
		251,
		273,
		252,
		263,
		255,
		-1,
		-1,
		255,
		256,
		262,
		248,
		254,
		250,
		-1,
		260,
		244,
		-1,
		-1,
		245,
		246,
		230,
		233,
		241,
		239,
		252,
		244,
		239,
		-1,
		-1,
		236,
		232,
		239,
		226,
		222,
		239,
		252,
		234,
		248,
		247,
		-1,
		240,
		258,
		265,
		233,
		231,
		215,
		213,
		231,
		233,
		239,
		239,
		-1,
		249,
		250,
		245,
		253,
		255,
		231,
		218,
		218,
		228,
		221,
		240,
		228,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		249,
		232,
		249,
		241,
		231,
		246,
		239,
		221,
		218,
		216,
		213,
		229,
		227,
		237,
		-1,
		-1,
		342,
		311,
		340,
		298,
		279,
		-1,
		245,
		225,
		231,
		235,
		229,
		222,
		236,
		232,
		-1,
		207,
		206,
		234,
		220,
		231,
		302,
		-1,
		-1,
		300,
		292,
		275,
		278,
		255,
		251,
		240,
		239,
		231,
		217,
		213,
		219,
		222,
		222,
		228,
		201,
		211,
		215,
		213,
		238,
		-1,
		-1,
		273,
		-1,
		-1,
		299,
		282,
		-1,
		265,
		272,
		261,
		267,
		253,
		274,
		250,
		241,
		233,
		227,
		215,
		217,
		214,
		227,
		215,
		198,
		223,
		227,
		208,
		229,
		224,
		-1,
		272,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		258,
		261,
		267,
		291,
		290,
		-1,
		262,
		250,
		251,
		236,
		233,
		220,
		208,
		221,
		206,
		213,
		212,
		202,
		200,
		230,
		205,
		227,
		224,
		243,
		248,
		242,
		251,
		-1,
		307,
		303,
		299,
		306,
		255,
		-1,
		-1,
		295,
		-1,
		298,
		299,
		274,
		247,
		250,
		237,
		228,
		215,
		204,
		215,
		204,
		201,
		209,
		194,
		209,
		200,
		199,
		217,
		227,
		235,
		239,
		245,
		-1,
		357,
		-1,
		299,
		283,
		285,
		257,
		278,
		-1,
		315,
		299,
		291,
		276,
		276,
		-1,
		246,
		243,
		233,
		211,
		196,
		213,
		205,
		203,
		207,
		189,
		203,
		194,
		212,
		219,
		217,
		221,
		241,
		253,
		317,
		307,
		-1,
		289,
		294,
		253,
		261,
		280,
		318,
		282,
		-1,
		277,
		-1,
		248,
		261,
		-1,
		217,
		213,
		195,
		196,
		191,
		206,
		200,
		185,
		182,
		200,
		203,
		210,
		214,
		230,
		-1,
		-1,
		302,
		306,
		295,
		246,
		265,
		289,
		326,
		275,
		264,
		263,
		-1,
		254,
		231,
		228,
		216,
		203,
		188,
		189,
		197,
		210,
		189,
		184,
		181,
		201,
		227,
		205,
		217,
		-1,
		-1,
		-1,
		327,
		-1,
		-1,
		272,
		243,
		267,
		309,
		293,
		286,
		274,
		239,
		239,
		233,
		-1,
		227,
		206,
		197,
		186,
		184,
		197,
		194,
		199,
		179,
		177,
		196,
		208,
		199,
		216,
		-1,
		-1,
		-1,
		302,
		291,
		292,
		238,
		261,
		298,
		272,
		258,
		263,
		238,
		231,
		225,
		240,
		223,
		204,
		193,
		185,
		174,
		190,
		198,
		193,
		175,
		184,
		190,
		214,
		204,
		210,
		-1,
		-1,
		309,
		299,
		283,
		285,
		282,
		252,
		259,
		291,
		263,
		276,
		-1,
		230,
		-1,
		219,
		214,
		198,
		193,
		190,
		187,
		181,
		190,
		192,
		182,
		177,
		184,
		219,
		219,
		194,
		214,
		217,
		-1,
		-1,
		-1,
		302,
		297,
		272,
		249,
		233,
		269,
		-1,
		246,
		247,
		-1,
		224,
		218,
		215,
		200,
		196,
		191,
		195,
		188,
		195,
		188,
		186,
		187,
		169,
		201,
		-1,
		202,
		196,
		204,
		194,
		182,
		-1,
		-1,
		-1,
		295,
		274,
		267,
		287,
		228,
		280,
		-1,
		-1,
		231,
		224,
		-1,
		211,
		193,
		200,
		198,
		192,
		196,
		193,
		182,
		195,
		188,
		174,
		176,
		189,
		193,
		197,
		184,
		180,
		177,
		191,
		-1,
		314,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		248,
		-1,
		240,
		232,
		222,
		216,
		210,
		206,
		204,
		220,
		204,
		207,
		205,
		196,
		204,
		177,
		170,
		177,
		166,
		184,
		192,
		184,
		178,
		177,
		187,
		-1,
		315,
		301,
		272,
		-1,
		-1,
		261,
		-1,
		225,
		239,
		255,
		-1,
		248,
		227,
		242,
		220,
		216,
		212,
		227,
		228,
		205,
		205,
		203,
		194,
		182,
		171,
		174,
		166,
		188,
		188,
		172,
		173,
		177,
		-1,
		321,
		308,
		266,
		262,
		251,
		271,
		222,
		210,
		242,
		-1,
		-1,
		284,
		-1,
		218,
		235,
		226,
		224,
		217,
		199,
		206,
		214,
		191,
		186,
		176,
		165,
		165,
		160,
		182,
		168,
		166,
		175,
		191,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		237,
		224,
		218,
		-1,
		259,
		-1,
		262,
		252,
		236,
		221,
		254,
		-1,
		198,
		194,
		201,
		-1,
		211,
		-1,
		184,
		181,
		172,
		157,
		154,
		165,
		163,
		174,
		170,
		-1,
		271,
		256,
		249,
		239,
		253,
		224,
		-1,
		279,
		-1,
		-1,
		249,
		243,
		243,
		227,
		228,
		214,
		194,
		186,
		201,
		200,
		187,
		186,
		170,
		163,
		160,
		153,
		166,
		176,
		181,
		168,
		-1,
		-1,
		-1,
		276,
		244,
		252,
		226,
		245,
		-1,
		-1,
		311,
		266,
		252,
		-1,
		223,
		214,
		202,
		192,
		182,
		187,
		188,
		178,
		176,
		168,
		170,
		164,
		155,
		154,
		170,
		162,
		184,
		-1,
		-1,
		241,
		254,
		252,
		234,
		229,
		-1,
		-1,
		-1,
		258,
		274,
		242,
		221,
		203,
		-1,
		-1,
		186,
		179,
		173,
		176,
		164,
		184,
		179,
		163,
		148,
		163,
		167,
		175,
		166,
		-1,
		244,
		231,
		-1,
		-1,
		228,
		218,
		-1,
		-1,
		-1,
		-1,
		254,
		199,
		188,
		183,
		187,
		185,
		-1,
		159,
		170,
		163,
		182,
		189,
		165,
		150,
		144,
		150,
		162,
		171,
		-1,
		-1,
		242,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		211,
		205,
		176,
		169,
		173,
		-1,
		161,
		163,
		160,
		172,
		168,
		165,
		156,
		147,
		143,
		147,
		151,
		165,
		169,
		265,
		-1,
		195,
		-1,
		-1,
		-1,
		229,
		235,
		215,
		192,
		165,
		160,
		153,
		147,
		152,
		163,
		172,
		183,
		148,
		150,
		140,
		139,
		143,
		160,
		164,
		-1,
		-1,
		193,
		189,
		224,
		236,
		208,
		242,
		-1,
		-1,
		166,
		159,
		151,
		143,
		156,
		159,
		144,
		146,
		146,
		144,
		138,
		148,
		163,
		158,
		-1,
		-1,
		-1,
		191,
		-1,
		207,
		-1,
		-1,
		198,
		239,
		186,
		168,
		164,
		150,
		152,
		146,
		134,
		139,
		149,
		143,
		140,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		197,
		-1,
		-1,
		-1,
		157,
		176,
		171,
		177,
		182,
		173,
		201,
		198,
		-1,
		147,
		175,
		140,
		147,
		130,
		137,
		142,
		139,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		190,
		179,
		168,
		174,
		-1,
		150,
		173,
		163,
		153,
		159,
		-1,
		-1,
		165,
		162,
		160,
		140,
		138,
		131,
		126,
		136,
		112,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		144,
		181,
		174,
		142,
		150,
		181,
		-1,
		140,
		132,
		160,
		145,
		153,
		-1,
		-1,
		138,
		129,
		134,
		143,
		144,
		150,
		149,
		132,
		138,
		139,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		137,
		157,
		136,
		139,
		163,
		177,
		-1,
		131,
		-1,
		-1,
		141,
		163,
		147,
		137,
		134,
		181,
		157,
		152,
		137,
		135,
		130,
		121,
		146,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		126,
		137,
		130,
		-1,
		-1,
		-1,
		-1,
		125,
		-1,
		-1,
		131,
		-1,
		174,
		-1,
		157,
		161,
		165,
		168,
		151,
		138,
		124,
		132,
		138,
		137,
		143,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		151,
		107,
		110,
		121,
		132,
		147,
		151,
		-1,
		115,
		151,
		137,
		-1,
		121,
		-1,
		-1,
		-1,
		171,
		178,
		170,
		171,
		150,
		150,
		116,
		120,
		133,
		140,
		150,
		161,
		153,
		157,
		170,
		181,
		184,
		147,
		138,
		151,
		96,
		96,
		117,
		126,
		147,
		111,
		108,
		145,
		144,
		133,
		128,
		115,
		-1,
		-1,
		184,
		188,
		-1,
		-1,
		157,
		124,
		112,
		122,
		126,
		140,
		152,
		165,
		153,
		158,
		152,
		184,
		-1,
		140,
		139,
		128,
		125,
		101,
		92,
		87,
		114,
		-1,
		-1,
		109,
		136,
		120,
		124,
		140,
		165,
		-1,
		99,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		129,
		118,
		109,
		114,
		134,
		145,
		167,
		149,
		166,
		157,
		167,
		171,
		124,
		121,
		109,
		107,
		130,
		95,
		83,
		-1,
		91,
		94,
		100,
		107,
		124,
		154,
		-1,
		-1,
		115,
		95,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		106,
		111,
		141,
		143,
		145,
		152,
		146,
		153,
		161,
		172,
		164,
		133,
		147,
		136,
		132,
		131,
		139,
		88,
		81,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		105,
		101,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		128,
		128,
		131,
		136,
		144,
		155,
		151,
		155,
		158,
		-1,
		167,
		-1,
		119,
		80,
		86,
		101,
		109,
		-1,
		-1,
		-1,
		122,
		108,
		101,
		89,
		87,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		164,
		132,
		137,
		132,
		147,
		158,
		149,
		157,
		151,
		154,
		-1,
		-1,
		79,
		62,
		-1,
		-1,
		36,
		38,
		-1,
		113,
		102,
		87,
		79,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		98,
		136,
		135,
		143,
		138,
		143,
		155,
		151,
		147,
		157,
		148,
		-1,
		-1,
		57,
		49,
		43,
		-1,
		21,
		-1,
		115,
		-1,
		82,
		89,
		77,
		-1,
		-1,
		-1,
		129,
		92,
		108,
		131,
		157,
		155,
		146,
		139,
		146,
		149,
		142,
		148,
		-1,
		-1,
		-1,
		39,
		13,
		122,
		113,
		96,
		76,
		68,
		88,
		-1,
		110,
		-1,
		85,
		88,
		113,
		152,
		154,
		140,
		136,
		149,
		143,
		140,
		138,
		45,
		-1,
		10,
		67,
		51,
		82,
		48,
		60,
		124,
		-1,
		107,
		89,
		-1,
		117,
		107,
		155,
		130,
		139,
		132,
		126,
		127,
		135,
		-1,
		-1,
		-1,
		0,
		1,
		20,
		32,
		43,
		41,
		59,
		-1,
		112,
		94,
		80,
		97,
		97,
		88,
		96,
		145,
		141,
		144,
		142,
		120,
		-1,
		138,
		-1,
		-1,
		25,
		-1,
		-1,
		-1,
		49,
		74,
		69,
		61,
		73,
		82,
		77,
		79,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		145,
		-1,
		32,
		-1,
		-1,
		70,
		56,
		68,
		79,
		69,
		69,
		74,
		72,
		94,
		124,
		110,
		108,
		113,
		118,
		-1,
		155,
		156,
		-1,
		89,
		81,
		67,
		-1,
		60,
		-1,
		115,
		76,
		-1,
		101,
		81,
		-1,
		119,
		115,
		-1,
		-1,
		145,
		105,
		-1,
		-1,
		-1,
		90,
		70,
		110,
		94,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		130,
		114,
		-1,
		83,
		86,
		-1,
		77,
		83,
		112,
		94,
		98,
		-1,
		-1,
		-1,
		139,
		120,
		114,
		98,
		103,
		91,
		108,
		94,
		96,
		108,
		97,
		118,
		-1,
		-1,
		-1,
		111,
		103,
		103,
		-1,
		-1,
		121,
		104,
		104,
		117,
		-1,
		-1,
		-1,
		133,
		114,
		-1,
		-1,
		112,
		-1,
		-1,
		117,
		116,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		122,
		-1,
		-1,
		-1,
		113,
		120,
		128,
		-1,
		-1,
		-1,
		-1,
		143,
		144,
		168,
		143,
		-1,
		-1,
		-1,
		127,
		127,
		-1,
		-1,
		146,
		144,
		-1,
		-1,
		-1,
		155,
		139,
		-1,
		131,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		164,
		-1,
		-1,
		-1,
		160,
		-1,
		166,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		173,
		165,
		179,
		-1,
		151,
		153,
		-1,
		201,
		-1,
		-1,
		188,
		179,
		-1,
		-1,
		156,
		163,
		185,
		188,
		218,
		-1,
		175
	],
	[
		-1,
		299,
		288,
		299,
		307,
		280,
		287,
		-1,
		306,
		310,
		276,
		270,
		309,
		278,
		284,
		295,
		-1,
		-1,
		-1,
		299,
		298,
		266,
		264,
		273,
		278,
		285,
		-1,
		284,
		-1,
		320,
		299,
		310,
		315,
		259,
		256,
		276,
		295,
		277,
		269,
		335,
		289,
		260,
		254,
		272,
		262,
		271,
		263,
		-1,
		260,
		250,
		272,
		251,
		262,
		254,
		-1,
		-1,
		254,
		255,
		261,
		247,
		253,
		249,
		-1,
		259,
		243,
		-1,
		-1,
		244,
		245,
		229,
		232,
		240,
		238,
		251,
		243,
		238,
		-1,
		-1,
		235,
		231,
		238,
		225,
		221,
		238,
		251,
		233,
		247,
		246,
		-1,
		239,
		257,
		264,
		232,
		230,
		214,
		212,
		230,
		232,
		238,
		238,
		-1,
		248,
		249,
		244,
		252,
		254,
		230,
		217,
		217,
		227,
		220,
		239,
		227,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		248,
		231,
		248,
		240,
		230,
		245,
		238,
		220,
		217,
		215,
		212,
		228,
		226,
		236,
		-1,
		-1,
		341,
		310,
		339,
		297,
		278,
		-1,
		244,
		224,
		230,
		234,
		228,
		221,
		235,
		231,
		-1,
		206,
		205,
		233,
		219,
		230,
		301,
		-1,
		-1,
		299,
		291,
		274,
		277,
		254,
		250,
		239,
		238,
		230,
		216,
		212,
		218,
		221,
		221,
		227,
		200,
		210,
		214,
		212,
		237,
		-1,
		-1,
		272,
		-1,
		-1,
		298,
		281,
		-1,
		264,
		271,
		260,
		266,
		252,
		273,
		249,
		240,
		232,
		226,
		214,
		216,
		213,
		226,
		214,
		197,
		222,
		226,
		207,
		228,
		223,
		-1,
		271,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		257,
		260,
		266,
		290,
		289,
		-1,
		261,
		249,
		250,
		235,
		232,
		219,
		207,
		220,
		205,
		212,
		211,
		201,
		199,
		229,
		204,
		226,
		223,
		242,
		247,
		241,
		250,
		-1,
		306,
		302,
		298,
		305,
		254,
		-1,
		-1,
		294,
		-1,
		297,
		298,
		273,
		246,
		249,
		236,
		227,
		214,
		203,
		214,
		203,
		200,
		208,
		193,
		208,
		199,
		198,
		216,
		226,
		234,
		238,
		244,
		-1,
		356,
		-1,
		298,
		282,
		284,
		256,
		277,
		-1,
		314,
		298,
		290,
		275,
		275,
		-1,
		245,
		242,
		232,
		210,
		195,
		212,
		204,
		202,
		206,
		188,
		202,
		193,
		211,
		218,
		216,
		220,
		240,
		252,
		316,
		306,
		-1,
		288,
		293,
		252,
		260,
		279,
		317,
		281,
		-1,
		276,
		-1,
		247,
		260,
		-1,
		216,
		212,
		194,
		195,
		190,
		205,
		199,
		184,
		181,
		199,
		202,
		209,
		213,
		229,
		-1,
		-1,
		301,
		305,
		294,
		245,
		264,
		288,
		325,
		274,
		263,
		262,
		-1,
		253,
		230,
		227,
		215,
		202,
		187,
		188,
		196,
		209,
		188,
		183,
		180,
		200,
		226,
		204,
		216,
		-1,
		-1,
		-1,
		326,
		-1,
		-1,
		271,
		242,
		266,
		308,
		292,
		285,
		273,
		238,
		238,
		232,
		-1,
		226,
		205,
		196,
		185,
		183,
		196,
		193,
		198,
		178,
		176,
		195,
		207,
		198,
		215,
		-1,
		-1,
		-1,
		301,
		290,
		291,
		237,
		260,
		297,
		271,
		257,
		262,
		237,
		230,
		224,
		239,
		222,
		203,
		192,
		184,
		173,
		189,
		197,
		192,
		174,
		183,
		189,
		213,
		203,
		209,
		-1,
		-1,
		308,
		298,
		282,
		284,
		281,
		251,
		258,
		290,
		262,
		275,
		-1,
		229,
		-1,
		218,
		213,
		197,
		192,
		189,
		186,
		180,
		189,
		191,
		181,
		176,
		183,
		218,
		218,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		301,
		296,
		271,
		248,
		232,
		268,
		-1,
		245,
		246,
		-1,
		223,
		217,
		214,
		199,
		195,
		190,
		194,
		187,
		194,
		187,
		185,
		186,
		168,
		200,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		294,
		273,
		266,
		286,
		227,
		279,
		-1,
		-1,
		230,
		223,
		-1,
		210,
		192,
		199,
		197,
		191,
		195,
		192,
		181,
		194,
		187,
		173,
		175,
		188,
		192,
		196,
		183,
		179,
		176,
		190,
		-1,
		313,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		247,
		-1,
		239,
		231,
		221,
		215,
		209,
		205,
		203,
		219,
		203,
		206,
		204,
		195,
		203,
		176,
		169,
		176,
		165,
		183,
		191,
		183,
		177,
		176,
		186,
		-1,
		314,
		300,
		271,
		-1,
		-1,
		260,
		-1,
		224,
		238,
		254,
		-1,
		247,
		226,
		241,
		219,
		215,
		211,
		226,
		227,
		204,
		204,
		202,
		193,
		181,
		170,
		173,
		165,
		187,
		187,
		171,
		172,
		176,
		-1,
		320,
		307,
		265,
		261,
		250,
		270,
		221,
		209,
		241,
		-1,
		-1,
		283,
		-1,
		217,
		234,
		225,
		223,
		216,
		198,
		205,
		213,
		190,
		185,
		175,
		164,
		164,
		159,
		181,
		167,
		165,
		174,
		190,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		236,
		223,
		217,
		-1,
		258,
		-1,
		261,
		251,
		235,
		220,
		253,
		-1,
		197,
		193,
		200,
		-1,
		210,
		-1,
		183,
		180,
		171,
		156,
		153,
		164,
		162,
		173,
		169,
		-1,
		270,
		255,
		248,
		238,
		252,
		223,
		-1,
		278,
		-1,
		-1,
		248,
		242,
		242,
		226,
		227,
		213,
		193,
		185,
		200,
		199,
		186,
		185,
		169,
		162,
		159,
		152,
		165,
		175,
		180,
		167,
		-1,
		-1,
		-1,
		275,
		245,
		253,
		225,
		244,
		-1,
		-1,
		310,
		265,
		251,
		-1,
		222,
		213,
		201,
		191,
		181,
		186,
		187,
		177,
		175,
		167,
		169,
		163,
		154,
		153,
		169,
		161,
		183,
		-1,
		-1,
		242,
		255,
		251,
		235,
		230,
		-1,
		-1,
		-1,
		257,
		273,
		241,
		220,
		202,
		-1,
		-1,
		185,
		178,
		172,
		175,
		163,
		183,
		178,
		162,
		147,
		162,
		166,
		174,
		165,
		-1,
		245,
		232,
		-1,
		-1,
		229,
		219,
		-1,
		-1,
		-1,
		-1,
		253,
		198,
		187,
		182,
		186,
		184,
		-1,
		158,
		169,
		162,
		181,
		188,
		164,
		149,
		143,
		149,
		161,
		170,
		-1,
		-1,
		243,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		210,
		204,
		175,
		168,
		172,
		-1,
		160,
		162,
		159,
		171,
		167,
		164,
		155,
		146,
		142,
		146,
		150,
		164,
		168,
		266,
		-1,
		196,
		-1,
		-1,
		-1,
		228,
		236,
		214,
		191,
		164,
		159,
		152,
		146,
		151,
		162,
		171,
		182,
		147,
		149,
		139,
		138,
		142,
		159,
		163,
		-1,
		-1,
		194,
		190,
		225,
		236,
		209,
		241,
		-1,
		-1,
		167,
		159,
		150,
		142,
		155,
		158,
		143,
		145,
		145,
		143,
		137,
		147,
		162,
		157,
		-1,
		-1,
		-1,
		192,
		-1,
		208,
		-1,
		-1,
		199,
		239,
		186,
		168,
		164,
		151,
		151,
		145,
		133,
		138,
		148,
		142,
		139,
		133,
		137,
		160,
		149,
		188,
		-1,
		-1,
		198,
		-1,
		-1,
		-1,
		158,
		177,
		172,
		178,
		183,
		174,
		201,
		198,
		-1,
		148,
		174,
		139,
		146,
		129,
		136,
		141,
		138,
		127,
		134,
		150,
		149,
		144,
		180,
		171,
		177,
		-1,
		-1,
		191,
		180,
		169,
		175,
		-1,
		151,
		174,
		164,
		154,
		160,
		-1,
		-1,
		166,
		163,
		161,
		139,
		137,
		130,
		125,
		135,
		111,
		123,
		127,
		131,
		137,
		142,
		147,
		153,
		168,
		183,
		-1,
		145,
		182,
		175,
		143,
		151,
		182,
		-1,
		141,
		133,
		161,
		146,
		154,
		-1,
		-1,
		139,
		130,
		135,
		144,
		143,
		149,
		148,
		131,
		137,
		138,
		130,
		129,
		147,
		151,
		160,
		167,
		157,
		170,
		174,
		-1,
		138,
		158,
		137,
		140,
		164,
		178,
		-1,
		132,
		-1,
		-1,
		140,
		164,
		148,
		138,
		135,
		182,
		158,
		153,
		136,
		134,
		129,
		120,
		145,
		138,
		138,
		141,
		156,
		161,
		153,
		167,
		167,
		168,
		-1,
		127,
		138,
		131,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		130,
		-1,
		175,
		-1,
		158,
		162,
		166,
		169,
		150,
		137,
		123,
		131,
		137,
		136,
		142,
		142,
		143,
		152,
		163,
		175,
		174,
		175,
		152,
		108,
		111,
		122,
		133,
		148,
		152,
		-1,
		116,
		152,
		136,
		-1,
		120,
		-1,
		-1,
		-1,
		172,
		179,
		171,
		170,
		149,
		149,
		115,
		119,
		132,
		139,
		149,
		160,
		152,
		156,
		169,
		180,
		183,
		148,
		139,
		152,
		97,
		97,
		118,
		127,
		148,
		112,
		109,
		146,
		143,
		132,
		127,
		114,
		-1,
		-1,
		183,
		189,
		-1,
		-1,
		156,
		123,
		111,
		121,
		125,
		139,
		151,
		164,
		152,
		157,
		151,
		183,
		-1,
		141,
		140,
		129,
		126,
		102,
		93,
		88,
		115,
		-1,
		-1,
		110,
		137,
		121,
		125,
		141,
		166,
		-1,
		98,
		-1,
		-1,
		163,
		-1,
		-1,
		148,
		128,
		117,
		108,
		113,
		133,
		144,
		166,
		148,
		165,
		156,
		166,
		170,
		125,
		122,
		110,
		108,
		131,
		96,
		84,
		-1,
		92,
		95,
		101,
		108,
		125,
		155,
		-1,
		-1,
		114,
		94,
		-1,
		-1,
		146,
		144,
		133,
		-1,
		123,
		105,
		110,
		140,
		142,
		144,
		151,
		145,
		152,
		160,
		171,
		163,
		134,
		148,
		137,
		133,
		132,
		140,
		89,
		82,
		89,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		-1,
		104,
		100,
		-1,
		-1,
		141,
		134,
		122,
		110,
		100,
		110,
		127,
		127,
		130,
		135,
		143,
		154,
		150,
		154,
		157,
		-1,
		168,
		-1,
		120,
		81,
		87,
		102,
		110,
		-1,
		-1,
		-1,
		121,
		107,
		100,
		88,
		86,
		-1,
		175,
		159,
		140,
		-1,
		110,
		123,
		163,
		131,
		136,
		131,
		146,
		157,
		148,
		156,
		150,
		153,
		-1,
		-1,
		80,
		63,
		-1,
		-1,
		37,
		39,
		-1,
		112,
		101,
		86,
		78,
		-1,
		-1,
		147,
		143,
		-1,
		-1,
		97,
		135,
		134,
		142,
		137,
		142,
		154,
		150,
		146,
		156,
		147,
		-1,
		-1,
		58,
		50,
		44,
		-1,
		22,
		-1,
		114,
		-1,
		81,
		88,
		76,
		-1,
		-1,
		-1,
		128,
		91,
		107,
		130,
		156,
		154,
		145,
		138,
		145,
		148,
		141,
		147,
		-1,
		-1,
		-1,
		40,
		14,
		121,
		112,
		95,
		75,
		67,
		87,
		-1,
		109,
		-1,
		84,
		87,
		112,
		151,
		153,
		139,
		135,
		148,
		142,
		139,
		137,
		46,
		-1,
		11,
		66,
		50,
		81,
		47,
		59,
		123,
		-1,
		106,
		88,
		-1,
		116,
		106,
		154,
		129,
		138,
		131,
		125,
		126,
		134,
		-1,
		-1,
		-1,
		1,
		0,
		19,
		31,
		42,
		40,
		58,
		-1,
		111,
		93,
		79,
		96,
		96,
		87,
		95,
		144,
		140,
		143,
		141,
		119,
		-1,
		139,
		-1,
		-1,
		26,
		-1,
		-1,
		-1,
		48,
		73,
		68,
		60,
		72,
		81,
		76,
		78,
		91,
		99,
		97,
		94,
		106,
		102,
		122,
		118,
		150,
		-1,
		146,
		-1,
		33,
		-1,
		-1,
		69,
		55,
		67,
		78,
		68,
		68,
		73,
		71,
		93,
		123,
		109,
		107,
		112,
		117,
		-1,
		156,
		156,
		-1,
		88,
		80,
		66,
		-1,
		59,
		-1,
		114,
		75,
		-1,
		100,
		80,
		-1,
		118,
		114,
		-1,
		-1,
		144,
		104,
		-1,
		-1,
		-1,
		89,
		69,
		109,
		93,
		-1,
		91,
		91,
		-1,
		-1,
		-1,
		129,
		113,
		-1,
		82,
		85,
		-1,
		76,
		82,
		111,
		93,
		97,
		-1,
		-1,
		-1,
		138,
		119,
		113,
		97,
		102,
		90,
		107,
		93,
		95,
		107,
		96,
		117,
		-1,
		-1,
		-1,
		110,
		102,
		102,
		-1,
		-1,
		120,
		103,
		103,
		116,
		-1,
		-1,
		-1,
		132,
		113,
		-1,
		-1,
		111,
		-1,
		-1,
		116,
		115,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		121,
		-1,
		-1,
		-1,
		112,
		119,
		127,
		-1,
		-1,
		-1,
		-1,
		142,
		143,
		167,
		142,
		-1,
		-1,
		-1,
		126,
		126,
		-1,
		-1,
		145,
		143,
		-1,
		-1,
		-1,
		154,
		138,
		-1,
		130,
		-1,
		-1,
		-1,
		145,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		159,
		-1,
		165,
		140,
		147,
		-1,
		-1,
		-1,
		-1,
		172,
		164,
		178,
		-1,
		150,
		152,
		-1,
		200,
		-1,
		-1,
		187,
		178,
		-1,
		-1,
		155,
		162,
		184,
		187,
		217,
		-1,
		174
	],
	[
		-1,
		286,
		275,
		286,
		294,
		267,
		274,
		-1,
		293,
		297,
		263,
		257,
		296,
		265,
		271,
		282,
		-1,
		-1,
		-1,
		286,
		285,
		253,
		251,
		260,
		265,
		272,
		-1,
		271,
		-1,
		307,
		286,
		297,
		302,
		246,
		243,
		263,
		282,
		264,
		256,
		322,
		276,
		247,
		241,
		259,
		249,
		258,
		250,
		-1,
		247,
		237,
		259,
		238,
		249,
		241,
		-1,
		-1,
		241,
		242,
		248,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		231,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		226,
		244,
		251,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		235,
		236,
		231,
		239,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		235,
		218,
		235,
		227,
		217,
		232,
		225,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		328,
		297,
		326,
		284,
		265,
		-1,
		231,
		211,
		217,
		221,
		215,
		208,
		222,
		218,
		-1,
		193,
		192,
		220,
		206,
		217,
		288,
		-1,
		-1,
		286,
		278,
		261,
		264,
		241,
		237,
		226,
		225,
		217,
		203,
		199,
		205,
		208,
		208,
		214,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		285,
		268,
		-1,
		251,
		258,
		247,
		253,
		239,
		260,
		236,
		227,
		219,
		213,
		201,
		203,
		200,
		213,
		201,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		244,
		247,
		253,
		277,
		276,
		-1,
		248,
		236,
		237,
		222,
		219,
		206,
		194,
		207,
		192,
		199,
		198,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		293,
		289,
		285,
		292,
		241,
		-1,
		-1,
		281,
		-1,
		284,
		285,
		260,
		233,
		236,
		223,
		214,
		201,
		190,
		201,
		190,
		187,
		195,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		343,
		-1,
		285,
		269,
		271,
		243,
		264,
		-1,
		301,
		285,
		277,
		262,
		262,
		-1,
		232,
		229,
		219,
		197,
		182,
		199,
		191,
		189,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		303,
		293,
		-1,
		275,
		280,
		239,
		247,
		266,
		304,
		268,
		-1,
		263,
		-1,
		234,
		247,
		-1,
		203,
		199,
		181,
		182,
		177,
		192,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		288,
		292,
		281,
		232,
		251,
		275,
		312,
		261,
		250,
		249,
		-1,
		240,
		217,
		214,
		202,
		189,
		174,
		175,
		183,
		196,
		175,
		170,
		167,
		187,
		213,
		191,
		203,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		258,
		229,
		253,
		295,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		213,
		192,
		183,
		172,
		170,
		183,
		180,
		185,
		165,
		163,
		182,
		194,
		185,
		202,
		-1,
		-1,
		-1,
		288,
		277,
		278,
		224,
		247,
		284,
		258,
		244,
		249,
		224,
		217,
		211,
		226,
		209,
		190,
		179,
		171,
		160,
		176,
		184,
		179,
		161,
		170,
		176,
		200,
		190,
		196,
		-1,
		-1,
		295,
		285,
		269,
		271,
		268,
		238,
		245,
		277,
		249,
		262,
		-1,
		216,
		-1,
		205,
		200,
		184,
		179,
		176,
		173,
		167,
		176,
		178,
		168,
		163,
		170,
		205,
		205,
		180,
		200,
		203,
		-1,
		-1,
		-1,
		288,
		283,
		258,
		235,
		219,
		255,
		-1,
		232,
		233,
		-1,
		210,
		204,
		201,
		186,
		182,
		177,
		181,
		174,
		181,
		174,
		172,
		173,
		155,
		187,
		-1,
		188,
		182,
		190,
		180,
		168,
		-1,
		-1,
		-1,
		281,
		260,
		253,
		273,
		214,
		266,
		-1,
		-1,
		217,
		210,
		-1,
		197,
		179,
		186,
		184,
		178,
		182,
		179,
		168,
		181,
		174,
		160,
		162,
		175,
		179,
		183,
		170,
		166,
		163,
		177,
		-1,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		234,
		-1,
		226,
		218,
		208,
		202,
		196,
		192,
		190,
		206,
		190,
		193,
		191,
		182,
		190,
		163,
		156,
		163,
		152,
		170,
		178,
		170,
		164,
		163,
		173,
		-1,
		301,
		287,
		258,
		-1,
		-1,
		247,
		-1,
		211,
		225,
		241,
		-1,
		234,
		213,
		228,
		206,
		202,
		198,
		213,
		214,
		191,
		191,
		189,
		180,
		168,
		157,
		160,
		152,
		174,
		174,
		158,
		159,
		163,
		-1,
		307,
		294,
		252,
		248,
		237,
		257,
		208,
		196,
		228,
		-1,
		-1,
		270,
		-1,
		204,
		221,
		212,
		210,
		203,
		185,
		192,
		200,
		177,
		172,
		162,
		151,
		151,
		146,
		168,
		154,
		152,
		161,
		177,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		223,
		210,
		204,
		-1,
		245,
		-1,
		248,
		238,
		222,
		207,
		240,
		-1,
		184,
		180,
		187,
		-1,
		197,
		-1,
		170,
		167,
		158,
		143,
		140,
		151,
		149,
		160,
		156,
		-1,
		257,
		242,
		235,
		225,
		239,
		210,
		-1,
		265,
		-1,
		-1,
		235,
		229,
		229,
		213,
		214,
		200,
		180,
		172,
		187,
		186,
		173,
		172,
		156,
		149,
		146,
		139,
		152,
		162,
		167,
		154,
		-1,
		-1,
		-1,
		262,
		247,
		252,
		212,
		231,
		-1,
		-1,
		297,
		252,
		238,
		-1,
		209,
		200,
		188,
		178,
		168,
		173,
		174,
		164,
		162,
		154,
		156,
		150,
		141,
		140,
		156,
		148,
		170,
		-1,
		-1,
		244,
		250,
		238,
		224,
		226,
		-1,
		-1,
		-1,
		244,
		260,
		228,
		207,
		189,
		-1,
		-1,
		172,
		165,
		159,
		162,
		150,
		170,
		165,
		149,
		134,
		149,
		153,
		161,
		152,
		-1,
		247,
		234,
		-1,
		-1,
		225,
		215,
		-1,
		-1,
		-1,
		-1,
		240,
		185,
		174,
		169,
		173,
		171,
		-1,
		145,
		156,
		149,
		168,
		175,
		151,
		136,
		130,
		136,
		148,
		157,
		-1,
		-1,
		239,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		197,
		191,
		162,
		155,
		159,
		-1,
		147,
		149,
		146,
		158,
		154,
		151,
		142,
		133,
		129,
		133,
		137,
		151,
		155,
		262,
		-1,
		192,
		-1,
		-1,
		-1,
		215,
		230,
		201,
		178,
		151,
		146,
		139,
		133,
		138,
		149,
		158,
		169,
		134,
		136,
		126,
		125,
		129,
		146,
		150,
		-1,
		-1,
		190,
		186,
		221,
		223,
		211,
		228,
		-1,
		-1,
		155,
		146,
		137,
		129,
		142,
		145,
		130,
		132,
		132,
		130,
		124,
		134,
		149,
		144,
		-1,
		-1,
		-1,
		194,
		-1,
		204,
		-1,
		-1,
		201,
		226,
		173,
		155,
		151,
		149,
		138,
		132,
		120,
		125,
		135,
		129,
		126,
		120,
		124,
		147,
		136,
		175,
		-1,
		-1,
		200,
		-1,
		-1,
		-1,
		160,
		173,
		168,
		180,
		185,
		176,
		188,
		185,
		-1,
		150,
		161,
		126,
		133,
		116,
		123,
		128,
		125,
		114,
		121,
		137,
		136,
		131,
		167,
		158,
		164,
		-1,
		-1,
		193,
		182,
		171,
		177,
		-1,
		153,
		170,
		166,
		156,
		162,
		-1,
		-1,
		168,
		165,
		157,
		126,
		124,
		117,
		112,
		122,
		98,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		147,
		184,
		177,
		145,
		153,
		184,
		-1,
		143,
		135,
		163,
		148,
		156,
		-1,
		-1,
		141,
		132,
		137,
		133,
		130,
		136,
		135,
		118,
		124,
		125,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		140,
		160,
		139,
		142,
		166,
		180,
		-1,
		134,
		-1,
		-1,
		127,
		166,
		150,
		140,
		137,
		184,
		147,
		142,
		123,
		121,
		116,
		107,
		132,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		129,
		140,
		133,
		-1,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		117,
		-1,
		177,
		-1,
		160,
		164,
		155,
		158,
		137,
		124,
		110,
		118,
		124,
		123,
		129,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		154,
		110,
		113,
		124,
		135,
		150,
		154,
		-1,
		118,
		154,
		123,
		-1,
		107,
		-1,
		-1,
		-1,
		174,
		168,
		160,
		157,
		136,
		136,
		102,
		106,
		119,
		126,
		136,
		147,
		139,
		143,
		156,
		167,
		170,
		150,
		141,
		154,
		99,
		99,
		120,
		129,
		150,
		114,
		111,
		148,
		130,
		119,
		114,
		101,
		-1,
		-1,
		170,
		178,
		-1,
		-1,
		143,
		110,
		98,
		108,
		112,
		126,
		138,
		151,
		139,
		144,
		138,
		170,
		-1,
		143,
		142,
		131,
		128,
		104,
		95,
		90,
		117,
		-1,
		-1,
		112,
		139,
		123,
		127,
		143,
		168,
		-1,
		85,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		115,
		104,
		95,
		100,
		120,
		131,
		153,
		135,
		152,
		143,
		153,
		157,
		127,
		124,
		112,
		110,
		133,
		98,
		86,
		-1,
		94,
		97,
		103,
		110,
		127,
		157,
		-1,
		-1,
		101,
		81,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		92,
		97,
		127,
		129,
		131,
		138,
		132,
		139,
		147,
		158,
		150,
		136,
		150,
		139,
		135,
		134,
		142,
		91,
		84,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		91,
		87,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		114,
		114,
		117,
		122,
		130,
		141,
		137,
		141,
		144,
		-1,
		170,
		-1,
		122,
		83,
		89,
		104,
		112,
		-1,
		-1,
		-1,
		108,
		94,
		87,
		75,
		73,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		150,
		118,
		123,
		118,
		133,
		144,
		135,
		143,
		137,
		140,
		-1,
		-1,
		82,
		65,
		-1,
		-1,
		39,
		41,
		-1,
		99,
		88,
		73,
		65,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		84,
		122,
		121,
		129,
		124,
		129,
		141,
		137,
		133,
		143,
		134,
		-1,
		-1,
		60,
		52,
		46,
		-1,
		24,
		-1,
		101,
		-1,
		68,
		75,
		63,
		-1,
		-1,
		-1,
		115,
		78,
		94,
		117,
		143,
		141,
		132,
		125,
		132,
		135,
		128,
		134,
		-1,
		-1,
		-1,
		42,
		16,
		108,
		99,
		82,
		62,
		54,
		74,
		-1,
		96,
		-1,
		71,
		74,
		99,
		138,
		140,
		126,
		122,
		135,
		129,
		126,
		124,
		48,
		-1,
		13,
		53,
		37,
		68,
		34,
		46,
		110,
		-1,
		93,
		75,
		-1,
		103,
		93,
		141,
		116,
		125,
		118,
		112,
		113,
		121,
		-1,
		-1,
		-1,
		14,
		13,
		0,
		18,
		29,
		27,
		45,
		-1,
		98,
		80,
		66,
		83,
		83,
		74,
		82,
		131,
		127,
		130,
		128,
		106,
		-1,
		141,
		-1,
		-1,
		37,
		-1,
		-1,
		-1,
		35,
		60,
		55,
		47,
		59,
		68,
		63,
		65,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		105,
		137,
		-1,
		148,
		-1,
		44,
		-1,
		-1,
		56,
		42,
		54,
		65,
		55,
		55,
		60,
		58,
		80,
		110,
		96,
		94,
		99,
		104,
		-1,
		144,
		143,
		-1,
		75,
		67,
		53,
		-1,
		46,
		-1,
		101,
		62,
		-1,
		87,
		67,
		-1,
		105,
		101,
		-1,
		-1,
		131,
		91,
		-1,
		-1,
		-1,
		76,
		56,
		96,
		80,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		116,
		100,
		-1,
		69,
		72,
		-1,
		63,
		69,
		98,
		80,
		84,
		-1,
		-1,
		-1,
		125,
		106,
		100,
		84,
		89,
		77,
		94,
		80,
		82,
		94,
		83,
		104,
		-1,
		-1,
		-1,
		97,
		89,
		89,
		-1,
		-1,
		107,
		90,
		90,
		103,
		-1,
		-1,
		-1,
		119,
		100,
		-1,
		-1,
		98,
		-1,
		-1,
		103,
		102,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		108,
		-1,
		-1,
		-1,
		99,
		106,
		114,
		-1,
		-1,
		-1,
		-1,
		129,
		130,
		154,
		129,
		-1,
		-1,
		-1,
		113,
		113,
		-1,
		-1,
		132,
		130,
		-1,
		-1,
		-1,
		141,
		125,
		-1,
		117,
		-1,
		-1,
		-1,
		132,
		-1,
		-1,
		150,
		-1,
		-1,
		-1,
		146,
		-1,
		152,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		159,
		151,
		165,
		-1,
		137,
		139,
		-1,
		187,
		-1,
		-1,
		174,
		165,
		-1,
		-1,
		142,
		149,
		171,
		174,
		204,
		-1,
		161
	],
	[
		-1,
		280,
		269,
		280,
		288,
		261,
		268,
		-1,
		287,
		291,
		257,
		251,
		290,
		259,
		265,
		276,
		-1,
		-1,
		-1,
		280,
		279,
		247,
		245,
		254,
		259,
		266,
		-1,
		265,
		-1,
		301,
		280,
		291,
		296,
		240,
		237,
		257,
		276,
		258,
		250,
		316,
		270,
		241,
		235,
		253,
		243,
		252,
		244,
		-1,
		241,
		231,
		253,
		232,
		243,
		235,
		-1,
		-1,
		235,
		236,
		242,
		228,
		234,
		230,
		-1,
		240,
		224,
		-1,
		-1,
		225,
		226,
		210,
		213,
		221,
		219,
		232,
		224,
		219,
		-1,
		-1,
		216,
		212,
		219,
		206,
		202,
		219,
		232,
		214,
		228,
		227,
		-1,
		220,
		238,
		245,
		213,
		211,
		195,
		193,
		211,
		213,
		219,
		219,
		-1,
		229,
		230,
		225,
		233,
		235,
		211,
		198,
		198,
		208,
		201,
		220,
		208,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		229,
		212,
		229,
		221,
		211,
		226,
		219,
		201,
		198,
		196,
		193,
		209,
		207,
		217,
		-1,
		-1,
		322,
		291,
		320,
		278,
		259,
		-1,
		225,
		205,
		211,
		215,
		209,
		202,
		216,
		212,
		-1,
		187,
		186,
		214,
		200,
		211,
		282,
		-1,
		-1,
		280,
		272,
		255,
		258,
		235,
		231,
		220,
		219,
		211,
		197,
		193,
		199,
		202,
		202,
		208,
		181,
		191,
		195,
		193,
		218,
		-1,
		-1,
		253,
		-1,
		-1,
		279,
		262,
		-1,
		245,
		252,
		241,
		247,
		233,
		254,
		230,
		221,
		213,
		207,
		195,
		197,
		194,
		207,
		195,
		178,
		203,
		207,
		188,
		209,
		204,
		-1,
		252,
		236,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		238,
		241,
		247,
		271,
		270,
		-1,
		242,
		230,
		231,
		216,
		213,
		200,
		188,
		201,
		186,
		193,
		192,
		182,
		180,
		210,
		185,
		207,
		204,
		223,
		228,
		222,
		231,
		-1,
		287,
		283,
		279,
		286,
		235,
		-1,
		-1,
		275,
		-1,
		278,
		279,
		254,
		227,
		230,
		217,
		208,
		195,
		184,
		195,
		184,
		181,
		189,
		174,
		189,
		180,
		179,
		197,
		207,
		215,
		219,
		225,
		-1,
		337,
		-1,
		279,
		263,
		265,
		237,
		258,
		-1,
		295,
		279,
		271,
		256,
		256,
		-1,
		226,
		223,
		213,
		191,
		176,
		193,
		185,
		183,
		187,
		169,
		183,
		174,
		192,
		199,
		197,
		201,
		221,
		233,
		297,
		287,
		-1,
		269,
		274,
		233,
		241,
		260,
		298,
		262,
		-1,
		257,
		-1,
		228,
		241,
		-1,
		197,
		193,
		175,
		176,
		171,
		186,
		180,
		165,
		162,
		180,
		183,
		190,
		194,
		210,
		-1,
		-1,
		282,
		286,
		275,
		226,
		245,
		269,
		306,
		255,
		244,
		243,
		-1,
		234,
		211,
		208,
		196,
		183,
		168,
		169,
		177,
		190,
		169,
		164,
		161,
		181,
		207,
		185,
		197,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		252,
		223,
		247,
		289,
		273,
		266,
		254,
		219,
		219,
		213,
		-1,
		207,
		186,
		177,
		166,
		164,
		177,
		174,
		179,
		159,
		157,
		176,
		188,
		179,
		196,
		-1,
		-1,
		-1,
		282,
		271,
		272,
		218,
		241,
		278,
		252,
		238,
		243,
		218,
		211,
		205,
		220,
		203,
		184,
		173,
		165,
		154,
		170,
		178,
		173,
		155,
		164,
		170,
		194,
		184,
		190,
		-1,
		-1,
		289,
		279,
		263,
		265,
		262,
		232,
		239,
		271,
		243,
		256,
		-1,
		210,
		-1,
		199,
		194,
		178,
		173,
		170,
		167,
		161,
		170,
		172,
		162,
		157,
		164,
		199,
		199,
		174,
		194,
		197,
		-1,
		-1,
		-1,
		282,
		277,
		252,
		229,
		213,
		249,
		-1,
		226,
		227,
		-1,
		204,
		198,
		195,
		180,
		176,
		171,
		175,
		168,
		175,
		168,
		166,
		167,
		149,
		181,
		-1,
		182,
		176,
		184,
		174,
		162,
		-1,
		-1,
		-1,
		275,
		254,
		247,
		267,
		208,
		260,
		-1,
		-1,
		211,
		204,
		-1,
		191,
		173,
		180,
		178,
		172,
		176,
		173,
		162,
		175,
		168,
		154,
		156,
		169,
		173,
		177,
		164,
		160,
		157,
		171,
		-1,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		228,
		-1,
		220,
		212,
		202,
		196,
		190,
		186,
		184,
		200,
		184,
		187,
		185,
		176,
		184,
		157,
		150,
		157,
		146,
		164,
		172,
		164,
		158,
		157,
		167,
		-1,
		295,
		281,
		252,
		-1,
		-1,
		241,
		-1,
		205,
		219,
		235,
		-1,
		228,
		207,
		222,
		200,
		196,
		192,
		207,
		208,
		185,
		185,
		183,
		174,
		162,
		151,
		154,
		146,
		168,
		168,
		152,
		153,
		157,
		-1,
		301,
		288,
		246,
		242,
		231,
		251,
		202,
		190,
		222,
		-1,
		-1,
		264,
		-1,
		198,
		215,
		206,
		204,
		197,
		179,
		186,
		194,
		171,
		166,
		156,
		145,
		145,
		140,
		162,
		148,
		146,
		155,
		171,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		217,
		204,
		198,
		-1,
		239,
		-1,
		242,
		232,
		216,
		201,
		234,
		-1,
		178,
		174,
		181,
		-1,
		191,
		-1,
		164,
		161,
		152,
		137,
		134,
		145,
		143,
		154,
		150,
		-1,
		251,
		236,
		229,
		219,
		233,
		204,
		-1,
		259,
		-1,
		-1,
		229,
		223,
		223,
		207,
		208,
		194,
		174,
		166,
		181,
		180,
		167,
		166,
		150,
		143,
		140,
		133,
		146,
		156,
		161,
		148,
		-1,
		-1,
		-1,
		256,
		242,
		246,
		206,
		225,
		-1,
		-1,
		291,
		246,
		232,
		-1,
		203,
		194,
		182,
		172,
		162,
		167,
		168,
		158,
		156,
		148,
		150,
		144,
		135,
		134,
		150,
		142,
		164,
		-1,
		-1,
		239,
		244,
		232,
		218,
		220,
		-1,
		-1,
		-1,
		238,
		254,
		222,
		201,
		183,
		-1,
		-1,
		166,
		159,
		153,
		156,
		144,
		164,
		159,
		143,
		128,
		143,
		147,
		155,
		146,
		-1,
		242,
		229,
		-1,
		-1,
		219,
		209,
		-1,
		-1,
		-1,
		-1,
		234,
		179,
		168,
		163,
		167,
		165,
		-1,
		139,
		150,
		143,
		162,
		169,
		145,
		130,
		124,
		130,
		142,
		151,
		-1,
		-1,
		233,
		-1,
		195,
		-1,
		-1,
		-1,
		-1,
		191,
		185,
		156,
		149,
		153,
		-1,
		141,
		143,
		140,
		152,
		148,
		145,
		136,
		127,
		123,
		127,
		131,
		145,
		149,
		256,
		-1,
		186,
		-1,
		-1,
		-1,
		209,
		224,
		195,
		172,
		145,
		140,
		133,
		127,
		132,
		143,
		152,
		163,
		128,
		130,
		120,
		119,
		123,
		140,
		144,
		-1,
		-1,
		184,
		180,
		215,
		217,
		221,
		222,
		-1,
		-1,
		149,
		140,
		131,
		123,
		136,
		139,
		124,
		126,
		126,
		124,
		118,
		128,
		143,
		138,
		-1,
		-1,
		-1,
		196,
		-1,
		198,
		-1,
		-1,
		211,
		220,
		167,
		149,
		145,
		143,
		132,
		126,
		114,
		119,
		129,
		123,
		120,
		114,
		118,
		141,
		130,
		169,
		-1,
		-1,
		210,
		-1,
		-1,
		-1,
		170,
		167,
		162,
		190,
		195,
		186,
		182,
		179,
		-1,
		149,
		155,
		120,
		127,
		110,
		117,
		122,
		119,
		108,
		115,
		131,
		130,
		125,
		161,
		152,
		158,
		-1,
		-1,
		203,
		192,
		181,
		187,
		-1,
		163,
		164,
		176,
		166,
		172,
		-1,
		-1,
		174,
		171,
		151,
		120,
		118,
		111,
		106,
		116,
		92,
		104,
		108,
		112,
		118,
		123,
		128,
		134,
		149,
		164,
		-1,
		157,
		194,
		187,
		155,
		163,
		194,
		-1,
		153,
		145,
		161,
		158,
		166,
		-1,
		-1,
		147,
		138,
		139,
		127,
		124,
		130,
		129,
		112,
		118,
		119,
		111,
		110,
		128,
		132,
		141,
		148,
		138,
		151,
		155,
		-1,
		150,
		170,
		149,
		152,
		176,
		190,
		-1,
		144,
		-1,
		-1,
		121,
		172,
		156,
		146,
		143,
		186,
		141,
		136,
		117,
		115,
		110,
		101,
		126,
		119,
		119,
		122,
		137,
		142,
		134,
		148,
		148,
		149,
		-1,
		139,
		150,
		143,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		111,
		-1,
		183,
		-1,
		166,
		170,
		149,
		152,
		131,
		118,
		104,
		112,
		118,
		117,
		123,
		123,
		124,
		133,
		144,
		156,
		155,
		156,
		164,
		120,
		123,
		134,
		145,
		160,
		164,
		-1,
		128,
		164,
		117,
		-1,
		101,
		-1,
		-1,
		-1,
		180,
		162,
		154,
		151,
		130,
		130,
		96,
		100,
		113,
		120,
		130,
		141,
		133,
		137,
		150,
		161,
		164,
		160,
		151,
		164,
		109,
		109,
		130,
		139,
		160,
		124,
		121,
		158,
		124,
		113,
		108,
		95,
		-1,
		-1,
		164,
		172,
		-1,
		-1,
		137,
		104,
		92,
		102,
		106,
		120,
		132,
		145,
		133,
		138,
		132,
		164,
		-1,
		153,
		152,
		141,
		138,
		114,
		105,
		100,
		127,
		-1,
		-1,
		122,
		149,
		133,
		137,
		153,
		178,
		-1,
		79,
		-1,
		-1,
		144,
		-1,
		-1,
		129,
		109,
		98,
		89,
		94,
		114,
		125,
		147,
		129,
		146,
		137,
		147,
		151,
		137,
		134,
		122,
		120,
		143,
		108,
		96,
		-1,
		104,
		107,
		113,
		120,
		137,
		167,
		-1,
		-1,
		95,
		75,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		86,
		91,
		121,
		123,
		125,
		132,
		126,
		133,
		141,
		152,
		144,
		146,
		160,
		149,
		145,
		144,
		152,
		101,
		94,
		101,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		-1,
		85,
		81,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		91,
		108,
		108,
		111,
		116,
		124,
		135,
		131,
		135,
		138,
		-1,
		180,
		-1,
		132,
		93,
		99,
		114,
		122,
		-1,
		-1,
		-1,
		102,
		88,
		81,
		69,
		67,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		144,
		112,
		117,
		112,
		127,
		138,
		129,
		137,
		131,
		134,
		-1,
		-1,
		92,
		75,
		-1,
		-1,
		49,
		51,
		-1,
		93,
		82,
		67,
		59,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		78,
		116,
		115,
		123,
		118,
		123,
		135,
		131,
		127,
		137,
		128,
		-1,
		-1,
		70,
		62,
		56,
		-1,
		34,
		-1,
		95,
		-1,
		62,
		69,
		57,
		-1,
		-1,
		-1,
		109,
		72,
		88,
		111,
		137,
		135,
		126,
		119,
		126,
		129,
		122,
		128,
		-1,
		-1,
		-1,
		52,
		26,
		102,
		93,
		76,
		56,
		48,
		68,
		-1,
		90,
		-1,
		65,
		68,
		93,
		132,
		134,
		120,
		116,
		129,
		123,
		120,
		118,
		58,
		-1,
		23,
		56,
		29,
		62,
		28,
		40,
		104,
		-1,
		87,
		69,
		-1,
		97,
		87,
		135,
		110,
		119,
		112,
		106,
		107,
		115,
		-1,
		-1,
		-1,
		25,
		24,
		16,
		0,
		23,
		21,
		39,
		-1,
		92,
		74,
		60,
		77,
		77,
		68,
		76,
		125,
		121,
		124,
		122,
		100,
		-1,
		151,
		-1,
		-1,
		48,
		-1,
		-1,
		-1,
		27,
		54,
		49,
		41,
		53,
		62,
		57,
		59,
		72,
		80,
		78,
		75,
		87,
		83,
		103,
		99,
		131,
		-1,
		149,
		-1,
		55,
		-1,
		-1,
		50,
		36,
		48,
		59,
		49,
		49,
		54,
		52,
		74,
		104,
		90,
		88,
		93,
		98,
		-1,
		138,
		137,
		-1,
		69,
		61,
		47,
		-1,
		40,
		-1,
		95,
		56,
		-1,
		81,
		61,
		-1,
		99,
		95,
		-1,
		-1,
		125,
		85,
		-1,
		-1,
		-1,
		70,
		50,
		90,
		74,
		-1,
		72,
		72,
		-1,
		-1,
		-1,
		110,
		94,
		-1,
		63,
		66,
		-1,
		57,
		63,
		92,
		74,
		78,
		-1,
		-1,
		-1,
		119,
		100,
		94,
		78,
		83,
		71,
		88,
		74,
		76,
		88,
		77,
		98,
		-1,
		-1,
		-1,
		91,
		83,
		83,
		-1,
		-1,
		101,
		84,
		84,
		97,
		-1,
		-1,
		-1,
		113,
		94,
		-1,
		-1,
		92,
		-1,
		-1,
		97,
		96,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		102,
		-1,
		-1,
		-1,
		93,
		100,
		108,
		-1,
		-1,
		-1,
		-1,
		123,
		124,
		148,
		123,
		-1,
		-1,
		-1,
		107,
		107,
		-1,
		-1,
		126,
		124,
		-1,
		-1,
		-1,
		135,
		119,
		-1,
		111,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		140,
		-1,
		146,
		121,
		128,
		-1,
		-1,
		-1,
		-1,
		153,
		145,
		159,
		-1,
		131,
		133,
		-1,
		181,
		-1,
		-1,
		168,
		159,
		-1,
		-1,
		136,
		143,
		165,
		168,
		198,
		-1,
		155
	],
	[
		-1,
		284,
		273,
		284,
		292,
		265,
		272,
		-1,
		291,
		295,
		261,
		255,
		294,
		263,
		269,
		280,
		-1,
		-1,
		-1,
		284,
		283,
		251,
		249,
		258,
		263,
		270,
		-1,
		269,
		-1,
		305,
		284,
		295,
		300,
		244,
		241,
		261,
		280,
		262,
		254,
		320,
		274,
		245,
		239,
		257,
		247,
		256,
		248,
		-1,
		245,
		235,
		257,
		236,
		247,
		239,
		-1,
		-1,
		239,
		240,
		246,
		232,
		238,
		234,
		-1,
		244,
		228,
		-1,
		-1,
		229,
		230,
		214,
		217,
		225,
		223,
		236,
		228,
		223,
		-1,
		-1,
		220,
		216,
		223,
		210,
		206,
		223,
		236,
		218,
		232,
		231,
		-1,
		224,
		242,
		249,
		217,
		215,
		199,
		197,
		215,
		217,
		223,
		223,
		-1,
		233,
		234,
		229,
		237,
		239,
		215,
		202,
		202,
		212,
		205,
		224,
		212,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		233,
		216,
		233,
		225,
		215,
		230,
		223,
		205,
		202,
		200,
		197,
		213,
		211,
		221,
		-1,
		-1,
		326,
		295,
		324,
		282,
		263,
		-1,
		229,
		209,
		215,
		219,
		213,
		206,
		220,
		216,
		-1,
		191,
		190,
		218,
		204,
		215,
		286,
		-1,
		-1,
		284,
		276,
		259,
		262,
		239,
		235,
		224,
		223,
		215,
		201,
		197,
		203,
		206,
		206,
		212,
		185,
		195,
		199,
		197,
		222,
		-1,
		-1,
		257,
		-1,
		-1,
		283,
		266,
		-1,
		249,
		256,
		245,
		251,
		237,
		258,
		234,
		225,
		217,
		211,
		199,
		201,
		198,
		211,
		199,
		182,
		207,
		211,
		192,
		213,
		208,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		242,
		245,
		251,
		275,
		274,
		-1,
		246,
		234,
		235,
		220,
		217,
		204,
		192,
		205,
		190,
		197,
		196,
		186,
		184,
		214,
		189,
		211,
		208,
		227,
		232,
		226,
		235,
		-1,
		291,
		287,
		283,
		290,
		239,
		-1,
		-1,
		279,
		-1,
		282,
		283,
		258,
		231,
		234,
		221,
		212,
		199,
		188,
		199,
		188,
		185,
		193,
		178,
		193,
		184,
		183,
		201,
		211,
		219,
		223,
		229,
		-1,
		341,
		-1,
		283,
		267,
		269,
		241,
		262,
		-1,
		299,
		283,
		275,
		260,
		260,
		-1,
		230,
		227,
		217,
		195,
		180,
		197,
		189,
		187,
		191,
		173,
		187,
		178,
		196,
		203,
		201,
		205,
		225,
		237,
		301,
		291,
		-1,
		273,
		278,
		237,
		245,
		264,
		302,
		266,
		-1,
		261,
		-1,
		232,
		245,
		-1,
		201,
		197,
		179,
		180,
		175,
		190,
		184,
		169,
		166,
		184,
		187,
		194,
		198,
		214,
		-1,
		-1,
		286,
		290,
		279,
		230,
		249,
		273,
		310,
		259,
		248,
		247,
		-1,
		238,
		215,
		212,
		200,
		187,
		172,
		173,
		181,
		194,
		173,
		168,
		165,
		185,
		211,
		189,
		201,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		256,
		227,
		251,
		293,
		277,
		270,
		258,
		223,
		223,
		217,
		-1,
		211,
		190,
		181,
		170,
		168,
		181,
		178,
		183,
		163,
		161,
		180,
		192,
		183,
		200,
		-1,
		-1,
		-1,
		286,
		275,
		276,
		222,
		245,
		282,
		256,
		242,
		247,
		222,
		215,
		209,
		224,
		207,
		188,
		177,
		169,
		158,
		174,
		182,
		177,
		159,
		168,
		174,
		198,
		188,
		194,
		-1,
		-1,
		293,
		283,
		267,
		269,
		266,
		236,
		243,
		275,
		247,
		260,
		-1,
		214,
		-1,
		203,
		198,
		182,
		177,
		174,
		171,
		165,
		174,
		176,
		166,
		161,
		168,
		203,
		203,
		178,
		198,
		201,
		-1,
		-1,
		-1,
		286,
		281,
		256,
		233,
		217,
		253,
		-1,
		230,
		231,
		-1,
		208,
		202,
		199,
		184,
		180,
		175,
		179,
		172,
		179,
		172,
		170,
		171,
		153,
		185,
		-1,
		186,
		180,
		188,
		178,
		166,
		-1,
		-1,
		-1,
		279,
		258,
		251,
		271,
		212,
		264,
		-1,
		-1,
		215,
		208,
		-1,
		195,
		177,
		184,
		182,
		176,
		180,
		177,
		166,
		179,
		172,
		158,
		160,
		173,
		177,
		181,
		168,
		164,
		161,
		175,
		-1,
		298,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		232,
		-1,
		224,
		216,
		206,
		200,
		194,
		190,
		188,
		204,
		188,
		191,
		189,
		180,
		188,
		161,
		154,
		161,
		150,
		168,
		176,
		168,
		162,
		161,
		171,
		-1,
		299,
		285,
		256,
		-1,
		-1,
		245,
		-1,
		209,
		223,
		239,
		-1,
		232,
		211,
		226,
		204,
		200,
		196,
		211,
		212,
		189,
		189,
		187,
		178,
		166,
		155,
		158,
		150,
		172,
		172,
		156,
		157,
		161,
		-1,
		305,
		292,
		250,
		246,
		235,
		255,
		206,
		194,
		226,
		-1,
		-1,
		268,
		-1,
		202,
		219,
		210,
		208,
		201,
		183,
		190,
		198,
		175,
		170,
		160,
		149,
		149,
		144,
		166,
		152,
		150,
		159,
		175,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		221,
		208,
		202,
		-1,
		243,
		-1,
		246,
		236,
		220,
		205,
		238,
		-1,
		182,
		178,
		185,
		-1,
		195,
		-1,
		168,
		165,
		156,
		141,
		138,
		149,
		147,
		158,
		154,
		-1,
		255,
		240,
		233,
		223,
		237,
		208,
		-1,
		263,
		-1,
		-1,
		233,
		227,
		227,
		211,
		212,
		198,
		178,
		170,
		185,
		184,
		171,
		170,
		154,
		147,
		144,
		137,
		150,
		160,
		165,
		152,
		-1,
		-1,
		-1,
		260,
		246,
		250,
		210,
		229,
		-1,
		-1,
		295,
		250,
		236,
		-1,
		207,
		198,
		186,
		176,
		166,
		171,
		172,
		162,
		160,
		152,
		154,
		148,
		139,
		138,
		154,
		146,
		168,
		-1,
		-1,
		243,
		248,
		236,
		222,
		224,
		-1,
		-1,
		-1,
		242,
		258,
		226,
		205,
		187,
		-1,
		-1,
		170,
		163,
		157,
		160,
		148,
		168,
		163,
		147,
		132,
		147,
		151,
		159,
		150,
		-1,
		246,
		233,
		-1,
		-1,
		223,
		213,
		-1,
		-1,
		-1,
		-1,
		238,
		183,
		172,
		167,
		171,
		169,
		-1,
		143,
		154,
		147,
		166,
		173,
		149,
		134,
		128,
		134,
		146,
		155,
		-1,
		-1,
		237,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		195,
		189,
		160,
		153,
		157,
		-1,
		145,
		147,
		144,
		156,
		152,
		149,
		140,
		131,
		127,
		131,
		135,
		149,
		153,
		260,
		-1,
		190,
		-1,
		-1,
		-1,
		213,
		228,
		199,
		176,
		149,
		144,
		137,
		131,
		136,
		147,
		156,
		167,
		132,
		134,
		124,
		123,
		127,
		144,
		148,
		-1,
		-1,
		188,
		184,
		219,
		221,
		225,
		226,
		-1,
		-1,
		153,
		144,
		135,
		127,
		140,
		143,
		128,
		130,
		130,
		128,
		122,
		132,
		147,
		142,
		-1,
		-1,
		-1,
		200,
		-1,
		202,
		-1,
		-1,
		221,
		224,
		171,
		153,
		149,
		147,
		136,
		130,
		118,
		123,
		133,
		127,
		124,
		118,
		122,
		145,
		134,
		173,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		182,
		171,
		166,
		200,
		205,
		196,
		186,
		183,
		-1,
		153,
		159,
		124,
		131,
		114,
		121,
		126,
		123,
		112,
		119,
		135,
		134,
		129,
		165,
		156,
		162,
		-1,
		-1,
		215,
		204,
		193,
		199,
		-1,
		175,
		168,
		186,
		176,
		182,
		-1,
		-1,
		178,
		175,
		155,
		124,
		122,
		115,
		110,
		120,
		96,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		153,
		168,
		-1,
		169,
		206,
		199,
		167,
		175,
		206,
		-1,
		165,
		157,
		165,
		168,
		175,
		-1,
		-1,
		151,
		142,
		143,
		131,
		128,
		134,
		133,
		116,
		122,
		123,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		162,
		182,
		161,
		164,
		188,
		202,
		-1,
		156,
		-1,
		-1,
		125,
		176,
		160,
		150,
		147,
		190,
		145,
		140,
		121,
		119,
		114,
		105,
		130,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		151,
		162,
		155,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		115,
		-1,
		187,
		-1,
		170,
		174,
		153,
		156,
		135,
		122,
		108,
		116,
		122,
		121,
		127,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		176,
		132,
		135,
		146,
		157,
		172,
		176,
		-1,
		140,
		176,
		121,
		-1,
		105,
		-1,
		-1,
		-1,
		184,
		166,
		158,
		155,
		134,
		134,
		100,
		104,
		117,
		124,
		134,
		145,
		137,
		141,
		154,
		165,
		168,
		172,
		163,
		176,
		121,
		121,
		142,
		151,
		172,
		136,
		133,
		170,
		128,
		117,
		112,
		99,
		-1,
		-1,
		168,
		176,
		-1,
		-1,
		141,
		108,
		96,
		106,
		110,
		124,
		136,
		149,
		137,
		142,
		136,
		168,
		-1,
		165,
		164,
		153,
		150,
		126,
		117,
		112,
		139,
		-1,
		-1,
		134,
		161,
		145,
		149,
		159,
		184,
		-1,
		83,
		-1,
		-1,
		148,
		-1,
		-1,
		133,
		113,
		102,
		93,
		98,
		118,
		129,
		151,
		133,
		150,
		141,
		151,
		155,
		149,
		146,
		134,
		132,
		155,
		120,
		108,
		-1,
		116,
		119,
		125,
		132,
		149,
		173,
		-1,
		-1,
		99,
		79,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		90,
		95,
		125,
		127,
		129,
		136,
		130,
		137,
		145,
		156,
		148,
		158,
		172,
		161,
		157,
		156,
		164,
		113,
		106,
		113,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		-1,
		89,
		85,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		95,
		112,
		112,
		115,
		120,
		128,
		139,
		135,
		139,
		142,
		-1,
		192,
		-1,
		144,
		105,
		111,
		126,
		134,
		-1,
		-1,
		-1,
		106,
		92,
		85,
		73,
		71,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		148,
		116,
		121,
		116,
		131,
		142,
		133,
		141,
		135,
		138,
		-1,
		-1,
		104,
		87,
		-1,
		-1,
		61,
		63,
		-1,
		97,
		86,
		71,
		63,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		82,
		120,
		119,
		127,
		122,
		127,
		139,
		135,
		131,
		141,
		132,
		-1,
		-1,
		82,
		74,
		68,
		-1,
		46,
		-1,
		99,
		-1,
		66,
		73,
		61,
		-1,
		-1,
		-1,
		113,
		76,
		92,
		115,
		141,
		139,
		130,
		123,
		130,
		133,
		126,
		132,
		-1,
		-1,
		-1,
		64,
		38,
		106,
		97,
		80,
		60,
		52,
		72,
		-1,
		94,
		-1,
		69,
		72,
		97,
		136,
		138,
		124,
		120,
		133,
		127,
		124,
		122,
		70,
		-1,
		40,
		73,
		37,
		66,
		32,
		44,
		108,
		-1,
		91,
		73,
		-1,
		101,
		91,
		139,
		114,
		123,
		116,
		110,
		111,
		119,
		-1,
		-1,
		-1,
		42,
		41,
		33,
		27,
		0,
		25,
		43,
		-1,
		96,
		78,
		64,
		81,
		81,
		72,
		80,
		129,
		125,
		128,
		126,
		104,
		-1,
		158,
		-1,
		-1,
		65,
		-1,
		-1,
		-1,
		36,
		58,
		53,
		45,
		57,
		66,
		61,
		63,
		76,
		84,
		82,
		79,
		91,
		87,
		107,
		103,
		135,
		-1,
		153,
		-1,
		72,
		-1,
		-1,
		54,
		40,
		52,
		63,
		53,
		53,
		58,
		56,
		78,
		108,
		94,
		92,
		97,
		102,
		-1,
		142,
		141,
		-1,
		73,
		65,
		51,
		-1,
		44,
		-1,
		99,
		60,
		-1,
		85,
		65,
		-1,
		103,
		99,
		-1,
		-1,
		129,
		89,
		-1,
		-1,
		-1,
		74,
		54,
		94,
		78,
		-1,
		76,
		76,
		-1,
		-1,
		-1,
		114,
		98,
		-1,
		67,
		70,
		-1,
		61,
		67,
		96,
		78,
		82,
		-1,
		-1,
		-1,
		123,
		104,
		98,
		82,
		87,
		75,
		92,
		78,
		80,
		92,
		81,
		102,
		-1,
		-1,
		-1,
		95,
		87,
		87,
		-1,
		-1,
		105,
		88,
		88,
		101,
		-1,
		-1,
		-1,
		117,
		98,
		-1,
		-1,
		96,
		-1,
		-1,
		101,
		100,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		106,
		-1,
		-1,
		-1,
		97,
		104,
		112,
		-1,
		-1,
		-1,
		-1,
		127,
		128,
		152,
		127,
		-1,
		-1,
		-1,
		111,
		111,
		-1,
		-1,
		130,
		128,
		-1,
		-1,
		-1,
		139,
		123,
		-1,
		115,
		-1,
		-1,
		-1,
		130,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		144,
		-1,
		150,
		125,
		132,
		-1,
		-1,
		-1,
		-1,
		157,
		149,
		163,
		-1,
		135,
		137,
		-1,
		185,
		-1,
		-1,
		172,
		163,
		-1,
		-1,
		140,
		147,
		169,
		172,
		202,
		-1,
		159
	],
	[
		-1,
		266,
		255,
		266,
		274,
		247,
		254,
		-1,
		273,
		277,
		243,
		237,
		276,
		245,
		251,
		262,
		-1,
		-1,
		-1,
		266,
		265,
		233,
		231,
		240,
		245,
		252,
		-1,
		251,
		-1,
		287,
		266,
		277,
		282,
		226,
		223,
		243,
		262,
		244,
		236,
		302,
		256,
		227,
		221,
		239,
		229,
		238,
		230,
		-1,
		227,
		217,
		239,
		218,
		229,
		221,
		-1,
		-1,
		221,
		222,
		228,
		214,
		220,
		216,
		-1,
		226,
		210,
		-1,
		-1,
		211,
		212,
		196,
		199,
		207,
		205,
		218,
		210,
		205,
		-1,
		-1,
		202,
		198,
		205,
		192,
		188,
		205,
		218,
		200,
		214,
		213,
		-1,
		206,
		224,
		231,
		199,
		197,
		181,
		179,
		197,
		199,
		205,
		205,
		-1,
		215,
		216,
		211,
		219,
		221,
		197,
		184,
		184,
		194,
		187,
		206,
		194,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		215,
		198,
		215,
		207,
		197,
		212,
		205,
		187,
		184,
		182,
		179,
		195,
		193,
		203,
		-1,
		-1,
		308,
		277,
		306,
		264,
		245,
		-1,
		211,
		191,
		197,
		201,
		195,
		188,
		202,
		198,
		-1,
		173,
		172,
		200,
		186,
		197,
		268,
		-1,
		-1,
		266,
		258,
		241,
		244,
		221,
		217,
		206,
		205,
		197,
		183,
		179,
		185,
		188,
		188,
		194,
		167,
		177,
		181,
		179,
		204,
		-1,
		-1,
		239,
		-1,
		-1,
		265,
		248,
		-1,
		231,
		238,
		227,
		233,
		219,
		240,
		216,
		207,
		199,
		193,
		181,
		183,
		180,
		193,
		181,
		164,
		189,
		193,
		174,
		195,
		190,
		-1,
		238,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		224,
		227,
		233,
		257,
		256,
		-1,
		228,
		216,
		217,
		202,
		199,
		186,
		174,
		187,
		172,
		179,
		178,
		168,
		166,
		196,
		171,
		193,
		190,
		209,
		214,
		208,
		217,
		-1,
		273,
		269,
		265,
		272,
		221,
		-1,
		-1,
		261,
		-1,
		264,
		265,
		240,
		213,
		216,
		203,
		194,
		181,
		170,
		181,
		170,
		167,
		175,
		160,
		175,
		166,
		165,
		183,
		193,
		201,
		205,
		211,
		-1,
		323,
		-1,
		265,
		249,
		251,
		223,
		244,
		-1,
		281,
		265,
		257,
		242,
		242,
		-1,
		212,
		209,
		199,
		177,
		162,
		179,
		171,
		169,
		173,
		155,
		169,
		160,
		178,
		185,
		183,
		187,
		207,
		219,
		283,
		273,
		-1,
		255,
		260,
		219,
		227,
		246,
		284,
		248,
		-1,
		243,
		-1,
		214,
		227,
		-1,
		183,
		179,
		161,
		162,
		157,
		172,
		166,
		151,
		148,
		166,
		169,
		176,
		180,
		196,
		-1,
		-1,
		268,
		272,
		261,
		212,
		231,
		255,
		292,
		241,
		230,
		229,
		-1,
		220,
		197,
		194,
		182,
		169,
		154,
		155,
		163,
		176,
		155,
		150,
		147,
		167,
		193,
		171,
		183,
		-1,
		-1,
		-1,
		293,
		-1,
		-1,
		238,
		209,
		233,
		275,
		259,
		252,
		240,
		205,
		205,
		199,
		-1,
		193,
		172,
		163,
		152,
		150,
		163,
		160,
		165,
		145,
		143,
		162,
		174,
		165,
		182,
		-1,
		-1,
		-1,
		268,
		257,
		258,
		204,
		227,
		264,
		238,
		224,
		229,
		204,
		197,
		191,
		206,
		189,
		170,
		159,
		151,
		140,
		156,
		164,
		159,
		141,
		150,
		156,
		180,
		170,
		176,
		-1,
		-1,
		275,
		265,
		249,
		251,
		248,
		218,
		225,
		257,
		229,
		242,
		-1,
		196,
		-1,
		185,
		180,
		164,
		159,
		156,
		153,
		147,
		156,
		158,
		148,
		143,
		150,
		185,
		185,
		160,
		180,
		183,
		-1,
		-1,
		-1,
		268,
		263,
		238,
		215,
		199,
		235,
		-1,
		212,
		213,
		-1,
		190,
		184,
		181,
		166,
		162,
		157,
		161,
		154,
		161,
		154,
		152,
		153,
		135,
		167,
		-1,
		168,
		162,
		170,
		160,
		148,
		-1,
		-1,
		-1,
		261,
		240,
		233,
		253,
		194,
		246,
		-1,
		-1,
		197,
		190,
		-1,
		177,
		159,
		166,
		164,
		158,
		162,
		159,
		148,
		161,
		154,
		140,
		142,
		155,
		159,
		163,
		150,
		146,
		143,
		157,
		-1,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		214,
		-1,
		206,
		198,
		188,
		182,
		176,
		172,
		170,
		186,
		170,
		173,
		171,
		162,
		170,
		143,
		136,
		143,
		132,
		150,
		158,
		150,
		144,
		143,
		153,
		-1,
		281,
		267,
		238,
		-1,
		-1,
		227,
		-1,
		191,
		205,
		221,
		-1,
		214,
		193,
		208,
		186,
		182,
		178,
		193,
		194,
		171,
		171,
		169,
		160,
		148,
		137,
		140,
		132,
		154,
		154,
		138,
		139,
		143,
		-1,
		287,
		274,
		232,
		228,
		217,
		237,
		188,
		176,
		208,
		-1,
		-1,
		250,
		-1,
		184,
		201,
		192,
		190,
		183,
		165,
		172,
		180,
		157,
		152,
		142,
		131,
		131,
		126,
		148,
		134,
		132,
		141,
		157,
		-1,
		-1,
		-1,
		254,
		-1,
		-1,
		203,
		190,
		184,
		-1,
		225,
		-1,
		228,
		218,
		202,
		187,
		220,
		-1,
		164,
		160,
		167,
		-1,
		177,
		-1,
		150,
		147,
		138,
		123,
		120,
		131,
		129,
		140,
		136,
		-1,
		237,
		222,
		215,
		205,
		219,
		190,
		-1,
		245,
		-1,
		-1,
		215,
		209,
		209,
		193,
		194,
		180,
		160,
		152,
		167,
		166,
		153,
		152,
		136,
		129,
		126,
		119,
		132,
		142,
		147,
		134,
		-1,
		-1,
		-1,
		242,
		228,
		232,
		192,
		211,
		-1,
		-1,
		277,
		232,
		218,
		-1,
		189,
		180,
		168,
		158,
		148,
		153,
		154,
		144,
		142,
		134,
		136,
		130,
		121,
		120,
		136,
		128,
		150,
		-1,
		-1,
		225,
		230,
		218,
		204,
		205,
		-1,
		-1,
		-1,
		224,
		240,
		208,
		187,
		169,
		-1,
		-1,
		152,
		145,
		139,
		142,
		130,
		150,
		145,
		129,
		114,
		129,
		133,
		141,
		132,
		-1,
		228,
		215,
		-1,
		-1,
		204,
		194,
		-1,
		-1,
		-1,
		-1,
		220,
		165,
		154,
		149,
		153,
		151,
		-1,
		125,
		136,
		129,
		148,
		155,
		131,
		116,
		110,
		116,
		128,
		137,
		-1,
		-1,
		218,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		177,
		171,
		142,
		135,
		139,
		-1,
		127,
		129,
		126,
		138,
		134,
		131,
		122,
		113,
		109,
		113,
		117,
		131,
		135,
		241,
		-1,
		171,
		-1,
		-1,
		-1,
		195,
		210,
		181,
		158,
		131,
		126,
		119,
		113,
		118,
		129,
		138,
		149,
		114,
		116,
		106,
		105,
		109,
		126,
		130,
		-1,
		-1,
		169,
		165,
		200,
		203,
		207,
		208,
		-1,
		-1,
		135,
		126,
		117,
		109,
		122,
		125,
		110,
		112,
		112,
		110,
		104,
		114,
		129,
		124,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		202,
		206,
		153,
		135,
		131,
		129,
		118,
		112,
		100,
		105,
		115,
		109,
		106,
		100,
		104,
		127,
		116,
		155,
		-1,
		-1,
		218,
		-1,
		-1,
		-1,
		178,
		152,
		147,
		181,
		186,
		177,
		168,
		165,
		-1,
		135,
		141,
		106,
		113,
		96,
		103,
		108,
		105,
		94,
		101,
		117,
		116,
		111,
		147,
		138,
		144,
		-1,
		-1,
		211,
		200,
		189,
		195,
		-1,
		171,
		149,
		167,
		157,
		163,
		-1,
		-1,
		160,
		157,
		137,
		106,
		104,
		97,
		92,
		102,
		78,
		90,
		94,
		98,
		104,
		109,
		114,
		120,
		135,
		150,
		-1,
		165,
		202,
		195,
		163,
		171,
		202,
		-1,
		161,
		153,
		146,
		149,
		157,
		-1,
		-1,
		133,
		124,
		125,
		113,
		110,
		116,
		115,
		98,
		104,
		105,
		97,
		96,
		114,
		118,
		127,
		134,
		124,
		137,
		141,
		-1,
		158,
		178,
		157,
		160,
		184,
		198,
		-1,
		152,
		-1,
		-1,
		106,
		158,
		142,
		132,
		129,
		172,
		127,
		122,
		103,
		101,
		96,
		87,
		112,
		105,
		105,
		108,
		123,
		128,
		120,
		134,
		134,
		135,
		-1,
		147,
		158,
		151,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		-1,
		96,
		-1,
		169,
		-1,
		152,
		156,
		135,
		138,
		117,
		104,
		90,
		98,
		104,
		103,
		109,
		109,
		110,
		119,
		130,
		142,
		141,
		142,
		172,
		128,
		131,
		142,
		153,
		168,
		172,
		-1,
		136,
		172,
		102,
		-1,
		86,
		-1,
		-1,
		-1,
		166,
		148,
		140,
		137,
		116,
		116,
		82,
		86,
		99,
		106,
		116,
		127,
		119,
		123,
		136,
		147,
		150,
		168,
		159,
		172,
		117,
		117,
		138,
		147,
		168,
		132,
		129,
		166,
		109,
		98,
		93,
		80,
		-1,
		-1,
		150,
		158,
		-1,
		-1,
		123,
		90,
		78,
		88,
		92,
		106,
		118,
		131,
		119,
		124,
		118,
		150,
		-1,
		161,
		160,
		149,
		146,
		122,
		113,
		108,
		135,
		-1,
		-1,
		130,
		157,
		141,
		142,
		140,
		165,
		-1,
		64,
		-1,
		-1,
		130,
		-1,
		-1,
		115,
		95,
		84,
		75,
		80,
		100,
		111,
		133,
		115,
		132,
		123,
		133,
		137,
		145,
		142,
		130,
		128,
		151,
		116,
		104,
		-1,
		112,
		115,
		121,
		128,
		143,
		154,
		-1,
		-1,
		80,
		60,
		-1,
		-1,
		113,
		111,
		100,
		-1,
		90,
		72,
		77,
		107,
		109,
		111,
		118,
		112,
		119,
		127,
		138,
		130,
		154,
		168,
		157,
		153,
		152,
		160,
		109,
		102,
		109,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		-1,
		70,
		66,
		-1,
		-1,
		108,
		101,
		89,
		77,
		67,
		77,
		94,
		94,
		97,
		102,
		110,
		121,
		117,
		121,
		124,
		-1,
		188,
		-1,
		140,
		101,
		107,
		122,
		130,
		-1,
		-1,
		-1,
		87,
		73,
		66,
		54,
		52,
		-1,
		142,
		126,
		107,
		-1,
		77,
		90,
		130,
		98,
		103,
		98,
		113,
		124,
		115,
		123,
		117,
		120,
		-1,
		-1,
		100,
		83,
		-1,
		-1,
		57,
		59,
		-1,
		78,
		67,
		52,
		44,
		-1,
		-1,
		114,
		110,
		-1,
		-1,
		64,
		102,
		101,
		109,
		104,
		109,
		121,
		117,
		113,
		123,
		114,
		-1,
		-1,
		78,
		70,
		64,
		-1,
		42,
		-1,
		80,
		-1,
		47,
		52,
		40,
		-1,
		-1,
		-1,
		95,
		58,
		74,
		97,
		123,
		121,
		112,
		105,
		112,
		115,
		108,
		114,
		-1,
		-1,
		-1,
		60,
		34,
		87,
		78,
		61,
		41,
		33,
		51,
		-1,
		76,
		-1,
		51,
		54,
		79,
		118,
		120,
		106,
		102,
		115,
		109,
		106,
		104,
		66,
		-1,
		36,
		69,
		33,
		47,
		12,
		23,
		90,
		-1,
		73,
		55,
		-1,
		83,
		73,
		121,
		96,
		105,
		98,
		92,
		93,
		101,
		-1,
		-1,
		-1,
		38,
		37,
		29,
		23,
		17,
		0,
		22,
		-1,
		78,
		60,
		46,
		63,
		63,
		54,
		62,
		111,
		107,
		110,
		108,
		86,
		-1,
		154,
		-1,
		-1,
		61,
		-1,
		-1,
		-1,
		32,
		54,
		39,
		27,
		41,
		48,
		43,
		45,
		58,
		66,
		64,
		61,
		73,
		69,
		89,
		85,
		117,
		-1,
		149,
		-1,
		68,
		-1,
		-1,
		50,
		36,
		48,
		50,
		39,
		37,
		40,
		38,
		60,
		90,
		76,
		74,
		79,
		84,
		-1,
		138,
		137,
		-1,
		69,
		61,
		47,
		-1,
		40,
		-1,
		85,
		46,
		-1,
		67,
		47,
		-1,
		85,
		81,
		-1,
		-1,
		125,
		85,
		-1,
		-1,
		-1,
		70,
		50,
		80,
		64,
		-1,
		58,
		58,
		-1,
		-1,
		-1,
		110,
		94,
		-1,
		63,
		66,
		-1,
		57,
		63,
		92,
		60,
		64,
		-1,
		-1,
		-1,
		119,
		100,
		94,
		78,
		83,
		71,
		88,
		74,
		76,
		74,
		63,
		84,
		-1,
		-1,
		-1,
		91,
		83,
		83,
		-1,
		-1,
		101,
		84,
		84,
		83,
		-1,
		-1,
		-1,
		113,
		94,
		-1,
		-1,
		92,
		-1,
		-1,
		97,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		102,
		-1,
		-1,
		-1,
		93,
		100,
		104,
		-1,
		-1,
		-1,
		-1,
		123,
		124,
		148,
		123,
		-1,
		-1,
		-1,
		99,
		93,
		-1,
		-1,
		126,
		124,
		-1,
		-1,
		-1,
		127,
		111,
		-1,
		97,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		132,
		-1,
		132,
		107,
		114,
		-1,
		-1,
		-1,
		-1,
		145,
		137,
		145,
		-1,
		117,
		119,
		-1,
		167,
		-1,
		-1,
		160,
		151,
		-1,
		-1,
		122,
		129,
		151,
		154,
		190,
		-1,
		141
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		259,
		263,
		229,
		223,
		262,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		252,
		251,
		219,
		217,
		226,
		231,
		238,
		-1,
		237,
		-1,
		273,
		252,
		263,
		268,
		212,
		209,
		229,
		248,
		230,
		222,
		288,
		242,
		213,
		207,
		225,
		215,
		224,
		216,
		-1,
		213,
		203,
		225,
		204,
		215,
		207,
		-1,
		-1,
		207,
		208,
		214,
		200,
		206,
		202,
		-1,
		212,
		196,
		-1,
		-1,
		197,
		198,
		182,
		185,
		193,
		191,
		204,
		196,
		191,
		-1,
		-1,
		188,
		184,
		191,
		178,
		174,
		191,
		204,
		186,
		200,
		199,
		-1,
		192,
		210,
		217,
		185,
		183,
		167,
		165,
		183,
		185,
		191,
		191,
		-1,
		201,
		202,
		197,
		205,
		207,
		183,
		170,
		170,
		180,
		173,
		192,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		201,
		184,
		201,
		193,
		183,
		198,
		191,
		173,
		170,
		168,
		165,
		181,
		179,
		189,
		-1,
		-1,
		294,
		263,
		292,
		250,
		231,
		-1,
		197,
		177,
		183,
		187,
		181,
		174,
		188,
		184,
		-1,
		159,
		158,
		186,
		172,
		183,
		254,
		-1,
		-1,
		252,
		244,
		227,
		230,
		207,
		203,
		192,
		191,
		183,
		169,
		165,
		171,
		174,
		174,
		180,
		153,
		163,
		167,
		165,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		251,
		234,
		-1,
		217,
		224,
		213,
		219,
		205,
		226,
		202,
		193,
		185,
		179,
		167,
		169,
		166,
		179,
		167,
		150,
		175,
		179,
		160,
		181,
		176,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		210,
		213,
		219,
		243,
		242,
		-1,
		214,
		202,
		203,
		188,
		185,
		172,
		160,
		173,
		158,
		165,
		164,
		154,
		152,
		182,
		157,
		179,
		176,
		195,
		200,
		194,
		203,
		-1,
		259,
		255,
		251,
		258,
		207,
		-1,
		-1,
		247,
		-1,
		250,
		251,
		226,
		199,
		202,
		189,
		180,
		167,
		156,
		167,
		156,
		153,
		161,
		146,
		161,
		152,
		151,
		169,
		179,
		187,
		191,
		197,
		-1,
		309,
		-1,
		251,
		235,
		237,
		209,
		230,
		-1,
		267,
		251,
		243,
		228,
		228,
		-1,
		198,
		195,
		185,
		163,
		148,
		165,
		157,
		155,
		159,
		141,
		155,
		146,
		164,
		171,
		169,
		173,
		193,
		205,
		269,
		259,
		-1,
		241,
		246,
		205,
		213,
		232,
		270,
		234,
		-1,
		229,
		-1,
		200,
		213,
		-1,
		169,
		165,
		147,
		148,
		143,
		158,
		152,
		137,
		134,
		152,
		155,
		162,
		166,
		182,
		-1,
		-1,
		254,
		258,
		247,
		198,
		217,
		241,
		278,
		227,
		216,
		215,
		-1,
		206,
		183,
		180,
		168,
		155,
		140,
		141,
		149,
		162,
		141,
		136,
		133,
		153,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		224,
		195,
		219,
		261,
		245,
		238,
		226,
		191,
		191,
		185,
		-1,
		179,
		158,
		149,
		138,
		136,
		149,
		146,
		151,
		131,
		129,
		148,
		160,
		151,
		168,
		-1,
		-1,
		-1,
		254,
		243,
		244,
		190,
		213,
		250,
		224,
		210,
		215,
		190,
		183,
		177,
		192,
		175,
		156,
		145,
		137,
		126,
		142,
		150,
		145,
		127,
		136,
		142,
		166,
		156,
		162,
		-1,
		-1,
		261,
		251,
		235,
		237,
		234,
		204,
		211,
		243,
		215,
		228,
		-1,
		182,
		-1,
		171,
		166,
		150,
		145,
		142,
		139,
		133,
		142,
		144,
		134,
		129,
		136,
		171,
		171,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		254,
		249,
		224,
		201,
		185,
		221,
		-1,
		198,
		199,
		-1,
		176,
		170,
		167,
		152,
		148,
		143,
		147,
		140,
		147,
		140,
		138,
		139,
		121,
		153,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		247,
		226,
		219,
		239,
		180,
		232,
		-1,
		-1,
		183,
		176,
		-1,
		163,
		145,
		152,
		150,
		144,
		148,
		145,
		134,
		147,
		140,
		126,
		128,
		141,
		145,
		149,
		136,
		132,
		129,
		143,
		-1,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		200,
		-1,
		192,
		184,
		174,
		168,
		162,
		158,
		156,
		172,
		156,
		159,
		157,
		148,
		156,
		129,
		122,
		129,
		118,
		136,
		144,
		136,
		130,
		129,
		139,
		-1,
		267,
		253,
		224,
		-1,
		-1,
		213,
		-1,
		177,
		191,
		207,
		-1,
		200,
		179,
		194,
		172,
		168,
		164,
		179,
		180,
		157,
		157,
		155,
		146,
		134,
		123,
		126,
		118,
		140,
		140,
		124,
		125,
		129,
		-1,
		273,
		260,
		218,
		214,
		203,
		223,
		174,
		162,
		194,
		-1,
		-1,
		236,
		-1,
		170,
		187,
		178,
		176,
		169,
		151,
		158,
		166,
		143,
		138,
		128,
		117,
		117,
		112,
		134,
		120,
		118,
		127,
		143,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		189,
		176,
		170,
		-1,
		211,
		-1,
		214,
		204,
		188,
		173,
		206,
		-1,
		150,
		146,
		153,
		-1,
		163,
		-1,
		136,
		133,
		124,
		109,
		106,
		117,
		115,
		126,
		122,
		-1,
		223,
		208,
		201,
		191,
		205,
		176,
		-1,
		231,
		-1,
		-1,
		201,
		195,
		195,
		179,
		180,
		166,
		146,
		138,
		153,
		152,
		139,
		138,
		122,
		115,
		112,
		105,
		118,
		128,
		133,
		120,
		-1,
		-1,
		-1,
		228,
		214,
		218,
		178,
		197,
		-1,
		-1,
		263,
		218,
		204,
		-1,
		175,
		166,
		154,
		144,
		134,
		139,
		140,
		130,
		128,
		120,
		122,
		116,
		107,
		106,
		122,
		114,
		136,
		-1,
		-1,
		211,
		216,
		204,
		190,
		196,
		-1,
		-1,
		-1,
		210,
		226,
		194,
		173,
		155,
		-1,
		-1,
		138,
		131,
		125,
		128,
		116,
		136,
		131,
		115,
		100,
		115,
		119,
		127,
		118,
		-1,
		214,
		201,
		-1,
		-1,
		195,
		185,
		-1,
		-1,
		-1,
		-1,
		206,
		151,
		140,
		135,
		139,
		137,
		-1,
		111,
		122,
		115,
		134,
		141,
		117,
		102,
		96,
		102,
		114,
		123,
		-1,
		-1,
		209,
		-1,
		171,
		-1,
		-1,
		-1,
		-1,
		163,
		157,
		128,
		121,
		125,
		-1,
		113,
		115,
		112,
		124,
		120,
		117,
		108,
		99,
		95,
		99,
		103,
		117,
		121,
		232,
		-1,
		162,
		-1,
		-1,
		-1,
		181,
		196,
		167,
		144,
		117,
		112,
		105,
		99,
		104,
		115,
		124,
		135,
		100,
		102,
		92,
		91,
		95,
		112,
		116,
		-1,
		-1,
		160,
		156,
		191,
		189,
		193,
		194,
		-1,
		-1,
		121,
		112,
		103,
		95,
		108,
		111,
		96,
		98,
		98,
		96,
		90,
		100,
		115,
		110,
		-1,
		-1,
		-1,
		172,
		-1,
		174,
		-1,
		-1,
		191,
		192,
		139,
		121,
		117,
		115,
		104,
		98,
		86,
		91,
		101,
		95,
		92,
		86,
		90,
		113,
		102,
		141,
		-1,
		-1,
		233,
		-1,
		-1,
		-1,
		179,
		143,
		138,
		172,
		175,
		166,
		154,
		151,
		-1,
		121,
		127,
		92,
		99,
		82,
		89,
		94,
		91,
		80,
		87,
		103,
		102,
		97,
		133,
		124,
		130,
		-1,
		-1,
		226,
		215,
		204,
		210,
		-1,
		172,
		140,
		158,
		148,
		152,
		-1,
		-1,
		146,
		143,
		123,
		92,
		90,
		83,
		78,
		88,
		64,
		76,
		80,
		84,
		90,
		95,
		100,
		106,
		121,
		136,
		-1,
		180,
		217,
		210,
		178,
		186,
		217,
		-1,
		162,
		154,
		137,
		140,
		143,
		-1,
		-1,
		119,
		110,
		111,
		99,
		96,
		102,
		101,
		84,
		90,
		91,
		83,
		82,
		100,
		104,
		113,
		120,
		110,
		123,
		127,
		-1,
		173,
		193,
		172,
		175,
		199,
		213,
		-1,
		159,
		-1,
		-1,
		97,
		144,
		128,
		118,
		115,
		158,
		113,
		108,
		89,
		87,
		82,
		73,
		98,
		91,
		91,
		94,
		109,
		114,
		106,
		120,
		120,
		121,
		-1,
		162,
		173,
		166,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		87,
		-1,
		155,
		-1,
		138,
		142,
		121,
		124,
		103,
		90,
		76,
		84,
		90,
		89,
		95,
		95,
		96,
		105,
		116,
		128,
		127,
		128,
		187,
		143,
		146,
		157,
		168,
		183,
		187,
		-1,
		151,
		187,
		93,
		-1,
		77,
		-1,
		-1,
		-1,
		152,
		134,
		126,
		123,
		102,
		102,
		68,
		72,
		85,
		92,
		102,
		113,
		105,
		109,
		122,
		133,
		136,
		183,
		174,
		187,
		132,
		132,
		153,
		162,
		183,
		147,
		144,
		181,
		100,
		89,
		84,
		71,
		-1,
		-1,
		136,
		144,
		-1,
		-1,
		109,
		76,
		64,
		74,
		78,
		92,
		104,
		117,
		105,
		110,
		104,
		136,
		-1,
		176,
		175,
		164,
		161,
		137,
		128,
		123,
		150,
		-1,
		-1,
		145,
		172,
		156,
		133,
		131,
		156,
		-1,
		55,
		-1,
		-1,
		116,
		-1,
		-1,
		101,
		81,
		70,
		61,
		66,
		86,
		97,
		119,
		101,
		118,
		109,
		119,
		123,
		160,
		157,
		145,
		143,
		166,
		131,
		119,
		-1,
		127,
		130,
		136,
		143,
		134,
		145,
		-1,
		-1,
		71,
		51,
		-1,
		-1,
		99,
		97,
		86,
		-1,
		76,
		58,
		63,
		93,
		95,
		97,
		104,
		98,
		105,
		113,
		124,
		116,
		169,
		183,
		172,
		168,
		167,
		175,
		124,
		117,
		124,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		76,
		-1,
		61,
		57,
		-1,
		-1,
		94,
		87,
		75,
		63,
		53,
		63,
		80,
		80,
		83,
		88,
		96,
		107,
		103,
		107,
		110,
		-1,
		203,
		-1,
		155,
		116,
		122,
		137,
		145,
		-1,
		-1,
		-1,
		78,
		64,
		57,
		45,
		43,
		-1,
		128,
		112,
		93,
		-1,
		63,
		76,
		116,
		84,
		89,
		84,
		99,
		110,
		101,
		109,
		103,
		106,
		-1,
		-1,
		115,
		98,
		-1,
		-1,
		72,
		74,
		-1,
		69,
		58,
		43,
		35,
		-1,
		-1,
		100,
		96,
		-1,
		-1,
		50,
		88,
		87,
		95,
		90,
		95,
		107,
		103,
		99,
		109,
		100,
		-1,
		-1,
		93,
		85,
		79,
		-1,
		57,
		-1,
		71,
		-1,
		38,
		42,
		30,
		-1,
		-1,
		-1,
		81,
		44,
		60,
		83,
		109,
		107,
		98,
		91,
		98,
		101,
		94,
		100,
		-1,
		-1,
		-1,
		75,
		49,
		78,
		69,
		52,
		32,
		24,
		41,
		-1,
		62,
		-1,
		37,
		40,
		65,
		104,
		106,
		92,
		88,
		101,
		95,
		92,
		90,
		81,
		-1,
		51,
		84,
		48,
		38,
		16,
		13,
		76,
		-1,
		59,
		41,
		-1,
		69,
		59,
		107,
		82,
		91,
		84,
		78,
		79,
		87,
		-1,
		-1,
		-1,
		53,
		52,
		44,
		38,
		36,
		21,
		0,
		-1,
		64,
		46,
		32,
		49,
		49,
		40,
		48,
		97,
		93,
		96,
		94,
		72,
		-1,
		167,
		-1,
		-1,
		76,
		-1,
		-1,
		-1,
		47,
		47,
		20,
		13,
		24,
		34,
		29,
		31,
		44,
		52,
		50,
		47,
		59,
		55,
		75,
		71,
		103,
		-1,
		162,
		-1,
		83,
		-1,
		-1,
		63,
		49,
		42,
		31,
		20,
		20,
		25,
		24,
		46,
		76,
		62,
		60,
		65,
		70,
		-1,
		151,
		150,
		-1,
		82,
		74,
		60,
		-1,
		53,
		-1,
		66,
		27,
		-1,
		53,
		33,
		-1,
		71,
		67,
		-1,
		-1,
		138,
		98,
		-1,
		-1,
		-1,
		83,
		63,
		61,
		45,
		-1,
		44,
		44,
		-1,
		-1,
		-1,
		123,
		107,
		-1,
		76,
		79,
		-1,
		70,
		76,
		99,
		46,
		50,
		-1,
		-1,
		-1,
		132,
		113,
		107,
		91,
		96,
		84,
		101,
		87,
		82,
		60,
		49,
		70,
		-1,
		-1,
		-1,
		104,
		96,
		96,
		-1,
		-1,
		107,
		90,
		71,
		69,
		-1,
		-1,
		-1,
		126,
		107,
		-1,
		-1,
		97,
		-1,
		-1,
		103,
		68,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		115,
		-1,
		-1,
		-1,
		93,
		89,
		90,
		-1,
		-1,
		-1,
		-1,
		136,
		137,
		161,
		136,
		-1,
		-1,
		-1,
		85,
		79,
		-1,
		-1,
		139,
		137,
		-1,
		-1,
		-1,
		113,
		97,
		-1,
		83,
		-1,
		-1,
		-1,
		104,
		-1,
		-1,
		116,
		-1,
		-1,
		-1,
		118,
		-1,
		118,
		93,
		100,
		-1,
		-1,
		-1,
		-1,
		131,
		123,
		131,
		-1,
		103,
		105,
		-1,
		153,
		-1,
		-1,
		146,
		137,
		-1,
		-1,
		108,
		115,
		137,
		140,
		176,
		-1,
		127
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		259,
		248,
		259,
		267,
		240,
		247,
		-1,
		266,
		270,
		236,
		230,
		269,
		238,
		244,
		255,
		-1,
		-1,
		-1,
		259,
		258,
		226,
		224,
		233,
		238,
		245,
		-1,
		244,
		-1,
		280,
		259,
		270,
		275,
		219,
		216,
		236,
		255,
		237,
		229,
		295,
		249,
		220,
		214,
		232,
		222,
		231,
		223,
		-1,
		220,
		210,
		232,
		211,
		222,
		214,
		-1,
		-1,
		214,
		215,
		221,
		207,
		213,
		209,
		-1,
		219,
		203,
		-1,
		-1,
		204,
		205,
		189,
		192,
		200,
		198,
		211,
		203,
		198,
		-1,
		-1,
		195,
		191,
		198,
		185,
		181,
		198,
		211,
		193,
		207,
		206,
		-1,
		199,
		217,
		224,
		192,
		190,
		174,
		172,
		190,
		192,
		198,
		198,
		-1,
		208,
		209,
		204,
		212,
		214,
		190,
		177,
		177,
		187,
		180,
		199,
		187,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		208,
		191,
		208,
		200,
		190,
		205,
		198,
		180,
		177,
		175,
		172,
		188,
		186,
		196,
		-1,
		-1,
		301,
		270,
		299,
		257,
		238,
		-1,
		204,
		184,
		190,
		194,
		188,
		181,
		195,
		191,
		-1,
		166,
		165,
		193,
		179,
		190,
		261,
		-1,
		-1,
		259,
		251,
		234,
		237,
		214,
		210,
		199,
		198,
		190,
		176,
		172,
		178,
		181,
		181,
		187,
		160,
		170,
		174,
		172,
		197,
		-1,
		-1,
		232,
		-1,
		-1,
		258,
		241,
		-1,
		224,
		231,
		220,
		226,
		212,
		233,
		209,
		200,
		192,
		186,
		174,
		176,
		173,
		186,
		174,
		157,
		182,
		186,
		167,
		188,
		183,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		217,
		220,
		226,
		250,
		249,
		-1,
		221,
		209,
		210,
		195,
		192,
		179,
		167,
		180,
		165,
		172,
		171,
		161,
		159,
		189,
		164,
		186,
		183,
		202,
		207,
		201,
		210,
		-1,
		266,
		262,
		258,
		265,
		214,
		-1,
		-1,
		254,
		-1,
		257,
		258,
		233,
		206,
		209,
		196,
		187,
		174,
		163,
		174,
		163,
		160,
		168,
		153,
		168,
		159,
		158,
		176,
		186,
		194,
		198,
		204,
		-1,
		316,
		-1,
		258,
		242,
		244,
		216,
		237,
		-1,
		274,
		258,
		250,
		235,
		235,
		-1,
		205,
		202,
		192,
		170,
		155,
		172,
		164,
		162,
		166,
		148,
		162,
		153,
		171,
		178,
		176,
		180,
		200,
		212,
		276,
		266,
		-1,
		248,
		253,
		212,
		220,
		239,
		277,
		241,
		-1,
		236,
		-1,
		207,
		220,
		-1,
		176,
		172,
		154,
		155,
		150,
		165,
		159,
		144,
		141,
		159,
		162,
		169,
		173,
		189,
		-1,
		-1,
		261,
		265,
		254,
		205,
		224,
		248,
		285,
		234,
		223,
		222,
		-1,
		213,
		190,
		187,
		175,
		162,
		147,
		148,
		156,
		169,
		148,
		143,
		140,
		160,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		231,
		202,
		226,
		268,
		252,
		245,
		233,
		198,
		198,
		192,
		-1,
		186,
		165,
		156,
		145,
		143,
		156,
		153,
		158,
		138,
		136,
		155,
		167,
		158,
		175,
		-1,
		-1,
		-1,
		261,
		250,
		251,
		197,
		220,
		257,
		231,
		217,
		222,
		197,
		190,
		184,
		199,
		182,
		163,
		152,
		144,
		133,
		149,
		157,
		152,
		134,
		143,
		149,
		173,
		163,
		169,
		-1,
		-1,
		268,
		258,
		242,
		244,
		241,
		211,
		218,
		250,
		222,
		235,
		-1,
		189,
		-1,
		178,
		173,
		157,
		152,
		149,
		146,
		140,
		149,
		151,
		141,
		136,
		143,
		178,
		178,
		153,
		173,
		176,
		-1,
		-1,
		-1,
		261,
		256,
		231,
		208,
		192,
		228,
		-1,
		205,
		206,
		-1,
		183,
		177,
		174,
		159,
		155,
		150,
		154,
		147,
		154,
		147,
		145,
		146,
		128,
		160,
		-1,
		161,
		155,
		163,
		153,
		141,
		-1,
		-1,
		-1,
		254,
		233,
		226,
		246,
		187,
		239,
		-1,
		-1,
		190,
		183,
		-1,
		170,
		152,
		159,
		157,
		151,
		155,
		152,
		141,
		154,
		147,
		133,
		135,
		148,
		152,
		156,
		143,
		139,
		136,
		150,
		-1,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		207,
		-1,
		199,
		191,
		181,
		175,
		169,
		165,
		163,
		179,
		163,
		166,
		164,
		155,
		163,
		136,
		129,
		136,
		125,
		143,
		151,
		143,
		137,
		136,
		146,
		-1,
		274,
		260,
		231,
		-1,
		-1,
		220,
		-1,
		184,
		198,
		214,
		-1,
		207,
		186,
		201,
		179,
		175,
		171,
		186,
		187,
		164,
		164,
		162,
		153,
		141,
		130,
		133,
		125,
		147,
		147,
		131,
		132,
		136,
		-1,
		280,
		267,
		225,
		221,
		210,
		230,
		181,
		169,
		201,
		-1,
		-1,
		243,
		-1,
		177,
		194,
		185,
		183,
		176,
		158,
		165,
		173,
		150,
		145,
		135,
		124,
		124,
		119,
		141,
		127,
		125,
		134,
		150,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		196,
		183,
		177,
		-1,
		218,
		-1,
		221,
		211,
		195,
		180,
		213,
		-1,
		157,
		153,
		160,
		-1,
		170,
		-1,
		143,
		140,
		131,
		116,
		113,
		124,
		122,
		133,
		129,
		-1,
		230,
		215,
		208,
		198,
		212,
		183,
		-1,
		238,
		-1,
		-1,
		208,
		202,
		202,
		186,
		187,
		173,
		153,
		145,
		160,
		159,
		146,
		145,
		129,
		122,
		119,
		112,
		125,
		135,
		140,
		127,
		-1,
		-1,
		-1,
		235,
		221,
		225,
		185,
		204,
		-1,
		-1,
		270,
		225,
		211,
		-1,
		182,
		173,
		161,
		151,
		141,
		146,
		147,
		137,
		135,
		127,
		129,
		123,
		114,
		113,
		129,
		121,
		143,
		-1,
		-1,
		218,
		223,
		211,
		197,
		216,
		-1,
		-1,
		-1,
		217,
		233,
		201,
		180,
		162,
		-1,
		-1,
		145,
		138,
		132,
		135,
		123,
		143,
		138,
		122,
		107,
		122,
		126,
		134,
		125,
		-1,
		221,
		208,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		-1,
		-1,
		213,
		158,
		147,
		142,
		146,
		144,
		-1,
		118,
		129,
		122,
		141,
		148,
		124,
		109,
		103,
		109,
		121,
		130,
		-1,
		-1,
		233,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		170,
		164,
		135,
		128,
		132,
		-1,
		120,
		122,
		119,
		131,
		127,
		124,
		115,
		106,
		102,
		106,
		110,
		124,
		128,
		256,
		-1,
		198,
		-1,
		-1,
		-1,
		188,
		203,
		174,
		151,
		124,
		119,
		112,
		106,
		111,
		122,
		131,
		142,
		107,
		109,
		99,
		98,
		102,
		119,
		123,
		-1,
		-1,
		196,
		192,
		214,
		196,
		200,
		201,
		-1,
		-1,
		128,
		119,
		110,
		102,
		115,
		118,
		103,
		105,
		105,
		103,
		97,
		107,
		122,
		117,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		198,
		199,
		146,
		128,
		124,
		122,
		111,
		105,
		93,
		98,
		108,
		102,
		99,
		93,
		97,
		120,
		109,
		148,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		161,
		158,
		-1,
		128,
		134,
		99,
		106,
		89,
		96,
		101,
		98,
		87,
		94,
		110,
		109,
		104,
		140,
		131,
		137,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		153,
		150,
		130,
		99,
		97,
		90,
		85,
		95,
		71,
		83,
		87,
		91,
		97,
		102,
		107,
		113,
		128,
		143,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		126,
		117,
		118,
		106,
		103,
		109,
		108,
		91,
		97,
		98,
		90,
		89,
		107,
		111,
		120,
		127,
		117,
		130,
		134,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		167,
		-1,
		-1,
		139,
		151,
		135,
		125,
		122,
		165,
		120,
		115,
		96,
		94,
		89,
		80,
		105,
		98,
		98,
		101,
		116,
		121,
		113,
		127,
		127,
		128,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		129,
		-1,
		162,
		-1,
		145,
		149,
		128,
		131,
		110,
		97,
		83,
		91,
		97,
		96,
		102,
		102,
		103,
		112,
		123,
		135,
		134,
		135,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		179,
		218,
		135,
		-1,
		119,
		-1,
		-1,
		-1,
		159,
		141,
		133,
		130,
		109,
		109,
		75,
		79,
		92,
		99,
		109,
		120,
		112,
		116,
		129,
		140,
		143,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		185,
		212,
		142,
		131,
		126,
		113,
		-1,
		-1,
		143,
		151,
		-1,
		-1,
		116,
		83,
		71,
		81,
		85,
		99,
		111,
		124,
		112,
		117,
		111,
		143,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		213,
		198,
		175,
		173,
		198,
		-1,
		102,
		-1,
		-1,
		123,
		-1,
		-1,
		108,
		88,
		77,
		68,
		73,
		93,
		104,
		126,
		108,
		125,
		116,
		126,
		130,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		170,
		173,
		179,
		186,
		176,
		187,
		-1,
		-1,
		118,
		98,
		-1,
		-1,
		106,
		104,
		93,
		-1,
		83,
		65,
		70,
		100,
		102,
		104,
		111,
		105,
		112,
		120,
		131,
		123,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		-1,
		108,
		104,
		-1,
		-1,
		101,
		94,
		82,
		70,
		60,
		70,
		87,
		87,
		90,
		95,
		103,
		114,
		110,
		114,
		117,
		-1,
		246,
		-1,
		198,
		159,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		125,
		111,
		104,
		92,
		90,
		-1,
		135,
		119,
		100,
		-1,
		70,
		83,
		123,
		91,
		96,
		91,
		106,
		117,
		108,
		116,
		110,
		113,
		-1,
		-1,
		158,
		141,
		-1,
		-1,
		115,
		117,
		-1,
		116,
		105,
		90,
		82,
		-1,
		-1,
		107,
		103,
		-1,
		-1,
		57,
		95,
		94,
		102,
		97,
		102,
		114,
		110,
		106,
		116,
		107,
		-1,
		-1,
		136,
		128,
		122,
		-1,
		100,
		-1,
		118,
		-1,
		85,
		91,
		79,
		-1,
		-1,
		-1,
		88,
		51,
		67,
		90,
		116,
		114,
		105,
		98,
		105,
		108,
		101,
		107,
		-1,
		-1,
		-1,
		118,
		92,
		125,
		116,
		99,
		79,
		71,
		90,
		-1,
		69,
		-1,
		44,
		47,
		72,
		111,
		113,
		99,
		95,
		108,
		102,
		99,
		97,
		124,
		-1,
		94,
		127,
		91,
		85,
		61,
		65,
		12,
		-1,
		66,
		48,
		-1,
		76,
		66,
		114,
		89,
		98,
		91,
		85,
		86,
		94,
		-1,
		-1,
		-1,
		96,
		95,
		87,
		81,
		81,
		66,
		57,
		-1,
		0,
		18,
		39,
		56,
		56,
		47,
		55,
		104,
		100,
		103,
		101,
		79,
		-1,
		197,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		90,
		85,
		58,
		46,
		52,
		48,
		34,
		40,
		51,
		59,
		57,
		54,
		66,
		62,
		82,
		78,
		110,
		-1,
		192,
		-1,
		126,
		-1,
		-1,
		108,
		88,
		80,
		69,
		58,
		56,
		47,
		38,
		60,
		85,
		69,
		67,
		72,
		77,
		-1,
		181,
		180,
		-1,
		127,
		119,
		105,
		-1,
		98,
		-1,
		104,
		65,
		-1,
		67,
		47,
		-1,
		78,
		74,
		-1,
		-1,
		168,
		143,
		-1,
		-1,
		-1,
		128,
		108,
		99,
		83,
		-1,
		58,
		58,
		-1,
		-1,
		-1,
		153,
		152,
		-1,
		121,
		124,
		-1,
		114,
		105,
		113,
		60,
		64,
		-1,
		-1,
		-1,
		162,
		143,
		137,
		136,
		134,
		129,
		126,
		112,
		96,
		74,
		63,
		84,
		-1,
		-1,
		-1,
		134,
		126,
		119,
		-1,
		-1,
		121,
		104,
		85,
		83,
		-1,
		-1,
		-1,
		156,
		137,
		-1,
		-1,
		111,
		-1,
		-1,
		117,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		145,
		-1,
		-1,
		-1,
		107,
		103,
		104,
		-1,
		-1,
		-1,
		-1,
		167,
		168,
		191,
		155,
		-1,
		-1,
		-1,
		99,
		93,
		-1,
		-1,
		170,
		168,
		-1,
		-1,
		-1,
		127,
		111,
		-1,
		97,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		132,
		-1,
		132,
		107,
		114,
		-1,
		-1,
		-1,
		-1,
		145,
		137,
		145,
		-1,
		117,
		119,
		-1,
		167,
		-1,
		-1,
		160,
		151,
		-1,
		-1,
		122,
		129,
		151,
		154,
		190,
		-1,
		141
	],
	[
		-1,
		241,
		230,
		241,
		249,
		222,
		229,
		-1,
		248,
		252,
		218,
		212,
		251,
		220,
		226,
		237,
		-1,
		-1,
		-1,
		241,
		240,
		208,
		206,
		215,
		220,
		227,
		-1,
		226,
		-1,
		262,
		241,
		252,
		257,
		201,
		198,
		218,
		237,
		219,
		211,
		277,
		231,
		202,
		196,
		214,
		204,
		213,
		205,
		-1,
		202,
		192,
		214,
		193,
		204,
		196,
		-1,
		-1,
		196,
		197,
		203,
		189,
		195,
		191,
		-1,
		201,
		185,
		-1,
		-1,
		186,
		187,
		171,
		174,
		182,
		180,
		193,
		185,
		180,
		-1,
		-1,
		177,
		173,
		180,
		167,
		163,
		180,
		193,
		175,
		189,
		188,
		-1,
		181,
		199,
		206,
		174,
		172,
		156,
		154,
		172,
		174,
		180,
		180,
		-1,
		190,
		191,
		186,
		194,
		196,
		172,
		159,
		159,
		169,
		162,
		181,
		169,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		190,
		173,
		190,
		182,
		172,
		187,
		180,
		162,
		159,
		157,
		154,
		170,
		168,
		178,
		-1,
		-1,
		283,
		252,
		281,
		239,
		220,
		-1,
		186,
		166,
		172,
		176,
		170,
		163,
		177,
		173,
		-1,
		148,
		147,
		175,
		161,
		172,
		243,
		-1,
		-1,
		241,
		233,
		216,
		219,
		196,
		192,
		181,
		180,
		172,
		158,
		154,
		160,
		163,
		163,
		169,
		142,
		152,
		156,
		154,
		179,
		-1,
		-1,
		214,
		-1,
		-1,
		240,
		223,
		-1,
		206,
		213,
		202,
		208,
		194,
		215,
		191,
		182,
		174,
		168,
		156,
		158,
		155,
		168,
		156,
		139,
		164,
		168,
		149,
		170,
		165,
		-1,
		213,
		197,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		199,
		202,
		208,
		232,
		231,
		-1,
		203,
		191,
		192,
		177,
		174,
		161,
		149,
		162,
		147,
		154,
		153,
		143,
		141,
		171,
		146,
		168,
		165,
		184,
		189,
		183,
		192,
		-1,
		248,
		244,
		240,
		247,
		196,
		-1,
		-1,
		236,
		-1,
		239,
		240,
		215,
		188,
		191,
		178,
		169,
		156,
		145,
		156,
		145,
		142,
		150,
		135,
		150,
		141,
		140,
		158,
		168,
		176,
		180,
		186,
		-1,
		298,
		-1,
		240,
		224,
		226,
		198,
		219,
		-1,
		256,
		240,
		232,
		217,
		217,
		-1,
		187,
		184,
		174,
		152,
		137,
		154,
		146,
		144,
		148,
		130,
		144,
		135,
		153,
		160,
		158,
		162,
		182,
		194,
		258,
		248,
		-1,
		230,
		235,
		194,
		202,
		221,
		259,
		223,
		-1,
		218,
		-1,
		189,
		202,
		-1,
		158,
		154,
		136,
		137,
		132,
		147,
		141,
		126,
		123,
		141,
		144,
		151,
		155,
		171,
		-1,
		-1,
		243,
		247,
		236,
		187,
		206,
		230,
		267,
		216,
		205,
		204,
		-1,
		195,
		172,
		169,
		157,
		144,
		129,
		130,
		138,
		151,
		130,
		125,
		122,
		142,
		168,
		146,
		158,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		213,
		184,
		208,
		250,
		234,
		227,
		215,
		180,
		180,
		174,
		-1,
		168,
		147,
		138,
		127,
		125,
		138,
		135,
		140,
		120,
		118,
		137,
		149,
		140,
		157,
		-1,
		-1,
		-1,
		243,
		232,
		233,
		179,
		202,
		239,
		213,
		199,
		204,
		179,
		172,
		166,
		181,
		164,
		145,
		134,
		126,
		115,
		131,
		139,
		134,
		116,
		125,
		131,
		155,
		145,
		151,
		-1,
		-1,
		250,
		240,
		224,
		226,
		223,
		193,
		200,
		232,
		204,
		217,
		-1,
		171,
		-1,
		160,
		155,
		139,
		134,
		131,
		128,
		122,
		131,
		133,
		123,
		118,
		125,
		160,
		160,
		135,
		155,
		158,
		-1,
		-1,
		-1,
		243,
		238,
		213,
		190,
		174,
		210,
		-1,
		187,
		188,
		-1,
		165,
		159,
		156,
		141,
		137,
		132,
		136,
		129,
		136,
		129,
		127,
		128,
		110,
		142,
		-1,
		143,
		137,
		145,
		135,
		123,
		-1,
		-1,
		-1,
		236,
		215,
		208,
		228,
		169,
		221,
		-1,
		-1,
		172,
		165,
		-1,
		152,
		134,
		141,
		139,
		133,
		137,
		134,
		123,
		136,
		129,
		115,
		117,
		130,
		134,
		138,
		125,
		121,
		118,
		132,
		-1,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		189,
		-1,
		181,
		173,
		163,
		157,
		151,
		147,
		145,
		161,
		145,
		148,
		146,
		137,
		145,
		118,
		111,
		118,
		107,
		125,
		133,
		125,
		119,
		118,
		128,
		-1,
		256,
		242,
		213,
		-1,
		-1,
		202,
		-1,
		166,
		180,
		196,
		-1,
		189,
		168,
		183,
		161,
		157,
		153,
		168,
		169,
		146,
		146,
		144,
		135,
		123,
		112,
		115,
		107,
		129,
		129,
		113,
		114,
		118,
		-1,
		262,
		249,
		207,
		203,
		192,
		212,
		163,
		151,
		183,
		-1,
		-1,
		225,
		-1,
		159,
		176,
		167,
		165,
		158,
		140,
		147,
		155,
		132,
		127,
		117,
		106,
		106,
		101,
		123,
		109,
		107,
		116,
		132,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		178,
		165,
		159,
		-1,
		200,
		-1,
		203,
		193,
		177,
		162,
		195,
		-1,
		139,
		135,
		142,
		-1,
		152,
		-1,
		125,
		122,
		113,
		98,
		95,
		106,
		104,
		115,
		111,
		-1,
		212,
		197,
		190,
		180,
		194,
		165,
		-1,
		220,
		-1,
		-1,
		190,
		184,
		184,
		168,
		169,
		155,
		135,
		127,
		142,
		141,
		128,
		127,
		111,
		104,
		101,
		94,
		107,
		117,
		122,
		109,
		-1,
		-1,
		-1,
		217,
		203,
		207,
		167,
		186,
		-1,
		-1,
		252,
		207,
		193,
		-1,
		164,
		155,
		143,
		133,
		123,
		128,
		129,
		119,
		117,
		109,
		111,
		105,
		96,
		95,
		111,
		103,
		125,
		-1,
		-1,
		200,
		205,
		193,
		179,
		198,
		-1,
		-1,
		-1,
		199,
		215,
		183,
		162,
		144,
		-1,
		-1,
		127,
		120,
		114,
		117,
		105,
		125,
		120,
		104,
		89,
		104,
		108,
		116,
		107,
		-1,
		203,
		190,
		-1,
		-1,
		201,
		195,
		-1,
		-1,
		-1,
		-1,
		195,
		140,
		129,
		124,
		128,
		126,
		-1,
		100,
		111,
		104,
		123,
		130,
		106,
		91,
		85,
		91,
		103,
		112,
		-1,
		-1,
		215,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		152,
		146,
		117,
		110,
		114,
		-1,
		102,
		104,
		101,
		113,
		109,
		106,
		97,
		88,
		84,
		88,
		92,
		106,
		110,
		238,
		-1,
		180,
		-1,
		-1,
		-1,
		170,
		185,
		156,
		133,
		106,
		101,
		94,
		88,
		93,
		104,
		113,
		124,
		89,
		91,
		81,
		80,
		84,
		101,
		105,
		-1,
		-1,
		178,
		174,
		196,
		178,
		182,
		183,
		-1,
		-1,
		110,
		101,
		92,
		84,
		97,
		100,
		85,
		87,
		87,
		85,
		79,
		89,
		104,
		99,
		-1,
		-1,
		-1,
		190,
		-1,
		192,
		-1,
		-1,
		180,
		181,
		128,
		110,
		106,
		104,
		93,
		87,
		75,
		80,
		90,
		84,
		81,
		75,
		79,
		102,
		91,
		130,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		169,
		161,
		156,
		162,
		164,
		155,
		143,
		140,
		-1,
		110,
		116,
		81,
		88,
		71,
		78,
		83,
		80,
		69,
		76,
		92,
		91,
		86,
		122,
		113,
		119,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		162,
		158,
		148,
		138,
		141,
		-1,
		-1,
		135,
		132,
		112,
		81,
		79,
		72,
		67,
		77,
		53,
		65,
		69,
		73,
		79,
		84,
		89,
		95,
		110,
		125,
		-1,
		205,
		242,
		235,
		203,
		211,
		242,
		-1,
		152,
		144,
		155,
		130,
		132,
		-1,
		-1,
		108,
		99,
		100,
		88,
		85,
		91,
		90,
		73,
		79,
		80,
		72,
		71,
		89,
		93,
		102,
		109,
		99,
		112,
		116,
		-1,
		198,
		218,
		197,
		200,
		224,
		238,
		-1,
		149,
		-1,
		-1,
		121,
		133,
		117,
		107,
		104,
		147,
		102,
		97,
		78,
		76,
		71,
		62,
		87,
		80,
		80,
		83,
		98,
		103,
		95,
		109,
		109,
		110,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		-1,
		111,
		-1,
		144,
		-1,
		127,
		131,
		110,
		113,
		92,
		79,
		65,
		73,
		79,
		78,
		84,
		84,
		85,
		94,
		105,
		117,
		116,
		117,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		161,
		200,
		117,
		-1,
		101,
		-1,
		-1,
		-1,
		141,
		123,
		115,
		112,
		91,
		91,
		57,
		61,
		74,
		81,
		91,
		102,
		94,
		98,
		111,
		122,
		125,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		172,
		167,
		194,
		124,
		113,
		108,
		95,
		-1,
		-1,
		125,
		133,
		-1,
		-1,
		98,
		65,
		53,
		63,
		67,
		81,
		93,
		106,
		94,
		99,
		93,
		125,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		170,
		195,
		180,
		157,
		155,
		180,
		-1,
		84,
		-1,
		-1,
		105,
		-1,
		-1,
		90,
		70,
		59,
		50,
		55,
		75,
		86,
		108,
		90,
		107,
		98,
		108,
		112,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		152,
		155,
		161,
		168,
		158,
		169,
		-1,
		-1,
		100,
		80,
		-1,
		-1,
		88,
		86,
		75,
		-1,
		65,
		47,
		52,
		82,
		84,
		86,
		93,
		87,
		94,
		102,
		113,
		105,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		105,
		-1,
		90,
		86,
		-1,
		-1,
		83,
		76,
		64,
		52,
		42,
		52,
		69,
		69,
		72,
		77,
		85,
		96,
		92,
		96,
		99,
		-1,
		228,
		-1,
		180,
		141,
		147,
		162,
		170,
		-1,
		-1,
		-1,
		107,
		93,
		86,
		74,
		72,
		-1,
		117,
		101,
		82,
		-1,
		52,
		65,
		105,
		73,
		78,
		73,
		88,
		99,
		90,
		98,
		92,
		95,
		-1,
		-1,
		140,
		123,
		-1,
		-1,
		97,
		99,
		-1,
		98,
		87,
		72,
		64,
		-1,
		-1,
		89,
		85,
		-1,
		-1,
		39,
		77,
		76,
		84,
		79,
		84,
		96,
		92,
		88,
		98,
		89,
		-1,
		-1,
		118,
		110,
		104,
		-1,
		82,
		-1,
		100,
		-1,
		67,
		73,
		61,
		-1,
		-1,
		-1,
		70,
		33,
		49,
		72,
		98,
		96,
		87,
		80,
		87,
		90,
		83,
		89,
		-1,
		-1,
		-1,
		100,
		74,
		107,
		98,
		81,
		61,
		53,
		72,
		-1,
		51,
		-1,
		26,
		29,
		54,
		93,
		95,
		81,
		77,
		90,
		84,
		81,
		79,
		106,
		-1,
		76,
		109,
		73,
		67,
		43,
		47,
		31,
		-1,
		48,
		30,
		-1,
		58,
		48,
		96,
		71,
		80,
		73,
		67,
		68,
		76,
		-1,
		-1,
		-1,
		78,
		77,
		69,
		63,
		63,
		48,
		39,
		-1,
		19,
		0,
		21,
		38,
		38,
		29,
		37,
		86,
		82,
		85,
		83,
		61,
		-1,
		179,
		-1,
		-1,
		101,
		-1,
		-1,
		-1,
		72,
		67,
		40,
		28,
		34,
		30,
		16,
		22,
		33,
		41,
		39,
		36,
		48,
		44,
		64,
		60,
		92,
		-1,
		174,
		-1,
		108,
		-1,
		-1,
		90,
		70,
		62,
		51,
		40,
		38,
		29,
		20,
		42,
		67,
		51,
		49,
		54,
		59,
		-1,
		163,
		162,
		-1,
		109,
		101,
		87,
		-1,
		80,
		-1,
		86,
		47,
		-1,
		49,
		29,
		-1,
		60,
		56,
		-1,
		-1,
		150,
		125,
		-1,
		-1,
		-1,
		110,
		90,
		81,
		65,
		-1,
		40,
		40,
		-1,
		-1,
		-1,
		135,
		134,
		-1,
		103,
		106,
		-1,
		96,
		87,
		95,
		42,
		46,
		-1,
		-1,
		-1,
		144,
		125,
		119,
		118,
		116,
		111,
		108,
		94,
		78,
		56,
		45,
		66,
		-1,
		-1,
		-1,
		116,
		108,
		101,
		-1,
		-1,
		103,
		86,
		67,
		65,
		-1,
		-1,
		-1,
		138,
		119,
		-1,
		-1,
		93,
		-1,
		-1,
		99,
		64,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		127,
		-1,
		-1,
		-1,
		89,
		85,
		86,
		-1,
		-1,
		-1,
		-1,
		149,
		150,
		173,
		137,
		-1,
		-1,
		-1,
		81,
		75,
		-1,
		-1,
		152,
		150,
		-1,
		-1,
		-1,
		109,
		93,
		-1,
		79,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		112,
		-1,
		-1,
		-1,
		114,
		-1,
		114,
		89,
		96,
		-1,
		-1,
		-1,
		-1,
		127,
		119,
		127,
		-1,
		99,
		101,
		-1,
		149,
		-1,
		-1,
		142,
		133,
		-1,
		-1,
		104,
		111,
		133,
		136,
		172,
		-1,
		123
	],
	[
		-1,
		220,
		209,
		220,
		228,
		201,
		208,
		-1,
		227,
		231,
		197,
		191,
		230,
		199,
		205,
		216,
		-1,
		-1,
		-1,
		220,
		219,
		187,
		185,
		194,
		199,
		206,
		-1,
		205,
		-1,
		241,
		220,
		231,
		236,
		180,
		177,
		197,
		216,
		198,
		190,
		256,
		210,
		181,
		175,
		193,
		183,
		192,
		184,
		-1,
		181,
		171,
		193,
		172,
		183,
		175,
		-1,
		-1,
		175,
		176,
		182,
		168,
		174,
		170,
		-1,
		180,
		164,
		-1,
		-1,
		165,
		166,
		150,
		153,
		161,
		159,
		172,
		164,
		159,
		-1,
		-1,
		156,
		152,
		159,
		146,
		142,
		159,
		172,
		154,
		168,
		167,
		-1,
		160,
		178,
		185,
		153,
		151,
		135,
		133,
		151,
		153,
		159,
		159,
		-1,
		169,
		170,
		165,
		173,
		175,
		151,
		138,
		138,
		148,
		141,
		160,
		148,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		203,
		169,
		152,
		169,
		161,
		151,
		166,
		159,
		141,
		138,
		136,
		133,
		149,
		147,
		157,
		-1,
		-1,
		262,
		231,
		260,
		218,
		199,
		-1,
		165,
		145,
		151,
		155,
		149,
		142,
		156,
		152,
		-1,
		127,
		126,
		154,
		140,
		151,
		222,
		-1,
		-1,
		220,
		212,
		195,
		198,
		175,
		171,
		160,
		159,
		151,
		137,
		133,
		139,
		142,
		142,
		148,
		121,
		131,
		135,
		133,
		158,
		-1,
		-1,
		193,
		-1,
		-1,
		219,
		202,
		-1,
		185,
		192,
		181,
		187,
		173,
		194,
		170,
		161,
		153,
		147,
		135,
		137,
		134,
		147,
		135,
		118,
		143,
		147,
		128,
		149,
		144,
		-1,
		192,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		178,
		181,
		187,
		211,
		210,
		-1,
		182,
		170,
		171,
		156,
		153,
		140,
		128,
		141,
		126,
		133,
		132,
		122,
		120,
		150,
		125,
		147,
		144,
		163,
		168,
		162,
		171,
		-1,
		227,
		223,
		219,
		226,
		175,
		-1,
		-1,
		215,
		-1,
		218,
		219,
		194,
		167,
		170,
		157,
		148,
		135,
		124,
		135,
		124,
		121,
		129,
		114,
		129,
		120,
		119,
		137,
		147,
		155,
		159,
		165,
		-1,
		277,
		-1,
		219,
		203,
		205,
		177,
		198,
		-1,
		235,
		219,
		211,
		196,
		196,
		-1,
		166,
		163,
		153,
		131,
		116,
		133,
		125,
		123,
		127,
		109,
		123,
		114,
		132,
		139,
		137,
		141,
		161,
		173,
		237,
		227,
		-1,
		209,
		214,
		173,
		181,
		200,
		238,
		202,
		-1,
		197,
		-1,
		168,
		181,
		-1,
		137,
		133,
		115,
		116,
		111,
		126,
		120,
		105,
		102,
		120,
		123,
		130,
		134,
		150,
		-1,
		-1,
		222,
		226,
		215,
		166,
		185,
		209,
		246,
		195,
		184,
		183,
		-1,
		174,
		151,
		148,
		136,
		123,
		108,
		109,
		117,
		130,
		109,
		104,
		101,
		121,
		147,
		125,
		137,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		192,
		163,
		187,
		229,
		213,
		206,
		194,
		159,
		159,
		153,
		-1,
		147,
		126,
		117,
		106,
		104,
		117,
		114,
		119,
		99,
		97,
		116,
		128,
		119,
		136,
		-1,
		-1,
		-1,
		222,
		211,
		212,
		158,
		181,
		218,
		192,
		178,
		183,
		158,
		151,
		145,
		160,
		143,
		124,
		113,
		105,
		94,
		110,
		118,
		113,
		95,
		104,
		110,
		134,
		124,
		130,
		-1,
		-1,
		229,
		219,
		203,
		205,
		202,
		172,
		179,
		211,
		183,
		196,
		-1,
		150,
		-1,
		139,
		134,
		118,
		113,
		110,
		107,
		101,
		110,
		112,
		102,
		97,
		104,
		139,
		139,
		114,
		134,
		137,
		-1,
		-1,
		-1,
		222,
		217,
		192,
		169,
		153,
		189,
		-1,
		166,
		167,
		-1,
		144,
		138,
		135,
		120,
		116,
		111,
		115,
		108,
		115,
		108,
		106,
		107,
		89,
		121,
		-1,
		122,
		116,
		124,
		114,
		102,
		-1,
		-1,
		-1,
		215,
		194,
		187,
		207,
		148,
		200,
		-1,
		-1,
		151,
		144,
		-1,
		131,
		113,
		120,
		118,
		112,
		116,
		113,
		102,
		115,
		108,
		94,
		96,
		109,
		113,
		117,
		104,
		100,
		97,
		111,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		168,
		-1,
		160,
		152,
		142,
		136,
		130,
		126,
		124,
		140,
		124,
		127,
		125,
		116,
		124,
		97,
		90,
		97,
		86,
		104,
		112,
		104,
		98,
		97,
		107,
		-1,
		235,
		221,
		192,
		-1,
		-1,
		181,
		-1,
		145,
		159,
		175,
		-1,
		168,
		147,
		162,
		140,
		136,
		132,
		147,
		148,
		125,
		125,
		123,
		114,
		102,
		91,
		94,
		86,
		108,
		108,
		92,
		93,
		97,
		-1,
		241,
		228,
		186,
		182,
		171,
		191,
		142,
		130,
		162,
		-1,
		-1,
		204,
		-1,
		138,
		155,
		146,
		144,
		137,
		119,
		126,
		134,
		111,
		106,
		96,
		85,
		85,
		80,
		102,
		88,
		86,
		95,
		111,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		157,
		144,
		138,
		-1,
		179,
		-1,
		182,
		172,
		156,
		141,
		174,
		-1,
		118,
		114,
		121,
		-1,
		131,
		-1,
		104,
		101,
		92,
		77,
		74,
		85,
		83,
		94,
		90,
		-1,
		191,
		176,
		169,
		159,
		173,
		144,
		-1,
		199,
		-1,
		-1,
		169,
		163,
		163,
		147,
		148,
		134,
		114,
		106,
		121,
		120,
		107,
		106,
		90,
		83,
		80,
		73,
		86,
		96,
		101,
		88,
		-1,
		-1,
		-1,
		196,
		182,
		186,
		146,
		165,
		-1,
		-1,
		231,
		186,
		172,
		-1,
		143,
		134,
		122,
		112,
		102,
		107,
		108,
		98,
		96,
		88,
		90,
		84,
		75,
		74,
		90,
		82,
		104,
		-1,
		-1,
		179,
		184,
		172,
		158,
		177,
		-1,
		-1,
		-1,
		178,
		194,
		162,
		141,
		123,
		-1,
		-1,
		106,
		99,
		93,
		96,
		84,
		104,
		99,
		83,
		68,
		83,
		87,
		95,
		86,
		-1,
		182,
		169,
		-1,
		-1,
		180,
		174,
		-1,
		-1,
		-1,
		-1,
		174,
		119,
		108,
		103,
		107,
		105,
		-1,
		79,
		90,
		83,
		102,
		109,
		85,
		70,
		64,
		70,
		82,
		91,
		-1,
		-1,
		194,
		-1,
		168,
		-1,
		-1,
		-1,
		-1,
		131,
		125,
		96,
		89,
		93,
		-1,
		81,
		83,
		80,
		92,
		88,
		85,
		76,
		67,
		63,
		67,
		71,
		85,
		89,
		217,
		-1,
		159,
		-1,
		-1,
		-1,
		149,
		164,
		135,
		112,
		85,
		80,
		73,
		67,
		72,
		83,
		92,
		103,
		68,
		70,
		60,
		59,
		63,
		80,
		84,
		-1,
		-1,
		157,
		153,
		175,
		157,
		161,
		162,
		-1,
		-1,
		89,
		80,
		71,
		63,
		76,
		79,
		64,
		66,
		66,
		64,
		58,
		68,
		83,
		78,
		-1,
		-1,
		-1,
		169,
		-1,
		171,
		-1,
		-1,
		159,
		160,
		107,
		89,
		85,
		83,
		72,
		66,
		54,
		59,
		69,
		63,
		60,
		54,
		58,
		81,
		70,
		109,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		148,
		140,
		135,
		141,
		143,
		134,
		122,
		119,
		-1,
		89,
		95,
		60,
		67,
		50,
		57,
		62,
		59,
		48,
		55,
		71,
		70,
		65,
		101,
		92,
		98,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		141,
		137,
		127,
		117,
		120,
		-1,
		-1,
		114,
		111,
		91,
		60,
		58,
		51,
		46,
		56,
		32,
		44,
		48,
		52,
		58,
		63,
		68,
		74,
		89,
		104,
		-1,
		188,
		225,
		218,
		186,
		194,
		225,
		-1,
		131,
		123,
		134,
		109,
		111,
		-1,
		-1,
		87,
		78,
		79,
		67,
		64,
		70,
		69,
		52,
		58,
		59,
		51,
		50,
		68,
		72,
		81,
		88,
		78,
		91,
		95,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		128,
		-1,
		-1,
		109,
		112,
		96,
		86,
		83,
		126,
		81,
		76,
		57,
		55,
		50,
		41,
		66,
		59,
		59,
		62,
		77,
		82,
		74,
		88,
		88,
		89,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		99,
		-1,
		123,
		-1,
		106,
		110,
		89,
		92,
		71,
		58,
		44,
		52,
		58,
		57,
		63,
		63,
		64,
		73,
		84,
		96,
		95,
		96,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		140,
		179,
		105,
		-1,
		89,
		-1,
		-1,
		-1,
		120,
		102,
		94,
		91,
		70,
		70,
		36,
		40,
		53,
		60,
		70,
		81,
		73,
		77,
		90,
		101,
		104,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		155,
		146,
		173,
		112,
		101,
		96,
		83,
		-1,
		-1,
		104,
		112,
		-1,
		-1,
		77,
		44,
		32,
		42,
		46,
		60,
		72,
		85,
		73,
		78,
		72,
		104,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		174,
		164,
		145,
		143,
		168,
		-1,
		72,
		-1,
		-1,
		84,
		-1,
		-1,
		69,
		49,
		38,
		29,
		34,
		54,
		65,
		87,
		69,
		86,
		77,
		87,
		91,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		140,
		138,
		144,
		151,
		146,
		157,
		-1,
		-1,
		88,
		68,
		-1,
		-1,
		67,
		65,
		54,
		-1,
		44,
		26,
		31,
		61,
		63,
		65,
		72,
		66,
		73,
		81,
		92,
		84,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		-1,
		78,
		74,
		-1,
		-1,
		62,
		55,
		43,
		31,
		21,
		31,
		48,
		48,
		51,
		56,
		64,
		75,
		71,
		75,
		78,
		-1,
		211,
		-1,
		163,
		129,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		95,
		81,
		74,
		62,
		60,
		-1,
		96,
		80,
		61,
		-1,
		31,
		44,
		84,
		52,
		57,
		52,
		67,
		78,
		69,
		77,
		71,
		74,
		-1,
		-1,
		128,
		111,
		-1,
		-1,
		85,
		87,
		-1,
		86,
		75,
		60,
		52,
		-1,
		-1,
		68,
		64,
		-1,
		-1,
		18,
		56,
		55,
		63,
		58,
		63,
		75,
		71,
		67,
		77,
		68,
		-1,
		-1,
		106,
		98,
		92,
		-1,
		70,
		-1,
		88,
		-1,
		55,
		61,
		49,
		-1,
		-1,
		-1,
		49,
		12,
		28,
		51,
		77,
		75,
		66,
		59,
		66,
		69,
		62,
		68,
		-1,
		-1,
		-1,
		88,
		62,
		95,
		86,
		69,
		49,
		41,
		60,
		-1,
		30,
		-1,
		5,
		8,
		33,
		72,
		74,
		60,
		56,
		69,
		63,
		60,
		58,
		94,
		-1,
		64,
		97,
		61,
		55,
		31,
		35,
		51,
		-1,
		27,
		9,
		-1,
		37,
		27,
		75,
		50,
		59,
		52,
		46,
		47,
		55,
		-1,
		-1,
		-1,
		66,
		65,
		57,
		51,
		51,
		36,
		27,
		-1,
		39,
		21,
		0,
		17,
		17,
		8,
		16,
		65,
		61,
		64,
		62,
		40,
		-1,
		167,
		-1,
		-1,
		89,
		-1,
		-1,
		-1,
		60,
		55,
		28,
		16,
		22,
		18,
		4,
		10,
		12,
		20,
		18,
		15,
		27,
		23,
		43,
		39,
		71,
		-1,
		162,
		-1,
		96,
		-1,
		-1,
		78,
		58,
		50,
		39,
		28,
		26,
		17,
		8,
		30,
		46,
		30,
		28,
		33,
		38,
		-1,
		151,
		150,
		-1,
		97,
		89,
		75,
		-1,
		68,
		-1,
		74,
		35,
		-1,
		37,
		17,
		-1,
		39,
		35,
		-1,
		-1,
		138,
		113,
		-1,
		-1,
		-1,
		98,
		78,
		69,
		53,
		-1,
		28,
		28,
		-1,
		-1,
		-1,
		123,
		122,
		-1,
		91,
		94,
		-1,
		84,
		75,
		83,
		30,
		34,
		-1,
		-1,
		-1,
		132,
		113,
		107,
		106,
		104,
		99,
		96,
		82,
		66,
		44,
		33,
		54,
		-1,
		-1,
		-1,
		104,
		96,
		89,
		-1,
		-1,
		91,
		74,
		55,
		53,
		-1,
		-1,
		-1,
		126,
		107,
		-1,
		-1,
		81,
		-1,
		-1,
		87,
		52,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		115,
		-1,
		-1,
		-1,
		77,
		73,
		74,
		-1,
		-1,
		-1,
		-1,
		137,
		138,
		161,
		125,
		-1,
		-1,
		-1,
		69,
		63,
		-1,
		-1,
		140,
		138,
		-1,
		-1,
		-1,
		97,
		81,
		-1,
		67,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		100,
		-1,
		-1,
		-1,
		102,
		-1,
		102,
		77,
		84,
		-1,
		-1,
		-1,
		-1,
		115,
		107,
		115,
		-1,
		87,
		89,
		-1,
		137,
		-1,
		-1,
		130,
		121,
		-1,
		-1,
		92,
		99,
		121,
		124,
		160,
		-1,
		111
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		145,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		139,
		146,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		131,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		138,
		134,
		141,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		168,
		154,
		134,
		126,
		141,
		140,
		127,
		126,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		163,
		154,
		142,
		132,
		122,
		127,
		128,
		118,
		116,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		182,
		161,
		143,
		-1,
		-1,
		126,
		119,
		113,
		116,
		104,
		124,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		194,
		139,
		128,
		123,
		127,
		125,
		-1,
		99,
		110,
		103,
		122,
		129,
		105,
		90,
		84,
		90,
		102,
		111,
		-1,
		-1,
		214,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		116,
		109,
		113,
		-1,
		101,
		103,
		100,
		112,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		105,
		109,
		237,
		-1,
		179,
		-1,
		-1,
		-1,
		169,
		184,
		155,
		132,
		105,
		100,
		93,
		87,
		92,
		103,
		112,
		123,
		88,
		90,
		80,
		79,
		83,
		100,
		104,
		-1,
		-1,
		177,
		173,
		195,
		177,
		181,
		182,
		-1,
		-1,
		109,
		100,
		91,
		83,
		96,
		99,
		84,
		86,
		86,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		189,
		-1,
		191,
		-1,
		-1,
		179,
		180,
		127,
		109,
		105,
		103,
		92,
		86,
		74,
		79,
		89,
		83,
		80,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		142,
		139,
		-1,
		109,
		115,
		80,
		87,
		70,
		77,
		82,
		79,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		134,
		131,
		111,
		80,
		78,
		71,
		66,
		76,
		52,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		208,
		245,
		238,
		206,
		214,
		245,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		107,
		98,
		99,
		87,
		84,
		90,
		89,
		72,
		78,
		79,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		148,
		-1,
		-1,
		129,
		132,
		116,
		106,
		103,
		146,
		101,
		96,
		77,
		75,
		70,
		61,
		86,
		79,
		79,
		82,
		97,
		102,
		94,
		108,
		108,
		109,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		119,
		-1,
		143,
		-1,
		126,
		130,
		109,
		112,
		91,
		78,
		64,
		72,
		78,
		77,
		83,
		83,
		84,
		93,
		104,
		116,
		115,
		116,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		160,
		199,
		125,
		-1,
		109,
		-1,
		-1,
		-1,
		140,
		122,
		114,
		111,
		90,
		90,
		56,
		60,
		73,
		80,
		90,
		101,
		93,
		97,
		110,
		121,
		124,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		175,
		166,
		193,
		132,
		121,
		116,
		103,
		-1,
		-1,
		124,
		132,
		-1,
		-1,
		97,
		64,
		52,
		62,
		66,
		80,
		92,
		105,
		93,
		98,
		92,
		122,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		194,
		184,
		165,
		163,
		188,
		-1,
		92,
		-1,
		-1,
		104,
		-1,
		-1,
		89,
		69,
		58,
		49,
		54,
		74,
		85,
		107,
		89,
		106,
		97,
		107,
		107,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		166,
		177,
		-1,
		-1,
		108,
		88,
		-1,
		-1,
		87,
		85,
		74,
		-1,
		64,
		46,
		51,
		81,
		83,
		85,
		92,
		86,
		93,
		97,
		108,
		100,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		98,
		94,
		-1,
		-1,
		82,
		75,
		63,
		51,
		41,
		51,
		68,
		68,
		71,
		76,
		84,
		95,
		87,
		91,
		94,
		-1,
		231,
		-1,
		183,
		149,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		115,
		101,
		94,
		82,
		80,
		-1,
		116,
		100,
		81,
		-1,
		51,
		64,
		104,
		72,
		77,
		72,
		83,
		94,
		85,
		93,
		87,
		90,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		106,
		95,
		80,
		72,
		-1,
		-1,
		88,
		84,
		-1,
		-1,
		38,
		63,
		75,
		83,
		78,
		79,
		91,
		87,
		83,
		93,
		84,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		108,
		-1,
		75,
		81,
		69,
		-1,
		-1,
		-1,
		69,
		32,
		48,
		58,
		93,
		91,
		82,
		75,
		82,
		85,
		78,
		84,
		-1,
		-1,
		-1,
		108,
		82,
		115,
		106,
		89,
		69,
		61,
		80,
		-1,
		43,
		-1,
		25,
		28,
		40,
		90,
		90,
		76,
		72,
		85,
		79,
		76,
		74,
		114,
		-1,
		84,
		117,
		81,
		75,
		51,
		55,
		71,
		-1,
		40,
		23,
		-1,
		44,
		34,
		91,
		66,
		75,
		68,
		62,
		63,
		71,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		71,
		56,
		47,
		-1,
		59,
		41,
		20,
		0,
		19,
		24,
		32,
		81,
		77,
		80,
		78,
		56,
		-1,
		187,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		75,
		48,
		36,
		42,
		38,
		24,
		22,
		7,
		30,
		34,
		31,
		43,
		39,
		59,
		55,
		87,
		-1,
		182,
		-1,
		116,
		-1,
		-1,
		98,
		78,
		70,
		59,
		48,
		46,
		37,
		28,
		50,
		45,
		46,
		44,
		49,
		54,
		-1,
		171,
		170,
		-1,
		117,
		109,
		95,
		-1,
		88,
		-1,
		94,
		55,
		-1,
		57,
		37,
		-1,
		55,
		51,
		-1,
		-1,
		158,
		133,
		-1,
		-1,
		-1,
		118,
		98,
		89,
		73,
		-1,
		48,
		48,
		-1,
		-1,
		-1,
		143,
		142,
		-1,
		111,
		114,
		-1,
		104,
		95,
		103,
		50,
		54,
		-1,
		-1,
		-1,
		152,
		133,
		127,
		126,
		124,
		119,
		116,
		102,
		86,
		64,
		53,
		74,
		-1,
		-1,
		-1,
		124,
		116,
		109,
		-1,
		-1,
		111,
		94,
		75,
		73,
		-1,
		-1,
		-1,
		146,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		107,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		135,
		-1,
		-1,
		-1,
		97,
		93,
		94,
		-1,
		-1,
		-1,
		-1,
		157,
		158,
		181,
		145,
		-1,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		160,
		158,
		-1,
		-1,
		-1,
		117,
		101,
		-1,
		87,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		122,
		-1,
		122,
		97,
		104,
		-1,
		-1,
		-1,
		-1,
		135,
		127,
		135,
		-1,
		107,
		109,
		-1,
		157,
		-1,
		-1,
		150,
		141,
		-1,
		-1,
		112,
		119,
		141,
		144,
		180,
		-1,
		131
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		145,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		139,
		146,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		131,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		138,
		134,
		141,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		168,
		154,
		134,
		126,
		141,
		140,
		127,
		126,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		163,
		154,
		142,
		132,
		122,
		127,
		128,
		118,
		116,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		182,
		161,
		143,
		-1,
		-1,
		126,
		119,
		113,
		116,
		104,
		124,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		194,
		139,
		128,
		123,
		127,
		125,
		-1,
		99,
		110,
		103,
		122,
		129,
		105,
		90,
		84,
		90,
		102,
		111,
		-1,
		-1,
		214,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		116,
		109,
		113,
		-1,
		101,
		103,
		100,
		112,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		105,
		109,
		237,
		-1,
		179,
		-1,
		-1,
		-1,
		169,
		184,
		155,
		132,
		105,
		100,
		93,
		87,
		92,
		103,
		112,
		123,
		88,
		90,
		80,
		79,
		83,
		100,
		104,
		-1,
		-1,
		177,
		173,
		195,
		177,
		181,
		182,
		-1,
		-1,
		109,
		100,
		91,
		83,
		96,
		99,
		84,
		86,
		86,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		189,
		-1,
		191,
		-1,
		-1,
		179,
		180,
		127,
		109,
		105,
		103,
		92,
		86,
		74,
		79,
		89,
		83,
		80,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		142,
		139,
		-1,
		109,
		115,
		80,
		87,
		70,
		77,
		82,
		79,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		134,
		131,
		111,
		80,
		78,
		71,
		66,
		76,
		52,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		208,
		245,
		238,
		206,
		214,
		245,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		107,
		98,
		99,
		87,
		84,
		90,
		89,
		72,
		78,
		79,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		148,
		-1,
		-1,
		129,
		132,
		116,
		106,
		103,
		146,
		101,
		96,
		77,
		75,
		70,
		61,
		86,
		79,
		79,
		82,
		97,
		102,
		94,
		108,
		108,
		105,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		119,
		-1,
		143,
		-1,
		126,
		130,
		109,
		112,
		91,
		78,
		64,
		72,
		78,
		77,
		83,
		83,
		84,
		93,
		104,
		109,
		115,
		116,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		160,
		199,
		125,
		-1,
		109,
		-1,
		-1,
		-1,
		140,
		122,
		114,
		111,
		90,
		90,
		56,
		60,
		73,
		80,
		90,
		101,
		93,
		92,
		103,
		114,
		113,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		175,
		166,
		193,
		132,
		121,
		116,
		103,
		-1,
		-1,
		124,
		132,
		-1,
		-1,
		97,
		64,
		52,
		62,
		66,
		80,
		92,
		105,
		85,
		91,
		85,
		109,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		194,
		184,
		165,
		163,
		188,
		-1,
		92,
		-1,
		-1,
		104,
		-1,
		-1,
		89,
		69,
		58,
		49,
		54,
		74,
		85,
		107,
		81,
		97,
		90,
		97,
		94,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		166,
		177,
		-1,
		-1,
		108,
		88,
		-1,
		-1,
		87,
		85,
		74,
		-1,
		64,
		46,
		51,
		81,
		83,
		85,
		84,
		78,
		85,
		84,
		95,
		87,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		98,
		94,
		-1,
		-1,
		82,
		75,
		63,
		51,
		41,
		51,
		68,
		68,
		71,
		76,
		76,
		87,
		74,
		78,
		81,
		-1,
		231,
		-1,
		183,
		149,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		115,
		101,
		94,
		82,
		80,
		-1,
		116,
		100,
		81,
		-1,
		51,
		64,
		102,
		72,
		77,
		72,
		70,
		81,
		72,
		80,
		74,
		77,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		106,
		95,
		80,
		72,
		-1,
		-1,
		88,
		84,
		-1,
		-1,
		38,
		53,
		71,
		83,
		78,
		66,
		78,
		74,
		70,
		80,
		71,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		108,
		-1,
		75,
		81,
		69,
		-1,
		-1,
		-1,
		69,
		32,
		48,
		48,
		80,
		78,
		69,
		62,
		69,
		72,
		65,
		71,
		-1,
		-1,
		-1,
		108,
		82,
		115,
		106,
		89,
		69,
		61,
		80,
		-1,
		50,
		-1,
		25,
		28,
		30,
		80,
		77,
		63,
		59,
		72,
		66,
		63,
		61,
		114,
		-1,
		84,
		117,
		81,
		75,
		51,
		55,
		71,
		-1,
		47,
		29,
		-1,
		34,
		24,
		78,
		53,
		62,
		55,
		49,
		50,
		58,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		71,
		56,
		47,
		-1,
		59,
		41,
		20,
		20,
		0,
		11,
		19,
		68,
		64,
		67,
		65,
		43,
		-1,
		187,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		75,
		48,
		36,
		42,
		38,
		24,
		30,
		15,
		17,
		21,
		18,
		30,
		26,
		46,
		42,
		74,
		-1,
		182,
		-1,
		116,
		-1,
		-1,
		98,
		78,
		70,
		59,
		48,
		46,
		37,
		28,
		50,
		48,
		33,
		31,
		36,
		41,
		-1,
		171,
		170,
		-1,
		117,
		109,
		95,
		-1,
		88,
		-1,
		94,
		55,
		-1,
		57,
		37,
		-1,
		42,
		38,
		-1,
		-1,
		158,
		133,
		-1,
		-1,
		-1,
		118,
		98,
		89,
		73,
		-1,
		48,
		48,
		-1,
		-1,
		-1,
		143,
		142,
		-1,
		111,
		114,
		-1,
		104,
		95,
		103,
		50,
		54,
		-1,
		-1,
		-1,
		152,
		133,
		127,
		126,
		124,
		119,
		116,
		102,
		86,
		64,
		53,
		74,
		-1,
		-1,
		-1,
		124,
		116,
		109,
		-1,
		-1,
		111,
		94,
		75,
		73,
		-1,
		-1,
		-1,
		146,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		107,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		135,
		-1,
		-1,
		-1,
		97,
		93,
		94,
		-1,
		-1,
		-1,
		-1,
		157,
		158,
		181,
		145,
		-1,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		160,
		158,
		-1,
		-1,
		-1,
		117,
		101,
		-1,
		87,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		122,
		-1,
		122,
		97,
		104,
		-1,
		-1,
		-1,
		-1,
		135,
		127,
		135,
		-1,
		107,
		109,
		-1,
		157,
		-1,
		-1,
		150,
		141,
		-1,
		-1,
		112,
		119,
		141,
		144,
		180,
		-1,
		131
	],
	[
		-1,
		229,
		218,
		229,
		237,
		210,
		217,
		-1,
		236,
		240,
		206,
		200,
		239,
		208,
		214,
		225,
		-1,
		-1,
		-1,
		229,
		228,
		196,
		194,
		203,
		208,
		215,
		-1,
		214,
		-1,
		250,
		229,
		240,
		245,
		189,
		186,
		206,
		225,
		207,
		199,
		265,
		219,
		190,
		184,
		202,
		192,
		201,
		193,
		-1,
		190,
		180,
		202,
		181,
		192,
		184,
		-1,
		-1,
		184,
		185,
		191,
		177,
		183,
		179,
		-1,
		189,
		173,
		-1,
		-1,
		174,
		175,
		159,
		162,
		170,
		168,
		181,
		173,
		168,
		-1,
		-1,
		165,
		161,
		168,
		155,
		151,
		168,
		181,
		163,
		177,
		176,
		-1,
		169,
		187,
		194,
		162,
		160,
		144,
		142,
		160,
		162,
		168,
		168,
		-1,
		178,
		179,
		174,
		182,
		184,
		160,
		147,
		147,
		157,
		150,
		169,
		157,
		203,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		178,
		161,
		178,
		170,
		160,
		175,
		168,
		150,
		147,
		145,
		142,
		158,
		156,
		166,
		-1,
		-1,
		271,
		240,
		269,
		227,
		208,
		-1,
		174,
		154,
		160,
		164,
		158,
		151,
		165,
		161,
		-1,
		136,
		135,
		163,
		149,
		160,
		231,
		-1,
		-1,
		229,
		221,
		204,
		207,
		184,
		180,
		169,
		168,
		160,
		146,
		142,
		148,
		151,
		151,
		157,
		130,
		140,
		144,
		142,
		167,
		-1,
		-1,
		202,
		-1,
		-1,
		228,
		211,
		-1,
		194,
		201,
		190,
		196,
		182,
		203,
		179,
		170,
		162,
		156,
		144,
		146,
		143,
		156,
		144,
		127,
		152,
		156,
		137,
		158,
		153,
		-1,
		201,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		187,
		190,
		196,
		220,
		219,
		-1,
		191,
		179,
		180,
		165,
		162,
		149,
		137,
		150,
		135,
		142,
		141,
		131,
		129,
		159,
		134,
		156,
		153,
		172,
		177,
		171,
		180,
		-1,
		236,
		232,
		228,
		235,
		184,
		-1,
		-1,
		224,
		-1,
		227,
		228,
		203,
		176,
		179,
		166,
		157,
		144,
		133,
		144,
		133,
		130,
		138,
		123,
		138,
		129,
		128,
		146,
		156,
		164,
		168,
		174,
		-1,
		286,
		-1,
		228,
		212,
		214,
		186,
		207,
		-1,
		244,
		228,
		220,
		205,
		205,
		-1,
		175,
		172,
		162,
		140,
		125,
		142,
		134,
		132,
		136,
		118,
		132,
		123,
		141,
		148,
		146,
		150,
		170,
		182,
		246,
		236,
		-1,
		218,
		223,
		182,
		190,
		209,
		247,
		211,
		-1,
		206,
		-1,
		177,
		190,
		-1,
		146,
		142,
		124,
		125,
		120,
		135,
		129,
		114,
		111,
		129,
		132,
		139,
		143,
		159,
		-1,
		-1,
		231,
		235,
		224,
		175,
		194,
		218,
		255,
		204,
		193,
		192,
		-1,
		183,
		160,
		157,
		145,
		132,
		117,
		118,
		126,
		139,
		118,
		113,
		110,
		130,
		156,
		134,
		146,
		-1,
		-1,
		-1,
		256,
		-1,
		-1,
		201,
		172,
		196,
		238,
		222,
		215,
		203,
		168,
		168,
		162,
		-1,
		156,
		135,
		126,
		115,
		113,
		126,
		123,
		128,
		108,
		106,
		125,
		137,
		128,
		145,
		-1,
		-1,
		-1,
		231,
		220,
		221,
		167,
		190,
		227,
		201,
		187,
		192,
		167,
		160,
		154,
		169,
		152,
		133,
		122,
		114,
		103,
		119,
		127,
		122,
		104,
		113,
		119,
		143,
		133,
		139,
		-1,
		-1,
		238,
		228,
		212,
		214,
		211,
		181,
		188,
		220,
		192,
		205,
		-1,
		159,
		-1,
		148,
		143,
		127,
		122,
		119,
		116,
		110,
		119,
		121,
		111,
		106,
		113,
		148,
		148,
		123,
		143,
		146,
		-1,
		-1,
		-1,
		231,
		226,
		201,
		178,
		162,
		198,
		-1,
		175,
		176,
		-1,
		153,
		147,
		144,
		129,
		125,
		120,
		124,
		117,
		124,
		117,
		115,
		116,
		98,
		130,
		-1,
		131,
		125,
		133,
		123,
		111,
		-1,
		-1,
		-1,
		224,
		203,
		196,
		216,
		157,
		209,
		-1,
		-1,
		160,
		153,
		-1,
		140,
		122,
		129,
		127,
		121,
		125,
		122,
		111,
		124,
		117,
		103,
		105,
		118,
		122,
		126,
		113,
		109,
		106,
		120,
		-1,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		177,
		-1,
		169,
		161,
		151,
		145,
		139,
		135,
		133,
		149,
		133,
		136,
		134,
		125,
		133,
		106,
		99,
		106,
		95,
		113,
		121,
		113,
		107,
		106,
		116,
		-1,
		244,
		230,
		201,
		-1,
		-1,
		190,
		-1,
		154,
		168,
		184,
		-1,
		177,
		156,
		171,
		149,
		145,
		141,
		156,
		157,
		134,
		134,
		132,
		123,
		111,
		100,
		103,
		95,
		117,
		117,
		101,
		102,
		106,
		-1,
		250,
		237,
		195,
		191,
		180,
		200,
		151,
		139,
		171,
		-1,
		-1,
		213,
		-1,
		147,
		164,
		155,
		153,
		146,
		128,
		135,
		143,
		120,
		115,
		105,
		94,
		94,
		89,
		111,
		97,
		95,
		104,
		120,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		166,
		153,
		147,
		-1,
		188,
		-1,
		191,
		181,
		165,
		150,
		183,
		-1,
		127,
		123,
		130,
		-1,
		140,
		-1,
		113,
		110,
		101,
		86,
		83,
		94,
		92,
		103,
		99,
		-1,
		200,
		185,
		178,
		168,
		182,
		153,
		-1,
		208,
		-1,
		-1,
		178,
		172,
		172,
		156,
		157,
		143,
		123,
		115,
		130,
		129,
		116,
		115,
		99,
		92,
		89,
		82,
		95,
		105,
		110,
		97,
		-1,
		-1,
		-1,
		205,
		191,
		195,
		155,
		174,
		-1,
		-1,
		240,
		195,
		181,
		-1,
		152,
		143,
		131,
		121,
		111,
		116,
		117,
		107,
		105,
		97,
		99,
		93,
		84,
		83,
		99,
		91,
		113,
		-1,
		-1,
		188,
		193,
		181,
		167,
		186,
		-1,
		-1,
		-1,
		187,
		203,
		171,
		150,
		132,
		-1,
		-1,
		115,
		108,
		102,
		105,
		93,
		113,
		108,
		92,
		77,
		92,
		96,
		104,
		95,
		-1,
		191,
		178,
		-1,
		-1,
		189,
		183,
		-1,
		-1,
		-1,
		-1,
		183,
		128,
		117,
		112,
		116,
		114,
		-1,
		88,
		99,
		92,
		111,
		118,
		94,
		79,
		73,
		79,
		91,
		100,
		-1,
		-1,
		203,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		140,
		134,
		105,
		98,
		102,
		-1,
		90,
		92,
		89,
		101,
		97,
		94,
		85,
		76,
		72,
		76,
		80,
		94,
		98,
		226,
		-1,
		168,
		-1,
		-1,
		-1,
		158,
		173,
		144,
		121,
		94,
		89,
		82,
		76,
		81,
		92,
		101,
		112,
		77,
		79,
		69,
		68,
		72,
		89,
		93,
		-1,
		-1,
		166,
		162,
		184,
		166,
		170,
		171,
		-1,
		-1,
		98,
		89,
		80,
		72,
		85,
		88,
		73,
		75,
		75,
		73,
		67,
		77,
		92,
		87,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		168,
		169,
		116,
		98,
		94,
		92,
		81,
		75,
		63,
		68,
		78,
		72,
		69,
		63,
		67,
		90,
		79,
		118,
		-1,
		-1,
		250,
		-1,
		-1,
		-1,
		157,
		149,
		144,
		150,
		152,
		143,
		131,
		128,
		-1,
		98,
		104,
		69,
		76,
		59,
		66,
		71,
		68,
		57,
		64,
		80,
		79,
		74,
		110,
		101,
		107,
		-1,
		-1,
		243,
		232,
		221,
		227,
		-1,
		150,
		146,
		136,
		126,
		129,
		-1,
		-1,
		123,
		120,
		100,
		69,
		67,
		60,
		55,
		65,
		41,
		53,
		57,
		61,
		67,
		72,
		77,
		83,
		98,
		113,
		-1,
		197,
		234,
		227,
		195,
		203,
		234,
		-1,
		140,
		132,
		143,
		118,
		120,
		-1,
		-1,
		96,
		87,
		88,
		76,
		73,
		79,
		78,
		61,
		67,
		68,
		60,
		59,
		77,
		81,
		90,
		97,
		87,
		100,
		104,
		-1,
		190,
		210,
		189,
		192,
		216,
		230,
		-1,
		137,
		-1,
		-1,
		118,
		121,
		105,
		95,
		92,
		135,
		90,
		85,
		66,
		64,
		59,
		50,
		75,
		68,
		68,
		71,
		86,
		91,
		83,
		97,
		97,
		94,
		-1,
		179,
		190,
		183,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		108,
		-1,
		132,
		-1,
		115,
		119,
		98,
		101,
		80,
		67,
		53,
		61,
		67,
		66,
		72,
		72,
		73,
		82,
		93,
		98,
		104,
		105,
		204,
		160,
		163,
		174,
		185,
		200,
		204,
		-1,
		149,
		188,
		114,
		-1,
		98,
		-1,
		-1,
		-1,
		129,
		111,
		103,
		100,
		79,
		79,
		45,
		49,
		62,
		69,
		79,
		90,
		82,
		81,
		92,
		103,
		102,
		200,
		191,
		204,
		149,
		149,
		170,
		179,
		200,
		164,
		155,
		182,
		121,
		110,
		105,
		92,
		-1,
		-1,
		113,
		121,
		-1,
		-1,
		86,
		53,
		41,
		51,
		55,
		69,
		81,
		94,
		74,
		80,
		74,
		98,
		-1,
		193,
		192,
		181,
		178,
		154,
		145,
		140,
		167,
		-1,
		-1,
		162,
		183,
		173,
		154,
		152,
		177,
		-1,
		81,
		-1,
		-1,
		93,
		-1,
		-1,
		78,
		58,
		47,
		38,
		43,
		63,
		74,
		96,
		70,
		86,
		79,
		86,
		83,
		177,
		174,
		162,
		160,
		183,
		148,
		136,
		-1,
		149,
		147,
		153,
		160,
		155,
		166,
		-1,
		-1,
		97,
		77,
		-1,
		-1,
		76,
		74,
		63,
		-1,
		53,
		35,
		40,
		70,
		72,
		74,
		73,
		67,
		74,
		73,
		84,
		76,
		186,
		200,
		189,
		185,
		184,
		192,
		141,
		134,
		146,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		102,
		-1,
		87,
		83,
		-1,
		-1,
		71,
		64,
		52,
		40,
		30,
		40,
		57,
		57,
		60,
		65,
		65,
		76,
		63,
		67,
		70,
		-1,
		220,
		-1,
		172,
		138,
		144,
		159,
		167,
		-1,
		-1,
		-1,
		104,
		90,
		83,
		71,
		69,
		-1,
		105,
		89,
		70,
		-1,
		40,
		53,
		93,
		61,
		66,
		61,
		59,
		70,
		61,
		69,
		63,
		66,
		-1,
		-1,
		137,
		120,
		-1,
		-1,
		94,
		96,
		-1,
		95,
		84,
		69,
		61,
		-1,
		-1,
		77,
		73,
		-1,
		-1,
		27,
		48,
		64,
		72,
		67,
		55,
		67,
		63,
		59,
		69,
		60,
		-1,
		-1,
		115,
		107,
		101,
		-1,
		79,
		-1,
		97,
		-1,
		64,
		70,
		58,
		-1,
		-1,
		-1,
		58,
		21,
		37,
		43,
		69,
		67,
		58,
		51,
		58,
		61,
		54,
		60,
		-1,
		-1,
		-1,
		97,
		71,
		104,
		95,
		78,
		58,
		50,
		69,
		-1,
		39,
		-1,
		14,
		17,
		25,
		75,
		66,
		52,
		48,
		61,
		55,
		52,
		50,
		103,
		-1,
		73,
		106,
		70,
		64,
		40,
		44,
		60,
		-1,
		36,
		18,
		-1,
		29,
		19,
		67,
		42,
		51,
		44,
		38,
		39,
		47,
		-1,
		-1,
		-1,
		75,
		74,
		66,
		60,
		60,
		45,
		36,
		-1,
		48,
		30,
		9,
		24,
		9,
		0,
		8,
		57,
		53,
		56,
		54,
		32,
		-1,
		176,
		-1,
		-1,
		98,
		-1,
		-1,
		-1,
		69,
		64,
		37,
		25,
		31,
		27,
		13,
		19,
		19,
		12,
		10,
		7,
		19,
		15,
		35,
		31,
		63,
		-1,
		171,
		-1,
		105,
		-1,
		-1,
		87,
		67,
		59,
		48,
		37,
		35,
		26,
		17,
		39,
		43,
		22,
		20,
		25,
		30,
		-1,
		160,
		159,
		-1,
		106,
		98,
		84,
		-1,
		77,
		-1,
		83,
		44,
		-1,
		46,
		26,
		-1,
		31,
		27,
		-1,
		-1,
		147,
		122,
		-1,
		-1,
		-1,
		107,
		87,
		78,
		62,
		-1,
		37,
		37,
		-1,
		-1,
		-1,
		132,
		131,
		-1,
		100,
		103,
		-1,
		93,
		84,
		92,
		39,
		43,
		-1,
		-1,
		-1,
		141,
		122,
		116,
		115,
		113,
		108,
		105,
		91,
		75,
		53,
		42,
		63,
		-1,
		-1,
		-1,
		113,
		105,
		98,
		-1,
		-1,
		100,
		83,
		64,
		62,
		-1,
		-1,
		-1,
		135,
		116,
		-1,
		-1,
		90,
		-1,
		-1,
		96,
		61,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		124,
		-1,
		-1,
		-1,
		86,
		82,
		83,
		-1,
		-1,
		-1,
		-1,
		146,
		147,
		170,
		134,
		-1,
		-1,
		-1,
		78,
		72,
		-1,
		-1,
		149,
		147,
		-1,
		-1,
		-1,
		106,
		90,
		-1,
		76,
		-1,
		-1,
		-1,
		97,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		111,
		-1,
		111,
		86,
		93,
		-1,
		-1,
		-1,
		-1,
		124,
		116,
		124,
		-1,
		96,
		98,
		-1,
		146,
		-1,
		-1,
		139,
		130,
		-1,
		-1,
		101,
		108,
		130,
		133,
		169,
		-1,
		120
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		145,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		139,
		146,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		131,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		138,
		134,
		141,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		168,
		154,
		134,
		126,
		141,
		140,
		127,
		126,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		163,
		154,
		142,
		132,
		122,
		127,
		128,
		118,
		116,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		182,
		161,
		143,
		-1,
		-1,
		126,
		119,
		113,
		116,
		104,
		124,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		194,
		139,
		128,
		123,
		127,
		125,
		-1,
		99,
		110,
		103,
		122,
		129,
		105,
		90,
		84,
		90,
		102,
		111,
		-1,
		-1,
		214,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		116,
		109,
		113,
		-1,
		101,
		103,
		100,
		112,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		105,
		109,
		237,
		-1,
		179,
		-1,
		-1,
		-1,
		169,
		184,
		155,
		132,
		105,
		100,
		93,
		87,
		92,
		103,
		112,
		123,
		88,
		90,
		80,
		79,
		83,
		100,
		104,
		-1,
		-1,
		177,
		173,
		195,
		177,
		181,
		182,
		-1,
		-1,
		109,
		100,
		91,
		83,
		96,
		99,
		84,
		86,
		86,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		189,
		-1,
		191,
		-1,
		-1,
		179,
		180,
		127,
		109,
		105,
		103,
		92,
		86,
		74,
		79,
		89,
		83,
		80,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		142,
		139,
		-1,
		109,
		115,
		80,
		87,
		70,
		77,
		82,
		79,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		134,
		131,
		111,
		80,
		78,
		71,
		66,
		76,
		52,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		208,
		245,
		238,
		206,
		214,
		245,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		107,
		98,
		99,
		87,
		84,
		90,
		89,
		72,
		78,
		79,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		148,
		-1,
		-1,
		129,
		132,
		116,
		106,
		103,
		146,
		101,
		96,
		77,
		75,
		70,
		61,
		86,
		79,
		79,
		82,
		96,
		101,
		93,
		108,
		104,
		97,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		119,
		-1,
		143,
		-1,
		126,
		130,
		109,
		112,
		91,
		78,
		64,
		72,
		78,
		77,
		83,
		83,
		83,
		85,
		97,
		101,
		111,
		113,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		160,
		199,
		125,
		-1,
		109,
		-1,
		-1,
		-1,
		140,
		122,
		114,
		111,
		90,
		90,
		56,
		60,
		73,
		80,
		90,
		100,
		85,
		84,
		95,
		106,
		105,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		175,
		166,
		193,
		132,
		121,
		116,
		103,
		-1,
		-1,
		124,
		132,
		-1,
		-1,
		97,
		64,
		52,
		62,
		66,
		80,
		92,
		97,
		77,
		83,
		77,
		101,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		194,
		184,
		165,
		163,
		188,
		-1,
		92,
		-1,
		-1,
		104,
		-1,
		-1,
		89,
		69,
		58,
		49,
		54,
		74,
		85,
		107,
		73,
		89,
		82,
		89,
		86,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		166,
		177,
		-1,
		-1,
		108,
		88,
		-1,
		-1,
		87,
		85,
		74,
		-1,
		64,
		46,
		51,
		81,
		83,
		82,
		76,
		70,
		77,
		76,
		87,
		79,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		98,
		94,
		-1,
		-1,
		82,
		75,
		63,
		51,
		41,
		51,
		68,
		68,
		71,
		73,
		68,
		79,
		66,
		70,
		73,
		-1,
		231,
		-1,
		183,
		149,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		115,
		101,
		94,
		82,
		80,
		-1,
		116,
		100,
		81,
		-1,
		51,
		64,
		94,
		65,
		74,
		72,
		62,
		73,
		64,
		72,
		66,
		69,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		106,
		95,
		80,
		72,
		-1,
		-1,
		88,
		84,
		-1,
		-1,
		38,
		45,
		63,
		80,
		76,
		58,
		70,
		66,
		62,
		72,
		63,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		108,
		-1,
		75,
		81,
		69,
		-1,
		-1,
		-1,
		69,
		32,
		48,
		40,
		72,
		70,
		61,
		54,
		61,
		64,
		57,
		63,
		-1,
		-1,
		-1,
		108,
		82,
		115,
		106,
		89,
		69,
		61,
		80,
		-1,
		50,
		-1,
		25,
		28,
		22,
		72,
		69,
		55,
		51,
		64,
		58,
		55,
		53,
		114,
		-1,
		84,
		117,
		81,
		75,
		51,
		55,
		71,
		-1,
		47,
		29,
		-1,
		33,
		16,
		70,
		45,
		54,
		47,
		41,
		42,
		50,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		71,
		56,
		47,
		-1,
		59,
		41,
		20,
		35,
		20,
		11,
		0,
		60,
		56,
		59,
		57,
		35,
		-1,
		187,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		75,
		48,
		36,
		42,
		38,
		24,
		30,
		30,
		15,
		2,
		1,
		17,
		18,
		38,
		34,
		66,
		-1,
		182,
		-1,
		116,
		-1,
		-1,
		98,
		78,
		70,
		59,
		48,
		46,
		37,
		28,
		50,
		51,
		23,
		23,
		28,
		33,
		-1,
		171,
		170,
		-1,
		117,
		109,
		95,
		-1,
		88,
		-1,
		94,
		55,
		-1,
		57,
		37,
		-1,
		34,
		30,
		-1,
		-1,
		158,
		133,
		-1,
		-1,
		-1,
		118,
		98,
		89,
		73,
		-1,
		48,
		48,
		-1,
		-1,
		-1,
		143,
		142,
		-1,
		111,
		114,
		-1,
		104,
		95,
		103,
		50,
		54,
		-1,
		-1,
		-1,
		152,
		133,
		127,
		126,
		124,
		119,
		116,
		102,
		86,
		64,
		53,
		74,
		-1,
		-1,
		-1,
		124,
		116,
		109,
		-1,
		-1,
		111,
		94,
		75,
		73,
		-1,
		-1,
		-1,
		146,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		107,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		135,
		-1,
		-1,
		-1,
		97,
		93,
		94,
		-1,
		-1,
		-1,
		-1,
		157,
		158,
		181,
		145,
		-1,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		160,
		158,
		-1,
		-1,
		-1,
		117,
		101,
		-1,
		87,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		122,
		-1,
		122,
		97,
		104,
		-1,
		-1,
		-1,
		-1,
		135,
		127,
		135,
		-1,
		107,
		109,
		-1,
		157,
		-1,
		-1,
		150,
		141,
		-1,
		-1,
		112,
		119,
		141,
		144,
		180,
		-1,
		131
	],
	[
		-1,
		274,
		263,
		274,
		282,
		255,
		262,
		-1,
		281,
		285,
		251,
		245,
		284,
		253,
		259,
		270,
		-1,
		-1,
		-1,
		274,
		273,
		241,
		239,
		248,
		253,
		260,
		-1,
		259,
		-1,
		295,
		274,
		285,
		290,
		234,
		231,
		251,
		270,
		252,
		244,
		310,
		264,
		235,
		229,
		247,
		237,
		246,
		238,
		-1,
		235,
		225,
		247,
		226,
		237,
		229,
		-1,
		-1,
		229,
		230,
		236,
		222,
		228,
		224,
		-1,
		234,
		218,
		-1,
		-1,
		219,
		220,
		204,
		207,
		215,
		213,
		226,
		218,
		213,
		-1,
		-1,
		210,
		206,
		213,
		200,
		196,
		213,
		226,
		208,
		222,
		221,
		-1,
		214,
		232,
		239,
		207,
		205,
		189,
		187,
		205,
		207,
		213,
		213,
		-1,
		223,
		224,
		219,
		227,
		229,
		205,
		192,
		192,
		202,
		195,
		214,
		202,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		223,
		206,
		223,
		215,
		205,
		220,
		213,
		195,
		192,
		190,
		187,
		203,
		201,
		211,
		-1,
		-1,
		316,
		285,
		314,
		272,
		253,
		-1,
		219,
		199,
		205,
		209,
		203,
		196,
		210,
		206,
		-1,
		181,
		180,
		208,
		194,
		205,
		276,
		-1,
		-1,
		274,
		266,
		249,
		252,
		229,
		225,
		214,
		213,
		205,
		191,
		187,
		193,
		196,
		196,
		202,
		175,
		185,
		189,
		187,
		212,
		-1,
		-1,
		247,
		-1,
		-1,
		273,
		256,
		-1,
		239,
		246,
		235,
		241,
		227,
		248,
		224,
		215,
		207,
		201,
		189,
		191,
		188,
		201,
		189,
		172,
		197,
		201,
		182,
		203,
		198,
		-1,
		246,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		232,
		235,
		241,
		265,
		264,
		-1,
		236,
		224,
		225,
		210,
		207,
		194,
		182,
		195,
		180,
		187,
		186,
		176,
		174,
		204,
		179,
		201,
		198,
		217,
		222,
		216,
		225,
		-1,
		281,
		277,
		273,
		280,
		229,
		-1,
		-1,
		269,
		-1,
		272,
		273,
		248,
		221,
		224,
		211,
		202,
		189,
		178,
		189,
		178,
		175,
		183,
		168,
		183,
		174,
		173,
		191,
		201,
		209,
		213,
		219,
		-1,
		331,
		-1,
		273,
		257,
		259,
		231,
		252,
		-1,
		289,
		273,
		265,
		250,
		250,
		-1,
		220,
		217,
		207,
		185,
		170,
		187,
		179,
		177,
		181,
		163,
		177,
		168,
		186,
		193,
		191,
		195,
		215,
		227,
		291,
		281,
		-1,
		263,
		268,
		227,
		235,
		254,
		292,
		256,
		-1,
		251,
		-1,
		222,
		235,
		-1,
		191,
		187,
		169,
		170,
		165,
		180,
		174,
		159,
		156,
		174,
		177,
		184,
		188,
		204,
		-1,
		-1,
		276,
		280,
		269,
		220,
		239,
		263,
		300,
		249,
		238,
		237,
		-1,
		228,
		205,
		202,
		190,
		177,
		162,
		163,
		171,
		184,
		163,
		158,
		155,
		175,
		201,
		179,
		191,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		246,
		217,
		241,
		283,
		267,
		260,
		248,
		213,
		213,
		207,
		-1,
		201,
		180,
		171,
		160,
		158,
		171,
		168,
		173,
		153,
		151,
		170,
		182,
		173,
		190,
		-1,
		-1,
		-1,
		276,
		265,
		266,
		212,
		235,
		272,
		246,
		232,
		237,
		212,
		205,
		199,
		214,
		197,
		178,
		167,
		159,
		148,
		164,
		172,
		167,
		149,
		158,
		164,
		188,
		178,
		184,
		-1,
		-1,
		283,
		273,
		257,
		259,
		256,
		226,
		233,
		265,
		237,
		250,
		-1,
		204,
		-1,
		193,
		188,
		172,
		167,
		164,
		161,
		155,
		164,
		166,
		156,
		151,
		158,
		193,
		193,
		168,
		188,
		191,
		-1,
		-1,
		-1,
		276,
		271,
		246,
		223,
		207,
		243,
		-1,
		220,
		221,
		-1,
		198,
		192,
		189,
		174,
		170,
		165,
		169,
		162,
		169,
		162,
		160,
		161,
		143,
		175,
		-1,
		176,
		170,
		178,
		168,
		156,
		-1,
		-1,
		-1,
		269,
		248,
		241,
		261,
		202,
		254,
		-1,
		-1,
		205,
		198,
		-1,
		185,
		167,
		174,
		172,
		166,
		170,
		167,
		156,
		169,
		162,
		148,
		150,
		163,
		167,
		171,
		158,
		154,
		151,
		165,
		-1,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		222,
		-1,
		214,
		206,
		196,
		190,
		184,
		180,
		178,
		194,
		178,
		181,
		179,
		170,
		178,
		151,
		144,
		151,
		140,
		158,
		166,
		158,
		152,
		151,
		161,
		-1,
		289,
		275,
		246,
		-1,
		-1,
		235,
		-1,
		199,
		213,
		229,
		-1,
		222,
		201,
		216,
		194,
		190,
		186,
		201,
		202,
		180,
		179,
		177,
		168,
		156,
		145,
		148,
		140,
		162,
		162,
		146,
		147,
		151,
		-1,
		295,
		282,
		240,
		236,
		225,
		245,
		196,
		184,
		216,
		-1,
		-1,
		258,
		-1,
		192,
		209,
		200,
		198,
		191,
		182,
		188,
		188,
		165,
		160,
		150,
		139,
		139,
		134,
		156,
		142,
		140,
		149,
		165,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		211,
		198,
		192,
		-1,
		233,
		-1,
		236,
		226,
		210,
		195,
		228,
		-1,
		188,
		183,
		188,
		-1,
		185,
		-1,
		158,
		155,
		146,
		131,
		128,
		139,
		137,
		148,
		144,
		-1,
		245,
		230,
		223,
		213,
		227,
		198,
		-1,
		253,
		-1,
		-1,
		223,
		217,
		217,
		201,
		204,
		204,
		184,
		176,
		188,
		180,
		172,
		166,
		144,
		137,
		134,
		127,
		140,
		150,
		155,
		142,
		-1,
		-1,
		-1,
		250,
		236,
		240,
		200,
		219,
		-1,
		-1,
		285,
		240,
		226,
		-1,
		210,
		204,
		192,
		182,
		172,
		177,
		178,
		163,
		156,
		142,
		144,
		138,
		129,
		128,
		144,
		136,
		158,
		-1,
		-1,
		233,
		238,
		226,
		212,
		231,
		-1,
		-1,
		-1,
		232,
		248,
		232,
		211,
		193,
		-1,
		-1,
		176,
		169,
		163,
		159,
		146,
		158,
		153,
		137,
		122,
		137,
		141,
		149,
		140,
		-1,
		236,
		223,
		-1,
		-1,
		234,
		228,
		-1,
		-1,
		-1,
		-1,
		244,
		189,
		178,
		173,
		177,
		175,
		-1,
		149,
		160,
		150,
		162,
		169,
		139,
		124,
		118,
		124,
		136,
		145,
		-1,
		-1,
		248,
		-1,
		231,
		-1,
		-1,
		-1,
		-1,
		201,
		195,
		166,
		159,
		163,
		-1,
		151,
		153,
		150,
		162,
		142,
		139,
		130,
		121,
		117,
		121,
		125,
		139,
		143,
		271,
		-1,
		222,
		-1,
		-1,
		-1,
		219,
		234,
		205,
		182,
		155,
		150,
		143,
		137,
		142,
		153,
		150,
		161,
		128,
		124,
		114,
		113,
		117,
		134,
		134,
		-1,
		-1,
		220,
		216,
		245,
		227,
		231,
		232,
		-1,
		-1,
		159,
		150,
		141,
		133,
		146,
		149,
		134,
		131,
		125,
		118,
		112,
		122,
		133,
		128,
		-1,
		-1,
		-1,
		232,
		-1,
		234,
		-1,
		-1,
		222,
		230,
		177,
		159,
		155,
		153,
		140,
		134,
		124,
		129,
		135,
		126,
		120,
		108,
		108,
		131,
		120,
		137,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		211,
		203,
		198,
		204,
		206,
		197,
		192,
		189,
		-1,
		159,
		163,
		130,
		137,
		120,
		127,
		130,
		122,
		102,
		105,
		121,
		120,
		115,
		129,
		120,
		124,
		-1,
		-1,
		297,
		286,
		275,
		281,
		-1,
		204,
		200,
		190,
		180,
		183,
		-1,
		-1,
		177,
		174,
		154,
		123,
		128,
		121,
		116,
		121,
		102,
		98,
		98,
		93,
		108,
		113,
		115,
		108,
		115,
		130,
		-1,
		251,
		288,
		281,
		249,
		257,
		288,
		-1,
		194,
		186,
		197,
		172,
		174,
		-1,
		-1,
		150,
		141,
		142,
		130,
		127,
		140,
		136,
		106,
		103,
		113,
		91,
		98,
		109,
		101,
		105,
		106,
		111,
		124,
		128,
		-1,
		244,
		264,
		243,
		246,
		270,
		284,
		-1,
		191,
		-1,
		-1,
		183,
		175,
		159,
		149,
		146,
		189,
		136,
		131,
		108,
		106,
		103,
		94,
		115,
		99,
		87,
		84,
		93,
		98,
		90,
		116,
		117,
		110,
		-1,
		233,
		244,
		237,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		173,
		-1,
		186,
		-1,
		169,
		173,
		144,
		147,
		122,
		109,
		95,
		95,
		101,
		99,
		95,
		91,
		80,
		89,
		100,
		112,
		122,
		124,
		258,
		214,
		217,
		228,
		239,
		254,
		258,
		-1,
		203,
		242,
		179,
		-1,
		163,
		-1,
		-1,
		-1,
		183,
		157,
		149,
		142,
		121,
		121,
		87,
		83,
		96,
		100,
		105,
		97,
		81,
		93,
		106,
		117,
		118,
		254,
		245,
		258,
		203,
		203,
		224,
		233,
		254,
		218,
		209,
		236,
		186,
		175,
		170,
		157,
		-1,
		-1,
		164,
		167,
		-1,
		-1,
		128,
		104,
		91,
		85,
		89,
		103,
		105,
		93,
		73,
		93,
		88,
		114,
		-1,
		247,
		246,
		235,
		232,
		208,
		199,
		194,
		221,
		-1,
		-1,
		216,
		237,
		227,
		219,
		217,
		242,
		-1,
		146,
		-1,
		-1,
		144,
		-1,
		-1,
		129,
		109,
		98,
		89,
		75,
		97,
		108,
		120,
		69,
		86,
		93,
		102,
		99,
		231,
		228,
		216,
		214,
		237,
		202,
		190,
		-1,
		203,
		201,
		207,
		214,
		220,
		231,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		127,
		125,
		114,
		-1,
		104,
		86,
		72,
		99,
		80,
		78,
		72,
		66,
		73,
		89,
		100,
		92,
		240,
		254,
		243,
		239,
		238,
		246,
		195,
		188,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		122,
		115,
		103,
		91,
		81,
		86,
		72,
		68,
		68,
		69,
		64,
		75,
		79,
		83,
		86,
		-1,
		274,
		-1,
		226,
		202,
		209,
		224,
		232,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		156,
		140,
		121,
		-1,
		91,
		104,
		96,
		65,
		53,
		62,
		58,
		69,
		76,
		85,
		79,
		82,
		-1,
		-1,
		202,
		185,
		-1,
		-1,
		159,
		161,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		128,
		124,
		-1,
		-1,
		92,
		66,
		63,
		59,
		58,
		54,
		66,
		62,
		74,
		85,
		76,
		-1,
		-1,
		180,
		172,
		166,
		-1,
		144,
		-1,
		162,
		-1,
		129,
		135,
		123,
		-1,
		-1,
		-1,
		123,
		86,
		102,
		73,
		36,
		34,
		48,
		50,
		57,
		67,
		70,
		76,
		-1,
		-1,
		-1,
		162,
		136,
		169,
		160,
		143,
		123,
		115,
		134,
		-1,
		104,
		-1,
		79,
		82,
		87,
		44,
		32,
		20,
		50,
		53,
		59,
		68,
		66,
		168,
		-1,
		138,
		171,
		135,
		129,
		105,
		109,
		125,
		-1,
		101,
		83,
		-1,
		94,
		81,
		21,
		16,
		37,
		46,
		53,
		64,
		63,
		-1,
		-1,
		-1,
		140,
		139,
		131,
		125,
		125,
		110,
		101,
		-1,
		113,
		95,
		74,
		89,
		74,
		65,
		65,
		0,
		21,
		47,
		49,
		58,
		-1,
		241,
		-1,
		-1,
		163,
		-1,
		-1,
		-1,
		134,
		129,
		102,
		90,
		96,
		92,
		78,
		84,
		84,
		77,
		67,
		64,
		57,
		51,
		59,
		59,
		95,
		-1,
		236,
		-1,
		170,
		-1,
		-1,
		152,
		132,
		124,
		113,
		102,
		100,
		91,
		82,
		104,
		108,
		56,
		56,
		61,
		66,
		-1,
		225,
		224,
		-1,
		171,
		163,
		149,
		-1,
		142,
		-1,
		148,
		109,
		-1,
		111,
		91,
		-1,
		67,
		63,
		-1,
		-1,
		212,
		187,
		-1,
		-1,
		-1,
		172,
		152,
		143,
		127,
		-1,
		102,
		102,
		-1,
		-1,
		-1,
		197,
		196,
		-1,
		165,
		168,
		-1,
		158,
		149,
		157,
		104,
		108,
		-1,
		-1,
		-1,
		206,
		187,
		181,
		180,
		178,
		173,
		170,
		156,
		140,
		118,
		107,
		128,
		-1,
		-1,
		-1,
		178,
		170,
		163,
		-1,
		-1,
		165,
		148,
		129,
		127,
		-1,
		-1,
		-1,
		200,
		181,
		-1,
		-1,
		155,
		-1,
		-1,
		161,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		189,
		-1,
		-1,
		-1,
		151,
		147,
		148,
		-1,
		-1,
		-1,
		-1,
		211,
		212,
		235,
		199,
		-1,
		-1,
		-1,
		143,
		137,
		-1,
		-1,
		214,
		212,
		-1,
		-1,
		-1,
		171,
		155,
		-1,
		141,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		176,
		-1,
		176,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		189,
		181,
		189,
		-1,
		161,
		163,
		-1,
		211,
		-1,
		-1,
		204,
		195,
		-1,
		-1,
		166,
		173,
		195,
		198,
		234,
		-1,
		185
	],
	[
		-1,
		267,
		256,
		267,
		275,
		248,
		255,
		-1,
		274,
		278,
		244,
		238,
		277,
		246,
		252,
		263,
		-1,
		-1,
		-1,
		267,
		266,
		234,
		232,
		241,
		246,
		253,
		-1,
		252,
		-1,
		288,
		267,
		278,
		283,
		227,
		224,
		244,
		263,
		245,
		237,
		303,
		257,
		228,
		222,
		240,
		230,
		239,
		231,
		-1,
		228,
		218,
		240,
		219,
		230,
		222,
		-1,
		-1,
		222,
		223,
		229,
		215,
		221,
		217,
		-1,
		227,
		211,
		-1,
		-1,
		212,
		213,
		197,
		200,
		208,
		206,
		219,
		211,
		206,
		-1,
		-1,
		203,
		199,
		206,
		193,
		189,
		206,
		219,
		201,
		215,
		214,
		-1,
		207,
		225,
		232,
		200,
		198,
		182,
		180,
		198,
		200,
		206,
		206,
		-1,
		216,
		217,
		212,
		220,
		222,
		198,
		185,
		185,
		195,
		188,
		207,
		195,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		216,
		199,
		216,
		208,
		198,
		213,
		206,
		188,
		185,
		183,
		180,
		196,
		194,
		204,
		-1,
		-1,
		309,
		278,
		307,
		265,
		246,
		-1,
		212,
		192,
		198,
		202,
		196,
		189,
		203,
		199,
		-1,
		174,
		173,
		201,
		187,
		198,
		269,
		-1,
		-1,
		267,
		259,
		242,
		245,
		222,
		218,
		207,
		206,
		198,
		184,
		180,
		186,
		189,
		189,
		195,
		168,
		178,
		182,
		180,
		205,
		-1,
		-1,
		240,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		228,
		234,
		220,
		241,
		217,
		208,
		200,
		194,
		182,
		184,
		181,
		194,
		182,
		165,
		190,
		194,
		175,
		196,
		191,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		257,
		-1,
		229,
		217,
		218,
		203,
		200,
		187,
		175,
		188,
		173,
		180,
		179,
		169,
		167,
		197,
		172,
		194,
		191,
		210,
		215,
		209,
		218,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		265,
		266,
		241,
		214,
		217,
		204,
		195,
		182,
		171,
		182,
		171,
		168,
		176,
		161,
		176,
		167,
		166,
		184,
		194,
		202,
		206,
		212,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		266,
		258,
		243,
		243,
		-1,
		213,
		210,
		200,
		178,
		163,
		180,
		172,
		170,
		174,
		156,
		170,
		161,
		179,
		186,
		184,
		188,
		208,
		220,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		285,
		249,
		-1,
		244,
		-1,
		215,
		228,
		-1,
		184,
		180,
		162,
		163,
		158,
		173,
		167,
		152,
		149,
		167,
		170,
		177,
		181,
		197,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		242,
		231,
		230,
		-1,
		221,
		198,
		195,
		183,
		170,
		155,
		156,
		164,
		177,
		156,
		151,
		148,
		168,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		260,
		253,
		241,
		206,
		206,
		200,
		-1,
		194,
		173,
		164,
		153,
		151,
		164,
		161,
		166,
		146,
		144,
		163,
		175,
		166,
		183,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		205,
		228,
		265,
		239,
		225,
		230,
		205,
		198,
		192,
		207,
		190,
		171,
		160,
		152,
		141,
		157,
		165,
		160,
		142,
		151,
		157,
		181,
		171,
		177,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		219,
		226,
		258,
		230,
		243,
		-1,
		197,
		-1,
		186,
		181,
		165,
		160,
		157,
		154,
		148,
		157,
		159,
		149,
		144,
		151,
		186,
		186,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		269,
		264,
		239,
		216,
		200,
		236,
		-1,
		213,
		214,
		-1,
		191,
		185,
		182,
		167,
		163,
		158,
		162,
		155,
		162,
		155,
		153,
		154,
		136,
		168,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		262,
		241,
		234,
		254,
		195,
		247,
		-1,
		-1,
		198,
		191,
		-1,
		178,
		160,
		167,
		165,
		159,
		163,
		160,
		149,
		162,
		155,
		141,
		143,
		156,
		160,
		164,
		151,
		147,
		144,
		158,
		-1,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		215,
		-1,
		207,
		199,
		189,
		183,
		177,
		173,
		171,
		187,
		171,
		174,
		172,
		163,
		171,
		144,
		137,
		144,
		133,
		151,
		159,
		151,
		145,
		144,
		154,
		-1,
		282,
		268,
		239,
		-1,
		-1,
		228,
		-1,
		192,
		206,
		222,
		-1,
		215,
		194,
		209,
		187,
		183,
		179,
		194,
		195,
		173,
		172,
		170,
		161,
		149,
		138,
		141,
		133,
		155,
		155,
		139,
		140,
		144,
		-1,
		288,
		275,
		233,
		229,
		218,
		238,
		189,
		177,
		209,
		-1,
		-1,
		251,
		-1,
		185,
		202,
		193,
		191,
		184,
		175,
		181,
		181,
		158,
		153,
		143,
		132,
		132,
		127,
		149,
		135,
		133,
		142,
		158,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		204,
		191,
		185,
		-1,
		226,
		-1,
		229,
		219,
		203,
		188,
		221,
		-1,
		181,
		176,
		181,
		-1,
		178,
		-1,
		151,
		148,
		139,
		124,
		121,
		132,
		130,
		141,
		137,
		-1,
		238,
		223,
		216,
		206,
		220,
		191,
		-1,
		246,
		-1,
		-1,
		216,
		210,
		210,
		194,
		197,
		197,
		177,
		169,
		181,
		173,
		165,
		159,
		137,
		130,
		127,
		120,
		133,
		143,
		148,
		135,
		-1,
		-1,
		-1,
		243,
		229,
		233,
		193,
		212,
		-1,
		-1,
		278,
		233,
		219,
		-1,
		203,
		197,
		185,
		175,
		165,
		170,
		171,
		156,
		149,
		135,
		137,
		131,
		122,
		121,
		137,
		129,
		151,
		-1,
		-1,
		226,
		231,
		219,
		205,
		224,
		-1,
		-1,
		-1,
		225,
		241,
		225,
		204,
		186,
		-1,
		-1,
		169,
		162,
		156,
		152,
		139,
		151,
		146,
		130,
		115,
		130,
		134,
		142,
		133,
		-1,
		229,
		216,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		-1,
		-1,
		237,
		182,
		171,
		166,
		170,
		168,
		-1,
		142,
		153,
		143,
		155,
		162,
		132,
		117,
		111,
		117,
		129,
		138,
		-1,
		-1,
		241,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		194,
		188,
		159,
		152,
		156,
		-1,
		144,
		146,
		143,
		155,
		135,
		132,
		123,
		114,
		110,
		114,
		118,
		132,
		136,
		264,
		-1,
		215,
		-1,
		-1,
		-1,
		212,
		227,
		198,
		175,
		148,
		143,
		136,
		130,
		135,
		146,
		143,
		154,
		121,
		117,
		107,
		106,
		110,
		127,
		127,
		-1,
		-1,
		213,
		209,
		238,
		220,
		224,
		225,
		-1,
		-1,
		152,
		143,
		134,
		126,
		139,
		142,
		127,
		124,
		118,
		111,
		105,
		115,
		126,
		121,
		-1,
		-1,
		-1,
		225,
		-1,
		227,
		-1,
		-1,
		215,
		223,
		170,
		152,
		148,
		146,
		133,
		127,
		117,
		122,
		128,
		119,
		113,
		101,
		101,
		124,
		113,
		130,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		204,
		196,
		191,
		197,
		199,
		190,
		185,
		182,
		-1,
		152,
		156,
		123,
		130,
		113,
		120,
		123,
		115,
		95,
		98,
		114,
		113,
		108,
		122,
		113,
		117,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		197,
		193,
		183,
		173,
		176,
		-1,
		-1,
		170,
		167,
		147,
		116,
		121,
		114,
		109,
		114,
		95,
		91,
		91,
		86,
		101,
		106,
		108,
		101,
		108,
		123,
		-1,
		244,
		281,
		274,
		242,
		250,
		281,
		-1,
		187,
		179,
		190,
		165,
		167,
		-1,
		-1,
		143,
		134,
		135,
		123,
		120,
		133,
		129,
		99,
		96,
		106,
		84,
		91,
		102,
		94,
		98,
		99,
		102,
		115,
		119,
		-1,
		237,
		257,
		236,
		239,
		263,
		277,
		-1,
		184,
		-1,
		-1,
		179,
		168,
		152,
		142,
		139,
		182,
		129,
		124,
		101,
		99,
		96,
		87,
		108,
		92,
		80,
		77,
		86,
		91,
		83,
		109,
		108,
		101,
		-1,
		226,
		237,
		230,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		169,
		-1,
		179,
		-1,
		162,
		166,
		137,
		140,
		115,
		102,
		88,
		88,
		94,
		92,
		88,
		84,
		73,
		82,
		93,
		105,
		115,
		117,
		251,
		207,
		210,
		221,
		232,
		247,
		251,
		-1,
		196,
		235,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		176,
		150,
		142,
		135,
		114,
		114,
		80,
		76,
		89,
		93,
		98,
		90,
		74,
		86,
		99,
		110,
		109,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		211,
		202,
		229,
		182,
		171,
		166,
		153,
		-1,
		-1,
		157,
		160,
		-1,
		-1,
		121,
		97,
		84,
		78,
		82,
		96,
		98,
		86,
		66,
		86,
		81,
		105,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		230,
		220,
		215,
		213,
		238,
		-1,
		142,
		-1,
		-1,
		137,
		-1,
		-1,
		122,
		102,
		91,
		82,
		68,
		90,
		101,
		113,
		62,
		79,
		86,
		93,
		90,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		196,
		194,
		200,
		207,
		216,
		227,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		120,
		118,
		107,
		-1,
		97,
		79,
		65,
		92,
		73,
		71,
		65,
		59,
		66,
		80,
		91,
		83,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		115,
		108,
		96,
		84,
		74,
		79,
		65,
		61,
		61,
		62,
		57,
		68,
		70,
		74,
		77,
		-1,
		267,
		-1,
		219,
		195,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		149,
		133,
		114,
		-1,
		84,
		97,
		89,
		58,
		44,
		55,
		51,
		62,
		68,
		76,
		70,
		73,
		-1,
		-1,
		198,
		181,
		-1,
		-1,
		155,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		121,
		117,
		-1,
		-1,
		85,
		59,
		56,
		50,
		49,
		47,
		58,
		55,
		66,
		76,
		67,
		-1,
		-1,
		176,
		168,
		162,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		119,
		82,
		98,
		66,
		29,
		27,
		39,
		43,
		50,
		60,
		61,
		67,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		78,
		80,
		37,
		25,
		11,
		41,
		44,
		50,
		59,
		57,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		90,
		77,
		26,
		12,
		28,
		37,
		44,
		55,
		54,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		85,
		70,
		61,
		61,
		16,
		0,
		38,
		40,
		49,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		80,
		73,
		63,
		60,
		53,
		47,
		50,
		50,
		86,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		104,
		52,
		52,
		57,
		58,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		63,
		59,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		252,
		241,
		252,
		260,
		233,
		240,
		-1,
		259,
		263,
		229,
		223,
		262,
		231,
		237,
		248,
		-1,
		-1,
		-1,
		252,
		251,
		219,
		217,
		226,
		231,
		238,
		-1,
		237,
		-1,
		273,
		252,
		263,
		268,
		212,
		209,
		229,
		248,
		230,
		222,
		288,
		242,
		213,
		207,
		225,
		215,
		224,
		216,
		-1,
		213,
		203,
		225,
		204,
		215,
		207,
		-1,
		-1,
		207,
		208,
		214,
		200,
		206,
		202,
		-1,
		212,
		196,
		-1,
		-1,
		197,
		198,
		182,
		185,
		193,
		191,
		204,
		196,
		191,
		-1,
		-1,
		188,
		184,
		191,
		178,
		174,
		191,
		204,
		186,
		200,
		199,
		-1,
		192,
		210,
		217,
		185,
		183,
		167,
		165,
		183,
		185,
		191,
		191,
		-1,
		201,
		202,
		197,
		205,
		207,
		183,
		170,
		170,
		180,
		173,
		192,
		180,
		226,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		201,
		184,
		201,
		193,
		183,
		198,
		191,
		173,
		170,
		168,
		165,
		181,
		179,
		189,
		-1,
		-1,
		294,
		263,
		292,
		250,
		231,
		-1,
		197,
		177,
		183,
		187,
		181,
		174,
		188,
		184,
		-1,
		159,
		158,
		186,
		172,
		183,
		254,
		-1,
		-1,
		252,
		244,
		227,
		230,
		207,
		203,
		192,
		191,
		183,
		169,
		165,
		171,
		174,
		174,
		180,
		153,
		163,
		167,
		165,
		190,
		-1,
		-1,
		225,
		-1,
		-1,
		251,
		234,
		-1,
		217,
		224,
		213,
		219,
		205,
		226,
		202,
		193,
		185,
		179,
		167,
		169,
		166,
		179,
		167,
		150,
		175,
		179,
		160,
		181,
		176,
		-1,
		224,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		210,
		213,
		219,
		243,
		242,
		-1,
		214,
		202,
		203,
		188,
		185,
		172,
		160,
		173,
		158,
		165,
		164,
		154,
		152,
		182,
		157,
		179,
		176,
		195,
		200,
		194,
		203,
		-1,
		259,
		255,
		251,
		258,
		207,
		-1,
		-1,
		247,
		-1,
		250,
		251,
		226,
		199,
		202,
		189,
		180,
		167,
		156,
		167,
		156,
		153,
		161,
		146,
		161,
		152,
		151,
		169,
		179,
		187,
		191,
		197,
		-1,
		309,
		-1,
		251,
		235,
		237,
		209,
		230,
		-1,
		267,
		251,
		243,
		228,
		228,
		-1,
		198,
		195,
		185,
		163,
		148,
		165,
		157,
		155,
		159,
		141,
		155,
		146,
		164,
		171,
		169,
		173,
		193,
		205,
		269,
		259,
		-1,
		241,
		246,
		205,
		213,
		232,
		270,
		234,
		-1,
		229,
		-1,
		200,
		213,
		-1,
		169,
		165,
		147,
		148,
		143,
		158,
		152,
		137,
		134,
		152,
		155,
		162,
		166,
		182,
		-1,
		-1,
		254,
		258,
		247,
		198,
		217,
		241,
		278,
		227,
		216,
		215,
		-1,
		206,
		183,
		180,
		168,
		155,
		140,
		141,
		149,
		162,
		141,
		136,
		133,
		153,
		179,
		157,
		169,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		224,
		195,
		219,
		261,
		245,
		238,
		226,
		191,
		191,
		185,
		-1,
		179,
		158,
		149,
		138,
		136,
		149,
		146,
		151,
		131,
		129,
		148,
		160,
		151,
		168,
		-1,
		-1,
		-1,
		254,
		243,
		244,
		190,
		213,
		250,
		224,
		210,
		215,
		190,
		183,
		177,
		192,
		175,
		156,
		145,
		137,
		126,
		142,
		150,
		145,
		127,
		136,
		142,
		166,
		156,
		162,
		-1,
		-1,
		261,
		251,
		235,
		237,
		234,
		204,
		211,
		243,
		215,
		228,
		-1,
		182,
		-1,
		171,
		166,
		150,
		145,
		142,
		139,
		133,
		142,
		144,
		134,
		129,
		136,
		171,
		171,
		146,
		166,
		169,
		-1,
		-1,
		-1,
		254,
		249,
		224,
		201,
		185,
		221,
		-1,
		198,
		199,
		-1,
		176,
		170,
		167,
		152,
		148,
		143,
		147,
		140,
		147,
		140,
		138,
		139,
		121,
		153,
		-1,
		154,
		148,
		156,
		146,
		134,
		-1,
		-1,
		-1,
		247,
		226,
		219,
		239,
		180,
		232,
		-1,
		-1,
		183,
		176,
		-1,
		163,
		145,
		152,
		150,
		144,
		148,
		145,
		134,
		147,
		140,
		126,
		128,
		141,
		145,
		149,
		136,
		132,
		129,
		143,
		-1,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		180,
		200,
		-1,
		192,
		184,
		174,
		168,
		162,
		158,
		156,
		172,
		156,
		159,
		157,
		148,
		156,
		129,
		122,
		129,
		118,
		136,
		144,
		136,
		130,
		129,
		139,
		-1,
		267,
		253,
		224,
		-1,
		-1,
		213,
		-1,
		177,
		191,
		207,
		-1,
		200,
		179,
		194,
		172,
		168,
		164,
		179,
		180,
		158,
		157,
		155,
		146,
		134,
		123,
		126,
		118,
		140,
		140,
		124,
		125,
		129,
		-1,
		273,
		260,
		218,
		214,
		203,
		223,
		174,
		162,
		194,
		-1,
		-1,
		236,
		-1,
		170,
		187,
		178,
		176,
		169,
		160,
		166,
		166,
		143,
		138,
		128,
		117,
		117,
		112,
		134,
		120,
		118,
		127,
		143,
		-1,
		-1,
		-1,
		240,
		-1,
		-1,
		189,
		176,
		170,
		-1,
		211,
		-1,
		214,
		204,
		188,
		173,
		206,
		-1,
		171,
		161,
		166,
		-1,
		163,
		-1,
		136,
		133,
		124,
		109,
		106,
		117,
		115,
		126,
		122,
		-1,
		223,
		208,
		201,
		191,
		205,
		176,
		-1,
		231,
		-1,
		-1,
		201,
		195,
		195,
		179,
		182,
		187,
		167,
		159,
		166,
		158,
		150,
		144,
		122,
		115,
		112,
		105,
		118,
		128,
		133,
		120,
		-1,
		-1,
		-1,
		228,
		214,
		218,
		178,
		197,
		-1,
		-1,
		263,
		218,
		204,
		-1,
		188,
		187,
		175,
		165,
		155,
		160,
		161,
		141,
		134,
		120,
		122,
		116,
		107,
		106,
		122,
		114,
		136,
		-1,
		-1,
		211,
		216,
		204,
		190,
		209,
		-1,
		-1,
		-1,
		210,
		226,
		215,
		189,
		176,
		-1,
		-1,
		159,
		152,
		146,
		137,
		124,
		136,
		131,
		115,
		100,
		115,
		119,
		127,
		118,
		-1,
		214,
		201,
		-1,
		-1,
		212,
		206,
		-1,
		-1,
		-1,
		-1,
		227,
		172,
		161,
		156,
		160,
		158,
		-1,
		132,
		143,
		128,
		140,
		147,
		117,
		102,
		96,
		102,
		114,
		123,
		-1,
		-1,
		226,
		-1,
		216,
		-1,
		-1,
		-1,
		-1,
		184,
		178,
		149,
		142,
		146,
		-1,
		134,
		136,
		130,
		145,
		120,
		117,
		108,
		99,
		95,
		99,
		103,
		117,
		121,
		249,
		-1,
		207,
		-1,
		-1,
		-1,
		202,
		217,
		188,
		165,
		138,
		133,
		126,
		120,
		125,
		136,
		128,
		139,
		106,
		102,
		92,
		91,
		95,
		112,
		112,
		-1,
		-1,
		205,
		201,
		228,
		210,
		214,
		215,
		-1,
		-1,
		142,
		133,
		124,
		116,
		129,
		132,
		112,
		109,
		103,
		96,
		90,
		100,
		111,
		106,
		-1,
		-1,
		-1,
		217,
		-1,
		219,
		-1,
		-1,
		207,
		213,
		160,
		142,
		138,
		136,
		125,
		119,
		107,
		112,
		113,
		104,
		98,
		86,
		86,
		109,
		98,
		115,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		196,
		188,
		183,
		189,
		191,
		182,
		175,
		172,
		-1,
		142,
		148,
		113,
		120,
		103,
		110,
		108,
		100,
		80,
		83,
		99,
		98,
		93,
		107,
		98,
		102,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		189,
		185,
		175,
		165,
		168,
		-1,
		-1,
		162,
		159,
		139,
		108,
		111,
		104,
		99,
		106,
		87,
		76,
		76,
		71,
		86,
		91,
		93,
		86,
		93,
		108,
		-1,
		236,
		273,
		266,
		234,
		242,
		273,
		-1,
		179,
		171,
		182,
		157,
		159,
		-1,
		-1,
		135,
		126,
		127,
		115,
		112,
		119,
		114,
		91,
		85,
		91,
		69,
		76,
		87,
		79,
		83,
		84,
		87,
		100,
		104,
		-1,
		229,
		249,
		228,
		231,
		255,
		269,
		-1,
		176,
		-1,
		-1,
		177,
		160,
		144,
		134,
		131,
		174,
		121,
		116,
		93,
		91,
		88,
		79,
		93,
		77,
		65,
		62,
		71,
		76,
		68,
		94,
		93,
		86,
		-1,
		218,
		229,
		222,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		-1,
		167,
		-1,
		171,
		-1,
		154,
		158,
		129,
		132,
		107,
		94,
		80,
		80,
		86,
		77,
		73,
		69,
		58,
		67,
		78,
		90,
		100,
		102,
		243,
		199,
		202,
		213,
		224,
		239,
		243,
		-1,
		188,
		227,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		168,
		142,
		134,
		127,
		106,
		106,
		72,
		68,
		81,
		78,
		84,
		75,
		60,
		71,
		84,
		95,
		94,
		239,
		230,
		243,
		188,
		188,
		209,
		218,
		239,
		203,
		194,
		221,
		180,
		169,
		164,
		151,
		-1,
		-1,
		149,
		152,
		-1,
		-1,
		113,
		89,
		76,
		70,
		74,
		88,
		84,
		72,
		52,
		72,
		66,
		90,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		179,
		206,
		-1,
		-1,
		201,
		222,
		212,
		213,
		211,
		236,
		-1,
		140,
		-1,
		-1,
		129,
		-1,
		-1,
		114,
		94,
		83,
		74,
		60,
		82,
		88,
		99,
		48,
		65,
		71,
		78,
		75,
		216,
		213,
		201,
		199,
		222,
		187,
		175,
		-1,
		188,
		186,
		192,
		199,
		214,
		225,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		71,
		57,
		84,
		65,
		57,
		51,
		45,
		52,
		65,
		76,
		68,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		173,
		185,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		71,
		57,
		53,
		53,
		48,
		43,
		54,
		55,
		59,
		62,
		-1,
		259,
		-1,
		211,
		187,
		201,
		216,
		224,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		89,
		57,
		47,
		47,
		37,
		48,
		53,
		61,
		55,
		58,
		-1,
		-1,
		196,
		179,
		-1,
		-1,
		153,
		155,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		77,
		71,
		60,
		53,
		51,
		33,
		45,
		41,
		51,
		61,
		52,
		-1,
		-1,
		174,
		166,
		160,
		-1,
		138,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		115,
		78,
		96,
		78,
		45,
		43,
		35,
		29,
		36,
		46,
		46,
		52,
		-1,
		-1,
		-1,
		156,
		130,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		98,
		-1,
		73,
		76,
		81,
		53,
		53,
		39,
		26,
		29,
		35,
		44,
		42,
		162,
		-1,
		132,
		165,
		129,
		123,
		99,
		103,
		119,
		-1,
		95,
		77,
		-1,
		88,
		75,
		54,
		29,
		13,
		22,
		26,
		34,
		39,
		-1,
		-1,
		-1,
		134,
		133,
		125,
		119,
		119,
		104,
		95,
		-1,
		107,
		89,
		68,
		83,
		68,
		59,
		59,
		44,
		40,
		0,
		2,
		27,
		-1,
		235,
		-1,
		-1,
		157,
		-1,
		-1,
		-1,
		128,
		123,
		96,
		84,
		90,
		86,
		72,
		78,
		78,
		71,
		61,
		58,
		51,
		45,
		21,
		30,
		65,
		-1,
		230,
		-1,
		164,
		-1,
		-1,
		146,
		126,
		118,
		107,
		96,
		94,
		85,
		76,
		98,
		102,
		50,
		42,
		37,
		38,
		-1,
		219,
		218,
		-1,
		165,
		157,
		143,
		-1,
		136,
		-1,
		142,
		103,
		-1,
		105,
		85,
		-1,
		53,
		42,
		-1,
		-1,
		206,
		181,
		-1,
		-1,
		-1,
		166,
		146,
		137,
		121,
		-1,
		96,
		96,
		-1,
		-1,
		-1,
		191,
		190,
		-1,
		159,
		162,
		-1,
		152,
		143,
		151,
		98,
		102,
		-1,
		-1,
		-1,
		200,
		181,
		175,
		174,
		172,
		167,
		164,
		150,
		134,
		112,
		101,
		122,
		-1,
		-1,
		-1,
		172,
		164,
		157,
		-1,
		-1,
		159,
		142,
		123,
		121,
		-1,
		-1,
		-1,
		194,
		175,
		-1,
		-1,
		149,
		-1,
		-1,
		155,
		120,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		183,
		-1,
		-1,
		-1,
		145,
		141,
		142,
		-1,
		-1,
		-1,
		-1,
		205,
		206,
		229,
		193,
		-1,
		-1,
		-1,
		137,
		131,
		-1,
		-1,
		208,
		206,
		-1,
		-1,
		-1,
		165,
		149,
		-1,
		135,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		168,
		-1,
		-1,
		-1,
		170,
		-1,
		170,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		183,
		175,
		183,
		-1,
		155,
		157,
		-1,
		205,
		-1,
		-1,
		198,
		189,
		-1,
		-1,
		160,
		167,
		189,
		192,
		228,
		-1,
		179
	],
	[
		-1,
		250,
		239,
		250,
		258,
		231,
		238,
		-1,
		257,
		261,
		227,
		221,
		260,
		229,
		235,
		246,
		-1,
		-1,
		-1,
		250,
		249,
		217,
		215,
		224,
		229,
		236,
		-1,
		235,
		-1,
		271,
		250,
		261,
		266,
		210,
		207,
		227,
		246,
		228,
		220,
		286,
		240,
		211,
		205,
		223,
		213,
		222,
		214,
		-1,
		211,
		201,
		223,
		202,
		213,
		205,
		-1,
		-1,
		205,
		206,
		212,
		198,
		204,
		200,
		-1,
		210,
		194,
		-1,
		-1,
		195,
		196,
		180,
		183,
		191,
		189,
		202,
		194,
		189,
		-1,
		-1,
		186,
		182,
		189,
		176,
		172,
		189,
		202,
		184,
		198,
		197,
		-1,
		190,
		208,
		215,
		183,
		181,
		165,
		163,
		181,
		183,
		189,
		189,
		-1,
		199,
		200,
		195,
		203,
		205,
		181,
		168,
		168,
		178,
		171,
		190,
		178,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		199,
		182,
		199,
		191,
		181,
		196,
		189,
		171,
		168,
		166,
		163,
		179,
		177,
		187,
		-1,
		-1,
		292,
		261,
		290,
		248,
		229,
		-1,
		195,
		175,
		181,
		185,
		179,
		172,
		186,
		182,
		-1,
		157,
		156,
		184,
		170,
		181,
		252,
		-1,
		-1,
		250,
		242,
		225,
		228,
		205,
		201,
		190,
		189,
		181,
		167,
		163,
		169,
		172,
		172,
		178,
		151,
		161,
		165,
		163,
		188,
		-1,
		-1,
		223,
		-1,
		-1,
		249,
		232,
		-1,
		215,
		222,
		211,
		217,
		203,
		224,
		200,
		191,
		183,
		177,
		165,
		167,
		164,
		177,
		165,
		148,
		173,
		177,
		158,
		179,
		174,
		-1,
		222,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		208,
		211,
		217,
		241,
		240,
		-1,
		212,
		200,
		201,
		186,
		183,
		170,
		158,
		171,
		156,
		163,
		162,
		152,
		150,
		180,
		155,
		177,
		174,
		193,
		198,
		192,
		201,
		-1,
		257,
		253,
		249,
		256,
		205,
		-1,
		-1,
		245,
		-1,
		248,
		249,
		224,
		197,
		200,
		187,
		178,
		165,
		154,
		165,
		154,
		151,
		159,
		144,
		159,
		150,
		149,
		167,
		177,
		185,
		189,
		195,
		-1,
		307,
		-1,
		249,
		233,
		235,
		207,
		228,
		-1,
		265,
		249,
		241,
		226,
		226,
		-1,
		196,
		193,
		183,
		161,
		146,
		163,
		155,
		153,
		157,
		139,
		153,
		144,
		162,
		169,
		167,
		171,
		191,
		203,
		267,
		257,
		-1,
		239,
		244,
		203,
		211,
		230,
		268,
		232,
		-1,
		227,
		-1,
		198,
		211,
		-1,
		167,
		163,
		145,
		146,
		141,
		156,
		150,
		135,
		132,
		150,
		153,
		160,
		164,
		180,
		-1,
		-1,
		252,
		256,
		245,
		196,
		215,
		239,
		276,
		225,
		214,
		213,
		-1,
		204,
		181,
		178,
		166,
		153,
		138,
		139,
		147,
		160,
		139,
		134,
		131,
		151,
		177,
		155,
		167,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		222,
		193,
		217,
		259,
		243,
		236,
		224,
		189,
		189,
		183,
		-1,
		177,
		156,
		147,
		136,
		134,
		147,
		144,
		149,
		129,
		127,
		146,
		158,
		149,
		166,
		-1,
		-1,
		-1,
		252,
		241,
		242,
		188,
		211,
		248,
		222,
		208,
		213,
		188,
		181,
		175,
		190,
		173,
		154,
		143,
		135,
		124,
		140,
		148,
		143,
		125,
		134,
		140,
		164,
		154,
		160,
		-1,
		-1,
		259,
		249,
		233,
		235,
		232,
		202,
		209,
		241,
		213,
		226,
		-1,
		180,
		-1,
		169,
		164,
		148,
		143,
		140,
		137,
		131,
		140,
		142,
		132,
		127,
		134,
		169,
		169,
		144,
		164,
		167,
		-1,
		-1,
		-1,
		252,
		247,
		222,
		199,
		183,
		219,
		-1,
		196,
		197,
		-1,
		174,
		168,
		165,
		150,
		146,
		141,
		145,
		138,
		145,
		138,
		136,
		137,
		119,
		151,
		-1,
		152,
		146,
		154,
		144,
		132,
		-1,
		-1,
		-1,
		245,
		224,
		217,
		237,
		178,
		230,
		-1,
		-1,
		181,
		174,
		-1,
		161,
		143,
		150,
		148,
		142,
		146,
		143,
		132,
		145,
		138,
		124,
		126,
		139,
		143,
		147,
		134,
		130,
		127,
		141,
		-1,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		198,
		-1,
		190,
		182,
		172,
		166,
		160,
		156,
		154,
		170,
		154,
		157,
		155,
		146,
		154,
		127,
		120,
		127,
		116,
		134,
		142,
		134,
		128,
		127,
		137,
		-1,
		265,
		251,
		222,
		-1,
		-1,
		211,
		-1,
		175,
		189,
		205,
		-1,
		198,
		177,
		192,
		170,
		166,
		162,
		177,
		178,
		156,
		155,
		153,
		144,
		132,
		121,
		124,
		116,
		138,
		138,
		122,
		123,
		127,
		-1,
		271,
		258,
		216,
		212,
		201,
		221,
		172,
		160,
		192,
		-1,
		-1,
		234,
		-1,
		168,
		185,
		176,
		174,
		167,
		158,
		164,
		164,
		141,
		136,
		126,
		115,
		115,
		110,
		132,
		118,
		116,
		125,
		141,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		187,
		174,
		168,
		-1,
		209,
		-1,
		212,
		202,
		186,
		171,
		204,
		-1,
		169,
		159,
		164,
		-1,
		161,
		-1,
		134,
		131,
		122,
		107,
		104,
		115,
		113,
		124,
		120,
		-1,
		221,
		206,
		199,
		189,
		203,
		174,
		-1,
		229,
		-1,
		-1,
		199,
		193,
		193,
		177,
		180,
		185,
		165,
		157,
		164,
		156,
		148,
		142,
		120,
		113,
		110,
		103,
		116,
		126,
		131,
		118,
		-1,
		-1,
		-1,
		226,
		212,
		216,
		176,
		195,
		-1,
		-1,
		261,
		216,
		202,
		-1,
		186,
		185,
		173,
		163,
		153,
		158,
		159,
		139,
		132,
		118,
		120,
		114,
		105,
		104,
		120,
		112,
		134,
		-1,
		-1,
		209,
		214,
		202,
		188,
		207,
		-1,
		-1,
		-1,
		208,
		224,
		213,
		187,
		174,
		-1,
		-1,
		157,
		150,
		144,
		135,
		122,
		134,
		129,
		113,
		98,
		113,
		117,
		125,
		116,
		-1,
		212,
		199,
		-1,
		-1,
		210,
		204,
		-1,
		-1,
		-1,
		-1,
		225,
		170,
		159,
		154,
		158,
		156,
		-1,
		130,
		141,
		126,
		138,
		145,
		115,
		100,
		94,
		100,
		112,
		121,
		-1,
		-1,
		224,
		-1,
		214,
		-1,
		-1,
		-1,
		-1,
		182,
		176,
		147,
		140,
		144,
		-1,
		132,
		134,
		128,
		143,
		118,
		115,
		106,
		97,
		93,
		97,
		101,
		115,
		119,
		247,
		-1,
		205,
		-1,
		-1,
		-1,
		200,
		215,
		186,
		163,
		136,
		131,
		124,
		118,
		123,
		134,
		126,
		137,
		104,
		100,
		90,
		89,
		93,
		110,
		110,
		-1,
		-1,
		203,
		199,
		226,
		208,
		212,
		213,
		-1,
		-1,
		140,
		131,
		122,
		114,
		127,
		130,
		110,
		107,
		101,
		94,
		88,
		98,
		109,
		104,
		-1,
		-1,
		-1,
		215,
		-1,
		217,
		-1,
		-1,
		205,
		211,
		158,
		140,
		136,
		134,
		123,
		117,
		105,
		110,
		111,
		102,
		96,
		84,
		84,
		107,
		96,
		113,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		194,
		186,
		181,
		187,
		189,
		180,
		173,
		170,
		-1,
		140,
		146,
		111,
		118,
		101,
		108,
		106,
		98,
		78,
		81,
		97,
		96,
		91,
		105,
		96,
		100,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		187,
		183,
		173,
		163,
		166,
		-1,
		-1,
		160,
		157,
		137,
		106,
		109,
		102,
		97,
		104,
		85,
		74,
		74,
		69,
		84,
		89,
		91,
		84,
		91,
		106,
		-1,
		234,
		271,
		264,
		232,
		240,
		271,
		-1,
		177,
		169,
		180,
		155,
		157,
		-1,
		-1,
		133,
		124,
		125,
		113,
		110,
		117,
		112,
		89,
		83,
		89,
		67,
		74,
		85,
		77,
		81,
		82,
		85,
		98,
		102,
		-1,
		227,
		247,
		226,
		229,
		253,
		267,
		-1,
		174,
		-1,
		-1,
		176,
		158,
		142,
		132,
		129,
		172,
		119,
		114,
		91,
		89,
		86,
		77,
		91,
		75,
		63,
		60,
		69,
		74,
		66,
		92,
		91,
		84,
		-1,
		216,
		227,
		220,
		-1,
		-1,
		-1,
		-1,
		175,
		-1,
		-1,
		166,
		-1,
		169,
		-1,
		152,
		156,
		127,
		130,
		105,
		92,
		78,
		78,
		84,
		75,
		71,
		67,
		56,
		65,
		76,
		88,
		98,
		100,
		241,
		197,
		200,
		211,
		222,
		237,
		241,
		-1,
		186,
		225,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		166,
		140,
		132,
		125,
		104,
		104,
		70,
		66,
		79,
		76,
		82,
		73,
		58,
		69,
		82,
		93,
		92,
		237,
		228,
		241,
		186,
		186,
		207,
		216,
		237,
		201,
		192,
		219,
		179,
		168,
		163,
		150,
		-1,
		-1,
		147,
		150,
		-1,
		-1,
		111,
		87,
		74,
		68,
		72,
		86,
		82,
		70,
		50,
		70,
		64,
		88,
		-1,
		230,
		229,
		218,
		215,
		191,
		182,
		177,
		204,
		-1,
		-1,
		199,
		220,
		210,
		212,
		210,
		235,
		-1,
		139,
		-1,
		-1,
		127,
		-1,
		-1,
		112,
		92,
		81,
		72,
		58,
		80,
		86,
		97,
		46,
		63,
		69,
		76,
		73,
		214,
		211,
		199,
		197,
		220,
		185,
		173,
		-1,
		186,
		184,
		190,
		197,
		213,
		224,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		110,
		108,
		97,
		-1,
		87,
		69,
		55,
		82,
		63,
		55,
		49,
		43,
		50,
		63,
		74,
		66,
		223,
		237,
		226,
		222,
		221,
		229,
		178,
		171,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		105,
		98,
		86,
		74,
		64,
		69,
		55,
		51,
		51,
		46,
		41,
		52,
		53,
		57,
		60,
		-1,
		257,
		-1,
		209,
		185,
		199,
		214,
		222,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		139,
		123,
		104,
		-1,
		74,
		87,
		87,
		55,
		47,
		45,
		35,
		46,
		51,
		59,
		53,
		56,
		-1,
		-1,
		195,
		178,
		-1,
		-1,
		152,
		154,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		111,
		107,
		-1,
		-1,
		75,
		69,
		58,
		53,
		49,
		31,
		43,
		39,
		49,
		59,
		50,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		113,
		76,
		95,
		76,
		45,
		43,
		33,
		27,
		34,
		44,
		44,
		50,
		-1,
		-1,
		-1,
		155,
		129,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		97,
		-1,
		72,
		75,
		80,
		53,
		55,
		41,
		24,
		27,
		33,
		42,
		40,
		161,
		-1,
		131,
		164,
		128,
		122,
		98,
		102,
		118,
		-1,
		94,
		76,
		-1,
		87,
		74,
		56,
		31,
		15,
		20,
		24,
		32,
		37,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		103,
		94,
		-1,
		106,
		88,
		67,
		82,
		67,
		58,
		58,
		46,
		42,
		2,
		0,
		25,
		-1,
		234,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		122,
		95,
		83,
		89,
		85,
		71,
		77,
		77,
		70,
		60,
		57,
		50,
		44,
		23,
		28,
		63,
		-1,
		229,
		-1,
		163,
		-1,
		-1,
		145,
		125,
		117,
		106,
		95,
		93,
		84,
		75,
		97,
		101,
		49,
		40,
		35,
		36,
		-1,
		218,
		217,
		-1,
		164,
		156,
		142,
		-1,
		135,
		-1,
		141,
		102,
		-1,
		104,
		84,
		-1,
		51,
		40,
		-1,
		-1,
		205,
		180,
		-1,
		-1,
		-1,
		165,
		145,
		136,
		120,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		190,
		189,
		-1,
		158,
		161,
		-1,
		151,
		142,
		150,
		97,
		101,
		-1,
		-1,
		-1,
		199,
		180,
		174,
		173,
		171,
		166,
		163,
		149,
		133,
		111,
		100,
		121,
		-1,
		-1,
		-1,
		171,
		163,
		156,
		-1,
		-1,
		158,
		141,
		122,
		120,
		-1,
		-1,
		-1,
		193,
		174,
		-1,
		-1,
		148,
		-1,
		-1,
		154,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		182,
		-1,
		-1,
		-1,
		144,
		140,
		141,
		-1,
		-1,
		-1,
		-1,
		204,
		205,
		228,
		192,
		-1,
		-1,
		-1,
		136,
		130,
		-1,
		-1,
		207,
		205,
		-1,
		-1,
		-1,
		164,
		148,
		-1,
		134,
		-1,
		-1,
		-1,
		155,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		169,
		-1,
		169,
		144,
		151,
		-1,
		-1,
		-1,
		-1,
		182,
		174,
		182,
		-1,
		154,
		156,
		-1,
		204,
		-1,
		-1,
		197,
		188,
		-1,
		-1,
		159,
		166,
		188,
		191,
		227,
		-1,
		178
	],
	[
		-1,
		246,
		235,
		246,
		254,
		227,
		234,
		-1,
		253,
		257,
		223,
		217,
		256,
		225,
		231,
		242,
		-1,
		-1,
		-1,
		246,
		245,
		213,
		211,
		220,
		225,
		232,
		-1,
		231,
		-1,
		267,
		246,
		257,
		262,
		206,
		203,
		223,
		242,
		224,
		216,
		282,
		236,
		207,
		201,
		219,
		209,
		218,
		210,
		-1,
		207,
		197,
		219,
		198,
		209,
		201,
		-1,
		-1,
		201,
		202,
		208,
		194,
		200,
		196,
		-1,
		206,
		190,
		-1,
		-1,
		191,
		192,
		176,
		179,
		187,
		185,
		198,
		190,
		185,
		-1,
		-1,
		182,
		178,
		185,
		172,
		168,
		185,
		198,
		180,
		194,
		193,
		-1,
		186,
		204,
		211,
		179,
		177,
		161,
		159,
		177,
		179,
		185,
		185,
		-1,
		195,
		196,
		191,
		199,
		201,
		177,
		164,
		164,
		174,
		167,
		186,
		174,
		220,
		-1,
		-1,
		-1,
		-1,
		-1,
		229,
		195,
		178,
		195,
		187,
		177,
		192,
		185,
		167,
		164,
		162,
		159,
		175,
		173,
		183,
		-1,
		-1,
		288,
		257,
		286,
		244,
		225,
		-1,
		191,
		171,
		177,
		181,
		175,
		168,
		182,
		178,
		-1,
		153,
		152,
		180,
		166,
		177,
		248,
		-1,
		-1,
		246,
		238,
		221,
		224,
		201,
		197,
		186,
		185,
		177,
		163,
		159,
		165,
		168,
		168,
		174,
		147,
		157,
		161,
		159,
		184,
		-1,
		-1,
		219,
		-1,
		-1,
		245,
		228,
		-1,
		211,
		218,
		207,
		213,
		199,
		220,
		196,
		187,
		179,
		173,
		161,
		163,
		160,
		173,
		161,
		144,
		169,
		173,
		154,
		175,
		170,
		-1,
		218,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		204,
		207,
		213,
		237,
		236,
		-1,
		208,
		196,
		197,
		182,
		179,
		166,
		154,
		167,
		152,
		159,
		158,
		148,
		146,
		176,
		151,
		173,
		170,
		189,
		194,
		188,
		197,
		-1,
		253,
		249,
		245,
		252,
		201,
		-1,
		-1,
		241,
		-1,
		244,
		245,
		220,
		193,
		196,
		183,
		174,
		161,
		150,
		161,
		150,
		147,
		155,
		140,
		155,
		146,
		145,
		163,
		173,
		181,
		185,
		191,
		-1,
		303,
		-1,
		245,
		229,
		231,
		203,
		224,
		-1,
		261,
		245,
		237,
		222,
		222,
		-1,
		192,
		189,
		179,
		157,
		142,
		159,
		151,
		149,
		153,
		135,
		149,
		140,
		158,
		165,
		163,
		167,
		187,
		199,
		263,
		253,
		-1,
		235,
		240,
		199,
		207,
		226,
		264,
		228,
		-1,
		223,
		-1,
		194,
		207,
		-1,
		163,
		159,
		141,
		142,
		137,
		152,
		146,
		131,
		128,
		146,
		149,
		156,
		160,
		176,
		-1,
		-1,
		248,
		252,
		241,
		192,
		211,
		235,
		272,
		221,
		210,
		209,
		-1,
		200,
		177,
		174,
		162,
		149,
		134,
		135,
		143,
		156,
		135,
		130,
		127,
		147,
		173,
		151,
		163,
		-1,
		-1,
		-1,
		273,
		-1,
		-1,
		218,
		189,
		213,
		255,
		239,
		232,
		220,
		185,
		185,
		179,
		-1,
		173,
		152,
		143,
		132,
		130,
		143,
		140,
		145,
		125,
		123,
		142,
		154,
		145,
		162,
		-1,
		-1,
		-1,
		248,
		237,
		238,
		184,
		207,
		244,
		218,
		204,
		209,
		184,
		177,
		171,
		186,
		169,
		150,
		139,
		131,
		120,
		136,
		144,
		139,
		121,
		130,
		136,
		160,
		150,
		156,
		-1,
		-1,
		255,
		245,
		229,
		231,
		228,
		198,
		205,
		237,
		209,
		222,
		-1,
		176,
		-1,
		165,
		160,
		144,
		139,
		136,
		133,
		127,
		136,
		138,
		128,
		123,
		130,
		165,
		165,
		140,
		160,
		163,
		-1,
		-1,
		-1,
		248,
		243,
		218,
		195,
		179,
		215,
		-1,
		192,
		193,
		-1,
		170,
		164,
		161,
		146,
		142,
		137,
		141,
		134,
		141,
		134,
		132,
		133,
		115,
		147,
		-1,
		148,
		142,
		150,
		140,
		128,
		-1,
		-1,
		-1,
		241,
		220,
		213,
		233,
		174,
		226,
		-1,
		-1,
		177,
		170,
		-1,
		157,
		139,
		146,
		144,
		138,
		142,
		139,
		128,
		141,
		134,
		120,
		122,
		135,
		139,
		143,
		130,
		126,
		123,
		137,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		194,
		-1,
		186,
		178,
		168,
		162,
		156,
		152,
		150,
		166,
		150,
		153,
		151,
		142,
		150,
		123,
		116,
		123,
		112,
		130,
		138,
		130,
		124,
		123,
		133,
		-1,
		261,
		247,
		218,
		-1,
		-1,
		207,
		-1,
		171,
		185,
		201,
		-1,
		194,
		173,
		188,
		166,
		162,
		158,
		173,
		174,
		152,
		151,
		149,
		140,
		128,
		117,
		120,
		112,
		134,
		134,
		118,
		119,
		123,
		-1,
		267,
		254,
		212,
		208,
		197,
		217,
		168,
		156,
		188,
		-1,
		-1,
		230,
		-1,
		164,
		181,
		172,
		170,
		163,
		154,
		160,
		160,
		137,
		132,
		122,
		111,
		111,
		106,
		128,
		114,
		112,
		121,
		132,
		-1,
		-1,
		-1,
		234,
		-1,
		-1,
		183,
		170,
		164,
		-1,
		205,
		-1,
		208,
		198,
		182,
		167,
		200,
		-1,
		161,
		155,
		160,
		-1,
		157,
		-1,
		130,
		127,
		118,
		103,
		100,
		111,
		109,
		120,
		116,
		-1,
		217,
		202,
		195,
		185,
		199,
		170,
		-1,
		225,
		-1,
		-1,
		195,
		189,
		189,
		173,
		176,
		177,
		157,
		149,
		160,
		152,
		144,
		138,
		116,
		109,
		106,
		99,
		112,
		122,
		127,
		114,
		-1,
		-1,
		-1,
		222,
		208,
		212,
		172,
		191,
		-1,
		-1,
		257,
		212,
		198,
		-1,
		182,
		177,
		165,
		155,
		145,
		150,
		151,
		135,
		128,
		114,
		116,
		110,
		101,
		100,
		116,
		108,
		130,
		-1,
		-1,
		205,
		210,
		198,
		184,
		203,
		-1,
		-1,
		-1,
		204,
		220,
		205,
		183,
		166,
		-1,
		-1,
		149,
		142,
		136,
		131,
		118,
		130,
		125,
		109,
		94,
		109,
		113,
		121,
		112,
		-1,
		208,
		195,
		-1,
		-1,
		206,
		200,
		-1,
		-1,
		-1,
		-1,
		217,
		162,
		151,
		146,
		150,
		148,
		-1,
		122,
		133,
		122,
		134,
		141,
		111,
		96,
		90,
		96,
		108,
		117,
		-1,
		-1,
		220,
		-1,
		210,
		-1,
		-1,
		-1,
		-1,
		174,
		168,
		139,
		132,
		136,
		-1,
		124,
		126,
		123,
		135,
		114,
		111,
		102,
		93,
		89,
		93,
		97,
		104,
		110,
		243,
		-1,
		201,
		-1,
		-1,
		-1,
		192,
		207,
		178,
		155,
		128,
		123,
		116,
		110,
		115,
		126,
		122,
		133,
		100,
		96,
		86,
		85,
		89,
		106,
		106,
		-1,
		-1,
		199,
		195,
		218,
		200,
		204,
		205,
		-1,
		-1,
		132,
		123,
		114,
		106,
		119,
		122,
		106,
		103,
		97,
		90,
		84,
		94,
		105,
		100,
		-1,
		-1,
		-1,
		211,
		-1,
		213,
		-1,
		-1,
		201,
		203,
		150,
		132,
		128,
		126,
		115,
		109,
		97,
		102,
		107,
		98,
		92,
		80,
		80,
		103,
		92,
		98,
		-1,
		-1,
		283,
		-1,
		-1,
		-1,
		190,
		182,
		177,
		183,
		185,
		176,
		165,
		162,
		-1,
		132,
		138,
		103,
		110,
		93,
		100,
		102,
		94,
		74,
		77,
		93,
		92,
		85,
		90,
		81,
		89,
		-1,
		-1,
		276,
		265,
		254,
		260,
		-1,
		183,
		179,
		169,
		159,
		162,
		-1,
		-1,
		156,
		153,
		133,
		102,
		101,
		94,
		89,
		99,
		75,
		70,
		70,
		65,
		80,
		85,
		82,
		75,
		80,
		95,
		-1,
		230,
		267,
		260,
		228,
		236,
		267,
		-1,
		173,
		165,
		176,
		151,
		153,
		-1,
		-1,
		129,
		120,
		121,
		109,
		106,
		113,
		108,
		85,
		79,
		85,
		63,
		70,
		81,
		73,
		77,
		78,
		67,
		80,
		84,
		-1,
		223,
		243,
		222,
		225,
		249,
		263,
		-1,
		170,
		-1,
		-1,
		152,
		154,
		138,
		128,
		125,
		168,
		115,
		110,
		87,
		85,
		82,
		73,
		87,
		71,
		59,
		56,
		65,
		70,
		62,
		77,
		73,
		66,
		-1,
		212,
		223,
		216,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		142,
		-1,
		165,
		-1,
		148,
		152,
		123,
		126,
		101,
		88,
		74,
		74,
		80,
		71,
		67,
		63,
		52,
		54,
		66,
		70,
		80,
		82,
		237,
		193,
		196,
		207,
		218,
		233,
		237,
		-1,
		182,
		221,
		148,
		-1,
		132,
		-1,
		-1,
		-1,
		162,
		136,
		128,
		121,
		100,
		100,
		66,
		62,
		75,
		72,
		78,
		69,
		54,
		53,
		64,
		75,
		74,
		233,
		224,
		237,
		182,
		182,
		203,
		212,
		233,
		197,
		188,
		215,
		155,
		144,
		139,
		126,
		-1,
		-1,
		143,
		146,
		-1,
		-1,
		107,
		83,
		70,
		64,
		68,
		82,
		78,
		66,
		46,
		52,
		46,
		70,
		-1,
		226,
		225,
		214,
		211,
		187,
		178,
		173,
		200,
		-1,
		-1,
		195,
		216,
		206,
		188,
		186,
		211,
		-1,
		115,
		-1,
		-1,
		123,
		-1,
		-1,
		108,
		88,
		77,
		68,
		54,
		76,
		82,
		93,
		42,
		58,
		51,
		58,
		55,
		210,
		207,
		195,
		193,
		216,
		181,
		169,
		-1,
		182,
		180,
		186,
		193,
		189,
		200,
		-1,
		-1,
		131,
		111,
		-1,
		-1,
		106,
		104,
		93,
		-1,
		83,
		65,
		51,
		78,
		59,
		51,
		45,
		39,
		46,
		45,
		56,
		48,
		219,
		233,
		222,
		218,
		217,
		225,
		174,
		167,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		121,
		117,
		-1,
		-1,
		101,
		94,
		82,
		70,
		60,
		65,
		51,
		47,
		47,
		42,
		37,
		48,
		35,
		39,
		42,
		-1,
		253,
		-1,
		205,
		172,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		138,
		124,
		117,
		105,
		103,
		-1,
		135,
		119,
		100,
		-1,
		70,
		83,
		83,
		51,
		43,
		41,
		31,
		42,
		33,
		41,
		35,
		38,
		-1,
		-1,
		171,
		154,
		-1,
		-1,
		128,
		130,
		-1,
		129,
		118,
		103,
		95,
		-1,
		-1,
		107,
		103,
		-1,
		-1,
		61,
		65,
		54,
		49,
		45,
		27,
		39,
		35,
		31,
		41,
		32,
		-1,
		-1,
		149,
		141,
		135,
		-1,
		113,
		-1,
		131,
		-1,
		98,
		104,
		92,
		-1,
		-1,
		-1,
		92,
		55,
		71,
		72,
		41,
		39,
		30,
		23,
		30,
		33,
		26,
		32,
		-1,
		-1,
		-1,
		131,
		105,
		138,
		129,
		112,
		92,
		84,
		103,
		-1,
		73,
		-1,
		48,
		51,
		56,
		49,
		52,
		46,
		20,
		33,
		25,
		24,
		22,
		137,
		-1,
		107,
		140,
		104,
		98,
		74,
		78,
		94,
		-1,
		70,
		52,
		-1,
		63,
		50,
		63,
		47,
		29,
		16,
		7,
		11,
		19,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		94,
		79,
		70,
		-1,
		82,
		64,
		43,
		58,
		43,
		34,
		34,
		53,
		49,
		29,
		27,
		0,
		-1,
		210,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		98,
		71,
		59,
		65,
		61,
		47,
		53,
		53,
		46,
		36,
		33,
		29,
		20,
		26,
		3,
		38,
		-1,
		205,
		-1,
		139,
		-1,
		-1,
		121,
		101,
		93,
		82,
		71,
		69,
		60,
		51,
		73,
		77,
		27,
		15,
		10,
		11,
		-1,
		194,
		193,
		-1,
		140,
		132,
		118,
		-1,
		111,
		-1,
		117,
		78,
		-1,
		80,
		60,
		-1,
		26,
		15,
		-1,
		-1,
		181,
		156,
		-1,
		-1,
		-1,
		141,
		121,
		112,
		96,
		-1,
		71,
		71,
		-1,
		-1,
		-1,
		166,
		165,
		-1,
		134,
		137,
		-1,
		127,
		118,
		126,
		73,
		77,
		-1,
		-1,
		-1,
		175,
		156,
		150,
		149,
		147,
		142,
		139,
		125,
		109,
		87,
		76,
		97,
		-1,
		-1,
		-1,
		147,
		139,
		132,
		-1,
		-1,
		134,
		117,
		98,
		96,
		-1,
		-1,
		-1,
		169,
		150,
		-1,
		-1,
		124,
		-1,
		-1,
		130,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		158,
		-1,
		-1,
		-1,
		120,
		116,
		117,
		-1,
		-1,
		-1,
		-1,
		180,
		181,
		204,
		168,
		-1,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		183,
		181,
		-1,
		-1,
		-1,
		140,
		124,
		-1,
		110,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		145,
		-1,
		145,
		120,
		127,
		-1,
		-1,
		-1,
		-1,
		158,
		150,
		158,
		-1,
		130,
		132,
		-1,
		180,
		-1,
		-1,
		173,
		164,
		-1,
		-1,
		135,
		142,
		164,
		167,
		203,
		-1,
		154
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		390,
		379,
		390,
		398,
		371,
		378,
		-1,
		397,
		401,
		367,
		361,
		400,
		369,
		375,
		386,
		-1,
		-1,
		-1,
		390,
		389,
		357,
		355,
		364,
		369,
		376,
		-1,
		375,
		-1,
		411,
		390,
		401,
		406,
		350,
		347,
		367,
		386,
		368,
		360,
		426,
		380,
		351,
		345,
		363,
		353,
		362,
		354,
		-1,
		351,
		341,
		363,
		342,
		353,
		345,
		-1,
		-1,
		345,
		346,
		352,
		338,
		344,
		340,
		-1,
		350,
		334,
		-1,
		-1,
		335,
		336,
		320,
		323,
		331,
		329,
		342,
		334,
		329,
		-1,
		-1,
		326,
		322,
		329,
		316,
		312,
		329,
		342,
		324,
		338,
		337,
		-1,
		330,
		348,
		355,
		323,
		321,
		305,
		303,
		321,
		323,
		329,
		329,
		-1,
		339,
		340,
		335,
		343,
		345,
		321,
		308,
		308,
		318,
		311,
		330,
		318,
		364,
		-1,
		-1,
		-1,
		-1,
		-1,
		373,
		339,
		322,
		339,
		331,
		321,
		336,
		329,
		311,
		308,
		306,
		303,
		319,
		317,
		327,
		-1,
		-1,
		432,
		401,
		430,
		388,
		369,
		-1,
		335,
		315,
		321,
		325,
		319,
		312,
		326,
		322,
		-1,
		297,
		296,
		324,
		310,
		321,
		392,
		-1,
		-1,
		390,
		382,
		365,
		368,
		345,
		341,
		330,
		329,
		321,
		307,
		303,
		309,
		312,
		312,
		318,
		291,
		301,
		305,
		303,
		328,
		-1,
		-1,
		363,
		-1,
		-1,
		389,
		372,
		-1,
		355,
		362,
		351,
		357,
		343,
		364,
		340,
		331,
		323,
		317,
		305,
		307,
		304,
		317,
		305,
		288,
		313,
		317,
		298,
		319,
		314,
		-1,
		362,
		346,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		367,
		348,
		351,
		357,
		381,
		380,
		-1,
		352,
		340,
		341,
		326,
		323,
		310,
		298,
		311,
		296,
		303,
		302,
		292,
		290,
		320,
		295,
		317,
		314,
		333,
		338,
		332,
		341,
		-1,
		397,
		393,
		389,
		396,
		345,
		-1,
		-1,
		385,
		-1,
		388,
		389,
		364,
		337,
		340,
		327,
		318,
		305,
		294,
		305,
		294,
		291,
		299,
		284,
		299,
		290,
		289,
		307,
		317,
		325,
		329,
		335,
		-1,
		447,
		-1,
		389,
		373,
		375,
		347,
		368,
		-1,
		405,
		389,
		381,
		366,
		366,
		-1,
		336,
		333,
		323,
		301,
		286,
		303,
		295,
		293,
		297,
		279,
		293,
		284,
		302,
		309,
		307,
		311,
		331,
		343,
		407,
		397,
		-1,
		379,
		384,
		343,
		351,
		370,
		408,
		372,
		-1,
		367,
		-1,
		338,
		351,
		-1,
		307,
		303,
		285,
		286,
		281,
		296,
		290,
		275,
		272,
		290,
		293,
		300,
		304,
		320,
		-1,
		-1,
		392,
		396,
		385,
		336,
		355,
		379,
		416,
		365,
		354,
		353,
		-1,
		344,
		321,
		318,
		306,
		293,
		278,
		279,
		287,
		300,
		279,
		274,
		271,
		291,
		317,
		295,
		307,
		-1,
		-1,
		-1,
		417,
		-1,
		-1,
		362,
		333,
		357,
		399,
		383,
		376,
		364,
		329,
		329,
		323,
		-1,
		317,
		296,
		287,
		276,
		274,
		287,
		284,
		289,
		269,
		267,
		286,
		298,
		289,
		306,
		-1,
		-1,
		-1,
		392,
		381,
		382,
		328,
		351,
		388,
		362,
		348,
		353,
		328,
		321,
		315,
		330,
		313,
		294,
		283,
		275,
		264,
		280,
		288,
		283,
		265,
		274,
		280,
		304,
		294,
		300,
		-1,
		-1,
		399,
		389,
		373,
		375,
		372,
		342,
		349,
		381,
		353,
		366,
		-1,
		320,
		-1,
		309,
		304,
		288,
		283,
		280,
		277,
		271,
		280,
		282,
		272,
		267,
		274,
		309,
		309,
		284,
		304,
		307,
		-1,
		-1,
		-1,
		392,
		387,
		362,
		339,
		323,
		359,
		-1,
		336,
		337,
		-1,
		314,
		308,
		305,
		290,
		286,
		281,
		285,
		278,
		285,
		278,
		276,
		277,
		259,
		291,
		-1,
		292,
		286,
		294,
		284,
		272,
		-1,
		-1,
		-1,
		385,
		364,
		357,
		377,
		318,
		370,
		-1,
		-1,
		321,
		314,
		-1,
		301,
		283,
		290,
		288,
		282,
		286,
		283,
		272,
		285,
		278,
		264,
		266,
		279,
		283,
		287,
		274,
		270,
		267,
		281,
		-1,
		404,
		-1,
		-1,
		-1,
		-1,
		-1,
		318,
		338,
		-1,
		330,
		322,
		312,
		306,
		300,
		296,
		294,
		310,
		294,
		297,
		295,
		286,
		294,
		267,
		260,
		267,
		256,
		274,
		282,
		274,
		268,
		267,
		277,
		-1,
		405,
		391,
		362,
		-1,
		-1,
		351,
		-1,
		315,
		329,
		345,
		-1,
		338,
		317,
		332,
		310,
		306,
		302,
		317,
		318,
		295,
		295,
		293,
		284,
		272,
		261,
		264,
		256,
		278,
		278,
		262,
		263,
		267,
		-1,
		411,
		398,
		356,
		352,
		341,
		361,
		312,
		300,
		332,
		-1,
		-1,
		374,
		-1,
		308,
		325,
		316,
		314,
		307,
		289,
		296,
		304,
		281,
		276,
		266,
		255,
		255,
		250,
		272,
		258,
		256,
		265,
		281,
		-1,
		-1,
		-1,
		378,
		-1,
		-1,
		327,
		314,
		308,
		-1,
		349,
		-1,
		352,
		342,
		326,
		311,
		344,
		-1,
		288,
		284,
		291,
		-1,
		301,
		-1,
		274,
		271,
		262,
		247,
		244,
		255,
		253,
		264,
		260,
		-1,
		361,
		346,
		339,
		329,
		343,
		314,
		-1,
		369,
		-1,
		-1,
		339,
		333,
		333,
		317,
		318,
		304,
		284,
		276,
		291,
		290,
		277,
		276,
		260,
		253,
		250,
		243,
		256,
		266,
		271,
		258,
		-1,
		-1,
		-1,
		366,
		332,
		340,
		316,
		335,
		-1,
		-1,
		401,
		356,
		342,
		-1,
		313,
		304,
		292,
		282,
		272,
		277,
		278,
		268,
		266,
		258,
		260,
		254,
		245,
		244,
		260,
		252,
		274,
		-1,
		-1,
		329,
		342,
		342,
		328,
		323,
		-1,
		-1,
		-1,
		348,
		364,
		332,
		311,
		293,
		-1,
		-1,
		276,
		269,
		263,
		266,
		254,
		274,
		269,
		253,
		238,
		253,
		257,
		265,
		256,
		-1,
		332,
		319,
		-1,
		-1,
		322,
		312,
		-1,
		-1,
		-1,
		-1,
		344,
		289,
		278,
		273,
		277,
		275,
		-1,
		249,
		260,
		253,
		272,
		279,
		255,
		240,
		234,
		240,
		252,
		261,
		-1,
		-1,
		336,
		-1,
		298,
		-1,
		-1,
		-1,
		-1,
		301,
		295,
		266,
		259,
		263,
		-1,
		251,
		253,
		250,
		262,
		258,
		255,
		246,
		237,
		233,
		237,
		241,
		255,
		259,
		359,
		-1,
		289,
		-1,
		-1,
		-1,
		319,
		329,
		305,
		282,
		255,
		250,
		243,
		237,
		242,
		253,
		262,
		273,
		238,
		240,
		230,
		229,
		233,
		250,
		254,
		-1,
		-1,
		287,
		283,
		318,
		327,
		302,
		332,
		-1,
		-1,
		259,
		250,
		241,
		233,
		246,
		249,
		234,
		236,
		236,
		234,
		228,
		238,
		253,
		248,
		-1,
		-1,
		-1,
		285,
		-1,
		301,
		-1,
		-1,
		292,
		330,
		277,
		259,
		255,
		244,
		242,
		236,
		224,
		229,
		239,
		233,
		230,
		224,
		228,
		251,
		240,
		279,
		-1,
		-1,
		285,
		-1,
		-1,
		-1,
		251,
		270,
		265,
		271,
		276,
		267,
		292,
		289,
		-1,
		241,
		265,
		230,
		237,
		220,
		227,
		232,
		229,
		218,
		225,
		241,
		240,
		235,
		271,
		262,
		268,
		-1,
		-1,
		278,
		267,
		256,
		262,
		-1,
		244,
		267,
		257,
		247,
		253,
		-1,
		-1,
		259,
		256,
		254,
		230,
		228,
		221,
		216,
		226,
		202,
		214,
		218,
		222,
		228,
		233,
		238,
		244,
		259,
		274,
		-1,
		232,
		269,
		262,
		230,
		238,
		269,
		-1,
		234,
		226,
		254,
		239,
		247,
		-1,
		-1,
		232,
		223,
		228,
		237,
		234,
		240,
		239,
		222,
		228,
		229,
		221,
		220,
		238,
		242,
		251,
		258,
		248,
		261,
		265,
		-1,
		225,
		245,
		224,
		227,
		251,
		265,
		-1,
		225,
		-1,
		-1,
		247,
		257,
		241,
		231,
		228,
		275,
		251,
		246,
		227,
		225,
		220,
		211,
		236,
		229,
		229,
		232,
		247,
		252,
		244,
		258,
		258,
		259,
		-1,
		214,
		225,
		218,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		-1,
		237,
		-1,
		268,
		-1,
		251,
		255,
		259,
		262,
		241,
		228,
		214,
		222,
		228,
		227,
		233,
		233,
		234,
		243,
		254,
		266,
		265,
		266,
		185,
		195,
		198,
		209,
		220,
		235,
		239,
		-1,
		209,
		245,
		243,
		-1,
		227,
		-1,
		-1,
		-1,
		265,
		272,
		264,
		261,
		240,
		240,
		206,
		210,
		223,
		230,
		240,
		251,
		243,
		247,
		260,
		271,
		274,
		181,
		186,
		239,
		184,
		184,
		205,
		214,
		235,
		205,
		202,
		239,
		244,
		239,
		234,
		221,
		-1,
		-1,
		274,
		282,
		-1,
		-1,
		247,
		214,
		202,
		212,
		216,
		230,
		242,
		255,
		243,
		248,
		242,
		274,
		-1,
		181,
		176,
		163,
		158,
		152,
		164,
		175,
		202,
		-1,
		-1,
		203,
		230,
		214,
		218,
		234,
		259,
		-1,
		205,
		-1,
		-1,
		254,
		-1,
		-1,
		239,
		219,
		208,
		199,
		204,
		224,
		235,
		257,
		239,
		256,
		247,
		257,
		261,
		165,
		158,
		146,
		148,
		154,
		183,
		171,
		-1,
		190,
		188,
		194,
		201,
		218,
		248,
		-1,
		-1,
		221,
		201,
		-1,
		-1,
		237,
		235,
		224,
		-1,
		214,
		196,
		201,
		231,
		233,
		235,
		242,
		236,
		243,
		251,
		262,
		254,
		174,
		184,
		173,
		146,
		155,
		168,
		176,
		175,
		187,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		211,
		207,
		-1,
		-1,
		232,
		225,
		213,
		201,
		191,
		201,
		218,
		218,
		221,
		226,
		234,
		245,
		241,
		245,
		248,
		-1,
		183,
		-1,
		207,
		189,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		228,
		214,
		207,
		195,
		193,
		-1,
		266,
		250,
		231,
		-1,
		201,
		214,
		254,
		222,
		227,
		222,
		237,
		248,
		239,
		247,
		241,
		244,
		-1,
		-1,
		191,
		174,
		-1,
		-1,
		148,
		150,
		-1,
		219,
		208,
		193,
		185,
		-1,
		-1,
		238,
		234,
		-1,
		-1,
		188,
		226,
		225,
		233,
		228,
		233,
		245,
		241,
		237,
		247,
		238,
		-1,
		-1,
		169,
		161,
		155,
		-1,
		133,
		-1,
		221,
		-1,
		188,
		197,
		185,
		-1,
		-1,
		-1,
		219,
		182,
		198,
		221,
		247,
		245,
		236,
		229,
		236,
		239,
		232,
		238,
		-1,
		-1,
		-1,
		108,
		128,
		228,
		219,
		202,
		182,
		174,
		196,
		-1,
		200,
		-1,
		175,
		178,
		203,
		242,
		244,
		230,
		226,
		239,
		233,
		230,
		228,
		102,
		-1,
		132,
		191,
		161,
		188,
		154,
		168,
		214,
		-1,
		197,
		179,
		-1,
		207,
		197,
		245,
		220,
		229,
		222,
		216,
		217,
		225,
		-1,
		-1,
		-1,
		147,
		146,
		145,
		151,
		151,
		149,
		166,
		-1,
		202,
		184,
		170,
		187,
		187,
		178,
		186,
		235,
		231,
		234,
		232,
		210,
		-1,
		0,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		160,
		144,
		157,
		168,
		171,
		167,
		167,
		169,
		182,
		190,
		188,
		185,
		197,
		193,
		213,
		209,
		241,
		-1,
		7,
		-1,
		177,
		-1,
		-1,
		122,
		128,
		138,
		149,
		177,
		177,
		166,
		162,
		179,
		214,
		200,
		198,
		203,
		208,
		-1,
		17,
		18,
		-1,
		86,
		96,
		117,
		-1,
		119,
		-1,
		223,
		184,
		-1,
		163,
		157,
		-1,
		209,
		205,
		-1,
		-1,
		29,
		75,
		-1,
		-1,
		-1,
		118,
		127,
		218,
		202,
		-1,
		147,
		154,
		-1,
		-1,
		-1,
		43,
		66,
		-1,
		111,
		114,
		-1,
		128,
		134,
		162,
		142,
		148,
		-1,
		-1,
		-1,
		70,
		54,
		59,
		101,
		96,
		119,
		159,
		145,
		145,
		129,
		139,
		168,
		-1,
		-1,
		-1,
		73,
		70,
		81,
		-1,
		-1,
		170,
		153,
		140,
		138,
		-1,
		-1,
		-1,
		95,
		76,
		-1,
		-1,
		90,
		-1,
		-1,
		135,
		114,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		84,
		-1,
		-1,
		-1,
		91,
		98,
		119,
		-1,
		-1,
		-1,
		-1,
		110,
		111,
		130,
		105,
		-1,
		-1,
		-1,
		105,
		108,
		-1,
		-1,
		113,
		111,
		-1,
		-1,
		-1,
		133,
		117,
		-1,
		119,
		-1,
		-1,
		-1,
		124,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		138,
		-1,
		154,
		129,
		136,
		-1,
		-1,
		-1,
		-1,
		151,
		143,
		167,
		-1,
		139,
		141,
		-1,
		189,
		-1,
		-1,
		166,
		157,
		-1,
		-1,
		144,
		151,
		173,
		176,
		196,
		-1,
		163
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		319,
		308,
		319,
		327,
		300,
		307,
		-1,
		326,
		330,
		296,
		290,
		329,
		298,
		304,
		315,
		-1,
		-1,
		-1,
		319,
		318,
		286,
		284,
		293,
		298,
		305,
		-1,
		304,
		-1,
		340,
		319,
		330,
		335,
		279,
		276,
		296,
		315,
		297,
		289,
		355,
		309,
		280,
		274,
		292,
		282,
		291,
		283,
		-1,
		280,
		270,
		292,
		271,
		282,
		274,
		-1,
		-1,
		274,
		275,
		281,
		267,
		273,
		269,
		-1,
		279,
		263,
		-1,
		-1,
		264,
		265,
		249,
		252,
		260,
		258,
		271,
		263,
		258,
		-1,
		-1,
		255,
		251,
		258,
		245,
		241,
		258,
		271,
		253,
		267,
		266,
		-1,
		259,
		277,
		284,
		252,
		250,
		234,
		232,
		250,
		252,
		258,
		258,
		-1,
		268,
		269,
		264,
		272,
		274,
		250,
		237,
		237,
		247,
		240,
		259,
		247,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		268,
		251,
		268,
		260,
		250,
		265,
		258,
		240,
		237,
		235,
		232,
		248,
		246,
		256,
		-1,
		-1,
		361,
		330,
		359,
		317,
		298,
		-1,
		264,
		244,
		250,
		254,
		248,
		241,
		255,
		251,
		-1,
		226,
		225,
		253,
		239,
		250,
		321,
		-1,
		-1,
		319,
		311,
		294,
		297,
		274,
		270,
		259,
		258,
		250,
		236,
		232,
		238,
		241,
		241,
		247,
		220,
		230,
		234,
		232,
		257,
		-1,
		-1,
		292,
		-1,
		-1,
		318,
		301,
		-1,
		284,
		291,
		280,
		286,
		272,
		293,
		269,
		260,
		252,
		246,
		234,
		236,
		233,
		246,
		234,
		217,
		242,
		246,
		227,
		248,
		243,
		-1,
		291,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		277,
		280,
		286,
		310,
		309,
		-1,
		281,
		269,
		270,
		255,
		252,
		239,
		227,
		240,
		225,
		232,
		231,
		221,
		219,
		249,
		224,
		246,
		243,
		262,
		267,
		261,
		270,
		-1,
		326,
		322,
		318,
		325,
		274,
		-1,
		-1,
		314,
		-1,
		317,
		318,
		293,
		266,
		269,
		256,
		247,
		234,
		223,
		234,
		223,
		220,
		228,
		213,
		228,
		219,
		218,
		236,
		246,
		254,
		258,
		264,
		-1,
		376,
		-1,
		318,
		302,
		304,
		276,
		297,
		-1,
		334,
		318,
		310,
		295,
		295,
		-1,
		265,
		262,
		252,
		230,
		215,
		232,
		224,
		222,
		226,
		208,
		222,
		213,
		231,
		238,
		236,
		240,
		260,
		272,
		336,
		326,
		-1,
		308,
		313,
		272,
		280,
		299,
		337,
		301,
		-1,
		296,
		-1,
		267,
		280,
		-1,
		236,
		232,
		214,
		215,
		210,
		225,
		219,
		204,
		201,
		219,
		222,
		229,
		233,
		249,
		-1,
		-1,
		321,
		325,
		314,
		265,
		284,
		308,
		345,
		294,
		283,
		282,
		-1,
		273,
		250,
		247,
		235,
		222,
		207,
		208,
		216,
		229,
		208,
		203,
		200,
		220,
		246,
		224,
		236,
		-1,
		-1,
		-1,
		346,
		-1,
		-1,
		291,
		262,
		286,
		328,
		312,
		305,
		293,
		258,
		258,
		252,
		-1,
		246,
		225,
		216,
		205,
		203,
		216,
		213,
		218,
		198,
		196,
		215,
		227,
		218,
		235,
		-1,
		-1,
		-1,
		321,
		310,
		311,
		257,
		280,
		317,
		291,
		277,
		282,
		257,
		250,
		244,
		259,
		242,
		223,
		212,
		204,
		193,
		209,
		217,
		212,
		194,
		203,
		209,
		233,
		223,
		229,
		-1,
		-1,
		328,
		318,
		302,
		304,
		301,
		271,
		278,
		310,
		282,
		295,
		-1,
		249,
		-1,
		238,
		233,
		217,
		212,
		209,
		206,
		200,
		209,
		211,
		201,
		196,
		203,
		238,
		238,
		213,
		233,
		236,
		-1,
		-1,
		-1,
		321,
		316,
		291,
		268,
		252,
		288,
		-1,
		265,
		266,
		-1,
		243,
		237,
		234,
		219,
		215,
		210,
		214,
		207,
		214,
		207,
		205,
		206,
		188,
		220,
		-1,
		221,
		215,
		223,
		213,
		201,
		-1,
		-1,
		-1,
		314,
		293,
		286,
		306,
		247,
		299,
		-1,
		-1,
		250,
		243,
		-1,
		230,
		212,
		219,
		217,
		211,
		215,
		212,
		201,
		214,
		207,
		193,
		195,
		208,
		212,
		216,
		203,
		199,
		196,
		210,
		-1,
		333,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		267,
		-1,
		259,
		251,
		241,
		235,
		229,
		225,
		223,
		239,
		223,
		226,
		224,
		215,
		223,
		196,
		189,
		196,
		185,
		203,
		211,
		203,
		197,
		196,
		206,
		-1,
		334,
		320,
		291,
		-1,
		-1,
		280,
		-1,
		244,
		258,
		274,
		-1,
		267,
		246,
		261,
		239,
		235,
		231,
		246,
		247,
		224,
		224,
		222,
		213,
		201,
		190,
		193,
		185,
		207,
		207,
		191,
		192,
		196,
		-1,
		340,
		327,
		285,
		281,
		270,
		290,
		241,
		229,
		261,
		-1,
		-1,
		303,
		-1,
		237,
		254,
		245,
		243,
		236,
		218,
		225,
		233,
		210,
		205,
		195,
		184,
		184,
		179,
		201,
		187,
		185,
		194,
		210,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		256,
		243,
		237,
		-1,
		278,
		-1,
		281,
		271,
		255,
		240,
		273,
		-1,
		217,
		213,
		220,
		-1,
		230,
		-1,
		203,
		200,
		191,
		176,
		173,
		184,
		182,
		193,
		189,
		-1,
		290,
		275,
		268,
		258,
		272,
		243,
		-1,
		298,
		-1,
		-1,
		268,
		262,
		262,
		246,
		247,
		233,
		213,
		205,
		220,
		219,
		206,
		205,
		189,
		182,
		179,
		172,
		185,
		195,
		200,
		187,
		-1,
		-1,
		-1,
		295,
		261,
		269,
		245,
		264,
		-1,
		-1,
		330,
		285,
		271,
		-1,
		242,
		233,
		221,
		211,
		201,
		206,
		207,
		197,
		195,
		187,
		189,
		183,
		174,
		173,
		189,
		181,
		203,
		-1,
		-1,
		258,
		271,
		271,
		251,
		246,
		-1,
		-1,
		-1,
		277,
		293,
		261,
		240,
		222,
		-1,
		-1,
		205,
		198,
		192,
		195,
		183,
		203,
		198,
		182,
		167,
		182,
		186,
		194,
		185,
		-1,
		261,
		248,
		-1,
		-1,
		245,
		235,
		-1,
		-1,
		-1,
		-1,
		273,
		218,
		207,
		202,
		206,
		204,
		-1,
		178,
		189,
		182,
		201,
		208,
		184,
		169,
		163,
		169,
		181,
		190,
		-1,
		-1,
		259,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		230,
		224,
		195,
		188,
		192,
		-1,
		180,
		182,
		179,
		191,
		187,
		184,
		175,
		166,
		162,
		166,
		170,
		184,
		188,
		282,
		-1,
		212,
		-1,
		-1,
		-1,
		248,
		252,
		234,
		211,
		184,
		179,
		172,
		166,
		171,
		182,
		191,
		202,
		167,
		169,
		159,
		158,
		162,
		179,
		183,
		-1,
		-1,
		210,
		206,
		241,
		253,
		225,
		261,
		-1,
		-1,
		183,
		176,
		170,
		162,
		175,
		178,
		163,
		165,
		165,
		163,
		157,
		167,
		182,
		177,
		-1,
		-1,
		-1,
		208,
		-1,
		224,
		-1,
		-1,
		215,
		256,
		203,
		185,
		181,
		167,
		171,
		165,
		153,
		158,
		168,
		162,
		159,
		153,
		157,
		180,
		169,
		208,
		-1,
		-1,
		214,
		-1,
		-1,
		-1,
		174,
		193,
		188,
		194,
		199,
		190,
		218,
		215,
		-1,
		164,
		194,
		159,
		166,
		149,
		156,
		161,
		158,
		147,
		154,
		170,
		169,
		164,
		200,
		191,
		197,
		-1,
		-1,
		207,
		196,
		185,
		191,
		-1,
		167,
		190,
		180,
		170,
		176,
		-1,
		-1,
		182,
		179,
		177,
		157,
		157,
		150,
		145,
		155,
		131,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		161,
		198,
		191,
		159,
		167,
		198,
		-1,
		157,
		149,
		177,
		162,
		170,
		-1,
		-1,
		155,
		146,
		151,
		160,
		161,
		169,
		168,
		151,
		157,
		158,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		154,
		174,
		153,
		156,
		180,
		194,
		-1,
		148,
		-1,
		-1,
		160,
		180,
		164,
		154,
		151,
		198,
		174,
		169,
		156,
		154,
		149,
		140,
		165,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		143,
		154,
		147,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		150,
		-1,
		191,
		-1,
		174,
		178,
		182,
		185,
		170,
		157,
		143,
		151,
		157,
		156,
		162,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		168,
		124,
		127,
		138,
		149,
		164,
		168,
		-1,
		132,
		168,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		188,
		195,
		187,
		190,
		169,
		169,
		135,
		139,
		152,
		159,
		169,
		180,
		172,
		176,
		189,
		200,
		203,
		164,
		155,
		168,
		113,
		113,
		134,
		143,
		164,
		128,
		125,
		162,
		163,
		152,
		147,
		134,
		-1,
		-1,
		203,
		205,
		-1,
		-1,
		176,
		143,
		131,
		141,
		145,
		159,
		171,
		184,
		172,
		177,
		171,
		203,
		-1,
		157,
		156,
		145,
		142,
		118,
		109,
		104,
		131,
		-1,
		-1,
		126,
		153,
		137,
		141,
		157,
		182,
		-1,
		118,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		148,
		137,
		128,
		133,
		153,
		164,
		186,
		168,
		185,
		176,
		186,
		190,
		141,
		138,
		126,
		124,
		147,
		112,
		100,
		-1,
		108,
		111,
		117,
		124,
		141,
		171,
		-1,
		-1,
		134,
		114,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		125,
		130,
		160,
		162,
		164,
		171,
		165,
		172,
		180,
		191,
		183,
		150,
		164,
		153,
		149,
		148,
		156,
		105,
		98,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		124,
		120,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		147,
		147,
		150,
		155,
		163,
		174,
		170,
		174,
		177,
		-1,
		184,
		-1,
		136,
		97,
		103,
		118,
		126,
		-1,
		-1,
		-1,
		141,
		127,
		120,
		108,
		106,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		183,
		151,
		156,
		151,
		166,
		177,
		168,
		176,
		170,
		173,
		-1,
		-1,
		96,
		79,
		-1,
		-1,
		53,
		55,
		-1,
		132,
		121,
		106,
		98,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		117,
		155,
		154,
		162,
		157,
		162,
		174,
		170,
		166,
		176,
		167,
		-1,
		-1,
		74,
		66,
		60,
		-1,
		38,
		-1,
		134,
		-1,
		101,
		108,
		96,
		-1,
		-1,
		-1,
		148,
		111,
		127,
		150,
		176,
		174,
		165,
		158,
		165,
		168,
		161,
		167,
		-1,
		-1,
		-1,
		56,
		30,
		141,
		132,
		115,
		95,
		87,
		107,
		-1,
		129,
		-1,
		104,
		107,
		132,
		171,
		173,
		159,
		155,
		168,
		162,
		159,
		157,
		62,
		-1,
		27,
		86,
		70,
		101,
		67,
		79,
		143,
		-1,
		126,
		108,
		-1,
		136,
		126,
		174,
		149,
		158,
		151,
		145,
		146,
		154,
		-1,
		-1,
		-1,
		24,
		25,
		40,
		51,
		62,
		60,
		78,
		-1,
		131,
		113,
		99,
		116,
		116,
		107,
		115,
		164,
		160,
		163,
		161,
		139,
		-1,
		155,
		-1,
		-1,
		0,
		-1,
		-1,
		-1,
		68,
		93,
		88,
		80,
		92,
		101,
		96,
		98,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		138,
		170,
		-1,
		162,
		-1,
		7,
		-1,
		-1,
		89,
		75,
		87,
		98,
		88,
		88,
		93,
		91,
		113,
		143,
		129,
		127,
		132,
		137,
		-1,
		172,
		173,
		-1,
		108,
		100,
		86,
		-1,
		79,
		-1,
		134,
		95,
		-1,
		120,
		100,
		-1,
		138,
		134,
		-1,
		-1,
		164,
		124,
		-1,
		-1,
		-1,
		109,
		89,
		129,
		113,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		149,
		133,
		-1,
		102,
		105,
		-1,
		96,
		102,
		131,
		113,
		117,
		-1,
		-1,
		-1,
		158,
		139,
		133,
		117,
		122,
		110,
		127,
		113,
		115,
		127,
		116,
		137,
		-1,
		-1,
		-1,
		130,
		122,
		122,
		-1,
		-1,
		140,
		123,
		123,
		136,
		-1,
		-1,
		-1,
		152,
		133,
		-1,
		-1,
		131,
		-1,
		-1,
		136,
		135,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		141,
		-1,
		-1,
		-1,
		132,
		139,
		147,
		-1,
		-1,
		-1,
		-1,
		162,
		163,
		187,
		162,
		-1,
		-1,
		-1,
		146,
		146,
		-1,
		-1,
		165,
		163,
		-1,
		-1,
		-1,
		174,
		158,
		-1,
		150,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		179,
		-1,
		185,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		192,
		184,
		198,
		-1,
		170,
		172,
		-1,
		220,
		-1,
		-1,
		207,
		198,
		-1,
		-1,
		175,
		182,
		204,
		207,
		237,
		-1,
		194
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		292,
		281,
		292,
		300,
		273,
		280,
		-1,
		299,
		303,
		269,
		263,
		302,
		271,
		277,
		288,
		-1,
		-1,
		-1,
		292,
		291,
		259,
		257,
		266,
		271,
		278,
		-1,
		277,
		-1,
		313,
		292,
		303,
		308,
		252,
		249,
		269,
		288,
		270,
		262,
		328,
		282,
		253,
		247,
		265,
		255,
		264,
		256,
		-1,
		253,
		243,
		265,
		244,
		255,
		247,
		-1,
		-1,
		247,
		248,
		254,
		240,
		246,
		242,
		-1,
		252,
		236,
		-1,
		-1,
		237,
		238,
		222,
		225,
		233,
		231,
		244,
		236,
		231,
		-1,
		-1,
		228,
		224,
		231,
		218,
		214,
		231,
		244,
		226,
		240,
		239,
		-1,
		232,
		250,
		257,
		225,
		223,
		207,
		205,
		223,
		225,
		231,
		231,
		-1,
		241,
		242,
		237,
		245,
		247,
		223,
		210,
		210,
		220,
		213,
		232,
		220,
		266,
		-1,
		-1,
		-1,
		-1,
		-1,
		275,
		241,
		224,
		241,
		233,
		223,
		238,
		231,
		213,
		210,
		208,
		205,
		221,
		219,
		229,
		-1,
		-1,
		334,
		303,
		332,
		290,
		271,
		-1,
		237,
		217,
		223,
		227,
		221,
		214,
		228,
		224,
		-1,
		199,
		198,
		226,
		212,
		223,
		294,
		-1,
		-1,
		292,
		284,
		267,
		270,
		247,
		243,
		232,
		231,
		223,
		209,
		205,
		211,
		214,
		214,
		220,
		193,
		203,
		207,
		205,
		230,
		-1,
		-1,
		265,
		-1,
		-1,
		291,
		274,
		-1,
		257,
		264,
		253,
		259,
		245,
		266,
		242,
		233,
		225,
		219,
		207,
		209,
		206,
		219,
		207,
		190,
		215,
		219,
		200,
		221,
		216,
		-1,
		264,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		250,
		253,
		259,
		283,
		282,
		-1,
		254,
		242,
		243,
		228,
		225,
		212,
		200,
		213,
		198,
		205,
		204,
		194,
		192,
		222,
		197,
		219,
		216,
		235,
		240,
		234,
		243,
		-1,
		299,
		295,
		291,
		298,
		247,
		-1,
		-1,
		287,
		-1,
		290,
		291,
		266,
		239,
		242,
		229,
		220,
		207,
		196,
		207,
		196,
		193,
		201,
		186,
		201,
		192,
		191,
		209,
		219,
		227,
		231,
		237,
		-1,
		349,
		-1,
		291,
		275,
		277,
		249,
		270,
		-1,
		307,
		291,
		283,
		268,
		268,
		-1,
		238,
		235,
		225,
		203,
		188,
		205,
		197,
		195,
		199,
		181,
		195,
		186,
		204,
		211,
		209,
		213,
		233,
		245,
		309,
		299,
		-1,
		281,
		286,
		245,
		253,
		272,
		310,
		274,
		-1,
		269,
		-1,
		240,
		253,
		-1,
		209,
		205,
		187,
		188,
		183,
		198,
		192,
		177,
		174,
		192,
		195,
		202,
		206,
		222,
		-1,
		-1,
		294,
		298,
		287,
		238,
		257,
		281,
		318,
		267,
		256,
		255,
		-1,
		246,
		223,
		220,
		208,
		195,
		180,
		181,
		189,
		202,
		181,
		176,
		173,
		193,
		219,
		197,
		209,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		264,
		235,
		259,
		301,
		285,
		278,
		266,
		231,
		231,
		225,
		-1,
		219,
		198,
		189,
		178,
		176,
		189,
		186,
		191,
		171,
		169,
		188,
		200,
		191,
		208,
		-1,
		-1,
		-1,
		294,
		283,
		284,
		230,
		253,
		290,
		264,
		250,
		255,
		230,
		223,
		217,
		232,
		215,
		196,
		185,
		177,
		166,
		182,
		190,
		185,
		167,
		176,
		182,
		206,
		196,
		202,
		-1,
		-1,
		301,
		291,
		275,
		277,
		274,
		244,
		251,
		283,
		255,
		268,
		-1,
		222,
		-1,
		211,
		206,
		190,
		185,
		182,
		179,
		173,
		182,
		184,
		174,
		169,
		176,
		211,
		211,
		186,
		206,
		209,
		-1,
		-1,
		-1,
		294,
		289,
		264,
		241,
		225,
		261,
		-1,
		238,
		239,
		-1,
		216,
		210,
		207,
		192,
		188,
		183,
		187,
		180,
		187,
		180,
		178,
		179,
		161,
		193,
		-1,
		194,
		188,
		196,
		186,
		174,
		-1,
		-1,
		-1,
		287,
		266,
		259,
		279,
		220,
		272,
		-1,
		-1,
		223,
		216,
		-1,
		203,
		185,
		192,
		190,
		184,
		188,
		185,
		174,
		187,
		180,
		166,
		168,
		181,
		185,
		189,
		176,
		172,
		169,
		183,
		-1,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		240,
		-1,
		232,
		224,
		214,
		208,
		202,
		198,
		196,
		212,
		196,
		199,
		197,
		188,
		196,
		169,
		162,
		169,
		158,
		176,
		184,
		176,
		170,
		169,
		179,
		-1,
		307,
		293,
		264,
		-1,
		-1,
		253,
		-1,
		217,
		231,
		247,
		-1,
		240,
		219,
		234,
		212,
		208,
		204,
		219,
		220,
		197,
		197,
		195,
		186,
		174,
		163,
		166,
		158,
		180,
		180,
		164,
		165,
		169,
		-1,
		313,
		300,
		258,
		254,
		243,
		263,
		214,
		202,
		234,
		-1,
		-1,
		276,
		-1,
		210,
		227,
		218,
		216,
		209,
		191,
		198,
		206,
		183,
		178,
		168,
		157,
		157,
		152,
		174,
		160,
		158,
		167,
		183,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		229,
		216,
		210,
		-1,
		251,
		-1,
		254,
		244,
		228,
		213,
		246,
		-1,
		190,
		186,
		193,
		-1,
		203,
		-1,
		176,
		173,
		164,
		149,
		146,
		157,
		155,
		166,
		162,
		-1,
		263,
		248,
		241,
		231,
		245,
		216,
		-1,
		271,
		-1,
		-1,
		241,
		235,
		235,
		219,
		220,
		206,
		186,
		178,
		193,
		192,
		179,
		178,
		162,
		155,
		152,
		145,
		158,
		168,
		173,
		160,
		-1,
		-1,
		-1,
		268,
		254,
		258,
		218,
		237,
		-1,
		-1,
		303,
		258,
		244,
		-1,
		215,
		206,
		194,
		184,
		174,
		179,
		180,
		170,
		168,
		160,
		162,
		156,
		147,
		146,
		162,
		154,
		176,
		-1,
		-1,
		251,
		256,
		244,
		230,
		232,
		-1,
		-1,
		-1,
		250,
		266,
		234,
		213,
		195,
		-1,
		-1,
		178,
		171,
		165,
		168,
		156,
		176,
		171,
		155,
		140,
		155,
		159,
		167,
		158,
		-1,
		254,
		241,
		-1,
		-1,
		231,
		221,
		-1,
		-1,
		-1,
		-1,
		246,
		191,
		180,
		175,
		179,
		177,
		-1,
		151,
		162,
		155,
		174,
		181,
		157,
		142,
		136,
		142,
		154,
		163,
		-1,
		-1,
		245,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		203,
		197,
		168,
		161,
		165,
		-1,
		153,
		155,
		152,
		164,
		160,
		157,
		148,
		139,
		135,
		139,
		143,
		157,
		161,
		268,
		-1,
		198,
		-1,
		-1,
		-1,
		221,
		236,
		207,
		184,
		157,
		152,
		145,
		139,
		144,
		155,
		164,
		175,
		140,
		142,
		132,
		131,
		135,
		152,
		156,
		-1,
		-1,
		196,
		192,
		227,
		229,
		233,
		234,
		-1,
		-1,
		161,
		152,
		143,
		135,
		148,
		151,
		136,
		138,
		138,
		136,
		130,
		140,
		155,
		150,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		229,
		232,
		179,
		161,
		157,
		155,
		144,
		138,
		126,
		131,
		141,
		135,
		132,
		126,
		130,
		153,
		142,
		181,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		190,
		179,
		174,
		208,
		213,
		204,
		194,
		191,
		-1,
		161,
		167,
		132,
		139,
		122,
		129,
		134,
		131,
		120,
		127,
		143,
		142,
		137,
		173,
		164,
		170,
		-1,
		-1,
		223,
		212,
		201,
		207,
		-1,
		183,
		176,
		194,
		184,
		190,
		-1,
		-1,
		186,
		183,
		163,
		132,
		130,
		123,
		118,
		128,
		104,
		116,
		120,
		124,
		130,
		135,
		140,
		146,
		161,
		176,
		-1,
		177,
		214,
		207,
		175,
		183,
		214,
		-1,
		173,
		165,
		173,
		176,
		183,
		-1,
		-1,
		159,
		150,
		151,
		139,
		136,
		142,
		141,
		124,
		130,
		131,
		123,
		122,
		140,
		144,
		153,
		160,
		150,
		163,
		167,
		-1,
		170,
		190,
		169,
		172,
		196,
		210,
		-1,
		164,
		-1,
		-1,
		133,
		184,
		168,
		158,
		155,
		198,
		153,
		148,
		129,
		127,
		122,
		113,
		138,
		131,
		131,
		134,
		149,
		154,
		146,
		160,
		160,
		161,
		-1,
		159,
		170,
		163,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		123,
		-1,
		195,
		-1,
		178,
		182,
		161,
		164,
		143,
		130,
		116,
		124,
		130,
		129,
		135,
		135,
		136,
		145,
		156,
		168,
		167,
		168,
		184,
		140,
		143,
		154,
		165,
		180,
		184,
		-1,
		148,
		184,
		129,
		-1,
		113,
		-1,
		-1,
		-1,
		192,
		174,
		166,
		163,
		142,
		142,
		108,
		112,
		125,
		132,
		142,
		153,
		145,
		149,
		162,
		173,
		176,
		180,
		171,
		184,
		129,
		129,
		150,
		159,
		180,
		144,
		141,
		178,
		136,
		125,
		120,
		107,
		-1,
		-1,
		176,
		184,
		-1,
		-1,
		149,
		116,
		104,
		114,
		118,
		132,
		144,
		157,
		145,
		150,
		144,
		176,
		-1,
		173,
		172,
		161,
		158,
		134,
		125,
		120,
		147,
		-1,
		-1,
		142,
		169,
		153,
		157,
		167,
		192,
		-1,
		91,
		-1,
		-1,
		156,
		-1,
		-1,
		141,
		121,
		110,
		101,
		106,
		126,
		137,
		159,
		141,
		158,
		149,
		159,
		163,
		157,
		154,
		142,
		140,
		163,
		128,
		116,
		-1,
		124,
		127,
		133,
		140,
		157,
		181,
		-1,
		-1,
		107,
		87,
		-1,
		-1,
		139,
		137,
		126,
		-1,
		116,
		98,
		103,
		133,
		135,
		137,
		144,
		138,
		145,
		153,
		164,
		156,
		166,
		180,
		169,
		165,
		164,
		172,
		121,
		114,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		97,
		93,
		-1,
		-1,
		134,
		127,
		115,
		103,
		93,
		103,
		120,
		120,
		123,
		128,
		136,
		147,
		143,
		147,
		150,
		-1,
		200,
		-1,
		152,
		113,
		119,
		134,
		142,
		-1,
		-1,
		-1,
		114,
		100,
		93,
		81,
		79,
		-1,
		168,
		152,
		133,
		-1,
		103,
		116,
		156,
		124,
		129,
		124,
		139,
		150,
		141,
		149,
		143,
		146,
		-1,
		-1,
		112,
		95,
		-1,
		-1,
		69,
		71,
		-1,
		105,
		94,
		79,
		71,
		-1,
		-1,
		140,
		136,
		-1,
		-1,
		90,
		128,
		127,
		135,
		130,
		135,
		147,
		143,
		139,
		149,
		140,
		-1,
		-1,
		90,
		82,
		76,
		-1,
		54,
		-1,
		107,
		-1,
		74,
		81,
		69,
		-1,
		-1,
		-1,
		121,
		84,
		100,
		123,
		149,
		147,
		138,
		131,
		138,
		141,
		134,
		140,
		-1,
		-1,
		-1,
		72,
		46,
		114,
		105,
		88,
		68,
		60,
		80,
		-1,
		102,
		-1,
		77,
		80,
		105,
		144,
		146,
		132,
		128,
		141,
		135,
		132,
		130,
		78,
		-1,
		46,
		79,
		44,
		74,
		40,
		52,
		116,
		-1,
		99,
		81,
		-1,
		109,
		99,
		147,
		122,
		131,
		124,
		118,
		119,
		127,
		-1,
		-1,
		-1,
		48,
		47,
		39,
		33,
		35,
		33,
		51,
		-1,
		104,
		86,
		72,
		89,
		89,
		80,
		88,
		137,
		133,
		136,
		134,
		112,
		-1,
		166,
		-1,
		-1,
		71,
		-1,
		-1,
		-1,
		0,
		66,
		61,
		53,
		65,
		74,
		69,
		71,
		84,
		92,
		90,
		87,
		99,
		95,
		115,
		111,
		143,
		-1,
		161,
		-1,
		78,
		-1,
		-1,
		62,
		48,
		60,
		71,
		61,
		61,
		66,
		64,
		86,
		116,
		102,
		100,
		105,
		110,
		-1,
		150,
		149,
		-1,
		81,
		73,
		59,
		-1,
		52,
		-1,
		107,
		68,
		-1,
		93,
		73,
		-1,
		111,
		107,
		-1,
		-1,
		137,
		97,
		-1,
		-1,
		-1,
		82,
		62,
		102,
		86,
		-1,
		84,
		84,
		-1,
		-1,
		-1,
		122,
		106,
		-1,
		75,
		78,
		-1,
		69,
		75,
		104,
		86,
		90,
		-1,
		-1,
		-1,
		131,
		112,
		106,
		90,
		95,
		83,
		100,
		86,
		88,
		100,
		89,
		110,
		-1,
		-1,
		-1,
		103,
		95,
		95,
		-1,
		-1,
		113,
		96,
		96,
		109,
		-1,
		-1,
		-1,
		125,
		106,
		-1,
		-1,
		104,
		-1,
		-1,
		109,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		114,
		-1,
		-1,
		-1,
		105,
		112,
		120,
		-1,
		-1,
		-1,
		-1,
		135,
		136,
		160,
		135,
		-1,
		-1,
		-1,
		119,
		119,
		-1,
		-1,
		138,
		136,
		-1,
		-1,
		-1,
		147,
		131,
		-1,
		123,
		-1,
		-1,
		-1,
		138,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		152,
		-1,
		158,
		133,
		140,
		-1,
		-1,
		-1,
		-1,
		165,
		157,
		171,
		-1,
		143,
		145,
		-1,
		193,
		-1,
		-1,
		180,
		171,
		-1,
		-1,
		148,
		155,
		177,
		180,
		210,
		-1,
		167
	],
	[
		-1,
		279,
		268,
		279,
		287,
		260,
		267,
		-1,
		286,
		290,
		256,
		250,
		289,
		258,
		264,
		275,
		-1,
		-1,
		-1,
		279,
		278,
		246,
		244,
		253,
		258,
		265,
		-1,
		264,
		-1,
		300,
		279,
		290,
		295,
		239,
		236,
		256,
		275,
		257,
		249,
		315,
		269,
		240,
		234,
		252,
		242,
		251,
		243,
		-1,
		240,
		230,
		252,
		231,
		242,
		234,
		-1,
		-1,
		234,
		235,
		241,
		227,
		233,
		229,
		-1,
		239,
		223,
		-1,
		-1,
		224,
		225,
		209,
		212,
		220,
		218,
		231,
		223,
		218,
		-1,
		-1,
		215,
		211,
		218,
		205,
		201,
		218,
		231,
		213,
		227,
		226,
		-1,
		219,
		237,
		244,
		212,
		210,
		194,
		192,
		210,
		212,
		218,
		218,
		-1,
		228,
		229,
		224,
		232,
		234,
		210,
		197,
		197,
		207,
		200,
		219,
		207,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		262,
		228,
		211,
		228,
		220,
		210,
		225,
		218,
		200,
		197,
		195,
		192,
		208,
		206,
		216,
		-1,
		-1,
		321,
		290,
		319,
		277,
		258,
		-1,
		224,
		204,
		210,
		214,
		208,
		201,
		215,
		211,
		-1,
		186,
		185,
		213,
		199,
		210,
		281,
		-1,
		-1,
		279,
		271,
		254,
		257,
		234,
		230,
		219,
		218,
		210,
		196,
		192,
		198,
		201,
		201,
		207,
		180,
		190,
		194,
		192,
		217,
		-1,
		-1,
		252,
		-1,
		-1,
		278,
		261,
		-1,
		244,
		251,
		240,
		246,
		232,
		253,
		229,
		220,
		212,
		206,
		194,
		196,
		193,
		206,
		194,
		177,
		202,
		206,
		187,
		208,
		203,
		-1,
		251,
		235,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		237,
		240,
		246,
		270,
		269,
		-1,
		241,
		229,
		230,
		215,
		212,
		199,
		187,
		200,
		185,
		192,
		191,
		181,
		179,
		209,
		184,
		206,
		203,
		222,
		227,
		221,
		230,
		-1,
		286,
		282,
		278,
		285,
		234,
		-1,
		-1,
		274,
		-1,
		277,
		278,
		253,
		226,
		229,
		216,
		207,
		194,
		183,
		194,
		183,
		180,
		188,
		173,
		188,
		179,
		178,
		196,
		206,
		214,
		218,
		224,
		-1,
		336,
		-1,
		278,
		262,
		264,
		236,
		257,
		-1,
		294,
		278,
		270,
		255,
		255,
		-1,
		225,
		222,
		212,
		190,
		175,
		192,
		184,
		182,
		186,
		168,
		182,
		173,
		191,
		198,
		196,
		200,
		220,
		232,
		296,
		286,
		-1,
		268,
		273,
		232,
		240,
		259,
		297,
		261,
		-1,
		256,
		-1,
		227,
		240,
		-1,
		196,
		192,
		174,
		175,
		170,
		185,
		179,
		164,
		161,
		179,
		182,
		189,
		193,
		209,
		-1,
		-1,
		281,
		285,
		274,
		225,
		244,
		268,
		305,
		254,
		243,
		242,
		-1,
		233,
		210,
		207,
		195,
		182,
		167,
		168,
		176,
		189,
		168,
		163,
		160,
		180,
		206,
		184,
		196,
		-1,
		-1,
		-1,
		306,
		-1,
		-1,
		251,
		222,
		246,
		288,
		272,
		265,
		253,
		218,
		218,
		212,
		-1,
		206,
		185,
		176,
		165,
		163,
		176,
		173,
		178,
		158,
		156,
		175,
		187,
		178,
		195,
		-1,
		-1,
		-1,
		281,
		270,
		271,
		217,
		240,
		277,
		251,
		237,
		242,
		217,
		210,
		204,
		219,
		202,
		183,
		172,
		164,
		153,
		169,
		177,
		172,
		154,
		163,
		169,
		193,
		183,
		189,
		-1,
		-1,
		288,
		278,
		262,
		264,
		261,
		231,
		238,
		270,
		242,
		255,
		-1,
		209,
		-1,
		198,
		193,
		177,
		172,
		169,
		166,
		160,
		169,
		171,
		161,
		156,
		163,
		198,
		198,
		173,
		193,
		196,
		-1,
		-1,
		-1,
		281,
		276,
		251,
		228,
		212,
		248,
		-1,
		225,
		226,
		-1,
		203,
		197,
		194,
		179,
		175,
		170,
		174,
		167,
		174,
		167,
		165,
		166,
		148,
		180,
		-1,
		181,
		175,
		183,
		173,
		161,
		-1,
		-1,
		-1,
		274,
		253,
		246,
		266,
		207,
		259,
		-1,
		-1,
		210,
		203,
		-1,
		190,
		172,
		179,
		177,
		171,
		175,
		172,
		161,
		174,
		167,
		153,
		155,
		168,
		172,
		176,
		163,
		159,
		156,
		170,
		-1,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		207,
		227,
		-1,
		219,
		211,
		201,
		195,
		189,
		185,
		183,
		199,
		183,
		186,
		184,
		175,
		183,
		156,
		149,
		156,
		145,
		163,
		171,
		163,
		157,
		156,
		166,
		-1,
		294,
		280,
		251,
		-1,
		-1,
		240,
		-1,
		204,
		218,
		234,
		-1,
		227,
		206,
		221,
		199,
		195,
		191,
		206,
		207,
		184,
		184,
		182,
		173,
		161,
		150,
		153,
		145,
		167,
		167,
		151,
		152,
		156,
		-1,
		300,
		287,
		245,
		241,
		230,
		250,
		201,
		189,
		221,
		-1,
		-1,
		263,
		-1,
		197,
		214,
		205,
		203,
		196,
		178,
		185,
		193,
		170,
		165,
		155,
		144,
		144,
		139,
		161,
		147,
		145,
		154,
		170,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		216,
		203,
		197,
		-1,
		238,
		-1,
		241,
		231,
		215,
		200,
		233,
		-1,
		177,
		173,
		180,
		-1,
		190,
		-1,
		163,
		160,
		151,
		136,
		133,
		144,
		142,
		153,
		149,
		-1,
		250,
		235,
		228,
		218,
		232,
		203,
		-1,
		258,
		-1,
		-1,
		228,
		222,
		222,
		206,
		207,
		193,
		173,
		165,
		180,
		179,
		166,
		165,
		149,
		142,
		139,
		132,
		145,
		155,
		160,
		147,
		-1,
		-1,
		-1,
		255,
		241,
		245,
		205,
		224,
		-1,
		-1,
		290,
		245,
		231,
		-1,
		202,
		193,
		181,
		171,
		161,
		166,
		167,
		157,
		155,
		147,
		149,
		143,
		134,
		133,
		149,
		141,
		163,
		-1,
		-1,
		238,
		243,
		231,
		217,
		232,
		-1,
		-1,
		-1,
		237,
		253,
		221,
		200,
		182,
		-1,
		-1,
		165,
		158,
		152,
		155,
		143,
		163,
		158,
		142,
		127,
		142,
		146,
		154,
		145,
		-1,
		241,
		228,
		-1,
		-1,
		231,
		221,
		-1,
		-1,
		-1,
		-1,
		233,
		178,
		167,
		162,
		166,
		164,
		-1,
		138,
		149,
		142,
		161,
		168,
		144,
		129,
		123,
		129,
		141,
		150,
		-1,
		-1,
		245,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		190,
		184,
		155,
		148,
		152,
		-1,
		140,
		142,
		139,
		151,
		147,
		144,
		135,
		126,
		122,
		126,
		130,
		144,
		148,
		268,
		-1,
		198,
		-1,
		-1,
		-1,
		208,
		223,
		194,
		171,
		144,
		139,
		132,
		126,
		131,
		142,
		151,
		162,
		127,
		129,
		119,
		118,
		122,
		139,
		143,
		-1,
		-1,
		196,
		192,
		227,
		216,
		220,
		221,
		-1,
		-1,
		148,
		139,
		130,
		122,
		135,
		138,
		123,
		125,
		125,
		123,
		117,
		127,
		142,
		137,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		218,
		219,
		166,
		148,
		144,
		142,
		131,
		125,
		113,
		118,
		128,
		122,
		119,
		113,
		117,
		140,
		129,
		168,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		202,
		179,
		174,
		200,
		202,
		193,
		181,
		178,
		-1,
		148,
		154,
		119,
		126,
		109,
		116,
		121,
		118,
		107,
		114,
		130,
		129,
		124,
		160,
		151,
		157,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		195,
		176,
		186,
		176,
		179,
		-1,
		-1,
		173,
		170,
		150,
		119,
		117,
		110,
		105,
		115,
		91,
		103,
		107,
		111,
		117,
		122,
		127,
		133,
		148,
		163,
		-1,
		189,
		226,
		219,
		187,
		195,
		226,
		-1,
		185,
		177,
		173,
		168,
		170,
		-1,
		-1,
		146,
		137,
		138,
		126,
		123,
		129,
		128,
		111,
		117,
		118,
		110,
		109,
		127,
		131,
		140,
		147,
		137,
		150,
		154,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		176,
		-1,
		-1,
		133,
		171,
		155,
		145,
		142,
		185,
		140,
		135,
		116,
		114,
		109,
		100,
		125,
		118,
		118,
		121,
		136,
		141,
		133,
		147,
		147,
		148,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		-1,
		123,
		-1,
		182,
		-1,
		165,
		169,
		148,
		151,
		130,
		117,
		103,
		111,
		117,
		116,
		122,
		122,
		123,
		132,
		143,
		155,
		154,
		155,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		160,
		196,
		129,
		-1,
		113,
		-1,
		-1,
		-1,
		179,
		161,
		153,
		150,
		129,
		129,
		95,
		99,
		112,
		119,
		129,
		140,
		132,
		136,
		149,
		160,
		163,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		156,
		153,
		190,
		136,
		125,
		120,
		107,
		-1,
		-1,
		163,
		171,
		-1,
		-1,
		136,
		103,
		91,
		101,
		105,
		119,
		131,
		144,
		132,
		137,
		131,
		163,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		181,
		165,
		169,
		167,
		192,
		-1,
		96,
		-1,
		-1,
		143,
		-1,
		-1,
		128,
		108,
		97,
		88,
		93,
		113,
		124,
		146,
		128,
		145,
		136,
		146,
		150,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		136,
		139,
		145,
		152,
		169,
		181,
		-1,
		-1,
		112,
		92,
		-1,
		-1,
		126,
		124,
		113,
		-1,
		103,
		85,
		90,
		120,
		122,
		124,
		131,
		125,
		132,
		140,
		151,
		143,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		-1,
		102,
		98,
		-1,
		-1,
		121,
		114,
		102,
		90,
		80,
		90,
		107,
		107,
		110,
		115,
		123,
		134,
		130,
		134,
		137,
		-1,
		212,
		-1,
		164,
		125,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		119,
		105,
		98,
		86,
		84,
		-1,
		155,
		139,
		120,
		-1,
		90,
		103,
		143,
		111,
		116,
		111,
		126,
		137,
		128,
		136,
		130,
		133,
		-1,
		-1,
		124,
		107,
		-1,
		-1,
		81,
		83,
		-1,
		110,
		99,
		84,
		76,
		-1,
		-1,
		127,
		123,
		-1,
		-1,
		77,
		115,
		114,
		122,
		117,
		122,
		134,
		130,
		126,
		136,
		127,
		-1,
		-1,
		102,
		94,
		88,
		-1,
		66,
		-1,
		112,
		-1,
		79,
		77,
		65,
		-1,
		-1,
		-1,
		108,
		71,
		87,
		110,
		136,
		134,
		125,
		118,
		125,
		128,
		121,
		127,
		-1,
		-1,
		-1,
		84,
		58,
		119,
		110,
		93,
		73,
		65,
		76,
		-1,
		89,
		-1,
		64,
		67,
		92,
		131,
		133,
		119,
		115,
		128,
		122,
		119,
		117,
		90,
		-1,
		60,
		93,
		57,
		79,
		52,
		53,
		103,
		-1,
		86,
		68,
		-1,
		96,
		86,
		134,
		109,
		118,
		111,
		105,
		106,
		114,
		-1,
		-1,
		-1,
		62,
		61,
		53,
		47,
		47,
		45,
		43,
		-1,
		91,
		73,
		59,
		76,
		76,
		67,
		75,
		124,
		120,
		123,
		121,
		99,
		-1,
		149,
		-1,
		-1,
		85,
		-1,
		-1,
		-1,
		56,
		0,
		24,
		40,
		48,
		61,
		56,
		58,
		71,
		79,
		77,
		74,
		86,
		82,
		102,
		98,
		130,
		-1,
		144,
		-1,
		92,
		-1,
		-1,
		42,
		16,
		8,
		16,
		44,
		44,
		49,
		51,
		73,
		103,
		89,
		87,
		92,
		97,
		-1,
		133,
		132,
		-1,
		61,
		53,
		39,
		-1,
		32,
		-1,
		90,
		51,
		-1,
		80,
		60,
		-1,
		98,
		94,
		-1,
		-1,
		120,
		77,
		-1,
		-1,
		-1,
		63,
		38,
		85,
		69,
		-1,
		71,
		71,
		-1,
		-1,
		-1,
		105,
		86,
		-1,
		56,
		59,
		-1,
		45,
		51,
		80,
		73,
		77,
		-1,
		-1,
		-1,
		114,
		95,
		89,
		71,
		76,
		64,
		76,
		62,
		65,
		82,
		76,
		97,
		-1,
		-1,
		-1,
		86,
		78,
		78,
		-1,
		-1,
		90,
		73,
		73,
		91,
		-1,
		-1,
		-1,
		108,
		89,
		-1,
		-1,
		87,
		-1,
		-1,
		86,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		97,
		-1,
		-1,
		-1,
		88,
		95,
		97,
		-1,
		-1,
		-1,
		-1,
		118,
		119,
		143,
		118,
		-1,
		-1,
		-1,
		102,
		103,
		-1,
		-1,
		121,
		119,
		-1,
		-1,
		-1,
		130,
		114,
		-1,
		107,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		135,
		-1,
		142,
		117,
		124,
		-1,
		-1,
		-1,
		-1,
		148,
		140,
		155,
		-1,
		127,
		129,
		-1,
		177,
		-1,
		-1,
		163,
		154,
		-1,
		-1,
		132,
		139,
		161,
		164,
		193,
		-1,
		151
	],
	[
		-1,
		255,
		244,
		255,
		263,
		236,
		243,
		-1,
		262,
		266,
		232,
		226,
		265,
		234,
		240,
		251,
		-1,
		-1,
		-1,
		255,
		254,
		222,
		220,
		229,
		234,
		241,
		-1,
		240,
		-1,
		276,
		255,
		266,
		271,
		215,
		212,
		232,
		251,
		233,
		225,
		291,
		245,
		216,
		210,
		228,
		218,
		227,
		219,
		-1,
		216,
		206,
		228,
		207,
		218,
		210,
		-1,
		-1,
		210,
		211,
		217,
		203,
		209,
		205,
		-1,
		215,
		199,
		-1,
		-1,
		200,
		201,
		185,
		188,
		196,
		194,
		207,
		199,
		194,
		-1,
		-1,
		191,
		187,
		194,
		181,
		177,
		194,
		207,
		189,
		203,
		202,
		-1,
		195,
		213,
		220,
		188,
		186,
		170,
		168,
		186,
		188,
		194,
		194,
		-1,
		204,
		205,
		200,
		208,
		210,
		186,
		173,
		173,
		183,
		176,
		195,
		183,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		204,
		187,
		204,
		196,
		186,
		201,
		194,
		176,
		173,
		171,
		168,
		184,
		182,
		192,
		-1,
		-1,
		297,
		266,
		295,
		253,
		234,
		-1,
		200,
		180,
		186,
		190,
		184,
		177,
		191,
		187,
		-1,
		162,
		161,
		189,
		175,
		186,
		257,
		-1,
		-1,
		255,
		247,
		230,
		233,
		210,
		206,
		195,
		194,
		186,
		172,
		168,
		174,
		177,
		177,
		183,
		156,
		166,
		170,
		168,
		193,
		-1,
		-1,
		228,
		-1,
		-1,
		254,
		237,
		-1,
		220,
		227,
		216,
		222,
		208,
		229,
		205,
		196,
		188,
		182,
		170,
		172,
		169,
		182,
		170,
		153,
		178,
		182,
		163,
		184,
		179,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		213,
		216,
		222,
		246,
		245,
		-1,
		217,
		205,
		206,
		191,
		188,
		175,
		163,
		176,
		161,
		168,
		167,
		157,
		155,
		185,
		160,
		182,
		179,
		198,
		203,
		197,
		206,
		-1,
		262,
		258,
		254,
		261,
		210,
		-1,
		-1,
		250,
		-1,
		253,
		254,
		229,
		202,
		205,
		192,
		183,
		170,
		159,
		170,
		159,
		156,
		164,
		149,
		164,
		155,
		154,
		172,
		182,
		190,
		194,
		200,
		-1,
		312,
		-1,
		254,
		238,
		240,
		212,
		233,
		-1,
		270,
		254,
		246,
		231,
		231,
		-1,
		201,
		198,
		188,
		166,
		151,
		168,
		160,
		158,
		162,
		144,
		158,
		149,
		167,
		174,
		172,
		176,
		196,
		208,
		272,
		262,
		-1,
		244,
		249,
		208,
		216,
		235,
		273,
		237,
		-1,
		232,
		-1,
		203,
		216,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		155,
		140,
		137,
		155,
		158,
		165,
		169,
		185,
		-1,
		-1,
		257,
		261,
		250,
		201,
		220,
		244,
		281,
		230,
		219,
		218,
		-1,
		209,
		186,
		183,
		171,
		158,
		143,
		144,
		152,
		165,
		144,
		139,
		136,
		156,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		227,
		198,
		222,
		264,
		248,
		241,
		229,
		194,
		194,
		188,
		-1,
		182,
		161,
		152,
		141,
		139,
		152,
		149,
		154,
		134,
		132,
		151,
		163,
		154,
		171,
		-1,
		-1,
		-1,
		257,
		246,
		247,
		193,
		216,
		253,
		227,
		213,
		218,
		193,
		186,
		180,
		195,
		178,
		159,
		148,
		140,
		129,
		145,
		153,
		148,
		130,
		139,
		145,
		169,
		159,
		165,
		-1,
		-1,
		264,
		254,
		238,
		240,
		237,
		207,
		214,
		246,
		218,
		231,
		-1,
		185,
		-1,
		174,
		169,
		153,
		148,
		145,
		142,
		136,
		145,
		147,
		137,
		132,
		139,
		174,
		174,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		257,
		252,
		227,
		204,
		188,
		224,
		-1,
		201,
		202,
		-1,
		179,
		173,
		170,
		155,
		151,
		146,
		150,
		143,
		150,
		143,
		141,
		142,
		124,
		156,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		250,
		229,
		222,
		242,
		183,
		235,
		-1,
		-1,
		186,
		179,
		-1,
		166,
		148,
		155,
		153,
		147,
		151,
		148,
		137,
		150,
		143,
		129,
		131,
		144,
		148,
		152,
		139,
		135,
		132,
		146,
		-1,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		203,
		-1,
		195,
		187,
		177,
		171,
		165,
		161,
		159,
		175,
		159,
		162,
		160,
		151,
		159,
		132,
		125,
		132,
		121,
		139,
		147,
		139,
		133,
		132,
		142,
		-1,
		270,
		256,
		227,
		-1,
		-1,
		216,
		-1,
		180,
		194,
		210,
		-1,
		203,
		182,
		197,
		175,
		171,
		167,
		182,
		183,
		160,
		160,
		158,
		149,
		137,
		126,
		129,
		121,
		143,
		143,
		127,
		128,
		132,
		-1,
		276,
		263,
		221,
		217,
		206,
		226,
		177,
		165,
		197,
		-1,
		-1,
		239,
		-1,
		173,
		190,
		181,
		179,
		172,
		154,
		161,
		169,
		146,
		141,
		131,
		120,
		120,
		115,
		137,
		123,
		121,
		130,
		146,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		192,
		179,
		173,
		-1,
		214,
		-1,
		217,
		207,
		191,
		176,
		209,
		-1,
		153,
		149,
		156,
		-1,
		166,
		-1,
		139,
		136,
		127,
		112,
		109,
		120,
		118,
		129,
		125,
		-1,
		226,
		211,
		204,
		194,
		208,
		179,
		-1,
		234,
		-1,
		-1,
		204,
		198,
		198,
		182,
		183,
		169,
		149,
		141,
		156,
		155,
		142,
		141,
		125,
		118,
		115,
		108,
		121,
		131,
		136,
		123,
		-1,
		-1,
		-1,
		231,
		217,
		221,
		181,
		200,
		-1,
		-1,
		266,
		221,
		207,
		-1,
		178,
		169,
		157,
		147,
		137,
		142,
		143,
		133,
		131,
		123,
		125,
		119,
		110,
		109,
		125,
		117,
		139,
		-1,
		-1,
		214,
		219,
		207,
		193,
		208,
		-1,
		-1,
		-1,
		213,
		229,
		197,
		176,
		158,
		-1,
		-1,
		141,
		134,
		128,
		131,
		119,
		139,
		134,
		118,
		103,
		118,
		122,
		130,
		121,
		-1,
		217,
		204,
		-1,
		-1,
		207,
		197,
		-1,
		-1,
		-1,
		-1,
		209,
		154,
		143,
		138,
		142,
		140,
		-1,
		114,
		125,
		118,
		137,
		144,
		120,
		105,
		99,
		105,
		117,
		126,
		-1,
		-1,
		221,
		-1,
		183,
		-1,
		-1,
		-1,
		-1,
		166,
		160,
		131,
		124,
		128,
		-1,
		116,
		118,
		115,
		127,
		123,
		120,
		111,
		102,
		98,
		102,
		106,
		120,
		124,
		244,
		-1,
		174,
		-1,
		-1,
		-1,
		184,
		199,
		170,
		147,
		120,
		115,
		108,
		102,
		107,
		118,
		127,
		138,
		103,
		105,
		95,
		94,
		98,
		115,
		119,
		-1,
		-1,
		172,
		168,
		203,
		192,
		196,
		197,
		-1,
		-1,
		124,
		115,
		106,
		98,
		111,
		114,
		99,
		101,
		101,
		99,
		93,
		103,
		118,
		113,
		-1,
		-1,
		-1,
		184,
		-1,
		186,
		-1,
		-1,
		194,
		195,
		142,
		124,
		120,
		118,
		107,
		101,
		89,
		94,
		104,
		98,
		95,
		89,
		93,
		116,
		105,
		144,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		183,
		155,
		150,
		176,
		178,
		169,
		157,
		154,
		-1,
		124,
		130,
		95,
		102,
		85,
		92,
		97,
		94,
		83,
		90,
		106,
		105,
		100,
		136,
		127,
		133,
		-1,
		-1,
		233,
		222,
		211,
		217,
		-1,
		176,
		152,
		162,
		152,
		155,
		-1,
		-1,
		149,
		146,
		126,
		95,
		93,
		86,
		81,
		91,
		67,
		79,
		83,
		87,
		93,
		98,
		103,
		109,
		124,
		139,
		-1,
		187,
		224,
		217,
		185,
		193,
		224,
		-1,
		166,
		158,
		149,
		144,
		146,
		-1,
		-1,
		122,
		113,
		114,
		102,
		99,
		105,
		104,
		87,
		93,
		94,
		86,
		85,
		103,
		107,
		116,
		123,
		113,
		126,
		130,
		-1,
		180,
		200,
		179,
		182,
		206,
		220,
		-1,
		163,
		-1,
		-1,
		109,
		147,
		131,
		121,
		118,
		161,
		116,
		111,
		92,
		90,
		85,
		76,
		101,
		94,
		94,
		97,
		112,
		117,
		109,
		123,
		123,
		124,
		-1,
		169,
		180,
		173,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		-1,
		99,
		-1,
		158,
		-1,
		141,
		145,
		124,
		127,
		106,
		93,
		79,
		87,
		93,
		92,
		98,
		98,
		99,
		108,
		119,
		131,
		130,
		131,
		194,
		150,
		153,
		164,
		175,
		190,
		194,
		-1,
		158,
		194,
		105,
		-1,
		89,
		-1,
		-1,
		-1,
		155,
		137,
		129,
		126,
		105,
		105,
		71,
		75,
		88,
		95,
		105,
		116,
		108,
		112,
		125,
		136,
		139,
		190,
		181,
		194,
		139,
		139,
		160,
		169,
		190,
		154,
		151,
		188,
		112,
		101,
		96,
		83,
		-1,
		-1,
		139,
		147,
		-1,
		-1,
		112,
		79,
		67,
		77,
		81,
		95,
		107,
		120,
		108,
		113,
		107,
		139,
		-1,
		183,
		182,
		171,
		168,
		144,
		135,
		130,
		157,
		-1,
		-1,
		152,
		179,
		163,
		145,
		143,
		168,
		-1,
		72,
		-1,
		-1,
		119,
		-1,
		-1,
		104,
		84,
		73,
		64,
		69,
		89,
		100,
		122,
		104,
		121,
		112,
		122,
		126,
		167,
		164,
		152,
		150,
		173,
		138,
		126,
		-1,
		134,
		137,
		143,
		150,
		146,
		157,
		-1,
		-1,
		88,
		68,
		-1,
		-1,
		102,
		100,
		89,
		-1,
		79,
		61,
		66,
		96,
		98,
		100,
		107,
		101,
		108,
		116,
		127,
		119,
		176,
		190,
		179,
		175,
		174,
		182,
		131,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		-1,
		78,
		74,
		-1,
		-1,
		97,
		90,
		78,
		66,
		56,
		66,
		83,
		83,
		86,
		91,
		99,
		110,
		106,
		110,
		113,
		-1,
		210,
		-1,
		162,
		123,
		129,
		144,
		152,
		-1,
		-1,
		-1,
		95,
		81,
		74,
		62,
		60,
		-1,
		131,
		115,
		96,
		-1,
		66,
		79,
		119,
		87,
		92,
		87,
		102,
		113,
		104,
		112,
		106,
		109,
		-1,
		-1,
		122,
		105,
		-1,
		-1,
		79,
		81,
		-1,
		86,
		75,
		60,
		52,
		-1,
		-1,
		103,
		99,
		-1,
		-1,
		53,
		91,
		90,
		98,
		93,
		98,
		110,
		106,
		102,
		112,
		103,
		-1,
		-1,
		100,
		92,
		86,
		-1,
		64,
		-1,
		88,
		-1,
		55,
		53,
		41,
		-1,
		-1,
		-1,
		84,
		47,
		63,
		86,
		112,
		110,
		101,
		94,
		101,
		104,
		97,
		103,
		-1,
		-1,
		-1,
		82,
		56,
		95,
		86,
		69,
		49,
		41,
		52,
		-1,
		65,
		-1,
		40,
		43,
		68,
		107,
		109,
		95,
		91,
		104,
		98,
		95,
		93,
		88,
		-1,
		58,
		91,
		55,
		55,
		31,
		29,
		79,
		-1,
		62,
		44,
		-1,
		72,
		62,
		110,
		85,
		94,
		87,
		81,
		82,
		90,
		-1,
		-1,
		-1,
		60,
		59,
		51,
		45,
		45,
		36,
		19,
		-1,
		67,
		49,
		35,
		52,
		52,
		43,
		51,
		100,
		96,
		99,
		97,
		75,
		-1,
		169,
		-1,
		-1,
		83,
		-1,
		-1,
		-1,
		54,
		27,
		0,
		16,
		24,
		37,
		32,
		34,
		47,
		55,
		53,
		50,
		62,
		58,
		78,
		74,
		106,
		-1,
		164,
		-1,
		90,
		-1,
		-1,
		62,
		36,
		22,
		11,
		20,
		20,
		25,
		27,
		49,
		79,
		65,
		63,
		68,
		73,
		-1,
		153,
		152,
		-1,
		81,
		73,
		59,
		-1,
		52,
		-1,
		66,
		27,
		-1,
		56,
		36,
		-1,
		74,
		70,
		-1,
		-1,
		140,
		97,
		-1,
		-1,
		-1,
		83,
		58,
		61,
		45,
		-1,
		47,
		47,
		-1,
		-1,
		-1,
		125,
		106,
		-1,
		76,
		79,
		-1,
		65,
		71,
		100,
		49,
		53,
		-1,
		-1,
		-1,
		134,
		115,
		109,
		91,
		96,
		84,
		96,
		82,
		85,
		63,
		52,
		73,
		-1,
		-1,
		-1,
		106,
		98,
		98,
		-1,
		-1,
		110,
		93,
		74,
		72,
		-1,
		-1,
		-1,
		128,
		109,
		-1,
		-1,
		100,
		-1,
		-1,
		106,
		71,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		117,
		-1,
		-1,
		-1,
		96,
		92,
		93,
		-1,
		-1,
		-1,
		-1,
		138,
		139,
		163,
		138,
		-1,
		-1,
		-1,
		88,
		82,
		-1,
		-1,
		141,
		139,
		-1,
		-1,
		-1,
		116,
		100,
		-1,
		86,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		121,
		-1,
		121,
		96,
		103,
		-1,
		-1,
		-1,
		-1,
		134,
		126,
		134,
		-1,
		106,
		108,
		-1,
		156,
		-1,
		-1,
		149,
		140,
		-1,
		-1,
		111,
		118,
		140,
		143,
		179,
		-1,
		130
	],
	[
		-1,
		239,
		228,
		239,
		247,
		220,
		227,
		-1,
		246,
		250,
		216,
		210,
		249,
		218,
		224,
		235,
		-1,
		-1,
		-1,
		239,
		238,
		206,
		204,
		213,
		218,
		225,
		-1,
		224,
		-1,
		260,
		239,
		250,
		255,
		199,
		196,
		216,
		235,
		217,
		209,
		275,
		229,
		200,
		194,
		212,
		202,
		211,
		203,
		-1,
		200,
		190,
		212,
		191,
		202,
		194,
		-1,
		-1,
		194,
		195,
		201,
		187,
		193,
		189,
		-1,
		199,
		183,
		-1,
		-1,
		184,
		185,
		169,
		172,
		180,
		178,
		191,
		183,
		178,
		-1,
		-1,
		175,
		171,
		178,
		165,
		161,
		178,
		191,
		173,
		187,
		186,
		-1,
		179,
		197,
		204,
		172,
		170,
		154,
		152,
		170,
		172,
		178,
		178,
		-1,
		188,
		189,
		184,
		192,
		194,
		170,
		157,
		157,
		167,
		160,
		179,
		167,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		188,
		171,
		188,
		180,
		170,
		185,
		178,
		160,
		157,
		155,
		152,
		168,
		166,
		176,
		-1,
		-1,
		281,
		250,
		279,
		237,
		218,
		-1,
		184,
		164,
		170,
		174,
		168,
		161,
		175,
		171,
		-1,
		146,
		145,
		173,
		159,
		170,
		241,
		-1,
		-1,
		239,
		231,
		214,
		217,
		194,
		190,
		179,
		178,
		170,
		156,
		152,
		158,
		161,
		161,
		167,
		140,
		150,
		154,
		152,
		177,
		-1,
		-1,
		212,
		-1,
		-1,
		238,
		221,
		-1,
		204,
		211,
		200,
		206,
		192,
		213,
		189,
		180,
		172,
		166,
		154,
		156,
		153,
		166,
		154,
		137,
		162,
		166,
		147,
		168,
		163,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		197,
		200,
		206,
		230,
		229,
		-1,
		201,
		189,
		190,
		175,
		172,
		159,
		147,
		160,
		145,
		152,
		151,
		141,
		139,
		169,
		144,
		166,
		163,
		182,
		187,
		181,
		190,
		-1,
		246,
		242,
		238,
		245,
		194,
		-1,
		-1,
		234,
		-1,
		237,
		238,
		213,
		186,
		189,
		176,
		167,
		154,
		143,
		154,
		143,
		140,
		148,
		133,
		148,
		139,
		138,
		156,
		166,
		174,
		178,
		184,
		-1,
		296,
		-1,
		238,
		222,
		224,
		196,
		217,
		-1,
		254,
		238,
		230,
		215,
		215,
		-1,
		185,
		182,
		172,
		150,
		135,
		152,
		144,
		142,
		146,
		128,
		142,
		133,
		151,
		158,
		156,
		160,
		180,
		192,
		256,
		246,
		-1,
		228,
		233,
		192,
		200,
		219,
		257,
		221,
		-1,
		216,
		-1,
		187,
		200,
		-1,
		156,
		152,
		134,
		135,
		130,
		145,
		139,
		124,
		121,
		139,
		142,
		149,
		153,
		169,
		-1,
		-1,
		241,
		245,
		234,
		185,
		204,
		228,
		265,
		214,
		203,
		202,
		-1,
		193,
		170,
		167,
		155,
		142,
		127,
		128,
		136,
		149,
		128,
		123,
		120,
		140,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		211,
		182,
		206,
		248,
		232,
		225,
		213,
		178,
		178,
		172,
		-1,
		166,
		145,
		136,
		125,
		123,
		136,
		133,
		138,
		118,
		116,
		135,
		147,
		138,
		155,
		-1,
		-1,
		-1,
		241,
		230,
		231,
		177,
		200,
		237,
		211,
		197,
		202,
		177,
		170,
		164,
		179,
		162,
		143,
		132,
		124,
		113,
		129,
		137,
		132,
		114,
		123,
		129,
		153,
		143,
		149,
		-1,
		-1,
		248,
		238,
		222,
		224,
		221,
		191,
		198,
		230,
		202,
		215,
		-1,
		169,
		-1,
		158,
		153,
		137,
		132,
		129,
		126,
		120,
		129,
		131,
		121,
		116,
		123,
		158,
		158,
		133,
		153,
		156,
		-1,
		-1,
		-1,
		241,
		236,
		211,
		188,
		172,
		208,
		-1,
		185,
		186,
		-1,
		163,
		157,
		154,
		139,
		135,
		130,
		134,
		127,
		134,
		127,
		125,
		126,
		108,
		140,
		-1,
		141,
		135,
		143,
		133,
		121,
		-1,
		-1,
		-1,
		234,
		213,
		206,
		226,
		167,
		219,
		-1,
		-1,
		170,
		163,
		-1,
		150,
		132,
		139,
		137,
		131,
		135,
		132,
		121,
		134,
		127,
		113,
		115,
		128,
		132,
		136,
		123,
		119,
		116,
		130,
		-1,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		187,
		-1,
		179,
		171,
		161,
		155,
		149,
		145,
		143,
		159,
		143,
		146,
		144,
		135,
		143,
		116,
		109,
		116,
		105,
		123,
		131,
		123,
		117,
		116,
		126,
		-1,
		254,
		240,
		211,
		-1,
		-1,
		200,
		-1,
		164,
		178,
		194,
		-1,
		187,
		166,
		181,
		159,
		155,
		151,
		166,
		167,
		144,
		144,
		142,
		133,
		121,
		110,
		113,
		105,
		127,
		127,
		111,
		112,
		116,
		-1,
		260,
		247,
		205,
		201,
		190,
		210,
		161,
		149,
		181,
		-1,
		-1,
		223,
		-1,
		157,
		174,
		165,
		163,
		156,
		138,
		145,
		153,
		130,
		125,
		115,
		104,
		104,
		99,
		121,
		107,
		105,
		114,
		130,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		176,
		163,
		157,
		-1,
		198,
		-1,
		201,
		191,
		175,
		160,
		193,
		-1,
		137,
		133,
		140,
		-1,
		150,
		-1,
		123,
		120,
		111,
		96,
		93,
		104,
		102,
		113,
		109,
		-1,
		210,
		195,
		188,
		178,
		192,
		163,
		-1,
		218,
		-1,
		-1,
		188,
		182,
		182,
		166,
		167,
		153,
		133,
		125,
		140,
		139,
		126,
		125,
		109,
		102,
		99,
		92,
		105,
		115,
		120,
		107,
		-1,
		-1,
		-1,
		215,
		201,
		205,
		165,
		184,
		-1,
		-1,
		250,
		205,
		191,
		-1,
		162,
		153,
		141,
		131,
		121,
		126,
		127,
		117,
		115,
		107,
		109,
		103,
		94,
		93,
		109,
		101,
		123,
		-1,
		-1,
		198,
		203,
		191,
		177,
		192,
		-1,
		-1,
		-1,
		197,
		213,
		181,
		160,
		142,
		-1,
		-1,
		125,
		118,
		112,
		115,
		103,
		123,
		118,
		102,
		87,
		102,
		106,
		114,
		105,
		-1,
		201,
		188,
		-1,
		-1,
		191,
		181,
		-1,
		-1,
		-1,
		-1,
		193,
		138,
		127,
		122,
		126,
		124,
		-1,
		98,
		109,
		102,
		121,
		128,
		104,
		89,
		83,
		89,
		101,
		110,
		-1,
		-1,
		205,
		-1,
		167,
		-1,
		-1,
		-1,
		-1,
		150,
		144,
		115,
		108,
		112,
		-1,
		100,
		102,
		99,
		111,
		107,
		104,
		95,
		86,
		82,
		86,
		90,
		104,
		108,
		228,
		-1,
		158,
		-1,
		-1,
		-1,
		168,
		183,
		154,
		131,
		104,
		99,
		92,
		86,
		91,
		102,
		111,
		122,
		87,
		89,
		79,
		78,
		82,
		99,
		103,
		-1,
		-1,
		156,
		152,
		187,
		176,
		180,
		181,
		-1,
		-1,
		108,
		99,
		90,
		82,
		95,
		98,
		83,
		85,
		85,
		83,
		77,
		87,
		102,
		97,
		-1,
		-1,
		-1,
		168,
		-1,
		170,
		-1,
		-1,
		178,
		179,
		126,
		108,
		104,
		102,
		91,
		85,
		73,
		78,
		88,
		82,
		79,
		73,
		77,
		100,
		89,
		128,
		-1,
		-1,
		230,
		-1,
		-1,
		-1,
		167,
		139,
		134,
		160,
		162,
		153,
		141,
		138,
		-1,
		108,
		114,
		79,
		86,
		69,
		76,
		81,
		78,
		67,
		74,
		90,
		89,
		84,
		120,
		111,
		117,
		-1,
		-1,
		223,
		212,
		201,
		207,
		-1,
		160,
		136,
		146,
		136,
		139,
		-1,
		-1,
		133,
		130,
		110,
		79,
		77,
		70,
		65,
		75,
		51,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		177,
		214,
		207,
		175,
		183,
		214,
		-1,
		150,
		142,
		133,
		128,
		130,
		-1,
		-1,
		106,
		97,
		98,
		86,
		83,
		89,
		88,
		71,
		77,
		78,
		70,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		170,
		190,
		169,
		172,
		196,
		210,
		-1,
		147,
		-1,
		-1,
		93,
		131,
		115,
		105,
		102,
		145,
		100,
		95,
		76,
		74,
		69,
		60,
		85,
		78,
		78,
		81,
		96,
		101,
		93,
		107,
		107,
		108,
		-1,
		159,
		170,
		163,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		83,
		-1,
		142,
		-1,
		125,
		129,
		108,
		111,
		90,
		77,
		63,
		71,
		77,
		76,
		82,
		82,
		83,
		92,
		103,
		115,
		114,
		115,
		184,
		140,
		143,
		154,
		165,
		180,
		184,
		-1,
		148,
		184,
		89,
		-1,
		73,
		-1,
		-1,
		-1,
		139,
		121,
		113,
		110,
		89,
		89,
		55,
		59,
		72,
		79,
		89,
		100,
		92,
		96,
		109,
		120,
		123,
		180,
		171,
		184,
		129,
		129,
		150,
		159,
		180,
		144,
		141,
		178,
		96,
		85,
		80,
		67,
		-1,
		-1,
		123,
		131,
		-1,
		-1,
		96,
		63,
		51,
		61,
		65,
		79,
		91,
		104,
		92,
		97,
		91,
		123,
		-1,
		173,
		172,
		161,
		158,
		134,
		125,
		120,
		147,
		-1,
		-1,
		142,
		169,
		152,
		129,
		127,
		152,
		-1,
		56,
		-1,
		-1,
		103,
		-1,
		-1,
		88,
		68,
		57,
		48,
		53,
		73,
		84,
		106,
		88,
		105,
		96,
		106,
		110,
		157,
		154,
		142,
		140,
		163,
		128,
		116,
		-1,
		124,
		127,
		133,
		140,
		130,
		141,
		-1,
		-1,
		72,
		52,
		-1,
		-1,
		86,
		84,
		73,
		-1,
		63,
		45,
		50,
		80,
		82,
		84,
		91,
		85,
		92,
		100,
		111,
		103,
		166,
		180,
		169,
		165,
		164,
		172,
		121,
		114,
		121,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		77,
		-1,
		62,
		58,
		-1,
		-1,
		81,
		74,
		62,
		50,
		40,
		50,
		67,
		67,
		70,
		75,
		83,
		94,
		90,
		94,
		97,
		-1,
		200,
		-1,
		152,
		113,
		119,
		134,
		142,
		-1,
		-1,
		-1,
		79,
		65,
		58,
		46,
		44,
		-1,
		115,
		99,
		80,
		-1,
		50,
		63,
		103,
		71,
		76,
		71,
		86,
		97,
		88,
		96,
		90,
		93,
		-1,
		-1,
		112,
		95,
		-1,
		-1,
		69,
		71,
		-1,
		70,
		59,
		44,
		36,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		37,
		75,
		74,
		82,
		77,
		82,
		94,
		90,
		86,
		96,
		87,
		-1,
		-1,
		90,
		82,
		76,
		-1,
		54,
		-1,
		72,
		-1,
		39,
		45,
		33,
		-1,
		-1,
		-1,
		68,
		31,
		47,
		70,
		96,
		94,
		85,
		78,
		85,
		88,
		81,
		87,
		-1,
		-1,
		-1,
		72,
		46,
		79,
		70,
		53,
		33,
		25,
		44,
		-1,
		49,
		-1,
		24,
		27,
		52,
		91,
		93,
		79,
		75,
		88,
		82,
		79,
		77,
		78,
		-1,
		48,
		81,
		45,
		39,
		15,
		19,
		63,
		-1,
		46,
		28,
		-1,
		56,
		46,
		94,
		69,
		78,
		71,
		65,
		66,
		74,
		-1,
		-1,
		-1,
		50,
		49,
		41,
		35,
		35,
		20,
		11,
		-1,
		51,
		33,
		19,
		36,
		36,
		27,
		35,
		84,
		80,
		83,
		81,
		59,
		-1,
		166,
		-1,
		-1,
		73,
		-1,
		-1,
		-1,
		44,
		39,
		12,
		0,
		14,
		21,
		16,
		18,
		31,
		39,
		37,
		34,
		46,
		42,
		62,
		58,
		90,
		-1,
		161,
		-1,
		80,
		-1,
		-1,
		62,
		42,
		34,
		23,
		12,
		10,
		13,
		11,
		33,
		63,
		49,
		47,
		52,
		57,
		-1,
		150,
		149,
		-1,
		81,
		73,
		59,
		-1,
		52,
		-1,
		58,
		19,
		-1,
		40,
		20,
		-1,
		58,
		54,
		-1,
		-1,
		137,
		97,
		-1,
		-1,
		-1,
		82,
		62,
		53,
		37,
		-1,
		31,
		31,
		-1,
		-1,
		-1,
		122,
		106,
		-1,
		75,
		78,
		-1,
		69,
		75,
		86,
		33,
		37,
		-1,
		-1,
		-1,
		131,
		112,
		106,
		90,
		95,
		83,
		99,
		85,
		69,
		47,
		36,
		57,
		-1,
		-1,
		-1,
		103,
		95,
		92,
		-1,
		-1,
		94,
		77,
		58,
		56,
		-1,
		-1,
		-1,
		125,
		106,
		-1,
		-1,
		84,
		-1,
		-1,
		90,
		55,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		114,
		-1,
		-1,
		-1,
		80,
		76,
		77,
		-1,
		-1,
		-1,
		-1,
		135,
		136,
		160,
		128,
		-1,
		-1,
		-1,
		72,
		66,
		-1,
		-1,
		138,
		136,
		-1,
		-1,
		-1,
		100,
		84,
		-1,
		70,
		-1,
		-1,
		-1,
		91,
		-1,
		-1,
		103,
		-1,
		-1,
		-1,
		105,
		-1,
		105,
		80,
		87,
		-1,
		-1,
		-1,
		-1,
		118,
		110,
		118,
		-1,
		90,
		92,
		-1,
		140,
		-1,
		-1,
		133,
		124,
		-1,
		-1,
		95,
		102,
		124,
		127,
		163,
		-1,
		114
	],
	[
		-1,
		242,
		231,
		242,
		250,
		223,
		230,
		-1,
		249,
		253,
		219,
		213,
		252,
		221,
		227,
		238,
		-1,
		-1,
		-1,
		242,
		241,
		209,
		207,
		216,
		221,
		228,
		-1,
		227,
		-1,
		263,
		242,
		253,
		258,
		202,
		199,
		219,
		238,
		220,
		212,
		278,
		232,
		203,
		197,
		215,
		205,
		214,
		206,
		-1,
		203,
		193,
		215,
		194,
		205,
		197,
		-1,
		-1,
		197,
		198,
		204,
		190,
		196,
		192,
		-1,
		202,
		186,
		-1,
		-1,
		187,
		188,
		172,
		175,
		183,
		181,
		194,
		186,
		181,
		-1,
		-1,
		178,
		174,
		181,
		168,
		164,
		181,
		194,
		176,
		190,
		189,
		-1,
		182,
		200,
		207,
		175,
		173,
		157,
		155,
		173,
		175,
		181,
		181,
		-1,
		191,
		192,
		187,
		195,
		197,
		173,
		160,
		160,
		170,
		163,
		182,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		174,
		191,
		183,
		173,
		188,
		181,
		163,
		160,
		158,
		155,
		171,
		169,
		179,
		-1,
		-1,
		284,
		253,
		282,
		240,
		221,
		-1,
		187,
		167,
		173,
		177,
		171,
		164,
		178,
		174,
		-1,
		149,
		148,
		176,
		162,
		173,
		244,
		-1,
		-1,
		242,
		234,
		217,
		220,
		197,
		193,
		182,
		181,
		173,
		159,
		155,
		161,
		164,
		164,
		170,
		143,
		153,
		157,
		155,
		180,
		-1,
		-1,
		215,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		203,
		209,
		195,
		216,
		192,
		183,
		175,
		169,
		157,
		159,
		156,
		169,
		157,
		140,
		165,
		169,
		150,
		171,
		166,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		232,
		-1,
		204,
		192,
		193,
		178,
		175,
		162,
		150,
		163,
		148,
		155,
		154,
		144,
		142,
		172,
		147,
		169,
		166,
		185,
		190,
		184,
		193,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		240,
		241,
		216,
		189,
		192,
		179,
		170,
		157,
		146,
		157,
		146,
		143,
		151,
		136,
		151,
		142,
		141,
		159,
		169,
		177,
		181,
		187,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		241,
		233,
		218,
		218,
		-1,
		188,
		185,
		175,
		153,
		138,
		155,
		147,
		145,
		149,
		131,
		145,
		136,
		154,
		161,
		159,
		163,
		183,
		195,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		260,
		224,
		-1,
		219,
		-1,
		190,
		203,
		-1,
		159,
		155,
		137,
		138,
		133,
		148,
		142,
		127,
		124,
		142,
		145,
		152,
		156,
		172,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		217,
		206,
		205,
		-1,
		196,
		173,
		170,
		158,
		145,
		130,
		131,
		139,
		152,
		131,
		126,
		123,
		143,
		169,
		147,
		159,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		235,
		228,
		216,
		181,
		181,
		175,
		-1,
		169,
		148,
		139,
		128,
		126,
		139,
		136,
		141,
		121,
		119,
		138,
		150,
		141,
		158,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		180,
		203,
		240,
		214,
		200,
		205,
		180,
		173,
		167,
		182,
		165,
		146,
		135,
		127,
		116,
		132,
		140,
		135,
		117,
		126,
		132,
		156,
		146,
		152,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		194,
		201,
		233,
		205,
		218,
		-1,
		172,
		-1,
		161,
		156,
		140,
		135,
		132,
		129,
		123,
		132,
		134,
		124,
		119,
		126,
		161,
		161,
		136,
		156,
		159,
		-1,
		-1,
		-1,
		244,
		239,
		214,
		191,
		175,
		211,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		142,
		138,
		133,
		137,
		130,
		137,
		130,
		128,
		129,
		111,
		143,
		-1,
		144,
		138,
		146,
		136,
		124,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		142,
		140,
		134,
		138,
		135,
		124,
		137,
		130,
		116,
		118,
		131,
		135,
		139,
		126,
		122,
		119,
		133,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		162,
		146,
		149,
		147,
		138,
		146,
		119,
		112,
		119,
		108,
		126,
		134,
		126,
		120,
		119,
		129,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		190,
		169,
		184,
		162,
		158,
		154,
		169,
		170,
		147,
		147,
		145,
		136,
		124,
		113,
		116,
		108,
		130,
		130,
		114,
		115,
		119,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		152,
		184,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		168,
		166,
		159,
		141,
		148,
		156,
		133,
		128,
		118,
		107,
		107,
		102,
		124,
		110,
		108,
		117,
		133,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		140,
		136,
		143,
		-1,
		153,
		-1,
		126,
		123,
		114,
		99,
		96,
		107,
		105,
		116,
		112,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		221,
		-1,
		-1,
		191,
		185,
		185,
		169,
		170,
		156,
		136,
		128,
		143,
		142,
		129,
		128,
		112,
		105,
		102,
		95,
		108,
		118,
		123,
		110,
		-1,
		-1,
		-1,
		218,
		204,
		208,
		168,
		187,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		165,
		156,
		144,
		134,
		124,
		129,
		130,
		120,
		118,
		110,
		112,
		106,
		97,
		96,
		112,
		104,
		126,
		-1,
		-1,
		201,
		206,
		194,
		180,
		199,
		-1,
		-1,
		-1,
		200,
		216,
		184,
		163,
		145,
		-1,
		-1,
		128,
		121,
		115,
		118,
		106,
		126,
		121,
		105,
		90,
		105,
		109,
		117,
		108,
		-1,
		204,
		191,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		105,
		124,
		131,
		107,
		92,
		86,
		92,
		104,
		113,
		-1,
		-1,
		216,
		-1,
		182,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		102,
		114,
		110,
		107,
		98,
		89,
		85,
		89,
		93,
		107,
		111,
		239,
		-1,
		173,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		114,
		125,
		90,
		92,
		82,
		81,
		85,
		102,
		106,
		-1,
		-1,
		171,
		167,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		86,
		88,
		88,
		86,
		80,
		90,
		105,
		100,
		-1,
		-1,
		-1,
		183,
		-1,
		185,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		94,
		88,
		76,
		81,
		91,
		85,
		82,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		170,
		154,
		149,
		163,
		165,
		156,
		144,
		141,
		-1,
		111,
		117,
		82,
		89,
		72,
		79,
		84,
		81,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		163,
		151,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		80,
		73,
		68,
		78,
		54,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		189,
		226,
		219,
		187,
		195,
		226,
		-1,
		153,
		145,
		148,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		92,
		91,
		74,
		80,
		81,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		150,
		-1,
		-1,
		108,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		79,
		77,
		72,
		63,
		88,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		98,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		93,
		80,
		66,
		74,
		80,
		79,
		85,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		160,
		196,
		104,
		-1,
		88,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		113,
		92,
		92,
		58,
		62,
		75,
		82,
		92,
		103,
		95,
		99,
		112,
		123,
		126,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		156,
		153,
		190,
		111,
		100,
		95,
		82,
		-1,
		-1,
		126,
		134,
		-1,
		-1,
		99,
		66,
		54,
		64,
		68,
		82,
		94,
		107,
		95,
		100,
		94,
		126,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		181,
		165,
		144,
		142,
		167,
		-1,
		71,
		-1,
		-1,
		106,
		-1,
		-1,
		91,
		71,
		60,
		51,
		56,
		76,
		87,
		109,
		91,
		108,
		99,
		109,
		113,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		136,
		139,
		145,
		152,
		145,
		156,
		-1,
		-1,
		87,
		67,
		-1,
		-1,
		89,
		87,
		76,
		-1,
		66,
		48,
		53,
		83,
		85,
		87,
		94,
		88,
		95,
		103,
		114,
		106,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		92,
		-1,
		77,
		73,
		-1,
		-1,
		84,
		77,
		65,
		53,
		43,
		53,
		70,
		70,
		73,
		78,
		86,
		97,
		93,
		97,
		100,
		-1,
		212,
		-1,
		164,
		125,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		94,
		80,
		73,
		61,
		59,
		-1,
		118,
		102,
		83,
		-1,
		53,
		66,
		106,
		74,
		79,
		74,
		89,
		100,
		91,
		99,
		93,
		96,
		-1,
		-1,
		124,
		107,
		-1,
		-1,
		81,
		83,
		-1,
		85,
		74,
		59,
		51,
		-1,
		-1,
		90,
		86,
		-1,
		-1,
		40,
		78,
		77,
		85,
		80,
		85,
		97,
		93,
		89,
		99,
		90,
		-1,
		-1,
		102,
		94,
		88,
		-1,
		66,
		-1,
		87,
		-1,
		54,
		55,
		43,
		-1,
		-1,
		-1,
		71,
		34,
		50,
		73,
		99,
		97,
		88,
		81,
		88,
		91,
		84,
		90,
		-1,
		-1,
		-1,
		84,
		58,
		94,
		85,
		68,
		48,
		40,
		54,
		-1,
		52,
		-1,
		27,
		30,
		55,
		94,
		96,
		82,
		78,
		91,
		85,
		82,
		80,
		90,
		-1,
		60,
		93,
		57,
		54,
		30,
		31,
		66,
		-1,
		49,
		31,
		-1,
		59,
		49,
		97,
		72,
		81,
		74,
		68,
		69,
		77,
		-1,
		-1,
		-1,
		62,
		61,
		53,
		47,
		47,
		35,
		21,
		-1,
		54,
		36,
		22,
		39,
		39,
		30,
		38,
		87,
		83,
		86,
		84,
		62,
		-1,
		171,
		-1,
		-1,
		85,
		-1,
		-1,
		-1,
		56,
		49,
		22,
		15,
		0,
		16,
		19,
		19,
		34,
		42,
		40,
		37,
		49,
		45,
		65,
		61,
		93,
		-1,
		166,
		-1,
		92,
		-1,
		-1,
		74,
		54,
		44,
		33,
		21,
		18,
		6,
		14,
		32,
		64,
		52,
		50,
		55,
		60,
		-1,
		155,
		154,
		-1,
		93,
		85,
		71,
		-1,
		64,
		-1,
		67,
		28,
		-1,
		37,
		15,
		-1,
		61,
		57,
		-1,
		-1,
		142,
		109,
		-1,
		-1,
		-1,
		94,
		74,
		62,
		46,
		-1,
		29,
		28,
		-1,
		-1,
		-1,
		127,
		118,
		-1,
		87,
		90,
		-1,
		81,
		79,
		87,
		35,
		39,
		-1,
		-1,
		-1,
		136,
		117,
		111,
		102,
		107,
		95,
		100,
		86,
		70,
		48,
		38,
		57,
		-1,
		-1,
		-1,
		108,
		100,
		93,
		-1,
		-1,
		95,
		78,
		59,
		57,
		-1,
		-1,
		-1,
		130,
		111,
		-1,
		-1,
		85,
		-1,
		-1,
		91,
		56,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		119,
		-1,
		-1,
		-1,
		81,
		77,
		78,
		-1,
		-1,
		-1,
		-1,
		141,
		142,
		165,
		129,
		-1,
		-1,
		-1,
		73,
		67,
		-1,
		-1,
		144,
		142,
		-1,
		-1,
		-1,
		101,
		85,
		-1,
		71,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		104,
		-1,
		-1,
		-1,
		106,
		-1,
		106,
		81,
		88,
		-1,
		-1,
		-1,
		-1,
		119,
		111,
		119,
		-1,
		91,
		93,
		-1,
		141,
		-1,
		-1,
		134,
		125,
		-1,
		-1,
		96,
		103,
		125,
		128,
		164,
		-1,
		115
	],
	[
		-1,
		242,
		231,
		242,
		250,
		223,
		230,
		-1,
		249,
		253,
		219,
		213,
		252,
		221,
		227,
		238,
		-1,
		-1,
		-1,
		242,
		241,
		209,
		207,
		216,
		221,
		228,
		-1,
		227,
		-1,
		263,
		242,
		253,
		258,
		202,
		199,
		219,
		238,
		220,
		212,
		278,
		232,
		203,
		197,
		215,
		205,
		214,
		206,
		-1,
		203,
		193,
		215,
		194,
		205,
		197,
		-1,
		-1,
		197,
		198,
		204,
		190,
		196,
		192,
		-1,
		202,
		186,
		-1,
		-1,
		187,
		188,
		172,
		175,
		183,
		181,
		194,
		186,
		181,
		-1,
		-1,
		178,
		174,
		181,
		168,
		164,
		181,
		194,
		176,
		190,
		189,
		-1,
		182,
		200,
		207,
		175,
		173,
		157,
		155,
		173,
		175,
		181,
		181,
		-1,
		191,
		192,
		187,
		195,
		197,
		173,
		160,
		160,
		170,
		163,
		182,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		174,
		191,
		183,
		173,
		188,
		181,
		163,
		160,
		158,
		155,
		171,
		169,
		179,
		-1,
		-1,
		284,
		253,
		282,
		240,
		221,
		-1,
		187,
		167,
		173,
		177,
		171,
		164,
		178,
		174,
		-1,
		149,
		148,
		176,
		162,
		173,
		244,
		-1,
		-1,
		242,
		234,
		217,
		220,
		197,
		193,
		182,
		181,
		173,
		159,
		155,
		161,
		164,
		164,
		170,
		143,
		153,
		157,
		155,
		180,
		-1,
		-1,
		215,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		203,
		209,
		195,
		216,
		192,
		183,
		175,
		169,
		157,
		159,
		156,
		169,
		157,
		140,
		165,
		169,
		150,
		171,
		166,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		232,
		-1,
		204,
		192,
		193,
		178,
		175,
		162,
		150,
		163,
		148,
		155,
		154,
		144,
		142,
		172,
		147,
		169,
		166,
		185,
		190,
		184,
		193,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		240,
		241,
		216,
		189,
		192,
		179,
		170,
		157,
		146,
		157,
		146,
		143,
		151,
		136,
		151,
		142,
		141,
		159,
		169,
		177,
		181,
		187,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		241,
		233,
		218,
		218,
		-1,
		188,
		185,
		175,
		153,
		138,
		155,
		147,
		145,
		149,
		131,
		145,
		136,
		154,
		161,
		159,
		163,
		183,
		195,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		260,
		224,
		-1,
		219,
		-1,
		190,
		203,
		-1,
		159,
		155,
		137,
		138,
		133,
		148,
		142,
		127,
		124,
		142,
		145,
		152,
		156,
		172,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		217,
		206,
		205,
		-1,
		196,
		173,
		170,
		158,
		145,
		130,
		131,
		139,
		152,
		131,
		126,
		123,
		143,
		169,
		147,
		159,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		235,
		228,
		216,
		181,
		181,
		175,
		-1,
		169,
		148,
		139,
		128,
		126,
		139,
		136,
		141,
		121,
		119,
		138,
		150,
		141,
		158,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		180,
		203,
		240,
		214,
		200,
		205,
		180,
		173,
		167,
		182,
		165,
		146,
		135,
		127,
		116,
		132,
		140,
		135,
		117,
		126,
		132,
		156,
		146,
		152,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		194,
		201,
		233,
		205,
		218,
		-1,
		172,
		-1,
		161,
		156,
		140,
		135,
		132,
		129,
		123,
		132,
		134,
		124,
		119,
		126,
		161,
		161,
		136,
		156,
		159,
		-1,
		-1,
		-1,
		244,
		239,
		214,
		191,
		175,
		211,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		142,
		138,
		133,
		137,
		130,
		137,
		130,
		128,
		129,
		111,
		143,
		-1,
		144,
		138,
		146,
		136,
		124,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		142,
		140,
		134,
		138,
		135,
		124,
		137,
		130,
		116,
		118,
		131,
		135,
		139,
		126,
		122,
		119,
		133,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		162,
		146,
		149,
		147,
		138,
		146,
		119,
		112,
		119,
		108,
		126,
		134,
		126,
		120,
		119,
		129,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		190,
		169,
		184,
		162,
		158,
		154,
		169,
		170,
		147,
		147,
		145,
		136,
		124,
		113,
		116,
		108,
		130,
		130,
		114,
		115,
		119,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		152,
		184,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		168,
		166,
		159,
		141,
		148,
		156,
		133,
		128,
		118,
		107,
		107,
		102,
		124,
		110,
		108,
		117,
		133,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		140,
		136,
		143,
		-1,
		153,
		-1,
		126,
		123,
		114,
		99,
		96,
		107,
		105,
		116,
		112,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		221,
		-1,
		-1,
		191,
		185,
		185,
		169,
		170,
		156,
		136,
		128,
		143,
		142,
		129,
		128,
		112,
		105,
		102,
		95,
		108,
		118,
		123,
		110,
		-1,
		-1,
		-1,
		218,
		204,
		208,
		168,
		187,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		165,
		156,
		144,
		134,
		124,
		129,
		130,
		120,
		118,
		110,
		112,
		106,
		97,
		96,
		112,
		104,
		126,
		-1,
		-1,
		201,
		206,
		194,
		180,
		199,
		-1,
		-1,
		-1,
		200,
		216,
		184,
		163,
		145,
		-1,
		-1,
		128,
		121,
		115,
		118,
		106,
		126,
		121,
		105,
		90,
		105,
		109,
		117,
		108,
		-1,
		204,
		191,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		105,
		124,
		131,
		107,
		92,
		86,
		92,
		104,
		113,
		-1,
		-1,
		216,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		102,
		114,
		110,
		107,
		98,
		89,
		85,
		89,
		93,
		107,
		111,
		239,
		-1,
		180,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		114,
		125,
		90,
		92,
		82,
		81,
		85,
		102,
		106,
		-1,
		-1,
		178,
		174,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		86,
		88,
		88,
		86,
		80,
		90,
		105,
		100,
		-1,
		-1,
		-1,
		190,
		-1,
		192,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		94,
		88,
		76,
		81,
		91,
		85,
		82,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		170,
		161,
		156,
		163,
		165,
		156,
		144,
		141,
		-1,
		111,
		117,
		82,
		89,
		72,
		79,
		84,
		81,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		163,
		158,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		80,
		73,
		68,
		78,
		54,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		199,
		236,
		229,
		197,
		205,
		236,
		-1,
		153,
		145,
		155,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		92,
		91,
		74,
		80,
		81,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		192,
		212,
		191,
		194,
		218,
		232,
		-1,
		150,
		-1,
		-1,
		115,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		79,
		77,
		72,
		63,
		88,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		105,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		93,
		80,
		66,
		74,
		80,
		79,
		85,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		162,
		201,
		111,
		-1,
		95,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		113,
		92,
		92,
		58,
		62,
		75,
		82,
		92,
		103,
		95,
		99,
		112,
		123,
		126,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		166,
		163,
		195,
		118,
		107,
		102,
		89,
		-1,
		-1,
		126,
		134,
		-1,
		-1,
		99,
		66,
		54,
		64,
		68,
		82,
		94,
		107,
		95,
		100,
		94,
		126,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		191,
		174,
		151,
		149,
		174,
		-1,
		78,
		-1,
		-1,
		106,
		-1,
		-1,
		91,
		71,
		60,
		51,
		56,
		76,
		87,
		109,
		91,
		108,
		99,
		109,
		113,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		146,
		149,
		155,
		162,
		152,
		163,
		-1,
		-1,
		94,
		74,
		-1,
		-1,
		89,
		87,
		76,
		-1,
		66,
		48,
		53,
		83,
		85,
		87,
		94,
		88,
		95,
		103,
		114,
		106,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		-1,
		84,
		80,
		-1,
		-1,
		84,
		77,
		65,
		53,
		43,
		53,
		70,
		70,
		73,
		78,
		86,
		97,
		93,
		97,
		100,
		-1,
		222,
		-1,
		174,
		135,
		141,
		156,
		164,
		-1,
		-1,
		-1,
		101,
		87,
		80,
		68,
		66,
		-1,
		118,
		102,
		83,
		-1,
		53,
		66,
		106,
		74,
		79,
		74,
		89,
		100,
		91,
		99,
		93,
		96,
		-1,
		-1,
		134,
		117,
		-1,
		-1,
		91,
		93,
		-1,
		92,
		81,
		66,
		58,
		-1,
		-1,
		90,
		86,
		-1,
		-1,
		40,
		78,
		77,
		85,
		80,
		85,
		97,
		93,
		89,
		99,
		90,
		-1,
		-1,
		112,
		104,
		98,
		-1,
		76,
		-1,
		94,
		-1,
		61,
		67,
		55,
		-1,
		-1,
		-1,
		71,
		34,
		50,
		73,
		99,
		97,
		88,
		81,
		88,
		91,
		84,
		90,
		-1,
		-1,
		-1,
		94,
		68,
		101,
		92,
		75,
		55,
		47,
		66,
		-1,
		52,
		-1,
		27,
		30,
		55,
		94,
		96,
		82,
		78,
		91,
		85,
		82,
		80,
		100,
		-1,
		70,
		103,
		67,
		61,
		37,
		41,
		66,
		-1,
		49,
		31,
		-1,
		59,
		49,
		97,
		72,
		81,
		74,
		68,
		69,
		77,
		-1,
		-1,
		-1,
		72,
		71,
		63,
		57,
		57,
		42,
		33,
		-1,
		54,
		36,
		22,
		39,
		39,
		30,
		38,
		87,
		83,
		86,
		84,
		62,
		-1,
		170,
		-1,
		-1,
		95,
		-1,
		-1,
		-1,
		66,
		61,
		34,
		22,
		20,
		0,
		19,
		19,
		34,
		42,
		40,
		37,
		49,
		45,
		65,
		61,
		93,
		-1,
		165,
		-1,
		102,
		-1,
		-1,
		84,
		64,
		56,
		45,
		34,
		32,
		15,
		14,
		30,
		64,
		52,
		50,
		55,
		60,
		-1,
		154,
		153,
		-1,
		103,
		95,
		81,
		-1,
		74,
		-1,
		80,
		41,
		-1,
		36,
		13,
		-1,
		61,
		57,
		-1,
		-1,
		141,
		119,
		-1,
		-1,
		-1,
		104,
		84,
		75,
		59,
		-1,
		28,
		27,
		-1,
		-1,
		-1,
		126,
		127,
		-1,
		97,
		100,
		-1,
		87,
		78,
		86,
		34,
		38,
		-1,
		-1,
		-1,
		135,
		116,
		110,
		112,
		107,
		105,
		99,
		85,
		69,
		47,
		37,
		56,
		-1,
		-1,
		-1,
		107,
		99,
		92,
		-1,
		-1,
		94,
		77,
		58,
		56,
		-1,
		-1,
		-1,
		129,
		110,
		-1,
		-1,
		84,
		-1,
		-1,
		90,
		55,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		118,
		-1,
		-1,
		-1,
		80,
		76,
		77,
		-1,
		-1,
		-1,
		-1,
		140,
		141,
		164,
		128,
		-1,
		-1,
		-1,
		72,
		66,
		-1,
		-1,
		143,
		141,
		-1,
		-1,
		-1,
		100,
		84,
		-1,
		70,
		-1,
		-1,
		-1,
		91,
		-1,
		-1,
		103,
		-1,
		-1,
		-1,
		105,
		-1,
		105,
		80,
		87,
		-1,
		-1,
		-1,
		-1,
		118,
		110,
		118,
		-1,
		90,
		92,
		-1,
		140,
		-1,
		-1,
		133,
		124,
		-1,
		-1,
		95,
		102,
		124,
		127,
		163,
		-1,
		114
	],
	[
		-1,
		225,
		214,
		225,
		233,
		206,
		213,
		-1,
		232,
		236,
		202,
		196,
		235,
		204,
		210,
		221,
		-1,
		-1,
		-1,
		225,
		224,
		192,
		190,
		199,
		204,
		211,
		-1,
		210,
		-1,
		246,
		225,
		236,
		241,
		185,
		182,
		202,
		221,
		203,
		195,
		261,
		215,
		186,
		180,
		198,
		188,
		197,
		189,
		-1,
		186,
		176,
		198,
		177,
		188,
		180,
		-1,
		-1,
		180,
		181,
		187,
		173,
		179,
		175,
		-1,
		185,
		169,
		-1,
		-1,
		170,
		171,
		155,
		158,
		166,
		164,
		177,
		169,
		164,
		-1,
		-1,
		161,
		157,
		164,
		151,
		147,
		164,
		177,
		159,
		173,
		172,
		-1,
		165,
		183,
		190,
		158,
		156,
		140,
		138,
		156,
		158,
		164,
		164,
		-1,
		174,
		175,
		170,
		178,
		180,
		156,
		143,
		143,
		153,
		146,
		165,
		153,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		174,
		157,
		174,
		166,
		156,
		171,
		164,
		146,
		143,
		141,
		138,
		154,
		152,
		162,
		-1,
		-1,
		267,
		236,
		265,
		223,
		204,
		-1,
		170,
		150,
		156,
		160,
		154,
		147,
		161,
		157,
		-1,
		132,
		131,
		159,
		145,
		156,
		227,
		-1,
		-1,
		225,
		217,
		200,
		203,
		180,
		176,
		165,
		164,
		156,
		142,
		138,
		144,
		147,
		147,
		153,
		126,
		136,
		140,
		138,
		163,
		-1,
		-1,
		198,
		-1,
		-1,
		224,
		207,
		-1,
		190,
		197,
		186,
		192,
		178,
		199,
		175,
		166,
		158,
		152,
		140,
		142,
		139,
		152,
		140,
		123,
		148,
		152,
		133,
		154,
		149,
		-1,
		197,
		181,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		183,
		186,
		192,
		216,
		215,
		-1,
		187,
		175,
		176,
		161,
		158,
		145,
		133,
		146,
		131,
		138,
		137,
		127,
		125,
		155,
		130,
		152,
		149,
		168,
		173,
		167,
		176,
		-1,
		232,
		228,
		224,
		231,
		180,
		-1,
		-1,
		220,
		-1,
		223,
		224,
		199,
		172,
		175,
		162,
		153,
		140,
		129,
		140,
		129,
		126,
		134,
		119,
		134,
		125,
		124,
		142,
		152,
		160,
		164,
		170,
		-1,
		282,
		-1,
		224,
		208,
		210,
		182,
		203,
		-1,
		240,
		224,
		216,
		201,
		201,
		-1,
		171,
		168,
		158,
		136,
		121,
		138,
		130,
		128,
		132,
		114,
		128,
		119,
		137,
		144,
		142,
		146,
		166,
		178,
		242,
		232,
		-1,
		214,
		219,
		178,
		186,
		205,
		243,
		207,
		-1,
		202,
		-1,
		173,
		186,
		-1,
		142,
		138,
		120,
		121,
		116,
		131,
		125,
		110,
		107,
		125,
		128,
		135,
		139,
		155,
		-1,
		-1,
		227,
		231,
		220,
		171,
		190,
		214,
		251,
		200,
		189,
		188,
		-1,
		179,
		156,
		153,
		141,
		128,
		113,
		114,
		122,
		135,
		114,
		109,
		106,
		126,
		152,
		130,
		142,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		197,
		168,
		192,
		234,
		218,
		211,
		199,
		164,
		164,
		158,
		-1,
		152,
		131,
		122,
		111,
		109,
		122,
		119,
		124,
		104,
		102,
		121,
		133,
		124,
		141,
		-1,
		-1,
		-1,
		227,
		216,
		217,
		163,
		186,
		223,
		197,
		183,
		188,
		163,
		156,
		150,
		165,
		148,
		129,
		118,
		110,
		99,
		115,
		123,
		118,
		100,
		109,
		115,
		139,
		129,
		135,
		-1,
		-1,
		234,
		224,
		208,
		210,
		207,
		177,
		184,
		216,
		188,
		201,
		-1,
		155,
		-1,
		144,
		139,
		123,
		118,
		115,
		112,
		106,
		115,
		117,
		107,
		102,
		109,
		144,
		144,
		119,
		139,
		142,
		-1,
		-1,
		-1,
		227,
		222,
		197,
		174,
		158,
		194,
		-1,
		171,
		172,
		-1,
		149,
		143,
		140,
		125,
		121,
		116,
		120,
		113,
		120,
		113,
		111,
		112,
		94,
		126,
		-1,
		127,
		121,
		129,
		119,
		107,
		-1,
		-1,
		-1,
		220,
		199,
		192,
		212,
		153,
		205,
		-1,
		-1,
		156,
		149,
		-1,
		136,
		118,
		125,
		123,
		117,
		121,
		118,
		107,
		120,
		113,
		99,
		101,
		114,
		118,
		122,
		109,
		105,
		102,
		116,
		-1,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		173,
		-1,
		165,
		157,
		147,
		141,
		135,
		131,
		129,
		145,
		129,
		132,
		130,
		121,
		129,
		102,
		95,
		102,
		91,
		109,
		117,
		109,
		103,
		102,
		112,
		-1,
		240,
		226,
		197,
		-1,
		-1,
		186,
		-1,
		150,
		164,
		180,
		-1,
		173,
		152,
		167,
		145,
		141,
		137,
		152,
		153,
		130,
		130,
		128,
		119,
		107,
		96,
		99,
		91,
		113,
		113,
		97,
		98,
		102,
		-1,
		246,
		233,
		191,
		187,
		176,
		196,
		147,
		135,
		167,
		-1,
		-1,
		209,
		-1,
		143,
		160,
		151,
		149,
		142,
		124,
		131,
		139,
		116,
		111,
		101,
		90,
		90,
		85,
		107,
		93,
		91,
		100,
		116,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		162,
		149,
		143,
		-1,
		184,
		-1,
		187,
		177,
		161,
		146,
		179,
		-1,
		123,
		119,
		126,
		-1,
		136,
		-1,
		109,
		106,
		97,
		82,
		79,
		90,
		88,
		99,
		95,
		-1,
		196,
		181,
		174,
		164,
		178,
		149,
		-1,
		204,
		-1,
		-1,
		174,
		168,
		168,
		152,
		153,
		139,
		119,
		111,
		126,
		125,
		112,
		111,
		95,
		88,
		85,
		78,
		91,
		101,
		106,
		93,
		-1,
		-1,
		-1,
		201,
		187,
		191,
		151,
		170,
		-1,
		-1,
		236,
		191,
		177,
		-1,
		148,
		139,
		127,
		117,
		107,
		112,
		113,
		103,
		101,
		93,
		95,
		89,
		80,
		79,
		95,
		87,
		109,
		-1,
		-1,
		184,
		189,
		177,
		163,
		182,
		-1,
		-1,
		-1,
		183,
		199,
		167,
		146,
		128,
		-1,
		-1,
		111,
		104,
		98,
		101,
		89,
		109,
		104,
		88,
		73,
		88,
		92,
		100,
		91,
		-1,
		187,
		174,
		-1,
		-1,
		185,
		179,
		-1,
		-1,
		-1,
		-1,
		179,
		124,
		113,
		108,
		112,
		110,
		-1,
		84,
		95,
		88,
		107,
		114,
		90,
		75,
		69,
		75,
		87,
		96,
		-1,
		-1,
		199,
		-1,
		173,
		-1,
		-1,
		-1,
		-1,
		136,
		130,
		101,
		94,
		98,
		-1,
		86,
		88,
		85,
		97,
		93,
		90,
		81,
		72,
		68,
		72,
		76,
		90,
		94,
		222,
		-1,
		164,
		-1,
		-1,
		-1,
		154,
		169,
		140,
		117,
		90,
		85,
		78,
		72,
		77,
		88,
		97,
		108,
		73,
		75,
		65,
		64,
		68,
		85,
		89,
		-1,
		-1,
		162,
		158,
		180,
		162,
		166,
		167,
		-1,
		-1,
		94,
		85,
		76,
		68,
		81,
		84,
		69,
		71,
		71,
		69,
		63,
		73,
		88,
		83,
		-1,
		-1,
		-1,
		174,
		-1,
		176,
		-1,
		-1,
		164,
		165,
		112,
		94,
		90,
		88,
		77,
		71,
		59,
		64,
		74,
		68,
		65,
		59,
		63,
		86,
		75,
		114,
		-1,
		-1,
		242,
		-1,
		-1,
		-1,
		153,
		145,
		140,
		146,
		148,
		139,
		127,
		124,
		-1,
		94,
		100,
		65,
		72,
		55,
		62,
		67,
		64,
		53,
		60,
		76,
		75,
		70,
		106,
		97,
		103,
		-1,
		-1,
		235,
		224,
		213,
		219,
		-1,
		146,
		142,
		132,
		122,
		125,
		-1,
		-1,
		119,
		116,
		96,
		65,
		63,
		56,
		51,
		61,
		37,
		49,
		53,
		57,
		63,
		68,
		73,
		79,
		94,
		109,
		-1,
		189,
		226,
		219,
		187,
		195,
		226,
		-1,
		136,
		128,
		139,
		114,
		116,
		-1,
		-1,
		92,
		83,
		84,
		72,
		69,
		75,
		74,
		57,
		63,
		64,
		56,
		55,
		73,
		77,
		86,
		93,
		83,
		96,
		100,
		-1,
		182,
		202,
		181,
		184,
		208,
		222,
		-1,
		133,
		-1,
		-1,
		105,
		117,
		101,
		91,
		88,
		131,
		86,
		81,
		62,
		60,
		55,
		46,
		71,
		64,
		64,
		67,
		82,
		87,
		79,
		93,
		93,
		94,
		-1,
		171,
		182,
		175,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		-1,
		95,
		-1,
		128,
		-1,
		111,
		115,
		94,
		97,
		76,
		63,
		49,
		57,
		63,
		62,
		68,
		68,
		69,
		78,
		89,
		101,
		100,
		101,
		196,
		152,
		155,
		166,
		177,
		192,
		196,
		-1,
		145,
		184,
		101,
		-1,
		85,
		-1,
		-1,
		-1,
		125,
		107,
		99,
		96,
		75,
		75,
		41,
		45,
		58,
		65,
		75,
		86,
		78,
		82,
		95,
		106,
		109,
		192,
		183,
		196,
		141,
		141,
		162,
		171,
		192,
		156,
		151,
		178,
		108,
		97,
		92,
		79,
		-1,
		-1,
		109,
		117,
		-1,
		-1,
		82,
		49,
		37,
		47,
		51,
		65,
		77,
		90,
		78,
		83,
		77,
		109,
		-1,
		185,
		184,
		173,
		170,
		146,
		137,
		132,
		159,
		-1,
		-1,
		154,
		179,
		164,
		141,
		139,
		164,
		-1,
		68,
		-1,
		-1,
		89,
		-1,
		-1,
		74,
		54,
		43,
		34,
		39,
		59,
		70,
		92,
		74,
		91,
		82,
		92,
		96,
		169,
		166,
		154,
		152,
		175,
		140,
		128,
		-1,
		136,
		139,
		145,
		152,
		142,
		153,
		-1,
		-1,
		84,
		64,
		-1,
		-1,
		72,
		70,
		59,
		-1,
		49,
		31,
		36,
		66,
		68,
		70,
		77,
		71,
		78,
		86,
		97,
		89,
		178,
		192,
		181,
		177,
		176,
		184,
		133,
		126,
		133,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		89,
		-1,
		74,
		70,
		-1,
		-1,
		67,
		60,
		48,
		36,
		26,
		36,
		53,
		53,
		56,
		61,
		69,
		80,
		76,
		80,
		83,
		-1,
		212,
		-1,
		164,
		125,
		131,
		146,
		154,
		-1,
		-1,
		-1,
		91,
		77,
		70,
		58,
		56,
		-1,
		101,
		85,
		66,
		-1,
		36,
		49,
		89,
		57,
		62,
		57,
		72,
		83,
		74,
		82,
		76,
		79,
		-1,
		-1,
		124,
		107,
		-1,
		-1,
		81,
		83,
		-1,
		82,
		71,
		56,
		48,
		-1,
		-1,
		73,
		69,
		-1,
		-1,
		23,
		61,
		60,
		68,
		63,
		68,
		80,
		76,
		72,
		82,
		73,
		-1,
		-1,
		102,
		94,
		88,
		-1,
		66,
		-1,
		84,
		-1,
		51,
		57,
		45,
		-1,
		-1,
		-1,
		54,
		17,
		33,
		56,
		82,
		80,
		71,
		64,
		71,
		74,
		67,
		73,
		-1,
		-1,
		-1,
		84,
		58,
		91,
		82,
		65,
		45,
		37,
		56,
		-1,
		35,
		-1,
		10,
		13,
		38,
		77,
		79,
		65,
		61,
		74,
		68,
		65,
		63,
		90,
		-1,
		60,
		93,
		57,
		51,
		27,
		31,
		47,
		-1,
		32,
		14,
		-1,
		42,
		32,
		80,
		55,
		64,
		57,
		51,
		52,
		60,
		-1,
		-1,
		-1,
		62,
		61,
		53,
		47,
		47,
		32,
		23,
		-1,
		35,
		17,
		5,
		22,
		22,
		13,
		21,
		70,
		66,
		69,
		67,
		45,
		-1,
		163,
		-1,
		-1,
		85,
		-1,
		-1,
		-1,
		56,
		51,
		24,
		12,
		18,
		14,
		0,
		6,
		17,
		25,
		23,
		20,
		32,
		28,
		48,
		44,
		76,
		-1,
		158,
		-1,
		92,
		-1,
		-1,
		74,
		54,
		46,
		35,
		24,
		22,
		13,
		4,
		26,
		51,
		35,
		33,
		38,
		43,
		-1,
		147,
		146,
		-1,
		93,
		85,
		71,
		-1,
		64,
		-1,
		70,
		31,
		-1,
		33,
		13,
		-1,
		44,
		40,
		-1,
		-1,
		134,
		109,
		-1,
		-1,
		-1,
		94,
		74,
		65,
		49,
		-1,
		24,
		24,
		-1,
		-1,
		-1,
		119,
		118,
		-1,
		87,
		90,
		-1,
		80,
		71,
		79,
		26,
		30,
		-1,
		-1,
		-1,
		128,
		109,
		103,
		102,
		100,
		95,
		92,
		78,
		62,
		40,
		29,
		50,
		-1,
		-1,
		-1,
		100,
		92,
		85,
		-1,
		-1,
		87,
		70,
		51,
		49,
		-1,
		-1,
		-1,
		122,
		103,
		-1,
		-1,
		77,
		-1,
		-1,
		83,
		48,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		111,
		-1,
		-1,
		-1,
		73,
		69,
		70,
		-1,
		-1,
		-1,
		-1,
		133,
		134,
		157,
		121,
		-1,
		-1,
		-1,
		65,
		59,
		-1,
		-1,
		136,
		134,
		-1,
		-1,
		-1,
		93,
		77,
		-1,
		63,
		-1,
		-1,
		-1,
		84,
		-1,
		-1,
		96,
		-1,
		-1,
		-1,
		98,
		-1,
		98,
		73,
		80,
		-1,
		-1,
		-1,
		-1,
		111,
		103,
		111,
		-1,
		83,
		85,
		-1,
		133,
		-1,
		-1,
		126,
		117,
		-1,
		-1,
		88,
		95,
		117,
		120,
		156,
		-1,
		107
	],
	[
		-1,
		232,
		221,
		232,
		240,
		213,
		220,
		-1,
		239,
		243,
		209,
		203,
		242,
		211,
		217,
		228,
		-1,
		-1,
		-1,
		232,
		231,
		199,
		197,
		206,
		211,
		218,
		-1,
		217,
		-1,
		253,
		232,
		243,
		248,
		192,
		189,
		209,
		228,
		210,
		202,
		268,
		222,
		193,
		187,
		205,
		195,
		204,
		196,
		-1,
		193,
		183,
		205,
		184,
		195,
		187,
		-1,
		-1,
		187,
		188,
		194,
		180,
		186,
		182,
		-1,
		192,
		176,
		-1,
		-1,
		177,
		178,
		162,
		165,
		173,
		171,
		184,
		176,
		171,
		-1,
		-1,
		168,
		164,
		171,
		158,
		154,
		171,
		184,
		166,
		180,
		179,
		-1,
		172,
		190,
		197,
		165,
		163,
		147,
		145,
		163,
		165,
		171,
		171,
		-1,
		181,
		182,
		177,
		185,
		187,
		163,
		150,
		150,
		160,
		153,
		172,
		160,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		181,
		164,
		181,
		173,
		163,
		178,
		171,
		153,
		150,
		148,
		145,
		161,
		159,
		169,
		-1,
		-1,
		274,
		243,
		272,
		230,
		211,
		-1,
		177,
		157,
		163,
		167,
		161,
		154,
		168,
		164,
		-1,
		139,
		138,
		166,
		152,
		163,
		234,
		-1,
		-1,
		232,
		224,
		207,
		210,
		187,
		183,
		172,
		171,
		163,
		149,
		145,
		151,
		154,
		154,
		160,
		133,
		143,
		147,
		145,
		170,
		-1,
		-1,
		205,
		-1,
		-1,
		231,
		214,
		-1,
		197,
		204,
		193,
		199,
		185,
		206,
		182,
		173,
		165,
		159,
		147,
		149,
		146,
		159,
		147,
		130,
		155,
		159,
		140,
		161,
		156,
		-1,
		204,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		209,
		190,
		193,
		199,
		223,
		222,
		-1,
		194,
		182,
		183,
		168,
		165,
		152,
		140,
		153,
		138,
		145,
		144,
		134,
		132,
		162,
		137,
		159,
		156,
		175,
		180,
		174,
		183,
		-1,
		239,
		235,
		231,
		238,
		187,
		-1,
		-1,
		227,
		-1,
		230,
		231,
		206,
		179,
		182,
		169,
		160,
		147,
		136,
		147,
		136,
		133,
		141,
		126,
		141,
		132,
		131,
		149,
		159,
		167,
		171,
		177,
		-1,
		289,
		-1,
		231,
		215,
		217,
		189,
		210,
		-1,
		247,
		231,
		223,
		208,
		208,
		-1,
		178,
		175,
		165,
		143,
		128,
		145,
		137,
		135,
		139,
		121,
		135,
		126,
		144,
		151,
		149,
		153,
		173,
		185,
		249,
		239,
		-1,
		221,
		226,
		185,
		193,
		212,
		250,
		214,
		-1,
		209,
		-1,
		180,
		193,
		-1,
		149,
		145,
		127,
		128,
		123,
		138,
		132,
		117,
		114,
		132,
		135,
		142,
		146,
		162,
		-1,
		-1,
		234,
		238,
		227,
		178,
		197,
		221,
		258,
		207,
		196,
		195,
		-1,
		186,
		163,
		160,
		148,
		135,
		120,
		121,
		129,
		142,
		121,
		116,
		113,
		133,
		159,
		137,
		149,
		-1,
		-1,
		-1,
		259,
		-1,
		-1,
		204,
		175,
		199,
		241,
		225,
		218,
		206,
		171,
		171,
		165,
		-1,
		159,
		138,
		129,
		118,
		116,
		129,
		126,
		131,
		111,
		109,
		128,
		140,
		131,
		148,
		-1,
		-1,
		-1,
		234,
		223,
		224,
		170,
		193,
		230,
		204,
		190,
		195,
		170,
		163,
		157,
		172,
		155,
		136,
		125,
		117,
		106,
		122,
		130,
		125,
		107,
		116,
		122,
		146,
		136,
		142,
		-1,
		-1,
		241,
		231,
		215,
		217,
		214,
		184,
		191,
		223,
		195,
		208,
		-1,
		162,
		-1,
		151,
		146,
		130,
		125,
		122,
		119,
		113,
		122,
		124,
		114,
		109,
		116,
		151,
		151,
		126,
		146,
		149,
		-1,
		-1,
		-1,
		234,
		229,
		204,
		181,
		165,
		201,
		-1,
		178,
		179,
		-1,
		156,
		150,
		147,
		132,
		128,
		123,
		127,
		120,
		127,
		120,
		118,
		119,
		101,
		133,
		-1,
		134,
		128,
		136,
		126,
		114,
		-1,
		-1,
		-1,
		227,
		206,
		199,
		219,
		160,
		212,
		-1,
		-1,
		163,
		156,
		-1,
		143,
		125,
		132,
		130,
		124,
		128,
		125,
		114,
		127,
		120,
		106,
		108,
		121,
		125,
		129,
		116,
		112,
		109,
		123,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		180,
		-1,
		172,
		164,
		154,
		148,
		142,
		138,
		136,
		152,
		136,
		139,
		137,
		128,
		136,
		109,
		102,
		109,
		98,
		116,
		124,
		116,
		110,
		109,
		119,
		-1,
		247,
		233,
		204,
		-1,
		-1,
		193,
		-1,
		157,
		171,
		187,
		-1,
		180,
		159,
		174,
		152,
		148,
		144,
		159,
		160,
		137,
		137,
		135,
		126,
		114,
		103,
		106,
		98,
		120,
		120,
		104,
		105,
		109,
		-1,
		253,
		240,
		198,
		194,
		183,
		203,
		154,
		142,
		174,
		-1,
		-1,
		216,
		-1,
		150,
		167,
		158,
		156,
		149,
		131,
		138,
		146,
		123,
		118,
		108,
		97,
		97,
		92,
		114,
		100,
		98,
		107,
		123,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		169,
		156,
		150,
		-1,
		191,
		-1,
		194,
		184,
		168,
		153,
		186,
		-1,
		130,
		126,
		133,
		-1,
		143,
		-1,
		116,
		113,
		104,
		89,
		86,
		97,
		95,
		106,
		102,
		-1,
		203,
		188,
		181,
		171,
		185,
		156,
		-1,
		211,
		-1,
		-1,
		181,
		175,
		175,
		159,
		160,
		146,
		126,
		118,
		133,
		132,
		119,
		118,
		102,
		95,
		92,
		85,
		98,
		108,
		113,
		100,
		-1,
		-1,
		-1,
		208,
		194,
		198,
		158,
		177,
		-1,
		-1,
		243,
		198,
		184,
		-1,
		155,
		146,
		134,
		124,
		114,
		119,
		120,
		110,
		108,
		100,
		102,
		96,
		87,
		86,
		102,
		94,
		116,
		-1,
		-1,
		191,
		196,
		184,
		170,
		189,
		-1,
		-1,
		-1,
		190,
		206,
		174,
		153,
		135,
		-1,
		-1,
		118,
		111,
		105,
		108,
		96,
		116,
		111,
		95,
		80,
		95,
		99,
		107,
		98,
		-1,
		194,
		181,
		-1,
		-1,
		192,
		186,
		-1,
		-1,
		-1,
		-1,
		186,
		131,
		120,
		115,
		119,
		117,
		-1,
		91,
		102,
		95,
		114,
		121,
		97,
		82,
		76,
		82,
		94,
		103,
		-1,
		-1,
		206,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		143,
		137,
		108,
		101,
		105,
		-1,
		93,
		95,
		92,
		104,
		100,
		97,
		88,
		79,
		75,
		79,
		83,
		97,
		101,
		229,
		-1,
		171,
		-1,
		-1,
		-1,
		161,
		176,
		147,
		124,
		97,
		92,
		85,
		79,
		84,
		95,
		104,
		115,
		80,
		82,
		72,
		71,
		75,
		92,
		96,
		-1,
		-1,
		169,
		165,
		187,
		169,
		173,
		174,
		-1,
		-1,
		101,
		92,
		83,
		75,
		88,
		91,
		76,
		78,
		78,
		76,
		70,
		80,
		95,
		90,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		171,
		172,
		119,
		101,
		97,
		95,
		84,
		78,
		66,
		71,
		81,
		75,
		72,
		66,
		70,
		93,
		82,
		121,
		-1,
		-1,
		246,
		-1,
		-1,
		-1,
		160,
		152,
		147,
		153,
		155,
		146,
		134,
		131,
		-1,
		101,
		107,
		72,
		79,
		62,
		69,
		74,
		71,
		60,
		67,
		83,
		82,
		77,
		113,
		104,
		110,
		-1,
		-1,
		239,
		228,
		217,
		223,
		-1,
		153,
		149,
		139,
		129,
		132,
		-1,
		-1,
		126,
		123,
		103,
		72,
		70,
		63,
		58,
		68,
		44,
		56,
		60,
		64,
		70,
		75,
		80,
		86,
		101,
		116,
		-1,
		193,
		230,
		223,
		191,
		199,
		230,
		-1,
		143,
		135,
		146,
		121,
		123,
		-1,
		-1,
		99,
		90,
		91,
		79,
		76,
		82,
		81,
		64,
		70,
		71,
		63,
		62,
		80,
		84,
		93,
		100,
		90,
		103,
		107,
		-1,
		186,
		206,
		185,
		188,
		212,
		226,
		-1,
		140,
		-1,
		-1,
		109,
		124,
		108,
		98,
		95,
		138,
		93,
		88,
		69,
		67,
		62,
		53,
		78,
		71,
		71,
		74,
		89,
		94,
		86,
		100,
		100,
		101,
		-1,
		175,
		186,
		179,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		-1,
		99,
		-1,
		135,
		-1,
		118,
		122,
		101,
		104,
		83,
		70,
		56,
		64,
		70,
		69,
		75,
		75,
		76,
		85,
		96,
		108,
		107,
		108,
		200,
		156,
		159,
		170,
		181,
		196,
		200,
		-1,
		152,
		191,
		105,
		-1,
		89,
		-1,
		-1,
		-1,
		132,
		114,
		106,
		103,
		82,
		82,
		48,
		52,
		65,
		72,
		82,
		93,
		85,
		89,
		102,
		113,
		116,
		196,
		187,
		200,
		145,
		145,
		166,
		175,
		196,
		160,
		157,
		185,
		112,
		101,
		96,
		83,
		-1,
		-1,
		116,
		124,
		-1,
		-1,
		89,
		56,
		44,
		54,
		58,
		72,
		84,
		97,
		85,
		90,
		84,
		116,
		-1,
		189,
		188,
		177,
		174,
		150,
		141,
		136,
		163,
		-1,
		-1,
		158,
		185,
		168,
		145,
		143,
		168,
		-1,
		72,
		-1,
		-1,
		96,
		-1,
		-1,
		81,
		61,
		50,
		41,
		46,
		66,
		77,
		99,
		81,
		98,
		89,
		99,
		103,
		173,
		170,
		158,
		156,
		179,
		144,
		132,
		-1,
		140,
		143,
		149,
		156,
		146,
		157,
		-1,
		-1,
		88,
		68,
		-1,
		-1,
		79,
		77,
		66,
		-1,
		56,
		38,
		43,
		73,
		75,
		77,
		84,
		78,
		85,
		93,
		104,
		96,
		182,
		196,
		185,
		181,
		180,
		188,
		137,
		130,
		137,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		-1,
		78,
		74,
		-1,
		-1,
		74,
		67,
		55,
		43,
		33,
		43,
		60,
		60,
		63,
		68,
		76,
		87,
		83,
		87,
		90,
		-1,
		216,
		-1,
		168,
		129,
		135,
		150,
		158,
		-1,
		-1,
		-1,
		95,
		81,
		74,
		62,
		60,
		-1,
		108,
		92,
		73,
		-1,
		43,
		56,
		96,
		64,
		69,
		64,
		79,
		90,
		81,
		89,
		83,
		86,
		-1,
		-1,
		128,
		111,
		-1,
		-1,
		85,
		87,
		-1,
		86,
		75,
		60,
		52,
		-1,
		-1,
		80,
		76,
		-1,
		-1,
		30,
		68,
		67,
		75,
		70,
		75,
		87,
		83,
		79,
		89,
		80,
		-1,
		-1,
		106,
		98,
		92,
		-1,
		70,
		-1,
		88,
		-1,
		55,
		61,
		49,
		-1,
		-1,
		-1,
		61,
		24,
		40,
		63,
		89,
		87,
		78,
		71,
		78,
		81,
		74,
		80,
		-1,
		-1,
		-1,
		88,
		62,
		95,
		86,
		69,
		49,
		41,
		60,
		-1,
		42,
		-1,
		17,
		20,
		45,
		84,
		86,
		72,
		68,
		81,
		75,
		72,
		70,
		94,
		-1,
		64,
		97,
		61,
		55,
		31,
		35,
		54,
		-1,
		39,
		21,
		-1,
		49,
		39,
		87,
		62,
		71,
		64,
		58,
		59,
		67,
		-1,
		-1,
		-1,
		66,
		65,
		57,
		51,
		51,
		36,
		27,
		-1,
		42,
		24,
		12,
		23,
		29,
		20,
		28,
		77,
		73,
		76,
		74,
		52,
		-1,
		167,
		-1,
		-1,
		89,
		-1,
		-1,
		-1,
		60,
		55,
		28,
		16,
		20,
		16,
		7,
		0,
		18,
		32,
		30,
		27,
		39,
		35,
		55,
		51,
		83,
		-1,
		162,
		-1,
		96,
		-1,
		-1,
		78,
		58,
		50,
		39,
		28,
		26,
		15,
		8,
		29,
		45,
		42,
		40,
		45,
		50,
		-1,
		151,
		150,
		-1,
		97,
		89,
		75,
		-1,
		68,
		-1,
		74,
		35,
		-1,
		37,
		15,
		-1,
		51,
		47,
		-1,
		-1,
		138,
		113,
		-1,
		-1,
		-1,
		98,
		78,
		69,
		53,
		-1,
		28,
		28,
		-1,
		-1,
		-1,
		123,
		122,
		-1,
		91,
		94,
		-1,
		84,
		75,
		83,
		30,
		34,
		-1,
		-1,
		-1,
		132,
		113,
		107,
		106,
		104,
		99,
		96,
		82,
		66,
		44,
		33,
		54,
		-1,
		-1,
		-1,
		104,
		96,
		89,
		-1,
		-1,
		91,
		74,
		55,
		53,
		-1,
		-1,
		-1,
		126,
		107,
		-1,
		-1,
		81,
		-1,
		-1,
		87,
		52,
		-1,
		-1,
		-1,
		-1,
		-1,
		143,
		115,
		-1,
		-1,
		-1,
		77,
		73,
		74,
		-1,
		-1,
		-1,
		-1,
		137,
		138,
		161,
		125,
		-1,
		-1,
		-1,
		69,
		63,
		-1,
		-1,
		140,
		138,
		-1,
		-1,
		-1,
		97,
		81,
		-1,
		67,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		100,
		-1,
		-1,
		-1,
		102,
		-1,
		102,
		77,
		84,
		-1,
		-1,
		-1,
		-1,
		115,
		107,
		115,
		-1,
		87,
		89,
		-1,
		137,
		-1,
		-1,
		130,
		121,
		-1,
		-1,
		92,
		99,
		121,
		124,
		160,
		-1,
		111
	],
	[
		-1,
		233,
		222,
		233,
		241,
		214,
		221,
		-1,
		240,
		244,
		210,
		204,
		243,
		212,
		218,
		229,
		-1,
		-1,
		-1,
		233,
		232,
		200,
		198,
		207,
		212,
		219,
		-1,
		218,
		-1,
		254,
		233,
		244,
		249,
		193,
		190,
		210,
		229,
		211,
		203,
		269,
		223,
		194,
		188,
		206,
		196,
		205,
		197,
		-1,
		194,
		184,
		206,
		185,
		196,
		188,
		-1,
		-1,
		188,
		189,
		195,
		181,
		187,
		183,
		-1,
		193,
		177,
		-1,
		-1,
		178,
		179,
		163,
		166,
		174,
		172,
		185,
		177,
		172,
		-1,
		-1,
		169,
		165,
		172,
		159,
		155,
		172,
		185,
		167,
		181,
		180,
		-1,
		173,
		191,
		198,
		166,
		164,
		148,
		146,
		164,
		166,
		172,
		172,
		-1,
		182,
		183,
		178,
		186,
		188,
		164,
		151,
		151,
		161,
		154,
		173,
		161,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		182,
		165,
		182,
		174,
		164,
		179,
		172,
		154,
		151,
		149,
		146,
		162,
		160,
		170,
		-1,
		-1,
		275,
		244,
		273,
		231,
		212,
		-1,
		178,
		158,
		164,
		168,
		162,
		155,
		169,
		165,
		-1,
		140,
		139,
		167,
		153,
		164,
		235,
		-1,
		-1,
		233,
		225,
		208,
		211,
		188,
		184,
		173,
		172,
		164,
		150,
		146,
		152,
		155,
		155,
		161,
		134,
		144,
		148,
		146,
		171,
		-1,
		-1,
		206,
		-1,
		-1,
		232,
		215,
		-1,
		198,
		205,
		194,
		200,
		186,
		207,
		183,
		174,
		166,
		160,
		148,
		150,
		147,
		160,
		148,
		131,
		156,
		160,
		141,
		162,
		157,
		-1,
		205,
		189,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		191,
		194,
		200,
		224,
		223,
		-1,
		195,
		183,
		184,
		169,
		166,
		153,
		141,
		154,
		139,
		146,
		145,
		135,
		133,
		163,
		138,
		160,
		157,
		176,
		181,
		175,
		184,
		-1,
		240,
		236,
		232,
		239,
		188,
		-1,
		-1,
		228,
		-1,
		231,
		232,
		207,
		180,
		183,
		170,
		161,
		148,
		137,
		148,
		137,
		134,
		142,
		127,
		142,
		133,
		132,
		150,
		160,
		168,
		172,
		178,
		-1,
		290,
		-1,
		232,
		216,
		218,
		190,
		211,
		-1,
		248,
		232,
		224,
		209,
		209,
		-1,
		179,
		176,
		166,
		144,
		129,
		146,
		138,
		136,
		140,
		122,
		136,
		127,
		145,
		152,
		150,
		154,
		174,
		186,
		250,
		240,
		-1,
		222,
		227,
		186,
		194,
		213,
		251,
		215,
		-1,
		210,
		-1,
		181,
		194,
		-1,
		150,
		146,
		128,
		129,
		124,
		139,
		133,
		118,
		115,
		133,
		136,
		143,
		147,
		163,
		-1,
		-1,
		235,
		239,
		228,
		179,
		198,
		222,
		259,
		208,
		197,
		196,
		-1,
		187,
		164,
		161,
		149,
		136,
		121,
		122,
		130,
		143,
		122,
		117,
		114,
		134,
		160,
		138,
		150,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		205,
		176,
		200,
		242,
		226,
		219,
		207,
		172,
		172,
		166,
		-1,
		160,
		139,
		130,
		119,
		117,
		130,
		127,
		132,
		112,
		110,
		129,
		141,
		132,
		149,
		-1,
		-1,
		-1,
		235,
		224,
		225,
		171,
		194,
		231,
		205,
		191,
		196,
		171,
		164,
		158,
		173,
		156,
		137,
		126,
		118,
		107,
		123,
		131,
		126,
		108,
		117,
		123,
		147,
		137,
		143,
		-1,
		-1,
		242,
		232,
		216,
		218,
		215,
		185,
		192,
		224,
		196,
		209,
		-1,
		163,
		-1,
		152,
		147,
		131,
		126,
		123,
		120,
		114,
		123,
		125,
		115,
		110,
		117,
		152,
		152,
		127,
		147,
		150,
		-1,
		-1,
		-1,
		235,
		230,
		205,
		182,
		166,
		202,
		-1,
		179,
		180,
		-1,
		157,
		151,
		148,
		133,
		129,
		124,
		128,
		121,
		128,
		121,
		119,
		120,
		102,
		134,
		-1,
		135,
		129,
		137,
		127,
		115,
		-1,
		-1,
		-1,
		228,
		207,
		200,
		220,
		161,
		213,
		-1,
		-1,
		164,
		157,
		-1,
		144,
		126,
		133,
		131,
		125,
		129,
		126,
		115,
		128,
		121,
		107,
		109,
		122,
		126,
		130,
		117,
		113,
		110,
		124,
		-1,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		181,
		-1,
		173,
		165,
		155,
		149,
		143,
		139,
		137,
		153,
		137,
		140,
		138,
		129,
		137,
		110,
		103,
		110,
		99,
		117,
		125,
		117,
		111,
		110,
		120,
		-1,
		248,
		234,
		205,
		-1,
		-1,
		194,
		-1,
		158,
		172,
		188,
		-1,
		181,
		160,
		175,
		153,
		149,
		145,
		160,
		161,
		138,
		138,
		136,
		127,
		115,
		104,
		107,
		99,
		121,
		121,
		105,
		106,
		110,
		-1,
		254,
		241,
		199,
		195,
		184,
		204,
		155,
		143,
		175,
		-1,
		-1,
		217,
		-1,
		151,
		168,
		159,
		157,
		150,
		132,
		139,
		147,
		124,
		119,
		109,
		98,
		98,
		93,
		115,
		101,
		99,
		108,
		124,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		170,
		157,
		151,
		-1,
		192,
		-1,
		195,
		185,
		169,
		154,
		187,
		-1,
		131,
		127,
		134,
		-1,
		144,
		-1,
		117,
		114,
		105,
		90,
		87,
		98,
		96,
		107,
		103,
		-1,
		204,
		189,
		182,
		172,
		186,
		157,
		-1,
		212,
		-1,
		-1,
		182,
		176,
		176,
		160,
		161,
		147,
		127,
		119,
		134,
		133,
		120,
		119,
		103,
		96,
		93,
		86,
		99,
		109,
		114,
		101,
		-1,
		-1,
		-1,
		209,
		195,
		199,
		159,
		178,
		-1,
		-1,
		244,
		199,
		185,
		-1,
		156,
		147,
		135,
		125,
		115,
		120,
		121,
		111,
		109,
		101,
		103,
		97,
		88,
		87,
		103,
		95,
		117,
		-1,
		-1,
		192,
		197,
		185,
		171,
		190,
		-1,
		-1,
		-1,
		191,
		207,
		175,
		154,
		136,
		-1,
		-1,
		119,
		112,
		106,
		109,
		97,
		117,
		112,
		96,
		81,
		96,
		100,
		108,
		99,
		-1,
		195,
		182,
		-1,
		-1,
		193,
		187,
		-1,
		-1,
		-1,
		-1,
		187,
		132,
		121,
		116,
		120,
		118,
		-1,
		92,
		103,
		96,
		115,
		122,
		98,
		83,
		77,
		83,
		95,
		104,
		-1,
		-1,
		207,
		-1,
		181,
		-1,
		-1,
		-1,
		-1,
		144,
		138,
		109,
		102,
		106,
		-1,
		94,
		96,
		93,
		105,
		101,
		98,
		89,
		80,
		76,
		80,
		84,
		98,
		102,
		230,
		-1,
		172,
		-1,
		-1,
		-1,
		162,
		177,
		148,
		125,
		98,
		93,
		86,
		80,
		85,
		96,
		105,
		116,
		81,
		83,
		73,
		72,
		76,
		93,
		97,
		-1,
		-1,
		170,
		166,
		188,
		170,
		174,
		175,
		-1,
		-1,
		102,
		93,
		84,
		76,
		89,
		92,
		77,
		79,
		79,
		77,
		71,
		81,
		96,
		91,
		-1,
		-1,
		-1,
		182,
		-1,
		184,
		-1,
		-1,
		172,
		173,
		120,
		102,
		98,
		96,
		85,
		79,
		67,
		72,
		82,
		76,
		73,
		67,
		71,
		94,
		83,
		122,
		-1,
		-1,
		254,
		-1,
		-1,
		-1,
		161,
		153,
		148,
		154,
		156,
		147,
		135,
		132,
		-1,
		102,
		108,
		73,
		80,
		63,
		70,
		75,
		72,
		61,
		68,
		84,
		83,
		78,
		114,
		105,
		111,
		-1,
		-1,
		247,
		236,
		225,
		231,
		-1,
		154,
		150,
		140,
		130,
		133,
		-1,
		-1,
		127,
		124,
		104,
		73,
		71,
		64,
		59,
		69,
		45,
		57,
		61,
		65,
		71,
		76,
		81,
		87,
		102,
		117,
		-1,
		201,
		238,
		231,
		199,
		207,
		238,
		-1,
		144,
		136,
		147,
		122,
		124,
		-1,
		-1,
		100,
		91,
		92,
		80,
		77,
		83,
		82,
		65,
		71,
		72,
		64,
		63,
		81,
		85,
		94,
		101,
		91,
		104,
		108,
		-1,
		194,
		214,
		193,
		196,
		220,
		234,
		-1,
		141,
		-1,
		-1,
		122,
		125,
		109,
		99,
		96,
		139,
		94,
		89,
		70,
		68,
		63,
		54,
		79,
		72,
		72,
		75,
		90,
		95,
		87,
		101,
		101,
		102,
		-1,
		183,
		194,
		187,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		-1,
		112,
		-1,
		136,
		-1,
		119,
		123,
		102,
		105,
		84,
		71,
		57,
		65,
		71,
		70,
		76,
		76,
		77,
		86,
		97,
		109,
		108,
		109,
		208,
		164,
		167,
		178,
		189,
		204,
		208,
		-1,
		153,
		192,
		118,
		-1,
		102,
		-1,
		-1,
		-1,
		133,
		115,
		107,
		104,
		83,
		83,
		49,
		53,
		66,
		73,
		83,
		94,
		86,
		90,
		103,
		114,
		117,
		204,
		195,
		208,
		153,
		153,
		174,
		183,
		204,
		168,
		159,
		186,
		125,
		114,
		109,
		96,
		-1,
		-1,
		117,
		125,
		-1,
		-1,
		90,
		57,
		45,
		55,
		59,
		73,
		85,
		98,
		86,
		91,
		85,
		115,
		-1,
		197,
		196,
		185,
		182,
		158,
		149,
		144,
		171,
		-1,
		-1,
		166,
		187,
		177,
		158,
		156,
		181,
		-1,
		85,
		-1,
		-1,
		97,
		-1,
		-1,
		82,
		62,
		51,
		42,
		47,
		67,
		78,
		100,
		82,
		99,
		90,
		100,
		100,
		181,
		178,
		166,
		164,
		187,
		152,
		140,
		-1,
		153,
		151,
		157,
		164,
		159,
		170,
		-1,
		-1,
		101,
		81,
		-1,
		-1,
		80,
		78,
		67,
		-1,
		57,
		39,
		44,
		74,
		76,
		78,
		85,
		79,
		86,
		90,
		101,
		93,
		190,
		204,
		193,
		189,
		188,
		196,
		145,
		138,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		-1,
		91,
		87,
		-1,
		-1,
		75,
		68,
		56,
		44,
		34,
		44,
		61,
		61,
		64,
		69,
		77,
		88,
		80,
		84,
		87,
		-1,
		224,
		-1,
		176,
		142,
		148,
		163,
		171,
		-1,
		-1,
		-1,
		108,
		94,
		87,
		75,
		73,
		-1,
		109,
		93,
		74,
		-1,
		44,
		57,
		97,
		65,
		70,
		65,
		76,
		87,
		78,
		86,
		80,
		83,
		-1,
		-1,
		141,
		124,
		-1,
		-1,
		98,
		100,
		-1,
		99,
		88,
		73,
		65,
		-1,
		-1,
		81,
		77,
		-1,
		-1,
		31,
		56,
		68,
		76,
		71,
		72,
		84,
		80,
		76,
		86,
		77,
		-1,
		-1,
		119,
		111,
		105,
		-1,
		83,
		-1,
		101,
		-1,
		68,
		74,
		62,
		-1,
		-1,
		-1,
		62,
		25,
		41,
		51,
		86,
		84,
		75,
		68,
		75,
		78,
		71,
		77,
		-1,
		-1,
		-1,
		101,
		75,
		108,
		99,
		82,
		62,
		54,
		73,
		-1,
		36,
		-1,
		18,
		21,
		33,
		83,
		83,
		69,
		65,
		78,
		72,
		69,
		67,
		107,
		-1,
		77,
		110,
		74,
		68,
		44,
		48,
		64,
		-1,
		33,
		16,
		-1,
		37,
		27,
		84,
		59,
		68,
		61,
		55,
		56,
		64,
		-1,
		-1,
		-1,
		79,
		78,
		70,
		64,
		64,
		49,
		40,
		-1,
		52,
		34,
		13,
		5,
		12,
		17,
		25,
		74,
		70,
		73,
		71,
		49,
		-1,
		180,
		-1,
		-1,
		102,
		-1,
		-1,
		-1,
		73,
		68,
		41,
		29,
		35,
		31,
		17,
		15,
		0,
		23,
		27,
		24,
		36,
		32,
		52,
		48,
		80,
		-1,
		175,
		-1,
		109,
		-1,
		-1,
		91,
		71,
		63,
		52,
		41,
		39,
		30,
		21,
		43,
		38,
		39,
		37,
		42,
		47,
		-1,
		164,
		163,
		-1,
		110,
		102,
		88,
		-1,
		81,
		-1,
		87,
		48,
		-1,
		50,
		30,
		-1,
		48,
		44,
		-1,
		-1,
		151,
		126,
		-1,
		-1,
		-1,
		111,
		91,
		82,
		66,
		-1,
		41,
		41,
		-1,
		-1,
		-1,
		136,
		135,
		-1,
		104,
		107,
		-1,
		97,
		88,
		96,
		43,
		47,
		-1,
		-1,
		-1,
		145,
		126,
		120,
		119,
		117,
		112,
		109,
		95,
		79,
		57,
		46,
		67,
		-1,
		-1,
		-1,
		117,
		109,
		102,
		-1,
		-1,
		104,
		87,
		68,
		66,
		-1,
		-1,
		-1,
		139,
		120,
		-1,
		-1,
		94,
		-1,
		-1,
		100,
		65,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		128,
		-1,
		-1,
		-1,
		90,
		86,
		87,
		-1,
		-1,
		-1,
		-1,
		150,
		151,
		174,
		138,
		-1,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		153,
		151,
		-1,
		-1,
		-1,
		110,
		94,
		-1,
		80,
		-1,
		-1,
		-1,
		101,
		-1,
		-1,
		113,
		-1,
		-1,
		-1,
		115,
		-1,
		115,
		90,
		97,
		-1,
		-1,
		-1,
		-1,
		128,
		120,
		128,
		-1,
		100,
		102,
		-1,
		150,
		-1,
		-1,
		143,
		134,
		-1,
		-1,
		105,
		112,
		134,
		137,
		173,
		-1,
		124
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		159,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		147,
		153,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		127,
		123,
		120,
		134,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		120,
		130,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		148,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		120,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		142,
		149,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		118,
		134,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		141,
		137,
		144,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		113,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		171,
		157,
		137,
		129,
		144,
		143,
		130,
		129,
		113,
		106,
		103,
		96,
		109,
		119,
		124,
		111,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		166,
		157,
		145,
		135,
		125,
		130,
		131,
		121,
		119,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		127,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		185,
		164,
		146,
		-1,
		-1,
		129,
		122,
		116,
		119,
		107,
		127,
		122,
		106,
		91,
		106,
		110,
		118,
		109,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		197,
		142,
		131,
		126,
		130,
		128,
		-1,
		102,
		113,
		106,
		125,
		132,
		108,
		93,
		87,
		93,
		105,
		114,
		-1,
		-1,
		217,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		154,
		148,
		119,
		112,
		116,
		-1,
		104,
		106,
		103,
		115,
		111,
		108,
		99,
		90,
		86,
		90,
		94,
		108,
		112,
		240,
		-1,
		182,
		-1,
		-1,
		-1,
		172,
		187,
		158,
		135,
		108,
		103,
		96,
		90,
		95,
		106,
		115,
		126,
		91,
		93,
		83,
		82,
		86,
		103,
		107,
		-1,
		-1,
		180,
		176,
		198,
		180,
		184,
		185,
		-1,
		-1,
		112,
		103,
		94,
		86,
		99,
		102,
		87,
		89,
		89,
		87,
		81,
		91,
		106,
		101,
		-1,
		-1,
		-1,
		192,
		-1,
		194,
		-1,
		-1,
		182,
		183,
		130,
		112,
		108,
		106,
		95,
		89,
		77,
		82,
		92,
		86,
		83,
		77,
		81,
		104,
		93,
		132,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		145,
		142,
		-1,
		112,
		118,
		83,
		90,
		73,
		80,
		85,
		82,
		71,
		78,
		94,
		93,
		88,
		124,
		115,
		121,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		137,
		134,
		114,
		83,
		81,
		74,
		69,
		79,
		55,
		67,
		71,
		75,
		81,
		86,
		91,
		97,
		112,
		127,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		110,
		101,
		102,
		90,
		87,
		93,
		92,
		75,
		81,
		82,
		74,
		73,
		91,
		95,
		104,
		111,
		101,
		114,
		118,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		151,
		-1,
		-1,
		132,
		135,
		119,
		109,
		106,
		149,
		104,
		99,
		80,
		78,
		73,
		64,
		89,
		82,
		82,
		85,
		100,
		105,
		97,
		111,
		111,
		108,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		122,
		-1,
		146,
		-1,
		129,
		133,
		112,
		115,
		94,
		81,
		67,
		75,
		81,
		80,
		86,
		86,
		87,
		96,
		107,
		112,
		118,
		119,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		163,
		202,
		128,
		-1,
		112,
		-1,
		-1,
		-1,
		143,
		125,
		117,
		114,
		93,
		93,
		59,
		63,
		76,
		83,
		93,
		104,
		96,
		95,
		106,
		117,
		116,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		169,
		196,
		135,
		124,
		119,
		106,
		-1,
		-1,
		127,
		135,
		-1,
		-1,
		100,
		67,
		55,
		65,
		69,
		83,
		95,
		108,
		88,
		94,
		88,
		112,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		197,
		187,
		168,
		166,
		191,
		-1,
		95,
		-1,
		-1,
		107,
		-1,
		-1,
		92,
		72,
		61,
		52,
		57,
		77,
		88,
		110,
		84,
		100,
		93,
		100,
		97,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		169,
		180,
		-1,
		-1,
		111,
		91,
		-1,
		-1,
		90,
		88,
		77,
		-1,
		67,
		49,
		54,
		84,
		86,
		88,
		87,
		81,
		88,
		87,
		98,
		90,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		101,
		97,
		-1,
		-1,
		85,
		78,
		66,
		54,
		44,
		54,
		71,
		71,
		74,
		79,
		79,
		90,
		77,
		81,
		84,
		-1,
		234,
		-1,
		186,
		152,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		118,
		104,
		97,
		85,
		83,
		-1,
		119,
		103,
		84,
		-1,
		54,
		67,
		97,
		68,
		80,
		75,
		73,
		84,
		75,
		83,
		77,
		80,
		-1,
		-1,
		151,
		134,
		-1,
		-1,
		108,
		110,
		-1,
		109,
		98,
		83,
		75,
		-1,
		-1,
		91,
		87,
		-1,
		-1,
		41,
		48,
		66,
		86,
		81,
		69,
		81,
		77,
		73,
		83,
		74,
		-1,
		-1,
		129,
		121,
		115,
		-1,
		93,
		-1,
		111,
		-1,
		78,
		84,
		72,
		-1,
		-1,
		-1,
		72,
		35,
		51,
		43,
		83,
		81,
		72,
		65,
		72,
		75,
		68,
		74,
		-1,
		-1,
		-1,
		111,
		85,
		118,
		109,
		92,
		72,
		64,
		83,
		-1,
		53,
		-1,
		28,
		31,
		25,
		75,
		80,
		66,
		62,
		75,
		69,
		66,
		64,
		117,
		-1,
		87,
		120,
		84,
		78,
		54,
		58,
		74,
		-1,
		50,
		32,
		-1,
		36,
		19,
		81,
		56,
		65,
		58,
		52,
		53,
		61,
		-1,
		-1,
		-1,
		89,
		88,
		80,
		74,
		74,
		59,
		50,
		-1,
		62,
		44,
		23,
		30,
		17,
		14,
		15,
		71,
		67,
		70,
		68,
		46,
		-1,
		190,
		-1,
		-1,
		112,
		-1,
		-1,
		-1,
		83,
		78,
		51,
		39,
		45,
		41,
		27,
		32,
		25,
		0,
		12,
		16,
		32,
		29,
		49,
		45,
		77,
		-1,
		185,
		-1,
		119,
		-1,
		-1,
		101,
		81,
		73,
		62,
		51,
		49,
		40,
		31,
		53,
		39,
		36,
		34,
		39,
		44,
		-1,
		174,
		173,
		-1,
		120,
		112,
		98,
		-1,
		91,
		-1,
		97,
		58,
		-1,
		60,
		40,
		-1,
		45,
		41,
		-1,
		-1,
		161,
		136,
		-1,
		-1,
		-1,
		121,
		101,
		92,
		76,
		-1,
		51,
		51,
		-1,
		-1,
		-1,
		146,
		145,
		-1,
		114,
		117,
		-1,
		107,
		98,
		106,
		53,
		57,
		-1,
		-1,
		-1,
		155,
		136,
		130,
		129,
		127,
		122,
		119,
		105,
		89,
		67,
		56,
		77,
		-1,
		-1,
		-1,
		127,
		119,
		112,
		-1,
		-1,
		114,
		97,
		78,
		76,
		-1,
		-1,
		-1,
		149,
		130,
		-1,
		-1,
		104,
		-1,
		-1,
		110,
		75,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		138,
		-1,
		-1,
		-1,
		100,
		96,
		97,
		-1,
		-1,
		-1,
		-1,
		160,
		161,
		184,
		148,
		-1,
		-1,
		-1,
		92,
		86,
		-1,
		-1,
		163,
		161,
		-1,
		-1,
		-1,
		120,
		104,
		-1,
		90,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		125,
		-1,
		125,
		100,
		107,
		-1,
		-1,
		-1,
		-1,
		138,
		130,
		138,
		-1,
		110,
		112,
		-1,
		160,
		-1,
		-1,
		153,
		144,
		-1,
		-1,
		115,
		122,
		144,
		147,
		183,
		-1,
		134
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		159,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		147,
		153,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		127,
		123,
		120,
		134,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		120,
		130,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		148,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		120,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		142,
		149,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		118,
		134,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		141,
		137,
		144,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		113,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		171,
		157,
		137,
		129,
		144,
		143,
		130,
		129,
		113,
		106,
		103,
		96,
		109,
		119,
		124,
		111,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		166,
		157,
		145,
		135,
		125,
		130,
		131,
		121,
		119,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		127,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		185,
		164,
		146,
		-1,
		-1,
		129,
		122,
		116,
		119,
		107,
		127,
		122,
		106,
		91,
		106,
		110,
		118,
		109,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		197,
		142,
		131,
		126,
		130,
		128,
		-1,
		102,
		113,
		106,
		125,
		132,
		108,
		93,
		87,
		93,
		105,
		114,
		-1,
		-1,
		217,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		154,
		148,
		119,
		112,
		116,
		-1,
		104,
		106,
		103,
		115,
		111,
		108,
		99,
		90,
		86,
		90,
		94,
		108,
		112,
		240,
		-1,
		182,
		-1,
		-1,
		-1,
		172,
		187,
		158,
		135,
		108,
		103,
		96,
		90,
		95,
		106,
		115,
		126,
		91,
		93,
		83,
		82,
		86,
		103,
		107,
		-1,
		-1,
		180,
		176,
		198,
		180,
		184,
		185,
		-1,
		-1,
		112,
		103,
		94,
		86,
		99,
		102,
		87,
		89,
		89,
		87,
		81,
		91,
		106,
		101,
		-1,
		-1,
		-1,
		192,
		-1,
		194,
		-1,
		-1,
		182,
		183,
		130,
		112,
		108,
		106,
		95,
		89,
		77,
		82,
		92,
		86,
		83,
		77,
		81,
		104,
		93,
		132,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		145,
		142,
		-1,
		112,
		118,
		83,
		90,
		73,
		80,
		85,
		82,
		71,
		78,
		94,
		93,
		88,
		124,
		115,
		121,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		137,
		134,
		114,
		83,
		81,
		74,
		69,
		79,
		55,
		67,
		71,
		75,
		81,
		86,
		91,
		97,
		112,
		127,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		110,
		101,
		102,
		90,
		87,
		93,
		92,
		75,
		81,
		82,
		74,
		73,
		91,
		95,
		104,
		111,
		101,
		114,
		118,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		151,
		-1,
		-1,
		132,
		135,
		119,
		109,
		106,
		149,
		104,
		99,
		80,
		78,
		73,
		64,
		89,
		82,
		82,
		85,
		99,
		104,
		96,
		111,
		107,
		100,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		122,
		-1,
		146,
		-1,
		129,
		133,
		112,
		115,
		94,
		81,
		67,
		75,
		81,
		80,
		86,
		86,
		86,
		88,
		100,
		104,
		114,
		116,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		163,
		202,
		128,
		-1,
		112,
		-1,
		-1,
		-1,
		143,
		125,
		117,
		114,
		93,
		93,
		59,
		63,
		76,
		83,
		93,
		103,
		88,
		87,
		98,
		109,
		108,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		169,
		196,
		135,
		124,
		119,
		106,
		-1,
		-1,
		127,
		135,
		-1,
		-1,
		100,
		67,
		55,
		65,
		69,
		83,
		95,
		100,
		80,
		86,
		80,
		104,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		197,
		187,
		168,
		166,
		191,
		-1,
		95,
		-1,
		-1,
		107,
		-1,
		-1,
		92,
		72,
		61,
		52,
		57,
		77,
		88,
		110,
		76,
		92,
		85,
		92,
		89,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		169,
		180,
		-1,
		-1,
		111,
		91,
		-1,
		-1,
		90,
		88,
		77,
		-1,
		67,
		49,
		54,
		84,
		86,
		85,
		79,
		73,
		80,
		79,
		90,
		82,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		101,
		97,
		-1,
		-1,
		85,
		78,
		66,
		54,
		44,
		54,
		71,
		71,
		74,
		76,
		71,
		82,
		69,
		73,
		76,
		-1,
		234,
		-1,
		186,
		152,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		118,
		104,
		97,
		85,
		83,
		-1,
		119,
		103,
		84,
		-1,
		54,
		67,
		92,
		63,
		77,
		75,
		65,
		76,
		67,
		75,
		69,
		72,
		-1,
		-1,
		151,
		134,
		-1,
		-1,
		108,
		110,
		-1,
		109,
		98,
		83,
		75,
		-1,
		-1,
		91,
		87,
		-1,
		-1,
		41,
		43,
		61,
		83,
		79,
		61,
		73,
		69,
		65,
		75,
		66,
		-1,
		-1,
		129,
		121,
		115,
		-1,
		93,
		-1,
		111,
		-1,
		78,
		84,
		72,
		-1,
		-1,
		-1,
		72,
		35,
		51,
		38,
		75,
		73,
		64,
		57,
		64,
		67,
		60,
		66,
		-1,
		-1,
		-1,
		111,
		85,
		118,
		109,
		92,
		72,
		64,
		83,
		-1,
		53,
		-1,
		28,
		31,
		20,
		70,
		72,
		58,
		54,
		67,
		61,
		58,
		56,
		117,
		-1,
		87,
		120,
		84,
		78,
		54,
		58,
		74,
		-1,
		50,
		32,
		-1,
		31,
		14,
		73,
		48,
		57,
		50,
		44,
		45,
		53,
		-1,
		-1,
		-1,
		89,
		88,
		80,
		74,
		74,
		59,
		50,
		-1,
		62,
		44,
		23,
		38,
		23,
		14,
		3,
		63,
		59,
		62,
		60,
		38,
		-1,
		190,
		-1,
		-1,
		112,
		-1,
		-1,
		-1,
		83,
		78,
		51,
		39,
		45,
		41,
		27,
		33,
		33,
		13,
		0,
		4,
		20,
		21,
		41,
		37,
		69,
		-1,
		185,
		-1,
		119,
		-1,
		-1,
		101,
		81,
		73,
		62,
		51,
		49,
		40,
		31,
		53,
		49,
		26,
		26,
		31,
		36,
		-1,
		174,
		173,
		-1,
		120,
		112,
		98,
		-1,
		91,
		-1,
		97,
		58,
		-1,
		60,
		40,
		-1,
		37,
		33,
		-1,
		-1,
		161,
		136,
		-1,
		-1,
		-1,
		121,
		101,
		92,
		76,
		-1,
		51,
		51,
		-1,
		-1,
		-1,
		146,
		145,
		-1,
		114,
		117,
		-1,
		107,
		98,
		106,
		53,
		57,
		-1,
		-1,
		-1,
		155,
		136,
		130,
		129,
		127,
		122,
		119,
		105,
		89,
		67,
		56,
		77,
		-1,
		-1,
		-1,
		127,
		119,
		112,
		-1,
		-1,
		114,
		97,
		78,
		76,
		-1,
		-1,
		-1,
		149,
		130,
		-1,
		-1,
		104,
		-1,
		-1,
		110,
		75,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		138,
		-1,
		-1,
		-1,
		100,
		96,
		97,
		-1,
		-1,
		-1,
		-1,
		160,
		161,
		184,
		148,
		-1,
		-1,
		-1,
		92,
		86,
		-1,
		-1,
		163,
		161,
		-1,
		-1,
		-1,
		120,
		104,
		-1,
		90,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		125,
		-1,
		125,
		100,
		107,
		-1,
		-1,
		-1,
		-1,
		138,
		130,
		138,
		-1,
		110,
		112,
		-1,
		160,
		-1,
		-1,
		153,
		144,
		-1,
		-1,
		115,
		122,
		144,
		147,
		183,
		-1,
		134
	],
	[
		-1,
		240,
		229,
		240,
		248,
		221,
		228,
		-1,
		247,
		251,
		217,
		211,
		250,
		219,
		225,
		236,
		-1,
		-1,
		-1,
		240,
		239,
		207,
		205,
		214,
		219,
		226,
		-1,
		225,
		-1,
		261,
		240,
		251,
		256,
		200,
		197,
		217,
		236,
		218,
		210,
		276,
		230,
		201,
		195,
		213,
		203,
		212,
		204,
		-1,
		201,
		191,
		213,
		192,
		203,
		195,
		-1,
		-1,
		195,
		196,
		202,
		188,
		194,
		190,
		-1,
		200,
		184,
		-1,
		-1,
		185,
		186,
		170,
		173,
		181,
		179,
		192,
		184,
		179,
		-1,
		-1,
		176,
		172,
		179,
		166,
		162,
		179,
		192,
		174,
		188,
		187,
		-1,
		180,
		198,
		205,
		173,
		171,
		155,
		153,
		171,
		173,
		179,
		179,
		-1,
		189,
		190,
		185,
		193,
		195,
		171,
		158,
		158,
		168,
		161,
		180,
		168,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		223,
		189,
		172,
		189,
		181,
		171,
		186,
		179,
		161,
		158,
		156,
		153,
		169,
		167,
		177,
		-1,
		-1,
		282,
		251,
		280,
		238,
		219,
		-1,
		185,
		165,
		171,
		175,
		169,
		162,
		176,
		172,
		-1,
		147,
		146,
		174,
		160,
		171,
		242,
		-1,
		-1,
		240,
		232,
		215,
		218,
		195,
		191,
		180,
		179,
		171,
		157,
		153,
		159,
		162,
		162,
		168,
		141,
		151,
		155,
		153,
		178,
		-1,
		-1,
		213,
		-1,
		-1,
		239,
		222,
		-1,
		205,
		212,
		201,
		207,
		193,
		214,
		190,
		181,
		173,
		167,
		155,
		157,
		154,
		167,
		155,
		138,
		163,
		167,
		148,
		169,
		164,
		-1,
		212,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		198,
		201,
		207,
		231,
		230,
		-1,
		202,
		190,
		191,
		176,
		173,
		160,
		148,
		161,
		146,
		153,
		152,
		142,
		140,
		170,
		145,
		167,
		164,
		183,
		188,
		182,
		191,
		-1,
		247,
		243,
		239,
		246,
		195,
		-1,
		-1,
		235,
		-1,
		238,
		239,
		214,
		187,
		190,
		177,
		168,
		155,
		144,
		155,
		144,
		141,
		149,
		134,
		149,
		140,
		139,
		157,
		167,
		175,
		179,
		185,
		-1,
		297,
		-1,
		239,
		223,
		225,
		197,
		218,
		-1,
		255,
		239,
		231,
		216,
		216,
		-1,
		186,
		183,
		173,
		151,
		136,
		153,
		145,
		143,
		147,
		129,
		143,
		134,
		152,
		159,
		157,
		161,
		181,
		193,
		257,
		247,
		-1,
		229,
		234,
		193,
		201,
		220,
		258,
		222,
		-1,
		217,
		-1,
		188,
		201,
		-1,
		157,
		153,
		135,
		136,
		131,
		146,
		140,
		125,
		122,
		140,
		143,
		150,
		154,
		170,
		-1,
		-1,
		242,
		246,
		235,
		186,
		205,
		229,
		266,
		215,
		204,
		203,
		-1,
		194,
		171,
		168,
		156,
		143,
		128,
		129,
		137,
		150,
		129,
		124,
		121,
		141,
		167,
		145,
		157,
		-1,
		-1,
		-1,
		267,
		-1,
		-1,
		212,
		183,
		207,
		249,
		233,
		226,
		214,
		179,
		179,
		173,
		-1,
		167,
		146,
		137,
		126,
		124,
		137,
		134,
		139,
		119,
		117,
		136,
		148,
		139,
		156,
		-1,
		-1,
		-1,
		242,
		231,
		232,
		178,
		201,
		238,
		212,
		198,
		203,
		178,
		171,
		165,
		180,
		163,
		144,
		133,
		125,
		114,
		130,
		138,
		133,
		115,
		124,
		130,
		154,
		144,
		150,
		-1,
		-1,
		249,
		239,
		223,
		225,
		222,
		192,
		199,
		231,
		203,
		216,
		-1,
		170,
		-1,
		159,
		154,
		138,
		133,
		130,
		127,
		121,
		130,
		132,
		122,
		117,
		124,
		159,
		159,
		134,
		154,
		157,
		-1,
		-1,
		-1,
		242,
		237,
		212,
		189,
		173,
		209,
		-1,
		186,
		187,
		-1,
		164,
		158,
		155,
		140,
		136,
		131,
		135,
		128,
		135,
		128,
		126,
		127,
		109,
		141,
		-1,
		142,
		136,
		144,
		134,
		122,
		-1,
		-1,
		-1,
		235,
		214,
		207,
		227,
		168,
		220,
		-1,
		-1,
		171,
		164,
		-1,
		151,
		133,
		140,
		138,
		132,
		136,
		133,
		122,
		135,
		128,
		114,
		116,
		129,
		133,
		137,
		124,
		120,
		117,
		131,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		168,
		188,
		-1,
		180,
		172,
		162,
		156,
		150,
		146,
		144,
		160,
		144,
		147,
		145,
		136,
		144,
		117,
		110,
		117,
		106,
		124,
		132,
		124,
		118,
		117,
		127,
		-1,
		255,
		241,
		212,
		-1,
		-1,
		201,
		-1,
		165,
		179,
		195,
		-1,
		188,
		167,
		182,
		160,
		156,
		152,
		167,
		168,
		145,
		145,
		143,
		134,
		122,
		111,
		114,
		106,
		128,
		128,
		112,
		113,
		117,
		-1,
		261,
		248,
		206,
		202,
		191,
		211,
		162,
		150,
		182,
		-1,
		-1,
		224,
		-1,
		158,
		175,
		166,
		164,
		157,
		139,
		146,
		154,
		131,
		126,
		116,
		105,
		105,
		100,
		122,
		108,
		106,
		115,
		131,
		-1,
		-1,
		-1,
		228,
		-1,
		-1,
		177,
		164,
		158,
		-1,
		199,
		-1,
		202,
		192,
		176,
		161,
		194,
		-1,
		138,
		134,
		141,
		-1,
		151,
		-1,
		124,
		121,
		112,
		97,
		94,
		105,
		103,
		114,
		110,
		-1,
		211,
		196,
		189,
		179,
		193,
		164,
		-1,
		219,
		-1,
		-1,
		189,
		183,
		183,
		167,
		168,
		154,
		134,
		126,
		141,
		140,
		127,
		126,
		110,
		103,
		100,
		93,
		106,
		116,
		121,
		108,
		-1,
		-1,
		-1,
		216,
		202,
		206,
		166,
		185,
		-1,
		-1,
		251,
		206,
		192,
		-1,
		163,
		154,
		142,
		132,
		122,
		127,
		128,
		118,
		116,
		108,
		110,
		104,
		95,
		94,
		110,
		102,
		124,
		-1,
		-1,
		199,
		204,
		192,
		178,
		197,
		-1,
		-1,
		-1,
		198,
		214,
		182,
		161,
		143,
		-1,
		-1,
		126,
		119,
		113,
		116,
		104,
		124,
		119,
		103,
		88,
		103,
		107,
		115,
		106,
		-1,
		202,
		189,
		-1,
		-1,
		200,
		194,
		-1,
		-1,
		-1,
		-1,
		194,
		139,
		128,
		123,
		127,
		125,
		-1,
		99,
		110,
		103,
		122,
		129,
		105,
		90,
		84,
		90,
		102,
		111,
		-1,
		-1,
		214,
		-1,
		188,
		-1,
		-1,
		-1,
		-1,
		151,
		145,
		116,
		109,
		113,
		-1,
		101,
		103,
		100,
		112,
		108,
		105,
		96,
		87,
		83,
		87,
		91,
		105,
		109,
		237,
		-1,
		179,
		-1,
		-1,
		-1,
		169,
		184,
		155,
		132,
		105,
		100,
		93,
		87,
		92,
		103,
		112,
		123,
		88,
		90,
		80,
		79,
		83,
		100,
		104,
		-1,
		-1,
		177,
		173,
		195,
		177,
		181,
		182,
		-1,
		-1,
		109,
		100,
		91,
		83,
		96,
		99,
		84,
		86,
		86,
		84,
		78,
		88,
		103,
		98,
		-1,
		-1,
		-1,
		189,
		-1,
		191,
		-1,
		-1,
		179,
		180,
		127,
		109,
		105,
		103,
		92,
		86,
		74,
		79,
		89,
		83,
		80,
		74,
		78,
		101,
		90,
		129,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		168,
		160,
		155,
		161,
		163,
		154,
		142,
		139,
		-1,
		109,
		115,
		80,
		87,
		70,
		77,
		82,
		79,
		68,
		75,
		91,
		90,
		85,
		121,
		112,
		118,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		161,
		157,
		147,
		137,
		140,
		-1,
		-1,
		134,
		131,
		111,
		80,
		78,
		71,
		66,
		76,
		52,
		64,
		68,
		72,
		78,
		83,
		88,
		94,
		109,
		124,
		-1,
		208,
		245,
		238,
		206,
		214,
		245,
		-1,
		151,
		143,
		154,
		129,
		131,
		-1,
		-1,
		107,
		98,
		99,
		87,
		84,
		90,
		89,
		72,
		78,
		79,
		71,
		70,
		88,
		92,
		101,
		108,
		98,
		111,
		115,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		148,
		-1,
		-1,
		129,
		132,
		116,
		106,
		103,
		146,
		101,
		96,
		77,
		75,
		70,
		61,
		86,
		79,
		79,
		82,
		96,
		101,
		93,
		108,
		104,
		97,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		-1,
		119,
		-1,
		143,
		-1,
		126,
		130,
		109,
		112,
		91,
		78,
		64,
		72,
		78,
		77,
		83,
		83,
		83,
		85,
		97,
		101,
		111,
		113,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		160,
		199,
		125,
		-1,
		109,
		-1,
		-1,
		-1,
		140,
		122,
		114,
		111,
		90,
		90,
		56,
		60,
		73,
		80,
		90,
		100,
		85,
		84,
		95,
		106,
		105,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		175,
		166,
		193,
		132,
		121,
		116,
		103,
		-1,
		-1,
		124,
		132,
		-1,
		-1,
		97,
		64,
		52,
		62,
		66,
		80,
		92,
		97,
		77,
		83,
		77,
		101,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		194,
		184,
		165,
		163,
		188,
		-1,
		92,
		-1,
		-1,
		104,
		-1,
		-1,
		89,
		69,
		58,
		49,
		54,
		74,
		85,
		107,
		73,
		89,
		82,
		89,
		86,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		160,
		158,
		164,
		171,
		166,
		177,
		-1,
		-1,
		108,
		88,
		-1,
		-1,
		87,
		85,
		74,
		-1,
		64,
		46,
		51,
		81,
		83,
		82,
		76,
		70,
		77,
		76,
		87,
		79,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		98,
		94,
		-1,
		-1,
		82,
		75,
		63,
		51,
		41,
		51,
		68,
		68,
		71,
		73,
		68,
		79,
		66,
		70,
		73,
		-1,
		231,
		-1,
		183,
		149,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		115,
		101,
		94,
		82,
		80,
		-1,
		116,
		100,
		81,
		-1,
		51,
		64,
		96,
		67,
		74,
		72,
		62,
		73,
		64,
		72,
		66,
		69,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		106,
		95,
		80,
		72,
		-1,
		-1,
		88,
		84,
		-1,
		-1,
		38,
		47,
		65,
		80,
		76,
		58,
		70,
		66,
		62,
		72,
		63,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		108,
		-1,
		75,
		81,
		69,
		-1,
		-1,
		-1,
		69,
		32,
		48,
		42,
		72,
		70,
		61,
		54,
		61,
		64,
		57,
		63,
		-1,
		-1,
		-1,
		108,
		82,
		115,
		106,
		89,
		69,
		61,
		80,
		-1,
		50,
		-1,
		25,
		28,
		24,
		74,
		69,
		55,
		51,
		64,
		58,
		55,
		53,
		114,
		-1,
		84,
		117,
		81,
		75,
		51,
		55,
		71,
		-1,
		47,
		29,
		-1,
		35,
		18,
		70,
		45,
		54,
		47,
		41,
		42,
		50,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		71,
		56,
		47,
		-1,
		59,
		41,
		20,
		35,
		20,
		11,
		2,
		60,
		56,
		59,
		57,
		35,
		-1,
		187,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		75,
		48,
		36,
		42,
		38,
		24,
		30,
		30,
		17,
		4,
		0,
		17,
		18,
		38,
		34,
		66,
		-1,
		182,
		-1,
		116,
		-1,
		-1,
		98,
		78,
		70,
		59,
		48,
		46,
		37,
		28,
		50,
		53,
		23,
		23,
		28,
		33,
		-1,
		171,
		170,
		-1,
		117,
		109,
		95,
		-1,
		88,
		-1,
		94,
		55,
		-1,
		57,
		37,
		-1,
		34,
		30,
		-1,
		-1,
		158,
		133,
		-1,
		-1,
		-1,
		118,
		98,
		89,
		73,
		-1,
		48,
		48,
		-1,
		-1,
		-1,
		143,
		142,
		-1,
		111,
		114,
		-1,
		104,
		95,
		103,
		50,
		54,
		-1,
		-1,
		-1,
		152,
		133,
		127,
		126,
		124,
		119,
		116,
		102,
		86,
		64,
		53,
		74,
		-1,
		-1,
		-1,
		124,
		116,
		109,
		-1,
		-1,
		111,
		94,
		75,
		73,
		-1,
		-1,
		-1,
		146,
		127,
		-1,
		-1,
		101,
		-1,
		-1,
		107,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		135,
		-1,
		-1,
		-1,
		97,
		93,
		94,
		-1,
		-1,
		-1,
		-1,
		157,
		158,
		181,
		145,
		-1,
		-1,
		-1,
		89,
		83,
		-1,
		-1,
		160,
		158,
		-1,
		-1,
		-1,
		117,
		101,
		-1,
		87,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		122,
		-1,
		122,
		97,
		104,
		-1,
		-1,
		-1,
		-1,
		135,
		127,
		135,
		-1,
		107,
		109,
		-1,
		157,
		-1,
		-1,
		150,
		141,
		-1,
		-1,
		112,
		119,
		141,
		144,
		180,
		-1,
		131
	],
	[
		-1,
		253,
		242,
		253,
		261,
		234,
		241,
		-1,
		260,
		264,
		230,
		224,
		263,
		232,
		238,
		249,
		-1,
		-1,
		-1,
		253,
		252,
		220,
		218,
		227,
		232,
		239,
		-1,
		238,
		-1,
		274,
		253,
		264,
		269,
		213,
		210,
		230,
		249,
		231,
		223,
		289,
		243,
		214,
		208,
		226,
		216,
		225,
		217,
		-1,
		214,
		204,
		226,
		205,
		216,
		208,
		-1,
		-1,
		208,
		209,
		215,
		201,
		207,
		203,
		-1,
		213,
		197,
		-1,
		-1,
		198,
		199,
		183,
		186,
		194,
		192,
		205,
		197,
		192,
		-1,
		-1,
		189,
		185,
		192,
		179,
		175,
		192,
		205,
		187,
		201,
		200,
		-1,
		193,
		211,
		218,
		186,
		184,
		168,
		166,
		184,
		186,
		192,
		192,
		-1,
		202,
		203,
		198,
		206,
		208,
		184,
		171,
		171,
		181,
		174,
		193,
		181,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		202,
		185,
		202,
		194,
		184,
		199,
		192,
		174,
		171,
		169,
		166,
		182,
		180,
		190,
		-1,
		-1,
		295,
		264,
		293,
		251,
		232,
		-1,
		198,
		178,
		184,
		188,
		182,
		175,
		189,
		185,
		-1,
		160,
		159,
		187,
		173,
		184,
		255,
		-1,
		-1,
		253,
		245,
		228,
		231,
		208,
		204,
		193,
		192,
		184,
		170,
		166,
		172,
		175,
		175,
		181,
		154,
		164,
		168,
		166,
		191,
		-1,
		-1,
		226,
		-1,
		-1,
		252,
		235,
		-1,
		218,
		225,
		214,
		220,
		206,
		227,
		203,
		194,
		186,
		180,
		168,
		170,
		167,
		180,
		168,
		151,
		176,
		180,
		161,
		182,
		177,
		-1,
		225,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		211,
		214,
		220,
		244,
		243,
		-1,
		215,
		203,
		204,
		189,
		186,
		173,
		161,
		174,
		159,
		166,
		165,
		155,
		153,
		183,
		158,
		180,
		177,
		196,
		201,
		195,
		204,
		-1,
		260,
		256,
		252,
		259,
		208,
		-1,
		-1,
		248,
		-1,
		251,
		252,
		227,
		200,
		203,
		190,
		181,
		168,
		157,
		168,
		157,
		154,
		162,
		147,
		162,
		153,
		152,
		170,
		180,
		188,
		192,
		198,
		-1,
		310,
		-1,
		252,
		236,
		238,
		210,
		231,
		-1,
		268,
		252,
		244,
		229,
		229,
		-1,
		199,
		196,
		186,
		164,
		149,
		166,
		158,
		156,
		160,
		142,
		156,
		147,
		165,
		172,
		170,
		174,
		194,
		206,
		270,
		260,
		-1,
		242,
		247,
		206,
		214,
		233,
		271,
		235,
		-1,
		230,
		-1,
		201,
		214,
		-1,
		170,
		166,
		148,
		149,
		144,
		159,
		153,
		138,
		135,
		153,
		156,
		163,
		167,
		183,
		-1,
		-1,
		255,
		259,
		248,
		199,
		218,
		242,
		279,
		228,
		217,
		216,
		-1,
		207,
		184,
		181,
		169,
		156,
		141,
		142,
		150,
		163,
		142,
		137,
		134,
		154,
		180,
		158,
		170,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		225,
		196,
		220,
		262,
		246,
		239,
		227,
		192,
		192,
		186,
		-1,
		180,
		159,
		150,
		139,
		137,
		150,
		147,
		152,
		132,
		130,
		149,
		161,
		152,
		169,
		-1,
		-1,
		-1,
		255,
		244,
		245,
		191,
		214,
		251,
		225,
		211,
		216,
		191,
		184,
		178,
		193,
		176,
		157,
		146,
		138,
		127,
		143,
		151,
		146,
		128,
		137,
		143,
		167,
		157,
		163,
		-1,
		-1,
		262,
		252,
		236,
		238,
		235,
		205,
		212,
		244,
		216,
		229,
		-1,
		183,
		-1,
		172,
		167,
		151,
		146,
		143,
		140,
		134,
		143,
		145,
		135,
		130,
		137,
		172,
		172,
		147,
		167,
		170,
		-1,
		-1,
		-1,
		255,
		250,
		225,
		202,
		186,
		222,
		-1,
		199,
		200,
		-1,
		177,
		171,
		168,
		153,
		149,
		144,
		148,
		141,
		148,
		141,
		139,
		140,
		122,
		154,
		-1,
		155,
		149,
		157,
		147,
		135,
		-1,
		-1,
		-1,
		248,
		227,
		220,
		240,
		181,
		233,
		-1,
		-1,
		184,
		177,
		-1,
		164,
		146,
		153,
		151,
		145,
		149,
		146,
		135,
		148,
		141,
		127,
		129,
		142,
		146,
		150,
		137,
		133,
		130,
		144,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		201,
		-1,
		193,
		185,
		175,
		169,
		163,
		159,
		157,
		173,
		157,
		160,
		158,
		149,
		157,
		130,
		123,
		130,
		119,
		137,
		145,
		137,
		131,
		130,
		140,
		-1,
		268,
		254,
		225,
		-1,
		-1,
		214,
		-1,
		178,
		192,
		208,
		-1,
		201,
		180,
		195,
		173,
		169,
		165,
		180,
		181,
		158,
		158,
		156,
		147,
		135,
		124,
		127,
		119,
		141,
		141,
		125,
		126,
		130,
		-1,
		274,
		261,
		219,
		215,
		204,
		224,
		175,
		163,
		195,
		-1,
		-1,
		237,
		-1,
		171,
		188,
		179,
		177,
		170,
		152,
		159,
		167,
		144,
		139,
		129,
		118,
		118,
		113,
		135,
		121,
		119,
		128,
		144,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		190,
		177,
		171,
		-1,
		212,
		-1,
		215,
		205,
		189,
		174,
		207,
		-1,
		151,
		147,
		154,
		-1,
		164,
		-1,
		137,
		134,
		125,
		110,
		107,
		118,
		116,
		127,
		123,
		-1,
		224,
		209,
		202,
		192,
		206,
		177,
		-1,
		232,
		-1,
		-1,
		202,
		196,
		196,
		180,
		181,
		167,
		147,
		139,
		154,
		153,
		140,
		139,
		123,
		116,
		113,
		106,
		119,
		129,
		134,
		121,
		-1,
		-1,
		-1,
		229,
		215,
		219,
		179,
		198,
		-1,
		-1,
		264,
		219,
		205,
		-1,
		176,
		167,
		155,
		145,
		135,
		140,
		141,
		131,
		129,
		121,
		123,
		117,
		108,
		107,
		123,
		115,
		137,
		-1,
		-1,
		212,
		217,
		205,
		191,
		210,
		-1,
		-1,
		-1,
		211,
		227,
		195,
		174,
		156,
		-1,
		-1,
		139,
		132,
		126,
		129,
		117,
		137,
		132,
		116,
		101,
		116,
		120,
		128,
		119,
		-1,
		215,
		202,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		-1,
		-1,
		207,
		152,
		141,
		136,
		140,
		138,
		-1,
		112,
		123,
		116,
		135,
		142,
		118,
		103,
		97,
		103,
		115,
		124,
		-1,
		-1,
		227,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		129,
		122,
		126,
		-1,
		114,
		116,
		113,
		125,
		121,
		118,
		109,
		100,
		96,
		100,
		104,
		118,
		122,
		250,
		-1,
		192,
		-1,
		-1,
		-1,
		182,
		197,
		168,
		145,
		118,
		113,
		106,
		100,
		105,
		116,
		125,
		136,
		101,
		103,
		93,
		92,
		96,
		113,
		117,
		-1,
		-1,
		190,
		186,
		208,
		190,
		194,
		195,
		-1,
		-1,
		122,
		113,
		104,
		96,
		109,
		112,
		97,
		99,
		99,
		97,
		91,
		101,
		116,
		111,
		-1,
		-1,
		-1,
		202,
		-1,
		204,
		-1,
		-1,
		192,
		193,
		140,
		122,
		118,
		116,
		105,
		99,
		87,
		92,
		102,
		96,
		93,
		87,
		91,
		114,
		103,
		130,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		155,
		152,
		-1,
		122,
		128,
		93,
		100,
		83,
		90,
		95,
		92,
		81,
		88,
		104,
		103,
		98,
		122,
		113,
		121,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		147,
		144,
		124,
		93,
		91,
		84,
		79,
		89,
		65,
		77,
		81,
		85,
		91,
		96,
		101,
		107,
		112,
		127,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		120,
		111,
		112,
		100,
		97,
		103,
		102,
		85,
		91,
		92,
		84,
		83,
		101,
		105,
		109,
		110,
		99,
		112,
		116,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		161,
		-1,
		-1,
		142,
		145,
		129,
		119,
		116,
		159,
		114,
		109,
		90,
		88,
		83,
		74,
		99,
		92,
		91,
		88,
		97,
		102,
		94,
		109,
		105,
		98,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		132,
		-1,
		156,
		-1,
		139,
		143,
		122,
		125,
		104,
		91,
		77,
		85,
		91,
		90,
		96,
		95,
		84,
		86,
		98,
		102,
		112,
		114,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		173,
		212,
		138,
		-1,
		122,
		-1,
		-1,
		-1,
		153,
		135,
		127,
		124,
		103,
		103,
		69,
		73,
		86,
		93,
		103,
		101,
		86,
		85,
		96,
		107,
		106,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		188,
		179,
		206,
		145,
		134,
		129,
		116,
		-1,
		-1,
		137,
		145,
		-1,
		-1,
		110,
		77,
		65,
		75,
		79,
		93,
		105,
		98,
		78,
		84,
		78,
		102,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		207,
		197,
		178,
		176,
		201,
		-1,
		105,
		-1,
		-1,
		117,
		-1,
		-1,
		102,
		82,
		71,
		62,
		67,
		87,
		98,
		120,
		74,
		90,
		83,
		90,
		87,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		179,
		190,
		-1,
		-1,
		121,
		101,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		59,
		64,
		94,
		91,
		83,
		77,
		71,
		78,
		77,
		88,
		80,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		111,
		107,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		64,
		81,
		79,
		79,
		74,
		69,
		80,
		67,
		71,
		74,
		-1,
		244,
		-1,
		196,
		162,
		168,
		183,
		191,
		-1,
		-1,
		-1,
		128,
		114,
		107,
		95,
		93,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		115,
		83,
		75,
		73,
		63,
		74,
		65,
		73,
		67,
		70,
		-1,
		-1,
		161,
		144,
		-1,
		-1,
		118,
		120,
		-1,
		119,
		108,
		93,
		85,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		51,
		68,
		86,
		81,
		77,
		59,
		71,
		67,
		63,
		73,
		64,
		-1,
		-1,
		139,
		131,
		125,
		-1,
		103,
		-1,
		121,
		-1,
		88,
		94,
		82,
		-1,
		-1,
		-1,
		82,
		45,
		61,
		63,
		73,
		71,
		62,
		55,
		62,
		65,
		58,
		64,
		-1,
		-1,
		-1,
		121,
		95,
		128,
		119,
		102,
		82,
		74,
		93,
		-1,
		63,
		-1,
		38,
		41,
		45,
		81,
		70,
		56,
		52,
		65,
		59,
		56,
		54,
		127,
		-1,
		97,
		130,
		94,
		88,
		64,
		68,
		84,
		-1,
		60,
		42,
		-1,
		53,
		39,
		71,
		46,
		55,
		48,
		42,
		43,
		51,
		-1,
		-1,
		-1,
		99,
		98,
		90,
		84,
		84,
		69,
		60,
		-1,
		72,
		54,
		33,
		48,
		33,
		24,
		23,
		61,
		57,
		60,
		58,
		36,
		-1,
		200,
		-1,
		-1,
		122,
		-1,
		-1,
		-1,
		93,
		88,
		61,
		49,
		55,
		51,
		37,
		43,
		43,
		36,
		25,
		22,
		0,
		19,
		39,
		35,
		67,
		-1,
		195,
		-1,
		129,
		-1,
		-1,
		111,
		91,
		83,
		72,
		61,
		59,
		50,
		41,
		63,
		67,
		20,
		24,
		29,
		34,
		-1,
		184,
		183,
		-1,
		130,
		122,
		108,
		-1,
		101,
		-1,
		107,
		68,
		-1,
		70,
		50,
		-1,
		35,
		31,
		-1,
		-1,
		171,
		146,
		-1,
		-1,
		-1,
		131,
		111,
		102,
		86,
		-1,
		61,
		61,
		-1,
		-1,
		-1,
		156,
		155,
		-1,
		124,
		127,
		-1,
		117,
		108,
		116,
		63,
		67,
		-1,
		-1,
		-1,
		165,
		146,
		140,
		139,
		137,
		132,
		129,
		115,
		99,
		77,
		66,
		87,
		-1,
		-1,
		-1,
		137,
		129,
		122,
		-1,
		-1,
		124,
		107,
		88,
		86,
		-1,
		-1,
		-1,
		159,
		140,
		-1,
		-1,
		114,
		-1,
		-1,
		120,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		148,
		-1,
		-1,
		-1,
		110,
		106,
		107,
		-1,
		-1,
		-1,
		-1,
		170,
		171,
		194,
		158,
		-1,
		-1,
		-1,
		102,
		96,
		-1,
		-1,
		173,
		171,
		-1,
		-1,
		-1,
		130,
		114,
		-1,
		100,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		133,
		-1,
		-1,
		-1,
		135,
		-1,
		135,
		110,
		117,
		-1,
		-1,
		-1,
		-1,
		148,
		140,
		148,
		-1,
		120,
		122,
		-1,
		170,
		-1,
		-1,
		163,
		154,
		-1,
		-1,
		125,
		132,
		154,
		157,
		193,
		-1,
		144
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		159,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		147,
		153,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		127,
		123,
		120,
		134,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		120,
		130,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		148,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		120,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		142,
		149,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		118,
		134,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		141,
		137,
		144,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		113,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		171,
		157,
		137,
		129,
		144,
		143,
		130,
		129,
		113,
		106,
		103,
		96,
		109,
		119,
		124,
		111,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		166,
		157,
		145,
		135,
		125,
		130,
		131,
		121,
		119,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		127,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		185,
		164,
		146,
		-1,
		-1,
		129,
		122,
		116,
		119,
		107,
		127,
		122,
		106,
		91,
		106,
		110,
		118,
		109,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		197,
		142,
		131,
		126,
		130,
		128,
		-1,
		102,
		113,
		106,
		125,
		132,
		108,
		93,
		87,
		93,
		105,
		114,
		-1,
		-1,
		217,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		154,
		148,
		119,
		112,
		116,
		-1,
		104,
		106,
		103,
		115,
		111,
		108,
		99,
		90,
		86,
		90,
		94,
		108,
		112,
		240,
		-1,
		182,
		-1,
		-1,
		-1,
		172,
		187,
		158,
		135,
		108,
		103,
		96,
		90,
		95,
		106,
		115,
		126,
		91,
		93,
		83,
		82,
		86,
		103,
		107,
		-1,
		-1,
		180,
		176,
		198,
		180,
		184,
		185,
		-1,
		-1,
		112,
		103,
		94,
		86,
		99,
		102,
		87,
		89,
		89,
		87,
		81,
		91,
		106,
		101,
		-1,
		-1,
		-1,
		192,
		-1,
		194,
		-1,
		-1,
		182,
		183,
		130,
		112,
		108,
		106,
		95,
		89,
		77,
		82,
		92,
		86,
		83,
		77,
		81,
		104,
		93,
		111,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		171,
		163,
		158,
		164,
		166,
		157,
		145,
		142,
		-1,
		112,
		118,
		83,
		90,
		73,
		80,
		85,
		82,
		71,
		78,
		94,
		93,
		88,
		103,
		94,
		102,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		164,
		160,
		150,
		140,
		143,
		-1,
		-1,
		137,
		134,
		114,
		83,
		81,
		74,
		69,
		79,
		55,
		67,
		71,
		75,
		81,
		86,
		91,
		88,
		93,
		108,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		154,
		146,
		157,
		132,
		134,
		-1,
		-1,
		110,
		101,
		102,
		90,
		87,
		93,
		92,
		75,
		81,
		82,
		74,
		73,
		91,
		86,
		90,
		91,
		80,
		93,
		97,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		151,
		-1,
		-1,
		132,
		135,
		119,
		109,
		106,
		149,
		104,
		99,
		80,
		78,
		73,
		64,
		89,
		82,
		72,
		69,
		78,
		83,
		75,
		90,
		86,
		79,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		152,
		-1,
		-1,
		122,
		-1,
		146,
		-1,
		129,
		133,
		112,
		115,
		94,
		81,
		67,
		75,
		81,
		80,
		80,
		76,
		65,
		67,
		79,
		83,
		93,
		95,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		163,
		202,
		128,
		-1,
		112,
		-1,
		-1,
		-1,
		143,
		125,
		117,
		114,
		93,
		93,
		59,
		63,
		76,
		83,
		91,
		82,
		67,
		66,
		77,
		88,
		87,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		169,
		196,
		135,
		124,
		119,
		106,
		-1,
		-1,
		127,
		135,
		-1,
		-1,
		100,
		67,
		55,
		65,
		69,
		83,
		91,
		79,
		59,
		65,
		59,
		83,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		197,
		187,
		168,
		166,
		191,
		-1,
		95,
		-1,
		-1,
		107,
		-1,
		-1,
		92,
		72,
		61,
		52,
		57,
		77,
		88,
		106,
		55,
		71,
		64,
		71,
		68,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		163,
		161,
		167,
		174,
		169,
		180,
		-1,
		-1,
		111,
		91,
		-1,
		-1,
		90,
		88,
		77,
		-1,
		67,
		49,
		54,
		84,
		72,
		64,
		58,
		52,
		59,
		58,
		69,
		61,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		101,
		97,
		-1,
		-1,
		85,
		78,
		66,
		54,
		44,
		54,
		64,
		60,
		60,
		55,
		50,
		61,
		48,
		52,
		55,
		-1,
		234,
		-1,
		186,
		152,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		118,
		104,
		97,
		85,
		83,
		-1,
		119,
		103,
		84,
		-1,
		54,
		67,
		96,
		64,
		56,
		54,
		44,
		55,
		46,
		54,
		48,
		51,
		-1,
		-1,
		151,
		134,
		-1,
		-1,
		108,
		110,
		-1,
		109,
		98,
		83,
		75,
		-1,
		-1,
		91,
		87,
		-1,
		-1,
		41,
		59,
		67,
		62,
		58,
		40,
		52,
		48,
		44,
		54,
		45,
		-1,
		-1,
		129,
		121,
		115,
		-1,
		93,
		-1,
		111,
		-1,
		78,
		84,
		72,
		-1,
		-1,
		-1,
		72,
		35,
		51,
		54,
		54,
		52,
		43,
		36,
		43,
		46,
		39,
		45,
		-1,
		-1,
		-1,
		111,
		85,
		118,
		109,
		92,
		72,
		64,
		83,
		-1,
		53,
		-1,
		28,
		31,
		36,
		62,
		51,
		37,
		33,
		46,
		40,
		37,
		35,
		117,
		-1,
		87,
		120,
		84,
		78,
		54,
		58,
		74,
		-1,
		50,
		32,
		-1,
		43,
		30,
		52,
		27,
		36,
		29,
		23,
		24,
		32,
		-1,
		-1,
		-1,
		89,
		88,
		80,
		74,
		74,
		59,
		50,
		-1,
		62,
		44,
		23,
		38,
		23,
		14,
		14,
		42,
		38,
		41,
		39,
		17,
		-1,
		190,
		-1,
		-1,
		112,
		-1,
		-1,
		-1,
		83,
		78,
		51,
		39,
		45,
		41,
		27,
		33,
		33,
		26,
		16,
		13,
		9,
		0,
		20,
		16,
		48,
		-1,
		185,
		-1,
		119,
		-1,
		-1,
		101,
		81,
		73,
		62,
		51,
		49,
		40,
		31,
		53,
		57,
		7,
		5,
		10,
		15,
		-1,
		174,
		173,
		-1,
		120,
		112,
		98,
		-1,
		91,
		-1,
		97,
		58,
		-1,
		60,
		40,
		-1,
		16,
		12,
		-1,
		-1,
		161,
		136,
		-1,
		-1,
		-1,
		121,
		101,
		92,
		76,
		-1,
		51,
		51,
		-1,
		-1,
		-1,
		146,
		145,
		-1,
		114,
		117,
		-1,
		107,
		98,
		106,
		53,
		57,
		-1,
		-1,
		-1,
		155,
		136,
		130,
		129,
		127,
		122,
		119,
		105,
		89,
		67,
		56,
		77,
		-1,
		-1,
		-1,
		127,
		119,
		112,
		-1,
		-1,
		114,
		97,
		78,
		76,
		-1,
		-1,
		-1,
		149,
		130,
		-1,
		-1,
		104,
		-1,
		-1,
		110,
		75,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		138,
		-1,
		-1,
		-1,
		100,
		96,
		97,
		-1,
		-1,
		-1,
		-1,
		160,
		161,
		184,
		148,
		-1,
		-1,
		-1,
		92,
		86,
		-1,
		-1,
		163,
		161,
		-1,
		-1,
		-1,
		120,
		104,
		-1,
		90,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		125,
		-1,
		125,
		100,
		107,
		-1,
		-1,
		-1,
		-1,
		138,
		130,
		138,
		-1,
		110,
		112,
		-1,
		160,
		-1,
		-1,
		153,
		144,
		-1,
		-1,
		115,
		122,
		144,
		147,
		183,
		-1,
		134
	],
	[
		-1,
		267,
		256,
		267,
		275,
		248,
		255,
		-1,
		274,
		278,
		244,
		238,
		277,
		246,
		252,
		263,
		-1,
		-1,
		-1,
		267,
		266,
		234,
		232,
		241,
		246,
		253,
		-1,
		252,
		-1,
		288,
		267,
		278,
		283,
		227,
		224,
		244,
		263,
		245,
		237,
		303,
		257,
		228,
		222,
		240,
		230,
		239,
		231,
		-1,
		228,
		218,
		240,
		219,
		230,
		222,
		-1,
		-1,
		222,
		223,
		229,
		215,
		221,
		217,
		-1,
		227,
		211,
		-1,
		-1,
		212,
		213,
		197,
		200,
		208,
		206,
		219,
		211,
		206,
		-1,
		-1,
		203,
		199,
		206,
		193,
		189,
		206,
		219,
		201,
		215,
		214,
		-1,
		207,
		225,
		232,
		200,
		198,
		182,
		180,
		198,
		200,
		206,
		206,
		-1,
		216,
		217,
		212,
		220,
		222,
		198,
		185,
		185,
		195,
		188,
		207,
		195,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		216,
		199,
		216,
		208,
		198,
		213,
		206,
		188,
		185,
		183,
		180,
		196,
		194,
		204,
		-1,
		-1,
		309,
		278,
		307,
		265,
		246,
		-1,
		212,
		192,
		198,
		202,
		196,
		189,
		203,
		199,
		-1,
		174,
		173,
		201,
		187,
		198,
		269,
		-1,
		-1,
		267,
		259,
		242,
		245,
		222,
		218,
		207,
		206,
		198,
		184,
		180,
		186,
		189,
		189,
		195,
		168,
		178,
		182,
		180,
		205,
		-1,
		-1,
		240,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		228,
		234,
		220,
		241,
		217,
		208,
		200,
		194,
		182,
		184,
		181,
		194,
		182,
		165,
		190,
		194,
		175,
		196,
		191,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		257,
		-1,
		229,
		217,
		218,
		203,
		200,
		187,
		175,
		188,
		173,
		180,
		179,
		169,
		167,
		197,
		172,
		194,
		191,
		210,
		215,
		209,
		218,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		265,
		266,
		241,
		214,
		217,
		204,
		195,
		182,
		171,
		182,
		171,
		168,
		176,
		161,
		176,
		167,
		166,
		184,
		194,
		202,
		206,
		212,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		266,
		258,
		243,
		243,
		-1,
		213,
		210,
		200,
		178,
		163,
		180,
		172,
		170,
		174,
		156,
		170,
		161,
		179,
		186,
		184,
		188,
		208,
		220,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		285,
		249,
		-1,
		244,
		-1,
		215,
		228,
		-1,
		184,
		180,
		162,
		163,
		158,
		173,
		167,
		152,
		149,
		167,
		170,
		177,
		181,
		197,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		242,
		231,
		230,
		-1,
		221,
		198,
		195,
		183,
		170,
		155,
		156,
		164,
		177,
		156,
		151,
		148,
		168,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		260,
		253,
		241,
		206,
		206,
		200,
		-1,
		194,
		173,
		164,
		153,
		151,
		164,
		161,
		166,
		146,
		144,
		163,
		175,
		166,
		183,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		205,
		228,
		265,
		239,
		225,
		230,
		205,
		198,
		192,
		207,
		190,
		171,
		160,
		152,
		141,
		157,
		165,
		160,
		142,
		151,
		157,
		181,
		171,
		177,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		219,
		226,
		258,
		230,
		243,
		-1,
		197,
		-1,
		186,
		181,
		165,
		160,
		157,
		154,
		148,
		157,
		159,
		149,
		144,
		151,
		186,
		186,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		269,
		264,
		239,
		216,
		200,
		236,
		-1,
		213,
		214,
		-1,
		191,
		185,
		182,
		167,
		163,
		158,
		162,
		155,
		162,
		155,
		153,
		154,
		136,
		168,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		262,
		241,
		234,
		254,
		195,
		247,
		-1,
		-1,
		198,
		191,
		-1,
		178,
		160,
		167,
		165,
		159,
		163,
		160,
		149,
		162,
		155,
		141,
		143,
		156,
		160,
		164,
		151,
		147,
		144,
		158,
		-1,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		215,
		-1,
		207,
		199,
		189,
		183,
		177,
		173,
		171,
		187,
		171,
		174,
		172,
		163,
		171,
		144,
		137,
		144,
		133,
		151,
		159,
		151,
		145,
		144,
		154,
		-1,
		282,
		268,
		239,
		-1,
		-1,
		228,
		-1,
		192,
		206,
		222,
		-1,
		215,
		194,
		209,
		187,
		183,
		179,
		194,
		195,
		172,
		172,
		170,
		161,
		149,
		138,
		141,
		133,
		155,
		155,
		139,
		140,
		144,
		-1,
		288,
		275,
		233,
		229,
		218,
		238,
		189,
		177,
		209,
		-1,
		-1,
		251,
		-1,
		185,
		202,
		193,
		191,
		184,
		166,
		173,
		181,
		158,
		153,
		143,
		132,
		132,
		127,
		149,
		135,
		133,
		142,
		154,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		204,
		191,
		185,
		-1,
		226,
		-1,
		229,
		219,
		203,
		188,
		221,
		-1,
		165,
		161,
		168,
		-1,
		178,
		-1,
		151,
		148,
		139,
		124,
		121,
		132,
		130,
		141,
		137,
		-1,
		238,
		223,
		216,
		206,
		220,
		191,
		-1,
		246,
		-1,
		-1,
		216,
		210,
		210,
		194,
		195,
		181,
		161,
		153,
		168,
		167,
		154,
		153,
		137,
		130,
		127,
		120,
		133,
		143,
		148,
		135,
		-1,
		-1,
		-1,
		243,
		229,
		233,
		193,
		212,
		-1,
		-1,
		278,
		233,
		219,
		-1,
		190,
		181,
		169,
		159,
		149,
		154,
		155,
		145,
		143,
		135,
		137,
		131,
		122,
		121,
		137,
		129,
		151,
		-1,
		-1,
		226,
		231,
		219,
		205,
		224,
		-1,
		-1,
		-1,
		225,
		241,
		209,
		188,
		170,
		-1,
		-1,
		153,
		146,
		140,
		143,
		131,
		151,
		146,
		130,
		115,
		130,
		134,
		142,
		133,
		-1,
		229,
		216,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		-1,
		-1,
		221,
		166,
		155,
		150,
		154,
		152,
		-1,
		126,
		137,
		130,
		149,
		156,
		132,
		117,
		111,
		117,
		129,
		138,
		-1,
		-1,
		241,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		178,
		172,
		143,
		136,
		140,
		-1,
		128,
		130,
		127,
		139,
		135,
		132,
		123,
		114,
		110,
		114,
		118,
		126,
		132,
		264,
		-1,
		206,
		-1,
		-1,
		-1,
		196,
		211,
		182,
		159,
		132,
		127,
		120,
		114,
		119,
		130,
		139,
		150,
		115,
		117,
		107,
		106,
		110,
		127,
		128,
		-1,
		-1,
		204,
		200,
		222,
		204,
		208,
		209,
		-1,
		-1,
		136,
		127,
		118,
		110,
		123,
		126,
		111,
		113,
		113,
		111,
		105,
		115,
		127,
		122,
		-1,
		-1,
		-1,
		216,
		-1,
		218,
		-1,
		-1,
		206,
		207,
		154,
		136,
		132,
		130,
		119,
		113,
		101,
		106,
		116,
		110,
		107,
		101,
		102,
		125,
		114,
		120,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		195,
		187,
		182,
		188,
		190,
		181,
		169,
		166,
		-1,
		136,
		142,
		107,
		114,
		97,
		104,
		109,
		106,
		95,
		99,
		115,
		114,
		107,
		112,
		103,
		111,
		-1,
		-1,
		281,
		270,
		259,
		265,
		-1,
		188,
		184,
		174,
		164,
		167,
		-1,
		-1,
		161,
		158,
		138,
		107,
		105,
		98,
		93,
		103,
		79,
		91,
		92,
		87,
		102,
		107,
		104,
		97,
		102,
		117,
		-1,
		235,
		272,
		265,
		233,
		241,
		272,
		-1,
		178,
		170,
		181,
		156,
		158,
		-1,
		-1,
		134,
		125,
		126,
		114,
		111,
		117,
		116,
		99,
		101,
		106,
		85,
		92,
		103,
		95,
		99,
		100,
		89,
		102,
		106,
		-1,
		228,
		248,
		227,
		230,
		254,
		268,
		-1,
		175,
		-1,
		-1,
		156,
		159,
		143,
		133,
		130,
		173,
		128,
		123,
		104,
		102,
		97,
		88,
		109,
		93,
		81,
		78,
		87,
		92,
		84,
		99,
		95,
		88,
		-1,
		217,
		228,
		221,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		146,
		-1,
		170,
		-1,
		153,
		157,
		136,
		139,
		118,
		105,
		91,
		96,
		102,
		93,
		89,
		85,
		74,
		76,
		88,
		92,
		102,
		104,
		242,
		198,
		201,
		212,
		223,
		238,
		242,
		-1,
		187,
		226,
		152,
		-1,
		136,
		-1,
		-1,
		-1,
		167,
		149,
		141,
		138,
		117,
		117,
		83,
		84,
		97,
		94,
		100,
		91,
		76,
		75,
		86,
		97,
		96,
		238,
		229,
		242,
		187,
		187,
		208,
		217,
		238,
		202,
		193,
		220,
		159,
		148,
		143,
		130,
		-1,
		-1,
		151,
		159,
		-1,
		-1,
		124,
		91,
		79,
		86,
		90,
		104,
		100,
		88,
		68,
		74,
		68,
		92,
		-1,
		231,
		230,
		219,
		216,
		192,
		183,
		178,
		205,
		-1,
		-1,
		200,
		221,
		211,
		192,
		190,
		215,
		-1,
		119,
		-1,
		-1,
		131,
		-1,
		-1,
		116,
		96,
		85,
		76,
		76,
		98,
		104,
		115,
		64,
		80,
		73,
		80,
		77,
		215,
		212,
		200,
		198,
		221,
		186,
		174,
		-1,
		187,
		185,
		191,
		198,
		193,
		204,
		-1,
		-1,
		135,
		115,
		-1,
		-1,
		114,
		112,
		101,
		-1,
		91,
		73,
		73,
		100,
		81,
		73,
		67,
		61,
		68,
		67,
		78,
		70,
		224,
		238,
		227,
		223,
		222,
		230,
		179,
		172,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		140,
		-1,
		125,
		121,
		-1,
		-1,
		109,
		102,
		90,
		78,
		68,
		78,
		73,
		69,
		69,
		64,
		59,
		70,
		57,
		61,
		64,
		-1,
		258,
		-1,
		210,
		176,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		142,
		128,
		121,
		109,
		107,
		-1,
		143,
		127,
		108,
		-1,
		78,
		91,
		105,
		73,
		61,
		63,
		53,
		64,
		55,
		63,
		57,
		60,
		-1,
		-1,
		175,
		158,
		-1,
		-1,
		132,
		134,
		-1,
		133,
		122,
		107,
		99,
		-1,
		-1,
		115,
		111,
		-1,
		-1,
		65,
		83,
		76,
		67,
		66,
		49,
		61,
		57,
		53,
		63,
		54,
		-1,
		-1,
		153,
		145,
		139,
		-1,
		117,
		-1,
		135,
		-1,
		102,
		108,
		96,
		-1,
		-1,
		-1,
		96,
		59,
		75,
		78,
		59,
		57,
		52,
		45,
		52,
		55,
		48,
		54,
		-1,
		-1,
		-1,
		135,
		109,
		142,
		133,
		116,
		96,
		88,
		107,
		-1,
		77,
		-1,
		52,
		55,
		60,
		67,
		65,
		51,
		42,
		47,
		49,
		46,
		44,
		141,
		-1,
		111,
		144,
		108,
		102,
		78,
		82,
		98,
		-1,
		74,
		56,
		-1,
		67,
		54,
		66,
		41,
		27,
		38,
		32,
		33,
		41,
		-1,
		-1,
		-1,
		113,
		112,
		104,
		98,
		98,
		83,
		74,
		-1,
		86,
		68,
		47,
		62,
		47,
		38,
		38,
		56,
		52,
		22,
		24,
		26,
		-1,
		214,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		107,
		102,
		75,
		63,
		69,
		65,
		51,
		57,
		57,
		50,
		40,
		37,
		30,
		24,
		0,
		25,
		55,
		-1,
		209,
		-1,
		143,
		-1,
		-1,
		125,
		105,
		97,
		86,
		75,
		73,
		64,
		55,
		77,
		81,
		29,
		25,
		23,
		21,
		-1,
		198,
		197,
		-1,
		144,
		136,
		122,
		-1,
		115,
		-1,
		121,
		82,
		-1,
		84,
		64,
		-1,
		34,
		24,
		-1,
		-1,
		185,
		160,
		-1,
		-1,
		-1,
		145,
		125,
		116,
		100,
		-1,
		75,
		75,
		-1,
		-1,
		-1,
		170,
		169,
		-1,
		138,
		141,
		-1,
		131,
		122,
		130,
		77,
		81,
		-1,
		-1,
		-1,
		179,
		160,
		154,
		153,
		151,
		146,
		143,
		129,
		113,
		91,
		80,
		101,
		-1,
		-1,
		-1,
		151,
		143,
		136,
		-1,
		-1,
		138,
		121,
		102,
		100,
		-1,
		-1,
		-1,
		173,
		154,
		-1,
		-1,
		128,
		-1,
		-1,
		134,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		162,
		-1,
		-1,
		-1,
		124,
		120,
		121,
		-1,
		-1,
		-1,
		-1,
		184,
		185,
		208,
		172,
		-1,
		-1,
		-1,
		116,
		110,
		-1,
		-1,
		187,
		185,
		-1,
		-1,
		-1,
		144,
		128,
		-1,
		114,
		-1,
		-1,
		-1,
		135,
		-1,
		-1,
		147,
		-1,
		-1,
		-1,
		149,
		-1,
		149,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		162,
		154,
		162,
		-1,
		134,
		136,
		-1,
		184,
		-1,
		-1,
		177,
		168,
		-1,
		-1,
		139,
		146,
		168,
		171,
		207,
		-1,
		158
	],
	[
		-1,
		243,
		232,
		243,
		251,
		224,
		231,
		-1,
		250,
		254,
		220,
		214,
		253,
		222,
		228,
		239,
		-1,
		-1,
		-1,
		243,
		242,
		210,
		208,
		217,
		222,
		229,
		-1,
		228,
		-1,
		264,
		243,
		254,
		259,
		203,
		200,
		220,
		239,
		221,
		213,
		279,
		233,
		204,
		198,
		216,
		206,
		215,
		207,
		-1,
		204,
		194,
		216,
		195,
		206,
		198,
		-1,
		-1,
		198,
		199,
		205,
		191,
		197,
		193,
		-1,
		203,
		187,
		-1,
		-1,
		188,
		189,
		173,
		176,
		184,
		182,
		195,
		187,
		182,
		-1,
		-1,
		179,
		175,
		182,
		169,
		165,
		182,
		195,
		177,
		191,
		190,
		-1,
		183,
		201,
		208,
		176,
		174,
		158,
		156,
		174,
		176,
		182,
		182,
		-1,
		192,
		193,
		188,
		196,
		198,
		174,
		161,
		161,
		171,
		164,
		183,
		171,
		217,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		192,
		175,
		192,
		184,
		174,
		189,
		182,
		164,
		161,
		159,
		156,
		172,
		170,
		180,
		-1,
		-1,
		285,
		254,
		283,
		241,
		222,
		-1,
		188,
		168,
		174,
		178,
		172,
		165,
		179,
		175,
		-1,
		150,
		149,
		177,
		163,
		174,
		245,
		-1,
		-1,
		243,
		235,
		218,
		221,
		198,
		194,
		183,
		182,
		174,
		160,
		156,
		162,
		165,
		165,
		171,
		144,
		154,
		158,
		156,
		181,
		-1,
		-1,
		216,
		-1,
		-1,
		242,
		225,
		-1,
		208,
		215,
		204,
		210,
		196,
		217,
		193,
		184,
		176,
		170,
		158,
		160,
		157,
		170,
		158,
		141,
		166,
		170,
		151,
		172,
		167,
		-1,
		215,
		199,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		201,
		204,
		210,
		234,
		233,
		-1,
		205,
		193,
		194,
		179,
		176,
		163,
		151,
		164,
		149,
		156,
		155,
		145,
		143,
		173,
		148,
		170,
		167,
		186,
		191,
		185,
		194,
		-1,
		250,
		246,
		242,
		249,
		198,
		-1,
		-1,
		238,
		-1,
		241,
		242,
		217,
		190,
		193,
		180,
		171,
		158,
		147,
		158,
		147,
		144,
		152,
		137,
		152,
		143,
		142,
		160,
		170,
		178,
		182,
		188,
		-1,
		300,
		-1,
		242,
		226,
		228,
		200,
		221,
		-1,
		258,
		242,
		234,
		219,
		219,
		-1,
		189,
		186,
		176,
		154,
		139,
		156,
		148,
		146,
		150,
		132,
		146,
		137,
		155,
		162,
		160,
		164,
		184,
		196,
		260,
		250,
		-1,
		232,
		237,
		196,
		204,
		223,
		261,
		225,
		-1,
		220,
		-1,
		191,
		204,
		-1,
		160,
		156,
		138,
		139,
		134,
		149,
		143,
		128,
		125,
		143,
		146,
		153,
		157,
		173,
		-1,
		-1,
		245,
		249,
		238,
		189,
		208,
		232,
		269,
		218,
		207,
		206,
		-1,
		197,
		174,
		171,
		159,
		146,
		131,
		132,
		140,
		153,
		132,
		127,
		124,
		144,
		170,
		148,
		160,
		-1,
		-1,
		-1,
		270,
		-1,
		-1,
		215,
		186,
		210,
		252,
		236,
		229,
		217,
		182,
		182,
		176,
		-1,
		170,
		149,
		140,
		129,
		127,
		140,
		137,
		142,
		122,
		120,
		139,
		151,
		142,
		159,
		-1,
		-1,
		-1,
		245,
		234,
		235,
		181,
		204,
		241,
		215,
		201,
		206,
		181,
		174,
		168,
		183,
		166,
		147,
		136,
		128,
		117,
		133,
		141,
		136,
		118,
		127,
		133,
		157,
		147,
		153,
		-1,
		-1,
		252,
		242,
		226,
		228,
		225,
		195,
		202,
		234,
		206,
		219,
		-1,
		173,
		-1,
		162,
		157,
		141,
		136,
		133,
		130,
		124,
		133,
		135,
		125,
		120,
		127,
		162,
		162,
		137,
		157,
		160,
		-1,
		-1,
		-1,
		245,
		240,
		215,
		192,
		176,
		212,
		-1,
		189,
		190,
		-1,
		167,
		161,
		158,
		143,
		139,
		134,
		138,
		131,
		138,
		131,
		129,
		130,
		112,
		144,
		-1,
		145,
		139,
		147,
		137,
		125,
		-1,
		-1,
		-1,
		238,
		217,
		210,
		230,
		171,
		223,
		-1,
		-1,
		174,
		167,
		-1,
		154,
		136,
		143,
		141,
		135,
		139,
		136,
		125,
		138,
		131,
		117,
		119,
		132,
		136,
		140,
		127,
		123,
		120,
		134,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		191,
		-1,
		183,
		175,
		165,
		159,
		153,
		149,
		147,
		163,
		147,
		150,
		148,
		139,
		147,
		120,
		113,
		120,
		109,
		127,
		135,
		127,
		121,
		120,
		130,
		-1,
		258,
		244,
		215,
		-1,
		-1,
		204,
		-1,
		168,
		182,
		198,
		-1,
		191,
		170,
		185,
		163,
		159,
		155,
		170,
		171,
		149,
		148,
		146,
		137,
		125,
		114,
		117,
		109,
		131,
		131,
		115,
		116,
		120,
		-1,
		264,
		251,
		209,
		205,
		194,
		214,
		165,
		153,
		185,
		-1,
		-1,
		227,
		-1,
		161,
		178,
		169,
		167,
		160,
		151,
		157,
		157,
		134,
		129,
		119,
		108,
		108,
		103,
		125,
		111,
		109,
		118,
		129,
		-1,
		-1,
		-1,
		231,
		-1,
		-1,
		180,
		167,
		161,
		-1,
		202,
		-1,
		205,
		195,
		179,
		164,
		197,
		-1,
		158,
		152,
		157,
		-1,
		154,
		-1,
		127,
		124,
		115,
		100,
		97,
		108,
		106,
		117,
		113,
		-1,
		214,
		199,
		192,
		182,
		196,
		167,
		-1,
		222,
		-1,
		-1,
		192,
		186,
		186,
		170,
		173,
		174,
		154,
		146,
		157,
		149,
		141,
		135,
		113,
		106,
		103,
		96,
		109,
		119,
		124,
		111,
		-1,
		-1,
		-1,
		219,
		205,
		209,
		169,
		188,
		-1,
		-1,
		254,
		209,
		195,
		-1,
		179,
		174,
		162,
		152,
		142,
		147,
		148,
		132,
		125,
		111,
		113,
		107,
		98,
		97,
		113,
		105,
		127,
		-1,
		-1,
		202,
		207,
		195,
		181,
		200,
		-1,
		-1,
		-1,
		201,
		217,
		202,
		180,
		163,
		-1,
		-1,
		146,
		139,
		133,
		128,
		115,
		127,
		122,
		106,
		91,
		106,
		110,
		118,
		109,
		-1,
		205,
		192,
		-1,
		-1,
		203,
		197,
		-1,
		-1,
		-1,
		-1,
		214,
		159,
		148,
		143,
		147,
		145,
		-1,
		119,
		130,
		119,
		131,
		138,
		108,
		93,
		87,
		93,
		105,
		114,
		-1,
		-1,
		217,
		-1,
		207,
		-1,
		-1,
		-1,
		-1,
		171,
		165,
		136,
		129,
		133,
		-1,
		121,
		123,
		120,
		132,
		111,
		108,
		99,
		90,
		86,
		90,
		94,
		101,
		107,
		240,
		-1,
		198,
		-1,
		-1,
		-1,
		189,
		204,
		175,
		152,
		125,
		120,
		113,
		107,
		112,
		123,
		119,
		130,
		97,
		93,
		83,
		82,
		86,
		103,
		103,
		-1,
		-1,
		196,
		192,
		215,
		197,
		201,
		202,
		-1,
		-1,
		129,
		120,
		111,
		103,
		116,
		119,
		103,
		100,
		94,
		87,
		81,
		91,
		102,
		97,
		-1,
		-1,
		-1,
		208,
		-1,
		210,
		-1,
		-1,
		198,
		200,
		147,
		129,
		125,
		123,
		112,
		106,
		94,
		99,
		104,
		95,
		89,
		77,
		77,
		100,
		89,
		95,
		-1,
		-1,
		280,
		-1,
		-1,
		-1,
		187,
		179,
		174,
		180,
		182,
		173,
		162,
		159,
		-1,
		129,
		135,
		100,
		107,
		90,
		97,
		99,
		91,
		71,
		74,
		90,
		89,
		82,
		87,
		78,
		86,
		-1,
		-1,
		273,
		262,
		251,
		257,
		-1,
		180,
		176,
		166,
		156,
		159,
		-1,
		-1,
		153,
		150,
		130,
		99,
		98,
		91,
		86,
		96,
		72,
		67,
		67,
		62,
		77,
		82,
		79,
		72,
		77,
		92,
		-1,
		227,
		264,
		257,
		225,
		233,
		264,
		-1,
		170,
		162,
		173,
		148,
		150,
		-1,
		-1,
		126,
		117,
		118,
		106,
		103,
		110,
		105,
		82,
		76,
		82,
		60,
		67,
		78,
		70,
		74,
		75,
		64,
		77,
		81,
		-1,
		220,
		240,
		219,
		222,
		246,
		260,
		-1,
		167,
		-1,
		-1,
		149,
		151,
		135,
		125,
		122,
		165,
		112,
		107,
		84,
		82,
		79,
		70,
		84,
		68,
		56,
		53,
		62,
		67,
		59,
		74,
		70,
		63,
		-1,
		209,
		220,
		213,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		139,
		-1,
		162,
		-1,
		145,
		149,
		120,
		123,
		98,
		85,
		71,
		71,
		77,
		68,
		64,
		60,
		49,
		51,
		63,
		67,
		77,
		79,
		234,
		190,
		193,
		204,
		215,
		230,
		234,
		-1,
		179,
		218,
		145,
		-1,
		129,
		-1,
		-1,
		-1,
		159,
		133,
		125,
		118,
		97,
		97,
		63,
		59,
		72,
		69,
		75,
		66,
		51,
		50,
		61,
		72,
		71,
		230,
		221,
		234,
		179,
		179,
		200,
		209,
		230,
		194,
		185,
		212,
		152,
		141,
		136,
		123,
		-1,
		-1,
		140,
		143,
		-1,
		-1,
		104,
		80,
		67,
		61,
		65,
		79,
		75,
		63,
		43,
		49,
		43,
		67,
		-1,
		223,
		222,
		211,
		208,
		184,
		175,
		170,
		197,
		-1,
		-1,
		192,
		213,
		203,
		185,
		183,
		208,
		-1,
		112,
		-1,
		-1,
		120,
		-1,
		-1,
		105,
		85,
		74,
		65,
		51,
		73,
		79,
		90,
		39,
		55,
		48,
		55,
		52,
		207,
		204,
		192,
		190,
		213,
		178,
		166,
		-1,
		179,
		177,
		183,
		190,
		186,
		197,
		-1,
		-1,
		128,
		108,
		-1,
		-1,
		103,
		101,
		90,
		-1,
		80,
		62,
		48,
		75,
		56,
		48,
		42,
		36,
		43,
		42,
		53,
		45,
		216,
		230,
		219,
		215,
		214,
		222,
		171,
		164,
		176,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		118,
		114,
		-1,
		-1,
		98,
		91,
		79,
		67,
		57,
		62,
		48,
		44,
		44,
		39,
		34,
		45,
		32,
		36,
		39,
		-1,
		250,
		-1,
		202,
		169,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		135,
		121,
		114,
		102,
		100,
		-1,
		132,
		116,
		97,
		-1,
		67,
		80,
		80,
		48,
		40,
		38,
		28,
		39,
		30,
		38,
		32,
		35,
		-1,
		-1,
		168,
		151,
		-1,
		-1,
		125,
		127,
		-1,
		126,
		115,
		100,
		92,
		-1,
		-1,
		104,
		100,
		-1,
		-1,
		58,
		62,
		51,
		46,
		42,
		24,
		36,
		32,
		28,
		38,
		29,
		-1,
		-1,
		146,
		138,
		132,
		-1,
		110,
		-1,
		128,
		-1,
		95,
		101,
		89,
		-1,
		-1,
		-1,
		89,
		52,
		68,
		69,
		38,
		36,
		27,
		20,
		27,
		30,
		23,
		29,
		-1,
		-1,
		-1,
		128,
		102,
		135,
		126,
		109,
		89,
		81,
		100,
		-1,
		70,
		-1,
		45,
		48,
		53,
		46,
		49,
		43,
		17,
		30,
		24,
		21,
		19,
		134,
		-1,
		104,
		137,
		101,
		95,
		71,
		75,
		91,
		-1,
		67,
		49,
		-1,
		60,
		47,
		60,
		44,
		26,
		13,
		7,
		8,
		16,
		-1,
		-1,
		-1,
		106,
		105,
		97,
		91,
		91,
		76,
		67,
		-1,
		79,
		61,
		40,
		55,
		40,
		31,
		31,
		50,
		46,
		29,
		27,
		1,
		-1,
		207,
		-1,
		-1,
		129,
		-1,
		-1,
		-1,
		100,
		95,
		68,
		56,
		62,
		58,
		44,
		50,
		50,
		43,
		33,
		30,
		26,
		17,
		23,
		0,
		36,
		-1,
		202,
		-1,
		136,
		-1,
		-1,
		118,
		98,
		90,
		79,
		68,
		66,
		57,
		48,
		70,
		74,
		24,
		12,
		7,
		8,
		-1,
		191,
		190,
		-1,
		137,
		129,
		115,
		-1,
		108,
		-1,
		114,
		75,
		-1,
		77,
		57,
		-1,
		23,
		12,
		-1,
		-1,
		178,
		153,
		-1,
		-1,
		-1,
		138,
		118,
		109,
		93,
		-1,
		68,
		68,
		-1,
		-1,
		-1,
		163,
		162,
		-1,
		131,
		134,
		-1,
		124,
		115,
		123,
		70,
		74,
		-1,
		-1,
		-1,
		172,
		153,
		147,
		146,
		144,
		139,
		136,
		122,
		106,
		84,
		73,
		94,
		-1,
		-1,
		-1,
		144,
		136,
		129,
		-1,
		-1,
		131,
		114,
		95,
		93,
		-1,
		-1,
		-1,
		166,
		147,
		-1,
		-1,
		121,
		-1,
		-1,
		127,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		155,
		-1,
		-1,
		-1,
		117,
		113,
		114,
		-1,
		-1,
		-1,
		-1,
		177,
		178,
		201,
		165,
		-1,
		-1,
		-1,
		109,
		103,
		-1,
		-1,
		180,
		178,
		-1,
		-1,
		-1,
		137,
		121,
		-1,
		107,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		142,
		-1,
		142,
		117,
		124,
		-1,
		-1,
		-1,
		-1,
		155,
		147,
		155,
		-1,
		127,
		129,
		-1,
		177,
		-1,
		-1,
		170,
		161,
		-1,
		-1,
		132,
		139,
		161,
		164,
		200,
		-1,
		151
	],
	[
		-1,
		276,
		265,
		276,
		284,
		257,
		264,
		-1,
		283,
		287,
		253,
		247,
		286,
		255,
		261,
		272,
		-1,
		-1,
		-1,
		276,
		275,
		243,
		241,
		250,
		255,
		262,
		-1,
		261,
		-1,
		297,
		276,
		287,
		292,
		236,
		233,
		253,
		272,
		254,
		246,
		312,
		266,
		237,
		231,
		249,
		239,
		248,
		240,
		-1,
		237,
		227,
		249,
		228,
		239,
		231,
		-1,
		-1,
		231,
		232,
		238,
		224,
		230,
		226,
		-1,
		236,
		220,
		-1,
		-1,
		221,
		222,
		206,
		209,
		217,
		215,
		228,
		220,
		215,
		-1,
		-1,
		212,
		208,
		215,
		202,
		198,
		215,
		228,
		210,
		224,
		223,
		-1,
		216,
		234,
		241,
		209,
		207,
		191,
		189,
		207,
		209,
		215,
		215,
		-1,
		225,
		226,
		221,
		229,
		231,
		207,
		194,
		194,
		204,
		197,
		216,
		204,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		225,
		208,
		225,
		217,
		207,
		222,
		215,
		197,
		194,
		192,
		189,
		205,
		203,
		213,
		-1,
		-1,
		318,
		287,
		316,
		274,
		255,
		-1,
		221,
		201,
		207,
		211,
		205,
		198,
		212,
		208,
		-1,
		183,
		182,
		210,
		196,
		207,
		278,
		-1,
		-1,
		276,
		268,
		251,
		254,
		231,
		227,
		216,
		215,
		207,
		193,
		189,
		195,
		198,
		198,
		204,
		177,
		187,
		191,
		189,
		214,
		-1,
		-1,
		249,
		-1,
		-1,
		275,
		258,
		-1,
		241,
		248,
		237,
		243,
		229,
		250,
		226,
		217,
		209,
		203,
		191,
		193,
		190,
		203,
		191,
		174,
		199,
		203,
		184,
		205,
		200,
		-1,
		248,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		234,
		237,
		243,
		267,
		266,
		-1,
		238,
		226,
		227,
		212,
		209,
		196,
		184,
		197,
		182,
		189,
		188,
		178,
		176,
		206,
		181,
		203,
		200,
		219,
		224,
		218,
		227,
		-1,
		283,
		279,
		275,
		282,
		231,
		-1,
		-1,
		271,
		-1,
		274,
		275,
		250,
		223,
		226,
		213,
		204,
		191,
		180,
		191,
		180,
		177,
		185,
		170,
		185,
		176,
		175,
		193,
		203,
		211,
		215,
		221,
		-1,
		333,
		-1,
		275,
		259,
		261,
		233,
		254,
		-1,
		291,
		275,
		267,
		252,
		252,
		-1,
		222,
		219,
		209,
		187,
		172,
		189,
		181,
		179,
		183,
		165,
		179,
		170,
		188,
		195,
		193,
		197,
		217,
		229,
		293,
		283,
		-1,
		265,
		270,
		229,
		237,
		256,
		294,
		258,
		-1,
		253,
		-1,
		224,
		237,
		-1,
		193,
		189,
		171,
		172,
		167,
		182,
		176,
		161,
		158,
		176,
		179,
		186,
		190,
		206,
		-1,
		-1,
		278,
		282,
		271,
		222,
		241,
		265,
		302,
		251,
		240,
		239,
		-1,
		230,
		207,
		204,
		192,
		179,
		164,
		165,
		173,
		186,
		165,
		160,
		157,
		177,
		203,
		181,
		193,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		248,
		219,
		243,
		285,
		269,
		262,
		250,
		215,
		215,
		209,
		-1,
		203,
		182,
		173,
		162,
		160,
		173,
		170,
		175,
		155,
		153,
		172,
		184,
		175,
		192,
		-1,
		-1,
		-1,
		278,
		267,
		268,
		214,
		237,
		274,
		248,
		234,
		239,
		214,
		207,
		201,
		216,
		199,
		180,
		169,
		161,
		150,
		166,
		174,
		169,
		151,
		160,
		166,
		190,
		180,
		186,
		-1,
		-1,
		285,
		275,
		259,
		261,
		258,
		228,
		235,
		267,
		239,
		252,
		-1,
		206,
		-1,
		195,
		190,
		174,
		169,
		166,
		163,
		157,
		166,
		168,
		158,
		153,
		160,
		195,
		195,
		170,
		190,
		193,
		-1,
		-1,
		-1,
		278,
		273,
		248,
		225,
		209,
		245,
		-1,
		222,
		223,
		-1,
		200,
		194,
		191,
		176,
		172,
		167,
		171,
		164,
		171,
		164,
		162,
		163,
		145,
		177,
		-1,
		178,
		172,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		271,
		250,
		243,
		263,
		204,
		256,
		-1,
		-1,
		207,
		200,
		-1,
		187,
		169,
		176,
		174,
		168,
		172,
		169,
		158,
		171,
		164,
		150,
		152,
		165,
		169,
		173,
		160,
		156,
		153,
		167,
		-1,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		224,
		-1,
		216,
		208,
		198,
		192,
		186,
		182,
		180,
		196,
		180,
		183,
		181,
		172,
		180,
		153,
		146,
		153,
		142,
		160,
		168,
		160,
		154,
		153,
		163,
		-1,
		291,
		277,
		248,
		-1,
		-1,
		237,
		-1,
		201,
		215,
		231,
		-1,
		224,
		203,
		218,
		196,
		192,
		188,
		203,
		204,
		182,
		181,
		179,
		170,
		158,
		147,
		150,
		142,
		164,
		164,
		148,
		149,
		153,
		-1,
		297,
		284,
		242,
		238,
		227,
		247,
		198,
		186,
		218,
		-1,
		-1,
		260,
		-1,
		194,
		211,
		202,
		200,
		193,
		184,
		190,
		190,
		167,
		162,
		152,
		141,
		141,
		136,
		158,
		144,
		142,
		151,
		162,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		213,
		200,
		194,
		-1,
		235,
		-1,
		238,
		228,
		212,
		197,
		230,
		-1,
		188,
		184,
		190,
		-1,
		187,
		-1,
		160,
		157,
		148,
		133,
		130,
		141,
		139,
		150,
		146,
		-1,
		247,
		232,
		225,
		215,
		229,
		200,
		-1,
		255,
		-1,
		-1,
		225,
		219,
		219,
		203,
		206,
		204,
		184,
		176,
		190,
		182,
		174,
		168,
		146,
		139,
		136,
		129,
		142,
		152,
		157,
		144,
		-1,
		-1,
		-1,
		252,
		238,
		242,
		202,
		221,
		-1,
		-1,
		287,
		242,
		228,
		-1,
		212,
		204,
		192,
		182,
		172,
		177,
		178,
		165,
		158,
		144,
		146,
		140,
		131,
		130,
		146,
		138,
		160,
		-1,
		-1,
		235,
		240,
		228,
		214,
		233,
		-1,
		-1,
		-1,
		234,
		250,
		232,
		211,
		193,
		-1,
		-1,
		176,
		169,
		163,
		161,
		148,
		160,
		155,
		139,
		124,
		139,
		143,
		151,
		142,
		-1,
		238,
		225,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		-1,
		-1,
		244,
		189,
		178,
		173,
		177,
		175,
		-1,
		149,
		160,
		152,
		164,
		171,
		141,
		126,
		120,
		126,
		138,
		147,
		-1,
		-1,
		250,
		-1,
		238,
		-1,
		-1,
		-1,
		-1,
		201,
		195,
		166,
		159,
		163,
		-1,
		151,
		153,
		150,
		162,
		144,
		141,
		132,
		123,
		119,
		123,
		127,
		134,
		140,
		273,
		-1,
		229,
		-1,
		-1,
		-1,
		219,
		234,
		205,
		182,
		155,
		150,
		143,
		137,
		142,
		153,
		152,
		163,
		130,
		126,
		116,
		115,
		119,
		136,
		136,
		-1,
		-1,
		227,
		223,
		245,
		227,
		231,
		232,
		-1,
		-1,
		159,
		150,
		141,
		133,
		146,
		149,
		134,
		133,
		127,
		120,
		114,
		124,
		135,
		130,
		-1,
		-1,
		-1,
		239,
		-1,
		241,
		-1,
		-1,
		229,
		230,
		177,
		159,
		155,
		153,
		142,
		136,
		124,
		129,
		137,
		128,
		122,
		110,
		110,
		133,
		122,
		128,
		-1,
		-1,
		311,
		-1,
		-1,
		-1,
		218,
		210,
		205,
		211,
		213,
		204,
		192,
		189,
		-1,
		159,
		165,
		130,
		137,
		120,
		127,
		132,
		124,
		104,
		107,
		123,
		122,
		115,
		120,
		111,
		119,
		-1,
		-1,
		304,
		293,
		282,
		288,
		-1,
		211,
		207,
		197,
		187,
		190,
		-1,
		-1,
		184,
		181,
		161,
		130,
		128,
		121,
		116,
		126,
		102,
		100,
		100,
		95,
		110,
		115,
		112,
		105,
		110,
		125,
		-1,
		258,
		295,
		288,
		256,
		264,
		295,
		-1,
		201,
		193,
		204,
		179,
		181,
		-1,
		-1,
		157,
		148,
		149,
		137,
		134,
		140,
		138,
		115,
		109,
		115,
		93,
		100,
		111,
		103,
		107,
		108,
		97,
		110,
		114,
		-1,
		251,
		271,
		250,
		253,
		277,
		291,
		-1,
		198,
		-1,
		-1,
		179,
		182,
		166,
		156,
		153,
		196,
		145,
		140,
		117,
		115,
		112,
		103,
		117,
		101,
		89,
		86,
		95,
		100,
		92,
		107,
		103,
		96,
		-1,
		240,
		251,
		244,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		169,
		-1,
		193,
		-1,
		176,
		180,
		153,
		156,
		131,
		118,
		104,
		104,
		110,
		101,
		97,
		93,
		82,
		84,
		96,
		100,
		110,
		112,
		265,
		221,
		224,
		235,
		246,
		261,
		265,
		-1,
		210,
		249,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		190,
		166,
		158,
		151,
		130,
		130,
		96,
		92,
		105,
		102,
		108,
		99,
		84,
		83,
		94,
		105,
		104,
		261,
		252,
		265,
		210,
		210,
		231,
		240,
		261,
		225,
		216,
		243,
		182,
		171,
		166,
		153,
		-1,
		-1,
		173,
		176,
		-1,
		-1,
		137,
		113,
		100,
		94,
		98,
		112,
		108,
		96,
		76,
		82,
		76,
		100,
		-1,
		254,
		253,
		242,
		239,
		215,
		206,
		201,
		228,
		-1,
		-1,
		223,
		244,
		234,
		215,
		213,
		238,
		-1,
		142,
		-1,
		-1,
		153,
		-1,
		-1,
		138,
		118,
		107,
		98,
		84,
		106,
		112,
		123,
		72,
		88,
		81,
		88,
		85,
		238,
		235,
		223,
		221,
		244,
		209,
		197,
		-1,
		210,
		208,
		214,
		221,
		216,
		227,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		136,
		134,
		123,
		-1,
		113,
		95,
		81,
		108,
		89,
		81,
		75,
		69,
		76,
		75,
		86,
		78,
		247,
		261,
		250,
		246,
		245,
		253,
		202,
		195,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		131,
		124,
		112,
		100,
		90,
		95,
		81,
		77,
		77,
		72,
		67,
		78,
		65,
		69,
		72,
		-1,
		281,
		-1,
		233,
		199,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		165,
		149,
		130,
		-1,
		100,
		113,
		113,
		81,
		73,
		71,
		61,
		72,
		63,
		71,
		65,
		68,
		-1,
		-1,
		198,
		181,
		-1,
		-1,
		155,
		157,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		137,
		133,
		-1,
		-1,
		88,
		95,
		84,
		79,
		75,
		57,
		69,
		65,
		61,
		71,
		62,
		-1,
		-1,
		176,
		168,
		162,
		-1,
		140,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		119,
		82,
		98,
		101,
		71,
		69,
		60,
		53,
		60,
		63,
		56,
		62,
		-1,
		-1,
		-1,
		158,
		132,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		100,
		-1,
		75,
		78,
		83,
		79,
		82,
		76,
		50,
		63,
		57,
		54,
		52,
		164,
		-1,
		134,
		167,
		131,
		125,
		101,
		105,
		121,
		-1,
		97,
		79,
		-1,
		90,
		77,
		93,
		74,
		59,
		46,
		40,
		41,
		49,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		106,
		97,
		-1,
		109,
		91,
		70,
		85,
		70,
		61,
		61,
		83,
		79,
		62,
		60,
		34,
		-1,
		237,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		125,
		98,
		86,
		92,
		88,
		74,
		80,
		80,
		73,
		63,
		60,
		56,
		47,
		51,
		33,
		0,
		-1,
		232,
		-1,
		166,
		-1,
		-1,
		148,
		128,
		120,
		109,
		98,
		96,
		87,
		78,
		100,
		104,
		54,
		42,
		37,
		36,
		-1,
		221,
		220,
		-1,
		167,
		159,
		145,
		-1,
		138,
		-1,
		144,
		105,
		-1,
		107,
		87,
		-1,
		53,
		42,
		-1,
		-1,
		208,
		183,
		-1,
		-1,
		-1,
		168,
		148,
		139,
		123,
		-1,
		98,
		98,
		-1,
		-1,
		-1,
		193,
		192,
		-1,
		161,
		164,
		-1,
		154,
		145,
		153,
		100,
		104,
		-1,
		-1,
		-1,
		202,
		183,
		177,
		176,
		174,
		169,
		166,
		152,
		136,
		114,
		103,
		124,
		-1,
		-1,
		-1,
		174,
		166,
		159,
		-1,
		-1,
		161,
		144,
		125,
		123,
		-1,
		-1,
		-1,
		196,
		177,
		-1,
		-1,
		151,
		-1,
		-1,
		157,
		122,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		185,
		-1,
		-1,
		-1,
		147,
		143,
		144,
		-1,
		-1,
		-1,
		-1,
		207,
		208,
		231,
		195,
		-1,
		-1,
		-1,
		139,
		133,
		-1,
		-1,
		210,
		208,
		-1,
		-1,
		-1,
		167,
		151,
		-1,
		137,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		172,
		-1,
		172,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		185,
		177,
		185,
		-1,
		157,
		159,
		-1,
		207,
		-1,
		-1,
		200,
		191,
		-1,
		-1,
		162,
		169,
		191,
		194,
		230,
		-1,
		181
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		383,
		372,
		383,
		391,
		364,
		371,
		-1,
		390,
		394,
		360,
		354,
		393,
		362,
		368,
		379,
		-1,
		-1,
		-1,
		383,
		382,
		350,
		348,
		357,
		362,
		369,
		-1,
		368,
		-1,
		404,
		383,
		394,
		399,
		343,
		340,
		360,
		379,
		361,
		353,
		419,
		373,
		344,
		338,
		356,
		346,
		355,
		347,
		-1,
		344,
		334,
		356,
		335,
		346,
		338,
		-1,
		-1,
		338,
		339,
		345,
		331,
		337,
		333,
		-1,
		343,
		327,
		-1,
		-1,
		328,
		329,
		313,
		316,
		324,
		322,
		335,
		327,
		322,
		-1,
		-1,
		319,
		315,
		322,
		309,
		305,
		322,
		335,
		317,
		331,
		330,
		-1,
		323,
		341,
		348,
		316,
		314,
		298,
		296,
		314,
		316,
		322,
		322,
		-1,
		332,
		333,
		328,
		336,
		338,
		314,
		301,
		301,
		311,
		304,
		323,
		311,
		357,
		-1,
		-1,
		-1,
		-1,
		-1,
		366,
		332,
		315,
		332,
		324,
		314,
		329,
		322,
		304,
		301,
		299,
		296,
		312,
		310,
		320,
		-1,
		-1,
		425,
		394,
		423,
		381,
		362,
		-1,
		328,
		308,
		314,
		318,
		312,
		305,
		319,
		315,
		-1,
		290,
		289,
		317,
		303,
		314,
		385,
		-1,
		-1,
		383,
		375,
		358,
		361,
		338,
		334,
		323,
		322,
		314,
		300,
		296,
		302,
		305,
		305,
		311,
		284,
		294,
		298,
		296,
		321,
		-1,
		-1,
		356,
		-1,
		-1,
		382,
		365,
		-1,
		348,
		355,
		344,
		350,
		336,
		357,
		333,
		324,
		316,
		310,
		298,
		300,
		297,
		310,
		298,
		281,
		306,
		310,
		291,
		312,
		307,
		-1,
		355,
		339,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		360,
		341,
		344,
		350,
		374,
		373,
		-1,
		345,
		333,
		334,
		319,
		316,
		303,
		291,
		304,
		289,
		296,
		295,
		285,
		283,
		313,
		288,
		310,
		307,
		326,
		331,
		325,
		334,
		-1,
		390,
		386,
		382,
		389,
		338,
		-1,
		-1,
		378,
		-1,
		381,
		382,
		357,
		330,
		333,
		320,
		311,
		298,
		287,
		298,
		287,
		284,
		292,
		277,
		292,
		283,
		282,
		300,
		310,
		318,
		322,
		328,
		-1,
		440,
		-1,
		382,
		366,
		368,
		340,
		361,
		-1,
		398,
		382,
		374,
		359,
		359,
		-1,
		329,
		326,
		316,
		294,
		279,
		296,
		288,
		286,
		290,
		272,
		286,
		277,
		295,
		302,
		300,
		304,
		324,
		336,
		400,
		390,
		-1,
		372,
		377,
		336,
		344,
		363,
		401,
		365,
		-1,
		360,
		-1,
		331,
		344,
		-1,
		300,
		296,
		278,
		279,
		274,
		289,
		283,
		268,
		265,
		283,
		286,
		293,
		297,
		313,
		-1,
		-1,
		385,
		389,
		378,
		329,
		348,
		372,
		409,
		358,
		347,
		346,
		-1,
		337,
		314,
		311,
		299,
		286,
		271,
		272,
		280,
		293,
		272,
		267,
		264,
		284,
		310,
		288,
		300,
		-1,
		-1,
		-1,
		410,
		-1,
		-1,
		355,
		326,
		350,
		392,
		376,
		369,
		357,
		322,
		322,
		316,
		-1,
		310,
		289,
		280,
		269,
		267,
		280,
		277,
		282,
		262,
		260,
		279,
		291,
		282,
		299,
		-1,
		-1,
		-1,
		385,
		374,
		375,
		321,
		344,
		381,
		355,
		341,
		346,
		321,
		314,
		308,
		323,
		306,
		287,
		276,
		268,
		257,
		273,
		281,
		276,
		258,
		267,
		273,
		297,
		287,
		293,
		-1,
		-1,
		392,
		382,
		366,
		368,
		365,
		335,
		342,
		374,
		346,
		359,
		-1,
		313,
		-1,
		302,
		297,
		281,
		276,
		273,
		270,
		264,
		273,
		275,
		265,
		260,
		267,
		302,
		302,
		277,
		297,
		300,
		-1,
		-1,
		-1,
		385,
		380,
		355,
		332,
		316,
		352,
		-1,
		329,
		330,
		-1,
		307,
		301,
		298,
		283,
		279,
		274,
		278,
		271,
		278,
		271,
		269,
		270,
		252,
		284,
		-1,
		285,
		279,
		287,
		277,
		265,
		-1,
		-1,
		-1,
		378,
		357,
		350,
		370,
		311,
		363,
		-1,
		-1,
		314,
		307,
		-1,
		294,
		276,
		283,
		281,
		275,
		279,
		276,
		265,
		278,
		271,
		257,
		259,
		272,
		276,
		280,
		267,
		263,
		260,
		274,
		-1,
		397,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		331,
		-1,
		323,
		315,
		305,
		299,
		293,
		289,
		287,
		303,
		287,
		290,
		288,
		279,
		287,
		260,
		253,
		260,
		249,
		267,
		275,
		267,
		261,
		260,
		270,
		-1,
		398,
		384,
		355,
		-1,
		-1,
		344,
		-1,
		308,
		322,
		338,
		-1,
		331,
		310,
		325,
		303,
		299,
		295,
		310,
		311,
		288,
		288,
		286,
		277,
		265,
		254,
		257,
		249,
		271,
		271,
		255,
		256,
		260,
		-1,
		404,
		391,
		349,
		345,
		334,
		354,
		305,
		293,
		325,
		-1,
		-1,
		367,
		-1,
		301,
		318,
		309,
		307,
		300,
		282,
		289,
		297,
		274,
		269,
		259,
		248,
		248,
		243,
		265,
		251,
		249,
		258,
		274,
		-1,
		-1,
		-1,
		371,
		-1,
		-1,
		320,
		307,
		301,
		-1,
		342,
		-1,
		345,
		335,
		319,
		304,
		337,
		-1,
		281,
		277,
		284,
		-1,
		294,
		-1,
		267,
		264,
		255,
		240,
		237,
		248,
		246,
		257,
		253,
		-1,
		354,
		339,
		332,
		322,
		336,
		307,
		-1,
		362,
		-1,
		-1,
		332,
		326,
		326,
		310,
		311,
		297,
		277,
		269,
		284,
		283,
		270,
		269,
		253,
		246,
		243,
		236,
		249,
		259,
		264,
		251,
		-1,
		-1,
		-1,
		359,
		338,
		346,
		309,
		328,
		-1,
		-1,
		394,
		349,
		335,
		-1,
		306,
		297,
		285,
		275,
		265,
		270,
		271,
		261,
		259,
		251,
		253,
		247,
		238,
		237,
		253,
		245,
		267,
		-1,
		-1,
		335,
		347,
		335,
		321,
		329,
		-1,
		-1,
		-1,
		341,
		357,
		325,
		304,
		286,
		-1,
		-1,
		269,
		262,
		256,
		259,
		247,
		267,
		262,
		246,
		231,
		246,
		250,
		258,
		249,
		-1,
		338,
		325,
		-1,
		-1,
		328,
		318,
		-1,
		-1,
		-1,
		-1,
		337,
		282,
		271,
		266,
		270,
		268,
		-1,
		242,
		253,
		246,
		265,
		272,
		248,
		233,
		227,
		233,
		245,
		254,
		-1,
		-1,
		342,
		-1,
		304,
		-1,
		-1,
		-1,
		-1,
		294,
		288,
		259,
		252,
		256,
		-1,
		244,
		246,
		243,
		255,
		251,
		248,
		239,
		230,
		226,
		230,
		234,
		248,
		252,
		365,
		-1,
		295,
		-1,
		-1,
		-1,
		312,
		327,
		298,
		275,
		248,
		243,
		236,
		230,
		235,
		246,
		255,
		266,
		231,
		233,
		223,
		222,
		226,
		243,
		247,
		-1,
		-1,
		293,
		289,
		324,
		320,
		308,
		325,
		-1,
		-1,
		252,
		243,
		234,
		226,
		239,
		242,
		227,
		229,
		229,
		227,
		221,
		231,
		246,
		241,
		-1,
		-1,
		-1,
		291,
		-1,
		307,
		-1,
		-1,
		298,
		323,
		270,
		252,
		248,
		246,
		235,
		229,
		217,
		222,
		232,
		226,
		223,
		217,
		221,
		244,
		233,
		272,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		257,
		276,
		271,
		277,
		282,
		273,
		285,
		282,
		-1,
		247,
		258,
		223,
		230,
		213,
		220,
		225,
		222,
		211,
		218,
		234,
		233,
		228,
		264,
		255,
		261,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		250,
		273,
		263,
		253,
		259,
		-1,
		-1,
		265,
		262,
		254,
		223,
		221,
		214,
		209,
		219,
		195,
		207,
		211,
		215,
		221,
		226,
		231,
		237,
		252,
		267,
		-1,
		238,
		275,
		268,
		236,
		244,
		275,
		-1,
		240,
		232,
		260,
		245,
		253,
		-1,
		-1,
		238,
		229,
		234,
		230,
		227,
		233,
		232,
		215,
		221,
		222,
		214,
		213,
		231,
		235,
		244,
		251,
		241,
		254,
		258,
		-1,
		231,
		251,
		230,
		233,
		257,
		271,
		-1,
		231,
		-1,
		-1,
		240,
		263,
		247,
		237,
		234,
		281,
		244,
		239,
		220,
		218,
		213,
		204,
		229,
		222,
		222,
		225,
		240,
		245,
		237,
		251,
		251,
		252,
		-1,
		220,
		231,
		224,
		-1,
		-1,
		-1,
		-1,
		225,
		-1,
		-1,
		230,
		-1,
		274,
		-1,
		257,
		261,
		252,
		255,
		234,
		221,
		207,
		215,
		221,
		220,
		226,
		226,
		227,
		236,
		247,
		259,
		258,
		259,
		191,
		201,
		204,
		215,
		226,
		241,
		245,
		-1,
		215,
		251,
		236,
		-1,
		220,
		-1,
		-1,
		-1,
		271,
		265,
		257,
		254,
		233,
		233,
		199,
		203,
		216,
		223,
		233,
		244,
		236,
		240,
		253,
		264,
		267,
		187,
		192,
		245,
		190,
		190,
		211,
		220,
		241,
		211,
		208,
		245,
		243,
		232,
		227,
		214,
		-1,
		-1,
		267,
		275,
		-1,
		-1,
		240,
		207,
		195,
		205,
		209,
		223,
		235,
		248,
		236,
		241,
		235,
		267,
		-1,
		187,
		182,
		169,
		164,
		158,
		170,
		181,
		208,
		-1,
		-1,
		209,
		236,
		220,
		224,
		240,
		265,
		-1,
		198,
		-1,
		-1,
		247,
		-1,
		-1,
		232,
		212,
		201,
		192,
		197,
		217,
		228,
		250,
		232,
		249,
		240,
		250,
		254,
		171,
		164,
		152,
		154,
		160,
		189,
		177,
		-1,
		196,
		194,
		200,
		207,
		224,
		254,
		-1,
		-1,
		214,
		194,
		-1,
		-1,
		230,
		228,
		217,
		-1,
		207,
		189,
		194,
		224,
		226,
		228,
		235,
		229,
		236,
		244,
		255,
		247,
		180,
		190,
		179,
		152,
		161,
		174,
		182,
		181,
		193,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		-1,
		204,
		200,
		-1,
		-1,
		225,
		218,
		206,
		194,
		184,
		194,
		211,
		211,
		214,
		219,
		227,
		238,
		234,
		238,
		241,
		-1,
		189,
		-1,
		213,
		195,
		204,
		219,
		227,
		-1,
		-1,
		-1,
		221,
		207,
		200,
		188,
		186,
		-1,
		259,
		243,
		224,
		-1,
		194,
		207,
		247,
		215,
		220,
		215,
		230,
		241,
		232,
		240,
		234,
		237,
		-1,
		-1,
		197,
		180,
		-1,
		-1,
		154,
		156,
		-1,
		212,
		201,
		186,
		178,
		-1,
		-1,
		231,
		227,
		-1,
		-1,
		181,
		219,
		218,
		226,
		221,
		226,
		238,
		234,
		230,
		240,
		231,
		-1,
		-1,
		175,
		167,
		161,
		-1,
		139,
		-1,
		214,
		-1,
		181,
		190,
		178,
		-1,
		-1,
		-1,
		212,
		175,
		191,
		214,
		240,
		238,
		229,
		222,
		229,
		232,
		225,
		231,
		-1,
		-1,
		-1,
		114,
		134,
		221,
		212,
		195,
		175,
		167,
		189,
		-1,
		193,
		-1,
		168,
		171,
		196,
		235,
		237,
		223,
		219,
		232,
		226,
		223,
		221,
		108,
		-1,
		138,
		190,
		154,
		181,
		147,
		161,
		207,
		-1,
		190,
		172,
		-1,
		200,
		190,
		238,
		213,
		222,
		215,
		209,
		210,
		218,
		-1,
		-1,
		-1,
		153,
		152,
		150,
		144,
		144,
		142,
		159,
		-1,
		195,
		177,
		163,
		180,
		180,
		171,
		179,
		228,
		224,
		227,
		225,
		203,
		-1,
		6,
		-1,
		-1,
		176,
		-1,
		-1,
		-1,
		153,
		137,
		150,
		161,
		164,
		160,
		160,
		162,
		175,
		183,
		181,
		178,
		190,
		186,
		206,
		202,
		234,
		-1,
		0,
		-1,
		183,
		-1,
		-1,
		115,
		121,
		131,
		142,
		170,
		170,
		159,
		155,
		172,
		207,
		193,
		191,
		196,
		201,
		-1,
		10,
		11,
		-1,
		79,
		89,
		110,
		-1,
		112,
		-1,
		216,
		177,
		-1,
		156,
		150,
		-1,
		202,
		198,
		-1,
		-1,
		22,
		68,
		-1,
		-1,
		-1,
		111,
		120,
		211,
		195,
		-1,
		140,
		147,
		-1,
		-1,
		-1,
		36,
		59,
		-1,
		104,
		107,
		-1,
		121,
		127,
		155,
		135,
		141,
		-1,
		-1,
		-1,
		63,
		47,
		52,
		94,
		89,
		112,
		152,
		138,
		138,
		122,
		132,
		161,
		-1,
		-1,
		-1,
		66,
		63,
		74,
		-1,
		-1,
		163,
		146,
		133,
		131,
		-1,
		-1,
		-1,
		88,
		69,
		-1,
		-1,
		83,
		-1,
		-1,
		128,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		106,
		77,
		-1,
		-1,
		-1,
		84,
		91,
		112,
		-1,
		-1,
		-1,
		-1,
		103,
		104,
		123,
		98,
		-1,
		-1,
		-1,
		98,
		101,
		-1,
		-1,
		106,
		104,
		-1,
		-1,
		-1,
		126,
		110,
		-1,
		112,
		-1,
		-1,
		-1,
		117,
		-1,
		-1,
		145,
		-1,
		-1,
		-1,
		131,
		-1,
		147,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		144,
		136,
		160,
		-1,
		132,
		134,
		-1,
		182,
		-1,
		-1,
		159,
		150,
		-1,
		-1,
		137,
		144,
		166,
		169,
		189,
		-1,
		156
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		325,
		314,
		325,
		333,
		306,
		313,
		-1,
		332,
		336,
		302,
		296,
		335,
		304,
		310,
		321,
		-1,
		-1,
		-1,
		325,
		324,
		292,
		290,
		299,
		304,
		311,
		-1,
		310,
		-1,
		346,
		325,
		336,
		341,
		285,
		282,
		302,
		321,
		303,
		295,
		361,
		315,
		286,
		280,
		298,
		288,
		297,
		289,
		-1,
		286,
		276,
		298,
		277,
		288,
		280,
		-1,
		-1,
		280,
		281,
		287,
		273,
		279,
		275,
		-1,
		285,
		269,
		-1,
		-1,
		270,
		271,
		255,
		258,
		266,
		264,
		277,
		269,
		264,
		-1,
		-1,
		261,
		257,
		264,
		251,
		247,
		264,
		277,
		259,
		273,
		272,
		-1,
		265,
		283,
		290,
		258,
		256,
		240,
		238,
		256,
		258,
		264,
		264,
		-1,
		274,
		275,
		270,
		278,
		280,
		256,
		243,
		243,
		253,
		246,
		265,
		253,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		308,
		274,
		257,
		274,
		266,
		256,
		271,
		264,
		246,
		243,
		241,
		238,
		254,
		252,
		262,
		-1,
		-1,
		367,
		336,
		365,
		323,
		304,
		-1,
		270,
		250,
		256,
		260,
		254,
		247,
		261,
		257,
		-1,
		232,
		231,
		259,
		245,
		256,
		327,
		-1,
		-1,
		325,
		317,
		300,
		303,
		280,
		276,
		265,
		264,
		256,
		242,
		238,
		244,
		247,
		247,
		253,
		226,
		236,
		240,
		238,
		263,
		-1,
		-1,
		298,
		-1,
		-1,
		324,
		307,
		-1,
		290,
		297,
		286,
		292,
		278,
		299,
		275,
		266,
		258,
		252,
		240,
		242,
		239,
		252,
		240,
		223,
		248,
		252,
		233,
		254,
		249,
		-1,
		297,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		283,
		286,
		292,
		316,
		315,
		-1,
		287,
		275,
		276,
		261,
		258,
		245,
		233,
		246,
		231,
		238,
		237,
		227,
		225,
		255,
		230,
		252,
		249,
		268,
		273,
		267,
		276,
		-1,
		332,
		328,
		324,
		331,
		280,
		-1,
		-1,
		320,
		-1,
		323,
		324,
		299,
		272,
		275,
		262,
		253,
		240,
		229,
		240,
		229,
		226,
		234,
		219,
		234,
		225,
		224,
		242,
		252,
		260,
		264,
		270,
		-1,
		382,
		-1,
		324,
		308,
		310,
		282,
		303,
		-1,
		340,
		324,
		316,
		301,
		301,
		-1,
		271,
		268,
		258,
		236,
		221,
		238,
		230,
		228,
		232,
		214,
		228,
		219,
		237,
		244,
		242,
		246,
		266,
		278,
		342,
		332,
		-1,
		314,
		319,
		278,
		286,
		305,
		343,
		307,
		-1,
		302,
		-1,
		273,
		286,
		-1,
		242,
		238,
		220,
		221,
		216,
		231,
		225,
		210,
		207,
		225,
		228,
		235,
		239,
		255,
		-1,
		-1,
		327,
		331,
		320,
		271,
		290,
		314,
		351,
		300,
		289,
		288,
		-1,
		279,
		256,
		253,
		241,
		228,
		213,
		214,
		222,
		235,
		214,
		209,
		206,
		226,
		252,
		230,
		242,
		-1,
		-1,
		-1,
		352,
		-1,
		-1,
		297,
		268,
		292,
		334,
		318,
		311,
		299,
		264,
		264,
		258,
		-1,
		252,
		231,
		222,
		211,
		209,
		222,
		219,
		224,
		204,
		202,
		221,
		233,
		224,
		241,
		-1,
		-1,
		-1,
		327,
		316,
		317,
		263,
		286,
		323,
		297,
		283,
		288,
		263,
		256,
		250,
		265,
		248,
		229,
		218,
		210,
		199,
		215,
		223,
		218,
		200,
		209,
		215,
		239,
		229,
		235,
		-1,
		-1,
		334,
		324,
		308,
		310,
		307,
		277,
		284,
		316,
		288,
		301,
		-1,
		255,
		-1,
		244,
		239,
		223,
		218,
		215,
		212,
		206,
		215,
		217,
		207,
		202,
		209,
		244,
		244,
		219,
		239,
		242,
		-1,
		-1,
		-1,
		327,
		322,
		297,
		274,
		258,
		294,
		-1,
		271,
		272,
		-1,
		249,
		243,
		240,
		225,
		221,
		216,
		220,
		213,
		220,
		213,
		211,
		212,
		194,
		226,
		-1,
		227,
		221,
		229,
		219,
		207,
		-1,
		-1,
		-1,
		320,
		299,
		292,
		312,
		253,
		305,
		-1,
		-1,
		256,
		249,
		-1,
		236,
		218,
		225,
		223,
		217,
		221,
		218,
		207,
		220,
		213,
		199,
		201,
		214,
		218,
		222,
		209,
		205,
		202,
		216,
		-1,
		339,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		273,
		-1,
		265,
		257,
		247,
		241,
		235,
		231,
		229,
		245,
		229,
		232,
		230,
		221,
		229,
		202,
		195,
		202,
		191,
		209,
		217,
		209,
		203,
		202,
		212,
		-1,
		340,
		326,
		297,
		-1,
		-1,
		286,
		-1,
		250,
		264,
		280,
		-1,
		273,
		252,
		267,
		245,
		241,
		237,
		252,
		253,
		230,
		230,
		228,
		219,
		207,
		196,
		199,
		191,
		213,
		213,
		197,
		198,
		202,
		-1,
		346,
		333,
		291,
		287,
		276,
		296,
		247,
		235,
		267,
		-1,
		-1,
		309,
		-1,
		243,
		260,
		251,
		249,
		242,
		224,
		231,
		239,
		216,
		211,
		201,
		190,
		190,
		185,
		207,
		193,
		191,
		200,
		216,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		262,
		249,
		243,
		-1,
		284,
		-1,
		287,
		277,
		261,
		246,
		279,
		-1,
		223,
		219,
		226,
		-1,
		236,
		-1,
		209,
		206,
		197,
		182,
		179,
		190,
		188,
		199,
		195,
		-1,
		296,
		281,
		274,
		264,
		278,
		249,
		-1,
		304,
		-1,
		-1,
		274,
		268,
		268,
		252,
		253,
		239,
		219,
		211,
		226,
		225,
		212,
		211,
		195,
		188,
		185,
		178,
		191,
		201,
		206,
		193,
		-1,
		-1,
		-1,
		301,
		267,
		275,
		251,
		270,
		-1,
		-1,
		336,
		291,
		277,
		-1,
		248,
		239,
		227,
		217,
		207,
		212,
		213,
		203,
		201,
		193,
		195,
		189,
		180,
		179,
		195,
		187,
		209,
		-1,
		-1,
		264,
		277,
		277,
		257,
		252,
		-1,
		-1,
		-1,
		283,
		299,
		267,
		246,
		228,
		-1,
		-1,
		211,
		204,
		198,
		201,
		189,
		209,
		204,
		188,
		173,
		188,
		192,
		200,
		191,
		-1,
		267,
		254,
		-1,
		-1,
		251,
		241,
		-1,
		-1,
		-1,
		-1,
		279,
		224,
		213,
		208,
		212,
		210,
		-1,
		184,
		195,
		188,
		207,
		214,
		190,
		175,
		169,
		175,
		187,
		196,
		-1,
		-1,
		265,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		236,
		230,
		201,
		194,
		198,
		-1,
		186,
		188,
		185,
		197,
		193,
		190,
		181,
		172,
		168,
		172,
		176,
		190,
		194,
		288,
		-1,
		218,
		-1,
		-1,
		-1,
		254,
		258,
		240,
		217,
		190,
		185,
		178,
		172,
		177,
		188,
		197,
		208,
		173,
		175,
		165,
		164,
		168,
		185,
		189,
		-1,
		-1,
		216,
		212,
		247,
		259,
		231,
		267,
		-1,
		-1,
		189,
		182,
		176,
		168,
		181,
		184,
		169,
		171,
		171,
		169,
		163,
		173,
		188,
		183,
		-1,
		-1,
		-1,
		214,
		-1,
		230,
		-1,
		-1,
		221,
		262,
		209,
		191,
		187,
		173,
		177,
		171,
		159,
		164,
		174,
		168,
		165,
		159,
		163,
		186,
		175,
		214,
		-1,
		-1,
		220,
		-1,
		-1,
		-1,
		180,
		199,
		194,
		200,
		205,
		196,
		224,
		221,
		-1,
		170,
		200,
		165,
		172,
		155,
		162,
		167,
		164,
		153,
		160,
		176,
		175,
		170,
		206,
		197,
		203,
		-1,
		-1,
		213,
		202,
		191,
		197,
		-1,
		173,
		196,
		186,
		176,
		182,
		-1,
		-1,
		188,
		185,
		183,
		163,
		163,
		156,
		151,
		161,
		137,
		149,
		153,
		157,
		163,
		168,
		173,
		179,
		194,
		209,
		-1,
		167,
		204,
		197,
		165,
		173,
		204,
		-1,
		163,
		155,
		183,
		168,
		176,
		-1,
		-1,
		161,
		152,
		157,
		166,
		167,
		175,
		174,
		157,
		163,
		164,
		156,
		155,
		173,
		177,
		186,
		193,
		183,
		196,
		200,
		-1,
		160,
		180,
		159,
		162,
		186,
		200,
		-1,
		154,
		-1,
		-1,
		166,
		186,
		170,
		160,
		157,
		204,
		180,
		175,
		162,
		160,
		155,
		146,
		171,
		164,
		164,
		167,
		182,
		187,
		179,
		193,
		193,
		194,
		-1,
		149,
		160,
		153,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		156,
		-1,
		197,
		-1,
		180,
		184,
		188,
		191,
		176,
		163,
		149,
		157,
		163,
		162,
		168,
		168,
		169,
		178,
		189,
		201,
		200,
		201,
		174,
		130,
		133,
		144,
		155,
		170,
		174,
		-1,
		138,
		174,
		162,
		-1,
		146,
		-1,
		-1,
		-1,
		194,
		201,
		193,
		196,
		175,
		175,
		141,
		145,
		158,
		165,
		175,
		186,
		178,
		182,
		195,
		206,
		209,
		170,
		161,
		174,
		119,
		119,
		140,
		149,
		170,
		134,
		131,
		168,
		169,
		158,
		153,
		140,
		-1,
		-1,
		209,
		211,
		-1,
		-1,
		182,
		149,
		137,
		147,
		151,
		165,
		177,
		190,
		178,
		183,
		177,
		209,
		-1,
		163,
		162,
		151,
		148,
		124,
		115,
		110,
		137,
		-1,
		-1,
		132,
		159,
		143,
		147,
		163,
		188,
		-1,
		124,
		-1,
		-1,
		189,
		-1,
		-1,
		174,
		154,
		143,
		134,
		139,
		159,
		170,
		192,
		174,
		191,
		182,
		192,
		196,
		147,
		144,
		132,
		130,
		153,
		118,
		106,
		-1,
		114,
		117,
		123,
		130,
		147,
		177,
		-1,
		-1,
		140,
		120,
		-1,
		-1,
		172,
		170,
		159,
		-1,
		149,
		131,
		136,
		166,
		168,
		170,
		177,
		171,
		178,
		186,
		197,
		189,
		156,
		170,
		159,
		155,
		154,
		162,
		111,
		104,
		111,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		-1,
		130,
		126,
		-1,
		-1,
		167,
		160,
		148,
		136,
		126,
		136,
		153,
		153,
		156,
		161,
		169,
		180,
		176,
		180,
		183,
		-1,
		190,
		-1,
		142,
		103,
		109,
		124,
		132,
		-1,
		-1,
		-1,
		147,
		133,
		126,
		114,
		112,
		-1,
		201,
		185,
		166,
		-1,
		136,
		149,
		189,
		157,
		162,
		157,
		172,
		183,
		174,
		182,
		176,
		179,
		-1,
		-1,
		102,
		85,
		-1,
		-1,
		59,
		61,
		-1,
		138,
		127,
		112,
		104,
		-1,
		-1,
		173,
		169,
		-1,
		-1,
		123,
		161,
		160,
		168,
		163,
		168,
		180,
		176,
		172,
		182,
		173,
		-1,
		-1,
		80,
		72,
		66,
		-1,
		44,
		-1,
		140,
		-1,
		107,
		114,
		102,
		-1,
		-1,
		-1,
		154,
		117,
		133,
		156,
		182,
		180,
		171,
		164,
		171,
		174,
		167,
		173,
		-1,
		-1,
		-1,
		62,
		36,
		147,
		138,
		121,
		101,
		93,
		113,
		-1,
		135,
		-1,
		110,
		113,
		138,
		177,
		179,
		165,
		161,
		174,
		168,
		165,
		163,
		68,
		-1,
		33,
		92,
		76,
		107,
		73,
		85,
		149,
		-1,
		132,
		114,
		-1,
		142,
		132,
		180,
		155,
		164,
		157,
		151,
		152,
		160,
		-1,
		-1,
		-1,
		30,
		31,
		46,
		57,
		68,
		66,
		84,
		-1,
		137,
		119,
		105,
		122,
		122,
		113,
		121,
		170,
		166,
		169,
		167,
		145,
		-1,
		161,
		-1,
		-1,
		6,
		-1,
		-1,
		-1,
		74,
		99,
		94,
		86,
		98,
		107,
		102,
		104,
		117,
		125,
		123,
		120,
		132,
		128,
		148,
		144,
		176,
		-1,
		168,
		-1,
		0,
		-1,
		-1,
		95,
		81,
		93,
		104,
		94,
		94,
		99,
		97,
		119,
		149,
		135,
		133,
		138,
		143,
		-1,
		178,
		179,
		-1,
		114,
		106,
		92,
		-1,
		85,
		-1,
		140,
		101,
		-1,
		126,
		106,
		-1,
		144,
		140,
		-1,
		-1,
		170,
		130,
		-1,
		-1,
		-1,
		115,
		95,
		135,
		119,
		-1,
		117,
		117,
		-1,
		-1,
		-1,
		155,
		139,
		-1,
		108,
		111,
		-1,
		102,
		108,
		137,
		119,
		123,
		-1,
		-1,
		-1,
		164,
		145,
		139,
		123,
		128,
		116,
		133,
		119,
		121,
		133,
		122,
		143,
		-1,
		-1,
		-1,
		136,
		128,
		128,
		-1,
		-1,
		146,
		129,
		129,
		142,
		-1,
		-1,
		-1,
		158,
		139,
		-1,
		-1,
		137,
		-1,
		-1,
		142,
		141,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		147,
		-1,
		-1,
		-1,
		138,
		145,
		153,
		-1,
		-1,
		-1,
		-1,
		168,
		169,
		193,
		168,
		-1,
		-1,
		-1,
		152,
		152,
		-1,
		-1,
		171,
		169,
		-1,
		-1,
		-1,
		180,
		164,
		-1,
		156,
		-1,
		-1,
		-1,
		171,
		-1,
		-1,
		189,
		-1,
		-1,
		-1,
		185,
		-1,
		191,
		166,
		173,
		-1,
		-1,
		-1,
		-1,
		198,
		190,
		204,
		-1,
		176,
		178,
		-1,
		226,
		-1,
		-1,
		213,
		204,
		-1,
		-1,
		181,
		188,
		210,
		213,
		243,
		-1,
		200
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		300,
		289,
		300,
		308,
		281,
		288,
		-1,
		307,
		311,
		277,
		271,
		310,
		279,
		285,
		296,
		-1,
		-1,
		-1,
		300,
		299,
		267,
		265,
		274,
		279,
		286,
		-1,
		285,
		-1,
		321,
		300,
		311,
		316,
		260,
		257,
		277,
		296,
		278,
		270,
		336,
		290,
		261,
		255,
		273,
		263,
		272,
		264,
		-1,
		261,
		251,
		273,
		252,
		263,
		255,
		-1,
		-1,
		255,
		256,
		262,
		248,
		254,
		250,
		-1,
		260,
		244,
		-1,
		-1,
		245,
		246,
		230,
		233,
		241,
		239,
		252,
		244,
		239,
		-1,
		-1,
		236,
		232,
		239,
		226,
		222,
		239,
		252,
		234,
		248,
		247,
		-1,
		240,
		258,
		265,
		233,
		231,
		215,
		213,
		231,
		233,
		239,
		239,
		-1,
		249,
		250,
		245,
		253,
		255,
		231,
		218,
		218,
		228,
		221,
		240,
		228,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		249,
		232,
		249,
		241,
		231,
		246,
		239,
		221,
		218,
		216,
		213,
		229,
		227,
		237,
		-1,
		-1,
		342,
		311,
		340,
		298,
		279,
		-1,
		245,
		225,
		231,
		235,
		229,
		222,
		236,
		232,
		-1,
		207,
		206,
		234,
		220,
		231,
		302,
		-1,
		-1,
		300,
		292,
		275,
		278,
		255,
		251,
		240,
		239,
		231,
		217,
		213,
		219,
		222,
		222,
		228,
		201,
		211,
		215,
		213,
		238,
		-1,
		-1,
		273,
		-1,
		-1,
		299,
		282,
		-1,
		265,
		272,
		261,
		267,
		253,
		274,
		250,
		241,
		233,
		227,
		215,
		217,
		214,
		227,
		215,
		198,
		223,
		227,
		208,
		229,
		224,
		-1,
		272,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		258,
		261,
		267,
		291,
		290,
		-1,
		262,
		250,
		251,
		236,
		233,
		220,
		208,
		221,
		206,
		213,
		212,
		202,
		200,
		230,
		205,
		227,
		224,
		243,
		248,
		242,
		251,
		-1,
		307,
		303,
		299,
		306,
		255,
		-1,
		-1,
		295,
		-1,
		298,
		299,
		274,
		247,
		250,
		237,
		228,
		215,
		204,
		215,
		204,
		201,
		209,
		194,
		209,
		200,
		199,
		217,
		227,
		235,
		239,
		245,
		-1,
		357,
		-1,
		299,
		283,
		285,
		257,
		278,
		-1,
		315,
		299,
		291,
		276,
		276,
		-1,
		246,
		243,
		233,
		211,
		196,
		213,
		205,
		203,
		207,
		189,
		203,
		194,
		212,
		219,
		217,
		221,
		241,
		253,
		317,
		307,
		-1,
		289,
		294,
		253,
		261,
		280,
		318,
		282,
		-1,
		277,
		-1,
		248,
		261,
		-1,
		217,
		213,
		195,
		196,
		191,
		206,
		200,
		185,
		182,
		200,
		203,
		210,
		214,
		230,
		-1,
		-1,
		302,
		306,
		295,
		246,
		265,
		289,
		326,
		275,
		264,
		263,
		-1,
		254,
		231,
		228,
		216,
		203,
		188,
		189,
		197,
		210,
		189,
		184,
		181,
		201,
		227,
		205,
		217,
		-1,
		-1,
		-1,
		327,
		-1,
		-1,
		272,
		243,
		267,
		309,
		293,
		286,
		274,
		239,
		239,
		233,
		-1,
		227,
		206,
		197,
		186,
		184,
		197,
		194,
		199,
		179,
		177,
		196,
		208,
		199,
		216,
		-1,
		-1,
		-1,
		302,
		291,
		292,
		238,
		261,
		298,
		272,
		258,
		263,
		238,
		231,
		225,
		240,
		223,
		204,
		193,
		185,
		174,
		190,
		198,
		193,
		175,
		184,
		190,
		214,
		204,
		210,
		-1,
		-1,
		309,
		299,
		283,
		285,
		282,
		252,
		259,
		291,
		263,
		276,
		-1,
		230,
		-1,
		219,
		214,
		198,
		193,
		190,
		187,
		181,
		190,
		192,
		182,
		177,
		184,
		219,
		219,
		194,
		214,
		217,
		-1,
		-1,
		-1,
		302,
		297,
		272,
		249,
		233,
		269,
		-1,
		246,
		247,
		-1,
		224,
		218,
		215,
		200,
		196,
		191,
		195,
		188,
		195,
		188,
		186,
		187,
		169,
		201,
		-1,
		202,
		196,
		204,
		194,
		182,
		-1,
		-1,
		-1,
		295,
		274,
		267,
		287,
		228,
		280,
		-1,
		-1,
		231,
		224,
		-1,
		211,
		193,
		200,
		198,
		192,
		196,
		193,
		182,
		195,
		188,
		174,
		176,
		189,
		193,
		197,
		184,
		180,
		177,
		191,
		-1,
		314,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		248,
		-1,
		240,
		232,
		222,
		216,
		210,
		206,
		204,
		220,
		204,
		207,
		205,
		196,
		204,
		177,
		170,
		177,
		166,
		184,
		192,
		184,
		178,
		177,
		187,
		-1,
		315,
		301,
		272,
		-1,
		-1,
		261,
		-1,
		225,
		239,
		255,
		-1,
		248,
		227,
		242,
		220,
		216,
		212,
		227,
		228,
		205,
		205,
		203,
		194,
		182,
		171,
		174,
		166,
		188,
		188,
		172,
		173,
		177,
		-1,
		321,
		308,
		266,
		262,
		251,
		271,
		222,
		210,
		242,
		-1,
		-1,
		284,
		-1,
		218,
		235,
		226,
		224,
		217,
		199,
		206,
		214,
		191,
		186,
		176,
		165,
		165,
		160,
		182,
		168,
		166,
		175,
		191,
		-1,
		-1,
		-1,
		288,
		-1,
		-1,
		237,
		224,
		218,
		-1,
		259,
		-1,
		262,
		252,
		236,
		221,
		254,
		-1,
		198,
		194,
		201,
		-1,
		211,
		-1,
		184,
		181,
		172,
		157,
		154,
		165,
		163,
		174,
		170,
		-1,
		271,
		256,
		249,
		239,
		253,
		224,
		-1,
		279,
		-1,
		-1,
		249,
		243,
		243,
		227,
		228,
		214,
		194,
		186,
		201,
		200,
		187,
		186,
		170,
		163,
		160,
		153,
		166,
		176,
		181,
		168,
		-1,
		-1,
		-1,
		276,
		262,
		266,
		226,
		245,
		-1,
		-1,
		311,
		266,
		252,
		-1,
		223,
		214,
		202,
		192,
		182,
		187,
		188,
		178,
		176,
		168,
		170,
		164,
		155,
		154,
		170,
		162,
		184,
		-1,
		-1,
		259,
		264,
		252,
		238,
		240,
		-1,
		-1,
		-1,
		258,
		274,
		242,
		221,
		203,
		-1,
		-1,
		186,
		179,
		173,
		176,
		164,
		184,
		179,
		163,
		148,
		163,
		167,
		175,
		166,
		-1,
		262,
		249,
		-1,
		-1,
		239,
		229,
		-1,
		-1,
		-1,
		-1,
		254,
		199,
		188,
		183,
		187,
		185,
		-1,
		159,
		170,
		163,
		182,
		189,
		165,
		150,
		144,
		150,
		162,
		171,
		-1,
		-1,
		253,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		211,
		205,
		176,
		169,
		173,
		-1,
		161,
		163,
		160,
		172,
		168,
		165,
		156,
		147,
		143,
		147,
		151,
		165,
		169,
		276,
		-1,
		206,
		-1,
		-1,
		-1,
		229,
		244,
		215,
		192,
		165,
		160,
		153,
		147,
		152,
		163,
		172,
		183,
		148,
		150,
		140,
		139,
		143,
		160,
		164,
		-1,
		-1,
		204,
		200,
		235,
		237,
		241,
		242,
		-1,
		-1,
		169,
		160,
		151,
		143,
		156,
		159,
		144,
		146,
		146,
		144,
		138,
		148,
		163,
		158,
		-1,
		-1,
		-1,
		216,
		-1,
		218,
		-1,
		-1,
		237,
		240,
		187,
		169,
		165,
		163,
		152,
		146,
		134,
		139,
		149,
		143,
		140,
		134,
		138,
		161,
		150,
		189,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		198,
		187,
		182,
		216,
		221,
		212,
		202,
		199,
		-1,
		169,
		175,
		140,
		147,
		130,
		137,
		142,
		139,
		128,
		135,
		151,
		150,
		145,
		181,
		172,
		178,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		191,
		184,
		202,
		192,
		198,
		-1,
		-1,
		194,
		191,
		171,
		140,
		138,
		131,
		126,
		136,
		112,
		124,
		128,
		132,
		138,
		143,
		148,
		154,
		169,
		184,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		181,
		173,
		181,
		184,
		191,
		-1,
		-1,
		167,
		158,
		159,
		147,
		144,
		150,
		149,
		132,
		138,
		139,
		131,
		130,
		148,
		152,
		161,
		168,
		158,
		171,
		175,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		172,
		-1,
		-1,
		141,
		192,
		176,
		166,
		163,
		206,
		161,
		156,
		137,
		135,
		130,
		121,
		146,
		139,
		139,
		142,
		157,
		162,
		154,
		168,
		168,
		169,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		131,
		-1,
		203,
		-1,
		186,
		190,
		169,
		172,
		151,
		138,
		124,
		132,
		138,
		137,
		143,
		143,
		144,
		153,
		164,
		176,
		175,
		176,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		156,
		192,
		137,
		-1,
		121,
		-1,
		-1,
		-1,
		200,
		182,
		174,
		171,
		150,
		150,
		116,
		120,
		133,
		140,
		150,
		161,
		153,
		157,
		170,
		181,
		184,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		152,
		149,
		186,
		144,
		133,
		128,
		115,
		-1,
		-1,
		184,
		192,
		-1,
		-1,
		157,
		124,
		112,
		122,
		126,
		140,
		152,
		165,
		153,
		158,
		152,
		184,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		150,
		177,
		161,
		165,
		175,
		200,
		-1,
		99,
		-1,
		-1,
		164,
		-1,
		-1,
		149,
		129,
		118,
		109,
		114,
		134,
		145,
		167,
		149,
		166,
		157,
		167,
		171,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		132,
		135,
		141,
		148,
		165,
		189,
		-1,
		-1,
		115,
		95,
		-1,
		-1,
		147,
		145,
		134,
		-1,
		124,
		106,
		111,
		141,
		143,
		145,
		152,
		146,
		153,
		161,
		172,
		164,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		-1,
		105,
		101,
		-1,
		-1,
		142,
		135,
		123,
		111,
		101,
		111,
		128,
		128,
		131,
		136,
		144,
		155,
		151,
		155,
		158,
		-1,
		208,
		-1,
		160,
		121,
		127,
		142,
		150,
		-1,
		-1,
		-1,
		122,
		108,
		101,
		89,
		87,
		-1,
		176,
		160,
		141,
		-1,
		111,
		124,
		164,
		132,
		137,
		132,
		147,
		158,
		149,
		157,
		151,
		154,
		-1,
		-1,
		120,
		103,
		-1,
		-1,
		77,
		79,
		-1,
		113,
		102,
		87,
		79,
		-1,
		-1,
		148,
		144,
		-1,
		-1,
		98,
		136,
		135,
		143,
		138,
		143,
		155,
		151,
		147,
		157,
		148,
		-1,
		-1,
		98,
		90,
		84,
		-1,
		62,
		-1,
		115,
		-1,
		82,
		89,
		77,
		-1,
		-1,
		-1,
		129,
		92,
		108,
		131,
		157,
		155,
		146,
		139,
		146,
		149,
		142,
		148,
		-1,
		-1,
		-1,
		80,
		54,
		122,
		113,
		96,
		76,
		68,
		88,
		-1,
		110,
		-1,
		85,
		88,
		113,
		152,
		154,
		140,
		136,
		149,
		143,
		140,
		138,
		86,
		-1,
		56,
		89,
		53,
		82,
		48,
		60,
		124,
		-1,
		107,
		89,
		-1,
		117,
		107,
		155,
		130,
		139,
		132,
		126,
		127,
		135,
		-1,
		-1,
		-1,
		58,
		57,
		49,
		43,
		43,
		41,
		59,
		-1,
		112,
		94,
		80,
		97,
		97,
		88,
		96,
		145,
		141,
		144,
		142,
		120,
		-1,
		120,
		-1,
		-1,
		81,
		-1,
		-1,
		-1,
		52,
		42,
		55,
		61,
		73,
		82,
		77,
		79,
		92,
		100,
		98,
		95,
		107,
		103,
		123,
		119,
		151,
		-1,
		115,
		-1,
		88,
		-1,
		-1,
		0,
		24,
		36,
		47,
		69,
		69,
		74,
		72,
		94,
		124,
		110,
		108,
		113,
		118,
		-1,
		104,
		103,
		-1,
		28,
		20,
		7,
		-1,
		22,
		-1,
		115,
		76,
		-1,
		101,
		81,
		-1,
		119,
		115,
		-1,
		-1,
		91,
		44,
		-1,
		-1,
		-1,
		53,
		35,
		110,
		94,
		-1,
		92,
		92,
		-1,
		-1,
		-1,
		76,
		53,
		-1,
		46,
		49,
		-1,
		42,
		48,
		77,
		93,
		98,
		-1,
		-1,
		-1,
		85,
		65,
		70,
		61,
		66,
		54,
		73,
		59,
		61,
		78,
		90,
		118,
		-1,
		-1,
		-1,
		76,
		68,
		68,
		-1,
		-1,
		86,
		69,
		69,
		87,
		-1,
		-1,
		-1,
		98,
		79,
		-1,
		-1,
		77,
		-1,
		-1,
		82,
		88,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		87,
		-1,
		-1,
		-1,
		78,
		85,
		93,
		-1,
		-1,
		-1,
		-1,
		108,
		109,
		133,
		108,
		-1,
		-1,
		-1,
		92,
		95,
		-1,
		-1,
		111,
		109,
		-1,
		-1,
		-1,
		120,
		104,
		-1,
		103,
		-1,
		-1,
		-1,
		111,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		125,
		-1,
		138,
		113,
		120,
		-1,
		-1,
		-1,
		-1,
		138,
		130,
		151,
		-1,
		123,
		125,
		-1,
		173,
		-1,
		-1,
		153,
		144,
		-1,
		-1,
		128,
		135,
		157,
		160,
		183,
		-1,
		147
	],
	[
		-1,
		286,
		275,
		286,
		294,
		267,
		274,
		-1,
		293,
		297,
		263,
		257,
		296,
		265,
		271,
		282,
		-1,
		-1,
		-1,
		286,
		285,
		253,
		251,
		260,
		265,
		272,
		-1,
		271,
		-1,
		307,
		286,
		297,
		302,
		246,
		243,
		263,
		282,
		264,
		256,
		322,
		276,
		247,
		241,
		259,
		249,
		258,
		250,
		-1,
		247,
		237,
		259,
		238,
		249,
		241,
		-1,
		-1,
		241,
		242,
		248,
		234,
		240,
		236,
		-1,
		246,
		230,
		-1,
		-1,
		231,
		232,
		216,
		219,
		227,
		225,
		238,
		230,
		225,
		-1,
		-1,
		222,
		218,
		225,
		212,
		208,
		225,
		238,
		220,
		234,
		233,
		-1,
		226,
		244,
		251,
		219,
		217,
		201,
		199,
		217,
		219,
		225,
		225,
		-1,
		235,
		236,
		231,
		239,
		241,
		217,
		204,
		204,
		214,
		207,
		226,
		214,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		269,
		235,
		218,
		235,
		227,
		217,
		232,
		225,
		207,
		204,
		202,
		199,
		215,
		213,
		223,
		-1,
		-1,
		328,
		297,
		326,
		284,
		265,
		-1,
		231,
		211,
		217,
		221,
		215,
		208,
		222,
		218,
		-1,
		193,
		192,
		220,
		206,
		217,
		288,
		-1,
		-1,
		286,
		278,
		261,
		264,
		241,
		237,
		226,
		225,
		217,
		203,
		199,
		205,
		208,
		208,
		214,
		187,
		197,
		201,
		199,
		224,
		-1,
		-1,
		259,
		-1,
		-1,
		285,
		268,
		-1,
		251,
		258,
		247,
		253,
		239,
		260,
		236,
		227,
		219,
		213,
		201,
		203,
		200,
		213,
		201,
		184,
		209,
		213,
		194,
		215,
		210,
		-1,
		258,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		263,
		244,
		247,
		253,
		277,
		276,
		-1,
		248,
		236,
		237,
		222,
		219,
		206,
		194,
		207,
		192,
		199,
		198,
		188,
		186,
		216,
		191,
		213,
		210,
		229,
		234,
		228,
		237,
		-1,
		293,
		289,
		285,
		292,
		241,
		-1,
		-1,
		281,
		-1,
		284,
		285,
		260,
		233,
		236,
		223,
		214,
		201,
		190,
		201,
		190,
		187,
		195,
		180,
		195,
		186,
		185,
		203,
		213,
		221,
		225,
		231,
		-1,
		343,
		-1,
		285,
		269,
		271,
		243,
		264,
		-1,
		301,
		285,
		277,
		262,
		262,
		-1,
		232,
		229,
		219,
		197,
		182,
		199,
		191,
		189,
		193,
		175,
		189,
		180,
		198,
		205,
		203,
		207,
		227,
		239,
		303,
		293,
		-1,
		275,
		280,
		239,
		247,
		266,
		304,
		268,
		-1,
		263,
		-1,
		234,
		247,
		-1,
		203,
		199,
		181,
		182,
		177,
		192,
		186,
		171,
		168,
		186,
		189,
		196,
		200,
		216,
		-1,
		-1,
		288,
		292,
		281,
		232,
		251,
		275,
		312,
		261,
		250,
		249,
		-1,
		240,
		217,
		214,
		202,
		189,
		174,
		175,
		183,
		196,
		175,
		170,
		167,
		187,
		213,
		191,
		203,
		-1,
		-1,
		-1,
		313,
		-1,
		-1,
		258,
		229,
		253,
		295,
		279,
		272,
		260,
		225,
		225,
		219,
		-1,
		213,
		192,
		183,
		172,
		170,
		183,
		180,
		185,
		165,
		163,
		182,
		194,
		185,
		202,
		-1,
		-1,
		-1,
		288,
		277,
		278,
		224,
		247,
		284,
		258,
		244,
		249,
		224,
		217,
		211,
		226,
		209,
		190,
		179,
		171,
		160,
		176,
		184,
		179,
		161,
		170,
		176,
		200,
		190,
		196,
		-1,
		-1,
		295,
		285,
		269,
		271,
		268,
		238,
		245,
		277,
		249,
		262,
		-1,
		216,
		-1,
		205,
		200,
		184,
		179,
		176,
		173,
		167,
		176,
		178,
		168,
		163,
		170,
		205,
		205,
		180,
		200,
		203,
		-1,
		-1,
		-1,
		288,
		283,
		258,
		235,
		219,
		255,
		-1,
		232,
		233,
		-1,
		210,
		204,
		201,
		186,
		182,
		177,
		181,
		174,
		181,
		174,
		172,
		173,
		155,
		187,
		-1,
		188,
		182,
		190,
		180,
		168,
		-1,
		-1,
		-1,
		281,
		260,
		253,
		273,
		214,
		266,
		-1,
		-1,
		217,
		210,
		-1,
		197,
		179,
		186,
		184,
		178,
		182,
		179,
		168,
		181,
		174,
		160,
		162,
		175,
		179,
		183,
		170,
		166,
		163,
		177,
		-1,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		214,
		234,
		-1,
		226,
		218,
		208,
		202,
		196,
		192,
		190,
		206,
		190,
		193,
		191,
		182,
		190,
		163,
		156,
		163,
		152,
		170,
		178,
		170,
		164,
		163,
		173,
		-1,
		301,
		287,
		258,
		-1,
		-1,
		247,
		-1,
		211,
		225,
		241,
		-1,
		234,
		213,
		228,
		206,
		202,
		198,
		213,
		214,
		191,
		191,
		189,
		180,
		168,
		157,
		160,
		152,
		174,
		174,
		158,
		159,
		163,
		-1,
		307,
		294,
		252,
		248,
		237,
		257,
		208,
		196,
		228,
		-1,
		-1,
		270,
		-1,
		204,
		221,
		212,
		210,
		203,
		185,
		192,
		200,
		177,
		172,
		162,
		151,
		151,
		146,
		168,
		154,
		152,
		161,
		177,
		-1,
		-1,
		-1,
		274,
		-1,
		-1,
		223,
		210,
		204,
		-1,
		245,
		-1,
		248,
		238,
		222,
		207,
		240,
		-1,
		184,
		180,
		187,
		-1,
		197,
		-1,
		170,
		167,
		158,
		143,
		140,
		151,
		149,
		160,
		156,
		-1,
		257,
		242,
		235,
		225,
		239,
		210,
		-1,
		265,
		-1,
		-1,
		235,
		229,
		229,
		213,
		214,
		200,
		180,
		172,
		187,
		186,
		173,
		172,
		156,
		149,
		146,
		139,
		152,
		162,
		167,
		154,
		-1,
		-1,
		-1,
		262,
		248,
		252,
		212,
		231,
		-1,
		-1,
		297,
		252,
		238,
		-1,
		209,
		200,
		188,
		178,
		168,
		173,
		174,
		164,
		162,
		154,
		156,
		150,
		141,
		140,
		156,
		148,
		170,
		-1,
		-1,
		245,
		250,
		238,
		224,
		228,
		-1,
		-1,
		-1,
		244,
		260,
		228,
		207,
		189,
		-1,
		-1,
		172,
		165,
		159,
		162,
		150,
		170,
		165,
		149,
		134,
		149,
		153,
		161,
		152,
		-1,
		248,
		235,
		-1,
		-1,
		227,
		217,
		-1,
		-1,
		-1,
		-1,
		240,
		185,
		174,
		169,
		173,
		171,
		-1,
		145,
		156,
		149,
		168,
		175,
		151,
		136,
		130,
		136,
		148,
		157,
		-1,
		-1,
		241,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		197,
		191,
		162,
		155,
		159,
		-1,
		147,
		149,
		146,
		158,
		154,
		151,
		142,
		133,
		129,
		133,
		137,
		151,
		155,
		264,
		-1,
		194,
		-1,
		-1,
		-1,
		215,
		230,
		201,
		178,
		151,
		146,
		139,
		133,
		138,
		149,
		158,
		169,
		134,
		136,
		126,
		125,
		129,
		146,
		150,
		-1,
		-1,
		192,
		188,
		223,
		223,
		227,
		228,
		-1,
		-1,
		155,
		146,
		137,
		129,
		142,
		145,
		130,
		132,
		132,
		130,
		124,
		134,
		149,
		144,
		-1,
		-1,
		-1,
		204,
		-1,
		206,
		-1,
		-1,
		225,
		226,
		173,
		155,
		151,
		149,
		138,
		132,
		120,
		125,
		135,
		129,
		126,
		120,
		124,
		147,
		136,
		175,
		-1,
		-1,
		226,
		-1,
		-1,
		-1,
		186,
		175,
		170,
		204,
		209,
		200,
		188,
		185,
		-1,
		155,
		161,
		126,
		133,
		116,
		123,
		128,
		125,
		114,
		121,
		137,
		136,
		131,
		167,
		158,
		164,
		-1,
		-1,
		219,
		208,
		197,
		203,
		-1,
		179,
		172,
		190,
		180,
		186,
		-1,
		-1,
		180,
		177,
		157,
		126,
		124,
		117,
		112,
		122,
		98,
		110,
		114,
		118,
		124,
		129,
		134,
		140,
		155,
		170,
		-1,
		173,
		210,
		203,
		171,
		179,
		210,
		-1,
		169,
		161,
		169,
		172,
		177,
		-1,
		-1,
		153,
		144,
		145,
		133,
		130,
		136,
		135,
		118,
		124,
		125,
		117,
		116,
		134,
		138,
		147,
		154,
		144,
		157,
		161,
		-1,
		166,
		186,
		165,
		168,
		192,
		206,
		-1,
		160,
		-1,
		-1,
		129,
		178,
		162,
		152,
		149,
		192,
		147,
		142,
		123,
		121,
		116,
		107,
		132,
		125,
		125,
		128,
		143,
		148,
		140,
		154,
		154,
		155,
		-1,
		155,
		166,
		159,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		-1,
		119,
		-1,
		189,
		-1,
		172,
		176,
		155,
		158,
		137,
		124,
		110,
		118,
		124,
		123,
		129,
		129,
		130,
		139,
		150,
		162,
		161,
		162,
		180,
		136,
		139,
		150,
		161,
		176,
		180,
		-1,
		144,
		180,
		125,
		-1,
		109,
		-1,
		-1,
		-1,
		186,
		168,
		160,
		157,
		136,
		136,
		102,
		106,
		119,
		126,
		136,
		147,
		139,
		143,
		156,
		167,
		170,
		176,
		167,
		180,
		125,
		125,
		146,
		155,
		176,
		140,
		137,
		174,
		132,
		121,
		116,
		103,
		-1,
		-1,
		170,
		178,
		-1,
		-1,
		143,
		110,
		98,
		108,
		112,
		126,
		138,
		151,
		139,
		144,
		138,
		170,
		-1,
		169,
		168,
		157,
		154,
		130,
		121,
		116,
		143,
		-1,
		-1,
		138,
		165,
		149,
		153,
		163,
		188,
		-1,
		87,
		-1,
		-1,
		150,
		-1,
		-1,
		135,
		115,
		104,
		95,
		100,
		120,
		131,
		153,
		135,
		152,
		143,
		153,
		157,
		153,
		150,
		138,
		136,
		159,
		124,
		112,
		-1,
		120,
		123,
		129,
		136,
		153,
		177,
		-1,
		-1,
		103,
		83,
		-1,
		-1,
		133,
		131,
		120,
		-1,
		110,
		92,
		97,
		127,
		129,
		131,
		138,
		132,
		139,
		147,
		158,
		150,
		162,
		176,
		165,
		161,
		160,
		168,
		117,
		110,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		-1,
		93,
		89,
		-1,
		-1,
		128,
		121,
		109,
		97,
		87,
		97,
		114,
		114,
		117,
		122,
		130,
		141,
		137,
		141,
		144,
		-1,
		196,
		-1,
		148,
		109,
		115,
		130,
		138,
		-1,
		-1,
		-1,
		110,
		96,
		89,
		77,
		75,
		-1,
		162,
		146,
		127,
		-1,
		97,
		110,
		150,
		118,
		123,
		118,
		133,
		144,
		135,
		143,
		137,
		140,
		-1,
		-1,
		108,
		91,
		-1,
		-1,
		65,
		67,
		-1,
		101,
		90,
		75,
		67,
		-1,
		-1,
		134,
		130,
		-1,
		-1,
		84,
		122,
		121,
		129,
		124,
		129,
		141,
		137,
		133,
		143,
		134,
		-1,
		-1,
		86,
		78,
		72,
		-1,
		50,
		-1,
		103,
		-1,
		70,
		77,
		65,
		-1,
		-1,
		-1,
		115,
		78,
		94,
		117,
		143,
		141,
		132,
		125,
		132,
		135,
		128,
		134,
		-1,
		-1,
		-1,
		68,
		42,
		110,
		101,
		84,
		64,
		56,
		76,
		-1,
		96,
		-1,
		71,
		74,
		99,
		138,
		140,
		126,
		122,
		135,
		129,
		126,
		124,
		74,
		-1,
		44,
		77,
		41,
		70,
		36,
		48,
		110,
		-1,
		93,
		75,
		-1,
		103,
		93,
		141,
		116,
		125,
		118,
		112,
		113,
		121,
		-1,
		-1,
		-1,
		46,
		45,
		37,
		31,
		31,
		29,
		47,
		-1,
		98,
		80,
		66,
		83,
		83,
		74,
		82,
		131,
		127,
		130,
		128,
		106,
		-1,
		133,
		-1,
		-1,
		69,
		-1,
		-1,
		-1,
		40,
		18,
		31,
		47,
		55,
		68,
		63,
		65,
		78,
		86,
		84,
		81,
		93,
		89,
		109,
		105,
		137,
		-1,
		128,
		-1,
		76,
		-1,
		-1,
		26,
		0,
		12,
		23,
		51,
		51,
		56,
		58,
		80,
		110,
		96,
		94,
		99,
		104,
		-1,
		117,
		116,
		-1,
		45,
		37,
		23,
		-1,
		16,
		-1,
		97,
		58,
		-1,
		87,
		67,
		-1,
		105,
		101,
		-1,
		-1,
		104,
		61,
		-1,
		-1,
		-1,
		47,
		24,
		92,
		76,
		-1,
		78,
		78,
		-1,
		-1,
		-1,
		89,
		70,
		-1,
		40,
		43,
		-1,
		31,
		37,
		66,
		80,
		84,
		-1,
		-1,
		-1,
		98,
		79,
		73,
		55,
		60,
		48,
		62,
		48,
		51,
		68,
		80,
		104,
		-1,
		-1,
		-1,
		70,
		62,
		62,
		-1,
		-1,
		76,
		59,
		59,
		77,
		-1,
		-1,
		-1,
		92,
		73,
		-1,
		-1,
		71,
		-1,
		-1,
		72,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		81,
		-1,
		-1,
		-1,
		72,
		79,
		83,
		-1,
		-1,
		-1,
		-1,
		102,
		103,
		127,
		102,
		-1,
		-1,
		-1,
		86,
		89,
		-1,
		-1,
		105,
		103,
		-1,
		-1,
		-1,
		114,
		98,
		-1,
		93,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		126,
		-1,
		-1,
		-1,
		119,
		-1,
		128,
		103,
		110,
		-1,
		-1,
		-1,
		-1,
		132,
		124,
		141,
		-1,
		113,
		115,
		-1,
		163,
		-1,
		-1,
		147,
		138,
		-1,
		-1,
		118,
		125,
		147,
		150,
		177,
		-1,
		137
	],
	[
		-1,
		274,
		263,
		274,
		282,
		255,
		262,
		-1,
		281,
		285,
		251,
		245,
		284,
		253,
		259,
		270,
		-1,
		-1,
		-1,
		274,
		273,
		241,
		239,
		248,
		253,
		260,
		-1,
		259,
		-1,
		295,
		274,
		285,
		290,
		234,
		231,
		251,
		270,
		252,
		244,
		310,
		264,
		235,
		229,
		247,
		237,
		246,
		238,
		-1,
		235,
		225,
		247,
		226,
		237,
		229,
		-1,
		-1,
		229,
		230,
		236,
		222,
		228,
		224,
		-1,
		234,
		218,
		-1,
		-1,
		219,
		220,
		204,
		207,
		215,
		213,
		226,
		218,
		213,
		-1,
		-1,
		210,
		206,
		213,
		200,
		196,
		213,
		226,
		208,
		222,
		221,
		-1,
		214,
		232,
		239,
		207,
		205,
		189,
		187,
		205,
		207,
		213,
		213,
		-1,
		223,
		224,
		219,
		227,
		229,
		205,
		192,
		192,
		202,
		195,
		214,
		202,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		223,
		206,
		223,
		215,
		205,
		220,
		213,
		195,
		192,
		190,
		187,
		203,
		201,
		211,
		-1,
		-1,
		316,
		285,
		314,
		272,
		253,
		-1,
		219,
		199,
		205,
		209,
		203,
		196,
		210,
		206,
		-1,
		181,
		180,
		208,
		194,
		205,
		276,
		-1,
		-1,
		274,
		266,
		249,
		252,
		229,
		225,
		214,
		213,
		205,
		191,
		187,
		193,
		196,
		196,
		202,
		175,
		185,
		189,
		187,
		212,
		-1,
		-1,
		247,
		-1,
		-1,
		273,
		256,
		-1,
		239,
		246,
		235,
		241,
		227,
		248,
		224,
		215,
		207,
		201,
		189,
		191,
		188,
		201,
		189,
		172,
		197,
		201,
		182,
		203,
		198,
		-1,
		246,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		232,
		235,
		241,
		265,
		264,
		-1,
		236,
		224,
		225,
		210,
		207,
		194,
		182,
		195,
		180,
		187,
		186,
		176,
		174,
		204,
		179,
		201,
		198,
		217,
		222,
		216,
		225,
		-1,
		281,
		277,
		273,
		280,
		229,
		-1,
		-1,
		269,
		-1,
		272,
		273,
		248,
		221,
		224,
		211,
		202,
		189,
		178,
		189,
		178,
		175,
		183,
		168,
		183,
		174,
		173,
		191,
		201,
		209,
		213,
		219,
		-1,
		331,
		-1,
		273,
		257,
		259,
		231,
		252,
		-1,
		289,
		273,
		265,
		250,
		250,
		-1,
		220,
		217,
		207,
		185,
		170,
		187,
		179,
		177,
		181,
		163,
		177,
		168,
		186,
		193,
		191,
		195,
		215,
		227,
		291,
		281,
		-1,
		263,
		268,
		227,
		235,
		254,
		292,
		256,
		-1,
		251,
		-1,
		222,
		235,
		-1,
		191,
		187,
		169,
		170,
		165,
		180,
		174,
		159,
		156,
		174,
		177,
		184,
		188,
		204,
		-1,
		-1,
		276,
		280,
		269,
		220,
		239,
		263,
		300,
		249,
		238,
		237,
		-1,
		228,
		205,
		202,
		190,
		177,
		162,
		163,
		171,
		184,
		163,
		158,
		155,
		175,
		201,
		179,
		191,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		246,
		217,
		241,
		283,
		267,
		260,
		248,
		213,
		213,
		207,
		-1,
		201,
		180,
		171,
		160,
		158,
		171,
		168,
		173,
		153,
		151,
		170,
		182,
		173,
		190,
		-1,
		-1,
		-1,
		276,
		265,
		266,
		212,
		235,
		272,
		246,
		232,
		237,
		212,
		205,
		199,
		214,
		197,
		178,
		167,
		159,
		148,
		164,
		172,
		167,
		149,
		158,
		164,
		188,
		178,
		184,
		-1,
		-1,
		283,
		273,
		257,
		259,
		256,
		226,
		233,
		265,
		237,
		250,
		-1,
		204,
		-1,
		193,
		188,
		172,
		167,
		164,
		161,
		155,
		164,
		166,
		156,
		151,
		158,
		193,
		193,
		168,
		188,
		191,
		-1,
		-1,
		-1,
		276,
		271,
		246,
		223,
		207,
		243,
		-1,
		220,
		221,
		-1,
		198,
		192,
		189,
		174,
		170,
		165,
		169,
		162,
		169,
		162,
		160,
		161,
		143,
		175,
		-1,
		176,
		170,
		178,
		168,
		156,
		-1,
		-1,
		-1,
		269,
		248,
		241,
		261,
		202,
		254,
		-1,
		-1,
		205,
		198,
		-1,
		185,
		167,
		174,
		172,
		166,
		170,
		167,
		156,
		169,
		162,
		148,
		150,
		163,
		167,
		171,
		158,
		154,
		151,
		165,
		-1,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		222,
		-1,
		214,
		206,
		196,
		190,
		184,
		180,
		178,
		194,
		178,
		181,
		179,
		170,
		178,
		151,
		144,
		151,
		140,
		158,
		166,
		158,
		152,
		151,
		161,
		-1,
		289,
		275,
		246,
		-1,
		-1,
		235,
		-1,
		199,
		213,
		229,
		-1,
		222,
		201,
		216,
		194,
		190,
		186,
		201,
		202,
		179,
		179,
		177,
		168,
		156,
		145,
		148,
		140,
		162,
		162,
		146,
		147,
		151,
		-1,
		295,
		282,
		240,
		236,
		225,
		245,
		196,
		184,
		216,
		-1,
		-1,
		258,
		-1,
		192,
		209,
		200,
		198,
		191,
		173,
		180,
		188,
		165,
		160,
		150,
		139,
		139,
		134,
		156,
		142,
		140,
		149,
		165,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		211,
		198,
		192,
		-1,
		233,
		-1,
		236,
		226,
		210,
		195,
		228,
		-1,
		172,
		168,
		175,
		-1,
		185,
		-1,
		158,
		155,
		146,
		131,
		128,
		139,
		137,
		148,
		144,
		-1,
		245,
		230,
		223,
		213,
		227,
		198,
		-1,
		253,
		-1,
		-1,
		223,
		217,
		217,
		201,
		202,
		188,
		168,
		160,
		175,
		174,
		161,
		160,
		144,
		137,
		134,
		127,
		140,
		150,
		155,
		142,
		-1,
		-1,
		-1,
		250,
		236,
		240,
		200,
		219,
		-1,
		-1,
		285,
		240,
		226,
		-1,
		197,
		188,
		176,
		166,
		156,
		161,
		162,
		152,
		150,
		142,
		144,
		138,
		129,
		128,
		144,
		136,
		158,
		-1,
		-1,
		233,
		238,
		226,
		212,
		227,
		-1,
		-1,
		-1,
		232,
		248,
		216,
		195,
		177,
		-1,
		-1,
		160,
		153,
		147,
		150,
		138,
		158,
		153,
		137,
		122,
		137,
		141,
		149,
		140,
		-1,
		236,
		223,
		-1,
		-1,
		226,
		216,
		-1,
		-1,
		-1,
		-1,
		228,
		173,
		162,
		157,
		161,
		159,
		-1,
		133,
		144,
		137,
		156,
		163,
		139,
		124,
		118,
		124,
		136,
		145,
		-1,
		-1,
		240,
		-1,
		202,
		-1,
		-1,
		-1,
		-1,
		185,
		179,
		150,
		143,
		147,
		-1,
		135,
		137,
		134,
		146,
		142,
		139,
		130,
		121,
		117,
		121,
		125,
		139,
		143,
		263,
		-1,
		193,
		-1,
		-1,
		-1,
		203,
		218,
		189,
		166,
		139,
		134,
		127,
		121,
		126,
		137,
		146,
		157,
		122,
		124,
		114,
		113,
		117,
		134,
		138,
		-1,
		-1,
		191,
		187,
		222,
		211,
		215,
		216,
		-1,
		-1,
		143,
		134,
		125,
		117,
		130,
		133,
		118,
		120,
		120,
		118,
		112,
		122,
		137,
		132,
		-1,
		-1,
		-1,
		203,
		-1,
		205,
		-1,
		-1,
		213,
		214,
		161,
		143,
		139,
		137,
		126,
		120,
		108,
		113,
		123,
		117,
		114,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		240,
		-1,
		-1,
		-1,
		200,
		174,
		169,
		195,
		197,
		188,
		176,
		173,
		-1,
		143,
		149,
		114,
		121,
		104,
		111,
		116,
		113,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		233,
		222,
		211,
		217,
		-1,
		193,
		171,
		181,
		171,
		174,
		-1,
		-1,
		168,
		165,
		145,
		114,
		112,
		105,
		100,
		110,
		86,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		187,
		224,
		217,
		185,
		193,
		224,
		-1,
		183,
		175,
		168,
		163,
		165,
		-1,
		-1,
		141,
		132,
		133,
		121,
		118,
		124,
		123,
		106,
		112,
		113,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		180,
		200,
		179,
		182,
		206,
		220,
		-1,
		174,
		-1,
		-1,
		128,
		166,
		150,
		140,
		137,
		180,
		135,
		130,
		111,
		109,
		104,
		95,
		120,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		169,
		180,
		173,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		118,
		-1,
		177,
		-1,
		160,
		164,
		143,
		146,
		125,
		112,
		98,
		106,
		112,
		111,
		117,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		194,
		150,
		153,
		164,
		175,
		190,
		194,
		-1,
		158,
		194,
		124,
		-1,
		108,
		-1,
		-1,
		-1,
		174,
		156,
		148,
		145,
		124,
		124,
		90,
		94,
		107,
		114,
		124,
		135,
		127,
		131,
		144,
		155,
		158,
		190,
		181,
		194,
		139,
		139,
		160,
		169,
		190,
		154,
		151,
		188,
		131,
		120,
		115,
		102,
		-1,
		-1,
		158,
		166,
		-1,
		-1,
		131,
		98,
		86,
		96,
		100,
		114,
		126,
		139,
		127,
		132,
		126,
		158,
		-1,
		183,
		182,
		171,
		168,
		144,
		135,
		130,
		157,
		-1,
		-1,
		152,
		179,
		163,
		164,
		162,
		187,
		-1,
		91,
		-1,
		-1,
		138,
		-1,
		-1,
		123,
		103,
		92,
		83,
		88,
		108,
		119,
		141,
		123,
		140,
		131,
		141,
		145,
		167,
		164,
		152,
		150,
		173,
		138,
		126,
		-1,
		134,
		137,
		143,
		150,
		165,
		176,
		-1,
		-1,
		107,
		87,
		-1,
		-1,
		121,
		119,
		108,
		-1,
		98,
		80,
		85,
		115,
		117,
		119,
		126,
		120,
		127,
		135,
		146,
		138,
		176,
		190,
		179,
		175,
		174,
		182,
		131,
		124,
		131,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		-1,
		97,
		93,
		-1,
		-1,
		116,
		109,
		97,
		85,
		75,
		85,
		102,
		102,
		105,
		110,
		118,
		129,
		125,
		129,
		132,
		-1,
		210,
		-1,
		162,
		123,
		129,
		144,
		152,
		-1,
		-1,
		-1,
		114,
		100,
		93,
		81,
		79,
		-1,
		150,
		134,
		115,
		-1,
		85,
		98,
		138,
		106,
		111,
		106,
		121,
		132,
		123,
		131,
		125,
		128,
		-1,
		-1,
		122,
		105,
		-1,
		-1,
		79,
		81,
		-1,
		105,
		94,
		79,
		71,
		-1,
		-1,
		122,
		118,
		-1,
		-1,
		72,
		110,
		109,
		117,
		112,
		117,
		129,
		125,
		121,
		131,
		122,
		-1,
		-1,
		100,
		92,
		86,
		-1,
		64,
		-1,
		107,
		-1,
		74,
		72,
		60,
		-1,
		-1,
		-1,
		103,
		66,
		82,
		105,
		131,
		129,
		120,
		113,
		120,
		123,
		116,
		122,
		-1,
		-1,
		-1,
		82,
		56,
		114,
		105,
		88,
		68,
		60,
		71,
		-1,
		84,
		-1,
		59,
		62,
		87,
		126,
		128,
		114,
		110,
		123,
		117,
		114,
		112,
		88,
		-1,
		58,
		91,
		55,
		74,
		50,
		48,
		98,
		-1,
		81,
		63,
		-1,
		91,
		81,
		129,
		104,
		113,
		106,
		100,
		101,
		109,
		-1,
		-1,
		-1,
		60,
		59,
		51,
		45,
		45,
		43,
		38,
		-1,
		86,
		68,
		54,
		71,
		71,
		62,
		70,
		119,
		115,
		118,
		116,
		94,
		-1,
		147,
		-1,
		-1,
		83,
		-1,
		-1,
		-1,
		54,
		8,
		19,
		35,
		43,
		56,
		51,
		53,
		66,
		74,
		72,
		69,
		81,
		77,
		97,
		93,
		125,
		-1,
		142,
		-1,
		90,
		-1,
		-1,
		40,
		14,
		0,
		11,
		39,
		39,
		44,
		46,
		68,
		98,
		84,
		82,
		87,
		92,
		-1,
		131,
		130,
		-1,
		59,
		51,
		37,
		-1,
		30,
		-1,
		85,
		46,
		-1,
		75,
		55,
		-1,
		93,
		89,
		-1,
		-1,
		118,
		75,
		-1,
		-1,
		-1,
		61,
		36,
		80,
		64,
		-1,
		66,
		66,
		-1,
		-1,
		-1,
		103,
		84,
		-1,
		54,
		57,
		-1,
		43,
		49,
		78,
		68,
		72,
		-1,
		-1,
		-1,
		112,
		93,
		87,
		69,
		74,
		62,
		74,
		60,
		63,
		80,
		71,
		92,
		-1,
		-1,
		-1,
		84,
		76,
		76,
		-1,
		-1,
		88,
		71,
		71,
		89,
		-1,
		-1,
		-1,
		106,
		87,
		-1,
		-1,
		85,
		-1,
		-1,
		84,
		90,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		95,
		-1,
		-1,
		-1,
		86,
		93,
		95,
		-1,
		-1,
		-1,
		-1,
		116,
		117,
		141,
		116,
		-1,
		-1,
		-1,
		100,
		101,
		-1,
		-1,
		119,
		117,
		-1,
		-1,
		-1,
		128,
		112,
		-1,
		105,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		138,
		-1,
		-1,
		-1,
		133,
		-1,
		140,
		115,
		122,
		-1,
		-1,
		-1,
		-1,
		146,
		138,
		153,
		-1,
		125,
		127,
		-1,
		175,
		-1,
		-1,
		161,
		152,
		-1,
		-1,
		130,
		137,
		159,
		162,
		191,
		-1,
		149
	],
	[
		-1,
		263,
		252,
		263,
		271,
		244,
		251,
		-1,
		270,
		274,
		240,
		234,
		273,
		242,
		248,
		259,
		-1,
		-1,
		-1,
		263,
		262,
		230,
		228,
		237,
		242,
		249,
		-1,
		248,
		-1,
		284,
		263,
		274,
		279,
		223,
		220,
		240,
		259,
		241,
		233,
		299,
		253,
		224,
		218,
		236,
		226,
		235,
		227,
		-1,
		224,
		214,
		236,
		215,
		226,
		218,
		-1,
		-1,
		218,
		219,
		225,
		211,
		217,
		213,
		-1,
		223,
		207,
		-1,
		-1,
		208,
		209,
		193,
		196,
		204,
		202,
		215,
		207,
		202,
		-1,
		-1,
		199,
		195,
		202,
		189,
		185,
		202,
		215,
		197,
		211,
		210,
		-1,
		203,
		221,
		228,
		196,
		194,
		178,
		176,
		194,
		196,
		202,
		202,
		-1,
		212,
		213,
		208,
		216,
		218,
		194,
		181,
		181,
		191,
		184,
		203,
		191,
		237,
		-1,
		-1,
		-1,
		-1,
		-1,
		246,
		212,
		195,
		212,
		204,
		194,
		209,
		202,
		184,
		181,
		179,
		176,
		192,
		190,
		200,
		-1,
		-1,
		305,
		274,
		303,
		261,
		242,
		-1,
		208,
		188,
		194,
		198,
		192,
		185,
		199,
		195,
		-1,
		170,
		169,
		197,
		183,
		194,
		265,
		-1,
		-1,
		263,
		255,
		238,
		241,
		218,
		214,
		203,
		202,
		194,
		180,
		176,
		182,
		185,
		185,
		191,
		164,
		174,
		178,
		176,
		201,
		-1,
		-1,
		236,
		-1,
		-1,
		262,
		245,
		-1,
		228,
		235,
		224,
		230,
		216,
		237,
		213,
		204,
		196,
		190,
		178,
		180,
		177,
		190,
		178,
		161,
		186,
		190,
		171,
		192,
		187,
		-1,
		235,
		219,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		221,
		224,
		230,
		254,
		253,
		-1,
		225,
		213,
		214,
		199,
		196,
		183,
		171,
		184,
		169,
		176,
		175,
		165,
		163,
		193,
		168,
		190,
		187,
		206,
		211,
		205,
		214,
		-1,
		270,
		266,
		262,
		269,
		218,
		-1,
		-1,
		258,
		-1,
		261,
		262,
		237,
		210,
		213,
		200,
		191,
		178,
		167,
		178,
		167,
		164,
		172,
		157,
		172,
		163,
		162,
		180,
		190,
		198,
		202,
		208,
		-1,
		320,
		-1,
		262,
		246,
		248,
		220,
		241,
		-1,
		278,
		262,
		254,
		239,
		239,
		-1,
		209,
		206,
		196,
		174,
		159,
		176,
		168,
		166,
		170,
		152,
		166,
		157,
		175,
		182,
		180,
		184,
		204,
		216,
		280,
		270,
		-1,
		252,
		257,
		216,
		224,
		243,
		281,
		245,
		-1,
		240,
		-1,
		211,
		224,
		-1,
		180,
		176,
		158,
		159,
		154,
		169,
		163,
		148,
		145,
		163,
		166,
		173,
		177,
		193,
		-1,
		-1,
		265,
		269,
		258,
		209,
		228,
		252,
		289,
		238,
		227,
		226,
		-1,
		217,
		194,
		191,
		179,
		166,
		151,
		152,
		160,
		173,
		152,
		147,
		144,
		164,
		190,
		168,
		180,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		235,
		206,
		230,
		272,
		256,
		249,
		237,
		202,
		202,
		196,
		-1,
		190,
		169,
		160,
		149,
		147,
		160,
		157,
		162,
		142,
		140,
		159,
		171,
		162,
		179,
		-1,
		-1,
		-1,
		265,
		254,
		255,
		201,
		224,
		261,
		235,
		221,
		226,
		201,
		194,
		188,
		203,
		186,
		167,
		156,
		148,
		137,
		153,
		161,
		156,
		138,
		147,
		153,
		177,
		167,
		173,
		-1,
		-1,
		272,
		262,
		246,
		248,
		245,
		215,
		222,
		254,
		226,
		239,
		-1,
		193,
		-1,
		182,
		177,
		161,
		156,
		153,
		150,
		144,
		153,
		155,
		145,
		140,
		147,
		182,
		182,
		157,
		177,
		180,
		-1,
		-1,
		-1,
		265,
		260,
		235,
		212,
		196,
		232,
		-1,
		209,
		210,
		-1,
		187,
		181,
		178,
		163,
		159,
		154,
		158,
		151,
		158,
		151,
		149,
		150,
		132,
		164,
		-1,
		165,
		159,
		167,
		157,
		145,
		-1,
		-1,
		-1,
		258,
		237,
		230,
		250,
		191,
		243,
		-1,
		-1,
		194,
		187,
		-1,
		174,
		156,
		163,
		161,
		155,
		159,
		156,
		145,
		158,
		151,
		137,
		139,
		152,
		156,
		160,
		147,
		143,
		140,
		154,
		-1,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		191,
		211,
		-1,
		203,
		195,
		185,
		179,
		173,
		169,
		167,
		183,
		167,
		170,
		168,
		159,
		167,
		140,
		133,
		140,
		129,
		147,
		155,
		147,
		141,
		140,
		150,
		-1,
		278,
		264,
		235,
		-1,
		-1,
		224,
		-1,
		188,
		202,
		218,
		-1,
		211,
		190,
		205,
		183,
		179,
		175,
		190,
		191,
		168,
		168,
		166,
		157,
		145,
		134,
		137,
		129,
		151,
		151,
		135,
		136,
		140,
		-1,
		284,
		271,
		229,
		225,
		214,
		234,
		185,
		173,
		205,
		-1,
		-1,
		247,
		-1,
		181,
		198,
		189,
		187,
		180,
		162,
		169,
		177,
		154,
		149,
		139,
		128,
		128,
		123,
		145,
		131,
		129,
		138,
		154,
		-1,
		-1,
		-1,
		251,
		-1,
		-1,
		200,
		187,
		181,
		-1,
		222,
		-1,
		225,
		215,
		199,
		184,
		217,
		-1,
		161,
		157,
		164,
		-1,
		174,
		-1,
		147,
		144,
		135,
		120,
		117,
		128,
		126,
		137,
		133,
		-1,
		234,
		219,
		212,
		202,
		216,
		187,
		-1,
		242,
		-1,
		-1,
		212,
		206,
		206,
		190,
		191,
		177,
		157,
		149,
		164,
		163,
		150,
		149,
		133,
		126,
		123,
		116,
		129,
		139,
		144,
		131,
		-1,
		-1,
		-1,
		239,
		225,
		229,
		189,
		208,
		-1,
		-1,
		274,
		229,
		215,
		-1,
		186,
		177,
		165,
		155,
		145,
		150,
		151,
		141,
		139,
		131,
		133,
		127,
		118,
		117,
		133,
		125,
		147,
		-1,
		-1,
		222,
		227,
		215,
		201,
		216,
		-1,
		-1,
		-1,
		221,
		237,
		205,
		184,
		166,
		-1,
		-1,
		149,
		142,
		136,
		139,
		127,
		147,
		142,
		126,
		111,
		126,
		130,
		138,
		129,
		-1,
		225,
		212,
		-1,
		-1,
		215,
		205,
		-1,
		-1,
		-1,
		-1,
		217,
		162,
		151,
		146,
		150,
		148,
		-1,
		122,
		133,
		126,
		145,
		152,
		128,
		113,
		107,
		113,
		125,
		134,
		-1,
		-1,
		229,
		-1,
		191,
		-1,
		-1,
		-1,
		-1,
		174,
		168,
		139,
		132,
		136,
		-1,
		124,
		126,
		123,
		135,
		131,
		128,
		119,
		110,
		106,
		110,
		114,
		128,
		132,
		252,
		-1,
		182,
		-1,
		-1,
		-1,
		192,
		207,
		178,
		155,
		128,
		123,
		116,
		110,
		115,
		126,
		135,
		146,
		111,
		113,
		103,
		102,
		106,
		123,
		127,
		-1,
		-1,
		180,
		176,
		211,
		200,
		204,
		205,
		-1,
		-1,
		132,
		123,
		114,
		106,
		119,
		122,
		107,
		109,
		109,
		107,
		101,
		111,
		126,
		121,
		-1,
		-1,
		-1,
		192,
		-1,
		194,
		-1,
		-1,
		202,
		203,
		150,
		132,
		128,
		126,
		115,
		109,
		97,
		102,
		112,
		106,
		103,
		97,
		101,
		124,
		113,
		152,
		-1,
		-1,
		248,
		-1,
		-1,
		-1,
		191,
		163,
		158,
		184,
		186,
		177,
		165,
		162,
		-1,
		132,
		138,
		103,
		110,
		93,
		100,
		105,
		102,
		91,
		98,
		114,
		113,
		108,
		144,
		135,
		141,
		-1,
		-1,
		241,
		230,
		219,
		225,
		-1,
		184,
		160,
		170,
		160,
		163,
		-1,
		-1,
		157,
		154,
		134,
		103,
		101,
		94,
		89,
		99,
		75,
		87,
		91,
		95,
		101,
		106,
		111,
		117,
		132,
		147,
		-1,
		195,
		232,
		225,
		193,
		201,
		232,
		-1,
		174,
		166,
		157,
		152,
		154,
		-1,
		-1,
		130,
		121,
		122,
		110,
		107,
		113,
		112,
		95,
		101,
		102,
		94,
		93,
		111,
		115,
		124,
		131,
		121,
		134,
		138,
		-1,
		188,
		208,
		187,
		190,
		214,
		228,
		-1,
		171,
		-1,
		-1,
		117,
		155,
		139,
		129,
		126,
		169,
		124,
		119,
		100,
		98,
		93,
		84,
		109,
		102,
		102,
		105,
		120,
		125,
		117,
		131,
		131,
		132,
		-1,
		177,
		188,
		181,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		107,
		-1,
		166,
		-1,
		149,
		153,
		132,
		135,
		114,
		101,
		87,
		95,
		101,
		100,
		106,
		106,
		107,
		116,
		127,
		139,
		138,
		139,
		202,
		158,
		161,
		172,
		183,
		198,
		202,
		-1,
		166,
		202,
		113,
		-1,
		97,
		-1,
		-1,
		-1,
		163,
		145,
		137,
		134,
		113,
		113,
		79,
		83,
		96,
		103,
		113,
		124,
		116,
		120,
		133,
		144,
		147,
		198,
		189,
		202,
		147,
		147,
		168,
		177,
		198,
		162,
		159,
		196,
		120,
		109,
		104,
		91,
		-1,
		-1,
		147,
		155,
		-1,
		-1,
		120,
		87,
		75,
		85,
		89,
		103,
		115,
		128,
		116,
		121,
		115,
		147,
		-1,
		191,
		190,
		179,
		176,
		152,
		143,
		138,
		165,
		-1,
		-1,
		160,
		187,
		171,
		153,
		151,
		176,
		-1,
		80,
		-1,
		-1,
		127,
		-1,
		-1,
		112,
		92,
		81,
		72,
		77,
		97,
		108,
		130,
		112,
		129,
		120,
		130,
		134,
		175,
		172,
		160,
		158,
		181,
		146,
		134,
		-1,
		142,
		145,
		151,
		158,
		154,
		165,
		-1,
		-1,
		96,
		76,
		-1,
		-1,
		110,
		108,
		97,
		-1,
		87,
		69,
		74,
		104,
		106,
		108,
		115,
		109,
		116,
		124,
		135,
		127,
		184,
		198,
		187,
		183,
		182,
		190,
		139,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		101,
		-1,
		86,
		82,
		-1,
		-1,
		105,
		98,
		86,
		74,
		64,
		74,
		91,
		91,
		94,
		99,
		107,
		118,
		114,
		118,
		121,
		-1,
		218,
		-1,
		170,
		131,
		137,
		152,
		160,
		-1,
		-1,
		-1,
		103,
		89,
		82,
		70,
		68,
		-1,
		139,
		123,
		104,
		-1,
		74,
		87,
		127,
		95,
		100,
		95,
		110,
		121,
		112,
		120,
		114,
		117,
		-1,
		-1,
		130,
		113,
		-1,
		-1,
		87,
		89,
		-1,
		94,
		83,
		68,
		60,
		-1,
		-1,
		111,
		107,
		-1,
		-1,
		61,
		99,
		98,
		106,
		101,
		106,
		118,
		114,
		110,
		120,
		111,
		-1,
		-1,
		108,
		100,
		94,
		-1,
		72,
		-1,
		96,
		-1,
		63,
		61,
		49,
		-1,
		-1,
		-1,
		92,
		55,
		71,
		94,
		120,
		118,
		109,
		102,
		109,
		112,
		105,
		111,
		-1,
		-1,
		-1,
		90,
		64,
		103,
		94,
		77,
		57,
		49,
		60,
		-1,
		73,
		-1,
		48,
		51,
		76,
		115,
		117,
		103,
		99,
		112,
		106,
		103,
		101,
		96,
		-1,
		66,
		99,
		63,
		63,
		39,
		37,
		87,
		-1,
		70,
		52,
		-1,
		80,
		70,
		118,
		93,
		102,
		95,
		89,
		90,
		98,
		-1,
		-1,
		-1,
		68,
		67,
		59,
		53,
		53,
		44,
		27,
		-1,
		75,
		57,
		43,
		60,
		60,
		51,
		59,
		108,
		104,
		107,
		105,
		83,
		-1,
		158,
		-1,
		-1,
		91,
		-1,
		-1,
		-1,
		62,
		16,
		8,
		24,
		32,
		45,
		40,
		42,
		55,
		63,
		61,
		58,
		70,
		66,
		86,
		82,
		114,
		-1,
		153,
		-1,
		98,
		-1,
		-1,
		51,
		25,
		11,
		0,
		28,
		28,
		33,
		35,
		57,
		87,
		73,
		71,
		76,
		81,
		-1,
		142,
		141,
		-1,
		70,
		62,
		48,
		-1,
		41,
		-1,
		74,
		35,
		-1,
		64,
		44,
		-1,
		82,
		78,
		-1,
		-1,
		129,
		86,
		-1,
		-1,
		-1,
		72,
		47,
		69,
		53,
		-1,
		55,
		55,
		-1,
		-1,
		-1,
		114,
		95,
		-1,
		65,
		68,
		-1,
		54,
		60,
		89,
		57,
		61,
		-1,
		-1,
		-1,
		123,
		104,
		98,
		80,
		85,
		73,
		85,
		71,
		74,
		71,
		60,
		81,
		-1,
		-1,
		-1,
		95,
		87,
		87,
		-1,
		-1,
		99,
		82,
		82,
		80,
		-1,
		-1,
		-1,
		117,
		98,
		-1,
		-1,
		96,
		-1,
		-1,
		95,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		106,
		-1,
		-1,
		-1,
		97,
		100,
		101,
		-1,
		-1,
		-1,
		-1,
		127,
		128,
		152,
		127,
		-1,
		-1,
		-1,
		96,
		90,
		-1,
		-1,
		130,
		128,
		-1,
		-1,
		-1,
		124,
		108,
		-1,
		94,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		127,
		-1,
		-1,
		-1,
		129,
		-1,
		129,
		104,
		111,
		-1,
		-1,
		-1,
		-1,
		142,
		134,
		142,
		-1,
		114,
		116,
		-1,
		164,
		-1,
		-1,
		157,
		148,
		-1,
		-1,
		119,
		126,
		148,
		151,
		187,
		-1,
		138
	],
	[
		-1,
		250,
		239,
		250,
		258,
		231,
		238,
		-1,
		257,
		261,
		227,
		221,
		260,
		229,
		235,
		246,
		-1,
		-1,
		-1,
		250,
		249,
		217,
		215,
		224,
		229,
		236,
		-1,
		235,
		-1,
		271,
		250,
		261,
		266,
		210,
		207,
		227,
		246,
		228,
		220,
		286,
		240,
		211,
		205,
		223,
		213,
		222,
		214,
		-1,
		211,
		201,
		223,
		202,
		213,
		205,
		-1,
		-1,
		205,
		206,
		212,
		198,
		204,
		200,
		-1,
		210,
		194,
		-1,
		-1,
		195,
		196,
		180,
		183,
		191,
		189,
		202,
		194,
		189,
		-1,
		-1,
		186,
		182,
		189,
		176,
		172,
		189,
		202,
		184,
		198,
		197,
		-1,
		190,
		208,
		215,
		183,
		181,
		165,
		163,
		181,
		183,
		189,
		189,
		-1,
		199,
		200,
		195,
		203,
		205,
		181,
		168,
		168,
		178,
		171,
		190,
		178,
		224,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		199,
		182,
		199,
		191,
		181,
		196,
		189,
		171,
		168,
		166,
		163,
		179,
		177,
		187,
		-1,
		-1,
		292,
		261,
		290,
		248,
		229,
		-1,
		195,
		175,
		181,
		185,
		179,
		172,
		186,
		182,
		-1,
		157,
		156,
		184,
		170,
		181,
		252,
		-1,
		-1,
		250,
		242,
		225,
		228,
		205,
		201,
		190,
		189,
		181,
		167,
		163,
		169,
		172,
		172,
		178,
		151,
		161,
		165,
		163,
		188,
		-1,
		-1,
		223,
		-1,
		-1,
		249,
		232,
		-1,
		215,
		222,
		211,
		217,
		203,
		224,
		200,
		191,
		183,
		177,
		165,
		167,
		164,
		177,
		165,
		148,
		173,
		177,
		158,
		179,
		174,
		-1,
		222,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		208,
		211,
		217,
		241,
		240,
		-1,
		212,
		200,
		201,
		186,
		183,
		170,
		158,
		171,
		156,
		163,
		162,
		152,
		150,
		180,
		155,
		177,
		174,
		193,
		198,
		192,
		201,
		-1,
		257,
		253,
		249,
		256,
		205,
		-1,
		-1,
		245,
		-1,
		248,
		249,
		224,
		197,
		200,
		187,
		178,
		165,
		154,
		165,
		154,
		151,
		159,
		144,
		159,
		150,
		149,
		167,
		177,
		185,
		189,
		195,
		-1,
		307,
		-1,
		249,
		233,
		235,
		207,
		228,
		-1,
		265,
		249,
		241,
		226,
		226,
		-1,
		196,
		193,
		183,
		161,
		146,
		163,
		155,
		153,
		157,
		139,
		153,
		144,
		162,
		169,
		167,
		171,
		191,
		203,
		267,
		257,
		-1,
		239,
		244,
		203,
		211,
		230,
		268,
		232,
		-1,
		227,
		-1,
		198,
		211,
		-1,
		167,
		163,
		145,
		146,
		141,
		156,
		150,
		135,
		132,
		150,
		153,
		160,
		164,
		180,
		-1,
		-1,
		252,
		256,
		245,
		196,
		215,
		239,
		276,
		225,
		214,
		213,
		-1,
		204,
		181,
		178,
		166,
		153,
		138,
		139,
		147,
		160,
		139,
		134,
		131,
		151,
		177,
		155,
		167,
		-1,
		-1,
		-1,
		277,
		-1,
		-1,
		222,
		193,
		217,
		259,
		243,
		236,
		224,
		189,
		189,
		183,
		-1,
		177,
		156,
		147,
		136,
		134,
		147,
		144,
		149,
		129,
		127,
		146,
		158,
		149,
		166,
		-1,
		-1,
		-1,
		252,
		241,
		242,
		188,
		211,
		248,
		222,
		208,
		213,
		188,
		181,
		175,
		190,
		173,
		154,
		143,
		135,
		124,
		140,
		148,
		143,
		125,
		134,
		140,
		164,
		154,
		160,
		-1,
		-1,
		259,
		249,
		233,
		235,
		232,
		202,
		209,
		241,
		213,
		226,
		-1,
		180,
		-1,
		169,
		164,
		148,
		143,
		140,
		137,
		131,
		140,
		142,
		132,
		127,
		134,
		169,
		169,
		144,
		164,
		167,
		-1,
		-1,
		-1,
		252,
		247,
		222,
		199,
		183,
		219,
		-1,
		196,
		197,
		-1,
		174,
		168,
		165,
		150,
		146,
		141,
		145,
		138,
		145,
		138,
		136,
		137,
		119,
		151,
		-1,
		152,
		146,
		154,
		144,
		132,
		-1,
		-1,
		-1,
		245,
		224,
		217,
		237,
		178,
		230,
		-1,
		-1,
		181,
		174,
		-1,
		161,
		143,
		150,
		148,
		142,
		146,
		143,
		132,
		145,
		138,
		124,
		126,
		139,
		143,
		147,
		134,
		130,
		127,
		141,
		-1,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		178,
		198,
		-1,
		190,
		182,
		172,
		166,
		160,
		156,
		154,
		170,
		154,
		157,
		155,
		146,
		154,
		127,
		120,
		127,
		116,
		134,
		142,
		134,
		128,
		127,
		137,
		-1,
		265,
		251,
		222,
		-1,
		-1,
		211,
		-1,
		175,
		189,
		205,
		-1,
		198,
		177,
		192,
		170,
		166,
		162,
		177,
		178,
		155,
		155,
		153,
		144,
		132,
		121,
		124,
		116,
		138,
		138,
		122,
		123,
		127,
		-1,
		271,
		258,
		216,
		212,
		201,
		221,
		172,
		160,
		192,
		-1,
		-1,
		234,
		-1,
		168,
		185,
		176,
		174,
		167,
		149,
		156,
		164,
		141,
		136,
		126,
		115,
		115,
		110,
		132,
		118,
		116,
		125,
		141,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		187,
		174,
		168,
		-1,
		209,
		-1,
		212,
		202,
		186,
		171,
		204,
		-1,
		148,
		144,
		151,
		-1,
		161,
		-1,
		134,
		131,
		122,
		107,
		104,
		115,
		113,
		124,
		120,
		-1,
		221,
		206,
		199,
		189,
		203,
		174,
		-1,
		229,
		-1,
		-1,
		199,
		193,
		193,
		177,
		178,
		164,
		144,
		136,
		151,
		150,
		137,
		136,
		120,
		113,
		110,
		103,
		116,
		126,
		131,
		118,
		-1,
		-1,
		-1,
		226,
		212,
		216,
		176,
		195,
		-1,
		-1,
		261,
		216,
		202,
		-1,
		173,
		164,
		152,
		142,
		132,
		137,
		138,
		128,
		126,
		118,
		120,
		114,
		105,
		104,
		120,
		112,
		134,
		-1,
		-1,
		209,
		214,
		202,
		188,
		203,
		-1,
		-1,
		-1,
		208,
		224,
		192,
		171,
		153,
		-1,
		-1,
		136,
		129,
		123,
		126,
		114,
		134,
		129,
		113,
		98,
		113,
		117,
		125,
		116,
		-1,
		212,
		199,
		-1,
		-1,
		202,
		192,
		-1,
		-1,
		-1,
		-1,
		204,
		149,
		138,
		133,
		137,
		135,
		-1,
		109,
		120,
		113,
		132,
		139,
		115,
		100,
		94,
		100,
		112,
		121,
		-1,
		-1,
		216,
		-1,
		178,
		-1,
		-1,
		-1,
		-1,
		161,
		155,
		126,
		119,
		123,
		-1,
		111,
		113,
		110,
		122,
		118,
		115,
		106,
		97,
		93,
		97,
		101,
		115,
		119,
		239,
		-1,
		169,
		-1,
		-1,
		-1,
		179,
		194,
		165,
		142,
		115,
		110,
		103,
		97,
		102,
		113,
		122,
		133,
		98,
		100,
		90,
		89,
		93,
		110,
		114,
		-1,
		-1,
		167,
		163,
		198,
		187,
		191,
		192,
		-1,
		-1,
		119,
		110,
		101,
		93,
		106,
		109,
		94,
		96,
		96,
		94,
		88,
		98,
		113,
		108,
		-1,
		-1,
		-1,
		179,
		-1,
		181,
		-1,
		-1,
		189,
		190,
		137,
		119,
		115,
		113,
		102,
		96,
		84,
		89,
		99,
		93,
		90,
		84,
		88,
		111,
		100,
		139,
		-1,
		-1,
		235,
		-1,
		-1,
		-1,
		178,
		150,
		145,
		171,
		173,
		164,
		152,
		149,
		-1,
		119,
		125,
		90,
		97,
		80,
		87,
		92,
		89,
		78,
		85,
		101,
		100,
		95,
		131,
		122,
		128,
		-1,
		-1,
		228,
		217,
		206,
		212,
		-1,
		171,
		147,
		157,
		147,
		150,
		-1,
		-1,
		144,
		141,
		121,
		90,
		88,
		81,
		76,
		86,
		62,
		74,
		78,
		82,
		88,
		93,
		98,
		104,
		119,
		134,
		-1,
		182,
		219,
		212,
		180,
		188,
		219,
		-1,
		161,
		153,
		144,
		139,
		141,
		-1,
		-1,
		117,
		108,
		109,
		97,
		94,
		100,
		99,
		82,
		88,
		89,
		81,
		80,
		98,
		102,
		111,
		118,
		108,
		121,
		125,
		-1,
		175,
		195,
		174,
		177,
		201,
		215,
		-1,
		158,
		-1,
		-1,
		104,
		142,
		126,
		116,
		113,
		156,
		111,
		106,
		87,
		85,
		80,
		71,
		96,
		89,
		89,
		92,
		107,
		112,
		104,
		118,
		118,
		119,
		-1,
		164,
		175,
		168,
		-1,
		-1,
		-1,
		-1,
		159,
		-1,
		-1,
		94,
		-1,
		153,
		-1,
		136,
		140,
		119,
		122,
		101,
		88,
		74,
		82,
		88,
		87,
		93,
		93,
		94,
		103,
		114,
		126,
		125,
		126,
		189,
		145,
		148,
		159,
		170,
		185,
		189,
		-1,
		153,
		189,
		100,
		-1,
		84,
		-1,
		-1,
		-1,
		150,
		132,
		124,
		121,
		100,
		100,
		66,
		70,
		83,
		90,
		100,
		111,
		103,
		107,
		120,
		131,
		134,
		185,
		176,
		189,
		134,
		134,
		155,
		164,
		185,
		149,
		146,
		183,
		107,
		96,
		91,
		78,
		-1,
		-1,
		134,
		142,
		-1,
		-1,
		107,
		74,
		62,
		72,
		76,
		90,
		102,
		115,
		103,
		108,
		102,
		134,
		-1,
		178,
		177,
		166,
		163,
		139,
		130,
		125,
		152,
		-1,
		-1,
		147,
		174,
		158,
		140,
		138,
		163,
		-1,
		67,
		-1,
		-1,
		114,
		-1,
		-1,
		99,
		79,
		68,
		59,
		64,
		84,
		95,
		117,
		99,
		116,
		107,
		117,
		121,
		162,
		159,
		147,
		145,
		168,
		133,
		121,
		-1,
		129,
		132,
		138,
		145,
		141,
		152,
		-1,
		-1,
		83,
		63,
		-1,
		-1,
		97,
		95,
		84,
		-1,
		74,
		56,
		61,
		91,
		93,
		95,
		102,
		96,
		103,
		111,
		122,
		114,
		171,
		185,
		174,
		170,
		169,
		177,
		126,
		119,
		126,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		-1,
		73,
		69,
		-1,
		-1,
		92,
		85,
		73,
		61,
		51,
		61,
		78,
		78,
		81,
		86,
		94,
		105,
		101,
		105,
		108,
		-1,
		205,
		-1,
		157,
		118,
		124,
		139,
		147,
		-1,
		-1,
		-1,
		90,
		76,
		69,
		57,
		55,
		-1,
		126,
		110,
		91,
		-1,
		61,
		74,
		114,
		82,
		87,
		82,
		97,
		108,
		99,
		107,
		101,
		104,
		-1,
		-1,
		117,
		100,
		-1,
		-1,
		74,
		76,
		-1,
		81,
		70,
		55,
		47,
		-1,
		-1,
		98,
		94,
		-1,
		-1,
		48,
		86,
		85,
		93,
		88,
		93,
		105,
		101,
		97,
		107,
		98,
		-1,
		-1,
		95,
		87,
		81,
		-1,
		59,
		-1,
		83,
		-1,
		50,
		48,
		36,
		-1,
		-1,
		-1,
		79,
		42,
		58,
		81,
		107,
		105,
		96,
		89,
		96,
		99,
		92,
		98,
		-1,
		-1,
		-1,
		77,
		51,
		90,
		81,
		64,
		44,
		36,
		47,
		-1,
		60,
		-1,
		35,
		38,
		63,
		102,
		104,
		90,
		86,
		99,
		93,
		90,
		88,
		83,
		-1,
		53,
		86,
		50,
		50,
		26,
		24,
		74,
		-1,
		57,
		39,
		-1,
		67,
		57,
		105,
		80,
		89,
		82,
		76,
		77,
		85,
		-1,
		-1,
		-1,
		55,
		54,
		46,
		40,
		40,
		31,
		14,
		-1,
		62,
		44,
		30,
		47,
		47,
		38,
		46,
		95,
		91,
		94,
		92,
		70,
		-1,
		171,
		-1,
		-1,
		78,
		-1,
		-1,
		-1,
		49,
		42,
		15,
		11,
		19,
		32,
		27,
		29,
		42,
		50,
		48,
		45,
		57,
		53,
		73,
		69,
		101,
		-1,
		166,
		-1,
		85,
		-1,
		-1,
		67,
		47,
		37,
		26,
		0,
		15,
		20,
		22,
		44,
		74,
		60,
		58,
		63,
		68,
		-1,
		155,
		154,
		-1,
		86,
		78,
		64,
		-1,
		57,
		-1,
		61,
		22,
		-1,
		51,
		31,
		-1,
		69,
		65,
		-1,
		-1,
		142,
		102,
		-1,
		-1,
		-1,
		87,
		67,
		56,
		40,
		-1,
		42,
		42,
		-1,
		-1,
		-1,
		127,
		111,
		-1,
		80,
		83,
		-1,
		74,
		80,
		97,
		44,
		48,
		-1,
		-1,
		-1,
		136,
		117,
		111,
		95,
		100,
		88,
		105,
		91,
		80,
		58,
		47,
		68,
		-1,
		-1,
		-1,
		108,
		100,
		100,
		-1,
		-1,
		105,
		88,
		69,
		67,
		-1,
		-1,
		-1,
		130,
		111,
		-1,
		-1,
		95,
		-1,
		-1,
		101,
		66,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		119,
		-1,
		-1,
		-1,
		91,
		87,
		88,
		-1,
		-1,
		-1,
		-1,
		140,
		141,
		165,
		139,
		-1,
		-1,
		-1,
		83,
		77,
		-1,
		-1,
		143,
		141,
		-1,
		-1,
		-1,
		111,
		95,
		-1,
		81,
		-1,
		-1,
		-1,
		102,
		-1,
		-1,
		114,
		-1,
		-1,
		-1,
		116,
		-1,
		116,
		91,
		98,
		-1,
		-1,
		-1,
		-1,
		129,
		121,
		129,
		-1,
		101,
		103,
		-1,
		151,
		-1,
		-1,
		144,
		135,
		-1,
		-1,
		106,
		113,
		135,
		138,
		174,
		-1,
		125
	],
	[
		-1,
		249,
		238,
		249,
		257,
		230,
		237,
		-1,
		256,
		260,
		226,
		220,
		259,
		228,
		234,
		245,
		-1,
		-1,
		-1,
		249,
		248,
		216,
		214,
		223,
		228,
		235,
		-1,
		234,
		-1,
		270,
		249,
		260,
		265,
		209,
		206,
		226,
		245,
		227,
		219,
		285,
		239,
		210,
		204,
		222,
		212,
		221,
		213,
		-1,
		210,
		200,
		222,
		201,
		212,
		204,
		-1,
		-1,
		204,
		205,
		211,
		197,
		203,
		199,
		-1,
		209,
		193,
		-1,
		-1,
		194,
		195,
		179,
		182,
		190,
		188,
		201,
		193,
		188,
		-1,
		-1,
		185,
		181,
		188,
		175,
		171,
		188,
		201,
		183,
		197,
		196,
		-1,
		189,
		207,
		214,
		182,
		180,
		164,
		162,
		180,
		182,
		188,
		188,
		-1,
		198,
		199,
		194,
		202,
		204,
		180,
		167,
		167,
		177,
		170,
		189,
		177,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		198,
		181,
		198,
		190,
		180,
		195,
		188,
		170,
		167,
		165,
		162,
		178,
		176,
		186,
		-1,
		-1,
		291,
		260,
		289,
		247,
		228,
		-1,
		194,
		174,
		180,
		184,
		178,
		171,
		185,
		181,
		-1,
		156,
		155,
		183,
		169,
		180,
		251,
		-1,
		-1,
		249,
		241,
		224,
		227,
		204,
		200,
		189,
		188,
		180,
		166,
		162,
		168,
		171,
		171,
		177,
		150,
		160,
		164,
		162,
		187,
		-1,
		-1,
		222,
		-1,
		-1,
		248,
		231,
		-1,
		214,
		221,
		210,
		216,
		202,
		223,
		199,
		190,
		182,
		176,
		164,
		166,
		163,
		176,
		164,
		147,
		172,
		176,
		157,
		178,
		173,
		-1,
		221,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		207,
		210,
		216,
		240,
		239,
		-1,
		211,
		199,
		200,
		185,
		182,
		169,
		157,
		170,
		155,
		162,
		161,
		151,
		149,
		179,
		154,
		176,
		173,
		192,
		197,
		191,
		200,
		-1,
		256,
		252,
		248,
		255,
		204,
		-1,
		-1,
		244,
		-1,
		247,
		248,
		223,
		196,
		199,
		186,
		177,
		164,
		153,
		164,
		153,
		150,
		158,
		143,
		158,
		149,
		148,
		166,
		176,
		184,
		188,
		194,
		-1,
		306,
		-1,
		248,
		232,
		234,
		206,
		227,
		-1,
		264,
		248,
		240,
		225,
		225,
		-1,
		195,
		192,
		182,
		160,
		145,
		162,
		154,
		152,
		156,
		138,
		152,
		143,
		161,
		168,
		166,
		170,
		190,
		202,
		266,
		256,
		-1,
		238,
		243,
		202,
		210,
		229,
		267,
		231,
		-1,
		226,
		-1,
		197,
		210,
		-1,
		166,
		162,
		144,
		145,
		140,
		155,
		149,
		134,
		131,
		149,
		152,
		159,
		163,
		179,
		-1,
		-1,
		251,
		255,
		244,
		195,
		214,
		238,
		275,
		224,
		213,
		212,
		-1,
		203,
		180,
		177,
		165,
		152,
		137,
		138,
		146,
		159,
		138,
		133,
		130,
		150,
		176,
		154,
		166,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		221,
		192,
		216,
		258,
		242,
		235,
		223,
		188,
		188,
		182,
		-1,
		176,
		155,
		146,
		135,
		133,
		146,
		143,
		148,
		128,
		126,
		145,
		157,
		148,
		165,
		-1,
		-1,
		-1,
		251,
		240,
		241,
		187,
		210,
		247,
		221,
		207,
		212,
		187,
		180,
		174,
		189,
		172,
		153,
		142,
		134,
		123,
		139,
		147,
		142,
		124,
		133,
		139,
		163,
		153,
		159,
		-1,
		-1,
		258,
		248,
		232,
		234,
		231,
		201,
		208,
		240,
		212,
		225,
		-1,
		179,
		-1,
		168,
		163,
		147,
		142,
		139,
		136,
		130,
		139,
		141,
		131,
		126,
		133,
		168,
		168,
		143,
		163,
		166,
		-1,
		-1,
		-1,
		251,
		246,
		221,
		198,
		182,
		218,
		-1,
		195,
		196,
		-1,
		173,
		167,
		164,
		149,
		145,
		140,
		144,
		137,
		144,
		137,
		135,
		136,
		118,
		150,
		-1,
		151,
		145,
		153,
		143,
		131,
		-1,
		-1,
		-1,
		244,
		223,
		216,
		236,
		177,
		229,
		-1,
		-1,
		180,
		173,
		-1,
		160,
		142,
		149,
		147,
		141,
		145,
		142,
		131,
		144,
		137,
		123,
		125,
		138,
		142,
		146,
		133,
		129,
		126,
		140,
		-1,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		197,
		-1,
		189,
		181,
		171,
		165,
		159,
		155,
		153,
		169,
		153,
		156,
		154,
		145,
		153,
		126,
		119,
		126,
		115,
		133,
		141,
		133,
		127,
		126,
		136,
		-1,
		264,
		250,
		221,
		-1,
		-1,
		210,
		-1,
		174,
		188,
		204,
		-1,
		197,
		176,
		191,
		169,
		165,
		161,
		176,
		177,
		154,
		154,
		152,
		143,
		131,
		120,
		123,
		115,
		137,
		137,
		121,
		122,
		126,
		-1,
		270,
		257,
		215,
		211,
		200,
		220,
		171,
		159,
		191,
		-1,
		-1,
		233,
		-1,
		167,
		184,
		175,
		173,
		166,
		148,
		155,
		163,
		140,
		135,
		125,
		114,
		114,
		109,
		131,
		117,
		115,
		124,
		140,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		186,
		173,
		167,
		-1,
		208,
		-1,
		211,
		201,
		185,
		170,
		203,
		-1,
		147,
		143,
		150,
		-1,
		160,
		-1,
		133,
		130,
		121,
		106,
		103,
		114,
		112,
		123,
		119,
		-1,
		220,
		205,
		198,
		188,
		202,
		173,
		-1,
		228,
		-1,
		-1,
		198,
		192,
		192,
		176,
		177,
		163,
		143,
		135,
		150,
		149,
		136,
		135,
		119,
		112,
		109,
		102,
		115,
		125,
		130,
		117,
		-1,
		-1,
		-1,
		225,
		211,
		215,
		175,
		194,
		-1,
		-1,
		260,
		215,
		201,
		-1,
		172,
		163,
		151,
		141,
		131,
		136,
		137,
		127,
		125,
		117,
		119,
		113,
		104,
		103,
		119,
		111,
		133,
		-1,
		-1,
		208,
		213,
		201,
		187,
		202,
		-1,
		-1,
		-1,
		207,
		223,
		191,
		170,
		152,
		-1,
		-1,
		135,
		128,
		122,
		125,
		113,
		133,
		128,
		112,
		97,
		112,
		116,
		124,
		115,
		-1,
		211,
		198,
		-1,
		-1,
		201,
		191,
		-1,
		-1,
		-1,
		-1,
		203,
		148,
		137,
		132,
		136,
		134,
		-1,
		108,
		119,
		112,
		131,
		138,
		114,
		99,
		93,
		99,
		111,
		120,
		-1,
		-1,
		215,
		-1,
		177,
		-1,
		-1,
		-1,
		-1,
		160,
		154,
		125,
		118,
		122,
		-1,
		110,
		112,
		109,
		121,
		117,
		114,
		105,
		96,
		92,
		96,
		100,
		114,
		118,
		238,
		-1,
		168,
		-1,
		-1,
		-1,
		178,
		193,
		164,
		141,
		114,
		109,
		102,
		96,
		101,
		112,
		121,
		132,
		97,
		99,
		89,
		88,
		92,
		109,
		113,
		-1,
		-1,
		166,
		162,
		197,
		186,
		190,
		191,
		-1,
		-1,
		118,
		109,
		100,
		92,
		105,
		108,
		93,
		95,
		95,
		93,
		87,
		97,
		112,
		107,
		-1,
		-1,
		-1,
		178,
		-1,
		180,
		-1,
		-1,
		188,
		189,
		136,
		118,
		114,
		112,
		101,
		95,
		83,
		88,
		98,
		92,
		89,
		83,
		87,
		110,
		99,
		138,
		-1,
		-1,
		237,
		-1,
		-1,
		-1,
		177,
		149,
		144,
		170,
		172,
		163,
		151,
		148,
		-1,
		118,
		124,
		89,
		96,
		79,
		86,
		91,
		88,
		77,
		84,
		100,
		99,
		94,
		130,
		121,
		127,
		-1,
		-1,
		230,
		219,
		208,
		214,
		-1,
		170,
		146,
		156,
		146,
		149,
		-1,
		-1,
		143,
		140,
		120,
		89,
		87,
		80,
		75,
		85,
		61,
		73,
		77,
		81,
		87,
		92,
		97,
		103,
		118,
		133,
		-1,
		184,
		221,
		214,
		182,
		190,
		221,
		-1,
		160,
		152,
		143,
		138,
		140,
		-1,
		-1,
		116,
		107,
		108,
		96,
		93,
		99,
		98,
		81,
		87,
		88,
		80,
		79,
		97,
		101,
		110,
		117,
		107,
		120,
		124,
		-1,
		177,
		197,
		176,
		179,
		203,
		217,
		-1,
		157,
		-1,
		-1,
		103,
		141,
		125,
		115,
		112,
		155,
		110,
		105,
		86,
		84,
		79,
		70,
		95,
		88,
		88,
		91,
		106,
		111,
		103,
		117,
		117,
		118,
		-1,
		166,
		177,
		170,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		-1,
		93,
		-1,
		152,
		-1,
		135,
		139,
		118,
		121,
		100,
		87,
		73,
		81,
		87,
		86,
		92,
		92,
		93,
		102,
		113,
		125,
		124,
		125,
		191,
		147,
		150,
		161,
		172,
		187,
		191,
		-1,
		155,
		191,
		99,
		-1,
		83,
		-1,
		-1,
		-1,
		149,
		131,
		123,
		120,
		99,
		99,
		65,
		69,
		82,
		89,
		99,
		110,
		102,
		106,
		119,
		130,
		133,
		187,
		178,
		191,
		136,
		136,
		157,
		166,
		187,
		151,
		148,
		185,
		106,
		95,
		90,
		77,
		-1,
		-1,
		133,
		141,
		-1,
		-1,
		106,
		73,
		61,
		71,
		75,
		89,
		101,
		114,
		102,
		107,
		101,
		133,
		-1,
		180,
		179,
		168,
		165,
		141,
		132,
		127,
		154,
		-1,
		-1,
		149,
		176,
		160,
		139,
		137,
		162,
		-1,
		66,
		-1,
		-1,
		113,
		-1,
		-1,
		98,
		78,
		67,
		58,
		63,
		83,
		94,
		116,
		98,
		115,
		106,
		116,
		120,
		164,
		161,
		149,
		147,
		170,
		135,
		123,
		-1,
		131,
		134,
		140,
		147,
		140,
		151,
		-1,
		-1,
		82,
		62,
		-1,
		-1,
		96,
		94,
		83,
		-1,
		73,
		55,
		60,
		90,
		92,
		94,
		101,
		95,
		102,
		110,
		121,
		113,
		173,
		187,
		176,
		172,
		171,
		179,
		128,
		121,
		128,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		-1,
		72,
		68,
		-1,
		-1,
		91,
		84,
		72,
		60,
		50,
		60,
		77,
		77,
		80,
		85,
		93,
		104,
		100,
		104,
		107,
		-1,
		207,
		-1,
		159,
		120,
		126,
		141,
		149,
		-1,
		-1,
		-1,
		89,
		75,
		68,
		56,
		54,
		-1,
		125,
		109,
		90,
		-1,
		60,
		73,
		113,
		81,
		86,
		81,
		96,
		107,
		98,
		106,
		100,
		103,
		-1,
		-1,
		119,
		102,
		-1,
		-1,
		76,
		78,
		-1,
		80,
		69,
		54,
		46,
		-1,
		-1,
		97,
		93,
		-1,
		-1,
		47,
		85,
		84,
		92,
		87,
		92,
		104,
		100,
		96,
		106,
		97,
		-1,
		-1,
		97,
		89,
		83,
		-1,
		61,
		-1,
		82,
		-1,
		49,
		50,
		38,
		-1,
		-1,
		-1,
		78,
		41,
		57,
		80,
		106,
		104,
		95,
		88,
		95,
		98,
		91,
		97,
		-1,
		-1,
		-1,
		79,
		53,
		89,
		80,
		63,
		43,
		35,
		49,
		-1,
		59,
		-1,
		34,
		37,
		62,
		101,
		103,
		89,
		85,
		98,
		92,
		89,
		87,
		85,
		-1,
		55,
		88,
		52,
		49,
		25,
		26,
		73,
		-1,
		56,
		38,
		-1,
		66,
		56,
		104,
		79,
		88,
		81,
		75,
		76,
		84,
		-1,
		-1,
		-1,
		57,
		56,
		48,
		42,
		42,
		30,
		16,
		-1,
		61,
		43,
		29,
		46,
		46,
		37,
		45,
		94,
		90,
		93,
		91,
		69,
		-1,
		173,
		-1,
		-1,
		80,
		-1,
		-1,
		-1,
		51,
		44,
		17,
		10,
		15,
		31,
		26,
		28,
		41,
		49,
		47,
		44,
		56,
		52,
		72,
		68,
		100,
		-1,
		168,
		-1,
		87,
		-1,
		-1,
		69,
		49,
		39,
		28,
		14,
		0,
		16,
		21,
		43,
		73,
		59,
		57,
		62,
		67,
		-1,
		157,
		156,
		-1,
		88,
		80,
		66,
		-1,
		59,
		-1,
		60,
		21,
		-1,
		50,
		30,
		-1,
		68,
		64,
		-1,
		-1,
		144,
		104,
		-1,
		-1,
		-1,
		89,
		69,
		55,
		39,
		-1,
		41,
		41,
		-1,
		-1,
		-1,
		129,
		113,
		-1,
		82,
		85,
		-1,
		76,
		82,
		96,
		43,
		47,
		-1,
		-1,
		-1,
		138,
		119,
		113,
		97,
		102,
		90,
		107,
		93,
		79,
		57,
		46,
		67,
		-1,
		-1,
		-1,
		110,
		102,
		102,
		-1,
		-1,
		104,
		87,
		68,
		66,
		-1,
		-1,
		-1,
		132,
		113,
		-1,
		-1,
		94,
		-1,
		-1,
		100,
		65,
		-1,
		-1,
		-1,
		-1,
		-1,
		148,
		121,
		-1,
		-1,
		-1,
		90,
		86,
		87,
		-1,
		-1,
		-1,
		-1,
		142,
		143,
		167,
		138,
		-1,
		-1,
		-1,
		82,
		76,
		-1,
		-1,
		145,
		143,
		-1,
		-1,
		-1,
		110,
		94,
		-1,
		80,
		-1,
		-1,
		-1,
		101,
		-1,
		-1,
		113,
		-1,
		-1,
		-1,
		115,
		-1,
		115,
		90,
		97,
		-1,
		-1,
		-1,
		-1,
		128,
		120,
		128,
		-1,
		100,
		102,
		-1,
		150,
		-1,
		-1,
		143,
		134,
		-1,
		-1,
		105,
		112,
		134,
		137,
		173,
		-1,
		124
	],
	[
		-1,
		242,
		231,
		242,
		250,
		223,
		230,
		-1,
		249,
		253,
		219,
		213,
		252,
		221,
		227,
		238,
		-1,
		-1,
		-1,
		242,
		241,
		209,
		207,
		216,
		221,
		228,
		-1,
		227,
		-1,
		263,
		242,
		253,
		258,
		202,
		199,
		219,
		238,
		220,
		212,
		278,
		232,
		203,
		197,
		215,
		205,
		214,
		206,
		-1,
		203,
		193,
		215,
		194,
		205,
		197,
		-1,
		-1,
		197,
		198,
		204,
		190,
		196,
		192,
		-1,
		202,
		186,
		-1,
		-1,
		187,
		188,
		172,
		175,
		183,
		181,
		194,
		186,
		181,
		-1,
		-1,
		178,
		174,
		181,
		168,
		164,
		181,
		194,
		176,
		190,
		189,
		-1,
		182,
		200,
		207,
		175,
		173,
		157,
		155,
		173,
		175,
		181,
		181,
		-1,
		191,
		192,
		187,
		195,
		197,
		173,
		160,
		160,
		170,
		163,
		182,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		174,
		191,
		183,
		173,
		188,
		181,
		163,
		160,
		158,
		155,
		171,
		169,
		179,
		-1,
		-1,
		284,
		253,
		282,
		240,
		221,
		-1,
		187,
		167,
		173,
		177,
		171,
		164,
		178,
		174,
		-1,
		149,
		148,
		176,
		162,
		173,
		244,
		-1,
		-1,
		242,
		234,
		217,
		220,
		197,
		193,
		182,
		181,
		173,
		159,
		155,
		161,
		164,
		164,
		170,
		143,
		153,
		157,
		155,
		180,
		-1,
		-1,
		215,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		203,
		209,
		195,
		216,
		192,
		183,
		175,
		169,
		157,
		159,
		156,
		169,
		157,
		140,
		165,
		169,
		150,
		171,
		166,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		232,
		-1,
		204,
		192,
		193,
		178,
		175,
		162,
		150,
		163,
		148,
		155,
		154,
		144,
		142,
		172,
		147,
		169,
		166,
		185,
		190,
		184,
		193,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		240,
		241,
		216,
		189,
		192,
		179,
		170,
		157,
		146,
		157,
		146,
		143,
		151,
		136,
		151,
		142,
		141,
		159,
		169,
		177,
		181,
		187,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		241,
		233,
		218,
		218,
		-1,
		188,
		185,
		175,
		153,
		138,
		155,
		147,
		145,
		149,
		131,
		145,
		136,
		154,
		161,
		159,
		163,
		183,
		195,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		260,
		224,
		-1,
		219,
		-1,
		190,
		203,
		-1,
		159,
		155,
		137,
		138,
		133,
		148,
		142,
		127,
		124,
		142,
		145,
		152,
		156,
		172,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		217,
		206,
		205,
		-1,
		196,
		173,
		170,
		158,
		145,
		130,
		131,
		139,
		152,
		131,
		126,
		123,
		143,
		169,
		147,
		159,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		235,
		228,
		216,
		181,
		181,
		175,
		-1,
		169,
		148,
		139,
		128,
		126,
		139,
		136,
		141,
		121,
		119,
		138,
		150,
		141,
		158,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		180,
		203,
		240,
		214,
		200,
		205,
		180,
		173,
		167,
		182,
		165,
		146,
		135,
		127,
		116,
		132,
		140,
		135,
		117,
		126,
		132,
		156,
		146,
		152,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		194,
		201,
		233,
		205,
		218,
		-1,
		172,
		-1,
		161,
		156,
		140,
		135,
		132,
		129,
		123,
		132,
		134,
		124,
		119,
		126,
		161,
		161,
		136,
		156,
		159,
		-1,
		-1,
		-1,
		244,
		239,
		214,
		191,
		175,
		211,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		142,
		138,
		133,
		137,
		130,
		137,
		130,
		128,
		129,
		111,
		143,
		-1,
		144,
		138,
		146,
		136,
		124,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		142,
		140,
		134,
		138,
		135,
		124,
		137,
		130,
		116,
		118,
		131,
		135,
		139,
		126,
		122,
		119,
		133,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		162,
		146,
		149,
		147,
		138,
		146,
		119,
		112,
		119,
		108,
		126,
		134,
		126,
		120,
		119,
		129,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		190,
		169,
		184,
		162,
		158,
		154,
		169,
		170,
		147,
		147,
		145,
		136,
		124,
		113,
		116,
		108,
		130,
		130,
		114,
		115,
		119,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		152,
		184,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		168,
		166,
		159,
		141,
		148,
		156,
		133,
		128,
		118,
		107,
		107,
		102,
		124,
		110,
		108,
		117,
		133,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		140,
		136,
		143,
		-1,
		153,
		-1,
		126,
		123,
		114,
		99,
		96,
		107,
		105,
		116,
		112,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		221,
		-1,
		-1,
		191,
		185,
		185,
		169,
		170,
		156,
		136,
		128,
		143,
		142,
		129,
		128,
		112,
		105,
		102,
		95,
		108,
		118,
		123,
		110,
		-1,
		-1,
		-1,
		218,
		204,
		208,
		168,
		187,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		165,
		156,
		144,
		134,
		124,
		129,
		130,
		120,
		118,
		110,
		112,
		106,
		97,
		96,
		112,
		104,
		126,
		-1,
		-1,
		201,
		206,
		194,
		180,
		199,
		-1,
		-1,
		-1,
		200,
		216,
		184,
		163,
		145,
		-1,
		-1,
		128,
		121,
		115,
		118,
		106,
		126,
		121,
		105,
		90,
		105,
		109,
		117,
		108,
		-1,
		204,
		191,
		-1,
		-1,
		202,
		194,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		105,
		124,
		131,
		107,
		92,
		86,
		92,
		104,
		113,
		-1,
		-1,
		216,
		-1,
		180,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		102,
		114,
		110,
		107,
		98,
		89,
		85,
		89,
		93,
		107,
		111,
		239,
		-1,
		171,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		114,
		125,
		90,
		92,
		82,
		81,
		85,
		102,
		106,
		-1,
		-1,
		169,
		165,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		86,
		88,
		88,
		86,
		80,
		90,
		105,
		100,
		-1,
		-1,
		-1,
		181,
		-1,
		183,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		94,
		88,
		76,
		81,
		91,
		85,
		82,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		170,
		152,
		147,
		163,
		165,
		156,
		144,
		141,
		-1,
		111,
		117,
		82,
		89,
		72,
		79,
		84,
		81,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		236,
		225,
		214,
		220,
		-1,
		163,
		149,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		80,
		73,
		68,
		78,
		54,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		190,
		227,
		220,
		188,
		196,
		227,
		-1,
		153,
		145,
		146,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		92,
		91,
		74,
		80,
		81,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		183,
		203,
		182,
		185,
		209,
		223,
		-1,
		150,
		-1,
		-1,
		106,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		79,
		77,
		72,
		63,
		88,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		172,
		183,
		176,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		96,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		93,
		80,
		66,
		74,
		80,
		79,
		85,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		197,
		153,
		156,
		167,
		178,
		193,
		197,
		-1,
		161,
		197,
		102,
		-1,
		86,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		113,
		92,
		92,
		58,
		62,
		75,
		82,
		92,
		103,
		95,
		99,
		112,
		123,
		126,
		193,
		184,
		197,
		142,
		142,
		163,
		172,
		193,
		157,
		154,
		191,
		109,
		98,
		93,
		80,
		-1,
		-1,
		126,
		134,
		-1,
		-1,
		99,
		66,
		54,
		64,
		68,
		82,
		94,
		107,
		95,
		100,
		94,
		126,
		-1,
		186,
		185,
		174,
		171,
		147,
		138,
		133,
		160,
		-1,
		-1,
		155,
		182,
		165,
		142,
		140,
		165,
		-1,
		69,
		-1,
		-1,
		106,
		-1,
		-1,
		91,
		71,
		60,
		51,
		56,
		76,
		87,
		109,
		91,
		108,
		99,
		109,
		113,
		170,
		167,
		155,
		153,
		176,
		141,
		129,
		-1,
		137,
		140,
		146,
		153,
		143,
		154,
		-1,
		-1,
		85,
		65,
		-1,
		-1,
		89,
		87,
		76,
		-1,
		66,
		48,
		53,
		83,
		85,
		87,
		94,
		88,
		95,
		103,
		114,
		106,
		179,
		193,
		182,
		178,
		177,
		185,
		134,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		90,
		-1,
		75,
		71,
		-1,
		-1,
		84,
		77,
		65,
		53,
		43,
		53,
		70,
		70,
		73,
		78,
		86,
		97,
		93,
		97,
		100,
		-1,
		213,
		-1,
		165,
		126,
		132,
		147,
		155,
		-1,
		-1,
		-1,
		92,
		78,
		71,
		59,
		57,
		-1,
		118,
		102,
		83,
		-1,
		53,
		66,
		106,
		74,
		79,
		74,
		89,
		100,
		91,
		99,
		93,
		96,
		-1,
		-1,
		125,
		108,
		-1,
		-1,
		82,
		84,
		-1,
		83,
		72,
		57,
		49,
		-1,
		-1,
		90,
		86,
		-1,
		-1,
		40,
		78,
		77,
		85,
		80,
		85,
		97,
		93,
		89,
		99,
		90,
		-1,
		-1,
		103,
		95,
		89,
		-1,
		67,
		-1,
		85,
		-1,
		52,
		58,
		46,
		-1,
		-1,
		-1,
		71,
		34,
		50,
		73,
		99,
		97,
		88,
		81,
		88,
		91,
		84,
		90,
		-1,
		-1,
		-1,
		85,
		59,
		92,
		83,
		66,
		46,
		38,
		57,
		-1,
		52,
		-1,
		27,
		30,
		55,
		94,
		96,
		82,
		78,
		91,
		85,
		82,
		80,
		91,
		-1,
		61,
		94,
		58,
		52,
		28,
		32,
		66,
		-1,
		49,
		31,
		-1,
		59,
		49,
		97,
		72,
		81,
		74,
		68,
		69,
		77,
		-1,
		-1,
		-1,
		63,
		62,
		54,
		48,
		48,
		33,
		24,
		-1,
		54,
		36,
		22,
		39,
		39,
		30,
		38,
		87,
		83,
		86,
		84,
		62,
		-1,
		171,
		-1,
		-1,
		86,
		-1,
		-1,
		-1,
		57,
		52,
		25,
		13,
		8,
		16,
		19,
		19,
		34,
		42,
		40,
		37,
		49,
		45,
		65,
		61,
		93,
		-1,
		166,
		-1,
		93,
		-1,
		-1,
		75,
		55,
		47,
		36,
		25,
		22,
		0,
		14,
		32,
		64,
		52,
		50,
		55,
		60,
		-1,
		155,
		154,
		-1,
		94,
		86,
		72,
		-1,
		65,
		-1,
		71,
		32,
		-1,
		37,
		15,
		-1,
		61,
		57,
		-1,
		-1,
		142,
		110,
		-1,
		-1,
		-1,
		95,
		75,
		66,
		50,
		-1,
		29,
		28,
		-1,
		-1,
		-1,
		127,
		119,
		-1,
		88,
		91,
		-1,
		82,
		79,
		87,
		35,
		39,
		-1,
		-1,
		-1,
		136,
		117,
		111,
		103,
		108,
		96,
		100,
		86,
		70,
		48,
		38,
		57,
		-1,
		-1,
		-1,
		108,
		100,
		93,
		-1,
		-1,
		95,
		78,
		59,
		57,
		-1,
		-1,
		-1,
		130,
		111,
		-1,
		-1,
		85,
		-1,
		-1,
		91,
		56,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		119,
		-1,
		-1,
		-1,
		81,
		77,
		78,
		-1,
		-1,
		-1,
		-1,
		141,
		142,
		165,
		129,
		-1,
		-1,
		-1,
		73,
		67,
		-1,
		-1,
		144,
		142,
		-1,
		-1,
		-1,
		101,
		85,
		-1,
		71,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		104,
		-1,
		-1,
		-1,
		106,
		-1,
		106,
		81,
		88,
		-1,
		-1,
		-1,
		-1,
		119,
		111,
		119,
		-1,
		91,
		93,
		-1,
		141,
		-1,
		-1,
		134,
		125,
		-1,
		-1,
		96,
		103,
		125,
		128,
		164,
		-1,
		115
	],
	[
		-1,
		228,
		217,
		228,
		236,
		209,
		216,
		-1,
		235,
		239,
		205,
		199,
		238,
		207,
		213,
		224,
		-1,
		-1,
		-1,
		228,
		227,
		195,
		193,
		202,
		207,
		214,
		-1,
		213,
		-1,
		249,
		228,
		239,
		244,
		188,
		185,
		205,
		224,
		206,
		198,
		264,
		218,
		189,
		183,
		201,
		191,
		200,
		192,
		-1,
		189,
		179,
		201,
		180,
		191,
		183,
		-1,
		-1,
		183,
		184,
		190,
		176,
		182,
		178,
		-1,
		188,
		172,
		-1,
		-1,
		173,
		174,
		158,
		161,
		169,
		167,
		180,
		172,
		167,
		-1,
		-1,
		164,
		160,
		167,
		154,
		150,
		167,
		180,
		162,
		176,
		175,
		-1,
		168,
		186,
		193,
		161,
		159,
		143,
		141,
		159,
		161,
		167,
		167,
		-1,
		177,
		178,
		173,
		181,
		183,
		159,
		146,
		146,
		156,
		149,
		168,
		156,
		202,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		177,
		160,
		177,
		169,
		159,
		174,
		167,
		149,
		146,
		144,
		141,
		157,
		155,
		165,
		-1,
		-1,
		270,
		239,
		268,
		226,
		207,
		-1,
		173,
		153,
		159,
		163,
		157,
		150,
		164,
		160,
		-1,
		135,
		134,
		162,
		148,
		159,
		230,
		-1,
		-1,
		228,
		220,
		203,
		206,
		183,
		179,
		168,
		167,
		159,
		145,
		141,
		147,
		150,
		150,
		156,
		129,
		139,
		143,
		141,
		166,
		-1,
		-1,
		201,
		-1,
		-1,
		227,
		210,
		-1,
		193,
		200,
		189,
		195,
		181,
		202,
		178,
		169,
		161,
		155,
		143,
		145,
		142,
		155,
		143,
		126,
		151,
		155,
		136,
		157,
		152,
		-1,
		200,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		186,
		189,
		195,
		219,
		218,
		-1,
		190,
		178,
		179,
		164,
		161,
		148,
		136,
		149,
		134,
		141,
		140,
		130,
		128,
		158,
		133,
		155,
		152,
		171,
		176,
		170,
		179,
		-1,
		235,
		231,
		227,
		234,
		183,
		-1,
		-1,
		223,
		-1,
		226,
		227,
		202,
		175,
		178,
		165,
		156,
		143,
		132,
		143,
		132,
		129,
		137,
		122,
		137,
		128,
		127,
		145,
		155,
		163,
		167,
		173,
		-1,
		285,
		-1,
		227,
		211,
		213,
		185,
		206,
		-1,
		243,
		227,
		219,
		204,
		204,
		-1,
		174,
		171,
		161,
		139,
		124,
		141,
		133,
		131,
		135,
		117,
		131,
		122,
		140,
		147,
		145,
		149,
		169,
		181,
		245,
		235,
		-1,
		217,
		222,
		181,
		189,
		208,
		246,
		210,
		-1,
		205,
		-1,
		176,
		189,
		-1,
		145,
		141,
		123,
		124,
		119,
		134,
		128,
		113,
		110,
		128,
		131,
		138,
		142,
		158,
		-1,
		-1,
		230,
		234,
		223,
		174,
		193,
		217,
		254,
		203,
		192,
		191,
		-1,
		182,
		159,
		156,
		144,
		131,
		116,
		117,
		125,
		138,
		117,
		112,
		109,
		129,
		155,
		133,
		145,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		200,
		171,
		195,
		237,
		221,
		214,
		202,
		167,
		167,
		161,
		-1,
		155,
		134,
		125,
		114,
		112,
		125,
		122,
		127,
		107,
		105,
		124,
		136,
		127,
		144,
		-1,
		-1,
		-1,
		230,
		219,
		220,
		166,
		189,
		226,
		200,
		186,
		191,
		166,
		159,
		153,
		168,
		151,
		132,
		121,
		113,
		102,
		118,
		126,
		121,
		103,
		112,
		118,
		142,
		132,
		138,
		-1,
		-1,
		237,
		227,
		211,
		213,
		210,
		180,
		187,
		219,
		191,
		204,
		-1,
		158,
		-1,
		147,
		142,
		126,
		121,
		118,
		115,
		109,
		118,
		120,
		110,
		105,
		112,
		147,
		147,
		122,
		142,
		145,
		-1,
		-1,
		-1,
		230,
		225,
		200,
		177,
		161,
		197,
		-1,
		174,
		175,
		-1,
		152,
		146,
		143,
		128,
		124,
		119,
		123,
		116,
		123,
		116,
		114,
		115,
		97,
		129,
		-1,
		130,
		124,
		132,
		122,
		110,
		-1,
		-1,
		-1,
		223,
		202,
		195,
		215,
		156,
		208,
		-1,
		-1,
		159,
		152,
		-1,
		139,
		121,
		128,
		126,
		120,
		124,
		121,
		110,
		123,
		116,
		102,
		104,
		117,
		121,
		125,
		112,
		108,
		105,
		119,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		176,
		-1,
		168,
		160,
		150,
		144,
		138,
		134,
		132,
		148,
		132,
		135,
		133,
		124,
		132,
		105,
		98,
		105,
		94,
		112,
		120,
		112,
		106,
		105,
		115,
		-1,
		243,
		229,
		200,
		-1,
		-1,
		189,
		-1,
		153,
		167,
		183,
		-1,
		176,
		155,
		170,
		148,
		144,
		140,
		155,
		156,
		133,
		133,
		131,
		122,
		110,
		99,
		102,
		94,
		116,
		116,
		100,
		101,
		105,
		-1,
		249,
		236,
		194,
		190,
		179,
		199,
		150,
		138,
		170,
		-1,
		-1,
		212,
		-1,
		146,
		163,
		154,
		152,
		145,
		127,
		134,
		142,
		119,
		114,
		104,
		93,
		93,
		88,
		110,
		96,
		94,
		103,
		119,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		165,
		152,
		146,
		-1,
		187,
		-1,
		190,
		180,
		164,
		149,
		182,
		-1,
		126,
		122,
		129,
		-1,
		139,
		-1,
		112,
		109,
		100,
		85,
		82,
		93,
		91,
		102,
		98,
		-1,
		199,
		184,
		177,
		167,
		181,
		152,
		-1,
		207,
		-1,
		-1,
		177,
		171,
		171,
		155,
		156,
		142,
		122,
		114,
		129,
		128,
		115,
		114,
		98,
		91,
		88,
		81,
		94,
		104,
		109,
		96,
		-1,
		-1,
		-1,
		204,
		190,
		194,
		154,
		173,
		-1,
		-1,
		239,
		194,
		180,
		-1,
		151,
		142,
		130,
		120,
		110,
		115,
		116,
		106,
		104,
		96,
		98,
		92,
		83,
		82,
		98,
		90,
		112,
		-1,
		-1,
		187,
		192,
		180,
		166,
		185,
		-1,
		-1,
		-1,
		186,
		202,
		170,
		149,
		131,
		-1,
		-1,
		114,
		107,
		101,
		104,
		92,
		112,
		107,
		91,
		76,
		91,
		95,
		103,
		94,
		-1,
		190,
		177,
		-1,
		-1,
		188,
		182,
		-1,
		-1,
		-1,
		-1,
		182,
		127,
		116,
		111,
		115,
		113,
		-1,
		87,
		98,
		91,
		110,
		117,
		93,
		78,
		72,
		78,
		90,
		99,
		-1,
		-1,
		202,
		-1,
		175,
		-1,
		-1,
		-1,
		-1,
		139,
		133,
		104,
		97,
		101,
		-1,
		89,
		91,
		88,
		100,
		96,
		93,
		84,
		75,
		71,
		75,
		79,
		93,
		97,
		225,
		-1,
		166,
		-1,
		-1,
		-1,
		157,
		172,
		143,
		120,
		93,
		88,
		81,
		75,
		80,
		91,
		100,
		111,
		76,
		78,
		68,
		67,
		71,
		88,
		92,
		-1,
		-1,
		164,
		160,
		183,
		165,
		169,
		170,
		-1,
		-1,
		97,
		88,
		79,
		71,
		84,
		87,
		72,
		74,
		74,
		72,
		66,
		76,
		91,
		86,
		-1,
		-1,
		-1,
		176,
		-1,
		178,
		-1,
		-1,
		167,
		168,
		115,
		97,
		93,
		91,
		80,
		74,
		62,
		67,
		77,
		71,
		68,
		62,
		66,
		89,
		78,
		117,
		-1,
		-1,
		238,
		-1,
		-1,
		-1,
		156,
		147,
		142,
		149,
		151,
		142,
		130,
		127,
		-1,
		97,
		103,
		68,
		75,
		58,
		65,
		70,
		67,
		56,
		63,
		79,
		78,
		73,
		109,
		100,
		106,
		-1,
		-1,
		231,
		220,
		209,
		215,
		-1,
		149,
		144,
		135,
		125,
		128,
		-1,
		-1,
		122,
		119,
		99,
		68,
		66,
		59,
		54,
		64,
		40,
		52,
		56,
		60,
		66,
		71,
		76,
		82,
		97,
		112,
		-1,
		185,
		222,
		215,
		183,
		191,
		222,
		-1,
		139,
		131,
		141,
		117,
		119,
		-1,
		-1,
		95,
		86,
		87,
		75,
		72,
		78,
		77,
		60,
		66,
		67,
		59,
		58,
		76,
		80,
		89,
		96,
		86,
		99,
		103,
		-1,
		178,
		198,
		177,
		180,
		204,
		218,
		-1,
		136,
		-1,
		-1,
		101,
		120,
		104,
		94,
		91,
		134,
		89,
		84,
		65,
		63,
		58,
		49,
		74,
		67,
		67,
		70,
		85,
		90,
		82,
		96,
		96,
		97,
		-1,
		167,
		178,
		171,
		-1,
		-1,
		-1,
		-1,
		137,
		-1,
		-1,
		91,
		-1,
		131,
		-1,
		114,
		118,
		97,
		100,
		79,
		66,
		52,
		60,
		66,
		65,
		71,
		71,
		72,
		81,
		92,
		104,
		103,
		104,
		192,
		148,
		151,
		162,
		173,
		188,
		192,
		-1,
		148,
		187,
		97,
		-1,
		81,
		-1,
		-1,
		-1,
		128,
		110,
		102,
		99,
		78,
		78,
		44,
		48,
		61,
		68,
		78,
		89,
		81,
		85,
		98,
		109,
		112,
		188,
		179,
		192,
		137,
		137,
		158,
		167,
		188,
		152,
		149,
		181,
		104,
		93,
		88,
		75,
		-1,
		-1,
		112,
		120,
		-1,
		-1,
		85,
		52,
		40,
		50,
		54,
		68,
		80,
		93,
		81,
		86,
		80,
		112,
		-1,
		181,
		180,
		169,
		166,
		142,
		133,
		128,
		155,
		-1,
		-1,
		150,
		177,
		160,
		137,
		135,
		160,
		-1,
		64,
		-1,
		-1,
		92,
		-1,
		-1,
		77,
		57,
		46,
		37,
		42,
		62,
		73,
		95,
		77,
		94,
		85,
		95,
		99,
		165,
		162,
		150,
		148,
		171,
		136,
		124,
		-1,
		132,
		135,
		141,
		148,
		138,
		149,
		-1,
		-1,
		80,
		60,
		-1,
		-1,
		75,
		73,
		62,
		-1,
		52,
		34,
		39,
		69,
		71,
		73,
		80,
		74,
		81,
		89,
		100,
		92,
		174,
		188,
		177,
		173,
		172,
		180,
		129,
		122,
		129,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		85,
		-1,
		70,
		66,
		-1,
		-1,
		70,
		63,
		51,
		39,
		29,
		39,
		56,
		56,
		59,
		64,
		72,
		83,
		79,
		83,
		86,
		-1,
		208,
		-1,
		160,
		121,
		127,
		142,
		150,
		-1,
		-1,
		-1,
		87,
		73,
		66,
		54,
		52,
		-1,
		104,
		88,
		69,
		-1,
		39,
		52,
		92,
		60,
		65,
		60,
		75,
		86,
		77,
		85,
		79,
		82,
		-1,
		-1,
		120,
		103,
		-1,
		-1,
		77,
		79,
		-1,
		78,
		67,
		52,
		44,
		-1,
		-1,
		76,
		72,
		-1,
		-1,
		26,
		64,
		63,
		71,
		66,
		71,
		83,
		79,
		75,
		85,
		76,
		-1,
		-1,
		98,
		90,
		84,
		-1,
		62,
		-1,
		80,
		-1,
		47,
		53,
		41,
		-1,
		-1,
		-1,
		57,
		20,
		36,
		59,
		85,
		83,
		74,
		67,
		74,
		77,
		70,
		76,
		-1,
		-1,
		-1,
		80,
		54,
		87,
		78,
		61,
		41,
		33,
		52,
		-1,
		38,
		-1,
		13,
		16,
		41,
		80,
		82,
		68,
		64,
		77,
		71,
		68,
		66,
		86,
		-1,
		56,
		89,
		53,
		47,
		23,
		27,
		52,
		-1,
		35,
		17,
		-1,
		45,
		35,
		83,
		58,
		67,
		60,
		54,
		55,
		63,
		-1,
		-1,
		-1,
		58,
		57,
		49,
		43,
		43,
		28,
		19,
		-1,
		40,
		22,
		8,
		25,
		25,
		16,
		24,
		73,
		69,
		72,
		70,
		48,
		-1,
		159,
		-1,
		-1,
		81,
		-1,
		-1,
		-1,
		52,
		47,
		20,
		8,
		14,
		10,
		5,
		7,
		20,
		28,
		26,
		23,
		35,
		31,
		51,
		47,
		79,
		-1,
		154,
		-1,
		88,
		-1,
		-1,
		70,
		50,
		42,
		31,
		20,
		18,
		9,
		0,
		22,
		52,
		38,
		36,
		41,
		46,
		-1,
		143,
		142,
		-1,
		89,
		81,
		67,
		-1,
		60,
		-1,
		66,
		27,
		-1,
		29,
		9,
		-1,
		47,
		43,
		-1,
		-1,
		130,
		105,
		-1,
		-1,
		-1,
		90,
		70,
		61,
		45,
		-1,
		20,
		20,
		-1,
		-1,
		-1,
		115,
		114,
		-1,
		83,
		86,
		-1,
		76,
		67,
		75,
		22,
		26,
		-1,
		-1,
		-1,
		124,
		105,
		99,
		98,
		96,
		91,
		88,
		74,
		58,
		36,
		25,
		46,
		-1,
		-1,
		-1,
		96,
		88,
		81,
		-1,
		-1,
		83,
		66,
		47,
		45,
		-1,
		-1,
		-1,
		118,
		99,
		-1,
		-1,
		73,
		-1,
		-1,
		79,
		44,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		107,
		-1,
		-1,
		-1,
		69,
		65,
		66,
		-1,
		-1,
		-1,
		-1,
		129,
		130,
		153,
		117,
		-1,
		-1,
		-1,
		61,
		55,
		-1,
		-1,
		132,
		130,
		-1,
		-1,
		-1,
		89,
		73,
		-1,
		59,
		-1,
		-1,
		-1,
		80,
		-1,
		-1,
		92,
		-1,
		-1,
		-1,
		94,
		-1,
		94,
		69,
		76,
		-1,
		-1,
		-1,
		-1,
		107,
		99,
		107,
		-1,
		79,
		81,
		-1,
		129,
		-1,
		-1,
		122,
		113,
		-1,
		-1,
		84,
		91,
		113,
		116,
		152,
		-1,
		103
	],
	[
		-1,
		253,
		242,
		253,
		261,
		234,
		241,
		-1,
		260,
		264,
		230,
		224,
		263,
		232,
		238,
		249,
		-1,
		-1,
		-1,
		253,
		252,
		220,
		218,
		227,
		232,
		239,
		-1,
		238,
		-1,
		274,
		253,
		264,
		269,
		213,
		210,
		230,
		249,
		231,
		223,
		289,
		243,
		214,
		208,
		226,
		216,
		225,
		217,
		-1,
		214,
		204,
		226,
		205,
		216,
		208,
		-1,
		-1,
		208,
		209,
		215,
		201,
		207,
		203,
		-1,
		213,
		197,
		-1,
		-1,
		198,
		199,
		183,
		186,
		194,
		192,
		205,
		197,
		192,
		-1,
		-1,
		189,
		185,
		192,
		179,
		175,
		192,
		205,
		187,
		201,
		200,
		-1,
		193,
		211,
		218,
		186,
		184,
		168,
		166,
		184,
		186,
		192,
		192,
		-1,
		202,
		203,
		198,
		206,
		208,
		184,
		171,
		171,
		181,
		174,
		193,
		181,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		202,
		185,
		202,
		194,
		184,
		199,
		192,
		174,
		171,
		169,
		166,
		182,
		180,
		190,
		-1,
		-1,
		295,
		264,
		293,
		251,
		232,
		-1,
		198,
		178,
		184,
		188,
		182,
		175,
		189,
		185,
		-1,
		160,
		159,
		187,
		173,
		184,
		255,
		-1,
		-1,
		253,
		245,
		228,
		231,
		208,
		204,
		193,
		192,
		184,
		170,
		166,
		172,
		175,
		175,
		181,
		154,
		164,
		168,
		166,
		191,
		-1,
		-1,
		226,
		-1,
		-1,
		252,
		235,
		-1,
		218,
		225,
		214,
		220,
		206,
		227,
		203,
		194,
		186,
		180,
		168,
		170,
		167,
		180,
		168,
		151,
		176,
		180,
		161,
		182,
		177,
		-1,
		225,
		209,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		211,
		214,
		220,
		244,
		243,
		-1,
		215,
		203,
		204,
		189,
		186,
		173,
		161,
		174,
		159,
		166,
		165,
		155,
		153,
		183,
		158,
		180,
		177,
		196,
		201,
		195,
		204,
		-1,
		260,
		256,
		252,
		259,
		208,
		-1,
		-1,
		248,
		-1,
		251,
		252,
		227,
		200,
		203,
		190,
		181,
		168,
		157,
		168,
		157,
		154,
		162,
		147,
		162,
		153,
		152,
		170,
		180,
		188,
		192,
		198,
		-1,
		310,
		-1,
		252,
		236,
		238,
		210,
		231,
		-1,
		268,
		252,
		244,
		229,
		229,
		-1,
		199,
		196,
		186,
		164,
		149,
		166,
		158,
		156,
		160,
		142,
		156,
		147,
		165,
		172,
		170,
		174,
		194,
		206,
		270,
		260,
		-1,
		242,
		247,
		206,
		214,
		233,
		271,
		235,
		-1,
		230,
		-1,
		201,
		214,
		-1,
		170,
		166,
		148,
		149,
		144,
		159,
		153,
		138,
		135,
		153,
		156,
		163,
		167,
		183,
		-1,
		-1,
		255,
		259,
		248,
		199,
		218,
		242,
		279,
		228,
		217,
		216,
		-1,
		207,
		184,
		181,
		169,
		156,
		141,
		142,
		150,
		163,
		142,
		137,
		134,
		154,
		180,
		158,
		170,
		-1,
		-1,
		-1,
		280,
		-1,
		-1,
		225,
		196,
		220,
		262,
		246,
		239,
		227,
		192,
		192,
		186,
		-1,
		180,
		159,
		150,
		139,
		137,
		150,
		147,
		152,
		132,
		130,
		149,
		161,
		152,
		169,
		-1,
		-1,
		-1,
		255,
		244,
		245,
		191,
		214,
		251,
		225,
		211,
		216,
		191,
		184,
		178,
		193,
		176,
		157,
		146,
		138,
		127,
		143,
		151,
		146,
		128,
		137,
		143,
		167,
		157,
		163,
		-1,
		-1,
		262,
		252,
		236,
		238,
		235,
		205,
		212,
		244,
		216,
		229,
		-1,
		183,
		-1,
		172,
		167,
		151,
		146,
		143,
		140,
		134,
		143,
		145,
		135,
		130,
		137,
		172,
		172,
		147,
		167,
		170,
		-1,
		-1,
		-1,
		255,
		250,
		225,
		202,
		186,
		222,
		-1,
		199,
		200,
		-1,
		177,
		171,
		168,
		153,
		149,
		144,
		148,
		141,
		148,
		141,
		139,
		140,
		122,
		154,
		-1,
		155,
		149,
		157,
		147,
		135,
		-1,
		-1,
		-1,
		248,
		227,
		220,
		240,
		181,
		233,
		-1,
		-1,
		184,
		177,
		-1,
		164,
		146,
		153,
		151,
		145,
		149,
		146,
		135,
		148,
		141,
		127,
		129,
		142,
		146,
		150,
		137,
		133,
		130,
		144,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		201,
		-1,
		193,
		185,
		175,
		169,
		163,
		159,
		157,
		173,
		157,
		160,
		158,
		149,
		157,
		130,
		123,
		130,
		119,
		137,
		145,
		137,
		131,
		130,
		140,
		-1,
		268,
		254,
		225,
		-1,
		-1,
		214,
		-1,
		178,
		192,
		208,
		-1,
		201,
		180,
		195,
		173,
		169,
		165,
		180,
		181,
		158,
		158,
		156,
		147,
		135,
		124,
		127,
		119,
		141,
		141,
		125,
		126,
		130,
		-1,
		274,
		261,
		219,
		215,
		204,
		224,
		175,
		163,
		195,
		-1,
		-1,
		237,
		-1,
		171,
		188,
		179,
		177,
		170,
		152,
		159,
		167,
		144,
		139,
		129,
		118,
		118,
		113,
		135,
		121,
		119,
		128,
		144,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		190,
		177,
		171,
		-1,
		212,
		-1,
		215,
		205,
		189,
		174,
		207,
		-1,
		151,
		147,
		154,
		-1,
		164,
		-1,
		137,
		134,
		125,
		110,
		107,
		118,
		116,
		127,
		123,
		-1,
		224,
		209,
		202,
		192,
		206,
		177,
		-1,
		232,
		-1,
		-1,
		202,
		196,
		196,
		180,
		181,
		167,
		147,
		139,
		154,
		153,
		140,
		139,
		123,
		116,
		113,
		106,
		119,
		129,
		134,
		121,
		-1,
		-1,
		-1,
		229,
		215,
		219,
		179,
		198,
		-1,
		-1,
		264,
		219,
		205,
		-1,
		176,
		167,
		155,
		145,
		135,
		140,
		141,
		131,
		129,
		121,
		123,
		117,
		108,
		107,
		123,
		115,
		137,
		-1,
		-1,
		212,
		217,
		205,
		191,
		210,
		-1,
		-1,
		-1,
		211,
		227,
		195,
		174,
		156,
		-1,
		-1,
		139,
		132,
		126,
		129,
		117,
		137,
		132,
		116,
		101,
		116,
		120,
		128,
		119,
		-1,
		215,
		202,
		-1,
		-1,
		213,
		207,
		-1,
		-1,
		-1,
		-1,
		207,
		152,
		141,
		136,
		140,
		138,
		-1,
		112,
		123,
		116,
		135,
		142,
		118,
		103,
		97,
		103,
		115,
		124,
		-1,
		-1,
		227,
		-1,
		200,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		129,
		122,
		126,
		-1,
		114,
		116,
		113,
		125,
		121,
		118,
		109,
		100,
		96,
		100,
		104,
		118,
		122,
		250,
		-1,
		191,
		-1,
		-1,
		-1,
		182,
		197,
		168,
		145,
		118,
		113,
		106,
		100,
		105,
		116,
		125,
		136,
		101,
		103,
		93,
		92,
		96,
		113,
		117,
		-1,
		-1,
		189,
		185,
		208,
		190,
		194,
		195,
		-1,
		-1,
		122,
		113,
		104,
		96,
		109,
		112,
		97,
		99,
		99,
		97,
		91,
		101,
		116,
		111,
		-1,
		-1,
		-1,
		201,
		-1,
		203,
		-1,
		-1,
		192,
		193,
		140,
		122,
		118,
		116,
		105,
		99,
		87,
		92,
		102,
		96,
		93,
		87,
		91,
		114,
		103,
		142,
		-1,
		-1,
		263,
		-1,
		-1,
		-1,
		181,
		172,
		167,
		174,
		176,
		167,
		155,
		152,
		-1,
		122,
		128,
		93,
		100,
		83,
		90,
		95,
		92,
		81,
		88,
		104,
		103,
		98,
		134,
		125,
		131,
		-1,
		-1,
		256,
		245,
		234,
		240,
		-1,
		174,
		169,
		160,
		150,
		153,
		-1,
		-1,
		147,
		144,
		124,
		93,
		91,
		84,
		79,
		89,
		65,
		77,
		81,
		85,
		91,
		96,
		101,
		107,
		122,
		137,
		-1,
		210,
		247,
		240,
		208,
		216,
		247,
		-1,
		164,
		156,
		166,
		142,
		144,
		-1,
		-1,
		120,
		111,
		112,
		100,
		97,
		103,
		102,
		85,
		91,
		92,
		84,
		83,
		101,
		105,
		114,
		121,
		111,
		124,
		128,
		-1,
		203,
		223,
		202,
		205,
		229,
		243,
		-1,
		161,
		-1,
		-1,
		126,
		145,
		129,
		119,
		116,
		159,
		114,
		109,
		90,
		88,
		83,
		74,
		99,
		92,
		92,
		95,
		110,
		115,
		107,
		121,
		121,
		122,
		-1,
		192,
		203,
		196,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		116,
		-1,
		156,
		-1,
		139,
		143,
		122,
		125,
		104,
		91,
		77,
		85,
		91,
		90,
		96,
		96,
		97,
		106,
		117,
		129,
		128,
		129,
		217,
		173,
		176,
		187,
		198,
		213,
		217,
		-1,
		173,
		212,
		122,
		-1,
		106,
		-1,
		-1,
		-1,
		153,
		135,
		127,
		124,
		103,
		103,
		69,
		73,
		86,
		93,
		103,
		114,
		106,
		110,
		123,
		134,
		137,
		213,
		204,
		217,
		162,
		162,
		183,
		192,
		213,
		177,
		174,
		206,
		129,
		118,
		113,
		100,
		-1,
		-1,
		137,
		145,
		-1,
		-1,
		110,
		77,
		65,
		75,
		79,
		93,
		105,
		118,
		106,
		111,
		105,
		137,
		-1,
		206,
		205,
		194,
		191,
		167,
		158,
		153,
		180,
		-1,
		-1,
		175,
		202,
		185,
		162,
		160,
		185,
		-1,
		89,
		-1,
		-1,
		117,
		-1,
		-1,
		102,
		82,
		71,
		62,
		67,
		87,
		98,
		120,
		102,
		119,
		110,
		120,
		124,
		190,
		187,
		175,
		173,
		196,
		161,
		149,
		-1,
		157,
		160,
		166,
		173,
		163,
		174,
		-1,
		-1,
		105,
		85,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		59,
		64,
		94,
		96,
		98,
		105,
		99,
		106,
		114,
		125,
		117,
		199,
		213,
		202,
		198,
		197,
		205,
		154,
		147,
		154,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		-1,
		95,
		91,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		64,
		81,
		81,
		84,
		89,
		97,
		108,
		104,
		108,
		111,
		-1,
		233,
		-1,
		185,
		146,
		152,
		167,
		175,
		-1,
		-1,
		-1,
		112,
		98,
		91,
		79,
		77,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		117,
		85,
		90,
		85,
		100,
		111,
		102,
		110,
		104,
		107,
		-1,
		-1,
		145,
		128,
		-1,
		-1,
		102,
		104,
		-1,
		103,
		92,
		77,
		69,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		51,
		89,
		88,
		96,
		91,
		96,
		108,
		104,
		100,
		110,
		101,
		-1,
		-1,
		123,
		115,
		109,
		-1,
		87,
		-1,
		105,
		-1,
		72,
		78,
		66,
		-1,
		-1,
		-1,
		82,
		45,
		61,
		84,
		110,
		108,
		99,
		92,
		99,
		102,
		95,
		101,
		-1,
		-1,
		-1,
		105,
		79,
		112,
		103,
		86,
		66,
		58,
		77,
		-1,
		63,
		-1,
		38,
		41,
		66,
		105,
		107,
		93,
		89,
		102,
		96,
		93,
		91,
		111,
		-1,
		81,
		114,
		78,
		72,
		48,
		52,
		75,
		-1,
		60,
		42,
		-1,
		70,
		60,
		108,
		83,
		92,
		85,
		79,
		80,
		88,
		-1,
		-1,
		-1,
		83,
		82,
		74,
		68,
		68,
		53,
		44,
		-1,
		63,
		45,
		33,
		50,
		50,
		41,
		49,
		98,
		94,
		97,
		95,
		73,
		-1,
		179,
		-1,
		-1,
		106,
		-1,
		-1,
		-1,
		77,
		72,
		45,
		33,
		32,
		26,
		28,
		28,
		45,
		53,
		51,
		48,
		60,
		56,
		76,
		72,
		104,
		-1,
		174,
		-1,
		113,
		-1,
		-1,
		95,
		75,
		67,
		56,
		45,
		43,
		27,
		25,
		0,
		73,
		63,
		61,
		66,
		71,
		-1,
		163,
		162,
		-1,
		114,
		106,
		92,
		-1,
		85,
		-1,
		91,
		52,
		-1,
		47,
		25,
		-1,
		72,
		68,
		-1,
		-1,
		150,
		130,
		-1,
		-1,
		-1,
		115,
		95,
		86,
		70,
		-1,
		38,
		38,
		-1,
		-1,
		-1,
		135,
		136,
		-1,
		108,
		111,
		-1,
		96,
		87,
		95,
		44,
		48,
		-1,
		-1,
		-1,
		144,
		125,
		119,
		121,
		116,
		116,
		108,
		94,
		78,
		56,
		47,
		67,
		-1,
		-1,
		-1,
		116,
		108,
		101,
		-1,
		-1,
		103,
		86,
		67,
		65,
		-1,
		-1,
		-1,
		138,
		119,
		-1,
		-1,
		93,
		-1,
		-1,
		99,
		64,
		-1,
		-1,
		-1,
		-1,
		-1,
		155,
		127,
		-1,
		-1,
		-1,
		89,
		85,
		86,
		-1,
		-1,
		-1,
		-1,
		149,
		150,
		173,
		137,
		-1,
		-1,
		-1,
		81,
		75,
		-1,
		-1,
		152,
		150,
		-1,
		-1,
		-1,
		109,
		93,
		-1,
		79,
		-1,
		-1,
		-1,
		100,
		-1,
		-1,
		112,
		-1,
		-1,
		-1,
		114,
		-1,
		114,
		89,
		96,
		-1,
		-1,
		-1,
		-1,
		127,
		119,
		127,
		-1,
		99,
		101,
		-1,
		149,
		-1,
		-1,
		142,
		133,
		-1,
		-1,
		104,
		111,
		133,
		136,
		172,
		-1,
		123
	],
	[
		-1,
		267,
		256,
		267,
		275,
		248,
		255,
		-1,
		274,
		278,
		244,
		238,
		277,
		246,
		252,
		263,
		-1,
		-1,
		-1,
		267,
		266,
		234,
		232,
		241,
		246,
		253,
		-1,
		252,
		-1,
		288,
		267,
		278,
		283,
		227,
		224,
		244,
		263,
		245,
		237,
		303,
		257,
		228,
		222,
		240,
		230,
		239,
		231,
		-1,
		228,
		218,
		240,
		219,
		230,
		222,
		-1,
		-1,
		222,
		223,
		229,
		215,
		221,
		217,
		-1,
		227,
		211,
		-1,
		-1,
		212,
		213,
		197,
		200,
		208,
		206,
		219,
		211,
		206,
		-1,
		-1,
		203,
		199,
		206,
		193,
		189,
		206,
		219,
		201,
		215,
		214,
		-1,
		207,
		225,
		232,
		200,
		198,
		182,
		180,
		198,
		200,
		206,
		206,
		-1,
		216,
		217,
		212,
		220,
		222,
		198,
		185,
		185,
		195,
		188,
		207,
		195,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		216,
		199,
		216,
		208,
		198,
		213,
		206,
		188,
		185,
		183,
		180,
		196,
		194,
		204,
		-1,
		-1,
		309,
		278,
		307,
		265,
		246,
		-1,
		212,
		192,
		198,
		202,
		196,
		189,
		203,
		199,
		-1,
		174,
		173,
		201,
		187,
		198,
		269,
		-1,
		-1,
		267,
		259,
		242,
		245,
		222,
		218,
		207,
		206,
		198,
		184,
		180,
		186,
		189,
		189,
		195,
		168,
		178,
		182,
		180,
		205,
		-1,
		-1,
		240,
		-1,
		-1,
		266,
		249,
		-1,
		232,
		239,
		228,
		234,
		220,
		241,
		217,
		208,
		200,
		194,
		182,
		184,
		181,
		194,
		182,
		165,
		190,
		194,
		175,
		196,
		191,
		-1,
		239,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		225,
		228,
		234,
		258,
		257,
		-1,
		229,
		217,
		218,
		203,
		200,
		187,
		175,
		188,
		173,
		180,
		179,
		169,
		167,
		197,
		172,
		194,
		191,
		210,
		215,
		209,
		218,
		-1,
		274,
		270,
		266,
		273,
		222,
		-1,
		-1,
		262,
		-1,
		265,
		266,
		241,
		214,
		217,
		204,
		195,
		182,
		171,
		182,
		171,
		168,
		176,
		161,
		176,
		167,
		166,
		184,
		194,
		202,
		206,
		212,
		-1,
		324,
		-1,
		266,
		250,
		252,
		224,
		245,
		-1,
		282,
		266,
		258,
		243,
		243,
		-1,
		213,
		210,
		200,
		178,
		163,
		180,
		172,
		170,
		174,
		156,
		170,
		161,
		179,
		186,
		184,
		188,
		208,
		220,
		284,
		274,
		-1,
		256,
		261,
		220,
		228,
		247,
		285,
		249,
		-1,
		244,
		-1,
		215,
		228,
		-1,
		184,
		180,
		162,
		163,
		158,
		173,
		167,
		152,
		149,
		167,
		170,
		177,
		181,
		197,
		-1,
		-1,
		269,
		273,
		262,
		213,
		232,
		256,
		293,
		242,
		231,
		230,
		-1,
		221,
		198,
		195,
		183,
		170,
		155,
		156,
		164,
		177,
		156,
		151,
		148,
		168,
		194,
		172,
		184,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		239,
		210,
		234,
		276,
		260,
		253,
		241,
		206,
		206,
		200,
		-1,
		194,
		173,
		164,
		153,
		151,
		164,
		161,
		166,
		146,
		144,
		163,
		175,
		166,
		183,
		-1,
		-1,
		-1,
		269,
		258,
		259,
		205,
		228,
		265,
		239,
		225,
		230,
		205,
		198,
		192,
		207,
		190,
		171,
		160,
		152,
		141,
		157,
		165,
		160,
		142,
		151,
		157,
		181,
		171,
		177,
		-1,
		-1,
		276,
		266,
		250,
		252,
		249,
		219,
		226,
		258,
		230,
		243,
		-1,
		197,
		-1,
		186,
		181,
		165,
		160,
		157,
		154,
		148,
		157,
		159,
		149,
		144,
		151,
		186,
		186,
		161,
		181,
		184,
		-1,
		-1,
		-1,
		269,
		264,
		239,
		216,
		200,
		236,
		-1,
		213,
		214,
		-1,
		191,
		185,
		182,
		167,
		163,
		158,
		162,
		155,
		162,
		155,
		153,
		154,
		136,
		168,
		-1,
		169,
		163,
		171,
		161,
		149,
		-1,
		-1,
		-1,
		262,
		241,
		234,
		254,
		195,
		247,
		-1,
		-1,
		198,
		191,
		-1,
		178,
		160,
		167,
		165,
		159,
		163,
		160,
		149,
		162,
		155,
		141,
		143,
		156,
		160,
		164,
		151,
		147,
		144,
		158,
		-1,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		215,
		-1,
		207,
		199,
		189,
		183,
		177,
		173,
		171,
		187,
		171,
		174,
		172,
		163,
		171,
		144,
		137,
		144,
		133,
		151,
		159,
		151,
		145,
		144,
		154,
		-1,
		282,
		268,
		239,
		-1,
		-1,
		228,
		-1,
		192,
		206,
		222,
		-1,
		215,
		194,
		209,
		187,
		183,
		179,
		194,
		195,
		172,
		172,
		170,
		161,
		149,
		138,
		141,
		133,
		155,
		155,
		139,
		140,
		144,
		-1,
		288,
		275,
		233,
		229,
		218,
		238,
		189,
		177,
		209,
		-1,
		-1,
		251,
		-1,
		185,
		202,
		193,
		191,
		184,
		166,
		173,
		181,
		158,
		153,
		143,
		132,
		132,
		127,
		149,
		135,
		133,
		142,
		158,
		-1,
		-1,
		-1,
		255,
		-1,
		-1,
		204,
		191,
		185,
		-1,
		226,
		-1,
		229,
		219,
		203,
		188,
		221,
		-1,
		165,
		161,
		168,
		-1,
		178,
		-1,
		151,
		148,
		139,
		124,
		121,
		132,
		130,
		141,
		137,
		-1,
		238,
		223,
		216,
		206,
		220,
		191,
		-1,
		246,
		-1,
		-1,
		216,
		210,
		210,
		194,
		195,
		181,
		161,
		153,
		168,
		167,
		154,
		153,
		137,
		130,
		127,
		120,
		133,
		143,
		148,
		135,
		-1,
		-1,
		-1,
		243,
		229,
		233,
		193,
		212,
		-1,
		-1,
		278,
		233,
		219,
		-1,
		190,
		181,
		169,
		159,
		149,
		154,
		155,
		145,
		143,
		135,
		137,
		131,
		122,
		121,
		137,
		129,
		151,
		-1,
		-1,
		226,
		231,
		219,
		205,
		224,
		-1,
		-1,
		-1,
		225,
		241,
		209,
		188,
		170,
		-1,
		-1,
		153,
		146,
		140,
		143,
		131,
		151,
		146,
		130,
		115,
		130,
		134,
		142,
		133,
		-1,
		229,
		216,
		-1,
		-1,
		227,
		221,
		-1,
		-1,
		-1,
		-1,
		221,
		166,
		155,
		150,
		154,
		152,
		-1,
		126,
		137,
		130,
		149,
		156,
		132,
		117,
		111,
		117,
		129,
		138,
		-1,
		-1,
		241,
		-1,
		215,
		-1,
		-1,
		-1,
		-1,
		178,
		172,
		143,
		136,
		140,
		-1,
		128,
		130,
		127,
		139,
		135,
		132,
		123,
		114,
		110,
		114,
		118,
		132,
		136,
		264,
		-1,
		206,
		-1,
		-1,
		-1,
		196,
		211,
		182,
		159,
		132,
		127,
		120,
		114,
		119,
		130,
		139,
		150,
		115,
		117,
		107,
		106,
		110,
		127,
		131,
		-1,
		-1,
		204,
		200,
		222,
		204,
		208,
		209,
		-1,
		-1,
		136,
		127,
		118,
		110,
		123,
		126,
		111,
		113,
		113,
		111,
		105,
		115,
		130,
		125,
		-1,
		-1,
		-1,
		216,
		-1,
		218,
		-1,
		-1,
		206,
		207,
		154,
		136,
		132,
		130,
		119,
		113,
		101,
		106,
		116,
		110,
		107,
		101,
		105,
		128,
		117,
		156,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		195,
		187,
		182,
		188,
		190,
		181,
		169,
		166,
		-1,
		136,
		142,
		107,
		114,
		97,
		104,
		109,
		106,
		95,
		102,
		118,
		117,
		112,
		148,
		139,
		145,
		-1,
		-1,
		281,
		270,
		259,
		265,
		-1,
		188,
		184,
		174,
		164,
		167,
		-1,
		-1,
		161,
		158,
		138,
		107,
		105,
		98,
		93,
		103,
		79,
		91,
		95,
		99,
		105,
		110,
		115,
		121,
		136,
		151,
		-1,
		235,
		272,
		265,
		233,
		241,
		272,
		-1,
		178,
		170,
		181,
		156,
		158,
		-1,
		-1,
		134,
		125,
		126,
		114,
		111,
		117,
		116,
		99,
		105,
		106,
		98,
		97,
		115,
		119,
		128,
		135,
		125,
		138,
		142,
		-1,
		228,
		248,
		227,
		230,
		254,
		268,
		-1,
		175,
		-1,
		-1,
		152,
		159,
		143,
		133,
		130,
		173,
		128,
		123,
		104,
		102,
		97,
		88,
		113,
		106,
		106,
		109,
		124,
		129,
		121,
		135,
		135,
		136,
		-1,
		217,
		228,
		221,
		-1,
		-1,
		-1,
		-1,
		176,
		-1,
		-1,
		142,
		-1,
		170,
		-1,
		153,
		157,
		136,
		139,
		118,
		105,
		91,
		99,
		105,
		104,
		110,
		110,
		111,
		120,
		131,
		143,
		142,
		143,
		242,
		198,
		201,
		212,
		223,
		238,
		242,
		-1,
		187,
		226,
		148,
		-1,
		132,
		-1,
		-1,
		-1,
		167,
		149,
		141,
		138,
		117,
		117,
		83,
		87,
		100,
		107,
		117,
		128,
		120,
		124,
		137,
		148,
		148,
		238,
		229,
		242,
		187,
		187,
		208,
		217,
		238,
		202,
		193,
		220,
		155,
		144,
		139,
		126,
		-1,
		-1,
		151,
		159,
		-1,
		-1,
		124,
		91,
		79,
		89,
		93,
		107,
		119,
		132,
		120,
		125,
		119,
		144,
		-1,
		231,
		230,
		219,
		216,
		192,
		183,
		178,
		205,
		-1,
		-1,
		200,
		221,
		211,
		188,
		186,
		211,
		-1,
		115,
		-1,
		-1,
		131,
		-1,
		-1,
		116,
		96,
		85,
		76,
		81,
		101,
		112,
		134,
		116,
		132,
		124,
		132,
		129,
		215,
		212,
		200,
		198,
		221,
		186,
		174,
		-1,
		183,
		185,
		191,
		198,
		189,
		200,
		-1,
		-1,
		131,
		111,
		-1,
		-1,
		114,
		112,
		101,
		-1,
		91,
		73,
		78,
		108,
		110,
		112,
		119,
		113,
		120,
		119,
		130,
		122,
		224,
		238,
		227,
		223,
		222,
		230,
		179,
		172,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		121,
		117,
		-1,
		-1,
		109,
		102,
		90,
		78,
		68,
		78,
		95,
		95,
		98,
		103,
		111,
		122,
		109,
		113,
		116,
		-1,
		258,
		-1,
		210,
		172,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		138,
		124,
		117,
		105,
		103,
		-1,
		143,
		127,
		108,
		-1,
		78,
		91,
		131,
		99,
		104,
		99,
		105,
		116,
		107,
		115,
		109,
		112,
		-1,
		-1,
		171,
		154,
		-1,
		-1,
		128,
		130,
		-1,
		129,
		118,
		103,
		95,
		-1,
		-1,
		115,
		111,
		-1,
		-1,
		65,
		87,
		102,
		110,
		105,
		101,
		113,
		109,
		105,
		115,
		106,
		-1,
		-1,
		149,
		141,
		135,
		-1,
		113,
		-1,
		131,
		-1,
		98,
		104,
		92,
		-1,
		-1,
		-1,
		96,
		59,
		75,
		82,
		115,
		113,
		104,
		97,
		104,
		107,
		100,
		106,
		-1,
		-1,
		-1,
		131,
		105,
		138,
		129,
		112,
		92,
		84,
		103,
		-1,
		70,
		-1,
		52,
		55,
		64,
		114,
		112,
		98,
		94,
		107,
		101,
		98,
		96,
		137,
		-1,
		107,
		140,
		104,
		98,
		74,
		78,
		97,
		-1,
		67,
		50,
		-1,
		71,
		58,
		113,
		88,
		97,
		90,
		84,
		85,
		93,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		94,
		79,
		70,
		-1,
		85,
		67,
		47,
		43,
		49,
		46,
		54,
		103,
		99,
		102,
		100,
		78,
		-1,
		210,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		98,
		71,
		59,
		63,
		59,
		50,
		43,
		38,
		42,
		51,
		53,
		65,
		61,
		81,
		77,
		109,
		-1,
		205,
		-1,
		139,
		-1,
		-1,
		121,
		101,
		93,
		82,
		71,
		69,
		58,
		51,
		72,
		0,
		68,
		66,
		71,
		76,
		-1,
		194,
		193,
		-1,
		140,
		132,
		118,
		-1,
		111,
		-1,
		117,
		78,
		-1,
		80,
		58,
		-1,
		77,
		73,
		-1,
		-1,
		181,
		156,
		-1,
		-1,
		-1,
		141,
		121,
		112,
		96,
		-1,
		71,
		71,
		-1,
		-1,
		-1,
		166,
		165,
		-1,
		134,
		137,
		-1,
		127,
		118,
		126,
		73,
		77,
		-1,
		-1,
		-1,
		175,
		156,
		150,
		149,
		147,
		142,
		139,
		125,
		109,
		87,
		76,
		97,
		-1,
		-1,
		-1,
		147,
		139,
		132,
		-1,
		-1,
		134,
		117,
		98,
		96,
		-1,
		-1,
		-1,
		169,
		150,
		-1,
		-1,
		124,
		-1,
		-1,
		130,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		158,
		-1,
		-1,
		-1,
		120,
		116,
		117,
		-1,
		-1,
		-1,
		-1,
		180,
		181,
		204,
		168,
		-1,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		183,
		181,
		-1,
		-1,
		-1,
		140,
		124,
		-1,
		110,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		145,
		-1,
		145,
		120,
		127,
		-1,
		-1,
		-1,
		-1,
		158,
		150,
		158,
		-1,
		130,
		132,
		-1,
		180,
		-1,
		-1,
		173,
		164,
		-1,
		-1,
		135,
		142,
		164,
		167,
		203,
		-1,
		154
	],
	[
		-1,
		251,
		240,
		251,
		259,
		232,
		239,
		-1,
		258,
		262,
		228,
		222,
		261,
		230,
		236,
		247,
		-1,
		-1,
		-1,
		251,
		250,
		218,
		216,
		225,
		230,
		237,
		-1,
		236,
		-1,
		272,
		251,
		262,
		267,
		211,
		208,
		228,
		247,
		229,
		221,
		287,
		241,
		212,
		206,
		224,
		214,
		223,
		215,
		-1,
		212,
		202,
		224,
		203,
		214,
		206,
		-1,
		-1,
		206,
		207,
		213,
		199,
		205,
		201,
		-1,
		211,
		195,
		-1,
		-1,
		196,
		197,
		181,
		184,
		192,
		190,
		203,
		195,
		190,
		-1,
		-1,
		187,
		183,
		190,
		177,
		173,
		190,
		203,
		185,
		199,
		198,
		-1,
		191,
		209,
		216,
		184,
		182,
		166,
		164,
		182,
		184,
		190,
		190,
		-1,
		200,
		201,
		196,
		204,
		206,
		182,
		169,
		169,
		179,
		172,
		191,
		179,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		200,
		183,
		200,
		192,
		182,
		197,
		190,
		172,
		169,
		167,
		164,
		180,
		178,
		188,
		-1,
		-1,
		293,
		262,
		291,
		249,
		230,
		-1,
		196,
		176,
		182,
		186,
		180,
		173,
		187,
		183,
		-1,
		158,
		157,
		185,
		171,
		182,
		253,
		-1,
		-1,
		251,
		243,
		226,
		229,
		206,
		202,
		191,
		190,
		182,
		168,
		164,
		170,
		173,
		173,
		179,
		152,
		162,
		166,
		164,
		189,
		-1,
		-1,
		224,
		-1,
		-1,
		250,
		233,
		-1,
		216,
		223,
		212,
		218,
		204,
		225,
		201,
		192,
		184,
		178,
		166,
		168,
		165,
		178,
		166,
		149,
		174,
		178,
		159,
		180,
		175,
		-1,
		223,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		209,
		212,
		218,
		242,
		241,
		-1,
		213,
		201,
		202,
		187,
		184,
		171,
		159,
		172,
		157,
		164,
		163,
		153,
		151,
		181,
		156,
		178,
		175,
		194,
		199,
		193,
		202,
		-1,
		258,
		254,
		250,
		257,
		206,
		-1,
		-1,
		246,
		-1,
		249,
		250,
		225,
		198,
		201,
		188,
		179,
		166,
		155,
		166,
		155,
		152,
		160,
		145,
		160,
		151,
		150,
		168,
		178,
		186,
		190,
		196,
		-1,
		308,
		-1,
		250,
		234,
		236,
		208,
		229,
		-1,
		266,
		250,
		242,
		227,
		227,
		-1,
		197,
		194,
		184,
		162,
		147,
		164,
		156,
		154,
		158,
		140,
		154,
		145,
		163,
		170,
		168,
		172,
		192,
		204,
		268,
		258,
		-1,
		240,
		245,
		204,
		212,
		231,
		269,
		233,
		-1,
		228,
		-1,
		199,
		212,
		-1,
		168,
		164,
		146,
		147,
		142,
		157,
		151,
		136,
		133,
		151,
		154,
		161,
		165,
		181,
		-1,
		-1,
		253,
		257,
		246,
		197,
		216,
		240,
		277,
		226,
		215,
		214,
		-1,
		205,
		182,
		179,
		167,
		154,
		139,
		140,
		148,
		161,
		140,
		135,
		132,
		152,
		178,
		156,
		168,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		223,
		194,
		218,
		260,
		244,
		237,
		225,
		190,
		190,
		184,
		-1,
		178,
		157,
		148,
		137,
		135,
		148,
		145,
		150,
		130,
		128,
		147,
		159,
		150,
		167,
		-1,
		-1,
		-1,
		253,
		242,
		243,
		189,
		212,
		249,
		223,
		209,
		214,
		189,
		182,
		176,
		191,
		174,
		155,
		144,
		136,
		125,
		141,
		149,
		144,
		126,
		135,
		141,
		165,
		155,
		161,
		-1,
		-1,
		260,
		250,
		234,
		236,
		233,
		203,
		210,
		242,
		214,
		227,
		-1,
		181,
		-1,
		170,
		165,
		149,
		144,
		141,
		138,
		132,
		141,
		143,
		133,
		128,
		135,
		170,
		170,
		145,
		165,
		168,
		-1,
		-1,
		-1,
		253,
		248,
		223,
		200,
		184,
		220,
		-1,
		197,
		198,
		-1,
		175,
		169,
		166,
		151,
		147,
		142,
		146,
		139,
		146,
		139,
		137,
		138,
		120,
		152,
		-1,
		153,
		147,
		155,
		145,
		133,
		-1,
		-1,
		-1,
		246,
		225,
		218,
		238,
		179,
		231,
		-1,
		-1,
		182,
		175,
		-1,
		162,
		144,
		151,
		149,
		143,
		147,
		144,
		133,
		146,
		139,
		125,
		127,
		140,
		144,
		148,
		135,
		131,
		128,
		142,
		-1,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		199,
		-1,
		191,
		183,
		173,
		167,
		161,
		157,
		155,
		171,
		155,
		158,
		156,
		147,
		155,
		128,
		121,
		128,
		117,
		135,
		143,
		135,
		129,
		128,
		138,
		-1,
		266,
		252,
		223,
		-1,
		-1,
		212,
		-1,
		176,
		190,
		206,
		-1,
		199,
		178,
		193,
		171,
		167,
		163,
		178,
		179,
		156,
		156,
		154,
		145,
		133,
		122,
		125,
		117,
		139,
		139,
		123,
		124,
		128,
		-1,
		272,
		259,
		217,
		213,
		202,
		222,
		173,
		161,
		193,
		-1,
		-1,
		235,
		-1,
		169,
		186,
		177,
		175,
		168,
		150,
		157,
		165,
		142,
		137,
		127,
		116,
		116,
		111,
		133,
		119,
		117,
		126,
		142,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		188,
		175,
		169,
		-1,
		210,
		-1,
		213,
		203,
		187,
		172,
		205,
		-1,
		149,
		145,
		152,
		-1,
		162,
		-1,
		135,
		132,
		123,
		108,
		105,
		116,
		114,
		125,
		121,
		-1,
		222,
		207,
		200,
		190,
		204,
		175,
		-1,
		230,
		-1,
		-1,
		200,
		194,
		194,
		178,
		179,
		165,
		145,
		137,
		152,
		151,
		138,
		137,
		121,
		114,
		111,
		104,
		117,
		127,
		132,
		119,
		-1,
		-1,
		-1,
		227,
		213,
		217,
		177,
		196,
		-1,
		-1,
		262,
		217,
		203,
		-1,
		174,
		165,
		153,
		143,
		133,
		138,
		139,
		129,
		127,
		119,
		121,
		115,
		106,
		105,
		121,
		113,
		135,
		-1,
		-1,
		210,
		215,
		203,
		189,
		208,
		-1,
		-1,
		-1,
		209,
		225,
		193,
		172,
		154,
		-1,
		-1,
		137,
		130,
		124,
		127,
		115,
		135,
		130,
		114,
		99,
		114,
		118,
		126,
		117,
		-1,
		213,
		200,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		-1,
		-1,
		205,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		121,
		114,
		133,
		140,
		116,
		101,
		95,
		101,
		113,
		122,
		-1,
		-1,
		225,
		-1,
		199,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		127,
		120,
		124,
		-1,
		112,
		114,
		111,
		123,
		119,
		116,
		107,
		98,
		94,
		98,
		102,
		116,
		120,
		248,
		-1,
		190,
		-1,
		-1,
		-1,
		180,
		195,
		166,
		143,
		116,
		111,
		104,
		98,
		103,
		114,
		123,
		134,
		99,
		101,
		91,
		90,
		94,
		111,
		115,
		-1,
		-1,
		188,
		184,
		206,
		188,
		192,
		193,
		-1,
		-1,
		120,
		111,
		102,
		94,
		107,
		110,
		95,
		97,
		97,
		95,
		89,
		99,
		114,
		109,
		-1,
		-1,
		-1,
		200,
		-1,
		202,
		-1,
		-1,
		190,
		191,
		138,
		120,
		116,
		114,
		103,
		97,
		85,
		90,
		100,
		94,
		91,
		85,
		89,
		112,
		101,
		123,
		-1,
		-1,
		272,
		-1,
		-1,
		-1,
		179,
		171,
		166,
		172,
		174,
		165,
		153,
		150,
		-1,
		120,
		126,
		91,
		98,
		81,
		88,
		93,
		90,
		79,
		86,
		102,
		101,
		96,
		115,
		106,
		114,
		-1,
		-1,
		265,
		254,
		243,
		249,
		-1,
		172,
		168,
		158,
		148,
		151,
		-1,
		-1,
		145,
		142,
		122,
		91,
		89,
		82,
		77,
		87,
		63,
		75,
		79,
		83,
		89,
		94,
		99,
		100,
		105,
		120,
		-1,
		219,
		256,
		249,
		217,
		225,
		256,
		-1,
		162,
		154,
		165,
		140,
		142,
		-1,
		-1,
		118,
		109,
		110,
		98,
		95,
		101,
		100,
		83,
		89,
		90,
		82,
		81,
		99,
		98,
		102,
		103,
		92,
		105,
		109,
		-1,
		212,
		232,
		211,
		214,
		238,
		252,
		-1,
		159,
		-1,
		-1,
		140,
		143,
		127,
		117,
		114,
		157,
		112,
		107,
		88,
		86,
		81,
		72,
		97,
		90,
		84,
		81,
		90,
		95,
		87,
		102,
		98,
		91,
		-1,
		201,
		212,
		205,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		130,
		-1,
		154,
		-1,
		137,
		141,
		120,
		123,
		102,
		89,
		75,
		83,
		89,
		88,
		92,
		88,
		77,
		79,
		91,
		95,
		105,
		107,
		226,
		182,
		185,
		196,
		207,
		222,
		226,
		-1,
		171,
		210,
		136,
		-1,
		120,
		-1,
		-1,
		-1,
		151,
		133,
		125,
		122,
		101,
		101,
		67,
		71,
		84,
		91,
		101,
		94,
		79,
		78,
		89,
		100,
		99,
		222,
		213,
		226,
		171,
		171,
		192,
		201,
		222,
		186,
		177,
		204,
		143,
		132,
		127,
		114,
		-1,
		-1,
		135,
		143,
		-1,
		-1,
		108,
		75,
		63,
		73,
		77,
		91,
		103,
		91,
		71,
		77,
		71,
		95,
		-1,
		215,
		214,
		203,
		200,
		176,
		167,
		162,
		189,
		-1,
		-1,
		184,
		205,
		195,
		176,
		174,
		199,
		-1,
		103,
		-1,
		-1,
		115,
		-1,
		-1,
		100,
		80,
		69,
		60,
		65,
		85,
		96,
		118,
		67,
		83,
		76,
		83,
		80,
		199,
		196,
		184,
		182,
		205,
		170,
		158,
		-1,
		171,
		169,
		175,
		182,
		177,
		188,
		-1,
		-1,
		119,
		99,
		-1,
		-1,
		98,
		96,
		85,
		-1,
		75,
		57,
		62,
		92,
		84,
		76,
		70,
		64,
		71,
		70,
		81,
		73,
		208,
		222,
		211,
		207,
		206,
		214,
		163,
		156,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		124,
		-1,
		109,
		105,
		-1,
		-1,
		93,
		86,
		74,
		62,
		52,
		62,
		76,
		72,
		72,
		67,
		62,
		73,
		60,
		64,
		67,
		-1,
		242,
		-1,
		194,
		160,
		166,
		181,
		189,
		-1,
		-1,
		-1,
		126,
		112,
		105,
		93,
		91,
		-1,
		127,
		111,
		92,
		-1,
		62,
		75,
		108,
		76,
		68,
		66,
		56,
		67,
		58,
		66,
		60,
		63,
		-1,
		-1,
		159,
		142,
		-1,
		-1,
		116,
		118,
		-1,
		117,
		106,
		91,
		83,
		-1,
		-1,
		99,
		95,
		-1,
		-1,
		49,
		66,
		79,
		74,
		70,
		52,
		64,
		60,
		56,
		66,
		57,
		-1,
		-1,
		137,
		129,
		123,
		-1,
		101,
		-1,
		119,
		-1,
		86,
		92,
		80,
		-1,
		-1,
		-1,
		80,
		43,
		59,
		61,
		65,
		63,
		55,
		48,
		55,
		58,
		51,
		57,
		-1,
		-1,
		-1,
		119,
		93,
		126,
		117,
		100,
		80,
		72,
		91,
		-1,
		61,
		-1,
		36,
		39,
		43,
		73,
		61,
		47,
		45,
		58,
		52,
		49,
		47,
		125,
		-1,
		95,
		128,
		92,
		86,
		62,
		66,
		82,
		-1,
		58,
		40,
		-1,
		51,
		37,
		62,
		37,
		46,
		41,
		35,
		36,
		44,
		-1,
		-1,
		-1,
		97,
		96,
		88,
		82,
		82,
		67,
		58,
		-1,
		70,
		52,
		31,
		46,
		31,
		22,
		21,
		52,
		48,
		51,
		49,
		29,
		-1,
		198,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		91,
		86,
		59,
		47,
		53,
		49,
		35,
		41,
		41,
		34,
		23,
		20,
		12,
		12,
		30,
		28,
		60,
		-1,
		193,
		-1,
		127,
		-1,
		-1,
		109,
		89,
		81,
		70,
		59,
		57,
		48,
		39,
		61,
		65,
		0,
		17,
		22,
		27,
		-1,
		182,
		181,
		-1,
		128,
		120,
		106,
		-1,
		99,
		-1,
		105,
		66,
		-1,
		68,
		48,
		-1,
		28,
		24,
		-1,
		-1,
		169,
		144,
		-1,
		-1,
		-1,
		129,
		109,
		100,
		84,
		-1,
		59,
		59,
		-1,
		-1,
		-1,
		154,
		153,
		-1,
		122,
		125,
		-1,
		115,
		106,
		114,
		61,
		65,
		-1,
		-1,
		-1,
		163,
		144,
		138,
		137,
		135,
		130,
		127,
		113,
		97,
		75,
		64,
		85,
		-1,
		-1,
		-1,
		135,
		127,
		120,
		-1,
		-1,
		122,
		105,
		86,
		84,
		-1,
		-1,
		-1,
		157,
		138,
		-1,
		-1,
		112,
		-1,
		-1,
		118,
		83,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		146,
		-1,
		-1,
		-1,
		108,
		104,
		105,
		-1,
		-1,
		-1,
		-1,
		168,
		169,
		192,
		156,
		-1,
		-1,
		-1,
		100,
		94,
		-1,
		-1,
		171,
		169,
		-1,
		-1,
		-1,
		128,
		112,
		-1,
		98,
		-1,
		-1,
		-1,
		119,
		-1,
		-1,
		131,
		-1,
		-1,
		-1,
		133,
		-1,
		133,
		108,
		115,
		-1,
		-1,
		-1,
		-1,
		146,
		138,
		146,
		-1,
		118,
		120,
		-1,
		168,
		-1,
		-1,
		161,
		152,
		-1,
		-1,
		123,
		130,
		152,
		155,
		191,
		-1,
		142
	],
	[
		-1,
		248,
		237,
		248,
		256,
		229,
		236,
		-1,
		255,
		259,
		225,
		219,
		258,
		227,
		233,
		244,
		-1,
		-1,
		-1,
		248,
		247,
		215,
		213,
		222,
		227,
		234,
		-1,
		233,
		-1,
		269,
		248,
		259,
		264,
		208,
		205,
		225,
		244,
		226,
		218,
		284,
		238,
		209,
		203,
		221,
		211,
		220,
		212,
		-1,
		209,
		199,
		221,
		200,
		211,
		203,
		-1,
		-1,
		203,
		204,
		210,
		196,
		202,
		198,
		-1,
		208,
		192,
		-1,
		-1,
		193,
		194,
		178,
		181,
		189,
		187,
		200,
		192,
		187,
		-1,
		-1,
		184,
		180,
		187,
		174,
		170,
		187,
		200,
		182,
		196,
		195,
		-1,
		188,
		206,
		213,
		181,
		179,
		163,
		161,
		179,
		181,
		187,
		187,
		-1,
		197,
		198,
		193,
		201,
		203,
		179,
		166,
		166,
		176,
		169,
		188,
		176,
		222,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		197,
		180,
		197,
		189,
		179,
		194,
		187,
		169,
		166,
		164,
		161,
		177,
		175,
		185,
		-1,
		-1,
		290,
		259,
		288,
		246,
		227,
		-1,
		193,
		173,
		179,
		183,
		177,
		170,
		184,
		180,
		-1,
		155,
		154,
		182,
		168,
		179,
		250,
		-1,
		-1,
		248,
		240,
		223,
		226,
		203,
		199,
		188,
		187,
		179,
		165,
		161,
		167,
		170,
		170,
		176,
		149,
		159,
		163,
		161,
		186,
		-1,
		-1,
		221,
		-1,
		-1,
		247,
		230,
		-1,
		213,
		220,
		209,
		215,
		201,
		222,
		198,
		189,
		181,
		175,
		163,
		165,
		162,
		175,
		163,
		146,
		171,
		175,
		156,
		177,
		172,
		-1,
		220,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		206,
		209,
		215,
		239,
		238,
		-1,
		210,
		198,
		199,
		184,
		181,
		168,
		156,
		169,
		154,
		161,
		160,
		150,
		148,
		178,
		153,
		175,
		172,
		191,
		196,
		190,
		199,
		-1,
		255,
		251,
		247,
		254,
		203,
		-1,
		-1,
		243,
		-1,
		246,
		247,
		222,
		195,
		198,
		185,
		176,
		163,
		152,
		163,
		152,
		149,
		157,
		142,
		157,
		148,
		147,
		165,
		175,
		183,
		187,
		193,
		-1,
		305,
		-1,
		247,
		231,
		233,
		205,
		226,
		-1,
		263,
		247,
		239,
		224,
		224,
		-1,
		194,
		191,
		181,
		159,
		144,
		161,
		153,
		151,
		155,
		137,
		151,
		142,
		160,
		167,
		165,
		169,
		189,
		201,
		265,
		255,
		-1,
		237,
		242,
		201,
		209,
		228,
		266,
		230,
		-1,
		225,
		-1,
		196,
		209,
		-1,
		165,
		161,
		143,
		144,
		139,
		154,
		148,
		133,
		130,
		148,
		151,
		158,
		162,
		178,
		-1,
		-1,
		250,
		254,
		243,
		194,
		213,
		237,
		274,
		223,
		212,
		211,
		-1,
		202,
		179,
		176,
		164,
		151,
		136,
		137,
		145,
		158,
		137,
		132,
		129,
		149,
		175,
		153,
		165,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		220,
		191,
		215,
		257,
		241,
		234,
		222,
		187,
		187,
		181,
		-1,
		175,
		154,
		145,
		134,
		132,
		145,
		142,
		147,
		127,
		125,
		144,
		156,
		147,
		164,
		-1,
		-1,
		-1,
		250,
		239,
		240,
		186,
		209,
		246,
		220,
		206,
		211,
		186,
		179,
		173,
		188,
		171,
		152,
		141,
		133,
		122,
		138,
		146,
		141,
		123,
		132,
		138,
		162,
		152,
		158,
		-1,
		-1,
		257,
		247,
		231,
		233,
		230,
		200,
		207,
		239,
		211,
		224,
		-1,
		178,
		-1,
		167,
		162,
		146,
		141,
		138,
		135,
		129,
		138,
		140,
		130,
		125,
		132,
		167,
		167,
		142,
		162,
		165,
		-1,
		-1,
		-1,
		250,
		245,
		220,
		197,
		181,
		217,
		-1,
		194,
		195,
		-1,
		172,
		166,
		163,
		148,
		144,
		139,
		143,
		136,
		143,
		136,
		134,
		135,
		117,
		149,
		-1,
		150,
		144,
		152,
		142,
		130,
		-1,
		-1,
		-1,
		243,
		222,
		215,
		235,
		176,
		228,
		-1,
		-1,
		179,
		172,
		-1,
		159,
		141,
		148,
		146,
		140,
		144,
		141,
		130,
		143,
		136,
		122,
		124,
		137,
		141,
		145,
		132,
		128,
		125,
		139,
		-1,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		196,
		-1,
		188,
		180,
		170,
		164,
		158,
		154,
		152,
		168,
		152,
		155,
		153,
		144,
		152,
		125,
		118,
		125,
		114,
		132,
		140,
		132,
		126,
		125,
		135,
		-1,
		263,
		249,
		220,
		-1,
		-1,
		209,
		-1,
		173,
		187,
		203,
		-1,
		196,
		175,
		190,
		168,
		164,
		160,
		175,
		176,
		153,
		153,
		151,
		142,
		130,
		119,
		122,
		114,
		136,
		136,
		120,
		121,
		125,
		-1,
		269,
		256,
		214,
		210,
		199,
		219,
		170,
		158,
		190,
		-1,
		-1,
		232,
		-1,
		166,
		183,
		174,
		172,
		165,
		147,
		154,
		162,
		139,
		134,
		124,
		113,
		113,
		108,
		130,
		116,
		114,
		123,
		139,
		-1,
		-1,
		-1,
		236,
		-1,
		-1,
		185,
		172,
		166,
		-1,
		207,
		-1,
		210,
		200,
		184,
		169,
		202,
		-1,
		146,
		142,
		149,
		-1,
		159,
		-1,
		132,
		129,
		120,
		105,
		102,
		113,
		111,
		122,
		118,
		-1,
		219,
		204,
		197,
		187,
		201,
		172,
		-1,
		227,
		-1,
		-1,
		197,
		191,
		191,
		175,
		176,
		162,
		142,
		134,
		149,
		148,
		135,
		134,
		118,
		111,
		108,
		101,
		114,
		124,
		129,
		116,
		-1,
		-1,
		-1,
		224,
		210,
		214,
		174,
		193,
		-1,
		-1,
		259,
		214,
		200,
		-1,
		171,
		162,
		150,
		140,
		130,
		135,
		136,
		126,
		124,
		116,
		118,
		112,
		103,
		102,
		118,
		110,
		132,
		-1,
		-1,
		207,
		212,
		200,
		186,
		205,
		-1,
		-1,
		-1,
		206,
		222,
		190,
		169,
		151,
		-1,
		-1,
		134,
		127,
		121,
		124,
		112,
		132,
		127,
		111,
		96,
		111,
		115,
		123,
		114,
		-1,
		210,
		197,
		-1,
		-1,
		208,
		202,
		-1,
		-1,
		-1,
		-1,
		202,
		147,
		136,
		131,
		135,
		133,
		-1,
		107,
		118,
		111,
		130,
		137,
		113,
		98,
		92,
		98,
		110,
		119,
		-1,
		-1,
		222,
		-1,
		196,
		-1,
		-1,
		-1,
		-1,
		159,
		153,
		124,
		117,
		121,
		-1,
		109,
		111,
		108,
		120,
		116,
		113,
		104,
		95,
		91,
		95,
		99,
		112,
		117,
		245,
		-1,
		187,
		-1,
		-1,
		-1,
		177,
		192,
		163,
		140,
		113,
		108,
		101,
		95,
		100,
		111,
		120,
		131,
		96,
		98,
		88,
		87,
		91,
		108,
		112,
		-1,
		-1,
		185,
		181,
		203,
		185,
		189,
		190,
		-1,
		-1,
		117,
		108,
		99,
		91,
		104,
		107,
		92,
		94,
		94,
		92,
		86,
		96,
		111,
		106,
		-1,
		-1,
		-1,
		197,
		-1,
		199,
		-1,
		-1,
		187,
		188,
		135,
		117,
		113,
		111,
		100,
		94,
		82,
		87,
		97,
		91,
		88,
		82,
		86,
		109,
		98,
		106,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		176,
		168,
		163,
		169,
		171,
		162,
		150,
		147,
		-1,
		117,
		123,
		88,
		95,
		78,
		85,
		90,
		87,
		76,
		83,
		99,
		98,
		93,
		98,
		89,
		97,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		169,
		165,
		155,
		145,
		148,
		-1,
		-1,
		142,
		139,
		119,
		88,
		86,
		79,
		74,
		84,
		60,
		72,
		76,
		73,
		86,
		91,
		90,
		83,
		88,
		103,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		159,
		151,
		162,
		137,
		139,
		-1,
		-1,
		115,
		106,
		107,
		95,
		92,
		98,
		97,
		80,
		86,
		87,
		71,
		78,
		89,
		81,
		85,
		86,
		75,
		88,
		92,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		156,
		-1,
		-1,
		137,
		140,
		124,
		114,
		111,
		154,
		109,
		104,
		85,
		83,
		78,
		69,
		94,
		79,
		67,
		64,
		73,
		78,
		70,
		85,
		81,
		74,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		-1,
		127,
		-1,
		151,
		-1,
		134,
		138,
		117,
		120,
		99,
		86,
		72,
		80,
		86,
		79,
		75,
		71,
		60,
		62,
		74,
		78,
		88,
		90,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		168,
		207,
		133,
		-1,
		117,
		-1,
		-1,
		-1,
		148,
		130,
		122,
		119,
		98,
		98,
		64,
		68,
		81,
		80,
		86,
		77,
		62,
		61,
		72,
		83,
		82,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		174,
		201,
		140,
		129,
		124,
		111,
		-1,
		-1,
		132,
		140,
		-1,
		-1,
		105,
		72,
		60,
		70,
		74,
		88,
		86,
		74,
		54,
		60,
		54,
		78,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		202,
		192,
		173,
		171,
		196,
		-1,
		100,
		-1,
		-1,
		112,
		-1,
		-1,
		97,
		77,
		66,
		57,
		62,
		82,
		90,
		101,
		50,
		66,
		59,
		66,
		63,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		168,
		166,
		172,
		179,
		174,
		185,
		-1,
		-1,
		116,
		96,
		-1,
		-1,
		95,
		93,
		82,
		-1,
		72,
		54,
		59,
		86,
		67,
		59,
		53,
		47,
		54,
		53,
		64,
		56,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		-1,
		106,
		102,
		-1,
		-1,
		90,
		83,
		71,
		59,
		49,
		59,
		59,
		55,
		55,
		50,
		45,
		56,
		43,
		47,
		50,
		-1,
		239,
		-1,
		191,
		157,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		123,
		109,
		102,
		90,
		88,
		-1,
		124,
		108,
		89,
		-1,
		59,
		72,
		91,
		59,
		51,
		49,
		39,
		50,
		41,
		49,
		43,
		46,
		-1,
		-1,
		156,
		139,
		-1,
		-1,
		113,
		115,
		-1,
		114,
		103,
		88,
		80,
		-1,
		-1,
		96,
		92,
		-1,
		-1,
		46,
		64,
		62,
		57,
		53,
		35,
		47,
		43,
		39,
		49,
		40,
		-1,
		-1,
		134,
		126,
		120,
		-1,
		98,
		-1,
		116,
		-1,
		83,
		89,
		77,
		-1,
		-1,
		-1,
		77,
		40,
		56,
		59,
		49,
		47,
		38,
		31,
		38,
		41,
		34,
		40,
		-1,
		-1,
		-1,
		116,
		90,
		123,
		114,
		97,
		77,
		69,
		88,
		-1,
		58,
		-1,
		33,
		36,
		41,
		57,
		56,
		42,
		28,
		41,
		35,
		32,
		30,
		122,
		-1,
		92,
		125,
		89,
		83,
		59,
		63,
		79,
		-1,
		55,
		37,
		-1,
		48,
		35,
		57,
		32,
		37,
		24,
		18,
		19,
		27,
		-1,
		-1,
		-1,
		94,
		93,
		85,
		79,
		79,
		64,
		55,
		-1,
		67,
		49,
		28,
		43,
		28,
		19,
		19,
		47,
		43,
		40,
		38,
		12,
		-1,
		195,
		-1,
		-1,
		117,
		-1,
		-1,
		-1,
		88,
		83,
		56,
		44,
		50,
		46,
		32,
		38,
		38,
		31,
		21,
		18,
		14,
		5,
		21,
		11,
		43,
		-1,
		190,
		-1,
		124,
		-1,
		-1,
		106,
		86,
		78,
		67,
		56,
		54,
		45,
		36,
		58,
		62,
		12,
		0,
		5,
		10,
		-1,
		179,
		178,
		-1,
		125,
		117,
		103,
		-1,
		96,
		-1,
		102,
		63,
		-1,
		65,
		45,
		-1,
		11,
		7,
		-1,
		-1,
		166,
		141,
		-1,
		-1,
		-1,
		126,
		106,
		97,
		81,
		-1,
		56,
		56,
		-1,
		-1,
		-1,
		151,
		150,
		-1,
		119,
		122,
		-1,
		112,
		103,
		111,
		58,
		62,
		-1,
		-1,
		-1,
		160,
		141,
		135,
		134,
		132,
		127,
		124,
		110,
		94,
		72,
		61,
		82,
		-1,
		-1,
		-1,
		132,
		124,
		117,
		-1,
		-1,
		119,
		102,
		83,
		81,
		-1,
		-1,
		-1,
		154,
		135,
		-1,
		-1,
		109,
		-1,
		-1,
		115,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		143,
		-1,
		-1,
		-1,
		105,
		101,
		102,
		-1,
		-1,
		-1,
		-1,
		165,
		166,
		189,
		153,
		-1,
		-1,
		-1,
		97,
		91,
		-1,
		-1,
		168,
		166,
		-1,
		-1,
		-1,
		125,
		109,
		-1,
		95,
		-1,
		-1,
		-1,
		116,
		-1,
		-1,
		128,
		-1,
		-1,
		-1,
		130,
		-1,
		130,
		105,
		112,
		-1,
		-1,
		-1,
		-1,
		143,
		135,
		143,
		-1,
		115,
		117,
		-1,
		165,
		-1,
		-1,
		158,
		149,
		-1,
		-1,
		120,
		127,
		149,
		152,
		188,
		-1,
		139
	],
	[
		-1,
		249,
		238,
		249,
		257,
		230,
		237,
		-1,
		256,
		260,
		226,
		220,
		259,
		228,
		234,
		245,
		-1,
		-1,
		-1,
		249,
		248,
		216,
		214,
		223,
		228,
		235,
		-1,
		234,
		-1,
		270,
		249,
		260,
		265,
		209,
		206,
		226,
		245,
		227,
		219,
		285,
		239,
		210,
		204,
		222,
		212,
		221,
		213,
		-1,
		210,
		200,
		222,
		201,
		212,
		204,
		-1,
		-1,
		204,
		205,
		211,
		197,
		203,
		199,
		-1,
		209,
		193,
		-1,
		-1,
		194,
		195,
		179,
		182,
		190,
		188,
		201,
		193,
		188,
		-1,
		-1,
		185,
		181,
		188,
		175,
		171,
		188,
		201,
		183,
		197,
		196,
		-1,
		189,
		207,
		214,
		182,
		180,
		164,
		162,
		180,
		182,
		188,
		188,
		-1,
		198,
		199,
		194,
		202,
		204,
		180,
		167,
		167,
		177,
		170,
		189,
		177,
		223,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		198,
		181,
		198,
		190,
		180,
		195,
		188,
		170,
		167,
		165,
		162,
		178,
		176,
		186,
		-1,
		-1,
		291,
		260,
		289,
		247,
		228,
		-1,
		194,
		174,
		180,
		184,
		178,
		171,
		185,
		181,
		-1,
		156,
		155,
		183,
		169,
		180,
		251,
		-1,
		-1,
		249,
		241,
		224,
		227,
		204,
		200,
		189,
		188,
		180,
		166,
		162,
		168,
		171,
		171,
		177,
		150,
		160,
		164,
		162,
		187,
		-1,
		-1,
		222,
		-1,
		-1,
		248,
		231,
		-1,
		214,
		221,
		210,
		216,
		202,
		223,
		199,
		190,
		182,
		176,
		164,
		166,
		163,
		176,
		164,
		147,
		172,
		176,
		157,
		178,
		173,
		-1,
		221,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		207,
		210,
		216,
		240,
		239,
		-1,
		211,
		199,
		200,
		185,
		182,
		169,
		157,
		170,
		155,
		162,
		161,
		151,
		149,
		179,
		154,
		176,
		173,
		192,
		197,
		191,
		200,
		-1,
		256,
		252,
		248,
		255,
		204,
		-1,
		-1,
		244,
		-1,
		247,
		248,
		223,
		196,
		199,
		186,
		177,
		164,
		153,
		164,
		153,
		150,
		158,
		143,
		158,
		149,
		148,
		166,
		176,
		184,
		188,
		194,
		-1,
		306,
		-1,
		248,
		232,
		234,
		206,
		227,
		-1,
		264,
		248,
		240,
		225,
		225,
		-1,
		195,
		192,
		182,
		160,
		145,
		162,
		154,
		152,
		156,
		138,
		152,
		143,
		161,
		168,
		166,
		170,
		190,
		202,
		266,
		256,
		-1,
		238,
		243,
		202,
		210,
		229,
		267,
		231,
		-1,
		226,
		-1,
		197,
		210,
		-1,
		166,
		162,
		144,
		145,
		140,
		155,
		149,
		134,
		131,
		149,
		152,
		159,
		163,
		179,
		-1,
		-1,
		251,
		255,
		244,
		195,
		214,
		238,
		275,
		224,
		213,
		212,
		-1,
		203,
		180,
		177,
		165,
		152,
		137,
		138,
		146,
		159,
		138,
		133,
		130,
		150,
		176,
		154,
		166,
		-1,
		-1,
		-1,
		276,
		-1,
		-1,
		221,
		192,
		216,
		258,
		242,
		235,
		223,
		188,
		188,
		182,
		-1,
		176,
		155,
		146,
		135,
		133,
		146,
		143,
		148,
		128,
		126,
		145,
		157,
		148,
		165,
		-1,
		-1,
		-1,
		251,
		240,
		241,
		187,
		210,
		247,
		221,
		207,
		212,
		187,
		180,
		174,
		189,
		172,
		153,
		142,
		134,
		123,
		139,
		147,
		142,
		124,
		133,
		139,
		163,
		153,
		159,
		-1,
		-1,
		258,
		248,
		232,
		234,
		231,
		201,
		208,
		240,
		212,
		225,
		-1,
		179,
		-1,
		168,
		163,
		147,
		142,
		139,
		136,
		130,
		139,
		141,
		131,
		126,
		133,
		168,
		168,
		143,
		163,
		166,
		-1,
		-1,
		-1,
		251,
		246,
		221,
		198,
		182,
		218,
		-1,
		195,
		196,
		-1,
		173,
		167,
		164,
		149,
		145,
		140,
		144,
		137,
		144,
		137,
		135,
		136,
		118,
		150,
		-1,
		151,
		145,
		153,
		143,
		131,
		-1,
		-1,
		-1,
		244,
		223,
		216,
		236,
		177,
		229,
		-1,
		-1,
		180,
		173,
		-1,
		160,
		142,
		149,
		147,
		141,
		145,
		142,
		131,
		144,
		137,
		123,
		125,
		138,
		142,
		146,
		133,
		129,
		126,
		140,
		-1,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		197,
		-1,
		189,
		181,
		171,
		165,
		159,
		155,
		153,
		169,
		153,
		156,
		154,
		145,
		153,
		126,
		119,
		126,
		115,
		133,
		141,
		133,
		127,
		126,
		136,
		-1,
		264,
		250,
		221,
		-1,
		-1,
		210,
		-1,
		174,
		188,
		204,
		-1,
		197,
		176,
		191,
		169,
		165,
		161,
		176,
		177,
		155,
		154,
		152,
		143,
		131,
		120,
		123,
		115,
		137,
		137,
		121,
		122,
		126,
		-1,
		270,
		257,
		215,
		211,
		200,
		220,
		171,
		159,
		191,
		-1,
		-1,
		233,
		-1,
		167,
		184,
		175,
		173,
		166,
		152,
		159,
		163,
		140,
		135,
		125,
		114,
		114,
		109,
		131,
		117,
		115,
		124,
		135,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		186,
		173,
		167,
		-1,
		208,
		-1,
		211,
		201,
		185,
		170,
		203,
		-1,
		151,
		147,
		154,
		-1,
		160,
		-1,
		133,
		130,
		121,
		106,
		103,
		114,
		112,
		123,
		119,
		-1,
		220,
		205,
		198,
		188,
		202,
		173,
		-1,
		228,
		-1,
		-1,
		198,
		192,
		192,
		176,
		179,
		167,
		147,
		139,
		154,
		153,
		140,
		139,
		119,
		112,
		109,
		102,
		115,
		125,
		130,
		117,
		-1,
		-1,
		-1,
		225,
		211,
		215,
		175,
		194,
		-1,
		-1,
		260,
		215,
		201,
		-1,
		176,
		167,
		155,
		145,
		135,
		140,
		141,
		131,
		129,
		117,
		119,
		113,
		104,
		103,
		119,
		111,
		133,
		-1,
		-1,
		208,
		213,
		201,
		187,
		206,
		-1,
		-1,
		-1,
		207,
		223,
		195,
		174,
		156,
		-1,
		-1,
		139,
		132,
		126,
		129,
		117,
		133,
		128,
		112,
		97,
		112,
		116,
		124,
		115,
		-1,
		211,
		198,
		-1,
		-1,
		209,
		203,
		-1,
		-1,
		-1,
		-1,
		207,
		152,
		141,
		136,
		140,
		138,
		-1,
		112,
		123,
		116,
		135,
		142,
		114,
		99,
		93,
		99,
		111,
		120,
		-1,
		-1,
		223,
		-1,
		201,
		-1,
		-1,
		-1,
		-1,
		164,
		158,
		129,
		122,
		126,
		-1,
		114,
		116,
		113,
		125,
		117,
		114,
		105,
		96,
		92,
		96,
		100,
		107,
		113,
		246,
		-1,
		192,
		-1,
		-1,
		-1,
		182,
		197,
		168,
		145,
		118,
		113,
		106,
		100,
		105,
		116,
		125,
		136,
		101,
		99,
		89,
		88,
		92,
		109,
		109,
		-1,
		-1,
		190,
		186,
		208,
		190,
		194,
		195,
		-1,
		-1,
		122,
		113,
		104,
		96,
		109,
		112,
		97,
		99,
		99,
		93,
		87,
		97,
		108,
		103,
		-1,
		-1,
		-1,
		202,
		-1,
		204,
		-1,
		-1,
		192,
		193,
		140,
		122,
		118,
		116,
		105,
		99,
		87,
		92,
		102,
		96,
		93,
		83,
		83,
		106,
		95,
		101,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		181,
		173,
		168,
		174,
		176,
		167,
		155,
		152,
		-1,
		122,
		128,
		93,
		100,
		83,
		90,
		95,
		92,
		77,
		80,
		96,
		95,
		88,
		93,
		84,
		92,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		174,
		170,
		160,
		150,
		153,
		-1,
		-1,
		147,
		144,
		124,
		93,
		91,
		84,
		79,
		89,
		65,
		73,
		73,
		68,
		83,
		88,
		85,
		78,
		83,
		98,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		164,
		156,
		167,
		142,
		144,
		-1,
		-1,
		120,
		111,
		112,
		100,
		97,
		103,
		102,
		85,
		82,
		88,
		66,
		73,
		84,
		76,
		80,
		81,
		70,
		83,
		87,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		161,
		-1,
		-1,
		142,
		145,
		129,
		119,
		116,
		159,
		114,
		109,
		90,
		88,
		83,
		74,
		90,
		74,
		62,
		59,
		68,
		73,
		65,
		80,
		76,
		69,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		-1,
		132,
		-1,
		156,
		-1,
		139,
		143,
		122,
		125,
		104,
		91,
		77,
		77,
		83,
		74,
		70,
		66,
		55,
		57,
		69,
		73,
		83,
		85,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		173,
		212,
		138,
		-1,
		122,
		-1,
		-1,
		-1,
		153,
		135,
		127,
		124,
		103,
		103,
		69,
		65,
		78,
		75,
		81,
		72,
		57,
		56,
		67,
		78,
		77,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		188,
		179,
		206,
		145,
		134,
		129,
		116,
		-1,
		-1,
		137,
		145,
		-1,
		-1,
		110,
		77,
		65,
		67,
		71,
		85,
		81,
		69,
		49,
		55,
		49,
		73,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		207,
		197,
		178,
		176,
		201,
		-1,
		105,
		-1,
		-1,
		117,
		-1,
		-1,
		102,
		82,
		71,
		62,
		57,
		79,
		85,
		96,
		45,
		61,
		54,
		61,
		58,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		173,
		171,
		177,
		184,
		179,
		190,
		-1,
		-1,
		121,
		101,
		-1,
		-1,
		100,
		98,
		87,
		-1,
		77,
		59,
		54,
		81,
		62,
		54,
		48,
		42,
		49,
		48,
		59,
		51,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		170,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		-1,
		111,
		107,
		-1,
		-1,
		95,
		88,
		76,
		64,
		54,
		64,
		54,
		50,
		50,
		45,
		40,
		51,
		38,
		42,
		45,
		-1,
		244,
		-1,
		196,
		162,
		168,
		183,
		191,
		-1,
		-1,
		-1,
		128,
		114,
		107,
		95,
		93,
		-1,
		129,
		113,
		94,
		-1,
		64,
		77,
		86,
		54,
		46,
		44,
		34,
		45,
		36,
		44,
		38,
		41,
		-1,
		-1,
		161,
		144,
		-1,
		-1,
		118,
		120,
		-1,
		119,
		108,
		93,
		85,
		-1,
		-1,
		101,
		97,
		-1,
		-1,
		51,
		68,
		57,
		52,
		48,
		30,
		42,
		38,
		34,
		44,
		35,
		-1,
		-1,
		139,
		131,
		125,
		-1,
		103,
		-1,
		121,
		-1,
		88,
		94,
		82,
		-1,
		-1,
		-1,
		82,
		45,
		61,
		64,
		44,
		42,
		33,
		26,
		33,
		36,
		29,
		35,
		-1,
		-1,
		-1,
		121,
		95,
		128,
		119,
		102,
		82,
		74,
		93,
		-1,
		63,
		-1,
		38,
		41,
		46,
		52,
		55,
		47,
		23,
		36,
		30,
		27,
		25,
		127,
		-1,
		97,
		130,
		94,
		88,
		64,
		68,
		84,
		-1,
		60,
		42,
		-1,
		53,
		40,
		62,
		37,
		32,
		19,
		13,
		14,
		22,
		-1,
		-1,
		-1,
		99,
		98,
		90,
		84,
		84,
		69,
		60,
		-1,
		72,
		54,
		33,
		48,
		33,
		24,
		24,
		52,
		48,
		35,
		33,
		7,
		-1,
		200,
		-1,
		-1,
		122,
		-1,
		-1,
		-1,
		93,
		88,
		61,
		49,
		55,
		51,
		37,
		43,
		43,
		36,
		26,
		23,
		19,
		10,
		19,
		6,
		38,
		-1,
		195,
		-1,
		129,
		-1,
		-1,
		111,
		91,
		83,
		72,
		61,
		59,
		50,
		41,
		63,
		67,
		17,
		5,
		0,
		5,
		-1,
		184,
		183,
		-1,
		130,
		122,
		108,
		-1,
		101,
		-1,
		107,
		68,
		-1,
		70,
		50,
		-1,
		16,
		5,
		-1,
		-1,
		171,
		146,
		-1,
		-1,
		-1,
		131,
		111,
		102,
		86,
		-1,
		61,
		61,
		-1,
		-1,
		-1,
		156,
		155,
		-1,
		124,
		127,
		-1,
		117,
		108,
		116,
		63,
		67,
		-1,
		-1,
		-1,
		165,
		146,
		140,
		139,
		137,
		132,
		129,
		115,
		99,
		77,
		66,
		87,
		-1,
		-1,
		-1,
		137,
		129,
		122,
		-1,
		-1,
		124,
		107,
		88,
		86,
		-1,
		-1,
		-1,
		159,
		140,
		-1,
		-1,
		114,
		-1,
		-1,
		120,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		176,
		148,
		-1,
		-1,
		-1,
		110,
		106,
		107,
		-1,
		-1,
		-1,
		-1,
		170,
		171,
		194,
		158,
		-1,
		-1,
		-1,
		102,
		96,
		-1,
		-1,
		173,
		171,
		-1,
		-1,
		-1,
		130,
		114,
		-1,
		100,
		-1,
		-1,
		-1,
		121,
		-1,
		-1,
		133,
		-1,
		-1,
		-1,
		135,
		-1,
		135,
		110,
		117,
		-1,
		-1,
		-1,
		-1,
		148,
		140,
		148,
		-1,
		120,
		122,
		-1,
		170,
		-1,
		-1,
		163,
		154,
		-1,
		-1,
		125,
		132,
		154,
		157,
		193,
		-1,
		144
	],
	[
		-1,
		255,
		244,
		255,
		263,
		236,
		243,
		-1,
		262,
		266,
		232,
		226,
		265,
		234,
		240,
		251,
		-1,
		-1,
		-1,
		255,
		254,
		222,
		220,
		229,
		234,
		241,
		-1,
		240,
		-1,
		276,
		255,
		266,
		271,
		215,
		212,
		232,
		251,
		233,
		225,
		291,
		245,
		216,
		210,
		228,
		218,
		227,
		219,
		-1,
		216,
		206,
		228,
		207,
		218,
		210,
		-1,
		-1,
		210,
		211,
		217,
		203,
		209,
		205,
		-1,
		215,
		199,
		-1,
		-1,
		200,
		201,
		185,
		188,
		196,
		194,
		207,
		199,
		194,
		-1,
		-1,
		191,
		187,
		194,
		181,
		177,
		194,
		207,
		189,
		203,
		202,
		-1,
		195,
		213,
		220,
		188,
		186,
		170,
		168,
		186,
		188,
		194,
		194,
		-1,
		204,
		205,
		200,
		208,
		210,
		186,
		173,
		173,
		183,
		176,
		195,
		183,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		204,
		187,
		204,
		196,
		186,
		201,
		194,
		176,
		173,
		171,
		168,
		184,
		182,
		192,
		-1,
		-1,
		297,
		266,
		295,
		253,
		234,
		-1,
		200,
		180,
		186,
		190,
		184,
		177,
		191,
		187,
		-1,
		162,
		161,
		189,
		175,
		186,
		257,
		-1,
		-1,
		255,
		247,
		230,
		233,
		210,
		206,
		195,
		194,
		186,
		172,
		168,
		174,
		177,
		177,
		183,
		156,
		166,
		170,
		168,
		193,
		-1,
		-1,
		228,
		-1,
		-1,
		254,
		237,
		-1,
		220,
		227,
		216,
		222,
		208,
		229,
		205,
		196,
		188,
		182,
		170,
		172,
		169,
		182,
		170,
		153,
		178,
		182,
		163,
		184,
		179,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		213,
		216,
		222,
		246,
		245,
		-1,
		217,
		205,
		206,
		191,
		188,
		175,
		163,
		176,
		161,
		168,
		167,
		157,
		155,
		185,
		160,
		182,
		179,
		198,
		203,
		197,
		206,
		-1,
		262,
		258,
		254,
		261,
		210,
		-1,
		-1,
		250,
		-1,
		253,
		254,
		229,
		202,
		205,
		192,
		183,
		170,
		159,
		170,
		159,
		156,
		164,
		149,
		164,
		155,
		154,
		172,
		182,
		190,
		194,
		200,
		-1,
		312,
		-1,
		254,
		238,
		240,
		212,
		233,
		-1,
		270,
		254,
		246,
		231,
		231,
		-1,
		201,
		198,
		188,
		166,
		151,
		168,
		160,
		158,
		162,
		144,
		158,
		149,
		167,
		174,
		172,
		176,
		196,
		208,
		272,
		262,
		-1,
		244,
		249,
		208,
		216,
		235,
		273,
		237,
		-1,
		232,
		-1,
		203,
		216,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		155,
		140,
		137,
		155,
		158,
		165,
		169,
		185,
		-1,
		-1,
		257,
		261,
		250,
		201,
		220,
		244,
		281,
		230,
		219,
		218,
		-1,
		209,
		186,
		183,
		171,
		158,
		143,
		144,
		152,
		165,
		144,
		139,
		136,
		156,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		227,
		198,
		222,
		264,
		248,
		241,
		229,
		194,
		194,
		188,
		-1,
		182,
		161,
		152,
		141,
		139,
		152,
		149,
		154,
		134,
		132,
		151,
		163,
		154,
		171,
		-1,
		-1,
		-1,
		257,
		246,
		247,
		193,
		216,
		253,
		227,
		213,
		218,
		193,
		186,
		180,
		195,
		178,
		159,
		148,
		140,
		129,
		145,
		153,
		148,
		130,
		139,
		145,
		169,
		159,
		165,
		-1,
		-1,
		264,
		254,
		238,
		240,
		237,
		207,
		214,
		246,
		218,
		231,
		-1,
		185,
		-1,
		174,
		169,
		153,
		148,
		145,
		142,
		136,
		145,
		147,
		137,
		132,
		139,
		174,
		174,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		257,
		252,
		227,
		204,
		188,
		224,
		-1,
		201,
		202,
		-1,
		179,
		173,
		170,
		155,
		151,
		146,
		150,
		143,
		150,
		143,
		141,
		142,
		124,
		156,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		250,
		229,
		222,
		242,
		183,
		235,
		-1,
		-1,
		186,
		179,
		-1,
		166,
		148,
		155,
		153,
		147,
		151,
		148,
		137,
		150,
		143,
		129,
		131,
		144,
		148,
		152,
		139,
		135,
		132,
		146,
		-1,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		203,
		-1,
		195,
		187,
		177,
		171,
		165,
		161,
		159,
		175,
		159,
		162,
		160,
		151,
		159,
		132,
		125,
		132,
		121,
		139,
		147,
		139,
		133,
		132,
		142,
		-1,
		270,
		256,
		227,
		-1,
		-1,
		216,
		-1,
		180,
		194,
		210,
		-1,
		203,
		182,
		197,
		175,
		171,
		167,
		182,
		183,
		161,
		160,
		158,
		149,
		137,
		126,
		129,
		121,
		143,
		143,
		127,
		128,
		132,
		-1,
		276,
		263,
		221,
		217,
		206,
		226,
		177,
		165,
		197,
		-1,
		-1,
		239,
		-1,
		173,
		190,
		181,
		179,
		172,
		162,
		169,
		169,
		146,
		141,
		131,
		120,
		120,
		115,
		137,
		123,
		121,
		130,
		141,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		192,
		179,
		173,
		-1,
		214,
		-1,
		217,
		207,
		191,
		176,
		209,
		-1,
		161,
		157,
		164,
		-1,
		166,
		-1,
		139,
		136,
		127,
		112,
		109,
		120,
		118,
		129,
		125,
		-1,
		226,
		211,
		204,
		194,
		208,
		179,
		-1,
		234,
		-1,
		-1,
		204,
		198,
		198,
		182,
		185,
		177,
		157,
		149,
		164,
		161,
		150,
		147,
		125,
		118,
		115,
		108,
		121,
		131,
		136,
		123,
		-1,
		-1,
		-1,
		231,
		217,
		221,
		181,
		200,
		-1,
		-1,
		266,
		221,
		207,
		-1,
		186,
		177,
		165,
		155,
		145,
		150,
		151,
		141,
		137,
		123,
		125,
		119,
		110,
		109,
		125,
		117,
		139,
		-1,
		-1,
		214,
		219,
		207,
		193,
		212,
		-1,
		-1,
		-1,
		213,
		229,
		205,
		184,
		166,
		-1,
		-1,
		149,
		142,
		136,
		139,
		127,
		139,
		134,
		118,
		103,
		118,
		122,
		130,
		121,
		-1,
		217,
		204,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		-1,
		-1,
		217,
		162,
		151,
		146,
		150,
		148,
		-1,
		122,
		133,
		126,
		143,
		150,
		120,
		105,
		99,
		105,
		117,
		126,
		-1,
		-1,
		229,
		-1,
		211,
		-1,
		-1,
		-1,
		-1,
		174,
		168,
		139,
		132,
		136,
		-1,
		124,
		126,
		123,
		135,
		123,
		120,
		111,
		102,
		98,
		102,
		106,
		113,
		119,
		252,
		-1,
		202,
		-1,
		-1,
		-1,
		192,
		207,
		178,
		155,
		128,
		123,
		116,
		110,
		115,
		126,
		131,
		142,
		109,
		105,
		95,
		94,
		98,
		115,
		115,
		-1,
		-1,
		200,
		196,
		218,
		200,
		204,
		205,
		-1,
		-1,
		132,
		123,
		114,
		106,
		119,
		122,
		107,
		109,
		106,
		99,
		93,
		103,
		114,
		109,
		-1,
		-1,
		-1,
		212,
		-1,
		214,
		-1,
		-1,
		202,
		203,
		150,
		132,
		128,
		126,
		115,
		109,
		97,
		102,
		112,
		106,
		101,
		89,
		89,
		112,
		101,
		107,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		191,
		183,
		178,
		184,
		186,
		177,
		165,
		162,
		-1,
		132,
		138,
		103,
		110,
		93,
		100,
		105,
		102,
		83,
		86,
		102,
		101,
		94,
		99,
		90,
		98,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		184,
		180,
		170,
		160,
		163,
		-1,
		-1,
		157,
		154,
		134,
		103,
		101,
		94,
		89,
		99,
		75,
		79,
		79,
		74,
		89,
		94,
		91,
		84,
		89,
		104,
		-1,
		231,
		268,
		261,
		229,
		237,
		268,
		-1,
		174,
		166,
		177,
		152,
		154,
		-1,
		-1,
		130,
		121,
		122,
		110,
		107,
		113,
		112,
		94,
		88,
		94,
		72,
		79,
		90,
		82,
		86,
		87,
		76,
		89,
		93,
		-1,
		224,
		244,
		223,
		226,
		250,
		264,
		-1,
		171,
		-1,
		-1,
		152,
		155,
		139,
		129,
		126,
		169,
		124,
		119,
		96,
		94,
		91,
		82,
		96,
		80,
		68,
		65,
		74,
		79,
		71,
		86,
		82,
		75,
		-1,
		213,
		224,
		217,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		-1,
		142,
		-1,
		166,
		-1,
		149,
		153,
		132,
		135,
		110,
		97,
		83,
		83,
		89,
		80,
		76,
		72,
		61,
		63,
		75,
		79,
		89,
		91,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		183,
		222,
		148,
		-1,
		132,
		-1,
		-1,
		-1,
		163,
		145,
		137,
		130,
		109,
		109,
		75,
		71,
		84,
		81,
		87,
		78,
		63,
		62,
		73,
		84,
		83,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		198,
		189,
		216,
		155,
		144,
		139,
		126,
		-1,
		-1,
		147,
		155,
		-1,
		-1,
		116,
		87,
		75,
		73,
		77,
		91,
		87,
		75,
		55,
		61,
		55,
		79,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		217,
		207,
		188,
		186,
		211,
		-1,
		115,
		-1,
		-1,
		127,
		-1,
		-1,
		112,
		92,
		81,
		72,
		63,
		85,
		91,
		102,
		51,
		67,
		60,
		67,
		64,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		183,
		181,
		187,
		194,
		189,
		200,
		-1,
		-1,
		131,
		111,
		-1,
		-1,
		110,
		108,
		97,
		-1,
		87,
		69,
		60,
		87,
		68,
		60,
		54,
		48,
		55,
		54,
		65,
		57,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		136,
		-1,
		121,
		117,
		-1,
		-1,
		105,
		98,
		86,
		74,
		64,
		74,
		60,
		56,
		56,
		51,
		46,
		57,
		44,
		48,
		51,
		-1,
		254,
		-1,
		206,
		172,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		138,
		124,
		117,
		105,
		103,
		-1,
		139,
		123,
		104,
		-1,
		74,
		87,
		92,
		60,
		52,
		50,
		40,
		51,
		42,
		50,
		44,
		47,
		-1,
		-1,
		171,
		154,
		-1,
		-1,
		128,
		130,
		-1,
		129,
		118,
		103,
		95,
		-1,
		-1,
		111,
		107,
		-1,
		-1,
		61,
		74,
		63,
		58,
		54,
		36,
		48,
		44,
		40,
		50,
		41,
		-1,
		-1,
		149,
		141,
		135,
		-1,
		113,
		-1,
		131,
		-1,
		98,
		104,
		92,
		-1,
		-1,
		-1,
		92,
		55,
		71,
		74,
		50,
		48,
		39,
		32,
		39,
		42,
		35,
		41,
		-1,
		-1,
		-1,
		131,
		105,
		138,
		129,
		112,
		92,
		84,
		103,
		-1,
		73,
		-1,
		48,
		51,
		56,
		58,
		61,
		55,
		29,
		42,
		36,
		33,
		31,
		137,
		-1,
		107,
		140,
		104,
		98,
		74,
		78,
		94,
		-1,
		70,
		52,
		-1,
		63,
		50,
		72,
		47,
		38,
		25,
		19,
		20,
		28,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		94,
		79,
		70,
		-1,
		82,
		64,
		43,
		58,
		43,
		34,
		34,
		62,
		58,
		41,
		39,
		13,
		-1,
		210,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		98,
		71,
		59,
		65,
		61,
		47,
		53,
		53,
		46,
		36,
		33,
		29,
		20,
		24,
		12,
		42,
		-1,
		205,
		-1,
		139,
		-1,
		-1,
		121,
		101,
		93,
		82,
		71,
		69,
		60,
		51,
		73,
		77,
		27,
		15,
		10,
		0,
		-1,
		194,
		193,
		-1,
		140,
		132,
		118,
		-1,
		111,
		-1,
		117,
		78,
		-1,
		80,
		60,
		-1,
		26,
		15,
		-1,
		-1,
		181,
		156,
		-1,
		-1,
		-1,
		141,
		121,
		112,
		96,
		-1,
		71,
		71,
		-1,
		-1,
		-1,
		166,
		165,
		-1,
		134,
		137,
		-1,
		127,
		118,
		126,
		73,
		77,
		-1,
		-1,
		-1,
		175,
		156,
		150,
		149,
		147,
		142,
		139,
		125,
		109,
		87,
		76,
		97,
		-1,
		-1,
		-1,
		147,
		139,
		132,
		-1,
		-1,
		134,
		117,
		98,
		96,
		-1,
		-1,
		-1,
		169,
		150,
		-1,
		-1,
		124,
		-1,
		-1,
		130,
		95,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		158,
		-1,
		-1,
		-1,
		120,
		116,
		117,
		-1,
		-1,
		-1,
		-1,
		180,
		181,
		204,
		168,
		-1,
		-1,
		-1,
		112,
		106,
		-1,
		-1,
		183,
		181,
		-1,
		-1,
		-1,
		140,
		124,
		-1,
		110,
		-1,
		-1,
		-1,
		131,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		145,
		-1,
		145,
		120,
		127,
		-1,
		-1,
		-1,
		-1,
		158,
		150,
		158,
		-1,
		130,
		132,
		-1,
		180,
		-1,
		-1,
		173,
		164,
		-1,
		-1,
		135,
		142,
		164,
		167,
		203,
		-1,
		154
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		375,
		364,
		375,
		383,
		356,
		363,
		-1,
		382,
		386,
		352,
		346,
		385,
		354,
		360,
		371,
		-1,
		-1,
		-1,
		375,
		374,
		342,
		340,
		349,
		354,
		361,
		-1,
		360,
		-1,
		396,
		375,
		386,
		391,
		335,
		332,
		352,
		371,
		353,
		345,
		411,
		365,
		336,
		330,
		348,
		338,
		347,
		339,
		-1,
		336,
		326,
		348,
		327,
		338,
		330,
		-1,
		-1,
		330,
		331,
		337,
		323,
		329,
		325,
		-1,
		335,
		319,
		-1,
		-1,
		320,
		321,
		305,
		308,
		316,
		314,
		327,
		319,
		314,
		-1,
		-1,
		311,
		307,
		314,
		301,
		297,
		314,
		327,
		309,
		323,
		322,
		-1,
		315,
		333,
		340,
		308,
		306,
		290,
		288,
		306,
		308,
		314,
		314,
		-1,
		324,
		325,
		320,
		328,
		330,
		306,
		293,
		293,
		303,
		296,
		315,
		303,
		349,
		-1,
		-1,
		-1,
		-1,
		-1,
		358,
		324,
		307,
		324,
		316,
		306,
		321,
		314,
		296,
		293,
		291,
		288,
		304,
		302,
		312,
		-1,
		-1,
		417,
		386,
		415,
		373,
		354,
		-1,
		320,
		300,
		306,
		310,
		304,
		297,
		311,
		307,
		-1,
		282,
		281,
		309,
		295,
		306,
		377,
		-1,
		-1,
		375,
		367,
		350,
		353,
		330,
		326,
		315,
		314,
		306,
		292,
		288,
		294,
		297,
		297,
		303,
		276,
		286,
		290,
		288,
		313,
		-1,
		-1,
		348,
		-1,
		-1,
		374,
		357,
		-1,
		340,
		347,
		336,
		342,
		328,
		349,
		325,
		316,
		308,
		302,
		290,
		292,
		289,
		302,
		290,
		273,
		298,
		302,
		283,
		304,
		299,
		-1,
		347,
		331,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		352,
		333,
		336,
		342,
		366,
		365,
		-1,
		337,
		325,
		326,
		311,
		308,
		295,
		283,
		296,
		281,
		288,
		287,
		277,
		275,
		305,
		280,
		302,
		299,
		318,
		323,
		317,
		326,
		-1,
		382,
		378,
		374,
		381,
		330,
		-1,
		-1,
		370,
		-1,
		373,
		374,
		349,
		322,
		325,
		312,
		303,
		290,
		279,
		290,
		279,
		276,
		284,
		269,
		284,
		275,
		274,
		292,
		302,
		310,
		314,
		320,
		-1,
		432,
		-1,
		374,
		358,
		360,
		332,
		353,
		-1,
		390,
		374,
		366,
		351,
		351,
		-1,
		321,
		318,
		308,
		286,
		271,
		288,
		280,
		278,
		282,
		264,
		278,
		269,
		287,
		294,
		292,
		296,
		316,
		328,
		392,
		382,
		-1,
		364,
		369,
		328,
		336,
		355,
		393,
		357,
		-1,
		352,
		-1,
		323,
		336,
		-1,
		292,
		288,
		270,
		271,
		266,
		281,
		275,
		260,
		257,
		275,
		278,
		285,
		289,
		305,
		-1,
		-1,
		377,
		381,
		370,
		321,
		340,
		364,
		401,
		350,
		339,
		338,
		-1,
		329,
		306,
		303,
		291,
		278,
		263,
		264,
		272,
		285,
		264,
		259,
		256,
		276,
		302,
		280,
		292,
		-1,
		-1,
		-1,
		402,
		-1,
		-1,
		347,
		318,
		342,
		384,
		368,
		361,
		349,
		314,
		314,
		308,
		-1,
		302,
		281,
		272,
		261,
		259,
		272,
		269,
		274,
		254,
		252,
		271,
		283,
		274,
		291,
		-1,
		-1,
		-1,
		377,
		366,
		367,
		313,
		336,
		373,
		347,
		333,
		338,
		313,
		306,
		300,
		315,
		298,
		279,
		268,
		260,
		249,
		265,
		273,
		268,
		250,
		259,
		265,
		289,
		279,
		285,
		-1,
		-1,
		384,
		374,
		358,
		360,
		357,
		327,
		334,
		366,
		338,
		351,
		-1,
		305,
		-1,
		294,
		289,
		273,
		268,
		265,
		262,
		256,
		265,
		267,
		257,
		252,
		259,
		294,
		294,
		269,
		289,
		292,
		-1,
		-1,
		-1,
		377,
		372,
		347,
		324,
		308,
		344,
		-1,
		321,
		322,
		-1,
		299,
		293,
		290,
		275,
		271,
		266,
		270,
		263,
		270,
		263,
		261,
		262,
		244,
		276,
		-1,
		277,
		271,
		279,
		269,
		257,
		-1,
		-1,
		-1,
		370,
		349,
		342,
		362,
		303,
		355,
		-1,
		-1,
		306,
		299,
		-1,
		286,
		268,
		275,
		273,
		267,
		271,
		268,
		257,
		270,
		263,
		249,
		251,
		264,
		268,
		272,
		259,
		255,
		252,
		266,
		-1,
		389,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		323,
		-1,
		315,
		307,
		297,
		291,
		285,
		281,
		279,
		295,
		279,
		282,
		280,
		271,
		279,
		252,
		245,
		252,
		241,
		259,
		267,
		259,
		253,
		252,
		262,
		-1,
		390,
		376,
		347,
		-1,
		-1,
		336,
		-1,
		300,
		314,
		330,
		-1,
		323,
		302,
		317,
		295,
		291,
		287,
		302,
		303,
		280,
		280,
		278,
		269,
		257,
		246,
		249,
		241,
		263,
		263,
		247,
		248,
		252,
		-1,
		396,
		383,
		341,
		337,
		326,
		346,
		297,
		285,
		317,
		-1,
		-1,
		359,
		-1,
		293,
		310,
		301,
		299,
		292,
		274,
		281,
		289,
		266,
		261,
		251,
		240,
		240,
		235,
		257,
		243,
		241,
		250,
		266,
		-1,
		-1,
		-1,
		363,
		-1,
		-1,
		312,
		299,
		293,
		-1,
		334,
		-1,
		337,
		327,
		311,
		296,
		329,
		-1,
		273,
		269,
		276,
		-1,
		286,
		-1,
		259,
		256,
		247,
		232,
		229,
		240,
		238,
		249,
		245,
		-1,
		346,
		331,
		324,
		314,
		328,
		299,
		-1,
		354,
		-1,
		-1,
		324,
		318,
		318,
		302,
		303,
		289,
		269,
		261,
		276,
		275,
		262,
		261,
		245,
		238,
		235,
		228,
		241,
		251,
		256,
		243,
		-1,
		-1,
		-1,
		351,
		337,
		341,
		301,
		320,
		-1,
		-1,
		386,
		341,
		327,
		-1,
		298,
		289,
		277,
		267,
		257,
		262,
		263,
		253,
		251,
		243,
		245,
		239,
		230,
		229,
		245,
		237,
		259,
		-1,
		-1,
		334,
		339,
		327,
		313,
		331,
		-1,
		-1,
		-1,
		333,
		349,
		317,
		296,
		278,
		-1,
		-1,
		261,
		254,
		248,
		251,
		239,
		259,
		254,
		238,
		223,
		238,
		242,
		250,
		241,
		-1,
		337,
		324,
		-1,
		-1,
		330,
		320,
		-1,
		-1,
		-1,
		-1,
		329,
		274,
		263,
		258,
		262,
		260,
		-1,
		234,
		245,
		238,
		257,
		264,
		240,
		225,
		219,
		225,
		237,
		246,
		-1,
		-1,
		344,
		-1,
		306,
		-1,
		-1,
		-1,
		-1,
		286,
		280,
		251,
		244,
		248,
		-1,
		236,
		238,
		235,
		247,
		243,
		240,
		231,
		222,
		218,
		222,
		226,
		240,
		244,
		367,
		-1,
		297,
		-1,
		-1,
		-1,
		304,
		319,
		290,
		267,
		240,
		235,
		228,
		222,
		227,
		238,
		247,
		258,
		223,
		225,
		215,
		214,
		218,
		235,
		239,
		-1,
		-1,
		295,
		291,
		326,
		312,
		316,
		317,
		-1,
		-1,
		244,
		235,
		226,
		218,
		231,
		234,
		219,
		221,
		221,
		219,
		213,
		223,
		238,
		233,
		-1,
		-1,
		-1,
		303,
		-1,
		309,
		-1,
		-1,
		310,
		315,
		262,
		244,
		240,
		238,
		227,
		221,
		209,
		214,
		224,
		218,
		215,
		209,
		213,
		236,
		225,
		264,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		269,
		278,
		273,
		289,
		294,
		285,
		277,
		274,
		-1,
		244,
		250,
		215,
		222,
		205,
		212,
		217,
		214,
		203,
		210,
		226,
		225,
		220,
		256,
		247,
		253,
		-1,
		-1,
		296,
		285,
		274,
		280,
		-1,
		262,
		275,
		275,
		265,
		271,
		-1,
		-1,
		269,
		266,
		246,
		215,
		213,
		206,
		201,
		211,
		187,
		199,
		203,
		207,
		213,
		218,
		223,
		229,
		244,
		259,
		-1,
		250,
		287,
		280,
		248,
		256,
		287,
		-1,
		252,
		244,
		272,
		257,
		265,
		-1,
		-1,
		242,
		233,
		234,
		222,
		219,
		225,
		224,
		207,
		213,
		214,
		206,
		205,
		223,
		227,
		236,
		243,
		233,
		246,
		250,
		-1,
		243,
		263,
		242,
		245,
		269,
		283,
		-1,
		243,
		-1,
		-1,
		232,
		267,
		251,
		241,
		238,
		281,
		236,
		231,
		212,
		210,
		205,
		196,
		221,
		214,
		214,
		217,
		232,
		237,
		229,
		243,
		243,
		244,
		-1,
		232,
		243,
		236,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		222,
		-1,
		278,
		-1,
		261,
		265,
		244,
		247,
		226,
		213,
		199,
		207,
		213,
		212,
		218,
		218,
		219,
		228,
		239,
		251,
		250,
		251,
		203,
		213,
		216,
		227,
		238,
		253,
		257,
		-1,
		227,
		263,
		228,
		-1,
		212,
		-1,
		-1,
		-1,
		275,
		257,
		249,
		246,
		225,
		225,
		191,
		195,
		208,
		215,
		225,
		236,
		228,
		232,
		245,
		256,
		259,
		199,
		204,
		257,
		202,
		202,
		223,
		232,
		253,
		223,
		220,
		257,
		235,
		224,
		219,
		206,
		-1,
		-1,
		259,
		267,
		-1,
		-1,
		232,
		199,
		187,
		197,
		201,
		215,
		227,
		240,
		228,
		233,
		227,
		259,
		-1,
		199,
		194,
		181,
		176,
		170,
		182,
		193,
		220,
		-1,
		-1,
		221,
		248,
		232,
		236,
		252,
		277,
		-1,
		190,
		-1,
		-1,
		239,
		-1,
		-1,
		224,
		204,
		193,
		184,
		189,
		209,
		220,
		242,
		224,
		241,
		232,
		242,
		246,
		183,
		176,
		164,
		166,
		172,
		201,
		189,
		-1,
		208,
		206,
		212,
		219,
		236,
		266,
		-1,
		-1,
		206,
		186,
		-1,
		-1,
		222,
		220,
		209,
		-1,
		199,
		181,
		186,
		216,
		218,
		220,
		227,
		221,
		228,
		236,
		247,
		239,
		192,
		202,
		191,
		164,
		173,
		186,
		194,
		193,
		205,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		196,
		192,
		-1,
		-1,
		217,
		210,
		198,
		186,
		176,
		186,
		203,
		203,
		206,
		211,
		219,
		230,
		226,
		230,
		233,
		-1,
		201,
		-1,
		225,
		207,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		213,
		199,
		192,
		180,
		178,
		-1,
		251,
		235,
		216,
		-1,
		186,
		199,
		239,
		207,
		212,
		207,
		222,
		233,
		224,
		232,
		226,
		229,
		-1,
		-1,
		209,
		192,
		-1,
		-1,
		166,
		168,
		-1,
		204,
		193,
		178,
		170,
		-1,
		-1,
		223,
		219,
		-1,
		-1,
		173,
		211,
		210,
		218,
		213,
		218,
		230,
		226,
		222,
		232,
		223,
		-1,
		-1,
		187,
		179,
		173,
		-1,
		151,
		-1,
		206,
		-1,
		173,
		182,
		170,
		-1,
		-1,
		-1,
		204,
		167,
		183,
		206,
		232,
		230,
		221,
		214,
		221,
		224,
		217,
		223,
		-1,
		-1,
		-1,
		126,
		146,
		213,
		204,
		187,
		167,
		159,
		181,
		-1,
		185,
		-1,
		160,
		163,
		188,
		227,
		229,
		215,
		211,
		224,
		218,
		215,
		213,
		120,
		-1,
		149,
		182,
		146,
		173,
		139,
		153,
		199,
		-1,
		182,
		164,
		-1,
		192,
		182,
		230,
		205,
		214,
		207,
		201,
		202,
		210,
		-1,
		-1,
		-1,
		151,
		150,
		142,
		136,
		136,
		134,
		151,
		-1,
		187,
		169,
		155,
		172,
		172,
		163,
		171,
		220,
		216,
		219,
		217,
		195,
		-1,
		18,
		-1,
		-1,
		174,
		-1,
		-1,
		-1,
		145,
		129,
		142,
		153,
		156,
		152,
		152,
		154,
		167,
		175,
		173,
		170,
		182,
		178,
		198,
		194,
		226,
		-1,
		13,
		-1,
		181,
		-1,
		-1,
		107,
		113,
		123,
		134,
		162,
		162,
		151,
		147,
		164,
		199,
		185,
		183,
		188,
		193,
		-1,
		0,
		1,
		-1,
		71,
		81,
		102,
		-1,
		104,
		-1,
		208,
		169,
		-1,
		148,
		142,
		-1,
		194,
		190,
		-1,
		-1,
		14,
		60,
		-1,
		-1,
		-1,
		103,
		112,
		203,
		187,
		-1,
		132,
		139,
		-1,
		-1,
		-1,
		28,
		51,
		-1,
		96,
		99,
		-1,
		113,
		119,
		147,
		127,
		133,
		-1,
		-1,
		-1,
		55,
		39,
		44,
		86,
		81,
		104,
		144,
		130,
		130,
		114,
		124,
		153,
		-1,
		-1,
		-1,
		58,
		55,
		66,
		-1,
		-1,
		155,
		138,
		125,
		123,
		-1,
		-1,
		-1,
		80,
		61,
		-1,
		-1,
		75,
		-1,
		-1,
		120,
		99,
		-1,
		-1,
		-1,
		-1,
		-1,
		98,
		69,
		-1,
		-1,
		-1,
		76,
		83,
		104,
		-1,
		-1,
		-1,
		-1,
		95,
		96,
		115,
		90,
		-1,
		-1,
		-1,
		90,
		93,
		-1,
		-1,
		98,
		96,
		-1,
		-1,
		-1,
		118,
		102,
		-1,
		104,
		-1,
		-1,
		-1,
		109,
		-1,
		-1,
		137,
		-1,
		-1,
		-1,
		123,
		-1,
		139,
		114,
		121,
		-1,
		-1,
		-1,
		-1,
		136,
		128,
		152,
		-1,
		124,
		126,
		-1,
		174,
		-1,
		-1,
		151,
		142,
		-1,
		-1,
		129,
		136,
		158,
		161,
		181,
		-1,
		148
	],
	[
		-1,
		374,
		363,
		374,
		382,
		355,
		362,
		-1,
		381,
		385,
		351,
		345,
		384,
		353,
		359,
		370,
		-1,
		-1,
		-1,
		374,
		373,
		341,
		339,
		348,
		353,
		360,
		-1,
		359,
		-1,
		395,
		374,
		385,
		390,
		334,
		331,
		351,
		370,
		352,
		344,
		410,
		364,
		335,
		329,
		347,
		337,
		346,
		338,
		-1,
		335,
		325,
		347,
		326,
		337,
		329,
		-1,
		-1,
		329,
		330,
		336,
		322,
		328,
		324,
		-1,
		334,
		318,
		-1,
		-1,
		319,
		320,
		304,
		307,
		315,
		313,
		326,
		318,
		313,
		-1,
		-1,
		310,
		306,
		313,
		300,
		296,
		313,
		326,
		308,
		322,
		321,
		-1,
		314,
		332,
		339,
		307,
		305,
		289,
		287,
		305,
		307,
		313,
		313,
		-1,
		323,
		324,
		319,
		327,
		329,
		305,
		292,
		292,
		302,
		295,
		314,
		302,
		348,
		-1,
		-1,
		-1,
		-1,
		-1,
		357,
		323,
		306,
		323,
		315,
		305,
		320,
		313,
		295,
		292,
		290,
		287,
		303,
		301,
		311,
		-1,
		-1,
		416,
		385,
		414,
		372,
		353,
		-1,
		319,
		299,
		305,
		309,
		303,
		296,
		310,
		306,
		-1,
		281,
		280,
		308,
		294,
		305,
		376,
		-1,
		-1,
		374,
		366,
		349,
		352,
		329,
		325,
		314,
		313,
		305,
		291,
		287,
		293,
		296,
		296,
		302,
		275,
		285,
		289,
		287,
		312,
		-1,
		-1,
		347,
		-1,
		-1,
		373,
		356,
		-1,
		339,
		346,
		335,
		341,
		327,
		348,
		324,
		315,
		307,
		301,
		289,
		291,
		288,
		301,
		289,
		272,
		297,
		301,
		282,
		303,
		298,
		-1,
		346,
		330,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		351,
		332,
		335,
		341,
		365,
		364,
		-1,
		336,
		324,
		325,
		310,
		307,
		294,
		282,
		295,
		280,
		287,
		286,
		276,
		274,
		304,
		279,
		301,
		298,
		317,
		322,
		316,
		325,
		-1,
		381,
		377,
		373,
		380,
		329,
		-1,
		-1,
		369,
		-1,
		372,
		373,
		348,
		321,
		324,
		311,
		302,
		289,
		278,
		289,
		278,
		275,
		283,
		268,
		283,
		274,
		273,
		291,
		301,
		309,
		313,
		319,
		-1,
		431,
		-1,
		373,
		357,
		359,
		331,
		352,
		-1,
		389,
		373,
		365,
		350,
		350,
		-1,
		320,
		317,
		307,
		285,
		270,
		287,
		279,
		277,
		281,
		263,
		277,
		268,
		286,
		293,
		291,
		295,
		315,
		327,
		391,
		381,
		-1,
		363,
		368,
		327,
		335,
		354,
		392,
		356,
		-1,
		351,
		-1,
		322,
		335,
		-1,
		291,
		287,
		269,
		270,
		265,
		280,
		274,
		259,
		256,
		274,
		277,
		284,
		288,
		304,
		-1,
		-1,
		376,
		380,
		369,
		320,
		339,
		363,
		400,
		349,
		338,
		337,
		-1,
		328,
		305,
		302,
		290,
		277,
		262,
		263,
		271,
		284,
		263,
		258,
		255,
		275,
		301,
		279,
		291,
		-1,
		-1,
		-1,
		401,
		-1,
		-1,
		346,
		317,
		341,
		383,
		367,
		360,
		348,
		313,
		313,
		307,
		-1,
		301,
		280,
		271,
		260,
		258,
		271,
		268,
		273,
		253,
		251,
		270,
		282,
		273,
		290,
		-1,
		-1,
		-1,
		376,
		365,
		366,
		312,
		335,
		372,
		346,
		332,
		337,
		312,
		305,
		299,
		314,
		297,
		278,
		267,
		259,
		248,
		264,
		272,
		267,
		249,
		258,
		264,
		288,
		278,
		284,
		-1,
		-1,
		383,
		373,
		357,
		359,
		356,
		326,
		333,
		365,
		337,
		350,
		-1,
		304,
		-1,
		293,
		288,
		272,
		267,
		264,
		261,
		255,
		264,
		266,
		256,
		251,
		258,
		293,
		293,
		268,
		288,
		291,
		-1,
		-1,
		-1,
		376,
		371,
		346,
		323,
		307,
		343,
		-1,
		320,
		321,
		-1,
		298,
		292,
		289,
		274,
		270,
		265,
		269,
		262,
		269,
		262,
		260,
		261,
		243,
		275,
		-1,
		276,
		270,
		278,
		268,
		256,
		-1,
		-1,
		-1,
		369,
		348,
		341,
		361,
		302,
		354,
		-1,
		-1,
		305,
		298,
		-1,
		285,
		267,
		274,
		272,
		266,
		270,
		267,
		256,
		269,
		262,
		248,
		250,
		263,
		267,
		271,
		258,
		254,
		251,
		265,
		-1,
		388,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		322,
		-1,
		314,
		306,
		296,
		290,
		284,
		280,
		278,
		294,
		278,
		281,
		279,
		270,
		278,
		251,
		244,
		251,
		240,
		258,
		266,
		258,
		252,
		251,
		261,
		-1,
		389,
		375,
		346,
		-1,
		-1,
		335,
		-1,
		299,
		313,
		329,
		-1,
		322,
		301,
		316,
		294,
		290,
		286,
		301,
		302,
		279,
		279,
		277,
		268,
		256,
		245,
		248,
		240,
		262,
		262,
		246,
		247,
		251,
		-1,
		395,
		382,
		340,
		336,
		325,
		345,
		296,
		284,
		316,
		-1,
		-1,
		358,
		-1,
		292,
		309,
		300,
		298,
		291,
		273,
		280,
		288,
		265,
		260,
		250,
		239,
		239,
		234,
		256,
		242,
		240,
		249,
		265,
		-1,
		-1,
		-1,
		362,
		-1,
		-1,
		311,
		298,
		292,
		-1,
		333,
		-1,
		336,
		326,
		310,
		295,
		328,
		-1,
		272,
		268,
		275,
		-1,
		285,
		-1,
		258,
		255,
		246,
		231,
		228,
		239,
		237,
		248,
		244,
		-1,
		345,
		330,
		323,
		313,
		327,
		298,
		-1,
		353,
		-1,
		-1,
		323,
		317,
		317,
		301,
		302,
		288,
		268,
		260,
		275,
		274,
		261,
		260,
		244,
		237,
		234,
		227,
		240,
		250,
		255,
		242,
		-1,
		-1,
		-1,
		350,
		336,
		340,
		300,
		319,
		-1,
		-1,
		385,
		340,
		326,
		-1,
		297,
		288,
		276,
		266,
		256,
		261,
		262,
		252,
		250,
		242,
		244,
		238,
		229,
		228,
		244,
		236,
		258,
		-1,
		-1,
		333,
		338,
		326,
		312,
		330,
		-1,
		-1,
		-1,
		332,
		348,
		316,
		295,
		277,
		-1,
		-1,
		260,
		253,
		247,
		250,
		238,
		258,
		253,
		237,
		222,
		237,
		241,
		249,
		240,
		-1,
		336,
		323,
		-1,
		-1,
		329,
		319,
		-1,
		-1,
		-1,
		-1,
		328,
		273,
		262,
		257,
		261,
		259,
		-1,
		233,
		244,
		237,
		256,
		263,
		239,
		224,
		218,
		224,
		236,
		245,
		-1,
		-1,
		343,
		-1,
		305,
		-1,
		-1,
		-1,
		-1,
		285,
		279,
		250,
		243,
		247,
		-1,
		235,
		237,
		234,
		246,
		242,
		239,
		230,
		221,
		217,
		221,
		225,
		239,
		243,
		366,
		-1,
		296,
		-1,
		-1,
		-1,
		303,
		318,
		289,
		266,
		239,
		234,
		227,
		221,
		226,
		237,
		246,
		257,
		222,
		224,
		214,
		213,
		217,
		234,
		238,
		-1,
		-1,
		294,
		290,
		325,
		311,
		315,
		316,
		-1,
		-1,
		243,
		234,
		225,
		217,
		230,
		233,
		218,
		220,
		220,
		218,
		212,
		222,
		237,
		232,
		-1,
		-1,
		-1,
		304,
		-1,
		308,
		-1,
		-1,
		311,
		314,
		261,
		243,
		239,
		237,
		226,
		220,
		208,
		213,
		223,
		217,
		214,
		208,
		212,
		235,
		224,
		263,
		-1,
		-1,
		304,
		-1,
		-1,
		-1,
		270,
		277,
		272,
		290,
		295,
		286,
		276,
		273,
		-1,
		243,
		249,
		214,
		221,
		204,
		211,
		216,
		213,
		202,
		209,
		225,
		224,
		219,
		255,
		246,
		252,
		-1,
		-1,
		297,
		286,
		275,
		281,
		-1,
		263,
		274,
		276,
		266,
		272,
		-1,
		-1,
		268,
		265,
		245,
		214,
		212,
		205,
		200,
		210,
		186,
		198,
		202,
		206,
		212,
		217,
		222,
		228,
		243,
		258,
		-1,
		251,
		288,
		281,
		249,
		257,
		288,
		-1,
		253,
		245,
		271,
		258,
		265,
		-1,
		-1,
		241,
		232,
		233,
		221,
		218,
		224,
		223,
		206,
		212,
		213,
		205,
		204,
		222,
		226,
		235,
		242,
		232,
		245,
		249,
		-1,
		244,
		264,
		243,
		246,
		270,
		284,
		-1,
		244,
		-1,
		-1,
		231,
		266,
		250,
		240,
		237,
		280,
		235,
		230,
		211,
		209,
		204,
		195,
		220,
		213,
		213,
		216,
		231,
		236,
		228,
		242,
		242,
		243,
		-1,
		233,
		244,
		237,
		-1,
		-1,
		-1,
		-1,
		238,
		-1,
		-1,
		221,
		-1,
		277,
		-1,
		260,
		264,
		243,
		246,
		225,
		212,
		198,
		206,
		212,
		211,
		217,
		217,
		218,
		227,
		238,
		250,
		249,
		250,
		204,
		214,
		217,
		228,
		239,
		254,
		258,
		-1,
		228,
		264,
		227,
		-1,
		211,
		-1,
		-1,
		-1,
		274,
		256,
		248,
		245,
		224,
		224,
		190,
		194,
		207,
		214,
		224,
		235,
		227,
		231,
		244,
		255,
		258,
		200,
		205,
		258,
		203,
		203,
		224,
		233,
		254,
		224,
		221,
		258,
		234,
		223,
		218,
		205,
		-1,
		-1,
		258,
		266,
		-1,
		-1,
		231,
		198,
		186,
		196,
		200,
		214,
		226,
		239,
		227,
		232,
		226,
		258,
		-1,
		200,
		195,
		182,
		177,
		171,
		183,
		194,
		221,
		-1,
		-1,
		222,
		249,
		233,
		237,
		253,
		278,
		-1,
		189,
		-1,
		-1,
		238,
		-1,
		-1,
		223,
		203,
		192,
		183,
		188,
		208,
		219,
		241,
		223,
		240,
		231,
		241,
		245,
		184,
		177,
		165,
		167,
		173,
		202,
		190,
		-1,
		209,
		207,
		213,
		220,
		237,
		267,
		-1,
		-1,
		205,
		185,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		180,
		185,
		215,
		217,
		219,
		226,
		220,
		227,
		235,
		246,
		238,
		193,
		203,
		192,
		165,
		174,
		187,
		195,
		194,
		206,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		191,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		202,
		202,
		205,
		210,
		218,
		229,
		225,
		229,
		232,
		-1,
		202,
		-1,
		226,
		208,
		217,
		232,
		240,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		238,
		206,
		211,
		206,
		221,
		232,
		223,
		231,
		225,
		228,
		-1,
		-1,
		210,
		193,
		-1,
		-1,
		167,
		169,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		172,
		210,
		209,
		217,
		212,
		217,
		229,
		225,
		221,
		231,
		222,
		-1,
		-1,
		188,
		180,
		174,
		-1,
		152,
		-1,
		205,
		-1,
		172,
		181,
		169,
		-1,
		-1,
		-1,
		203,
		166,
		182,
		205,
		231,
		229,
		220,
		213,
		220,
		223,
		216,
		222,
		-1,
		-1,
		-1,
		127,
		146,
		212,
		203,
		186,
		166,
		158,
		180,
		-1,
		184,
		-1,
		159,
		162,
		187,
		226,
		228,
		214,
		210,
		223,
		217,
		214,
		212,
		121,
		-1,
		148,
		181,
		145,
		172,
		138,
		152,
		198,
		-1,
		181,
		163,
		-1,
		191,
		181,
		229,
		204,
		213,
		206,
		200,
		201,
		209,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		133,
		150,
		-1,
		186,
		168,
		154,
		171,
		171,
		162,
		170,
		219,
		215,
		218,
		216,
		194,
		-1,
		19,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		128,
		141,
		152,
		155,
		151,
		151,
		153,
		166,
		174,
		172,
		169,
		181,
		177,
		197,
		193,
		225,
		-1,
		14,
		-1,
		180,
		-1,
		-1,
		106,
		112,
		122,
		133,
		161,
		161,
		150,
		146,
		163,
		198,
		184,
		182,
		187,
		192,
		-1,
		1,
		0,
		-1,
		70,
		80,
		101,
		-1,
		103,
		-1,
		207,
		168,
		-1,
		147,
		141,
		-1,
		193,
		189,
		-1,
		-1,
		13,
		59,
		-1,
		-1,
		-1,
		102,
		111,
		202,
		186,
		-1,
		131,
		138,
		-1,
		-1,
		-1,
		27,
		50,
		-1,
		95,
		98,
		-1,
		112,
		118,
		146,
		126,
		132,
		-1,
		-1,
		-1,
		54,
		38,
		43,
		85,
		80,
		103,
		143,
		129,
		129,
		113,
		123,
		152,
		-1,
		-1,
		-1,
		57,
		54,
		65,
		-1,
		-1,
		154,
		137,
		124,
		122,
		-1,
		-1,
		-1,
		79,
		60,
		-1,
		-1,
		74,
		-1,
		-1,
		119,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		97,
		68,
		-1,
		-1,
		-1,
		75,
		82,
		103,
		-1,
		-1,
		-1,
		-1,
		94,
		95,
		114,
		89,
		-1,
		-1,
		-1,
		89,
		92,
		-1,
		-1,
		97,
		95,
		-1,
		-1,
		-1,
		117,
		101,
		-1,
		103,
		-1,
		-1,
		-1,
		108,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		122,
		-1,
		138,
		113,
		120,
		-1,
		-1,
		-1,
		-1,
		135,
		127,
		151,
		-1,
		123,
		125,
		-1,
		173,
		-1,
		-1,
		150,
		141,
		-1,
		-1,
		128,
		135,
		157,
		160,
		180,
		-1,
		147
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		326,
		315,
		326,
		334,
		307,
		314,
		-1,
		333,
		337,
		303,
		297,
		336,
		305,
		311,
		322,
		-1,
		-1,
		-1,
		326,
		325,
		293,
		291,
		300,
		305,
		312,
		-1,
		311,
		-1,
		347,
		326,
		337,
		342,
		286,
		283,
		303,
		322,
		304,
		296,
		362,
		316,
		287,
		281,
		299,
		289,
		298,
		290,
		-1,
		287,
		277,
		299,
		278,
		289,
		281,
		-1,
		-1,
		281,
		282,
		288,
		274,
		280,
		276,
		-1,
		286,
		270,
		-1,
		-1,
		271,
		272,
		256,
		259,
		267,
		265,
		278,
		270,
		265,
		-1,
		-1,
		262,
		258,
		265,
		252,
		248,
		265,
		278,
		260,
		274,
		273,
		-1,
		266,
		284,
		291,
		259,
		257,
		241,
		239,
		257,
		259,
		265,
		265,
		-1,
		275,
		276,
		271,
		279,
		281,
		257,
		244,
		244,
		254,
		247,
		266,
		254,
		300,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		275,
		258,
		275,
		267,
		257,
		272,
		265,
		247,
		244,
		242,
		239,
		255,
		253,
		263,
		-1,
		-1,
		368,
		337,
		366,
		324,
		305,
		-1,
		271,
		251,
		257,
		261,
		255,
		248,
		262,
		258,
		-1,
		233,
		232,
		260,
		246,
		257,
		328,
		-1,
		-1,
		326,
		318,
		301,
		304,
		281,
		277,
		266,
		265,
		257,
		243,
		239,
		245,
		248,
		248,
		254,
		227,
		237,
		241,
		239,
		264,
		-1,
		-1,
		299,
		-1,
		-1,
		325,
		308,
		-1,
		291,
		298,
		287,
		293,
		279,
		300,
		276,
		267,
		259,
		253,
		241,
		243,
		240,
		253,
		241,
		224,
		249,
		253,
		234,
		255,
		250,
		-1,
		298,
		282,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		284,
		287,
		293,
		317,
		316,
		-1,
		288,
		276,
		277,
		262,
		259,
		246,
		234,
		247,
		232,
		239,
		238,
		228,
		226,
		256,
		231,
		253,
		250,
		269,
		274,
		268,
		277,
		-1,
		333,
		329,
		325,
		332,
		281,
		-1,
		-1,
		321,
		-1,
		324,
		325,
		300,
		273,
		276,
		263,
		254,
		241,
		230,
		241,
		230,
		227,
		235,
		220,
		235,
		226,
		225,
		243,
		253,
		261,
		265,
		271,
		-1,
		383,
		-1,
		325,
		309,
		311,
		283,
		304,
		-1,
		341,
		325,
		317,
		302,
		302,
		-1,
		272,
		269,
		259,
		237,
		222,
		239,
		231,
		229,
		233,
		215,
		229,
		220,
		238,
		245,
		243,
		247,
		267,
		279,
		343,
		333,
		-1,
		315,
		320,
		279,
		287,
		306,
		344,
		308,
		-1,
		303,
		-1,
		274,
		287,
		-1,
		243,
		239,
		221,
		222,
		217,
		232,
		226,
		211,
		208,
		226,
		229,
		236,
		240,
		256,
		-1,
		-1,
		328,
		332,
		321,
		272,
		291,
		315,
		352,
		301,
		290,
		289,
		-1,
		280,
		257,
		254,
		242,
		229,
		214,
		215,
		223,
		236,
		215,
		210,
		207,
		227,
		253,
		231,
		243,
		-1,
		-1,
		-1,
		353,
		-1,
		-1,
		298,
		269,
		293,
		335,
		319,
		312,
		300,
		265,
		265,
		259,
		-1,
		253,
		232,
		223,
		212,
		210,
		223,
		220,
		225,
		205,
		203,
		222,
		234,
		225,
		242,
		-1,
		-1,
		-1,
		328,
		317,
		318,
		264,
		287,
		324,
		298,
		284,
		289,
		264,
		257,
		251,
		266,
		249,
		230,
		219,
		211,
		200,
		216,
		224,
		219,
		201,
		210,
		216,
		240,
		230,
		236,
		-1,
		-1,
		335,
		325,
		309,
		311,
		308,
		278,
		285,
		317,
		289,
		302,
		-1,
		256,
		-1,
		245,
		240,
		224,
		219,
		216,
		213,
		207,
		216,
		218,
		208,
		203,
		210,
		245,
		245,
		220,
		240,
		243,
		-1,
		-1,
		-1,
		328,
		323,
		298,
		275,
		259,
		295,
		-1,
		272,
		273,
		-1,
		250,
		244,
		241,
		226,
		222,
		217,
		221,
		214,
		221,
		214,
		212,
		213,
		195,
		227,
		-1,
		228,
		222,
		230,
		220,
		208,
		-1,
		-1,
		-1,
		321,
		300,
		293,
		313,
		254,
		306,
		-1,
		-1,
		257,
		250,
		-1,
		237,
		219,
		226,
		224,
		218,
		222,
		219,
		208,
		221,
		214,
		200,
		202,
		215,
		219,
		223,
		210,
		206,
		203,
		217,
		-1,
		340,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		274,
		-1,
		266,
		258,
		248,
		242,
		236,
		232,
		230,
		246,
		230,
		233,
		231,
		222,
		230,
		203,
		196,
		203,
		192,
		210,
		218,
		210,
		204,
		203,
		213,
		-1,
		341,
		327,
		298,
		-1,
		-1,
		287,
		-1,
		251,
		265,
		281,
		-1,
		274,
		253,
		268,
		246,
		242,
		238,
		253,
		254,
		231,
		231,
		229,
		220,
		208,
		197,
		200,
		192,
		214,
		214,
		198,
		199,
		203,
		-1,
		347,
		334,
		292,
		288,
		277,
		297,
		248,
		236,
		268,
		-1,
		-1,
		310,
		-1,
		244,
		261,
		252,
		250,
		243,
		225,
		232,
		240,
		217,
		212,
		202,
		191,
		191,
		186,
		208,
		194,
		192,
		201,
		217,
		-1,
		-1,
		-1,
		314,
		-1,
		-1,
		263,
		250,
		244,
		-1,
		285,
		-1,
		288,
		278,
		262,
		247,
		280,
		-1,
		224,
		220,
		227,
		-1,
		237,
		-1,
		210,
		207,
		198,
		183,
		180,
		191,
		189,
		200,
		196,
		-1,
		297,
		282,
		275,
		265,
		279,
		250,
		-1,
		305,
		-1,
		-1,
		275,
		269,
		269,
		253,
		254,
		240,
		220,
		212,
		227,
		226,
		213,
		212,
		196,
		189,
		186,
		179,
		192,
		202,
		207,
		194,
		-1,
		-1,
		-1,
		302,
		288,
		292,
		252,
		271,
		-1,
		-1,
		337,
		292,
		278,
		-1,
		249,
		240,
		228,
		218,
		208,
		213,
		214,
		204,
		202,
		194,
		196,
		190,
		181,
		180,
		196,
		188,
		210,
		-1,
		-1,
		285,
		290,
		278,
		264,
		266,
		-1,
		-1,
		-1,
		284,
		300,
		268,
		247,
		229,
		-1,
		-1,
		212,
		205,
		199,
		202,
		190,
		210,
		205,
		189,
		174,
		189,
		193,
		201,
		192,
		-1,
		288,
		275,
		-1,
		-1,
		265,
		255,
		-1,
		-1,
		-1,
		-1,
		280,
		225,
		214,
		209,
		213,
		211,
		-1,
		185,
		196,
		189,
		208,
		215,
		191,
		176,
		170,
		176,
		188,
		197,
		-1,
		-1,
		279,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		237,
		231,
		202,
		195,
		199,
		-1,
		187,
		189,
		186,
		198,
		194,
		191,
		182,
		173,
		169,
		173,
		177,
		191,
		195,
		302,
		-1,
		232,
		-1,
		-1,
		-1,
		255,
		270,
		241,
		218,
		191,
		186,
		179,
		173,
		178,
		189,
		198,
		209,
		174,
		176,
		166,
		165,
		169,
		186,
		190,
		-1,
		-1,
		230,
		226,
		261,
		263,
		267,
		268,
		-1,
		-1,
		195,
		186,
		177,
		169,
		182,
		185,
		170,
		172,
		172,
		170,
		164,
		174,
		189,
		184,
		-1,
		-1,
		-1,
		242,
		-1,
		244,
		-1,
		-1,
		263,
		266,
		213,
		195,
		191,
		189,
		178,
		172,
		160,
		165,
		175,
		169,
		166,
		160,
		164,
		187,
		176,
		215,
		-1,
		-1,
		264,
		-1,
		-1,
		-1,
		224,
		213,
		208,
		242,
		247,
		238,
		228,
		225,
		-1,
		195,
		201,
		166,
		173,
		156,
		163,
		168,
		165,
		154,
		161,
		177,
		176,
		171,
		207,
		198,
		204,
		-1,
		-1,
		257,
		246,
		235,
		241,
		-1,
		217,
		210,
		228,
		218,
		224,
		-1,
		-1,
		220,
		217,
		197,
		166,
		164,
		157,
		152,
		162,
		138,
		150,
		154,
		158,
		164,
		169,
		174,
		180,
		195,
		210,
		-1,
		211,
		248,
		241,
		209,
		217,
		248,
		-1,
		207,
		199,
		207,
		210,
		217,
		-1,
		-1,
		193,
		184,
		185,
		173,
		170,
		176,
		175,
		158,
		164,
		165,
		157,
		156,
		174,
		178,
		187,
		194,
		184,
		197,
		201,
		-1,
		204,
		224,
		203,
		206,
		230,
		244,
		-1,
		198,
		-1,
		-1,
		167,
		218,
		202,
		192,
		189,
		232,
		187,
		182,
		163,
		161,
		156,
		147,
		172,
		165,
		165,
		168,
		183,
		188,
		180,
		194,
		194,
		195,
		-1,
		193,
		204,
		197,
		-1,
		-1,
		-1,
		-1,
		192,
		-1,
		-1,
		157,
		-1,
		229,
		-1,
		212,
		216,
		195,
		198,
		177,
		164,
		150,
		158,
		164,
		163,
		169,
		169,
		170,
		179,
		190,
		202,
		201,
		202,
		218,
		174,
		177,
		188,
		199,
		214,
		218,
		-1,
		182,
		218,
		163,
		-1,
		147,
		-1,
		-1,
		-1,
		226,
		208,
		200,
		197,
		176,
		176,
		142,
		146,
		159,
		166,
		176,
		187,
		179,
		183,
		196,
		207,
		210,
		214,
		205,
		218,
		163,
		163,
		184,
		193,
		214,
		178,
		175,
		212,
		170,
		159,
		154,
		141,
		-1,
		-1,
		210,
		218,
		-1,
		-1,
		183,
		150,
		138,
		148,
		152,
		166,
		178,
		191,
		179,
		184,
		178,
		210,
		-1,
		207,
		206,
		195,
		192,
		168,
		159,
		154,
		181,
		-1,
		-1,
		176,
		203,
		187,
		191,
		201,
		226,
		-1,
		125,
		-1,
		-1,
		190,
		-1,
		-1,
		175,
		155,
		144,
		135,
		140,
		160,
		171,
		193,
		175,
		192,
		183,
		193,
		197,
		191,
		188,
		176,
		174,
		197,
		162,
		150,
		-1,
		158,
		161,
		167,
		174,
		191,
		215,
		-1,
		-1,
		141,
		121,
		-1,
		-1,
		173,
		171,
		160,
		-1,
		150,
		132,
		137,
		167,
		169,
		171,
		178,
		172,
		179,
		187,
		198,
		190,
		200,
		214,
		203,
		199,
		198,
		206,
		155,
		148,
		155,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		131,
		127,
		-1,
		-1,
		168,
		161,
		149,
		137,
		127,
		137,
		154,
		154,
		157,
		162,
		170,
		181,
		177,
		181,
		184,
		-1,
		234,
		-1,
		186,
		147,
		153,
		168,
		176,
		-1,
		-1,
		-1,
		148,
		134,
		127,
		115,
		113,
		-1,
		202,
		186,
		167,
		-1,
		137,
		150,
		190,
		158,
		163,
		158,
		173,
		184,
		175,
		183,
		177,
		180,
		-1,
		-1,
		146,
		129,
		-1,
		-1,
		103,
		105,
		-1,
		139,
		128,
		113,
		105,
		-1,
		-1,
		174,
		170,
		-1,
		-1,
		124,
		162,
		161,
		169,
		164,
		169,
		181,
		177,
		173,
		183,
		174,
		-1,
		-1,
		124,
		116,
		110,
		-1,
		88,
		-1,
		141,
		-1,
		108,
		115,
		103,
		-1,
		-1,
		-1,
		155,
		118,
		134,
		157,
		183,
		181,
		172,
		165,
		172,
		175,
		168,
		174,
		-1,
		-1,
		-1,
		106,
		80,
		148,
		139,
		122,
		102,
		94,
		114,
		-1,
		136,
		-1,
		111,
		114,
		139,
		178,
		180,
		166,
		162,
		175,
		169,
		166,
		164,
		112,
		-1,
		82,
		115,
		79,
		108,
		74,
		86,
		150,
		-1,
		133,
		115,
		-1,
		143,
		133,
		181,
		156,
		165,
		158,
		152,
		153,
		161,
		-1,
		-1,
		-1,
		84,
		83,
		75,
		69,
		69,
		67,
		85,
		-1,
		138,
		120,
		106,
		123,
		123,
		114,
		122,
		171,
		167,
		170,
		168,
		146,
		-1,
		92,
		-1,
		-1,
		107,
		-1,
		-1,
		-1,
		78,
		68,
		81,
		87,
		99,
		108,
		103,
		105,
		118,
		126,
		124,
		121,
		133,
		129,
		149,
		145,
		177,
		-1,
		87,
		-1,
		114,
		-1,
		-1,
		36,
		50,
		62,
		73,
		95,
		95,
		100,
		98,
		120,
		150,
		136,
		134,
		139,
		144,
		-1,
		76,
		75,
		-1,
		0,
		10,
		31,
		-1,
		48,
		-1,
		141,
		102,
		-1,
		127,
		107,
		-1,
		145,
		141,
		-1,
		-1,
		63,
		16,
		-1,
		-1,
		-1,
		79,
		61,
		136,
		120,
		-1,
		118,
		118,
		-1,
		-1,
		-1,
		48,
		25,
		-1,
		72,
		75,
		-1,
		68,
		74,
		103,
		119,
		124,
		-1,
		-1,
		-1,
		57,
		37,
		42,
		84,
		79,
		80,
		99,
		85,
		87,
		104,
		116,
		144,
		-1,
		-1,
		-1,
		56,
		53,
		64,
		-1,
		-1,
		112,
		95,
		95,
		113,
		-1,
		-1,
		-1,
		78,
		59,
		-1,
		-1,
		73,
		-1,
		-1,
		108,
		97,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		67,
		-1,
		-1,
		-1,
		74,
		81,
		102,
		-1,
		-1,
		-1,
		-1,
		93,
		94,
		113,
		88,
		-1,
		-1,
		-1,
		88,
		91,
		-1,
		-1,
		96,
		94,
		-1,
		-1,
		-1,
		116,
		100,
		-1,
		102,
		-1,
		-1,
		-1,
		107,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		121,
		-1,
		137,
		112,
		119,
		-1,
		-1,
		-1,
		-1,
		134,
		126,
		150,
		-1,
		122,
		124,
		-1,
		172,
		-1,
		-1,
		149,
		140,
		-1,
		-1,
		127,
		134,
		156,
		159,
		179,
		-1,
		146
	],
	[
		-1,
		319,
		308,
		319,
		327,
		300,
		307,
		-1,
		326,
		330,
		296,
		290,
		329,
		298,
		304,
		315,
		-1,
		-1,
		-1,
		319,
		318,
		286,
		284,
		293,
		298,
		305,
		-1,
		304,
		-1,
		340,
		319,
		330,
		335,
		279,
		276,
		296,
		315,
		297,
		289,
		355,
		309,
		280,
		274,
		292,
		282,
		291,
		283,
		-1,
		280,
		270,
		292,
		271,
		282,
		274,
		-1,
		-1,
		274,
		275,
		281,
		267,
		273,
		269,
		-1,
		279,
		263,
		-1,
		-1,
		264,
		265,
		249,
		252,
		260,
		258,
		271,
		263,
		258,
		-1,
		-1,
		255,
		251,
		258,
		245,
		241,
		258,
		271,
		253,
		267,
		266,
		-1,
		259,
		277,
		284,
		252,
		250,
		234,
		232,
		250,
		252,
		258,
		258,
		-1,
		268,
		269,
		264,
		272,
		274,
		250,
		237,
		237,
		247,
		240,
		259,
		247,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		268,
		251,
		268,
		260,
		250,
		265,
		258,
		240,
		237,
		235,
		232,
		248,
		246,
		256,
		-1,
		-1,
		361,
		330,
		359,
		317,
		298,
		-1,
		264,
		244,
		250,
		254,
		248,
		241,
		255,
		251,
		-1,
		226,
		225,
		253,
		239,
		250,
		321,
		-1,
		-1,
		319,
		311,
		294,
		297,
		274,
		270,
		259,
		258,
		250,
		236,
		232,
		238,
		241,
		241,
		247,
		220,
		230,
		234,
		232,
		257,
		-1,
		-1,
		292,
		-1,
		-1,
		318,
		301,
		-1,
		284,
		291,
		280,
		286,
		272,
		293,
		269,
		260,
		252,
		246,
		234,
		236,
		233,
		246,
		234,
		217,
		242,
		246,
		227,
		248,
		243,
		-1,
		291,
		275,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		277,
		280,
		286,
		310,
		309,
		-1,
		281,
		269,
		270,
		255,
		252,
		239,
		227,
		240,
		225,
		232,
		231,
		221,
		219,
		249,
		224,
		246,
		243,
		262,
		267,
		261,
		270,
		-1,
		326,
		322,
		318,
		325,
		274,
		-1,
		-1,
		314,
		-1,
		317,
		318,
		293,
		266,
		269,
		256,
		247,
		234,
		223,
		234,
		223,
		220,
		228,
		213,
		228,
		219,
		218,
		236,
		246,
		254,
		258,
		264,
		-1,
		376,
		-1,
		318,
		302,
		304,
		276,
		297,
		-1,
		334,
		318,
		310,
		295,
		295,
		-1,
		265,
		262,
		252,
		230,
		215,
		232,
		224,
		222,
		226,
		208,
		222,
		213,
		231,
		238,
		236,
		240,
		260,
		272,
		336,
		326,
		-1,
		308,
		313,
		272,
		280,
		299,
		337,
		301,
		-1,
		296,
		-1,
		267,
		280,
		-1,
		236,
		232,
		214,
		215,
		210,
		225,
		219,
		204,
		201,
		219,
		222,
		229,
		233,
		249,
		-1,
		-1,
		321,
		325,
		314,
		265,
		284,
		308,
		345,
		294,
		283,
		282,
		-1,
		273,
		250,
		247,
		235,
		222,
		207,
		208,
		216,
		229,
		208,
		203,
		200,
		220,
		246,
		224,
		236,
		-1,
		-1,
		-1,
		346,
		-1,
		-1,
		291,
		262,
		286,
		328,
		312,
		305,
		293,
		258,
		258,
		252,
		-1,
		246,
		225,
		216,
		205,
		203,
		216,
		213,
		218,
		198,
		196,
		215,
		227,
		218,
		235,
		-1,
		-1,
		-1,
		321,
		310,
		311,
		257,
		280,
		317,
		291,
		277,
		282,
		257,
		250,
		244,
		259,
		242,
		223,
		212,
		204,
		193,
		209,
		217,
		212,
		194,
		203,
		209,
		233,
		223,
		229,
		-1,
		-1,
		328,
		318,
		302,
		304,
		301,
		271,
		278,
		310,
		282,
		295,
		-1,
		249,
		-1,
		238,
		233,
		217,
		212,
		209,
		206,
		200,
		209,
		211,
		201,
		196,
		203,
		238,
		238,
		213,
		233,
		236,
		-1,
		-1,
		-1,
		321,
		316,
		291,
		268,
		252,
		288,
		-1,
		265,
		266,
		-1,
		243,
		237,
		234,
		219,
		215,
		210,
		214,
		207,
		214,
		207,
		205,
		206,
		188,
		220,
		-1,
		221,
		215,
		223,
		213,
		201,
		-1,
		-1,
		-1,
		314,
		293,
		286,
		306,
		247,
		299,
		-1,
		-1,
		250,
		243,
		-1,
		230,
		212,
		219,
		217,
		211,
		215,
		212,
		201,
		214,
		207,
		193,
		195,
		208,
		212,
		216,
		203,
		199,
		196,
		210,
		-1,
		333,
		-1,
		-1,
		-1,
		-1,
		-1,
		247,
		267,
		-1,
		259,
		251,
		241,
		235,
		229,
		225,
		223,
		239,
		223,
		226,
		224,
		215,
		223,
		196,
		189,
		196,
		185,
		203,
		211,
		203,
		197,
		196,
		206,
		-1,
		334,
		320,
		291,
		-1,
		-1,
		280,
		-1,
		244,
		258,
		274,
		-1,
		267,
		246,
		261,
		239,
		235,
		231,
		246,
		247,
		224,
		224,
		222,
		213,
		201,
		190,
		193,
		185,
		207,
		207,
		191,
		192,
		196,
		-1,
		340,
		327,
		285,
		281,
		270,
		290,
		241,
		229,
		261,
		-1,
		-1,
		303,
		-1,
		237,
		254,
		245,
		243,
		236,
		218,
		225,
		233,
		210,
		205,
		195,
		184,
		184,
		179,
		201,
		187,
		185,
		194,
		210,
		-1,
		-1,
		-1,
		307,
		-1,
		-1,
		256,
		243,
		237,
		-1,
		278,
		-1,
		281,
		271,
		255,
		240,
		273,
		-1,
		217,
		213,
		220,
		-1,
		230,
		-1,
		203,
		200,
		191,
		176,
		173,
		184,
		182,
		193,
		189,
		-1,
		290,
		275,
		268,
		258,
		272,
		243,
		-1,
		298,
		-1,
		-1,
		268,
		262,
		262,
		246,
		247,
		233,
		213,
		205,
		220,
		219,
		206,
		205,
		189,
		182,
		179,
		172,
		185,
		195,
		200,
		187,
		-1,
		-1,
		-1,
		295,
		281,
		285,
		245,
		264,
		-1,
		-1,
		330,
		285,
		271,
		-1,
		242,
		233,
		221,
		211,
		201,
		206,
		207,
		197,
		195,
		187,
		189,
		183,
		174,
		173,
		189,
		181,
		203,
		-1,
		-1,
		278,
		283,
		271,
		257,
		259,
		-1,
		-1,
		-1,
		277,
		293,
		261,
		240,
		222,
		-1,
		-1,
		205,
		198,
		192,
		195,
		183,
		203,
		198,
		182,
		167,
		182,
		186,
		194,
		185,
		-1,
		281,
		268,
		-1,
		-1,
		258,
		248,
		-1,
		-1,
		-1,
		-1,
		273,
		218,
		207,
		202,
		206,
		204,
		-1,
		178,
		189,
		182,
		201,
		208,
		184,
		169,
		163,
		169,
		181,
		190,
		-1,
		-1,
		272,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		230,
		224,
		195,
		188,
		192,
		-1,
		180,
		182,
		179,
		191,
		187,
		184,
		175,
		166,
		162,
		166,
		170,
		184,
		188,
		295,
		-1,
		225,
		-1,
		-1,
		-1,
		248,
		263,
		234,
		211,
		184,
		179,
		172,
		166,
		171,
		182,
		191,
		202,
		167,
		169,
		159,
		158,
		162,
		179,
		183,
		-1,
		-1,
		223,
		219,
		254,
		256,
		260,
		261,
		-1,
		-1,
		188,
		179,
		170,
		162,
		175,
		178,
		163,
		165,
		165,
		163,
		157,
		167,
		182,
		177,
		-1,
		-1,
		-1,
		235,
		-1,
		237,
		-1,
		-1,
		256,
		259,
		206,
		188,
		184,
		182,
		171,
		165,
		153,
		158,
		168,
		162,
		159,
		153,
		157,
		180,
		169,
		208,
		-1,
		-1,
		257,
		-1,
		-1,
		-1,
		217,
		206,
		201,
		235,
		240,
		231,
		221,
		218,
		-1,
		188,
		194,
		159,
		166,
		149,
		156,
		161,
		158,
		147,
		154,
		170,
		169,
		164,
		200,
		191,
		197,
		-1,
		-1,
		250,
		239,
		228,
		234,
		-1,
		210,
		203,
		221,
		211,
		217,
		-1,
		-1,
		213,
		210,
		190,
		159,
		157,
		150,
		145,
		155,
		131,
		143,
		147,
		151,
		157,
		162,
		167,
		173,
		188,
		203,
		-1,
		204,
		241,
		234,
		202,
		210,
		241,
		-1,
		200,
		192,
		200,
		203,
		210,
		-1,
		-1,
		186,
		177,
		178,
		166,
		163,
		169,
		168,
		151,
		157,
		158,
		150,
		149,
		167,
		171,
		180,
		187,
		177,
		190,
		194,
		-1,
		197,
		217,
		196,
		199,
		223,
		237,
		-1,
		191,
		-1,
		-1,
		160,
		211,
		195,
		185,
		182,
		225,
		180,
		175,
		156,
		154,
		149,
		140,
		165,
		158,
		158,
		161,
		176,
		181,
		173,
		187,
		187,
		188,
		-1,
		186,
		197,
		190,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		150,
		-1,
		222,
		-1,
		205,
		209,
		188,
		191,
		170,
		157,
		143,
		151,
		157,
		156,
		162,
		162,
		163,
		172,
		183,
		195,
		194,
		195,
		211,
		167,
		170,
		181,
		192,
		207,
		211,
		-1,
		175,
		211,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		219,
		201,
		193,
		190,
		169,
		169,
		135,
		139,
		152,
		159,
		169,
		180,
		172,
		176,
		189,
		200,
		203,
		207,
		198,
		211,
		156,
		156,
		177,
		186,
		207,
		171,
		168,
		205,
		163,
		152,
		147,
		134,
		-1,
		-1,
		203,
		211,
		-1,
		-1,
		176,
		143,
		131,
		141,
		145,
		159,
		171,
		184,
		172,
		177,
		171,
		203,
		-1,
		200,
		199,
		188,
		185,
		161,
		152,
		147,
		174,
		-1,
		-1,
		169,
		196,
		180,
		184,
		194,
		219,
		-1,
		118,
		-1,
		-1,
		183,
		-1,
		-1,
		168,
		148,
		137,
		128,
		133,
		153,
		164,
		186,
		168,
		185,
		176,
		186,
		190,
		184,
		181,
		169,
		167,
		190,
		155,
		143,
		-1,
		151,
		154,
		160,
		167,
		184,
		208,
		-1,
		-1,
		134,
		114,
		-1,
		-1,
		166,
		164,
		153,
		-1,
		143,
		125,
		130,
		160,
		162,
		164,
		171,
		165,
		172,
		180,
		191,
		183,
		193,
		207,
		196,
		192,
		191,
		199,
		148,
		141,
		148,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		124,
		120,
		-1,
		-1,
		161,
		154,
		142,
		130,
		120,
		130,
		147,
		147,
		150,
		155,
		163,
		174,
		170,
		174,
		177,
		-1,
		227,
		-1,
		179,
		140,
		146,
		161,
		169,
		-1,
		-1,
		-1,
		141,
		127,
		120,
		108,
		106,
		-1,
		195,
		179,
		160,
		-1,
		130,
		143,
		183,
		151,
		156,
		151,
		166,
		177,
		168,
		176,
		170,
		173,
		-1,
		-1,
		139,
		122,
		-1,
		-1,
		96,
		98,
		-1,
		132,
		121,
		106,
		98,
		-1,
		-1,
		167,
		163,
		-1,
		-1,
		117,
		155,
		154,
		162,
		157,
		162,
		174,
		170,
		166,
		176,
		167,
		-1,
		-1,
		117,
		109,
		103,
		-1,
		81,
		-1,
		134,
		-1,
		101,
		108,
		96,
		-1,
		-1,
		-1,
		148,
		111,
		127,
		150,
		176,
		174,
		165,
		158,
		165,
		168,
		161,
		167,
		-1,
		-1,
		-1,
		99,
		73,
		141,
		132,
		115,
		95,
		87,
		107,
		-1,
		129,
		-1,
		104,
		107,
		132,
		171,
		173,
		159,
		155,
		168,
		162,
		159,
		157,
		105,
		-1,
		75,
		108,
		72,
		101,
		67,
		79,
		143,
		-1,
		126,
		108,
		-1,
		136,
		126,
		174,
		149,
		158,
		151,
		145,
		146,
		154,
		-1,
		-1,
		-1,
		77,
		76,
		68,
		62,
		62,
		60,
		78,
		-1,
		131,
		113,
		99,
		116,
		116,
		107,
		115,
		164,
		160,
		163,
		161,
		139,
		-1,
		103,
		-1,
		-1,
		100,
		-1,
		-1,
		-1,
		71,
		61,
		74,
		80,
		92,
		101,
		96,
		98,
		111,
		119,
		117,
		114,
		126,
		122,
		142,
		138,
		170,
		-1,
		98,
		-1,
		107,
		-1,
		-1,
		29,
		43,
		55,
		66,
		88,
		88,
		93,
		91,
		113,
		143,
		129,
		127,
		132,
		137,
		-1,
		87,
		86,
		-1,
		11,
		0,
		24,
		-1,
		41,
		-1,
		134,
		95,
		-1,
		120,
		100,
		-1,
		138,
		134,
		-1,
		-1,
		74,
		27,
		-1,
		-1,
		-1,
		72,
		54,
		129,
		113,
		-1,
		111,
		111,
		-1,
		-1,
		-1,
		59,
		36,
		-1,
		65,
		68,
		-1,
		61,
		67,
		96,
		112,
		117,
		-1,
		-1,
		-1,
		68,
		48,
		53,
		80,
		85,
		73,
		92,
		78,
		80,
		97,
		109,
		137,
		-1,
		-1,
		-1,
		67,
		64,
		75,
		-1,
		-1,
		105,
		88,
		88,
		106,
		-1,
		-1,
		-1,
		89,
		70,
		-1,
		-1,
		84,
		-1,
		-1,
		101,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		78,
		-1,
		-1,
		-1,
		85,
		92,
		112,
		-1,
		-1,
		-1,
		-1,
		104,
		105,
		124,
		99,
		-1,
		-1,
		-1,
		99,
		102,
		-1,
		-1,
		107,
		105,
		-1,
		-1,
		-1,
		127,
		111,
		-1,
		113,
		-1,
		-1,
		-1,
		118,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		132,
		-1,
		148,
		123,
		130,
		-1,
		-1,
		-1,
		-1,
		145,
		137,
		161,
		-1,
		133,
		135,
		-1,
		183,
		-1,
		-1,
		160,
		151,
		-1,
		-1,
		138,
		145,
		167,
		170,
		190,
		-1,
		157
	],
	[
		-1,
		303,
		292,
		303,
		311,
		284,
		291,
		-1,
		310,
		314,
		280,
		274,
		313,
		282,
		288,
		299,
		-1,
		-1,
		-1,
		303,
		302,
		270,
		268,
		277,
		282,
		289,
		-1,
		288,
		-1,
		324,
		303,
		314,
		319,
		263,
		260,
		280,
		299,
		281,
		273,
		339,
		293,
		264,
		258,
		276,
		266,
		275,
		267,
		-1,
		264,
		254,
		276,
		255,
		266,
		258,
		-1,
		-1,
		258,
		259,
		265,
		251,
		257,
		253,
		-1,
		263,
		247,
		-1,
		-1,
		248,
		249,
		233,
		236,
		244,
		242,
		255,
		247,
		242,
		-1,
		-1,
		239,
		235,
		242,
		229,
		225,
		242,
		255,
		237,
		251,
		250,
		-1,
		243,
		261,
		268,
		236,
		234,
		218,
		216,
		234,
		236,
		242,
		242,
		-1,
		252,
		253,
		248,
		256,
		258,
		234,
		221,
		221,
		231,
		224,
		243,
		231,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		252,
		235,
		252,
		244,
		234,
		249,
		242,
		224,
		221,
		219,
		216,
		232,
		230,
		240,
		-1,
		-1,
		345,
		314,
		343,
		301,
		282,
		-1,
		248,
		228,
		234,
		238,
		232,
		225,
		239,
		235,
		-1,
		210,
		209,
		237,
		223,
		234,
		305,
		-1,
		-1,
		303,
		295,
		278,
		281,
		258,
		254,
		243,
		242,
		234,
		220,
		216,
		222,
		225,
		225,
		231,
		204,
		214,
		218,
		216,
		241,
		-1,
		-1,
		276,
		-1,
		-1,
		302,
		285,
		-1,
		268,
		275,
		264,
		270,
		256,
		277,
		253,
		244,
		236,
		230,
		218,
		220,
		217,
		230,
		218,
		201,
		226,
		230,
		211,
		232,
		227,
		-1,
		275,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		261,
		264,
		270,
		294,
		293,
		-1,
		265,
		253,
		254,
		239,
		236,
		223,
		211,
		224,
		209,
		216,
		215,
		205,
		203,
		233,
		208,
		230,
		227,
		246,
		251,
		245,
		254,
		-1,
		310,
		306,
		302,
		309,
		258,
		-1,
		-1,
		298,
		-1,
		301,
		302,
		277,
		250,
		253,
		240,
		231,
		218,
		207,
		218,
		207,
		204,
		212,
		197,
		212,
		203,
		202,
		220,
		230,
		238,
		242,
		248,
		-1,
		360,
		-1,
		302,
		286,
		288,
		260,
		281,
		-1,
		318,
		302,
		294,
		279,
		279,
		-1,
		249,
		246,
		236,
		214,
		199,
		216,
		208,
		206,
		210,
		192,
		206,
		197,
		215,
		222,
		220,
		224,
		244,
		256,
		320,
		310,
		-1,
		292,
		297,
		256,
		264,
		283,
		321,
		285,
		-1,
		280,
		-1,
		251,
		264,
		-1,
		220,
		216,
		198,
		199,
		194,
		209,
		203,
		188,
		185,
		203,
		206,
		213,
		217,
		233,
		-1,
		-1,
		305,
		309,
		298,
		249,
		268,
		292,
		329,
		278,
		267,
		266,
		-1,
		257,
		234,
		231,
		219,
		206,
		191,
		192,
		200,
		213,
		192,
		187,
		184,
		204,
		230,
		208,
		220,
		-1,
		-1,
		-1,
		330,
		-1,
		-1,
		275,
		246,
		270,
		312,
		296,
		289,
		277,
		242,
		242,
		236,
		-1,
		230,
		209,
		200,
		189,
		187,
		200,
		197,
		202,
		182,
		180,
		199,
		211,
		202,
		219,
		-1,
		-1,
		-1,
		305,
		294,
		295,
		241,
		264,
		301,
		275,
		261,
		266,
		241,
		234,
		228,
		243,
		226,
		207,
		196,
		188,
		177,
		193,
		201,
		196,
		178,
		187,
		193,
		217,
		207,
		213,
		-1,
		-1,
		312,
		302,
		286,
		288,
		285,
		255,
		262,
		294,
		266,
		279,
		-1,
		233,
		-1,
		222,
		217,
		201,
		196,
		193,
		190,
		184,
		193,
		195,
		185,
		180,
		187,
		222,
		222,
		197,
		217,
		220,
		-1,
		-1,
		-1,
		305,
		300,
		275,
		252,
		236,
		272,
		-1,
		249,
		250,
		-1,
		227,
		221,
		218,
		203,
		199,
		194,
		198,
		191,
		198,
		191,
		189,
		190,
		172,
		204,
		-1,
		205,
		199,
		207,
		197,
		185,
		-1,
		-1,
		-1,
		298,
		277,
		270,
		290,
		231,
		283,
		-1,
		-1,
		234,
		227,
		-1,
		214,
		196,
		203,
		201,
		195,
		199,
		196,
		185,
		198,
		191,
		177,
		179,
		192,
		196,
		200,
		187,
		183,
		180,
		194,
		-1,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		251,
		-1,
		243,
		235,
		225,
		219,
		213,
		209,
		207,
		223,
		207,
		210,
		208,
		199,
		207,
		180,
		173,
		180,
		169,
		187,
		195,
		187,
		181,
		180,
		190,
		-1,
		318,
		304,
		275,
		-1,
		-1,
		264,
		-1,
		228,
		242,
		258,
		-1,
		251,
		230,
		245,
		223,
		219,
		215,
		230,
		231,
		208,
		208,
		206,
		197,
		185,
		174,
		177,
		169,
		191,
		191,
		175,
		176,
		180,
		-1,
		324,
		311,
		269,
		265,
		254,
		274,
		225,
		213,
		245,
		-1,
		-1,
		287,
		-1,
		221,
		238,
		229,
		227,
		220,
		202,
		209,
		217,
		194,
		189,
		179,
		168,
		168,
		163,
		185,
		171,
		169,
		178,
		194,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		240,
		227,
		221,
		-1,
		262,
		-1,
		265,
		255,
		239,
		224,
		257,
		-1,
		201,
		197,
		204,
		-1,
		214,
		-1,
		187,
		184,
		175,
		160,
		157,
		168,
		166,
		177,
		173,
		-1,
		274,
		259,
		252,
		242,
		256,
		227,
		-1,
		282,
		-1,
		-1,
		252,
		246,
		246,
		230,
		231,
		217,
		197,
		189,
		204,
		203,
		190,
		189,
		173,
		166,
		163,
		156,
		169,
		179,
		184,
		171,
		-1,
		-1,
		-1,
		279,
		265,
		269,
		229,
		248,
		-1,
		-1,
		314,
		269,
		255,
		-1,
		226,
		217,
		205,
		195,
		185,
		190,
		191,
		181,
		179,
		171,
		173,
		167,
		158,
		157,
		173,
		165,
		187,
		-1,
		-1,
		262,
		267,
		255,
		241,
		243,
		-1,
		-1,
		-1,
		261,
		277,
		245,
		224,
		206,
		-1,
		-1,
		189,
		182,
		176,
		179,
		167,
		187,
		182,
		166,
		151,
		166,
		170,
		178,
		169,
		-1,
		265,
		252,
		-1,
		-1,
		242,
		232,
		-1,
		-1,
		-1,
		-1,
		257,
		202,
		191,
		186,
		190,
		188,
		-1,
		162,
		173,
		166,
		185,
		192,
		168,
		153,
		147,
		153,
		165,
		174,
		-1,
		-1,
		256,
		-1,
		218,
		-1,
		-1,
		-1,
		-1,
		214,
		208,
		179,
		172,
		176,
		-1,
		164,
		166,
		163,
		175,
		171,
		168,
		159,
		150,
		146,
		150,
		154,
		168,
		172,
		279,
		-1,
		209,
		-1,
		-1,
		-1,
		232,
		247,
		218,
		195,
		168,
		163,
		156,
		150,
		155,
		166,
		175,
		186,
		151,
		153,
		143,
		142,
		146,
		163,
		167,
		-1,
		-1,
		207,
		203,
		238,
		240,
		244,
		245,
		-1,
		-1,
		172,
		163,
		154,
		146,
		159,
		162,
		147,
		149,
		149,
		147,
		141,
		151,
		166,
		161,
		-1,
		-1,
		-1,
		219,
		-1,
		221,
		-1,
		-1,
		240,
		243,
		190,
		172,
		168,
		166,
		155,
		149,
		137,
		142,
		152,
		146,
		143,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		241,
		-1,
		-1,
		-1,
		201,
		190,
		185,
		219,
		224,
		215,
		205,
		202,
		-1,
		172,
		178,
		143,
		150,
		133,
		140,
		145,
		142,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		234,
		223,
		212,
		218,
		-1,
		194,
		187,
		205,
		195,
		201,
		-1,
		-1,
		197,
		194,
		174,
		143,
		141,
		134,
		129,
		139,
		115,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		188,
		225,
		218,
		186,
		194,
		225,
		-1,
		184,
		176,
		184,
		187,
		194,
		-1,
		-1,
		170,
		161,
		162,
		150,
		147,
		153,
		152,
		135,
		141,
		142,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		181,
		201,
		180,
		183,
		207,
		221,
		-1,
		175,
		-1,
		-1,
		144,
		195,
		179,
		169,
		166,
		209,
		164,
		159,
		140,
		138,
		133,
		124,
		149,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		170,
		181,
		174,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		134,
		-1,
		206,
		-1,
		189,
		193,
		172,
		175,
		154,
		141,
		127,
		135,
		141,
		140,
		146,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		195,
		151,
		154,
		165,
		176,
		191,
		195,
		-1,
		159,
		195,
		140,
		-1,
		124,
		-1,
		-1,
		-1,
		203,
		185,
		177,
		174,
		153,
		153,
		119,
		123,
		136,
		143,
		153,
		164,
		156,
		160,
		173,
		184,
		187,
		191,
		182,
		195,
		140,
		140,
		161,
		170,
		191,
		155,
		152,
		189,
		147,
		136,
		131,
		118,
		-1,
		-1,
		187,
		195,
		-1,
		-1,
		160,
		127,
		115,
		125,
		129,
		143,
		155,
		168,
		156,
		161,
		155,
		187,
		-1,
		184,
		183,
		172,
		169,
		145,
		136,
		131,
		158,
		-1,
		-1,
		153,
		180,
		164,
		168,
		178,
		203,
		-1,
		102,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		132,
		121,
		112,
		117,
		137,
		148,
		170,
		152,
		169,
		160,
		170,
		174,
		168,
		165,
		153,
		151,
		174,
		139,
		127,
		-1,
		135,
		138,
		144,
		151,
		168,
		192,
		-1,
		-1,
		118,
		98,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		109,
		114,
		144,
		146,
		148,
		155,
		149,
		156,
		164,
		175,
		167,
		177,
		191,
		180,
		176,
		175,
		183,
		132,
		125,
		132,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		-1,
		108,
		104,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		131,
		131,
		134,
		139,
		147,
		158,
		154,
		158,
		161,
		-1,
		211,
		-1,
		163,
		124,
		130,
		145,
		153,
		-1,
		-1,
		-1,
		125,
		111,
		104,
		92,
		90,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		167,
		135,
		140,
		135,
		150,
		161,
		152,
		160,
		154,
		157,
		-1,
		-1,
		123,
		106,
		-1,
		-1,
		80,
		82,
		-1,
		116,
		105,
		90,
		82,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		101,
		139,
		138,
		146,
		141,
		146,
		158,
		154,
		150,
		160,
		151,
		-1,
		-1,
		101,
		93,
		87,
		-1,
		65,
		-1,
		118,
		-1,
		85,
		92,
		80,
		-1,
		-1,
		-1,
		132,
		95,
		111,
		134,
		160,
		158,
		149,
		142,
		149,
		152,
		145,
		151,
		-1,
		-1,
		-1,
		83,
		57,
		125,
		116,
		99,
		79,
		71,
		91,
		-1,
		113,
		-1,
		88,
		91,
		116,
		155,
		157,
		143,
		139,
		152,
		146,
		143,
		141,
		89,
		-1,
		59,
		92,
		56,
		85,
		51,
		63,
		127,
		-1,
		110,
		92,
		-1,
		120,
		110,
		158,
		133,
		142,
		135,
		129,
		130,
		138,
		-1,
		-1,
		-1,
		61,
		60,
		52,
		46,
		46,
		44,
		62,
		-1,
		115,
		97,
		83,
		100,
		100,
		91,
		99,
		148,
		144,
		147,
		145,
		123,
		-1,
		121,
		-1,
		-1,
		84,
		-1,
		-1,
		-1,
		55,
		45,
		58,
		64,
		76,
		85,
		80,
		82,
		95,
		103,
		101,
		98,
		110,
		106,
		126,
		122,
		154,
		-1,
		116,
		-1,
		91,
		-1,
		-1,
		13,
		27,
		39,
		50,
		72,
		72,
		77,
		75,
		97,
		127,
		113,
		111,
		116,
		121,
		-1,
		105,
		104,
		-1,
		29,
		21,
		0,
		-1,
		25,
		-1,
		118,
		79,
		-1,
		104,
		84,
		-1,
		122,
		118,
		-1,
		-1,
		92,
		45,
		-1,
		-1,
		-1,
		56,
		38,
		113,
		97,
		-1,
		95,
		95,
		-1,
		-1,
		-1,
		77,
		54,
		-1,
		49,
		52,
		-1,
		45,
		51,
		80,
		96,
		101,
		-1,
		-1,
		-1,
		86,
		66,
		71,
		64,
		69,
		57,
		76,
		62,
		64,
		81,
		93,
		121,
		-1,
		-1,
		-1,
		79,
		71,
		71,
		-1,
		-1,
		89,
		72,
		72,
		90,
		-1,
		-1,
		-1,
		101,
		82,
		-1,
		-1,
		80,
		-1,
		-1,
		85,
		91,
		-1,
		-1,
		-1,
		-1,
		-1,
		117,
		90,
		-1,
		-1,
		-1,
		81,
		88,
		96,
		-1,
		-1,
		-1,
		-1,
		111,
		112,
		136,
		111,
		-1,
		-1,
		-1,
		95,
		98,
		-1,
		-1,
		114,
		112,
		-1,
		-1,
		-1,
		123,
		107,
		-1,
		106,
		-1,
		-1,
		-1,
		114,
		-1,
		-1,
		139,
		-1,
		-1,
		-1,
		128,
		-1,
		141,
		116,
		123,
		-1,
		-1,
		-1,
		-1,
		141,
		133,
		154,
		-1,
		126,
		128,
		-1,
		176,
		-1,
		-1,
		156,
		147,
		-1,
		-1,
		131,
		138,
		160,
		163,
		186,
		-1,
		150
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		290,
		279,
		290,
		298,
		271,
		278,
		-1,
		297,
		301,
		267,
		261,
		300,
		269,
		275,
		286,
		-1,
		-1,
		-1,
		290,
		289,
		257,
		255,
		264,
		269,
		276,
		-1,
		275,
		-1,
		311,
		290,
		301,
		306,
		250,
		247,
		267,
		286,
		268,
		260,
		326,
		280,
		251,
		245,
		263,
		253,
		262,
		254,
		-1,
		251,
		241,
		263,
		242,
		253,
		245,
		-1,
		-1,
		245,
		246,
		252,
		238,
		244,
		240,
		-1,
		250,
		234,
		-1,
		-1,
		235,
		236,
		220,
		223,
		231,
		229,
		242,
		234,
		229,
		-1,
		-1,
		226,
		222,
		229,
		216,
		212,
		229,
		242,
		224,
		238,
		237,
		-1,
		230,
		248,
		255,
		223,
		221,
		205,
		203,
		221,
		223,
		229,
		229,
		-1,
		239,
		240,
		235,
		243,
		245,
		221,
		208,
		208,
		218,
		211,
		230,
		218,
		264,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		239,
		222,
		239,
		231,
		221,
		236,
		229,
		211,
		208,
		206,
		203,
		219,
		217,
		227,
		-1,
		-1,
		332,
		301,
		330,
		288,
		269,
		-1,
		235,
		215,
		221,
		225,
		219,
		212,
		226,
		222,
		-1,
		197,
		196,
		224,
		210,
		221,
		292,
		-1,
		-1,
		290,
		282,
		265,
		268,
		245,
		241,
		230,
		229,
		221,
		207,
		203,
		209,
		212,
		212,
		218,
		191,
		201,
		205,
		203,
		228,
		-1,
		-1,
		263,
		-1,
		-1,
		289,
		272,
		-1,
		255,
		262,
		251,
		257,
		243,
		264,
		240,
		231,
		223,
		217,
		205,
		207,
		204,
		217,
		205,
		188,
		213,
		217,
		198,
		219,
		214,
		-1,
		262,
		246,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		248,
		251,
		257,
		281,
		280,
		-1,
		252,
		240,
		241,
		226,
		223,
		210,
		198,
		211,
		196,
		203,
		202,
		192,
		190,
		220,
		195,
		217,
		214,
		233,
		238,
		232,
		241,
		-1,
		297,
		293,
		289,
		296,
		245,
		-1,
		-1,
		285,
		-1,
		288,
		289,
		264,
		237,
		240,
		227,
		218,
		205,
		194,
		205,
		194,
		191,
		199,
		184,
		199,
		190,
		189,
		207,
		217,
		225,
		229,
		235,
		-1,
		347,
		-1,
		289,
		273,
		275,
		247,
		268,
		-1,
		305,
		289,
		281,
		266,
		266,
		-1,
		236,
		233,
		223,
		201,
		186,
		203,
		195,
		193,
		197,
		179,
		193,
		184,
		202,
		209,
		207,
		211,
		231,
		243,
		307,
		297,
		-1,
		279,
		284,
		243,
		251,
		270,
		308,
		272,
		-1,
		267,
		-1,
		238,
		251,
		-1,
		207,
		203,
		185,
		186,
		181,
		196,
		190,
		175,
		172,
		190,
		193,
		200,
		204,
		220,
		-1,
		-1,
		292,
		296,
		285,
		236,
		255,
		279,
		316,
		265,
		254,
		253,
		-1,
		244,
		221,
		218,
		206,
		193,
		178,
		179,
		187,
		200,
		179,
		174,
		171,
		191,
		217,
		195,
		207,
		-1,
		-1,
		-1,
		317,
		-1,
		-1,
		262,
		233,
		257,
		299,
		283,
		276,
		264,
		229,
		229,
		223,
		-1,
		217,
		196,
		187,
		176,
		174,
		187,
		184,
		189,
		169,
		167,
		186,
		198,
		189,
		206,
		-1,
		-1,
		-1,
		292,
		281,
		282,
		228,
		251,
		288,
		262,
		248,
		253,
		228,
		221,
		215,
		230,
		213,
		194,
		183,
		175,
		164,
		180,
		188,
		183,
		165,
		174,
		180,
		204,
		194,
		200,
		-1,
		-1,
		299,
		289,
		273,
		275,
		272,
		242,
		249,
		281,
		253,
		266,
		-1,
		220,
		-1,
		209,
		204,
		188,
		183,
		180,
		177,
		171,
		180,
		182,
		172,
		167,
		174,
		209,
		209,
		184,
		204,
		207,
		-1,
		-1,
		-1,
		292,
		287,
		262,
		239,
		223,
		259,
		-1,
		236,
		237,
		-1,
		214,
		208,
		205,
		190,
		186,
		181,
		185,
		178,
		185,
		178,
		176,
		177,
		159,
		191,
		-1,
		192,
		186,
		194,
		184,
		172,
		-1,
		-1,
		-1,
		285,
		264,
		257,
		277,
		218,
		270,
		-1,
		-1,
		221,
		214,
		-1,
		201,
		183,
		190,
		188,
		182,
		186,
		183,
		172,
		185,
		178,
		164,
		166,
		179,
		183,
		187,
		174,
		170,
		167,
		181,
		-1,
		304,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		238,
		-1,
		230,
		222,
		212,
		206,
		200,
		196,
		194,
		210,
		194,
		197,
		195,
		186,
		194,
		167,
		160,
		167,
		156,
		174,
		182,
		174,
		168,
		167,
		177,
		-1,
		305,
		291,
		262,
		-1,
		-1,
		251,
		-1,
		215,
		229,
		245,
		-1,
		238,
		217,
		232,
		210,
		206,
		202,
		217,
		218,
		195,
		195,
		193,
		184,
		172,
		161,
		164,
		156,
		178,
		178,
		162,
		163,
		167,
		-1,
		311,
		298,
		256,
		252,
		241,
		261,
		212,
		200,
		232,
		-1,
		-1,
		274,
		-1,
		208,
		225,
		216,
		214,
		207,
		189,
		196,
		204,
		181,
		176,
		166,
		155,
		155,
		150,
		172,
		158,
		156,
		165,
		181,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		227,
		214,
		208,
		-1,
		249,
		-1,
		252,
		242,
		226,
		211,
		244,
		-1,
		188,
		184,
		191,
		-1,
		201,
		-1,
		174,
		171,
		162,
		147,
		144,
		155,
		153,
		164,
		160,
		-1,
		261,
		246,
		239,
		229,
		243,
		214,
		-1,
		269,
		-1,
		-1,
		239,
		233,
		233,
		217,
		218,
		204,
		184,
		176,
		191,
		190,
		177,
		176,
		160,
		153,
		150,
		143,
		156,
		166,
		171,
		158,
		-1,
		-1,
		-1,
		266,
		252,
		256,
		216,
		235,
		-1,
		-1,
		301,
		256,
		242,
		-1,
		213,
		204,
		192,
		182,
		172,
		177,
		178,
		168,
		166,
		158,
		160,
		154,
		145,
		144,
		160,
		152,
		174,
		-1,
		-1,
		249,
		254,
		242,
		228,
		230,
		-1,
		-1,
		-1,
		248,
		264,
		232,
		211,
		193,
		-1,
		-1,
		176,
		169,
		163,
		166,
		154,
		174,
		169,
		153,
		138,
		153,
		157,
		165,
		156,
		-1,
		252,
		239,
		-1,
		-1,
		229,
		219,
		-1,
		-1,
		-1,
		-1,
		244,
		189,
		178,
		173,
		177,
		175,
		-1,
		149,
		160,
		153,
		172,
		179,
		155,
		140,
		134,
		140,
		152,
		161,
		-1,
		-1,
		243,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		201,
		195,
		166,
		159,
		163,
		-1,
		151,
		153,
		150,
		162,
		158,
		155,
		146,
		137,
		133,
		137,
		141,
		155,
		159,
		266,
		-1,
		196,
		-1,
		-1,
		-1,
		219,
		234,
		205,
		182,
		155,
		150,
		143,
		137,
		142,
		153,
		162,
		173,
		138,
		140,
		130,
		129,
		133,
		150,
		154,
		-1,
		-1,
		194,
		190,
		225,
		227,
		231,
		232,
		-1,
		-1,
		159,
		150,
		141,
		133,
		146,
		149,
		134,
		136,
		136,
		134,
		128,
		138,
		153,
		148,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		227,
		230,
		177,
		159,
		155,
		153,
		142,
		136,
		124,
		129,
		139,
		133,
		130,
		124,
		128,
		151,
		140,
		179,
		-1,
		-1,
		228,
		-1,
		-1,
		-1,
		188,
		177,
		172,
		206,
		211,
		202,
		192,
		189,
		-1,
		159,
		165,
		130,
		137,
		120,
		127,
		132,
		129,
		118,
		125,
		141,
		140,
		135,
		171,
		162,
		168,
		-1,
		-1,
		221,
		210,
		199,
		205,
		-1,
		181,
		174,
		192,
		182,
		188,
		-1,
		-1,
		184,
		181,
		161,
		130,
		128,
		121,
		116,
		126,
		102,
		114,
		118,
		122,
		128,
		133,
		138,
		144,
		159,
		174,
		-1,
		175,
		212,
		205,
		173,
		181,
		212,
		-1,
		171,
		163,
		171,
		174,
		181,
		-1,
		-1,
		157,
		148,
		149,
		137,
		134,
		140,
		139,
		122,
		128,
		129,
		121,
		120,
		138,
		142,
		151,
		158,
		148,
		161,
		165,
		-1,
		168,
		188,
		167,
		170,
		194,
		208,
		-1,
		162,
		-1,
		-1,
		131,
		182,
		166,
		156,
		153,
		196,
		151,
		146,
		127,
		125,
		120,
		111,
		136,
		129,
		129,
		132,
		147,
		152,
		144,
		158,
		158,
		159,
		-1,
		157,
		168,
		161,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		-1,
		121,
		-1,
		193,
		-1,
		176,
		180,
		159,
		162,
		141,
		128,
		114,
		122,
		128,
		127,
		133,
		133,
		134,
		143,
		154,
		166,
		165,
		166,
		182,
		138,
		141,
		152,
		163,
		178,
		182,
		-1,
		146,
		182,
		127,
		-1,
		111,
		-1,
		-1,
		-1,
		190,
		172,
		164,
		161,
		140,
		140,
		106,
		110,
		123,
		130,
		140,
		151,
		143,
		147,
		160,
		171,
		174,
		178,
		169,
		182,
		127,
		127,
		148,
		157,
		178,
		142,
		139,
		176,
		134,
		123,
		118,
		105,
		-1,
		-1,
		174,
		182,
		-1,
		-1,
		147,
		114,
		102,
		112,
		116,
		130,
		142,
		155,
		143,
		148,
		142,
		174,
		-1,
		171,
		170,
		159,
		156,
		132,
		123,
		118,
		145,
		-1,
		-1,
		140,
		167,
		151,
		155,
		165,
		190,
		-1,
		89,
		-1,
		-1,
		154,
		-1,
		-1,
		139,
		119,
		108,
		99,
		104,
		124,
		135,
		157,
		139,
		156,
		147,
		157,
		161,
		155,
		152,
		140,
		138,
		161,
		126,
		114,
		-1,
		122,
		125,
		131,
		138,
		155,
		179,
		-1,
		-1,
		105,
		85,
		-1,
		-1,
		137,
		135,
		124,
		-1,
		114,
		96,
		101,
		131,
		133,
		135,
		142,
		136,
		143,
		151,
		162,
		154,
		164,
		178,
		167,
		163,
		162,
		170,
		119,
		112,
		119,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		-1,
		95,
		91,
		-1,
		-1,
		132,
		125,
		113,
		101,
		91,
		101,
		118,
		118,
		121,
		126,
		134,
		145,
		141,
		145,
		148,
		-1,
		198,
		-1,
		150,
		111,
		117,
		132,
		140,
		-1,
		-1,
		-1,
		112,
		98,
		91,
		79,
		77,
		-1,
		166,
		150,
		131,
		-1,
		101,
		114,
		154,
		122,
		127,
		122,
		137,
		148,
		139,
		147,
		141,
		144,
		-1,
		-1,
		110,
		93,
		-1,
		-1,
		67,
		69,
		-1,
		103,
		92,
		77,
		69,
		-1,
		-1,
		138,
		134,
		-1,
		-1,
		88,
		126,
		125,
		133,
		128,
		133,
		145,
		141,
		137,
		147,
		138,
		-1,
		-1,
		88,
		80,
		74,
		-1,
		52,
		-1,
		105,
		-1,
		72,
		79,
		67,
		-1,
		-1,
		-1,
		119,
		82,
		98,
		121,
		147,
		145,
		136,
		129,
		136,
		139,
		132,
		138,
		-1,
		-1,
		-1,
		70,
		44,
		112,
		103,
		86,
		66,
		58,
		78,
		-1,
		100,
		-1,
		75,
		78,
		103,
		142,
		144,
		130,
		126,
		139,
		133,
		130,
		128,
		76,
		-1,
		46,
		79,
		43,
		72,
		38,
		50,
		114,
		-1,
		97,
		79,
		-1,
		107,
		97,
		145,
		120,
		129,
		122,
		116,
		117,
		125,
		-1,
		-1,
		-1,
		48,
		47,
		39,
		33,
		33,
		31,
		49,
		-1,
		102,
		84,
		70,
		87,
		87,
		78,
		86,
		135,
		131,
		134,
		132,
		110,
		-1,
		118,
		-1,
		-1,
		71,
		-1,
		-1,
		-1,
		42,
		30,
		43,
		51,
		63,
		72,
		67,
		69,
		82,
		90,
		88,
		85,
		97,
		93,
		113,
		109,
		141,
		-1,
		113,
		-1,
		78,
		-1,
		-1,
		22,
		14,
		24,
		35,
		59,
		59,
		64,
		62,
		84,
		114,
		100,
		98,
		103,
		108,
		-1,
		102,
		101,
		-1,
		41,
		33,
		19,
		-1,
		0,
		-1,
		105,
		66,
		-1,
		91,
		71,
		-1,
		109,
		105,
		-1,
		-1,
		89,
		57,
		-1,
		-1,
		-1,
		32,
		13,
		100,
		84,
		-1,
		77,
		82,
		-1,
		-1,
		-1,
		74,
		66,
		-1,
		25,
		28,
		-1,
		20,
		26,
		55,
		72,
		78,
		-1,
		-1,
		-1,
		83,
		64,
		58,
		40,
		45,
		33,
		51,
		37,
		40,
		57,
		69,
		98,
		-1,
		-1,
		-1,
		55,
		47,
		47,
		-1,
		-1,
		65,
		48,
		48,
		66,
		-1,
		-1,
		-1,
		77,
		58,
		-1,
		-1,
		56,
		-1,
		-1,
		61,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		93,
		66,
		-1,
		-1,
		-1,
		57,
		64,
		72,
		-1,
		-1,
		-1,
		-1,
		87,
		88,
		112,
		87,
		-1,
		-1,
		-1,
		71,
		74,
		-1,
		-1,
		90,
		88,
		-1,
		-1,
		-1,
		99,
		83,
		-1,
		82,
		-1,
		-1,
		-1,
		90,
		-1,
		-1,
		115,
		-1,
		-1,
		-1,
		104,
		-1,
		117,
		92,
		99,
		-1,
		-1,
		-1,
		-1,
		117,
		109,
		130,
		-1,
		102,
		104,
		-1,
		152,
		-1,
		-1,
		132,
		123,
		-1,
		-1,
		107,
		114,
		136,
		139,
		162,
		-1,
		126
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		296,
		285,
		296,
		304,
		277,
		284,
		-1,
		303,
		307,
		273,
		267,
		306,
		275,
		281,
		292,
		-1,
		-1,
		-1,
		296,
		295,
		263,
		261,
		270,
		275,
		282,
		-1,
		281,
		-1,
		317,
		296,
		307,
		312,
		256,
		253,
		273,
		292,
		274,
		266,
		332,
		286,
		257,
		251,
		269,
		259,
		268,
		260,
		-1,
		257,
		247,
		269,
		248,
		259,
		251,
		-1,
		-1,
		251,
		252,
		258,
		244,
		250,
		246,
		-1,
		256,
		240,
		-1,
		-1,
		241,
		242,
		226,
		229,
		237,
		235,
		248,
		240,
		235,
		-1,
		-1,
		232,
		228,
		235,
		222,
		218,
		235,
		248,
		230,
		244,
		243,
		-1,
		236,
		254,
		261,
		229,
		227,
		211,
		209,
		227,
		229,
		235,
		235,
		-1,
		245,
		246,
		241,
		249,
		251,
		227,
		214,
		214,
		224,
		217,
		236,
		224,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		245,
		228,
		245,
		237,
		227,
		242,
		235,
		217,
		214,
		212,
		209,
		225,
		223,
		233,
		-1,
		-1,
		338,
		307,
		336,
		294,
		275,
		-1,
		241,
		221,
		227,
		231,
		225,
		218,
		232,
		228,
		-1,
		203,
		202,
		230,
		216,
		227,
		298,
		-1,
		-1,
		296,
		288,
		271,
		274,
		251,
		247,
		236,
		235,
		227,
		213,
		209,
		215,
		218,
		218,
		224,
		197,
		207,
		211,
		209,
		234,
		-1,
		-1,
		269,
		-1,
		-1,
		295,
		278,
		-1,
		261,
		268,
		257,
		263,
		249,
		270,
		246,
		237,
		229,
		223,
		211,
		213,
		210,
		223,
		211,
		194,
		219,
		223,
		204,
		225,
		220,
		-1,
		268,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		254,
		257,
		263,
		287,
		286,
		-1,
		258,
		246,
		247,
		232,
		229,
		216,
		204,
		217,
		202,
		209,
		208,
		198,
		196,
		226,
		201,
		223,
		220,
		239,
		244,
		238,
		247,
		-1,
		303,
		299,
		295,
		302,
		251,
		-1,
		-1,
		291,
		-1,
		294,
		295,
		270,
		243,
		246,
		233,
		224,
		211,
		200,
		211,
		200,
		197,
		205,
		190,
		205,
		196,
		195,
		213,
		223,
		231,
		235,
		241,
		-1,
		353,
		-1,
		295,
		279,
		281,
		253,
		274,
		-1,
		311,
		295,
		287,
		272,
		272,
		-1,
		242,
		239,
		229,
		207,
		192,
		209,
		201,
		199,
		203,
		185,
		199,
		190,
		208,
		215,
		213,
		217,
		237,
		249,
		313,
		303,
		-1,
		285,
		290,
		249,
		257,
		276,
		314,
		278,
		-1,
		273,
		-1,
		244,
		257,
		-1,
		213,
		209,
		191,
		192,
		187,
		202,
		196,
		181,
		178,
		196,
		199,
		206,
		210,
		226,
		-1,
		-1,
		298,
		302,
		291,
		242,
		261,
		285,
		322,
		271,
		260,
		259,
		-1,
		250,
		227,
		224,
		212,
		199,
		184,
		185,
		193,
		206,
		185,
		180,
		177,
		197,
		223,
		201,
		213,
		-1,
		-1,
		-1,
		323,
		-1,
		-1,
		268,
		239,
		263,
		305,
		289,
		282,
		270,
		235,
		235,
		229,
		-1,
		223,
		202,
		193,
		182,
		180,
		193,
		190,
		195,
		175,
		173,
		192,
		204,
		195,
		212,
		-1,
		-1,
		-1,
		298,
		287,
		288,
		234,
		257,
		294,
		268,
		254,
		259,
		234,
		227,
		221,
		236,
		219,
		200,
		189,
		181,
		170,
		186,
		194,
		189,
		171,
		180,
		186,
		210,
		200,
		206,
		-1,
		-1,
		305,
		295,
		279,
		281,
		278,
		248,
		255,
		287,
		259,
		272,
		-1,
		226,
		-1,
		215,
		210,
		194,
		189,
		186,
		183,
		177,
		186,
		188,
		178,
		173,
		180,
		215,
		215,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		298,
		293,
		268,
		245,
		229,
		265,
		-1,
		242,
		243,
		-1,
		220,
		214,
		211,
		196,
		192,
		187,
		191,
		184,
		191,
		184,
		182,
		183,
		165,
		197,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		291,
		270,
		263,
		283,
		224,
		276,
		-1,
		-1,
		227,
		220,
		-1,
		207,
		189,
		196,
		194,
		188,
		192,
		189,
		178,
		191,
		184,
		170,
		172,
		185,
		189,
		193,
		180,
		176,
		173,
		187,
		-1,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		244,
		-1,
		236,
		228,
		218,
		212,
		206,
		202,
		200,
		216,
		200,
		203,
		201,
		192,
		200,
		173,
		166,
		173,
		162,
		180,
		188,
		180,
		174,
		173,
		183,
		-1,
		311,
		297,
		268,
		-1,
		-1,
		257,
		-1,
		221,
		235,
		251,
		-1,
		244,
		223,
		238,
		216,
		212,
		208,
		223,
		224,
		201,
		201,
		199,
		190,
		178,
		167,
		170,
		162,
		184,
		184,
		168,
		169,
		173,
		-1,
		317,
		304,
		262,
		258,
		247,
		267,
		218,
		206,
		238,
		-1,
		-1,
		280,
		-1,
		214,
		231,
		222,
		220,
		213,
		195,
		202,
		210,
		187,
		182,
		172,
		161,
		161,
		156,
		178,
		164,
		162,
		171,
		187,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		233,
		220,
		214,
		-1,
		255,
		-1,
		258,
		248,
		232,
		217,
		250,
		-1,
		194,
		190,
		197,
		-1,
		207,
		-1,
		180,
		177,
		168,
		153,
		150,
		161,
		159,
		170,
		166,
		-1,
		267,
		252,
		245,
		235,
		249,
		220,
		-1,
		275,
		-1,
		-1,
		245,
		239,
		239,
		223,
		224,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		166,
		159,
		156,
		149,
		162,
		172,
		177,
		164,
		-1,
		-1,
		-1,
		272,
		258,
		262,
		222,
		241,
		-1,
		-1,
		307,
		262,
		248,
		-1,
		219,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		164,
		166,
		160,
		151,
		150,
		166,
		158,
		180,
		-1,
		-1,
		255,
		260,
		248,
		234,
		249,
		-1,
		-1,
		-1,
		254,
		270,
		238,
		217,
		199,
		-1,
		-1,
		182,
		175,
		169,
		172,
		160,
		180,
		175,
		159,
		144,
		159,
		163,
		171,
		162,
		-1,
		258,
		245,
		-1,
		-1,
		248,
		238,
		-1,
		-1,
		-1,
		-1,
		250,
		195,
		184,
		179,
		183,
		181,
		-1,
		155,
		166,
		159,
		178,
		185,
		161,
		146,
		140,
		146,
		158,
		167,
		-1,
		-1,
		262,
		-1,
		224,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		172,
		165,
		169,
		-1,
		157,
		159,
		156,
		168,
		164,
		161,
		152,
		143,
		139,
		143,
		147,
		161,
		165,
		285,
		-1,
		215,
		-1,
		-1,
		-1,
		225,
		240,
		211,
		188,
		161,
		156,
		149,
		143,
		148,
		159,
		168,
		179,
		144,
		146,
		136,
		135,
		139,
		156,
		160,
		-1,
		-1,
		213,
		209,
		244,
		233,
		237,
		238,
		-1,
		-1,
		165,
		156,
		147,
		139,
		152,
		155,
		140,
		142,
		142,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		225,
		-1,
		227,
		-1,
		-1,
		235,
		236,
		183,
		165,
		161,
		159,
		148,
		142,
		130,
		135,
		145,
		139,
		136,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		224,
		196,
		191,
		217,
		219,
		210,
		198,
		195,
		-1,
		165,
		171,
		136,
		143,
		126,
		133,
		138,
		135,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		217,
		193,
		203,
		193,
		196,
		-1,
		-1,
		190,
		187,
		167,
		136,
		134,
		127,
		122,
		132,
		108,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		228,
		265,
		258,
		226,
		234,
		265,
		-1,
		207,
		199,
		190,
		185,
		187,
		-1,
		-1,
		163,
		154,
		155,
		143,
		140,
		146,
		145,
		128,
		134,
		135,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		221,
		241,
		220,
		223,
		247,
		261,
		-1,
		204,
		-1,
		-1,
		150,
		188,
		172,
		162,
		159,
		202,
		157,
		152,
		133,
		131,
		126,
		117,
		142,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		210,
		221,
		214,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		140,
		-1,
		199,
		-1,
		182,
		186,
		165,
		168,
		147,
		134,
		120,
		128,
		134,
		133,
		139,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		235,
		191,
		194,
		205,
		216,
		231,
		235,
		-1,
		199,
		235,
		146,
		-1,
		130,
		-1,
		-1,
		-1,
		196,
		178,
		170,
		167,
		146,
		146,
		112,
		116,
		129,
		136,
		146,
		157,
		149,
		153,
		166,
		177,
		180,
		231,
		222,
		235,
		180,
		180,
		201,
		210,
		231,
		195,
		192,
		229,
		153,
		142,
		137,
		124,
		-1,
		-1,
		180,
		188,
		-1,
		-1,
		153,
		120,
		108,
		118,
		122,
		136,
		148,
		161,
		149,
		154,
		148,
		180,
		-1,
		224,
		223,
		212,
		209,
		185,
		176,
		171,
		198,
		-1,
		-1,
		193,
		220,
		204,
		186,
		184,
		209,
		-1,
		113,
		-1,
		-1,
		160,
		-1,
		-1,
		145,
		125,
		114,
		105,
		110,
		130,
		141,
		163,
		145,
		162,
		153,
		163,
		167,
		208,
		205,
		193,
		191,
		214,
		179,
		167,
		-1,
		175,
		178,
		184,
		191,
		187,
		198,
		-1,
		-1,
		129,
		109,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		102,
		107,
		137,
		139,
		141,
		148,
		142,
		149,
		157,
		168,
		160,
		217,
		231,
		220,
		216,
		215,
		223,
		172,
		165,
		172,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		-1,
		119,
		115,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		124,
		124,
		127,
		132,
		140,
		151,
		147,
		151,
		154,
		-1,
		251,
		-1,
		203,
		164,
		170,
		185,
		193,
		-1,
		-1,
		-1,
		136,
		122,
		115,
		103,
		101,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		160,
		128,
		133,
		128,
		143,
		154,
		145,
		153,
		147,
		150,
		-1,
		-1,
		163,
		146,
		-1,
		-1,
		120,
		122,
		-1,
		127,
		116,
		101,
		93,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		94,
		132,
		131,
		139,
		134,
		139,
		151,
		147,
		143,
		153,
		144,
		-1,
		-1,
		141,
		133,
		127,
		-1,
		105,
		-1,
		129,
		-1,
		96,
		94,
		82,
		-1,
		-1,
		-1,
		125,
		88,
		104,
		127,
		153,
		151,
		142,
		135,
		142,
		145,
		138,
		144,
		-1,
		-1,
		-1,
		123,
		97,
		136,
		127,
		110,
		90,
		82,
		93,
		-1,
		106,
		-1,
		81,
		84,
		109,
		148,
		150,
		136,
		132,
		145,
		139,
		136,
		134,
		129,
		-1,
		99,
		132,
		96,
		96,
		72,
		70,
		120,
		-1,
		103,
		85,
		-1,
		113,
		103,
		151,
		126,
		135,
		128,
		122,
		123,
		131,
		-1,
		-1,
		-1,
		101,
		100,
		92,
		86,
		86,
		77,
		60,
		-1,
		108,
		90,
		76,
		93,
		93,
		84,
		92,
		141,
		137,
		140,
		138,
		116,
		-1,
		217,
		-1,
		-1,
		124,
		-1,
		-1,
		-1,
		95,
		88,
		61,
		57,
		65,
		78,
		73,
		75,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		115,
		147,
		-1,
		212,
		-1,
		131,
		-1,
		-1,
		113,
		93,
		83,
		72,
		58,
		61,
		66,
		68,
		90,
		120,
		106,
		104,
		109,
		114,
		-1,
		201,
		200,
		-1,
		132,
		124,
		110,
		-1,
		103,
		-1,
		0,
		38,
		-1,
		97,
		77,
		-1,
		115,
		111,
		-1,
		-1,
		188,
		148,
		-1,
		-1,
		-1,
		133,
		113,
		5,
		19,
		-1,
		88,
		88,
		-1,
		-1,
		-1,
		173,
		157,
		-1,
		126,
		129,
		-1,
		120,
		126,
		143,
		90,
		94,
		-1,
		-1,
		-1,
		182,
		163,
		157,
		141,
		146,
		134,
		151,
		137,
		126,
		104,
		93,
		114,
		-1,
		-1,
		-1,
		154,
		146,
		146,
		-1,
		-1,
		151,
		134,
		115,
		113,
		-1,
		-1,
		-1,
		176,
		157,
		-1,
		-1,
		141,
		-1,
		-1,
		147,
		112,
		-1,
		-1,
		-1,
		-1,
		-1,
		192,
		165,
		-1,
		-1,
		-1,
		137,
		133,
		134,
		-1,
		-1,
		-1,
		-1,
		186,
		187,
		211,
		185,
		-1,
		-1,
		-1,
		129,
		123,
		-1,
		-1,
		189,
		187,
		-1,
		-1,
		-1,
		157,
		141,
		-1,
		127,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		162,
		-1,
		162,
		137,
		144,
		-1,
		-1,
		-1,
		-1,
		175,
		167,
		175,
		-1,
		147,
		149,
		-1,
		197,
		-1,
		-1,
		190,
		181,
		-1,
		-1,
		152,
		159,
		181,
		184,
		220,
		-1,
		171
	],
	[
		-1,
		258,
		247,
		258,
		266,
		239,
		246,
		-1,
		265,
		269,
		235,
		229,
		268,
		237,
		243,
		254,
		-1,
		-1,
		-1,
		258,
		257,
		225,
		223,
		232,
		237,
		244,
		-1,
		243,
		-1,
		279,
		258,
		269,
		274,
		218,
		215,
		235,
		254,
		236,
		228,
		294,
		248,
		219,
		213,
		231,
		221,
		230,
		222,
		-1,
		219,
		209,
		231,
		210,
		221,
		213,
		-1,
		-1,
		213,
		214,
		220,
		206,
		212,
		208,
		-1,
		218,
		202,
		-1,
		-1,
		203,
		204,
		188,
		191,
		199,
		197,
		210,
		202,
		197,
		-1,
		-1,
		194,
		190,
		197,
		184,
		180,
		197,
		210,
		192,
		206,
		205,
		-1,
		198,
		216,
		223,
		191,
		189,
		173,
		171,
		189,
		191,
		197,
		197,
		-1,
		207,
		208,
		203,
		211,
		213,
		189,
		176,
		176,
		186,
		179,
		198,
		186,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		207,
		190,
		207,
		199,
		189,
		204,
		197,
		179,
		176,
		174,
		171,
		187,
		185,
		195,
		-1,
		-1,
		300,
		269,
		298,
		256,
		237,
		-1,
		203,
		183,
		189,
		193,
		187,
		180,
		194,
		190,
		-1,
		165,
		164,
		192,
		178,
		189,
		260,
		-1,
		-1,
		258,
		250,
		233,
		236,
		213,
		209,
		198,
		197,
		189,
		175,
		171,
		177,
		180,
		180,
		186,
		159,
		169,
		173,
		171,
		196,
		-1,
		-1,
		231,
		-1,
		-1,
		257,
		240,
		-1,
		223,
		230,
		219,
		225,
		211,
		232,
		208,
		199,
		191,
		185,
		173,
		175,
		172,
		185,
		173,
		156,
		181,
		185,
		166,
		187,
		182,
		-1,
		230,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		216,
		219,
		225,
		249,
		248,
		-1,
		220,
		208,
		209,
		194,
		191,
		178,
		166,
		179,
		164,
		171,
		170,
		160,
		158,
		188,
		163,
		185,
		182,
		201,
		206,
		200,
		209,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		253,
		-1,
		256,
		257,
		232,
		205,
		208,
		195,
		186,
		173,
		162,
		173,
		162,
		159,
		167,
		152,
		167,
		158,
		157,
		175,
		185,
		193,
		197,
		203,
		-1,
		315,
		-1,
		257,
		241,
		243,
		215,
		236,
		-1,
		273,
		257,
		249,
		234,
		234,
		-1,
		204,
		201,
		191,
		169,
		154,
		171,
		163,
		161,
		165,
		147,
		161,
		152,
		170,
		177,
		175,
		179,
		199,
		211,
		275,
		265,
		-1,
		247,
		252,
		211,
		219,
		238,
		276,
		240,
		-1,
		235,
		-1,
		206,
		219,
		-1,
		175,
		171,
		153,
		154,
		149,
		164,
		158,
		143,
		140,
		158,
		161,
		168,
		172,
		188,
		-1,
		-1,
		260,
		264,
		253,
		204,
		223,
		247,
		284,
		233,
		222,
		221,
		-1,
		212,
		189,
		186,
		174,
		161,
		146,
		147,
		155,
		168,
		147,
		142,
		139,
		159,
		185,
		163,
		175,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		230,
		201,
		225,
		267,
		251,
		244,
		232,
		197,
		197,
		191,
		-1,
		185,
		164,
		155,
		144,
		142,
		155,
		152,
		157,
		137,
		135,
		154,
		166,
		157,
		174,
		-1,
		-1,
		-1,
		260,
		249,
		250,
		196,
		219,
		256,
		230,
		216,
		221,
		196,
		189,
		183,
		198,
		181,
		162,
		151,
		143,
		132,
		148,
		156,
		151,
		133,
		142,
		148,
		172,
		162,
		168,
		-1,
		-1,
		267,
		257,
		241,
		243,
		240,
		210,
		217,
		249,
		221,
		234,
		-1,
		188,
		-1,
		177,
		172,
		156,
		151,
		148,
		145,
		139,
		148,
		150,
		140,
		135,
		142,
		177,
		177,
		152,
		172,
		175,
		-1,
		-1,
		-1,
		260,
		255,
		230,
		207,
		191,
		227,
		-1,
		204,
		205,
		-1,
		182,
		176,
		173,
		158,
		154,
		149,
		153,
		146,
		153,
		146,
		144,
		145,
		127,
		159,
		-1,
		160,
		154,
		162,
		152,
		140,
		-1,
		-1,
		-1,
		253,
		232,
		225,
		245,
		186,
		238,
		-1,
		-1,
		189,
		182,
		-1,
		169,
		151,
		158,
		156,
		150,
		154,
		151,
		140,
		153,
		146,
		132,
		134,
		147,
		151,
		155,
		142,
		138,
		135,
		149,
		-1,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		206,
		-1,
		198,
		190,
		180,
		174,
		168,
		164,
		162,
		178,
		162,
		165,
		163,
		154,
		162,
		135,
		128,
		135,
		124,
		142,
		150,
		142,
		136,
		135,
		145,
		-1,
		273,
		259,
		230,
		-1,
		-1,
		219,
		-1,
		183,
		197,
		213,
		-1,
		206,
		185,
		200,
		178,
		174,
		170,
		185,
		186,
		163,
		163,
		161,
		152,
		140,
		129,
		132,
		124,
		146,
		146,
		130,
		131,
		135,
		-1,
		279,
		266,
		224,
		220,
		209,
		229,
		180,
		168,
		200,
		-1,
		-1,
		242,
		-1,
		176,
		193,
		184,
		182,
		175,
		157,
		164,
		172,
		149,
		144,
		134,
		123,
		123,
		118,
		140,
		126,
		124,
		133,
		149,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		195,
		182,
		176,
		-1,
		217,
		-1,
		220,
		210,
		194,
		179,
		212,
		-1,
		156,
		152,
		159,
		-1,
		169,
		-1,
		142,
		139,
		130,
		115,
		112,
		123,
		121,
		132,
		128,
		-1,
		229,
		214,
		207,
		197,
		211,
		182,
		-1,
		237,
		-1,
		-1,
		207,
		201,
		201,
		185,
		186,
		172,
		152,
		144,
		159,
		158,
		145,
		144,
		128,
		121,
		118,
		111,
		124,
		134,
		139,
		126,
		-1,
		-1,
		-1,
		234,
		220,
		224,
		184,
		203,
		-1,
		-1,
		269,
		224,
		210,
		-1,
		181,
		172,
		160,
		150,
		140,
		145,
		146,
		136,
		134,
		126,
		128,
		122,
		113,
		112,
		128,
		120,
		142,
		-1,
		-1,
		217,
		222,
		210,
		196,
		211,
		-1,
		-1,
		-1,
		216,
		232,
		200,
		179,
		161,
		-1,
		-1,
		144,
		137,
		131,
		134,
		122,
		142,
		137,
		121,
		106,
		121,
		125,
		133,
		124,
		-1,
		220,
		207,
		-1,
		-1,
		210,
		200,
		-1,
		-1,
		-1,
		-1,
		212,
		157,
		146,
		141,
		145,
		143,
		-1,
		117,
		128,
		121,
		140,
		147,
		123,
		108,
		102,
		108,
		120,
		129,
		-1,
		-1,
		224,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		169,
		163,
		134,
		127,
		131,
		-1,
		119,
		121,
		118,
		130,
		126,
		123,
		114,
		105,
		101,
		105,
		109,
		123,
		127,
		247,
		-1,
		177,
		-1,
		-1,
		-1,
		187,
		202,
		173,
		150,
		123,
		118,
		111,
		105,
		110,
		121,
		130,
		141,
		106,
		108,
		98,
		97,
		101,
		118,
		122,
		-1,
		-1,
		175,
		171,
		206,
		195,
		199,
		200,
		-1,
		-1,
		127,
		118,
		109,
		101,
		114,
		117,
		102,
		104,
		104,
		102,
		96,
		106,
		121,
		116,
		-1,
		-1,
		-1,
		187,
		-1,
		189,
		-1,
		-1,
		197,
		198,
		145,
		127,
		123,
		121,
		110,
		104,
		92,
		97,
		107,
		101,
		98,
		92,
		96,
		119,
		108,
		147,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		186,
		158,
		153,
		179,
		181,
		172,
		160,
		157,
		-1,
		127,
		133,
		98,
		105,
		88,
		95,
		100,
		97,
		86,
		93,
		109,
		108,
		103,
		139,
		130,
		136,
		-1,
		-1,
		236,
		225,
		214,
		220,
		-1,
		179,
		155,
		165,
		155,
		158,
		-1,
		-1,
		152,
		149,
		129,
		98,
		96,
		89,
		84,
		94,
		70,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		190,
		227,
		220,
		188,
		196,
		227,
		-1,
		169,
		161,
		152,
		147,
		149,
		-1,
		-1,
		125,
		116,
		117,
		105,
		102,
		108,
		107,
		90,
		96,
		97,
		89,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		183,
		203,
		182,
		185,
		209,
		223,
		-1,
		166,
		-1,
		-1,
		112,
		150,
		134,
		124,
		121,
		164,
		119,
		114,
		95,
		93,
		88,
		79,
		104,
		97,
		97,
		100,
		115,
		120,
		112,
		126,
		126,
		127,
		-1,
		172,
		183,
		176,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		102,
		-1,
		161,
		-1,
		144,
		148,
		127,
		130,
		109,
		96,
		82,
		90,
		96,
		95,
		101,
		101,
		102,
		111,
		122,
		134,
		133,
		134,
		197,
		153,
		156,
		167,
		178,
		193,
		197,
		-1,
		161,
		197,
		108,
		-1,
		92,
		-1,
		-1,
		-1,
		158,
		140,
		132,
		129,
		108,
		108,
		74,
		78,
		91,
		98,
		108,
		119,
		111,
		115,
		128,
		139,
		142,
		193,
		184,
		197,
		142,
		142,
		163,
		172,
		193,
		157,
		154,
		191,
		115,
		104,
		99,
		86,
		-1,
		-1,
		142,
		150,
		-1,
		-1,
		115,
		82,
		70,
		80,
		84,
		98,
		110,
		123,
		111,
		116,
		110,
		142,
		-1,
		186,
		185,
		174,
		171,
		147,
		138,
		133,
		160,
		-1,
		-1,
		155,
		182,
		166,
		148,
		146,
		171,
		-1,
		75,
		-1,
		-1,
		122,
		-1,
		-1,
		107,
		87,
		76,
		67,
		72,
		92,
		103,
		125,
		107,
		124,
		115,
		125,
		129,
		170,
		167,
		155,
		153,
		176,
		141,
		129,
		-1,
		137,
		140,
		146,
		153,
		149,
		160,
		-1,
		-1,
		91,
		71,
		-1,
		-1,
		105,
		103,
		92,
		-1,
		82,
		64,
		69,
		99,
		101,
		103,
		110,
		104,
		111,
		119,
		130,
		122,
		179,
		193,
		182,
		178,
		177,
		185,
		134,
		127,
		134,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		81,
		77,
		-1,
		-1,
		100,
		93,
		81,
		69,
		59,
		69,
		86,
		86,
		89,
		94,
		102,
		113,
		109,
		113,
		116,
		-1,
		213,
		-1,
		165,
		126,
		132,
		147,
		155,
		-1,
		-1,
		-1,
		98,
		84,
		77,
		65,
		63,
		-1,
		134,
		118,
		99,
		-1,
		69,
		82,
		122,
		90,
		95,
		90,
		105,
		116,
		107,
		115,
		109,
		112,
		-1,
		-1,
		125,
		108,
		-1,
		-1,
		82,
		84,
		-1,
		89,
		78,
		63,
		55,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		56,
		94,
		93,
		101,
		96,
		101,
		113,
		109,
		105,
		115,
		106,
		-1,
		-1,
		103,
		95,
		89,
		-1,
		67,
		-1,
		91,
		-1,
		58,
		56,
		44,
		-1,
		-1,
		-1,
		87,
		50,
		66,
		89,
		115,
		113,
		104,
		97,
		104,
		107,
		100,
		106,
		-1,
		-1,
		-1,
		85,
		59,
		98,
		89,
		72,
		52,
		44,
		55,
		-1,
		68,
		-1,
		43,
		46,
		71,
		110,
		112,
		98,
		94,
		107,
		101,
		98,
		96,
		91,
		-1,
		61,
		94,
		58,
		58,
		34,
		32,
		82,
		-1,
		65,
		47,
		-1,
		75,
		65,
		113,
		88,
		97,
		90,
		84,
		85,
		93,
		-1,
		-1,
		-1,
		63,
		62,
		54,
		48,
		48,
		39,
		22,
		-1,
		70,
		52,
		38,
		55,
		55,
		46,
		54,
		103,
		99,
		102,
		100,
		78,
		-1,
		179,
		-1,
		-1,
		86,
		-1,
		-1,
		-1,
		57,
		50,
		23,
		19,
		27,
		40,
		35,
		37,
		50,
		58,
		56,
		53,
		65,
		61,
		81,
		77,
		109,
		-1,
		174,
		-1,
		93,
		-1,
		-1,
		75,
		55,
		45,
		34,
		20,
		23,
		28,
		30,
		52,
		82,
		68,
		66,
		71,
		76,
		-1,
		163,
		162,
		-1,
		94,
		86,
		72,
		-1,
		65,
		-1,
		39,
		0,
		-1,
		59,
		39,
		-1,
		77,
		73,
		-1,
		-1,
		150,
		110,
		-1,
		-1,
		-1,
		95,
		75,
		34,
		18,
		-1,
		50,
		50,
		-1,
		-1,
		-1,
		135,
		119,
		-1,
		88,
		91,
		-1,
		82,
		88,
		105,
		52,
		56,
		-1,
		-1,
		-1,
		144,
		125,
		119,
		103,
		108,
		96,
		113,
		99,
		88,
		66,
		55,
		76,
		-1,
		-1,
		-1,
		116,
		108,
		108,
		-1,
		-1,
		113,
		96,
		77,
		75,
		-1,
		-1,
		-1,
		138,
		119,
		-1,
		-1,
		103,
		-1,
		-1,
		109,
		74,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		127,
		-1,
		-1,
		-1,
		99,
		95,
		96,
		-1,
		-1,
		-1,
		-1,
		148,
		149,
		173,
		147,
		-1,
		-1,
		-1,
		91,
		85,
		-1,
		-1,
		151,
		149,
		-1,
		-1,
		-1,
		119,
		103,
		-1,
		89,
		-1,
		-1,
		-1,
		110,
		-1,
		-1,
		122,
		-1,
		-1,
		-1,
		124,
		-1,
		124,
		99,
		106,
		-1,
		-1,
		-1,
		-1,
		137,
		129,
		137,
		-1,
		109,
		111,
		-1,
		159,
		-1,
		-1,
		152,
		143,
		-1,
		-1,
		114,
		121,
		143,
		146,
		182,
		-1,
		133
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		259,
		248,
		259,
		267,
		240,
		247,
		-1,
		266,
		270,
		236,
		230,
		269,
		238,
		244,
		255,
		-1,
		-1,
		-1,
		259,
		258,
		226,
		224,
		233,
		238,
		245,
		-1,
		244,
		-1,
		280,
		259,
		270,
		275,
		219,
		216,
		236,
		255,
		237,
		229,
		295,
		249,
		220,
		214,
		232,
		222,
		231,
		223,
		-1,
		220,
		210,
		232,
		211,
		222,
		214,
		-1,
		-1,
		214,
		215,
		221,
		207,
		213,
		209,
		-1,
		219,
		203,
		-1,
		-1,
		204,
		205,
		189,
		192,
		200,
		198,
		211,
		203,
		198,
		-1,
		-1,
		195,
		191,
		198,
		185,
		181,
		198,
		211,
		193,
		207,
		206,
		-1,
		199,
		217,
		224,
		192,
		190,
		174,
		172,
		190,
		192,
		198,
		198,
		-1,
		208,
		209,
		204,
		212,
		214,
		190,
		177,
		177,
		187,
		180,
		199,
		187,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		208,
		191,
		208,
		200,
		190,
		205,
		198,
		180,
		177,
		175,
		172,
		188,
		186,
		196,
		-1,
		-1,
		301,
		270,
		299,
		257,
		238,
		-1,
		204,
		184,
		190,
		194,
		188,
		181,
		195,
		191,
		-1,
		166,
		165,
		193,
		179,
		190,
		261,
		-1,
		-1,
		259,
		251,
		234,
		237,
		214,
		210,
		199,
		198,
		190,
		176,
		172,
		178,
		181,
		181,
		187,
		160,
		170,
		174,
		172,
		197,
		-1,
		-1,
		232,
		-1,
		-1,
		258,
		241,
		-1,
		224,
		231,
		220,
		226,
		212,
		233,
		209,
		200,
		192,
		186,
		174,
		176,
		173,
		186,
		174,
		157,
		182,
		186,
		167,
		188,
		183,
		-1,
		231,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		236,
		217,
		220,
		226,
		250,
		249,
		-1,
		221,
		209,
		210,
		195,
		192,
		179,
		167,
		180,
		165,
		172,
		171,
		161,
		159,
		189,
		164,
		186,
		183,
		202,
		207,
		201,
		210,
		-1,
		266,
		262,
		258,
		265,
		214,
		-1,
		-1,
		254,
		-1,
		257,
		258,
		233,
		206,
		209,
		196,
		187,
		174,
		163,
		174,
		163,
		160,
		168,
		153,
		168,
		159,
		158,
		176,
		186,
		194,
		198,
		204,
		-1,
		316,
		-1,
		258,
		242,
		244,
		216,
		237,
		-1,
		274,
		258,
		250,
		235,
		235,
		-1,
		205,
		202,
		192,
		170,
		155,
		172,
		164,
		162,
		166,
		148,
		162,
		153,
		171,
		178,
		176,
		180,
		200,
		212,
		276,
		266,
		-1,
		248,
		253,
		212,
		220,
		239,
		277,
		241,
		-1,
		236,
		-1,
		207,
		220,
		-1,
		176,
		172,
		154,
		155,
		150,
		165,
		159,
		144,
		141,
		159,
		162,
		169,
		173,
		189,
		-1,
		-1,
		261,
		265,
		254,
		205,
		224,
		248,
		285,
		234,
		223,
		222,
		-1,
		213,
		190,
		187,
		175,
		162,
		147,
		148,
		156,
		169,
		148,
		143,
		140,
		160,
		186,
		164,
		176,
		-1,
		-1,
		-1,
		286,
		-1,
		-1,
		231,
		202,
		226,
		268,
		252,
		245,
		233,
		198,
		198,
		192,
		-1,
		186,
		165,
		156,
		145,
		143,
		156,
		153,
		158,
		138,
		136,
		155,
		167,
		158,
		175,
		-1,
		-1,
		-1,
		261,
		250,
		251,
		197,
		220,
		257,
		231,
		217,
		222,
		197,
		190,
		184,
		199,
		182,
		163,
		152,
		144,
		133,
		149,
		157,
		152,
		134,
		143,
		149,
		173,
		163,
		169,
		-1,
		-1,
		268,
		258,
		242,
		244,
		241,
		211,
		218,
		250,
		222,
		235,
		-1,
		189,
		-1,
		178,
		173,
		157,
		152,
		149,
		146,
		140,
		149,
		151,
		141,
		136,
		143,
		178,
		178,
		153,
		173,
		176,
		-1,
		-1,
		-1,
		261,
		256,
		231,
		208,
		192,
		228,
		-1,
		205,
		206,
		-1,
		183,
		177,
		174,
		159,
		155,
		150,
		154,
		147,
		154,
		147,
		145,
		146,
		128,
		160,
		-1,
		161,
		155,
		163,
		153,
		141,
		-1,
		-1,
		-1,
		254,
		233,
		226,
		246,
		187,
		239,
		-1,
		-1,
		190,
		183,
		-1,
		170,
		152,
		159,
		157,
		151,
		155,
		152,
		141,
		154,
		147,
		133,
		135,
		148,
		152,
		156,
		143,
		139,
		136,
		150,
		-1,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		207,
		-1,
		199,
		191,
		181,
		175,
		169,
		165,
		163,
		179,
		163,
		166,
		164,
		155,
		163,
		136,
		129,
		136,
		125,
		143,
		151,
		143,
		137,
		136,
		146,
		-1,
		274,
		260,
		231,
		-1,
		-1,
		220,
		-1,
		184,
		198,
		214,
		-1,
		207,
		186,
		201,
		179,
		175,
		171,
		186,
		187,
		164,
		164,
		162,
		153,
		141,
		130,
		133,
		125,
		147,
		147,
		131,
		132,
		136,
		-1,
		280,
		267,
		225,
		221,
		210,
		230,
		181,
		169,
		201,
		-1,
		-1,
		243,
		-1,
		177,
		194,
		185,
		183,
		176,
		158,
		165,
		173,
		150,
		145,
		135,
		124,
		124,
		119,
		141,
		127,
		125,
		134,
		150,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		196,
		183,
		177,
		-1,
		218,
		-1,
		221,
		211,
		195,
		180,
		213,
		-1,
		157,
		153,
		160,
		-1,
		170,
		-1,
		143,
		140,
		131,
		116,
		113,
		124,
		122,
		133,
		129,
		-1,
		230,
		215,
		208,
		198,
		212,
		183,
		-1,
		238,
		-1,
		-1,
		208,
		202,
		202,
		186,
		187,
		173,
		153,
		145,
		160,
		159,
		146,
		145,
		129,
		122,
		119,
		112,
		125,
		135,
		140,
		127,
		-1,
		-1,
		-1,
		235,
		221,
		225,
		185,
		204,
		-1,
		-1,
		270,
		225,
		211,
		-1,
		182,
		173,
		161,
		151,
		141,
		146,
		147,
		137,
		135,
		127,
		129,
		123,
		114,
		113,
		129,
		121,
		143,
		-1,
		-1,
		218,
		223,
		211,
		197,
		216,
		-1,
		-1,
		-1,
		217,
		233,
		201,
		180,
		162,
		-1,
		-1,
		145,
		138,
		132,
		135,
		123,
		143,
		138,
		122,
		107,
		122,
		126,
		134,
		125,
		-1,
		221,
		208,
		-1,
		-1,
		219,
		213,
		-1,
		-1,
		-1,
		-1,
		213,
		158,
		147,
		142,
		146,
		144,
		-1,
		118,
		129,
		122,
		141,
		148,
		124,
		109,
		103,
		109,
		121,
		130,
		-1,
		-1,
		233,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		170,
		164,
		135,
		128,
		132,
		-1,
		120,
		122,
		119,
		131,
		127,
		124,
		115,
		106,
		102,
		106,
		110,
		124,
		128,
		256,
		-1,
		197,
		-1,
		-1,
		-1,
		188,
		203,
		174,
		151,
		124,
		119,
		112,
		106,
		111,
		122,
		131,
		142,
		107,
		109,
		99,
		98,
		102,
		119,
		123,
		-1,
		-1,
		195,
		191,
		214,
		196,
		200,
		201,
		-1,
		-1,
		128,
		119,
		110,
		102,
		115,
		118,
		103,
		105,
		105,
		103,
		97,
		107,
		122,
		117,
		-1,
		-1,
		-1,
		207,
		-1,
		209,
		-1,
		-1,
		198,
		199,
		146,
		128,
		124,
		122,
		111,
		105,
		93,
		98,
		108,
		102,
		99,
		93,
		97,
		120,
		109,
		148,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		187,
		178,
		173,
		180,
		182,
		173,
		161,
		158,
		-1,
		128,
		134,
		99,
		106,
		89,
		96,
		101,
		98,
		87,
		94,
		110,
		109,
		104,
		140,
		131,
		137,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		180,
		175,
		166,
		156,
		159,
		-1,
		-1,
		153,
		150,
		130,
		99,
		97,
		90,
		85,
		95,
		71,
		83,
		87,
		91,
		97,
		102,
		107,
		113,
		128,
		143,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		170,
		162,
		172,
		148,
		150,
		-1,
		-1,
		126,
		117,
		118,
		106,
		103,
		109,
		108,
		91,
		97,
		98,
		90,
		89,
		107,
		111,
		120,
		127,
		117,
		130,
		134,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		167,
		-1,
		-1,
		132,
		151,
		135,
		125,
		122,
		165,
		120,
		115,
		96,
		94,
		89,
		80,
		105,
		98,
		98,
		101,
		116,
		121,
		113,
		127,
		127,
		128,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		168,
		-1,
		-1,
		122,
		-1,
		162,
		-1,
		145,
		149,
		128,
		131,
		110,
		97,
		83,
		91,
		97,
		96,
		102,
		102,
		103,
		112,
		123,
		135,
		134,
		135,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		179,
		218,
		128,
		-1,
		112,
		-1,
		-1,
		-1,
		159,
		141,
		133,
		130,
		109,
		109,
		75,
		79,
		92,
		99,
		109,
		120,
		112,
		116,
		129,
		140,
		143,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		180,
		212,
		135,
		124,
		119,
		106,
		-1,
		-1,
		143,
		151,
		-1,
		-1,
		116,
		83,
		71,
		81,
		85,
		99,
		111,
		124,
		112,
		117,
		111,
		143,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		208,
		191,
		168,
		166,
		191,
		-1,
		95,
		-1,
		-1,
		123,
		-1,
		-1,
		108,
		88,
		77,
		68,
		73,
		93,
		104,
		126,
		108,
		125,
		116,
		126,
		130,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		163,
		166,
		172,
		179,
		169,
		180,
		-1,
		-1,
		111,
		91,
		-1,
		-1,
		106,
		104,
		93,
		-1,
		83,
		65,
		70,
		100,
		102,
		104,
		111,
		105,
		112,
		120,
		131,
		123,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		-1,
		101,
		97,
		-1,
		-1,
		101,
		94,
		82,
		70,
		60,
		70,
		87,
		87,
		90,
		95,
		103,
		114,
		110,
		114,
		117,
		-1,
		239,
		-1,
		191,
		152,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		118,
		104,
		97,
		85,
		83,
		-1,
		135,
		119,
		100,
		-1,
		70,
		83,
		123,
		91,
		96,
		91,
		106,
		117,
		108,
		116,
		110,
		113,
		-1,
		-1,
		151,
		134,
		-1,
		-1,
		108,
		110,
		-1,
		109,
		98,
		83,
		75,
		-1,
		-1,
		107,
		103,
		-1,
		-1,
		57,
		95,
		94,
		102,
		97,
		102,
		114,
		110,
		106,
		116,
		107,
		-1,
		-1,
		129,
		121,
		115,
		-1,
		93,
		-1,
		111,
		-1,
		78,
		84,
		72,
		-1,
		-1,
		-1,
		88,
		51,
		67,
		90,
		116,
		114,
		105,
		98,
		105,
		108,
		101,
		107,
		-1,
		-1,
		-1,
		111,
		85,
		118,
		109,
		92,
		72,
		64,
		83,
		-1,
		69,
		-1,
		44,
		47,
		72,
		111,
		113,
		99,
		95,
		108,
		102,
		99,
		97,
		117,
		-1,
		87,
		120,
		84,
		78,
		54,
		58,
		83,
		-1,
		66,
		48,
		-1,
		76,
		66,
		114,
		89,
		98,
		91,
		85,
		86,
		94,
		-1,
		-1,
		-1,
		89,
		88,
		80,
		74,
		74,
		59,
		50,
		-1,
		71,
		53,
		39,
		56,
		56,
		47,
		55,
		104,
		100,
		103,
		101,
		79,
		-1,
		165,
		-1,
		-1,
		112,
		-1,
		-1,
		-1,
		83,
		78,
		51,
		39,
		40,
		36,
		36,
		38,
		51,
		59,
		57,
		54,
		66,
		62,
		82,
		78,
		110,
		-1,
		160,
		-1,
		119,
		-1,
		-1,
		101,
		81,
		73,
		62,
		51,
		49,
		35,
		31,
		48,
		83,
		69,
		67,
		72,
		77,
		-1,
		149,
		148,
		-1,
		120,
		112,
		98,
		-1,
		91,
		-1,
		97,
		58,
		-1,
		0,
		26,
		-1,
		78,
		74,
		-1,
		-1,
		136,
		131,
		-1,
		-1,
		-1,
		121,
		86,
		92,
		76,
		-1,
		22,
		21,
		-1,
		-1,
		-1,
		121,
		122,
		-1,
		114,
		117,
		-1,
		82,
		73,
		81,
		28,
		32,
		-1,
		-1,
		-1,
		130,
		111,
		105,
		107,
		102,
		122,
		94,
		80,
		64,
		42,
		31,
		52,
		-1,
		-1,
		-1,
		102,
		94,
		87,
		-1,
		-1,
		89,
		72,
		53,
		51,
		-1,
		-1,
		-1,
		124,
		105,
		-1,
		-1,
		79,
		-1,
		-1,
		85,
		50,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		113,
		-1,
		-1,
		-1,
		75,
		71,
		72,
		-1,
		-1,
		-1,
		-1,
		135,
		136,
		159,
		123,
		-1,
		-1,
		-1,
		67,
		61,
		-1,
		-1,
		138,
		136,
		-1,
		-1,
		-1,
		95,
		79,
		-1,
		65,
		-1,
		-1,
		-1,
		86,
		-1,
		-1,
		98,
		-1,
		-1,
		-1,
		100,
		-1,
		100,
		75,
		82,
		-1,
		-1,
		-1,
		-1,
		113,
		105,
		113,
		-1,
		85,
		87,
		-1,
		135,
		-1,
		-1,
		128,
		119,
		-1,
		-1,
		90,
		97,
		119,
		122,
		158,
		-1,
		109
	],
	[
		-1,
		239,
		228,
		239,
		247,
		220,
		227,
		-1,
		246,
		250,
		216,
		210,
		249,
		218,
		224,
		235,
		-1,
		-1,
		-1,
		239,
		238,
		206,
		204,
		213,
		218,
		225,
		-1,
		224,
		-1,
		260,
		239,
		250,
		255,
		199,
		196,
		216,
		235,
		217,
		209,
		275,
		229,
		200,
		194,
		212,
		202,
		211,
		203,
		-1,
		200,
		190,
		212,
		191,
		202,
		194,
		-1,
		-1,
		194,
		195,
		201,
		187,
		193,
		189,
		-1,
		199,
		183,
		-1,
		-1,
		184,
		185,
		169,
		172,
		180,
		178,
		191,
		183,
		178,
		-1,
		-1,
		175,
		171,
		178,
		165,
		161,
		178,
		191,
		173,
		187,
		186,
		-1,
		179,
		197,
		204,
		172,
		170,
		154,
		152,
		170,
		172,
		178,
		178,
		-1,
		188,
		189,
		184,
		192,
		194,
		170,
		157,
		157,
		167,
		160,
		179,
		167,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		222,
		188,
		171,
		188,
		180,
		170,
		185,
		178,
		160,
		157,
		155,
		152,
		168,
		166,
		176,
		-1,
		-1,
		281,
		250,
		279,
		237,
		218,
		-1,
		184,
		164,
		170,
		174,
		168,
		161,
		175,
		171,
		-1,
		146,
		145,
		173,
		159,
		170,
		241,
		-1,
		-1,
		239,
		231,
		214,
		217,
		194,
		190,
		179,
		178,
		170,
		156,
		152,
		158,
		161,
		161,
		167,
		140,
		150,
		154,
		152,
		177,
		-1,
		-1,
		212,
		-1,
		-1,
		238,
		221,
		-1,
		204,
		211,
		200,
		206,
		192,
		213,
		189,
		180,
		172,
		166,
		154,
		156,
		153,
		166,
		154,
		137,
		162,
		166,
		147,
		168,
		163,
		-1,
		211,
		195,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		197,
		200,
		206,
		230,
		229,
		-1,
		201,
		189,
		190,
		175,
		172,
		159,
		147,
		160,
		145,
		152,
		151,
		141,
		139,
		169,
		144,
		166,
		163,
		182,
		187,
		181,
		190,
		-1,
		246,
		242,
		238,
		245,
		194,
		-1,
		-1,
		234,
		-1,
		237,
		238,
		213,
		186,
		189,
		176,
		167,
		154,
		143,
		154,
		143,
		140,
		148,
		133,
		148,
		139,
		138,
		156,
		166,
		174,
		178,
		184,
		-1,
		296,
		-1,
		238,
		222,
		224,
		196,
		217,
		-1,
		254,
		238,
		230,
		215,
		215,
		-1,
		185,
		182,
		172,
		150,
		135,
		152,
		144,
		142,
		146,
		128,
		142,
		133,
		151,
		158,
		156,
		160,
		180,
		192,
		256,
		246,
		-1,
		228,
		233,
		192,
		200,
		219,
		257,
		221,
		-1,
		216,
		-1,
		187,
		200,
		-1,
		156,
		152,
		134,
		135,
		130,
		145,
		139,
		124,
		121,
		139,
		142,
		149,
		153,
		169,
		-1,
		-1,
		241,
		245,
		234,
		185,
		204,
		228,
		265,
		214,
		203,
		202,
		-1,
		193,
		170,
		167,
		155,
		142,
		127,
		128,
		136,
		149,
		128,
		123,
		120,
		140,
		166,
		144,
		156,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		211,
		182,
		206,
		248,
		232,
		225,
		213,
		178,
		178,
		172,
		-1,
		166,
		145,
		136,
		125,
		123,
		136,
		133,
		138,
		118,
		116,
		135,
		147,
		138,
		155,
		-1,
		-1,
		-1,
		241,
		230,
		231,
		177,
		200,
		237,
		211,
		197,
		202,
		177,
		170,
		164,
		179,
		162,
		143,
		132,
		124,
		113,
		129,
		137,
		132,
		114,
		123,
		129,
		153,
		143,
		149,
		-1,
		-1,
		248,
		238,
		222,
		224,
		221,
		191,
		198,
		230,
		202,
		215,
		-1,
		169,
		-1,
		158,
		153,
		137,
		132,
		129,
		126,
		120,
		129,
		131,
		121,
		116,
		123,
		158,
		158,
		133,
		153,
		156,
		-1,
		-1,
		-1,
		241,
		236,
		211,
		188,
		172,
		208,
		-1,
		185,
		186,
		-1,
		163,
		157,
		154,
		139,
		135,
		130,
		134,
		127,
		134,
		127,
		125,
		126,
		108,
		140,
		-1,
		141,
		135,
		143,
		133,
		121,
		-1,
		-1,
		-1,
		234,
		213,
		206,
		226,
		167,
		219,
		-1,
		-1,
		170,
		163,
		-1,
		150,
		132,
		139,
		137,
		131,
		135,
		132,
		121,
		134,
		127,
		113,
		115,
		128,
		132,
		136,
		123,
		119,
		116,
		130,
		-1,
		253,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		187,
		-1,
		179,
		171,
		161,
		155,
		149,
		145,
		143,
		159,
		143,
		146,
		144,
		135,
		143,
		116,
		109,
		116,
		105,
		123,
		131,
		123,
		117,
		116,
		126,
		-1,
		254,
		240,
		211,
		-1,
		-1,
		200,
		-1,
		164,
		178,
		194,
		-1,
		187,
		166,
		181,
		159,
		155,
		151,
		166,
		167,
		144,
		144,
		142,
		133,
		121,
		110,
		113,
		105,
		127,
		127,
		111,
		112,
		116,
		-1,
		260,
		247,
		205,
		201,
		190,
		210,
		161,
		149,
		181,
		-1,
		-1,
		223,
		-1,
		157,
		174,
		165,
		163,
		156,
		138,
		145,
		153,
		130,
		125,
		115,
		104,
		104,
		99,
		121,
		107,
		105,
		114,
		130,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		176,
		163,
		157,
		-1,
		198,
		-1,
		201,
		191,
		175,
		160,
		193,
		-1,
		137,
		133,
		140,
		-1,
		150,
		-1,
		123,
		120,
		111,
		96,
		93,
		104,
		102,
		113,
		109,
		-1,
		210,
		195,
		188,
		178,
		192,
		163,
		-1,
		218,
		-1,
		-1,
		188,
		182,
		182,
		166,
		167,
		153,
		133,
		125,
		140,
		139,
		126,
		125,
		109,
		102,
		99,
		92,
		105,
		115,
		120,
		107,
		-1,
		-1,
		-1,
		215,
		201,
		205,
		165,
		184,
		-1,
		-1,
		250,
		205,
		191,
		-1,
		162,
		153,
		141,
		131,
		121,
		126,
		127,
		117,
		115,
		107,
		109,
		103,
		94,
		93,
		109,
		101,
		123,
		-1,
		-1,
		198,
		203,
		191,
		177,
		196,
		-1,
		-1,
		-1,
		197,
		213,
		181,
		160,
		142,
		-1,
		-1,
		125,
		118,
		112,
		115,
		103,
		123,
		118,
		102,
		87,
		102,
		106,
		114,
		105,
		-1,
		201,
		188,
		-1,
		-1,
		199,
		193,
		-1,
		-1,
		-1,
		-1,
		193,
		138,
		127,
		122,
		126,
		124,
		-1,
		98,
		109,
		102,
		121,
		128,
		104,
		89,
		83,
		89,
		101,
		110,
		-1,
		-1,
		213,
		-1,
		186,
		-1,
		-1,
		-1,
		-1,
		150,
		144,
		115,
		108,
		112,
		-1,
		100,
		102,
		99,
		111,
		107,
		104,
		95,
		86,
		82,
		86,
		90,
		104,
		108,
		236,
		-1,
		177,
		-1,
		-1,
		-1,
		168,
		183,
		154,
		131,
		104,
		99,
		92,
		86,
		91,
		102,
		111,
		122,
		87,
		89,
		79,
		78,
		82,
		99,
		103,
		-1,
		-1,
		175,
		171,
		194,
		176,
		180,
		181,
		-1,
		-1,
		108,
		99,
		90,
		82,
		95,
		98,
		83,
		85,
		85,
		83,
		77,
		87,
		102,
		97,
		-1,
		-1,
		-1,
		187,
		-1,
		189,
		-1,
		-1,
		178,
		179,
		126,
		108,
		104,
		102,
		91,
		85,
		73,
		78,
		88,
		82,
		79,
		73,
		77,
		100,
		89,
		128,
		-1,
		-1,
		249,
		-1,
		-1,
		-1,
		167,
		158,
		153,
		160,
		162,
		153,
		141,
		138,
		-1,
		108,
		114,
		79,
		86,
		69,
		76,
		81,
		78,
		67,
		74,
		90,
		89,
		84,
		120,
		111,
		117,
		-1,
		-1,
		242,
		231,
		220,
		226,
		-1,
		160,
		155,
		146,
		136,
		139,
		-1,
		-1,
		133,
		130,
		110,
		79,
		77,
		70,
		65,
		75,
		51,
		63,
		67,
		71,
		77,
		82,
		87,
		93,
		108,
		123,
		-1,
		196,
		233,
		226,
		194,
		202,
		233,
		-1,
		150,
		142,
		152,
		128,
		130,
		-1,
		-1,
		106,
		97,
		98,
		86,
		83,
		89,
		88,
		71,
		77,
		78,
		70,
		69,
		87,
		91,
		100,
		107,
		97,
		110,
		114,
		-1,
		189,
		209,
		188,
		191,
		215,
		229,
		-1,
		147,
		-1,
		-1,
		112,
		131,
		115,
		105,
		102,
		145,
		100,
		95,
		76,
		74,
		69,
		60,
		85,
		78,
		78,
		81,
		96,
		101,
		93,
		107,
		107,
		108,
		-1,
		178,
		189,
		182,
		-1,
		-1,
		-1,
		-1,
		148,
		-1,
		-1,
		102,
		-1,
		142,
		-1,
		125,
		129,
		108,
		111,
		90,
		77,
		63,
		71,
		77,
		76,
		82,
		82,
		83,
		92,
		103,
		115,
		114,
		115,
		203,
		159,
		162,
		173,
		184,
		199,
		203,
		-1,
		159,
		198,
		108,
		-1,
		92,
		-1,
		-1,
		-1,
		139,
		121,
		113,
		110,
		89,
		89,
		55,
		59,
		72,
		79,
		89,
		100,
		92,
		96,
		109,
		120,
		123,
		199,
		190,
		203,
		148,
		148,
		169,
		178,
		199,
		163,
		160,
		192,
		115,
		104,
		99,
		86,
		-1,
		-1,
		123,
		131,
		-1,
		-1,
		96,
		63,
		51,
		61,
		65,
		79,
		91,
		104,
		92,
		97,
		91,
		123,
		-1,
		192,
		191,
		180,
		177,
		153,
		144,
		139,
		166,
		-1,
		-1,
		161,
		188,
		171,
		148,
		146,
		171,
		-1,
		75,
		-1,
		-1,
		103,
		-1,
		-1,
		88,
		68,
		57,
		48,
		53,
		73,
		84,
		106,
		88,
		105,
		96,
		106,
		110,
		176,
		173,
		161,
		159,
		182,
		147,
		135,
		-1,
		143,
		146,
		152,
		159,
		149,
		160,
		-1,
		-1,
		91,
		71,
		-1,
		-1,
		86,
		84,
		73,
		-1,
		63,
		45,
		50,
		80,
		82,
		84,
		91,
		85,
		92,
		100,
		111,
		103,
		185,
		199,
		188,
		184,
		183,
		191,
		140,
		133,
		140,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		-1,
		81,
		77,
		-1,
		-1,
		81,
		74,
		62,
		50,
		40,
		50,
		67,
		67,
		70,
		75,
		83,
		94,
		90,
		94,
		97,
		-1,
		219,
		-1,
		171,
		132,
		138,
		153,
		161,
		-1,
		-1,
		-1,
		98,
		84,
		77,
		65,
		63,
		-1,
		115,
		99,
		80,
		-1,
		50,
		63,
		103,
		71,
		76,
		71,
		86,
		97,
		88,
		96,
		90,
		93,
		-1,
		-1,
		131,
		114,
		-1,
		-1,
		88,
		90,
		-1,
		89,
		78,
		63,
		55,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		37,
		75,
		74,
		82,
		77,
		82,
		94,
		90,
		86,
		96,
		87,
		-1,
		-1,
		109,
		101,
		95,
		-1,
		73,
		-1,
		91,
		-1,
		58,
		64,
		52,
		-1,
		-1,
		-1,
		68,
		31,
		47,
		70,
		96,
		94,
		85,
		78,
		85,
		88,
		81,
		87,
		-1,
		-1,
		-1,
		91,
		65,
		98,
		89,
		72,
		52,
		44,
		63,
		-1,
		49,
		-1,
		24,
		27,
		52,
		91,
		93,
		79,
		75,
		88,
		82,
		79,
		77,
		97,
		-1,
		67,
		100,
		64,
		58,
		34,
		38,
		63,
		-1,
		46,
		28,
		-1,
		56,
		46,
		94,
		69,
		78,
		71,
		65,
		66,
		74,
		-1,
		-1,
		-1,
		69,
		68,
		60,
		54,
		54,
		39,
		30,
		-1,
		51,
		33,
		19,
		36,
		36,
		27,
		35,
		84,
		80,
		83,
		81,
		59,
		-1,
		157,
		-1,
		-1,
		92,
		-1,
		-1,
		-1,
		63,
		58,
		31,
		19,
		17,
		13,
		16,
		16,
		31,
		39,
		37,
		34,
		46,
		42,
		62,
		58,
		90,
		-1,
		152,
		-1,
		99,
		-1,
		-1,
		81,
		61,
		53,
		42,
		31,
		29,
		12,
		11,
		27,
		61,
		49,
		47,
		52,
		57,
		-1,
		141,
		140,
		-1,
		100,
		92,
		78,
		-1,
		71,
		-1,
		77,
		38,
		-1,
		23,
		0,
		-1,
		58,
		54,
		-1,
		-1,
		128,
		116,
		-1,
		-1,
		-1,
		101,
		78,
		72,
		56,
		-1,
		15,
		14,
		-1,
		-1,
		-1,
		113,
		114,
		-1,
		94,
		97,
		-1,
		74,
		65,
		73,
		21,
		25,
		-1,
		-1,
		-1,
		122,
		103,
		97,
		99,
		94,
		102,
		86,
		72,
		56,
		34,
		24,
		43,
		-1,
		-1,
		-1,
		94,
		86,
		79,
		-1,
		-1,
		81,
		64,
		45,
		43,
		-1,
		-1,
		-1,
		116,
		97,
		-1,
		-1,
		71,
		-1,
		-1,
		77,
		42,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		105,
		-1,
		-1,
		-1,
		67,
		63,
		64,
		-1,
		-1,
		-1,
		-1,
		127,
		128,
		151,
		115,
		-1,
		-1,
		-1,
		59,
		53,
		-1,
		-1,
		130,
		128,
		-1,
		-1,
		-1,
		87,
		71,
		-1,
		57,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		90,
		-1,
		-1,
		-1,
		92,
		-1,
		92,
		67,
		74,
		-1,
		-1,
		-1,
		-1,
		105,
		97,
		105,
		-1,
		77,
		79,
		-1,
		127,
		-1,
		-1,
		120,
		111,
		-1,
		-1,
		82,
		89,
		111,
		114,
		150,
		-1,
		101
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		260,
		249,
		260,
		268,
		241,
		248,
		-1,
		267,
		271,
		237,
		231,
		270,
		239,
		245,
		256,
		-1,
		-1,
		-1,
		260,
		259,
		227,
		225,
		234,
		239,
		246,
		-1,
		245,
		-1,
		281,
		260,
		271,
		276,
		220,
		217,
		237,
		256,
		238,
		230,
		296,
		250,
		221,
		215,
		233,
		223,
		232,
		224,
		-1,
		221,
		211,
		233,
		212,
		223,
		215,
		-1,
		-1,
		215,
		216,
		222,
		208,
		214,
		210,
		-1,
		220,
		204,
		-1,
		-1,
		205,
		206,
		190,
		193,
		201,
		199,
		212,
		204,
		199,
		-1,
		-1,
		196,
		192,
		199,
		186,
		182,
		199,
		212,
		194,
		208,
		207,
		-1,
		200,
		218,
		225,
		193,
		191,
		175,
		173,
		191,
		193,
		199,
		199,
		-1,
		209,
		210,
		205,
		213,
		215,
		191,
		178,
		178,
		188,
		181,
		200,
		188,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		243,
		209,
		192,
		209,
		201,
		191,
		206,
		199,
		181,
		178,
		176,
		173,
		189,
		187,
		197,
		-1,
		-1,
		302,
		271,
		300,
		258,
		239,
		-1,
		205,
		185,
		191,
		195,
		189,
		182,
		196,
		192,
		-1,
		167,
		166,
		194,
		180,
		191,
		262,
		-1,
		-1,
		260,
		252,
		235,
		238,
		215,
		211,
		200,
		199,
		191,
		177,
		173,
		179,
		182,
		182,
		188,
		161,
		171,
		175,
		173,
		198,
		-1,
		-1,
		233,
		-1,
		-1,
		259,
		242,
		-1,
		225,
		232,
		221,
		227,
		213,
		234,
		210,
		201,
		193,
		187,
		175,
		177,
		174,
		187,
		175,
		158,
		183,
		187,
		168,
		189,
		184,
		-1,
		232,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		218,
		221,
		227,
		251,
		250,
		-1,
		222,
		210,
		211,
		196,
		193,
		180,
		168,
		181,
		166,
		173,
		172,
		162,
		160,
		190,
		165,
		187,
		184,
		203,
		208,
		202,
		211,
		-1,
		267,
		263,
		259,
		266,
		215,
		-1,
		-1,
		255,
		-1,
		258,
		259,
		234,
		207,
		210,
		197,
		188,
		175,
		164,
		175,
		164,
		161,
		169,
		154,
		169,
		160,
		159,
		177,
		187,
		195,
		199,
		205,
		-1,
		317,
		-1,
		259,
		243,
		245,
		217,
		238,
		-1,
		275,
		259,
		251,
		236,
		236,
		-1,
		206,
		203,
		193,
		171,
		156,
		173,
		165,
		163,
		167,
		149,
		163,
		154,
		172,
		179,
		177,
		181,
		201,
		213,
		277,
		267,
		-1,
		249,
		254,
		213,
		221,
		240,
		278,
		242,
		-1,
		237,
		-1,
		208,
		221,
		-1,
		177,
		173,
		155,
		156,
		151,
		166,
		160,
		145,
		142,
		160,
		163,
		170,
		174,
		190,
		-1,
		-1,
		262,
		266,
		255,
		206,
		225,
		249,
		286,
		235,
		224,
		223,
		-1,
		214,
		191,
		188,
		176,
		163,
		148,
		149,
		157,
		170,
		149,
		144,
		141,
		161,
		187,
		165,
		177,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		232,
		203,
		227,
		269,
		253,
		246,
		234,
		199,
		199,
		193,
		-1,
		187,
		166,
		157,
		146,
		144,
		157,
		154,
		159,
		139,
		137,
		156,
		168,
		159,
		176,
		-1,
		-1,
		-1,
		262,
		251,
		252,
		198,
		221,
		258,
		232,
		218,
		223,
		198,
		191,
		185,
		200,
		183,
		164,
		153,
		145,
		134,
		150,
		158,
		153,
		135,
		144,
		150,
		174,
		164,
		170,
		-1,
		-1,
		269,
		259,
		243,
		245,
		242,
		212,
		219,
		251,
		223,
		236,
		-1,
		190,
		-1,
		179,
		174,
		158,
		153,
		150,
		147,
		141,
		150,
		152,
		142,
		137,
		144,
		179,
		179,
		154,
		174,
		177,
		-1,
		-1,
		-1,
		262,
		257,
		232,
		209,
		193,
		229,
		-1,
		206,
		207,
		-1,
		184,
		178,
		175,
		160,
		156,
		151,
		155,
		148,
		155,
		148,
		146,
		147,
		129,
		161,
		-1,
		162,
		156,
		164,
		154,
		142,
		-1,
		-1,
		-1,
		255,
		234,
		227,
		247,
		188,
		240,
		-1,
		-1,
		191,
		184,
		-1,
		171,
		153,
		160,
		158,
		152,
		156,
		153,
		142,
		155,
		148,
		134,
		136,
		149,
		153,
		157,
		144,
		140,
		137,
		151,
		-1,
		274,
		-1,
		-1,
		-1,
		-1,
		-1,
		188,
		208,
		-1,
		200,
		192,
		182,
		176,
		170,
		166,
		164,
		180,
		164,
		167,
		165,
		156,
		164,
		137,
		130,
		137,
		126,
		144,
		152,
		144,
		138,
		137,
		147,
		-1,
		275,
		261,
		232,
		-1,
		-1,
		221,
		-1,
		185,
		199,
		215,
		-1,
		208,
		187,
		202,
		180,
		176,
		172,
		187,
		188,
		165,
		165,
		163,
		154,
		142,
		131,
		134,
		126,
		148,
		148,
		132,
		133,
		137,
		-1,
		281,
		268,
		226,
		222,
		211,
		231,
		182,
		170,
		202,
		-1,
		-1,
		244,
		-1,
		178,
		195,
		186,
		184,
		177,
		159,
		166,
		174,
		151,
		146,
		136,
		125,
		125,
		120,
		142,
		128,
		126,
		135,
		151,
		-1,
		-1,
		-1,
		248,
		-1,
		-1,
		197,
		184,
		178,
		-1,
		219,
		-1,
		222,
		212,
		196,
		181,
		214,
		-1,
		158,
		154,
		161,
		-1,
		171,
		-1,
		144,
		141,
		132,
		117,
		114,
		125,
		123,
		134,
		130,
		-1,
		231,
		216,
		209,
		199,
		213,
		184,
		-1,
		239,
		-1,
		-1,
		209,
		203,
		203,
		187,
		188,
		174,
		154,
		146,
		161,
		160,
		147,
		146,
		130,
		123,
		120,
		113,
		126,
		136,
		141,
		128,
		-1,
		-1,
		-1,
		236,
		222,
		226,
		186,
		205,
		-1,
		-1,
		271,
		226,
		212,
		-1,
		183,
		174,
		162,
		152,
		142,
		147,
		148,
		138,
		136,
		128,
		130,
		124,
		115,
		114,
		130,
		122,
		144,
		-1,
		-1,
		219,
		224,
		212,
		198,
		217,
		-1,
		-1,
		-1,
		218,
		234,
		202,
		181,
		163,
		-1,
		-1,
		146,
		139,
		133,
		136,
		124,
		144,
		139,
		123,
		108,
		123,
		127,
		135,
		126,
		-1,
		222,
		209,
		-1,
		-1,
		220,
		214,
		-1,
		-1,
		-1,
		-1,
		214,
		159,
		148,
		143,
		147,
		145,
		-1,
		119,
		130,
		123,
		142,
		149,
		125,
		110,
		104,
		110,
		122,
		131,
		-1,
		-1,
		234,
		-1,
		208,
		-1,
		-1,
		-1,
		-1,
		171,
		165,
		136,
		129,
		133,
		-1,
		121,
		123,
		120,
		132,
		128,
		125,
		116,
		107,
		103,
		107,
		111,
		124,
		129,
		257,
		-1,
		199,
		-1,
		-1,
		-1,
		189,
		204,
		175,
		152,
		125,
		120,
		113,
		107,
		112,
		123,
		132,
		143,
		108,
		110,
		100,
		99,
		103,
		120,
		124,
		-1,
		-1,
		197,
		193,
		215,
		197,
		201,
		202,
		-1,
		-1,
		129,
		120,
		111,
		103,
		116,
		119,
		104,
		106,
		106,
		104,
		98,
		108,
		123,
		118,
		-1,
		-1,
		-1,
		209,
		-1,
		211,
		-1,
		-1,
		199,
		200,
		147,
		129,
		125,
		123,
		112,
		106,
		94,
		99,
		109,
		103,
		100,
		94,
		98,
		121,
		110,
		118,
		-1,
		-1,
		281,
		-1,
		-1,
		-1,
		188,
		180,
		175,
		181,
		183,
		174,
		162,
		159,
		-1,
		129,
		135,
		100,
		107,
		90,
		97,
		102,
		99,
		88,
		95,
		111,
		110,
		105,
		110,
		101,
		109,
		-1,
		-1,
		274,
		263,
		252,
		258,
		-1,
		181,
		177,
		167,
		157,
		160,
		-1,
		-1,
		154,
		151,
		131,
		100,
		98,
		91,
		86,
		96,
		72,
		84,
		88,
		85,
		98,
		103,
		102,
		95,
		100,
		115,
		-1,
		228,
		265,
		258,
		226,
		234,
		265,
		-1,
		171,
		163,
		174,
		149,
		151,
		-1,
		-1,
		127,
		118,
		119,
		107,
		104,
		110,
		109,
		92,
		98,
		99,
		83,
		90,
		101,
		93,
		97,
		98,
		87,
		100,
		104,
		-1,
		221,
		241,
		220,
		223,
		247,
		261,
		-1,
		168,
		-1,
		-1,
		149,
		152,
		136,
		126,
		123,
		166,
		121,
		116,
		97,
		95,
		90,
		81,
		106,
		91,
		79,
		76,
		85,
		90,
		82,
		97,
		93,
		86,
		-1,
		210,
		221,
		214,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		-1,
		139,
		-1,
		163,
		-1,
		146,
		150,
		129,
		132,
		111,
		98,
		84,
		92,
		98,
		91,
		87,
		83,
		72,
		74,
		86,
		90,
		100,
		102,
		235,
		191,
		194,
		205,
		216,
		231,
		235,
		-1,
		180,
		219,
		145,
		-1,
		129,
		-1,
		-1,
		-1,
		160,
		142,
		134,
		131,
		110,
		110,
		76,
		80,
		93,
		92,
		98,
		89,
		74,
		73,
		84,
		95,
		94,
		231,
		222,
		235,
		180,
		180,
		201,
		210,
		231,
		195,
		186,
		213,
		152,
		141,
		136,
		123,
		-1,
		-1,
		144,
		152,
		-1,
		-1,
		117,
		84,
		72,
		82,
		86,
		100,
		98,
		86,
		66,
		72,
		66,
		90,
		-1,
		224,
		223,
		212,
		209,
		185,
		176,
		171,
		198,
		-1,
		-1,
		193,
		214,
		204,
		185,
		183,
		208,
		-1,
		112,
		-1,
		-1,
		124,
		-1,
		-1,
		109,
		89,
		78,
		69,
		74,
		94,
		102,
		113,
		62,
		78,
		71,
		78,
		75,
		208,
		205,
		193,
		191,
		214,
		179,
		167,
		-1,
		180,
		178,
		184,
		191,
		186,
		197,
		-1,
		-1,
		128,
		108,
		-1,
		-1,
		107,
		105,
		94,
		-1,
		84,
		66,
		71,
		98,
		79,
		71,
		65,
		59,
		66,
		65,
		76,
		68,
		217,
		231,
		220,
		216,
		215,
		223,
		172,
		165,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		118,
		114,
		-1,
		-1,
		102,
		95,
		83,
		71,
		61,
		71,
		71,
		67,
		67,
		62,
		57,
		68,
		55,
		59,
		62,
		-1,
		251,
		-1,
		203,
		169,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		135,
		121,
		114,
		102,
		100,
		-1,
		136,
		120,
		101,
		-1,
		71,
		84,
		103,
		71,
		63,
		61,
		51,
		62,
		53,
		61,
		55,
		58,
		-1,
		-1,
		168,
		151,
		-1,
		-1,
		125,
		127,
		-1,
		126,
		115,
		100,
		92,
		-1,
		-1,
		108,
		104,
		-1,
		-1,
		58,
		76,
		74,
		69,
		65,
		47,
		59,
		55,
		51,
		61,
		52,
		-1,
		-1,
		146,
		138,
		132,
		-1,
		110,
		-1,
		128,
		-1,
		95,
		101,
		89,
		-1,
		-1,
		-1,
		89,
		52,
		68,
		71,
		61,
		59,
		50,
		43,
		50,
		53,
		46,
		52,
		-1,
		-1,
		-1,
		128,
		102,
		135,
		126,
		109,
		89,
		81,
		100,
		-1,
		70,
		-1,
		45,
		48,
		53,
		69,
		68,
		54,
		40,
		53,
		47,
		44,
		42,
		134,
		-1,
		104,
		137,
		101,
		95,
		71,
		75,
		91,
		-1,
		67,
		49,
		-1,
		60,
		47,
		69,
		44,
		49,
		36,
		30,
		31,
		39,
		-1,
		-1,
		-1,
		106,
		105,
		97,
		91,
		91,
		76,
		67,
		-1,
		79,
		61,
		40,
		55,
		40,
		31,
		31,
		59,
		55,
		52,
		50,
		24,
		-1,
		207,
		-1,
		-1,
		129,
		-1,
		-1,
		-1,
		100,
		95,
		68,
		56,
		62,
		58,
		44,
		50,
		50,
		43,
		33,
		30,
		26,
		17,
		31,
		23,
		55,
		-1,
		202,
		-1,
		136,
		-1,
		-1,
		118,
		98,
		90,
		79,
		68,
		66,
		57,
		48,
		70,
		74,
		24,
		12,
		17,
		22,
		-1,
		191,
		190,
		-1,
		137,
		129,
		115,
		-1,
		108,
		-1,
		114,
		75,
		-1,
		77,
		57,
		-1,
		0,
		12,
		-1,
		-1,
		178,
		153,
		-1,
		-1,
		-1,
		138,
		118,
		109,
		93,
		-1,
		68,
		68,
		-1,
		-1,
		-1,
		163,
		162,
		-1,
		131,
		134,
		-1,
		124,
		115,
		123,
		70,
		74,
		-1,
		-1,
		-1,
		172,
		153,
		147,
		146,
		144,
		139,
		136,
		122,
		106,
		84,
		73,
		94,
		-1,
		-1,
		-1,
		144,
		136,
		129,
		-1,
		-1,
		131,
		114,
		95,
		93,
		-1,
		-1,
		-1,
		166,
		147,
		-1,
		-1,
		121,
		-1,
		-1,
		127,
		92,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		155,
		-1,
		-1,
		-1,
		117,
		113,
		114,
		-1,
		-1,
		-1,
		-1,
		177,
		178,
		201,
		165,
		-1,
		-1,
		-1,
		109,
		103,
		-1,
		-1,
		180,
		178,
		-1,
		-1,
		-1,
		137,
		121,
		-1,
		107,
		-1,
		-1,
		-1,
		128,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		142,
		-1,
		142,
		117,
		124,
		-1,
		-1,
		-1,
		-1,
		155,
		147,
		155,
		-1,
		127,
		129,
		-1,
		177,
		-1,
		-1,
		170,
		161,
		-1,
		-1,
		132,
		139,
		161,
		164,
		200,
		-1,
		151
	],
	[
		-1,
		255,
		244,
		255,
		263,
		236,
		243,
		-1,
		262,
		266,
		232,
		226,
		265,
		234,
		240,
		251,
		-1,
		-1,
		-1,
		255,
		254,
		222,
		220,
		229,
		234,
		241,
		-1,
		240,
		-1,
		276,
		255,
		266,
		271,
		215,
		212,
		232,
		251,
		233,
		225,
		291,
		245,
		216,
		210,
		228,
		218,
		227,
		219,
		-1,
		216,
		206,
		228,
		207,
		218,
		210,
		-1,
		-1,
		210,
		211,
		217,
		203,
		209,
		205,
		-1,
		215,
		199,
		-1,
		-1,
		200,
		201,
		185,
		188,
		196,
		194,
		207,
		199,
		194,
		-1,
		-1,
		191,
		187,
		194,
		181,
		177,
		194,
		207,
		189,
		203,
		202,
		-1,
		195,
		213,
		220,
		188,
		186,
		170,
		168,
		186,
		188,
		194,
		194,
		-1,
		204,
		205,
		200,
		208,
		210,
		186,
		173,
		173,
		183,
		176,
		195,
		183,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		238,
		204,
		187,
		204,
		196,
		186,
		201,
		194,
		176,
		173,
		171,
		168,
		184,
		182,
		192,
		-1,
		-1,
		297,
		266,
		295,
		253,
		234,
		-1,
		200,
		180,
		186,
		190,
		184,
		177,
		191,
		187,
		-1,
		162,
		161,
		189,
		175,
		186,
		257,
		-1,
		-1,
		255,
		247,
		230,
		233,
		210,
		206,
		195,
		194,
		186,
		172,
		168,
		174,
		177,
		177,
		183,
		156,
		166,
		170,
		168,
		193,
		-1,
		-1,
		228,
		-1,
		-1,
		254,
		237,
		-1,
		220,
		227,
		216,
		222,
		208,
		229,
		205,
		196,
		188,
		182,
		170,
		172,
		169,
		182,
		170,
		153,
		178,
		182,
		163,
		184,
		179,
		-1,
		227,
		211,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		213,
		216,
		222,
		246,
		245,
		-1,
		217,
		205,
		206,
		191,
		188,
		175,
		163,
		176,
		161,
		168,
		167,
		157,
		155,
		185,
		160,
		182,
		179,
		198,
		203,
		197,
		206,
		-1,
		262,
		258,
		254,
		261,
		210,
		-1,
		-1,
		250,
		-1,
		253,
		254,
		229,
		202,
		205,
		192,
		183,
		170,
		159,
		170,
		159,
		156,
		164,
		149,
		164,
		155,
		154,
		172,
		182,
		190,
		194,
		200,
		-1,
		312,
		-1,
		254,
		238,
		240,
		212,
		233,
		-1,
		270,
		254,
		246,
		231,
		231,
		-1,
		201,
		198,
		188,
		166,
		151,
		168,
		160,
		158,
		162,
		144,
		158,
		149,
		167,
		174,
		172,
		176,
		196,
		208,
		272,
		262,
		-1,
		244,
		249,
		208,
		216,
		235,
		273,
		237,
		-1,
		232,
		-1,
		203,
		216,
		-1,
		172,
		168,
		150,
		151,
		146,
		161,
		155,
		140,
		137,
		155,
		158,
		165,
		169,
		185,
		-1,
		-1,
		257,
		261,
		250,
		201,
		220,
		244,
		281,
		230,
		219,
		218,
		-1,
		209,
		186,
		183,
		171,
		158,
		143,
		144,
		152,
		165,
		144,
		139,
		136,
		156,
		182,
		160,
		172,
		-1,
		-1,
		-1,
		282,
		-1,
		-1,
		227,
		198,
		222,
		264,
		248,
		241,
		229,
		194,
		194,
		188,
		-1,
		182,
		161,
		152,
		141,
		139,
		152,
		149,
		154,
		134,
		132,
		151,
		163,
		154,
		171,
		-1,
		-1,
		-1,
		257,
		246,
		247,
		193,
		216,
		253,
		227,
		213,
		218,
		193,
		186,
		180,
		195,
		178,
		159,
		148,
		140,
		129,
		145,
		153,
		148,
		130,
		139,
		145,
		169,
		159,
		165,
		-1,
		-1,
		264,
		254,
		238,
		240,
		237,
		207,
		214,
		246,
		218,
		231,
		-1,
		185,
		-1,
		174,
		169,
		153,
		148,
		145,
		142,
		136,
		145,
		147,
		137,
		132,
		139,
		174,
		174,
		149,
		169,
		172,
		-1,
		-1,
		-1,
		257,
		252,
		227,
		204,
		188,
		224,
		-1,
		201,
		202,
		-1,
		179,
		173,
		170,
		155,
		151,
		146,
		150,
		143,
		150,
		143,
		141,
		142,
		124,
		156,
		-1,
		157,
		151,
		159,
		149,
		137,
		-1,
		-1,
		-1,
		250,
		229,
		222,
		242,
		183,
		235,
		-1,
		-1,
		186,
		179,
		-1,
		166,
		148,
		155,
		153,
		147,
		151,
		148,
		137,
		150,
		143,
		129,
		131,
		144,
		148,
		152,
		139,
		135,
		132,
		146,
		-1,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		183,
		203,
		-1,
		195,
		187,
		177,
		171,
		165,
		161,
		159,
		175,
		159,
		162,
		160,
		151,
		159,
		132,
		125,
		132,
		121,
		139,
		147,
		139,
		133,
		132,
		142,
		-1,
		270,
		256,
		227,
		-1,
		-1,
		216,
		-1,
		180,
		194,
		210,
		-1,
		203,
		182,
		197,
		175,
		171,
		167,
		182,
		183,
		161,
		160,
		158,
		149,
		137,
		126,
		129,
		121,
		143,
		143,
		127,
		128,
		132,
		-1,
		276,
		263,
		221,
		217,
		206,
		226,
		177,
		165,
		197,
		-1,
		-1,
		239,
		-1,
		173,
		190,
		181,
		179,
		172,
		157,
		164,
		169,
		146,
		141,
		131,
		120,
		120,
		115,
		137,
		123,
		121,
		130,
		141,
		-1,
		-1,
		-1,
		243,
		-1,
		-1,
		192,
		179,
		173,
		-1,
		214,
		-1,
		217,
		207,
		191,
		176,
		209,
		-1,
		156,
		152,
		159,
		-1,
		166,
		-1,
		139,
		136,
		127,
		112,
		109,
		120,
		118,
		129,
		125,
		-1,
		226,
		211,
		204,
		194,
		208,
		179,
		-1,
		234,
		-1,
		-1,
		204,
		198,
		198,
		182,
		185,
		172,
		152,
		144,
		159,
		158,
		145,
		144,
		125,
		118,
		115,
		108,
		121,
		131,
		136,
		123,
		-1,
		-1,
		-1,
		231,
		217,
		221,
		181,
		200,
		-1,
		-1,
		266,
		221,
		207,
		-1,
		181,
		172,
		160,
		150,
		140,
		145,
		146,
		136,
		134,
		123,
		125,
		119,
		110,
		109,
		125,
		117,
		139,
		-1,
		-1,
		214,
		219,
		207,
		193,
		212,
		-1,
		-1,
		-1,
		213,
		229,
		200,
		179,
		161,
		-1,
		-1,
		144,
		137,
		131,
		134,
		122,
		139,
		134,
		118,
		103,
		118,
		122,
		130,
		121,
		-1,
		217,
		204,
		-1,
		-1,
		215,
		209,
		-1,
		-1,
		-1,
		-1,
		212,
		157,
		146,
		141,
		145,
		143,
		-1,
		117,
		128,
		121,
		140,
		147,
		120,
		105,
		99,
		105,
		117,
		126,
		-1,
		-1,
		229,
		-1,
		206,
		-1,
		-1,
		-1,
		-1,
		169,
		163,
		134,
		127,
		131,
		-1,
		119,
		121,
		118,
		130,
		123,
		120,
		111,
		102,
		98,
		102,
		106,
		113,
		119,
		252,
		-1,
		197,
		-1,
		-1,
		-1,
		187,
		202,
		173,
		150,
		123,
		118,
		111,
		105,
		110,
		121,
		130,
		141,
		106,
		105,
		95,
		94,
		98,
		115,
		115,
		-1,
		-1,
		195,
		191,
		213,
		195,
		199,
		200,
		-1,
		-1,
		127,
		118,
		109,
		101,
		114,
		117,
		102,
		104,
		104,
		99,
		93,
		103,
		114,
		109,
		-1,
		-1,
		-1,
		207,
		-1,
		209,
		-1,
		-1,
		197,
		198,
		145,
		127,
		123,
		121,
		110,
		104,
		92,
		97,
		107,
		101,
		98,
		89,
		89,
		112,
		101,
		107,
		-1,
		-1,
		279,
		-1,
		-1,
		-1,
		186,
		178,
		173,
		179,
		181,
		172,
		160,
		157,
		-1,
		127,
		133,
		98,
		105,
		88,
		95,
		100,
		97,
		83,
		86,
		102,
		101,
		94,
		99,
		90,
		98,
		-1,
		-1,
		272,
		261,
		250,
		256,
		-1,
		179,
		175,
		165,
		155,
		158,
		-1,
		-1,
		152,
		149,
		129,
		98,
		96,
		89,
		84,
		94,
		70,
		79,
		79,
		74,
		89,
		94,
		91,
		84,
		89,
		104,
		-1,
		226,
		263,
		256,
		224,
		232,
		263,
		-1,
		169,
		161,
		172,
		147,
		149,
		-1,
		-1,
		125,
		116,
		117,
		105,
		102,
		108,
		107,
		90,
		88,
		94,
		72,
		79,
		90,
		82,
		86,
		87,
		76,
		89,
		93,
		-1,
		219,
		239,
		218,
		221,
		245,
		259,
		-1,
		166,
		-1,
		-1,
		147,
		150,
		134,
		124,
		121,
		164,
		119,
		114,
		95,
		93,
		88,
		79,
		96,
		80,
		68,
		65,
		74,
		79,
		71,
		86,
		82,
		75,
		-1,
		208,
		219,
		212,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		137,
		-1,
		161,
		-1,
		144,
		148,
		127,
		130,
		109,
		96,
		82,
		83,
		89,
		80,
		76,
		72,
		61,
		63,
		75,
		79,
		89,
		91,
		233,
		189,
		192,
		203,
		214,
		229,
		233,
		-1,
		178,
		217,
		143,
		-1,
		127,
		-1,
		-1,
		-1,
		158,
		140,
		132,
		129,
		108,
		108,
		74,
		71,
		84,
		81,
		87,
		78,
		63,
		62,
		73,
		84,
		83,
		229,
		220,
		233,
		178,
		178,
		199,
		208,
		229,
		193,
		184,
		211,
		150,
		139,
		134,
		121,
		-1,
		-1,
		142,
		150,
		-1,
		-1,
		115,
		82,
		70,
		73,
		77,
		91,
		87,
		75,
		55,
		61,
		55,
		79,
		-1,
		222,
		221,
		210,
		207,
		183,
		174,
		169,
		196,
		-1,
		-1,
		191,
		212,
		202,
		183,
		181,
		206,
		-1,
		110,
		-1,
		-1,
		122,
		-1,
		-1,
		107,
		87,
		76,
		67,
		63,
		85,
		91,
		102,
		51,
		67,
		60,
		67,
		64,
		206,
		203,
		191,
		189,
		212,
		177,
		165,
		-1,
		178,
		176,
		182,
		189,
		184,
		195,
		-1,
		-1,
		126,
		106,
		-1,
		-1,
		105,
		103,
		92,
		-1,
		82,
		64,
		60,
		87,
		68,
		60,
		54,
		48,
		55,
		54,
		65,
		57,
		215,
		229,
		218,
		214,
		213,
		221,
		170,
		163,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		-1,
		116,
		112,
		-1,
		-1,
		100,
		93,
		81,
		69,
		59,
		69,
		60,
		56,
		56,
		51,
		46,
		57,
		44,
		48,
		51,
		-1,
		249,
		-1,
		201,
		167,
		173,
		188,
		196,
		-1,
		-1,
		-1,
		133,
		119,
		112,
		100,
		98,
		-1,
		134,
		118,
		99,
		-1,
		69,
		82,
		92,
		60,
		52,
		50,
		40,
		51,
		42,
		50,
		44,
		47,
		-1,
		-1,
		166,
		149,
		-1,
		-1,
		123,
		125,
		-1,
		124,
		113,
		98,
		90,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		56,
		74,
		63,
		58,
		54,
		36,
		48,
		44,
		40,
		50,
		41,
		-1,
		-1,
		144,
		136,
		130,
		-1,
		108,
		-1,
		126,
		-1,
		93,
		99,
		87,
		-1,
		-1,
		-1,
		87,
		50,
		66,
		69,
		50,
		48,
		39,
		32,
		39,
		42,
		35,
		41,
		-1,
		-1,
		-1,
		126,
		100,
		133,
		124,
		107,
		87,
		79,
		98,
		-1,
		68,
		-1,
		43,
		46,
		51,
		58,
		61,
		52,
		29,
		42,
		36,
		33,
		31,
		132,
		-1,
		102,
		135,
		99,
		93,
		69,
		73,
		89,
		-1,
		65,
		47,
		-1,
		58,
		45,
		67,
		42,
		38,
		25,
		19,
		20,
		28,
		-1,
		-1,
		-1,
		104,
		103,
		95,
		89,
		89,
		74,
		65,
		-1,
		77,
		59,
		38,
		53,
		38,
		29,
		29,
		57,
		53,
		41,
		39,
		13,
		-1,
		205,
		-1,
		-1,
		127,
		-1,
		-1,
		-1,
		98,
		93,
		66,
		54,
		60,
		56,
		42,
		48,
		48,
		41,
		31,
		28,
		24,
		15,
		21,
		12,
		44,
		-1,
		200,
		-1,
		134,
		-1,
		-1,
		116,
		96,
		88,
		77,
		66,
		64,
		55,
		46,
		68,
		72,
		22,
		10,
		6,
		11,
		-1,
		189,
		188,
		-1,
		135,
		127,
		113,
		-1,
		106,
		-1,
		112,
		73,
		-1,
		75,
		55,
		-1,
		14,
		0,
		-1,
		-1,
		176,
		151,
		-1,
		-1,
		-1,
		136,
		116,
		107,
		91,
		-1,
		66,
		66,
		-1,
		-1,
		-1,
		161,
		160,
		-1,
		129,
		132,
		-1,
		122,
		113,
		121,
		68,
		72,
		-1,
		-1,
		-1,
		170,
		151,
		145,
		144,
		142,
		137,
		134,
		120,
		104,
		82,
		71,
		92,
		-1,
		-1,
		-1,
		142,
		134,
		127,
		-1,
		-1,
		129,
		112,
		93,
		91,
		-1,
		-1,
		-1,
		164,
		145,
		-1,
		-1,
		119,
		-1,
		-1,
		125,
		90,
		-1,
		-1,
		-1,
		-1,
		-1,
		181,
		153,
		-1,
		-1,
		-1,
		115,
		111,
		112,
		-1,
		-1,
		-1,
		-1,
		175,
		176,
		199,
		163,
		-1,
		-1,
		-1,
		107,
		101,
		-1,
		-1,
		178,
		176,
		-1,
		-1,
		-1,
		135,
		119,
		-1,
		105,
		-1,
		-1,
		-1,
		126,
		-1,
		-1,
		138,
		-1,
		-1,
		-1,
		140,
		-1,
		140,
		115,
		122,
		-1,
		-1,
		-1,
		-1,
		153,
		145,
		153,
		-1,
		125,
		127,
		-1,
		175,
		-1,
		-1,
		168,
		159,
		-1,
		-1,
		130,
		137,
		159,
		162,
		198,
		-1,
		149
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		361,
		350,
		361,
		369,
		342,
		349,
		-1,
		368,
		372,
		338,
		332,
		371,
		340,
		346,
		357,
		-1,
		-1,
		-1,
		361,
		360,
		328,
		326,
		335,
		340,
		347,
		-1,
		346,
		-1,
		382,
		361,
		372,
		377,
		321,
		318,
		338,
		357,
		339,
		331,
		397,
		351,
		322,
		316,
		334,
		324,
		333,
		325,
		-1,
		322,
		312,
		334,
		313,
		324,
		316,
		-1,
		-1,
		316,
		317,
		323,
		309,
		315,
		311,
		-1,
		321,
		305,
		-1,
		-1,
		306,
		307,
		291,
		294,
		302,
		300,
		313,
		305,
		300,
		-1,
		-1,
		297,
		293,
		300,
		287,
		283,
		300,
		313,
		295,
		309,
		308,
		-1,
		301,
		319,
		326,
		294,
		292,
		276,
		274,
		292,
		294,
		300,
		300,
		-1,
		310,
		311,
		306,
		314,
		316,
		292,
		279,
		279,
		289,
		282,
		301,
		289,
		335,
		-1,
		-1,
		-1,
		-1,
		-1,
		344,
		310,
		293,
		310,
		302,
		292,
		307,
		300,
		282,
		279,
		277,
		274,
		290,
		288,
		298,
		-1,
		-1,
		403,
		372,
		401,
		359,
		340,
		-1,
		306,
		286,
		292,
		296,
		290,
		283,
		297,
		293,
		-1,
		268,
		267,
		295,
		281,
		292,
		363,
		-1,
		-1,
		361,
		353,
		336,
		339,
		316,
		312,
		301,
		300,
		292,
		278,
		274,
		280,
		283,
		283,
		289,
		262,
		272,
		276,
		274,
		299,
		-1,
		-1,
		334,
		-1,
		-1,
		360,
		343,
		-1,
		326,
		333,
		322,
		328,
		314,
		335,
		311,
		302,
		294,
		288,
		276,
		278,
		275,
		288,
		276,
		259,
		284,
		288,
		269,
		290,
		285,
		-1,
		333,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		338,
		319,
		322,
		328,
		352,
		351,
		-1,
		323,
		311,
		312,
		297,
		294,
		281,
		269,
		282,
		267,
		274,
		273,
		263,
		261,
		291,
		266,
		288,
		285,
		304,
		309,
		303,
		312,
		-1,
		368,
		364,
		360,
		367,
		316,
		-1,
		-1,
		356,
		-1,
		359,
		360,
		335,
		308,
		311,
		298,
		289,
		276,
		265,
		276,
		265,
		262,
		270,
		255,
		270,
		261,
		260,
		278,
		288,
		296,
		300,
		306,
		-1,
		418,
		-1,
		360,
		344,
		346,
		318,
		339,
		-1,
		376,
		360,
		352,
		337,
		337,
		-1,
		307,
		304,
		294,
		272,
		257,
		274,
		266,
		264,
		268,
		250,
		264,
		255,
		273,
		280,
		278,
		282,
		302,
		314,
		378,
		368,
		-1,
		350,
		355,
		314,
		322,
		341,
		379,
		343,
		-1,
		338,
		-1,
		309,
		322,
		-1,
		278,
		274,
		256,
		257,
		252,
		267,
		261,
		246,
		243,
		261,
		264,
		271,
		275,
		291,
		-1,
		-1,
		363,
		367,
		356,
		307,
		326,
		350,
		387,
		336,
		325,
		324,
		-1,
		315,
		292,
		289,
		277,
		264,
		249,
		250,
		258,
		271,
		250,
		245,
		242,
		262,
		288,
		266,
		278,
		-1,
		-1,
		-1,
		388,
		-1,
		-1,
		333,
		304,
		328,
		370,
		354,
		347,
		335,
		300,
		300,
		294,
		-1,
		288,
		267,
		258,
		247,
		245,
		258,
		255,
		260,
		240,
		238,
		257,
		269,
		260,
		277,
		-1,
		-1,
		-1,
		363,
		352,
		353,
		299,
		322,
		359,
		333,
		319,
		324,
		299,
		292,
		286,
		301,
		284,
		265,
		254,
		246,
		235,
		251,
		259,
		254,
		236,
		245,
		251,
		275,
		265,
		271,
		-1,
		-1,
		370,
		360,
		344,
		346,
		343,
		313,
		320,
		352,
		324,
		337,
		-1,
		291,
		-1,
		280,
		275,
		259,
		254,
		251,
		248,
		242,
		251,
		253,
		243,
		238,
		245,
		280,
		280,
		255,
		275,
		278,
		-1,
		-1,
		-1,
		363,
		358,
		333,
		310,
		294,
		330,
		-1,
		307,
		308,
		-1,
		285,
		279,
		276,
		261,
		257,
		252,
		256,
		249,
		256,
		249,
		247,
		248,
		230,
		262,
		-1,
		263,
		257,
		265,
		255,
		243,
		-1,
		-1,
		-1,
		356,
		335,
		328,
		348,
		289,
		341,
		-1,
		-1,
		292,
		285,
		-1,
		272,
		254,
		261,
		259,
		253,
		257,
		254,
		243,
		256,
		249,
		235,
		237,
		250,
		254,
		258,
		245,
		241,
		238,
		252,
		-1,
		375,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		309,
		-1,
		301,
		293,
		283,
		277,
		271,
		267,
		265,
		281,
		265,
		268,
		266,
		257,
		265,
		238,
		231,
		238,
		227,
		245,
		253,
		245,
		239,
		238,
		248,
		-1,
		376,
		362,
		333,
		-1,
		-1,
		322,
		-1,
		286,
		300,
		316,
		-1,
		309,
		288,
		303,
		281,
		277,
		273,
		288,
		289,
		266,
		266,
		264,
		255,
		243,
		232,
		235,
		227,
		249,
		249,
		233,
		234,
		238,
		-1,
		382,
		369,
		327,
		323,
		312,
		332,
		283,
		271,
		303,
		-1,
		-1,
		345,
		-1,
		279,
		296,
		287,
		285,
		278,
		260,
		267,
		275,
		252,
		247,
		237,
		226,
		226,
		221,
		243,
		229,
		227,
		236,
		252,
		-1,
		-1,
		-1,
		349,
		-1,
		-1,
		298,
		285,
		279,
		-1,
		320,
		-1,
		323,
		313,
		297,
		282,
		315,
		-1,
		259,
		255,
		262,
		-1,
		272,
		-1,
		245,
		242,
		233,
		218,
		215,
		226,
		224,
		235,
		231,
		-1,
		332,
		317,
		310,
		300,
		314,
		285,
		-1,
		340,
		-1,
		-1,
		310,
		304,
		304,
		288,
		289,
		275,
		255,
		247,
		262,
		261,
		248,
		247,
		231,
		224,
		221,
		214,
		227,
		237,
		242,
		229,
		-1,
		-1,
		-1,
		337,
		323,
		327,
		287,
		306,
		-1,
		-1,
		372,
		327,
		313,
		-1,
		284,
		275,
		263,
		253,
		243,
		248,
		249,
		239,
		237,
		229,
		231,
		225,
		216,
		215,
		231,
		223,
		245,
		-1,
		-1,
		320,
		325,
		313,
		299,
		317,
		-1,
		-1,
		-1,
		319,
		335,
		303,
		282,
		264,
		-1,
		-1,
		247,
		240,
		234,
		237,
		225,
		245,
		240,
		224,
		209,
		224,
		228,
		236,
		227,
		-1,
		323,
		310,
		-1,
		-1,
		316,
		306,
		-1,
		-1,
		-1,
		-1,
		315,
		260,
		249,
		244,
		248,
		246,
		-1,
		220,
		231,
		224,
		243,
		250,
		226,
		211,
		205,
		211,
		223,
		232,
		-1,
		-1,
		330,
		-1,
		292,
		-1,
		-1,
		-1,
		-1,
		272,
		266,
		237,
		230,
		234,
		-1,
		222,
		224,
		221,
		233,
		229,
		226,
		217,
		208,
		204,
		208,
		212,
		226,
		230,
		353,
		-1,
		283,
		-1,
		-1,
		-1,
		290,
		305,
		276,
		253,
		226,
		221,
		214,
		208,
		213,
		224,
		233,
		244,
		209,
		211,
		201,
		200,
		204,
		221,
		225,
		-1,
		-1,
		281,
		277,
		312,
		298,
		302,
		303,
		-1,
		-1,
		230,
		221,
		212,
		204,
		217,
		220,
		205,
		207,
		207,
		205,
		199,
		209,
		224,
		219,
		-1,
		-1,
		-1,
		293,
		-1,
		295,
		-1,
		-1,
		300,
		301,
		248,
		230,
		226,
		224,
		213,
		207,
		195,
		200,
		210,
		204,
		201,
		195,
		199,
		222,
		211,
		250,
		-1,
		-1,
		315,
		-1,
		-1,
		-1,
		277,
		264,
		259,
		282,
		284,
		275,
		263,
		260,
		-1,
		230,
		236,
		201,
		208,
		191,
		198,
		203,
		200,
		189,
		196,
		212,
		211,
		206,
		242,
		233,
		239,
		-1,
		-1,
		308,
		297,
		286,
		292,
		-1,
		270,
		261,
		268,
		258,
		261,
		-1,
		-1,
		255,
		252,
		232,
		201,
		199,
		192,
		187,
		197,
		173,
		185,
		189,
		193,
		199,
		204,
		209,
		215,
		230,
		245,
		-1,
		262,
		299,
		292,
		260,
		268,
		299,
		-1,
		260,
		252,
		258,
		250,
		252,
		-1,
		-1,
		228,
		219,
		220,
		208,
		205,
		211,
		210,
		193,
		199,
		200,
		192,
		191,
		209,
		213,
		222,
		229,
		219,
		232,
		236,
		-1,
		255,
		275,
		254,
		257,
		281,
		295,
		-1,
		251,
		-1,
		-1,
		218,
		253,
		237,
		227,
		224,
		267,
		222,
		217,
		198,
		196,
		191,
		182,
		207,
		200,
		200,
		203,
		218,
		223,
		215,
		229,
		229,
		230,
		-1,
		244,
		255,
		248,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		208,
		-1,
		264,
		-1,
		247,
		251,
		230,
		233,
		212,
		199,
		185,
		193,
		199,
		198,
		204,
		204,
		205,
		214,
		225,
		237,
		236,
		237,
		215,
		225,
		228,
		239,
		250,
		265,
		269,
		-1,
		235,
		271,
		214,
		-1,
		198,
		-1,
		-1,
		-1,
		261,
		243,
		235,
		232,
		211,
		211,
		177,
		181,
		194,
		201,
		211,
		222,
		214,
		218,
		231,
		242,
		245,
		211,
		216,
		269,
		214,
		214,
		235,
		244,
		265,
		231,
		228,
		265,
		221,
		210,
		205,
		192,
		-1,
		-1,
		245,
		253,
		-1,
		-1,
		218,
		185,
		173,
		183,
		187,
		201,
		213,
		226,
		214,
		219,
		213,
		245,
		-1,
		211,
		206,
		193,
		188,
		182,
		194,
		205,
		232,
		-1,
		-1,
		229,
		256,
		240,
		244,
		252,
		277,
		-1,
		176,
		-1,
		-1,
		225,
		-1,
		-1,
		210,
		190,
		179,
		170,
		175,
		195,
		206,
		228,
		210,
		227,
		218,
		228,
		232,
		195,
		188,
		176,
		178,
		184,
		213,
		201,
		-1,
		211,
		214,
		220,
		227,
		244,
		266,
		-1,
		-1,
		192,
		172,
		-1,
		-1,
		208,
		206,
		195,
		-1,
		185,
		167,
		172,
		202,
		204,
		206,
		213,
		207,
		214,
		222,
		233,
		225,
		204,
		214,
		203,
		176,
		185,
		198,
		206,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		182,
		178,
		-1,
		-1,
		203,
		196,
		184,
		172,
		162,
		172,
		189,
		189,
		192,
		197,
		205,
		216,
		212,
		216,
		219,
		-1,
		213,
		-1,
		237,
		200,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		199,
		185,
		178,
		166,
		164,
		-1,
		237,
		221,
		202,
		-1,
		172,
		185,
		225,
		193,
		198,
		193,
		208,
		219,
		210,
		218,
		212,
		215,
		-1,
		-1,
		199,
		182,
		-1,
		-1,
		156,
		158,
		-1,
		190,
		179,
		164,
		156,
		-1,
		-1,
		209,
		205,
		-1,
		-1,
		159,
		197,
		196,
		204,
		199,
		204,
		216,
		212,
		208,
		218,
		209,
		-1,
		-1,
		177,
		169,
		163,
		-1,
		141,
		-1,
		192,
		-1,
		159,
		168,
		156,
		-1,
		-1,
		-1,
		190,
		153,
		169,
		192,
		218,
		216,
		207,
		200,
		207,
		210,
		203,
		209,
		-1,
		-1,
		-1,
		138,
		133,
		199,
		190,
		173,
		153,
		145,
		167,
		-1,
		171,
		-1,
		146,
		149,
		174,
		213,
		215,
		201,
		197,
		210,
		204,
		201,
		199,
		132,
		-1,
		135,
		168,
		132,
		159,
		125,
		139,
		185,
		-1,
		168,
		150,
		-1,
		178,
		168,
		216,
		191,
		200,
		193,
		187,
		188,
		196,
		-1,
		-1,
		-1,
		137,
		136,
		128,
		122,
		122,
		120,
		137,
		-1,
		173,
		155,
		141,
		158,
		158,
		149,
		157,
		206,
		202,
		205,
		203,
		181,
		-1,
		30,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		131,
		115,
		128,
		139,
		142,
		138,
		138,
		140,
		153,
		161,
		159,
		156,
		168,
		164,
		184,
		180,
		212,
		-1,
		25,
		-1,
		167,
		-1,
		-1,
		93,
		99,
		109,
		120,
		148,
		148,
		137,
		133,
		150,
		185,
		171,
		169,
		174,
		179,
		-1,
		14,
		13,
		-1,
		57,
		67,
		88,
		-1,
		90,
		-1,
		194,
		155,
		-1,
		134,
		128,
		-1,
		180,
		176,
		-1,
		-1,
		0,
		46,
		-1,
		-1,
		-1,
		89,
		98,
		189,
		173,
		-1,
		118,
		125,
		-1,
		-1,
		-1,
		14,
		37,
		-1,
		82,
		85,
		-1,
		99,
		105,
		133,
		113,
		119,
		-1,
		-1,
		-1,
		41,
		25,
		30,
		72,
		67,
		90,
		130,
		116,
		116,
		100,
		110,
		139,
		-1,
		-1,
		-1,
		44,
		41,
		52,
		-1,
		-1,
		141,
		124,
		111,
		109,
		-1,
		-1,
		-1,
		66,
		47,
		-1,
		-1,
		61,
		-1,
		-1,
		106,
		85,
		-1,
		-1,
		-1,
		-1,
		-1,
		84,
		55,
		-1,
		-1,
		-1,
		62,
		69,
		90,
		-1,
		-1,
		-1,
		-1,
		81,
		82,
		101,
		76,
		-1,
		-1,
		-1,
		76,
		79,
		-1,
		-1,
		84,
		82,
		-1,
		-1,
		-1,
		104,
		88,
		-1,
		90,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		123,
		-1,
		-1,
		-1,
		109,
		-1,
		125,
		100,
		107,
		-1,
		-1,
		-1,
		-1,
		122,
		114,
		138,
		-1,
		110,
		112,
		-1,
		160,
		-1,
		-1,
		137,
		128,
		-1,
		-1,
		115,
		122,
		144,
		147,
		167,
		-1,
		134
	],
	[
		-1,
		337,
		326,
		337,
		345,
		318,
		325,
		-1,
		344,
		348,
		314,
		308,
		347,
		316,
		322,
		333,
		-1,
		-1,
		-1,
		337,
		336,
		304,
		302,
		311,
		316,
		323,
		-1,
		322,
		-1,
		358,
		337,
		348,
		353,
		297,
		294,
		314,
		333,
		315,
		307,
		373,
		327,
		298,
		292,
		310,
		300,
		309,
		301,
		-1,
		298,
		288,
		310,
		289,
		300,
		292,
		-1,
		-1,
		292,
		293,
		299,
		285,
		291,
		287,
		-1,
		297,
		281,
		-1,
		-1,
		282,
		283,
		267,
		270,
		278,
		276,
		289,
		281,
		276,
		-1,
		-1,
		273,
		269,
		276,
		263,
		259,
		276,
		289,
		271,
		285,
		284,
		-1,
		277,
		295,
		302,
		270,
		268,
		252,
		250,
		268,
		270,
		276,
		276,
		-1,
		286,
		287,
		282,
		290,
		292,
		268,
		255,
		255,
		265,
		258,
		277,
		265,
		311,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		286,
		269,
		286,
		278,
		268,
		283,
		276,
		258,
		255,
		253,
		250,
		266,
		264,
		274,
		-1,
		-1,
		379,
		348,
		377,
		335,
		316,
		-1,
		282,
		262,
		268,
		272,
		266,
		259,
		273,
		269,
		-1,
		244,
		243,
		271,
		257,
		268,
		339,
		-1,
		-1,
		337,
		329,
		312,
		315,
		292,
		288,
		277,
		276,
		268,
		254,
		250,
		256,
		259,
		259,
		265,
		238,
		248,
		252,
		250,
		275,
		-1,
		-1,
		310,
		-1,
		-1,
		336,
		319,
		-1,
		302,
		309,
		298,
		304,
		290,
		311,
		287,
		278,
		270,
		264,
		252,
		254,
		251,
		264,
		252,
		235,
		260,
		264,
		245,
		266,
		261,
		-1,
		309,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		295,
		298,
		304,
		328,
		327,
		-1,
		299,
		287,
		288,
		273,
		270,
		257,
		245,
		258,
		243,
		250,
		249,
		239,
		237,
		267,
		242,
		264,
		261,
		280,
		285,
		279,
		288,
		-1,
		344,
		340,
		336,
		343,
		292,
		-1,
		-1,
		332,
		-1,
		335,
		336,
		311,
		284,
		287,
		274,
		265,
		252,
		241,
		252,
		241,
		238,
		246,
		231,
		246,
		237,
		236,
		254,
		264,
		272,
		276,
		282,
		-1,
		394,
		-1,
		336,
		320,
		322,
		294,
		315,
		-1,
		352,
		336,
		328,
		313,
		313,
		-1,
		283,
		280,
		270,
		248,
		233,
		250,
		242,
		240,
		244,
		226,
		240,
		231,
		249,
		256,
		254,
		258,
		278,
		290,
		354,
		344,
		-1,
		326,
		331,
		290,
		298,
		317,
		355,
		319,
		-1,
		314,
		-1,
		285,
		298,
		-1,
		254,
		250,
		232,
		233,
		228,
		243,
		237,
		222,
		219,
		237,
		240,
		247,
		251,
		267,
		-1,
		-1,
		339,
		343,
		332,
		283,
		302,
		326,
		363,
		312,
		301,
		300,
		-1,
		291,
		268,
		265,
		253,
		240,
		225,
		226,
		234,
		247,
		226,
		221,
		218,
		238,
		264,
		242,
		254,
		-1,
		-1,
		-1,
		364,
		-1,
		-1,
		309,
		280,
		304,
		346,
		330,
		323,
		311,
		276,
		276,
		270,
		-1,
		264,
		243,
		234,
		223,
		221,
		234,
		231,
		236,
		216,
		214,
		233,
		245,
		236,
		253,
		-1,
		-1,
		-1,
		339,
		328,
		329,
		275,
		298,
		335,
		309,
		295,
		300,
		275,
		268,
		262,
		277,
		260,
		241,
		230,
		222,
		211,
		227,
		235,
		230,
		212,
		221,
		227,
		251,
		241,
		247,
		-1,
		-1,
		346,
		336,
		320,
		322,
		319,
		289,
		296,
		328,
		300,
		313,
		-1,
		267,
		-1,
		256,
		251,
		235,
		230,
		227,
		224,
		218,
		227,
		229,
		219,
		214,
		221,
		256,
		256,
		231,
		251,
		254,
		-1,
		-1,
		-1,
		339,
		334,
		309,
		286,
		270,
		306,
		-1,
		283,
		284,
		-1,
		261,
		255,
		252,
		237,
		233,
		228,
		232,
		225,
		232,
		225,
		223,
		224,
		206,
		238,
		-1,
		239,
		233,
		241,
		231,
		219,
		-1,
		-1,
		-1,
		332,
		311,
		304,
		324,
		265,
		317,
		-1,
		-1,
		268,
		261,
		-1,
		248,
		230,
		237,
		235,
		229,
		233,
		230,
		219,
		232,
		225,
		211,
		213,
		226,
		230,
		234,
		221,
		217,
		214,
		228,
		-1,
		351,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		285,
		-1,
		277,
		269,
		259,
		253,
		247,
		243,
		241,
		257,
		241,
		244,
		242,
		233,
		241,
		214,
		207,
		214,
		203,
		221,
		229,
		221,
		215,
		214,
		224,
		-1,
		352,
		338,
		309,
		-1,
		-1,
		298,
		-1,
		262,
		276,
		292,
		-1,
		285,
		264,
		279,
		257,
		253,
		249,
		264,
		265,
		242,
		242,
		240,
		231,
		219,
		208,
		211,
		203,
		225,
		225,
		209,
		210,
		214,
		-1,
		358,
		345,
		303,
		299,
		288,
		308,
		259,
		247,
		279,
		-1,
		-1,
		321,
		-1,
		255,
		272,
		263,
		261,
		254,
		236,
		243,
		251,
		228,
		223,
		213,
		202,
		202,
		197,
		219,
		205,
		203,
		212,
		228,
		-1,
		-1,
		-1,
		325,
		-1,
		-1,
		274,
		261,
		255,
		-1,
		296,
		-1,
		299,
		289,
		273,
		258,
		291,
		-1,
		235,
		231,
		238,
		-1,
		248,
		-1,
		221,
		218,
		209,
		194,
		191,
		202,
		200,
		211,
		207,
		-1,
		308,
		293,
		286,
		276,
		290,
		261,
		-1,
		316,
		-1,
		-1,
		286,
		280,
		280,
		264,
		265,
		251,
		231,
		223,
		238,
		237,
		224,
		223,
		207,
		200,
		197,
		190,
		203,
		213,
		218,
		205,
		-1,
		-1,
		-1,
		313,
		299,
		303,
		263,
		282,
		-1,
		-1,
		348,
		303,
		289,
		-1,
		260,
		251,
		239,
		229,
		219,
		224,
		225,
		215,
		213,
		205,
		207,
		201,
		192,
		191,
		207,
		199,
		221,
		-1,
		-1,
		296,
		301,
		289,
		275,
		277,
		-1,
		-1,
		-1,
		295,
		311,
		279,
		258,
		240,
		-1,
		-1,
		223,
		216,
		210,
		213,
		201,
		221,
		216,
		200,
		185,
		200,
		204,
		212,
		203,
		-1,
		299,
		286,
		-1,
		-1,
		276,
		266,
		-1,
		-1,
		-1,
		-1,
		291,
		236,
		225,
		220,
		224,
		222,
		-1,
		196,
		207,
		200,
		219,
		226,
		202,
		187,
		181,
		187,
		199,
		208,
		-1,
		-1,
		290,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		248,
		242,
		213,
		206,
		210,
		-1,
		198,
		200,
		197,
		209,
		205,
		202,
		193,
		184,
		180,
		184,
		188,
		202,
		206,
		313,
		-1,
		243,
		-1,
		-1,
		-1,
		266,
		281,
		252,
		229,
		202,
		197,
		190,
		184,
		189,
		200,
		209,
		220,
		185,
		187,
		177,
		176,
		180,
		197,
		201,
		-1,
		-1,
		241,
		237,
		272,
		274,
		278,
		279,
		-1,
		-1,
		206,
		197,
		188,
		180,
		193,
		196,
		181,
		183,
		183,
		181,
		175,
		185,
		200,
		195,
		-1,
		-1,
		-1,
		253,
		-1,
		255,
		-1,
		-1,
		274,
		277,
		224,
		206,
		202,
		200,
		189,
		183,
		171,
		176,
		186,
		180,
		177,
		171,
		175,
		198,
		187,
		226,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		235,
		224,
		219,
		253,
		258,
		249,
		239,
		236,
		-1,
		206,
		212,
		177,
		184,
		167,
		174,
		179,
		176,
		165,
		172,
		188,
		187,
		182,
		218,
		209,
		215,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		228,
		221,
		239,
		229,
		235,
		-1,
		-1,
		231,
		228,
		208,
		177,
		175,
		168,
		163,
		173,
		149,
		161,
		165,
		169,
		175,
		180,
		185,
		191,
		206,
		221,
		-1,
		222,
		259,
		252,
		220,
		228,
		259,
		-1,
		218,
		210,
		218,
		221,
		228,
		-1,
		-1,
		204,
		195,
		196,
		184,
		181,
		187,
		186,
		169,
		175,
		176,
		168,
		167,
		185,
		189,
		198,
		205,
		195,
		208,
		212,
		-1,
		215,
		235,
		214,
		217,
		241,
		255,
		-1,
		209,
		-1,
		-1,
		178,
		229,
		213,
		203,
		200,
		243,
		198,
		193,
		174,
		172,
		167,
		158,
		183,
		176,
		176,
		179,
		194,
		199,
		191,
		205,
		205,
		206,
		-1,
		204,
		215,
		208,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		168,
		-1,
		240,
		-1,
		223,
		227,
		206,
		209,
		188,
		175,
		161,
		169,
		175,
		174,
		180,
		180,
		181,
		190,
		201,
		213,
		212,
		213,
		229,
		185,
		188,
		199,
		210,
		225,
		229,
		-1,
		193,
		229,
		174,
		-1,
		158,
		-1,
		-1,
		-1,
		237,
		219,
		211,
		208,
		187,
		187,
		153,
		157,
		170,
		177,
		187,
		198,
		190,
		194,
		207,
		218,
		221,
		225,
		216,
		229,
		174,
		174,
		195,
		204,
		225,
		189,
		186,
		223,
		181,
		170,
		165,
		152,
		-1,
		-1,
		221,
		229,
		-1,
		-1,
		194,
		161,
		149,
		159,
		163,
		177,
		189,
		202,
		190,
		195,
		189,
		221,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		165,
		192,
		-1,
		-1,
		187,
		214,
		198,
		202,
		212,
		237,
		-1,
		136,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		166,
		155,
		146,
		151,
		171,
		182,
		204,
		186,
		203,
		194,
		204,
		208,
		202,
		199,
		187,
		185,
		208,
		173,
		161,
		-1,
		169,
		172,
		178,
		185,
		202,
		226,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		143,
		148,
		178,
		180,
		182,
		189,
		183,
		190,
		198,
		209,
		201,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		165,
		165,
		168,
		173,
		181,
		192,
		188,
		192,
		195,
		-1,
		245,
		-1,
		197,
		158,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		201,
		169,
		174,
		169,
		184,
		195,
		186,
		194,
		188,
		191,
		-1,
		-1,
		157,
		140,
		-1,
		-1,
		114,
		116,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		135,
		173,
		172,
		180,
		175,
		180,
		192,
		188,
		184,
		194,
		185,
		-1,
		-1,
		135,
		127,
		121,
		-1,
		99,
		-1,
		152,
		-1,
		119,
		126,
		114,
		-1,
		-1,
		-1,
		166,
		129,
		145,
		168,
		194,
		192,
		183,
		176,
		183,
		186,
		179,
		185,
		-1,
		-1,
		-1,
		117,
		91,
		159,
		150,
		133,
		113,
		105,
		125,
		-1,
		147,
		-1,
		122,
		125,
		150,
		189,
		191,
		177,
		173,
		186,
		180,
		177,
		175,
		123,
		-1,
		93,
		126,
		90,
		119,
		85,
		97,
		161,
		-1,
		144,
		126,
		-1,
		154,
		144,
		192,
		167,
		176,
		169,
		163,
		164,
		172,
		-1,
		-1,
		-1,
		95,
		94,
		86,
		80,
		80,
		78,
		96,
		-1,
		149,
		131,
		117,
		134,
		134,
		125,
		133,
		182,
		178,
		181,
		179,
		157,
		-1,
		76,
		-1,
		-1,
		118,
		-1,
		-1,
		-1,
		89,
		79,
		92,
		98,
		110,
		119,
		114,
		116,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		156,
		188,
		-1,
		71,
		-1,
		125,
		-1,
		-1,
		47,
		61,
		73,
		84,
		106,
		106,
		111,
		109,
		131,
		161,
		147,
		145,
		150,
		155,
		-1,
		60,
		59,
		-1,
		11,
		21,
		42,
		-1,
		59,
		-1,
		152,
		113,
		-1,
		130,
		118,
		-1,
		156,
		152,
		-1,
		-1,
		47,
		0,
		-1,
		-1,
		-1,
		85,
		72,
		147,
		131,
		-1,
		114,
		121,
		-1,
		-1,
		-1,
		32,
		9,
		-1,
		78,
		81,
		-1,
		79,
		85,
		114,
		109,
		115,
		-1,
		-1,
		-1,
		41,
		21,
		26,
		68,
		63,
		86,
		110,
		96,
		98,
		96,
		106,
		135,
		-1,
		-1,
		-1,
		40,
		37,
		48,
		-1,
		-1,
		123,
		106,
		106,
		105,
		-1,
		-1,
		-1,
		62,
		43,
		-1,
		-1,
		57,
		-1,
		-1,
		102,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		51,
		-1,
		-1,
		-1,
		58,
		65,
		86,
		-1,
		-1,
		-1,
		-1,
		77,
		78,
		97,
		72,
		-1,
		-1,
		-1,
		72,
		75,
		-1,
		-1,
		80,
		78,
		-1,
		-1,
		-1,
		100,
		84,
		-1,
		86,
		-1,
		-1,
		-1,
		91,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		105,
		-1,
		121,
		96,
		103,
		-1,
		-1,
		-1,
		-1,
		118,
		110,
		134,
		-1,
		106,
		108,
		-1,
		156,
		-1,
		-1,
		133,
		124,
		-1,
		-1,
		111,
		118,
		140,
		143,
		163,
		-1,
		130
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		327,
		316,
		327,
		335,
		308,
		315,
		-1,
		334,
		338,
		304,
		298,
		337,
		306,
		312,
		323,
		-1,
		-1,
		-1,
		327,
		326,
		294,
		292,
		301,
		306,
		313,
		-1,
		312,
		-1,
		348,
		327,
		338,
		343,
		287,
		284,
		304,
		323,
		305,
		297,
		363,
		317,
		288,
		282,
		300,
		290,
		299,
		291,
		-1,
		288,
		278,
		300,
		279,
		290,
		282,
		-1,
		-1,
		282,
		283,
		289,
		275,
		281,
		277,
		-1,
		287,
		271,
		-1,
		-1,
		272,
		273,
		257,
		260,
		268,
		266,
		279,
		271,
		266,
		-1,
		-1,
		263,
		259,
		266,
		253,
		249,
		266,
		279,
		261,
		275,
		274,
		-1,
		267,
		285,
		292,
		260,
		258,
		242,
		240,
		258,
		260,
		266,
		266,
		-1,
		276,
		277,
		272,
		280,
		282,
		258,
		245,
		245,
		255,
		248,
		267,
		255,
		301,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		276,
		259,
		276,
		268,
		258,
		273,
		266,
		248,
		245,
		243,
		240,
		256,
		254,
		264,
		-1,
		-1,
		369,
		338,
		367,
		325,
		306,
		-1,
		272,
		252,
		258,
		262,
		256,
		249,
		263,
		259,
		-1,
		234,
		233,
		261,
		247,
		258,
		329,
		-1,
		-1,
		327,
		319,
		302,
		305,
		282,
		278,
		267,
		266,
		258,
		244,
		240,
		246,
		249,
		249,
		255,
		228,
		238,
		242,
		240,
		265,
		-1,
		-1,
		300,
		-1,
		-1,
		326,
		309,
		-1,
		292,
		299,
		288,
		294,
		280,
		301,
		277,
		268,
		260,
		254,
		242,
		244,
		241,
		254,
		242,
		225,
		250,
		254,
		235,
		256,
		251,
		-1,
		299,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		285,
		288,
		294,
		318,
		317,
		-1,
		289,
		277,
		278,
		263,
		260,
		247,
		235,
		248,
		233,
		240,
		239,
		229,
		227,
		257,
		232,
		254,
		251,
		270,
		275,
		269,
		278,
		-1,
		334,
		330,
		326,
		333,
		282,
		-1,
		-1,
		322,
		-1,
		325,
		326,
		301,
		274,
		277,
		264,
		255,
		242,
		231,
		242,
		231,
		228,
		236,
		221,
		236,
		227,
		226,
		244,
		254,
		262,
		266,
		272,
		-1,
		384,
		-1,
		326,
		310,
		312,
		284,
		305,
		-1,
		342,
		326,
		318,
		303,
		303,
		-1,
		273,
		270,
		260,
		238,
		223,
		240,
		232,
		230,
		234,
		216,
		230,
		221,
		239,
		246,
		244,
		248,
		268,
		280,
		344,
		334,
		-1,
		316,
		321,
		280,
		288,
		307,
		345,
		309,
		-1,
		304,
		-1,
		275,
		288,
		-1,
		244,
		240,
		222,
		223,
		218,
		233,
		227,
		212,
		209,
		227,
		230,
		237,
		241,
		257,
		-1,
		-1,
		329,
		333,
		322,
		273,
		292,
		316,
		353,
		302,
		291,
		290,
		-1,
		281,
		258,
		255,
		243,
		230,
		215,
		216,
		224,
		237,
		216,
		211,
		208,
		228,
		254,
		232,
		244,
		-1,
		-1,
		-1,
		354,
		-1,
		-1,
		299,
		270,
		294,
		336,
		320,
		313,
		301,
		266,
		266,
		260,
		-1,
		254,
		233,
		224,
		213,
		211,
		224,
		221,
		226,
		206,
		204,
		223,
		235,
		226,
		243,
		-1,
		-1,
		-1,
		329,
		318,
		319,
		265,
		288,
		325,
		299,
		285,
		290,
		265,
		258,
		252,
		267,
		250,
		231,
		220,
		212,
		201,
		217,
		225,
		220,
		202,
		211,
		217,
		241,
		231,
		237,
		-1,
		-1,
		336,
		326,
		310,
		312,
		309,
		279,
		286,
		318,
		290,
		303,
		-1,
		257,
		-1,
		246,
		241,
		225,
		220,
		217,
		214,
		208,
		217,
		219,
		209,
		204,
		211,
		246,
		246,
		221,
		241,
		244,
		-1,
		-1,
		-1,
		329,
		324,
		299,
		276,
		260,
		296,
		-1,
		273,
		274,
		-1,
		251,
		245,
		242,
		227,
		223,
		218,
		222,
		215,
		222,
		215,
		213,
		214,
		196,
		228,
		-1,
		229,
		223,
		231,
		221,
		209,
		-1,
		-1,
		-1,
		322,
		301,
		294,
		314,
		255,
		307,
		-1,
		-1,
		258,
		251,
		-1,
		238,
		220,
		227,
		225,
		219,
		223,
		220,
		209,
		222,
		215,
		201,
		203,
		216,
		220,
		224,
		211,
		207,
		204,
		218,
		-1,
		341,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		275,
		-1,
		267,
		259,
		249,
		243,
		237,
		233,
		231,
		247,
		231,
		234,
		232,
		223,
		231,
		204,
		197,
		204,
		193,
		211,
		219,
		211,
		205,
		204,
		214,
		-1,
		342,
		328,
		299,
		-1,
		-1,
		288,
		-1,
		252,
		266,
		282,
		-1,
		275,
		254,
		269,
		247,
		243,
		239,
		254,
		255,
		232,
		232,
		230,
		221,
		209,
		198,
		201,
		193,
		215,
		215,
		199,
		200,
		204,
		-1,
		348,
		335,
		293,
		289,
		278,
		298,
		249,
		237,
		269,
		-1,
		-1,
		311,
		-1,
		245,
		262,
		253,
		251,
		244,
		226,
		233,
		241,
		218,
		213,
		203,
		192,
		192,
		187,
		209,
		195,
		193,
		202,
		218,
		-1,
		-1,
		-1,
		315,
		-1,
		-1,
		264,
		251,
		245,
		-1,
		286,
		-1,
		289,
		279,
		263,
		248,
		281,
		-1,
		225,
		221,
		228,
		-1,
		238,
		-1,
		211,
		208,
		199,
		184,
		181,
		192,
		190,
		201,
		197,
		-1,
		298,
		283,
		276,
		266,
		280,
		251,
		-1,
		306,
		-1,
		-1,
		276,
		270,
		270,
		254,
		255,
		241,
		221,
		213,
		228,
		227,
		214,
		213,
		197,
		190,
		187,
		180,
		193,
		203,
		208,
		195,
		-1,
		-1,
		-1,
		303,
		289,
		293,
		253,
		272,
		-1,
		-1,
		338,
		293,
		279,
		-1,
		250,
		241,
		229,
		219,
		209,
		214,
		215,
		205,
		203,
		195,
		197,
		191,
		182,
		181,
		197,
		189,
		211,
		-1,
		-1,
		286,
		291,
		279,
		265,
		266,
		-1,
		-1,
		-1,
		285,
		301,
		269,
		248,
		230,
		-1,
		-1,
		213,
		206,
		200,
		203,
		191,
		211,
		206,
		190,
		175,
		190,
		194,
		202,
		193,
		-1,
		289,
		276,
		-1,
		-1,
		265,
		255,
		-1,
		-1,
		-1,
		-1,
		281,
		226,
		215,
		210,
		214,
		212,
		-1,
		186,
		197,
		190,
		209,
		216,
		192,
		177,
		171,
		177,
		189,
		198,
		-1,
		-1,
		279,
		-1,
		241,
		-1,
		-1,
		-1,
		-1,
		238,
		232,
		203,
		196,
		200,
		-1,
		188,
		190,
		187,
		199,
		195,
		192,
		183,
		174,
		170,
		174,
		178,
		192,
		196,
		302,
		-1,
		232,
		-1,
		-1,
		-1,
		256,
		271,
		242,
		219,
		192,
		187,
		180,
		174,
		179,
		190,
		199,
		210,
		175,
		177,
		167,
		166,
		170,
		187,
		191,
		-1,
		-1,
		230,
		226,
		261,
		264,
		268,
		269,
		-1,
		-1,
		196,
		187,
		178,
		170,
		183,
		186,
		171,
		173,
		173,
		171,
		165,
		175,
		190,
		185,
		-1,
		-1,
		-1,
		242,
		-1,
		244,
		-1,
		-1,
		263,
		267,
		214,
		196,
		192,
		190,
		179,
		173,
		161,
		166,
		176,
		170,
		167,
		161,
		165,
		188,
		177,
		216,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		226,
		213,
		208,
		242,
		247,
		238,
		229,
		226,
		-1,
		196,
		202,
		167,
		174,
		157,
		164,
		169,
		166,
		155,
		162,
		178,
		177,
		172,
		208,
		199,
		205,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		219,
		210,
		228,
		218,
		224,
		-1,
		-1,
		221,
		218,
		198,
		167,
		165,
		158,
		153,
		163,
		139,
		151,
		155,
		159,
		165,
		170,
		175,
		181,
		196,
		211,
		-1,
		213,
		250,
		243,
		211,
		219,
		250,
		-1,
		209,
		201,
		207,
		210,
		218,
		-1,
		-1,
		194,
		185,
		186,
		174,
		171,
		177,
		176,
		159,
		165,
		166,
		158,
		157,
		175,
		179,
		188,
		195,
		185,
		198,
		202,
		-1,
		206,
		226,
		205,
		208,
		232,
		246,
		-1,
		200,
		-1,
		-1,
		167,
		219,
		203,
		193,
		190,
		233,
		188,
		183,
		164,
		162,
		157,
		148,
		173,
		166,
		166,
		169,
		184,
		189,
		181,
		195,
		195,
		196,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		-1,
		157,
		-1,
		230,
		-1,
		213,
		217,
		196,
		199,
		178,
		165,
		151,
		159,
		165,
		164,
		170,
		170,
		171,
		180,
		191,
		203,
		202,
		203,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		184,
		220,
		163,
		-1,
		147,
		-1,
		-1,
		-1,
		227,
		209,
		201,
		198,
		177,
		177,
		143,
		147,
		160,
		167,
		177,
		188,
		180,
		184,
		197,
		208,
		211,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		180,
		177,
		214,
		170,
		159,
		154,
		141,
		-1,
		-1,
		211,
		219,
		-1,
		-1,
		184,
		151,
		139,
		149,
		153,
		167,
		179,
		192,
		180,
		185,
		179,
		211,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		205,
		189,
		193,
		201,
		226,
		-1,
		125,
		-1,
		-1,
		191,
		-1,
		-1,
		176,
		156,
		145,
		136,
		141,
		161,
		172,
		194,
		176,
		193,
		184,
		194,
		198,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		160,
		163,
		169,
		176,
		193,
		215,
		-1,
		-1,
		141,
		121,
		-1,
		-1,
		174,
		172,
		161,
		-1,
		151,
		133,
		138,
		168,
		170,
		172,
		179,
		173,
		180,
		188,
		199,
		191,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		146,
		-1,
		131,
		127,
		-1,
		-1,
		169,
		162,
		150,
		138,
		128,
		138,
		155,
		155,
		158,
		163,
		171,
		182,
		178,
		182,
		185,
		-1,
		236,
		-1,
		188,
		149,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		148,
		134,
		127,
		115,
		113,
		-1,
		203,
		187,
		168,
		-1,
		138,
		151,
		191,
		159,
		164,
		159,
		174,
		185,
		176,
		184,
		178,
		181,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		139,
		128,
		113,
		105,
		-1,
		-1,
		175,
		171,
		-1,
		-1,
		125,
		163,
		162,
		170,
		165,
		170,
		182,
		178,
		174,
		184,
		175,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		141,
		-1,
		108,
		117,
		105,
		-1,
		-1,
		-1,
		156,
		119,
		135,
		158,
		184,
		182,
		173,
		166,
		173,
		176,
		169,
		175,
		-1,
		-1,
		-1,
		108,
		82,
		148,
		139,
		122,
		102,
		94,
		116,
		-1,
		137,
		-1,
		112,
		115,
		140,
		179,
		181,
		167,
		163,
		176,
		170,
		167,
		165,
		114,
		-1,
		84,
		117,
		81,
		108,
		74,
		88,
		151,
		-1,
		134,
		116,
		-1,
		144,
		134,
		182,
		157,
		166,
		159,
		153,
		154,
		162,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		71,
		69,
		86,
		-1,
		139,
		121,
		107,
		124,
		124,
		115,
		123,
		172,
		168,
		171,
		169,
		147,
		-1,
		120,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		64,
		77,
		88,
		101,
		109,
		104,
		106,
		119,
		127,
		125,
		122,
		134,
		130,
		150,
		146,
		178,
		-1,
		115,
		-1,
		116,
		-1,
		-1,
		61,
		48,
		58,
		69,
		97,
		97,
		101,
		99,
		121,
		151,
		137,
		135,
		140,
		145,
		-1,
		104,
		103,
		-1,
		80,
		72,
		58,
		-1,
		39,
		-1,
		143,
		104,
		-1,
		118,
		108,
		-1,
		146,
		142,
		-1,
		-1,
		91,
		86,
		-1,
		-1,
		-1,
		0,
		47,
		138,
		122,
		-1,
		102,
		109,
		-1,
		-1,
		-1,
		76,
		77,
		-1,
		27,
		30,
		-1,
		48,
		54,
		82,
		97,
		103,
		-1,
		-1,
		-1,
		85,
		66,
		60,
		42,
		47,
		35,
		79,
		65,
		65,
		82,
		94,
		123,
		-1,
		-1,
		-1,
		57,
		49,
		49,
		-1,
		-1,
		90,
		73,
		73,
		91,
		-1,
		-1,
		-1,
		79,
		60,
		-1,
		-1,
		58,
		-1,
		-1,
		86,
		82,
		-1,
		-1,
		-1,
		-1,
		-1,
		95,
		68,
		-1,
		-1,
		-1,
		59,
		66,
		87,
		-1,
		-1,
		-1,
		-1,
		89,
		90,
		114,
		89,
		-1,
		-1,
		-1,
		73,
		76,
		-1,
		-1,
		92,
		90,
		-1,
		-1,
		-1,
		101,
		85,
		-1,
		87,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		106,
		-1,
		122,
		97,
		104,
		-1,
		-1,
		-1,
		-1,
		119,
		111,
		135,
		-1,
		107,
		109,
		-1,
		157,
		-1,
		-1,
		134,
		125,
		-1,
		-1,
		112,
		119,
		141,
		144,
		164,
		-1,
		131
	],
	[
		-1,
		307,
		296,
		307,
		315,
		288,
		295,
		-1,
		314,
		318,
		284,
		278,
		317,
		286,
		292,
		303,
		-1,
		-1,
		-1,
		307,
		306,
		274,
		272,
		281,
		286,
		293,
		-1,
		292,
		-1,
		328,
		307,
		318,
		323,
		267,
		264,
		284,
		303,
		285,
		277,
		343,
		297,
		268,
		262,
		280,
		270,
		279,
		271,
		-1,
		268,
		258,
		280,
		259,
		270,
		262,
		-1,
		-1,
		262,
		263,
		269,
		255,
		261,
		257,
		-1,
		267,
		251,
		-1,
		-1,
		252,
		253,
		237,
		240,
		248,
		246,
		259,
		251,
		246,
		-1,
		-1,
		243,
		239,
		246,
		233,
		229,
		246,
		259,
		241,
		255,
		254,
		-1,
		247,
		265,
		272,
		240,
		238,
		222,
		220,
		238,
		240,
		246,
		246,
		-1,
		256,
		257,
		252,
		260,
		262,
		238,
		225,
		225,
		235,
		228,
		247,
		235,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		256,
		239,
		256,
		248,
		238,
		253,
		246,
		228,
		225,
		223,
		220,
		236,
		234,
		244,
		-1,
		-1,
		349,
		318,
		347,
		305,
		286,
		-1,
		252,
		232,
		238,
		242,
		236,
		229,
		243,
		239,
		-1,
		214,
		213,
		241,
		227,
		238,
		309,
		-1,
		-1,
		307,
		299,
		282,
		285,
		262,
		258,
		247,
		246,
		238,
		224,
		220,
		226,
		229,
		229,
		235,
		208,
		218,
		222,
		220,
		245,
		-1,
		-1,
		280,
		-1,
		-1,
		306,
		289,
		-1,
		272,
		279,
		268,
		274,
		260,
		281,
		257,
		248,
		240,
		234,
		222,
		224,
		221,
		234,
		222,
		205,
		230,
		234,
		215,
		236,
		231,
		-1,
		279,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		265,
		268,
		274,
		298,
		297,
		-1,
		269,
		257,
		258,
		243,
		240,
		227,
		215,
		228,
		213,
		220,
		219,
		209,
		207,
		237,
		212,
		234,
		231,
		250,
		255,
		249,
		258,
		-1,
		314,
		310,
		306,
		313,
		262,
		-1,
		-1,
		302,
		-1,
		305,
		306,
		281,
		254,
		257,
		244,
		235,
		222,
		211,
		222,
		211,
		208,
		216,
		201,
		216,
		207,
		206,
		224,
		234,
		242,
		246,
		252,
		-1,
		364,
		-1,
		306,
		290,
		292,
		264,
		285,
		-1,
		322,
		306,
		298,
		283,
		283,
		-1,
		253,
		250,
		240,
		218,
		203,
		220,
		212,
		210,
		214,
		196,
		210,
		201,
		219,
		226,
		224,
		228,
		248,
		260,
		324,
		314,
		-1,
		296,
		301,
		260,
		268,
		287,
		325,
		289,
		-1,
		284,
		-1,
		255,
		268,
		-1,
		224,
		220,
		202,
		203,
		198,
		213,
		207,
		192,
		189,
		207,
		210,
		217,
		221,
		237,
		-1,
		-1,
		309,
		313,
		302,
		253,
		272,
		296,
		333,
		282,
		271,
		270,
		-1,
		261,
		238,
		235,
		223,
		210,
		195,
		196,
		204,
		217,
		196,
		191,
		188,
		208,
		234,
		212,
		224,
		-1,
		-1,
		-1,
		334,
		-1,
		-1,
		279,
		250,
		274,
		316,
		300,
		293,
		281,
		246,
		246,
		240,
		-1,
		234,
		213,
		204,
		193,
		191,
		204,
		201,
		206,
		186,
		184,
		203,
		215,
		206,
		223,
		-1,
		-1,
		-1,
		309,
		298,
		299,
		245,
		268,
		305,
		279,
		265,
		270,
		245,
		238,
		232,
		247,
		230,
		211,
		200,
		192,
		181,
		197,
		205,
		200,
		182,
		191,
		197,
		221,
		211,
		217,
		-1,
		-1,
		316,
		306,
		290,
		292,
		289,
		259,
		266,
		298,
		270,
		283,
		-1,
		237,
		-1,
		226,
		221,
		205,
		200,
		197,
		194,
		188,
		197,
		199,
		189,
		184,
		191,
		226,
		226,
		201,
		221,
		224,
		-1,
		-1,
		-1,
		309,
		304,
		279,
		256,
		240,
		276,
		-1,
		253,
		254,
		-1,
		231,
		225,
		222,
		207,
		203,
		198,
		202,
		195,
		202,
		195,
		193,
		194,
		176,
		208,
		-1,
		209,
		203,
		211,
		201,
		189,
		-1,
		-1,
		-1,
		302,
		281,
		274,
		294,
		235,
		287,
		-1,
		-1,
		238,
		231,
		-1,
		218,
		200,
		207,
		205,
		199,
		203,
		200,
		189,
		202,
		195,
		181,
		183,
		196,
		200,
		204,
		191,
		187,
		184,
		198,
		-1,
		321,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		255,
		-1,
		247,
		239,
		229,
		223,
		217,
		213,
		211,
		227,
		211,
		214,
		212,
		203,
		211,
		184,
		177,
		184,
		173,
		191,
		199,
		191,
		185,
		184,
		194,
		-1,
		322,
		308,
		279,
		-1,
		-1,
		268,
		-1,
		232,
		246,
		262,
		-1,
		255,
		234,
		249,
		227,
		223,
		219,
		234,
		235,
		212,
		212,
		210,
		201,
		189,
		178,
		181,
		173,
		195,
		195,
		179,
		180,
		184,
		-1,
		328,
		315,
		273,
		269,
		258,
		278,
		229,
		217,
		249,
		-1,
		-1,
		291,
		-1,
		225,
		242,
		233,
		231,
		224,
		206,
		213,
		221,
		198,
		193,
		183,
		172,
		172,
		167,
		189,
		175,
		173,
		182,
		198,
		-1,
		-1,
		-1,
		295,
		-1,
		-1,
		244,
		231,
		225,
		-1,
		266,
		-1,
		269,
		259,
		243,
		228,
		261,
		-1,
		205,
		201,
		208,
		-1,
		218,
		-1,
		191,
		188,
		179,
		164,
		161,
		172,
		170,
		181,
		177,
		-1,
		278,
		263,
		256,
		246,
		260,
		231,
		-1,
		286,
		-1,
		-1,
		256,
		250,
		250,
		234,
		235,
		221,
		201,
		193,
		208,
		207,
		194,
		193,
		177,
		170,
		167,
		160,
		173,
		183,
		188,
		175,
		-1,
		-1,
		-1,
		283,
		269,
		273,
		233,
		252,
		-1,
		-1,
		318,
		273,
		259,
		-1,
		230,
		221,
		209,
		199,
		189,
		194,
		195,
		185,
		183,
		175,
		177,
		171,
		162,
		161,
		177,
		169,
		191,
		-1,
		-1,
		266,
		271,
		259,
		245,
		253,
		-1,
		-1,
		-1,
		265,
		281,
		249,
		228,
		210,
		-1,
		-1,
		193,
		186,
		180,
		183,
		171,
		191,
		186,
		170,
		155,
		170,
		174,
		182,
		173,
		-1,
		269,
		256,
		-1,
		-1,
		252,
		242,
		-1,
		-1,
		-1,
		-1,
		261,
		206,
		195,
		190,
		194,
		192,
		-1,
		166,
		177,
		170,
		189,
		196,
		172,
		157,
		151,
		157,
		169,
		178,
		-1,
		-1,
		266,
		-1,
		228,
		-1,
		-1,
		-1,
		-1,
		218,
		212,
		183,
		176,
		180,
		-1,
		168,
		170,
		167,
		179,
		175,
		172,
		163,
		154,
		150,
		154,
		158,
		172,
		176,
		289,
		-1,
		219,
		-1,
		-1,
		-1,
		236,
		251,
		222,
		199,
		172,
		167,
		160,
		154,
		159,
		170,
		179,
		190,
		155,
		157,
		147,
		146,
		150,
		167,
		171,
		-1,
		-1,
		217,
		213,
		248,
		244,
		248,
		249,
		-1,
		-1,
		176,
		167,
		158,
		150,
		163,
		166,
		151,
		153,
		153,
		151,
		145,
		155,
		170,
		165,
		-1,
		-1,
		-1,
		229,
		-1,
		231,
		-1,
		-1,
		246,
		247,
		194,
		176,
		172,
		170,
		159,
		153,
		141,
		146,
		156,
		150,
		147,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		251,
		-1,
		-1,
		-1,
		211,
		200,
		195,
		228,
		230,
		221,
		209,
		206,
		-1,
		176,
		182,
		147,
		154,
		137,
		144,
		149,
		146,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		244,
		233,
		222,
		228,
		-1,
		204,
		197,
		214,
		204,
		207,
		-1,
		-1,
		201,
		198,
		178,
		147,
		145,
		138,
		133,
		143,
		119,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		198,
		235,
		228,
		196,
		204,
		235,
		-1,
		194,
		186,
		194,
		196,
		198,
		-1,
		-1,
		174,
		165,
		166,
		154,
		151,
		157,
		156,
		139,
		145,
		146,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		191,
		211,
		190,
		193,
		217,
		231,
		-1,
		185,
		-1,
		-1,
		154,
		199,
		183,
		173,
		170,
		213,
		168,
		163,
		144,
		142,
		137,
		128,
		153,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		180,
		191,
		184,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		-1,
		144,
		-1,
		210,
		-1,
		193,
		197,
		176,
		179,
		158,
		145,
		131,
		139,
		145,
		144,
		150,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		205,
		161,
		164,
		175,
		186,
		201,
		205,
		-1,
		169,
		205,
		150,
		-1,
		134,
		-1,
		-1,
		-1,
		207,
		189,
		181,
		178,
		157,
		157,
		123,
		127,
		140,
		147,
		157,
		168,
		160,
		164,
		177,
		188,
		191,
		201,
		192,
		205,
		150,
		150,
		171,
		180,
		201,
		165,
		162,
		199,
		157,
		146,
		141,
		128,
		-1,
		-1,
		191,
		199,
		-1,
		-1,
		164,
		131,
		119,
		129,
		133,
		147,
		159,
		172,
		160,
		165,
		159,
		191,
		-1,
		194,
		193,
		182,
		179,
		155,
		146,
		141,
		168,
		-1,
		-1,
		163,
		190,
		174,
		178,
		188,
		213,
		-1,
		112,
		-1,
		-1,
		171,
		-1,
		-1,
		156,
		136,
		125,
		116,
		121,
		141,
		152,
		174,
		156,
		173,
		164,
		174,
		178,
		178,
		175,
		163,
		161,
		184,
		149,
		137,
		-1,
		145,
		148,
		154,
		161,
		178,
		202,
		-1,
		-1,
		128,
		108,
		-1,
		-1,
		154,
		152,
		141,
		-1,
		131,
		113,
		118,
		148,
		150,
		152,
		159,
		153,
		160,
		168,
		179,
		171,
		187,
		201,
		190,
		186,
		185,
		193,
		142,
		135,
		142,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		118,
		114,
		-1,
		-1,
		149,
		142,
		130,
		118,
		108,
		118,
		135,
		135,
		138,
		143,
		151,
		162,
		158,
		162,
		165,
		-1,
		221,
		-1,
		173,
		134,
		140,
		155,
		163,
		-1,
		-1,
		-1,
		135,
		121,
		114,
		102,
		100,
		-1,
		183,
		167,
		148,
		-1,
		118,
		131,
		171,
		139,
		144,
		139,
		154,
		165,
		156,
		164,
		158,
		161,
		-1,
		-1,
		133,
		116,
		-1,
		-1,
		90,
		92,
		-1,
		126,
		115,
		100,
		92,
		-1,
		-1,
		155,
		151,
		-1,
		-1,
		105,
		143,
		142,
		150,
		145,
		150,
		162,
		158,
		154,
		164,
		155,
		-1,
		-1,
		111,
		103,
		97,
		-1,
		75,
		-1,
		128,
		-1,
		95,
		102,
		90,
		-1,
		-1,
		-1,
		136,
		99,
		115,
		138,
		164,
		162,
		153,
		146,
		153,
		156,
		149,
		155,
		-1,
		-1,
		-1,
		93,
		67,
		135,
		126,
		109,
		89,
		81,
		101,
		-1,
		117,
		-1,
		92,
		95,
		120,
		159,
		161,
		147,
		143,
		156,
		150,
		147,
		145,
		99,
		-1,
		69,
		102,
		66,
		95,
		61,
		73,
		131,
		-1,
		114,
		96,
		-1,
		124,
		114,
		162,
		137,
		146,
		139,
		133,
		134,
		142,
		-1,
		-1,
		-1,
		71,
		70,
		62,
		56,
		56,
		54,
		72,
		-1,
		119,
		101,
		87,
		104,
		104,
		95,
		103,
		152,
		148,
		151,
		149,
		127,
		-1,
		132,
		-1,
		-1,
		94,
		-1,
		-1,
		-1,
		65,
		44,
		57,
		73,
		81,
		84,
		84,
		86,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		126,
		158,
		-1,
		127,
		-1,
		101,
		-1,
		-1,
		45,
		28,
		38,
		49,
		77,
		77,
		82,
		79,
		96,
		131,
		117,
		115,
		120,
		125,
		-1,
		116,
		115,
		-1,
		64,
		56,
		42,
		-1,
		23,
		-1,
		123,
		84,
		-1,
		80,
		74,
		-1,
		126,
		122,
		-1,
		-1,
		103,
		80,
		-1,
		-1,
		-1,
		48,
		0,
		118,
		102,
		-1,
		64,
		71,
		-1,
		-1,
		-1,
		88,
		89,
		-1,
		41,
		44,
		-1,
		7,
		13,
		42,
		59,
		65,
		-1,
		-1,
		-1,
		97,
		78,
		72,
		56,
		61,
		49,
		38,
		24,
		27,
		44,
		56,
		85,
		-1,
		-1,
		-1,
		69,
		61,
		61,
		-1,
		-1,
		52,
		35,
		35,
		53,
		-1,
		-1,
		-1,
		91,
		72,
		-1,
		-1,
		70,
		-1,
		-1,
		48,
		54,
		-1,
		-1,
		-1,
		-1,
		-1,
		107,
		80,
		-1,
		-1,
		-1,
		71,
		75,
		59,
		-1,
		-1,
		-1,
		-1,
		101,
		102,
		126,
		101,
		-1,
		-1,
		-1,
		71,
		65,
		-1,
		-1,
		104,
		102,
		-1,
		-1,
		-1,
		99,
		83,
		-1,
		69,
		-1,
		-1,
		-1,
		90,
		-1,
		-1,
		102,
		-1,
		-1,
		-1,
		104,
		-1,
		104,
		79,
		86,
		-1,
		-1,
		-1,
		-1,
		117,
		109,
		117,
		-1,
		89,
		91,
		-1,
		139,
		-1,
		-1,
		132,
		123,
		-1,
		-1,
		94,
		101,
		123,
		126,
		162,
		-1,
		113
	],
	[
		-1,
		291,
		280,
		291,
		299,
		272,
		279,
		-1,
		298,
		302,
		268,
		262,
		301,
		270,
		276,
		287,
		-1,
		-1,
		-1,
		291,
		290,
		258,
		256,
		265,
		270,
		277,
		-1,
		276,
		-1,
		312,
		291,
		302,
		307,
		251,
		248,
		268,
		287,
		269,
		261,
		327,
		281,
		252,
		246,
		264,
		254,
		263,
		255,
		-1,
		252,
		242,
		264,
		243,
		254,
		246,
		-1,
		-1,
		246,
		247,
		253,
		239,
		245,
		241,
		-1,
		251,
		235,
		-1,
		-1,
		236,
		237,
		221,
		224,
		232,
		230,
		243,
		235,
		230,
		-1,
		-1,
		227,
		223,
		230,
		217,
		213,
		230,
		243,
		225,
		239,
		238,
		-1,
		231,
		249,
		256,
		224,
		222,
		206,
		204,
		222,
		224,
		230,
		230,
		-1,
		240,
		241,
		236,
		244,
		246,
		222,
		209,
		209,
		219,
		212,
		231,
		219,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		240,
		223,
		240,
		232,
		222,
		237,
		230,
		212,
		209,
		207,
		204,
		220,
		218,
		228,
		-1,
		-1,
		333,
		302,
		331,
		289,
		270,
		-1,
		236,
		216,
		222,
		226,
		220,
		213,
		227,
		223,
		-1,
		198,
		197,
		225,
		211,
		222,
		293,
		-1,
		-1,
		291,
		283,
		266,
		269,
		246,
		242,
		231,
		230,
		222,
		208,
		204,
		210,
		213,
		213,
		219,
		192,
		202,
		206,
		204,
		229,
		-1,
		-1,
		264,
		-1,
		-1,
		290,
		273,
		-1,
		256,
		263,
		252,
		258,
		244,
		265,
		241,
		232,
		224,
		218,
		206,
		208,
		205,
		218,
		206,
		189,
		214,
		218,
		199,
		220,
		215,
		-1,
		263,
		247,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		268,
		249,
		252,
		258,
		282,
		281,
		-1,
		253,
		241,
		242,
		227,
		224,
		211,
		199,
		212,
		197,
		204,
		203,
		193,
		191,
		221,
		196,
		218,
		215,
		234,
		239,
		233,
		242,
		-1,
		298,
		294,
		290,
		297,
		246,
		-1,
		-1,
		286,
		-1,
		289,
		290,
		265,
		238,
		241,
		228,
		219,
		206,
		195,
		206,
		195,
		192,
		200,
		185,
		200,
		191,
		190,
		208,
		218,
		226,
		230,
		236,
		-1,
		348,
		-1,
		290,
		274,
		276,
		248,
		269,
		-1,
		306,
		290,
		282,
		267,
		267,
		-1,
		237,
		234,
		224,
		202,
		187,
		204,
		196,
		194,
		198,
		180,
		194,
		185,
		203,
		210,
		208,
		212,
		232,
		244,
		308,
		298,
		-1,
		280,
		285,
		244,
		252,
		271,
		309,
		273,
		-1,
		268,
		-1,
		239,
		252,
		-1,
		208,
		204,
		186,
		187,
		182,
		197,
		191,
		176,
		173,
		191,
		194,
		201,
		205,
		221,
		-1,
		-1,
		293,
		297,
		286,
		237,
		256,
		280,
		317,
		266,
		255,
		254,
		-1,
		245,
		222,
		219,
		207,
		194,
		179,
		180,
		188,
		201,
		180,
		175,
		172,
		192,
		218,
		196,
		208,
		-1,
		-1,
		-1,
		318,
		-1,
		-1,
		263,
		234,
		258,
		300,
		284,
		277,
		265,
		230,
		230,
		224,
		-1,
		218,
		197,
		188,
		177,
		175,
		188,
		185,
		190,
		170,
		168,
		187,
		199,
		190,
		207,
		-1,
		-1,
		-1,
		293,
		282,
		283,
		229,
		252,
		289,
		263,
		249,
		254,
		229,
		222,
		216,
		231,
		214,
		195,
		184,
		176,
		165,
		181,
		189,
		184,
		166,
		175,
		181,
		205,
		195,
		201,
		-1,
		-1,
		300,
		290,
		274,
		276,
		273,
		243,
		250,
		282,
		254,
		267,
		-1,
		221,
		-1,
		210,
		205,
		189,
		184,
		181,
		178,
		172,
		181,
		183,
		173,
		168,
		175,
		210,
		210,
		185,
		205,
		208,
		-1,
		-1,
		-1,
		293,
		288,
		263,
		240,
		224,
		260,
		-1,
		237,
		238,
		-1,
		215,
		209,
		206,
		191,
		187,
		182,
		186,
		179,
		186,
		179,
		177,
		178,
		160,
		192,
		-1,
		193,
		187,
		195,
		185,
		173,
		-1,
		-1,
		-1,
		286,
		265,
		258,
		278,
		219,
		271,
		-1,
		-1,
		222,
		215,
		-1,
		202,
		184,
		191,
		189,
		183,
		187,
		184,
		173,
		186,
		179,
		165,
		167,
		180,
		184,
		188,
		175,
		171,
		168,
		182,
		-1,
		305,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		239,
		-1,
		231,
		223,
		213,
		207,
		201,
		197,
		195,
		211,
		195,
		198,
		196,
		187,
		195,
		168,
		161,
		168,
		157,
		175,
		183,
		175,
		169,
		168,
		178,
		-1,
		306,
		292,
		263,
		-1,
		-1,
		252,
		-1,
		216,
		230,
		246,
		-1,
		239,
		218,
		233,
		211,
		207,
		203,
		218,
		219,
		196,
		196,
		194,
		185,
		173,
		162,
		165,
		157,
		179,
		179,
		163,
		164,
		168,
		-1,
		312,
		299,
		257,
		253,
		242,
		262,
		213,
		201,
		233,
		-1,
		-1,
		275,
		-1,
		209,
		226,
		217,
		215,
		208,
		190,
		197,
		205,
		182,
		177,
		167,
		156,
		156,
		151,
		173,
		159,
		157,
		166,
		182,
		-1,
		-1,
		-1,
		279,
		-1,
		-1,
		228,
		215,
		209,
		-1,
		250,
		-1,
		253,
		243,
		227,
		212,
		245,
		-1,
		189,
		185,
		192,
		-1,
		202,
		-1,
		175,
		172,
		163,
		148,
		145,
		156,
		154,
		165,
		161,
		-1,
		262,
		247,
		240,
		230,
		244,
		215,
		-1,
		270,
		-1,
		-1,
		240,
		234,
		234,
		218,
		219,
		205,
		185,
		177,
		192,
		191,
		178,
		177,
		161,
		154,
		151,
		144,
		157,
		167,
		172,
		159,
		-1,
		-1,
		-1,
		267,
		253,
		257,
		217,
		236,
		-1,
		-1,
		302,
		257,
		243,
		-1,
		214,
		205,
		193,
		183,
		173,
		178,
		179,
		169,
		167,
		159,
		161,
		155,
		146,
		145,
		161,
		153,
		175,
		-1,
		-1,
		250,
		255,
		243,
		229,
		244,
		-1,
		-1,
		-1,
		249,
		265,
		233,
		212,
		194,
		-1,
		-1,
		177,
		170,
		164,
		167,
		155,
		175,
		170,
		154,
		139,
		154,
		158,
		166,
		157,
		-1,
		253,
		240,
		-1,
		-1,
		243,
		233,
		-1,
		-1,
		-1,
		-1,
		245,
		190,
		179,
		174,
		178,
		176,
		-1,
		150,
		161,
		154,
		173,
		180,
		156,
		141,
		135,
		141,
		153,
		162,
		-1,
		-1,
		257,
		-1,
		219,
		-1,
		-1,
		-1,
		-1,
		202,
		196,
		167,
		160,
		164,
		-1,
		152,
		154,
		151,
		163,
		159,
		156,
		147,
		138,
		134,
		138,
		142,
		156,
		160,
		280,
		-1,
		210,
		-1,
		-1,
		-1,
		220,
		235,
		206,
		183,
		156,
		151,
		144,
		138,
		143,
		154,
		163,
		174,
		139,
		141,
		131,
		130,
		134,
		151,
		155,
		-1,
		-1,
		208,
		204,
		239,
		228,
		232,
		233,
		-1,
		-1,
		160,
		151,
		142,
		134,
		147,
		150,
		135,
		137,
		137,
		135,
		129,
		139,
		154,
		149,
		-1,
		-1,
		-1,
		220,
		-1,
		222,
		-1,
		-1,
		230,
		231,
		178,
		160,
		156,
		154,
		143,
		137,
		125,
		130,
		140,
		134,
		131,
		125,
		129,
		152,
		141,
		180,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		219,
		191,
		186,
		212,
		214,
		205,
		193,
		190,
		-1,
		160,
		166,
		131,
		138,
		121,
		128,
		133,
		130,
		119,
		126,
		142,
		141,
		136,
		172,
		163,
		169,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		212,
		188,
		198,
		188,
		191,
		-1,
		-1,
		185,
		182,
		162,
		131,
		129,
		122,
		117,
		127,
		103,
		115,
		119,
		123,
		129,
		134,
		139,
		145,
		160,
		175,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		202,
		194,
		185,
		180,
		182,
		-1,
		-1,
		158,
		149,
		150,
		138,
		135,
		141,
		140,
		123,
		129,
		130,
		122,
		121,
		139,
		143,
		152,
		159,
		149,
		162,
		166,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		199,
		-1,
		-1,
		145,
		183,
		167,
		157,
		154,
		197,
		152,
		147,
		128,
		126,
		121,
		112,
		137,
		130,
		130,
		133,
		148,
		153,
		145,
		159,
		159,
		160,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		-1,
		135,
		-1,
		194,
		-1,
		177,
		181,
		160,
		163,
		142,
		129,
		115,
		123,
		129,
		128,
		134,
		134,
		135,
		144,
		155,
		167,
		166,
		167,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		194,
		230,
		141,
		-1,
		125,
		-1,
		-1,
		-1,
		191,
		173,
		165,
		162,
		141,
		141,
		107,
		111,
		124,
		131,
		141,
		152,
		144,
		148,
		161,
		172,
		175,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		187,
		224,
		148,
		137,
		132,
		119,
		-1,
		-1,
		175,
		183,
		-1,
		-1,
		148,
		115,
		103,
		113,
		117,
		131,
		143,
		156,
		144,
		149,
		143,
		175,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		215,
		199,
		181,
		179,
		204,
		-1,
		108,
		-1,
		-1,
		155,
		-1,
		-1,
		140,
		120,
		109,
		100,
		105,
		125,
		136,
		158,
		140,
		157,
		148,
		158,
		162,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		170,
		173,
		179,
		186,
		182,
		193,
		-1,
		-1,
		124,
		104,
		-1,
		-1,
		138,
		136,
		125,
		-1,
		115,
		97,
		102,
		132,
		134,
		136,
		143,
		137,
		144,
		152,
		163,
		155,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		-1,
		114,
		110,
		-1,
		-1,
		133,
		126,
		114,
		102,
		92,
		102,
		119,
		119,
		122,
		127,
		135,
		146,
		142,
		146,
		149,
		-1,
		246,
		-1,
		198,
		159,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		131,
		117,
		110,
		98,
		96,
		-1,
		167,
		151,
		132,
		-1,
		102,
		115,
		155,
		123,
		128,
		123,
		138,
		149,
		140,
		148,
		142,
		145,
		-1,
		-1,
		158,
		141,
		-1,
		-1,
		115,
		117,
		-1,
		122,
		111,
		96,
		88,
		-1,
		-1,
		139,
		135,
		-1,
		-1,
		89,
		127,
		126,
		134,
		129,
		134,
		146,
		142,
		138,
		148,
		139,
		-1,
		-1,
		136,
		128,
		122,
		-1,
		100,
		-1,
		124,
		-1,
		91,
		89,
		77,
		-1,
		-1,
		-1,
		120,
		83,
		99,
		122,
		148,
		146,
		137,
		130,
		137,
		140,
		133,
		139,
		-1,
		-1,
		-1,
		118,
		92,
		131,
		122,
		105,
		85,
		77,
		88,
		-1,
		101,
		-1,
		76,
		79,
		104,
		143,
		145,
		131,
		127,
		140,
		134,
		131,
		129,
		124,
		-1,
		94,
		127,
		91,
		91,
		67,
		65,
		115,
		-1,
		98,
		80,
		-1,
		108,
		98,
		146,
		121,
		130,
		123,
		117,
		118,
		126,
		-1,
		-1,
		-1,
		96,
		95,
		87,
		81,
		81,
		72,
		55,
		-1,
		103,
		85,
		71,
		88,
		88,
		79,
		87,
		136,
		132,
		135,
		133,
		111,
		-1,
		212,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		90,
		83,
		56,
		52,
		60,
		73,
		68,
		70,
		83,
		91,
		89,
		86,
		98,
		94,
		114,
		110,
		142,
		-1,
		207,
		-1,
		126,
		-1,
		-1,
		108,
		88,
		78,
		67,
		53,
		56,
		61,
		63,
		85,
		115,
		101,
		99,
		104,
		109,
		-1,
		196,
		195,
		-1,
		127,
		119,
		105,
		-1,
		98,
		-1,
		5,
		33,
		-1,
		92,
		72,
		-1,
		110,
		106,
		-1,
		-1,
		183,
		143,
		-1,
		-1,
		-1,
		128,
		108,
		0,
		14,
		-1,
		83,
		83,
		-1,
		-1,
		-1,
		168,
		152,
		-1,
		121,
		124,
		-1,
		115,
		121,
		138,
		85,
		89,
		-1,
		-1,
		-1,
		177,
		158,
		152,
		136,
		141,
		129,
		146,
		132,
		121,
		99,
		88,
		109,
		-1,
		-1,
		-1,
		149,
		141,
		141,
		-1,
		-1,
		146,
		129,
		110,
		108,
		-1,
		-1,
		-1,
		171,
		152,
		-1,
		-1,
		136,
		-1,
		-1,
		142,
		107,
		-1,
		-1,
		-1,
		-1,
		-1,
		187,
		160,
		-1,
		-1,
		-1,
		132,
		128,
		129,
		-1,
		-1,
		-1,
		-1,
		181,
		182,
		206,
		180,
		-1,
		-1,
		-1,
		124,
		118,
		-1,
		-1,
		184,
		182,
		-1,
		-1,
		-1,
		152,
		136,
		-1,
		122,
		-1,
		-1,
		-1,
		143,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		157,
		-1,
		157,
		132,
		139,
		-1,
		-1,
		-1,
		-1,
		170,
		162,
		170,
		-1,
		142,
		144,
		-1,
		192,
		-1,
		-1,
		185,
		176,
		-1,
		-1,
		147,
		154,
		176,
		179,
		215,
		-1,
		166
	],
	[
		-1,
		277,
		266,
		277,
		285,
		258,
		265,
		-1,
		284,
		288,
		254,
		248,
		287,
		256,
		262,
		273,
		-1,
		-1,
		-1,
		277,
		276,
		244,
		242,
		251,
		256,
		263,
		-1,
		262,
		-1,
		298,
		277,
		288,
		293,
		237,
		234,
		254,
		273,
		255,
		247,
		313,
		267,
		238,
		232,
		250,
		240,
		249,
		241,
		-1,
		238,
		228,
		250,
		229,
		240,
		232,
		-1,
		-1,
		232,
		233,
		239,
		225,
		231,
		227,
		-1,
		237,
		221,
		-1,
		-1,
		222,
		223,
		207,
		210,
		218,
		216,
		229,
		221,
		216,
		-1,
		-1,
		213,
		209,
		216,
		203,
		199,
		216,
		229,
		211,
		225,
		224,
		-1,
		217,
		235,
		242,
		210,
		208,
		192,
		190,
		208,
		210,
		216,
		216,
		-1,
		226,
		227,
		222,
		230,
		232,
		208,
		195,
		195,
		205,
		198,
		217,
		205,
		251,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		226,
		209,
		226,
		218,
		208,
		223,
		216,
		198,
		195,
		193,
		190,
		206,
		204,
		214,
		-1,
		-1,
		319,
		288,
		317,
		275,
		256,
		-1,
		222,
		202,
		208,
		212,
		206,
		199,
		213,
		209,
		-1,
		184,
		183,
		211,
		197,
		208,
		279,
		-1,
		-1,
		277,
		269,
		252,
		255,
		232,
		228,
		217,
		216,
		208,
		194,
		190,
		196,
		199,
		199,
		205,
		178,
		188,
		192,
		190,
		215,
		-1,
		-1,
		250,
		-1,
		-1,
		276,
		259,
		-1,
		242,
		249,
		238,
		244,
		230,
		251,
		227,
		218,
		210,
		204,
		192,
		194,
		191,
		204,
		192,
		175,
		200,
		204,
		185,
		206,
		201,
		-1,
		249,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		254,
		235,
		238,
		244,
		268,
		267,
		-1,
		239,
		227,
		228,
		213,
		210,
		197,
		185,
		198,
		183,
		190,
		189,
		179,
		177,
		207,
		182,
		204,
		201,
		220,
		225,
		219,
		228,
		-1,
		284,
		280,
		276,
		283,
		232,
		-1,
		-1,
		272,
		-1,
		275,
		276,
		251,
		224,
		227,
		214,
		205,
		192,
		181,
		192,
		181,
		178,
		186,
		171,
		186,
		177,
		176,
		194,
		204,
		212,
		216,
		222,
		-1,
		334,
		-1,
		276,
		260,
		262,
		234,
		255,
		-1,
		292,
		276,
		268,
		253,
		253,
		-1,
		223,
		220,
		210,
		188,
		173,
		190,
		182,
		180,
		184,
		166,
		180,
		171,
		189,
		196,
		194,
		198,
		218,
		230,
		294,
		284,
		-1,
		266,
		271,
		230,
		238,
		257,
		295,
		259,
		-1,
		254,
		-1,
		225,
		238,
		-1,
		194,
		190,
		172,
		173,
		168,
		183,
		177,
		162,
		159,
		177,
		180,
		187,
		191,
		207,
		-1,
		-1,
		279,
		283,
		272,
		223,
		242,
		266,
		303,
		252,
		241,
		240,
		-1,
		231,
		208,
		205,
		193,
		180,
		165,
		166,
		174,
		187,
		166,
		161,
		158,
		178,
		204,
		182,
		194,
		-1,
		-1,
		-1,
		304,
		-1,
		-1,
		249,
		220,
		244,
		286,
		270,
		263,
		251,
		216,
		216,
		210,
		-1,
		204,
		183,
		174,
		163,
		161,
		174,
		171,
		176,
		156,
		154,
		173,
		185,
		176,
		193,
		-1,
		-1,
		-1,
		279,
		268,
		269,
		215,
		238,
		275,
		249,
		235,
		240,
		215,
		208,
		202,
		217,
		200,
		181,
		170,
		162,
		151,
		167,
		175,
		170,
		152,
		161,
		167,
		191,
		181,
		187,
		-1,
		-1,
		286,
		276,
		260,
		262,
		259,
		229,
		236,
		268,
		240,
		253,
		-1,
		207,
		-1,
		196,
		191,
		175,
		170,
		167,
		164,
		158,
		167,
		169,
		159,
		154,
		161,
		196,
		196,
		171,
		191,
		194,
		-1,
		-1,
		-1,
		279,
		274,
		249,
		226,
		210,
		246,
		-1,
		223,
		224,
		-1,
		201,
		195,
		192,
		177,
		173,
		168,
		172,
		165,
		172,
		165,
		163,
		164,
		146,
		178,
		-1,
		179,
		173,
		181,
		171,
		159,
		-1,
		-1,
		-1,
		272,
		251,
		244,
		264,
		205,
		257,
		-1,
		-1,
		208,
		201,
		-1,
		188,
		170,
		177,
		175,
		169,
		173,
		170,
		159,
		172,
		165,
		151,
		153,
		166,
		170,
		174,
		161,
		157,
		154,
		168,
		-1,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		205,
		225,
		-1,
		217,
		209,
		199,
		193,
		187,
		183,
		181,
		197,
		181,
		184,
		182,
		173,
		181,
		154,
		147,
		154,
		143,
		161,
		169,
		161,
		155,
		154,
		164,
		-1,
		292,
		278,
		249,
		-1,
		-1,
		238,
		-1,
		202,
		216,
		232,
		-1,
		225,
		204,
		219,
		197,
		193,
		189,
		204,
		205,
		182,
		182,
		180,
		171,
		159,
		148,
		151,
		143,
		165,
		165,
		149,
		150,
		154,
		-1,
		298,
		285,
		243,
		239,
		228,
		248,
		199,
		187,
		219,
		-1,
		-1,
		261,
		-1,
		195,
		212,
		203,
		201,
		194,
		176,
		183,
		191,
		168,
		163,
		153,
		142,
		142,
		137,
		159,
		145,
		143,
		152,
		168,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		214,
		201,
		195,
		-1,
		236,
		-1,
		239,
		229,
		213,
		198,
		231,
		-1,
		175,
		171,
		178,
		-1,
		188,
		-1,
		161,
		158,
		149,
		134,
		131,
		142,
		140,
		151,
		147,
		-1,
		248,
		233,
		226,
		216,
		230,
		201,
		-1,
		256,
		-1,
		-1,
		226,
		220,
		220,
		204,
		205,
		191,
		171,
		163,
		178,
		177,
		164,
		163,
		147,
		140,
		137,
		130,
		143,
		153,
		158,
		145,
		-1,
		-1,
		-1,
		253,
		239,
		243,
		203,
		222,
		-1,
		-1,
		288,
		243,
		229,
		-1,
		200,
		191,
		179,
		169,
		159,
		164,
		165,
		155,
		153,
		145,
		147,
		141,
		132,
		131,
		147,
		139,
		161,
		-1,
		-1,
		236,
		241,
		229,
		215,
		230,
		-1,
		-1,
		-1,
		235,
		251,
		219,
		198,
		180,
		-1,
		-1,
		163,
		156,
		150,
		153,
		141,
		161,
		156,
		140,
		125,
		140,
		144,
		152,
		143,
		-1,
		239,
		226,
		-1,
		-1,
		229,
		219,
		-1,
		-1,
		-1,
		-1,
		231,
		176,
		165,
		160,
		164,
		162,
		-1,
		136,
		147,
		140,
		159,
		166,
		142,
		127,
		121,
		127,
		139,
		148,
		-1,
		-1,
		243,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		188,
		182,
		153,
		146,
		150,
		-1,
		138,
		140,
		137,
		149,
		145,
		142,
		133,
		124,
		120,
		124,
		128,
		142,
		146,
		266,
		-1,
		196,
		-1,
		-1,
		-1,
		206,
		221,
		192,
		169,
		142,
		137,
		130,
		124,
		129,
		140,
		149,
		160,
		125,
		127,
		117,
		116,
		120,
		137,
		141,
		-1,
		-1,
		194,
		190,
		225,
		214,
		218,
		219,
		-1,
		-1,
		146,
		137,
		128,
		120,
		133,
		136,
		121,
		123,
		123,
		121,
		115,
		125,
		140,
		135,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		216,
		217,
		164,
		146,
		142,
		140,
		129,
		123,
		111,
		116,
		126,
		120,
		117,
		111,
		115,
		138,
		127,
		166,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		205,
		177,
		172,
		198,
		200,
		191,
		179,
		176,
		-1,
		146,
		152,
		117,
		124,
		107,
		114,
		119,
		116,
		105,
		112,
		128,
		127,
		122,
		158,
		149,
		155,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		198,
		174,
		184,
		174,
		177,
		-1,
		-1,
		171,
		168,
		148,
		117,
		115,
		108,
		103,
		113,
		89,
		101,
		105,
		109,
		115,
		120,
		125,
		131,
		146,
		161,
		-1,
		209,
		246,
		239,
		207,
		215,
		246,
		-1,
		188,
		180,
		171,
		166,
		168,
		-1,
		-1,
		144,
		135,
		136,
		124,
		121,
		127,
		126,
		109,
		115,
		116,
		108,
		107,
		125,
		129,
		138,
		145,
		135,
		148,
		152,
		-1,
		202,
		222,
		201,
		204,
		228,
		242,
		-1,
		185,
		-1,
		-1,
		131,
		169,
		153,
		143,
		140,
		183,
		138,
		133,
		114,
		112,
		107,
		98,
		123,
		116,
		116,
		119,
		134,
		139,
		131,
		145,
		145,
		146,
		-1,
		191,
		202,
		195,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		121,
		-1,
		180,
		-1,
		163,
		167,
		146,
		149,
		128,
		115,
		101,
		109,
		115,
		114,
		120,
		120,
		121,
		130,
		141,
		153,
		152,
		153,
		216,
		172,
		175,
		186,
		197,
		212,
		216,
		-1,
		180,
		216,
		127,
		-1,
		111,
		-1,
		-1,
		-1,
		177,
		159,
		151,
		148,
		127,
		127,
		93,
		97,
		110,
		117,
		127,
		138,
		130,
		134,
		147,
		158,
		161,
		212,
		203,
		216,
		161,
		161,
		182,
		191,
		212,
		176,
		173,
		210,
		134,
		123,
		118,
		105,
		-1,
		-1,
		161,
		169,
		-1,
		-1,
		134,
		101,
		89,
		99,
		103,
		117,
		129,
		142,
		130,
		135,
		129,
		161,
		-1,
		205,
		204,
		193,
		190,
		166,
		157,
		152,
		179,
		-1,
		-1,
		174,
		201,
		185,
		167,
		165,
		190,
		-1,
		94,
		-1,
		-1,
		141,
		-1,
		-1,
		126,
		106,
		95,
		86,
		91,
		111,
		122,
		144,
		126,
		143,
		134,
		144,
		148,
		189,
		186,
		174,
		172,
		195,
		160,
		148,
		-1,
		156,
		159,
		165,
		172,
		168,
		179,
		-1,
		-1,
		110,
		90,
		-1,
		-1,
		124,
		122,
		111,
		-1,
		101,
		83,
		88,
		118,
		120,
		122,
		129,
		123,
		130,
		138,
		149,
		141,
		198,
		212,
		201,
		197,
		196,
		204,
		153,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		100,
		96,
		-1,
		-1,
		119,
		112,
		100,
		88,
		78,
		88,
		105,
		105,
		108,
		113,
		121,
		132,
		128,
		132,
		135,
		-1,
		232,
		-1,
		184,
		145,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		117,
		103,
		96,
		84,
		82,
		-1,
		153,
		137,
		118,
		-1,
		88,
		101,
		141,
		109,
		114,
		109,
		124,
		135,
		126,
		134,
		128,
		131,
		-1,
		-1,
		144,
		127,
		-1,
		-1,
		101,
		103,
		-1,
		108,
		97,
		82,
		74,
		-1,
		-1,
		125,
		121,
		-1,
		-1,
		75,
		113,
		112,
		120,
		115,
		120,
		132,
		128,
		124,
		134,
		125,
		-1,
		-1,
		122,
		114,
		108,
		-1,
		86,
		-1,
		110,
		-1,
		77,
		75,
		63,
		-1,
		-1,
		-1,
		106,
		69,
		85,
		108,
		134,
		132,
		123,
		116,
		123,
		126,
		119,
		125,
		-1,
		-1,
		-1,
		104,
		78,
		117,
		108,
		91,
		71,
		63,
		74,
		-1,
		87,
		-1,
		62,
		65,
		90,
		129,
		131,
		117,
		113,
		126,
		120,
		117,
		115,
		110,
		-1,
		80,
		113,
		77,
		77,
		53,
		51,
		101,
		-1,
		84,
		66,
		-1,
		94,
		84,
		132,
		107,
		116,
		109,
		103,
		104,
		112,
		-1,
		-1,
		-1,
		82,
		81,
		73,
		67,
		67,
		58,
		41,
		-1,
		89,
		71,
		57,
		74,
		74,
		65,
		73,
		122,
		118,
		121,
		119,
		97,
		-1,
		198,
		-1,
		-1,
		105,
		-1,
		-1,
		-1,
		76,
		69,
		42,
		38,
		46,
		59,
		54,
		56,
		69,
		77,
		75,
		72,
		84,
		80,
		100,
		96,
		128,
		-1,
		193,
		-1,
		112,
		-1,
		-1,
		94,
		74,
		64,
		53,
		39,
		42,
		47,
		49,
		71,
		101,
		87,
		85,
		90,
		95,
		-1,
		182,
		181,
		-1,
		113,
		105,
		91,
		-1,
		84,
		-1,
		21,
		19,
		-1,
		78,
		58,
		-1,
		96,
		92,
		-1,
		-1,
		169,
		129,
		-1,
		-1,
		-1,
		114,
		94,
		16,
		0,
		-1,
		69,
		69,
		-1,
		-1,
		-1,
		154,
		138,
		-1,
		107,
		110,
		-1,
		101,
		107,
		124,
		71,
		75,
		-1,
		-1,
		-1,
		163,
		144,
		138,
		122,
		127,
		115,
		132,
		118,
		107,
		85,
		74,
		95,
		-1,
		-1,
		-1,
		135,
		127,
		127,
		-1,
		-1,
		132,
		115,
		96,
		94,
		-1,
		-1,
		-1,
		157,
		138,
		-1,
		-1,
		122,
		-1,
		-1,
		128,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		146,
		-1,
		-1,
		-1,
		118,
		114,
		115,
		-1,
		-1,
		-1,
		-1,
		167,
		168,
		192,
		166,
		-1,
		-1,
		-1,
		110,
		104,
		-1,
		-1,
		170,
		168,
		-1,
		-1,
		-1,
		138,
		122,
		-1,
		108,
		-1,
		-1,
		-1,
		129,
		-1,
		-1,
		141,
		-1,
		-1,
		-1,
		143,
		-1,
		143,
		118,
		125,
		-1,
		-1,
		-1,
		-1,
		156,
		148,
		156,
		-1,
		128,
		130,
		-1,
		178,
		-1,
		-1,
		171,
		162,
		-1,
		-1,
		133,
		140,
		162,
		165,
		201,
		-1,
		152
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		251,
		240,
		251,
		259,
		232,
		239,
		-1,
		258,
		262,
		228,
		222,
		261,
		230,
		236,
		247,
		-1,
		-1,
		-1,
		251,
		250,
		218,
		216,
		225,
		230,
		237,
		-1,
		236,
		-1,
		272,
		251,
		262,
		267,
		211,
		208,
		228,
		247,
		229,
		221,
		287,
		241,
		212,
		206,
		224,
		214,
		223,
		215,
		-1,
		212,
		202,
		224,
		203,
		214,
		206,
		-1,
		-1,
		206,
		207,
		213,
		199,
		205,
		201,
		-1,
		211,
		195,
		-1,
		-1,
		196,
		197,
		181,
		184,
		192,
		190,
		203,
		195,
		190,
		-1,
		-1,
		187,
		183,
		190,
		177,
		173,
		190,
		203,
		185,
		199,
		198,
		-1,
		191,
		209,
		216,
		184,
		182,
		166,
		164,
		182,
		184,
		190,
		190,
		-1,
		200,
		201,
		196,
		204,
		206,
		182,
		169,
		169,
		179,
		172,
		191,
		179,
		225,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		200,
		183,
		200,
		192,
		182,
		197,
		190,
		172,
		169,
		167,
		164,
		180,
		178,
		188,
		-1,
		-1,
		293,
		262,
		291,
		249,
		230,
		-1,
		196,
		176,
		182,
		186,
		180,
		173,
		187,
		183,
		-1,
		158,
		157,
		185,
		171,
		182,
		253,
		-1,
		-1,
		251,
		243,
		226,
		229,
		206,
		202,
		191,
		190,
		182,
		168,
		164,
		170,
		173,
		173,
		179,
		152,
		162,
		166,
		164,
		189,
		-1,
		-1,
		224,
		-1,
		-1,
		250,
		233,
		-1,
		216,
		223,
		212,
		218,
		204,
		225,
		201,
		192,
		184,
		178,
		166,
		168,
		165,
		178,
		166,
		149,
		174,
		178,
		159,
		180,
		175,
		-1,
		223,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		228,
		209,
		212,
		218,
		242,
		241,
		-1,
		213,
		201,
		202,
		187,
		184,
		171,
		159,
		172,
		157,
		164,
		163,
		153,
		151,
		181,
		156,
		178,
		175,
		194,
		199,
		193,
		202,
		-1,
		258,
		254,
		250,
		257,
		206,
		-1,
		-1,
		246,
		-1,
		249,
		250,
		225,
		198,
		201,
		188,
		179,
		166,
		155,
		166,
		155,
		152,
		160,
		145,
		160,
		151,
		150,
		168,
		178,
		186,
		190,
		196,
		-1,
		308,
		-1,
		250,
		234,
		236,
		208,
		229,
		-1,
		266,
		250,
		242,
		227,
		227,
		-1,
		197,
		194,
		184,
		162,
		147,
		164,
		156,
		154,
		158,
		140,
		154,
		145,
		163,
		170,
		168,
		172,
		192,
		204,
		268,
		258,
		-1,
		240,
		245,
		204,
		212,
		231,
		269,
		233,
		-1,
		228,
		-1,
		199,
		212,
		-1,
		168,
		164,
		146,
		147,
		142,
		157,
		151,
		136,
		133,
		151,
		154,
		161,
		165,
		181,
		-1,
		-1,
		253,
		257,
		246,
		197,
		216,
		240,
		277,
		226,
		215,
		214,
		-1,
		205,
		182,
		179,
		167,
		154,
		139,
		140,
		148,
		161,
		140,
		135,
		132,
		152,
		178,
		156,
		168,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		223,
		194,
		218,
		260,
		244,
		237,
		225,
		190,
		190,
		184,
		-1,
		178,
		157,
		148,
		137,
		135,
		148,
		145,
		150,
		130,
		128,
		147,
		159,
		150,
		167,
		-1,
		-1,
		-1,
		253,
		242,
		243,
		189,
		212,
		249,
		223,
		209,
		214,
		189,
		182,
		176,
		191,
		174,
		155,
		144,
		136,
		125,
		141,
		149,
		144,
		126,
		135,
		141,
		165,
		155,
		161,
		-1,
		-1,
		260,
		250,
		234,
		236,
		233,
		203,
		210,
		242,
		214,
		227,
		-1,
		181,
		-1,
		170,
		165,
		149,
		144,
		141,
		138,
		132,
		141,
		143,
		133,
		128,
		135,
		170,
		170,
		145,
		165,
		168,
		-1,
		-1,
		-1,
		253,
		248,
		223,
		200,
		184,
		220,
		-1,
		197,
		198,
		-1,
		175,
		169,
		166,
		151,
		147,
		142,
		146,
		139,
		146,
		139,
		137,
		138,
		120,
		152,
		-1,
		153,
		147,
		155,
		145,
		133,
		-1,
		-1,
		-1,
		246,
		225,
		218,
		238,
		179,
		231,
		-1,
		-1,
		182,
		175,
		-1,
		162,
		144,
		151,
		149,
		143,
		147,
		144,
		133,
		146,
		139,
		125,
		127,
		140,
		144,
		148,
		135,
		131,
		128,
		142,
		-1,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		199,
		-1,
		191,
		183,
		173,
		167,
		161,
		157,
		155,
		171,
		155,
		158,
		156,
		147,
		155,
		128,
		121,
		128,
		117,
		135,
		143,
		135,
		129,
		128,
		138,
		-1,
		266,
		252,
		223,
		-1,
		-1,
		212,
		-1,
		176,
		190,
		206,
		-1,
		199,
		178,
		193,
		171,
		167,
		163,
		178,
		179,
		156,
		156,
		154,
		145,
		133,
		122,
		125,
		117,
		139,
		139,
		123,
		124,
		128,
		-1,
		272,
		259,
		217,
		213,
		202,
		222,
		173,
		161,
		193,
		-1,
		-1,
		235,
		-1,
		169,
		186,
		177,
		175,
		168,
		150,
		157,
		165,
		142,
		137,
		127,
		116,
		116,
		111,
		133,
		119,
		117,
		126,
		142,
		-1,
		-1,
		-1,
		239,
		-1,
		-1,
		188,
		175,
		169,
		-1,
		210,
		-1,
		213,
		203,
		187,
		172,
		205,
		-1,
		149,
		145,
		152,
		-1,
		162,
		-1,
		135,
		132,
		123,
		108,
		105,
		116,
		114,
		125,
		121,
		-1,
		222,
		207,
		200,
		190,
		204,
		175,
		-1,
		230,
		-1,
		-1,
		200,
		194,
		194,
		178,
		179,
		165,
		145,
		137,
		152,
		151,
		138,
		137,
		121,
		114,
		111,
		104,
		117,
		127,
		132,
		119,
		-1,
		-1,
		-1,
		227,
		213,
		217,
		177,
		196,
		-1,
		-1,
		262,
		217,
		203,
		-1,
		174,
		165,
		153,
		143,
		133,
		138,
		139,
		129,
		127,
		119,
		121,
		115,
		106,
		105,
		121,
		113,
		135,
		-1,
		-1,
		210,
		215,
		203,
		189,
		208,
		-1,
		-1,
		-1,
		209,
		225,
		193,
		172,
		154,
		-1,
		-1,
		137,
		130,
		124,
		127,
		115,
		135,
		130,
		114,
		99,
		114,
		118,
		126,
		117,
		-1,
		213,
		200,
		-1,
		-1,
		211,
		205,
		-1,
		-1,
		-1,
		-1,
		205,
		150,
		139,
		134,
		138,
		136,
		-1,
		110,
		121,
		114,
		133,
		140,
		116,
		101,
		95,
		101,
		113,
		122,
		-1,
		-1,
		225,
		-1,
		198,
		-1,
		-1,
		-1,
		-1,
		162,
		156,
		127,
		120,
		124,
		-1,
		112,
		114,
		111,
		123,
		119,
		116,
		107,
		98,
		94,
		98,
		102,
		116,
		120,
		248,
		-1,
		189,
		-1,
		-1,
		-1,
		180,
		195,
		166,
		143,
		116,
		111,
		104,
		98,
		103,
		114,
		123,
		134,
		99,
		101,
		91,
		90,
		94,
		111,
		115,
		-1,
		-1,
		187,
		183,
		206,
		188,
		192,
		193,
		-1,
		-1,
		120,
		111,
		102,
		94,
		107,
		110,
		95,
		97,
		97,
		95,
		89,
		99,
		114,
		109,
		-1,
		-1,
		-1,
		199,
		-1,
		201,
		-1,
		-1,
		190,
		191,
		138,
		120,
		116,
		114,
		103,
		97,
		85,
		90,
		100,
		94,
		91,
		85,
		89,
		112,
		101,
		140,
		-1,
		-1,
		261,
		-1,
		-1,
		-1,
		179,
		170,
		165,
		172,
		174,
		165,
		153,
		150,
		-1,
		120,
		126,
		91,
		98,
		81,
		88,
		93,
		90,
		79,
		86,
		102,
		101,
		96,
		132,
		123,
		129,
		-1,
		-1,
		254,
		243,
		232,
		238,
		-1,
		172,
		167,
		158,
		148,
		151,
		-1,
		-1,
		145,
		142,
		122,
		91,
		89,
		82,
		77,
		87,
		63,
		75,
		79,
		83,
		89,
		94,
		99,
		105,
		120,
		135,
		-1,
		208,
		245,
		238,
		206,
		214,
		245,
		-1,
		162,
		154,
		164,
		140,
		142,
		-1,
		-1,
		118,
		109,
		110,
		98,
		95,
		101,
		100,
		83,
		89,
		90,
		82,
		81,
		99,
		103,
		112,
		119,
		109,
		122,
		126,
		-1,
		201,
		221,
		200,
		203,
		227,
		241,
		-1,
		159,
		-1,
		-1,
		124,
		143,
		127,
		117,
		114,
		157,
		112,
		107,
		88,
		86,
		81,
		72,
		97,
		90,
		90,
		93,
		108,
		113,
		105,
		119,
		119,
		120,
		-1,
		190,
		201,
		194,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		-1,
		114,
		-1,
		154,
		-1,
		137,
		141,
		120,
		123,
		102,
		89,
		75,
		83,
		89,
		88,
		94,
		94,
		95,
		104,
		115,
		127,
		126,
		127,
		215,
		171,
		174,
		185,
		196,
		211,
		215,
		-1,
		171,
		210,
		120,
		-1,
		104,
		-1,
		-1,
		-1,
		151,
		133,
		125,
		122,
		101,
		101,
		67,
		71,
		84,
		91,
		101,
		112,
		104,
		108,
		121,
		132,
		135,
		211,
		202,
		215,
		160,
		160,
		181,
		190,
		211,
		175,
		172,
		204,
		127,
		116,
		111,
		98,
		-1,
		-1,
		135,
		143,
		-1,
		-1,
		108,
		75,
		63,
		73,
		77,
		91,
		103,
		116,
		104,
		109,
		103,
		135,
		-1,
		204,
		203,
		192,
		189,
		165,
		156,
		151,
		178,
		-1,
		-1,
		173,
		200,
		183,
		160,
		158,
		183,
		-1,
		87,
		-1,
		-1,
		115,
		-1,
		-1,
		100,
		80,
		69,
		60,
		65,
		85,
		96,
		118,
		100,
		117,
		108,
		118,
		122,
		188,
		185,
		173,
		171,
		194,
		159,
		147,
		-1,
		155,
		158,
		164,
		171,
		161,
		172,
		-1,
		-1,
		103,
		83,
		-1,
		-1,
		98,
		96,
		85,
		-1,
		75,
		57,
		62,
		92,
		94,
		96,
		103,
		97,
		104,
		112,
		123,
		115,
		197,
		211,
		200,
		196,
		195,
		203,
		152,
		145,
		152,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		-1,
		93,
		89,
		-1,
		-1,
		93,
		86,
		74,
		62,
		52,
		62,
		79,
		79,
		82,
		87,
		95,
		106,
		102,
		106,
		109,
		-1,
		231,
		-1,
		183,
		144,
		150,
		165,
		173,
		-1,
		-1,
		-1,
		110,
		96,
		89,
		77,
		75,
		-1,
		127,
		111,
		92,
		-1,
		62,
		75,
		115,
		83,
		88,
		83,
		98,
		109,
		100,
		108,
		102,
		105,
		-1,
		-1,
		143,
		126,
		-1,
		-1,
		100,
		102,
		-1,
		101,
		90,
		75,
		67,
		-1,
		-1,
		99,
		95,
		-1,
		-1,
		49,
		87,
		86,
		94,
		89,
		94,
		106,
		102,
		98,
		108,
		99,
		-1,
		-1,
		121,
		113,
		107,
		-1,
		85,
		-1,
		103,
		-1,
		70,
		76,
		64,
		-1,
		-1,
		-1,
		80,
		43,
		59,
		82,
		108,
		106,
		97,
		90,
		97,
		100,
		93,
		99,
		-1,
		-1,
		-1,
		103,
		77,
		110,
		101,
		84,
		64,
		56,
		75,
		-1,
		61,
		-1,
		36,
		39,
		64,
		103,
		105,
		91,
		87,
		100,
		94,
		91,
		89,
		109,
		-1,
		79,
		112,
		76,
		70,
		46,
		50,
		75,
		-1,
		58,
		40,
		-1,
		68,
		58,
		106,
		81,
		90,
		83,
		77,
		78,
		86,
		-1,
		-1,
		-1,
		81,
		80,
		72,
		66,
		66,
		51,
		42,
		-1,
		63,
		45,
		31,
		48,
		48,
		39,
		47,
		96,
		92,
		95,
		93,
		71,
		-1,
		150,
		-1,
		-1,
		104,
		-1,
		-1,
		-1,
		75,
		70,
		43,
		31,
		32,
		28,
		28,
		30,
		43,
		51,
		49,
		46,
		58,
		54,
		74,
		70,
		102,
		-1,
		145,
		-1,
		111,
		-1,
		-1,
		93,
		73,
		65,
		54,
		43,
		41,
		27,
		23,
		40,
		75,
		61,
		59,
		64,
		69,
		-1,
		134,
		133,
		-1,
		112,
		104,
		90,
		-1,
		83,
		-1,
		89,
		50,
		-1,
		23,
		18,
		-1,
		70,
		66,
		-1,
		-1,
		121,
		116,
		-1,
		-1,
		-1,
		107,
		71,
		84,
		68,
		-1,
		0,
		14,
		-1,
		-1,
		-1,
		106,
		107,
		-1,
		100,
		103,
		-1,
		67,
		58,
		66,
		13,
		17,
		-1,
		-1,
		-1,
		115,
		96,
		90,
		92,
		87,
		108,
		79,
		65,
		49,
		27,
		16,
		37,
		-1,
		-1,
		-1,
		87,
		79,
		72,
		-1,
		-1,
		74,
		57,
		38,
		36,
		-1,
		-1,
		-1,
		109,
		90,
		-1,
		-1,
		64,
		-1,
		-1,
		70,
		35,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		98,
		-1,
		-1,
		-1,
		60,
		56,
		57,
		-1,
		-1,
		-1,
		-1,
		120,
		121,
		144,
		108,
		-1,
		-1,
		-1,
		52,
		46,
		-1,
		-1,
		123,
		121,
		-1,
		-1,
		-1,
		80,
		64,
		-1,
		50,
		-1,
		-1,
		-1,
		71,
		-1,
		-1,
		83,
		-1,
		-1,
		-1,
		85,
		-1,
		85,
		60,
		67,
		-1,
		-1,
		-1,
		-1,
		98,
		90,
		98,
		-1,
		70,
		72,
		-1,
		120,
		-1,
		-1,
		113,
		104,
		-1,
		-1,
		75,
		82,
		104,
		107,
		143,
		-1,
		94
	],
	[
		-1,
		242,
		231,
		242,
		250,
		223,
		230,
		-1,
		249,
		253,
		219,
		213,
		252,
		221,
		227,
		238,
		-1,
		-1,
		-1,
		242,
		241,
		209,
		207,
		216,
		221,
		228,
		-1,
		227,
		-1,
		263,
		242,
		253,
		258,
		202,
		199,
		219,
		238,
		220,
		212,
		278,
		232,
		203,
		197,
		215,
		205,
		214,
		206,
		-1,
		203,
		193,
		215,
		194,
		205,
		197,
		-1,
		-1,
		197,
		198,
		204,
		190,
		196,
		192,
		-1,
		202,
		186,
		-1,
		-1,
		187,
		188,
		172,
		175,
		183,
		181,
		194,
		186,
		181,
		-1,
		-1,
		178,
		174,
		181,
		168,
		164,
		181,
		194,
		176,
		190,
		189,
		-1,
		182,
		200,
		207,
		175,
		173,
		157,
		155,
		173,
		175,
		181,
		181,
		-1,
		191,
		192,
		187,
		195,
		197,
		173,
		160,
		160,
		170,
		163,
		182,
		170,
		216,
		-1,
		-1,
		-1,
		-1,
		-1,
		225,
		191,
		174,
		191,
		183,
		173,
		188,
		181,
		163,
		160,
		158,
		155,
		171,
		169,
		179,
		-1,
		-1,
		284,
		253,
		282,
		240,
		221,
		-1,
		187,
		167,
		173,
		177,
		171,
		164,
		178,
		174,
		-1,
		149,
		148,
		176,
		162,
		173,
		244,
		-1,
		-1,
		242,
		234,
		217,
		220,
		197,
		193,
		182,
		181,
		173,
		159,
		155,
		161,
		164,
		164,
		170,
		143,
		153,
		157,
		155,
		180,
		-1,
		-1,
		215,
		-1,
		-1,
		241,
		224,
		-1,
		207,
		214,
		203,
		209,
		195,
		216,
		192,
		183,
		175,
		169,
		157,
		159,
		156,
		169,
		157,
		140,
		165,
		169,
		150,
		171,
		166,
		-1,
		214,
		198,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		219,
		200,
		203,
		209,
		233,
		232,
		-1,
		204,
		192,
		193,
		178,
		175,
		162,
		150,
		163,
		148,
		155,
		154,
		144,
		142,
		172,
		147,
		169,
		166,
		185,
		190,
		184,
		193,
		-1,
		249,
		245,
		241,
		248,
		197,
		-1,
		-1,
		237,
		-1,
		240,
		241,
		216,
		189,
		192,
		179,
		170,
		157,
		146,
		157,
		146,
		143,
		151,
		136,
		151,
		142,
		141,
		159,
		169,
		177,
		181,
		187,
		-1,
		299,
		-1,
		241,
		225,
		227,
		199,
		220,
		-1,
		257,
		241,
		233,
		218,
		218,
		-1,
		188,
		185,
		175,
		153,
		138,
		155,
		147,
		145,
		149,
		131,
		145,
		136,
		154,
		161,
		159,
		163,
		183,
		195,
		259,
		249,
		-1,
		231,
		236,
		195,
		203,
		222,
		260,
		224,
		-1,
		219,
		-1,
		190,
		203,
		-1,
		159,
		155,
		137,
		138,
		133,
		148,
		142,
		127,
		124,
		142,
		145,
		152,
		156,
		172,
		-1,
		-1,
		244,
		248,
		237,
		188,
		207,
		231,
		268,
		217,
		206,
		205,
		-1,
		196,
		173,
		170,
		158,
		145,
		130,
		131,
		139,
		152,
		131,
		126,
		123,
		143,
		169,
		147,
		159,
		-1,
		-1,
		-1,
		269,
		-1,
		-1,
		214,
		185,
		209,
		251,
		235,
		228,
		216,
		181,
		181,
		175,
		-1,
		169,
		148,
		139,
		128,
		126,
		139,
		136,
		141,
		121,
		119,
		138,
		150,
		141,
		158,
		-1,
		-1,
		-1,
		244,
		233,
		234,
		180,
		203,
		240,
		214,
		200,
		205,
		180,
		173,
		167,
		182,
		165,
		146,
		135,
		127,
		116,
		132,
		140,
		135,
		117,
		126,
		132,
		156,
		146,
		152,
		-1,
		-1,
		251,
		241,
		225,
		227,
		224,
		194,
		201,
		233,
		205,
		218,
		-1,
		172,
		-1,
		161,
		156,
		140,
		135,
		132,
		129,
		123,
		132,
		134,
		124,
		119,
		126,
		161,
		161,
		136,
		156,
		159,
		-1,
		-1,
		-1,
		244,
		239,
		214,
		191,
		175,
		211,
		-1,
		188,
		189,
		-1,
		166,
		160,
		157,
		142,
		138,
		133,
		137,
		130,
		137,
		130,
		128,
		129,
		111,
		143,
		-1,
		144,
		138,
		146,
		136,
		124,
		-1,
		-1,
		-1,
		237,
		216,
		209,
		229,
		170,
		222,
		-1,
		-1,
		173,
		166,
		-1,
		153,
		135,
		142,
		140,
		134,
		138,
		135,
		124,
		137,
		130,
		116,
		118,
		131,
		135,
		139,
		126,
		122,
		119,
		133,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		190,
		-1,
		182,
		174,
		164,
		158,
		152,
		148,
		146,
		162,
		146,
		149,
		147,
		138,
		146,
		119,
		112,
		119,
		108,
		126,
		134,
		126,
		120,
		119,
		129,
		-1,
		257,
		243,
		214,
		-1,
		-1,
		203,
		-1,
		167,
		181,
		197,
		-1,
		190,
		169,
		184,
		162,
		158,
		154,
		169,
		170,
		147,
		147,
		145,
		136,
		124,
		113,
		116,
		108,
		130,
		130,
		114,
		115,
		119,
		-1,
		263,
		250,
		208,
		204,
		193,
		213,
		164,
		152,
		184,
		-1,
		-1,
		226,
		-1,
		160,
		177,
		168,
		166,
		159,
		141,
		148,
		156,
		133,
		128,
		118,
		107,
		107,
		102,
		124,
		110,
		108,
		117,
		133,
		-1,
		-1,
		-1,
		230,
		-1,
		-1,
		179,
		166,
		160,
		-1,
		201,
		-1,
		204,
		194,
		178,
		163,
		196,
		-1,
		140,
		136,
		143,
		-1,
		153,
		-1,
		126,
		123,
		114,
		99,
		96,
		107,
		105,
		116,
		112,
		-1,
		213,
		198,
		191,
		181,
		195,
		166,
		-1,
		221,
		-1,
		-1,
		191,
		185,
		185,
		169,
		170,
		156,
		136,
		128,
		143,
		142,
		129,
		128,
		112,
		105,
		102,
		95,
		108,
		118,
		123,
		110,
		-1,
		-1,
		-1,
		218,
		204,
		208,
		168,
		187,
		-1,
		-1,
		253,
		208,
		194,
		-1,
		165,
		156,
		144,
		134,
		124,
		129,
		130,
		120,
		118,
		110,
		112,
		106,
		97,
		96,
		112,
		104,
		126,
		-1,
		-1,
		201,
		206,
		194,
		180,
		199,
		-1,
		-1,
		-1,
		200,
		216,
		184,
		163,
		145,
		-1,
		-1,
		128,
		121,
		115,
		118,
		106,
		126,
		121,
		105,
		90,
		105,
		109,
		117,
		108,
		-1,
		204,
		191,
		-1,
		-1,
		202,
		196,
		-1,
		-1,
		-1,
		-1,
		196,
		141,
		130,
		125,
		129,
		127,
		-1,
		101,
		112,
		105,
		124,
		131,
		107,
		92,
		86,
		92,
		104,
		113,
		-1,
		-1,
		216,
		-1,
		189,
		-1,
		-1,
		-1,
		-1,
		153,
		147,
		118,
		111,
		115,
		-1,
		103,
		105,
		102,
		114,
		110,
		107,
		98,
		89,
		85,
		89,
		93,
		107,
		111,
		239,
		-1,
		180,
		-1,
		-1,
		-1,
		171,
		186,
		157,
		134,
		107,
		102,
		95,
		89,
		94,
		105,
		114,
		125,
		90,
		92,
		82,
		81,
		85,
		102,
		106,
		-1,
		-1,
		178,
		174,
		197,
		179,
		183,
		184,
		-1,
		-1,
		111,
		102,
		93,
		85,
		98,
		101,
		86,
		88,
		88,
		86,
		80,
		90,
		105,
		100,
		-1,
		-1,
		-1,
		190,
		-1,
		192,
		-1,
		-1,
		181,
		182,
		129,
		111,
		107,
		105,
		94,
		88,
		76,
		81,
		91,
		85,
		82,
		76,
		80,
		103,
		92,
		131,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		170,
		161,
		156,
		163,
		165,
		156,
		144,
		141,
		-1,
		111,
		117,
		82,
		89,
		72,
		79,
		84,
		81,
		70,
		77,
		93,
		92,
		87,
		123,
		114,
		120,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		163,
		158,
		149,
		139,
		142,
		-1,
		-1,
		136,
		133,
		113,
		82,
		80,
		73,
		68,
		78,
		54,
		66,
		70,
		74,
		80,
		85,
		90,
		96,
		111,
		126,
		-1,
		199,
		236,
		229,
		197,
		205,
		236,
		-1,
		153,
		145,
		155,
		131,
		133,
		-1,
		-1,
		109,
		100,
		101,
		89,
		86,
		92,
		91,
		74,
		80,
		81,
		73,
		72,
		90,
		94,
		103,
		110,
		100,
		113,
		117,
		-1,
		192,
		212,
		191,
		194,
		218,
		232,
		-1,
		150,
		-1,
		-1,
		115,
		134,
		118,
		108,
		105,
		148,
		103,
		98,
		79,
		77,
		72,
		63,
		88,
		81,
		81,
		84,
		99,
		104,
		96,
		110,
		110,
		111,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		-1,
		105,
		-1,
		145,
		-1,
		128,
		132,
		111,
		114,
		93,
		80,
		66,
		74,
		80,
		79,
		85,
		85,
		86,
		95,
		106,
		118,
		117,
		118,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		162,
		201,
		111,
		-1,
		95,
		-1,
		-1,
		-1,
		142,
		124,
		116,
		113,
		92,
		92,
		58,
		62,
		75,
		82,
		92,
		103,
		95,
		99,
		112,
		123,
		126,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		166,
		163,
		195,
		118,
		107,
		102,
		89,
		-1,
		-1,
		126,
		134,
		-1,
		-1,
		99,
		66,
		54,
		64,
		68,
		82,
		94,
		107,
		95,
		100,
		94,
		126,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		191,
		174,
		151,
		149,
		174,
		-1,
		78,
		-1,
		-1,
		106,
		-1,
		-1,
		91,
		71,
		60,
		51,
		56,
		76,
		87,
		109,
		91,
		108,
		99,
		109,
		113,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		146,
		149,
		155,
		162,
		152,
		163,
		-1,
		-1,
		94,
		74,
		-1,
		-1,
		89,
		87,
		76,
		-1,
		66,
		48,
		53,
		83,
		85,
		87,
		94,
		88,
		95,
		103,
		114,
		106,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		99,
		-1,
		84,
		80,
		-1,
		-1,
		84,
		77,
		65,
		53,
		43,
		53,
		70,
		70,
		73,
		78,
		86,
		97,
		93,
		97,
		100,
		-1,
		222,
		-1,
		174,
		135,
		141,
		156,
		164,
		-1,
		-1,
		-1,
		101,
		87,
		80,
		68,
		66,
		-1,
		118,
		102,
		83,
		-1,
		53,
		66,
		106,
		74,
		79,
		74,
		89,
		100,
		91,
		99,
		93,
		96,
		-1,
		-1,
		134,
		117,
		-1,
		-1,
		91,
		93,
		-1,
		92,
		81,
		66,
		58,
		-1,
		-1,
		90,
		86,
		-1,
		-1,
		40,
		78,
		77,
		85,
		80,
		85,
		97,
		93,
		89,
		99,
		90,
		-1,
		-1,
		112,
		104,
		98,
		-1,
		76,
		-1,
		94,
		-1,
		61,
		67,
		55,
		-1,
		-1,
		-1,
		71,
		34,
		50,
		73,
		99,
		97,
		88,
		81,
		88,
		91,
		84,
		90,
		-1,
		-1,
		-1,
		94,
		68,
		101,
		92,
		75,
		55,
		47,
		66,
		-1,
		52,
		-1,
		27,
		30,
		55,
		94,
		96,
		82,
		78,
		91,
		85,
		82,
		80,
		100,
		-1,
		70,
		103,
		67,
		61,
		37,
		41,
		66,
		-1,
		49,
		31,
		-1,
		59,
		49,
		97,
		72,
		81,
		74,
		68,
		69,
		77,
		-1,
		-1,
		-1,
		72,
		71,
		63,
		57,
		57,
		42,
		33,
		-1,
		54,
		36,
		22,
		39,
		39,
		30,
		38,
		87,
		83,
		86,
		84,
		62,
		-1,
		153,
		-1,
		-1,
		95,
		-1,
		-1,
		-1,
		66,
		61,
		34,
		22,
		23,
		19,
		19,
		21,
		34,
		42,
		40,
		37,
		49,
		45,
		65,
		61,
		93,
		-1,
		148,
		-1,
		102,
		-1,
		-1,
		84,
		64,
		56,
		45,
		34,
		32,
		18,
		14,
		31,
		66,
		52,
		50,
		55,
		60,
		-1,
		137,
		136,
		-1,
		103,
		95,
		81,
		-1,
		74,
		-1,
		80,
		41,
		-1,
		19,
		9,
		-1,
		61,
		57,
		-1,
		-1,
		124,
		119,
		-1,
		-1,
		-1,
		104,
		74,
		75,
		59,
		-1,
		11,
		0,
		-1,
		-1,
		-1,
		109,
		110,
		-1,
		97,
		100,
		-1,
		70,
		61,
		69,
		17,
		21,
		-1,
		-1,
		-1,
		118,
		99,
		93,
		95,
		90,
		105,
		82,
		68,
		52,
		30,
		20,
		39,
		-1,
		-1,
		-1,
		90,
		82,
		75,
		-1,
		-1,
		77,
		60,
		41,
		39,
		-1,
		-1,
		-1,
		112,
		93,
		-1,
		-1,
		67,
		-1,
		-1,
		73,
		38,
		-1,
		-1,
		-1,
		-1,
		-1,
		129,
		101,
		-1,
		-1,
		-1,
		63,
		59,
		60,
		-1,
		-1,
		-1,
		-1,
		123,
		124,
		147,
		111,
		-1,
		-1,
		-1,
		55,
		49,
		-1,
		-1,
		126,
		124,
		-1,
		-1,
		-1,
		83,
		67,
		-1,
		53,
		-1,
		-1,
		-1,
		74,
		-1,
		-1,
		86,
		-1,
		-1,
		-1,
		88,
		-1,
		88,
		63,
		70,
		-1,
		-1,
		-1,
		-1,
		101,
		93,
		101,
		-1,
		73,
		75,
		-1,
		123,
		-1,
		-1,
		116,
		107,
		-1,
		-1,
		78,
		85,
		107,
		110,
		146,
		-1,
		97
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		349,
		338,
		349,
		357,
		330,
		337,
		-1,
		356,
		360,
		326,
		320,
		359,
		328,
		334,
		345,
		-1,
		-1,
		-1,
		349,
		348,
		316,
		314,
		323,
		328,
		335,
		-1,
		334,
		-1,
		370,
		349,
		360,
		365,
		309,
		306,
		326,
		345,
		327,
		319,
		385,
		339,
		310,
		304,
		322,
		312,
		321,
		313,
		-1,
		310,
		300,
		322,
		301,
		312,
		304,
		-1,
		-1,
		304,
		305,
		311,
		297,
		303,
		299,
		-1,
		309,
		293,
		-1,
		-1,
		294,
		295,
		279,
		282,
		290,
		288,
		301,
		293,
		288,
		-1,
		-1,
		285,
		281,
		288,
		275,
		271,
		288,
		301,
		283,
		297,
		296,
		-1,
		289,
		307,
		314,
		282,
		280,
		264,
		262,
		280,
		282,
		288,
		288,
		-1,
		298,
		299,
		294,
		302,
		304,
		280,
		267,
		267,
		277,
		270,
		289,
		277,
		323,
		-1,
		-1,
		-1,
		-1,
		-1,
		332,
		298,
		281,
		298,
		290,
		280,
		295,
		288,
		270,
		267,
		265,
		262,
		278,
		276,
		286,
		-1,
		-1,
		391,
		360,
		389,
		347,
		328,
		-1,
		294,
		274,
		280,
		284,
		278,
		271,
		285,
		281,
		-1,
		256,
		255,
		283,
		269,
		280,
		351,
		-1,
		-1,
		349,
		341,
		324,
		327,
		304,
		300,
		289,
		288,
		280,
		266,
		262,
		268,
		271,
		271,
		277,
		250,
		260,
		264,
		262,
		287,
		-1,
		-1,
		322,
		-1,
		-1,
		348,
		331,
		-1,
		314,
		321,
		310,
		316,
		302,
		323,
		299,
		290,
		282,
		276,
		264,
		266,
		263,
		276,
		264,
		247,
		272,
		276,
		257,
		278,
		273,
		-1,
		321,
		305,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		326,
		307,
		310,
		316,
		340,
		339,
		-1,
		311,
		299,
		300,
		285,
		282,
		269,
		257,
		270,
		255,
		262,
		261,
		251,
		249,
		279,
		254,
		276,
		273,
		292,
		297,
		291,
		300,
		-1,
		356,
		352,
		348,
		355,
		304,
		-1,
		-1,
		344,
		-1,
		347,
		348,
		323,
		296,
		299,
		286,
		277,
		264,
		253,
		264,
		253,
		250,
		258,
		243,
		258,
		249,
		248,
		266,
		276,
		284,
		288,
		294,
		-1,
		406,
		-1,
		348,
		332,
		334,
		306,
		327,
		-1,
		364,
		348,
		340,
		325,
		325,
		-1,
		295,
		292,
		282,
		260,
		245,
		262,
		254,
		252,
		256,
		238,
		252,
		243,
		261,
		268,
		266,
		270,
		290,
		302,
		366,
		356,
		-1,
		338,
		343,
		302,
		310,
		329,
		367,
		331,
		-1,
		326,
		-1,
		297,
		310,
		-1,
		266,
		262,
		244,
		245,
		240,
		255,
		249,
		234,
		231,
		249,
		252,
		259,
		263,
		279,
		-1,
		-1,
		351,
		355,
		344,
		295,
		314,
		338,
		375,
		324,
		313,
		312,
		-1,
		303,
		280,
		277,
		265,
		252,
		237,
		238,
		246,
		259,
		238,
		233,
		230,
		250,
		276,
		254,
		266,
		-1,
		-1,
		-1,
		376,
		-1,
		-1,
		321,
		292,
		316,
		358,
		342,
		335,
		323,
		288,
		288,
		282,
		-1,
		276,
		255,
		246,
		235,
		233,
		246,
		243,
		248,
		228,
		226,
		245,
		257,
		248,
		265,
		-1,
		-1,
		-1,
		351,
		340,
		341,
		287,
		310,
		347,
		321,
		307,
		312,
		287,
		280,
		274,
		289,
		272,
		253,
		242,
		234,
		223,
		239,
		247,
		242,
		224,
		233,
		239,
		263,
		253,
		259,
		-1,
		-1,
		358,
		348,
		332,
		334,
		331,
		301,
		308,
		340,
		312,
		325,
		-1,
		279,
		-1,
		268,
		263,
		247,
		242,
		239,
		236,
		230,
		239,
		241,
		231,
		226,
		233,
		268,
		268,
		243,
		263,
		266,
		-1,
		-1,
		-1,
		351,
		346,
		321,
		298,
		282,
		318,
		-1,
		295,
		296,
		-1,
		273,
		267,
		264,
		249,
		245,
		240,
		244,
		237,
		244,
		237,
		235,
		236,
		218,
		250,
		-1,
		251,
		245,
		253,
		243,
		231,
		-1,
		-1,
		-1,
		344,
		323,
		316,
		336,
		277,
		329,
		-1,
		-1,
		280,
		273,
		-1,
		260,
		242,
		249,
		247,
		241,
		245,
		242,
		231,
		244,
		237,
		223,
		225,
		238,
		242,
		246,
		233,
		229,
		226,
		240,
		-1,
		363,
		-1,
		-1,
		-1,
		-1,
		-1,
		277,
		297,
		-1,
		289,
		281,
		271,
		265,
		259,
		255,
		253,
		269,
		253,
		256,
		254,
		245,
		253,
		226,
		219,
		226,
		215,
		233,
		241,
		233,
		227,
		226,
		236,
		-1,
		364,
		350,
		321,
		-1,
		-1,
		310,
		-1,
		274,
		288,
		304,
		-1,
		297,
		276,
		291,
		269,
		265,
		261,
		276,
		277,
		254,
		254,
		252,
		243,
		231,
		220,
		223,
		215,
		237,
		237,
		221,
		222,
		226,
		-1,
		370,
		357,
		315,
		311,
		300,
		320,
		271,
		259,
		291,
		-1,
		-1,
		333,
		-1,
		267,
		284,
		275,
		273,
		266,
		248,
		255,
		263,
		240,
		235,
		225,
		214,
		214,
		209,
		231,
		217,
		215,
		224,
		240,
		-1,
		-1,
		-1,
		337,
		-1,
		-1,
		286,
		273,
		267,
		-1,
		308,
		-1,
		311,
		301,
		285,
		270,
		303,
		-1,
		247,
		243,
		250,
		-1,
		260,
		-1,
		233,
		230,
		221,
		206,
		203,
		214,
		212,
		223,
		219,
		-1,
		320,
		305,
		298,
		288,
		302,
		273,
		-1,
		328,
		-1,
		-1,
		298,
		292,
		292,
		276,
		277,
		263,
		243,
		235,
		250,
		249,
		236,
		235,
		219,
		212,
		209,
		202,
		215,
		225,
		230,
		217,
		-1,
		-1,
		-1,
		325,
		311,
		315,
		275,
		294,
		-1,
		-1,
		360,
		315,
		301,
		-1,
		272,
		263,
		251,
		241,
		231,
		236,
		237,
		227,
		225,
		217,
		219,
		213,
		204,
		203,
		219,
		211,
		233,
		-1,
		-1,
		308,
		313,
		301,
		287,
		305,
		-1,
		-1,
		-1,
		307,
		323,
		291,
		270,
		252,
		-1,
		-1,
		235,
		228,
		222,
		225,
		213,
		233,
		228,
		212,
		197,
		212,
		216,
		224,
		215,
		-1,
		311,
		298,
		-1,
		-1,
		304,
		294,
		-1,
		-1,
		-1,
		-1,
		303,
		248,
		237,
		232,
		236,
		234,
		-1,
		208,
		219,
		212,
		231,
		238,
		214,
		199,
		193,
		199,
		211,
		220,
		-1,
		-1,
		318,
		-1,
		280,
		-1,
		-1,
		-1,
		-1,
		260,
		254,
		225,
		218,
		222,
		-1,
		210,
		212,
		209,
		221,
		217,
		214,
		205,
		196,
		192,
		196,
		200,
		214,
		218,
		341,
		-1,
		271,
		-1,
		-1,
		-1,
		278,
		293,
		264,
		241,
		214,
		209,
		202,
		196,
		201,
		212,
		221,
		232,
		197,
		199,
		189,
		188,
		192,
		209,
		213,
		-1,
		-1,
		269,
		265,
		300,
		286,
		290,
		291,
		-1,
		-1,
		218,
		209,
		200,
		192,
		205,
		208,
		193,
		195,
		195,
		193,
		187,
		197,
		212,
		207,
		-1,
		-1,
		-1,
		281,
		-1,
		283,
		-1,
		-1,
		288,
		289,
		236,
		218,
		214,
		212,
		201,
		195,
		183,
		188,
		198,
		192,
		189,
		183,
		187,
		210,
		199,
		238,
		-1,
		-1,
		305,
		-1,
		-1,
		-1,
		265,
		252,
		247,
		270,
		272,
		263,
		251,
		248,
		-1,
		218,
		224,
		189,
		196,
		179,
		186,
		191,
		188,
		177,
		184,
		200,
		199,
		194,
		230,
		221,
		227,
		-1,
		-1,
		298,
		287,
		276,
		282,
		-1,
		258,
		249,
		256,
		246,
		249,
		-1,
		-1,
		243,
		240,
		220,
		189,
		187,
		180,
		175,
		185,
		161,
		173,
		177,
		181,
		187,
		192,
		197,
		203,
		218,
		233,
		-1,
		252,
		289,
		282,
		250,
		258,
		289,
		-1,
		248,
		240,
		246,
		238,
		240,
		-1,
		-1,
		216,
		207,
		208,
		196,
		193,
		199,
		198,
		181,
		187,
		188,
		180,
		179,
		197,
		201,
		210,
		217,
		207,
		220,
		224,
		-1,
		245,
		265,
		244,
		247,
		271,
		285,
		-1,
		239,
		-1,
		-1,
		206,
		241,
		225,
		215,
		212,
		255,
		210,
		205,
		186,
		184,
		179,
		170,
		195,
		188,
		188,
		191,
		206,
		211,
		203,
		217,
		217,
		218,
		-1,
		234,
		245,
		238,
		-1,
		-1,
		-1,
		-1,
		233,
		-1,
		-1,
		196,
		-1,
		252,
		-1,
		235,
		239,
		218,
		221,
		200,
		187,
		173,
		181,
		187,
		186,
		192,
		192,
		193,
		202,
		213,
		225,
		224,
		225,
		232,
		215,
		218,
		229,
		240,
		255,
		259,
		-1,
		223,
		259,
		202,
		-1,
		186,
		-1,
		-1,
		-1,
		249,
		231,
		223,
		220,
		199,
		199,
		165,
		169,
		182,
		189,
		199,
		210,
		202,
		206,
		219,
		230,
		233,
		228,
		233,
		259,
		204,
		204,
		225,
		234,
		255,
		219,
		216,
		253,
		209,
		198,
		193,
		180,
		-1,
		-1,
		233,
		241,
		-1,
		-1,
		206,
		173,
		161,
		171,
		175,
		189,
		201,
		214,
		202,
		207,
		201,
		233,
		-1,
		228,
		223,
		210,
		205,
		199,
		200,
		195,
		222,
		-1,
		-1,
		217,
		244,
		228,
		232,
		240,
		265,
		-1,
		164,
		-1,
		-1,
		213,
		-1,
		-1,
		198,
		178,
		167,
		158,
		163,
		183,
		194,
		216,
		198,
		215,
		206,
		216,
		220,
		212,
		205,
		193,
		195,
		201,
		203,
		191,
		-1,
		199,
		202,
		208,
		215,
		232,
		254,
		-1,
		-1,
		180,
		160,
		-1,
		-1,
		196,
		194,
		183,
		-1,
		173,
		155,
		160,
		190,
		192,
		194,
		201,
		195,
		202,
		210,
		221,
		213,
		221,
		231,
		220,
		193,
		202,
		215,
		196,
		189,
		196,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		170,
		166,
		-1,
		-1,
		191,
		184,
		172,
		160,
		150,
		160,
		177,
		177,
		180,
		185,
		193,
		204,
		200,
		204,
		207,
		-1,
		230,
		-1,
		227,
		188,
		194,
		209,
		217,
		-1,
		-1,
		-1,
		187,
		173,
		166,
		154,
		152,
		-1,
		225,
		209,
		190,
		-1,
		160,
		173,
		213,
		181,
		186,
		181,
		196,
		207,
		198,
		206,
		200,
		203,
		-1,
		-1,
		187,
		170,
		-1,
		-1,
		144,
		146,
		-1,
		178,
		167,
		152,
		144,
		-1,
		-1,
		197,
		193,
		-1,
		-1,
		147,
		185,
		184,
		192,
		187,
		192,
		204,
		200,
		196,
		206,
		197,
		-1,
		-1,
		165,
		157,
		151,
		-1,
		129,
		-1,
		180,
		-1,
		147,
		156,
		144,
		-1,
		-1,
		-1,
		178,
		141,
		157,
		180,
		206,
		204,
		195,
		188,
		195,
		198,
		191,
		197,
		-1,
		-1,
		-1,
		147,
		121,
		187,
		178,
		161,
		141,
		133,
		155,
		-1,
		159,
		-1,
		134,
		137,
		162,
		201,
		203,
		189,
		185,
		198,
		192,
		189,
		187,
		149,
		-1,
		123,
		156,
		120,
		147,
		113,
		127,
		173,
		-1,
		156,
		138,
		-1,
		166,
		156,
		204,
		179,
		188,
		181,
		175,
		176,
		184,
		-1,
		-1,
		-1,
		125,
		124,
		116,
		110,
		110,
		108,
		125,
		-1,
		161,
		143,
		129,
		146,
		146,
		137,
		145,
		194,
		190,
		193,
		191,
		169,
		-1,
		47,
		-1,
		-1,
		148,
		-1,
		-1,
		-1,
		119,
		103,
		116,
		127,
		130,
		126,
		126,
		128,
		141,
		149,
		147,
		144,
		156,
		152,
		172,
		168,
		200,
		-1,
		42,
		-1,
		155,
		-1,
		-1,
		81,
		87,
		97,
		108,
		136,
		136,
		125,
		121,
		138,
		173,
		159,
		157,
		162,
		167,
		-1,
		31,
		30,
		-1,
		45,
		55,
		76,
		-1,
		78,
		-1,
		182,
		143,
		-1,
		122,
		116,
		-1,
		168,
		164,
		-1,
		-1,
		18,
		34,
		-1,
		-1,
		-1,
		77,
		86,
		177,
		161,
		-1,
		106,
		113,
		-1,
		-1,
		-1,
		0,
		25,
		-1,
		70,
		73,
		-1,
		87,
		93,
		121,
		101,
		107,
		-1,
		-1,
		-1,
		29,
		13,
		18,
		60,
		55,
		78,
		118,
		104,
		104,
		88,
		98,
		127,
		-1,
		-1,
		-1,
		32,
		29,
		40,
		-1,
		-1,
		129,
		112,
		99,
		97,
		-1,
		-1,
		-1,
		54,
		35,
		-1,
		-1,
		49,
		-1,
		-1,
		94,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		72,
		43,
		-1,
		-1,
		-1,
		50,
		57,
		78,
		-1,
		-1,
		-1,
		-1,
		69,
		70,
		89,
		64,
		-1,
		-1,
		-1,
		64,
		67,
		-1,
		-1,
		72,
		70,
		-1,
		-1,
		-1,
		92,
		76,
		-1,
		78,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		111,
		-1,
		-1,
		-1,
		97,
		-1,
		113,
		88,
		95,
		-1,
		-1,
		-1,
		-1,
		110,
		102,
		126,
		-1,
		98,
		100,
		-1,
		148,
		-1,
		-1,
		125,
		116,
		-1,
		-1,
		103,
		110,
		132,
		135,
		155,
		-1,
		122
	],
	[
		-1,
		346,
		335,
		346,
		354,
		327,
		334,
		-1,
		353,
		357,
		323,
		317,
		356,
		325,
		331,
		342,
		-1,
		-1,
		-1,
		346,
		345,
		313,
		311,
		320,
		325,
		332,
		-1,
		331,
		-1,
		367,
		346,
		357,
		362,
		306,
		303,
		323,
		342,
		324,
		316,
		382,
		336,
		307,
		301,
		319,
		309,
		318,
		310,
		-1,
		307,
		297,
		319,
		298,
		309,
		301,
		-1,
		-1,
		301,
		302,
		308,
		294,
		300,
		296,
		-1,
		306,
		290,
		-1,
		-1,
		291,
		292,
		276,
		279,
		287,
		285,
		298,
		290,
		285,
		-1,
		-1,
		282,
		278,
		285,
		272,
		268,
		285,
		298,
		280,
		294,
		293,
		-1,
		286,
		304,
		311,
		279,
		277,
		261,
		259,
		277,
		279,
		285,
		285,
		-1,
		295,
		296,
		291,
		299,
		301,
		277,
		264,
		264,
		274,
		267,
		286,
		274,
		320,
		-1,
		-1,
		-1,
		-1,
		-1,
		329,
		295,
		278,
		295,
		287,
		277,
		292,
		285,
		267,
		264,
		262,
		259,
		275,
		273,
		283,
		-1,
		-1,
		388,
		357,
		386,
		344,
		325,
		-1,
		291,
		271,
		277,
		281,
		275,
		268,
		282,
		278,
		-1,
		253,
		252,
		280,
		266,
		277,
		348,
		-1,
		-1,
		346,
		338,
		321,
		324,
		301,
		297,
		286,
		285,
		277,
		263,
		259,
		265,
		268,
		268,
		274,
		247,
		257,
		261,
		259,
		284,
		-1,
		-1,
		319,
		-1,
		-1,
		345,
		328,
		-1,
		311,
		318,
		307,
		313,
		299,
		320,
		296,
		287,
		279,
		273,
		261,
		263,
		260,
		273,
		261,
		244,
		269,
		273,
		254,
		275,
		270,
		-1,
		318,
		302,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		323,
		304,
		307,
		313,
		337,
		336,
		-1,
		308,
		296,
		297,
		282,
		279,
		266,
		254,
		267,
		252,
		259,
		258,
		248,
		246,
		276,
		251,
		273,
		270,
		289,
		294,
		288,
		297,
		-1,
		353,
		349,
		345,
		352,
		301,
		-1,
		-1,
		341,
		-1,
		344,
		345,
		320,
		293,
		296,
		283,
		274,
		261,
		250,
		261,
		250,
		247,
		255,
		240,
		255,
		246,
		245,
		263,
		273,
		281,
		285,
		291,
		-1,
		403,
		-1,
		345,
		329,
		331,
		303,
		324,
		-1,
		361,
		345,
		337,
		322,
		322,
		-1,
		292,
		289,
		279,
		257,
		242,
		259,
		251,
		249,
		253,
		235,
		249,
		240,
		258,
		265,
		263,
		267,
		287,
		299,
		363,
		353,
		-1,
		335,
		340,
		299,
		307,
		326,
		364,
		328,
		-1,
		323,
		-1,
		294,
		307,
		-1,
		263,
		259,
		241,
		242,
		237,
		252,
		246,
		231,
		228,
		246,
		249,
		256,
		260,
		276,
		-1,
		-1,
		348,
		352,
		341,
		292,
		311,
		335,
		372,
		321,
		310,
		309,
		-1,
		300,
		277,
		274,
		262,
		249,
		234,
		235,
		243,
		256,
		235,
		230,
		227,
		247,
		273,
		251,
		263,
		-1,
		-1,
		-1,
		373,
		-1,
		-1,
		318,
		289,
		313,
		355,
		339,
		332,
		320,
		285,
		285,
		279,
		-1,
		273,
		252,
		243,
		232,
		230,
		243,
		240,
		245,
		225,
		223,
		242,
		254,
		245,
		262,
		-1,
		-1,
		-1,
		348,
		337,
		338,
		284,
		307,
		344,
		318,
		304,
		309,
		284,
		277,
		271,
		286,
		269,
		250,
		239,
		231,
		220,
		236,
		244,
		239,
		221,
		230,
		236,
		260,
		250,
		256,
		-1,
		-1,
		355,
		345,
		329,
		331,
		328,
		298,
		305,
		337,
		309,
		322,
		-1,
		276,
		-1,
		265,
		260,
		244,
		239,
		236,
		233,
		227,
		236,
		238,
		228,
		223,
		230,
		265,
		265,
		240,
		260,
		263,
		-1,
		-1,
		-1,
		348,
		343,
		318,
		295,
		279,
		315,
		-1,
		292,
		293,
		-1,
		270,
		264,
		261,
		246,
		242,
		237,
		241,
		234,
		241,
		234,
		232,
		233,
		215,
		247,
		-1,
		248,
		242,
		250,
		240,
		228,
		-1,
		-1,
		-1,
		341,
		320,
		313,
		333,
		274,
		326,
		-1,
		-1,
		277,
		270,
		-1,
		257,
		239,
		246,
		244,
		238,
		242,
		239,
		228,
		241,
		234,
		220,
		222,
		235,
		239,
		243,
		230,
		226,
		223,
		237,
		-1,
		360,
		-1,
		-1,
		-1,
		-1,
		-1,
		274,
		294,
		-1,
		286,
		278,
		268,
		262,
		256,
		252,
		250,
		266,
		250,
		253,
		251,
		242,
		250,
		223,
		216,
		223,
		212,
		230,
		238,
		230,
		224,
		223,
		233,
		-1,
		361,
		347,
		318,
		-1,
		-1,
		307,
		-1,
		271,
		285,
		301,
		-1,
		294,
		273,
		288,
		266,
		262,
		258,
		273,
		274,
		251,
		251,
		249,
		240,
		228,
		217,
		220,
		212,
		234,
		234,
		218,
		219,
		223,
		-1,
		367,
		354,
		312,
		308,
		297,
		317,
		268,
		256,
		288,
		-1,
		-1,
		330,
		-1,
		264,
		281,
		272,
		270,
		263,
		245,
		252,
		260,
		237,
		232,
		222,
		211,
		211,
		206,
		228,
		214,
		212,
		221,
		237,
		-1,
		-1,
		-1,
		334,
		-1,
		-1,
		283,
		270,
		264,
		-1,
		305,
		-1,
		308,
		298,
		282,
		267,
		300,
		-1,
		244,
		240,
		247,
		-1,
		257,
		-1,
		230,
		227,
		218,
		203,
		200,
		211,
		209,
		220,
		216,
		-1,
		317,
		302,
		295,
		285,
		299,
		270,
		-1,
		325,
		-1,
		-1,
		295,
		289,
		289,
		273,
		274,
		260,
		240,
		232,
		247,
		246,
		233,
		232,
		216,
		209,
		206,
		199,
		212,
		222,
		227,
		214,
		-1,
		-1,
		-1,
		322,
		308,
		312,
		272,
		291,
		-1,
		-1,
		357,
		312,
		298,
		-1,
		269,
		260,
		248,
		238,
		228,
		233,
		234,
		224,
		222,
		214,
		216,
		210,
		201,
		200,
		216,
		208,
		230,
		-1,
		-1,
		305,
		310,
		298,
		284,
		286,
		-1,
		-1,
		-1,
		304,
		320,
		288,
		267,
		249,
		-1,
		-1,
		232,
		225,
		219,
		222,
		210,
		230,
		225,
		209,
		194,
		209,
		213,
		221,
		212,
		-1,
		308,
		295,
		-1,
		-1,
		285,
		275,
		-1,
		-1,
		-1,
		-1,
		300,
		245,
		234,
		229,
		233,
		231,
		-1,
		205,
		216,
		209,
		228,
		235,
		211,
		196,
		190,
		196,
		208,
		217,
		-1,
		-1,
		299,
		-1,
		261,
		-1,
		-1,
		-1,
		-1,
		257,
		251,
		222,
		215,
		219,
		-1,
		207,
		209,
		206,
		218,
		214,
		211,
		202,
		193,
		189,
		193,
		197,
		211,
		215,
		322,
		-1,
		252,
		-1,
		-1,
		-1,
		275,
		290,
		261,
		238,
		211,
		206,
		199,
		193,
		198,
		209,
		218,
		229,
		194,
		196,
		186,
		185,
		189,
		206,
		210,
		-1,
		-1,
		250,
		246,
		281,
		283,
		287,
		288,
		-1,
		-1,
		215,
		206,
		197,
		189,
		202,
		205,
		190,
		192,
		192,
		190,
		184,
		194,
		209,
		204,
		-1,
		-1,
		-1,
		262,
		-1,
		264,
		-1,
		-1,
		283,
		286,
		233,
		215,
		211,
		209,
		198,
		192,
		180,
		185,
		195,
		189,
		186,
		180,
		184,
		207,
		196,
		235,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		244,
		233,
		228,
		262,
		267,
		258,
		248,
		245,
		-1,
		215,
		221,
		186,
		193,
		176,
		183,
		188,
		185,
		174,
		181,
		197,
		196,
		191,
		227,
		218,
		224,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		237,
		230,
		248,
		238,
		244,
		-1,
		-1,
		240,
		237,
		217,
		186,
		184,
		177,
		172,
		182,
		158,
		170,
		174,
		178,
		184,
		189,
		194,
		200,
		215,
		230,
		-1,
		231,
		268,
		261,
		229,
		237,
		268,
		-1,
		227,
		219,
		227,
		230,
		237,
		-1,
		-1,
		213,
		204,
		205,
		193,
		190,
		196,
		195,
		178,
		184,
		185,
		177,
		176,
		194,
		198,
		207,
		214,
		204,
		217,
		221,
		-1,
		224,
		244,
		223,
		226,
		250,
		264,
		-1,
		218,
		-1,
		-1,
		187,
		238,
		222,
		212,
		209,
		252,
		207,
		202,
		183,
		181,
		176,
		167,
		192,
		185,
		185,
		188,
		203,
		208,
		200,
		214,
		214,
		215,
		-1,
		213,
		224,
		217,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		177,
		-1,
		249,
		-1,
		232,
		236,
		215,
		218,
		197,
		184,
		170,
		178,
		184,
		183,
		189,
		189,
		190,
		199,
		210,
		222,
		221,
		222,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		202,
		238,
		183,
		-1,
		167,
		-1,
		-1,
		-1,
		246,
		228,
		220,
		217,
		196,
		196,
		162,
		166,
		179,
		186,
		196,
		207,
		199,
		203,
		216,
		227,
		230,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		198,
		195,
		232,
		190,
		179,
		174,
		161,
		-1,
		-1,
		230,
		238,
		-1,
		-1,
		203,
		170,
		158,
		168,
		172,
		186,
		198,
		211,
		199,
		204,
		198,
		230,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		223,
		207,
		211,
		221,
		246,
		-1,
		145,
		-1,
		-1,
		210,
		-1,
		-1,
		195,
		175,
		164,
		155,
		160,
		180,
		191,
		213,
		195,
		212,
		203,
		213,
		217,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		178,
		181,
		187,
		194,
		211,
		235,
		-1,
		-1,
		161,
		141,
		-1,
		-1,
		193,
		191,
		180,
		-1,
		170,
		152,
		157,
		187,
		189,
		191,
		198,
		192,
		199,
		207,
		218,
		210,
		220,
		234,
		223,
		213,
		218,
		226,
		175,
		168,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		188,
		181,
		169,
		157,
		147,
		157,
		174,
		174,
		177,
		182,
		190,
		201,
		197,
		201,
		204,
		-1,
		250,
		-1,
		206,
		167,
		173,
		188,
		196,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		222,
		206,
		187,
		-1,
		157,
		170,
		210,
		178,
		183,
		178,
		193,
		204,
		195,
		203,
		197,
		200,
		-1,
		-1,
		166,
		149,
		-1,
		-1,
		123,
		125,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		194,
		190,
		-1,
		-1,
		144,
		182,
		181,
		189,
		184,
		189,
		201,
		197,
		193,
		203,
		194,
		-1,
		-1,
		144,
		136,
		130,
		-1,
		108,
		-1,
		161,
		-1,
		128,
		135,
		123,
		-1,
		-1,
		-1,
		175,
		138,
		154,
		177,
		203,
		201,
		192,
		185,
		192,
		195,
		188,
		194,
		-1,
		-1,
		-1,
		126,
		100,
		168,
		159,
		142,
		122,
		114,
		134,
		-1,
		156,
		-1,
		131,
		134,
		159,
		198,
		200,
		186,
		182,
		195,
		189,
		186,
		184,
		132,
		-1,
		102,
		135,
		99,
		128,
		94,
		106,
		170,
		-1,
		153,
		135,
		-1,
		163,
		153,
		201,
		176,
		185,
		178,
		172,
		173,
		181,
		-1,
		-1,
		-1,
		104,
		103,
		95,
		89,
		89,
		87,
		105,
		-1,
		158,
		140,
		126,
		143,
		143,
		134,
		142,
		191,
		187,
		190,
		188,
		166,
		-1,
		67,
		-1,
		-1,
		127,
		-1,
		-1,
		-1,
		98,
		88,
		101,
		107,
		119,
		125,
		123,
		125,
		138,
		146,
		144,
		141,
		153,
		149,
		169,
		165,
		197,
		-1,
		62,
		-1,
		134,
		-1,
		-1,
		56,
		70,
		82,
		93,
		115,
		115,
		120,
		118,
		137,
		170,
		156,
		154,
		159,
		164,
		-1,
		51,
		50,
		-1,
		20,
		30,
		51,
		-1,
		68,
		-1,
		161,
		122,
		-1,
		121,
		115,
		-1,
		165,
		161,
		-1,
		-1,
		38,
		9,
		-1,
		-1,
		-1,
		76,
		81,
		156,
		140,
		-1,
		105,
		112,
		-1,
		-1,
		-1,
		23,
		0,
		-1,
		69,
		72,
		-1,
		86,
		92,
		120,
		100,
		106,
		-1,
		-1,
		-1,
		32,
		12,
		17,
		59,
		54,
		77,
		117,
		103,
		103,
		87,
		97,
		126,
		-1,
		-1,
		-1,
		31,
		28,
		39,
		-1,
		-1,
		128,
		111,
		98,
		96,
		-1,
		-1,
		-1,
		53,
		34,
		-1,
		-1,
		48,
		-1,
		-1,
		93,
		72,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		42,
		-1,
		-1,
		-1,
		49,
		56,
		77,
		-1,
		-1,
		-1,
		-1,
		68,
		69,
		88,
		63,
		-1,
		-1,
		-1,
		63,
		66,
		-1,
		-1,
		71,
		69,
		-1,
		-1,
		-1,
		91,
		75,
		-1,
		77,
		-1,
		-1,
		-1,
		82,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		96,
		-1,
		112,
		87,
		94,
		-1,
		-1,
		-1,
		-1,
		109,
		101,
		125,
		-1,
		97,
		99,
		-1,
		147,
		-1,
		-1,
		124,
		115,
		-1,
		-1,
		102,
		109,
		131,
		134,
		154,
		-1,
		121
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		327,
		331,
		297,
		291,
		330,
		299,
		305,
		316,
		-1,
		-1,
		-1,
		320,
		319,
		287,
		285,
		294,
		299,
		306,
		-1,
		305,
		-1,
		341,
		320,
		331,
		336,
		280,
		277,
		297,
		316,
		298,
		290,
		356,
		310,
		281,
		275,
		293,
		283,
		292,
		284,
		-1,
		281,
		271,
		293,
		272,
		283,
		275,
		-1,
		-1,
		275,
		276,
		282,
		268,
		274,
		270,
		-1,
		280,
		264,
		-1,
		-1,
		265,
		266,
		250,
		253,
		261,
		259,
		272,
		264,
		259,
		-1,
		-1,
		256,
		252,
		259,
		246,
		242,
		259,
		272,
		254,
		268,
		267,
		-1,
		260,
		278,
		285,
		253,
		251,
		235,
		233,
		251,
		253,
		259,
		259,
		-1,
		269,
		270,
		265,
		273,
		275,
		251,
		238,
		238,
		248,
		241,
		260,
		248,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		269,
		252,
		269,
		261,
		251,
		266,
		259,
		241,
		238,
		236,
		233,
		249,
		247,
		257,
		-1,
		-1,
		362,
		331,
		360,
		318,
		299,
		-1,
		265,
		245,
		251,
		255,
		249,
		242,
		256,
		252,
		-1,
		227,
		226,
		254,
		240,
		251,
		322,
		-1,
		-1,
		320,
		312,
		295,
		298,
		275,
		271,
		260,
		259,
		251,
		237,
		233,
		239,
		242,
		242,
		248,
		221,
		231,
		235,
		233,
		258,
		-1,
		-1,
		293,
		-1,
		-1,
		319,
		302,
		-1,
		285,
		292,
		281,
		287,
		273,
		294,
		270,
		261,
		253,
		247,
		235,
		237,
		234,
		247,
		235,
		218,
		243,
		247,
		228,
		249,
		244,
		-1,
		292,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		278,
		281,
		287,
		311,
		310,
		-1,
		282,
		270,
		271,
		256,
		253,
		240,
		228,
		241,
		226,
		233,
		232,
		222,
		220,
		250,
		225,
		247,
		244,
		263,
		268,
		262,
		271,
		-1,
		327,
		323,
		319,
		326,
		275,
		-1,
		-1,
		315,
		-1,
		318,
		319,
		294,
		267,
		270,
		257,
		248,
		235,
		224,
		235,
		224,
		221,
		229,
		214,
		229,
		220,
		219,
		237,
		247,
		255,
		259,
		265,
		-1,
		377,
		-1,
		319,
		303,
		305,
		277,
		298,
		-1,
		335,
		319,
		311,
		296,
		296,
		-1,
		266,
		263,
		253,
		231,
		216,
		233,
		225,
		223,
		227,
		209,
		223,
		214,
		232,
		239,
		237,
		241,
		261,
		273,
		337,
		327,
		-1,
		309,
		314,
		273,
		281,
		300,
		338,
		302,
		-1,
		297,
		-1,
		268,
		281,
		-1,
		237,
		233,
		215,
		216,
		211,
		226,
		220,
		205,
		202,
		220,
		223,
		230,
		234,
		250,
		-1,
		-1,
		322,
		326,
		315,
		266,
		285,
		309,
		346,
		295,
		284,
		283,
		-1,
		274,
		251,
		248,
		236,
		223,
		208,
		209,
		217,
		230,
		209,
		204,
		201,
		221,
		247,
		225,
		237,
		-1,
		-1,
		-1,
		347,
		-1,
		-1,
		292,
		263,
		287,
		329,
		313,
		306,
		294,
		259,
		259,
		253,
		-1,
		247,
		226,
		217,
		206,
		204,
		217,
		214,
		219,
		199,
		197,
		216,
		228,
		219,
		236,
		-1,
		-1,
		-1,
		322,
		311,
		312,
		258,
		281,
		318,
		292,
		278,
		283,
		258,
		251,
		245,
		260,
		243,
		224,
		213,
		205,
		194,
		210,
		218,
		213,
		195,
		204,
		210,
		234,
		224,
		230,
		-1,
		-1,
		329,
		319,
		303,
		305,
		302,
		272,
		279,
		311,
		283,
		296,
		-1,
		250,
		-1,
		239,
		234,
		218,
		213,
		210,
		207,
		201,
		210,
		212,
		202,
		197,
		204,
		239,
		239,
		214,
		234,
		237,
		-1,
		-1,
		-1,
		322,
		317,
		292,
		269,
		253,
		289,
		-1,
		266,
		267,
		-1,
		244,
		238,
		235,
		220,
		216,
		211,
		215,
		208,
		215,
		208,
		206,
		207,
		189,
		221,
		-1,
		222,
		216,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		315,
		294,
		287,
		307,
		248,
		300,
		-1,
		-1,
		251,
		244,
		-1,
		231,
		213,
		220,
		218,
		212,
		216,
		213,
		202,
		215,
		208,
		194,
		196,
		209,
		213,
		217,
		204,
		200,
		197,
		211,
		-1,
		334,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		268,
		-1,
		260,
		252,
		242,
		236,
		230,
		226,
		224,
		240,
		224,
		227,
		225,
		216,
		224,
		197,
		190,
		197,
		186,
		204,
		212,
		204,
		198,
		197,
		207,
		-1,
		335,
		321,
		292,
		-1,
		-1,
		281,
		-1,
		245,
		259,
		275,
		-1,
		268,
		247,
		262,
		240,
		236,
		232,
		247,
		248,
		225,
		225,
		223,
		214,
		202,
		191,
		194,
		186,
		208,
		208,
		192,
		193,
		197,
		-1,
		341,
		328,
		286,
		282,
		271,
		291,
		242,
		230,
		262,
		-1,
		-1,
		304,
		-1,
		238,
		255,
		246,
		244,
		237,
		219,
		226,
		234,
		211,
		206,
		196,
		185,
		185,
		180,
		202,
		188,
		186,
		195,
		211,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		257,
		244,
		238,
		-1,
		279,
		-1,
		282,
		272,
		256,
		241,
		274,
		-1,
		218,
		214,
		221,
		-1,
		231,
		-1,
		204,
		201,
		192,
		177,
		174,
		185,
		183,
		194,
		190,
		-1,
		291,
		276,
		269,
		259,
		273,
		244,
		-1,
		299,
		-1,
		-1,
		269,
		263,
		263,
		247,
		248,
		234,
		214,
		206,
		221,
		220,
		207,
		206,
		190,
		183,
		180,
		173,
		186,
		196,
		201,
		188,
		-1,
		-1,
		-1,
		296,
		282,
		286,
		246,
		265,
		-1,
		-1,
		331,
		286,
		272,
		-1,
		243,
		234,
		222,
		212,
		202,
		207,
		208,
		198,
		196,
		188,
		190,
		184,
		175,
		174,
		190,
		182,
		204,
		-1,
		-1,
		279,
		284,
		272,
		258,
		259,
		-1,
		-1,
		-1,
		278,
		294,
		262,
		241,
		223,
		-1,
		-1,
		206,
		199,
		193,
		196,
		184,
		204,
		199,
		183,
		168,
		183,
		187,
		195,
		186,
		-1,
		282,
		269,
		-1,
		-1,
		258,
		248,
		-1,
		-1,
		-1,
		-1,
		274,
		219,
		208,
		203,
		207,
		205,
		-1,
		179,
		190,
		183,
		202,
		209,
		185,
		170,
		164,
		170,
		182,
		191,
		-1,
		-1,
		272,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		231,
		225,
		196,
		189,
		193,
		-1,
		181,
		183,
		180,
		192,
		188,
		185,
		176,
		167,
		163,
		167,
		171,
		185,
		189,
		295,
		-1,
		225,
		-1,
		-1,
		-1,
		249,
		264,
		235,
		212,
		185,
		180,
		173,
		167,
		172,
		183,
		192,
		203,
		168,
		170,
		160,
		159,
		163,
		180,
		184,
		-1,
		-1,
		223,
		219,
		254,
		257,
		261,
		262,
		-1,
		-1,
		189,
		180,
		171,
		163,
		176,
		179,
		164,
		166,
		166,
		164,
		158,
		168,
		183,
		178,
		-1,
		-1,
		-1,
		235,
		-1,
		237,
		-1,
		-1,
		256,
		260,
		207,
		189,
		185,
		183,
		172,
		166,
		154,
		159,
		169,
		163,
		160,
		154,
		158,
		181,
		170,
		209,
		-1,
		-1,
		259,
		-1,
		-1,
		-1,
		219,
		206,
		201,
		235,
		240,
		231,
		222,
		219,
		-1,
		189,
		195,
		160,
		167,
		150,
		157,
		162,
		159,
		148,
		155,
		171,
		170,
		165,
		201,
		192,
		198,
		-1,
		-1,
		252,
		241,
		230,
		236,
		-1,
		212,
		203,
		221,
		211,
		217,
		-1,
		-1,
		214,
		211,
		191,
		160,
		158,
		151,
		146,
		156,
		132,
		144,
		148,
		152,
		158,
		163,
		168,
		174,
		189,
		204,
		-1,
		206,
		243,
		236,
		204,
		212,
		243,
		-1,
		202,
		194,
		200,
		203,
		211,
		-1,
		-1,
		187,
		178,
		179,
		167,
		164,
		170,
		169,
		152,
		158,
		159,
		151,
		150,
		168,
		172,
		181,
		188,
		178,
		191,
		195,
		-1,
		199,
		219,
		198,
		201,
		225,
		239,
		-1,
		193,
		-1,
		-1,
		160,
		212,
		196,
		186,
		183,
		226,
		181,
		176,
		157,
		155,
		150,
		141,
		166,
		159,
		159,
		162,
		177,
		182,
		174,
		188,
		188,
		189,
		-1,
		188,
		199,
		192,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		150,
		-1,
		223,
		-1,
		206,
		210,
		189,
		192,
		171,
		158,
		144,
		152,
		158,
		157,
		163,
		163,
		164,
		173,
		184,
		196,
		195,
		196,
		213,
		169,
		172,
		183,
		194,
		209,
		213,
		-1,
		177,
		213,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		220,
		202,
		194,
		191,
		170,
		170,
		136,
		140,
		153,
		160,
		170,
		181,
		173,
		177,
		190,
		201,
		204,
		209,
		200,
		213,
		158,
		158,
		179,
		188,
		209,
		173,
		170,
		207,
		163,
		152,
		147,
		134,
		-1,
		-1,
		204,
		212,
		-1,
		-1,
		177,
		144,
		132,
		142,
		146,
		160,
		172,
		185,
		173,
		178,
		172,
		204,
		-1,
		202,
		201,
		190,
		187,
		163,
		154,
		149,
		176,
		-1,
		-1,
		171,
		198,
		182,
		186,
		194,
		219,
		-1,
		118,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		149,
		138,
		129,
		134,
		154,
		165,
		187,
		169,
		186,
		177,
		187,
		191,
		186,
		183,
		171,
		169,
		192,
		157,
		145,
		-1,
		153,
		156,
		162,
		169,
		186,
		208,
		-1,
		-1,
		134,
		114,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		126,
		131,
		161,
		163,
		165,
		172,
		166,
		173,
		181,
		192,
		184,
		195,
		209,
		198,
		194,
		193,
		201,
		150,
		143,
		150,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		-1,
		124,
		120,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		148,
		148,
		151,
		156,
		164,
		175,
		171,
		175,
		178,
		-1,
		229,
		-1,
		181,
		142,
		148,
		163,
		171,
		-1,
		-1,
		-1,
		141,
		127,
		120,
		108,
		106,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		184,
		152,
		157,
		152,
		167,
		178,
		169,
		177,
		171,
		174,
		-1,
		-1,
		141,
		124,
		-1,
		-1,
		98,
		100,
		-1,
		132,
		121,
		106,
		98,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		118,
		156,
		155,
		163,
		158,
		163,
		175,
		171,
		167,
		177,
		168,
		-1,
		-1,
		119,
		111,
		105,
		-1,
		83,
		-1,
		134,
		-1,
		101,
		110,
		98,
		-1,
		-1,
		-1,
		149,
		112,
		128,
		151,
		177,
		175,
		166,
		159,
		166,
		169,
		162,
		168,
		-1,
		-1,
		-1,
		101,
		75,
		141,
		132,
		115,
		95,
		87,
		109,
		-1,
		130,
		-1,
		105,
		108,
		133,
		172,
		174,
		160,
		156,
		169,
		163,
		160,
		158,
		107,
		-1,
		77,
		110,
		74,
		101,
		67,
		81,
		144,
		-1,
		127,
		109,
		-1,
		137,
		127,
		175,
		150,
		159,
		152,
		146,
		147,
		155,
		-1,
		-1,
		-1,
		79,
		78,
		70,
		64,
		64,
		62,
		79,
		-1,
		132,
		114,
		100,
		117,
		117,
		108,
		116,
		165,
		161,
		164,
		162,
		140,
		-1,
		113,
		-1,
		-1,
		102,
		-1,
		-1,
		-1,
		73,
		57,
		70,
		81,
		94,
		102,
		97,
		99,
		112,
		120,
		118,
		115,
		127,
		123,
		143,
		139,
		171,
		-1,
		108,
		-1,
		109,
		-1,
		-1,
		54,
		41,
		51,
		62,
		90,
		90,
		94,
		92,
		114,
		144,
		130,
		128,
		133,
		138,
		-1,
		97,
		96,
		-1,
		73,
		65,
		51,
		-1,
		32,
		-1,
		136,
		97,
		-1,
		111,
		101,
		-1,
		139,
		135,
		-1,
		-1,
		84,
		79,
		-1,
		-1,
		-1,
		27,
		40,
		131,
		115,
		-1,
		95,
		102,
		-1,
		-1,
		-1,
		69,
		70,
		-1,
		0,
		23,
		-1,
		41,
		47,
		75,
		90,
		96,
		-1,
		-1,
		-1,
		78,
		59,
		53,
		15,
		20,
		28,
		72,
		58,
		58,
		75,
		87,
		116,
		-1,
		-1,
		-1,
		50,
		42,
		35,
		-1,
		-1,
		83,
		66,
		66,
		84,
		-1,
		-1,
		-1,
		72,
		53,
		-1,
		-1,
		49,
		-1,
		-1,
		79,
		73,
		-1,
		-1,
		-1,
		-1,
		-1,
		88,
		61,
		-1,
		-1,
		-1,
		50,
		57,
		78,
		-1,
		-1,
		-1,
		-1,
		82,
		83,
		107,
		82,
		-1,
		-1,
		-1,
		64,
		67,
		-1,
		-1,
		85,
		83,
		-1,
		-1,
		-1,
		92,
		76,
		-1,
		78,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		111,
		-1,
		-1,
		-1,
		97,
		-1,
		113,
		88,
		95,
		-1,
		-1,
		-1,
		-1,
		110,
		102,
		126,
		-1,
		98,
		100,
		-1,
		148,
		-1,
		-1,
		125,
		116,
		-1,
		-1,
		103,
		110,
		132,
		135,
		155,
		-1,
		122
	],
	[
		-1,
		323,
		312,
		323,
		331,
		304,
		311,
		-1,
		330,
		334,
		300,
		294,
		333,
		302,
		308,
		319,
		-1,
		-1,
		-1,
		323,
		322,
		290,
		288,
		297,
		302,
		309,
		-1,
		308,
		-1,
		344,
		323,
		334,
		339,
		283,
		280,
		300,
		319,
		301,
		293,
		359,
		313,
		284,
		278,
		296,
		286,
		295,
		287,
		-1,
		284,
		274,
		296,
		275,
		286,
		278,
		-1,
		-1,
		278,
		279,
		285,
		271,
		277,
		273,
		-1,
		283,
		267,
		-1,
		-1,
		268,
		269,
		253,
		256,
		264,
		262,
		275,
		267,
		262,
		-1,
		-1,
		259,
		255,
		262,
		249,
		245,
		262,
		275,
		257,
		271,
		270,
		-1,
		263,
		281,
		288,
		256,
		254,
		238,
		236,
		254,
		256,
		262,
		262,
		-1,
		272,
		273,
		268,
		276,
		278,
		254,
		241,
		241,
		251,
		244,
		263,
		251,
		297,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		272,
		255,
		272,
		264,
		254,
		269,
		262,
		244,
		241,
		239,
		236,
		252,
		250,
		260,
		-1,
		-1,
		365,
		334,
		363,
		321,
		302,
		-1,
		268,
		248,
		254,
		258,
		252,
		245,
		259,
		255,
		-1,
		230,
		229,
		257,
		243,
		254,
		325,
		-1,
		-1,
		323,
		315,
		298,
		301,
		278,
		274,
		263,
		262,
		254,
		240,
		236,
		242,
		245,
		245,
		251,
		224,
		234,
		238,
		236,
		261,
		-1,
		-1,
		296,
		-1,
		-1,
		322,
		305,
		-1,
		288,
		295,
		284,
		290,
		276,
		297,
		273,
		264,
		256,
		250,
		238,
		240,
		237,
		250,
		238,
		221,
		246,
		250,
		231,
		252,
		247,
		-1,
		295,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		281,
		284,
		290,
		314,
		313,
		-1,
		285,
		273,
		274,
		259,
		256,
		243,
		231,
		244,
		229,
		236,
		235,
		225,
		223,
		253,
		228,
		250,
		247,
		266,
		271,
		265,
		274,
		-1,
		330,
		326,
		322,
		329,
		278,
		-1,
		-1,
		318,
		-1,
		321,
		322,
		297,
		270,
		273,
		260,
		251,
		238,
		227,
		238,
		227,
		224,
		232,
		217,
		232,
		223,
		222,
		240,
		250,
		258,
		262,
		268,
		-1,
		380,
		-1,
		322,
		306,
		308,
		280,
		301,
		-1,
		338,
		322,
		314,
		299,
		299,
		-1,
		269,
		266,
		256,
		234,
		219,
		236,
		228,
		226,
		230,
		212,
		226,
		217,
		235,
		242,
		240,
		244,
		264,
		276,
		340,
		330,
		-1,
		312,
		317,
		276,
		284,
		303,
		341,
		305,
		-1,
		300,
		-1,
		271,
		284,
		-1,
		240,
		236,
		218,
		219,
		214,
		229,
		223,
		208,
		205,
		223,
		226,
		233,
		237,
		253,
		-1,
		-1,
		325,
		329,
		318,
		269,
		288,
		312,
		349,
		298,
		287,
		286,
		-1,
		277,
		254,
		251,
		239,
		226,
		211,
		212,
		220,
		233,
		212,
		207,
		204,
		224,
		250,
		228,
		240,
		-1,
		-1,
		-1,
		350,
		-1,
		-1,
		295,
		266,
		290,
		332,
		316,
		309,
		297,
		262,
		262,
		256,
		-1,
		250,
		229,
		220,
		209,
		207,
		220,
		217,
		222,
		202,
		200,
		219,
		231,
		222,
		239,
		-1,
		-1,
		-1,
		325,
		314,
		315,
		261,
		284,
		321,
		295,
		281,
		286,
		261,
		254,
		248,
		263,
		246,
		227,
		216,
		208,
		197,
		213,
		221,
		216,
		198,
		207,
		213,
		237,
		227,
		233,
		-1,
		-1,
		332,
		322,
		306,
		308,
		305,
		275,
		282,
		314,
		286,
		299,
		-1,
		253,
		-1,
		242,
		237,
		221,
		216,
		213,
		210,
		204,
		213,
		215,
		205,
		200,
		207,
		242,
		242,
		217,
		237,
		240,
		-1,
		-1,
		-1,
		325,
		320,
		295,
		272,
		256,
		292,
		-1,
		269,
		270,
		-1,
		247,
		241,
		238,
		223,
		219,
		214,
		218,
		211,
		218,
		211,
		209,
		210,
		192,
		224,
		-1,
		225,
		219,
		227,
		217,
		205,
		-1,
		-1,
		-1,
		318,
		297,
		290,
		310,
		251,
		303,
		-1,
		-1,
		254,
		247,
		-1,
		234,
		216,
		223,
		221,
		215,
		219,
		216,
		205,
		218,
		211,
		197,
		199,
		212,
		216,
		220,
		207,
		203,
		200,
		214,
		-1,
		337,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		271,
		-1,
		263,
		255,
		245,
		239,
		233,
		229,
		227,
		243,
		227,
		230,
		228,
		219,
		227,
		200,
		193,
		200,
		189,
		207,
		215,
		207,
		201,
		200,
		210,
		-1,
		338,
		324,
		295,
		-1,
		-1,
		284,
		-1,
		248,
		262,
		278,
		-1,
		271,
		250,
		265,
		243,
		239,
		235,
		250,
		251,
		228,
		228,
		226,
		217,
		205,
		194,
		197,
		189,
		211,
		211,
		195,
		196,
		200,
		-1,
		344,
		331,
		289,
		285,
		274,
		294,
		245,
		233,
		265,
		-1,
		-1,
		307,
		-1,
		241,
		258,
		249,
		247,
		240,
		222,
		229,
		237,
		214,
		209,
		199,
		188,
		188,
		183,
		205,
		191,
		189,
		198,
		214,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		260,
		247,
		241,
		-1,
		282,
		-1,
		285,
		275,
		259,
		244,
		277,
		-1,
		221,
		217,
		224,
		-1,
		234,
		-1,
		207,
		204,
		195,
		180,
		177,
		188,
		186,
		197,
		193,
		-1,
		294,
		279,
		272,
		262,
		276,
		247,
		-1,
		302,
		-1,
		-1,
		272,
		266,
		266,
		250,
		251,
		237,
		217,
		209,
		224,
		223,
		210,
		209,
		193,
		186,
		183,
		176,
		189,
		199,
		204,
		191,
		-1,
		-1,
		-1,
		299,
		285,
		289,
		249,
		268,
		-1,
		-1,
		334,
		289,
		275,
		-1,
		246,
		237,
		225,
		215,
		205,
		210,
		211,
		201,
		199,
		191,
		193,
		187,
		178,
		177,
		193,
		185,
		207,
		-1,
		-1,
		282,
		287,
		275,
		261,
		262,
		-1,
		-1,
		-1,
		281,
		297,
		265,
		244,
		226,
		-1,
		-1,
		209,
		202,
		196,
		199,
		187,
		207,
		202,
		186,
		171,
		186,
		190,
		198,
		189,
		-1,
		285,
		272,
		-1,
		-1,
		261,
		251,
		-1,
		-1,
		-1,
		-1,
		277,
		222,
		211,
		206,
		210,
		208,
		-1,
		182,
		193,
		186,
		205,
		212,
		188,
		173,
		167,
		173,
		185,
		194,
		-1,
		-1,
		275,
		-1,
		237,
		-1,
		-1,
		-1,
		-1,
		234,
		228,
		199,
		192,
		196,
		-1,
		184,
		186,
		183,
		195,
		191,
		188,
		179,
		170,
		166,
		170,
		174,
		188,
		192,
		298,
		-1,
		228,
		-1,
		-1,
		-1,
		252,
		267,
		238,
		215,
		188,
		183,
		176,
		170,
		175,
		186,
		195,
		206,
		171,
		173,
		163,
		162,
		166,
		183,
		187,
		-1,
		-1,
		226,
		222,
		257,
		260,
		264,
		265,
		-1,
		-1,
		192,
		183,
		174,
		166,
		179,
		182,
		167,
		169,
		169,
		167,
		161,
		171,
		186,
		181,
		-1,
		-1,
		-1,
		238,
		-1,
		240,
		-1,
		-1,
		259,
		263,
		210,
		192,
		188,
		186,
		175,
		169,
		157,
		162,
		172,
		166,
		163,
		157,
		161,
		184,
		173,
		212,
		-1,
		-1,
		262,
		-1,
		-1,
		-1,
		222,
		209,
		204,
		238,
		243,
		234,
		225,
		222,
		-1,
		192,
		198,
		163,
		170,
		153,
		160,
		165,
		162,
		151,
		158,
		174,
		173,
		168,
		204,
		195,
		201,
		-1,
		-1,
		255,
		244,
		233,
		239,
		-1,
		215,
		206,
		224,
		214,
		220,
		-1,
		-1,
		217,
		214,
		194,
		163,
		161,
		154,
		149,
		159,
		135,
		147,
		151,
		155,
		161,
		166,
		171,
		177,
		192,
		207,
		-1,
		209,
		246,
		239,
		207,
		215,
		246,
		-1,
		205,
		197,
		203,
		206,
		214,
		-1,
		-1,
		190,
		181,
		182,
		170,
		167,
		173,
		172,
		155,
		161,
		162,
		154,
		153,
		171,
		175,
		184,
		191,
		181,
		194,
		198,
		-1,
		202,
		222,
		201,
		204,
		228,
		242,
		-1,
		196,
		-1,
		-1,
		163,
		215,
		199,
		189,
		186,
		229,
		184,
		179,
		160,
		158,
		153,
		144,
		169,
		162,
		162,
		165,
		180,
		185,
		177,
		191,
		191,
		192,
		-1,
		191,
		202,
		195,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		-1,
		153,
		-1,
		226,
		-1,
		209,
		213,
		192,
		195,
		174,
		161,
		147,
		155,
		161,
		160,
		166,
		166,
		167,
		176,
		187,
		199,
		198,
		199,
		216,
		172,
		175,
		186,
		197,
		212,
		216,
		-1,
		180,
		216,
		159,
		-1,
		143,
		-1,
		-1,
		-1,
		223,
		205,
		197,
		194,
		173,
		173,
		139,
		143,
		156,
		163,
		173,
		184,
		176,
		180,
		193,
		204,
		207,
		212,
		203,
		216,
		161,
		161,
		182,
		191,
		212,
		176,
		173,
		210,
		166,
		155,
		150,
		137,
		-1,
		-1,
		207,
		215,
		-1,
		-1,
		180,
		147,
		135,
		145,
		149,
		163,
		175,
		188,
		176,
		181,
		175,
		207,
		-1,
		205,
		204,
		193,
		190,
		166,
		157,
		152,
		179,
		-1,
		-1,
		174,
		201,
		185,
		189,
		197,
		222,
		-1,
		121,
		-1,
		-1,
		187,
		-1,
		-1,
		172,
		152,
		141,
		132,
		137,
		157,
		168,
		190,
		172,
		189,
		180,
		190,
		194,
		189,
		186,
		174,
		172,
		195,
		160,
		148,
		-1,
		156,
		159,
		165,
		172,
		189,
		211,
		-1,
		-1,
		137,
		117,
		-1,
		-1,
		170,
		168,
		157,
		-1,
		147,
		129,
		134,
		164,
		166,
		168,
		175,
		169,
		176,
		184,
		195,
		187,
		198,
		212,
		201,
		197,
		196,
		204,
		153,
		146,
		153,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		142,
		-1,
		127,
		123,
		-1,
		-1,
		165,
		158,
		146,
		134,
		124,
		134,
		151,
		151,
		154,
		159,
		167,
		178,
		174,
		178,
		181,
		-1,
		232,
		-1,
		184,
		145,
		151,
		166,
		174,
		-1,
		-1,
		-1,
		144,
		130,
		123,
		111,
		109,
		-1,
		199,
		183,
		164,
		-1,
		134,
		147,
		187,
		155,
		160,
		155,
		170,
		181,
		172,
		180,
		174,
		177,
		-1,
		-1,
		144,
		127,
		-1,
		-1,
		101,
		103,
		-1,
		135,
		124,
		109,
		101,
		-1,
		-1,
		171,
		167,
		-1,
		-1,
		121,
		159,
		158,
		166,
		161,
		166,
		178,
		174,
		170,
		180,
		171,
		-1,
		-1,
		122,
		114,
		108,
		-1,
		86,
		-1,
		137,
		-1,
		104,
		113,
		101,
		-1,
		-1,
		-1,
		152,
		115,
		131,
		154,
		180,
		178,
		169,
		162,
		169,
		172,
		165,
		171,
		-1,
		-1,
		-1,
		104,
		78,
		144,
		135,
		118,
		98,
		90,
		112,
		-1,
		133,
		-1,
		108,
		111,
		136,
		175,
		177,
		163,
		159,
		172,
		166,
		163,
		161,
		110,
		-1,
		80,
		113,
		77,
		104,
		70,
		84,
		147,
		-1,
		130,
		112,
		-1,
		140,
		130,
		178,
		153,
		162,
		155,
		149,
		150,
		158,
		-1,
		-1,
		-1,
		82,
		81,
		73,
		67,
		67,
		65,
		82,
		-1,
		135,
		117,
		103,
		120,
		120,
		111,
		119,
		168,
		164,
		167,
		165,
		143,
		-1,
		116,
		-1,
		-1,
		105,
		-1,
		-1,
		-1,
		76,
		60,
		73,
		84,
		97,
		105,
		100,
		102,
		115,
		123,
		121,
		118,
		130,
		126,
		146,
		142,
		174,
		-1,
		111,
		-1,
		112,
		-1,
		-1,
		57,
		44,
		54,
		65,
		93,
		93,
		97,
		95,
		117,
		147,
		133,
		131,
		136,
		141,
		-1,
		100,
		99,
		-1,
		76,
		68,
		54,
		-1,
		35,
		-1,
		139,
		100,
		-1,
		114,
		104,
		-1,
		142,
		138,
		-1,
		-1,
		87,
		82,
		-1,
		-1,
		-1,
		30,
		43,
		134,
		118,
		-1,
		98,
		105,
		-1,
		-1,
		-1,
		72,
		73,
		-1,
		23,
		0,
		-1,
		44,
		50,
		78,
		93,
		99,
		-1,
		-1,
		-1,
		81,
		62,
		56,
		38,
		43,
		5,
		75,
		61,
		61,
		78,
		90,
		119,
		-1,
		-1,
		-1,
		53,
		45,
		45,
		-1,
		-1,
		86,
		69,
		69,
		87,
		-1,
		-1,
		-1,
		75,
		56,
		-1,
		-1,
		54,
		-1,
		-1,
		82,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		64,
		-1,
		-1,
		-1,
		55,
		62,
		83,
		-1,
		-1,
		-1,
		-1,
		85,
		86,
		110,
		85,
		-1,
		-1,
		-1,
		69,
		72,
		-1,
		-1,
		88,
		86,
		-1,
		-1,
		-1,
		97,
		81,
		-1,
		83,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		116,
		-1,
		-1,
		-1,
		102,
		-1,
		118,
		93,
		100,
		-1,
		-1,
		-1,
		-1,
		115,
		107,
		131,
		-1,
		103,
		105,
		-1,
		153,
		-1,
		-1,
		130,
		121,
		-1,
		-1,
		108,
		115,
		137,
		140,
		160,
		-1,
		127
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		302,
		291,
		302,
		310,
		283,
		290,
		-1,
		309,
		313,
		279,
		273,
		312,
		281,
		287,
		298,
		-1,
		-1,
		-1,
		302,
		301,
		269,
		267,
		276,
		281,
		288,
		-1,
		287,
		-1,
		323,
		302,
		313,
		318,
		262,
		259,
		279,
		298,
		280,
		272,
		338,
		292,
		263,
		257,
		275,
		265,
		274,
		266,
		-1,
		263,
		253,
		275,
		254,
		265,
		257,
		-1,
		-1,
		257,
		258,
		264,
		250,
		256,
		252,
		-1,
		262,
		246,
		-1,
		-1,
		247,
		248,
		232,
		235,
		243,
		241,
		254,
		246,
		241,
		-1,
		-1,
		238,
		234,
		241,
		228,
		224,
		241,
		254,
		236,
		250,
		249,
		-1,
		242,
		260,
		267,
		235,
		233,
		217,
		215,
		233,
		235,
		241,
		241,
		-1,
		251,
		252,
		247,
		255,
		257,
		233,
		220,
		220,
		230,
		223,
		242,
		230,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		251,
		234,
		251,
		243,
		233,
		248,
		241,
		223,
		220,
		218,
		215,
		231,
		229,
		239,
		-1,
		-1,
		344,
		313,
		342,
		300,
		281,
		-1,
		247,
		227,
		233,
		237,
		231,
		224,
		238,
		234,
		-1,
		209,
		208,
		236,
		222,
		233,
		304,
		-1,
		-1,
		302,
		294,
		277,
		280,
		257,
		253,
		242,
		241,
		233,
		219,
		215,
		221,
		224,
		224,
		230,
		203,
		213,
		217,
		215,
		240,
		-1,
		-1,
		275,
		-1,
		-1,
		301,
		284,
		-1,
		267,
		274,
		263,
		269,
		255,
		276,
		252,
		243,
		235,
		229,
		217,
		219,
		216,
		229,
		217,
		200,
		225,
		229,
		210,
		231,
		226,
		-1,
		274,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		260,
		263,
		269,
		293,
		292,
		-1,
		264,
		252,
		253,
		238,
		235,
		222,
		210,
		223,
		208,
		215,
		214,
		204,
		202,
		232,
		207,
		229,
		226,
		245,
		250,
		244,
		253,
		-1,
		309,
		305,
		301,
		308,
		257,
		-1,
		-1,
		297,
		-1,
		300,
		301,
		276,
		249,
		252,
		239,
		230,
		217,
		206,
		217,
		206,
		203,
		211,
		196,
		211,
		202,
		201,
		219,
		229,
		237,
		241,
		247,
		-1,
		359,
		-1,
		301,
		285,
		287,
		259,
		280,
		-1,
		317,
		301,
		293,
		278,
		278,
		-1,
		248,
		245,
		235,
		213,
		198,
		215,
		207,
		205,
		209,
		191,
		205,
		196,
		214,
		221,
		219,
		223,
		243,
		255,
		319,
		309,
		-1,
		291,
		296,
		255,
		263,
		282,
		320,
		284,
		-1,
		279,
		-1,
		250,
		263,
		-1,
		219,
		215,
		197,
		198,
		193,
		208,
		202,
		187,
		184,
		202,
		205,
		212,
		216,
		232,
		-1,
		-1,
		304,
		308,
		297,
		248,
		267,
		291,
		328,
		277,
		266,
		265,
		-1,
		256,
		233,
		230,
		218,
		205,
		190,
		191,
		199,
		212,
		191,
		186,
		183,
		203,
		229,
		207,
		219,
		-1,
		-1,
		-1,
		329,
		-1,
		-1,
		274,
		245,
		269,
		311,
		295,
		288,
		276,
		241,
		241,
		235,
		-1,
		229,
		208,
		199,
		188,
		186,
		199,
		196,
		201,
		181,
		179,
		198,
		210,
		201,
		218,
		-1,
		-1,
		-1,
		304,
		293,
		294,
		240,
		263,
		300,
		274,
		260,
		265,
		240,
		233,
		227,
		242,
		225,
		206,
		195,
		187,
		176,
		192,
		200,
		195,
		177,
		186,
		192,
		216,
		206,
		212,
		-1,
		-1,
		311,
		301,
		285,
		287,
		284,
		254,
		261,
		293,
		265,
		278,
		-1,
		232,
		-1,
		221,
		216,
		200,
		195,
		192,
		189,
		183,
		192,
		194,
		184,
		179,
		186,
		221,
		221,
		196,
		216,
		219,
		-1,
		-1,
		-1,
		304,
		299,
		274,
		251,
		235,
		271,
		-1,
		248,
		249,
		-1,
		226,
		220,
		217,
		202,
		198,
		193,
		197,
		190,
		197,
		190,
		188,
		189,
		171,
		203,
		-1,
		204,
		198,
		206,
		196,
		184,
		-1,
		-1,
		-1,
		297,
		276,
		269,
		289,
		230,
		282,
		-1,
		-1,
		233,
		226,
		-1,
		213,
		195,
		202,
		200,
		194,
		198,
		195,
		184,
		197,
		190,
		176,
		178,
		191,
		195,
		199,
		186,
		182,
		179,
		193,
		-1,
		316,
		-1,
		-1,
		-1,
		-1,
		-1,
		230,
		250,
		-1,
		242,
		234,
		224,
		218,
		212,
		208,
		206,
		222,
		206,
		209,
		207,
		198,
		206,
		179,
		172,
		179,
		168,
		186,
		194,
		186,
		180,
		179,
		189,
		-1,
		317,
		303,
		274,
		-1,
		-1,
		263,
		-1,
		227,
		241,
		257,
		-1,
		250,
		229,
		244,
		222,
		218,
		214,
		229,
		230,
		207,
		207,
		205,
		196,
		184,
		173,
		176,
		168,
		190,
		190,
		174,
		175,
		179,
		-1,
		323,
		310,
		268,
		264,
		253,
		273,
		224,
		212,
		244,
		-1,
		-1,
		286,
		-1,
		220,
		237,
		228,
		226,
		219,
		201,
		208,
		216,
		193,
		188,
		178,
		167,
		167,
		162,
		184,
		170,
		168,
		177,
		193,
		-1,
		-1,
		-1,
		290,
		-1,
		-1,
		239,
		226,
		220,
		-1,
		261,
		-1,
		264,
		254,
		238,
		223,
		256,
		-1,
		200,
		196,
		203,
		-1,
		213,
		-1,
		186,
		183,
		174,
		159,
		156,
		167,
		165,
		176,
		172,
		-1,
		273,
		258,
		251,
		241,
		255,
		226,
		-1,
		281,
		-1,
		-1,
		251,
		245,
		245,
		229,
		230,
		216,
		196,
		188,
		203,
		202,
		189,
		188,
		172,
		165,
		162,
		155,
		168,
		178,
		183,
		170,
		-1,
		-1,
		-1,
		278,
		264,
		268,
		228,
		247,
		-1,
		-1,
		313,
		268,
		254,
		-1,
		225,
		216,
		204,
		194,
		184,
		189,
		190,
		180,
		178,
		170,
		172,
		166,
		157,
		156,
		172,
		164,
		186,
		-1,
		-1,
		261,
		266,
		254,
		240,
		252,
		-1,
		-1,
		-1,
		260,
		276,
		244,
		223,
		205,
		-1,
		-1,
		188,
		181,
		175,
		178,
		166,
		186,
		181,
		165,
		150,
		165,
		169,
		177,
		168,
		-1,
		264,
		251,
		-1,
		-1,
		251,
		241,
		-1,
		-1,
		-1,
		-1,
		256,
		201,
		190,
		185,
		189,
		187,
		-1,
		161,
		172,
		165,
		184,
		191,
		167,
		152,
		146,
		152,
		164,
		173,
		-1,
		-1,
		265,
		-1,
		227,
		-1,
		-1,
		-1,
		-1,
		213,
		207,
		178,
		171,
		175,
		-1,
		163,
		165,
		162,
		174,
		170,
		167,
		158,
		149,
		145,
		149,
		153,
		167,
		171,
		288,
		-1,
		218,
		-1,
		-1,
		-1,
		231,
		246,
		217,
		194,
		167,
		162,
		155,
		149,
		154,
		165,
		174,
		185,
		150,
		152,
		142,
		141,
		145,
		162,
		166,
		-1,
		-1,
		216,
		212,
		247,
		239,
		243,
		244,
		-1,
		-1,
		171,
		162,
		153,
		145,
		158,
		161,
		146,
		148,
		148,
		146,
		140,
		150,
		165,
		160,
		-1,
		-1,
		-1,
		228,
		-1,
		230,
		-1,
		-1,
		241,
		242,
		189,
		171,
		167,
		165,
		154,
		148,
		136,
		141,
		151,
		145,
		142,
		136,
		140,
		163,
		152,
		191,
		-1,
		-1,
		252,
		-1,
		-1,
		-1,
		212,
		199,
		194,
		223,
		225,
		216,
		204,
		201,
		-1,
		171,
		177,
		142,
		149,
		132,
		139,
		144,
		141,
		130,
		137,
		153,
		152,
		147,
		183,
		174,
		180,
		-1,
		-1,
		245,
		234,
		223,
		229,
		-1,
		205,
		196,
		209,
		199,
		202,
		-1,
		-1,
		196,
		193,
		173,
		142,
		140,
		133,
		128,
		138,
		114,
		126,
		130,
		134,
		140,
		145,
		150,
		156,
		171,
		186,
		-1,
		199,
		236,
		229,
		197,
		205,
		236,
		-1,
		195,
		187,
		193,
		191,
		193,
		-1,
		-1,
		169,
		160,
		161,
		149,
		146,
		152,
		151,
		134,
		140,
		141,
		133,
		132,
		150,
		154,
		163,
		170,
		160,
		173,
		177,
		-1,
		192,
		212,
		191,
		194,
		218,
		232,
		-1,
		186,
		-1,
		-1,
		153,
		194,
		178,
		168,
		165,
		208,
		163,
		158,
		139,
		137,
		132,
		123,
		148,
		141,
		141,
		144,
		159,
		164,
		156,
		170,
		170,
		171,
		-1,
		181,
		192,
		185,
		-1,
		-1,
		-1,
		-1,
		180,
		-1,
		-1,
		143,
		-1,
		205,
		-1,
		188,
		192,
		171,
		174,
		153,
		140,
		126,
		134,
		140,
		139,
		145,
		145,
		146,
		155,
		166,
		178,
		177,
		178,
		206,
		162,
		165,
		176,
		187,
		202,
		206,
		-1,
		170,
		206,
		149,
		-1,
		133,
		-1,
		-1,
		-1,
		202,
		184,
		176,
		173,
		152,
		152,
		118,
		122,
		135,
		142,
		152,
		163,
		155,
		159,
		172,
		183,
		186,
		202,
		193,
		206,
		151,
		151,
		172,
		181,
		202,
		166,
		163,
		200,
		156,
		145,
		140,
		127,
		-1,
		-1,
		186,
		194,
		-1,
		-1,
		159,
		126,
		114,
		124,
		128,
		142,
		154,
		167,
		155,
		160,
		154,
		186,
		-1,
		195,
		194,
		183,
		180,
		156,
		147,
		142,
		169,
		-1,
		-1,
		164,
		191,
		175,
		179,
		187,
		212,
		-1,
		111,
		-1,
		-1,
		166,
		-1,
		-1,
		151,
		131,
		120,
		111,
		116,
		136,
		147,
		169,
		151,
		168,
		159,
		169,
		173,
		179,
		176,
		164,
		162,
		185,
		150,
		138,
		-1,
		146,
		149,
		155,
		162,
		179,
		201,
		-1,
		-1,
		127,
		107,
		-1,
		-1,
		149,
		147,
		136,
		-1,
		126,
		108,
		113,
		143,
		145,
		147,
		154,
		148,
		155,
		163,
		174,
		166,
		188,
		202,
		191,
		187,
		186,
		194,
		143,
		136,
		143,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		132,
		-1,
		117,
		113,
		-1,
		-1,
		144,
		137,
		125,
		113,
		103,
		113,
		130,
		130,
		133,
		138,
		146,
		157,
		153,
		157,
		160,
		-1,
		222,
		-1,
		174,
		135,
		141,
		156,
		164,
		-1,
		-1,
		-1,
		134,
		120,
		113,
		101,
		99,
		-1,
		178,
		162,
		143,
		-1,
		113,
		126,
		166,
		134,
		139,
		134,
		149,
		160,
		151,
		159,
		153,
		156,
		-1,
		-1,
		134,
		117,
		-1,
		-1,
		91,
		93,
		-1,
		125,
		114,
		99,
		91,
		-1,
		-1,
		150,
		146,
		-1,
		-1,
		100,
		138,
		137,
		145,
		140,
		145,
		157,
		153,
		149,
		159,
		150,
		-1,
		-1,
		112,
		104,
		98,
		-1,
		76,
		-1,
		127,
		-1,
		94,
		103,
		91,
		-1,
		-1,
		-1,
		131,
		94,
		110,
		133,
		159,
		157,
		148,
		141,
		148,
		151,
		144,
		150,
		-1,
		-1,
		-1,
		94,
		68,
		134,
		125,
		108,
		88,
		80,
		102,
		-1,
		112,
		-1,
		87,
		90,
		115,
		154,
		156,
		142,
		138,
		151,
		145,
		142,
		140,
		100,
		-1,
		70,
		103,
		67,
		94,
		60,
		74,
		126,
		-1,
		109,
		91,
		-1,
		119,
		109,
		157,
		132,
		141,
		134,
		128,
		129,
		137,
		-1,
		-1,
		-1,
		72,
		71,
		63,
		57,
		57,
		55,
		72,
		-1,
		114,
		96,
		82,
		99,
		99,
		90,
		98,
		147,
		143,
		146,
		144,
		122,
		-1,
		129,
		-1,
		-1,
		95,
		-1,
		-1,
		-1,
		66,
		50,
		63,
		74,
		83,
		79,
		79,
		81,
		94,
		102,
		100,
		97,
		109,
		105,
		125,
		121,
		153,
		-1,
		124,
		-1,
		102,
		-1,
		-1,
		47,
		34,
		44,
		55,
		83,
		83,
		78,
		74,
		91,
		126,
		112,
		110,
		115,
		120,
		-1,
		113,
		112,
		-1,
		66,
		58,
		44,
		-1,
		25,
		-1,
		129,
		90,
		-1,
		75,
		69,
		-1,
		121,
		117,
		-1,
		-1,
		100,
		82,
		-1,
		-1,
		-1,
		45,
		6,
		124,
		108,
		-1,
		59,
		66,
		-1,
		-1,
		-1,
		85,
		86,
		-1,
		38,
		41,
		-1,
		0,
		8,
		37,
		54,
		60,
		-1,
		-1,
		-1,
		94,
		75,
		69,
		53,
		58,
		46,
		33,
		19,
		22,
		39,
		51,
		80,
		-1,
		-1,
		-1,
		66,
		58,
		58,
		-1,
		-1,
		47,
		30,
		30,
		48,
		-1,
		-1,
		-1,
		88,
		69,
		-1,
		-1,
		67,
		-1,
		-1,
		43,
		49,
		-1,
		-1,
		-1,
		-1,
		-1,
		104,
		77,
		-1,
		-1,
		-1,
		68,
		70,
		54,
		-1,
		-1,
		-1,
		-1,
		98,
		99,
		123,
		98,
		-1,
		-1,
		-1,
		66,
		60,
		-1,
		-1,
		101,
		99,
		-1,
		-1,
		-1,
		94,
		78,
		-1,
		64,
		-1,
		-1,
		-1,
		85,
		-1,
		-1,
		97,
		-1,
		-1,
		-1,
		99,
		-1,
		99,
		74,
		81,
		-1,
		-1,
		-1,
		-1,
		112,
		104,
		112,
		-1,
		84,
		86,
		-1,
		134,
		-1,
		-1,
		127,
		118,
		-1,
		-1,
		89,
		96,
		118,
		121,
		157,
		-1,
		108
	],
	[
		-1,
		296,
		285,
		296,
		304,
		277,
		284,
		-1,
		303,
		307,
		273,
		267,
		306,
		275,
		281,
		292,
		-1,
		-1,
		-1,
		296,
		295,
		263,
		261,
		270,
		275,
		282,
		-1,
		281,
		-1,
		317,
		296,
		307,
		312,
		256,
		253,
		273,
		292,
		274,
		266,
		332,
		286,
		257,
		251,
		269,
		259,
		268,
		260,
		-1,
		257,
		247,
		269,
		248,
		259,
		251,
		-1,
		-1,
		251,
		252,
		258,
		244,
		250,
		246,
		-1,
		256,
		240,
		-1,
		-1,
		241,
		242,
		226,
		229,
		237,
		235,
		248,
		240,
		235,
		-1,
		-1,
		232,
		228,
		235,
		222,
		218,
		235,
		248,
		230,
		244,
		243,
		-1,
		236,
		254,
		261,
		229,
		227,
		211,
		209,
		227,
		229,
		235,
		235,
		-1,
		245,
		246,
		241,
		249,
		251,
		227,
		214,
		214,
		224,
		217,
		236,
		224,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		245,
		228,
		245,
		237,
		227,
		242,
		235,
		217,
		214,
		212,
		209,
		225,
		223,
		233,
		-1,
		-1,
		338,
		307,
		336,
		294,
		275,
		-1,
		241,
		221,
		227,
		231,
		225,
		218,
		232,
		228,
		-1,
		203,
		202,
		230,
		216,
		227,
		298,
		-1,
		-1,
		296,
		288,
		271,
		274,
		251,
		247,
		236,
		235,
		227,
		213,
		209,
		215,
		218,
		218,
		224,
		197,
		207,
		211,
		209,
		234,
		-1,
		-1,
		269,
		-1,
		-1,
		295,
		278,
		-1,
		261,
		268,
		257,
		263,
		249,
		270,
		246,
		237,
		229,
		223,
		211,
		213,
		210,
		223,
		211,
		194,
		219,
		223,
		204,
		225,
		220,
		-1,
		268,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		254,
		257,
		263,
		287,
		286,
		-1,
		258,
		246,
		247,
		232,
		229,
		216,
		204,
		217,
		202,
		209,
		208,
		198,
		196,
		226,
		201,
		223,
		220,
		239,
		244,
		238,
		247,
		-1,
		303,
		299,
		295,
		302,
		251,
		-1,
		-1,
		291,
		-1,
		294,
		295,
		270,
		243,
		246,
		233,
		224,
		211,
		200,
		211,
		200,
		197,
		205,
		190,
		205,
		196,
		195,
		213,
		223,
		231,
		235,
		241,
		-1,
		353,
		-1,
		295,
		279,
		281,
		253,
		274,
		-1,
		311,
		295,
		287,
		272,
		272,
		-1,
		242,
		239,
		229,
		207,
		192,
		209,
		201,
		199,
		203,
		185,
		199,
		190,
		208,
		215,
		213,
		217,
		237,
		249,
		313,
		303,
		-1,
		285,
		290,
		249,
		257,
		276,
		314,
		278,
		-1,
		273,
		-1,
		244,
		257,
		-1,
		213,
		209,
		191,
		192,
		187,
		202,
		196,
		181,
		178,
		196,
		199,
		206,
		210,
		226,
		-1,
		-1,
		298,
		302,
		291,
		242,
		261,
		285,
		322,
		271,
		260,
		259,
		-1,
		250,
		227,
		224,
		212,
		199,
		184,
		185,
		193,
		206,
		185,
		180,
		177,
		197,
		223,
		201,
		213,
		-1,
		-1,
		-1,
		323,
		-1,
		-1,
		268,
		239,
		263,
		305,
		289,
		282,
		270,
		235,
		235,
		229,
		-1,
		223,
		202,
		193,
		182,
		180,
		193,
		190,
		195,
		175,
		173,
		192,
		204,
		195,
		212,
		-1,
		-1,
		-1,
		298,
		287,
		288,
		234,
		257,
		294,
		268,
		254,
		259,
		234,
		227,
		221,
		236,
		219,
		200,
		189,
		181,
		170,
		186,
		194,
		189,
		171,
		180,
		186,
		210,
		200,
		206,
		-1,
		-1,
		305,
		295,
		279,
		281,
		278,
		248,
		255,
		287,
		259,
		272,
		-1,
		226,
		-1,
		215,
		210,
		194,
		189,
		186,
		183,
		177,
		186,
		188,
		178,
		173,
		180,
		215,
		215,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		298,
		293,
		268,
		245,
		229,
		265,
		-1,
		242,
		243,
		-1,
		220,
		214,
		211,
		196,
		192,
		187,
		191,
		184,
		191,
		184,
		182,
		183,
		165,
		197,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		291,
		270,
		263,
		283,
		224,
		276,
		-1,
		-1,
		227,
		220,
		-1,
		207,
		189,
		196,
		194,
		188,
		192,
		189,
		178,
		191,
		184,
		170,
		172,
		185,
		189,
		193,
		180,
		176,
		173,
		187,
		-1,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		244,
		-1,
		236,
		228,
		218,
		212,
		206,
		202,
		200,
		216,
		200,
		203,
		201,
		192,
		200,
		173,
		166,
		173,
		162,
		180,
		188,
		180,
		174,
		173,
		183,
		-1,
		311,
		297,
		268,
		-1,
		-1,
		257,
		-1,
		221,
		235,
		251,
		-1,
		244,
		223,
		238,
		216,
		212,
		208,
		223,
		224,
		201,
		201,
		199,
		190,
		178,
		167,
		170,
		162,
		184,
		184,
		168,
		169,
		173,
		-1,
		317,
		304,
		262,
		258,
		247,
		267,
		218,
		206,
		238,
		-1,
		-1,
		280,
		-1,
		214,
		231,
		222,
		220,
		213,
		195,
		202,
		210,
		187,
		182,
		172,
		161,
		161,
		156,
		178,
		164,
		162,
		171,
		187,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		233,
		220,
		214,
		-1,
		255,
		-1,
		258,
		248,
		232,
		217,
		250,
		-1,
		194,
		190,
		197,
		-1,
		207,
		-1,
		180,
		177,
		168,
		153,
		150,
		161,
		159,
		170,
		166,
		-1,
		267,
		252,
		245,
		235,
		249,
		220,
		-1,
		275,
		-1,
		-1,
		245,
		239,
		239,
		223,
		224,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		166,
		159,
		156,
		149,
		162,
		172,
		177,
		164,
		-1,
		-1,
		-1,
		272,
		258,
		262,
		222,
		241,
		-1,
		-1,
		307,
		262,
		248,
		-1,
		219,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		164,
		166,
		160,
		151,
		150,
		166,
		158,
		180,
		-1,
		-1,
		255,
		260,
		248,
		234,
		253,
		-1,
		-1,
		-1,
		254,
		270,
		238,
		217,
		199,
		-1,
		-1,
		182,
		175,
		169,
		172,
		160,
		180,
		175,
		159,
		144,
		159,
		163,
		171,
		162,
		-1,
		258,
		245,
		-1,
		-1,
		256,
		247,
		-1,
		-1,
		-1,
		-1,
		250,
		195,
		184,
		179,
		183,
		181,
		-1,
		155,
		166,
		159,
		178,
		185,
		161,
		146,
		140,
		146,
		158,
		167,
		-1,
		-1,
		270,
		-1,
		233,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		172,
		165,
		169,
		-1,
		157,
		159,
		156,
		168,
		164,
		161,
		152,
		143,
		139,
		143,
		147,
		161,
		165,
		293,
		-1,
		224,
		-1,
		-1,
		-1,
		225,
		240,
		211,
		188,
		161,
		156,
		149,
		143,
		148,
		159,
		168,
		179,
		144,
		146,
		136,
		135,
		139,
		156,
		160,
		-1,
		-1,
		222,
		218,
		251,
		233,
		237,
		238,
		-1,
		-1,
		165,
		156,
		147,
		139,
		152,
		155,
		140,
		142,
		142,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		234,
		-1,
		236,
		-1,
		-1,
		235,
		236,
		183,
		165,
		161,
		159,
		148,
		142,
		130,
		135,
		145,
		139,
		136,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		258,
		-1,
		-1,
		-1,
		218,
		205,
		200,
		217,
		219,
		210,
		198,
		195,
		-1,
		165,
		171,
		136,
		143,
		126,
		133,
		138,
		135,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		251,
		240,
		229,
		235,
		-1,
		211,
		202,
		203,
		193,
		196,
		-1,
		-1,
		190,
		187,
		167,
		136,
		134,
		127,
		122,
		132,
		108,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		205,
		242,
		235,
		203,
		211,
		242,
		-1,
		201,
		193,
		199,
		185,
		187,
		-1,
		-1,
		163,
		154,
		155,
		143,
		140,
		146,
		145,
		128,
		134,
		135,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		198,
		218,
		197,
		200,
		224,
		238,
		-1,
		192,
		-1,
		-1,
		159,
		188,
		172,
		162,
		159,
		202,
		157,
		152,
		133,
		131,
		126,
		117,
		142,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		187,
		198,
		191,
		-1,
		-1,
		-1,
		-1,
		186,
		-1,
		-1,
		149,
		-1,
		199,
		-1,
		182,
		186,
		165,
		168,
		147,
		134,
		120,
		128,
		134,
		133,
		139,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		212,
		168,
		171,
		182,
		193,
		208,
		212,
		-1,
		176,
		212,
		155,
		-1,
		139,
		-1,
		-1,
		-1,
		196,
		178,
		170,
		167,
		146,
		146,
		112,
		116,
		129,
		136,
		146,
		157,
		149,
		153,
		166,
		177,
		180,
		208,
		199,
		212,
		157,
		157,
		178,
		187,
		208,
		172,
		169,
		206,
		162,
		151,
		146,
		133,
		-1,
		-1,
		180,
		188,
		-1,
		-1,
		153,
		120,
		108,
		118,
		122,
		136,
		148,
		161,
		149,
		154,
		148,
		180,
		-1,
		201,
		200,
		189,
		186,
		162,
		153,
		148,
		175,
		-1,
		-1,
		170,
		197,
		181,
		185,
		193,
		218,
		-1,
		117,
		-1,
		-1,
		160,
		-1,
		-1,
		145,
		125,
		114,
		105,
		110,
		130,
		141,
		163,
		145,
		162,
		153,
		163,
		167,
		185,
		182,
		170,
		168,
		191,
		156,
		144,
		-1,
		152,
		155,
		161,
		168,
		185,
		207,
		-1,
		-1,
		133,
		113,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		102,
		107,
		137,
		139,
		141,
		148,
		142,
		149,
		157,
		168,
		160,
		194,
		208,
		197,
		193,
		192,
		200,
		149,
		142,
		149,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		-1,
		123,
		119,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		124,
		124,
		127,
		132,
		140,
		151,
		147,
		151,
		154,
		-1,
		228,
		-1,
		180,
		141,
		147,
		162,
		170,
		-1,
		-1,
		-1,
		140,
		126,
		119,
		107,
		105,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		160,
		128,
		133,
		128,
		143,
		154,
		145,
		153,
		147,
		150,
		-1,
		-1,
		140,
		123,
		-1,
		-1,
		97,
		99,
		-1,
		131,
		120,
		105,
		97,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		94,
		132,
		131,
		139,
		134,
		139,
		151,
		147,
		143,
		153,
		144,
		-1,
		-1,
		118,
		110,
		104,
		-1,
		82,
		-1,
		133,
		-1,
		100,
		109,
		97,
		-1,
		-1,
		-1,
		125,
		88,
		104,
		127,
		153,
		151,
		142,
		135,
		142,
		145,
		138,
		144,
		-1,
		-1,
		-1,
		100,
		74,
		140,
		131,
		114,
		94,
		86,
		108,
		-1,
		106,
		-1,
		81,
		84,
		109,
		148,
		150,
		136,
		132,
		145,
		139,
		136,
		134,
		106,
		-1,
		76,
		109,
		73,
		100,
		66,
		80,
		120,
		-1,
		103,
		85,
		-1,
		113,
		103,
		151,
		126,
		135,
		128,
		122,
		123,
		131,
		-1,
		-1,
		-1,
		78,
		77,
		69,
		63,
		63,
		61,
		78,
		-1,
		108,
		90,
		76,
		93,
		93,
		84,
		92,
		141,
		137,
		140,
		138,
		116,
		-1,
		135,
		-1,
		-1,
		101,
		-1,
		-1,
		-1,
		72,
		56,
		69,
		76,
		77,
		73,
		73,
		75,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		115,
		147,
		-1,
		130,
		-1,
		108,
		-1,
		-1,
		53,
		40,
		50,
		61,
		88,
		86,
		72,
		68,
		85,
		120,
		106,
		104,
		109,
		114,
		-1,
		119,
		118,
		-1,
		72,
		64,
		50,
		-1,
		31,
		-1,
		134,
		95,
		-1,
		69,
		63,
		-1,
		115,
		111,
		-1,
		-1,
		106,
		88,
		-1,
		-1,
		-1,
		51,
		13,
		129,
		113,
		-1,
		53,
		60,
		-1,
		-1,
		-1,
		91,
		92,
		-1,
		44,
		47,
		-1,
		9,
		0,
		29,
		47,
		54,
		-1,
		-1,
		-1,
		100,
		81,
		75,
		59,
		64,
		52,
		25,
		11,
		15,
		32,
		45,
		74,
		-1,
		-1,
		-1,
		72,
		64,
		64,
		-1,
		-1,
		39,
		22,
		23,
		41,
		-1,
		-1,
		-1,
		94,
		75,
		-1,
		-1,
		72,
		-1,
		-1,
		36,
		43,
		-1,
		-1,
		-1,
		-1,
		-1,
		110,
		83,
		-1,
		-1,
		-1,
		68,
		64,
		47,
		-1,
		-1,
		-1,
		-1,
		104,
		105,
		129,
		104,
		-1,
		-1,
		-1,
		60,
		54,
		-1,
		-1,
		107,
		105,
		-1,
		-1,
		-1,
		88,
		72,
		-1,
		58,
		-1,
		-1,
		-1,
		79,
		-1,
		-1,
		91,
		-1,
		-1,
		-1,
		93,
		-1,
		93,
		68,
		75,
		-1,
		-1,
		-1,
		-1,
		106,
		98,
		106,
		-1,
		78,
		80,
		-1,
		128,
		-1,
		-1,
		121,
		112,
		-1,
		-1,
		83,
		90,
		112,
		115,
		151,
		-1,
		102
	],
	[
		-1,
		304,
		293,
		304,
		312,
		285,
		292,
		-1,
		311,
		315,
		281,
		275,
		314,
		283,
		289,
		300,
		-1,
		-1,
		-1,
		304,
		303,
		271,
		269,
		278,
		283,
		290,
		-1,
		289,
		-1,
		325,
		304,
		315,
		320,
		264,
		261,
		281,
		300,
		282,
		274,
		340,
		294,
		265,
		259,
		277,
		267,
		276,
		268,
		-1,
		265,
		255,
		277,
		256,
		267,
		259,
		-1,
		-1,
		259,
		260,
		266,
		252,
		258,
		254,
		-1,
		264,
		248,
		-1,
		-1,
		249,
		250,
		234,
		237,
		245,
		243,
		256,
		248,
		243,
		-1,
		-1,
		240,
		236,
		243,
		230,
		226,
		243,
		256,
		238,
		252,
		251,
		-1,
		244,
		262,
		269,
		237,
		235,
		219,
		217,
		235,
		237,
		243,
		243,
		-1,
		253,
		254,
		249,
		257,
		259,
		235,
		222,
		222,
		232,
		225,
		244,
		232,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		253,
		236,
		253,
		245,
		235,
		250,
		243,
		225,
		222,
		220,
		217,
		233,
		231,
		241,
		-1,
		-1,
		346,
		315,
		344,
		302,
		283,
		-1,
		249,
		229,
		235,
		239,
		233,
		226,
		240,
		236,
		-1,
		211,
		210,
		238,
		224,
		235,
		306,
		-1,
		-1,
		304,
		296,
		279,
		282,
		259,
		255,
		244,
		243,
		235,
		221,
		217,
		223,
		226,
		226,
		232,
		205,
		215,
		219,
		217,
		242,
		-1,
		-1,
		277,
		-1,
		-1,
		303,
		286,
		-1,
		269,
		276,
		265,
		271,
		257,
		278,
		254,
		245,
		237,
		231,
		219,
		221,
		218,
		231,
		219,
		202,
		227,
		231,
		212,
		233,
		228,
		-1,
		276,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		262,
		265,
		271,
		295,
		294,
		-1,
		266,
		254,
		255,
		240,
		237,
		224,
		212,
		225,
		210,
		217,
		216,
		206,
		204,
		234,
		209,
		231,
		228,
		247,
		252,
		246,
		255,
		-1,
		311,
		307,
		303,
		310,
		259,
		-1,
		-1,
		299,
		-1,
		302,
		303,
		278,
		251,
		254,
		241,
		232,
		219,
		208,
		219,
		208,
		205,
		213,
		198,
		213,
		204,
		203,
		221,
		231,
		239,
		243,
		249,
		-1,
		361,
		-1,
		303,
		287,
		289,
		261,
		282,
		-1,
		319,
		303,
		295,
		280,
		280,
		-1,
		250,
		247,
		237,
		215,
		200,
		217,
		209,
		207,
		211,
		193,
		207,
		198,
		216,
		223,
		221,
		225,
		245,
		257,
		321,
		311,
		-1,
		293,
		298,
		257,
		265,
		284,
		322,
		286,
		-1,
		281,
		-1,
		252,
		265,
		-1,
		221,
		217,
		199,
		200,
		195,
		210,
		204,
		189,
		186,
		204,
		207,
		214,
		218,
		234,
		-1,
		-1,
		306,
		310,
		299,
		250,
		269,
		293,
		330,
		279,
		268,
		267,
		-1,
		258,
		235,
		232,
		220,
		207,
		192,
		193,
		201,
		214,
		193,
		188,
		185,
		205,
		231,
		209,
		221,
		-1,
		-1,
		-1,
		331,
		-1,
		-1,
		276,
		247,
		271,
		313,
		297,
		290,
		278,
		243,
		243,
		237,
		-1,
		231,
		210,
		201,
		190,
		188,
		201,
		198,
		203,
		183,
		181,
		200,
		212,
		203,
		220,
		-1,
		-1,
		-1,
		306,
		295,
		296,
		242,
		265,
		302,
		276,
		262,
		267,
		242,
		235,
		229,
		244,
		227,
		208,
		197,
		189,
		178,
		194,
		202,
		197,
		179,
		188,
		194,
		218,
		208,
		214,
		-1,
		-1,
		313,
		303,
		287,
		289,
		286,
		256,
		263,
		295,
		267,
		280,
		-1,
		234,
		-1,
		223,
		218,
		202,
		197,
		194,
		191,
		185,
		194,
		196,
		186,
		181,
		188,
		223,
		223,
		198,
		218,
		221,
		-1,
		-1,
		-1,
		306,
		301,
		276,
		253,
		237,
		273,
		-1,
		250,
		251,
		-1,
		228,
		222,
		219,
		204,
		200,
		195,
		199,
		192,
		199,
		192,
		190,
		191,
		173,
		205,
		-1,
		206,
		200,
		208,
		198,
		186,
		-1,
		-1,
		-1,
		299,
		278,
		271,
		291,
		232,
		284,
		-1,
		-1,
		235,
		228,
		-1,
		215,
		197,
		204,
		202,
		196,
		200,
		197,
		186,
		199,
		192,
		178,
		180,
		193,
		197,
		201,
		188,
		184,
		181,
		195,
		-1,
		318,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		252,
		-1,
		244,
		236,
		226,
		220,
		214,
		210,
		208,
		224,
		208,
		211,
		209,
		200,
		208,
		181,
		174,
		181,
		170,
		188,
		196,
		188,
		182,
		181,
		191,
		-1,
		319,
		305,
		276,
		-1,
		-1,
		265,
		-1,
		229,
		243,
		259,
		-1,
		252,
		231,
		246,
		224,
		220,
		216,
		231,
		232,
		209,
		209,
		207,
		198,
		186,
		175,
		178,
		170,
		192,
		192,
		176,
		177,
		181,
		-1,
		325,
		312,
		270,
		266,
		255,
		275,
		226,
		214,
		246,
		-1,
		-1,
		288,
		-1,
		222,
		239,
		230,
		228,
		221,
		203,
		210,
		218,
		195,
		190,
		180,
		169,
		169,
		164,
		186,
		172,
		170,
		179,
		195,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		241,
		228,
		222,
		-1,
		263,
		-1,
		266,
		256,
		240,
		225,
		258,
		-1,
		202,
		198,
		205,
		-1,
		215,
		-1,
		188,
		185,
		176,
		161,
		158,
		169,
		167,
		178,
		174,
		-1,
		275,
		260,
		253,
		243,
		257,
		228,
		-1,
		283,
		-1,
		-1,
		253,
		247,
		247,
		231,
		232,
		218,
		198,
		190,
		205,
		204,
		191,
		190,
		174,
		167,
		164,
		157,
		170,
		180,
		185,
		172,
		-1,
		-1,
		-1,
		280,
		266,
		270,
		230,
		249,
		-1,
		-1,
		315,
		270,
		256,
		-1,
		227,
		218,
		206,
		196,
		186,
		191,
		192,
		182,
		180,
		172,
		174,
		168,
		159,
		158,
		174,
		166,
		188,
		-1,
		-1,
		263,
		268,
		256,
		242,
		261,
		-1,
		-1,
		-1,
		262,
		278,
		246,
		225,
		207,
		-1,
		-1,
		190,
		183,
		177,
		180,
		168,
		188,
		183,
		167,
		152,
		167,
		171,
		179,
		170,
		-1,
		266,
		253,
		-1,
		-1,
		264,
		258,
		-1,
		-1,
		-1,
		-1,
		258,
		203,
		192,
		187,
		191,
		189,
		-1,
		163,
		174,
		167,
		186,
		193,
		169,
		154,
		148,
		154,
		166,
		175,
		-1,
		-1,
		278,
		-1,
		251,
		-1,
		-1,
		-1,
		-1,
		215,
		209,
		180,
		173,
		177,
		-1,
		165,
		167,
		164,
		176,
		172,
		169,
		160,
		151,
		147,
		151,
		155,
		169,
		173,
		301,
		-1,
		242,
		-1,
		-1,
		-1,
		233,
		248,
		219,
		196,
		169,
		164,
		157,
		151,
		156,
		167,
		176,
		187,
		152,
		154,
		144,
		143,
		147,
		164,
		168,
		-1,
		-1,
		240,
		236,
		259,
		241,
		245,
		246,
		-1,
		-1,
		173,
		164,
		155,
		147,
		160,
		163,
		148,
		150,
		150,
		148,
		142,
		152,
		167,
		162,
		-1,
		-1,
		-1,
		252,
		-1,
		254,
		-1,
		-1,
		243,
		244,
		191,
		173,
		169,
		167,
		156,
		150,
		138,
		143,
		153,
		147,
		144,
		138,
		142,
		165,
		154,
		193,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		232,
		223,
		218,
		225,
		227,
		218,
		206,
		203,
		-1,
		173,
		179,
		144,
		151,
		134,
		141,
		146,
		143,
		132,
		139,
		155,
		154,
		149,
		185,
		176,
		182,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		225,
		220,
		211,
		201,
		204,
		-1,
		-1,
		198,
		195,
		175,
		144,
		142,
		135,
		130,
		140,
		116,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		233,
		270,
		263,
		231,
		239,
		270,
		-1,
		215,
		207,
		217,
		193,
		195,
		-1,
		-1,
		171,
		162,
		163,
		151,
		148,
		154,
		153,
		136,
		142,
		143,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		226,
		246,
		225,
		228,
		252,
		266,
		-1,
		212,
		-1,
		-1,
		177,
		196,
		180,
		170,
		167,
		210,
		165,
		160,
		141,
		139,
		134,
		125,
		150,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		167,
		-1,
		207,
		-1,
		190,
		194,
		173,
		176,
		155,
		142,
		128,
		136,
		142,
		141,
		147,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		204,
		240,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		204,
		186,
		178,
		175,
		154,
		154,
		120,
		124,
		137,
		144,
		154,
		165,
		157,
		161,
		174,
		185,
		188,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		200,
		197,
		234,
		180,
		169,
		164,
		151,
		-1,
		-1,
		188,
		196,
		-1,
		-1,
		161,
		128,
		116,
		126,
		130,
		144,
		156,
		169,
		157,
		162,
		156,
		188,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		225,
		209,
		213,
		211,
		236,
		-1,
		140,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		133,
		122,
		113,
		118,
		138,
		149,
		171,
		153,
		170,
		161,
		171,
		175,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		180,
		183,
		189,
		196,
		213,
		225,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		110,
		115,
		145,
		147,
		149,
		156,
		150,
		157,
		165,
		176,
		168,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		132,
		132,
		135,
		140,
		148,
		159,
		155,
		159,
		162,
		-1,
		256,
		-1,
		208,
		169,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		168,
		136,
		141,
		136,
		151,
		162,
		153,
		161,
		155,
		158,
		-1,
		-1,
		168,
		151,
		-1,
		-1,
		125,
		127,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		102,
		140,
		139,
		147,
		142,
		147,
		159,
		155,
		151,
		161,
		152,
		-1,
		-1,
		146,
		138,
		132,
		-1,
		110,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		133,
		96,
		112,
		135,
		161,
		159,
		150,
		143,
		150,
		153,
		146,
		152,
		-1,
		-1,
		-1,
		128,
		102,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		114,
		-1,
		89,
		92,
		117,
		156,
		158,
		144,
		140,
		153,
		147,
		144,
		142,
		134,
		-1,
		104,
		137,
		101,
		123,
		94,
		103,
		128,
		-1,
		111,
		93,
		-1,
		121,
		111,
		159,
		134,
		143,
		136,
		130,
		131,
		139,
		-1,
		-1,
		-1,
		106,
		105,
		97,
		91,
		91,
		89,
		95,
		-1,
		116,
		98,
		84,
		101,
		101,
		92,
		100,
		149,
		145,
		148,
		146,
		124,
		-1,
		163,
		-1,
		-1,
		129,
		-1,
		-1,
		-1,
		100,
		84,
		96,
		84,
		85,
		81,
		81,
		83,
		96,
		104,
		102,
		99,
		111,
		107,
		127,
		123,
		155,
		-1,
		158,
		-1,
		136,
		-1,
		-1,
		81,
		68,
		78,
		89,
		96,
		94,
		80,
		76,
		93,
		128,
		114,
		112,
		117,
		122,
		-1,
		147,
		146,
		-1,
		100,
		92,
		78,
		-1,
		59,
		-1,
		142,
		103,
		-1,
		77,
		71,
		-1,
		123,
		119,
		-1,
		-1,
		134,
		116,
		-1,
		-1,
		-1,
		79,
		43,
		137,
		121,
		-1,
		61,
		68,
		-1,
		-1,
		-1,
		119,
		120,
		-1,
		72,
		75,
		-1,
		39,
		30,
		0,
		54,
		62,
		-1,
		-1,
		-1,
		128,
		109,
		103,
		87,
		92,
		80,
		51,
		37,
		22,
		39,
		53,
		82,
		-1,
		-1,
		-1,
		100,
		92,
		88,
		-1,
		-1,
		47,
		30,
		30,
		48,
		-1,
		-1,
		-1,
		122,
		103,
		-1,
		-1,
		80,
		-1,
		-1,
		43,
		51,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		111,
		-1,
		-1,
		-1,
		76,
		72,
		54,
		-1,
		-1,
		-1,
		-1,
		132,
		133,
		157,
		124,
		-1,
		-1,
		-1,
		68,
		62,
		-1,
		-1,
		135,
		133,
		-1,
		-1,
		-1,
		96,
		80,
		-1,
		66,
		-1,
		-1,
		-1,
		87,
		-1,
		-1,
		99,
		-1,
		-1,
		-1,
		101,
		-1,
		101,
		76,
		83,
		-1,
		-1,
		-1,
		-1,
		114,
		106,
		114,
		-1,
		86,
		88,
		-1,
		136,
		-1,
		-1,
		129,
		120,
		-1,
		-1,
		91,
		98,
		120,
		123,
		159,
		-1,
		110
	],
	[
		-1,
		257,
		246,
		257,
		265,
		238,
		245,
		-1,
		264,
		268,
		234,
		228,
		267,
		236,
		242,
		253,
		-1,
		-1,
		-1,
		257,
		256,
		224,
		222,
		231,
		236,
		243,
		-1,
		242,
		-1,
		278,
		257,
		268,
		273,
		217,
		214,
		234,
		253,
		235,
		227,
		293,
		247,
		218,
		212,
		230,
		220,
		229,
		221,
		-1,
		218,
		208,
		230,
		209,
		220,
		212,
		-1,
		-1,
		212,
		213,
		219,
		205,
		211,
		207,
		-1,
		217,
		201,
		-1,
		-1,
		202,
		203,
		187,
		190,
		198,
		196,
		209,
		201,
		196,
		-1,
		-1,
		193,
		189,
		196,
		183,
		179,
		196,
		209,
		191,
		205,
		204,
		-1,
		197,
		215,
		222,
		190,
		188,
		172,
		170,
		188,
		190,
		196,
		196,
		-1,
		206,
		207,
		202,
		210,
		212,
		188,
		175,
		175,
		185,
		178,
		197,
		185,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		240,
		206,
		189,
		206,
		198,
		188,
		203,
		196,
		178,
		175,
		173,
		170,
		186,
		184,
		194,
		-1,
		-1,
		299,
		268,
		297,
		255,
		236,
		-1,
		202,
		182,
		188,
		192,
		186,
		179,
		193,
		189,
		-1,
		164,
		163,
		191,
		177,
		188,
		259,
		-1,
		-1,
		257,
		249,
		232,
		235,
		212,
		208,
		197,
		196,
		188,
		174,
		170,
		176,
		179,
		179,
		185,
		158,
		168,
		172,
		170,
		195,
		-1,
		-1,
		230,
		-1,
		-1,
		256,
		239,
		-1,
		222,
		229,
		218,
		224,
		210,
		231,
		207,
		198,
		190,
		184,
		172,
		174,
		171,
		184,
		172,
		155,
		180,
		184,
		165,
		186,
		181,
		-1,
		229,
		213,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		215,
		218,
		224,
		248,
		247,
		-1,
		219,
		207,
		208,
		193,
		190,
		177,
		165,
		178,
		163,
		170,
		169,
		159,
		157,
		187,
		162,
		184,
		181,
		200,
		205,
		199,
		208,
		-1,
		264,
		260,
		256,
		263,
		212,
		-1,
		-1,
		252,
		-1,
		255,
		256,
		231,
		204,
		207,
		194,
		185,
		172,
		161,
		172,
		161,
		158,
		166,
		151,
		166,
		157,
		156,
		174,
		184,
		192,
		196,
		202,
		-1,
		314,
		-1,
		256,
		240,
		242,
		214,
		235,
		-1,
		272,
		256,
		248,
		233,
		233,
		-1,
		203,
		200,
		190,
		168,
		153,
		170,
		162,
		160,
		164,
		146,
		160,
		151,
		169,
		176,
		174,
		178,
		198,
		210,
		274,
		264,
		-1,
		246,
		251,
		210,
		218,
		237,
		275,
		239,
		-1,
		234,
		-1,
		205,
		218,
		-1,
		174,
		170,
		152,
		153,
		148,
		163,
		157,
		142,
		139,
		157,
		160,
		167,
		171,
		187,
		-1,
		-1,
		259,
		263,
		252,
		203,
		222,
		246,
		283,
		232,
		221,
		220,
		-1,
		211,
		188,
		185,
		173,
		160,
		145,
		146,
		154,
		167,
		146,
		141,
		138,
		158,
		184,
		162,
		174,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		229,
		200,
		224,
		266,
		250,
		243,
		231,
		196,
		196,
		190,
		-1,
		184,
		163,
		154,
		143,
		141,
		154,
		151,
		156,
		136,
		134,
		153,
		165,
		156,
		173,
		-1,
		-1,
		-1,
		259,
		248,
		249,
		195,
		218,
		255,
		229,
		215,
		220,
		195,
		188,
		182,
		197,
		180,
		161,
		150,
		142,
		131,
		147,
		155,
		150,
		132,
		141,
		147,
		171,
		161,
		167,
		-1,
		-1,
		266,
		256,
		240,
		242,
		239,
		209,
		216,
		248,
		220,
		233,
		-1,
		187,
		-1,
		176,
		171,
		155,
		150,
		147,
		144,
		138,
		147,
		149,
		139,
		134,
		141,
		176,
		176,
		151,
		171,
		174,
		-1,
		-1,
		-1,
		259,
		254,
		229,
		206,
		190,
		226,
		-1,
		203,
		204,
		-1,
		181,
		175,
		172,
		157,
		153,
		148,
		152,
		145,
		152,
		145,
		143,
		144,
		126,
		158,
		-1,
		159,
		153,
		161,
		151,
		139,
		-1,
		-1,
		-1,
		252,
		231,
		224,
		244,
		185,
		237,
		-1,
		-1,
		188,
		181,
		-1,
		168,
		150,
		157,
		155,
		149,
		153,
		150,
		139,
		152,
		145,
		131,
		133,
		146,
		150,
		154,
		141,
		137,
		134,
		148,
		-1,
		271,
		-1,
		-1,
		-1,
		-1,
		-1,
		185,
		205,
		-1,
		197,
		189,
		179,
		173,
		167,
		163,
		161,
		177,
		161,
		164,
		162,
		153,
		161,
		134,
		127,
		134,
		123,
		141,
		149,
		141,
		135,
		134,
		144,
		-1,
		272,
		258,
		229,
		-1,
		-1,
		218,
		-1,
		182,
		196,
		212,
		-1,
		205,
		184,
		199,
		177,
		173,
		169,
		184,
		185,
		162,
		162,
		160,
		151,
		139,
		128,
		131,
		123,
		145,
		145,
		129,
		130,
		134,
		-1,
		278,
		265,
		223,
		219,
		208,
		228,
		179,
		167,
		199,
		-1,
		-1,
		241,
		-1,
		175,
		192,
		183,
		181,
		174,
		156,
		163,
		171,
		148,
		143,
		133,
		122,
		122,
		117,
		139,
		125,
		123,
		132,
		148,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		194,
		181,
		175,
		-1,
		216,
		-1,
		219,
		209,
		193,
		178,
		211,
		-1,
		155,
		151,
		158,
		-1,
		168,
		-1,
		141,
		138,
		129,
		114,
		111,
		122,
		120,
		131,
		127,
		-1,
		228,
		213,
		206,
		196,
		210,
		181,
		-1,
		236,
		-1,
		-1,
		206,
		200,
		200,
		184,
		185,
		171,
		151,
		143,
		158,
		157,
		144,
		143,
		127,
		120,
		117,
		110,
		123,
		133,
		138,
		125,
		-1,
		-1,
		-1,
		233,
		219,
		223,
		183,
		202,
		-1,
		-1,
		268,
		223,
		209,
		-1,
		180,
		171,
		159,
		149,
		139,
		144,
		145,
		135,
		133,
		125,
		127,
		121,
		112,
		111,
		127,
		119,
		141,
		-1,
		-1,
		216,
		221,
		209,
		195,
		214,
		-1,
		-1,
		-1,
		215,
		231,
		199,
		178,
		160,
		-1,
		-1,
		143,
		136,
		130,
		133,
		121,
		141,
		136,
		120,
		105,
		120,
		124,
		132,
		123,
		-1,
		219,
		206,
		-1,
		-1,
		217,
		211,
		-1,
		-1,
		-1,
		-1,
		211,
		156,
		145,
		140,
		144,
		142,
		-1,
		116,
		127,
		120,
		139,
		146,
		122,
		107,
		101,
		107,
		119,
		128,
		-1,
		-1,
		231,
		-1,
		204,
		-1,
		-1,
		-1,
		-1,
		168,
		162,
		133,
		126,
		130,
		-1,
		118,
		120,
		117,
		129,
		125,
		122,
		113,
		104,
		100,
		104,
		108,
		122,
		126,
		254,
		-1,
		195,
		-1,
		-1,
		-1,
		186,
		201,
		172,
		149,
		122,
		117,
		110,
		104,
		109,
		120,
		129,
		140,
		105,
		107,
		97,
		96,
		100,
		117,
		121,
		-1,
		-1,
		193,
		189,
		212,
		194,
		198,
		199,
		-1,
		-1,
		126,
		117,
		108,
		100,
		113,
		116,
		101,
		103,
		103,
		101,
		95,
		105,
		120,
		115,
		-1,
		-1,
		-1,
		205,
		-1,
		207,
		-1,
		-1,
		196,
		197,
		144,
		126,
		122,
		120,
		109,
		103,
		91,
		96,
		106,
		100,
		97,
		91,
		95,
		118,
		107,
		146,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		185,
		176,
		171,
		178,
		180,
		171,
		159,
		156,
		-1,
		126,
		132,
		97,
		104,
		87,
		94,
		99,
		96,
		85,
		92,
		108,
		107,
		102,
		138,
		129,
		135,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		178,
		173,
		164,
		154,
		157,
		-1,
		-1,
		151,
		148,
		128,
		97,
		95,
		88,
		83,
		93,
		69,
		81,
		85,
		89,
		95,
		100,
		105,
		111,
		126,
		141,
		-1,
		214,
		251,
		244,
		212,
		220,
		251,
		-1,
		168,
		160,
		170,
		146,
		148,
		-1,
		-1,
		124,
		115,
		116,
		104,
		101,
		107,
		106,
		89,
		95,
		96,
		88,
		87,
		105,
		109,
		118,
		125,
		115,
		128,
		132,
		-1,
		207,
		227,
		206,
		209,
		233,
		247,
		-1,
		165,
		-1,
		-1,
		130,
		149,
		133,
		123,
		120,
		163,
		118,
		113,
		94,
		92,
		87,
		78,
		103,
		96,
		96,
		99,
		114,
		119,
		111,
		125,
		125,
		126,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		-1,
		120,
		-1,
		160,
		-1,
		143,
		147,
		126,
		129,
		108,
		95,
		81,
		89,
		95,
		94,
		100,
		100,
		101,
		110,
		121,
		133,
		132,
		133,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		177,
		216,
		126,
		-1,
		110,
		-1,
		-1,
		-1,
		157,
		139,
		131,
		128,
		107,
		107,
		73,
		77,
		90,
		97,
		107,
		118,
		110,
		114,
		127,
		138,
		141,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		181,
		178,
		210,
		133,
		122,
		117,
		104,
		-1,
		-1,
		141,
		149,
		-1,
		-1,
		114,
		81,
		69,
		79,
		83,
		97,
		109,
		122,
		110,
		115,
		109,
		141,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		206,
		189,
		166,
		164,
		189,
		-1,
		93,
		-1,
		-1,
		121,
		-1,
		-1,
		106,
		86,
		75,
		66,
		71,
		91,
		102,
		124,
		106,
		123,
		114,
		124,
		128,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		161,
		164,
		170,
		177,
		167,
		178,
		-1,
		-1,
		109,
		89,
		-1,
		-1,
		104,
		102,
		91,
		-1,
		81,
		63,
		68,
		98,
		100,
		102,
		109,
		103,
		110,
		118,
		129,
		121,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		-1,
		99,
		95,
		-1,
		-1,
		99,
		92,
		80,
		68,
		58,
		68,
		85,
		85,
		88,
		93,
		101,
		112,
		108,
		112,
		115,
		-1,
		237,
		-1,
		189,
		150,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		116,
		102,
		95,
		83,
		81,
		-1,
		133,
		117,
		98,
		-1,
		68,
		81,
		121,
		89,
		94,
		89,
		104,
		115,
		106,
		114,
		108,
		111,
		-1,
		-1,
		149,
		132,
		-1,
		-1,
		106,
		108,
		-1,
		107,
		96,
		81,
		73,
		-1,
		-1,
		105,
		101,
		-1,
		-1,
		55,
		93,
		92,
		100,
		95,
		100,
		112,
		108,
		104,
		114,
		105,
		-1,
		-1,
		127,
		119,
		113,
		-1,
		91,
		-1,
		109,
		-1,
		76,
		82,
		70,
		-1,
		-1,
		-1,
		86,
		49,
		65,
		88,
		114,
		112,
		103,
		96,
		103,
		106,
		99,
		105,
		-1,
		-1,
		-1,
		109,
		83,
		116,
		107,
		90,
		70,
		62,
		81,
		-1,
		67,
		-1,
		42,
		45,
		70,
		109,
		111,
		97,
		93,
		106,
		100,
		97,
		95,
		115,
		-1,
		85,
		118,
		82,
		76,
		52,
		56,
		81,
		-1,
		64,
		46,
		-1,
		74,
		64,
		112,
		87,
		96,
		89,
		83,
		84,
		92,
		-1,
		-1,
		-1,
		87,
		86,
		78,
		72,
		72,
		57,
		48,
		-1,
		69,
		51,
		37,
		54,
		54,
		45,
		53,
		102,
		98,
		101,
		99,
		77,
		-1,
		144,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		81,
		76,
		49,
		37,
		38,
		34,
		34,
		36,
		49,
		57,
		55,
		52,
		64,
		60,
		80,
		76,
		108,
		-1,
		139,
		-1,
		117,
		-1,
		-1,
		99,
		79,
		71,
		60,
		49,
		47,
		33,
		29,
		46,
		81,
		67,
		65,
		70,
		75,
		-1,
		128,
		127,
		-1,
		118,
		110,
		96,
		-1,
		77,
		-1,
		95,
		56,
		-1,
		30,
		24,
		-1,
		76,
		72,
		-1,
		-1,
		115,
		110,
		-1,
		-1,
		-1,
		97,
		61,
		90,
		74,
		-1,
		14,
		21,
		-1,
		-1,
		-1,
		100,
		101,
		-1,
		90,
		93,
		-1,
		57,
		48,
		56,
		0,
		13,
		-1,
		-1,
		-1,
		109,
		90,
		84,
		86,
		81,
		98,
		69,
		55,
		39,
		17,
		5,
		33,
		-1,
		-1,
		-1,
		81,
		73,
		66,
		-1,
		-1,
		64,
		47,
		28,
		26,
		-1,
		-1,
		-1,
		103,
		84,
		-1,
		-1,
		58,
		-1,
		-1,
		60,
		29,
		-1,
		-1,
		-1,
		-1,
		-1,
		120,
		92,
		-1,
		-1,
		-1,
		54,
		50,
		51,
		-1,
		-1,
		-1,
		-1,
		114,
		115,
		138,
		102,
		-1,
		-1,
		-1,
		46,
		40,
		-1,
		-1,
		117,
		115,
		-1,
		-1,
		-1,
		74,
		58,
		-1,
		44,
		-1,
		-1,
		-1,
		65,
		-1,
		-1,
		77,
		-1,
		-1,
		-1,
		79,
		-1,
		79,
		54,
		61,
		-1,
		-1,
		-1,
		-1,
		92,
		84,
		92,
		-1,
		64,
		66,
		-1,
		114,
		-1,
		-1,
		107,
		98,
		-1,
		-1,
		69,
		76,
		98,
		101,
		137,
		-1,
		88
	],
	[
		-1,
		258,
		247,
		258,
		266,
		239,
		246,
		-1,
		265,
		269,
		235,
		229,
		268,
		237,
		243,
		254,
		-1,
		-1,
		-1,
		258,
		257,
		225,
		223,
		232,
		237,
		244,
		-1,
		243,
		-1,
		279,
		258,
		269,
		274,
		218,
		215,
		235,
		254,
		236,
		228,
		294,
		248,
		219,
		213,
		231,
		221,
		230,
		222,
		-1,
		219,
		209,
		231,
		210,
		221,
		213,
		-1,
		-1,
		213,
		214,
		220,
		206,
		212,
		208,
		-1,
		218,
		202,
		-1,
		-1,
		203,
		204,
		188,
		191,
		199,
		197,
		210,
		202,
		197,
		-1,
		-1,
		194,
		190,
		197,
		184,
		180,
		197,
		210,
		192,
		206,
		205,
		-1,
		198,
		216,
		223,
		191,
		189,
		173,
		171,
		189,
		191,
		197,
		197,
		-1,
		207,
		208,
		203,
		211,
		213,
		189,
		176,
		176,
		186,
		179,
		198,
		186,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		207,
		190,
		207,
		199,
		189,
		204,
		197,
		179,
		176,
		174,
		171,
		187,
		185,
		195,
		-1,
		-1,
		300,
		269,
		298,
		256,
		237,
		-1,
		203,
		183,
		189,
		193,
		187,
		180,
		194,
		190,
		-1,
		165,
		164,
		192,
		178,
		189,
		260,
		-1,
		-1,
		258,
		250,
		233,
		236,
		213,
		209,
		198,
		197,
		189,
		175,
		171,
		177,
		180,
		180,
		186,
		159,
		169,
		173,
		171,
		196,
		-1,
		-1,
		231,
		-1,
		-1,
		257,
		240,
		-1,
		223,
		230,
		219,
		225,
		211,
		232,
		208,
		199,
		191,
		185,
		173,
		175,
		172,
		185,
		173,
		156,
		181,
		185,
		166,
		187,
		182,
		-1,
		230,
		214,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		216,
		219,
		225,
		249,
		248,
		-1,
		220,
		208,
		209,
		194,
		191,
		178,
		166,
		179,
		164,
		171,
		170,
		160,
		158,
		188,
		163,
		185,
		182,
		201,
		206,
		200,
		209,
		-1,
		265,
		261,
		257,
		264,
		213,
		-1,
		-1,
		253,
		-1,
		256,
		257,
		232,
		205,
		208,
		195,
		186,
		173,
		162,
		173,
		162,
		159,
		167,
		152,
		167,
		158,
		157,
		175,
		185,
		193,
		197,
		203,
		-1,
		315,
		-1,
		257,
		241,
		243,
		215,
		236,
		-1,
		273,
		257,
		249,
		234,
		234,
		-1,
		204,
		201,
		191,
		169,
		154,
		171,
		163,
		161,
		165,
		147,
		161,
		152,
		170,
		177,
		175,
		179,
		199,
		211,
		275,
		265,
		-1,
		247,
		252,
		211,
		219,
		238,
		276,
		240,
		-1,
		235,
		-1,
		206,
		219,
		-1,
		175,
		171,
		153,
		154,
		149,
		164,
		158,
		143,
		140,
		158,
		161,
		168,
		172,
		188,
		-1,
		-1,
		260,
		264,
		253,
		204,
		223,
		247,
		284,
		233,
		222,
		221,
		-1,
		212,
		189,
		186,
		174,
		161,
		146,
		147,
		155,
		168,
		147,
		142,
		139,
		159,
		185,
		163,
		175,
		-1,
		-1,
		-1,
		285,
		-1,
		-1,
		230,
		201,
		225,
		267,
		251,
		244,
		232,
		197,
		197,
		191,
		-1,
		185,
		164,
		155,
		144,
		142,
		155,
		152,
		157,
		137,
		135,
		154,
		166,
		157,
		174,
		-1,
		-1,
		-1,
		260,
		249,
		250,
		196,
		219,
		256,
		230,
		216,
		221,
		196,
		189,
		183,
		198,
		181,
		162,
		151,
		143,
		132,
		148,
		156,
		151,
		133,
		142,
		148,
		172,
		162,
		168,
		-1,
		-1,
		267,
		257,
		241,
		243,
		240,
		210,
		217,
		249,
		221,
		234,
		-1,
		188,
		-1,
		177,
		172,
		156,
		151,
		148,
		145,
		139,
		148,
		150,
		140,
		135,
		142,
		177,
		177,
		152,
		172,
		175,
		-1,
		-1,
		-1,
		260,
		255,
		230,
		207,
		191,
		227,
		-1,
		204,
		205,
		-1,
		182,
		176,
		173,
		158,
		154,
		149,
		153,
		146,
		153,
		146,
		144,
		145,
		127,
		159,
		-1,
		160,
		154,
		162,
		152,
		140,
		-1,
		-1,
		-1,
		253,
		232,
		225,
		245,
		186,
		238,
		-1,
		-1,
		189,
		182,
		-1,
		169,
		151,
		158,
		156,
		150,
		154,
		151,
		140,
		153,
		146,
		132,
		134,
		147,
		151,
		155,
		142,
		138,
		135,
		149,
		-1,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		186,
		206,
		-1,
		198,
		190,
		180,
		174,
		168,
		164,
		162,
		178,
		162,
		165,
		163,
		154,
		162,
		135,
		128,
		135,
		124,
		142,
		150,
		142,
		136,
		135,
		145,
		-1,
		273,
		259,
		230,
		-1,
		-1,
		219,
		-1,
		183,
		197,
		213,
		-1,
		206,
		185,
		200,
		178,
		174,
		170,
		185,
		186,
		163,
		163,
		161,
		152,
		140,
		129,
		132,
		124,
		146,
		146,
		130,
		131,
		135,
		-1,
		279,
		266,
		224,
		220,
		209,
		229,
		180,
		168,
		200,
		-1,
		-1,
		242,
		-1,
		176,
		193,
		184,
		182,
		175,
		157,
		164,
		172,
		149,
		144,
		134,
		123,
		123,
		118,
		140,
		126,
		124,
		133,
		149,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		195,
		182,
		176,
		-1,
		217,
		-1,
		220,
		210,
		194,
		179,
		212,
		-1,
		156,
		152,
		159,
		-1,
		169,
		-1,
		142,
		139,
		130,
		115,
		112,
		123,
		121,
		132,
		128,
		-1,
		229,
		214,
		207,
		197,
		211,
		182,
		-1,
		237,
		-1,
		-1,
		207,
		201,
		201,
		185,
		186,
		172,
		152,
		144,
		159,
		158,
		145,
		144,
		128,
		121,
		118,
		111,
		124,
		134,
		139,
		126,
		-1,
		-1,
		-1,
		234,
		220,
		224,
		184,
		203,
		-1,
		-1,
		269,
		224,
		210,
		-1,
		181,
		172,
		160,
		150,
		140,
		145,
		146,
		136,
		134,
		126,
		128,
		122,
		113,
		112,
		128,
		120,
		142,
		-1,
		-1,
		217,
		222,
		210,
		196,
		215,
		-1,
		-1,
		-1,
		216,
		232,
		200,
		179,
		161,
		-1,
		-1,
		144,
		137,
		131,
		134,
		122,
		142,
		137,
		121,
		106,
		121,
		125,
		133,
		124,
		-1,
		220,
		207,
		-1,
		-1,
		218,
		212,
		-1,
		-1,
		-1,
		-1,
		212,
		157,
		146,
		141,
		145,
		143,
		-1,
		117,
		128,
		121,
		140,
		147,
		123,
		108,
		102,
		108,
		120,
		129,
		-1,
		-1,
		232,
		-1,
		205,
		-1,
		-1,
		-1,
		-1,
		169,
		163,
		134,
		127,
		131,
		-1,
		119,
		121,
		118,
		130,
		126,
		123,
		114,
		105,
		101,
		105,
		109,
		123,
		127,
		255,
		-1,
		196,
		-1,
		-1,
		-1,
		187,
		202,
		173,
		150,
		123,
		118,
		111,
		105,
		110,
		121,
		130,
		141,
		106,
		108,
		98,
		97,
		101,
		118,
		122,
		-1,
		-1,
		194,
		190,
		213,
		195,
		199,
		200,
		-1,
		-1,
		127,
		118,
		109,
		101,
		114,
		117,
		102,
		104,
		104,
		102,
		96,
		106,
		121,
		116,
		-1,
		-1,
		-1,
		206,
		-1,
		208,
		-1,
		-1,
		197,
		198,
		145,
		127,
		123,
		121,
		110,
		104,
		92,
		97,
		107,
		101,
		98,
		92,
		96,
		119,
		108,
		147,
		-1,
		-1,
		268,
		-1,
		-1,
		-1,
		186,
		177,
		172,
		179,
		181,
		172,
		160,
		157,
		-1,
		127,
		133,
		98,
		105,
		88,
		95,
		100,
		97,
		86,
		93,
		109,
		108,
		103,
		139,
		130,
		136,
		-1,
		-1,
		261,
		250,
		239,
		245,
		-1,
		179,
		174,
		165,
		155,
		158,
		-1,
		-1,
		152,
		149,
		129,
		98,
		96,
		89,
		84,
		94,
		70,
		82,
		86,
		90,
		96,
		101,
		106,
		112,
		127,
		142,
		-1,
		215,
		252,
		245,
		213,
		221,
		252,
		-1,
		169,
		161,
		171,
		147,
		149,
		-1,
		-1,
		125,
		116,
		117,
		105,
		102,
		108,
		107,
		90,
		96,
		97,
		89,
		88,
		106,
		110,
		119,
		126,
		116,
		129,
		133,
		-1,
		208,
		228,
		207,
		210,
		234,
		248,
		-1,
		166,
		-1,
		-1,
		131,
		150,
		134,
		124,
		121,
		164,
		119,
		114,
		95,
		93,
		88,
		79,
		104,
		97,
		97,
		100,
		115,
		120,
		112,
		126,
		126,
		127,
		-1,
		197,
		208,
		201,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		-1,
		121,
		-1,
		161,
		-1,
		144,
		148,
		127,
		130,
		109,
		96,
		82,
		90,
		96,
		95,
		101,
		101,
		102,
		111,
		122,
		134,
		133,
		134,
		222,
		178,
		181,
		192,
		203,
		218,
		222,
		-1,
		178,
		217,
		127,
		-1,
		111,
		-1,
		-1,
		-1,
		158,
		140,
		132,
		129,
		108,
		108,
		74,
		78,
		91,
		98,
		108,
		119,
		111,
		115,
		128,
		139,
		142,
		218,
		209,
		222,
		167,
		167,
		188,
		197,
		218,
		182,
		179,
		211,
		134,
		123,
		118,
		105,
		-1,
		-1,
		142,
		150,
		-1,
		-1,
		115,
		82,
		70,
		80,
		84,
		98,
		110,
		123,
		111,
		116,
		110,
		142,
		-1,
		211,
		210,
		199,
		196,
		172,
		163,
		158,
		185,
		-1,
		-1,
		180,
		207,
		190,
		167,
		165,
		190,
		-1,
		94,
		-1,
		-1,
		122,
		-1,
		-1,
		107,
		87,
		76,
		67,
		72,
		92,
		103,
		125,
		107,
		124,
		115,
		125,
		129,
		195,
		192,
		180,
		178,
		201,
		166,
		154,
		-1,
		162,
		165,
		171,
		178,
		168,
		179,
		-1,
		-1,
		110,
		90,
		-1,
		-1,
		105,
		103,
		92,
		-1,
		82,
		64,
		69,
		99,
		101,
		103,
		110,
		104,
		111,
		119,
		130,
		122,
		204,
		218,
		207,
		203,
		202,
		210,
		159,
		152,
		159,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		-1,
		100,
		96,
		-1,
		-1,
		100,
		93,
		81,
		69,
		59,
		69,
		86,
		86,
		89,
		94,
		102,
		113,
		109,
		113,
		116,
		-1,
		238,
		-1,
		190,
		151,
		157,
		172,
		180,
		-1,
		-1,
		-1,
		117,
		103,
		96,
		84,
		82,
		-1,
		134,
		118,
		99,
		-1,
		69,
		82,
		122,
		90,
		95,
		90,
		105,
		116,
		107,
		115,
		109,
		112,
		-1,
		-1,
		150,
		133,
		-1,
		-1,
		107,
		109,
		-1,
		108,
		97,
		82,
		74,
		-1,
		-1,
		106,
		102,
		-1,
		-1,
		56,
		94,
		93,
		101,
		96,
		101,
		113,
		109,
		105,
		115,
		106,
		-1,
		-1,
		128,
		120,
		114,
		-1,
		92,
		-1,
		110,
		-1,
		77,
		83,
		71,
		-1,
		-1,
		-1,
		87,
		50,
		66,
		89,
		115,
		113,
		104,
		97,
		104,
		107,
		100,
		106,
		-1,
		-1,
		-1,
		110,
		84,
		117,
		108,
		91,
		71,
		63,
		82,
		-1,
		68,
		-1,
		43,
		46,
		71,
		110,
		112,
		98,
		94,
		107,
		101,
		98,
		96,
		116,
		-1,
		86,
		119,
		83,
		77,
		53,
		57,
		82,
		-1,
		65,
		47,
		-1,
		75,
		65,
		113,
		88,
		97,
		90,
		84,
		85,
		93,
		-1,
		-1,
		-1,
		88,
		87,
		79,
		73,
		73,
		58,
		49,
		-1,
		70,
		52,
		38,
		55,
		55,
		46,
		54,
		103,
		99,
		102,
		100,
		78,
		-1,
		149,
		-1,
		-1,
		111,
		-1,
		-1,
		-1,
		82,
		77,
		50,
		38,
		39,
		35,
		35,
		37,
		50,
		58,
		56,
		53,
		65,
		61,
		81,
		77,
		109,
		-1,
		144,
		-1,
		118,
		-1,
		-1,
		100,
		80,
		72,
		61,
		50,
		48,
		34,
		30,
		47,
		82,
		68,
		66,
		71,
		76,
		-1,
		133,
		132,
		-1,
		119,
		111,
		97,
		-1,
		85,
		-1,
		96,
		57,
		-1,
		31,
		25,
		-1,
		77,
		73,
		-1,
		-1,
		120,
		115,
		-1,
		-1,
		-1,
		105,
		69,
		91,
		75,
		-1,
		15,
		22,
		-1,
		-1,
		-1,
		105,
		106,
		-1,
		98,
		101,
		-1,
		65,
		56,
		64,
		10,
		0,
		-1,
		-1,
		-1,
		114,
		95,
		89,
		91,
		86,
		106,
		77,
		63,
		47,
		25,
		13,
		20,
		-1,
		-1,
		-1,
		86,
		78,
		71,
		-1,
		-1,
		72,
		55,
		36,
		34,
		-1,
		-1,
		-1,
		108,
		89,
		-1,
		-1,
		63,
		-1,
		-1,
		68,
		34,
		-1,
		-1,
		-1,
		-1,
		-1,
		125,
		97,
		-1,
		-1,
		-1,
		59,
		55,
		56,
		-1,
		-1,
		-1,
		-1,
		119,
		120,
		143,
		107,
		-1,
		-1,
		-1,
		51,
		45,
		-1,
		-1,
		122,
		120,
		-1,
		-1,
		-1,
		79,
		63,
		-1,
		49,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		82,
		-1,
		-1,
		-1,
		84,
		-1,
		84,
		59,
		66,
		-1,
		-1,
		-1,
		-1,
		97,
		89,
		97,
		-1,
		69,
		71,
		-1,
		119,
		-1,
		-1,
		112,
		103,
		-1,
		-1,
		74,
		81,
		103,
		106,
		142,
		-1,
		93
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		357,
		346,
		357,
		365,
		338,
		345,
		-1,
		364,
		368,
		334,
		328,
		367,
		336,
		342,
		353,
		-1,
		-1,
		-1,
		357,
		356,
		324,
		322,
		331,
		336,
		343,
		-1,
		342,
		-1,
		378,
		357,
		368,
		373,
		317,
		314,
		334,
		353,
		335,
		327,
		393,
		347,
		318,
		312,
		330,
		320,
		329,
		321,
		-1,
		318,
		308,
		330,
		309,
		320,
		312,
		-1,
		-1,
		312,
		313,
		319,
		305,
		311,
		307,
		-1,
		317,
		301,
		-1,
		-1,
		302,
		303,
		287,
		290,
		298,
		296,
		309,
		301,
		296,
		-1,
		-1,
		293,
		289,
		296,
		283,
		279,
		296,
		309,
		291,
		305,
		304,
		-1,
		297,
		315,
		322,
		290,
		288,
		272,
		270,
		288,
		290,
		296,
		296,
		-1,
		306,
		307,
		302,
		310,
		312,
		288,
		275,
		275,
		285,
		278,
		297,
		285,
		331,
		-1,
		-1,
		-1,
		-1,
		-1,
		340,
		306,
		289,
		306,
		298,
		288,
		303,
		296,
		278,
		275,
		273,
		270,
		286,
		284,
		294,
		-1,
		-1,
		399,
		368,
		397,
		355,
		336,
		-1,
		302,
		282,
		288,
		292,
		286,
		279,
		293,
		289,
		-1,
		264,
		263,
		291,
		277,
		288,
		359,
		-1,
		-1,
		357,
		349,
		332,
		335,
		312,
		308,
		297,
		296,
		288,
		274,
		270,
		276,
		279,
		279,
		285,
		258,
		268,
		272,
		270,
		295,
		-1,
		-1,
		330,
		-1,
		-1,
		356,
		339,
		-1,
		322,
		329,
		318,
		324,
		310,
		331,
		307,
		298,
		290,
		284,
		272,
		274,
		271,
		284,
		272,
		255,
		280,
		284,
		265,
		286,
		281,
		-1,
		329,
		313,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		334,
		315,
		318,
		324,
		348,
		347,
		-1,
		319,
		307,
		308,
		293,
		290,
		277,
		265,
		278,
		263,
		270,
		269,
		259,
		257,
		287,
		262,
		284,
		281,
		300,
		305,
		299,
		308,
		-1,
		364,
		360,
		356,
		363,
		312,
		-1,
		-1,
		352,
		-1,
		355,
		356,
		331,
		304,
		307,
		294,
		285,
		272,
		261,
		272,
		261,
		258,
		266,
		251,
		266,
		257,
		256,
		274,
		284,
		292,
		296,
		302,
		-1,
		414,
		-1,
		356,
		340,
		342,
		314,
		335,
		-1,
		372,
		356,
		348,
		333,
		333,
		-1,
		303,
		300,
		290,
		268,
		253,
		270,
		262,
		260,
		264,
		246,
		260,
		251,
		269,
		276,
		274,
		278,
		298,
		310,
		374,
		364,
		-1,
		346,
		351,
		310,
		318,
		337,
		375,
		339,
		-1,
		334,
		-1,
		305,
		318,
		-1,
		274,
		270,
		252,
		253,
		248,
		263,
		257,
		242,
		239,
		257,
		260,
		267,
		271,
		287,
		-1,
		-1,
		359,
		363,
		352,
		303,
		322,
		346,
		383,
		332,
		321,
		320,
		-1,
		311,
		288,
		285,
		273,
		260,
		245,
		246,
		254,
		267,
		246,
		241,
		238,
		258,
		284,
		262,
		274,
		-1,
		-1,
		-1,
		384,
		-1,
		-1,
		329,
		300,
		324,
		366,
		350,
		343,
		331,
		296,
		296,
		290,
		-1,
		284,
		263,
		254,
		243,
		241,
		254,
		251,
		256,
		236,
		234,
		253,
		265,
		256,
		273,
		-1,
		-1,
		-1,
		359,
		348,
		349,
		295,
		318,
		355,
		329,
		315,
		320,
		295,
		288,
		282,
		297,
		280,
		261,
		250,
		242,
		231,
		247,
		255,
		250,
		232,
		241,
		247,
		271,
		261,
		267,
		-1,
		-1,
		366,
		356,
		340,
		342,
		339,
		309,
		316,
		348,
		320,
		333,
		-1,
		287,
		-1,
		276,
		271,
		255,
		250,
		247,
		244,
		238,
		247,
		249,
		239,
		234,
		241,
		276,
		276,
		251,
		271,
		274,
		-1,
		-1,
		-1,
		359,
		354,
		329,
		306,
		290,
		326,
		-1,
		303,
		304,
		-1,
		281,
		275,
		272,
		257,
		253,
		248,
		252,
		245,
		252,
		245,
		243,
		244,
		226,
		258,
		-1,
		259,
		253,
		261,
		251,
		239,
		-1,
		-1,
		-1,
		352,
		331,
		324,
		344,
		285,
		337,
		-1,
		-1,
		288,
		281,
		-1,
		268,
		250,
		257,
		255,
		249,
		253,
		250,
		239,
		252,
		245,
		231,
		233,
		246,
		250,
		254,
		241,
		237,
		234,
		248,
		-1,
		371,
		-1,
		-1,
		-1,
		-1,
		-1,
		285,
		305,
		-1,
		297,
		289,
		279,
		273,
		267,
		263,
		261,
		277,
		261,
		264,
		262,
		253,
		261,
		234,
		227,
		234,
		223,
		241,
		249,
		241,
		235,
		234,
		244,
		-1,
		372,
		358,
		329,
		-1,
		-1,
		318,
		-1,
		282,
		296,
		312,
		-1,
		305,
		284,
		299,
		277,
		273,
		269,
		284,
		285,
		262,
		262,
		260,
		251,
		239,
		228,
		231,
		223,
		245,
		245,
		229,
		230,
		234,
		-1,
		378,
		365,
		323,
		319,
		308,
		328,
		279,
		267,
		299,
		-1,
		-1,
		341,
		-1,
		275,
		292,
		283,
		281,
		274,
		256,
		263,
		271,
		248,
		243,
		233,
		222,
		222,
		217,
		239,
		225,
		223,
		232,
		248,
		-1,
		-1,
		-1,
		345,
		-1,
		-1,
		294,
		281,
		275,
		-1,
		316,
		-1,
		319,
		309,
		293,
		278,
		311,
		-1,
		255,
		251,
		258,
		-1,
		268,
		-1,
		241,
		238,
		229,
		214,
		211,
		222,
		220,
		231,
		227,
		-1,
		328,
		313,
		306,
		296,
		310,
		281,
		-1,
		336,
		-1,
		-1,
		306,
		300,
		300,
		284,
		285,
		271,
		251,
		243,
		258,
		257,
		244,
		243,
		227,
		220,
		217,
		210,
		223,
		233,
		238,
		225,
		-1,
		-1,
		-1,
		333,
		319,
		323,
		283,
		302,
		-1,
		-1,
		368,
		323,
		309,
		-1,
		280,
		271,
		259,
		249,
		239,
		244,
		245,
		235,
		233,
		225,
		227,
		221,
		212,
		211,
		227,
		219,
		241,
		-1,
		-1,
		316,
		321,
		309,
		295,
		313,
		-1,
		-1,
		-1,
		315,
		331,
		299,
		278,
		260,
		-1,
		-1,
		243,
		236,
		230,
		233,
		221,
		241,
		236,
		220,
		205,
		220,
		224,
		232,
		223,
		-1,
		319,
		306,
		-1,
		-1,
		312,
		302,
		-1,
		-1,
		-1,
		-1,
		311,
		256,
		245,
		240,
		244,
		242,
		-1,
		216,
		227,
		220,
		239,
		246,
		222,
		207,
		201,
		207,
		219,
		228,
		-1,
		-1,
		326,
		-1,
		288,
		-1,
		-1,
		-1,
		-1,
		268,
		262,
		233,
		226,
		230,
		-1,
		218,
		220,
		217,
		229,
		225,
		222,
		213,
		204,
		200,
		204,
		208,
		222,
		226,
		349,
		-1,
		279,
		-1,
		-1,
		-1,
		286,
		301,
		272,
		249,
		222,
		217,
		210,
		204,
		209,
		220,
		229,
		240,
		205,
		207,
		197,
		196,
		200,
		217,
		221,
		-1,
		-1,
		277,
		273,
		308,
		294,
		298,
		299,
		-1,
		-1,
		226,
		217,
		208,
		200,
		213,
		216,
		201,
		203,
		203,
		201,
		195,
		205,
		220,
		215,
		-1,
		-1,
		-1,
		289,
		-1,
		291,
		-1,
		-1,
		296,
		297,
		244,
		226,
		222,
		220,
		209,
		203,
		191,
		196,
		206,
		200,
		197,
		191,
		195,
		218,
		207,
		246,
		-1,
		-1,
		313,
		-1,
		-1,
		-1,
		273,
		260,
		255,
		278,
		280,
		271,
		259,
		256,
		-1,
		226,
		232,
		197,
		204,
		187,
		194,
		199,
		196,
		185,
		192,
		208,
		207,
		202,
		238,
		229,
		235,
		-1,
		-1,
		306,
		295,
		284,
		290,
		-1,
		266,
		257,
		264,
		254,
		257,
		-1,
		-1,
		251,
		248,
		228,
		197,
		195,
		188,
		183,
		193,
		169,
		181,
		185,
		189,
		195,
		200,
		205,
		211,
		226,
		241,
		-1,
		260,
		297,
		290,
		258,
		266,
		297,
		-1,
		256,
		248,
		254,
		246,
		248,
		-1,
		-1,
		224,
		215,
		216,
		204,
		201,
		207,
		206,
		189,
		195,
		196,
		188,
		187,
		205,
		209,
		218,
		225,
		215,
		228,
		232,
		-1,
		253,
		273,
		252,
		255,
		279,
		293,
		-1,
		247,
		-1,
		-1,
		214,
		249,
		233,
		223,
		220,
		263,
		218,
		213,
		194,
		192,
		187,
		178,
		203,
		196,
		196,
		199,
		214,
		219,
		211,
		225,
		225,
		226,
		-1,
		242,
		253,
		246,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		204,
		-1,
		260,
		-1,
		243,
		247,
		226,
		229,
		208,
		195,
		181,
		189,
		195,
		194,
		200,
		200,
		201,
		210,
		221,
		233,
		232,
		233,
		258,
		223,
		226,
		237,
		248,
		263,
		267,
		-1,
		231,
		267,
		210,
		-1,
		194,
		-1,
		-1,
		-1,
		257,
		239,
		231,
		228,
		207,
		207,
		173,
		177,
		190,
		197,
		207,
		218,
		210,
		214,
		227,
		238,
		241,
		254,
		254,
		267,
		212,
		212,
		233,
		242,
		263,
		227,
		224,
		261,
		217,
		206,
		201,
		188,
		-1,
		-1,
		241,
		249,
		-1,
		-1,
		214,
		181,
		169,
		179,
		183,
		197,
		209,
		222,
		210,
		215,
		209,
		241,
		-1,
		254,
		249,
		236,
		231,
		217,
		208,
		203,
		230,
		-1,
		-1,
		225,
		252,
		236,
		240,
		248,
		273,
		-1,
		172,
		-1,
		-1,
		221,
		-1,
		-1,
		206,
		186,
		175,
		166,
		171,
		191,
		202,
		224,
		206,
		223,
		214,
		224,
		228,
		238,
		231,
		219,
		221,
		227,
		211,
		199,
		-1,
		207,
		210,
		216,
		223,
		240,
		262,
		-1,
		-1,
		188,
		168,
		-1,
		-1,
		204,
		202,
		191,
		-1,
		181,
		163,
		168,
		198,
		200,
		202,
		209,
		203,
		210,
		218,
		229,
		221,
		247,
		257,
		246,
		219,
		228,
		241,
		204,
		197,
		204,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		178,
		174,
		-1,
		-1,
		199,
		192,
		180,
		168,
		158,
		168,
		185,
		185,
		188,
		193,
		201,
		212,
		208,
		212,
		215,
		-1,
		256,
		-1,
		235,
		196,
		202,
		217,
		225,
		-1,
		-1,
		-1,
		195,
		181,
		174,
		162,
		160,
		-1,
		233,
		217,
		198,
		-1,
		168,
		181,
		221,
		189,
		194,
		189,
		204,
		215,
		206,
		214,
		208,
		211,
		-1,
		-1,
		195,
		178,
		-1,
		-1,
		152,
		154,
		-1,
		186,
		175,
		160,
		152,
		-1,
		-1,
		205,
		201,
		-1,
		-1,
		155,
		193,
		192,
		200,
		195,
		200,
		212,
		208,
		204,
		214,
		205,
		-1,
		-1,
		173,
		165,
		159,
		-1,
		137,
		-1,
		188,
		-1,
		155,
		164,
		152,
		-1,
		-1,
		-1,
		186,
		149,
		165,
		188,
		214,
		212,
		203,
		196,
		203,
		206,
		199,
		205,
		-1,
		-1,
		-1,
		155,
		129,
		195,
		186,
		169,
		149,
		141,
		163,
		-1,
		167,
		-1,
		142,
		145,
		170,
		209,
		211,
		197,
		193,
		206,
		200,
		197,
		195,
		161,
		-1,
		131,
		164,
		128,
		155,
		121,
		135,
		181,
		-1,
		164,
		146,
		-1,
		174,
		164,
		212,
		187,
		196,
		189,
		183,
		184,
		192,
		-1,
		-1,
		-1,
		133,
		132,
		124,
		118,
		118,
		116,
		133,
		-1,
		169,
		151,
		137,
		154,
		154,
		145,
		153,
		202,
		198,
		201,
		199,
		177,
		-1,
		73,
		-1,
		-1,
		156,
		-1,
		-1,
		-1,
		127,
		111,
		124,
		135,
		138,
		134,
		134,
		136,
		149,
		157,
		155,
		152,
		164,
		160,
		180,
		176,
		208,
		-1,
		68,
		-1,
		163,
		-1,
		-1,
		90,
		95,
		105,
		116,
		144,
		144,
		133,
		129,
		146,
		181,
		167,
		165,
		170,
		175,
		-1,
		57,
		56,
		-1,
		54,
		64,
		85,
		-1,
		86,
		-1,
		190,
		151,
		-1,
		130,
		124,
		-1,
		176,
		172,
		-1,
		-1,
		44,
		43,
		-1,
		-1,
		-1,
		85,
		94,
		185,
		169,
		-1,
		114,
		121,
		-1,
		-1,
		-1,
		29,
		34,
		-1,
		78,
		81,
		-1,
		95,
		101,
		129,
		109,
		115,
		-1,
		-1,
		-1,
		0,
		22,
		27,
		68,
		63,
		86,
		126,
		112,
		112,
		96,
		106,
		135,
		-1,
		-1,
		-1,
		39,
		36,
		48,
		-1,
		-1,
		137,
		120,
		107,
		105,
		-1,
		-1,
		-1,
		61,
		42,
		-1,
		-1,
		57,
		-1,
		-1,
		102,
		81,
		-1,
		-1,
		-1,
		-1,
		-1,
		79,
		50,
		-1,
		-1,
		-1,
		58,
		65,
		86,
		-1,
		-1,
		-1,
		-1,
		76,
		77,
		96,
		71,
		-1,
		-1,
		-1,
		72,
		75,
		-1,
		-1,
		79,
		77,
		-1,
		-1,
		-1,
		100,
		84,
		-1,
		86,
		-1,
		-1,
		-1,
		91,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		105,
		-1,
		121,
		96,
		103,
		-1,
		-1,
		-1,
		-1,
		118,
		110,
		134,
		-1,
		106,
		108,
		-1,
		156,
		-1,
		-1,
		133,
		124,
		-1,
		-1,
		111,
		118,
		140,
		143,
		163,
		-1,
		130
	],
	[
		-1,
		337,
		326,
		337,
		345,
		318,
		325,
		-1,
		344,
		348,
		314,
		308,
		347,
		316,
		322,
		333,
		-1,
		-1,
		-1,
		337,
		336,
		304,
		302,
		311,
		316,
		323,
		-1,
		322,
		-1,
		358,
		337,
		348,
		353,
		297,
		294,
		314,
		333,
		315,
		307,
		373,
		327,
		298,
		292,
		310,
		300,
		309,
		301,
		-1,
		298,
		288,
		310,
		289,
		300,
		292,
		-1,
		-1,
		292,
		293,
		299,
		285,
		291,
		287,
		-1,
		297,
		281,
		-1,
		-1,
		282,
		283,
		267,
		270,
		278,
		276,
		289,
		281,
		276,
		-1,
		-1,
		273,
		269,
		276,
		263,
		259,
		276,
		289,
		271,
		285,
		284,
		-1,
		277,
		295,
		302,
		270,
		268,
		252,
		250,
		268,
		270,
		276,
		276,
		-1,
		286,
		287,
		282,
		290,
		292,
		268,
		255,
		255,
		265,
		258,
		277,
		265,
		311,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		286,
		269,
		286,
		278,
		268,
		283,
		276,
		258,
		255,
		253,
		250,
		266,
		264,
		274,
		-1,
		-1,
		379,
		348,
		377,
		335,
		316,
		-1,
		282,
		262,
		268,
		272,
		266,
		259,
		273,
		269,
		-1,
		244,
		243,
		271,
		257,
		268,
		339,
		-1,
		-1,
		337,
		329,
		312,
		315,
		292,
		288,
		277,
		276,
		268,
		254,
		250,
		256,
		259,
		259,
		265,
		238,
		248,
		252,
		250,
		275,
		-1,
		-1,
		310,
		-1,
		-1,
		336,
		319,
		-1,
		302,
		309,
		298,
		304,
		290,
		311,
		287,
		278,
		270,
		264,
		252,
		254,
		251,
		264,
		252,
		235,
		260,
		264,
		245,
		266,
		261,
		-1,
		309,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		295,
		298,
		304,
		328,
		327,
		-1,
		299,
		287,
		288,
		273,
		270,
		257,
		245,
		258,
		243,
		250,
		249,
		239,
		237,
		267,
		242,
		264,
		261,
		280,
		285,
		279,
		288,
		-1,
		344,
		340,
		336,
		343,
		292,
		-1,
		-1,
		332,
		-1,
		335,
		336,
		311,
		284,
		287,
		274,
		265,
		252,
		241,
		252,
		241,
		238,
		246,
		231,
		246,
		237,
		236,
		254,
		264,
		272,
		276,
		282,
		-1,
		394,
		-1,
		336,
		320,
		322,
		294,
		315,
		-1,
		352,
		336,
		328,
		313,
		313,
		-1,
		283,
		280,
		270,
		248,
		233,
		250,
		242,
		240,
		244,
		226,
		240,
		231,
		249,
		256,
		254,
		258,
		278,
		290,
		354,
		344,
		-1,
		326,
		331,
		290,
		298,
		317,
		355,
		319,
		-1,
		314,
		-1,
		285,
		298,
		-1,
		254,
		250,
		232,
		233,
		228,
		243,
		237,
		222,
		219,
		237,
		240,
		247,
		251,
		267,
		-1,
		-1,
		339,
		343,
		332,
		283,
		302,
		326,
		363,
		312,
		301,
		300,
		-1,
		291,
		268,
		265,
		253,
		240,
		225,
		226,
		234,
		247,
		226,
		221,
		218,
		238,
		264,
		242,
		254,
		-1,
		-1,
		-1,
		364,
		-1,
		-1,
		309,
		280,
		304,
		346,
		330,
		323,
		311,
		276,
		276,
		270,
		-1,
		264,
		243,
		234,
		223,
		221,
		234,
		231,
		236,
		216,
		214,
		233,
		245,
		236,
		253,
		-1,
		-1,
		-1,
		339,
		328,
		329,
		275,
		298,
		335,
		309,
		295,
		300,
		275,
		268,
		262,
		277,
		260,
		241,
		230,
		222,
		211,
		227,
		235,
		230,
		212,
		221,
		227,
		251,
		241,
		247,
		-1,
		-1,
		346,
		336,
		320,
		322,
		319,
		289,
		296,
		328,
		300,
		313,
		-1,
		267,
		-1,
		256,
		251,
		235,
		230,
		227,
		224,
		218,
		227,
		229,
		219,
		214,
		221,
		256,
		256,
		231,
		251,
		254,
		-1,
		-1,
		-1,
		339,
		334,
		309,
		286,
		270,
		306,
		-1,
		283,
		284,
		-1,
		261,
		255,
		252,
		237,
		233,
		228,
		232,
		225,
		232,
		225,
		223,
		224,
		206,
		238,
		-1,
		239,
		233,
		241,
		231,
		219,
		-1,
		-1,
		-1,
		332,
		311,
		304,
		324,
		265,
		317,
		-1,
		-1,
		268,
		261,
		-1,
		248,
		230,
		237,
		235,
		229,
		233,
		230,
		219,
		232,
		225,
		211,
		213,
		226,
		230,
		234,
		221,
		217,
		214,
		228,
		-1,
		351,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		285,
		-1,
		277,
		269,
		259,
		253,
		247,
		243,
		241,
		257,
		241,
		244,
		242,
		233,
		241,
		214,
		207,
		214,
		203,
		221,
		229,
		221,
		215,
		214,
		224,
		-1,
		352,
		338,
		309,
		-1,
		-1,
		298,
		-1,
		262,
		276,
		292,
		-1,
		285,
		264,
		279,
		257,
		253,
		249,
		264,
		265,
		242,
		242,
		240,
		231,
		219,
		208,
		211,
		203,
		225,
		225,
		209,
		210,
		214,
		-1,
		358,
		345,
		303,
		299,
		288,
		308,
		259,
		247,
		279,
		-1,
		-1,
		321,
		-1,
		255,
		272,
		263,
		261,
		254,
		236,
		243,
		251,
		228,
		223,
		213,
		202,
		202,
		197,
		219,
		205,
		203,
		212,
		228,
		-1,
		-1,
		-1,
		325,
		-1,
		-1,
		274,
		261,
		255,
		-1,
		296,
		-1,
		299,
		289,
		273,
		258,
		291,
		-1,
		235,
		231,
		238,
		-1,
		248,
		-1,
		221,
		218,
		209,
		194,
		191,
		202,
		200,
		211,
		207,
		-1,
		308,
		293,
		286,
		276,
		290,
		261,
		-1,
		316,
		-1,
		-1,
		286,
		280,
		280,
		264,
		265,
		251,
		231,
		223,
		238,
		237,
		224,
		223,
		207,
		200,
		197,
		190,
		203,
		213,
		218,
		205,
		-1,
		-1,
		-1,
		313,
		299,
		303,
		263,
		282,
		-1,
		-1,
		348,
		303,
		289,
		-1,
		260,
		251,
		239,
		229,
		219,
		224,
		225,
		215,
		213,
		205,
		207,
		201,
		192,
		191,
		207,
		199,
		221,
		-1,
		-1,
		296,
		301,
		289,
		275,
		293,
		-1,
		-1,
		-1,
		295,
		311,
		279,
		258,
		240,
		-1,
		-1,
		223,
		216,
		210,
		213,
		201,
		221,
		216,
		200,
		185,
		200,
		204,
		212,
		203,
		-1,
		299,
		286,
		-1,
		-1,
		292,
		282,
		-1,
		-1,
		-1,
		-1,
		291,
		236,
		225,
		220,
		224,
		222,
		-1,
		196,
		207,
		200,
		219,
		226,
		202,
		187,
		181,
		187,
		199,
		208,
		-1,
		-1,
		306,
		-1,
		268,
		-1,
		-1,
		-1,
		-1,
		248,
		242,
		213,
		206,
		210,
		-1,
		198,
		200,
		197,
		209,
		205,
		202,
		193,
		184,
		180,
		184,
		188,
		202,
		206,
		329,
		-1,
		259,
		-1,
		-1,
		-1,
		266,
		281,
		252,
		229,
		202,
		197,
		190,
		184,
		189,
		200,
		209,
		220,
		185,
		187,
		177,
		176,
		180,
		197,
		201,
		-1,
		-1,
		257,
		253,
		288,
		274,
		278,
		279,
		-1,
		-1,
		206,
		197,
		188,
		180,
		193,
		196,
		181,
		183,
		183,
		181,
		175,
		185,
		200,
		195,
		-1,
		-1,
		-1,
		269,
		-1,
		271,
		-1,
		-1,
		276,
		277,
		224,
		206,
		202,
		200,
		189,
		183,
		171,
		176,
		186,
		180,
		177,
		171,
		175,
		198,
		187,
		226,
		-1,
		-1,
		293,
		-1,
		-1,
		-1,
		253,
		240,
		235,
		258,
		260,
		251,
		239,
		236,
		-1,
		206,
		212,
		177,
		184,
		167,
		174,
		179,
		176,
		165,
		172,
		188,
		187,
		182,
		218,
		209,
		215,
		-1,
		-1,
		286,
		275,
		264,
		270,
		-1,
		246,
		237,
		244,
		234,
		237,
		-1,
		-1,
		231,
		228,
		208,
		177,
		175,
		168,
		163,
		173,
		149,
		161,
		165,
		169,
		175,
		180,
		185,
		191,
		206,
		221,
		-1,
		240,
		277,
		270,
		238,
		246,
		277,
		-1,
		236,
		228,
		234,
		226,
		228,
		-1,
		-1,
		204,
		195,
		196,
		184,
		181,
		187,
		186,
		169,
		175,
		176,
		168,
		167,
		185,
		189,
		198,
		205,
		195,
		208,
		212,
		-1,
		233,
		253,
		232,
		235,
		259,
		273,
		-1,
		227,
		-1,
		-1,
		194,
		229,
		213,
		203,
		200,
		243,
		198,
		193,
		174,
		172,
		167,
		158,
		183,
		176,
		176,
		179,
		194,
		199,
		191,
		205,
		205,
		206,
		-1,
		222,
		233,
		226,
		-1,
		-1,
		-1,
		-1,
		221,
		-1,
		-1,
		184,
		-1,
		240,
		-1,
		223,
		227,
		206,
		209,
		188,
		175,
		161,
		169,
		175,
		174,
		180,
		180,
		181,
		190,
		201,
		213,
		212,
		213,
		240,
		203,
		206,
		217,
		228,
		243,
		247,
		-1,
		211,
		247,
		190,
		-1,
		174,
		-1,
		-1,
		-1,
		237,
		219,
		211,
		208,
		187,
		187,
		153,
		157,
		170,
		177,
		187,
		198,
		190,
		194,
		207,
		218,
		221,
		236,
		234,
		247,
		192,
		192,
		213,
		222,
		243,
		207,
		204,
		241,
		197,
		186,
		181,
		168,
		-1,
		-1,
		221,
		229,
		-1,
		-1,
		194,
		161,
		149,
		159,
		163,
		177,
		189,
		202,
		190,
		195,
		189,
		221,
		-1,
		236,
		231,
		218,
		213,
		197,
		188,
		183,
		210,
		-1,
		-1,
		205,
		232,
		216,
		220,
		228,
		253,
		-1,
		152,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		166,
		155,
		146,
		151,
		171,
		182,
		204,
		186,
		203,
		194,
		204,
		208,
		220,
		213,
		201,
		203,
		209,
		191,
		179,
		-1,
		187,
		190,
		196,
		203,
		220,
		242,
		-1,
		-1,
		168,
		148,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		143,
		148,
		178,
		180,
		182,
		189,
		183,
		190,
		198,
		209,
		201,
		229,
		239,
		228,
		201,
		210,
		223,
		184,
		177,
		184,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		173,
		-1,
		158,
		154,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		165,
		165,
		168,
		173,
		181,
		192,
		188,
		192,
		195,
		-1,
		238,
		-1,
		215,
		176,
		182,
		197,
		205,
		-1,
		-1,
		-1,
		175,
		161,
		154,
		142,
		140,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		201,
		169,
		174,
		169,
		184,
		195,
		186,
		194,
		188,
		191,
		-1,
		-1,
		175,
		158,
		-1,
		-1,
		132,
		134,
		-1,
		166,
		155,
		140,
		132,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		135,
		173,
		172,
		180,
		175,
		180,
		192,
		188,
		184,
		194,
		185,
		-1,
		-1,
		153,
		145,
		139,
		-1,
		117,
		-1,
		168,
		-1,
		135,
		144,
		132,
		-1,
		-1,
		-1,
		166,
		129,
		145,
		168,
		194,
		192,
		183,
		176,
		183,
		186,
		179,
		185,
		-1,
		-1,
		-1,
		135,
		109,
		175,
		166,
		149,
		129,
		121,
		143,
		-1,
		147,
		-1,
		122,
		125,
		150,
		189,
		191,
		177,
		173,
		186,
		180,
		177,
		175,
		141,
		-1,
		111,
		144,
		108,
		135,
		101,
		115,
		161,
		-1,
		144,
		126,
		-1,
		154,
		144,
		192,
		167,
		176,
		169,
		163,
		164,
		172,
		-1,
		-1,
		-1,
		113,
		112,
		104,
		98,
		98,
		96,
		113,
		-1,
		149,
		131,
		117,
		134,
		134,
		125,
		133,
		182,
		178,
		181,
		179,
		157,
		-1,
		55,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		107,
		91,
		104,
		115,
		118,
		114,
		114,
		116,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		156,
		188,
		-1,
		50,
		-1,
		143,
		-1,
		-1,
		68,
		75,
		85,
		96,
		124,
		124,
		113,
		109,
		126,
		161,
		147,
		145,
		150,
		155,
		-1,
		39,
		38,
		-1,
		32,
		42,
		63,
		-1,
		66,
		-1,
		170,
		131,
		-1,
		110,
		104,
		-1,
		156,
		152,
		-1,
		-1,
		26,
		21,
		-1,
		-1,
		-1,
		65,
		74,
		165,
		149,
		-1,
		94,
		101,
		-1,
		-1,
		-1,
		11,
		12,
		-1,
		58,
		61,
		-1,
		75,
		81,
		109,
		89,
		95,
		-1,
		-1,
		-1,
		20,
		0,
		5,
		48,
		43,
		66,
		106,
		92,
		92,
		76,
		86,
		115,
		-1,
		-1,
		-1,
		19,
		16,
		28,
		-1,
		-1,
		117,
		100,
		87,
		85,
		-1,
		-1,
		-1,
		41,
		22,
		-1,
		-1,
		37,
		-1,
		-1,
		82,
		61,
		-1,
		-1,
		-1,
		-1,
		-1,
		59,
		30,
		-1,
		-1,
		-1,
		38,
		45,
		66,
		-1,
		-1,
		-1,
		-1,
		56,
		57,
		76,
		51,
		-1,
		-1,
		-1,
		52,
		55,
		-1,
		-1,
		59,
		57,
		-1,
		-1,
		-1,
		80,
		64,
		-1,
		66,
		-1,
		-1,
		-1,
		71,
		-1,
		-1,
		99,
		-1,
		-1,
		-1,
		85,
		-1,
		101,
		76,
		83,
		-1,
		-1,
		-1,
		-1,
		98,
		90,
		114,
		-1,
		86,
		88,
		-1,
		136,
		-1,
		-1,
		113,
		104,
		-1,
		-1,
		91,
		98,
		120,
		123,
		143,
		-1,
		110
	],
	[
		-1,
		336,
		325,
		336,
		344,
		317,
		324,
		-1,
		343,
		347,
		313,
		307,
		346,
		315,
		321,
		332,
		-1,
		-1,
		-1,
		336,
		335,
		303,
		301,
		310,
		315,
		322,
		-1,
		321,
		-1,
		357,
		336,
		347,
		352,
		296,
		293,
		313,
		332,
		314,
		306,
		372,
		326,
		297,
		291,
		309,
		299,
		308,
		300,
		-1,
		297,
		287,
		309,
		288,
		299,
		291,
		-1,
		-1,
		291,
		292,
		298,
		284,
		290,
		286,
		-1,
		296,
		280,
		-1,
		-1,
		281,
		282,
		266,
		269,
		277,
		275,
		288,
		280,
		275,
		-1,
		-1,
		272,
		268,
		275,
		262,
		258,
		275,
		288,
		270,
		284,
		283,
		-1,
		276,
		294,
		301,
		269,
		267,
		251,
		249,
		267,
		269,
		275,
		275,
		-1,
		285,
		286,
		281,
		289,
		291,
		267,
		254,
		254,
		264,
		257,
		276,
		264,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		285,
		268,
		285,
		277,
		267,
		282,
		275,
		257,
		254,
		252,
		249,
		265,
		263,
		273,
		-1,
		-1,
		378,
		347,
		376,
		334,
		315,
		-1,
		281,
		261,
		267,
		271,
		265,
		258,
		272,
		268,
		-1,
		243,
		242,
		270,
		256,
		267,
		338,
		-1,
		-1,
		336,
		328,
		311,
		314,
		291,
		287,
		276,
		275,
		267,
		253,
		249,
		255,
		258,
		258,
		264,
		237,
		247,
		251,
		249,
		274,
		-1,
		-1,
		309,
		-1,
		-1,
		335,
		318,
		-1,
		301,
		308,
		297,
		303,
		289,
		310,
		286,
		277,
		269,
		263,
		251,
		253,
		250,
		263,
		251,
		234,
		259,
		263,
		244,
		265,
		260,
		-1,
		308,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		294,
		297,
		303,
		327,
		326,
		-1,
		298,
		286,
		287,
		272,
		269,
		256,
		244,
		257,
		242,
		249,
		248,
		238,
		236,
		266,
		241,
		263,
		260,
		279,
		284,
		278,
		287,
		-1,
		343,
		339,
		335,
		342,
		291,
		-1,
		-1,
		331,
		-1,
		334,
		335,
		310,
		283,
		286,
		273,
		264,
		251,
		240,
		251,
		240,
		237,
		245,
		230,
		245,
		236,
		235,
		253,
		263,
		271,
		275,
		281,
		-1,
		393,
		-1,
		335,
		319,
		321,
		293,
		314,
		-1,
		351,
		335,
		327,
		312,
		312,
		-1,
		282,
		279,
		269,
		247,
		232,
		249,
		241,
		239,
		243,
		225,
		239,
		230,
		248,
		255,
		253,
		257,
		277,
		289,
		353,
		343,
		-1,
		325,
		330,
		289,
		297,
		316,
		354,
		318,
		-1,
		313,
		-1,
		284,
		297,
		-1,
		253,
		249,
		231,
		232,
		227,
		242,
		236,
		221,
		218,
		236,
		239,
		246,
		250,
		266,
		-1,
		-1,
		338,
		342,
		331,
		282,
		301,
		325,
		362,
		311,
		300,
		299,
		-1,
		290,
		267,
		264,
		252,
		239,
		224,
		225,
		233,
		246,
		225,
		220,
		217,
		237,
		263,
		241,
		253,
		-1,
		-1,
		-1,
		363,
		-1,
		-1,
		308,
		279,
		303,
		345,
		329,
		322,
		310,
		275,
		275,
		269,
		-1,
		263,
		242,
		233,
		222,
		220,
		233,
		230,
		235,
		215,
		213,
		232,
		244,
		235,
		252,
		-1,
		-1,
		-1,
		338,
		327,
		328,
		274,
		297,
		334,
		308,
		294,
		299,
		274,
		267,
		261,
		276,
		259,
		240,
		229,
		221,
		210,
		226,
		234,
		229,
		211,
		220,
		226,
		250,
		240,
		246,
		-1,
		-1,
		345,
		335,
		319,
		321,
		318,
		288,
		295,
		327,
		299,
		312,
		-1,
		266,
		-1,
		255,
		250,
		234,
		229,
		226,
		223,
		217,
		226,
		228,
		218,
		213,
		220,
		255,
		255,
		230,
		250,
		253,
		-1,
		-1,
		-1,
		338,
		333,
		308,
		285,
		269,
		305,
		-1,
		282,
		283,
		-1,
		260,
		254,
		251,
		236,
		232,
		227,
		231,
		224,
		231,
		224,
		222,
		223,
		205,
		237,
		-1,
		238,
		232,
		240,
		230,
		218,
		-1,
		-1,
		-1,
		331,
		310,
		303,
		323,
		264,
		316,
		-1,
		-1,
		267,
		260,
		-1,
		247,
		229,
		236,
		234,
		228,
		232,
		229,
		218,
		231,
		224,
		210,
		212,
		225,
		229,
		233,
		220,
		216,
		213,
		227,
		-1,
		350,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		284,
		-1,
		276,
		268,
		258,
		252,
		246,
		242,
		240,
		256,
		240,
		243,
		241,
		232,
		240,
		213,
		206,
		213,
		202,
		220,
		228,
		220,
		214,
		213,
		223,
		-1,
		351,
		337,
		308,
		-1,
		-1,
		297,
		-1,
		261,
		275,
		291,
		-1,
		284,
		263,
		278,
		256,
		252,
		248,
		263,
		264,
		241,
		241,
		239,
		230,
		218,
		207,
		210,
		202,
		224,
		224,
		208,
		209,
		213,
		-1,
		357,
		344,
		302,
		298,
		287,
		307,
		258,
		246,
		278,
		-1,
		-1,
		320,
		-1,
		254,
		271,
		262,
		260,
		253,
		235,
		242,
		250,
		227,
		222,
		212,
		201,
		201,
		196,
		218,
		204,
		202,
		211,
		227,
		-1,
		-1,
		-1,
		324,
		-1,
		-1,
		273,
		260,
		254,
		-1,
		295,
		-1,
		298,
		288,
		272,
		257,
		290,
		-1,
		234,
		230,
		237,
		-1,
		247,
		-1,
		220,
		217,
		208,
		193,
		190,
		201,
		199,
		210,
		206,
		-1,
		307,
		292,
		285,
		275,
		289,
		260,
		-1,
		315,
		-1,
		-1,
		285,
		279,
		279,
		263,
		264,
		250,
		230,
		222,
		237,
		236,
		223,
		222,
		206,
		199,
		196,
		189,
		202,
		212,
		217,
		204,
		-1,
		-1,
		-1,
		312,
		298,
		302,
		262,
		281,
		-1,
		-1,
		347,
		302,
		288,
		-1,
		259,
		250,
		238,
		228,
		218,
		223,
		224,
		214,
		212,
		204,
		206,
		200,
		191,
		190,
		206,
		198,
		220,
		-1,
		-1,
		295,
		300,
		288,
		274,
		292,
		-1,
		-1,
		-1,
		294,
		310,
		278,
		257,
		239,
		-1,
		-1,
		222,
		215,
		209,
		212,
		200,
		220,
		215,
		199,
		184,
		199,
		203,
		211,
		202,
		-1,
		298,
		285,
		-1,
		-1,
		291,
		281,
		-1,
		-1,
		-1,
		-1,
		290,
		235,
		224,
		219,
		223,
		221,
		-1,
		195,
		206,
		199,
		218,
		225,
		201,
		186,
		180,
		186,
		198,
		207,
		-1,
		-1,
		305,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		247,
		241,
		212,
		205,
		209,
		-1,
		197,
		199,
		196,
		208,
		204,
		201,
		192,
		183,
		179,
		183,
		187,
		201,
		205,
		328,
		-1,
		258,
		-1,
		-1,
		-1,
		265,
		280,
		251,
		228,
		201,
		196,
		189,
		183,
		188,
		199,
		208,
		219,
		184,
		186,
		176,
		175,
		179,
		196,
		200,
		-1,
		-1,
		256,
		252,
		287,
		273,
		277,
		278,
		-1,
		-1,
		205,
		196,
		187,
		179,
		192,
		195,
		180,
		182,
		182,
		180,
		174,
		184,
		199,
		194,
		-1,
		-1,
		-1,
		268,
		-1,
		270,
		-1,
		-1,
		275,
		276,
		223,
		205,
		201,
		199,
		188,
		182,
		170,
		175,
		185,
		179,
		176,
		170,
		174,
		197,
		186,
		225,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		252,
		239,
		234,
		257,
		259,
		250,
		238,
		235,
		-1,
		205,
		211,
		176,
		183,
		166,
		173,
		178,
		175,
		164,
		171,
		187,
		186,
		181,
		217,
		208,
		214,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		245,
		236,
		243,
		233,
		236,
		-1,
		-1,
		230,
		227,
		207,
		176,
		174,
		167,
		162,
		172,
		148,
		160,
		164,
		168,
		174,
		179,
		184,
		190,
		205,
		220,
		-1,
		239,
		276,
		269,
		237,
		245,
		276,
		-1,
		235,
		227,
		233,
		225,
		227,
		-1,
		-1,
		203,
		194,
		195,
		183,
		180,
		186,
		185,
		168,
		174,
		175,
		167,
		166,
		184,
		188,
		197,
		204,
		194,
		207,
		211,
		-1,
		232,
		252,
		231,
		234,
		258,
		272,
		-1,
		226,
		-1,
		-1,
		193,
		228,
		212,
		202,
		199,
		242,
		197,
		192,
		173,
		171,
		166,
		157,
		182,
		175,
		175,
		178,
		193,
		198,
		190,
		204,
		204,
		205,
		-1,
		221,
		232,
		225,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		183,
		-1,
		239,
		-1,
		222,
		226,
		205,
		208,
		187,
		174,
		160,
		168,
		174,
		173,
		179,
		179,
		180,
		189,
		200,
		212,
		211,
		212,
		246,
		202,
		205,
		216,
		227,
		242,
		246,
		-1,
		210,
		246,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		236,
		218,
		210,
		207,
		186,
		186,
		152,
		156,
		169,
		176,
		186,
		197,
		189,
		193,
		206,
		217,
		220,
		242,
		233,
		246,
		191,
		191,
		212,
		221,
		242,
		206,
		203,
		240,
		196,
		185,
		180,
		167,
		-1,
		-1,
		220,
		228,
		-1,
		-1,
		193,
		160,
		148,
		158,
		162,
		176,
		188,
		201,
		189,
		194,
		188,
		220,
		-1,
		235,
		234,
		223,
		219,
		196,
		187,
		182,
		209,
		-1,
		-1,
		204,
		231,
		215,
		219,
		227,
		252,
		-1,
		151,
		-1,
		-1,
		200,
		-1,
		-1,
		185,
		165,
		154,
		145,
		150,
		170,
		181,
		203,
		185,
		202,
		193,
		203,
		207,
		219,
		216,
		204,
		202,
		215,
		190,
		178,
		-1,
		186,
		189,
		195,
		202,
		219,
		241,
		-1,
		-1,
		167,
		147,
		-1,
		-1,
		183,
		181,
		170,
		-1,
		160,
		142,
		147,
		177,
		179,
		181,
		188,
		182,
		189,
		197,
		208,
		200,
		228,
		242,
		231,
		207,
		216,
		229,
		183,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		172,
		-1,
		157,
		153,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		164,
		164,
		167,
		172,
		180,
		191,
		187,
		191,
		194,
		-1,
		244,
		-1,
		214,
		175,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		174,
		160,
		153,
		141,
		139,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		200,
		168,
		173,
		168,
		183,
		194,
		185,
		193,
		187,
		190,
		-1,
		-1,
		174,
		157,
		-1,
		-1,
		131,
		133,
		-1,
		165,
		154,
		139,
		131,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		134,
		172,
		171,
		179,
		174,
		179,
		191,
		187,
		183,
		193,
		184,
		-1,
		-1,
		152,
		144,
		138,
		-1,
		116,
		-1,
		167,
		-1,
		134,
		143,
		131,
		-1,
		-1,
		-1,
		165,
		128,
		144,
		167,
		193,
		191,
		182,
		175,
		182,
		185,
		178,
		184,
		-1,
		-1,
		-1,
		134,
		108,
		174,
		165,
		148,
		128,
		120,
		142,
		-1,
		146,
		-1,
		121,
		124,
		149,
		188,
		190,
		176,
		172,
		185,
		179,
		176,
		174,
		140,
		-1,
		110,
		143,
		107,
		134,
		100,
		114,
		160,
		-1,
		143,
		125,
		-1,
		153,
		143,
		191,
		166,
		175,
		168,
		162,
		163,
		171,
		-1,
		-1,
		-1,
		112,
		111,
		103,
		97,
		97,
		95,
		112,
		-1,
		148,
		130,
		116,
		133,
		133,
		124,
		132,
		181,
		177,
		180,
		178,
		156,
		-1,
		61,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		106,
		90,
		103,
		114,
		117,
		113,
		113,
		115,
		128,
		136,
		134,
		131,
		143,
		139,
		159,
		155,
		187,
		-1,
		56,
		-1,
		142,
		-1,
		-1,
		74,
		74,
		84,
		95,
		123,
		123,
		112,
		108,
		125,
		160,
		146,
		144,
		149,
		154,
		-1,
		45,
		44,
		-1,
		38,
		48,
		69,
		-1,
		65,
		-1,
		169,
		130,
		-1,
		109,
		103,
		-1,
		155,
		151,
		-1,
		-1,
		32,
		27,
		-1,
		-1,
		-1,
		64,
		73,
		164,
		148,
		-1,
		93,
		100,
		-1,
		-1,
		-1,
		17,
		18,
		-1,
		57,
		60,
		-1,
		74,
		80,
		108,
		88,
		94,
		-1,
		-1,
		-1,
		26,
		6,
		0,
		47,
		42,
		65,
		105,
		91,
		91,
		75,
		85,
		114,
		-1,
		-1,
		-1,
		18,
		15,
		27,
		-1,
		-1,
		116,
		99,
		86,
		84,
		-1,
		-1,
		-1,
		40,
		21,
		-1,
		-1,
		36,
		-1,
		-1,
		81,
		60,
		-1,
		-1,
		-1,
		-1,
		-1,
		58,
		29,
		-1,
		-1,
		-1,
		37,
		44,
		65,
		-1,
		-1,
		-1,
		-1,
		55,
		56,
		75,
		50,
		-1,
		-1,
		-1,
		51,
		54,
		-1,
		-1,
		58,
		56,
		-1,
		-1,
		-1,
		79,
		63,
		-1,
		65,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		98,
		-1,
		-1,
		-1,
		84,
		-1,
		100,
		75,
		82,
		-1,
		-1,
		-1,
		-1,
		97,
		89,
		113,
		-1,
		85,
		87,
		-1,
		135,
		-1,
		-1,
		112,
		103,
		-1,
		-1,
		90,
		97,
		119,
		122,
		142,
		-1,
		109
	],
	[
		-1,
		330,
		319,
		330,
		338,
		311,
		318,
		-1,
		337,
		341,
		307,
		301,
		340,
		309,
		315,
		326,
		-1,
		-1,
		-1,
		330,
		329,
		297,
		295,
		304,
		309,
		316,
		-1,
		315,
		-1,
		351,
		330,
		341,
		346,
		290,
		287,
		307,
		326,
		308,
		300,
		366,
		320,
		291,
		285,
		303,
		293,
		302,
		294,
		-1,
		291,
		281,
		303,
		282,
		293,
		285,
		-1,
		-1,
		285,
		286,
		292,
		278,
		284,
		280,
		-1,
		290,
		274,
		-1,
		-1,
		275,
		276,
		260,
		263,
		271,
		269,
		282,
		274,
		269,
		-1,
		-1,
		266,
		262,
		269,
		256,
		252,
		269,
		282,
		264,
		278,
		277,
		-1,
		270,
		288,
		295,
		263,
		261,
		245,
		243,
		261,
		263,
		269,
		269,
		-1,
		279,
		280,
		275,
		283,
		285,
		261,
		248,
		248,
		258,
		251,
		270,
		258,
		304,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		279,
		262,
		279,
		271,
		261,
		276,
		269,
		251,
		248,
		246,
		243,
		259,
		257,
		267,
		-1,
		-1,
		372,
		341,
		370,
		328,
		309,
		-1,
		275,
		255,
		261,
		265,
		259,
		252,
		266,
		262,
		-1,
		237,
		236,
		264,
		250,
		261,
		332,
		-1,
		-1,
		330,
		322,
		305,
		308,
		285,
		281,
		270,
		269,
		261,
		247,
		243,
		249,
		252,
		252,
		258,
		231,
		241,
		245,
		243,
		268,
		-1,
		-1,
		303,
		-1,
		-1,
		329,
		312,
		-1,
		295,
		302,
		291,
		297,
		283,
		304,
		280,
		271,
		263,
		257,
		245,
		247,
		244,
		257,
		245,
		228,
		253,
		257,
		238,
		259,
		254,
		-1,
		302,
		286,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		307,
		288,
		291,
		297,
		321,
		320,
		-1,
		292,
		280,
		281,
		266,
		263,
		250,
		238,
		251,
		236,
		243,
		242,
		232,
		230,
		260,
		235,
		257,
		254,
		273,
		278,
		272,
		281,
		-1,
		337,
		333,
		329,
		336,
		285,
		-1,
		-1,
		325,
		-1,
		328,
		329,
		304,
		277,
		280,
		267,
		258,
		245,
		234,
		245,
		234,
		231,
		239,
		224,
		239,
		230,
		229,
		247,
		257,
		265,
		269,
		275,
		-1,
		387,
		-1,
		329,
		313,
		315,
		287,
		308,
		-1,
		345,
		329,
		321,
		306,
		306,
		-1,
		276,
		273,
		263,
		241,
		226,
		243,
		235,
		233,
		237,
		219,
		233,
		224,
		242,
		249,
		247,
		251,
		271,
		283,
		347,
		337,
		-1,
		319,
		324,
		283,
		291,
		310,
		348,
		312,
		-1,
		307,
		-1,
		278,
		291,
		-1,
		247,
		243,
		225,
		226,
		221,
		236,
		230,
		215,
		212,
		230,
		233,
		240,
		244,
		260,
		-1,
		-1,
		332,
		336,
		325,
		276,
		295,
		319,
		356,
		305,
		294,
		293,
		-1,
		284,
		261,
		258,
		246,
		233,
		218,
		219,
		227,
		240,
		219,
		214,
		211,
		231,
		257,
		235,
		247,
		-1,
		-1,
		-1,
		357,
		-1,
		-1,
		302,
		273,
		297,
		339,
		323,
		316,
		304,
		269,
		269,
		263,
		-1,
		257,
		236,
		227,
		216,
		214,
		227,
		224,
		229,
		209,
		207,
		226,
		238,
		229,
		246,
		-1,
		-1,
		-1,
		332,
		321,
		322,
		268,
		291,
		328,
		302,
		288,
		293,
		268,
		261,
		255,
		270,
		253,
		234,
		223,
		215,
		204,
		220,
		228,
		223,
		205,
		214,
		220,
		244,
		234,
		240,
		-1,
		-1,
		339,
		329,
		313,
		315,
		312,
		282,
		289,
		321,
		293,
		306,
		-1,
		260,
		-1,
		249,
		244,
		228,
		223,
		220,
		217,
		211,
		220,
		222,
		212,
		207,
		214,
		249,
		249,
		224,
		244,
		247,
		-1,
		-1,
		-1,
		332,
		327,
		302,
		279,
		263,
		299,
		-1,
		276,
		277,
		-1,
		254,
		248,
		245,
		230,
		226,
		221,
		225,
		218,
		225,
		218,
		216,
		217,
		199,
		231,
		-1,
		232,
		226,
		234,
		224,
		212,
		-1,
		-1,
		-1,
		325,
		304,
		297,
		317,
		258,
		310,
		-1,
		-1,
		261,
		254,
		-1,
		241,
		223,
		230,
		228,
		222,
		226,
		223,
		212,
		225,
		218,
		204,
		206,
		219,
		223,
		227,
		214,
		210,
		207,
		221,
		-1,
		344,
		-1,
		-1,
		-1,
		-1,
		-1,
		258,
		278,
		-1,
		270,
		262,
		252,
		246,
		240,
		236,
		234,
		250,
		234,
		237,
		235,
		226,
		234,
		207,
		200,
		207,
		196,
		214,
		222,
		214,
		208,
		207,
		217,
		-1,
		345,
		331,
		302,
		-1,
		-1,
		291,
		-1,
		255,
		269,
		285,
		-1,
		278,
		257,
		272,
		250,
		246,
		242,
		257,
		258,
		235,
		235,
		233,
		224,
		212,
		201,
		204,
		196,
		218,
		218,
		202,
		203,
		207,
		-1,
		351,
		338,
		296,
		292,
		281,
		301,
		252,
		240,
		272,
		-1,
		-1,
		314,
		-1,
		248,
		265,
		256,
		254,
		247,
		229,
		236,
		244,
		221,
		216,
		206,
		195,
		195,
		190,
		212,
		198,
		196,
		205,
		221,
		-1,
		-1,
		-1,
		318,
		-1,
		-1,
		267,
		254,
		248,
		-1,
		289,
		-1,
		292,
		282,
		266,
		251,
		284,
		-1,
		228,
		224,
		231,
		-1,
		241,
		-1,
		214,
		211,
		202,
		187,
		184,
		195,
		193,
		204,
		200,
		-1,
		301,
		286,
		279,
		269,
		283,
		254,
		-1,
		309,
		-1,
		-1,
		279,
		273,
		273,
		257,
		258,
		244,
		224,
		216,
		231,
		230,
		217,
		216,
		200,
		193,
		190,
		183,
		196,
		206,
		211,
		198,
		-1,
		-1,
		-1,
		306,
		292,
		296,
		256,
		275,
		-1,
		-1,
		341,
		296,
		282,
		-1,
		253,
		244,
		232,
		222,
		212,
		217,
		218,
		208,
		206,
		198,
		200,
		194,
		185,
		184,
		200,
		192,
		214,
		-1,
		-1,
		289,
		294,
		282,
		268,
		269,
		-1,
		-1,
		-1,
		288,
		304,
		272,
		251,
		233,
		-1,
		-1,
		216,
		209,
		203,
		206,
		194,
		214,
		209,
		193,
		178,
		193,
		197,
		205,
		196,
		-1,
		292,
		279,
		-1,
		-1,
		268,
		258,
		-1,
		-1,
		-1,
		-1,
		284,
		229,
		218,
		213,
		217,
		215,
		-1,
		189,
		200,
		193,
		212,
		219,
		195,
		180,
		174,
		180,
		192,
		201,
		-1,
		-1,
		282,
		-1,
		244,
		-1,
		-1,
		-1,
		-1,
		241,
		235,
		206,
		199,
		203,
		-1,
		191,
		193,
		190,
		202,
		198,
		195,
		186,
		177,
		173,
		177,
		181,
		195,
		199,
		305,
		-1,
		235,
		-1,
		-1,
		-1,
		259,
		274,
		245,
		222,
		195,
		190,
		183,
		177,
		182,
		193,
		202,
		213,
		178,
		180,
		170,
		169,
		173,
		190,
		194,
		-1,
		-1,
		233,
		229,
		264,
		267,
		271,
		272,
		-1,
		-1,
		199,
		190,
		181,
		173,
		186,
		189,
		174,
		176,
		176,
		174,
		168,
		178,
		193,
		188,
		-1,
		-1,
		-1,
		245,
		-1,
		247,
		-1,
		-1,
		266,
		270,
		217,
		199,
		195,
		193,
		182,
		176,
		164,
		169,
		179,
		173,
		170,
		164,
		168,
		191,
		180,
		219,
		-1,
		-1,
		269,
		-1,
		-1,
		-1,
		229,
		216,
		211,
		245,
		250,
		241,
		232,
		229,
		-1,
		199,
		205,
		170,
		177,
		160,
		167,
		172,
		169,
		158,
		165,
		181,
		180,
		175,
		211,
		202,
		208,
		-1,
		-1,
		262,
		251,
		240,
		246,
		-1,
		222,
		213,
		231,
		221,
		227,
		-1,
		-1,
		224,
		221,
		201,
		170,
		168,
		161,
		156,
		166,
		142,
		154,
		158,
		162,
		168,
		173,
		178,
		184,
		199,
		214,
		-1,
		216,
		253,
		246,
		214,
		222,
		253,
		-1,
		212,
		204,
		210,
		213,
		221,
		-1,
		-1,
		197,
		188,
		189,
		177,
		174,
		180,
		179,
		162,
		168,
		169,
		161,
		160,
		178,
		182,
		191,
		198,
		188,
		201,
		205,
		-1,
		209,
		229,
		208,
		211,
		235,
		249,
		-1,
		203,
		-1,
		-1,
		170,
		222,
		206,
		196,
		193,
		236,
		191,
		186,
		167,
		165,
		160,
		151,
		176,
		169,
		169,
		172,
		187,
		192,
		184,
		198,
		198,
		199,
		-1,
		198,
		209,
		202,
		-1,
		-1,
		-1,
		-1,
		197,
		-1,
		-1,
		160,
		-1,
		233,
		-1,
		216,
		220,
		199,
		202,
		181,
		168,
		154,
		162,
		168,
		167,
		173,
		173,
		174,
		183,
		194,
		206,
		205,
		206,
		223,
		179,
		182,
		193,
		204,
		219,
		223,
		-1,
		187,
		223,
		166,
		-1,
		150,
		-1,
		-1,
		-1,
		230,
		212,
		204,
		201,
		180,
		180,
		146,
		150,
		163,
		170,
		180,
		191,
		183,
		187,
		200,
		211,
		214,
		219,
		210,
		223,
		168,
		168,
		189,
		198,
		219,
		183,
		180,
		217,
		173,
		162,
		157,
		144,
		-1,
		-1,
		214,
		222,
		-1,
		-1,
		187,
		154,
		142,
		152,
		156,
		170,
		182,
		195,
		183,
		188,
		182,
		214,
		-1,
		212,
		211,
		200,
		197,
		173,
		164,
		159,
		186,
		-1,
		-1,
		181,
		208,
		192,
		196,
		204,
		229,
		-1,
		128,
		-1,
		-1,
		194,
		-1,
		-1,
		179,
		159,
		148,
		139,
		144,
		164,
		175,
		197,
		179,
		196,
		187,
		197,
		201,
		196,
		193,
		181,
		179,
		202,
		167,
		155,
		-1,
		163,
		166,
		172,
		179,
		196,
		218,
		-1,
		-1,
		144,
		124,
		-1,
		-1,
		177,
		175,
		164,
		-1,
		154,
		136,
		141,
		171,
		173,
		175,
		182,
		176,
		183,
		191,
		202,
		194,
		205,
		219,
		208,
		204,
		203,
		211,
		160,
		153,
		160,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		149,
		-1,
		134,
		130,
		-1,
		-1,
		172,
		165,
		153,
		141,
		131,
		141,
		158,
		158,
		161,
		166,
		174,
		185,
		181,
		185,
		188,
		-1,
		239,
		-1,
		191,
		152,
		158,
		173,
		181,
		-1,
		-1,
		-1,
		151,
		137,
		130,
		118,
		116,
		-1,
		206,
		190,
		171,
		-1,
		141,
		154,
		194,
		162,
		167,
		162,
		177,
		188,
		179,
		187,
		181,
		184,
		-1,
		-1,
		151,
		134,
		-1,
		-1,
		108,
		110,
		-1,
		142,
		131,
		116,
		108,
		-1,
		-1,
		178,
		174,
		-1,
		-1,
		128,
		166,
		165,
		173,
		168,
		173,
		185,
		181,
		177,
		187,
		178,
		-1,
		-1,
		129,
		121,
		115,
		-1,
		93,
		-1,
		144,
		-1,
		111,
		120,
		108,
		-1,
		-1,
		-1,
		159,
		122,
		138,
		161,
		187,
		185,
		176,
		169,
		176,
		179,
		172,
		178,
		-1,
		-1,
		-1,
		111,
		85,
		151,
		142,
		125,
		105,
		97,
		119,
		-1,
		140,
		-1,
		115,
		118,
		143,
		182,
		184,
		170,
		166,
		179,
		173,
		170,
		168,
		117,
		-1,
		87,
		120,
		84,
		111,
		77,
		91,
		154,
		-1,
		137,
		119,
		-1,
		147,
		137,
		185,
		160,
		169,
		162,
		156,
		157,
		165,
		-1,
		-1,
		-1,
		89,
		88,
		80,
		74,
		74,
		72,
		89,
		-1,
		142,
		124,
		110,
		127,
		127,
		118,
		126,
		175,
		171,
		174,
		172,
		150,
		-1,
		103,
		-1,
		-1,
		112,
		-1,
		-1,
		-1,
		83,
		67,
		80,
		91,
		104,
		111,
		107,
		109,
		122,
		130,
		128,
		125,
		137,
		133,
		153,
		149,
		181,
		-1,
		98,
		-1,
		119,
		-1,
		-1,
		64,
		51,
		61,
		72,
		100,
		100,
		104,
		102,
		123,
		154,
		140,
		138,
		143,
		148,
		-1,
		87,
		86,
		-1,
		80,
		75,
		61,
		-1,
		42,
		-1,
		146,
		107,
		-1,
		107,
		101,
		-1,
		149,
		145,
		-1,
		-1,
		74,
		69,
		-1,
		-1,
		-1,
		37,
		50,
		141,
		125,
		-1,
		91,
		98,
		-1,
		-1,
		-1,
		59,
		60,
		-1,
		10,
		33,
		-1,
		51,
		57,
		85,
		86,
		92,
		-1,
		-1,
		-1,
		68,
		49,
		43,
		0,
		5,
		38,
		82,
		68,
		68,
		73,
		83,
		112,
		-1,
		-1,
		-1,
		40,
		32,
		20,
		-1,
		-1,
		93,
		76,
		76,
		82,
		-1,
		-1,
		-1,
		62,
		43,
		-1,
		-1,
		34,
		-1,
		-1,
		79,
		58,
		-1,
		-1,
		-1,
		-1,
		-1,
		80,
		51,
		-1,
		-1,
		-1,
		35,
		42,
		63,
		-1,
		-1,
		-1,
		-1,
		73,
		74,
		97,
		72,
		-1,
		-1,
		-1,
		49,
		52,
		-1,
		-1,
		76,
		74,
		-1,
		-1,
		-1,
		77,
		61,
		-1,
		63,
		-1,
		-1,
		-1,
		68,
		-1,
		-1,
		96,
		-1,
		-1,
		-1,
		82,
		-1,
		98,
		73,
		80,
		-1,
		-1,
		-1,
		-1,
		95,
		87,
		111,
		-1,
		83,
		85,
		-1,
		133,
		-1,
		-1,
		110,
		101,
		-1,
		-1,
		88,
		95,
		117,
		120,
		140,
		-1,
		107
	],
	[
		-1,
		329,
		318,
		329,
		337,
		310,
		317,
		-1,
		336,
		340,
		306,
		300,
		339,
		308,
		314,
		325,
		-1,
		-1,
		-1,
		329,
		328,
		296,
		294,
		303,
		308,
		315,
		-1,
		314,
		-1,
		350,
		329,
		340,
		345,
		289,
		286,
		306,
		325,
		307,
		299,
		365,
		319,
		290,
		284,
		302,
		292,
		301,
		293,
		-1,
		290,
		280,
		302,
		281,
		292,
		284,
		-1,
		-1,
		284,
		285,
		291,
		277,
		283,
		279,
		-1,
		289,
		273,
		-1,
		-1,
		274,
		275,
		259,
		262,
		270,
		268,
		281,
		273,
		268,
		-1,
		-1,
		265,
		261,
		268,
		255,
		251,
		268,
		281,
		263,
		277,
		276,
		-1,
		269,
		287,
		294,
		262,
		260,
		244,
		242,
		260,
		262,
		268,
		268,
		-1,
		278,
		279,
		274,
		282,
		284,
		260,
		247,
		247,
		257,
		250,
		269,
		257,
		303,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		278,
		261,
		278,
		270,
		260,
		275,
		268,
		250,
		247,
		245,
		242,
		258,
		256,
		266,
		-1,
		-1,
		371,
		340,
		369,
		327,
		308,
		-1,
		274,
		254,
		260,
		264,
		258,
		251,
		265,
		261,
		-1,
		236,
		235,
		263,
		249,
		260,
		331,
		-1,
		-1,
		329,
		321,
		304,
		307,
		284,
		280,
		269,
		268,
		260,
		246,
		242,
		248,
		251,
		251,
		257,
		230,
		240,
		244,
		242,
		267,
		-1,
		-1,
		302,
		-1,
		-1,
		328,
		311,
		-1,
		294,
		301,
		290,
		296,
		282,
		303,
		279,
		270,
		262,
		256,
		244,
		246,
		243,
		256,
		244,
		227,
		252,
		256,
		237,
		258,
		253,
		-1,
		301,
		285,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		306,
		287,
		290,
		296,
		320,
		319,
		-1,
		291,
		279,
		280,
		265,
		262,
		249,
		237,
		250,
		235,
		242,
		241,
		231,
		229,
		259,
		234,
		256,
		253,
		272,
		277,
		271,
		280,
		-1,
		336,
		332,
		328,
		335,
		284,
		-1,
		-1,
		324,
		-1,
		327,
		328,
		303,
		276,
		279,
		266,
		257,
		244,
		233,
		244,
		233,
		230,
		238,
		223,
		238,
		229,
		228,
		246,
		256,
		264,
		268,
		274,
		-1,
		386,
		-1,
		328,
		312,
		314,
		286,
		307,
		-1,
		344,
		328,
		320,
		305,
		305,
		-1,
		275,
		272,
		262,
		240,
		225,
		242,
		234,
		232,
		236,
		218,
		232,
		223,
		241,
		248,
		246,
		250,
		270,
		282,
		346,
		336,
		-1,
		318,
		323,
		282,
		290,
		309,
		347,
		311,
		-1,
		306,
		-1,
		277,
		290,
		-1,
		246,
		242,
		224,
		225,
		220,
		235,
		229,
		214,
		211,
		229,
		232,
		239,
		243,
		259,
		-1,
		-1,
		331,
		335,
		324,
		275,
		294,
		318,
		355,
		304,
		293,
		292,
		-1,
		283,
		260,
		257,
		245,
		232,
		217,
		218,
		226,
		239,
		218,
		213,
		210,
		230,
		256,
		234,
		246,
		-1,
		-1,
		-1,
		356,
		-1,
		-1,
		301,
		272,
		296,
		338,
		322,
		315,
		303,
		268,
		268,
		262,
		-1,
		256,
		235,
		226,
		215,
		213,
		226,
		223,
		228,
		208,
		206,
		225,
		237,
		228,
		245,
		-1,
		-1,
		-1,
		331,
		320,
		321,
		267,
		290,
		327,
		301,
		287,
		292,
		267,
		260,
		254,
		269,
		252,
		233,
		222,
		214,
		203,
		219,
		227,
		222,
		204,
		213,
		219,
		243,
		233,
		239,
		-1,
		-1,
		338,
		328,
		312,
		314,
		311,
		281,
		288,
		320,
		292,
		305,
		-1,
		259,
		-1,
		248,
		243,
		227,
		222,
		219,
		216,
		210,
		219,
		221,
		211,
		206,
		213,
		248,
		248,
		223,
		243,
		246,
		-1,
		-1,
		-1,
		331,
		326,
		301,
		278,
		262,
		298,
		-1,
		275,
		276,
		-1,
		253,
		247,
		244,
		229,
		225,
		220,
		224,
		217,
		224,
		217,
		215,
		216,
		198,
		230,
		-1,
		231,
		225,
		233,
		223,
		211,
		-1,
		-1,
		-1,
		324,
		303,
		296,
		316,
		257,
		309,
		-1,
		-1,
		260,
		253,
		-1,
		240,
		222,
		229,
		227,
		221,
		225,
		222,
		211,
		224,
		217,
		203,
		205,
		218,
		222,
		226,
		213,
		209,
		206,
		220,
		-1,
		343,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		277,
		-1,
		269,
		261,
		251,
		245,
		239,
		235,
		233,
		249,
		233,
		236,
		234,
		225,
		233,
		206,
		199,
		206,
		195,
		213,
		221,
		213,
		207,
		206,
		216,
		-1,
		344,
		330,
		301,
		-1,
		-1,
		290,
		-1,
		254,
		268,
		284,
		-1,
		277,
		256,
		271,
		249,
		245,
		241,
		256,
		257,
		234,
		234,
		232,
		223,
		211,
		200,
		203,
		195,
		217,
		217,
		201,
		202,
		206,
		-1,
		350,
		337,
		295,
		291,
		280,
		300,
		251,
		239,
		271,
		-1,
		-1,
		313,
		-1,
		247,
		264,
		255,
		253,
		246,
		228,
		235,
		243,
		220,
		215,
		205,
		194,
		194,
		189,
		211,
		197,
		195,
		204,
		220,
		-1,
		-1,
		-1,
		317,
		-1,
		-1,
		266,
		253,
		247,
		-1,
		288,
		-1,
		291,
		281,
		265,
		250,
		283,
		-1,
		227,
		223,
		230,
		-1,
		240,
		-1,
		213,
		210,
		201,
		186,
		183,
		194,
		192,
		203,
		199,
		-1,
		300,
		285,
		278,
		268,
		282,
		253,
		-1,
		308,
		-1,
		-1,
		278,
		272,
		272,
		256,
		257,
		243,
		223,
		215,
		230,
		229,
		216,
		215,
		199,
		192,
		189,
		182,
		195,
		205,
		210,
		197,
		-1,
		-1,
		-1,
		305,
		291,
		295,
		255,
		274,
		-1,
		-1,
		340,
		295,
		281,
		-1,
		252,
		243,
		231,
		221,
		211,
		216,
		217,
		207,
		205,
		197,
		199,
		193,
		184,
		183,
		199,
		191,
		213,
		-1,
		-1,
		288,
		293,
		281,
		267,
		274,
		-1,
		-1,
		-1,
		287,
		303,
		271,
		250,
		232,
		-1,
		-1,
		215,
		208,
		202,
		205,
		193,
		213,
		208,
		192,
		177,
		192,
		196,
		204,
		195,
		-1,
		291,
		278,
		-1,
		-1,
		273,
		263,
		-1,
		-1,
		-1,
		-1,
		283,
		228,
		217,
		212,
		216,
		214,
		-1,
		188,
		199,
		192,
		211,
		218,
		194,
		179,
		173,
		179,
		191,
		200,
		-1,
		-1,
		287,
		-1,
		249,
		-1,
		-1,
		-1,
		-1,
		240,
		234,
		205,
		198,
		202,
		-1,
		190,
		192,
		189,
		201,
		197,
		194,
		185,
		176,
		172,
		176,
		180,
		194,
		198,
		310,
		-1,
		240,
		-1,
		-1,
		-1,
		258,
		273,
		244,
		221,
		194,
		189,
		182,
		176,
		181,
		192,
		201,
		212,
		177,
		179,
		169,
		168,
		172,
		189,
		193,
		-1,
		-1,
		238,
		234,
		269,
		266,
		270,
		271,
		-1,
		-1,
		198,
		189,
		180,
		172,
		185,
		188,
		173,
		175,
		175,
		173,
		167,
		177,
		192,
		187,
		-1,
		-1,
		-1,
		250,
		-1,
		252,
		-1,
		-1,
		268,
		269,
		216,
		198,
		194,
		192,
		181,
		175,
		163,
		168,
		178,
		172,
		169,
		163,
		167,
		190,
		179,
		218,
		-1,
		-1,
		274,
		-1,
		-1,
		-1,
		234,
		221,
		216,
		250,
		252,
		243,
		231,
		228,
		-1,
		198,
		204,
		169,
		176,
		159,
		166,
		171,
		168,
		157,
		164,
		180,
		179,
		174,
		210,
		201,
		207,
		-1,
		-1,
		267,
		256,
		245,
		251,
		-1,
		227,
		218,
		236,
		226,
		229,
		-1,
		-1,
		223,
		220,
		200,
		169,
		167,
		160,
		155,
		165,
		141,
		153,
		157,
		161,
		167,
		172,
		177,
		183,
		198,
		213,
		-1,
		221,
		258,
		251,
		219,
		227,
		258,
		-1,
		217,
		209,
		215,
		218,
		220,
		-1,
		-1,
		196,
		187,
		188,
		176,
		173,
		179,
		178,
		161,
		167,
		168,
		160,
		159,
		177,
		181,
		190,
		197,
		187,
		200,
		204,
		-1,
		214,
		234,
		213,
		216,
		240,
		254,
		-1,
		208,
		-1,
		-1,
		175,
		221,
		205,
		195,
		192,
		235,
		190,
		185,
		166,
		164,
		159,
		150,
		175,
		168,
		168,
		171,
		186,
		191,
		183,
		197,
		197,
		198,
		-1,
		203,
		214,
		207,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		165,
		-1,
		232,
		-1,
		215,
		219,
		198,
		201,
		180,
		167,
		153,
		161,
		167,
		166,
		172,
		172,
		173,
		182,
		193,
		205,
		204,
		205,
		228,
		184,
		187,
		198,
		209,
		224,
		228,
		-1,
		192,
		228,
		171,
		-1,
		155,
		-1,
		-1,
		-1,
		229,
		211,
		203,
		200,
		179,
		179,
		145,
		149,
		162,
		169,
		179,
		190,
		182,
		186,
		199,
		210,
		213,
		224,
		215,
		228,
		173,
		173,
		194,
		203,
		224,
		188,
		185,
		222,
		178,
		167,
		162,
		149,
		-1,
		-1,
		213,
		221,
		-1,
		-1,
		186,
		153,
		141,
		151,
		155,
		169,
		181,
		194,
		182,
		187,
		181,
		213,
		-1,
		217,
		216,
		205,
		202,
		178,
		169,
		164,
		191,
		-1,
		-1,
		186,
		213,
		197,
		201,
		209,
		234,
		-1,
		133,
		-1,
		-1,
		193,
		-1,
		-1,
		178,
		158,
		147,
		138,
		143,
		163,
		174,
		196,
		178,
		195,
		186,
		196,
		200,
		201,
		198,
		186,
		184,
		207,
		172,
		160,
		-1,
		168,
		171,
		177,
		184,
		201,
		223,
		-1,
		-1,
		149,
		129,
		-1,
		-1,
		176,
		174,
		163,
		-1,
		153,
		135,
		140,
		170,
		172,
		174,
		181,
		175,
		182,
		190,
		201,
		193,
		210,
		224,
		213,
		209,
		208,
		216,
		165,
		158,
		165,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		154,
		-1,
		139,
		135,
		-1,
		-1,
		171,
		164,
		152,
		140,
		130,
		140,
		157,
		157,
		160,
		165,
		173,
		184,
		180,
		184,
		187,
		-1,
		244,
		-1,
		196,
		157,
		163,
		178,
		186,
		-1,
		-1,
		-1,
		156,
		142,
		135,
		123,
		121,
		-1,
		205,
		189,
		170,
		-1,
		140,
		153,
		193,
		161,
		166,
		161,
		176,
		187,
		178,
		186,
		180,
		183,
		-1,
		-1,
		156,
		139,
		-1,
		-1,
		113,
		115,
		-1,
		147,
		136,
		121,
		113,
		-1,
		-1,
		177,
		173,
		-1,
		-1,
		127,
		165,
		164,
		172,
		167,
		172,
		184,
		180,
		176,
		186,
		177,
		-1,
		-1,
		134,
		126,
		120,
		-1,
		98,
		-1,
		149,
		-1,
		116,
		125,
		113,
		-1,
		-1,
		-1,
		158,
		121,
		137,
		160,
		186,
		184,
		175,
		168,
		175,
		178,
		171,
		177,
		-1,
		-1,
		-1,
		116,
		90,
		156,
		147,
		130,
		110,
		102,
		124,
		-1,
		139,
		-1,
		114,
		117,
		142,
		181,
		183,
		169,
		165,
		178,
		172,
		169,
		167,
		122,
		-1,
		92,
		125,
		89,
		116,
		82,
		96,
		153,
		-1,
		136,
		118,
		-1,
		146,
		136,
		184,
		159,
		168,
		161,
		155,
		156,
		164,
		-1,
		-1,
		-1,
		94,
		93,
		85,
		79,
		79,
		77,
		94,
		-1,
		141,
		123,
		109,
		126,
		126,
		117,
		125,
		174,
		170,
		173,
		171,
		149,
		-1,
		98,
		-1,
		-1,
		117,
		-1,
		-1,
		-1,
		88,
		72,
		85,
		96,
		109,
		106,
		106,
		108,
		121,
		129,
		127,
		124,
		136,
		132,
		152,
		148,
		180,
		-1,
		93,
		-1,
		124,
		-1,
		-1,
		69,
		56,
		66,
		77,
		105,
		105,
		105,
		101,
		118,
		153,
		139,
		137,
		142,
		147,
		-1,
		82,
		81,
		-1,
		75,
		80,
		66,
		-1,
		47,
		-1,
		151,
		112,
		-1,
		102,
		96,
		-1,
		148,
		144,
		-1,
		-1,
		69,
		64,
		-1,
		-1,
		-1,
		42,
		55,
		146,
		130,
		-1,
		86,
		93,
		-1,
		-1,
		-1,
		54,
		55,
		-1,
		15,
		38,
		-1,
		56,
		62,
		90,
		81,
		87,
		-1,
		-1,
		-1,
		63,
		44,
		38,
		5,
		0,
		43,
		87,
		73,
		73,
		68,
		78,
		107,
		-1,
		-1,
		-1,
		35,
		27,
		15,
		-1,
		-1,
		98,
		81,
		79,
		77,
		-1,
		-1,
		-1,
		57,
		38,
		-1,
		-1,
		29,
		-1,
		-1,
		74,
		53,
		-1,
		-1,
		-1,
		-1,
		-1,
		75,
		46,
		-1,
		-1,
		-1,
		30,
		37,
		58,
		-1,
		-1,
		-1,
		-1,
		68,
		69,
		92,
		67,
		-1,
		-1,
		-1,
		44,
		47,
		-1,
		-1,
		71,
		69,
		-1,
		-1,
		-1,
		72,
		56,
		-1,
		58,
		-1,
		-1,
		-1,
		63,
		-1,
		-1,
		91,
		-1,
		-1,
		-1,
		77,
		-1,
		93,
		68,
		75,
		-1,
		-1,
		-1,
		-1,
		90,
		82,
		106,
		-1,
		78,
		80,
		-1,
		128,
		-1,
		-1,
		105,
		96,
		-1,
		-1,
		83,
		90,
		112,
		115,
		135,
		-1,
		102
	],
	[
		-1,
		328,
		317,
		328,
		336,
		309,
		316,
		-1,
		335,
		339,
		305,
		299,
		338,
		307,
		313,
		324,
		-1,
		-1,
		-1,
		328,
		327,
		295,
		293,
		302,
		307,
		314,
		-1,
		313,
		-1,
		349,
		328,
		339,
		344,
		288,
		285,
		305,
		324,
		306,
		298,
		364,
		318,
		289,
		283,
		301,
		291,
		300,
		292,
		-1,
		289,
		279,
		301,
		280,
		291,
		283,
		-1,
		-1,
		283,
		284,
		290,
		276,
		282,
		278,
		-1,
		288,
		272,
		-1,
		-1,
		273,
		274,
		258,
		261,
		269,
		267,
		280,
		272,
		267,
		-1,
		-1,
		264,
		260,
		267,
		254,
		250,
		267,
		280,
		262,
		276,
		275,
		-1,
		268,
		286,
		293,
		261,
		259,
		243,
		241,
		259,
		261,
		267,
		267,
		-1,
		277,
		278,
		273,
		281,
		283,
		259,
		246,
		246,
		256,
		249,
		268,
		256,
		302,
		-1,
		-1,
		-1,
		-1,
		-1,
		311,
		277,
		260,
		277,
		269,
		259,
		274,
		267,
		249,
		246,
		244,
		241,
		257,
		255,
		265,
		-1,
		-1,
		370,
		339,
		368,
		326,
		307,
		-1,
		273,
		253,
		259,
		263,
		257,
		250,
		264,
		260,
		-1,
		235,
		234,
		262,
		248,
		259,
		330,
		-1,
		-1,
		328,
		320,
		303,
		306,
		283,
		279,
		268,
		267,
		259,
		245,
		241,
		247,
		250,
		250,
		256,
		229,
		239,
		243,
		241,
		266,
		-1,
		-1,
		301,
		-1,
		-1,
		327,
		310,
		-1,
		293,
		300,
		289,
		295,
		281,
		302,
		278,
		269,
		261,
		255,
		243,
		245,
		242,
		255,
		243,
		226,
		251,
		255,
		236,
		257,
		252,
		-1,
		300,
		284,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		305,
		286,
		289,
		295,
		319,
		318,
		-1,
		290,
		278,
		279,
		264,
		261,
		248,
		236,
		249,
		234,
		241,
		240,
		230,
		228,
		258,
		233,
		255,
		252,
		271,
		276,
		270,
		279,
		-1,
		335,
		331,
		327,
		334,
		283,
		-1,
		-1,
		323,
		-1,
		326,
		327,
		302,
		275,
		278,
		265,
		256,
		243,
		232,
		243,
		232,
		229,
		237,
		222,
		237,
		228,
		227,
		245,
		255,
		263,
		267,
		273,
		-1,
		385,
		-1,
		327,
		311,
		313,
		285,
		306,
		-1,
		343,
		327,
		319,
		304,
		304,
		-1,
		274,
		271,
		261,
		239,
		224,
		241,
		233,
		231,
		235,
		217,
		231,
		222,
		240,
		247,
		245,
		249,
		269,
		281,
		345,
		335,
		-1,
		317,
		322,
		281,
		289,
		308,
		346,
		310,
		-1,
		305,
		-1,
		276,
		289,
		-1,
		245,
		241,
		223,
		224,
		219,
		234,
		228,
		213,
		210,
		228,
		231,
		238,
		242,
		258,
		-1,
		-1,
		330,
		334,
		323,
		274,
		293,
		317,
		354,
		303,
		292,
		291,
		-1,
		282,
		259,
		256,
		244,
		231,
		216,
		217,
		225,
		238,
		217,
		212,
		209,
		229,
		255,
		233,
		245,
		-1,
		-1,
		-1,
		355,
		-1,
		-1,
		300,
		271,
		295,
		337,
		321,
		314,
		302,
		267,
		267,
		261,
		-1,
		255,
		234,
		225,
		214,
		212,
		225,
		222,
		227,
		207,
		205,
		224,
		236,
		227,
		244,
		-1,
		-1,
		-1,
		330,
		319,
		320,
		266,
		289,
		326,
		300,
		286,
		291,
		266,
		259,
		253,
		268,
		251,
		232,
		221,
		213,
		202,
		218,
		226,
		221,
		203,
		212,
		218,
		242,
		232,
		238,
		-1,
		-1,
		337,
		327,
		311,
		313,
		310,
		280,
		287,
		319,
		291,
		304,
		-1,
		258,
		-1,
		247,
		242,
		226,
		221,
		218,
		215,
		209,
		218,
		220,
		210,
		205,
		212,
		247,
		247,
		222,
		242,
		245,
		-1,
		-1,
		-1,
		330,
		325,
		300,
		277,
		261,
		297,
		-1,
		274,
		275,
		-1,
		252,
		246,
		243,
		228,
		224,
		219,
		223,
		216,
		223,
		216,
		214,
		215,
		197,
		229,
		-1,
		230,
		224,
		232,
		222,
		210,
		-1,
		-1,
		-1,
		323,
		302,
		295,
		315,
		256,
		308,
		-1,
		-1,
		259,
		252,
		-1,
		239,
		221,
		228,
		226,
		220,
		224,
		221,
		210,
		223,
		216,
		202,
		204,
		217,
		221,
		225,
		212,
		208,
		205,
		219,
		-1,
		342,
		-1,
		-1,
		-1,
		-1,
		-1,
		256,
		276,
		-1,
		268,
		260,
		250,
		244,
		238,
		234,
		232,
		248,
		232,
		235,
		233,
		224,
		232,
		205,
		198,
		205,
		194,
		212,
		220,
		212,
		206,
		205,
		215,
		-1,
		343,
		329,
		300,
		-1,
		-1,
		289,
		-1,
		253,
		267,
		283,
		-1,
		276,
		255,
		270,
		248,
		244,
		240,
		255,
		256,
		233,
		233,
		231,
		222,
		210,
		199,
		202,
		194,
		216,
		216,
		200,
		201,
		205,
		-1,
		349,
		336,
		294,
		290,
		279,
		299,
		250,
		238,
		270,
		-1,
		-1,
		312,
		-1,
		246,
		263,
		254,
		252,
		245,
		227,
		234,
		242,
		219,
		214,
		204,
		193,
		193,
		188,
		210,
		196,
		194,
		203,
		219,
		-1,
		-1,
		-1,
		316,
		-1,
		-1,
		265,
		252,
		246,
		-1,
		287,
		-1,
		290,
		280,
		264,
		249,
		282,
		-1,
		226,
		222,
		229,
		-1,
		239,
		-1,
		212,
		209,
		200,
		185,
		182,
		193,
		191,
		202,
		198,
		-1,
		299,
		284,
		277,
		267,
		281,
		252,
		-1,
		307,
		-1,
		-1,
		277,
		271,
		271,
		255,
		256,
		242,
		222,
		214,
		229,
		228,
		215,
		214,
		198,
		191,
		188,
		181,
		194,
		204,
		209,
		196,
		-1,
		-1,
		-1,
		304,
		290,
		294,
		254,
		273,
		-1,
		-1,
		339,
		294,
		280,
		-1,
		251,
		242,
		230,
		220,
		210,
		215,
		216,
		206,
		204,
		196,
		198,
		192,
		183,
		182,
		198,
		190,
		212,
		-1,
		-1,
		287,
		292,
		280,
		266,
		267,
		-1,
		-1,
		-1,
		286,
		302,
		270,
		249,
		231,
		-1,
		-1,
		214,
		207,
		201,
		204,
		192,
		212,
		207,
		191,
		176,
		191,
		195,
		203,
		194,
		-1,
		290,
		277,
		-1,
		-1,
		266,
		256,
		-1,
		-1,
		-1,
		-1,
		282,
		227,
		216,
		211,
		215,
		213,
		-1,
		187,
		198,
		191,
		210,
		217,
		193,
		178,
		172,
		178,
		190,
		199,
		-1,
		-1,
		280,
		-1,
		242,
		-1,
		-1,
		-1,
		-1,
		239,
		233,
		204,
		197,
		201,
		-1,
		189,
		191,
		188,
		200,
		196,
		193,
		184,
		175,
		171,
		175,
		179,
		193,
		197,
		303,
		-1,
		233,
		-1,
		-1,
		-1,
		257,
		272,
		243,
		220,
		193,
		188,
		181,
		175,
		180,
		191,
		200,
		211,
		176,
		178,
		168,
		167,
		171,
		188,
		192,
		-1,
		-1,
		231,
		227,
		262,
		265,
		269,
		270,
		-1,
		-1,
		197,
		188,
		179,
		171,
		184,
		187,
		172,
		174,
		174,
		172,
		166,
		176,
		191,
		186,
		-1,
		-1,
		-1,
		243,
		-1,
		245,
		-1,
		-1,
		264,
		268,
		215,
		197,
		193,
		191,
		180,
		174,
		162,
		167,
		177,
		171,
		168,
		162,
		166,
		189,
		178,
		217,
		-1,
		-1,
		267,
		-1,
		-1,
		-1,
		227,
		214,
		209,
		243,
		248,
		239,
		230,
		227,
		-1,
		197,
		203,
		168,
		175,
		158,
		165,
		170,
		167,
		156,
		163,
		179,
		178,
		173,
		209,
		200,
		206,
		-1,
		-1,
		260,
		249,
		238,
		244,
		-1,
		220,
		211,
		229,
		219,
		225,
		-1,
		-1,
		222,
		219,
		199,
		168,
		166,
		159,
		154,
		164,
		140,
		152,
		156,
		160,
		166,
		171,
		176,
		182,
		197,
		212,
		-1,
		214,
		251,
		244,
		212,
		220,
		251,
		-1,
		210,
		202,
		208,
		211,
		219,
		-1,
		-1,
		195,
		186,
		187,
		175,
		172,
		178,
		177,
		160,
		166,
		167,
		159,
		158,
		176,
		180,
		189,
		196,
		186,
		199,
		203,
		-1,
		207,
		227,
		206,
		209,
		233,
		247,
		-1,
		201,
		-1,
		-1,
		168,
		220,
		204,
		194,
		191,
		234,
		189,
		184,
		165,
		163,
		158,
		149,
		174,
		167,
		167,
		170,
		185,
		190,
		182,
		196,
		196,
		197,
		-1,
		196,
		207,
		200,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		-1,
		158,
		-1,
		231,
		-1,
		214,
		218,
		197,
		200,
		179,
		166,
		152,
		160,
		166,
		165,
		171,
		171,
		172,
		181,
		192,
		204,
		203,
		204,
		221,
		177,
		180,
		191,
		202,
		217,
		221,
		-1,
		185,
		221,
		164,
		-1,
		148,
		-1,
		-1,
		-1,
		228,
		210,
		202,
		199,
		178,
		178,
		144,
		148,
		161,
		168,
		178,
		189,
		181,
		185,
		198,
		209,
		212,
		217,
		208,
		221,
		166,
		166,
		187,
		196,
		217,
		181,
		178,
		215,
		171,
		160,
		155,
		142,
		-1,
		-1,
		212,
		220,
		-1,
		-1,
		185,
		152,
		140,
		150,
		154,
		168,
		180,
		193,
		181,
		186,
		180,
		212,
		-1,
		210,
		209,
		198,
		195,
		171,
		162,
		157,
		184,
		-1,
		-1,
		179,
		206,
		190,
		194,
		202,
		227,
		-1,
		126,
		-1,
		-1,
		192,
		-1,
		-1,
		177,
		157,
		146,
		137,
		142,
		162,
		173,
		195,
		177,
		194,
		185,
		195,
		199,
		194,
		191,
		179,
		177,
		200,
		165,
		153,
		-1,
		161,
		164,
		170,
		177,
		194,
		216,
		-1,
		-1,
		142,
		122,
		-1,
		-1,
		175,
		173,
		162,
		-1,
		152,
		134,
		139,
		169,
		171,
		173,
		180,
		174,
		181,
		189,
		200,
		192,
		203,
		217,
		206,
		202,
		201,
		209,
		158,
		151,
		158,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		147,
		-1,
		132,
		128,
		-1,
		-1,
		170,
		163,
		151,
		139,
		129,
		139,
		156,
		156,
		159,
		164,
		172,
		183,
		179,
		183,
		186,
		-1,
		237,
		-1,
		189,
		150,
		156,
		171,
		179,
		-1,
		-1,
		-1,
		149,
		135,
		128,
		116,
		114,
		-1,
		204,
		188,
		169,
		-1,
		139,
		152,
		192,
		160,
		165,
		160,
		175,
		186,
		177,
		185,
		179,
		182,
		-1,
		-1,
		149,
		132,
		-1,
		-1,
		106,
		108,
		-1,
		140,
		129,
		114,
		106,
		-1,
		-1,
		176,
		172,
		-1,
		-1,
		126,
		164,
		163,
		171,
		166,
		171,
		183,
		179,
		175,
		185,
		176,
		-1,
		-1,
		127,
		119,
		113,
		-1,
		91,
		-1,
		142,
		-1,
		109,
		118,
		106,
		-1,
		-1,
		-1,
		157,
		120,
		136,
		159,
		185,
		183,
		174,
		167,
		174,
		177,
		170,
		176,
		-1,
		-1,
		-1,
		109,
		83,
		149,
		140,
		123,
		103,
		95,
		117,
		-1,
		138,
		-1,
		113,
		116,
		141,
		180,
		182,
		168,
		164,
		177,
		171,
		168,
		166,
		115,
		-1,
		85,
		118,
		82,
		109,
		75,
		89,
		152,
		-1,
		135,
		117,
		-1,
		145,
		135,
		183,
		158,
		167,
		160,
		154,
		155,
		163,
		-1,
		-1,
		-1,
		87,
		86,
		78,
		72,
		72,
		70,
		87,
		-1,
		140,
		122,
		108,
		125,
		125,
		116,
		124,
		173,
		169,
		172,
		170,
		148,
		-1,
		121,
		-1,
		-1,
		110,
		-1,
		-1,
		-1,
		81,
		65,
		78,
		89,
		102,
		110,
		105,
		107,
		120,
		128,
		126,
		123,
		135,
		131,
		151,
		147,
		179,
		-1,
		116,
		-1,
		117,
		-1,
		-1,
		62,
		49,
		59,
		70,
		98,
		98,
		102,
		100,
		122,
		152,
		138,
		136,
		141,
		146,
		-1,
		105,
		104,
		-1,
		81,
		73,
		59,
		-1,
		40,
		-1,
		144,
		105,
		-1,
		119,
		109,
		-1,
		147,
		143,
		-1,
		-1,
		92,
		87,
		-1,
		-1,
		-1,
		35,
		48,
		139,
		123,
		-1,
		103,
		110,
		-1,
		-1,
		-1,
		77,
		78,
		-1,
		28,
		5,
		-1,
		49,
		55,
		83,
		98,
		104,
		-1,
		-1,
		-1,
		86,
		67,
		61,
		43,
		48,
		0,
		80,
		66,
		66,
		83,
		95,
		124,
		-1,
		-1,
		-1,
		58,
		50,
		50,
		-1,
		-1,
		91,
		74,
		74,
		92,
		-1,
		-1,
		-1,
		80,
		61,
		-1,
		-1,
		59,
		-1,
		-1,
		87,
		83,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		69,
		-1,
		-1,
		-1,
		60,
		67,
		88,
		-1,
		-1,
		-1,
		-1,
		90,
		91,
		115,
		90,
		-1,
		-1,
		-1,
		74,
		77,
		-1,
		-1,
		93,
		91,
		-1,
		-1,
		-1,
		102,
		86,
		-1,
		88,
		-1,
		-1,
		-1,
		93,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		107,
		-1,
		123,
		98,
		105,
		-1,
		-1,
		-1,
		-1,
		120,
		112,
		136,
		-1,
		108,
		110,
		-1,
		158,
		-1,
		-1,
		135,
		126,
		-1,
		-1,
		113,
		120,
		142,
		145,
		165,
		-1,
		132
	],
	[
		-1,
		316,
		305,
		316,
		324,
		297,
		304,
		-1,
		323,
		327,
		293,
		287,
		326,
		295,
		301,
		312,
		-1,
		-1,
		-1,
		316,
		315,
		283,
		281,
		290,
		295,
		302,
		-1,
		301,
		-1,
		337,
		316,
		327,
		332,
		276,
		273,
		293,
		312,
		294,
		286,
		352,
		306,
		277,
		271,
		289,
		279,
		288,
		280,
		-1,
		277,
		267,
		289,
		268,
		279,
		271,
		-1,
		-1,
		271,
		272,
		278,
		264,
		270,
		266,
		-1,
		276,
		260,
		-1,
		-1,
		261,
		262,
		246,
		249,
		257,
		255,
		268,
		260,
		255,
		-1,
		-1,
		252,
		248,
		255,
		242,
		238,
		255,
		268,
		250,
		264,
		263,
		-1,
		256,
		274,
		281,
		249,
		247,
		231,
		229,
		247,
		249,
		255,
		255,
		-1,
		265,
		266,
		261,
		269,
		271,
		247,
		234,
		234,
		244,
		237,
		256,
		244,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		299,
		265,
		248,
		265,
		257,
		247,
		262,
		255,
		237,
		234,
		232,
		229,
		245,
		243,
		253,
		-1,
		-1,
		358,
		327,
		356,
		314,
		295,
		-1,
		261,
		241,
		247,
		251,
		245,
		238,
		252,
		248,
		-1,
		223,
		222,
		250,
		236,
		247,
		318,
		-1,
		-1,
		316,
		308,
		291,
		294,
		271,
		267,
		256,
		255,
		247,
		233,
		229,
		235,
		238,
		238,
		244,
		217,
		227,
		231,
		229,
		254,
		-1,
		-1,
		289,
		-1,
		-1,
		315,
		298,
		-1,
		281,
		288,
		277,
		283,
		269,
		290,
		266,
		257,
		249,
		243,
		231,
		233,
		230,
		243,
		231,
		214,
		239,
		243,
		224,
		245,
		240,
		-1,
		288,
		272,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		293,
		274,
		277,
		283,
		307,
		306,
		-1,
		278,
		266,
		267,
		252,
		249,
		236,
		224,
		237,
		222,
		229,
		228,
		218,
		216,
		246,
		221,
		243,
		240,
		259,
		264,
		258,
		267,
		-1,
		323,
		319,
		315,
		322,
		271,
		-1,
		-1,
		311,
		-1,
		314,
		315,
		290,
		263,
		266,
		253,
		244,
		231,
		220,
		231,
		220,
		217,
		225,
		210,
		225,
		216,
		215,
		233,
		243,
		251,
		255,
		261,
		-1,
		373,
		-1,
		315,
		299,
		301,
		273,
		294,
		-1,
		331,
		315,
		307,
		292,
		292,
		-1,
		262,
		259,
		249,
		227,
		212,
		229,
		221,
		219,
		223,
		205,
		219,
		210,
		228,
		235,
		233,
		237,
		257,
		269,
		333,
		323,
		-1,
		305,
		310,
		269,
		277,
		296,
		334,
		298,
		-1,
		293,
		-1,
		264,
		277,
		-1,
		233,
		229,
		211,
		212,
		207,
		222,
		216,
		201,
		198,
		216,
		219,
		226,
		230,
		246,
		-1,
		-1,
		318,
		322,
		311,
		262,
		281,
		305,
		342,
		291,
		280,
		279,
		-1,
		270,
		247,
		244,
		232,
		219,
		204,
		205,
		213,
		226,
		205,
		200,
		197,
		217,
		243,
		221,
		233,
		-1,
		-1,
		-1,
		343,
		-1,
		-1,
		288,
		259,
		283,
		325,
		309,
		302,
		290,
		255,
		255,
		249,
		-1,
		243,
		222,
		213,
		202,
		200,
		213,
		210,
		215,
		195,
		193,
		212,
		224,
		215,
		232,
		-1,
		-1,
		-1,
		318,
		307,
		308,
		254,
		277,
		314,
		288,
		274,
		279,
		254,
		247,
		241,
		256,
		239,
		220,
		209,
		201,
		190,
		206,
		214,
		209,
		191,
		200,
		206,
		230,
		220,
		226,
		-1,
		-1,
		325,
		315,
		299,
		301,
		298,
		268,
		275,
		307,
		279,
		292,
		-1,
		246,
		-1,
		235,
		230,
		214,
		209,
		206,
		203,
		197,
		206,
		208,
		198,
		193,
		200,
		235,
		235,
		210,
		230,
		233,
		-1,
		-1,
		-1,
		318,
		313,
		288,
		265,
		249,
		285,
		-1,
		262,
		263,
		-1,
		240,
		234,
		231,
		216,
		212,
		207,
		211,
		204,
		211,
		204,
		202,
		203,
		185,
		217,
		-1,
		218,
		212,
		220,
		210,
		198,
		-1,
		-1,
		-1,
		311,
		290,
		283,
		303,
		244,
		296,
		-1,
		-1,
		247,
		240,
		-1,
		227,
		209,
		216,
		214,
		208,
		212,
		209,
		198,
		211,
		204,
		190,
		192,
		205,
		209,
		213,
		200,
		196,
		193,
		207,
		-1,
		330,
		-1,
		-1,
		-1,
		-1,
		-1,
		244,
		264,
		-1,
		256,
		248,
		238,
		232,
		226,
		222,
		220,
		236,
		220,
		223,
		221,
		212,
		220,
		193,
		186,
		193,
		182,
		200,
		208,
		200,
		194,
		193,
		203,
		-1,
		331,
		317,
		288,
		-1,
		-1,
		277,
		-1,
		241,
		255,
		271,
		-1,
		264,
		243,
		258,
		236,
		232,
		228,
		243,
		244,
		221,
		221,
		219,
		210,
		198,
		187,
		190,
		182,
		204,
		204,
		188,
		189,
		193,
		-1,
		337,
		324,
		282,
		278,
		267,
		287,
		238,
		226,
		258,
		-1,
		-1,
		300,
		-1,
		234,
		251,
		242,
		240,
		233,
		215,
		222,
		230,
		207,
		202,
		192,
		181,
		181,
		176,
		198,
		184,
		182,
		191,
		207,
		-1,
		-1,
		-1,
		304,
		-1,
		-1,
		253,
		240,
		234,
		-1,
		275,
		-1,
		278,
		268,
		252,
		237,
		270,
		-1,
		214,
		210,
		217,
		-1,
		227,
		-1,
		200,
		197,
		188,
		173,
		170,
		181,
		179,
		190,
		186,
		-1,
		287,
		272,
		265,
		255,
		269,
		240,
		-1,
		295,
		-1,
		-1,
		265,
		259,
		259,
		243,
		244,
		230,
		210,
		202,
		217,
		216,
		203,
		202,
		186,
		179,
		176,
		169,
		182,
		192,
		197,
		184,
		-1,
		-1,
		-1,
		292,
		278,
		282,
		242,
		261,
		-1,
		-1,
		327,
		282,
		268,
		-1,
		239,
		230,
		218,
		208,
		198,
		203,
		204,
		194,
		192,
		184,
		186,
		180,
		171,
		170,
		186,
		178,
		200,
		-1,
		-1,
		275,
		280,
		268,
		254,
		273,
		-1,
		-1,
		-1,
		274,
		290,
		258,
		237,
		219,
		-1,
		-1,
		202,
		195,
		189,
		192,
		180,
		200,
		195,
		179,
		164,
		179,
		183,
		191,
		182,
		-1,
		278,
		265,
		-1,
		-1,
		276,
		270,
		-1,
		-1,
		-1,
		-1,
		270,
		215,
		204,
		199,
		203,
		201,
		-1,
		175,
		186,
		179,
		198,
		205,
		181,
		166,
		160,
		166,
		178,
		187,
		-1,
		-1,
		290,
		-1,
		257,
		-1,
		-1,
		-1,
		-1,
		227,
		221,
		192,
		185,
		189,
		-1,
		177,
		179,
		176,
		188,
		184,
		181,
		172,
		163,
		159,
		163,
		167,
		181,
		185,
		313,
		-1,
		248,
		-1,
		-1,
		-1,
		245,
		260,
		231,
		208,
		181,
		176,
		169,
		163,
		168,
		179,
		188,
		199,
		164,
		166,
		156,
		155,
		159,
		176,
		180,
		-1,
		-1,
		246,
		242,
		271,
		253,
		257,
		258,
		-1,
		-1,
		185,
		176,
		167,
		159,
		172,
		175,
		160,
		162,
		162,
		160,
		154,
		164,
		179,
		174,
		-1,
		-1,
		-1,
		258,
		-1,
		260,
		-1,
		-1,
		255,
		256,
		203,
		185,
		181,
		179,
		168,
		162,
		150,
		155,
		165,
		159,
		156,
		150,
		154,
		177,
		166,
		205,
		-1,
		-1,
		282,
		-1,
		-1,
		-1,
		242,
		229,
		224,
		237,
		239,
		230,
		218,
		215,
		-1,
		185,
		191,
		156,
		163,
		146,
		153,
		158,
		155,
		144,
		151,
		167,
		166,
		161,
		197,
		188,
		194,
		-1,
		-1,
		275,
		264,
		253,
		259,
		-1,
		235,
		226,
		223,
		213,
		216,
		-1,
		-1,
		210,
		207,
		187,
		156,
		154,
		147,
		142,
		152,
		128,
		140,
		144,
		148,
		154,
		159,
		164,
		170,
		185,
		200,
		-1,
		229,
		266,
		259,
		227,
		235,
		266,
		-1,
		225,
		217,
		223,
		205,
		207,
		-1,
		-1,
		183,
		174,
		175,
		163,
		160,
		166,
		165,
		148,
		154,
		155,
		147,
		146,
		164,
		168,
		177,
		184,
		174,
		187,
		191,
		-1,
		222,
		242,
		221,
		224,
		248,
		262,
		-1,
		216,
		-1,
		-1,
		183,
		208,
		192,
		182,
		179,
		222,
		177,
		172,
		153,
		151,
		146,
		137,
		162,
		155,
		155,
		158,
		173,
		178,
		170,
		184,
		184,
		185,
		-1,
		211,
		222,
		215,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		-1,
		173,
		-1,
		219,
		-1,
		202,
		206,
		185,
		188,
		167,
		154,
		140,
		148,
		154,
		153,
		159,
		159,
		160,
		169,
		180,
		192,
		191,
		192,
		236,
		192,
		195,
		206,
		217,
		232,
		236,
		-1,
		200,
		236,
		179,
		-1,
		163,
		-1,
		-1,
		-1,
		216,
		198,
		190,
		187,
		166,
		166,
		132,
		136,
		149,
		156,
		166,
		177,
		169,
		173,
		186,
		197,
		200,
		232,
		223,
		236,
		181,
		181,
		202,
		211,
		232,
		196,
		193,
		230,
		186,
		175,
		170,
		157,
		-1,
		-1,
		200,
		208,
		-1,
		-1,
		173,
		140,
		128,
		138,
		142,
		156,
		168,
		181,
		169,
		174,
		168,
		200,
		-1,
		225,
		224,
		213,
		210,
		186,
		177,
		172,
		199,
		-1,
		-1,
		194,
		221,
		205,
		209,
		217,
		242,
		-1,
		141,
		-1,
		-1,
		180,
		-1,
		-1,
		165,
		145,
		134,
		125,
		130,
		150,
		161,
		183,
		165,
		182,
		173,
		183,
		187,
		209,
		206,
		194,
		192,
		215,
		180,
		168,
		-1,
		176,
		179,
		185,
		192,
		209,
		231,
		-1,
		-1,
		157,
		137,
		-1,
		-1,
		163,
		161,
		150,
		-1,
		140,
		122,
		127,
		157,
		159,
		161,
		168,
		162,
		169,
		177,
		188,
		180,
		218,
		232,
		221,
		217,
		216,
		224,
		173,
		166,
		173,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		162,
		-1,
		147,
		143,
		-1,
		-1,
		158,
		151,
		139,
		127,
		117,
		127,
		144,
		144,
		147,
		152,
		160,
		171,
		167,
		171,
		174,
		-1,
		252,
		-1,
		204,
		165,
		171,
		186,
		194,
		-1,
		-1,
		-1,
		164,
		150,
		143,
		131,
		129,
		-1,
		192,
		176,
		157,
		-1,
		127,
		140,
		180,
		148,
		153,
		148,
		163,
		174,
		165,
		173,
		167,
		170,
		-1,
		-1,
		164,
		147,
		-1,
		-1,
		121,
		123,
		-1,
		155,
		144,
		129,
		121,
		-1,
		-1,
		164,
		160,
		-1,
		-1,
		114,
		152,
		151,
		159,
		154,
		159,
		171,
		167,
		163,
		173,
		164,
		-1,
		-1,
		142,
		134,
		128,
		-1,
		106,
		-1,
		157,
		-1,
		124,
		133,
		121,
		-1,
		-1,
		-1,
		145,
		108,
		124,
		147,
		173,
		171,
		162,
		155,
		162,
		165,
		158,
		164,
		-1,
		-1,
		-1,
		124,
		98,
		164,
		155,
		138,
		118,
		110,
		132,
		-1,
		126,
		-1,
		101,
		104,
		129,
		168,
		170,
		156,
		152,
		165,
		159,
		156,
		154,
		130,
		-1,
		100,
		133,
		97,
		124,
		90,
		104,
		140,
		-1,
		123,
		105,
		-1,
		133,
		123,
		171,
		146,
		155,
		148,
		142,
		143,
		151,
		-1,
		-1,
		-1,
		102,
		101,
		93,
		87,
		87,
		85,
		102,
		-1,
		128,
		110,
		96,
		113,
		113,
		104,
		112,
		161,
		157,
		160,
		158,
		136,
		-1,
		159,
		-1,
		-1,
		125,
		-1,
		-1,
		-1,
		96,
		80,
		93,
		96,
		97,
		93,
		93,
		95,
		108,
		116,
		114,
		111,
		123,
		119,
		139,
		135,
		167,
		-1,
		154,
		-1,
		132,
		-1,
		-1,
		77,
		64,
		74,
		85,
		108,
		106,
		92,
		88,
		105,
		140,
		126,
		124,
		129,
		134,
		-1,
		143,
		142,
		-1,
		96,
		88,
		74,
		-1,
		55,
		-1,
		154,
		115,
		-1,
		89,
		83,
		-1,
		135,
		131,
		-1,
		-1,
		130,
		112,
		-1,
		-1,
		-1,
		75,
		37,
		149,
		133,
		-1,
		73,
		80,
		-1,
		-1,
		-1,
		115,
		116,
		-1,
		68,
		71,
		-1,
		33,
		24,
		49,
		67,
		74,
		-1,
		-1,
		-1,
		124,
		105,
		99,
		83,
		88,
		76,
		0,
		11,
		35,
		52,
		65,
		94,
		-1,
		-1,
		-1,
		96,
		88,
		88,
		-1,
		-1,
		59,
		42,
		43,
		61,
		-1,
		-1,
		-1,
		118,
		99,
		-1,
		-1,
		92,
		-1,
		-1,
		56,
		63,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		107,
		-1,
		-1,
		-1,
		88,
		84,
		67,
		-1,
		-1,
		-1,
		-1,
		128,
		129,
		153,
		128,
		-1,
		-1,
		-1,
		80,
		74,
		-1,
		-1,
		131,
		129,
		-1,
		-1,
		-1,
		108,
		92,
		-1,
		78,
		-1,
		-1,
		-1,
		99,
		-1,
		-1,
		111,
		-1,
		-1,
		-1,
		113,
		-1,
		113,
		88,
		95,
		-1,
		-1,
		-1,
		-1,
		126,
		118,
		126,
		-1,
		98,
		100,
		-1,
		148,
		-1,
		-1,
		141,
		132,
		-1,
		-1,
		103,
		110,
		132,
		135,
		171,
		-1,
		122
	],
	[
		-1,
		305,
		294,
		305,
		313,
		286,
		293,
		-1,
		312,
		316,
		282,
		276,
		315,
		284,
		290,
		301,
		-1,
		-1,
		-1,
		305,
		304,
		272,
		270,
		279,
		284,
		291,
		-1,
		290,
		-1,
		326,
		305,
		316,
		321,
		265,
		262,
		282,
		301,
		283,
		275,
		341,
		295,
		266,
		260,
		278,
		268,
		277,
		269,
		-1,
		266,
		256,
		278,
		257,
		268,
		260,
		-1,
		-1,
		260,
		261,
		267,
		253,
		259,
		255,
		-1,
		265,
		249,
		-1,
		-1,
		250,
		251,
		235,
		238,
		246,
		244,
		257,
		249,
		244,
		-1,
		-1,
		241,
		237,
		244,
		231,
		227,
		244,
		257,
		239,
		253,
		252,
		-1,
		245,
		263,
		270,
		238,
		236,
		220,
		218,
		236,
		238,
		244,
		244,
		-1,
		254,
		255,
		250,
		258,
		260,
		236,
		223,
		223,
		233,
		226,
		245,
		233,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		288,
		254,
		237,
		254,
		246,
		236,
		251,
		244,
		226,
		223,
		221,
		218,
		234,
		232,
		242,
		-1,
		-1,
		347,
		316,
		345,
		303,
		284,
		-1,
		250,
		230,
		236,
		240,
		234,
		227,
		241,
		237,
		-1,
		212,
		211,
		239,
		225,
		236,
		307,
		-1,
		-1,
		305,
		297,
		280,
		283,
		260,
		256,
		245,
		244,
		236,
		222,
		218,
		224,
		227,
		227,
		233,
		206,
		216,
		220,
		218,
		243,
		-1,
		-1,
		278,
		-1,
		-1,
		304,
		287,
		-1,
		270,
		277,
		266,
		272,
		258,
		279,
		255,
		246,
		238,
		232,
		220,
		222,
		219,
		232,
		220,
		203,
		228,
		232,
		213,
		234,
		229,
		-1,
		277,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		263,
		266,
		272,
		296,
		295,
		-1,
		267,
		255,
		256,
		241,
		238,
		225,
		213,
		226,
		211,
		218,
		217,
		207,
		205,
		235,
		210,
		232,
		229,
		248,
		253,
		247,
		256,
		-1,
		312,
		308,
		304,
		311,
		260,
		-1,
		-1,
		300,
		-1,
		303,
		304,
		279,
		252,
		255,
		242,
		233,
		220,
		209,
		220,
		209,
		206,
		214,
		199,
		214,
		205,
		204,
		222,
		232,
		240,
		244,
		250,
		-1,
		362,
		-1,
		304,
		288,
		290,
		262,
		283,
		-1,
		320,
		304,
		296,
		281,
		281,
		-1,
		251,
		248,
		238,
		216,
		201,
		218,
		210,
		208,
		212,
		194,
		208,
		199,
		217,
		224,
		222,
		226,
		246,
		258,
		322,
		312,
		-1,
		294,
		299,
		258,
		266,
		285,
		323,
		287,
		-1,
		282,
		-1,
		253,
		266,
		-1,
		222,
		218,
		200,
		201,
		196,
		211,
		205,
		190,
		187,
		205,
		208,
		215,
		219,
		235,
		-1,
		-1,
		307,
		311,
		300,
		251,
		270,
		294,
		331,
		280,
		269,
		268,
		-1,
		259,
		236,
		233,
		221,
		208,
		193,
		194,
		202,
		215,
		194,
		189,
		186,
		206,
		232,
		210,
		222,
		-1,
		-1,
		-1,
		332,
		-1,
		-1,
		277,
		248,
		272,
		314,
		298,
		291,
		279,
		244,
		244,
		238,
		-1,
		232,
		211,
		202,
		191,
		189,
		202,
		199,
		204,
		184,
		182,
		201,
		213,
		204,
		221,
		-1,
		-1,
		-1,
		307,
		296,
		297,
		243,
		266,
		303,
		277,
		263,
		268,
		243,
		236,
		230,
		245,
		228,
		209,
		198,
		190,
		179,
		195,
		203,
		198,
		180,
		189,
		195,
		219,
		209,
		215,
		-1,
		-1,
		314,
		304,
		288,
		290,
		287,
		257,
		264,
		296,
		268,
		281,
		-1,
		235,
		-1,
		224,
		219,
		203,
		198,
		195,
		192,
		186,
		195,
		197,
		187,
		182,
		189,
		224,
		224,
		199,
		219,
		222,
		-1,
		-1,
		-1,
		307,
		302,
		277,
		254,
		238,
		274,
		-1,
		251,
		252,
		-1,
		229,
		223,
		220,
		205,
		201,
		196,
		200,
		193,
		200,
		193,
		191,
		192,
		174,
		206,
		-1,
		207,
		201,
		209,
		199,
		187,
		-1,
		-1,
		-1,
		300,
		279,
		272,
		292,
		233,
		285,
		-1,
		-1,
		236,
		229,
		-1,
		216,
		198,
		205,
		203,
		197,
		201,
		198,
		187,
		200,
		193,
		179,
		181,
		194,
		198,
		202,
		189,
		185,
		182,
		196,
		-1,
		319,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		253,
		-1,
		245,
		237,
		227,
		221,
		215,
		211,
		209,
		225,
		209,
		212,
		210,
		201,
		209,
		182,
		175,
		182,
		171,
		189,
		197,
		189,
		183,
		182,
		192,
		-1,
		320,
		306,
		277,
		-1,
		-1,
		266,
		-1,
		230,
		244,
		260,
		-1,
		253,
		232,
		247,
		225,
		221,
		217,
		232,
		233,
		210,
		210,
		208,
		199,
		187,
		176,
		179,
		171,
		193,
		193,
		177,
		178,
		182,
		-1,
		326,
		313,
		271,
		267,
		256,
		276,
		227,
		215,
		247,
		-1,
		-1,
		289,
		-1,
		223,
		240,
		231,
		229,
		222,
		204,
		211,
		219,
		196,
		191,
		181,
		170,
		170,
		165,
		187,
		173,
		171,
		180,
		196,
		-1,
		-1,
		-1,
		293,
		-1,
		-1,
		242,
		229,
		223,
		-1,
		264,
		-1,
		267,
		257,
		241,
		226,
		259,
		-1,
		203,
		199,
		206,
		-1,
		216,
		-1,
		189,
		186,
		177,
		162,
		159,
		170,
		168,
		179,
		175,
		-1,
		276,
		261,
		254,
		244,
		258,
		229,
		-1,
		284,
		-1,
		-1,
		254,
		248,
		248,
		232,
		233,
		219,
		199,
		191,
		206,
		205,
		192,
		191,
		175,
		168,
		165,
		158,
		171,
		181,
		186,
		173,
		-1,
		-1,
		-1,
		281,
		267,
		271,
		231,
		250,
		-1,
		-1,
		316,
		271,
		257,
		-1,
		228,
		219,
		207,
		197,
		187,
		192,
		193,
		183,
		181,
		173,
		175,
		169,
		160,
		159,
		175,
		167,
		189,
		-1,
		-1,
		264,
		269,
		257,
		243,
		262,
		-1,
		-1,
		-1,
		263,
		279,
		247,
		226,
		208,
		-1,
		-1,
		191,
		184,
		178,
		181,
		169,
		189,
		184,
		168,
		153,
		168,
		172,
		180,
		171,
		-1,
		267,
		254,
		-1,
		-1,
		265,
		259,
		-1,
		-1,
		-1,
		-1,
		259,
		204,
		193,
		188,
		192,
		190,
		-1,
		164,
		175,
		168,
		187,
		194,
		170,
		155,
		149,
		155,
		167,
		176,
		-1,
		-1,
		279,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		216,
		210,
		181,
		174,
		178,
		-1,
		166,
		168,
		165,
		177,
		173,
		170,
		161,
		152,
		148,
		152,
		156,
		170,
		174,
		302,
		-1,
		237,
		-1,
		-1,
		-1,
		234,
		249,
		220,
		197,
		170,
		165,
		158,
		152,
		157,
		168,
		177,
		188,
		153,
		155,
		145,
		144,
		148,
		165,
		169,
		-1,
		-1,
		235,
		231,
		260,
		242,
		246,
		247,
		-1,
		-1,
		174,
		165,
		156,
		148,
		161,
		164,
		149,
		151,
		151,
		149,
		143,
		153,
		168,
		163,
		-1,
		-1,
		-1,
		247,
		-1,
		249,
		-1,
		-1,
		244,
		245,
		192,
		174,
		170,
		168,
		157,
		151,
		139,
		144,
		154,
		148,
		145,
		139,
		143,
		166,
		155,
		194,
		-1,
		-1,
		271,
		-1,
		-1,
		-1,
		231,
		218,
		213,
		226,
		228,
		219,
		207,
		204,
		-1,
		174,
		180,
		145,
		152,
		135,
		142,
		147,
		144,
		133,
		140,
		156,
		155,
		150,
		186,
		177,
		183,
		-1,
		-1,
		264,
		253,
		242,
		248,
		-1,
		224,
		215,
		212,
		202,
		205,
		-1,
		-1,
		199,
		196,
		176,
		145,
		143,
		136,
		131,
		141,
		117,
		129,
		133,
		137,
		143,
		148,
		153,
		159,
		174,
		189,
		-1,
		218,
		255,
		248,
		216,
		224,
		255,
		-1,
		214,
		206,
		212,
		194,
		196,
		-1,
		-1,
		172,
		163,
		164,
		152,
		149,
		155,
		154,
		137,
		143,
		144,
		136,
		135,
		153,
		157,
		166,
		173,
		163,
		176,
		180,
		-1,
		211,
		231,
		210,
		213,
		237,
		251,
		-1,
		205,
		-1,
		-1,
		172,
		197,
		181,
		171,
		168,
		211,
		166,
		161,
		142,
		140,
		135,
		126,
		151,
		144,
		144,
		147,
		162,
		167,
		159,
		173,
		173,
		174,
		-1,
		200,
		211,
		204,
		-1,
		-1,
		-1,
		-1,
		199,
		-1,
		-1,
		162,
		-1,
		208,
		-1,
		191,
		195,
		174,
		177,
		156,
		143,
		129,
		137,
		143,
		142,
		148,
		148,
		149,
		158,
		169,
		181,
		180,
		181,
		225,
		181,
		184,
		195,
		206,
		221,
		225,
		-1,
		189,
		225,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		205,
		187,
		179,
		176,
		155,
		155,
		121,
		125,
		138,
		145,
		155,
		166,
		158,
		162,
		175,
		186,
		189,
		221,
		212,
		225,
		170,
		170,
		191,
		200,
		221,
		185,
		182,
		219,
		175,
		164,
		159,
		146,
		-1,
		-1,
		189,
		197,
		-1,
		-1,
		162,
		129,
		117,
		127,
		131,
		145,
		157,
		170,
		158,
		163,
		157,
		189,
		-1,
		214,
		213,
		202,
		199,
		175,
		166,
		161,
		188,
		-1,
		-1,
		183,
		210,
		194,
		198,
		206,
		231,
		-1,
		130,
		-1,
		-1,
		169,
		-1,
		-1,
		154,
		134,
		123,
		114,
		119,
		139,
		150,
		172,
		154,
		171,
		162,
		172,
		176,
		198,
		195,
		183,
		181,
		204,
		169,
		157,
		-1,
		165,
		168,
		174,
		181,
		198,
		220,
		-1,
		-1,
		146,
		126,
		-1,
		-1,
		152,
		150,
		139,
		-1,
		129,
		111,
		116,
		146,
		148,
		150,
		157,
		151,
		158,
		166,
		177,
		169,
		207,
		221,
		210,
		206,
		205,
		213,
		162,
		155,
		162,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		151,
		-1,
		136,
		132,
		-1,
		-1,
		147,
		140,
		128,
		116,
		106,
		116,
		133,
		133,
		136,
		141,
		149,
		160,
		156,
		160,
		163,
		-1,
		241,
		-1,
		193,
		154,
		160,
		175,
		183,
		-1,
		-1,
		-1,
		153,
		139,
		132,
		120,
		118,
		-1,
		181,
		165,
		146,
		-1,
		116,
		129,
		169,
		137,
		142,
		137,
		152,
		163,
		154,
		162,
		156,
		159,
		-1,
		-1,
		153,
		136,
		-1,
		-1,
		110,
		112,
		-1,
		144,
		133,
		118,
		110,
		-1,
		-1,
		153,
		149,
		-1,
		-1,
		103,
		141,
		140,
		148,
		143,
		148,
		160,
		156,
		152,
		162,
		153,
		-1,
		-1,
		131,
		123,
		117,
		-1,
		95,
		-1,
		146,
		-1,
		113,
		122,
		110,
		-1,
		-1,
		-1,
		134,
		97,
		113,
		136,
		162,
		160,
		151,
		144,
		151,
		154,
		147,
		153,
		-1,
		-1,
		-1,
		113,
		87,
		153,
		144,
		127,
		107,
		99,
		121,
		-1,
		115,
		-1,
		90,
		93,
		118,
		157,
		159,
		145,
		141,
		154,
		148,
		145,
		143,
		119,
		-1,
		89,
		122,
		86,
		113,
		79,
		93,
		129,
		-1,
		112,
		94,
		-1,
		122,
		112,
		160,
		135,
		144,
		137,
		131,
		132,
		140,
		-1,
		-1,
		-1,
		91,
		90,
		82,
		76,
		76,
		74,
		91,
		-1,
		117,
		99,
		85,
		102,
		102,
		93,
		101,
		150,
		146,
		149,
		147,
		125,
		-1,
		148,
		-1,
		-1,
		114,
		-1,
		-1,
		-1,
		85,
		69,
		82,
		85,
		86,
		82,
		82,
		84,
		97,
		105,
		103,
		100,
		112,
		108,
		128,
		124,
		156,
		-1,
		143,
		-1,
		121,
		-1,
		-1,
		66,
		53,
		63,
		74,
		97,
		95,
		81,
		77,
		94,
		129,
		115,
		113,
		118,
		123,
		-1,
		132,
		131,
		-1,
		85,
		77,
		63,
		-1,
		44,
		-1,
		143,
		104,
		-1,
		78,
		72,
		-1,
		124,
		120,
		-1,
		-1,
		119,
		101,
		-1,
		-1,
		-1,
		64,
		26,
		138,
		122,
		-1,
		62,
		69,
		-1,
		-1,
		-1,
		104,
		105,
		-1,
		57,
		60,
		-1,
		22,
		13,
		38,
		56,
		63,
		-1,
		-1,
		-1,
		113,
		94,
		88,
		72,
		77,
		65,
		14,
		0,
		24,
		41,
		54,
		83,
		-1,
		-1,
		-1,
		85,
		77,
		77,
		-1,
		-1,
		48,
		31,
		32,
		50,
		-1,
		-1,
		-1,
		107,
		88,
		-1,
		-1,
		81,
		-1,
		-1,
		45,
		52,
		-1,
		-1,
		-1,
		-1,
		-1,
		123,
		96,
		-1,
		-1,
		-1,
		77,
		73,
		56,
		-1,
		-1,
		-1,
		-1,
		117,
		118,
		142,
		117,
		-1,
		-1,
		-1,
		69,
		63,
		-1,
		-1,
		120,
		118,
		-1,
		-1,
		-1,
		97,
		81,
		-1,
		67,
		-1,
		-1,
		-1,
		88,
		-1,
		-1,
		100,
		-1,
		-1,
		-1,
		102,
		-1,
		102,
		77,
		84,
		-1,
		-1,
		-1,
		-1,
		115,
		107,
		115,
		-1,
		87,
		89,
		-1,
		137,
		-1,
		-1,
		130,
		121,
		-1,
		-1,
		92,
		99,
		121,
		124,
		160,
		-1,
		111
	],
	[
		-1,
		287,
		276,
		287,
		295,
		268,
		275,
		-1,
		294,
		298,
		264,
		258,
		297,
		266,
		272,
		283,
		-1,
		-1,
		-1,
		287,
		286,
		254,
		252,
		261,
		266,
		273,
		-1,
		272,
		-1,
		308,
		287,
		298,
		303,
		247,
		244,
		264,
		283,
		265,
		257,
		323,
		277,
		248,
		242,
		260,
		250,
		259,
		251,
		-1,
		248,
		238,
		260,
		239,
		250,
		242,
		-1,
		-1,
		242,
		243,
		249,
		235,
		241,
		237,
		-1,
		247,
		231,
		-1,
		-1,
		232,
		233,
		217,
		220,
		228,
		226,
		239,
		231,
		226,
		-1,
		-1,
		223,
		219,
		226,
		213,
		209,
		226,
		239,
		221,
		235,
		234,
		-1,
		227,
		245,
		252,
		220,
		218,
		202,
		200,
		218,
		220,
		226,
		226,
		-1,
		236,
		237,
		232,
		240,
		242,
		218,
		205,
		205,
		215,
		208,
		227,
		215,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		236,
		219,
		236,
		228,
		218,
		233,
		226,
		208,
		205,
		203,
		200,
		216,
		214,
		224,
		-1,
		-1,
		329,
		298,
		327,
		285,
		266,
		-1,
		232,
		212,
		218,
		222,
		216,
		209,
		223,
		219,
		-1,
		194,
		193,
		221,
		207,
		218,
		289,
		-1,
		-1,
		287,
		279,
		262,
		265,
		242,
		238,
		227,
		226,
		218,
		204,
		200,
		206,
		209,
		209,
		215,
		188,
		198,
		202,
		200,
		225,
		-1,
		-1,
		260,
		-1,
		-1,
		286,
		269,
		-1,
		252,
		259,
		248,
		254,
		240,
		261,
		237,
		228,
		220,
		214,
		202,
		204,
		201,
		214,
		202,
		185,
		210,
		214,
		195,
		216,
		211,
		-1,
		259,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		245,
		248,
		254,
		278,
		277,
		-1,
		249,
		237,
		238,
		223,
		220,
		207,
		195,
		208,
		193,
		200,
		199,
		189,
		187,
		217,
		192,
		214,
		211,
		230,
		235,
		229,
		238,
		-1,
		294,
		290,
		286,
		293,
		242,
		-1,
		-1,
		282,
		-1,
		285,
		286,
		261,
		234,
		237,
		224,
		215,
		202,
		191,
		202,
		191,
		188,
		196,
		181,
		196,
		187,
		186,
		204,
		214,
		222,
		226,
		232,
		-1,
		344,
		-1,
		286,
		270,
		272,
		244,
		265,
		-1,
		302,
		286,
		278,
		263,
		263,
		-1,
		233,
		230,
		220,
		198,
		183,
		200,
		192,
		190,
		194,
		176,
		190,
		181,
		199,
		206,
		204,
		208,
		228,
		240,
		304,
		294,
		-1,
		276,
		281,
		240,
		248,
		267,
		305,
		269,
		-1,
		264,
		-1,
		235,
		248,
		-1,
		204,
		200,
		182,
		183,
		178,
		193,
		187,
		172,
		169,
		187,
		190,
		197,
		201,
		217,
		-1,
		-1,
		289,
		293,
		282,
		233,
		252,
		276,
		313,
		262,
		251,
		250,
		-1,
		241,
		218,
		215,
		203,
		190,
		175,
		176,
		184,
		197,
		176,
		171,
		168,
		188,
		214,
		192,
		204,
		-1,
		-1,
		-1,
		314,
		-1,
		-1,
		259,
		230,
		254,
		296,
		280,
		273,
		261,
		226,
		226,
		220,
		-1,
		214,
		193,
		184,
		173,
		171,
		184,
		181,
		186,
		166,
		164,
		183,
		195,
		186,
		203,
		-1,
		-1,
		-1,
		289,
		278,
		279,
		225,
		248,
		285,
		259,
		245,
		250,
		225,
		218,
		212,
		227,
		210,
		191,
		180,
		172,
		161,
		177,
		185,
		180,
		162,
		171,
		177,
		201,
		191,
		197,
		-1,
		-1,
		296,
		286,
		270,
		272,
		269,
		239,
		246,
		278,
		250,
		263,
		-1,
		217,
		-1,
		206,
		201,
		185,
		180,
		177,
		174,
		168,
		177,
		179,
		169,
		164,
		171,
		206,
		206,
		181,
		201,
		204,
		-1,
		-1,
		-1,
		289,
		284,
		259,
		236,
		220,
		256,
		-1,
		233,
		234,
		-1,
		211,
		205,
		202,
		187,
		183,
		178,
		182,
		175,
		182,
		175,
		173,
		174,
		156,
		188,
		-1,
		189,
		183,
		191,
		181,
		169,
		-1,
		-1,
		-1,
		282,
		261,
		254,
		274,
		215,
		267,
		-1,
		-1,
		218,
		211,
		-1,
		198,
		180,
		187,
		185,
		179,
		183,
		180,
		169,
		182,
		175,
		161,
		163,
		176,
		180,
		184,
		171,
		167,
		164,
		178,
		-1,
		301,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		235,
		-1,
		227,
		219,
		209,
		203,
		197,
		193,
		191,
		207,
		191,
		194,
		192,
		183,
		191,
		164,
		157,
		164,
		153,
		171,
		179,
		171,
		165,
		164,
		174,
		-1,
		302,
		288,
		259,
		-1,
		-1,
		248,
		-1,
		212,
		226,
		242,
		-1,
		235,
		214,
		229,
		207,
		203,
		199,
		214,
		215,
		192,
		192,
		190,
		181,
		169,
		158,
		161,
		153,
		175,
		175,
		159,
		160,
		164,
		-1,
		308,
		295,
		253,
		249,
		238,
		258,
		209,
		197,
		229,
		-1,
		-1,
		271,
		-1,
		205,
		222,
		213,
		211,
		204,
		186,
		193,
		201,
		178,
		173,
		163,
		152,
		152,
		147,
		169,
		155,
		153,
		162,
		178,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		224,
		211,
		205,
		-1,
		246,
		-1,
		249,
		239,
		223,
		208,
		241,
		-1,
		185,
		181,
		188,
		-1,
		198,
		-1,
		171,
		168,
		159,
		144,
		141,
		152,
		150,
		161,
		157,
		-1,
		258,
		243,
		236,
		226,
		240,
		211,
		-1,
		266,
		-1,
		-1,
		236,
		230,
		230,
		214,
		215,
		201,
		181,
		173,
		188,
		187,
		174,
		173,
		157,
		150,
		147,
		140,
		153,
		163,
		168,
		155,
		-1,
		-1,
		-1,
		263,
		249,
		253,
		213,
		232,
		-1,
		-1,
		298,
		253,
		239,
		-1,
		210,
		201,
		189,
		179,
		169,
		174,
		175,
		165,
		163,
		155,
		157,
		151,
		142,
		141,
		157,
		149,
		171,
		-1,
		-1,
		246,
		251,
		239,
		225,
		244,
		-1,
		-1,
		-1,
		245,
		261,
		229,
		208,
		190,
		-1,
		-1,
		173,
		166,
		160,
		163,
		151,
		171,
		166,
		150,
		135,
		150,
		154,
		162,
		153,
		-1,
		249,
		236,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		-1,
		-1,
		241,
		186,
		175,
		170,
		174,
		172,
		-1,
		146,
		157,
		150,
		169,
		176,
		152,
		137,
		131,
		137,
		149,
		158,
		-1,
		-1,
		261,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		198,
		192,
		163,
		156,
		160,
		-1,
		148,
		150,
		147,
		159,
		155,
		152,
		143,
		134,
		130,
		134,
		138,
		152,
		156,
		284,
		-1,
		225,
		-1,
		-1,
		-1,
		216,
		231,
		202,
		179,
		152,
		147,
		140,
		134,
		139,
		150,
		159,
		170,
		135,
		137,
		127,
		126,
		130,
		147,
		151,
		-1,
		-1,
		223,
		219,
		242,
		224,
		228,
		229,
		-1,
		-1,
		156,
		147,
		138,
		130,
		143,
		146,
		131,
		133,
		133,
		131,
		125,
		135,
		150,
		145,
		-1,
		-1,
		-1,
		235,
		-1,
		237,
		-1,
		-1,
		226,
		227,
		174,
		156,
		152,
		150,
		139,
		133,
		121,
		126,
		136,
		130,
		127,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		270,
		-1,
		-1,
		-1,
		215,
		206,
		201,
		208,
		210,
		201,
		189,
		186,
		-1,
		156,
		162,
		127,
		134,
		117,
		124,
		129,
		126,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		263,
		252,
		241,
		247,
		-1,
		208,
		203,
		194,
		184,
		187,
		-1,
		-1,
		181,
		178,
		158,
		127,
		125,
		118,
		113,
		123,
		99,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		217,
		254,
		247,
		215,
		223,
		254,
		-1,
		198,
		190,
		200,
		176,
		178,
		-1,
		-1,
		154,
		145,
		146,
		134,
		131,
		137,
		136,
		119,
		125,
		126,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		210,
		230,
		209,
		212,
		236,
		250,
		-1,
		195,
		-1,
		-1,
		160,
		179,
		163,
		153,
		150,
		193,
		148,
		143,
		124,
		122,
		117,
		108,
		133,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		199,
		210,
		203,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		150,
		-1,
		190,
		-1,
		173,
		177,
		156,
		159,
		138,
		125,
		111,
		119,
		125,
		124,
		130,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		224,
		180,
		183,
		194,
		205,
		220,
		224,
		-1,
		188,
		224,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		187,
		169,
		161,
		158,
		137,
		137,
		103,
		107,
		120,
		127,
		137,
		148,
		140,
		144,
		157,
		168,
		171,
		220,
		211,
		224,
		169,
		169,
		190,
		199,
		220,
		184,
		181,
		218,
		163,
		152,
		147,
		134,
		-1,
		-1,
		171,
		179,
		-1,
		-1,
		144,
		111,
		99,
		109,
		113,
		127,
		139,
		152,
		140,
		145,
		139,
		171,
		-1,
		213,
		212,
		201,
		198,
		174,
		165,
		160,
		187,
		-1,
		-1,
		182,
		209,
		193,
		196,
		194,
		219,
		-1,
		123,
		-1,
		-1,
		151,
		-1,
		-1,
		136,
		116,
		105,
		96,
		101,
		121,
		132,
		154,
		136,
		153,
		144,
		154,
		158,
		197,
		194,
		182,
		180,
		203,
		168,
		156,
		-1,
		164,
		167,
		173,
		180,
		197,
		208,
		-1,
		-1,
		139,
		119,
		-1,
		-1,
		134,
		132,
		121,
		-1,
		111,
		93,
		98,
		128,
		130,
		132,
		139,
		133,
		140,
		148,
		159,
		151,
		206,
		220,
		209,
		205,
		204,
		212,
		161,
		154,
		161,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		125,
		-1,
		-1,
		129,
		122,
		110,
		98,
		88,
		98,
		115,
		115,
		118,
		123,
		131,
		142,
		138,
		142,
		145,
		-1,
		240,
		-1,
		192,
		153,
		159,
		174,
		182,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		163,
		147,
		128,
		-1,
		98,
		111,
		151,
		119,
		124,
		119,
		134,
		145,
		136,
		144,
		138,
		141,
		-1,
		-1,
		152,
		135,
		-1,
		-1,
		109,
		111,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		135,
		131,
		-1,
		-1,
		85,
		123,
		122,
		130,
		125,
		130,
		142,
		138,
		134,
		144,
		135,
		-1,
		-1,
		130,
		122,
		116,
		-1,
		94,
		-1,
		139,
		-1,
		106,
		112,
		100,
		-1,
		-1,
		-1,
		116,
		79,
		95,
		118,
		144,
		142,
		133,
		126,
		133,
		136,
		129,
		135,
		-1,
		-1,
		-1,
		112,
		86,
		146,
		137,
		120,
		100,
		92,
		111,
		-1,
		97,
		-1,
		72,
		75,
		100,
		139,
		141,
		127,
		123,
		136,
		130,
		127,
		125,
		118,
		-1,
		88,
		121,
		85,
		106,
		78,
		86,
		111,
		-1,
		94,
		76,
		-1,
		104,
		94,
		142,
		117,
		126,
		119,
		113,
		114,
		122,
		-1,
		-1,
		-1,
		90,
		89,
		81,
		75,
		75,
		73,
		78,
		-1,
		99,
		81,
		67,
		84,
		84,
		75,
		83,
		132,
		128,
		131,
		129,
		107,
		-1,
		147,
		-1,
		-1,
		113,
		-1,
		-1,
		-1,
		84,
		68,
		79,
		67,
		68,
		64,
		64,
		66,
		79,
		87,
		85,
		82,
		94,
		90,
		110,
		106,
		138,
		-1,
		142,
		-1,
		120,
		-1,
		-1,
		65,
		52,
		62,
		73,
		79,
		77,
		63,
		59,
		76,
		111,
		97,
		95,
		100,
		105,
		-1,
		131,
		130,
		-1,
		84,
		76,
		62,
		-1,
		43,
		-1,
		125,
		86,
		-1,
		60,
		54,
		-1,
		106,
		102,
		-1,
		-1,
		118,
		100,
		-1,
		-1,
		-1,
		63,
		27,
		120,
		104,
		-1,
		44,
		51,
		-1,
		-1,
		-1,
		103,
		104,
		-1,
		56,
		59,
		-1,
		23,
		14,
		22,
		37,
		45,
		-1,
		-1,
		-1,
		112,
		93,
		87,
		71,
		76,
		64,
		35,
		21,
		0,
		22,
		36,
		65,
		-1,
		-1,
		-1,
		84,
		76,
		71,
		-1,
		-1,
		30,
		13,
		13,
		31,
		-1,
		-1,
		-1,
		106,
		87,
		-1,
		-1,
		63,
		-1,
		-1,
		22,
		34,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		95,
		-1,
		-1,
		-1,
		59,
		55,
		33,
		-1,
		-1,
		-1,
		-1,
		116,
		117,
		141,
		107,
		-1,
		-1,
		-1,
		51,
		45,
		-1,
		-1,
		119,
		117,
		-1,
		-1,
		-1,
		79,
		63,
		-1,
		49,
		-1,
		-1,
		-1,
		70,
		-1,
		-1,
		82,
		-1,
		-1,
		-1,
		84,
		-1,
		84,
		59,
		66,
		-1,
		-1,
		-1,
		-1,
		97,
		89,
		97,
		-1,
		69,
		71,
		-1,
		119,
		-1,
		-1,
		112,
		103,
		-1,
		-1,
		74,
		81,
		103,
		106,
		142,
		-1,
		93
	],
	[
		-1,
		265,
		254,
		265,
		273,
		246,
		253,
		-1,
		272,
		276,
		242,
		236,
		275,
		244,
		250,
		261,
		-1,
		-1,
		-1,
		265,
		264,
		232,
		230,
		239,
		244,
		251,
		-1,
		250,
		-1,
		286,
		265,
		276,
		281,
		225,
		222,
		242,
		261,
		243,
		235,
		301,
		255,
		226,
		220,
		238,
		228,
		237,
		229,
		-1,
		226,
		216,
		238,
		217,
		228,
		220,
		-1,
		-1,
		220,
		221,
		227,
		213,
		219,
		215,
		-1,
		225,
		209,
		-1,
		-1,
		210,
		211,
		195,
		198,
		206,
		204,
		217,
		209,
		204,
		-1,
		-1,
		201,
		197,
		204,
		191,
		187,
		204,
		217,
		199,
		213,
		212,
		-1,
		205,
		223,
		230,
		198,
		196,
		180,
		178,
		196,
		198,
		204,
		204,
		-1,
		214,
		215,
		210,
		218,
		220,
		196,
		183,
		183,
		193,
		186,
		205,
		193,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		214,
		197,
		214,
		206,
		196,
		211,
		204,
		186,
		183,
		181,
		178,
		194,
		192,
		202,
		-1,
		-1,
		307,
		276,
		305,
		263,
		244,
		-1,
		210,
		190,
		196,
		200,
		194,
		187,
		201,
		197,
		-1,
		172,
		171,
		199,
		185,
		196,
		267,
		-1,
		-1,
		265,
		257,
		240,
		243,
		220,
		216,
		205,
		204,
		196,
		182,
		178,
		184,
		187,
		187,
		193,
		166,
		176,
		180,
		178,
		203,
		-1,
		-1,
		238,
		-1,
		-1,
		264,
		247,
		-1,
		230,
		237,
		226,
		232,
		218,
		239,
		215,
		206,
		198,
		192,
		180,
		182,
		179,
		192,
		180,
		163,
		188,
		192,
		173,
		194,
		189,
		-1,
		237,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		223,
		226,
		232,
		256,
		255,
		-1,
		227,
		215,
		216,
		201,
		198,
		185,
		173,
		186,
		171,
		178,
		177,
		167,
		165,
		195,
		170,
		192,
		189,
		208,
		213,
		207,
		216,
		-1,
		272,
		268,
		264,
		271,
		220,
		-1,
		-1,
		260,
		-1,
		263,
		264,
		239,
		212,
		215,
		202,
		193,
		180,
		169,
		180,
		169,
		166,
		174,
		159,
		174,
		165,
		164,
		182,
		192,
		200,
		204,
		210,
		-1,
		322,
		-1,
		264,
		248,
		250,
		222,
		243,
		-1,
		280,
		264,
		256,
		241,
		241,
		-1,
		211,
		208,
		198,
		176,
		161,
		178,
		170,
		168,
		172,
		154,
		168,
		159,
		177,
		184,
		182,
		186,
		206,
		218,
		282,
		272,
		-1,
		254,
		259,
		218,
		226,
		245,
		283,
		247,
		-1,
		242,
		-1,
		213,
		226,
		-1,
		182,
		178,
		160,
		161,
		156,
		171,
		165,
		150,
		147,
		165,
		168,
		175,
		179,
		195,
		-1,
		-1,
		267,
		271,
		260,
		211,
		230,
		254,
		291,
		240,
		229,
		228,
		-1,
		219,
		196,
		193,
		181,
		168,
		153,
		154,
		162,
		175,
		154,
		149,
		146,
		166,
		192,
		170,
		182,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		237,
		208,
		232,
		274,
		258,
		251,
		239,
		204,
		204,
		198,
		-1,
		192,
		171,
		162,
		151,
		149,
		162,
		159,
		164,
		144,
		142,
		161,
		173,
		164,
		181,
		-1,
		-1,
		-1,
		267,
		256,
		257,
		203,
		226,
		263,
		237,
		223,
		228,
		203,
		196,
		190,
		205,
		188,
		169,
		158,
		150,
		139,
		155,
		163,
		158,
		140,
		149,
		155,
		179,
		169,
		175,
		-1,
		-1,
		274,
		264,
		248,
		250,
		247,
		217,
		224,
		256,
		228,
		241,
		-1,
		195,
		-1,
		184,
		179,
		163,
		158,
		155,
		152,
		146,
		155,
		157,
		147,
		142,
		149,
		184,
		184,
		159,
		179,
		182,
		-1,
		-1,
		-1,
		267,
		262,
		237,
		214,
		198,
		234,
		-1,
		211,
		212,
		-1,
		189,
		183,
		180,
		165,
		161,
		156,
		160,
		153,
		160,
		153,
		151,
		152,
		134,
		166,
		-1,
		167,
		161,
		169,
		159,
		147,
		-1,
		-1,
		-1,
		260,
		239,
		232,
		252,
		193,
		245,
		-1,
		-1,
		196,
		189,
		-1,
		176,
		158,
		165,
		163,
		157,
		161,
		158,
		147,
		160,
		153,
		139,
		141,
		154,
		158,
		162,
		149,
		145,
		142,
		156,
		-1,
		279,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		213,
		-1,
		205,
		197,
		187,
		181,
		175,
		171,
		169,
		185,
		169,
		172,
		170,
		161,
		169,
		142,
		135,
		142,
		131,
		149,
		157,
		149,
		143,
		142,
		152,
		-1,
		280,
		266,
		237,
		-1,
		-1,
		226,
		-1,
		190,
		204,
		220,
		-1,
		213,
		192,
		207,
		185,
		181,
		177,
		192,
		193,
		170,
		170,
		168,
		159,
		147,
		136,
		139,
		131,
		153,
		153,
		137,
		138,
		142,
		-1,
		286,
		273,
		231,
		227,
		216,
		236,
		187,
		175,
		207,
		-1,
		-1,
		249,
		-1,
		183,
		200,
		191,
		189,
		182,
		164,
		171,
		179,
		156,
		151,
		141,
		130,
		130,
		125,
		147,
		133,
		131,
		140,
		156,
		-1,
		-1,
		-1,
		253,
		-1,
		-1,
		202,
		189,
		183,
		-1,
		224,
		-1,
		227,
		217,
		201,
		186,
		219,
		-1,
		163,
		159,
		166,
		-1,
		176,
		-1,
		149,
		146,
		137,
		122,
		119,
		130,
		128,
		139,
		135,
		-1,
		236,
		221,
		214,
		204,
		218,
		189,
		-1,
		244,
		-1,
		-1,
		214,
		208,
		208,
		192,
		193,
		179,
		159,
		151,
		166,
		165,
		152,
		151,
		135,
		128,
		125,
		118,
		131,
		141,
		146,
		133,
		-1,
		-1,
		-1,
		241,
		227,
		231,
		191,
		210,
		-1,
		-1,
		276,
		231,
		217,
		-1,
		188,
		179,
		167,
		157,
		147,
		152,
		153,
		143,
		141,
		133,
		135,
		129,
		120,
		119,
		135,
		127,
		149,
		-1,
		-1,
		224,
		229,
		217,
		203,
		222,
		-1,
		-1,
		-1,
		223,
		239,
		207,
		186,
		168,
		-1,
		-1,
		151,
		144,
		138,
		141,
		129,
		149,
		144,
		128,
		113,
		128,
		132,
		140,
		131,
		-1,
		227,
		214,
		-1,
		-1,
		225,
		219,
		-1,
		-1,
		-1,
		-1,
		219,
		164,
		153,
		148,
		152,
		150,
		-1,
		124,
		135,
		128,
		147,
		154,
		130,
		115,
		109,
		115,
		127,
		136,
		-1,
		-1,
		239,
		-1,
		212,
		-1,
		-1,
		-1,
		-1,
		176,
		170,
		141,
		134,
		138,
		-1,
		126,
		128,
		125,
		137,
		133,
		130,
		121,
		112,
		108,
		112,
		116,
		130,
		134,
		262,
		-1,
		203,
		-1,
		-1,
		-1,
		194,
		209,
		180,
		157,
		130,
		125,
		118,
		112,
		117,
		128,
		137,
		148,
		113,
		115,
		105,
		104,
		108,
		125,
		129,
		-1,
		-1,
		201,
		197,
		220,
		202,
		206,
		207,
		-1,
		-1,
		134,
		125,
		116,
		108,
		121,
		124,
		109,
		111,
		111,
		109,
		103,
		113,
		128,
		123,
		-1,
		-1,
		-1,
		213,
		-1,
		215,
		-1,
		-1,
		204,
		205,
		152,
		134,
		130,
		128,
		117,
		111,
		99,
		104,
		114,
		108,
		105,
		99,
		103,
		126,
		115,
		154,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		193,
		184,
		179,
		186,
		188,
		179,
		167,
		164,
		-1,
		134,
		140,
		105,
		112,
		95,
		102,
		107,
		104,
		93,
		100,
		116,
		115,
		110,
		146,
		137,
		143,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		186,
		181,
		172,
		162,
		165,
		-1,
		-1,
		159,
		156,
		136,
		105,
		103,
		96,
		91,
		101,
		77,
		89,
		93,
		97,
		103,
		108,
		113,
		119,
		134,
		149,
		-1,
		222,
		259,
		252,
		220,
		228,
		259,
		-1,
		176,
		168,
		178,
		154,
		156,
		-1,
		-1,
		132,
		123,
		124,
		112,
		109,
		115,
		114,
		97,
		103,
		104,
		96,
		95,
		113,
		117,
		126,
		133,
		123,
		136,
		140,
		-1,
		215,
		235,
		214,
		217,
		241,
		255,
		-1,
		173,
		-1,
		-1,
		138,
		157,
		141,
		131,
		128,
		171,
		126,
		121,
		102,
		100,
		95,
		86,
		111,
		104,
		104,
		107,
		122,
		127,
		119,
		133,
		133,
		134,
		-1,
		204,
		215,
		208,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		-1,
		128,
		-1,
		168,
		-1,
		151,
		155,
		134,
		137,
		116,
		103,
		89,
		97,
		103,
		102,
		108,
		108,
		109,
		118,
		129,
		141,
		140,
		141,
		229,
		185,
		188,
		199,
		210,
		225,
		229,
		-1,
		185,
		224,
		134,
		-1,
		118,
		-1,
		-1,
		-1,
		165,
		147,
		139,
		136,
		115,
		115,
		81,
		85,
		98,
		105,
		115,
		126,
		118,
		122,
		135,
		146,
		149,
		225,
		216,
		229,
		174,
		174,
		195,
		204,
		225,
		189,
		186,
		218,
		141,
		130,
		125,
		112,
		-1,
		-1,
		149,
		157,
		-1,
		-1,
		122,
		89,
		77,
		87,
		91,
		105,
		117,
		130,
		118,
		123,
		117,
		149,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		165,
		192,
		-1,
		-1,
		187,
		214,
		197,
		174,
		172,
		197,
		-1,
		101,
		-1,
		-1,
		129,
		-1,
		-1,
		114,
		94,
		83,
		74,
		79,
		99,
		110,
		132,
		114,
		131,
		122,
		132,
		136,
		202,
		199,
		187,
		185,
		208,
		173,
		161,
		-1,
		169,
		172,
		178,
		185,
		175,
		186,
		-1,
		-1,
		117,
		97,
		-1,
		-1,
		112,
		110,
		99,
		-1,
		89,
		71,
		76,
		106,
		108,
		110,
		117,
		111,
		118,
		126,
		137,
		129,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		-1,
		107,
		103,
		-1,
		-1,
		107,
		100,
		88,
		76,
		66,
		76,
		93,
		93,
		96,
		101,
		109,
		120,
		116,
		120,
		123,
		-1,
		245,
		-1,
		197,
		158,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		124,
		110,
		103,
		91,
		89,
		-1,
		141,
		125,
		106,
		-1,
		76,
		89,
		129,
		97,
		102,
		97,
		112,
		123,
		114,
		122,
		116,
		119,
		-1,
		-1,
		157,
		140,
		-1,
		-1,
		114,
		116,
		-1,
		115,
		104,
		89,
		81,
		-1,
		-1,
		113,
		109,
		-1,
		-1,
		63,
		101,
		100,
		108,
		103,
		108,
		120,
		116,
		112,
		122,
		113,
		-1,
		-1,
		135,
		127,
		121,
		-1,
		99,
		-1,
		117,
		-1,
		84,
		90,
		78,
		-1,
		-1,
		-1,
		94,
		57,
		73,
		96,
		122,
		120,
		111,
		104,
		111,
		114,
		107,
		113,
		-1,
		-1,
		-1,
		117,
		91,
		124,
		115,
		98,
		78,
		70,
		89,
		-1,
		75,
		-1,
		50,
		53,
		78,
		117,
		119,
		105,
		101,
		114,
		108,
		105,
		103,
		123,
		-1,
		93,
		126,
		90,
		84,
		60,
		64,
		89,
		-1,
		72,
		54,
		-1,
		82,
		72,
		120,
		95,
		104,
		97,
		91,
		92,
		100,
		-1,
		-1,
		-1,
		95,
		94,
		86,
		80,
		80,
		65,
		56,
		-1,
		77,
		59,
		45,
		62,
		62,
		53,
		61,
		110,
		106,
		109,
		107,
		85,
		-1,
		127,
		-1,
		-1,
		118,
		-1,
		-1,
		-1,
		89,
		84,
		57,
		45,
		46,
		42,
		42,
		44,
		57,
		65,
		63,
		60,
		72,
		68,
		88,
		84,
		116,
		-1,
		122,
		-1,
		125,
		-1,
		-1,
		82,
		69,
		79,
		68,
		57,
		55,
		41,
		37,
		54,
		89,
		75,
		73,
		78,
		83,
		-1,
		111,
		110,
		-1,
		101,
		93,
		79,
		-1,
		60,
		-1,
		103,
		64,
		-1,
		38,
		32,
		-1,
		84,
		80,
		-1,
		-1,
		98,
		93,
		-1,
		-1,
		-1,
		80,
		44,
		98,
		82,
		-1,
		22,
		29,
		-1,
		-1,
		-1,
		83,
		84,
		-1,
		73,
		76,
		-1,
		40,
		31,
		39,
		15,
		23,
		-1,
		-1,
		-1,
		92,
		73,
		67,
		69,
		64,
		81,
		52,
		38,
		22,
		0,
		14,
		43,
		-1,
		-1,
		-1,
		64,
		56,
		49,
		-1,
		-1,
		47,
		30,
		11,
		9,
		-1,
		-1,
		-1,
		86,
		67,
		-1,
		-1,
		41,
		-1,
		-1,
		43,
		12,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		75,
		-1,
		-1,
		-1,
		37,
		33,
		34,
		-1,
		-1,
		-1,
		-1,
		97,
		98,
		121,
		85,
		-1,
		-1,
		-1,
		29,
		23,
		-1,
		-1,
		100,
		98,
		-1,
		-1,
		-1,
		57,
		41,
		-1,
		27,
		-1,
		-1,
		-1,
		48,
		-1,
		-1,
		60,
		-1,
		-1,
		-1,
		62,
		-1,
		62,
		37,
		44,
		-1,
		-1,
		-1,
		-1,
		75,
		67,
		75,
		-1,
		47,
		49,
		-1,
		97,
		-1,
		-1,
		90,
		81,
		-1,
		-1,
		52,
		59,
		81,
		84,
		120,
		-1,
		71
	],
	[
		-1,
		256,
		245,
		256,
		264,
		237,
		244,
		-1,
		263,
		267,
		233,
		227,
		266,
		235,
		241,
		252,
		-1,
		-1,
		-1,
		256,
		255,
		223,
		221,
		230,
		235,
		242,
		-1,
		241,
		-1,
		277,
		256,
		267,
		272,
		216,
		213,
		233,
		252,
		234,
		226,
		292,
		246,
		217,
		211,
		229,
		219,
		228,
		220,
		-1,
		217,
		207,
		229,
		208,
		219,
		211,
		-1,
		-1,
		211,
		212,
		218,
		204,
		210,
		206,
		-1,
		216,
		200,
		-1,
		-1,
		201,
		202,
		186,
		189,
		197,
		195,
		208,
		200,
		195,
		-1,
		-1,
		192,
		188,
		195,
		182,
		178,
		195,
		208,
		190,
		204,
		203,
		-1,
		196,
		214,
		221,
		189,
		187,
		171,
		169,
		187,
		189,
		195,
		195,
		-1,
		205,
		206,
		201,
		209,
		211,
		187,
		174,
		174,
		184,
		177,
		196,
		184,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		239,
		205,
		188,
		205,
		197,
		187,
		202,
		195,
		177,
		174,
		172,
		169,
		185,
		183,
		193,
		-1,
		-1,
		298,
		267,
		296,
		254,
		235,
		-1,
		201,
		181,
		187,
		191,
		185,
		178,
		192,
		188,
		-1,
		163,
		162,
		190,
		176,
		187,
		258,
		-1,
		-1,
		256,
		248,
		231,
		234,
		211,
		207,
		196,
		195,
		187,
		173,
		169,
		175,
		178,
		178,
		184,
		157,
		167,
		171,
		169,
		194,
		-1,
		-1,
		229,
		-1,
		-1,
		255,
		238,
		-1,
		221,
		228,
		217,
		223,
		209,
		230,
		206,
		197,
		189,
		183,
		171,
		173,
		170,
		183,
		171,
		154,
		179,
		183,
		164,
		185,
		180,
		-1,
		228,
		212,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		233,
		214,
		217,
		223,
		247,
		246,
		-1,
		218,
		206,
		207,
		192,
		189,
		176,
		164,
		177,
		162,
		169,
		168,
		158,
		156,
		186,
		161,
		183,
		180,
		199,
		204,
		198,
		207,
		-1,
		263,
		259,
		255,
		262,
		211,
		-1,
		-1,
		251,
		-1,
		254,
		255,
		230,
		203,
		206,
		193,
		184,
		171,
		160,
		171,
		160,
		157,
		165,
		150,
		165,
		156,
		155,
		173,
		183,
		191,
		195,
		201,
		-1,
		313,
		-1,
		255,
		239,
		241,
		213,
		234,
		-1,
		271,
		255,
		247,
		232,
		232,
		-1,
		202,
		199,
		189,
		167,
		152,
		169,
		161,
		159,
		163,
		145,
		159,
		150,
		168,
		175,
		173,
		177,
		197,
		209,
		273,
		263,
		-1,
		245,
		250,
		209,
		217,
		236,
		274,
		238,
		-1,
		233,
		-1,
		204,
		217,
		-1,
		173,
		169,
		151,
		152,
		147,
		162,
		156,
		141,
		138,
		156,
		159,
		166,
		170,
		186,
		-1,
		-1,
		258,
		262,
		251,
		202,
		221,
		245,
		282,
		231,
		220,
		219,
		-1,
		210,
		187,
		184,
		172,
		159,
		144,
		145,
		153,
		166,
		145,
		140,
		137,
		157,
		183,
		161,
		173,
		-1,
		-1,
		-1,
		283,
		-1,
		-1,
		228,
		199,
		223,
		265,
		249,
		242,
		230,
		195,
		195,
		189,
		-1,
		183,
		162,
		153,
		142,
		140,
		153,
		150,
		155,
		135,
		133,
		152,
		164,
		155,
		172,
		-1,
		-1,
		-1,
		258,
		247,
		248,
		194,
		217,
		254,
		228,
		214,
		219,
		194,
		187,
		181,
		196,
		179,
		160,
		149,
		141,
		130,
		146,
		154,
		149,
		131,
		140,
		146,
		170,
		160,
		166,
		-1,
		-1,
		265,
		255,
		239,
		241,
		238,
		208,
		215,
		247,
		219,
		232,
		-1,
		186,
		-1,
		175,
		170,
		154,
		149,
		146,
		143,
		137,
		146,
		148,
		138,
		133,
		140,
		175,
		175,
		150,
		170,
		173,
		-1,
		-1,
		-1,
		258,
		253,
		228,
		205,
		189,
		225,
		-1,
		202,
		203,
		-1,
		180,
		174,
		171,
		156,
		152,
		147,
		151,
		144,
		151,
		144,
		142,
		143,
		125,
		157,
		-1,
		158,
		152,
		160,
		150,
		138,
		-1,
		-1,
		-1,
		251,
		230,
		223,
		243,
		184,
		236,
		-1,
		-1,
		187,
		180,
		-1,
		167,
		149,
		156,
		154,
		148,
		152,
		149,
		138,
		151,
		144,
		130,
		132,
		145,
		149,
		153,
		140,
		136,
		133,
		147,
		-1,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		184,
		204,
		-1,
		196,
		188,
		178,
		172,
		166,
		162,
		160,
		176,
		160,
		163,
		161,
		152,
		160,
		133,
		126,
		133,
		122,
		140,
		148,
		140,
		134,
		133,
		143,
		-1,
		271,
		257,
		228,
		-1,
		-1,
		217,
		-1,
		181,
		195,
		211,
		-1,
		204,
		183,
		198,
		176,
		172,
		168,
		183,
		184,
		161,
		161,
		159,
		150,
		138,
		127,
		130,
		122,
		144,
		144,
		128,
		129,
		133,
		-1,
		277,
		264,
		222,
		218,
		207,
		227,
		178,
		166,
		198,
		-1,
		-1,
		240,
		-1,
		174,
		191,
		182,
		180,
		173,
		155,
		162,
		170,
		147,
		142,
		132,
		121,
		121,
		116,
		138,
		124,
		122,
		131,
		147,
		-1,
		-1,
		-1,
		244,
		-1,
		-1,
		193,
		180,
		174,
		-1,
		215,
		-1,
		218,
		208,
		192,
		177,
		210,
		-1,
		154,
		150,
		157,
		-1,
		167,
		-1,
		140,
		137,
		128,
		113,
		110,
		121,
		119,
		130,
		126,
		-1,
		227,
		212,
		205,
		195,
		209,
		180,
		-1,
		235,
		-1,
		-1,
		205,
		199,
		199,
		183,
		184,
		170,
		150,
		142,
		157,
		156,
		143,
		142,
		126,
		119,
		116,
		109,
		122,
		132,
		137,
		124,
		-1,
		-1,
		-1,
		232,
		218,
		222,
		182,
		201,
		-1,
		-1,
		267,
		222,
		208,
		-1,
		179,
		170,
		158,
		148,
		138,
		143,
		144,
		134,
		132,
		124,
		126,
		120,
		111,
		110,
		126,
		118,
		140,
		-1,
		-1,
		215,
		220,
		208,
		194,
		213,
		-1,
		-1,
		-1,
		214,
		230,
		198,
		177,
		159,
		-1,
		-1,
		142,
		135,
		129,
		132,
		120,
		140,
		135,
		119,
		104,
		119,
		123,
		131,
		122,
		-1,
		218,
		205,
		-1,
		-1,
		216,
		210,
		-1,
		-1,
		-1,
		-1,
		210,
		155,
		144,
		139,
		143,
		141,
		-1,
		115,
		126,
		119,
		138,
		145,
		121,
		106,
		100,
		106,
		118,
		127,
		-1,
		-1,
		230,
		-1,
		203,
		-1,
		-1,
		-1,
		-1,
		167,
		161,
		132,
		125,
		129,
		-1,
		117,
		119,
		116,
		128,
		124,
		121,
		112,
		103,
		99,
		103,
		107,
		121,
		125,
		253,
		-1,
		194,
		-1,
		-1,
		-1,
		185,
		200,
		171,
		148,
		121,
		116,
		109,
		103,
		108,
		119,
		128,
		139,
		104,
		106,
		96,
		95,
		99,
		116,
		120,
		-1,
		-1,
		192,
		188,
		211,
		193,
		197,
		198,
		-1,
		-1,
		125,
		116,
		107,
		99,
		112,
		115,
		100,
		102,
		102,
		100,
		94,
		104,
		119,
		114,
		-1,
		-1,
		-1,
		204,
		-1,
		206,
		-1,
		-1,
		195,
		196,
		143,
		125,
		121,
		119,
		108,
		102,
		90,
		95,
		105,
		99,
		96,
		90,
		94,
		117,
		106,
		145,
		-1,
		-1,
		266,
		-1,
		-1,
		-1,
		184,
		175,
		170,
		177,
		179,
		170,
		158,
		155,
		-1,
		125,
		131,
		96,
		103,
		86,
		93,
		98,
		95,
		84,
		91,
		107,
		106,
		101,
		137,
		128,
		134,
		-1,
		-1,
		259,
		248,
		237,
		243,
		-1,
		177,
		172,
		163,
		153,
		156,
		-1,
		-1,
		150,
		147,
		127,
		96,
		94,
		87,
		82,
		92,
		68,
		80,
		84,
		88,
		94,
		99,
		104,
		110,
		125,
		140,
		-1,
		213,
		250,
		243,
		211,
		219,
		250,
		-1,
		167,
		159,
		169,
		145,
		147,
		-1,
		-1,
		123,
		114,
		115,
		103,
		100,
		106,
		105,
		88,
		94,
		95,
		87,
		86,
		104,
		108,
		117,
		124,
		114,
		127,
		131,
		-1,
		206,
		226,
		205,
		208,
		232,
		246,
		-1,
		164,
		-1,
		-1,
		129,
		148,
		132,
		122,
		119,
		162,
		117,
		112,
		93,
		91,
		86,
		77,
		102,
		95,
		95,
		98,
		113,
		118,
		110,
		124,
		124,
		125,
		-1,
		195,
		206,
		199,
		-1,
		-1,
		-1,
		-1,
		165,
		-1,
		-1,
		119,
		-1,
		159,
		-1,
		142,
		146,
		125,
		128,
		107,
		94,
		80,
		88,
		94,
		93,
		99,
		99,
		100,
		109,
		120,
		132,
		131,
		132,
		220,
		176,
		179,
		190,
		201,
		216,
		220,
		-1,
		176,
		215,
		125,
		-1,
		109,
		-1,
		-1,
		-1,
		156,
		138,
		130,
		127,
		106,
		106,
		72,
		76,
		89,
		96,
		106,
		117,
		109,
		113,
		126,
		137,
		140,
		216,
		207,
		220,
		165,
		165,
		186,
		195,
		216,
		180,
		177,
		209,
		132,
		121,
		116,
		103,
		-1,
		-1,
		140,
		148,
		-1,
		-1,
		113,
		80,
		68,
		78,
		82,
		96,
		108,
		121,
		109,
		114,
		108,
		140,
		-1,
		209,
		208,
		197,
		194,
		170,
		161,
		156,
		183,
		-1,
		-1,
		178,
		205,
		188,
		165,
		163,
		188,
		-1,
		92,
		-1,
		-1,
		120,
		-1,
		-1,
		105,
		85,
		74,
		65,
		70,
		90,
		101,
		123,
		105,
		122,
		113,
		123,
		127,
		193,
		190,
		178,
		176,
		199,
		164,
		152,
		-1,
		160,
		163,
		169,
		176,
		166,
		177,
		-1,
		-1,
		108,
		88,
		-1,
		-1,
		103,
		101,
		90,
		-1,
		80,
		62,
		67,
		97,
		99,
		101,
		108,
		102,
		109,
		117,
		128,
		120,
		202,
		216,
		205,
		201,
		200,
		208,
		157,
		150,
		157,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		113,
		-1,
		98,
		94,
		-1,
		-1,
		98,
		91,
		79,
		67,
		57,
		67,
		84,
		84,
		87,
		92,
		100,
		111,
		107,
		111,
		114,
		-1,
		236,
		-1,
		188,
		149,
		155,
		170,
		178,
		-1,
		-1,
		-1,
		115,
		101,
		94,
		82,
		80,
		-1,
		132,
		116,
		97,
		-1,
		67,
		80,
		120,
		88,
		93,
		88,
		103,
		114,
		105,
		113,
		107,
		110,
		-1,
		-1,
		148,
		131,
		-1,
		-1,
		105,
		107,
		-1,
		106,
		95,
		80,
		72,
		-1,
		-1,
		104,
		100,
		-1,
		-1,
		54,
		92,
		91,
		99,
		94,
		99,
		111,
		107,
		103,
		113,
		104,
		-1,
		-1,
		126,
		118,
		112,
		-1,
		90,
		-1,
		108,
		-1,
		75,
		81,
		69,
		-1,
		-1,
		-1,
		85,
		48,
		64,
		87,
		113,
		111,
		102,
		95,
		102,
		105,
		98,
		104,
		-1,
		-1,
		-1,
		108,
		82,
		115,
		106,
		89,
		69,
		61,
		80,
		-1,
		66,
		-1,
		41,
		44,
		69,
		108,
		110,
		96,
		92,
		105,
		99,
		96,
		94,
		114,
		-1,
		84,
		117,
		81,
		75,
		51,
		55,
		80,
		-1,
		63,
		45,
		-1,
		73,
		63,
		111,
		86,
		95,
		88,
		82,
		83,
		91,
		-1,
		-1,
		-1,
		86,
		85,
		77,
		71,
		71,
		56,
		47,
		-1,
		68,
		50,
		36,
		53,
		53,
		44,
		52,
		101,
		97,
		100,
		98,
		76,
		-1,
		140,
		-1,
		-1,
		109,
		-1,
		-1,
		-1,
		80,
		75,
		48,
		36,
		37,
		33,
		33,
		35,
		48,
		56,
		54,
		51,
		63,
		59,
		79,
		75,
		107,
		-1,
		135,
		-1,
		116,
		-1,
		-1,
		95,
		78,
		70,
		59,
		48,
		46,
		32,
		28,
		45,
		80,
		66,
		64,
		69,
		74,
		-1,
		124,
		123,
		-1,
		114,
		106,
		92,
		-1,
		73,
		-1,
		94,
		55,
		-1,
		29,
		23,
		-1,
		75,
		71,
		-1,
		-1,
		111,
		106,
		-1,
		-1,
		-1,
		93,
		57,
		89,
		73,
		-1,
		13,
		20,
		-1,
		-1,
		-1,
		96,
		97,
		-1,
		86,
		89,
		-1,
		53,
		44,
		52,
		3,
		12,
		-1,
		-1,
		-1,
		105,
		86,
		80,
		82,
		77,
		94,
		65,
		51,
		35,
		13,
		0,
		32,
		-1,
		-1,
		-1,
		77,
		69,
		62,
		-1,
		-1,
		60,
		43,
		24,
		22,
		-1,
		-1,
		-1,
		99,
		80,
		-1,
		-1,
		54,
		-1,
		-1,
		56,
		25,
		-1,
		-1,
		-1,
		-1,
		-1,
		116,
		88,
		-1,
		-1,
		-1,
		50,
		46,
		47,
		-1,
		-1,
		-1,
		-1,
		110,
		111,
		134,
		98,
		-1,
		-1,
		-1,
		42,
		36,
		-1,
		-1,
		113,
		111,
		-1,
		-1,
		-1,
		70,
		54,
		-1,
		40,
		-1,
		-1,
		-1,
		61,
		-1,
		-1,
		73,
		-1,
		-1,
		-1,
		75,
		-1,
		75,
		50,
		57,
		-1,
		-1,
		-1,
		-1,
		88,
		80,
		88,
		-1,
		60,
		62,
		-1,
		110,
		-1,
		-1,
		103,
		94,
		-1,
		-1,
		65,
		72,
		94,
		97,
		133,
		-1,
		84
	],
	[
		-1,
		278,
		267,
		278,
		286,
		259,
		266,
		-1,
		285,
		289,
		255,
		249,
		288,
		257,
		263,
		274,
		-1,
		-1,
		-1,
		278,
		277,
		245,
		243,
		252,
		257,
		264,
		-1,
		263,
		-1,
		299,
		278,
		289,
		294,
		238,
		235,
		255,
		274,
		256,
		248,
		314,
		268,
		239,
		233,
		251,
		241,
		250,
		242,
		-1,
		239,
		229,
		251,
		230,
		241,
		233,
		-1,
		-1,
		233,
		234,
		240,
		226,
		232,
		228,
		-1,
		238,
		222,
		-1,
		-1,
		223,
		224,
		208,
		211,
		219,
		217,
		230,
		222,
		217,
		-1,
		-1,
		214,
		210,
		217,
		204,
		200,
		217,
		230,
		212,
		226,
		225,
		-1,
		218,
		236,
		243,
		211,
		209,
		193,
		191,
		209,
		211,
		217,
		217,
		-1,
		227,
		228,
		223,
		231,
		233,
		209,
		196,
		196,
		206,
		199,
		218,
		206,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		227,
		210,
		227,
		219,
		209,
		224,
		217,
		199,
		196,
		194,
		191,
		207,
		205,
		215,
		-1,
		-1,
		320,
		289,
		318,
		276,
		257,
		-1,
		223,
		203,
		209,
		213,
		207,
		200,
		214,
		210,
		-1,
		185,
		184,
		212,
		198,
		209,
		280,
		-1,
		-1,
		278,
		270,
		253,
		256,
		233,
		229,
		218,
		217,
		209,
		195,
		191,
		197,
		200,
		200,
		206,
		179,
		189,
		193,
		191,
		216,
		-1,
		-1,
		251,
		-1,
		-1,
		277,
		260,
		-1,
		243,
		250,
		239,
		245,
		231,
		252,
		228,
		219,
		211,
		205,
		193,
		195,
		192,
		205,
		193,
		176,
		201,
		205,
		186,
		207,
		202,
		-1,
		250,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		255,
		236,
		239,
		245,
		269,
		268,
		-1,
		240,
		228,
		229,
		214,
		211,
		198,
		186,
		199,
		184,
		191,
		190,
		180,
		178,
		208,
		183,
		205,
		202,
		221,
		226,
		220,
		229,
		-1,
		285,
		281,
		277,
		284,
		233,
		-1,
		-1,
		273,
		-1,
		276,
		277,
		252,
		225,
		228,
		215,
		206,
		193,
		182,
		193,
		182,
		179,
		187,
		172,
		187,
		178,
		177,
		195,
		205,
		213,
		217,
		223,
		-1,
		335,
		-1,
		277,
		261,
		263,
		235,
		256,
		-1,
		293,
		277,
		269,
		254,
		254,
		-1,
		224,
		221,
		211,
		189,
		174,
		191,
		183,
		181,
		185,
		167,
		181,
		172,
		190,
		197,
		195,
		199,
		219,
		231,
		295,
		285,
		-1,
		267,
		272,
		231,
		239,
		258,
		296,
		260,
		-1,
		255,
		-1,
		226,
		239,
		-1,
		195,
		191,
		173,
		174,
		169,
		184,
		178,
		163,
		160,
		178,
		181,
		188,
		192,
		208,
		-1,
		-1,
		280,
		284,
		273,
		224,
		243,
		267,
		304,
		253,
		242,
		241,
		-1,
		232,
		209,
		206,
		194,
		181,
		166,
		167,
		175,
		188,
		167,
		162,
		159,
		179,
		205,
		183,
		195,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		250,
		221,
		245,
		287,
		271,
		264,
		252,
		217,
		217,
		211,
		-1,
		205,
		184,
		175,
		164,
		162,
		175,
		172,
		177,
		157,
		155,
		174,
		186,
		177,
		194,
		-1,
		-1,
		-1,
		280,
		269,
		270,
		216,
		239,
		276,
		250,
		236,
		241,
		216,
		209,
		203,
		218,
		201,
		182,
		171,
		163,
		152,
		168,
		176,
		171,
		153,
		162,
		168,
		192,
		182,
		188,
		-1,
		-1,
		287,
		277,
		261,
		263,
		260,
		230,
		237,
		269,
		241,
		254,
		-1,
		208,
		-1,
		197,
		192,
		176,
		171,
		168,
		165,
		159,
		168,
		170,
		160,
		155,
		162,
		197,
		197,
		172,
		192,
		195,
		-1,
		-1,
		-1,
		280,
		275,
		250,
		227,
		211,
		247,
		-1,
		224,
		225,
		-1,
		202,
		196,
		193,
		178,
		174,
		169,
		173,
		166,
		173,
		166,
		164,
		165,
		147,
		179,
		-1,
		180,
		174,
		182,
		172,
		160,
		-1,
		-1,
		-1,
		273,
		252,
		245,
		265,
		206,
		258,
		-1,
		-1,
		209,
		202,
		-1,
		189,
		171,
		178,
		176,
		170,
		174,
		171,
		160,
		173,
		166,
		152,
		154,
		167,
		171,
		175,
		162,
		158,
		155,
		169,
		-1,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		206,
		226,
		-1,
		218,
		210,
		200,
		194,
		188,
		184,
		182,
		198,
		182,
		185,
		183,
		174,
		182,
		155,
		148,
		155,
		144,
		162,
		170,
		162,
		156,
		155,
		165,
		-1,
		293,
		279,
		250,
		-1,
		-1,
		239,
		-1,
		203,
		217,
		233,
		-1,
		226,
		205,
		220,
		198,
		194,
		190,
		205,
		206,
		183,
		183,
		181,
		172,
		160,
		149,
		152,
		144,
		166,
		166,
		150,
		151,
		155,
		-1,
		299,
		286,
		244,
		240,
		229,
		249,
		200,
		188,
		220,
		-1,
		-1,
		262,
		-1,
		196,
		213,
		204,
		202,
		195,
		177,
		184,
		192,
		169,
		164,
		154,
		143,
		143,
		138,
		160,
		146,
		144,
		153,
		169,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		215,
		202,
		196,
		-1,
		237,
		-1,
		240,
		230,
		214,
		199,
		232,
		-1,
		176,
		172,
		179,
		-1,
		189,
		-1,
		162,
		159,
		150,
		135,
		132,
		143,
		141,
		152,
		148,
		-1,
		249,
		234,
		227,
		217,
		231,
		202,
		-1,
		257,
		-1,
		-1,
		227,
		221,
		221,
		205,
		206,
		192,
		172,
		164,
		179,
		178,
		165,
		164,
		148,
		141,
		138,
		131,
		144,
		154,
		159,
		146,
		-1,
		-1,
		-1,
		254,
		240,
		244,
		204,
		223,
		-1,
		-1,
		289,
		244,
		230,
		-1,
		201,
		192,
		180,
		170,
		160,
		165,
		166,
		156,
		154,
		146,
		148,
		142,
		133,
		132,
		148,
		140,
		162,
		-1,
		-1,
		237,
		242,
		230,
		216,
		235,
		-1,
		-1,
		-1,
		236,
		252,
		220,
		199,
		181,
		-1,
		-1,
		164,
		157,
		151,
		154,
		142,
		162,
		157,
		141,
		126,
		141,
		145,
		153,
		144,
		-1,
		240,
		227,
		-1,
		-1,
		238,
		232,
		-1,
		-1,
		-1,
		-1,
		232,
		177,
		166,
		161,
		165,
		163,
		-1,
		137,
		148,
		141,
		160,
		167,
		143,
		128,
		122,
		128,
		140,
		149,
		-1,
		-1,
		252,
		-1,
		225,
		-1,
		-1,
		-1,
		-1,
		189,
		183,
		154,
		147,
		151,
		-1,
		139,
		141,
		138,
		150,
		146,
		143,
		134,
		125,
		121,
		125,
		129,
		143,
		147,
		275,
		-1,
		216,
		-1,
		-1,
		-1,
		207,
		222,
		193,
		170,
		143,
		138,
		131,
		125,
		130,
		141,
		150,
		161,
		126,
		128,
		118,
		117,
		121,
		138,
		142,
		-1,
		-1,
		214,
		210,
		233,
		215,
		219,
		220,
		-1,
		-1,
		147,
		138,
		129,
		121,
		134,
		137,
		122,
		124,
		124,
		122,
		116,
		126,
		141,
		136,
		-1,
		-1,
		-1,
		226,
		-1,
		228,
		-1,
		-1,
		217,
		218,
		165,
		147,
		143,
		141,
		130,
		124,
		112,
		117,
		127,
		121,
		118,
		112,
		116,
		139,
		128,
		167,
		-1,
		-1,
		288,
		-1,
		-1,
		-1,
		206,
		197,
		192,
		199,
		201,
		192,
		180,
		177,
		-1,
		147,
		153,
		118,
		125,
		108,
		115,
		120,
		117,
		106,
		113,
		129,
		128,
		123,
		159,
		150,
		156,
		-1,
		-1,
		281,
		270,
		259,
		265,
		-1,
		199,
		194,
		185,
		175,
		178,
		-1,
		-1,
		172,
		169,
		149,
		118,
		116,
		109,
		104,
		114,
		90,
		102,
		106,
		110,
		116,
		121,
		126,
		132,
		147,
		162,
		-1,
		235,
		272,
		265,
		233,
		241,
		272,
		-1,
		189,
		181,
		191,
		167,
		169,
		-1,
		-1,
		145,
		136,
		137,
		125,
		122,
		128,
		127,
		110,
		116,
		117,
		109,
		108,
		126,
		130,
		139,
		146,
		136,
		149,
		153,
		-1,
		228,
		248,
		227,
		230,
		254,
		268,
		-1,
		186,
		-1,
		-1,
		151,
		170,
		154,
		144,
		141,
		184,
		139,
		134,
		115,
		113,
		108,
		99,
		124,
		117,
		117,
		120,
		135,
		140,
		132,
		146,
		146,
		147,
		-1,
		217,
		228,
		221,
		-1,
		-1,
		-1,
		-1,
		187,
		-1,
		-1,
		141,
		-1,
		181,
		-1,
		164,
		168,
		147,
		150,
		129,
		116,
		102,
		110,
		116,
		115,
		121,
		121,
		122,
		131,
		142,
		154,
		153,
		154,
		242,
		198,
		201,
		212,
		223,
		238,
		242,
		-1,
		198,
		237,
		147,
		-1,
		131,
		-1,
		-1,
		-1,
		178,
		160,
		152,
		149,
		128,
		128,
		94,
		98,
		111,
		118,
		128,
		139,
		131,
		135,
		148,
		159,
		162,
		238,
		229,
		242,
		187,
		187,
		208,
		217,
		238,
		202,
		199,
		231,
		154,
		143,
		138,
		125,
		-1,
		-1,
		162,
		170,
		-1,
		-1,
		135,
		102,
		90,
		100,
		104,
		118,
		130,
		143,
		131,
		136,
		130,
		162,
		-1,
		231,
		230,
		219,
		216,
		192,
		183,
		178,
		205,
		-1,
		-1,
		200,
		227,
		210,
		187,
		185,
		210,
		-1,
		114,
		-1,
		-1,
		142,
		-1,
		-1,
		127,
		107,
		96,
		87,
		92,
		112,
		123,
		145,
		127,
		144,
		135,
		145,
		149,
		215,
		212,
		200,
		198,
		221,
		186,
		174,
		-1,
		182,
		185,
		191,
		198,
		188,
		199,
		-1,
		-1,
		130,
		110,
		-1,
		-1,
		125,
		123,
		112,
		-1,
		102,
		84,
		89,
		119,
		121,
		123,
		130,
		124,
		131,
		139,
		150,
		142,
		224,
		238,
		227,
		223,
		222,
		230,
		179,
		172,
		179,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		135,
		-1,
		120,
		116,
		-1,
		-1,
		120,
		113,
		101,
		89,
		79,
		89,
		106,
		106,
		109,
		114,
		122,
		133,
		129,
		133,
		136,
		-1,
		258,
		-1,
		210,
		171,
		177,
		192,
		200,
		-1,
		-1,
		-1,
		137,
		123,
		116,
		104,
		102,
		-1,
		154,
		138,
		119,
		-1,
		89,
		102,
		142,
		110,
		115,
		110,
		125,
		136,
		127,
		135,
		129,
		132,
		-1,
		-1,
		170,
		153,
		-1,
		-1,
		127,
		129,
		-1,
		128,
		117,
		102,
		94,
		-1,
		-1,
		126,
		122,
		-1,
		-1,
		76,
		114,
		113,
		121,
		116,
		121,
		133,
		129,
		125,
		135,
		126,
		-1,
		-1,
		148,
		140,
		134,
		-1,
		112,
		-1,
		130,
		-1,
		97,
		103,
		91,
		-1,
		-1,
		-1,
		107,
		70,
		86,
		109,
		135,
		133,
		124,
		117,
		124,
		127,
		120,
		126,
		-1,
		-1,
		-1,
		130,
		104,
		137,
		128,
		111,
		91,
		83,
		102,
		-1,
		88,
		-1,
		63,
		66,
		91,
		130,
		132,
		118,
		114,
		127,
		121,
		118,
		116,
		136,
		-1,
		106,
		139,
		103,
		97,
		73,
		77,
		102,
		-1,
		85,
		67,
		-1,
		95,
		85,
		133,
		108,
		117,
		110,
		104,
		105,
		113,
		-1,
		-1,
		-1,
		108,
		107,
		99,
		93,
		93,
		78,
		69,
		-1,
		90,
		72,
		58,
		75,
		75,
		66,
		74,
		123,
		119,
		122,
		120,
		98,
		-1,
		169,
		-1,
		-1,
		131,
		-1,
		-1,
		-1,
		102,
		97,
		70,
		58,
		59,
		55,
		55,
		57,
		70,
		78,
		76,
		73,
		85,
		81,
		101,
		97,
		129,
		-1,
		164,
		-1,
		138,
		-1,
		-1,
		120,
		100,
		92,
		81,
		70,
		68,
		54,
		50,
		67,
		102,
		88,
		86,
		91,
		96,
		-1,
		153,
		152,
		-1,
		139,
		131,
		117,
		-1,
		105,
		-1,
		116,
		77,
		-1,
		51,
		45,
		-1,
		97,
		93,
		-1,
		-1,
		140,
		135,
		-1,
		-1,
		-1,
		125,
		89,
		111,
		95,
		-1,
		35,
		42,
		-1,
		-1,
		-1,
		125,
		126,
		-1,
		118,
		121,
		-1,
		85,
		76,
		84,
		30,
		20,
		-1,
		-1,
		-1,
		134,
		115,
		109,
		111,
		106,
		126,
		97,
		83,
		67,
		45,
		33,
		0,
		-1,
		-1,
		-1,
		106,
		98,
		91,
		-1,
		-1,
		92,
		75,
		56,
		54,
		-1,
		-1,
		-1,
		128,
		109,
		-1,
		-1,
		83,
		-1,
		-1,
		88,
		54,
		-1,
		-1,
		-1,
		-1,
		-1,
		145,
		117,
		-1,
		-1,
		-1,
		79,
		75,
		76,
		-1,
		-1,
		-1,
		-1,
		139,
		140,
		163,
		127,
		-1,
		-1,
		-1,
		71,
		65,
		-1,
		-1,
		142,
		140,
		-1,
		-1,
		-1,
		99,
		83,
		-1,
		69,
		-1,
		-1,
		-1,
		90,
		-1,
		-1,
		102,
		-1,
		-1,
		-1,
		104,
		-1,
		104,
		79,
		86,
		-1,
		-1,
		-1,
		-1,
		117,
		109,
		117,
		-1,
		89,
		91,
		-1,
		139,
		-1,
		-1,
		132,
		123,
		-1,
		-1,
		94,
		101,
		123,
		126,
		162,
		-1,
		113
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		331,
		320,
		331,
		339,
		312,
		319,
		-1,
		338,
		342,
		308,
		302,
		341,
		310,
		316,
		327,
		-1,
		-1,
		-1,
		331,
		330,
		298,
		296,
		305,
		310,
		317,
		-1,
		316,
		-1,
		352,
		331,
		342,
		347,
		291,
		288,
		308,
		327,
		309,
		301,
		367,
		321,
		292,
		286,
		304,
		294,
		303,
		295,
		-1,
		292,
		282,
		304,
		283,
		294,
		286,
		-1,
		-1,
		286,
		287,
		293,
		279,
		285,
		281,
		-1,
		291,
		275,
		-1,
		-1,
		276,
		277,
		261,
		264,
		272,
		270,
		283,
		275,
		270,
		-1,
		-1,
		267,
		263,
		270,
		257,
		253,
		270,
		283,
		265,
		279,
		278,
		-1,
		271,
		289,
		296,
		264,
		262,
		246,
		244,
		262,
		264,
		270,
		270,
		-1,
		280,
		281,
		276,
		284,
		286,
		262,
		249,
		249,
		259,
		252,
		271,
		259,
		305,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		280,
		263,
		280,
		272,
		262,
		277,
		270,
		252,
		249,
		247,
		244,
		260,
		258,
		268,
		-1,
		-1,
		373,
		342,
		371,
		329,
		310,
		-1,
		276,
		256,
		262,
		266,
		260,
		253,
		267,
		263,
		-1,
		238,
		237,
		265,
		251,
		262,
		333,
		-1,
		-1,
		331,
		323,
		306,
		309,
		286,
		282,
		271,
		270,
		262,
		248,
		244,
		250,
		253,
		253,
		259,
		232,
		242,
		246,
		244,
		269,
		-1,
		-1,
		304,
		-1,
		-1,
		330,
		313,
		-1,
		296,
		303,
		292,
		298,
		284,
		305,
		281,
		272,
		264,
		258,
		246,
		248,
		245,
		258,
		246,
		229,
		254,
		258,
		239,
		260,
		255,
		-1,
		303,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		308,
		289,
		292,
		298,
		322,
		321,
		-1,
		293,
		281,
		282,
		267,
		264,
		251,
		239,
		252,
		237,
		244,
		243,
		233,
		231,
		261,
		236,
		258,
		255,
		274,
		279,
		273,
		282,
		-1,
		338,
		334,
		330,
		337,
		286,
		-1,
		-1,
		326,
		-1,
		329,
		330,
		305,
		278,
		281,
		268,
		259,
		246,
		235,
		246,
		235,
		232,
		240,
		225,
		240,
		231,
		230,
		248,
		258,
		266,
		270,
		276,
		-1,
		388,
		-1,
		330,
		314,
		316,
		288,
		309,
		-1,
		346,
		330,
		322,
		307,
		307,
		-1,
		277,
		274,
		264,
		242,
		227,
		244,
		236,
		234,
		238,
		220,
		234,
		225,
		243,
		250,
		248,
		252,
		272,
		284,
		348,
		338,
		-1,
		320,
		325,
		284,
		292,
		311,
		349,
		313,
		-1,
		308,
		-1,
		279,
		292,
		-1,
		248,
		244,
		226,
		227,
		222,
		237,
		231,
		216,
		213,
		231,
		234,
		241,
		245,
		261,
		-1,
		-1,
		333,
		337,
		326,
		277,
		296,
		320,
		357,
		306,
		295,
		294,
		-1,
		285,
		262,
		259,
		247,
		234,
		219,
		220,
		228,
		241,
		220,
		215,
		212,
		232,
		258,
		236,
		248,
		-1,
		-1,
		-1,
		358,
		-1,
		-1,
		303,
		274,
		298,
		340,
		324,
		317,
		305,
		270,
		270,
		264,
		-1,
		258,
		237,
		228,
		217,
		215,
		228,
		225,
		230,
		210,
		208,
		227,
		239,
		230,
		247,
		-1,
		-1,
		-1,
		333,
		322,
		323,
		269,
		292,
		329,
		303,
		289,
		294,
		269,
		262,
		256,
		271,
		254,
		235,
		224,
		216,
		205,
		221,
		229,
		224,
		206,
		215,
		221,
		245,
		235,
		241,
		-1,
		-1,
		340,
		330,
		314,
		316,
		313,
		283,
		290,
		322,
		294,
		307,
		-1,
		261,
		-1,
		250,
		245,
		229,
		224,
		221,
		218,
		212,
		221,
		223,
		213,
		208,
		215,
		250,
		250,
		225,
		245,
		248,
		-1,
		-1,
		-1,
		333,
		328,
		303,
		280,
		264,
		300,
		-1,
		277,
		278,
		-1,
		255,
		249,
		246,
		231,
		227,
		222,
		226,
		219,
		226,
		219,
		217,
		218,
		200,
		232,
		-1,
		233,
		227,
		235,
		225,
		213,
		-1,
		-1,
		-1,
		326,
		305,
		298,
		318,
		259,
		311,
		-1,
		-1,
		262,
		255,
		-1,
		242,
		224,
		231,
		229,
		223,
		227,
		224,
		213,
		226,
		219,
		205,
		207,
		220,
		224,
		228,
		215,
		211,
		208,
		222,
		-1,
		345,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		279,
		-1,
		271,
		263,
		253,
		247,
		241,
		237,
		235,
		251,
		235,
		238,
		236,
		227,
		235,
		208,
		201,
		208,
		197,
		215,
		223,
		215,
		209,
		208,
		218,
		-1,
		346,
		332,
		303,
		-1,
		-1,
		292,
		-1,
		256,
		270,
		286,
		-1,
		279,
		258,
		273,
		251,
		247,
		243,
		258,
		259,
		236,
		236,
		234,
		225,
		213,
		202,
		205,
		197,
		219,
		219,
		203,
		204,
		208,
		-1,
		352,
		339,
		297,
		293,
		282,
		302,
		253,
		241,
		273,
		-1,
		-1,
		315,
		-1,
		249,
		266,
		257,
		255,
		248,
		230,
		237,
		245,
		222,
		217,
		207,
		196,
		196,
		191,
		213,
		199,
		197,
		206,
		222,
		-1,
		-1,
		-1,
		319,
		-1,
		-1,
		268,
		255,
		249,
		-1,
		290,
		-1,
		293,
		283,
		267,
		252,
		285,
		-1,
		229,
		225,
		232,
		-1,
		242,
		-1,
		215,
		212,
		203,
		188,
		185,
		196,
		194,
		205,
		201,
		-1,
		302,
		287,
		280,
		270,
		284,
		255,
		-1,
		310,
		-1,
		-1,
		280,
		274,
		274,
		258,
		259,
		245,
		225,
		217,
		232,
		231,
		218,
		217,
		201,
		194,
		191,
		184,
		197,
		207,
		212,
		199,
		-1,
		-1,
		-1,
		307,
		293,
		297,
		257,
		276,
		-1,
		-1,
		342,
		297,
		283,
		-1,
		254,
		245,
		233,
		223,
		213,
		218,
		219,
		209,
		207,
		199,
		201,
		195,
		186,
		185,
		201,
		193,
		215,
		-1,
		-1,
		290,
		295,
		283,
		269,
		287,
		-1,
		-1,
		-1,
		289,
		305,
		273,
		252,
		234,
		-1,
		-1,
		217,
		210,
		204,
		207,
		195,
		215,
		210,
		194,
		179,
		194,
		198,
		206,
		197,
		-1,
		293,
		280,
		-1,
		-1,
		286,
		276,
		-1,
		-1,
		-1,
		-1,
		285,
		230,
		219,
		214,
		218,
		216,
		-1,
		190,
		201,
		194,
		213,
		220,
		196,
		181,
		175,
		181,
		193,
		202,
		-1,
		-1,
		300,
		-1,
		262,
		-1,
		-1,
		-1,
		-1,
		242,
		236,
		207,
		200,
		204,
		-1,
		192,
		194,
		191,
		203,
		199,
		196,
		187,
		178,
		174,
		178,
		182,
		196,
		200,
		323,
		-1,
		253,
		-1,
		-1,
		-1,
		260,
		275,
		246,
		223,
		196,
		191,
		184,
		178,
		183,
		194,
		203,
		214,
		179,
		181,
		171,
		170,
		174,
		191,
		195,
		-1,
		-1,
		251,
		247,
		282,
		268,
		272,
		273,
		-1,
		-1,
		200,
		191,
		182,
		174,
		187,
		190,
		175,
		177,
		177,
		175,
		169,
		179,
		194,
		189,
		-1,
		-1,
		-1,
		263,
		-1,
		265,
		-1,
		-1,
		270,
		271,
		218,
		200,
		196,
		194,
		183,
		177,
		165,
		170,
		180,
		174,
		171,
		165,
		169,
		192,
		181,
		220,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		247,
		234,
		229,
		252,
		254,
		245,
		233,
		230,
		-1,
		200,
		206,
		171,
		178,
		161,
		168,
		173,
		170,
		159,
		166,
		182,
		181,
		176,
		212,
		203,
		209,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		240,
		231,
		238,
		228,
		231,
		-1,
		-1,
		225,
		222,
		202,
		171,
		169,
		162,
		157,
		167,
		143,
		155,
		159,
		163,
		169,
		174,
		179,
		185,
		200,
		215,
		-1,
		234,
		271,
		264,
		232,
		240,
		271,
		-1,
		230,
		222,
		228,
		220,
		222,
		-1,
		-1,
		198,
		189,
		190,
		178,
		175,
		181,
		180,
		163,
		169,
		170,
		162,
		161,
		179,
		183,
		192,
		199,
		189,
		202,
		206,
		-1,
		227,
		247,
		226,
		229,
		253,
		267,
		-1,
		221,
		-1,
		-1,
		188,
		223,
		207,
		197,
		194,
		237,
		192,
		187,
		168,
		166,
		161,
		152,
		177,
		170,
		170,
		173,
		188,
		193,
		185,
		199,
		199,
		200,
		-1,
		216,
		227,
		220,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		178,
		-1,
		234,
		-1,
		217,
		221,
		200,
		203,
		182,
		169,
		155,
		163,
		169,
		168,
		174,
		174,
		175,
		184,
		195,
		207,
		206,
		207,
		241,
		197,
		200,
		211,
		222,
		237,
		241,
		-1,
		205,
		241,
		184,
		-1,
		168,
		-1,
		-1,
		-1,
		231,
		213,
		205,
		202,
		181,
		181,
		147,
		151,
		164,
		171,
		181,
		192,
		184,
		188,
		201,
		212,
		215,
		237,
		228,
		241,
		186,
		186,
		207,
		216,
		237,
		201,
		198,
		235,
		191,
		180,
		175,
		162,
		-1,
		-1,
		215,
		223,
		-1,
		-1,
		188,
		155,
		143,
		153,
		157,
		171,
		183,
		196,
		184,
		189,
		183,
		215,
		-1,
		230,
		229,
		218,
		215,
		191,
		182,
		177,
		204,
		-1,
		-1,
		199,
		226,
		210,
		214,
		222,
		247,
		-1,
		146,
		-1,
		-1,
		195,
		-1,
		-1,
		180,
		160,
		149,
		140,
		145,
		165,
		176,
		198,
		180,
		197,
		188,
		198,
		202,
		214,
		211,
		199,
		197,
		220,
		185,
		173,
		-1,
		181,
		184,
		190,
		197,
		214,
		236,
		-1,
		-1,
		162,
		142,
		-1,
		-1,
		178,
		176,
		165,
		-1,
		155,
		137,
		142,
		172,
		174,
		176,
		183,
		177,
		184,
		192,
		203,
		195,
		223,
		237,
		226,
		222,
		221,
		229,
		178,
		171,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		167,
		-1,
		152,
		148,
		-1,
		-1,
		173,
		166,
		154,
		142,
		132,
		142,
		159,
		159,
		162,
		167,
		175,
		186,
		182,
		186,
		189,
		-1,
		257,
		-1,
		209,
		170,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		169,
		155,
		148,
		136,
		134,
		-1,
		207,
		191,
		172,
		-1,
		142,
		155,
		195,
		163,
		168,
		163,
		178,
		189,
		180,
		188,
		182,
		185,
		-1,
		-1,
		169,
		152,
		-1,
		-1,
		126,
		128,
		-1,
		160,
		149,
		134,
		126,
		-1,
		-1,
		179,
		175,
		-1,
		-1,
		129,
		167,
		166,
		174,
		169,
		174,
		186,
		182,
		178,
		188,
		179,
		-1,
		-1,
		147,
		139,
		133,
		-1,
		111,
		-1,
		162,
		-1,
		129,
		138,
		126,
		-1,
		-1,
		-1,
		160,
		123,
		139,
		162,
		188,
		186,
		177,
		170,
		177,
		180,
		173,
		179,
		-1,
		-1,
		-1,
		129,
		103,
		169,
		160,
		143,
		123,
		115,
		137,
		-1,
		141,
		-1,
		116,
		119,
		144,
		183,
		185,
		171,
		167,
		180,
		174,
		171,
		169,
		135,
		-1,
		105,
		138,
		102,
		129,
		95,
		109,
		155,
		-1,
		138,
		120,
		-1,
		148,
		138,
		186,
		161,
		170,
		163,
		157,
		158,
		166,
		-1,
		-1,
		-1,
		107,
		106,
		98,
		92,
		92,
		90,
		107,
		-1,
		143,
		125,
		111,
		128,
		128,
		119,
		127,
		176,
		172,
		175,
		173,
		151,
		-1,
		76,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		101,
		85,
		98,
		109,
		112,
		108,
		108,
		110,
		123,
		131,
		129,
		126,
		138,
		134,
		154,
		150,
		182,
		-1,
		71,
		-1,
		137,
		-1,
		-1,
		82,
		69,
		79,
		90,
		118,
		118,
		107,
		103,
		120,
		155,
		141,
		139,
		144,
		149,
		-1,
		60,
		59,
		-1,
		53,
		63,
		79,
		-1,
		60,
		-1,
		164,
		125,
		-1,
		104,
		98,
		-1,
		150,
		146,
		-1,
		-1,
		47,
		42,
		-1,
		-1,
		-1,
		59,
		68,
		159,
		143,
		-1,
		88,
		95,
		-1,
		-1,
		-1,
		32,
		33,
		-1,
		52,
		55,
		-1,
		69,
		75,
		103,
		83,
		89,
		-1,
		-1,
		-1,
		41,
		22,
		16,
		42,
		37,
		60,
		100,
		86,
		86,
		70,
		80,
		109,
		-1,
		-1,
		-1,
		0,
		10,
		22,
		-1,
		-1,
		111,
		94,
		81,
		79,
		-1,
		-1,
		-1,
		25,
		6,
		-1,
		-1,
		31,
		-1,
		-1,
		76,
		55,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		14,
		-1,
		-1,
		-1,
		32,
		39,
		60,
		-1,
		-1,
		-1,
		-1,
		42,
		43,
		60,
		35,
		-1,
		-1,
		-1,
		46,
		49,
		-1,
		-1,
		45,
		43,
		-1,
		-1,
		-1,
		66,
		58,
		-1,
		60,
		-1,
		-1,
		-1,
		65,
		-1,
		-1,
		93,
		-1,
		-1,
		-1,
		79,
		-1,
		95,
		70,
		77,
		-1,
		-1,
		-1,
		-1,
		92,
		84,
		108,
		-1,
		80,
		82,
		-1,
		130,
		-1,
		-1,
		107,
		98,
		-1,
		-1,
		85,
		92,
		114,
		117,
		137,
		-1,
		104
	],
	[
		-1,
		321,
		310,
		321,
		329,
		302,
		309,
		-1,
		328,
		332,
		298,
		292,
		331,
		300,
		306,
		317,
		-1,
		-1,
		-1,
		321,
		320,
		288,
		286,
		295,
		300,
		307,
		-1,
		306,
		-1,
		342,
		321,
		332,
		337,
		281,
		278,
		298,
		317,
		299,
		291,
		357,
		311,
		282,
		276,
		294,
		284,
		293,
		285,
		-1,
		282,
		272,
		294,
		273,
		284,
		276,
		-1,
		-1,
		276,
		277,
		283,
		269,
		275,
		271,
		-1,
		281,
		265,
		-1,
		-1,
		266,
		267,
		251,
		254,
		262,
		260,
		273,
		265,
		260,
		-1,
		-1,
		257,
		253,
		260,
		247,
		243,
		260,
		273,
		255,
		269,
		268,
		-1,
		261,
		279,
		286,
		254,
		252,
		236,
		234,
		252,
		254,
		260,
		260,
		-1,
		270,
		271,
		266,
		274,
		276,
		252,
		239,
		239,
		249,
		242,
		261,
		249,
		295,
		-1,
		-1,
		-1,
		-1,
		-1,
		304,
		270,
		253,
		270,
		262,
		252,
		267,
		260,
		242,
		239,
		237,
		234,
		250,
		248,
		258,
		-1,
		-1,
		363,
		332,
		361,
		319,
		300,
		-1,
		266,
		246,
		252,
		256,
		250,
		243,
		257,
		253,
		-1,
		228,
		227,
		255,
		241,
		252,
		323,
		-1,
		-1,
		321,
		313,
		296,
		299,
		276,
		272,
		261,
		260,
		252,
		238,
		234,
		240,
		243,
		243,
		249,
		222,
		232,
		236,
		234,
		259,
		-1,
		-1,
		294,
		-1,
		-1,
		320,
		303,
		-1,
		286,
		293,
		282,
		288,
		274,
		295,
		271,
		262,
		254,
		248,
		236,
		238,
		235,
		248,
		236,
		219,
		244,
		248,
		229,
		250,
		245,
		-1,
		293,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		298,
		279,
		282,
		288,
		312,
		311,
		-1,
		283,
		271,
		272,
		257,
		254,
		241,
		229,
		242,
		227,
		234,
		233,
		223,
		221,
		251,
		226,
		248,
		245,
		264,
		269,
		263,
		272,
		-1,
		328,
		324,
		320,
		327,
		276,
		-1,
		-1,
		316,
		-1,
		319,
		320,
		295,
		268,
		271,
		258,
		249,
		236,
		225,
		236,
		225,
		222,
		230,
		215,
		230,
		221,
		220,
		238,
		248,
		256,
		260,
		266,
		-1,
		378,
		-1,
		320,
		304,
		306,
		278,
		299,
		-1,
		336,
		320,
		312,
		297,
		297,
		-1,
		267,
		264,
		254,
		232,
		217,
		234,
		226,
		224,
		228,
		210,
		224,
		215,
		233,
		240,
		238,
		242,
		262,
		274,
		338,
		328,
		-1,
		310,
		315,
		274,
		282,
		301,
		339,
		303,
		-1,
		298,
		-1,
		269,
		282,
		-1,
		238,
		234,
		216,
		217,
		212,
		227,
		221,
		206,
		203,
		221,
		224,
		231,
		235,
		251,
		-1,
		-1,
		323,
		327,
		316,
		267,
		286,
		310,
		347,
		296,
		285,
		284,
		-1,
		275,
		252,
		249,
		237,
		224,
		209,
		210,
		218,
		231,
		210,
		205,
		202,
		222,
		248,
		226,
		238,
		-1,
		-1,
		-1,
		348,
		-1,
		-1,
		293,
		264,
		288,
		330,
		314,
		307,
		295,
		260,
		260,
		254,
		-1,
		248,
		227,
		218,
		207,
		205,
		218,
		215,
		220,
		200,
		198,
		217,
		229,
		220,
		237,
		-1,
		-1,
		-1,
		323,
		312,
		313,
		259,
		282,
		319,
		293,
		279,
		284,
		259,
		252,
		246,
		261,
		244,
		225,
		214,
		206,
		195,
		211,
		219,
		214,
		196,
		205,
		211,
		235,
		225,
		231,
		-1,
		-1,
		330,
		320,
		304,
		306,
		303,
		273,
		280,
		312,
		284,
		297,
		-1,
		251,
		-1,
		240,
		235,
		219,
		214,
		211,
		208,
		202,
		211,
		213,
		203,
		198,
		205,
		240,
		240,
		215,
		235,
		238,
		-1,
		-1,
		-1,
		323,
		318,
		293,
		270,
		254,
		290,
		-1,
		267,
		268,
		-1,
		245,
		239,
		236,
		221,
		217,
		212,
		216,
		209,
		216,
		209,
		207,
		208,
		190,
		222,
		-1,
		223,
		217,
		225,
		215,
		203,
		-1,
		-1,
		-1,
		316,
		295,
		288,
		308,
		249,
		301,
		-1,
		-1,
		252,
		245,
		-1,
		232,
		214,
		221,
		219,
		213,
		217,
		214,
		203,
		216,
		209,
		195,
		197,
		210,
		214,
		218,
		205,
		201,
		198,
		212,
		-1,
		335,
		-1,
		-1,
		-1,
		-1,
		-1,
		249,
		269,
		-1,
		261,
		253,
		243,
		237,
		231,
		227,
		225,
		241,
		225,
		228,
		226,
		217,
		225,
		198,
		191,
		198,
		187,
		205,
		213,
		205,
		199,
		198,
		208,
		-1,
		336,
		322,
		293,
		-1,
		-1,
		282,
		-1,
		246,
		260,
		276,
		-1,
		269,
		248,
		263,
		241,
		237,
		233,
		248,
		249,
		226,
		226,
		224,
		215,
		203,
		192,
		195,
		187,
		209,
		209,
		193,
		194,
		198,
		-1,
		342,
		329,
		287,
		283,
		272,
		292,
		243,
		231,
		263,
		-1,
		-1,
		305,
		-1,
		239,
		256,
		247,
		245,
		238,
		220,
		227,
		235,
		212,
		207,
		197,
		186,
		186,
		181,
		203,
		189,
		187,
		196,
		212,
		-1,
		-1,
		-1,
		309,
		-1,
		-1,
		258,
		245,
		239,
		-1,
		280,
		-1,
		283,
		273,
		257,
		242,
		275,
		-1,
		219,
		215,
		222,
		-1,
		232,
		-1,
		205,
		202,
		193,
		178,
		175,
		186,
		184,
		195,
		191,
		-1,
		292,
		277,
		270,
		260,
		274,
		245,
		-1,
		300,
		-1,
		-1,
		270,
		264,
		264,
		248,
		249,
		235,
		215,
		207,
		222,
		221,
		208,
		207,
		191,
		184,
		181,
		174,
		187,
		197,
		202,
		189,
		-1,
		-1,
		-1,
		297,
		283,
		287,
		247,
		266,
		-1,
		-1,
		332,
		287,
		273,
		-1,
		244,
		235,
		223,
		213,
		203,
		208,
		209,
		199,
		197,
		189,
		191,
		185,
		176,
		175,
		191,
		183,
		205,
		-1,
		-1,
		280,
		285,
		273,
		259,
		277,
		-1,
		-1,
		-1,
		279,
		295,
		263,
		242,
		224,
		-1,
		-1,
		207,
		200,
		194,
		197,
		185,
		205,
		200,
		184,
		169,
		184,
		188,
		196,
		187,
		-1,
		283,
		270,
		-1,
		-1,
		276,
		266,
		-1,
		-1,
		-1,
		-1,
		275,
		220,
		209,
		204,
		208,
		206,
		-1,
		180,
		191,
		184,
		203,
		210,
		186,
		171,
		165,
		171,
		183,
		192,
		-1,
		-1,
		290,
		-1,
		252,
		-1,
		-1,
		-1,
		-1,
		232,
		226,
		197,
		190,
		194,
		-1,
		182,
		184,
		181,
		193,
		189,
		186,
		177,
		168,
		164,
		168,
		172,
		186,
		190,
		313,
		-1,
		243,
		-1,
		-1,
		-1,
		250,
		265,
		236,
		213,
		186,
		181,
		174,
		168,
		173,
		184,
		193,
		204,
		169,
		171,
		161,
		160,
		164,
		181,
		185,
		-1,
		-1,
		241,
		237,
		272,
		258,
		262,
		263,
		-1,
		-1,
		190,
		181,
		172,
		164,
		177,
		180,
		165,
		167,
		167,
		165,
		159,
		169,
		184,
		179,
		-1,
		-1,
		-1,
		253,
		-1,
		255,
		-1,
		-1,
		260,
		261,
		208,
		190,
		186,
		184,
		173,
		167,
		155,
		160,
		170,
		164,
		161,
		155,
		159,
		182,
		171,
		210,
		-1,
		-1,
		277,
		-1,
		-1,
		-1,
		237,
		224,
		219,
		242,
		244,
		235,
		223,
		220,
		-1,
		190,
		196,
		161,
		168,
		151,
		158,
		163,
		160,
		149,
		156,
		172,
		171,
		166,
		202,
		193,
		199,
		-1,
		-1,
		270,
		259,
		248,
		254,
		-1,
		230,
		221,
		228,
		218,
		221,
		-1,
		-1,
		215,
		212,
		192,
		161,
		159,
		152,
		147,
		157,
		133,
		145,
		149,
		153,
		159,
		164,
		169,
		175,
		190,
		205,
		-1,
		224,
		261,
		254,
		222,
		230,
		261,
		-1,
		220,
		212,
		218,
		210,
		212,
		-1,
		-1,
		188,
		179,
		180,
		168,
		165,
		171,
		170,
		153,
		159,
		160,
		152,
		151,
		169,
		173,
		182,
		189,
		179,
		192,
		196,
		-1,
		217,
		237,
		216,
		219,
		243,
		257,
		-1,
		211,
		-1,
		-1,
		178,
		213,
		197,
		187,
		184,
		227,
		182,
		177,
		158,
		156,
		151,
		142,
		167,
		160,
		160,
		163,
		178,
		183,
		175,
		189,
		189,
		190,
		-1,
		206,
		217,
		210,
		-1,
		-1,
		-1,
		-1,
		205,
		-1,
		-1,
		168,
		-1,
		224,
		-1,
		207,
		211,
		190,
		193,
		172,
		159,
		145,
		153,
		159,
		158,
		164,
		164,
		165,
		174,
		185,
		197,
		196,
		197,
		231,
		187,
		190,
		201,
		212,
		227,
		231,
		-1,
		195,
		231,
		174,
		-1,
		158,
		-1,
		-1,
		-1,
		221,
		203,
		195,
		192,
		171,
		171,
		137,
		141,
		154,
		161,
		171,
		182,
		174,
		178,
		191,
		202,
		205,
		227,
		218,
		231,
		176,
		176,
		197,
		206,
		227,
		191,
		188,
		225,
		181,
		170,
		165,
		152,
		-1,
		-1,
		205,
		213,
		-1,
		-1,
		178,
		145,
		133,
		143,
		147,
		161,
		173,
		186,
		174,
		179,
		173,
		205,
		-1,
		220,
		219,
		208,
		205,
		181,
		172,
		167,
		194,
		-1,
		-1,
		189,
		216,
		200,
		204,
		212,
		237,
		-1,
		136,
		-1,
		-1,
		185,
		-1,
		-1,
		170,
		150,
		139,
		130,
		135,
		155,
		166,
		188,
		170,
		187,
		178,
		188,
		192,
		204,
		201,
		189,
		187,
		210,
		175,
		163,
		-1,
		171,
		174,
		180,
		187,
		204,
		226,
		-1,
		-1,
		152,
		132,
		-1,
		-1,
		168,
		166,
		155,
		-1,
		145,
		127,
		132,
		162,
		164,
		166,
		173,
		167,
		174,
		182,
		193,
		185,
		213,
		227,
		216,
		212,
		211,
		219,
		168,
		161,
		168,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		157,
		-1,
		142,
		138,
		-1,
		-1,
		163,
		156,
		144,
		132,
		122,
		132,
		149,
		149,
		152,
		157,
		165,
		176,
		172,
		176,
		179,
		-1,
		247,
		-1,
		199,
		160,
		166,
		181,
		189,
		-1,
		-1,
		-1,
		159,
		145,
		138,
		126,
		124,
		-1,
		197,
		181,
		162,
		-1,
		132,
		145,
		185,
		153,
		158,
		153,
		168,
		179,
		170,
		178,
		172,
		175,
		-1,
		-1,
		159,
		142,
		-1,
		-1,
		116,
		118,
		-1,
		150,
		139,
		124,
		116,
		-1,
		-1,
		169,
		165,
		-1,
		-1,
		119,
		157,
		156,
		164,
		159,
		164,
		176,
		172,
		168,
		178,
		169,
		-1,
		-1,
		137,
		129,
		123,
		-1,
		101,
		-1,
		152,
		-1,
		119,
		128,
		116,
		-1,
		-1,
		-1,
		150,
		113,
		129,
		152,
		178,
		176,
		167,
		160,
		167,
		170,
		163,
		169,
		-1,
		-1,
		-1,
		119,
		93,
		159,
		150,
		133,
		113,
		105,
		127,
		-1,
		131,
		-1,
		106,
		109,
		134,
		173,
		175,
		161,
		157,
		170,
		164,
		161,
		159,
		125,
		-1,
		95,
		128,
		92,
		119,
		85,
		99,
		145,
		-1,
		128,
		110,
		-1,
		138,
		128,
		176,
		151,
		160,
		153,
		147,
		148,
		156,
		-1,
		-1,
		-1,
		97,
		96,
		88,
		82,
		82,
		80,
		97,
		-1,
		133,
		115,
		101,
		118,
		118,
		109,
		117,
		166,
		162,
		165,
		163,
		141,
		-1,
		71,
		-1,
		-1,
		120,
		-1,
		-1,
		-1,
		91,
		75,
		88,
		99,
		102,
		98,
		98,
		100,
		113,
		121,
		119,
		116,
		128,
		124,
		144,
		140,
		172,
		-1,
		66,
		-1,
		127,
		-1,
		-1,
		72,
		59,
		69,
		80,
		108,
		108,
		97,
		93,
		110,
		145,
		131,
		129,
		134,
		139,
		-1,
		55,
		54,
		-1,
		48,
		58,
		69,
		-1,
		50,
		-1,
		154,
		115,
		-1,
		94,
		88,
		-1,
		140,
		136,
		-1,
		-1,
		42,
		37,
		-1,
		-1,
		-1,
		49,
		58,
		149,
		133,
		-1,
		78,
		85,
		-1,
		-1,
		-1,
		27,
		28,
		-1,
		42,
		45,
		-1,
		59,
		65,
		93,
		73,
		79,
		-1,
		-1,
		-1,
		36,
		17,
		11,
		32,
		27,
		50,
		90,
		76,
		76,
		60,
		70,
		99,
		-1,
		-1,
		-1,
		8,
		0,
		12,
		-1,
		-1,
		101,
		84,
		71,
		69,
		-1,
		-1,
		-1,
		30,
		11,
		-1,
		-1,
		21,
		-1,
		-1,
		66,
		45,
		-1,
		-1,
		-1,
		-1,
		-1,
		48,
		19,
		-1,
		-1,
		-1,
		22,
		29,
		50,
		-1,
		-1,
		-1,
		-1,
		44,
		45,
		65,
		40,
		-1,
		-1,
		-1,
		36,
		39,
		-1,
		-1,
		47,
		45,
		-1,
		-1,
		-1,
		64,
		48,
		-1,
		50,
		-1,
		-1,
		-1,
		55,
		-1,
		-1,
		83,
		-1,
		-1,
		-1,
		69,
		-1,
		85,
		60,
		67,
		-1,
		-1,
		-1,
		-1,
		82,
		74,
		98,
		-1,
		70,
		72,
		-1,
		120,
		-1,
		-1,
		97,
		88,
		-1,
		-1,
		75,
		82,
		104,
		107,
		127,
		-1,
		94
	],
	[
		-1,
		314,
		303,
		314,
		322,
		295,
		302,
		-1,
		321,
		325,
		291,
		285,
		324,
		293,
		299,
		310,
		-1,
		-1,
		-1,
		314,
		313,
		281,
		279,
		288,
		293,
		300,
		-1,
		299,
		-1,
		335,
		314,
		325,
		330,
		274,
		271,
		291,
		310,
		292,
		284,
		350,
		304,
		275,
		269,
		287,
		277,
		286,
		278,
		-1,
		275,
		265,
		287,
		266,
		277,
		269,
		-1,
		-1,
		269,
		270,
		276,
		262,
		268,
		264,
		-1,
		274,
		258,
		-1,
		-1,
		259,
		260,
		244,
		247,
		255,
		253,
		266,
		258,
		253,
		-1,
		-1,
		250,
		246,
		253,
		240,
		236,
		253,
		266,
		248,
		262,
		261,
		-1,
		254,
		272,
		279,
		247,
		245,
		229,
		227,
		245,
		247,
		253,
		253,
		-1,
		263,
		264,
		259,
		267,
		269,
		245,
		232,
		232,
		242,
		235,
		254,
		242,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		263,
		246,
		263,
		255,
		245,
		260,
		253,
		235,
		232,
		230,
		227,
		243,
		241,
		251,
		-1,
		-1,
		356,
		325,
		354,
		312,
		293,
		-1,
		259,
		239,
		245,
		249,
		243,
		236,
		250,
		246,
		-1,
		221,
		220,
		248,
		234,
		245,
		316,
		-1,
		-1,
		314,
		306,
		289,
		292,
		269,
		265,
		254,
		253,
		245,
		231,
		227,
		233,
		236,
		236,
		242,
		215,
		225,
		229,
		227,
		252,
		-1,
		-1,
		287,
		-1,
		-1,
		313,
		296,
		-1,
		279,
		286,
		275,
		281,
		267,
		288,
		264,
		255,
		247,
		241,
		229,
		231,
		228,
		241,
		229,
		212,
		237,
		241,
		222,
		243,
		238,
		-1,
		286,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		272,
		275,
		281,
		305,
		304,
		-1,
		276,
		264,
		265,
		250,
		247,
		234,
		222,
		235,
		220,
		227,
		226,
		216,
		214,
		244,
		219,
		241,
		238,
		257,
		262,
		256,
		265,
		-1,
		321,
		317,
		313,
		320,
		269,
		-1,
		-1,
		309,
		-1,
		312,
		313,
		288,
		261,
		264,
		251,
		242,
		229,
		218,
		229,
		218,
		215,
		223,
		208,
		223,
		214,
		213,
		231,
		241,
		249,
		253,
		259,
		-1,
		371,
		-1,
		313,
		297,
		299,
		271,
		292,
		-1,
		329,
		313,
		305,
		290,
		290,
		-1,
		260,
		257,
		247,
		225,
		210,
		227,
		219,
		217,
		221,
		203,
		217,
		208,
		226,
		233,
		231,
		235,
		255,
		267,
		331,
		321,
		-1,
		303,
		308,
		267,
		275,
		294,
		332,
		296,
		-1,
		291,
		-1,
		262,
		275,
		-1,
		231,
		227,
		209,
		210,
		205,
		220,
		214,
		199,
		196,
		214,
		217,
		224,
		228,
		244,
		-1,
		-1,
		316,
		320,
		309,
		260,
		279,
		303,
		340,
		289,
		278,
		277,
		-1,
		268,
		245,
		242,
		230,
		217,
		202,
		203,
		211,
		224,
		203,
		198,
		195,
		215,
		241,
		219,
		231,
		-1,
		-1,
		-1,
		341,
		-1,
		-1,
		286,
		257,
		281,
		323,
		307,
		300,
		288,
		253,
		253,
		247,
		-1,
		241,
		220,
		211,
		200,
		198,
		211,
		208,
		213,
		193,
		191,
		210,
		222,
		213,
		230,
		-1,
		-1,
		-1,
		316,
		305,
		306,
		252,
		275,
		312,
		286,
		272,
		277,
		252,
		245,
		239,
		254,
		237,
		218,
		207,
		199,
		188,
		204,
		212,
		207,
		189,
		198,
		204,
		228,
		218,
		224,
		-1,
		-1,
		323,
		313,
		297,
		299,
		296,
		266,
		273,
		305,
		277,
		290,
		-1,
		244,
		-1,
		233,
		228,
		212,
		207,
		204,
		201,
		195,
		204,
		206,
		196,
		191,
		198,
		233,
		233,
		208,
		228,
		231,
		-1,
		-1,
		-1,
		316,
		311,
		286,
		263,
		247,
		283,
		-1,
		260,
		261,
		-1,
		238,
		232,
		229,
		214,
		210,
		205,
		209,
		202,
		209,
		202,
		200,
		201,
		183,
		215,
		-1,
		216,
		210,
		218,
		208,
		196,
		-1,
		-1,
		-1,
		309,
		288,
		281,
		301,
		242,
		294,
		-1,
		-1,
		245,
		238,
		-1,
		225,
		207,
		214,
		212,
		206,
		210,
		207,
		196,
		209,
		202,
		188,
		190,
		203,
		207,
		211,
		198,
		194,
		191,
		205,
		-1,
		328,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		262,
		-1,
		254,
		246,
		236,
		230,
		224,
		220,
		218,
		234,
		218,
		221,
		219,
		210,
		218,
		191,
		184,
		191,
		180,
		198,
		206,
		198,
		192,
		191,
		201,
		-1,
		329,
		315,
		286,
		-1,
		-1,
		275,
		-1,
		239,
		253,
		269,
		-1,
		262,
		241,
		256,
		234,
		230,
		226,
		241,
		242,
		219,
		219,
		217,
		208,
		196,
		185,
		188,
		180,
		202,
		202,
		186,
		187,
		191,
		-1,
		335,
		322,
		280,
		276,
		265,
		285,
		236,
		224,
		256,
		-1,
		-1,
		298,
		-1,
		232,
		249,
		240,
		238,
		231,
		213,
		220,
		228,
		205,
		200,
		190,
		179,
		179,
		174,
		196,
		182,
		180,
		189,
		205,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		251,
		238,
		232,
		-1,
		273,
		-1,
		276,
		266,
		250,
		235,
		268,
		-1,
		212,
		208,
		215,
		-1,
		225,
		-1,
		198,
		195,
		186,
		171,
		168,
		179,
		177,
		188,
		184,
		-1,
		285,
		270,
		263,
		253,
		267,
		238,
		-1,
		293,
		-1,
		-1,
		263,
		257,
		257,
		241,
		242,
		228,
		208,
		200,
		215,
		214,
		201,
		200,
		184,
		177,
		174,
		167,
		180,
		190,
		195,
		182,
		-1,
		-1,
		-1,
		290,
		276,
		280,
		240,
		259,
		-1,
		-1,
		325,
		280,
		266,
		-1,
		237,
		228,
		216,
		206,
		196,
		201,
		202,
		192,
		190,
		182,
		184,
		178,
		169,
		168,
		184,
		176,
		198,
		-1,
		-1,
		273,
		278,
		266,
		252,
		271,
		-1,
		-1,
		-1,
		272,
		288,
		256,
		235,
		217,
		-1,
		-1,
		200,
		193,
		187,
		190,
		178,
		198,
		193,
		177,
		162,
		177,
		181,
		189,
		180,
		-1,
		276,
		263,
		-1,
		-1,
		274,
		267,
		-1,
		-1,
		-1,
		-1,
		268,
		213,
		202,
		197,
		201,
		199,
		-1,
		173,
		184,
		177,
		196,
		203,
		179,
		164,
		158,
		164,
		176,
		185,
		-1,
		-1,
		288,
		-1,
		253,
		-1,
		-1,
		-1,
		-1,
		225,
		219,
		190,
		183,
		187,
		-1,
		175,
		177,
		174,
		186,
		182,
		179,
		170,
		161,
		157,
		161,
		165,
		179,
		183,
		311,
		-1,
		244,
		-1,
		-1,
		-1,
		243,
		258,
		229,
		206,
		179,
		174,
		167,
		161,
		166,
		177,
		186,
		197,
		162,
		164,
		154,
		153,
		157,
		174,
		178,
		-1,
		-1,
		242,
		238,
		269,
		251,
		255,
		256,
		-1,
		-1,
		183,
		174,
		165,
		157,
		170,
		173,
		158,
		160,
		160,
		158,
		152,
		162,
		177,
		172,
		-1,
		-1,
		-1,
		254,
		-1,
		256,
		-1,
		-1,
		253,
		254,
		201,
		183,
		179,
		177,
		166,
		160,
		148,
		153,
		163,
		157,
		154,
		148,
		152,
		175,
		164,
		203,
		-1,
		-1,
		278,
		-1,
		-1,
		-1,
		238,
		225,
		220,
		235,
		237,
		228,
		216,
		213,
		-1,
		183,
		189,
		154,
		161,
		144,
		151,
		156,
		153,
		142,
		149,
		165,
		164,
		159,
		195,
		186,
		192,
		-1,
		-1,
		271,
		260,
		249,
		255,
		-1,
		231,
		222,
		221,
		211,
		214,
		-1,
		-1,
		208,
		205,
		185,
		154,
		152,
		145,
		140,
		150,
		126,
		138,
		142,
		146,
		152,
		157,
		162,
		168,
		183,
		198,
		-1,
		225,
		262,
		255,
		223,
		231,
		262,
		-1,
		221,
		213,
		219,
		203,
		205,
		-1,
		-1,
		181,
		172,
		173,
		161,
		158,
		164,
		163,
		146,
		152,
		153,
		145,
		144,
		162,
		166,
		175,
		182,
		172,
		185,
		189,
		-1,
		218,
		238,
		217,
		220,
		244,
		258,
		-1,
		212,
		-1,
		-1,
		179,
		206,
		190,
		180,
		177,
		220,
		175,
		170,
		151,
		149,
		144,
		135,
		160,
		153,
		153,
		156,
		171,
		176,
		168,
		182,
		182,
		183,
		-1,
		207,
		218,
		211,
		-1,
		-1,
		-1,
		-1,
		206,
		-1,
		-1,
		169,
		-1,
		217,
		-1,
		200,
		204,
		183,
		186,
		165,
		152,
		138,
		146,
		152,
		151,
		157,
		157,
		158,
		167,
		178,
		190,
		189,
		190,
		232,
		188,
		191,
		202,
		213,
		228,
		232,
		-1,
		196,
		232,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		214,
		196,
		188,
		185,
		164,
		164,
		130,
		134,
		147,
		154,
		164,
		175,
		167,
		171,
		184,
		195,
		198,
		228,
		219,
		232,
		177,
		177,
		198,
		207,
		228,
		192,
		189,
		226,
		182,
		171,
		166,
		153,
		-1,
		-1,
		198,
		206,
		-1,
		-1,
		171,
		138,
		126,
		136,
		140,
		154,
		166,
		179,
		167,
		172,
		166,
		198,
		-1,
		221,
		220,
		209,
		206,
		182,
		173,
		168,
		195,
		-1,
		-1,
		190,
		217,
		201,
		205,
		213,
		238,
		-1,
		137,
		-1,
		-1,
		178,
		-1,
		-1,
		163,
		143,
		132,
		123,
		128,
		148,
		159,
		181,
		163,
		180,
		171,
		181,
		185,
		205,
		202,
		190,
		188,
		211,
		176,
		164,
		-1,
		172,
		175,
		181,
		188,
		205,
		227,
		-1,
		-1,
		153,
		133,
		-1,
		-1,
		161,
		159,
		148,
		-1,
		138,
		120,
		125,
		155,
		157,
		159,
		166,
		160,
		167,
		175,
		186,
		178,
		214,
		228,
		217,
		213,
		212,
		220,
		169,
		162,
		169,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		158,
		-1,
		143,
		139,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		142,
		142,
		145,
		150,
		158,
		169,
		165,
		169,
		172,
		-1,
		248,
		-1,
		200,
		161,
		167,
		182,
		190,
		-1,
		-1,
		-1,
		160,
		146,
		139,
		127,
		125,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		178,
		146,
		151,
		146,
		161,
		172,
		163,
		171,
		165,
		168,
		-1,
		-1,
		160,
		143,
		-1,
		-1,
		117,
		119,
		-1,
		151,
		140,
		125,
		117,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		112,
		150,
		149,
		157,
		152,
		157,
		169,
		165,
		161,
		171,
		162,
		-1,
		-1,
		138,
		130,
		124,
		-1,
		102,
		-1,
		153,
		-1,
		120,
		129,
		117,
		-1,
		-1,
		-1,
		143,
		106,
		122,
		145,
		171,
		169,
		160,
		153,
		160,
		163,
		156,
		162,
		-1,
		-1,
		-1,
		120,
		94,
		160,
		151,
		134,
		114,
		106,
		128,
		-1,
		124,
		-1,
		99,
		102,
		127,
		166,
		168,
		154,
		150,
		163,
		157,
		154,
		152,
		126,
		-1,
		96,
		129,
		93,
		120,
		86,
		100,
		138,
		-1,
		121,
		103,
		-1,
		131,
		121,
		169,
		144,
		153,
		146,
		140,
		141,
		149,
		-1,
		-1,
		-1,
		98,
		97,
		89,
		83,
		83,
		81,
		98,
		-1,
		126,
		108,
		94,
		111,
		111,
		102,
		110,
		159,
		155,
		158,
		156,
		134,
		-1,
		83,
		-1,
		-1,
		121,
		-1,
		-1,
		-1,
		92,
		76,
		89,
		94,
		95,
		91,
		91,
		93,
		106,
		114,
		112,
		109,
		121,
		117,
		137,
		133,
		165,
		-1,
		78,
		-1,
		128,
		-1,
		-1,
		73,
		60,
		70,
		81,
		106,
		104,
		90,
		86,
		103,
		138,
		124,
		122,
		127,
		132,
		-1,
		67,
		66,
		-1,
		60,
		70,
		70,
		-1,
		51,
		-1,
		152,
		113,
		-1,
		87,
		81,
		-1,
		133,
		129,
		-1,
		-1,
		54,
		49,
		-1,
		-1,
		-1,
		50,
		59,
		147,
		131,
		-1,
		71,
		78,
		-1,
		-1,
		-1,
		39,
		40,
		-1,
		30,
		46,
		-1,
		60,
		66,
		92,
		66,
		72,
		-1,
		-1,
		-1,
		48,
		29,
		23,
		20,
		15,
		51,
		91,
		77,
		75,
		53,
		63,
		92,
		-1,
		-1,
		-1,
		20,
		12,
		0,
		-1,
		-1,
		100,
		83,
		64,
		62,
		-1,
		-1,
		-1,
		42,
		23,
		-1,
		-1,
		14,
		-1,
		-1,
		59,
		38,
		-1,
		-1,
		-1,
		-1,
		-1,
		60,
		31,
		-1,
		-1,
		-1,
		15,
		22,
		43,
		-1,
		-1,
		-1,
		-1,
		53,
		54,
		77,
		52,
		-1,
		-1,
		-1,
		29,
		32,
		-1,
		-1,
		56,
		54,
		-1,
		-1,
		-1,
		57,
		41,
		-1,
		43,
		-1,
		-1,
		-1,
		48,
		-1,
		-1,
		76,
		-1,
		-1,
		-1,
		62,
		-1,
		78,
		53,
		60,
		-1,
		-1,
		-1,
		-1,
		75,
		67,
		91,
		-1,
		63,
		65,
		-1,
		113,
		-1,
		-1,
		90,
		81,
		-1,
		-1,
		68,
		75,
		97,
		100,
		120,
		-1,
		87
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		313,
		302,
		313,
		321,
		294,
		301,
		-1,
		320,
		324,
		290,
		284,
		323,
		292,
		298,
		309,
		-1,
		-1,
		-1,
		313,
		312,
		280,
		278,
		287,
		292,
		299,
		-1,
		298,
		-1,
		334,
		313,
		324,
		329,
		273,
		270,
		290,
		309,
		291,
		283,
		349,
		303,
		274,
		268,
		286,
		276,
		285,
		277,
		-1,
		274,
		264,
		286,
		265,
		276,
		268,
		-1,
		-1,
		268,
		269,
		275,
		261,
		267,
		263,
		-1,
		273,
		257,
		-1,
		-1,
		258,
		259,
		243,
		246,
		254,
		252,
		265,
		257,
		252,
		-1,
		-1,
		249,
		245,
		252,
		239,
		235,
		252,
		265,
		247,
		261,
		260,
		-1,
		253,
		271,
		278,
		246,
		244,
		228,
		226,
		244,
		246,
		252,
		252,
		-1,
		262,
		263,
		258,
		266,
		268,
		244,
		231,
		231,
		241,
		234,
		253,
		241,
		287,
		-1,
		-1,
		-1,
		-1,
		-1,
		296,
		262,
		245,
		262,
		254,
		244,
		259,
		252,
		234,
		231,
		229,
		226,
		242,
		240,
		250,
		-1,
		-1,
		355,
		324,
		353,
		311,
		292,
		-1,
		258,
		238,
		244,
		248,
		242,
		235,
		249,
		245,
		-1,
		220,
		219,
		247,
		233,
		244,
		315,
		-1,
		-1,
		313,
		305,
		288,
		291,
		268,
		264,
		253,
		252,
		244,
		230,
		226,
		232,
		235,
		235,
		241,
		214,
		224,
		228,
		226,
		251,
		-1,
		-1,
		286,
		-1,
		-1,
		312,
		295,
		-1,
		278,
		285,
		274,
		280,
		266,
		287,
		263,
		254,
		246,
		240,
		228,
		230,
		227,
		240,
		228,
		211,
		236,
		240,
		221,
		242,
		237,
		-1,
		285,
		269,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		271,
		274,
		280,
		304,
		303,
		-1,
		275,
		263,
		264,
		249,
		246,
		233,
		221,
		234,
		219,
		226,
		225,
		215,
		213,
		243,
		218,
		240,
		237,
		256,
		261,
		255,
		264,
		-1,
		320,
		316,
		312,
		319,
		268,
		-1,
		-1,
		308,
		-1,
		311,
		312,
		287,
		260,
		263,
		250,
		241,
		228,
		217,
		228,
		217,
		214,
		222,
		207,
		222,
		213,
		212,
		230,
		240,
		248,
		252,
		258,
		-1,
		370,
		-1,
		312,
		296,
		298,
		270,
		291,
		-1,
		328,
		312,
		304,
		289,
		289,
		-1,
		259,
		256,
		246,
		224,
		209,
		226,
		218,
		216,
		220,
		202,
		216,
		207,
		225,
		232,
		230,
		234,
		254,
		266,
		330,
		320,
		-1,
		302,
		307,
		266,
		274,
		293,
		331,
		295,
		-1,
		290,
		-1,
		261,
		274,
		-1,
		230,
		226,
		208,
		209,
		204,
		219,
		213,
		198,
		195,
		213,
		216,
		223,
		227,
		243,
		-1,
		-1,
		315,
		319,
		308,
		259,
		278,
		302,
		339,
		288,
		277,
		276,
		-1,
		267,
		244,
		241,
		229,
		216,
		201,
		202,
		210,
		223,
		202,
		197,
		194,
		214,
		240,
		218,
		230,
		-1,
		-1,
		-1,
		340,
		-1,
		-1,
		285,
		256,
		280,
		322,
		306,
		299,
		287,
		252,
		252,
		246,
		-1,
		240,
		219,
		210,
		199,
		197,
		210,
		207,
		212,
		192,
		190,
		209,
		221,
		212,
		229,
		-1,
		-1,
		-1,
		315,
		304,
		305,
		251,
		274,
		311,
		285,
		271,
		276,
		251,
		244,
		238,
		253,
		236,
		217,
		206,
		198,
		187,
		203,
		211,
		206,
		188,
		197,
		203,
		227,
		217,
		223,
		-1,
		-1,
		322,
		312,
		296,
		298,
		295,
		265,
		272,
		304,
		276,
		289,
		-1,
		243,
		-1,
		232,
		227,
		211,
		206,
		203,
		200,
		194,
		203,
		205,
		195,
		190,
		197,
		232,
		232,
		207,
		227,
		230,
		-1,
		-1,
		-1,
		315,
		310,
		285,
		262,
		246,
		282,
		-1,
		259,
		260,
		-1,
		237,
		231,
		228,
		213,
		209,
		204,
		208,
		201,
		208,
		201,
		199,
		200,
		182,
		214,
		-1,
		215,
		209,
		217,
		207,
		195,
		-1,
		-1,
		-1,
		308,
		287,
		280,
		300,
		241,
		293,
		-1,
		-1,
		244,
		237,
		-1,
		224,
		206,
		213,
		211,
		205,
		209,
		206,
		195,
		208,
		201,
		187,
		189,
		202,
		206,
		210,
		197,
		193,
		190,
		204,
		-1,
		327,
		-1,
		-1,
		-1,
		-1,
		-1,
		241,
		261,
		-1,
		253,
		245,
		235,
		229,
		223,
		219,
		217,
		233,
		217,
		220,
		218,
		209,
		217,
		190,
		183,
		190,
		179,
		197,
		205,
		197,
		191,
		190,
		200,
		-1,
		328,
		314,
		285,
		-1,
		-1,
		274,
		-1,
		238,
		252,
		268,
		-1,
		261,
		240,
		255,
		233,
		229,
		225,
		240,
		241,
		218,
		218,
		216,
		207,
		195,
		184,
		187,
		179,
		201,
		201,
		185,
		186,
		190,
		-1,
		334,
		321,
		279,
		275,
		264,
		284,
		235,
		223,
		255,
		-1,
		-1,
		297,
		-1,
		231,
		248,
		239,
		237,
		230,
		212,
		219,
		227,
		204,
		199,
		189,
		178,
		178,
		173,
		195,
		181,
		179,
		188,
		204,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		250,
		237,
		231,
		-1,
		272,
		-1,
		275,
		265,
		249,
		234,
		267,
		-1,
		211,
		207,
		214,
		-1,
		224,
		-1,
		197,
		194,
		185,
		170,
		167,
		178,
		176,
		187,
		183,
		-1,
		284,
		269,
		262,
		252,
		266,
		237,
		-1,
		292,
		-1,
		-1,
		262,
		256,
		256,
		240,
		241,
		227,
		207,
		199,
		214,
		213,
		200,
		199,
		183,
		176,
		173,
		166,
		179,
		189,
		194,
		181,
		-1,
		-1,
		-1,
		289,
		275,
		279,
		239,
		258,
		-1,
		-1,
		324,
		279,
		265,
		-1,
		236,
		227,
		215,
		205,
		195,
		200,
		201,
		191,
		189,
		181,
		183,
		177,
		168,
		167,
		183,
		175,
		197,
		-1,
		-1,
		272,
		277,
		265,
		251,
		270,
		-1,
		-1,
		-1,
		271,
		287,
		255,
		234,
		216,
		-1,
		-1,
		199,
		192,
		186,
		189,
		177,
		197,
		192,
		176,
		161,
		176,
		180,
		188,
		179,
		-1,
		275,
		262,
		-1,
		-1,
		273,
		267,
		-1,
		-1,
		-1,
		-1,
		267,
		212,
		201,
		196,
		200,
		198,
		-1,
		172,
		183,
		176,
		195,
		202,
		178,
		163,
		157,
		163,
		175,
		184,
		-1,
		-1,
		287,
		-1,
		260,
		-1,
		-1,
		-1,
		-1,
		224,
		218,
		189,
		182,
		186,
		-1,
		174,
		176,
		173,
		185,
		181,
		178,
		169,
		160,
		156,
		160,
		164,
		178,
		182,
		310,
		-1,
		251,
		-1,
		-1,
		-1,
		242,
		257,
		228,
		205,
		178,
		173,
		166,
		160,
		165,
		176,
		185,
		196,
		161,
		163,
		153,
		152,
		156,
		173,
		177,
		-1,
		-1,
		249,
		245,
		268,
		250,
		254,
		255,
		-1,
		-1,
		182,
		173,
		164,
		156,
		169,
		172,
		157,
		159,
		159,
		157,
		151,
		161,
		176,
		171,
		-1,
		-1,
		-1,
		261,
		-1,
		263,
		-1,
		-1,
		252,
		253,
		200,
		182,
		178,
		176,
		165,
		159,
		147,
		152,
		162,
		156,
		153,
		147,
		151,
		174,
		163,
		202,
		-1,
		-1,
		292,
		-1,
		-1,
		-1,
		241,
		232,
		227,
		234,
		236,
		227,
		215,
		212,
		-1,
		182,
		188,
		153,
		160,
		143,
		150,
		155,
		152,
		141,
		148,
		164,
		163,
		158,
		194,
		185,
		191,
		-1,
		-1,
		285,
		274,
		263,
		269,
		-1,
		234,
		229,
		220,
		210,
		213,
		-1,
		-1,
		207,
		204,
		184,
		153,
		151,
		144,
		139,
		149,
		125,
		137,
		141,
		145,
		151,
		156,
		161,
		167,
		182,
		197,
		-1,
		239,
		276,
		269,
		237,
		245,
		276,
		-1,
		224,
		216,
		226,
		202,
		204,
		-1,
		-1,
		180,
		171,
		172,
		160,
		157,
		163,
		162,
		145,
		151,
		152,
		144,
		143,
		161,
		165,
		174,
		181,
		171,
		184,
		188,
		-1,
		232,
		252,
		231,
		234,
		258,
		272,
		-1,
		221,
		-1,
		-1,
		186,
		205,
		189,
		179,
		176,
		219,
		174,
		169,
		150,
		148,
		143,
		134,
		159,
		152,
		152,
		155,
		170,
		175,
		167,
		181,
		181,
		182,
		-1,
		221,
		232,
		225,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		-1,
		176,
		-1,
		216,
		-1,
		199,
		203,
		182,
		185,
		164,
		151,
		137,
		145,
		151,
		150,
		156,
		156,
		157,
		166,
		177,
		189,
		188,
		189,
		246,
		202,
		205,
		216,
		227,
		242,
		246,
		-1,
		210,
		246,
		182,
		-1,
		166,
		-1,
		-1,
		-1,
		213,
		195,
		187,
		184,
		163,
		163,
		129,
		133,
		146,
		153,
		163,
		174,
		166,
		170,
		183,
		194,
		197,
		242,
		233,
		246,
		191,
		191,
		212,
		221,
		242,
		206,
		203,
		240,
		189,
		178,
		173,
		160,
		-1,
		-1,
		197,
		205,
		-1,
		-1,
		170,
		137,
		125,
		135,
		139,
		153,
		165,
		178,
		166,
		171,
		165,
		197,
		-1,
		235,
		234,
		223,
		220,
		196,
		187,
		182,
		209,
		-1,
		-1,
		204,
		231,
		215,
		219,
		220,
		245,
		-1,
		149,
		-1,
		-1,
		177,
		-1,
		-1,
		162,
		142,
		131,
		122,
		127,
		147,
		158,
		180,
		162,
		179,
		170,
		180,
		184,
		219,
		216,
		204,
		202,
		225,
		190,
		178,
		-1,
		186,
		189,
		195,
		202,
		219,
		234,
		-1,
		-1,
		165,
		145,
		-1,
		-1,
		160,
		158,
		147,
		-1,
		137,
		119,
		124,
		154,
		156,
		158,
		165,
		159,
		166,
		174,
		185,
		177,
		228,
		242,
		231,
		227,
		226,
		234,
		183,
		176,
		183,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		-1,
		155,
		151,
		-1,
		-1,
		155,
		148,
		136,
		124,
		114,
		124,
		141,
		141,
		144,
		149,
		157,
		168,
		164,
		168,
		171,
		-1,
		262,
		-1,
		214,
		175,
		181,
		196,
		204,
		-1,
		-1,
		-1,
		172,
		158,
		151,
		139,
		137,
		-1,
		189,
		173,
		154,
		-1,
		124,
		137,
		177,
		145,
		150,
		145,
		160,
		171,
		162,
		170,
		164,
		167,
		-1,
		-1,
		174,
		157,
		-1,
		-1,
		131,
		133,
		-1,
		163,
		152,
		137,
		129,
		-1,
		-1,
		161,
		157,
		-1,
		-1,
		111,
		149,
		148,
		156,
		151,
		156,
		168,
		164,
		160,
		170,
		161,
		-1,
		-1,
		152,
		144,
		138,
		-1,
		116,
		-1,
		165,
		-1,
		132,
		138,
		126,
		-1,
		-1,
		-1,
		142,
		105,
		121,
		144,
		170,
		168,
		159,
		152,
		159,
		162,
		155,
		161,
		-1,
		-1,
		-1,
		134,
		108,
		172,
		163,
		146,
		126,
		118,
		137,
		-1,
		123,
		-1,
		98,
		101,
		126,
		165,
		167,
		153,
		149,
		162,
		156,
		153,
		151,
		140,
		-1,
		110,
		143,
		107,
		132,
		100,
		112,
		137,
		-1,
		120,
		102,
		-1,
		130,
		120,
		168,
		143,
		152,
		145,
		139,
		140,
		148,
		-1,
		-1,
		-1,
		112,
		111,
		103,
		97,
		97,
		95,
		104,
		-1,
		125,
		107,
		93,
		110,
		110,
		101,
		109,
		158,
		154,
		157,
		155,
		133,
		-1,
		169,
		-1,
		-1,
		135,
		-1,
		-1,
		-1,
		106,
		90,
		103,
		93,
		94,
		90,
		90,
		92,
		105,
		113,
		111,
		108,
		120,
		116,
		136,
		132,
		164,
		-1,
		164,
		-1,
		142,
		-1,
		-1,
		87,
		74,
		84,
		95,
		105,
		103,
		89,
		85,
		102,
		137,
		123,
		121,
		126,
		131,
		-1,
		153,
		152,
		-1,
		106,
		98,
		84,
		-1,
		65,
		-1,
		151,
		112,
		-1,
		86,
		80,
		-1,
		132,
		128,
		-1,
		-1,
		140,
		122,
		-1,
		-1,
		-1,
		85,
		49,
		146,
		130,
		-1,
		70,
		77,
		-1,
		-1,
		-1,
		125,
		126,
		-1,
		78,
		81,
		-1,
		45,
		36,
		48,
		63,
		71,
		-1,
		-1,
		-1,
		134,
		115,
		109,
		93,
		98,
		86,
		57,
		43,
		31,
		48,
		62,
		91,
		-1,
		-1,
		-1,
		106,
		98,
		97,
		-1,
		-1,
		0,
		17,
		39,
		57,
		-1,
		-1,
		-1,
		128,
		109,
		-1,
		-1,
		89,
		-1,
		-1,
		52,
		60,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		117,
		-1,
		-1,
		-1,
		85,
		81,
		63,
		-1,
		-1,
		-1,
		-1,
		138,
		139,
		163,
		133,
		-1,
		-1,
		-1,
		77,
		71,
		-1,
		-1,
		141,
		139,
		-1,
		-1,
		-1,
		105,
		89,
		-1,
		75,
		-1,
		-1,
		-1,
		96,
		-1,
		-1,
		108,
		-1,
		-1,
		-1,
		110,
		-1,
		110,
		85,
		92,
		-1,
		-1,
		-1,
		-1,
		123,
		115,
		123,
		-1,
		95,
		97,
		-1,
		145,
		-1,
		-1,
		138,
		129,
		-1,
		-1,
		100,
		107,
		129,
		132,
		168,
		-1,
		119
	],
	[
		-1,
		296,
		285,
		296,
		304,
		277,
		284,
		-1,
		303,
		307,
		273,
		267,
		306,
		275,
		281,
		292,
		-1,
		-1,
		-1,
		296,
		295,
		263,
		261,
		270,
		275,
		282,
		-1,
		281,
		-1,
		317,
		296,
		307,
		312,
		256,
		253,
		273,
		292,
		274,
		266,
		332,
		286,
		257,
		251,
		269,
		259,
		268,
		260,
		-1,
		257,
		247,
		269,
		248,
		259,
		251,
		-1,
		-1,
		251,
		252,
		258,
		244,
		250,
		246,
		-1,
		256,
		240,
		-1,
		-1,
		241,
		242,
		226,
		229,
		237,
		235,
		248,
		240,
		235,
		-1,
		-1,
		232,
		228,
		235,
		222,
		218,
		235,
		248,
		230,
		244,
		243,
		-1,
		236,
		254,
		261,
		229,
		227,
		211,
		209,
		227,
		229,
		235,
		235,
		-1,
		245,
		246,
		241,
		249,
		251,
		227,
		214,
		214,
		224,
		217,
		236,
		224,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		245,
		228,
		245,
		237,
		227,
		242,
		235,
		217,
		214,
		212,
		209,
		225,
		223,
		233,
		-1,
		-1,
		338,
		307,
		336,
		294,
		275,
		-1,
		241,
		221,
		227,
		231,
		225,
		218,
		232,
		228,
		-1,
		203,
		202,
		230,
		216,
		227,
		298,
		-1,
		-1,
		296,
		288,
		271,
		274,
		251,
		247,
		236,
		235,
		227,
		213,
		209,
		215,
		218,
		218,
		224,
		197,
		207,
		211,
		209,
		234,
		-1,
		-1,
		269,
		-1,
		-1,
		295,
		278,
		-1,
		261,
		268,
		257,
		263,
		249,
		270,
		246,
		237,
		229,
		223,
		211,
		213,
		210,
		223,
		211,
		194,
		219,
		223,
		204,
		225,
		220,
		-1,
		268,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		273,
		254,
		257,
		263,
		287,
		286,
		-1,
		258,
		246,
		247,
		232,
		229,
		216,
		204,
		217,
		202,
		209,
		208,
		198,
		196,
		226,
		201,
		223,
		220,
		239,
		244,
		238,
		247,
		-1,
		303,
		299,
		295,
		302,
		251,
		-1,
		-1,
		291,
		-1,
		294,
		295,
		270,
		243,
		246,
		233,
		224,
		211,
		200,
		211,
		200,
		197,
		205,
		190,
		205,
		196,
		195,
		213,
		223,
		231,
		235,
		241,
		-1,
		353,
		-1,
		295,
		279,
		281,
		253,
		274,
		-1,
		311,
		295,
		287,
		272,
		272,
		-1,
		242,
		239,
		229,
		207,
		192,
		209,
		201,
		199,
		203,
		185,
		199,
		190,
		208,
		215,
		213,
		217,
		237,
		249,
		313,
		303,
		-1,
		285,
		290,
		249,
		257,
		276,
		314,
		278,
		-1,
		273,
		-1,
		244,
		257,
		-1,
		213,
		209,
		191,
		192,
		187,
		202,
		196,
		181,
		178,
		196,
		199,
		206,
		210,
		226,
		-1,
		-1,
		298,
		302,
		291,
		242,
		261,
		285,
		322,
		271,
		260,
		259,
		-1,
		250,
		227,
		224,
		212,
		199,
		184,
		185,
		193,
		206,
		185,
		180,
		177,
		197,
		223,
		201,
		213,
		-1,
		-1,
		-1,
		323,
		-1,
		-1,
		268,
		239,
		263,
		305,
		289,
		282,
		270,
		235,
		235,
		229,
		-1,
		223,
		202,
		193,
		182,
		180,
		193,
		190,
		195,
		175,
		173,
		192,
		204,
		195,
		212,
		-1,
		-1,
		-1,
		298,
		287,
		288,
		234,
		257,
		294,
		268,
		254,
		259,
		234,
		227,
		221,
		236,
		219,
		200,
		189,
		181,
		170,
		186,
		194,
		189,
		171,
		180,
		186,
		210,
		200,
		206,
		-1,
		-1,
		305,
		295,
		279,
		281,
		278,
		248,
		255,
		287,
		259,
		272,
		-1,
		226,
		-1,
		215,
		210,
		194,
		189,
		186,
		183,
		177,
		186,
		188,
		178,
		173,
		180,
		215,
		215,
		190,
		210,
		213,
		-1,
		-1,
		-1,
		298,
		293,
		268,
		245,
		229,
		265,
		-1,
		242,
		243,
		-1,
		220,
		214,
		211,
		196,
		192,
		187,
		191,
		184,
		191,
		184,
		182,
		183,
		165,
		197,
		-1,
		198,
		192,
		200,
		190,
		178,
		-1,
		-1,
		-1,
		291,
		270,
		263,
		283,
		224,
		276,
		-1,
		-1,
		227,
		220,
		-1,
		207,
		189,
		196,
		194,
		188,
		192,
		189,
		178,
		191,
		184,
		170,
		172,
		185,
		189,
		193,
		180,
		176,
		173,
		187,
		-1,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		224,
		244,
		-1,
		236,
		228,
		218,
		212,
		206,
		202,
		200,
		216,
		200,
		203,
		201,
		192,
		200,
		173,
		166,
		173,
		162,
		180,
		188,
		180,
		174,
		173,
		183,
		-1,
		311,
		297,
		268,
		-1,
		-1,
		257,
		-1,
		221,
		235,
		251,
		-1,
		244,
		223,
		238,
		216,
		212,
		208,
		223,
		224,
		201,
		201,
		199,
		190,
		178,
		167,
		170,
		162,
		184,
		184,
		168,
		169,
		173,
		-1,
		317,
		304,
		262,
		258,
		247,
		267,
		218,
		206,
		238,
		-1,
		-1,
		280,
		-1,
		214,
		231,
		222,
		220,
		213,
		195,
		202,
		210,
		187,
		182,
		172,
		161,
		161,
		156,
		178,
		164,
		162,
		171,
		187,
		-1,
		-1,
		-1,
		284,
		-1,
		-1,
		233,
		220,
		214,
		-1,
		255,
		-1,
		258,
		248,
		232,
		217,
		250,
		-1,
		194,
		190,
		197,
		-1,
		207,
		-1,
		180,
		177,
		168,
		153,
		150,
		161,
		159,
		170,
		166,
		-1,
		267,
		252,
		245,
		235,
		249,
		220,
		-1,
		275,
		-1,
		-1,
		245,
		239,
		239,
		223,
		224,
		210,
		190,
		182,
		197,
		196,
		183,
		182,
		166,
		159,
		156,
		149,
		162,
		172,
		177,
		164,
		-1,
		-1,
		-1,
		272,
		258,
		262,
		222,
		241,
		-1,
		-1,
		307,
		262,
		248,
		-1,
		219,
		210,
		198,
		188,
		178,
		183,
		184,
		174,
		172,
		164,
		166,
		160,
		151,
		150,
		166,
		158,
		180,
		-1,
		-1,
		255,
		260,
		248,
		234,
		253,
		-1,
		-1,
		-1,
		254,
		270,
		238,
		217,
		199,
		-1,
		-1,
		182,
		175,
		169,
		172,
		160,
		180,
		175,
		159,
		144,
		159,
		163,
		171,
		162,
		-1,
		258,
		245,
		-1,
		-1,
		256,
		250,
		-1,
		-1,
		-1,
		-1,
		250,
		195,
		184,
		179,
		183,
		181,
		-1,
		155,
		166,
		159,
		178,
		185,
		161,
		146,
		140,
		146,
		158,
		167,
		-1,
		-1,
		270,
		-1,
		243,
		-1,
		-1,
		-1,
		-1,
		207,
		201,
		172,
		165,
		169,
		-1,
		157,
		159,
		156,
		168,
		164,
		161,
		152,
		143,
		139,
		143,
		147,
		161,
		165,
		293,
		-1,
		234,
		-1,
		-1,
		-1,
		225,
		240,
		211,
		188,
		161,
		156,
		149,
		143,
		148,
		159,
		168,
		179,
		144,
		146,
		136,
		135,
		139,
		156,
		160,
		-1,
		-1,
		232,
		228,
		251,
		233,
		237,
		238,
		-1,
		-1,
		165,
		156,
		147,
		139,
		152,
		155,
		140,
		142,
		142,
		140,
		134,
		144,
		159,
		154,
		-1,
		-1,
		-1,
		244,
		-1,
		246,
		-1,
		-1,
		235,
		236,
		183,
		165,
		161,
		159,
		148,
		142,
		130,
		135,
		145,
		139,
		136,
		130,
		134,
		157,
		146,
		185,
		-1,
		-1,
		275,
		-1,
		-1,
		-1,
		224,
		215,
		210,
		217,
		219,
		210,
		198,
		195,
		-1,
		165,
		171,
		136,
		143,
		126,
		133,
		138,
		135,
		124,
		131,
		147,
		146,
		141,
		177,
		168,
		174,
		-1,
		-1,
		268,
		257,
		246,
		252,
		-1,
		217,
		212,
		203,
		193,
		196,
		-1,
		-1,
		190,
		187,
		167,
		136,
		134,
		127,
		122,
		132,
		108,
		120,
		124,
		128,
		134,
		139,
		144,
		150,
		165,
		180,
		-1,
		222,
		259,
		252,
		220,
		228,
		259,
		-1,
		207,
		199,
		209,
		185,
		187,
		-1,
		-1,
		163,
		154,
		155,
		143,
		140,
		146,
		145,
		128,
		134,
		135,
		127,
		126,
		144,
		148,
		157,
		164,
		154,
		167,
		171,
		-1,
		215,
		235,
		214,
		217,
		241,
		255,
		-1,
		204,
		-1,
		-1,
		169,
		188,
		172,
		162,
		159,
		202,
		157,
		152,
		133,
		131,
		126,
		117,
		142,
		135,
		135,
		138,
		153,
		158,
		150,
		164,
		164,
		165,
		-1,
		204,
		215,
		208,
		-1,
		-1,
		-1,
		-1,
		203,
		-1,
		-1,
		159,
		-1,
		199,
		-1,
		182,
		186,
		165,
		168,
		147,
		134,
		120,
		128,
		134,
		133,
		139,
		139,
		140,
		149,
		160,
		172,
		171,
		172,
		229,
		185,
		188,
		199,
		210,
		225,
		229,
		-1,
		193,
		229,
		165,
		-1,
		149,
		-1,
		-1,
		-1,
		196,
		178,
		170,
		167,
		146,
		146,
		112,
		116,
		129,
		136,
		146,
		157,
		149,
		153,
		166,
		177,
		180,
		225,
		216,
		229,
		174,
		174,
		195,
		204,
		225,
		189,
		186,
		223,
		172,
		161,
		156,
		143,
		-1,
		-1,
		180,
		188,
		-1,
		-1,
		153,
		120,
		108,
		118,
		122,
		136,
		148,
		161,
		149,
		154,
		148,
		180,
		-1,
		218,
		217,
		206,
		203,
		179,
		170,
		165,
		192,
		-1,
		-1,
		187,
		214,
		198,
		202,
		203,
		228,
		-1,
		132,
		-1,
		-1,
		160,
		-1,
		-1,
		145,
		125,
		114,
		105,
		110,
		130,
		141,
		163,
		145,
		162,
		153,
		163,
		167,
		202,
		199,
		187,
		185,
		208,
		173,
		161,
		-1,
		169,
		172,
		178,
		185,
		202,
		217,
		-1,
		-1,
		148,
		128,
		-1,
		-1,
		143,
		141,
		130,
		-1,
		120,
		102,
		107,
		137,
		139,
		141,
		148,
		142,
		149,
		157,
		168,
		160,
		211,
		225,
		214,
		210,
		209,
		217,
		166,
		159,
		166,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		153,
		-1,
		138,
		134,
		-1,
		-1,
		138,
		131,
		119,
		107,
		97,
		107,
		124,
		124,
		127,
		132,
		140,
		151,
		147,
		151,
		154,
		-1,
		245,
		-1,
		197,
		158,
		164,
		179,
		187,
		-1,
		-1,
		-1,
		155,
		141,
		134,
		122,
		120,
		-1,
		172,
		156,
		137,
		-1,
		107,
		120,
		160,
		128,
		133,
		128,
		143,
		154,
		145,
		153,
		147,
		150,
		-1,
		-1,
		157,
		140,
		-1,
		-1,
		114,
		116,
		-1,
		146,
		135,
		120,
		112,
		-1,
		-1,
		144,
		140,
		-1,
		-1,
		94,
		132,
		131,
		139,
		134,
		139,
		151,
		147,
		143,
		153,
		144,
		-1,
		-1,
		135,
		127,
		121,
		-1,
		99,
		-1,
		148,
		-1,
		115,
		121,
		109,
		-1,
		-1,
		-1,
		125,
		88,
		104,
		127,
		153,
		151,
		142,
		135,
		142,
		145,
		138,
		144,
		-1,
		-1,
		-1,
		117,
		91,
		155,
		146,
		129,
		109,
		101,
		120,
		-1,
		106,
		-1,
		81,
		84,
		109,
		148,
		150,
		136,
		132,
		145,
		139,
		136,
		134,
		123,
		-1,
		93,
		126,
		90,
		115,
		83,
		95,
		120,
		-1,
		103,
		85,
		-1,
		113,
		103,
		151,
		126,
		135,
		128,
		122,
		123,
		131,
		-1,
		-1,
		-1,
		95,
		94,
		86,
		80,
		80,
		78,
		87,
		-1,
		108,
		90,
		76,
		93,
		93,
		84,
		92,
		141,
		137,
		140,
		138,
		116,
		-1,
		152,
		-1,
		-1,
		118,
		-1,
		-1,
		-1,
		89,
		73,
		86,
		76,
		77,
		73,
		73,
		75,
		88,
		96,
		94,
		91,
		103,
		99,
		119,
		115,
		147,
		-1,
		147,
		-1,
		125,
		-1,
		-1,
		70,
		57,
		67,
		78,
		88,
		86,
		72,
		68,
		85,
		120,
		106,
		104,
		109,
		114,
		-1,
		136,
		135,
		-1,
		89,
		81,
		67,
		-1,
		48,
		-1,
		134,
		95,
		-1,
		69,
		63,
		-1,
		115,
		111,
		-1,
		-1,
		123,
		105,
		-1,
		-1,
		-1,
		68,
		32,
		129,
		113,
		-1,
		53,
		60,
		-1,
		-1,
		-1,
		108,
		109,
		-1,
		61,
		64,
		-1,
		28,
		19,
		31,
		46,
		54,
		-1,
		-1,
		-1,
		117,
		98,
		92,
		76,
		81,
		69,
		40,
		26,
		14,
		31,
		45,
		74,
		-1,
		-1,
		-1,
		89,
		81,
		80,
		-1,
		-1,
		17,
		0,
		22,
		40,
		-1,
		-1,
		-1,
		111,
		92,
		-1,
		-1,
		72,
		-1,
		-1,
		35,
		43,
		-1,
		-1,
		-1,
		-1,
		-1,
		127,
		100,
		-1,
		-1,
		-1,
		68,
		64,
		46,
		-1,
		-1,
		-1,
		-1,
		121,
		122,
		146,
		116,
		-1,
		-1,
		-1,
		60,
		54,
		-1,
		-1,
		124,
		122,
		-1,
		-1,
		-1,
		88,
		72,
		-1,
		58,
		-1,
		-1,
		-1,
		79,
		-1,
		-1,
		91,
		-1,
		-1,
		-1,
		93,
		-1,
		93,
		68,
		75,
		-1,
		-1,
		-1,
		-1,
		106,
		98,
		106,
		-1,
		78,
		80,
		-1,
		128,
		-1,
		-1,
		121,
		112,
		-1,
		-1,
		83,
		90,
		112,
		115,
		151,
		-1,
		102
	],
	[
		-1,
		284,
		273,
		284,
		292,
		265,
		272,
		-1,
		291,
		295,
		261,
		255,
		294,
		263,
		269,
		280,
		-1,
		-1,
		-1,
		284,
		283,
		251,
		249,
		258,
		263,
		270,
		-1,
		269,
		-1,
		305,
		284,
		295,
		300,
		244,
		241,
		261,
		280,
		262,
		254,
		320,
		274,
		245,
		239,
		257,
		247,
		256,
		248,
		-1,
		245,
		235,
		257,
		236,
		247,
		239,
		-1,
		-1,
		239,
		240,
		246,
		232,
		238,
		234,
		-1,
		244,
		228,
		-1,
		-1,
		229,
		230,
		214,
		217,
		225,
		223,
		236,
		228,
		223,
		-1,
		-1,
		220,
		216,
		223,
		210,
		206,
		223,
		236,
		218,
		232,
		231,
		-1,
		224,
		242,
		249,
		217,
		215,
		199,
		197,
		215,
		217,
		223,
		223,
		-1,
		233,
		234,
		229,
		237,
		239,
		215,
		202,
		202,
		212,
		205,
		224,
		212,
		258,
		-1,
		-1,
		-1,
		-1,
		-1,
		267,
		233,
		216,
		233,
		225,
		215,
		230,
		223,
		205,
		202,
		200,
		197,
		213,
		211,
		221,
		-1,
		-1,
		326,
		295,
		324,
		282,
		263,
		-1,
		229,
		209,
		215,
		219,
		213,
		206,
		220,
		216,
		-1,
		191,
		190,
		218,
		204,
		215,
		286,
		-1,
		-1,
		284,
		276,
		259,
		262,
		239,
		235,
		224,
		223,
		215,
		201,
		197,
		203,
		206,
		206,
		212,
		185,
		195,
		199,
		197,
		222,
		-1,
		-1,
		257,
		-1,
		-1,
		283,
		266,
		-1,
		249,
		256,
		245,
		251,
		237,
		258,
		234,
		225,
		217,
		211,
		199,
		201,
		198,
		211,
		199,
		182,
		207,
		211,
		192,
		213,
		208,
		-1,
		256,
		240,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		242,
		245,
		251,
		275,
		274,
		-1,
		246,
		234,
		235,
		220,
		217,
		204,
		192,
		205,
		190,
		197,
		196,
		186,
		184,
		214,
		189,
		211,
		208,
		227,
		232,
		226,
		235,
		-1,
		291,
		287,
		283,
		290,
		239,
		-1,
		-1,
		279,
		-1,
		282,
		283,
		258,
		231,
		234,
		221,
		212,
		199,
		188,
		199,
		188,
		185,
		193,
		178,
		193,
		184,
		183,
		201,
		211,
		219,
		223,
		229,
		-1,
		341,
		-1,
		283,
		267,
		269,
		241,
		262,
		-1,
		299,
		283,
		275,
		260,
		260,
		-1,
		230,
		227,
		217,
		195,
		180,
		197,
		189,
		187,
		191,
		173,
		187,
		178,
		196,
		203,
		201,
		205,
		225,
		237,
		301,
		291,
		-1,
		273,
		278,
		237,
		245,
		264,
		302,
		266,
		-1,
		261,
		-1,
		232,
		245,
		-1,
		201,
		197,
		179,
		180,
		175,
		190,
		184,
		169,
		166,
		184,
		187,
		194,
		198,
		214,
		-1,
		-1,
		286,
		290,
		279,
		230,
		249,
		273,
		310,
		259,
		248,
		247,
		-1,
		238,
		215,
		212,
		200,
		187,
		172,
		173,
		181,
		194,
		173,
		168,
		165,
		185,
		211,
		189,
		201,
		-1,
		-1,
		-1,
		311,
		-1,
		-1,
		256,
		227,
		251,
		293,
		277,
		270,
		258,
		223,
		223,
		217,
		-1,
		211,
		190,
		181,
		170,
		168,
		181,
		178,
		183,
		163,
		161,
		180,
		192,
		183,
		200,
		-1,
		-1,
		-1,
		286,
		275,
		276,
		222,
		245,
		282,
		256,
		242,
		247,
		222,
		215,
		209,
		224,
		207,
		188,
		177,
		169,
		158,
		174,
		182,
		177,
		159,
		168,
		174,
		198,
		188,
		194,
		-1,
		-1,
		293,
		283,
		267,
		269,
		266,
		236,
		243,
		275,
		247,
		260,
		-1,
		214,
		-1,
		203,
		198,
		182,
		177,
		174,
		171,
		165,
		174,
		176,
		166,
		161,
		168,
		203,
		203,
		178,
		198,
		201,
		-1,
		-1,
		-1,
		286,
		281,
		256,
		233,
		217,
		253,
		-1,
		230,
		231,
		-1,
		208,
		202,
		199,
		184,
		180,
		175,
		179,
		172,
		179,
		172,
		170,
		171,
		153,
		185,
		-1,
		186,
		180,
		188,
		178,
		166,
		-1,
		-1,
		-1,
		279,
		258,
		251,
		271,
		212,
		264,
		-1,
		-1,
		215,
		208,
		-1,
		195,
		177,
		184,
		182,
		176,
		180,
		177,
		166,
		179,
		172,
		158,
		160,
		173,
		177,
		181,
		168,
		164,
		161,
		175,
		-1,
		298,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		232,
		-1,
		224,
		216,
		206,
		200,
		194,
		190,
		188,
		204,
		188,
		191,
		189,
		180,
		188,
		161,
		154,
		161,
		150,
		168,
		176,
		168,
		162,
		161,
		171,
		-1,
		299,
		285,
		256,
		-1,
		-1,
		245,
		-1,
		209,
		223,
		239,
		-1,
		232,
		211,
		226,
		204,
		200,
		196,
		211,
		212,
		189,
		189,
		187,
		178,
		166,
		155,
		158,
		150,
		172,
		172,
		156,
		157,
		161,
		-1,
		305,
		292,
		250,
		246,
		235,
		255,
		206,
		194,
		226,
		-1,
		-1,
		268,
		-1,
		202,
		219,
		210,
		208,
		201,
		183,
		190,
		198,
		175,
		170,
		160,
		149,
		149,
		144,
		166,
		152,
		150,
		159,
		175,
		-1,
		-1,
		-1,
		272,
		-1,
		-1,
		221,
		208,
		202,
		-1,
		243,
		-1,
		246,
		236,
		220,
		205,
		238,
		-1,
		182,
		178,
		185,
		-1,
		195,
		-1,
		168,
		165,
		156,
		141,
		138,
		149,
		147,
		158,
		154,
		-1,
		255,
		240,
		233,
		223,
		237,
		208,
		-1,
		263,
		-1,
		-1,
		233,
		227,
		227,
		211,
		212,
		198,
		178,
		170,
		185,
		184,
		171,
		170,
		154,
		147,
		144,
		137,
		150,
		160,
		165,
		152,
		-1,
		-1,
		-1,
		260,
		246,
		250,
		210,
		229,
		-1,
		-1,
		295,
		250,
		236,
		-1,
		207,
		198,
		186,
		176,
		166,
		171,
		172,
		162,
		160,
		152,
		154,
		148,
		139,
		138,
		154,
		146,
		168,
		-1,
		-1,
		243,
		248,
		236,
		222,
		241,
		-1,
		-1,
		-1,
		242,
		258,
		226,
		205,
		187,
		-1,
		-1,
		170,
		163,
		157,
		160,
		148,
		168,
		163,
		147,
		132,
		147,
		151,
		159,
		150,
		-1,
		246,
		233,
		-1,
		-1,
		244,
		238,
		-1,
		-1,
		-1,
		-1,
		238,
		183,
		172,
		167,
		171,
		169,
		-1,
		143,
		154,
		147,
		166,
		173,
		149,
		134,
		128,
		134,
		146,
		155,
		-1,
		-1,
		258,
		-1,
		231,
		-1,
		-1,
		-1,
		-1,
		195,
		189,
		160,
		153,
		157,
		-1,
		145,
		147,
		144,
		156,
		152,
		149,
		140,
		131,
		127,
		131,
		135,
		149,
		153,
		281,
		-1,
		222,
		-1,
		-1,
		-1,
		213,
		228,
		199,
		176,
		149,
		144,
		137,
		131,
		136,
		147,
		156,
		167,
		132,
		134,
		124,
		123,
		127,
		144,
		148,
		-1,
		-1,
		220,
		216,
		239,
		221,
		225,
		226,
		-1,
		-1,
		153,
		144,
		135,
		127,
		140,
		143,
		128,
		130,
		130,
		128,
		122,
		132,
		147,
		142,
		-1,
		-1,
		-1,
		232,
		-1,
		234,
		-1,
		-1,
		223,
		224,
		171,
		153,
		149,
		147,
		136,
		130,
		118,
		123,
		133,
		127,
		124,
		118,
		122,
		145,
		134,
		173,
		-1,
		-1,
		276,
		-1,
		-1,
		-1,
		212,
		203,
		198,
		205,
		207,
		198,
		186,
		183,
		-1,
		153,
		159,
		124,
		131,
		114,
		121,
		126,
		123,
		112,
		119,
		135,
		134,
		129,
		165,
		156,
		162,
		-1,
		-1,
		269,
		258,
		247,
		253,
		-1,
		205,
		200,
		191,
		181,
		184,
		-1,
		-1,
		178,
		175,
		155,
		124,
		122,
		115,
		110,
		120,
		96,
		108,
		112,
		116,
		122,
		127,
		132,
		138,
		153,
		168,
		-1,
		223,
		260,
		253,
		221,
		229,
		260,
		-1,
		195,
		187,
		197,
		173,
		175,
		-1,
		-1,
		151,
		142,
		143,
		131,
		128,
		134,
		133,
		116,
		122,
		123,
		115,
		114,
		132,
		136,
		145,
		152,
		142,
		155,
		159,
		-1,
		216,
		236,
		215,
		218,
		242,
		256,
		-1,
		192,
		-1,
		-1,
		157,
		176,
		160,
		150,
		147,
		190,
		145,
		140,
		121,
		119,
		114,
		105,
		130,
		123,
		123,
		126,
		141,
		146,
		138,
		152,
		152,
		153,
		-1,
		205,
		216,
		209,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		-1,
		147,
		-1,
		187,
		-1,
		170,
		174,
		153,
		156,
		135,
		122,
		108,
		116,
		122,
		121,
		127,
		127,
		128,
		137,
		148,
		160,
		159,
		160,
		230,
		186,
		189,
		200,
		211,
		226,
		230,
		-1,
		194,
		230,
		153,
		-1,
		137,
		-1,
		-1,
		-1,
		184,
		166,
		158,
		155,
		134,
		134,
		100,
		104,
		117,
		124,
		134,
		145,
		137,
		141,
		154,
		165,
		168,
		226,
		217,
		230,
		175,
		175,
		196,
		205,
		226,
		190,
		187,
		224,
		160,
		149,
		144,
		131,
		-1,
		-1,
		168,
		176,
		-1,
		-1,
		141,
		108,
		96,
		106,
		110,
		124,
		136,
		149,
		137,
		142,
		136,
		168,
		-1,
		219,
		218,
		207,
		204,
		180,
		171,
		166,
		193,
		-1,
		-1,
		188,
		215,
		199,
		193,
		191,
		216,
		-1,
		120,
		-1,
		-1,
		148,
		-1,
		-1,
		133,
		113,
		102,
		93,
		98,
		118,
		129,
		151,
		133,
		150,
		141,
		151,
		155,
		203,
		200,
		188,
		186,
		209,
		174,
		162,
		-1,
		170,
		173,
		179,
		186,
		194,
		205,
		-1,
		-1,
		136,
		116,
		-1,
		-1,
		131,
		129,
		118,
		-1,
		108,
		90,
		95,
		125,
		127,
		129,
		136,
		130,
		137,
		145,
		156,
		148,
		212,
		226,
		215,
		211,
		210,
		218,
		167,
		160,
		167,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		141,
		-1,
		126,
		122,
		-1,
		-1,
		126,
		119,
		107,
		95,
		85,
		95,
		112,
		112,
		115,
		120,
		128,
		139,
		135,
		139,
		142,
		-1,
		246,
		-1,
		198,
		159,
		165,
		180,
		188,
		-1,
		-1,
		-1,
		143,
		129,
		122,
		110,
		108,
		-1,
		160,
		144,
		125,
		-1,
		95,
		108,
		148,
		116,
		121,
		116,
		131,
		142,
		133,
		141,
		135,
		138,
		-1,
		-1,
		158,
		141,
		-1,
		-1,
		115,
		117,
		-1,
		134,
		123,
		108,
		100,
		-1,
		-1,
		132,
		128,
		-1,
		-1,
		82,
		120,
		119,
		127,
		122,
		127,
		139,
		135,
		131,
		141,
		132,
		-1,
		-1,
		136,
		128,
		122,
		-1,
		100,
		-1,
		136,
		-1,
		103,
		109,
		97,
		-1,
		-1,
		-1,
		113,
		76,
		92,
		115,
		141,
		139,
		130,
		123,
		130,
		133,
		126,
		132,
		-1,
		-1,
		-1,
		118,
		92,
		143,
		134,
		117,
		97,
		89,
		108,
		-1,
		94,
		-1,
		69,
		72,
		97,
		136,
		138,
		124,
		120,
		133,
		127,
		124,
		122,
		124,
		-1,
		94,
		127,
		91,
		103,
		79,
		83,
		108,
		-1,
		91,
		73,
		-1,
		101,
		91,
		139,
		114,
		123,
		116,
		110,
		111,
		119,
		-1,
		-1,
		-1,
		96,
		95,
		87,
		81,
		81,
		79,
		75,
		-1,
		96,
		78,
		64,
		81,
		81,
		72,
		80,
		129,
		125,
		128,
		126,
		104,
		-1,
		146,
		-1,
		-1,
		119,
		-1,
		-1,
		-1,
		90,
		74,
		76,
		64,
		65,
		61,
		61,
		63,
		76,
		84,
		82,
		79,
		91,
		87,
		107,
		103,
		135,
		-1,
		141,
		-1,
		126,
		-1,
		-1,
		71,
		58,
		68,
		79,
		76,
		74,
		60,
		56,
		73,
		108,
		94,
		92,
		97,
		102,
		-1,
		130,
		129,
		-1,
		90,
		82,
		68,
		-1,
		49,
		-1,
		122,
		83,
		-1,
		57,
		51,
		-1,
		103,
		99,
		-1,
		-1,
		117,
		106,
		-1,
		-1,
		-1,
		69,
		33,
		117,
		101,
		-1,
		41,
		48,
		-1,
		-1,
		-1,
		102,
		103,
		-1,
		62,
		65,
		-1,
		29,
		20,
		28,
		34,
		42,
		-1,
		-1,
		-1,
		111,
		92,
		86,
		77,
		82,
		70,
		41,
		27,
		11,
		19,
		33,
		62,
		-1,
		-1,
		-1,
		83,
		75,
		68,
		-1,
		-1,
		36,
		19,
		0,
		28,
		-1,
		-1,
		-1,
		105,
		86,
		-1,
		-1,
		60,
		-1,
		-1,
		32,
		31,
		-1,
		-1,
		-1,
		-1,
		-1,
		122,
		94,
		-1,
		-1,
		-1,
		56,
		52,
		43,
		-1,
		-1,
		-1,
		-1,
		116,
		117,
		140,
		104,
		-1,
		-1,
		-1,
		48,
		42,
		-1,
		-1,
		119,
		117,
		-1,
		-1,
		-1,
		76,
		60,
		-1,
		46,
		-1,
		-1,
		-1,
		67,
		-1,
		-1,
		79,
		-1,
		-1,
		-1,
		81,
		-1,
		81,
		56,
		63,
		-1,
		-1,
		-1,
		-1,
		94,
		86,
		94,
		-1,
		66,
		68,
		-1,
		116,
		-1,
		-1,
		109,
		100,
		-1,
		-1,
		71,
		78,
		100,
		103,
		139,
		-1,
		90
	],
	[
		-1,
		274,
		263,
		274,
		282,
		255,
		262,
		-1,
		281,
		285,
		251,
		245,
		284,
		253,
		259,
		270,
		-1,
		-1,
		-1,
		274,
		273,
		241,
		239,
		248,
		253,
		260,
		-1,
		259,
		-1,
		295,
		274,
		285,
		290,
		234,
		231,
		251,
		270,
		252,
		244,
		310,
		264,
		235,
		229,
		247,
		237,
		246,
		238,
		-1,
		235,
		225,
		247,
		226,
		237,
		229,
		-1,
		-1,
		229,
		230,
		236,
		222,
		228,
		224,
		-1,
		234,
		218,
		-1,
		-1,
		219,
		220,
		204,
		207,
		215,
		213,
		226,
		218,
		213,
		-1,
		-1,
		210,
		206,
		213,
		200,
		196,
		213,
		226,
		208,
		222,
		221,
		-1,
		214,
		232,
		239,
		207,
		205,
		189,
		187,
		205,
		207,
		213,
		213,
		-1,
		223,
		224,
		219,
		227,
		229,
		205,
		192,
		192,
		202,
		195,
		214,
		202,
		248,
		-1,
		-1,
		-1,
		-1,
		-1,
		257,
		223,
		206,
		223,
		215,
		205,
		220,
		213,
		195,
		192,
		190,
		187,
		203,
		201,
		211,
		-1,
		-1,
		316,
		285,
		314,
		272,
		253,
		-1,
		219,
		199,
		205,
		209,
		203,
		196,
		210,
		206,
		-1,
		181,
		180,
		208,
		194,
		205,
		276,
		-1,
		-1,
		274,
		266,
		249,
		252,
		229,
		225,
		214,
		213,
		205,
		191,
		187,
		193,
		196,
		196,
		202,
		175,
		185,
		189,
		187,
		212,
		-1,
		-1,
		247,
		-1,
		-1,
		273,
		256,
		-1,
		239,
		246,
		235,
		241,
		227,
		248,
		224,
		215,
		207,
		201,
		189,
		191,
		188,
		201,
		189,
		172,
		197,
		201,
		182,
		203,
		198,
		-1,
		246,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		251,
		232,
		235,
		241,
		265,
		264,
		-1,
		236,
		224,
		225,
		210,
		207,
		194,
		182,
		195,
		180,
		187,
		186,
		176,
		174,
		204,
		179,
		201,
		198,
		217,
		222,
		216,
		225,
		-1,
		281,
		277,
		273,
		280,
		229,
		-1,
		-1,
		269,
		-1,
		272,
		273,
		248,
		221,
		224,
		211,
		202,
		189,
		178,
		189,
		178,
		175,
		183,
		168,
		183,
		174,
		173,
		191,
		201,
		209,
		213,
		219,
		-1,
		331,
		-1,
		273,
		257,
		259,
		231,
		252,
		-1,
		289,
		273,
		265,
		250,
		250,
		-1,
		220,
		217,
		207,
		185,
		170,
		187,
		179,
		177,
		181,
		163,
		177,
		168,
		186,
		193,
		191,
		195,
		215,
		227,
		291,
		281,
		-1,
		263,
		268,
		227,
		235,
		254,
		292,
		256,
		-1,
		251,
		-1,
		222,
		235,
		-1,
		191,
		187,
		169,
		170,
		165,
		180,
		174,
		159,
		156,
		174,
		177,
		184,
		188,
		204,
		-1,
		-1,
		276,
		280,
		269,
		220,
		239,
		263,
		300,
		249,
		238,
		237,
		-1,
		228,
		205,
		202,
		190,
		177,
		162,
		163,
		171,
		184,
		163,
		158,
		155,
		175,
		201,
		179,
		191,
		-1,
		-1,
		-1,
		301,
		-1,
		-1,
		246,
		217,
		241,
		283,
		267,
		260,
		248,
		213,
		213,
		207,
		-1,
		201,
		180,
		171,
		160,
		158,
		171,
		168,
		173,
		153,
		151,
		170,
		182,
		173,
		190,
		-1,
		-1,
		-1,
		276,
		265,
		266,
		212,
		235,
		272,
		246,
		232,
		237,
		212,
		205,
		199,
		214,
		197,
		178,
		167,
		159,
		148,
		164,
		172,
		167,
		149,
		158,
		164,
		188,
		178,
		184,
		-1,
		-1,
		283,
		273,
		257,
		259,
		256,
		226,
		233,
		265,
		237,
		250,
		-1,
		204,
		-1,
		193,
		188,
		172,
		167,
		164,
		161,
		155,
		164,
		166,
		156,
		151,
		158,
		193,
		193,
		168,
		188,
		191,
		-1,
		-1,
		-1,
		276,
		271,
		246,
		223,
		207,
		243,
		-1,
		220,
		221,
		-1,
		198,
		192,
		189,
		174,
		170,
		165,
		169,
		162,
		169,
		162,
		160,
		161,
		143,
		175,
		-1,
		176,
		170,
		178,
		168,
		156,
		-1,
		-1,
		-1,
		269,
		248,
		241,
		261,
		202,
		254,
		-1,
		-1,
		205,
		198,
		-1,
		185,
		167,
		174,
		172,
		166,
		170,
		167,
		156,
		169,
		162,
		148,
		150,
		163,
		167,
		171,
		158,
		154,
		151,
		165,
		-1,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		202,
		222,
		-1,
		214,
		206,
		196,
		190,
		184,
		180,
		178,
		194,
		178,
		181,
		179,
		170,
		178,
		151,
		144,
		151,
		140,
		158,
		166,
		158,
		152,
		151,
		161,
		-1,
		289,
		275,
		246,
		-1,
		-1,
		235,
		-1,
		199,
		213,
		229,
		-1,
		222,
		201,
		216,
		194,
		190,
		186,
		201,
		202,
		179,
		179,
		177,
		168,
		156,
		145,
		148,
		140,
		162,
		162,
		146,
		147,
		151,
		-1,
		295,
		282,
		240,
		236,
		225,
		245,
		196,
		184,
		216,
		-1,
		-1,
		258,
		-1,
		192,
		209,
		200,
		198,
		191,
		173,
		180,
		188,
		165,
		160,
		150,
		139,
		139,
		134,
		156,
		142,
		140,
		149,
		165,
		-1,
		-1,
		-1,
		262,
		-1,
		-1,
		211,
		198,
		192,
		-1,
		233,
		-1,
		236,
		226,
		210,
		195,
		228,
		-1,
		172,
		168,
		175,
		-1,
		185,
		-1,
		158,
		155,
		146,
		131,
		128,
		139,
		137,
		148,
		144,
		-1,
		245,
		230,
		223,
		213,
		227,
		198,
		-1,
		253,
		-1,
		-1,
		223,
		217,
		217,
		201,
		202,
		188,
		168,
		160,
		175,
		174,
		161,
		160,
		144,
		137,
		134,
		127,
		140,
		150,
		155,
		142,
		-1,
		-1,
		-1,
		250,
		236,
		240,
		200,
		219,
		-1,
		-1,
		285,
		240,
		226,
		-1,
		197,
		188,
		176,
		166,
		156,
		161,
		162,
		152,
		150,
		142,
		144,
		138,
		129,
		128,
		144,
		136,
		158,
		-1,
		-1,
		233,
		238,
		226,
		212,
		231,
		-1,
		-1,
		-1,
		232,
		248,
		216,
		195,
		177,
		-1,
		-1,
		160,
		153,
		147,
		150,
		138,
		158,
		153,
		137,
		122,
		137,
		141,
		149,
		140,
		-1,
		236,
		223,
		-1,
		-1,
		234,
		228,
		-1,
		-1,
		-1,
		-1,
		228,
		173,
		162,
		157,
		161,
		159,
		-1,
		133,
		144,
		137,
		156,
		163,
		139,
		124,
		118,
		124,
		136,
		145,
		-1,
		-1,
		248,
		-1,
		221,
		-1,
		-1,
		-1,
		-1,
		185,
		179,
		150,
		143,
		147,
		-1,
		135,
		137,
		134,
		146,
		142,
		139,
		130,
		121,
		117,
		121,
		125,
		139,
		143,
		271,
		-1,
		212,
		-1,
		-1,
		-1,
		203,
		218,
		189,
		166,
		139,
		134,
		127,
		121,
		126,
		137,
		146,
		157,
		122,
		124,
		114,
		113,
		117,
		134,
		138,
		-1,
		-1,
		210,
		206,
		229,
		211,
		215,
		216,
		-1,
		-1,
		143,
		134,
		125,
		117,
		130,
		133,
		118,
		120,
		120,
		118,
		112,
		122,
		137,
		132,
		-1,
		-1,
		-1,
		222,
		-1,
		224,
		-1,
		-1,
		213,
		214,
		161,
		143,
		139,
		137,
		126,
		120,
		108,
		113,
		123,
		117,
		114,
		108,
		112,
		135,
		124,
		163,
		-1,
		-1,
		284,
		-1,
		-1,
		-1,
		202,
		193,
		188,
		195,
		197,
		188,
		176,
		173,
		-1,
		143,
		149,
		114,
		121,
		104,
		111,
		116,
		113,
		102,
		109,
		125,
		124,
		119,
		155,
		146,
		152,
		-1,
		-1,
		277,
		266,
		255,
		261,
		-1,
		195,
		190,
		181,
		171,
		174,
		-1,
		-1,
		168,
		165,
		145,
		114,
		112,
		105,
		100,
		110,
		86,
		98,
		102,
		106,
		112,
		117,
		122,
		128,
		143,
		158,
		-1,
		231,
		268,
		261,
		229,
		237,
		268,
		-1,
		185,
		177,
		187,
		163,
		165,
		-1,
		-1,
		141,
		132,
		133,
		121,
		118,
		124,
		123,
		106,
		112,
		113,
		105,
		104,
		122,
		126,
		135,
		142,
		132,
		145,
		149,
		-1,
		224,
		244,
		223,
		226,
		250,
		264,
		-1,
		182,
		-1,
		-1,
		147,
		166,
		150,
		140,
		137,
		180,
		135,
		130,
		111,
		109,
		104,
		95,
		120,
		113,
		113,
		116,
		131,
		136,
		128,
		142,
		142,
		143,
		-1,
		213,
		224,
		217,
		-1,
		-1,
		-1,
		-1,
		183,
		-1,
		-1,
		137,
		-1,
		177,
		-1,
		160,
		164,
		143,
		146,
		125,
		112,
		98,
		106,
		112,
		111,
		117,
		117,
		118,
		127,
		138,
		150,
		149,
		150,
		238,
		194,
		197,
		208,
		219,
		234,
		238,
		-1,
		194,
		233,
		143,
		-1,
		127,
		-1,
		-1,
		-1,
		174,
		156,
		148,
		145,
		124,
		124,
		90,
		94,
		107,
		114,
		124,
		135,
		127,
		131,
		144,
		155,
		158,
		234,
		225,
		238,
		183,
		183,
		204,
		213,
		234,
		198,
		195,
		227,
		150,
		139,
		134,
		121,
		-1,
		-1,
		158,
		166,
		-1,
		-1,
		131,
		98,
		86,
		96,
		100,
		114,
		126,
		139,
		127,
		132,
		126,
		158,
		-1,
		227,
		226,
		215,
		212,
		188,
		179,
		174,
		201,
		-1,
		-1,
		196,
		223,
		206,
		183,
		181,
		206,
		-1,
		110,
		-1,
		-1,
		138,
		-1,
		-1,
		123,
		103,
		92,
		83,
		88,
		108,
		119,
		141,
		123,
		140,
		131,
		141,
		145,
		211,
		208,
		196,
		194,
		217,
		182,
		170,
		-1,
		178,
		181,
		187,
		194,
		184,
		195,
		-1,
		-1,
		126,
		106,
		-1,
		-1,
		121,
		119,
		108,
		-1,
		98,
		80,
		85,
		115,
		117,
		119,
		126,
		120,
		127,
		135,
		146,
		138,
		220,
		234,
		223,
		219,
		218,
		226,
		175,
		168,
		175,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		131,
		-1,
		116,
		112,
		-1,
		-1,
		116,
		109,
		97,
		85,
		75,
		85,
		102,
		102,
		105,
		110,
		118,
		129,
		125,
		129,
		132,
		-1,
		254,
		-1,
		206,
		167,
		173,
		188,
		196,
		-1,
		-1,
		-1,
		133,
		119,
		112,
		100,
		98,
		-1,
		150,
		134,
		115,
		-1,
		85,
		98,
		138,
		106,
		111,
		106,
		121,
		132,
		123,
		131,
		125,
		128,
		-1,
		-1,
		166,
		149,
		-1,
		-1,
		123,
		125,
		-1,
		124,
		113,
		98,
		90,
		-1,
		-1,
		122,
		118,
		-1,
		-1,
		72,
		110,
		109,
		117,
		112,
		117,
		129,
		125,
		121,
		131,
		122,
		-1,
		-1,
		144,
		136,
		130,
		-1,
		108,
		-1,
		126,
		-1,
		93,
		99,
		87,
		-1,
		-1,
		-1,
		103,
		66,
		82,
		105,
		131,
		129,
		120,
		113,
		120,
		123,
		116,
		122,
		-1,
		-1,
		-1,
		126,
		100,
		133,
		124,
		107,
		87,
		79,
		98,
		-1,
		84,
		-1,
		59,
		62,
		87,
		126,
		128,
		114,
		110,
		123,
		117,
		114,
		112,
		132,
		-1,
		102,
		135,
		99,
		93,
		69,
		73,
		98,
		-1,
		81,
		63,
		-1,
		91,
		81,
		129,
		104,
		113,
		106,
		100,
		101,
		109,
		-1,
		-1,
		-1,
		104,
		103,
		95,
		89,
		89,
		74,
		65,
		-1,
		86,
		68,
		54,
		71,
		71,
		62,
		70,
		119,
		115,
		118,
		116,
		94,
		-1,
		136,
		-1,
		-1,
		127,
		-1,
		-1,
		-1,
		98,
		93,
		66,
		54,
		55,
		51,
		51,
		53,
		66,
		74,
		72,
		69,
		81,
		77,
		97,
		93,
		125,
		-1,
		131,
		-1,
		134,
		-1,
		-1,
		91,
		78,
		88,
		77,
		66,
		64,
		50,
		46,
		63,
		98,
		84,
		82,
		87,
		92,
		-1,
		120,
		119,
		-1,
		110,
		102,
		88,
		-1,
		69,
		-1,
		112,
		73,
		-1,
		47,
		41,
		-1,
		93,
		89,
		-1,
		-1,
		107,
		102,
		-1,
		-1,
		-1,
		89,
		53,
		107,
		91,
		-1,
		31,
		38,
		-1,
		-1,
		-1,
		92,
		93,
		-1,
		82,
		85,
		-1,
		49,
		40,
		48,
		24,
		32,
		-1,
		-1,
		-1,
		101,
		82,
		76,
		78,
		73,
		90,
		61,
		47,
		31,
		9,
		23,
		52,
		-1,
		-1,
		-1,
		73,
		65,
		58,
		-1,
		-1,
		56,
		39,
		20,
		0,
		-1,
		-1,
		-1,
		95,
		76,
		-1,
		-1,
		50,
		-1,
		-1,
		52,
		21,
		-1,
		-1,
		-1,
		-1,
		-1,
		112,
		84,
		-1,
		-1,
		-1,
		46,
		42,
		43,
		-1,
		-1,
		-1,
		-1,
		106,
		107,
		130,
		94,
		-1,
		-1,
		-1,
		38,
		32,
		-1,
		-1,
		109,
		107,
		-1,
		-1,
		-1,
		66,
		50,
		-1,
		36,
		-1,
		-1,
		-1,
		57,
		-1,
		-1,
		69,
		-1,
		-1,
		-1,
		71,
		-1,
		71,
		46,
		53,
		-1,
		-1,
		-1,
		-1,
		84,
		76,
		84,
		-1,
		56,
		58,
		-1,
		106,
		-1,
		-1,
		99,
		90,
		-1,
		-1,
		61,
		68,
		90,
		93,
		129,
		-1,
		80
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		353,
		342,
		353,
		361,
		334,
		341,
		-1,
		360,
		364,
		330,
		324,
		363,
		332,
		338,
		349,
		-1,
		-1,
		-1,
		353,
		352,
		320,
		318,
		327,
		332,
		339,
		-1,
		338,
		-1,
		374,
		353,
		364,
		369,
		313,
		310,
		330,
		349,
		331,
		323,
		389,
		343,
		314,
		308,
		326,
		316,
		325,
		317,
		-1,
		314,
		304,
		326,
		305,
		316,
		308,
		-1,
		-1,
		308,
		309,
		315,
		301,
		307,
		303,
		-1,
		313,
		297,
		-1,
		-1,
		298,
		299,
		283,
		286,
		294,
		292,
		305,
		297,
		292,
		-1,
		-1,
		289,
		285,
		292,
		279,
		275,
		292,
		305,
		287,
		301,
		300,
		-1,
		293,
		311,
		318,
		286,
		284,
		268,
		266,
		284,
		286,
		292,
		292,
		-1,
		302,
		303,
		298,
		306,
		308,
		284,
		271,
		271,
		281,
		274,
		293,
		281,
		327,
		-1,
		-1,
		-1,
		-1,
		-1,
		336,
		302,
		285,
		302,
		294,
		284,
		299,
		292,
		274,
		271,
		269,
		266,
		282,
		280,
		290,
		-1,
		-1,
		395,
		364,
		393,
		351,
		332,
		-1,
		298,
		278,
		284,
		288,
		282,
		275,
		289,
		285,
		-1,
		260,
		259,
		287,
		273,
		284,
		355,
		-1,
		-1,
		353,
		345,
		328,
		331,
		308,
		304,
		293,
		292,
		284,
		270,
		266,
		272,
		275,
		275,
		281,
		254,
		264,
		268,
		266,
		291,
		-1,
		-1,
		326,
		-1,
		-1,
		352,
		335,
		-1,
		318,
		325,
		314,
		320,
		306,
		327,
		303,
		294,
		286,
		280,
		268,
		270,
		267,
		280,
		268,
		251,
		276,
		280,
		261,
		282,
		277,
		-1,
		325,
		309,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		330,
		311,
		314,
		320,
		344,
		343,
		-1,
		315,
		303,
		304,
		289,
		286,
		273,
		261,
		274,
		259,
		266,
		265,
		255,
		253,
		283,
		258,
		280,
		277,
		296,
		301,
		295,
		304,
		-1,
		360,
		356,
		352,
		359,
		308,
		-1,
		-1,
		348,
		-1,
		351,
		352,
		327,
		300,
		303,
		290,
		281,
		268,
		257,
		268,
		257,
		254,
		262,
		247,
		262,
		253,
		252,
		270,
		280,
		288,
		292,
		298,
		-1,
		410,
		-1,
		352,
		336,
		338,
		310,
		331,
		-1,
		368,
		352,
		344,
		329,
		329,
		-1,
		299,
		296,
		286,
		264,
		249,
		266,
		258,
		256,
		260,
		242,
		256,
		247,
		265,
		272,
		270,
		274,
		294,
		306,
		370,
		360,
		-1,
		342,
		347,
		306,
		314,
		333,
		371,
		335,
		-1,
		330,
		-1,
		301,
		314,
		-1,
		270,
		266,
		248,
		249,
		244,
		259,
		253,
		238,
		235,
		253,
		256,
		263,
		267,
		283,
		-1,
		-1,
		355,
		359,
		348,
		299,
		318,
		342,
		379,
		328,
		317,
		316,
		-1,
		307,
		284,
		281,
		269,
		256,
		241,
		242,
		250,
		263,
		242,
		237,
		234,
		254,
		280,
		258,
		270,
		-1,
		-1,
		-1,
		380,
		-1,
		-1,
		325,
		296,
		320,
		362,
		346,
		339,
		327,
		292,
		292,
		286,
		-1,
		280,
		259,
		250,
		239,
		237,
		250,
		247,
		252,
		232,
		230,
		249,
		261,
		252,
		269,
		-1,
		-1,
		-1,
		355,
		344,
		345,
		291,
		314,
		351,
		325,
		311,
		316,
		291,
		284,
		278,
		293,
		276,
		257,
		246,
		238,
		227,
		243,
		251,
		246,
		228,
		237,
		243,
		267,
		257,
		263,
		-1,
		-1,
		362,
		352,
		336,
		338,
		335,
		305,
		312,
		344,
		316,
		329,
		-1,
		283,
		-1,
		272,
		267,
		251,
		246,
		243,
		240,
		234,
		243,
		245,
		235,
		230,
		237,
		272,
		272,
		247,
		267,
		270,
		-1,
		-1,
		-1,
		355,
		350,
		325,
		302,
		286,
		322,
		-1,
		299,
		300,
		-1,
		277,
		271,
		268,
		253,
		249,
		244,
		248,
		241,
		248,
		241,
		239,
		240,
		222,
		254,
		-1,
		255,
		249,
		257,
		247,
		235,
		-1,
		-1,
		-1,
		348,
		327,
		320,
		340,
		281,
		333,
		-1,
		-1,
		284,
		277,
		-1,
		264,
		246,
		253,
		251,
		245,
		249,
		246,
		235,
		248,
		241,
		227,
		229,
		242,
		246,
		250,
		237,
		233,
		230,
		244,
		-1,
		367,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		301,
		-1,
		293,
		285,
		275,
		269,
		263,
		259,
		257,
		273,
		257,
		260,
		258,
		249,
		257,
		230,
		223,
		230,
		219,
		237,
		245,
		237,
		231,
		230,
		240,
		-1,
		368,
		354,
		325,
		-1,
		-1,
		314,
		-1,
		278,
		292,
		308,
		-1,
		301,
		280,
		295,
		273,
		269,
		265,
		280,
		281,
		258,
		258,
		256,
		247,
		235,
		224,
		227,
		219,
		241,
		241,
		225,
		226,
		230,
		-1,
		374,
		361,
		319,
		315,
		304,
		324,
		275,
		263,
		295,
		-1,
		-1,
		337,
		-1,
		271,
		288,
		279,
		277,
		270,
		252,
		259,
		267,
		244,
		239,
		229,
		218,
		218,
		213,
		235,
		221,
		219,
		228,
		244,
		-1,
		-1,
		-1,
		341,
		-1,
		-1,
		290,
		277,
		271,
		-1,
		312,
		-1,
		315,
		305,
		289,
		274,
		307,
		-1,
		251,
		247,
		254,
		-1,
		264,
		-1,
		237,
		234,
		225,
		210,
		207,
		218,
		216,
		227,
		223,
		-1,
		324,
		309,
		302,
		292,
		306,
		277,
		-1,
		332,
		-1,
		-1,
		302,
		296,
		296,
		280,
		281,
		267,
		247,
		239,
		254,
		253,
		240,
		239,
		223,
		216,
		213,
		206,
		219,
		229,
		234,
		221,
		-1,
		-1,
		-1,
		329,
		315,
		319,
		279,
		298,
		-1,
		-1,
		364,
		319,
		305,
		-1,
		276,
		267,
		255,
		245,
		235,
		240,
		241,
		231,
		229,
		221,
		223,
		217,
		208,
		207,
		223,
		215,
		237,
		-1,
		-1,
		312,
		317,
		305,
		291,
		309,
		-1,
		-1,
		-1,
		311,
		327,
		295,
		274,
		256,
		-1,
		-1,
		239,
		232,
		226,
		229,
		217,
		237,
		232,
		216,
		201,
		216,
		220,
		228,
		219,
		-1,
		315,
		302,
		-1,
		-1,
		308,
		298,
		-1,
		-1,
		-1,
		-1,
		307,
		252,
		241,
		236,
		240,
		238,
		-1,
		212,
		223,
		216,
		235,
		242,
		218,
		203,
		197,
		203,
		215,
		224,
		-1,
		-1,
		322,
		-1,
		284,
		-1,
		-1,
		-1,
		-1,
		264,
		258,
		229,
		222,
		226,
		-1,
		214,
		216,
		213,
		225,
		221,
		218,
		209,
		200,
		196,
		200,
		204,
		218,
		222,
		345,
		-1,
		275,
		-1,
		-1,
		-1,
		282,
		297,
		268,
		245,
		218,
		213,
		206,
		200,
		205,
		216,
		225,
		236,
		201,
		203,
		193,
		192,
		196,
		213,
		217,
		-1,
		-1,
		273,
		269,
		304,
		290,
		294,
		295,
		-1,
		-1,
		222,
		213,
		204,
		196,
		209,
		212,
		197,
		199,
		199,
		197,
		191,
		201,
		216,
		211,
		-1,
		-1,
		-1,
		285,
		-1,
		287,
		-1,
		-1,
		292,
		293,
		240,
		222,
		218,
		216,
		205,
		199,
		187,
		192,
		202,
		196,
		193,
		187,
		191,
		214,
		203,
		242,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		269,
		256,
		251,
		274,
		276,
		267,
		255,
		252,
		-1,
		222,
		228,
		193,
		200,
		183,
		190,
		195,
		192,
		181,
		188,
		204,
		203,
		198,
		234,
		225,
		231,
		-1,
		-1,
		302,
		291,
		280,
		286,
		-1,
		262,
		253,
		260,
		250,
		253,
		-1,
		-1,
		247,
		244,
		224,
		193,
		191,
		184,
		179,
		189,
		165,
		177,
		181,
		185,
		191,
		196,
		201,
		207,
		222,
		237,
		-1,
		256,
		293,
		286,
		254,
		262,
		293,
		-1,
		252,
		244,
		250,
		242,
		244,
		-1,
		-1,
		220,
		211,
		212,
		200,
		197,
		203,
		202,
		185,
		191,
		192,
		184,
		183,
		201,
		205,
		214,
		221,
		211,
		224,
		228,
		-1,
		249,
		269,
		248,
		251,
		275,
		289,
		-1,
		243,
		-1,
		-1,
		210,
		245,
		229,
		219,
		216,
		259,
		214,
		209,
		190,
		188,
		183,
		174,
		199,
		192,
		192,
		195,
		210,
		215,
		207,
		221,
		221,
		222,
		-1,
		238,
		249,
		242,
		-1,
		-1,
		-1,
		-1,
		237,
		-1,
		-1,
		200,
		-1,
		256,
		-1,
		239,
		243,
		222,
		225,
		204,
		191,
		177,
		185,
		191,
		190,
		196,
		196,
		197,
		206,
		217,
		229,
		228,
		229,
		263,
		219,
		222,
		233,
		244,
		259,
		263,
		-1,
		227,
		263,
		206,
		-1,
		190,
		-1,
		-1,
		-1,
		253,
		235,
		227,
		224,
		203,
		203,
		169,
		173,
		186,
		193,
		203,
		214,
		206,
		210,
		223,
		234,
		237,
		259,
		250,
		263,
		208,
		208,
		229,
		238,
		259,
		223,
		220,
		257,
		213,
		202,
		197,
		184,
		-1,
		-1,
		237,
		245,
		-1,
		-1,
		210,
		177,
		165,
		175,
		179,
		193,
		205,
		218,
		206,
		211,
		205,
		237,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		199,
		226,
		-1,
		-1,
		221,
		248,
		232,
		236,
		244,
		269,
		-1,
		168,
		-1,
		-1,
		217,
		-1,
		-1,
		202,
		182,
		171,
		162,
		167,
		187,
		198,
		220,
		202,
		219,
		210,
		220,
		224,
		236,
		233,
		221,
		219,
		242,
		207,
		195,
		-1,
		203,
		206,
		212,
		219,
		236,
		258,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		200,
		198,
		187,
		-1,
		177,
		159,
		164,
		194,
		196,
		198,
		205,
		199,
		206,
		214,
		225,
		217,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		195,
		188,
		176,
		164,
		154,
		164,
		181,
		181,
		184,
		189,
		197,
		208,
		204,
		208,
		211,
		-1,
		279,
		-1,
		231,
		192,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		229,
		213,
		194,
		-1,
		164,
		177,
		217,
		185,
		190,
		185,
		200,
		211,
		202,
		210,
		204,
		207,
		-1,
		-1,
		191,
		174,
		-1,
		-1,
		148,
		150,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		201,
		197,
		-1,
		-1,
		151,
		189,
		188,
		196,
		191,
		196,
		208,
		204,
		200,
		210,
		201,
		-1,
		-1,
		169,
		161,
		155,
		-1,
		133,
		-1,
		184,
		-1,
		151,
		160,
		148,
		-1,
		-1,
		-1,
		182,
		145,
		161,
		184,
		210,
		208,
		199,
		192,
		199,
		202,
		195,
		201,
		-1,
		-1,
		-1,
		151,
		125,
		191,
		182,
		165,
		145,
		137,
		159,
		-1,
		163,
		-1,
		138,
		141,
		166,
		205,
		207,
		193,
		189,
		202,
		196,
		193,
		191,
		157,
		-1,
		127,
		160,
		124,
		151,
		117,
		131,
		177,
		-1,
		160,
		142,
		-1,
		170,
		160,
		208,
		183,
		192,
		185,
		179,
		180,
		188,
		-1,
		-1,
		-1,
		129,
		128,
		120,
		114,
		114,
		112,
		129,
		-1,
		165,
		147,
		133,
		150,
		150,
		141,
		149,
		198,
		194,
		197,
		195,
		173,
		-1,
		98,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		123,
		107,
		120,
		131,
		134,
		130,
		130,
		132,
		145,
		153,
		151,
		148,
		160,
		156,
		176,
		172,
		204,
		-1,
		93,
		-1,
		159,
		-1,
		-1,
		104,
		91,
		101,
		112,
		140,
		140,
		129,
		125,
		142,
		177,
		163,
		161,
		166,
		171,
		-1,
		82,
		81,
		-1,
		75,
		85,
		101,
		-1,
		82,
		-1,
		186,
		147,
		-1,
		126,
		120,
		-1,
		172,
		168,
		-1,
		-1,
		69,
		64,
		-1,
		-1,
		-1,
		81,
		90,
		181,
		165,
		-1,
		110,
		117,
		-1,
		-1,
		-1,
		54,
		55,
		-1,
		74,
		77,
		-1,
		91,
		97,
		125,
		105,
		111,
		-1,
		-1,
		-1,
		63,
		44,
		38,
		64,
		59,
		82,
		122,
		108,
		108,
		92,
		102,
		131,
		-1,
		-1,
		-1,
		25,
		32,
		44,
		-1,
		-1,
		133,
		116,
		103,
		101,
		-1,
		-1,
		-1,
		0,
		20,
		-1,
		-1,
		53,
		-1,
		-1,
		98,
		77,
		-1,
		-1,
		-1,
		-1,
		-1,
		43,
		15,
		-1,
		-1,
		-1,
		54,
		61,
		82,
		-1,
		-1,
		-1,
		-1,
		44,
		44,
		61,
		36,
		-1,
		-1,
		-1,
		68,
		71,
		-1,
		-1,
		47,
		45,
		-1,
		-1,
		-1,
		67,
		79,
		-1,
		82,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		115,
		-1,
		-1,
		-1,
		97,
		-1,
		117,
		92,
		99,
		-1,
		-1,
		-1,
		-1,
		110,
		102,
		130,
		-1,
		102,
		104,
		-1,
		152,
		-1,
		-1,
		125,
		120,
		-1,
		-1,
		107,
		114,
		136,
		139,
		144,
		-1,
		126
	],
	[
		-1,
		333,
		322,
		333,
		341,
		314,
		321,
		-1,
		340,
		344,
		310,
		304,
		343,
		312,
		318,
		329,
		-1,
		-1,
		-1,
		333,
		332,
		300,
		298,
		307,
		312,
		319,
		-1,
		318,
		-1,
		354,
		333,
		344,
		349,
		293,
		290,
		310,
		329,
		311,
		303,
		369,
		323,
		294,
		288,
		306,
		296,
		305,
		297,
		-1,
		294,
		284,
		306,
		285,
		296,
		288,
		-1,
		-1,
		288,
		289,
		295,
		281,
		287,
		283,
		-1,
		293,
		277,
		-1,
		-1,
		278,
		279,
		263,
		266,
		274,
		272,
		285,
		277,
		272,
		-1,
		-1,
		269,
		265,
		272,
		259,
		255,
		272,
		285,
		267,
		281,
		280,
		-1,
		273,
		291,
		298,
		266,
		264,
		248,
		246,
		264,
		266,
		272,
		272,
		-1,
		282,
		283,
		278,
		286,
		288,
		264,
		251,
		251,
		261,
		254,
		273,
		261,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		282,
		265,
		282,
		274,
		264,
		279,
		272,
		254,
		251,
		249,
		246,
		262,
		260,
		270,
		-1,
		-1,
		375,
		344,
		373,
		331,
		312,
		-1,
		278,
		258,
		264,
		268,
		262,
		255,
		269,
		265,
		-1,
		240,
		239,
		267,
		253,
		264,
		335,
		-1,
		-1,
		333,
		325,
		308,
		311,
		288,
		284,
		273,
		272,
		264,
		250,
		246,
		252,
		255,
		255,
		261,
		234,
		244,
		248,
		246,
		271,
		-1,
		-1,
		306,
		-1,
		-1,
		332,
		315,
		-1,
		298,
		305,
		294,
		300,
		286,
		307,
		283,
		274,
		266,
		260,
		248,
		250,
		247,
		260,
		248,
		231,
		256,
		260,
		241,
		262,
		257,
		-1,
		305,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		291,
		294,
		300,
		324,
		323,
		-1,
		295,
		283,
		284,
		269,
		266,
		253,
		241,
		254,
		239,
		246,
		245,
		235,
		233,
		263,
		238,
		260,
		257,
		276,
		281,
		275,
		284,
		-1,
		340,
		336,
		332,
		339,
		288,
		-1,
		-1,
		328,
		-1,
		331,
		332,
		307,
		280,
		283,
		270,
		261,
		248,
		237,
		248,
		237,
		234,
		242,
		227,
		242,
		233,
		232,
		250,
		260,
		268,
		272,
		278,
		-1,
		390,
		-1,
		332,
		316,
		318,
		290,
		311,
		-1,
		348,
		332,
		324,
		309,
		309,
		-1,
		279,
		276,
		266,
		244,
		229,
		246,
		238,
		236,
		240,
		222,
		236,
		227,
		245,
		252,
		250,
		254,
		274,
		286,
		350,
		340,
		-1,
		322,
		327,
		286,
		294,
		313,
		351,
		315,
		-1,
		310,
		-1,
		281,
		294,
		-1,
		250,
		246,
		228,
		229,
		224,
		239,
		233,
		218,
		215,
		233,
		236,
		243,
		247,
		263,
		-1,
		-1,
		335,
		339,
		328,
		279,
		298,
		322,
		359,
		308,
		297,
		296,
		-1,
		287,
		264,
		261,
		249,
		236,
		221,
		222,
		230,
		243,
		222,
		217,
		214,
		234,
		260,
		238,
		250,
		-1,
		-1,
		-1,
		360,
		-1,
		-1,
		305,
		276,
		300,
		342,
		326,
		319,
		307,
		272,
		272,
		266,
		-1,
		260,
		239,
		230,
		219,
		217,
		230,
		227,
		232,
		212,
		210,
		229,
		241,
		232,
		249,
		-1,
		-1,
		-1,
		335,
		324,
		325,
		271,
		294,
		331,
		305,
		291,
		296,
		271,
		264,
		258,
		273,
		256,
		237,
		226,
		218,
		207,
		223,
		231,
		226,
		208,
		217,
		223,
		247,
		237,
		243,
		-1,
		-1,
		342,
		332,
		316,
		318,
		315,
		285,
		292,
		324,
		296,
		309,
		-1,
		263,
		-1,
		252,
		247,
		231,
		226,
		223,
		220,
		214,
		223,
		225,
		215,
		210,
		217,
		252,
		252,
		227,
		247,
		250,
		-1,
		-1,
		-1,
		335,
		330,
		305,
		282,
		266,
		302,
		-1,
		279,
		280,
		-1,
		257,
		251,
		248,
		233,
		229,
		224,
		228,
		221,
		228,
		221,
		219,
		220,
		202,
		234,
		-1,
		235,
		229,
		237,
		227,
		215,
		-1,
		-1,
		-1,
		328,
		307,
		300,
		320,
		261,
		313,
		-1,
		-1,
		264,
		257,
		-1,
		244,
		226,
		233,
		231,
		225,
		229,
		226,
		215,
		228,
		221,
		207,
		209,
		222,
		226,
		230,
		217,
		213,
		210,
		224,
		-1,
		347,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		281,
		-1,
		273,
		265,
		255,
		249,
		243,
		239,
		237,
		253,
		237,
		240,
		238,
		229,
		237,
		210,
		203,
		210,
		199,
		217,
		225,
		217,
		211,
		210,
		220,
		-1,
		348,
		334,
		305,
		-1,
		-1,
		294,
		-1,
		258,
		272,
		288,
		-1,
		281,
		260,
		275,
		253,
		249,
		245,
		260,
		261,
		238,
		238,
		236,
		227,
		215,
		204,
		207,
		199,
		221,
		221,
		205,
		206,
		210,
		-1,
		354,
		341,
		299,
		295,
		284,
		304,
		255,
		243,
		275,
		-1,
		-1,
		317,
		-1,
		251,
		268,
		259,
		257,
		250,
		232,
		239,
		247,
		224,
		219,
		209,
		198,
		198,
		193,
		215,
		201,
		199,
		208,
		224,
		-1,
		-1,
		-1,
		321,
		-1,
		-1,
		270,
		257,
		251,
		-1,
		292,
		-1,
		295,
		285,
		269,
		254,
		287,
		-1,
		231,
		227,
		234,
		-1,
		244,
		-1,
		217,
		214,
		205,
		190,
		187,
		198,
		196,
		207,
		203,
		-1,
		304,
		289,
		282,
		272,
		286,
		257,
		-1,
		312,
		-1,
		-1,
		282,
		276,
		276,
		260,
		261,
		247,
		227,
		219,
		234,
		233,
		220,
		219,
		203,
		196,
		193,
		186,
		199,
		209,
		214,
		201,
		-1,
		-1,
		-1,
		309,
		295,
		299,
		259,
		278,
		-1,
		-1,
		344,
		299,
		285,
		-1,
		256,
		247,
		235,
		225,
		215,
		220,
		221,
		211,
		209,
		201,
		203,
		197,
		188,
		187,
		203,
		195,
		217,
		-1,
		-1,
		292,
		297,
		285,
		271,
		289,
		-1,
		-1,
		-1,
		291,
		307,
		275,
		254,
		236,
		-1,
		-1,
		219,
		212,
		206,
		209,
		197,
		217,
		212,
		196,
		181,
		196,
		200,
		208,
		199,
		-1,
		295,
		282,
		-1,
		-1,
		288,
		278,
		-1,
		-1,
		-1,
		-1,
		287,
		232,
		221,
		216,
		220,
		218,
		-1,
		192,
		203,
		196,
		215,
		222,
		198,
		183,
		177,
		183,
		195,
		204,
		-1,
		-1,
		302,
		-1,
		264,
		-1,
		-1,
		-1,
		-1,
		244,
		238,
		209,
		202,
		206,
		-1,
		194,
		196,
		193,
		205,
		201,
		198,
		189,
		180,
		176,
		180,
		184,
		198,
		202,
		325,
		-1,
		255,
		-1,
		-1,
		-1,
		262,
		277,
		248,
		225,
		198,
		193,
		186,
		180,
		185,
		196,
		205,
		216,
		181,
		183,
		173,
		172,
		176,
		193,
		197,
		-1,
		-1,
		253,
		249,
		284,
		270,
		274,
		275,
		-1,
		-1,
		202,
		193,
		184,
		176,
		189,
		192,
		177,
		179,
		179,
		177,
		171,
		181,
		196,
		191,
		-1,
		-1,
		-1,
		265,
		-1,
		267,
		-1,
		-1,
		272,
		273,
		220,
		202,
		198,
		196,
		185,
		179,
		167,
		172,
		182,
		176,
		173,
		167,
		171,
		194,
		183,
		222,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		249,
		236,
		231,
		254,
		256,
		247,
		235,
		232,
		-1,
		202,
		208,
		173,
		180,
		163,
		170,
		175,
		172,
		161,
		168,
		184,
		183,
		178,
		214,
		205,
		211,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		242,
		233,
		240,
		230,
		233,
		-1,
		-1,
		227,
		224,
		204,
		173,
		171,
		164,
		159,
		169,
		145,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		236,
		273,
		266,
		234,
		242,
		273,
		-1,
		232,
		224,
		230,
		222,
		224,
		-1,
		-1,
		200,
		191,
		192,
		180,
		177,
		183,
		182,
		165,
		171,
		172,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		229,
		249,
		228,
		231,
		255,
		269,
		-1,
		223,
		-1,
		-1,
		190,
		225,
		209,
		199,
		196,
		239,
		194,
		189,
		170,
		168,
		163,
		154,
		179,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		218,
		229,
		222,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		-1,
		180,
		-1,
		236,
		-1,
		219,
		223,
		202,
		205,
		184,
		171,
		157,
		165,
		171,
		170,
		176,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		243,
		199,
		202,
		213,
		224,
		239,
		243,
		-1,
		207,
		243,
		186,
		-1,
		170,
		-1,
		-1,
		-1,
		233,
		215,
		207,
		204,
		183,
		183,
		149,
		153,
		166,
		173,
		183,
		194,
		186,
		190,
		203,
		214,
		217,
		239,
		230,
		243,
		188,
		188,
		209,
		218,
		239,
		203,
		200,
		237,
		193,
		182,
		177,
		164,
		-1,
		-1,
		217,
		225,
		-1,
		-1,
		190,
		157,
		145,
		155,
		159,
		173,
		185,
		198,
		186,
		191,
		185,
		217,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		179,
		206,
		-1,
		-1,
		201,
		228,
		212,
		216,
		224,
		249,
		-1,
		148,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		162,
		151,
		142,
		147,
		167,
		178,
		200,
		182,
		199,
		190,
		200,
		204,
		216,
		213,
		201,
		199,
		222,
		187,
		175,
		-1,
		183,
		186,
		192,
		199,
		216,
		238,
		-1,
		-1,
		164,
		144,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		139,
		144,
		174,
		176,
		178,
		185,
		179,
		186,
		194,
		205,
		197,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		169,
		-1,
		154,
		150,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		161,
		161,
		164,
		169,
		177,
		188,
		184,
		188,
		191,
		-1,
		259,
		-1,
		211,
		172,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		171,
		157,
		150,
		138,
		136,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		197,
		165,
		170,
		165,
		180,
		191,
		182,
		190,
		184,
		187,
		-1,
		-1,
		171,
		154,
		-1,
		-1,
		128,
		130,
		-1,
		162,
		151,
		136,
		128,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		131,
		169,
		168,
		176,
		171,
		176,
		188,
		184,
		180,
		190,
		181,
		-1,
		-1,
		149,
		141,
		135,
		-1,
		113,
		-1,
		164,
		-1,
		131,
		140,
		128,
		-1,
		-1,
		-1,
		162,
		125,
		141,
		164,
		190,
		188,
		179,
		172,
		179,
		182,
		175,
		181,
		-1,
		-1,
		-1,
		131,
		105,
		171,
		162,
		145,
		125,
		117,
		139,
		-1,
		143,
		-1,
		118,
		121,
		146,
		185,
		187,
		173,
		169,
		182,
		176,
		173,
		171,
		137,
		-1,
		107,
		140,
		104,
		131,
		97,
		111,
		157,
		-1,
		140,
		122,
		-1,
		150,
		140,
		188,
		163,
		172,
		165,
		159,
		160,
		168,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		94,
		92,
		109,
		-1,
		145,
		127,
		113,
		130,
		130,
		121,
		129,
		178,
		174,
		177,
		175,
		153,
		-1,
		78,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		87,
		100,
		111,
		114,
		110,
		110,
		112,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		152,
		184,
		-1,
		73,
		-1,
		139,
		-1,
		-1,
		84,
		71,
		81,
		92,
		120,
		120,
		109,
		105,
		122,
		157,
		143,
		141,
		146,
		151,
		-1,
		62,
		61,
		-1,
		55,
		65,
		81,
		-1,
		62,
		-1,
		166,
		127,
		-1,
		106,
		100,
		-1,
		152,
		148,
		-1,
		-1,
		49,
		44,
		-1,
		-1,
		-1,
		61,
		70,
		161,
		145,
		-1,
		90,
		97,
		-1,
		-1,
		-1,
		34,
		35,
		-1,
		54,
		57,
		-1,
		71,
		77,
		105,
		85,
		91,
		-1,
		-1,
		-1,
		43,
		24,
		18,
		44,
		39,
		62,
		102,
		88,
		88,
		72,
		82,
		111,
		-1,
		-1,
		-1,
		5,
		12,
		24,
		-1,
		-1,
		113,
		96,
		83,
		81,
		-1,
		-1,
		-1,
		19,
		0,
		-1,
		-1,
		33,
		-1,
		-1,
		78,
		57,
		-1,
		-1,
		-1,
		-1,
		-1,
		37,
		8,
		-1,
		-1,
		-1,
		34,
		41,
		62,
		-1,
		-1,
		-1,
		-1,
		37,
		37,
		54,
		29,
		-1,
		-1,
		-1,
		48,
		51,
		-1,
		-1,
		40,
		38,
		-1,
		-1,
		-1,
		60,
		60,
		-1,
		62,
		-1,
		-1,
		-1,
		67,
		-1,
		-1,
		95,
		-1,
		-1,
		-1,
		81,
		-1,
		97,
		72,
		79,
		-1,
		-1,
		-1,
		-1,
		94,
		86,
		110,
		-1,
		82,
		84,
		-1,
		132,
		-1,
		-1,
		109,
		100,
		-1,
		-1,
		87,
		94,
		116,
		119,
		137,
		-1,
		106
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		307,
		296,
		307,
		315,
		288,
		295,
		-1,
		314,
		318,
		284,
		278,
		317,
		286,
		292,
		303,
		-1,
		-1,
		-1,
		307,
		306,
		274,
		272,
		281,
		286,
		293,
		-1,
		292,
		-1,
		328,
		307,
		318,
		323,
		267,
		264,
		284,
		303,
		285,
		277,
		343,
		297,
		268,
		262,
		280,
		270,
		279,
		271,
		-1,
		268,
		258,
		280,
		259,
		270,
		262,
		-1,
		-1,
		262,
		263,
		269,
		255,
		261,
		257,
		-1,
		267,
		251,
		-1,
		-1,
		252,
		253,
		237,
		240,
		248,
		246,
		259,
		251,
		246,
		-1,
		-1,
		243,
		239,
		246,
		233,
		229,
		246,
		259,
		241,
		255,
		254,
		-1,
		247,
		265,
		272,
		240,
		238,
		222,
		220,
		238,
		240,
		246,
		246,
		-1,
		256,
		257,
		252,
		260,
		262,
		238,
		225,
		225,
		235,
		228,
		247,
		235,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		256,
		239,
		256,
		248,
		238,
		253,
		246,
		228,
		225,
		223,
		220,
		236,
		234,
		244,
		-1,
		-1,
		349,
		318,
		347,
		305,
		286,
		-1,
		252,
		232,
		238,
		242,
		236,
		229,
		243,
		239,
		-1,
		214,
		213,
		241,
		227,
		238,
		309,
		-1,
		-1,
		307,
		299,
		282,
		285,
		262,
		258,
		247,
		246,
		238,
		224,
		220,
		226,
		229,
		229,
		235,
		208,
		218,
		222,
		220,
		245,
		-1,
		-1,
		280,
		-1,
		-1,
		306,
		289,
		-1,
		272,
		279,
		268,
		274,
		260,
		281,
		257,
		248,
		240,
		234,
		222,
		224,
		221,
		234,
		222,
		205,
		230,
		234,
		215,
		236,
		231,
		-1,
		279,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		265,
		268,
		274,
		298,
		297,
		-1,
		269,
		257,
		258,
		243,
		240,
		227,
		215,
		228,
		213,
		220,
		219,
		209,
		207,
		237,
		212,
		234,
		231,
		250,
		255,
		249,
		258,
		-1,
		314,
		310,
		306,
		313,
		262,
		-1,
		-1,
		302,
		-1,
		305,
		306,
		281,
		254,
		257,
		244,
		235,
		222,
		211,
		222,
		211,
		208,
		216,
		201,
		216,
		207,
		206,
		224,
		234,
		242,
		246,
		252,
		-1,
		364,
		-1,
		306,
		290,
		292,
		264,
		285,
		-1,
		322,
		306,
		298,
		283,
		283,
		-1,
		253,
		250,
		240,
		218,
		203,
		220,
		212,
		210,
		214,
		196,
		210,
		201,
		219,
		226,
		224,
		228,
		248,
		260,
		324,
		314,
		-1,
		296,
		301,
		260,
		268,
		287,
		325,
		289,
		-1,
		284,
		-1,
		255,
		268,
		-1,
		224,
		220,
		202,
		203,
		198,
		213,
		207,
		192,
		189,
		207,
		210,
		217,
		221,
		237,
		-1,
		-1,
		309,
		313,
		302,
		253,
		272,
		296,
		333,
		282,
		271,
		270,
		-1,
		261,
		238,
		235,
		223,
		210,
		195,
		196,
		204,
		217,
		196,
		191,
		188,
		208,
		234,
		212,
		224,
		-1,
		-1,
		-1,
		334,
		-1,
		-1,
		279,
		250,
		274,
		316,
		300,
		293,
		281,
		246,
		246,
		240,
		-1,
		234,
		213,
		204,
		193,
		191,
		204,
		201,
		206,
		186,
		184,
		203,
		215,
		206,
		223,
		-1,
		-1,
		-1,
		309,
		298,
		299,
		245,
		268,
		305,
		279,
		265,
		270,
		245,
		238,
		232,
		247,
		230,
		211,
		200,
		192,
		181,
		197,
		205,
		200,
		182,
		191,
		197,
		221,
		211,
		217,
		-1,
		-1,
		316,
		306,
		290,
		292,
		289,
		259,
		266,
		298,
		270,
		283,
		-1,
		237,
		-1,
		226,
		221,
		205,
		200,
		197,
		194,
		188,
		197,
		199,
		189,
		184,
		191,
		226,
		226,
		201,
		221,
		224,
		-1,
		-1,
		-1,
		309,
		304,
		279,
		256,
		240,
		276,
		-1,
		253,
		254,
		-1,
		231,
		225,
		222,
		207,
		203,
		198,
		202,
		195,
		202,
		195,
		193,
		194,
		176,
		208,
		-1,
		209,
		203,
		211,
		201,
		189,
		-1,
		-1,
		-1,
		302,
		281,
		274,
		294,
		235,
		287,
		-1,
		-1,
		238,
		231,
		-1,
		218,
		200,
		207,
		205,
		199,
		203,
		200,
		189,
		202,
		195,
		181,
		183,
		196,
		200,
		204,
		191,
		187,
		184,
		198,
		-1,
		321,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		255,
		-1,
		247,
		239,
		229,
		223,
		217,
		213,
		211,
		227,
		211,
		214,
		212,
		203,
		211,
		184,
		177,
		184,
		173,
		191,
		199,
		191,
		185,
		184,
		194,
		-1,
		322,
		308,
		279,
		-1,
		-1,
		268,
		-1,
		232,
		246,
		262,
		-1,
		255,
		234,
		249,
		227,
		223,
		219,
		234,
		235,
		212,
		212,
		210,
		201,
		189,
		178,
		181,
		173,
		195,
		195,
		179,
		180,
		184,
		-1,
		328,
		315,
		273,
		269,
		258,
		278,
		229,
		217,
		249,
		-1,
		-1,
		291,
		-1,
		225,
		242,
		233,
		231,
		224,
		206,
		213,
		221,
		198,
		193,
		183,
		172,
		172,
		167,
		189,
		175,
		173,
		182,
		198,
		-1,
		-1,
		-1,
		295,
		-1,
		-1,
		244,
		231,
		225,
		-1,
		266,
		-1,
		269,
		259,
		243,
		228,
		261,
		-1,
		205,
		201,
		208,
		-1,
		218,
		-1,
		191,
		188,
		179,
		164,
		161,
		172,
		170,
		181,
		177,
		-1,
		278,
		263,
		256,
		246,
		260,
		231,
		-1,
		286,
		-1,
		-1,
		256,
		250,
		250,
		234,
		235,
		221,
		201,
		193,
		208,
		207,
		194,
		193,
		177,
		170,
		167,
		160,
		173,
		183,
		188,
		175,
		-1,
		-1,
		-1,
		283,
		269,
		273,
		233,
		252,
		-1,
		-1,
		318,
		273,
		259,
		-1,
		230,
		221,
		209,
		199,
		189,
		194,
		195,
		185,
		183,
		175,
		177,
		171,
		162,
		161,
		177,
		169,
		191,
		-1,
		-1,
		266,
		271,
		259,
		245,
		264,
		-1,
		-1,
		-1,
		265,
		281,
		249,
		228,
		210,
		-1,
		-1,
		193,
		186,
		180,
		183,
		171,
		191,
		186,
		170,
		155,
		170,
		174,
		182,
		173,
		-1,
		269,
		256,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		-1,
		-1,
		261,
		206,
		195,
		190,
		194,
		192,
		-1,
		166,
		177,
		170,
		189,
		196,
		172,
		157,
		151,
		157,
		169,
		178,
		-1,
		-1,
		281,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		218,
		212,
		183,
		176,
		180,
		-1,
		168,
		170,
		167,
		179,
		175,
		172,
		163,
		154,
		150,
		154,
		158,
		172,
		176,
		304,
		-1,
		245,
		-1,
		-1,
		-1,
		236,
		251,
		222,
		199,
		172,
		167,
		160,
		154,
		159,
		170,
		179,
		190,
		155,
		157,
		147,
		146,
		150,
		167,
		171,
		-1,
		-1,
		243,
		239,
		262,
		244,
		248,
		249,
		-1,
		-1,
		176,
		167,
		158,
		150,
		163,
		166,
		151,
		153,
		153,
		151,
		145,
		155,
		170,
		165,
		-1,
		-1,
		-1,
		255,
		-1,
		257,
		-1,
		-1,
		246,
		247,
		194,
		176,
		172,
		170,
		159,
		153,
		141,
		146,
		156,
		150,
		147,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		289,
		-1,
		-1,
		-1,
		235,
		226,
		221,
		228,
		230,
		221,
		209,
		206,
		-1,
		176,
		182,
		147,
		154,
		137,
		144,
		149,
		146,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		282,
		271,
		260,
		266,
		-1,
		228,
		223,
		214,
		204,
		207,
		-1,
		-1,
		201,
		198,
		178,
		147,
		145,
		138,
		133,
		143,
		119,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		236,
		273,
		266,
		234,
		242,
		273,
		-1,
		218,
		210,
		220,
		196,
		198,
		-1,
		-1,
		174,
		165,
		166,
		154,
		151,
		157,
		156,
		139,
		145,
		146,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		229,
		249,
		228,
		231,
		255,
		269,
		-1,
		215,
		-1,
		-1,
		180,
		199,
		183,
		173,
		170,
		213,
		168,
		163,
		144,
		142,
		137,
		128,
		153,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		218,
		229,
		222,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		170,
		-1,
		210,
		-1,
		193,
		197,
		176,
		179,
		158,
		145,
		131,
		139,
		145,
		144,
		150,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		243,
		199,
		202,
		213,
		224,
		239,
		243,
		-1,
		207,
		243,
		176,
		-1,
		160,
		-1,
		-1,
		-1,
		207,
		189,
		181,
		178,
		157,
		157,
		123,
		127,
		140,
		147,
		157,
		168,
		160,
		164,
		177,
		188,
		191,
		239,
		230,
		243,
		188,
		188,
		209,
		218,
		239,
		203,
		200,
		237,
		183,
		172,
		167,
		154,
		-1,
		-1,
		191,
		199,
		-1,
		-1,
		164,
		131,
		119,
		129,
		133,
		147,
		159,
		172,
		160,
		165,
		159,
		191,
		-1,
		232,
		231,
		220,
		217,
		193,
		184,
		179,
		206,
		-1,
		-1,
		201,
		228,
		212,
		216,
		214,
		239,
		-1,
		143,
		-1,
		-1,
		171,
		-1,
		-1,
		156,
		136,
		125,
		116,
		121,
		141,
		152,
		174,
		156,
		173,
		164,
		174,
		178,
		216,
		213,
		201,
		199,
		222,
		187,
		175,
		-1,
		183,
		186,
		192,
		199,
		216,
		228,
		-1,
		-1,
		159,
		139,
		-1,
		-1,
		154,
		152,
		141,
		-1,
		131,
		113,
		118,
		148,
		150,
		152,
		159,
		153,
		160,
		168,
		179,
		171,
		225,
		239,
		228,
		224,
		223,
		231,
		180,
		173,
		180,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		145,
		-1,
		-1,
		149,
		142,
		130,
		118,
		108,
		118,
		135,
		135,
		138,
		143,
		151,
		162,
		158,
		162,
		165,
		-1,
		259,
		-1,
		211,
		172,
		178,
		193,
		201,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		183,
		167,
		148,
		-1,
		118,
		131,
		171,
		139,
		144,
		139,
		154,
		165,
		156,
		164,
		158,
		161,
		-1,
		-1,
		171,
		154,
		-1,
		-1,
		128,
		130,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		155,
		151,
		-1,
		-1,
		105,
		143,
		142,
		150,
		145,
		150,
		162,
		158,
		154,
		164,
		155,
		-1,
		-1,
		149,
		141,
		135,
		-1,
		113,
		-1,
		159,
		-1,
		126,
		132,
		120,
		-1,
		-1,
		-1,
		136,
		99,
		115,
		138,
		164,
		162,
		153,
		146,
		153,
		156,
		149,
		155,
		-1,
		-1,
		-1,
		131,
		105,
		166,
		157,
		140,
		120,
		112,
		131,
		-1,
		117,
		-1,
		92,
		95,
		120,
		159,
		161,
		147,
		143,
		156,
		150,
		147,
		145,
		137,
		-1,
		107,
		140,
		104,
		126,
		97,
		106,
		131,
		-1,
		114,
		96,
		-1,
		124,
		114,
		162,
		137,
		146,
		139,
		133,
		134,
		142,
		-1,
		-1,
		-1,
		109,
		108,
		100,
		94,
		94,
		92,
		98,
		-1,
		119,
		101,
		87,
		104,
		104,
		95,
		103,
		152,
		148,
		151,
		149,
		127,
		-1,
		94,
		-1,
		-1,
		132,
		-1,
		-1,
		-1,
		103,
		87,
		99,
		87,
		88,
		84,
		84,
		86,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		126,
		158,
		-1,
		89,
		-1,
		139,
		-1,
		-1,
		84,
		71,
		81,
		92,
		99,
		97,
		83,
		79,
		96,
		131,
		117,
		115,
		120,
		125,
		-1,
		78,
		77,
		-1,
		71,
		81,
		81,
		-1,
		62,
		-1,
		145,
		106,
		-1,
		80,
		74,
		-1,
		126,
		122,
		-1,
		-1,
		65,
		60,
		-1,
		-1,
		-1,
		61,
		70,
		140,
		124,
		-1,
		64,
		71,
		-1,
		-1,
		-1,
		50,
		51,
		-1,
		47,
		57,
		-1,
		71,
		77,
		85,
		59,
		65,
		-1,
		-1,
		-1,
		59,
		40,
		34,
		37,
		32,
		62,
		98,
		84,
		68,
		46,
		56,
		85,
		-1,
		-1,
		-1,
		31,
		23,
		17,
		-1,
		-1,
		93,
		76,
		57,
		55,
		-1,
		-1,
		-1,
		53,
		34,
		-1,
		-1,
		0,
		-1,
		-1,
		52,
		31,
		-1,
		-1,
		-1,
		-1,
		-1,
		71,
		42,
		-1,
		-1,
		-1,
		5,
		8,
		36,
		-1,
		-1,
		-1,
		-1,
		64,
		65,
		88,
		63,
		-1,
		-1,
		-1,
		18,
		25,
		-1,
		-1,
		67,
		65,
		-1,
		-1,
		-1,
		46,
		30,
		-1,
		36,
		-1,
		-1,
		-1,
		37,
		-1,
		-1,
		69,
		-1,
		-1,
		-1,
		51,
		-1,
		71,
		46,
		53,
		-1,
		-1,
		-1,
		-1,
		64,
		56,
		84,
		-1,
		56,
		58,
		-1,
		106,
		-1,
		-1,
		79,
		70,
		-1,
		-1,
		61,
		68,
		90,
		93,
		109,
		-1,
		80
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		304,
		293,
		304,
		312,
		285,
		292,
		-1,
		311,
		315,
		281,
		275,
		314,
		283,
		289,
		300,
		-1,
		-1,
		-1,
		304,
		303,
		271,
		269,
		278,
		283,
		290,
		-1,
		289,
		-1,
		325,
		304,
		315,
		320,
		264,
		261,
		281,
		300,
		282,
		274,
		340,
		294,
		265,
		259,
		277,
		267,
		276,
		268,
		-1,
		265,
		255,
		277,
		256,
		267,
		259,
		-1,
		-1,
		259,
		260,
		266,
		252,
		258,
		254,
		-1,
		264,
		248,
		-1,
		-1,
		249,
		250,
		234,
		237,
		245,
		243,
		256,
		248,
		243,
		-1,
		-1,
		240,
		236,
		243,
		230,
		226,
		243,
		256,
		238,
		252,
		251,
		-1,
		244,
		262,
		269,
		237,
		235,
		219,
		217,
		235,
		237,
		243,
		243,
		-1,
		253,
		254,
		249,
		257,
		259,
		235,
		222,
		222,
		232,
		225,
		244,
		232,
		278,
		-1,
		-1,
		-1,
		-1,
		-1,
		287,
		253,
		236,
		253,
		245,
		235,
		250,
		243,
		225,
		222,
		220,
		217,
		233,
		231,
		241,
		-1,
		-1,
		346,
		315,
		344,
		302,
		283,
		-1,
		249,
		229,
		235,
		239,
		233,
		226,
		240,
		236,
		-1,
		211,
		210,
		238,
		224,
		235,
		306,
		-1,
		-1,
		304,
		296,
		279,
		282,
		259,
		255,
		244,
		243,
		235,
		221,
		217,
		223,
		226,
		226,
		232,
		205,
		215,
		219,
		217,
		242,
		-1,
		-1,
		277,
		-1,
		-1,
		303,
		286,
		-1,
		269,
		276,
		265,
		271,
		257,
		278,
		254,
		245,
		237,
		231,
		219,
		221,
		218,
		231,
		219,
		202,
		227,
		231,
		212,
		233,
		228,
		-1,
		276,
		260,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		281,
		262,
		265,
		271,
		295,
		294,
		-1,
		266,
		254,
		255,
		240,
		237,
		224,
		212,
		225,
		210,
		217,
		216,
		206,
		204,
		234,
		209,
		231,
		228,
		247,
		252,
		246,
		255,
		-1,
		311,
		307,
		303,
		310,
		259,
		-1,
		-1,
		299,
		-1,
		302,
		303,
		278,
		251,
		254,
		241,
		232,
		219,
		208,
		219,
		208,
		205,
		213,
		198,
		213,
		204,
		203,
		221,
		231,
		239,
		243,
		249,
		-1,
		361,
		-1,
		303,
		287,
		289,
		261,
		282,
		-1,
		319,
		303,
		295,
		280,
		280,
		-1,
		250,
		247,
		237,
		215,
		200,
		217,
		209,
		207,
		211,
		193,
		207,
		198,
		216,
		223,
		221,
		225,
		245,
		257,
		321,
		311,
		-1,
		293,
		298,
		257,
		265,
		284,
		322,
		286,
		-1,
		281,
		-1,
		252,
		265,
		-1,
		221,
		217,
		199,
		200,
		195,
		210,
		204,
		189,
		186,
		204,
		207,
		214,
		218,
		234,
		-1,
		-1,
		306,
		310,
		299,
		250,
		269,
		293,
		330,
		279,
		268,
		267,
		-1,
		258,
		235,
		232,
		220,
		207,
		192,
		193,
		201,
		214,
		193,
		188,
		185,
		205,
		231,
		209,
		221,
		-1,
		-1,
		-1,
		331,
		-1,
		-1,
		276,
		247,
		271,
		313,
		297,
		290,
		278,
		243,
		243,
		237,
		-1,
		231,
		210,
		201,
		190,
		188,
		201,
		198,
		203,
		183,
		181,
		200,
		212,
		203,
		220,
		-1,
		-1,
		-1,
		306,
		295,
		296,
		242,
		265,
		302,
		276,
		262,
		267,
		242,
		235,
		229,
		244,
		227,
		208,
		197,
		189,
		178,
		194,
		202,
		197,
		179,
		188,
		194,
		218,
		208,
		214,
		-1,
		-1,
		313,
		303,
		287,
		289,
		286,
		256,
		263,
		295,
		267,
		280,
		-1,
		234,
		-1,
		223,
		218,
		202,
		197,
		194,
		191,
		185,
		194,
		196,
		186,
		181,
		188,
		223,
		223,
		198,
		218,
		221,
		-1,
		-1,
		-1,
		306,
		301,
		276,
		253,
		237,
		273,
		-1,
		250,
		251,
		-1,
		228,
		222,
		219,
		204,
		200,
		195,
		199,
		192,
		199,
		192,
		190,
		191,
		173,
		205,
		-1,
		206,
		200,
		208,
		198,
		186,
		-1,
		-1,
		-1,
		299,
		278,
		271,
		291,
		232,
		284,
		-1,
		-1,
		235,
		228,
		-1,
		215,
		197,
		204,
		202,
		196,
		200,
		197,
		186,
		199,
		192,
		178,
		180,
		193,
		197,
		201,
		188,
		184,
		181,
		195,
		-1,
		318,
		-1,
		-1,
		-1,
		-1,
		-1,
		232,
		252,
		-1,
		244,
		236,
		226,
		220,
		214,
		210,
		208,
		224,
		208,
		211,
		209,
		200,
		208,
		181,
		174,
		181,
		170,
		188,
		196,
		188,
		182,
		181,
		191,
		-1,
		319,
		305,
		276,
		-1,
		-1,
		265,
		-1,
		229,
		243,
		259,
		-1,
		252,
		231,
		246,
		224,
		220,
		216,
		231,
		232,
		209,
		209,
		207,
		198,
		186,
		175,
		178,
		170,
		192,
		192,
		176,
		177,
		181,
		-1,
		325,
		312,
		270,
		266,
		255,
		275,
		226,
		214,
		246,
		-1,
		-1,
		288,
		-1,
		222,
		239,
		230,
		228,
		221,
		203,
		210,
		218,
		195,
		190,
		180,
		169,
		169,
		164,
		186,
		172,
		170,
		179,
		195,
		-1,
		-1,
		-1,
		292,
		-1,
		-1,
		241,
		228,
		222,
		-1,
		263,
		-1,
		266,
		256,
		240,
		225,
		258,
		-1,
		202,
		198,
		205,
		-1,
		215,
		-1,
		188,
		185,
		176,
		161,
		158,
		169,
		167,
		178,
		174,
		-1,
		275,
		260,
		253,
		243,
		257,
		228,
		-1,
		283,
		-1,
		-1,
		253,
		247,
		247,
		231,
		232,
		218,
		198,
		190,
		205,
		204,
		191,
		190,
		174,
		167,
		164,
		157,
		170,
		180,
		185,
		172,
		-1,
		-1,
		-1,
		280,
		266,
		270,
		230,
		249,
		-1,
		-1,
		315,
		270,
		256,
		-1,
		227,
		218,
		206,
		196,
		186,
		191,
		192,
		182,
		180,
		172,
		174,
		168,
		159,
		158,
		174,
		166,
		188,
		-1,
		-1,
		263,
		268,
		256,
		242,
		261,
		-1,
		-1,
		-1,
		262,
		278,
		246,
		225,
		207,
		-1,
		-1,
		190,
		183,
		177,
		180,
		168,
		188,
		183,
		167,
		152,
		167,
		171,
		179,
		170,
		-1,
		266,
		253,
		-1,
		-1,
		264,
		258,
		-1,
		-1,
		-1,
		-1,
		258,
		203,
		192,
		187,
		191,
		189,
		-1,
		163,
		174,
		167,
		186,
		193,
		169,
		154,
		148,
		154,
		166,
		175,
		-1,
		-1,
		278,
		-1,
		251,
		-1,
		-1,
		-1,
		-1,
		215,
		209,
		180,
		173,
		177,
		-1,
		165,
		167,
		164,
		176,
		172,
		169,
		160,
		151,
		147,
		151,
		155,
		169,
		173,
		301,
		-1,
		242,
		-1,
		-1,
		-1,
		233,
		248,
		219,
		196,
		169,
		164,
		157,
		151,
		156,
		167,
		176,
		187,
		152,
		154,
		144,
		143,
		147,
		164,
		168,
		-1,
		-1,
		240,
		236,
		259,
		241,
		245,
		246,
		-1,
		-1,
		173,
		164,
		155,
		147,
		160,
		163,
		148,
		150,
		150,
		148,
		142,
		152,
		167,
		162,
		-1,
		-1,
		-1,
		252,
		-1,
		254,
		-1,
		-1,
		243,
		244,
		191,
		173,
		169,
		167,
		156,
		150,
		138,
		143,
		153,
		147,
		144,
		138,
		142,
		165,
		154,
		193,
		-1,
		-1,
		287,
		-1,
		-1,
		-1,
		232,
		223,
		218,
		225,
		227,
		218,
		206,
		203,
		-1,
		173,
		179,
		144,
		151,
		134,
		141,
		146,
		143,
		132,
		139,
		155,
		154,
		149,
		185,
		176,
		182,
		-1,
		-1,
		280,
		269,
		258,
		264,
		-1,
		225,
		220,
		211,
		201,
		204,
		-1,
		-1,
		198,
		195,
		175,
		144,
		142,
		135,
		130,
		140,
		116,
		128,
		132,
		136,
		142,
		147,
		152,
		158,
		173,
		188,
		-1,
		234,
		271,
		264,
		232,
		240,
		271,
		-1,
		215,
		207,
		217,
		193,
		195,
		-1,
		-1,
		171,
		162,
		163,
		151,
		148,
		154,
		153,
		136,
		142,
		143,
		135,
		134,
		152,
		156,
		165,
		172,
		162,
		175,
		179,
		-1,
		227,
		247,
		226,
		229,
		253,
		267,
		-1,
		212,
		-1,
		-1,
		177,
		196,
		180,
		170,
		167,
		210,
		165,
		160,
		141,
		139,
		134,
		125,
		150,
		143,
		143,
		146,
		161,
		166,
		158,
		172,
		172,
		173,
		-1,
		216,
		227,
		220,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		-1,
		167,
		-1,
		207,
		-1,
		190,
		194,
		173,
		176,
		155,
		142,
		128,
		136,
		142,
		141,
		147,
		147,
		148,
		157,
		168,
		180,
		179,
		180,
		241,
		197,
		200,
		211,
		222,
		237,
		241,
		-1,
		205,
		241,
		173,
		-1,
		157,
		-1,
		-1,
		-1,
		204,
		186,
		178,
		175,
		154,
		154,
		120,
		124,
		137,
		144,
		154,
		165,
		157,
		161,
		174,
		185,
		188,
		237,
		228,
		241,
		186,
		186,
		207,
		216,
		237,
		201,
		198,
		235,
		180,
		169,
		164,
		151,
		-1,
		-1,
		188,
		196,
		-1,
		-1,
		161,
		128,
		116,
		126,
		130,
		144,
		156,
		169,
		157,
		162,
		156,
		188,
		-1,
		230,
		229,
		218,
		215,
		191,
		182,
		177,
		204,
		-1,
		-1,
		199,
		226,
		210,
		213,
		211,
		236,
		-1,
		140,
		-1,
		-1,
		168,
		-1,
		-1,
		153,
		133,
		122,
		113,
		118,
		138,
		149,
		171,
		153,
		170,
		161,
		171,
		175,
		214,
		211,
		199,
		197,
		220,
		185,
		173,
		-1,
		181,
		184,
		190,
		197,
		214,
		225,
		-1,
		-1,
		156,
		136,
		-1,
		-1,
		151,
		149,
		138,
		-1,
		128,
		110,
		115,
		145,
		147,
		149,
		156,
		150,
		157,
		165,
		176,
		168,
		223,
		237,
		226,
		222,
		221,
		229,
		178,
		171,
		178,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		161,
		-1,
		146,
		142,
		-1,
		-1,
		146,
		139,
		127,
		115,
		105,
		115,
		132,
		132,
		135,
		140,
		148,
		159,
		155,
		159,
		162,
		-1,
		257,
		-1,
		209,
		170,
		176,
		191,
		199,
		-1,
		-1,
		-1,
		163,
		149,
		142,
		130,
		128,
		-1,
		180,
		164,
		145,
		-1,
		115,
		128,
		168,
		136,
		141,
		136,
		151,
		162,
		153,
		161,
		155,
		158,
		-1,
		-1,
		169,
		152,
		-1,
		-1,
		126,
		128,
		-1,
		154,
		143,
		128,
		120,
		-1,
		-1,
		152,
		148,
		-1,
		-1,
		102,
		140,
		139,
		147,
		142,
		147,
		159,
		155,
		151,
		161,
		152,
		-1,
		-1,
		147,
		139,
		133,
		-1,
		111,
		-1,
		156,
		-1,
		123,
		129,
		117,
		-1,
		-1,
		-1,
		133,
		96,
		112,
		135,
		161,
		159,
		150,
		143,
		150,
		153,
		146,
		152,
		-1,
		-1,
		-1,
		129,
		103,
		163,
		154,
		137,
		117,
		109,
		128,
		-1,
		114,
		-1,
		89,
		92,
		117,
		156,
		158,
		144,
		140,
		153,
		147,
		144,
		142,
		135,
		-1,
		105,
		138,
		102,
		123,
		95,
		103,
		128,
		-1,
		111,
		93,
		-1,
		121,
		111,
		159,
		134,
		143,
		136,
		130,
		131,
		139,
		-1,
		-1,
		-1,
		107,
		106,
		98,
		92,
		92,
		90,
		95,
		-1,
		116,
		98,
		84,
		101,
		101,
		92,
		100,
		149,
		145,
		148,
		146,
		124,
		-1,
		138,
		-1,
		-1,
		130,
		-1,
		-1,
		-1,
		101,
		85,
		96,
		84,
		85,
		81,
		81,
		83,
		96,
		104,
		102,
		99,
		111,
		107,
		127,
		123,
		155,
		-1,
		133,
		-1,
		137,
		-1,
		-1,
		82,
		69,
		79,
		90,
		96,
		94,
		80,
		76,
		93,
		128,
		114,
		112,
		117,
		122,
		-1,
		122,
		121,
		-1,
		101,
		93,
		79,
		-1,
		60,
		-1,
		142,
		103,
		-1,
		77,
		71,
		-1,
		123,
		119,
		-1,
		-1,
		109,
		104,
		-1,
		-1,
		-1,
		80,
		44,
		137,
		121,
		-1,
		61,
		68,
		-1,
		-1,
		-1,
		94,
		95,
		-1,
		73,
		76,
		-1,
		40,
		31,
		39,
		54,
		62,
		-1,
		-1,
		-1,
		103,
		84,
		78,
		80,
		75,
		81,
		52,
		38,
		17,
		39,
		53,
		82,
		-1,
		-1,
		-1,
		75,
		67,
		60,
		-1,
		-1,
		47,
		30,
		30,
		48,
		-1,
		-1,
		-1,
		97,
		78,
		-1,
		-1,
		52,
		-1,
		-1,
		0,
		38,
		-1,
		-1,
		-1,
		-1,
		-1,
		114,
		86,
		-1,
		-1,
		-1,
		48,
		43,
		11,
		-1,
		-1,
		-1,
		-1,
		108,
		109,
		132,
		95,
		-1,
		-1,
		-1,
		39,
		27,
		-1,
		-1,
		111,
		109,
		-1,
		-1,
		-1,
		67,
		51,
		-1,
		39,
		-1,
		-1,
		-1,
		58,
		-1,
		-1,
		72,
		-1,
		-1,
		-1,
		72,
		-1,
		74,
		49,
		56,
		-1,
		-1,
		-1,
		-1,
		85,
		77,
		87,
		-1,
		59,
		61,
		-1,
		109,
		-1,
		-1,
		100,
		91,
		-1,
		-1,
		64,
		71,
		93,
		96,
		130,
		-1,
		83
	],
	[
		-1,
		276,
		265,
		276,
		284,
		257,
		264,
		-1,
		283,
		287,
		253,
		247,
		286,
		255,
		261,
		272,
		-1,
		-1,
		-1,
		276,
		275,
		243,
		241,
		250,
		255,
		262,
		-1,
		261,
		-1,
		297,
		276,
		287,
		292,
		236,
		233,
		253,
		272,
		254,
		246,
		312,
		266,
		237,
		231,
		249,
		239,
		248,
		240,
		-1,
		237,
		227,
		249,
		228,
		239,
		231,
		-1,
		-1,
		231,
		232,
		238,
		224,
		230,
		226,
		-1,
		236,
		220,
		-1,
		-1,
		221,
		222,
		206,
		209,
		217,
		215,
		228,
		220,
		215,
		-1,
		-1,
		212,
		208,
		215,
		202,
		198,
		215,
		228,
		210,
		224,
		223,
		-1,
		216,
		234,
		241,
		209,
		207,
		191,
		189,
		207,
		209,
		215,
		215,
		-1,
		225,
		226,
		221,
		229,
		231,
		207,
		194,
		194,
		204,
		197,
		216,
		204,
		250,
		-1,
		-1,
		-1,
		-1,
		-1,
		259,
		225,
		208,
		225,
		217,
		207,
		222,
		215,
		197,
		194,
		192,
		189,
		205,
		203,
		213,
		-1,
		-1,
		318,
		287,
		316,
		274,
		255,
		-1,
		221,
		201,
		207,
		211,
		205,
		198,
		212,
		208,
		-1,
		183,
		182,
		210,
		196,
		207,
		278,
		-1,
		-1,
		276,
		268,
		251,
		254,
		231,
		227,
		216,
		215,
		207,
		193,
		189,
		195,
		198,
		198,
		204,
		177,
		187,
		191,
		189,
		214,
		-1,
		-1,
		249,
		-1,
		-1,
		275,
		258,
		-1,
		241,
		248,
		237,
		243,
		229,
		250,
		226,
		217,
		209,
		203,
		191,
		193,
		190,
		203,
		191,
		174,
		199,
		203,
		184,
		205,
		200,
		-1,
		248,
		232,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		253,
		234,
		237,
		243,
		267,
		266,
		-1,
		238,
		226,
		227,
		212,
		209,
		196,
		184,
		197,
		182,
		189,
		188,
		178,
		176,
		206,
		181,
		203,
		200,
		219,
		224,
		218,
		227,
		-1,
		283,
		279,
		275,
		282,
		231,
		-1,
		-1,
		271,
		-1,
		274,
		275,
		250,
		223,
		226,
		213,
		204,
		191,
		180,
		191,
		180,
		177,
		185,
		170,
		185,
		176,
		175,
		193,
		203,
		211,
		215,
		221,
		-1,
		333,
		-1,
		275,
		259,
		261,
		233,
		254,
		-1,
		291,
		275,
		267,
		252,
		252,
		-1,
		222,
		219,
		209,
		187,
		172,
		189,
		181,
		179,
		183,
		165,
		179,
		170,
		188,
		195,
		193,
		197,
		217,
		229,
		293,
		283,
		-1,
		265,
		270,
		229,
		237,
		256,
		294,
		258,
		-1,
		253,
		-1,
		224,
		237,
		-1,
		193,
		189,
		171,
		172,
		167,
		182,
		176,
		161,
		158,
		176,
		179,
		186,
		190,
		206,
		-1,
		-1,
		278,
		282,
		271,
		222,
		241,
		265,
		302,
		251,
		240,
		239,
		-1,
		230,
		207,
		204,
		192,
		179,
		164,
		165,
		173,
		186,
		165,
		160,
		157,
		177,
		203,
		181,
		193,
		-1,
		-1,
		-1,
		303,
		-1,
		-1,
		248,
		219,
		243,
		285,
		269,
		262,
		250,
		215,
		215,
		209,
		-1,
		203,
		182,
		173,
		162,
		160,
		173,
		170,
		175,
		155,
		153,
		172,
		184,
		175,
		192,
		-1,
		-1,
		-1,
		278,
		267,
		268,
		214,
		237,
		274,
		248,
		234,
		239,
		214,
		207,
		201,
		216,
		199,
		180,
		169,
		161,
		150,
		166,
		174,
		169,
		151,
		160,
		166,
		190,
		180,
		186,
		-1,
		-1,
		285,
		275,
		259,
		261,
		258,
		228,
		235,
		267,
		239,
		252,
		-1,
		206,
		-1,
		195,
		190,
		174,
		169,
		166,
		163,
		157,
		166,
		168,
		158,
		153,
		160,
		195,
		195,
		170,
		190,
		193,
		-1,
		-1,
		-1,
		278,
		273,
		248,
		225,
		209,
		245,
		-1,
		222,
		223,
		-1,
		200,
		194,
		191,
		176,
		172,
		167,
		171,
		164,
		171,
		164,
		162,
		163,
		145,
		177,
		-1,
		178,
		172,
		180,
		170,
		158,
		-1,
		-1,
		-1,
		271,
		250,
		243,
		263,
		204,
		256,
		-1,
		-1,
		207,
		200,
		-1,
		187,
		169,
		176,
		174,
		168,
		172,
		169,
		158,
		171,
		164,
		150,
		152,
		165,
		169,
		173,
		160,
		156,
		153,
		167,
		-1,
		290,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		224,
		-1,
		216,
		208,
		198,
		192,
		186,
		182,
		180,
		196,
		180,
		183,
		181,
		172,
		180,
		153,
		146,
		153,
		142,
		160,
		168,
		160,
		154,
		153,
		163,
		-1,
		291,
		277,
		248,
		-1,
		-1,
		237,
		-1,
		201,
		215,
		231,
		-1,
		224,
		203,
		218,
		196,
		192,
		188,
		203,
		204,
		181,
		181,
		179,
		170,
		158,
		147,
		150,
		142,
		164,
		164,
		148,
		149,
		153,
		-1,
		297,
		284,
		242,
		238,
		227,
		247,
		198,
		186,
		218,
		-1,
		-1,
		260,
		-1,
		194,
		211,
		202,
		200,
		193,
		175,
		182,
		190,
		167,
		162,
		152,
		141,
		141,
		136,
		158,
		144,
		142,
		151,
		167,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		213,
		200,
		194,
		-1,
		235,
		-1,
		238,
		228,
		212,
		197,
		230,
		-1,
		174,
		170,
		177,
		-1,
		187,
		-1,
		160,
		157,
		148,
		133,
		130,
		141,
		139,
		150,
		146,
		-1,
		247,
		232,
		225,
		215,
		229,
		200,
		-1,
		255,
		-1,
		-1,
		225,
		219,
		219,
		203,
		204,
		190,
		170,
		162,
		177,
		176,
		163,
		162,
		146,
		139,
		136,
		129,
		142,
		152,
		157,
		144,
		-1,
		-1,
		-1,
		252,
		238,
		242,
		202,
		221,
		-1,
		-1,
		287,
		242,
		228,
		-1,
		199,
		190,
		178,
		168,
		158,
		163,
		164,
		154,
		152,
		144,
		146,
		140,
		131,
		130,
		146,
		138,
		160,
		-1,
		-1,
		235,
		240,
		228,
		214,
		233,
		-1,
		-1,
		-1,
		234,
		250,
		218,
		197,
		179,
		-1,
		-1,
		162,
		155,
		149,
		152,
		140,
		160,
		155,
		139,
		124,
		139,
		143,
		151,
		142,
		-1,
		238,
		225,
		-1,
		-1,
		236,
		230,
		-1,
		-1,
		-1,
		-1,
		230,
		175,
		164,
		159,
		163,
		161,
		-1,
		135,
		146,
		139,
		158,
		165,
		141,
		126,
		120,
		126,
		138,
		147,
		-1,
		-1,
		250,
		-1,
		223,
		-1,
		-1,
		-1,
		-1,
		187,
		181,
		152,
		145,
		149,
		-1,
		137,
		139,
		136,
		148,
		144,
		141,
		132,
		123,
		119,
		123,
		127,
		141,
		145,
		273,
		-1,
		214,
		-1,
		-1,
		-1,
		205,
		220,
		191,
		168,
		141,
		136,
		129,
		123,
		128,
		139,
		148,
		159,
		124,
		126,
		116,
		115,
		119,
		136,
		140,
		-1,
		-1,
		212,
		208,
		231,
		213,
		217,
		218,
		-1,
		-1,
		145,
		136,
		127,
		119,
		132,
		135,
		120,
		122,
		122,
		120,
		114,
		124,
		139,
		134,
		-1,
		-1,
		-1,
		224,
		-1,
		226,
		-1,
		-1,
		215,
		216,
		163,
		145,
		141,
		139,
		128,
		122,
		110,
		115,
		125,
		119,
		116,
		110,
		114,
		137,
		126,
		165,
		-1,
		-1,
		286,
		-1,
		-1,
		-1,
		204,
		195,
		190,
		197,
		199,
		190,
		178,
		175,
		-1,
		145,
		151,
		116,
		123,
		106,
		113,
		118,
		115,
		104,
		111,
		127,
		126,
		121,
		157,
		148,
		154,
		-1,
		-1,
		279,
		268,
		257,
		263,
		-1,
		197,
		192,
		183,
		173,
		176,
		-1,
		-1,
		170,
		167,
		147,
		116,
		114,
		107,
		102,
		112,
		88,
		100,
		104,
		108,
		114,
		119,
		124,
		130,
		145,
		160,
		-1,
		233,
		270,
		263,
		231,
		239,
		270,
		-1,
		187,
		179,
		189,
		165,
		167,
		-1,
		-1,
		143,
		134,
		135,
		123,
		120,
		126,
		125,
		108,
		114,
		115,
		107,
		106,
		124,
		128,
		137,
		144,
		134,
		147,
		151,
		-1,
		226,
		246,
		225,
		228,
		252,
		266,
		-1,
		184,
		-1,
		-1,
		149,
		168,
		152,
		142,
		139,
		182,
		137,
		132,
		113,
		111,
		106,
		97,
		122,
		115,
		115,
		118,
		133,
		138,
		130,
		144,
		144,
		145,
		-1,
		215,
		226,
		219,
		-1,
		-1,
		-1,
		-1,
		185,
		-1,
		-1,
		139,
		-1,
		179,
		-1,
		162,
		166,
		145,
		148,
		127,
		114,
		100,
		108,
		114,
		113,
		119,
		119,
		120,
		129,
		140,
		152,
		151,
		152,
		240,
		196,
		199,
		210,
		221,
		236,
		240,
		-1,
		196,
		235,
		145,
		-1,
		129,
		-1,
		-1,
		-1,
		176,
		158,
		150,
		147,
		126,
		126,
		92,
		96,
		109,
		116,
		126,
		137,
		129,
		133,
		146,
		157,
		160,
		236,
		227,
		240,
		185,
		185,
		206,
		215,
		236,
		200,
		197,
		229,
		152,
		141,
		136,
		123,
		-1,
		-1,
		160,
		168,
		-1,
		-1,
		133,
		100,
		88,
		98,
		102,
		116,
		128,
		141,
		129,
		134,
		128,
		160,
		-1,
		229,
		228,
		217,
		214,
		190,
		181,
		176,
		203,
		-1,
		-1,
		198,
		225,
		208,
		185,
		183,
		208,
		-1,
		112,
		-1,
		-1,
		140,
		-1,
		-1,
		125,
		105,
		94,
		85,
		90,
		110,
		121,
		143,
		125,
		142,
		133,
		143,
		147,
		213,
		210,
		198,
		196,
		219,
		184,
		172,
		-1,
		180,
		183,
		189,
		196,
		186,
		197,
		-1,
		-1,
		128,
		108,
		-1,
		-1,
		123,
		121,
		110,
		-1,
		100,
		82,
		87,
		117,
		119,
		121,
		128,
		122,
		129,
		137,
		148,
		140,
		222,
		236,
		225,
		221,
		220,
		228,
		177,
		170,
		177,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		-1,
		118,
		114,
		-1,
		-1,
		118,
		111,
		99,
		87,
		77,
		87,
		104,
		104,
		107,
		112,
		120,
		131,
		127,
		131,
		134,
		-1,
		256,
		-1,
		208,
		169,
		175,
		190,
		198,
		-1,
		-1,
		-1,
		135,
		121,
		114,
		102,
		100,
		-1,
		152,
		136,
		117,
		-1,
		87,
		100,
		140,
		108,
		113,
		108,
		123,
		134,
		125,
		133,
		127,
		130,
		-1,
		-1,
		168,
		151,
		-1,
		-1,
		125,
		127,
		-1,
		126,
		115,
		100,
		92,
		-1,
		-1,
		124,
		120,
		-1,
		-1,
		74,
		112,
		111,
		119,
		114,
		119,
		131,
		127,
		123,
		133,
		124,
		-1,
		-1,
		146,
		138,
		132,
		-1,
		110,
		-1,
		128,
		-1,
		95,
		101,
		89,
		-1,
		-1,
		-1,
		105,
		68,
		84,
		107,
		133,
		131,
		122,
		115,
		122,
		125,
		118,
		124,
		-1,
		-1,
		-1,
		128,
		102,
		135,
		126,
		109,
		89,
		81,
		100,
		-1,
		86,
		-1,
		61,
		64,
		89,
		128,
		130,
		116,
		112,
		125,
		119,
		116,
		114,
		134,
		-1,
		104,
		137,
		101,
		95,
		71,
		75,
		100,
		-1,
		83,
		65,
		-1,
		93,
		83,
		131,
		106,
		115,
		108,
		102,
		103,
		111,
		-1,
		-1,
		-1,
		106,
		105,
		97,
		91,
		91,
		76,
		67,
		-1,
		88,
		70,
		56,
		73,
		73,
		64,
		72,
		121,
		117,
		120,
		118,
		96,
		-1,
		115,
		-1,
		-1,
		129,
		-1,
		-1,
		-1,
		100,
		95,
		68,
		56,
		57,
		53,
		53,
		55,
		68,
		76,
		74,
		71,
		83,
		79,
		99,
		95,
		127,
		-1,
		110,
		-1,
		136,
		-1,
		-1,
		97,
		84,
		90,
		79,
		68,
		66,
		52,
		48,
		65,
		100,
		86,
		84,
		89,
		94,
		-1,
		99,
		98,
		-1,
		92,
		102,
		94,
		-1,
		75,
		-1,
		114,
		75,
		-1,
		49,
		43,
		-1,
		95,
		91,
		-1,
		-1,
		86,
		81,
		-1,
		-1,
		-1,
		81,
		59,
		109,
		93,
		-1,
		33,
		40,
		-1,
		-1,
		-1,
		71,
		72,
		-1,
		67,
		77,
		-1,
		55,
		46,
		54,
		28,
		34,
		-1,
		-1,
		-1,
		80,
		61,
		55,
		57,
		52,
		82,
		67,
		53,
		37,
		15,
		25,
		54,
		-1,
		-1,
		-1,
		52,
		44,
		37,
		-1,
		-1,
		62,
		45,
		26,
		24,
		-1,
		-1,
		-1,
		74,
		55,
		-1,
		-1,
		29,
		-1,
		-1,
		38,
		0,
		-1,
		-1,
		-1,
		-1,
		-1,
		91,
		63,
		-1,
		-1,
		-1,
		25,
		21,
		22,
		-1,
		-1,
		-1,
		-1,
		85,
		86,
		109,
		73,
		-1,
		-1,
		-1,
		17,
		11,
		-1,
		-1,
		88,
		86,
		-1,
		-1,
		-1,
		45,
		29,
		-1,
		18,
		-1,
		-1,
		-1,
		36,
		-1,
		-1,
		51,
		-1,
		-1,
		-1,
		50,
		-1,
		53,
		28,
		35,
		-1,
		-1,
		-1,
		-1,
		63,
		55,
		66,
		-1,
		38,
		40,
		-1,
		88,
		-1,
		-1,
		78,
		69,
		-1,
		-1,
		43,
		50,
		72,
		75,
		108,
		-1,
		62
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		374,
		363,
		374,
		382,
		355,
		362,
		-1,
		381,
		385,
		351,
		345,
		384,
		353,
		359,
		370,
		-1,
		-1,
		-1,
		374,
		373,
		341,
		339,
		348,
		353,
		360,
		-1,
		359,
		-1,
		395,
		374,
		385,
		390,
		334,
		331,
		351,
		370,
		352,
		344,
		410,
		364,
		335,
		329,
		347,
		337,
		346,
		338,
		-1,
		335,
		325,
		347,
		326,
		337,
		329,
		-1,
		-1,
		329,
		330,
		336,
		322,
		328,
		324,
		-1,
		334,
		318,
		-1,
		-1,
		319,
		320,
		304,
		307,
		315,
		313,
		326,
		318,
		313,
		-1,
		-1,
		310,
		306,
		313,
		300,
		296,
		313,
		326,
		308,
		322,
		321,
		-1,
		314,
		332,
		339,
		307,
		305,
		289,
		287,
		305,
		307,
		313,
		313,
		-1,
		323,
		324,
		319,
		327,
		329,
		305,
		292,
		292,
		302,
		295,
		314,
		302,
		348,
		-1,
		-1,
		-1,
		-1,
		-1,
		357,
		323,
		306,
		323,
		315,
		305,
		320,
		313,
		295,
		292,
		290,
		287,
		303,
		301,
		311,
		-1,
		-1,
		416,
		385,
		414,
		372,
		353,
		-1,
		319,
		299,
		305,
		309,
		303,
		296,
		310,
		306,
		-1,
		281,
		280,
		308,
		294,
		305,
		376,
		-1,
		-1,
		374,
		366,
		349,
		352,
		329,
		325,
		314,
		313,
		305,
		291,
		287,
		293,
		296,
		296,
		302,
		275,
		285,
		289,
		287,
		312,
		-1,
		-1,
		347,
		-1,
		-1,
		373,
		356,
		-1,
		339,
		346,
		335,
		341,
		327,
		348,
		324,
		315,
		307,
		301,
		289,
		291,
		288,
		301,
		289,
		272,
		297,
		301,
		282,
		303,
		298,
		-1,
		346,
		330,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		351,
		332,
		335,
		341,
		365,
		364,
		-1,
		336,
		324,
		325,
		310,
		307,
		294,
		282,
		295,
		280,
		287,
		286,
		276,
		274,
		304,
		279,
		301,
		298,
		317,
		322,
		316,
		325,
		-1,
		381,
		377,
		373,
		380,
		329,
		-1,
		-1,
		369,
		-1,
		372,
		373,
		348,
		321,
		324,
		311,
		302,
		289,
		278,
		289,
		278,
		275,
		283,
		268,
		283,
		274,
		273,
		291,
		301,
		309,
		313,
		319,
		-1,
		431,
		-1,
		373,
		357,
		359,
		331,
		352,
		-1,
		389,
		373,
		365,
		350,
		350,
		-1,
		320,
		317,
		307,
		285,
		270,
		287,
		279,
		277,
		281,
		263,
		277,
		268,
		286,
		293,
		291,
		295,
		315,
		327,
		391,
		381,
		-1,
		363,
		368,
		327,
		335,
		354,
		392,
		356,
		-1,
		351,
		-1,
		322,
		335,
		-1,
		291,
		287,
		269,
		270,
		265,
		280,
		274,
		259,
		256,
		274,
		277,
		284,
		288,
		304,
		-1,
		-1,
		376,
		380,
		369,
		320,
		339,
		363,
		400,
		349,
		338,
		337,
		-1,
		328,
		305,
		302,
		290,
		277,
		262,
		263,
		271,
		284,
		263,
		258,
		255,
		275,
		301,
		279,
		291,
		-1,
		-1,
		-1,
		401,
		-1,
		-1,
		346,
		317,
		341,
		383,
		367,
		360,
		348,
		313,
		313,
		307,
		-1,
		301,
		280,
		271,
		260,
		258,
		271,
		268,
		273,
		253,
		251,
		270,
		282,
		273,
		290,
		-1,
		-1,
		-1,
		376,
		365,
		366,
		312,
		335,
		372,
		346,
		332,
		337,
		312,
		305,
		299,
		314,
		297,
		278,
		267,
		259,
		248,
		264,
		272,
		267,
		249,
		258,
		264,
		288,
		278,
		284,
		-1,
		-1,
		383,
		373,
		357,
		359,
		356,
		326,
		333,
		365,
		337,
		350,
		-1,
		304,
		-1,
		293,
		288,
		272,
		267,
		264,
		261,
		255,
		264,
		266,
		256,
		251,
		258,
		293,
		293,
		268,
		288,
		291,
		-1,
		-1,
		-1,
		376,
		371,
		346,
		323,
		307,
		343,
		-1,
		320,
		321,
		-1,
		298,
		292,
		289,
		274,
		270,
		265,
		269,
		262,
		269,
		262,
		260,
		261,
		243,
		275,
		-1,
		276,
		270,
		278,
		268,
		256,
		-1,
		-1,
		-1,
		369,
		348,
		341,
		361,
		302,
		354,
		-1,
		-1,
		305,
		298,
		-1,
		285,
		267,
		274,
		272,
		266,
		270,
		267,
		256,
		269,
		262,
		248,
		250,
		263,
		267,
		271,
		258,
		254,
		251,
		265,
		-1,
		388,
		-1,
		-1,
		-1,
		-1,
		-1,
		302,
		322,
		-1,
		314,
		306,
		296,
		290,
		284,
		280,
		278,
		294,
		278,
		281,
		279,
		270,
		278,
		251,
		244,
		251,
		240,
		258,
		266,
		258,
		252,
		251,
		261,
		-1,
		389,
		375,
		346,
		-1,
		-1,
		335,
		-1,
		299,
		313,
		329,
		-1,
		322,
		301,
		316,
		294,
		290,
		286,
		301,
		302,
		279,
		279,
		277,
		268,
		256,
		245,
		248,
		240,
		262,
		262,
		246,
		247,
		251,
		-1,
		395,
		382,
		340,
		336,
		325,
		345,
		296,
		284,
		316,
		-1,
		-1,
		358,
		-1,
		292,
		309,
		300,
		298,
		291,
		273,
		280,
		288,
		265,
		260,
		250,
		239,
		239,
		234,
		256,
		242,
		240,
		249,
		265,
		-1,
		-1,
		-1,
		362,
		-1,
		-1,
		311,
		298,
		292,
		-1,
		333,
		-1,
		336,
		326,
		310,
		295,
		328,
		-1,
		272,
		268,
		275,
		-1,
		285,
		-1,
		258,
		255,
		246,
		231,
		228,
		239,
		237,
		248,
		244,
		-1,
		345,
		330,
		323,
		313,
		327,
		298,
		-1,
		353,
		-1,
		-1,
		323,
		317,
		317,
		301,
		302,
		288,
		268,
		260,
		275,
		274,
		261,
		260,
		244,
		237,
		234,
		227,
		240,
		250,
		255,
		242,
		-1,
		-1,
		-1,
		350,
		336,
		340,
		300,
		319,
		-1,
		-1,
		385,
		340,
		326,
		-1,
		297,
		288,
		276,
		266,
		256,
		261,
		262,
		252,
		250,
		242,
		244,
		238,
		229,
		228,
		244,
		236,
		258,
		-1,
		-1,
		333,
		338,
		326,
		312,
		330,
		-1,
		-1,
		-1,
		332,
		348,
		316,
		295,
		277,
		-1,
		-1,
		260,
		253,
		247,
		250,
		238,
		258,
		253,
		237,
		222,
		237,
		241,
		249,
		240,
		-1,
		336,
		323,
		-1,
		-1,
		329,
		319,
		-1,
		-1,
		-1,
		-1,
		328,
		273,
		262,
		257,
		261,
		259,
		-1,
		233,
		244,
		237,
		256,
		263,
		239,
		224,
		218,
		224,
		236,
		245,
		-1,
		-1,
		343,
		-1,
		305,
		-1,
		-1,
		-1,
		-1,
		285,
		279,
		250,
		243,
		247,
		-1,
		235,
		237,
		234,
		246,
		242,
		239,
		230,
		221,
		217,
		221,
		225,
		239,
		243,
		366,
		-1,
		296,
		-1,
		-1,
		-1,
		303,
		318,
		289,
		266,
		239,
		234,
		227,
		221,
		226,
		237,
		246,
		257,
		222,
		224,
		214,
		213,
		217,
		234,
		238,
		-1,
		-1,
		294,
		290,
		325,
		311,
		315,
		316,
		-1,
		-1,
		243,
		234,
		225,
		217,
		230,
		233,
		218,
		220,
		220,
		218,
		212,
		222,
		237,
		232,
		-1,
		-1,
		-1,
		306,
		-1,
		308,
		-1,
		-1,
		313,
		314,
		261,
		243,
		239,
		237,
		226,
		220,
		208,
		213,
		223,
		217,
		214,
		208,
		212,
		235,
		224,
		263,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		290,
		277,
		272,
		295,
		297,
		288,
		276,
		273,
		-1,
		243,
		249,
		214,
		221,
		204,
		211,
		216,
		213,
		202,
		209,
		225,
		224,
		219,
		255,
		246,
		252,
		-1,
		-1,
		323,
		312,
		301,
		307,
		-1,
		283,
		274,
		281,
		271,
		274,
		-1,
		-1,
		268,
		265,
		245,
		214,
		212,
		205,
		200,
		210,
		186,
		198,
		202,
		206,
		212,
		217,
		222,
		228,
		243,
		258,
		-1,
		277,
		314,
		307,
		275,
		283,
		314,
		-1,
		273,
		265,
		271,
		263,
		265,
		-1,
		-1,
		241,
		232,
		233,
		221,
		218,
		224,
		223,
		206,
		212,
		213,
		205,
		204,
		222,
		226,
		235,
		242,
		232,
		245,
		249,
		-1,
		270,
		290,
		269,
		272,
		296,
		310,
		-1,
		264,
		-1,
		-1,
		231,
		266,
		250,
		240,
		237,
		280,
		235,
		230,
		211,
		209,
		204,
		195,
		220,
		213,
		213,
		216,
		231,
		236,
		228,
		242,
		242,
		243,
		-1,
		259,
		270,
		263,
		-1,
		-1,
		-1,
		-1,
		258,
		-1,
		-1,
		221,
		-1,
		277,
		-1,
		260,
		264,
		243,
		246,
		225,
		212,
		198,
		206,
		212,
		211,
		217,
		217,
		218,
		227,
		238,
		250,
		249,
		250,
		269,
		240,
		243,
		254,
		265,
		280,
		284,
		-1,
		248,
		284,
		227,
		-1,
		211,
		-1,
		-1,
		-1,
		274,
		256,
		248,
		245,
		224,
		224,
		190,
		194,
		207,
		214,
		224,
		235,
		227,
		231,
		244,
		255,
		258,
		265,
		270,
		284,
		229,
		229,
		250,
		259,
		280,
		244,
		241,
		278,
		234,
		223,
		218,
		205,
		-1,
		-1,
		258,
		266,
		-1,
		-1,
		231,
		198,
		186,
		196,
		200,
		214,
		226,
		239,
		227,
		232,
		226,
		258,
		-1,
		263,
		262,
		251,
		248,
		234,
		225,
		220,
		247,
		-1,
		-1,
		242,
		269,
		253,
		257,
		265,
		290,
		-1,
		189,
		-1,
		-1,
		238,
		-1,
		-1,
		223,
		203,
		192,
		183,
		188,
		208,
		219,
		241,
		223,
		240,
		231,
		241,
		245,
		247,
		244,
		232,
		230,
		249,
		228,
		216,
		-1,
		224,
		227,
		233,
		240,
		257,
		279,
		-1,
		-1,
		205,
		185,
		-1,
		-1,
		221,
		219,
		208,
		-1,
		198,
		180,
		185,
		215,
		217,
		219,
		226,
		220,
		227,
		235,
		246,
		238,
		256,
		270,
		259,
		250,
		250,
		260,
		221,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		210,
		-1,
		195,
		191,
		-1,
		-1,
		216,
		209,
		197,
		185,
		175,
		185,
		202,
		202,
		205,
		210,
		218,
		229,
		225,
		229,
		232,
		-1,
		285,
		-1,
		252,
		213,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		212,
		198,
		191,
		179,
		177,
		-1,
		250,
		234,
		215,
		-1,
		185,
		198,
		238,
		206,
		211,
		206,
		221,
		232,
		223,
		231,
		225,
		228,
		-1,
		-1,
		212,
		195,
		-1,
		-1,
		169,
		171,
		-1,
		203,
		192,
		177,
		169,
		-1,
		-1,
		222,
		218,
		-1,
		-1,
		172,
		210,
		209,
		217,
		212,
		217,
		229,
		225,
		221,
		231,
		222,
		-1,
		-1,
		190,
		182,
		176,
		-1,
		154,
		-1,
		205,
		-1,
		172,
		181,
		169,
		-1,
		-1,
		-1,
		203,
		166,
		182,
		205,
		231,
		229,
		220,
		213,
		220,
		223,
		216,
		222,
		-1,
		-1,
		-1,
		172,
		146,
		212,
		203,
		186,
		166,
		158,
		180,
		-1,
		184,
		-1,
		159,
		162,
		187,
		226,
		228,
		214,
		210,
		223,
		217,
		214,
		212,
		178,
		-1,
		148,
		181,
		145,
		172,
		138,
		152,
		198,
		-1,
		181,
		163,
		-1,
		191,
		181,
		229,
		204,
		213,
		206,
		200,
		201,
		209,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		133,
		150,
		-1,
		186,
		168,
		154,
		171,
		171,
		162,
		170,
		219,
		215,
		218,
		216,
		194,
		-1,
		123,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		128,
		141,
		152,
		155,
		151,
		151,
		153,
		166,
		174,
		172,
		169,
		181,
		177,
		197,
		193,
		225,
		-1,
		118,
		-1,
		180,
		-1,
		-1,
		125,
		112,
		122,
		133,
		161,
		161,
		150,
		146,
		163,
		198,
		184,
		182,
		187,
		192,
		-1,
		107,
		106,
		-1,
		100,
		110,
		122,
		-1,
		103,
		-1,
		207,
		168,
		-1,
		147,
		141,
		-1,
		193,
		189,
		-1,
		-1,
		94,
		89,
		-1,
		-1,
		-1,
		102,
		111,
		202,
		186,
		-1,
		131,
		138,
		-1,
		-1,
		-1,
		79,
		80,
		-1,
		95,
		98,
		-1,
		112,
		118,
		146,
		126,
		132,
		-1,
		-1,
		-1,
		88,
		69,
		63,
		85,
		80,
		103,
		143,
		129,
		129,
		113,
		123,
		152,
		-1,
		-1,
		-1,
		50,
		57,
		65,
		-1,
		-1,
		154,
		137,
		124,
		122,
		-1,
		-1,
		-1,
		50,
		45,
		-1,
		-1,
		74,
		-1,
		-1,
		119,
		98,
		-1,
		-1,
		-1,
		-1,
		-1,
		0,
		37,
		-1,
		-1,
		-1,
		75,
		82,
		103,
		-1,
		-1,
		-1,
		-1,
		26,
		27,
		71,
		58,
		-1,
		-1,
		-1,
		89,
		92,
		-1,
		-1,
		29,
		27,
		-1,
		-1,
		-1,
		89,
		101,
		-1,
		103,
		-1,
		-1,
		-1,
		105,
		-1,
		-1,
		136,
		-1,
		-1,
		-1,
		119,
		-1,
		138,
		113,
		120,
		-1,
		-1,
		-1,
		-1,
		132,
		124,
		151,
		-1,
		123,
		125,
		-1,
		173,
		-1,
		-1,
		147,
		141,
		-1,
		-1,
		128,
		135,
		157,
		160,
		126,
		-1,
		147
	],
	[
		-1,
		343,
		332,
		343,
		351,
		324,
		331,
		-1,
		350,
		354,
		320,
		314,
		353,
		322,
		328,
		339,
		-1,
		-1,
		-1,
		343,
		342,
		310,
		308,
		317,
		322,
		329,
		-1,
		328,
		-1,
		364,
		343,
		354,
		359,
		303,
		300,
		320,
		339,
		321,
		313,
		379,
		333,
		304,
		298,
		316,
		306,
		315,
		307,
		-1,
		304,
		294,
		316,
		295,
		306,
		298,
		-1,
		-1,
		298,
		299,
		305,
		291,
		297,
		293,
		-1,
		303,
		287,
		-1,
		-1,
		288,
		289,
		273,
		276,
		284,
		282,
		295,
		287,
		282,
		-1,
		-1,
		279,
		275,
		282,
		269,
		265,
		282,
		295,
		277,
		291,
		290,
		-1,
		283,
		301,
		308,
		276,
		274,
		258,
		256,
		274,
		276,
		282,
		282,
		-1,
		292,
		293,
		288,
		296,
		298,
		274,
		261,
		261,
		271,
		264,
		283,
		271,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		326,
		292,
		275,
		292,
		284,
		274,
		289,
		282,
		264,
		261,
		259,
		256,
		272,
		270,
		280,
		-1,
		-1,
		385,
		354,
		383,
		341,
		322,
		-1,
		288,
		268,
		274,
		278,
		272,
		265,
		279,
		275,
		-1,
		250,
		249,
		277,
		263,
		274,
		345,
		-1,
		-1,
		343,
		335,
		318,
		321,
		298,
		294,
		283,
		282,
		274,
		260,
		256,
		262,
		265,
		265,
		271,
		244,
		254,
		258,
		256,
		281,
		-1,
		-1,
		316,
		-1,
		-1,
		342,
		325,
		-1,
		308,
		315,
		304,
		310,
		296,
		317,
		293,
		284,
		276,
		270,
		258,
		260,
		257,
		270,
		258,
		241,
		266,
		270,
		251,
		272,
		267,
		-1,
		315,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		301,
		304,
		310,
		334,
		333,
		-1,
		305,
		293,
		294,
		279,
		276,
		263,
		251,
		264,
		249,
		256,
		255,
		245,
		243,
		273,
		248,
		270,
		267,
		286,
		291,
		285,
		294,
		-1,
		350,
		346,
		342,
		349,
		298,
		-1,
		-1,
		338,
		-1,
		341,
		342,
		317,
		290,
		293,
		280,
		271,
		258,
		247,
		258,
		247,
		244,
		252,
		237,
		252,
		243,
		242,
		260,
		270,
		278,
		282,
		288,
		-1,
		400,
		-1,
		342,
		326,
		328,
		300,
		321,
		-1,
		358,
		342,
		334,
		319,
		319,
		-1,
		289,
		286,
		276,
		254,
		239,
		256,
		248,
		246,
		250,
		232,
		246,
		237,
		255,
		262,
		260,
		264,
		284,
		296,
		360,
		350,
		-1,
		332,
		337,
		296,
		304,
		323,
		361,
		325,
		-1,
		320,
		-1,
		291,
		304,
		-1,
		260,
		256,
		238,
		239,
		234,
		249,
		243,
		228,
		225,
		243,
		246,
		253,
		257,
		273,
		-1,
		-1,
		345,
		349,
		338,
		289,
		308,
		332,
		369,
		318,
		307,
		306,
		-1,
		297,
		274,
		271,
		259,
		246,
		231,
		232,
		240,
		253,
		232,
		227,
		224,
		244,
		270,
		248,
		260,
		-1,
		-1,
		-1,
		370,
		-1,
		-1,
		315,
		286,
		310,
		352,
		336,
		329,
		317,
		282,
		282,
		276,
		-1,
		270,
		249,
		240,
		229,
		227,
		240,
		237,
		242,
		222,
		220,
		239,
		251,
		242,
		259,
		-1,
		-1,
		-1,
		345,
		334,
		335,
		281,
		304,
		341,
		315,
		301,
		306,
		281,
		274,
		268,
		283,
		266,
		247,
		236,
		228,
		217,
		233,
		241,
		236,
		218,
		227,
		233,
		257,
		247,
		253,
		-1,
		-1,
		352,
		342,
		326,
		328,
		325,
		295,
		302,
		334,
		306,
		319,
		-1,
		273,
		-1,
		262,
		257,
		241,
		236,
		233,
		230,
		224,
		233,
		235,
		225,
		220,
		227,
		262,
		262,
		237,
		257,
		260,
		-1,
		-1,
		-1,
		345,
		340,
		315,
		292,
		276,
		312,
		-1,
		289,
		290,
		-1,
		267,
		261,
		258,
		243,
		239,
		234,
		238,
		231,
		238,
		231,
		229,
		230,
		212,
		244,
		-1,
		245,
		239,
		247,
		237,
		225,
		-1,
		-1,
		-1,
		338,
		317,
		310,
		330,
		271,
		323,
		-1,
		-1,
		274,
		267,
		-1,
		254,
		236,
		243,
		241,
		235,
		239,
		236,
		225,
		238,
		231,
		217,
		219,
		232,
		236,
		240,
		227,
		223,
		220,
		234,
		-1,
		357,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		291,
		-1,
		283,
		275,
		265,
		259,
		253,
		249,
		247,
		263,
		247,
		250,
		248,
		239,
		247,
		220,
		213,
		220,
		209,
		227,
		235,
		227,
		221,
		220,
		230,
		-1,
		358,
		344,
		315,
		-1,
		-1,
		304,
		-1,
		268,
		282,
		298,
		-1,
		291,
		270,
		285,
		263,
		259,
		255,
		270,
		271,
		248,
		248,
		246,
		237,
		225,
		214,
		217,
		209,
		231,
		231,
		215,
		216,
		220,
		-1,
		364,
		351,
		309,
		305,
		294,
		314,
		265,
		253,
		285,
		-1,
		-1,
		327,
		-1,
		261,
		278,
		269,
		267,
		260,
		242,
		249,
		257,
		234,
		229,
		219,
		208,
		208,
		203,
		225,
		211,
		209,
		218,
		234,
		-1,
		-1,
		-1,
		331,
		-1,
		-1,
		280,
		267,
		261,
		-1,
		302,
		-1,
		305,
		295,
		279,
		264,
		297,
		-1,
		241,
		237,
		244,
		-1,
		254,
		-1,
		227,
		224,
		215,
		200,
		197,
		208,
		206,
		217,
		213,
		-1,
		314,
		299,
		292,
		282,
		296,
		267,
		-1,
		322,
		-1,
		-1,
		292,
		286,
		286,
		270,
		271,
		257,
		237,
		229,
		244,
		243,
		230,
		229,
		213,
		206,
		203,
		196,
		209,
		219,
		224,
		211,
		-1,
		-1,
		-1,
		319,
		305,
		309,
		269,
		288,
		-1,
		-1,
		354,
		309,
		295,
		-1,
		266,
		257,
		245,
		235,
		225,
		230,
		231,
		221,
		219,
		211,
		213,
		207,
		198,
		197,
		213,
		205,
		227,
		-1,
		-1,
		302,
		307,
		295,
		281,
		299,
		-1,
		-1,
		-1,
		301,
		317,
		285,
		264,
		246,
		-1,
		-1,
		229,
		222,
		216,
		219,
		207,
		227,
		222,
		206,
		191,
		206,
		210,
		218,
		209,
		-1,
		305,
		292,
		-1,
		-1,
		298,
		288,
		-1,
		-1,
		-1,
		-1,
		297,
		242,
		231,
		226,
		230,
		228,
		-1,
		202,
		213,
		206,
		225,
		232,
		208,
		193,
		187,
		193,
		205,
		214,
		-1,
		-1,
		312,
		-1,
		274,
		-1,
		-1,
		-1,
		-1,
		254,
		248,
		219,
		212,
		216,
		-1,
		204,
		206,
		203,
		215,
		211,
		208,
		199,
		190,
		186,
		190,
		194,
		208,
		212,
		335,
		-1,
		265,
		-1,
		-1,
		-1,
		272,
		287,
		258,
		235,
		208,
		203,
		196,
		190,
		195,
		206,
		215,
		226,
		191,
		193,
		183,
		182,
		186,
		203,
		207,
		-1,
		-1,
		263,
		259,
		294,
		280,
		284,
		285,
		-1,
		-1,
		212,
		203,
		194,
		186,
		199,
		202,
		187,
		189,
		189,
		187,
		181,
		191,
		206,
		201,
		-1,
		-1,
		-1,
		275,
		-1,
		277,
		-1,
		-1,
		282,
		283,
		230,
		212,
		208,
		206,
		195,
		189,
		177,
		182,
		192,
		186,
		183,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		299,
		-1,
		-1,
		-1,
		259,
		246,
		241,
		264,
		266,
		257,
		245,
		242,
		-1,
		212,
		218,
		183,
		190,
		173,
		180,
		185,
		182,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		292,
		281,
		270,
		276,
		-1,
		252,
		243,
		250,
		240,
		243,
		-1,
		-1,
		237,
		234,
		214,
		183,
		181,
		174,
		169,
		179,
		155,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		246,
		283,
		276,
		244,
		252,
		283,
		-1,
		242,
		234,
		240,
		232,
		234,
		-1,
		-1,
		210,
		201,
		202,
		190,
		187,
		193,
		192,
		175,
		181,
		182,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		239,
		259,
		238,
		241,
		265,
		279,
		-1,
		233,
		-1,
		-1,
		200,
		235,
		219,
		209,
		206,
		249,
		204,
		199,
		180,
		178,
		173,
		164,
		189,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		228,
		239,
		232,
		-1,
		-1,
		-1,
		-1,
		227,
		-1,
		-1,
		190,
		-1,
		246,
		-1,
		229,
		233,
		212,
		215,
		194,
		181,
		167,
		175,
		181,
		180,
		186,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		253,
		209,
		212,
		223,
		234,
		249,
		253,
		-1,
		217,
		253,
		196,
		-1,
		180,
		-1,
		-1,
		-1,
		243,
		225,
		217,
		214,
		193,
		193,
		159,
		163,
		176,
		183,
		193,
		204,
		196,
		200,
		213,
		224,
		227,
		249,
		240,
		253,
		198,
		198,
		219,
		228,
		249,
		213,
		210,
		247,
		203,
		192,
		187,
		174,
		-1,
		-1,
		227,
		235,
		-1,
		-1,
		200,
		167,
		155,
		165,
		169,
		183,
		195,
		208,
		196,
		201,
		195,
		227,
		-1,
		242,
		241,
		230,
		227,
		203,
		194,
		189,
		216,
		-1,
		-1,
		211,
		238,
		222,
		226,
		234,
		259,
		-1,
		158,
		-1,
		-1,
		207,
		-1,
		-1,
		192,
		172,
		161,
		152,
		157,
		177,
		188,
		210,
		192,
		209,
		200,
		210,
		214,
		226,
		223,
		211,
		209,
		232,
		197,
		185,
		-1,
		193,
		196,
		202,
		209,
		226,
		248,
		-1,
		-1,
		174,
		154,
		-1,
		-1,
		190,
		188,
		177,
		-1,
		167,
		149,
		154,
		184,
		186,
		188,
		195,
		189,
		196,
		204,
		215,
		207,
		235,
		249,
		238,
		234,
		233,
		241,
		190,
		183,
		190,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		179,
		-1,
		164,
		160,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		171,
		171,
		174,
		179,
		187,
		198,
		194,
		198,
		201,
		-1,
		269,
		-1,
		221,
		182,
		188,
		203,
		211,
		-1,
		-1,
		-1,
		181,
		167,
		160,
		148,
		146,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		207,
		175,
		180,
		175,
		190,
		201,
		192,
		200,
		194,
		197,
		-1,
		-1,
		181,
		164,
		-1,
		-1,
		138,
		140,
		-1,
		172,
		161,
		146,
		138,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		141,
		179,
		178,
		186,
		181,
		186,
		198,
		194,
		190,
		200,
		191,
		-1,
		-1,
		159,
		151,
		145,
		-1,
		123,
		-1,
		174,
		-1,
		141,
		150,
		138,
		-1,
		-1,
		-1,
		172,
		135,
		151,
		174,
		200,
		198,
		189,
		182,
		189,
		192,
		185,
		191,
		-1,
		-1,
		-1,
		141,
		115,
		181,
		172,
		155,
		135,
		127,
		149,
		-1,
		153,
		-1,
		128,
		131,
		156,
		195,
		197,
		183,
		179,
		192,
		186,
		183,
		181,
		147,
		-1,
		117,
		150,
		114,
		141,
		107,
		121,
		167,
		-1,
		150,
		132,
		-1,
		160,
		150,
		198,
		173,
		182,
		175,
		169,
		170,
		178,
		-1,
		-1,
		-1,
		119,
		118,
		110,
		104,
		104,
		102,
		119,
		-1,
		155,
		137,
		123,
		140,
		140,
		131,
		139,
		188,
		184,
		187,
		185,
		163,
		-1,
		88,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		113,
		97,
		110,
		121,
		124,
		120,
		120,
		122,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		162,
		194,
		-1,
		83,
		-1,
		149,
		-1,
		-1,
		94,
		81,
		91,
		102,
		130,
		130,
		119,
		115,
		132,
		167,
		153,
		151,
		156,
		161,
		-1,
		72,
		71,
		-1,
		65,
		75,
		91,
		-1,
		72,
		-1,
		176,
		137,
		-1,
		116,
		110,
		-1,
		162,
		158,
		-1,
		-1,
		59,
		54,
		-1,
		-1,
		-1,
		71,
		80,
		171,
		155,
		-1,
		100,
		107,
		-1,
		-1,
		-1,
		44,
		45,
		-1,
		64,
		67,
		-1,
		81,
		87,
		115,
		95,
		101,
		-1,
		-1,
		-1,
		53,
		34,
		28,
		54,
		49,
		72,
		112,
		98,
		98,
		82,
		92,
		121,
		-1,
		-1,
		-1,
		15,
		22,
		34,
		-1,
		-1,
		123,
		106,
		93,
		91,
		-1,
		-1,
		-1,
		16,
		10,
		-1,
		-1,
		43,
		-1,
		-1,
		88,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		30,
		0,
		-1,
		-1,
		-1,
		44,
		51,
		72,
		-1,
		-1,
		-1,
		-1,
		29,
		29,
		46,
		21,
		-1,
		-1,
		-1,
		58,
		61,
		-1,
		-1,
		32,
		30,
		-1,
		-1,
		-1,
		52,
		64,
		-1,
		72,
		-1,
		-1,
		-1,
		68,
		-1,
		-1,
		105,
		-1,
		-1,
		-1,
		82,
		-1,
		107,
		82,
		89,
		-1,
		-1,
		-1,
		-1,
		95,
		87,
		120,
		-1,
		92,
		94,
		-1,
		142,
		-1,
		-1,
		110,
		105,
		-1,
		-1,
		97,
		104,
		126,
		129,
		129,
		-1,
		116
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		306,
		295,
		306,
		314,
		287,
		294,
		-1,
		313,
		317,
		283,
		277,
		316,
		285,
		291,
		302,
		-1,
		-1,
		-1,
		306,
		305,
		273,
		271,
		280,
		285,
		292,
		-1,
		291,
		-1,
		327,
		306,
		317,
		322,
		266,
		263,
		283,
		302,
		284,
		276,
		342,
		296,
		267,
		261,
		279,
		269,
		278,
		270,
		-1,
		267,
		257,
		279,
		258,
		269,
		261,
		-1,
		-1,
		261,
		262,
		268,
		254,
		260,
		256,
		-1,
		266,
		250,
		-1,
		-1,
		251,
		252,
		236,
		239,
		247,
		245,
		258,
		250,
		245,
		-1,
		-1,
		242,
		238,
		245,
		232,
		228,
		245,
		258,
		240,
		254,
		253,
		-1,
		246,
		264,
		271,
		239,
		237,
		221,
		219,
		237,
		239,
		245,
		245,
		-1,
		255,
		256,
		251,
		259,
		261,
		237,
		224,
		224,
		234,
		227,
		246,
		234,
		280,
		-1,
		-1,
		-1,
		-1,
		-1,
		289,
		255,
		238,
		255,
		247,
		237,
		252,
		245,
		227,
		224,
		222,
		219,
		235,
		233,
		243,
		-1,
		-1,
		348,
		317,
		346,
		304,
		285,
		-1,
		251,
		231,
		237,
		241,
		235,
		228,
		242,
		238,
		-1,
		213,
		212,
		240,
		226,
		237,
		308,
		-1,
		-1,
		306,
		298,
		281,
		284,
		261,
		257,
		246,
		245,
		237,
		223,
		219,
		225,
		228,
		228,
		234,
		207,
		217,
		221,
		219,
		244,
		-1,
		-1,
		279,
		-1,
		-1,
		305,
		288,
		-1,
		271,
		278,
		267,
		273,
		259,
		280,
		256,
		247,
		239,
		233,
		221,
		223,
		220,
		233,
		221,
		204,
		229,
		233,
		214,
		235,
		230,
		-1,
		278,
		262,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		264,
		267,
		273,
		297,
		296,
		-1,
		268,
		256,
		257,
		242,
		239,
		226,
		214,
		227,
		212,
		219,
		218,
		208,
		206,
		236,
		211,
		233,
		230,
		249,
		254,
		248,
		257,
		-1,
		313,
		309,
		305,
		312,
		261,
		-1,
		-1,
		301,
		-1,
		304,
		305,
		280,
		253,
		256,
		243,
		234,
		221,
		210,
		221,
		210,
		207,
		215,
		200,
		215,
		206,
		205,
		223,
		233,
		241,
		245,
		251,
		-1,
		363,
		-1,
		305,
		289,
		291,
		263,
		284,
		-1,
		321,
		305,
		297,
		282,
		282,
		-1,
		252,
		249,
		239,
		217,
		202,
		219,
		211,
		209,
		213,
		195,
		209,
		200,
		218,
		225,
		223,
		227,
		247,
		259,
		323,
		313,
		-1,
		295,
		300,
		259,
		267,
		286,
		324,
		288,
		-1,
		283,
		-1,
		254,
		267,
		-1,
		223,
		219,
		201,
		202,
		197,
		212,
		206,
		191,
		188,
		206,
		209,
		216,
		220,
		236,
		-1,
		-1,
		308,
		312,
		301,
		252,
		271,
		295,
		332,
		281,
		270,
		269,
		-1,
		260,
		237,
		234,
		222,
		209,
		194,
		195,
		203,
		216,
		195,
		190,
		187,
		207,
		233,
		211,
		223,
		-1,
		-1,
		-1,
		333,
		-1,
		-1,
		278,
		249,
		273,
		315,
		299,
		292,
		280,
		245,
		245,
		239,
		-1,
		233,
		212,
		203,
		192,
		190,
		203,
		200,
		205,
		185,
		183,
		202,
		214,
		205,
		222,
		-1,
		-1,
		-1,
		308,
		297,
		298,
		244,
		267,
		304,
		278,
		264,
		269,
		244,
		237,
		231,
		246,
		229,
		210,
		199,
		191,
		180,
		196,
		204,
		199,
		181,
		190,
		196,
		220,
		210,
		216,
		-1,
		-1,
		315,
		305,
		289,
		291,
		288,
		258,
		265,
		297,
		269,
		282,
		-1,
		236,
		-1,
		225,
		220,
		204,
		199,
		196,
		193,
		187,
		196,
		198,
		188,
		183,
		190,
		225,
		225,
		200,
		220,
		223,
		-1,
		-1,
		-1,
		308,
		303,
		278,
		255,
		239,
		275,
		-1,
		252,
		253,
		-1,
		230,
		224,
		221,
		206,
		202,
		197,
		201,
		194,
		201,
		194,
		192,
		193,
		175,
		207,
		-1,
		208,
		202,
		210,
		200,
		188,
		-1,
		-1,
		-1,
		301,
		280,
		273,
		293,
		234,
		286,
		-1,
		-1,
		237,
		230,
		-1,
		217,
		199,
		206,
		204,
		198,
		202,
		199,
		188,
		201,
		194,
		180,
		182,
		195,
		199,
		203,
		190,
		186,
		183,
		197,
		-1,
		320,
		-1,
		-1,
		-1,
		-1,
		-1,
		234,
		254,
		-1,
		246,
		238,
		228,
		222,
		216,
		212,
		210,
		226,
		210,
		213,
		211,
		202,
		210,
		183,
		176,
		183,
		172,
		190,
		198,
		190,
		184,
		183,
		193,
		-1,
		321,
		307,
		278,
		-1,
		-1,
		267,
		-1,
		231,
		245,
		261,
		-1,
		254,
		233,
		248,
		226,
		222,
		218,
		233,
		234,
		211,
		211,
		209,
		200,
		188,
		177,
		180,
		172,
		194,
		194,
		178,
		179,
		183,
		-1,
		327,
		314,
		272,
		268,
		257,
		277,
		228,
		216,
		248,
		-1,
		-1,
		290,
		-1,
		224,
		241,
		232,
		230,
		223,
		205,
		212,
		220,
		197,
		192,
		182,
		171,
		171,
		166,
		188,
		174,
		172,
		181,
		197,
		-1,
		-1,
		-1,
		294,
		-1,
		-1,
		243,
		230,
		224,
		-1,
		265,
		-1,
		268,
		258,
		242,
		227,
		260,
		-1,
		204,
		200,
		207,
		-1,
		217,
		-1,
		190,
		187,
		178,
		163,
		160,
		171,
		169,
		180,
		176,
		-1,
		277,
		262,
		255,
		245,
		259,
		230,
		-1,
		285,
		-1,
		-1,
		255,
		249,
		249,
		233,
		234,
		220,
		200,
		192,
		207,
		206,
		193,
		192,
		176,
		169,
		166,
		159,
		172,
		182,
		187,
		174,
		-1,
		-1,
		-1,
		282,
		268,
		272,
		232,
		251,
		-1,
		-1,
		317,
		272,
		258,
		-1,
		229,
		220,
		208,
		198,
		188,
		193,
		194,
		184,
		182,
		174,
		176,
		170,
		161,
		160,
		176,
		168,
		190,
		-1,
		-1,
		265,
		270,
		258,
		244,
		263,
		-1,
		-1,
		-1,
		264,
		280,
		248,
		227,
		209,
		-1,
		-1,
		192,
		185,
		179,
		182,
		170,
		190,
		185,
		169,
		154,
		169,
		173,
		181,
		172,
		-1,
		268,
		255,
		-1,
		-1,
		266,
		260,
		-1,
		-1,
		-1,
		-1,
		260,
		205,
		194,
		189,
		193,
		191,
		-1,
		165,
		176,
		169,
		188,
		195,
		171,
		156,
		150,
		156,
		168,
		177,
		-1,
		-1,
		280,
		-1,
		253,
		-1,
		-1,
		-1,
		-1,
		217,
		211,
		182,
		175,
		179,
		-1,
		167,
		169,
		166,
		178,
		174,
		171,
		162,
		153,
		149,
		153,
		157,
		171,
		175,
		303,
		-1,
		244,
		-1,
		-1,
		-1,
		235,
		250,
		221,
		198,
		171,
		166,
		159,
		153,
		158,
		169,
		178,
		189,
		154,
		156,
		146,
		145,
		149,
		166,
		170,
		-1,
		-1,
		242,
		238,
		261,
		243,
		247,
		248,
		-1,
		-1,
		175,
		166,
		157,
		149,
		162,
		165,
		150,
		152,
		152,
		150,
		144,
		154,
		169,
		164,
		-1,
		-1,
		-1,
		254,
		-1,
		256,
		-1,
		-1,
		245,
		246,
		193,
		175,
		171,
		169,
		158,
		152,
		140,
		145,
		155,
		149,
		146,
		140,
		144,
		167,
		156,
		195,
		-1,
		-1,
		291,
		-1,
		-1,
		-1,
		234,
		225,
		220,
		227,
		229,
		220,
		208,
		205,
		-1,
		175,
		181,
		146,
		153,
		136,
		143,
		148,
		145,
		134,
		141,
		157,
		156,
		151,
		187,
		178,
		184,
		-1,
		-1,
		284,
		273,
		262,
		268,
		-1,
		227,
		222,
		213,
		203,
		206,
		-1,
		-1,
		200,
		197,
		177,
		146,
		144,
		137,
		132,
		142,
		118,
		130,
		134,
		138,
		144,
		149,
		154,
		160,
		175,
		190,
		-1,
		238,
		275,
		268,
		236,
		244,
		275,
		-1,
		217,
		209,
		219,
		195,
		197,
		-1,
		-1,
		173,
		164,
		165,
		153,
		150,
		156,
		155,
		138,
		144,
		145,
		137,
		136,
		154,
		158,
		167,
		174,
		164,
		177,
		181,
		-1,
		231,
		251,
		230,
		233,
		257,
		271,
		-1,
		214,
		-1,
		-1,
		179,
		198,
		182,
		172,
		169,
		212,
		167,
		162,
		143,
		141,
		136,
		127,
		152,
		145,
		145,
		148,
		163,
		168,
		160,
		174,
		174,
		175,
		-1,
		220,
		231,
		224,
		-1,
		-1,
		-1,
		-1,
		215,
		-1,
		-1,
		169,
		-1,
		209,
		-1,
		192,
		196,
		175,
		178,
		157,
		144,
		130,
		138,
		144,
		143,
		149,
		149,
		150,
		159,
		170,
		182,
		181,
		182,
		245,
		201,
		204,
		215,
		226,
		241,
		245,
		-1,
		209,
		245,
		175,
		-1,
		159,
		-1,
		-1,
		-1,
		206,
		188,
		180,
		177,
		156,
		156,
		122,
		126,
		139,
		146,
		156,
		167,
		159,
		163,
		176,
		187,
		190,
		241,
		232,
		245,
		190,
		190,
		211,
		220,
		241,
		205,
		202,
		239,
		182,
		171,
		166,
		153,
		-1,
		-1,
		190,
		198,
		-1,
		-1,
		163,
		130,
		118,
		128,
		132,
		146,
		158,
		171,
		159,
		164,
		158,
		190,
		-1,
		234,
		233,
		222,
		219,
		195,
		186,
		181,
		208,
		-1,
		-1,
		203,
		230,
		214,
		215,
		213,
		238,
		-1,
		142,
		-1,
		-1,
		170,
		-1,
		-1,
		155,
		135,
		124,
		115,
		120,
		140,
		151,
		173,
		155,
		172,
		163,
		173,
		177,
		218,
		215,
		203,
		201,
		224,
		189,
		177,
		-1,
		185,
		188,
		194,
		201,
		216,
		227,
		-1,
		-1,
		158,
		138,
		-1,
		-1,
		153,
		151,
		140,
		-1,
		130,
		112,
		117,
		147,
		149,
		151,
		158,
		152,
		159,
		167,
		178,
		170,
		227,
		241,
		230,
		226,
		225,
		233,
		182,
		175,
		182,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		163,
		-1,
		148,
		144,
		-1,
		-1,
		148,
		141,
		129,
		117,
		107,
		117,
		134,
		134,
		137,
		142,
		150,
		161,
		157,
		161,
		164,
		-1,
		261,
		-1,
		213,
		174,
		180,
		195,
		203,
		-1,
		-1,
		-1,
		165,
		151,
		144,
		132,
		130,
		-1,
		182,
		166,
		147,
		-1,
		117,
		130,
		170,
		138,
		143,
		138,
		153,
		164,
		155,
		163,
		157,
		160,
		-1,
		-1,
		173,
		156,
		-1,
		-1,
		130,
		132,
		-1,
		156,
		145,
		130,
		122,
		-1,
		-1,
		154,
		150,
		-1,
		-1,
		104,
		142,
		141,
		149,
		144,
		149,
		161,
		157,
		153,
		163,
		154,
		-1,
		-1,
		151,
		143,
		137,
		-1,
		115,
		-1,
		158,
		-1,
		125,
		131,
		119,
		-1,
		-1,
		-1,
		135,
		98,
		114,
		137,
		163,
		161,
		152,
		145,
		152,
		155,
		148,
		154,
		-1,
		-1,
		-1,
		133,
		107,
		165,
		156,
		139,
		119,
		111,
		130,
		-1,
		116,
		-1,
		91,
		94,
		119,
		158,
		160,
		146,
		142,
		155,
		149,
		146,
		144,
		139,
		-1,
		109,
		142,
		106,
		125,
		99,
		105,
		130,
		-1,
		113,
		95,
		-1,
		123,
		113,
		161,
		136,
		145,
		138,
		132,
		133,
		141,
		-1,
		-1,
		-1,
		111,
		110,
		102,
		96,
		96,
		94,
		97,
		-1,
		118,
		100,
		86,
		103,
		103,
		94,
		102,
		151,
		147,
		150,
		148,
		126,
		-1,
		97,
		-1,
		-1,
		134,
		-1,
		-1,
		-1,
		105,
		89,
		98,
		86,
		87,
		83,
		83,
		85,
		98,
		106,
		104,
		101,
		113,
		109,
		129,
		125,
		157,
		-1,
		92,
		-1,
		141,
		-1,
		-1,
		86,
		73,
		83,
		94,
		98,
		96,
		82,
		78,
		95,
		130,
		116,
		114,
		119,
		124,
		-1,
		81,
		80,
		-1,
		74,
		84,
		83,
		-1,
		64,
		-1,
		144,
		105,
		-1,
		79,
		73,
		-1,
		125,
		121,
		-1,
		-1,
		68,
		63,
		-1,
		-1,
		-1,
		63,
		72,
		139,
		123,
		-1,
		63,
		70,
		-1,
		-1,
		-1,
		53,
		54,
		-1,
		49,
		59,
		-1,
		73,
		76,
		84,
		58,
		64,
		-1,
		-1,
		-1,
		62,
		43,
		37,
		39,
		34,
		64,
		97,
		83,
		67,
		45,
		55,
		84,
		-1,
		-1,
		-1,
		34,
		26,
		19,
		-1,
		-1,
		92,
		75,
		56,
		54,
		-1,
		-1,
		-1,
		56,
		37,
		-1,
		-1,
		6,
		-1,
		-1,
		51,
		30,
		-1,
		-1,
		-1,
		-1,
		-1,
		73,
		45,
		-1,
		-1,
		-1,
		0,
		7,
		35,
		-1,
		-1,
		-1,
		-1,
		67,
		68,
		91,
		66,
		-1,
		-1,
		-1,
		17,
		24,
		-1,
		-1,
		70,
		68,
		-1,
		-1,
		-1,
		45,
		29,
		-1,
		35,
		-1,
		-1,
		-1,
		36,
		-1,
		-1,
		68,
		-1,
		-1,
		-1,
		50,
		-1,
		70,
		45,
		52,
		-1,
		-1,
		-1,
		-1,
		63,
		55,
		83,
		-1,
		55,
		57,
		-1,
		105,
		-1,
		-1,
		78,
		69,
		-1,
		-1,
		60,
		67,
		89,
		92,
		108,
		-1,
		79
	],
	[
		-1,
		299,
		288,
		299,
		307,
		280,
		287,
		-1,
		306,
		310,
		276,
		270,
		309,
		278,
		284,
		295,
		-1,
		-1,
		-1,
		299,
		298,
		266,
		264,
		273,
		278,
		285,
		-1,
		284,
		-1,
		320,
		299,
		310,
		315,
		259,
		256,
		276,
		295,
		277,
		269,
		335,
		289,
		260,
		254,
		272,
		262,
		271,
		263,
		-1,
		260,
		250,
		272,
		251,
		262,
		254,
		-1,
		-1,
		254,
		255,
		261,
		247,
		253,
		249,
		-1,
		259,
		243,
		-1,
		-1,
		244,
		245,
		229,
		232,
		240,
		238,
		251,
		243,
		238,
		-1,
		-1,
		235,
		231,
		238,
		225,
		221,
		238,
		251,
		233,
		247,
		246,
		-1,
		239,
		257,
		264,
		232,
		230,
		214,
		212,
		230,
		232,
		238,
		238,
		-1,
		248,
		249,
		244,
		252,
		254,
		230,
		217,
		217,
		227,
		220,
		239,
		227,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		248,
		231,
		248,
		240,
		230,
		245,
		238,
		220,
		217,
		215,
		212,
		228,
		226,
		236,
		-1,
		-1,
		341,
		310,
		339,
		297,
		278,
		-1,
		244,
		224,
		230,
		234,
		228,
		221,
		235,
		231,
		-1,
		206,
		205,
		233,
		219,
		230,
		301,
		-1,
		-1,
		299,
		291,
		274,
		277,
		254,
		250,
		239,
		238,
		230,
		216,
		212,
		218,
		221,
		221,
		227,
		200,
		210,
		214,
		212,
		237,
		-1,
		-1,
		272,
		-1,
		-1,
		298,
		281,
		-1,
		264,
		271,
		260,
		266,
		252,
		273,
		249,
		240,
		232,
		226,
		214,
		216,
		213,
		226,
		214,
		197,
		222,
		226,
		207,
		228,
		223,
		-1,
		271,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		257,
		260,
		266,
		290,
		289,
		-1,
		261,
		249,
		250,
		235,
		232,
		219,
		207,
		220,
		205,
		212,
		211,
		201,
		199,
		229,
		204,
		226,
		223,
		242,
		247,
		241,
		250,
		-1,
		306,
		302,
		298,
		305,
		254,
		-1,
		-1,
		294,
		-1,
		297,
		298,
		273,
		246,
		249,
		236,
		227,
		214,
		203,
		214,
		203,
		200,
		208,
		193,
		208,
		199,
		198,
		216,
		226,
		234,
		238,
		244,
		-1,
		356,
		-1,
		298,
		282,
		284,
		256,
		277,
		-1,
		314,
		298,
		290,
		275,
		275,
		-1,
		245,
		242,
		232,
		210,
		195,
		212,
		204,
		202,
		206,
		188,
		202,
		193,
		211,
		218,
		216,
		220,
		240,
		252,
		316,
		306,
		-1,
		288,
		293,
		252,
		260,
		279,
		317,
		281,
		-1,
		276,
		-1,
		247,
		260,
		-1,
		216,
		212,
		194,
		195,
		190,
		205,
		199,
		184,
		181,
		199,
		202,
		209,
		213,
		229,
		-1,
		-1,
		301,
		305,
		294,
		245,
		264,
		288,
		325,
		274,
		263,
		262,
		-1,
		253,
		230,
		227,
		215,
		202,
		187,
		188,
		196,
		209,
		188,
		183,
		180,
		200,
		226,
		204,
		216,
		-1,
		-1,
		-1,
		326,
		-1,
		-1,
		271,
		242,
		266,
		308,
		292,
		285,
		273,
		238,
		238,
		232,
		-1,
		226,
		205,
		196,
		185,
		183,
		196,
		193,
		198,
		178,
		176,
		195,
		207,
		198,
		215,
		-1,
		-1,
		-1,
		301,
		290,
		291,
		237,
		260,
		297,
		271,
		257,
		262,
		237,
		230,
		224,
		239,
		222,
		203,
		192,
		184,
		173,
		189,
		197,
		192,
		174,
		183,
		189,
		213,
		203,
		209,
		-1,
		-1,
		308,
		298,
		282,
		284,
		281,
		251,
		258,
		290,
		262,
		275,
		-1,
		229,
		-1,
		218,
		213,
		197,
		192,
		189,
		186,
		180,
		189,
		191,
		181,
		176,
		183,
		218,
		218,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		301,
		296,
		271,
		248,
		232,
		268,
		-1,
		245,
		246,
		-1,
		223,
		217,
		214,
		199,
		195,
		190,
		194,
		187,
		194,
		187,
		185,
		186,
		168,
		200,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		294,
		273,
		266,
		286,
		227,
		279,
		-1,
		-1,
		230,
		223,
		-1,
		210,
		192,
		199,
		197,
		191,
		195,
		192,
		181,
		194,
		187,
		173,
		175,
		188,
		192,
		196,
		183,
		179,
		176,
		190,
		-1,
		313,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		247,
		-1,
		239,
		231,
		221,
		215,
		209,
		205,
		203,
		219,
		203,
		206,
		204,
		195,
		203,
		176,
		169,
		176,
		165,
		183,
		191,
		183,
		177,
		176,
		186,
		-1,
		314,
		300,
		271,
		-1,
		-1,
		260,
		-1,
		224,
		238,
		254,
		-1,
		247,
		226,
		241,
		219,
		215,
		211,
		226,
		227,
		204,
		204,
		202,
		193,
		181,
		170,
		173,
		165,
		187,
		187,
		171,
		172,
		176,
		-1,
		320,
		307,
		265,
		261,
		250,
		270,
		221,
		209,
		241,
		-1,
		-1,
		283,
		-1,
		217,
		234,
		225,
		223,
		216,
		198,
		205,
		213,
		190,
		185,
		175,
		164,
		164,
		159,
		181,
		167,
		165,
		174,
		190,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		236,
		223,
		217,
		-1,
		258,
		-1,
		261,
		251,
		235,
		220,
		253,
		-1,
		197,
		193,
		200,
		-1,
		210,
		-1,
		183,
		180,
		171,
		156,
		153,
		164,
		162,
		173,
		169,
		-1,
		270,
		255,
		248,
		238,
		252,
		223,
		-1,
		278,
		-1,
		-1,
		248,
		242,
		242,
		226,
		227,
		213,
		193,
		185,
		200,
		199,
		186,
		185,
		169,
		162,
		159,
		152,
		165,
		175,
		180,
		167,
		-1,
		-1,
		-1,
		275,
		261,
		265,
		225,
		244,
		-1,
		-1,
		310,
		265,
		251,
		-1,
		222,
		213,
		201,
		191,
		181,
		186,
		187,
		177,
		175,
		167,
		169,
		163,
		154,
		153,
		169,
		161,
		183,
		-1,
		-1,
		258,
		263,
		251,
		237,
		256,
		-1,
		-1,
		-1,
		257,
		273,
		241,
		220,
		202,
		-1,
		-1,
		185,
		178,
		172,
		175,
		163,
		183,
		178,
		162,
		147,
		162,
		166,
		174,
		165,
		-1,
		261,
		248,
		-1,
		-1,
		259,
		253,
		-1,
		-1,
		-1,
		-1,
		253,
		198,
		187,
		182,
		186,
		184,
		-1,
		158,
		169,
		162,
		181,
		188,
		164,
		149,
		143,
		149,
		161,
		170,
		-1,
		-1,
		273,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		210,
		204,
		175,
		168,
		172,
		-1,
		160,
		162,
		159,
		171,
		167,
		164,
		155,
		146,
		142,
		146,
		150,
		164,
		168,
		296,
		-1,
		237,
		-1,
		-1,
		-1,
		228,
		243,
		214,
		191,
		164,
		159,
		152,
		146,
		151,
		162,
		171,
		182,
		147,
		149,
		139,
		138,
		142,
		159,
		163,
		-1,
		-1,
		235,
		231,
		254,
		236,
		240,
		241,
		-1,
		-1,
		168,
		159,
		150,
		142,
		155,
		158,
		143,
		145,
		145,
		143,
		137,
		147,
		162,
		157,
		-1,
		-1,
		-1,
		247,
		-1,
		249,
		-1,
		-1,
		238,
		239,
		186,
		168,
		164,
		162,
		151,
		145,
		133,
		138,
		148,
		142,
		139,
		133,
		137,
		160,
		149,
		188,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		227,
		218,
		213,
		220,
		222,
		213,
		201,
		198,
		-1,
		168,
		174,
		139,
		146,
		129,
		136,
		141,
		138,
		127,
		134,
		150,
		149,
		144,
		180,
		171,
		177,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		220,
		215,
		206,
		196,
		199,
		-1,
		-1,
		193,
		190,
		170,
		139,
		137,
		130,
		125,
		135,
		111,
		123,
		127,
		131,
		137,
		142,
		147,
		153,
		168,
		183,
		-1,
		244,
		281,
		274,
		242,
		250,
		281,
		-1,
		210,
		202,
		212,
		188,
		190,
		-1,
		-1,
		166,
		157,
		158,
		146,
		143,
		149,
		148,
		131,
		137,
		138,
		130,
		129,
		147,
		151,
		160,
		167,
		157,
		170,
		174,
		-1,
		237,
		257,
		236,
		239,
		263,
		277,
		-1,
		207,
		-1,
		-1,
		172,
		191,
		175,
		165,
		162,
		205,
		160,
		155,
		136,
		134,
		129,
		120,
		145,
		138,
		138,
		141,
		156,
		161,
		153,
		167,
		167,
		168,
		-1,
		226,
		237,
		230,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		162,
		-1,
		202,
		-1,
		185,
		189,
		168,
		171,
		150,
		137,
		123,
		131,
		137,
		136,
		142,
		142,
		143,
		152,
		163,
		175,
		174,
		175,
		251,
		207,
		210,
		221,
		232,
		247,
		251,
		-1,
		215,
		251,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		199,
		181,
		173,
		170,
		149,
		149,
		115,
		119,
		132,
		139,
		149,
		160,
		152,
		156,
		169,
		180,
		183,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		211,
		208,
		245,
		175,
		164,
		159,
		146,
		-1,
		-1,
		183,
		191,
		-1,
		-1,
		156,
		123,
		111,
		121,
		125,
		139,
		151,
		164,
		152,
		157,
		151,
		183,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		236,
		220,
		208,
		206,
		231,
		-1,
		135,
		-1,
		-1,
		163,
		-1,
		-1,
		148,
		128,
		117,
		108,
		113,
		133,
		144,
		166,
		148,
		165,
		156,
		166,
		170,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		191,
		194,
		200,
		207,
		209,
		220,
		-1,
		-1,
		151,
		131,
		-1,
		-1,
		146,
		144,
		133,
		-1,
		123,
		105,
		110,
		140,
		142,
		144,
		151,
		145,
		152,
		160,
		171,
		163,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		141,
		137,
		-1,
		-1,
		141,
		134,
		122,
		110,
		100,
		110,
		127,
		127,
		130,
		135,
		143,
		154,
		150,
		154,
		157,
		-1,
		267,
		-1,
		219,
		180,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		158,
		144,
		137,
		125,
		123,
		-1,
		175,
		159,
		140,
		-1,
		110,
		123,
		163,
		131,
		136,
		131,
		146,
		157,
		148,
		156,
		150,
		153,
		-1,
		-1,
		179,
		162,
		-1,
		-1,
		136,
		138,
		-1,
		149,
		138,
		123,
		115,
		-1,
		-1,
		147,
		143,
		-1,
		-1,
		97,
		135,
		134,
		142,
		137,
		142,
		154,
		150,
		146,
		156,
		147,
		-1,
		-1,
		157,
		149,
		143,
		-1,
		121,
		-1,
		151,
		-1,
		118,
		124,
		112,
		-1,
		-1,
		-1,
		128,
		91,
		107,
		130,
		156,
		154,
		145,
		138,
		145,
		148,
		141,
		147,
		-1,
		-1,
		-1,
		139,
		113,
		158,
		149,
		132,
		112,
		104,
		123,
		-1,
		109,
		-1,
		84,
		87,
		112,
		151,
		153,
		139,
		135,
		148,
		142,
		139,
		137,
		145,
		-1,
		115,
		148,
		112,
		118,
		94,
		98,
		123,
		-1,
		106,
		88,
		-1,
		116,
		106,
		154,
		129,
		138,
		131,
		125,
		126,
		134,
		-1,
		-1,
		-1,
		117,
		116,
		108,
		102,
		102,
		99,
		90,
		-1,
		111,
		93,
		79,
		96,
		96,
		87,
		95,
		144,
		140,
		143,
		141,
		119,
		-1,
		103,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		111,
		95,
		91,
		79,
		80,
		76,
		76,
		78,
		91,
		99,
		97,
		94,
		106,
		102,
		122,
		118,
		150,
		-1,
		98,
		-1,
		147,
		-1,
		-1,
		92,
		79,
		89,
		100,
		91,
		89,
		75,
		71,
		88,
		123,
		109,
		107,
		112,
		117,
		-1,
		87,
		86,
		-1,
		80,
		90,
		89,
		-1,
		70,
		-1,
		137,
		98,
		-1,
		72,
		66,
		-1,
		118,
		114,
		-1,
		-1,
		74,
		69,
		-1,
		-1,
		-1,
		69,
		78,
		132,
		116,
		-1,
		56,
		63,
		-1,
		-1,
		-1,
		59,
		60,
		-1,
		55,
		65,
		-1,
		78,
		69,
		77,
		51,
		57,
		-1,
		-1,
		-1,
		68,
		49,
		43,
		45,
		40,
		70,
		90,
		76,
		60,
		38,
		48,
		77,
		-1,
		-1,
		-1,
		40,
		32,
		25,
		-1,
		-1,
		85,
		68,
		49,
		47,
		-1,
		-1,
		-1,
		62,
		43,
		-1,
		-1,
		11,
		-1,
		-1,
		44,
		23,
		-1,
		-1,
		-1,
		-1,
		-1,
		79,
		51,
		-1,
		-1,
		-1,
		6,
		0,
		28,
		-1,
		-1,
		-1,
		-1,
		73,
		74,
		97,
		66,
		-1,
		-1,
		-1,
		10,
		17,
		-1,
		-1,
		76,
		74,
		-1,
		-1,
		-1,
		38,
		22,
		-1,
		28,
		-1,
		-1,
		-1,
		29,
		-1,
		-1,
		61,
		-1,
		-1,
		-1,
		43,
		-1,
		63,
		38,
		45,
		-1,
		-1,
		-1,
		-1,
		56,
		48,
		76,
		-1,
		48,
		50,
		-1,
		98,
		-1,
		-1,
		71,
		62,
		-1,
		-1,
		53,
		60,
		82,
		85,
		101,
		-1,
		72
	],
	[
		-1,
		303,
		292,
		303,
		311,
		284,
		291,
		-1,
		310,
		314,
		280,
		274,
		313,
		282,
		288,
		299,
		-1,
		-1,
		-1,
		303,
		302,
		270,
		268,
		277,
		282,
		289,
		-1,
		288,
		-1,
		324,
		303,
		314,
		319,
		263,
		260,
		280,
		299,
		281,
		273,
		339,
		293,
		264,
		258,
		276,
		266,
		275,
		267,
		-1,
		264,
		254,
		276,
		255,
		266,
		258,
		-1,
		-1,
		258,
		259,
		265,
		251,
		257,
		253,
		-1,
		263,
		247,
		-1,
		-1,
		248,
		249,
		233,
		236,
		244,
		242,
		255,
		247,
		242,
		-1,
		-1,
		239,
		235,
		242,
		229,
		225,
		242,
		255,
		237,
		251,
		250,
		-1,
		243,
		261,
		268,
		236,
		234,
		218,
		216,
		234,
		236,
		242,
		242,
		-1,
		252,
		253,
		248,
		256,
		258,
		234,
		221,
		221,
		231,
		224,
		243,
		231,
		277,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		252,
		235,
		252,
		244,
		234,
		249,
		242,
		224,
		221,
		219,
		216,
		232,
		230,
		240,
		-1,
		-1,
		345,
		314,
		343,
		301,
		282,
		-1,
		248,
		228,
		234,
		238,
		232,
		225,
		239,
		235,
		-1,
		210,
		209,
		237,
		223,
		234,
		305,
		-1,
		-1,
		303,
		295,
		278,
		281,
		258,
		254,
		243,
		242,
		234,
		220,
		216,
		222,
		225,
		225,
		231,
		204,
		214,
		218,
		216,
		241,
		-1,
		-1,
		276,
		-1,
		-1,
		302,
		285,
		-1,
		268,
		275,
		264,
		270,
		256,
		277,
		253,
		244,
		236,
		230,
		218,
		220,
		217,
		230,
		218,
		201,
		226,
		230,
		211,
		232,
		227,
		-1,
		275,
		259,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		280,
		261,
		264,
		270,
		294,
		293,
		-1,
		265,
		253,
		254,
		239,
		236,
		223,
		211,
		224,
		209,
		216,
		215,
		205,
		203,
		233,
		208,
		230,
		227,
		246,
		251,
		245,
		254,
		-1,
		310,
		306,
		302,
		309,
		258,
		-1,
		-1,
		298,
		-1,
		301,
		302,
		277,
		250,
		253,
		240,
		231,
		218,
		207,
		218,
		207,
		204,
		212,
		197,
		212,
		203,
		202,
		220,
		230,
		238,
		242,
		248,
		-1,
		360,
		-1,
		302,
		286,
		288,
		260,
		281,
		-1,
		318,
		302,
		294,
		279,
		279,
		-1,
		249,
		246,
		236,
		214,
		199,
		216,
		208,
		206,
		210,
		192,
		206,
		197,
		215,
		222,
		220,
		224,
		244,
		256,
		320,
		310,
		-1,
		292,
		297,
		256,
		264,
		283,
		321,
		285,
		-1,
		280,
		-1,
		251,
		264,
		-1,
		220,
		216,
		198,
		199,
		194,
		209,
		203,
		188,
		185,
		203,
		206,
		213,
		217,
		233,
		-1,
		-1,
		305,
		309,
		298,
		249,
		268,
		292,
		329,
		278,
		267,
		266,
		-1,
		257,
		234,
		231,
		219,
		206,
		191,
		192,
		200,
		213,
		192,
		187,
		184,
		204,
		230,
		208,
		220,
		-1,
		-1,
		-1,
		330,
		-1,
		-1,
		275,
		246,
		270,
		312,
		296,
		289,
		277,
		242,
		242,
		236,
		-1,
		230,
		209,
		200,
		189,
		187,
		200,
		197,
		202,
		182,
		180,
		199,
		211,
		202,
		219,
		-1,
		-1,
		-1,
		305,
		294,
		295,
		241,
		264,
		301,
		275,
		261,
		266,
		241,
		234,
		228,
		243,
		226,
		207,
		196,
		188,
		177,
		193,
		201,
		196,
		178,
		187,
		193,
		217,
		207,
		213,
		-1,
		-1,
		312,
		302,
		286,
		288,
		285,
		255,
		262,
		294,
		266,
		279,
		-1,
		233,
		-1,
		222,
		217,
		201,
		196,
		193,
		190,
		184,
		193,
		195,
		185,
		180,
		187,
		222,
		222,
		197,
		217,
		220,
		-1,
		-1,
		-1,
		305,
		300,
		275,
		252,
		236,
		272,
		-1,
		249,
		250,
		-1,
		227,
		221,
		218,
		203,
		199,
		194,
		198,
		191,
		198,
		191,
		189,
		190,
		172,
		204,
		-1,
		205,
		199,
		207,
		197,
		185,
		-1,
		-1,
		-1,
		298,
		277,
		270,
		290,
		231,
		283,
		-1,
		-1,
		234,
		227,
		-1,
		214,
		196,
		203,
		201,
		195,
		199,
		196,
		185,
		198,
		191,
		177,
		179,
		192,
		196,
		200,
		187,
		183,
		180,
		194,
		-1,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		231,
		251,
		-1,
		243,
		235,
		225,
		219,
		213,
		209,
		207,
		223,
		207,
		210,
		208,
		199,
		207,
		180,
		173,
		180,
		169,
		187,
		195,
		187,
		181,
		180,
		190,
		-1,
		318,
		304,
		275,
		-1,
		-1,
		264,
		-1,
		228,
		242,
		258,
		-1,
		251,
		230,
		245,
		223,
		219,
		215,
		230,
		231,
		208,
		208,
		206,
		197,
		185,
		174,
		177,
		169,
		191,
		191,
		175,
		176,
		180,
		-1,
		324,
		311,
		269,
		265,
		254,
		274,
		225,
		213,
		245,
		-1,
		-1,
		287,
		-1,
		221,
		238,
		229,
		227,
		220,
		202,
		209,
		217,
		194,
		189,
		179,
		168,
		168,
		163,
		185,
		171,
		169,
		178,
		194,
		-1,
		-1,
		-1,
		291,
		-1,
		-1,
		240,
		227,
		221,
		-1,
		262,
		-1,
		265,
		255,
		239,
		224,
		257,
		-1,
		201,
		197,
		204,
		-1,
		214,
		-1,
		187,
		184,
		175,
		160,
		157,
		168,
		166,
		177,
		173,
		-1,
		274,
		259,
		252,
		242,
		256,
		227,
		-1,
		282,
		-1,
		-1,
		252,
		246,
		246,
		230,
		231,
		217,
		197,
		189,
		204,
		203,
		190,
		189,
		173,
		166,
		163,
		156,
		169,
		179,
		184,
		171,
		-1,
		-1,
		-1,
		279,
		265,
		269,
		229,
		248,
		-1,
		-1,
		314,
		269,
		255,
		-1,
		226,
		217,
		205,
		195,
		185,
		190,
		191,
		181,
		179,
		171,
		173,
		167,
		158,
		157,
		173,
		165,
		187,
		-1,
		-1,
		262,
		267,
		255,
		241,
		260,
		-1,
		-1,
		-1,
		261,
		277,
		245,
		224,
		206,
		-1,
		-1,
		189,
		182,
		176,
		179,
		167,
		187,
		182,
		166,
		151,
		166,
		170,
		178,
		169,
		-1,
		265,
		252,
		-1,
		-1,
		263,
		257,
		-1,
		-1,
		-1,
		-1,
		257,
		202,
		191,
		186,
		190,
		188,
		-1,
		162,
		173,
		166,
		185,
		192,
		168,
		153,
		147,
		153,
		165,
		174,
		-1,
		-1,
		277,
		-1,
		250,
		-1,
		-1,
		-1,
		-1,
		214,
		208,
		179,
		172,
		176,
		-1,
		164,
		166,
		163,
		175,
		171,
		168,
		159,
		150,
		146,
		150,
		154,
		168,
		172,
		300,
		-1,
		241,
		-1,
		-1,
		-1,
		232,
		247,
		218,
		195,
		168,
		163,
		156,
		150,
		155,
		166,
		175,
		186,
		151,
		153,
		143,
		142,
		146,
		163,
		167,
		-1,
		-1,
		239,
		235,
		258,
		240,
		244,
		245,
		-1,
		-1,
		172,
		163,
		154,
		146,
		159,
		162,
		147,
		149,
		149,
		147,
		141,
		151,
		166,
		161,
		-1,
		-1,
		-1,
		251,
		-1,
		253,
		-1,
		-1,
		242,
		243,
		190,
		172,
		168,
		166,
		155,
		149,
		137,
		142,
		152,
		146,
		143,
		137,
		141,
		164,
		153,
		192,
		-1,
		-1,
		303,
		-1,
		-1,
		-1,
		231,
		222,
		217,
		224,
		226,
		217,
		205,
		202,
		-1,
		172,
		178,
		143,
		150,
		133,
		140,
		145,
		142,
		131,
		138,
		154,
		153,
		148,
		184,
		175,
		181,
		-1,
		-1,
		296,
		285,
		274,
		280,
		-1,
		224,
		219,
		210,
		200,
		203,
		-1,
		-1,
		197,
		194,
		174,
		143,
		141,
		134,
		129,
		139,
		115,
		127,
		131,
		135,
		141,
		146,
		151,
		157,
		172,
		187,
		-1,
		250,
		287,
		280,
		248,
		256,
		287,
		-1,
		214,
		206,
		216,
		192,
		194,
		-1,
		-1,
		170,
		161,
		162,
		150,
		147,
		153,
		152,
		135,
		141,
		142,
		134,
		133,
		151,
		155,
		164,
		171,
		161,
		174,
		178,
		-1,
		243,
		263,
		242,
		245,
		269,
		283,
		-1,
		211,
		-1,
		-1,
		176,
		195,
		179,
		169,
		166,
		209,
		164,
		159,
		140,
		138,
		133,
		124,
		149,
		142,
		142,
		145,
		160,
		165,
		157,
		171,
		171,
		172,
		-1,
		232,
		243,
		236,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		-1,
		166,
		-1,
		206,
		-1,
		189,
		193,
		172,
		175,
		154,
		141,
		127,
		135,
		141,
		140,
		146,
		146,
		147,
		156,
		167,
		179,
		178,
		179,
		257,
		213,
		216,
		227,
		238,
		253,
		257,
		-1,
		221,
		257,
		172,
		-1,
		156,
		-1,
		-1,
		-1,
		203,
		185,
		177,
		174,
		153,
		153,
		119,
		123,
		136,
		143,
		153,
		164,
		156,
		160,
		173,
		184,
		187,
		253,
		244,
		257,
		202,
		202,
		223,
		232,
		253,
		217,
		214,
		251,
		179,
		168,
		163,
		150,
		-1,
		-1,
		187,
		195,
		-1,
		-1,
		160,
		127,
		115,
		125,
		129,
		143,
		155,
		168,
		156,
		161,
		155,
		187,
		-1,
		246,
		245,
		234,
		231,
		207,
		198,
		193,
		220,
		-1,
		-1,
		215,
		242,
		226,
		212,
		210,
		235,
		-1,
		139,
		-1,
		-1,
		167,
		-1,
		-1,
		152,
		132,
		121,
		112,
		117,
		137,
		148,
		170,
		152,
		169,
		160,
		170,
		174,
		230,
		227,
		215,
		213,
		236,
		201,
		189,
		-1,
		197,
		200,
		206,
		213,
		213,
		224,
		-1,
		-1,
		155,
		135,
		-1,
		-1,
		150,
		148,
		137,
		-1,
		127,
		109,
		114,
		144,
		146,
		148,
		155,
		149,
		156,
		164,
		175,
		167,
		239,
		253,
		242,
		238,
		237,
		245,
		194,
		187,
		194,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		160,
		-1,
		145,
		141,
		-1,
		-1,
		145,
		138,
		126,
		114,
		104,
		114,
		131,
		131,
		134,
		139,
		147,
		158,
		154,
		158,
		161,
		-1,
		273,
		-1,
		225,
		186,
		192,
		207,
		215,
		-1,
		-1,
		-1,
		162,
		148,
		141,
		129,
		127,
		-1,
		179,
		163,
		144,
		-1,
		114,
		127,
		167,
		135,
		140,
		135,
		150,
		161,
		152,
		160,
		154,
		157,
		-1,
		-1,
		185,
		168,
		-1,
		-1,
		142,
		144,
		-1,
		153,
		142,
		127,
		119,
		-1,
		-1,
		151,
		147,
		-1,
		-1,
		101,
		139,
		138,
		146,
		141,
		146,
		158,
		154,
		150,
		160,
		151,
		-1,
		-1,
		163,
		155,
		149,
		-1,
		127,
		-1,
		155,
		-1,
		122,
		128,
		116,
		-1,
		-1,
		-1,
		132,
		95,
		111,
		134,
		160,
		158,
		149,
		142,
		149,
		152,
		145,
		151,
		-1,
		-1,
		-1,
		145,
		119,
		162,
		153,
		136,
		116,
		108,
		127,
		-1,
		113,
		-1,
		88,
		91,
		116,
		155,
		157,
		143,
		139,
		152,
		146,
		143,
		141,
		151,
		-1,
		121,
		154,
		118,
		122,
		98,
		102,
		127,
		-1,
		110,
		92,
		-1,
		120,
		110,
		158,
		133,
		142,
		135,
		129,
		130,
		138,
		-1,
		-1,
		-1,
		123,
		122,
		114,
		108,
		108,
		103,
		94,
		-1,
		115,
		97,
		83,
		100,
		100,
		91,
		99,
		148,
		144,
		147,
		145,
		123,
		-1,
		127,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		117,
		101,
		95,
		83,
		84,
		80,
		80,
		82,
		95,
		103,
		101,
		98,
		110,
		106,
		126,
		122,
		154,
		-1,
		122,
		-1,
		153,
		-1,
		-1,
		98,
		85,
		95,
		106,
		95,
		93,
		79,
		75,
		92,
		127,
		113,
		111,
		116,
		121,
		-1,
		111,
		110,
		-1,
		104,
		109,
		95,
		-1,
		76,
		-1,
		141,
		102,
		-1,
		76,
		70,
		-1,
		122,
		118,
		-1,
		-1,
		98,
		93,
		-1,
		-1,
		-1,
		93,
		60,
		136,
		120,
		-1,
		60,
		67,
		-1,
		-1,
		-1,
		83,
		84,
		-1,
		79,
		89,
		-1,
		56,
		47,
		55,
		55,
		61,
		-1,
		-1,
		-1,
		92,
		73,
		67,
		69,
		64,
		94,
		68,
		54,
		33,
		42,
		52,
		81,
		-1,
		-1,
		-1,
		64,
		56,
		49,
		-1,
		-1,
		63,
		46,
		46,
		51,
		-1,
		-1,
		-1,
		86,
		67,
		-1,
		-1,
		41,
		-1,
		-1,
		16,
		27,
		-1,
		-1,
		-1,
		-1,
		-1,
		103,
		75,
		-1,
		-1,
		-1,
		37,
		32,
		0,
		-1,
		-1,
		-1,
		-1,
		97,
		98,
		121,
		84,
		-1,
		-1,
		-1,
		28,
		16,
		-1,
		-1,
		100,
		98,
		-1,
		-1,
		-1,
		56,
		40,
		-1,
		28,
		-1,
		-1,
		-1,
		47,
		-1,
		-1,
		61,
		-1,
		-1,
		-1,
		61,
		-1,
		63,
		38,
		45,
		-1,
		-1,
		-1,
		-1,
		74,
		66,
		76,
		-1,
		48,
		50,
		-1,
		98,
		-1,
		-1,
		89,
		80,
		-1,
		-1,
		53,
		60,
		82,
		85,
		119,
		-1,
		72
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		380,
		369,
		380,
		388,
		361,
		368,
		-1,
		387,
		391,
		357,
		351,
		390,
		359,
		365,
		376,
		-1,
		-1,
		-1,
		380,
		379,
		347,
		345,
		354,
		359,
		366,
		-1,
		365,
		-1,
		401,
		380,
		391,
		396,
		340,
		337,
		357,
		376,
		358,
		350,
		416,
		370,
		341,
		335,
		353,
		343,
		352,
		344,
		-1,
		341,
		331,
		353,
		332,
		343,
		335,
		-1,
		-1,
		335,
		336,
		342,
		328,
		334,
		330,
		-1,
		340,
		324,
		-1,
		-1,
		325,
		326,
		310,
		313,
		321,
		319,
		332,
		324,
		319,
		-1,
		-1,
		316,
		312,
		319,
		306,
		302,
		319,
		332,
		314,
		328,
		327,
		-1,
		320,
		338,
		345,
		313,
		311,
		295,
		293,
		311,
		313,
		319,
		319,
		-1,
		329,
		330,
		325,
		333,
		335,
		311,
		298,
		298,
		308,
		301,
		320,
		308,
		354,
		-1,
		-1,
		-1,
		-1,
		-1,
		363,
		329,
		312,
		329,
		321,
		311,
		326,
		319,
		301,
		298,
		296,
		293,
		309,
		307,
		317,
		-1,
		-1,
		422,
		391,
		420,
		378,
		359,
		-1,
		325,
		305,
		311,
		315,
		309,
		302,
		316,
		312,
		-1,
		287,
		286,
		314,
		300,
		311,
		382,
		-1,
		-1,
		380,
		372,
		355,
		358,
		335,
		331,
		320,
		319,
		311,
		297,
		293,
		299,
		302,
		302,
		308,
		281,
		291,
		295,
		293,
		318,
		-1,
		-1,
		353,
		-1,
		-1,
		379,
		362,
		-1,
		345,
		352,
		341,
		347,
		333,
		354,
		330,
		321,
		313,
		307,
		295,
		297,
		294,
		307,
		295,
		278,
		303,
		307,
		288,
		309,
		304,
		-1,
		352,
		336,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		357,
		338,
		341,
		347,
		371,
		370,
		-1,
		342,
		330,
		331,
		316,
		313,
		300,
		288,
		301,
		286,
		293,
		292,
		282,
		280,
		310,
		285,
		307,
		304,
		323,
		328,
		322,
		331,
		-1,
		387,
		383,
		379,
		386,
		335,
		-1,
		-1,
		375,
		-1,
		378,
		379,
		354,
		327,
		330,
		317,
		308,
		295,
		284,
		295,
		284,
		281,
		289,
		274,
		289,
		280,
		279,
		297,
		307,
		315,
		319,
		325,
		-1,
		437,
		-1,
		379,
		363,
		365,
		337,
		358,
		-1,
		395,
		379,
		371,
		356,
		356,
		-1,
		326,
		323,
		313,
		291,
		276,
		293,
		285,
		283,
		287,
		269,
		283,
		274,
		292,
		299,
		297,
		301,
		321,
		333,
		397,
		387,
		-1,
		369,
		374,
		333,
		341,
		360,
		398,
		362,
		-1,
		357,
		-1,
		328,
		341,
		-1,
		297,
		293,
		275,
		276,
		271,
		286,
		280,
		265,
		262,
		280,
		283,
		290,
		294,
		310,
		-1,
		-1,
		382,
		386,
		375,
		326,
		345,
		369,
		406,
		355,
		344,
		343,
		-1,
		334,
		311,
		308,
		296,
		283,
		268,
		269,
		277,
		290,
		269,
		264,
		261,
		281,
		307,
		285,
		297,
		-1,
		-1,
		-1,
		407,
		-1,
		-1,
		352,
		323,
		347,
		389,
		373,
		366,
		354,
		319,
		319,
		313,
		-1,
		307,
		286,
		277,
		266,
		264,
		277,
		274,
		279,
		259,
		257,
		276,
		288,
		279,
		296,
		-1,
		-1,
		-1,
		382,
		371,
		372,
		318,
		341,
		378,
		352,
		338,
		343,
		318,
		311,
		305,
		320,
		303,
		284,
		273,
		265,
		254,
		270,
		278,
		273,
		255,
		264,
		270,
		294,
		284,
		290,
		-1,
		-1,
		389,
		379,
		363,
		365,
		362,
		332,
		339,
		371,
		343,
		356,
		-1,
		310,
		-1,
		299,
		294,
		278,
		273,
		270,
		267,
		261,
		270,
		272,
		262,
		257,
		264,
		299,
		299,
		274,
		294,
		297,
		-1,
		-1,
		-1,
		382,
		377,
		352,
		329,
		313,
		349,
		-1,
		326,
		327,
		-1,
		304,
		298,
		295,
		280,
		276,
		271,
		275,
		268,
		275,
		268,
		266,
		267,
		249,
		281,
		-1,
		282,
		276,
		284,
		274,
		262,
		-1,
		-1,
		-1,
		375,
		354,
		347,
		367,
		308,
		360,
		-1,
		-1,
		311,
		304,
		-1,
		291,
		273,
		280,
		278,
		272,
		276,
		273,
		262,
		275,
		268,
		254,
		256,
		269,
		273,
		277,
		264,
		260,
		257,
		271,
		-1,
		394,
		-1,
		-1,
		-1,
		-1,
		-1,
		308,
		328,
		-1,
		320,
		312,
		302,
		296,
		290,
		286,
		284,
		300,
		284,
		287,
		285,
		276,
		284,
		257,
		250,
		257,
		246,
		264,
		272,
		264,
		258,
		257,
		267,
		-1,
		395,
		381,
		352,
		-1,
		-1,
		341,
		-1,
		305,
		319,
		335,
		-1,
		328,
		307,
		322,
		300,
		296,
		292,
		307,
		308,
		285,
		285,
		283,
		274,
		262,
		251,
		254,
		246,
		268,
		268,
		252,
		253,
		257,
		-1,
		401,
		388,
		346,
		342,
		331,
		351,
		302,
		290,
		322,
		-1,
		-1,
		364,
		-1,
		298,
		315,
		306,
		304,
		297,
		279,
		286,
		294,
		271,
		266,
		256,
		245,
		245,
		240,
		262,
		248,
		246,
		255,
		271,
		-1,
		-1,
		-1,
		368,
		-1,
		-1,
		317,
		304,
		298,
		-1,
		339,
		-1,
		342,
		332,
		316,
		301,
		334,
		-1,
		278,
		274,
		281,
		-1,
		291,
		-1,
		264,
		261,
		252,
		237,
		234,
		245,
		243,
		254,
		250,
		-1,
		351,
		336,
		329,
		319,
		333,
		304,
		-1,
		359,
		-1,
		-1,
		329,
		323,
		323,
		307,
		308,
		294,
		274,
		266,
		281,
		280,
		267,
		266,
		250,
		243,
		240,
		233,
		246,
		256,
		261,
		248,
		-1,
		-1,
		-1,
		356,
		342,
		346,
		306,
		325,
		-1,
		-1,
		391,
		346,
		332,
		-1,
		303,
		294,
		282,
		272,
		262,
		267,
		268,
		258,
		256,
		248,
		250,
		244,
		235,
		234,
		250,
		242,
		264,
		-1,
		-1,
		339,
		344,
		332,
		318,
		336,
		-1,
		-1,
		-1,
		338,
		354,
		322,
		301,
		283,
		-1,
		-1,
		266,
		259,
		253,
		256,
		244,
		264,
		259,
		243,
		228,
		243,
		247,
		255,
		246,
		-1,
		342,
		329,
		-1,
		-1,
		335,
		325,
		-1,
		-1,
		-1,
		-1,
		334,
		279,
		268,
		263,
		267,
		265,
		-1,
		239,
		250,
		243,
		262,
		269,
		245,
		230,
		224,
		230,
		242,
		251,
		-1,
		-1,
		349,
		-1,
		311,
		-1,
		-1,
		-1,
		-1,
		291,
		285,
		256,
		249,
		253,
		-1,
		241,
		243,
		240,
		252,
		248,
		245,
		236,
		227,
		223,
		227,
		231,
		245,
		249,
		372,
		-1,
		302,
		-1,
		-1,
		-1,
		309,
		324,
		295,
		272,
		245,
		240,
		233,
		227,
		232,
		243,
		252,
		263,
		228,
		230,
		220,
		219,
		223,
		240,
		244,
		-1,
		-1,
		300,
		296,
		331,
		317,
		321,
		322,
		-1,
		-1,
		249,
		240,
		231,
		223,
		236,
		239,
		224,
		226,
		226,
		224,
		218,
		228,
		243,
		238,
		-1,
		-1,
		-1,
		312,
		-1,
		314,
		-1,
		-1,
		319,
		320,
		267,
		249,
		245,
		243,
		232,
		226,
		214,
		219,
		229,
		223,
		220,
		214,
		218,
		241,
		230,
		269,
		-1,
		-1,
		336,
		-1,
		-1,
		-1,
		296,
		283,
		278,
		301,
		303,
		294,
		282,
		279,
		-1,
		249,
		255,
		220,
		227,
		210,
		217,
		222,
		219,
		208,
		215,
		231,
		230,
		225,
		261,
		252,
		258,
		-1,
		-1,
		329,
		318,
		307,
		313,
		-1,
		289,
		280,
		287,
		277,
		280,
		-1,
		-1,
		274,
		271,
		251,
		220,
		218,
		211,
		206,
		216,
		192,
		204,
		208,
		212,
		218,
		223,
		228,
		234,
		249,
		264,
		-1,
		283,
		320,
		313,
		281,
		289,
		320,
		-1,
		279,
		271,
		277,
		269,
		271,
		-1,
		-1,
		247,
		238,
		239,
		227,
		224,
		230,
		229,
		212,
		218,
		219,
		211,
		210,
		228,
		232,
		241,
		248,
		238,
		251,
		255,
		-1,
		276,
		296,
		275,
		278,
		302,
		316,
		-1,
		270,
		-1,
		-1,
		237,
		272,
		256,
		246,
		243,
		286,
		241,
		236,
		217,
		215,
		210,
		201,
		226,
		219,
		219,
		222,
		237,
		242,
		234,
		248,
		248,
		249,
		-1,
		265,
		276,
		269,
		-1,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		227,
		-1,
		283,
		-1,
		266,
		270,
		249,
		252,
		231,
		218,
		204,
		212,
		218,
		217,
		223,
		223,
		224,
		233,
		244,
		256,
		255,
		256,
		243,
		246,
		249,
		260,
		271,
		286,
		290,
		-1,
		254,
		290,
		233,
		-1,
		217,
		-1,
		-1,
		-1,
		280,
		262,
		254,
		251,
		230,
		230,
		196,
		200,
		213,
		220,
		230,
		241,
		233,
		237,
		250,
		261,
		264,
		239,
		244,
		290,
		235,
		235,
		256,
		265,
		286,
		250,
		247,
		284,
		240,
		229,
		224,
		211,
		-1,
		-1,
		264,
		272,
		-1,
		-1,
		237,
		204,
		192,
		202,
		206,
		220,
		232,
		245,
		233,
		238,
		232,
		264,
		-1,
		237,
		236,
		225,
		222,
		208,
		220,
		226,
		253,
		-1,
		-1,
		248,
		275,
		259,
		263,
		271,
		296,
		-1,
		195,
		-1,
		-1,
		244,
		-1,
		-1,
		229,
		209,
		198,
		189,
		194,
		214,
		225,
		247,
		229,
		246,
		237,
		247,
		251,
		221,
		218,
		206,
		204,
		223,
		234,
		222,
		-1,
		230,
		233,
		239,
		246,
		263,
		285,
		-1,
		-1,
		211,
		191,
		-1,
		-1,
		227,
		225,
		214,
		-1,
		204,
		186,
		191,
		221,
		223,
		225,
		232,
		226,
		233,
		241,
		252,
		244,
		230,
		244,
		233,
		224,
		224,
		234,
		227,
		220,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		197,
		-1,
		-1,
		222,
		215,
		203,
		191,
		181,
		191,
		208,
		208,
		211,
		216,
		224,
		235,
		231,
		235,
		238,
		-1,
		259,
		-1,
		258,
		219,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		256,
		240,
		221,
		-1,
		191,
		204,
		244,
		212,
		217,
		212,
		227,
		238,
		229,
		237,
		231,
		234,
		-1,
		-1,
		218,
		201,
		-1,
		-1,
		175,
		177,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		228,
		224,
		-1,
		-1,
		178,
		216,
		215,
		223,
		218,
		223,
		235,
		231,
		227,
		237,
		228,
		-1,
		-1,
		196,
		188,
		182,
		-1,
		160,
		-1,
		211,
		-1,
		178,
		187,
		175,
		-1,
		-1,
		-1,
		209,
		172,
		188,
		211,
		237,
		235,
		226,
		219,
		226,
		229,
		222,
		228,
		-1,
		-1,
		-1,
		178,
		152,
		218,
		209,
		192,
		172,
		164,
		186,
		-1,
		190,
		-1,
		165,
		168,
		193,
		232,
		234,
		220,
		216,
		229,
		223,
		220,
		218,
		184,
		-1,
		154,
		187,
		151,
		178,
		144,
		158,
		204,
		-1,
		187,
		169,
		-1,
		197,
		187,
		235,
		210,
		219,
		212,
		206,
		207,
		215,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		139,
		156,
		-1,
		192,
		174,
		160,
		177,
		177,
		168,
		176,
		225,
		221,
		224,
		222,
		200,
		-1,
		127,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		134,
		147,
		158,
		161,
		157,
		157,
		159,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		199,
		231,
		-1,
		122,
		-1,
		186,
		-1,
		-1,
		131,
		118,
		128,
		139,
		167,
		167,
		156,
		152,
		169,
		204,
		190,
		188,
		193,
		198,
		-1,
		111,
		110,
		-1,
		104,
		114,
		128,
		-1,
		109,
		-1,
		213,
		174,
		-1,
		153,
		147,
		-1,
		199,
		195,
		-1,
		-1,
		98,
		93,
		-1,
		-1,
		-1,
		108,
		117,
		208,
		192,
		-1,
		137,
		144,
		-1,
		-1,
		-1,
		83,
		84,
		-1,
		101,
		104,
		-1,
		118,
		124,
		152,
		132,
		138,
		-1,
		-1,
		-1,
		92,
		73,
		67,
		91,
		86,
		109,
		149,
		135,
		135,
		119,
		129,
		158,
		-1,
		-1,
		-1,
		59,
		61,
		71,
		-1,
		-1,
		160,
		143,
		130,
		128,
		-1,
		-1,
		-1,
		66,
		60,
		-1,
		-1,
		80,
		-1,
		-1,
		125,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		21,
		50,
		-1,
		-1,
		-1,
		81,
		88,
		109,
		-1,
		-1,
		-1,
		-1,
		0,
		1,
		45,
		46,
		-1,
		-1,
		-1,
		95,
		98,
		-1,
		-1,
		3,
		1,
		-1,
		-1,
		-1,
		77,
		89,
		-1,
		109,
		-1,
		-1,
		-1,
		93,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		107,
		-1,
		144,
		119,
		126,
		-1,
		-1,
		-1,
		-1,
		120,
		112,
		157,
		-1,
		129,
		131,
		-1,
		179,
		-1,
		-1,
		135,
		130,
		-1,
		-1,
		134,
		141,
		163,
		166,
		100,
		-1,
		153
	],
	[
		-1,
		380,
		369,
		380,
		388,
		361,
		368,
		-1,
		387,
		391,
		357,
		351,
		390,
		359,
		365,
		376,
		-1,
		-1,
		-1,
		380,
		379,
		347,
		345,
		354,
		359,
		366,
		-1,
		365,
		-1,
		401,
		380,
		391,
		396,
		340,
		337,
		357,
		376,
		358,
		350,
		416,
		370,
		341,
		335,
		353,
		343,
		352,
		344,
		-1,
		341,
		331,
		353,
		332,
		343,
		335,
		-1,
		-1,
		335,
		336,
		342,
		328,
		334,
		330,
		-1,
		340,
		324,
		-1,
		-1,
		325,
		326,
		310,
		313,
		321,
		319,
		332,
		324,
		319,
		-1,
		-1,
		316,
		312,
		319,
		306,
		302,
		319,
		332,
		314,
		328,
		327,
		-1,
		320,
		338,
		345,
		313,
		311,
		295,
		293,
		311,
		313,
		319,
		319,
		-1,
		329,
		330,
		325,
		333,
		335,
		311,
		298,
		298,
		308,
		301,
		320,
		308,
		354,
		-1,
		-1,
		-1,
		-1,
		-1,
		363,
		329,
		312,
		329,
		321,
		311,
		326,
		319,
		301,
		298,
		296,
		293,
		309,
		307,
		317,
		-1,
		-1,
		422,
		391,
		420,
		378,
		359,
		-1,
		325,
		305,
		311,
		315,
		309,
		302,
		316,
		312,
		-1,
		287,
		286,
		314,
		300,
		311,
		382,
		-1,
		-1,
		380,
		372,
		355,
		358,
		335,
		331,
		320,
		319,
		311,
		297,
		293,
		299,
		302,
		302,
		308,
		281,
		291,
		295,
		293,
		318,
		-1,
		-1,
		353,
		-1,
		-1,
		379,
		362,
		-1,
		345,
		352,
		341,
		347,
		333,
		354,
		330,
		321,
		313,
		307,
		295,
		297,
		294,
		307,
		295,
		278,
		303,
		307,
		288,
		309,
		304,
		-1,
		352,
		336,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		357,
		338,
		341,
		347,
		371,
		370,
		-1,
		342,
		330,
		331,
		316,
		313,
		300,
		288,
		301,
		286,
		293,
		292,
		282,
		280,
		310,
		285,
		307,
		304,
		323,
		328,
		322,
		331,
		-1,
		387,
		383,
		379,
		386,
		335,
		-1,
		-1,
		375,
		-1,
		378,
		379,
		354,
		327,
		330,
		317,
		308,
		295,
		284,
		295,
		284,
		281,
		289,
		274,
		289,
		280,
		279,
		297,
		307,
		315,
		319,
		325,
		-1,
		437,
		-1,
		379,
		363,
		365,
		337,
		358,
		-1,
		395,
		379,
		371,
		356,
		356,
		-1,
		326,
		323,
		313,
		291,
		276,
		293,
		285,
		283,
		287,
		269,
		283,
		274,
		292,
		299,
		297,
		301,
		321,
		333,
		397,
		387,
		-1,
		369,
		374,
		333,
		341,
		360,
		398,
		362,
		-1,
		357,
		-1,
		328,
		341,
		-1,
		297,
		293,
		275,
		276,
		271,
		286,
		280,
		265,
		262,
		280,
		283,
		290,
		294,
		310,
		-1,
		-1,
		382,
		386,
		375,
		326,
		345,
		369,
		406,
		355,
		344,
		343,
		-1,
		334,
		311,
		308,
		296,
		283,
		268,
		269,
		277,
		290,
		269,
		264,
		261,
		281,
		307,
		285,
		297,
		-1,
		-1,
		-1,
		407,
		-1,
		-1,
		352,
		323,
		347,
		389,
		373,
		366,
		354,
		319,
		319,
		313,
		-1,
		307,
		286,
		277,
		266,
		264,
		277,
		274,
		279,
		259,
		257,
		276,
		288,
		279,
		296,
		-1,
		-1,
		-1,
		382,
		371,
		372,
		318,
		341,
		378,
		352,
		338,
		343,
		318,
		311,
		305,
		320,
		303,
		284,
		273,
		265,
		254,
		270,
		278,
		273,
		255,
		264,
		270,
		294,
		284,
		290,
		-1,
		-1,
		389,
		379,
		363,
		365,
		362,
		332,
		339,
		371,
		343,
		356,
		-1,
		310,
		-1,
		299,
		294,
		278,
		273,
		270,
		267,
		261,
		270,
		272,
		262,
		257,
		264,
		299,
		299,
		274,
		294,
		297,
		-1,
		-1,
		-1,
		382,
		377,
		352,
		329,
		313,
		349,
		-1,
		326,
		327,
		-1,
		304,
		298,
		295,
		280,
		276,
		271,
		275,
		268,
		275,
		268,
		266,
		267,
		249,
		281,
		-1,
		282,
		276,
		284,
		274,
		262,
		-1,
		-1,
		-1,
		375,
		354,
		347,
		367,
		308,
		360,
		-1,
		-1,
		311,
		304,
		-1,
		291,
		273,
		280,
		278,
		272,
		276,
		273,
		262,
		275,
		268,
		254,
		256,
		269,
		273,
		277,
		264,
		260,
		257,
		271,
		-1,
		394,
		-1,
		-1,
		-1,
		-1,
		-1,
		308,
		328,
		-1,
		320,
		312,
		302,
		296,
		290,
		286,
		284,
		300,
		284,
		287,
		285,
		276,
		284,
		257,
		250,
		257,
		246,
		264,
		272,
		264,
		258,
		257,
		267,
		-1,
		395,
		381,
		352,
		-1,
		-1,
		341,
		-1,
		305,
		319,
		335,
		-1,
		328,
		307,
		322,
		300,
		296,
		292,
		307,
		308,
		285,
		285,
		283,
		274,
		262,
		251,
		254,
		246,
		268,
		268,
		252,
		253,
		257,
		-1,
		401,
		388,
		346,
		342,
		331,
		351,
		302,
		290,
		322,
		-1,
		-1,
		364,
		-1,
		298,
		315,
		306,
		304,
		297,
		279,
		286,
		294,
		271,
		266,
		256,
		245,
		245,
		240,
		262,
		248,
		246,
		255,
		271,
		-1,
		-1,
		-1,
		368,
		-1,
		-1,
		317,
		304,
		298,
		-1,
		339,
		-1,
		342,
		332,
		316,
		301,
		334,
		-1,
		278,
		274,
		281,
		-1,
		291,
		-1,
		264,
		261,
		252,
		237,
		234,
		245,
		243,
		254,
		250,
		-1,
		351,
		336,
		329,
		319,
		333,
		304,
		-1,
		359,
		-1,
		-1,
		329,
		323,
		323,
		307,
		308,
		294,
		274,
		266,
		281,
		280,
		267,
		266,
		250,
		243,
		240,
		233,
		246,
		256,
		261,
		248,
		-1,
		-1,
		-1,
		356,
		342,
		346,
		306,
		325,
		-1,
		-1,
		391,
		346,
		332,
		-1,
		303,
		294,
		282,
		272,
		262,
		267,
		268,
		258,
		256,
		248,
		250,
		244,
		235,
		234,
		250,
		242,
		264,
		-1,
		-1,
		339,
		344,
		332,
		318,
		336,
		-1,
		-1,
		-1,
		338,
		354,
		322,
		301,
		283,
		-1,
		-1,
		266,
		259,
		253,
		256,
		244,
		264,
		259,
		243,
		228,
		243,
		247,
		255,
		246,
		-1,
		342,
		329,
		-1,
		-1,
		335,
		325,
		-1,
		-1,
		-1,
		-1,
		334,
		279,
		268,
		263,
		267,
		265,
		-1,
		239,
		250,
		243,
		262,
		269,
		245,
		230,
		224,
		230,
		242,
		251,
		-1,
		-1,
		349,
		-1,
		311,
		-1,
		-1,
		-1,
		-1,
		291,
		285,
		256,
		249,
		253,
		-1,
		241,
		243,
		240,
		252,
		248,
		245,
		236,
		227,
		223,
		227,
		231,
		245,
		249,
		372,
		-1,
		302,
		-1,
		-1,
		-1,
		309,
		324,
		295,
		272,
		245,
		240,
		233,
		227,
		232,
		243,
		252,
		263,
		228,
		230,
		220,
		219,
		223,
		240,
		244,
		-1,
		-1,
		300,
		296,
		331,
		317,
		321,
		322,
		-1,
		-1,
		249,
		240,
		231,
		223,
		236,
		239,
		224,
		226,
		226,
		224,
		218,
		228,
		243,
		238,
		-1,
		-1,
		-1,
		312,
		-1,
		314,
		-1,
		-1,
		319,
		320,
		267,
		249,
		245,
		243,
		232,
		226,
		214,
		219,
		229,
		223,
		220,
		214,
		218,
		241,
		230,
		269,
		-1,
		-1,
		336,
		-1,
		-1,
		-1,
		296,
		283,
		278,
		301,
		303,
		294,
		282,
		279,
		-1,
		249,
		255,
		220,
		227,
		210,
		217,
		222,
		219,
		208,
		215,
		231,
		230,
		225,
		261,
		252,
		258,
		-1,
		-1,
		329,
		318,
		307,
		313,
		-1,
		289,
		280,
		287,
		277,
		280,
		-1,
		-1,
		274,
		271,
		251,
		220,
		218,
		211,
		206,
		216,
		192,
		204,
		208,
		212,
		218,
		223,
		228,
		234,
		249,
		264,
		-1,
		283,
		320,
		313,
		281,
		289,
		320,
		-1,
		279,
		271,
		277,
		269,
		271,
		-1,
		-1,
		247,
		238,
		239,
		227,
		224,
		230,
		229,
		212,
		218,
		219,
		211,
		210,
		228,
		232,
		241,
		248,
		238,
		251,
		255,
		-1,
		276,
		296,
		275,
		278,
		302,
		316,
		-1,
		270,
		-1,
		-1,
		237,
		272,
		256,
		246,
		243,
		286,
		241,
		236,
		217,
		215,
		210,
		201,
		226,
		219,
		219,
		222,
		237,
		242,
		234,
		248,
		248,
		249,
		-1,
		265,
		276,
		269,
		-1,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		227,
		-1,
		283,
		-1,
		266,
		270,
		249,
		252,
		231,
		218,
		204,
		212,
		218,
		217,
		223,
		223,
		224,
		233,
		244,
		256,
		255,
		256,
		243,
		246,
		249,
		260,
		271,
		286,
		290,
		-1,
		254,
		290,
		233,
		-1,
		217,
		-1,
		-1,
		-1,
		280,
		262,
		254,
		251,
		230,
		230,
		196,
		200,
		213,
		220,
		230,
		241,
		233,
		237,
		250,
		261,
		264,
		239,
		244,
		290,
		235,
		235,
		256,
		265,
		286,
		250,
		247,
		284,
		240,
		229,
		224,
		211,
		-1,
		-1,
		264,
		272,
		-1,
		-1,
		237,
		204,
		192,
		202,
		206,
		220,
		232,
		245,
		233,
		238,
		232,
		264,
		-1,
		237,
		236,
		225,
		222,
		208,
		220,
		226,
		253,
		-1,
		-1,
		248,
		275,
		259,
		263,
		271,
		296,
		-1,
		195,
		-1,
		-1,
		244,
		-1,
		-1,
		229,
		209,
		198,
		189,
		194,
		214,
		225,
		247,
		229,
		246,
		237,
		247,
		251,
		221,
		218,
		206,
		204,
		223,
		234,
		222,
		-1,
		230,
		233,
		239,
		246,
		263,
		285,
		-1,
		-1,
		211,
		191,
		-1,
		-1,
		227,
		225,
		214,
		-1,
		204,
		186,
		191,
		221,
		223,
		225,
		232,
		226,
		233,
		241,
		252,
		244,
		230,
		244,
		233,
		224,
		224,
		234,
		227,
		220,
		227,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		201,
		197,
		-1,
		-1,
		222,
		215,
		203,
		191,
		181,
		191,
		208,
		208,
		211,
		216,
		224,
		235,
		231,
		235,
		238,
		-1,
		259,
		-1,
		258,
		219,
		225,
		240,
		248,
		-1,
		-1,
		-1,
		218,
		204,
		197,
		185,
		183,
		-1,
		256,
		240,
		221,
		-1,
		191,
		204,
		244,
		212,
		217,
		212,
		227,
		238,
		229,
		237,
		231,
		234,
		-1,
		-1,
		218,
		201,
		-1,
		-1,
		175,
		177,
		-1,
		209,
		198,
		183,
		175,
		-1,
		-1,
		228,
		224,
		-1,
		-1,
		178,
		216,
		215,
		223,
		218,
		223,
		235,
		231,
		227,
		237,
		228,
		-1,
		-1,
		196,
		188,
		182,
		-1,
		160,
		-1,
		211,
		-1,
		178,
		187,
		175,
		-1,
		-1,
		-1,
		209,
		172,
		188,
		211,
		237,
		235,
		226,
		219,
		226,
		229,
		222,
		228,
		-1,
		-1,
		-1,
		178,
		152,
		218,
		209,
		192,
		172,
		164,
		186,
		-1,
		190,
		-1,
		165,
		168,
		193,
		232,
		234,
		220,
		216,
		229,
		223,
		220,
		218,
		184,
		-1,
		154,
		187,
		151,
		178,
		144,
		158,
		204,
		-1,
		187,
		169,
		-1,
		197,
		187,
		235,
		210,
		219,
		212,
		206,
		207,
		215,
		-1,
		-1,
		-1,
		156,
		155,
		147,
		141,
		141,
		139,
		156,
		-1,
		192,
		174,
		160,
		177,
		177,
		168,
		176,
		225,
		221,
		224,
		222,
		200,
		-1,
		127,
		-1,
		-1,
		179,
		-1,
		-1,
		-1,
		150,
		134,
		147,
		158,
		161,
		157,
		157,
		159,
		172,
		180,
		178,
		175,
		187,
		183,
		203,
		199,
		231,
		-1,
		122,
		-1,
		186,
		-1,
		-1,
		131,
		118,
		128,
		139,
		167,
		167,
		156,
		152,
		169,
		204,
		190,
		188,
		193,
		198,
		-1,
		111,
		110,
		-1,
		104,
		114,
		128,
		-1,
		109,
		-1,
		213,
		174,
		-1,
		153,
		147,
		-1,
		199,
		195,
		-1,
		-1,
		98,
		93,
		-1,
		-1,
		-1,
		108,
		117,
		208,
		192,
		-1,
		137,
		144,
		-1,
		-1,
		-1,
		83,
		84,
		-1,
		101,
		104,
		-1,
		118,
		124,
		152,
		132,
		138,
		-1,
		-1,
		-1,
		92,
		73,
		67,
		91,
		86,
		109,
		149,
		135,
		135,
		119,
		129,
		158,
		-1,
		-1,
		-1,
		59,
		61,
		71,
		-1,
		-1,
		160,
		143,
		130,
		128,
		-1,
		-1,
		-1,
		65,
		59,
		-1,
		-1,
		80,
		-1,
		-1,
		125,
		104,
		-1,
		-1,
		-1,
		-1,
		-1,
		21,
		49,
		-1,
		-1,
		-1,
		81,
		88,
		109,
		-1,
		-1,
		-1,
		-1,
		0,
		0,
		44,
		45,
		-1,
		-1,
		-1,
		95,
		98,
		-1,
		-1,
		3,
		1,
		-1,
		-1,
		-1,
		76,
		88,
		-1,
		109,
		-1,
		-1,
		-1,
		92,
		-1,
		-1,
		142,
		-1,
		-1,
		-1,
		106,
		-1,
		144,
		119,
		126,
		-1,
		-1,
		-1,
		-1,
		119,
		111,
		157,
		-1,
		129,
		131,
		-1,
		179,
		-1,
		-1,
		134,
		129,
		-1,
		-1,
		134,
		141,
		163,
		166,
		100,
		-1,
		153
	],
	[
		-1,
		384,
		373,
		384,
		392,
		365,
		372,
		-1,
		391,
		395,
		361,
		355,
		394,
		363,
		369,
		380,
		-1,
		-1,
		-1,
		384,
		383,
		351,
		349,
		358,
		363,
		370,
		-1,
		369,
		-1,
		405,
		384,
		395,
		400,
		344,
		341,
		361,
		380,
		362,
		354,
		420,
		374,
		345,
		339,
		357,
		347,
		356,
		348,
		-1,
		345,
		335,
		357,
		336,
		347,
		339,
		-1,
		-1,
		339,
		340,
		346,
		332,
		338,
		334,
		-1,
		344,
		328,
		-1,
		-1,
		329,
		330,
		314,
		317,
		325,
		323,
		336,
		328,
		323,
		-1,
		-1,
		320,
		316,
		323,
		310,
		306,
		323,
		336,
		318,
		332,
		331,
		-1,
		324,
		342,
		349,
		317,
		315,
		299,
		297,
		315,
		317,
		323,
		323,
		-1,
		333,
		334,
		329,
		337,
		339,
		315,
		302,
		302,
		312,
		305,
		324,
		312,
		358,
		-1,
		-1,
		-1,
		-1,
		-1,
		367,
		333,
		316,
		333,
		325,
		315,
		330,
		323,
		305,
		302,
		300,
		297,
		313,
		311,
		321,
		-1,
		-1,
		426,
		395,
		424,
		382,
		363,
		-1,
		329,
		309,
		315,
		319,
		313,
		306,
		320,
		316,
		-1,
		291,
		290,
		318,
		304,
		315,
		386,
		-1,
		-1,
		384,
		376,
		359,
		362,
		339,
		335,
		324,
		323,
		315,
		301,
		297,
		303,
		306,
		306,
		312,
		285,
		295,
		299,
		297,
		322,
		-1,
		-1,
		357,
		-1,
		-1,
		383,
		366,
		-1,
		349,
		356,
		345,
		351,
		337,
		358,
		334,
		325,
		317,
		311,
		299,
		301,
		298,
		311,
		299,
		282,
		307,
		311,
		292,
		313,
		308,
		-1,
		356,
		340,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		361,
		342,
		345,
		351,
		375,
		374,
		-1,
		346,
		334,
		335,
		320,
		317,
		304,
		292,
		305,
		290,
		297,
		296,
		286,
		284,
		314,
		289,
		311,
		308,
		327,
		332,
		326,
		335,
		-1,
		391,
		387,
		383,
		390,
		339,
		-1,
		-1,
		379,
		-1,
		382,
		383,
		358,
		331,
		334,
		321,
		312,
		299,
		288,
		299,
		288,
		285,
		293,
		278,
		293,
		284,
		283,
		301,
		311,
		319,
		323,
		329,
		-1,
		441,
		-1,
		383,
		367,
		369,
		341,
		362,
		-1,
		399,
		383,
		375,
		360,
		360,
		-1,
		330,
		327,
		317,
		295,
		280,
		297,
		289,
		287,
		291,
		273,
		287,
		278,
		296,
		303,
		301,
		305,
		325,
		337,
		401,
		391,
		-1,
		373,
		378,
		337,
		345,
		364,
		402,
		366,
		-1,
		361,
		-1,
		332,
		345,
		-1,
		301,
		297,
		279,
		280,
		275,
		290,
		284,
		269,
		266,
		284,
		287,
		294,
		298,
		314,
		-1,
		-1,
		386,
		390,
		379,
		330,
		349,
		373,
		410,
		359,
		348,
		347,
		-1,
		338,
		315,
		312,
		300,
		287,
		272,
		273,
		281,
		294,
		273,
		268,
		265,
		285,
		311,
		289,
		301,
		-1,
		-1,
		-1,
		411,
		-1,
		-1,
		356,
		327,
		351,
		393,
		377,
		370,
		358,
		323,
		323,
		317,
		-1,
		311,
		290,
		281,
		270,
		268,
		281,
		278,
		283,
		263,
		261,
		280,
		292,
		283,
		300,
		-1,
		-1,
		-1,
		386,
		375,
		376,
		322,
		345,
		382,
		356,
		342,
		347,
		322,
		315,
		309,
		324,
		307,
		288,
		277,
		269,
		258,
		274,
		282,
		277,
		259,
		268,
		274,
		298,
		288,
		294,
		-1,
		-1,
		393,
		383,
		367,
		369,
		366,
		336,
		343,
		375,
		347,
		360,
		-1,
		314,
		-1,
		303,
		298,
		282,
		277,
		274,
		271,
		265,
		274,
		276,
		266,
		261,
		268,
		303,
		303,
		278,
		298,
		301,
		-1,
		-1,
		-1,
		386,
		381,
		356,
		333,
		317,
		353,
		-1,
		330,
		331,
		-1,
		308,
		302,
		299,
		284,
		280,
		275,
		279,
		272,
		279,
		272,
		270,
		271,
		253,
		285,
		-1,
		286,
		280,
		288,
		278,
		266,
		-1,
		-1,
		-1,
		379,
		358,
		351,
		371,
		312,
		364,
		-1,
		-1,
		315,
		308,
		-1,
		295,
		277,
		284,
		282,
		276,
		280,
		277,
		266,
		279,
		272,
		258,
		260,
		273,
		277,
		281,
		268,
		264,
		261,
		275,
		-1,
		398,
		-1,
		-1,
		-1,
		-1,
		-1,
		312,
		332,
		-1,
		324,
		316,
		306,
		300,
		294,
		290,
		288,
		304,
		288,
		291,
		289,
		280,
		288,
		261,
		254,
		261,
		250,
		268,
		276,
		268,
		262,
		261,
		271,
		-1,
		399,
		385,
		356,
		-1,
		-1,
		345,
		-1,
		309,
		323,
		339,
		-1,
		332,
		311,
		326,
		304,
		300,
		296,
		311,
		312,
		289,
		289,
		287,
		278,
		266,
		255,
		258,
		250,
		272,
		272,
		256,
		257,
		261,
		-1,
		405,
		392,
		350,
		346,
		335,
		355,
		306,
		294,
		326,
		-1,
		-1,
		368,
		-1,
		302,
		319,
		310,
		308,
		301,
		283,
		290,
		298,
		275,
		270,
		260,
		249,
		249,
		244,
		266,
		252,
		250,
		259,
		275,
		-1,
		-1,
		-1,
		372,
		-1,
		-1,
		321,
		308,
		302,
		-1,
		343,
		-1,
		346,
		336,
		320,
		305,
		338,
		-1,
		282,
		278,
		285,
		-1,
		295,
		-1,
		268,
		265,
		256,
		241,
		238,
		249,
		247,
		258,
		254,
		-1,
		355,
		340,
		333,
		323,
		337,
		308,
		-1,
		363,
		-1,
		-1,
		333,
		327,
		327,
		311,
		312,
		298,
		278,
		270,
		285,
		284,
		271,
		270,
		254,
		247,
		244,
		237,
		250,
		260,
		265,
		252,
		-1,
		-1,
		-1,
		360,
		346,
		350,
		310,
		329,
		-1,
		-1,
		395,
		350,
		336,
		-1,
		307,
		298,
		286,
		276,
		266,
		271,
		272,
		262,
		260,
		252,
		254,
		248,
		239,
		238,
		254,
		246,
		268,
		-1,
		-1,
		343,
		348,
		336,
		322,
		340,
		-1,
		-1,
		-1,
		342,
		358,
		326,
		305,
		287,
		-1,
		-1,
		270,
		263,
		257,
		260,
		248,
		268,
		263,
		247,
		232,
		247,
		251,
		259,
		250,
		-1,
		346,
		333,
		-1,
		-1,
		339,
		329,
		-1,
		-1,
		-1,
		-1,
		338,
		283,
		272,
		267,
		271,
		269,
		-1,
		243,
		254,
		247,
		266,
		273,
		249,
		234,
		228,
		234,
		246,
		255,
		-1,
		-1,
		353,
		-1,
		315,
		-1,
		-1,
		-1,
		-1,
		295,
		289,
		260,
		253,
		257,
		-1,
		245,
		247,
		244,
		256,
		252,
		249,
		240,
		231,
		227,
		231,
		235,
		249,
		253,
		376,
		-1,
		306,
		-1,
		-1,
		-1,
		313,
		328,
		299,
		276,
		249,
		244,
		237,
		231,
		236,
		247,
		256,
		267,
		232,
		234,
		224,
		223,
		227,
		244,
		248,
		-1,
		-1,
		304,
		300,
		335,
		321,
		325,
		326,
		-1,
		-1,
		253,
		244,
		235,
		227,
		240,
		243,
		228,
		230,
		230,
		228,
		222,
		232,
		247,
		242,
		-1,
		-1,
		-1,
		316,
		-1,
		318,
		-1,
		-1,
		323,
		324,
		271,
		253,
		249,
		247,
		236,
		230,
		218,
		223,
		233,
		227,
		224,
		218,
		222,
		245,
		234,
		273,
		-1,
		-1,
		340,
		-1,
		-1,
		-1,
		300,
		287,
		282,
		305,
		307,
		298,
		286,
		283,
		-1,
		253,
		259,
		224,
		231,
		214,
		221,
		226,
		223,
		212,
		219,
		235,
		234,
		229,
		265,
		256,
		262,
		-1,
		-1,
		333,
		322,
		311,
		317,
		-1,
		293,
		284,
		291,
		281,
		284,
		-1,
		-1,
		278,
		275,
		255,
		224,
		222,
		215,
		210,
		220,
		196,
		208,
		212,
		216,
		222,
		227,
		232,
		238,
		253,
		268,
		-1,
		287,
		324,
		317,
		285,
		293,
		324,
		-1,
		283,
		275,
		281,
		273,
		275,
		-1,
		-1,
		251,
		242,
		243,
		231,
		228,
		234,
		233,
		216,
		222,
		223,
		215,
		214,
		232,
		236,
		245,
		252,
		242,
		255,
		259,
		-1,
		280,
		300,
		279,
		282,
		306,
		320,
		-1,
		274,
		-1,
		-1,
		241,
		276,
		260,
		250,
		247,
		290,
		245,
		240,
		221,
		219,
		214,
		205,
		230,
		223,
		223,
		226,
		241,
		246,
		238,
		252,
		252,
		253,
		-1,
		269,
		280,
		273,
		-1,
		-1,
		-1,
		-1,
		268,
		-1,
		-1,
		231,
		-1,
		287,
		-1,
		270,
		274,
		253,
		256,
		235,
		222,
		208,
		216,
		222,
		221,
		227,
		227,
		228,
		237,
		248,
		260,
		259,
		260,
		262,
		250,
		253,
		264,
		275,
		290,
		294,
		-1,
		258,
		294,
		237,
		-1,
		221,
		-1,
		-1,
		-1,
		284,
		266,
		258,
		255,
		234,
		234,
		200,
		204,
		217,
		224,
		234,
		245,
		237,
		241,
		254,
		265,
		268,
		258,
		263,
		294,
		239,
		239,
		260,
		269,
		290,
		254,
		251,
		288,
		244,
		233,
		228,
		215,
		-1,
		-1,
		268,
		276,
		-1,
		-1,
		241,
		208,
		196,
		206,
		210,
		224,
		236,
		249,
		237,
		242,
		236,
		268,
		-1,
		256,
		255,
		244,
		241,
		227,
		235,
		230,
		257,
		-1,
		-1,
		252,
		279,
		263,
		267,
		275,
		300,
		-1,
		199,
		-1,
		-1,
		248,
		-1,
		-1,
		233,
		213,
		202,
		193,
		198,
		218,
		229,
		251,
		233,
		250,
		241,
		251,
		255,
		240,
		237,
		225,
		223,
		242,
		238,
		226,
		-1,
		234,
		237,
		243,
		250,
		267,
		289,
		-1,
		-1,
		215,
		195,
		-1,
		-1,
		231,
		229,
		218,
		-1,
		208,
		190,
		195,
		225,
		227,
		229,
		236,
		230,
		237,
		245,
		256,
		248,
		249,
		263,
		252,
		243,
		243,
		253,
		231,
		224,
		231,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		220,
		-1,
		205,
		201,
		-1,
		-1,
		226,
		219,
		207,
		195,
		185,
		195,
		212,
		212,
		215,
		220,
		228,
		239,
		235,
		239,
		242,
		-1,
		278,
		-1,
		262,
		223,
		229,
		244,
		252,
		-1,
		-1,
		-1,
		222,
		208,
		201,
		189,
		187,
		-1,
		260,
		244,
		225,
		-1,
		195,
		208,
		248,
		216,
		221,
		216,
		231,
		242,
		233,
		241,
		235,
		238,
		-1,
		-1,
		222,
		205,
		-1,
		-1,
		179,
		181,
		-1,
		213,
		202,
		187,
		179,
		-1,
		-1,
		232,
		228,
		-1,
		-1,
		182,
		220,
		219,
		227,
		222,
		227,
		239,
		235,
		231,
		241,
		232,
		-1,
		-1,
		200,
		192,
		186,
		-1,
		164,
		-1,
		215,
		-1,
		182,
		191,
		179,
		-1,
		-1,
		-1,
		213,
		176,
		192,
		215,
		241,
		239,
		230,
		223,
		230,
		233,
		226,
		232,
		-1,
		-1,
		-1,
		182,
		156,
		222,
		213,
		196,
		176,
		168,
		190,
		-1,
		194,
		-1,
		169,
		172,
		197,
		236,
		238,
		224,
		220,
		233,
		227,
		224,
		222,
		188,
		-1,
		158,
		191,
		155,
		182,
		148,
		162,
		208,
		-1,
		191,
		173,
		-1,
		201,
		191,
		239,
		214,
		223,
		216,
		210,
		211,
		219,
		-1,
		-1,
		-1,
		160,
		159,
		151,
		145,
		145,
		143,
		160,
		-1,
		196,
		178,
		164,
		181,
		181,
		172,
		180,
		229,
		225,
		228,
		226,
		204,
		-1,
		129,
		-1,
		-1,
		183,
		-1,
		-1,
		-1,
		154,
		138,
		151,
		162,
		165,
		161,
		161,
		163,
		176,
		184,
		182,
		179,
		191,
		187,
		207,
		203,
		235,
		-1,
		124,
		-1,
		190,
		-1,
		-1,
		135,
		122,
		132,
		143,
		171,
		171,
		160,
		156,
		173,
		208,
		194,
		192,
		197,
		202,
		-1,
		113,
		112,
		-1,
		106,
		116,
		132,
		-1,
		113,
		-1,
		217,
		178,
		-1,
		157,
		151,
		-1,
		203,
		199,
		-1,
		-1,
		100,
		95,
		-1,
		-1,
		-1,
		112,
		121,
		212,
		196,
		-1,
		141,
		148,
		-1,
		-1,
		-1,
		85,
		86,
		-1,
		105,
		108,
		-1,
		122,
		128,
		156,
		136,
		142,
		-1,
		-1,
		-1,
		94,
		75,
		69,
		95,
		90,
		113,
		153,
		139,
		139,
		123,
		133,
		162,
		-1,
		-1,
		-1,
		56,
		63,
		75,
		-1,
		-1,
		164,
		147,
		134,
		132,
		-1,
		-1,
		-1,
		57,
		51,
		-1,
		-1,
		84,
		-1,
		-1,
		129,
		108,
		-1,
		-1,
		-1,
		-1,
		-1,
		40,
		41,
		-1,
		-1,
		-1,
		85,
		92,
		113,
		-1,
		-1,
		-1,
		-1,
		19,
		19,
		0,
		37,
		-1,
		-1,
		-1,
		99,
		102,
		-1,
		-1,
		22,
		20,
		-1,
		-1,
		-1,
		68,
		80,
		-1,
		113,
		-1,
		-1,
		-1,
		84,
		-1,
		-1,
		146,
		-1,
		-1,
		-1,
		98,
		-1,
		148,
		123,
		130,
		-1,
		-1,
		-1,
		-1,
		111,
		103,
		161,
		-1,
		133,
		135,
		-1,
		183,
		-1,
		-1,
		126,
		121,
		-1,
		-1,
		138,
		145,
		167,
		170,
		119,
		-1,
		157
	],
	[
		-1,
		351,
		340,
		351,
		359,
		332,
		339,
		-1,
		358,
		362,
		328,
		322,
		361,
		330,
		336,
		347,
		-1,
		-1,
		-1,
		351,
		350,
		318,
		316,
		325,
		330,
		337,
		-1,
		336,
		-1,
		372,
		351,
		362,
		367,
		311,
		308,
		328,
		347,
		329,
		321,
		387,
		341,
		312,
		306,
		324,
		314,
		323,
		315,
		-1,
		312,
		302,
		324,
		303,
		314,
		306,
		-1,
		-1,
		306,
		307,
		313,
		299,
		305,
		301,
		-1,
		311,
		295,
		-1,
		-1,
		296,
		297,
		281,
		284,
		292,
		290,
		303,
		295,
		290,
		-1,
		-1,
		287,
		283,
		290,
		277,
		273,
		290,
		303,
		285,
		299,
		298,
		-1,
		291,
		309,
		316,
		284,
		282,
		266,
		264,
		282,
		284,
		290,
		290,
		-1,
		300,
		301,
		296,
		304,
		306,
		282,
		269,
		269,
		279,
		272,
		291,
		279,
		325,
		-1,
		-1,
		-1,
		-1,
		-1,
		334,
		300,
		283,
		300,
		292,
		282,
		297,
		290,
		272,
		269,
		267,
		264,
		280,
		278,
		288,
		-1,
		-1,
		393,
		362,
		391,
		349,
		330,
		-1,
		296,
		276,
		282,
		286,
		280,
		273,
		287,
		283,
		-1,
		258,
		257,
		285,
		271,
		282,
		353,
		-1,
		-1,
		351,
		343,
		326,
		329,
		306,
		302,
		291,
		290,
		282,
		268,
		264,
		270,
		273,
		273,
		279,
		252,
		262,
		266,
		264,
		289,
		-1,
		-1,
		324,
		-1,
		-1,
		350,
		333,
		-1,
		316,
		323,
		312,
		318,
		304,
		325,
		301,
		292,
		284,
		278,
		266,
		268,
		265,
		278,
		266,
		249,
		274,
		278,
		259,
		280,
		275,
		-1,
		323,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		328,
		309,
		312,
		318,
		342,
		341,
		-1,
		313,
		301,
		302,
		287,
		284,
		271,
		259,
		272,
		257,
		264,
		263,
		253,
		251,
		281,
		256,
		278,
		275,
		294,
		299,
		293,
		302,
		-1,
		358,
		354,
		350,
		357,
		306,
		-1,
		-1,
		346,
		-1,
		349,
		350,
		325,
		298,
		301,
		288,
		279,
		266,
		255,
		266,
		255,
		252,
		260,
		245,
		260,
		251,
		250,
		268,
		278,
		286,
		290,
		296,
		-1,
		408,
		-1,
		350,
		334,
		336,
		308,
		329,
		-1,
		366,
		350,
		342,
		327,
		327,
		-1,
		297,
		294,
		284,
		262,
		247,
		264,
		256,
		254,
		258,
		240,
		254,
		245,
		263,
		270,
		268,
		272,
		292,
		304,
		368,
		358,
		-1,
		340,
		345,
		304,
		312,
		331,
		369,
		333,
		-1,
		328,
		-1,
		299,
		312,
		-1,
		268,
		264,
		246,
		247,
		242,
		257,
		251,
		236,
		233,
		251,
		254,
		261,
		265,
		281,
		-1,
		-1,
		353,
		357,
		346,
		297,
		316,
		340,
		377,
		326,
		315,
		314,
		-1,
		305,
		282,
		279,
		267,
		254,
		239,
		240,
		248,
		261,
		240,
		235,
		232,
		252,
		278,
		256,
		268,
		-1,
		-1,
		-1,
		378,
		-1,
		-1,
		323,
		294,
		318,
		360,
		344,
		337,
		325,
		290,
		290,
		284,
		-1,
		278,
		257,
		248,
		237,
		235,
		248,
		245,
		250,
		230,
		228,
		247,
		259,
		250,
		267,
		-1,
		-1,
		-1,
		353,
		342,
		343,
		289,
		312,
		349,
		323,
		309,
		314,
		289,
		282,
		276,
		291,
		274,
		255,
		244,
		236,
		225,
		241,
		249,
		244,
		226,
		235,
		241,
		265,
		255,
		261,
		-1,
		-1,
		360,
		350,
		334,
		336,
		333,
		303,
		310,
		342,
		314,
		327,
		-1,
		281,
		-1,
		270,
		265,
		249,
		244,
		241,
		238,
		232,
		241,
		243,
		233,
		228,
		235,
		270,
		270,
		245,
		265,
		268,
		-1,
		-1,
		-1,
		353,
		348,
		323,
		300,
		284,
		320,
		-1,
		297,
		298,
		-1,
		275,
		269,
		266,
		251,
		247,
		242,
		246,
		239,
		246,
		239,
		237,
		238,
		220,
		252,
		-1,
		253,
		247,
		255,
		245,
		233,
		-1,
		-1,
		-1,
		346,
		325,
		318,
		338,
		279,
		331,
		-1,
		-1,
		282,
		275,
		-1,
		262,
		244,
		251,
		249,
		243,
		247,
		244,
		233,
		246,
		239,
		225,
		227,
		240,
		244,
		248,
		235,
		231,
		228,
		242,
		-1,
		365,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		299,
		-1,
		291,
		283,
		273,
		267,
		261,
		257,
		255,
		271,
		255,
		258,
		256,
		247,
		255,
		228,
		221,
		228,
		217,
		235,
		243,
		235,
		229,
		228,
		238,
		-1,
		366,
		352,
		323,
		-1,
		-1,
		312,
		-1,
		276,
		290,
		306,
		-1,
		299,
		278,
		293,
		271,
		267,
		263,
		278,
		279,
		256,
		256,
		254,
		245,
		233,
		222,
		225,
		217,
		239,
		239,
		223,
		224,
		228,
		-1,
		372,
		359,
		317,
		313,
		302,
		322,
		273,
		261,
		293,
		-1,
		-1,
		335,
		-1,
		269,
		286,
		277,
		275,
		268,
		250,
		257,
		265,
		242,
		237,
		227,
		216,
		216,
		211,
		233,
		219,
		217,
		226,
		242,
		-1,
		-1,
		-1,
		339,
		-1,
		-1,
		288,
		275,
		269,
		-1,
		310,
		-1,
		313,
		303,
		287,
		272,
		305,
		-1,
		249,
		245,
		252,
		-1,
		262,
		-1,
		235,
		232,
		223,
		208,
		205,
		216,
		214,
		225,
		221,
		-1,
		322,
		307,
		300,
		290,
		304,
		275,
		-1,
		330,
		-1,
		-1,
		300,
		294,
		294,
		278,
		279,
		265,
		245,
		237,
		252,
		251,
		238,
		237,
		221,
		214,
		211,
		204,
		217,
		227,
		232,
		219,
		-1,
		-1,
		-1,
		327,
		313,
		317,
		277,
		296,
		-1,
		-1,
		362,
		317,
		303,
		-1,
		274,
		265,
		253,
		243,
		233,
		238,
		239,
		229,
		227,
		219,
		221,
		215,
		206,
		205,
		221,
		213,
		235,
		-1,
		-1,
		310,
		315,
		303,
		289,
		308,
		-1,
		-1,
		-1,
		309,
		325,
		293,
		272,
		254,
		-1,
		-1,
		237,
		230,
		224,
		227,
		215,
		235,
		230,
		214,
		199,
		214,
		218,
		226,
		217,
		-1,
		313,
		300,
		-1,
		-1,
		311,
		305,
		-1,
		-1,
		-1,
		-1,
		305,
		250,
		239,
		234,
		238,
		236,
		-1,
		210,
		221,
		214,
		233,
		240,
		216,
		201,
		195,
		201,
		213,
		222,
		-1,
		-1,
		325,
		-1,
		298,
		-1,
		-1,
		-1,
		-1,
		262,
		256,
		227,
		220,
		224,
		-1,
		212,
		214,
		211,
		223,
		219,
		216,
		207,
		198,
		194,
		198,
		202,
		216,
		220,
		348,
		-1,
		289,
		-1,
		-1,
		-1,
		280,
		295,
		266,
		243,
		216,
		211,
		204,
		198,
		203,
		214,
		223,
		234,
		199,
		201,
		191,
		190,
		194,
		211,
		215,
		-1,
		-1,
		287,
		283,
		306,
		288,
		292,
		293,
		-1,
		-1,
		220,
		211,
		202,
		194,
		207,
		210,
		195,
		197,
		197,
		195,
		189,
		199,
		214,
		209,
		-1,
		-1,
		-1,
		299,
		-1,
		301,
		-1,
		-1,
		290,
		291,
		238,
		220,
		216,
		214,
		203,
		197,
		185,
		190,
		200,
		194,
		191,
		185,
		189,
		212,
		201,
		240,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		279,
		270,
		265,
		272,
		274,
		265,
		253,
		250,
		-1,
		220,
		226,
		191,
		198,
		181,
		188,
		193,
		190,
		179,
		186,
		202,
		201,
		196,
		232,
		223,
		229,
		-1,
		-1,
		317,
		306,
		295,
		301,
		-1,
		272,
		267,
		258,
		248,
		251,
		-1,
		-1,
		245,
		242,
		222,
		191,
		189,
		182,
		177,
		187,
		163,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		271,
		308,
		301,
		269,
		277,
		308,
		-1,
		262,
		254,
		264,
		240,
		242,
		-1,
		-1,
		218,
		209,
		210,
		198,
		195,
		201,
		200,
		183,
		189,
		190,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		264,
		284,
		263,
		266,
		290,
		304,
		-1,
		258,
		-1,
		-1,
		224,
		243,
		227,
		217,
		214,
		257,
		212,
		207,
		188,
		186,
		181,
		172,
		197,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		253,
		264,
		257,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		214,
		-1,
		254,
		-1,
		237,
		241,
		220,
		223,
		202,
		189,
		175,
		183,
		189,
		188,
		194,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		272,
		234,
		237,
		248,
		259,
		274,
		278,
		-1,
		242,
		278,
		220,
		-1,
		204,
		-1,
		-1,
		-1,
		251,
		233,
		225,
		222,
		201,
		201,
		167,
		171,
		184,
		191,
		201,
		212,
		204,
		208,
		221,
		232,
		235,
		268,
		265,
		278,
		223,
		223,
		244,
		253,
		274,
		238,
		235,
		272,
		227,
		216,
		211,
		198,
		-1,
		-1,
		235,
		243,
		-1,
		-1,
		208,
		175,
		163,
		173,
		177,
		191,
		203,
		216,
		204,
		209,
		203,
		235,
		-1,
		266,
		265,
		254,
		251,
		228,
		219,
		214,
		241,
		-1,
		-1,
		236,
		263,
		247,
		251,
		258,
		283,
		-1,
		183,
		-1,
		-1,
		215,
		-1,
		-1,
		200,
		180,
		169,
		160,
		165,
		185,
		196,
		218,
		200,
		217,
		208,
		218,
		222,
		250,
		247,
		235,
		233,
		252,
		222,
		210,
		-1,
		218,
		221,
		227,
		234,
		251,
		272,
		-1,
		-1,
		199,
		179,
		-1,
		-1,
		198,
		196,
		185,
		-1,
		175,
		157,
		162,
		192,
		194,
		196,
		203,
		197,
		204,
		212,
		223,
		215,
		259,
		273,
		262,
		253,
		253,
		263,
		215,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		204,
		-1,
		189,
		185,
		-1,
		-1,
		193,
		186,
		174,
		162,
		152,
		162,
		179,
		179,
		182,
		187,
		195,
		206,
		202,
		206,
		209,
		-1,
		288,
		-1,
		246,
		207,
		213,
		228,
		236,
		-1,
		-1,
		-1,
		206,
		192,
		185,
		173,
		171,
		-1,
		227,
		211,
		192,
		-1,
		162,
		175,
		215,
		183,
		188,
		183,
		198,
		209,
		200,
		208,
		202,
		205,
		-1,
		-1,
		206,
		189,
		-1,
		-1,
		163,
		165,
		-1,
		197,
		186,
		171,
		163,
		-1,
		-1,
		199,
		195,
		-1,
		-1,
		149,
		187,
		186,
		194,
		189,
		194,
		206,
		202,
		198,
		208,
		199,
		-1,
		-1,
		184,
		176,
		170,
		-1,
		148,
		-1,
		199,
		-1,
		166,
		175,
		163,
		-1,
		-1,
		-1,
		180,
		143,
		159,
		182,
		208,
		206,
		197,
		190,
		197,
		200,
		193,
		199,
		-1,
		-1,
		-1,
		166,
		140,
		206,
		197,
		180,
		160,
		152,
		174,
		-1,
		161,
		-1,
		136,
		139,
		164,
		203,
		205,
		191,
		187,
		200,
		194,
		191,
		189,
		172,
		-1,
		142,
		175,
		139,
		166,
		132,
		146,
		175,
		-1,
		158,
		140,
		-1,
		168,
		158,
		206,
		181,
		190,
		183,
		177,
		178,
		186,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		127,
		142,
		-1,
		163,
		145,
		131,
		148,
		148,
		139,
		147,
		196,
		192,
		195,
		193,
		171,
		-1,
		113,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		122,
		135,
		131,
		132,
		128,
		128,
		130,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		170,
		202,
		-1,
		108,
		-1,
		174,
		-1,
		-1,
		119,
		106,
		116,
		127,
		143,
		141,
		127,
		123,
		140,
		175,
		161,
		159,
		164,
		169,
		-1,
		97,
		96,
		-1,
		90,
		100,
		116,
		-1,
		97,
		-1,
		189,
		150,
		-1,
		124,
		118,
		-1,
		170,
		166,
		-1,
		-1,
		84,
		79,
		-1,
		-1,
		-1,
		96,
		105,
		184,
		168,
		-1,
		108,
		115,
		-1,
		-1,
		-1,
		69,
		70,
		-1,
		89,
		92,
		-1,
		106,
		112,
		129,
		103,
		109,
		-1,
		-1,
		-1,
		78,
		59,
		53,
		79,
		74,
		97,
		137,
		123,
		112,
		90,
		100,
		129,
		-1,
		-1,
		-1,
		40,
		47,
		59,
		-1,
		-1,
		137,
		120,
		101,
		99,
		-1,
		-1,
		-1,
		41,
		35,
		-1,
		-1,
		68,
		-1,
		-1,
		96,
		75,
		-1,
		-1,
		-1,
		-1,
		-1,
		50,
		25,
		-1,
		-1,
		-1,
		69,
		66,
		80,
		-1,
		-1,
		-1,
		-1,
		29,
		29,
		46,
		0,
		-1,
		-1,
		-1,
		62,
		69,
		-1,
		-1,
		32,
		30,
		-1,
		-1,
		-1,
		31,
		43,
		-1,
		80,
		-1,
		-1,
		-1,
		47,
		-1,
		-1,
		113,
		-1,
		-1,
		-1,
		61,
		-1,
		115,
		90,
		97,
		-1,
		-1,
		-1,
		-1,
		74,
		66,
		128,
		-1,
		100,
		102,
		-1,
		150,
		-1,
		-1,
		89,
		84,
		-1,
		-1,
		105,
		112,
		134,
		137,
		123,
		-1,
		124
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		293,
		282,
		293,
		301,
		274,
		281,
		-1,
		300,
		304,
		270,
		264,
		303,
		272,
		278,
		289,
		-1,
		-1,
		-1,
		293,
		292,
		260,
		258,
		267,
		272,
		279,
		-1,
		278,
		-1,
		314,
		293,
		304,
		309,
		253,
		250,
		270,
		289,
		271,
		263,
		329,
		283,
		254,
		248,
		266,
		256,
		265,
		257,
		-1,
		254,
		244,
		266,
		245,
		256,
		248,
		-1,
		-1,
		248,
		249,
		255,
		241,
		247,
		243,
		-1,
		253,
		237,
		-1,
		-1,
		238,
		239,
		223,
		226,
		234,
		232,
		245,
		237,
		232,
		-1,
		-1,
		229,
		225,
		232,
		219,
		215,
		232,
		245,
		227,
		241,
		240,
		-1,
		233,
		251,
		258,
		226,
		224,
		208,
		206,
		224,
		226,
		232,
		232,
		-1,
		242,
		243,
		238,
		246,
		248,
		224,
		211,
		211,
		221,
		214,
		233,
		221,
		267,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		242,
		225,
		242,
		234,
		224,
		239,
		232,
		214,
		211,
		209,
		206,
		222,
		220,
		230,
		-1,
		-1,
		335,
		304,
		333,
		291,
		272,
		-1,
		238,
		218,
		224,
		228,
		222,
		215,
		229,
		225,
		-1,
		200,
		199,
		227,
		213,
		224,
		295,
		-1,
		-1,
		293,
		285,
		268,
		271,
		248,
		244,
		233,
		232,
		224,
		210,
		206,
		212,
		215,
		215,
		221,
		194,
		204,
		208,
		206,
		231,
		-1,
		-1,
		266,
		-1,
		-1,
		292,
		275,
		-1,
		258,
		265,
		254,
		260,
		246,
		267,
		243,
		234,
		226,
		220,
		208,
		210,
		207,
		220,
		208,
		191,
		216,
		220,
		201,
		222,
		217,
		-1,
		265,
		249,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		251,
		254,
		260,
		284,
		283,
		-1,
		255,
		243,
		244,
		229,
		226,
		213,
		201,
		214,
		199,
		206,
		205,
		195,
		193,
		223,
		198,
		220,
		217,
		236,
		241,
		235,
		244,
		-1,
		300,
		296,
		292,
		299,
		248,
		-1,
		-1,
		288,
		-1,
		291,
		292,
		267,
		240,
		243,
		230,
		221,
		208,
		197,
		208,
		197,
		194,
		202,
		187,
		202,
		193,
		192,
		210,
		220,
		228,
		232,
		238,
		-1,
		350,
		-1,
		292,
		276,
		278,
		250,
		271,
		-1,
		308,
		292,
		284,
		269,
		269,
		-1,
		239,
		236,
		226,
		204,
		189,
		206,
		198,
		196,
		200,
		182,
		196,
		187,
		205,
		212,
		210,
		214,
		234,
		246,
		310,
		300,
		-1,
		282,
		287,
		246,
		254,
		273,
		311,
		275,
		-1,
		270,
		-1,
		241,
		254,
		-1,
		210,
		206,
		188,
		189,
		184,
		199,
		193,
		178,
		175,
		193,
		196,
		203,
		207,
		223,
		-1,
		-1,
		295,
		299,
		288,
		239,
		258,
		282,
		319,
		268,
		257,
		256,
		-1,
		247,
		224,
		221,
		209,
		196,
		181,
		182,
		190,
		203,
		182,
		177,
		174,
		194,
		220,
		198,
		210,
		-1,
		-1,
		-1,
		320,
		-1,
		-1,
		265,
		236,
		260,
		302,
		286,
		279,
		267,
		232,
		232,
		226,
		-1,
		220,
		199,
		190,
		179,
		177,
		190,
		187,
		192,
		172,
		170,
		189,
		201,
		192,
		209,
		-1,
		-1,
		-1,
		295,
		284,
		285,
		231,
		254,
		291,
		265,
		251,
		256,
		231,
		224,
		218,
		233,
		216,
		197,
		186,
		178,
		167,
		183,
		191,
		186,
		168,
		177,
		183,
		207,
		197,
		203,
		-1,
		-1,
		302,
		292,
		276,
		278,
		275,
		245,
		252,
		284,
		256,
		269,
		-1,
		223,
		-1,
		212,
		207,
		191,
		186,
		183,
		180,
		174,
		183,
		185,
		175,
		170,
		177,
		212,
		212,
		187,
		207,
		210,
		-1,
		-1,
		-1,
		295,
		290,
		265,
		242,
		226,
		262,
		-1,
		239,
		240,
		-1,
		217,
		211,
		208,
		193,
		189,
		184,
		188,
		181,
		188,
		181,
		179,
		180,
		162,
		194,
		-1,
		195,
		189,
		197,
		187,
		175,
		-1,
		-1,
		-1,
		288,
		267,
		260,
		280,
		221,
		273,
		-1,
		-1,
		224,
		217,
		-1,
		204,
		186,
		193,
		191,
		185,
		189,
		186,
		175,
		188,
		181,
		167,
		169,
		182,
		186,
		190,
		177,
		173,
		170,
		184,
		-1,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		221,
		241,
		-1,
		233,
		225,
		215,
		209,
		203,
		199,
		197,
		213,
		197,
		200,
		198,
		189,
		197,
		170,
		163,
		170,
		159,
		177,
		185,
		177,
		171,
		170,
		180,
		-1,
		308,
		294,
		265,
		-1,
		-1,
		254,
		-1,
		218,
		232,
		248,
		-1,
		241,
		220,
		235,
		213,
		209,
		205,
		220,
		221,
		198,
		198,
		196,
		187,
		175,
		164,
		167,
		159,
		181,
		181,
		165,
		166,
		170,
		-1,
		314,
		301,
		259,
		255,
		244,
		264,
		215,
		203,
		235,
		-1,
		-1,
		277,
		-1,
		211,
		228,
		219,
		217,
		210,
		192,
		199,
		207,
		184,
		179,
		169,
		158,
		158,
		153,
		175,
		161,
		159,
		168,
		184,
		-1,
		-1,
		-1,
		281,
		-1,
		-1,
		230,
		217,
		211,
		-1,
		252,
		-1,
		255,
		245,
		229,
		214,
		247,
		-1,
		191,
		187,
		194,
		-1,
		204,
		-1,
		177,
		174,
		165,
		150,
		147,
		158,
		156,
		167,
		163,
		-1,
		264,
		249,
		242,
		232,
		246,
		217,
		-1,
		272,
		-1,
		-1,
		242,
		236,
		236,
		220,
		221,
		207,
		187,
		179,
		194,
		193,
		180,
		179,
		163,
		156,
		153,
		146,
		159,
		169,
		174,
		161,
		-1,
		-1,
		-1,
		269,
		255,
		259,
		219,
		238,
		-1,
		-1,
		304,
		259,
		245,
		-1,
		216,
		207,
		195,
		185,
		175,
		180,
		181,
		171,
		169,
		161,
		163,
		157,
		148,
		147,
		163,
		155,
		177,
		-1,
		-1,
		252,
		257,
		245,
		231,
		250,
		-1,
		-1,
		-1,
		251,
		267,
		235,
		214,
		196,
		-1,
		-1,
		179,
		172,
		166,
		169,
		157,
		177,
		172,
		156,
		141,
		156,
		160,
		168,
		159,
		-1,
		255,
		242,
		-1,
		-1,
		253,
		247,
		-1,
		-1,
		-1,
		-1,
		247,
		192,
		181,
		176,
		180,
		178,
		-1,
		152,
		163,
		156,
		175,
		182,
		158,
		143,
		137,
		143,
		155,
		164,
		-1,
		-1,
		267,
		-1,
		240,
		-1,
		-1,
		-1,
		-1,
		204,
		198,
		169,
		162,
		166,
		-1,
		154,
		156,
		153,
		165,
		161,
		158,
		149,
		140,
		136,
		140,
		144,
		158,
		162,
		290,
		-1,
		231,
		-1,
		-1,
		-1,
		222,
		237,
		208,
		185,
		158,
		153,
		146,
		140,
		145,
		156,
		165,
		176,
		141,
		143,
		133,
		132,
		136,
		153,
		157,
		-1,
		-1,
		229,
		225,
		248,
		230,
		234,
		235,
		-1,
		-1,
		162,
		153,
		144,
		136,
		149,
		152,
		137,
		139,
		139,
		137,
		131,
		141,
		156,
		151,
		-1,
		-1,
		-1,
		241,
		-1,
		243,
		-1,
		-1,
		232,
		233,
		180,
		162,
		158,
		156,
		145,
		139,
		127,
		132,
		142,
		136,
		133,
		127,
		131,
		154,
		143,
		182,
		-1,
		-1,
		300,
		-1,
		-1,
		-1,
		221,
		212,
		207,
		214,
		216,
		207,
		195,
		192,
		-1,
		162,
		168,
		133,
		140,
		123,
		130,
		135,
		132,
		121,
		128,
		144,
		143,
		138,
		174,
		165,
		171,
		-1,
		-1,
		293,
		282,
		271,
		277,
		-1,
		214,
		209,
		200,
		190,
		193,
		-1,
		-1,
		187,
		184,
		164,
		133,
		131,
		124,
		119,
		129,
		105,
		117,
		121,
		125,
		131,
		136,
		141,
		147,
		162,
		177,
		-1,
		247,
		284,
		277,
		245,
		253,
		284,
		-1,
		204,
		196,
		206,
		182,
		184,
		-1,
		-1,
		160,
		151,
		152,
		140,
		137,
		143,
		142,
		125,
		131,
		132,
		124,
		123,
		141,
		145,
		154,
		161,
		151,
		164,
		168,
		-1,
		240,
		260,
		239,
		242,
		266,
		280,
		-1,
		201,
		-1,
		-1,
		166,
		185,
		169,
		159,
		156,
		199,
		154,
		149,
		130,
		128,
		123,
		114,
		139,
		132,
		132,
		135,
		150,
		155,
		147,
		161,
		161,
		162,
		-1,
		229,
		240,
		233,
		-1,
		-1,
		-1,
		-1,
		202,
		-1,
		-1,
		156,
		-1,
		196,
		-1,
		179,
		183,
		162,
		165,
		144,
		131,
		117,
		125,
		131,
		130,
		136,
		136,
		137,
		146,
		157,
		169,
		168,
		169,
		254,
		210,
		213,
		224,
		235,
		250,
		254,
		-1,
		213,
		252,
		162,
		-1,
		146,
		-1,
		-1,
		-1,
		193,
		175,
		167,
		164,
		143,
		143,
		109,
		113,
		126,
		133,
		143,
		154,
		146,
		150,
		163,
		174,
		177,
		250,
		241,
		254,
		199,
		199,
		220,
		229,
		250,
		214,
		211,
		246,
		169,
		158,
		153,
		140,
		-1,
		-1,
		177,
		185,
		-1,
		-1,
		150,
		117,
		105,
		115,
		119,
		133,
		145,
		158,
		146,
		151,
		145,
		177,
		-1,
		243,
		242,
		231,
		228,
		204,
		195,
		190,
		217,
		-1,
		-1,
		212,
		239,
		223,
		202,
		200,
		225,
		-1,
		129,
		-1,
		-1,
		157,
		-1,
		-1,
		142,
		122,
		111,
		102,
		107,
		127,
		138,
		160,
		142,
		159,
		150,
		160,
		164,
		227,
		224,
		212,
		210,
		233,
		198,
		186,
		-1,
		194,
		197,
		203,
		210,
		203,
		214,
		-1,
		-1,
		145,
		125,
		-1,
		-1,
		140,
		138,
		127,
		-1,
		117,
		99,
		104,
		134,
		136,
		138,
		145,
		139,
		146,
		154,
		165,
		157,
		236,
		250,
		239,
		235,
		234,
		242,
		191,
		184,
		191,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		150,
		-1,
		135,
		131,
		-1,
		-1,
		135,
		128,
		116,
		104,
		94,
		104,
		121,
		121,
		124,
		129,
		137,
		148,
		144,
		148,
		151,
		-1,
		270,
		-1,
		222,
		183,
		189,
		204,
		212,
		-1,
		-1,
		-1,
		152,
		138,
		131,
		119,
		117,
		-1,
		169,
		153,
		134,
		-1,
		104,
		117,
		157,
		125,
		130,
		125,
		140,
		151,
		142,
		150,
		144,
		147,
		-1,
		-1,
		182,
		165,
		-1,
		-1,
		139,
		141,
		-1,
		143,
		132,
		117,
		109,
		-1,
		-1,
		141,
		137,
		-1,
		-1,
		91,
		129,
		128,
		136,
		131,
		136,
		148,
		144,
		140,
		150,
		141,
		-1,
		-1,
		160,
		152,
		146,
		-1,
		124,
		-1,
		145,
		-1,
		112,
		118,
		106,
		-1,
		-1,
		-1,
		122,
		85,
		101,
		124,
		150,
		148,
		139,
		132,
		139,
		142,
		135,
		141,
		-1,
		-1,
		-1,
		142,
		116,
		152,
		143,
		126,
		106,
		98,
		117,
		-1,
		103,
		-1,
		78,
		81,
		106,
		145,
		147,
		133,
		129,
		142,
		136,
		133,
		131,
		148,
		-1,
		118,
		151,
		115,
		112,
		88,
		92,
		117,
		-1,
		100,
		82,
		-1,
		110,
		100,
		148,
		123,
		132,
		125,
		119,
		120,
		128,
		-1,
		-1,
		-1,
		120,
		119,
		111,
		105,
		105,
		93,
		84,
		-1,
		105,
		87,
		73,
		90,
		90,
		81,
		89,
		138,
		134,
		137,
		135,
		113,
		-1,
		106,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		114,
		98,
		85,
		73,
		74,
		70,
		70,
		72,
		85,
		93,
		91,
		88,
		100,
		96,
		116,
		112,
		144,
		-1,
		101,
		-1,
		150,
		-1,
		-1,
		95,
		82,
		92,
		96,
		85,
		83,
		69,
		65,
		82,
		117,
		103,
		101,
		106,
		111,
		-1,
		90,
		89,
		-1,
		83,
		93,
		92,
		-1,
		73,
		-1,
		131,
		92,
		-1,
		66,
		60,
		-1,
		112,
		108,
		-1,
		-1,
		77,
		72,
		-1,
		-1,
		-1,
		72,
		76,
		126,
		110,
		-1,
		50,
		57,
		-1,
		-1,
		-1,
		62,
		63,
		-1,
		58,
		68,
		-1,
		72,
		63,
		71,
		45,
		51,
		-1,
		-1,
		-1,
		71,
		52,
		46,
		48,
		43,
		73,
		84,
		70,
		54,
		32,
		42,
		71,
		-1,
		-1,
		-1,
		43,
		35,
		28,
		-1,
		-1,
		79,
		62,
		43,
		41,
		-1,
		-1,
		-1,
		65,
		46,
		-1,
		-1,
		19,
		-1,
		-1,
		38,
		17,
		-1,
		-1,
		-1,
		-1,
		-1,
		82,
		54,
		-1,
		-1,
		-1,
		14,
		8,
		22,
		-1,
		-1,
		-1,
		-1,
		76,
		77,
		100,
		60,
		-1,
		-1,
		-1,
		0,
		11,
		-1,
		-1,
		79,
		77,
		-1,
		-1,
		-1,
		32,
		16,
		-1,
		22,
		-1,
		-1,
		-1,
		23,
		-1,
		-1,
		55,
		-1,
		-1,
		-1,
		37,
		-1,
		57,
		32,
		39,
		-1,
		-1,
		-1,
		-1,
		50,
		42,
		70,
		-1,
		42,
		44,
		-1,
		92,
		-1,
		-1,
		65,
		56,
		-1,
		-1,
		47,
		54,
		76,
		79,
		95,
		-1,
		66
	],
	[
		-1,
		287,
		276,
		287,
		295,
		268,
		275,
		-1,
		294,
		298,
		264,
		258,
		297,
		266,
		272,
		283,
		-1,
		-1,
		-1,
		287,
		286,
		254,
		252,
		261,
		266,
		273,
		-1,
		272,
		-1,
		308,
		287,
		298,
		303,
		247,
		244,
		264,
		283,
		265,
		257,
		323,
		277,
		248,
		242,
		260,
		250,
		259,
		251,
		-1,
		248,
		238,
		260,
		239,
		250,
		242,
		-1,
		-1,
		242,
		243,
		249,
		235,
		241,
		237,
		-1,
		247,
		231,
		-1,
		-1,
		232,
		233,
		217,
		220,
		228,
		226,
		239,
		231,
		226,
		-1,
		-1,
		223,
		219,
		226,
		213,
		209,
		226,
		239,
		221,
		235,
		234,
		-1,
		227,
		245,
		252,
		220,
		218,
		202,
		200,
		218,
		220,
		226,
		226,
		-1,
		236,
		237,
		232,
		240,
		242,
		218,
		205,
		205,
		215,
		208,
		227,
		215,
		261,
		-1,
		-1,
		-1,
		-1,
		-1,
		270,
		236,
		219,
		236,
		228,
		218,
		233,
		226,
		208,
		205,
		203,
		200,
		216,
		214,
		224,
		-1,
		-1,
		329,
		298,
		327,
		285,
		266,
		-1,
		232,
		212,
		218,
		222,
		216,
		209,
		223,
		219,
		-1,
		194,
		193,
		221,
		207,
		218,
		289,
		-1,
		-1,
		287,
		279,
		262,
		265,
		242,
		238,
		227,
		226,
		218,
		204,
		200,
		206,
		209,
		209,
		215,
		188,
		198,
		202,
		200,
		225,
		-1,
		-1,
		260,
		-1,
		-1,
		286,
		269,
		-1,
		252,
		259,
		248,
		254,
		240,
		261,
		237,
		228,
		220,
		214,
		202,
		204,
		201,
		214,
		202,
		185,
		210,
		214,
		195,
		216,
		211,
		-1,
		259,
		243,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		245,
		248,
		254,
		278,
		277,
		-1,
		249,
		237,
		238,
		223,
		220,
		207,
		195,
		208,
		193,
		200,
		199,
		189,
		187,
		217,
		192,
		214,
		211,
		230,
		235,
		229,
		238,
		-1,
		294,
		290,
		286,
		293,
		242,
		-1,
		-1,
		282,
		-1,
		285,
		286,
		261,
		234,
		237,
		224,
		215,
		202,
		191,
		202,
		191,
		188,
		196,
		181,
		196,
		187,
		186,
		204,
		214,
		222,
		226,
		232,
		-1,
		344,
		-1,
		286,
		270,
		272,
		244,
		265,
		-1,
		302,
		286,
		278,
		263,
		263,
		-1,
		233,
		230,
		220,
		198,
		183,
		200,
		192,
		190,
		194,
		176,
		190,
		181,
		199,
		206,
		204,
		208,
		228,
		240,
		304,
		294,
		-1,
		276,
		281,
		240,
		248,
		267,
		305,
		269,
		-1,
		264,
		-1,
		235,
		248,
		-1,
		204,
		200,
		182,
		183,
		178,
		193,
		187,
		172,
		169,
		187,
		190,
		197,
		201,
		217,
		-1,
		-1,
		289,
		293,
		282,
		233,
		252,
		276,
		313,
		262,
		251,
		250,
		-1,
		241,
		218,
		215,
		203,
		190,
		175,
		176,
		184,
		197,
		176,
		171,
		168,
		188,
		214,
		192,
		204,
		-1,
		-1,
		-1,
		314,
		-1,
		-1,
		259,
		230,
		254,
		296,
		280,
		273,
		261,
		226,
		226,
		220,
		-1,
		214,
		193,
		184,
		173,
		171,
		184,
		181,
		186,
		166,
		164,
		183,
		195,
		186,
		203,
		-1,
		-1,
		-1,
		289,
		278,
		279,
		225,
		248,
		285,
		259,
		245,
		250,
		225,
		218,
		212,
		227,
		210,
		191,
		180,
		172,
		161,
		177,
		185,
		180,
		162,
		171,
		177,
		201,
		191,
		197,
		-1,
		-1,
		296,
		286,
		270,
		272,
		269,
		239,
		246,
		278,
		250,
		263,
		-1,
		217,
		-1,
		206,
		201,
		185,
		180,
		177,
		174,
		168,
		177,
		179,
		169,
		164,
		171,
		206,
		206,
		181,
		201,
		204,
		-1,
		-1,
		-1,
		289,
		284,
		259,
		236,
		220,
		256,
		-1,
		233,
		234,
		-1,
		211,
		205,
		202,
		187,
		183,
		178,
		182,
		175,
		182,
		175,
		173,
		174,
		156,
		188,
		-1,
		189,
		183,
		191,
		181,
		169,
		-1,
		-1,
		-1,
		282,
		261,
		254,
		274,
		215,
		267,
		-1,
		-1,
		218,
		211,
		-1,
		198,
		180,
		187,
		185,
		179,
		183,
		180,
		169,
		182,
		175,
		161,
		163,
		176,
		180,
		184,
		171,
		167,
		164,
		178,
		-1,
		301,
		-1,
		-1,
		-1,
		-1,
		-1,
		215,
		235,
		-1,
		227,
		219,
		209,
		203,
		197,
		193,
		191,
		207,
		191,
		194,
		192,
		183,
		191,
		164,
		157,
		164,
		153,
		171,
		179,
		171,
		165,
		164,
		174,
		-1,
		302,
		288,
		259,
		-1,
		-1,
		248,
		-1,
		212,
		226,
		242,
		-1,
		235,
		214,
		229,
		207,
		203,
		199,
		214,
		215,
		192,
		192,
		190,
		181,
		169,
		158,
		161,
		153,
		175,
		175,
		159,
		160,
		164,
		-1,
		308,
		295,
		253,
		249,
		238,
		258,
		209,
		197,
		229,
		-1,
		-1,
		271,
		-1,
		205,
		222,
		213,
		211,
		204,
		186,
		193,
		201,
		178,
		173,
		163,
		152,
		152,
		147,
		169,
		155,
		153,
		162,
		178,
		-1,
		-1,
		-1,
		275,
		-1,
		-1,
		224,
		211,
		205,
		-1,
		246,
		-1,
		249,
		239,
		223,
		208,
		241,
		-1,
		185,
		181,
		188,
		-1,
		198,
		-1,
		171,
		168,
		159,
		144,
		141,
		152,
		150,
		161,
		157,
		-1,
		258,
		243,
		236,
		226,
		240,
		211,
		-1,
		266,
		-1,
		-1,
		236,
		230,
		230,
		214,
		215,
		201,
		181,
		173,
		188,
		187,
		174,
		173,
		157,
		150,
		147,
		140,
		153,
		163,
		168,
		155,
		-1,
		-1,
		-1,
		263,
		249,
		253,
		213,
		232,
		-1,
		-1,
		298,
		253,
		239,
		-1,
		210,
		201,
		189,
		179,
		169,
		174,
		175,
		165,
		163,
		155,
		157,
		151,
		142,
		141,
		157,
		149,
		171,
		-1,
		-1,
		246,
		251,
		239,
		225,
		244,
		-1,
		-1,
		-1,
		245,
		261,
		229,
		208,
		190,
		-1,
		-1,
		173,
		166,
		160,
		163,
		151,
		171,
		166,
		150,
		135,
		150,
		154,
		162,
		153,
		-1,
		249,
		236,
		-1,
		-1,
		247,
		241,
		-1,
		-1,
		-1,
		-1,
		241,
		186,
		175,
		170,
		174,
		172,
		-1,
		146,
		157,
		150,
		169,
		176,
		152,
		137,
		131,
		137,
		149,
		158,
		-1,
		-1,
		261,
		-1,
		234,
		-1,
		-1,
		-1,
		-1,
		198,
		192,
		163,
		156,
		160,
		-1,
		148,
		150,
		147,
		159,
		155,
		152,
		143,
		134,
		130,
		134,
		138,
		152,
		156,
		284,
		-1,
		225,
		-1,
		-1,
		-1,
		216,
		231,
		202,
		179,
		152,
		147,
		140,
		134,
		139,
		150,
		159,
		170,
		135,
		137,
		127,
		126,
		130,
		147,
		151,
		-1,
		-1,
		223,
		219,
		242,
		224,
		228,
		229,
		-1,
		-1,
		156,
		147,
		138,
		130,
		143,
		146,
		131,
		133,
		133,
		131,
		125,
		135,
		150,
		145,
		-1,
		-1,
		-1,
		235,
		-1,
		237,
		-1,
		-1,
		226,
		227,
		174,
		156,
		152,
		150,
		139,
		133,
		121,
		126,
		136,
		130,
		127,
		121,
		125,
		148,
		137,
		176,
		-1,
		-1,
		297,
		-1,
		-1,
		-1,
		215,
		206,
		201,
		208,
		210,
		201,
		189,
		186,
		-1,
		156,
		162,
		127,
		134,
		117,
		124,
		129,
		126,
		115,
		122,
		138,
		137,
		132,
		168,
		159,
		165,
		-1,
		-1,
		290,
		279,
		268,
		274,
		-1,
		208,
		203,
		194,
		184,
		187,
		-1,
		-1,
		181,
		178,
		158,
		127,
		125,
		118,
		113,
		123,
		99,
		111,
		115,
		119,
		125,
		130,
		135,
		141,
		156,
		171,
		-1,
		244,
		281,
		274,
		242,
		250,
		281,
		-1,
		198,
		190,
		200,
		176,
		178,
		-1,
		-1,
		154,
		145,
		146,
		134,
		131,
		137,
		136,
		119,
		125,
		126,
		118,
		117,
		135,
		139,
		148,
		155,
		145,
		158,
		162,
		-1,
		237,
		257,
		236,
		239,
		263,
		277,
		-1,
		195,
		-1,
		-1,
		160,
		179,
		163,
		153,
		150,
		193,
		148,
		143,
		124,
		122,
		117,
		108,
		133,
		126,
		126,
		129,
		144,
		149,
		141,
		155,
		155,
		156,
		-1,
		226,
		237,
		230,
		-1,
		-1,
		-1,
		-1,
		196,
		-1,
		-1,
		150,
		-1,
		190,
		-1,
		173,
		177,
		156,
		159,
		138,
		125,
		111,
		119,
		125,
		124,
		130,
		130,
		131,
		140,
		151,
		163,
		162,
		163,
		251,
		207,
		210,
		221,
		232,
		247,
		251,
		-1,
		207,
		246,
		156,
		-1,
		140,
		-1,
		-1,
		-1,
		187,
		169,
		161,
		158,
		137,
		137,
		103,
		107,
		120,
		127,
		137,
		148,
		140,
		144,
		157,
		168,
		171,
		247,
		238,
		251,
		196,
		196,
		217,
		226,
		247,
		211,
		208,
		240,
		163,
		152,
		147,
		134,
		-1,
		-1,
		171,
		179,
		-1,
		-1,
		144,
		111,
		99,
		109,
		113,
		127,
		139,
		152,
		140,
		145,
		139,
		171,
		-1,
		240,
		239,
		228,
		225,
		201,
		192,
		187,
		214,
		-1,
		-1,
		209,
		236,
		219,
		196,
		194,
		219,
		-1,
		123,
		-1,
		-1,
		151,
		-1,
		-1,
		136,
		116,
		105,
		96,
		101,
		121,
		132,
		154,
		136,
		153,
		144,
		154,
		158,
		224,
		221,
		209,
		207,
		230,
		195,
		183,
		-1,
		191,
		194,
		200,
		207,
		197,
		208,
		-1,
		-1,
		139,
		119,
		-1,
		-1,
		134,
		132,
		121,
		-1,
		111,
		93,
		98,
		128,
		130,
		132,
		139,
		133,
		140,
		148,
		159,
		151,
		233,
		247,
		236,
		232,
		231,
		239,
		188,
		181,
		188,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		144,
		-1,
		129,
		125,
		-1,
		-1,
		129,
		122,
		110,
		98,
		88,
		98,
		115,
		115,
		118,
		123,
		131,
		142,
		138,
		142,
		145,
		-1,
		267,
		-1,
		219,
		180,
		186,
		201,
		209,
		-1,
		-1,
		-1,
		146,
		132,
		125,
		113,
		111,
		-1,
		163,
		147,
		128,
		-1,
		98,
		111,
		151,
		119,
		124,
		119,
		134,
		145,
		136,
		144,
		138,
		141,
		-1,
		-1,
		179,
		162,
		-1,
		-1,
		136,
		138,
		-1,
		137,
		126,
		111,
		103,
		-1,
		-1,
		135,
		131,
		-1,
		-1,
		85,
		123,
		122,
		130,
		125,
		130,
		142,
		138,
		134,
		144,
		135,
		-1,
		-1,
		157,
		149,
		143,
		-1,
		121,
		-1,
		139,
		-1,
		106,
		112,
		100,
		-1,
		-1,
		-1,
		116,
		79,
		95,
		118,
		144,
		142,
		133,
		126,
		133,
		136,
		129,
		135,
		-1,
		-1,
		-1,
		139,
		113,
		146,
		137,
		120,
		100,
		92,
		111,
		-1,
		97,
		-1,
		72,
		75,
		100,
		139,
		141,
		127,
		123,
		136,
		130,
		127,
		125,
		145,
		-1,
		115,
		148,
		112,
		106,
		82,
		86,
		111,
		-1,
		94,
		76,
		-1,
		104,
		94,
		142,
		117,
		126,
		119,
		113,
		114,
		122,
		-1,
		-1,
		-1,
		117,
		116,
		108,
		102,
		102,
		87,
		78,
		-1,
		99,
		81,
		67,
		84,
		84,
		75,
		83,
		132,
		128,
		131,
		129,
		107,
		-1,
		111,
		-1,
		-1,
		140,
		-1,
		-1,
		-1,
		111,
		103,
		79,
		67,
		68,
		64,
		64,
		66,
		79,
		87,
		85,
		82,
		94,
		90,
		110,
		106,
		138,
		-1,
		106,
		-1,
		147,
		-1,
		-1,
		100,
		87,
		97,
		90,
		79,
		77,
		63,
		59,
		76,
		111,
		97,
		95,
		100,
		105,
		-1,
		95,
		94,
		-1,
		88,
		98,
		97,
		-1,
		78,
		-1,
		125,
		86,
		-1,
		60,
		54,
		-1,
		106,
		102,
		-1,
		-1,
		82,
		77,
		-1,
		-1,
		-1,
		77,
		70,
		120,
		104,
		-1,
		44,
		51,
		-1,
		-1,
		-1,
		67,
		68,
		-1,
		63,
		73,
		-1,
		66,
		57,
		65,
		39,
		45,
		-1,
		-1,
		-1,
		76,
		57,
		51,
		53,
		48,
		78,
		78,
		64,
		44,
		26,
		36,
		65,
		-1,
		-1,
		-1,
		48,
		40,
		33,
		-1,
		-1,
		73,
		56,
		37,
		35,
		-1,
		-1,
		-1,
		70,
		51,
		-1,
		-1,
		25,
		-1,
		-1,
		27,
		11,
		-1,
		-1,
		-1,
		-1,
		-1,
		87,
		59,
		-1,
		-1,
		-1,
		21,
		16,
		11,
		-1,
		-1,
		-1,
		-1,
		81,
		82,
		105,
		68,
		-1,
		-1,
		-1,
		12,
		0,
		-1,
		-1,
		84,
		82,
		-1,
		-1,
		-1,
		40,
		24,
		-1,
		12,
		-1,
		-1,
		-1,
		31,
		-1,
		-1,
		45,
		-1,
		-1,
		-1,
		45,
		-1,
		47,
		22,
		29,
		-1,
		-1,
		-1,
		-1,
		58,
		50,
		60,
		-1,
		32,
		34,
		-1,
		82,
		-1,
		-1,
		73,
		64,
		-1,
		-1,
		37,
		44,
		66,
		69,
		103,
		-1,
		56
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		382,
		371,
		382,
		390,
		363,
		370,
		-1,
		389,
		393,
		359,
		353,
		392,
		361,
		367,
		378,
		-1,
		-1,
		-1,
		382,
		381,
		349,
		347,
		356,
		361,
		368,
		-1,
		367,
		-1,
		403,
		382,
		393,
		398,
		342,
		339,
		359,
		378,
		360,
		352,
		418,
		372,
		343,
		337,
		355,
		345,
		354,
		346,
		-1,
		343,
		333,
		355,
		334,
		345,
		337,
		-1,
		-1,
		337,
		338,
		344,
		330,
		336,
		332,
		-1,
		342,
		326,
		-1,
		-1,
		327,
		328,
		312,
		315,
		323,
		321,
		334,
		326,
		321,
		-1,
		-1,
		318,
		314,
		321,
		308,
		304,
		321,
		334,
		316,
		330,
		329,
		-1,
		322,
		340,
		347,
		315,
		313,
		297,
		295,
		313,
		315,
		321,
		321,
		-1,
		331,
		332,
		327,
		335,
		337,
		313,
		300,
		300,
		310,
		303,
		322,
		310,
		356,
		-1,
		-1,
		-1,
		-1,
		-1,
		365,
		331,
		314,
		331,
		323,
		313,
		328,
		321,
		303,
		300,
		298,
		295,
		311,
		309,
		319,
		-1,
		-1,
		424,
		393,
		422,
		380,
		361,
		-1,
		327,
		307,
		313,
		317,
		311,
		304,
		318,
		314,
		-1,
		289,
		288,
		316,
		302,
		313,
		384,
		-1,
		-1,
		382,
		374,
		357,
		360,
		337,
		333,
		322,
		321,
		313,
		299,
		295,
		301,
		304,
		304,
		310,
		283,
		293,
		297,
		295,
		320,
		-1,
		-1,
		355,
		-1,
		-1,
		381,
		364,
		-1,
		347,
		354,
		343,
		349,
		335,
		356,
		332,
		323,
		315,
		309,
		297,
		299,
		296,
		309,
		297,
		280,
		305,
		309,
		290,
		311,
		306,
		-1,
		354,
		338,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		359,
		340,
		343,
		349,
		373,
		372,
		-1,
		344,
		332,
		333,
		318,
		315,
		302,
		290,
		303,
		288,
		295,
		294,
		284,
		282,
		312,
		287,
		309,
		306,
		325,
		330,
		324,
		333,
		-1,
		389,
		385,
		381,
		388,
		337,
		-1,
		-1,
		377,
		-1,
		380,
		381,
		356,
		329,
		332,
		319,
		310,
		297,
		286,
		297,
		286,
		283,
		291,
		276,
		291,
		282,
		281,
		299,
		309,
		317,
		321,
		327,
		-1,
		439,
		-1,
		381,
		365,
		367,
		339,
		360,
		-1,
		397,
		381,
		373,
		358,
		358,
		-1,
		328,
		325,
		315,
		293,
		278,
		295,
		287,
		285,
		289,
		271,
		285,
		276,
		294,
		301,
		299,
		303,
		323,
		335,
		399,
		389,
		-1,
		371,
		376,
		335,
		343,
		362,
		400,
		364,
		-1,
		359,
		-1,
		330,
		343,
		-1,
		299,
		295,
		277,
		278,
		273,
		288,
		282,
		267,
		264,
		282,
		285,
		292,
		296,
		312,
		-1,
		-1,
		384,
		388,
		377,
		328,
		347,
		371,
		408,
		357,
		346,
		345,
		-1,
		336,
		313,
		310,
		298,
		285,
		270,
		271,
		279,
		292,
		271,
		266,
		263,
		283,
		309,
		287,
		299,
		-1,
		-1,
		-1,
		409,
		-1,
		-1,
		354,
		325,
		349,
		391,
		375,
		368,
		356,
		321,
		321,
		315,
		-1,
		309,
		288,
		279,
		268,
		266,
		279,
		276,
		281,
		261,
		259,
		278,
		290,
		281,
		298,
		-1,
		-1,
		-1,
		384,
		373,
		374,
		320,
		343,
		380,
		354,
		340,
		345,
		320,
		313,
		307,
		322,
		305,
		286,
		275,
		267,
		256,
		272,
		280,
		275,
		257,
		266,
		272,
		296,
		286,
		292,
		-1,
		-1,
		391,
		381,
		365,
		367,
		364,
		334,
		341,
		373,
		345,
		358,
		-1,
		312,
		-1,
		301,
		296,
		280,
		275,
		272,
		269,
		263,
		272,
		274,
		264,
		259,
		266,
		301,
		301,
		276,
		296,
		299,
		-1,
		-1,
		-1,
		384,
		379,
		354,
		331,
		315,
		351,
		-1,
		328,
		329,
		-1,
		306,
		300,
		297,
		282,
		278,
		273,
		277,
		270,
		277,
		270,
		268,
		269,
		251,
		283,
		-1,
		284,
		278,
		286,
		276,
		264,
		-1,
		-1,
		-1,
		377,
		356,
		349,
		369,
		310,
		362,
		-1,
		-1,
		313,
		306,
		-1,
		293,
		275,
		282,
		280,
		274,
		278,
		275,
		264,
		277,
		270,
		256,
		258,
		271,
		275,
		279,
		266,
		262,
		259,
		273,
		-1,
		396,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		330,
		-1,
		322,
		314,
		304,
		298,
		292,
		288,
		286,
		302,
		286,
		289,
		287,
		278,
		286,
		259,
		252,
		259,
		248,
		266,
		274,
		266,
		260,
		259,
		269,
		-1,
		397,
		383,
		354,
		-1,
		-1,
		343,
		-1,
		307,
		321,
		337,
		-1,
		330,
		309,
		324,
		302,
		298,
		294,
		309,
		310,
		287,
		287,
		285,
		276,
		264,
		253,
		256,
		248,
		270,
		270,
		254,
		255,
		259,
		-1,
		403,
		390,
		348,
		344,
		333,
		353,
		304,
		292,
		324,
		-1,
		-1,
		366,
		-1,
		300,
		317,
		308,
		306,
		299,
		281,
		288,
		296,
		273,
		268,
		258,
		247,
		247,
		242,
		264,
		250,
		248,
		257,
		273,
		-1,
		-1,
		-1,
		370,
		-1,
		-1,
		319,
		306,
		300,
		-1,
		341,
		-1,
		344,
		334,
		318,
		303,
		336,
		-1,
		280,
		276,
		283,
		-1,
		293,
		-1,
		266,
		263,
		254,
		239,
		236,
		247,
		245,
		256,
		252,
		-1,
		353,
		338,
		331,
		321,
		335,
		306,
		-1,
		361,
		-1,
		-1,
		331,
		325,
		325,
		309,
		310,
		296,
		276,
		268,
		283,
		282,
		269,
		268,
		252,
		245,
		242,
		235,
		248,
		258,
		263,
		250,
		-1,
		-1,
		-1,
		358,
		344,
		348,
		308,
		327,
		-1,
		-1,
		393,
		348,
		334,
		-1,
		305,
		296,
		284,
		274,
		264,
		269,
		270,
		260,
		258,
		250,
		252,
		246,
		237,
		236,
		252,
		244,
		266,
		-1,
		-1,
		341,
		346,
		334,
		320,
		338,
		-1,
		-1,
		-1,
		340,
		356,
		324,
		303,
		285,
		-1,
		-1,
		268,
		261,
		255,
		258,
		246,
		266,
		261,
		245,
		230,
		245,
		249,
		257,
		248,
		-1,
		344,
		331,
		-1,
		-1,
		337,
		327,
		-1,
		-1,
		-1,
		-1,
		336,
		281,
		270,
		265,
		269,
		267,
		-1,
		241,
		252,
		245,
		264,
		271,
		247,
		232,
		226,
		232,
		244,
		253,
		-1,
		-1,
		351,
		-1,
		313,
		-1,
		-1,
		-1,
		-1,
		293,
		287,
		258,
		251,
		255,
		-1,
		243,
		245,
		242,
		254,
		250,
		247,
		238,
		229,
		225,
		229,
		233,
		247,
		251,
		374,
		-1,
		304,
		-1,
		-1,
		-1,
		311,
		326,
		297,
		274,
		247,
		242,
		235,
		229,
		234,
		245,
		254,
		265,
		230,
		232,
		222,
		221,
		225,
		242,
		246,
		-1,
		-1,
		302,
		298,
		333,
		319,
		323,
		324,
		-1,
		-1,
		251,
		242,
		233,
		225,
		238,
		241,
		226,
		228,
		228,
		226,
		220,
		230,
		245,
		240,
		-1,
		-1,
		-1,
		314,
		-1,
		316,
		-1,
		-1,
		321,
		322,
		269,
		251,
		247,
		245,
		234,
		228,
		216,
		221,
		231,
		225,
		222,
		216,
		220,
		243,
		232,
		271,
		-1,
		-1,
		338,
		-1,
		-1,
		-1,
		298,
		285,
		280,
		303,
		305,
		296,
		284,
		281,
		-1,
		251,
		257,
		222,
		229,
		212,
		219,
		224,
		221,
		210,
		217,
		233,
		232,
		227,
		263,
		254,
		260,
		-1,
		-1,
		331,
		320,
		309,
		315,
		-1,
		291,
		282,
		289,
		279,
		282,
		-1,
		-1,
		276,
		273,
		253,
		222,
		220,
		213,
		208,
		218,
		194,
		206,
		210,
		214,
		220,
		225,
		230,
		236,
		251,
		266,
		-1,
		285,
		322,
		315,
		283,
		291,
		322,
		-1,
		281,
		273,
		279,
		271,
		273,
		-1,
		-1,
		249,
		240,
		241,
		229,
		226,
		232,
		231,
		214,
		220,
		221,
		213,
		212,
		230,
		234,
		243,
		250,
		240,
		253,
		257,
		-1,
		278,
		298,
		277,
		280,
		304,
		318,
		-1,
		272,
		-1,
		-1,
		239,
		274,
		258,
		248,
		245,
		288,
		243,
		238,
		219,
		217,
		212,
		203,
		228,
		221,
		221,
		224,
		239,
		244,
		236,
		250,
		250,
		251,
		-1,
		267,
		278,
		271,
		-1,
		-1,
		-1,
		-1,
		266,
		-1,
		-1,
		229,
		-1,
		285,
		-1,
		268,
		272,
		251,
		254,
		233,
		220,
		206,
		214,
		220,
		219,
		225,
		225,
		226,
		235,
		246,
		258,
		257,
		258,
		240,
		248,
		251,
		262,
		273,
		288,
		292,
		-1,
		256,
		292,
		235,
		-1,
		219,
		-1,
		-1,
		-1,
		282,
		264,
		256,
		253,
		232,
		232,
		198,
		202,
		215,
		222,
		232,
		243,
		235,
		239,
		252,
		263,
		266,
		236,
		241,
		292,
		237,
		237,
		258,
		267,
		288,
		252,
		249,
		286,
		242,
		231,
		226,
		213,
		-1,
		-1,
		266,
		274,
		-1,
		-1,
		239,
		206,
		194,
		204,
		208,
		222,
		234,
		247,
		235,
		240,
		234,
		266,
		-1,
		234,
		233,
		222,
		219,
		205,
		217,
		228,
		255,
		-1,
		-1,
		250,
		277,
		261,
		265,
		273,
		298,
		-1,
		197,
		-1,
		-1,
		246,
		-1,
		-1,
		231,
		211,
		200,
		191,
		196,
		216,
		227,
		249,
		231,
		248,
		239,
		249,
		253,
		218,
		215,
		203,
		201,
		220,
		236,
		224,
		-1,
		232,
		235,
		241,
		248,
		265,
		287,
		-1,
		-1,
		213,
		193,
		-1,
		-1,
		229,
		227,
		216,
		-1,
		206,
		188,
		193,
		223,
		225,
		227,
		234,
		228,
		235,
		243,
		254,
		246,
		227,
		241,
		230,
		221,
		221,
		231,
		229,
		222,
		229,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		203,
		199,
		-1,
		-1,
		224,
		217,
		205,
		193,
		183,
		193,
		210,
		210,
		213,
		218,
		226,
		237,
		233,
		237,
		240,
		-1,
		256,
		-1,
		260,
		221,
		227,
		242,
		250,
		-1,
		-1,
		-1,
		220,
		206,
		199,
		187,
		185,
		-1,
		258,
		242,
		223,
		-1,
		193,
		206,
		246,
		214,
		219,
		214,
		229,
		240,
		231,
		239,
		233,
		236,
		-1,
		-1,
		220,
		203,
		-1,
		-1,
		177,
		179,
		-1,
		211,
		200,
		185,
		177,
		-1,
		-1,
		230,
		226,
		-1,
		-1,
		180,
		218,
		217,
		225,
		220,
		225,
		237,
		233,
		229,
		239,
		230,
		-1,
		-1,
		198,
		190,
		184,
		-1,
		162,
		-1,
		213,
		-1,
		180,
		189,
		177,
		-1,
		-1,
		-1,
		211,
		174,
		190,
		213,
		239,
		237,
		228,
		221,
		228,
		231,
		224,
		230,
		-1,
		-1,
		-1,
		180,
		154,
		220,
		211,
		194,
		174,
		166,
		188,
		-1,
		192,
		-1,
		167,
		170,
		195,
		234,
		236,
		222,
		218,
		231,
		225,
		222,
		220,
		186,
		-1,
		156,
		189,
		153,
		180,
		146,
		160,
		206,
		-1,
		189,
		171,
		-1,
		199,
		189,
		237,
		212,
		221,
		214,
		208,
		209,
		217,
		-1,
		-1,
		-1,
		158,
		157,
		149,
		143,
		143,
		141,
		158,
		-1,
		194,
		176,
		162,
		179,
		179,
		170,
		178,
		227,
		223,
		226,
		224,
		202,
		-1,
		129,
		-1,
		-1,
		181,
		-1,
		-1,
		-1,
		152,
		136,
		149,
		160,
		163,
		159,
		159,
		161,
		174,
		182,
		180,
		177,
		189,
		185,
		205,
		201,
		233,
		-1,
		124,
		-1,
		188,
		-1,
		-1,
		133,
		120,
		130,
		141,
		169,
		169,
		158,
		154,
		171,
		206,
		192,
		190,
		195,
		200,
		-1,
		113,
		112,
		-1,
		106,
		116,
		130,
		-1,
		111,
		-1,
		215,
		176,
		-1,
		155,
		149,
		-1,
		201,
		197,
		-1,
		-1,
		100,
		95,
		-1,
		-1,
		-1,
		110,
		119,
		210,
		194,
		-1,
		139,
		146,
		-1,
		-1,
		-1,
		85,
		86,
		-1,
		103,
		106,
		-1,
		120,
		126,
		154,
		134,
		140,
		-1,
		-1,
		-1,
		94,
		75,
		69,
		93,
		88,
		111,
		151,
		137,
		137,
		121,
		131,
		160,
		-1,
		-1,
		-1,
		61,
		63,
		73,
		-1,
		-1,
		162,
		145,
		132,
		130,
		-1,
		-1,
		-1,
		68,
		62,
		-1,
		-1,
		82,
		-1,
		-1,
		127,
		106,
		-1,
		-1,
		-1,
		-1,
		-1,
		23,
		52,
		-1,
		-1,
		-1,
		83,
		90,
		111,
		-1,
		-1,
		-1,
		-1,
		2,
		3,
		47,
		48,
		-1,
		-1,
		-1,
		97,
		100,
		-1,
		-1,
		0,
		1,
		-1,
		-1,
		-1,
		79,
		91,
		-1,
		111,
		-1,
		-1,
		-1,
		95,
		-1,
		-1,
		144,
		-1,
		-1,
		-1,
		109,
		-1,
		146,
		121,
		128,
		-1,
		-1,
		-1,
		-1,
		122,
		114,
		159,
		-1,
		131,
		133,
		-1,
		181,
		-1,
		-1,
		137,
		132,
		-1,
		-1,
		136,
		143,
		165,
		168,
		97,
		-1,
		155
	],
	[
		-1,
		381,
		370,
		381,
		389,
		362,
		369,
		-1,
		388,
		392,
		358,
		352,
		391,
		360,
		366,
		377,
		-1,
		-1,
		-1,
		381,
		380,
		348,
		346,
		355,
		360,
		367,
		-1,
		366,
		-1,
		402,
		381,
		392,
		397,
		341,
		338,
		358,
		377,
		359,
		351,
		417,
		371,
		342,
		336,
		354,
		344,
		353,
		345,
		-1,
		342,
		332,
		354,
		333,
		344,
		336,
		-1,
		-1,
		336,
		337,
		343,
		329,
		335,
		331,
		-1,
		341,
		325,
		-1,
		-1,
		326,
		327,
		311,
		314,
		322,
		320,
		333,
		325,
		320,
		-1,
		-1,
		317,
		313,
		320,
		307,
		303,
		320,
		333,
		315,
		329,
		328,
		-1,
		321,
		339,
		346,
		314,
		312,
		296,
		294,
		312,
		314,
		320,
		320,
		-1,
		330,
		331,
		326,
		334,
		336,
		312,
		299,
		299,
		309,
		302,
		321,
		309,
		355,
		-1,
		-1,
		-1,
		-1,
		-1,
		364,
		330,
		313,
		330,
		322,
		312,
		327,
		320,
		302,
		299,
		297,
		294,
		310,
		308,
		318,
		-1,
		-1,
		423,
		392,
		421,
		379,
		360,
		-1,
		326,
		306,
		312,
		316,
		310,
		303,
		317,
		313,
		-1,
		288,
		287,
		315,
		301,
		312,
		383,
		-1,
		-1,
		381,
		373,
		356,
		359,
		336,
		332,
		321,
		320,
		312,
		298,
		294,
		300,
		303,
		303,
		309,
		282,
		292,
		296,
		294,
		319,
		-1,
		-1,
		354,
		-1,
		-1,
		380,
		363,
		-1,
		346,
		353,
		342,
		348,
		334,
		355,
		331,
		322,
		314,
		308,
		296,
		298,
		295,
		308,
		296,
		279,
		304,
		308,
		289,
		310,
		305,
		-1,
		353,
		337,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		358,
		339,
		342,
		348,
		372,
		371,
		-1,
		343,
		331,
		332,
		317,
		314,
		301,
		289,
		302,
		287,
		294,
		293,
		283,
		281,
		311,
		286,
		308,
		305,
		324,
		329,
		323,
		332,
		-1,
		388,
		384,
		380,
		387,
		336,
		-1,
		-1,
		376,
		-1,
		379,
		380,
		355,
		328,
		331,
		318,
		309,
		296,
		285,
		296,
		285,
		282,
		290,
		275,
		290,
		281,
		280,
		298,
		308,
		316,
		320,
		326,
		-1,
		438,
		-1,
		380,
		364,
		366,
		338,
		359,
		-1,
		396,
		380,
		372,
		357,
		357,
		-1,
		327,
		324,
		314,
		292,
		277,
		294,
		286,
		284,
		288,
		270,
		284,
		275,
		293,
		300,
		298,
		302,
		322,
		334,
		398,
		388,
		-1,
		370,
		375,
		334,
		342,
		361,
		399,
		363,
		-1,
		358,
		-1,
		329,
		342,
		-1,
		298,
		294,
		276,
		277,
		272,
		287,
		281,
		266,
		263,
		281,
		284,
		291,
		295,
		311,
		-1,
		-1,
		383,
		387,
		376,
		327,
		346,
		370,
		407,
		356,
		345,
		344,
		-1,
		335,
		312,
		309,
		297,
		284,
		269,
		270,
		278,
		291,
		270,
		265,
		262,
		282,
		308,
		286,
		298,
		-1,
		-1,
		-1,
		408,
		-1,
		-1,
		353,
		324,
		348,
		390,
		374,
		367,
		355,
		320,
		320,
		314,
		-1,
		308,
		287,
		278,
		267,
		265,
		278,
		275,
		280,
		260,
		258,
		277,
		289,
		280,
		297,
		-1,
		-1,
		-1,
		383,
		372,
		373,
		319,
		342,
		379,
		353,
		339,
		344,
		319,
		312,
		306,
		321,
		304,
		285,
		274,
		266,
		255,
		271,
		279,
		274,
		256,
		265,
		271,
		295,
		285,
		291,
		-1,
		-1,
		390,
		380,
		364,
		366,
		363,
		333,
		340,
		372,
		344,
		357,
		-1,
		311,
		-1,
		300,
		295,
		279,
		274,
		271,
		268,
		262,
		271,
		273,
		263,
		258,
		265,
		300,
		300,
		275,
		295,
		298,
		-1,
		-1,
		-1,
		383,
		378,
		353,
		330,
		314,
		350,
		-1,
		327,
		328,
		-1,
		305,
		299,
		296,
		281,
		277,
		272,
		276,
		269,
		276,
		269,
		267,
		268,
		250,
		282,
		-1,
		283,
		277,
		285,
		275,
		263,
		-1,
		-1,
		-1,
		376,
		355,
		348,
		368,
		309,
		361,
		-1,
		-1,
		312,
		305,
		-1,
		292,
		274,
		281,
		279,
		273,
		277,
		274,
		263,
		276,
		269,
		255,
		257,
		270,
		274,
		278,
		265,
		261,
		258,
		272,
		-1,
		395,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		329,
		-1,
		321,
		313,
		303,
		297,
		291,
		287,
		285,
		301,
		285,
		288,
		286,
		277,
		285,
		258,
		251,
		258,
		247,
		265,
		273,
		265,
		259,
		258,
		268,
		-1,
		396,
		382,
		353,
		-1,
		-1,
		342,
		-1,
		306,
		320,
		336,
		-1,
		329,
		308,
		323,
		301,
		297,
		293,
		308,
		309,
		286,
		286,
		284,
		275,
		263,
		252,
		255,
		247,
		269,
		269,
		253,
		254,
		258,
		-1,
		402,
		389,
		347,
		343,
		332,
		352,
		303,
		291,
		323,
		-1,
		-1,
		365,
		-1,
		299,
		316,
		307,
		305,
		298,
		280,
		287,
		295,
		272,
		267,
		257,
		246,
		246,
		241,
		263,
		249,
		247,
		256,
		272,
		-1,
		-1,
		-1,
		369,
		-1,
		-1,
		318,
		305,
		299,
		-1,
		340,
		-1,
		343,
		333,
		317,
		302,
		335,
		-1,
		279,
		275,
		282,
		-1,
		292,
		-1,
		265,
		262,
		253,
		238,
		235,
		246,
		244,
		255,
		251,
		-1,
		352,
		337,
		330,
		320,
		334,
		305,
		-1,
		360,
		-1,
		-1,
		330,
		324,
		324,
		308,
		309,
		295,
		275,
		267,
		282,
		281,
		268,
		267,
		251,
		244,
		241,
		234,
		247,
		257,
		262,
		249,
		-1,
		-1,
		-1,
		357,
		343,
		347,
		307,
		326,
		-1,
		-1,
		392,
		347,
		333,
		-1,
		304,
		295,
		283,
		273,
		263,
		268,
		269,
		259,
		257,
		249,
		251,
		245,
		236,
		235,
		251,
		243,
		265,
		-1,
		-1,
		340,
		345,
		333,
		319,
		337,
		-1,
		-1,
		-1,
		339,
		355,
		323,
		302,
		284,
		-1,
		-1,
		267,
		260,
		254,
		257,
		245,
		265,
		260,
		244,
		229,
		244,
		248,
		256,
		247,
		-1,
		343,
		330,
		-1,
		-1,
		336,
		326,
		-1,
		-1,
		-1,
		-1,
		335,
		280,
		269,
		264,
		268,
		266,
		-1,
		240,
		251,
		244,
		263,
		270,
		246,
		231,
		225,
		231,
		243,
		252,
		-1,
		-1,
		350,
		-1,
		312,
		-1,
		-1,
		-1,
		-1,
		292,
		286,
		257,
		250,
		254,
		-1,
		242,
		244,
		241,
		253,
		249,
		246,
		237,
		228,
		224,
		228,
		232,
		246,
		250,
		373,
		-1,
		303,
		-1,
		-1,
		-1,
		310,
		325,
		296,
		273,
		246,
		241,
		234,
		228,
		233,
		244,
		253,
		264,
		229,
		231,
		221,
		220,
		224,
		241,
		245,
		-1,
		-1,
		301,
		297,
		332,
		318,
		322,
		323,
		-1,
		-1,
		250,
		241,
		232,
		224,
		237,
		240,
		225,
		227,
		227,
		225,
		219,
		229,
		244,
		239,
		-1,
		-1,
		-1,
		313,
		-1,
		315,
		-1,
		-1,
		320,
		321,
		268,
		250,
		246,
		244,
		233,
		227,
		215,
		220,
		230,
		224,
		221,
		215,
		219,
		242,
		231,
		270,
		-1,
		-1,
		337,
		-1,
		-1,
		-1,
		297,
		284,
		279,
		302,
		304,
		295,
		283,
		280,
		-1,
		250,
		256,
		221,
		228,
		211,
		218,
		223,
		220,
		209,
		216,
		232,
		231,
		226,
		262,
		253,
		259,
		-1,
		-1,
		330,
		319,
		308,
		314,
		-1,
		290,
		281,
		288,
		278,
		281,
		-1,
		-1,
		275,
		272,
		252,
		221,
		219,
		212,
		207,
		217,
		193,
		205,
		209,
		213,
		219,
		224,
		229,
		235,
		250,
		265,
		-1,
		284,
		321,
		314,
		282,
		290,
		321,
		-1,
		280,
		272,
		278,
		270,
		272,
		-1,
		-1,
		248,
		239,
		240,
		228,
		225,
		231,
		230,
		213,
		219,
		220,
		212,
		211,
		229,
		233,
		242,
		249,
		239,
		252,
		256,
		-1,
		277,
		297,
		276,
		279,
		303,
		317,
		-1,
		271,
		-1,
		-1,
		238,
		273,
		257,
		247,
		244,
		287,
		242,
		237,
		218,
		216,
		211,
		202,
		227,
		220,
		220,
		223,
		238,
		243,
		235,
		249,
		249,
		250,
		-1,
		266,
		277,
		270,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		228,
		-1,
		284,
		-1,
		267,
		271,
		250,
		253,
		232,
		219,
		205,
		213,
		219,
		218,
		224,
		224,
		225,
		234,
		245,
		257,
		256,
		257,
		242,
		247,
		250,
		261,
		272,
		287,
		291,
		-1,
		255,
		291,
		234,
		-1,
		218,
		-1,
		-1,
		-1,
		281,
		263,
		255,
		252,
		231,
		231,
		197,
		201,
		214,
		221,
		231,
		242,
		234,
		238,
		251,
		262,
		265,
		238,
		243,
		291,
		236,
		236,
		257,
		266,
		287,
		251,
		248,
		285,
		241,
		230,
		225,
		212,
		-1,
		-1,
		265,
		273,
		-1,
		-1,
		238,
		205,
		193,
		203,
		207,
		221,
		233,
		246,
		234,
		239,
		233,
		265,
		-1,
		236,
		235,
		224,
		221,
		207,
		219,
		227,
		254,
		-1,
		-1,
		249,
		276,
		260,
		264,
		272,
		297,
		-1,
		196,
		-1,
		-1,
		245,
		-1,
		-1,
		230,
		210,
		199,
		190,
		195,
		215,
		226,
		248,
		230,
		247,
		238,
		248,
		252,
		220,
		217,
		205,
		203,
		222,
		235,
		223,
		-1,
		231,
		234,
		240,
		247,
		264,
		286,
		-1,
		-1,
		212,
		192,
		-1,
		-1,
		228,
		226,
		215,
		-1,
		205,
		187,
		192,
		222,
		224,
		226,
		233,
		227,
		234,
		242,
		253,
		245,
		229,
		243,
		232,
		223,
		223,
		233,
		228,
		221,
		228,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		217,
		-1,
		202,
		198,
		-1,
		-1,
		223,
		216,
		204,
		192,
		182,
		192,
		209,
		209,
		212,
		217,
		225,
		236,
		232,
		236,
		239,
		-1,
		258,
		-1,
		259,
		220,
		226,
		241,
		249,
		-1,
		-1,
		-1,
		219,
		205,
		198,
		186,
		184,
		-1,
		257,
		241,
		222,
		-1,
		192,
		205,
		245,
		213,
		218,
		213,
		228,
		239,
		230,
		238,
		232,
		235,
		-1,
		-1,
		219,
		202,
		-1,
		-1,
		176,
		178,
		-1,
		210,
		199,
		184,
		176,
		-1,
		-1,
		229,
		225,
		-1,
		-1,
		179,
		217,
		216,
		224,
		219,
		224,
		236,
		232,
		228,
		238,
		229,
		-1,
		-1,
		197,
		189,
		183,
		-1,
		161,
		-1,
		212,
		-1,
		179,
		188,
		176,
		-1,
		-1,
		-1,
		210,
		173,
		189,
		212,
		238,
		236,
		227,
		220,
		227,
		230,
		223,
		229,
		-1,
		-1,
		-1,
		179,
		153,
		219,
		210,
		193,
		173,
		165,
		187,
		-1,
		191,
		-1,
		166,
		169,
		194,
		233,
		235,
		221,
		217,
		230,
		224,
		221,
		219,
		185,
		-1,
		155,
		188,
		152,
		179,
		145,
		159,
		205,
		-1,
		188,
		170,
		-1,
		198,
		188,
		236,
		211,
		220,
		213,
		207,
		208,
		216,
		-1,
		-1,
		-1,
		157,
		156,
		148,
		142,
		142,
		140,
		157,
		-1,
		193,
		175,
		161,
		178,
		178,
		169,
		177,
		226,
		222,
		225,
		223,
		201,
		-1,
		128,
		-1,
		-1,
		180,
		-1,
		-1,
		-1,
		151,
		135,
		148,
		159,
		162,
		158,
		158,
		160,
		173,
		181,
		179,
		176,
		188,
		184,
		204,
		200,
		232,
		-1,
		123,
		-1,
		187,
		-1,
		-1,
		132,
		119,
		129,
		140,
		168,
		168,
		157,
		153,
		170,
		205,
		191,
		189,
		194,
		199,
		-1,
		112,
		111,
		-1,
		105,
		115,
		129,
		-1,
		110,
		-1,
		214,
		175,
		-1,
		154,
		148,
		-1,
		200,
		196,
		-1,
		-1,
		99,
		94,
		-1,
		-1,
		-1,
		109,
		118,
		209,
		193,
		-1,
		138,
		145,
		-1,
		-1,
		-1,
		84,
		85,
		-1,
		102,
		105,
		-1,
		119,
		125,
		153,
		133,
		139,
		-1,
		-1,
		-1,
		93,
		74,
		68,
		92,
		87,
		110,
		150,
		136,
		136,
		120,
		130,
		159,
		-1,
		-1,
		-1,
		60,
		62,
		72,
		-1,
		-1,
		161,
		144,
		131,
		129,
		-1,
		-1,
		-1,
		67,
		61,
		-1,
		-1,
		81,
		-1,
		-1,
		126,
		105,
		-1,
		-1,
		-1,
		-1,
		-1,
		22,
		51,
		-1,
		-1,
		-1,
		82,
		89,
		110,
		-1,
		-1,
		-1,
		-1,
		1,
		2,
		46,
		47,
		-1,
		-1,
		-1,
		96,
		99,
		-1,
		-1,
		2,
		0,
		-1,
		-1,
		-1,
		78,
		90,
		-1,
		110,
		-1,
		-1,
		-1,
		94,
		-1,
		-1,
		143,
		-1,
		-1,
		-1,
		108,
		-1,
		145,
		120,
		127,
		-1,
		-1,
		-1,
		-1,
		121,
		113,
		158,
		-1,
		130,
		132,
		-1,
		180,
		-1,
		-1,
		136,
		131,
		-1,
		-1,
		135,
		142,
		164,
		167,
		99,
		-1,
		154
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		327,
		331,
		297,
		291,
		330,
		299,
		305,
		316,
		-1,
		-1,
		-1,
		320,
		319,
		287,
		285,
		294,
		299,
		306,
		-1,
		305,
		-1,
		341,
		320,
		331,
		336,
		280,
		277,
		297,
		316,
		298,
		290,
		356,
		310,
		281,
		275,
		293,
		283,
		292,
		284,
		-1,
		281,
		271,
		293,
		272,
		283,
		275,
		-1,
		-1,
		275,
		276,
		282,
		268,
		274,
		270,
		-1,
		280,
		264,
		-1,
		-1,
		265,
		266,
		250,
		253,
		261,
		259,
		272,
		264,
		259,
		-1,
		-1,
		256,
		252,
		259,
		246,
		242,
		259,
		272,
		254,
		268,
		267,
		-1,
		260,
		278,
		285,
		253,
		251,
		235,
		233,
		251,
		253,
		259,
		259,
		-1,
		269,
		270,
		265,
		273,
		275,
		251,
		238,
		238,
		248,
		241,
		260,
		248,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		269,
		252,
		269,
		261,
		251,
		266,
		259,
		241,
		238,
		236,
		233,
		249,
		247,
		257,
		-1,
		-1,
		362,
		331,
		360,
		318,
		299,
		-1,
		265,
		245,
		251,
		255,
		249,
		242,
		256,
		252,
		-1,
		227,
		226,
		254,
		240,
		251,
		322,
		-1,
		-1,
		320,
		312,
		295,
		298,
		275,
		271,
		260,
		259,
		251,
		237,
		233,
		239,
		242,
		242,
		248,
		221,
		231,
		235,
		233,
		258,
		-1,
		-1,
		293,
		-1,
		-1,
		319,
		302,
		-1,
		285,
		292,
		281,
		287,
		273,
		294,
		270,
		261,
		253,
		247,
		235,
		237,
		234,
		247,
		235,
		218,
		243,
		247,
		228,
		249,
		244,
		-1,
		292,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		278,
		281,
		287,
		311,
		310,
		-1,
		282,
		270,
		271,
		256,
		253,
		240,
		228,
		241,
		226,
		233,
		232,
		222,
		220,
		250,
		225,
		247,
		244,
		263,
		268,
		262,
		271,
		-1,
		327,
		323,
		319,
		326,
		275,
		-1,
		-1,
		315,
		-1,
		318,
		319,
		294,
		267,
		270,
		257,
		248,
		235,
		224,
		235,
		224,
		221,
		229,
		214,
		229,
		220,
		219,
		237,
		247,
		255,
		259,
		265,
		-1,
		377,
		-1,
		319,
		303,
		305,
		277,
		298,
		-1,
		335,
		319,
		311,
		296,
		296,
		-1,
		266,
		263,
		253,
		231,
		216,
		233,
		225,
		223,
		227,
		209,
		223,
		214,
		232,
		239,
		237,
		241,
		261,
		273,
		337,
		327,
		-1,
		309,
		314,
		273,
		281,
		300,
		338,
		302,
		-1,
		297,
		-1,
		268,
		281,
		-1,
		237,
		233,
		215,
		216,
		211,
		226,
		220,
		205,
		202,
		220,
		223,
		230,
		234,
		250,
		-1,
		-1,
		322,
		326,
		315,
		266,
		285,
		309,
		346,
		295,
		284,
		283,
		-1,
		274,
		251,
		248,
		236,
		223,
		208,
		209,
		217,
		230,
		209,
		204,
		201,
		221,
		247,
		225,
		237,
		-1,
		-1,
		-1,
		347,
		-1,
		-1,
		292,
		263,
		287,
		329,
		313,
		306,
		294,
		259,
		259,
		253,
		-1,
		247,
		226,
		217,
		206,
		204,
		217,
		214,
		219,
		199,
		197,
		216,
		228,
		219,
		236,
		-1,
		-1,
		-1,
		322,
		311,
		312,
		258,
		281,
		318,
		292,
		278,
		283,
		258,
		251,
		245,
		260,
		243,
		224,
		213,
		205,
		194,
		210,
		218,
		213,
		195,
		204,
		210,
		234,
		224,
		230,
		-1,
		-1,
		329,
		319,
		303,
		305,
		302,
		272,
		279,
		311,
		283,
		296,
		-1,
		250,
		-1,
		239,
		234,
		218,
		213,
		210,
		207,
		201,
		210,
		212,
		202,
		197,
		204,
		239,
		239,
		214,
		234,
		237,
		-1,
		-1,
		-1,
		322,
		317,
		292,
		269,
		253,
		289,
		-1,
		266,
		267,
		-1,
		244,
		238,
		235,
		220,
		216,
		211,
		215,
		208,
		215,
		208,
		206,
		207,
		189,
		221,
		-1,
		222,
		216,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		315,
		294,
		287,
		307,
		248,
		300,
		-1,
		-1,
		251,
		244,
		-1,
		231,
		213,
		220,
		218,
		212,
		216,
		213,
		202,
		215,
		208,
		194,
		196,
		209,
		213,
		217,
		204,
		200,
		197,
		211,
		-1,
		334,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		268,
		-1,
		260,
		252,
		242,
		236,
		230,
		226,
		224,
		240,
		224,
		227,
		225,
		216,
		224,
		197,
		190,
		197,
		186,
		204,
		212,
		204,
		198,
		197,
		207,
		-1,
		335,
		321,
		292,
		-1,
		-1,
		281,
		-1,
		245,
		259,
		275,
		-1,
		268,
		247,
		262,
		240,
		236,
		232,
		247,
		248,
		225,
		225,
		223,
		214,
		202,
		191,
		194,
		186,
		208,
		208,
		192,
		193,
		197,
		-1,
		341,
		328,
		286,
		282,
		271,
		291,
		242,
		230,
		262,
		-1,
		-1,
		304,
		-1,
		238,
		255,
		246,
		244,
		237,
		219,
		226,
		234,
		211,
		206,
		196,
		185,
		185,
		180,
		202,
		188,
		186,
		195,
		211,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		257,
		244,
		238,
		-1,
		279,
		-1,
		282,
		272,
		256,
		241,
		274,
		-1,
		218,
		214,
		221,
		-1,
		231,
		-1,
		204,
		201,
		192,
		177,
		174,
		185,
		183,
		194,
		190,
		-1,
		291,
		276,
		269,
		259,
		273,
		244,
		-1,
		299,
		-1,
		-1,
		269,
		263,
		263,
		247,
		248,
		234,
		214,
		206,
		221,
		220,
		207,
		206,
		190,
		183,
		180,
		173,
		186,
		196,
		201,
		188,
		-1,
		-1,
		-1,
		296,
		282,
		286,
		246,
		265,
		-1,
		-1,
		331,
		286,
		272,
		-1,
		243,
		234,
		222,
		212,
		202,
		207,
		208,
		198,
		196,
		188,
		190,
		184,
		175,
		174,
		190,
		182,
		204,
		-1,
		-1,
		279,
		284,
		272,
		258,
		277,
		-1,
		-1,
		-1,
		278,
		294,
		262,
		241,
		223,
		-1,
		-1,
		206,
		199,
		193,
		196,
		184,
		204,
		199,
		183,
		168,
		183,
		187,
		195,
		186,
		-1,
		282,
		269,
		-1,
		-1,
		280,
		274,
		-1,
		-1,
		-1,
		-1,
		274,
		219,
		208,
		203,
		207,
		205,
		-1,
		179,
		190,
		183,
		202,
		209,
		185,
		170,
		164,
		170,
		182,
		191,
		-1,
		-1,
		294,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		231,
		225,
		196,
		189,
		193,
		-1,
		181,
		183,
		180,
		192,
		188,
		185,
		176,
		167,
		163,
		167,
		171,
		185,
		189,
		317,
		-1,
		258,
		-1,
		-1,
		-1,
		249,
		264,
		235,
		212,
		185,
		180,
		173,
		167,
		172,
		183,
		192,
		203,
		168,
		170,
		160,
		159,
		163,
		180,
		184,
		-1,
		-1,
		256,
		252,
		275,
		257,
		261,
		262,
		-1,
		-1,
		189,
		180,
		171,
		163,
		176,
		179,
		164,
		166,
		166,
		164,
		158,
		168,
		183,
		178,
		-1,
		-1,
		-1,
		268,
		-1,
		270,
		-1,
		-1,
		259,
		260,
		207,
		189,
		185,
		183,
		172,
		166,
		154,
		159,
		169,
		163,
		160,
		154,
		158,
		181,
		170,
		209,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		248,
		239,
		234,
		241,
		243,
		234,
		222,
		219,
		-1,
		189,
		195,
		160,
		167,
		150,
		157,
		162,
		159,
		148,
		155,
		171,
		170,
		165,
		201,
		192,
		198,
		-1,
		-1,
		320,
		309,
		298,
		304,
		-1,
		241,
		236,
		227,
		217,
		220,
		-1,
		-1,
		214,
		211,
		191,
		160,
		158,
		151,
		146,
		156,
		132,
		144,
		148,
		152,
		158,
		163,
		168,
		174,
		189,
		204,
		-1,
		274,
		311,
		304,
		272,
		280,
		311,
		-1,
		231,
		223,
		233,
		209,
		211,
		-1,
		-1,
		187,
		178,
		179,
		167,
		164,
		170,
		169,
		152,
		158,
		159,
		151,
		150,
		168,
		172,
		181,
		188,
		178,
		191,
		195,
		-1,
		267,
		287,
		266,
		269,
		293,
		307,
		-1,
		228,
		-1,
		-1,
		193,
		212,
		196,
		186,
		183,
		226,
		181,
		176,
		157,
		155,
		150,
		141,
		166,
		159,
		159,
		162,
		177,
		182,
		174,
		188,
		188,
		189,
		-1,
		256,
		267,
		260,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		183,
		-1,
		223,
		-1,
		206,
		210,
		189,
		192,
		171,
		158,
		144,
		152,
		158,
		157,
		163,
		163,
		164,
		173,
		184,
		196,
		195,
		196,
		281,
		237,
		240,
		251,
		262,
		277,
		281,
		-1,
		240,
		279,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		220,
		202,
		194,
		191,
		170,
		170,
		136,
		140,
		153,
		160,
		170,
		181,
		173,
		177,
		190,
		201,
		204,
		277,
		268,
		281,
		226,
		226,
		247,
		256,
		277,
		241,
		238,
		273,
		196,
		185,
		180,
		167,
		-1,
		-1,
		204,
		212,
		-1,
		-1,
		177,
		144,
		132,
		142,
		146,
		160,
		172,
		185,
		173,
		178,
		172,
		204,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		217,
		244,
		-1,
		-1,
		239,
		266,
		250,
		229,
		227,
		252,
		-1,
		156,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		149,
		138,
		129,
		134,
		154,
		165,
		187,
		169,
		186,
		177,
		187,
		191,
		254,
		251,
		239,
		237,
		260,
		225,
		213,
		-1,
		221,
		224,
		230,
		237,
		230,
		241,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		126,
		131,
		161,
		163,
		165,
		172,
		166,
		173,
		181,
		192,
		184,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		148,
		148,
		151,
		156,
		164,
		175,
		171,
		175,
		178,
		-1,
		297,
		-1,
		249,
		210,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		184,
		152,
		157,
		152,
		167,
		178,
		169,
		177,
		171,
		174,
		-1,
		-1,
		209,
		192,
		-1,
		-1,
		166,
		168,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		118,
		156,
		155,
		163,
		158,
		163,
		175,
		171,
		167,
		177,
		168,
		-1,
		-1,
		187,
		179,
		173,
		-1,
		151,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		149,
		112,
		128,
		151,
		177,
		175,
		166,
		159,
		166,
		169,
		162,
		168,
		-1,
		-1,
		-1,
		169,
		143,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		130,
		-1,
		105,
		108,
		133,
		172,
		174,
		160,
		156,
		169,
		163,
		160,
		158,
		175,
		-1,
		145,
		178,
		142,
		139,
		115,
		119,
		144,
		-1,
		127,
		109,
		-1,
		137,
		127,
		175,
		150,
		159,
		152,
		146,
		147,
		155,
		-1,
		-1,
		-1,
		147,
		146,
		138,
		132,
		132,
		120,
		111,
		-1,
		132,
		114,
		100,
		117,
		117,
		108,
		116,
		165,
		161,
		164,
		162,
		140,
		-1,
		133,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		141,
		125,
		112,
		100,
		101,
		97,
		97,
		99,
		112,
		120,
		118,
		115,
		127,
		123,
		143,
		139,
		171,
		-1,
		128,
		-1,
		177,
		-1,
		-1,
		122,
		109,
		119,
		123,
		112,
		110,
		96,
		92,
		109,
		144,
		130,
		128,
		133,
		138,
		-1,
		117,
		116,
		-1,
		110,
		120,
		119,
		-1,
		100,
		-1,
		158,
		119,
		-1,
		93,
		87,
		-1,
		139,
		135,
		-1,
		-1,
		104,
		99,
		-1,
		-1,
		-1,
		99,
		103,
		153,
		137,
		-1,
		77,
		84,
		-1,
		-1,
		-1,
		89,
		90,
		-1,
		85,
		95,
		-1,
		99,
		90,
		98,
		72,
		78,
		-1,
		-1,
		-1,
		98,
		79,
		73,
		75,
		70,
		100,
		111,
		97,
		81,
		59,
		69,
		98,
		-1,
		-1,
		-1,
		68,
		62,
		55,
		-1,
		-1,
		106,
		89,
		70,
		68,
		-1,
		-1,
		-1,
		69,
		63,
		-1,
		-1,
		46,
		-1,
		-1,
		65,
		44,
		-1,
		-1,
		-1,
		-1,
		-1,
		78,
		53,
		-1,
		-1,
		-1,
		41,
		35,
		49,
		-1,
		-1,
		-1,
		-1,
		57,
		57,
		74,
		28,
		-1,
		-1,
		-1,
		31,
		38,
		-1,
		-1,
		60,
		58,
		-1,
		-1,
		-1,
		0,
		12,
		-1,
		49,
		-1,
		-1,
		-1,
		16,
		-1,
		-1,
		82,
		-1,
		-1,
		-1,
		30,
		-1,
		84,
		59,
		66,
		-1,
		-1,
		-1,
		-1,
		43,
		35,
		97,
		-1,
		69,
		71,
		-1,
		119,
		-1,
		-1,
		58,
		53,
		-1,
		-1,
		74,
		81,
		103,
		106,
		92,
		-1,
		93
	],
	[
		-1,
		309,
		298,
		309,
		317,
		290,
		297,
		-1,
		316,
		320,
		286,
		280,
		319,
		288,
		294,
		305,
		-1,
		-1,
		-1,
		309,
		308,
		276,
		274,
		283,
		288,
		295,
		-1,
		294,
		-1,
		330,
		309,
		320,
		325,
		269,
		266,
		286,
		305,
		287,
		279,
		345,
		299,
		270,
		264,
		282,
		272,
		281,
		273,
		-1,
		270,
		260,
		282,
		261,
		272,
		264,
		-1,
		-1,
		264,
		265,
		271,
		257,
		263,
		259,
		-1,
		269,
		253,
		-1,
		-1,
		254,
		255,
		239,
		242,
		250,
		248,
		261,
		253,
		248,
		-1,
		-1,
		245,
		241,
		248,
		235,
		231,
		248,
		261,
		243,
		257,
		256,
		-1,
		249,
		267,
		274,
		242,
		240,
		224,
		222,
		240,
		242,
		248,
		248,
		-1,
		258,
		259,
		254,
		262,
		264,
		240,
		227,
		227,
		237,
		230,
		249,
		237,
		283,
		-1,
		-1,
		-1,
		-1,
		-1,
		292,
		258,
		241,
		258,
		250,
		240,
		255,
		248,
		230,
		227,
		225,
		222,
		238,
		236,
		246,
		-1,
		-1,
		351,
		320,
		349,
		307,
		288,
		-1,
		254,
		234,
		240,
		244,
		238,
		231,
		245,
		241,
		-1,
		216,
		215,
		243,
		229,
		240,
		311,
		-1,
		-1,
		309,
		301,
		284,
		287,
		264,
		260,
		249,
		248,
		240,
		226,
		222,
		228,
		231,
		231,
		237,
		210,
		220,
		224,
		222,
		247,
		-1,
		-1,
		282,
		-1,
		-1,
		308,
		291,
		-1,
		274,
		281,
		270,
		276,
		262,
		283,
		259,
		250,
		242,
		236,
		224,
		226,
		223,
		236,
		224,
		207,
		232,
		236,
		217,
		238,
		233,
		-1,
		281,
		265,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		286,
		267,
		270,
		276,
		300,
		299,
		-1,
		271,
		259,
		260,
		245,
		242,
		229,
		217,
		230,
		215,
		222,
		221,
		211,
		209,
		239,
		214,
		236,
		233,
		252,
		257,
		251,
		260,
		-1,
		316,
		312,
		308,
		315,
		264,
		-1,
		-1,
		304,
		-1,
		307,
		308,
		283,
		256,
		259,
		246,
		237,
		224,
		213,
		224,
		213,
		210,
		218,
		203,
		218,
		209,
		208,
		226,
		236,
		244,
		248,
		254,
		-1,
		366,
		-1,
		308,
		292,
		294,
		266,
		287,
		-1,
		324,
		308,
		300,
		285,
		285,
		-1,
		255,
		252,
		242,
		220,
		205,
		222,
		214,
		212,
		216,
		198,
		212,
		203,
		221,
		228,
		226,
		230,
		250,
		262,
		326,
		316,
		-1,
		298,
		303,
		262,
		270,
		289,
		327,
		291,
		-1,
		286,
		-1,
		257,
		270,
		-1,
		226,
		222,
		204,
		205,
		200,
		215,
		209,
		194,
		191,
		209,
		212,
		219,
		223,
		239,
		-1,
		-1,
		311,
		315,
		304,
		255,
		274,
		298,
		335,
		284,
		273,
		272,
		-1,
		263,
		240,
		237,
		225,
		212,
		197,
		198,
		206,
		219,
		198,
		193,
		190,
		210,
		236,
		214,
		226,
		-1,
		-1,
		-1,
		336,
		-1,
		-1,
		281,
		252,
		276,
		318,
		302,
		295,
		283,
		248,
		248,
		242,
		-1,
		236,
		215,
		206,
		195,
		193,
		206,
		203,
		208,
		188,
		186,
		205,
		217,
		208,
		225,
		-1,
		-1,
		-1,
		311,
		300,
		301,
		247,
		270,
		307,
		281,
		267,
		272,
		247,
		240,
		234,
		249,
		232,
		213,
		202,
		194,
		183,
		199,
		207,
		202,
		184,
		193,
		199,
		223,
		213,
		219,
		-1,
		-1,
		318,
		308,
		292,
		294,
		291,
		261,
		268,
		300,
		272,
		285,
		-1,
		239,
		-1,
		228,
		223,
		207,
		202,
		199,
		196,
		190,
		199,
		201,
		191,
		186,
		193,
		228,
		228,
		203,
		223,
		226,
		-1,
		-1,
		-1,
		311,
		306,
		281,
		258,
		242,
		278,
		-1,
		255,
		256,
		-1,
		233,
		227,
		224,
		209,
		205,
		200,
		204,
		197,
		204,
		197,
		195,
		196,
		178,
		210,
		-1,
		211,
		205,
		213,
		203,
		191,
		-1,
		-1,
		-1,
		304,
		283,
		276,
		296,
		237,
		289,
		-1,
		-1,
		240,
		233,
		-1,
		220,
		202,
		209,
		207,
		201,
		205,
		202,
		191,
		204,
		197,
		183,
		185,
		198,
		202,
		206,
		193,
		189,
		186,
		200,
		-1,
		323,
		-1,
		-1,
		-1,
		-1,
		-1,
		237,
		257,
		-1,
		249,
		241,
		231,
		225,
		219,
		215,
		213,
		229,
		213,
		216,
		214,
		205,
		213,
		186,
		179,
		186,
		175,
		193,
		201,
		193,
		187,
		186,
		196,
		-1,
		324,
		310,
		281,
		-1,
		-1,
		270,
		-1,
		234,
		248,
		264,
		-1,
		257,
		236,
		251,
		229,
		225,
		221,
		236,
		237,
		214,
		214,
		212,
		203,
		191,
		180,
		183,
		175,
		197,
		197,
		181,
		182,
		186,
		-1,
		330,
		317,
		275,
		271,
		260,
		280,
		231,
		219,
		251,
		-1,
		-1,
		293,
		-1,
		227,
		244,
		235,
		233,
		226,
		208,
		215,
		223,
		200,
		195,
		185,
		174,
		174,
		169,
		191,
		177,
		175,
		184,
		200,
		-1,
		-1,
		-1,
		297,
		-1,
		-1,
		246,
		233,
		227,
		-1,
		268,
		-1,
		271,
		261,
		245,
		230,
		263,
		-1,
		207,
		203,
		210,
		-1,
		220,
		-1,
		193,
		190,
		181,
		166,
		163,
		174,
		172,
		183,
		179,
		-1,
		280,
		265,
		258,
		248,
		262,
		233,
		-1,
		288,
		-1,
		-1,
		258,
		252,
		252,
		236,
		237,
		223,
		203,
		195,
		210,
		209,
		196,
		195,
		179,
		172,
		169,
		162,
		175,
		185,
		190,
		177,
		-1,
		-1,
		-1,
		285,
		271,
		275,
		235,
		254,
		-1,
		-1,
		320,
		275,
		261,
		-1,
		232,
		223,
		211,
		201,
		191,
		196,
		197,
		187,
		185,
		177,
		179,
		173,
		164,
		163,
		179,
		171,
		193,
		-1,
		-1,
		268,
		273,
		261,
		247,
		266,
		-1,
		-1,
		-1,
		267,
		283,
		251,
		230,
		212,
		-1,
		-1,
		195,
		188,
		182,
		185,
		173,
		193,
		188,
		172,
		157,
		172,
		176,
		184,
		175,
		-1,
		271,
		258,
		-1,
		-1,
		269,
		263,
		-1,
		-1,
		-1,
		-1,
		263,
		208,
		197,
		192,
		196,
		194,
		-1,
		168,
		179,
		172,
		191,
		198,
		174,
		159,
		153,
		159,
		171,
		180,
		-1,
		-1,
		283,
		-1,
		256,
		-1,
		-1,
		-1,
		-1,
		220,
		214,
		185,
		178,
		182,
		-1,
		170,
		172,
		169,
		181,
		177,
		174,
		165,
		156,
		152,
		156,
		160,
		174,
		178,
		306,
		-1,
		247,
		-1,
		-1,
		-1,
		238,
		253,
		224,
		201,
		174,
		169,
		162,
		156,
		161,
		172,
		181,
		192,
		157,
		159,
		149,
		148,
		152,
		169,
		173,
		-1,
		-1,
		245,
		241,
		264,
		246,
		250,
		251,
		-1,
		-1,
		178,
		169,
		160,
		152,
		165,
		168,
		153,
		155,
		155,
		153,
		147,
		157,
		172,
		167,
		-1,
		-1,
		-1,
		257,
		-1,
		259,
		-1,
		-1,
		248,
		249,
		196,
		178,
		174,
		172,
		161,
		155,
		143,
		148,
		158,
		152,
		149,
		143,
		147,
		170,
		159,
		198,
		-1,
		-1,
		316,
		-1,
		-1,
		-1,
		237,
		228,
		223,
		230,
		232,
		223,
		211,
		208,
		-1,
		178,
		184,
		149,
		156,
		139,
		146,
		151,
		148,
		137,
		144,
		160,
		159,
		154,
		190,
		181,
		187,
		-1,
		-1,
		309,
		298,
		287,
		293,
		-1,
		230,
		225,
		216,
		206,
		209,
		-1,
		-1,
		203,
		200,
		180,
		149,
		147,
		140,
		135,
		145,
		121,
		133,
		137,
		141,
		147,
		152,
		157,
		163,
		178,
		193,
		-1,
		263,
		300,
		293,
		261,
		269,
		300,
		-1,
		220,
		212,
		222,
		198,
		200,
		-1,
		-1,
		176,
		167,
		168,
		156,
		153,
		159,
		158,
		141,
		147,
		148,
		140,
		139,
		157,
		161,
		170,
		177,
		167,
		180,
		184,
		-1,
		256,
		276,
		255,
		258,
		282,
		296,
		-1,
		217,
		-1,
		-1,
		182,
		201,
		185,
		175,
		172,
		215,
		170,
		165,
		146,
		144,
		139,
		130,
		155,
		148,
		148,
		151,
		166,
		171,
		163,
		177,
		177,
		178,
		-1,
		245,
		256,
		249,
		-1,
		-1,
		-1,
		-1,
		218,
		-1,
		-1,
		172,
		-1,
		212,
		-1,
		195,
		199,
		178,
		181,
		160,
		147,
		133,
		141,
		147,
		146,
		152,
		152,
		153,
		162,
		173,
		185,
		184,
		185,
		270,
		226,
		229,
		240,
		251,
		266,
		270,
		-1,
		229,
		268,
		178,
		-1,
		162,
		-1,
		-1,
		-1,
		209,
		191,
		183,
		180,
		159,
		159,
		125,
		129,
		142,
		149,
		159,
		170,
		162,
		166,
		179,
		190,
		193,
		266,
		257,
		270,
		215,
		215,
		236,
		245,
		266,
		230,
		227,
		262,
		185,
		174,
		169,
		156,
		-1,
		-1,
		193,
		201,
		-1,
		-1,
		166,
		133,
		121,
		131,
		135,
		149,
		161,
		174,
		162,
		167,
		161,
		193,
		-1,
		259,
		258,
		247,
		244,
		220,
		211,
		206,
		233,
		-1,
		-1,
		228,
		255,
		239,
		218,
		216,
		241,
		-1,
		145,
		-1,
		-1,
		173,
		-1,
		-1,
		158,
		138,
		127,
		118,
		123,
		143,
		154,
		176,
		158,
		175,
		166,
		176,
		180,
		243,
		240,
		228,
		226,
		249,
		214,
		202,
		-1,
		210,
		213,
		219,
		226,
		219,
		230,
		-1,
		-1,
		161,
		141,
		-1,
		-1,
		156,
		154,
		143,
		-1,
		133,
		115,
		120,
		150,
		152,
		154,
		161,
		155,
		162,
		170,
		181,
		173,
		252,
		266,
		255,
		251,
		250,
		258,
		207,
		200,
		207,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		166,
		-1,
		151,
		147,
		-1,
		-1,
		151,
		144,
		132,
		120,
		110,
		120,
		137,
		137,
		140,
		145,
		153,
		164,
		160,
		164,
		167,
		-1,
		286,
		-1,
		238,
		199,
		205,
		220,
		228,
		-1,
		-1,
		-1,
		168,
		154,
		147,
		135,
		133,
		-1,
		185,
		169,
		150,
		-1,
		120,
		133,
		173,
		141,
		146,
		141,
		156,
		167,
		158,
		166,
		160,
		163,
		-1,
		-1,
		198,
		181,
		-1,
		-1,
		155,
		157,
		-1,
		159,
		148,
		133,
		125,
		-1,
		-1,
		157,
		153,
		-1,
		-1,
		107,
		145,
		144,
		152,
		147,
		152,
		164,
		160,
		156,
		166,
		157,
		-1,
		-1,
		176,
		168,
		162,
		-1,
		140,
		-1,
		161,
		-1,
		128,
		134,
		122,
		-1,
		-1,
		-1,
		138,
		101,
		117,
		140,
		166,
		164,
		155,
		148,
		155,
		158,
		151,
		157,
		-1,
		-1,
		-1,
		158,
		132,
		168,
		159,
		142,
		122,
		114,
		133,
		-1,
		119,
		-1,
		94,
		97,
		122,
		161,
		163,
		149,
		145,
		158,
		152,
		149,
		147,
		164,
		-1,
		134,
		167,
		131,
		128,
		104,
		108,
		133,
		-1,
		116,
		98,
		-1,
		126,
		116,
		164,
		139,
		148,
		141,
		135,
		136,
		144,
		-1,
		-1,
		-1,
		136,
		135,
		127,
		121,
		121,
		109,
		100,
		-1,
		121,
		103,
		89,
		106,
		106,
		97,
		105,
		154,
		150,
		153,
		151,
		129,
		-1,
		122,
		-1,
		-1,
		159,
		-1,
		-1,
		-1,
		130,
		114,
		101,
		89,
		90,
		86,
		86,
		88,
		101,
		109,
		107,
		104,
		116,
		112,
		132,
		128,
		160,
		-1,
		117,
		-1,
		166,
		-1,
		-1,
		111,
		98,
		108,
		112,
		101,
		99,
		85,
		81,
		98,
		133,
		119,
		117,
		122,
		127,
		-1,
		106,
		105,
		-1,
		99,
		109,
		108,
		-1,
		89,
		-1,
		147,
		108,
		-1,
		82,
		76,
		-1,
		128,
		124,
		-1,
		-1,
		93,
		88,
		-1,
		-1,
		-1,
		88,
		92,
		142,
		126,
		-1,
		66,
		73,
		-1,
		-1,
		-1,
		78,
		79,
		-1,
		74,
		84,
		-1,
		88,
		79,
		87,
		61,
		67,
		-1,
		-1,
		-1,
		87,
		68,
		62,
		64,
		59,
		89,
		100,
		86,
		70,
		48,
		58,
		87,
		-1,
		-1,
		-1,
		59,
		51,
		44,
		-1,
		-1,
		95,
		78,
		59,
		57,
		-1,
		-1,
		-1,
		81,
		62,
		-1,
		-1,
		35,
		-1,
		-1,
		54,
		33,
		-1,
		-1,
		-1,
		-1,
		-1,
		96,
		70,
		-1,
		-1,
		-1,
		30,
		24,
		38,
		-1,
		-1,
		-1,
		-1,
		75,
		75,
		92,
		46,
		-1,
		-1,
		-1,
		20,
		27,
		-1,
		-1,
		78,
		76,
		-1,
		-1,
		-1,
		18,
		0,
		-1,
		38,
		-1,
		-1,
		-1,
		9,
		-1,
		-1,
		71,
		-1,
		-1,
		-1,
		23,
		-1,
		73,
		48,
		55,
		-1,
		-1,
		-1,
		-1,
		36,
		28,
		86,
		-1,
		58,
		60,
		-1,
		108,
		-1,
		-1,
		51,
		46,
		-1,
		-1,
		63,
		70,
		92,
		95,
		85,
		-1,
		82
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		299,
		288,
		299,
		307,
		280,
		287,
		-1,
		306,
		310,
		276,
		270,
		309,
		278,
		284,
		295,
		-1,
		-1,
		-1,
		299,
		298,
		266,
		264,
		273,
		278,
		285,
		-1,
		284,
		-1,
		320,
		299,
		310,
		315,
		259,
		256,
		276,
		295,
		277,
		269,
		335,
		289,
		260,
		254,
		272,
		262,
		271,
		263,
		-1,
		260,
		250,
		272,
		251,
		262,
		254,
		-1,
		-1,
		254,
		255,
		261,
		247,
		253,
		249,
		-1,
		259,
		243,
		-1,
		-1,
		244,
		245,
		229,
		232,
		240,
		238,
		251,
		243,
		238,
		-1,
		-1,
		235,
		231,
		238,
		225,
		221,
		238,
		251,
		233,
		247,
		246,
		-1,
		239,
		257,
		264,
		232,
		230,
		214,
		212,
		230,
		232,
		238,
		238,
		-1,
		248,
		249,
		244,
		252,
		254,
		230,
		217,
		217,
		227,
		220,
		239,
		227,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		248,
		231,
		248,
		240,
		230,
		245,
		238,
		220,
		217,
		215,
		212,
		228,
		226,
		236,
		-1,
		-1,
		341,
		310,
		339,
		297,
		278,
		-1,
		244,
		224,
		230,
		234,
		228,
		221,
		235,
		231,
		-1,
		206,
		205,
		233,
		219,
		230,
		301,
		-1,
		-1,
		299,
		291,
		274,
		277,
		254,
		250,
		239,
		238,
		230,
		216,
		212,
		218,
		221,
		221,
		227,
		200,
		210,
		214,
		212,
		237,
		-1,
		-1,
		272,
		-1,
		-1,
		298,
		281,
		-1,
		264,
		271,
		260,
		266,
		252,
		273,
		249,
		240,
		232,
		226,
		214,
		216,
		213,
		226,
		214,
		197,
		222,
		226,
		207,
		228,
		223,
		-1,
		271,
		255,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		276,
		257,
		260,
		266,
		290,
		289,
		-1,
		261,
		249,
		250,
		235,
		232,
		219,
		207,
		220,
		205,
		212,
		211,
		201,
		199,
		229,
		204,
		226,
		223,
		242,
		247,
		241,
		250,
		-1,
		306,
		302,
		298,
		305,
		254,
		-1,
		-1,
		294,
		-1,
		297,
		298,
		273,
		246,
		249,
		236,
		227,
		214,
		203,
		214,
		203,
		200,
		208,
		193,
		208,
		199,
		198,
		216,
		226,
		234,
		238,
		244,
		-1,
		356,
		-1,
		298,
		282,
		284,
		256,
		277,
		-1,
		314,
		298,
		290,
		275,
		275,
		-1,
		245,
		242,
		232,
		210,
		195,
		212,
		204,
		202,
		206,
		188,
		202,
		193,
		211,
		218,
		216,
		220,
		240,
		252,
		316,
		306,
		-1,
		288,
		293,
		252,
		260,
		279,
		317,
		281,
		-1,
		276,
		-1,
		247,
		260,
		-1,
		216,
		212,
		194,
		195,
		190,
		205,
		199,
		184,
		181,
		199,
		202,
		209,
		213,
		229,
		-1,
		-1,
		301,
		305,
		294,
		245,
		264,
		288,
		325,
		274,
		263,
		262,
		-1,
		253,
		230,
		227,
		215,
		202,
		187,
		188,
		196,
		209,
		188,
		183,
		180,
		200,
		226,
		204,
		216,
		-1,
		-1,
		-1,
		326,
		-1,
		-1,
		271,
		242,
		266,
		308,
		292,
		285,
		273,
		238,
		238,
		232,
		-1,
		226,
		205,
		196,
		185,
		183,
		196,
		193,
		198,
		178,
		176,
		195,
		207,
		198,
		215,
		-1,
		-1,
		-1,
		301,
		290,
		291,
		237,
		260,
		297,
		271,
		257,
		262,
		237,
		230,
		224,
		239,
		222,
		203,
		192,
		184,
		173,
		189,
		197,
		192,
		174,
		183,
		189,
		213,
		203,
		209,
		-1,
		-1,
		308,
		298,
		282,
		284,
		281,
		251,
		258,
		290,
		262,
		275,
		-1,
		229,
		-1,
		218,
		213,
		197,
		192,
		189,
		186,
		180,
		189,
		191,
		181,
		176,
		183,
		218,
		218,
		193,
		213,
		216,
		-1,
		-1,
		-1,
		301,
		296,
		271,
		248,
		232,
		268,
		-1,
		245,
		246,
		-1,
		223,
		217,
		214,
		199,
		195,
		190,
		194,
		187,
		194,
		187,
		185,
		186,
		168,
		200,
		-1,
		201,
		195,
		203,
		193,
		181,
		-1,
		-1,
		-1,
		294,
		273,
		266,
		286,
		227,
		279,
		-1,
		-1,
		230,
		223,
		-1,
		210,
		192,
		199,
		197,
		191,
		195,
		192,
		181,
		194,
		187,
		173,
		175,
		188,
		192,
		196,
		183,
		179,
		176,
		190,
		-1,
		313,
		-1,
		-1,
		-1,
		-1,
		-1,
		227,
		247,
		-1,
		239,
		231,
		221,
		215,
		209,
		205,
		203,
		219,
		203,
		206,
		204,
		195,
		203,
		176,
		169,
		176,
		165,
		183,
		191,
		183,
		177,
		176,
		186,
		-1,
		314,
		300,
		271,
		-1,
		-1,
		260,
		-1,
		224,
		238,
		254,
		-1,
		247,
		226,
		241,
		219,
		215,
		211,
		226,
		227,
		204,
		204,
		202,
		193,
		181,
		170,
		173,
		165,
		187,
		187,
		171,
		172,
		176,
		-1,
		320,
		307,
		265,
		261,
		250,
		270,
		221,
		209,
		241,
		-1,
		-1,
		283,
		-1,
		217,
		234,
		225,
		223,
		216,
		198,
		205,
		213,
		190,
		185,
		175,
		164,
		164,
		159,
		181,
		167,
		165,
		174,
		190,
		-1,
		-1,
		-1,
		287,
		-1,
		-1,
		236,
		223,
		217,
		-1,
		258,
		-1,
		261,
		251,
		235,
		220,
		253,
		-1,
		197,
		193,
		200,
		-1,
		210,
		-1,
		183,
		180,
		171,
		156,
		153,
		164,
		162,
		173,
		169,
		-1,
		270,
		255,
		248,
		238,
		252,
		223,
		-1,
		278,
		-1,
		-1,
		248,
		242,
		242,
		226,
		227,
		213,
		193,
		185,
		200,
		199,
		186,
		185,
		169,
		162,
		159,
		152,
		165,
		175,
		180,
		167,
		-1,
		-1,
		-1,
		275,
		261,
		265,
		225,
		244,
		-1,
		-1,
		310,
		265,
		251,
		-1,
		222,
		213,
		201,
		191,
		181,
		186,
		187,
		177,
		175,
		167,
		169,
		163,
		154,
		153,
		169,
		161,
		183,
		-1,
		-1,
		258,
		263,
		251,
		237,
		256,
		-1,
		-1,
		-1,
		257,
		273,
		241,
		220,
		202,
		-1,
		-1,
		185,
		178,
		172,
		175,
		163,
		183,
		178,
		162,
		147,
		162,
		166,
		174,
		165,
		-1,
		261,
		248,
		-1,
		-1,
		259,
		253,
		-1,
		-1,
		-1,
		-1,
		253,
		198,
		187,
		182,
		186,
		184,
		-1,
		158,
		169,
		162,
		181,
		188,
		164,
		149,
		143,
		149,
		161,
		170,
		-1,
		-1,
		273,
		-1,
		246,
		-1,
		-1,
		-1,
		-1,
		210,
		204,
		175,
		168,
		172,
		-1,
		160,
		162,
		159,
		171,
		167,
		164,
		155,
		146,
		142,
		146,
		150,
		164,
		168,
		296,
		-1,
		237,
		-1,
		-1,
		-1,
		228,
		243,
		214,
		191,
		164,
		159,
		152,
		146,
		151,
		162,
		171,
		182,
		147,
		149,
		139,
		138,
		142,
		159,
		163,
		-1,
		-1,
		235,
		231,
		254,
		236,
		240,
		241,
		-1,
		-1,
		168,
		159,
		150,
		142,
		155,
		158,
		143,
		145,
		145,
		143,
		137,
		147,
		162,
		157,
		-1,
		-1,
		-1,
		247,
		-1,
		249,
		-1,
		-1,
		238,
		239,
		186,
		168,
		164,
		162,
		151,
		145,
		133,
		138,
		148,
		142,
		139,
		133,
		137,
		160,
		149,
		188,
		-1,
		-1,
		309,
		-1,
		-1,
		-1,
		227,
		218,
		213,
		220,
		222,
		213,
		201,
		198,
		-1,
		168,
		174,
		139,
		146,
		129,
		136,
		141,
		138,
		127,
		134,
		150,
		149,
		144,
		180,
		171,
		177,
		-1,
		-1,
		302,
		291,
		280,
		286,
		-1,
		220,
		215,
		206,
		196,
		199,
		-1,
		-1,
		193,
		190,
		170,
		139,
		137,
		130,
		125,
		135,
		111,
		123,
		127,
		131,
		137,
		142,
		147,
		153,
		168,
		183,
		-1,
		256,
		293,
		286,
		254,
		262,
		293,
		-1,
		210,
		202,
		212,
		188,
		190,
		-1,
		-1,
		166,
		157,
		158,
		146,
		143,
		149,
		148,
		131,
		137,
		138,
		130,
		129,
		147,
		151,
		160,
		167,
		157,
		170,
		174,
		-1,
		249,
		269,
		248,
		251,
		275,
		289,
		-1,
		207,
		-1,
		-1,
		172,
		191,
		175,
		165,
		162,
		205,
		160,
		155,
		136,
		134,
		129,
		120,
		145,
		138,
		138,
		141,
		156,
		161,
		153,
		167,
		167,
		168,
		-1,
		238,
		249,
		242,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		-1,
		162,
		-1,
		202,
		-1,
		185,
		189,
		168,
		171,
		150,
		137,
		123,
		131,
		137,
		136,
		142,
		142,
		143,
		152,
		163,
		175,
		174,
		175,
		263,
		219,
		222,
		233,
		244,
		259,
		263,
		-1,
		219,
		258,
		168,
		-1,
		152,
		-1,
		-1,
		-1,
		199,
		181,
		173,
		170,
		149,
		149,
		115,
		119,
		132,
		139,
		149,
		160,
		152,
		156,
		169,
		180,
		183,
		259,
		250,
		263,
		208,
		208,
		229,
		238,
		259,
		223,
		220,
		252,
		175,
		164,
		159,
		146,
		-1,
		-1,
		183,
		191,
		-1,
		-1,
		156,
		123,
		111,
		121,
		125,
		139,
		151,
		164,
		152,
		157,
		151,
		183,
		-1,
		252,
		251,
		240,
		237,
		213,
		204,
		199,
		226,
		-1,
		-1,
		221,
		248,
		231,
		208,
		206,
		231,
		-1,
		135,
		-1,
		-1,
		163,
		-1,
		-1,
		148,
		128,
		117,
		108,
		113,
		133,
		144,
		166,
		148,
		165,
		156,
		166,
		170,
		236,
		233,
		221,
		219,
		242,
		207,
		195,
		-1,
		203,
		206,
		212,
		219,
		209,
		220,
		-1,
		-1,
		151,
		131,
		-1,
		-1,
		146,
		144,
		133,
		-1,
		123,
		105,
		110,
		140,
		142,
		144,
		151,
		145,
		152,
		160,
		171,
		163,
		245,
		259,
		248,
		244,
		243,
		251,
		200,
		193,
		200,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		-1,
		141,
		137,
		-1,
		-1,
		141,
		134,
		122,
		110,
		100,
		110,
		127,
		127,
		130,
		135,
		143,
		154,
		150,
		154,
		157,
		-1,
		279,
		-1,
		231,
		192,
		198,
		213,
		221,
		-1,
		-1,
		-1,
		158,
		144,
		137,
		125,
		123,
		-1,
		175,
		159,
		140,
		-1,
		110,
		123,
		163,
		131,
		136,
		131,
		146,
		157,
		148,
		156,
		150,
		153,
		-1,
		-1,
		191,
		174,
		-1,
		-1,
		148,
		150,
		-1,
		149,
		138,
		123,
		115,
		-1,
		-1,
		147,
		143,
		-1,
		-1,
		97,
		135,
		134,
		142,
		137,
		142,
		154,
		150,
		146,
		156,
		147,
		-1,
		-1,
		169,
		161,
		155,
		-1,
		133,
		-1,
		151,
		-1,
		118,
		124,
		112,
		-1,
		-1,
		-1,
		128,
		91,
		107,
		130,
		156,
		154,
		145,
		138,
		145,
		148,
		141,
		147,
		-1,
		-1,
		-1,
		151,
		125,
		158,
		149,
		132,
		112,
		104,
		123,
		-1,
		109,
		-1,
		84,
		87,
		112,
		151,
		153,
		139,
		135,
		148,
		142,
		139,
		137,
		157,
		-1,
		127,
		160,
		124,
		118,
		94,
		98,
		123,
		-1,
		106,
		88,
		-1,
		116,
		106,
		154,
		129,
		138,
		131,
		125,
		126,
		134,
		-1,
		-1,
		-1,
		129,
		128,
		120,
		114,
		114,
		99,
		90,
		-1,
		111,
		93,
		79,
		96,
		96,
		87,
		95,
		144,
		140,
		143,
		141,
		119,
		-1,
		124,
		-1,
		-1,
		152,
		-1,
		-1,
		-1,
		123,
		116,
		91,
		79,
		80,
		76,
		76,
		78,
		91,
		99,
		97,
		94,
		106,
		102,
		122,
		118,
		150,
		-1,
		119,
		-1,
		159,
		-1,
		-1,
		113,
		100,
		110,
		102,
		91,
		89,
		75,
		71,
		88,
		123,
		109,
		107,
		112,
		117,
		-1,
		108,
		107,
		-1,
		101,
		111,
		110,
		-1,
		91,
		-1,
		137,
		98,
		-1,
		72,
		66,
		-1,
		118,
		114,
		-1,
		-1,
		95,
		90,
		-1,
		-1,
		-1,
		90,
		82,
		132,
		116,
		-1,
		56,
		63,
		-1,
		-1,
		-1,
		80,
		81,
		-1,
		76,
		86,
		-1,
		78,
		69,
		77,
		51,
		57,
		-1,
		-1,
		-1,
		89,
		70,
		64,
		66,
		61,
		91,
		90,
		76,
		59,
		38,
		48,
		77,
		-1,
		-1,
		-1,
		61,
		53,
		46,
		-1,
		-1,
		85,
		68,
		49,
		47,
		-1,
		-1,
		-1,
		83,
		64,
		-1,
		-1,
		38,
		-1,
		-1,
		42,
		23,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		72,
		-1,
		-1,
		-1,
		34,
		30,
		26,
		-1,
		-1,
		-1,
		-1,
		94,
		95,
		118,
		82,
		-1,
		-1,
		-1,
		26,
		15,
		-1,
		-1,
		97,
		95,
		-1,
		-1,
		-1,
		54,
		38,
		-1,
		0,
		-1,
		-1,
		-1,
		45,
		-1,
		-1,
		33,
		-1,
		-1,
		-1,
		59,
		-1,
		45,
		20,
		27,
		-1,
		-1,
		-1,
		-1,
		72,
		64,
		58,
		-1,
		30,
		32,
		-1,
		80,
		-1,
		-1,
		87,
		78,
		-1,
		-1,
		35,
		42,
		64,
		67,
		117,
		-1,
		54
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		317,
		306,
		317,
		325,
		298,
		305,
		-1,
		324,
		328,
		294,
		288,
		327,
		296,
		302,
		313,
		-1,
		-1,
		-1,
		317,
		316,
		284,
		282,
		291,
		296,
		303,
		-1,
		302,
		-1,
		338,
		317,
		328,
		333,
		277,
		274,
		294,
		313,
		295,
		287,
		353,
		307,
		278,
		272,
		290,
		280,
		289,
		281,
		-1,
		278,
		268,
		290,
		269,
		280,
		272,
		-1,
		-1,
		272,
		273,
		279,
		265,
		271,
		267,
		-1,
		277,
		261,
		-1,
		-1,
		262,
		263,
		247,
		250,
		258,
		256,
		269,
		261,
		256,
		-1,
		-1,
		253,
		249,
		256,
		243,
		239,
		256,
		269,
		251,
		265,
		264,
		-1,
		257,
		275,
		282,
		250,
		248,
		232,
		230,
		248,
		250,
		256,
		256,
		-1,
		266,
		267,
		262,
		270,
		272,
		248,
		235,
		235,
		245,
		238,
		257,
		245,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		266,
		249,
		266,
		258,
		248,
		263,
		256,
		238,
		235,
		233,
		230,
		246,
		244,
		254,
		-1,
		-1,
		359,
		328,
		357,
		315,
		296,
		-1,
		262,
		242,
		248,
		252,
		246,
		239,
		253,
		249,
		-1,
		224,
		223,
		251,
		237,
		248,
		319,
		-1,
		-1,
		317,
		309,
		292,
		295,
		272,
		268,
		257,
		256,
		248,
		234,
		230,
		236,
		239,
		239,
		245,
		218,
		228,
		232,
		230,
		255,
		-1,
		-1,
		290,
		-1,
		-1,
		316,
		299,
		-1,
		282,
		289,
		278,
		284,
		270,
		291,
		267,
		258,
		250,
		244,
		232,
		234,
		231,
		244,
		232,
		215,
		240,
		244,
		225,
		246,
		241,
		-1,
		289,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		275,
		278,
		284,
		308,
		307,
		-1,
		279,
		267,
		268,
		253,
		250,
		237,
		225,
		238,
		223,
		230,
		229,
		219,
		217,
		247,
		222,
		244,
		241,
		260,
		265,
		259,
		268,
		-1,
		324,
		320,
		316,
		323,
		272,
		-1,
		-1,
		312,
		-1,
		315,
		316,
		291,
		264,
		267,
		254,
		245,
		232,
		221,
		232,
		221,
		218,
		226,
		211,
		226,
		217,
		216,
		234,
		244,
		252,
		256,
		262,
		-1,
		374,
		-1,
		316,
		300,
		302,
		274,
		295,
		-1,
		332,
		316,
		308,
		293,
		293,
		-1,
		263,
		260,
		250,
		228,
		213,
		230,
		222,
		220,
		224,
		206,
		220,
		211,
		229,
		236,
		234,
		238,
		258,
		270,
		334,
		324,
		-1,
		306,
		311,
		270,
		278,
		297,
		335,
		299,
		-1,
		294,
		-1,
		265,
		278,
		-1,
		234,
		230,
		212,
		213,
		208,
		223,
		217,
		202,
		199,
		217,
		220,
		227,
		231,
		247,
		-1,
		-1,
		319,
		323,
		312,
		263,
		282,
		306,
		343,
		292,
		281,
		280,
		-1,
		271,
		248,
		245,
		233,
		220,
		205,
		206,
		214,
		227,
		206,
		201,
		198,
		218,
		244,
		222,
		234,
		-1,
		-1,
		-1,
		344,
		-1,
		-1,
		289,
		260,
		284,
		326,
		310,
		303,
		291,
		256,
		256,
		250,
		-1,
		244,
		223,
		214,
		203,
		201,
		214,
		211,
		216,
		196,
		194,
		213,
		225,
		216,
		233,
		-1,
		-1,
		-1,
		319,
		308,
		309,
		255,
		278,
		315,
		289,
		275,
		280,
		255,
		248,
		242,
		257,
		240,
		221,
		210,
		202,
		191,
		207,
		215,
		210,
		192,
		201,
		207,
		231,
		221,
		227,
		-1,
		-1,
		326,
		316,
		300,
		302,
		299,
		269,
		276,
		308,
		280,
		293,
		-1,
		247,
		-1,
		236,
		231,
		215,
		210,
		207,
		204,
		198,
		207,
		209,
		199,
		194,
		201,
		236,
		236,
		211,
		231,
		234,
		-1,
		-1,
		-1,
		319,
		314,
		289,
		266,
		250,
		286,
		-1,
		263,
		264,
		-1,
		241,
		235,
		232,
		217,
		213,
		208,
		212,
		205,
		212,
		205,
		203,
		204,
		186,
		218,
		-1,
		219,
		213,
		221,
		211,
		199,
		-1,
		-1,
		-1,
		312,
		291,
		284,
		304,
		245,
		297,
		-1,
		-1,
		248,
		241,
		-1,
		228,
		210,
		217,
		215,
		209,
		213,
		210,
		199,
		212,
		205,
		191,
		193,
		206,
		210,
		214,
		201,
		197,
		194,
		208,
		-1,
		331,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		265,
		-1,
		257,
		249,
		239,
		233,
		227,
		223,
		221,
		237,
		221,
		224,
		222,
		213,
		221,
		194,
		187,
		194,
		183,
		201,
		209,
		201,
		195,
		194,
		204,
		-1,
		332,
		318,
		289,
		-1,
		-1,
		278,
		-1,
		242,
		256,
		272,
		-1,
		265,
		244,
		259,
		237,
		233,
		229,
		244,
		245,
		222,
		222,
		220,
		211,
		199,
		188,
		191,
		183,
		205,
		205,
		189,
		190,
		194,
		-1,
		338,
		325,
		283,
		279,
		268,
		288,
		239,
		227,
		259,
		-1,
		-1,
		301,
		-1,
		235,
		252,
		243,
		241,
		234,
		216,
		223,
		231,
		208,
		203,
		193,
		182,
		182,
		177,
		199,
		185,
		183,
		192,
		208,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		254,
		241,
		235,
		-1,
		276,
		-1,
		279,
		269,
		253,
		238,
		271,
		-1,
		215,
		211,
		218,
		-1,
		228,
		-1,
		201,
		198,
		189,
		174,
		171,
		182,
		180,
		191,
		187,
		-1,
		288,
		273,
		266,
		256,
		270,
		241,
		-1,
		296,
		-1,
		-1,
		266,
		260,
		260,
		244,
		245,
		231,
		211,
		203,
		218,
		217,
		204,
		203,
		187,
		180,
		177,
		170,
		183,
		193,
		198,
		185,
		-1,
		-1,
		-1,
		293,
		279,
		283,
		243,
		262,
		-1,
		-1,
		328,
		283,
		269,
		-1,
		240,
		231,
		219,
		209,
		199,
		204,
		205,
		195,
		193,
		185,
		187,
		181,
		172,
		171,
		187,
		179,
		201,
		-1,
		-1,
		276,
		281,
		269,
		255,
		274,
		-1,
		-1,
		-1,
		275,
		291,
		259,
		238,
		220,
		-1,
		-1,
		203,
		196,
		190,
		193,
		181,
		201,
		196,
		180,
		165,
		180,
		184,
		192,
		183,
		-1,
		279,
		266,
		-1,
		-1,
		277,
		271,
		-1,
		-1,
		-1,
		-1,
		271,
		216,
		205,
		200,
		204,
		202,
		-1,
		176,
		187,
		180,
		199,
		206,
		182,
		167,
		161,
		167,
		179,
		188,
		-1,
		-1,
		291,
		-1,
		264,
		-1,
		-1,
		-1,
		-1,
		228,
		222,
		193,
		186,
		190,
		-1,
		178,
		180,
		177,
		189,
		185,
		182,
		173,
		164,
		160,
		164,
		168,
		182,
		186,
		314,
		-1,
		255,
		-1,
		-1,
		-1,
		246,
		261,
		232,
		209,
		182,
		177,
		170,
		164,
		169,
		180,
		189,
		200,
		165,
		167,
		157,
		156,
		160,
		177,
		181,
		-1,
		-1,
		253,
		249,
		272,
		254,
		258,
		259,
		-1,
		-1,
		186,
		177,
		168,
		160,
		173,
		176,
		161,
		163,
		163,
		161,
		155,
		165,
		180,
		175,
		-1,
		-1,
		-1,
		265,
		-1,
		267,
		-1,
		-1,
		256,
		257,
		204,
		186,
		182,
		180,
		169,
		163,
		151,
		156,
		166,
		160,
		157,
		151,
		155,
		178,
		167,
		206,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		245,
		236,
		231,
		238,
		240,
		231,
		219,
		216,
		-1,
		186,
		192,
		157,
		164,
		147,
		154,
		159,
		156,
		145,
		152,
		168,
		167,
		162,
		198,
		189,
		195,
		-1,
		-1,
		317,
		306,
		295,
		301,
		-1,
		238,
		233,
		224,
		214,
		217,
		-1,
		-1,
		211,
		208,
		188,
		157,
		155,
		148,
		143,
		153,
		129,
		141,
		145,
		149,
		155,
		160,
		165,
		171,
		186,
		201,
		-1,
		271,
		308,
		301,
		269,
		277,
		308,
		-1,
		228,
		220,
		230,
		206,
		208,
		-1,
		-1,
		184,
		175,
		176,
		164,
		161,
		167,
		166,
		149,
		155,
		156,
		148,
		147,
		165,
		169,
		178,
		185,
		175,
		188,
		192,
		-1,
		264,
		284,
		263,
		266,
		290,
		304,
		-1,
		225,
		-1,
		-1,
		190,
		209,
		193,
		183,
		180,
		223,
		178,
		173,
		154,
		152,
		147,
		138,
		163,
		156,
		156,
		159,
		174,
		179,
		171,
		185,
		185,
		186,
		-1,
		253,
		264,
		257,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		180,
		-1,
		220,
		-1,
		203,
		207,
		186,
		189,
		168,
		155,
		141,
		149,
		155,
		154,
		160,
		160,
		161,
		170,
		181,
		193,
		192,
		193,
		278,
		234,
		237,
		248,
		259,
		274,
		278,
		-1,
		237,
		276,
		186,
		-1,
		170,
		-1,
		-1,
		-1,
		217,
		199,
		191,
		188,
		167,
		167,
		133,
		137,
		150,
		157,
		167,
		178,
		170,
		174,
		187,
		198,
		201,
		274,
		265,
		278,
		223,
		223,
		244,
		253,
		274,
		238,
		235,
		270,
		193,
		182,
		177,
		164,
		-1,
		-1,
		201,
		209,
		-1,
		-1,
		174,
		141,
		129,
		139,
		143,
		157,
		169,
		182,
		170,
		175,
		169,
		201,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		214,
		241,
		-1,
		-1,
		236,
		263,
		247,
		226,
		224,
		249,
		-1,
		153,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		146,
		135,
		126,
		131,
		151,
		162,
		184,
		166,
		183,
		174,
		184,
		188,
		251,
		248,
		236,
		234,
		257,
		222,
		210,
		-1,
		218,
		221,
		227,
		234,
		227,
		238,
		-1,
		-1,
		169,
		149,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		123,
		128,
		158,
		160,
		162,
		169,
		163,
		170,
		178,
		189,
		181,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		159,
		155,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		145,
		145,
		148,
		153,
		161,
		172,
		168,
		172,
		175,
		-1,
		294,
		-1,
		246,
		207,
		213,
		228,
		236,
		-1,
		-1,
		-1,
		176,
		162,
		155,
		143,
		141,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		181,
		149,
		154,
		149,
		164,
		175,
		166,
		174,
		168,
		171,
		-1,
		-1,
		206,
		189,
		-1,
		-1,
		163,
		165,
		-1,
		167,
		156,
		141,
		133,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		115,
		153,
		152,
		160,
		155,
		160,
		172,
		168,
		164,
		174,
		165,
		-1,
		-1,
		184,
		176,
		170,
		-1,
		148,
		-1,
		169,
		-1,
		136,
		142,
		130,
		-1,
		-1,
		-1,
		146,
		109,
		125,
		148,
		174,
		172,
		163,
		156,
		163,
		166,
		159,
		165,
		-1,
		-1,
		-1,
		166,
		140,
		176,
		167,
		150,
		130,
		122,
		141,
		-1,
		127,
		-1,
		102,
		105,
		130,
		169,
		171,
		157,
		153,
		166,
		160,
		157,
		155,
		172,
		-1,
		142,
		175,
		139,
		136,
		112,
		116,
		141,
		-1,
		124,
		106,
		-1,
		134,
		124,
		172,
		147,
		156,
		149,
		143,
		144,
		152,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		117,
		108,
		-1,
		129,
		111,
		97,
		114,
		114,
		105,
		113,
		162,
		158,
		161,
		159,
		137,
		-1,
		130,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		122,
		109,
		97,
		98,
		94,
		94,
		96,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		136,
		168,
		-1,
		125,
		-1,
		174,
		-1,
		-1,
		119,
		106,
		116,
		120,
		109,
		107,
		93,
		89,
		106,
		141,
		127,
		125,
		130,
		135,
		-1,
		114,
		113,
		-1,
		107,
		117,
		116,
		-1,
		97,
		-1,
		155,
		116,
		-1,
		90,
		84,
		-1,
		136,
		132,
		-1,
		-1,
		101,
		96,
		-1,
		-1,
		-1,
		96,
		100,
		150,
		134,
		-1,
		74,
		81,
		-1,
		-1,
		-1,
		86,
		87,
		-1,
		82,
		92,
		-1,
		96,
		87,
		95,
		69,
		75,
		-1,
		-1,
		-1,
		95,
		76,
		70,
		72,
		67,
		97,
		108,
		94,
		78,
		56,
		66,
		95,
		-1,
		-1,
		-1,
		67,
		59,
		52,
		-1,
		-1,
		103,
		86,
		67,
		65,
		-1,
		-1,
		-1,
		89,
		70,
		-1,
		-1,
		43,
		-1,
		-1,
		62,
		41,
		-1,
		-1,
		-1,
		-1,
		-1,
		100,
		75,
		-1,
		-1,
		-1,
		38,
		32,
		46,
		-1,
		-1,
		-1,
		-1,
		79,
		79,
		96,
		50,
		-1,
		-1,
		-1,
		28,
		35,
		-1,
		-1,
		82,
		80,
		-1,
		-1,
		-1,
		22,
		9,
		-1,
		46,
		-1,
		-1,
		-1,
		0,
		-1,
		-1,
		79,
		-1,
		-1,
		-1,
		14,
		-1,
		81,
		56,
		63,
		-1,
		-1,
		-1,
		-1,
		27,
		19,
		94,
		-1,
		66,
		68,
		-1,
		116,
		-1,
		-1,
		42,
		37,
		-1,
		-1,
		71,
		78,
		100,
		103,
		76,
		-1,
		90
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		332,
		321,
		332,
		340,
		313,
		320,
		-1,
		339,
		343,
		309,
		303,
		342,
		311,
		317,
		328,
		-1,
		-1,
		-1,
		332,
		331,
		299,
		297,
		306,
		311,
		318,
		-1,
		317,
		-1,
		353,
		332,
		343,
		348,
		292,
		289,
		309,
		328,
		310,
		302,
		368,
		322,
		293,
		287,
		305,
		295,
		304,
		296,
		-1,
		293,
		283,
		305,
		284,
		295,
		287,
		-1,
		-1,
		287,
		288,
		294,
		280,
		286,
		282,
		-1,
		292,
		276,
		-1,
		-1,
		277,
		278,
		262,
		265,
		273,
		271,
		284,
		276,
		271,
		-1,
		-1,
		268,
		264,
		271,
		258,
		254,
		271,
		284,
		266,
		280,
		279,
		-1,
		272,
		290,
		297,
		265,
		263,
		247,
		245,
		263,
		265,
		271,
		271,
		-1,
		281,
		282,
		277,
		285,
		287,
		263,
		250,
		250,
		260,
		253,
		272,
		260,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		281,
		264,
		281,
		273,
		263,
		278,
		271,
		253,
		250,
		248,
		245,
		261,
		259,
		269,
		-1,
		-1,
		374,
		343,
		372,
		330,
		311,
		-1,
		277,
		257,
		263,
		267,
		261,
		254,
		268,
		264,
		-1,
		239,
		238,
		266,
		252,
		263,
		334,
		-1,
		-1,
		332,
		324,
		307,
		310,
		287,
		283,
		272,
		271,
		263,
		249,
		245,
		251,
		254,
		254,
		260,
		233,
		243,
		247,
		245,
		270,
		-1,
		-1,
		305,
		-1,
		-1,
		331,
		314,
		-1,
		297,
		304,
		293,
		299,
		285,
		306,
		282,
		273,
		265,
		259,
		247,
		249,
		246,
		259,
		247,
		230,
		255,
		259,
		240,
		261,
		256,
		-1,
		304,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		290,
		293,
		299,
		323,
		322,
		-1,
		294,
		282,
		283,
		268,
		265,
		252,
		240,
		253,
		238,
		245,
		244,
		234,
		232,
		262,
		237,
		259,
		256,
		275,
		280,
		274,
		283,
		-1,
		339,
		335,
		331,
		338,
		287,
		-1,
		-1,
		327,
		-1,
		330,
		331,
		306,
		279,
		282,
		269,
		260,
		247,
		236,
		247,
		236,
		233,
		241,
		226,
		241,
		232,
		231,
		249,
		259,
		267,
		271,
		277,
		-1,
		389,
		-1,
		331,
		315,
		317,
		289,
		310,
		-1,
		347,
		331,
		323,
		308,
		308,
		-1,
		278,
		275,
		265,
		243,
		228,
		245,
		237,
		235,
		239,
		221,
		235,
		226,
		244,
		251,
		249,
		253,
		273,
		285,
		349,
		339,
		-1,
		321,
		326,
		285,
		293,
		312,
		350,
		314,
		-1,
		309,
		-1,
		280,
		293,
		-1,
		249,
		245,
		227,
		228,
		223,
		238,
		232,
		217,
		214,
		232,
		235,
		242,
		246,
		262,
		-1,
		-1,
		334,
		338,
		327,
		278,
		297,
		321,
		358,
		307,
		296,
		295,
		-1,
		286,
		263,
		260,
		248,
		235,
		220,
		221,
		229,
		242,
		221,
		216,
		213,
		233,
		259,
		237,
		249,
		-1,
		-1,
		-1,
		359,
		-1,
		-1,
		304,
		275,
		299,
		341,
		325,
		318,
		306,
		271,
		271,
		265,
		-1,
		259,
		238,
		229,
		218,
		216,
		229,
		226,
		231,
		211,
		209,
		228,
		240,
		231,
		248,
		-1,
		-1,
		-1,
		334,
		323,
		324,
		270,
		293,
		330,
		304,
		290,
		295,
		270,
		263,
		257,
		272,
		255,
		236,
		225,
		217,
		206,
		222,
		230,
		225,
		207,
		216,
		222,
		246,
		236,
		242,
		-1,
		-1,
		341,
		331,
		315,
		317,
		314,
		284,
		291,
		323,
		295,
		308,
		-1,
		262,
		-1,
		251,
		246,
		230,
		225,
		222,
		219,
		213,
		222,
		224,
		214,
		209,
		216,
		251,
		251,
		226,
		246,
		249,
		-1,
		-1,
		-1,
		334,
		329,
		304,
		281,
		265,
		301,
		-1,
		278,
		279,
		-1,
		256,
		250,
		247,
		232,
		228,
		223,
		227,
		220,
		227,
		220,
		218,
		219,
		201,
		233,
		-1,
		234,
		228,
		236,
		226,
		214,
		-1,
		-1,
		-1,
		327,
		306,
		299,
		319,
		260,
		312,
		-1,
		-1,
		263,
		256,
		-1,
		243,
		225,
		232,
		230,
		224,
		228,
		225,
		214,
		227,
		220,
		206,
		208,
		221,
		225,
		229,
		216,
		212,
		209,
		223,
		-1,
		346,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		280,
		-1,
		272,
		264,
		254,
		248,
		242,
		238,
		236,
		252,
		236,
		239,
		237,
		228,
		236,
		209,
		202,
		209,
		198,
		216,
		224,
		216,
		210,
		209,
		219,
		-1,
		347,
		333,
		304,
		-1,
		-1,
		293,
		-1,
		257,
		271,
		287,
		-1,
		280,
		259,
		274,
		252,
		248,
		244,
		259,
		260,
		237,
		237,
		235,
		226,
		214,
		203,
		206,
		198,
		220,
		220,
		204,
		205,
		209,
		-1,
		353,
		340,
		298,
		294,
		283,
		303,
		254,
		242,
		274,
		-1,
		-1,
		316,
		-1,
		250,
		267,
		258,
		256,
		249,
		231,
		238,
		246,
		223,
		218,
		208,
		197,
		197,
		192,
		214,
		200,
		198,
		207,
		223,
		-1,
		-1,
		-1,
		320,
		-1,
		-1,
		269,
		256,
		250,
		-1,
		291,
		-1,
		294,
		284,
		268,
		253,
		286,
		-1,
		230,
		226,
		233,
		-1,
		243,
		-1,
		216,
		213,
		204,
		189,
		186,
		197,
		195,
		206,
		202,
		-1,
		303,
		288,
		281,
		271,
		285,
		256,
		-1,
		311,
		-1,
		-1,
		281,
		275,
		275,
		259,
		260,
		246,
		226,
		218,
		233,
		232,
		219,
		218,
		202,
		195,
		192,
		185,
		198,
		208,
		213,
		200,
		-1,
		-1,
		-1,
		308,
		294,
		298,
		258,
		277,
		-1,
		-1,
		343,
		298,
		284,
		-1,
		255,
		246,
		234,
		224,
		214,
		219,
		220,
		210,
		208,
		200,
		202,
		196,
		187,
		186,
		202,
		194,
		216,
		-1,
		-1,
		291,
		296,
		284,
		270,
		289,
		-1,
		-1,
		-1,
		290,
		306,
		274,
		253,
		235,
		-1,
		-1,
		218,
		211,
		205,
		208,
		196,
		216,
		211,
		195,
		180,
		195,
		199,
		207,
		198,
		-1,
		294,
		281,
		-1,
		-1,
		292,
		286,
		-1,
		-1,
		-1,
		-1,
		286,
		231,
		220,
		215,
		219,
		217,
		-1,
		191,
		202,
		195,
		214,
		221,
		197,
		182,
		176,
		182,
		194,
		203,
		-1,
		-1,
		306,
		-1,
		279,
		-1,
		-1,
		-1,
		-1,
		243,
		237,
		208,
		201,
		205,
		-1,
		193,
		195,
		192,
		204,
		200,
		197,
		188,
		179,
		175,
		179,
		183,
		197,
		201,
		329,
		-1,
		270,
		-1,
		-1,
		-1,
		261,
		276,
		247,
		224,
		197,
		192,
		185,
		179,
		184,
		195,
		204,
		215,
		180,
		182,
		172,
		171,
		175,
		192,
		196,
		-1,
		-1,
		268,
		264,
		287,
		269,
		273,
		274,
		-1,
		-1,
		201,
		192,
		183,
		175,
		188,
		191,
		176,
		178,
		178,
		176,
		170,
		180,
		195,
		190,
		-1,
		-1,
		-1,
		280,
		-1,
		282,
		-1,
		-1,
		271,
		272,
		219,
		201,
		197,
		195,
		184,
		178,
		166,
		171,
		181,
		175,
		172,
		166,
		170,
		193,
		182,
		221,
		-1,
		-1,
		342,
		-1,
		-1,
		-1,
		260,
		251,
		246,
		253,
		255,
		246,
		234,
		231,
		-1,
		201,
		207,
		172,
		179,
		162,
		169,
		174,
		171,
		160,
		167,
		183,
		182,
		177,
		213,
		204,
		210,
		-1,
		-1,
		335,
		324,
		313,
		319,
		-1,
		253,
		248,
		239,
		229,
		232,
		-1,
		-1,
		226,
		223,
		203,
		172,
		170,
		163,
		158,
		168,
		144,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		289,
		326,
		319,
		287,
		295,
		326,
		-1,
		243,
		235,
		245,
		221,
		223,
		-1,
		-1,
		199,
		190,
		191,
		179,
		176,
		182,
		181,
		164,
		170,
		171,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		282,
		302,
		281,
		284,
		308,
		322,
		-1,
		240,
		-1,
		-1,
		205,
		224,
		208,
		198,
		195,
		238,
		193,
		188,
		169,
		167,
		162,
		153,
		178,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		271,
		282,
		275,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		195,
		-1,
		235,
		-1,
		218,
		222,
		201,
		204,
		183,
		170,
		156,
		164,
		170,
		169,
		175,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		296,
		252,
		255,
		266,
		277,
		292,
		296,
		-1,
		252,
		291,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		232,
		214,
		206,
		203,
		182,
		182,
		148,
		152,
		165,
		172,
		182,
		193,
		185,
		189,
		202,
		213,
		216,
		292,
		283,
		296,
		241,
		241,
		262,
		271,
		292,
		256,
		253,
		285,
		208,
		197,
		192,
		179,
		-1,
		-1,
		216,
		224,
		-1,
		-1,
		189,
		156,
		144,
		154,
		158,
		172,
		184,
		197,
		185,
		190,
		184,
		216,
		-1,
		285,
		284,
		273,
		270,
		246,
		237,
		232,
		259,
		-1,
		-1,
		254,
		281,
		264,
		241,
		239,
		264,
		-1,
		168,
		-1,
		-1,
		196,
		-1,
		-1,
		181,
		161,
		150,
		141,
		146,
		166,
		177,
		199,
		181,
		198,
		189,
		199,
		203,
		269,
		266,
		254,
		252,
		275,
		240,
		228,
		-1,
		236,
		239,
		245,
		252,
		242,
		253,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		179,
		177,
		166,
		-1,
		156,
		138,
		143,
		173,
		175,
		177,
		184,
		178,
		185,
		193,
		204,
		196,
		278,
		292,
		281,
		277,
		276,
		284,
		233,
		226,
		233,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		174,
		167,
		155,
		143,
		133,
		143,
		160,
		160,
		163,
		168,
		176,
		187,
		183,
		187,
		190,
		-1,
		312,
		-1,
		264,
		225,
		231,
		246,
		254,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		208,
		192,
		173,
		-1,
		143,
		156,
		196,
		164,
		169,
		164,
		179,
		190,
		181,
		189,
		183,
		186,
		-1,
		-1,
		224,
		207,
		-1,
		-1,
		181,
		183,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		180,
		176,
		-1,
		-1,
		130,
		168,
		167,
		175,
		170,
		175,
		187,
		183,
		179,
		189,
		180,
		-1,
		-1,
		202,
		194,
		188,
		-1,
		166,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		161,
		124,
		140,
		163,
		189,
		187,
		178,
		171,
		178,
		181,
		174,
		180,
		-1,
		-1,
		-1,
		184,
		158,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		142,
		-1,
		117,
		120,
		145,
		184,
		186,
		172,
		168,
		181,
		175,
		172,
		170,
		190,
		-1,
		160,
		193,
		157,
		151,
		127,
		131,
		156,
		-1,
		139,
		121,
		-1,
		149,
		139,
		187,
		162,
		171,
		164,
		158,
		159,
		167,
		-1,
		-1,
		-1,
		162,
		161,
		153,
		147,
		147,
		132,
		123,
		-1,
		144,
		126,
		112,
		129,
		129,
		120,
		128,
		177,
		173,
		176,
		174,
		152,
		-1,
		157,
		-1,
		-1,
		185,
		-1,
		-1,
		-1,
		156,
		149,
		124,
		112,
		113,
		109,
		109,
		111,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		151,
		183,
		-1,
		152,
		-1,
		192,
		-1,
		-1,
		146,
		133,
		143,
		135,
		124,
		122,
		108,
		104,
		121,
		156,
		142,
		140,
		145,
		150,
		-1,
		141,
		140,
		-1,
		134,
		144,
		143,
		-1,
		124,
		-1,
		170,
		131,
		-1,
		105,
		99,
		-1,
		151,
		147,
		-1,
		-1,
		128,
		123,
		-1,
		-1,
		-1,
		123,
		115,
		165,
		149,
		-1,
		89,
		96,
		-1,
		-1,
		-1,
		113,
		114,
		-1,
		109,
		119,
		-1,
		111,
		102,
		110,
		84,
		90,
		-1,
		-1,
		-1,
		122,
		103,
		97,
		99,
		94,
		124,
		123,
		109,
		92,
		71,
		81,
		110,
		-1,
		-1,
		-1,
		94,
		86,
		79,
		-1,
		-1,
		118,
		101,
		82,
		80,
		-1,
		-1,
		-1,
		116,
		97,
		-1,
		-1,
		71,
		-1,
		-1,
		75,
		56,
		-1,
		-1,
		-1,
		-1,
		-1,
		133,
		105,
		-1,
		-1,
		-1,
		67,
		63,
		59,
		-1,
		-1,
		-1,
		-1,
		127,
		128,
		151,
		115,
		-1,
		-1,
		-1,
		59,
		48,
		-1,
		-1,
		130,
		128,
		-1,
		-1,
		-1,
		87,
		71,
		-1,
		41,
		-1,
		-1,
		-1,
		78,
		-1,
		-1,
		0,
		-1,
		-1,
		-1,
		92,
		-1,
		63,
		38,
		45,
		-1,
		-1,
		-1,
		-1,
		105,
		97,
		76,
		-1,
		48,
		50,
		-1,
		98,
		-1,
		-1,
		120,
		111,
		-1,
		-1,
		53,
		60,
		82,
		85,
		150,
		-1,
		72
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		332,
		321,
		332,
		340,
		313,
		320,
		-1,
		339,
		343,
		309,
		303,
		342,
		311,
		317,
		328,
		-1,
		-1,
		-1,
		332,
		331,
		299,
		297,
		306,
		311,
		318,
		-1,
		317,
		-1,
		353,
		332,
		343,
		348,
		292,
		289,
		309,
		328,
		310,
		302,
		368,
		322,
		293,
		287,
		305,
		295,
		304,
		296,
		-1,
		293,
		283,
		305,
		284,
		295,
		287,
		-1,
		-1,
		287,
		288,
		294,
		280,
		286,
		282,
		-1,
		292,
		276,
		-1,
		-1,
		277,
		278,
		262,
		265,
		273,
		271,
		284,
		276,
		271,
		-1,
		-1,
		268,
		264,
		271,
		258,
		254,
		271,
		284,
		266,
		280,
		279,
		-1,
		272,
		290,
		297,
		265,
		263,
		247,
		245,
		263,
		265,
		271,
		271,
		-1,
		281,
		282,
		277,
		285,
		287,
		263,
		250,
		250,
		260,
		253,
		272,
		260,
		306,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		281,
		264,
		281,
		273,
		263,
		278,
		271,
		253,
		250,
		248,
		245,
		261,
		259,
		269,
		-1,
		-1,
		374,
		343,
		372,
		330,
		311,
		-1,
		277,
		257,
		263,
		267,
		261,
		254,
		268,
		264,
		-1,
		239,
		238,
		266,
		252,
		263,
		334,
		-1,
		-1,
		332,
		324,
		307,
		310,
		287,
		283,
		272,
		271,
		263,
		249,
		245,
		251,
		254,
		254,
		260,
		233,
		243,
		247,
		245,
		270,
		-1,
		-1,
		305,
		-1,
		-1,
		331,
		314,
		-1,
		297,
		304,
		293,
		299,
		285,
		306,
		282,
		273,
		265,
		259,
		247,
		249,
		246,
		259,
		247,
		230,
		255,
		259,
		240,
		261,
		256,
		-1,
		304,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		309,
		290,
		293,
		299,
		323,
		322,
		-1,
		294,
		282,
		283,
		268,
		265,
		252,
		240,
		253,
		238,
		245,
		244,
		234,
		232,
		262,
		237,
		259,
		256,
		275,
		280,
		274,
		283,
		-1,
		339,
		335,
		331,
		338,
		287,
		-1,
		-1,
		327,
		-1,
		330,
		331,
		306,
		279,
		282,
		269,
		260,
		247,
		236,
		247,
		236,
		233,
		241,
		226,
		241,
		232,
		231,
		249,
		259,
		267,
		271,
		277,
		-1,
		389,
		-1,
		331,
		315,
		317,
		289,
		310,
		-1,
		347,
		331,
		323,
		308,
		308,
		-1,
		278,
		275,
		265,
		243,
		228,
		245,
		237,
		235,
		239,
		221,
		235,
		226,
		244,
		251,
		249,
		253,
		273,
		285,
		349,
		339,
		-1,
		321,
		326,
		285,
		293,
		312,
		350,
		314,
		-1,
		309,
		-1,
		280,
		293,
		-1,
		249,
		245,
		227,
		228,
		223,
		238,
		232,
		217,
		214,
		232,
		235,
		242,
		246,
		262,
		-1,
		-1,
		334,
		338,
		327,
		278,
		297,
		321,
		358,
		307,
		296,
		295,
		-1,
		286,
		263,
		260,
		248,
		235,
		220,
		221,
		229,
		242,
		221,
		216,
		213,
		233,
		259,
		237,
		249,
		-1,
		-1,
		-1,
		359,
		-1,
		-1,
		304,
		275,
		299,
		341,
		325,
		318,
		306,
		271,
		271,
		265,
		-1,
		259,
		238,
		229,
		218,
		216,
		229,
		226,
		231,
		211,
		209,
		228,
		240,
		231,
		248,
		-1,
		-1,
		-1,
		334,
		323,
		324,
		270,
		293,
		330,
		304,
		290,
		295,
		270,
		263,
		257,
		272,
		255,
		236,
		225,
		217,
		206,
		222,
		230,
		225,
		207,
		216,
		222,
		246,
		236,
		242,
		-1,
		-1,
		341,
		331,
		315,
		317,
		314,
		284,
		291,
		323,
		295,
		308,
		-1,
		262,
		-1,
		251,
		246,
		230,
		225,
		222,
		219,
		213,
		222,
		224,
		214,
		209,
		216,
		251,
		251,
		226,
		246,
		249,
		-1,
		-1,
		-1,
		334,
		329,
		304,
		281,
		265,
		301,
		-1,
		278,
		279,
		-1,
		256,
		250,
		247,
		232,
		228,
		223,
		227,
		220,
		227,
		220,
		218,
		219,
		201,
		233,
		-1,
		234,
		228,
		236,
		226,
		214,
		-1,
		-1,
		-1,
		327,
		306,
		299,
		319,
		260,
		312,
		-1,
		-1,
		263,
		256,
		-1,
		243,
		225,
		232,
		230,
		224,
		228,
		225,
		214,
		227,
		220,
		206,
		208,
		221,
		225,
		229,
		216,
		212,
		209,
		223,
		-1,
		346,
		-1,
		-1,
		-1,
		-1,
		-1,
		260,
		280,
		-1,
		272,
		264,
		254,
		248,
		242,
		238,
		236,
		252,
		236,
		239,
		237,
		228,
		236,
		209,
		202,
		209,
		198,
		216,
		224,
		216,
		210,
		209,
		219,
		-1,
		347,
		333,
		304,
		-1,
		-1,
		293,
		-1,
		257,
		271,
		287,
		-1,
		280,
		259,
		274,
		252,
		248,
		244,
		259,
		260,
		237,
		237,
		235,
		226,
		214,
		203,
		206,
		198,
		220,
		220,
		204,
		205,
		209,
		-1,
		353,
		340,
		298,
		294,
		283,
		303,
		254,
		242,
		274,
		-1,
		-1,
		316,
		-1,
		250,
		267,
		258,
		256,
		249,
		231,
		238,
		246,
		223,
		218,
		208,
		197,
		197,
		192,
		214,
		200,
		198,
		207,
		223,
		-1,
		-1,
		-1,
		320,
		-1,
		-1,
		269,
		256,
		250,
		-1,
		291,
		-1,
		294,
		284,
		268,
		253,
		286,
		-1,
		230,
		226,
		233,
		-1,
		243,
		-1,
		216,
		213,
		204,
		189,
		186,
		197,
		195,
		206,
		202,
		-1,
		303,
		288,
		281,
		271,
		285,
		256,
		-1,
		311,
		-1,
		-1,
		281,
		275,
		275,
		259,
		260,
		246,
		226,
		218,
		233,
		232,
		219,
		218,
		202,
		195,
		192,
		185,
		198,
		208,
		213,
		200,
		-1,
		-1,
		-1,
		308,
		294,
		298,
		258,
		277,
		-1,
		-1,
		343,
		298,
		284,
		-1,
		255,
		246,
		234,
		224,
		214,
		219,
		220,
		210,
		208,
		200,
		202,
		196,
		187,
		186,
		202,
		194,
		216,
		-1,
		-1,
		291,
		296,
		284,
		270,
		289,
		-1,
		-1,
		-1,
		290,
		306,
		274,
		253,
		235,
		-1,
		-1,
		218,
		211,
		205,
		208,
		196,
		216,
		211,
		195,
		180,
		195,
		199,
		207,
		198,
		-1,
		294,
		281,
		-1,
		-1,
		292,
		286,
		-1,
		-1,
		-1,
		-1,
		286,
		231,
		220,
		215,
		219,
		217,
		-1,
		191,
		202,
		195,
		214,
		221,
		197,
		182,
		176,
		182,
		194,
		203,
		-1,
		-1,
		306,
		-1,
		279,
		-1,
		-1,
		-1,
		-1,
		243,
		237,
		208,
		201,
		205,
		-1,
		193,
		195,
		192,
		204,
		200,
		197,
		188,
		179,
		175,
		179,
		183,
		197,
		201,
		329,
		-1,
		270,
		-1,
		-1,
		-1,
		261,
		276,
		247,
		224,
		197,
		192,
		185,
		179,
		184,
		195,
		204,
		215,
		180,
		182,
		172,
		171,
		175,
		192,
		196,
		-1,
		-1,
		268,
		264,
		287,
		269,
		273,
		274,
		-1,
		-1,
		201,
		192,
		183,
		175,
		188,
		191,
		176,
		178,
		178,
		176,
		170,
		180,
		195,
		190,
		-1,
		-1,
		-1,
		280,
		-1,
		282,
		-1,
		-1,
		271,
		272,
		219,
		201,
		197,
		195,
		184,
		178,
		166,
		171,
		181,
		175,
		172,
		166,
		170,
		193,
		182,
		221,
		-1,
		-1,
		339,
		-1,
		-1,
		-1,
		260,
		251,
		246,
		253,
		255,
		246,
		234,
		231,
		-1,
		201,
		207,
		172,
		179,
		162,
		169,
		174,
		171,
		160,
		167,
		183,
		182,
		177,
		213,
		204,
		210,
		-1,
		-1,
		332,
		321,
		310,
		316,
		-1,
		253,
		248,
		239,
		229,
		232,
		-1,
		-1,
		226,
		223,
		203,
		172,
		170,
		163,
		158,
		168,
		144,
		156,
		160,
		164,
		170,
		175,
		180,
		186,
		201,
		216,
		-1,
		286,
		323,
		316,
		284,
		292,
		323,
		-1,
		243,
		235,
		245,
		221,
		223,
		-1,
		-1,
		199,
		190,
		191,
		179,
		176,
		182,
		181,
		164,
		170,
		171,
		163,
		162,
		180,
		184,
		193,
		200,
		190,
		203,
		207,
		-1,
		279,
		299,
		278,
		281,
		305,
		319,
		-1,
		240,
		-1,
		-1,
		205,
		224,
		208,
		198,
		195,
		238,
		193,
		188,
		169,
		167,
		162,
		153,
		178,
		171,
		171,
		174,
		189,
		194,
		186,
		200,
		200,
		201,
		-1,
		268,
		279,
		272,
		-1,
		-1,
		-1,
		-1,
		241,
		-1,
		-1,
		195,
		-1,
		235,
		-1,
		218,
		222,
		201,
		204,
		183,
		170,
		156,
		164,
		170,
		169,
		175,
		175,
		176,
		185,
		196,
		208,
		207,
		208,
		293,
		249,
		252,
		263,
		274,
		289,
		293,
		-1,
		252,
		291,
		201,
		-1,
		185,
		-1,
		-1,
		-1,
		232,
		214,
		206,
		203,
		182,
		182,
		148,
		152,
		165,
		172,
		182,
		193,
		185,
		189,
		202,
		213,
		216,
		289,
		280,
		293,
		238,
		238,
		259,
		268,
		289,
		253,
		250,
		285,
		208,
		197,
		192,
		179,
		-1,
		-1,
		216,
		224,
		-1,
		-1,
		189,
		156,
		144,
		154,
		158,
		172,
		184,
		197,
		185,
		190,
		184,
		216,
		-1,
		282,
		281,
		270,
		267,
		243,
		234,
		229,
		256,
		-1,
		-1,
		251,
		278,
		262,
		241,
		239,
		264,
		-1,
		168,
		-1,
		-1,
		196,
		-1,
		-1,
		181,
		161,
		150,
		141,
		146,
		166,
		177,
		199,
		181,
		198,
		189,
		199,
		203,
		266,
		263,
		251,
		249,
		272,
		237,
		225,
		-1,
		233,
		236,
		242,
		249,
		242,
		253,
		-1,
		-1,
		184,
		164,
		-1,
		-1,
		179,
		177,
		166,
		-1,
		156,
		138,
		143,
		173,
		175,
		177,
		184,
		178,
		185,
		193,
		204,
		196,
		275,
		289,
		278,
		274,
		273,
		281,
		230,
		223,
		230,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		189,
		-1,
		174,
		170,
		-1,
		-1,
		174,
		167,
		155,
		143,
		133,
		143,
		160,
		160,
		163,
		168,
		176,
		187,
		183,
		187,
		190,
		-1,
		309,
		-1,
		261,
		222,
		228,
		243,
		251,
		-1,
		-1,
		-1,
		191,
		177,
		170,
		158,
		156,
		-1,
		208,
		192,
		173,
		-1,
		143,
		156,
		196,
		164,
		169,
		164,
		179,
		190,
		181,
		189,
		183,
		186,
		-1,
		-1,
		221,
		204,
		-1,
		-1,
		178,
		180,
		-1,
		182,
		171,
		156,
		148,
		-1,
		-1,
		180,
		176,
		-1,
		-1,
		130,
		168,
		167,
		175,
		170,
		175,
		187,
		183,
		179,
		189,
		180,
		-1,
		-1,
		199,
		191,
		185,
		-1,
		163,
		-1,
		184,
		-1,
		151,
		157,
		145,
		-1,
		-1,
		-1,
		161,
		124,
		140,
		163,
		189,
		187,
		178,
		171,
		178,
		181,
		174,
		180,
		-1,
		-1,
		-1,
		181,
		155,
		191,
		182,
		165,
		145,
		137,
		156,
		-1,
		142,
		-1,
		117,
		120,
		145,
		184,
		186,
		172,
		168,
		181,
		175,
		172,
		170,
		187,
		-1,
		157,
		190,
		154,
		151,
		127,
		131,
		156,
		-1,
		139,
		121,
		-1,
		149,
		139,
		187,
		162,
		171,
		164,
		158,
		159,
		167,
		-1,
		-1,
		-1,
		159,
		158,
		150,
		144,
		144,
		132,
		123,
		-1,
		144,
		126,
		112,
		129,
		129,
		120,
		128,
		177,
		173,
		176,
		174,
		152,
		-1,
		145,
		-1,
		-1,
		182,
		-1,
		-1,
		-1,
		153,
		137,
		124,
		112,
		113,
		109,
		109,
		111,
		124,
		132,
		130,
		127,
		139,
		135,
		155,
		151,
		183,
		-1,
		140,
		-1,
		189,
		-1,
		-1,
		134,
		121,
		131,
		135,
		124,
		122,
		108,
		104,
		121,
		156,
		142,
		140,
		145,
		150,
		-1,
		129,
		128,
		-1,
		122,
		132,
		131,
		-1,
		112,
		-1,
		170,
		131,
		-1,
		105,
		99,
		-1,
		151,
		147,
		-1,
		-1,
		116,
		111,
		-1,
		-1,
		-1,
		111,
		115,
		165,
		149,
		-1,
		89,
		96,
		-1,
		-1,
		-1,
		101,
		102,
		-1,
		97,
		107,
		-1,
		111,
		102,
		110,
		84,
		90,
		-1,
		-1,
		-1,
		110,
		91,
		85,
		87,
		82,
		112,
		123,
		109,
		93,
		71,
		81,
		110,
		-1,
		-1,
		-1,
		82,
		74,
		67,
		-1,
		-1,
		118,
		101,
		82,
		80,
		-1,
		-1,
		-1,
		104,
		85,
		-1,
		-1,
		58,
		-1,
		-1,
		77,
		56,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		90,
		-1,
		-1,
		-1,
		53,
		47,
		61,
		-1,
		-1,
		-1,
		-1,
		94,
		94,
		111,
		65,
		-1,
		-1,
		-1,
		43,
		50,
		-1,
		-1,
		97,
		95,
		-1,
		-1,
		-1,
		37,
		24,
		-1,
		61,
		-1,
		-1,
		-1,
		15,
		-1,
		-1,
		94,
		-1,
		-1,
		-1,
		0,
		-1,
		96,
		71,
		78,
		-1,
		-1,
		-1,
		-1,
		13,
		5,
		109,
		-1,
		81,
		83,
		-1,
		112,
		-1,
		-1,
		28,
		23,
		-1,
		-1,
		86,
		93,
		96,
		99,
		62,
		-1,
		77
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		333,
		322,
		333,
		341,
		314,
		321,
		-1,
		340,
		344,
		310,
		304,
		343,
		312,
		318,
		329,
		-1,
		-1,
		-1,
		333,
		332,
		300,
		298,
		307,
		312,
		319,
		-1,
		318,
		-1,
		354,
		333,
		344,
		349,
		293,
		290,
		310,
		329,
		311,
		303,
		369,
		323,
		294,
		288,
		306,
		296,
		305,
		297,
		-1,
		294,
		284,
		306,
		285,
		296,
		288,
		-1,
		-1,
		288,
		289,
		295,
		281,
		287,
		283,
		-1,
		293,
		277,
		-1,
		-1,
		278,
		279,
		263,
		266,
		274,
		272,
		285,
		277,
		272,
		-1,
		-1,
		269,
		265,
		272,
		259,
		255,
		272,
		285,
		267,
		281,
		280,
		-1,
		273,
		291,
		298,
		266,
		264,
		248,
		246,
		264,
		266,
		272,
		272,
		-1,
		282,
		283,
		278,
		286,
		288,
		264,
		251,
		251,
		261,
		254,
		273,
		261,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		282,
		265,
		282,
		274,
		264,
		279,
		272,
		254,
		251,
		249,
		246,
		262,
		260,
		270,
		-1,
		-1,
		375,
		344,
		373,
		331,
		312,
		-1,
		278,
		258,
		264,
		268,
		262,
		255,
		269,
		265,
		-1,
		240,
		239,
		267,
		253,
		264,
		335,
		-1,
		-1,
		333,
		325,
		308,
		311,
		288,
		284,
		273,
		272,
		264,
		250,
		246,
		252,
		255,
		255,
		261,
		234,
		244,
		248,
		246,
		271,
		-1,
		-1,
		306,
		-1,
		-1,
		332,
		315,
		-1,
		298,
		305,
		294,
		300,
		286,
		307,
		283,
		274,
		266,
		260,
		248,
		250,
		247,
		260,
		248,
		231,
		256,
		260,
		241,
		262,
		257,
		-1,
		305,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		291,
		294,
		300,
		324,
		323,
		-1,
		295,
		283,
		284,
		269,
		266,
		253,
		241,
		254,
		239,
		246,
		245,
		235,
		233,
		263,
		238,
		260,
		257,
		276,
		281,
		275,
		284,
		-1,
		340,
		336,
		332,
		339,
		288,
		-1,
		-1,
		328,
		-1,
		331,
		332,
		307,
		280,
		283,
		270,
		261,
		248,
		237,
		248,
		237,
		234,
		242,
		227,
		242,
		233,
		232,
		250,
		260,
		268,
		272,
		278,
		-1,
		390,
		-1,
		332,
		316,
		318,
		290,
		311,
		-1,
		348,
		332,
		324,
		309,
		309,
		-1,
		279,
		276,
		266,
		244,
		229,
		246,
		238,
		236,
		240,
		222,
		236,
		227,
		245,
		252,
		250,
		254,
		274,
		286,
		350,
		340,
		-1,
		322,
		327,
		286,
		294,
		313,
		351,
		315,
		-1,
		310,
		-1,
		281,
		294,
		-1,
		250,
		246,
		228,
		229,
		224,
		239,
		233,
		218,
		215,
		233,
		236,
		243,
		247,
		263,
		-1,
		-1,
		335,
		339,
		328,
		279,
		298,
		322,
		359,
		308,
		297,
		296,
		-1,
		287,
		264,
		261,
		249,
		236,
		221,
		222,
		230,
		243,
		222,
		217,
		214,
		234,
		260,
		238,
		250,
		-1,
		-1,
		-1,
		360,
		-1,
		-1,
		305,
		276,
		300,
		342,
		326,
		319,
		307,
		272,
		272,
		266,
		-1,
		260,
		239,
		230,
		219,
		217,
		230,
		227,
		232,
		212,
		210,
		229,
		241,
		232,
		249,
		-1,
		-1,
		-1,
		335,
		324,
		325,
		271,
		294,
		331,
		305,
		291,
		296,
		271,
		264,
		258,
		273,
		256,
		237,
		226,
		218,
		207,
		223,
		231,
		226,
		208,
		217,
		223,
		247,
		237,
		243,
		-1,
		-1,
		342,
		332,
		316,
		318,
		315,
		285,
		292,
		324,
		296,
		309,
		-1,
		263,
		-1,
		252,
		247,
		231,
		226,
		223,
		220,
		214,
		223,
		225,
		215,
		210,
		217,
		252,
		252,
		227,
		247,
		250,
		-1,
		-1,
		-1,
		335,
		330,
		305,
		282,
		266,
		302,
		-1,
		279,
		280,
		-1,
		257,
		251,
		248,
		233,
		229,
		224,
		228,
		221,
		228,
		221,
		219,
		220,
		202,
		234,
		-1,
		235,
		229,
		237,
		227,
		215,
		-1,
		-1,
		-1,
		328,
		307,
		300,
		320,
		261,
		313,
		-1,
		-1,
		264,
		257,
		-1,
		244,
		226,
		233,
		231,
		225,
		229,
		226,
		215,
		228,
		221,
		207,
		209,
		222,
		226,
		230,
		217,
		213,
		210,
		224,
		-1,
		347,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		281,
		-1,
		273,
		265,
		255,
		249,
		243,
		239,
		237,
		253,
		237,
		240,
		238,
		229,
		237,
		210,
		203,
		210,
		199,
		217,
		225,
		217,
		211,
		210,
		220,
		-1,
		348,
		334,
		305,
		-1,
		-1,
		294,
		-1,
		258,
		272,
		288,
		-1,
		281,
		260,
		275,
		253,
		249,
		245,
		260,
		261,
		238,
		238,
		236,
		227,
		215,
		204,
		207,
		199,
		221,
		221,
		205,
		206,
		210,
		-1,
		354,
		341,
		299,
		295,
		284,
		304,
		255,
		243,
		275,
		-1,
		-1,
		317,
		-1,
		251,
		268,
		259,
		257,
		250,
		232,
		239,
		247,
		224,
		219,
		209,
		198,
		198,
		193,
		215,
		201,
		199,
		208,
		224,
		-1,
		-1,
		-1,
		321,
		-1,
		-1,
		270,
		257,
		251,
		-1,
		292,
		-1,
		295,
		285,
		269,
		254,
		287,
		-1,
		231,
		227,
		234,
		-1,
		244,
		-1,
		217,
		214,
		205,
		190,
		187,
		198,
		196,
		207,
		203,
		-1,
		304,
		289,
		282,
		272,
		286,
		257,
		-1,
		312,
		-1,
		-1,
		282,
		276,
		276,
		260,
		261,
		247,
		227,
		219,
		234,
		233,
		220,
		219,
		203,
		196,
		193,
		186,
		199,
		209,
		214,
		201,
		-1,
		-1,
		-1,
		309,
		295,
		299,
		259,
		278,
		-1,
		-1,
		344,
		299,
		285,
		-1,
		256,
		247,
		235,
		225,
		215,
		220,
		221,
		211,
		209,
		201,
		203,
		197,
		188,
		187,
		203,
		195,
		217,
		-1,
		-1,
		292,
		297,
		285,
		271,
		290,
		-1,
		-1,
		-1,
		291,
		307,
		275,
		254,
		236,
		-1,
		-1,
		219,
		212,
		206,
		209,
		197,
		217,
		212,
		196,
		181,
		196,
		200,
		208,
		199,
		-1,
		295,
		282,
		-1,
		-1,
		293,
		287,
		-1,
		-1,
		-1,
		-1,
		287,
		232,
		221,
		216,
		220,
		218,
		-1,
		192,
		203,
		196,
		215,
		222,
		198,
		183,
		177,
		183,
		195,
		204,
		-1,
		-1,
		307,
		-1,
		280,
		-1,
		-1,
		-1,
		-1,
		244,
		238,
		209,
		202,
		206,
		-1,
		194,
		196,
		193,
		205,
		201,
		198,
		189,
		180,
		176,
		180,
		184,
		198,
		202,
		330,
		-1,
		271,
		-1,
		-1,
		-1,
		262,
		277,
		248,
		225,
		198,
		193,
		186,
		180,
		185,
		196,
		205,
		216,
		181,
		183,
		173,
		172,
		176,
		193,
		197,
		-1,
		-1,
		269,
		265,
		288,
		270,
		274,
		275,
		-1,
		-1,
		202,
		193,
		184,
		176,
		189,
		192,
		177,
		179,
		179,
		177,
		171,
		181,
		196,
		191,
		-1,
		-1,
		-1,
		281,
		-1,
		283,
		-1,
		-1,
		272,
		273,
		220,
		202,
		198,
		196,
		185,
		179,
		167,
		172,
		182,
		176,
		173,
		167,
		171,
		194,
		183,
		222,
		-1,
		-1,
		343,
		-1,
		-1,
		-1,
		261,
		252,
		247,
		254,
		256,
		247,
		235,
		232,
		-1,
		202,
		208,
		173,
		180,
		163,
		170,
		175,
		172,
		161,
		168,
		184,
		183,
		178,
		214,
		205,
		211,
		-1,
		-1,
		336,
		325,
		314,
		320,
		-1,
		254,
		249,
		240,
		230,
		233,
		-1,
		-1,
		227,
		224,
		204,
		173,
		171,
		164,
		159,
		169,
		145,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		290,
		327,
		320,
		288,
		296,
		327,
		-1,
		244,
		236,
		246,
		222,
		224,
		-1,
		-1,
		200,
		191,
		192,
		180,
		177,
		183,
		182,
		165,
		171,
		172,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		283,
		303,
		282,
		285,
		309,
		323,
		-1,
		241,
		-1,
		-1,
		206,
		225,
		209,
		199,
		196,
		239,
		194,
		189,
		170,
		168,
		163,
		154,
		179,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		272,
		283,
		276,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		196,
		-1,
		236,
		-1,
		219,
		223,
		202,
		205,
		184,
		171,
		157,
		165,
		171,
		170,
		176,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		297,
		253,
		256,
		267,
		278,
		293,
		297,
		-1,
		253,
		292,
		202,
		-1,
		186,
		-1,
		-1,
		-1,
		233,
		215,
		207,
		204,
		183,
		183,
		149,
		153,
		166,
		173,
		183,
		194,
		186,
		190,
		203,
		214,
		217,
		293,
		284,
		297,
		242,
		242,
		263,
		272,
		293,
		257,
		254,
		286,
		209,
		198,
		193,
		180,
		-1,
		-1,
		217,
		225,
		-1,
		-1,
		190,
		157,
		145,
		155,
		159,
		173,
		185,
		198,
		186,
		191,
		185,
		217,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		260,
		-1,
		-1,
		255,
		282,
		265,
		242,
		240,
		265,
		-1,
		169,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		162,
		151,
		142,
		147,
		167,
		178,
		200,
		182,
		199,
		190,
		200,
		204,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		237,
		240,
		246,
		253,
		243,
		254,
		-1,
		-1,
		185,
		165,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		139,
		144,
		174,
		176,
		178,
		185,
		179,
		186,
		194,
		205,
		197,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		171,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		161,
		161,
		164,
		169,
		177,
		188,
		184,
		188,
		191,
		-1,
		313,
		-1,
		265,
		226,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		197,
		165,
		170,
		165,
		180,
		191,
		182,
		190,
		184,
		187,
		-1,
		-1,
		225,
		208,
		-1,
		-1,
		182,
		184,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		131,
		169,
		168,
		176,
		171,
		176,
		188,
		184,
		180,
		190,
		181,
		-1,
		-1,
		203,
		195,
		189,
		-1,
		167,
		-1,
		185,
		-1,
		152,
		158,
		146,
		-1,
		-1,
		-1,
		162,
		125,
		141,
		164,
		190,
		188,
		179,
		172,
		179,
		182,
		175,
		181,
		-1,
		-1,
		-1,
		185,
		159,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		143,
		-1,
		118,
		121,
		146,
		185,
		187,
		173,
		169,
		182,
		176,
		173,
		171,
		191,
		-1,
		161,
		194,
		158,
		152,
		128,
		132,
		157,
		-1,
		140,
		122,
		-1,
		150,
		140,
		188,
		163,
		172,
		165,
		159,
		160,
		168,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		145,
		127,
		113,
		130,
		130,
		121,
		129,
		178,
		174,
		177,
		175,
		153,
		-1,
		158,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		150,
		125,
		113,
		114,
		110,
		110,
		112,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		152,
		184,
		-1,
		153,
		-1,
		193,
		-1,
		-1,
		147,
		134,
		144,
		136,
		125,
		123,
		109,
		105,
		122,
		157,
		143,
		141,
		146,
		151,
		-1,
		142,
		141,
		-1,
		135,
		145,
		144,
		-1,
		125,
		-1,
		171,
		132,
		-1,
		106,
		100,
		-1,
		152,
		148,
		-1,
		-1,
		129,
		124,
		-1,
		-1,
		-1,
		124,
		116,
		166,
		150,
		-1,
		90,
		97,
		-1,
		-1,
		-1,
		114,
		115,
		-1,
		110,
		120,
		-1,
		112,
		103,
		111,
		85,
		91,
		-1,
		-1,
		-1,
		123,
		104,
		98,
		100,
		95,
		125,
		124,
		110,
		93,
		72,
		82,
		111,
		-1,
		-1,
		-1,
		95,
		87,
		80,
		-1,
		-1,
		119,
		102,
		83,
		81,
		-1,
		-1,
		-1,
		117,
		98,
		-1,
		-1,
		72,
		-1,
		-1,
		76,
		57,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		106,
		-1,
		-1,
		-1,
		68,
		64,
		60,
		-1,
		-1,
		-1,
		-1,
		128,
		129,
		152,
		116,
		-1,
		-1,
		-1,
		60,
		49,
		-1,
		-1,
		131,
		129,
		-1,
		-1,
		-1,
		88,
		72,
		-1,
		44,
		-1,
		-1,
		-1,
		79,
		-1,
		-1,
		64,
		-1,
		-1,
		-1,
		93,
		-1,
		0,
		26,
		29,
		-1,
		-1,
		-1,
		-1,
		106,
		98,
		13,
		-1,
		32,
		34,
		-1,
		82,
		-1,
		-1,
		121,
		112,
		-1,
		-1,
		37,
		44,
		66,
		69,
		151,
		-1,
		56
	],
	[
		-1,
		307,
		296,
		307,
		315,
		288,
		295,
		-1,
		314,
		318,
		284,
		278,
		317,
		286,
		292,
		303,
		-1,
		-1,
		-1,
		307,
		306,
		274,
		272,
		281,
		286,
		293,
		-1,
		292,
		-1,
		328,
		307,
		318,
		323,
		267,
		264,
		284,
		303,
		285,
		277,
		343,
		297,
		268,
		262,
		280,
		270,
		279,
		271,
		-1,
		268,
		258,
		280,
		259,
		270,
		262,
		-1,
		-1,
		262,
		263,
		269,
		255,
		261,
		257,
		-1,
		267,
		251,
		-1,
		-1,
		252,
		253,
		237,
		240,
		248,
		246,
		259,
		251,
		246,
		-1,
		-1,
		243,
		239,
		246,
		233,
		229,
		246,
		259,
		241,
		255,
		254,
		-1,
		247,
		265,
		272,
		240,
		238,
		222,
		220,
		238,
		240,
		246,
		246,
		-1,
		256,
		257,
		252,
		260,
		262,
		238,
		225,
		225,
		235,
		228,
		247,
		235,
		281,
		-1,
		-1,
		-1,
		-1,
		-1,
		290,
		256,
		239,
		256,
		248,
		238,
		253,
		246,
		228,
		225,
		223,
		220,
		236,
		234,
		244,
		-1,
		-1,
		349,
		318,
		347,
		305,
		286,
		-1,
		252,
		232,
		238,
		242,
		236,
		229,
		243,
		239,
		-1,
		214,
		213,
		241,
		227,
		238,
		309,
		-1,
		-1,
		307,
		299,
		282,
		285,
		262,
		258,
		247,
		246,
		238,
		224,
		220,
		226,
		229,
		229,
		235,
		208,
		218,
		222,
		220,
		245,
		-1,
		-1,
		280,
		-1,
		-1,
		306,
		289,
		-1,
		272,
		279,
		268,
		274,
		260,
		281,
		257,
		248,
		240,
		234,
		222,
		224,
		221,
		234,
		222,
		205,
		230,
		234,
		215,
		236,
		231,
		-1,
		279,
		263,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		265,
		268,
		274,
		298,
		297,
		-1,
		269,
		257,
		258,
		243,
		240,
		227,
		215,
		228,
		213,
		220,
		219,
		209,
		207,
		237,
		212,
		234,
		231,
		250,
		255,
		249,
		258,
		-1,
		314,
		310,
		306,
		313,
		262,
		-1,
		-1,
		302,
		-1,
		305,
		306,
		281,
		254,
		257,
		244,
		235,
		222,
		211,
		222,
		211,
		208,
		216,
		201,
		216,
		207,
		206,
		224,
		234,
		242,
		246,
		252,
		-1,
		364,
		-1,
		306,
		290,
		292,
		264,
		285,
		-1,
		322,
		306,
		298,
		283,
		283,
		-1,
		253,
		250,
		240,
		218,
		203,
		220,
		212,
		210,
		214,
		196,
		210,
		201,
		219,
		226,
		224,
		228,
		248,
		260,
		324,
		314,
		-1,
		296,
		301,
		260,
		268,
		287,
		325,
		289,
		-1,
		284,
		-1,
		255,
		268,
		-1,
		224,
		220,
		202,
		203,
		198,
		213,
		207,
		192,
		189,
		207,
		210,
		217,
		221,
		237,
		-1,
		-1,
		309,
		313,
		302,
		253,
		272,
		296,
		333,
		282,
		271,
		270,
		-1,
		261,
		238,
		235,
		223,
		210,
		195,
		196,
		204,
		217,
		196,
		191,
		188,
		208,
		234,
		212,
		224,
		-1,
		-1,
		-1,
		334,
		-1,
		-1,
		279,
		250,
		274,
		316,
		300,
		293,
		281,
		246,
		246,
		240,
		-1,
		234,
		213,
		204,
		193,
		191,
		204,
		201,
		206,
		186,
		184,
		203,
		215,
		206,
		223,
		-1,
		-1,
		-1,
		309,
		298,
		299,
		245,
		268,
		305,
		279,
		265,
		270,
		245,
		238,
		232,
		247,
		230,
		211,
		200,
		192,
		181,
		197,
		205,
		200,
		182,
		191,
		197,
		221,
		211,
		217,
		-1,
		-1,
		316,
		306,
		290,
		292,
		289,
		259,
		266,
		298,
		270,
		283,
		-1,
		237,
		-1,
		226,
		221,
		205,
		200,
		197,
		194,
		188,
		197,
		199,
		189,
		184,
		191,
		226,
		226,
		201,
		221,
		224,
		-1,
		-1,
		-1,
		309,
		304,
		279,
		256,
		240,
		276,
		-1,
		253,
		254,
		-1,
		231,
		225,
		222,
		207,
		203,
		198,
		202,
		195,
		202,
		195,
		193,
		194,
		176,
		208,
		-1,
		209,
		203,
		211,
		201,
		189,
		-1,
		-1,
		-1,
		302,
		281,
		274,
		294,
		235,
		287,
		-1,
		-1,
		238,
		231,
		-1,
		218,
		200,
		207,
		205,
		199,
		203,
		200,
		189,
		202,
		195,
		181,
		183,
		196,
		200,
		204,
		191,
		187,
		184,
		198,
		-1,
		321,
		-1,
		-1,
		-1,
		-1,
		-1,
		235,
		255,
		-1,
		247,
		239,
		229,
		223,
		217,
		213,
		211,
		227,
		211,
		214,
		212,
		203,
		211,
		184,
		177,
		184,
		173,
		191,
		199,
		191,
		185,
		184,
		194,
		-1,
		322,
		308,
		279,
		-1,
		-1,
		268,
		-1,
		232,
		246,
		262,
		-1,
		255,
		234,
		249,
		227,
		223,
		219,
		234,
		235,
		212,
		212,
		210,
		201,
		189,
		178,
		181,
		173,
		195,
		195,
		179,
		180,
		184,
		-1,
		328,
		315,
		273,
		269,
		258,
		278,
		229,
		217,
		249,
		-1,
		-1,
		291,
		-1,
		225,
		242,
		233,
		231,
		224,
		206,
		213,
		221,
		198,
		193,
		183,
		172,
		172,
		167,
		189,
		175,
		173,
		182,
		198,
		-1,
		-1,
		-1,
		295,
		-1,
		-1,
		244,
		231,
		225,
		-1,
		266,
		-1,
		269,
		259,
		243,
		228,
		261,
		-1,
		205,
		201,
		208,
		-1,
		218,
		-1,
		191,
		188,
		179,
		164,
		161,
		172,
		170,
		181,
		177,
		-1,
		278,
		263,
		256,
		246,
		260,
		231,
		-1,
		286,
		-1,
		-1,
		256,
		250,
		250,
		234,
		235,
		221,
		201,
		193,
		208,
		207,
		194,
		193,
		177,
		170,
		167,
		160,
		173,
		183,
		188,
		175,
		-1,
		-1,
		-1,
		283,
		269,
		273,
		233,
		252,
		-1,
		-1,
		318,
		273,
		259,
		-1,
		230,
		221,
		209,
		199,
		189,
		194,
		195,
		185,
		183,
		175,
		177,
		171,
		162,
		161,
		177,
		169,
		191,
		-1,
		-1,
		266,
		271,
		259,
		245,
		264,
		-1,
		-1,
		-1,
		265,
		281,
		249,
		228,
		210,
		-1,
		-1,
		193,
		186,
		180,
		183,
		171,
		191,
		186,
		170,
		155,
		170,
		174,
		182,
		173,
		-1,
		269,
		256,
		-1,
		-1,
		267,
		261,
		-1,
		-1,
		-1,
		-1,
		261,
		206,
		195,
		190,
		194,
		192,
		-1,
		166,
		177,
		170,
		189,
		196,
		172,
		157,
		151,
		157,
		169,
		178,
		-1,
		-1,
		281,
		-1,
		254,
		-1,
		-1,
		-1,
		-1,
		218,
		212,
		183,
		176,
		180,
		-1,
		168,
		170,
		167,
		179,
		175,
		172,
		163,
		154,
		150,
		154,
		158,
		172,
		176,
		304,
		-1,
		245,
		-1,
		-1,
		-1,
		236,
		251,
		222,
		199,
		172,
		167,
		160,
		154,
		159,
		170,
		179,
		190,
		155,
		157,
		147,
		146,
		150,
		167,
		171,
		-1,
		-1,
		243,
		239,
		262,
		244,
		248,
		249,
		-1,
		-1,
		176,
		167,
		158,
		150,
		163,
		166,
		151,
		153,
		153,
		151,
		145,
		155,
		170,
		165,
		-1,
		-1,
		-1,
		255,
		-1,
		257,
		-1,
		-1,
		246,
		247,
		194,
		176,
		172,
		170,
		159,
		153,
		141,
		146,
		156,
		150,
		147,
		141,
		145,
		168,
		157,
		196,
		-1,
		-1,
		317,
		-1,
		-1,
		-1,
		235,
		226,
		221,
		228,
		230,
		221,
		209,
		206,
		-1,
		176,
		182,
		147,
		154,
		137,
		144,
		149,
		146,
		135,
		142,
		158,
		157,
		152,
		188,
		179,
		185,
		-1,
		-1,
		310,
		299,
		288,
		294,
		-1,
		228,
		223,
		214,
		204,
		207,
		-1,
		-1,
		201,
		198,
		178,
		147,
		145,
		138,
		133,
		143,
		119,
		131,
		135,
		139,
		145,
		150,
		155,
		161,
		176,
		191,
		-1,
		264,
		301,
		294,
		262,
		270,
		301,
		-1,
		218,
		210,
		220,
		196,
		198,
		-1,
		-1,
		174,
		165,
		166,
		154,
		151,
		157,
		156,
		139,
		145,
		146,
		138,
		137,
		155,
		159,
		168,
		175,
		165,
		178,
		182,
		-1,
		257,
		277,
		256,
		259,
		283,
		297,
		-1,
		215,
		-1,
		-1,
		180,
		199,
		183,
		173,
		170,
		213,
		168,
		163,
		144,
		142,
		137,
		128,
		153,
		146,
		146,
		149,
		164,
		169,
		161,
		175,
		175,
		176,
		-1,
		246,
		257,
		250,
		-1,
		-1,
		-1,
		-1,
		216,
		-1,
		-1,
		170,
		-1,
		210,
		-1,
		193,
		197,
		176,
		179,
		158,
		145,
		131,
		139,
		145,
		144,
		150,
		150,
		151,
		160,
		171,
		183,
		182,
		183,
		271,
		227,
		230,
		241,
		252,
		267,
		271,
		-1,
		227,
		266,
		176,
		-1,
		160,
		-1,
		-1,
		-1,
		207,
		189,
		181,
		178,
		157,
		157,
		123,
		127,
		140,
		147,
		157,
		168,
		160,
		164,
		177,
		188,
		191,
		267,
		258,
		271,
		216,
		216,
		237,
		246,
		267,
		231,
		228,
		260,
		183,
		172,
		167,
		154,
		-1,
		-1,
		191,
		199,
		-1,
		-1,
		164,
		131,
		119,
		129,
		133,
		147,
		159,
		172,
		160,
		165,
		159,
		191,
		-1,
		260,
		259,
		248,
		245,
		221,
		212,
		207,
		234,
		-1,
		-1,
		229,
		256,
		239,
		216,
		214,
		239,
		-1,
		143,
		-1,
		-1,
		171,
		-1,
		-1,
		156,
		136,
		125,
		116,
		121,
		141,
		152,
		174,
		156,
		173,
		164,
		174,
		178,
		244,
		241,
		229,
		227,
		250,
		215,
		203,
		-1,
		211,
		214,
		220,
		227,
		217,
		228,
		-1,
		-1,
		159,
		139,
		-1,
		-1,
		154,
		152,
		141,
		-1,
		131,
		113,
		118,
		148,
		150,
		152,
		159,
		153,
		160,
		168,
		179,
		171,
		253,
		267,
		256,
		252,
		251,
		259,
		208,
		201,
		208,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		164,
		-1,
		149,
		145,
		-1,
		-1,
		149,
		142,
		130,
		118,
		108,
		118,
		135,
		135,
		138,
		143,
		151,
		162,
		158,
		162,
		165,
		-1,
		287,
		-1,
		239,
		200,
		206,
		221,
		229,
		-1,
		-1,
		-1,
		166,
		152,
		145,
		133,
		131,
		-1,
		183,
		167,
		148,
		-1,
		118,
		131,
		171,
		139,
		144,
		139,
		154,
		165,
		156,
		164,
		158,
		161,
		-1,
		-1,
		199,
		182,
		-1,
		-1,
		156,
		158,
		-1,
		157,
		146,
		131,
		123,
		-1,
		-1,
		155,
		151,
		-1,
		-1,
		105,
		143,
		142,
		150,
		145,
		150,
		162,
		158,
		154,
		164,
		155,
		-1,
		-1,
		177,
		169,
		163,
		-1,
		141,
		-1,
		159,
		-1,
		126,
		132,
		120,
		-1,
		-1,
		-1,
		136,
		99,
		115,
		138,
		164,
		162,
		153,
		146,
		153,
		156,
		149,
		155,
		-1,
		-1,
		-1,
		159,
		133,
		166,
		157,
		140,
		120,
		112,
		131,
		-1,
		117,
		-1,
		92,
		95,
		120,
		159,
		161,
		147,
		143,
		156,
		150,
		147,
		145,
		165,
		-1,
		135,
		168,
		132,
		126,
		102,
		106,
		131,
		-1,
		114,
		96,
		-1,
		124,
		114,
		162,
		137,
		146,
		139,
		133,
		134,
		142,
		-1,
		-1,
		-1,
		137,
		136,
		128,
		122,
		122,
		107,
		98,
		-1,
		119,
		101,
		87,
		104,
		104,
		95,
		103,
		152,
		148,
		151,
		149,
		127,
		-1,
		132,
		-1,
		-1,
		160,
		-1,
		-1,
		-1,
		131,
		124,
		99,
		87,
		88,
		84,
		84,
		86,
		99,
		107,
		105,
		102,
		114,
		110,
		130,
		126,
		158,
		-1,
		127,
		-1,
		167,
		-1,
		-1,
		121,
		108,
		118,
		110,
		99,
		97,
		83,
		79,
		96,
		131,
		117,
		115,
		120,
		125,
		-1,
		116,
		115,
		-1,
		109,
		119,
		118,
		-1,
		99,
		-1,
		145,
		106,
		-1,
		80,
		74,
		-1,
		126,
		122,
		-1,
		-1,
		103,
		98,
		-1,
		-1,
		-1,
		98,
		90,
		140,
		124,
		-1,
		64,
		71,
		-1,
		-1,
		-1,
		88,
		89,
		-1,
		84,
		94,
		-1,
		86,
		77,
		85,
		59,
		65,
		-1,
		-1,
		-1,
		97,
		78,
		72,
		74,
		69,
		99,
		98,
		84,
		67,
		46,
		56,
		85,
		-1,
		-1,
		-1,
		69,
		61,
		54,
		-1,
		-1,
		93,
		76,
		57,
		55,
		-1,
		-1,
		-1,
		91,
		72,
		-1,
		-1,
		46,
		-1,
		-1,
		50,
		31,
		-1,
		-1,
		-1,
		-1,
		-1,
		108,
		80,
		-1,
		-1,
		-1,
		42,
		38,
		34,
		-1,
		-1,
		-1,
		-1,
		102,
		103,
		126,
		90,
		-1,
		-1,
		-1,
		34,
		23,
		-1,
		-1,
		105,
		103,
		-1,
		-1,
		-1,
		62,
		46,
		-1,
		18,
		-1,
		-1,
		-1,
		53,
		-1,
		-1,
		38,
		-1,
		-1,
		-1,
		67,
		-1,
		25,
		0,
		7,
		-1,
		-1,
		-1,
		-1,
		80,
		72,
		38,
		-1,
		10,
		12,
		-1,
		60,
		-1,
		-1,
		95,
		86,
		-1,
		-1,
		15,
		22,
		44,
		47,
		125,
		-1,
		34
	],
	[
		-1,
		314,
		303,
		314,
		322,
		295,
		302,
		-1,
		321,
		325,
		291,
		285,
		324,
		293,
		299,
		310,
		-1,
		-1,
		-1,
		314,
		313,
		281,
		279,
		288,
		293,
		300,
		-1,
		299,
		-1,
		335,
		314,
		325,
		330,
		274,
		271,
		291,
		310,
		292,
		284,
		350,
		304,
		275,
		269,
		287,
		277,
		286,
		278,
		-1,
		275,
		265,
		287,
		266,
		277,
		269,
		-1,
		-1,
		269,
		270,
		276,
		262,
		268,
		264,
		-1,
		274,
		258,
		-1,
		-1,
		259,
		260,
		244,
		247,
		255,
		253,
		266,
		258,
		253,
		-1,
		-1,
		250,
		246,
		253,
		240,
		236,
		253,
		266,
		248,
		262,
		261,
		-1,
		254,
		272,
		279,
		247,
		245,
		229,
		227,
		245,
		247,
		253,
		253,
		-1,
		263,
		264,
		259,
		267,
		269,
		245,
		232,
		232,
		242,
		235,
		254,
		242,
		288,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		263,
		246,
		263,
		255,
		245,
		260,
		253,
		235,
		232,
		230,
		227,
		243,
		241,
		251,
		-1,
		-1,
		356,
		325,
		354,
		312,
		293,
		-1,
		259,
		239,
		245,
		249,
		243,
		236,
		250,
		246,
		-1,
		221,
		220,
		248,
		234,
		245,
		316,
		-1,
		-1,
		314,
		306,
		289,
		292,
		269,
		265,
		254,
		253,
		245,
		231,
		227,
		233,
		236,
		236,
		242,
		215,
		225,
		229,
		227,
		252,
		-1,
		-1,
		287,
		-1,
		-1,
		313,
		296,
		-1,
		279,
		286,
		275,
		281,
		267,
		288,
		264,
		255,
		247,
		241,
		229,
		231,
		228,
		241,
		229,
		212,
		237,
		241,
		222,
		243,
		238,
		-1,
		286,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		291,
		272,
		275,
		281,
		305,
		304,
		-1,
		276,
		264,
		265,
		250,
		247,
		234,
		222,
		235,
		220,
		227,
		226,
		216,
		214,
		244,
		219,
		241,
		238,
		257,
		262,
		256,
		265,
		-1,
		321,
		317,
		313,
		320,
		269,
		-1,
		-1,
		309,
		-1,
		312,
		313,
		288,
		261,
		264,
		251,
		242,
		229,
		218,
		229,
		218,
		215,
		223,
		208,
		223,
		214,
		213,
		231,
		241,
		249,
		253,
		259,
		-1,
		371,
		-1,
		313,
		297,
		299,
		271,
		292,
		-1,
		329,
		313,
		305,
		290,
		290,
		-1,
		260,
		257,
		247,
		225,
		210,
		227,
		219,
		217,
		221,
		203,
		217,
		208,
		226,
		233,
		231,
		235,
		255,
		267,
		331,
		321,
		-1,
		303,
		308,
		267,
		275,
		294,
		332,
		296,
		-1,
		291,
		-1,
		262,
		275,
		-1,
		231,
		227,
		209,
		210,
		205,
		220,
		214,
		199,
		196,
		214,
		217,
		224,
		228,
		244,
		-1,
		-1,
		316,
		320,
		309,
		260,
		279,
		303,
		340,
		289,
		278,
		277,
		-1,
		268,
		245,
		242,
		230,
		217,
		202,
		203,
		211,
		224,
		203,
		198,
		195,
		215,
		241,
		219,
		231,
		-1,
		-1,
		-1,
		341,
		-1,
		-1,
		286,
		257,
		281,
		323,
		307,
		300,
		288,
		253,
		253,
		247,
		-1,
		241,
		220,
		211,
		200,
		198,
		211,
		208,
		213,
		193,
		191,
		210,
		222,
		213,
		230,
		-1,
		-1,
		-1,
		316,
		305,
		306,
		252,
		275,
		312,
		286,
		272,
		277,
		252,
		245,
		239,
		254,
		237,
		218,
		207,
		199,
		188,
		204,
		212,
		207,
		189,
		198,
		204,
		228,
		218,
		224,
		-1,
		-1,
		323,
		313,
		297,
		299,
		296,
		266,
		273,
		305,
		277,
		290,
		-1,
		244,
		-1,
		233,
		228,
		212,
		207,
		204,
		201,
		195,
		204,
		206,
		196,
		191,
		198,
		233,
		233,
		208,
		228,
		231,
		-1,
		-1,
		-1,
		316,
		311,
		286,
		263,
		247,
		283,
		-1,
		260,
		261,
		-1,
		238,
		232,
		229,
		214,
		210,
		205,
		209,
		202,
		209,
		202,
		200,
		201,
		183,
		215,
		-1,
		216,
		210,
		218,
		208,
		196,
		-1,
		-1,
		-1,
		309,
		288,
		281,
		301,
		242,
		294,
		-1,
		-1,
		245,
		238,
		-1,
		225,
		207,
		214,
		212,
		206,
		210,
		207,
		196,
		209,
		202,
		188,
		190,
		203,
		207,
		211,
		198,
		194,
		191,
		205,
		-1,
		328,
		-1,
		-1,
		-1,
		-1,
		-1,
		242,
		262,
		-1,
		254,
		246,
		236,
		230,
		224,
		220,
		218,
		234,
		218,
		221,
		219,
		210,
		218,
		191,
		184,
		191,
		180,
		198,
		206,
		198,
		192,
		191,
		201,
		-1,
		329,
		315,
		286,
		-1,
		-1,
		275,
		-1,
		239,
		253,
		269,
		-1,
		262,
		241,
		256,
		234,
		230,
		226,
		241,
		242,
		219,
		219,
		217,
		208,
		196,
		185,
		188,
		180,
		202,
		202,
		186,
		187,
		191,
		-1,
		335,
		322,
		280,
		276,
		265,
		285,
		236,
		224,
		256,
		-1,
		-1,
		298,
		-1,
		232,
		249,
		240,
		238,
		231,
		213,
		220,
		228,
		205,
		200,
		190,
		179,
		179,
		174,
		196,
		182,
		180,
		189,
		205,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		251,
		238,
		232,
		-1,
		273,
		-1,
		276,
		266,
		250,
		235,
		268,
		-1,
		212,
		208,
		215,
		-1,
		225,
		-1,
		198,
		195,
		186,
		171,
		168,
		179,
		177,
		188,
		184,
		-1,
		285,
		270,
		263,
		253,
		267,
		238,
		-1,
		293,
		-1,
		-1,
		263,
		257,
		257,
		241,
		242,
		228,
		208,
		200,
		215,
		214,
		201,
		200,
		184,
		177,
		174,
		167,
		180,
		190,
		195,
		182,
		-1,
		-1,
		-1,
		290,
		276,
		280,
		240,
		259,
		-1,
		-1,
		325,
		280,
		266,
		-1,
		237,
		228,
		216,
		206,
		196,
		201,
		202,
		192,
		190,
		182,
		184,
		178,
		169,
		168,
		184,
		176,
		198,
		-1,
		-1,
		273,
		278,
		266,
		252,
		271,
		-1,
		-1,
		-1,
		272,
		288,
		256,
		235,
		217,
		-1,
		-1,
		200,
		193,
		187,
		190,
		178,
		198,
		193,
		177,
		162,
		177,
		181,
		189,
		180,
		-1,
		276,
		263,
		-1,
		-1,
		274,
		268,
		-1,
		-1,
		-1,
		-1,
		268,
		213,
		202,
		197,
		201,
		199,
		-1,
		173,
		184,
		177,
		196,
		203,
		179,
		164,
		158,
		164,
		176,
		185,
		-1,
		-1,
		288,
		-1,
		261,
		-1,
		-1,
		-1,
		-1,
		225,
		219,
		190,
		183,
		187,
		-1,
		175,
		177,
		174,
		186,
		182,
		179,
		170,
		161,
		157,
		161,
		165,
		179,
		183,
		311,
		-1,
		252,
		-1,
		-1,
		-1,
		243,
		258,
		229,
		206,
		179,
		174,
		167,
		161,
		166,
		177,
		186,
		197,
		162,
		164,
		154,
		153,
		157,
		174,
		178,
		-1,
		-1,
		250,
		246,
		269,
		251,
		255,
		256,
		-1,
		-1,
		183,
		174,
		165,
		157,
		170,
		173,
		158,
		160,
		160,
		158,
		152,
		162,
		177,
		172,
		-1,
		-1,
		-1,
		262,
		-1,
		264,
		-1,
		-1,
		253,
		254,
		201,
		183,
		179,
		177,
		166,
		160,
		148,
		153,
		163,
		157,
		154,
		148,
		152,
		175,
		164,
		203,
		-1,
		-1,
		324,
		-1,
		-1,
		-1,
		242,
		233,
		228,
		235,
		237,
		228,
		216,
		213,
		-1,
		183,
		189,
		154,
		161,
		144,
		151,
		156,
		153,
		142,
		149,
		165,
		164,
		159,
		195,
		186,
		192,
		-1,
		-1,
		317,
		306,
		295,
		301,
		-1,
		235,
		230,
		221,
		211,
		214,
		-1,
		-1,
		208,
		205,
		185,
		154,
		152,
		145,
		140,
		150,
		126,
		138,
		142,
		146,
		152,
		157,
		162,
		168,
		183,
		198,
		-1,
		271,
		308,
		301,
		269,
		277,
		308,
		-1,
		225,
		217,
		227,
		203,
		205,
		-1,
		-1,
		181,
		172,
		173,
		161,
		158,
		164,
		163,
		146,
		152,
		153,
		145,
		144,
		162,
		166,
		175,
		182,
		172,
		185,
		189,
		-1,
		264,
		284,
		263,
		266,
		290,
		304,
		-1,
		222,
		-1,
		-1,
		187,
		206,
		190,
		180,
		177,
		220,
		175,
		170,
		151,
		149,
		144,
		135,
		160,
		153,
		153,
		156,
		171,
		176,
		168,
		182,
		182,
		183,
		-1,
		253,
		264,
		257,
		-1,
		-1,
		-1,
		-1,
		223,
		-1,
		-1,
		177,
		-1,
		217,
		-1,
		200,
		204,
		183,
		186,
		165,
		152,
		138,
		146,
		152,
		151,
		157,
		157,
		158,
		167,
		178,
		190,
		189,
		190,
		278,
		234,
		237,
		248,
		259,
		274,
		278,
		-1,
		234,
		273,
		183,
		-1,
		167,
		-1,
		-1,
		-1,
		214,
		196,
		188,
		185,
		164,
		164,
		130,
		134,
		147,
		154,
		164,
		175,
		167,
		171,
		184,
		195,
		198,
		274,
		265,
		278,
		223,
		223,
		244,
		253,
		274,
		238,
		235,
		267,
		190,
		179,
		174,
		161,
		-1,
		-1,
		198,
		206,
		-1,
		-1,
		171,
		138,
		126,
		136,
		140,
		154,
		166,
		179,
		167,
		172,
		166,
		198,
		-1,
		267,
		266,
		255,
		252,
		228,
		219,
		214,
		241,
		-1,
		-1,
		236,
		263,
		246,
		223,
		221,
		246,
		-1,
		150,
		-1,
		-1,
		178,
		-1,
		-1,
		163,
		143,
		132,
		123,
		128,
		148,
		159,
		181,
		163,
		180,
		171,
		181,
		185,
		251,
		248,
		236,
		234,
		257,
		222,
		210,
		-1,
		218,
		221,
		227,
		234,
		224,
		235,
		-1,
		-1,
		166,
		146,
		-1,
		-1,
		161,
		159,
		148,
		-1,
		138,
		120,
		125,
		155,
		157,
		159,
		166,
		160,
		167,
		175,
		186,
		178,
		260,
		274,
		263,
		259,
		258,
		266,
		215,
		208,
		215,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		171,
		-1,
		156,
		152,
		-1,
		-1,
		156,
		149,
		137,
		125,
		115,
		125,
		142,
		142,
		145,
		150,
		158,
		169,
		165,
		169,
		172,
		-1,
		294,
		-1,
		246,
		207,
		213,
		228,
		236,
		-1,
		-1,
		-1,
		173,
		159,
		152,
		140,
		138,
		-1,
		190,
		174,
		155,
		-1,
		125,
		138,
		178,
		146,
		151,
		146,
		161,
		172,
		163,
		171,
		165,
		168,
		-1,
		-1,
		206,
		189,
		-1,
		-1,
		163,
		165,
		-1,
		164,
		153,
		138,
		130,
		-1,
		-1,
		162,
		158,
		-1,
		-1,
		112,
		150,
		149,
		157,
		152,
		157,
		169,
		165,
		161,
		171,
		162,
		-1,
		-1,
		184,
		176,
		170,
		-1,
		148,
		-1,
		166,
		-1,
		133,
		139,
		127,
		-1,
		-1,
		-1,
		143,
		106,
		122,
		145,
		171,
		169,
		160,
		153,
		160,
		163,
		156,
		162,
		-1,
		-1,
		-1,
		166,
		140,
		173,
		164,
		147,
		127,
		119,
		138,
		-1,
		124,
		-1,
		99,
		102,
		127,
		166,
		168,
		154,
		150,
		163,
		157,
		154,
		152,
		172,
		-1,
		142,
		175,
		139,
		133,
		109,
		113,
		138,
		-1,
		121,
		103,
		-1,
		131,
		121,
		169,
		144,
		153,
		146,
		140,
		141,
		149,
		-1,
		-1,
		-1,
		144,
		143,
		135,
		129,
		129,
		114,
		105,
		-1,
		126,
		108,
		94,
		111,
		111,
		102,
		110,
		159,
		155,
		158,
		156,
		134,
		-1,
		139,
		-1,
		-1,
		167,
		-1,
		-1,
		-1,
		138,
		131,
		106,
		94,
		95,
		91,
		91,
		93,
		106,
		114,
		112,
		109,
		121,
		117,
		137,
		133,
		165,
		-1,
		134,
		-1,
		174,
		-1,
		-1,
		128,
		115,
		125,
		117,
		106,
		104,
		90,
		86,
		103,
		138,
		124,
		122,
		127,
		132,
		-1,
		123,
		122,
		-1,
		116,
		126,
		125,
		-1,
		106,
		-1,
		152,
		113,
		-1,
		87,
		81,
		-1,
		133,
		129,
		-1,
		-1,
		110,
		105,
		-1,
		-1,
		-1,
		105,
		97,
		147,
		131,
		-1,
		71,
		78,
		-1,
		-1,
		-1,
		95,
		96,
		-1,
		91,
		101,
		-1,
		93,
		84,
		92,
		66,
		72,
		-1,
		-1,
		-1,
		104,
		85,
		79,
		81,
		76,
		106,
		105,
		91,
		74,
		53,
		63,
		92,
		-1,
		-1,
		-1,
		76,
		68,
		61,
		-1,
		-1,
		100,
		83,
		64,
		62,
		-1,
		-1,
		-1,
		98,
		79,
		-1,
		-1,
		53,
		-1,
		-1,
		57,
		38,
		-1,
		-1,
		-1,
		-1,
		-1,
		115,
		87,
		-1,
		-1,
		-1,
		49,
		45,
		41,
		-1,
		-1,
		-1,
		-1,
		109,
		110,
		133,
		97,
		-1,
		-1,
		-1,
		41,
		30,
		-1,
		-1,
		112,
		110,
		-1,
		-1,
		-1,
		69,
		53,
		-1,
		25,
		-1,
		-1,
		-1,
		60,
		-1,
		-1,
		45,
		-1,
		-1,
		-1,
		74,
		-1,
		29,
		8,
		0,
		-1,
		-1,
		-1,
		-1,
		87,
		79,
		42,
		-1,
		3,
		10,
		-1,
		58,
		-1,
		-1,
		102,
		91,
		-1,
		-1,
		13,
		20,
		42,
		45,
		132,
		-1,
		32
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		343,
		332,
		343,
		351,
		324,
		331,
		-1,
		350,
		354,
		320,
		314,
		353,
		322,
		328,
		339,
		-1,
		-1,
		-1,
		343,
		342,
		310,
		308,
		317,
		322,
		329,
		-1,
		328,
		-1,
		364,
		343,
		354,
		359,
		303,
		300,
		320,
		339,
		321,
		313,
		379,
		333,
		304,
		298,
		316,
		306,
		315,
		307,
		-1,
		304,
		294,
		316,
		295,
		306,
		298,
		-1,
		-1,
		298,
		299,
		305,
		291,
		297,
		293,
		-1,
		303,
		287,
		-1,
		-1,
		288,
		289,
		273,
		276,
		284,
		282,
		295,
		287,
		282,
		-1,
		-1,
		279,
		275,
		282,
		269,
		265,
		282,
		295,
		277,
		291,
		290,
		-1,
		283,
		301,
		308,
		276,
		274,
		258,
		256,
		274,
		276,
		282,
		282,
		-1,
		292,
		293,
		288,
		296,
		298,
		274,
		261,
		261,
		271,
		264,
		283,
		271,
		317,
		-1,
		-1,
		-1,
		-1,
		-1,
		326,
		292,
		275,
		292,
		284,
		274,
		289,
		282,
		264,
		261,
		259,
		256,
		272,
		270,
		280,
		-1,
		-1,
		385,
		354,
		383,
		341,
		322,
		-1,
		288,
		268,
		274,
		278,
		272,
		265,
		279,
		275,
		-1,
		250,
		249,
		277,
		263,
		274,
		345,
		-1,
		-1,
		343,
		335,
		318,
		321,
		298,
		294,
		283,
		282,
		274,
		260,
		256,
		262,
		265,
		265,
		271,
		244,
		254,
		258,
		256,
		281,
		-1,
		-1,
		316,
		-1,
		-1,
		342,
		325,
		-1,
		308,
		315,
		304,
		310,
		296,
		317,
		293,
		284,
		276,
		270,
		258,
		260,
		257,
		270,
		258,
		241,
		266,
		270,
		251,
		272,
		267,
		-1,
		315,
		299,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		301,
		304,
		310,
		334,
		333,
		-1,
		305,
		293,
		294,
		279,
		276,
		263,
		251,
		264,
		249,
		256,
		255,
		245,
		243,
		273,
		248,
		270,
		267,
		286,
		291,
		285,
		294,
		-1,
		350,
		346,
		342,
		349,
		298,
		-1,
		-1,
		338,
		-1,
		341,
		342,
		317,
		290,
		293,
		280,
		271,
		258,
		247,
		258,
		247,
		244,
		252,
		237,
		252,
		243,
		242,
		260,
		270,
		278,
		282,
		288,
		-1,
		400,
		-1,
		342,
		326,
		328,
		300,
		321,
		-1,
		358,
		342,
		334,
		319,
		319,
		-1,
		289,
		286,
		276,
		254,
		239,
		256,
		248,
		246,
		250,
		232,
		246,
		237,
		255,
		262,
		260,
		264,
		284,
		296,
		360,
		350,
		-1,
		332,
		337,
		296,
		304,
		323,
		361,
		325,
		-1,
		320,
		-1,
		291,
		304,
		-1,
		260,
		256,
		238,
		239,
		234,
		249,
		243,
		228,
		225,
		243,
		246,
		253,
		257,
		273,
		-1,
		-1,
		345,
		349,
		338,
		289,
		308,
		332,
		369,
		318,
		307,
		306,
		-1,
		297,
		274,
		271,
		259,
		246,
		231,
		232,
		240,
		253,
		232,
		227,
		224,
		244,
		270,
		248,
		260,
		-1,
		-1,
		-1,
		370,
		-1,
		-1,
		315,
		286,
		310,
		352,
		336,
		329,
		317,
		282,
		282,
		276,
		-1,
		270,
		249,
		240,
		229,
		227,
		240,
		237,
		242,
		222,
		220,
		239,
		251,
		242,
		259,
		-1,
		-1,
		-1,
		345,
		334,
		335,
		281,
		304,
		341,
		315,
		301,
		306,
		281,
		274,
		268,
		283,
		266,
		247,
		236,
		228,
		217,
		233,
		241,
		236,
		218,
		227,
		233,
		257,
		247,
		253,
		-1,
		-1,
		352,
		342,
		326,
		328,
		325,
		295,
		302,
		334,
		306,
		319,
		-1,
		273,
		-1,
		262,
		257,
		241,
		236,
		233,
		230,
		224,
		233,
		235,
		225,
		220,
		227,
		262,
		262,
		237,
		257,
		260,
		-1,
		-1,
		-1,
		345,
		340,
		315,
		292,
		276,
		312,
		-1,
		289,
		290,
		-1,
		267,
		261,
		258,
		243,
		239,
		234,
		238,
		231,
		238,
		231,
		229,
		230,
		212,
		244,
		-1,
		245,
		239,
		247,
		237,
		225,
		-1,
		-1,
		-1,
		338,
		317,
		310,
		330,
		271,
		323,
		-1,
		-1,
		274,
		267,
		-1,
		254,
		236,
		243,
		241,
		235,
		239,
		236,
		225,
		238,
		231,
		217,
		219,
		232,
		236,
		240,
		227,
		223,
		220,
		234,
		-1,
		357,
		-1,
		-1,
		-1,
		-1,
		-1,
		271,
		291,
		-1,
		283,
		275,
		265,
		259,
		253,
		249,
		247,
		263,
		247,
		250,
		248,
		239,
		247,
		220,
		213,
		220,
		209,
		227,
		235,
		227,
		221,
		220,
		230,
		-1,
		358,
		344,
		315,
		-1,
		-1,
		304,
		-1,
		268,
		282,
		298,
		-1,
		291,
		270,
		285,
		263,
		259,
		255,
		270,
		271,
		248,
		248,
		246,
		237,
		225,
		214,
		217,
		209,
		231,
		231,
		215,
		216,
		220,
		-1,
		364,
		351,
		309,
		305,
		294,
		314,
		265,
		253,
		285,
		-1,
		-1,
		327,
		-1,
		261,
		278,
		269,
		267,
		260,
		242,
		249,
		257,
		234,
		229,
		219,
		208,
		208,
		203,
		225,
		211,
		209,
		218,
		234,
		-1,
		-1,
		-1,
		331,
		-1,
		-1,
		280,
		267,
		261,
		-1,
		302,
		-1,
		305,
		295,
		279,
		264,
		297,
		-1,
		241,
		237,
		244,
		-1,
		254,
		-1,
		227,
		224,
		215,
		200,
		197,
		208,
		206,
		217,
		213,
		-1,
		314,
		299,
		292,
		282,
		296,
		267,
		-1,
		322,
		-1,
		-1,
		292,
		286,
		286,
		270,
		271,
		257,
		237,
		229,
		244,
		243,
		230,
		229,
		213,
		206,
		203,
		196,
		209,
		219,
		224,
		211,
		-1,
		-1,
		-1,
		319,
		305,
		309,
		269,
		288,
		-1,
		-1,
		354,
		309,
		295,
		-1,
		266,
		257,
		245,
		235,
		225,
		230,
		231,
		221,
		219,
		211,
		213,
		207,
		198,
		197,
		213,
		205,
		227,
		-1,
		-1,
		302,
		307,
		295,
		281,
		300,
		-1,
		-1,
		-1,
		301,
		317,
		285,
		264,
		246,
		-1,
		-1,
		229,
		222,
		216,
		219,
		207,
		227,
		222,
		206,
		191,
		206,
		210,
		218,
		209,
		-1,
		305,
		292,
		-1,
		-1,
		303,
		297,
		-1,
		-1,
		-1,
		-1,
		297,
		242,
		231,
		226,
		230,
		228,
		-1,
		202,
		213,
		206,
		225,
		232,
		208,
		193,
		187,
		193,
		205,
		214,
		-1,
		-1,
		317,
		-1,
		290,
		-1,
		-1,
		-1,
		-1,
		254,
		248,
		219,
		212,
		216,
		-1,
		204,
		206,
		203,
		215,
		211,
		208,
		199,
		190,
		186,
		190,
		194,
		208,
		212,
		340,
		-1,
		281,
		-1,
		-1,
		-1,
		272,
		287,
		258,
		235,
		208,
		203,
		196,
		190,
		195,
		206,
		215,
		226,
		191,
		193,
		183,
		182,
		186,
		203,
		207,
		-1,
		-1,
		279,
		275,
		298,
		280,
		284,
		285,
		-1,
		-1,
		212,
		203,
		194,
		186,
		199,
		202,
		187,
		189,
		189,
		187,
		181,
		191,
		206,
		201,
		-1,
		-1,
		-1,
		291,
		-1,
		293,
		-1,
		-1,
		282,
		283,
		230,
		212,
		208,
		206,
		195,
		189,
		177,
		182,
		192,
		186,
		183,
		177,
		181,
		204,
		193,
		232,
		-1,
		-1,
		350,
		-1,
		-1,
		-1,
		271,
		262,
		257,
		264,
		266,
		257,
		245,
		242,
		-1,
		212,
		218,
		183,
		190,
		173,
		180,
		185,
		182,
		171,
		178,
		194,
		193,
		188,
		224,
		215,
		221,
		-1,
		-1,
		343,
		332,
		321,
		327,
		-1,
		264,
		259,
		250,
		240,
		243,
		-1,
		-1,
		237,
		234,
		214,
		183,
		181,
		174,
		169,
		179,
		155,
		167,
		171,
		175,
		181,
		186,
		191,
		197,
		212,
		227,
		-1,
		297,
		334,
		327,
		295,
		303,
		334,
		-1,
		254,
		246,
		256,
		232,
		234,
		-1,
		-1,
		210,
		201,
		202,
		190,
		187,
		193,
		192,
		175,
		181,
		182,
		174,
		173,
		191,
		195,
		204,
		211,
		201,
		214,
		218,
		-1,
		290,
		310,
		289,
		292,
		316,
		330,
		-1,
		251,
		-1,
		-1,
		216,
		235,
		219,
		209,
		206,
		249,
		204,
		199,
		180,
		178,
		173,
		164,
		189,
		182,
		182,
		185,
		200,
		205,
		197,
		211,
		211,
		212,
		-1,
		279,
		290,
		283,
		-1,
		-1,
		-1,
		-1,
		252,
		-1,
		-1,
		206,
		-1,
		246,
		-1,
		229,
		233,
		212,
		215,
		194,
		181,
		167,
		175,
		181,
		180,
		186,
		186,
		187,
		196,
		207,
		219,
		218,
		219,
		304,
		260,
		263,
		274,
		285,
		300,
		304,
		-1,
		263,
		302,
		212,
		-1,
		196,
		-1,
		-1,
		-1,
		243,
		225,
		217,
		214,
		193,
		193,
		159,
		163,
		176,
		183,
		193,
		204,
		196,
		200,
		213,
		224,
		227,
		300,
		291,
		304,
		249,
		249,
		270,
		279,
		300,
		264,
		261,
		296,
		219,
		208,
		203,
		190,
		-1,
		-1,
		227,
		235,
		-1,
		-1,
		200,
		167,
		155,
		165,
		169,
		183,
		195,
		208,
		196,
		201,
		195,
		227,
		-1,
		293,
		292,
		281,
		278,
		254,
		245,
		240,
		267,
		-1,
		-1,
		262,
		289,
		273,
		252,
		250,
		275,
		-1,
		179,
		-1,
		-1,
		207,
		-1,
		-1,
		192,
		172,
		161,
		152,
		157,
		177,
		188,
		210,
		192,
		209,
		200,
		210,
		214,
		277,
		274,
		262,
		260,
		283,
		248,
		236,
		-1,
		244,
		247,
		253,
		260,
		253,
		264,
		-1,
		-1,
		195,
		175,
		-1,
		-1,
		190,
		188,
		177,
		-1,
		167,
		149,
		154,
		184,
		186,
		188,
		195,
		189,
		196,
		204,
		215,
		207,
		286,
		300,
		289,
		285,
		284,
		292,
		241,
		234,
		241,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		200,
		-1,
		185,
		181,
		-1,
		-1,
		185,
		178,
		166,
		154,
		144,
		154,
		171,
		171,
		174,
		179,
		187,
		198,
		194,
		198,
		201,
		-1,
		320,
		-1,
		272,
		233,
		239,
		254,
		262,
		-1,
		-1,
		-1,
		202,
		188,
		181,
		169,
		167,
		-1,
		219,
		203,
		184,
		-1,
		154,
		167,
		207,
		175,
		180,
		175,
		190,
		201,
		192,
		200,
		194,
		197,
		-1,
		-1,
		232,
		215,
		-1,
		-1,
		189,
		191,
		-1,
		193,
		182,
		167,
		159,
		-1,
		-1,
		191,
		187,
		-1,
		-1,
		141,
		179,
		178,
		186,
		181,
		186,
		198,
		194,
		190,
		200,
		191,
		-1,
		-1,
		210,
		202,
		196,
		-1,
		174,
		-1,
		195,
		-1,
		162,
		168,
		156,
		-1,
		-1,
		-1,
		172,
		135,
		151,
		174,
		200,
		198,
		189,
		182,
		189,
		192,
		185,
		191,
		-1,
		-1,
		-1,
		192,
		166,
		202,
		193,
		176,
		156,
		148,
		167,
		-1,
		153,
		-1,
		128,
		131,
		156,
		195,
		197,
		183,
		179,
		192,
		186,
		183,
		181,
		198,
		-1,
		168,
		201,
		165,
		162,
		138,
		142,
		167,
		-1,
		150,
		132,
		-1,
		160,
		150,
		198,
		173,
		182,
		175,
		169,
		170,
		178,
		-1,
		-1,
		-1,
		170,
		169,
		161,
		155,
		155,
		143,
		134,
		-1,
		155,
		137,
		123,
		140,
		140,
		131,
		139,
		188,
		184,
		187,
		185,
		163,
		-1,
		156,
		-1,
		-1,
		193,
		-1,
		-1,
		-1,
		164,
		148,
		135,
		123,
		124,
		120,
		120,
		122,
		135,
		143,
		141,
		138,
		150,
		146,
		166,
		162,
		194,
		-1,
		151,
		-1,
		200,
		-1,
		-1,
		145,
		132,
		142,
		146,
		135,
		133,
		119,
		115,
		132,
		167,
		153,
		151,
		156,
		161,
		-1,
		140,
		139,
		-1,
		133,
		143,
		142,
		-1,
		123,
		-1,
		181,
		142,
		-1,
		116,
		110,
		-1,
		162,
		158,
		-1,
		-1,
		127,
		122,
		-1,
		-1,
		-1,
		122,
		126,
		176,
		160,
		-1,
		100,
		107,
		-1,
		-1,
		-1,
		112,
		113,
		-1,
		108,
		118,
		-1,
		122,
		113,
		121,
		95,
		101,
		-1,
		-1,
		-1,
		121,
		102,
		96,
		98,
		93,
		123,
		134,
		120,
		104,
		82,
		92,
		121,
		-1,
		-1,
		-1,
		93,
		85,
		78,
		-1,
		-1,
		129,
		112,
		93,
		91,
		-1,
		-1,
		-1,
		115,
		96,
		-1,
		-1,
		69,
		-1,
		-1,
		88,
		67,
		-1,
		-1,
		-1,
		-1,
		-1,
		126,
		101,
		-1,
		-1,
		-1,
		64,
		58,
		72,
		-1,
		-1,
		-1,
		-1,
		105,
		105,
		122,
		76,
		-1,
		-1,
		-1,
		54,
		61,
		-1,
		-1,
		108,
		106,
		-1,
		-1,
		-1,
		48,
		35,
		-1,
		72,
		-1,
		-1,
		-1,
		26,
		-1,
		-1,
		105,
		-1,
		-1,
		-1,
		11,
		-1,
		107,
		82,
		89,
		-1,
		-1,
		-1,
		-1,
		0,
		7,
		120,
		-1,
		92,
		91,
		-1,
		105,
		-1,
		-1,
		21,
		16,
		-1,
		-1,
		88,
		92,
		89,
		92,
		55,
		-1,
		70
	],
	[
		-1,
		336,
		325,
		336,
		344,
		317,
		324,
		-1,
		343,
		347,
		313,
		307,
		346,
		315,
		321,
		332,
		-1,
		-1,
		-1,
		336,
		335,
		303,
		301,
		310,
		315,
		322,
		-1,
		321,
		-1,
		357,
		336,
		347,
		352,
		296,
		293,
		313,
		332,
		314,
		306,
		372,
		326,
		297,
		291,
		309,
		299,
		308,
		300,
		-1,
		297,
		287,
		309,
		288,
		299,
		291,
		-1,
		-1,
		291,
		292,
		298,
		284,
		290,
		286,
		-1,
		296,
		280,
		-1,
		-1,
		281,
		282,
		266,
		269,
		277,
		275,
		288,
		280,
		275,
		-1,
		-1,
		272,
		268,
		275,
		262,
		258,
		275,
		288,
		270,
		284,
		283,
		-1,
		276,
		294,
		301,
		269,
		267,
		251,
		249,
		267,
		269,
		275,
		275,
		-1,
		285,
		286,
		281,
		289,
		291,
		267,
		254,
		254,
		264,
		257,
		276,
		264,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		319,
		285,
		268,
		285,
		277,
		267,
		282,
		275,
		257,
		254,
		252,
		249,
		265,
		263,
		273,
		-1,
		-1,
		378,
		347,
		376,
		334,
		315,
		-1,
		281,
		261,
		267,
		271,
		265,
		258,
		272,
		268,
		-1,
		243,
		242,
		270,
		256,
		267,
		338,
		-1,
		-1,
		336,
		328,
		311,
		314,
		291,
		287,
		276,
		275,
		267,
		253,
		249,
		255,
		258,
		258,
		264,
		237,
		247,
		251,
		249,
		274,
		-1,
		-1,
		309,
		-1,
		-1,
		335,
		318,
		-1,
		301,
		308,
		297,
		303,
		289,
		310,
		286,
		277,
		269,
		263,
		251,
		253,
		250,
		263,
		251,
		234,
		259,
		263,
		244,
		265,
		260,
		-1,
		308,
		292,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		313,
		294,
		297,
		303,
		327,
		326,
		-1,
		298,
		286,
		287,
		272,
		269,
		256,
		244,
		257,
		242,
		249,
		248,
		238,
		236,
		266,
		241,
		263,
		260,
		279,
		284,
		278,
		287,
		-1,
		343,
		339,
		335,
		342,
		291,
		-1,
		-1,
		331,
		-1,
		334,
		335,
		310,
		283,
		286,
		273,
		264,
		251,
		240,
		251,
		240,
		237,
		245,
		230,
		245,
		236,
		235,
		253,
		263,
		271,
		275,
		281,
		-1,
		393,
		-1,
		335,
		319,
		321,
		293,
		314,
		-1,
		351,
		335,
		327,
		312,
		312,
		-1,
		282,
		279,
		269,
		247,
		232,
		249,
		241,
		239,
		243,
		225,
		239,
		230,
		248,
		255,
		253,
		257,
		277,
		289,
		353,
		343,
		-1,
		325,
		330,
		289,
		297,
		316,
		354,
		318,
		-1,
		313,
		-1,
		284,
		297,
		-1,
		253,
		249,
		231,
		232,
		227,
		242,
		236,
		221,
		218,
		236,
		239,
		246,
		250,
		266,
		-1,
		-1,
		338,
		342,
		331,
		282,
		301,
		325,
		362,
		311,
		300,
		299,
		-1,
		290,
		267,
		264,
		252,
		239,
		224,
		225,
		233,
		246,
		225,
		220,
		217,
		237,
		263,
		241,
		253,
		-1,
		-1,
		-1,
		363,
		-1,
		-1,
		308,
		279,
		303,
		345,
		329,
		322,
		310,
		275,
		275,
		269,
		-1,
		263,
		242,
		233,
		222,
		220,
		233,
		230,
		235,
		215,
		213,
		232,
		244,
		235,
		252,
		-1,
		-1,
		-1,
		338,
		327,
		328,
		274,
		297,
		334,
		308,
		294,
		299,
		274,
		267,
		261,
		276,
		259,
		240,
		229,
		221,
		210,
		226,
		234,
		229,
		211,
		220,
		226,
		250,
		240,
		246,
		-1,
		-1,
		345,
		335,
		319,
		321,
		318,
		288,
		295,
		327,
		299,
		312,
		-1,
		266,
		-1,
		255,
		250,
		234,
		229,
		226,
		223,
		217,
		226,
		228,
		218,
		213,
		220,
		255,
		255,
		230,
		250,
		253,
		-1,
		-1,
		-1,
		338,
		333,
		308,
		285,
		269,
		305,
		-1,
		282,
		283,
		-1,
		260,
		254,
		251,
		236,
		232,
		227,
		231,
		224,
		231,
		224,
		222,
		223,
		205,
		237,
		-1,
		238,
		232,
		240,
		230,
		218,
		-1,
		-1,
		-1,
		331,
		310,
		303,
		323,
		264,
		316,
		-1,
		-1,
		267,
		260,
		-1,
		247,
		229,
		236,
		234,
		228,
		232,
		229,
		218,
		231,
		224,
		210,
		212,
		225,
		229,
		233,
		220,
		216,
		213,
		227,
		-1,
		350,
		-1,
		-1,
		-1,
		-1,
		-1,
		264,
		284,
		-1,
		276,
		268,
		258,
		252,
		246,
		242,
		240,
		256,
		240,
		243,
		241,
		232,
		240,
		213,
		206,
		213,
		202,
		220,
		228,
		220,
		214,
		213,
		223,
		-1,
		351,
		337,
		308,
		-1,
		-1,
		297,
		-1,
		261,
		275,
		291,
		-1,
		284,
		263,
		278,
		256,
		252,
		248,
		263,
		264,
		241,
		241,
		239,
		230,
		218,
		207,
		210,
		202,
		224,
		224,
		208,
		209,
		213,
		-1,
		357,
		344,
		302,
		298,
		287,
		307,
		258,
		246,
		278,
		-1,
		-1,
		320,
		-1,
		254,
		271,
		262,
		260,
		253,
		235,
		242,
		250,
		227,
		222,
		212,
		201,
		201,
		196,
		218,
		204,
		202,
		211,
		227,
		-1,
		-1,
		-1,
		324,
		-1,
		-1,
		273,
		260,
		254,
		-1,
		295,
		-1,
		298,
		288,
		272,
		257,
		290,
		-1,
		234,
		230,
		237,
		-1,
		247,
		-1,
		220,
		217,
		208,
		193,
		190,
		201,
		199,
		210,
		206,
		-1,
		307,
		292,
		285,
		275,
		289,
		260,
		-1,
		315,
		-1,
		-1,
		285,
		279,
		279,
		263,
		264,
		250,
		230,
		222,
		237,
		236,
		223,
		222,
		206,
		199,
		196,
		189,
		202,
		212,
		217,
		204,
		-1,
		-1,
		-1,
		312,
		298,
		302,
		262,
		281,
		-1,
		-1,
		347,
		302,
		288,
		-1,
		259,
		250,
		238,
		228,
		218,
		223,
		224,
		214,
		212,
		204,
		206,
		200,
		191,
		190,
		206,
		198,
		220,
		-1,
		-1,
		295,
		300,
		288,
		274,
		293,
		-1,
		-1,
		-1,
		294,
		310,
		278,
		257,
		239,
		-1,
		-1,
		222,
		215,
		209,
		212,
		200,
		220,
		215,
		199,
		184,
		199,
		203,
		211,
		202,
		-1,
		298,
		285,
		-1,
		-1,
		296,
		290,
		-1,
		-1,
		-1,
		-1,
		290,
		235,
		224,
		219,
		223,
		221,
		-1,
		195,
		206,
		199,
		218,
		225,
		201,
		186,
		180,
		186,
		198,
		207,
		-1,
		-1,
		310,
		-1,
		283,
		-1,
		-1,
		-1,
		-1,
		247,
		241,
		212,
		205,
		209,
		-1,
		197,
		199,
		196,
		208,
		204,
		201,
		192,
		183,
		179,
		183,
		187,
		201,
		205,
		333,
		-1,
		274,
		-1,
		-1,
		-1,
		265,
		280,
		251,
		228,
		201,
		196,
		189,
		183,
		188,
		199,
		208,
		219,
		184,
		186,
		176,
		175,
		179,
		196,
		200,
		-1,
		-1,
		272,
		268,
		291,
		273,
		277,
		278,
		-1,
		-1,
		205,
		196,
		187,
		179,
		192,
		195,
		180,
		182,
		182,
		180,
		174,
		184,
		199,
		194,
		-1,
		-1,
		-1,
		284,
		-1,
		286,
		-1,
		-1,
		275,
		276,
		223,
		205,
		201,
		199,
		188,
		182,
		170,
		175,
		185,
		179,
		176,
		170,
		174,
		197,
		186,
		225,
		-1,
		-1,
		343,
		-1,
		-1,
		-1,
		264,
		255,
		250,
		257,
		259,
		250,
		238,
		235,
		-1,
		205,
		211,
		176,
		183,
		166,
		173,
		178,
		175,
		164,
		171,
		187,
		186,
		181,
		217,
		208,
		214,
		-1,
		-1,
		336,
		325,
		314,
		320,
		-1,
		257,
		252,
		243,
		233,
		236,
		-1,
		-1,
		230,
		227,
		207,
		176,
		174,
		167,
		162,
		172,
		148,
		160,
		164,
		168,
		174,
		179,
		184,
		190,
		205,
		220,
		-1,
		290,
		327,
		320,
		288,
		296,
		327,
		-1,
		247,
		239,
		249,
		225,
		227,
		-1,
		-1,
		203,
		194,
		195,
		183,
		180,
		186,
		185,
		168,
		174,
		175,
		167,
		166,
		184,
		188,
		197,
		204,
		194,
		207,
		211,
		-1,
		283,
		303,
		282,
		285,
		309,
		323,
		-1,
		244,
		-1,
		-1,
		209,
		228,
		212,
		202,
		199,
		242,
		197,
		192,
		173,
		171,
		166,
		157,
		182,
		175,
		175,
		178,
		193,
		198,
		190,
		204,
		204,
		205,
		-1,
		272,
		283,
		276,
		-1,
		-1,
		-1,
		-1,
		245,
		-1,
		-1,
		199,
		-1,
		239,
		-1,
		222,
		226,
		205,
		208,
		187,
		174,
		160,
		168,
		174,
		173,
		179,
		179,
		180,
		189,
		200,
		212,
		211,
		212,
		297,
		253,
		256,
		267,
		278,
		293,
		297,
		-1,
		256,
		295,
		205,
		-1,
		189,
		-1,
		-1,
		-1,
		236,
		218,
		210,
		207,
		186,
		186,
		152,
		156,
		169,
		176,
		186,
		197,
		189,
		193,
		206,
		217,
		220,
		293,
		284,
		297,
		242,
		242,
		263,
		272,
		293,
		257,
		254,
		289,
		212,
		201,
		196,
		183,
		-1,
		-1,
		220,
		228,
		-1,
		-1,
		193,
		160,
		148,
		158,
		162,
		176,
		188,
		201,
		189,
		194,
		188,
		220,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		260,
		-1,
		-1,
		255,
		282,
		266,
		245,
		243,
		268,
		-1,
		172,
		-1,
		-1,
		200,
		-1,
		-1,
		185,
		165,
		154,
		145,
		150,
		170,
		181,
		203,
		185,
		202,
		193,
		203,
		207,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		237,
		240,
		246,
		253,
		246,
		257,
		-1,
		-1,
		188,
		168,
		-1,
		-1,
		183,
		181,
		170,
		-1,
		160,
		142,
		147,
		177,
		179,
		181,
		188,
		182,
		189,
		197,
		208,
		200,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		193,
		-1,
		178,
		174,
		-1,
		-1,
		178,
		171,
		159,
		147,
		137,
		147,
		164,
		164,
		167,
		172,
		180,
		191,
		187,
		191,
		194,
		-1,
		313,
		-1,
		265,
		226,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		195,
		181,
		174,
		162,
		160,
		-1,
		212,
		196,
		177,
		-1,
		147,
		160,
		200,
		168,
		173,
		168,
		183,
		194,
		185,
		193,
		187,
		190,
		-1,
		-1,
		225,
		208,
		-1,
		-1,
		182,
		184,
		-1,
		186,
		175,
		160,
		152,
		-1,
		-1,
		184,
		180,
		-1,
		-1,
		134,
		172,
		171,
		179,
		174,
		179,
		191,
		187,
		183,
		193,
		184,
		-1,
		-1,
		203,
		195,
		189,
		-1,
		167,
		-1,
		188,
		-1,
		155,
		161,
		149,
		-1,
		-1,
		-1,
		165,
		128,
		144,
		167,
		193,
		191,
		182,
		175,
		182,
		185,
		178,
		184,
		-1,
		-1,
		-1,
		185,
		159,
		195,
		186,
		169,
		149,
		141,
		160,
		-1,
		146,
		-1,
		121,
		124,
		149,
		188,
		190,
		176,
		172,
		185,
		179,
		176,
		174,
		191,
		-1,
		161,
		194,
		158,
		155,
		131,
		135,
		160,
		-1,
		143,
		125,
		-1,
		153,
		143,
		191,
		166,
		175,
		168,
		162,
		163,
		171,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		136,
		127,
		-1,
		148,
		130,
		116,
		133,
		133,
		124,
		132,
		181,
		177,
		180,
		178,
		156,
		-1,
		149,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		141,
		128,
		116,
		117,
		113,
		113,
		115,
		128,
		136,
		134,
		131,
		143,
		139,
		159,
		155,
		187,
		-1,
		144,
		-1,
		193,
		-1,
		-1,
		138,
		125,
		135,
		139,
		128,
		126,
		112,
		108,
		125,
		160,
		146,
		144,
		149,
		154,
		-1,
		133,
		132,
		-1,
		126,
		136,
		135,
		-1,
		116,
		-1,
		174,
		135,
		-1,
		109,
		103,
		-1,
		155,
		151,
		-1,
		-1,
		120,
		115,
		-1,
		-1,
		-1,
		115,
		119,
		169,
		153,
		-1,
		93,
		100,
		-1,
		-1,
		-1,
		105,
		106,
		-1,
		101,
		111,
		-1,
		115,
		106,
		114,
		88,
		94,
		-1,
		-1,
		-1,
		114,
		95,
		89,
		91,
		86,
		116,
		127,
		113,
		97,
		75,
		85,
		114,
		-1,
		-1,
		-1,
		86,
		78,
		71,
		-1,
		-1,
		122,
		105,
		86,
		84,
		-1,
		-1,
		-1,
		108,
		89,
		-1,
		-1,
		62,
		-1,
		-1,
		81,
		60,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		94,
		-1,
		-1,
		-1,
		57,
		51,
		65,
		-1,
		-1,
		-1,
		-1,
		98,
		98,
		115,
		69,
		-1,
		-1,
		-1,
		47,
		54,
		-1,
		-1,
		101,
		99,
		-1,
		-1,
		-1,
		41,
		28,
		-1,
		65,
		-1,
		-1,
		-1,
		19,
		-1,
		-1,
		98,
		-1,
		-1,
		-1,
		4,
		-1,
		100,
		75,
		82,
		-1,
		-1,
		-1,
		-1,
		8,
		0,
		113,
		-1,
		85,
		87,
		-1,
		107,
		-1,
		-1,
		23,
		18,
		-1,
		-1,
		90,
		94,
		91,
		94,
		57,
		-1,
		72
	],
	[
		-1,
		337,
		326,
		337,
		345,
		318,
		325,
		-1,
		344,
		348,
		314,
		308,
		347,
		316,
		322,
		333,
		-1,
		-1,
		-1,
		337,
		336,
		304,
		302,
		311,
		316,
		323,
		-1,
		322,
		-1,
		358,
		337,
		348,
		353,
		297,
		294,
		314,
		333,
		315,
		307,
		373,
		327,
		298,
		292,
		310,
		300,
		309,
		301,
		-1,
		298,
		288,
		310,
		289,
		300,
		292,
		-1,
		-1,
		292,
		293,
		299,
		285,
		291,
		287,
		-1,
		297,
		281,
		-1,
		-1,
		282,
		283,
		267,
		270,
		278,
		276,
		289,
		281,
		276,
		-1,
		-1,
		273,
		269,
		276,
		263,
		259,
		276,
		289,
		271,
		285,
		284,
		-1,
		277,
		295,
		302,
		270,
		268,
		252,
		250,
		268,
		270,
		276,
		276,
		-1,
		286,
		287,
		282,
		290,
		292,
		268,
		255,
		255,
		265,
		258,
		277,
		265,
		311,
		-1,
		-1,
		-1,
		-1,
		-1,
		320,
		286,
		269,
		286,
		278,
		268,
		283,
		276,
		258,
		255,
		253,
		250,
		266,
		264,
		274,
		-1,
		-1,
		379,
		348,
		377,
		335,
		316,
		-1,
		282,
		262,
		268,
		272,
		266,
		259,
		273,
		269,
		-1,
		244,
		243,
		271,
		257,
		268,
		339,
		-1,
		-1,
		337,
		329,
		312,
		315,
		292,
		288,
		277,
		276,
		268,
		254,
		250,
		256,
		259,
		259,
		265,
		238,
		248,
		252,
		250,
		275,
		-1,
		-1,
		310,
		-1,
		-1,
		336,
		319,
		-1,
		302,
		309,
		298,
		304,
		290,
		311,
		287,
		278,
		270,
		264,
		252,
		254,
		251,
		264,
		252,
		235,
		260,
		264,
		245,
		266,
		261,
		-1,
		309,
		293,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		314,
		295,
		298,
		304,
		328,
		327,
		-1,
		299,
		287,
		288,
		273,
		270,
		257,
		245,
		258,
		243,
		250,
		249,
		239,
		237,
		267,
		242,
		264,
		261,
		280,
		285,
		279,
		288,
		-1,
		344,
		340,
		336,
		343,
		292,
		-1,
		-1,
		332,
		-1,
		335,
		336,
		311,
		284,
		287,
		274,
		265,
		252,
		241,
		252,
		241,
		238,
		246,
		231,
		246,
		237,
		236,
		254,
		264,
		272,
		276,
		282,
		-1,
		394,
		-1,
		336,
		320,
		322,
		294,
		315,
		-1,
		352,
		336,
		328,
		313,
		313,
		-1,
		283,
		280,
		270,
		248,
		233,
		250,
		242,
		240,
		244,
		226,
		240,
		231,
		249,
		256,
		254,
		258,
		278,
		290,
		354,
		344,
		-1,
		326,
		331,
		290,
		298,
		317,
		355,
		319,
		-1,
		314,
		-1,
		285,
		298,
		-1,
		254,
		250,
		232,
		233,
		228,
		243,
		237,
		222,
		219,
		237,
		240,
		247,
		251,
		267,
		-1,
		-1,
		339,
		343,
		332,
		283,
		302,
		326,
		363,
		312,
		301,
		300,
		-1,
		291,
		268,
		265,
		253,
		240,
		225,
		226,
		234,
		247,
		226,
		221,
		218,
		238,
		264,
		242,
		254,
		-1,
		-1,
		-1,
		364,
		-1,
		-1,
		309,
		280,
		304,
		346,
		330,
		323,
		311,
		276,
		276,
		270,
		-1,
		264,
		243,
		234,
		223,
		221,
		234,
		231,
		236,
		216,
		214,
		233,
		245,
		236,
		253,
		-1,
		-1,
		-1,
		339,
		328,
		329,
		275,
		298,
		335,
		309,
		295,
		300,
		275,
		268,
		262,
		277,
		260,
		241,
		230,
		222,
		211,
		227,
		235,
		230,
		212,
		221,
		227,
		251,
		241,
		247,
		-1,
		-1,
		346,
		336,
		320,
		322,
		319,
		289,
		296,
		328,
		300,
		313,
		-1,
		267,
		-1,
		256,
		251,
		235,
		230,
		227,
		224,
		218,
		227,
		229,
		219,
		214,
		221,
		256,
		256,
		231,
		251,
		254,
		-1,
		-1,
		-1,
		339,
		334,
		309,
		286,
		270,
		306,
		-1,
		283,
		284,
		-1,
		261,
		255,
		252,
		237,
		233,
		228,
		232,
		225,
		232,
		225,
		223,
		224,
		206,
		238,
		-1,
		239,
		233,
		241,
		231,
		219,
		-1,
		-1,
		-1,
		332,
		311,
		304,
		324,
		265,
		317,
		-1,
		-1,
		268,
		261,
		-1,
		248,
		230,
		237,
		235,
		229,
		233,
		230,
		219,
		232,
		225,
		211,
		213,
		226,
		230,
		234,
		221,
		217,
		214,
		228,
		-1,
		351,
		-1,
		-1,
		-1,
		-1,
		-1,
		265,
		285,
		-1,
		277,
		269,
		259,
		253,
		247,
		243,
		241,
		257,
		241,
		244,
		242,
		233,
		241,
		214,
		207,
		214,
		203,
		221,
		229,
		221,
		215,
		214,
		224,
		-1,
		352,
		338,
		309,
		-1,
		-1,
		298,
		-1,
		262,
		276,
		292,
		-1,
		285,
		264,
		279,
		257,
		253,
		249,
		264,
		265,
		242,
		242,
		240,
		231,
		219,
		208,
		211,
		203,
		225,
		225,
		209,
		210,
		214,
		-1,
		358,
		345,
		303,
		299,
		288,
		308,
		259,
		247,
		279,
		-1,
		-1,
		321,
		-1,
		255,
		272,
		263,
		261,
		254,
		236,
		243,
		251,
		228,
		223,
		213,
		202,
		202,
		197,
		219,
		205,
		203,
		212,
		228,
		-1,
		-1,
		-1,
		325,
		-1,
		-1,
		274,
		261,
		255,
		-1,
		296,
		-1,
		299,
		289,
		273,
		258,
		291,
		-1,
		235,
		231,
		238,
		-1,
		248,
		-1,
		221,
		218,
		209,
		194,
		191,
		202,
		200,
		211,
		207,
		-1,
		308,
		293,
		286,
		276,
		290,
		261,
		-1,
		316,
		-1,
		-1,
		286,
		280,
		280,
		264,
		265,
		251,
		231,
		223,
		238,
		237,
		224,
		223,
		207,
		200,
		197,
		190,
		203,
		213,
		218,
		205,
		-1,
		-1,
		-1,
		313,
		299,
		303,
		263,
		282,
		-1,
		-1,
		348,
		303,
		289,
		-1,
		260,
		251,
		239,
		229,
		219,
		224,
		225,
		215,
		213,
		205,
		207,
		201,
		192,
		191,
		207,
		199,
		221,
		-1,
		-1,
		296,
		301,
		289,
		275,
		294,
		-1,
		-1,
		-1,
		295,
		311,
		279,
		258,
		240,
		-1,
		-1,
		223,
		216,
		210,
		213,
		201,
		221,
		216,
		200,
		185,
		200,
		204,
		212,
		203,
		-1,
		299,
		286,
		-1,
		-1,
		297,
		291,
		-1,
		-1,
		-1,
		-1,
		291,
		236,
		225,
		220,
		224,
		222,
		-1,
		196,
		207,
		200,
		219,
		226,
		202,
		187,
		181,
		187,
		199,
		208,
		-1,
		-1,
		311,
		-1,
		284,
		-1,
		-1,
		-1,
		-1,
		248,
		242,
		213,
		206,
		210,
		-1,
		198,
		200,
		197,
		209,
		205,
		202,
		193,
		184,
		180,
		184,
		188,
		202,
		206,
		334,
		-1,
		275,
		-1,
		-1,
		-1,
		266,
		281,
		252,
		229,
		202,
		197,
		190,
		184,
		189,
		200,
		209,
		220,
		185,
		187,
		177,
		176,
		180,
		197,
		201,
		-1,
		-1,
		273,
		269,
		292,
		274,
		278,
		279,
		-1,
		-1,
		206,
		197,
		188,
		180,
		193,
		196,
		181,
		183,
		183,
		181,
		175,
		185,
		200,
		195,
		-1,
		-1,
		-1,
		285,
		-1,
		287,
		-1,
		-1,
		276,
		277,
		224,
		206,
		202,
		200,
		189,
		183,
		171,
		176,
		186,
		180,
		177,
		171,
		175,
		198,
		187,
		226,
		-1,
		-1,
		347,
		-1,
		-1,
		-1,
		265,
		256,
		251,
		258,
		260,
		251,
		239,
		236,
		-1,
		206,
		212,
		177,
		184,
		167,
		174,
		179,
		176,
		165,
		172,
		188,
		187,
		182,
		218,
		209,
		215,
		-1,
		-1,
		340,
		329,
		318,
		324,
		-1,
		258,
		253,
		244,
		234,
		237,
		-1,
		-1,
		231,
		228,
		208,
		177,
		175,
		168,
		163,
		173,
		149,
		161,
		165,
		169,
		175,
		180,
		185,
		191,
		206,
		221,
		-1,
		294,
		331,
		324,
		292,
		300,
		331,
		-1,
		248,
		240,
		250,
		226,
		228,
		-1,
		-1,
		204,
		195,
		196,
		184,
		181,
		187,
		186,
		169,
		175,
		176,
		168,
		167,
		185,
		189,
		198,
		205,
		195,
		208,
		212,
		-1,
		287,
		307,
		286,
		289,
		313,
		327,
		-1,
		245,
		-1,
		-1,
		210,
		229,
		213,
		203,
		200,
		243,
		198,
		193,
		174,
		172,
		167,
		158,
		183,
		176,
		176,
		179,
		194,
		199,
		191,
		205,
		205,
		206,
		-1,
		276,
		287,
		280,
		-1,
		-1,
		-1,
		-1,
		246,
		-1,
		-1,
		200,
		-1,
		240,
		-1,
		223,
		227,
		206,
		209,
		188,
		175,
		161,
		169,
		175,
		174,
		180,
		180,
		181,
		190,
		201,
		213,
		212,
		213,
		301,
		257,
		260,
		271,
		282,
		297,
		301,
		-1,
		257,
		296,
		206,
		-1,
		190,
		-1,
		-1,
		-1,
		237,
		219,
		211,
		208,
		187,
		187,
		153,
		157,
		170,
		177,
		187,
		198,
		190,
		194,
		207,
		218,
		221,
		297,
		288,
		301,
		246,
		246,
		267,
		276,
		297,
		261,
		258,
		290,
		213,
		202,
		197,
		184,
		-1,
		-1,
		221,
		229,
		-1,
		-1,
		194,
		161,
		149,
		159,
		163,
		177,
		189,
		202,
		190,
		195,
		189,
		221,
		-1,
		290,
		289,
		278,
		275,
		251,
		242,
		237,
		264,
		-1,
		-1,
		259,
		286,
		269,
		246,
		244,
		269,
		-1,
		173,
		-1,
		-1,
		201,
		-1,
		-1,
		186,
		166,
		155,
		146,
		151,
		171,
		182,
		204,
		186,
		203,
		194,
		204,
		208,
		274,
		271,
		259,
		257,
		280,
		245,
		233,
		-1,
		241,
		244,
		250,
		257,
		247,
		258,
		-1,
		-1,
		189,
		169,
		-1,
		-1,
		184,
		182,
		171,
		-1,
		161,
		143,
		148,
		178,
		180,
		182,
		189,
		183,
		190,
		198,
		209,
		201,
		283,
		297,
		286,
		282,
		281,
		289,
		238,
		231,
		238,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		194,
		-1,
		179,
		175,
		-1,
		-1,
		179,
		172,
		160,
		148,
		138,
		148,
		165,
		165,
		168,
		173,
		181,
		192,
		188,
		192,
		195,
		-1,
		317,
		-1,
		269,
		230,
		236,
		251,
		259,
		-1,
		-1,
		-1,
		196,
		182,
		175,
		163,
		161,
		-1,
		213,
		197,
		178,
		-1,
		148,
		161,
		201,
		169,
		174,
		169,
		184,
		195,
		186,
		194,
		188,
		191,
		-1,
		-1,
		229,
		212,
		-1,
		-1,
		186,
		188,
		-1,
		187,
		176,
		161,
		153,
		-1,
		-1,
		185,
		181,
		-1,
		-1,
		135,
		173,
		172,
		180,
		175,
		180,
		192,
		188,
		184,
		194,
		185,
		-1,
		-1,
		207,
		199,
		193,
		-1,
		171,
		-1,
		189,
		-1,
		156,
		162,
		150,
		-1,
		-1,
		-1,
		166,
		129,
		145,
		168,
		194,
		192,
		183,
		176,
		183,
		186,
		179,
		185,
		-1,
		-1,
		-1,
		189,
		163,
		196,
		187,
		170,
		150,
		142,
		161,
		-1,
		147,
		-1,
		122,
		125,
		150,
		189,
		191,
		177,
		173,
		186,
		180,
		177,
		175,
		195,
		-1,
		165,
		198,
		162,
		156,
		132,
		136,
		161,
		-1,
		144,
		126,
		-1,
		154,
		144,
		192,
		167,
		176,
		169,
		163,
		164,
		172,
		-1,
		-1,
		-1,
		167,
		166,
		158,
		152,
		152,
		137,
		128,
		-1,
		149,
		131,
		117,
		134,
		134,
		125,
		133,
		182,
		178,
		181,
		179,
		157,
		-1,
		162,
		-1,
		-1,
		190,
		-1,
		-1,
		-1,
		161,
		154,
		129,
		117,
		118,
		114,
		114,
		116,
		129,
		137,
		135,
		132,
		144,
		140,
		160,
		156,
		188,
		-1,
		157,
		-1,
		197,
		-1,
		-1,
		151,
		138,
		148,
		140,
		129,
		127,
		113,
		109,
		126,
		161,
		147,
		145,
		150,
		155,
		-1,
		146,
		145,
		-1,
		139,
		149,
		148,
		-1,
		129,
		-1,
		175,
		136,
		-1,
		110,
		104,
		-1,
		156,
		152,
		-1,
		-1,
		133,
		128,
		-1,
		-1,
		-1,
		128,
		120,
		170,
		154,
		-1,
		94,
		101,
		-1,
		-1,
		-1,
		118,
		119,
		-1,
		114,
		124,
		-1,
		116,
		107,
		115,
		89,
		95,
		-1,
		-1,
		-1,
		127,
		108,
		102,
		104,
		99,
		129,
		128,
		114,
		97,
		76,
		86,
		115,
		-1,
		-1,
		-1,
		99,
		91,
		84,
		-1,
		-1,
		123,
		106,
		87,
		85,
		-1,
		-1,
		-1,
		121,
		102,
		-1,
		-1,
		76,
		-1,
		-1,
		80,
		61,
		-1,
		-1,
		-1,
		-1,
		-1,
		138,
		110,
		-1,
		-1,
		-1,
		72,
		68,
		64,
		-1,
		-1,
		-1,
		-1,
		132,
		133,
		156,
		120,
		-1,
		-1,
		-1,
		64,
		53,
		-1,
		-1,
		135,
		133,
		-1,
		-1,
		-1,
		92,
		76,
		-1,
		48,
		-1,
		-1,
		-1,
		83,
		-1,
		-1,
		68,
		-1,
		-1,
		-1,
		97,
		-1,
		4,
		30,
		33,
		-1,
		-1,
		-1,
		-1,
		110,
		102,
		0,
		-1,
		36,
		38,
		-1,
		86,
		-1,
		-1,
		125,
		116,
		-1,
		-1,
		41,
		48,
		70,
		73,
		155,
		-1,
		60
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		317,
		306,
		317,
		325,
		298,
		305,
		-1,
		324,
		328,
		294,
		288,
		327,
		296,
		302,
		313,
		-1,
		-1,
		-1,
		317,
		316,
		284,
		282,
		291,
		296,
		303,
		-1,
		302,
		-1,
		338,
		317,
		328,
		333,
		277,
		274,
		294,
		313,
		295,
		287,
		353,
		307,
		278,
		272,
		290,
		280,
		289,
		281,
		-1,
		278,
		268,
		290,
		269,
		280,
		272,
		-1,
		-1,
		272,
		273,
		279,
		265,
		271,
		267,
		-1,
		277,
		261,
		-1,
		-1,
		262,
		263,
		247,
		250,
		258,
		256,
		269,
		261,
		256,
		-1,
		-1,
		253,
		249,
		256,
		243,
		239,
		256,
		269,
		251,
		265,
		264,
		-1,
		257,
		275,
		282,
		250,
		248,
		232,
		230,
		248,
		250,
		256,
		256,
		-1,
		266,
		267,
		262,
		270,
		272,
		248,
		235,
		235,
		245,
		238,
		257,
		245,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		266,
		249,
		266,
		258,
		248,
		263,
		256,
		238,
		235,
		233,
		230,
		246,
		244,
		254,
		-1,
		-1,
		359,
		328,
		357,
		315,
		296,
		-1,
		262,
		242,
		248,
		252,
		246,
		239,
		253,
		249,
		-1,
		224,
		223,
		251,
		237,
		248,
		319,
		-1,
		-1,
		317,
		309,
		292,
		295,
		272,
		268,
		257,
		256,
		248,
		234,
		230,
		236,
		239,
		239,
		245,
		218,
		228,
		232,
		230,
		255,
		-1,
		-1,
		290,
		-1,
		-1,
		316,
		299,
		-1,
		282,
		289,
		278,
		284,
		270,
		291,
		267,
		258,
		250,
		244,
		232,
		234,
		231,
		244,
		232,
		215,
		240,
		244,
		225,
		246,
		241,
		-1,
		289,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		275,
		278,
		284,
		308,
		307,
		-1,
		279,
		267,
		268,
		253,
		250,
		237,
		225,
		238,
		223,
		230,
		229,
		219,
		217,
		247,
		222,
		244,
		241,
		260,
		265,
		259,
		268,
		-1,
		324,
		320,
		316,
		323,
		272,
		-1,
		-1,
		312,
		-1,
		315,
		316,
		291,
		264,
		267,
		254,
		245,
		232,
		221,
		232,
		221,
		218,
		226,
		211,
		226,
		217,
		216,
		234,
		244,
		252,
		256,
		262,
		-1,
		374,
		-1,
		316,
		300,
		302,
		274,
		295,
		-1,
		332,
		316,
		308,
		293,
		293,
		-1,
		263,
		260,
		250,
		228,
		213,
		230,
		222,
		220,
		224,
		206,
		220,
		211,
		229,
		236,
		234,
		238,
		258,
		270,
		334,
		324,
		-1,
		306,
		311,
		270,
		278,
		297,
		335,
		299,
		-1,
		294,
		-1,
		265,
		278,
		-1,
		234,
		230,
		212,
		213,
		208,
		223,
		217,
		202,
		199,
		217,
		220,
		227,
		231,
		247,
		-1,
		-1,
		319,
		323,
		312,
		263,
		282,
		306,
		343,
		292,
		281,
		280,
		-1,
		271,
		248,
		245,
		233,
		220,
		205,
		206,
		214,
		227,
		206,
		201,
		198,
		218,
		244,
		222,
		234,
		-1,
		-1,
		-1,
		344,
		-1,
		-1,
		289,
		260,
		284,
		326,
		310,
		303,
		291,
		256,
		256,
		250,
		-1,
		244,
		223,
		214,
		203,
		201,
		214,
		211,
		216,
		196,
		194,
		213,
		225,
		216,
		233,
		-1,
		-1,
		-1,
		319,
		308,
		309,
		255,
		278,
		315,
		289,
		275,
		280,
		255,
		248,
		242,
		257,
		240,
		221,
		210,
		202,
		191,
		207,
		215,
		210,
		192,
		201,
		207,
		231,
		221,
		227,
		-1,
		-1,
		326,
		316,
		300,
		302,
		299,
		269,
		276,
		308,
		280,
		293,
		-1,
		247,
		-1,
		236,
		231,
		215,
		210,
		207,
		204,
		198,
		207,
		209,
		199,
		194,
		201,
		236,
		236,
		211,
		231,
		234,
		-1,
		-1,
		-1,
		319,
		314,
		289,
		266,
		250,
		286,
		-1,
		263,
		264,
		-1,
		241,
		235,
		232,
		217,
		213,
		208,
		212,
		205,
		212,
		205,
		203,
		204,
		186,
		218,
		-1,
		219,
		213,
		221,
		211,
		199,
		-1,
		-1,
		-1,
		312,
		291,
		284,
		304,
		245,
		297,
		-1,
		-1,
		248,
		241,
		-1,
		228,
		210,
		217,
		215,
		209,
		213,
		210,
		199,
		212,
		205,
		191,
		193,
		206,
		210,
		214,
		201,
		197,
		194,
		208,
		-1,
		331,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		265,
		-1,
		257,
		249,
		239,
		233,
		227,
		223,
		221,
		237,
		221,
		224,
		222,
		213,
		221,
		194,
		187,
		194,
		183,
		201,
		209,
		201,
		195,
		194,
		204,
		-1,
		332,
		318,
		289,
		-1,
		-1,
		278,
		-1,
		242,
		256,
		272,
		-1,
		265,
		244,
		259,
		237,
		233,
		229,
		244,
		245,
		222,
		222,
		220,
		211,
		199,
		188,
		191,
		183,
		205,
		205,
		189,
		190,
		194,
		-1,
		338,
		325,
		283,
		279,
		268,
		288,
		239,
		227,
		259,
		-1,
		-1,
		301,
		-1,
		235,
		252,
		243,
		241,
		234,
		216,
		223,
		231,
		208,
		203,
		193,
		182,
		182,
		177,
		199,
		185,
		183,
		192,
		208,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		254,
		241,
		235,
		-1,
		276,
		-1,
		279,
		269,
		253,
		238,
		271,
		-1,
		215,
		211,
		218,
		-1,
		228,
		-1,
		201,
		198,
		189,
		174,
		171,
		182,
		180,
		191,
		187,
		-1,
		288,
		273,
		266,
		256,
		270,
		241,
		-1,
		296,
		-1,
		-1,
		266,
		260,
		260,
		244,
		245,
		231,
		211,
		203,
		218,
		217,
		204,
		203,
		187,
		180,
		177,
		170,
		183,
		193,
		198,
		185,
		-1,
		-1,
		-1,
		293,
		279,
		283,
		243,
		262,
		-1,
		-1,
		328,
		283,
		269,
		-1,
		240,
		231,
		219,
		209,
		199,
		204,
		205,
		195,
		193,
		185,
		187,
		181,
		172,
		171,
		187,
		179,
		201,
		-1,
		-1,
		276,
		281,
		269,
		255,
		274,
		-1,
		-1,
		-1,
		275,
		291,
		259,
		238,
		220,
		-1,
		-1,
		203,
		196,
		190,
		193,
		181,
		201,
		196,
		180,
		165,
		180,
		184,
		192,
		183,
		-1,
		279,
		266,
		-1,
		-1,
		277,
		271,
		-1,
		-1,
		-1,
		-1,
		271,
		216,
		205,
		200,
		204,
		202,
		-1,
		176,
		187,
		180,
		199,
		206,
		182,
		167,
		161,
		167,
		179,
		188,
		-1,
		-1,
		291,
		-1,
		264,
		-1,
		-1,
		-1,
		-1,
		228,
		222,
		193,
		186,
		190,
		-1,
		178,
		180,
		177,
		189,
		185,
		182,
		173,
		164,
		160,
		164,
		168,
		182,
		186,
		314,
		-1,
		255,
		-1,
		-1,
		-1,
		246,
		261,
		232,
		209,
		182,
		177,
		170,
		164,
		169,
		180,
		189,
		200,
		165,
		167,
		157,
		156,
		160,
		177,
		181,
		-1,
		-1,
		253,
		249,
		272,
		254,
		258,
		259,
		-1,
		-1,
		186,
		177,
		168,
		160,
		173,
		176,
		161,
		163,
		163,
		161,
		155,
		165,
		180,
		175,
		-1,
		-1,
		-1,
		265,
		-1,
		267,
		-1,
		-1,
		256,
		257,
		204,
		186,
		182,
		180,
		169,
		163,
		151,
		156,
		166,
		160,
		157,
		151,
		155,
		178,
		167,
		206,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		245,
		236,
		231,
		238,
		240,
		231,
		219,
		216,
		-1,
		186,
		192,
		157,
		164,
		147,
		154,
		159,
		156,
		145,
		152,
		168,
		167,
		162,
		198,
		189,
		195,
		-1,
		-1,
		320,
		309,
		298,
		304,
		-1,
		238,
		233,
		224,
		214,
		217,
		-1,
		-1,
		211,
		208,
		188,
		157,
		155,
		148,
		143,
		153,
		129,
		141,
		145,
		149,
		155,
		160,
		165,
		171,
		186,
		201,
		-1,
		274,
		311,
		304,
		272,
		280,
		311,
		-1,
		228,
		220,
		230,
		206,
		208,
		-1,
		-1,
		184,
		175,
		176,
		164,
		161,
		167,
		166,
		149,
		155,
		156,
		148,
		147,
		165,
		169,
		178,
		185,
		175,
		188,
		192,
		-1,
		267,
		287,
		266,
		269,
		293,
		307,
		-1,
		225,
		-1,
		-1,
		190,
		209,
		193,
		183,
		180,
		223,
		178,
		173,
		154,
		152,
		147,
		138,
		163,
		156,
		156,
		159,
		174,
		179,
		171,
		185,
		185,
		186,
		-1,
		256,
		267,
		260,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		180,
		-1,
		220,
		-1,
		203,
		207,
		186,
		189,
		168,
		155,
		141,
		149,
		155,
		154,
		160,
		160,
		161,
		170,
		181,
		193,
		192,
		193,
		281,
		237,
		240,
		251,
		262,
		277,
		281,
		-1,
		237,
		276,
		186,
		-1,
		170,
		-1,
		-1,
		-1,
		217,
		199,
		191,
		188,
		167,
		167,
		133,
		137,
		150,
		157,
		167,
		178,
		170,
		174,
		187,
		198,
		201,
		277,
		268,
		281,
		226,
		226,
		247,
		256,
		277,
		241,
		238,
		270,
		193,
		182,
		177,
		164,
		-1,
		-1,
		201,
		209,
		-1,
		-1,
		174,
		141,
		129,
		139,
		143,
		157,
		169,
		182,
		170,
		175,
		169,
		201,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		217,
		244,
		-1,
		-1,
		239,
		266,
		249,
		226,
		224,
		249,
		-1,
		153,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		146,
		135,
		126,
		131,
		151,
		162,
		184,
		166,
		183,
		174,
		184,
		188,
		254,
		251,
		239,
		237,
		260,
		225,
		213,
		-1,
		221,
		224,
		230,
		237,
		227,
		238,
		-1,
		-1,
		169,
		149,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		123,
		128,
		158,
		160,
		162,
		169,
		163,
		170,
		178,
		189,
		181,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		159,
		155,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		145,
		145,
		148,
		153,
		161,
		172,
		168,
		172,
		175,
		-1,
		297,
		-1,
		249,
		210,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		176,
		162,
		155,
		143,
		141,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		181,
		149,
		154,
		149,
		164,
		175,
		166,
		174,
		168,
		171,
		-1,
		-1,
		209,
		192,
		-1,
		-1,
		166,
		168,
		-1,
		167,
		156,
		141,
		133,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		115,
		153,
		152,
		160,
		155,
		160,
		172,
		168,
		164,
		174,
		165,
		-1,
		-1,
		187,
		179,
		173,
		-1,
		151,
		-1,
		169,
		-1,
		136,
		142,
		130,
		-1,
		-1,
		-1,
		146,
		109,
		125,
		148,
		174,
		172,
		163,
		156,
		163,
		166,
		159,
		165,
		-1,
		-1,
		-1,
		169,
		143,
		176,
		167,
		150,
		130,
		122,
		141,
		-1,
		127,
		-1,
		102,
		105,
		130,
		169,
		171,
		157,
		153,
		166,
		160,
		157,
		155,
		175,
		-1,
		145,
		178,
		142,
		136,
		112,
		116,
		141,
		-1,
		124,
		106,
		-1,
		134,
		124,
		172,
		147,
		156,
		149,
		143,
		144,
		152,
		-1,
		-1,
		-1,
		147,
		146,
		138,
		132,
		132,
		117,
		108,
		-1,
		129,
		111,
		97,
		114,
		114,
		105,
		113,
		162,
		158,
		161,
		159,
		137,
		-1,
		142,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		141,
		134,
		109,
		97,
		98,
		94,
		94,
		96,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		136,
		168,
		-1,
		137,
		-1,
		177,
		-1,
		-1,
		131,
		118,
		128,
		120,
		109,
		107,
		93,
		89,
		106,
		141,
		127,
		125,
		130,
		135,
		-1,
		126,
		125,
		-1,
		119,
		129,
		128,
		-1,
		109,
		-1,
		155,
		116,
		-1,
		90,
		84,
		-1,
		136,
		132,
		-1,
		-1,
		113,
		108,
		-1,
		-1,
		-1,
		108,
		100,
		150,
		134,
		-1,
		74,
		81,
		-1,
		-1,
		-1,
		98,
		99,
		-1,
		94,
		104,
		-1,
		96,
		87,
		95,
		69,
		75,
		-1,
		-1,
		-1,
		107,
		88,
		82,
		84,
		79,
		109,
		108,
		94,
		77,
		56,
		66,
		95,
		-1,
		-1,
		-1,
		79,
		71,
		64,
		-1,
		-1,
		103,
		86,
		67,
		65,
		-1,
		-1,
		-1,
		101,
		82,
		-1,
		-1,
		56,
		-1,
		-1,
		60,
		41,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		90,
		-1,
		-1,
		-1,
		52,
		48,
		44,
		-1,
		-1,
		-1,
		-1,
		112,
		113,
		136,
		100,
		-1,
		-1,
		-1,
		44,
		33,
		-1,
		-1,
		115,
		113,
		-1,
		-1,
		-1,
		72,
		56,
		-1,
		28,
		-1,
		-1,
		-1,
		63,
		-1,
		-1,
		48,
		-1,
		-1,
		-1,
		77,
		-1,
		32,
		11,
		3,
		-1,
		-1,
		-1,
		-1,
		90,
		82,
		45,
		-1,
		0,
		7,
		-1,
		55,
		-1,
		-1,
		105,
		88,
		-1,
		-1,
		10,
		17,
		39,
		42,
		135,
		-1,
		29
	],
	[
		-1,
		317,
		306,
		317,
		325,
		298,
		305,
		-1,
		324,
		328,
		294,
		288,
		327,
		296,
		302,
		313,
		-1,
		-1,
		-1,
		317,
		316,
		284,
		282,
		291,
		296,
		303,
		-1,
		302,
		-1,
		338,
		317,
		328,
		333,
		277,
		274,
		294,
		313,
		295,
		287,
		353,
		307,
		278,
		272,
		290,
		280,
		289,
		281,
		-1,
		278,
		268,
		290,
		269,
		280,
		272,
		-1,
		-1,
		272,
		273,
		279,
		265,
		271,
		267,
		-1,
		277,
		261,
		-1,
		-1,
		262,
		263,
		247,
		250,
		258,
		256,
		269,
		261,
		256,
		-1,
		-1,
		253,
		249,
		256,
		243,
		239,
		256,
		269,
		251,
		265,
		264,
		-1,
		257,
		275,
		282,
		250,
		248,
		232,
		230,
		248,
		250,
		256,
		256,
		-1,
		266,
		267,
		262,
		270,
		272,
		248,
		235,
		235,
		245,
		238,
		257,
		245,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		300,
		266,
		249,
		266,
		258,
		248,
		263,
		256,
		238,
		235,
		233,
		230,
		246,
		244,
		254,
		-1,
		-1,
		359,
		328,
		357,
		315,
		296,
		-1,
		262,
		242,
		248,
		252,
		246,
		239,
		253,
		249,
		-1,
		224,
		223,
		251,
		237,
		248,
		319,
		-1,
		-1,
		317,
		309,
		292,
		295,
		272,
		268,
		257,
		256,
		248,
		234,
		230,
		236,
		239,
		239,
		245,
		218,
		228,
		232,
		230,
		255,
		-1,
		-1,
		290,
		-1,
		-1,
		316,
		299,
		-1,
		282,
		289,
		278,
		284,
		270,
		291,
		267,
		258,
		250,
		244,
		232,
		234,
		231,
		244,
		232,
		215,
		240,
		244,
		225,
		246,
		241,
		-1,
		289,
		273,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		294,
		275,
		278,
		284,
		308,
		307,
		-1,
		279,
		267,
		268,
		253,
		250,
		237,
		225,
		238,
		223,
		230,
		229,
		219,
		217,
		247,
		222,
		244,
		241,
		260,
		265,
		259,
		268,
		-1,
		324,
		320,
		316,
		323,
		272,
		-1,
		-1,
		312,
		-1,
		315,
		316,
		291,
		264,
		267,
		254,
		245,
		232,
		221,
		232,
		221,
		218,
		226,
		211,
		226,
		217,
		216,
		234,
		244,
		252,
		256,
		262,
		-1,
		374,
		-1,
		316,
		300,
		302,
		274,
		295,
		-1,
		332,
		316,
		308,
		293,
		293,
		-1,
		263,
		260,
		250,
		228,
		213,
		230,
		222,
		220,
		224,
		206,
		220,
		211,
		229,
		236,
		234,
		238,
		258,
		270,
		334,
		324,
		-1,
		306,
		311,
		270,
		278,
		297,
		335,
		299,
		-1,
		294,
		-1,
		265,
		278,
		-1,
		234,
		230,
		212,
		213,
		208,
		223,
		217,
		202,
		199,
		217,
		220,
		227,
		231,
		247,
		-1,
		-1,
		319,
		323,
		312,
		263,
		282,
		306,
		343,
		292,
		281,
		280,
		-1,
		271,
		248,
		245,
		233,
		220,
		205,
		206,
		214,
		227,
		206,
		201,
		198,
		218,
		244,
		222,
		234,
		-1,
		-1,
		-1,
		344,
		-1,
		-1,
		289,
		260,
		284,
		326,
		310,
		303,
		291,
		256,
		256,
		250,
		-1,
		244,
		223,
		214,
		203,
		201,
		214,
		211,
		216,
		196,
		194,
		213,
		225,
		216,
		233,
		-1,
		-1,
		-1,
		319,
		308,
		309,
		255,
		278,
		315,
		289,
		275,
		280,
		255,
		248,
		242,
		257,
		240,
		221,
		210,
		202,
		191,
		207,
		215,
		210,
		192,
		201,
		207,
		231,
		221,
		227,
		-1,
		-1,
		326,
		316,
		300,
		302,
		299,
		269,
		276,
		308,
		280,
		293,
		-1,
		247,
		-1,
		236,
		231,
		215,
		210,
		207,
		204,
		198,
		207,
		209,
		199,
		194,
		201,
		236,
		236,
		211,
		231,
		234,
		-1,
		-1,
		-1,
		319,
		314,
		289,
		266,
		250,
		286,
		-1,
		263,
		264,
		-1,
		241,
		235,
		232,
		217,
		213,
		208,
		212,
		205,
		212,
		205,
		203,
		204,
		186,
		218,
		-1,
		219,
		213,
		221,
		211,
		199,
		-1,
		-1,
		-1,
		312,
		291,
		284,
		304,
		245,
		297,
		-1,
		-1,
		248,
		241,
		-1,
		228,
		210,
		217,
		215,
		209,
		213,
		210,
		199,
		212,
		205,
		191,
		193,
		206,
		210,
		214,
		201,
		197,
		194,
		208,
		-1,
		331,
		-1,
		-1,
		-1,
		-1,
		-1,
		245,
		265,
		-1,
		257,
		249,
		239,
		233,
		227,
		223,
		221,
		237,
		221,
		224,
		222,
		213,
		221,
		194,
		187,
		194,
		183,
		201,
		209,
		201,
		195,
		194,
		204,
		-1,
		332,
		318,
		289,
		-1,
		-1,
		278,
		-1,
		242,
		256,
		272,
		-1,
		265,
		244,
		259,
		237,
		233,
		229,
		244,
		245,
		222,
		222,
		220,
		211,
		199,
		188,
		191,
		183,
		205,
		205,
		189,
		190,
		194,
		-1,
		338,
		325,
		283,
		279,
		268,
		288,
		239,
		227,
		259,
		-1,
		-1,
		301,
		-1,
		235,
		252,
		243,
		241,
		234,
		216,
		223,
		231,
		208,
		203,
		193,
		182,
		182,
		177,
		199,
		185,
		183,
		192,
		208,
		-1,
		-1,
		-1,
		305,
		-1,
		-1,
		254,
		241,
		235,
		-1,
		276,
		-1,
		279,
		269,
		253,
		238,
		271,
		-1,
		215,
		211,
		218,
		-1,
		228,
		-1,
		201,
		198,
		189,
		174,
		171,
		182,
		180,
		191,
		187,
		-1,
		288,
		273,
		266,
		256,
		270,
		241,
		-1,
		296,
		-1,
		-1,
		266,
		260,
		260,
		244,
		245,
		231,
		211,
		203,
		218,
		217,
		204,
		203,
		187,
		180,
		177,
		170,
		183,
		193,
		198,
		185,
		-1,
		-1,
		-1,
		293,
		279,
		283,
		243,
		262,
		-1,
		-1,
		328,
		283,
		269,
		-1,
		240,
		231,
		219,
		209,
		199,
		204,
		205,
		195,
		193,
		185,
		187,
		181,
		172,
		171,
		187,
		179,
		201,
		-1,
		-1,
		276,
		281,
		269,
		255,
		274,
		-1,
		-1,
		-1,
		275,
		291,
		259,
		238,
		220,
		-1,
		-1,
		203,
		196,
		190,
		193,
		181,
		201,
		196,
		180,
		165,
		180,
		184,
		192,
		183,
		-1,
		279,
		266,
		-1,
		-1,
		277,
		271,
		-1,
		-1,
		-1,
		-1,
		271,
		216,
		205,
		200,
		204,
		202,
		-1,
		176,
		187,
		180,
		199,
		206,
		182,
		167,
		161,
		167,
		179,
		188,
		-1,
		-1,
		291,
		-1,
		264,
		-1,
		-1,
		-1,
		-1,
		228,
		222,
		193,
		186,
		190,
		-1,
		178,
		180,
		177,
		189,
		185,
		182,
		173,
		164,
		160,
		164,
		168,
		182,
		186,
		314,
		-1,
		255,
		-1,
		-1,
		-1,
		246,
		261,
		232,
		209,
		182,
		177,
		170,
		164,
		169,
		180,
		189,
		200,
		165,
		167,
		157,
		156,
		160,
		177,
		181,
		-1,
		-1,
		253,
		249,
		272,
		254,
		258,
		259,
		-1,
		-1,
		186,
		177,
		168,
		160,
		173,
		176,
		161,
		163,
		163,
		161,
		155,
		165,
		180,
		175,
		-1,
		-1,
		-1,
		265,
		-1,
		267,
		-1,
		-1,
		256,
		257,
		204,
		186,
		182,
		180,
		169,
		163,
		151,
		156,
		166,
		160,
		157,
		151,
		155,
		178,
		167,
		206,
		-1,
		-1,
		327,
		-1,
		-1,
		-1,
		245,
		236,
		231,
		238,
		240,
		231,
		219,
		216,
		-1,
		186,
		192,
		157,
		164,
		147,
		154,
		159,
		156,
		145,
		152,
		168,
		167,
		162,
		198,
		189,
		195,
		-1,
		-1,
		320,
		309,
		298,
		304,
		-1,
		238,
		233,
		224,
		214,
		217,
		-1,
		-1,
		211,
		208,
		188,
		157,
		155,
		148,
		143,
		153,
		129,
		141,
		145,
		149,
		155,
		160,
		165,
		171,
		186,
		201,
		-1,
		274,
		311,
		304,
		272,
		280,
		311,
		-1,
		228,
		220,
		230,
		206,
		208,
		-1,
		-1,
		184,
		175,
		176,
		164,
		161,
		167,
		166,
		149,
		155,
		156,
		148,
		147,
		165,
		169,
		178,
		185,
		175,
		188,
		192,
		-1,
		267,
		287,
		266,
		269,
		293,
		307,
		-1,
		225,
		-1,
		-1,
		190,
		209,
		193,
		183,
		180,
		223,
		178,
		173,
		154,
		152,
		147,
		138,
		163,
		156,
		156,
		159,
		174,
		179,
		171,
		185,
		185,
		186,
		-1,
		256,
		267,
		260,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		-1,
		180,
		-1,
		220,
		-1,
		203,
		207,
		186,
		189,
		168,
		155,
		141,
		149,
		155,
		154,
		160,
		160,
		161,
		170,
		181,
		193,
		192,
		193,
		281,
		237,
		240,
		251,
		262,
		277,
		281,
		-1,
		237,
		276,
		186,
		-1,
		170,
		-1,
		-1,
		-1,
		217,
		199,
		191,
		188,
		167,
		167,
		133,
		137,
		150,
		157,
		167,
		178,
		170,
		174,
		187,
		198,
		201,
		277,
		268,
		281,
		226,
		226,
		247,
		256,
		277,
		241,
		238,
		270,
		193,
		182,
		177,
		164,
		-1,
		-1,
		201,
		209,
		-1,
		-1,
		174,
		141,
		129,
		139,
		143,
		157,
		169,
		182,
		170,
		175,
		169,
		201,
		-1,
		270,
		269,
		258,
		255,
		231,
		222,
		217,
		244,
		-1,
		-1,
		239,
		266,
		249,
		226,
		224,
		249,
		-1,
		153,
		-1,
		-1,
		181,
		-1,
		-1,
		166,
		146,
		135,
		126,
		131,
		151,
		162,
		184,
		166,
		183,
		174,
		184,
		188,
		254,
		251,
		239,
		237,
		260,
		225,
		213,
		-1,
		221,
		224,
		230,
		237,
		227,
		238,
		-1,
		-1,
		169,
		149,
		-1,
		-1,
		164,
		162,
		151,
		-1,
		141,
		123,
		128,
		158,
		160,
		162,
		169,
		163,
		170,
		178,
		189,
		181,
		263,
		277,
		266,
		262,
		261,
		269,
		218,
		211,
		218,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		174,
		-1,
		159,
		155,
		-1,
		-1,
		159,
		152,
		140,
		128,
		118,
		128,
		145,
		145,
		148,
		153,
		161,
		172,
		168,
		172,
		175,
		-1,
		297,
		-1,
		249,
		210,
		216,
		231,
		239,
		-1,
		-1,
		-1,
		176,
		162,
		155,
		143,
		141,
		-1,
		193,
		177,
		158,
		-1,
		128,
		141,
		181,
		149,
		154,
		149,
		164,
		175,
		166,
		174,
		168,
		171,
		-1,
		-1,
		209,
		192,
		-1,
		-1,
		166,
		168,
		-1,
		167,
		156,
		141,
		133,
		-1,
		-1,
		165,
		161,
		-1,
		-1,
		115,
		153,
		152,
		160,
		155,
		160,
		172,
		168,
		164,
		174,
		165,
		-1,
		-1,
		187,
		179,
		173,
		-1,
		151,
		-1,
		169,
		-1,
		136,
		142,
		130,
		-1,
		-1,
		-1,
		146,
		109,
		125,
		148,
		174,
		172,
		163,
		156,
		163,
		166,
		159,
		165,
		-1,
		-1,
		-1,
		169,
		143,
		176,
		167,
		150,
		130,
		122,
		141,
		-1,
		127,
		-1,
		102,
		105,
		130,
		169,
		171,
		157,
		153,
		166,
		160,
		157,
		155,
		175,
		-1,
		145,
		178,
		142,
		136,
		112,
		116,
		141,
		-1,
		124,
		106,
		-1,
		134,
		124,
		172,
		147,
		156,
		149,
		143,
		144,
		152,
		-1,
		-1,
		-1,
		147,
		146,
		138,
		132,
		132,
		117,
		108,
		-1,
		129,
		111,
		97,
		114,
		114,
		105,
		113,
		162,
		158,
		161,
		159,
		137,
		-1,
		142,
		-1,
		-1,
		170,
		-1,
		-1,
		-1,
		141,
		134,
		109,
		97,
		98,
		94,
		94,
		96,
		109,
		117,
		115,
		112,
		124,
		120,
		140,
		136,
		168,
		-1,
		137,
		-1,
		177,
		-1,
		-1,
		131,
		118,
		128,
		120,
		109,
		107,
		93,
		89,
		106,
		141,
		127,
		125,
		130,
		135,
		-1,
		126,
		125,
		-1,
		119,
		129,
		128,
		-1,
		109,
		-1,
		155,
		116,
		-1,
		90,
		84,
		-1,
		136,
		132,
		-1,
		-1,
		113,
		108,
		-1,
		-1,
		-1,
		108,
		100,
		150,
		134,
		-1,
		74,
		81,
		-1,
		-1,
		-1,
		98,
		99,
		-1,
		94,
		104,
		-1,
		96,
		87,
		95,
		69,
		75,
		-1,
		-1,
		-1,
		107,
		88,
		82,
		84,
		79,
		109,
		108,
		94,
		77,
		56,
		66,
		95,
		-1,
		-1,
		-1,
		79,
		71,
		64,
		-1,
		-1,
		103,
		86,
		67,
		65,
		-1,
		-1,
		-1,
		101,
		82,
		-1,
		-1,
		56,
		-1,
		-1,
		60,
		41,
		-1,
		-1,
		-1,
		-1,
		-1,
		118,
		90,
		-1,
		-1,
		-1,
		52,
		48,
		44,
		-1,
		-1,
		-1,
		-1,
		112,
		113,
		136,
		100,
		-1,
		-1,
		-1,
		44,
		33,
		-1,
		-1,
		115,
		113,
		-1,
		-1,
		-1,
		72,
		56,
		-1,
		28,
		-1,
		-1,
		-1,
		63,
		-1,
		-1,
		48,
		-1,
		-1,
		-1,
		77,
		-1,
		31,
		10,
		10,
		-1,
		-1,
		-1,
		-1,
		90,
		82,
		44,
		-1,
		7,
		0,
		-1,
		48,
		-1,
		-1,
		105,
		81,
		-1,
		-1,
		3,
		10,
		32,
		35,
		134,
		-1,
		22
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		369,
		358,
		369,
		377,
		350,
		357,
		-1,
		376,
		380,
		346,
		340,
		379,
		348,
		354,
		365,
		-1,
		-1,
		-1,
		369,
		368,
		336,
		334,
		343,
		348,
		355,
		-1,
		354,
		-1,
		390,
		369,
		380,
		385,
		329,
		326,
		346,
		365,
		347,
		339,
		405,
		359,
		330,
		324,
		342,
		332,
		341,
		333,
		-1,
		330,
		320,
		342,
		321,
		332,
		324,
		-1,
		-1,
		324,
		325,
		331,
		317,
		323,
		319,
		-1,
		329,
		313,
		-1,
		-1,
		314,
		315,
		299,
		302,
		310,
		308,
		321,
		313,
		308,
		-1,
		-1,
		305,
		301,
		308,
		295,
		291,
		308,
		321,
		303,
		317,
		316,
		-1,
		309,
		327,
		334,
		302,
		300,
		284,
		282,
		300,
		302,
		308,
		308,
		-1,
		318,
		319,
		314,
		322,
		324,
		300,
		287,
		287,
		297,
		290,
		309,
		297,
		343,
		-1,
		-1,
		-1,
		-1,
		-1,
		352,
		318,
		301,
		318,
		310,
		300,
		315,
		308,
		290,
		287,
		285,
		282,
		298,
		296,
		306,
		-1,
		-1,
		411,
		380,
		409,
		367,
		348,
		-1,
		314,
		294,
		300,
		304,
		298,
		291,
		305,
		301,
		-1,
		276,
		275,
		303,
		289,
		300,
		371,
		-1,
		-1,
		369,
		361,
		344,
		347,
		324,
		320,
		309,
		308,
		300,
		286,
		282,
		288,
		291,
		291,
		297,
		270,
		280,
		284,
		282,
		307,
		-1,
		-1,
		342,
		-1,
		-1,
		368,
		351,
		-1,
		334,
		341,
		330,
		336,
		322,
		343,
		319,
		310,
		302,
		296,
		284,
		286,
		283,
		296,
		284,
		267,
		292,
		296,
		277,
		298,
		293,
		-1,
		341,
		325,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		346,
		327,
		330,
		336,
		360,
		359,
		-1,
		331,
		319,
		320,
		305,
		302,
		289,
		277,
		290,
		275,
		282,
		281,
		271,
		269,
		299,
		274,
		296,
		293,
		312,
		317,
		311,
		320,
		-1,
		376,
		372,
		368,
		375,
		324,
		-1,
		-1,
		364,
		-1,
		367,
		368,
		343,
		316,
		319,
		306,
		297,
		284,
		273,
		284,
		273,
		270,
		278,
		263,
		278,
		269,
		268,
		286,
		296,
		304,
		308,
		314,
		-1,
		426,
		-1,
		368,
		352,
		354,
		326,
		347,
		-1,
		384,
		368,
		360,
		345,
		345,
		-1,
		315,
		312,
		302,
		280,
		265,
		282,
		274,
		272,
		276,
		258,
		272,
		263,
		281,
		288,
		286,
		290,
		310,
		322,
		386,
		376,
		-1,
		358,
		363,
		322,
		330,
		349,
		387,
		351,
		-1,
		346,
		-1,
		317,
		330,
		-1,
		286,
		282,
		264,
		265,
		260,
		275,
		269,
		254,
		251,
		269,
		272,
		279,
		283,
		299,
		-1,
		-1,
		371,
		375,
		364,
		315,
		334,
		358,
		395,
		344,
		333,
		332,
		-1,
		323,
		300,
		297,
		285,
		272,
		257,
		258,
		266,
		279,
		258,
		253,
		250,
		270,
		296,
		274,
		286,
		-1,
		-1,
		-1,
		396,
		-1,
		-1,
		341,
		312,
		336,
		378,
		362,
		355,
		343,
		308,
		308,
		302,
		-1,
		296,
		275,
		266,
		255,
		253,
		266,
		263,
		268,
		248,
		246,
		265,
		277,
		268,
		285,
		-1,
		-1,
		-1,
		371,
		360,
		361,
		307,
		330,
		367,
		341,
		327,
		332,
		307,
		300,
		294,
		309,
		292,
		273,
		262,
		254,
		243,
		259,
		267,
		262,
		244,
		253,
		259,
		283,
		273,
		279,
		-1,
		-1,
		378,
		368,
		352,
		354,
		351,
		321,
		328,
		360,
		332,
		345,
		-1,
		299,
		-1,
		288,
		283,
		267,
		262,
		259,
		256,
		250,
		259,
		261,
		251,
		246,
		253,
		288,
		288,
		263,
		283,
		286,
		-1,
		-1,
		-1,
		371,
		366,
		341,
		318,
		302,
		338,
		-1,
		315,
		316,
		-1,
		293,
		287,
		284,
		269,
		265,
		260,
		264,
		257,
		264,
		257,
		255,
		256,
		238,
		270,
		-1,
		271,
		265,
		273,
		263,
		251,
		-1,
		-1,
		-1,
		364,
		343,
		336,
		356,
		297,
		349,
		-1,
		-1,
		300,
		293,
		-1,
		280,
		262,
		269,
		267,
		261,
		265,
		262,
		251,
		264,
		257,
		243,
		245,
		258,
		262,
		266,
		253,
		249,
		246,
		260,
		-1,
		383,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		317,
		-1,
		309,
		301,
		291,
		285,
		279,
		275,
		273,
		289,
		273,
		276,
		274,
		265,
		273,
		246,
		239,
		246,
		235,
		253,
		261,
		253,
		247,
		246,
		256,
		-1,
		384,
		370,
		341,
		-1,
		-1,
		330,
		-1,
		294,
		308,
		324,
		-1,
		317,
		296,
		311,
		289,
		285,
		281,
		296,
		297,
		274,
		274,
		272,
		263,
		251,
		240,
		243,
		235,
		257,
		257,
		241,
		242,
		246,
		-1,
		390,
		377,
		335,
		331,
		320,
		340,
		291,
		279,
		311,
		-1,
		-1,
		353,
		-1,
		287,
		304,
		295,
		293,
		286,
		268,
		275,
		283,
		260,
		255,
		245,
		234,
		234,
		229,
		251,
		237,
		235,
		244,
		260,
		-1,
		-1,
		-1,
		357,
		-1,
		-1,
		306,
		293,
		287,
		-1,
		328,
		-1,
		331,
		321,
		305,
		290,
		323,
		-1,
		267,
		263,
		270,
		-1,
		280,
		-1,
		253,
		250,
		241,
		226,
		223,
		234,
		232,
		243,
		239,
		-1,
		340,
		325,
		318,
		308,
		322,
		293,
		-1,
		348,
		-1,
		-1,
		318,
		312,
		312,
		296,
		297,
		283,
		263,
		255,
		270,
		269,
		256,
		255,
		239,
		232,
		229,
		222,
		235,
		245,
		250,
		237,
		-1,
		-1,
		-1,
		345,
		331,
		335,
		295,
		314,
		-1,
		-1,
		380,
		335,
		321,
		-1,
		292,
		283,
		271,
		261,
		251,
		256,
		257,
		247,
		245,
		237,
		239,
		233,
		224,
		223,
		239,
		231,
		253,
		-1,
		-1,
		328,
		333,
		321,
		307,
		326,
		-1,
		-1,
		-1,
		327,
		343,
		311,
		290,
		272,
		-1,
		-1,
		255,
		248,
		242,
		245,
		233,
		253,
		248,
		232,
		217,
		232,
		236,
		244,
		235,
		-1,
		331,
		318,
		-1,
		-1,
		329,
		323,
		-1,
		-1,
		-1,
		-1,
		323,
		268,
		257,
		252,
		256,
		254,
		-1,
		228,
		239,
		232,
		251,
		258,
		234,
		219,
		213,
		219,
		231,
		240,
		-1,
		-1,
		343,
		-1,
		316,
		-1,
		-1,
		-1,
		-1,
		280,
		274,
		245,
		238,
		242,
		-1,
		230,
		232,
		229,
		241,
		237,
		234,
		225,
		216,
		212,
		216,
		220,
		234,
		238,
		366,
		-1,
		307,
		-1,
		-1,
		-1,
		298,
		313,
		284,
		261,
		234,
		229,
		222,
		216,
		221,
		232,
		241,
		252,
		217,
		219,
		209,
		208,
		212,
		229,
		233,
		-1,
		-1,
		305,
		301,
		324,
		306,
		310,
		311,
		-1,
		-1,
		238,
		229,
		220,
		212,
		225,
		228,
		213,
		215,
		215,
		213,
		207,
		217,
		232,
		227,
		-1,
		-1,
		-1,
		317,
		-1,
		319,
		-1,
		-1,
		308,
		309,
		256,
		238,
		234,
		232,
		221,
		215,
		203,
		208,
		218,
		212,
		209,
		203,
		207,
		230,
		219,
		258,
		-1,
		-1,
		379,
		-1,
		-1,
		-1,
		297,
		288,
		283,
		290,
		292,
		283,
		271,
		268,
		-1,
		238,
		244,
		209,
		216,
		199,
		206,
		211,
		208,
		197,
		204,
		220,
		219,
		214,
		250,
		241,
		247,
		-1,
		-1,
		372,
		361,
		350,
		356,
		-1,
		290,
		285,
		276,
		266,
		269,
		-1,
		-1,
		263,
		260,
		240,
		209,
		207,
		200,
		195,
		205,
		181,
		193,
		197,
		201,
		207,
		212,
		217,
		223,
		238,
		253,
		-1,
		326,
		363,
		356,
		324,
		332,
		363,
		-1,
		280,
		272,
		282,
		258,
		260,
		-1,
		-1,
		236,
		227,
		228,
		216,
		213,
		219,
		218,
		201,
		207,
		208,
		200,
		199,
		217,
		221,
		230,
		237,
		227,
		240,
		244,
		-1,
		319,
		339,
		318,
		321,
		345,
		359,
		-1,
		277,
		-1,
		-1,
		242,
		261,
		245,
		235,
		232,
		275,
		230,
		225,
		206,
		204,
		199,
		190,
		215,
		208,
		208,
		211,
		226,
		231,
		223,
		237,
		237,
		238,
		-1,
		308,
		319,
		312,
		-1,
		-1,
		-1,
		-1,
		278,
		-1,
		-1,
		232,
		-1,
		272,
		-1,
		255,
		259,
		238,
		241,
		220,
		207,
		193,
		201,
		207,
		206,
		212,
		212,
		213,
		222,
		233,
		245,
		244,
		245,
		333,
		289,
		292,
		303,
		314,
		329,
		333,
		-1,
		289,
		328,
		238,
		-1,
		222,
		-1,
		-1,
		-1,
		269,
		251,
		243,
		240,
		219,
		219,
		185,
		189,
		202,
		209,
		219,
		230,
		222,
		226,
		239,
		250,
		253,
		329,
		320,
		333,
		278,
		278,
		299,
		308,
		329,
		293,
		290,
		322,
		245,
		234,
		229,
		216,
		-1,
		-1,
		253,
		261,
		-1,
		-1,
		226,
		193,
		181,
		191,
		195,
		209,
		221,
		234,
		222,
		227,
		221,
		253,
		-1,
		322,
		321,
		310,
		307,
		283,
		274,
		269,
		296,
		-1,
		-1,
		291,
		318,
		301,
		278,
		276,
		301,
		-1,
		205,
		-1,
		-1,
		233,
		-1,
		-1,
		218,
		198,
		187,
		178,
		183,
		203,
		214,
		236,
		218,
		235,
		226,
		236,
		240,
		306,
		303,
		291,
		289,
		312,
		277,
		265,
		-1,
		273,
		276,
		282,
		289,
		279,
		290,
		-1,
		-1,
		221,
		201,
		-1,
		-1,
		216,
		214,
		203,
		-1,
		193,
		175,
		180,
		210,
		212,
		214,
		221,
		215,
		222,
		230,
		241,
		233,
		315,
		329,
		318,
		314,
		313,
		321,
		270,
		263,
		270,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		226,
		-1,
		211,
		207,
		-1,
		-1,
		211,
		204,
		192,
		180,
		170,
		180,
		197,
		197,
		200,
		205,
		213,
		224,
		220,
		224,
		227,
		-1,
		349,
		-1,
		301,
		262,
		268,
		283,
		291,
		-1,
		-1,
		-1,
		228,
		214,
		207,
		195,
		193,
		-1,
		245,
		229,
		210,
		-1,
		180,
		193,
		233,
		201,
		206,
		201,
		216,
		227,
		218,
		226,
		220,
		223,
		-1,
		-1,
		261,
		244,
		-1,
		-1,
		218,
		220,
		-1,
		219,
		208,
		193,
		185,
		-1,
		-1,
		217,
		213,
		-1,
		-1,
		167,
		205,
		204,
		212,
		207,
		212,
		224,
		220,
		216,
		226,
		217,
		-1,
		-1,
		239,
		231,
		225,
		-1,
		203,
		-1,
		221,
		-1,
		188,
		194,
		182,
		-1,
		-1,
		-1,
		198,
		161,
		177,
		200,
		226,
		224,
		215,
		208,
		215,
		218,
		211,
		217,
		-1,
		-1,
		-1,
		221,
		195,
		228,
		219,
		202,
		182,
		174,
		193,
		-1,
		179,
		-1,
		154,
		157,
		182,
		221,
		223,
		209,
		205,
		218,
		212,
		209,
		207,
		227,
		-1,
		197,
		230,
		194,
		188,
		164,
		168,
		193,
		-1,
		176,
		158,
		-1,
		186,
		176,
		224,
		199,
		208,
		201,
		195,
		196,
		204,
		-1,
		-1,
		-1,
		199,
		198,
		190,
		184,
		184,
		169,
		160,
		-1,
		181,
		163,
		149,
		166,
		166,
		157,
		165,
		214,
		210,
		213,
		211,
		189,
		-1,
		194,
		-1,
		-1,
		222,
		-1,
		-1,
		-1,
		193,
		186,
		161,
		149,
		150,
		146,
		146,
		148,
		161,
		169,
		167,
		164,
		176,
		172,
		192,
		188,
		220,
		-1,
		189,
		-1,
		229,
		-1,
		-1,
		183,
		170,
		180,
		172,
		161,
		159,
		145,
		141,
		158,
		193,
		179,
		177,
		182,
		187,
		-1,
		178,
		177,
		-1,
		171,
		181,
		180,
		-1,
		161,
		-1,
		207,
		168,
		-1,
		142,
		136,
		-1,
		188,
		184,
		-1,
		-1,
		165,
		160,
		-1,
		-1,
		-1,
		160,
		152,
		202,
		186,
		-1,
		126,
		133,
		-1,
		-1,
		-1,
		150,
		151,
		-1,
		146,
		156,
		-1,
		148,
		139,
		147,
		121,
		127,
		-1,
		-1,
		-1,
		159,
		140,
		134,
		136,
		131,
		161,
		160,
		146,
		129,
		108,
		118,
		147,
		-1,
		-1,
		-1,
		131,
		123,
		116,
		-1,
		-1,
		155,
		138,
		119,
		117,
		-1,
		-1,
		-1,
		153,
		134,
		-1,
		-1,
		108,
		-1,
		-1,
		112,
		93,
		-1,
		-1,
		-1,
		-1,
		-1,
		170,
		142,
		-1,
		-1,
		-1,
		104,
		100,
		96,
		-1,
		-1,
		-1,
		-1,
		164,
		165,
		188,
		152,
		-1,
		-1,
		-1,
		96,
		85,
		-1,
		-1,
		167,
		165,
		-1,
		-1,
		-1,
		124,
		108,
		-1,
		80,
		-1,
		-1,
		-1,
		115,
		-1,
		-1,
		100,
		-1,
		-1,
		-1,
		126,
		-1,
		83,
		62,
		62,
		-1,
		-1,
		-1,
		-1,
		121,
		122,
		96,
		-1,
		59,
		52,
		-1,
		0,
		-1,
		-1,
		136,
		102,
		-1,
		-1,
		49,
		53,
		18,
		14,
		155,
		-1,
		43
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		354,
		343,
		354,
		362,
		335,
		342,
		-1,
		361,
		365,
		331,
		325,
		364,
		333,
		339,
		350,
		-1,
		-1,
		-1,
		354,
		353,
		321,
		319,
		328,
		333,
		340,
		-1,
		339,
		-1,
		375,
		354,
		365,
		370,
		314,
		311,
		331,
		350,
		332,
		324,
		390,
		344,
		315,
		309,
		327,
		317,
		326,
		318,
		-1,
		315,
		305,
		327,
		306,
		317,
		309,
		-1,
		-1,
		309,
		310,
		316,
		302,
		308,
		304,
		-1,
		314,
		298,
		-1,
		-1,
		299,
		300,
		284,
		287,
		295,
		293,
		306,
		298,
		293,
		-1,
		-1,
		290,
		286,
		293,
		280,
		276,
		293,
		306,
		288,
		302,
		301,
		-1,
		294,
		312,
		319,
		287,
		285,
		269,
		267,
		285,
		287,
		293,
		293,
		-1,
		303,
		304,
		299,
		307,
		309,
		285,
		272,
		272,
		282,
		275,
		294,
		282,
		328,
		-1,
		-1,
		-1,
		-1,
		-1,
		337,
		303,
		286,
		303,
		295,
		285,
		300,
		293,
		275,
		272,
		270,
		267,
		283,
		281,
		291,
		-1,
		-1,
		396,
		365,
		394,
		352,
		333,
		-1,
		299,
		279,
		285,
		289,
		283,
		276,
		290,
		286,
		-1,
		261,
		260,
		288,
		274,
		285,
		356,
		-1,
		-1,
		354,
		346,
		329,
		332,
		309,
		305,
		294,
		293,
		285,
		271,
		267,
		273,
		276,
		276,
		282,
		255,
		265,
		269,
		267,
		292,
		-1,
		-1,
		327,
		-1,
		-1,
		353,
		336,
		-1,
		319,
		326,
		315,
		321,
		307,
		328,
		304,
		295,
		287,
		281,
		269,
		271,
		268,
		281,
		269,
		252,
		277,
		281,
		262,
		283,
		278,
		-1,
		326,
		310,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		331,
		312,
		315,
		321,
		345,
		344,
		-1,
		316,
		304,
		305,
		290,
		287,
		274,
		262,
		275,
		260,
		267,
		266,
		256,
		254,
		284,
		259,
		281,
		278,
		297,
		302,
		296,
		305,
		-1,
		361,
		357,
		353,
		360,
		309,
		-1,
		-1,
		349,
		-1,
		352,
		353,
		328,
		301,
		304,
		291,
		282,
		269,
		258,
		269,
		258,
		255,
		263,
		248,
		263,
		254,
		253,
		271,
		281,
		289,
		293,
		299,
		-1,
		411,
		-1,
		353,
		337,
		339,
		311,
		332,
		-1,
		369,
		353,
		345,
		330,
		330,
		-1,
		300,
		297,
		287,
		265,
		250,
		267,
		259,
		257,
		261,
		243,
		257,
		248,
		266,
		273,
		271,
		275,
		295,
		307,
		371,
		361,
		-1,
		343,
		348,
		307,
		315,
		334,
		372,
		336,
		-1,
		331,
		-1,
		302,
		315,
		-1,
		271,
		267,
		249,
		250,
		245,
		260,
		254,
		239,
		236,
		254,
		257,
		264,
		268,
		284,
		-1,
		-1,
		356,
		360,
		349,
		300,
		319,
		343,
		380,
		329,
		318,
		317,
		-1,
		308,
		285,
		282,
		270,
		257,
		242,
		243,
		251,
		264,
		243,
		238,
		235,
		255,
		281,
		259,
		271,
		-1,
		-1,
		-1,
		381,
		-1,
		-1,
		326,
		297,
		321,
		363,
		347,
		340,
		328,
		293,
		293,
		287,
		-1,
		281,
		260,
		251,
		240,
		238,
		251,
		248,
		253,
		233,
		231,
		250,
		262,
		253,
		270,
		-1,
		-1,
		-1,
		356,
		345,
		346,
		292,
		315,
		352,
		326,
		312,
		317,
		292,
		285,
		279,
		294,
		277,
		258,
		247,
		239,
		228,
		244,
		252,
		247,
		229,
		238,
		244,
		268,
		258,
		264,
		-1,
		-1,
		363,
		353,
		337,
		339,
		336,
		306,
		313,
		345,
		317,
		330,
		-1,
		284,
		-1,
		273,
		268,
		252,
		247,
		244,
		241,
		235,
		244,
		246,
		236,
		231,
		238,
		273,
		273,
		248,
		268,
		271,
		-1,
		-1,
		-1,
		356,
		351,
		326,
		303,
		287,
		323,
		-1,
		300,
		301,
		-1,
		278,
		272,
		269,
		254,
		250,
		245,
		249,
		242,
		249,
		242,
		240,
		241,
		223,
		255,
		-1,
		256,
		250,
		258,
		248,
		236,
		-1,
		-1,
		-1,
		349,
		328,
		321,
		341,
		282,
		334,
		-1,
		-1,
		285,
		278,
		-1,
		265,
		247,
		254,
		252,
		246,
		250,
		247,
		236,
		249,
		242,
		228,
		230,
		243,
		247,
		251,
		238,
		234,
		231,
		245,
		-1,
		368,
		-1,
		-1,
		-1,
		-1,
		-1,
		282,
		302,
		-1,
		294,
		286,
		276,
		270,
		264,
		260,
		258,
		274,
		258,
		261,
		259,
		250,
		258,
		231,
		224,
		231,
		220,
		238,
		246,
		238,
		232,
		231,
		241,
		-1,
		369,
		355,
		326,
		-1,
		-1,
		315,
		-1,
		279,
		293,
		309,
		-1,
		302,
		281,
		296,
		274,
		270,
		266,
		281,
		282,
		259,
		259,
		257,
		248,
		236,
		225,
		228,
		220,
		242,
		242,
		226,
		227,
		231,
		-1,
		375,
		362,
		320,
		316,
		305,
		325,
		276,
		264,
		296,
		-1,
		-1,
		338,
		-1,
		272,
		289,
		280,
		278,
		271,
		253,
		260,
		268,
		245,
		240,
		230,
		219,
		219,
		214,
		236,
		222,
		220,
		229,
		245,
		-1,
		-1,
		-1,
		342,
		-1,
		-1,
		291,
		278,
		272,
		-1,
		313,
		-1,
		316,
		306,
		290,
		275,
		308,
		-1,
		252,
		248,
		255,
		-1,
		265,
		-1,
		238,
		235,
		226,
		211,
		208,
		219,
		217,
		228,
		224,
		-1,
		325,
		310,
		303,
		293,
		307,
		278,
		-1,
		333,
		-1,
		-1,
		303,
		297,
		297,
		281,
		282,
		268,
		248,
		240,
		255,
		254,
		241,
		240,
		224,
		217,
		214,
		207,
		220,
		230,
		235,
		222,
		-1,
		-1,
		-1,
		330,
		316,
		320,
		280,
		299,
		-1,
		-1,
		365,
		320,
		306,
		-1,
		277,
		268,
		256,
		246,
		236,
		241,
		242,
		232,
		230,
		222,
		224,
		218,
		209,
		208,
		224,
		216,
		238,
		-1,
		-1,
		313,
		318,
		306,
		292,
		311,
		-1,
		-1,
		-1,
		312,
		328,
		296,
		275,
		257,
		-1,
		-1,
		240,
		233,
		227,
		230,
		218,
		238,
		233,
		217,
		202,
		217,
		221,
		229,
		220,
		-1,
		316,
		303,
		-1,
		-1,
		314,
		308,
		-1,
		-1,
		-1,
		-1,
		308,
		253,
		242,
		237,
		241,
		239,
		-1,
		213,
		224,
		217,
		236,
		243,
		219,
		204,
		198,
		204,
		216,
		225,
		-1,
		-1,
		328,
		-1,
		301,
		-1,
		-1,
		-1,
		-1,
		265,
		259,
		230,
		223,
		227,
		-1,
		215,
		217,
		214,
		226,
		222,
		219,
		210,
		201,
		197,
		201,
		205,
		219,
		223,
		351,
		-1,
		292,
		-1,
		-1,
		-1,
		283,
		298,
		269,
		246,
		219,
		214,
		207,
		201,
		206,
		217,
		226,
		237,
		202,
		204,
		194,
		193,
		197,
		214,
		218,
		-1,
		-1,
		290,
		286,
		309,
		291,
		295,
		296,
		-1,
		-1,
		223,
		214,
		205,
		197,
		210,
		213,
		198,
		200,
		200,
		198,
		192,
		202,
		217,
		212,
		-1,
		-1,
		-1,
		302,
		-1,
		304,
		-1,
		-1,
		293,
		294,
		241,
		223,
		219,
		217,
		206,
		200,
		188,
		193,
		203,
		197,
		194,
		188,
		192,
		215,
		204,
		243,
		-1,
		-1,
		361,
		-1,
		-1,
		-1,
		282,
		273,
		268,
		275,
		277,
		268,
		256,
		253,
		-1,
		223,
		229,
		194,
		201,
		184,
		191,
		196,
		193,
		182,
		189,
		205,
		204,
		199,
		235,
		226,
		232,
		-1,
		-1,
		354,
		343,
		332,
		338,
		-1,
		275,
		270,
		261,
		251,
		254,
		-1,
		-1,
		248,
		245,
		225,
		194,
		192,
		185,
		180,
		190,
		166,
		178,
		182,
		186,
		192,
		197,
		202,
		208,
		223,
		238,
		-1,
		308,
		345,
		338,
		306,
		314,
		345,
		-1,
		265,
		257,
		267,
		243,
		245,
		-1,
		-1,
		221,
		212,
		213,
		201,
		198,
		204,
		203,
		186,
		192,
		193,
		185,
		184,
		202,
		206,
		215,
		222,
		212,
		225,
		229,
		-1,
		301,
		321,
		300,
		303,
		327,
		341,
		-1,
		262,
		-1,
		-1,
		227,
		246,
		230,
		220,
		217,
		260,
		215,
		210,
		191,
		189,
		184,
		175,
		200,
		193,
		193,
		196,
		211,
		216,
		208,
		222,
		222,
		223,
		-1,
		290,
		301,
		294,
		-1,
		-1,
		-1,
		-1,
		263,
		-1,
		-1,
		217,
		-1,
		257,
		-1,
		240,
		244,
		223,
		226,
		205,
		192,
		178,
		186,
		192,
		191,
		197,
		197,
		198,
		207,
		218,
		230,
		229,
		230,
		315,
		271,
		274,
		285,
		296,
		311,
		315,
		-1,
		274,
		313,
		223,
		-1,
		207,
		-1,
		-1,
		-1,
		254,
		236,
		228,
		225,
		204,
		204,
		170,
		174,
		187,
		194,
		204,
		215,
		207,
		211,
		224,
		235,
		238,
		311,
		302,
		315,
		260,
		260,
		281,
		290,
		311,
		275,
		272,
		307,
		230,
		219,
		214,
		201,
		-1,
		-1,
		238,
		246,
		-1,
		-1,
		211,
		178,
		166,
		176,
		180,
		194,
		206,
		219,
		207,
		212,
		206,
		238,
		-1,
		304,
		303,
		292,
		289,
		265,
		256,
		251,
		278,
		-1,
		-1,
		273,
		300,
		284,
		263,
		261,
		286,
		-1,
		190,
		-1,
		-1,
		218,
		-1,
		-1,
		203,
		183,
		172,
		163,
		168,
		188,
		199,
		221,
		203,
		220,
		211,
		221,
		225,
		288,
		285,
		273,
		271,
		294,
		259,
		247,
		-1,
		255,
		258,
		264,
		271,
		264,
		275,
		-1,
		-1,
		206,
		186,
		-1,
		-1,
		201,
		199,
		188,
		-1,
		178,
		160,
		165,
		195,
		197,
		199,
		206,
		200,
		207,
		215,
		226,
		218,
		297,
		311,
		300,
		296,
		295,
		303,
		252,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		211,
		-1,
		196,
		192,
		-1,
		-1,
		196,
		189,
		177,
		165,
		155,
		165,
		182,
		182,
		185,
		190,
		198,
		209,
		205,
		209,
		212,
		-1,
		331,
		-1,
		283,
		244,
		250,
		265,
		273,
		-1,
		-1,
		-1,
		213,
		199,
		192,
		180,
		178,
		-1,
		230,
		214,
		195,
		-1,
		165,
		178,
		218,
		186,
		191,
		186,
		201,
		212,
		203,
		211,
		205,
		208,
		-1,
		-1,
		243,
		226,
		-1,
		-1,
		200,
		202,
		-1,
		204,
		193,
		178,
		170,
		-1,
		-1,
		202,
		198,
		-1,
		-1,
		152,
		190,
		189,
		197,
		192,
		197,
		209,
		205,
		201,
		211,
		202,
		-1,
		-1,
		221,
		213,
		207,
		-1,
		185,
		-1,
		206,
		-1,
		173,
		179,
		167,
		-1,
		-1,
		-1,
		183,
		146,
		162,
		185,
		211,
		209,
		200,
		193,
		200,
		203,
		196,
		202,
		-1,
		-1,
		-1,
		203,
		177,
		213,
		204,
		187,
		167,
		159,
		178,
		-1,
		164,
		-1,
		139,
		142,
		167,
		206,
		208,
		194,
		190,
		203,
		197,
		194,
		192,
		209,
		-1,
		179,
		212,
		176,
		173,
		149,
		153,
		178,
		-1,
		161,
		143,
		-1,
		171,
		161,
		209,
		184,
		193,
		186,
		180,
		181,
		189,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		154,
		145,
		-1,
		166,
		148,
		134,
		151,
		151,
		142,
		150,
		199,
		195,
		198,
		196,
		174,
		-1,
		167,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		159,
		146,
		134,
		135,
		131,
		131,
		133,
		146,
		154,
		152,
		149,
		161,
		157,
		177,
		173,
		205,
		-1,
		162,
		-1,
		211,
		-1,
		-1,
		156,
		143,
		153,
		157,
		146,
		144,
		130,
		126,
		143,
		178,
		164,
		162,
		167,
		172,
		-1,
		151,
		150,
		-1,
		144,
		154,
		153,
		-1,
		134,
		-1,
		192,
		153,
		-1,
		127,
		121,
		-1,
		173,
		169,
		-1,
		-1,
		138,
		133,
		-1,
		-1,
		-1,
		133,
		137,
		187,
		171,
		-1,
		111,
		118,
		-1,
		-1,
		-1,
		123,
		124,
		-1,
		119,
		129,
		-1,
		133,
		124,
		132,
		106,
		112,
		-1,
		-1,
		-1,
		132,
		113,
		107,
		109,
		104,
		134,
		145,
		131,
		115,
		93,
		103,
		132,
		-1,
		-1,
		-1,
		104,
		96,
		89,
		-1,
		-1,
		140,
		123,
		104,
		102,
		-1,
		-1,
		-1,
		126,
		107,
		-1,
		-1,
		80,
		-1,
		-1,
		99,
		78,
		-1,
		-1,
		-1,
		-1,
		-1,
		137,
		112,
		-1,
		-1,
		-1,
		75,
		69,
		83,
		-1,
		-1,
		-1,
		-1,
		116,
		116,
		133,
		87,
		-1,
		-1,
		-1,
		65,
		72,
		-1,
		-1,
		119,
		117,
		-1,
		-1,
		-1,
		59,
		46,
		-1,
		83,
		-1,
		-1,
		-1,
		37,
		-1,
		-1,
		116,
		-1,
		-1,
		-1,
		22,
		-1,
		118,
		93,
		100,
		-1,
		-1,
		-1,
		-1,
		17,
		18,
		131,
		-1,
		103,
		102,
		-1,
		116,
		-1,
		-1,
		0,
		27,
		-1,
		-1,
		99,
		103,
		100,
		103,
		66,
		-1,
		81
	],
	[
		-1,
		356,
		345,
		356,
		364,
		337,
		344,
		-1,
		363,
		367,
		333,
		327,
		366,
		335,
		341,
		352,
		-1,
		-1,
		-1,
		356,
		355,
		323,
		321,
		330,
		335,
		342,
		-1,
		341,
		-1,
		377,
		356,
		367,
		372,
		316,
		313,
		333,
		352,
		334,
		326,
		392,
		346,
		317,
		311,
		329,
		319,
		328,
		320,
		-1,
		317,
		307,
		329,
		308,
		319,
		311,
		-1,
		-1,
		311,
		312,
		318,
		304,
		310,
		306,
		-1,
		316,
		300,
		-1,
		-1,
		301,
		302,
		286,
		289,
		297,
		295,
		308,
		300,
		295,
		-1,
		-1,
		292,
		288,
		295,
		282,
		278,
		295,
		308,
		290,
		304,
		303,
		-1,
		296,
		314,
		321,
		289,
		287,
		271,
		269,
		287,
		289,
		295,
		295,
		-1,
		305,
		306,
		301,
		309,
		311,
		287,
		274,
		274,
		284,
		277,
		296,
		284,
		330,
		-1,
		-1,
		-1,
		-1,
		-1,
		339,
		305,
		288,
		305,
		297,
		287,
		302,
		295,
		277,
		274,
		272,
		269,
		285,
		283,
		293,
		-1,
		-1,
		398,
		367,
		396,
		354,
		335,
		-1,
		301,
		281,
		287,
		291,
		285,
		278,
		292,
		288,
		-1,
		263,
		262,
		290,
		276,
		287,
		358,
		-1,
		-1,
		356,
		348,
		331,
		334,
		311,
		307,
		296,
		295,
		287,
		273,
		269,
		275,
		278,
		278,
		284,
		257,
		267,
		271,
		269,
		294,
		-1,
		-1,
		329,
		-1,
		-1,
		355,
		338,
		-1,
		321,
		328,
		317,
		323,
		309,
		330,
		306,
		297,
		289,
		283,
		271,
		273,
		270,
		283,
		271,
		254,
		279,
		283,
		264,
		285,
		280,
		-1,
		328,
		312,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		333,
		314,
		317,
		323,
		347,
		346,
		-1,
		318,
		306,
		307,
		292,
		289,
		276,
		264,
		277,
		262,
		269,
		268,
		258,
		256,
		286,
		261,
		283,
		280,
		299,
		304,
		298,
		307,
		-1,
		363,
		359,
		355,
		362,
		311,
		-1,
		-1,
		351,
		-1,
		354,
		355,
		330,
		303,
		306,
		293,
		284,
		271,
		260,
		271,
		260,
		257,
		265,
		250,
		265,
		256,
		255,
		273,
		283,
		291,
		295,
		301,
		-1,
		413,
		-1,
		355,
		339,
		341,
		313,
		334,
		-1,
		371,
		355,
		347,
		332,
		332,
		-1,
		302,
		299,
		289,
		267,
		252,
		269,
		261,
		259,
		263,
		245,
		259,
		250,
		268,
		275,
		273,
		277,
		297,
		309,
		373,
		363,
		-1,
		345,
		350,
		309,
		317,
		336,
		374,
		338,
		-1,
		333,
		-1,
		304,
		317,
		-1,
		273,
		269,
		251,
		252,
		247,
		262,
		256,
		241,
		238,
		256,
		259,
		266,
		270,
		286,
		-1,
		-1,
		358,
		362,
		351,
		302,
		321,
		345,
		382,
		331,
		320,
		319,
		-1,
		310,
		287,
		284,
		272,
		259,
		244,
		245,
		253,
		266,
		245,
		240,
		237,
		257,
		283,
		261,
		273,
		-1,
		-1,
		-1,
		383,
		-1,
		-1,
		328,
		299,
		323,
		365,
		349,
		342,
		330,
		295,
		295,
		289,
		-1,
		283,
		262,
		253,
		242,
		240,
		253,
		250,
		255,
		235,
		233,
		252,
		264,
		255,
		272,
		-1,
		-1,
		-1,
		358,
		347,
		348,
		294,
		317,
		354,
		328,
		314,
		319,
		294,
		287,
		281,
		296,
		279,
		260,
		249,
		241,
		230,
		246,
		254,
		249,
		231,
		240,
		246,
		270,
		260,
		266,
		-1,
		-1,
		365,
		355,
		339,
		341,
		338,
		308,
		315,
		347,
		319,
		332,
		-1,
		286,
		-1,
		275,
		270,
		254,
		249,
		246,
		243,
		237,
		246,
		248,
		238,
		233,
		240,
		275,
		275,
		250,
		270,
		273,
		-1,
		-1,
		-1,
		358,
		353,
		328,
		305,
		289,
		325,
		-1,
		302,
		303,
		-1,
		280,
		274,
		271,
		256,
		252,
		247,
		251,
		244,
		251,
		244,
		242,
		243,
		225,
		257,
		-1,
		258,
		252,
		260,
		250,
		238,
		-1,
		-1,
		-1,
		351,
		330,
		323,
		343,
		284,
		336,
		-1,
		-1,
		287,
		280,
		-1,
		267,
		249,
		256,
		254,
		248,
		252,
		249,
		238,
		251,
		244,
		230,
		232,
		245,
		249,
		253,
		240,
		236,
		233,
		247,
		-1,
		370,
		-1,
		-1,
		-1,
		-1,
		-1,
		284,
		304,
		-1,
		296,
		288,
		278,
		272,
		266,
		262,
		260,
		276,
		260,
		263,
		261,
		252,
		260,
		233,
		226,
		233,
		222,
		240,
		248,
		240,
		234,
		233,
		243,
		-1,
		371,
		357,
		328,
		-1,
		-1,
		317,
		-1,
		281,
		295,
		311,
		-1,
		304,
		283,
		298,
		276,
		272,
		268,
		283,
		284,
		261,
		261,
		259,
		250,
		238,
		227,
		230,
		222,
		244,
		244,
		228,
		229,
		233,
		-1,
		377,
		364,
		322,
		318,
		307,
		327,
		278,
		266,
		298,
		-1,
		-1,
		340,
		-1,
		274,
		291,
		282,
		280,
		273,
		255,
		262,
		270,
		247,
		242,
		232,
		221,
		221,
		216,
		238,
		224,
		222,
		231,
		247,
		-1,
		-1,
		-1,
		344,
		-1,
		-1,
		293,
		280,
		274,
		-1,
		315,
		-1,
		318,
		308,
		292,
		277,
		310,
		-1,
		254,
		250,
		257,
		-1,
		267,
		-1,
		240,
		237,
		228,
		213,
		210,
		221,
		219,
		230,
		226,
		-1,
		327,
		312,
		305,
		295,
		309,
		280,
		-1,
		335,
		-1,
		-1,
		305,
		299,
		299,
		283,
		284,
		270,
		250,
		242,
		257,
		256,
		243,
		242,
		226,
		219,
		216,
		209,
		222,
		232,
		237,
		224,
		-1,
		-1,
		-1,
		332,
		318,
		322,
		282,
		301,
		-1,
		-1,
		367,
		322,
		308,
		-1,
		279,
		270,
		258,
		248,
		238,
		243,
		244,
		234,
		232,
		224,
		226,
		220,
		211,
		210,
		226,
		218,
		240,
		-1,
		-1,
		315,
		320,
		308,
		294,
		313,
		-1,
		-1,
		-1,
		314,
		330,
		298,
		277,
		259,
		-1,
		-1,
		242,
		235,
		229,
		232,
		220,
		240,
		235,
		219,
		204,
		219,
		223,
		231,
		222,
		-1,
		318,
		305,
		-1,
		-1,
		316,
		310,
		-1,
		-1,
		-1,
		-1,
		310,
		255,
		244,
		239,
		243,
		241,
		-1,
		215,
		226,
		219,
		238,
		245,
		221,
		206,
		200,
		206,
		218,
		227,
		-1,
		-1,
		330,
		-1,
		303,
		-1,
		-1,
		-1,
		-1,
		267,
		261,
		232,
		225,
		229,
		-1,
		217,
		219,
		216,
		228,
		224,
		221,
		212,
		203,
		199,
		203,
		207,
		221,
		225,
		353,
		-1,
		294,
		-1,
		-1,
		-1,
		285,
		300,
		271,
		248,
		221,
		216,
		209,
		203,
		208,
		219,
		228,
		239,
		204,
		206,
		196,
		195,
		199,
		216,
		220,
		-1,
		-1,
		292,
		288,
		311,
		293,
		297,
		298,
		-1,
		-1,
		225,
		216,
		207,
		199,
		212,
		215,
		200,
		202,
		202,
		200,
		194,
		204,
		219,
		214,
		-1,
		-1,
		-1,
		304,
		-1,
		306,
		-1,
		-1,
		295,
		296,
		243,
		225,
		221,
		219,
		208,
		202,
		190,
		195,
		205,
		199,
		196,
		190,
		194,
		217,
		206,
		245,
		-1,
		-1,
		363,
		-1,
		-1,
		-1,
		284,
		275,
		270,
		277,
		279,
		270,
		258,
		255,
		-1,
		225,
		231,
		196,
		203,
		186,
		193,
		198,
		195,
		184,
		191,
		207,
		206,
		201,
		237,
		228,
		234,
		-1,
		-1,
		356,
		345,
		334,
		340,
		-1,
		277,
		272,
		263,
		253,
		256,
		-1,
		-1,
		250,
		247,
		227,
		196,
		194,
		187,
		182,
		192,
		168,
		180,
		184,
		188,
		194,
		199,
		204,
		210,
		225,
		240,
		-1,
		310,
		347,
		340,
		308,
		316,
		347,
		-1,
		267,
		259,
		269,
		245,
		247,
		-1,
		-1,
		223,
		214,
		215,
		203,
		200,
		206,
		205,
		188,
		194,
		195,
		187,
		186,
		204,
		208,
		217,
		224,
		214,
		227,
		231,
		-1,
		303,
		323,
		302,
		305,
		329,
		343,
		-1,
		264,
		-1,
		-1,
		229,
		248,
		232,
		222,
		219,
		262,
		217,
		212,
		193,
		191,
		186,
		177,
		202,
		195,
		195,
		198,
		213,
		218,
		210,
		224,
		224,
		225,
		-1,
		292,
		303,
		296,
		-1,
		-1,
		-1,
		-1,
		265,
		-1,
		-1,
		219,
		-1,
		259,
		-1,
		242,
		246,
		225,
		228,
		207,
		194,
		180,
		188,
		194,
		193,
		199,
		199,
		200,
		209,
		220,
		232,
		231,
		232,
		317,
		273,
		276,
		287,
		298,
		313,
		317,
		-1,
		276,
		315,
		225,
		-1,
		209,
		-1,
		-1,
		-1,
		256,
		238,
		230,
		227,
		206,
		206,
		172,
		176,
		189,
		196,
		206,
		217,
		209,
		213,
		226,
		237,
		240,
		313,
		304,
		317,
		262,
		262,
		283,
		292,
		313,
		277,
		274,
		309,
		232,
		221,
		216,
		203,
		-1,
		-1,
		240,
		248,
		-1,
		-1,
		213,
		180,
		168,
		178,
		182,
		196,
		208,
		221,
		209,
		214,
		208,
		240,
		-1,
		306,
		305,
		294,
		291,
		267,
		258,
		253,
		280,
		-1,
		-1,
		275,
		302,
		286,
		265,
		263,
		288,
		-1,
		192,
		-1,
		-1,
		220,
		-1,
		-1,
		205,
		185,
		174,
		165,
		170,
		190,
		201,
		223,
		205,
		222,
		213,
		223,
		227,
		290,
		287,
		275,
		273,
		296,
		261,
		249,
		-1,
		257,
		260,
		266,
		273,
		266,
		277,
		-1,
		-1,
		208,
		188,
		-1,
		-1,
		203,
		201,
		190,
		-1,
		180,
		162,
		167,
		197,
		199,
		201,
		208,
		202,
		209,
		217,
		228,
		220,
		299,
		313,
		302,
		298,
		297,
		305,
		254,
		247,
		254,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		213,
		-1,
		198,
		194,
		-1,
		-1,
		198,
		191,
		179,
		167,
		157,
		167,
		184,
		184,
		187,
		192,
		200,
		211,
		207,
		211,
		214,
		-1,
		333,
		-1,
		285,
		246,
		252,
		267,
		275,
		-1,
		-1,
		-1,
		215,
		201,
		194,
		182,
		180,
		-1,
		232,
		216,
		197,
		-1,
		167,
		180,
		220,
		188,
		193,
		188,
		203,
		214,
		205,
		213,
		207,
		210,
		-1,
		-1,
		245,
		228,
		-1,
		-1,
		202,
		204,
		-1,
		206,
		195,
		180,
		172,
		-1,
		-1,
		204,
		200,
		-1,
		-1,
		154,
		192,
		191,
		199,
		194,
		199,
		211,
		207,
		203,
		213,
		204,
		-1,
		-1,
		223,
		215,
		209,
		-1,
		187,
		-1,
		208,
		-1,
		175,
		181,
		169,
		-1,
		-1,
		-1,
		185,
		148,
		164,
		187,
		213,
		211,
		202,
		195,
		202,
		205,
		198,
		204,
		-1,
		-1,
		-1,
		205,
		179,
		215,
		206,
		189,
		169,
		161,
		180,
		-1,
		166,
		-1,
		141,
		144,
		169,
		208,
		210,
		196,
		192,
		205,
		199,
		196,
		194,
		211,
		-1,
		181,
		214,
		178,
		175,
		151,
		155,
		180,
		-1,
		163,
		145,
		-1,
		173,
		163,
		211,
		186,
		195,
		188,
		182,
		183,
		191,
		-1,
		-1,
		-1,
		183,
		182,
		174,
		168,
		168,
		156,
		147,
		-1,
		168,
		150,
		136,
		153,
		153,
		144,
		152,
		201,
		197,
		200,
		198,
		176,
		-1,
		169,
		-1,
		-1,
		206,
		-1,
		-1,
		-1,
		177,
		161,
		148,
		136,
		137,
		133,
		133,
		135,
		148,
		156,
		154,
		151,
		163,
		159,
		179,
		175,
		207,
		-1,
		164,
		-1,
		213,
		-1,
		-1,
		158,
		145,
		155,
		159,
		148,
		146,
		132,
		128,
		145,
		180,
		166,
		164,
		169,
		174,
		-1,
		153,
		152,
		-1,
		146,
		156,
		155,
		-1,
		136,
		-1,
		194,
		155,
		-1,
		129,
		123,
		-1,
		175,
		171,
		-1,
		-1,
		140,
		135,
		-1,
		-1,
		-1,
		135,
		139,
		189,
		173,
		-1,
		113,
		120,
		-1,
		-1,
		-1,
		125,
		126,
		-1,
		121,
		131,
		-1,
		135,
		126,
		134,
		108,
		114,
		-1,
		-1,
		-1,
		134,
		115,
		109,
		111,
		106,
		136,
		147,
		133,
		117,
		95,
		105,
		134,
		-1,
		-1,
		-1,
		106,
		98,
		91,
		-1,
		-1,
		142,
		125,
		106,
		104,
		-1,
		-1,
		-1,
		128,
		109,
		-1,
		-1,
		82,
		-1,
		-1,
		101,
		80,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		114,
		-1,
		-1,
		-1,
		77,
		71,
		85,
		-1,
		-1,
		-1,
		-1,
		118,
		118,
		135,
		89,
		-1,
		-1,
		-1,
		67,
		74,
		-1,
		-1,
		121,
		119,
		-1,
		-1,
		-1,
		61,
		48,
		-1,
		85,
		-1,
		-1,
		-1,
		39,
		-1,
		-1,
		118,
		-1,
		-1,
		-1,
		24,
		-1,
		106,
		85,
		85,
		-1,
		-1,
		-1,
		-1,
		19,
		20,
		119,
		-1,
		82,
		75,
		-1,
		89,
		-1,
		-1,
		34,
		0,
		-1,
		-1,
		72,
		76,
		73,
		76,
		53,
		-1,
		54
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		320,
		309,
		320,
		328,
		301,
		308,
		-1,
		327,
		331,
		297,
		291,
		330,
		299,
		305,
		316,
		-1,
		-1,
		-1,
		320,
		319,
		287,
		285,
		294,
		299,
		306,
		-1,
		305,
		-1,
		341,
		320,
		331,
		336,
		280,
		277,
		297,
		316,
		298,
		290,
		356,
		310,
		281,
		275,
		293,
		283,
		292,
		284,
		-1,
		281,
		271,
		293,
		272,
		283,
		275,
		-1,
		-1,
		275,
		276,
		282,
		268,
		274,
		270,
		-1,
		280,
		264,
		-1,
		-1,
		265,
		266,
		250,
		253,
		261,
		259,
		272,
		264,
		259,
		-1,
		-1,
		256,
		252,
		259,
		246,
		242,
		259,
		272,
		254,
		268,
		267,
		-1,
		260,
		278,
		285,
		253,
		251,
		235,
		233,
		251,
		253,
		259,
		259,
		-1,
		269,
		270,
		265,
		273,
		275,
		251,
		238,
		238,
		248,
		241,
		260,
		248,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		303,
		269,
		252,
		269,
		261,
		251,
		266,
		259,
		241,
		238,
		236,
		233,
		249,
		247,
		257,
		-1,
		-1,
		362,
		331,
		360,
		318,
		299,
		-1,
		265,
		245,
		251,
		255,
		249,
		242,
		256,
		252,
		-1,
		227,
		226,
		254,
		240,
		251,
		322,
		-1,
		-1,
		320,
		312,
		295,
		298,
		275,
		271,
		260,
		259,
		251,
		237,
		233,
		239,
		242,
		242,
		248,
		221,
		231,
		235,
		233,
		258,
		-1,
		-1,
		293,
		-1,
		-1,
		319,
		302,
		-1,
		285,
		292,
		281,
		287,
		273,
		294,
		270,
		261,
		253,
		247,
		235,
		237,
		234,
		247,
		235,
		218,
		243,
		247,
		228,
		249,
		244,
		-1,
		292,
		276,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		297,
		278,
		281,
		287,
		311,
		310,
		-1,
		282,
		270,
		271,
		256,
		253,
		240,
		228,
		241,
		226,
		233,
		232,
		222,
		220,
		250,
		225,
		247,
		244,
		263,
		268,
		262,
		271,
		-1,
		327,
		323,
		319,
		326,
		275,
		-1,
		-1,
		315,
		-1,
		318,
		319,
		294,
		267,
		270,
		257,
		248,
		235,
		224,
		235,
		224,
		221,
		229,
		214,
		229,
		220,
		219,
		237,
		247,
		255,
		259,
		265,
		-1,
		377,
		-1,
		319,
		303,
		305,
		277,
		298,
		-1,
		335,
		319,
		311,
		296,
		296,
		-1,
		266,
		263,
		253,
		231,
		216,
		233,
		225,
		223,
		227,
		209,
		223,
		214,
		232,
		239,
		237,
		241,
		261,
		273,
		337,
		327,
		-1,
		309,
		314,
		273,
		281,
		300,
		338,
		302,
		-1,
		297,
		-1,
		268,
		281,
		-1,
		237,
		233,
		215,
		216,
		211,
		226,
		220,
		205,
		202,
		220,
		223,
		230,
		234,
		250,
		-1,
		-1,
		322,
		326,
		315,
		266,
		285,
		309,
		346,
		295,
		284,
		283,
		-1,
		274,
		251,
		248,
		236,
		223,
		208,
		209,
		217,
		230,
		209,
		204,
		201,
		221,
		247,
		225,
		237,
		-1,
		-1,
		-1,
		347,
		-1,
		-1,
		292,
		263,
		287,
		329,
		313,
		306,
		294,
		259,
		259,
		253,
		-1,
		247,
		226,
		217,
		206,
		204,
		217,
		214,
		219,
		199,
		197,
		216,
		228,
		219,
		236,
		-1,
		-1,
		-1,
		322,
		311,
		312,
		258,
		281,
		318,
		292,
		278,
		283,
		258,
		251,
		245,
		260,
		243,
		224,
		213,
		205,
		194,
		210,
		218,
		213,
		195,
		204,
		210,
		234,
		224,
		230,
		-1,
		-1,
		329,
		319,
		303,
		305,
		302,
		272,
		279,
		311,
		283,
		296,
		-1,
		250,
		-1,
		239,
		234,
		218,
		213,
		210,
		207,
		201,
		210,
		212,
		202,
		197,
		204,
		239,
		239,
		214,
		234,
		237,
		-1,
		-1,
		-1,
		322,
		317,
		292,
		269,
		253,
		289,
		-1,
		266,
		267,
		-1,
		244,
		238,
		235,
		220,
		216,
		211,
		215,
		208,
		215,
		208,
		206,
		207,
		189,
		221,
		-1,
		222,
		216,
		224,
		214,
		202,
		-1,
		-1,
		-1,
		315,
		294,
		287,
		307,
		248,
		300,
		-1,
		-1,
		251,
		244,
		-1,
		231,
		213,
		220,
		218,
		212,
		216,
		213,
		202,
		215,
		208,
		194,
		196,
		209,
		213,
		217,
		204,
		200,
		197,
		211,
		-1,
		334,
		-1,
		-1,
		-1,
		-1,
		-1,
		248,
		268,
		-1,
		260,
		252,
		242,
		236,
		230,
		226,
		224,
		240,
		224,
		227,
		225,
		216,
		224,
		197,
		190,
		197,
		186,
		204,
		212,
		204,
		198,
		197,
		207,
		-1,
		335,
		321,
		292,
		-1,
		-1,
		281,
		-1,
		245,
		259,
		275,
		-1,
		268,
		247,
		262,
		240,
		236,
		232,
		247,
		248,
		225,
		225,
		223,
		214,
		202,
		191,
		194,
		186,
		208,
		208,
		192,
		193,
		197,
		-1,
		341,
		328,
		286,
		282,
		271,
		291,
		242,
		230,
		262,
		-1,
		-1,
		304,
		-1,
		238,
		255,
		246,
		244,
		237,
		219,
		226,
		234,
		211,
		206,
		196,
		185,
		185,
		180,
		202,
		188,
		186,
		195,
		211,
		-1,
		-1,
		-1,
		308,
		-1,
		-1,
		257,
		244,
		238,
		-1,
		279,
		-1,
		282,
		272,
		256,
		241,
		274,
		-1,
		218,
		214,
		221,
		-1,
		231,
		-1,
		204,
		201,
		192,
		177,
		174,
		185,
		183,
		194,
		190,
		-1,
		291,
		276,
		269,
		259,
		273,
		244,
		-1,
		299,
		-1,
		-1,
		269,
		263,
		263,
		247,
		248,
		234,
		214,
		206,
		221,
		220,
		207,
		206,
		190,
		183,
		180,
		173,
		186,
		196,
		201,
		188,
		-1,
		-1,
		-1,
		296,
		282,
		286,
		246,
		265,
		-1,
		-1,
		331,
		286,
		272,
		-1,
		243,
		234,
		222,
		212,
		202,
		207,
		208,
		198,
		196,
		188,
		190,
		184,
		175,
		174,
		190,
		182,
		204,
		-1,
		-1,
		279,
		284,
		272,
		258,
		277,
		-1,
		-1,
		-1,
		278,
		294,
		262,
		241,
		223,
		-1,
		-1,
		206,
		199,
		193,
		196,
		184,
		204,
		199,
		183,
		168,
		183,
		187,
		195,
		186,
		-1,
		282,
		269,
		-1,
		-1,
		280,
		274,
		-1,
		-1,
		-1,
		-1,
		274,
		219,
		208,
		203,
		207,
		205,
		-1,
		179,
		190,
		183,
		202,
		209,
		185,
		170,
		164,
		170,
		182,
		191,
		-1,
		-1,
		294,
		-1,
		267,
		-1,
		-1,
		-1,
		-1,
		231,
		225,
		196,
		189,
		193,
		-1,
		181,
		183,
		180,
		192,
		188,
		185,
		176,
		167,
		163,
		167,
		171,
		185,
		189,
		317,
		-1,
		258,
		-1,
		-1,
		-1,
		249,
		264,
		235,
		212,
		185,
		180,
		173,
		167,
		172,
		183,
		192,
		203,
		168,
		170,
		160,
		159,
		163,
		180,
		184,
		-1,
		-1,
		256,
		252,
		275,
		257,
		261,
		262,
		-1,
		-1,
		189,
		180,
		171,
		163,
		176,
		179,
		164,
		166,
		166,
		164,
		158,
		168,
		183,
		178,
		-1,
		-1,
		-1,
		268,
		-1,
		270,
		-1,
		-1,
		259,
		260,
		207,
		189,
		185,
		183,
		172,
		166,
		154,
		159,
		169,
		163,
		160,
		154,
		158,
		181,
		170,
		209,
		-1,
		-1,
		330,
		-1,
		-1,
		-1,
		248,
		239,
		234,
		241,
		243,
		234,
		222,
		219,
		-1,
		189,
		195,
		160,
		167,
		150,
		157,
		162,
		159,
		148,
		155,
		171,
		170,
		165,
		201,
		192,
		198,
		-1,
		-1,
		323,
		312,
		301,
		307,
		-1,
		241,
		236,
		227,
		217,
		220,
		-1,
		-1,
		214,
		211,
		191,
		160,
		158,
		151,
		146,
		156,
		132,
		144,
		148,
		152,
		158,
		163,
		168,
		174,
		189,
		204,
		-1,
		277,
		314,
		307,
		275,
		283,
		314,
		-1,
		231,
		223,
		233,
		209,
		211,
		-1,
		-1,
		187,
		178,
		179,
		167,
		164,
		170,
		169,
		152,
		158,
		159,
		151,
		150,
		168,
		172,
		181,
		188,
		178,
		191,
		195,
		-1,
		270,
		290,
		269,
		272,
		296,
		310,
		-1,
		228,
		-1,
		-1,
		193,
		212,
		196,
		186,
		183,
		226,
		181,
		176,
		157,
		155,
		150,
		141,
		166,
		159,
		159,
		162,
		177,
		182,
		174,
		188,
		188,
		189,
		-1,
		259,
		270,
		263,
		-1,
		-1,
		-1,
		-1,
		229,
		-1,
		-1,
		183,
		-1,
		223,
		-1,
		206,
		210,
		189,
		192,
		171,
		158,
		144,
		152,
		158,
		157,
		163,
		163,
		164,
		173,
		184,
		196,
		195,
		196,
		284,
		240,
		243,
		254,
		265,
		280,
		284,
		-1,
		240,
		279,
		189,
		-1,
		173,
		-1,
		-1,
		-1,
		220,
		202,
		194,
		191,
		170,
		170,
		136,
		140,
		153,
		160,
		170,
		181,
		173,
		177,
		190,
		201,
		204,
		280,
		271,
		284,
		229,
		229,
		250,
		259,
		280,
		244,
		241,
		273,
		196,
		185,
		180,
		167,
		-1,
		-1,
		204,
		212,
		-1,
		-1,
		177,
		144,
		132,
		142,
		146,
		160,
		172,
		185,
		173,
		178,
		172,
		204,
		-1,
		273,
		272,
		261,
		258,
		234,
		225,
		220,
		247,
		-1,
		-1,
		242,
		269,
		252,
		229,
		227,
		252,
		-1,
		156,
		-1,
		-1,
		184,
		-1,
		-1,
		169,
		149,
		138,
		129,
		134,
		154,
		165,
		187,
		169,
		186,
		177,
		187,
		191,
		257,
		254,
		242,
		240,
		263,
		228,
		216,
		-1,
		224,
		227,
		233,
		240,
		230,
		241,
		-1,
		-1,
		172,
		152,
		-1,
		-1,
		167,
		165,
		154,
		-1,
		144,
		126,
		131,
		161,
		163,
		165,
		172,
		166,
		173,
		181,
		192,
		184,
		266,
		280,
		269,
		265,
		264,
		272,
		221,
		214,
		221,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		177,
		-1,
		162,
		158,
		-1,
		-1,
		162,
		155,
		143,
		131,
		121,
		131,
		148,
		148,
		151,
		156,
		164,
		175,
		171,
		175,
		178,
		-1,
		300,
		-1,
		252,
		213,
		219,
		234,
		242,
		-1,
		-1,
		-1,
		179,
		165,
		158,
		146,
		144,
		-1,
		196,
		180,
		161,
		-1,
		131,
		144,
		184,
		152,
		157,
		152,
		167,
		178,
		169,
		177,
		171,
		174,
		-1,
		-1,
		212,
		195,
		-1,
		-1,
		169,
		171,
		-1,
		170,
		159,
		144,
		136,
		-1,
		-1,
		168,
		164,
		-1,
		-1,
		118,
		156,
		155,
		163,
		158,
		163,
		175,
		171,
		167,
		177,
		168,
		-1,
		-1,
		190,
		182,
		176,
		-1,
		154,
		-1,
		172,
		-1,
		139,
		145,
		133,
		-1,
		-1,
		-1,
		149,
		112,
		128,
		151,
		177,
		175,
		166,
		159,
		166,
		169,
		162,
		168,
		-1,
		-1,
		-1,
		172,
		146,
		179,
		170,
		153,
		133,
		125,
		144,
		-1,
		130,
		-1,
		105,
		108,
		133,
		172,
		174,
		160,
		156,
		169,
		163,
		160,
		158,
		178,
		-1,
		148,
		181,
		145,
		139,
		115,
		119,
		144,
		-1,
		127,
		109,
		-1,
		137,
		127,
		175,
		150,
		159,
		152,
		146,
		147,
		155,
		-1,
		-1,
		-1,
		150,
		149,
		141,
		135,
		135,
		120,
		111,
		-1,
		132,
		114,
		100,
		117,
		117,
		108,
		116,
		165,
		161,
		164,
		162,
		140,
		-1,
		145,
		-1,
		-1,
		173,
		-1,
		-1,
		-1,
		144,
		137,
		112,
		100,
		101,
		97,
		97,
		99,
		112,
		120,
		118,
		115,
		127,
		123,
		143,
		139,
		171,
		-1,
		140,
		-1,
		180,
		-1,
		-1,
		134,
		121,
		131,
		123,
		112,
		110,
		96,
		92,
		109,
		144,
		130,
		128,
		133,
		138,
		-1,
		129,
		128,
		-1,
		122,
		132,
		131,
		-1,
		112,
		-1,
		158,
		119,
		-1,
		93,
		87,
		-1,
		139,
		135,
		-1,
		-1,
		116,
		111,
		-1,
		-1,
		-1,
		111,
		103,
		153,
		137,
		-1,
		77,
		84,
		-1,
		-1,
		-1,
		101,
		102,
		-1,
		97,
		107,
		-1,
		99,
		90,
		98,
		72,
		78,
		-1,
		-1,
		-1,
		110,
		91,
		85,
		87,
		82,
		112,
		111,
		97,
		80,
		59,
		69,
		98,
		-1,
		-1,
		-1,
		82,
		74,
		67,
		-1,
		-1,
		106,
		89,
		70,
		68,
		-1,
		-1,
		-1,
		104,
		85,
		-1,
		-1,
		59,
		-1,
		-1,
		63,
		44,
		-1,
		-1,
		-1,
		-1,
		-1,
		121,
		93,
		-1,
		-1,
		-1,
		55,
		51,
		47,
		-1,
		-1,
		-1,
		-1,
		115,
		116,
		139,
		103,
		-1,
		-1,
		-1,
		47,
		36,
		-1,
		-1,
		118,
		116,
		-1,
		-1,
		-1,
		75,
		59,
		-1,
		31,
		-1,
		-1,
		-1,
		66,
		-1,
		-1,
		51,
		-1,
		-1,
		-1,
		80,
		-1,
		34,
		13,
		13,
		-1,
		-1,
		-1,
		-1,
		93,
		85,
		47,
		-1,
		10,
		3,
		-1,
		45,
		-1,
		-1,
		108,
		78,
		-1,
		-1,
		0,
		7,
		29,
		32,
		131,
		-1,
		19
	],
	[
		-1,
		333,
		322,
		333,
		341,
		314,
		321,
		-1,
		340,
		344,
		310,
		304,
		343,
		312,
		318,
		329,
		-1,
		-1,
		-1,
		333,
		332,
		300,
		298,
		307,
		312,
		319,
		-1,
		318,
		-1,
		354,
		333,
		344,
		349,
		293,
		290,
		310,
		329,
		311,
		303,
		369,
		323,
		294,
		288,
		306,
		296,
		305,
		297,
		-1,
		294,
		284,
		306,
		285,
		296,
		288,
		-1,
		-1,
		288,
		289,
		295,
		281,
		287,
		283,
		-1,
		293,
		277,
		-1,
		-1,
		278,
		279,
		263,
		266,
		274,
		272,
		285,
		277,
		272,
		-1,
		-1,
		269,
		265,
		272,
		259,
		255,
		272,
		285,
		267,
		281,
		280,
		-1,
		273,
		291,
		298,
		266,
		264,
		248,
		246,
		264,
		266,
		272,
		272,
		-1,
		282,
		283,
		278,
		286,
		288,
		264,
		251,
		251,
		261,
		254,
		273,
		261,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		316,
		282,
		265,
		282,
		274,
		264,
		279,
		272,
		254,
		251,
		249,
		246,
		262,
		260,
		270,
		-1,
		-1,
		375,
		344,
		373,
		331,
		312,
		-1,
		278,
		258,
		264,
		268,
		262,
		255,
		269,
		265,
		-1,
		240,
		239,
		267,
		253,
		264,
		335,
		-1,
		-1,
		333,
		325,
		308,
		311,
		288,
		284,
		273,
		272,
		264,
		250,
		246,
		252,
		255,
		255,
		261,
		234,
		244,
		248,
		246,
		271,
		-1,
		-1,
		306,
		-1,
		-1,
		332,
		315,
		-1,
		298,
		305,
		294,
		300,
		286,
		307,
		283,
		274,
		266,
		260,
		248,
		250,
		247,
		260,
		248,
		231,
		256,
		260,
		241,
		262,
		257,
		-1,
		305,
		289,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		310,
		291,
		294,
		300,
		324,
		323,
		-1,
		295,
		283,
		284,
		269,
		266,
		253,
		241,
		254,
		239,
		246,
		245,
		235,
		233,
		263,
		238,
		260,
		257,
		276,
		281,
		275,
		284,
		-1,
		340,
		336,
		332,
		339,
		288,
		-1,
		-1,
		328,
		-1,
		331,
		332,
		307,
		280,
		283,
		270,
		261,
		248,
		237,
		248,
		237,
		234,
		242,
		227,
		242,
		233,
		232,
		250,
		260,
		268,
		272,
		278,
		-1,
		390,
		-1,
		332,
		316,
		318,
		290,
		311,
		-1,
		348,
		332,
		324,
		309,
		309,
		-1,
		279,
		276,
		266,
		244,
		229,
		246,
		238,
		236,
		240,
		222,
		236,
		227,
		245,
		252,
		250,
		254,
		274,
		286,
		350,
		340,
		-1,
		322,
		327,
		286,
		294,
		313,
		351,
		315,
		-1,
		310,
		-1,
		281,
		294,
		-1,
		250,
		246,
		228,
		229,
		224,
		239,
		233,
		218,
		215,
		233,
		236,
		243,
		247,
		263,
		-1,
		-1,
		335,
		339,
		328,
		279,
		298,
		322,
		359,
		308,
		297,
		296,
		-1,
		287,
		264,
		261,
		249,
		236,
		221,
		222,
		230,
		243,
		222,
		217,
		214,
		234,
		260,
		238,
		250,
		-1,
		-1,
		-1,
		360,
		-1,
		-1,
		305,
		276,
		300,
		342,
		326,
		319,
		307,
		272,
		272,
		266,
		-1,
		260,
		239,
		230,
		219,
		217,
		230,
		227,
		232,
		212,
		210,
		229,
		241,
		232,
		249,
		-1,
		-1,
		-1,
		335,
		324,
		325,
		271,
		294,
		331,
		305,
		291,
		296,
		271,
		264,
		258,
		273,
		256,
		237,
		226,
		218,
		207,
		223,
		231,
		226,
		208,
		217,
		223,
		247,
		237,
		243,
		-1,
		-1,
		342,
		332,
		316,
		318,
		315,
		285,
		292,
		324,
		296,
		309,
		-1,
		263,
		-1,
		252,
		247,
		231,
		226,
		223,
		220,
		214,
		223,
		225,
		215,
		210,
		217,
		252,
		252,
		227,
		247,
		250,
		-1,
		-1,
		-1,
		335,
		330,
		305,
		282,
		266,
		302,
		-1,
		279,
		280,
		-1,
		257,
		251,
		248,
		233,
		229,
		224,
		228,
		221,
		228,
		221,
		219,
		220,
		202,
		234,
		-1,
		235,
		229,
		237,
		227,
		215,
		-1,
		-1,
		-1,
		328,
		307,
		300,
		320,
		261,
		313,
		-1,
		-1,
		264,
		257,
		-1,
		244,
		226,
		233,
		231,
		225,
		229,
		226,
		215,
		228,
		221,
		207,
		209,
		222,
		226,
		230,
		217,
		213,
		210,
		224,
		-1,
		347,
		-1,
		-1,
		-1,
		-1,
		-1,
		261,
		281,
		-1,
		273,
		265,
		255,
		249,
		243,
		239,
		237,
		253,
		237,
		240,
		238,
		229,
		237,
		210,
		203,
		210,
		199,
		217,
		225,
		217,
		211,
		210,
		220,
		-1,
		348,
		334,
		305,
		-1,
		-1,
		294,
		-1,
		258,
		272,
		288,
		-1,
		281,
		260,
		275,
		253,
		249,
		245,
		260,
		261,
		238,
		238,
		236,
		227,
		215,
		204,
		207,
		199,
		221,
		221,
		205,
		206,
		210,
		-1,
		354,
		341,
		299,
		295,
		284,
		304,
		255,
		243,
		275,
		-1,
		-1,
		317,
		-1,
		251,
		268,
		259,
		257,
		250,
		232,
		239,
		247,
		224,
		219,
		209,
		198,
		198,
		193,
		215,
		201,
		199,
		208,
		224,
		-1,
		-1,
		-1,
		321,
		-1,
		-1,
		270,
		257,
		251,
		-1,
		292,
		-1,
		295,
		285,
		269,
		254,
		287,
		-1,
		231,
		227,
		234,
		-1,
		244,
		-1,
		217,
		214,
		205,
		190,
		187,
		198,
		196,
		207,
		203,
		-1,
		304,
		289,
		282,
		272,
		286,
		257,
		-1,
		312,
		-1,
		-1,
		282,
		276,
		276,
		260,
		261,
		247,
		227,
		219,
		234,
		233,
		220,
		219,
		203,
		196,
		193,
		186,
		199,
		209,
		214,
		201,
		-1,
		-1,
		-1,
		309,
		295,
		299,
		259,
		278,
		-1,
		-1,
		344,
		299,
		285,
		-1,
		256,
		247,
		235,
		225,
		215,
		220,
		221,
		211,
		209,
		201,
		203,
		197,
		188,
		187,
		203,
		195,
		217,
		-1,
		-1,
		292,
		297,
		285,
		271,
		290,
		-1,
		-1,
		-1,
		291,
		307,
		275,
		254,
		236,
		-1,
		-1,
		219,
		212,
		206,
		209,
		197,
		217,
		212,
		196,
		181,
		196,
		200,
		208,
		199,
		-1,
		295,
		282,
		-1,
		-1,
		293,
		287,
		-1,
		-1,
		-1,
		-1,
		287,
		232,
		221,
		216,
		220,
		218,
		-1,
		192,
		203,
		196,
		215,
		222,
		198,
		183,
		177,
		183,
		195,
		204,
		-1,
		-1,
		307,
		-1,
		280,
		-1,
		-1,
		-1,
		-1,
		244,
		238,
		209,
		202,
		206,
		-1,
		194,
		196,
		193,
		205,
		201,
		198,
		189,
		180,
		176,
		180,
		184,
		198,
		202,
		330,
		-1,
		271,
		-1,
		-1,
		-1,
		262,
		277,
		248,
		225,
		198,
		193,
		186,
		180,
		185,
		196,
		205,
		216,
		181,
		183,
		173,
		172,
		176,
		193,
		197,
		-1,
		-1,
		269,
		265,
		288,
		270,
		274,
		275,
		-1,
		-1,
		202,
		193,
		184,
		176,
		189,
		192,
		177,
		179,
		179,
		177,
		171,
		181,
		196,
		191,
		-1,
		-1,
		-1,
		281,
		-1,
		283,
		-1,
		-1,
		272,
		273,
		220,
		202,
		198,
		196,
		185,
		179,
		167,
		172,
		182,
		176,
		173,
		167,
		171,
		194,
		183,
		222,
		-1,
		-1,
		343,
		-1,
		-1,
		-1,
		261,
		252,
		247,
		254,
		256,
		247,
		235,
		232,
		-1,
		202,
		208,
		173,
		180,
		163,
		170,
		175,
		172,
		161,
		168,
		184,
		183,
		178,
		214,
		205,
		211,
		-1,
		-1,
		336,
		325,
		314,
		320,
		-1,
		254,
		249,
		240,
		230,
		233,
		-1,
		-1,
		227,
		224,
		204,
		173,
		171,
		164,
		159,
		169,
		145,
		157,
		161,
		165,
		171,
		176,
		181,
		187,
		202,
		217,
		-1,
		290,
		327,
		320,
		288,
		296,
		327,
		-1,
		244,
		236,
		246,
		222,
		224,
		-1,
		-1,
		200,
		191,
		192,
		180,
		177,
		183,
		182,
		165,
		171,
		172,
		164,
		163,
		181,
		185,
		194,
		201,
		191,
		204,
		208,
		-1,
		283,
		303,
		282,
		285,
		309,
		323,
		-1,
		241,
		-1,
		-1,
		206,
		225,
		209,
		199,
		196,
		239,
		194,
		189,
		170,
		168,
		163,
		154,
		179,
		172,
		172,
		175,
		190,
		195,
		187,
		201,
		201,
		202,
		-1,
		272,
		283,
		276,
		-1,
		-1,
		-1,
		-1,
		242,
		-1,
		-1,
		196,
		-1,
		236,
		-1,
		219,
		223,
		202,
		205,
		184,
		171,
		157,
		165,
		171,
		170,
		176,
		176,
		177,
		186,
		197,
		209,
		208,
		209,
		297,
		253,
		256,
		267,
		278,
		293,
		297,
		-1,
		253,
		292,
		202,
		-1,
		186,
		-1,
		-1,
		-1,
		233,
		215,
		207,
		204,
		183,
		183,
		149,
		153,
		166,
		173,
		183,
		194,
		186,
		190,
		203,
		214,
		217,
		293,
		284,
		297,
		242,
		242,
		263,
		272,
		293,
		257,
		254,
		286,
		209,
		198,
		193,
		180,
		-1,
		-1,
		217,
		225,
		-1,
		-1,
		190,
		157,
		145,
		155,
		159,
		173,
		185,
		198,
		186,
		191,
		185,
		217,
		-1,
		286,
		285,
		274,
		271,
		247,
		238,
		233,
		260,
		-1,
		-1,
		255,
		282,
		265,
		242,
		240,
		265,
		-1,
		169,
		-1,
		-1,
		197,
		-1,
		-1,
		182,
		162,
		151,
		142,
		147,
		167,
		178,
		200,
		182,
		199,
		190,
		200,
		204,
		270,
		267,
		255,
		253,
		276,
		241,
		229,
		-1,
		237,
		240,
		246,
		253,
		243,
		254,
		-1,
		-1,
		185,
		165,
		-1,
		-1,
		180,
		178,
		167,
		-1,
		157,
		139,
		144,
		174,
		176,
		178,
		185,
		179,
		186,
		194,
		205,
		197,
		279,
		293,
		282,
		278,
		277,
		285,
		234,
		227,
		234,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		190,
		-1,
		175,
		171,
		-1,
		-1,
		175,
		168,
		156,
		144,
		134,
		144,
		161,
		161,
		164,
		169,
		177,
		188,
		184,
		188,
		191,
		-1,
		313,
		-1,
		265,
		226,
		232,
		247,
		255,
		-1,
		-1,
		-1,
		192,
		178,
		171,
		159,
		157,
		-1,
		209,
		193,
		174,
		-1,
		144,
		157,
		197,
		165,
		170,
		165,
		180,
		191,
		182,
		190,
		184,
		187,
		-1,
		-1,
		225,
		208,
		-1,
		-1,
		182,
		184,
		-1,
		183,
		172,
		157,
		149,
		-1,
		-1,
		181,
		177,
		-1,
		-1,
		131,
		169,
		168,
		176,
		171,
		176,
		188,
		184,
		180,
		190,
		181,
		-1,
		-1,
		203,
		195,
		189,
		-1,
		167,
		-1,
		185,
		-1,
		152,
		158,
		146,
		-1,
		-1,
		-1,
		162,
		125,
		141,
		164,
		190,
		188,
		179,
		172,
		179,
		182,
		175,
		181,
		-1,
		-1,
		-1,
		185,
		159,
		192,
		183,
		166,
		146,
		138,
		157,
		-1,
		143,
		-1,
		118,
		121,
		146,
		185,
		187,
		173,
		169,
		182,
		176,
		173,
		171,
		191,
		-1,
		161,
		194,
		158,
		152,
		128,
		132,
		157,
		-1,
		140,
		122,
		-1,
		150,
		140,
		188,
		163,
		172,
		165,
		159,
		160,
		168,
		-1,
		-1,
		-1,
		163,
		162,
		154,
		148,
		148,
		133,
		124,
		-1,
		145,
		127,
		113,
		130,
		130,
		121,
		129,
		178,
		174,
		177,
		175,
		153,
		-1,
		158,
		-1,
		-1,
		186,
		-1,
		-1,
		-1,
		157,
		150,
		125,
		113,
		114,
		110,
		110,
		112,
		125,
		133,
		131,
		128,
		140,
		136,
		156,
		152,
		184,
		-1,
		153,
		-1,
		193,
		-1,
		-1,
		147,
		134,
		144,
		136,
		125,
		123,
		109,
		105,
		122,
		157,
		143,
		141,
		146,
		151,
		-1,
		142,
		141,
		-1,
		135,
		145,
		144,
		-1,
		125,
		-1,
		171,
		132,
		-1,
		106,
		100,
		-1,
		152,
		148,
		-1,
		-1,
		129,
		124,
		-1,
		-1,
		-1,
		124,
		116,
		166,
		150,
		-1,
		90,
		97,
		-1,
		-1,
		-1,
		114,
		115,
		-1,
		110,
		120,
		-1,
		112,
		103,
		111,
		85,
		91,
		-1,
		-1,
		-1,
		123,
		104,
		98,
		100,
		95,
		125,
		124,
		110,
		93,
		72,
		82,
		111,
		-1,
		-1,
		-1,
		95,
		87,
		80,
		-1,
		-1,
		119,
		102,
		83,
		81,
		-1,
		-1,
		-1,
		117,
		98,
		-1,
		-1,
		72,
		-1,
		-1,
		76,
		57,
		-1,
		-1,
		-1,
		-1,
		-1,
		134,
		106,
		-1,
		-1,
		-1,
		68,
		64,
		60,
		-1,
		-1,
		-1,
		-1,
		128,
		129,
		152,
		116,
		-1,
		-1,
		-1,
		60,
		49,
		-1,
		-1,
		131,
		129,
		-1,
		-1,
		-1,
		88,
		72,
		-1,
		44,
		-1,
		-1,
		-1,
		79,
		-1,
		-1,
		64,
		-1,
		-1,
		-1,
		93,
		-1,
		47,
		26,
		26,
		-1,
		-1,
		-1,
		-1,
		106,
		98,
		60,
		-1,
		23,
		16,
		-1,
		55,
		-1,
		-1,
		121,
		88,
		-1,
		-1,
		13,
		0,
		39,
		42,
		141,
		-1,
		29
	],
	[
		-1,
		351,
		340,
		351,
		359,
		332,
		339,
		-1,
		358,
		362,
		328,
		322,
		361,
		330,
		336,
		347,
		-1,
		-1,
		-1,
		351,
		350,
		318,
		316,
		325,
		330,
		337,
		-1,
		336,
		-1,
		372,
		351,
		362,
		367,
		311,
		308,
		328,
		347,
		329,
		321,
		387,
		341,
		312,
		306,
		324,
		314,
		323,
		315,
		-1,
		312,
		302,
		324,
		303,
		314,
		306,
		-1,
		-1,
		306,
		307,
		313,
		299,
		305,
		301,
		-1,
		311,
		295,
		-1,
		-1,
		296,
		297,
		281,
		284,
		292,
		290,
		303,
		295,
		290,
		-1,
		-1,
		287,
		283,
		290,
		277,
		273,
		290,
		303,
		285,
		299,
		298,
		-1,
		291,
		309,
		316,
		284,
		282,
		266,
		264,
		282,
		284,
		290,
		290,
		-1,
		300,
		301,
		296,
		304,
		306,
		282,
		269,
		269,
		279,
		272,
		291,
		279,
		325,
		-1,
		-1,
		-1,
		-1,
		-1,
		334,
		300,
		283,
		300,
		292,
		282,
		297,
		290,
		272,
		269,
		267,
		264,
		280,
		278,
		288,
		-1,
		-1,
		393,
		362,
		391,
		349,
		330,
		-1,
		296,
		276,
		282,
		286,
		280,
		273,
		287,
		283,
		-1,
		258,
		257,
		285,
		271,
		282,
		353,
		-1,
		-1,
		351,
		343,
		326,
		329,
		306,
		302,
		291,
		290,
		282,
		268,
		264,
		270,
		273,
		273,
		279,
		252,
		262,
		266,
		264,
		289,
		-1,
		-1,
		324,
		-1,
		-1,
		350,
		333,
		-1,
		316,
		323,
		312,
		318,
		304,
		325,
		301,
		292,
		284,
		278,
		266,
		268,
		265,
		278,
		266,
		249,
		274,
		278,
		259,
		280,
		275,
		-1,
		323,
		307,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		328,
		309,
		312,
		318,
		342,
		341,
		-1,
		313,
		301,
		302,
		287,
		284,
		271,
		259,
		272,
		257,
		264,
		263,
		253,
		251,
		281,
		256,
		278,
		275,
		294,
		299,
		293,
		302,
		-1,
		358,
		354,
		350,
		357,
		306,
		-1,
		-1,
		346,
		-1,
		349,
		350,
		325,
		298,
		301,
		288,
		279,
		266,
		255,
		266,
		255,
		252,
		260,
		245,
		260,
		251,
		250,
		268,
		278,
		286,
		290,
		296,
		-1,
		408,
		-1,
		350,
		334,
		336,
		308,
		329,
		-1,
		366,
		350,
		342,
		327,
		327,
		-1,
		297,
		294,
		284,
		262,
		247,
		264,
		256,
		254,
		258,
		240,
		254,
		245,
		263,
		270,
		268,
		272,
		292,
		304,
		368,
		358,
		-1,
		340,
		345,
		304,
		312,
		331,
		369,
		333,
		-1,
		328,
		-1,
		299,
		312,
		-1,
		268,
		264,
		246,
		247,
		242,
		257,
		251,
		236,
		233,
		251,
		254,
		261,
		265,
		281,
		-1,
		-1,
		353,
		357,
		346,
		297,
		316,
		340,
		377,
		326,
		315,
		314,
		-1,
		305,
		282,
		279,
		267,
		254,
		239,
		240,
		248,
		261,
		240,
		235,
		232,
		252,
		278,
		256,
		268,
		-1,
		-1,
		-1,
		378,
		-1,
		-1,
		323,
		294,
		318,
		360,
		344,
		337,
		325,
		290,
		290,
		284,
		-1,
		278,
		257,
		248,
		237,
		235,
		248,
		245,
		250,
		230,
		228,
		247,
		259,
		250,
		267,
		-1,
		-1,
		-1,
		353,
		342,
		343,
		289,
		312,
		349,
		323,
		309,
		314,
		289,
		282,
		276,
		291,
		274,
		255,
		244,
		236,
		225,
		241,
		249,
		244,
		226,
		235,
		241,
		265,
		255,
		261,
		-1,
		-1,
		360,
		350,
		334,
		336,
		333,
		303,
		310,
		342,
		314,
		327,
		-1,
		281,
		-1,
		270,
		265,
		249,
		244,
		241,
		238,
		232,
		241,
		243,
		233,
		228,
		235,
		270,
		270,
		245,
		265,
		268,
		-1,
		-1,
		-1,
		353,
		348,
		323,
		300,
		284,
		320,
		-1,
		297,
		298,
		-1,
		275,
		269,
		266,
		251,
		247,
		242,
		246,
		239,
		246,
		239,
		237,
		238,
		220,
		252,
		-1,
		253,
		247,
		255,
		245,
		233,
		-1,
		-1,
		-1,
		346,
		325,
		318,
		338,
		279,
		331,
		-1,
		-1,
		282,
		275,
		-1,
		262,
		244,
		251,
		249,
		243,
		247,
		244,
		233,
		246,
		239,
		225,
		227,
		240,
		244,
		248,
		235,
		231,
		228,
		242,
		-1,
		365,
		-1,
		-1,
		-1,
		-1,
		-1,
		279,
		299,
		-1,
		291,
		283,
		273,
		267,
		261,
		257,
		255,
		271,
		255,
		258,
		256,
		247,
		255,
		228,
		221,
		228,
		217,
		235,
		243,
		235,
		229,
		228,
		238,
		-1,
		366,
		352,
		323,
		-1,
		-1,
		312,
		-1,
		276,
		290,
		306,
		-1,
		299,
		278,
		293,
		271,
		267,
		263,
		278,
		279,
		256,
		256,
		254,
		245,
		233,
		222,
		225,
		217,
		239,
		239,
		223,
		224,
		228,
		-1,
		372,
		359,
		317,
		313,
		302,
		322,
		273,
		261,
		293,
		-1,
		-1,
		335,
		-1,
		269,
		286,
		277,
		275,
		268,
		250,
		257,
		265,
		242,
		237,
		227,
		216,
		216,
		211,
		233,
		219,
		217,
		226,
		242,
		-1,
		-1,
		-1,
		339,
		-1,
		-1,
		288,
		275,
		269,
		-1,
		310,
		-1,
		313,
		303,
		287,
		272,
		305,
		-1,
		249,
		245,
		252,
		-1,
		262,
		-1,
		235,
		232,
		223,
		208,
		205,
		216,
		214,
		225,
		221,
		-1,
		322,
		307,
		300,
		290,
		304,
		275,
		-1,
		330,
		-1,
		-1,
		300,
		294,
		294,
		278,
		279,
		265,
		245,
		237,
		252,
		251,
		238,
		237,
		221,
		214,
		211,
		204,
		217,
		227,
		232,
		219,
		-1,
		-1,
		-1,
		327,
		313,
		317,
		277,
		296,
		-1,
		-1,
		362,
		317,
		303,
		-1,
		274,
		265,
		253,
		243,
		233,
		238,
		239,
		229,
		227,
		219,
		221,
		215,
		206,
		205,
		221,
		213,
		235,
		-1,
		-1,
		310,
		315,
		303,
		289,
		308,
		-1,
		-1,
		-1,
		309,
		325,
		293,
		272,
		254,
		-1,
		-1,
		237,
		230,
		224,
		227,
		215,
		235,
		230,
		214,
		199,
		214,
		218,
		226,
		217,
		-1,
		313,
		300,
		-1,
		-1,
		311,
		305,
		-1,
		-1,
		-1,
		-1,
		305,
		250,
		239,
		234,
		238,
		236,
		-1,
		210,
		221,
		214,
		233,
		240,
		216,
		201,
		195,
		201,
		213,
		222,
		-1,
		-1,
		325,
		-1,
		298,
		-1,
		-1,
		-1,
		-1,
		262,
		256,
		227,
		220,
		224,
		-1,
		212,
		214,
		211,
		223,
		219,
		216,
		207,
		198,
		194,
		198,
		202,
		216,
		220,
		348,
		-1,
		289,
		-1,
		-1,
		-1,
		280,
		295,
		266,
		243,
		216,
		211,
		204,
		198,
		203,
		214,
		223,
		234,
		199,
		201,
		191,
		190,
		194,
		211,
		215,
		-1,
		-1,
		287,
		283,
		306,
		288,
		292,
		293,
		-1,
		-1,
		220,
		211,
		202,
		194,
		207,
		210,
		195,
		197,
		197,
		195,
		189,
		199,
		214,
		209,
		-1,
		-1,
		-1,
		299,
		-1,
		301,
		-1,
		-1,
		290,
		291,
		238,
		220,
		216,
		214,
		203,
		197,
		185,
		190,
		200,
		194,
		191,
		185,
		189,
		212,
		201,
		240,
		-1,
		-1,
		361,
		-1,
		-1,
		-1,
		279,
		270,
		265,
		272,
		274,
		265,
		253,
		250,
		-1,
		220,
		226,
		191,
		198,
		181,
		188,
		193,
		190,
		179,
		186,
		202,
		201,
		196,
		232,
		223,
		229,
		-1,
		-1,
		354,
		343,
		332,
		338,
		-1,
		272,
		267,
		258,
		248,
		251,
		-1,
		-1,
		245,
		242,
		222,
		191,
		189,
		182,
		177,
		187,
		163,
		175,
		179,
		183,
		189,
		194,
		199,
		205,
		220,
		235,
		-1,
		308,
		345,
		338,
		306,
		314,
		345,
		-1,
		262,
		254,
		264,
		240,
		242,
		-1,
		-1,
		218,
		209,
		210,
		198,
		195,
		201,
		200,
		183,
		189,
		190,
		182,
		181,
		199,
		203,
		212,
		219,
		209,
		222,
		226,
		-1,
		301,
		321,
		300,
		303,
		327,
		341,
		-1,
		259,
		-1,
		-1,
		224,
		243,
		227,
		217,
		214,
		257,
		212,
		207,
		188,
		186,
		181,
		172,
		197,
		190,
		190,
		193,
		208,
		213,
		205,
		219,
		219,
		220,
		-1,
		290,
		301,
		294,
		-1,
		-1,
		-1,
		-1,
		260,
		-1,
		-1,
		214,
		-1,
		254,
		-1,
		237,
		241,
		220,
		223,
		202,
		189,
		175,
		183,
		189,
		188,
		194,
		194,
		195,
		204,
		215,
		227,
		226,
		227,
		315,
		271,
		274,
		285,
		296,
		311,
		315,
		-1,
		271,
		310,
		220,
		-1,
		204,
		-1,
		-1,
		-1,
		251,
		233,
		225,
		222,
		201,
		201,
		167,
		171,
		184,
		191,
		201,
		212,
		204,
		208,
		221,
		232,
		235,
		311,
		302,
		315,
		260,
		260,
		281,
		290,
		311,
		275,
		272,
		304,
		227,
		216,
		211,
		198,
		-1,
		-1,
		235,
		243,
		-1,
		-1,
		208,
		175,
		163,
		173,
		177,
		191,
		203,
		216,
		204,
		209,
		203,
		235,
		-1,
		304,
		303,
		292,
		289,
		265,
		256,
		251,
		278,
		-1,
		-1,
		273,
		300,
		283,
		260,
		258,
		283,
		-1,
		187,
		-1,
		-1,
		215,
		-1,
		-1,
		200,
		180,
		169,
		160,
		165,
		185,
		196,
		218,
		200,
		217,
		208,
		218,
		222,
		288,
		285,
		273,
		271,
		294,
		259,
		247,
		-1,
		255,
		258,
		264,
		271,
		261,
		272,
		-1,
		-1,
		203,
		183,
		-1,
		-1,
		198,
		196,
		185,
		-1,
		175,
		157,
		162,
		192,
		194,
		196,
		203,
		197,
		204,
		212,
		223,
		215,
		297,
		311,
		300,
		296,
		295,
		303,
		252,
		245,
		252,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		208,
		-1,
		193,
		189,
		-1,
		-1,
		193,
		186,
		174,
		162,
		152,
		162,
		179,
		179,
		182,
		187,
		195,
		206,
		202,
		206,
		209,
		-1,
		331,
		-1,
		283,
		244,
		250,
		265,
		273,
		-1,
		-1,
		-1,
		210,
		196,
		189,
		177,
		175,
		-1,
		227,
		211,
		192,
		-1,
		162,
		175,
		215,
		183,
		188,
		183,
		198,
		209,
		200,
		208,
		202,
		205,
		-1,
		-1,
		243,
		226,
		-1,
		-1,
		200,
		202,
		-1,
		201,
		190,
		175,
		167,
		-1,
		-1,
		199,
		195,
		-1,
		-1,
		149,
		187,
		186,
		194,
		189,
		194,
		206,
		202,
		198,
		208,
		199,
		-1,
		-1,
		221,
		213,
		207,
		-1,
		185,
		-1,
		203,
		-1,
		170,
		176,
		164,
		-1,
		-1,
		-1,
		180,
		143,
		159,
		182,
		208,
		206,
		197,
		190,
		197,
		200,
		193,
		199,
		-1,
		-1,
		-1,
		203,
		177,
		210,
		201,
		184,
		164,
		156,
		175,
		-1,
		161,
		-1,
		136,
		139,
		164,
		203,
		205,
		191,
		187,
		200,
		194,
		191,
		189,
		209,
		-1,
		179,
		212,
		176,
		170,
		146,
		150,
		175,
		-1,
		158,
		140,
		-1,
		168,
		158,
		206,
		181,
		190,
		183,
		177,
		178,
		186,
		-1,
		-1,
		-1,
		181,
		180,
		172,
		166,
		166,
		151,
		142,
		-1,
		163,
		145,
		131,
		148,
		148,
		139,
		147,
		196,
		192,
		195,
		193,
		171,
		-1,
		176,
		-1,
		-1,
		204,
		-1,
		-1,
		-1,
		175,
		168,
		143,
		131,
		132,
		128,
		128,
		130,
		143,
		151,
		149,
		146,
		158,
		154,
		174,
		170,
		202,
		-1,
		171,
		-1,
		211,
		-1,
		-1,
		165,
		152,
		162,
		154,
		143,
		141,
		127,
		123,
		140,
		175,
		161,
		159,
		164,
		169,
		-1,
		160,
		159,
		-1,
		153,
		163,
		162,
		-1,
		143,
		-1,
		189,
		150,
		-1,
		124,
		118,
		-1,
		170,
		166,
		-1,
		-1,
		147,
		142,
		-1,
		-1,
		-1,
		142,
		134,
		184,
		168,
		-1,
		108,
		115,
		-1,
		-1,
		-1,
		132,
		133,
		-1,
		128,
		138,
		-1,
		130,
		121,
		129,
		103,
		109,
		-1,
		-1,
		-1,
		141,
		122,
		116,
		118,
		113,
		143,
		142,
		128,
		111,
		90,
		100,
		129,
		-1,
		-1,
		-1,
		113,
		105,
		98,
		-1,
		-1,
		137,
		120,
		101,
		99,
		-1,
		-1,
		-1,
		135,
		116,
		-1,
		-1,
		90,
		-1,
		-1,
		94,
		75,
		-1,
		-1,
		-1,
		-1,
		-1,
		152,
		124,
		-1,
		-1,
		-1,
		86,
		82,
		78,
		-1,
		-1,
		-1,
		-1,
		146,
		147,
		170,
		134,
		-1,
		-1,
		-1,
		78,
		67,
		-1,
		-1,
		149,
		147,
		-1,
		-1,
		-1,
		106,
		90,
		-1,
		62,
		-1,
		-1,
		-1,
		97,
		-1,
		-1,
		82,
		-1,
		-1,
		-1,
		108,
		-1,
		65,
		44,
		44,
		-1,
		-1,
		-1,
		-1,
		103,
		104,
		78,
		-1,
		41,
		34,
		-1,
		16,
		-1,
		-1,
		118,
		84,
		-1,
		-1,
		31,
		35,
		0,
		3,
		137,
		-1,
		25
	],
	[
		-1,
		355,
		344,
		355,
		363,
		336,
		343,
		-1,
		362,
		366,
		332,
		326,
		365,
		334,
		340,
		351,
		-1,
		-1,
		-1,
		355,
		354,
		322,
		320,
		329,
		334,
		341,
		-1,
		340,
		-1,
		376,
		355,
		366,
		371,
		315,
		312,
		332,
		351,
		333,
		325,
		391,
		345,
		316,
		310,
		328,
		318,
		327,
		319,
		-1,
		316,
		306,
		328,
		307,
		318,
		310,
		-1,
		-1,
		310,
		311,
		317,
		303,
		309,
		305,
		-1,
		315,
		299,
		-1,
		-1,
		300,
		301,
		285,
		288,
		296,
		294,
		307,
		299,
		294,
		-1,
		-1,
		291,
		287,
		294,
		281,
		277,
		294,
		307,
		289,
		303,
		302,
		-1,
		295,
		313,
		320,
		288,
		286,
		270,
		268,
		286,
		288,
		294,
		294,
		-1,
		304,
		305,
		300,
		308,
		310,
		286,
		273,
		273,
		283,
		276,
		295,
		283,
		329,
		-1,
		-1,
		-1,
		-1,
		-1,
		338,
		304,
		287,
		304,
		296,
		286,
		301,
		294,
		276,
		273,
		271,
		268,
		284,
		282,
		292,
		-1,
		-1,
		397,
		366,
		395,
		353,
		334,
		-1,
		300,
		280,
		286,
		290,
		284,
		277,
		291,
		287,
		-1,
		262,
		261,
		289,
		275,
		286,
		357,
		-1,
		-1,
		355,
		347,
		330,
		333,
		310,
		306,
		295,
		294,
		286,
		272,
		268,
		274,
		277,
		277,
		283,
		256,
		266,
		270,
		268,
		293,
		-1,
		-1,
		328,
		-1,
		-1,
		354,
		337,
		-1,
		320,
		327,
		316,
		322,
		308,
		329,
		305,
		296,
		288,
		282,
		270,
		272,
		269,
		282,
		270,
		253,
		278,
		282,
		263,
		284,
		279,
		-1,
		327,
		311,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		332,
		313,
		316,
		322,
		346,
		345,
		-1,
		317,
		305,
		306,
		291,
		288,
		275,
		263,
		276,
		261,
		268,
		267,
		257,
		255,
		285,
		260,
		282,
		279,
		298,
		303,
		297,
		306,
		-1,
		362,
		358,
		354,
		361,
		310,
		-1,
		-1,
		350,
		-1,
		353,
		354,
		329,
		302,
		305,
		292,
		283,
		270,
		259,
		270,
		259,
		256,
		264,
		249,
		264,
		255,
		254,
		272,
		282,
		290,
		294,
		300,
		-1,
		412,
		-1,
		354,
		338,
		340,
		312,
		333,
		-1,
		370,
		354,
		346,
		331,
		331,
		-1,
		301,
		298,
		288,
		266,
		251,
		268,
		260,
		258,
		262,
		244,
		258,
		249,
		267,
		274,
		272,
		276,
		296,
		308,
		372,
		362,
		-1,
		344,
		349,
		308,
		316,
		335,
		373,
		337,
		-1,
		332,
		-1,
		303,
		316,
		-1,
		272,
		268,
		250,
		251,
		246,
		261,
		255,
		240,
		237,
		255,
		258,
		265,
		269,
		285,
		-1,
		-1,
		357,
		361,
		350,
		301,
		320,
		344,
		381,
		330,
		319,
		318,
		-1,
		309,
		286,
		283,
		271,
		258,
		243,
		244,
		252,
		265,
		244,
		239,
		236,
		256,
		282,
		260,
		272,
		-1,
		-1,
		-1,
		382,
		-1,
		-1,
		327,
		298,
		322,
		364,
		348,
		341,
		329,
		294,
		294,
		288,
		-1,
		282,
		261,
		252,
		241,
		239,
		252,
		249,
		254,
		234,
		232,
		251,
		263,
		254,
		271,
		-1,
		-1,
		-1,
		357,
		346,
		347,
		293,
		316,
		353,
		327,
		313,
		318,
		293,
		286,
		280,
		295,
		278,
		259,
		248,
		240,
		229,
		245,
		253,
		248,
		230,
		239,
		245,
		269,
		259,
		265,
		-1,
		-1,
		364,
		354,
		338,
		340,
		337,
		307,
		314,
		346,
		318,
		331,
		-1,
		285,
		-1,
		274,
		269,
		253,
		248,
		245,
		242,
		236,
		245,
		247,
		237,
		232,
		239,
		274,
		274,
		249,
		269,
		272,
		-1,
		-1,
		-1,
		357,
		352,
		327,
		304,
		288,
		324,
		-1,
		301,
		302,
		-1,
		279,
		273,
		270,
		255,
		251,
		246,
		250,
		243,
		250,
		243,
		241,
		242,
		224,
		256,
		-1,
		257,
		251,
		259,
		249,
		237,
		-1,
		-1,
		-1,
		350,
		329,
		322,
		342,
		283,
		335,
		-1,
		-1,
		286,
		279,
		-1,
		266,
		248,
		255,
		253,
		247,
		251,
		248,
		237,
		250,
		243,
		229,
		231,
		244,
		248,
		252,
		239,
		235,
		232,
		246,
		-1,
		369,
		-1,
		-1,
		-1,
		-1,
		-1,
		283,
		303,
		-1,
		295,
		287,
		277,
		271,
		265,
		261,
		259,
		275,
		259,
		262,
		260,
		251,
		259,
		232,
		225,
		232,
		221,
		239,
		247,
		239,
		233,
		232,
		242,
		-1,
		370,
		356,
		327,
		-1,
		-1,
		316,
		-1,
		280,
		294,
		310,
		-1,
		303,
		282,
		297,
		275,
		271,
		267,
		282,
		283,
		260,
		260,
		258,
		249,
		237,
		226,
		229,
		221,
		243,
		243,
		227,
		228,
		232,
		-1,
		376,
		363,
		321,
		317,
		306,
		326,
		277,
		265,
		297,
		-1,
		-1,
		339,
		-1,
		273,
		290,
		281,
		279,
		272,
		254,
		261,
		269,
		246,
		241,
		231,
		220,
		220,
		215,
		237,
		223,
		221,
		230,
		246,
		-1,
		-1,
		-1,
		343,
		-1,
		-1,
		292,
		279,
		273,
		-1,
		314,
		-1,
		317,
		307,
		291,
		276,
		309,
		-1,
		253,
		249,
		256,
		-1,
		266,
		-1,
		239,
		236,
		227,
		212,
		209,
		220,
		218,
		229,
		225,
		-1,
		326,
		311,
		304,
		294,
		308,
		279,
		-1,
		334,
		-1,
		-1,
		304,
		298,
		298,
		282,
		283,
		269,
		249,
		241,
		256,
		255,
		242,
		241,
		225,
		218,
		215,
		208,
		221,
		231,
		236,
		223,
		-1,
		-1,
		-1,
		331,
		317,
		321,
		281,
		300,
		-1,
		-1,
		366,
		321,
		307,
		-1,
		278,
		269,
		257,
		247,
		237,
		242,
		243,
		233,
		231,
		223,
		225,
		219,
		210,
		209,
		225,
		217,
		239,
		-1,
		-1,
		314,
		319,
		307,
		293,
		312,
		-1,
		-1,
		-1,
		313,
		329,
		297,
		276,
		258,
		-1,
		-1,
		241,
		234,
		228,
		231,
		219,
		239,
		234,
		218,
		203,
		218,
		222,
		230,
		221,
		-1,
		317,
		304,
		-1,
		-1,
		315,
		309,
		-1,
		-1,
		-1,
		-1,
		309,
		254,
		243,
		238,
		242,
		240,
		-1,
		214,
		225,
		218,
		237,
		244,
		220,
		205,
		199,
		205,
		217,
		226,
		-1,
		-1,
		329,
		-1,
		302,
		-1,
		-1,
		-1,
		-1,
		266,
		260,
		231,
		224,
		228,
		-1,
		216,
		218,
		215,
		227,
		223,
		220,
		211,
		202,
		198,
		202,
		206,
		220,
		224,
		352,
		-1,
		293,
		-1,
		-1,
		-1,
		284,
		299,
		270,
		247,
		220,
		215,
		208,
		202,
		207,
		218,
		227,
		238,
		203,
		205,
		195,
		194,
		198,
		215,
		219,
		-1,
		-1,
		291,
		287,
		310,
		292,
		296,
		297,
		-1,
		-1,
		224,
		215,
		206,
		198,
		211,
		214,
		199,
		201,
		201,
		199,
		193,
		203,
		218,
		213,
		-1,
		-1,
		-1,
		303,
		-1,
		305,
		-1,
		-1,
		294,
		295,
		242,
		224,
		220,
		218,
		207,
		201,
		189,
		194,
		204,
		198,
		195,
		189,
		193,
		216,
		205,
		244,
		-1,
		-1,
		365,
		-1,
		-1,
		-1,
		283,
		274,
		269,
		276,
		278,
		269,
		257,
		254,
		-1,
		224,
		230,
		195,
		202,
		185,
		192,
		197,
		194,
		183,
		190,
		206,
		205,
		200,
		236,
		227,
		233,
		-1,
		-1,
		358,
		347,
		336,
		342,
		-1,
		276,
		271,
		262,
		252,
		255,
		-1,
		-1,
		249,
		246,
		226,
		195,
		193,
		186,
		181,
		191,
		167,
		179,
		183,
		187,
		193,
		198,
		203,
		209,
		224,
		239,
		-1,
		312,
		349,
		342,
		310,
		318,
		349,
		-1,
		266,
		258,
		268,
		244,
		246,
		-1,
		-1,
		222,
		213,
		214,
		202,
		199,
		205,
		204,
		187,
		193,
		194,
		186,
		185,
		203,
		207,
		216,
		223,
		213,
		226,
		230,
		-1,
		305,
		325,
		304,
		307,
		331,
		345,
		-1,
		263,
		-1,
		-1,
		228,
		247,
		231,
		221,
		218,
		261,
		216,
		211,
		192,
		190,
		185,
		176,
		201,
		194,
		194,
		197,
		212,
		217,
		209,
		223,
		223,
		224,
		-1,
		294,
		305,
		298,
		-1,
		-1,
		-1,
		-1,
		264,
		-1,
		-1,
		218,
		-1,
		258,
		-1,
		241,
		245,
		224,
		227,
		206,
		193,
		179,
		187,
		193,
		192,
		198,
		198,
		199,
		208,
		219,
		231,
		230,
		231,
		319,
		275,
		278,
		289,
		300,
		315,
		319,
		-1,
		275,
		314,
		224,
		-1,
		208,
		-1,
		-1,
		-1,
		255,
		237,
		229,
		226,
		205,
		205,
		171,
		175,
		188,
		195,
		205,
		216,
		208,
		212,
		225,
		236,
		239,
		315,
		306,
		319,
		264,
		264,
		285,
		294,
		315,
		279,
		276,
		308,
		231,
		220,
		215,
		202,
		-1,
		-1,
		239,
		247,
		-1,
		-1,
		212,
		179,
		167,
		177,
		181,
		195,
		207,
		220,
		208,
		213,
		207,
		239,
		-1,
		308,
		307,
		296,
		293,
		269,
		260,
		255,
		282,
		-1,
		-1,
		277,
		304,
		287,
		264,
		262,
		287,
		-1,
		191,
		-1,
		-1,
		219,
		-1,
		-1,
		204,
		184,
		173,
		164,
		169,
		189,
		200,
		222,
		204,
		221,
		212,
		222,
		226,
		292,
		289,
		277,
		275,
		298,
		263,
		251,
		-1,
		259,
		262,
		268,
		275,
		265,
		276,
		-1,
		-1,
		207,
		187,
		-1,
		-1,
		202,
		200,
		189,
		-1,
		179,
		161,
		166,
		196,
		198,
		200,
		207,
		201,
		208,
		216,
		227,
		219,
		301,
		315,
		304,
		300,
		299,
		307,
		256,
		249,
		256,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		212,
		-1,
		197,
		193,
		-1,
		-1,
		197,
		190,
		178,
		166,
		156,
		166,
		183,
		183,
		186,
		191,
		199,
		210,
		206,
		210,
		213,
		-1,
		335,
		-1,
		287,
		248,
		254,
		269,
		277,
		-1,
		-1,
		-1,
		214,
		200,
		193,
		181,
		179,
		-1,
		231,
		215,
		196,
		-1,
		166,
		179,
		219,
		187,
		192,
		187,
		202,
		213,
		204,
		212,
		206,
		209,
		-1,
		-1,
		247,
		230,
		-1,
		-1,
		204,
		206,
		-1,
		205,
		194,
		179,
		171,
		-1,
		-1,
		203,
		199,
		-1,
		-1,
		153,
		191,
		190,
		198,
		193,
		198,
		210,
		206,
		202,
		212,
		203,
		-1,
		-1,
		225,
		217,
		211,
		-1,
		189,
		-1,
		207,
		-1,
		174,
		180,
		168,
		-1,
		-1,
		-1,
		184,
		147,
		163,
		186,
		212,
		210,
		201,
		194,
		201,
		204,
		197,
		203,
		-1,
		-1,
		-1,
		207,
		181,
		214,
		205,
		188,
		168,
		160,
		179,
		-1,
		165,
		-1,
		140,
		143,
		168,
		207,
		209,
		195,
		191,
		204,
		198,
		195,
		193,
		213,
		-1,
		183,
		216,
		180,
		174,
		150,
		154,
		179,
		-1,
		162,
		144,
		-1,
		172,
		162,
		210,
		185,
		194,
		187,
		181,
		182,
		190,
		-1,
		-1,
		-1,
		185,
		184,
		176,
		170,
		170,
		155,
		146,
		-1,
		167,
		149,
		135,
		152,
		152,
		143,
		151,
		200,
		196,
		199,
		197,
		175,
		-1,
		180,
		-1,
		-1,
		208,
		-1,
		-1,
		-1,
		179,
		172,
		147,
		135,
		136,
		132,
		132,
		134,
		147,
		155,
		153,
		150,
		162,
		158,
		178,
		174,
		206,
		-1,
		175,
		-1,
		215,
		-1,
		-1,
		169,
		156,
		166,
		158,
		147,
		145,
		131,
		127,
		144,
		179,
		165,
		163,
		168,
		173,
		-1,
		164,
		163,
		-1,
		157,
		167,
		166,
		-1,
		147,
		-1,
		193,
		154,
		-1,
		128,
		122,
		-1,
		174,
		170,
		-1,
		-1,
		151,
		146,
		-1,
		-1,
		-1,
		146,
		138,
		188,
		172,
		-1,
		112,
		119,
		-1,
		-1,
		-1,
		136,
		137,
		-1,
		132,
		142,
		-1,
		134,
		125,
		133,
		107,
		113,
		-1,
		-1,
		-1,
		145,
		126,
		120,
		122,
		117,
		147,
		146,
		132,
		115,
		94,
		104,
		133,
		-1,
		-1,
		-1,
		117,
		109,
		102,
		-1,
		-1,
		141,
		124,
		105,
		103,
		-1,
		-1,
		-1,
		139,
		120,
		-1,
		-1,
		94,
		-1,
		-1,
		98,
		79,
		-1,
		-1,
		-1,
		-1,
		-1,
		156,
		128,
		-1,
		-1,
		-1,
		90,
		86,
		82,
		-1,
		-1,
		-1,
		-1,
		150,
		151,
		174,
		138,
		-1,
		-1,
		-1,
		82,
		71,
		-1,
		-1,
		153,
		151,
		-1,
		-1,
		-1,
		110,
		94,
		-1,
		66,
		-1,
		-1,
		-1,
		101,
		-1,
		-1,
		86,
		-1,
		-1,
		-1,
		112,
		-1,
		69,
		48,
		48,
		-1,
		-1,
		-1,
		-1,
		107,
		108,
		82,
		-1,
		45,
		38,
		-1,
		13,
		-1,
		-1,
		122,
		88,
		-1,
		-1,
		35,
		39,
		4,
		0,
		141,
		-1,
		29
	],
	[
		-1,
		393,
		382,
		393,
		401,
		374,
		381,
		-1,
		400,
		404,
		370,
		364,
		403,
		372,
		378,
		389,
		-1,
		-1,
		-1,
		393,
		392,
		360,
		358,
		367,
		372,
		379,
		-1,
		378,
		-1,
		414,
		393,
		404,
		409,
		353,
		350,
		370,
		389,
		371,
		363,
		429,
		383,
		354,
		348,
		366,
		356,
		365,
		357,
		-1,
		354,
		344,
		366,
		345,
		356,
		348,
		-1,
		-1,
		348,
		349,
		355,
		341,
		347,
		343,
		-1,
		353,
		337,
		-1,
		-1,
		338,
		339,
		323,
		326,
		334,
		332,
		345,
		337,
		332,
		-1,
		-1,
		329,
		325,
		332,
		319,
		315,
		332,
		345,
		327,
		341,
		340,
		-1,
		333,
		351,
		358,
		326,
		324,
		308,
		306,
		324,
		326,
		332,
		332,
		-1,
		342,
		343,
		338,
		346,
		348,
		324,
		311,
		311,
		321,
		314,
		333,
		321,
		367,
		-1,
		-1,
		-1,
		-1,
		-1,
		376,
		342,
		325,
		342,
		334,
		324,
		339,
		332,
		314,
		311,
		309,
		306,
		322,
		320,
		330,
		-1,
		-1,
		435,
		404,
		433,
		391,
		372,
		-1,
		338,
		318,
		324,
		328,
		322,
		315,
		329,
		325,
		-1,
		300,
		299,
		327,
		313,
		324,
		395,
		-1,
		-1,
		393,
		385,
		368,
		371,
		348,
		344,
		333,
		332,
		324,
		310,
		306,
		312,
		315,
		315,
		321,
		294,
		304,
		308,
		306,
		331,
		-1,
		-1,
		366,
		-1,
		-1,
		392,
		375,
		-1,
		358,
		365,
		354,
		360,
		346,
		367,
		343,
		334,
		326,
		320,
		308,
		310,
		307,
		320,
		308,
		291,
		316,
		320,
		301,
		322,
		317,
		-1,
		365,
		349,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		370,
		351,
		354,
		360,
		384,
		383,
		-1,
		355,
		343,
		344,
		329,
		326,
		313,
		301,
		314,
		299,
		306,
		305,
		295,
		293,
		323,
		298,
		320,
		317,
		336,
		341,
		335,
		344,
		-1,
		400,
		396,
		392,
		399,
		348,
		-1,
		-1,
		388,
		-1,
		391,
		392,
		367,
		340,
		343,
		330,
		321,
		308,
		297,
		308,
		297,
		294,
		302,
		287,
		302,
		293,
		292,
		310,
		320,
		328,
		332,
		338,
		-1,
		450,
		-1,
		392,
		376,
		378,
		350,
		371,
		-1,
		408,
		392,
		384,
		369,
		369,
		-1,
		339,
		336,
		326,
		304,
		289,
		306,
		298,
		296,
		300,
		282,
		296,
		287,
		305,
		312,
		310,
		314,
		334,
		346,
		410,
		400,
		-1,
		382,
		387,
		346,
		354,
		373,
		411,
		375,
		-1,
		370,
		-1,
		341,
		354,
		-1,
		310,
		306,
		288,
		289,
		284,
		299,
		293,
		278,
		275,
		293,
		296,
		303,
		307,
		323,
		-1,
		-1,
		395,
		399,
		388,
		339,
		358,
		382,
		419,
		368,
		357,
		356,
		-1,
		347,
		324,
		321,
		309,
		296,
		281,
		282,
		290,
		303,
		282,
		277,
		274,
		294,
		320,
		298,
		310,
		-1,
		-1,
		-1,
		420,
		-1,
		-1,
		365,
		336,
		360,
		402,
		386,
		379,
		367,
		332,
		332,
		326,
		-1,
		320,
		299,
		290,
		279,
		277,
		290,
		287,
		292,
		272,
		270,
		289,
		301,
		292,
		309,
		-1,
		-1,
		-1,
		395,
		384,
		385,
		331,
		354,
		391,
		365,
		351,
		356,
		331,
		324,
		318,
		333,
		316,
		297,
		286,
		278,
		267,
		283,
		291,
		286,
		268,
		277,
		283,
		307,
		297,
		303,
		-1,
		-1,
		402,
		392,
		376,
		378,
		375,
		345,
		352,
		384,
		356,
		369,
		-1,
		323,
		-1,
		312,
		307,
		291,
		286,
		283,
		280,
		274,
		283,
		285,
		275,
		270,
		277,
		312,
		312,
		287,
		307,
		310,
		-1,
		-1,
		-1,
		395,
		390,
		365,
		342,
		326,
		362,
		-1,
		339,
		340,
		-1,
		317,
		311,
		308,
		293,
		289,
		284,
		288,
		281,
		288,
		281,
		279,
		280,
		262,
		294,
		-1,
		295,
		289,
		297,
		287,
		275,
		-1,
		-1,
		-1,
		388,
		367,
		360,
		380,
		321,
		373,
		-1,
		-1,
		324,
		317,
		-1,
		304,
		286,
		293,
		291,
		285,
		289,
		286,
		275,
		288,
		281,
		267,
		269,
		282,
		286,
		290,
		277,
		273,
		270,
		284,
		-1,
		407,
		-1,
		-1,
		-1,
		-1,
		-1,
		321,
		341,
		-1,
		333,
		325,
		315,
		309,
		303,
		299,
		297,
		313,
		297,
		300,
		298,
		289,
		297,
		270,
		263,
		270,
		259,
		277,
		285,
		277,
		271,
		270,
		280,
		-1,
		408,
		394,
		365,
		-1,
		-1,
		354,
		-1,
		318,
		332,
		348,
		-1,
		341,
		320,
		335,
		313,
		309,
		305,
		320,
		321,
		298,
		298,
		296,
		287,
		275,
		264,
		267,
		259,
		281,
		281,
		265,
		266,
		270,
		-1,
		414,
		401,
		359,
		355,
		344,
		364,
		315,
		303,
		335,
		-1,
		-1,
		377,
		-1,
		311,
		328,
		319,
		317,
		310,
		292,
		299,
		307,
		284,
		279,
		269,
		258,
		258,
		253,
		275,
		261,
		259,
		268,
		284,
		-1,
		-1,
		-1,
		381,
		-1,
		-1,
		330,
		317,
		311,
		-1,
		352,
		-1,
		355,
		345,
		329,
		314,
		347,
		-1,
		291,
		287,
		294,
		-1,
		304,
		-1,
		277,
		274,
		265,
		250,
		247,
		258,
		256,
		267,
		263,
		-1,
		364,
		349,
		342,
		332,
		346,
		317,
		-1,
		372,
		-1,
		-1,
		342,
		336,
		336,
		320,
		321,
		307,
		287,
		279,
		294,
		293,
		280,
		279,
		263,
		256,
		253,
		246,
		259,
		269,
		274,
		261,
		-1,
		-1,
		-1,
		369,
		355,
		359,
		319,
		338,
		-1,
		-1,
		404,
		359,
		345,
		-1,
		316,
		307,
		295,
		285,
		275,
		280,
		281,
		271,
		269,
		261,
		263,
		257,
		248,
		247,
		263,
		255,
		277,
		-1,
		-1,
		352,
		357,
		345,
		331,
		350,
		-1,
		-1,
		-1,
		351,
		367,
		335,
		314,
		296,
		-1,
		-1,
		279,
		272,
		266,
		269,
		257,
		277,
		272,
		256,
		241,
		256,
		260,
		268,
		259,
		-1,
		355,
		342,
		-1,
		-1,
		353,
		347,
		-1,
		-1,
		-1,
		-1,
		347,
		292,
		281,
		276,
		280,
		278,
		-1,
		252,
		263,
		256,
		275,
		282,
		258,
		243,
		237,
		243,
		255,
		264,
		-1,
		-1,
		367,
		-1,
		340,
		-1,
		-1,
		-1,
		-1,
		304,
		298,
		269,
		262,
		266,
		-1,
		254,
		256,
		253,
		265,
		261,
		258,
		249,
		240,
		236,
		240,
		244,
		258,
		262,
		390,
		-1,
		331,
		-1,
		-1,
		-1,
		322,
		337,
		308,
		285,
		258,
		253,
		246,
		240,
		245,
		256,
		265,
		276,
		241,
		243,
		233,
		232,
		236,
		253,
		257,
		-1,
		-1,
		329,
		325,
		348,
		330,
		334,
		335,
		-1,
		-1,
		262,
		253,
		244,
		236,
		249,
		252,
		237,
		239,
		239,
		237,
		231,
		241,
		256,
		251,
		-1,
		-1,
		-1,
		341,
		-1,
		343,
		-1,
		-1,
		332,
		333,
		280,
		262,
		258,
		256,
		245,
		239,
		227,
		232,
		242,
		236,
		233,
		227,
		231,
		254,
		243,
		282,
		-1,
		-1,
		400,
		-1,
		-1,
		-1,
		321,
		312,
		307,
		314,
		316,
		307,
		295,
		292,
		-1,
		262,
		268,
		233,
		240,
		223,
		230,
		235,
		232,
		221,
		228,
		244,
		243,
		238,
		274,
		265,
		271,
		-1,
		-1,
		393,
		382,
		371,
		377,
		-1,
		314,
		309,
		300,
		290,
		293,
		-1,
		-1,
		287,
		284,
		264,
		233,
		231,
		224,
		219,
		229,
		205,
		217,
		221,
		225,
		231,
		236,
		241,
		247,
		262,
		277,
		-1,
		347,
		384,
		377,
		345,
		353,
		384,
		-1,
		304,
		296,
		306,
		282,
		284,
		-1,
		-1,
		260,
		251,
		252,
		240,
		237,
		243,
		242,
		225,
		231,
		232,
		224,
		223,
		241,
		245,
		254,
		261,
		251,
		264,
		268,
		-1,
		340,
		360,
		339,
		342,
		366,
		380,
		-1,
		301,
		-1,
		-1,
		266,
		285,
		269,
		259,
		256,
		299,
		254,
		249,
		230,
		228,
		223,
		214,
		239,
		232,
		232,
		235,
		250,
		255,
		247,
		261,
		261,
		262,
		-1,
		329,
		340,
		333,
		-1,
		-1,
		-1,
		-1,
		302,
		-1,
		-1,
		256,
		-1,
		296,
		-1,
		279,
		283,
		262,
		265,
		244,
		231,
		217,
		225,
		231,
		230,
		236,
		236,
		237,
		246,
		257,
		269,
		268,
		269,
		323,
		310,
		313,
		324,
		335,
		350,
		354,
		-1,
		313,
		352,
		262,
		-1,
		246,
		-1,
		-1,
		-1,
		293,
		275,
		267,
		264,
		243,
		243,
		209,
		213,
		226,
		233,
		243,
		254,
		246,
		250,
		263,
		274,
		277,
		319,
		324,
		354,
		299,
		299,
		320,
		329,
		350,
		314,
		311,
		346,
		269,
		258,
		253,
		240,
		-1,
		-1,
		277,
		285,
		-1,
		-1,
		250,
		217,
		205,
		215,
		219,
		233,
		245,
		258,
		246,
		251,
		245,
		277,
		-1,
		317,
		316,
		305,
		302,
		288,
		295,
		290,
		317,
		-1,
		-1,
		312,
		339,
		323,
		302,
		300,
		325,
		-1,
		229,
		-1,
		-1,
		257,
		-1,
		-1,
		242,
		222,
		211,
		202,
		207,
		227,
		238,
		260,
		242,
		259,
		250,
		260,
		264,
		301,
		298,
		286,
		284,
		303,
		298,
		286,
		-1,
		294,
		297,
		303,
		310,
		303,
		314,
		-1,
		-1,
		245,
		225,
		-1,
		-1,
		240,
		238,
		227,
		-1,
		217,
		199,
		204,
		234,
		236,
		238,
		245,
		239,
		246,
		254,
		265,
		257,
		310,
		324,
		313,
		304,
		304,
		314,
		291,
		284,
		291,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		250,
		-1,
		235,
		231,
		-1,
		-1,
		235,
		228,
		216,
		204,
		194,
		204,
		221,
		221,
		224,
		229,
		237,
		248,
		244,
		248,
		251,
		-1,
		339,
		-1,
		322,
		283,
		289,
		304,
		312,
		-1,
		-1,
		-1,
		252,
		238,
		231,
		219,
		217,
		-1,
		269,
		253,
		234,
		-1,
		204,
		217,
		257,
		225,
		230,
		225,
		240,
		251,
		242,
		250,
		244,
		247,
		-1,
		-1,
		282,
		265,
		-1,
		-1,
		239,
		241,
		-1,
		243,
		232,
		217,
		209,
		-1,
		-1,
		241,
		237,
		-1,
		-1,
		191,
		229,
		228,
		236,
		231,
		236,
		248,
		244,
		240,
		250,
		241,
		-1,
		-1,
		260,
		252,
		246,
		-1,
		224,
		-1,
		245,
		-1,
		212,
		218,
		206,
		-1,
		-1,
		-1,
		222,
		185,
		201,
		224,
		250,
		248,
		239,
		232,
		239,
		242,
		235,
		241,
		-1,
		-1,
		-1,
		242,
		216,
		252,
		243,
		226,
		206,
		198,
		217,
		-1,
		203,
		-1,
		178,
		181,
		206,
		245,
		247,
		233,
		229,
		242,
		236,
		233,
		231,
		248,
		-1,
		218,
		251,
		215,
		212,
		188,
		192,
		217,
		-1,
		200,
		182,
		-1,
		210,
		200,
		248,
		223,
		232,
		225,
		219,
		220,
		228,
		-1,
		-1,
		-1,
		220,
		219,
		211,
		205,
		205,
		193,
		184,
		-1,
		205,
		187,
		173,
		190,
		190,
		181,
		189,
		238,
		234,
		237,
		235,
		213,
		-1,
		206,
		-1,
		-1,
		243,
		-1,
		-1,
		-1,
		214,
		198,
		185,
		173,
		174,
		170,
		170,
		172,
		185,
		193,
		191,
		188,
		200,
		196,
		216,
		212,
		244,
		-1,
		201,
		-1,
		250,
		-1,
		-1,
		195,
		182,
		192,
		196,
		185,
		183,
		169,
		165,
		182,
		217,
		203,
		201,
		206,
		211,
		-1,
		190,
		189,
		-1,
		183,
		193,
		192,
		-1,
		173,
		-1,
		231,
		192,
		-1,
		166,
		160,
		-1,
		212,
		208,
		-1,
		-1,
		177,
		172,
		-1,
		-1,
		-1,
		172,
		176,
		226,
		210,
		-1,
		150,
		157,
		-1,
		-1,
		-1,
		162,
		163,
		-1,
		158,
		168,
		-1,
		172,
		163,
		171,
		145,
		151,
		-1,
		-1,
		-1,
		171,
		152,
		146,
		148,
		143,
		173,
		184,
		170,
		154,
		132,
		142,
		171,
		-1,
		-1,
		-1,
		143,
		135,
		128,
		-1,
		-1,
		179,
		162,
		143,
		141,
		-1,
		-1,
		-1,
		164,
		146,
		-1,
		-1,
		119,
		-1,
		-1,
		138,
		117,
		-1,
		-1,
		-1,
		-1,
		-1,
		119,
		148,
		-1,
		-1,
		-1,
		114,
		108,
		122,
		-1,
		-1,
		-1,
		-1,
		98,
		99,
		143,
		126,
		-1,
		-1,
		-1,
		104,
		111,
		-1,
		-1,
		96,
		97,
		-1,
		-1,
		-1,
		98,
		85,
		-1,
		122,
		-1,
		-1,
		-1,
		76,
		-1,
		-1,
		155,
		-1,
		-1,
		-1,
		61,
		-1,
		157,
		132,
		136,
		-1,
		-1,
		-1,
		-1,
		56,
		57,
		170,
		-1,
		133,
		126,
		-1,
		140,
		-1,
		-1,
		71,
		51,
		-1,
		-1,
		123,
		127,
		124,
		127,
		0,
		-1,
		105
	],
	[
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1
	],
	[
		-1,
		338,
		327,
		338,
		346,
		319,
		326,
		-1,
		345,
		349,
		315,
		309,
		348,
		317,
		323,
		334,
		-1,
		-1,
		-1,
		338,
		337,
		305,
		303,
		312,
		317,
		324,
		-1,
		323,
		-1,
		359,
		338,
		349,
		354,
		298,
		295,
		315,
		334,
		316,
		308,
		374,
		328,
		299,
		293,
		311,
		301,
		310,
		302,
		-1,
		299,
		289,
		311,
		290,
		301,
		293,
		-1,
		-1,
		293,
		294,
		300,
		286,
		292,
		288,
		-1,
		298,
		282,
		-1,
		-1,
		283,
		284,
		268,
		271,
		279,
		277,
		290,
		282,
		277,
		-1,
		-1,
		274,
		270,
		277,
		264,
		260,
		277,
		290,
		272,
		286,
		285,
		-1,
		278,
		296,
		303,
		271,
		269,
		253,
		251,
		269,
		271,
		277,
		277,
		-1,
		287,
		288,
		283,
		291,
		293,
		269,
		256,
		256,
		266,
		259,
		278,
		266,
		312,
		-1,
		-1,
		-1,
		-1,
		-1,
		321,
		287,
		270,
		287,
		279,
		269,
		284,
		277,
		259,
		256,
		254,
		251,
		267,
		265,
		275,
		-1,
		-1,
		380,
		349,
		378,
		336,
		317,
		-1,
		283,
		263,
		269,
		273,
		267,
		260,
		274,
		270,
		-1,
		245,
		244,
		272,
		258,
		269,
		340,
		-1,
		-1,
		338,
		330,
		313,
		316,
		293,
		289,
		278,
		277,
		269,
		255,
		251,
		257,
		260,
		260,
		266,
		239,
		249,
		253,
		251,
		276,
		-1,
		-1,
		311,
		-1,
		-1,
		337,
		320,
		-1,
		303,
		310,
		299,
		305,
		291,
		312,
		288,
		279,
		271,
		265,
		253,
		255,
		252,
		265,
		253,
		236,
		261,
		265,
		246,
		267,
		262,
		-1,
		310,
		294,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		315,
		296,
		299,
		305,
		329,
		328,
		-1,
		300,
		288,
		289,
		274,
		271,
		258,
		246,
		259,
		244,
		251,
		250,
		240,
		238,
		268,
		243,
		265,
		262,
		281,
		286,
		280,
		289,
		-1,
		345,
		341,
		337,
		344,
		293,
		-1,
		-1,
		333,
		-1,
		336,
		337,
		312,
		285,
		288,
		275,
		266,
		253,
		242,
		253,
		242,
		239,
		247,
		232,
		247,
		238,
		237,
		255,
		265,
		273,
		277,
		283,
		-1,
		395,
		-1,
		337,
		321,
		323,
		295,
		316,
		-1,
		353,
		337,
		329,
		314,
		314,
		-1,
		284,
		281,
		271,
		249,
		234,
		251,
		243,
		241,
		245,
		227,
		241,
		232,
		250,
		257,
		255,
		259,
		279,
		291,
		355,
		345,
		-1,
		327,
		332,
		291,
		299,
		318,
		356,
		320,
		-1,
		315,
		-1,
		286,
		299,
		-1,
		255,
		251,
		233,
		234,
		229,
		244,
		238,
		223,
		220,
		238,
		241,
		248,
		252,
		268,
		-1,
		-1,
		340,
		344,
		333,
		284,
		303,
		327,
		364,
		313,
		302,
		301,
		-1,
		292,
		269,
		266,
		254,
		241,
		226,
		227,
		235,
		248,
		227,
		222,
		219,
		239,
		265,
		243,
		255,
		-1,
		-1,
		-1,
		365,
		-1,
		-1,
		310,
		281,
		305,
		347,
		331,
		324,
		312,
		277,
		277,
		271,
		-1,
		265,
		244,
		235,
		224,
		222,
		235,
		232,
		237,
		217,
		215,
		234,
		246,
		237,
		254,
		-1,
		-1,
		-1,
		340,
		329,
		330,
		276,
		299,
		336,
		310,
		296,
		301,
		276,
		269,
		263,
		278,
		261,
		242,
		231,
		223,
		212,
		228,
		236,
		231,
		213,
		222,
		228,
		252,
		242,
		248,
		-1,
		-1,
		347,
		337,
		321,
		323,
		320,
		290,
		297,
		329,
		301,
		314,
		-1,
		268,
		-1,
		257,
		252,
		236,
		231,
		228,
		225,
		219,
		228,
		230,
		220,
		215,
		222,
		257,
		257,
		232,
		252,
		255,
		-1,
		-1,
		-1,
		340,
		335,
		310,
		287,
		271,
		307,
		-1,
		284,
		285,
		-1,
		262,
		256,
		253,
		238,
		234,
		229,
		233,
		226,
		233,
		226,
		224,
		225,
		207,
		239,
		-1,
		240,
		234,
		242,
		232,
		220,
		-1,
		-1,
		-1,
		333,
		312,
		305,
		325,
		266,
		318,
		-1,
		-1,
		269,
		262,
		-1,
		249,
		231,
		238,
		236,
		230,
		234,
		231,
		220,
		233,
		226,
		212,
		214,
		227,
		231,
		235,
		222,
		218,
		215,
		229,
		-1,
		352,
		-1,
		-1,
		-1,
		-1,
		-1,
		266,
		286,
		-1,
		278,
		270,
		260,
		254,
		248,
		244,
		242,
		258,
		242,
		245,
		243,
		234,
		242,
		215,
		208,
		215,
		204,
		222,
		230,
		222,
		216,
		215,
		225,
		-1,
		353,
		339,
		310,
		-1,
		-1,
		299,
		-1,
		263,
		277,
		293,
		-1,
		286,
		265,
		280,
		258,
		254,
		250,
		265,
		266,
		243,
		243,
		241,
		232,
		220,
		209,
		212,
		204,
		226,
		226,
		210,
		211,
		215,
		-1,
		359,
		346,
		304,
		300,
		289,
		309,
		260,
		248,
		280,
		-1,
		-1,
		322,
		-1,
		256,
		273,
		264,
		262,
		255,
		237,
		244,
		252,
		229,
		224,
		214,
		203,
		203,
		198,
		220,
		206,
		204,
		213,
		229,
		-1,
		-1,
		-1,
		326,
		-1,
		-1,
		275,
		262,
		256,
		-1,
		297,
		-1,
		300,
		290,
		274,
		259,
		292,
		-1,
		236,
		232,
		239,
		-1,
		249,
		-1,
		222,
		219,
		210,
		195,
		192,
		203,
		201,
		212,
		208,
		-1,
		309,
		294,
		287,
		277,
		291,
		262,
		-1,
		317,
		-1,
		-1,
		287,
		281,
		281,
		265,
		266,
		252,
		232,
		224,
		239,
		238,
		225,
		224,
		208,
		201,
		198,
		191,
		204,
		214,
		219,
		206,
		-1,
		-1,
		-1,
		314,
		300,
		304,
		264,
		283,
		-1,
		-1,
		349,
		304,
		290,
		-1,
		261,
		252,
		240,
		230,
		220,
		225,
		226,
		216,
		214,
		206,
		208,
		202,
		193,
		192,
		208,
		200,
		222,
		-1,
		-1,
		297,
		302,
		290,
		276,
		295,
		-1,
		-1,
		-1,
		296,
		312,
		280,
		259,
		241,
		-1,
		-1,
		224,
		217,
		211,
		214,
		202,
		222,
		217,
		201,
		186,
		201,
		205,
		213,
		204,
		-1,
		300,
		287,
		-1,
		-1,
		298,
		292,
		-1,
		-1,
		-1,
		-1,
		292,
		237,
		226,
		221,
		225,
		223,
		-1,
		197,
		208,
		201,
		220,
		227,
		203,
		188,
		182,
		188,
		200,
		209,
		-1,
		-1,
		312,
		-1,
		285,
		-1,
		-1,
		-1,
		-1,
		249,
		243,
		214,
		207,
		211,
		-1,
		199,
		201,
		198,
		210,
		206,
		203,
		194,
		185,
		181,
		185,
		189,
		203,
		207,
		335,
		-1,
		276,
		-1,
		-1,
		-1,
		267,
		282,
		253,
		230,
		203,
		198,
		191,
		185,
		190,
		201,
		210,
		221,
		186,
		188,
		178,
		177,
		181,
		198,
		202,
		-1,
		-1,
		274,
		270,
		293,
		275,
		279,
		280,
		-1,
		-1,
		207,
		198,
		189,
		181,
		194,
		197,
		182,
		184,
		184,
		182,
		176,
		186,
		201,
		196,
		-1,
		-1,
		-1,
		286,
		-1,
		288,
		-1,
		-1,
		277,
		278,
		225,
		207,
		203,
		201,
		190,
		184,
		172,
		177,
		187,
		181,
		178,
		172,
		176,
		199,
		188,
		227,
		-1,
		-1,
		348,
		-1,
		-1,
		-1,
		266,
		257,
		252,
		259,
		261,
		252,
		240,
		237,
		-1,
		207,
		213,
		178,
		185,
		168,
		175,
		180,
		177,
		166,
		173,
		189,
		188,
		183,
		219,
		210,
		216,
		-1,
		-1,
		341,
		330,
		319,
		325,
		-1,
		259,
		254,
		245,
		235,
		238,
		-1,
		-1,
		232,
		229,
		209,
		178,
		176,
		169,
		164,
		174,
		150,
		162,
		166,
		170,
		176,
		181,
		186,
		192,
		207,
		222,
		-1,
		295,
		332,
		325,
		293,
		301,
		332,
		-1,
		249,
		241,
		251,
		227,
		229,
		-1,
		-1,
		205,
		196,
		197,
		185,
		182,
		188,
		187,
		170,
		176,
		177,
		169,
		168,
		186,
		190,
		199,
		206,
		196,
		209,
		213,
		-1,
		288,
		308,
		287,
		290,
		314,
		328,
		-1,
		246,
		-1,
		-1,
		211,
		230,
		214,
		204,
		201,
		244,
		199,
		194,
		175,
		173,
		168,
		159,
		184,
		177,
		177,
		180,
		195,
		200,
		192,
		206,
		206,
		207,
		-1,
		277,
		288,
		281,
		-1,
		-1,
		-1,
		-1,
		247,
		-1,
		-1,
		201,
		-1,
		241,
		-1,
		224,
		228,
		207,
		210,
		189,
		176,
		162,
		170,
		176,
		175,
		181,
		181,
		182,
		191,
		202,
		214,
		213,
		214,
		302,
		258,
		261,
		272,
		283,
		298,
		302,
		-1,
		258,
		297,
		207,
		-1,
		191,
		-1,
		-1,
		-1,
		238,
		220,
		212,
		209,
		188,
		188,
		154,
		158,
		171,
		178,
		188,
		199,
		191,
		195,
		208,
		219,
		222,
		298,
		289,
		302,
		247,
		247,
		268,
		277,
		298,
		262,
		259,
		291,
		214,
		203,
		198,
		185,
		-1,
		-1,
		222,
		230,
		-1,
		-1,
		195,
		162,
		150,
		160,
		164,
		178,
		190,
		203,
		191,
		196,
		190,
		222,
		-1,
		291,
		290,
		279,
		276,
		252,
		243,
		238,
		265,
		-1,
		-1,
		260,
		287,
		270,
		247,
		245,
		270,
		-1,
		174,
		-1,
		-1,
		202,
		-1,
		-1,
		187,
		167,
		156,
		147,
		152,
		172,
		183,
		205,
		187,
		204,
		195,
		205,
		209,
		275,
		272,
		260,
		258,
		281,
		246,
		234,
		-1,
		242,
		245,
		251,
		258,
		248,
		259,
		-1,
		-1,
		190,
		170,
		-1,
		-1,
		185,
		183,
		172,
		-1,
		162,
		144,
		149,
		179,
		181,
		183,
		190,
		184,
		191,
		199,
		210,
		202,
		284,
		298,
		287,
		283,
		282,
		290,
		239,
		232,
		239,
		-1,
		-1,
		-1,
		-1,
		-1,
		-1,
		195,
		-1,
		180,
		176,
		-1,
		-1,
		180,
		173,
		161,
		149,
		139,
		149,
		166,
		166,
		169,
		174,
		182,
		193,
		189,
		193,
		196,
		-1,
		318,
		-1,
		270,
		231,
		237,
		252,
		260,
		-1,
		-1,
		-1,
		197,
		183,
		176,
		164,
		162,
		-1,
		214,
		198,
		179,
		-1,
		149,
		162,
		202,
		170,
		175,
		170,
		185,
		196,
		187,
		195,
		189,
		192,
		-1,
		-1,
		230,
		213,
		-1,
		-1,
		187,
		189,
		-1,
		188,
		177,
		162,
		154,
		-1,
		-1,
		186,
		182,
		-1,
		-1,
		136,
		174,
		173,
		181,
		176,
		181,
		193,
		189,
		185,
		195,
		186,
		-1,
		-1,
		208,
		200,
		194,
		-1,
		172,
		-1,
		190,
		-1,
		157,
		163,
		151,
		-1,
		-1,
		-1,
		167,
		130,
		146,
		169,
		195,
		193,
		184,
		177,
		184,
		187,
		180,
		186,
		-1,
		-1,
		-1,
		190,
		164,
		197,
		188,
		171,
		151,
		143,
		162,
		-1,
		148,
		-1,
		123,
		126,
		151,
		190,
		192,
		178,
		174,
		187,
		181,
		178,
		176,
		196,
		-1,
		166,
		199,
		163,
		157,
		133,
		137,
		162,
		-1,
		145,
		127,
		-1,
		155,
		145,
		193,
		168,
		177,
		170,
		164,
		165,
		173,
		-1,
		-1,
		-1,
		168,
		167,
		159,
		153,
		153,
		138,
		129,
		-1,
		150,
		132,
		118,
		135,
		135,
		126,
		134,
		183,
		179,
		182,
		180,
		158,
		-1,
		163,
		-1,
		-1,
		191,
		-1,
		-1,
		-1,
		162,
		155,
		130,
		118,
		119,
		115,
		115,
		117,
		130,
		138,
		136,
		133,
		145,
		141,
		161,
		157,
		189,
		-1,
		158,
		-1,
		198,
		-1,
		-1,
		152,
		139,
		149,
		141,
		130,
		128,
		114,
		110,
		127,
		162,
		148,
		146,
		151,
		156,
		-1,
		147,
		146,
		-1,
		140,
		150,
		149,
		-1,
		130,
		-1,
		176,
		137,
		-1,
		111,
		105,
		-1,
		157,
		153,
		-1,
		-1,
		134,
		129,
		-1,
		-1,
		-1,
		129,
		121,
		171,
		155,
		-1,
		95,
		102,
		-1,
		-1,
		-1,
		119,
		120,
		-1,
		115,
		125,
		-1,
		117,
		108,
		116,
		90,
		96,
		-1,
		-1,
		-1,
		128,
		109,
		103,
		105,
		100,
		130,
		129,
		115,
		98,
		77,
		87,
		116,
		-1,
		-1,
		-1,
		100,
		92,
		85,
		-1,
		-1,
		124,
		107,
		88,
		86,
		-1,
		-1,
		-1,
		122,
		103,
		-1,
		-1,
		77,
		-1,
		-1,
		81,
		62,
		-1,
		-1,
		-1,
		-1,
		-1,
		139,
		111,
		-1,
		-1,
		-1,
		73,
		69,
		65,
		-1,
		-1,
		-1,
		-1,
		133,
		134,
		157,
		121,
		-1,
		-1,
		-1,
		65,
		54,
		-1,
		-1,
		136,
		134,
		-1,
		-1,
		-1,
		93,
		77,
		-1,
		49,
		-1,
		-1,
		-1,
		84,
		-1,
		-1,
		69,
		-1,
		-1,
		-1,
		83,
		-1,
		52,
		31,
		31,
		-1,
		-1,
		-1,
		-1,
		78,
		79,
		65,
		-1,
		28,
		21,
		-1,
		35,
		-1,
		-1,
		93,
		59,
		-1,
		-1,
		18,
		22,
		19,
		22,
		112,
		-1,
		0
	]
];


//////////////////
// WEBPACK FOOTER
// ../res/matrix.json
// module id = 16
// module chunks = 0